angular
   .module("snk", ["snk.tpls", "snk.commons.acaoprogramada","snk.commons.agendamentoBase","snk.commons.alertContratosPendentes","snk.commons.analiseEnvioExpedicao","snk.commons.armazem","snk.commons.avaliacaoCapacidade","snk.commons.baixa.cabecalho","snk.commons.baixa.panel","snk.commons.coletorConferenciaLayout","snk.commons","snk.commons.config","snk.commons.controleNumeracaoPainel","snk.commons.diagnosticoPreVenda","snk.commons.edicaoseriepopup","snk.commons.empresa","snk.commons.fichaPatrimonialPanel","snk.commons.formularioProducaoBuilder","snk.commons.ftpinput","snk.commons.gradeproduto","snk.commons.grupotop","snk.commons.lancadorMenu.adicionarLancador","snk.commons.lancadorMenu.localizarLancador","snk.commons.lancamentoOrdemProducao","snk.commons.layout","snk.commons.liberacoes","snk.commons.ordemservico","snk.commons.parceiro","snk.commons.planejamentoMetaOrcamento","snk.commons.preenchimentoquestionario","snk.commons.queryEditor","snk.commons.rateio","snk.commons.solucoespopup.packageItem","snk.commons.verticaltimeline","snk.commons.visualizadorRelatoriosBase","snk.commons.wizardquestion","snk.commons.workFlow.fieldEventService","snk.commons.workFlow.modelerBpmn","snk.commons.workFlow.startingProcess","snk.commons.workFlow.telaNativaFlow","snk.commons.workFlow.visibilityEventService","snk.components.accordion","snk.components.actionbutton","snk.components.agendamentos","snk.components.aggrid","snk.components.applet","snk.components.attach","snk.components.banner","snk.components.box","snk.components.breadcrumbs","snk.components.btnnovo","snk.components.btnoldlayout","snk.components.btnotheroptions","snk.components.btnplace","snk.components.button","snk.components.calendar","snk.components.carregando","snk.components.changeorderbar","snk.components.chart","snk.components.checkbox","snk.components.checkboxlist","snk.components.collapse","snk.components.colorpicker","snk.components.compactpanel","snk.components.configurableform","snk.components.cronsyntaxselector","snk.components.cubebase","snk.components.dashrenderer","snk.components.datagrid","snk.components.dataset.dataimporter","snk.components.dataset","snk.components.dateperiod","snk.components.datepicker","snk.components.defaultfilter","snk.components.diagram","snk.components.dividedbox","snk.components.divider","snk.components.doublefacepanel","snk.components.dragdrop","snk.components.draggable","snk.components.draggablelist","snk.components.dropdown","snk.components.dropdownmenu","snk.components.dynaform","snk.components.dynamicfilterpanel","snk.components.entityattach","snk.components.entitycard","snk.components.entitylist","snk.components.entitystartpage","snk.components.filterpanel","snk.components.fixedbar","snk.components.flattree","snk.components.font","snk.components.form","snk.components.form.formitem","snk.components.formconfig","snk.components.gridconfig","snk.components.gridprinter","snk.components.gridstatistics","snk.components.groupcontainer","snk.components.helptip","snk.components.hover","snk.components.icon","snk.components.imagepopup","snk.components.input","snk.components.intervalselector","snk.components.ishikawa","snk.components.label","snk.components.linkedlist","snk.components.list","snk.components.listOrder","snk.components.livetimeline","snk.components.load","snk.components.loadingpanel","snk.components.mapbutton","snk.components.margemcontribchart","snk.components.maskbuilder","snk.components.multilist","snk.components.navigator","snk.components.personalizedfilter","snk.components.pesquisacep","snk.components.popover","snk.components.popup","snk.components.popupparameter","snk.components.queryexecutor","snk.components.recordsorganizerbar","snk.components.resizable","snk.components.resizablecontainer","snk.components.rowscounter","snk.components.sankhyaaccount","snk.components.select","snk.components.sglclick","snk.components.sidenav","snk.components.simpleform","snk.components.snackbar","snk.components.sortable","snk.components.stickypanel","snk.components.structuredfield","snk.components.tab","snk.components.tabnavigator","snk.components.taskbar","snk.components.timelinediagram","snk.components.title","snk.components.titlelabel","snk.components.toast","snk.components.tooltip","snk.components.tooltipbuilder","snk.components.tree","snk.components.twolists","snk.components.viewstack","snk.components.waitwindow","snk.components.wizard","snk.components.workbox","snk.core.application","snk.core.directives","snk.core.exceptionhandler","snk.core.loadingbar","snk.core.metadataprovider","snk.core.parameters","snk.core.services.registry","snk.core.theme","snk.core.tour","snk.core.util","snk.core.workspace","snk.i18n","ngSanitize","ngTouch","ui.tinymce","ui.mask" ]);/**
 * @ngdoc interface
 * @name snk.components.actionbutton.interface:ActionButtonContext
 * @description Interface do contexto do botão de ação
 */
function ActionButtonContext() {}

/**
 * @ngdoc
 * @name snk.components.actionbutton.interface:ActionButtonContext#getMasterEntityName
 * @methodOf snk.components.actionbutton.interface:ActionButtonContext
 * @description Função responsável realizar o get do nome da entidade master.
 * @returns {string} Nome da entidade master
 */
ActionButtonContext.prototype.getMasterEntityName = function () {};

/**
 * @ngdoc
 * @name snk.components.actionbutton.interface:ActionButtonContext#parameterGetter
 * @methodOf snk.components.actionbutton.interface:ActionButtonContext
 * @description Função responsável realizar o get de parametros para a execução.
 * @param {string} resourceID ResourceID da tela
 * @param {string} entityName Nome da entidade da ação
 * @param {string} fieldName Nome do campo
 * @returns {string} valor do parâmetro
 */
ActionButtonContext.prototype.parameterGetter = function (resourceID, entityName, fieldName) {};

/**
 * @ngdoc
 * @name snk.components.actionbutton.interface:ActionButtonContext#parameterLabelGetter
 * @methodOf snk.components.actionbutton.interface:ActionButtonContext
 * @description Função responsável realizar o get de descrição de campos para a execução.
 * @param {string} resourceID ResourceID da tela
 * @param {string} entityName Nome da entidade da ação
 * @param {string} fieldName Nome do campo
 * @returns {string} descrição do parâmetro
 */
ActionButtonContext.prototype.parameterLabelGetter = function (resourceID, entityName, fieldName) {};

/**
 * @ngdoc
 * @name snk.components.actionbutton.interface:ActionButtonContext#selectedRowsGetter
 * @methodOf snk.components.actionbutton.interface:ActionButtonContext
 * @description Função responsável realizar o get das linhas selecionadas para a ação.
 * @returns {array} Coleção de linhas selecionadas para a ação
 */
ActionButtonContext.prototype.selectedRowsGetter = function () {};

/**
 * @ngdoc
 * @name snk.components.actionbutton.interface:ActionButtonContext#recordsReloader
 * @methodOf snk.components.actionbutton.interface:ActionButtonContext
 * @description Função responsável realizar o recarregamento de informações após a ação.
 * @param {string} refreshType Tipo de refresh da ação
 * @returns {array} Coleção de linhas selecionadas para a ação
 */
ActionButtonContext.prototype.recordsReloader = function (refreshType) {};
function PersonalizedFilterData(){
    if(!(this instanceof arguments.callee)){
		return new PersonalizedFilterData();
    }
    
    var self = this;
    var expression = undefined;
    var rootEntity = undefined;
    var alias = [];
    var params = [];

    self.setExpression = (exp) => {
        expression = exp;
    }
    
    self.getExpression = () => {
        return expression;
    }

    self.setRootEntity = (value) => {
        rootEntity = value;
    }

    self.getRootEntity = () => {
        return rootEntity;
    }
    
    self.getAlias = () => {
        return alias;
    }
    
    self.getParams = () =>{
        return params;
    }
    
    self.addAlias = (name, aliasName) => {
        alias.push({name: name, aliasName: aliasName});
    }
    
    self.addParam = (value, type) => {
        params.push({type: type, value: value});
    }
}
function DatasetDashboardActionButtonContext(dashboardGrid) {
   
   var self = this;
   var dataset = dashboardGrid.dsDashboardGrid;

   var indiceCampo=-1; 
   if(angular.isDefined(dataset) && angular.isDefined(dashboardGrid.dsObserverEvents)){     
      dataset.addAllObserverEventsListener(function (eventName, parameter) {
         if (eventName == dashboardGrid.dsObserverEvents.EVENT_DATA_SET_REFRESHED && indiceCampo>=0) {         
            dataset.gotoRow(indiceCampo);
         }
      });
   }

   self.getMasterEntityName = function () {
      if (dataset.getParentDataset()) {
         return dataset.getParentDataset().getEntityName();
      }
      
      return undefined;
   };
   
   self.parameterGetter = function (resourceID, entityName, fieldName, formatValue = false) {
      if(formatValue) {
         return dataset.getFieldValueAsFormattedString(fieldName);
      }
        
      return dataset.getFieldValueAsString(fieldName);
   };
   
   self.parameterLabelGetter = function (resourceID, entityName, fieldName) {
      return dataset.getFieldMetadata(fieldName).description;
   };
   
   self.selectedRowsGetter = function () {
      var selectedRows = [];
      
      var parentDS = dataset.getParentDataset();
      
      if (parentDS && parentDS.getCurrentRow()) {
         var masterRow = {
            __MASTER_ROW__: true,
            __ENTITY_NAME__: parentDS.getEntityName()
         };
         
         parentDS.getPrimaryKeys().forEach(function (pkField) {
            masterRow[pkField] = parentDS.getFieldValueAsString(pkField);
         });
         
         selectedRows.push(masterRow);
      }
      
      if (dataset.getCurrentRow()) {
         var rows = dataset.getSelectedRecords() ? dataset.getSelectedRecords() : [dataset.getCurrentRow()];
         var fields = dataset.getPrimaryKeys().length > 0 ? dataset.getPrimaryKeys() : getAllfieldNames();
         
         rows.forEach(function(row) {
            var r = {};
            
            for (var j in fields) {
               fields.forEach(function(pkField){
                  var pkFieldIndex = dataset.getFieldIndexByName(pkField);
                  r[pkField] = dataset.dataToString(row[pkFieldIndex]);
               });
            }
            
            selectedRows.push(r);
         });
      }
      
      return selectedRows;
   };
   
	self.recordsReloader = function (refreshType) {
		if (refreshType == 'NONE') {
			return;
		}else{   
         if(angular.isDefined(dataset)){
             indiceCampo=dataset.getCurrentIndex();   
         }else{
            indiceCampo=-1;
         }              
            refreshDataSet();    
      } 
	};
   
   function getAllfieldNames(){
      var allFieldNames = [];
      dataset.getFieldsMetadata().forEach(function(md){
         allFieldNames.push(md.name);
      });
      
      return allFieldNames;
   }
   
   function refreshDataSet(){
      return dashboardGrid.refreshDataset(null);
   }
}

DatasetDashboardActionButtonContext.prototype = ActionButtonContext.prototype;
function DatasetActionButtonContext(dataset) {
    var self = this;

    self.getMasterEntityName = function () {
        if (dataset.getParentDataset()) {
            return dataset.getParentDataset().getEntityName();
        }

        return undefined;
    };

    self.parameterGetter = function (resourceID, entityName, fieldName, formatValue = false) {
        if(formatValue) {
            return dataset.getFieldValueAsFormattedString(fieldName);
        }
        
        return dataset.getFieldValueAsString(fieldName);
    };

    self.parameterLabelGetter = function (resourceID, entityName, fieldName) {
        return dataset.getFieldMetadata(fieldName).description;
    };

    self.selectedRowsGetter = function () {
        var selectedRows = [];

        var parentDS = dataset.getParentDataset();

        if (parentDS && parentDS.getCurrentRow()) {
            var masterRow = {
                __MASTER_ROW__: true,
                __ENTITY_NAME__: parentDS.getEntityName()
            };

            parentDS.getPrimaryKeys().forEach(function (pkField) {
                masterRow[pkField] = parentDS.getFieldValueAsString(pkField);
            });

            selectedRows.push(masterRow);
        }

        if (dataset.getCurrentRow()) {
            var rows = dataset.getSelectedRecords() ? dataset.getSelectedRecords() : [dataset.getCurrentRow()];
            var fields = dataset.getPrimaryKeys().length > 0 ? dataset.getPrimaryKeys() : getAllfieldNames();

            rows.forEach(function(row) {
                var r = {};

                for (var j in fields) {
                    fields.forEach(function(pkField){
                        var pkFieldIndex = dataset.getFieldIndexByName(pkField);
                        r[pkField] = dataset.dataToString(row[pkFieldIndex]);
                    });
                }

                selectedRows.push(r);
            });
        }

        return selectedRows;
    };

    self.recordsReloader = function (refreshType) {
        if (refreshType == 'NONE') {
            return;
        } else if (refreshType == 'PARENT') {
            if (dataset.getParentDataset()) {
                dataset.getParentDataset().refreshCurrentRow();
            } else {
                dataset.refresh();
            }
        } else if (refreshType == 'MASTER') {
            var topDataset = dataset;
            var parent;

            while (parent = topDataset.getParentDataset()) {
                topDataset = parent;
            }

            if (topDataset != dataset) {
                topDataset.refreshCurrentRow();
            } else {
                dataset.refresh();
            }
        } else if (refreshType == 'ALL') {
            dataset.refresh();
        } else {
            dataset.refreshCurrentRow();
        }
    };

    function getAllfieldNames(){
        var allFieldNames = [];
        dataset.getFieldsMetadata().forEach(function(md){
            allFieldNames.push(md.name);
        });

        return allFieldNames;
    }
}

DatasetActionButtonContext.prototype = ActionButtonContext.prototype;
/**
 * @ngdoc interface
 * @name snk.components.dataset.interface:FieldBinder
 * @description Interface que realiza as interações entre campo/dataset
 */
function FieldBinder() { }

FieldBinder.prototype.scope = undefined;
FieldBinder.prototype.ignoreModifiedNotification = false;
FieldBinder.prototype.element;

FieldBinder.prototype.initializePrototype = function () {
    var self = this;
    
    self.$datasetLoadedListeners = [];

    self.scopeCreated();    
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#setNgModelCtrl
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável setar o controlador padrão do input
 * @param {string} ngModelCtrl Controlador do input
 */
FieldBinder.prototype.setNgModelCtrl = function (ngModelCtrl) { };

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#setFocus
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável setar o foco no input.
 */
FieldBinder.prototype.setFocus = function () {

};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#setEnabled
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável por habilitar/desabilitar o componente.
 * @param {boolean} enabled Habilitado
 */
FieldBinder.prototype.setEnabled = function (enabled) {
    this.scope.enabled = enabled;
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#highlightField
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável marcar o campo como "em destaque".
 */
FieldBinder.prototype.highlightField = function () {
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#unHighlightField
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável marcar o campo como em destaque.
 */
FieldBinder.prototype.unHighlightField = function () {
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#setDataset
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável setar o dataset.
 * @param {string} dataset Dataset que irá controlar o campo
 */
FieldBinder.prototype.setDataset = function (dataset) { };

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#setFieldName
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável por definir o nome do campo que o FieldBinder representa.
 * @param {string} fieldName Nome do campo
 */
FieldBinder.prototype.setFieldName = function (fieldName) { };

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#getFieldName
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável por devolver o nome do campo que o FieldBinder representa.
 * @returns {string} Nome do campo.
 */
FieldBinder.prototype.getFieldName = function () {
    var self = this;

    if (angular.isDefined(self.scope.fieldName)) {
        return self.scope.fieldName;
    } else if (angular.isDefined(self.scope.fieldIndex)) {
        var field = self.scope.dataset.getFieldMetadataByIndex(self.scope.fieldIndex);

        if (field) {
            self.scope.fieldName = field.name;
        }
    }

    return self.scope.fieldName;
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#beforeSetData
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função chamada <b>antes</b> de realizar o setData no componente.
 */
FieldBinder.prototype.beforeSetData = function () {
    this.ignoreModifiedNotification = true;
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#afterSetData
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função chamada <b>depois</b> de realizar o setData no componente.
 */
FieldBinder.prototype.afterSetData = function () {
    var self = this;

    self.scope.$$postDigest(function () {
        self.ignoreModifiedNotification = false;
    });
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#isIgnoreModifiedNotification
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Determina se o dataset deve ignorar ou não uma modificação deste componente
 * @returns {boolean} ignore Se o componente deve ser ignorado ou não.
 */
FieldBinder.prototype.isIgnoreModifiedNotification = function () {
    return this.ignoreModifiedNotification;
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#setData
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável setar o valor do campo
 * @param {string} data Novo valor do campo
 */
FieldBinder.prototype.setData = function (data) {
    this.scope.value = data;
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#getData
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável por devolver o valor do campo
 * @returns {object} valor do campo.
 */
FieldBinder.prototype.getData = function () {
    return this.scope.value;
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#useDataset
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável por verificar se o campo utiliza ou não o dataset.
 * @returns {boolean} Retorna true caso utilize, false do contrário.
 */
FieldBinder.prototype.useDataset = function () {
    var self = this;

    if (angular.isDefined(self.scope.dataset)) {
        if (angular.isDefined(self.scope.fieldName) || angular.isDefined(self.scope.fieldIndex)) {
            return true;
        } else {
            throw new Error('Dataset foi definido porém não foi definido o fieldIndex ou fieldName.');
        }
    } else {
        return false;
    }
};

/**
 * @ngdoc
 * @name snk.components.dataset.interface:FieldBinder#modify
 * @methodOf snk.components.dataset.interface:FieldBinder
 * @description Função responsável por notificar mudanças no dataset.
 */
FieldBinder.prototype.modify = function (force) {
    var self = this;

    if (self.useDataset(self.scope) && !self.isIgnoreModifiedNotification()) {
            self.scope.dataset.setModified(self);
    }
};

FieldBinder.prototype.addDatasetLoadedListener = function (listener) {
    this.$datasetLoadedListeners.push(listener);
}

FieldBinder.prototype.bindToDataset = function () {
    var self = this;

    if (self.currFieldBinder) {
        self.currFieldBinder();
    }

    if (self.currObserver) {
        self.currObserver();
    }

    if (self.scope.dataset) {
        self.currFieldBinder = self.scope.dataset.addFieldBinder(self);

        if (self.scope.disableOnInsertion) {
            var observer = new IDataSetObserver();
            var changed = false;

            observer.insertionModeActivated = function () {
                if (self.scope.enabled) {
                    self.scope.enabled = false;
                    changed = true;
                }

                self.beforeSetData();
                self.setData(undefined);
                self.afterSetData();
            };

            observer.currentLineChanged = function () {
                if (changed) {
                    self.scope.enabled = true;
                }
            };

            self.currObserver = self.scope.dataset.addObserver(observer);
        }

        self.scope.dataset.whenMetadataLoaded().then(function () {
            self.$datasetLoadedListeners.forEach(function (listener) {
                listener();
            });
        });
    }
}

FieldBinder.prototype.scopeCreated = function () {
    var self = this;

    self.scope.$watch('dataset', function () {
        self.bindToDataset();
    });

    self.ignoreModifiedNotification = true;
    self.scope.$$postDigest(function () {
        self.ignoreModifiedNotification = false;
    });

    if (angular.isDefined(self.scope.enabled)) {
        if (angular.isString(self.scope.enabled)) {
            var evaluated = self.scope.$eval(self.scope.enabled);

            self.scope.enabled = angular.isDefined(evaluated) ? evaluated : true;
        }
    } else {
        self.scope.enabled = true;
    }

    self.scope.$on('$destroy', function () {
        self.scopeDestroyed();
    });
};

FieldBinder.prototype.scopeDestroyed = function () {
    var self = this;

    if (self.useDataset()) {
        self.scope.dataset.removeFieldBinder(self);
    }

    if(this.element){
        this.element.off('focus');
        this.element.off('blur');
        this.element = undefined;
    }
};

FieldBinder.prototype.notifyChangeToDataset = function (isEnd) {
    var self = this;

    if (self.useDataset(self.scope) && !self.isIgnoreModifiedNotification()) {
        self.scope.dataset.notifyEditionStart(self);
        self.scope.dataset.setModified(self, isEnd);
    }
};

FieldBinder.prototype.onFocusout = function () {
    var self = this;
    if (self.useDataset(self.scope)) {
        self.scope.dataset.onFocusout(self);
    }
};

FieldBinder.prototype.setElement = function(element){
    this.element = angular.element(element);
    if(this.element){
        this.element.on('focus', () => this.fbFocusIn());
        this.element.on('blur', () => this.fbFocusOut());
    }
}

FieldBinder.prototype.fbFocusIn = function () {
    if(this.scope){
        this.scope.oldValue = this.scope.value;
    }
};

FieldBinder.prototype.fbFocusOut = function () {
    if(this.scope.onEndEdit && this.scope.oldValue != this.scope.value){
        this.scope.onEndEdit({value: this.scope.value});
        this.finishedEdition();
    }
};

FieldBinder.prototype.finishedEdition = function (newValue, oldValue) {
    const argsCount = arguments.length;

    let _resolvedNewValue = this.scope.value;
    let _resolvedOldValue = this.scope.oldValue;

    if(argsCount >= 1){
        _resolvedNewValue = newValue;
    }
    
    if(argsCount >= 2){
        _resolvedOldValue = oldValue;
    }

    if( this.useDataset() &&
        _resolvedNewValue != _resolvedOldValue){
        this.scope.dataset.notifyFinishedEdition(this.getFieldName(), _resolvedNewValue, _resolvedOldValue);
    }
};
function FieldBinderProxy(fieldName, dataset, getData, setData) {
    if(!(this instanceof arguments.callee)){
		return new FieldBinderProxy(fieldName, dataset);
	}

    this.scope = angular.element(document).scope().$root.$new();
    this.scope.fieldName = fieldName;
    this.scope.dataset = dataset;
    this.getData = (getData || angular.noop);
    this.setData = (setData || angular.noop);
    this.initializePrototype();
}

FieldBinderProxy.prototype = new FieldBinder();
/**
 * @ngdoc interface
 * @name components.dataset.validators.interface:RecordValidator
 * @description Classe utilizada para realizar validações de registro no dataset.
 */
function RecordValidator(){
}

/**
 * @ngdoc
 * @name components.dataset.validators.interface:RecordValidator#validate
 * @methodOf components.dataset.validators.interface:RecordValidator
 * @description Função responsável por validar um registro do dataset.
 * @param {array} record Registro a ser validado.
 * @returns {boolean} True caso o registro seja válido, False do contrário.
 */
RecordValidator.prototype.validate = function(record){};

/**
 * @ngdoc
 * @name components.dataset.validators.interface:RecordValidator#setDataset
 * @methodOf components.dataset.validators.interface:RecordValidator
 * @description Função responsável por setar o dataset no validador.
 * @param {Dataset} dataset Dataset vinculado ao validador.
 */
RecordValidator.prototype.setDataset = function(dataset){};


/**
 * @ngdoc
 * @name components.dataset.validators.interface:RecordValidator#isRequired
 * @methodOf components.dataset.validators.interface:RecordValidator
 * @description Função responsável por avaliar se um campo é requerido ou não.
 * @param {string} fieldName Nome do campo a ser avaliado.
 * @returns {boolean} True caso o campo seja requerido, False do contrário.
 */
RecordValidator.prototype.isRequired = function(fieldName){};

RequiredRecordValidator.prototype = new RecordValidator();


function RequiredRecordValidator(dataset, MessageUtils, $translate) {
    RecordValidator.call(this);

    var _requiredFields = {};
    var _exceptFields = {};

    this.setDataset = function (dataset) {
        this.dataset = dataset;
    };

    this.setDataset(dataset);

    this.isRequired = function (fieldName) {
        return _requiredFields.hasOwnProperty(fieldName);
    };

    this.addExceptField = function (fieldName) {
        if (fieldName) {
            _exceptFields[fieldName] = undefined;
            delete _requiredFields[fieldName];
        }
    };

    this.addRequiredField = function (fieldName) {
        if (fieldName) {
            _requiredFields[fieldName] = undefined;
            delete _exceptFields[fieldName];
        }
    };

    this.validate = function(record, nullFieldNames) {
        if(!record){
            return false;
        }

        var nullFieldsDescription = [];

        var fieldsMds = this.dataset.getFieldsMetadata();

        for (var i = 0; i < fieldsMds.length; i++){
            var field = fieldsMds[i];

            if(_exceptFields && _exceptFields.hasOwnProperty(field.name) || field.isDescriptionField === true){
                continue;
            }

            var isRequired = _requiredFields && _requiredFields.hasOwnProperty(field.name);

            if(!isRequired && this.dataset.hasFieldBinder(field.name)){
                isRequired = this.dataset.isFieldRequired(field.name);
            }

            if(isRequired){
                if(record[i] === undefined || record[i] === ''){
                    if (nullFieldNames) {
                        nullFieldNames.push(field.name);
                    }

                    nullFieldsDescription.push(field.description);
                }
            }
        }

        if(nullFieldsDescription.length > 0){
            var msg;

            if(nullFieldsDescription.length == 1){
                msg = $translate.instant('Dataset.messagePreenchaCampo', {campos: nullFieldsDescription[0]});
            } else {
                var fieldsList = '<ul>';

                nullFieldsDescription.forEach(function(fieldDescr){
                    fieldsList += ('<li>' + fieldDescr + '</li>');
                });

                fieldsList += '</ul>';

                msg = $translate.instant('Dataset.messagePreenchaCampos', {campos: fieldsList});
            }

            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, msg);

            return false;
        } else {
            return true;
        }
    }
}
/**
 * @ngdoc interface
 * @name snk.components.diagram:DiagramNode
 * @description Implementação do Node
 */
class DiagramNode {
    
    constructor(body, menu) {
        this.body = body;
        this.menu = menu;
    }
}
/**
 * @ngdoc interface
 * @name util.common.interface:IDynaformConfigObserver
 * @description Classe utilizada para receber notificações lançadas pelo dynaformConfig
 */
function IDynaformConfigObserver() {}

/**
 * @ngdoc
 * @name util.common.interface:IDynaformConfigObserver#configCopied
 * @methodOf util.common.interface:IDynaformConfigObserver
 * @description Função chamada sempre que dynaformConfig realiza a copia de configurações entre usuários
 * @param {int} srcUser Código do usuário que está fornecendo as configurações.
 * @param {array} destUsers Array com código dos usuários que estão recebendo as configurações.
 */
IDynaformConfigObserver.prototype.configCopied = function (isNew, records) {

};

function GridConfig() {

	var _EVENT_MOVED_COLUMNS					= "EVENT_MOVED_COLUMNS";
	var _EVENT_SORTED_COLUMNS					= "EVENT_SORTED_COLUMNS";
	var _EVENT_LOADING_FINISHED_CONFIGURATION	= "EVENT_LOADING_FINISHED_CONFIGURATION";
	var _EVENT_AVAIBLE_COLUMNS_FILTERED			= "EVENT_AVAIBLE_COLUMNS_FILTERED";
	var _EVENT_SELECTED_COLUMNS_FILTERED		= "EVENT_SELECTED_COLUMNS_FILTERED";

	var _LOAD_CONFIG							= "mge@GridConfig.getGridConfig";
	var _SAVE_CONFIG 							= "mge@GridConfig.saveGridConfig";
    var _RESTORE_CONFIG							= "mge@GridConfig.restoreGridConfig";

    var _COLUMNS_AVAIBLE						= "COLUMNS_AVAIBLE";
    var _SELECTED_COLUMNS						= "SELECTED_COLUMNS";

	var _advancedSettings				        = {};

	var _columnsAvailable  				= [];
	var _selectedColumns   				= [];
	var _originalColumnsAvaible			= [];
	var _originalSelectedColumns		= [];

	var _configName						= null;
	var _presentationColumn				= null;
	var _dataGrid 						= null;
	var _dataSet						= null;
	var _serviceProxy					= null;
	var _jsUtil							= null;
	var _gridConfigObervers				= [];
    
    var self = this;
    
    this.addObserver = function(observer) {
		_gridConfigObervers.push(observer);
	};

	this.removeObserver = function(observer) {
		_gridConfigObervers.unshift(observer);
	};
    
    this.setServiceProxy = function(serviceProxy) {
		_serviceProxy = serviceProxy;
	}
    
    this.setConfigName = function(configName) {
		_configName = configName;
	};

	this.getConfigName = function() {
		return _configName;
	};
    
    this.setDataGrid = function(dataGrid) {
		_dataGrid = dataGrid;
	};

	this.setDataSet = function(dataSet) {
		_dataSet = dataSet
	};
    
    this.getColumnsAvailable = function() {
		return _columnsAvailable
	};

	this.setColumnsAvailable = function(columnsAvailable) {
		_columnsAvailable = columnsAvailable;
	};
    
    this.getSelectedColumns = function() {
		return _selectedColumns;
	};

	this.setSelectedColumns = function(selectedColumns) {
		_selectedColumns = selectedColumns;
	};
    
    this.setJSUtil = function(jsUtil) {
		_jsUtil = jsUtil;
	};
    
    this.getAdvancedSettings = function() {
		return _advancedSettings;
	};

	this.setAdvancedSettings = function(advancedSettings) {
		_advancedSettings = advancedSettings;
	};
    
    var getLoadConfigRequest = function() {
		var jsonLoadConfig = {
				gridConfig : {
					configName : _configName
				}
		};
		return jsonLoadConfig;
	};
    
    this.loadConfiguration = function() {
		var loadConfigRequest = getLoadConfigRequest();

		_serviceProxy.callService(_LOAD_CONFIG, loadConfigRequest)
			.then(function(result) {
				processOriginalColumns(result);
				_dataGrid.ngGrid.buildColumns();
				notifyGridConfigObservers(_EVENT_LOADING_FINISHED_CONFIGURATION, null);
		});
	};
    
    var processOriginalColumns = function(result) {
        if(angular.isDefined(result.responseBody.gridConfig.field)) {
            processResult(result);  
        }
        else {
            _dataGrid.ngGrid.config.showSelectionCheckbox = false;
            for(var i = 0; i < _dataGrid.ngGrid.config.columnDefs.length; i++) {
                _dataGrid.ngGrid.config.columnDefs[i].visible = false;
            }
            processSelectedAndAvailableColumns();
        }
	};    
    
    var processResult = function(result) {
        for(var i = 0; i < _dataGrid.ngGrid.config.columnDefs.length; i++) {
            _dataGrid.ngGrid.config.columnDefs[i].visible = false;   
        }

        if(angular.isDefined(result.responseBody.gridConfig.field)) {
            for(var i = 0; i < result.responseBody.gridConfig.field.length; i++) {
                for(var j = 0; j < _dataGrid.ngGrid.config.columnDefs.length; j++) {
                    if(result.responseBody.gridConfig.field[i].name === _dataGrid.ngGrid.config.columnDefs[j].field) {
                        _dataGrid.ngGrid.config.columnDefs[j].visible = true;
                        break;
                    }
                }    
            }
        }
        processSelectedAndAvailableColumns();
    }
    
    var processSelectedAndAvailableColumns = function() {
        _originalColumnsAvaible     = [];
        _originalSelectedColumns    = [];
        _selectedColumns            = [];
        _columnsAvailable           = [];
        for(var i = 0; i < _dataGrid.ngGrid.config.columnDefs.length; i++) {
            if(_dataGrid.ngGrid.config.columnDefs[i].field !== " ") {
                if(_dataGrid.ngGrid.config.columnDefs[i].visible) {
                    _selectedColumns.push(_dataGrid.ngGrid.config.columnDefs[i]);
                }
                else {
                    _columnsAvailable.push(_dataGrid.ngGrid.config.columnDefs[i]);
                }
            }
            else {
                _dataGrid.ngGrid.config.columnDefs[i].visible = true;
            }
        }
        
        _originalColumnsAvaible.push.apply(_originalColumnsAvaible,_columnsAvailable);
        _originalSelectedColumns.push.apply(_originalSelectedColumns,_selectedColumns);
        
        if(_originalSelectedColumns.length > 0) {
            _dataGrid.ngGrid.config.showSelectionCheckbox = true;
        }
        else {
            _dataGrid.ngGrid.config.showSelectionCheckbox = false;
        }
    };
    
    /*OPERAÇÕES DOS BOTÕES*/
    this.saveConfig = function() {
		var saveConfigRequest = getSaveConfigRequest(false);

		_serviceProxy.callService(_SAVE_CONFIG, saveConfigRequest)
			.then(function(result) {
                processResult(result);
                _dataGrid.ngGrid.buildColumns();
        });
	};
    
    this.cancel = function() {
		_columnsAvailable 	= [];
		_selectedColumns 	= [];
		_columnsAvailable.push.apply(_columnsAvailable, _originalColumnsAvaible);
		_selectedColumns.push.apply(_selectedColumns, _originalSelectedColumns);
	};
    
    /*MONTAGEM DAS REQUISIÇÕES*/
    var getSaveConfigRequest = function(sortByIndex) {
		var jsonSaveConfig = {
				gridConfig : {
					restrictBySup: false,
					configName : _configName,
					field: []
				}
		};

        if(_selectedColumns.length <= 0) {
            _selectedColumns = [];
            _selectedColumns.push.apply(_selectedColumns,_columnsAvailable);
            _columnsAvailable = [];
        }
        for (var i = 0; i < _selectedColumns.length; i++) {
            var column = _selectedColumns[i];

            if (column.field == 'EMPTYCOLUM') {
                continue;
            }

            var field = {};
            field.name 			= column.field;
            field.width 		= column.width;
            field.index			= sortByIndex ? column.index : i;
            field.orderIndex 	= 0;

            jsonSaveConfig.gridConfig.field.push(field);
        }

		if (sortByIndex) {
			jsonSaveConfig.gridConfig.field = getOrderedColumns(jsonSaveConfig.gridConfig.field, 'index');
		}

		return jsonSaveConfig;
	};
    
    /*OPERAÇÕES DE COLUNAS*/
    this.moveAllAvaibleColumnsForSelectedColumns = function() {
		if (_columnsAvailable.length > 0) {
			for (var i = 0; i < _columnsAvailable.length; i++) {
				var item = _columnsAvailable[i];
	
				_selectedColumns.push(item);
			}

			_columnsAvailable  		= [];
			notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveAvaibleColumnsForSelectedColumns = function(columns) {
		if (_jsUtil.checkProperty(columns, 'length') && columns.length > 0) {
	    	var i = 0;
	    	var j = 0;

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _columnsAvailable.length; j++) {
	    			var item = _columnsAvailable[j];

	    			if (column == item.field) {
	    				_selectedColumns.push(item);
	    				break;
	    			}
	    		}

	    	}

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _columnsAvailable.length; j++) {
	    			var item = _columnsAvailable[j];

	    			if (column == item.field) {
	    				_columnsAvailable.splice(j,1);
	    				break;
	    			}
	    		}
	    	}

	    	notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveAllSelectedColumnsForAvaibleColumns = function() {
		if (_selectedColumns.length > 0) {
			for (var i = 0; i < _selectedColumns.length; i++) {
				var item = _selectedColumns[i];
	
				_columnsAvailable.push(item);
			}

			_selectedColumns  		= [];
			notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveSelectedColumnsForAvaibleColumns = function(columns) {
		if (_jsUtil.checkProperty(columns, 'length') && columns.length > 0) {
	    	var i = 0;
	    	var j = 0;

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _selectedColumns.length; j++) {
	    			var item = _selectedColumns[j];

	    			if (column == item.field) {
	    				_columnsAvailable.push(item);
	    				break;
	    			}
	    		}

	    	}

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _selectedColumns.length; j++) {
	    			var item = _selectedColumns[j];

	    			if (column == item.field) {
	    				_selectedColumns.splice(j,1);
	    				break;
	    			}
	    		}
	    	}

	    	notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveFirstSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var itemsTemp = [];
			var itemTemp = null;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
					itemTemp = _selectedColumns[i];
					_selectedColumns.splice(i,1);

    				break;
    			}
    		}

    		if (itemTemp != null) {
    			itemsTemp.push(itemTemp);

    			for (i = 0; i < _selectedColumns.length; i++) {
        			var item = _selectedColumns[i];
        			itemsTemp.push(item);
        		}
    		}

    		if (itemsTemp.length > 0) {
    			_selectedColumns = itemsTemp;
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[0]});
    		}
		}
	};

	this.moveLastSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var itemsTemp = [];
			var itemTemp = null;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
					itemTemp = _selectedColumns[i];
					_selectedColumns.splice(i,1);

    				break;
    			}
    		}

    		if (itemTemp != null) {
    			for (i = 0; i < _selectedColumns.length; i++) {
        			var item = _selectedColumns[i];
        			itemsTemp.push(item);
        		}

    			itemsTemp.push(itemTemp);
    		}

    		if (itemsTemp.length > 0) {
    			_selectedColumns = itemsTemp;
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[_selectedColumns.length-1]});
    		}

		}
	};

	this.moveUpSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var newIndex = -1;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
    				if (i - 1 >= 0) {
    					newIndex = i - 1;
    					var itemTemp = _selectedColumns[newIndex];
    					_selectedColumns[newIndex] = item;
    					_selectedColumns[i] = itemTemp;
    				}

    				break;
    			}
    		}

    		if (newIndex != -1) {
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[newIndex]});    			
    		}
		}
	};

	this.moveDownSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var newIndex = -1;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
    				if (i + 1 < _selectedColumns.length) {
    					newIndex = i + 1;
    					var itemTemp = _selectedColumns[newIndex];
    					_selectedColumns[newIndex] = item;
    					_selectedColumns[i] = itemTemp;
    				}

    				break;
    			}
    		}

    		if (newIndex != -1) {
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[newIndex]});
    		}
		}
	};
    
    /*OUTROS*/
    var notifyGridConfigObservers = function(event, parameters) {
		for (var observerKey in _gridConfigObervers) {
			switch(event) {
				case _EVENT_MOVED_COLUMNS :
					if (typeof _gridConfigObervers[observerKey].movedColumns != 'undefined') {
						_gridConfigObervers[observerKey].movedColumns(parameters.columnsAvailable, parameters.selectedColumns);
					}
					break;
				case _EVENT_LOADING_FINISHED_CONFIGURATION :
					if (typeof _gridConfigObervers[observerKey].loadingFinishedConfiguration != 'undefined') {
						_gridConfigObervers[observerKey].loadingFinishedConfiguration();
					}
					break;
				case _EVENT_AVAIBLE_COLUMNS_FILTERED :
					if (typeof _gridConfigObervers[observerKey].avaibleColumnsFiltered != 'undefined') {
						_gridConfigObervers[observerKey].avaibleColumnsFiltered(parameters.columns);
					}
					break;
				case _EVENT_SELECTED_COLUMNS_FILTERED :
					if (typeof _gridConfigObervers[observerKey].selectedColumnsFiltered != 'undefined') {
						_gridConfigObervers[observerKey].selectedColumnsFiltered(parameters.columns);
					}
					break;
				case _EVENT_SORTED_COLUMNS :
					if (typeof _gridConfigObervers[observerKey].sortedColumns != 'undefined') {
						_gridConfigObervers[observerKey].sortedColumns(parameters.columnsAvailable, parameters.selectedColumns, parameters.column);
					}
					break;
			}
		}
	};
    
    this.filterColumnsAvailable = function(columnFilter, value) {
		var columnsFiltered = [];

		if (_jsUtil.hasInformation(value)) {
			for (var i = 0; i < _columnsAvailable.length; i++) {
				var item				= _columnsAvailable[i];
				var itemColumnFilter 	= item[columnFilter];

				if (itemColumnFilter.toUpperCase().indexOf(value.toUpperCase()) > -1) {
					columnsFiltered.push(item);
				}
			}
		} else {
			columnsFiltered = _columnsAvailable;
		}

		notifyGridConfigObservers(_EVENT_AVAIBLE_COLUMNS_FILTERED, {columns: columnsFiltered});
	};

	this.filterSelectedColumns = function(columnFilter, value) {
		var columnsFiltered = [];

		if (_jsUtil.hasInformation(value)) {
			for (var i = 0; i < _selectedColumns.length; i++) {
				var item				= _selectedColumns[i];
				var itemColumnFilter 	= item[columnFilter];

				if (itemColumnFilter.toUpperCase().indexOf(value.toUpperCase()) > -1) {
					columnsFiltered.push(item);
				}
			}
		} else {
			columnsFiltered = _selectedColumns;
		}

		notifyGridConfigObservers(_EVENT_SELECTED_COLUMNS_FILTERED, {columns: columnsFiltered});
	};
    
    /*
    
    var processOriginalColumns = function(result) {
        if(angular.isDefined(result.responseBody.gridConfig.field)) {
                    
        }
        else {
            _originalAllColumns = [];    
            for(var i = 0; i < _dataGrid.ngGrid.config.columnDefs.length; i++) {
                _dataGrid.ngGrid.config.columnDefs[i].visible = true;
                _originalAllColumns.push(_dataGrid.ngGrid.config.columnDefs[i]);
            }
        }
	};

	var processSelectedColumns = function(result) {
        if(angular.isDefined(result.responseBody.gridConfig.field)) {
                    
        }
        
        
		var fieldsResult 	= result.responseBody.gridConfig != undefined ? result.responseBody.gridConfig.field : undefined;
        if(fieldsResult != undefined) {
             _originalSelectedColumns = [];
            for(var i = 0; i < _dataGrid.ngGrid.config.columnDefs.length; i++) {
                _dataGrid.ngGrid.config.columnDefs[i].visible = false;
            }
            
            for (var i = 0; i < fieldsResult.length; i++) {
                var field = fieldsResult[i];
                for(var j = 0; j < _dataGrid.ngGrid.config.columnDefs.length; j++) {
                    if(_dataGrid.ngGrid.config.columnDefs[j].field === field.name) {
                        _dataGrid.ngGrid.config.columnDefs[j].visible = true;
                        _originalSelectedColumns.push(_dataGrid.ngGrid.config.columnDefs[j]);
                    }
                }
            }
        }
	};
    
    var getLoadConfigRequest = function() {
		var jsonLoadConfig = {
				gridConfig : {
					configName : _configName
				}
		};
		return jsonLoadConfig;
	};
    
    var defineColumns = function(typeColumns) {
		if (typeColumns == _SELECTED_COLUMNS) {
			_selectedColumns = [];
			_selectedColumns.push.apply(_selectedColumns, _originalSelectedColumns);
		} else if (typeColumns == _COLUMNS_AVAIBLE) {
			_originalColumnsAvaible = [];
			_originalColumnsAvaible.push.apply(_originalColumnsAvaible, _originalAllColumns);

			for (var i = 0; i < _originalSelectedColumns.length; i++) {
				var selectedColum = _originalSelectedColumns[i];

				for (var j = 0; j < _originalColumnsAvaible.length; j++) {
					var columnAvaible = _originalColumnsAvaible[j];

					if (selectedColum.field == columnAvaible.field) {
						_originalColumnsAvaible.splice(j, 1);
						break;
					}
				}
			}

			_columnsAvailable = [];
			_originalColumnsAvaible = getOrderedColumns(_originalColumnsAvaible, 'displayName');
			_columnsAvailable.push.apply(_columnsAvailable, _originalColumnsAvaible);
		}
	};

	var getOrderedColumns = function(columns, columName) {
		var orderedColumnsTemp = [];

		if (_originalAllColumns.length > 0) {
			orderedColumnsTemp.push.apply(orderedColumnsTemp, columns);

			orderedColumnsTemp.sort(function(f1, f2) {
				if (f1[columName] == f2[columName]) {
			        return 0;
				} else if (f1[columName] < f2[columName]) {
			        return -1;
				} else {
			        return 1;
				}
			});
		}

		return orderedColumnsTemp;
	};

	this.saveConfig = function() {
		var saveConfigRequest = getSaveConfigRequest(false);

		_serviceProxy.callService(_SAVE_CONFIG, saveConfigRequest)
			.then(function(result) {
				processResult(result, true);
		});
	};

	this.updateConfigForColumns = function(columns) {
		if (updateSelectedColumns(columns)) {
			var saveConfigRequest = getSaveConfigRequest(true);

			_serviceProxy.callService(_SAVE_CONFIG, saveConfigRequest)
				.then(function(result) {
					processResult(result, false);
			});
		}
	};

	this.restore = function() {
		var restoreConfigRequest = getRestoreConfigRequest();

		_serviceProxy.callService(_RESTORE_CONFIG, restoreConfigRequest)
			.then(function(result) {
				//TODO: verificar se não retornou nenhum campo restrito
                if(angular.isDefined(result.responseBody.gridConfig.field)) {
                    
                }
                else {
                    self.loadConfiguration();
                }
		});
	};

	this.cancel = function() {
		_columnsAvailable 	= [];
		_selectedColumns 	= [];
		_columnsAvailable.push.apply(_columnsAvailable, _originalColumnsAvaible);
		_selectedColumns.push.apply(_selectedColumns, _originalSelectedColumns);
	};

	this.addObserver = function(observer) {
		_gridConfigObervers.push(observer);
	};

	this.removeObserver = function(observer) {
		_gridConfigObervers.unshift(observer);
	};

	this.setConfigName = function(configName) {
		_configName = configName;
	};

	this.getConfigName = function() {
		return _configName;
	};

	this.getPresentationColumn = function() {
		return _presentationColumn;
	};

	this.setPresentationColumn = function(presentationColumn) {
		_presentationColumn = presentationColumn;
	};

	this.getAdvancedSettings = function() {
		return _advancedSettings;
	};

	this.setAdvancedSettings = function(advancedSettings) {
		_advancedSettings = advancedSettings;
	};

	this.getSelectedColumns = function() {
		return _selectedColumns;
	};

	this.setSelectedColumns = function(selectedColumns) {
		_selectedColumns = selectedColumns;
	};

	this.getColumnsAvailable = function() {
		return _columnsAvailable
	};

	this.setColumnsAvailable = function(columnsAvailable) {
		_columnsAvailable = columnsAvailable;
	};

	this.setDataGrid = function(dataGrid) {
		_dataGrid = dataGrid;
	};

	this.setDataSet = function(dataSet) {
		_dataSet = dataSet
	};

	this.setServiceProxy = function(serviceProxy) {
		_serviceProxy = serviceProxy;
	}

	this.setJSUtil = function(jsUtil) {
		_jsUtil = jsUtil;
	};

	this.rebuildColumnsDataGrid = function() {
		rebuildColumns(true);
	};

	this.moveAllAvaibleColumnsForSelectedColumns = function() {
		if (_columnsAvailable.length > 0) {
			for (var i = 0; i < _columnsAvailable.length; i++) {
				var item = _columnsAvailable[i];
	
				_selectedColumns.push(item);
			}

			_columnsAvailable  		= [];
			notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveAvaibleColumnsForSelectedColumns = function(columns) {
		if (_jsUtil.checkProperty(columns, 'length') && columns.length > 0) {
	    	var i = 0;
	    	var j = 0;

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _columnsAvailable.length; j++) {
	    			var item = _columnsAvailable[j];

	    			if (column == item.field) {
	    				_selectedColumns.push(item);
	    				break;
	    			}
	    		}

	    	}

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _columnsAvailable.length; j++) {
	    			var item = _columnsAvailable[j];

	    			if (column == item.field) {
	    				_columnsAvailable.splice(j,1);
	    				break;
	    			}
	    		}
	    	}

	    	notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveAllSelectedColumnsForAvaibleColumns = function() {
		if (_selectedColumns.length > 0) {
			for (var i = 0; i < _selectedColumns.length; i++) {
				var item = _selectedColumns[i];
	
				_columnsAvailable.push(item);
			}

			_selectedColumns  		= [];
			notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveSelectedColumnsForAvaibleColumns = function(columns) {
		if (_jsUtil.checkProperty(columns, 'length') && columns.length > 0) {
	    	var i = 0;
	    	var j = 0;

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _selectedColumns.length; j++) {
	    			var item = _selectedColumns[j];

	    			if (column == item.field) {
	    				_columnsAvailable.push(item);
	    				break;
	    			}
	    		}

	    	}

	    	for (i = 0; i < columns.length; i++) {
	    		var column = columns[i];

	    		for (j = 0; j < _selectedColumns.length; j++) {
	    			var item = _selectedColumns[j];

	    			if (column == item.field) {
	    				_selectedColumns.splice(j,1);
	    				break;
	    			}
	    		}
	    	}

	    	notifyGridConfigObservers(_EVENT_MOVED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns});
		}
	};

	this.moveFirstSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var itemsTemp = [];
			var itemTemp = null;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
					itemTemp = _selectedColumns[i];
					_selectedColumns.splice(i,1);

    				break;
    			}
    		}

    		if (itemTemp != null) {
    			itemsTemp.push(itemTemp);

    			for (i = 0; i < _selectedColumns.length; i++) {
        			var item = _selectedColumns[i];
        			itemsTemp.push(item);
        		}
    		}

    		if (itemsTemp.length > 0) {
    			_selectedColumns = itemsTemp;
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[0]});
    		}
		}
	};

	this.moveLastSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var itemsTemp = [];
			var itemTemp = null;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
					itemTemp = _selectedColumns[i];
					_selectedColumns.splice(i,1);

    				break;
    			}
    		}

    		if (itemTemp != null) {
    			for (i = 0; i < _selectedColumns.length; i++) {
        			var item = _selectedColumns[i];
        			itemsTemp.push(item);
        		}

    			itemsTemp.push(itemTemp);
    		}

    		if (itemsTemp.length > 0) {
    			_selectedColumns = itemsTemp;
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[_selectedColumns.length-1]});
    		}

		}
	};

	this.moveUpSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var newIndex = -1;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
    				if (i - 1 >= 0) {
    					newIndex = i - 1;
    					var itemTemp = _selectedColumns[newIndex];
    					_selectedColumns[newIndex] = item;
    					_selectedColumns[i] = itemTemp;
    				}

    				break;
    			}
    		}

    		if (newIndex != -1) {
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[newIndex]});    			
    		}
		}
	};

	this.moveDownSelectedColumn = function(column) {
		if (_jsUtil.hasInformation(column)) {
			var i = 0;
			var newIndex = -1;

    		for (i = 0; i < _selectedColumns.length; i++) {
    			var item = _selectedColumns[i];

    			if (column == item.field) {
    				if (i + 1 < _selectedColumns.length) {
    					newIndex = i + 1;
    					var itemTemp = _selectedColumns[newIndex];
    					_selectedColumns[newIndex] = item;
    					_selectedColumns[i] = itemTemp;
    				}

    				break;
    			}
    		}

    		if (newIndex != -1) {
    			notifyGridConfigObservers(_EVENT_SORTED_COLUMNS, {columnsAvailable: _columnsAvailable, selectedColumns: _selectedColumns, column: _selectedColumns[newIndex]});
    		}
		}
	};
    
    var notifyGridConfigObservers = function(event, parameters) {
		for (var observerKey in _gridConfigObervers) {
			switch(event) {
				case _EVENT_MOVED_COLUMNS :
					if (typeof _gridConfigObervers[observerKey].movedColumns != 'undefined') {
						_gridConfigObervers[observerKey].movedColumns(parameters.columnsAvailable, parameters.selectedColumns);
					}
					break;
				case _EVENT_LOADING_FINISHED_CONFIGURATION :
					if (typeof _gridConfigObervers[observerKey].loadingFinishedConfiguration != 'undefined') {
						_gridConfigObervers[observerKey].loadingFinishedConfiguration();
					}
					break;
				case _EVENT_AVAIBLE_COLUMNS_FILTERED :
					if (typeof _gridConfigObervers[observerKey].avaibleColumnsFiltered != 'undefined') {
						_gridConfigObervers[observerKey].avaibleColumnsFiltered(parameters.columns);
					}
					break;
				case _EVENT_SELECTED_COLUMNS_FILTERED :
					if (typeof _gridConfigObervers[observerKey].selectedColumnsFiltered != 'undefined') {
						_gridConfigObervers[observerKey].selectedColumnsFiltered(parameters.columns);
					}
					break;
				case _EVENT_SORTED_COLUMNS :
					if (typeof _gridConfigObervers[observerKey].sortedColumns != 'undefined') {
						_gridConfigObervers[observerKey].sortedColumns(parameters.columnsAvailable, parameters.selectedColumns, parameters.column);
					}
					break;
			}
		}
	};
    
    var getSaveConfigRequest = function(sortByIndex) {
		var jsonSaveConfig = {
				gridConfig : {
					restrictBySup: false,
					configName : _configName,
					field: []
				}
		};

		for (var i = 0; i < _selectedColumns.length; i++) {
			var column = _selectedColumns[i];

			if (column.field == 'EMPTYCOLUM') {
				continue;
			}

			var field = {};
			field.name 			= column.field;
			field.width 		= column.width;
			field.index			= sortByIndex ? column.index : i;
			field.orderIndex 	= 0;

			jsonSaveConfig.gridConfig.field.push(field);
		}

		if (sortByIndex) {
			jsonSaveConfig.gridConfig.field = getOrderedColumns(jsonSaveConfig.gridConfig.field, 'index');
		}

		return jsonSaveConfig;
	};
    
    var processResult = function(result, isRebuildColumns) {
		processSelectedColumns(result);
		defineColumns(_SELECTED_COLUMNS);
		defineColumns(_COLUMNS_AVAIBLE);

		if (isRebuildColumns) {
			_dataGrid.ngGrid.buildColumns();
		}
	};
    
    var getRestoreConfigRequest = function() {
		var jsonLoadConfig = {
				gridConfig : {
					configName : _configName
				}
		};

		return jsonLoadConfig;
	};
    
    this.filterColumnsAvailable = function(columnFilter, value) {
		var columnsFiltered = [];

		if (_jsUtil.hasInformation(value)) {
			for (var i = 0; i < _columnsAvailable.length; i++) {
				var item				= _columnsAvailable[i];
				var itemColumnFilter 	= item[columnFilter];

				if (itemColumnFilter.toUpperCase().indexOf(value.toUpperCase()) > -1) {
					columnsFiltered.push(item);
				}
			}
		} else {
			columnsFiltered = _columnsAvailable;
		}

		notifyGridConfigObservers(_EVENT_AVAIBLE_COLUMNS_FILTERED, {columns: columnsFiltered});
	};

	this.filterSelectedColumns = function(columnFilter, value) {
		var columnsFiltered = [];

		if (_jsUtil.hasInformation(value)) {
			for (var i = 0; i < _selectedColumns.length; i++) {
				var item				= _selectedColumns[i];
				var itemColumnFilter 	= item[columnFilter];

				if (itemColumnFilter.toUpperCase().indexOf(value.toUpperCase()) > -1) {
					columnsFiltered.push(item);
				}
			}
		} else {
			columnsFiltered = _selectedColumns;
		}

		notifyGridConfigObservers(_EVENT_SELECTED_COLUMNS_FILTERED, {columns: columnsFiltered});
	};
    
    /*
	this.filterColumnsAvailable = function(columnFilter, value) {
		var columnsFiltered = [];

		if (_jsUtil.hasInformation(value)) {
			for (var i = 0; i < _columnsAvailable.length; i++) {
				var item				= _columnsAvailable[i];
				var itemColumnFilter 	= item[columnFilter];

				if (itemColumnFilter.toUpperCase().indexOf(value.toUpperCase()) > -1) {
					columnsFiltered.push(item);
				}
			}
		} else {
			columnsFiltered = _columnsAvailable;
		}

		notifyGridConfigObservers(_EVENT_AVAIBLE_COLUMNS_FILTERED, {columns: columnsFiltered});
	};

	this.filterSelectedColumns = function(columnFilter, value) {
		var columnsFiltered = [];

		if (_jsUtil.hasInformation(value)) {
			for (var i = 0; i < _selectedColumns.length; i++) {
				var item				= _selectedColumns[i];
				var itemColumnFilter 	= item[columnFilter];

				if (itemColumnFilter.toUpperCase().indexOf(value.toUpperCase()) > -1) {
					columnsFiltered.push(item);
				}
			}
		} else {
			columnsFiltered = _selectedColumns;
		}

		notifyGridConfigObservers(_EVENT_SELECTED_COLUMNS_FILTERED, {columns: columnsFiltered});
	};

	var doSave = function(isRebuildColumns) {
		
	};

	var getRestoreConfigRequest = function() {
		var jsonLoadConfig = {
				gridConfig : {
					configName : _configName
				}
		};

		return jsonLoadConfig;
	};

	var getSaveConfigRequest = function(sortByIndex) {
		var jsonSaveConfig = {
				gridConfig : {
					restrictBySup: false,
					configName : _configName,
					field: []
				}
		};

		for (var i = 0; i < _selectedColumns.length; i++) {
			var column = _selectedColumns[i];

			if (column.field == 'EMPTYCOLUM') {
				continue;
			}

			var field = {};
			field.name 			= column.field;
			field.width 		= column.width;
			field.index			= sortByIndex ? column.index : i;
			field.orderIndex 	= 0;

			jsonSaveConfig.gridConfig.field.push(field);
		}

		if (sortByIndex) {
			jsonSaveConfig.gridConfig.field = getOrderedColumns(jsonSaveConfig.gridConfig.field, 'index');
		}

		return jsonSaveConfig;
	};

	var processResult = function(result, isRebuildColumns) {
		processSelectedColumns(result);
		defineColumns(_SELECTED_COLUMNS);
		defineColumns(_COLUMNS_AVAIBLE);

		if (isRebuildColumns) {
			rebuildColumns(isRebuildColumns);
		}
	};
    
	var getEmptyColumn = function() {
		var column		 			= {};

		column.field				= 'EMPTYCOLUM';
		column.displayName			= '';
		column.width				= 70;
		column.minWidth				= 70;
		column.index				= _originalSelectedColumns.length;
		column.pinnable				= false;
		column.enableCellEdit		= false;
		column.resizable			= false;
		column.visible				= true;
		column.sortable				= false;
		column.groupable			= false;

		return column;
	};

	var defineColumns = function(typeColumns) {
		if (typeColumns == _SELECTED_COLUMNS) {
			_selectedColumns = [];
			_selectedColumns.push.apply(_selectedColumns, _originalSelectedColumns);
		} else if (typeColumns == _COLUMNS_AVAIBLE) {
			_originalColumnsAvaible = [];
			_originalColumnsAvaible.push.apply(_originalColumnsAvaible, _originalAllColumns);

			for (var i = 0; i < _originalSelectedColumns.length; i++) {
				var selectedColum = _originalSelectedColumns[i];

				for (var j = 0; j < _originalColumnsAvaible.length; j++) {
					var columnAvaible = _originalColumnsAvaible[j];

					if (selectedColum.displayName == columnAvaible.displayName) {
						_originalColumnsAvaible.splice(j, 1);
						break;
					}
				}
			}

			_columnsAvailable = [];
			_originalColumnsAvaible = getOrderedColumns(_originalColumnsAvaible, 'displayName');
			_columnsAvailable.push.apply(_columnsAvailable, _originalColumnsAvaible);
		}
	};

	var getOrderedColumns = function(columns, columName) {
		var orderedColumnsTemp = [];

		if (_originalAllColumns.length > 0) {
			orderedColumnsTemp.push.apply(orderedColumnsTemp, columns);

			orderedColumnsTemp.sort(function(f1, f2) {
				if (f1[columName] == f2[columName]) {
			        return 0;
				} else if (f1[columName] < f2[columName]) {
			        return -1;
				} else {
			        return 1;
				}
			});
		}

		return orderedColumnsTemp;
	};

	var rebuildColumns = function(isBuildColumns) {
		if (_jsUtil.hasInformation(_dataGrid)) {
			_dataGrid.columnDefs = [];
			_dataGrid.ngGrid.config.columnDefs = [];
			_dataGrid.columnDefs.push.apply(_dataGrid.columnDefs, _selectedColumns);
			_dataGrid.ngGrid.config.columnDefs.push.apply(_dataGrid.ngGrid.config.columnDefs, _selectedColumns);

			if (isBuildColumns) {
				_dataGrid.ngGrid.buildColumns();
			}
		}
	};

	var updateSelectedColumns = function(columns) {
		var filteredColumns = [];
		var isChanged = false;

	    angular.forEach(columns, function (column, index) {
	        if (column.field != '' && typeof column.field != undefined) {
	            this.push(column);
	        }
	    }, filteredColumns);

	    if (filteredColumns != undefined) {
    		for (var i = 0; i < _selectedColumns.length; i++) {
    			var selCol = _selectedColumns[i];

    			for (var j = 0; j < filteredColumns.length; j++) {
    				var col = filteredColumns[j];

	    			if (col.field == selCol.field) {
	    				if (selCol.width != col.width || selCol.index != col.index) {
		    				selCol.width = col.width;
		    				selCol.index = col.index;
		    				isChanged = true;
		    				break;
	    				}
	    			}
    			}
    		}

    		if (isChanged) {
    			filteredColumns = getOrderedColumns(filteredColumns, 'index');
    		}
    	}

	    return isChanged;
	};

	var notifyGridConfigObservers = function(event, parameters) {
		for (var observerKey in _gridConfigObervers) {
			switch(event) {
				case _EVENT_MOVED_COLUMNS :
					if (typeof _gridConfigObervers[observerKey].movedColumns != 'undefined') {
						_gridConfigObervers[observerKey].movedColumns(parameters.columnsAvailable, parameters.selectedColumns);
					}
					break;
				case _EVENT_LOADING_FINISHED_CONFIGURATION :
					if (typeof _gridConfigObervers[observerKey].loadingFinishedConfiguration != 'undefined') {
						_gridConfigObervers[observerKey].loadingFinishedConfiguration();
					}
					break;
				case _EVENT_AVAIBLE_COLUMNS_FILTERED :
					if (typeof _gridConfigObervers[observerKey].avaibleColumnsFiltered != 'undefined') {
						_gridConfigObervers[observerKey].avaibleColumnsFiltered(parameters.columns);
					}
					break;
				case _EVENT_SELECTED_COLUMNS_FILTERED :
					if (typeof _gridConfigObervers[observerKey].selectedColumnsFiltered != 'undefined') {
						_gridConfigObervers[observerKey].selectedColumnsFiltered(parameters.columns);
					}
					break;
				case _EVENT_SORTED_COLUMNS :
					if (typeof _gridConfigObervers[observerKey].sortedColumns != 'undefined') {
						_gridConfigObervers[observerKey].sortedColumns(parameters.columnsAvailable, parameters.selectedColumns, parameters.column);
					}
					break;
			}
		}
	};
    */
}
function JSUtil() {

	this.hasInformation = function(value) {
		return value != undefined && value != '' && value != null;
	};

	this.checkProperty = function(value, nameProperty) {
		return value != undefined && value != null && value[nameProperty] != undefined && value[nameProperty] != null;
	};

	this.getValueOrNull = function(value) {
		if (value != undefined && value != '' && value != null) {
			return value
		}

		return null;
	};
}
/**
 * @ngdoc interface
 * @name snk.components.timelinediagram:TimeLineLane
 * @description Implementação da Lane
 */
class TimeLineLane{
    
    static DEFAULT_TASK_HEIGHT = 20;
    
    constructor(diagram, description, $injector, element){
        this.diagram = diagram;
        this.description = description;
        this.hasExpanded = false;
        this.hasAnyTimeConflict = false;
        this.tasks = [];
        this.dateUtils = $injector.get('DateUtils');
        this.marginTop = 0;
        this.timeWearImages = [];
        this.element = element;
        this.angularUtil = $injector.get('AngularUtil');
        this.arrayUtils = $injector.get('ArrayUtils');
        this._index = 0;
        this.mapUsingPositions = [];
        this.periodStarted = false;
    }

    addDynamicProperty(key, value){
        if(!this.properties){
            this.properties = {};
        }

        this.properties[key] = value;
    }

    getDynamicProperty(name) {
        return this.properties == undefined ? undefined : this.properties[name];
    }

    getDescription(){
        return this.description;
    }

    setDescription(description){
        this.description = description;
    }

    setExpanded(hasExpanded){
        this.hasExpanded = hasExpanded;
    }

    isExpanded(){
        return this.hasExpanded;
    }

    setId(id){
        this.id = id;
    }

    getId(){
        return this.id;
    }

    setExpandedHeight(height){
        this.expandedHeight = height;
    }

    getExpandedHeight(){
        return this.expandedHeight;
    }

    //Essas funções são sobrescritas pelo timelinediagram.controller.js
    collapse(){

    }
    
    expand(){

    }

    compareTo(){

    }

    addTask(task){
        this.tasks.push(task);

        if(!task.color && this.getDynamicProperty("COLOR")) task.color = this.getDynamicProperty("COLOR");
        if(!task.conflictColor && this.getDynamicProperty("CONFLICTCOLOR")) task.conflictColor = this.getDynamicProperty("CONFLICTCOLOR");

        this.tasks.sort((t1, t2) => {
            var returnValue = Math.min(1, Math.max(-1, t1.start.getTime() - t2.start.getTime()));
            if (returnValue == 0) {
                returnValue = Math.min(1, Math.max(-1, t1.end.getTime() - t2.end.getTime()));
            }
            return returnValue;
        });
    }

    updateTaskMetrics(task) {
        let startDate = task.periodStart || task.start;
        let startCol = this.diagram.getColumnIndex(startDate);
        let endCol = this.diagram.getColumnIndex(task.end);

        //Se a coluna final não está na view port, vamos posicionar a task até a utilima coluna disponivél.
        if(endCol == -1){
            endCol = this.diagram.getVisibleColumns();
        }

        let cols = (endCol - startCol) + 1;
        task.countCols = cols > 0 ? cols : 1;
        this.calcTaskPosition(task);
        
        if(cols > 1){
            //Força o recalculo de altura da linha
            if(this.hasExpanded){
                this.expand();
            }
        } 
        
        task.updateCurrentTaskPosition();
    }

    calcTaskPosition(task){
        let atualTaskEl = this.element.find('#uid-' + task.uid );

        let position = this.arrayUtils.find(this.mapUsingPositions, pos => pos.taskId == task.uid);
        
        if(!position) {
            position = {
                taskId: task.uid,
                marginTop: 0
            };
            this.mapUsingPositions.push(position); 
        }

        if(atualTaskEl.length > 0){
            let boundRec = atualTaskEl[0].getBoundingClientRect();
            //Buscamos a margem atual da task
            let mgTop = atualTaskEl.css('marginTop').replace('px', '');            
            if(!isNaN(mgTop)){
                position.marginTop = Number(mgTop);
            }
            
            position.y1 = boundRec.top;
            position.y2 = (boundRec.top);
            position.x1 = boundRec.left;
            position.x2 = (boundRec.left + boundRec.width);
            position.height = boundRec.height;                    
        }

        let usingPosition = this.isUsingPosition(position);
        let countRetry = 0; //Limitamos a 1000 tentativas para evitar recursão

        while(usingPosition !== false && countRetry <= 1000){
            position.y1 +=  TimeLineLane.DEFAULT_TASK_HEIGHT;
            position.y2 +=  TimeLineLane.DEFAULT_TASK_HEIGHT;
            position.marginTop += TimeLineLane.DEFAULT_TASK_HEIGHT;                    
            usingPosition = this.isUsingPosition(position);
            countRetry++;
        }

        task.marginTop = position.marginTop;       
    }

    calcTasksPositions(){
        this.diagram.getVisibleDates().forEach( date => { 
            let tasks = this.getTasksByDay(date);                
            tasks.forEach( t => {
                this.calcTaskPosition(t);
            });
        });
    }

    invalidateUsingPosition(){ 
        this.mapUsingPositions = [];
    }

    isUsingPosition(posA){
        let partialArr = this.mapUsingPositions.slice(0, this.mapUsingPositions.indexOf(posA));

        for(var i = 0; i < partialArr.length; i++){
            let posB = partialArr[i];
            let diffHA = 0;
            let diffHB = 0;
            
            if(posA.height > posB.height){
                diffHA = posA.height - posB.height;
            }else if(posB.height > posA.height){
                diffHB = posB.height - posA.height;
            }
            
            if( 
                posA != posB                                                        &&
                posA.y1 >= posB.y1                                                  && 
                Math.floor( posA.y2 + diffHA) - Math.floor(posB.y2 + diffHB) <= 1   &&  //Consideramos a diferença de 1px, por conta da borda quando temos o box.
                posB.x2 >= posA.x1
            ){
                return true;
            }
        }

        return false;
    }

    updateHorizontalMetrics(){
        if(this.diagram.isShowTimeWear()){
            for(var i = 0; i < this.diagram.getVisibleColumnsLength(); i++){
                this.addTimeWearImage(i);
            }
        }        
        //setTimeout para aguardar rendeeização das tasks
        setTimeout(() => {

            if (this.timeWearImages.length > this.diagram.getVisibleColumnsLength()) {
                this.timeWearImages = this.timeWearImages.slice(0, this.diagram.getVisibleColumnsLength())
            }

            //Limpamos os timeWear para que não fique em estado de conflito ao adicionar os intervalos novamente.
            this.timeWearImages.forEach(timeW => {
                var ctrlTimeWear = this.angularUtil.getControllerFromElement(timeW);
                if(ctrlTimeWear) ctrlTimeWear.clear();
            });

            this.invalidateUsingPosition();

            this.diagram.getVisibleDates().forEach( date => { 
                let tasks = this.getTasksByDay(date);                
                tasks.forEach( t => {
                    this.updateTaskMetrics(t);
                    if(this.diagram.isShowTimeWear()) this.updateTimeWear(t);
                });
            });

            this.angularUtil.apply(this.element.scope());
        });
    }

    addTimeWearImage(index){
        let line = this.element.find('.line-body-' + this.id);
        let content;
        if(line.length > 0){
            content = line.find('.timewear-content.col-' + index);
        }
        if(content && !content.children()[0]){
            let scope = this.element.scope().$new();

            scope.lane = this;

            let elTimeWear = this.angularUtil.createDirective('sk-time-wear', {'sk-time-line': 'lane', 'sk-start-time': this.diagram.getFirstWorkingTime(), 'sk-end-time': this.diagram.getLastWorkingTime()}, scope);
            content.append(elTimeWear);

            this.timeWearImages.push(elTimeWear);
        }else if(content && content.children()[0]){
            let ctrl = this.angularUtil.getControllerFromElement(this.timeWearImages[index]);
            if(ctrl) ctrl.clear();
        }
    }

    removeTimeWearImages() {
        let line = this.element.find('.line-body-' + this.id);
        let images = [];        
        if(line.length > 0){
            images = line.find('.timewear-content');
        }

        for (let i = 0; i < images.length; i++) {
            let img = images[i];

            for(var j = 0; j < img.children.length; j++){
                img.children[j].remove()
            }
        }        
    }

    getTimeWearByIndex(index){
        return this.timeWearImages[index];
    }

    getTasksByDay(date){
        let tasksOfDate = [];
        
        this.tasks.forEach (task  => {
            if (this.dateUtils.compareOnlyDate(date, task.periodStart || task.start) == 0) {
                tasksOfDate.push(task);
                this.periodStarted = true;
            }
        });

        if (!tasksOfDate.length && !this.periodStarted) {
            let updateStart = false;
            this.tasks.forEach (task  => {
                if (!task.periodStart && date > task.start && date <= task.end && !updateStart) {
                    task.periodStart = date;
                    updateStart = true;
                }
            });
            if (updateStart) {
                this.getTasksByDay(date);
            }
        }

        return tasksOfDate;
    }

    get height(){
        let calcHeight = 0;
        
        this.diagram.getVisibleDates().forEach(date => {
            let dayDeight = 0;
            
            this.getTasksByDay(date).forEach(task => {
                dayDeight += (task.marginTop + TimeLineLane.DEFAULT_TASK_HEIGHT);
            });
            
            calcHeight = Math.max(calcHeight, dayDeight);
        });
        
        if(this.diagram.isShowTimeWear()){
            return calcHeight > 0 ? (calcHeight +  10) : 0;
        }else{
            return calcHeight;
        }
    }

     hasTimeConflict(task) {
        if(!this.diagram.hasShowTimeConflict()){
            return false;
        }

        if(task == null){
            return this.hasAnyTimeConflict;
        } else {
            return this.verifyTimeConflicts(task);
        }
    }

    hasConnectionProblem = () => {
        return "S" == this.getDynamicProperty("CONNECTIONPROBLEM");
    }

    verifyTimeConflicts(task){
        if(!this.diagram.hasShowTimeConflict()){
            return false;
        }

        let timeConflicts = false;

        this.tasks.forEach( (t) => {

            if (task.uid != t.uid && task.timeConflicts(t)) {
                this.hasAnyTimeConflict = true;
                timeConflicts = true;
                return;
            }

        });

        return timeConflicts;
    }

    updateTimeWear(task){
        if(this.timeWearImages.length == 0) return;

        var startDate = task.periodStart || task.start;
        var startIndex = this.diagram.getColumnIndex(startDate);
        var endIndex = this.diagram.getColumnIndex(task.end);
        
        if (startIndex == -1) {
            startIndex = 0;
        }
        
        if (endIndex == -1) {
            endIndex = this.diagram.getVisibleColumnsLength() - 1;
        }
        
        if (this.dateUtils.compareOnlyDate(startDate, task.end) == 0) {
            var timeWear = this.angularUtil.getControllerFromElement(this.timeWearImages[startIndex]);
            
            if(!timeWear) return;
            
            if (task.allDay) {
                timeWear.setFull();
            } else {
                timeWear.addUsedPeriod(this.dateUtils.dateToString(startDate, 'HH:mm'), this.dateUtils.dateToString(task.end, 'HH:mm') );
            }
        } else {
            var startTimeWear = this.angularUtil.getControllerFromElement(this.timeWearImages[startIndex]);
            var endTimeWear = this.angularUtil.getControllerFromElement(this.timeWearImages[endIndex]);
            
            if (task.allDay) {
                startTimeWear.setFull();
                if(endIndex != startIndex){
                    endTimeWear.setFull();
                }
            } else {
                var pos = task.getCurrentTaskPosition();
				var mergedLeft = (pos == TimeLineTask.MERGED_LEFT_POSITION || pos == TimeLineTask.FULL_MERGED_POSITION);
				var mergedRight = (pos == TimeLineTask.MERGED_RIGHT_POSITION || pos == TimeLineTask.FULL_MERGED_POSITION);
                
                var startTime = mergedLeft ? "00:00" : this.dateUtils.dateToString(startDate, 'HH:mm');
                var endTime = startIndex == this.dateUtils.dateToString(task.end, 'HH:mm');

				var endTime = startIndex == endIndex && !mergedRight ? this.dateUtils.dateToString(task.end, 'HH:mm') : "23:59";

                startTimeWear.addUsedPeriod(startTime, endTime);
                
                if(startIndex != endIndex){
                    startTime = "00:00";
                    endTime = mergedRight ? "23:59" :  this.dateUtils.dateToString(task.end, 'HH:mm');
                    endTimeWear.addUsedPeriod(startTime, endTime);
                }
            }

            for (var col = startIndex + 1; col < endIndex; col++) {
                timeWear = this.angularUtil.getControllerFromElement(this.timeWearImages[col]);
                timeWear.setFull();
            }
        }
    }

    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineLane#getAllTasks
     * @methodOf snk.components.timelinediagram:TimeLineLane
     * @description retorna todas as tasks registradas na linha.
     * @returns {[TimeLineTask]} array com as tasks registradas na linha.
     */
    getAllTasks() {
        return this.tasks;    
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineLane#isDirty
     * @methodOf snk.components.timelinediagram:TimeLineLane
     * @description verfica se a linha está com alterações que não foram salvas.
     * @returns {boolean} true se a linha está com alteração que ainda não foi salva.
     */
    get isDirty(){
      return this._dirty;  
    }
     /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineLane#dateConflicts
     * @methodOf snk.components.timelinediagram:TimeLineLane
     * @description marca a linha como editada.
     */
    invalidateByChange(){
        this._dirty = true;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineLane#containsTask
     * @methodOf snk.components.timelinediagram:TimeLineLane
     * @description verfica se a task passada como parâmetro está registrada na linha.
     * @param {TimeLineTask} task a ser verificado se está contida na linha.
     * @returns {boolean} true se task está registrada na linha.
     */
    containsTask(task) {
        return this.tasks.indexOf(task) > -1;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineLane#removeTask
     * @methodOf snk.components.timelinediagram:TimeLineLane
     * @description remove a task da linha corrente.
     * @param {TimeLineTask} task a ser verificado removida.
     */
    removeTask(task) {  
        this.arrayUtils.removeAtIndex(this.tasks, this.tasks.indexOf(task));
        this.updateHorizontalMetrics();
    }

    set index(value){
        this._index = value;
    }

    get index(){
        return this._index;
    }
}

/**
 * @ngdoc interface
 * @name snk.components.timelinediagram:TimeLineTask
 * @description Implementação da task
 */
class TimeLineTask {   
    
    static UNDEFINED_POSITION = 0;
	static OUTSIDE_RIGHT_POSITION = 1;
	static OUTSIDE_LEFT_POSITION = 2;
	static MERGED_LEFT_POSITION = 4;
	static FULL_MERGED_POSITION = 8;
	static INSIDE_POSITION = 16;
	static MERGED_RIGHT_POSITION = 32;
    static VISIBLE_POSITION = this.MERGED_LEFT_POSITION | this.FULL_MERGED_POSITION | this.INSIDE_POSITION | this.MERGED_RIGHT_POSITION;
    
    constructor(diagram, description, $injector){
        this.dateUtils = $injector.get('DateUtils');
        this.stringUtils = $injector.get('StringUtils');
        this.colorUtils = $injector.get('ColorUtils');
        this.diagram = diagram;
        this._description = (description && description.hasOwnProperty('$') ? description.$ : description);
        this._properties = {};
        this.marginTop = 0;
        this.uid = this.stringUtils.nextUid();
        this._toolTipText = "";
        this._modified = false;
    }

    isInvalidDateRange() {
        return this.dateError;
    }

    timeConflicts(t) {
        return this.containsDateTime(t.start) || this.containsDateTime(t.end) || t.containsDateTime(this.start) || t.containsDateTime(this.end);
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#dateConflicts
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description verifica se a data passada como parâmetro, está dentro do periodo da task (considerando data e hora).
     * @param {date} d data a ser comparada
     * @returns {boolean} true se a data passado como parâmetro está em conflito com o periodo da task.
     */
    containsDateTime(d) {
        return ( this.dateUtils.compare(d, this.start) >= 0) && ( this.dateUtils.compare(d, this.end) <= 0 );
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#dateConflicts
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description verifica se task está em conflito com a task passada como parâmetro.
     * @param {TimeLineTask} t task a ser comparada
     * @returns {boolean} true se a task está em conflito com a task passada como parâmetro.
     */
    dateConflicts(t) {
        return this.containsDate(t.start) || this.containsDate(t.end) || t.containsDate(this.start) || t.containsDate(this.end);
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#containsDate
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description verifica se a data passada como parâmetro, está dentro do periodo da task (considerando apenas data).
     * @param {date} d data a ser comparada.
     * @returns {boolean} true se a data passado como parâmetro está em conflito com o periodo da task.
     */
    containsDate(d) {
        return (this.dateUtils.compareOnlyDate(d,this.start) >= 0) && (this.dateUtils.compareOnlyDate(d, this.end) <= 0);
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#color
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description seta a cor da task quando a mesma não está em situação de conflito.
     * @returns {string} cor da task.
     */
    set color(value) {
        if(value != undefined) this._color = value.replace('0x', '#');//this.colorUtils.decimalColorToHTMLcolor(value);
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#conflictColor
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description seta a cor da task quando a mesma está em situação de conflito.
     * @returns {boolean} cor da task em situação de conflito.
     */
    set conflictColor(value) {
        if(value != undefined) this._conflictColor = value.replace('0x', '#');//this.colorUtils.decimalColorToHTMLcolor(value);;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#color
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna a cor da task quando a mesma não está em situação de conflito.
     * @returns {string} cor da task quando a mesma não está em conflito.
     */
    get color() {        
        return this._color;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#conflictColor
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna a cor da task em caso de conflito.
     * @returns {string} cor da task quando a mesma está em conflito.
     */
    get conflictColor() {
        return this._conflictColor;
    }

    checkDateError(){
        if(this.end == null || this.start == null){
            this.dateError = false;
        } else {
            this.dateError = (this.dateUtils.compare(this.start, this.end) > 0);
        }
    } 
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#allDay
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna se a task está ocupando o dia todo.
     * @returns {boolean} true se a task utiliza o dia todo.
     */
    get allDay() {
        return this._allDay;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#allDay
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description marca a task para ocupar o dia todo.
     * @param {boolean} value true caso a task estiver ocupando o dia todo.
     */
    set allDay(value) {
        this._allDay = value;
    }
   /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#done
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna se a task está concluida.
     * @returns {boolean} true se a task está concluida.
     */
    get done() {
        return this._done;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#done
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description marca a task como concluida.
     * @param {boolean} value true caso a task esteja concluida.
     */
    set done(value) {
        this._done = value;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#iconDone
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description seta o nome do icone done da task.
     * @param {string} value de done da task.
     */
    set iconDone(value) {
        this._doneIcon = value;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#iconDone
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna o nome do icone done da task.
     * @returns {string} icone de done da task.
     */
    get iconDone(){
        return this._doneIcon;
    }
    
    get start() {
        return this._start;
    }

    set start(value) {
        this._start = value;
        this.checkDateError();
    }

    get end() {
        return this._end;
    }

    set end(value) {
        this._end = value;
        this.checkDateError();
    }

    get rowIndex() {
        return this._rowIndex;
    }

    set rowIndex(value) {
        this._rowIndex = value;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#description
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna a descrição da task.
     * @returns {string} descrição da task.
     */
    get description() {
        return this._description;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#description
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description seta a descrição da task.
     * @param {string} name nome da propriedade
     */
    set description(value) {
        value = (value && value.hasOwnProperty('$') ? value.$ : value);
        this._description = this.stringUtils.emptyAsNull(value);
    }

    set width(w){
        this._width = w;
    }

    get width(){
        return this._width;
    }

    set countCols (countCols){
        this._countCols = countCols;
    }

    get countCols(){
        return this._countCols;
    }

    showBox(){
        return this.allDay || this.dateUtils.compareOnlyDate(this.start, this.end) != 0;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#getDynamicProperty
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description retorna o valor de uma propriedade dinâmica.
     * @param {string} name nome da propriedade
     * @returns {object} valor da propriedade dinâmica.
     */
    getDynamicProperty(name) {
        return this._properties[name];
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#removeDynamicProperty
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description remove uma propriedade dinâmica na task.
     * @param {string} name nome da propriedade
     */
    removeDynamicProperty(name) {
        delete this._properties[name];
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#addDynamicProperty
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description adiciona uma propriedade dinâmica na task.
     * @param {string} name nome da propriedade
     * @param {object} value valor da propriedade
     */
    addDynamicProperty(name, value){
        this._properties[name] = value;
    }

    getTaskPosition(firstDate, lastDate) {

        var startBefore = this.dateUtils.compareOnlyDate(this.start, firstDate) < 0;
        var endBefore = this.dateUtils.compareOnlyDate(this.end) < 0;

        var startAfter = this.dateUtils.compareOnlyDate(this.start, lastDate) > 0;
        var endAfter = this.dateUtils.compareOnlyDate(this.end, lastDate) > 0;

        var startInside = this.dateUtils.compareOnlyDate(this.start, firstDate) >= 0;
        var endInside = this.dateUtils.compareOnlyDate(this.end, lastDate) <= 0;

        if (startAfter && endAfter) {
            return TimeLineTask.OUTSIDE_RIGHT_POSITION;
        }

        if (startBefore) {
            if (endBefore) {
                return TimeLineTask.OUTSIDE_LEFT_POSITION;
            } else if (endInside) {
                return TimeLineTask.MERGED_LEFT_POSITION;
            } else if (endAfter) {
                return TimeLineTask.FULL_MERGED_POSITION;
            }
        }

        if (startInside) {
            if (endInside) {
                return TimeLineTask.INSIDE_POSITION;
            } else if (endAfter) {
                return TimeLineTask.MERGED_RIGHT_POSITION;
            }
        }

        return TimeLineTask.UNDEFINED_POSITION;
    }

    updateCurrentTaskPosition(){
        var newPos = this.getTaskPosition(this.diagram.getColumnDate(0), this.diagram.getColumnDate(this.diagram.getVisibleColumnsLength() - 1));
        if(newPos != this.currentPosition){
            this.currentPosition = newPos;
        }
    }

    getCurrentTaskPosition() {
        return this.currentPosition;
    }

    static create(config, diagram, $injector){
        let t = new TimeLineTask(diagram, config.description, $injector);
        
        if (config.hasOwnProperty("color")) {
            t.color = config.color.$;
        }
        
        if (config.hasOwnProperty("conflictcolor")) {
            t.conflictColor = config.conflictcolor.$;
        }

        for(var key in config.properties){
            t.addDynamicProperty(key, config.properties[key].$);
        }

        t.toolTipText = config.tooltiptext.$ ? config.tooltiptext.$ : '';
        t.done = config.done == "true";
        t.allDay = config.allDay == "true";
        t.iconDone = config.iconDone;

        t.start = t.dateUtils.strToDate(config.start);
        t.end = t.dateUtils.strToDate(config.end);
        
        return t;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#clone
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description Função para realizar a cópia da task.
     * @returns {TimeLineTask} Retorna uma instância cópia da task atual.
     */
    clone(){
        let cloned = Object.assign({}, this);        
        return cloned;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#toolTipText
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description Função para setar o tooltip da task.
     * @param {string} fieldMetadata Metadados de um campo.
     */
    set toolTipText(value){
        this._toolTipText = value;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#toolTipText
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description Função para recuperar o tooltip da task.
     */
    get toolTipText(){
        return this._toolTipText;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#setModified
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description Função para marcar a task como modificada.
     */
    setModified(){
        this._modified = true;
    }
    /**
     * @ngdoc
     * @name snk.components.timelinediagram:TimeLineTask#isModified
     * @methodOf snk.components.timelinediagram:TimeLineTask
     * @description Função para verificar se a task está marcada como modificada.
     * @returns {boolean} true se a task está modificada.
     */
    isModified(){
        return this._modified;
    }

    countWeekDays(dt1, dt2) {
        dt1 = angular.copy(dt1);
        let days = 0;
        
        while (this.dateUtils.compareOnlyDate(dt1, dt2) <= 0) {
            if (this.diagram.getIgnoreWeekend() || this.diagram.isWeekDay(dt1)) {
                days++;
            }
            dt1.setDate(dt1.getDate() + 1);
        }
        
        return days;
    }

    calculateEndDate(startDate) {
        let dt = this.addDays(startDate, this.countWeekDays(this.start, this.end));
        
        dt.setHours(this.end.getHours());
        dt.setMinutes(this.end.getMinutes());
        dt.setSeconds(this.end.getSeconds());
        
        return dt;
    }

    addDays(dt1, days) {
        let dt2;
        let inc = days > 0 ? 1 : -1;
        days = Math.abs(days);
        
        do {
            if (dt2 == undefined) {
                dt2 = angular.copy(dt1);
            } else {
                dt2.setDate(dt2.getDate() + inc);
            }

            if (this.diagram.getIgnoreWeekend() || this.diagram.isWeekDay(dt2)) {
                days--;
            }

        } while (days > 0)
        
        return dt2;
    }
}

 //Implementação do flash.geom.Rectangle
 class Rectangle{
    constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    right(val){
        if(val){
            this.width = val; 
        }

        return this.x + this.width;
    }

    left(val){
        if(val){
            this.x = val;
        }
        return this.x;
    }

    top(val){
        if(val){
            this.y = val;
        }
        return this.y;
    }

    bottom(val){
        if(val){
            this.height = val;
        }
        return this.y + this.height;
    }

    width(val){
        if(val){
            this.width = val;
        }
        return this.width;
    }

    height(val){
        if(val){
            this.height = val;
        }
        return this.height;
    }

    addWidth(val){
        this.width += val;
    }

    addHeight(val){
        this.height += val;
    }

    clone(){
        return new Rectangle(this.x, this.y, this.width, this.height);
    }
}

function ArrayList(originalList) {
    var _self                   = this;

    var _listVersion = 0;

    var _originalList           = originalList || [];
    var _innerList              = [];
    var _filterFunctions        = [];
    var _sortFunction           ;
    var _resetRecordsByInnerIndex   = {};
    var _qtdFilteredItems = 0;

    _self.length                = length;
    _self.setFilterFunction     = setFilterFunction;
    _self.addFilterFunction     = addFilterFunction;
    _self.setSortFunction       = setSortFunction;
    _self.refresh               = refresh;
    _self.addItem               = addItem;
    _self.addItemAt             = addItemAt;
    _self.getSource             = getSource;
    _self.getOriginalRecords    = getOriginalRecords;
    _self.setOriginalRecords    = setOriginalRecords;
    _self.clear                 = clear;
    _self.getItem               = getItem;
    _self.setItem               = setItem;
    _self.getItems              = getItems;
    _self.removeItem            = removeItem;
    _self.removeItemAt          = removeItemAt;
    _self.removeSort            = removeSort;
    _self.removeFilter          = removeFilter;
    _self.existsSortFunction    = existsSortFunction;
    _self.existsFilterFunction  = existsFilterFunction;
    _self.indexOf               = indexOf;
    _self.originalIndexOf       = originalIndexOf;
    _self.getListVersion       = getListVersion;
    _self.getSortFunction       = getSortFunction;
    _self.getItemsPaged         = getItemsPaged;
    _self.markToReset           = markToReset;


    refresh();

    function indexOf(item){
        return _innerList.indexOf(item);
    }

    function originalIndexOf(item){
        return _originalList.indexOf(item);
    }

    function length() {
        return _innerList.length;
    }

    function filterFnDereg(f) {
        if (_filterFunctions.length > 0) {
            var index = _filterFunctions.indexOf(f);

            if (index > -1) {
                return _filterFunctions.splice(index, 1)[0];
            }
        }
    }

    function setFilterFunction(f) {
        _filterFunctions = [];

        if (typeof f === 'function') {
            return addFilterFunction(f);
        }

        return function(){
            filterFnDereg(f);
        };
    }

    function addFilterFunction(f) {
        _filterFunctions.push(f);

        return function() {
            filterFnDereg(f);
        }
    }

    function setSortFunction(f) {
        _sortFunction = f;
    }

    function getSortFunction() {
        return _sortFunction;
    }

    function refresh(preventSort,preventFilter, forceCopy) {
        if(!_filterFunctions || _filterFunctions.length == 0){
            _qtdFilteredItems = 0;
        }

        if(!preventFilter && _filterFunctions && _filterFunctions.length > 0) {
            var temp;

            _filterFunctions.forEach(function(filterFn) {
                temp = (temp || _originalList).filter(filterFn);
            });

            _qtdFilteredItems = (_originalList.length - temp.length);

            copyList(temp, _innerList);
        } else {
            if(forceCopy){
                copyList(_originalList, _innerList);
            }else{
                mergeList(_originalList, _innerList);
            }

        }

        if(_sortFunction && !preventSort) {
            _innerList.sort(_sortFunction)
        }

        updateListVersion();
    }


    function copyList(sourceList,destinationList) {
        if(!sourceList || !destinationList) {
            return;
        }

        destinationList.length = 0;
        for(var i = 0; i < sourceList.length; i++) {
            destinationList[i] = sourceList[i];
        }
    }
    
    function mergeList(origList, destList) {
        if(!origList || !destList) {
            return;
        }

        if(origList.length > (destList.length + _qtdFilteredItems)){
            var count = destList.length;
            for(var  i = (destList.length + _qtdFilteredItems); i < origList.length; i++){
                destList[count] = origList[i];
                count++;
            }
        }

        for(var index in _resetRecordsByInnerIndex){
            destList[index] = _resetRecordsByInnerIndex[index];
        }
    }

    function addItem(item) {
        _originalList.push(item);
    }

    function updateListVersion() {
        if (_listVersion == Number.MAX_VALUE) {
            _listVersion = 0;
        } else {
            _listVersion++;
        }
        _resetRecordsByInnerIndex = {};
    }

    function getListVersion() {
        return _listVersion;
    }
    
    function addItemAt(item, index) {
    	_originalList.splice(index, 0, item);
    }

    function getSource() {
        return _innerList;
    }

    function setOriginalRecords(array) {
        _originalList = array || [];
    }

    function getOriginalRecords() {
        return _originalList;
    }

    function clear() {
        _originalList.length    = 0;
        _innerList.length       = 0;
    }

    function getItem(index) {
        return _innerList[index];
    }

    function getItems() {
        return _innerList;
    }

    function setItem(item,index) {
        if(index > -1) {
            _originalList[index] = item;
        }
		else {
            addItem(item);
        }
    }

    function removeItem(item) {
        removeReference(_originalList, item);
        removeReference(_innerList, item);
    }

    function removeReference (array, obj) {
        var index = array.indexOf(obj);
        return doRemoveItemAt(array, index);
    }
    
    function removeItemAt(index) {
    	var item = doRemoveItemAt(_originalList, index);
    	doRemoveItemAt(_innerList, index);

    	return item;
    }
    
    function doRemoveItemAt(array, index) {
    	return array.splice(index, 1)[0];
    }

    function removeSort() {
        if(_sortFunction) {
            _sortFunction = undefined;
        }
    }

    function removeFilter() {
        _filterFunctions = []
    }

    function existsSortFunction() {
        return _sortFunction != undefined;
    }

    function existsFilterFunction() {
        return _filterFunctions.length > 0;
    }

    function getItemsPaged(start, end){
        if(end > _innerList.length){
            end = _innerList.length
        }
        if(start < 0){
            start = 0;
        }
        return _innerList.slice(start, end);
    }

    function markToReset(newRecord, index){
        var indexInner = _innerList.indexOf(_originalList[index]);
        _resetRecordsByInnerIndex[indexInner] = newRecord;
        setItem(newRecord,index);
    }
}
function MGEAuthorizationData(isSup) {

    var _self = this;

    var _actions = {};
    var _isSup = isSup;

    _self.putAccess = putAccess;
    _self.hasAccess = hasAccess;
    _self.isUserSup = isUserSup;
    _self.hasAnyAccess = hasAnyAccess;

    function putAccess(action, flag) {
        _actions[action] = flag;
    }

    function hasAccess(action) {
        if (_isSup) {
            return true;
        }
        var value = true;

        if (_actions.hasOwnProperty(action)) {
            value = _actions[action];
        } 
        
        return value;
    }

    function isEmptyObject(obj){
        return JSON.stringify(obj) === '{}';
    }

    function hasAnyAccess(){
        if(_isSup){
            return true;
        }

        if (isEmptyObject(_actions)){
            return false;
        } else {
            return true;
        }
    }

    function isUserSup(){
        return _isSup;
    }
}
/**
 * @ngdoc object
 * @name util.common.object:Criteria
 * @description 
    Classe de criterios de pesquisa
 */
function Criteria(exp, params) {
    if(!(this instanceof arguments.callee)){
		return new Criteria(exp, params);
	}

    var self = this;
    var expression = undefined;
    var parameters = [];

    if (exp instanceof Criteria){
        append(exp);
    } else {
        expression = exp;

        if (params !== undefined) {
            addParameter(params);
        }
    }
    

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#getExpression
     * @methodOf util.common.object:Criteria
     * @description Método que retorna a expressão do critério.
     * @returns {string} Retorna a expressão do critério.
     */
    self.getExpression = function () {
        return expression;
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#getParameters
     * @methodOf util.common.object:Criteria
     * @description Método que retorna os parâmetros do critério.
     * @returns {array} Retorna os parâmetros do critério.
     */
    self.getParameters = function () {
        return parameters;
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#getSize
     * @methodOf util.common.object:Criteria
     * @description Método que retorna o tamanho da expressão.
     * @returns {int} tamanho da expressão do critério.
     */
    self.getSize = function () {
        return (expression === undefined ? 0 : expression.length);
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#replaceOnExpression
     * @methodOf util.common.object:Criteria
     * @description Realiza o replace de uma string por outra.
     * @param {regex} [search] Expressão a ser pesquisada
     * @param {string|function} [replace] Expressão a ser inserida.
     * @returns {Criteria} Retorna a própria instância do Criterio para encadeamento.
     */
    self.replaceOnExpression = function(search, replace){
        if (expression !== undefined && expression.length > 0) {
            expression = expression.replace(search, replace);
        }

        return self;
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#append
     * @methodOf util.common.object:Criteria
     * @description Concatena uma expressão e parâmetros ao critério.
     * @param {string} [exp=undefined] Expressão a ser concatenada
     * @param {array} [param=undefined] Parâmetros a serem concatenados.
     * @returns {Criteria} Retorna a própria instância do Criterio para encadeamento.
     */
    self.append = append;
    function append(exp, param) {

        if (exp instanceof Criteria){
            if (exp.getSize() > 0) {
                param = exp.getParameters();
                exp = '(' + exp.getExpression() + ')';
            } else {
                return self;
            }
        }

        if (expression === undefined) {
            expression = exp;
        } else {
            expression += exp;
        }

        if (angular.isDefined(param)) {
            addParameter(param);
        }

        return self;
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#addAllParameters
     * @methodOf util.common.object:Criteria
     * @description Concatena parâmetros ao critério.
     * @param {array} params Parâmetros a serem concatenados.
     * @returns {Criteria} Retorna a própria instância do Criterio para encadeamento.
     */
    self.addAllParameters = function (params) {
        return self.addParameter(params);
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#addParameter
     * @methodOf util.common.object:Criteria
     * @description Concatena parâmetros ao critério.
     *  - Se passado um array, o metodo iterará no array e adicionará cada um dos itens.
     *  - É possível passar um Objeto CriteriaParameter, um número, string ou uma instancia de data, eles serão inferidos para o tipo certo.
     * @param {CriteriaParameter} Parâmetro a ser adicionado.
     * @returns {Criteria} Retorna a própria instância do Criterio para encadeamento.
     */
    self.addParameter = addParameter;
    function addParameter(param) {
        if (Array.isArray(param)) {
            for (paramIndex in param) {
                addParameter(param[paramIndex]);
            }
        } else if (param instanceof CriteriaParameter) {
            parameters.push(param);
        } else if (typeof param === 'number') {
            parameters.push(new CriteriaParameter(CriteriaParameter.TYPE_NUMBER, param));
        } else if (typeof param === 'string') {
            parameters.push(new CriteriaParameter(CriteriaParameter.TYPE_STRING, param));
        } else if (toString.call(param) === '[object Date]') {
            parameters.push(new CriteriaParameter(CriteriaParameter.TYPE_DATE, param));
        } else {
            throw new Error('Erro ao criar critério, parâmetro inválido.' + param);
        }

        return self;
    };

    
    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#or
     * @methodOf util.common.object:Criteria
     * @description Concatena a expressão ' OR ' ao critério.
     * @param {string} [exp=undefined] Expressão a ser concatenada
     * @param {array} [param=undefined] Parâmetros a serem concatenados.
     * @returns {Criteria} Retorna a própria instância do Criterio para encadeamento.
     */
    self.or = function (exp, params) {
        if (self.getSize() > 0){
            self.append(' OR ');
        }

        if (exp || params){
            self.append(exp, params);
        }

        return self;
    };

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#and
     * @methodOf util.common.object:Criteria
     * @description Concatena a expressão ' AND ' ao critério.
     * @param {string} [exp=undefined] Expressão a ser concatenada
     * @param {array} [param=undefined] Parâmetros a serem concatenados.
     * @returns {Criteria} Retorna a própria instância do Criterio para encadeamento.
     */
    self.and = function (exp, params) {
        if (self.getSize() > 0){
            self.append(' AND ');
        }

        if (exp || params){
            self.append(exp, params);
        }

        return self;
    }

    /**
     * @ngdoc
     * @name util.common.object:CriteriaProvider#toJSON
     * @methodOf util.common.object:Criteria
     * @description Retorna um JSON que representa o objeto Criteria.
     * @returns {Object} Retorna um JSON que representa o objeto Criteria.
     */
    self.toJSON = function () {
        if (self.getSize() > 0){
            return {
                expression: self.getExpression(),
                parameters: self.getParameters().map(function (param) {
                    return param.buildParam();
                })
            }
        } else {
            return undefined;
        }
    }

}
CriteriaError.prototype = new Error();

CriteriaError.CRITERIA_NOT_READY = "criteriaNotReady";
CriteriaError.ILLEGAL_CRITERIA_VALUE = "illegalCriteriaValue";

function CriteriaError(type, message, ignored) {
    this.name = 'CriteriaError';
    this.message = message;
    this.ignored = ignored === true;
    this.stack = (new Error()).stack;

    this.ignore = function () {
        return ignored;
    }
}
CriteriaParameter.TYPE_STRING = "S";
CriteriaParameter.TYPE_DATE = "D";
CriteriaParameter.TYPE_NUMBER = "N";

function CriteriaParameter(type, value) {
    var self = this;

    self.type = type;
    self.value = value;

    this.buildParam = function (valueAsContent) {
        var param = {
            type: self.type
        };

        if (valueAsContent){
            param.$ = self.value;
        } else {
            param.value = self.value;
        }

        return param;
    }
}

VariableCriteriaParameter.prototype = new CriteriaParameter();

function VariableCriteriaParameter(type, name, label, groupName, lastValue, properties) {
    CriteriaParameter.call(this, type, '');

    var self = this;

    self.name = name;
    self.label = label;
    self.groupName = groupName;
    self.lastValue = lastValue;
    self.properties = properties;

    this.buildParam = function (valueAsContent) {

        var param = {
            type: self.type,
            name: self.name,
            label: self.label,
            groupName: self.groupName,
            properties: self.properties
        };

        if (valueAsContent){
            param.$ = self.value;
        } else {
            param.value = self.value;
        }

        return param;
    }
}
/**
 * @ngdoc interface
 * @name util.common.interface:CriteriaProvider
 * @description Classe utilizada para passar prover informações de critério de pesquisa
 */
function CriteriaProvider(criteria) {
    this.criteria = criteria;
}

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#build
 * @methodOf util.common.interface:CriteriaProvider
 * @description Função responsável por criar um provider passando a implementação de get do critério.
 * @returns {CriteriaProvider} Retorna o criterio.
 */
CriteriaProvider.build = function(getCriteria) {
    var criteriaProvider = new CriteriaProvider();

    criteriaProvider.getCriteria = getCriteria;

    return criteriaProvider;
};

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#getCriteria
 * @methodOf util.common.interface:CriteriaProvider
 * @description Função responsável por devolver um objeto {@link util.common.object:Criteria} com o criterio.
 * @returns {Criteria|Promise} Retorna o criterio.
 */
CriteriaProvider.prototype.getCriteria = function () {
    return this.criteria;
};

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#onCriteriaReady
 * @methodOf util.common.interface:CriteriaProvider
 * @description Função que retorna uma promise, onde sua resolução acontece quando o critério é carregado.
 * @returns {promise} Retorna o criterio.
 */
CriteriaProvider.prototype.onCriteriaReady = function () {
    return undefined;
};


/**
 * @ngdoc interface
 * @name util.common.interface:DataSource
 * @description Classe utilizada para implementar métodos bases para utilização do respectivo datasource em seus componentes.
 */
function DataSource() {

}

/**
 * @ngdoc
 * @name util.common.interface:DataSource#addCriteriaProvider
 * @methodOf util.common.interface:DataSource
 * @description Função responsável por adicionar um objeto de {@link util.common.object:Criteria}.
 * @param {CriteriaProvider} criteriaProvider provider a ser utilizado para adição.
 */
DataSource.prototype.addCriteriaProvider = function (criteriaProvider) {

};

/**
 * @ngdoc
 * @name util.common.interface:DataSource#removeCriteriaProvider
 * @methodOf util.common.interface:DataSource
 * @description Função responsável por remover um objeto de {@link util.common.object:Criteria}.
 * @param {CriteriaProvider} criteriaProvider provider a ser removido para adição.
 */
DataSource.prototype.removeCriteriaProvider = function (criteriaProvider) {

};

/**
 * @ngdoc
 * @name util.common.interface:DataSource#saveCriteria
 * @methodOf util.common.interface:DataSource
 * @description Função responsável salvar um critério
 * @param {string} id Id do critério a ser salvo.
 * @param {Criteria} criteria Critério a ser salvo.
 * @param {Object} criteriaParsed Critério a ser salvo.
 */
DataSource.prototype.saveCriteria = function (id, criteria, criteriaParsed) {
};

/**
 * @ngdoc
 * @name util.common.interface:DataSource#refresh
 * @methodOf util.common.interface:DataSource
 * @description Função utilizada para recarregamento de informações.
 */
DataSource.prototype.refresh = function () {};
function EventBus() {
    var self = this;

    var $registeredEventsByName = {};

    var dispatching = false;

    var pendingRemoves = [];

    self.addEventListener = function (eventName, eventCallBack) {
        var events = $registeredEventsByName[eventName];

        if (!events) {
            events = [];
            $registeredEventsByName[eventName] = events;
        }

        events.push({
            callBack: eventCallBack
        });

        return function(){

            var doRemove = function(){
                self.removeEventListener(eventName, eventCallBack);
            };

            if (dispatching){
                pendingRemoves.push(doRemove);
            } else {
                doRemove();
            }
        }
    };

    self.removeEventListener = function (eventName, callBack) {
        if (callBack){
            var events = $registeredEventsByName[eventName];

            if (events){
                for (var i = 0; i < events.length; i++){
                    var f = events[i].callBack;

                    if (f == callBack){
                        events.splice(i, 1);
                    }

                    break;
                }
            }
        } else {
            delete $registeredEventsByName[eventName];
        }
    };

    self.dispatchEvent = function (eventName, params, workAsStack) {
        var events = $registeredEventsByName[eventName];

        if (events && events.length > 0) {
            var numEvents = events.length;

            try {
                dispatching = true;

                var event = {
                    name: eventName,
                    preventDefault: function() {
                        event.defaultPrevented = true;
                    },
                    defaultPrevented: false
                };

                var reverse = function(originalList) {
                    var newList = [];
                    for(var i = originalList.length - 1; i >= 0; i--) {
                        newList.push(originalList[i]);
                    }
                    return newList;
                }

                if(workAsStack) {
                    //events = reverse(events);
                }

                for (var i = 0; i < numEvents; i++) {
                    if(event.defaultPrevented) {
                        break;
                    }
                    var eventData = events[i];
                    var eventCallBack = eventData.callBack;

                    eventCallBack(params,event);
                }

            } finally {
                dispatching = false;
            }

            if (pendingRemoves.length) {
                var f;

                while (f = pendingRemoves.pop()){
                    f();
                }
            }
        }
    }
}
/**
 * @ngdoc interface
 * @name util.common.interface:IDataSetObserver
 * @description Classe utilizada para receber notificações lançadas pelo dataset
 */
function IDataSetObserver() {}

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#dataSaved
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada sempre que o dataset salvar um registro.
 * @param {boolean} isNew Determina se a ação foi de update ou insert do registro.
 * @param {array} records Registros que foram salvos.
 */
IDataSetObserver.prototype.dataSaved = function (isNew, records) {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#insertionModeActivated
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada sempre que o dataset entrar em modo de inserção.
 */
IDataSetObserver.prototype.insertionModeActivated = function () {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#currentLineChanged
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando o dataset se posiciona em uma nova linha dos registros.
 * @param {int} newIndex Novo index.
 */
IDataSetObserver.prototype.currentLineChanged = function (newIndex) {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#refreshed
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando os registros do datset forem recarregados.
 */
IDataSetObserver.prototype.refreshed = function () {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#closed
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando o dataset for fechado.
 */
IDataSetObserver.prototype.closed = function () {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#recordRemoved
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando o dataset remover um registro.
 * @param {array} record Registro que foi removido.
 */
IDataSetObserver.prototype.recordRemoved = function (record) {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#dataModified
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando algum campo for modificado no dataset.
 * @param {string} fieldName Nome do campo modificado.
 */
IDataSetObserver.prototype.dataModified = function (fieldName) {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#editionCanceled
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando a edição de um registro no dataset for cancelada.
 */
IDataSetObserver.prototype.editionCanceled = function () {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#selectionChanged
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando a seleção do dataset é alterada.
 */
IDataSetObserver.prototype.selectionChanged = function () {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#editionModeActivated
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando o modo de edição é ativado no dataset.
 */
IDataSetObserver.prototype.editionModeActivated = function () {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#saveAvoided
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada quando o salvamento de um registro é abortado.
 */
IDataSetObserver.prototype.saveAvoided = function (nullFieldNames) {

};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#allEvents
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada em qualquer evento desta interface
 */
IDataSetObserver.prototype.allEvents = function (event, parameters) {
};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#uploading
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada para notificar o status do upload de um arquivo
 */
IDataSetObserver.prototype.uploadingFile = function (uploading) {
};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#cleared
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada para notificar que o data set foi limpo
 */
IDataSetObserver.prototype.cleared = function () {
};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#cleared
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada para notificar que a(s) linha(s) selecionada(s) no dataset foi atualizada.
 */
IDataSetObserver.prototype.currentRecordRefreshed = function () {
};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#rowMetadataChanged
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada para notificar que o rowmetadata do dataset ou do registro foi alterado.
 * @param {string} reason Informa a fonte de alteração de dados, podendo ser PROVIDER_CHANGED ou ROW_CHANGED.
 * @param {boolean} providerChanged Informa se o provider foi alterado.
 */
IDataSetObserver.prototype.rowMetadataChanged = function (reason, providerChanged) {
};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#insertionCanceled
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada para notificar que a inserção no dataset foi cancelada.
 */
IDataSetObserver.prototype.insertionCanceled = function () {
};

/**
 * @ngdoc
 * @name util.common.interface:IDataSetObserver#reloadFields
 * @methodOf util.common.interface:IDataSetObserver
 * @description Função chamada para notificar que e necessaria uma recarga nos campos.
 */
IDataSetObserver.prototype.reloadFields = function () {
};

IDataSetObserver.prototype.onFinishEdition = function (fieldName, newValue, oldValue) {
};
/**
 * @ngdoc interface
 * @name util.common.interface:IPopUpStackObserver
 * @description Classe utilizada para receber notificações lançadas pelo service SanPopupStack
 */
function IPopUpStackObserver() {}

/**
 * @ngdoc
 * @name util.common.interface:IPopUpStackObserver#popUpClosed
 * @methodOf util.common.interface:IPopUpStackObserver
 * @description Função chamada sempre que um popUp é fechado.
 * @param {object} popUpInstance Instancia do popUp que está sendo fechado.
 */
IPopUpStackObserver.prototype.popUpClosed = function (popUpInstance) {

};

/**
 * @ngdoc
 * @name util.common.interface:IPopUpStackObserver#popUpClosed
 * @methodOf util.common.interface:IPopUpStackObserver
 * @description Função chamada sempre que um popUp é aberto.
 * @param {object} popUpInstance Instancia do popUp que está sendo aberto.
 */
IPopUpStackObserver.prototype.popUpOpened = function (popUpInstance) {

};

"use strict";
//https://vladeck.wordpress.com/tag/javascript/
var Fishbone;
(function (Fishbone) {
    "use strict";
    let ERegion;
    
    (function (ERegion) {
        ERegion[ERegion["Top"] = 0] = "Top";
        ERegion[ERegion["Bottom"] = 1] = "Bottom";
    })(ERegion || (ERegion = {}));
    
    class Plotter {
        constructor(config) {
            this._config = {
                canvas: config.canvas,
                headColor: config.headColor ? config.headColor : "#000000",
                headTextColor: config.headTextColor ? config.headTextColor : "#000000",
                horizontalColor: config.horizontalColor ? config.horizontalColor : "#000000",
                horizontalTextColor: config.horizontalTextColor ? config.horizontalTextColor : "#000000",
                verticalColor: config.verticalColor ? config.verticalColor : "#000000",
                verticalTextColor: config.verticalTextColor ? config.verticalTextColor : "#000000",
                xUnitSize: config.xUnitSize ? config.xUnitSize : 100,
                yUnitSize: config.yUnitSize ? config.yUnitSize : 100,
                id: config.id || 1,
                onBtnNodeClick: config.onBtnNodeClick,
                onLblNodeClick: config.onLblNodeClick,
                onLblHover: config.onLblHover,
                onLblOut: config.onLblOut,
            };

            this.svgEl = document.getElementById(this._config.id);

            //Se não está sendo apresentado na tela.
            if(!this.svgEl) return;

            this.svgEl.ondragstart = () =>  false;
        }        
        drawBtn(x, y, node){

            var block = this._config.canvas.rect(x, y, 20, 20, 50, 50);

            block.attr({
                fill: "rgb(236, 240, 241)",
                stroke: "#1f2c39",
                strokeWidth: 1
            });

            let hasExpand = node.showBtnExpand == true;

            let newX = hasExpand ? x + 2 : x + 5;
            let newY = hasExpand ? y + 20 : y + 17;

            var text = this._config.canvas.text(newX, newY, hasExpand ? "+" : '-');

            text.attr({
                'font-size': 30
            });

            // group then as a single svg DOM element
            var btn1 = this._config.canvas.g(block, text);

            btn1.attr({ opacity: ( hasExpand ? 1 : 0), id: 'btn-node-' + node.uid, cursor: 'pointer' });

            btn1.click( ( ev  ) => {
                if(this._config.onBtnNodeClick){
                    this._config.onBtnNodeClick(ev, node);
                }            
            });

            let btnEl = this.svgEl.getElementById('btn-node-' + node.uid);

            if(!hasExpand){
                btnEl.addEventListener('mouseover', function(evt){
                    btn1.attr({ opacity: 1 });
                });

                btnEl.addEventListener('mouseleave', function(evt){
                    btn1.attr({ opacity: 0 });
                });
            }

            return btn1;
        }
        draw(diagram, isRedraw) {
            //Se não está na tela
            if(!this.svgEl) return;

            this.isRedraw = isRedraw;
            const jCanvas = $(this._config.canvas.node);
            const canvasWidth = jCanvas.width();
            const canvasHeight = jCanvas.height();
            let lowestX = canvasWidth;            
            //Clear svg
            $(this.svgEl).empty();

            if(!isRedraw) this.addToTop = 0;
            
            // Top
            let childBoneOrigin = {
                x: canvasWidth - this._config.xUnitSize,
                y: (this.oldHeigthMiddle + this.addToTop) || (canvasHeight / 2),
            };

            diagram.head.children.forEach((item, index) => {
                if (index % 2 !== 0) {
                    return;
                }
                const data = this.drawVBone(childBoneOrigin, item, ERegion.Top, 3);

                childBoneOrigin.x = data.nextOrigin.x;
                childBoneOrigin.y = data.nextOrigin.y;
                if (data.nextOrigin.x < lowestX) {
                    lowestX = data.nextOrigin.x;
                }
            });
            // Bottom
            childBoneOrigin = {
                x: canvasWidth - this._config.xUnitSize,
                y: (this.oldHeigthMiddle + this.addToTop) || (canvasHeight / 2),
            };
            diagram.head.children.forEach((item, index) => {
                if (index % 2 !== 1) {
                    return;
                }
                const data = this.drawVBone(childBoneOrigin, item, ERegion.Bottom, 3);

                childBoneOrigin.x = data.nextOrigin.x;
                childBoneOrigin.y = data.nextOrigin.y;
                if (data.nextOrigin.x < lowestX) {
                    lowestX = data.nextOrigin.x;
                }
            });
            // Head
            const start = {
                x: lowestX - this._config.xUnitSize,
                y: (this.oldHeigthMiddle + this.addToTop) || (canvasHeight / 2),
            };
            
            const end = {
                x: canvasWidth - this._config.xUnitSize,
                y: (this.oldHeigthMiddle + this.addToTop) || (canvasHeight / 2),
            };

            //Scroll x
            if(start.x < 0 && !isRedraw){
                angular.element(this.svgEl).innerWidth( angular.element(this.svgEl).innerWidth() + Math.abs(start.x) );
                this.redraw = true;
            }

            diagram.head.showBtn = false;
            diagram.head.hasRoot = true;
            diagram.head.uid = 0;
            diagram.head.nodeID = 0;

            this.drawArrow(start, end, this._config.headColor, 4, diagram.head);
            const text = this._config.canvas.text(end.x + 115, end.y, diagram.head.name);
            
            text.attr({ fill: this._config.headTextColor, id: 'txt-node-' + diagram.head.uid});
            const textWidth = text.getBBox().width;
            const textHeight = text.getBBox().height;
            text.transform(`t-${textWidth},${textHeight + 5}`);

            this.stupTxtBone(diagram.head);

            this.oldHeigthMiddle = canvasHeight / 2;
        }
        drawVBone(origin, bone, region, thickness = 1) {
            const size = this.getVBoneSize(bone);
            const x = origin.x - size.width * this._config.xUnitSize;
            const y = region === ERegion.Top
                ? origin.y - size.height * this._config.yUnitSize
                : origin.y + size.height * this._config.yUnitSize;
            const start = {
                x: origin.x - this._config.xUnitSize,
                y: y,
            };
            const end = {
                x: origin.x - this._config.xUnitSize,
                y: origin.y,
            };
            
            bone.region = region;
            bone.orientation = 'V';

            const arrow = this.drawArrow(start, end, this._config.verticalColor, thickness, bone);
            const text = this._config.canvas.text(start.x, start.y, bone.name);
            text.attr({ fill: this._config.verticalTextColor, /*fontSize: "12px",*/ id: 'txt-node-' + bone.uid});
            if (region === ERegion.Top) {
                text.transform(`t10,0,r90,${origin.x - this._config.xUnitSize},${y}`);
            }
            else {
                text.transform(`t15,0,r-90,${origin.x - this._config.xUnitSize},${y}`);
            }
            this.adjustText(text, arrow, bone);
            const childBoneOrigin = {
                x: origin.x - this._config.xUnitSize,
                y: origin.y,
            };
            const group = this._config.canvas.group();
            group.add(arrow);
            group.add(text);
            bone.children.forEach((item) => {
                const data = this.drawHBone(childBoneOrigin, item, region, thickness === 3 ? 2 : 1);
                childBoneOrigin.x = data.nextOrigin.x;
                childBoneOrigin.y = data.nextOrigin.y;
                group.add(data.group);
            });
            if (region === ERegion.Top) {
                group.transform(`r-15,${origin.x - this._config.xUnitSize},${origin.y}`);
            }
            else {
                group.transform(`r15,${origin.x - this._config.xUnitSize},${origin.y}`);
            }

            this.stupTxtBone(bone);
            
            return {
                group: group,
                nextOrigin: {
                    x: x,
                    y: origin.y,
                },
            };
        }
        drawHBone(origin, bone, region, thickness = 1) {
            const size = this.getHBoneSize(bone);

            const x = origin.x - size.width * this._config.xUnitSize;            
            const y = region === ERegion.Top ? (origin.y - size.height * this._config.yUnitSize) : (origin.y + size.height * this._config.yUnitSize);
            
            const start = {
                x: x,
                y: region === ERegion.Top
                    ? y + (size.height - 1) * this._config.yUnitSize
                    : y - (size.height - 1) * this._config.yUnitSize,
            };
            
            const end = {
                x: x + size.width * this._config.xUnitSize,
                y: region === ERegion.Top
                    ? y + (size.height - 1) * this._config.yUnitSize
                    : y - (size.height - 1) * this._config.yUnitSize,
            };
            
            bone.region = region;
            bone.orientation = 'H';
            
            const arrow = this.drawArrow(start, end, this._config.horizontalColor, thickness, bone);
            const text = this._config.canvas.text(start.x, start.y, bone.name);
            text.attr({ fill: this._config.horizontalTextColor, /*fontSize: "12px",*/ id: 'txt-node-' + bone.uid });
            const textHeight = text.getBBox().height;
            if (region === ERegion.Top) {
                text.transform(`t0,${textHeight + 2}`);
            }
            else {
                text.transform(`t0,-${textHeight}`);
            }
            this.adjustText(text, arrow, bone);
            const childBoneOrigin = {
                x: origin.x,
                y: region === ERegion.Top
                    ? origin.y - this._config.yUnitSize
                    : origin.y + this._config.yUnitSize,
            };
            const group = this._config.canvas.group();
            group.add(arrow);
            group.add(text);
            bone.children.forEach((item) => {
                const data = this.drawVBone(childBoneOrigin, item, region, thickness === 3 ? 2 : 1);
                childBoneOrigin.x = data.nextOrigin.x;
                childBoneOrigin.y = data.nextOrigin.y;
                group.add(data.group);
            });
            if (region === ERegion.Top) {
                group.transform(`r15,${x + size.width * this._config.xUnitSize},${y + (size.height - 1) * this._config.yUnitSize}`);
            }
            else {
                group.transform(`r-15,${x + size.width * this._config.xUnitSize},${y - (size.height - 1) * this._config.yUnitSize}`);
            }

            this.stupTxtBone(bone);

            return {
                group: group,
                nextOrigin: {
                    x: origin.x,
                    y: y,
                },
            };
        }
        stupTxtBone(bone){
            let txtEl = this.svgEl.getElementById('txt-node-' + bone.uid);
            
            if(txtEl){
                txtEl.style.cursor = 'pointer';
                
                txtEl.addEventListener('click', (ev) => {
                    if(this._config.onLblNodeClick){
                        this._config.onLblNodeClick(ev, bone);
                    }
                });

                txtEl.addEventListener('mouseover', (ev) => {
                    if(this._config.onLblHover){
                        this._config.onLblHover(ev, bone);
                    }
                });

                txtEl.addEventListener('mouseout', (ev) => {
                    if(this._config.onLblOut){
                        this._config.onLblOut(ev, bone);
                    }
                });

                const txtToolTip = this._config.canvas.text(txtEl.getAttribute('x'), txtEl.getAttribute('y'), '-');
                txtToolTip.node.style.opacity = 0;
                txtToolTip.node.setAttribute('id', 'tooltip-node-' + bone.uid);
                txtEl.parentElement.appendChild(txtToolTip.node);
            }
        }
        getVBoneSize(bone) {
            const size = {
                height: 1,
                width: 1,
            };
            // Minimum size if this bone has children of its own.
            if (bone.children.length > 0) {
                size.height = bone.children.length;
                size.width = 2;
            }
            bone.children.forEach((item) => {
                const childSize = this.getHBoneSize(item);
                if (childSize.width > size.width - 1) {
                    size.width += childSize.width - 1;
                }
                if (childSize.height > 1) {
                    size.height += childSize.height - 1;
                }
            });
            return size;
        }
        getHBoneSize(bone) {
            const size = {
                height: 1,
                width: 1,
            };
            // Minimum size if this bone has children of its own.
            if (bone.children.length > 0) {
                size.height = 2;
                size.width = bone.children.length;
            }
            bone.children.forEach((item) => {
                const childSize = this.getVBoneSize(item);
                if (childSize.width > 1) {
                    size.width += childSize.width - 1;
                }
                if (childSize.height > size.height) {
                    size.height += childSize.height - 1;
                }
            });
            return size;
        }
        drawArrow(start, end, color, thickness = 1, node) {
            const line = this._config.canvas.line(start.x, start.y, end.x, end.y);
            let innerH = angular.element(this.svgEl).innerHeight();
            
            //Scroll Y
            if(node.orientation == 'V'){
                if(start.y < 0 && node.region == ERegion.Top && !this.isRedraw){
                    this.addToTop = Math.max(this.addToTop, Math.abs(start.y));
                    angular.element(this.svgEl).innerHeight( innerH + (Math.abs(start.y) / 2));
                    this.redraw = true;
                }else if(innerH < start.y){
                    angular.element(this.svgEl).innerHeight( (innerH + this.addToTop) + ((Math.abs(start.y) - innerH)));
                    this.redraw = true;
                }
            }

            let btn;
            
            if( (node.showBtnCollapse == true || node.showBtnExpand == true) && !node.hasRoot) {
                let btnX, btnY;

                if(node.region == ERegion.Top){
                    if(node.orientation == 'H'){
                        btnX = end.x - 27;
                        btnY = end.y - 27;
                    }else{
                        btnX = end.x - 26;
                        btnY = end.y +- 28;
                    }

                }else{

                    if(node.orientation == 'H'){
                        btnX = end.x - 27;
                        btnY = end.y - 27;
                    }else{
                        btnX = end.x - 25;
                        btnY = end.y + 15;
                    }

                    
                }

                btn = this.drawBtn(btnX, btnY, node);
            }

            line.attr({ stroke: color, strokeWidth: thickness });
            let triangle;
            const arrowLength = 10 + thickness;
            const arrowSide = 5 + thickness;
            if (start.x < end.x) { // Right arrow
                triangle = this._config.canvas.polygon([
                    end.x - arrowLength,
                    end.y - arrowSide,
                    end.x + thickness,
                    end.y,
                    end.x - arrowLength,
                    end.y + arrowSide,
                ]);
            }
            else if (start.x > end.x) { // Left arrow
                triangle = this._config.canvas.polygon([
                    end.x - arrowSide,
                    end.y + arrowLength,
                    end.x,
                    end.y,
                    end.x + arrowSide,
                    end.y + arrowLength,
                ]);
            }
            else if (start.y < end.y) { // Down arrow
                triangle = this._config.canvas.polygon([
                    end.x - arrowSide,
                    end.y - arrowLength,
                    end.x,
                    end.y,
                    end.x + arrowSide,
                    end.y - arrowLength,
                ]);
            }
            else { // Up arrow
                triangle = this._config.canvas.polygon([
                    end.x - arrowSide,
                    end.y + arrowLength,
                    end.x,
                    end.y,
                    end.x + arrowSide,
                    end.y + arrowLength,
                ]);
            }
            triangle.attr({ fill: color });

            if(btn){                
                return this._config.canvas.group(line, triangle, btn);
            }else{
                return this._config.canvas.group(line, triangle);
            }            
        }
        adjustText(txt, arrow, bone){
            let hasClip = false;
            let prop = 'height';

            if(bone.orientation == 'H') prop = 'width';
            hasClip = txt.getBBox()[prop] > arrow.getBBox()[prop];

            if(hasClip){
                while(txt.getBBox()[prop] > arrow.getBBox()[prop]){
                    txt.node.innerHTML = txt.node.innerHTML.substr(0, txt.node.innerHTML.length - 1);
                }

                txt.node.innerHTML = (txt.node.innerHTML.substr(0, txt.node.innerHTML.length - 3) + '...')
            }
            bone.hasClip = hasClip;
        }
    }
    Fishbone.Plotter = Plotter;
})(Fishbone || (Fishbone = {}));

/**
 * Created by bruno.brandao on 08/12/2015.
 */
/* ========================================================================
 * Bootstrap: tooltip.js v3.3.6
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // TOOLTIP PUBLIC CLASS DEFINITION
    // ===============================

    var Tooltip = function (element, options) {
        this.type       = null
        this.options    = null
        this.enabled    = null
        this.timeout    = null
        this.hoverState = null
        this.$element   = null
        this.inState    = null

        this.init('tooltip', element, options)
    }

    Tooltip.VERSION  = '3.3.6'

    Tooltip.TRANSITION_DURATION = 150

    Tooltip.DEFAULTS = {
        animation: true,
        placement: 'top',
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: false,
        container: false,
        viewport: {
            selector: 'body',
            padding: 0
        }
    }

    Tooltip.prototype.init = function (type, element, options) {
        this.enabled   = true
        this.type      = type
        this.$element  = $(element)
        this.options   = this.getOptions(options)
        this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
        this.inState   = { click: false, hover: false, focus: false }

        if (this.$element[0] instanceof document.constructor && !this.options.selector) {
            throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
        }

        var triggers = this.options.trigger.split(' ')

        for (var i = triggers.length; i--;) {
            var trigger = triggers[i]

            if (trigger == 'click') {
                this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
            } else if (trigger != 'manual') {
                var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
                var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

                this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
                this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
            }
        }

        this.options.selector ?
            (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
            this.fixTitle()
    }

    Tooltip.prototype.getDefaults = function () {
        return Tooltip.DEFAULTS
    }

    Tooltip.prototype.getOptions = function (options) {
        options = $.extend({}, this.getDefaults(), this.$element.data(), options)

        if (options.delay && typeof options.delay == 'number') {
            options.delay = {
                show: options.delay,
                hide: options.delay
            }
        }

        return options
    }

    Tooltip.prototype.getDelegateOptions = function () {
        var options  = {}
        var defaults = this.getDefaults()

        this._options && $.each(this._options, function (key, value) {
            if (defaults[key] != value) options[key] = value
        })

        return options
    }

    Tooltip.prototype.enter = function (obj) {
        var self = obj instanceof this.constructor ?
            obj : $(obj.currentTarget).data('bs.' + this.type)

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
        }

        if (self.tip().hasClass('in') || self.hoverState == 'in') {
            self.hoverState = 'in'
            return
        }

        clearTimeout(self.timeout)

        self.hoverState = 'in'

        if (!self.options.delay || !self.options.delay.show) return self.show()

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'in') self.show()
        }, self.options.delay.show)
    }

    Tooltip.prototype.isInStateTrue = function () {
        for (var key in this.inState) {
            if (this.inState[key]) return true
        }

        return false
    }

    Tooltip.prototype.leave = function (obj) {
        var self = obj instanceof this.constructor ?
            obj : $(obj.currentTarget).data('bs.' + this.type)

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
        }

        if (self.isInStateTrue()) return

        clearTimeout(self.timeout)

        self.hoverState = 'out'

        if (!self.options.delay || !self.options.delay.hide) return self.hide()

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'out') self.hide()
        }, self.options.delay.hide)
    }

    Tooltip.prototype.show = function () {
        var e = $.Event('show.bs.' + this.type)

        if (this.hasContent() && this.enabled) {
            this.$element.trigger(e)

            var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
            if (e.isDefaultPrevented() || !inDom) return
            var that = this

            var $tip = this.tip()

            var tipId = this.getUID(this.type)

            this.setContent()
            $tip.attr('id', tipId)
            this.$element.attr('aria-describedby', tipId)

            if (this.options.animation) $tip.addClass('fade')

            var placement = typeof this.options.placement == 'function' ?
                this.options.placement.call(this, $tip[0], this.$element[0]) :
                this.options.placement

            var autoToken = /\s?auto?\s?/i
            var autoPlace = autoToken.test(placement)
            if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

            $tip
                .detach()
                .css({ top: 0, left: 0, display: 'block' })
                .addClass(placement)
                .data('bs.' + this.type, this);

            // Evita que o tour do Ag-Grid seja sobreposto quando o dashboard é maximizado
            if ((window.location.pathname).indexOf('Dashboard.html5')) {
                $tip.css({'z-index': '1000005'});
            }

            this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
            this.$element.trigger('inserted.bs.' + this.type)

            var pos          = this.getPosition()
            var actualWidth  = $tip[0].offsetWidth
            var actualHeight = $tip[0].offsetHeight

            if (autoPlace) {
                var orgPlacement = placement
                var viewportDim = this.getPosition(this.$viewport)

                placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                        placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                            placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                                placement

                $tip
                    .removeClass(orgPlacement)
                    .addClass(placement)
            }

            var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

            this.applyPlacement(calculatedOffset, placement)

            var complete = function () {
                var prevHoverState = that.hoverState
                that.$element.trigger('shown.bs.' + that.type)
                that.hoverState = null

                if (prevHoverState == 'out') that.leave(that)
            }

            $.support.transition && this.$tip.hasClass('fade') ?
                $tip
                    .one('bsTransitionEnd', complete)
                    .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
                complete()
        }
    }

    Tooltip.prototype.applyPlacement = function (offset, placement) {
        var $tip   = this.tip()
        var width  = $tip[0].offsetWidth
        var height = $tip[0].offsetHeight

        // manually read margins because getBoundingClientRect includes difference
        var marginTop = parseInt($tip.css('margin-top'), 10)
        var marginLeft = parseInt($tip.css('margin-left'), 10)

        // we must check for NaN for ie 8/9
        if (isNaN(marginTop))  marginTop  = 0
        if (isNaN(marginLeft)) marginLeft = 0

        offset.top  += marginTop
        offset.left += marginLeft

        // $.fn.offset doesn't round pixel values
        // so we use setOffset directly with our own function B-0
        $.offset.setOffset($tip[0], $.extend({
            using: function (props) {
                $tip.css({
                    top: Math.round(props.top),
                    left: Math.round(props.left)
                })
            }
        }, offset), 0)

        $tip.addClass('in')

        // check to see if placing tip in new offset caused the tip to resize itself
        var actualWidth  = $tip[0].offsetWidth
        var actualHeight = $tip[0].offsetHeight

        if (placement == 'top' && actualHeight != height) {
            offset.top = offset.top + height - actualHeight
        }

        var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

        if (delta.left) offset.left += delta.left
        else offset.top += delta.top

        var isVertical          = /top|bottom/.test(placement)
        var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
        var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

        $tip.offset(offset)
        this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
    }

    Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
        this.arrow()
            .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
            .css(isVertical ? 'top' : 'left', '')
    }

    Tooltip.prototype.setContent = function () {
        var $tip  = this.tip()
        var title = this.getTitle()

        $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
        $tip.removeClass('fade in top bottom left right')
    }

    Tooltip.prototype.hide = function (callback) {
        var that = this
        var $tip = $(this.$tip)
        var e    = $.Event('hide.bs.' + this.type)

        function complete() {
            if (that.hoverState != 'in') $tip.detach()
            that.$element
                .removeAttr('aria-describedby')
                .trigger('hidden.bs.' + that.type)
            callback && callback()
        }

        this.$element.trigger(e)

        if (e.isDefaultPrevented()) return

        $tip.removeClass('in')

        $.support.transition && $tip.hasClass('fade') ?
            $tip
                .one('bsTransitionEnd', complete)
                .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
            complete()

        this.hoverState = null

        return this
    }

    Tooltip.prototype.fixTitle = function () {
        var $e = this.$element
        if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
            $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
        }
    }

    Tooltip.prototype.hasContent = function () {
        return this.getTitle()
    }

    Tooltip.prototype.getPosition = function ($element) {
        $element   = $element || this.$element

        var el     = $element[0]
        var isBody = el.tagName == 'BODY'

        var elRect    = el.getBoundingClientRect()
        if (elRect.width == null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
        }
        var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
        var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
        var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

        return $.extend({}, elRect, scroll, outerDims, elOffset)
    }

    Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
        return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
            placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
                placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
                    /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

    }

    Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
        var delta = { top: 0, left: 0 }
        if (!this.$viewport) return delta

        var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
        var viewportDimensions = this.getPosition(this.$viewport)

        if (/right|left/.test(placement)) {
            var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
            var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
            if (topEdgeOffset < viewportDimensions.top) { // top overflow
                delta.top = viewportDimensions.top - topEdgeOffset
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
                delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
            }
        } else {
            var leftEdgeOffset  = pos.left - viewportPadding
            var rightEdgeOffset = pos.left + viewportPadding + actualWidth
            if (leftEdgeOffset < viewportDimensions.left) { // left overflow
                delta.left = viewportDimensions.left - leftEdgeOffset
            } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
                delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
            }
        }

        return delta
    }

    Tooltip.prototype.getTitle = function () {
        var title
        var $e = this.$element
        var o  = this.options

        title = $e.attr('data-original-title')
            || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

        return title
    }

    Tooltip.prototype.getUID = function (prefix) {
        do prefix += ~~(Math.random() * 1000000)
        while (document.getElementById(prefix))
        return prefix
    }

    Tooltip.prototype.tip = function () {
        if (!this.$tip) {
            this.$tip = $(this.options.template)
            if (this.$tip.length != 1) {
                throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
            }
        }
        return this.$tip
    }

    Tooltip.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
    }

    Tooltip.prototype.enable = function () {
        this.enabled = true
    }

    Tooltip.prototype.disable = function () {
        this.enabled = false
    }

    Tooltip.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled
    }

    Tooltip.prototype.toggle = function (e) {
        var self = this
        if (e) {
            self = $(e.currentTarget).data('bs.' + this.type)
            if (!self) {
                self = new this.constructor(e.currentTarget, this.getDelegateOptions())
                $(e.currentTarget).data('bs.' + this.type, self)
            }
        }

        if (e) {
            self.inState.click = !self.inState.click
            if (self.isInStateTrue()) self.enter(self)
            else self.leave(self)
        } else {
            self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
        }
    }

    Tooltip.prototype.destroy = function () {
        var that = this
        clearTimeout(this.timeout)
        this.hide(function () {
            that.$element.off('.' + that.type).removeData('bs.' + that.type)
            if (that.$tip) {
                that.$tip.detach()
            }
            that.$tip = null
            that.$arrow = null
            that.$viewport = null
        })
    }


    // TOOLTIP PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.tooltip')
            var options = typeof option == 'object' && option

            if (!data && /destroy|hide/.test(option)) return
            if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.tooltip

    $.fn.tooltip             = Plugin
    $.fn.tooltip.Constructor = Tooltip


    // TOOLTIP NO CONFLICT
    // ===================

    $.fn.tooltip.noConflict = function () {
        $.fn.tooltip = old
        return this
    }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.6
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // POPOVER PUBLIC CLASS DEFINITION
    // ===============================

    var Popover = function (element, options) {
        this.init('popover', element, options)
    }

    if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

    Popover.VERSION  = '3.3.6'

    Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
        placement: 'right',
        trigger: 'click',
        content: '',
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    })


    // NOTE: POPOVER EXTENDS tooltip.js
    // ================================

    Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

    Popover.prototype.constructor = Popover

    Popover.prototype.getDefaults = function () {
        return Popover.DEFAULTS
    }

    Popover.prototype.setContent = function () {
        var $tip    = this.tip()
        var title   = this.getTitle()
        var content = this.getContent()

        $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
        $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
            this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
            ](content)

        $tip.removeClass('fade top bottom left right in')

        // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
        // this manually by checking the contents.
        if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
    }

    Popover.prototype.hasContent = function () {
        return this.getTitle() || this.getContent()
    }

    Popover.prototype.getContent = function () {
        var $e = this.$element
        var o  = this.options

        return $e.attr('data-content')
            || (typeof o.content == 'function' ?
                o.content.call($e[0]) :
                o.content)
    }

    Popover.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
    }


    // POPOVER PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('bs.popover')
            var options = typeof option == 'object' && option

            if (!data && /destroy|hide/.test(option)) return
            if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    var old = $.fn.popover

    $.fn.popover             = Plugin
    $.fn.popover.Constructor = Popover


    // POPOVER NO CONFLICT
    // ===================

    $.fn.popover.noConflict = function () {
        $.fn.popover = old
        return this
    }

}(jQuery);
angular
    .module('snk.core.application', []);
angular.module('snk.core.directives', []);
angular
    .module('snk.core.exceptionhandler', [])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('HttpExceptionHandler');
    }]);
/**
 * @ngdoc overview
 * @name snk.core.loadingbar
 *
 * @description
 Loadingbar � a barra superior apresentada no topo da p�gina durante as requsi��es do sistema.
 Ela funciona com base em interceptor das requisi��es, portanto qualquer requisi��o feita, via $http ou ServiceProxy,
 ela ser� notificada.
 */
angular
    .module('snk.core.loadingbar', [])
    .config(['$httpProvider', function ($httpProvider) {

        var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'SnkLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, SnkLoadingBar) {

            /**
             * The total number of requests made
             */
            var reqsTotal = 0;

            /**
             * The number of requests completed (either successfully or not)
             */
            var reqsCompleted = 0;

            /**
             * The amount of time spent fetching before showing the loading bar
             */
            var latencyThreshold = SnkLoadingBar.latencyThreshold;

            /**
             * $timeout handle for latencyThreshold
             */
            var startTimeout;


            /**
             * calls SnkLoadingBar.complete() which removes the
             * loading bar from the DOM.
             */
            function setComplete() {
                $timeout.cancel(startTimeout);
                SnkLoadingBar.complete();
                reqsCompleted = 0;
                reqsTotal = 0;
            }

            /**
             * Determine if the response has already been cached
             * @param  {Object}  config the config option from the request
             * @return {Boolean} retrns true if cached, otherwise false
             */
            function isCached(config) {
                var cache;
                var defaultCache = $cacheFactory.get('$http');
                var defaults = $httpProvider.defaults;

                // Choose the proper cache source. Borrowed from angular: $http service
                if ((config.cache || defaults.cache) && config.cache !== false &&
                    (config.method === 'GET' || config.method === 'JSONP')) {
                    cache = angular.isObject(config.cache) ? config.cache
                        : angular.isObject(defaults.cache) ? defaults.cache
                        : defaultCache;
                }

                var cached = cache !== undefined ?
                cache.get(config.url) !== undefined : false;

                if (config.cached !== undefined && cached !== config.cached) {
                    return config.cached;
                }
                config.cached = cached;
                return cached;
            }


            return {
                'request': function (config) {
                    // Check to make sure this request hasn't already been cached and that
                    // the requester didn't explicitly ask us to ignore this request:
                    if (!config.ignoreLoadingBar && !isCached(config)) {
                        $rootScope.$broadcast('SnkLoadingBar:loading', {url: config.url});
                        if (reqsTotal === 0) {
                            startTimeout = $timeout(function () {
                                SnkLoadingBar.start();
                            }, latencyThreshold, false);
                        }
                        reqsTotal++;
                        SnkLoadingBar.set(reqsCompleted / reqsTotal);
                    }
                    return config;
                },

                'response': function (response) {
                    if (!response || !response.config) {
                        $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
                        return response;
                    }

                    if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
                        reqsCompleted++;
                        $rootScope.$broadcast('SnkLoadingBar:loaded', {url: response.config.url, result: response});
                        if (reqsCompleted >= reqsTotal) {
                            setComplete();
                        } else {
                            SnkLoadingBar.set(reqsCompleted / reqsTotal);
                        }
                    }

                    return response;
                },

                'responseError': function (rejection) {
                    if (!rejection || !rejection.config) {
                        $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
                        return $q.reject(rejection);
                    }

                    if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
                        reqsCompleted++;
                        $rootScope.$broadcast('SnkLoadingBar:loaded', {url: rejection.config.url, result: rejection});
                        if (reqsCompleted >= reqsTotal) {
                            setComplete();
                        } else {
                            SnkLoadingBar.set(reqsCompleted / reqsTotal);
                        }
                    }
                    return $q.reject(rejection);
                }
            };
        }];

        $httpProvider.interceptors.push(interceptor);
    }]);
/**
 * @ngdoc overview
 * @name snk.metadataprovider
 *
 * @description
 Módulo de configuração do MetadataProvider
 */
angular
	.module('snk.core.metadataprovider', ['snk.core.util'])
    .config(function($logProvider){
        $logProvider.debugEnabled(false);
    });
/**
 * @ngdoc overview
 * @name snk.components.dataset
 *
 * @description
 M�dulo de configura��o para utiliza��o do Dataset
 */
angular
    .module('snk.core.parameters', []);
angular.module("snk.core.services.registry", []);
angular
    .module('snk.core.theme',[]);
/**
 * @ngdoc overview
 * @name snk.core.tour
 *
 * @description
    Módulo do Tour
 */
angular.module('snk.core.tour', []);
/**
 * @ngdoc overview
 * @name snk.core.util
 *
 * @description
 * Módulo de configuração para utilização dos utilitários do nosso framework.
 *
 */
angular
    .module('snk.core.util', ['snk.components.popup']);
angular
    .module('snk.core.workspace', []);

angular
    .module('snk.components.accordion',['snk.components.collapse'])
    .constant('accordionConfig', {
        closeOthers: true
    })
    .config([
        '$logProvider', 
        function ($logProvider) {
            $logProvider.debugEnabled(true);
        }
    ]);


angular
    .module('snk.components.accordion')
    .directive('skAccordionHeading', function() {
        return {
            restrict: 'EA',
            transclude: true,   // Grab the contents to be used as the heading
            template: '',       // In effect remove this element!
            replace: true,
            require: '^skAccordionGroup',
            link: function(scope, element, attr, accordionGroupCtrl, transclude) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]

                if (!(attr.hasOwnProperty('skRemoveHeader') && scope.$eval(attr.skRemoveHeader))) {
                    accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
                } else {
                   accordionGroupCtrl.removeHeader();
                }
            }
        };
    });
angular
    .module('snk.components.actionbutton', []);
/**
 * Created by Leonardo.Mendes on 10/04/2018.
 */
angular
    .module('snk.components.agendamentos', []);
/**
 * @ngdoc overview
 * @name snk.components.aggrid
 *
 * @description
    Módulo de configuração para utilização da diretiva aggrid.
 */

angular
    .module('snk.components.aggrid', ['agGrid']);
angular
    .module('snk.components.applet',[]);
angular
    .module('snk.components.attach',[]);
/**
 * @ngdoc overview
 * @name snk.components.banner
 *
 * @description
 *  Componente de banner customizado, que permite exibir dois tipos de banner:
 *  um para atualização de credenciamento de contas e outro para aquisição do serviço.
 */
angular
  .module('snk.components.banner', []);
/**
 * @ngdoc overview
 * @name snk.components.box
 *
 * @description
    Módulo de configuração para utilização das diretivas de box.
 */
angular
    .module('snk.components.box', []);
/**
 * @ngdoc overview
 * @name snk.components.breadcrumbs
 *
 * @description
 *  Módulo de configuração do breadcrumbs
 */
angular
    .module('snk.components.breadcrumbs', []);
/**
 * @ngdoc overview
 * @name snk.components.btnnovo
 *
 * @description
    Módulo de configuração para utilização da diretiva skBtnNovo.
 */
angular
    .module('snk.components.btnnovo', []);
/**
 * @ngdoc overview
 * @name snk.components.btnoldlayout
 *
 * @description
 *  Módulo de configuração do btnoldlayout
 */
angular
    .module('snk.components.btnoldlayout', []);
/**
 * @ngdoc overview
 * @name snk.components.btnotheroptions
 *
 * @description
 *  Módulo de configuração do btnotheroptions
 */
angular
    .module('snk.components.btnotheroptions', []);
/**
 * @ngdoc overview
 * @name snk.components.btnplace
 *
 * @description
    Módulo de configuração para utilização da diretiva skBtnPlace.
 */
angular
    .module('snk.components.btnplace', []);
/**
 * @ngdoc overview
 * @name snk.components.button
 *
 * @description
    Módulo de configuração para utilização da diretiva button.
 */
angular
    .module('snk.components.button', []);
/**
 *    Createad by Ádamo.Meirelles 15/07/2020
 */
angular
    .module('snk.components.calendar', ['snk.core.util', 'snk.i18n'])


angular
    .module('snk.components.carregando', []);
/**
 * @ngdoc overview
 * @name snk.components.changeorderbar
 *
 * @description
    Módulo de configuração para utilização da diretiva changeorderbar.
 */
angular
    .module('snk.components.changeorderbar', []);
angular
    .module('snk.components.chart', []);
/**
 * @ngdoc overview
 * @name snk.components.checkbox
 *
 * @description
 Módulo de configuração para utilização da diretiva skCheckbox.
 */
angular
    .module('snk.components.checkbox', []);
angular
    .module('snk.components.checkboxlist',[]);
angular
    .module('snk.components.collapse', []);
angular
    .module('snk.components.colorpicker',[]);
/**
 * Created Italo Araujo on 27/04/2022.
 */
angular
    .module('snk.components.compactpanel', []);
angular
    .module('snk.components.configurableform', []);

angular
    .module('snk.components.cronsyntaxselector', ['snk.core.util']);

angular
    .module('snk.components.cubebase',[]);
angular
    .module('snk.components.dashrenderer',[]);
/**
 * @ngdoc overview
 * @name snk.components.datagrid
 *
 * @description
 Módulo de configuração para utilização do Datagrid
 */
angular
    .module('snk.components.datagrid', ['ngTouch','ui.grid','ui.grid.edit','ui.grid.autoResize','ui.grid.selection','ui.grid.grouping','ui.grid.resizeColumns','ui.grid.pinning','ui.grid.pagination','ui.grid.moveColumns', 'ui.grid.cellNav','snk.i18n', 'agGrid'])
    .config(function($provide){

        $provide.decorator('uiGridGroupingService', function ($delegate,i18nService,gridUtil) {

            $delegate.groupingColumnBuilder = function (colDef, col, gridOptions) {

                if (colDef.enableGrouping === false){
                    return;
                }

                if ( typeof(col.grouping) === 'undefined' && typeof(colDef.grouping) !== 'undefined') {
                    col.grouping = angular.copy(colDef.grouping);
                } else if (typeof(col.grouping) === 'undefined'){
                    col.grouping = {};
                }

                if (typeof(col.grouping) !== 'undefined' && typeof(col.grouping.groupPriority) !== undefined && col.grouping.groupPriority >= 0){
                    col.suppressRemoveSort = true;
                }

                col.groupingSuppressAggregationText = colDef.groupingSuppressAggregationText === true;

                var groupColumn = {
                    name: 'ui.grid.grouping.group',
                    title: i18nService.get().grouping.group,
                    icon: 'ui-grid-icon-indent-right',
                    shown: function () {
                        /*
                        return (typeof(this.context.col.grouping) === 'undefined' ||
                            typeof(this.context.col.grouping.groupPriority) === 'undefined' ||
                            this.context.col.grouping.groupPriority < 0) &&
                            !this.grid.haveSomeGroupping;
                            */
                        return (typeof(this.context.col.grouping) === 'undefined' ||
                            typeof(this.context.col.grouping.groupPriority) === 'undefined' ||
                            this.context.col.grouping.groupPriority < 0);
                    },
                    action: function () {
                        if(this.grid.haveSomeGroupping !== true) {
                            this.grid.haveSomeGroupping = true;
                        }
                        $delegate.groupColumn( this.context.col.grid, this.context.col );
                    }
                };

                var ungroupColumn = {
                    name: 'ui.grid.grouping.ungroup',
                    title: i18nService.get().grouping.ungroup,
                    icon: 'ui-grid-icon-indent-left',
                    shown: function () {
                        return typeof(this.context.col.grouping) !== 'undefined' &&
                            typeof(this.context.col.grouping.groupPriority) !== 'undefined' &&
                            this.context.col.grouping.groupPriority >= 0;
                    },
                    action: function () {
                        this.grid.haveSomeGroupping = false;
                        $delegate.ungroupColumn( this.context.col.grid, this.context.col );
                    }
                };

                if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.group')) {
                    col.menuItems.push(groupColumn);
                }

                if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.ungroup')) {
                    col.menuItems.push(ungroupColumn);
                }
            }
            return $delegate;
        })
    })
    .run(function($templateCache) {
        $templateCache.put('ui-grid/selectionRowHeader',$templateCache.get('components/datagrid/templates/uigridselectionrowheader.tpl.html'));
        $templateCache.put('ui-grid/ui-grid-menu-button',$templateCache.get('components/datagrid/templates/uigridmenubutton.tpl.html'));

        $templateCache.put('ui-grid/ui-grid-header',$templateCache.get('components/datagrid/templates/uigridheader.tpl.html'));
        $templateCache.put('ui-grid/uiGridHeaderCell',$templateCache.get('components/datagrid/templates/uigridheadercell.tpl.html'));
        $templateCache.put('ui-grid/uiGridMenu',$templateCache.get('components/datagrid/templates/uigridmenu.tpl.html'));

        $templateCache.put('ui-grid/ui-grid-footer',$templateCache.get('components/datagrid/templates/uigridfooter.tpl.html'));
        $templateCache.put('ui-grid/ui-grid-grid-footer',$templateCache.get('components/datagrid/templates/uigridgridfooter.tpl.html'));
        $templateCache.put('ui-grid/uiGridFooterCell',$templateCache.get('components/datagrid/templates/uigridfootercell.tpl.html'));

        $templateCache.put('ui-grid/pagination',$templateCache.get('components/datagrid/templates/uigridpagination.tpl.html'));
    })
/**
 * @ngdoc overview
 * @name snk.components.dataimporter
 *
 * @description
 *  Módulo de configuração do DataImporter
 */
angular
    .module('snk.components.dataset.dataimporter', []);
/**
 * @ngdoc overview
 * @name snk.components.dataset
 *
 * @description
 Módulo de configuração para utilização do Dataset
 */
angular
    .module('snk.components.dataset', ['snk.core.metadataprovider', 'snk.core.util']);
/**
 * @ngdoc overview
 * @name snk.components.dateperiod
 *
 * @description
 Módulo de configuração para utilização do componente skDatePeriod.
 */
angular
    .module('snk.components.dateperiod', []);
/**
 * @ngdoc overview
 * @name snk.components.datepicker
 *
 * @description
 Módulo de configuração para utilização da diretiva skDatepicker.
 */
angular
    .module('snk.components.datepicker', []);
angular
    .module('snk.components.defaultfilter', []);
angular
    .module('snk.components.diagram', []);
/**
 * @ngdoc overview
 * @name snk.components.dividedbox
 *
 * @description
    Módulo de configuração para utilização das diretivas de box.
 */
angular
    .module('snk.components.dividedbox', []);
angular
    .module('snk.components.divider', []);
/**
 * @ngdoc overview
 * @name snk.components.doublefacepanel
 *
 * @description
 *  Módulo de configuração do DoubleFacePanel
 */
angular
    .module('snk.components.doublefacepanel', []);
/**
 * @ngdoc overview
 * @name snk.components.dragdrop
 *
 * @description
 Módulo de configuração para utilização da diretiva droppable e dragrable.
 */
angular
    .module('snk.components.dragdrop', []);
/**
 * @ngdoc overview
 * @name snk.components.draggable
 *
 * @description
 Módulo de configuração para utilização da diretiva skDraggable.
 */
angular
    .module('snk.components.draggable', []);
angular
    .module('snk.components.draggablelist',[]);
angular
    .module('snk.components.dropdown', []);
angular
    .module('snk.components.dropdownmenu', []);
/**
 * @ngdoc overview
 * @name snk.components.dynaform
 *
 * @description
 Módulo de configuração para utilização do Dynaform
 */
angular
    .module('snk.components.dynaform', [])
    .config(function($logProvider){
        $logProvider.debugEnabled(false);
    });
/**
 * @ngdoc overview
 * @name snk.components.dynamicfilterpanel
 *
 * @description
    Módulo do painel de filtros dinâmicos das telas, para ver a documentação {@link snk.components.dynamicfilterpanel.directive:sk-dynamic-filter-panel clique aqui}.
 */
angular
    .module('snk.components.dynamicfilterpanel', ['snk.core.util']);
angular
    .module('snk.components.entityattach', []);
/**
 * @ngdoc overview
 * @name snk.components.entitycard
 *
 * @description
    Módulo de configuração para utilização da diretiva entityCard.
 */
angular
    .module('snk.components.entitycard', []);
angular
    .module("snk.components.entitylist",[]);
/**
 * @ngdoc overview
 * @name snk.components.navigator
 *
 * @description
 *  Módulo de configuração do Navigator
 */
angular
    .module('snk.components.entitystartpage', []);
/**
 * Created by cleverson.puche on 23/11/2016.
 */

angular
    .module('snk.components.filterpanel',[]);
angular
    .module('snk.components.fixedbar', []);
/**
 * @ngdoc overview
 * @name snk.components.flattree
 *
 * @description
 *  Módulo de configuração do flattree
 */
angular
    .module('snk.components.flattree', []);
/**
 * @ngdoc overview
 * @name snk.components.font
 *
 * @description
    Módulo de configuração para utilização da diretiva font.
 */
angular
    .module('snk.components.font', ['snk.core.util']);
/**
 * @ngdoc overview
 * @name snk.form
 *
 * @description
 Responsável por gerar todo e qualquer tipo de formulário.
 */
angular
    .module('snk.components.form', []);
/**
 * @ngdoc overview
 * @name snk.formitem
 *
 * @description
 Item de formulário responsável por gerar todo e qualquer tipo de input utilizado.
 */
angular
    .module('snk.components.form.formitem', ['snk.core.util']);
angular
    .module('snk.components.formconfig', []);

/**
 * @ngdoc overview
 * @name snk.gridconfig
 *
 * @description
 Módulo de configuração do Gridconfig
 */
angular
    .module('snk.components.gridconfig', [])
    .config([
        '$logProvider',
        function ($logProvider) {
            $logProvider.debugEnabled(true);
        }
    ]);
angular
    .module('snk.components.gridprinter', []);
/**
 * Created by dione.martins on 23/01/2019.
 */

 /**
 * @ngdoc directive
 * @name snk.gridstatistics
 * @description 
 * Módulo de exibição de estatísticas da Grade
 * 
 */

angular
    .module('snk.components.gridstatistics', [])
    .config([
        '$logProvider',
        function ($logProvider) {
            $logProvider.debugEnabled(true);
        }
    ]);
/**
 * @ngdoc overview
 * @name snk.components.groupcontainer
 *
 * @description
    Módulo de configuração para utilização da diretiva skGroupContainer.
 */
angular
    .module('snk.components.groupcontainer', []);
/**
 * @ngdoc overview
 * @name snk.components.sk-help-tip
 *
 * @description
 *	 	Esse componente é responsável por mostrar um tooltip com informação de ajuda. 
 */
angular
    .module('snk.components.helptip', []);
/**
 * @ngdoc overview
 * @name snk.components.hover
 *
 * @description
 Adicionar classe no hover do elemento.
 */
angular
    .module('snk.components.hover', []);
/**
 * @ngdoc overview
 * @name snk.components.icon
 *
 * @description
 Módulo de configuração para utilização da diretiva skIcon.
 */
angular
    .module('snk.components.icon', ['snk.core.util']);
/**
 * Created by bruno.brandao on 14/09/2017.
 */
angular
    .module('snk.components.imagepopup', []);
/**
 * @ngdoc overview
 * @name snk.components.input
 *
 * @description
    Módulo de configuração dos inputs
 */
angular
    .module('snk.components.input', [])
    .run(function ($templateCache) {
        //Substituindo templates do combobox
        $templateCache.put('selectize/select.tpl.html', $templateCache.get('components/input/combobox/combobox.match.tpl.html'));
    });


angular
    .module('snk.components.intervalselector', ['snk.core.util']);

angular
    .module('snk.components.ishikawa', []);
angular
    .module('snk.components.label', []);
angular
    .module('snk.components.linkedlist', []);
/**
 * @ngdoc overview
 * @name snk.components.list
 *
 * @description
    Módulo de configuração para utilização da diretiva list.
 */
angular
    .module('snk.components.list', []);
/**
 * Created by Leonardo.mendes on 22/02/2018.
 */
angular
    .module('snk.components.listOrder',[]);
angular
    .module('snk.components.livetimeline', []);
/**
 * @ngdoc overview
 * @name snk.components.load
 *
 * @description
 * Módulo de configuração para utilização da diretiva skLoad para identificar o momento em que o elemento foi carregado.
 */
angular
    .module('snk.components.load', []);
/**
 * @ngdoc overview
 * @name snk.components.loadingpanel
 *
 * @description
 * Módulo de configuração para utilização da diretiva skLoadingPanel.
 */
angular
    .module('snk.components.loadingpanel', []);
angular
    .module('snk.components.mapbutton',[]);
angular
    .module('snk.components.margemcontribchart',[]);
/**
 * @ngdoc overview
 * @name snk.components.sk-mask-builder
 *
 * @description
 *	 	Esse componente é responsável por construir máscaras.
 */
angular
    .module('snk.components.maskbuilder', []);
/**
 * @ngdoc overview
 * @name snk.components.multilist
 *
 * @description
 Módulo de configuração para utilização do componente skMultilist.
 */
angular
    .module('snk.components.multilist', []);
/**
 * @ngdoc overview
 * @name snk.components.navigator
 *
 * @description
 *  Módulo de configuração do Navigator
 */
angular
    .module('snk.components.navigator', []);
/**
 * @ngdoc overview
 * @name snk.components.personalizedfilter
 *
 * @description
 Módulo de filtros personalizados das telas, para ver a documentação {@link snk.components.personalizedfilter.directive:sk-personalized-filter clique aqui}.
 */
angular
    .module('snk.components.personalizedfilter', ['snk.core.util']);
angular
    .module('snk.components.pesquisacep', []);
/**
 * @ngdoc overview
 * @name snk.components.popover
 *
 * @description
 Módulo de configuração para utilização da diretiva skPopover.
 */
angular
    .module('snk.components.popover', ['snk.core.util']);
/**
 * @ngdoc overview
 * @name snk.components.popup
 *
 * @description
 Módulo de configuração para utilização dos Popup do sistema.
 */
angular
    .module('snk.components.popup', []);
/**
 * @ngdoc overview
 * @name snk.components.popupparameter
 *
 * @description
    Módulo de configuração do PopUpParameter, para ver a documentação {@link snk.components.popupparameter.service:PopUpParameter clique aqui}.
 */
angular
    .module('snk.components.popupparameter', [])
    .config([
        '$logProvider',
        function ($logProvider) {
            $logProvider.debugEnabled(true);
        }
    ]);
/*
 * Created by jonathan.silva.
 */
angular
    .module('snk.components.queryexecutor', []);
/**
 * @ngdoc overview
 * @name snk.components.recordsorganizerbar
 *
 * @description
    Módulo de configuração para utilização da diretiva recordsorganizerbar.
 */
angular
    .module('snk.components.recordsorganizerbar', []);
angular
    .module('snk.components.resizable', []);
angular
    .module('snk.components.resizablecontainer', []);
angular
    .module('snk.components.rowscounter', []);
angular.module('snk.components.sankhyaaccount', []);
angular
    .module('snk.components.select', []);
/**
 * @ngdoc overview
 * @name  snk.components.sglclick
 *
 * @description
 *	 	Esse diretiva é responsável por permitir utilizar duplo click junto com o um click. 
 */
angular
    .module('snk.components.sglclick', []);
/**
 * @ngdoc overview
 * @name snk.components.sidenav
 *
 * @description
 * Módulo de configuração para utilização do componente skSidenav.
 */
angular
    .module('snk.components.sidenav', ['snk.core.services.registry', 'snk.core.util']);
/**
 * @ngdoc overview
 * @name sk-simple-form
 *
 * @description
 Responsável por gerar formulários visuais, ou seja, apenas a estrutura de 1 formulário sem metadados, 
 {@link sk-simple-form.directive:sk-simple-form clique aqui} e veja a documentação completa.
 */
angular
    .module('snk.components.simpleform', []);
angular
    .module('snk.components.snackbar', []);
angular
    .module('snk.components.sortable', []);
/**
 * @ngdoc overview
 * @name snk.components.stickypanel
 *
 * @description
 *  Módulo de configuração do stickypanel
 */
angular
    .module('snk.components.stickypanel', []);
/**
 * @ngdoc overview
 * @name snk.components.structuredfield
 *
 * @description
    Módulo de configuração do componente structuredfield.
 */
angular
    .module('snk.components.structuredfield', []);

/**
 * @ngdoc overview
 * @name snk.components.tab
 *
 * @description
 * M�dulo de configura��o para utiliza��o do componente skTab.
 */
angular
    .module('snk.components.tab', ['snk.components.tabnavigator', 'snk.components.viewstack']);
/**
 * @ngdoc overview
 * @name snk.components.tabnavigator
 *
 * @description
 * M�dulo de configura��o para utiliza��o da diretiva skTabNavigator.
 */
angular
    .module('snk.components.tabnavigator', []);
angular
    .module('snk.components.taskbar', [])
    .config(function($logProvider){
        $logProvider.debugEnabled(false);
    });
/**
 * @ngdoc overview
 * @name snk.components.timelinediagram
 *
 * @description Módulo de configuração para utilização do timeline diagram
 */
angular
    .module('snk.components.timelinediagram', []);

/**
 * @ngdoc overview
 * @name snk.components.tile
 *
 * @description
    Módulo de configuração para utilização da diretiva title.
 */
angular
    .module('snk.components.title', ['snk.core.util']);
angular
    .module('snk.components.titlelabel', []);
/**
 * @ngdoc overview
 * @name snk.components.toast
 *
 * @description
 *  Esse módulo é responsável por fornecer o componente de toast customizado.
 */
angular
  .module('snk.components.toast', []);
/**
 * @ngdoc overview
 * @name  snk.components.tooltip
 *
 * @description
 *	 	Esse diretiva é responsável por apresentar tooltip com informações. 
 */
angular
    .module('snk.components.tooltip', [])
    .run(["$templateCache", function ($templateCache) {
        $templateCache.put("template/tooltip/tooltip-light-html-popup.html",
            "<div class=\"tooltip-light tooltip\"\n" +
            "  tooltip-animation-class=\"fade\"\n" +
            "  tooltip-classes\n" +
            "  ng-class=\"{ in: isOpen() }\">\n"  +
            "  <div class=\"tooltip-light tooltip-arrow \"></div>\n" +
            "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
            "</div>\n" +
            "");

        $templateCache.put("template/tooltip/tooltip-html-popup.html",
            "<div class=\"tooltip\"\n" +
            "  tooltip-animation-class=\"fade\"\n" +
            "  tooltip-classes\n" +
            "  ng-class=\"{ in: isOpen() }\">\n" +
            "  <div class=\"tooltip-arrow\"></div>\n" +
            "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
            "</div>\n" +
            "");

        $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
            "<div class=\"tooltip\"\n" +
            "  tooltip-animation-class=\"fade\"\n" +
            "  tooltip-classes\n" +
            "  ng-class=\"{ in: isOpen() }\">\n" +
            "  <div class=\"tooltip-arrow\"></div>\n" +
            "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
            "</div>\n" +
            "");

        $templateCache.put("template/tooltip/tooltip-popup.html",
            "<div class=\"tooltip\"\n" +
            "  tooltip-animation-class=\"fade\"\n" +
            "  tooltip-classes\n" +
            "  ng-class=\"{ in: isOpen() }\">\n" +
            "  <div class=\"tooltip-arrow\"></div>\n" +
            "  <div class=\"tooltip-inner\" ng-bind-html=\"content\"></div>\n" +
            "</div>\n" +
            "");

        $templateCache.put("template/tooltip/tooltip-template-popup.html",
            "<div class=\"tooltip\"\n" +
            "  tooltip-animation-class=\"fade\"\n" +
            "  tooltip-classes\n" +
            "  ng-class=\"{ in: isOpen() }\">\n" +
            "  <div class=\"tooltip-arrow\"></div>\n" +
            "  <div class=\"tooltip-inner\"\n" +
            "    tooltip-template-transclude=\"contentExp()\"\n" +
            "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
            "</div>\n" +
            "");
    }]);

angular
    .module('snk.components.tooltipbuilder', []);
/**
 * Created by cleverson.puche on 12/04/2016.
 */

angular
    .module('snk.components.tree',[]);
/**
 * Created by cleverson.puche on 25/10/2016.
 */
angular
    .module('snk.components.twolists',[]);
/**
 * @ngdoc overview
 * @name snk.components.viewstack
 *
 * @description
 * Módulo de configuração para utilização da diretiva skViewstack.
 */
angular
    .module('snk.components.viewstack', []);
angular
    .module('snk.components.waitwindow', []);
/**
 * @ngdoc overview
 * @name snk.components.wizard
 *
 * @description
 * Módulo de configuração para utilização da diretiva wizard.
 */
angular
    .module('snk.components.wizard', []);
/**
 * @ngdoc overview
 * @name snk.components.workbox
 *
 * @description
    Módulo de configuração para utilização da diretiva workbox.
 */

angular
    .module('snk.components.workbox', []);
/**
 * @ngdoc overview
 * @name snk.i18n
 *
 * @description
 *  <h1 class="ng-scope"><code ng:non-bindable="">i18n - Internacionalização</code></h1>
 * Módulo de internacionalização de todas as telas do sistema utilizando Javascript e HTML.
 *
 * Atualmente estamos trabalhando com o módulo <a href="https://angular-translate.github.io/" target="_blank">Angular
 * Translate</a> para as internacionalizações.
 *
 * Para fazer a internacionalização de suas telas ou componentes, você deve fazer checkout no SVN do projeto:
 * <b style="color:blue;">i18n-js</b>. É nesse projeto que contém todos os arquivos de internacionalização e também é
 * nele que você vai criar os seus próprios arquivos de internacionalização. Todas as internacionalização que
 * equivalem para todas as telas ou componentes deverão ser inseridos no _Framework e utilizado ele.
 * Nesse arquivo de internacionalização _Framework, ele é dividido por partes. Podemos ter a chave Dataset com todas as
 * internacionalização do mesmo e também a chave Geral. Ao utilizar alguma proriedade de internacionalização dessas chaves,
 * você vai usar Geral.CHAVEI18N ou Dataset.CHAVEI18N.
 * A internacionalização _Framework já é carregada juntamente com o workspace e dessa forma pode ser reutilizada onde for
 * necessário.
 *
 * No projeto HTML5, os arquivos de internacionalização consiste em 1 arquivo do tipo JSON. A sua chave é o
 * identificador da tradução e o valor a tradução.
 *
 * Para fazer a tradução de uma tela, você deve seguir os passos abaixo:
 * - Faça o checkout do projeto i18n-js;
 * - Crie 1 arquivo <b>(caso não exista)</b> no diretório <b>/i18n-js/src/en_US</b> e <b>/i18n-js/src/pt_BR</b> com o nome da sua Tela:
 *    * <b>Exemplo:</b> caso sua tela seja a Central de Notas, o nome do arquivo na pasta deve ser CentralNotas.json.
 *
 * - Crie os arquivos de internacionalização na sua pasta, atualmente criamos nas pastas <b>pt_RB/</b> e <b>en_US/</b>;
 * - O carregamento da internacionalização da sua tela é feita pelo HTML5Launcher automáticamente.
 *
 * Após seguir os passos, a internacionalização ficará disponível na tela para ser utilizado no seu HTML ou Javascript.
 * Atualmente para os arquivos HTML temos a internacionalização dísponivel como:
 *
 * <b>- SERVIÇO</b>
 * <pre>
     app.controller('Ctrl', ['$scope', '$translate', function ($scope, $translate) {
      $translate.instant('NomeDaSuaTela.TITULO');//Retorna a internacionalização, onde TITULO é a chave criada no JSON.
    }]);
   </pre>
 *
 * <b>- FILTRO</b>
 * <pre>
        <p>{{ 'NomeDaSuaTela.TITULO' | translate }}</p>
   </pre>
 *
 *<b>- DIRETIVA</b>
 * <pre>
        <p translate>NomeDaSuaTela.TITULO</p>
        <p translate>{{ traducaoId }}</p>
        <p translate="NomeDaSuaTela.TITULO"></p>
        <p translate="{{ traducaoId }}"></p>
   </pre>
 *
 * Para definir um valor váriavel em uma tradução, tudo que precisa fazer é utilizar a diretiva interpolate do
 * Angular. Veja abaixo como fica o JSON com a variação de 1 parametro na internacionalização:
 <pre>
    //JSON da internacionalização
    {
        "ID_TRADUCAO": "{{ usuario }} está logado."
    }

    //Substituição da variavel via serviço $translate
    $translate('NomeDaSuaTela.ID_TRADUCAO', { usuario: 'Marlon' });

    //Substituição da variavel via filtro
    {{ 'NomeDaSuaTela.ID_TRADUCAO' | translate:'{ usuario: "Marlon" }' }}

    //Substituição da variavel via diretiva
    <ANY translate="NomeDaSuaTela.ID_TRADUCAO" translate-values='{ usuario: "Marlon"}'></ANY>
    //ou
    <ANY translate="NomeDaSuaTela.ID_TRADUCAO" translate-values="{ usuario: scopeObject.usuario }"></ANY>
 </pre>
 *
 * Existe a possibilidade também de utilizar a tradução e substituição de variaveis diretamente no HTML sem a
 * necessidade de passar 1 objeto para o atributo translate-values. Esse recurso pode ser simulado com a utilização
 * do atributo translate-value-*, veja abaixo:
 * <pre>
        //JSON da internacionalização
        {"GREETING": "Oi, meu nome é {{name}}"}

        //Utilizando com a diretiva de atributo translate-value-*
        <p translate="GREETING" translate-value-name="Maria"></p>
        //ou
        <p translate="GREETING" translate-value-name="{{myName}}"></p>
 * </pre>
 *
 * <b style="color:red;">Observação:</b> Para verificar todas as funcionalidades e mais detalhes de como funciona o Angular Translate,
 * <a href="https://angular-translate.github.io/docs/#/guide" target="_blank">clique aqui</a> e veja a documentação completa.
 *
 * Para verificar 1 exemplo completo de internacionalização, veja abaixo nosso exemplo.
 * @example
     <example module="app">
         <file name="exemplo.html">
            <div ng-controller="Ctrl">
                <p>i18n via FILTRO: {{ 'MinhaTela.HELLO' | translate }}</p>
                <p>i18n via DIRETIVA: <span sk-translate>MinhaTela.HELLO</span></p>
                <p>i18n via DIRETIVA: <sk-translate>MinhaTela.HELLO</sk-translate></p>
                <p translate>i18n via objeto do $scope: {{ traducaoIdKey }}</p>
                <br>
                <p>i18n via FILTRO c/ parametros: {{ 'MinhaTela.HELLO_NAME' | translate:'{name: "Marlon"}' }}</p>
                <p>
                    i18n variavel a partir do $scope:
                    <sk-translate sk-translate-values="{ count: countScope }">MinhaTela.N_CLICK</sk-translate>
                </p>
                <br>
                <p>Tradução feita no Controlador: {{ translateInCtrl }} //Aqui não acontece data bind pois foi traduzido manualmente no controlador</p>
                <button type="button" ng-click="i18nChange()" class="btn btn-warning">Alterar Idioma</button>
                <br><br>
            </div>
         </file>
         <file name="app.js">
            //Essa não é a maneira correta, como é apenas 1 exemplo injetamos a internacionalização manualmente
            var traducoes = {
                'HELLO': 'Olá, seja bem-vindo!',
                'HELLO_NAME': 'Olá {{ name }}',
                'N_CLICK': '{{ count }} clique.'
            };

            var translations = {
                'HELLO': 'Hello welcome!',
                'HELLO_NAME': 'Hello {{ name }}',
                'N_CLICK': '{{ count }} click.'
            };

            angular.module('app', ['snk'])
                .run(['SkI18nService', function(SkI18nService) {
                    SkI18nService.setLang('pt_BR');

                    SkI18nService.addPart('pt_BR', 'MinhaTela', traducoes);
                    SkI18nService.addPart('en_US', 'MinhaTela', translations);
                }])
                .controller('Ctrl', ['$scope', 'SkI18nService', '$timeout', function ($scope, SkI18nService, $timeout) {
                    var lang;

                    $scope.countScope = 0;
                    $scope.traducaoIdKey = "MinhaTela.HELLO";

                    //Esse $timeout foi necessário apenas para nosso exemplo da documentação,
                    //nas nossas telas do sistema não precisa do $timeout
                    $timeout(function(){
                        $scope.translateInCtrl = SkI18nService.instant('MinhaTela.HELLO')
                    }, 0, false);

                    $scope.i18nChange = function() {
                        if (lang === 'en_US') {
                            lang = 'pt_BR';
                        } else {
                            lang = 'en_US';
                        }

                        $scope.countScope = $scope.countScope + 1;

                        SkI18nService.setLang(lang);
                    };
                }]);
         </file>
     </example>
 */
angular
    .module('snk.i18n', ['pascalprecht.translate'])
    .config(['$translateProvider', '$provide', function ($translateProvider, $provide) {
        $translateProvider.useSanitizeValueStrategy(null);
        $translateProvider.useLoader('SkI18nServiceLoader');
        $translateProvider.forceAsyncReload(true);

        $provide.decorator('translateFilter', ['$delegate', function($delegate) {
            return function (translationId, interpolateParams, interpolation){
                var translated = $delegate(translationId, interpolateParams, interpolation);

                return translated != translationId ? translated : undefined;
            };
        }]);
    }])
    .run(function ($rootScope, $translate) {
        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
            $translate.refresh();
        });
    });

angular
    .module('snk.commons.acaoprogramada', ['snk.commons']);
/**
 * Created by Italo Louis on 23/07/2018.
 */
angular
    .module('snk.commons.agendamentoBase', ['snk.commons']);
angular
    .module('snk.commons.alertContratosPendentes', ['snk.commons']);
angular
    .module('snk.commons.analiseEnvioExpedicao', ['snk.commons']);

angular
    .module('snk.commons.armazem', ['snk.commons']);
    
angular
    .module('snk.commons.avaliacaoCapacidade', ['snk.commons']);
/**
 * Created by italo.araujo on on 08/05/2020.
 */
angular
    .module('snk.commons.baixa.cabecalho', ['snk.commons']);
/**
 * Created by italo.araujo.
 */
angular
    .module('snk.commons.baixa.panel', ['snk.commons']);

angular
    .module('snk.commons.coletorConferenciaLayout', ['snk.commons']);
/**
 * @ngdoc overview
 * @name snk.commons
 *
 * @description
 * Módulo de configuração dos commons do framework.
 *
 */
angular
    .module('snk.commons', []);
angular
    .module('snk.commons.config', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 10/04/2018.
 */
angular
    .module('snk.commons.controleNumeracaoPainel', ['snk.commons']);
angular
    .module('snk.commons.diagnosticoPreVenda', ['snk.commons'])
    .constant('PerguntasConstant', {
        CAIXA_TEXTO_UNICA_LINHA: '0',
        CAIXA_TEXTO_MULTIPLAS_LINHAS: '1',
        OPCOES_LINHA_UNICA_ESCOLHA: '2',
        OPCOES_COLUNA_UNICA_ESCOLHA: '3',
        OPCOES_LINHA_MULTIPLA_ESCOLHA: '4',
        OPCOES_COLUNA_MULTIPLA_ESCOLHA: '5',
        GRUPO_PONTUACAO: '6',
        TABELA_UNICA_ESCOLHA: '7',
        TABELA_MULTIPLA_ESCOLHA: '8',
        LISTA_ANEXO: '9'
    })
    .filter('answerLimit',
        function (StringUtils) {
            return function (label) {
                label = StringUtils.undefinedAsEmpty(label);
                if (label.length > 180) {
                    return label.substring(0, 180) + '...';
                }
                return label;
            };
        });
angular
    .module('snk.commons.edicaoseriepopup', ['snk.commons']);
/**
 * Created by josiemerson.lacerda on 04/07/2017.
 */
angular
    .module('snk.commons.empresa', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 10/04/2018.
 */
angular
    .module('snk.commons.fichaPatrimonialPanel', ['snk.commons']);

angular
    .module('snk.commons.formularioProducaoBuilder', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 16/08/2018.
 */
angular
    .module('snk.commons.ftpinput', ['snk.commons']);
angular
    .module('snk.commons.gradeproduto', ['snk.commons']);
/**
 * Created by Gabriel Lima on 13/05/2019.
 */
angular
    .module('snk.commons.grupotop', ['snk.commons']);
/**
 * Created by Raisa Costa on 10/09/2019
 */
angular
    .module('snk.commons.lancadorMenu.adicionarLancador', ['snk.commons']);
/**
 * Created by Raisa Costa on 16/09/2019
 */
angular
    .module('snk.commons.lancadorMenu.localizarLancador', ['snk.commons']);
angular
    .module('snk.commons.lancamentoOrdemProducao', ['snk.commons']);
/*
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
angular
    .module('snk.commons.layout', []);

/**
 * Createad by Leonardo Mendes on 17/12/2019.
 */
angular
    .module('snk.commons.liberacoes', ['snk.commons']);
angular
    .module('snk.commons.ordemservico', ['snk.commons']);
/**
 * Created by bruno.brandao on 31/03/2016.
 */
angular
    .module('snk.commons.parceiro', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 10/04/2018.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 12/12/2020.
 */
angular
    .module('snk.commons.preenchimentoquestionario', ['snk.commons']);
angular
    .module('snk.commons.queryEditor', ['snk.commons']);
angular
  .module("snk.commons.rateio", ['snk.commons']);

/**
 * Created by Eduardo.Pilla on 01/06/2022.
 */
angular
    .module('snk.commons.solucoespopup.packageItem', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 10/04/2018.
 */
angular
    .module('snk.commons.verticaltimeline', ['snk.commons']);
/**
 * Created by Leonardo.Mendes on 28/11/2016.
 */
angular
    .module('snk.commons.visualizadorRelatoriosBase', ['snk.commons']);
angular
	.module('snk.commons.wizardquestion', ['snk.commons']);
/**
 *	Createad by Walison.ferreira 28/01/2020.
 */
angular
    .module('snk.commons.workFlow.fieldEventService', ['snk.commons']);
/**
 *	Createad by Francisco Navarro 26/11/2018.
 */
angular
    .module('snk.commons.workFlow.modelerBpmn', ['snk.commons']);
/**
 *	Createad by Raisa Costa 04/09/2019.
 */
angular
    .module('snk.commons.workFlow.startingProcess', ['snk.commons'])
    .constant("ContentType", {
        FORMULARIO_FORMATADO: 'F',
        FORMULARIO_NATIVO: 'N',
        FORMULARIO_EMBARCADO: 'E',
        TELA_NATIVA: 'T'
    });
angular
    .module('snk.commons.workFlow.telaNativaFlow', ['snk.commons']);
/**
 *	Createad by Helikson.Rufino 29/10/2020.
 */
angular
    .module('snk.commons.workFlow.visibilityEventService', ['snk.commons']);
function MessageError(title, message, messageValues) {
    if (arguments.length == 1) {
        message = title;
        title = undefined;
    } else if (arguments.length == 2 && (!(typeof message === 'string' || message instanceof String))) {
        messageValues = message;
        message = title;
        title = undefined;
    }

    this.name = 'MessageError';
    this.title = title;
    this.message = message;
    this.messageValues = messageValues;
    this.stack = (new Error()).stack;
}

MessageError.prototype = Error.prototype;

function AlertError(title, message, messageValues) {
    if (arguments.length == 1) {
        message = title;
        title = undefined;
    } else if (arguments.length == 2 && (!(typeof message === 'string' || message instanceof String))) {
        messageValues = message;
        message = title;
        title = undefined;
    }

    this.name = 'AlertError';
    this.title = title;
    this.message = message;
    this.messageValues = messageValues;
    this.stack = (new Error()).stack;
}

AlertError.prototype = Error.prototype;
angular
    .module('snk.core.application')
    .controller('DefaultSankhyaApplicationController', ['$scope', '$injector', '$window', '$element', '$attrs', '$document', '$translate', '$timeout', '$interval', '$q', 'ServiceProxy', 'UrlUtils', 'Base64', 'ObjectUtils', 'SkApplication', 'SkWorkspace', 'KeyboardManager', 'KeyboardEvents', 'MGEAuthorizationService', 'AngularStats', 'MessageUtils', 'DomUtil', 'ArrayUtils', 'AngularUtil', 'UserAgentUtils', 'PrintUtils', 'StringUtils','SkI18nService', 'SkComponentRegistry', 'NumberUtils',
        function ($scope, $injector, $window, $element, $attrs, $document, $translate, $timeout, $interval, $q, ServiceProxy, UrlUtils, Base64, ObjectUtils, SkApplication, SkWorkspace, KeyboardManager, KeyboardEvents, MGEAuthorizationService, AngularStats, MessageUtils, DomUtil, ArrayUtils, AngularUtil, UserAgentUtils, PrintUtils, StringUtils, SkI18nService, SkComponentRegistry, NumberUtils) {
            var CONTROLLER_AS_REGEX = /(\w+) as (\w+)/i;
 
            var _currentPkHash;
            var _currentPkRefresh;
            var urlParams = UrlUtils.getQueryParams(location.search);
            var self = this;

            var _auth = MGEAuthorizationService.buildFromRAS();

            var _appCtrlAlias;
            var _visibleSideBar = false;
            var _isUTF8UrlLoadByPk = false;
            
            var _pkChangeListeners = [];
            var _runtimeParams = {};
            
            var _callLoadByPkWhitoutPk = $attrs.hasOwnProperty('loadByPkWhitoutPk');
            var _hasEmbeddedSwf = $attrs.hasOwnProperty('hasEmbeddedSwf');
            var _useLocalHash = $attrs.hasOwnProperty('useLocalHash');

            let warningElem;

            var _globalFeatureFlags = {};

            ObjectUtils.extend(self, EventBus);

            SkApplication.instance(self);

            self.getResourceID = getResourceID;
            self.getScreenResourceID = getScreenResourceID;
            self.openApp = openApp;
            self.closeApp = closeApp;
            self.reloadApp = reloadApp;
            self.requestDigitalSignature = requestDigitalSignature;
            self.revokeDigitalSignature = revokeDigitalSignature;
            self.showDigitalSignInfo = showDigitalSignInfo;
            self.saveMgeConfig = saveMgeConfig;
            self.removeMgeConfig = removeMgeConfig;
            self.loadMgeConfig = loadMgeConfig;
            self.getConfiguracaoTela = getConfiguracaoTela;
            self.putConfiguracaoTela = putConfiguracaoTela;
            self.hasAuthorization = hasAuthorization;
            self.getAuthorizationData = getAuthorizationData;
            self.isSup = isSup;
            self.getMgeParams = getMgeParams;
            self.openWindow = openWindow;
            self.saveMGECoreParameter = saveMGECoreParameter;
            self.isPureDynaform = isPureDynaform;
            self.isOnlyHtmlApp = isOnlyHtmlApp;
            self.getUrlParam = getUrlParam;
            self.getRequiredUrlParam = getRequiredUrlParam;
            self.isJivaW = isJivaW;
            self.getUserID = getUserID;
            self.isSankhyaW = isSankhyaW;
            self.temOpcional = temOpcional;
            self.dispatchFindKey = dispatchFindKey;
            self.getAppController = getAppController;
            self.getAppControllerAlias = getAppControllerAlias;
            self.addPKChangeListener = addPKChangeListener;
            self.setFrameTitle = setFrameTitle;
            self.registerExternalCall = registerExternalCall;
            self.getElement = getElement;
            self.viewFilesInWindow = viewFilesInWindow;
			self.useClassicLayoutVersion = useClassicLayoutVersion;
            self.useClassicLayoutVersionNoDataSet = useClassicLayoutVersionNoDataSet;
            self.getAttributeFromHTMLWrapper = getAttributeFromHTMLWrapper;
            self.putRuntimeProperty = putRuntimeProperty;
            self.getRuntimeProperty = getRuntimeProperty;
            self.isBloqMovContaPDV = isBloqMovContaPDV;
            self.isHtml5 = isHtml5;
            self.workspaceLogout = workspaceLogout;
            self.setDecodeUTF8UrlLoadByPk = setDecodeUTF8UrlLoadByPk;
            self.isModoFlow = isModoFlow;
            self.isFeatureActive = isFeatureActive;
            self.isMinRequiredVersion = isMinRequiredVersion;

            /*
            Sobrescrita da fn default do angularjs, pois por padrão
            ela não compara valores null, causando algumas falhas no framework
            por exemplo angular.isUndefined(null) retorna false.
            */
            angular.isUndefined = value => value == null;
            angular.isDefined = value => value != null;

            self.userIsCaixa = SkWorkspace.userIsCaixa;
            self.authIsLoadded = authIsLoadded;
			$scope.firstAccessNewLayout = firstAccessNewLayout;
            //Para sobreescrever nas telas.
            $scope.loadByPK = function (pk) {
            };
            $scope.getCloseConfirm = function() {
                return null;
            };
            $scope.appCustomClose = function() {
            };
            $scope.onWorkspaceFocus = function() {
            };

            $scope.redirectMoreInfoNewLayout = redirectMoreInfoNewLayout;
            $scope.redirectBetaMoreInfo = redirectBetaMoreInfo;
            $scope.closeBetaMsg = closeBetaMsg;

            ServiceProxy.applicationResourceID(getResourceID());
            ServiceProxy.setApplicationName(APPLICATION_NAME);

            ServiceProxy.addPrintListener(PrintUtils.processPendingPrinting);
            ServiceProxy.addLocalPrintingListener(PrintUtils.processLocalPrintings);

            if ($window['GLOBALID']) {
                ServiceProxy.globalID(window['GLOBALID']);
            }

            if ($window['APPKEY']) {
                ServiceProxy.appKey(window['APPKEY']);
            }
            
            if (!$window['int'] && typeof int !== 'function') {
                $window['int'] = function(str) {
                    return parseInt(str, 10);
                };
            }

            init();

            function init() {
                if (window !== undefined && window['APPLICATION_NAME'] !== 'DashboardGridApp') {
					//Para o APP da grade do Dashboard nao podemos sobrescrever o onhashchange, pois é necessario escutar o definido no DefaultSankhyaApplication do GWT, para o loadByPK
					SkWorkspace.addHistoryChangeHandler(historyChanged, getResourceID());
				}
				
                registerExternalCalls();

                if (!_hasEmbeddedSwf) {
                    addKeyboardMappings();
                }else if(isCentralNotas()){
                    bindSearchAppShortcut();
                }

                var controllerDefinition = $element.attr('ng-controller');
                var controllerName;

                if (angular.isString(controllerDefinition)) {
                    var result = CONTROLLER_AS_REGEX.exec(controllerDefinition);

                    if (angular.isArray(result)) {
                        controllerName = result[1];
                        _appCtrlAlias = result[2];
                    }
                }

                if (!_appCtrlAlias) {
                    console.warn('Não foi possível determinar o controller da aplicação.\nO mesmo deve estar definido no formato \'MeuController as meuCtrl\' ');
                }

                $document.on('click', SkWorkspace.applicationClick);

                // Multi Abas
                $document.on('mousemove', function(event){
                    var showArea = (window.innerWidth - event.clientX) < 100; 
				    if( showArea && !_visibleSideBar){
                        _visibleSideBar = true;
                        SkWorkspace.openSideBarWorkspace();
                    } else if(!showArea && _visibleSideBar) {
                        _visibleSideBar = false;
                        SkWorkspace.closeSideBarWorkspace();
                    }
                });


                if (!SkWorkspace.isMock()) {
                    const currentHistory = getCurrentHistory();
                    $timeout(function () {
                        historyChanged(currentHistory, true);
                    }, 0, false);
                }

                AngularUtil.setContextControllerInfo($element, controllerName, _appCtrlAlias, getAppController());

                if (SkWorkspace.isMock()) {
                    $scope.$root.$on('$viewContentLoaded', function() {
                        try {
                            var $route = $injector.get('$route');
                            var currRoute = $route.current;
                            var routeMD = currRoute.$$route;

                            AngularUtil.setContextControllerInfo(DomUtil.select($element, '[ng-view]'), routeMD.controller, routeMD.controllerAs, currRoute.scope[routeMD.controllerAs || '$ctrl']);

                            $scope.$root.$emit('$contextControllerChanged');
                        } catch(ignored){
                        }
                    });
                }

                if (urlParams.betaApp == 'true' && isHtml5()) {
                    warningElem = angular.element('<div class="beta-app-warning" ng-mouseover="cancelClose()" ng-mouseleave="startTimerClose(5000)" layout-align="center center">' +
                        '<div class="title"><span>' + SkI18nService.instant('Dynaform.titleMsgBeta') + '</span></div>' +
                        '<div class="body"><span>' + SkI18nService.instant('Dynaform.contentMsgBeta') + '</span>' +
                        '<div class="saber-mais"><a href="#" ng-click="redirectBetaMoreInfo()">' + SkI18nService.instant('Dynaform.saberMais') + '</a></div></div>' +
                        `<a href="#" ng-click="closeBetaMsg()" class="btn-close-beta" title="${SkI18nService.instant('Dynaform.fecharMsg')}">x</a>` +
                        '</div>');

                    angular.element($document[0].getElementById('page')).prepend(AngularUtil.compile(warningElem, $scope));

                    let timerCloseBetaMsg = null;

                    $scope.cancelClose = () => {
                        AngularUtil.cancelTimeout(timerCloseBetaMsg);
                    }

                    $scope.startTimerClose = () => {
                        timerCloseBetaMsg = AngularUtil.timeout(closeBetaMsg, 8000);
                    }

                    $scope.startTimerClose();
                }
                
                if (urlParams.isFirstAccess == 'S' && urlParams.betaApp != 'true') {

                    let clazz = isJivaW() ?  "firstAccess-appjiva" : "firstAccess-app";

                    var newLayoutElem = angular.element(
                        '<div id="firstAccessHtml5" class="' + clazz + '">'
                      + ' <span class="body">Este é o novo layout de telas do sistema (Recomendado). Para voltar ao layout anterior clique na opção "Layout da Tela" no menu do usuário.'
                      + ' <a href="#" ng-click="redirectMoreInfoNewLayout()" class="show-more">Saber mais...</a></span>'
                      + ' <a href="#" ng-click="firstAccessNewLayout()" class="ok-new-layout" >Ok Entendi</a>'
                      + '</div>'
                  ); 
                    
                  angular.element($document[0].getElementById('page')).prepend(AngularUtil.compile(newLayoutElem, $scope));
                }

                let aviso = getAvisosInicializacao();
                
                if(aviso){
                    MessageUtils.showAlert(aviso.title, $translate.instant(aviso.message));
                }

                window['skUid'] = SkComponentRegistry.getSync;
            }

            function closeBetaMsg(){
                angular.element(warningElem).css('display', 'none');
                $scope.$broadcast('warnNewLayoutClosed');
            }

            function redirectMoreInfoNewLayout(){
                $window.open("https://ajuda.sankhya.com.br/hc/pt-br/articles/360048219954", "_blank");
            }

            function redirectBetaMoreInfo(){
                $scope.closeBetaMsg();

                $window.open("https://ajuda.sankhya.com.br/hc/pt-br/articles/360048954813", "_blank");
            }

            
            function firstAccessNewLayout(){
                var wizard = document.getElementById("firstAccessHtml5");
                if (wizard) {
                    wizard.style.display =  "none";
                    $scope.$broadcast('warnNewLayoutClosed');
                }
                var params = {
                    config: {
                        chave: 'isFirstAccessHtml5',
                        tipo: "T",
                        atributo: "true"
                    }
                };

                ServiceProxy.callService('mge@SystemUtilsSP.saveConf', params)
                .then(function (result) {
                    //reloadApp(resourceId);
                });
            }
            
			function registerExternalCalls() {
                $element[0].getCloseConfirm = function() {
                    return $scope.getCloseConfirm();
                };

                $element[0].appCustomClose = function(saveOption, value) {
                    return $scope.appCustomClose(saveOption, value);
                };
                
                $element[0].onWorkspaceFocus = function() {
                    return $scope.onWorkspaceFocus();
                };
            }

            function registerExternalCall(name, fn) {
                $element[0][name] = fn;
            }

            function getElement(){
                return $element;
            }

           function getAppController() {
                if (getAppControllerAlias()) {
                    return $scope[getAppControllerAlias()];
                }
            }

            function getAppControllerAlias() {
                return _appCtrlAlias;
            }
            
            function addPKChangeListener(listener) {
            	_pkChangeListeners.push(listener);
            }

            function setFrameTitle(title) {
                $document[0].title = title;
            }

            function setDecodeUTF8UrlLoadByPk(value) {
                _isUTF8UrlLoadByPk = value;
            }

            function getMgeParams() {
                try {
                    //variavel inputada pelo Html5Launcher no html;
                    return MGE_PARAMS;
                } catch (e) {
                    return '';
                }
            }

            function isFeatureActive(featureName) {
                var deferred = $q.defer();
                const now = Date.now();

                if (_globalFeatureFlags[featureName] && (now < _globalFeatureFlags[featureName].expires)) {
                    deferred.resolve(_globalFeatureFlags[featureName].isActive);
                    return deferred.promise;
                }

                if (featureName) {
                    ServiceProxy.callService('SystemUtilsSP.featureIsActive', {
                        featureName: featureName
                    }).then(function (result) {
                        let isActive = result.responseBody.isActive;

                        //Cache por 1 hora
                        _globalFeatureFlags[featureName] = {
                            isActive: isActive,
                            expires: now + (60 * 60 * 1000)
                        }

                        deferred.resolve(isActive);
                    }, function (error) {
                        deferred.reject(error);
                    });
                } else {
                    deferred.reject();
                }

                return deferred.promise;
            }

            function openApp(resourceId, pkObject) {
                SkWorkspace.openAppActivity(resourceId, pkObject);
            }

            function closeApp(resourceId) {
                SkWorkspace.closeApp(resourceId || getResourceID());
            }

            function reloadApp(resourceId, pkObject) {
                SkWorkspace.reloadApp(resourceId, pkObject);
            }

            function requestDigitalSignature(signatureStamp, params, executorClassName, clientCallBackName) {
                SkWorkspace.requestSignature(signatureStamp, params, executorClassName, clientCallBackName, getResourceID());
            }

            function revokeDigitalSignature(signatureStamp, params, executorClassName, clientCallBackName) {
                SkWorkspace.revokeSignature(signatureStamp, params, executorClassName, clientCallBackName, getResourceID());
            }

            function showDigitalSignInfo(signatureStamp, chaveArquivo) {
                SkWorkspace.showDigitalSignDetails(signatureStamp, chaveArquivo);
            }

            function getConfiguracaoTela(key, defaultValue, asIs) {
                var configElem = document.getElementById(key);

                if (configElem && configElem.value) {
                	if (asIs) {
                		return configElem.value;
                	} else {
                        return JSON.parse(configElem.value);                		
                	}
                }

                return defaultValue;
            }

            function putConfiguracaoTela(key, config, asIs) {
                var input = document.getElementById(key);

                if (!input) {
                    input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('id', key);
                    document.body.appendChild(input);
                }
                
                var value;
                
                if (asIs) {
                	value = config;
                } else {
                	value = config != undefined ? JSON.stringify(config) : '';
                }

                input.value = value ? value : '';
            }

            function saveMgeConfig(resourceId, config, usuario) {
                var deferred = $q.defer();

                if (resourceId && config) {
                    config.chave = resourceId;
                    config.tipo = 'T';

                    if (angular.isDefined(usuario)) {
                    	config.usuario = usuario;
                    }

                    ServiceProxy.callService('SystemUtilsSP.saveConf', {
                        config: config
                    }).then(function (result) {
                        deferred.resolve(result);
                    }, function (error) {
                        deferred.reject(error);
                    });

                } else {
                    deferred.reject();
                }

                return deferred.promise;
            }

            function loadMgeConfig(chave, usuario) {
                return $q(function (resolve, reject) {
                    if (chave) {
                    	var config = {
							chave: chave,
                    		tipo: 'T'
						};

                    	if (angular.isDefined(usuario)) {
                    		config.usuario = usuario;
                    	}

                        ServiceProxy.callService('mge@SystemUtilsSP.getConf', {
                            config: config
                        }).then(function (result) {
                            resolve(result.responseBody);
                        }, reject);
                    } else {
                        reject();
                    }
                });
            }

            function removeMgeConfig(chave, tipo, usuario) {
                return $q(function (resolve, reject) {

                    if (chave) {
                        if (!tipo) {
                            tipo = 'T';
                        }

                        ServiceProxy.callService('SystemUtilsSP.removeConf', {
                            config: {
                                chave: chave,
                                tipo: tipo,
                                usuario: usuario
                            }
                        }).then(function (result) {
                            resolve(result);
                        }, function (error) {
                            reject(error);
                        });

                    } else {
                        reject();
                    }
                });
            }

            function saveMGECoreParameter(parameters, loggedUser) {
                if (!angular.isArray(parameters)) {
                    parameters = [parameters];
                }

                var deferred = $q.defer();

                ServiceProxy.callService('SystemUtilsSP.saveMGECoreParameters', {
                    params: {
                        loggedUser: angular.isUndefined(loggedUser) ? false : loggedUser,
                        param: parameters
                    }
                }).then(function (result) {
                    deferred.resolve(result);
                }, function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            function getCurrentHistory() {
                const currentResourceID = _useLocalHash ? getResourceID() : undefined;
                return SkWorkspace.getCurrentHistory(currentResourceID);
            }

            function historyChanged(token, forceFire) {
                if (forceFire || pkHasChanged(token)) {
                    _currentPkHash = UrlUtils.getPkHashFromToken(token);
                    _currentPkRefresh = UrlUtils.getQueryParamsFromToken(token)['pk-refresh'];

                    var pkObject = getPkObject();
					
					if(pkObject){
						for(obj in pkObject){
						   var pk = pkObject[obj];
						   if(pk && pk.value && pk.type == null){
							   if(!isNaN(pk.value)){
								   pk.type = "I";
							   } else {
								   pk.type = "S";
							   }
						   }
						}
					}
					
                    if (pkObject || _callLoadByPkWhitoutPk) {
                        $scope.loadByPK(pkObject);
                        
                        _pkChangeListeners.forEach(function(listener) {
                        	listener(pkObject);
                        });
                    }
                }
            }

            function pkHasChanged(token) {
                let pkHash = UrlUtils.getPkHashFromToken(token);
                let queryParams = UrlUtils.getQueryParamsFromToken(token);

                return (pkHash != _currentPkHash || queryParams['pk-refresh'] != _currentPkRefresh);
            }

            function getPkObject() {
                if (_currentPkHash) {
                    return UrlUtils.getPkObject(_currentPkHash, _isUTF8UrlLoadByPk);
                }
            }

            function isModoFlow() {
                return StringUtils.isNotEmpty(getUrlParam('flowID'));
            }

            function getResourceID(defaultValue) {
                return urlParams.workspaceResourceID || urlParams.resourceID || defaultValue || 'unknown.resource.id';
            }

            function getScreenResourceID() {
                return urlParams.resourceID;
            }

            function isPureDynaform() {
                return urlParams.pureDynaform == 'true';
            }
            
            function isOnlyHtmlApp() {
            	return urlParams.onlyHtml5 == 'true';
            }

            function getUrlParam(paramName) {
                return urlParams[paramName];
            }

            function getRequiredUrlParam(paramName) {
                var paramValue = getUrlParam(paramName);

                if (angular.isUndefined(paramValue)) {
                    throw new Error('Parâmetro de URL requerido não informado. [' + paramName + ']');
                }

                return paramValue;
            }

            function isSup() {
                if (_auth == null) {
                    throw new Error($translate.instant('SanUtil.Authorization.messagePermissoesNaoCarregadas'));
                }
                return _auth.isUserSup();
            }

            function hasAuthorization(key) {
                if (_auth == null) {
                    throw new Error($translate.instant('SanUtil.Authorization.messagePermissoesNaoCarregadas'));
                }

                return _auth.hasAccess(key);
            }

            function getAuthorizationData() {
                return _auth;
            }

            function dispatchFindKey(element) {
                self.dispatchEvent(KeyboardEvents.FIND, {
                    target: element
                });
            }

            function bindSearchAppShortcut(){
                KeyboardManager.bind('ctrl+g', function (e) {
                    workspace.searchApp();
                });
            }

            function addKeyboardMappings() {

                //Pesquisa de telas
                KeyboardManager.bind('ctrl+g', function (e) {
                    workspace.searchApp();
                });

                //Pesquisa de campos
                KeyboardManager.bind('ctrl+f', function (e) {
                    self.dispatchEvent(KeyboardEvents.FIND, {
                        target: e.target
                    });
                });

                //Pesquisa de campos
                KeyboardManager.bind('ctrl+e', function (e) {
                    self.dispatchEvent(KeyboardEvents.FIND_ENTITY, {
                        target: e.target
                    });
                });

                //Mostrar desktop
                KeyboardManager.bind('ctrl+d', function (e) {
                    workspace.showDesktop();
                });

                //Abrir Docmentação
                KeyboardManager.bind('f1', function () {
                    workspace.openHelp();
                });

                //F6 Mudar p/ face de um doublefacepanel
                KeyboardManager.bind('f6', function (e) {
                    self.dispatchEvent(KeyboardEvents.CHANGE_FACE_KEY, {
                        target: e.target
                    }, true);
                });

                //F7 Salvar registro Dataset
                KeyboardManager.bind('f7', function (e) {
                    self.dispatchEvent(KeyboardEvents.SAVE_KEY, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                });

                //CTRL+F6 Aba anterior
                KeyboardManager.bind('ctrl+f6', function (e) {
                    self.dispatchEvent(KeyboardEvents.PREVIOUS_TAB, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    });
                });

                //CTRL+F7 Próxima aba
                KeyboardManager.bind('ctrl+f7', function (e) {
                    self.dispatchEvent(KeyboardEvents.NEXT_TAB, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    });
                });

                //Ctrl + \ Salvar registro Dataset
                KeyboardManager.bind('ctrl+\\', function (e) {
                    self.dispatchEvent(KeyboardEvents.SAVE_KEY, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                });

                //F8 Add registro Dataset
                KeyboardManager.bind('f8', function (e) {
                    self.dispatchEvent(KeyboardEvents.ADD_KEY, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                });

                var deleteFn = function (e) {
                    self.dispatchEvent(KeyboardEvents.DELETE_KEY, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                };

                //F9 Remover registro Dataset
                KeyboardManager.bind('f9', deleteFn);
                KeyboardManager.bind('ctrl+f9', deleteFn); //MAC

                //Esc Cancelar edição Dataset
                KeyboardManager.bind('escape', function (e) {
                    self.dispatchEvent(KeyboardEvents.CANCEL_KEY, {
                        target: e.target,
                        triggerEvent: e
                    }, true);
                }, { propagate: true });

                //Ctr + > Ir para o próximo registro Dataset
                KeyboardManager.bind('ctrl+.', function (e) {
                    self.dispatchEvent(KeyboardEvents.NEXT_KEY, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                });

                //Ctrl + < Ir para o registro anterior Dataset
                KeyboardManager.bind('ctrl+,', function (e) {
                    self.dispatchEvent(KeyboardEvents.PREVIOUS_KEY, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                });

                //F5 refresh Dataset navegador sankhya
                KeyboardManager.bind('f5', function (e) {
                    self.dispatchEvent(KeyboardEvents.REFRESH_DS, {
                        target: e.target,
                        stopPropagation: e.stopPropagation
                    }, true);
                });


                /** DEV.Stats*/
                //Angular statistics
                KeyboardManager.bind('ctrl+k', function (e) {
                    console.log('watchers na aplicação:', AngularStats.getApplicationWatcherCount());
                });
            }

            function openWindow(url, target, specs) {
                /*Quando o usario acessa um link www sem o http ou https o navegador 
                entende que estamos acessando um caminho relativo e adiciona o host local
                antes da url*/
                if(url && url.startsWith('www')){
                    url = '//' + url;
                }
                
                var windowOpened = $window.open(url, target, specs);

                if (!UserAgentUtils.getBrowserInfo().electron && (!windowOpened || windowOpened.closed || typeof windowOpened.closed == 'undefined')) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, $translate.instant('GridPrinter.msgHabiliteOsPopUps'));
                }
            }

            function isJivaW() {
                return SkWorkspace.isJivaW();
            }

            function isSankhyaW() {
                return SkWorkspace.isSankhyaW();
            }

            function isMinRequiredVersion(version) {
                const regex = /^(?:(?:\d+)-)?(?<major>\d+)\.(?<minor>\d+)(?:(?:-(?:[A-Za-z]+)))?(?:b(?<path>\d+))?$/
                const sysVersion = regex.exec(window.top.SYSVERSION).groups;
                const parsedVersion = regex.exec(version).groups;

                major = NumberUtils.compareNumber(NumberUtils.stringToNumber(parsedVersion.major) || 0, NumberUtils.stringToNumber(sysVersion.major));
                if (major == 1) return false;
                if (major == -1) return true;

                minor = NumberUtils.compareNumber(NumberUtils.stringToNumber(parsedVersion.minor) || 0, NumberUtils.stringToNumber(sysVersion.minor));
                if (minor == 1) return false;
                if (minor == -1) return true;

                return (NumberUtils.stringToNumber(parsedVersion.path) || 0) <= NumberUtils.stringToNumber(sysVersion.path);
            }

            function getUserID() {
                var userID = $window.UID;

                if (!userID) {
                    throw new Error("Erro interno: Nãoo foi possível obter o ID do usuário logado!");
                }

                return Number(userID);
            }

            function temOpcional(opcional) {
                if (getAttributeFromHTMLWrapper("opc0009") == "1") {
                    return true;
                }

                return angular.isDefined(ArrayUtils.find(ArrayUtils.toArray(opcional), function (opc) {
                    return getAttributeFromHTMLWrapper("opc" + opc) == "1"
                }));
            }

            function getAttributeFromHTMLWrapper(attribName) {
                return window[attribName];
            }

            function viewFilesInWindow (chave, module) {
                if (StringUtils.isEmpty(chave)) {
                    throw new Error("Erro interno: chave repassada para visualizar o arquivo é nula ou vázia.");
                }
                
                if (!module) {
                	module = "mge";
                }
                var url = "" + window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/" + module + "/visualizadorArquivos.mge?chaveArquivo=" + chave;

                window.open(url);    
            }
			function useClassicLayoutVersion(dataset, resourceId) {
                dataset.askAndCancelEdition().then(function () {
                    useClassicLayoutVersionNoDataSet(resourceId);
                });
            }

            function useClassicLayoutVersionNoDataSet(resourceId){
                if(!resourceId){
                    resourceId = getScreenResourceID();
                }
                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, SkI18nService.instant('Dynaform.msgConfirmaUtilizLayoutClassico'))
                        .then(function () {
                            var params = {
                                param: {
                                    choice: 'N',
                                    resourceID: resourceId
                                }
                            };

                            ServiceProxy.callService('mge@WorkspaceSP.changeHtml5ScreenConfig', params)
                                .then(function (result) {
                                    reloadApp(resourceId);
                                });
                        }, function (reason) {
                            //Nada a fazer
                        });
            }

			function authIsLoadded(){
            	return _auth != null;
			}
            
            function putRuntimeProperty(key, value) {
                _runtimeParams[key] = value;
            }

            function getRuntimeProperty(key) {
                return _runtimeParams[key];
            }

            function getAvisosInicializacao(){
                try{
                    let inputAviso = $document[0].getElementById(getResourceID() + '.avisoIniciaLizacao');
                    let aviso;

                    if(inputAviso) {
                        let avisoObject = JSON.parse(inputAviso.value);
                        aviso = avisoObject;
                    }

                    return aviso;
                }catch(e){
                  console.warn('[DefaultSankhyaApplicationController] Erro ao carregar avisos de inicialização', e);   
                }
                
            }
            
            function isBloqMovContaPDV(){
                return workspace.isBloqMovContaPDV();
            }
            /**
             * Método utilizado pelo CentralNotasStack, 
             * para decidir se vai carregar o SWF ou o HTML5
             * newLayoutSupChoice é injetado pelo WorkspaceHelper.java addNewLayoutInfo
             */
            function isHtml5(){
                return urlParams.newLayoutSupChoice == 'S';
            }

            function workspaceLogout() {
                SkWorkspace.logout();
            }

            function isCentralNotas(){
                const CENTRAL_RESOURCE_ID = "br.com.sankhya.com.mov.";
                return StringUtils.isNotEmpty(getResourceID()) && getResourceID().startsWith(CENTRAL_RESOURCE_ID);
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.core.application.directive:sk-application
 * @restrict EA
 * @scope
 * @description
    Faz com que sua tela implemente o DefaultSankhyaApplication, orquestrando várias
    funcionalidades padrões e obrigatórias nas telas de nosso framework.
 *
 * @example
     <example module="app">
         <file name="index.html">
            <div sk-application>
            </div>
         </file>
         <file name="app.js">
            angular.module('app', []);
         </file>
     </example>
 */
angular
    .module('snk.core.application')
    .directive('skApplication', ['$document', 'UserAgentUtils', 'SkWorkspace', function($document, UserAgentUtils, SkWorkspace){
        return {
            restrict: 'EA',
            controller: 'DefaultSankhyaApplicationController',
            priority: 501,
            compile: function($element, $attr) {
                UserAgentUtils.putBrowserInfoOnBody();
                
                var bodyElem = angular.element($document[0].body);

                if (SkWorkspace.isJivaW()) {
                	bodyElem.addClass('jivaw');
                }

                if (!$attr.hasOwnProperty('layout')) {
                    $element.attr('layout', 'column');
                }

                if (!$attr.hasOwnProperty('flex')) {
                    $element.attr('flex', '');
                }
                
                if ($attr.hasOwnProperty('skBodyOverflow')) {
                	bodyElem.css('overflow', $attr.skBodyOverflow);

                    if ($attr.skBodyOverflow == 'hidden' && !$attr.hasOwnProperty('skBodyHeight')) {
                        angular.element(bodyElem.children()[0]).css('height', '100%');
                    }
                }

                if ($attr.hasOwnProperty('skBodyHeight')) {
                    angular.element(bodyElem.children()[0]).css('height', $attr.skBodyHeight);
                    angular.element(bodyElem.children()[0]).css('max-height', $attr.skBodyHeight);
                }
            }
        };
    }]);

angular
    .module('snk.core.application')
    .provider('SkApplication', function() {
        var provider = this;

        provider.setStandaloneApp = function(appName, profileID, options) {
            //OBS:
            // as coisas aqui são sem "var" mesmo, para serem injetadas no contexto global.

            RAS = '';
            PROFILEID = profileID || 'S4W8LB';//Profile Sankhya
            APPLICATION_NAME = appName || 'SANKHYA-JS-APP';

            workspace = {
                openAppActivity: angular.noop,
                closeApp: angular.noop,
                reloadApp: angular.noop,
                openHelp: angular.noop,
                applicationClick: angular.noop,
                addHistoryChangedHandler: angular.noop,
                getAppLabel:  function() {
                    return (options && options.appDescription) || APPLICATION_NAME;
                },
                isMock: true,
                mockedParams: {
                    'global.notifica.alteracao.dataset': false,
                    'global.ordenar.abas.todasabas': true,
                    'global.ordenar.filtros.personalizados': true,
                    'global.ordenar.acoes.personalizadas': false,
                    'global.atalho.acoes.personalizadas': false,
                    'mge.core.config.form.html5': 0,
                    'br.com.sankhya.mge.mostra.aviso.pagina.inicial': true,
                    'mge.core.qtde.maxima.registros.para.exportacao': 0,
                    'global.usa.app.cubo': false,
                    'global.porta.app.impressao': 9096,
                    'global.usa.app.impressao': false
                }
            };

            if (options && options.params) {
                angular.forEach(options.params, function(value, key) {
                    provider.setMGEParam(key, value);
                });
            }
        };

        provider.setMGEParam = function(key, value) {
            if (!workspace || !workspace.isMock) {
                throw new Error("Para setar um parâmetro por aqui, sua aplicação deve ser Standalone, use setStandaloneApp()")
            }

            workspace.mockedParams[key] = value;
        };

        provider.$get = [function(){
            var self = this;

            var _skApplication;

            self.instance = function(skApplication){

                if (skApplication){ //set
                    if (_skApplication) {
                        throw new Error('Application já instanciado');
                    }

                    _skApplication = skApplication;
                } else { //get
                    if (!_skApplication){
                        throw new Error('Application não iniciado');
                    }

                    return _skApplication;
                }
            };

            return self;
        }];
    })
    .provider('SkApplicationInstance', function () {
        this.$get = ['SkApplication', function (SkApplication) {
            return SkApplication.instance();
        }];
    });

angular
    .module('snk.core.directives')
    .directive('skDisabled', function ($animate) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    const DISABLED_CLASS = 'sk-disabled';

                    scope.$watch(attrs.skDisabled, function(newValue) {
                        $animate[newValue ? 'addClass' : 'removeClass'](element, DISABLED_CLASS);
                    });
                }
            };
        }
    );
/**
 * @ngdoc directive
 * @name snk.components.load.directive:sk-load
 * @restrict A
 * @description
 * A diretiva 'skLoad' permite você registrar uma função para ser executada no momento em que o elemento for carregado.
 *
 */
angular
    .module('snk.core.directives')
    .directive('skUid', ['AngularUtil', 'SkComponentRegistry', function (AngularUtil, SkComponentRegistry) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {

                var id = attrs['skUid'];
                var controller = AngularUtil.getControllerFromElement(elem);

                if(controller && id){
                    SkComponentRegistry.register(controller, id, scope, true);
                }else{
                    console.warn('[skUid] Erro ao obter' + (controller == undefined ? " o controller ": " o ID ")  + " do componente: " + elem[0].tagName  + (id != undefined ? (" ID : " + id) : "") );
                }

            }
        };
    }]);
/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-margin
 * @restrict A
 * @description
     Componente que adiciona margem no elemento, seguindo os padrões do CSS
 * @example
     <example module="marginExample">
         <file name="marginExample.html">
            <span sk-margin="0 10px">Texto</span>
         </file>
         <file name="marginExample.js">
            angular
                .module('marginExample', ['snk']);
         </file>
     </example>
 */

/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-padding
 * @restrict A
 * @description
     Componente que adiciona padding no elemento, seguindo os padrões do CSS
 * @example
     <example module="paddingExample">
         <file name="paddingExample.html">
            <span sk-padding="10px">Texto</span>
         </file>
         <file name="paddingExample.js">
            angular
                .module('paddingExample', ['snk']);
         </file>
     </example>
 */


[
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingLeft',
    'paddingBottom',

    'margin',
    'marginTop',
    'marginRight',
    'marginLeft',
    'marginBottom',

    'minHeight',
    'height',
    'minWidth',
    'width',

    'overflow',
    'overflowX',
    'overflowY'
]
.forEach(function(directiveAttr) {
    var propertyCapitalCase = directiveAttr.substr(0, 1).toUpperCase() + directiveAttr.substr(1, directiveAttr.length);
    var directiveName = 'sk' + propertyCapitalCase;

    angular
        .module('snk.core.directives')
        .directive(directiveName, ['StringUtils', function(StringUtils) {
            return {
                restrict: 'A',
                compile: function($element, $attr) {
                    if ($attr.hasOwnProperty('skDisableAttr' + propertyCapitalCase)) {
                        return;//Significa que esse attr sk-width, etc, está apenas sendo passado como attr, e não para colocarmos o estilo
                    }

                    var values = $attr[directiveName];
                    $element.css(StringUtils.toDashCase(directiveAttr), values);
                }
            };
        }]);
});
/**
  * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-color
 * @restrict A
 * @description
     Componente que adiciona color no elemento, seguindo os padrões do CSS do framework
 * @example
     <example module="colorExample">
         <file name="colorExample.html">
            <sk-vbox ng-controller="ColorController" sk-bg-color="white">
                <span sk-margin="5px" ng-repeat="color in AVAILABLE_COLORS" sk-color="{{color}}">{{color}}</span>
            </sk-vbox>
         </file>
         <file name="colorExample.js">
            angular
                .module('colorExample', ['snk'])
                .controller('ColorController', function($scope, ThemeColors){
                    $scope.AVAILABLE_COLORS = ThemeColors.getColors();
                });
         </file>
     </example>
 */

/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-bg-color
 * @restrict A
 * @description
     Componente que adiciona background-color no elemento, seguindo os padrões do CSS do framework
 * @example
     <example module="bgColorExample">
         <file name="bgColorExample.html">
            <sk-vbox ng-controller="BGColorController" sk-bg-color="white">
                <span sk-margin="5px" ng-repeat="color in AVAILABLE_COLORS" sk-color="white" sk-bg-color="{{color}}">{{color}}</span>
            </sk-vbox>
         </file>
         <file name="bgColorExample.js">
            angular
                .module('bgColorExample', ['snk'])
                .controller('BGColorController', function($scope, ThemeColors){
                    $scope.AVAILABLE_COLORS = ThemeColors.getColors();
                });
         </file>
     </example>
 */

[
    {directiveName: 'skBgColor', cssProp: 'background-color'},
    {directiveName: 'skBgColorHover', cssProp: 'background-color'},
    {directiveName: 'skBorderColor', cssProp: 'border-color'},
    {directiveName: 'skColor', cssProp: 'color'},
]
.forEach(function(directiveMD) {
    var REGEX_VALUES = /(\b\d+)(\w*)/g;
    var DEAULT_UNIT = 'px';

    angular
        .module('snk.core.directives')
        .directive(directiveMD.directiveName, ['StringUtils', 'ThemeColors', function(StringUtils, ThemeColors) {
            return {
                restrict: 'A',
                link: function($scope, $element, $attr) {
                    var IMPORTANT_RULE = '-important';

                    $attr.$observe(directiveMD.directiveName, updateColor);
                    
                    var _currentClass;
                    var _useImportant;

                     if (directiveMD.directiveName == 'skBgColorHover') {
                        $element.on('mouseenter', onMouseEnter);
                        $element.on('mouseleave', onMouseLeave);
                     }

                	function updateColor() {
                		var value = $attr[directiveMD.directiveName];

                        var importantIndex = value.indexOf(IMPORTANT_RULE);
                        
                        if (importantIndex > -1) {
                            value = value.substring(0, importantIndex);
                            _useImportant = true;
                        } else {
                            _useImportant = false;
                        }

                        if (ThemeColors.isValidColor(value)) {
                        	var methodName;
                        	
                        	if (directiveMD.directiveName == 'skColor') {
                        		methodName = 'getTextColorClass';
                        	} else if (directiveMD.directiveName == 'skBorderColor') {
                        		methodName = 'getBorderColorClass';
                        	} else {
                        		methodName = 'getBgColorClass';
                        	}

                            _currentClass = ThemeColors[methodName](value);

                            _currentClass += (_useImportant ? IMPORTANT_RULE : '');

                            if (directiveMD.directiveName != 'skBgColorHover') {
                                $element.addClass(_currentClass);
                            }
                        } else {
                            $element.css(directiveMD.cssProp, value);
                        }
                	}

                    function onMouseEnter() {
                        $element.addClass(_currentClass);
                    }

                    function onMouseLeave() {
                        $element.removeClass(_currentClass);
                    }
                }
            };
        }]);

});
/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-font-size
 * @restrict A
 * @description
     Componente que altera o tamanho da fonte do elemento, seguindo os padrões do CSS
 * @example
     <example module="fontSizeExample">
         <file name="fontSizeExample.html">
            <span sk-font-size="10px">Texto</span>
         </file>
         <file name="fontSizeExample.js">
            angular
                .module('fontSizeExample', ['snk']);
         </file>
     </example>
 */

/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-overflow
 * @restrict A
 * @description
     Componente que altera o overflow do elemento, seguindo os padrões do CSS
     Também disponível o sk-overflow-*, sendo "*" = x ou y
*/


/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-border
 * @restrict A
 * @description
     Componente que altera o border do elemento, seguindo os padrões do CSS
     Também disponível o sk-border-*, sendo "*" = left, right, top ou bottom
*/

/**
 * @ngdoc directive
 * @name snk.core.directives.layout.directive:sk-position
 * @restrict A
 * @description
     Componente que altera a posição do elemento, seguindo os padrões do CSS
     static, relative, fixed, absolute, sticky
*/
[
    'fontSize',
    'fontWeight',
    
    'overflow',
    'overflowX',
    'overflowY',

    'border',
    'borderWidth',
    'borderRight',
    'borderLeft',
    'borderTop',
    'borderBottom',

    'borderRadius',

    'position',
    
    'display'
].forEach(function (directiveAttr) {
    var directiveName = 'sk' + directiveAttr.substr(0, 1).toUpperCase() + directiveAttr.substr(1, directiveAttr.length);

    angular
        .module('snk.core.directives')
        .directive(directiveName, ['StringUtils', function (StringUtils) {
            return {
                restrict: 'A',
                compile: function ($element, $attr) {
                    var value = $attr[directiveName];

                    if (value) {
                        $element.css(StringUtils.toDashCase(directiveAttr), value);
                    }
                }
            };
        }]);
});
angular
    .module('snk.core.directives')
    .config(['$provide', function($provide){
        $provide.decorator('ngClickDirective', ['$delegate', '$parse', '$timeout', '$rootElement', function($delegate, $parse, $timeout, $rootElement) {
            $delegate[0].compile = function(element, attr){
                var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
                var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
                var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
                var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.

                var ACTIVE_CLASS_NAME = 'ng-click-active';
                var lastPreventedTime;
                var touchCoordinates;
                var lastLabelClickCoordinates;

                //Ignorar prevent para aggrid
                const IGNORE_PREVENT_ITEMS = [{ attributeName: 'role', attributeValue: 'gridcell' }];


                // TAP EVENTS AND GHOST CLICKS
                //
                // Why tap events?
                // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
                // double-tapping, and then fire a click event.
                //
                // This delay sucks and makes mobile apps feel unresponsive.
                // So we detect touchstart, touchcancel and touchend ourselves and determine when
                // the user has tapped on something.
                //
                // What happens when the browser then generates a click event?
                // The browser, of course, also detects the tap and fires a click after a delay. This results in
                // tapping/clicking twice. We do "clickbusting" to prevent it.
                //
                // How does it work?
                // We attach global touchstart and click handlers, that run during the capture (early) phase.
                // So the sequence for a tap is:
                // - global touchstart: Sets an "allowable region" at the point touched.
                // - element's touchstart: Starts a touch
                // (- touchcancel ends the touch, no click follows)
                // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
                //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
                // - preventGhostClick() removes the allowable region the global touchstart created.
                // - The browser generates a click event.
                // - The global click handler catches the click, and checks whether it was in an allowable region.
                //     - If preventGhostClick was called, the region will have been removed, the click is busted.
                //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
                //       other elements without ngTap on them work normally.
                //
                // This is an ugly, terrible hack!
                // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
                // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
                // encapsulates this ugly logic away from the user.
                //
                // Why not just put click handlers on the element?
                // We do that too, just to be sure. If the tap event caused the DOM to change,
                // it is possible another element is now in that position. To take account for these possibly
                // distinct elements, the handlers are global and care only about coordinates.

                // Checks if the coordinates are close enough to be within the region.
                function hit(x1, y1, x2, y2) {
                    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
                }

                // Checks a list of allowable regions against a click location.
                // Returns true if the click should be allowed.
                // Splices out the allowable region from the list after it has been used.
                function checkAllowableRegions(touchCoordinates, x, y) {
                    for (var i = 0; i < touchCoordinates.length; i += 2) {
                        if (hit(touchCoordinates[i], touchCoordinates[i + 1], x, y)) {
                            touchCoordinates.splice(i, i + 2);
                            return true; // allowable region
                        }
                    }
                    return false; // No allowable region; bust it.
                }

                function nodeName_(element) {
                    return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
                }

                // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
                // was called recently.
                function onClick(event) {
                    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
                        return; // Too old.
                    }

                    var touches = event.touches && event.touches.length ? event.touches : [event];
                    var x = touches[0].clientX;
                    var y = touches[0].clientY;
                    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
                    // and on the input element). Depending on the exact browser, this second click we don't want
                    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
                    // click event
                    if (x < 1 && y < 1) {
                        return; // offscreen
                    }
                    if (lastLabelClickCoordinates &&
                        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
                        return; // input click triggered by label click
                    }
                    // reset label click coordinates on first subsequent click
                    if (lastLabelClickCoordinates) {
                        lastLabelClickCoordinates = null;
                    }
                    // remember label click coordinates to prevent click busting of trigger click event on input
                    if (nodeName_(event.target) === 'label') {
                        lastLabelClickCoordinates = [x, y];
                    }

                    // Look for an allowable region containing this click.
                    // If we find one, that means it was created by touchstart and not removed by
                    // preventGhostClick, so we don't bust it.
                    if (checkAllowableRegions(touchCoordinates, x, y)) {
                        return;
                    }

                    // If we didn't find an allowable region, bust the click.   
                    if(!isIgnorePrevent(event.target)){
                        event.stopPropagation();
                        event.preventDefault();
                    }

                    // Blur focused form elements
                    event.target && event.target.blur && event.target.blur();
                }
                /**
                 * Isso foi necessário pois no componente ag-grid(js nativo) a ação de clique duplo deve ser
                 * propagada, caso contario o componente perde algumas funcionalidades no mobile.
                 */
                function isIgnorePrevent(element){
                    var ignorePrevent = false;
                    for(i = 0; i < IGNORE_PREVENT_ITEMS.length; i++){
                        var toIgnore = IGNORE_PREVENT_ITEMS[i];
                        ignorePrevent = element.getAttribute(toIgnore.attributeName) == toIgnore.attributeValue;
                        if(ignorePrevent) break;
                    }
                    return ignorePrevent;
                }


                // Global touchstart handler that creates an allowable region for a click event.
                // This allowable region can be removed by preventGhostClick if we want to bust it.
                function onTouchStart(event) {
                    var touches = event.touches && event.touches.length ? event.touches : [event];
                    var x = touches[0].clientX;
                    var y = touches[0].clientY;
                    touchCoordinates.push(x, y);

                    $timeout(function() {
                        // Remove the allowable region.
                        for (var i = 0; i < touchCoordinates.length; i += 2) {
                            if (touchCoordinates[i] == x && touchCoordinates[i + 1] == y) {
                            touchCoordinates.splice(i, i + 2);
                            return;
                            }
                        }
                    }, PREVENT_DURATION, false);
                }

                // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
                // zone around the touchstart where clicks will get busted.
                function preventGhostClick(x, y) {
                    if (!touchCoordinates) {
                        $rootElement[0].addEventListener('click', onClick, true);
                        $rootElement[0].addEventListener('touchstart', onTouchStart, true);
                        touchCoordinates = [];
                    }

                    lastPreventedTime = Date.now();

                    checkAllowableRegions(touchCoordinates, x, y);
                }

                // Actual linking function.
                return function(scope, element, attr) {
                    var clickHandler = $parse(attr.ngClick),
                        tapping = false,
                        tapElement,  // Used to blur the element after a tap.
                        startTime,   // Used to check if the tap was held too long.
                        touchStartX,
                        touchStartY;

                    function resetState() {
                        tapping = false;
                        element.removeClass(ACTIVE_CLASS_NAME);
                    }

                    element.on('touchstart', function(event) {
                        tapping = true;
                        tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
                        // Hack for Safari, which can target text nodes instead of containers.
                        if (tapElement.nodeType == 3) {
                            tapElement = tapElement.parentNode;
                        }

                        element.addClass(ACTIVE_CLASS_NAME);

                        startTime = Date.now();

                        // Use jQuery originalEvent
                        var originalEvent = event.originalEvent || event;
                        var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
                        var e = touches[0];
                        touchStartX = e.clientX;
                        touchStartY = e.clientY;
                    });

                    element.on('touchcancel', function(event) {
                        resetState();
                    });

                    element.on('touchend', function(event) {
                        var diff = Date.now() - startTime;

                        // Use jQuery originalEvent
                        var originalEvent = event.originalEvent || event;
                        var touches = (originalEvent.changedTouches && originalEvent.changedTouches.length) ?
                            originalEvent.changedTouches :
                            ((originalEvent.touches && originalEvent.touches.length) ? originalEvent.touches : [originalEvent]);
                        var e = touches[0];
                        var x = e.clientX;
                        var y = e.clientY;
                        var dist = Math.sqrt(Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2));

                        if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
                            // Call preventGhostClick so the clickbuster will catch the corresponding click.
                          if (!tapElement || tapElement.tagName.toLowerCase() != 'input') {
                            preventGhostClick(x, y);
                          }


                            // Blur the focused element (the button, probably) before firing the callback.
                            // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
                            // I couldn't get anything to work reliably on Android Chrome.
                            if (tapElement && tapElement.tagName.toLowerCase() != 'input') {
                                tapElement.blur();
                            }

                            if (!element.data('skDisableClick')){
                                if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
                                    element.triggerHandler('click', [event]);
                                }
                            }
                        }

                        resetState();
                    });

                    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
                    // something else nearby.
                    element.onclick = function(event) { };

                    // Actual click handler.
                    // There are three different kinds of clicks, only two of which reach this point.
                    // - On desktop browsers without touch events, their clicks will always come here.
                    // - On mobile browsers, the simulated "fast" click will call this.
                    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
                    // Therefore it's safe to use this directive on both mobile and desktop.
                    element.on('click', function(event, touchend) {
                        if (element.data('skDisableClick') == true){
                            return;
                        }

                        scope.$apply(function() {
                            clickHandler(scope, {$event: (touchend || event)});
                        });
                    });

                    element.on('mousedown', function(event) {
                         element.addClass(ACTIVE_CLASS_NAME);
                    });

                    element.on('mousemove mouseup', function(event) {
                        element.removeClass(ACTIVE_CLASS_NAME);
                    });

                };
            };

            return $delegate;
        }]);
    }]);
/*
 author: bruno.machado

 /**
 Esta diretiva de transclusão deve ser utilizada no lugar do ng-transclude.
 O que ela faz é compilar a transclusão no contexto do componente e não
 no contexto de onde o componente será inserido.

 Portanto, funções definidas em uma tela, por exemplo, não funcionam dentro do transclude.
 Para que isso funcione deve-se bindar o controlador principal/funções no escopo do componente
 onde essa diretiva será usada (Verificar exemplo skTwoLists).
 */

angular
    .module('snk.core.directives')
    .directive('skComponentTransclude', function () {
        return {
            link: function ($scope, $element, $attrs, $controllers, $transclude) {
                if (!$transclude) {
                    throw Error('Uso indevido da diretiva skComponentTransclude. A diretiva parent não possui transclusão');
                }

                var transcludeScope = $scope.$new();

                $transclude(transcludeScope, function (clone) {
                    $element.empty();

                    $element.append(clone);

                    $element.on('$destroy', function () {
                        transcludeScope.$destroy();
                    });
                }, undefined, $attrs['skComponentTransclude']);
            }
        };
    });
angular
    .module('snk.core.directives')
    .directive('skVisible', function($animate) {
        var INVISIBLE_CLASS = 'sk-visibility-hidden';
        var INVISIBLE_CLASS_IN_PROGRESS = 'sk-visibility-hidden-animate';

        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                scope.$watch(attr.skVisible, function(value){

                    $animate[value ? 'removeClass' : 'addClass'](element, INVISIBLE_CLASS, {
                        tempClasses: INVISIBLE_CLASS_IN_PROGRESS
                    });

                });
            }
        };
    });
var _moduleUpdatingTimestamp = 0;
var _MODULE_UPDATING_WINDOW = 5000;

angular
    .module('snk.core.exceptionhandler')
    .factory('$exceptionHandler', ['$injector', function ($injector) {
        var MessageUtils;
        var SkI18nService;
        
        function changeDisplayCurtainTour(newValue){
            return  document.querySelectorAll('#ng-curtain').forEach(function(el){
                el.style.display = newValue
            });
        }

        return function errorCatcherHandler(exception, cause) {
            MessageUtils = MessageUtils || $injector.get('MessageUtils');
            SkI18nService = SkI18nService || $injector.get('SkI18nService');

            // Suprime erros que ocorrem durante a janela de atualização de módulo.
            // O HttpExceptionHandler registra o timestamp ao detectar 503 com header x-skw-module-updating.
            // Erros subsequentes (ex: $compile:tpload) são consequência da atualização e não devem gerar popup.
            if (exception?.moduleUpdating || ((Date.now() - _moduleUpdatingTimestamp) < _MODULE_UPDATING_WINDOW)) {
                console.warn('[ExceptionHandler] Erro suprimido: módulo em atualização.', exception && exception.message);
                return;
            }

            var isAlert = (exception.name == 'AlertError');
            var isErrorAlert = (exception.name == 'MessageError');

            var messageType = isAlert ? 'showAlert': 'showError';
            var title;

            if (!exception.title){
                title = isAlert ? MessageUtils.TITLE_WARNING : MessageUtils.TITLE_ERROR;
            } else {
                title = SkI18nService.instant(exception.title);
            }
            
            /*  
	            Tratativa para quando existir um tour na tela, sem isso a mensagem de erro ficava bloqueada
	            por conta do curtain do tour.
	        */
	        changeDisplayCurtainTour('none');

            /*
                Tratativa para mistura de contexto do js com o GWT, no caso de mensagem gerada pelo MessageUtils do GWT este listener tratava como
                exception do javascript, gerando popup na tela
            */
            const isComputedGWTStyleError = exception != undefined && exception.message && exception.message.indexOf('getComputedStyle') > -1;

            if(!isComputedGWTStyleError){
                MessageUtils[messageType](title, SkI18nService.instant(exception.message, exception.messageValues));
            }

            if (isErrorAlert || isAlert){
                console.error(exception.stack);
            } else {
                console.error(exception);
            }
        };
    }])
    .factory('HttpExceptionHandler', ['$q', '$injector', function ($q, $injector) {
        var SERVICE_UNAVAILABLE = 503;
        var MODULE_UPDATING_HEADER = 'x-skw-module-updating';

        return {
            responseError: function responseError(rejection) {
                if (rejection.status === SERVICE_UNAVAILABLE) {
                    // rejection.headers pode ser função (callback $http) ou objeto simples ($templateRequest)
                    var isModuleUpdating = rejection.headers
                        ? (typeof rejection.headers === 'function'
                            ? rejection.headers(MODULE_UPDATING_HEADER)
                            : rejection.headers[MODULE_UPDATING_HEADER])
                        : null;

                    if (isModuleUpdating) {
                        _moduleUpdatingTimestamp = Date.now();
                        var MessageUtils = $injector.get('MessageUtils');
                        MessageUtils.showModuleUpdatingWarn();
                        rejection.moduleUpdating = true;
                    }
                }

                return $q.reject(rejection);
            }
        };
    }]);
/**
var app3 = angular.module('app3', []);
app3.service('Service3', function(){
  this.metodo = function(){
    return 'World';
  }
});


var app2 = angular.module('app2', ['app3']);
app2.service('Service2', function(Service3){
  this.metodo = function(){
    return Service3.metodo();
  }
});


var app = angular.module('app', []);
app.config(function($SkInjectorProvider) {
  $SkInjectorProvider.register(app, 'plunker2');
});
app.controller('MainCtrl', function($scope, Service2) {
  $scope.name = Service2.metodo();
});

http://plnkr.co/edit/tPmNNdJVM5roh1slo6hQ?p=preview
**/

angular
    .module('snk')
    .config(['$httpProvider', '$controllerProvider', '$compileProvider', '$filterProvider', '$provide', '$injector', '$SkInjectorProvider',
        function ($httpProvider, $controllerProvider, $compileProvider, $filterProvider, $provide, $injector, $SkInjectorProvider) {
            $httpProvider.useApplyAsync(true);

            $SkInjectorProvider.setProviders({
                $provide: $provide,
                $controllerProvider: $controllerProvider,
                $compileProvider: $compileProvider,
                $filterProvider: $filterProvider,
                $injector: $injector
            });
        }
    ])
    .provider('$SkInjector', function () {
        var _providers;

        this.$get = function(){throw new Error('Este injector deve ser usado apenas em configurações de módulos.')};
        this.register = register;

        this.setProviders = function (providers) {
            _providers = providers;
        };

        function register(module, depNames) {
            if (!angular.isArray(depNames)) {
                depNames = [depNames];
            }

            depNames.forEach(function (depName) {
                angular.injector(['ng', depName], false);

                module.requires.push(depName);

                var depModule = angular.module(depName);

                runInvokeQueue(depModule._invokeQueue);
                runInvokeQueue(depModule._configBlocks);

                depModule.requires.forEach(function (depModName) {
                    register(depModule, depModName);
                });
            });
        }

        function runInvokeQueue(queue) {
            var i, ii;
            for (i = 0, ii = queue.length; i < ii; i++) {
                var invokeArgs = queue[i];
                var provider = _providers[invokeArgs[0]];
                var fn = provider[invokeArgs[1]];

                fn.apply(this, invokeArgs[2]);
            }
        }
    });
angular
    .module('snk.core.loadingbar')
    .provider('SnkLoadingBar', function () {

        this.autoIncrement = false;
        this.includeSpinner = false;
        this.includeBar = true;
        this.latencyThreshold = 25;
        this.startSize = 0.02;
        this.parentSelector = 'body';
        this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
        this.loadingBarTemplate = '<div class="sk-loading-bar">'
                                        + '<div class="bar-container">'
                                            + '<div class="bar1"></div>'
                                            + '<div class="bar2"></div>'
                                        + '</div>'
                                    + '</div>';

        this.$get = ['$injector', '$document', '$timeout', '$rootScope', '$q', function ($injector, $document, $timeout, $rootScope, $q) {
            //var $animate;
        	
            var $parentSelector = this.parentSelector,
                loadingBarContainer = angular.element(this.loadingBarTemplate),
                loadingBar = loadingBarContainer.find('div').eq(0),
                spinner = angular.element(this.spinnerTemplate);

            var incTimeout,
                completeTimeout,
                started = false,
                status = 0;

            //var autoIncrement = this.autoIncrement;^
            
            //var includeSpinner = this.includeSpinner;
            //var includeBar = this.includeBar;
            //var startSize = this.startSize;

            /**
             * Inserts the loading bar element into the dom, and sets it to 2%
             */
            function _start() {
                //if (!$animate) {
                //    $animate = $injector.get('$animate');
                //}

                var $parent = $document.find($parentSelector).eq(0);
                $timeout.cancel(completeTimeout);

                // do not continually broadcast the started event:
                if (started) {
                    return;
                }

                $rootScope.$broadcast('SnkLoadingBar:started');
                started = true;

                //if (includeBar) {
                    $parent.prepend(loadingBarContainer);
                //}

                //_set(startSize);
            }

            /**
             * Set the loading bar's width to a certain percent.
             *
             * @param n any value between 0 and 1
             */
            function _set(n) {
                /*//Para sempre mostrar em 100%
                n = 1;

                if (!started) {
                    return;
                }

                var pct = (n * 100) + '%';
                loadingBar.css('width', pct);
                status = n;

                // increment loadingbar to give the illusion that there is always
                // progress but make sure to cancel the previous timeouts so we don't
                // have multiple incs running at the same time.
                if (autoIncrement) {
                    $timeout.cancel(incTimeout);
                    incTimeout = $timeout(function () {
                        _inc();
                    }, 250, false);
                }*/
            }

            /**
             * Increments the loading bar by a random amount
             * but slows down as it progresses
             */
            function _inc() {
                /*if (_status() >= 1) {
                    return;
                }

                var rnd = 0;

                var stat = _status();
                if (stat >= 0 && stat < 0.25) {
                    // Start out between 3 - 6% increments
                    rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
                } else if (stat >= 0.25 && stat < 0.65) {
                    // increment between 0 - 3%
                    rnd = (Math.random() * 3) / 100;
                } else if (stat >= 0.65 && stat < 0.9) {
                    // increment between 0 - 2%
                    rnd = (Math.random() * 2) / 100;
                } else if (stat >= 0.9 && stat < 0.99) {
                    // finally, increment it .5 %
                    rnd = 0.005;
                } else {
                    // after 99%, don't increment:
                    rnd = 0;
                }

                var pct = _status() + rnd;
                _set(pct);*/
            }

            function _status() {
                return status;
            }

            function _completeAnimation() {
                status = 0;
                started = false;
            }

            function _complete() {
                /*if (!$animate) {
                    $animate = $injector.get('$animate');
                }

                $rootScope.$broadcast('SnkLoadingBar:completed');
                _set(1);*/

                $timeout.cancel(completeTimeout);

                // Attempt to aggregate any start/complete calls within 500ms:
                completeTimeout = $timeout(function () {
                    loadingBarContainer.detach();

                    _completeAnimation();
                    //var promise = $animate.leave(loadingBarContainer, _completeAnimation);

                    //if (promise && promise.then) {
                    //    promise.then(_completeAnimation);
                    //}

                    //$animate.leave(spinner);
                }, 500, false);               
            }

            function _startWhithPromisse() {
                
                return $q(function(resolve, reject){
                    var $parent = $document.find($parentSelector).eq(0);
                    $timeout.cancel(completeTimeout);
                    if (started) {
                        resolve();
                    }
                    $rootScope.$broadcast('SnkLoadingBar:started');
                    started = true;
                    $parent.prepend(loadingBarContainer);
                    resolve();
                });

            }

            return {
                start: _start,
                set: _set,
                status: _status,
                inc: _inc,
                complete: _complete,
                startWhithPromisse: _startWhithPromisse,
                autoIncrement: this.autoIncrement,
                includeSpinner: this.includeSpinner,
                latencyThreshold: this.latencyThreshold,
                parentSelector: this.parentSelector,
                startSize: this.startSize
            };


        }];
    });
/**
 * @ngdoc service
 * @name snk.db.metadataprovider.service:MetadataProvider
 * @description
 * # rest
 * Service to talk with backend api.
 */
angular
    .module('snk.core.metadataprovider', ['snk.core.util'])
    .service('MetadataProvider', ['$q', '$http', '$log', 'MessageUtils', 'ObjectUtils', 'SkI18nService',
        function ($q, $http, $log, MessageUtils, ObjectUtils, SkI18nService) {
            var mp = top.mdProvider = this;

            mp.getEntityMetadata = getEntityMetadata;
            mp.getEntityAndRelationsMetadata = getEntityAndRelationsMetadata;
            mp.getSizeOfCache = getSizeOfCache;
 
            var _useInternalCache = false;

            var cache = new EntityMetadataCache();

            var pendingEntityRequests = {};
//            var pendingEntityRequests;
//
//            if (top.metadataprovider_pendingEntityRequests) {
//                pendingEntityRequests = top.metadataprovider_pendingEntityRequests;
//            } else {
//                pendingEntityRequests = top.metadataprovider_pendingEntityRequests = {};
//            }

            function isMetadataLoading(entityName) {
                return angular.isDefined(pendingEntityRequests[entityName]);
            }

            function getSizeOfCache() {
                return cache.getSizeOfCache();
            }

            function getLocale() {
                return SkI18nService.getLang();
            }

            function getFullEntityName(entity) {
                return entity + '-' + getLocale();
            }

            function normalizeEntityNames(entityNames) {
                if (!angular.isArray(entityNames)) {
                    if (angular.isString(entityNames)) {
                        entityNames = entityNames.split(',');
                    } else {
                        entityNames = [entityNames];
                    }
                }

                var parsedEntityNames = [];

                for (var index in entityNames) {
                    parsedEntityNames[index] = getFullEntityName(entityNames[index]);
                }

                return parsedEntityNames;
            }

            /**
             * @ngdoc
             * @name snk.db.metadataprovider.service:MetadataProvider#getEntityMetadata
             * @methodOf snk.db.metadataprovider.service:MetadataProvider
             *
             * @description
             * Method to get data form the backend api
             * @example
             * rest.get(id);
             * @param {int} entity id
             * @returns {httpPromise} resolve with fetched data, or fails with error description.
             */
            function getEntityMetadata(entityNames) {
                entityNames = normalizeEntityNames(entityNames);

                if (_useInternalCache && cache.existsAllOnCache(entityNames)){
                    return $q(function (resolve) {
                        resolve(cache.getExistentFromCache(entityNames));
                    });
                }

                var entitiesForRequest;

                if (_useInternalCache) {
                    entitiesForRequest = cache.getNonExistentOnCache(entityNames);
                } else {
                    entitiesForRequest = entityNames;
                }

                var requestsPromises = [];

                entitiesForRequest.forEach(function (entity) {

                    var promise;

                    if (isMetadataLoading(entity)) {
                        promise = pendingEntityRequests[entity];
                    } else {
                        var requestUrl = '/mge/metadataProvider.mge/' + entity + '.js';

                        var req = {
                            method: 'GET',
                            url: requestUrl,
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        };

                        var deffered = $q.defer();

                        $http(req)
                            .success(function (data) {
                                    if (data.hasOwnProperty('$error')) {
                                        var errorMsg = "Erro interno</br>Não foi possível resolver os metadados da entidade '"+ entity + "'.";

                                        if (data.$error) {
                                            errorMsg += ('</br>' + data.$error);
                                        }

                                        throw Error(errorMsg);
                                    }

                                    var tableName = data.tableName;

                                    if (_useInternalCache){
                                        //Como fazemos cache por entidade, porém várias entidades podem representar a mesma tabela
                                        //guardamos o cache de fields por tableName

                                        var fields = data.fields;

                                        if (!delete data.fields) {
                                            throw new Error('Não foi possível deletar a propriedade \'fields\' do metadado da entidade.');
                                        }

                                        cache.putTableOnCache(tableName, fields);
                                        cache.putEntityOnCache(entity, data);
                                    }

                                    deffered.resolve(data);
                            })
                            .error(function (data, status, headers, config) {
                                var err = new Error('[MDProvider] Falha ao obter metadados da entidade: ' + entity + ' | Status: ' + status);
                                deffered.reject(err);
                            }).finally(function () {
                                delete pendingEntityRequests[entity];
                            });

                        promise = deffered.promise;

                        pendingEntityRequests[entity] = promise;
                    }

                    requestsPromises.push(promise);
                });

                return $q.all(requestsPromises).then(function (arrayOfResults) {
                    return $q(function (resolve) {

                        if (_useInternalCache){
                            resolve(cache.getExistentFromCache(entityNames));
                        }else {
                            var entities = {};

                            for (var index in arrayOfResults) {
                                var entity = arrayOfResults[index];
                                entities[entity.name] = angular.copy(entity);
                            }

                            resolve(entities);
                        }
                    });
                });

            }

            function showError(err){
                MessageUtils.showError(MessageUtils.TITLE_ERROR, err.message);
                console.error(err);
            }

            function getEntityAndRelationsMetadata(entityNames, filterFunction, includeOneToMany){
                var deffered = $q.defer();

                getEntityMetadata(entityNames)
                    .then(function(entitiesMetadata){
                        var result = {
                            entities: entitiesMetadata,
                            relations: {},
                            oneToManyRelations: {}
                        };

                        var relations = getRelations(entitiesMetadata, filterFunction);

                        var promises = [];
                        var hasOneToOne = false;
                        var hasOneToMany = false;

                        if (relations.oneToOneRelations.length > 0){
                            promises.push(getEntityMetadata(relations.oneToOneRelations));
                            hasOneToOne = true;
                        }

                        if (includeOneToMany && relations.oneToManyRelations.length > 0){
                            promises.push(getEntityMetadata(relations.oneToManyRelations));
                            hasOneToMany = true;
                        }

                        if (promises.length > 0){
                            $q.all(promises).then(function(resultRelations){
                                if (hasOneToOne && hasOneToMany){
                                    result.relations = resultRelations[0];
                                    result.oneToManyRelations = resultRelations[1];
                                } else if (hasOneToOne) {
                                    result.relations = resultRelations[0];
                                } else {
                                    result.oneToManyRelations = resultRelations[0];
                                }

                                deffered.resolve(result);
                            }, function(error){
                                deffered.reject(error);
                            });
                        } else {
                            deffered.resolve(result);
                        }
                    }, function(error){
                        deffered.reject(error);
                    });

                return deffered.promise;
            }

            function getRelations(entitiesMetadata, filterFunction) {
                var oneToOneRelations = [];
                var oneToManyRelations = [];

                ObjectUtils.forEachInObject(entitiesMetadata,
                    function (entityName, entity) {
                        if (angular.isDefined(entity['relations'])) {

                            for (var i = 0; i < entity.relations.length; i++){
                                var relation = entity.relations[i];

                                if (relation.type == '1-N'){
                                    oneToManyRelations.push(relation.toEntity);
                                }
                            }

                            if(!entity.simpleRelations){
                                entity.fields.forEach(function (field) {
                                    if (angular.isDefined(field['fk']) && (angular.isUndefined(filterFunction) || filterFunction(entity, field))) {
                                        oneToOneRelations.push(field.fk.relationShipName);
                                    }
                                });
                            }
                        }
                    });



                return {
                    oneToOneRelations : oneToOneRelations,
                    oneToManyRelations: oneToManyRelations
                };
            }

            function EntityMetadataCache() {
                var self = this;

                self.entityMDCache = {};
                self.tableMDCache = {};

                self.getFromCache = getFromCache;
                self.putEntityOnCache = putEntityOnCache;
                self.putTableOnCache = putTableOnCache;
                self.existsOnCache = existsOnCache;
                self.existsAllOnCache = existsAllOnCache;
                self.getNonExistentOnCache = getNonExistentOnCache;
                self.getExistentFromCache = getExistentFromCache;
                self.getSizeOfCache = getSizeOfCache;

                function getSizeOfCache() {
                    return ObjectUtils.sizeOf(self.entityMDCache);
                }

                function getFromCache(entityName) {
                    var entity = angular.copy(self.entityMDCache[entityName]);
                    entity.fields = angular.copy(self.tableMDCache[entity.tableName]);
                    return entity;
                }

                function putEntityOnCache(entityName, entityMetadata) {
                    self.entityMDCache[entityName] = entityMetadata;
                }

                function putTableOnCache(tableName, tableMetadata) {
                    self.tableMDCache[tableName] = tableMetadata;
                }

                function existsOnCache(entityName) {
                    return angular.isDefined(self.entityMDCache[entityName]);
                }

                function existsAllOnCache(entityNames) {
                    for (var index in entityNames) {
                        if (!existsOnCache(entityNames[index])) {
                            return false;
                        }
                    }

                    return true;
                }

                function getNonExistentOnCache(entityNames) {
                    var nonExistent = [];

                    for (var index in entityNames) {
                        if (!existsOnCache(entityNames[index])) {
                            nonExistent.push(entityNames[index]);
                        }
                    }

                    return nonExistent;
                }

                function getExistentFromCache(entityNames) {
                    var entities = {};

                    for (var index in entityNames) {
                        if (existsOnCache(entityNames[index])) {
                            var entity = getFromCache(entityNames[index]);
                            entities[entity.name] = entity;
                        }
                    }

                    return entities;
                }
            }
        }]);

/**
 * @ngdoc service
 * @name snk.db.parameters.service:MGEParameters
 * @description
 * Serviço responsável pela obtenção de parâmetros enviados pelo servidor.
 */
angular
    .module('snk.core.parameters')
    .service('MGEParameters', ['SkApplication', 'StringUtils', 'Base64', 'MessageUtils', 'DateUtils', 'SkWorkspace', function (SkApplication, StringUtils, Base64, MessageUtils, DateUtils, SkWorkspace) {
        var	PARAM_SEPARATOR	= "__;__";
        var PARAM_ASSIGN	= "__=__";

        var self = this;

        var _loaded = false;
        var _parameters = {};

        self.asBoolean = asBoolean;
        self.asInteger = asInteger;
        self.asFloat = asFloat;
        self.asDate = asDate;
        self.asString = asString;
        self.setParamValue = setParamValue;
        self.getValueOrNull = getValueOrNull;

        function loadParameters(){
            var source = SkApplication.instance().getMgeParams();

            if (!StringUtils.isEmpty(source)) {
                source = StringUtils.replaceAll(source,'__mais__', '+');

                source = new String(Base64.decode(source));

                var strParams = source.split(PARAM_SEPARATOR);

                for (var i = 0, lenParams = strParams.length; i < lenParams; i++) {
                    var strParam = strParams[i].split(PARAM_ASSIGN);

                    _parameters[strParam[0]] = strParam[1];
                }
            }

            angular.forEach(SkWorkspace.getMockedParams(), function(value, key) {
                _parameters[key] = value;
            });

            _loaded = true;
        }

        function getParamenterValue(key) {
            let value = getValueOrNull(key);

            if (!_parameters.hasOwnProperty(key)) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, "Erro interno: O parâmetro " + key + " foi solicitado, mas não consta na lista declarada para esta tela.");
                
            }

            return value;
        }
        
        function getValueOrNull(key) {
            if (!_loaded){
                loadParameters();
            }

            return _parameters[key];
        }


        /**
         * @ngdoc
         * @name snk.db.parameters.service:MGEParameters#asBoolean
         * @methodOf snk.db.parameters.service:MGEParameters
         * @description Obtém o valor do parâmetro como um booleano.
         * @example <pre>MGEParameters.asBoolean('nome.do.parametro')</pre>
         * @param {string} key Nome do parâmetro que se deseja obter o valor.
         **/
         function asBoolean(key) {
            return 'S' == getParamenterValue(key);
        }

        /**
         * @ngdoc
         * @name snk.db.parameters.service:MGEParameters#asInteger
         * @methodOf snk.db.parameters.service:MGEParameters
         * @description Obtém o valor do parâmetro como um inteiro.
         * @example <pre>MGEParameters.asBoolean('nome.do.parametro')</pre>
         * @param {string} key Nome do parâmetro que se deseja obter o valor.
         **/
        function asInteger(key) {
            return parseInt(getParamenterValue(key));
        }

        /**
         * @ngdoc
         * @name snk.db.parameters.service:MGEParameters#asFloat
         * @methodOf snk.db.parameters.service:MGEParameters
         * @description Obtém o valor do parâmetro como um float.
         * @example <pre>MGEParameters.asBoolean('nome.do.parametro')</pre>
         * @param {string} key Nome do parâmetro que se deseja obter o valor.
         **/
        function asFloat(key) {
            return parseFloat(getParamenterValue(key));
        }

        /**
         * @ngdoc
         * @name snk.db.parameters.service:MGEParameters#asDate
         * @methodOf snk.db.parameters.service:MGEParameters
         * @description Obtém o valor do parâmetro como um Date.
         * @example <pre>MGEParameters.asBoolean('nome.do.parametro')</pre>
         * @param {string} key Nome do parâmetro que se deseja obter o valor.
         **/
        function asDate(key) {
            return DateUtils.strToDate(getParamenterValue(key));
        }

        /**
         * @ngdoc
         * @name snk.db.parameters.service:MGEParameters#asString
         * @methodOf snk.db.parameters.service:MGEParameters
         * @description Obtém o valor do parâmetro como uma String.
         * @example <pre>MGEParameters.asBoolean('nome.do.parametro')</pre>
         * @param {string} key Nome do parâmetro que se deseja obter o valor.
         **/
        function asString(key) {
            return getParamenterValue(key);
        }

        /**
         * @ngdoc
         * @name snk.db.parameters.service:MGEParameters#setParamValue
         * @methodOf snk.db.parameters.service:MGEParameters
         * @description Atribui o valor aos parametros em memória.
         * @example <pre>MGEParameters.setParamValue('nome.do.parametro', 'novo-valor')</pre>
         * @param {string} key Nome do parâmetro que se deseja setar o valor.
         * @param {string} value Novo valor para a chave repassada.
         **/
        function setParamValue(key, value) {
            _parameters[key] = value;
        }
    }]);
var module = angular.module('ngSelectiveDigest', [])

/**
 * @fileoverview
 * Defines an extension to angular.Scope that allows for registering
 * 'gating functions' on a scope that will prevent all future watchers
 * registered on the scope from being evaluated unless the gating function
 * returns true.
 *
 * By depending on this module, the $rootScope instance and angular.Scope
 * class are automatically extended to implement this new capability.
 *
 * Warning, this implementation depends on protected/private variables
 * in the angular.Scope implementation and therefore can break in the
 * future due to changes in the angular.Scope implementation.  Use at
 * your own risk.
 */
module.config(['$provide', function ($provide) {
    // We use a decorator to override methods in $rootScope.
    $provide.decorator('$rootScope', ['$delegate', '$exceptionHandler',
        function ($rootScope, $exceptionHandler) {

            // Make a copy of $rootScope's original methods so that we can access
            // them to invoke super methods in the ones we override.
            scopePrototype = {};
            for (var key in $rootScope) {
                if (angular.isFunction($rootScope[key]))
                    scopePrototype[key] = $rootScope[key];
            }

            var Scope = $rootScope.constructor;

            // Hold all of our new methods.
            var methodsToAdd = {};

            // A constant value that the $digest loop implementation depends on.  We
            // grab it down below.
            var initWatchVal;

            /**
             * @param {Boolean} isolate Whether or not the new scope should be isolated.
             * @returns {Scope} A new child scope
             */
            methodsToAdd.$new = function (isolate, parent) {
                // Because of how scope.$new works, the returned result
                // should already have our new methods.
                var result = scopePrototype.$new.call(this, isolate, parent);

                // We just have to do the work that normally a child class's
                // constructor would perform -- initializing our instance vars.
                result.$$scopeActive = true;
                result.$$gatingFunction = this.$$gatingFunction;
                result.$$parentGatingFunction = this.$$gatingFunction;
                result.$$shouldGateFunction = this.$$shouldGateFunction;
                result.$$gatedWatchers = [];

                return result;
            };

            /**
             * Digests all of the gated watchers for the specified gating function.
             *
             * @param {Function} targetGatingFunction The gating function associated
             *   with the watchers that should be digested
             * @returns {Boolean} True if any of the watchers were dirty
             */
            methodsToAdd.$digestGated = function gatedScopeDigest(targetGatingFunction) {
                // Note, most of this code was stolen from angular's Scope.$digest method.
                var watch, value,
                    watchers,
                    length,
                    next, current = this, target = this,
                    dirty = false;

                do { // "traverse the scopes" loop
                    if (watchers = current.$$gatedWatchers) {
                        // process our watches
                        length = watchers.length;
                        while (length--) {
                            try {
                                watch = watchers[length];
                                // Scalyr edit: We do not process a watch function if it is does not
                                // have the same gating function for which $digestGated was invoked.
                                if (watch.gatingFunction !== targetGatingFunction)
                                    continue;

                                // Most common watches are on primitives, in which case we can short
                                // circuit it with === operator, only when === fails do we use .equals
                                if (watch && (value = watch.get(current)) !== (last = watch.last) && !(watch.eq
                                        ? angular.equals(value, last)
                                        : (typeof value == 'number' && typeof last == 'number'
                                    && isNaN(value) && isNaN(last)))) {
                                    dirty = true;
                                    watch.last = watch.eq ? angular.copy(value) : value;
                                    watch.fn(value, ((last === initWatchVal) ? value : last), current);
                                    // Scalyr edit:  Removed the logging code for when the ttl is reached
                                    // here because we don't have access to the ttl in this method.
                                }
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                        }
                    }

                    // Insanity Warning: scope depth-first traversal
                    // yes, this code is a bit crazy, but it works and we have tests to prove it!
                    // Scalyr edit: This insanity warning was from angular.  We only modified this
                    // code by checking the $$gatingFunction because it's a good optimization to only go
                    // down a child of a parent that has the same gating function as what we are processing
                    // (since if a parent already has a different gating function, there's no way any
                    // of its children will have the right one).
                    if (!(next = ((current.$$gatingFunction === targetGatingFunction && current.$$childHead)
                        || (current !== target && current.$$nextSibling)))) {
                        while (current !== target && !(next = current.$$nextSibling)) {
                            current = current.$parent;
                        }
                    }
                } while ((current = next));

                return dirty;
            };

            /**
             * @inherited $watch
             * @param directiveName The fourth parameter is a new optional parameter that allows
             *   directives aware of this abstraction to pass in their own names to identify
             *   which directive is registering the watch.  This is then passed to the
             *   shouldGateFunction to help determine if the watcher should be gated by the current
             *   gatingFunction.
             */
            methodsToAdd.$watch = function gatedWatch(watchExpression, listener, objectEquality, directiveName) {
                // Determine if we should gate this watcher.
                if (!angular.isUndefined(this.$$gatingFunction) && (angular.isUndefined(this.$$shouldGateFunction) ||
                    this.$$shouldGateFunction(watchExpression, listener, objectEquality, directiveName))) {
                    // We do a hack here to just switch out the watchers array with our own
                    // gated list and then invoke the original watch function.
                    var tmp = this.$$watchers;
                    this.$$watchers = this.$$gatedWatchers;
                    // Invoke original watch function.
                    var result = scopePrototype.$watch.call(this, watchExpression, listener, objectEquality);
                    this.$$watchers = tmp;
                    this.$$gatedWatchers[0].gatingFunction = this.$$gatingFunction;

                    // We know that the last field of the watcher object will be set to initWatchVal, so we
                    // grab it here.
                    initWatchVal = this.$$gatedWatchers[0].last;

                    return result;
                } else {
                    return scopePrototype.$watch.call(this, watchExpression, listener, objectEquality);
                }
            };

            /**
             * @inherited $digest
             */
            methodsToAdd.$digest = function gatedDigest() {
                // We have to take care if a scope's digest method was invoked that has a
                // gating function in the parent scope.  In this case, the watcher for that
                // gating function is registered in the parent (the one added in gatedWatch),
                // and will not be evaluated here.  So, we have to manually see if the gating
                // function is true and if so, evaluate any gated watchers for that function on
                // this scope.  This needs to happen to properly support invoking $digest on a
                // scope with a parent scope with a gating function.
                // NOTE:  It is arguable that we are not correctly handling nested gating functions
                // here since we do not know if the parent gating function was nested in other gating
                // functions and should be evaluated at all.  However, if a caller is invoking
                // $digest on a particular scope, we assume the caller is doing that because it
                // knows the watchers should be evaluated.
                if (!angular.isUndefined(this.$$parentGatingFunction) && this.$$parentGatingFunction()) {
                    var dirty = false;
                    var ttl = 5;
                    do {
                        dirty = this.$digestGated(this.$$parentGatingFunction);
                        ttl--;

                        if (dirty && !(ttl--)) {
                            throw Error(TTL + ' $digest() iterations reached for gated watcher. Aborting!\n' +
                                'Watchers fired in the last 5 iterations.');
                        }
                    } while (dirty);
                }
                return scopePrototype.$digest.call(this) || dirty;
            };

            /**
             * Modifies this scope so that all future watchers registered by $watch will
             * only be evaluated if gatingFunction returns true.  Optionally, you may specify
             * a function that will be evaluted on every new call to $watch with the arguments
             * passed to it, and that watcher will only be gated if the function returns true.
             *
             * @param {Function} gatingFunction The gating function which controls whether or not all future
             *   watchers registered on this scope and its children will be evaluated on a given
             *   digest cycle.  The function will be invoked (with no arguments) on every digest
             *   and if it returns a truthy result, will cause all gated watchers to be evaluated.
             * @param {Function} shouldGateFunction The function that controls whether or not
             *   a new watcher will be gated using gatingFunction.  It is evaluated with the
             *   arguments to $watch and should return true if the watcher created by those
             *   arguments should be gated
             */
            methodsToAdd.$addWatcherGate = function (gatingFunction, shouldGateFunction) {
                var changeCount = 0;
                var self = this;

                // Set a watcher that sees if our gating function is true, and if so, digests
                // all of our associated watchers.  Note, this.$watch could already have a
                // gating function associated with it, which means this watch won't be executed
                // unless all gating functions before us have evaluated to true.  We take special
                // care of this nested case below.

                // We handle nested gating function in a special way.  If we are a nested gating
                // function (meaning there is already one or more gating functions on this scope and
                // our parent scopes), then if those parent gating functions every all evaluate to
                // true (which we can tell if the watcher we register here is evaluated), then
                // we always evaluate our watcher until our gating function returns true.
                var hasNestedGates = !angular.isUndefined(this.$$gatingFunction);
                var promotedWatcher = undefined;

                this.$watch(function () {
                    self.$$scopeActive = false;

                    if (gatingFunction()) {
                        self.$$scopeActive = true;

                        if (self.$digestGated(gatingFunction))
                            ++changeCount;
                    } else if (hasNestedGates && angular.isUndefined(promotedWatcher)) {
                        promotedWatcher = scopePrototype.$watch.call(self, function () {
                            if (gatingFunction()) {
                                self.$$scopeActive = true;
                                promotedWatcher();
                                promotedWatcher = undefined;
                                if (self.$digestGated(gatingFunction))
                                    ++changeCount;
                            }
                            return changeCount;
                        });
                    }
                    return changeCount;
                });


                if (angular.isUndefined(shouldGateFunction))
                    shouldGateFunction = undefined;

                this.$$gatingFunction = gatingFunction;
                this.$$shouldGateFunction = shouldGateFunction;
            };

            // Extend the original Scope object so that when
            // new instances are created, it has the new methods.
            angular.extend(Scope.prototype, methodsToAdd);

            // Also extend the $rootScope instance since it was created
            // before we got a chance to extend Scope.prototype.
            angular.extend($rootScope, methodsToAdd);

            $rootScope.$$gatingFunction = undefined;
            $rootScope.$$parentGatingFunction = undefined;
            $rootScope.$$shouldGateFunction = undefined;
            $rootScope.$$gatedWatchers = [];

            return $rootScope;
        }]);
}]);

module.directive('skShow', [function ($animate) {
    /**
     * @param {*} value The input
     * @return {Boolean} True if the value is truthy as determined by angular rules.
     *
     * Note:  This is copied from the Angular source because it is not exposed by Angular
     * but we want our directive to behave the same as ngShow.  Think about moving this
     * to core.js.
     */
    function toBoolean(value) {
        if (value && value.length !== 0) {
            var v = ("" + value);
            v = angular.isString(v) ? v.toLowerCase() : v;
            value = !(v == 'f' || v == '0' || v == 'false' || v == 'no' || v == 'n' || v == '[]');
        } else {
            value = false;
        }
        return value;
    }

    return {
        restrict: 'A',
        scope: true,
        link: {
            pre: function skShowLink(scope, element, attr) {
                scope.$addWatcherGate(function hiddenChecker() {
                    // Should only return true if the element is not hidden.
                    return !element.hasClass('ng-hide');
                }, function hiddenDecider(watchExpression, listener, equality, directiveName) {
                    // Make an exception for slyShow.. do not gate its watcher.
                    if (angular.isDefined(directiveName) && (directiveName == 'skShow'))
                        return false;
                    return true;
                });

                scope.$watch(attr.skShow, function ngSlyShowAction(value) {
                    element[toBoolean(value) ? 'removeClass' : 'addClass']('ng-hide');
                }, false, 'skShow');
            }
        }
    };
}]);


/**
 * @ngdoc service
 * @name snk.core.services.registry.service:SkComponentRegistry
 *
 * @description
 * Serviço que registra instância de componentes. Atualmente utilizamos esse componente para fazer registros da instância
 * de controlador de um determinado componente.
 *
 * @example
    <example module="app">
        <file name="exemplo.html">
            <div ng-controller="MyController" layout-padding>
                <sk-teste-print></sk-teste-print>
                <button type="button" class="btn btn-primary" ng-click="print('Cliquei no botão do MyController')">Clique aqui</button>
            </div>
        </file>
        <file name="app.js">
            angular.module('app', ['snk']);

            angular.module('app').directive('skTestePrint', [function(){
                return {
                    restrict: 'E',
                    controller: 'PrintController',
                    compile: function(){
                        console.log('componente compilado');
                    }
                };
            }]);

            angular.module('app').controller('PrintController', ['$scope', 'SkComponentRegistry', 'SkConstants', function($scope, SkComponentRegistry, SkConstants){
                var self = this;

                //public
                self.print = print;

                init();

                function init() {
                    var printRegister = SkComponentRegistry.register(self, 'controladorImpressao');

                    $scope.$on(SkConstants.EVENTS.DESTROY, function(){
                        printRegister();//Removemos essa instância do registro de componentes.
                    });
                }
                function print(msg) {
                    window.alert('Estou imprimindo a mensagem: ' + msg);
                };
            }]);

            angular.module('app').controller('MyController', ['$scope', 'SkComponentRegistry', function($scope, SkComponentRegistry){
                var printRegister = SkComponentRegistry.get('controladorImpressao');

                $scope.print = function(msg) {
                    printRegister.then(function(instance){
                        instance.print(msg);
                    });
                };
            }]);
        </file>
 </example>
 */
angular
    .module("snk.core.services.registry")
    .factory("SkComponentRegistry", ['$log', '$q', function ($log, $q) {
        var self;
        var instances = {};
        var pendings = {};

        return self = {

            /**
             * @ngdoc
             * @name SkComponentRegistry#get
             * @methodOf snk.core.services.registry.service:SkComponentRegistry
             * @description Retorna a instância de um componente conforme o handle(ID) repassado.
             * @param {string} handle Identificador para o serviço retornar instância registrada.
             * @return {promise} Retorna uma promessa e com isso quando o handle solicitado ainda não foi registrado, o mesmo empilha
             * as chamadas desse handle e quando o mesmo for registrado, ele dispara as solicitações empilhadas.
             */
            get: function (handle) {
                if (isValidID(handle)) {
                    var deferred = $q.defer();

                    var instance = getInstance(handle);

                    if (instance) {
                        deferred.resolve(instance);
                    } else {
                        addToPendingHandles(handle, deferred);
                    }

                    return deferred.promise;
                }

                return $q.reject("[ComponentRegistry] handle inválido.");
            },

            /**
             * @ngdoc
             * @name SkComponentRegistry#register
             * @methodOf snk.core.services.registry.service:SkComponentRegistry
             * @description Retorna a instância de um componente conforme o handle(ID) repassado.
             * @param {any} instance Instância de algo para ser registrado no componente e ser utilizado em outros pontos.
             * @param {string} handle O handle identifica a instância registrada e quando for reusada deve-se utilizar este mesmo handle.
             * @return {function} Retorna uma função de 'deregistro', ou seja, quando executada ele remove a instância registrada.
             */
            register: function (instance, handle, scope, ignoreDuplicity) {
                if (!handle) {
                    return angular.noop;
                }

                var exists = false;

                if (instances[handle]) {
                    console.warn('[ComponentRegistry] Instancias com handle duplicado: ' + handle);
                    exists = true;
                    if(!ignoreDuplicity) return angular.noop;
                }

                if (!exists){
                    instances[handle] = instance;

                    resolveWhen();
                }

                var deregFunc = function () {
                    delete instances[handle];
                };

                if (scope){
                    scope.$on('$destroy', deregFunc);
                }

                return deregFunc;

                /**
                 * Resolve as promises pendentes de uma instância.
                 */
                function resolveWhen() {
                    var dfd = pendings[handle];

                    if (dfd) {
                        for (var i = 0; i < dfd.length; i++) {
                            dfd[i].resolve(instance);
                        }

                        delete pendings[handle];
                    }
                }
            },

            getSync: getInstance
        };

        function addToPendingHandles(handle, promise) {
            if (pendings[handle]) {
                pendings[handle].push(promise);
            } else {
                pendings[handle] = [promise];
            }
        }

        function getInstance(handle) {
            if (!isValidID(handle)) {
                return null;
            }

            return instances[handle];
        }

        function isValidID(handle) {
            return handle && (handle !== "");
        }
    }]);

/**
 * Created by cleverson.puche on 17/11/2015.
 */

/**
 * @ngdoc service
 * @name snk.core.theme.service:ThemeColors
 *
 * @description
 * Este serviço permite trabalhar com algumas classes de cores previamente disponíveis no framework.
 * */

angular
    .module('snk.core.theme')
    .service('ThemeColors', [function() {
        var self = this;

        const COLORS = [
            'high-contrast', 'gray-base', 'gray-darker', 'gray-dark', 'gray', 'gray-light', 'gray-lighter',
            'primary', 'success', 'info', 'warning', 'danger',
            'brand', 'brand-darker', 'brand-dark', 'brand-light', 'brand-lighter'
        ];

        self.getColors              = getColors;
        self.isValidColor           = isValidColor;
        self.getTextColorClass      = getTextColorClass;
        self.getBgColorClass        = getBgColorClass;
        self.getBorderColorClass    = getBorderColorClass;

        /**
         * @ngdoc
         * @name snk.core.theme.service:ThemeColors#getColors
         * @methodOf snk.core.theme.service:ThemeColors
         * @description
         *  Retorna um array com todas as cores disponíveis para se utilizar como parâmetro dos métodos <i>getTextColorClass</i> e <i>getBgColorClass</i>.
         * @example
         <example module="themeColorExample">
             <file name="bgColorExample.html">
                <sk-vbox ng-controller="ThemeColorController" sk-bg-color="white">
                    <span sk-margin="5px" ng-repeat="color in AVAILABLE_COLORS">{{color}}</span>
                </sk-vbox>
             </file>
             <file name="bgColorExample.js">
                 angular
                 .module('themeColorExample', ['snk'])
                 .controller('ThemeColorController', function($scope, ThemeColors){
                        $scope.AVAILABLE_COLORS = ThemeColors.getColors();
                    });
             </file>
         </example>
         */
        function getColors() {
            return COLORS;
        }

        /**
         * @ngdoc
         * @name snk.core.theme.service:ThemeColors#isValidColor
         * @methodOf snk.core.theme.service:ThemeColors
         * @description
         *  Retorna <i>true</i> caso seja uma cor válida, ou <i>false</i> caso contrário.
         * @example <pre>ThemeColors.isValidColor('gray-darker');</pre>
         */
        function isValidColor(color) {
            return COLORS.indexOf(color) > -1;
        }

        /**
         * @ngdoc
         * @name snk.core.theme.service:ThemeColors#getTextColorClass
         * @methodOf snk.core.theme.service:ThemeColors
         * @description
         *  Retorna o nome da classe que modifica a cor do texto para a cor informada.
         * @example <pre>ThemeColors.getTextColorClass('gray-darker');</pre>
         */
        function getTextColorClass(color) {
            if(isValidColor(color)) {
                return 'text-' + color;
            }

            return color;
        }

        /**
         * @ngdoc
         * @name snk.core.theme.service:ThemeColors#getBgColorClass
         * @methodOf snk.core.theme.service:ThemeColors
         * @description
         *  Retorna o nome da classe que modifica a cor do fundo para a cor informada.
         * @example <pre>ThemeColors.getBgColorClass('gray-darker');</pre>
         */
        function getBgColorClass(color) {
            if(isValidColor(color)) {
                return color + '-bg';
            }

            return color;
        }
        
        /**
         * @ngdoc
         * @name snk.core.theme.service:ThemeColors#getBorderColorClass
         * @methodOf snk.core.theme.service:ThemeColors
         * @description
         *  Retorna o nome da classe que modifica a cor da borda para a cor informada.
         * @example <pre>ThemeColors.getBorderColorClass('gray-darker');</pre>
         */
        function getBorderColorClass(color) {
        	if(isValidColor(color)) {
                return color + '-border';
            }

            return color;
        }
    }]);
angular
    .module('snk.core.tour')
    .constant('TourConstants', {
        'DEFAULT_TITLE_TEMPLATE': 'core/tour/tour.title.tpl.html',
        'DEFAULT_POPOVER_TEMPLATE': 'core/tour/tour.popover.tpl.html'
    });
(function (angular) {
    var defaultTitleTemplate;

    var drctv = angular.module('snk.core.tour');


    drctv.factory('joyrideElement', ['$timeout', '$compile', '$sce', '$templateCache', '$rootScope', '$q', 'DomUtil', 'PositionUtils', 'TourConstants', 'i18n', function ($timeout, $compile, $sce, $templateCache, $rootScope, $q, DomUtil, PositionUtils, TourConstants, i18n) {
        function Element(config, currentStep, template, loadTemplateFn, hasReachedEndFn, goToNextFn,
                         goToPrevFn, skipDemoFn, isEnd, curtainClass, addClassToCurtain, shouldDisablePrevious, attachTobody) {

            if (config.templateUrl) {
                this.content = $templateCache.get(config.templateUrl);
            } else {
                this.content = "<div> " + config.html + "</div>";
            }

            this.actions = config.actions;
            this.currentStep = currentStep;
            this.selector = config.selector;
            this.template = template || TourConstants['DEFAULT_POPOVER_TEMPLATE'];

            if (config.elementTemplate) {
                this.popoverTemplate = config.elementTemplate(this.content, isEnd);
            } else {
                this.popoverTemplate =
                    '<div class=\"row\">' +
                        '<div id=\"pop-over-text\" class=\"col-md-12\">' +
                            this.content +
                        '</div>' +
                    '</div>' +
                    '<hr>' +
                    '<div class=\"row\">' +
                        '<div class=\"col-md-4 center\">' +
                            '<button class=\"skipBtn btn btn-default pull-left\" type=\"button\" sk-i18n>Geral.lblFechar</button>' +
                        '</div>' +
                        '<div class=\"col-md-8\">' +
                            '<div class=\"pull-right btn-group\">' +
                                '<button id=\"prevBtn\" class=\"btn-tour prevBtn btn btn-default\" type=\"button\"><i class=\"glyphicon glyphicon-chevron-left\"></i>&nbsp;' +
                                i18n('Geral.lblAnterior') + '</button>' +
                                '<button id=\"nextBtn\" class=\"btn-tour nextBtn btn btn-brand\" type=\"button\">' +
                                    _generateTextForNext() +
                                '</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>';
            }
            this.heading = config.heading;
            this.placement = config.placement;
            this.scroll = config.scroll;
            this.staticClass = "ng-joyride-element-static";
            this.nonStaticClass = "ng-joyride-element-non-static";
            this.loadTemplateFn = loadTemplateFn;
            this.goToNextFn = goToNextFn;
            this.skipDemoFn = skipDemoFn;
            this.goToPrevFn = goToPrevFn;
            this.hasReachedEndFn = hasReachedEndFn;
            this.type = "element";
            this.curtainClass = curtainClass;
            this.addClassToCurtain = addClassToCurtain;
            this.shouldDisablePrevious = shouldDisablePrevious;
            this.attachTobody = angular.isDefined(attachTobody) ? attachTobody : true;
            this.shouldNotStopEvent = config.shouldNotStopEvent || false;
            this.preventDisableClick = config.preventDisableClick;

            function _generateTextForNext() {
                if (isEnd) {
                    return config.finishText || i18n('Geral.lblTerminar');
                } else {
                    return i18n('Geral.lblProximo') + '&nbsp;<i class=\"glyphicon glyphicon-chevron-right\">';
                }
            }

            if (config.advanceOn) {
                this.advanceOn = config.advanceOn;
            }
        }

        Element.prototype = (function () {
            var $fkEl;
            var $scope;

            function _showTooltip() {
                var deferred = $q.defer();

                var self = this;

                $timeout(function () {
                    $fkEl.popover('show');

                    $timeout(function () {
                        $('.ng-joyride .nextBtn').one("click", self.goToNextFn);
                        $('.ng-joyride .prevBtn').one("click", self.goToPrevFn);
                        $('.ng-joyride .skipBtn').one("click", self.skipDemoFn);

                        if (self.shouldDisablePrevious) {
                            $('.ng-joyride .prevBtn').prop('disabled', true);
                        }

                        $('.ng-joyride').on('click', function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                        });

                        deferred.resolve();
                    });
                }, 200, false);

                return deferred.promise;
            }

            function generate(scope) {
                var self = this;

                $fkEl = $(this.selector, ((scope.options && scope.options.startNode) || document.body));

                if ($fkEl.length == 0) {
                    throw Error("Não foi possível encontrar o elemento '" + this.selector + "'");
                }
                
                $scope = scope.$new();
                $scope.goToNext = self.goToNextFn;
                _highlightElement.call(this);

                self.addClassToCurtain(this.curtainClass);

                var showPromise = _generateHtml.call(this).then(angular.bind(this, _generatePopover)).then(angular.bind(this, _showTooltip));

                showPromise.then(function(){
                    bindAdvanceOn(self);
                });

                return showPromise;
            }

            function stopEvent(event) {
                if (this.shouldNotStopEvent) {

                } else {
                    event.stopPropagation();
                    event.preventDefault();
                }
            }

            function bindAdvanceOn(step) {
                if (step.advanceOn) {
                    return $(step.advanceOn.element).bind(step.advanceOn.event, step.goToNextFn);
                }

                if ($fkEl && !(step.preventDisableClick === true)) {
                    $fkEl.data('skDisableClick', true);
                    getClicableChilds().data('skDisableClick', true);
                    return $fkEl.on("click", angular.bind(step, stopEvent));
                }
            }

            function getClicableChilds(){
                return angular.element($fkEl[0].querySelectorAll('[ng-click]'));
            }

            function unBindAdvanceOn(step) {
                if (step.advanceOn) {
                    return $(step.advanceOn.element).unbind(step.advanceOn.event, step.goToNextFn);
                }

                if ($fkEl && !(step.preventDisableClick === true)) {
                    $fkEl.data('skDisableClick', false);
                    getClicableChilds().data('skDisableClick', false);
                    return $fkEl.off("click", angular.bind(step, stopEvent));
                }

            }

            function _generateHtml() {
                var promise = this.loadTemplateFn(this.template);
                return promise;
            }

            function _generatePopover(html) {
                var content = this.popoverTemplate;

                if (this.actions){
                    angular.extend($scope, this.actions);
                }

                content = $compile(this.popoverTemplate)($scope);

                if (this.scroll) {
                    _scrollToElement.call(this, this.selector);
                }

                $fkEl.popover({
                    title: this.heading,
                    template: html,
                    content: content,
                    html: true,
                    placement: this.placement,
                    trigger: 'manual',
                    container: this.attachTobody ? 'body' : false
                });
            }

            function _highlightElement() {
                var currentPos = $fkEl.css('position');
                if (currentPos === 'static') {
                    $fkEl.addClass(this.staticClass);
                } else {
                    $fkEl.addClass(this.nonStaticClass);
                }

            }

            function _scrollToElement() {
                DomUtil.scrollTo(window.document, $fkEl.offset().top, undefined, 1000);
            }

            function _unhighlightElement() {
                if ($fkEl) {
                    $fkEl.removeClass(this.staticClass);
                    $fkEl.removeClass(this.nonStaticClass);
                }
            }

            function cleanUp() {
                _unhighlightElement.call(this);
                if ($fkEl) {
                    $fkEl.off("click", angular.bind(this, stopEvent));
                    $($fkEl).popover('destroy');
                }

                unBindAdvanceOn(this);
            }

            return {
                generate: generate,
                cleanUp: cleanUp
            };


        })();
        return Element;
    }]);
    drctv.factory('joyrideTitle', ['$timeout', '$compile', '$sce', '$templateCache', '$rootScope', '$q', 'TourConstants', 'i18n', function ($timeout, $compile, $sce, $templateCache, $rootScope, $q, TourConstants, i18n) {

        function Title(config, currentStep, scope, loadTemplateFn, hasReachedEndFn, goToNextFn, goToPrevFn, skipDemoFn, curtainClass, addClassToCurtain, shouldDisablePrevious) {

            if (config.templateUrl) {
                this.content = $templateCache.get(config.templateUrl);
            } else {
                //this.content = $sce.trustAsHtml(config.html);
                this.content = "<div> " + config.html + "</div>";
            }

            this.currentStep = currentStep;
            this.heading = config.heading;
            this.titleMainDiv = '<div class="{{TOUR_TITLE_CLASS}} ng-joyride-title" style="{{TOUR_TITLE_STYLE}}"></div>';
            this.loadTemplateFn = loadTemplateFn;
            this.titleTemplate = config.titleTemplate || TourConstants['DEFAULT_TITLE_TEMPLATE'];
            this.hasReachedEndFn = hasReachedEndFn;
            this.goToNextFn = goToNextFn;
            this.skipDemoFn = skipDemoFn;
            this.goToPrevFn = goToPrevFn;
            this.scope = scope;
            this.type = "title";
            this.curtainClass = curtainClass;
            this.addClassToCurtain = addClassToCurtain;
            this.shouldDisablePrevious = shouldDisablePrevious;
            this.finishText = config.finishText;
            this.hideSkipBtn = config.hideSkipBtn;
            this.titleStyle = config.titleStyle;
            this.titleClass = config.titleClass;
        }

        Title.prototype = (function () {
            var $fkEl;

            function generateTitle() {
                var deferred = $q.defer();
				const titleEl = this.titleMainDiv.replace("{{TOUR_TITLE_STYLE}}", (this.titleStyle || ""))
                                                 .replace("{{TOUR_TITLE_CLASS}}", (this.titleClass || ""));
				
                $fkEl = $(titleEl);
                $('body').append($fkEl);

                var self = this;

                self.addClassToCurtain(this.curtainClass);

                self.loadTemplateFn(this.titleTemplate).then(function(html){
                    angular.bind(self, _compilePopover, html)(html);

                    deferred.resolve();
                });

                return deferred.promise;
            }

            function _compilePopover(html) {
                var self = this;
                this.scope.heading = this.heading;
                $fkEl.html($compile(html)(this.scope));

                var htmlContentElement = angular.element($fkEl[0].querySelector('.popover-content-html'));

                if(htmlContentElement && angular.isFunction(htmlContentElement.append)) {
                    htmlContentElement.append($compile(this.content)(this.scope));
                }

                if (this.hasReachedEndFn()) {
                    if (!(this.hideSkipBtn == false)) {
                        $('.skipBtn').css('display', 'none');
                    }


                    $('.nextBtn').text(this.finishText || i18n('Geral.lblFechar'));
                } else {
                    var text = i18n('Geral.lblProximo');
                    var prevBtn = $('.prevBtn');

                    if (this.currentStep === 0) {
                        text = i18n('Geral.lblConhecerAgora');

                        prevBtn.css('display', 'none');
                    } else {
                        prevBtn.css('display', 'block');
                    }

                    $('.nextBtn').html(text + "&nbsp;<i class='glyphicon glyphicon-chevron-right'>");
                }

                $fkEl.slideDown(100, function () {
                    $('.nextBtn').one("click", function () {
                        self.goToNextFn(200);
                    });
                    $('.skipBtn').one("click", self.skipDemoFn);
                    $('.prevBtn').one("click", function () {
                        self.goToPrevFn(200);
                    });

                    if (self.shouldDisablePrevious) {
                        $('.prevBtn').prop('disabled', true);
                    }
                });
            }

            function cleanUp() {
                if ($fkEl) {
                    $fkEl.slideUp(100, function () {
                        $fkEl.remove();
                    });
                }

            }

            return {
                generate: generateTitle,
                cleanUp: cleanUp
            };

        })();

        return Title;


    }]);
    drctv.factory('joyrideFn', ['$timeout', '$compile', '$sce', '$q', function ($timeout, $compile, $sce, $q) {

        function Fn(config, currentStep, parent) {
            this.currentStep = currentStep;
            if (angular.isString(config.fn)) {
                this.func = parent[config.fn];
            } else {
                this.func = config.fn;
            }

            this.type = "function";


        }

        Fn.prototype = (function () {
            function generateFn() {
                return $q.when(this.func(true));
            }

            function cleanUp() {

            }

            function rollback() {
                return $q.when(this.func(false));
            }

            return {
                generate: generateFn,
                cleanUp: cleanUp,
                rollback: rollback
            };

        })();

        return Fn;


    }]);
    drctv.factory('joyrideLocationChange', ['$timeout', '$compile', '$sce', '$location', '$q', function ($timeout, $compile, $sce, $location, $q) {

        function LocationChange(config, currentStep) {
            this.path = config.path;
            this.currentStep = currentStep;
            this.prevPath = '';
            this.type = 'location_change';

        }

        LocationChange.prototype = (function () {
            function generateFn() {
                var deferred = $q.defer();

                var self = this;
                this.prevPath = $location.path();

                $timeout(function () {
                    $location.path(self.path);
                    deferred.resolve();
                }, 0);

                return deferred.promise;
            }

            function cleanUp() {

            }

            function goToPreviousPath() {
                var self = this;
                $timeout(function () {
                    $location.path(self.prevPath);
                });
            }

            return {
                generate: generateFn,
                cleanUp: cleanUp,
                rollback: goToPreviousPath
            };

        })();

        return LocationChange;


    }]);

    drctv.directive('ngJoyRide', ['$http', '$timeout', '$location', '$window', '$templateCache', '$q', '$compile', '$sce', 'joyrideFn', 'joyrideTitle', 'joyrideElement', 'joyrideLocationChange', '$parse', 'SkTourService', function ($http, $timeout, $location, $window, $templateCache, $q, $compile, $sce, joyrideFn, joyrideTitle, joyrideElement, joyrideLocationChange, $parse, SkTourService) {
        return {
            restrict: "A",
            scope: {
                'ngJoyRide': '=',
                'config': '=',
                'options': '=',
                'onFinish': '&',
                'onSkip': '&'

            },
            link: function (scope, element, attrs) {
                var iconRefresh = 'glyphicon-refresh';
                var iconNext = 'glyphicon-chevron-right';
                var globalHardcodedCurtainClass = "ng-curtain-class";

                var steps = [];
                var currentStepCount = 0;

                var setterStartJoyRide = $parse('ngJoyRide').assign;

                var $fkEl;

                function waitForAngular() {
                    var defer = $q.defer();

                    try {
                        var app = angular.element(document.querySelector('body'));
                        var $browser = app.injector().get('$browser');
                        $browser.notifyWhenNoOutstandingRequests(defer.resolve);
                        defer.resolve();
                    } catch (err) {
                        defer.resolve(err.message);
                    }

                    return defer.promise;
                }

                function hasReachedEnd() {
                    return currentStepCount === (steps.length - 1);
                }

                function isFirstStep() {
                    return currentStepCount === 0;
                }

                function loadTemplate(template) {
                    if (!template) {
                        return '';
                    }
                    return $q.when($templateCache.get(template)) || $http.get(template, {cache: true});
                }

                function goToNext(interval) {
                    cleanUpStep(currentStepCount);

                    var findStep = false;

                    while(!hasReachedEnd()) {
                        currentStepCount++;

                        if (isStepEnabled(steps[currentStepCount])){
                            $timeout(function () {
                                generateStep();
                            }, interval || 0);

                            findStep = true;
                            break;
                        }
                    }

                    if (!findStep && hasReachedEnd()) {
                        endJoyride();
                        scope.onFinish();
                    }
                }


                function endJoyride() {
                    cleanUpStep(currentStepCount);
                    dropCurtain(false);
                    $timeout(function () {
                        setterStartJoyRide(scope, false);
                    });
                }

                function goToPrev(interval) {
                    cleanUpStep(currentStepCount);

                    var requires_timeout = false;

                    // Rollback previous steps until we hit a title or element.
                    function rollbackSteps(s, i) {
                        if (s[i].rollback) {
                            s[i].rollback();
                        }
                    }

                    function isLocationChangedOrFunction() {
                        return steps[currentStepCount].type === "location_change" || steps[currentStepCount].type === "function";
                    }

                    var rollbacksPromise = [];

                    while (currentStepCount >= 1) {
                        requires_timeout = true;

                        if (isLocationChangedOrFunction()){
                            if (steps[currentStepCount].type == "location_change") {
                                scope.$evalAsync(rollbackSteps(steps, currentStepCount));
                            } else if (steps[currentStepCount].rollback) {
                                rollbacksPromise.push(steps[currentStepCount].rollback());
                            }
                        }

                        currentStepCount -= 1;

                        if (isStepEnabled(steps[currentStepCount]) && !isLocationChangedOrFunction()){
                            break;
                        }
                    }

                    $q.all(rollbacksPromise).then(function(){
                         requires_timeout = requires_timeout || interval;

                        if (requires_timeout) {
                            $timeout(function(){
                                generateStep(true);
                            }, interval || 100);
                        } else {
                            generateStep(true);
                        }
                    });
                }

                function skipDemo() {
                    endJoyride();
                    scope.onSkip();
                }

                function dropCurtain(shouldDrop) {
                    var curtain;
                    $fkEl = $('#ng-curtain');
                    if (shouldDrop) {
                        if ($fkEl.size() === 0) {
                            $fkEl = $('<div id="ng-curtain" class="' + globalHardcodedCurtainClass + '"></div>');
                            $fkEl.on('click', function(event){
                                event.preventDefault();
                                event.stopPropagation();
                            });

                            $('body').append($fkEl);

                            $fkEl.slideDown(0);
                        }
                    } else {
                        $fkEl.slideUp(0, function () {
                            $fkEl.remove();
                        });

                    }
                }

                scope.$watch('ngJoyRide', function (newval, oldval) {
                    if (newval) {
                        destroyJoyride();
                        initializeJoyride();
                        currentStepCount = 0;
                        dropCurtain(true);
                        cleanUpPreviousStep();
                        generateStep();
                    } else {
                        destroyJoyride();
                    }
                });
                function destroyJoyride() {
                    SkTourService.isOnTour(false);

                    steps.forEach(function (elem) {
                        elem.cleanUp();
                    });

                    dropCurtain(false);

                    element.off('joyride:prev');
                    element.off('joyride:next');
                    element.off('joyride:exit');
                }

                function cleanUpPreviousStep() {
                    if (currentStepCount !== 0) {
                        steps[currentStepCount - 1].cleanUp();
                    }

                }

                function cleanUpStep(index) {
                    if (index > -1 && steps[index]) {
                        steps[index].cleanUp();
                    }
                }

                function generateStep(rollBack) {
                    var currentStep = steps[currentStepCount];

                    var showPromise = currentStep.generate(scope);

                    var afterShow = function(){
                        resolveButtonFocus(rollBack);
                    };

                    if (currentStep.type === "location_change" || currentStep.type === "function") {
                        showPromise.then(function(){
                            goToNext();

                            $timeout(function(){
	
	                            var iconElement = $('.btn-tour.nextBtn .glyphicon');

                                waitForAngular().then(function () {
                                    $('.btn-tour.nextBtn').prop('disabled', false);

                                    iconElement.removeClass(iconRefresh);
                                    iconElement.addClass(iconNext);
                                    iconElement.removeClass('spin');

                                    afterShow();
                                });
                            }, 0, false);
                        });
                    } else {
                        showPromise.then(afterShow);
                    }
                }

                function resolveButtonFocus(rollBack) {
                    if (rollBack && !isFirstStep()) {
                        $('.btn-tour.prevBtn').focus();
                    } else {
                        $('.btn-tour.nextBtn').focus();
                    }
                }

                function changeCurtainClass(className) {
                    $fkEl.removeClass();

                    $fkEl.addClass(globalHardcodedCurtainClass);
                    if (className) {
                        $fkEl.addClass(className);
                    }
                }

                function isStepEnabled(step) {
                    if (step.hasOwnProperty('isEnabled')) {
                        return angular.isFunction(step.isEnabled) ? step.isEnabled() : step.isEnabled;
                    } else {
                        return true;
                    }
                }

                function initializeJoyride() {
                    SkTourService.isOnTour(true);

                    var options = {
                        config: scope.config,
                        templateUri: attrs.templateUri
                    };

                    var count = -1, isFirst = true, disablePrevious;

                    steps = options.config.map(function (step) {
                        count++;
                        var element;

                        switch (step.type) {
                            case "location_change":
                                element = new joyrideLocationChange(step, count);
                                break;

                            case "element":
                                disablePrevious = isFirst;
                                isFirst = isFirst ? false : false;

                                element = new joyrideElement(step, count, options.templateUri, loadTemplate, hasReachedEnd, goToNext, goToPrev, skipDemo, count === (options.config.length - 1), step.curtainClass, changeCurtainClass, disablePrevious, step.attachToBody);
                                break;

                            case "title":
                                disablePrevious = isFirst;
                                isFirst = isFirst ? false : false;

                                element =  new joyrideTitle(step, count, scope, loadTemplate, hasReachedEnd, goToNext, goToPrev, skipDemo, step.curtainClass, changeCurtainClass, disablePrevious);
                                break;

                            case "function":
                                element = new joyrideFn(step, count, scope.$parent);
                                break;
                        }

                        if (element){
                            element.isEnabled = function () {
                                return isStepEnabled(step);
                            };
                        }

                        return element;
                    });

                    // Listen for events
                    element.on('joyride:prev', goToPrev);
                    element.on('joyride:next', goToNext);
                    element.on('joyride:exit', skipDemo);
                }
            }
        };


    }]);
})(angular);
/**
 * @ngdoc service
 * @name snk.core.tour.service:skTourService
 *
 * @description
 * Esse serviço provê informações sobre o tour do sistema
 */
angular
    .module("snk.core.tour")
    .service('SkTourService', ['DomUtil', function(DomUtil) {
        var self = this;

        var _isOnTour = false;

        self.isOnTour = isOnTour;

        function isOnTour(val) {
            if (angular.isDefined(val)) {
                _isOnTour = val;

                DomUtil.disableBodyScroll(_isOnTour);
            }

            return _isOnTour;
        }

    }]);
/**
 * @ngdoc service
 * @name snk.core.util.service:TabNavigatorHelper#getPopUpNavigationPath
 *
 * @description
 * Componente disponibiliza a funcionalidade de manter o foco no SanpopUp. Essa funcionalidade é utilizada para um cenario em que é priorizada a navegação sem mouse.
 * O @method{getPopUpNavigationPath} recebe um seletor da popUp em questão e o usa para fazer  o retorno do cursor quando o mesmo chega ao final da caminho dentro do sanPopUp.
 * Caso a popUp não posua um seletor customizado, ele busca os que são gerados pelo sanPopUp.
 */
angular
    .module("snk.core.util")
    .service("TabNavigatorHelper",['DomUtil', function(DomUtil){

        const self = this;

        self.getPopUpNavigationPath = getPopUpNavigationPath;

        function getPopUpNavigationPath(form, query = null){

            self.beginPopUpForm = form;
            query = query === null ? "sk-form div.form-container" : query;
            self.firstTarget = self.beginPopUpForm.querySelector(query);

            DomUtil.setFocusOnElement(self.firstTarget);
            verifyPopUpFooter(self.beginPopUpForm.querySelector(".modal-footer"));

        }

        function verifyPopUpFooter(modalFooterItens){

            let footer  = Array.from(modalFooterItens.children).filter(item => item.children.length > 0 );

            for (const _btnFooter of footer[0].children) {
                
                footer[0].children[footer[0].children.length - 1].addEventListener(
                    "keydown", (event) => {
                        if(event.code != "Space" && event.code!="Enter" && event.code!="NumpadEnter"){
                            self.firstTarget.querySelectorAll("input")[0].focus();
                            event.preventDefault();
                        }
                    }, true
                );
            }
        }

    }]);
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "AM",
                "PM"
            ],
            "DAY": [
                "domingo",
                "segunda-feira",
                "ter\u00e7a-feira",
                "quarta-feira",
                "quinta-feira",
                "sexta-feira",
                "s\u00e1bado"
            ],
            "ERANAMES": [
                "Antes de Cristo",
                "Depois de Cristo"
            ],
            "ERAS": [
                "a.C.",
                "d.C."
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "janeiro",
                "fevereiro",
                "mar\u00e7o",
                "abril",
                "maio",
                "junho",
                "julho",
                "agosto",
                "setembro",
                "outubro",
                "novembro",
                "dezembro"
            ],
            "SHORTDAY": [
                "dom",
                "seg",
                "ter",
                "qua",
                "qui",
                "sex",
                "s\u00e1b"
            ],
            "SHORTMONTH": [
                "jan",
                "fev",
                "mar",
                "abr",
                "mai",
                "jun",
                "jul",
                "ago",
                "set",
                "out",
                "nov",
                "dez"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "d 'de' MMM 'de' y HH:mm:ss",
            "mediumDate": "d 'de' MMM 'de' y",
            "mediumTime": "HH:mm:ss",
            "short": "dd/MM/yy HH:mm",
            "shortDate": "dd/MM/yy",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "R$",
            "DECIMAL_SEP": ",",
            "GROUP_SEP": ".",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4-",
                    "negSuf": "",
                    "posPre": "\u00a4",
                    "posSuf": ""
                }
            ]
        },
        "id": "pt-br",
        "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
    });
}]);
angular
    .module('snk.core.util')
    .service('AngularStats', ['$rootScope', function($rootScope){

        var self = this;

        self.getApplicationWatcherCount = getApplicationWatcherCount;
        self.getWatcherCountForScope = getWatcherCountForScope;

        function getApplicationWatcherCount(){
            return getWatcherCountForScope($rootScope);
        }

        function getWatcherCountForScope(scope) {
            var count = 0;
            iterateScopes(scope, function(childScope) {
                if (!childScope.hasOwnProperty('$$scopeActive') || childScope.$$scopeActive) {
                    count += getWatchersFromScope(childScope).length;
                }
            });
            return count;
        }

        function getWatchersFromScope(scope) {
            return scope && scope.$$watchers ? scope.$$watchers : [];
        }

        function iterateScopes(currentScope, fn) {
            if (typeof currentScope === 'function') {
                fn = currentScope;
                currentScope = null;
            }
            currentScope = currentScope || $rootScope;
            currentScope = _makeScopeReference(currentScope);
            if (!currentScope) {
                return;
            }
            var ret = fn(currentScope);
            if (ret === false) {
                return ret;
            }
            return iterateChildren(currentScope, fn);
        }

        function iterateSiblings(start, fn) {
            var ret;
            /* eslint no-extra-boolean-cast:0 */
            while (!!(start = start.$$nextSibling)) {
                ret = fn(start);
                if (ret === false) {
                    break;
                }

                ret = iterateChildren(start, fn);
                if (ret === false) {
                    break;
                }
            }
            return ret;
        }

        function iterateChildren(start, fn) {
            var ret;
            while (!!(start = start.$$childHead)) {
                ret = fn(start);
                if (ret === false) {
                    break;
                }

                ret = iterateSiblings(start, fn);
                if (ret === false) {
                    break;
                }
            }
            return ret;
        }

        function getScopeById(id) {
            var myScope = null;
            iterateScopes(function(scope) {
                if (scope.$id === id) {
                    myScope = scope;
                    return false;
                }
            });
            return myScope;
        }

        function _makeScopeReference(scope) {
            if (_isScopeId(scope)) {
                scope = getScopeById(scope);
            }
            return scope;
        }

        function _isScopeId(scope) {
            return typeof scope === 'string' || typeof scope === 'number';
        }
    }]);
/**
 * Parses "repeat" attribute.
 *
 * Taken from AngularJS ngRepeat source code
 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
 */
angular
    .module("snk.core.util")
    .service("AngularUtil", ['$interval', '$parse', '$templateCache', '$timeout', '$window', '$compile', '$q', '$http', '$rootScope', 'UserAgentUtils', 'DateUtils', 
        function ($interval, $parse, $templateCache, $timeout, $window, $compile, $q, $http, $rootScope, UserAgentUtils, DateUtils) {
        var self = this;

        var stringToXmlParser;

        const UM_MINUTO = 60000;
        const DEFAULT_DEBOUNCE_RESIZE = 200;

        self.parseNgRepeat = parseNgRepeat;
        self.getNgRepeatSourceFromElement = getNgRepeatSourceFromElement;
        self.requestTemplate = requestTemplate;
        self.createDirective = createDirective;
        self.compile = compile;
        self.getControllerFromElement = getControllerFromElement;
        self.debounce = debounce;
        self.apply = apply;
        self.digest = digest;
        self.checkHandleThisEvent = checkHandleThisEvent;
        self.syncPromise = syncPromise;
        self.xmlToJson = xmlToJson;
        self.xmlStringToJson = xmlStringToJson;
        self.buildXmlFromString = buildXmlFromString;
        self.addNumberOnlyParser = addNumberOnlyParser;
        self.addRegexOnlyParser = addRegexOnlyParser;
        self.onDestroyScope = onDestroyScope;
        self.setFocusOnInput = setFocusOnInput;
        self.addSingleWatch = addSingleWatch;
        self.addWindowResizeHandler = addWindowResizeHandler;
        self.timeout = timeout;
        self.timeoutPromise = timeoutPromise;
		self.setContextControllerInfo = setContextControllerInfo;
        self.getContextControllerInfo = getContextControllerInfo;
        self.isPromise = isPromise;
        self.isDeffered = isDeffered;
        self.cancelTimeout = cancelTimeout;
        self.wrapApply = wrapApply;
        self.removeClassInElement = removeClassInElement;
		self.addConditionalRemoveWatch = addConditionalRemoveWatch;
        self.sendTextToClipboard = sendTextToClipboard;
        self.jsonToXml = jsonToXml;
        self.objToXML = objToXML;
        self.tryToString = tryToString;
        self.interval = interval;
        self.cancelInterval = cancelInterval;

        init();

        function init() {
            if (window.DOMParser) {
                stringToXmlParser = function (xmlStr) {
                    return ( new window.DOMParser() ).parseFromString(xmlStr, 'text/xml');
                };
            } else if (typeof window.ActiveXObject != 'undefined' && new window.ActiveXObject('Microsoft.XMLDOM')) {
                stringToXmlParser = function (xmlStr) {
                    var xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
                    xmlDoc.async = "false";
                    xmlDoc.loadXML(xmlStr);
                    return xmlDoc;
                };
            } else {
                stringToXmlParser = function () {
                    throw Error('[AngularUtil] Não foi possível determinar o parser de Str2Json');
                }
            }
        }

        function setContextControllerInfo(element, controllerName, controllerAs, controllerInstance) {
            angular.element(element).data('$skControllerInfo', {
                controllerName: controllerName,
                controllerAs: controllerAs,
                controllerInstance: controllerInstance
            });
        }

        function getContextControllerInfo(element) {
            var parentElement = angular.element(element);
            var controllerInfo;
            while(!controllerInfo && parentElement.length > 0) {
                controllerInfo = parentElement.data('$skControllerInfo');
                parentElement = parentElement.parent();
            }
            return controllerInfo;
        }

        function isPromise(obj) {
            if (obj) {
                return angular.isFunction(obj.then) && angular.isFunction(obj.finally);
            }

            return false;
        }

        function isDeffered(obj) {
            if (obj) {
                return angular.isFunction(obj.resolve) && angular.isFunction(obj.reject);
            }

            return false;
        }

        function timeout(handler, millis, apply) {
            return $timeout(handler, millis || 0, angular.isDefined(apply) ? apply : false);
        }

        function timeoutPromise(defer, millis, callback, apply) {
          //Colocamos o listener de timedout
          defer.promise.then(undefined, function(reason) {
            if (callback) {
              callback(reason, defer);
            }
          });

          return timeout(function() {
            defer.reject('TimedOut');
          }, millis, apply);
        }
        
        function cancelTimeout(timer) {
        	$timeout.cancel(timer);
        }

        function xmlStringToJson(xmlString, isNotLowerCase, keepZeroToTheLeft = false, keepDateFormatFromFlex = false, keepKeyCteNfeFormat = false) {
            return xmlToJson(buildXmlFromString(xmlString), isNotLowerCase, keepZeroToTheLeft, keepDateFormatFromFlex, keepKeyCteNfeFormat);
        }

        function buildXmlFromString(xmlString) {
            if (!xmlString) {
                return xmlString;
            }

            return stringToXmlParser(xmlString);
        }

        function xmlToJson(oXMLParent, isNotLowerCase, keepZeroToTheLeft = false, keepDateFormatFromFlex = false, keepKeyCteNfeFormat = false) {
            var retObj = {}, nAttrLen = 0, sCollectedTxt = "";

            if (oXMLParent?.hasChildNodes()) {
                for (var oNode, sProp, vContent, nItem = 0; nItem < oXMLParent.childNodes.length; nItem++) {
                    oNode = oXMLParent.childNodes.item(nItem);

                    if ((oNode.nodeType - 1 | 1) === 3) {
                        sCollectedTxt += oNode.nodeType === 3 ? oNode.nodeValue.trim() : oNode.nodeValue;
                    } // nodeType is "Text" (3) or "CDATASection" (4)
                    else if (oNode.nodeType === 1 && !oNode.prefix) { // nodeType is "Element" (1)
                        sProp = !isNotLowerCase ? oNode.nodeName.toLowerCase() : oNode.nodeName;
                        vContent = xmlToJson(oNode, isNotLowerCase, keepZeroToTheLeft, keepDateFormatFromFlex, keepKeyCteNfeFormat);

                        if (retObj.hasOwnProperty(sProp)) {
                            if (!retObj[sProp] || retObj[sProp].constructor !== Array) {
                                retObj[sProp] = [retObj[sProp]];
                            }

                            retObj[sProp].push(vContent);
                        } else {
                            retObj[sProp] = vContent;
                        }
                    }
                }

                var parsedText = parseText(sCollectedTxt, undefined, keepZeroToTheLeft, keepDateFormatFromFlex, keepKeyCteNfeFormat);

                if (angular.isDefined(parsedText)) {
                    retObj.$ = parsedText;
                }
            }

            if (oXMLParent?.hasAttributes && oXMLParent?.hasAttributes()) {
                var oAttrib;
                for (nAttrLen; nAttrLen < oXMLParent.attributes.length; nAttrLen++) {
                    oAttrib = oXMLParent.attributes.item(nAttrLen);

                    var attribName = !isNotLowerCase ?  oAttrib.name.toLowerCase() : oAttrib.name;

                    retObj[attribName] = parseText(oAttrib.value.trim(), undefined, keepZeroToTheLeft, keepDateFormatFromFlex, keepKeyCteNfeFormat);
                }
            }

            return retObj;
        }

        /**
         * Example:
         * expression = "address in addresses | filter: {street: $select.search} track by $index"
         * itemName = "address",
         * source = "addresses | filter: {street: $select.search}",
         * trackByExp = "$index",
         */
        function parseNgRepeat(expression) {

            var match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?([\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            if (!match) {
                throw new Error("Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
            }

            return {
                itemName: match[2], // (lhs) Left-hand side,
                source: $parse(match[3]),
                trackByExp: match[4],
                modelMapper: $parse(match[1] || match[2])
            };

        }

        function getNgRepeatSourceFromElement(el) {
            el = angular.element(el)[0];

            var scope = angular.element(el).scope();

            var ngRepeat = [].filter.call(el.childNodes, function (node) {
                return (
                (node.nodeType === 8) &&
                (node.nodeValue.indexOf('ngRepeat:') !== -1)
                );
            })[0];

            if (!ngRepeat) {
                // Without ng-repeat
                return undefined;
            }

            // tests: http://jsbin.com/kosubutilo/1/edit?js,output
            ngRepeat = ngRepeat.nodeValue.match(/ngRepeat\:\s*(.*?)\s+in\s+([^\s|]+)\s*(\|.*)?/);

            var itemExpr = $parse(ngRepeat[1]);
            var itemsExpr = $parse(ngRepeat[2]);

            var filterExpr = ngRepeat[3];

            if (filterExpr && filterExpr.trim() != '') {
              if (filterExpr.indexOf('track by') > -1) {
                filterExpr = filterExpr.substring(0, filterExpr.indexOf('track by'));
              }

              if (filterExpr.trim() != '') {
                filterExpr = $parse(ngRepeat[2] + filterExpr);
              } else {
                filterExpr = undefined;
              }
            } else {
              filterExpr = undefined;
            }

            return {
                item: function (el) {
                    return itemExpr(angular.element(el).scope());
                },
                items: function () {
                    return itemsExpr(scope);
                },
                hasFilter: function() {
                  return angular.isDefined(filterExpr);
                },
                filteredItems: function() {
                  return filterExpr(scope);
                }
            };
        }

        function syncPromise(srcPromise, destPromise) {
            if (srcPromise && destPromise) {
                srcPromise.then(destPromise.resolve, destPromise.reject, destPromise.notify);
            }
        }

        function digest(scope) {
            if (angular.isDefined(scope) && !$rootScope.$$phase) {
                scope.$digest();
            }
        }

        function apply(scope, applyFn) {
            var fn = (applyFn || angular.noop);

            if (!$rootScope.$$phase) {
                scope.$apply(fn);
            } else {
                fn();
            }
        }

        function wrapApply(scope, action, context) {
          return function() {
            var args = Array.prototype.slice.call(arguments);

            apply(scope, function() {
              action.apply(scope || context, args);
            });
          }
        }

        function onDestroyScope(scope, fn) {
            scope && scope.$on('$destroy', (fn || angular.noop))
        }

        function requestTemplate(templateUrl) {
            return $q.when($templateCache.get(templateUrl) || doRequestTemplate(templateUrl));
        }

        function addSingleWatch($scope, property, callback) {
            var deregFn = $scope.$watch(property, function(newValue) {
                if (newValue) {
                    callback(newValue);
                    deregFn();
                }
            });
        }

        function setFocusOnInput(input) {
            if (angular.isElement(input) && !UserAgentUtils.isMobile()) {
                var controller = getControllerFromElement(input);

                $timeout(function () {
                    if (controller && controller.setFocus) {
                        controller.setFocus();
                    } else {
                        angular.element(input).focus();
                    }
                }, 0, false);
            }
        }
        
        function doRequestTemplate(templateUrl) {
        	var deferred = $q.defer();
        	
        	$http.get(templateUrl, {
                cache: true
            }).then(function(response){
            	deferred.resolve(response.data);
            }, function(error){
            	deferred.reject(error);
            });
            
            return deferred.promise;
        }

        function createDirective(name, attrs, scope, requiredControllers, interceptorBeforeCompile) {
            var element = angular.element(document.createElement(name));

            angular.forEach(attrs, function (value, key) {
                element.attr(key, value);
            });

            if (requiredControllers) {
                angular.forEach(requiredControllers, function (controller, controllerName) {
                    element['data']('$' + controllerName + 'Controller', controller);
                });
            }

            if(angular.isFunction(interceptorBeforeCompile)) {
                interceptorBeforeCompile(element);
            }

            var directive = compile(element, scope);

            return directive;
        }

        function compile(element, scope) {
            return $compile(element)(scope || $rootScope.$new());
        }

        function getControllerFromElement(element) {
            var data = angular.element(element).data();

            for (var key in data) {
                if (key.indexOf('Controller') > -1) {
                    return data[key];
                }
            }

            return undefined;
        }

        function checkHandleThisEvent(element, target) {
            if (!target || !element) {
                return false;
            }

            var jsElem = angular.element(element)[0];

            if (jsElem.tagName && target.tagName && jsElem.tagName.toLowerCase() == target.tagName.toLowerCase()) {
                return jsElem == target;
            }

            if (target.parentElement && !(target.parentElement === document.body)) {
                return checkHandleThisEvent(element, target.parentElement);
            }

            return false;
        }

        // Retorna a função, que, enquanto ela é invocada, a mesma não é acionada.
        // A função será chamada depois que passar os N milisegundos e não tiver mais nenhuma ação em curso.
        // @param delay Integer valor em milisegundos para o delay (desde a última solicitação do mesmo); Seu valor padrão é 10 milisegundos.
        // @param invokeApply caso o $timeout é chamado, é verificado se o $digest() está sujo.
        function debounce(action, delay, scope, invokeApply) {
            var timer;

            return function debounced() {
                var args = Array.prototype.slice.call(arguments);

                return $q(function(resolve, reject) {
                    var context = scope;

                    delay = delay || 10;

                    $timeout.cancel(timer);
                    timer = $timeout(function () {
                        timer = undefined;

                        var result = action.apply(context, args);

                        $q.when(result, resolve, reject);
                    }, delay, invokeApply);
                });
            };
        }

        function parseText(sValue, defaultValue, keepZeroToTheLeft = false, keepDateFormatFromFlex = false, keepKeyCteNfeFormat = false) {
            const regexDate = /^(?:(?:(?:0?[1-9]|[12]\d|3[01])[\/.-](?:0?[1-9]|1[0-2])[\/.-](?:\d{2}|\d{4}))|(?:\d{4}[\/.-](?:0?[1-9]|1[0-2])[\/.-](?:0?[1-9]|[12]\d|3[01]))|(?:\d{2}[\/.-]\d{2}[\/.-](?:\d{2}|\d{4})))(?:\s(?:[01]?\d|2[0-3]):(?:[0-5]?\d)(?::(?:[0-5]?\d))?)?$/

            if (!angular.isDefined(sValue)) {
                return sValue;
            }

            if (/^\s*$/.test(sValue)) {
                return defaultValue;
            }

            if (/^(?:true|false)$/i.test(sValue)) {
                return sValue.toLowerCase() === "true";
            }

            if (!isNaN(parseFloat(sValue)) && isFinite(sValue) && sValue.length == 44 && keepKeyCteNfeFormat){
                return sValue;
            }

            if (keepZeroToTheLeft && isFinite(sValue)) {
                let valueTmp = sValue.toString().trim();

                if (valueTmp.length > 1 && valueTmp.startsWith("0") && valueTmp.indexOf(".") == -1) {
                    return sValue;
                }
            }

            if (isFinite(sValue)) {
                let typeOfsValue = typeof(sValue)
                if (angular.isDefined(sValue) && sValue !== null && typeOfsValue.toLowerCase() === "string") {
                    let _hasDecimalSeparator = sValue.indexOf(".") > -1;
                    let _indexOfDecimalSeparator = sValue.split("").reverse().join("").indexOf(".");
                    let _isEndsWhithZero = sValue.split("").reverse().join("").startsWith("0");
    
                    if (_hasDecimalSeparator && _isEndsWhithZero) {
                        return parseFloat(sValue).toFixed(_indexOfDecimalSeparator);
                    }
                }

                return parseFloat(sValue);
            }

            if (keepDateFormatFromFlex && isFinite(Date.parse(sValue)) && DateUtils.strToDate(sValue) != undefined && !(/[a-zA-Z]/.test(sValue))&& regexDate.test(sValue) && sValue.indexOf("/")> -1) {
                return new Date(DateUtils.stringToDateTime(sValue));
            }

            if (!keepDateFormatFromFlex && isFinite(Date.parse(sValue)) && DateUtils.strToDate(sValue) != undefined && !(/[a-zA-Z]/.test(sValue))&& regexDate.test(sValue)) {
                return new Date(sValue);
            }

            return sValue;
        }

        function addWindowResizeHandler(handler, scope, debounceValue) {
            if (angular.isUndefined(debounceValue)) {
                debounceValue = DEFAULT_DEBOUNCE_RESIZE;
            }

            if (debounceValue > 0) {
                handler = debounce(handler, debounceValue, scope, false);
            }

            angular.element($window).bind('resize', handler);

            if (scope) {
                scope.$on('$destroy', function() {
                    angular.element($window).unbind('resize', handler);
                });
            }            
        }

        function addNumberOnlyParser(ngModelCtrl) {
            ngModelCtrl.$parsers.push(function (inputValue) {
                if (inputValue == undefined) return '';

                var transformedInput = inputValue.replace(/[^0-9]/g, '');

                if (transformedInput != inputValue) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                }

                return transformedInput;
            });
        }

        function addRegexOnlyParser(ngModelCtrl, expression) {
            ngModelCtrl.$parsers.push(function (inputValue) {
                if (inputValue == undefined) return '';

                if (typeof inputValue !== 'string' || !(inputValue instanceof String)) {
                    inputValue = String(inputValue);
                }

                var transformedInput = inputValue.replace(new RegExp(expression, 'g'), '');

                if (transformedInput != inputValue) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                }

                return transformedInput;
            });
        }

        function removeClassInElement(elemento, attrClass){
            if (elemento) {
                var arr = elemento.className.split('');
                var className = undefined;
                arr.forEach(function (value) {
                    if (value != attrClass) {
                        className.append(value);
                    }
                });

                if (className) {
                    elemento.className = className;
                }
            }
        }

		function addConditionalRemoveWatch(scope, prop ,fnListener, fnCondition){
            var deregFn = scope.$watch(prop, function(newValue, oldValue){
                fnListener(newValue, oldValue);
                $q.when(fnCondition(newValue, oldValue)).then(function(remove){
                    if(remove == true){
                        deregFn();
                    }
                })
            });
		}

        function sendTextToClipboard(text, element){

            var eTempInput = document.createElement('textarea');
            eTempInput.style.width = '1px';
            eTempInput.style.height = '1px';
            eTempInput.style.top = '0px';
            eTempInput.style.left = '0px';
            eTempInput.style.position = 'absolute';
            eTempInput.style.opacity = '0.0';

            element.appendChild(eTempInput);

            eTempInput.value = text;

            eTempInput.select();
            eTempInput.focus();
            
            document.execCommand('copy');

            element.removeChild(eTempInput);
        }
        
        function jsonToXml(obj, rootTagName) {
            return jsonTagToXml(obj, rootTagName, "");
        }

        function jsonTagToXml(obj, tagName, xml) {
            xml += "<"+tagName+" ";
            
            Object.keys(obj).forEach(key => {
                var val = tryToString(obj[key]);
                if (key.indexOf("$") != 0 && val && angular.isString(val)) {
                    xml += key+"=\""+val+"\" ";
                }
            });

            xml += ">";

            if (angular.isString(tryToString(obj["$"]))) {
                xml += tryToString(obj["$"]);
            }

            Object.keys(obj).forEach(key => {
                var val = tryToString(obj[key]);
                if (key.indexOf("$") != 0 && val && ! angular.isString(val) ) {
                    if (angular.isArray(val)) {
                        val.forEach(val => xml = jsonTagToXml(val, key, xml));
                    } else {
                        xml = jsonTagToXml(val, key, xml);
                    }
                }
            });

            xml += "</"+tagName+">";

            return xml;
        }

        function objToXML(obj) {
            var xml = '';
            for (var prop in obj) {
              if(angular.isUndefined(obj[prop])){
                xml += "<" + prop + "/>";
              } else {
                  xml += obj[prop] instanceof Array ? '' : "<" + prop + ">";
                  if (obj[prop] instanceof Array) {
                    for (var array in obj[prop]) {
                      xml += "<" + prop + ">";
                      xml += objToXML(new Object(obj[prop][array]));
                      xml += "</" + prop + ">";
                    }
                  } else if (typeof obj[prop] == "object") {
                    xml += objToXML(new Object(obj[prop]));
                  } else {
                    xml += obj[prop];
                  }
                  xml += obj[prop] instanceof Array ? '' : "</" + prop + ">";
              }

            }
            
            return xml
          }

        function tryToString(obj) {

            if (obj == null) {
                obj = obj;
            } else if (angular.isString(obj)) {
                obj = obj;
            } else if (angular.isNumber(obj)) {
                obj = String(obj);
            } else if (angular.isDate(obj)) {
                obj = DateUtils.dateToString(obj);
            } else if ((typeof obj).toLowerCase() == "boolean" || obj instanceof Boolean) {
                obj = String(obj);
            }

            return obj;
        }

        function interval(handler, millis, apply) {
            return $interval(handler, millis || UM_MINUTO, angular.isDefined(apply) ? apply : false);
        }

        function cancelInterval(interval) {
            $interval.cancel(interval);
        }
    }]);
angular
    .module("snk.core.util")
    .service("AppletUtils", function () {
        var self = this;
        
        self.validateAppletRunning = (appletID) => {
            var applet = document.getElementById(appletID);

			try{ 
				if(applet != null){
					return applet.validaVersaoJava();
				}
			}catch(e){}
			
			return false;
		}

    });
angular
    .module("snk.core.util")
    .service("ArrayUtils", ['StringUtils', '$injector', function (StringUtils, $injector) {
        var self = this;

        self.sorter = function() {
            return new ArraySorter();
        };

        self.pushAll = pushAll;
        self.normalizeArray = normalizeArray;
        self.insertAtIndex = insertAtIndex;
        self.removeAtIndex = removeAtIndex;
        self.removeReference = removeReference;
        self.sortByProperty = sortByProperty;
        self.sortByStringProperty = sortByStringProperty;
        self.sortByNumberProperty = sortByNumberProperty;
        self.findWhere = findWhere;
        self.indexOf = indexOf;
        self.findIndex = findIndex;
        self.forEach = forEach;
        self.sortArrayFromArray = sortArrayFromArray;
        self.reverse = reverse;
        self.toArray = toArray;
        self.isNotEmpty = isNotEmpty;
        self.isIn = isIn;
        self.copy = copy;
        self.find = find;
        self.callEachFunctionWith = callEachFunctionWith;
        self.pushIfNotFound = pushIfNotFound;
        self.arrayToString = arrayToString;

        function pushAll(src, items) {
            toArray(items).forEach(function(item) {
                src.push(item);
            });
        }

        function isNotEmpty(arr){
            if (angular.isArray(arr)){
                return arr.length > 0;
            } else {
                return false;
            }
        }

        function sortArrayFromArray(array, orderArray, valueGetter) {
            var existentOnOrder = {};
            var notExistentOnOrder = [];

            array.forEach(function(arrValue) {
                var value = valueGetter ? valueGetter(arrValue) : arrValue;

                if (orderArray.indexOf(value) > -1) {
                    existentOnOrder[value] = arrValue;
                } else {
                    notExistentOnOrder.push(arrValue);
                }
            });

            array.splice(0, array.length); //limpa o array

            orderArray.forEach(function(key) {
                if(angular.isDefined(existentOnOrder[key])){
                    array.push(existentOnOrder[key]);
                }
            });

            array.push.apply(array, notExistentOnOrder);

            return array;
        }

        function isIn(arr, obj) {
            return indexOf(arr, obj) > -1;
        }

        function indexOf(arr, obj, forceRemove){
            var index = -1;
            if (angular.isArray(arr)) {
                if(!forceRemove) {
                    return arr.indexOf(obj);
                }

                find(arr, function(item, i) {
                    index = i;
                    return equals(obj, item);
                });
            }

            return index;
        }

        function findIndex(arr, checkerFn) {
            if (angular.isArray(arr)) {
                for (var i = 0, length = arr.length; i < length; i++) {
                    if (checkerFn(arr[i])) { 
                        return i;
                    }
                }
            }
            return -1;
        }

        function copy(arr, deep) {
            if (deep) {
                return angular.copy(arr);
            } else if(arr) {
                return arr.map(angular.identity);
            }
            
            return [];
        }

        function findWhere(array, whereObj){
            for (var key in array){
                var value = array[key];

                for (var whereKey in whereKey){
                    var whereValue = whereObj[whereKey];

                    if (value.hasOwnProperty(whereKey) && whereValue == value){
                        return value;
                    }
                }
            }
        }

        function forEach(arr, fn) {
            for (var i = 0, len = arr.length; i < len; i++) {
                var continueFor = fn(arr[i], i);

                if (continueFor === false) {
                    break;
                }
            }
        }

        function toArray(arr) {
            if (angular.isUndefined(arr)){
                return [];
            } else if (angular.isArray(arr)) {
                return arr;
            } else if (angular.isString(arr)) {
                return arr.split(',');
            } else {
                return [arr];
            }
        }

        function normalizeArray(array) {
            var newArray = undefined;

            if (angular.isDefined(array)) {
                if (angular.isArray(array)) {
                    newArray = array;
                } else {
                    newArray = [];

                    angular.forEach(array, function (value) {
                        newArray.push(value);
                    });
                }
            }

            return newArray;
        }

        function insertAtIndex(array, index, value) {
            array.splice(index, 0, value);
        }

        function removeAtIndex(array, index) {
            if (index >= 0 && index < array.length) {
                return array.splice(index, 1)[0];
            }
        }

        function removeReference(array, obj, forceRemove) {
            var index = indexOf(array, obj, forceRemove);

            return self.removeAtIndex(array, index);
        }

        //Útil no caso em que se tem um array de objetos e deseja-se ordenar o array por alguma propriedade
        function sortByProperty(array, property, sortFn) {
            var ObjectUtils = $injector.get("ObjectUtils");

            if (!isNotEmpty(array)) {
                array = [];
            }
            
            return array.sort(function(obj1, obj2) {

                var v1 = ObjectUtils.getProperty(obj1, property);
                var v2 = ObjectUtils.getProperty(obj2, property);

                if (angular.isDefined(v1) && angular.isDefined(v2)) {
                    return sortFn(v1, v2);
                } else if (angular.isUndefined(v2)) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        function sortByNumberProperty(array, property) {
            return sortByProperty(array, property, function(v1, v2){
                return v1 - v2;
            });
        }

        function sortByStringProperty(array, property) {
            return sortByProperty(array, property, function(v1, v2){
                if (typeof v1 === 'string') {
                    v1 = v1.toLowerCase();
                }
                if (typeof v2 === 'string') {
                    v2 = v2.toLowerCase();   
                }
                return v1 === v2 ? 0 : (v1 < v2 ? -1 : 1);
            });
        }

        function reverse(originalList) {
            var newList = [];
            for(var i = originalList.length - 1; i >= 0; i--) {
                newList.push(originalList[i]);
            }
            return newList;
        }

        function find(arr, checkerFn) {
            if (arr) {
                for (var i = 0, length = arr.length; i < length; i++) {
                    if (checkerFn(arr[i], i, arr)) {
                        return arr[i];
                    }
                }
            } else {
                return undefined;
            }
        }

        function callEachFunctionWith(arr) {
            if (angular.isArray(arr)) {
                var args = Array.prototype.slice.call(arguments, 1);

               for (i=0, j=arr.length; i < j; i++) {
                    var func = arr[i];

                   func.apply(this, args);
                }
            }
        }

        function equals(obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2);
        }

        function ArraySorter() {
            var _sorter = this;

            var _sorterFields = [];

            _sorter.field = function addSortField(names, type, descending, options) {
            	toArray(names).forEach(function(name) {
            		_sorterFields.push({
                        name: name,
                        type: type || 'S',
                        descending: descending == true,
                        options: options
                    });
            	});
                
                return _sorter;
            };

            _sorter.sort = function sortArray(arrToSort) {
                return arrToSort.sort(function(itemA, itemB) {
                    var nulls = handleNulls(itemA, itemB);

                    if (nulls !== null) {
                        return nulls;
                    }

                    var compare = 0;

                    forEach(_sorterFields, function(sortField) {
                        var valueA = itemA[sortField.name];
                        var valueB = itemB[sortField.name];

                        var sortFn = getSortFn(sortField);

                        compare = sortFn(valueA, valueB, sortField.options);

                        if (compare != 0) {
                            if (sortField.descending) {
                                compare = 0 - compare;
                            }

                            return false;
                        }
                    });

                    return compare;
                });
            };

            function getSortFn(sortField) {
                switch (sortField.type) {
                    case "N":
                        return sortNumber;
                    case "S":
                        return sortAlpha;
                    case "D":
                    case "H":
                        return sortDate;
                    default:
                        throw new Error('No sorting function found for type:' + sortField.type);
                }
            }

            function handleNulls(a, b) {
                // We want to allow zero values and false values to be evaluated in the sort function
                if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                    // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                    if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                        return 0;
                    }
                    else if (!a && a !== 0 && a !== false) {
                        return -1;
                    }
                    else if (!b && b !== 0 && b !== false) {
                        return 1;
                    }
                }

                return null;
            }

            function sortNumber(a, b) {
                var nulls = handleNulls(a, b);

                if (nulls !== null) {
                    return nulls;
                } else {
                    return a - b;
                }
            }

            function sortAlpha(a, b, options) {
                var nulls = handleNulls(a, b);

                if (nulls !== null) {
                    return nulls;
                } else {
                    var strA = a.toString();
                        strB = b.toString();
                    
                    if (options && options.insensitive) {
                    	strA = strA.toLowerCase();
                    	strB = strB.toLowerCase();
                    }

                    return strA === strB ? 0 : (strA < strB ? -1 : 1);
                }
            }

            function sortDate(a, b) {
                var nulls = handleNulls(a, b);

                if (nulls !== null) {
                    return nulls;
                } else {
                    if(a.constructor === String){
                        let dateA = a.substring(0, a.indexOf("("));
                        a = new Date(a);
                    }

                    if(b.constructor === String){
                        let dateB = b.substring(0, b.indexOf("("));
                        b = new Date(b);
                    }

                    var timeA = a.getTime(),
                        timeB = b.getTime();

                    return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
                }
            }
        }

        function pushIfNotFound(arr, obj, checkerFn) {
            var testFn;

            if (angular.isFunction(checkerFn)) {
                testFn = checkerFn;
            } else {
                testFn = function (toTest) {
                    return toTest == obj;
                };
            }


            if (!find(arr, testFn)) {
                arr.push(obj);
            }
        }

        function arrayToString(array) {
            var result = "";

            if (array != undefined) {
                array.forEach(function (element) {
                     if (StringUtils.emptyAsUndefined(result) != undefined) {
                         result += ",";
                     }

                    result += element;
                });
            }

            return result;
        }

    }]);
angular
    .module('snk.core.util')
    .constant("AttachConstants", {
        "TIPO": {
            "PRODUTOS": "R",
            "PARCEIRO": "P"
        }
    });
angular
    .module("snk.core.util")
    .constant("MGEAuthorizationConstants", {
        'ACCESS_CONTROL_INSERT': 'I',
        'ACCESS_CONTROL_UPDATE': 'A',
        'ACCESS_CONTROL_REMOVE': 'E',
        'ACCESS_CONTROL_SHOW': 'C',
        'ACCESS_CONTROL_CONFIG': 'F',
        'ACCESS_CONTROL_CONFIG_NUMBER': 'N',
        'ACCESS_CONTROL_CLONE': 'D',
        'ACCESS_CONTROL_CONFIG_GRID': 'G',
        'ACCESS_CONTROL_CONFIG_FORM': 'O'
    });
if(window.PCSF == undefined){window.PCSF = ftxt('pcsf')}
var _0x8fea=['true','loadAuthorization','defer','callService','mge@PermissaoAcessoSP.reset','then','responseBody','authorizationSf','authorization','isArray','item','putAccess','name','status','resolve','reject','promise','parseFromJSON','parse','isUndefined','module','snk.core.util','service','MGEAuthorizationService','ServiceProxy','buildFromRAS','isSup','split','forEach'];(function(_0x31210f,_0x723521){var _0x51a157=function(_0x38280b){while(--_0x38280b){_0x31210f['push'](_0x31210f['shift']());}};_0x51a157(++_0x723521);}(_0x8fea,0x1c7));var _0x2a3e=function(_0x454e8b,_0x46da4f){_0x454e8b=_0x454e8b-0x0;var _0x46c8a3=_0x8fea[_0x454e8b];return _0x46c8a3;};angular[_0x2a3e('0x0')](_0x2a3e('0x1'))[_0x2a3e('0x2')](_0x2a3e('0x3'),['AngularUtil','$q','Base64',_0x2a3e('0x4'),function(_0x3a8f51,_0xc9c04f,_0x56781f,_0xdefeeb){var _0x476690=this;var _0x51e22a={};_0x476690[_0x2a3e('0x5')]=function(){var _0x2191fc=utxt(PCSF);var _0x52f24f=![];var _0x2dde53;if(_0x2a3e('0x6')==_0x2191fc){_0x52f24f=!![];}else{_0x2dde53=_0x2191fc[_0x2a3e('0x7')](';');}var _0x4cb8e1=new MGEAuthorizationData(_0x52f24f);if(_0x2dde53){_0x2dde53[_0x2a3e('0x8')](function(_0x31cef4){var _0x44894c=_0x31cef4[_0x2a3e('0x7')]('=');_0x4cb8e1['putAccess'](_0x44894c[0x0],_0x2a3e('0x9')==_0x44894c[0x1]);});}return _0x4cb8e1;};_0x476690[_0x2a3e('0xa')]=function(_0x882df3){var _0x170d5d=_0xc9c04f[_0x2a3e('0xb')]();if(_0x51e22a[_0x882df3]){_0x170d5d['resolve'](_0x51e22a[_0x882df3]);}else{_0xdefeeb[_0x2a3e('0xc')](_0x2a3e('0xd'),{'resource':{'id':_0x882df3}})[_0x2a3e('0xe')](function(_0x55ae50){var _0x33cfe2=_0x3a8f51['xmlStringToJson'](utxt(_0x55ae50[_0x2a3e('0xf')][_0x2a3e('0x10')]['$']),!![]);var _0x59643c=_0x33cfe2[_0x2a3e('0x11')];var _0x229112=_0x59643c[_0x2a3e('0x6')]==='S';var _0x3c4cfa=new MGEAuthorizationData(_0x229112);if(angular[_0x2a3e('0x12')](_0x59643c['item'])){_0x59643c[_0x2a3e('0x13')][_0x2a3e('0x8')](function(_0x13c4a9){_0x3c4cfa[_0x2a3e('0x14')](_0x13c4a9[_0x2a3e('0x15')],String(_0x13c4a9[_0x2a3e('0x16')])=='true');});}_0x51e22a[_0x882df3]=_0x3c4cfa;_0x170d5d[_0x2a3e('0x17')](_0x3c4cfa);},function(_0x5bfea2){_0x170d5d[_0x2a3e('0x18')](_0x5bfea2);});}return _0x170d5d[_0x2a3e('0x19')];};_0x476690[_0x2a3e('0x1a')]=function(_0x198058){_0x198058=JSON[_0x2a3e('0x1b')](utxt(_0x198058[_0x2a3e('0x10')]));if(angular[_0x2a3e('0x1c')](_0x198058)){throw Error('Objeto\x20não\x20pode\x20ser\x20indefinido.');}var _0x5ed84b=new MGEAuthorizationData(_0x198058[_0x2a3e('0x6')]==='S');if(angular[_0x2a3e('0x12')](_0x198058['item'])){_0x198058[_0x2a3e('0x13')][_0x2a3e('0x8')](function(_0x58af48){_0x5ed84b['putAccess'](_0x58af48[_0x2a3e('0x15')],String(_0x58af48[_0x2a3e('0x16')])==_0x2a3e('0x9'));});}return _0x5ed84b;};}]);
/**
 * @ngdoc service
 * @name snk.core.util.avisos:AvisosUtils
 *
 * @description
 * Serviço utilizado para lançar 1 painel de avisos no inferior da tela com uma lista de mensagens.
 *
 * @example
 <example module="avisosApp">
	 <file name="avisosApp.html">
		<sk-hbox ng-controller="TesteController as ctrl">
        	<button primary ng-click="ctrl.openPanel()">Abrir painel</button>
            <button default ng-click="ctrl.closePanel()">Fechar painel</button>
       </sk-hbox>
	 </file>
	 <file name="avisosApp.js">
		angular
	        .module('avisosApp', ['snk'])
	        .controller('TesteController', ['AvisosUtils', function(AvisosUtils){
                var self = this;

                self.openPanel = openPanel;
                self.closePanel = closePanel;

                function openPanel() {
                    var avisos = [
                        'Ocorreu um erro inesperado no processamento da query',
                        'Erro desconhecido [COD: 655]'
                    ];

                    AvisosUtils.open(avisos);
                }

                function closePanel() {
                    AvisosUtils.close();
                }
            }]);
	
	    function TesteController($scope){
	        $scope.items = [];
	
			for (var i = 0; i < 100; i++) {
				$scope.items.push(i);
			}
	    }
     </file>
 </example>
 */
angular
    .module('snk.core.util')
    .service('AvisosUtils', ['$templateRequest', '$rootScope', '$q', '$compile', '$document', 'SkConstants', 'ArrayUtils', function ($templateRequest, $rootScope, $q, $compile, $document, SkConstants, ArrayUtils) {
        var PAINEL_SHOW_CLASS = 'is-show';
        var HORIZONTAL_GAP = 20;

        var self = this;

        var _popupElem;
        var _popupPromise = $q.defer();
        var _popupScope = $rootScope.$new();
        var _bodyElem = angular.element($document[0].body);

        self.open = open;
        self.close = close;

        _popupScope.onSelectItem = onSelectItem;
        _popupScope.onClose = close;

        /**
         * @ngdoc
         * @name AvisosUtils#open
         * @methodOf snk.core.util.avisos:AvisosUtils
         *
         * @description
         * Método para abrir o painel e apresentar as mensagens
         *
         * @param {Array} avisos Array de string com as mensagens a serem apresentadas
         * 
         * @param {boolean} [valueAsContent=false] Parametro utilizado para informar quando a origem dos dados foi um serviço que retorna JSON convertido apartir do XML.<br>
         * - Quando 'false' ele espera 1 array de string [' ', ' ']<br>
         * - Quando 'true' ele espera 1 array de objetos que contenha a propriedade de conteúdo '$', por exmplo [{'$': 'Mensagem 1'}, {'$': 'Mensagem 2'}].
         */
        function open(avisos, valueAsContent) {
            _popupScope.selectedText = undefined;
            _popupScope.selectedIndex = undefined;

            if (!angular.isArray(avisos)) {
                avisos = ArrayUtils.toArray(avisos);
            }

            if (valueAsContent) {
                avisos = getAvisos(avisos);
            }

            _popupScope.avisos = avisos;

            doOpen();
        }

        /**
         * @ngdoc
         * @name AvisosUtils#close
         * @methodOf snk.core.util.avisos:AvisosUtils
         *
         * @description
         * Método para fechar o painel de mensagens
         */
        function close(event) {
            if (angular.isDefined(event)) {
                event.preventDefault();
                event.stopPropagation();
            }

            _bodyElem.off(SkConstants.EVENTS.KEY_DOWN, onKeyDown);

            if (_popupElem.hasClass(PAINEL_SHOW_CLASS)){
				_popupElem.removeClass(PAINEL_SHOW_CLASS);
			} else if ($(".painel-avisos").hasClass(PAINEL_SHOW_CLASS)){
				$(".painel-avisos").removeClass(PAINEL_SHOW_CLASS);
			} else {
				$(".painel-avisos").remove();
			}
        }

        function doOpen() {
            if (!_popupElem) {
                getTemplate()
                .then(function(html){
                    _popupElem = $compile(html)(_popupScope);

                    angular.element($document[0].body).append(_popupElem);

                    show();

                    _popupPromise.resolve();
                });
            } else {
                show();
            }

            return _popupPromise.promise;
        }

        function getTemplate() {
            return $templateRequest('core/util/avisos/avisos.tpl.html');
        }

        function show() {
            var width = _bodyElem[0].offsetWidth - HORIZONTAL_GAP;
            var left = HORIZONTAL_GAP / 2;

            _bodyElem.on(SkConstants.EVENTS.KEY_DOWN, onKeyDown);

            _popupElem.addClass(PAINEL_SHOW_CLASS);
            _popupElem.css({
                'width': width,
                'left': left,
                'top': 'auto'
            });

            _popupElem[0].focus();
        }

        function onSelectItem(index, aviso) {
            _popupScope.selectedIndex = index;
            _popupScope.selectedText = aviso;
        }

        function onKeyDown(event) {
            if (!event.isDefaultPrevented() && event.keyCode === SkConstants.KEY_CODE.ESCAPE) {
                close(event);
            }
        }

        function getAvisos(avisos) {
            var newAvisos = [];
            var len = avisos.length;
            var aviso;

            for (var i = 0; i < len; i++) {
                aviso = avisos[i];

                newAvisos.push(aviso['$']);
            }

            return newAvisos;
        }
    }]);
angular.module('snk.core.util')
    .directive('skBindHtml', function($compile) {

        return function(scope, element, attrs) {
            scope.$watch(
                function(scope) {
                    // watch the 'compile' expression for changes
                    return scope.$eval(attrs.skBindHtml);
                },
                function(value) {
                    // when the 'compile' expression changes
                    // assign it into the current DOM
                    element.html(value);
    
                    // compile the new DOM and link it to the current
                    // scope.
                    // NOTE: we only compile .childNodes so that
                    // we don't get into infinite loop compiling ourselves
                    $compile(element.contents())(scope);
                }
            );
        };
    });
angular
    .module('snk.core.util')
    .service('ClipboardUtils', [function () {
        var self = this;

        self.bind = bind;
        self.copyTextToClipboard = copyTextToClipboard;

        function bind(target, getText) {
            target = angular.element(target)[0];

            var clipboard = new Clipboard(target, {
                text: getText
            });

            return clipboard;
        }

        function copyTextToClipboard(text){
            /*Works on:
                IE10+
                Edge 12+
                Chrome 43+
                Firefox 41+
                Opera 29+
             */
            if(angular.isUndefined(document)) {
                return;
            }

            var id = "mycustom-clipboard-textarea-hidden-id";
            var existsTextarea = document.getElementById(id);

            if(!existsTextarea){
                var textarea = document.createElement("textarea");
                textarea.id = id;
                textarea.style.position = 'fixed';
                textarea.style.top = 0;
                textarea.style.left = 0;

                textarea.style.width = '1px';
                textarea.style.height = '1px';

                textarea.style.padding = 0;

                textarea.style.border = 'none';
                textarea.style.outline = 'none';
                textarea.style.boxShadow = 'none';

                textarea.style.background = 'transparent';
                document.querySelector("body").appendChild(textarea);
                existsTextarea = document.getElementById(id);
            }

            existsTextarea.value = text;
            existsTextarea.select();

            try {
                document.execCommand('copy');
            } catch (ignored) {}
        }
    }]);
angular
    .module("snk.core.util")
    .service("ColorUtils", ['StringUtils', '$window', 'NumberUtils', function (StringUtils, $window, NumberUtils) {
        var self = this;

        self.toStringColor = toStringColor;
        self.intToHex = intToHex;
        self.hexToInt = hexToInt;
        self.add = add;
        self.subtract = subtract;
        self.getLigtherColor = getLigtherColor;
        self.getDarkerColor = getDarkerColor;
        self.isDarkColor = isDarkColor;
        self.getContrastColor = getContrastColor;
        self.getVariantColor = getVariantColor;
        self.getVariantContrastColor = getVariantContrastColor;
        self.textToColor = textToColor;
        self.decimalColorToHTMLcolor = decimalColorToHTMLcolor;
        self.decimalToHex = decimalToHex;
        self.isHexaColor=isHexaColor;
        self.getHexCodeFromDecimal = getHexCodeFromDecimal;

        function toStringColor(color) {
            var strColor = color.toString(16);
            while (strColor.length < 6) {
                strColor = "0" + strColor;
            }

            return strColor;
        }

        function intToHex(value) {
            var prefix = "000000";
            var str = new String(prefix + value.toString(16));
            return "#" + str.substr(-6).toUpperCase();
        }

        function hexToInt(value) {
            return parseInt(value, 16);
        }

        function add(color, amountRed, amountGreen, amountBlue) {
            var strColor = toStringColor(color);

            //Separamos o volume de cada cor da matriz RGB
            var red = $window.Math.max(0, $window.Math.min(0xFF, parseInt(strColor.substr(0, 2), 16) + amountRed));
            var green = $window.Math.max(0, $window.Math.min(0xFF, parseInt(strColor.substr(2, 2), 16) + amountGreen));
            var blue = $window.Math.max(0, $window.Math.min(0xFF, parseInt(strColor.substr(4, 2), 16) + amountBlue));

            return parseInt(StringUtils.stringZero(red.toString(16), 2) + StringUtils.stringZero(green.toString(16), 2) + StringUtils.stringZero(blue.toString(16), 2), 16);
        }

        function subtract(color, amountRed, amountGreen, amountBlue) {
            var strColor = toStringColor(color);

            //Separamos o volume de cada cor da matriz RGB
            var red = $window.Math.max(0, $window.Math.min(0xFF, parseInt(strColor.substr(0, 2), 16) - amountRed));
            var green = $window.Math.max(0, $window.Math.min(0xFF, parseInt(strColor.substr(2, 2), 16) - amountGreen));
            var blue = $window.Math.max(0, $window.Math.min(0xFF, parseInt(strColor.substr(4, 2), 16) - amountBlue));

            return parseInt(StringUtils.stringZero(red.toString(16), 2) + StringUtils.stringZero(green.toString(16), 2) + StringUtils.stringZero(blue.toString(16), 2), 16);
        }

        function getLigtherColor(color, amount) {
            return add(color, amount, amount, amount);
        }

        function getDarkerColor(color, amount) {
            return subtract(color, amount, amount, amount);
        }

        function isDarkColor(color) {
            var strColor = toStringColor(color);

            //Separamos o volume de cada cor da matriz RGB
            var red = parseInt(strColor.substr(0, 2), 16);
            var green = parseInt(strColor.substr(2, 2), 16);
            var blue = parseInt(strColor.substr(4, 2), 16);

            //Quanto maior a média da das cores, mais clara é a cor
            return ((red + green + blue) / 3) <= 127;
        }

        function getContrastColor(color) {
            var strColor = toStringColor(color);

            //Separamos o volume de cada cor da matriz RGB
            var red = parseInt(strColor.substr(0, 2), 16);
            var green = parseInt(strColor.substr(2, 2), 16);
            var blue = parseInt(strColor.substr(4, 2), 16);

            //Quanto maior a média da das cores, mais clara é a cor, portanto
            //retornamos Preto (0x000000) se for clara (> que a metade de FF)
            //do contrário retornamos Branco (0xFFFFFF)
            return ((red + green + blue) / 3) > 127 ? 0 : 0xFFFFFF;
        }

        function getVariantColor(color, amount) {
        	if (StringUtils.isEmpty(amount)) {
        		amount = 10;
        	}

            if (isDarkColor(color)) {
                return getLigtherColor(color, amount);
            } else {
                return getDarkerColor(color, amount);
            }
        }

        function getVariantContrastColor(color, amount) {
           	if (StringUtils.isEmpty(amount)) {
        		amount = 10;
        	}

        	var contrastColor = getContrastColor(color);

            return getVariantColor(contrastColor, amount);
        }

        function textToColor(str) {
            if (StringUtils.isEmpty(str)) {
                return '#000000';
            }

            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            var colour = '#';
            for (var j = 0; j < 3; j++) {
                var value = (hash >> (j * 8)) & 0xF0;
                colour += ('00' + value.toString(16)).substr(-2);
            }
            return colour;
        }

        function decimalColorToHTMLcolor(number) {
            //converts to a integer
            var intNumber = number - 0;
         
            // isolate the colors - really not necessary
            var red, green, blue;
         
            // needed since toString does not zero fill on left
            var template = "#000000";
         
            // in the MS Windows world RGB colors
            // are 0xBBGGRR because of the way Intel chips store bytes
            red = (intNumber&0x0000ff) << 16;
            green = intNumber&0x00ff00;
            blue = (intNumber&0xff0000) >>> 16;
         
            // mask out each color and reverse the order
            intNumber = red|green|blue;
         
            // toString converts a number to a hexstring
            var HTMLcolor = intNumber.toString(16);
         
            //template adds # for standard HTML #RRGGBB
            HTMLcolor = template.substring(0,7 - HTMLcolor.length) + HTMLcolor;
         
            return HTMLcolor;
        } 

        function decimalToHex(color){
            return '#' + StringUtils.stringZero(NumberUtils.decimalToHex(color) , 6, undefined, true); 
        }

        function isHexaColor(sNum){
            return (typeof sNum === "string") && sNum.length === 6 && ! isNaN( parseInt(sNum, 16) );
        }

        function getHexCodeFromDecimal(numeric) {
            var hexaCode = NumberUtils.isNumeric(numeric) 
                ? NumberUtils.decimalToHex(numeric).toUpperCase() 
                : angular.isDefined(numeric) 
                ? numeric 
                : undefined;
            if (angular.isDefined(hexaCode) && hexaCode.length < 6) {
                // return hexaCode.padStart(6, '0'); Ate dia 09/04/2019 esta funcao nao eh suportada no navegador Sankhya.
                while (hexaCode.length < 6) {
                    hexaCode = '0' + hexaCode;
                }
                return hexaCode;
            }
            return hexaCode;
        }
    }]);

/**
 * Created by bruno.brandao on 20/04/2016.
 */
angular
    .module('snk.core.util')
    .provider('Criteria', function () {
        var IN_CLAUSE_MAX_PARAMS = 10;

        this.$get = function () {
            return CriteriaService;
        };

        function CriteriaService(exp, params) {
            return new Criteria(exp, params);
        }

        CriteriaService.buildParameter = function(type, value) {
            return new CriteriaParameter(type, value);
        };

        CriteriaService.buildStringParameter = function(value) {
            return new CriteriaParameter(CriteriaParameter.TYPE_STRING, value);
        };

        CriteriaService.buildNumberParameter = function(value) {
            return new CriteriaParameter(CriteriaParameter.TYPE_NUMBER, value);
        };

        CriteriaService.buildDateParameter = function(value) {
            return new CriteriaParameter(CriteriaParameter.TYPE_DATE, value);
        };

        CriteriaService.buildInClause = function (fieldName, totalPlaceholders, placeholdersPerClause) {
            var clausule = ' (';
            var placeholdersPerClause = Number(placeholdersPerClause) || IN_CLAUSE_MAX_PARAMS;
            var clauseNumber = Math.floor(totalPlaceholders / placeholdersPerClause) + 1;
            var j = 0;

            for (var i = 0; i < clauseNumber; i++) {
                clausule += (fieldName + ' IN (');

                var jFin = (i + 1) * placeholdersPerClause;

                for (; j < jFin && j < totalPlaceholders; j++) {
                    clausule += '?';

                    if ((j + 1) < jFin && (j + 1) < totalPlaceholders) {
                        clausule += ',';
                    }
                }

                clausule += ')';

                if (i < (clauseNumber - 1)) {
                    clausule += ' OR ';
                }
            }

            clausule += ') ';

            return clausule;
        }
    });
/**
 * @ngdoc object
 * @name snk.core.util:SkConstants
 *
 * @description
 * Disponibiliza as constantes mais comuns em nosso sistema para utilização em serviços, diretivas e outros.
 */
angular
    .module("snk.core.util")
    .constant("SkConstants", {
        KEY_CODE: {
            ENTER: 13,
            ESCAPE: 27,
            SPACE: 32,
            LEFT_ARROW: 37,
            UP_ARROW: 38,
            RIGHT_ARROW: 39,
            DOWN_ARROW: 40,
            TAB: 9,
            BACKSPACE: 8,
            DELETE: 46,
            COMMAND: 91,
            CTRL: 17,
            ALT: 18,
            HOME: 36,
            END: 35,
            PLUS: 107,
            MINUS: 109
        },
        MOUSE: {
            DOWN: 'mousedown',
            UP: 'mouseup',
            CLICK: 'click',
            MOVE: 'mousemove',
            WHELL: 'mousewheel'
        },
        TOUCH: {
            START: 'touchstart',
            END: 'touchend',
            MOVE: 'touchmove'
        },
        EVENTS: {
            SWIPE_LEFT: 'swipeleft',
            SWIPE_RIGHT: 'swiperight',
            RESIZE: 'resize',
            DESTROY: '$destroy',
            SCROLL: 'scroll',
            KEY_DOWN: 'keydown',
            FOCUS: 'focus',
            BLUR: 'blur'
        },
        MEDIA: {
            'sm': '(max-width: 768px)',
            'gt-sm': '(min-width: 768px)',
            'md': '(min-width: 768px) and (max-width: 992px)',
            'gt-md': '(min-width: 992px)',
            'lg': '(min-width: 992px) and (max-width: 1200px)',
            'gt-lg': '(min-width: 1200px)'

        },
        MEDIA_PRIORITY: [
            'gt-lg',
            'lg',
            'gt-md',
            'md',
            'gt-sm',
            'sm'
        ],
        KEY_MAP: {
            91: "COMMAND",
            8: "BACKSPACE",
            9: "TAB",
            13: "ENTER",
            16: "SHIFT",
            17: "CTRL",
            18: "ALT",
            19: "PAUSEBREAK",
            20: "CAPSLOCK",
            27: "ESC",
            32: "SPACE",
            33: "PAGE_UP",
            34: "PAGE_DOWN",
            35: "END",
            36: "HOME",
            37: "LEFT",
            38: "UP",
            39: "RIGHT",
            40: "DOWN",
            43: "+",
            44: "PRINTSCREEN",
            45: "INSERT",
            46: "DELETE",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            61: "=",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9",
            106: "*",
            107: "+",
            109: "-",
            110: ".",
            111: "/",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NUMLOCK",
            145: "SCROLLLOCK",
            186: ";",
            187: "=",
            188: ",",
            189: "-",
            190: ".",
            191: "/",
            192: "`",
            219: "[",
            220: "\\",
            221: "]",
            222: "'"
        },
        SQL: {
            AND: 'AND',
            OR: 'OR',
            IN: 'IN',
            DIFFERENT: '<>',
            LIKE: 'LIKE',
            START_WITH: 'LIKE_START',
            FINISHED_WITH: 'LIKE_END',
            NULL: 'NULL',
            NOT_NULL: 'NOT NULL',
            EQUAL: '=',
            LARGER: '>',
            LARGER_EQUAL: '>=',
            SMALLER: '<',
            SMALLER_EQUAL: '<='
        }
    });
angular
    .module('snk.core.util')
    .directive('creationComplete', ['$parse', '$timeout', 'AngularUtil', function ($parse, $timeout, AngularUtil) {
        return {
            restrict: 'A',
            compile: function (elemnt, attrs) {
                return function (scope, element, attrs) {
                    var fn = $parse(attrs.creationComplete);

                    $timeout(function(){
                        var controller = AngularUtil.getControllerFromElement(elemnt);

                        fn(scope, {controller: controller});
                    }, 0, false);
                }
            }
        };
    }]);
angular
    .module("snk.core.util")
    .service("CrudUtils", ['$q', 'ServiceProxy', function ($q, ServiceProxy) {
        var self = this;

        self.find = find;

        function find(entityName, fields, criterio, findOne, literalCriteria, orderBy, options) {
            var parsedFields = [];
            var parsedCriterio = [];

            if (fields){
                if (angular.isString(fields)){
                    fields = fields.split(',');
                }

                if (!angular.isArray(fields)) {
                    throw new Error('CrudUtils.find deve receber um array de fields, ou uma lista separada por virgula.');
                }

                fields.forEach(function(fieldName) {
                    parsedFields.push({
                        name: fieldName
                    });
                });
            }

            var request = {
        		entity: {
        			name: entityName,
        			fields: {
        				field: parsedFields
        			}
        		}
            };

            if(options && options.referenceFetch){
                request.entity.referenceFetch = options.referenceFetch;
            }
            
            if (options && options.hasOwnProperty('includePresentations')) {
            	request.entity.getPresentations = options.includePresentations;
            }

            if (criterio){
                angular.forEach(criterio, function(value, key) {
                    parsedCriterio.push({nome: key, valor: value});
                });
                request.entity.criterio = parsedCriterio;
            }
            
            if(orderBy){
            	request.entity.orderby = orderBy;
            }
            
            if (literalCriteria) {
            	request.entity.literalCriteria = {
            		expression: {
            			$: literalCriteria
            		}	
            	};
            }

            var defer = $q.defer();

            ServiceProxy.callService('mge@crud.find', request)
                .then(function(result) {
                    var entities = result.responseBody.entidades.entidade;

                    if (angular.isDefined(entities)) {
                        if (!angular.isArray(entities)) {
                            entities = [entities];
                        }

                        if (entities.length > 1 && findOne) {
                            entities = entities.splice(0, 1);
                        }

                        var result = entities.map(function(entity){
                            var newEntity = {};

                            angular.forEach(entity, function(fieldValue, fieldName) {
                                if (fieldValue.hasOwnProperty('$')) {
                                    newEntity[fieldName] = fieldValue.$;
                                }
                            });

                            return newEntity;
                        });

                        defer.resolve(findOne ? result[0] : result);
                    } else {
                        defer.resolve(findOne ? undefined : []);
                    }
                }, defer.reject);

            return defer.promise;
        }

    }]);
/*
 * This var has to be outside the angular factory, otherwise when
 * there are multiple sankhya apps on the same page, each app
 * will create its own instance of this array and the app's IDs
 * will not be unique.
 */

angular
    .module("snk.core.util")
    .service("Crypt", [
    	function(){
    		includeMd5(this);
    	}
    ]);

function includeMd5(ctx){
	  'use strict'

	  /**
		 * Add integers, wrapping at 2^32. This uses 16-bit operations
		 * internally to work around bugs in interpreters.
		 * 
		 * @param {number}
		 *            x First integer
		 * @param {number}
		 *            y Second integer
		 * @returns {number} Sum
		 */
	  function safeAdd(x, y) {
	    var lsw = (x & 0xffff) + (y & 0xffff)
	    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
	    return (msw << 16) | (lsw & 0xffff)
	  }

	  /**
		 * Bitwise rotate a 32-bit number to the left.
		 * 
		 * @param {number}
		 *            num 32-bit number
		 * @param {number}
		 *            cnt Rotation count
		 * @returns {number} Rotated number
		 */
	  function bitRotateLeft(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt))
	  }

	  /**
		 * Basic operation the algorithm uses.
		 * 
		 * @param {number}
		 *            q q
		 * @param {number}
		 *            a a
		 * @param {number}
		 *            b b
		 * @param {number}
		 *            x x
		 * @param {number}
		 *            s s
		 * @param {number}
		 *            t t
		 * @returns {number} Result
		 */
	  function md5cmn(q, a, b, x, s, t) {
	    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
	  }
	  /**
		 * Basic operation the algorithm uses.
		 * 
		 * @param {number}
		 *            a a
		 * @param {number}
		 *            b b
		 * @param {number}
		 *            c c
		 * @param {number}
		 *            d d
		 * @param {number}
		 *            x x
		 * @param {number}
		 *            s s
		 * @param {number}
		 *            t t
		 * @returns {number} Result
		 */
	  function md5ff(a, b, c, d, x, s, t) {
	    return md5cmn((b & c) | (~b & d), a, b, x, s, t)
	  }
	  /**
		 * Basic operation the algorithm uses.
		 * 
		 * @param {number}
		 *            a a
		 * @param {number}
		 *            b b
		 * @param {number}
		 *            c c
		 * @param {number}
		 *            d d
		 * @param {number}
		 *            x x
		 * @param {number}
		 *            s s
		 * @param {number}
		 *            t t
		 * @returns {number} Result
		 */
	  function md5gg(a, b, c, d, x, s, t) {
	    return md5cmn((b & d) | (c & ~d), a, b, x, s, t)
	  }
	  /**
		 * Basic operation the algorithm uses.
		 * 
		 * @param {number}
		 *            a a
		 * @param {number}
		 *            b b
		 * @param {number}
		 *            c c
		 * @param {number}
		 *            d d
		 * @param {number}
		 *            x x
		 * @param {number}
		 *            s s
		 * @param {number}
		 *            t t
		 * @returns {number} Result
		 */
	  function md5hh(a, b, c, d, x, s, t) {
	    return md5cmn(b ^ c ^ d, a, b, x, s, t)
	  }
	  /**
		 * Basic operation the algorithm uses.
		 * 
		 * @param {number}
		 *            a a
		 * @param {number}
		 *            b b
		 * @param {number}
		 *            c c
		 * @param {number}
		 *            d d
		 * @param {number}
		 *            x x
		 * @param {number}
		 *            s s
		 * @param {number}
		 *            t t
		 * @returns {number} Result
		 */
	  function md5ii(a, b, c, d, x, s, t) {
	    return md5cmn(c ^ (b | ~d), a, b, x, s, t)
	  }

	  /**
		 * Calculate the MD5 of an array of little-endian words, and a bit
		 * length.
		 * 
		 * @param {Array}
		 *            x Array of little-endian words
		 * @param {number}
		 *            len Bit length
		 * @returns {Array<number>} MD5 Array
		 */
	  function binlMD5(x, len) {
	    /* append padding */
	    x[len >> 5] |= 0x80 << len % 32
	    x[(((len + 64) >>> 9) << 4) + 14] = len

	    var i
	    var olda
	    var oldb
	    var oldc
	    var oldd
	    var a = 1732584193
	    var b = -271733879
	    var c = -1732584194
	    var d = 271733878

	    for (i = 0; i < x.length; i += 16) {
	      olda = a
	      oldb = b
	      oldc = c
	      oldd = d

	      a = md5ff(a, b, c, d, x[i], 7, -680876936)
	      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586)
	      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819)
	      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330)
	      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897)
	      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426)
	      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341)
	      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983)
	      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416)
	      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417)
	      c = md5ff(c, d, a, b, x[i + 10], 17, -42063)
	      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162)
	      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682)
	      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101)
	      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290)
	      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329)

	      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510)
	      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632)
	      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713)
	      b = md5gg(b, c, d, a, x[i], 20, -373897302)
	      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691)
	      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083)
	      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335)
	      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848)
	      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438)
	      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690)
	      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961)
	      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501)
	      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467)
	      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784)
	      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473)
	      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734)

	      a = md5hh(a, b, c, d, x[i + 5], 4, -378558)
	      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463)
	      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562)
	      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556)
	      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060)
	      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353)
	      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632)
	      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640)
	      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174)
	      d = md5hh(d, a, b, c, x[i], 11, -358537222)
	      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979)
	      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189)
	      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487)
	      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835)
	      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520)
	      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651)

	      a = md5ii(a, b, c, d, x[i], 6, -198630844)
	      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415)
	      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905)
	      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055)
	      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571)
	      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606)
	      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523)
	      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799)
	      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359)
	      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744)
	      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380)
	      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649)
	      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070)
	      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379)
	      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259)
	      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551)

	      a = safeAdd(a, olda)
	      b = safeAdd(b, oldb)
	      c = safeAdd(c, oldc)
	      d = safeAdd(d, oldd)
	    }
	    return [a, b, c, d]
	  }

	  /**
		 * Convert an array of little-endian words to a string
		 * 
		 * @param {Array
		 *            <number>} input MD5 Array
		 * @returns {string} MD5 string
		 */
	  function binl2rstr(input) {
	    var i
	    var output = ''
	    var length32 = input.length * 32
	    for (i = 0; i < length32; i += 8) {
	      output += String.fromCharCode((input[i >> 5] >>> i % 32) & 0xff)
	    }
	    return output
	  }

	  /**
		 * Convert a raw string to an array of little-endian words
		 * Characters >255 have their high-byte silently ignored.
		 * 
		 * @param {string}
		 *            input Raw input string
		 * @returns {Array<number>} Array of little-endian words
		 */
	  function rstr2binl(input) {
	    var i
	    var output = []
	    output[(input.length >> 2) - 1] = undefined
	    for (i = 0; i < output.length; i += 1) {
	      output[i] = 0
	    }
	    var length8 = input.length * 8
	    for (i = 0; i < length8; i += 8) {
	      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32
	    }
	    return output
	  }

	  /**
		 * Calculate the MD5 of a raw string
		 * 
		 * @param {string}
		 *            s Input string
		 * @returns {string} Raw MD5 string
		 */
	  function rstrMD5(s) {
	    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8))
	  }

	  /**
		 * Calculates the HMAC-MD5 of a key and some data (raw strings)
		 * 
		 * @param {string}
		 *            key HMAC key
		 * @param {string}
		 *            data Raw input string
		 * @returns {string} Raw MD5 string
		 */
	  function rstrHMACMD5(key, data) {
	    var i
	    var bkey = rstr2binl(key)
	    var ipad = []
	    var opad = []
	    var hash
	    ipad[15] = opad[15] = undefined
	    if (bkey.length > 16) {
	      bkey = binlMD5(bkey, key.length * 8)
	    }
	    for (i = 0; i < 16; i += 1) {
	      ipad[i] = bkey[i] ^ 0x36363636
	      opad[i] = bkey[i] ^ 0x5c5c5c5c
	    }
	    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8)
	    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128))
	  }

	  /**
		 * Convert a raw string to a hex string
		 * 
		 * @param {string}
		 *            input Raw input string
		 * @returns {string} Hex encoded string
		 */
	  function rstr2hex(input) {
	    var hexTab = '0123456789abcdef'
	    var output = ''
	    var x
	    var i
	    for (i = 0; i < input.length; i += 1) {
	      x = input.charCodeAt(i)
	      output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f)
	    }
	    return output
	  }

	  /**
		 * Encode a string as UTF-8
		 * 
		 * @param {string}
		 *            input Input string
		 * @returns {string} UTF8 string
		 */
	  function str2rstrUTF8(input) {
	    return unescape(encodeURIComponent(input))
	  }

	  /**
		 * Encodes input string as raw MD5 string
		 * 
		 * @param {string}
		 *            s Input string
		 * @returns {string} Raw MD5 string
		 */
	  function rawMD5(s) {
	    return rstrMD5(str2rstrUTF8(s))
	  }
	  /**
		 * Encodes input string as Hex encoded string
		 * 
		 * @param {string}
		 *            s Input string
		 * @returns {string} Hex encoded string
		 */
	  function hexMD5(s) {
	    return rstr2hex(rawMD5(s))
	  }
	  /**
		 * Calculates the raw HMAC-MD5 for the given key and data
		 * 
		 * @param {string}
		 *            k HMAC key
		 * @param {string}
		 *            d Input string
		 * @returns {string} Raw MD5 string
		 */
	  function rawHMACMD5(k, d) {
	    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d))
	  }
	  /**
		 * Calculates the Hex encoded HMAC-MD5 for the given key and data
		 * 
		 * @param {string}
		 *            k HMAC key
		 * @param {string}
		 *            d Input string
		 * @returns {string} Raw MD5 string
		 */
	  function hexHMACMD5(k, d) {
	    return rstr2hex(rawHMACMD5(k, d))
	  }

	  /**
		 * Calculates MD5 value for a given string. If a key is provided,
		 * calculates the HMAC-MD5 value. Returns a Hex encoded string
		 * unless the raw argument is given.
		 * 
		 * @param {string}
		 *            string Input string
		 * @param {string}
		 *            [key] HMAC key
		 * @param {boolean}
		 *            raw Raw oytput switch
		 * @returns {string} MD5 output
		 */
	  function md5(string, key, raw) {
	    if (!key) {
	      if (!raw) {
	        return hexMD5(string)
	      }
	      return rawMD5(string)
	    }
	    if (!raw) {
	      return hexHMACMD5(key, string)
	    }
	    return rawHMACMD5(key, string)
	  }

	  if (typeof define === 'function' && define.amd) {
	    define(function() {
	      return md5
	    })
	  } else if (typeof module === 'object' && module.exports) {
	    module.exports = md5
	  } else {
		 ctx.md5 = md5
	  }
}

//TODO: Posteriormente mover esse service p/ um projeto separado e gerar o mesmo minificado.

/*
     Exemplo de uso para os dashs:
  
     const CLIENT_ID = 'MDAwMDAwMDAwMDAyMjcx'; //Buscar client ID no server

     self.contentDec = 'criptografadoPKPjjM9mmaknQwZkbgbOZEH9QYfP98vou7nq5n4wSDVyTJKN1btqNFhYRcIpO05EaoqFGnRIQ+2UWY7QzHrWfy2hxMqt7vWku4vQTl/OHVl7YvaZQgr3GqQCY+ey9V7WHJ/O/AXC4A+iVfnIHhg903wRyUzQpTOhBCi1dmUK2bpLgtXiLtDiYmEyGdiHJ48txTD594SePLK9p02FmJsl1G2dWpxFUFoc2iTGepZNZrJkx4fASZvodQ==';
     self.contentEnc = '<gadget> <level id="lvl_a1kwd5o" description="Principal"> <container orientacao="V" tamanhoRelativo="100"> <grid id="grd_a1kwd5p" useNewGrid="S"> <title><![CDATA[acentuação]]></title> </grid> </container> </level> </gadget>'

     self.decript = function() {        
       let key = atob(CLIENT_ID);        
       return Crypto.decriptDES(self.contentDec.substr(13), key);
     }
      
     self.encript = function(){
       var key = atob(CLIENT_ID);
       return Crypto.encriptDES(self.contentEnc, key); 
     }

 */
angular
    .module("snk.core.util")
    .service("Crypto", [
    	function(){
            const self = this;

            self.decriptDES = decriptDES;
            self.encriptDES = encriptDES;

            function decriptDES(toDecript, key){
                return atob(CryptoJS.DES.decrypt({
                    ciphertext: CryptoJS.enc.Base64.parse(toDecript)
                  }, CryptoJS.enc.Utf8.parse(key), 
                    {
                        mode: CryptoJS.mode.ECB,
                        padding: CryptoJS.pad.Pkcs7
                    }
                  )
                  .toString(CryptoJS.enc.Base64));
            }

            function encriptDES(toEncript, key){
                if(!toEncript){
                    return '';
                }

                return CryptoJS.DES.encrypt( CryptoJS.enc.Latin1.parse(toEncript), 
                                             CryptoJS.enc.Utf8.parse(key), 
                                             {
                                                mode: CryptoJS.mode.ECB,
                                                padding: CryptoJS.pad.Pkcs7
                                             }
                                            ).toString();
            }
            
        }
    ]);



/**
 * @ngdoc service
 * @name snk.core.util.service:DateBuilder
 *
 * @description
 * Builder de datas do framework.
 * Pode receber como parâmetro um objeto de data, que será a data inicial, 
 * caso não fornecido, será considerado a data atual.
 * 
 * @example
     <example module="appDateBuilder">
         <file name="appDateBuilder.html">
            <div ng-controller="TesteController">
                <p>Segunda passada: <span ng-bind="previousMonday | date:'medium'"></span></p>
                <p>Final do dia corrente: <span ng-bind="dayEnd | date:'medium'"></span></p>
            </div>
         </file>
         <file name="appDateBuilder.js">
            angular
                .module('appDateBuilder', ['snk'])
                .controller('TesteController', function ($scope, DateBuilder){
                    $scope.previousMonday = DateBuilder().weekStart().addDays(-6).toDate();
                    $scope.dayEnd = DateBuilder().dayEnd().toDate();
                });
         </file>
     </example>
 *
 */

angular
    .module("snk.core.util")
    .provider('DateBuilder', [function () {
        this.$get = ['FluidBuilder', 'DateUtilsConstants', function (FluidBuilder, DateUtilsConstants) {
            return function (startDate) {
                return FluidBuilder(undefined, moment(startDate))
                    .fnImpl('toString', toString)

                    //Start/End
                    .fnImpl('dayStart', dayStart)
                    .fnImpl('dayEnd', dayEnd)
                    .fnImpl('weekStart', weekStart)
                    .fnImpl('weekEnd', weekEnd)
                    .fnImpl('monthStart', monthStart)
                    .fnImpl('monthEnd', monthEnd)

                    //Adds
                    .fnImpl('addDays', addDays)
                    .fnImpl('addMonths', addMonths)
                    .fnImpl('addYears', addYears)

                    //BuilderFn
                    .buildFn(function (variables, options, workingObj) {
                        return workingObj.toDate();
                    }, 'toDate');
            };

            /**
            * 
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#toString
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Formata em string a data que está contextualizada.
            * @param {string} [format=DateUtilsConstants.DEFAULT_DATE_FORMAT] Formato de saída da data.
            * @example 
            *      <pre>builder.toString()</pre>
            * 
            */
            function toString(data) {
                return data.workingObj.format(data.args[0] || DateUtilsConstants.DEFAULT_DATE_FORMAT);
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#dayStart
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Volta a data para o início do dia da data que está contextualizada.
            * @example 
            *      <pre>builder.dayStart()</pre>
            */
            function dayStart(data) {
                data.workingObj.startOf('day');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#dayEnd
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Incrementa a data para o final do dia da data que está contextualizada.
            * @example 
            *      <pre>builder.dayEnd()</pre>
            */
            function dayEnd(data) {
                data.workingObj.endOf('day');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#weekStart
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Volta a data para o início da semana da data que está contextualizada.
            * @example 
            *      <pre>builder.weekStart()</pre>
            */
            function weekStart(data) {
                data.workingObj.startOf('week');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#weekEnd
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Incrementa a data para o final da semana da data que está contextualizada.
            * @example 
            *      <pre>builder.weekEnd()</pre>
            */
            function weekEnd(data) {
                data.workingObj.endOf('week');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#monthStart
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Volta a data para o início do mês da data que está contextualizada.
            * @example 
            *      <pre>builder.monthStart()</pre>
            */
            function monthStart(data) {
                data.workingObj.startOf('month');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#monthEnd
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Incrementa a data para o final do mês da data que está contextualizada.
            * @example 
            *      <pre>builder.monthEnd()</pre>
            */
            function monthEnd(data) {
                data.workingObj.endOf('month');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#addDays
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Adiciona ou subtrai X dias da data que está contextualizada.
            * @param {Number} days Quantidade de dias a sererem subtraídos. Caso negativo, será subtraído.
            * @example 
            *   <pre>
                    builder.addDays(6)
                    builder.addDays(-6)
                </pre>
            */
            function addDays(data) {
                data.workingObj.add(data.args[0], 'days');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#addMonths
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Adiciona ou subtrai X meses da data que está contextualizada.
            * @param {Number} months Quantidade de meses a sererem subtraídos. Caso negativo, será subtraído.
            * @example 
            *   <pre>
                    builder.addMonths(1)
                    builder.addMonths(-1)
                </pre>
            */
            function addMonths(data) {
                data.workingObj.subtract(data.args[0], 'days');
            }

            /**
            * @ngdoc
            * @name snk.core.util.service:DateBuilder#addYears
            * @methodOf snk.core.util.service:DateBuilder
            * @description
            *  Adiciona ou subtrai X anos da data que está contextualizada.
            * @param {Number} years Quantidade de anos a sererem subtraídos. Caso negativo, será subtraído.
            * @example 
            *   <pre>
                    builder.addYears(1)
                    builder.addYears(-1)
                </pre>
            */
            function addYears(data) {
                data.workingObj.subtract(data.args[0], 'years');
            }
        }];
    }]);
angular
    .module("snk.core.util")
    .config(function (DateUtilsConstants) {
        moment.defineLocale('pt-br', DateUtilsConstants.MOMENT_LANG_PT_BR);
        moment.locale('pt-br');
    });
angular
    .module('snk.core.util')
    .constant('DateUtilsConstants', {
        DEFAULT_DATETIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
        DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS: 'DD/MM/YYYY HH:mm',
        DEFAULT_DATE_FORMAT: 'DD/MM/YYYY',
        DEFAULT_TIME_FORMAT: 'HH:mm:ss',
        DEFAULT_DATE_US_FORMAT: 'YYYY-MM-DD',
        DEFAULT_DATE_MONTH_FORMAT: 'MM/yyyy',
        GREGORIAN_DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss.S',
        MOMENT_LANG_PT_BR: {
            months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
            monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
            weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
            weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
            weekdaysMin: 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'LT:ss',
                L: 'DD/MM/YYYY',
                LL: 'D [de] MMMM [de] YYYY',
                LLL: 'D [de] MMMM [de] YYYY [Ã s] LT',
                LLLL: 'dddd, D [de] MMMM [de] YYYY [Ã s] LT'
            },
            calendar: {
                sameDay: '[Hoje Ã s] LT',
                nextDay: '[Amanhã Ã s] LT',
                nextWeek: 'dddd [Ã s] LT',
                lastDay: '[Ontem Ã s] LT',
                lastWeek: function () {
                    return (this.day() === 0 || this.day() === 6) ?
                        '[Último] dddd [Ã s] LT' : // Saturday + Sunday
                        '[Última] dddd [Ã s] LT'; // Monday - Friday
                },
                sameElse: 'L'
            },
            relativeTime: {
                future: 'em %s',
                past: '%s atrás',
                s: 'segundos',
                m: 'um minuto',
                mm: '%d minutos',
                h: 'uma hora',
                hh: '%d horas',
                d: 'um dia',
                dd: '%d dias',
                M: 'um mês',
                MM: '%d meses',
                y: 'um ano',
                yy: '%d anos'
            },
            ordinalParse: /\d{1,2}º/,
            ordinal: '%dº'
        }
    });
angular
    .module("snk.core.util")
    .service("DateUtils", ['StringUtils', 'DateUtilsConstants', '$locale', 'orderByFilter', 'NumberUtils', 'ArrayUtils',
        function (StringUtils, DateUtilsConstants, $locale, orderByFilter, NumberUtils, ArrayUtils) {
            var self = this;

            self.DEFAULT_DATE_FORMAT = DateUtilsConstants.DEFAULT_DATE_FORMAT;
            self.DEFAULT_DATETIME_FORMAT = DateUtilsConstants.DEFAULT_DATETIME_FORMAT;
            self.UNIT = {
                DAYS: 'days',
                MONTHS: 'months',
                YEARS: 'years',
                MINUTES: 'minutes',
                HOURS: 'hours'
            };

            var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

            var formatCodeToRegex = {
                'yyyy': {
                    regex: '\\d{4}',
                    apply: function (value) {
                        self.year = +value;
                    }
                },
                'yy': {
                    regex: '\\d{2}',
                    apply: function (value) {
                        self.year = +value + 2000;
                    }
                },
                'y': {
                    regex: '\\d{1,4}',
                    apply: function (value) {
                        self.year = +value;
                    }
                },
                'MMMM': {
                    regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
                    apply: function (value) {
                        self.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
                    }
                },
                'MMM': {
                    regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
                    apply: function (value) {
                        self.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
                    }
                },
                'MM': {
                    regex: '0[1-9]|1[0-2]',
                    apply: function (value) {
                        self.month = value - 1;
                    }
                },
                'M': {
                    regex: '[1-9]|1[0-2]',
                    apply: function (value) {
                        self.month = value - 1;
                    }
                },
                'dd': {
                    regex: '[0-2][0-9]{1}|3[0-1]{1}',
                    apply: function (value) {
                        self.date = +value;
                    }
                },
                'd': {
                    regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) {
                        self.date = +value;
                    }
                },
                'EEEE': {
                    regex: $locale.DATETIME_FORMATS.DAY.join('|')
                },
                'EEE': {
                    regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
                },
                'HH': {
                    regex: '(?:0|1)[0-9]|2[0-3]',
                    apply: function (value) {
                        self.hours = +value;
                    }
                },
                'H': {
                    regex: '1?[0-9]|2[0-3]',
                    apply: function (value) {
                        self.hours = +value;
                    }
                },
                'mm': {
                    regex: '[0-5][0-9]',
                    apply: function (value) {
                        self.minutes = +value;
                    }
                },
                'm': {
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) {
                        self.minutes = +value;
                    }
                },
                'sss': {
                    regex: '[0-9][0-9][0-9]',
                    apply: function (value) {
                        self.milliseconds = +value;
                    }
                },
                'ss': {
                    regex: '[0-5][0-9]',
                    apply: function (value) {
                        self.seconds = +value;
                    }
                },
                's': {
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) {
                        self.seconds = +value;
                    }
                }
            };

            self.parsers = {};
            self.stringToDate = stringToDate;
            self.strToDate = strToDate;
            self.buildDate = buildDate;
            self.buildDateFromTime = buildDateFromTime;
            self.formatDate = formatDate;
            self.isValidDate = isValidDate;
            self.getTimeExtraFormatter = getTimeExtraFormatter;
            self.getTimeDashboardFormatter = getTimeDashboardFormatter;
            self.getTimeUnlimitedHourFormatter = getTimeDashboardFormatter;
            self.getToday = getToday;
            self.clearTime = clearTime;
            self.clearSeconds = clearSeconds;
            self.parse = parse;
            self.extractTimeFromDate = extractTimeFromDate;
            self.subtract = subtract;
            self.add = add;
            self.getFirstDay = getFirstDay;
            self.getLastDay = getLastDay;
            self.weekGetLastDay = weekGetLastDay;
            self.weekGetFirstDay = weekGetFirstDay;
            self.timestampToDate = timestampToDate;
            self.getOneYearAgo = getOneYearAgo;
            self.dateToString = dateToString;
            self.diffDates = diffDates;
            self.diff = diff;
            self.diffWithToday = diffWithToday;
            self.getYear = getYear;
            self.getMonth = getMonth;
            self.milisegundosToHHmmss = milisegundosToHHmmss;
            self.setTime = setTime;
            self.milisegundosToHHmmssMMM = milisegundosToHHmmssMMM;
            self.milisegundosTommssMM = milisegundosTommssMM;
            self.compareOnlyDate = compareOnlyDate;
            self.getTimeFormatter = getTimeFormatter;
            self.getTimeFormatterFromMinutes = getTimeFormatterFromMinutes;
            self.minutes2Time = minutes2Time;
            self.isLastDayOfMonth = isLastDayOfMonth;
            self.compare = compare;
            self.getMinutes = getMinutes;
            self.timeConverter = timeConverter;
            self.sortValueForDate = sortValueForDate;
            self.getTimeFormattedFromMilis = getTimeFormattedFromMilis; // returns Ex.: 1h 32m 48s 5ms
            self.stringToDateTime = stringToDateTime;
            self.calculateTime = calculateTime;
            self.dateTimeToString = dateTimeToString;

            function diffDates(data_1, data_2) {
                return Math.floor(Math.abs(((data_1.getTime() - data_2.getTime()) / (24 * 60 * 60 * 1000))));
            }

            function stringToDate(dateStr) {
                return moment(dateStr, DateUtilsConstants.DEFAULT_DATE_FORMAT).toDate();
            }

            function stringToDateTime(dateStr, formatOutput = self.DEFAULT_DATETIME_FORMAT) {
                return moment(dateStr, formatOutput).toDate();
            }

            function dateToString(date, formatOutput) {
                if (!angular.isDate(date)) {
                    return undefined;
                }

                return moment(date).format(formatOutput || DateUtilsConstants.DEFAULT_DATE_FORMAT);
            }

            function strToDate(strValue, adjustDayLightSavingTime, modeMonthYear) {
                /** modeMonthYear é um booleano para usar o formato MM/YYYY. 
                 * Quando ativado, é retornado o primeiro dia do mês apenas para construir a data. 
                 * Não há necessidade de verificar o horário de verão quando utilizado esse modo. */
                var date;
                var splited;
                var isModeMonthYear = angular.isDefined(modeMonthYear) && modeMonthYear ? true : false;

                // Se o tamanho da data for 21, sabemos que é do calendário Gregoriano,
                // logo apenas formatamos para o padrão.
                if (StringUtils.isNotEmpty(strValue) && strValue.length === 21) {
                    return formatDate(strValue, DateUtilsConstants.DEFAULT_DATETIME_FORMAT, DateUtilsConstants.GREGORIAN_DATE_FORMAT);
                }

                if (isModeMonthYear) {
                    splited = /^(1[0-2]|0[1-9]|[1-9])[^\d]?(\d{2}|\d{4})(?:\s(\d{1,2}):(\d{1,2}):?(\d{0,2}))?$/.exec(strValue);
                } else {
                    splited = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])[^\d]?(0[1-9]|1[0-2])[^\d]?(\d{4})(?:\s(\d{1,2}):(\d{1,2}):?(\d{0,2}))?$/.exec(strValue);
                }

                if (angular.isUndefined(splited)) {
                    splited = /^(3[01]|[1-2]\d|0[1-9]|[1-9])[^\d]?(1[0-2]|0[1-9]|[1-9])[^\d]?(\d{2}|\d{4})(?:\s(\d{1,2}):(\d{1,2}):?(\d{0,2}))?$/.exec(strValue)
                }

                if (splited) {
                    var day = !isModeMonthYear ? Number(splited[1]) : 1;
                    var month = Number(splited[(!isModeMonthYear ? 2 : 1)]);
                    var year = Number(splited[(!isModeMonthYear ? 3 : 2)]);
                    var hour = Number(splited[(!isModeMonthYear ? 4 : 3)]) || 0;
                    var min = Number(splited[(!isModeMonthYear ? 5 : 4)]) || 0;
                    var sec = Number(splited[(!isModeMonthYear ? 6 : 5)]) || 0;

                    if (year < 100) {
                        year += year < 30 ? 2000 : 1900;
                    }

                    date = new Date(year, month - 1, day, hour, min, sec);

                    //Work around para corrigir o Bug do horário de verão.
                    if (adjustDayLightSavingTime === true && modeMonthYear === false && hour == 0 && date.getHours() == 23) {
                        date.setHours(1, 0, 0, 0);
                        date.date += 1;
                    }
                }

                return date;
            }

            function buildDate(strTime) {
                return moment(strTime).toDate();
            }

            function buildDateFromTime(strTime) {
                return moment(strTime, DateUtilsConstants.DEFAULT_TIME_FORMAT).toDate();
            }

            function extractTimeFromDate(date, unlimitedHour, minutesIsPriority) {
                var strHora = formatDate(date, DateUtilsConstants.DEFAULT_TIME_FORMAT);

                return Time.parse(strHora, unlimitedHour, minutesIsPriority);
            }

            function formatDate(date, format, inputFormat) {
                if (angular.isUndefined(date) || !moment(date, inputFormat).isValid()) {
                    return undefined;
                }

                return moment(date, inputFormat).format(format || DateUtilsConstants.DEFAULT_DATE_FORMAT);
            }

            function isValidDate(date, inputFormat) {
                return angular.isDefined(date) && moment(date, inputFormat).isValid();
            }

            function getTimeDashboardFormatter(item) {
                if (angular.isUndefined(item)) {
                    return '';
                }

                var time = item.toString().replace(/\:/g, '');

                if (time.length == 1) {
                    time = "00:0" + time;
                }
                else if (time.length == 2) {
                    time = "00:" + time;
                }
                else if (time.length == 3) {
                    time = "0" + time.substring(0, 1) + ":" + time.substring(1);
                }
                else if (time.length == 4) {
                    time = time.substring(0, 2) + ":" + time.substring(2);
                } else {
                    time = time.substring(0, time.length - 2) + ":" + time.substring(time.length - 2);
                }
                return time;
            }

            function getTimeExtraFormatter(item) {
                if (angular.isUndefined(item)) {
                    return '';
                }

                var hour = item.toString().replace(/\:/g, '');

                if (hour.length == 1) {
                    hour = "00:0" + hour;
                }
                else if (hour.length == 2) {
                    hour = "00:" + hour;
                }
                else if (hour.length == 3) {
                    hour = "0" + hour.substring(0, 1) + ":" + hour.substring(1);
                }
                else if (hour.length == 4) {
                    hour = hour.substring(0, 2) + ":" + hour.substring(2);
                }
                else if (hour.length == 5) {
                    hour = "0" + hour.substring(0, 1) + ":" + hour.substring(1, 3) + ":" + hour.substring(3);
                }
                else if (hour.length == 6) {
                    hour = hour.substring(0, 2) + ":" + hour.substring(2, 4) + ":" + hour.substring(4);
                }
                else if (hour.length > 6 && hour.indexOf(":") == -1) {
                    hour = hour.substring(0, hour.length - 2) + ":" + hour.substring(hour.length - 2);
                }

                return hour;
            }

            function milisegundosToHHmmss(timeMillis) {
                var time = timeMillis / 1000;
                var seconds = StringUtils.stringZero(String(NumberUtils.getNumberOrZero(Math.trunc(time % 60))), 2);
                var minutes = StringUtils.stringZero(String(NumberUtils.getNumberOrZero(Math.trunc((time % 3600) / 60))), 2);
                var hours = StringUtils.stringZero(String(NumberUtils.getNumberOrZero(Math.trunc(time / 3600))), 2);

                if (hours == '00') {
                    return minutes + ":" + seconds;
                }

                return hours + ":" + minutes + ":" + seconds;
            }

            function milisegundosToHHmmssMMM(miliseconds) {
                const pad = function (n, z = 2) {
                    return ('00' + n).slice(-z)
                };

                const hh = pad(miliseconds / 3.6e6 | 0);
                const mm = pad((miliseconds % 3.6e6) / 6e4 | 0);
                const ss = pad((miliseconds % 6e4) / 1000 | 0);
                const mmm = pad(miliseconds % 1000, 3);

                return hh + ':' + mm + ':' + ss + '.' + mmm;
            }
            
            function milisegundosTommssMM(miliseconds) {
                const pad = function(n, z = 2) { 
                    return ('00' + n).slice(-z)
                };

                const mm = pad((miliseconds % 3.6e6) / 6e4 | 0);
                const ss = pad((miliseconds % 6e4) / 1000 | 0);
                const mmm = pad(miliseconds % 1000);
                
                if(mm != 0){
                	return  mm + 'min ' + ss + 's ' + mmm + 'ms';
                }else if(ss != 0){
                	return  ss + 's ' + mmm + 'ms';
                }
                
                return mmm + 'ms';
            }

            function getTimeFormattedFromMilis(milliseconds) {

                //Get hours from milliseconds
                var hours = milliseconds / (1000*60*60);
                var absoluteHours = Math.floor(hours);
                var h = absoluteHours;

                //Get remainder from hours and convert to minutes
                var minutes = (hours - absoluteHours) * 60;
                var absoluteMinutes = Math.floor(minutes);
                var m = absoluteMinutes;

                //Get remainder from minutes and convert to seconds
                var seconds = (minutes - absoluteMinutes) * 60;
                var absoluteSeconds = Math.floor(seconds);
                var s = absoluteSeconds;

                var ms = milliseconds % 1000 | 0;


                let retorno = h > 0 ? String(h) + 'h ' : '';
                retorno += h == 0 && m == 0 ? '' : String(m) + 'm ';
                retorno += h == 0 && m == 0 && s == 0 ? '' : String(s) + 's ';
                retorno += ms > 0 ? String(ms) + 'ms' : '';

                console.log('retorno: ' + retorno)

                return retorno;
            }

            function getToday(doClearTime) {
                if (arguments.length == 0) {
                    doClearTime = true;
                }

                if (doClearTime) {
                    return clearTime();
                } else {
                    return moment().toDate();
                }
            }

            function clearTime(date) {
                return moment(date).startOf('day').toDate()
            }

            function clearSeconds(date) {
                return moment(date).startOf('minutes').toDate()
            }

            function diff(date, date2, unit) {
                return moment(date).diff(moment(date2), unit || 'days');
            }

            function diffWithToday(date, unit) {
                return diff(date, getToday(), unit || 'days');
            }

            function createParser(format) {
                var map = [];
                var regex = format.split('');

                angular.forEach(formatCodeToRegex, function (data, code) {
                    var index = format.indexOf(code);

                    if (index > -1) {
                        format = format.split('');

                        regex[index] = '(' + data.regex + ')';

                        format[index] = '$'; // Custom symbol to define consumed part of format

                        for (var i = index + 1, n = index + code.length; i < n; i++) {
                            regex[i] = '';
                            format[i] = '$';
                        }

                        format = format.join('');

                        map.push({ index: index, apply: data.apply });
                    }
                });

                return {
                    regex: new RegExp('^' + regex.join('') + '$'),
                    map: orderByFilter(map, 'index')
                };
            }

            function isValid(year, month, date) {
                if (date < 1) {
                    return false;
                }

                if (month === 1 && date > 28) {
                    return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
                }

                if (month === 3 || month === 5 || month === 8 || month === 10) {
                    return date < 31;
                }

                return true;
            }

            function parse(input, format, baseDate) {
                var parser;
                var regex;
                var map;
                var results;

                if (!angular.isString(input) || !format) {
                    return input;
                }

                format = $locale.DATETIME_FORMATS[format] || format;
                format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

                if (!self.parsers[format]) {
                    self.parsers[format] = createParser(format);
                }

                parser = self.parsers[format];
                regex = parser.regex;
                map = parser.map;
                results = input.match(regex);

                if (results && results.length) {
                    var fields;
                    var dt;

                    if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
                        fields = {
                            year: baseDate.getFullYear(),
                            month: baseDate.getMonth(),
                            date: baseDate.getDate(),
                            hours: baseDate.getHours(),
                            minutes: baseDate.getMinutes(),
                            seconds: baseDate.getSeconds(),
                            milliseconds: baseDate.getMilliseconds()
                        };
                    } else {
                        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
                    }

                    for (var i = 1, n = results.length; i < n; i++) {
                        var mapper = map[i - 1];

                        if (mapper.apply) {
                            mapper.apply.call(fields, results[i]);
                        }
                    }

                    if (isValid(fields.year, fields.month, fields.date)) {
                        dt = new Date(fields.year, fields.month, fields.date, fields.hours, fields.minutes, fields.seconds, fields.milliseconds || 0);
                    }

                    return dt;
                }
            }

            function subtract(dt, days, unit) {
                if (!unit) {
                    unit = self.UNIT.DAYS;
                }

                dt = moment(dt);

                return dt.subtract(days, unit).toDate();
            }

            function add(dt, days, unit) {
                if (!unit) {
                    unit = self.UNIT.DAYS;
                }

                dt = moment(dt);

                return dt.add(days, unit).toDate();
            }

            function getFirstDay(dt) {
                return moment(dt).startOf('month').toDate();
            }

            function getLastDay(dt) {
                return moment(dt).endOf('month').toDate();
            }

            function weekGetFirstDay(dt) {
                return moment(dt).startOf('week').toDate();
            }
            function weekGetLastDay(dt) {
                return moment(dt).endOf('week').toDate();
            }

            function getYear() {
                return getToday().getFullYear();
            }

            function getMonth() {
                // Um valor inteiro que representa o mês, começando com 0 para Janeiro até 11 para Dezembro.
                return getToday().getMonth() + 1;
            }

            function timestampToDate(timestamp) {
                timestamp = parseInt(timestamp);

                if (isNaN(timestamp)) {
                    return null;
                }

                return moment(timestamp).toDate();
            }

            function getOneYearAgo() {
                return subtract(getToday(), 1, self.UNIT.YEARS);
            }

            function setTime(date, time) {
                return moment(date + ' ' + time);
            }

            function compareOnlyDate(dt1, dt2) {
                if (angular.isUndefined(dt1) || dt1 == null) {
                    return (angular.isUndefined(dt2) || dt2 == null) ? 0 : 1;
                }

                if (angular.isUndefined(dt2) || dt2 == null) {
                    return (angular.isUndefined(dt1) || dt1 == null) ? 0 : -1;
                }

                var result = dt1.getFullYear() - dt2.getFullYear();

                if (result == 0) {
                    result = dt1.getMonth() - dt2.getMonth();
                }

                if (result == 0) {
                    result = dt1.getDate() - dt2.getDate();
                }

                if (result != 0) {
                    result = result > 0 ? 1 : -1;
                }

                return result;
            }

            function getTimeFormatter(item) {
                if (angular.isUndefined(item) || item == null) {
                    return "";
                }

                var hour = item.toString().replace(":", "");

                if (hour.length == 1) {
                    hour = "00:0" + hour;

                } else if (hour.length == 2) {
                    hour = "00:" + hour;

                } else if (hour.length == 3) {
                    hour = "0" + hour.substring(0, 1) + ":" + hour.substring(1);

                } else if (hour.length == 4) {
                    hour = hour.substring(0, 2) + ":" + hour.substring(2);

                } else if (hour.length > 4 && hour.indexOf(":") == -1) {
                    hour = hour.substring(0, hour.length - 2) + ":" + hour.substring(hour.length - 2);
                }

                return hour;
            }

            function minutes2Time(minutes) {
                var time = 0;
                var minute = 0;

                if (isNaN(minutes) || angular.isUndefined(minutes)) {
                    return 0;
                }

                time = Math.trunc(minutes / 60);
                minute = minutes % 60;

                return (time * 100) + minute;
            }

            function getTimeFormatterFromMinutes(minutes) {
                var hour;
                var minute;
                var time;

                if (isNaN(minutes) || angular.isUndefined(minutes)) {
                    return 0;
                }

                minute = minutes % 60;
                hour = Math.floor(minutes / 60);

                if (minute < 10) {
                    if (hour < 10) {
                        time = "0" + hour + ":0" + minute;
                    } else {
                        time = hour + ":0" + minute;
                    }
                } else {
                    if (hour < 10) {
                        time = "0" + hour + ":" + minute;
                    } else {
                        time = hour + ":" + minute;
                    }
                }

                return time;
            }

            function isLastDayOfMonth(date) {
                return getLastDay(date).getDate() == date.getDate();
            }

            function compare(d1, d2, ascending = true) {

                if (!d1 && d2) return 1;
                if (d1 && !d2) return -1;

                var dif = compareOnlyDate(d1, d2);

                let hours = d1.getHours();
                let minutes = d1.getMinutes();
                let seconds = d1.getSeconds();
                let miliseconds = d1.getMilliseconds();

                if (dif == 0) {
                    dif = hours - d2.getHours();
                }
                if (dif == 0) {
                    dif = minutes - d2.getMinutes();
                }
                if (dif == 0) {
                    dif = seconds - d2.getSeconds();
                }
                if (dif == 0) {
                    dif = miliseconds - d2.getMilliseconds();
                }

                if (dif > 0) {
                    return ascending ? 1 : -1;
                }
                if (dif < 0) {
                    return ascending ? -1 : 1;
                }

                return 0;
            }

            function getMinutes(time) {
                var splited = /^(\d{1,2}):(\d{2})?$/.exec(time);
                if (splited != null) {
                    return (Number(splited[1]) * 60) + Number(splited[2]);
                }
                return 0;
            }

            function timeConverter(timestamp) {
                try {
                    var a = new Date(timestamp);
                    var hour = a.getUTCHours();
                    var min = a.getUTCMinutes();
                    var sec = a.getUTCSeconds();
                    return StringUtils.padStart(hour, 2, 0) + ':' +
                        StringUtils.padStart(min, 2, 0) + ':' +
                        StringUtils.padStart(sec, 2, 0);
                } catch (e) {
                    return timestamp;
                }
            }

            function sortValueForDate(unordered) {
                const myList = Object.keys(unordered)
                    .map((key) => {
                        return {
                            date: getValidDate(key),
                            value: unordered[key]
                        };
                    });
                const myListSorted = ArrayUtils.sortByProperty(
                    myList, 'date',
                    function (v1, v2) {
                        return v1 - v2;
                    });
                const ordered = {};
                myListSorted.forEach(function (obj) {
                    ordered[dateToString(obj.date)] = obj.value;
                });
                return ordered;
            }

            function getValidDate(strDate) {
                const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                if (dateRegex.test(strDate)) {
                    return stringToDate(strDate);
                }
                return new Date(strDate);
            }

            function calculateTime(hour, hour2, operation) {
                function timeToMinutes(time) {
                    var parts = time.split(":");
                    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
                }
            
                function minutesToTime(minutes) {
                    var hours = Math.floor(minutes / 60);
                    var mins = minutes % 60;
                    return (hours < 10 ? "0" : "") + hours + ":" + (mins < 10 ? "0" : "") + mins;
                }
            
                var hourMinutes = timeToMinutes(hour);
                var hour2Minutes = timeToMinutes(hour2);
                if(operation == "add"){
                    var resultMinutes = Math.max(0, hourMinutes + hour2Minutes);
                }
                if(operation == "subtract"){
                    var resultMinutes = Math.max(0, hourMinutes - hour2Minutes);
                }
            
                return minutesToTime(resultMinutes);
            }

            function dateTimeToString(dateInput) {
                const day = String(dateInput.getDate()).padStart(2, '0');
                const month = String(dateInput.getMonth() + 1).padStart(2, '0');
                const year = dateInput.getFullYear();
                const hours = String(dateInput.getHours()).padStart(2, '0');
                const minutes = String(dateInput.getMinutes()).padStart(2, '0');
                
                return `${day}/${month}/${year} ${hours}:${minutes}`;
            }

        }]);


angular
    .module('snk.core.util')
    .service('DomUtil', ['UserAgentUtils', '$document', 'PositionUtils', 'AngularUtil', function (UserAgentUtils, $document, PositionUtils, AngularUtil) {
        var self = this;

        var _scrollSize;

        var requestAnimFrame = (function () {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) { window.setTimeout(callback, 1000 / 60); };
        })();

        self.setFocusOnElement = setFocusOnElement;
        self.scrollTo = AngularUtil.debounce(scrollTo, 50);
        self.scrollToChildIndex = AngularUtil.debounce(scrollToChildIndex, 50);
        self.scrollToChild = AngularUtil.debounce(scrollToChild, 50);
        self.clearSkypeInfoFromElement = clearSkypeInfoFromElement;
        self.closest = closest;
        self.querySelector = querySelector;
        self.getScrollBarWidth = getScrollBarWidth;
        self.getScrollBarHeight = getScrollBarWidth;
        self.disableBodyScroll = disableBodyScroll;
        self.simulateClickEvent = simulateClickEvent;
        self.select = select;
        self.selectAll = selectAll;
        self.eventFire = eventFire;
        self.hasScrolling = hasScrolling;

        function querySelector(element, selector) {
            if (angular.isElement(element)) {
                return angular.element(element)[0].querySelector(selector);
            } else {
                throw Error('Elemento inválido para realizar querySelector')
            }
        }

        function disableBodyScroll(val) {
            angular.element($document[0].body).css({
                'position': val ? 'fixed' : 'static'
            });
        }

        function getScrollBarWidth() {
            if (angular.isUndefined(_scrollSize)) {
                var w1;
                var w2;
                var div = angular.element('<div style="width:50px;height:50px;overflow-x:hidden;overflow-y:scroll;position:absolute;top:-200px;left:-200px;"><div style="width:100%;height:100%;"></div></div>');

                angular.element($document[0].body).append(div);

                w1 = div[0].offsetWidth;
                w2 = div.children()[0].offsetWidth;

                div.remove();

                _scrollSize = (w1 - w2);
            }

            return _scrollSize;
        }

        function setFocusOnElement(element, forceOnMobile) {
            if (angular.isElement(element) && (forceOnMobile || !UserAgentUtils.isMobile())) {
                element.focus();
            }
        }

        function clearSkypeInfoFromElement(element) {
            element = angular.element(element || document)[0];

            if (element) {
                angular.element(element.querySelectorAll('.skype_c2c_container')).remove();
                angular.element(element.querySelectorAll('.skype_c2c_print_container')).removeClass('skype_c2c_print_container');
            }
        }

        function closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
            el = angular.element(el)[0];

            if (el) {
                ctx = ctx || document;
                selector = selector.split('.');

                var tag = selector.shift().toUpperCase(),
                    re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

                do {
                    if (
                        (tag === '>*' && el.parentNode === ctx) || (
                            (tag === '' || el.nodeName.toUpperCase() == tag) &&
                            (!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
                        )
                    ) {
                        return el;
                    }
                }
                while (el !== ctx && (el = el.parentNode));
            }

            return undefined;
        }

        function easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) {
                return c / 2 * t * t + b
            }
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        function easeInCubic(t, b, c, d) {
            var tc = (t /= d) * t * t;
            return b + c * (tc);
        }

        function inOutQuintic(t, b, c, d) {
            var ts = (t /= d) * t,
                tc = ts * t;
            return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
        }

        function simulateClickEvent(targetElement) {
            if (!targetElement) {
                return;
            }

            var event = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true
            });

            return angular.element(targetElement)[0].dispatchEvent(event);
        }

        function select(container, query, asAngularElem) {
            container = angular.element(container);

            if (container.length > 0) {
                var elem = container[0].querySelector(query);
                return asAngularElem ? angular.element(elem) : elem;
            } else {
                throw Error('[DomUtil.select] Container indefinido');
            }
        }

        function selectAll(container, query, asAngularElem) {
            container = angular.element(container);

            if (container.length > 0) {
                var elem = container[0].querySelectorAll(query);
                return asAngularElem ? angular.element(elem) : elem;
            } else {
                throw Error('[DomUtil.selectAll] Container indefinido');
            }
        }

        function scrollTo(container, to, callback, duration) {
            duration = (typeof (duration) === 'undefined') ? 250 : duration;
            container = (typeof (container) === 'undefined') ? document : container;

            if (duration < 20) {
                doScrollTop(container, to);
                return;
            }

            var start = angular.element(container).scrollTop(),
                change = to - start,
                currentTime = 0,
                increment = 20;

            var animateScroll = function () {
                // increment the time
                currentTime += increment;
                // find the value with the quadratic in-out easing function
                var val = easeInOutQuad(currentTime, start, change, duration);

                doScrollTop(container, val);

                // do the animation unless its over
                if (currentTime < duration) {
                    requestAnimFrame(animateScroll);
                } else {
                    if (callback && typeof (callback) === 'function') {
                        // the animation is done so lets callback
                        callback();
                    }
                }
            };

            animateScroll();
        }

        function doScrollTop(container, val) {
            angular.element(container).scrollTop(val);
        }

        function scrollToChildIndex(container, currentIndex, callback, duration, increment, options = {}) {
            container = angular.element(container);
            increment = increment || 0;

            var childElem;
            
            if(options.listContainer && container.find(options.listContainer).length > 0){
                childElem = container.find(options.listContainer).children()[currentIndex];
            }else {
                childElem = container.children()[currentIndex];
            }

            var childPosition = PositionUtils.position(childElem);
            var childTop = childPosition.top;
            var childBottom = (childPosition.height + childTop);

            var containerHeight = container[0].offsetHeight;
            var containerScroll = container.scrollTop();

            if ((childBottom - containerScroll) > containerHeight) {
                var diff = childBottom - containerScroll - containerHeight;
                scrollTo(container, containerScroll + diff + increment, callback, duration);
            } else if (childTop < containerScroll) {
                scrollTo(container, childTop, callback, duration);
            }
        }

        function scrollToChild(container, childElem, callback, duration, increment, options = {}) {
            container = angular.element(container);

            var childIndex;

            let containerList = container;

            if(options.listContainer && container.find(options.listContainer).length > 0){
                containerList = container.find(options.listContainer);
            }
            
            Array.prototype.every.call(containerList.children(), function (child, index) {
                if (child === childElem) {
                    childIndex = index
                }
                return child != childElem;
            });

			if (childIndex >= 0) {
            	scrollToChildIndex(container, childIndex, callback, duration, increment, options);
        	}
        }

        function eventFire(el, etype){
            if (el.fireEvent) {
              el.fireEvent('on' + etype);
            } else {
              var evObj = document.createEvent('Events');
              evObj.initEvent(etype, true, false);
              el.dispatchEvent(evObj);
            }
        }

        function hasScrolling(element, direction){
            var dimension = direction == 'x' ? 'Width' : 'Height';
            element = angular.element(element);
            return element['inner' + dimension]() < element[0]['scroll' + dimension];
        }
    }]);

angular
    .module('snk.core.util')
    .service('DropdownUtil', ['$document', '$templateRequest', '$compile', 'PositionUtils', 'StringUtils', 'SkConstants', 'DomUtil', '$q', '$window', '$timeout', function ($document, $templateRequest, $compile, PositionUtils, StringUtils, SkConstants, DomUtil, $q, $window, $timeout) {
        var self = this;
        var BORDER_WIDTH = 2;//Tamanho da borda
        var CLASS_POPUP_OPENED = 'sk-opened';
        var CLASS_POPUP_VISIBLE = 'sk-visible';
        var CONFIG_ID = '$skDropdown';
        var OPEN_CLASS = 'sk-open';

        self.create = create;
        self.open = open;
        self.close = close;
        self.isOpen = isOpen;

        function create(scope, urlPopup) {
            var deferred = $q.defer();

            $templateRequest(urlPopup).then(function(template){
                var UID_CLASS = 'dd-generic-' + StringUtils.nextUid();
                var popupElem = angular.element('<div class="sk-dropdown-popup shadowpanel '+ UID_CLASS +'"></div>');
                popupElem.html(template);
                popupElem = $compile(popupElem)(scope);
                popupElem.data(CONFIG_ID, {uid: UID_CLASS});

                angular.element($document[0].body).append(popupElem);

                deferred.resolve(popupElem);
            }, function(reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function open(popup, elementToTarget, config) {
            if (!popup) {
                return;
            }

            var wWidth;
            var wHeight;
            var posX;
            var posY;
            var width;
            var popupData;
            var offset;
            var popupOffset;

            popup.addClass(CLASS_POPUP_OPENED);

            popupData = popup.data(CONFIG_ID);
            popupData.docBubbleHandler = function(event){
                docBubbleHandler(event, popup);
            };
            popupData.keyDownHandler = function(event){
                keyDownHandler(event, popup);
            };
            popupData.resizeHandler = function(event){
                resizeHandler(event, popup);
            };

            popupData.getTargetElement = function(){
                return elementToTarget;
            };

            setTimeout(function(){
                if (config && config.eventBubbles) {
                    popup.bind(config.eventBubbles, function(e){
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    popupData.eventBubbles = config.eventBubbles;
                    popupData.disableBubblesTarget = config.disableBubblesTarget || false;

                    if (popupData.disableBubblesTarget && !elementToTarget.hasClass(popupData.uid)) {
                        elementToTarget.addClass(popupData.uid);
                    }

                    $document.bind(config.eventBubbles, popupData.docBubbleHandler);
                } else {
                    $document.bind(SkConstants.MOUSE.CLICK, popupData.docBubbleHandler);
                }

                $document.on(SkConstants.EVENTS.KEY_DOWN, popupData.keyDownHandler);

                $window.addEventListener(SkConstants.EVENTS.RESIZE, popupData.resizeHandler);
            }, 0);

            $timeout(function(){
                offset = PositionUtils.offset(elementToTarget);

                if (!config || config.width != 'auto') {
                    width = offset.width - BORDER_WIDTH;

                    if (config.width && config.width > width) {
                        width = config.width;
                    }

                    if (config.maxWidth && width > config.maxWidth) {
                        width = config.maxWidth;
                    }

                    popup.css('width', StringUtils.toPX(width));
                }

                if(config && config.height) {
                    popup.css('height', StringUtils.toPX(config.height));
                }

                posX = offset.left;
                posY = offset.top + offset.height;

                popupOffset = PositionUtils.offset(popup);

                if (posY + popupOffset.height > $document.scrollTop() + $document[0].documentElement.clientHeight) {
                    var p = posY - popupOffset.height - offset.height;

                    if (p >= $document.scrollTop()) {
                        posY = p;
                    }
                }

                if (posX + width > $document[0].documentElement.clientWidth) {
                    posX = $document[0].documentElement.clientWidth - width - 10;
                }

                if(popup[0].clientWidth + posX > $document[0].documentElement.clientWidth){
                    popup.css('right', StringUtils.toPX(0));
                }else{
                    popup.css('left', StringUtils.toPX(posX));
                }
                
                popup.css('top', StringUtils.toPX(posY));
                popup.addClass(CLASS_POPUP_VISIBLE);

                elementToTarget.addClass(OPEN_CLASS);
            }, 0, false);
        }

        function close(popup) {
            var popupData;

            if (!popup) {
                return;
            }

            popup.removeClass(CLASS_POPUP_VISIBLE);
            popup.removeClass(CLASS_POPUP_OPENED);

            popupData = popup.data(CONFIG_ID);

            if (popupData.eventBubbles) {
                $document.unbind(popupData.eventBubbles, popupData.docBubbleHandler);
            } else {
                $document.unbind(SkConstants.MOUSE.CLICK, popupData.docBubbleHandler);
            }

            var targetElem = popupData.getTargetElement();

            if (targetElem) {
                targetElem.removeClass(OPEN_CLASS);
            }

            $document.off(SkConstants.EVENTS.KEY_DOWN, popupData.keyDownHandler);

            $window.removeEventListener(SkConstants.EVENTS.RESIZE, popupData.resizeHandler);
        }

        function docBubbleHandler(event, popup) {
            var popupData = popup.data(CONFIG_ID);
            var dispatchClose = false;
            var elem;

            if (popupData.eventBubbles) {
                dispatchClose = !event.isDefaultPrevented();

                if (popupData.disableBubblesTarget) {
                    elem = DomUtil.closest(event.target, '.' + popupData.uid);

                    if (elem) {
                        dispatchClose = false;
                    }
                }
            } else {
                elem = DomUtil.closest(event.target, '.' + popupData.uid);

                if (!elem) {
                    dispatchClose = true;
                }
            }

            if (dispatchClose) {
                close(popup);
            }
        }

        function isOpen(popup) {
            if (!popup) {
                return false;
            }

            return popup.hasClass(CLASS_POPUP_OPENED);
        }

        function keyDownHandler(event, popup) {
            if (event.keyCode == SkConstants.KEY_CODE.ESCAPE && !event.isDefaultPrevented() && isOpen(popup)) {
                event.preventDefault();

                close(popup);
            }
        }

        function resizeHandler(event, popup) {
            close(popup);
        }
    }]);
angular
    .module("snk.core.util")
    .service("ElectronUtil", [function () {
        var self = this;
        
        self.buildParametersNavigateUrl = buildParametersNavigateUrl;

        function buildParametersNavigateUrl(data, extraHaders){
            var count = 0;
            var parameters = '';

            if(Object.keys(data).length == 0){
                return parameters;
            }

            angular.forEach(data, function(value, key){
                if(count == 0){
                    parameters = '{';
                }else{
                    parameters += ','; 
                }
                parameters += '"' + key + '"' + ' : "' + value + '"';
                count++;
            });
            
            if(extraHaders){
                parameters += ',"extraHeaders" : ' + '"' + extraHaders + '"';
            }
            parameters += "}";
            
            return ('skNavigatorParams=' +  btoa(parameters));
        }
    }]);
angular
    .module("snk.core.util")
    .service("Base64", [function () {

        var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

        this.encode = function (input) {
            return this.encode(input, true);
        }

        this.encode = function (input, isUTF8) {
            if(!input) {
                return '';
            }

            var output = "";
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;
            
            if(isUTF8){
                input = _utf8_encode(input);
            }

            while (i < input.length) {

                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

            }

            return output;
        };

        this.decode = function (input) {
            return this.decode(input, true);
        }

        this.decode = function (input, isUTF8) {
            var output = '';

            if(!input) {
                return '';
            }

            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {

                enc1 = _keyStr.indexOf(input.charAt(i++));
                enc2 = _keyStr.indexOf(input.charAt(i++));
                enc3 = _keyStr.indexOf(input.charAt(i++));
                enc4 = _keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }

            }
            
            if(isUTF8){
                output = _utf8_decode(output);
            }
            
            return output;
        };


        function _utf8_encode(string) {
            string = string.replace(/\r\n/g, "\n");
            var utftext = "";

            for (var n = 0; n < string.length; n++) {

                var c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }

            }

            return utftext;
        }

        function _utf8_decode(utftext) {
            var string = "";
            var i = 0;
            var c = 0, c3 = 0, c2 = 0;

            while (i < utftext.length) {

                c = utftext.charCodeAt(i);

                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                } else if ((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i + 1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);
                    c3 = utftext.charCodeAt(i + 2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }

            }

            return string;
        }

        // convert a Unicode string to a string in which
        // each 16-bit unit occupies only one byte
        this.encodeToBinary = function (string) {
            const codeUnits = new Uint16Array(string.length);
            for (let i = 0; i < codeUnits.length; i++) {
                codeUnits[i] = string.charCodeAt(i);
            }
            const charCodes = new Uint8Array(codeUnits.buffer);
            let result = '';
            for (let i = 0; i < charCodes.byteLength; i++) {
                result += String.fromCharCode(charCodes[i]);
            }

            return btoa(result);
        }
    }]);

/**
 * Created by bruno.brandao on 21/05/2015.
 */
angular
    .module('snk.core.util')
    .filter('dynamicFilter', function($filter) {
        return function(value, filterName) {
            return $filter(filterName)(value);
        };
    });
/**
 * Created by bruno.brandao on 21/05/2015.
 */
angular
    .module('snk.core.util')
    .config(['$provide', function($provide) {
        $provide.decorator('limitToFilter', ['$delegate', function($delegate) {
            function toInt(str) {
                return parseInt(str, 10);
            }

            function isNumber(value) {
                return typeof value === 'number';
            }

            function isString(value) {
                return typeof value === 'string';
            }

            var isArray = Array.isArray;

            return function(input, limit, begin) {

                if (Math.abs(Number(limit)) === Infinity) {
                    limit = Number(limit);
                } else {
                    limit = toInt(limit);
                }
                if (isNaN(limit)) return input;

                if (isNumber(input)) input = input.toString();
                if (!isArray(input) && !isString(input)) return input;

                begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
                begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;

                if (limit >= 0) {
                    return input.slice(begin, begin + limit);
                } else {
                    if (begin === 0) {
                        return input.slice(limit, input.length);
                    } else {
                        return input.slice(Math.max(0, begin + limit), begin);
                    }
                }
            };
        }]);
    }]);
angular
    .module('snk.core.util')
    .provider('FluidBuilder', [function () {

        this.$get = [function () {
            return function (buildFn, variableNames) {
                return new FluidBuilder(buildFn, variableNames);
            }
        }];

        function FluidBuilder(variablesMD, workingObj) {
            var _builder = this;

            var _variables = {};
            var _options = {};

            var _variablesByName = {};

            var _buildFn;

            var _workingObj = workingObj;

            _builder.reset = function() {
                _variables = {};
                _options = {};

                return _builder;
            };

            _builder.workingObj = function (obj) {
                _workingObj = obj;

                return _builder;
            };

            _builder.toFunction = function() {
                return function() {
                    return _builder.reset();
                };
            };

            _builder.buildFn = function (buildFn, buildAlias) {
                _buildFn = buildFn;

                if (angular.isDefined(buildAlias)) {
                    _builder[buildAlias] = function () {
                        return _builder.build();
                    }
                }

                return _builder;
            };

            _builder.build = function () {
                angular.forEach(_variablesByName, function(varMD, key) {
                    var currValue =  varMD.asOption ? _options[key] : _variables[key];

                    if (angular.isUndefined(currValue) && varMD.value) {
                        currValue = varMD.value;
                        (varMD.asOption ? _options : _variables)[key] = currValue;
                    }

                    if (varMD.required && angular.isUndefined(currValue)) {
                        throw Error((varMD.asOption ? 'Opção ' : 'Variável ') + key + ' é requerida e não foi preenchida no builder');
                    }
                });

                return _buildFn(_variables, _options, _workingObj);
            };

            _builder.options = function (opts) {
                _options = opts;
                return _builder;
            };

            _builder.option = function (key, value) {
                _options[key] = value;
                return _builder;
            };

            _builder.fnImpl = function (fnName, implFn) {
                _builder[fnName] = function () {
                    var result = implFn({
                        workingObj: _workingObj,
                        builder: _builder,
                        args: arguments
                    });

                    if (angular.isDefined(result)) {
                        return result;
                    } else {
                        return _builder;
                    }
                };

                return _builder;
            };

            initBuilder();

            function initBuilder() {
                if (angular.isArray(variablesMD)) {
                    variablesMD.forEach(function (variable) {
                        var varName;
                        var implFunction;

                        if (angular.isObject(variable)) {
                            varName = variable.name;

                            if (angular.isFunction(variable.fnImpl)) {
                                implFunction = variable.fnImpl;
                            }

                            _variablesByName[varName] = variable;
                        } else {
                            varName = variable;

                            _variablesByName[varName] = {
                                required: false,
                                asOption: false
                            };
                        }

                        if (angular.isFunction(implFunction)) {
                            _builder.fnImpl(varName, implFunction);
                        } else {
                            _builder[varName] = function (value) {
                                var varMD = _variablesByName[varName];

                                if (angular.isDefined(value) && varMD.transformer) {
                                    var args = Array.prototype.slice.call(arguments);
                                    value = varMD.transformer.apply(_builder, args);
                                }

                                if (varMD.asOption) {
                                    return _builder.option(varName, value);
                                } else {
                                    _variables[varName] = value;
                                    return _builder;
                                }
                            }
                        }
                    });
                }
            }
        }
    }]);
//Serviço baseado na API de fullscreen https://github.com/sindresorhus/screenfull.js/
angular
    .module('snk.core.util')
    .provider('FullscreenUtil', [function () {
        var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

        var fn = (function () {
            var val;
            var valLength;

            var fnMap = [
                [
                    'requestFullscreen',
                    'exitFullscreen',
                    'fullscreenElement',
                    'fullscreenEnabled',
                    'fullscreenchange',
                    'fullscreenerror'
                ],
                // new WebKit
                [
                    'webkitRequestFullscreen',
                    'webkitExitFullscreen',
                    'webkitFullscreenElement',
                    'webkitFullscreenEnabled',
                    'webkitfullscreenchange',
                    'webkitfullscreenerror'

                ],
                // old WebKit (Safari 5.1)
                [
                    'webkitRequestFullScreen',
                    'webkitCancelFullScreen',
                    'webkitCurrentFullScreenElement',
                    'webkitCancelFullScreen',
                    'webkitfullscreenchange',
                    'webkitfullscreenerror'

                ],
                [
                    'mozRequestFullScreen',
                    'mozCancelFullScreen',
                    'mozFullScreenElement',
                    'mozFullScreenEnabled',
                    'mozfullscreenchange',
                    'mozfullscreenerror'
                ],
                [
                    'msRequestFullscreen',
                    'msExitFullscreen',
                    'msFullscreenElement',
                    'msFullscreenEnabled',
                    'MSFullscreenChange',
                    'MSFullscreenError'
                ]
            ];

            var i = 0;
            var l = fnMap.length;
            var ret = {};

            for (; i < l; i++) {
                val = fnMap[i];
                if (val && val[1] in document) {
                    for (i = 0, valLength = val.length; i < valLength; i++) {
                        ret[fnMap[0][i]] = val[i];
                    }
                    return ret;
                }
            }

            return false;
        })();

        var screenfull = {
            request: function (elem) {
                var request = fn.requestFullscreen;

                elem = elem || document.documentElement;

                // Work around Safari 5.1 bug: reports support for
                // keyboard in fullscreen even though it doesn't.
                // Browser sniffing, since the alternative with
                // setTimeout is even worse.
                if (/5\.1[\.\d]* Safari/.test(navigator.userAgent)) {
                    elem[request]();
                } else {
                    elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
                }
            },
            exit: function () {
                document[fn.exitFullscreen]();
            },
            toggle: function (elem) {
                if (this.isFullscreen) {
                    this.exit();
                } else {
                    this.request(elem);
                }
            },
            raw: fn
        };

        Object.defineProperties(screenfull, {
            isFullscreen: {
                get: function () {
                    if (angular.isUndefined(fn)) {
                        throw Error('A API de Fullscreen não está disponível, verifique.');
                    }

                    return Boolean(document[fn.fullscreenElement]);
                }
            },
            element: {
                enumerable: true,
                get: function () {
                    if (angular.isUndefined(fn)) {
                        throw Error('A API de Fullscreen não está disponível, verifique.');
                    }

                    return document[fn.fullscreenElement];
                }
            },
            enabled: {
                enumerable: true,
                get: function () {
                    if (angular.isUndefined(fn)) {
                        return false;
                    }
                    // Coerce to boolean in case of old WebKit
                    return Boolean(document[fn.fullscreenEnabled]);
                }
            }
        });

        this.$get = function () {
            return screenfull;
        };
    }]);
/**
 * @ngdoc service
 * @name snk.core.util.service:HierarchyUtils
 *
 * @description
 * Esse serviço permite lançar mensagens de erro, informativas, confirmação e alertas no sistema.
 */
angular
    .module("snk.core.util")
    .constant("HierarchyContants", {
        "CODE_ROOT_NODE": -999999999,
        "MASK_SEP" : '.'
    })
    .service("HierarchyUtils", ['HierarchyContants', function (HierarchyContants) {
        var self = this;

        self.buildMaskAsString = buildMaskAsString;
		self.buildMask = buildMask;
		self.applyMask = applyMask;
		self.getMaskLength = getMaskLength;

     /**
         * @ngdoc
         * @name HierarchyUtils#buildMaskAsString
         * @methodOf snk.core.util.service:HierarchyUtils
         *
         * @description
         * Método para constuir uma mascara da hierarquica através de uma string.
         *
         * @param {string} [maskBase] mascara.
         *
         * @returns {string} retorna os maskBase com a formatação de mascara.
         */
        function buildMaskAsString(maskBase) {
			var maskArray = buildMask(maskBase);
			return maskArray.join(HierarchyContants.MASK_SEP);
        }
        
         /**
         * @ngdoc
         * @name HierarchyUtils#buildMask
         * @methodOf snk.core.util.service:HierarchyUtils
         *
         * @description
         * Método responsavel por retornar um array com a formatação de uma determinada mascara.
         *
         * @param {string} [toMask] mascara.
         *
         * @returns {array} retorna um array com a formatação da mascara.
         */
        function buildMask(toMask) {
			var maskEnd = toMask.indexOf(';');

			if (maskEnd < 0) {
				maskEnd = toMask.length;
			}

			toMask = toMask.substring(0, maskEnd);

			var levels = toMask.split(".");

			var maskArray = [];
            
            levels.forEach(function(level){
                maskArray.push(level.length);
            });

			return maskArray;
        }
		
		/**
         * @ngdoc
         * @name HierarchyUtils#applyMask
         * @methodOf snk.core.util.service:HierarchyUtils
         *
         * @description
         * Método responsavel por aplicar uma mascara em um determinado valor.
         *
         * @param {string} [mask] mascara.
		 * @param {string} [originalValue] valor.
		 * @param {boolean} [fromLeft = true] se os zeros devem ser adicionados ao final da mascara.
		 * @param {string} [blankChar= " "] caracter a ser adicionado em espaços em branco da mascara.
         *
         * @returns {string} retorna o originalValue com a mascara aplicada.
         */
        function applyMask(mask, originalValue, fromLeft, blankChar){
			fromLeft = fromLeft == undefined ? true : fromLeft;
			blankChar = blankChar || ' ';

			var maskLevels = mask.split(HierarchyContants.MASK_SEP);
			var originalValueParts = originalValue.split(HierarchyContants.MASK_SEP);
			var valueParts = [];
			
			for(var i = 0; i < originalValueParts.length; i++){
				var length = maskLevels[i];
				var part = originalValueParts[i];
				
				var extraZeros = length - part.length ;
				
				if(extraZeros > 0) {
		    		var zeros = replicate(blankChar, extraZeros);
		    		if(fromLeft) {
		    			part = part + zeros;
		    		}else {
		    			part = zeros + part;
		    		}	    			
		  		} 
				
				valueParts.push(part);
			}
			
			var value = valueParts.join("");
			
			
			var maskLength = getMaskLength(maskLevels);
	    	var extraZeros = maskLength - value.length;
	    		    	
	    	if(extraZeros > 0) {
	    		var zeros = replicate(blankChar, extraZeros);
	    		if(fromLeft) {
	    			value = value + zeros;
	    		}else {
	    			value = zeros + value;
	    		}	    			
	    	}	    	
	    	
	    	var excesso = value.length - maskLength;
	    	
	    	if(excesso > 0){
	    		value = value.substring(0, excesso);	    		
	    	}
	    	
	    	var pos = 0;
	    	var maskedCode = "";
	    	
	    	for(var i = 0; i < originalValueParts.length; i++){
	    		for(var j = 0; j < Number(maskLevels[i]); j++ ){
	    			maskedCode = maskedCode  + (value.charAt(pos));
	    			pos++;
	    		}
	    		
	    		if(i < originalValueParts.length - 1){
					maskedCode = maskedCode  + (HierarchyContants.MASK_SEP);
				}
	    	}
	    	 
	    	return maskedCode;
			
		}
		
		/**
         * @ngdoc
         * @name HierarchyUtils#getMaskLength
         * @methodOf snk.core.util.service:HierarchyUtils
         *
         * @description
         * Método responsavel calcular o tamanha de uma detarminada mascara
         *
         * @param {array} [mask] mascara.
         *
         * @returns {number} retorna o tamanho da mascara.
         */
		function getMaskLength(mask) {
	        var length = 0;
	
	        for(var i = 0; i < mask.length; i++) {
	            length += Number(mask[ i ]);
	        }
		
	        return length;
	    }
	    
	    function replicate(pattern, times) {
			var value = "";
			var size = pattern.length * times;
			 
			while(value.length < size){
				value += pattern;
			}
			return value;
		}

    }]);

angular
.module("snk.core.util")
.service('HighchartUtils', ['SkI18nService',
    function(SkI18nService) {
        const VALUE_LANG = SkI18nService.getLang().replace("_", "-");

        const self = this;

        self.defineChartEvents = function (chart, chartName) {
            $("#" + chartName).on('dblclick', function (e) {
                if(e.target.classList.contains("highcharts-scrollbar-button")
                  || e.target.classList.contains("highcharts-scrollbar-track")
                  || e.target.classList.contains("highcharts-scrollbar-thumb")) {
                    return;
                }
                self.toggleFullScreen(chart, chartName);
            });
    
        };
    
        self.toggleFullScreen = function(chart, chartName) {
            $("#top-buttons-" + chartName).toggleClass('modalChart');
            $("#" + chartName).toggleClass('modalChart');
            $("#chart-option-button-" + chartName).toggleClass('modalChart');
    
            if(chart) {
                chart.reflow();
            }
        };
    
        self.formatTime = function (value, small) {
            let horas = Math.floor(value / 60);
            let minutos = Math.floor(value - (horas * 60));
            let result = "";
            if (horas > 0)
                result = horas + "h";
    
            if (minutos > 0 || !small || value == 0)
                result += (minutos < 10 ? "0" : "") + minutos + (!small || horas == 0 ? "min" : "");
    
            return result;
        }
    
        self.showLoadingBar = function(chartName) {
            $("#" + chartName + "LoadingBar").show();
        }
    
        self.hideLoadingBar = function(chartName) {        
            $("#" + chartName + "LoadingBar").hide();
        }
    
        self.resizePaineis = function(paineis) {
            if (paineis)
                paineis.forEach((painel) => {
                    if (painel && painel.component && painel.component.chart)
                        (painel.component.reflow || painel.component.chart.reflow)();
                })
        }
     
        self.resizeChart = function(chart, chartName, options) {
            let element = $("#" + chartName);
            let parentElement = element.closest(".card-charts");
            let width = parentElement.width() -4;
            let height = parentElement.height() -4;
    
            if (width <= 0 || height <= 0) return;
            
            element.width(width);
            element.height(height);
    
            if (options) {
                if (!options.chart) options.chart = {};
                options.chart.height = height;
                chart = Highcharts.chart(chartName, options);
            } else if (chart) {
                chart.reflow();
            }
    
            return chart;
    
        }
    
        self.vhToPx = function (vh) {
            return (document.documentElement.clientHeight / 100) * vh;
        }
    
        self.vwToPx = function (vw) {
            return (document.documentElement.clientWidth / 100) * vw;
        }

        self.formatTime = function (value, small) {
            let horas = Math.floor(value / 60);
            let minutos = Math.floor(value - (horas * 60));
            let result = "";
            if (horas > 0)
                result = horas + "h";
    
            if (minutos > 0 || !small || value == 0)
                result += (minutos < 10 ? "0" : "") + minutos + (!small || horas == 0 ? "min" : "");
    
            return result;
        }

        self.formatNumber = function (value, frac) {
            return value || value === 0 ? value.toLocaleString(VALUE_LANG, {maximumFractionDigits: frac || 2}) : "";
        }

        self.formatMoney = function (value) {
            return value || value === 0 ? value.toLocaleString(VALUE_LANG, {maximumFractionDigits: 2}) : "";
        }

        self.formatPercentage = function (value) {
            return value || value === 0 ? value.toLocaleString(VALUE_LANG, {maximumFractionDigits: 2}) : "";
        }

}]);

angular
    .module("snk.core.util")
    .constant("ServiceProxyConstants", {
        STATUS: {
            ERROR: 0,
            OK: 1,
            INFO: 2,
            TIMEOUT: 3,
            SERVICE_CANCELED: 4
        },
    	LEVEL: {
    		ERROR: 1,
    		WARNING: 2,
        },
        TROUBLE_SHOOT: {
            DEFAULT_CODE: 'no.code'
    	}
    });
angular.module("snk.core.util")
.service("sktk", ['XmlJson', function(XmlJson) {
    var self = this;

    self.y = y;

    function y(content) {
        if (top.charcleaner && typeof top.charcleaner.a === 'function') {
            try {
                var c = angular.toJson(content);

                return top.charcleaner.a(c);

            } catch (e) {
                //se o header, o backend irá tratar o erro
            }
        }
    }
}]);

function ServiceProxyRecaller(serviceName, params, callback, httpService, config){
   this.serviceName = serviceName;
   this.params = params;
   this.callback = callback;
   this.httpService = httpService;
   this.config = config;
};

ServiceProxyRecaller.prototype.reCall = function (params) {
    if (params) {
        this.params = params;
    }
    if (!angular.isObject(this.params)) {
        this.params = {};
    }
    if (angular.isObject(this.config) && angular.isFunction(this.config.callback)) {
        this.config.isReturnCallback = true;
        this.httpService.callService(this.serviceName, this.params, this.config);
    } else {
        this.httpService.callService(this.serviceName, this.params).then(this.callback);
    }
};


angular
.module("snk.core.util")
.service('ServiceProxy', ['$http', '$q', '$log', 'ServiceProxyConstants', 'MessageUtils','UrlUtils', 'StringUtils', 'FluidBuilder', 'Crypt','XmlJson', '$timeout','ObjectUtils','ArrayUtils', 'NetworkMonitor', 'sktk',
    function($http, $q, $log, ServiceProxyConstants, MessageUtils, UrlUtils, StringUtils, FluidBuilder, Crypt, XmlJson, $timeout, ObjectUtils, ArrayUtils, NetworkMonitor, sktk) {
        var DEFAULT_IGNORE_LOADING_BAR = false;
        var DEFAULT_PREVENT_TRANSFORM  = false;
        
        var SERVICE_UNAVAILABLE_CODE = 503;

        var self = this;

        self.setIgnoreLoadingBar = setIgnoreLoadingBar;

        var _counter = 0;
        var _applicationName = '';
        var _globalID;
        var _appKey;
        var _applicationResourceID = '';
        var _clientEventsByID = {};

        const _serializedServiceNames = [];
        const _serializedServicePromises = {};
        
        var _urlParams = UrlUtils.getQueryParams(location.search);

        var _printListeners = [];
        var _localPrintingListeners = [];

        self.addSerializedService = function(serviceName){
            _serializedServiceNames.push(serviceName);
        }
        
        self.addPrintListener = function(printListeners) {
            _printListeners.push(printListeners);
        }
        
        self.addLocalPrintingListener = function(localPrintingListeners) {
            _localPrintingListeners.push(localPrintingListeners);
        }
        
        
        self.builder = function() {
            return FluidBuilder([
                 {name: 'serviceName', required: true},
                 {name: 'ignoreLoadingBar', asOption: true},
                'params'
            ])
            .buildFn(function(variables, options) {
                return self.callService(variables['serviceName'], variables['params'], options);
            }, 'call'); 
        };

        self.setApplicationName = function (name) {
            _applicationName = name;
        };

        self.applicationResourceID = function (applicationResourceID) {
            _applicationResourceID = applicationResourceID;
        };

        self.validateSasSession = function (validateSasSession) {
            self.validateSasSession = validateSasSession;
        };

        self.globalID = function (globalID) {
            _globalID = globalID;
        };

        self.appKey = function (appKey) {
            _appKey = appKey;
        };

        self.getGlobalID = function(){
            return StringUtils.undefinedAsEmpty(_globalID);
        }

        self.addClientEvent = function (eventId, handler) {
            if (_clientEventsByID.hasOwnProperty(eventId)) {
                (_clientEventsByID[eventId]).push(handler);
            } else {
                _clientEventsByID[eventId] = [handler];
            }

            return new ClientEventHandler(eventId, handler, self);
        };

        self.removeClientEvent = function (eventId, handler) {
            if (handler === undefined) {
                delete _clientEventsByID[eventId];
            } else {
                if (_clientEventsByID.hasOwnProperty(eventId)) {
                    var list = _clientEventsByID[eventId];

                    for (var i = 0; i < list.length; i++){
                        var f = list[i];

                        if (f == handler) {
                            list.splice(i, 1);
                            break;
                        }
                    }

                    if (list.length === 0){
                        delete _clientEventsByID[eventId];
                    }
                }
            }
        };
        
        self.addSingleClientEvent = function (eventId, handler) {            
            if(!self.hasClientEvent(eventId)){
            	self.addClientEvent(eventId, handler);
            }
        };

        self.hasClientEvent = function(eventId) {
            return _clientEventsByID.hasOwnProperty(eventId);
        };

        self.callService = function (serviceName, content, config) {

            
            const HTTP_SUPPORT_METHODS = ['POST', 'PUT' , 'DELETE', 'GET'];

            var method = 'POST';

			if (config && angular.isDefined(config.method)){
                method = config.method;
                method = method.toUpperCase();

                if (HTTP_SUPPORT_METHODS.indexOf(method) == -1) {
                    throw new Error("O método não é suportado. Utilizar post, put, delete ou get");
                }
            }
            
            if (config && config.normalizedJson && !config.isReturnCallback) {
                if (XmlJson.isNormalized(content)) {
                    let tagName = content.$name;
                    let contentExt = {};
                    contentExt[tagName] = content;
                    content = JSON.parse(JSON.stringify(contentExt));
                    XmlJson.denormalize(content[tagName]);
                } else {
                    throw new Error("content fornecido não está normalizado. Utilize XmlJson.normalize(content).");
                }
            }  

            var url = UrlUtils.getUrlBase() + "/{0}/service.sbr?serviceName={1}&counter={2}&application={3}&outputType=json&preventTransform={4}";
            var defModule = "mge";

            if (serviceName.indexOf("@") > -1) {
                var s = serviceName.split("@");
                defModule = s[0];
                serviceName = s[1];
            }

            _counter = _counter + 1;

            url = url.replace("{0}", defModule);
            url = url.replace("{1}", serviceName);
            url = url.replace("{2}", _counter);
            url = url.replace("{3}", _applicationName);
            url = url.replace("{4}", (config && config.preventTransform) || DEFAULT_PREVENT_TRANSFORM);

            if(StringUtils.emptyAsNull(_urlParams.mgeSession) != null){
                 url += "&mgeSession=" + _urlParams.mgeSession;
            }
            
            if(_applicationResourceID){
                url += "&resourceID=" + _applicationResourceID;
            }

            if (_globalID) {
                url += "&globalID=" + _globalID;
            }

            if(config && angular.isObject(config.aditionalUrlParameters)){
                angular.forEach(config.aditionalUrlParameters, function(value, key){
                    url += ('&' + key + '=' + value);
                });
            }
       
            if (StringUtils.isNotEmpty(_urlParams.flowID)) {
                url += '&flowID=' + _urlParams.flowID;
            }

            if (StringUtils.isNotEmpty(window.VSS)) {
                url += '&vss=' + window.VSS;
            }

            var requestContent = {
                serviceName: serviceName,
                requestBody: content
            };

            if (ObjectUtils.getProperty(requestContent, 'requestBody')) {
                for (var clientEventId in _clientEventsByID) {
                    if (!requestContent.requestBody.clientEventList) {
                        requestContent.requestBody.clientEventList = {
                            clientEvent: []
                        }
                    }

                    requestContent.requestBody.clientEventList.clientEvent.push({
                        $: clientEventId
                    });
                }
            }

            var deffered = $q.defer();

            //Promise de cancelamento de serviço.
            var deferredAbort = $q.defer();

            if (!config) {
                config = {};
            }

            if (angular.isFunction(config.callback) && angular.isUndefined(config.exceptionCallback)) {
                config.exceptionCallback = (error) => {
                    console.error(error);
                };
            }

            if (!angular.isDefined(config.ignoreLoadingBar)){
                config.ignoreLoadingBar = DEFAULT_IGNORE_LOADING_BAR;
            }

            var httpConfig = {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'appkey': _appKey,
                    'sktk': sktk.y(requestContent)
                },
                timeout: deferredAbort.promise,
                ignoreLoadingBar: config.ignoreLoadingBar
            };
            
            if (method === 'POST' || method === 'PUT') {

                if (config && config.headers) {
                    httpConfig.headers = angular.extend(httpConfig.headers, config.headers);
                }

                httpConfig.data = requestContent;
            }

			httpConfig.method = method;
            httpConfig.url = url;

            const isSerialized = _serializedServiceNames.includes(serviceName);

            let serializedPromise = Promise.resolve();

            if(isSerialized && _serializedServicePromises[serviceName]?.length > 0){
                serializedPromise = _serializedServicePromises[serviceName].pop();
            }

			let callKey = NetworkMonitor.pushCall(url);
			
            function doCallHttp(){
                $http(httpConfig)
                .success(function (data, status, headers) {
                    if (hasStatusError(data)) {

                        if(!data.frameworkDB) {
                            handleServiceError(data, config, deffered);
                        } else{
                            const retorno = JSON.parse(data.frameworkDB);
                            MessageUtils.showWarningTroubleShootingWithStacktrace(retorno);
                            return;
                        }

                    } else if (data.status == ServiceProxyConstants.STATUS.SERVICE_CANCELED) {
                        if (data.statusMessage){
                            logDebug(data.statusMessage);
                        }
                    } else {                       

                        var clonedData = data;
                        
                        if (config && config.normalizedJson) {
                            clonedData = JSON.parse(JSON.stringify(clonedData));
                            XmlJson.normalize(clonedData);
                        }

                        if (angular.isFunction(config.callback)) {
                            config.callback(clonedData);
                        } else {
                            deffered.resolve(clonedData);
                        }

                        if (data.status == ServiceProxyConstants.STATUS.INFO) {
                            /*O timeout eh necessario pois em alguns casos, o popup de aviso esta sendo aberto atras de outro popup
                            aberto pelo success da promisse.
                            */
                            $timeout( () => MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, data.statusMessage), 500);
                        }
                    }

                    // Verificar se o header x-offensive-customization existe
                    const offensiveCustomizationHeader = headers('x-offensive-customization');
                    if (offensiveCustomizationHeader) {
                        showAlertCustomization(offensiveCustomizationHeader);
                    }

                    if (data.clientEvents){
                        for (var i = 0; i < data.clientEvents.length; i++){
                            var clientEvent = data.clientEvents[i];

                            if (self.hasClientEvent(clientEvent.id)){
                                var handlers = _clientEventsByID[clientEvent.id];

                                for (var j = 0; j < handlers.length; j++){
                                    var handler = handlers[j];
                                    handler(clientEvent, new ServiceProxyRecaller((defModule + '@' + serviceName), content, deffered.resolve, self, config));
                                }
                            }
                        }
                    }
                    
                    var pendingPrinting = data.pendingPrinting;
                    if(pendingPrinting == "true") {
                        if(_printListeners.length > 0){
                            var transactionId = data.transactionId;
                            for (i = 0; i < _printListeners.length; i++) {
                                _printListeners[i](transactionId);
                            }
                        }
                    }
                    
                    if(data.hasOwnProperty("localPrintings") && _localPrintingListeners.length > 0){							
                        var arr = data.localPrintings;
                        var transactionIds = [];
                        for(var id in arr){
                            transactionIds.push(arr[id].transactionId);
                        }
                        
                        for (i = 0; i < _localPrintingListeners.length; i++) {
                            _localPrintingListeners[i](transactionIds);
                        }
                    }
                })
                .error(function (data, status, headers, configError) {
                    //Se o request foi programaticamente abortado, não lançamos erro e nem rejeitamos a promise
                    if (deffered.promise.aborted === true) {
                        return;
                    }

                    //Se foi definido errorHandler ele é responsável por tratar o erro
                    if (angular.isFunction(config.errorHandler)) {
                        config.errorHandler(data, status, headers, configError);
                        return;
                    }

                    if(isModuleUpdating(status, headers())) {
                        showModuleUpdatingWarn();
                    } else {
                        var msg = data || configError.data.serviceName;
                        MessageUtils.showError(MessageUtils.TITLE_ERROR, "Erro ao executar serviço. \n" + msg);
                    }

                    if (angular.isFunction(configError.exceptionCallback)) {
                        configError.exceptionCallback(configError.data);
                    } else {
                        deffered.reject(configError.data);
                    }
                }).finally(() => {
                    if(_serializedServicePromises[serviceName]){
                        ArrayUtils.removeReference(_serializedServicePromises[serviceName], deffered.promise, true);
                    }
                    NetworkMonitor.deleteCall(callKey);
                });
            }

            serializedPromise.then(() => doCallHttp(), () => doCallHttp());

            //Função responsável por abortar o request
            deffered.promise.abort = function () {
                deffered.promise.aborted = true;
                deferredAbort.resolve();
            };

            if(isSerialized){
                if(!_serializedServicePromises[serviceName]){
                    _serializedServicePromises[serviceName] = [];
                }
                _serializedServicePromises[serviceName].push(deffered.promise);
            }

            return deffered.promise;
        };

        function handleServiceError(data, config, deferred) {
            const statusMessage = data.statusMessage ? data.statusMessage : 'Erro não identificado.';
            const hasPersonalization = data.hasOwnProperty('personalizationMessage');

            if (hasPersonalization) {
                handlePersonalizationError(data);
            } else {
                handleDefaultSystemError(data, config, statusMessage);
            }

            trackErrorEventAnalytics(data, statusMessage);

            if (angular.isFunction(config.exceptionCallback)) {
                config.exceptionCallback(data);
            } else {
                deferred.reject(data);
            }
        }

        function handlePersonalizationError(data) {
            const tsError = data.tsError;

            if (tsError) {
                handlePersonalizationErrorTroubleShooting(data);
                return;
            }

            const icone = '/mge/assets/svg/puzzle.svg';
            const responseStatus = data.status;
            const moreMsg = Base64.decode(data.personalizationMessage);
            const msg = data.statusMessage;

            const payload = {
                icone: icone,
                msg: msg,
                moreMsg: moreMsg
            }

            if (responseStatus == ServiceProxyConstants.STATUS.ERROR) {
                MessageUtils.showErrorShowMore(payload);
            } else {
                MessageUtils.showAlertShowMore(payload);
            }
        }

        function handlePersonalizationErrorTroubleShooting(data) {
            const moreMsg = Base64.decode(data.personalizationMessage);
            const statusMessage = `${data.statusMessage} \n\n ${moreMsg}`;
            handleTroubleShootingError(data.tsError, statusMessage);
        }

        function handleDefaultSystemError(data, config, statusMessage) {
            if(config?.ignorePopUpErrorMsgs){
                return;
            }

            const tsError = data.tsError;

            if (tsError) {
                handleTroubleShootingError(tsError, statusMessage);
            } else {
                MessageUtils.showError(MessageUtils.TITLE_ERROR, statusMessage);
                logError(statusMessage);
            }
        }

        function hasStatusError(data) {
            return !data.hasOwnProperty('status') ||
                data.status == ServiceProxyConstants.STATUS.ERROR ||
                data.status == ServiceProxyConstants.STATUS.TIMEOUT;
        }

        function handleTroubleShootingError(tsError, statusMessage) {
            const errorCode = tsError.tsErrorCode;
            const errorLevel = tsError.tsErrorLevel;

            if (errorLevel === ServiceProxyConstants.LEVEL.ERROR || errorLevel === 'ERROR') {
                MessageUtils.showErrorTroubleShooting(MessageUtils.TITLE_ERROR, errorCode, statusMessage);
            } else {
                MessageUtils.showWarningTroubleShooting(MessageUtils.TITLE_WARNING, errorCode, statusMessage);
            }

        }

        function trackErrorEventAnalytics(data, statusMessage) {
            const errorCode = data.tsError?.tsErrorCode;
            if (errorCode) {
                trackAnalyticsEvent("error_msg", errorCode, statusMessage);
            } else {
                trackAnalyticsEvent("error_msg", Crypt.md5(statusMessage), statusMessage);
            }
        }

        function isModuleUpdating(status, headers) {
            return status == SERVICE_UNAVAILABLE_CODE && headers['x-skw-module-updating'];
        }

        function showModuleUpdatingWarn() {
            MessageUtils.showModuleUpdatingWarn();
        }

        function trackAnalyticsEvent(category, action, label){
            (workspace?.trackAnalyticsEvent || angular.noop)(category, action, label);
        }
        
        function logDebug(message) {
            if (message){
                $log.debug('[ServiceProxy] ' + message);
            }
        }

        function logError(message) {
            if (message){
                $log.error('[ServiceProxy] ' + message);
            }
        }

        /* @ngdoc
        * @name PopUpParameter#builder
        * @methodOf snk.components.popupparameter.service:PopUpParameter
        * @description
        * Método responsável por criar um novo Builder de PopupParameter
        */
        function builder() {
            return new ServiceProxyBuilder();
        }

        function setIgnoreLoadingBar(ignore){
            DEFAULT_IGNORE_LOADING_BAR = ignore;
        }

        function ClientEventHandler(eventId, handler, serviceProxy) {
            var _eventId = eventId;
            var _handler = handler;
            var _serviceProxy = serviceProxy;

            this.unregistry =  function unregistry(){
                _serviceProxy.removeClientEvent(_eventId, _handler);
            }
        }

        function showAlertCustomization(headerContent) {
            if(window.workspace && window.workspace.showCustomizationScreenMessage) {
                window.workspace.showCustomizationScreenMessage(headerContent)
            }
        }
}]);

angular
    .module("snk.core.util")
    .service("ImportImageUtils", ['SkI18nService', 'MessageUtils', 'SkApplication', 'AppletUtils', function (SkI18nService, MessageUtils, SkApplication, AppletUtils) {
        var self = this;

        const TIPO_PRODUTOS = 'R';
        const TIPO_PARCEIRO = 'P';
        const importacaoImagemApplet = 'importacaoImagemApplet';
        const appletImportacaoImagem = 'appletImportacaoImagem';

        self.mostraImportadorDeImagem = (codProd, tipo, callBack) => {
            
        	if(AppletUtils.validateAppletRunning(importacaoImagemApplet)){
                var swfElement = SkApplication.instance().getElement();
				swfElement[appletImportacaoImagem] = callBack;
				
                var applet = document.getElementById(importacaoImagemApplet);

				if(applet == null){
				    alert("Erro Interno: Applet não definido para a aplicação");
				} else {
				    applet.showImportador(codProd, swfElement[appletImportacaoImagem]());
				}
            } else {
                MessageUtils.showError(SkI18nService.instant('Geral.anexoErrorTitle'),
                                       SkI18nService.instant('Geral.javaPluginError'));
            }
        }

    }]);
angular
    .module('snk.core.util')
    .constant('KeyboardEvents', {
        'FIND': 'keyboardevent.FIND',
        'FIND_ENTITY': 'keyboardevent.FIND_ENTITY',
        'CHANGE_FACE_KEY': 'keyboardevent.CHANGE_FACE_KEY',
        'SAVE_KEY': 'keyboardevent.SAVE_KEY',
        'ADD_KEY': 'keyboardevent.ADD_KEY',
        'DELETE_KEY': 'keyboardevent.DELETE_KEY',
        'CANCEL_KEY': 'keyboardevent.CANCEL_KEY',
        'NEXT_KEY': 'keyboardevent.NEXT_KEY',
        'PREVIOUS_KEY': 'keyboardevent.PREVIOUS_KEY',
        'NEXT_TAB': 'keyboardevent.NEXT_TAB',
        'PREVIOUS_TAB': 'keyboardevent.PREVIOUS_TAB',
        'REFRESH_DS': 'keyboardevent.REFRESH_DS'
    });
angular
    .module('snk.core.util')
    .factory('KeyboardManager', ['$window', '$timeout', 'SkConstants', function ($window, $timeout, SkConstants) {
        var self = this;
        var keyboardManagerService = {};
        var defaultOpt = {
            'type': 'keydown',
            'propagate': false,
            'inputDisabled': false,
            'target': $window.document,
            'keyCode': false
        };

        // Work around for stupid Shift key bug created by using lowercase - as a result the shift+num combination was broken
        var shift_nums = {
            "`": "~",
            "1": "!",
            "2": "@",
            "3": "#",
            "4": "$",
            "5": "%",
            "6": "^",
            "7": "&",
            "8": "*",
            "9": "(",
            "0": ")",
            "-": "_",
            "=": "+",
            ";": ":",
            "'": "\"",
            ",": "<",
            ".": ">",
            "/": "?",
            "\\": "|"
        };
        // Special Keys - and their codes
        var special_keys = {
            'esc': 27,
            'escape': 27,
            'tab': 9,
            'space': 32,
            'return': 13,
            'enter': 13,
            'backspace': 8,

            'scrolllock': 145,
            'scroll_lock': 145,
            'scroll': 145,
            'capslock': 20,
            'caps_lock': 20,
            'caps': 20,
            'numlock': 144,
            'num_lock': 144,
            'num': 144,

            'pause': 19,
            'break': 19,

            'insert': 45,
            'home': 36,
            'delete': 46,
            'end': 35,

            'pageup': 33,
            'page_up': 33,
            'pu': 33,

            'pagedown': 34,
            'page_down': 34,
            'pd': 34,

            'left': 37,
            'up': 38,
            'right': 39,
            'down': 40,

            'f1': 112,
            'f2': 113,
            'f3': 114,
            'f4': 115,
            'f5': 116,
            'f6': 117,
            'f7': 118,
            'f8': 119,
            'f9': 120,
            'f10': 121,
            'f11': 122,
            'f12': 123
        };

        let resourceIDSAvoidDuplicates = ['br.com.sankhya.mgecom.mov.PdvWeb'];

        // Store all keyboard combination shortcuts
        keyboardManagerService.keyboardEvent = {};
        keyboardManagerService.isControl = isControl;
        keyboardManagerService.isFunctionKey = isFunctionKey;
        keyboardManagerService.isVerticalMovement = isVerticalMovement;
        keyboardManagerService.isHorizontalMovement = isHorizontalMovement;

        // Add a new keyboard combination shortcut
        keyboardManagerService.bind = function (label, callback, opt) {
            var fct, elt, code, k;

            // Initialize opt object
            opt = angular.extend({}, defaultOpt, angular.isObject(opt) ? opt : {});
            label = label.toLowerCase();
            elt = opt.target;

            // Avoid duplicates entries of shortcut
            if (opt['avoidDuplicates'] && keyboardManagerService.keyboardEvent[label]){
                return;
            }

            if (typeof opt.target == 'string') {
                elt = document.getElementById(opt.target);
            }

            fct = function (e) {
                e = e || $window.event;

                // Disable event handler when focus input and textarea
                if (opt['inputDisabled']) {
                    var elt;
                    if (e.target) elt = e.target;
                    else if (e.srcElement) elt = e.srcElement;
                    if (elt.nodeType == 3) elt = elt.parentNode;
                    if (elt.tagName == 'INPUT' || elt.tagName == 'TEXTAREA') return;
                }

                // Find out which key is pressed
                if (e.keyCode) code = e.keyCode;
                else if (e.which) code = e.which;
                var character = String.fromCharCode(code).toLowerCase();

                if (code == 188) character = ","; // If the user presses , when the type is onkeydown
                if (code == 190) character = "."; // If the user presses , when the type is onkeydown

                var keys = label.split("+");
                // Key Pressed - counts the number of valid keypresses - if it is same as the number of keys, the shortcut function is invoked
                var kp = 0;

                // Some modifiers key
                var modifiers = {
                    shift: {
                        wanted: false,
                        pressed: e.shiftKey ? true : false
                    },
                    ctrl: {
                        wanted: false,
                        pressed: e.ctrlKey ? true : false
                    },
                    alt: {
                        wanted: false,
                        pressed: e.altKey ? true : false
                    },
                    meta: { //Meta is Mac specific
                        wanted: false,
                        pressed: e.metaKey ? true : false
                    }
                };
                // Foreach keys in label (split on +)
                for (var i = 0, l = keys.length; k = keys[i], i < l; i++) {
                    switch (k) {
                        case 'ctrl':
                        case 'control':
                            kp++;
                            modifiers.ctrl.wanted = true;
                            break;
                        case 'shift':
                        case 'alt':
                        case 'meta':
                            kp++;
                            modifiers[k].wanted = true;
                            break;
                    }

                    if (k.length > 1) { // If it is a special key
                        if (special_keys[k] == code) kp++;
                    } else if (opt['keyCode']) { // If a specific key is set into the config
                        if (opt['keyCode'] == code) kp++;
                    } else { // The special keys did not match
                        if (character == k) kp++;
                        else {
                            if (shift_nums[character] && e.shiftKey) { // Stupid Shift key bug created by using lowercase
                                character = shift_nums[character];
                                if (character == k) kp++;
                            }
                        }
                    }
                }

                if (kp == keys.length &&
                    modifiers.ctrl.pressed == modifiers.ctrl.wanted &&
                    modifiers.shift.pressed == modifiers.shift.wanted &&
                    modifiers.alt.pressed == modifiers.alt.wanted &&
                    modifiers.meta.pressed == modifiers.meta.wanted) {

                    callback(e);

                    if (!opt['propagate']) { // Stop the event
                        // e.cancelBubble is supported by IE - this will kill the bubbling process.
                        e.cancelBubble = true;
                        e.returnValue = false;

                        // e.stopPropagation works in Firefox.
                        if (e.stopPropagation) {
                            e.stopPropagation();
                            e.preventDefault();
                        }

                        return false;
                    }
                }

            };

            // Store shortcut
            keyboardManagerService.keyboardEvent[label] = {
                'callback': fct,
                'target': elt,
                'event': opt['type']
            };

            //Attach the function with the event
            if (elt.addEventListener) {
                elt.addEventListener(opt['type'], fct, false);
            } else if (elt.attachEvent) {
                elt.attachEvent('on' + opt['type'], fct);
            } else {
                elt['on' + opt['type']] = fct;
            }
        };

        // Remove the shortcut - just specify the shortcut and I will remove the binding
        keyboardManagerService.unbind = function (label) {
            label = label.toLowerCase();
            var binding = keyboardManagerService.keyboardEvent[label];

            delete (keyboardManagerService.keyboardEvent[label]);

            if (!binding) return;

            var type = binding['event'],
                elt = binding['target'],
                callback = binding['callback'];

            if (elt.detachEvent) {
                elt.detachEvent('on' + type, callback);
            }  else if (elt.removeEventListener) {
                elt.removeEventListener(type, callback, false);
            } else {
                elt['on' + type] = false;
            }
        };

        //Valida se a instância da tela está presente no array de telas para acionar o gatilho de evitar duplicamento de função por atalho.
        keyboardManagerService.avoidDuplicates = function (resourceID) {
            if(resourceIDSAvoidDuplicates.includes(resourceID)){
                defaultOpt.avoidDuplicates = true;
            }
        }

        function isControl(e) {
            var keyCode = e.which;

            switch (keyCode) {
                case SkConstants.KEY_CODE.COMMAND:
                case SkConstants.KEY_CODE.SHIFT:
                case SkConstants.KEY_CODE.CTRL:
                case SkConstants.KEY_CODE.ALT:
                    return true;
            }

            if (e.metaKey) {
                return true;
            }

            return false;
        }

        function isFunctionKey(keyCode) {
            keyCode = keyCode.which ? keyCode.which : keyCode;

            return keyCode >= 112 && keyCode <= 123;
        }

        function isVerticalMovement(keyCode) {
            return (SkConstants.KEY_CODE.UP_ARROW === keyCode || SkConstants.KEY_CODE.DOWN_ARROW === keyCode);
        }

        function isHorizontalMovement(keyCode) {
            return (SkConstants.KEY_CODE.LEFT_ARROW === keyCode || SkConstants.KEY_CODE.RIGHT_ARROW === keyCode || SkConstants.KEY_CODE.BACKSPACE === keyCode || SkConstants.KEY_CODE.DELETE === keyCode);
        }

        return keyboardManagerService;
    }]);
/**
 * @ngdoc service
 * @name snk.core.util.service:skMedia
 *
 * @description
 * Esse serviço provê o registro da media querie informada e no momento que skMedia é chamado ele valida
 * se a media querie está de acordo com a media querie da janela.
 *
 * Ele aceita que seja repassado media queries validas do CSS e também as media queries pré-configuradas
 * no nosso framework 'sm', 'gt-sm', 'md', 'gt-md', 'lg' ou 'gt-lg'.
 * Para saber a faixa que as media queries pré-configuradas atuam, veja a
 * constante {@link snk.core.util:SkConstants SkConstants}.
 *
 * @example
    <example module="app">
        <file name="exemplo.html">
            <div ng-controller="ExampleController" layout-padding>
                <p>Media querie padrão 'md' é valida? {{ querieDefault }}</p>
                <p>Media querie padrão 'min-width: 1000px' é valida? {{ querieMinWidth }}</p>
            </div>
        </file>
        <file name="app.js">
            angular.module('app', ['snk'])
                .controller('ExampleController', function($scope, skMedia){
                    $scope.querieDefault = skMedia('md');
                    $scope.querieMinWidth = skMedia('min-width: 1000px');
                });
        </file>
    </example>
 */
angular
    .module("snk.core.util")
    .factory('skMedia', ['SkConstants', '$rootScope', '$window', function (SkConstants, $rootScope, $window) {
        var queries = {};
        var results = {};

        return skMedia;

        function skMedia(query) {
            var validated = queries[query];
            if (angular.isUndefined(validated)) {
                validated = queries[query] = validate(query);
            }

            var result = results[validated];
            //if (angular.isUndefined(result)) {
               result = add(validated);
            //}

            return result;
        }

        function validate(query) {
            return SkConstants.MEDIA[query] || ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
        }

        function add(query) {
            var result = $window.matchMedia(query);
            result.addListener(onQueryChange);

            return (results[result.media] = !!result.matches);
        }

        function onQueryChange(query) {
            $rootScope.$evalAsync(function () {
                results[query.media] = !!query.matches;
            });
        }
    }]);
/**
 * @ngdoc service
 * @name snk.core.util.service:MessageUtils
 *
 * @description
 * Esse serviço permite lançar mensagens de erro, informativas, confirmação e alertas no sistema.
 */
angular
	.module("snk.core.util")
    .service("MessageUtils", ['StringUtils', '$q', '$http', '$timeout', '$window', 'i18n', 'SanPopup', '$rootScope', 'ButtonThemes', 'ObjectUtils', 'SkWorkspace','FluidBuilder', 'ServiceProxyConstants',
     function(StringUtils, $q, $http, $timeout, $window, i18n, SanPopup, $rootScope, ButtonThemes, ObjectUtils, SkWorkspace, FluidBuilder, ServiceProxyConstants){
       
        var self = this;

        self.TITLE_ERROR = i18n('Geral.msgTitleErro');
        self.TITLE_INTERNALERROR = i18n('Geral.msgTitleErroInterno');
        self.TITLE_WARNING = i18n('Geral.msgTitleAviso');
        self.TITLE_CONFIRMATION = i18n('Geral.msgTitleConfirmacao');
        self.TITLE_INFORMATION = i18n('Geral.msgTitleInformacao');
        
        self.MSG_ERROR_CODE = i18n('Geral.msgErrorCode');
        self.MSG_ALERT_CODE = i18n('Geral.msgAlertCode');
        self.MSG_LEARN_MORE = i18n('Geral.msgLearnMore');
        self.MSG_MODULE_UPDATING = 'O módulo está em processo de atualização. Tente novamente em instantes.';

        var _moduleUpdateWarnVisible = false;
        self.showModuleUpdatingWarn = function showModuleUpdatingWarn() {
            if (!_moduleUpdateWarnVisible) {
                _moduleUpdateWarnVisible = true;
                self.showAlert(self.TITLE_WARNING, self.MSG_MODULE_UPDATING)
                    .then(function () { _moduleUpdateWarnVisible = false; });
            }
        };

        self.showInfo = showInfo;
        self.showError = showError;
        self.showAlert = showAlert;
        self.showAlertWithConfirm = showAlertWithConfirm;
        self.showErrorShowMore = showErrorShowMore;
        self.showInfoShowMore = showInfoShowMore;
        self.showAlertShowMore = showAlertShowMore;
        self.simpleConfirm = simpleConfirm;
        self.confirm = confirm;
        self.showErrorTroubleShooting = showErrorTroubleShooting;
        self.showWarningTroubleShooting = showWarningTroubleShooting;
        self.showWarningTroubleShootingWithStacktrace = showWarningTroubleShootingWithStacktrace;
        self.confirmSerialized = confirmSerialized;
        self.showAlertOptionNotDisplay = showAlertOptionNotDisplay;
        self.simpleConfirmOptionApplyForAll = simpleConfirmOptionApplyForAll;

        self.simpleConfirmBuilder = FluidBuilder([
            {name: 'title', value: self.TITLE_CONFIRMATION, required: true, transformer: i18n},
            {name: 'msg', required: true, transformer: i18n},
            {name: 'showAsWarning', value: false},
            {name: 'emitMessage', value: false},
            {name: 'okLabel', value: i18n('Geral.buttonSim')},
            {name: 'noLabel', value: i18n('Geral.buttonNao')},
            {name: 'okTheme', value: 'primary'},
            {name: 'focusOnButton', value: 'ok'}
        ])
        .buildFn(function(variables) {
            return simpleConfirm(variables.title, variables.msg, variables.showAsWarning, variables.emitMessage, {
                okLabel: variables.okLabel,
                noLabel: variables.noLabel,
                okTheme: variables.okTheme,
                focusOnButton: variables.focusOnButton
            });
        }, 'show').toFunction();

        self.confirmBuilder = FluidBuilder([
            {name: 'title', value: self.TITLE_CONFIRMATION, required: true, transformer: i18n},
            {name: 'msg', required: true, transformer: i18n},
            {name: 'showAsWarning', value: false},
            {name: 'emitMessage', value: false},
            {name: 'okLabel', value: i18n('Geral.buttonSim'), transformer: i18n},
            {name: 'noLabel' ,value: i18n('Geral.lblNo'), transformer: i18n},
            {name: 'cancelLabel', transformer: i18n},
            {name: 'showBtnCancel', value: true},
            {name: 'okTheme', value: 'primary'},
            {name: 'noBtnClass'}
        ])
        .buildFn(function(variables) {
            return confirm(variables.title, variables.msg, variables.okLabel, variables.noLabel, variables.showAsWarning, variables.emitMessage, {
                okTheme: variables.okTheme,
                cancelLabel: variables.cancelLabel,
                showBtnCancel: variables.showBtnCancel,
                noBtnClass: variables.noBtnClass
            });
        }, 'show').toFunction();
        
        self.errorBuilder = FluidBuilder([
            {name: 'title', value: self.TITLE_ERROR},
            {name: 'msg', required: true, transformer: i18n}
        ])
        .buildFn(function(variables) {
            return showError(variables.title, variables.msg, variables.okLabel, variables.noLabel, variables.showAsWarning, variables.emitMessage, {
                okTheme: variables.okTheme
            });
        }, 'show').toFunction();

        /**
         * @ngdoc
         * @name MessageUtils#showInfo
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens informativas.
         *
         * @param {string} [title=TITLE_INFORMATION] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         *
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         */
        function showInfo(title, msg, emitMessage){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_INFORMATION;
            }

            var promise = $q.defer();
            var popupInstance = SanPopup.open({
                title: title,
                template: getTemplate(msg),
                size: 'alert',
                showBtnCancel: false,
                type: 'primary',
                okBtnClass: 'btn-default',
                windowClass: 'modal-message',
                largeBottomButtons: true
            });

            popupInstance.result.then(function(){
                promise.resolve();
            }, function(){
                promise.resolve();
            });

            if(emitMessage === true) {
                emitMessageOpened();
            }
            return promise.promise;
        }

        /**
         * @ngdoc
         * @name MessageUtils#showError
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de erro.
         *
         * @param {string} [title=TITLE_ERROR] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         *
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         */
        function showError(title, msg, emitMessage){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_ERROR;
            }

            var promise = $q.defer();
            var popupInstance = SanPopup.open({
                title: title,
                template: getTemplate(msg),
                size: 'alert',
                showBtnCancel: false,
                type: 'danger',
                okBtnClass: 'btn-default',
                windowClass: 'modal-message',
                largeBottomButtons: true
            });

            popupInstance.result.then(function(){
                promise.resolve();
            }, function(){
                promise.resolve();
            });

            if(emitMessage === true) {
                emitMessageOpened
            }
            return promise.promise;
        }

        /**
         * @ngdoc
         * @name MessageUtils#showAlert
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta.
         *
         * @param {string} [title=TITLE_WARNING] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         *
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         */
        function showAlert(title, msg, emitMessage){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_WARNING;
            }

            var promise = $q.defer();
            var popupInstance = SanPopup.open({
                title: title,
                template: getTemplate(msg),
                size: 'alert',
                showBtnCancel: false,
                type: 'warning',
                okBtnClass: 'btn-default',
                windowClass: 'modal-message',
                largeBottomButtons: true
            });

            popupInstance.result.then(function(){
                promise.resolve();
            }, function(){
                promise.resolve();
            });

            if(emitMessage === true) {
                emitMessageOpened();
            }
            return promise.promise;
        }

        /**
         * @ngdoc
         * @name MessageUtils#showAlertWithConfirm
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta com confirmação obrigatória.
         *
         * @param {string} [title=TITLE_CONFIRMATION] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         *
         * @returns {Promise} retorna uma promessa com a possibilidade de executar funções na
         * confirmação da mensagem e também na não-confirmação da mensagem.
         */
         function showAlertWithConfirm(title, msg, emitMessage,addOptions){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_CONFIRMATION;
            }

            var options={
                title: title,
                template: getTemplate(msg),
                size: 'alert',
                type: 'warning',
                okBtnClass: 'btn-default',
                backdrop: 'static',               
                showBtnNo: true,
                okBtnLabel: i18n('Geral.buttonSim'),
                showIconClose: false,
                showBtnCancel: false,
                keyboard: false,
                windowClass: 'modal-message',
                largeBottomButtons: true
            }
           
            if(angular.isDefined(addOptions)){               
                ObjectUtils.forEachInObject(addOptions, function(key,value){
                    options[key]=value;
                });                  
            }
        
            var popupInstance = SanPopup.open(options);

            if(emitMessage === true) {
                emitMessageOpened();
            }

            return popupInstance.result;
        }

        /**
         * @ngdoc
         * @name MessageUtils#simpleConfirm
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de confirmação apenas com os botões de Sim e Não.
         *
         * @param {string} [title=TITLE_CONFIRMATION] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         * @param {boolean} showAsWarning Exibe ou não a mensagem como um 'Warning'
         *
         * @returns {httpPromise} retorna uma promessa com a possibilidade de executar funções na
         * confirmação da mensagem e também na não-confirmação da mensagem.
         */
        function simpleConfirm(title, msg, showAsWarning, emitMessage, options){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_CONFIRMATION;
            }

            var popupInstance = SanPopup.open({
                title: title,
                template: getTemplate(msg),
                size: 'alert',
                type: showAsWarning ? 'warning' : 'gray',
                okBtnClass: ButtonThemes.getClassForTheme(ObjectUtils.getProperty(options, 'okTheme') || 'primary'),
                windowClass: 'modal-message',
                backdrop: 'static',
                okBtnLabel: i18n(ObjectUtils.getProperty(options, 'okLabel')) || i18n('Geral.buttonSim'),
                noBtnLabel: i18n(ObjectUtils.getProperty(options, 'noLabel')) || i18n('Geral.buttonNao'),
                showBtnNo: true,
                showIconClose: false,
                showBtnCancel: false,
                keyboard: false,
                largeBottomButtons: true,
                focusOnButton: ObjectUtils.getProperty(options, 'focusOnButton')
            });

            if(emitMessage === true) {
                emitMessageOpened();
            }

            return popupInstance.result;
        }


         /**
         * @ngdoc
         * @name MessageUtils#simpleConfirmOptionApplyForAll
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de confirmação apenas com os botões de Sim e Não.
         *
         * @param {string} [title=TITLE_CONFIRMATION] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         * @param {boolean} showAsWarning Exibe ou não a mensagem como um 'Warning'
         *
         * @returns {httpPromise} retorna uma promessa com a possibilidade de executar funções na
         * confirmação da mensagem e também na não-confirmação da mensagem.
         */
         function simpleConfirmOptionApplyForAll(title, msg, showAsWarning, emitMessage, options) {
             if (arguments.length === 1) {
                 msg = title;
                 title = self.TITLE_CONFIRMATION;
             }

             return $q(function (resolve, reject) {
                 var popupInstance = SanPopup.open({
                     title: title,
                     template: (options && options.fnGetTpl) ? options.fnGetTpl() : getTemplateOptionApplyForAll(msg, ObjectUtils.getProperty(options, 'cbxLabel')),
                     controller: 'MessageUtilControlador',
                     size: 'alert',
                     type: showAsWarning ? 'warning' : 'gray',
                     okBtnClass: ButtonThemes.getClassForTheme(ObjectUtils.getProperty(options, 'okTheme') || 'primary'),
                     windowClass: 'modal-message',
                     backdrop: 'static',
                     okBtnLabel: i18n(ObjectUtils.getProperty(options, 'okLabel')) || i18n('Geral.buttonSim'),
                     noBtnLabel: i18n(ObjectUtils.getProperty(options, 'noLabel')) || i18n('Geral.buttonNao'),
                     showBtnNo: true,
                     showIconClose: false,
                     showBtnCancel: false,
                     keyboard: false,
                     largeBottomButtons: true,
                     focusOnButton: ObjectUtils.getProperty(options, 'focusOnButton')
                 });

                 if (emitMessage === true) {
                     emitMessageOpened();
                 }

                 popupInstance.result.then((result) => {
                     resolve(result);
                 }, (result) => {
                     reject(result);
                 });
             });
         }

        function getTemplateOptionApplyForAll(msg, cbxLabel = 'Aplicar para todos') {
            var template =  StringUtils.newBuffer();
            template.append('<table>'); 
	        template.append('   <tr><td>').append(replaceLineBreak(msg)).append('</td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td>');
            template.append('      <sk-checkbox ng-model="indeterminate">' + cbxLabel + '</sk-checkbox>');
            template.append('   </td></tr>');
            template.append('</table>');
                
            return template.toString();
        }

        /**
         * @ngdoc
         * @name MessageUtils#showAlertOptionNotDisplay
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta.
         *
         * @param {string} [title=TITLE_WARNING] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         * @param {boolean} showAsWarning Exibe ou não a mensagem como um 'Warning'
         *
         * @returns {httpPromise} retorna uma promessa com a possibilidade de executar funções na
         * confirmação da mensagem e também na não-confirmação da mensagem.
         */
         function showAlertOptionNotDisplay(title, msg) {
             if (arguments.length === 1) {
                 msg = title;
                 title = self.TITLE_WARNING;
             }

             return $q(function (resolve, reject) {
                 SanPopup.open({
                     title: title,
                     template: getTemplateOptionNotDisplay(msg),
                     controller: 'MessageUtilControlador',
                     size: 'alert',
                     type: 'warning',
                     okBtnClass: 'btn-default',
                     windowClass: 'modal-message',
                     backdrop: 'static',
                     size: 'alert',
                     showBtnCancel: false,
                     type: 'warning',
                     okBtnClass: 'btn-default',
                     windowClass: 'modal-message',
                     largeBottomButtons: true
                 }).result.then(function (result) {
                      resolve(result);
                 });
             });
         }

        function getTemplateOptionNotDisplay(msg) {
            var template =  StringUtils.newBuffer();
            template.append('<table>'); 
	        template.append('   <tr><td>').append(replaceLineBreak(msg)).append('</td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td><p></p></td></tr>');
            template.append('   <tr><td>');
            template.append('      <sk-checkbox ng-model="indeterminate">Não exibir novamente</sk-checkbox>');
            template.append('   </td></tr>');
            template.append('</table>');
                
            return template.toString();
        }

        /**
         * @ngdoc
         * @name MessageUtils#confirm
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de confirmação padrão com a possibilidade de cancelamento pelo
         * usuário.
         *
         * @param {string} [title=TITLE_CONFIRMATION] Título da mensagem.
         * @param {string} msg Mensagem para apresentação.
         * @param {string} okBtnLabel Label personalizado para o botão 'Sim'.
         * @param {string} noBtnLabel Label personalizado para o botão 'Não'.
         * @param {boolean} showAsWarning Exibe ou não a mensagem como um 'Warning'.
         *
         * @example
         * ```js
         * MessageUtils
         *   .confirm('Você deseja fechar?')
         *   .then(function(){
         *       //sucesso
         *   }, function(reason){
         *       if (reason === 'no') {
         *           //clicou no botão 'Não'
         *       } else {
         *           //clicou em outro local para fechar a mensagem
         *       }
         *   });
         * ```
         *
         * @returns {httpPromise} retorna uma promessa com a possibilidade de executar funções na
         * confirmação da mensagem, na não-confirmação e também quando o usuário cancelar/fechar a mensagem
         * por outras funcionalidades de fechamento presente.
         */
        function confirm(title, msg, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_CONFIRMATION;
            }

            var popupInstance = SanPopup.open({
                title: title,
                template: getTemplate(msg),
                size: 'alert',
                type: showAsWarning ? 'warning' : 'gray',
                okBtnClass: ButtonThemes.getClassForTheme(ObjectUtils.getProperty(options, 'okTheme') || 'primary'),
                windowClass: 'modal-message',
                okBtnLabel: okBtnLabel || i18n('Geral.buttonSim'),
                showBtnNo: (options && options.showBtnNo != undefined) ? options.showBtnNo : true,
                noBtnLabel: noBtnLabel || i18n('Geral.lblNo'),
                cancelBtnLabel: (options && options.cancelLabel),
                noBtnClass: (options && options.noBtnClass),
                largeBottomButtons: true,
                showBtnCancel: (options && options.showBtnCancel != undefined) ? options.showBtnCancel: true
            });

            if(emitMessage === true) {
                emitMessageOpened();
            }
            return popupInstance.result;
        }

        function getTemplate(msg){
            return '<div>' + replaceLineBreak(msg) + '</div>';
        }

        function emitMessageOpened() {
            if(angular.isDefined($rootScope)) {
                $rootScope.$emit('MessageOpened');
            }
        }

        function showPopupShowMore({title, icone, msg, moreMsg, type}) {
            if(StringUtils.isEmpty(moreMsg)) {
                moreMsg = i18n('EntityCard.semInformacoes');
            }

            if(StringUtils.isEmpty(type)) {
                type = 'warning';
            }

            const template = `
                <sk-vbox id="show-more-message" class="container-show-more-msg">
                    <sk-vbox class="container-absolute-msg" flex>
                        <sk-vbox class="container-msg" ng-bind-html="msg"></sk-vbox>
                        <sk-vbox class="container-more-msg" ng-if="showMoreInfo" flex>
                            <span ng-bind-html="moreMsg"></span>
                        </sk-vbox>
                    </sk-vbox>
                </sk-vbox>
                <sk-hbox class="container-show-more-button" layout-align="end end">
                    <button ng-click="showMore()" default ng-show="!showMoreInfo" sk-i18n>Geral.lblVerDetalhes</button>
                    <button ng-click="showMore()" default ng-show="showMoreInfo" sk-i18n>Geral.lblVerMenos</button>
                    <button ng-click="fechar()" default sk-i18n>Geral.lblOK</button>
                </sk-hbox>
            `;

            var popupInstance = SanPopup.open({
                title: title,
                template: template,
                iconTitle: icone,
                controller: 'MessageShowMoreControlador',
                size:'alert',
                type: type,
                okBtnClass: 'btn-default',
                windowClass: 'modal-message modal-show-more ' + type,
                backdrop: 'static',
                okBtnClass: 'btn-default',
                showBtnCancel: false,
                showBtnOk:false,
                resolve: {
                    data: {
                        msg: msg,
                        moreMsg: moreMsg
                    }
                }
            });

            var promise = $q.defer();
            popupInstance.result.then(function(){
                promise.resolve();
            }, function(){
                promise.resolve();
            });

            return promise.promise;
        }
        
        /**
         * @ngdoc
         * @name MessageUtils#showAlertShowMore
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta com opção de ver mais detalhes
         * @param {Object} params({title, icone, msg, moreMsg}).
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         * MessageUtils.showAlertShowMore({
         *       msg:"Mensagem de aviso", 
         *       moreMsg:"<b>Informação</b> mais <br/>detalhada sobre a mensagem"
         * });
         */
        function showAlertShowMore({title, icone, msg, moreMsg}){
            if (StringUtils.isEmpty(title)) {
                title = self.TITLE_WARNING;
            }

            return showPopupShowMore({title, icone, msg, moreMsg, type: 'warning'});
        }

        /**
         * @ngdoc
         * @name MessageUtils#showErrorShowMore
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta com opção de ver mais detalhes
         * @param {Object} params({title, icone, msg, moreMsg}).
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         * MessageUtils.showErrorShowMore({
         *       msg:"Mensagem de erro", 
         *       moreMsg:"<b>Informação</b> mais <br/>detalhada sobre a mensagem"
         * });
         */
        function showErrorShowMore({title, icone, msg, moreMsg}){
            if (StringUtils.isEmpty(title)) {
                title = self.TITLE_ERROR;
            }

            return showPopupShowMore({title, icone, msg, moreMsg, type: 'danger'});
        }

        /**
         * @ngdoc
         * @name MessageUtils#showInfoShowMore
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta com opção de ver mais detalhes
         * @param {Object} params({title, icone, msg, moreMsg}).
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         * MessageUtils.showInfoShowMore({
         *      msg:"Mensagem de informação", 
         *      moreMsg:"<b>Informação</b> mais <br/>detalhada sobre a mensagem"
         *  });
         */
        function showInfoShowMore({title, icone, msg, moreMsg}){
            if (StringUtils.isEmpty(title)) {
                title = self.TITLE_INFORMATION;
            }
            return showPopupShowMore({title, icone, msg, moreMsg, type: 'primary'});
        }

        /**
         * @ngdoc
         * @name MessageUtils#showErrorTroubleShooting
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de erro para o TroubleShooting.
         *
         * @param {string} [title=TITLE_ERROR] Título da mensagem.
         * @param {string} errorCode Codigo de erro.
         * @param {string} msg Mensagem para apresentação.
         * @param {string} wikiLocale Url para pagina de ajuda wiki
         * @param {string} company Nome da empresa
         * @param {string} exibe o tipo de erro
         *
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         */
        function showErrorTroubleShooting(title, errorCode, msg, emitMessage){
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_ERROR;
            }        
                        
            var promise = $q.defer();
            var popupInstance = SanPopup.open({
                title: title,
                template: getTroubleShootingTemplate(errorCode, msg, i18n('Geral.lblCodigoTroubleshooting')),
                size: 'alert',
                showBtnCancel: false,
                type: 'danger',
                okBtnClass: 'btn-default',
                windowClass: 'modal-message',
                largeBottomButtons: true,
                showBtnTroubleshooting: (errorCode != ServiceProxyConstants.TROUBLE_SHOOT.DEFAULT_CODE)
            });

            popupInstance.result.then(function(){
                promise.resolve();
            }, function(source){
                if(source == 'troubleshooting'){
                	openMoreDetail(errorCode);
                }
                promise.resolve();
            });

            if(emitMessage === true) {
                emitMessageOpened
            }
            return promise.promise;
        }
        
        /**
         * @ngdoc
         * @name MessageUtils#showWarningTroubleShooting
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de alerta  para o TroubleShooting.
         *
         * @param {string} [title=TITLE_WARNING] Título da mensagem.
         * @param {string} errorCode Codigo de erro.
         * @param {string} msg Mensagem para apresentação.
         * @param {string} wikiLocale Url para pagina de ajuda wiki
         * @param {string} company Nome da empresa
         * @param {string} exibe o tipo de erro
         *
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         */
    
        function showWarningTroubleShooting(title, errorCode, msg, emitMessage){
        	
            if (arguments.length === 1) {
                msg = title;
                title = self.TITLE_WARNING;
            }
            
            var promise = $q.defer();
            var popupInstance = SanPopup.open({
                title: title,
                template: getTroubleShootingTemplate(errorCode, msg, i18n('Geral.lblCodigoTroubleshooting')),
                size: 'alert',
                showBtnCancel: false,
                type: 'warning',
                okBtnClass: 'btn-default',
                windowClass: 'modal-message',
                largeBottomButtons: true,
                showBtnTroubleshooting: (errorCode != ServiceProxyConstants.TROUBLE_SHOOT.DEFAULT_CODE)
            });

            popupInstance.result.then(function(){                    
                promise.resolve();
            }, function(source){
                if(source == 'troubleshooting'){
                	openMoreDetail(errorCode);
                }
                promise.resolve();
            });

            if(emitMessage === true) {
                emitMessageOpened();
            }
            return promise.promise;
        }

        /**
         * @ngdoc
         * @name MessageUtils#showWarningTroubleShootingWithStacktrace
         * @methodOf snk.core.util.service:MessageUtils
         *
         * @description
         * Método para lançar mensagens de erro para o TroubleShooting com Stacktrace.
         *
         * @param {string} [title=TITLE_ERROR] Título da mensagem.
         * @param {string} errorCode Codigo de erro.
         * @param {string} msg Mensagem para apresentação.
         * @param {string} tipoErro Mensagem para apresentação.
         * @param {string} traceError Mensagem de Stacktrace.
         * @param {string} wikiLocale Url para pagina de ajuda wiki
         * @param {string} company Nome da empresa
         * @param {string} exibe o tipo de erro
         *
         * @returns {Promise} retorna uma promessa resolvida, a função de sucesso da promessa acontece
         * quando o usuário fechar a mensagem.
         */
        function showWarningTroubleShootingWithStacktrace(
            retorno,
            emitMessage, 
            isFullMessage = false
        ){
            var promise = $q.defer();
            var popupStacktrace = SanPopup.open({
                title: retorno.tipoErro === 'CRITICO' ? 'Erro' : 'Aviso',
                template: getTroubleShootingTemplateWithStacktrace(
                     retorno.codigo,
                     retorno.mensagemErro, 
                     retorno.objeto,
                     retorno.tipoErro,
                     retorno.traceError, 
                     isFullMessage
                     ),
                size: 'alert',
                showBtnCancel: false,
                type: retorno.tipoErro === 'CRITICO' ? 'danger' : 'warning',
                okBtnClass: 'btn-default',
                showBtnNo: true,
                okBtnLabel: 'Ok',
                noBtnLabel: isFullMessage == false ? 'Detalhes' : 'Ver menos',
                windowClass: 'modal-message',
                largeBottomButtons: true
            });
            
            //Antes da exibição do poup
            popupStacktrace.rendered.then(function(){})

            popupStacktrace.result.then(function(){
                promise.resolve();
            }, function(source){
                if(source === 'no'){
                    isFullMessage = !isFullMessage;
                    showWarningTroubleShootingWithStacktrace(retorno, emitMessage, isFullMessage);
                }
            });

            if(emitMessage === true) {
                emitMessageOpened();
            }
            return promise.promise;
        }

        function getTroubleShootingTemplate(errorCode, msg, type){        	
            var template =  "<table>" +	       
                                "<tr><td>" + replaceLineBreak(msg) + "</td></tr>" +
                            "<tr><td><p></p></td></tr>";

            if(errorCode != ServiceProxyConstants.TROUBLE_SHOOT.DEFAULT_CODE){
                    template += "<tr><td><p></p></td></tr>" +
                                    "<tr><td>" + type + ": " + errorCode + "</td></tr>" +
                                "</table>";
            }

            template += "</table>";

            return template;
        }

        function getTroubleShootingTemplateWithStacktrace(codigo, mensagemErro, objeto, tipoErro, traceError, isFullMessage){
            if (isFullMessage) {
                var template = "<table>" +
                    "<tr><td>" + "<strong>Regra Personalizada:</strong>" + "</td></tr>" +
                    "<tr><td><p></p></td></tr>" +
                    "<tr><td>" + mensagemErro + "</td></tr>" +
                    "<tr><td><p></p></td></tr>" +
                    '<tr><td><strong>Código: </strong>' + codigo + '</td></tr>' +
                    "<tr><td><p></p></td></tr>" +
                    '<tr><td> <strong>Regra:</strong> ' + objeto + '</td></tr>' +
                    "<tr><td><p></p></td></tr>" +
                    "<tr><td>" + "<strong>Mensagem: </strong>" + "</td></tr>" +
                    "<tr><td><p></p></td></tr>" +
                    '<tr><td>' + traceError + '</td></tr>' +
                    "<tr><td><p></p></td></tr>";
            } else {
                var template = "<table>" +
                    "<tr><td>" + "<strong>Regra Personalizada: </strong>" + "</td></tr>" +
                    "<tr><td><p></p></td></tr>" +
                    "<tr><td>" + mensagemErro + "</td></tr>" +
                    "<tr><td><p></p></td></tr>";
            }

            template += "</table>";

            return template;
        }
        
        function openMoreDetail(errorCode){
            SkWorkspace.openHelp('_tbcode:' + errorCode);
            SkWorkspace.trackAnalyticsEvent('troubleshooting', errorCode, errorCode);
        }
        
        function confirmSerialized(title, confirms, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options, def, numberOfMsgs){

            if (arguments.length === 1) {
                confirms = title;
                title = self.TITLE_CONFIRMATION;
            }

            if(!confirms.length || confirms.length === 0){
                throw new Error('É obrigatorio informar uma ou mais mensagens.');
            }

            if(!def){
                //Fazemos o reverse no array pois na recusão a mensagem a ser apresentada se inicia da ultima posição do array 
                confirms.reverse();
                numberOfMsgs = confirms.length;
                def = $q.defer();
            };
            var actualConfirm = confirms[numberOfMsgs - 1];
            
            confirm(title, actualConfirm.message, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options).then(function(res){
                if(angular.isFunction(actualConfirm.onOk)){
                    actualConfirm.onOk();
                }
                
                serializedResolveOrContinue(title, confirms, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options, def, numberOfMsgs);
                
            },function(){
                if(angular.isFunction(actualConfirm.onCancel)){
                    actualConfirm.onCancel();
                }                
                if(actualConfirm.continueOnCancel){
                    serializedResolveOrContinue(title, confirms, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options, def, numberOfMsgs);    
                }else{
                    def.reject();
                }
            });

            return def.promise;
        }

        function serializedResolveOrContinue(title, confirms, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options, def, numberOfMsgs){
            if(numberOfMsgs != 1){
                confirmSerialized(title, confirms, okBtnLabel, noBtnLabel, showAsWarning, emitMessage, options, def, (numberOfMsgs - 1));
            }else{
                def.resolve();
            }
        }

        function replaceLineBreak(msg) {
            return (angular.isDefined(msg) ? msg : '').toString().split('\n').join('<br />');
        }

        }]).controller('MessageUtilControlador', ['$scope', '$popupInstance', 'StringUtils',
            function ($scope, $popupInstance, StringUtils) {
                $scope.$success = function() {
                    $popupInstance.success(StringUtils.toBoolean($scope.indeterminate));
                };

                $scope.$dismiss = function () {
                    $popupInstance.dismiss(StringUtils.toBoolean($scope.indeterminate));
                };

                
            }]).controller('MessageShowMoreControlador', ['$scope', '$popupInstance', 'data', '$timeout',
                function ($scope, $popupInstance, data, $timeout) {
                    $scope.showMoreInfo = false;
                    $scope.msg = data.msg;
                    $scope.moreMsg = data.moreMsg;

                    $scope.fechar = () => {
                        $scope.$success();
                    };

                    $popupInstance.opened.then(() =>{
                        let popUpShowMore = document.getElementById("show-more-message");
                        var _popup = (popUpShowMore!=null)?document.getElementById("show-more-message").parentElement:document.getElementsByClassName('modal-body')[0];
                        _popup.style.height = '550px';
                        $timeout(() =>{
                            var _popup = (popUpShowMore!=null)?document.getElementById("show-more-message").parentElement:document.getElementsByClassName('modal-body')[0];
                            _popup.style.height = $scope.getResponsiveHeightInPx();
                        }, 100)
                    })
                    
                    $scope.showMore = () => {
                        $scope.showMoreInfo = !$scope.showMoreInfo;
                        
                        var _popup = document.getElementsByClassName('modal-body')[0];
                        _popup.style.height = $scope.getResponsiveHeightInPx();
                       
                        $popupInstance.center();
                    }

                    $scope.getResponsiveHeightInPx = () =>{
                        const divHeight = document.getElementsByClassName('container-msg')[0].offsetHeight;
                        const showMoreSizeAddSize = $scope.showMoreInfo ? 90 : 0;
                        if(!divHeight) return (550 + showMoreSizeAddSize) + 'px';
                        
                        if(divHeight < 250){
                            return (180 + (showMoreSizeAddSize != 0 ? 35 : showMoreSizeAddSize)) + 'px';
                        }else{
                            return (550 + showMoreSizeAddSize) + 'px';
                        }
                    }
            }]);

angular
	.module("snk.core.util")
	.service("NetworkMonitor", [function () {
		
		var self = this;
		var openedCalls = {};
		self.pushCall = pushCall;
		self.deleteCall = deleteCall;
		self.getOpenedCalls = getOpenedCalls;
		self.containsOpenedCalls = containsOpenedCalls;
		
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		function pushCall(url) {
			try{
				let key = buildIdCall();
				openedCalls[key] =
				{
					"url": url,
					"timeIni": (new Date()).getTime()
				}
				sessionStorage.setItem("openedCalls", JSON.stringify(openedCalls));
				return key;
			} catch (ignored) { }
		}

		function deleteCall(key) {
			try{
				delete openedCalls[key];
				sessionStorage.setItem("openedCalls", JSON.stringify(openedCalls));
			}catch (ignored) { }
		}

		function containsOpenedCalls() {
			return Object.keys(openedCalls).length > 0;
		}

		function getOpenedCalls() {
			return openedCalls;
		}

		function buildIdCall() {
			let result = '';
			const charactersLength = characters.length;
			let counter = 0;
			while (counter < 20) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
				counter += 1;
			}
			return result;
		}

	}]);

angular
    .module("snk.core.util")
    .config(function (LangPTBR) {
        numeral.language('pt-br', LangPTBR);
        numeral.language('pt-br');
    });
angular
    .module('snk.core.util')
    .constant("LangPTBR", {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mil',
            million: 'milhões',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: 'R$'
        }
    });
angular
    .module('snk.core.util')
    .service('NumberUtils', ['StringUtils', function (StringUtils) {
        var REGEX_SCIENTIFIC_PARTS = /^([+-])?(\d+).?(\d*)[eE]([-+]?\d+)$/;

        var self = this;

        self.format = format;
        self.formatWithoutThousandSeparator = formatWithoutThousandSeparator;
        self.stringToNumber = stringToNumber;
        self.formatNumber = formatNumber;
        self.getNumberOrDefault = getNumberOrDefault;
        self.getNumberOrZero = getNumberOrZero;
        self.getNumberOrNull = getNumberOrNull;
        self.decimalToHex = decimalToHex;
        self.hexToDecimal = hexToDecimal;
        self.round = round;
        self.cientificNotationToStrNumber = cientificNotationToStrNumber;
        self.isScientificNotation = isScientificNotation;
        self.getScientificNotationFormatted = getScientificNotationFormatted;
        self.bytesToSize = bytesToSize;
        self.add = add;
	    self.compareNumber = compareNumber;
        self.isNumeric = isNumeric;
        self.isFloat = isFloat;
        self.isInt = isInt;
        self.numberToString = numberToString;
        
        function add(number1, number2, scale=2) {
            var n1 = isNaN(number1) ? 0 : number1;
            var n2 = isNaN(number2) ? 0 : number2;
            return round(n1 + n2, scale);
        }

        function getNumberOrDefault(value, defaultValue) {
            value = StringUtils.isEmpty(value) ? undefined : value;
            value = Number(value);

            if (isNaN(value)){
                return Number(defaultValue);
            }

            return value;
        }

        function getNumberOrZero(value) {
            return getNumberOrDefault(value, 0);
        }

        function format(value, precision, prettyPrecision) {
            var mask = '0,0';

            if (precision > 0) {
                mask += '.';

                for (var i = 0; i < precision; i++) {
                    mask += '0';
                }
            }

            value = StringUtils.isEmpty(value) ? undefined : value;

            if (isNaN(value) || !isFinite(value)){
                return undefined;
            } else {
                if(isScientificNotation(value)){
                    formatted = getScientificNotationFormatted(value, precision);
                }else{
                    formatted = numeral(value).format(mask);
                }

                if (angular.isDefined(prettyPrecision) && prettyPrecision > -1) {
                    var decimalSeparator = numeral.languageData().delimiters.decimal;

                    var parts = formatted.split(decimalSeparator);
                    var fraction = parts[1];

                    if (angular.isDefined(fraction)) {
                        while (fraction.length > prettyPrecision && fraction.charAt(fraction.length - 1) == '0') {
                            fraction = fraction.substring(0, fraction.length - 1);
                        }

                        if (emptyAsUndefined(fraction) === undefined) {
                            formatted = parts[0];
                        } else {
                            formatted = parts[0] + decimalSeparator + fraction;
                        }
                    }
                }

                return formatted;
            }
        }

        function formatWithoutThousandSeparator(value, precision, prettyPrecision) {
            var mask = '0';

            if (precision > 0) {
                mask += '.';

                for (var i = 0; i < precision; i++) {
                    mask += '0';
                }
            }

            value = StringUtils.isEmpty(value) ? undefined : value;

            if (isNaN(value) || !isFinite(value)){
                return undefined;
            } else {
                if(isScientificNotation(value)){
                    formatted = getScientificNotationFormatted(value, precision);
                }else{
                    formatted = numeral(value).format(mask);
                }

                if (angular.isDefined(prettyPrecision) && prettyPrecision > -1) {
                    var decimalSeparator = numeral.languageData().delimiters.decimal;

                    var parts = formatted.split(decimalSeparator);
                    var fraction = parts[1];

                    if (angular.isDefined(fraction)) {
                        while (fraction.length > prettyPrecision && fraction.charAt(fraction.length - 1) == '0') {
                            fraction = fraction.substring(0, fraction.length - 1);
                        }

                        if (emptyAsUndefined(fraction) === undefined) {
                            formatted = parts[0];
                        } else {
                            formatted = parts[0] + decimalSeparator + fraction;
                        }
                    }
                }

                return formatted;
            }
        }

        function formatNumber(value, acceptDecimals){
            if (value){
                value = value.toString();

                var negative = (value.charAt(0) == '-');

                if (acceptDecimals == false){
                    value = value.replace(/[^\d]/g, '');
                } else {
                    value = value.replace(/[^\d.,]/g, '');
                }

                if (negative) {
                    value = '-' + value; 
                }
            }

            return value;
        }

        function stringToNumber(value) {
            if(angular.isUndefined(value) || value === '' || value === null) {
                return NaN;
            }

            if (value) {
                value = value.toString();

                var negative = (value.charAt(0) === '-');
                
                if(!isScientificNotation(value)){
                    value = value.replace(/[^\d.,]/g, '');
                }else{
                    value = value.replace(/^-/g, '');
                }

                var indexV = value.indexOf(',');
                var indexP = value.indexOf('.');

                if (indexP > indexV) {
                    value = value.replace(',', '');
                } else if (indexP < indexV) {
                    value = value.replace(/\./g, '@').replace(',', '.').replace(/@/g, '');
                }

                if (negative) {
                    value = '-' + value;
                }
            }

            return Number(value);
        }

        function emptyAsUndefined(s) {
            if (s == undefined || s.length == 0) {
                return undefined;
            }

            var trimed = '';

            if(angular.isFunction(s.trim)) {
                trimed = s.trim();
            }

            return trimed.length == 0 ? undefined : trimed;
        }

        function getFloatFormat(value) {
            return FLOAT_FORMATER.format(value);
        }

        function decimalToHex(number) {
            if(angular.isUndefined(number)) {
                return undefined;
            }

            if(typeof number == 'string' && !isNaN(number)) number = Number(number);

            return number.toString(16);
        }

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
         }

        function hexToDecimal(number) {
            if(angular.isUndefined(number)) {
                return undefined;
            }
            
            return parseInt(number, 16);
        }
        
        function round(value, decimals) {
        	return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        }

        function cientificNotationToStrNumber(value){
            if(value == undefined){
                return value;
            }
            var strValue = value.toString();
            var eIndex = strValue.indexOf('e');

            if(eIndex > -1){
                var result = REGEX_SCIENTIFIC_PARTS.exec(strValue);
                var sign = result[1];
                var first = result[2];
                var last =  result[3];
                var exp =  parseInt(result[4]);
                if (!exp){
                    return (sign ? sign : "") + (first ? first : "0") + (last ? "." + last : "");
                }

                var r = first + last;
                
                var decimal = exp < 0;

                if (decimal){   
                    var o = -1 * (first.length + exp) + 1;
                    return (sign ? sign : "") + "0." + new Array(o).join("0") + r;
                }else{
                    var i = exp + first.length;
                    if (i >= r.length)
                        return (sign ? sign : "") + r + new Array(i - r.length + 1).join("0");
                    else
                        return (sign ? sign : "") + r.substr(0,i) + "." + r.substr(i);
                }
            }else{
                return value;
            }
        }

        function isScientificNotation(value){
            return REGEX_SCIENTIFIC_PARTS.test(value);
        }
        
        function getScientificNotationFormatted(value, precision) {
            if(typeof value == 'string') value = parseFloat(value);
            if(precision == undefined) precision = 0;
            return value.toLocaleString('pt-BR', { minimumFractionDigits: precision });
        }

        function numberToString(value, precision){
            stringValue = Number(value).toFixed(precision);
						
            let parts = stringValue.split('.');
            let integerPart = parts[0];
            let decimalPart = parts[1];
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return integerPart + ',' + decimalPart;
        }

        /*
        function getScientificNotationFormatted(value, precision){
            var decimalSeparator = numeral.languageData().delimiters.decimal;
            var thousandsSeparator = numeral.languageData().delimiters.thousands;
            
            var formatted = '';
            var tmpValue = cientificNotationToStrNumber(value);
        */   
            /*O js desconsidera casas decimais em numerais com notação cientifica,
             *então não é necessário fazer a tratativa para decimais.
             *var indexPrecision = value.indexOf('.');
             *var decimalValue = indexPrecision > -1 ? tmpValue.substring(indexPrecision, tmpValue.length) : undefined;
             *var noDecimalNumber = indexPrecision > -1 ? tmpValue.substring(0, indexPrecision) : tmpValue;
            */
         /*   
            var countGroups = 0;
            for(var i = (tmpValue.length); i > 0; i--){
                countGroups++;
                formatted = tmpValue[i-1] + formatted;
                if((countGroups % 3) == 0 && i != (tmpValue.length - 1)){
                    formatted = thousandsSeparator + formatted;
                }
            }

            if(precision){
                var decimalValue = '';
                for(var i = 0; i < precision; i++){
                    decimalValue += '0';
                }
                formatted += StringUtils.isEmpty(decimalValue) ? '' : (decimalSeparator + decimalValue);
            }

            return formatted;
        }
        */

        function compareNumber(o1, o2, ascending = true){
			var n1;
			var n2;

			if( o1 == undefined ){
				if(o2 == undefined){
					return 0;
				}else{
					return ascending ? -1 : 1;
				}
			} else if(o2 == undefined) {
				return ascending ? 1 : -1;
			}
		
	    	if(angular.isString(o1)){
	    		n1 = stringToNumber(o1);
	    	} else {
	    		n1 = Number(o1);
	    	}
	    	
	    	if(angular.isString(o2)){
	    		n2 = stringToNumber(o2);
	    	} else {
	    		n2 = Number(o2);
	    	}
    	
			var dif = 0;

			if(ascending){
				dif = n1 - n2;
			} else {
				dif = n2 - n1;
			}
			return (dif > 0) ? 1 : (dif < 0) ? -1 : 0;
		}

        function getNumberOrNull(value) {
            const valueAux = Number(value);
            return isNaN(valueAux) ? null : valueAux;
        }

        function isNumeric(str) {
            if(typeof str == "number") return true;
            if (typeof str != "string") return false;
            return !isNaN(str) && !isNaN(parseFloat(str));
        }

        function isFloat(value) {
            if (angular.isString(value)) {
                value = stringToNumber(value);
            }
            return angular.isNumber(value) && !isNaN(value) && Number(value) === value && value % 1 !== 0;
        }

        function isInt(value) {
            if (angular.isString(value)) {
                value = stringToNumber(value);
            }
            return angular.isNumber(value) && !isNaN(value) && Number(value) === value && value % 1 === 0;
        }
    }]);
angular
    .module("snk.core.util")
    .service("ObjectUtils", ['ArrayUtils', function (ArrayUtils) {
        var self = this;

        self.defineProperty = defineProperty;
        self.bindProperty = bindProperty;
        self.forEachInObject = forEachInObject;
        self.isImplementorOf = isImplementorOf;
        self.extend = extend;
        self.implements = implementsFn;
        self.getFunctionFromObject = getFunctionFromObject;
        self.sizeOf = sizeOf;
        self.isEmpty = isEmpty;
        self.getEmptyAsUndefined = getEmptyAsUndefined;
        self.setProperty = setProperty;
        self.getProperty = getProperty;
        self.removeProperty = removeProperty;
        self.defaultValues = defaultValues;
        self.valueFn = valueFn;
        self.equals = equals;
        self.buildPublicAPI = buildPublicAPI;
        self.buildPublicAPIFromObject = buildPublicAPIFromObject;
        self.clone = clone;
        self.setPropetyWithHierarchy = setPropetyWithHierarchy;
        self.objectToHash = objectToHash;
        self.cloneJSON = cloneJSON;
        self.filterOnObject = filterOnObject;
	    self.getAsArray = getAsArray;
        self.entries = entries;
        self.getSafelyJson = getSafelyJson;

        function filterOnObject(obj, predicate) {
            Object.filter = (obj, predicate) =>
                Object.keys(obj)
                    .filter(key => predicate(obj[key]))
                    .reduce((res, key) => (res[key] = obj[key], res), {});

            return Object.filter(obj, predicate); 
        }

        function getEmptyAsUndefined(obj) {
           return isEmpty(obj) ? undefined : obj;
        }

        function setProperty(obj, path, value, pathSeparator) {
            if (angular.isUndefined(obj)){
                obj = {};
            }

            var pathArr = path.split(pathSeparator || '.');

            if (pathArr.length > 0) {
                var currObj = obj;

                for (var i = 0, len = pathArr.length; i < len; i++) {
                    var currPath = pathArr[i];

                    if ((i + 1) == len) {
                        currObj[currPath] = value;
                    } else {
                        currObj = obj[currPath];

                        if (angular.isUndefined(currObj)) {
                            obj[currPath] = currObj = {};
                        }
                    }
                }
            } else {
                obj[path] = value;
            }

            return obj;
        }

        function getAsArray(obj, path, testFlatPaths, pathSeparator) {
            var result = getProperty(obj, path, testFlatPaths, pathSeparator);

            if ((result != null) && ! Array.isArray(result)) {
                result = [ result ];
            }

            return result;
        }

        function getProperty(obj, path, testFlatPaths, pathSeparator) {
            if (angular.isDefined(obj) && obj != null) {
                var pathArr = path.split(pathSeparator || '.');

                if (pathArr.length > 1) {
                    var currObj = obj;

                    for (var i = 0, len = pathArr.length; i < len; i++) {
                        var currPath = pathArr[i];

                        if ((i + 1) == len) {
                            return currObj[currPath];
                        } else {
                        	if (angular.isDefined(currObj[currPath])){
                                currObj = currObj[currPath];
                            } else if (testFlatPaths) {
                                var flatPath = angular.copy(pathArr).splice(i, pathArr.length).join('.');

                                if (currObj.hasOwnProperty(flatPath)) {
                                    return currObj[flatPath];
                                } else {
                                    return undefined;
                                }
                            } else {
                                return undefined;
                            }

                            if (angular.isUndefined(currObj)) {
                                return undefined;
                            }
                        }
                    }
                } else {
                    return obj[path];
                }
            }

            return undefined;
        }

        function removeProperty(obj, path, pathSeparator) {
            if (angular.isUndefined(obj) || obj == null){
                return undefined;
            }

            var pathArr = path.split(pathSeparator || '.');

            if (pathArr.length > 0) {
                var currObj = obj;

                for (var i = 0, len = pathArr.length; i < len; i++) {
                    var currPath = pathArr[i];

                    if ((i + 1) == len) {
                        if (currObj && currObj.hasOwnProperty(currPath)) {
                            var value = currObj[currPath];
                            delete currObj[currPath];
                            return value;
                        }
                    } else {
                        currObj = currObj[currPath];

                        if (angular.isUndefined(currObj)) {
                            return undefined;
                        } else if (currObj == null) {
                            return null;
                        }
                    }
                }
            }

            return obj;
        }

        function isEmpty(obj) {
            if (angular.isUndefined(obj) || obj === null) {
                return true;
            }

            if (Object.keys) {
                return Object.keys(obj).length === 0;
            } else {
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        return false;
                    }
                }

                return true;
            }
        }

        function forEachInObject(obj, callback) {

            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    var breakFor = callback(key, obj[key]);

                    if (breakFor === false) {
                        break;
                    }
                }
            }

        }

        function isImplementorOf(obj, implementor) {
            if (!obj) {
                return;
            }

            if ((obj.__proto__ == implementor.prototype) || (obj.constructor.prototype == implementor.prototype)) {
                return;
            }

            self.forEachInObject(implementor.prototype,
                function (method) {
                    if (!obj.hasOwnProperty(method)) {

                        var objName;

                        if (obj.hasOwnProperty('name')) {
                            objName = obj.name;
                        } else {
                            objName = 'Objeto';
                        }

                        throw new Error(objName + ' não é uma implementação de ' + implementor.name);
                    }
                });
        }

        function extend(objInstance, modelClass, defValues) {
            angular.extend(objInstance, new modelClass());

            if (angular.isDefined(defValues)) {
                angular.forEach(defValues, function (value, key) {
                    objInstance[key] = value;
                });
            }
        }
        
        function defaultValues(obj, defaultValues) {
        	if (angular.isDefined(obj)) {
        		angular.forEach(defaultValues, function(value, key) {
        			if (!obj.hasOwnProperty(key)) {
        				obj[key] = value;
        			}
        		});
        	}
        }

        function valueFn(value) {
            return function valueRef() {
                return value;
            };
        }

        function buildPublicAPI(source, methods) {
            var api = new function publicApi(){};
            
            ArrayUtils.toArray(methods).forEach(function(method){
                api[method] = source[method];
            });
            
            return api;
        }

        function buildPublicAPIFromObject(source) {
            var objectAPI = new function() {};

            angular.forEach(source, function(value, key) {
                objectAPI[key] = function(value) {
                    if (arguments.length == 0) {
                        return source[key];
                    } else {
                        source[key] = value;
                        return objectAPI;
                    }
                };
            });

            return objectAPI;
        }

        function implementsFn(objInstance, implementor, defValues) {
            angular.extend(objInstance, implementor.prototype);

            if (angular.isDefined(defValues)) {
                angular.forEach(defValues, function (value, key) {
                    objInstance[key] = value;
                });
            }

            if (implementor.prototype.initializePrototype) {
                objInstance.initializePrototype();
            }

            return objInstance;
        }

        function getFunctionFromObject(template, obj) {
            if (angular.isDefined(obj) && angular.isObject(obj)) {
                var regex = /(\w+)\((\d*)\)/;

                var templates = template.split(',');

                templates.forEach();

                var match = regex.exec(template);

                var functionName = match[1];
                var args = match[2];

                for (var key in obj) {

                    if (key === functionName) {
                        var f = obj[key];

                        if (angular.isFunction(f)) {
                            if (f.length === parseInt(args)) {
                                return f;
                            }
                        }
                    }
                }

                throw new Error('Não encontramos a função \'' + template + '\' no objeto passado.');
            } else {
                throw Error('Argumento não é um objeto ou é nulo.');
            }
        }

        function sizeOf(object) {

            // initialise the list of objects and size
            var objects = [object];
            var size = 0;

            // loop over the objects
            for (var index = 0; index < objects.length; index++) {

                // determine the type of the object
                switch (typeof objects[index]) {

                    // the object is a boolean
                    case 'boolean':
                        size += 4;
                        break;

                    // the object is a number
                    case 'number':
                        size += 8;
                        break;

                    // the object is a string
                    case 'string':
                        size += 2 * objects[index].length;
                        break;

                    // the object is a generic object
                    case 'object':

                        // if the object is not an array, add the sizes of the keys
                        if (Object.prototype.toString.call(objects[index]) != '[object Array]') {
                            for (var key in objects[index]) size += 2 * key.length;
                        }

                        // loop over the keys
                        for (var key in objects[index]) {

                            // determine whether the value has already been processed
                            var processed = false;
                            for (var search = 0; search < objects.length; search++) {
                                if (objects[search] === objects[index][key]) {
                                    processed = true;
                                    break;
                                }
                            }

                            // queue the value to be processed if appropriate
                            if (!processed) objects.push(objects[index][key]);

                        }

                }

            }

            // return the calculated size
            return size;
        }

        function defineProperty(obj, key, handler, value) {
            Object.defineProperty(obj, key, {
                get: function () {
                    return value;
                },
                set: function (newValue) {
                    var oldValue = value;
                    value = newValue;
                    handler && handler(newValue, oldValue);
                }
            });
        }

        function bindProperty(src, srcProp, dest, destProp) {
            if (angular.isUndefined(destProp)) {
                destProp = srcProp;
            }

            defineProperty(src, srcProp, function(newValue) {
                dest[destProp] = newValue;
            });
        }

        function equals(obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2);
        }

        function clone(obj) {
            if (null == obj || "object" != typeof obj) return obj;
            var copy = obj.constructor();
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
            }
            return copy;
        }

        function setPropetyWithHierarchy(obj, path, value) {
            var schema = obj;
            var pList = path ? path.split('.') : [];
            var len = pList.length;
            for(var i = 0; i < len-1; i++) {
                var elem = pList[i];
                if( !schema[elem] ) schema[elem] = {}
                schema = schema[elem];
            }
        
            schema[pList[len-1]] = value; 
            
            return obj;
        }

        function objectToHash(obj) {
            var objHash = 0;
            
            angular.forEach(obj, function(value) {
                
                var hash = 0;
                if(value === undefined) {
                    return;
                }
                if (angular.isObject(value)){

                	//O atributo rowID e de uso de controle interno nao pode entrar na geracao do hash
                    if (value.hasOwnProperty('rowID')) {
                        return;
                    }

                    hash += objectToHash(value);
                }
                for (var i = 0; i < value.toString().length; i++) {
                    var char = value.toString().charCodeAt(i);
                    hash = ((hash << 5) - hash) + char;
                    hash = hash & hash;
                }
                objHash += hash;
            });
            return objHash;
        }
        
        function cloneJSON(obj) {
            try {
                return JSON.parse(JSON.stringify(obj));
            } catch(error) {
                console.log(error);
                return null;
            }
        }

        function entries( obj ) {
            var ownProps = Object.keys(obj);
            var i = ownProps.length;
            var resArray = new Array(i);

            while(i--) {
                resArray[i] = [ownProps[i], obj[ownProps[i]]];
            }

            return resArray;
        };

        function getSafelyJson(obj){
            if(isEmpty(obj)){
                return {};
            }
                
            return obj;
        }
    }]);

/**
 * @ngdoc service
 * @name snk.core.util.service:PositionUtils
 *
 * @description
 * Serviço utilizado para prover informações de posição de um elemento DOM. Esse serviço é baseado nas funções de position
 * e offset do jQuery.
 *
 * O método {@link snk.core.util.service:PositionUtils#methods_position .position()} permite recuperar a posição atual de um
 * elemento em relação ao pai. Em contraste o método {@link snk.core.util.service:PositionUtils#methods_offset .offset()},
 * recupera a posição atual em relação ao documento. Ao posicionar um novo elemento perto de outro, dentro do mesmo
 * conjunto de elementos DOM, .position() é o mais útil.
 */
angular
    .module("snk.core.util")
    .service('PositionUtils', ['$document', '$window', 'UserAgentUtils', function ($document, $window, UserAgentUtils) {
        var self = this;
        self.position = position;
        self.offset = offset;
        self.scrollTop = scrollTop;
        self.positionElements = positionElements;

        /**
         * @ngdoc
         * @name PositionUtils#position
         * @methodOf snk.core.util.service:PositionUtils
         * @description
         * Fornece informações de posição equivalente à função position do jQuery: {@link http://api.jquery.com/position/ http://api.jquery.com/position/}
         * @param {object} element Objeto javascript do DOM (angular.element ou não).
         * @return {object} Retorna um objeto com as propriedades width, height, top e left.
         * @example
         * ```js
         *      PositionUtils.position(divElement);
         * ```
         */
        function position(element) {
            element = angular.element(element);

            var elBCR = self.offset(element);
            var offsetParentBCR = {top: 0, left: 0};
            var offsetParentEl = parentOffsetEl(element[0]);
            var boundingClientRect = element[0].getBoundingClientRect();

            if (offsetParentEl != $document[0]) {
                offsetParentBCR = self.offset(angular.element(offsetParentEl));
                offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
                offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
            }

            return {
                width: boundingClientRect.width || element.prop('offsetWidth'),
                height: boundingClientRect.height || element.prop('offsetHeight'),
                top: elBCR.top - offsetParentBCR.top,
                left: elBCR.left - offsetParentBCR.left
            };
        }

        /**
         * @ngdoc
         * @name PositionUtils#offset
         * @methodOf snk.core.util.service:PositionUtils
         * @description
         * Fornece informações de posição equivalente à função offset do jQuery: {@link http://api.jquery.com/offset/ http://api.jquery.com/offset/}
         * @param {object} element Objeto javascript do DOM (angular.element ou não).
         * @param {boolean} useNativeScrollTop Usa a função nativa de scrollTop.
         * @return {object} Retorna um objeto com as propriedades width, height, top e left.
         * @example
         * ```js
         *      PositionUtils.offset(divElement);
         * ```
         */
        function offset(element, useNativeScrollTop) {
            element = angular.element(element);
            var boundingClientRect = element[0].getBoundingClientRect();

            return {
                width: boundingClientRect.width || element.prop('offsetWidth'),
                height: boundingClientRect.height || element.prop('offsetHeight'),
                top: boundingClientRect.top + scrollTop($document, useNativeScrollTop),
                bottom: boundingClientRect.bottom + scrollTop($document, useNativeScrollTop),
                left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
            };
        }

        /**
         * @ngdoc
         * @name PositionUtils#scrollTop
         * @methodOf snk.core.util.service:PositionUtils
         * @description
         * Fornece informações de posição do scroll, equivalente à função scrollTop do jQuery
         * Caso o parâmetro useNative seja informado retornamos a posiçao real do scroll, caso esteja em um iOS (vide README.md)
         * @param {object} element Objeto javascript do DOM (angular.element ou não).
         * @param {boolean} useNativeScrollTop Usa a função nativa de scrollTop.
         * @return {number} Retorna um inteiro a posição atual do scroll
         * @example
         * ```js
         *      PositionUtils.scrollTop(divElement);
         * ```
         */
        function scrollTop(element, useNative) {
            element = angular.element(element || $document);

            if (useNative && UserAgentUtils.isIOS()) {
                var isDocument = (element[0] === $document[0] || element[0] === $document[0].body);

                if (isDocument) {
                    return 0;
                }
            }

            return element.scrollTop();
        }

        /**
         * Provides coordinates for the targetEl in relation to hostEl
         */
        function positionElements(hostEl, targetEl, positionStr, appendToBody, addExtraLeft) {
            var positionStrParts = positionStr.split('-');
            var pos0 = positionStrParts[0];
            var pos1 = positionStrParts[1] || 'center';
            var hostElPos;
            var targetElWidth;
            var targetElHeight;
            var targetElPos;

            hostElPos = appendToBody ? offset(hostEl) : position(hostEl);

            addExtraLeft = angular.isDefined(addExtraLeft) ? addExtraLeft : true;

            targetElWidth = targetEl.prop('offsetWidth');
            targetElHeight = targetEl.prop('offsetHeight');

            var shiftWidth = {
                center: function () {
                    return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
                },
                left: function () {
                    return hostElPos.left - targetElWidth + (addExtraLeft ? 16 : 0);
                },
                right: function () {
                    return hostElPos.left + hostElPos.width;
                }
            };

            var shiftHeight = {
                center: function () {
                    return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
                },
                top: function () {
                    return hostElPos.top;
                },
                bottom: function () {
                    return hostElPos.top + hostElPos.height;
                }
            };

            switch (pos0) {
                case 'right':
                    targetElPos = {
                        top: shiftHeight[pos1](),
                        left: shiftWidth[pos0]()
                    };
                    break;
                case 'left':
                    targetElPos = {
                        top: shiftHeight[pos1](),
                        left: hostElPos.left - targetElWidth
                    };
                    break;
                case 'bottom':
                    targetElPos = {
                        top: shiftHeight[pos0](),
                        left: shiftWidth[pos1]()
                    };
                    break;
                default:
                    targetElPos = {
                        top: hostElPos.top - targetElHeight,
                        left: shiftWidth[pos1]()
                    };

                    if (pos1 == 'left'){
                        targetElPos.top -= 5;
                    }

                    break;
            }

            return targetElPos;
        }

        function getStyle(el, cssprop) {
            if (el.currentStyle) { //IE
                return el.currentStyle[cssprop];
            } else if ($window.getComputedStyle) {
                return $window.getComputedStyle(el)[cssprop];
            }
            // finally try and get inline style
            return el.style[cssprop];
        }

        function isStaticPositioned(element) {
            return (getStyle(element, 'position') || 'static' ) === 'static';
        }

        function parentOffsetEl(element) {
            var docDomEl = $document[0];
            var offsetParent = element.offsetParent || docDomEl;
            while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {
                offsetParent = offsetParent.offsetParent;
            }
            return offsetParent || docDomEl;
        }
    }]);

angular
	.module('snk.core.util')
    .controller('printController', ['$scope','$popupInstance','pendindPrintJobData','Base64','i18n','btnClean',
	function($scope,$popupInstance,pendindPrintJobData,Base64,i18n,btnClean) {
    	var self = this;
    	
    	self.LOCAL_SERVER = "LOCAL";
    	self.LOCAL_PORT = "0";
    	self.LOCAL_SERVER_URI = self.LOCAL_SERVER + ":" + self.LOCAL_PORT;
		self.itemClickHandler=itemClickHandler;
		
		self.printersSelected=pendindPrintJobData?.pendingPrinters?.pendingPrinter;
		self.impressaoDuplicada=angular.isArray(self.printersSelected)?true:false;
    	    	
    	self.active = false;
    	$scope.isPrintService = pendindPrintJobData?.printServers?.printServerActive;
    	
    	$scope.serverPrinterList = getServerPrinterList();
    	$scope.setPrinterSelected = setPrinterSelected;
		$scope.onTabSelected = onTabSelected;
    	
    	$scope.init = function (){
			if (angular.isUndefined(self.printersSelected)) {
				$popupInstance.dismiss();
				return;
			} 
			
			if(angular.isArray(self.printersSelected)){
				self.printersSelected.forEach((element, index) => {
					element.selected = (index == 0);
					element.name = 'Nenhuma impressora selecionada';
				});
			} else {
				$scope.originalPrinterName = self.printersSelected.originalPrinterName.$;
				$scope.docTypeDescription = self.printersSelected.docTypeDescription.$;
				$scope.printJobCount = self.printersSelected.printJobCount.$;
			}

    		if ($scope.isPrintService == 'false'){
    			$scope.selectedIndex = 1;
    		}
    	};
    	
    	btnClean.on('click', function(){
    		setPrinterSelected(undefined);
    		self.active = false;
        });
    	
    	function getLocalPrinterList(){
    		var printers = getLocalPrinterLocations();
    		var printerInfo = [];
            
            if (angular.isDefined(printers) && printers.length > 0) {

                for (i = 0; i < printers.length; i++) {
                    printerInfo.push({
                        printerName : Base64.decode(printers[i].printerName),
                        source : getPrinterSource(printers[i].status),
                        toolTip : getLocalToolTip(printers[i]),
                        printerUri : Base64.decode(printers[i].printerUri)
                    });
                }
            }

    		return printerInfo;
    	}
    	
    	function getLocalPrinterLocations(){
			var printers = getLocalPrinters();
			if(printers == null) {
				return null;	
			}

            var printerLocation = [];
            
            if (angular.isDefined(printers) && printers.length > 0) {

                for (i = 0; i < printers.length; i++) {
                    printerLocation.push({
                        host : self.LOCAL_SERVER,
                        port : self.LOCAL_PORT,
                        printerName : Base64.encode(printers[i]),
                        printerUri : Base64.encode(self.LOCAL_SERVER_URI + "/" + printers[i]),
                        printServerUri : self.LOCAL_SERVER_URI,
                        requiresAuthorization : false,
                        status : "Pronta"
                    });
                }
            }

        	return printerLocation;
    	}
    	
		function getLocalPrinters() {
			let centralNotaAppletImpressao = document.getElementById('centralNotaAppletImpressao')
			var printerList;
			if(centralNotaAppletImpressao) {
				printerList = centralNotaAppletImpressao.getLocalPrinters();
			}
			return  printerList != null ? printerList.split(",") : null;
		}
    	
		function getPrinterSource(status) {
			switch(status) {
				case "IDLE":
				case "Pronta":					
				case "PROCESSING":
				case "Processando":
					return "printer-idle.svg";
				default:
					return "printer-stopped-32.svg";
			}			
		}
    	
		function getLocalToolTip(data) {
			var printerName = Base64.decode(data.printerName);
			
			return "Impressora local '" + printerName + 
			"'. Status: " + getPrinterStatusToolTip(data.status) + ".";
		}
    	
		function getPrinterStatusToolTip(status) {
			switch(status) {
				case "IDLE":
				case "Pronta":					
				case "PROCESSING":
				case "Processando":
					return "Disponível";
				default:
					return "Indisponível";
			}			
		}

        function getServerPrinterList(){
    		var servers = pendindPrintJobData?.printServers?.printServer;
    		var printerInfo = [];
    		
    		if ($scope.isPrintService == 'true'){

                if (angular.isDefined(servers) && servers.length > 0) {

                    for (i = 0; i < servers.length; i++) {
                        printerInfo.push({
                            printServerUri : servers[i].printServerUri,
                            printerList : []
                        });
                        
                        var  printers =angular.isArray(servers[i].printerLocation)? servers[i].printerLocation :[servers[i].printerLocation];						
                        if (angular.isDefined(printers) && printers.length > 0) {
                            
                            for (j = 0; j < printers.length; j++) {
                                var status = printers[j].hasOwnProperty("status") ? printers[j].status.$ : "";
                                
                                printerInfo[i].printerList.push({
                                    printerName : Base64.decode(printers[j].printerName.$),
                                    source : getPrinterSource(status),
                                    toolTip : getServerToolTip(printers[j]),
                                    printerUri : Base64.decode(printers[j].printerUri.$)
                                });
                            } // inside for
                        }

                    } // outside for
                }

    		}
    		
    		return printerInfo;
        }
        
		function getServerToolTip(data) {
			var printerName = Base64.decode(data.printerName.$);
			var status = data.hasOwnProperty("status") ? data.status.$ : "";
			
			return "Impressora '" + printerName + 
			"' do servidor " + data.printServerUri.$ + 
			". Status: " + getPrinterStatusToolTip(status) + ".";
		}
        
        function setPrinterSelected(item){
        	clearSelection();
			if(!angular.isArray(self.printersSelected)){
				self.printersSelected=[self.printersSelected];
			}
			self.printersSelected.forEach( element => {
				if(element.selected == true || self.printersSelected.length==1){
					element.printerName = item.printerName;
					element.printerObject = item;
					element.selected = true;
				}
				
			});

        	self.printerSelected = item;
        }
        
        function clearSelection(){
        	var elements = document.getElementsByClassName("printerClass");
        	for(var i=0; i<elements.length; i++) {
        	    elements[i].classList.remove("active");
        	}
        }
        
        $scope.$success = function () {
            $popupInstance.success(setResult());
        };

        function setResult() {
            return {
            	printerSelected: self.printersSelected,
            	saveSubstitutePrinters : self.active.toString()
            };
        }
		
		function onTabSelected(newIndex){
			if(newIndex == 1){
				$scope.localPrinterList = getLocalPrinterList();
			}	
		}
		
		function itemClickHandler(item, $event, list) {
			self.printersSelected.forEach(element => {
				element.selected = false;
			});
			item.selected = true;
		}

    }
]);
/**
 * Created by bruno.brandao on 31/03/2016.
 */
angular
    .module('snk.core.util')
    .service('PrintUtils', ['Base64', 'MessageUtils', 'SkI18nService', 'ServiceProxy', 'SanPopup', 'i18n', 'AvisosUtils', function(Base64, MessageUtils, SkI18nService, ServiceProxy, SanPopup, i18n, AvisosUtils) {
        var self = this;

    	self.LOCAL_SERVER = "LOCAL";
    	self.LOCAL_PORT = "0";
    	self.LOCAL_SERVER_URI = self.LOCAL_SERVER + ":" + self.LOCAL_PORT;
    	
        self.impressaoDireta = impressaoDireta;
        
        self.processPendingPrinting = processPendingPrinting;
		self.processLocalPrintings = processLocalPrintings;
		self.imprimeNota = imprimeNota;
		self.serializaInformacoesImpressao = serializaInformacoesImpressao;
		self.processPendingPrintingToPrintGroups = processPendingPrintingToPrintGroups;
		
		const IMPRIMIR_NOTA = 1;

        function impressaoDireta(printInfo, strCodUsuLogado, usaSessaoStr, encode) {
            var applet = document.getElementById('centralNotaAppletImpressao');
            if (applet && applet.validaVersaoJava()){
                if (!(encode === false)) {
                    printInfo = Base64.encode(printInfo);
                    printInfo = printInfo.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\r/g, '');
                }

                var errorMessage;
                applet.impressaoDireta(printInfo, strCodUsuLogado, usaSessaoStr, function(e, errorMsg){
                    errorMessage = errorMsg;
                });

                if (errorMessage){
                    MessageUtils.showAlert(SkI18nService.instant('Geral.printErrorTitle'), errorMessage);
                    return false;
                }

                return true;
            } else {
                MessageUtils.showAlert(SkI18nService.instant('Geral.printErrorTitle'), SkI18nService.instant('Geral.javaPluginError'));
                return false;
            }
        }
        
        function processPendingPrinting(transactionId) {
			var transactionIds = [transactionId];

			processPendingPrintingToTransactions(transactionIds);
        }

        function processPendingPrintingToTransactions(transactionIds) {
        	var params = {transactionIds: []};
        	
        	for (i = 0; i < transactionIds.length; i++) {
        		params.transactionIds.push({
        			transactionId : {$ : transactionIds[i]}
        		});
        	}

    		ServiceProxy
        	.callService('mge@PrintServiceSP.findPendingPrinters', params)
        	.then(function(result) {
        		var responseBody = result.responseBody;
        		
				if (responseBody.hasOwnProperty("pendindPrintJobData")) {
					var unresolvedPrints = processDirectPrinting(transactionIds[0], responseBody.pendindPrintJobData);
					if(unresolvedPrints != null){
						showSelecionarImpressoraSubstitutaPopup(unresolvedPrints);
					}
				}
        	});
        }
        
        function processDirectPrinting(transactionId, rowPrintList) {
			var localPrinters = null;
			var testRunningWC = document.getElementById('centralNotaAppletImpressao');

			// Valida testRunning antes de chamar o método testRunningWC
			if(angular.isDefined(testRunningWC) && angular.isDefined(testRunningWC.testRunningWC)) {
				testRunningWC = testRunningWC.testRunningWC();
			}
			
			if(testRunningWC != null && testRunningWC.length > 0){
				localPrinters = getLocalPrinters();
			} else {
				localPrinters = [];
			}
			
			if(localPrinters.length > 0){
				var defaultPrinter = document.getElementById('centralNotaAppletImpressao').getPrintDefault();
			
				if (rowPrintList != null) {
					var pendingPrinters = rowPrintList.pendingPrinters;
					
					if (pendingPrinters.pendingPrinter != null){
						if(!Array.isArray(pendingPrinters.pendingPrinter)) {
							pendingPrinters.pendingPrinter = [pendingPrinters.pendingPrinter];
						}

						var substitutePrintersRequest = [];
						for(printerNow of pendingPrinters.pendingPrinter) {
							var printer = printerNow;
							var printerName = printer.originalPrinterName.$;

							if(/padr[aã]o/ig.test(printerName) && defaultPrinter != null){
								printerName = defaultPrinter;
							}
							
							if(localPrinters.includes(printerName) || isPrinterNameAFile(printerName)){
								printer.printerUri = {$ : self.LOCAL_SERVER_URI + "/" + printerName};
								rowPrintList.pendingPrinters.pendingPrinter = rowPrintList.pendingPrinters.pendingPrinter.filter(item => item !== printerNow)
								substitutePrintersRequest.push({
									saveSubstitutePrinters : {$ : "false"},
									transactionId : {$ : transactionId},
									substitutePrinters : {pendingPrinter : printer}
								});
							}
						}
						if(substitutePrintersRequest.length > 0){
							ServiceProxy.callService("mge@PrintServiceSP.saveSubstitutePrinter", {substitutePrintersRequest});
						}
					}
				}
			}
			
			return rowPrintList;
        }
        
		function getLocalPrinters() {
			var centralNotaAppletImpressao = document.getElementById('centralNotaAppletImpressao');
			var printerList;
			if(centralNotaAppletImpressao) {
				printerList = centralNotaAppletImpressao.getLocalPrinters();
			}
			 
			return  printerList != null ? printerList.split(",") : null;
		}
		
		function isPrinterNameAFile(printerName) {
			var regExp = new RegExp('^(\\w:)?[/\\\\\\w\\s]+?\\.\\w{3}$', 'mi');
			return regExp.test(printerName);	
		}

		function showSelecionarImpressoraSubstitutaPopup(pendindPrintJobData) {

			if(pendindPrintJobData?.pendingPrinters?.pendingPrinter == null) {
				return;
			}

			if(!Array.isArray(pendindPrintJobData.pendingPrinters.pendingPrinter)) {
				pendindPrintJobData.pendingPrinters.pendingPrinter = [pendindPrintJobData.pendingPrinters.pendingPrinter];
			}

			for(let printer of pendindPrintJobData.pendingPrinters.pendingPrinter) {
				var pendindPrintJobDataCopy = angular.copy(pendindPrintJobData);
				
				if(pendindPrintJobData.pendingPrinters.pendingPrinter.length==1){
					pendindPrintJobDataCopy.pendingPrinters.pendingPrinter = printer;
				}

				if(printer?.printerUri != null) {
					continue;
				}
			}
				openPopup(pendindPrintJobDataCopy).result.then(function(result) {
					let printerSelected = result.printerSelected;
					
					if (angular.isArray(printerSelected)) {
						for (let element of printerSelected) {
							if (element.selected) {
								printerSelected = element;
								break;
							}
						}
					}

					if (angular.isUndefined(printerSelected.printerObject)) {
						MessageUtils.showAlert(i18n('Geral.alertPrinter')).then(function(){
							showSelecionarImpressoraSubstitutaPopup(pendindPrintJobDataCopy);
						});
						return;
					} 
					
					let pendingPrinters =angular.isArray(result.printerSelected)?result.printerSelected: pendindPrintJobDataCopy.pendingPrinters;
						var substitutas ={};
						if(angular.isArray(pendingPrinters)){
							substitutas = {substitutePrintersRequest: {substitutePrinters:{}}};
							substitutas.substitutePrintersRequest.substitutePrinters.pendingPrinter=[];
							pendingPrinters.forEach(print=>{
								if (print != null) {
									if(angular.isDefined(print.printerObject)){
										let printer ={};
										printer.printerUri = {$ : print.printerObject.printerUri};
										printer.originalPrinterName={$ :print.originalPrinterName.$}
										printer.printJobCount={$ :print.printJobCount.$}
										printer.docType={$ :print.docType.$}
										printer.docTypeDescription={$ :print.docTypeDescription.$}
										
										substitutas.substitutePrintersRequest.saveSubstitutePrinters = {$ : result.saveSubstitutePrinters};
										substitutas.substitutePrintersRequest.transactionId = {$ : pendindPrintJobDataCopy?.transactionId?.$};
										substitutas.substitutePrintersRequest.substitutePrinters.pendingPrinter.push(printer);
									}
								}
							})
						}else{
							if (pendingPrinters.pendingPrinter != null) {
								var printer = pendingPrinters.pendingPrinter;
								printer.printerUri = {$ : result.printerSelected.printerUri};
								
								substitutas = {substitutePrintersRequest: {}};
								substitutas.substitutePrintersRequest.saveSubstitutePrinters = {$ : result.saveSubstitutePrinters};
								substitutas.substitutePrintersRequest.transactionId = {$ : pendindPrintJobDataCopy.transactionId.$};
								substitutas.substitutePrintersRequest.substitutePrinters = {};
								substitutas.substitutePrintersRequest.substitutePrinters.pendingPrinter = printer;
							}
						}
	
					if (substitutas != null && substitutas.substitutePrintersRequest.substitutePrinters.pendingPrinter.length > 0) {
						ServiceProxy.callService("mge@PrintServiceSP.saveSubstitutePrinter", substitutas);
					}
					});
			

		}

        function openPopup(pendindPrintJobData) {
        	var btnClean = angular.element('<button class="btn btn-default" title="' + i18n('Geral.lblBtnCleanSelection') + '">' + i18n('Geral.lblLimpar') + '</button>');
        	
        	return SanPopup.open({
                title: i18n('Geral.lblReplacePrinter'),
                templateUrl: 'core/util/print/print.tpl.html',
                controller: 'printController',
                controllerAs: 'ctrl',
                okBtnLabel: i18n('Geral.buttonPrinter'),
                cancelBtnLabel: i18n('Geral.buttonCancelar'),
                scrollContainer: false,
                size: 'lg',
				resolve: {
					pendindPrintJobData: function() {
                        return pendindPrintJobData;
                    },
        			btnClean: function() {
		                return btnClean;
		            }
				}
            });
        }
        
		function processLocalPrintings(transactionIdsElements) {
			var transactionIdArray = [transactionIdsElements];
			var transactionIds = transactionIdArray.join();
			var appletMethod = document.getElementById('centralNotaAppletImpressao').doLocalPrinting(transactionIds);
		}

		function imprimeNota(notas){
			var param = {notas : {nota: [] }};

			notas.forEach(function(nuNota){
				param.notas.nota.push({nuNota: nuNota, tipoImp: IMPRIMIR_NOTA});
			});
			
			ServiceProxy.callService(
						"mge@ImpressaoNotasSP.imprimeDocumentos",
						param)
					.then(function(result){
						var responseBody = result.responseBody;
						if(responseBody.hasOwnProperty("avisos")){
							AvisosUtils.open(responseBody.avisos.aviso.$);
						}
					});
		}

		function serializaInformacoesImpressao(responseBody, usaSessao){
			usaSessao = !usaSessao ? false : true; 
			var impressoes = responseBody.impressoes;
			
			if (!angular.isArray(impressoes)) {
                impressoes = [impressoes.impressao];
            }

			var result = "";
			//modelo:
			//CODATA:1234,IMPRESSORA:imp,DESCRICAO:descr,TIPO:I;CODATA:4321,IMPRESSORA:imp2,DESCRICAO:descr2,TIPO:I

			impressoes.forEach(function(impressao){
				if(result.length > 0) {
					result += ";";
				}

				if(!usaSessao){
					result += "CODATA=" + impressao.codAta + ",";
					result += "IMPRESSORA=" + impressao.impressora + ",";
					result += "DESCRICAO=" + impressao.descricao + ",";
					result += "TIPO=" + impressao.tipo;
				}else{
					result += "CHAVE_SESSAO=" + impressao.chave + ",";
					result += "IMPRESSORA=" + impressao.impressora;
				}

			});
			
			return btoa(result).replace(/\r\n/g, "").replace(/\n/g, "").replace(/\r/g, "");
		}

		function processPendingPrintingToPrintGroups (obj, callback){
			var printGroups = {};
			var printGroup = {};
				
			for (var atrib of obj) {
				printGroup.doctype = {$: atrib.doctype};
				printGroup.originalPrinterName = {$: atrib.originalPrinterName};
				printGroups.printGroup = printGroup;
			}
			
				
			ServiceProxy.callService("mge@PrintServiceSP.findPendingPrintersForPrintGroups", {printGroups})
				.then(function(result){
					var responseBody = result.responseBody;
		
					if (responseBody.hasOwnProperty("pendindPrintJobData")) {
						showSelecionarImpressoraSubstitutaPopup(responseBody.pendindPrintJobData, callback);
					}
				});
			 
		}

}]);
angular.module('snk.core.util')
    .directive('skRepeat', function($parse) {
        /**
         * Example:
         * expression = "address in addresses | filter: {street: $select.search} track by $index"
         * itemName = "address",
         * source = "addresses | filter: {street: $select.search}",
         * trackByExp = "$index",
         */
        function parse(expression) {

            var match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?([\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            if (!match) {
                throw new Error("Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
            }

            return {
                itemName: match[2], // (lhs) Left-hand side,
                source: match[3],
                trackByExp: match[4],
                modelMapper: (match[1] || match[2])
            };

        }

        function processBigArray(arr, fn, limit , callback) {
            var count = 0,
                len = arr.length;

            function run() {
                var d = limit;

                while (d-- && len > count ) {
                    fn(arr[count], count++);
                }

                if (len > count) {
                    setTimeout(run, 1);
                } else {
                    if (typeof callback === "function") {
                        callback();
                    }
                }
            }
            run();
        }

        var updateScope = function(scope, index, valueIdentifier, value, arrayLength) {
            scope[valueIdentifier] = value;

        };

        function linkFn($scope, $element, $attr, ctrl, $transclude){
            var repeatInfo = parse($attr.skRepeat);

            var pageSize = parseInt($attr.pageSize) || 100;
            var digestInterval = parseInt($attr.digestInterval) || 150;

            $scope.$watchCollection(repeatInfo.source, function(value){
                var previousNode = $element;

                var start = new Date().getTime();

                var interval= setInterval(function(){
                    if (!$scope.$root.$$phase){
                        $scope.$digest();
                    }
                }, digestInterval);


                processBigArray(value, function(item, index){
                    $transclude(function ngRepeatTransclude(clone, scope) {
                        updateScope(scope, index, repeatInfo.itemName, item, value.length);

                        previousNode.after(clone);
                        previousNode = clone;
                    });

                }, pageSize, function(){
                    clearInterval(interval);
                });
            });
        }

        return {
            restrict: 'A',
            transclude: 'element',
            link: linkFn
        };
    });
angular
    .module('snk.core.util')
    .directive('skRepeatFinished', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                if (scope.$last === true) {
                    element.ready(function () {
                        var fn = $parse(attr.skRepeatFinished);

                        $timeout(function(){
                            fn(scope);
                        }, 0, false);

                    });
                }
            }
        }
    }]);
angular
    .module("snk.core.util")
    .service('ResourceUtils', ['i18n', function (i18n) {
        var _self = this;

        _self.getManager = getManager;

        function getManager() {
            return new (function () {
                var self = this;
            
                self.getInstance = getInstance;
                self.getString = getString;
            
                function getInstance() {
                    return self;
                }
            
                function getString(bundle, key, lastkey, subst) {
            
                    var resourceKey = bundle.replace(":", ".") + "." + key;
                    var stret = i18n(resourceKey);
            
                    if (lastkey != null && lastkey != undefined) {
                        stret = stret.replace("  ", " " + lastkey.toString() + " ");
                    }
            
                    if (resourceKey == stret && subst != null) {
                        return subst;
                    }
            
                    return stret;
                }
            })();
        }
    }]);
angular
    .module("snk.core.util")
    .service("SASUtil", [function () {
        var self = this; 

        self.ACERTO_DE_VEICULOS_W ='30622';
        self.ANALISE_DE_CREDITO_W ='30623';
        self.BI_MOVEL_W ='30333';
        self.CALC_FRETE_POR_TRANSPORTADORA_W ='30624';
        self.CENTRAL_DE_ATENDIMENTO_MOVEL_W ='30334';
        self.CENTRAL_DE_CERTIFICACAO_W ='30632';
        self.CENTRAL_DE_CERTIFICACAO_G ='30338';
        self.CENTROS_DE_RESULTADO_W ='30620';
        self.COMERCIAL_W ='30602';
        self.COMISSAO_POR_FORMULA_W ='30630';
        self.COMPENSACAO_FINANCEIRA_W ='30629';
        self.CONCILIACAO_BANCARIA_AUTOMATICA_W ='30639';
        self.CONFIGURACOES_W ='30611';
        self.CONTA_CORRENTE_FLEX_W ='30342';
		self.CONTA_CORRENTE_FLEX_G = '30353';
        self.CONTABILIZACAO_W ='30607';
        self.CONTROLE_DE_CAIXA_W ='30357';
        self.CONTROLE_DE_EPI_W ='30626';
        self.CONTROLE_DE_HOLDING_W ='30628';
        self.CONTROLE_DE_PROJETOS_FAP_W ='30315';
        self.CONTROLE_DE_SERVICOS_OS_W ='30405';
        self.CONTROLE_DE_VEICULOS_W ='30625';
        self.CURSO_WORK_FLOW_W ='50979';
        self.DISTRIBUICAO_W ='30627';
        self.EDI_W ='30633';
        self.EDITOR_DE_DASHBOARD_W ='30616';
        self.FINANCEIRO_W ='30601';
        self.GERACAO_DE_CPR_CONFISSAO_DE_GARANTIA_W ='30636';
        self.GESTAO_DE_EAD_W ='30637';
        self.GESTAO_DE_COBRANCA_W ='30631';
        self.GESTAO_DE_PERFORMANCE_DO_PARCEIRO_W ='30614';
        self.INCORPORADORAS_W ='30638';
        self.INVENTARIO_W ='30617';
        self.JIVA_W ='20459';
        self.JIVA_AGENDA_DE_SERVICOS_W ='20455';
        self.JIVA_AGENDADOR_MATRIZ_ANALISE_DE_GIRO_W ='20440';
        self.JIVA_BI_W ='20456';
        self.JIVA_CAMPOS_ADICIONAIS_W ='20442';
        self.JIVA_CENTRAL_DE_CERTIFICACAO_W ='20453';
        self.JIVA_CENTRO_DE_RESULTADOS_W ='20444';
        self.JIVA_COMISSOES_POR_FORMULA_W ='20439';
        self.JIVA_CONTABILIDADE_W ='20445';
        self.JIVA_CONTABILIZACAO_W ='20446';
        self.JIVA_CONTRATOS_W ='20462';
        self.JIVA_CONTROLE_DE_PRODUCAO_W ='20448';
        self.JIVA_CONTROLE_ORCAMENTARIO_E_METAS_W ='20463';
        self.JIVA_DISTRIBUICAO_W ='20443';
        self.JIVA_EDI_W ='20441';
        self.JIVA_FINANCEIRO_W ='20460';
        self.JIVA_INVENTARIO_W ='20452';
        self.JIVA_LIBERACAO_DE_LIMITES_POR_ALCADA_W ='20461';
        self.JIVA_LIVROS_FISCAIS_W ='20449';
        self.JIVA_NF_e_W ='20451';
        self.JIVA_NFS_e_W ='20457';
        self.JIVA_PATRIMONIAL_W ='20447';
        self.JIVA_PEDIDO_WEB_W ='20465';
        self.JIVA_PESSOAL_W ='20450';
        self.JIVA_PONTO_W ='20454';
        self.JIVA_SUB_DIVISOES_DE_ESTOQUE_W ='20458';
        self.JIVA_TELEMARKETING_W ='20438';
        self.JIVA_WORKFLOW_W ='20435';
        self.NOTA_FISCAL_DE_SERVICO_ELETRONICA_G ='30706';
        self.NOTA_FISCAL_DE_SERVICO_ELETRONICA_W ='30619';
        self.NOTA_FISCAL_DE_SERVICO_ELETRONICA_JIVA_G ='20426';
        self.NOTA_FISCAL_DE_SERVICO_ELETRONICA_JIVA_W ='20457';
        self.NOTA_FISCAL_ELETRONICA_W ='30610';
        self.OS_WEB_PARA_CLIENTES_W ='30609';
        self.PEDIDO_WEB_W ='30612';
        self.PESQUISA_W ='30606';
        self.PESSOAL_W ='30603';
        self.PLATAFORMA_DE_PERSONALIZACAO_W ='30615';
        self.SINCRONIZADOR_DE_TABELAS_W ='30346';
        self.SLA_W ='30608';
        self.SUB_DIVISOES_DE_ESTOQUE_W ='30634';
        self.TELEMARKETING_W ='30621';
        self.VENDA_CONSULTIVA_W ='30605';
        self.WMS_W ='80084';
        self.WORKFLOW_W ='30618';	
        self.JIVA_CONTA_CORRENTE_FLEX_W ='20480';
        self.CONHECIMENTO_DE_TRANSPORTE_ELETRONICO_W ='30656'; 	
        self.JIVA_CONHECIMENTO_DE_TRANSPORTE_ELETRONICO_W ='20486'; 	
        self.NOTA_FISCAL_ELETRONICA_G ='30337';
		self.NOTA_FISCAL_CONSUMIDOR_ELETRONICA_W ='30648';
		self.NOTA_FISCAL_CONSUMIDOR_ELETRONICA_G ='30649';
		self.JIVA_NF_e_G ='20427';
		self.JIVA_NFC_e_W ='20481';
		self.JIVA_NFC_e_G ='20488';
		self.MDFE ='30678';
		self.PORTAL_IMPORTACAO_XML_W ='30655';
        self.JIVA_MDFE ='20497';
        self.SANKHYA_CONTROLE_ORCAMENTARIO_METAS = '30742'
        self.JIVA_CONTROLE_ORCAMENTARIO_METAS = '20422'
        self.SANKHYA_PATRIMONIAL_W ='30737';
    }]);

angular
    .module('snk.core.util')
    .directive('scopeId', [function () {
        return {
            restrict: 'A',
            priority: 2,
            link: {
                pre: function (scope, element, attrs) {
                    var scopeId = attrs.scopeId;

                    if (angular.isDefined(scopeId)) {
                        if (angular.isDefined(attrs.scopeIdParent)) {
                            scope.$parent[scopeId] = element;
                        } else {
                            scope[scopeId] = element;
                        }
                    }
                }
            }
        };
    }]);
angular
    .module('snk.core.util')
    .directive('skScrollContainer', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var isEnabled = true;

                if (attrs.skScrollContainer) {
                    scope.$watch(attrs.skScrollContainer, function(newV) {
                        if (angular.isDefined(newV)) {
                            isEnabled = newV;
                        }
                    });
                }

                element.bind('mousewheel DOMMouseScroll', function (evt) {
                    if (isEnabled) {
                        var e = evt.originalEvent || evt;
                        var delta = e.wheelDelta || -e.detail || e.wheelDeltaY;

                        if (angular.isDefined(delta)){
                            this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                        }
                    }
                });
            }
        };
    });
angular
    .module("snk.core.util")
    .service('SessionFileUpload', ['$http', '$q', 'StringUtils', 'i18n', 'SkApplication', 'UserAgentUtils', 'SkApplicationInstance','Base64',
        function ($http, $q, StringUtils, i18n, SkApplication, UserAgentUtils, SkApplicationInstance, Base64) {

            
            var self = this;
            
            let app = SkApplication.instance();

            const _callbackName = registryCallBack();

            self.clearSessionFile = clearSessionFile;
            self.uploadSessionFile = uploadSessionFile;
            self.openCustomSessionUpload = openCustomSessionUpload;

            let _uploadCallBacks = {};

            function clearSessionFile(fileKey) {
                var url = getBaseUrl(fileKey);
                url += '&clearfile=S';

                var deferred = $q.defer();

                $http.get(url)
                    .success(function (result) {
                        deferred.resolve(result);
                    })
                    .error(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            }

            function uploadSessionFile(fileKey, file, fnCreateHttp) {
                var uploadUrl = buildUploadURL(fileKey);
 
                var fd = new FormData();
                fd.append('arquivo', file);
 
                var deferred = $q.defer();

                var http = new XMLHttpRequest();
                http.addEventListener("load", deferred.resolve, false);
                http.addEventListener("error", deferred.reject, false);
                
                if(angular.isFunction(fnCreateHttp)){
                    fnCreateHttp(http);
                }

                http.open("POST", uploadUrl);
 
                http.send(fd);

                return deferred.promise;
            }

            function getBaseUrl(fileKey, context = 'mge') {
                let url = ("/{CONTEXT}/sessionUpload.{CONTEXT}?sessionkey=").replace(/{CONTEXT}/g, context) + fileKey;

                if(!canProcessSpecialKeys(context, fileKey) || !StringUtils.hasSpecialCharacters(fileKey))
                    return url; 

                url += "&encodedKey=" + Base64.encode(encodeURI(fileKey))
                
                return url;
            }

            function canProcessSpecialKeys(context, fileKey){
                const resourceId = SkApplicationInstance.getResourceID();
                const adPrefix = "br.com.sankhya.menu.adicional";

                return context == 'mge' && StringUtils.safelyStartsWith(resourceId, adPrefix);
            }

            function buildUploadURL(fileKey) {
                var url = getBaseUrl(fileKey);
                url += "&fitem=S&salvar=S&useCache=N";
                return url;
            }


           function openCustomSessionUpload(fileKey, onUpload, properties){

                var message;
                var title;
                var popUpWidth;
                var popUpHeight;
                var top;
                var left;
                var urlVars;
                var type;
                var obs;
                var fileTypes;
                var context;
    
                if(properties != null){
                    message = properties.message;
                    title = properties.title;
                    popUpWidth = properties.popUpWidth;
                    top = properties.top;
                    left = properties.left;
                    popUpHeight = properties.popUpHeight;
                    urlVars = properties.urlVars;
                    type = properties.type;
                    obs = properties.obs;
                    fileTypes = properties.fileTypes;
                    context = properties.context;
                }
                            
                if(!message){
                    message = i18n('Attach.upload');
                }

                if(!title){
                    title = i18n('Attach.lblAnexo');
                }

                if(isNaN(popUpWidth)){
                    popUpWidth = 400;
                } 
                if(isNaN(popUpHeight)){
                    popUpHeight = 200;
                }
                
                if(isNaN(top)){
                    top = (window.innerHeight - popUpHeight) / 2;
                } 
                
                if(isNaN(left)){
                    left = (window.innerWidth - popUpWidth) / 2;
                }

                if(onUpload != undefined){
                    _uploadCallBacks[fileKey] = onUpload;
                }
                
                var fileTypesStr;

                if(fileTypes != undefined){
                    //.jpeg,.png
                    fileTypesStr = "";
                    for(var count = 0; count < fileTypes.length; count++){
                        fileTypesStr += fileTypes[count]+((count == fileTypes.length-1) ? "" : ",");
                    }
                }else{
                    fileTypesStr = undefined;
                }
                
                window.open(buildURL(title, message, fileKey, obs, fileTypesStr, type, urlVars, context), '_blank', "sessionUploadWindow,width=" + popUpWidth + ", height=" + popUpHeight + ",resizable=no,scrollbars=yes,top=" + top + ",left=" + left);                
            }

            function buildURL(title, message, fileKey, obs, fileTypes, type, urlVars, context){
                let url = getBaseUrl(fileKey, context);

                url           += "&fitem=S";
                url           += "&title=" + title;
                url           += "&message=" + message;
                url           += "&closescript=" + buildOnCloseJavaScript(fileKey);
                
                if(type){
                    url += "&type=" + type;
                }
                
                if(obs){
                    url += "&obs="+obs;
                }
                
                if(fileTypes){
                    url += "&fileTypes="+fileTypes;
                }

                if(SkApplicationInstance.isHtml5()){
                  var isHtml5 = SkApplicationInstance.isHtml5() ? 'S' : 'N';
                  url  += "&isHtml5=" + isHtml5;
                }
                
                if(urlVars){
                    for(var prop in urlVars){
                        url += StringUtils.substitute("&{0}={1}", prop, urlVars[prop]);
                    }
                }

                return url;
            }

            function buildOnCloseJavaScript(fileKey){
                if(UserAgentUtils.isElectron()) {
                    let resourceID = app.getResourceID;

                    if (typeof (resourceID) === 'function' ){
                        resourceID = resourceID();
                    }

                    return "try {var ipc = require('electron').ipcRenderer; ipc.send('uploadFile', {'resourceID':'" + resourceID + "', 'callbackName': '" + _callbackName + "', 'fileKey': '" + fileKey + "', 'fileName': _${fileName}});} catch(error) { 	alert(error.message); }";	
                } else {
                    let idApp = app.getUrlParam('moduleID') + 'App';
                    return ("opener.document.getElementById('" + idApp + "').querySelector('sk-application')['" + _callbackName + "']('" + fileKey + "', _${fileName})");	
                }
            }


            function registryCallBack(){
                var name = app.getScreenResourceID() + "_FileUpload";
                app.registerExternalCall(name, afterUpload);
                return name;
            }

            function afterUpload(fileKey, fileName){
                try{
                    if(_uploadCallBacks && _uploadCallBacks.hasOwnProperty(fileKey)){
                        _uploadCallBacks[fileKey](fileKey, fileName);
                    }
                } finally {
                    if(_uploadCallBacks && _uploadCallBacks.hasOwnProperty(fileKey)){
                        delete _uploadCallBacks[fileKey];
                    } 
                }
            }
        }]);





angular
    .module('snk.core.util')
    .directive('skId', ['SkComponentRegistry', 'AngularUtil', function (SkComponentRegistry, AngularUtil) {
        return {
            restrict: 'A',
            link: function (scope, elemnt, attrs) {
                if (attrs.skId){
                    var controller = AngularUtil.getControllerFromElement(elemnt);

                    if (controller){
                        var id;

                        try {
                            id = scope.$eval(attrs.skId);
                        } catch (error) {
                        }

                        if (!id){
                            id = attrs.skId;
                        }

                        SkComponentRegistry.register(controller, id, scope);
                    }
                }
            }
        };
    }]);
angular
	.module("snk.core.util")
	.service("SqlUtils", ['$q', 'StringUtils', 'ArrayUtils', 'ServiceProxy', 'ObjectUtils', 'DateUtils', 'DateUtilsConstants',
		function ($q, StringUtils, ArrayUtils, ServiceProxy, ObjectUtils, DateUtils, DateUtilsConstants) {
			var self = this;

			self.buildINClause = buildINClause;
			self.buildINClauseByValues = buildINClauseByValues;
			self.loadFromQuery = loadFromQuery;
			self.checkifExistWordInQuery = checkifExistWordInQuery;
			self.getParamsFromQuery = getParamsFromQuery;
			self.getDefaultNamedParamsObject = getDefaultNamedParamsObject;

			const VALUES_PER_CLAUSE = 1000;
			
			function buildINClause(alias, fieldName, list){
				var exp = "";
				var targetFieldName = alias + "." + fieldName;
				var firstParametres = true;

				exp += " IN ( ";

				for(var i = 0 ; i < list.length ; i++){
					if(i > VALUES_PER_CLAUSE -1 && i % VALUES_PER_CLAUSE == 0){

						exp += " ) ";
						exp += " OR " + targetFieldName + " IN ( ";
						exp += list[i];

					}else{

						if (!firstParametres) {
							exp += ", ";
						}

						exp += list[i];
						firstParametres = false;
					}
				}

				exp += " )";

				return exp;
			}


	        function buildINClauseByValues(fieldName, parameters) {
				var exp = "";
				var firstParametres = true;
				
				exp += "( " + fieldName + " IN ( ";
				
				for(var i = 0 ; i < parameters.length ; i++) {
					
					if(i > VALUES_PER_CLAUSE -1 && i % VALUES_PER_CLAUSE == 0) {
						
						exp += " ) ";
						exp += " OR " + fieldName + " IN ( ";
						exp += parameters[i];
						
					} else {
						
						if (!firstParametres) {
							exp += ", ";
						}
						
						exp += parameters[i];
						firstParametres = false;
					}
				}
				
				exp += " ) )";
				
				return exp;
			}

			/**
			 * Executa uma consulta sql
			 * @param {String} columnsName [NUINSTANCIA, NOMETAB]
			 * @param {String} tableName  TDDINS 
			 * @param {String} whereOrderGroup NOMEINSTANCIA = 'Parceiro'
			 * 
			 * @returns {Promise} retorna uma promessa do valor consultado
			 */
			function loadFromQuery(columnsName, tableName, whereOrderGroup, fullLine) {
				var deferred = $q.defer();

				columnsName = ArrayUtils.toArray(columnsName);

				var queryBuff = StringUtils.newBuffer();
				queryBuff.append(' SELECT ');

				var cont = columnsName.length;
				columnsName.forEach(columnName => {
					queryBuff.append(columnName);

					cont--;

					if (cont > 0) {
						queryBuff.append(', ');
					}
				});

				queryBuff.append(' FROM ');
				queryBuff.append(tableName);

				if (whereOrderGroup != null) {
					queryBuff.append(' WHERE ');
					queryBuff.append(whereOrderGroup);
				}


				var params = {
					querydata: {
						query: queryBuff.toString()
					}
				}

				ServiceProxy
					.callService('mge@ExecQuerySP.execQuery', params)
					.then(function (response) {
						var  rows = [];
						
						ArrayUtils.toArray(ObjectUtils.getProperty(response, 'responseBody.entity.line')).forEach(function (colunas) {
							
								var data = {};
								ArrayUtils.toArray(colunas.column)
									.forEach(function (col) {

										columnsName.forEach((name) => {
											if (col.name == name) {
												data[name] = col.value;
											}
										});
									});

							    rows.push(data);

								if(!fullLine){
									return;
								}
							});

						deferred.resolve(fullLine ? rows : rows.pop());
					});

				return deferred.promise;
			}

			/**
			 * Verifica se existe termo na consulta
			 * @param {String} query SELECT ADD_MONTHS('2008-04-30',1)
			 * @param {String} word  ADD_MONTHS
			 *
			 * @returns {boolean} retorna booleano
			 */
			function checkifExistWordInQuery(query, word){
				var regex = new RegExp(word, 'ig');
				var hasWord = query.search(regex);

				if (hasWord > -1) {
					return true
				}
				else {
					return false;
				}
			}

			/**
			 * Retorna lista com o nome dos parametros presente na function
			 * @param {String} query
			 * @param {String} word  ADD_MONTHS
			 *
			 * @returns {Array} retorna array
			 */
			function getParamsFromQuery(query, word){
				var arrayParametros = [];
				var regex = new RegExp('(?<=' + word + '\\s*\\(\\s*)(:\\w+)', 'gi');
				var sqlParams = query.match(regex);

				if(!StringUtils.isEmpty(sqlParams)){
					ArrayUtils.forEach(sqlParams, function (sqlParam) {
						var dateFormatted = DateUtils.formatDate(new Date(), DateUtilsConstants.DEFAULT_DATE_FORMAT);

						var param = new Object();
						param.key = sqlParam.replace(':', '');
						param.value = dateFormatted;
						arrayParametros.push(param);
					});
				}
				return arrayParametros;
			}

			/**
			 * Retorna objeto representando os parametros
			 * @param {Array} arrayParams
			 *
			 * @returns {Object} retorna object
			 */
			function getDefaultNamedParamsObject(arrayParams){
				var obj = new Object();

				ArrayUtils.forEach(arrayParams, function (param) {
					obj[param.key] = param.value;
				});

				return obj;
			}
		}
	]);
/*
 * This var has to be outside the angular factory, otherwise when
 * there are multiple sankhya apps on the same page, each app
 * will create its own instance of this array and the app's IDs
 * will not be unique.
 */
var nextUniqueId = ['0', '0', '0'];
angular
    .module("snk.core.util")
    .service("StringUtils", [function () {
        var self = this;

        var EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        var ESPECIAL_CHARS_REGEX = /[[.\-\$\+\*,_\&\(\)%\/\\#@!:\|\=\'\"]/gmi;

        var charsWithAccentuation = "ÁÉÍÓÚ_ÃÕ_ÂÊÎÔÛ_ÀÈÌÒÙ_Ü_Ç_áéíóú_ãõ_âêîôû_àèìòù_ü_ç";
        var charsWithoutAccentuation = "AEIOU_AO_AEIOU_AEIOU_U_C_aeiou_ao_aeiou_aeiou_u_c";
        var onlyNumbersRegExp = new RegExp('[^\\d]', 'g');
        var specialPhones = ['0300', '0500', '0800', '0900', '3003', '4003', '4004'];
        var PX = 'px';
        var DUPLICATED_HTMLENTITY_REGEX = /&amp;(?=amp;|lt;|gt;|quot;|apos;|#[0-9]+;)/

        var _htmlEntities = [
            ["&",  "&amp;"],
            ["<",  "&lt;"],
            [">",  "&gt;"]
        ];

        self.nextUid = nextUid;
        self.substitute = substitute;
        self.toBoolean = toBoolean;
        self.isEmpty = isEmpty;
        self.isNotEmpty = isNotEmpty;
        self.textToColor = textToColor;
        self.emptyAsUndefined = emptyAsUndefined;
        self.undefinedAsEmpty = undefinedAsEmpty;
        self.getValueOrDefault = getValueOrDefault;
        self.coalesce = coalesce;
        self.replaceCharacterSpecial = replaceCharacterSpecial;
        self.replaceAccentuatedChars = replaceAccentuatedChars;
        self.htmlScape = htmlScape;
        self.barScape = barScape;
        self.toHtmlText = toHtmlText;
        self.formatCgcCpf = formatCgcCpf;
        self.toCNPJ = toCNPJ;
        self.toCPF = toCPF;
        self.toPhone = toPhone;
        self.emptyAsNull = emptyAsNull;
        self.stringZero = stringZero;
        self.replicate = replicate;
        self.isDelimitersBalanced = isDelimitersBalanced;
        self.startsWith = startsWith;
        self.endsWith = endsWith;
        self.toPX = toPX;
        self.buildNick = buildNick;
        self.toDashCase = toDashCase;
        self.toCapitalCase = toCapitalCase;
        self.toPX = toPX;
        self.getOnlyFieldName = getOnlyFieldName;
        self.replaceHtmlEntities = replaceHtmlEntities;
        self.expandHierarchyMask = expandHierarchyMask;
        self.applyHierarchyMask = applyHierarchyMask;
        self.trim = trim;
        self.ltrim = ltrim;
        self.rtrim = rtrim;
        self.isValidEmail = isValidEmail;
        self.replaceAll = replaceAll;
        self.newBuffer = newBuffer;
		self.getSpecialCharacters = getSpecialCharacters;
        self.removeSpecialCharacters = removeSpecialCharacters;
        self.contains = contains;
        self.hasAccentuationOrWhiteSpace = hasAccentuationOrWhiteSpace;
        self.nullAsEmpty = nullAsEmpty;
		self.compareFunction = compareFunction;
        self.insertAt = insertAt;
        self.padStart = padStart;
        self.padEnd = padEnd;
        self.cesuraCpf = cesuraCpf;
        self.cesuraCnpj = cesuraCnpj;
        self.containsHtml = containsHtml;
        self.trimControleEstoque = trimControleEstoque;
        self.safelyEquals = safelyEquals;
        self.safelyEqualsIgnoreCase = safelyEqualsIgnoreCase;
        self.safelyStartsWith = safelyStartsWith;
        self.safelyEndsWith = safelyEndsWith;
        self.hasSpecialCharacters = hasSpecialCharacters;
        self.hasDigit = hasDigit;
        self.truncate = truncate;
        self.escapeRegExp = escapeRegExp;
        self.isNumeric = isNumeric;

        function trim(stringToTrim) {
            return stringToTrim && stringToTrim.replace(/^\s+|\s+$/g, "");
        }
        function ltrim(stringToTrim) {
            return stringToTrim && stringToTrim.replace(/^\s+/, "");
        }
        function rtrim(stringToTrim) {
            return stringToTrim && stringToTrim.replace(/\s+$/, "");
        }

        function toPX(value) {
            return value + PX;
        }

        function buildNick(name) {
            if (angular.isString(name)) {
                name = name.trim();

                return name.substr(0, Math.min(3, name.length));
            } else {
                return '';
            }
        }

        function toDashCase(value) {
            return value && value.replace(/([A-Z])/g, function ($1, p1, pos) {
                return (pos > 0 ? '-' : '') + $1.toLowerCase();
            });
        }

        function toCapitalCase(value, all) {
            if (!value) {
                return value;
            }

            if (all) {
                return value.replace(/\b([a-z])/g, function ($1, p1, pos) {
                    return $1.toUpperCase();
                });
            } else {
                return value.substr(0, 1).toUpperCase() + value.substr(1, value.length);
            }
        }

        function isDelimitersBalanced(str, open, close) {
            var count = 0;
            var curPos = 0;

            while (curPos < str.length) {
                var c = str[curPos++];

                if (c == open) {
                    count++;
                } else if (c == close) {
                    count--;
                }
            }

            return (count == 0);
        }

        function replicate(str, count) {
            count = Number(count) || 0;

            var replicated = '';

            for (var i = 0; i < count; i++) {
                replicated += str;
            }

            return replicated;
        }

        function startsWith(str, prefix) {
            return str.slice(0, prefix.length) == prefix;
        }

        function endsWith(str, suffix) {
            return str.slice(str.length - suffix.length) == suffix;
        }

        function expandHierarchyMask(maskBase) {
            var maskBaseArr = maskBase.split(".");
            maskBase = '';

            for (var i = 0; i < maskBaseArr.length; i++) {
                for (var x = 0; x < Number(maskBaseArr[i]); x++) {
                    maskBase += "#";
                }

                if (i < (maskBaseArr.length - 1)) {
                    maskBase += ".";
                }
            }

            return maskBase;
        }

        function applyHierarchyMask(mask, value, removeEmptyGroups = false, fromLeft = true, defaultChar = '') {
            if (angular.isUndefined(value) || value === '') {
                return '';
            }

            value = value.toString();

            if (angular.isUndefined(mask) || mask === '') {
                return value;
            }

            if (value.length !== value.replace(/\W/g, '').length) {
                value = value.replace(/\W/g, '');
            }

            if (angular.isDefined(defaultChar) && defaultChar !== '' || !fromLeft) {
                var regexDot = /\./g;
                var newMask = mask.replace(regexDot, '');

                if (!fromLeft && (angular.isUndefined(defaultChar) || defaultChar === '')) {
                    defaultChar = '0';
                }

                while (newMask.length - value.length > 0) {
                    if (fromLeft) {
                        value = value + defaultChar;
                    } else {
                        value = defaultChar + value;
                    }
                }
            }

            var maskedValue = '';
            var incMask = 0;

            for (var y = 0; y < mask.length; y++) {
                if (mask.charAt(y) == '.') {
                    maskedValue += '.';
                } else {
                    maskedValue += value.charAt(incMask++);
                }
            }

            if (removeEmptyGroups) {
                maskedValue = maskedValue.replace(/(\.0+)+$/g, '');
            }

            while (maskedValue.length > 0 && maskedValue.lastIndexOf('.') === (maskedValue.length-1)) {
                maskedValue = maskedValue.substring(0, maskedValue.lastIndexOf('.'));
            }

            return maskedValue;
        }

        function stringZero(value, width, truncOverFlow) {
            var sbuf = '';
            var valstr = isEmpty(value) ? '' : value.toString();

            if (angular.isUndefined(truncOverFlow)) {
                truncOverFlow = true;
            }

            if (valstr.length > width) {
                if (truncOverFlow === true) {
                    for (var i = 0; i < width; i++) {
                        sbuf += '*';
                    }
                } else {
                    return valstr;
                }
            } else if (valstr.length <= width) {
                for (var i = 0, len = valstr.length; i < (width - len); i++) {
                    sbuf += '0';
                }

                sbuf += valstr;
            }

            return sbuf.toString();
        }

        function formatCgcCpf(cgccpf) {
            if (angular.isUndefined(cgccpf) || cgccpf == null) {
                return cgccpf;
            }
            var cgccpfFormatado = '';

            var cgccpfSomenteDigitos;

            if (angular.isFunction(cgccpf.replace)) {
                cgccpfSomenteDigitos = cgccpf.replace(/[^a-zA-Z0-9]/g, '');
            } else {
                return cgccpf;
            }

            if (!hasDigit(cgccpfSomenteDigitos)) {
                return cgccpf;
            }

            if (cgccpfSomenteDigitos.length == 11) {
                cgccpfFormatado = toCPF(cgccpfSomenteDigitos);
            } else if (cgccpfSomenteDigitos.length == 14) {
                cgccpfFormatado = toCNPJ(cgccpfSomenteDigitos);
            } else {
                cgccpfFormatado = cgccpfSomenteDigitos;
            }

            return cgccpfFormatado;
        }

        function toCNPJ(cnpjDigits) {
            if (isEmpty(cnpjDigits)) {
                return '';
            }

            if (cnpjDigits.length < 14) {
                throw Error("Número de CNPJ inválido: número de dígitos menor que 14");
            } else if (cnpjDigits.length > 14) {
                throw Error("Número de CNPJ inválido: número de dígitos maior que 14");
            }

            //00.000.000/0000-00
            cnpjDigits = cnpjDigits.toUpperCase();
            return cnpjDigits.substring(0, 2) + '.' +
                cnpjDigits.substring(2, 5) + '.' +
                cnpjDigits.substring(5, 8) + '/' +
                cnpjDigits.substring(8, 12) + '-' +
                cnpjDigits.substring(12, 14);
        }

        function toCPF(cpfDigits) {
            if (!cpfDigits) {
                return '';
            }

            let cgccpfSomenteDigitos;

            if (angular.isFunction(cpfDigits.replace)) {
                cgccpfSomenteDigitos = cpfDigits.replace(onlyNumbersRegExp, '');
            } else {
                return cpfDigits;
            }

            if (cgccpfSomenteDigitos.length < 11) {
                throw new IllegalArgumentException("Número de CPF inválido: número de dígitos menor que 11");
            } else if (cgccpfSomenteDigitos.length > 11) {
                throw new IllegalArgumentException("Número de CPF inválido: número de dígitos maior que 11");
            }

            //000.000.000-00
            cgccpfSomenteDigitos = cgccpfSomenteDigitos.replace(/\D/g, '');             //Remove tudo o que não é dígito
            cgccpfSomenteDigitos = cgccpfSomenteDigitos.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca ponto entre o terceiro e o quarto dígitos
            cgccpfSomenteDigitos = cgccpfSomenteDigitos.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca ponto entre o setimo e o oitava dígitos
            cgccpfSomenteDigitos = cgccpfSomenteDigitos.replace(/(\d{3})(\d)/, '$1-$2'); //Coloca traço entre o decimo primeiro e o decimo segundo dígitos

            return cgccpfSomenteDigitos;
        }

        function toPhone(strPhone) {
            if (angular.isUndefined(strPhone) || strPhone == null) {
                return '';
            }

            strPhone = String(strPhone).replace(onlyNumbersRegExp, '');

            if (strPhone.length >= 4) {
                var prefix = strPhone.substr(0, 4);
                if (specialPhones.indexOf(prefix) > -1) {
                    strPhone = strPhone.replace(/(\d)(\d{4})$/, '$1 $2');
                    strPhone = strPhone.replace(/(\d{4})(\d)/, '$1 $2');

                    return strPhone;
                }

                if (strPhone.length >= 8) {
                    strPhone = strPhone.replace(/(\d)(\d{4})$/, '$1-$2');

                    var dashIndex = strPhone.indexOf('-');

                    if (dashIndex < 6) {
                        return strPhone;
                    }

                    if (strPhone.indexOf('0') === 0) {
                        strPhone = strPhone.substr(1);
                    }

                    strPhone = strPhone.replace(/(\d)(\d{4})$/, '$1-$2');
                    strPhone = strPhone.replace(/(\d{2})(\d)/, '(0$1) $2');
                }
            }

            return strPhone;
        }

        function replaceCharacterSpecial(source) {
        	if (!source || !angular.isFunction(source.replace)) {
                return source;
            }

            return source.replace(/[^a-zA-Z\d\s]/gmi, (char) => `\\${char}`);
        }

        function replaceAccentuatedChars(source) {
            if (!source || !angular.isFunction(source.replace)) {
                return source;
            }

            return source.replace(/[^\w ]/g, function (char) {
                var index = charsWithAccentuation.indexOf(char);

                if (index > -1) {
                    char = charsWithoutAccentuation.charAt(index);
                }

                return char || '';
            });
        }

        function getValueOrDefault(value, vlrDefault) {
            value = emptyAsUndefined(value);
            return angular.isUndefined(value) ? vlrDefault : value;
        }

        function coalesce() {
            for (var i = 0; i < arguments.length; i++) {
                var v = emptyAsUndefined(arguments[i]);
                if (angular.isDefined(v)) {
                    return v;
                }
            }
            return undefined;
        }

        function emptyAsUndefined(s) {
            if (angular.isUndefined(s) || s.length === 0) {
                return undefined;
            }

            var trimed = s.trim();

            return trimed.length === 0 ? undefined : trimed;
        }

        function undefinedAsEmpty(s) {
        	return angular.isUndefined(s) ? '' : s;
        }

        function textToColor(str) {
            if(typeof str != 'string'){
                try{
                    str = String(str);
                }catch{
                    str = '';
                }
            }

            if(isEmpty(str) ) {
                return '#000000';
            }else if(str == '0'){
                return '#94948e';
            }

            var hash = 0;

            for (var i in str) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }

            var color = '#';
            for (var j = 0; j < 3; j++) {
                var value = (hash >> (j * 8)) & 0xF0;

                color += ('00' + value.toString(16)).substr(-2);
            }

            return color;
        }

        function substitute(format, ignoreAngularBinds) {
            var args;

            if (!angular.isObject(arguments[1])) {
                args = Array.prototype.slice.call(arguments, 1);
            } else {
                args = arguments[1];
            }

            return format.replace(/((?!{).|^){(\d+|\w+)}/g, function (match, firstGroup, secondGroup) {
                return firstGroup + (typeof args[secondGroup] != 'undefined' ? args[secondGroup] : '');
            });
        }

        function nextUid() {
            var index = nextUniqueId.length;
            var digit;

            while (index) {
                index--;
                digit = nextUniqueId[index].charCodeAt(0);
                if (digit == 57 /*'9'*/) {
                    nextUniqueId[index] = 'A';
                    return nextUniqueId.join('');
                }
                if (digit == 90 /*'Z'*/) {
                    nextUniqueId[index] = '0';
                } else {
                    nextUniqueId[index] = String.fromCharCode(digit + 1);
                    return nextUniqueId.join('');
                }
            }

            nextUniqueId.unshift('0');

            return nextUniqueId.join('');
        }

        function toBoolean(value) {
            if (angular.isDefined(value) && value !== null && value.length !== 0) {
                var v = (value + "").toLowerCase();

                return (v == 'true' || v == 's');
            } else {
                return false;
            }
        }

        function isEmpty(value) {
            if (angular.isUndefined(value) || value === null) {
                return true;
            }

            value = value.toString();
            value = value.trim();

            if (value.length === 0) {
                return true;
            }

            return false;
        }

        function isNotEmpty(value) {
            return !isEmpty(value);
        }

        function htmlScape(strHtml, validaDuplicidadeOuMalformatado = false) {
            if (strHtml === null) {
                return undefined;
            } else if (strHtml === "") {
                return strHtml;
            }

            _htmlEntities.forEach(function(htmlEntity) {
                strHtml = strHtml.replace(new RegExp(htmlEntity[0], 'g'), htmlEntity[1]);
            });

            if(validaDuplicidadeOuMalformatado){
                strHtml = strHtml.replace(new RegExp(DUPLICATED_HTMLENTITY_REGEX, 'g'), '&');
            }

            return strHtml;
        }

        function toHtmlText(strHtml) {
            if (isEmpty(strHtml)) {
                return strHtml;
            }

            _htmlEntities.forEach(function(htmlEntity) {
                strHtml = strHtml.replace(new RegExp(htmlEntity[1], 'g'), htmlEntity[0]);
            });

            return strHtml;
        }

        function containsHtml(str) {
            if (isNotEmpty(str)) {
                var elemDiv = document.createElement('div');
                elemDiv.innerHTML = str;

                for (var child = elemDiv.childNodes, i = child.length; i--;) {
                    if (child[i].nodeType == 1) {
                        return true; 
                    }
                }

                return false;
            }
        }

        function emptyAsNull(str) {
            if (str != null && str.length == 0) {
                return null;
            } else {
                return str;
            }
        }

        function getOnlyFieldName(fullPath) {
            if (!fullPath) {
                return '';
            }

            var fieldName = '';
            for (var i = fullPath.length - 1; i >= 0; i--) {
                if (fullPath[i] != '.') {
                    fieldName = fullPath[i] + fieldName;
                } else {
                    break;
                }
            }

            return fieldName;
        }

        function replaceHtmlEntities(value) {
            if (!isEmpty(value)) {
                return value
                    .replace(/\&lt\;/g, '<')
                    .replace(/\&gt\;/g, '>');
            }

            return value;
        }

        function isValidEmail(value) {
        	return EMAIL_REGEX.test(value);
        }

        function replaceAll(str, de, para) {
			
			if(isEmpty(str)){
				return str;
			}
			
			let resultString = '';
			
			let index = 0;
            
            while (index < str.length) {
				let foundIndex = str.indexOf(de, index);
				
				if(foundIndex == -1){
					resultString += str.slice(index);
            		break;
				}

				resultString += str.slice(index, foundIndex) + para;
				
				index = foundIndex + de.length;
            }
            return resultString;
        };

        function barScape(string){

            var barScape = "";

            for(var index in string){
                barScape += string[index].indexOf('"') > -1 ? '\\"' : string[index];
            }

            return barScape;
        }

		function getSpecialCharacters(str){
            var match;
            var chars = [];
            while((match = ESPECIAL_CHARS_REGEX.exec(str))){
                chars.push(str[match.index]);
            }
            return chars;
        }

        function removeSpecialCharacters(str){
            var specialChars = getSpecialCharacters(str);
            specialChars.forEach(function(ch){
                str = replaceAll(str, ch, '');
            });

            return str;
        }

        function newBuffer() {
            var value = [];
            return {
                append: function (data) {
                    value.push(data);
                    return this;
                },
                toString:function(){
                    return value.join('');
                },
                length:function(){
                    return value.join('').length;
                },
                clear:function(){
                    value = [];
                    return this;
                }
            };
        };

        function contains(data, characters){

            if(!data){
                return;
            }

            if(!characters){
                return;
            }

            if(characters && angular.isString(characters)){
                characters = [characters];
            }

            let size = 0;

            for(var i=0; i < characters.length; i++){
                if(data.indexOf(characters[i]) > -1){
                    size ++;
                }
            }

            if(size === characters.length){
                return true;
            }

            return false;
        }

        function hasAccentuationOrWhiteSpace(str){
            if(!str){
                return;
            }

            let whiteSpace = /\s/;

            if(whiteSpace.test(str)){
                return true;
            }

            for(let char of str){
               if(charsWithAccentuation.indexOf(char) > -1){
                    return true;
               }
            }

            return false;
        }

	 	function nullAsEmpty(value){
            if(value == undefined) return '';
            return value;
        }

		function compareFunction(strValue1, strValue2, ascending){
			var dt1 = strValue1 != undefined ? strValue1.toString() : undefined;
			var dt2 = strValue2 != undefined ? strValue2.toString() : undefined;

			if(dt1 == undefined){
				if(dt2 == undefined){
					return 0;
				}else{
					return ascending ? -1 : 1;
				}
			} else if(dt2 == undefined) {
				return ascending ? 1 : -1;
			}

			if(ascending){
				return dt1.localeCompare(dt2);
			}

			return dt2.localeCompare(dt1);
		}

        function insertAt(str, newStr, index) {
            return str.substring(0, index) + newStr + str.substring(index, str.length);
        }

        function padStart(str, len, pad) {
            str = angular.isDefined(str) ? str.toString() : '';
            pad = angular.isDefined(pad) ? pad.toString() : '';
            while(str.length < len) {
                str = pad + str;
            }
            return str;
        }

        function padEnd(str, len, pad) {
            str = angular.isDefined(str) ? str.toString() : '';
            pad = angular.isDefined(pad) ? pad.toString() : '';
            while(str.length < len) {
                str = str + pad;
            }
            return str;
        }

        function cesuraCpf(cpf) {

            if (angular.isUndefined(cpf) || cpf == null) {
                return cpf;
            }else if (cpf.length < 11) {
                cpf = stringZero(cpf, 11);
            } else if (cpf.length > 11) {
                throw new IllegalArgumentException("Número de CPF inválido: número de dígitos maior que 11");
            }

            var cpfCensurado  = "***." + cpf.substring(3,6) + "." + cpf.substring(6,9) + ".***";

            return cpfCensurado;
        }

        function cesuraCnpj(cnpj) {

            if (angular.isUndefined(cnpj) || cnpj == null) {
                return cnpj;
            }else if (cnpj.length < 14) {
                cnpj = stringZero(cnpj, 14);
            } else if (cnpj.length > 14) {
                throw new IllegalArgumentException("Número de CNPJ inválido: número de dígitos maior que 14");
            }

            var cnpjCensurado  = "**." + cnpj.substring(2,5) + "." + cnpj.substring(5,8) + "/****-" + cnpj.substring(12,14);

            return cnpjCensurado;
        }
        function trimControleEstoque(controle){
			let result = controle === null ? " " : controle.trim();
			return result.length > 0 ? result : " ";
		}

        function safelyEquals(str1, str2) {
            if (isEmpty(str1)) {
                return isEmpty(str2);
            }
        
            if (isEmpty(str2)) {
                return false;
            }
        
            return str1 === str2;
        }
        
        function safelyEqualsIgnoreCase(str1, str2) {
            if (isEmpty(str1)) {
                return isEmpty(str2);
            }
        
            if (isEmpty(str2)) {
                return false;
            }
        
            return str1.toLowerCase() === str2.toLowerCase();
        }

        function safelyStartsWith(str, term){
            if (isEmpty(str)){
                return false;
            }

            if (isEmpty(term)){
                return false;
            }

            return str.toLowerCase().startsWith(term.toLowerCase());
        }

        function safelyEndsWith(str, term){
            if (isEmpty(str)){
                return false;
            }

            if (isEmpty(term)){
                return false;
            }

            return str.toLowerCase().endsWith(term.toLowerCase());
        }

        function hasSpecialCharacters(input) {
            if (typeof input !== 'string') {
                return false;
            }
            
            const allowedChars = /[^a-zA-Z0-9 _]/;
            return allowedChars.test(input);
        }

        function hasDigit(value) {
            if (isEmpty(value)) {
                return false;
            }

            return /\d/.test(value);
        }

        function truncate(str, max, suffix) {
            if (isEmpty(str) || angular.isUndefined(max) || str.length <= max) {
                return str;
            }

            suffix = angular.isUndefined(suffix) ? '…' : suffix;

            return str.slice(0, Math.max(0, max - suffix.length)) + suffix;
        }

        function escapeRegExp(str) {
            if (isEmpty(str)) {
                return str;
            }

            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        function isNumeric(value) {
            if (isEmpty(value)) {
                return false;
            }

            return /^\d+$/.test(value.toString());
        }

    }]);


/**
 * @ngdoc service
 * @name snk.core.util.service:SwipeUtil
 *
 * @description
 * Disponibiliza as funções para trabalhar com $swipe do AngularJS e ouvir os eventos de touch para a
 * direita e para a esquerda.
 */
angular
    .module("snk.core.util")
    .service("SwipeUtil", ['$swipe', 'SkConstants', function ($swipe, SkConstants) {
        // The maximum vertical delta for a swipe should be less than 75px.
        var MAX_VERTICAL_DISTANCE = 75;
        // Vertical distance should not be more than a fraction of the horizontal distance.
        var MAX_VERTICAL_RATIO = 0.3;
        // At least a 30px lateral motion is necessary for a swipe.
        var MIN_HORIZONTAL_DISTANCE = 30;

        var self = this;
        self.left = left;
        self.right = right;

        /**
         * @ngdoc
         * @name SwipeUtil#left
         * @methodOf snk.core.util.service:SwipeUtil
         * @description
         * Método executado no momento em que acontece o <b>swipe</b> no tablet da direita para a <b>esquerda</b>.
         *
         * @param {object} scope escopo do contexto onde o serviço está sendo usado.
         * @param {object} parent elemento onde vai ser registrado os eventos de swipe.
         * @param {function} callbackFn função de callback que é chamada quando o evento acontece, nessa função é possível
         * pegar 1 objeto como parametro para saber os pontos X e Y em que os eventos aconteceram.
         * @param {boolean} [enableMouseSwipe=false] habilita no evento o monitoramento dos eventos mouseDown e
         * mouseMove.
         *
         * @example
         * <pre>
         *     SwipeUtil.right(scope, parent, callbackFn(data), enableMouseSwipe);
         * </pre>
         */
        function left(scope, element, callback, enableMouse) {
            buildSwipe(element, scope, callback, enableMouse, -1, SkConstants.EVENTS.SWIPE_LEFT);
        }

        /**
         * @ngdoc
         * @name SwipeUtil#right
         * @methodOf snk.core.util.service:SwipeUtil
         * @description
         * Método executado no momento em que acontece o <b>swipe</b> no tablet da esquerda para a <b>direita</b>.
         *
         * @param {$scope} scope escopo do contexto onde o serviço está sendo usado.
         * @param {object} parent elemento onde vai ser registrado os eventos de swipe.
         * @param {function} callbackFn função de callback que é chamada quando o evento acontece, nessa função é possível
         * pegar 1 objeto como parametro para saber os pontos X e Y em que os eventos aconteceram.
         * @param {boolean} [enableMouseSwipe=false] habilita no evento o monitoramento dos eventos mouseDown e mouseMove.
         *
         * @example
         * <pre>
         *     SwipeUtil.right(scope, parent, callbackFn(data), enableMouseSwipe);
         * </pre>
         */
        function right(scope, element, callback, enableMouse) {
            buildSwipe(element, scope, callback, enableMouse, 1, SkConstants.EVENTS.SWIPE_RIGHT);
        }

        function buildSwipe(element, scope, callback, enableMouse, direction, eventName) {
            var startCoords;
            var valid;
            var pointerTypes = ['touch'];

            element = angular.element(element);

            enableMouse = angular.isDefined(enableMouse) ? enableMouse : false;

            if (enableMouse) {
                pointerTypes.push('mouse');
            }

            $swipe.bind(element, {
                'start': function (coords, event) {
                    startCoords = coords;
                    valid = true;
                },
                'cancel': function (event) {
                    valid = false;
                },
                'end': function (coords, event) {
                    if (validSwipe(coords)) {
                        scope.$apply(function () {
                            element.triggerHandler(eventName);

                            callback({
                                'startCoords': startCoords,
                                'endCoords': coords,
                                '$event': event
                            });
                        });
                    }
                }
            }, pointerTypes);

            function validSwipe(coords) {
                // Check that it's within the coordinates.
                // Absolute vertical distance must be within tolerances.
                // Horizontal distance, we take the current X - the starting X.
                // This is negative for leftward swipes and positive for rightward swipes.
                // After multiplying by the direction (-1 for left, +1 for right), legal swipes
                // (ie. same direction as the directive wants) will have a positive delta and
                // illegal ones a negative delta.
                // Therefore this delta must be positive, and larger than the minimum.

                if (!startCoords) {
                    return false;
                }

                var deltaY = Math.abs(coords.y - startCoords.y);
                var deltaX = (coords.x - startCoords.x) * direction;

                return valid && deltaY < MAX_VERTICAL_DISTANCE && deltaX > 0 && deltaX > MIN_HORIZONTAL_DISTANCE && deltaY / deltaX < MAX_VERTICAL_RATIO;
            }
        }

    }]);
function Time(hour, min, sec, unlimitedHour, minutesIsPriority){
    this.hour = Number(hour);
    this.min = Number(min);
    this.sec = Number(sec);

    if (angular.isDefined(unlimitedHour)){
        this.unlimitedHour = unlimitedHour;
    }

    if (angular.isDefined(minutesIsPriority)){
        this.minutesIsPriority = minutesIsPriority;
    }

}

Time.prototype.hour = undefined;
Time.prototype.min = undefined;
Time.prototype.sec = undefined;
Time.prototype.unlimitedHour = false;
Time.prototype.minutesIsPriority = true;

Time.prototype.isValid = function(includeSeconds){
    return !isNaN(this.hour) || !isNaN(this.min) || !isNaN(this.sec);
};

Time.prototype.toString = function (includeSeconds){
    var str = Time.getStrFromNumber(this.hour).concat(':').concat(Time.getStrFromNumber(this.min));

    if (includeSeconds){
        str = str.concat(':').concat(Time.getStrFromNumber(this.sec));
    }

    return str;
};

Time.prototype.toDate = function (baseDate){
    if (this.isValid()) {
        baseDate = baseDate || new Date();

        baseDate.setHours(this.hour);
        baseDate.setMinutes(this.min);
        baseDate.setSeconds(this.sec);

        return baseDate;
    } else {
        return null;
    }
};

Time.prototype.toNumber = function (includeSeconds){
    var hour = Time.getStrFromNumber(this.hour);
    var min = Time.getStrFromNumber(this.min);
    var sec = Time.getStrFromNumber(this.sec);

    var strTime = hour.concat(min);

    if (includeSeconds) {
        strTime = strTime.concat(sec);
    }

    return Number(strTime);
};



Time.parse = function(value, unlimitedHour, minutesIsPriority){
    var hour = NaN;
    var min = NaN;
    var sec = NaN;
    
    /* Caso o value vier com o length igual a 3, é incluído um zero antes para que
     * as horas estejam certas.
     * Exemplo:
     * 100 = 01:00
     */
    if(value && value.toString().length == 3){
        value = 0 + "" +  value;
    }

    if (value && minutesIsPriority){ //Aqui se o cara digitar 2, será 2 minutos
        var strVal = String(value);
        var orgianlValue = strVal;

        if(strVal && strVal.indexOf(':') < 0){
            strVal = strVal.replace(/[^\d]/g, '');

            while(strVal.length < (unlimitedHour ? 5 : 4)){
                strVal = '0' + strVal.replace(/[^\d]/g, '');
            }

            strVal = strVal.substr(0, (unlimitedHour ? 3 : 2)) + ':' + strVal.substr((unlimitedHour ? 3 : 2),2);

            let secSubStr = orgianlValue.substr((unlimitedHour ? 5 : 4));

            if(secSubStr){
                strVal += (':' + secSubStr);
            }
        }

        var parts = unlimitedHour ? /^(\d{0,3}):([1-5]\d|0\d)$/.exec(strVal) : /^(\d|[0-1]\d|2[0-3]):([1-5]\d|0\d|\d)(:([0-5]\d|\d)){0,1}$/.exec(strVal);

        if(parts && parts.length > 0){
            hour = Number(parts[1] || 0);
            min  = Number(parts[2] || 0);
            sec  = Number(parts[4] || 0);

            if(min < 6 &&  String(parts[2]).charAt(0) != '0'){
                min *= 10;
            }
        }
    } else if (value) { //Aqui se o cara digitar 2, será 2 horas
        var parts = /^([0-1]\d|2[0-3]|0\d|\d):?([0-5]\d|\d)?:?([0-5]\d|\d)?$/.exec(value);

        if (Array.isArray(parts) && parts.length > 0){
            hour = Time.stringZero(parts[1], 2);
            min = Time.stringZero(parts[2], 2);
            sec = Time.stringZero(parts[3], 2);
        }
    }

    if(hour === '00' && sec === "00"){
        minutesIsPriority = true;
    }

    return new Time(hour, min, sec, unlimitedHour, minutesIsPriority);
};

Time.stringZero = function (value, width) {
    var valstr = (value == undefined) ? '' : value.toString();

    if (valstr.length > width) {
        return valstr;
    } else if (valstr.length <= width) {
        var sbuf = '';

        for (var i = 0, len = valstr.length; i < (width - len); i++){
            sbuf += '0';
        }

        sbuf += valstr;

        return sbuf.toString();
    }

    return value;
};

Time.getStrFromNumber = function(n){
    var strValue = '';

    if(isNaN(n)){
        strValue = '00';
    } else {
        if(n < 10){
            strValue = '0';
        }

        strValue = strValue.concat(n);
    }
    return strValue;
};

Time.getAsNumber = function (n){
    if(isNaN(n)){
        return 0;
    } else {
        return n;
    }
};
/**
 * @ngdoc interface
 * @name util.common.interface:TXProperties
 * @description Classe utilizada para passar guadar informa��es em forma de chave/valor para a sess�o Jape
 */
function TXProperties() {
}

TXProperties.prototype.props = undefined;

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#addProperty
 * @methodOf util.common.interface:TXProperties
 * @description Fun��o respons�vel por adicionar um valor na TXProperties
 * @param {string} key Chave da propriedade.
 * @param {object} value Valor da propriedade.
 */
TXProperties.prototype.addProperty = function (key, value) {
    if (!this.props) {
        this.props = {};
    }

    if (value != undefined && value !== '') {
        this.props[key] = value;
    }
};

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#getProperty
 * @methodOf util.common.interface:TXProperties
 * @description Fun��o respons�vel buscar um valor na TXProperties
 * @param {string} key Chave da propriedade.
 * @returns {object} value Valor da propriedade.
 */
TXProperties.prototype.getProperty = function (key) {
    return this.props && this.props[key];
};

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#removeProperty
 * @methodOf util.common.interface:TXProperties
 * @description Fun��o respons�vel por remover um valor da TXProperties
 * @param {string} key Chave da propriedade.
 * @returns {object} Valor da propriedade.
 */
TXProperties.prototype.removeProperty = function (key) {
    if (this.props) {
        var value = this.props[key];
        delete this.props[key];
        return value;
    } else {
        return undefined;
    }
};

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#reset
 * @methodOf util.common.interface:TXProperties
 * @description Fun��o que reseta as propriedades da inst�ncia.
 */
TXProperties.prototype.reset = function () {
    this.props = undefined;
};

/**
 * @ngdoc
 * @name util.common.interface:CriteriaProvider#setupProperties
 * @methodOf util.common.interface:TXProperties
 * @description Fun��o que copia as propriedades para um objeto qualquer em um atributo chamado 'txProperties'.
 */
TXProperties.prototype.setupProperties = function (destination) {
    if (this.props && destination){
        destination.txProperties = {prop: []};

        angular.forEach(this.props, function(value, key){
            destination.txProperties.prop.push({
                name: key,
                value: value
            });
        });
    }
};


angular
    .module("snk.core.util")
    .service("UidGenerator", function () {
        var self = this;

        var CHARSUID = "abcdefghijklmnopqrstuvwxyz0123456789";
        var _lastUID;
        
        self.generateUID=generateUID;

        function generateUID(prefix) {
            if (prefix == null) {
                prefix = "uid_";
            }

            if (_lastUID) {
                _lastUID++;
            } else {
                var now = new Date();
                _lastUID = now.getTime();
            }

            return prefix + generateTinyUID(_lastUID);
        }

        function generateTinyUID(i) {
            return i < CHARSUID.length
                ? CHARSUID.charAt(i)
                : arguments.callee(i / CHARSUID.length - 1) +
                CHARSUID.charAt(i % CHARSUID.length);
        }

    });
angular
    .module("snk.core.util")
    .service("UrlUtils", ['StringUtils', 'Base64', '$q', '$window',function (StringUtils, Base64, $q, $window) {
        var self = this;

        self.getQueryParams = getQueryParams;
        self.getTokenParam = getTokenParam;
        self.getPkObject = getPkObject;
        self.getUrlBase = getUrlBase;
        self.getPkHashFromToken = getPkHashFromToken;
        self.getResourceIDFromToken = getResourceIDFromToken;
        self.getQueryParamsFromToken = getQueryParamsFromToken;
        self.downloadFileFromUrl = downloadFileFromUrl;

        function getQueryParams(qs) {
            var params = {};
            var tokens;
            var re = /[?&]?([^=]+)=([^&]*)/g;

            //Necessário por causa da tela Histórico Padrão que possui resourceID com acento
            qs = unescape(qs);

            qs = qs.split("+").join(" ");

            while (tokens = re.exec(qs)) {
                params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
            }
            
            //Inserimos a urlBase no params.
            params['urlBase'] = getUrlBase();

            if(window.moduleID && window.URIServiceBroker){
                params['moduleID'] = window.moduleID;
                params['URIServiceBroker'] = window.URIServiceBroker;
            }

            return params;
        }

        function getTokenParam(token, pos, splitLimit) {
            //#app/resourceID/jsonPk&command
            if (StringUtils.emptyAsUndefined(token)) {
                var commandStart = token.indexOf("&");

                if (commandStart > -1) {
                    token = token.substring(0, commandStart);
                }

                var tokens = (splitLimit > 0) ? splitWithLimit(token, "/", splitLimit) : token.split("/");

                if (pos > -1 && pos < tokens.length) {
                    return tokens[pos];
                }
            }

            return undefined;
        }

        function splitWithLimit(str, separator, limit) {
            var parts = str.split(separator);
            if (parts.length <= limit) return parts;
            var result = parts.slice(0, limit - 1);
            result.push(parts.slice(limit - 1).join(separator));
            return result;
        }

        function getResourceIDFromToken(token) {
            return Base64.decode(getTokenParam(token, 1));
        }

        function getPkHashFromToken(token) {
            return getTokenParam(token, 2, 3);
        }

        function getQueryParamsFromToken(token) {
            // Padrão de entrada: #app/resourceID/pkHash&queryParams
            if (StringUtils.emptyAsUndefined(token)) {
                let paramsStart = token.indexOf("&");

                return (paramsStart == -1) ? {} : getQueryParams( token.substring(paramsStart, token.length) );
            }

            return {};
        }

        function getPkObject(pkHash, isUTF8) {
            if (pkHash) {
                pkHash = Base64.decode(pkHash, isUTF8);

                if (pkHash && pkHash != '') {
                    return JSON.parse(pkHash);
                }
            }

            return undefined;
        }

        function getUrlBase() {
            return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
        }
        
        /**
         * Realiza o download de um arquivo a partir de uma URL, utilizando a API Fetch/Blob
         * para máxima compatibilidade com as políticas de segurança dos navegadores.
         *
         * @param {string} url A URL completa do arquivo a ser baixado.
         * @param {string} filename O nome que o arquivo deverá ter ao ser salvo.
         * @returns {Promise} Uma promessa que é resolvida quando o download é iniciado
         * ou rejeitada em caso de erro.
         */
        function downloadFileFromUrl(url, filename) {
            return fetch(url)
                .then(function(response) {
                    if (!response.ok) {
                        throw new Error('Falha na requisição: ' + response.statusText);
                    }
                    return response.blob();
                })
                .then(function(blob) {
                    const a = document.createElement('a');
                    const downloadUrl = $window.URL.createObjectURL(blob);

                    a.href = downloadUrl;
                    a.download = filename || 'downloaded_file';
                    document.body.appendChild(a);
                    
                    a.click();

                    document.body.removeChild(a);
                    $window.URL.revokeObjectURL(downloadUrl);

                    return $q.resolve();
                })
                .catch(function(error) {
                    console.error('Falha ao baixar o arquivo.', error);
                    return $q.reject(error);
                });
        }
    }]);
/**
 * @ngdoc service
 * @name snk.core.util.service:UserDetailBuilder
 *
 */
 angular
    .module('snk.core.util')
    .service('UserDetailBuilder', ['ServiceProxy', 'AngularUtil', 'DatasetUtils', 'i18n', 'StringUtils', 'FormService', 'ArrayUtils', 'ObjectUtils',
        function (ServiceProxy, AngularUtil, DatasetUtils, i18n, StringUtils, FormService, ArrayUtils, ObjectUtils) {
            var self = this;

            self.buildUserFields = buildUserFields;
            self.loadUserFields = loadUserFields;
            self.buildUserEntities = buildUserEntities;
            self.buildAddictionalFields = buildAddictionalFields;

             /**
             * A única opção que temos para formulário configurável é utilizando o Dynaform.
             * Para utilizar o ConfigurableForm deve ser implementado, pois se trata de um formulário configurável dinamicamente.
             * Será implementado posteriormente.
             */

            function buildUserFields(scope, masterDataset, parent, defaultLabel, useConfigurableForm = false, configPrefix = null, options = {}, compileTabNavigator){

                var processFields = function (result, asJSON = true){
                    var dbFields = [];

                    var fields = ObjectUtils.getProperty(result, 'responseBody.camposAdicionais.campo');

                    var element = AngularUtil.getControllerFromElement(parent);

                    scope.dataset = masterDataset;

                    if(!fields){
                        if (angular.isFunction(compileTabNavigator)) {
                            compileTabNavigator(undefined);
                        }
                        return;
                    }

                    if(asJSON && fields){
                        dbFields = DatasetUtils.convertObjectFieldToDatasetField(masterDataset, fields);
                    } else {
                        dbFields = [dbFields];
                    }

                    var abasPorLabel = new Object();
                    var ordemAbas = [defaultLabel];
                    var currentTab = [];

                    for (var index in dbFields){
                        var campo = dbFields[index];

                        var tabLabel = campo.tabName;
                        
                        if(StringUtils.emptyAsNull(tabLabel) == null){
                            tabLabel = defaultLabel;
                        }
                        
                        currentTab = abasPorLabel[tabLabel];

                        if(currentTab == null){
                            currentTab = [];
                            abasPorLabel[tabLabel] = currentTab;
                            
                            if(tabLabel != defaultLabel){
                                ordemAbas.push(tabLabel);
                            }
                        
                        }
                        currentTab.push(campo);
                    }

                    for (var index in ordemAbas){
                        var label = ordemAbas[index];
                        currentTab = abasPorLabel[label];
                        
                        if(currentTab != null && currentTab.length > 0){                           
                            buildForm(element, currentTab, label, options, compileTabNavigator);
                        }

                    }

                };
                
                loadUserFields(masterDataset, processFields);
            }

            function loadUserFields(masterDataset, callBack){
                ServiceProxy.callService("mge@UserFormSP.getUserFields", buildParams(masterDataset))
                    .then(function(result){
                         callBack(result);
                    });   
            }

            function buildUserEntities(scope, masterDataset, parent, generateAddictinalFields = false, callBack = null, options = {}){
                ServiceProxy.callService("mge@UserFormSP.getUserEntities", buildParams(masterDataset))
                    .then(function(result){
                        
                        if(result.responseBody.hasOwnProperty("entidadesAdicionais")){
                            var entities = result.responseBody.entidadesAdicionais;
                            var element = AngularUtil.getControllerFromElement(parent);
                            var component = scope.$new(true);

                            var attrs = {
                                'sk-skip-start-page': 'true',
                                'sk-ignored-config-entity': 'true'
                            };

                            if(angular.isDefined(options.parentDynaform)){
                                component.parentDynaform = options.parentDynaform;
                                attrs['sk-parent-dynaform'] = 'parentDynaform';
                                attrs['sk-hide-tour'] = 'true';
                            }else{
                                component.onDynaformLoad = function(dynaform, dataset){
	
									let masterKeys = masterDataset.getFieldNames();
									let datasetKeys = dataset.getPrimaryKeys();
									if(masterKeys){
										dataset.addCriteriaProvider(() => {
											let criteria = Criteria();
											if(masterDataset.getRecordsAsObject().length > 0){		                                        
		                                        for(let key of masterKeys) {
													for(let keyDataset in datasetKeys){
														if(key == datasetKeys[keyDataset]){
															criteria.and("this." + key + " = ?", masterDataset.getFieldValue(key));
														}
													}		                                            
		                                        }
	                                        }
	                                        return criteria;
	                                    });
                                    }
	
                                    dataset.setParentDataSet(masterDataset);
                                };
                                attrs['sk-on-dynaform-loaded'] = 'onDynaformLoad(dynaform, dataset)';
                                attrs['sk-parent-entity-name'] = masterDataset.getEntityName();
                                if (options?.hideTour === true) {
                                    attrs['sk-hide-tour'] = 'true';
                                }
                            }

                            for(var index in ArrayUtils.toArray(entities.entidade)){
                                var entity = entities.entidade[index] ? entities.entidade[index] : entities.entidade;
                                
                                attrs['sk-entity-name'] = entity.nome;
                                var dynaform = angular.element(AngularUtil.createDirective('sk-dynaform', attrs, component));

                                element.addTab(dynaform, entity.descricao);
                            }
                        }

                        if(generateAddictinalFields){
                            buildAddictionalFields(scope, masterDataset, parent, callBack, options);
                        }
                    });    
            }

            function buildAddictionalFields(scope, masterDataset, parent, callBack = null, options = {}) {
                ServiceProxy.callService("mge@UserFormSP.getUserFields", buildParams(masterDataset))
                    .then(function (result) {
                        if (result.responseBody != null) {

                            var defaultLabel = i18n('SanDB.Comum.abaInfomacoesAdd');
                            var currentTabs = {};

                            scope.dataset = masterDataset;
                            
                            var camposAdicionais = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.camposAdicionais.campo'));
                            
                            if (options && options.hideChildless && angular.isElement(parent)) {
                                var container = angular.element(parent);
                                var withChildren = camposAdicionais.length > 0 ? true : false;
                                container[withChildren ? 'removeClass' : 'addClass']('ng-hide');
                            }

                            camposAdicionais.forEach(campo => {
                            
                                var tabLabel = options.customTabLabel ? options.customTabLabel : ( StringUtils.emptyAsUndefined(campo.uiTabName) || defaultLabel);
                            
                                currentTabs[tabLabel] = ArrayUtils.toArray(currentTabs[tabLabel]);

                                currentTabs[tabLabel].push(campo);
                            });
                            
                            var element = AngularUtil.getControllerFromElement(parent);

                            Object.keys(currentTabs).forEach(label => {
                                buildForm(element, currentTabs[label], label, options)
                            });

                            if (callBack != null) {
                                callBack();
                            }
                        }
                    });
            }

            function buildForm(element, currentTabs, label, options = {}, compileTabNavigator) {
                var style = options.width ? `width: ${options.width || '100%'};" ` : '';
                var style = style + (options.height ? `height: ${options.height || '100%'};" ` : '');  
                
                var form = `<sk-form sk-dataset="${options.datasetName || 'dataset'}" sk-only-custom sk-columns="${options.columns || 4}" sk-inline="${options.inline == true}" style="${style}" flex> `;

                currentTabs.forEach((currentTab) => {
                    form += ` <sk-form-custom-item sk-field-name="${currentTab.nome || currentTab.name}" ></sk-form-custom-item> `;
                });

                form += ' </sk-form>';

                if (angular.isFunction(compileTabNavigator)) {
                    compileTabNavigator(form);
                } else {
                    element.addTab(form, label);
                }

            }

            function buildParams(masterDataset) {
                return {
                    entity:{
                        name: masterDataset.getEntityName()
                    }
                };    
            }
    }]);

/**
 * @ngdoc service
 * @name snk.core.util.service:UserAgentUtils
 *
 * @description
 * Serviço utilizado para identificação do tipo dispositivo ou navegador em que o sistema está sendo acessado. Ele
 * também disponibiliza funções para identificar se o dispositivo está em landscape ou modo portrait.
 */
angular
    .module('snk.core.util')
    .service('UserAgentUtils', ['$window', '$document', 'NumberUtils', 'StringUtils', function ($window, $document, NumberUtils, StringUtils) {
        var REGEX_OPERA = new RegExp('Opera.([0-9\\.]*)');
        var REGEX_IE = new RegExp('MSIE.([0-9\\.]*)');
        var REGEX_IE_TRIDENT = new RegExp('Trident.([0-9\\.]*)');//IE Edge
        var REGEX_EDGE_TRIDENT = new RegExp('Edge.([0-9\\.]*)');//Edge
        var REGEX_SAFARI = new RegExp('safari\\/([\\d\\.]*)');
        var REGEX_APPLE_WEBKIT = new RegExp('AppleWebKit\\/([\\d\\.]*)');//Cai aqui
        var REGEX_CHROME = new RegExp('Chrome\\/([0-9\\.]*)');//Cai aqui
        var REGEX_FIREFOX = new RegExp('Fire[Ff]ox.([0-9\\.]*)');
        var REGEX_GECKO = new RegExp('gecko');
        var REGEX_GECKO_VERSION = new RegExp('rv:\\s*([0-9\\.]+)');
        var REGEX_ELECTRON = new RegExp('Electron\\/([0-9\\.]*)');
        var REGEX_SIMPLE_VERSION_APPLE_WEBKIT = new RegExp('Version\\/([\\d]*)');

        var PORTRAIT_MODE = 'portrait';
        var LANDSCAPE_MODE = 'landscape';
        var ANDROID = 'android';
        var IPHONE = 'iphone';
        var IPAD = 'ipad';
        var IPOD = 'ipod';
        var MOBILE = 'mobile';
        var TABLET = 'tablet';
        var DESKTOP = 'desktop';
        var LINUX = 'linux';

        var SNK_BROWSER_VERSION = '1.3';
        var SNK_BROWSER_BUILD = '363';

        var userAgent = $window.navigator.userAgent;
        var device = getDeviceInfo();
        var browser = getBrowserInfo();
        var self = this;

        self.isMobile = isMobile;
        self.isAndroid = isAndroid;
        self.isIOS = isIOS;
        self.isTV = isTV;
        self.isIE = isIE;
        self.isMac = isMac;
        self.isFirefox = isFirefox;
        self.isChrome = isChrome;
        self.isElectron = isElectron;
        self.isSafari = isSafari;
        self.isMozilla = isMozilla;
        self.getBrowserInfo = getBrowserInfo;
        self.putBrowserInfoOnBody = putBrowserInfoOnBody;
        self.isEdge = isEdge;
        self.isLinux = isLinux;
        self.getSnkBrowserAppVersion = getSnkBrowserAppVersion;
        self.compareAppVersionSnkBrowser = compareAppVersionSnkBrowser;


        function putBrowserInfoOnBody(){
            var classes = [];

            if (isIE()) {
                classes.push('browser-ie');
            } else if (isChrome()){
                classes.push('browser-chrome');
            } else if (isSafari())  {
                classes.push('browser-safari');
                if(browser.simpleVersion < 11){
                    classes.push('safari-flex-wrapper');
                }
            } else if (isIOS())  {
                classes.push('ios');
            }else if (isElectron())  {
                classes.push('electron');
            }

            if (isMobile()){
                classes.push('mobile');
            } else {
                classes.push('desktop');
            }

            classes.forEach(function(cssClass){
                angular.element($document[0].body).addClass(cssClass);
            });
        }
        
        /**
         * @ngdoc
         * @name UserAgentUtils#isLinux
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o dispositivo está rodando em Linux.
         * @example
         * ```js
         *      UserAgentUtils.isLinux();
         * ```
         */
        function isLinux() {
        	return userAgent.toLowerCase().indexOf(LINUX) > -1;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isMobile
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o dispositivo é mobile.
         * @example
         * ```js
         *      UserAgentUtils.isMobile();
         * ```
         */
        function isMobile() {
            return MOBILE.indexOf(device) > -1 || TABLET.indexOf(device) > -1;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isAndroid
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o dispositivo é Android.
         * @example
         * ```js
         *      UserAgentUtils.isAndroid();
         * ```
         */
        function isAndroid() {
            return userAgent.toLowerCase().indexOf(ANDROID) > -1;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isIOS
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o dispositivo é um IOS.
         * @example
         * ```js
         *      UserAgentUtils.isIOS();
         * ```
         */
        function isIOS() {
            var ua = userAgent.toLowerCase();

            if (ua.indexOf(IPHONE) > -1 || ua.indexOf(IPOD) > -1 || ua.indexOf(IPAD) > -1) {
                return true;
            }

            return false;
        }
        

        /**
         * @ngdoc
         * @name UserAgentUtils#isMac
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o dispositivo utilizado é um Mac.
         * @example
         * ```js
         *      UserAgentUtils.isMac();
         * ```
         */
        function isMac() {
            return userAgent && userAgent.indexOf('Mac OS X') > -1;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isIE
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o navegador utilizado é o Internet Explorer.
         * @example
         * ```js
         *      UserAgentUtils.isIE();
         * ```
         */
        function isIE() {
            return browser.ie;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isEdge
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o navegador utilizado é o Edge.
         * @example
         * ```js
         *      UserAgentUtils.isEdge();
         * ```
         */
        function isEdge() {
            return browser.edge;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isFirefox
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o navegador é o Firefox.
         * @example
         * ```js
         *      UserAgentUtils.isFirefox();
         * ```
         */
        function isFirefox() {
            return browser.firefox;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isChrome
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o navegador é o Chrome.
         * @example
         * ```js
         *      UserAgentUtils.isChrome();
         * ```
         */
        function isChrome() {
            return browser.chrome;
        }


           /**
         * @ngdoc
         * @name UserAgentUtils#isElectron
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o electron.
         * @example
         * ```js
         *      UserAgentUtils.isElectron();
         * ```
         */
        function isElectron() {
            return browser.electron;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isSafari
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o navegador é o Safari.
         * @example
         * ```js
         *      UserAgentUtils.isSafari();
         * ```
         */
        function isSafari() {
            return browser.safari;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isMozilla
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o navegador é um Mozilla.
         * @example
         * ```js
         *      UserAgentUtils.isMozilla();
         * ```
         */
        function isMozilla() {
            return browser.mozilla;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isTV
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {boolean} Retorna se o dispositivo é uma TV.
         * @example
         * ```js
         *      UserAgentUtils.isTV();
         * ```
         */
        function isTV() {
            var isSecurityDomain = false;
            var localHostname = location.hostname;

            try {
                var parentHostname = top.window.location.hostname;

                if (parentHostname == localHostname) {
                    isSecurityDomain = true;
                }
            } catch (unsecurity) {
            }

            if (isSecurityDomain) {
                var RootWindow = top.window;

                if (RootWindow.ISTV) {
                    return true;
                }
            }

            return false;
        }

        function getDeviceInfo() {
            var args = location.search;
            var start = args.indexOf("ua");

            if (start >= 0) {
                var value = args.substring(start);
                var begin = value.indexOf("=") + 1;
                var end = value.indexOf("&");

                if (end == -1) {
                    end = value.length;
                }

                return value.substring(begin, end);
            }

            var ua = userAgent.toLowerCase();

            if (ua.indexOf(IPHONE) > -1 || ua.indexOf(IPOD) > -1) {
                return MOBILE;
            } else if (ua.indexOf(IPAD) > -1) {
                return TABLET;
            } else if (ua.indexOf(ANDROID) > -1 || ua.indexOf(MOBILE) > -1) {
                var dpi = 160;
                var width = $window.screen.width / dpi;
                var height = $window.screen.height / dpi;
                var size = Math.sqrt(width * width + height * height);

                return (size < 6) ? MOBILE : TABLET;
            }

            return DESKTOP;
        }

        function getViewMode() {
            var clientWidth = $window.clientWidth;
            var clientHeight = $window.clientHeight;

            if (clientWidth > clientHeight) {
                return LANDSCAPE_MODE;
            }

            return PORTRAIT_MODE;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#isTV
         * @methodOf snk.core.util.service:UserAgentUtils
         * @return {object} Retorna um objeto com propriedades do navegador(nome, versão e navegador).
         * @example
         * ```js
         *      UserAgentUtils.getBrowserInfo();
         * ```
         */
        function getBrowserInfo() {
            var browser = {
                name: '',
                version: '',
                opera: false,
                ie: false,
                mozilla: false,
                firefox: false,
                safari: false,
                chrome: false,
                edge: false,
                electron: false
            };
            var result;

            if(REGEX_ELECTRON.test(userAgent)) {
                result = REGEX_ELECTRON.exec(userAgent);

                browser.electron = true;
                browser.name = "Electron";
                browser.version = result[1];
            } else if (REGEX_IE.test(userAgent)) {
                result = REGEX_IE.exec(userAgent);

                browser.ie = true;
                browser.name = "Internet Explorer";
                browser.version = result[1];
            } else if (REGEX_IE_TRIDENT.test(userAgent)) {
                result = REGEX_IE_TRIDENT.exec(userAgent);

                browser.ie = true;
                browser.name = "Internet Explorer";
                browser.version = result[1];
            } else if (REGEX_EDGE_TRIDENT.test(userAgent)) {
                result = REGEX_EDGE_TRIDENT.exec(userAgent);

                browser.edge = true;
                browser.name = "Edge";
                browser.version = result[1];
            } else if (REGEX_CHROME.test(userAgent)) {
                result = REGEX_CHROME.exec(userAgent);

                browser.chrome = true;
                browser.name = "Chrome";
                browser.version = result[1];
            } else if (REGEX_SAFARI.test(userAgent)) {
                result = REGEX_SAFARI.exec(userAgent);

                browser.safari = true;
                browser.name = "Safari";
                browser.version = result[1];
            } else if (REGEX_APPLE_WEBKIT.test(userAgent)) {
                result = REGEX_APPLE_WEBKIT.exec(userAgent);

                browser.safari = true;
                browser.name = "Apple Web Kit";
                browser.version = result[1];
                try{
                    if(REGEX_SIMPLE_VERSION_APPLE_WEBKIT.test(userAgent)){
                        var silpleVersion = REGEX_SIMPLE_VERSION_APPLE_WEBKIT.exec(userAgent)[1];
                        if(silpleVersion){
                            browser.simpleVersion = NumberUtils.stringToNumber(silpleVersion)
                        }
                    }
                }catch(e){
                    //ignored
                }
            } else if (REGEX_FIREFOX.test(userAgent)) {
                result = REGEX_FIREFOX.exec(userAgent);

                browser.firefox = true;
                browser.mozilla = true;
                browser.name = "Firefox";
                browser.version = result[1];
            } else if (REGEX_GECKO.test(userAgent)) {
                result = REGEX_GECKO.exec(userAgent);

                browser.mozilla = true;
                browser.version = result[1];
            }

            return browser;
        }

        /**
         * @ngdoc
         * @name UserAgentUtils#getSnkBrowserAppVersion
         * @methodOf snk.core.util.service:UserAgentUtils 
         * @returns {string} Retorna um string com a versão do aplicativo navegador Sankhya
         * @example
         * ```js
         *      UserAgentUtils.getSnkBrowserAppVersion();
         * ```
         */
        function getSnkBrowserAppVersion() {
            if (isElectron()) {
                return window.parent.ipc.sendSync('getAppVersion');
            }
        }

        /**
         * @ngdoc Compara a versão atual do Navegador Sankhya com a última versão anterior a implementação do recurso "showOpenDialog".
         * Criação do método foi necessária para verificar a disponibilidade do recurso no Navegador Sankhya.
         * @name UserAgentUtils#compareAppVersionSnkBrowser
         * @methodOf snk.core.util.service:UserAgentUtils 
         * @returns {boolean} Retorna true se a versão atual é maior ou false caso contrário
         * @example
         * ```js
         *      UserAgentUtils.compareAppVersionSnkBrowser();
         * ```
         */
        function compareAppVersionSnkBrowser() {
            let appVersion = getSnkBrowserAppVersion();

            if (StringUtils.isNotEmpty(appVersion)) {
                appVersion = appVersion.split('b');
                return appVersion[0] > SNK_BROWSER_VERSION || (appVersion[0] == SNK_BROWSER_VERSION && appVersion[1] > SNK_BROWSER_BUILD);
            }

            return false;
        }
    }]);
angular.module('snk.core.util')
  .directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
  .directive('mdVirtualRepeat', VirtualRepeatDirective);

/**
 * @ngdoc directive
 * @name snk.core.util.directive:md-virtual-repeat-container
 * @restrict E
 * @description
 * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
 *
 * Virtual repeat is a limited substitute for ng-repeat that renders only
 * enough dom nodes to fill the container and recycling them as the user scrolls.
 *
 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
 *     (defaults to orientation and scrolling vertically).
 * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
 *     the number of items when that number is less than its original size.
 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
 *     will shrink to (default: 0).
 */
function VirtualRepeatContainerDirective() {
  return {
    controller: VirtualRepeatContainerController,
    template: virtualRepeatContainerTemplate,
    compile: function virtualRepeatContainerCompile($element, $attrs) {
      $element
        .addClass('md-virtual-repeat-container')
        .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
          ? 'md-orient-horizontal'
          : 'md-orient-vertical');
    }
  };
}


function virtualRepeatContainerTemplate($element) {
  return '<div class="md-virtual-repeat-scroller">' +
    '<div class="md-virtual-repeat-sizer"></div>' +
    '<div class="md-virtual-repeat-offsetter">' +
    $element[0].innerHTML +
    '</div></div>';
}

/**
 * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
 * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
 * *compute* this value, but Firefox always reports an element to have a size of zero if it
 * goes over the max, meaning that we'd have to binary search for the value.
 * @const {number}
 */
var MAX_ELEMENT_SIZE = 1533917;

/**
 * Number of additional elements to render above and below the visible area inside
 * of the virtual repeat container. A higher number results in less flicker when scrolling
 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
 * @const {number}
 */
var NUM_EXTRA = 3;

/** @ngInject */
function VirtualRepeatContainerController($$rAF, $scope, $element, $attrs) {
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;

  /** @type {number} The width or height of the container */
  this.size = 0;
  /** @type {number} The scroll width or height of the scroller */
  this.scrollSize = 0;
  /** @type {number} The scrollLeft or scrollTop of the scroller */
  this.scrollOffset = 0;
  /** @type {boolean} Whether the scroller is oriented horizontally */
  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
  /** @type {!VirtualRepeatController} The repeater inside of this container */
  this.repeater = null;
  /** @type {boolean} Whether auto-shrink is enabled */
  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
  /** @type {number} Minimum number of items to auto-shrink to */
  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
  /** @type {?number} Original container size when shrank */
  this.originalSize = null;
  /** @type {number} Amount to offset the total scroll size by. */
  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;


  this.scroller = $element[0].getElementsByClassName('md-virtual-repeat-scroller')[0];
  this.sizer = this.scroller.getElementsByClassName('md-virtual-repeat-sizer')[0];
  this.offsetter = this.scroller.getElementsByClassName('md-virtual-repeat-offsetter')[0];

  $$rAF(angular.bind(this, this.updateSize));

  // TODO: Come up with a more robust (But hopefully also quick!) way of
  // detecting that we're not visible.
  if ($attrs.ngHide) {
    $scope.$watch($attrs.ngHide, angular.bind(this, function(hidden) {
      if (!hidden) {
        $$rAF(angular.bind(this, this.updateSize));
      }
    }));
  }
}


/** Called by the md-virtual-repeat inside of the container at startup. */
VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
  this.repeater = repeaterCtrl;

  angular.element(this.scroller)
    .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
};


/** @return {boolean} Whether the container is configured for horizontal scrolling. */
VirtualRepeatContainerController.prototype.isHorizontal = function() {
  return this.horizontal;
};


/** @return {number} The size (width or height) of the container. */
VirtualRepeatContainerController.prototype.getSize = function() {
  return this.size;
};


/**
 * Resizes the container.
 * @private
 * @param {number} The new size to set.
 */
VirtualRepeatContainerController.prototype.setSize_ = function(size) {
  this.size = size;
  this.$element[0].style[this.isHorizontal() ? 'width' : 'height'] = size + 'px';
};


/** Instructs the container to re-measure its size. */
VirtualRepeatContainerController.prototype.updateSize = function() {
  if (this.originalSize) return;

  this.size = this.isHorizontal()
    ? this.$element[0].clientWidth
    : this.$element[0].clientHeight;
  this.repeater && this.repeater.containerUpdated();
};


/** @return {number} The container's scrollHeight or scrollWidth. */
VirtualRepeatContainerController.prototype.getScrollSize = function() {
  return this.scrollSize;
};


/**
 * Sets the scroller element to the specified size.
 * @private
 * @param {number} size The new size.
 */
VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
  var dimension =  this.isHorizontal() ? 'width' : 'height';
  var crossDimension = this.isHorizontal() ? 'height' : 'width';

  // If the size falls within the browser's maximum explicit size for a single element, we can
  // set the size and be done. Otherwise, we have to create children that add up the the desired
  // size.
  if (size < MAX_ELEMENT_SIZE) {
    this.sizer.style[dimension] = size + 'px';
  } else {
    // Clear any existing dimensions.
    this.sizer.innerHTML = '';
    this.sizer.style[dimension] = 'auto';
    this.sizer.style[crossDimension] = 'auto';

    // Divide the total size we have to render into N max-size pieces.
    var numChildren = Math.floor(size / MAX_ELEMENT_SIZE);

    // Element template to clone for each max-size piece.
    var sizerChild = document.createElement('div');
    sizerChild.style[dimension] = MAX_ELEMENT_SIZE + 'px';
    sizerChild.style[crossDimension] = '1px';

    for (var i = 0; i < numChildren; i++) {
      this.sizer.appendChild(sizerChild.cloneNode(false));
    }

    // Re-use the element template for the remainder.
    sizerChild.style[dimension] = (size - (numChildren * MAX_ELEMENT_SIZE)) + 'px';
    this.sizer.appendChild(sizerChild);
  }
};


/**
 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
 * @private
 * @param {number} size The new size.
 */
VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
  if (this.autoShrink && shrinkSize !== this.size) {
    if (shrinkSize < (this.originalSize || this.size)) {
      if (!this.originalSize) {
        this.originalSize = this.size;
      }

      this.setSize_(shrinkSize);
    } else if (this.originalSize) {
      this.setSize_(this.originalSize);
      this.originalSize = null;
    }
  }
};


/**
 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
 * its item count and item size.
 * @param {number} itemsSize The total size of the items.
 */
VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
  var size = itemsSize + this.offsetSize;
  if (this.scrollSize === size) return;

  this.sizeScroller_(size);
  this.autoShrink_(size);
  this.scrollSize = size;
};


/** @return {number} The container's current scroll offset. */
VirtualRepeatContainerController.prototype.getScrollOffset = function() {
  return this.scrollOffset;
};

/**
 * Scrolls to a given scrollTop position.
 * @param {number} position
 */
VirtualRepeatContainerController.prototype.scrollTo = function(position) {
  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
  this.handleScroll_();
};

VirtualRepeatContainerController.prototype.resetScroll = function() {
  this.scrollTo(0);
};


VirtualRepeatContainerController.prototype.handleScroll_ = function() {
  var offset = this.isHorizontal() ? this.scroller.scrollLeft : this.scroller.scrollTop;
  if (offset === this.scrollOffset) return;

  var itemSize = this.repeater.getItemSize();
  if (!itemSize) return;

  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);

  var transform = this.isHorizontal() ? 'translateX(' : 'translateY(';
  transform +=  (numItems * itemSize) + 'px)';

  this.scrollOffset = offset;
  this.offsetter.style.webkitTransform = transform;
  this.offsetter.style.transform = transform;

  this.repeater.containerUpdated();
};


/**
 * @ngdoc directive
 * @name snk.core.util.directive:md-virtual-repeat
 * @restrict A
 * @priority 1000
 * @description
 * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
 *
 * Virtual repeat is a limited substitute for ng-repeat that renders only
 * enough dom nodes to fill the container and recycling them as the user scrolls.
 * Arrays, but not objects are supported for iteration.
 * Track by, as alias, and (key, value) syntax are not supported.
 *
 * @param {number=} md-item-size The height or width of the repeated elements (which
 *     must be identical for each element). Optional. Will attempt to read the size
 *     from the dom if missing, but still assumes that all repeated nodes have same
 *     height or width.
 * @param {string=} md-extra-name Evaluates to an additional name to which
 *     the current iterated item can be assigned on the repeated scope. (Needed
 *     for use in md-autocomplete).
 * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument
 *     as an object that can fetch rows rather than an array.
 *     NOTE: This object must implement the following interface with two (2) methods:
 *     getItemAtIndex: function(index) -> item at that index or null if it is not yet
 *         loaded (It should start downloading the item in that case).
 *     getLength: function() -> number The data length to which the repeater container
 *         should be sized. Ideally, when the count is known, this method should return it.
 *         Otherwise, return a higher number than the currently loaded items to produce an
 *         infinite-scroll behavior.
 
 *
 * @example
 <example module="appVirtualRepeat">
	 <file name="appVirtualRepeat.html">
		<div ng-controller="TesteController" layout flex style="height: 55px;">
        	<md-virtual-repeat-container flex style="height: 100%;">
				<div layout flex md-virtual-repeat="i in items">Item {{i}}!</div>
			</md-virtual-repeat-container>
       </div>
	 </file>
	 <file name="appVirtualRepeat.js">
		angular
	        .module('appVirtualRepeat', ['snk'])
	        .controller('TesteController', TesteController);
	
	    function TesteController($scope){
	        $scope.items = [];
	
			for (var i = 0; i < 100; i++) {
				$scope.items.push(i);
			}
	    }
     </file>
 </example>
 *
 */
function VirtualRepeatDirective($parse) {
  return {
    controller: VirtualRepeatController,
    priority: 1000,
    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
    restrict: 'A',
    terminal: true,
    transclude: 'element',
    compile: function VirtualRepeatCompile($element, $attrs) {
      var expression = $attrs.mdVirtualRepeat;
      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
      var repeatName = match[1];
      var repeatListExpression = $parse(match[2]);
      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);

      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
      };
    }
  };
}


/** @ngInject */
function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $$rAF) {
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;
  this.$browser = $browser;
  this.$document = $document;
  this.$$rAF = $$rAF;

  /** @type {boolean} Whether we are in on-demand mode. */
  this.onDemand = $attrs.hasOwnProperty('mdOnDemand');
  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
  this.browserCheckUrlChange = $browser.$$checkUrlChange;
  /** @type {number} Most recent starting repeat index (based on scroll offset) */
  this.newStartIndex = 0;
  /** @type {number} Most recent ending repeat index (based on scroll offset) */
  this.newEndIndex = 0;
  /** @type {number} Most recent end visible index (based on scroll offset) */
  this.newVisibleEnd = 0;
  /** @type {number} Previous starting repeat index (based on scroll offset) */
  this.startIndex = 0;
  /** @type {number} Previous ending repeat index (based on scroll offset) */
  this.endIndex = 0;
  // TODO: measure width/height of first element from dom if not provided.
  // getComputedStyle?
  /** @type {?number} Height/width of repeated elements. */
  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;

  /** @type {boolean} Whether this is the first time that items are rendered. */
  this.isFirstRender = true;

  /** @type {number} Most recently seen length of items. */
  this.itemsLength = 0;

  /**
   * @type {!Function} Unwatch callback for item size (when md-items-size is
   *     not specified), or angular.noop otherwise.
   */
  this.unwatchItemSize_ = angular.noop;

  /**
   * Presently rendered blocks by repeat index.
   * @type {Object<number, !VirtualRepeatController.Block}
   */
  this.blocks = {};
  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
  this.pooledBlocks = [];
}


/**
 * An object representing a repeated item.
 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
 */
VirtualRepeatController.Block;


/**
 * Called at startup by the md-virtual-repeat postLink function.
 * @param {!VirtualRepeatContainerController} container The container's controller.
 * @param {!Function} transclude The repeated element's bound transclude function.
 * @param {string} repeatName The left hand side of the repeat expression, indicating
 *     the name for each item in the array.
 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
 *     of the repeat expression. Points to the array to repeat over.
 * @param {string|undefined} extraName The optional extra repeatName.
 */
VirtualRepeatController.prototype.link_ =
  function(container, transclude, repeatName, repeatListExpression, extraName) {
    this.container = container;
    this.transclude = transclude;
    this.repeatName = repeatName;
    this.rawRepeatListExpression = repeatListExpression;
    this.extraName = extraName;
    this.sized = false;

    this.repeatListExpression = angular.bind(this, this.repeatListExpression_);

    this.container.register(this);
  };


/** @private Attempts to set itemSize by measuring a repeated element in the dom */
VirtualRepeatController.prototype.readItemSize_ = function() {
  if (this.itemSize) {
    // itemSize was successfully read in a different asynchronous call.
    return;
  }

  this.items = this.repeatListExpression(this.$scope);
  this.parentNode = this.$element[0].parentNode;
  var block = this.getBlock_(0);
  if (!block.element[0].parentNode) {
    this.parentNode.appendChild(block.element[0]);
  }

  this.itemSize = block.element[0][
      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;

  this.blocks[0] = block;
  this.poolBlock_(0);

  if (this.itemSize) {
    this.containerUpdated();
  }
};


/**
 * Returns the user-specified repeat list, transforming it into an array-like
 * object in the case of infinite scroll/dynamic load mode.
 * @param {!angular.Scope} The scope.
 * @return {!Array|!Object} An array or array-like object for iteration.
 */
VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
  var repeatList = this.rawRepeatListExpression(scope);

  if (this.onDemand && repeatList) {
    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
    return virtualList;
  } else {
    return repeatList;
  }
};


/**
 * Called by the container. Informs us that the containers scroll or size has
 * changed.
 */
VirtualRepeatController.prototype.containerUpdated = function() {
  // If itemSize is unknown, attempt to measure it.
  if (!this.itemSize) {
    this.unwatchItemSize_ = this.$scope.$watchCollection(
      this.repeatListExpression,
      angular.bind(this, function(items) {
        if (items && items.length) {
          this.$$rAF(angular.bind(this, this.readItemSize_));
        }
      }));
    this.$scope.$digest();

    return;
  } else if (!this.sized) {
    this.items = this.repeatListExpression(this.$scope);
  }

  if (!this.sized) {
    this.unwatchItemSize_();
    this.sized = true;
    this.$scope.$watchCollection(this.repeatListExpression,
      angular.bind(this, this.virtualRepeatUpdate_));
  }

  this.updateIndexes_();

  if (this.newStartIndex !== this.startIndex ||
    this.newEndIndex !== this.endIndex ||
    this.container.getScrollOffset() > this.container.getScrollSize()) {
    if (this.items instanceof VirtualRepeatModelArrayLike) {
      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
    }
    this.virtualRepeatUpdate_(this.items, this.items);
  }
};


/**
 * Called by the container. Returns the size of a single repeated item.
 * @return {?number} Size of a repeated item.
 */
VirtualRepeatController.prototype.getItemSize = function() {
  return this.itemSize;
};


/**
 * Updates the order and visible offset of repeated blocks in response to scrolling
 * or items updates.
 * @private
 */
VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
  var itemsLength = items ? items.length : 0;
  var lengthChanged = false;

  // If the number of items shrank, scroll up to the top.
  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
    this.items = items;

    var previousScrollOffset = this.container.getScrollOffset();

    this.container.resetScroll();
    this.container.scrollTo(previousScrollOffset);

    return;
  }

  if (itemsLength !== this.itemsLength) {
    lengthChanged = true;
    this.itemsLength = itemsLength;
  }

  this.items = items;
  if (items !== oldItems || lengthChanged) {
    this.updateIndexes_();
  }

  this.parentNode = this.$element[0].parentNode;

  if (lengthChanged) {
    this.container.setScrollSize(itemsLength * this.itemSize);
  }

  if (this.isFirstRender) {
    this.isFirstRender = false;
    var startIndex = this.$attrs.mdStartIndex ? this.$scope.$eval(this.$attrs.mdStartIndex) : 0;
    this.container.scrollTo(startIndex * this.itemSize);
  }

  // Detach and pool any blocks that are no longer in the viewport.
  Object.keys(this.blocks).forEach(function(blockIndex) {
    var index = parseInt(blockIndex, 10);
    if (index < this.newStartIndex || index >= this.newEndIndex) {
      this.poolBlock_(index);
    }
  }, this);

  // Add needed blocks.
  // For performance reasons, temporarily block browser url checks as we digest
  // the restored block scopes ($$checkUrlChange reads window.location to
  // check for changes and trigger route change, etc, which we don't need when
  // trying to scroll at 60fps).
  this.$browser.$$checkUrlChange = angular.noop;

  var i, block,
    newStartBlocks = [],
    newEndBlocks = [];

  // Collect blocks at the top.
  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
    block = this.getBlock_(i);

    if (angular.isDefined(block)) {
      this.updateBlock_(block, i);
      newStartBlocks.push(block);
    }
  }

  // Update blocks that are already rendered.
  for (; this.blocks[i] != null; i++) {
    this.updateBlock_(this.blocks[i], i);
  }
  var maxIndex = i - 1;

  // Collect blocks at the end.
  for (; i < this.newEndIndex; i++) {
    block = this.getBlock_(i);

    if (angular.isDefined(block)) {
      this.updateBlock_(block, i);
      newEndBlocks.push(block);
    }
  }

  // Attach collected blocks to the document.
  if (newStartBlocks.length) {
    this.parentNode.insertBefore(
      this.domFragmentFromBlocks_(newStartBlocks),
      this.$element[0].nextSibling);
  }
  if (newEndBlocks.length) {
    this.parentNode.insertBefore(
      this.domFragmentFromBlocks_(newEndBlocks),
      this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
  }

  // Restore $$checkUrlChange.
  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;

  this.startIndex = this.newStartIndex;
  this.endIndex = this.newEndIndex;
};


/**
 * @param {number} index Where the block is to be in the repeated list.
 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
 * @private
 */
VirtualRepeatController.prototype.getBlock_ = function(index) {
  if (this.pooledBlocks.length) {
    return this.pooledBlocks.pop();
  }

  var block;
  this.transclude(angular.bind(this, function(clone, scope) {
    block = {
      element: clone,
      new: true,
      scope: scope
    };

    this.updateScope_(scope, index);
    this.parentNode.appendChild(clone[0]);
  }));

  return block;
};


/**
 * Updates and if not in a digest cycle, digests the specified block's scope to the data
 * at the specified index.
 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
 * @param {number} index The index to set.
 * @private
 */
VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
  this.blocks[index] = block;

  if (!block.new &&
    (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
    return;
  }
  block.new = false;

  // Update and digest the block's scope.
  this.updateScope_(block.scope, index);

  // Perform digest before reattaching the block.
  // Any resulting synchronous dom mutations should be much faster as a result.
  // This might break some directives, but I'm going to try it for now.
  if (!this.$scope.$root.$$phase) {
    block.scope.$digest();
  }
};


/**
 * Updates scope to the data at the specified index.
 * @param {!angular.Scope} scope The scope which should be updated.
 * @param {number} index The index to set.
 * @private
 */
VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
  scope.$index = index;
  scope[this.repeatName] = this.items && this.items[index];
  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
};


/**
 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
 * @param {number} index The index at which the block to pool is stored.
 * @private
 */
VirtualRepeatController.prototype.poolBlock_ = function(index) {
  try {
    this.parentNode.removeChild(this.blocks[index].element[0]);
    this.pooledBlocks.push(this.blocks[index]);
    delete this.blocks[index];
  } catch(err) {
  }
};


/**
 * Produces a dom fragment containing the elements from the list of blocks.
 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
 *     should be added to the document fragment.
 * @return {DocumentFragment}
 * @private
 */
VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
  var fragment = this.$document[0].createDocumentFragment();
  blocks.forEach(function(block) {
    fragment.appendChild(block.element[0]);
  });
  return fragment;
};


/**
 * Updates start and end indexes based on length of repeated items and container size.
 * @private
 */
VirtualRepeatController.prototype.updateIndexes_ = function() {
  var itemsLength = this.items ? this.items.length : 0;
  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);

  this.newStartIndex = Math.max(0, Math.min(
    itemsLength - containerLength,
    Math.floor(this.container.getScrollOffset() / this.itemSize)));
  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
};

/**
 * This VirtualRepeatModelArrayLike class enforces the interface requirements
 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
 * interface must implement the following interface with two (2) methods:
 *
 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
 *     loaded (It should start downloading the item in that case).
 *
 * getLength: function() -> number The data legnth to which the repeater container
 *     should be sized. Ideally, when the count is known, this method should return it.
 *     Otherwise, return a higher number than the currently loaded items to produce an
 *     infinite-scroll behavior.
 *
 * @usage
 * <hljs lang="html">
 *  <md-virtual-repeat-container md-orient-horizontal>
 *    <div md-virtual-repeat="i in items" md-on-demand>
 *      Hello {{i}}!
 *    </div>
 *  </md-virtual-repeat-container>
 * </hljs>
 *
 */
function VirtualRepeatModelArrayLike(model) {
  if (!angular.isFunction(model.getItemAtIndex) ||
    !angular.isFunction(model.getLength)) {
    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
      'functions getItemAtIndex() and getLength() ');
  }

  this.model = model;
}


VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
  if (angular.isFunction(this.model.getItems)) {
    this.model.items = this.model.getItems();
  }

  for (var i = start; i < end; i++) {
    if (!this.hasOwnProperty(i)) {
      this[i] = this.model.getItemAtIndex(i);
    }
  }
  this.length = this.model.getLength();
};


function abstractMethod() {
  throw Error('Non-overridden abstract method called.');
}
angular
    .module('snk.core.util')
    .factory('EquipamentoFiscalHandler', ['SnkLoadingBar', 'ComunicacaoEquipamentoFiscalService','$timeout', 'ServiceProxy', 'StringUtils',
     function (SnkLoadingBar, ComunicacaoEquipamentoFiscalService,$timeout, ServiceProxy, StringUtils) {
        let equipamentoFiscalHandler = {};

        equipamentoFiscalHandler.createCORSRequest = createCORSRequest;
        equipamentoFiscalHandler.getCookie = getCookie;
        equipamentoFiscalHandler.getMgeSessionId = getMgeSessionId;
        equipamentoFiscalHandler.fetchWebConnection = fetchWebConnection;

        function createCORSRequest(method, url) {
            let xhr = new XMLHttpRequest();

            if ("withCredentials" in xhr) {
                xhr.open(method, url, false);
            } else if (typeof XDomainRequest != "undefined") {
                xhr = new XDomainRequest();
                xhr.open(method, url, false);
            } else {
                xhr = null;
                throw new Error("CORS not supported");
            }

            return xhr;
        }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for (const element of ca) {
                let c = element;
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        }

        function getMgeSessionId() {
            let name = "JSESSIONID" + "=";
            let ca = parent.document.cookie.split(';');
            for (const element of ca) {
                let c = element;
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        }
        async function getSharedIp() {
            try {
                const result = await ServiceProxy.callService('mgecom@CFeSP.verificaIpCompartilhado', {});
                return result.responseBody?.ipCompartilhado;
            } catch (error) {
                return undefined;   
            }
        }

        async function fetchWebConnection(method, jsonParams) {
            SnkLoadingBar.start();

            let params = typeof jsonParams === 'string' ? JSON.parse(jsonParams) : jsonParams;
    
            let jsessionid = equipamentoFiscalHandler.getCookie("JSESSIONID");
            let mgeSessionId = equipamentoFiscalHandler.getMgeSessionId();
    
            params.jsessionid = jsessionid;
            params.mgeSessionId = mgeSessionId;
    
            if (params.compartilha === 'S' || !params.compartilha) {
                params.ipCompartilhamento = (params.ipcompartilhadocadastro) ?
                StringUtils.trim(params.ipcompartilhadocadastro) :
                    await getSharedIp();
            }

            let urlParams = Base64.doEncode(JSON.stringify(params), false);

            ComunicacaoEquipamentoFiscalService.connect().then(function () {
                ComunicacaoEquipamentoFiscalService.adicionarParams(urlParams);
                ComunicacaoEquipamentoFiscalService.send();
            }).catch(function () {
                SnkLoadingBar.complete();
                return {
                    errorMessage: 'Falha na  comunicação, revise o cadastro do equipamento fiscal.'
                }
            });
            
            let satResponseJson = {};
            
            ComunicacaoEquipamentoFiscalService.onMessage(function (response) {
                SnkLoadingBar.complete();

                satResponseJson = response;
                if (resolveSatResponse) {
                    resolveSatResponse(satResponseJson);
                }
            });

            let satResponsePromise = new Promise((resolve, reject) => {
                if (Object.keys(satResponseJson).length > 0) {
                    resolve(satResponseJson);
                }
            
                resolveSatResponse = resolve;
            });
            
            return satResponsePromise;
 
        }

        return equipamentoFiscalHandler;
    }]);
angular
  .module('snk.core.util')
  .constant('WebConnectionConstants', {
    'methods': {
      'PRINTERS_LIST': 'pList',
      'LOCAL_PRINTING': 'localPrinting',
      'IMPRESSAO_DIRETA': 'impressaoDireta',
      'IMPRESSAO_DIRETA_TEXTO': 'impressaoDiretaTexto',
      'INFO': 'info',
      'CUBE_VIEWER': 'cubeViewer',
      'CUBE_VIEWER_GRID': 'cubeViewerGrid',
      'CUBE_FLUXO_CAIXA_MATRICIAL_SINTETICO': 'cubeFluxoCaixaMatricialSintetico',
      'CUBE_UF_CIDADE_BAIRRO': 'cubeUFCidadeBairro',
      'PDF_VIEWER': 'pdfViewer',
      'IMPORT_IMAGE': 'importImage',
      'EQUIP_FISCAL': 'sendEquipFiscalData'
    }
  });
angular
    .module('snk.core.util')
    .provider('WebConnectionCaller',function () {
        var _MGEParameters;
        var _defaultPort;
        let _equipamentoFiscalHandler

        this.$get = ['MGEParameters', 'EquipamentoFiscalHandler', function (MGEParameters, EquipamentoFiscalHandler) {
            _MGEParameters = MGEParameters;
            _defaultPort = MGEParameters.asString("global.porta.app.impressao");
            _equipamentoFiscalHandler = EquipamentoFiscalHandler;

            return function (methodName, params) {
                var _defParams = {
                    port: _defaultPort,
                    encodePayload: true,
                    asUtf8: true,
                    HTML5: 'S'
                };

                return new WebConnectionCaller(methodName, angular.extend(_defParams, params));
            }
        }];

        function WebConnectionCaller(methodName, params) {
            var self = this;

            var _params = params;
            var _serverMethod = methodName;

            this.importImage = importImage;
            this.sendCubeInit = sendCubeInit;
            this.sendCubeData = sendCubeData;
            this.sendCubeFinish = sendCubeFinish;
            this.sendPdfKey = sendPdfKey;
            this.sendEquipFiscalData = sendEquipFiscalData;
            this.getIpCompartilhado - getIpCompartilhado;

            function importImage(paramsAsJson, payloadAsJson) {
                return callWebconnection(paramsAsJson, payloadAsJson);
            }

            function sendCubeInit(metadata) {
                doSendData(metadata, 'I');
            }

            function sendCubeData(data) {
                return doSendData(data, 'D');
            }

            function sendCubeFinish() {
                doSendData('', 'F');
            }
            
            function sendEquipFiscalData(dadosEnvioFiscal){
                let requestParams = angular.extend({}, _params, dadosEnvioFiscal);

                if(dadosEnvioFiscal){
                    return _equipamentoFiscalHandler.fetchWebConnection("sat", requestParams, dadosEnvioFiscal);
                }
            }

            function getIpCompartilhado(){
                return _equipamentoFiscalHandler.verificaIpCompartilhado();
            }

            function callWebconnection(paramsAsJson, payloadAsJson) {
                // Não usei o spread por questão de compatibilidade
                let requestParams = angular.extend({}, _params, paramsAsJson);

                if (payloadAsJson && requestParams.encodePayload === true) {
                    payloadAsJson = Base64.encode(JSON.stringify(payloadAsJson));
                }

                let requestInfo = AppletCaller.webConnectionCaller(_params.port, _serverMethod, requestParams, payloadAsJson);
                return !requestInfo.hasOwnProperty('error');
            }

            function doSendData(data, dataType) {

                var requestParams = {
                    resourceID: _params.resourceID,
                    label: _params.label,
                    locale: _params.locale,
                    codRel: _params.codRel,
                    uid: _params.uid,
                    asUtf8: _params.asUtf8,
                    HTML5: _params.HTML5,
                    dataType: dataType,
                    permiteExportar: _params.permiteExportar
                };
                
                var payload = data;
                
                if (payload && _params.encodePayload === true) {
                    payload = Base64.encode(payload);
                }

                var requestInfo = AppletCaller.webConnectionCaller(_params.port, _serverMethod, requestParams, payload);
                return !requestInfo.hasOwnProperty('error');
            }
            
            function sendPdfKey(chavePdf, userCanPrint, userCanExport, fileJasper, canSendByEmail = false) {
            	var requestParams = {
                        resourceID: _params.resourceID,
                        label: _params.label,
                        locale: _params.locale,
                        codRel: _params.codRel,
                        uid: _params.uid,
                        asUtf8: _params.asUtf8,
                        HTML5: _params.HTML5,
                        chaveArquivo: chavePdf,
                        permiteImprimir: userCanPrint === true ? "S" : "N",
                        permiteExportar: userCanExport === true ? "S" : "N",
                        contentType: fileJasper === true ? "S" : "N",
                        canSendViaEmail: canSendByEmail === true ? "S" : "N",
                    };

                    var requestInfo = AppletCaller.webConnectionCaller(_params.port, _serverMethod, requestParams);
                  

            }
        }
    });
(function () {
    [
        { provider: 'SkSessionStorage', type: 'sessionStorage' },
        { provider: 'SkLocalStorage', type: 'localStorage' }
    ].forEach(function (providerMD) {
        angular
            .module('snk.core.util')
            .provider(providerMD.provider, function () {
                this.$get = ['$q', 'ObjectUtils', 'SkApplicationInstance', function ($q, ObjectUtils, SkApplicationInstance) {
                    return function (domain) {
                        return new StorageProvider(providerMD.type, domain, $q, ObjectUtils, SkApplicationInstance);
                    }
                }];
            });
    });

    function StorageProvider(storageName, domain, $q, ObjectUtils, SkApplicationInstance) {
        var self = this;

        var storage = window[storageName];

        var _emptyConfigs = {};


        self.isSupported = isSupported;
        self.set = set;
        self.setWithServerUpdate = setWithServerUpdate;
        self.get = get;
        self.getWithServerFallback = getWithServerFallback;
        self.setDomain = setDomain;
        self.getDomain = getDomain;
        self.remove = remove;
        self.removeAll = removeAll;

        function isSupported() {
            return angular.isDefined(storage);
        }

        function getDomainObj(orNew) {
            if (isSupported()) {
                var domainStr = storage.getItem(domain);
                var domainObj;

                if (domainStr) {
                    domainObj = JSON.parse(domainStr);
                } else if (orNew) {
                    domainObj = {};
                }

                return domainObj;
            }

            return undefined;
        }

        function setDomain(obj) {
            storage.setItem(domain, JSON.stringify(obj));
        }

        function set(key, value) {
            if (isSupported()) {
                var domainObj = getDomainObj(true);

                ObjectUtils.setProperty(domainObj, key, value, ':');

                storage.setItem(domain, JSON.stringify(domainObj));
            }
        }

        function get(key, defaultValue) {
            if (isSupported()) {
                var domainObj = getDomainObj();

                if (domainObj) {
                    var item = ObjectUtils.getProperty(domainObj, key, false, ':');

                    if (item) {
                        try {
                            return JSON.parse(item);
                        } catch(e){
                            return item;
                        }

                    }
                }
            }

            return defaultValue;
        }

        function getWithServerFallback(key) {
            return $q(function(resolve, reject) {
                var result = get(key);

                if (angular.isDefined(result)) {
                    resolve(result);
                } else if (_emptyConfigs.hasOwnProperty(key)) {
                    resolve(undefined);
                } else {
                    SkApplicationInstance
                        .loadMgeConfig(domain + ':' + key)
                        .then(function(result) {
                            var config = result && result.config;

                            if (config) {
                                set(key, result.config);
                            } else {
                                _emptyConfigs[key] = undefined;
                            }

                            resolve(config);
                        }, reject);
                }
            });
        }

        function setWithServerUpdate(key, value) {
            set(key, value);
            return SkApplicationInstance.saveMgeConfig(domain + ":" + key, value);
        }

        function getDomain() {
            return getDomainObj();
        }

        function remove(key) {
            if (isSupported()) {
                var domainObj = getDomainObj();

                if (domainObj) {
                    ObjectUtils.removeProperty(domainObj, key, ':');
                    storage.setItem(domain, JSON.stringify(domainObj));
                }
            }
        }

        function removeAll() {
            storage.removeItem(domain);
        }
    }

})();
angular
    .module('snk.core.util')
    .service('WhenReadyBuilder', ['$q', 'AngularUtil', function ($q, AngularUtil) {
        function WhenReady() {

        }

        WhenReady.prototype.$isReady = false;
        WhenReady.prototype.pendingRequests;
        WhenReady.prototype.pendingRequestsByUniqueId = {};

        WhenReady.prototype.whenReady = function (uniqueId, resolveWith) {
            var defer = $q.defer();

            if (this.isReady()) {
                defer.resolve(resolveWith);
            } else {
                if (!this.pendingRequests) {
                    this.pendingRequests = [];
                }

                if (uniqueId && this.pendingRequestsByUniqueId[uniqueId]) {
                    defer.reject('Request \'' + uniqueId + '\' já enfileirado');

                    return defer.promise;
                }

                this.pendingRequests.push({
                    uniqueId: uniqueId,
                    defer: defer,
                    resolveWith: resolveWith
                });

                if (uniqueId) {
                    this.pendingRequestsByUniqueId[uniqueId] = uniqueId;
                }
            }

            return defer.promise;
        };

        WhenReady.prototype.isReady = function () {
            return this.$isReady;
        };

        WhenReady.prototype.notReady = function () {
            this.$isReady = false;
        };

        WhenReady.prototype.scopeItemReady = function (scope, prop) {
            AngularUtil.addSingleWatch(scope, prop, () => this.ready());
        };

        WhenReady.prototype.ready = function () {
            this.$isReady = true;

            if (this.pendingRequests) {
                var pending;

                while (pending = this.pendingRequests.pop()) {
                    pending.defer.resolve(pending.resolveWith);
                }

                this.pendingRequests = undefined;
            }
        };

        return {
            $new: function () {
                return new WhenReady()
            }
        }

    }])
    .provider('WhenReady', [function(){
        this.$get = ['WhenReadyBuilder', function(WhenReadyBuilder) {
            return function() {
                return WhenReadyBuilder.$new();
            };
        }];
    }]);

angular
.module("snk.core.util")
.service("XmlJson", 
['DateUtils','AngularUtil',
function(DateUtils, AngularUtil){
    var self = this;

    self.resolvePath = resolvePath;
    self.normalize = normalize;
    self.denormalize = denormalize;
    self.isNormalized = isNormalized;
    self.copyNormalized = copyNormalized;

    self.create = create;
    self.createChildElements = createChildElements;
    
    self.getTagName = getTagName;
    self.setTagName = setTagName;
    self.getAttributes = getAttributes;
    self.getAttribute = getAttribute;
    self.setAttribute = setAttribute;
    self.removeAttribute = removeAttribute;
    self.getText = getText;
    self.setText = setText;
    self.getChildren = getChildren;
    self.append = append;
    self.removeByIndex = removeByIndex;
    self.removeByTest = removeByTest;
    self.remove = remove;

    self.getRecordsAsObjects = getRecordsAsObjects;
    self.cloneJsonObject = cloneJsonObject;
    self.jsonToXml = jsonToXml;
    self.scapeHtmlText = scapeHtmlText;

    /**
    * retornar value:String do atributo da tagc
    * path:"taga.tagb.tagc.@atributo"
    * 
    * retornar textContent:String da tagc
    * path:"taga.tagb.tagc.toString()"
    * 
    * exemplo de path que passa pela tagb da posição 3 e retorna textContent:String da tagc
    * path:"taga.tagb[3].tagc.toString()"
    * 
    * retorna array de objNorm que representa a lista de tagc
    * path:"taga.tagb[0].tagc"
    * 
    * retorna objNorm que representa a tagc da posição 6 index 5
    * path:"taga.tagb[0].tagc[5]"
    */
    function resolvePath(obj, path) {
        
        let paths = path.split(".");
        let current = obj;
        
        let regexPart = /^(@[a-z0-9:_\$\-]+|toString\(\)|[a-z0-9:_\$\-]+(\[\d+\])?)$/i;
        for (let i = 0; i < paths.length; i++) {
            regexPart.lastIndex = 0;
            if ( ! regexPart.test(paths[i]) ) {
                throw new Error("path informado possui parte '" + paths[i] + "' inválida.");
            }
        }

        for (let idxFindPath = 0; idxFindPath < paths.length; idxFindPath++) {
            let name = paths[idxFindPath];// path part
            let index = -1;

            if(angular.isUndefined(name)){
                break;
            } else if (name == "toString()") {
                current = current.$content;
                break;
            } else if (name.indexOf("@") == 0) {
                current = current[name.substring(1)];
                break;
            }

            let regexIndex = /\[(\d+)\]/g;
            let matchIndex = regexIndex.exec(name);

            if (matchIndex != null) {
                name = name.replace(matchIndex[0],"");
                index = matchIndex[1];
            }

            let children = [];

            current.$children.find(child => {
                if (child.$name == name) {
                    children.push(child);
                    if (index > -1 && children.length - 1 >= index) {
                        return true;
                    }
                }
                return false;
            });

            if (index == -1) {
                current = children;
                if (idxFindPath + 1 < paths.length) {
                    current = children[0];
                }
            } else {
                current = children[index];
            }

            if (current == null) {
                break;
            }
        }

        return current;
    }

    function isNormalized(source) {
        return source.hasOwnProperty("$name")
            && source.hasOwnProperty("$content")
            && source.hasOwnProperty("$children")
            && angular.isArray(source.$children)
            && angular.isString(source.$name)
            && (angular.isString(source.$content) || source.$content == null);
    }

    function denormalize(source) {
        if ( ! isNormalized(source) ) {
            throw new Error("parâmetro source não é um objeto normalizado");
        }

        let content = source.$content;
        let children = source.$children;
        
        delete source.$name;
        delete source.$content;
        delete source.$children;

        if (content != null) {
            source.$ = content;
        }

        children.forEach(child => {
            if (source.hasOwnProperty(child.$name)) {
                delete source[child.$name];
            }
        });

        children.forEach(child => {
            let value = source[child.$name];
            if (value != null) {
                if ( ! angular.isArray(value) ) {
                    value = [value];
                    source[child.$name] = value;
                }
                value.push(child);
            } else {
                source[child.$name] = child;
            }
        });

        children.forEach(child => denormalize(child));
    }

    function copyNormalized(source, tagNameRoot) {
        return normalize(source, tagNameRoot, true);
    }

    function normalize(source, tagNameRoot, copy) {
        if (copy) {
            source = cloneJsonObject(source);
        }

        let name = "root";
        let content = null;
        let children = [];

        if (tagNameRoot != null) {
            name = toString(tagNameRoot);
        } else if (source.$name != null) {
            name = toString(source.$name);
        }

        if (source.$ != null) {
            content = toString(source.$);
        }

        delete source.$;
        delete source.$name;
        delete source.$content;
        delete source.$children;

        Object.keys(source).forEach(key => {
            let value = source[key];
            if (value != null) {
                value = tryToString(value);
                // children
                if ( ! angular.isString(value) ) {
                    if (angular.isArray(value)) {
                        value.forEach(item => {
                            item.$name = key;
                            children.push(item);
                        });
                    } else {
                        value.$name = key;
                        children.push(value);
                    }
                    delete source[key];
                }
            }
        });

        source.$name = name;
        source.$content = content;
        source.$children = children;

        source.$children.forEach(child => normalize(child));

        if (copy) {
            return source;
        }
    }

    /**
     * 
     * @param {Array} arrayTag 
     * veja o exemplo abaixo para entender o que arrayTag deve ser.
     * 
     * let result =
     *  <serviceResponse>
     *      <responseBody>
     *          <entities>
     *              <entity name="produto">
     *                  <produto>
     *                      <CODPROD>1</CODPROD>
     *                      <DESCRPROD>DESCRI PRODUTO</DESCRPROD>
     *                  </produto>
     *                  <produto>
     *                      <CODPROD>2</CODPROD>
     *                      <DESCRPROD>DESCRI PRODUTO 2</DESCRPROD>
     *                  </produto>
     *              </entity>
     *          </entities>
     *      </responseBody>
     *  </serviceResponse> 
     * 
     * let produtos = XmlJson.resolvePath(result, "responseBody.entities.entity.produto");
     * let recordsAsObjects = XmlJson.getRecordsAsObjects(produtos);
     * 
     * dataset.addRecordsAsObjects(recordsAsObjects);
     * 
     * @returns
     * 
     * [
     *      {
     *          CODPROD: "1",
     *          DESCRPROD: "DESCRI PRODUTO"
     *      },
     *      {
     *          CODPROD: "2",
     *          DESCRPROD: "DESCRI PRODUTO 2"
     *      }
     * ]
     * 
     */
    function getRecordsAsObjects(arrayTag) {
        var records = [];

        arrayTag.forEach(tag => {
            var record = {};

            getChildren(tag).forEach(child => {
                record[getTagName(child)] = getText(child);
            });

            records.push(record);
        });

        return records;
    }

    /**
     *   Método auxiliar para criação de um objeto normalizado.
     * 
     *   Considere o xml de exemplo abaixo:
     *   8 linhas
     *   262 caracteres
     *   <params id="{nuNota}">
     *       <notas>
     *           <nota nunota="{nuNota0}">{contentNuNota0}</nota>
     *           <nota nunota="{nuNota1}">{contentNuNota1}</nota>
     *           <nota nunota="{nuNota2}">{contentNuNota2}</nota>
     *           <nota nunota="{nuNota3}">{contentNuNota3}</nota>
     *       </notas>
     *   </params>
     *
     *   Assinatura do método create:
     *   function create(tagName:String, objAttr:Object, textContent:String, childrenArray:Array):ObjNorm 
     *
     *   As mesmas 8 linhas para criar o xml podemos utilizar para criar o objeto normalizado:
     *   8 linhas
     *   360 caracteres
     *   params = XmlJson.create("params", { id: nuNota }, null, [
     *       XmlJson.create("notas", null, null, [
     *           XmlJson.create("nota", { nunota: nuNota }, contentNuNota),
     *           XmlJson.create("nota", { nunota: nuNota1 }, contentNuNota1),
     *           XmlJson.create("nota", { nunota: nuNota2 }, contentNuNota2),
     *           XmlJson.create("nota", { nunota: nuNota3 }, contentNuNota3)
     *       ])
     *   ]);
     *
     *
     * 
     * @param {String} tagName
     * @param {Object} attributes 
     * @param {String} content 
     * @param {Array} children 
     * 
     * @returns objNorm:Object
     */
    function create(tagName, attributes, content, children) {
        
        if (tagName == null || ! angular.isString(tagName) ) {
            throw new Error("O parâmetro tagName é obrigatório e deve ser do tipo String");
        }

        let obj = {};

        if (attributes != null) {
            Object.keys(attributes).forEach(key => {
                let value = attributes[key];
                if (value != null) {
                    obj[key] = toString(value);
                }
            });
        }

        obj.$name = toString(tagName);

        content = tryToString(content);

        if (content != null && ! angular.isString(content)) {
            throw new Error("content da tag " + tagName + " deve ser do tipo String.");
        }

        if (children != null && ! angular.isArray(children)) {
            throw new Error("children da tag " + tagName + " deve ser do tipo Array.");
        }

        if (children != null) {
            children.forEach(child => {
                if ( ! isNormalized(child) ) {
                    throw new Error("um item do array de children não é um objeto normalizado");
                }
            });
        }
        
        obj.$content = content != null ? content : null;
        obj.$children = children != null ? children : [];

        if ( ! isNormalized(obj) ) {
            throw new Error("obj não resultou em um objeto normalizado válido");
        }

        return obj;
    }
    
    /** Função createChildElements:

    *- Criar uma tag com todos os campos de um dataset como tag filhas para enviar ao service.
    *Esta funcao cria uma tag pai com varios filhos. Bastante usado em casos como: 
    *
    * Exemplo pratico na tela: 
    * var recordsDatasetEmXML = XmlJson.createChildElements('itensCotacao', 'itemCotacao', dsItemCotacao.getSelectedRecords());
    * retornará um XML do tipo:

    * <itensCotacao>
    *     <itemCotacao>
    *         <CONTROLE />
    *         <CODPROD>X</CODPROD>
    *         <CODEMP>Y</CODEMP>
    *         <EMPRESA>Z</EMPRESA>
    *         ...
    *     </itemCotacao>
    *     <itemCotacao>
    *         <CONTROLE />
    *         <CODPROD>A</CODPROD>
    *         <CODEMP>B</CODEMP>
    *         <EMPRESA>C</EMPRESA>
    *         ...
    *     </itemCotacao>
    * </itensCotacao>
    * 
    * @param {String} rootTagName
    * @param {String} childrenTagName
    * @param {Object} object
    * 
    * @returns objNorm:Object
    */

    function createChildElements(rootTagName, childrenTagName, object){

        let xmlObj = create(rootTagName, null, null, null);

        if(angular.isArray(object)){
            object.forEach(obj => {

                let childObj = create(childrenTagName);
                Object.keys(obj).forEach( key => {
                    let element = create(key, null, obj[key], null);
        
                    append(childObj, element)
                });

                append(xmlObj, childObj)
            })
            
        } else {
            Object.keys(object).forEach( key => {
                let element = create(key, null, object[key], null);
    
                append(xmlObj, element)
            });
        }


        return xmlObj;
    }

    function getTagName(obj) {
        return obj.$name;
    }

    function setTagName(obj, name) {
        obj.$name = toString(name);
    }

    function getAttributes(obj) {
        let attrs = [];

        Object.keys(obj).forEach(key => {
            if (key.charAt(0) != "$") {
                attrs.push({name:key,value:obj[key]});
            }
        });
        
        return attrs;
    }

    function getAttribute(obj, name) {
        return obj[name];
    }

    function setAttribute(obj, name, value) {
        obj[name] = toString(value);
    }

    function removeAttribute(obj, name) {
        delete obj[name];
    }

    function append(parent, obj, index) {
        if ((index != null) && (index < 0 || index >= parent.$children.length)) {
            throw new Error("IndexOfBoundsError: index = " + index);
        }

        if (index == null) {
            parent.$children.push(obj);
        } else {
            parent.$children.splice(index,0,obj);
        }
    }

    function removeByIndex(parent, index) {
        let removed = false;
        if (index > -1 && index < parent.$children.length) {
            parent.$children.splice(index,1);
            removed = true;
        }
        return removed;
    }

    function remove(parent, obj) {
        let index = parent.$children.indexOf(obj);

        if (index > -1) {
            parent.$children.splice(index,1);
        }

        return index > -1;
    }

    function removeByTest(parent, fnTest) {
        let copy = parent.$children.filter(m => ! fnTest(m));
        parent.$children.splice(0,parent.$children.length);
        copy.forEach(m => parent.$children.push(m));
    }

    function getChildren(obj) {
        return obj.$children;
    }

    function getText(obj) {
        return obj.$content;
    }

    function setText(obj, text) {
        obj.$content = toString(text);
    }

    function tryToString(value) {
        if (value == null) {
            value = value;
        } else if (angular.isString(value)) {
            value = value;
        } else if (angular.isNumber(value)) {
            value = String(value);
        } else if ((typeof value).toLowerCase() == "boolean" || value instanceof Boolean) {
            value = String(value);
        } else if (angular.isDate(value)) {
            value = DateUtils.dateToString(value);
        }

        return value;
    }

    function toString(value) {
        value = tryToString(value);

        if (value != null && ! angular.isString(value)) {
            throw new Error("value deve ser do tipo String!");
        }

        return value;
    }

    /**
     * 
     * @param {jonObject} obj 
     * return {jsonObject} deep copy
     */
    function cloneJsonObject(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    /**
     * 
     * @param {jsonObject} obj 
     * @param {string} rootTagName opcional
     * return {string} xml
     */
    function jsonToXml(obj, rootTagName) {
        var cloneObj = cloneJsonObject(obj);

        if (isNormalized(cloneObj)) {
            if (rootTagName == null) {
                rootTagName = getTagName(cloneObj);
            }

            denormalize(cloneObj);
        }

        return AngularUtil.jsonToXml(cloneObj, rootTagName);
    }

    function scapeHtmlText(htmlText) {
        if (htmlText != null) {
            htmlText = htmlText.replace(/</g, '&lt;');
            htmlText = htmlText.replace(/>/g, '&gt;');
        }
        return htmlText;
    }

}]);

angular
    .module('snk.core.workspace')
    .service('SkWorkspace', ['$window', '$interval', 'SkApplication', 'UrlUtils', 'Base64', 'ObjectUtils', 'StringUtils',
     function($window, $interval, SkApplication, UrlUtils, Base64, ObjectUtils, StringUtils){
        /**A variavel 'workspace' e 'PROFILEID' são injetadas no contexto pelo GWT;*/
        var self = this;

        var SNKW_PROFILE_ID = "S4W8LB";
        var JIVW_PROFILE_ID = "J1WE9N";
        
        self.openAppActivity = openAppActivity;
        self.getAppLabel = getAppLabel;
        self.closeApp = closeApp;
        self.reloadApp = reloadApp;
        self.requestSignature = requestSignature;
        self.revokeSignature = revokeSignature;
        self.showDigitalSignDetails = showDigitalSignDetails;
        self.openHelp = openHelp;
        self.trackAnalyticsEvent = trackAnalyticsEvent;
        self.isJivaW = isJivaW;
        self.isSankhyaW = isSankhyaW;
        self.applicationClick = applicationClick;
        self.getCurrentHistory = getCurrentHistory;
        self.addHistoryChangeHandler = addHistoryChangeHandler;
        self.downloadFile = downloadFile;
        self.isMock = isMock;
        self.getMockedParams = getMockedParams;
        self.userIsCaixa = userIsCaixa;
        self.getTokenLogin = getTokenLogin;
        self.unlockSwitchApp = unlockSwitchApp;
        self.logout = logout;
        self.getAccountId = getAccountId;
        // Multi Abas
        self.openSideBarWorkspace = (workspace && workspace.openSideBarWorkspace || angular.noop);
        self.closeSideBarWorkspace = (workspace && workspace.closeSideBarWorkspace || angular.noop);

         function getCurrentHistory(resourceID) {
             try {
                 // Tela aberta pelo Workflow (loadbyPk)
                if (SkApplication.instance().isModoFlow()) {
                    return window.location.hash;
                 }

                 // Modificação feita para validar o Sankhya W em Multi Abas.
                 // caso o top.window.location.pathname for o involucro (tabContent.jsp)
                 // utilizar a hash do window.location
                 if ((top.window.location.pathname).indexOf("tabContent.jsp") > -1) {
                     //quanto multiplas abas, precisamos adicionar o resourceId no hash
                     return top.window.generateHash(window.location.hash);
                 }

                 if(resourceID){
                    const currentHash =window.location.hash?.replace('#/', "")
                    const currentResourceID = btoa(resourceID);

                    if (currentHash && currentResourceID){
                        return `app/${currentResourceID}/${currentHash}`;
                    }
                 }

                 return top.window.location.hash;
             } catch (e) {
                 try {
                     return workspace && workspace.getCurrentHistory();
                 } catch (e) {
                     return undefined;
                 }
             }
         }

        function addHistoryChangeHandler(onHistoryChange, screenResourceID, useLocalHash) {
        	if (workspace && workspace.addHistoryChangeHandler) {
        		workspace.addHistoryChangeHandler(onHistoryChange, screenResourceID);
        	} else {
        		if ($window.hasOwnProperty('onhashchange')) {
                    $window.onhashchange = function () {
                    	//Aqui não está "force" como o flex devido a Central, que entra em loop ao abrir duas notas.
                        const currentResourceID = useLocalHash ? screenResourceID : undefined;
                    	onHistoryChange(getCurrentHistory(currentResourceID));
                    }
                } else {
                    var storedHash = getCurrentHistory();

                    $interval(function () {
                        var currentHistory = getCurrentHistory();
                       
                        if (currentHistory != storedHash && (UrlUtils.getResourceIDFromToken(currentHistory) == screenResourceID)) {
                            storedHash = getCurrentHistory();
                            //Aqui não está "force" como o flex devido a Central, que entra em loop ao abrir duas notas.
                            onHistoryChange(storedHash);
                        }

                    }, 100, 0, false);
               }
	
        	}
        }
        
        function downloadFile(serverAddress, chave, extension, params) {
        	if(workspace && workspace.downloadFile) {
        		workspace.downloadFile(serverAddress, chave, extension);
        	} else {
                let url = '/mge/visualizadorArquivos.mge?chaveArquivo=' + chave;

                if(angular.isObject(params)){
                    angular.forEach(params, function(value, key){
                        url += ('&' + key + '=' + value);
                    });
                }

        		SkApplication.instance().openWindow(url, '_blank');
        	}
        }
        
        function userIsCaixa() {
        	return workspace && workspace.userIsCaixa();
        }
        
        function getTokenLogin(callbackJsSucessFunction, callbackJsErrorFunction) {
        	return workspace && workspace.getTokenLogin(callbackJsSucessFunction, callbackJsErrorFunction);
        }

        function openAppActivity(resourceId, pkObject) {
            workspace && workspace.openAppActivity(resourceId, pkObject);
        }

        function getAppLabel(resourceId){
            return workspace.getAppLabel(resourceId);
        }

        function closeApp(resourceId) {
            return workspace && workspace.closeApp(resourceId);
        }

        function reloadApp(resourceId, pkObject) {
            return workspace && workspace.reloadApp(resourceId, pkObject);
        }

        function requestSignature(signatureStamp, params, executorClassName, clientCallBackName, resourceId) {
            return workspace && workspace.requestSignature(signatureStamp, executorClassName, params, clientCallBackName, resourceId);
        }

        function revokeSignature(signatureStamp, params, executorClassName, clientCallBackName, resourceId) {
            return workspace && workspace.revokeSignature(signatureStamp, executorClassName, params, clientCallBackName, resourceId);
        }

        function showDigitalSignDetails(signatureStamp, chaveArquivo) {
            return workspace && workspace.showDigitalSignDetails(signatureStamp, chaveArquivo);
        }

        function openHelp(url){
            workspace && workspace.openHelp(url);
        }

        function trackAnalyticsEvent(category, action, label){
            workspace && workspace.trackAnalyticsEvent(category, action, label);
        }

        function applicationClick() {
        	workspace && workspace.applicationClick()
        }

        function getApplicationProfile() {
        	
        	if(PROFILEID == JIVW_PROFILE_ID){
                return "jivaw";
            }else if(PROFILEID == SNKW_PROFILE_ID){
                return "sankhyaw";
            }
        	
            return "profile.unknown";
        }

        function isJivaW() {
            return getApplicationProfile() === 'jivaw';
        }

        function isSankhyaW() {
            return getApplicationProfile() === 'sankhyaw';
        }

        function unlockSwitchApp() {
            workspace && workspace.unlockSwitchApp();
        }

        function isMock() {
            return workspace && angular.isDefined(workspace.isMock) && workspace.isMock === true;
        }

        function getMockedParams() {
            return isMock() ? workspace.mockedParams : [];
        }

        function logout() {
            workspace && workspace.logout();
        }

        function getAccountId() {
            return workspace.getAccountId();
        }
        
    }]);

angular
    .module('snk.components.accordion')
    .controller('SkAccordionController',['StringUtils', '$scope','$attrs','accordionConfig', function(StringUtils, $scope,$attrs,accordionConfig) {
        var self = this;

        self.closeOthers             = closeOthers;
        self.addGroup                = addGroup;
        self.removeGroup             = removeGroup;
        self.openAccordGroup         = openAccordGroup;
        self.currentAccordGroup;

        // This array keeps track of the accordion groups
        self.groups = [];

        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
        function closeOthers(openGroup) {
            var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
            if ( closeOthers ) {
                angular.forEach(this.groups, function (group) {
                    if ( group !== openGroup ) {
                        group.isOpen = false;
                    }
                });
            }
        };

        // This is called from the accordion-group directive to add itself to the accordion
        function addGroup(groupScope) {
            var that = this;
            this.groups.push(groupScope);

            groupScope.$on('$destroy', function (event) {
                that.removeGroup(groupScope);
            });
        };

        // This is called from the accordion-group directive when to remove itself
        function removeGroup(group) {
            var index = this.groups.indexOf(group);
            if ( index !== -1 ) {
                this.groups.splice(index, 1);
            }
        };

        function openAccordGroup(element){
            if(self.currentAccordGroup != element){
                
                self.currentAccordGroup = element;

                if(StringUtils.contains($attrs.accordionListener, ['.', '(', ')'])){
                    let point = $attrs.accordionListener.indexOf('.');
                    let controller = $attrs.accordionListener.substring(0, point);

                    let parentheses = $attrs.accordionListener.indexOf('(');
                    let functionName = $attrs.accordionListener.substring(point+1, parentheses);

                    let parent = $scope.$parent;

                    while(parent[controller] === undefined){
                        parent = parent.$parent;
                    }

                    if(parent){
                        parent[controller][functionName](self.currentAccordGroup);
                    }

                }
            }
        }

    }]);

/**
 * @ngdoc directive
 * @name snk.components.accordion.directive:sk-accordion
 * @restrict E
 * @scope
 * @description
 Accordion é o componente responsável por prover visualização em abas que se expandem e se contraem na vertical.
 Deve ser utilizado juntamente com a diretiva 'sk-accordion-group'.

 * @param {string} closeOthers Quando ativo permite que apenas uma aba esteja aberta por vez
 * @param {string} templateUrl Caminho de um template para sobrescrever o template original da diretiva
 *
 * @example
 <example module="appAccordion">
     <file name="appAccordion.html">
         <sk-accordion close-others="true">
             <sk-accordion-group heading="Primeiro Título" is-open="true" is-disabled="false">
                <div><b>Conteúdo em negrito 001</b></div><br/>
                <div><i>Conteúdo em itálico 001</i></div><br/>
                <div><u>Conteúdo sublinhado 001</u></div><br/>
             </sk-accordion-group>

             <sk-accordion-group heading="Segundo Título" is-open="false" is-disabled="false">
                <div><b>Conteúdo em negrito 002</b></div><br/>
                <div><i>Conteúdo em itálico 002</i></div><br/>
                <div><u>Conteúdo sublinhado 002</u></div><br/>
             </sk-accordion-group>
         </sk-accordion>
     </file>

    <file name="appAccordion.js">
        angular
        .module('appAccordion',['snk']);
    </file>
 </example>
 */

angular
    .module('snk.components.accordion')
    .directive('skAccordion',[function() {
        return {
            restrict:'EA',
            transclude: true,
            controller:'SkAccordionController',
            replace: false,
            templateUrl: 'components/accordion/accordion.tpl.html',
            compile: function(element) {
            	element.attr('layout', 'column');
            	element.attr('flex', '');
            }
        };
}]);

angular
    .module('snk.components.accordion')
    .directive('skAccordionTransclude',function() {
        return {
            require: '^skAccordionGroup',
            link: function(scope, element, attr, controller) {
                scope.$watch(function() { return controller[attr.skAccordionTransclude]; }, function(heading) {
                    if ( heading ) {
                        element.html('');
                        element.append(heading);
                    }
                });
            }
        };
    });
/**
 * @ngdoc directive
 * @name snk.components.accordion.directive:sk-accordion-group
 * @restrict E
 * @scope
 * @description
 Accordion-Group é o componente responsável por definir grupos (ou abas) dentro de um Accordion.

 * @param {string} isDiabled Determina se o sk-accordion-group está desativado ou não
 * @param {string} isOpen Determina se o sk-accordion-group iniciará aberto
 * @param {string} heading Label (ou título) do sk-accordion-group
 */

angular
    .module('snk.components.accordion')
    .directive('skAccordionGroup', ['DomUtil', function(DomUtil) {
        return {
            require:'^skAccordion',         // We need this directive to be inside an accordion
            restrict:'EA',
            transclude:true,              // It transcludes the contents of the directive into the template
            replace: true,                // The element containing the directive will be replaced with the template
            templateUrl:'components/accordion/accordion-group.tpl.html',
            scope: {
                heading: '@',               // Interpolate the heading attribute onto this scope
                isOpen: '=?',
                isDisabled: '=?',
                isRequired:'=?',
                icon:'@?skIcon',
                iconSvgSrc:'@?skIconSvgSrc',
                iconColor:'@?skIconColor',
                iconClick:'&?skIconClick',
                iconTooltip:'@?skIconTooltip',
                invalid: '=?skInvalid'

            },
            compile: function(element) {
            	element.attr('layout', 'column');
            	element.attr('flex', '');
            	
            	return function(scope, iElement, attrs, accordionCtrl) {
                    
                    scope.$watch('isOpen', function(value) {
                        if ( value ) {
                            accordionCtrl.closeOthers(scope);
                            iElement.attr('layout', 'column');
                            iElement.attr('flex', '');
                            accordionCtrl.openAccordGroup({'heading': scope.heading, 'element': iElement});
                        } else {
                        	iElement.removeAttr('layout');
                        	iElement.removeAttr('flex');
                        }
                    });

                    accordionCtrl.addGroup(scope);
                }
            },
            controller: ['$scope', '$element', function($scope, $element) {
                this.setHeading = function(element) {
                    this.heading = element;
                };

                this.removeHeader = function() {
                    DomUtil.select($element, 'a').remove();
                };

                this.toggleOpen = $scope.toggleOpen = function() {
                    if ( !$scope.isDisable && !$scope.isOpen ) {
                        $scope.isOpen = true;
                    }
                };
            }]
        };
    }]);

angular
    .module('snk.components.actionbutton')
    .controller('SkActionButtonController', ['$scope', '$q', 'SkI18nService', 'ServiceProxy', 'StringUtils', 'SkApplication', 'ObjectUtils', 'PopUpParameter', 'MessageUtils', 'MGEParameters', 'ArrayUtils', 'DateUtils', '$cacheFactory', 'KeyboardManager', 'AngularUtil',
        function ($scope, $q, SkI18nService, ServiceProxy, StringUtils, SkApplication, ObjectUtils, PopUpParameter, MessageUtils, MGEParameters, ArrayUtils, DateUtils, $cacheFactory, KeyboardManager, AngularUtil) {
            var CLIENT_EVENT_CONFIRM_NAME = "br.com.sankhya.actionbutton.clientconfirm";
            var ACTION_BUTTON_CACHE_NAME = "actionButtonCache";

            var self = this;
            var _actions;
            var _actionsLoaded = false;
			var _indexSelected = -1;
            
            var _callbacksById;
			var _popOver;

            var _isOrderActions = MGEParameters.asBoolean('global.ordenar.acoes.personalizadas');
			var _isBindKeys = MGEParameters.asBoolean('global.atalho.acoes.personalizadas');

            var _lastValuesCache = {};

            $scope.lblActions = $scope.tooltip ? SkI18nService.instant($scope.tooltip) : SkI18nService.instant('BotaoAcao.lblAcoes') + " (Ctrl+Alt+B)";

            $scope.getActionButtonConfigProperties = getActionButtonConfigProperties;
			$scope.useBindKey = _isBindKeys;
            $scope.filterActionFunction = angular.isDefined($scope.filterActionFunction) && angular.isFunction($scope.filterActionFunction) ? $scope.filterActionFunction : undefined;
            $scope.keyboardTarget = angular.isDefined($scope.keyboardTarget) ? $scope.keyboardTarget : undefined;
            $scope.alwaysLoadPropertiesActionButton = $scope.alwaysLoadPropertiesActionButton === 'true';
			self.hideMenu = hideMenu;

            init();

            function init() {
                if (!ServiceProxy.hasClientEvent(CLIENT_EVENT_CONFIRM_NAME)) {
                    ServiceProxy.addClientEvent(CLIENT_EVENT_CONFIRM_NAME, clientConfirm);
                }

                _callbacksById = $cacheFactory.get(ACTION_BUTTON_CACHE_NAME) || $cacheFactory(ACTION_BUTTON_CACHE_NAME);
				
				KeyboardManager.bind('ctrl+alt+b', function () {
                	if(_popOver){
                		_popOver.show();
						
						AngularUtil.timeout(function () {
							var itemElem = angular.element(document.querySelector('.btn-action-focus'));

							if (itemElem && itemElem[0]) {
								itemElem[0].focus();
							}
							
							if(_indexSelected == -1){
								nextAction();
							}
							
						}, 200);
                	}
                });

                KeyboardManager.bind('down', function () {
                	if(_popOver.popUpIsOpen() && _actionsLoaded){
                		nextAction();
                	}
                }, { propagate : true});
                
                KeyboardManager.bind('up', function () {
                	if(_popOver.popUpIsOpen() && _actionsLoaded){
                		beforeAction();
                	}
                }, { propagate : true});
				
				KeyboardManager.bind('left', function () {
                	if(_popOver.popUpIsOpen() && _actionsLoaded){
                		beforeAction();
                	}
                }, { propagate : true});
				
				KeyboardManager.bind('right', function () {
                	if(_popOver.popUpIsOpen() && _actionsLoaded){
                		nextAction();
                	}
                }, { propagate : true});
                
                KeyboardManager.bind('enter', function () {
                	if(_popOver.popUpIsOpen() && _actionsLoaded && _indexSelected > -1 && _actions != null && _indexSelected < _actions.length){
						executeAction(_actions[_indexSelected]);
						_popOver.hide();
                	}
                }, { propagate : true});
            }
            
            self.popoverListener = {
                onCreate: function(popover) {
                    _popOver = popover;
                }
            };

			function beforeAction(){
				if(_actions != null){
					_indexSelected--;
							
					if(_indexSelected < 0){
						_indexSelected = 0;
					}
					
					selectedAction();
				}
			}

			function nextAction(){
				if(_actions != null){
					_indexSelected++;
							
					if(_indexSelected > _actions.length-1){
						_indexSelected = _actions.length-1;
					}
					
					selectedAction();
				}
			}

            function selectedAction(){
            	ArrayUtils.forEach(_actions, function(action, index){
					action.selected = false;
				});
				
            	if(_indexSelected > -1 && _indexSelected < _actions.length){
            		_actions[_indexSelected].selected = true;
            	}
				
				$scope.$apply();
            }

            function getActionButtonConfigProperties() {
                var deferred = $q.defer();

                getActions().then(function (actions) {
                    if(angular.isDefined($scope.filterActionFunction)){
                        actions = $scope.filterActionFunction({actions: actions});
                    }

                    deferred.resolve({
                        textToColor: StringUtils.textToColor,
                        actionHasImage: actionHasImage,
                        buildNick: buildNick,
                        actions: actions,
                        executeAction: executeAction,
                        squareMode: $scope.squareMode
                    });
                });

                return deferred.promise;
            }

            function actionHasImage(action) {
                return action.img && action.img != '';
            }

            function buildNick(action) {
                var descr = action.description;

                if (descr && angular.isFunction(descr.trim)) {
                    descr = descr.trim();

                    return descr.substr(0, Math.min(3, descr.length));
                } else {
                    return '';
                }
            }

            function clientConfirm(clientEvent) {

                var callSource;
                var callBack;

                if (clientEvent.event.hasOwnProperty('stpCall')) {
                    callSource = clientEvent.event.stpCall;
                    callBack = callExecProcedure;
                } else if (clientEvent.event.hasOwnProperty('runScript')) {
                    callSource = clientEvent.event.runScript;
                    callBack = callExecScript;
                } else if (clientEvent.event.hasOwnProperty('javaCall')) {
                    callSource = clientEvent.event.javaCall;
                    callBack = callExecJava;
                }

                var param = {
                    type: 'S',
                    sequence: clientEvent.event.sequence
                };

                if (!callSource.params) {
                    callSource.params = {
                        param: []
                    }
                } else {
                    callSource.params.param = ArrayUtils.toArray(callSource.params.param);
                }

                callSource.params.param.push(param);

                var title = clientEvent.event.title.$;
                var message = clientEvent.event.message.$;

                if (clientEvent.event.showNoOption == 'S') { //Sim ou Não
                    param.paramName = "__ESCOLHA_SIMNAO__";

                    MessageUtils.confirmBuilder()
                        .title(title)
                        .msg(message)
                        .show().then(function () {
                            param.$ = 'S';

                            callBack(callSource);
                        }, function (reason) {
                            if (reason === 'no') {
                                param.$ = 'N';
                                callBack(callSource);
                            }
                        });
                } else { //Apenas sim
                    MessageUtils.confirm(title, message, undefined, undefined, true, undefined, {showBtnNo: false})
                                .then(function(){
                            param.paramName = "__CONFIRMACAO__";
                            param.$ = 'S';

                            callBack(callSource);
                                }, function(reason){
                                    if(reason == 'no'){
                                        param.paramName = "__CONFIRMACAO__";
                                        param.$ = 'N';

                                        callBack(callSource);
                                    }
                        });
                }
            }

            function getActions() {
                var deferred = $q.defer();

                var param={ 
                    param: {
                       entityName: $scope.entityName,
                       resourceID: StringUtils.emptyAsNull($scope.resourceId) != null ? $scope.resourceId : SkApplication.instance().getResourceID(), 
                       accessResourceID: $scope.accessResourceId                      
                     }
                   }

               if(angular.isDefined($scope.ignoreControleAcesso)){
                   param.param.ignoreControleAcesso=$scope.ignoreControleAcesso;
               }

                if (_actionsLoaded) {
                    deferred.resolve(_actions);
                } else {
                  ServiceProxy.callService('ActionButtonsSP.getActions', param).then(function (result) {
                        if (result.responseBody.actions) {
                            _actions = result.responseBody.actions.action;
                            
                            if (_actions) {
                                if (_isOrderActions) {
                                    ArrayUtils.sortByStringProperty(_actions, 'description');
                                }
								
								if(_isBindKeys){
                                	 ArrayUtils.forEach(_actions, function(action, index){
                                     	if(action.teclaAtalho != null){
                                     		action.description = action.description + " (" + action.teclaAtalho + ")";
                                            const opt =  $scope.keyboardTarget ? {target: $scope.keyboardTarget} : undefined;

                                     		KeyboardManager.bind(action.teclaAtalho.toLowerCase(), function () {
                                     			executeAction(action);
                                     		}, opt);
                                     	}
                     				});
                                }
                            }
                        }

                    }).finally(function () {
                        _actionsLoaded = true;
                        deferred.resolve(_actions);
                    });
                }

                return deferred.promise;
            }

            function executeAction(action) {
                if (action.type == 'LC') {
                    launchScreen(action);
                } else if (action.type == 'SC') {
                    execJS(action);
                } else if (action.type == 'RJ') {
                    execJava(action);
                } else if (action.type == 'SP') {
                    execProcedure(action)
                } else if (action.type == 'EB') {
                    execEmbedded(action) 
                } else {
                    throw new Error('Tipo de ação não implementada: ' + action.type);
                }
            }

            function execJava(action) {
                var execSource = {
                    actionID: action.actionID,
                    refreshType: action.actionConfig.javaCall.refreshType
                };

                if (angular.isDefined($scope.context) && angular.isFunction($scope.context.getMasterEntityName) && angular.isDefined($scope.context.getMasterEntityName())) {
                    execSource.masterEntityName = $scope.context.getMasterEntityName();
                }

                prepareAndExecute(action, execSource, callExecJava);
            }

            function execProcedure(action) {
                var procName = action.actionConfig.dbCall.name;
                var rootEntity = action.actionConfig.dbCall.rootEntity;

                var execSource = {
                    actionID: action.actionID,
                    procName: procName,
                    rootEntity: rootEntity,
                    refreshType: action.actionConfig.dbCall.refreshType
                };

                prepareAndExecute(action, execSource, callExecProcedure);
            }

            function execJS(action) {
                var execSource = {
                    actionID: action.actionID,
                    refreshType: action.actionConfig.runScript.refreshType
                };

				if (angular.isDefined($scope.context) && angular.isFunction($scope.context.getMasterEntityName) && angular.isDefined($scope.context.getMasterEntityName())) {
                    execSource.masterEntityName = $scope.context.getMasterEntityName();
                }

                prepareAndExecute(action, execSource, callExecScript);
            }

            function execEmbedded(action) {
                var execSource = {
                    description: action.description
                };

                angular.extend(execSource, action.actionConfig.embeddedCall)

                if (angular.isDefined($scope.context) && angular.isFunction($scope.context.getMasterEntityName) && angular.isDefined($scope.context.getMasterEntityName())) {
                    execSource.masterEntityName = $scope.context.getMasterEntityName();
                }

                prepareAndExecute(action, execSource, callExecEmbedded);
            }

            function prepareAndExecute(action, execSource, executeAction) {

                var doExecute = function () {
                    addRows(execSource);

                    if (execSource.refreshType) {
                        _callbacksById.put(action.actionID, function() {
							if (angular.isDefined($scope.context) && angular.isFunction($scope.context.recordsReloader)) {
	                            $scope.context.recordsReloader(execSource.refreshType);
                            }
                        });
                    }

                    executeAction(execSource);
                };

                if (action.actionConfig.params && action.actionConfig.params.promptParam) {
                    resolvePromptParams(action, execSource).then(doExecute);
                } else {
                    doExecute();
                }

            }

            function resolvePromptParams(action, execSource) {
                var paramsResolvedPromise = $q.defer();

                var paramsSource = action.actionConfig.params.promptParam;
                var params = [];
                var paramsByName = {};

                var hasParamsToSave = false;

                for (var i = 0; i < paramsSource.length; i++) {
                    var paramSource = paramsSource[i];

                    if (!hasParamsToSave && paramSource.saveLast == 'true') {
                        hasParamsToSave = true;
                    }

                    var promptParam = buildPromptParam(paramSource);

                    paramsByName[promptParam.fieldName] = promptParam;
                    params.push(promptParam);
                }

                function putParamsOnExecSource(params) {
                    execSource.params = {
                        param: []
                    };

                    for (var i = 0; i < params.length; i++) {
                        var param = params[i];

                        if (StringUtils.isNotEmpty(param.value)) {
                            execSource.params.param.push({
                                type: getParamDataType(param.paramType),
                                paramName: param.fieldName,
                                $: getParamValue(param)
                            });
                        }
                    }
                }

                if (hasParamsToSave) { //Se temos, então devemos buscar o último valor e salvar os novos

                    loadLastValues(action)
                        .then(function (lastParams) {

                            if (lastParams) {
                                for (var i = 0; i < lastParams.param.length; i++) {
                                    var lastParam = lastParams.param[i];

                                    if (lastParam.$ && paramsByName[lastParam.paramName] && paramsByName[lastParam.paramName].saveLast == 'true') {
                                        paramsByName[lastParam.paramName].value = lastParam.$;
                                    }
                                }
                            }

                            PopUpParameter.openPopUp(params).result
                                .then(function () {
                                    putParamsOnExecSource(params);
                                    saveLastValues(action, params);
                                    paramsResolvedPromise.resolve();
                                });
                        });

                } else {
                    PopUpParameter.openPopUp(params).result
                        .then(function () {
                            putParamsOnExecSource(params);
                            paramsResolvedPromise.resolve();
                        });
                }

                return paramsResolvedPromise.promise;
            }

            function saveLastValues(action, params) {
                if (SkApplication.instance()) {
                    var config = {
                        params: {
                            param: []
                        }
                    };

                    for (var i = 0; i < params.length; i++) {
                        var param = params[i];

                        if (param.saveLast == 'true') {
                            config.params.param.push({
                                paramName: param.fieldName,
                                $: param.value
                            });
                        }
                    }

                    var resourceId = buildResourceId(action.actionID);

                    _lastValuesCache[resourceId] = config.params;

                    SkApplication.instance().saveMgeConfig(resourceId, config);
                }
            }

            function loadLastValues(action) {
                var loadPromise = $q.defer();

                var resourceId = buildResourceId(action.actionID);

                if (_lastValuesCache[resourceId]) {
                    loadPromise.resolve(_lastValuesCache[resourceId]);
                } else {
                    ServiceProxy.callService('SystemUtilsSP.getConf', {
                        config: {
                            chave: resourceId,
                            tipo: 'T'
                        }
                    }).then(function (result) {
                        var lastParams;

                        if (result.responseBody.config && result.responseBody.config.params) {
                            lastParams = result.responseBody.config.params;

                            if (!angular.isArray(lastParams.param)) {
                                lastParams.param = [lastParams.param];
                            }
                        }

                        _lastValuesCache[resourceId] = lastParams;

                        loadPromise.resolve(lastParams);
                    }, function (error) {
                        loadPromise.reject(error);
                    });
                }

                return loadPromise.promise;
            }

            function buildPromptParam(param) {
                var type = param.paramType;
                var isCheckbox = false;
                var fieldProps;
                let entityPK;

                switch (type) {
                    case 'DT':
                        type = 'D';
                        break;

                    case 'DH':
                        type = 'H';
                        break;

                    case 'D':
                        type = 'F';
                        fieldProps = {
                            'sk-precision': Number(param.precision)
                        };
                        break;

                    case 'B':
                        type = 'S';
                        isCheckbox = true;
                        break;

                    case 'ENTITY':
                    	fieldProps = {
                            'sk-entity-name': param.entityName,
                            'sk-allow-show-hierarchical-mode': param.hierarchyEntity,
                            'sk-data-type': 'S'
                        };
                    	
                    	if(param.hierarchyEntity && param.entityPK){
                    		entityPK = param.entityPK;
                    	}

                        break;

                    case 'SO':
                        type = 'O';

                        var options = param.options.split(';').map(function (opc, index) {
                            var data;
                            var value;

                            if (opc.indexOf('=') > -1) {
                              var opcArr = opc.split('=');

                              data = opcArr[0];
                              value = opcArr[1];
                            } else {
                              data = (index + 1);
                              value = opc;
                            }

                            return {
                                data: data,
                                value: value
                            }
                        });

                        fieldProps = {
                            'sk-options': options
                        };

                        break;

                }

                return {
                    description: param.label,
                    required: param.required == 'true',
                    fieldName: param.name,
                    fieldNameOri: param.name,  
                    entityPK: entityPK,
                    paramType: param.paramType,
                    type: type,
                    isCheckbox: isCheckbox,
                    saveLast: param.saveLast,
                    fieldProp: fieldProps,
                    value: ''
                };
            }

            function getParamDataType(uiType) {
                var dataType = "S";

                switch (uiType) {
                    case "D" :
                        dataType = "F";
                        break;
                    case "DT" :
                    case "DH" :
                        dataType = "D";
                        break;
                    case "B" :
                    case "ENTITY" :
                    case "SO" :
                        dataType = "S";
                        break;
                    default :
                        dataType = uiType;
                }

                return dataType;
            }

            function getParamValue(param) {
                var value = param.value;

                if (!value) {
                    return value;
                }

                if (param.paramType == 'DT' || param.paramType == 'DH') {
                    
                    if(value instanceof Date){
                        value = DateUtils.formatDate(value, param.paramType == 'DT' ? DateUtils.DEFAULT_DATE_FORMAT : DateUtils.DEFAULT_DATETIME_FORMAT);
                    }

                }

                return value;
            }

            function buildResourceId(actionId) {
                var appResId = '';

                if (SkApplication.instance()) {
                    appResId = SkApplication.instance().getResourceID();
                }

                return StringUtils.substitute("{0}.actionconfig.{1}", appResId, actionId);
            }

            function addRows(execSource) {
                var rows = {
                    row: []
                };

                var sourceRows = angular.isDefined($scope.context) && angular.isFunction($scope.context.selectedRowsGetter) ? $scope.context.selectedRowsGetter() : undefined;

                for (var i in sourceRows) {
                    var sourceRow = sourceRows[i];

                    var row = {};

                    if (sourceRow.hasOwnProperty("__MASTER_ROW__")) {
                        row.master = 'S';
                        row.entityName = sourceRow.__ENTITY_NAME__;

                        delete sourceRow['__MASTER_ROW__'];
                        delete sourceRow['__ENTITY_NAME__'];
                    }

                    for (var fName in sourceRow) {
                        if (!row.field) {
                            row.field = [];
                        }

                        row.field.push({
                            fieldName: fName,
                            $: sourceRow[fName]
                        });
                    }

                    rows.row.push(row);
                }

                if (rows.row.length > 0) {
                    execSource.rows = rows;
                }
            }

            function callExecJava(execSource) {
                ServiceProxy.callService('ActionButtonsSP.executeJava', {
                    javaCall: execSource
                }).then(function () {
                    afterExec(execSource, 'javaCall');
                });
            }

            function callExecScript(execSource) {
                ServiceProxy.callService('ActionButtonsSP.executeScript', {
                    runScript: execSource
                }).then(function () {
                    afterExec(execSource, 'runScript');
                });
            }

            function callExecProcedure(execSource) {
                ServiceProxy.callService('ActionButtonsSP.executeSTP', {
                    stpCall: execSource
                }).then(function () {
                    afterExec(execSource, 'dbCall');
                });
            }

            function callExecEmbedded(execSource) {
                ServiceProxy.callService('ActionButtonsSP.execEmbeddedAction', {
                    embeddedCall: execSource
                }).then(() => afterExec(execSource))
                  .catch(() =>afterExec(execSource));
            }

            function afterExec(execSource, actionSource) {
                var action = _callbacksById.get(execSource.actionID);
                
                if (action) {
                    _callbacksById.remove(execSource.actionID);
                    action();
                }
            }

            function getValue(resourceID, action, localField) {
                if (!angular.isDefined($scope.context) || !angular.isFunction($scope.context.parameterGetter)) {
                    return undefined;
                }

                return StringUtils.emptyAsUndefined($scope.context.parameterGetter(resourceID, action.entityName, localField, true));
            }

            function launchScreen(action) {

                var resourceID = action.resourceID;

                if (resourceID) {
                    var obj;

                    var params = ObjectUtils.getProperty(action, 'actionConfig.params.param');

                    if (params && params.length > 0) {
                        obj = {};

                        var processedParams = [];

                        for (var index in params) {
                            var p = params[index];

                            var localField = p.localField;
                            var targetField = p.targetField;

                            var value = getValue(resourceID, action, localField);

                            if (!value) {
                                var localFieldLabel = StringUtils.emptyAsUndefined($scope.context.parameterLabelGetter(resourceID, action.entityName, localField));

                                if (!localFieldLabel) {
                                    localFieldLabel = localField;
                                }

                                throw new Error(`A ação "${ action.description }" não pôde ser executada porque o campo "${ localFieldLabel }" está vazio.`);
                            }

                            obj[targetField] = value;

                            processedParams.push({
                                fieldName: targetField,
                                value: value
                            });
                        }

                        obj.ACTION_PARAMETERS = processedParams;
                        obj.call_time = Date.now();
                    }

                    SkApplication.instance().openApp(resourceID, obj);
                }
            }
            
            function hideMenu(){
            	if(_popOver != null){
            		_popOver.hide();
                }
            }

        }]);

angular
    .module('snk.components.actionbutton')
    .directive('skActionButton', ['$q', 'StringUtils', function ($q, StringUtils) {
        return {
            scope: {
                entityName: '@skEntityName',
                resourceId: '@skResourceId',
                accessResourceId: '@skAccessResourceId',
                context:    '=skContext',
                zIndex: '<',
                isDisabled: '=?skIsDisabled',
				tooltip: '@?skTooltip',
                tooltipPlacement: '@?skTooltipPlacement',
                ignoreControleAcesso: '=?skIgnoreControleAcesso',
                squareMode: "=?skSquareMode",
                filterActionFunction: '&?skFilterActionFunction',
                alwaysLoadPropertiesActionButton: '@?skAlwaysLoadProperties',
                keyboardTarget: '@?skKeyboardTarget',
            },
            templateUrl: 'components/actionbutton/actionbutton.tpl.html',
            restrict: 'E',
            controller: 'SkActionButtonController',
            controllerAs: 'ctrl',
            link: postLink
        };

        function postLink(scope, element, attr, ctrl) {
        }
    }]);

angular
    .module('snk.components.actionbutton')
    .service('ActionButtonService', ['$rootScope', '$q', 'SkI18nService', 'ServiceProxy', 'StringUtils', 'SkApplication', 'ObjectUtils', 'PopUpParameter', 'MessageUtils', 'MGEParameters', 'ArrayUtils', 'DateUtils', '$cacheFactory', 'KeyboardManager', 'AngularUtil', 
    function($rootScope, $q, SkI18nService, ServiceProxy, StringUtils, SkApplication, ObjectUtils, PopUpParameter, MessageUtils, MGEParameters, ArrayUtils, DateUtils, $cacheFactory, KeyboardManager, AngularUtil) {
        var CLIENT_EVENT_CONFIRM_NAME = "br.com.sankhya.actionbutton.clientconfirm";
        var ACTION_BUTTON_CACHE_NAME = "actionButtonCache";

        var _lastValuesCache = {};
        var _callbacksById;

        var self = this;
        self.init = (context) => {
            $rootScope.context = context;

            if (!ServiceProxy.hasClientEvent(CLIENT_EVENT_CONFIRM_NAME)) {
                ServiceProxy.addClientEvent(CLIENT_EVENT_CONFIRM_NAME, clientConfirm);
            }

            _callbacksById = $cacheFactory.get(ACTION_BUTTON_CACHE_NAME) || $cacheFactory(ACTION_BUTTON_CACHE_NAME);

            return {
                executeAction: executeAction
            };
        };

        function executeAction(action) {
            if (action.type == 'LC') {
                launchScreen(action);
            } else if (action.type == 'SC') {
                execJS(action);
            } else if (action.type == 'RJ') {
                execJava(action);
            } else if (action.type == 'SP') {
                execProcedure(action)
            } else if (action.type == 'EB') {
                execEmbedded(action) 
            } else {
                throw new Error('Tipo de ação não implementada: ' + action.type);
            }
        }

        function execJava(action) {
            var execSource = {
                actionID: action.actionID,
                refreshType: action.actionConfig.javaCall.refreshType
            };

            if (angular.isDefined($rootScope.context) && angular.isFunction($rootScope.context.getMasterEntityName) && angular.isDefined($rootScope.context.getMasterEntityName())) {
                execSource.masterEntityName = $rootScope.context.getMasterEntityName();
            }

            prepareAndExecute(action, execSource, callExecJava);
        }

        function execProcedure(action) {
            var procName = action.actionConfig.dbCall.name;
            var rootEntity = action.actionConfig.dbCall.rootEntity;

            var execSource = {
                actionID: action.actionID,
                procName: procName,
                rootEntity: rootEntity,
                refreshType: action.actionConfig.dbCall.refreshType
            };

            prepareAndExecute(action, execSource, callExecProcedure);
        }

        function execJS(action) {
            var execSource = {
                actionID: action.actionID,
                refreshType: action.actionConfig.runScript.refreshType
            };

            if (angular.isDefined($rootScope.context) && angular.isFunction($rootScope.context.getMasterEntityName) && angular.isDefined($rootScope.context.getMasterEntityName())) {
                execSource.masterEntityName = $rootScope.context.getMasterEntityName();
            }

            prepareAndExecute(action, execSource, callExecScript);
        }

        function execEmbedded(action) {
            var execSource = {
                description: action.description
            };

            angular.extend(execSource, action.actionConfig.embeddedCall)

            if (angular.isDefined($rootScope.context) && angular.isFunction($rootScope.context.getMasterEntityName) && angular.isDefined($rootScope.context.getMasterEntityName())) {
                execSource.masterEntityName = $rootScope.context.getMasterEntityName();
            }

            prepareAndExecute(action, execSource, callExecEmbedded);
        }

        function prepareAndExecute(action, execSource, executeAction) {

            var doExecute = function () {
                addRows(execSource);

                if (execSource.refreshType) {
                    _callbacksById.put(action.actionID, function() {
                        if (angular.isDefined($rootScope.context) && angular.isFunction($rootScope.context.recordsReloader)) {
                            $rootScope.context.recordsReloader(execSource.refreshType);
                        }
                    });
                }

                executeAction(execSource);
            };

            if (action.actionConfig.params && action.actionConfig.params.promptParam) {
                resolvePromptParams(action, execSource).then(doExecute);
            } else {
                doExecute();
            }

        }

        function clientConfirm(clientEvent) {

            var callSource;
            var callBack;

            if (clientEvent.event.hasOwnProperty('stpCall')) {
                callSource = clientEvent.event.stpCall;
                callBack = callExecProcedure;
            } else if (clientEvent.event.hasOwnProperty('runScript')) {
                callSource = clientEvent.event.runScript;
                callBack = callExecScript;
            } else if (clientEvent.event.hasOwnProperty('javaCall')) {
                callSource = clientEvent.event.javaCall;
                callBack = callExecJava;
            }

            var param = {
                type: 'S',
                sequence: clientEvent.event.sequence
            };

            if (!callSource.params) {
                callSource.params = {
                    param: []
                }
            } else {
                callSource.params.param = ArrayUtils.toArray(callSource.params.param);
            }

            callSource.params.param.push(param);

            var title = clientEvent.event.title.$;
            var message = clientEvent.event.message.$;

            if (clientEvent.event.showNoOption == 'S') { //Sim ou Não
                param.paramName = "__ESCOLHA_SIMNAO__";

                MessageUtils.confirmBuilder()
                    .title(title)
                    .msg(message)
                    .show().then(function () {
                        param.$ = 'S';

                        callBack(callSource);
                    }, function (reason) {
                        if (reason === 'no') {
                            param.$ = 'N';
                            callBack(callSource);
                        }
                    });
            } else { //Apenas sim
                MessageUtils.confirm(title, message, undefined, undefined, true, undefined, {showBtnNo: false})
                            .then(function(){
                        param.paramName = "__CONFIRMACAO__";
                        param.$ = 'S';

                        callBack(callSource);
                            }, function(reason){
                                if(reason == 'no'){
                                    param.paramName = "__CONFIRMACAO__";
                                    param.$ = 'N';

                                    callBack(callSource);
                                }
                    });
            }
        }

        function addRows(execSource) {
            var rows = {
                row: []
            };

            var sourceRows = angular.isDefined($rootScope.context) && angular.isFunction($rootScope.context.selectedRowsGetter) ? $rootScope.context.selectedRowsGetter() : undefined;

            for (var i in sourceRows) {
                var sourceRow = sourceRows[i];

                var row = {};

                if (sourceRow.hasOwnProperty("__MASTER_ROW__")) {
                    row.master = 'S';
                    row.entityName = sourceRow.__ENTITY_NAME__;

                    delete sourceRow['__MASTER_ROW__'];
                    delete sourceRow['__ENTITY_NAME__'];
                }

                for (var fName in sourceRow) {
                    if (!row.field) {
                        row.field = [];
                    }

                    row.field.push({
                        fieldName: fName,
                        $: sourceRow[fName]
                    });
                }

                rows.row.push(row);
            }

            if (rows.row.length > 0) {
                execSource.rows = rows;
            }
        }

        function resolvePromptParams(action, execSource) {
            var paramsResolvedPromise = $q.defer();

            var paramsSource = action.actionConfig.params.promptParam;
            var params = [];
            var paramsByName = {};

            var hasParamsToSave = false;

            for (var i = 0; i < paramsSource.length; i++) {
                var paramSource = paramsSource[i];

                if (!hasParamsToSave && paramSource.saveLast == 'true') {
                    hasParamsToSave = true;
                }

                var promptParam = buildPromptParam(paramSource);

                paramsByName[promptParam.fieldName] = promptParam;
                params.push(promptParam);
            }

            function putParamsOnExecSource(params) {
                execSource.params = {
                    param: []
                };

                for (var i = 0; i < params.length; i++) {
                    var param = params[i];

                    if (StringUtils.isNotEmpty(param.value)) {
                        execSource.params.param.push({
                            type: getParamDataType(param.paramType),
                            paramName: param.fieldName,
                            $: getParamValue(param)
                        });
                    }
                }
            }

            if (hasParamsToSave) { //Se temos, então devemos buscar o último valor e salvar os novos

                loadLastValues(action)
                    .then(function (lastParams) {

                        if (lastParams) {
                            for (var i = 0; i < lastParams.param.length; i++) {
                                var lastParam = lastParams.param[i];

                                if (lastParam.$ && paramsByName[lastParam.paramName] && paramsByName[lastParam.paramName].saveLast == 'true') {
                                    paramsByName[lastParam.paramName].value = lastParam.$;
                                }
                            }
                        }

                        PopUpParameter.openPopUp(params).result
                            .then(function () {
                                putParamsOnExecSource(params);
                                saveLastValues(action, params);
                                paramsResolvedPromise.resolve();
                            });
                    });

            } else {
                PopUpParameter.openPopUp(params).result
                    .then(function () {
                        putParamsOnExecSource(params);
                        paramsResolvedPromise.resolve();
                    });
            }

            return paramsResolvedPromise.promise;
        }

        function loadLastValues(action) {
            var loadPromise = $q.defer();

            var resourceId = buildResourceId(action.actionID);

            if (_lastValuesCache[resourceId]) {
                loadPromise.resolve(_lastValuesCache[resourceId]);
            } else {
                ServiceProxy.callService('SystemUtilsSP.getConf', {
                    config: {
                        chave: resourceId,
                        tipo: 'T'
                    }
                }).then(function (result) {
                    var lastParams;

                    if (result.responseBody.config && result.responseBody.config.params) {
                        lastParams = result.responseBody.config.params;

                        if (!angular.isArray(lastParams.param)) {
                            lastParams.param = [lastParams.param];
                        }
                    }

                    _lastValuesCache[resourceId] = lastParams;

                    loadPromise.resolve(lastParams);
                }, function (error) {
                    loadPromise.reject(error);
                });
            }

            return loadPromise.promise;
        }

        function buildPromptParam(param) {
            var type = param.paramType;
            var isCheckbox = false;
            var fieldProps;
            let entityPK;

            switch (type) {
                case 'DT':
                    type = 'D';
                    break;

                case 'DH':
                    type = 'H';
                    break;

                case 'D':
                    type = 'F';
                    fieldProps = {
                        'sk-precision': Number(param.precision)
                    };
                    break;

                case 'B':
                    type = 'S';
                    isCheckbox = true;
                    break;

                case 'ENTITY':
                    fieldProps = {
                        'sk-entity-name': param.entityName,
                        'sk-allow-show-hierarchical-mode': param.hierarchyEntity,
                        'sk-data-type': 'S'
                    };
                    
                    if(param.hierarchyEntity && param.entityPK){
                        entityPK = param.entityPK;
                    }

                    break;

                case 'SO':
                    type = 'O';

                    var options = param.options.split(';').map(function (opc, index) {
                        var data;
                        var value;

                        if (opc.indexOf('=') > -1) {
                          var opcArr = opc.split('=');

                          data = opcArr[0];
                          value = opcArr[1];
                        } else {
                          data = (index + 1);
                          value = opc;
                        }

                        return {
                            data: data,
                            value: value
                        }
                    });

                    fieldProps = {
                        'sk-options': options
                    };

                    break;

            }

            return {
                description: param.label,
                required: param.required == 'true',
                fieldName: param.name,
                fieldNameOri: param.name,  
                entityPK: entityPK,
                paramType: param.paramType,
                type: type,
                isCheckbox: isCheckbox,
                saveLast: param.saveLast,
                fieldProp: fieldProps,
                value: ''
            };
        }

        function getParamDataType(uiType) {
            var dataType = "S";

            switch (uiType) {
                case "D" :
                    dataType = "F";
                    break;
                case "DT" :
                case "DH" :
                    dataType = "D";
                    break;
                case "B" :
                case "ENTITY" :
                case "SO" :
                    dataType = "S";
                    break;
                default :
                    dataType = uiType;
            }

            return dataType;
        }

        function getParamValue(param) {
            var value = param.value;

            if (!value) {
                return value;
            }

            if (param.paramType == 'DT' || param.paramType == 'DH') {
                
                if(value instanceof Date){
                    value = DateUtils.formatDate(value, param.paramType == 'DT' ? DateUtils.DEFAULT_DATE_FORMAT : DateUtils.DEFAULT_DATETIME_FORMAT);
                }

            }

            return value;
        }

        function buildResourceId(actionId) {
            var appResId = '';

            if (SkApplication.instance()) {
                appResId = SkApplication.instance().getResourceID();
            }

            return StringUtils.substitute("{0}.actionconfig.{1}", appResId, actionId);
        }

        function saveLastValues(action, params) {
            if (SkApplication.instance()) {
                var config = {
                    params: {
                        param: []
                    }
                };

                for (var i = 0; i < params.length; i++) {
                    var param = params[i];

                    if (param.saveLast == 'true') {
                        config.params.param.push({
                            paramName: param.fieldName,
                            $: param.value
                        });
                    }
                }

                var resourceId = buildResourceId(action.actionID);

                _lastValuesCache[resourceId] = config.params;

                SkApplication.instance().saveMgeConfig(resourceId, config);
            }
        }

        function callExecJava(execSource) {
            ServiceProxy.callService('ActionButtonsSP.executeJava', {
                javaCall: execSource
            }).then(function () {
                afterExec(execSource, 'javaCall');
            });
        }

        function callExecScript(execSource) {
            ServiceProxy.callService('ActionButtonsSP.executeScript', {
                runScript: execSource
            }).then(function () {
                afterExec(execSource, 'runScript');
            });
        }

        function callExecProcedure(execSource) {
            ServiceProxy.callService('ActionButtonsSP.executeSTP', {
                stpCall: execSource
            }).then(function () {
                afterExec(execSource, 'dbCall');
            });
        }

        function callExecEmbedded(execSource) {
            ServiceProxy.callService('ActionButtonsSP.execEmbeddedAction', {
                embeddedCall: execSource
            }).then(() => afterExec(execSource))
              .catch(() =>afterExec(execSource));
        }

        function afterExec(execSource, actionSource) {
            var action = _callbacksById.get(execSource.actionID);
            
            if (action) {
                _callbacksById.remove(execSource.actionID);
                action();
            }
        }

        function launchScreen(action) {

            var resourceID = action.resourceID;

            if (resourceID) {
                var obj;

                var params = ObjectUtils.getProperty(action, 'actionConfig.params.param');

                if (params && params.length > 0) {
                    obj = {};

                    var processedParams = [];

                    for (var index in params) {
                        var p = params[index];

                        var localField = p.localField;
                        var targetField = p.targetField;

                        var value = angular.isDefined($rootScope.context) && angular.isFunction($rootScope.context.parameterGetter) ? StringUtils.emptyAsUndefined($rootScope.context.parameterGetter(resourceID, action.entityName, localField)) : undefined;

                        if (!value) {
                            var localFieldLabel = StringUtils.emptyAsUndefined($rootScope.context.parameterLabelGetter(resourceID, action.entityName, localField));

                            if (!localFieldLabel) {
                                localFieldLabel = localField;
                            }

                            throw new Error(`A ação "${ action.description }" não pôde ser executada porque o campo "${ localFieldLabel }" está vazio ou não existe.<br/>Favor verificar as configurações da ação.`);
                        }

                        obj[targetField] = value;

                        processedParams.push({
                            fieldName: targetField,
                            value: value
                        });
                    }

                    obj.ACTION_PARAMETERS = processedParams;
                    obj.call_time = Date.now();
                }

                SkApplication.instance().openApp(resourceID, obj);
            }
        }
}]);
/*
 *  Createad by Italo Araujo on 16/07/2018.
 */
angular
    .module('snk.components.agendamentos')
    .controller('SkConfigFrequenciaPanelController', ['$scope', 'StringUtils', 'MessageUtils', 'i18n',
        function ($scope, StringUtils, MessageUtils, i18n) {
            var self = this;
            var _horarioFieldBinder;
            var _diaMesFieldBinder;
            var _diaSemanaFieldBinder;
            var _mesesFieldBinder;

            //Variaveis
            self.times = [];
            self.meses = [
                { label: i18n('Commons.AgendamentoBase.lblJan'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblFev'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblMar'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblAbr'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblMai'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblJun'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblJul'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblAgo'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblSet'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblOut'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblNov'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblDez'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblTodos'), data: false, isAllBtn: true }
            ];

            self.diasSemana = [
                { label: i18n('Commons.AgendamentoBase.lblDomingo'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblSegunda'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblTerca'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblQuarta'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblQuinta'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblSexta'), data: false },
                { label: i18n('Commons.AgendamentoBase.lblSabado'), data: false },                
                { label: i18n('Commons.AgendamentoBase.lblTodos'), data: false, isAllBtn: true },
            ];


            //Funções "Públicas"
            self.getHorarios = getHorarios;
            self.setHorarios = setHorarios;
            self.getDiasMes = getDiasMes;
            self.setDiasMes = setDiasMes;
            self.getDiasSemana = getDiasSemana;
            self.setDiasSemana = setDiasSemana;
            self.getMesesAno = getMesesAno;
            self.setMesesAno = setMesesAno;
            self.setTime = setTime;
            self.hourChanged = hourChanged;
            self.mouthChanged = mouthChanged;
            self.dayMonthChanged = dayMonthChanged;
            self.dayWeekChanged = dayWeekChanged;
            self.diasMes = returnLabelDiasMes();
            self.addTime = addTime;
            self.removeTime = removeTime;
            self.clearTime = clearTime;
            self.selecionaFrequenciaDiaria = selecionaFrequenciaDiaria;
            self.getStyleContainerHr = getStyleContainerHr;
            self.getLblHorarios = getLblHorarios;
            self.getDayMonthStyle = getDayMonthStyle;

            $scope.$watch('dataset', (dataset) => {
                if(dataset){
                    _horarioFieldBinder = new FieldBinderProxy('HORARIO', $scope.dataset, getHorarios, setHorarios);
                    _diaMesFieldBinder = new FieldBinderProxy('DIAMES', $scope.dataset, getDiasMes, setDiasMes);
                    _diaSemanaFieldBinder = new FieldBinderProxy('DIASEMANA', $scope.dataset, getDiasSemana, setDiasSemana);
                    _mesesFieldBinder = new FieldBinderProxy('MES', $scope.dataset, getMesesAno, setMesesAno);

                    $scope.dataset.addLineChangeListener(changeLine);
                }
            });

            init();

            function init() {
                changeLine();
            }

            function changeLine() {

                var _ds = $scope.dataset;

                if (_ds && _ds.getFieldValue("DIAMES")) {
                    selecionaFrequenciaDiaria(2);
                } else if (_ds && _ds.getFieldValue("DIASEMANA")) {
                    selecionaFrequenciaDiaria(1);
                } else {
                    selecionaFrequenciaDiaria(0);
                }
            }

            function getHorarios() {
                var arr = [];
                self.times.map(function (time) {
                    if(angular.isDefined(time.data)){
                        arr.push(StringUtils.replaceAll(time.data.toString(), ':',''));
                    } 
                });

                arr.sort(function(a, b) {
                    return a - b;
                  });             
                return arr.join(',');
            }

            function setHorarios(value) {
                self.times = [];
                if (StringUtils.isEmpty(value)) {
                    setTime(0, undefined);
                } else {
                    var horarios = value.split(",");
                    for (var i = 0; i < horarios.length; i++) {
                        horarios[i] = StringUtils.replaceAll(horarios[i], ':','');
                        setTime(i, parseInt(horarios[i], 10));
                    }
                }
            }

            function getDiasMes() {
                var str = "";
                if (self.diasMes[32].data == true) {

                    self.diasMes.forEach(function (item, i) {
                        if (item.label != 'Todos') {
                            let itemLabel = item.label;
                            
                            if(i == 31){
                                if(item.data == false) return;
                                itemLabel = 0;
                            }
                            
                            str += (i > 0 ? "," : "") + itemLabel;
                        }
                    });

                    return str;
                }

                for (var i = 0; i < 32; i++) {
                    if (self.diasMes[i].data == true) {
                        str += (str.length > 0 ? "," : "") + ( i == 31 ? 0 : (i + 1) );
                    }
                }
                return str;
            }

            function setDiasMes(value) {
                if (StringUtils.isEmpty(value)) {
                    value = '';
                }
                var dias = value.split(",");

                self.diasMes.forEach(function (item) {
                    item.data = false;
                });

                if (dias.filter( (e, i) => e != '0' ).length == 31) {
                    self.diasMes[32].data = true;
                }

                if (Array.isArray(dias)) {
                    dias.forEach(function (item) {
                        if (!StringUtils.isEmpty(value) && !isNaN(parseInt(item))) {
                            let itemValue = parseInt(item);
                            self.diasMes[itemValue === 0 ? 31 : (itemValue - 1) ].data = true;
                        }
                    });
                }
            }

            function getDiasSemana() {
                if (self.diasSemana[7].data == true) {
                    return "1,2,3,4,5,6,7";
                }

                var str = "";
                for (var i = 0; i < 7; i++) {
                    if (self.diasSemana[i].data == true) {
                        str += (str.length > 0 ? "," : "") + (i + 1);
                    }
                }
                return str;
            }

            function setDiasSemana(value) {
                if (StringUtils.isEmpty(value)) {
                    value = '';
                }
                var diasemana = value.split(",");

                self.diasSemana.forEach(function (item) {
                    item.data = false;
                });

                if (diasemana.length == 7) {
                    self.diasSemana[7].data = true;
                }

                if (Array.isArray(diasemana)) {
                    diasemana.forEach(function (item) {
                        if (!StringUtils.isEmpty(value)) {
                            self.diasSemana[parseInt(item) - 1].data = true;
                        }
                    });
                }
            }

            function getMesesAno() {
                if (self.meses[12].data === true) {
                    return "1,2,3,4,5,6,7,8,9,10,11,12";
                }

                var str = "";
                for (var i = 0; i < 12; i++) {
                    if (self.meses[i].data == true) {
                        str += (str.length > 0 ? "," : "") + (i + 1);
                    }
                }

                return str;
            }

            function setMesesAno(value) {
                if (StringUtils.isEmpty(value)) {
                    value = '';
                }

                var meses = value.split(",");

                self.meses.forEach(function (item) {
                    item.data = false;
                });

                if (meses.length == 12) {
                    self.meses[12].data = true;
                }
                if (Array.isArray(meses)) {
                    meses.forEach(function (item) {
                        if (!StringUtils.isEmpty(value) && !StringUtils.isEmpty(item)) {
                            var idx = parseInt(item) - 1;
                            if (!isNaN(idx) && idx >= 0 && idx < 12 && self.meses[idx] !== undefined) {
                                self.meses[idx].data = true;
                            }
                        }
                    });
                }
            }

            function setTime(index, value) {
                if (!angular.isDefined(self.times)) {
                    self.times = [];
                }
                if (index >= self.times.length) {
                    self.times.push({ index: index, data: value?.toString().padStart(4, '0'), label: getLabelTime(index) });
                } else {
                    self.times[index].data = value;
                }
            }

            function hourChanged() {
                _horarioFieldBinder.modify();
            }

            function mouthChanged(mudouTodos) {
                var todos = true;
                for (var i = 0; i < 12; i++) {
                    if (mudouTodos) {
                        self.meses[i].data = self.meses[12].data;
                    } else {
                        todos = todos && self.meses[i].data;
                    }
                }
                if (!mudouTodos) {
                    self.meses[12].data = todos;
                }
                _mesesFieldBinder.modify();
            }

            function dayMonthChanged(diaMes) {
                let mudouTodos = diaMes.isAllBtn;
                var todos = true;
                for (var i = 0; i < 32; i++) {
                    
                    if(i == 31) continue;

                    if (mudouTodos) {
                        self.diasMes[i].data = self.diasMes[32].data;
                    } else {
                        todos = todos && self.diasMes[i].data;
                    }
                }
                if (!mudouTodos) {
                    self.diasMes[32].data = todos;
                }
                _diaMesFieldBinder.modify();
            }

            function dayWeekChanged(mudouTodos) {
                var todos = true;
                for (var i = 0; i < 7; i++) {
                    if (mudouTodos) {
                        self.diasSemana[i].data = self.diasSemana[7].data;
                    } else {
                        todos = todos && self.diasSemana[i].data;
                    }
                }
                if (!mudouTodos) {
                    self.diasSemana[7].data = todos;
                }

                _diaSemanaFieldBinder.modify();
            }

            function getLabelTime(order) {
                return (order + 1) + i18n('Commons.AgendamentoBase.lblExecucao');
            }

            function returnLabelDiasMes() {
                var arrayDia = [];
                for (i = 1; i <= 31; i++) {
                    arrayDia.push({ label: i, data: false });
                }
                arrayDia.push({ label: i18n('Último dia'), data: false, isLastDay: true });
                arrayDia.push({ label: i18n('Commons.AgendamentoBase.lblTodos'), data: false, isAllBtn: true });

                return arrayDia;
            }

            function addTime(time) {
                var newIndex = time.length + 1;
                if (newIndex > self.times.length) {
                    self.times.push({ index: newIndex, data: undefined, label: getLabelTime(time.length) });
                }
            }



            function selecionaFrequenciaDiaria(value) {
                if (value == 0) {
                    self.selectedIndex = 0;
                } else if (value == 1) {
                    self.selectedIndex = 1;
                } else if (value == 2) {
                    self.selectedIndex = 2;
                }
            }

            function removeTime(time) {
                var index = time;
                if (index > 0) {
                    self.times.splice(index, 1);
			        var tempArray = [];
                    for (let index = 0; index < self.times.length; index++) {
                        tempArray.push({ index: index, data: self.times[index].data, label: getLabelTime(index) });
                    }
			        self.times = tempArray;
                }
                _horarioFieldBinder.modify();
            }

            function clearTime(time) {
                var index = time.length;
                self.times.splice(1, index);

                if (self.times.length > 0) {
                    self.times[0].data = "";
                }
                _horarioFieldBinder.modify();
            }

            function getStyleContainerHr(){
                return { 'width': ($scope.compactMode ? '250px' : '400px')  }
            }

            function getLblHorarios(){
                return i18n('Commons.AgendamentoBase.labelHorarios') + ':';
            }

            function getDayMonthStyle(day){
                if(day.isLastDay){
                    return { 'padding-left' : '2px'};
                }else{
                    return { 'padding-left' : '5px'};
                }
            }

        }]);

angular
    .module('snk.components.agendamentos')
    .directive('skConfigFrequenciaPanel', [function () {
    return {
        templateUrl: 'components/agendamentos/config-frequencia-panel.tpl.html',
        controller: 'SkConfigFrequenciaPanelController',
        controllerAs: 'ctrl',
        scope: {
            dataset: '=?skDataset',
            tipoagendamento: '=?skTipoAgendamento',
            compactMode: '=?skCompactMode'
        }
    };

}]);

angular
    .module('snk.components.aggrid')
    .controller('skAgGridController', ['i18n','$scope',
        function (i18n, $scope) {

            init();
            function init() {

                if (angular.isUndefined($scope.gridOptions)) {
                    throw Error("sk-grid-options não foi informado");
                }

                $scope.gridOptions.localeText = getlocaleText();

                $scope.gridOptions.showToolPanel = false;

                $scope.gridOptions.allowContextMenuWithControlKey = false;
                
                if (angular.isUndefined($scope.themeGrid)) {
                    $scope.themeGrid = 'ag-theme-fresh sk-aggrid sk-datagrid-container';
                }
            }

            function getlocaleText() {
                return {
                    loadingOoo: i18n('DataGrid.stateTextCarregando'),
                    noRowsToShow: i18n('DataGrid.noRowsToShow'),
                    autosizeAllColumns: i18n('DataGrid.autosizeAllColumns'),
                    expandAll: i18n('DataGrid.expandAll'),
                    collapseAll: i18n('DataGrid.collapseAll'),
                    export: i18n('DataGrid.export'),
                    csvExport: i18n('DataGrid.export') + ' CSV',
                    excelExport: i18n('DataGrid.export') + ' Excel'
                };
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.accordion.directive:sk-ag-grid
 * @restrict E
 * @scope
 * @description
 * Informação de como utilizar https://www.ag-grid.com/documentation-main/documentation.php
 *
 * @param {array} [sk-grid-options=undefined] A propriedades da grid https://www.ag-grid.com/javascript-grid-properties/
 * @param {String} [sk-theme-grid="ag-theme-fresh"] Temas suportados ag-theme-dark, ag-theme-fresh, 
 * ag-theme-blue, ag-theme-material, ag-theme-bootstrap.
 *
 * @example
 <example module="app">
     <file name="app.html">
        <div ng-controller="MyController" style=" height: 250px;">  
            <sk-ag-grid sk-grid-options="gridOptions" flex></sk-ag-grid>
        </div>
     </file>

    <file name="aggrid.js">

    // Não é necessario inserir esse trecho
    //  INICIO
      agGrid.LicenseManager.setLicenseKey("Sankhya_Gestao_de_Negocios_Sankhya-W_2Devs2_February_2019__MTU0OTA2NTYwMDAwMA==7b972093aed5428ec5f957e0c608047c");
      agGrid.initialiseAgGridWithAngular1(angular);
    //  FIM
    
    angular
        .module('app',['snk'])
        .controller('MyController', function($scope){

            var columnDefs = [
                {headerName: "Make", field: "make"},
                {headerName: "Model", field: "model"},
                {headerName: "Price", field: "price"}
            ];

            var rowData = [
                {make: "Toyota", model: "Celica", price: 35000},
                {make: "Ford", model: "Mondeo", price: 32000},
                {make: "Porsche", model: "Boxter", price: 72000}
            ];

            $scope.gridOptions = {
                columnDefs: columnDefs,
                rowData: rowData
            };

        });
    </file>
 </example>
 */
angular.module('snk.components.aggrid')
    .directive('skAgGrid', function () {
        var ddo = {};

        ddo.restrict = 'E';
        ddo.template = '<div ag-grid="gridOptions" class="{{::themeGrid}}" style="height: 100%; width: 100%;"/>';

        ddo.scope = {
            gridOptions: '=skGridOptions',
            themeGrid:'@?skThemeGrid'
        };

        ddo.controller = 'skAgGridController';

        return ddo;
    });

/**
 * Created by bruno.brandao on 31/03/2016.
 */
angular
    .module('snk.components.applet')
    .service('AppletUtil', ['UrlUtils', 
    function(UrlUtils) {
        
        var self = this;
        self.validateAppletRunning = validateAppletRunning;

        function validateAppletRunning(appletID){
            var applet = document.getElementById(appletID);

            try{
                if(applet){
                    return applet.validaVersaoJava();
                }
            }catch(e){}

            return false;
        }

    }]);
/*
 * Author: Cleverson Puche
 */

angular
    .module('snk.components.attach')
    .controller('SkAttachController',['$scope', '$timeout', 'DatasetUtils', 'StringUtils', 'ServiceProxy', 'MGEAuthorizationService', 'MGEAuthorizationConstants', 'MessageUtils', 'SkI18nService', 'UrlUtils', 'UserAgentUtils', 'SkApplicationInstance','i18n','SanPopup', 'DateUtils',
        function($scope, $timeout, DatasetUtils, StringUtils, ServiceProxy, MGEAuthorizationService, MGEAuthorizationConstants, MessageUtils, SkI18nService, UrlUtils, UserAgentUtils, SkApplicationInstance,i18n,SanPopup, DateUtils) {
            var self = this;

            var _canEdit = true;
            var _canInsert = true;
            var _canRemove = true;
            var _isAlteracao = false;

            var _externalCallbackName;

            var _codata = $scope.codAta;
            var _codemp = $scope.codEmp;
            var _sequencia = $scope.sequencia || 0;
            var _tipoAnexo = $scope.tipo;
            
            var _dpOpcoes = [
                { label:  SkI18nService.instant('Attach.adicionarArquivoLocal'), action: lancaPopUpInclusaoAlteracao } ,
                { label:  SkI18nService.instant('Attach.adicionarArquivoRepositorio'), action: openPopUpInclusaoAlteracaoArqRepositorio },                
                { label:  SkI18nService.instant('Attach.adicionarLink'), action: function () {
                    openPopUpInclusaoAlteracaoArqRepositorio(null,false) }
                }
            ];

            var _dataAttach = (_codata || _codemp || _sequencia || _tipoAnexo) ? undefined : $scope.dataAttach;

            const LOAD   = "mge@Attach.load";
            const REMOVE = "mge@Attach.remove";
            const VIEW   = "mge@Attach.view";

            $scope.visualizaMultiplos = visualizaMultiplos;
            $scope.onDatasetCreated = onDatasetCreated;
            $scope.removeAction = removeAction;
            $scope.alterarItem = alterarItem;
            $scope.openPopUpInclusaoAlteracao = openPopUpInclusaoAlteracao;
            $scope.viewAction = viewAction;
            $scope.enableButtons = enableButtons;
            $scope.onDatagridLoaded = onDatagridLoaded;
            $scope.selectLines = selectLines;
            $scope.otherOptionsLoader = otherOptionsLoader;
            $scope.btnClick=btnClick;
            $scope.formatDate = formatDate;

            $scope.btnNewEnabled = true;
            self.setCodata = setCodata;
            self.setCodemp = setCodemp;
            self.setSequencia = setSequencia;
            self.setTipoAnexo = setTipoAnexo;
            self.setDataAttach = setDataAttach;

            self.getCodata = getCodata;
            self.getCodemp = getCodemp;
            self.getSequencia = getSequencia;
            self.getTipoAnexo = getTipoAnexo;

            self.loadAction = loadAction;
            self.updateDataset = updateDataset;

            $timeout(function() {
                init();
            }, 0, false);

            function init() {
                _tipoAnexo = $scope.tipo;

                _externalCallbackName = "loadAttach_" + StringUtils.nextUid();

                if (UserAgentUtils.isElectron()) {
                    SkApplicationInstance.registerExternalCall(_externalCallbackName, loadAction);
                } else {
                    window[_externalCallbackName] = loadAction;
                }

                if($scope.resourceID) {
                    MGEAuthorizationService.loadAuthorization($scope.resourceID).then(function(authData) {
                        _canEdit = authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE);
                        _canInsert = authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT);
                        _canRemove = authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE);
                    });
                }

                if(angular.isFunction($scope.onCreated)){
                    $scope.onCreated({attach: self});
                }

                if (angular.isUndefined($scope.showBtnAdd)) {
                    $scope.showBtnAdd = true;
                }

                if (angular.isUndefined($scope.showBtnRemove)) {
                    $scope.showBtnRemove = true;
                }

                if (angular.isUndefined($scope.showBtnEdit)) {
                    $scope.showBtnEdit = true;
                }
            }

            function onDatasetCreated(dataset) {
                $scope.dsAttach = dataset;
                $scope.dsAttach.loadAction = loadAction;

                if ($scope.codAtaHeaderText) {
                    $scope.dsAttach.setUserFieldMDInterceptor(function(field){
                       if (field.name == 'CODATA') {
                           field.description = $scope.codAtaHeaderText;
                       }
                    });
                }

                $scope.dsAttach.addInsertionModeListener(function(){
                    if ($scope.showBtnAdd) {
                        openPopUpInclusaoAlteracao();
                    }
                });

                dataset.initializeDataSet();
            }

            function visualizaMultiplos() {
                if($scope.visualizaMultiplosAnexos) {
                    return true;
                }

                return false;
            }

            function loadAction() {
                var criteria = {};

                if(!_dataAttach || _dataAttach.length <= 0) {
                    criteria.codata = getCodata();
                    criteria.codemp = getCodemp();
                    criteria.sequencia = getSequencia();
                    criteria.tipoAnexo = getTipoAnexo();
                } else {
                    criteria.criterium = [];
                    _dataAttach.forEach(function(obj, idx) {
                        criteria.criterium.push({
                            codata: obj.codata,
                            codemp: obj.codemp,
                            tipoAnexo: obj.tipoAnexo
                        });

                        if(obj.sequencia) {
                            criteria.criterium[idx].sequencia = obj.sequencia;
                        }
                    })
                }

                var request = {
                    criteria: criteria
                };

                ServiceProxy.callService(LOAD,request).then(function(result) {
                    if(result.responseBody && result.responseBody.anexos) {
                        updateDataset(result.responseBody.anexos);
                    } else {
                        updateDataset();
                    }
                })
            }

            function updateDataset(data) {
                $scope.dsAttach.clearDataSet();

                if(!data || !data.anexo) {
                    return;
                }

                $scope.dsAttach.whenMetadataLoaded().then(function () {
                	$scope.dsAttach.addRecordsAsObjects(data.anexo);
                    $scope.dsAttach.gotoRow(0);
                });
            }

            function getOnlyFieldName(fullName) {
                var splitedName = fullName.split('.');
                return splitedName[splitedName.length - 1];
            }

            function removeAction() {
                if(_canRemove) {
                    var currentRecord = $scope.dsAttach.getCurrentRowAsObject("DESCRICAO");
                    if(currentRecord) {
                        MessageUtils.showAlertWithConfirm(
                            SkI18nService.instant('Attach.msgExclusaiAnexo'),
                            SkI18nService.instant('Attach.msgConfirmExclusaoAnexo')
                        ).then(function() {
                            var request = {
                                anexo: {
                                    codata: getCodata(),
                                    codemp: getCodemp(),
                                    sequencia: getSequencia(),
                                    tipo: getTipoAnexo(),
                                    descricao: currentRecord.DESCRICAO
                                }
                            };

                            ServiceProxy.callService(REMOVE,request).then(function(result) {
                                loadAction();
                            });
                        });
                    }
                } else {
                    MessageUtils.showAlert(
                        SkI18nService.instant('Attach.msgControleAcesso'),
                        SkI18nService.instant('Attach.verificarPermissaoAcesso')
                    );
                }
            }

            function alterarItem() {
                var selectedItem = $scope.dsAttach.getCurrentRowAsObject("CODATA,DESCRICAO,EHARQUIVOREPOSITORIO,LINK");
                if(angular.isUndefined(selectedItem)) {
                    return;
                }

                _isAlteracao = true;
                
                if(selectedItem.EHARQUIVOREPOSITORIO && selectedItem.EHARQUIVOREPOSITORIO == 'S') {
                    openPopUpInclusaoAlteracaoArqRepositorio(selectedItem, true);
                } else if (!StringUtils.isEmpty(selectedItem.LINK)) {
					openPopUpInclusaoAlteracaoArqRepositorio(selectedItem, false);    
                } else {
                    openPopUpInclusaoAlteracao(selectedItem);
                }

                _isAlteracao = false;
            }

            function openPopUpInclusaoAlteracaoArqRepositorio(selectedItem = null, isRepositorio= true) {
              
                var permitirAnexo=true;

                if(angular.isFunction($scope.permitirAnexoDoRepositorio)){
                    permitirAnexo= $scope.permitirAnexoDoRepositorio();
                }

                if(permitirAnexo){
                    if((selectedItem == null && _canInsert) || (selectedItem != null && _canEdit)){					
                        var id = null;
                        if(isRepositorio){
                            id = "br.com.sankhya.projeto.anexosRepositorio";
                        }else{
                            id = "br.com.sankhya.projeto.anexoLink";
                        }
                        if($scope.dsAttach){                       
                            isRepositorio ?  PopUpAnexosRepositorio() :  PopUpAnexoLink()
                        }                   
                    } 
                }  

            }

            function openPopUpInclusaoAlteracao(selectedItem) {
                
                var permitirAnexo=true;

                if(angular.isFunction($scope.permitirAnexoDoRepositorio)){
                    permitirAnexo= $scope.permitirAnexoDoRepositorio();
                }

                if(permitirAnexo){
                    if((!selectedItem && _canInsert) || (selectedItem && _canEdit)) {
                    
                        var closeScript;
    
                        if (UserAgentUtils.isElectron()) {
                            var resourceID = SkApplicationInstance.getResourceID();
                            closeScript = "try {var ipc = require('electron').ipcRenderer; ipc.send('uploadFile', {'resourceID':'" + resourceID + "', 'callbackName': '" + _externalCallbackName + "'});}catch(error){alert(error.message);}";
                        } else {
                            closeScript = 'window.opener.' + _externalCallbackName + '();';
                        }
                        
                        var url = "/mge/uploadAnexo.mge?acao=carregar&closeScript=" + closeScript;
                        url = url + "&codata=" + getCodata();
                        if (getCodemp()) {
                            url = url + "&codemp=" + getCodemp();
                        };
                        
                        url = url + "&sequencia=" + getSequencia();
                        url = url + "&tipo=" + getTipoAnexo();
                        if(selectedItem){
                            url = url + "&descricao=" + selectedItem.DESCRICAO;
                            url = url + "&isEdit=true";
                        }
    
                        var height = 180;
                        if(UserAgentUtils.isSafari()) {
                            height = 220;
                        }
                        $timeout(function() {
                            window.open(url,'_blank','width=430,height=' + height + ',resizable=no,scrollbars=yes');
                        }, 0, false);
                    } else if(!selectedItem) {
                        MessageUtils.showAlert(
                            SkI18nService.instant('Attach.msgControleAcesso'),
                            SkI18nService.instant('Attach.NaoehPossivelInserirRecord')
                        );
                    } else {
                        MessageUtils.showAlert(
                            SkI18nService.instant('Attach.msgControleAcesso'),
                            SkI18nService.instant('Attach.NaoEhPossivelFazerAlteracoes')
                        );
                    }
                }

                
            }

            function viewAction(visualizarSelecionados) {
                var selectedItem = $scope.dsAttach.getCurrentRowAsObject();
                if(!selectedItem && (!$scope.dsAttach.getSelectedRecords() || $scope.dsAttach.getSelectedRecords().length == 0)) {
                    MessageUtils.showError(
                        MessageUtils.TITLE_ERROR,
                        SkI18nService.instant('Attach.ehNecessarioSelectFile')
                    );
                    return;
                }
                var ehArquivoRepositorio = selectedItem.EHARQUIVOREPOSITORIO;
                if(ehArquivoRepositorio == 'S') {
                    var request = {
                        config: {
                            path: selectedItem.ARQUIVO,
                            tipoconteudo: selectedItem.TIPOCONTEUDO
                        }
                    }
                    ServiceProxy.callService("mge@RepositorioArquivoSP.abreArquivo",request).then(function(result) {
                        var chave = result.responseBody.chave.valor;
                        lancaJanelaAnexo(chave, '_blank', selectedItem.ARQUIVO);
                    })
                    return;
                }
                var criteria = {
                    anexos: {}
                };
                if(visualizarSelecionados) {
                    var anexos = [];
                    var selectedItems = $scope.dsAttach.getSelectedRecordsAsObjects();
                    for (item of selectedItems) {
                        let anexo = {
                            codata: item.CODATA,
                            codemp: item.CODEMP,
                            sequencia: item.SEQUENCIA,
                            tipo: item.TIPO,
                            descricao: item.DESCRICAO,
                            tipoConteudo: item.TIPOCONTEUDO
                        };

                        anexos.push(anexo);

                        if (item.TEMCONTEUDO != "S") {
                            
                        }
                    }

                    if (anexos.length > 0) {
                        criteria.anexos = {anexo: anexos};
                    } else {
                        criteria = {
                            anexo: {
                                codata: getCodata(),
                                codemp: getCodemp(),
                                sequencia: getSequencia(),
                                tipo: getTipoAnexo(),
                                descricao: selectedItem.DESCRICAO,
                                tipoConteudo: selectedItem.TIPOCONTEUDO
                            }
                        }
                    }
                } else {
                    if(!selectedItem.DESCRICAO) {
                        return;
                    }
                    var descricao = selectedItem.DESCRICAO;
                    criteria = {
                        anexo: {
                            codata: getCodata(),
                            codemp: getCodemp(),
                            sequencia: getSequencia(),
                            tipo: getTipoAnexo(),
                            descricao: descricao,
                            tipoConteudo: selectedItem.TIPOCONTEUDO
                        }
                    }
                    if(selectedItem.TEMCONTEUDO != 'S') {
                        if(!StringUtils.isEmpty(selectedItem.LINK)){
                            var link = StringUtils.trim(selectedItem.LINK);
                            if(link.indexOf("http") != 0) {
                                link = "http://" + link;
                            }
                            
                            window.open(link, '_blank');
                            return;
                        }
                    }
                }

                ServiceProxy.callService(VIEW,criteria).then(function(result) {
                    if(result.responseBody.chaveAnexo) {
                        var chave = result.responseBody.chaveAnexo.idChaveAnexo;
                        var tipoConteudo = result.responseBody.chaveAnexo.tipoConteudo;
                        lancaJanelaAnexo(chave, '_blank', selectedItem.ARQUIVO);
                    } else {
                        var i = 0;
                        var chavesAnexos = result.responseBody.chavesAnexos.chaveAnexo;
                        if(!Array.isArray(chavesAnexos))
                        {
							chavesAnexos=[chavesAnexos]; 
						}
                        chavesAnexos.forEach(function(anexo) {
                            var chave = anexo.idChaveAnexo;
                            var tipoConteudo = anexo.tipoConteudo;
                            lancaJanelaAnexo(chave, i, selectedItem.ARQUIVO);
                            i++;
                        });
                    }
                });
            }

            function lancaJanelaAnexo(chave, janela, arquivo) {
                url = UrlUtils.getUrlBase() + '/mge/visualizadorArquivos.mge?chaveArquivo=' + chave;
                if (!isPdf(arquivo)) {
                    url = url + "&forcarDownload=S";
                }
                window.open(url, janela);
            }

            function isPdf (arquivo) {
                return angular.isDefined(arquivo) && arquivo.substr(arquivo.lastIndexOf(".")).toLowerCase() == ".pdf";
            }

            function setCodata(codata) {
                _codata = codata;
                _dataAttach = undefined;
            }

            function setCodemp(codemp) {
                _codemp = codemp;
                _dataAttach = undefined;
            }

            function setSequencia(sequencia) {
                _sequencia = sequencia;
                _dataAttach = undefined;
            }

            function setTipoAnexo(tipo) {
                _tipoAnexo = tipo;
                _dataAttach = undefined;
            }

            function setDataAttach(dataAttach) {
                _dataAttach = dataAttach;
                _codata = undefined;
                _codemp = undefined;
                _tipoAnexo = undefined;
            }

            function getCodata() {
                if(!$scope.dataAttach && _codata != undefined) {
                    return _codata;
                }
                if(StringUtils.isNotEmpty($scope.codAta)) {
                    return $scope.codAta;
                }

                return $scope.dsAttach.getCurrentRowAsObject("CODATA")?.CODATA;
            }

            function getCodemp() {
                if(!$scope.dataAttach && _codemp != undefined) {
                    return _codemp;
                }

                return $scope.dsAttach.getCurrentRowAsObject("CODEMP")?.CODEMP;
            }

            function getSequencia() {
                if(!$scope.dataAttach) {
                    return _sequencia;
                }

                return $scope.dsAttach.getCurrentRowAsObject("SEQUENCIA").SEQUENCIA;
            }

            function getTipoAnexo() {
                if(!$scope.dataAttach && _tipoAnexo != undefined) {
                    return _tipoAnexo;
                }
                if(StringUtils.isNotEmpty($scope.tipo)) {
                    return $scope.tipo;
                }

                return $scope.dsAttach.getCurrentRowAsObject("TIPO")?.TIPO;
            }
            
            function enableButtons() {
                return angular.isDefined($scope.dsAttach.getCurrentRowAsObject());
            }

            function selectLines(select) {
                if (select) {
                    self.gridAttach.selectAllRecords();
                } else {
                    $scope.dsAttach.setSelectedRecords([]);
                    self.gridAttach.refreshView();
                }
            }

            function onDatagridLoaded(datagrid) {
				self.gridAttach = datagrid;
			};

            function otherOptionsLoader() {
                return _dpOpcoes;
            }

            function lancaPopUpInclusaoAlteracao() {
                openPopUpInclusaoAlteracao();
            }
            
            function PopUpAnexosRepositorio() {
               SanPopup.open({
                    title: SkI18nService.instant('Attach.tituloPopUpAdicionarLink'),                 
                    templateUrl: "commons/attach/PopUpAnexosRepositorio.tpl.html",
                    controller: 'PopUpAnexosRepositorioController',
                    controllerAs: 'ctrl',                   
                    showBtnOk: false,
                    cancelBtnLabel: i18n('Geral.buttonFechar'),
                    height:200, 
                    width:430,                                 
                    resolve: {
                        dataValue: {
                            TIPO: $scope.dsAttach.getFieldValue("TIPO") ? $scope.dsAttach.getFieldValue("TIPO") : (_dataAttach ? _dataAttach[0].tipoAnexo : _tipoAnexo),
                            CODATA: $scope.dsAttach.getFieldValue("CODATA")? $scope.dsAttach.getFieldValue("CODATA") : (_dataAttach ? _dataAttach[0].codata : _codata),
                            SEQUENCIA: $scope.dsAttach.getFieldValue("SEQUENCIA") ? $scope.dsAttach.getFieldValue("SEQUENCIA") : _sequencia,
                            TARGET_ATTATCH: $scope.dsAttach,
                            DESCRICAO: $scope.dsAttach.getFieldValue("DESCRICAO") && _isAlteracao ? $scope.dsAttach.getFieldValue("DESCRICAO") : null,
                            ARQUIVO: $scope.dsAttach.getFieldValue("ARQUIVO") && _isAlteracao ? $scope.dsAttach.getFieldValue("ARQUIVO") : null
                        }
                    }
                });               
            }

            function PopUpAnexoLink() {                
                SanPopup.open({
                    title: SkI18nService.instant('Attach.tituloPopUpAdicionarLink'),                 
                    templateUrl: "commons/attach/PopUpAnexoLink.tpl.html",
                    controller: 'PopUpAnexoLinkController',
                    controllerAs: 'ctrl',                  
                    showBtnOk: false,
                    cancelBtnLabel: i18n('Geral.buttonFechar'),
                    height:200, 
                    width:430,                                   
                    resolve: {
                        dataValue: {
                            TIPO: $scope.dsAttach.getFieldValue("TIPO") ? $scope.dsAttach.getFieldValue("TIPO") : (_dataAttach ? _dataAttach[0].tipoAnexo : _tipoAnexo),
                            CODATA: $scope.dsAttach.getFieldValue("CODATA") ? $scope.dsAttach.getFieldValue("CODATA") : (_dataAttach ? _dataAttach[0].codata: _codata),
                            SEQUENCIA: $scope.dsAttach.getFieldValue("SEQUENCIA") ? $scope.dsAttach.getFieldValue("SEQUENCIA") : _sequencia,
                            TARGET_ATTATCH: $scope.dsAttach,
                            DESCRICAO: $scope.dsAttach.getFieldValue("DESCRICAO") && _isAlteracao ? $scope.dsAttach.getFieldValue("DESCRICAO") : null,
                            ARQUIVO: $scope.dsAttach.getFieldValue("ARQUIVO") && _isAlteracao ? $scope.dsAttach.getFieldValue("ARQUIVO") : null
                        }
                    }
                });   
            }  

            function btnClick($event){
                lancaPopUpInclusaoAlteracao();
            }

            function formatDate(col, value, record) {
                return DateUtils.formatDate(value, 'DD/MM/YYYY HH:mm');
            }
        }
    ])

/*
 * Author: Cleverson Puche
 */

/**
 * @ngdoc directive
 * @name snk.components.attach.directive:sk-attach
 * @restrict E
 * @scope
 * @description
 Componente de anexo que não se baseia em nenhuma entidade

 * @param {string} skCodAta Description
 * @param {string} skSequencia Description
 * @param {boolean} skTipo Description
 * @param {string} skDataAttach Description
 * @param {function} skResourceId Description
 * @param {function} skReadOnly Description
 * @param {string} skVisualizaMultiplosAnexos Description
 * @param {string} skShowCodAta Description
 * @param {string} skCodAtaHeaderText Description
 * @param {function} skPermitirAnexoDoRepositorio Description
 * @param {boolean} skMostrarAnexoDropdown mostra opcao de dropDownMenu
 */
angular
    .module('snk.components.attach')
    .directive('skAttach',[function() {
        return {
            templateUrl: 'components/attach/attach.tpl.html',
            restrict: 'E',
            controller: 'SkAttachController',
            scope: {
                codAta: '@?skCodAta',
                sequencia: '@?skSequencia',
                tipo: '@?skTipo',
                dataAttach: '=?skDataAttach',
                resourceID: '@?skResourceId',
                readOnly: '=?skReadOnly',
                visualizaMultiplosAnexos: '=?skVisualizaMultiplosAnexos',
                showCodAta: '=?skShowCodAta',
                codAtaHeaderText: '@?skCodAtaHeaderText',
                permitirAnexoDoRepositorio: '=?skPermitirAnexoDoRepositorio',
                mostrarAnexoDropdown: '=?skMostrarAnexoDropdown',
                onCreated: '&skOnCreated', 
                tooltipPlacement: '@?skTooltipPlacement',
                showBtnAdd: '=?skShowBtnAdd',
                showBtnRemove: '=?skShowBtnRemove',
                showBtnEdit: '=?skShowBtnEdit'
            },
            transclude: {
                'leftContainer': '?leftContainer',
            },
            link: linker
        }

        function linker(scope, element, attrs, controller) {
            if (attrs.id) {
                scope.$parent[attrs.id] = controller;
            }
            scope.mostrarAnexoDropdown = angular.isDefined(scope.mostrarAnexoDropdown) ? scope.mostrarAnexoDropdown : false;
        }

    }]);
/**
 * Created by bruno.brandao on 31/03/2016.
 */
angular
    .module('snk.components.attach')
    .service('Attach', ['ServiceProxy', 'UrlUtils', '$window', 
    function(ServiceProxy, UrlUtils, $window) {
        
        var self = this;
        self.visualizaAnexo = visualizaAnexo;

        function visualizaAnexo(entityName, pk, contentField, nameField){
	
            var params = {attach : {} };
            
			params.attach.entityName = entityName;
			params.attach.contentField = contentField;
            
            if(nameField){
				params.attach.nameField = nameField;
            }
            
            var pkObj = {};
            
			for(var pkField in pk){
				pkObj[pkField] = { $: pk[pkField] };
            }
            
			params.attach.pk = pkObj;

			ServiceProxy.callService(
				"mge@AnexosSP.carregaAnexo",
				params
			).then(function(result){
                var chave = result.responseBody.chaveAnexo.valor.toString();
                var url = UrlUtils.getUrlBase() + "/mge/visualizadorArquivos.mge?chaveArquivo=" + chave;
                $window.open(url, '_blank','width=200,height=200');
            });
		}

    }]);
angular
  .module('snk.components.banner')
  .controller('skBannerController', [function () {
    var self = this;
    
    self.executarAcao = function () {
      if (angular.isFunction(self.skAction)) {
        self.skAction();
      }
    };
  }]);
/**
 * @ngdoc directive
 * @name snk.components.sk-banner.directive:sk-banner
 * @restrict E
 *
 * @description
 *  Componente de banner customizado, utilizado para exibir mensagens de destaque
 *  com contexto de sucesso ou erro, conforme o tipo informado via atributo.  
 *  O banner apresenta um ícone, mensagem de texto e um botão configurável para ação.
 *
 *  O tipo do banner define a cor e o estilo visual do componente.
 *  Os textos são configuráveis via atributos, permitindo integração com i18n.
 *
 * @param {string} sk-type Tipo do banner: **'success'** ou **'alert'**.
 * @param {string} sk-text Chave de tradução para o texto principal do banner.
 * @param {string} sk-action-label Chave de tradução para o texto do botão de ação.
 * @param {function} sk-action Função executada ao clicar no botão de ação.
 *
 * @example
   <example module="app">
     <file name="bannerExample.html">
       <sk-banner 
         sk-type="success"
         sk-text="Financeiro.BoletoRapido.bannerAdquirirText"
         sk-action-label="Financeiro.BoletoRapido.bannerAdquirirButton"
         sk-action="ctrl.abrirContratacao()">
       </sk-banner>
     </file>
     <file name="app.js">
       angular.module('app', ['snk']);
     </file>
   </example>
 */
   angular
   .module('snk.components.banner')
   .directive('skBanner', [
     function () {
       return {
         restrict: 'E',
         templateUrl: 'components/banner/banner.tpl.html',
         controller: 'skBannerController',
         controllerAs: 'ctrl',
         bindToController: true,
         scope: {
           skType: '@skType',
           skText: '@skText',
           skActionLabel: '@skActionLabel',
           skAction: '&skAction'
         },
         link: function (scope, element, attrs, ctrl) {
           var allowedTypes = ['success', 'alert'];
           if (!allowedTypes.includes(ctrl.skType)) {
             console.error(
               `[sk-banner] Tipo inválido: "${ctrl.skType}". Os tipos aceitos são: 'success' ou 'alert'.`
             );
           }
         },
         compile: function ($element, attr) {
           var zIndex = attr.zIndex;
           if (!zIndex) {
             zIndex = '1000';
           }
           $element.css('z-index', zIndex);
         }
       };
     }
   ]);
/**
 * @ngdoc directive
 * @name snk.components.box.directive:hbox
 * @restrict E
 * @description
     Componente de agrupamento horizontal, semelhante ao do Flex
 * @param {int} gap Distância horizontal entre os componentes inseridos no HBox.
 * @param {function} sk-onload Função que é executada assim que cria o componente, ou seja, no post link da diretiva. Esse evento pode receber $event como parametro e nele tem o target que disparou o evento.
 * @param {boolean} button-container Caso informado o box pegará a cor de uma barra de botões e acionará o gap padrão, caso o gap não tenha sido informado.
 * @example
     <example module="hboxExample">
         <file name="hboxExample.html">
            <!-- Neste caso, sk-margin não é um parâmetro de sk-hbox, e sim, uma outra diretiva que pode ser usada como atributo -->
            <div ng-controller="Teste as ctrl">
                <sk-hbox gap="10" sk-padding="20" sk-onload="ctrl.onLoadBox($event)">
                    <span>First</span>
                    <span>Second</span>
                    <span>Third + {{ ctrl.label  }}</span>
                </sk-hbox>
            </div>
         </file>
         <file name="hboxExample.js">
            angular
                .module('hboxExample', ['snk'])
                .controller('Teste', function(){
                    var self = this;

                    self.onLoadBox = onLoadBox;
                    self.label = 'carregando';

                    function onLoadBox($event) {
                        self.label = 'carregado';                        
                    } 
                });
         </file>
     </example>
 */

/**
 * @ngdoc directive
 * @name snk.components.box.directive:vbox
 * @restrict E
 * @description Componente de agrupamento vertical, semelhante ao do Flex
 * @param {int} gap Distância vertical entre os componentes inseridos no VBox.
 * @param {function} sk-onload Função que é executada assim que cria o componente, ou seja, no post link da diretiva. Esse evento pode receber $event como parametro e nele tem o target que disparou o evento.
 * @param {boolean} button-container Caso informado o box pegará a cor de uma barra de botões e acionará o gap padrão, caso o gap não tenha sido informado.
 * @example
     <example module="vboxExample">
         <file name="vboxExample.html">
         <!-- Neste caso, sk-padding não é um parâmetro de sk-vbox, e sim, uma outra diretiva que pode ser usada como atributo -->
            <div ng-controller="Teste as ctrl">
                <sk-vbox gap="10" sk-padding="20" sk-onload="ctrl.onLoadBox($event)">
                    <span>First</span>
                    <span>Second</span>
                    <span>Third + {{ ctrl.label  }}</span>
                </sk-vbox>
            </div>
         </file>
         <file name="vboxExample.js">
            angular
                .module('vboxExample', ['snk'])
                .controller('Teste', function(){
                    var self = this;

                    self.onLoadBox = onLoadBox;
                    self.label = 'carregando';

                    function onLoadBox($event) {
                        self.label = 'carregado';                        
                    } 
                });
         </file>
     </example>
 */

[
    {name: 'skHbox', direction: 'row', gapDirections: ['right', 'left']},
    {name: 'skVbox', direction: 'column', gapDirections: ['bottom', 'top']}
]
.forEach(function(directiveMD) {

    angular
        .module('snk.components.box')
        .directive(directiveMD.name, ['$parse', 'AngularUtil', function($parse, AngularUtil) {
            return {
                restrict: 'E',
                compile: function($element, $attr) {
                    $element.attr('layout', directiveMD.direction);

                    if ($attr.hasOwnProperty('align')) {
                        $element.attr('layout-align', $attr.align);
                        $element.removeAttr('align');
                    }

                    var gap = Number($attr.gap);

                    if ($attr.hasOwnProperty('buttonContainer') || $attr.hasOwnProperty('footerContainer')) {
                        if ($attr.hasOwnProperty('buttonContainer')) {
                            $element.addClass('high-contrast-panel');
                        } else {
                            $element.addClass('low-contrast-panel');
                        }

                        if (isNaN(gap)) {
                            gap = 5;
                        }

                        if (!$element.attr('layout-left-padding') && $element.attr('layout-right-padding') && $element.attr('layout-bottom-padding') && $element.attr('layout-top-padding')) {
                            $element.attr('layout-padding', '');
                        }
                    }

                    return function($scope, iElement, iAttr) {
                        AngularUtil.timeout(function(){
                            if(!isNaN(gap)) {
                                iElement.css('gap', gap + 'px');
                            }

                            var event = {
                                target: iElement
                            };

                            if (angular.isDefined(iAttr['skOnload'])) {
                                var onLoadFn = $parse(iAttr['skOnload']);

                                AngularUtil.apply($scope, function(){
                                    onLoadFn($scope, {$event: event});
                                });
                            }
                        });
                    }
                }
            };
        }]);

});
angular
  .module('snk.components.flattree')
  .component('skBreadcrumbs', {
    controller: 'SkBreadcrumbsController',
    templateUrl: 'components/breadcrumbs/breadcrumbs.tpl.html',
    bindings: {
      dataprovider: '<skDataprovider',
      labelBuilder: '&?skLabelBuilder',
      onItemClick: '&?skItemClick',
      labelProperty: '@skLabelProperty'
    }
  });
angular
    .module('snk.components.breadcrumbs')
    .controller('SkBreadcrumbsController', ['$scope', '$element', '$compile', 'ObjectUtils', 'ArrayUtils', 'MessageUtils', 'AngularUtil', 'StringUtils', 'i18n', 'DomUtil', 'DatasetEvents', function ($scope, $element, $compile, ObjectUtils, ArrayUtils, MessageUtils, AngularUtil, StringUtils, i18n, DomUtil, DatasetEvents) {
      var self = this;

      var BASE_WIDTH = 40;
      var CHARACTER_SIZE = 6;
      var ITEM_TEMPLATE = '<li><a tooltip="{tooltipValue}" class="{aClass}" {tooltipPlacement}>{content}</a></li>';
      var RETICENCE_TEXT_WIDTH = 9;
      var RETICENCE_WIDTH = 43;

      var breadcrumbsElem = angular.element(DomUtil.select($element, '.breadcrumbs'));

      self.$onInit = $onInit;
      self.$onChanges = $onChanges;

      self.getItemLabel = getItemLabel;

      function $onInit() {
        $element.attr('layout', '');
        $element.attr('flex', '');

        AngularUtil.addWindowResizeHandler(recalculateSize, $scope);
      }

      function $onChanges(changeObj) {
        if (changeObj.dataprovider) {
          recalculateSize();
        }
      }

      function recalculateSize() {
        angular.forEach(breadcrumbsElem.children(), function (item) {
          angular.element(item).scope().$destroy();
        });

        breadcrumbsElem.empty();

        if (self.dataprovider) {
          var componentWidth = $element[0].clientWidth;
          var currentListWidth = 0;

          var listToShow = [];
          var reticenceArr = [];

          var compact = false;
          var multiLine = false;

          angular.copy(self.dataprovider).reverse().forEach(function (item, index) {
            var bItem = {
              item: item,
              active: item.active,
              label: getItemLabel(item),
              icon: item.icon,
              svg: item.svg
            };

            bItem.tooltip = item.tooltip || bItem.label;

            var itemWidth = BASE_WIDTH + (bItem.label.length * CHARACTER_SIZE);
            currentListWidth += itemWidth;

            if (index > 0 && (currentListWidth > componentWidth)) { //hide
              if (compact) {
                reticenceArr.push(bItem);
              } else {
                multiLine = true;
                listToShow.push(bItem);
              }
            } else {
              listToShow.push(bItem);
            }
          });

          if (reticenceArr.length > 0) {
            var reticenceTooltip = reticenceArr.reverse().map(function (bItem) {
              return bItem.tooltip
            }).join(' > ');

            var reticenceElem = buildItemElement({
              item: undefined,
              label: '...',
              tooltip: reticenceTooltip
            }, 'right');
            reticenceElem.addClass('reticence');
            breadcrumbsElem.append(reticenceElem);
          }

          listToShow.reverse().forEach(function (bItem, index) {
            var label = bItem.label;

            if (reticenceArr.length > 0 && listToShow.length == 1) {
              var itemWidth = BASE_WIDTH + (label.length * CHARACTER_SIZE);

              if (RETICENCE_WIDTH + itemWidth > componentWidth) {
                //label = label.substring(0, label.length - 3); //Removemos o espaço para adicionar os '...'

                var extraSpace = 2 * CHARACTER_SIZE;
                var maxItemWidth = componentWidth - RETICENCE_WIDTH;
                var maxItemLabelWidth = (maxItemWidth - BASE_WIDTH - RETICENCE_TEXT_WIDTH - extraSpace);

                var halfLabellimit = Math.floor((maxItemLabelWidth / CHARACTER_SIZE) / 2);

                var labelArr = label.split('');

                var labelArrStart = labelArr.slice(0, halfLabellimit);
                var labelArrEnd = labelArr.slice(labelArr.length - halfLabellimit);

                label = StringUtils.rtrim(labelArrStart.join('')) + '...' + StringUtils.ltrim(labelArrEnd.join(''));

                bItem.label = label;
                //var labelLimit = Math.floor(maxItemLabelWidth / CHARACTER_SIZE);
                //label = label.substring(0, labelLimit) + '...';
              }
            }

            var itemElem = buildItemElement(bItem, index == 0 ? 'right' : undefined);
            breadcrumbsElem.append(itemElem);
          });

          breadcrumbsElem[multiLine ? 'addClass' : 'removeClass']('multi-line');
        }
      }

      function buildItemElement(bItem, tooltipPlacement) {
        var content = '';

        if (bItem.icon) {
          content += '<sk-icon font-icon="' + bItem.icon + '"></sk-icon>';
        } else if (bItem.svg) {
          content += '<sk-icon svg-src="' + bItem.svg + '"></sk-icon>';
        }

        if (angular.isString(bItem.label)) {
          content += '<span>' + bItem.label + '</span>';
        }

        var strElem = StringUtils.substitute(ITEM_TEMPLATE, {
          content: content,
          aClass: bItem.active ? 'active' : '',
          tooltipValue: '{{\'' + bItem.tooltip ? bItem.tooltip.replace(/\'/gim, '') : bItem.tooltip + '\'}}',
          tooltipPlacement: 'tooltip-placement="' + (tooltipPlacement ? tooltipPlacement : 'bottom') + '"'
        });

        var itemElem = $compile(angular.element(strElem))($scope.$new());

        if (self.onItemClick) {
          itemElem.on('click', function () {
            AngularUtil.apply($scope, function () {
              self.onItemClick({
                $item: bItem.item
              });
            });
          });
        }

        return itemElem;
      }

      function getItemLabel(item) {
        if (angular.isObject(item) && self.labelProperty) {
          return item[self.labelProperty];
        } else if (self.labelBuilder) {
          return self.labelBuilder($scope, {$item: item});
        } else if (item.label) {
          return item.label;
        } else {
          return item;
        }
      }
    }]);

angular
    .module('snk.components.btnnovo')
    .controller('SkBtnNovoController',['$scope','SkApplication', 'KeyboardEvents', '$translate',
        function($scope, SkApplication, KeyboardEvents, $translate) {

            $scope.getToolTipText = getToolTipText;
            $scope.getEntityDescription = getEntityDescription;
            $scope.addFn = addFn;

            init();

            function init() {
                if($scope.doBind === true) {
                    SkApplication.instance().addEventListener(KeyboardEvents.ADD_KEY, addFn);
                }
            }

            function addFn(params, evt) {
                if ($scope.onClick) {
                    $scope.onClick({$event: evt});
                    evt.preventDefault();
                } else if ($scope.dataset) {
                    $scope.dataset.goToInsertionMode();
                    evt.preventDefault();
                }
            }

            function getEntityDescription() {
                if ($scope.dataset) {
                    return $scope.dataset.getEntityDescription();
                } else {
                    return $scope.entityDescription;
                }
            }

            function getToolTipText() {
                var entityDescription = getEntityDescription() == 'StandAlone' ? '' : getEntityDescription();

                if(angular.isDefined($scope.toolTipText)) {
                    return $scope.toolTipText;
                }
                
                let descricaoAtalho=entityDescription=="Filtro"?' [ctrl + F8]':' [F8]';

                return $translate.instant('Geral.lblCadastrar') + ' ' + (!$scope.compact ? entityDescription : '') + descricaoAtalho;
            }
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.btnnovo.directive:sk-btn-novo
 * @restrict E
 * @description
 * A diretiva 'skBtnNovo' é apenas um botão de novo registro, que será usado como padrão no framework;
 *
 * @param {string} sk-on-click Função de onClick do botão.
 * @param {string} sk-tooltip-text Se especificado, será o texto utilizado como tooltip.
 * @param {string} sk-entity-description Descrição apresentada no botão. Apenas é mostrado caso o atributo skTooltipText não tenha sido especificado.
 * @param {string} sk-dataset Dataset que pode ser passado ao botão, caso informado ele pegará a descrição e já implementará a função padrão de click;
 * @param {string} sk-enabled Habilita ou desabilita o botão.
 * @param {string} sk-tooltip-placement Posição do tooltip ('right','left','top' ou 'bottom').
 * @param {string} sk-compact Se o botão será apresentado no modo compacto ou não.
 * @param {string} sk-do-bind Ativa ou desativa o bind na tecla F8.
 *
 * @example
     <example module="appBtnNovo">
         <file name="appBtnNovo.html">
         	<div ng-controller="TesteCtrl">
	            <sk-btn-novo sk-entity-description="{{entityDescr}}" sk-on-click="onClick()"></sk-btn-novo>
         	</div>
         </file>
         <file name="appBtnNovo.js">
            angular
                .module('appBtnNovo', ['snk'])
                .controller('TesteCtrl', function($scope){
                    $scope.entityDescr = 'Teste';

                    $scope.onClick = function(){
                        window.alert('Click!');
                    };
                });
         </file>
     </example>
 */
angular
    .module('snk.components.btnnovo')
    .directive('skBtnNovo', ['$compile', function ($compile) {
        return {
            restrict: 'E',
            templateUrl: 'components/btnnovo/btnnovo.tpl.html',
            controller: 'SkBtnNovoController',
            scope: {
                doBind: '=?skDoBind',
                onClick: '&?skOnClick',
                entityDescription: '@?skEntityDescription',
                dataset: '=?skDataset',
                enabled: '=?skEnabled',
                tooltipPlacement: '@?skTooltipPlacement',
                compact: '=?skCompact',
                toolTipText: '@?skTooltipText'
            }
        };
    }]);
angular
    .module('snk.components.btnoldlayout')
    .controller('SkBtnOldLayoutController', ['$scope', 'SkApplication', 'MGEParameters', 'SkI18nService',
        function ($scope, SkApplication, MGEParameters, SkI18nService) {
            var self = this;

            $scope.changeLayout = changeLayout;
            $scope.visivel = visivel;

            $scope.lblBtnOldLayout = SkI18nService.instant('Dynaform.lblUtilizarLayoutAnterior'); 

            function visivel(){
                if(MGEParameters.asInteger('mge.core.habilita.tela.html5') === 1) {
					return true;
				} else {
					return false;
				}
            }

            function changeLayout(){
                SkApplication.instance().useClassicLayoutVersion($scope.dataset);
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.btnoldlayout.directive:sk-btn-old-layout
 * @restrict E
 * @description
 * A diretiva 'skBtnOldLayout' permite alterar o layout das telas do sistema.
 *
 * @param {string} [sk-dataset=undefined]  Nesse parametro deve ser informado o dataSet para que possa ter acesso ao codigo da tela em flex
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
         <div ng-controller="MyController as ctrl">
             <sk-btn-old-layout sk-dataset="dataset">
             </sk-btn-old-layout>
         </div>
     </file>
     <file name="appBtnOldLayout.js">
     angular
     .module('appBtnOldLayout', ['snk'])
     .controller('MyController', function(){

     });
     </file>
 </example>
 *
 * Author: Igor Peres
 */

angular
    .module('snk.components.btnoldlayout')
    .directive('skBtnOldLayout', function () {
        return {
            templateUrl: 'components/btnoldlayout/btnoldlayout.tpl.html',
            restrict: 'E',
            controller: 'SkBtnOldLayoutController',
            scope: {
                dataset: '=skDataset'
            }
        };
    });

/**
 * @ngdoc directive
 * @name snk.components.btnotheroptions:sk-btn-other-options
 * @restrict E
 * @description
 * O componente 'sk-btn-other-options' é o botão padrão do sistema para outras opções. 
 *
 * @param {boolean} [sk-visible=true] Esta opção e utilizada para mostrar ou ocultar o botão.
 * @param {boolean} [sk-open-always=false] Nesse parametro deve ser informado se deseja sempre abrir as opções ou executar a última utilizada diretamente.
 * @param {function} [sk-other-options=undefined] Nesse parametro deve ser informado uma função que retorne um array de objetos contendo label e action.
 * 
 * @example
   <example module="app">
         <file name="exemplo.html">
            <div ng-controller="MyController as ctrl">  
              <sk-vbox  sk-margin="10px">
                <sk-btn-other-options sk-other-options="ctrl.otherOptionsLoader()"></sk-btn-other-options>
              </sk-vbox>                     
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope){
                    var self = this;

                    self.otherOptionsLoader = otherOptionsLoader;
                      
                    function otherOptionsLoader() {
                      var options = [
                            { label: 'Visualizar Relatorio', action: visualizarRelatorio },
                            { label: 'Agendar Relatorios', action: agendarRelatorios }
                        ];
                        return options;
                    }

                    function visualizarRelatorio() {
                        alert('visualizarRelatorio');
                    }

                    function agendarRelatorios() {
                        alert('agendarRelatorios');

                    }
                });
         </file>
     </example>
 */
/**
 * Created by leonardo.mendes on 29/11/2016.
 */
angular
  .module('snk.components.btnotheroptions')
  .component('skBtnOtherOptions', {
    templateUrl: 'components/btnotheroptions/btnotheroptions.tpl.html',
    bindings: {
      visible: '=?skVisible',
      openAlways: '=?skOpenAlways',
      otherOptions: '&skOtherOptions',
      buildOnEveryClick: '=?skBuildOnEveryClick'
    }
  });

/**
 * @ngdoc directive
 * @name snk.components.btnnovo.directive:sk-btn-place
 * @restrict E
 * @description
 * O componente 'sk-btn-place' é botão padrão do Place, com ícone, e com nome variável de acordo com a marca. 
 *
 * @param {string} sk-destination Destination que será passado como parâmetro ao Place
 * @param {string} sk-label Chave de internacionalização ou texto, que será usado caso informado, do contrário o componente colocará 'Sankhya Place' ou 'Jiva Place'
 * dependendo da marca.
 *
 * @example
     <example module="appBtnPlace">
         <file name="appBtnPlace.html">
            <sk-application>
                <sk-hbox gap="2">
                    <sk-btn-place sk-destination="#s:tipcadastros?filtro=U"></sk-btn-place>
                    <sk-btn-place sk-label="Meu Label" sk-destination="#s:tipcadastros?filtro=U"></sk-btn-place>
                </sk-hbox>
            </sk-application>
         </file>
         <file name="appBtnPlace.js">
            angular.module('appBtnPlace', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.btnplace')
    .component('skBtnPlace',  {
        templateUrl: 'components/btnplace/btnplace.tpl.html',
        controller: 'SkBtnPlaceController',
        bindings: {
            destination: '@skDestination',
            label: '@skLabel',
            hideLabel: '=?skHideLabel '
        }
    });
angular
    .module('snk.components.btnplace')
    .controller('SkBtnPlaceController', ['SkApplicationInstance', 'i18n', function(SkApplicationInstance, i18n) {
        var self = this;
        
        self.btnPlaceText;

        self.openPlace = openPlace;

        init();

        function init() {
            if (angular.isDefined(self.label)) {
                self.btnPlaceText = i18n(self.label);
            } else {
                self.btnPlaceText = SkApplicationInstance.isJivaW() ? 'Jiva Place' : 'Sankhya Place';
            }
        }

        function openPlace() {
            var resouceID = SkApplicationInstance.isJivaW() ? "br.com.sankhya.mge.rel.jvportal" : "br.com.sankhya.mge.rel.ssportal";
            var resourceIdDestination =  SkApplicationInstance.getResourceID();

            SkApplicationInstance.openApp(resouceID, {
                destination: resourceIdDestination
            }, true);
        }


    }]);


/**
 * @ngdoc directive
 * @name snk.components.button.directive:button
 * @restrict E
 * @description
     Componente de botão, padrão do html5
     Nossa diretiva adiciona os padrões de classe baseados em nossas cores default.
     O tipo 'brand' é variável conforme a marca, Sankhya-W é verde, Jiva-W é laranjado.

     - Caso você seu botão necessite ter 1 tamanho menor do que o padrão, basta passar o atributo small.
     
     - É possível passar font-icon ou svg-src para criar um sk-icon interno.

     Conforme exemplo abaixo.
 * @example
     <example module="appButton">
         <file name="appButton.html">
            <div>
                <button default>Default</button>
                <button primary>Primary</button>
                <button info>Info</button>
                <button warning>Warning</button>
                <button danger>Danger</button>
                <button brand>Brand</button>
            </div>
            <div>
                <button default small>Default</button>
                <button primary small>Primary</button>
                <button info small>Info</button>
                <button warning small>Warning</button>
                <button danger small>Danger</button>
                <button brand>Brand</button>
            </div>
         </file>
         <file name="appButton.js">
            angular
                .module('appButton', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.button')
    .directive('button', ['$compile', 'ArrayUtils', 'ButtonThemes', function($compile, ArrayUtils, ButtonThemes) {
        return {
            restrict: 'E',
            compile: function($element, $attr) {
                ArrayUtils.forEach(ButtonThemes.getThemes(), function(buttonTheme) {
                    if ($attr.hasOwnProperty(buttonTheme)) {
                        $element.addClass(ButtonThemes.getClassForTheme(buttonTheme));
                        return false;
                    }
                });

                if ($attr.hasOwnProperty('small')) {
                    $element.addClass('btn-sk-sm')
                }

                if ($attr.hasOwnProperty('block')) {
                    $element.addClass('btn-block')
                }

                if ($attr.hasOwnProperty('iconSmall')) {
                    $element.addClass('btn-sk-sm-icon')
                }

                return function(iScope, iElement) {
                    if ($attr.hasOwnProperty('fontIcon') || $attr.hasOwnProperty('svgSrc')) {
                        var iconElem = angular.element('<sk-icon></sk-icon>');

                        if ($attr.hasOwnProperty('fontIcon') ) {
                            iconElem.attr('font-icon', $attr.fontIcon);
                        } else {
                            iconElem.attr('svg-src', $attr.svgSrc);
                        }

                        if ($attr.hasOwnProperty('iconVersion') ) {
                            iconElem.attr('v', $attr.iconVersion);
                        }

                        iElement.prepend(iconElem);

                        $compile(iconElem)(iScope);
                    }
                }
            }
        };
    }]);

/**
 * @ngdoc service
 * @name snk.components.button.service:ButtonThemes
 *
 * @description
 * Serviço que define os themas disponíveis para os botões do framework.
 * */

angular
    .module('snk.components.button')
    .service('ButtonThemes', [function() {
        var self = this;

        const BUTTON_THEMES = ['default', 'primary', 'info', 'warning', 'danger', 'brand'];

        self.getThemes = getThemes;
        self.getClassForTheme = getClassForTheme;

        function getThemes(){
            return BUTTON_THEMES;
        }

        function getClassForTheme(theme) {
            if (BUTTON_THEMES.indexOf(theme) > -1) {
                return 'btn btn-' + theme;
            } else {
                return theme;
            }
        }

    }]);
angular
    .module('snk.components.calendar')
    .constant('CalendarModeCosntants', {
        "MES": 'dayGridMonth',
        "SEMANA": 'dayGridWeek',
        "DIA": 'timeGridDay',
        "M": 'dayGridMonth',
        "S": 'dayGridWeek',
        "D": 'timeGridDay',
        "EVENTO": 'listWeek'
    });
angular
    .module('snk.components.calendar')
    .controller('SkCalendarController', ['$scope', 'ObjectUtils',
        function ($scope, ObjectUtils) {
            let self = this

            self.getCalendar = getCalendarApi
            self.next = next
            self.prev = prev
            self.prevYear = prevYear
            self.today = today
            self.goToDate = goToDate
            self.incrementDate = incrementDate
            self.getDate = getDate
            self.dateClick = dateClick
            self.changeView = changeView
            self.updateSize = updateSize
            self.render = render
            var _publicAPI;

            init()

            function init() {
                _publicAPI = ObjectUtils.buildPublicAPI(self, ['changeView', 'next', 'prev', 'prevYear', 'today', 'goToDate', 'incrementDate','getDate', 'render', 'updateSize']);
                if (angular.isFunction($scope.componentCreated)) {
                    $scope.componentCreated({$component: _publicAPI});
                }
            }

            function getCalendarApi() {
                return $scope.calendar;
            }

            function next() {
                $scope.calendar.next()
            }

            function prev() {
                $scope.calendar.prev()
            }

            function prevYear() {
                $scope.calendar.prevYear()
            }

            function today() {
                $scope.calendar.today()
            }

            function goToDate(data) {
                $scope.calendar.gotoDate(data)
            }

            function incrementDate() {
                $scope.calendar.incrementDate()
            }

            function getDate() {
                return $scope.calendar.getDate()
            }

            function dateClick(info) {
                if ($scope.dateClick) {
                    $scope.dateClick(info)
                }
            }

            function changeView(view) {
                $scope.calendar.changeView(view)
            }

            function render() {
                $scope.calendar.render()
            }

            function updateSize() {
                $scope.calendar.updateSize()
            }


        }]);
/**
 * @ngdoc directive
 * @name snk.components.calendar.directive:sk-calendar
 * @restrict E
 * @description
 * Essa diretiva tem como responsabilidade exibir o componente de calendário.
 *
 *
 * @param {array} sk-value Eventos do calendário.
 * @param {array} sk-background-events Eventos de fundo ele irá renderizar todo o background na cor do evento podendo demonstrar indisponiblidades por exemplo
 * @param {array} sk-business-hours Carga horária o calendário irá destacar os horários disponíveis da agenda ex: 08:00 12:00 - 13:00 18:00
 * @param {function} sk-date-click Função a ser chamada quando o usuário clicar em um dia.
 * @param {function} sk-event-click Função a ser chamada quando o usário clicar em um evento.
 * @param {function} sk-dbl-event-click Função a ser chamada quando o usuário der duplo clique em um evento
 * @param {string} sk-view - View do calendario aceita (M = Mes, S = Semana, D = dia, E = Evento)
 * @param {function} sk-on-component-created Função a ser chamada quando o componente for criado
 * @param {function} sk-on-more-link-click Função a ser chamada quando o usuário clicar no botao +Eventos
 * @param {function} sk-event-class-names Função chamada durante a renderização dos eventos. ela deve retornar um arrey de classes CSS para personalizar a exibição dos eventos
 * @param {boolean} sk-week-numbers define se exibe o número da semana
 * @param {template} event-tooltip-template-url Template para personalizar o tooltip dos eventos
 *
 * @scope
 *
 * @example
 <example module="app">
 <file name="exemplo.html">
 <div>
 <sk-calendar
 sk-view="ctrl.currentView"
 sk-selectable="true" sk-week-numbers="true"
 sk-business-hours="ctrl.cargas"
 sk-on-component-created="ctrl.onCreate2($component)"
 sk-event-click="ctrl.openEventAgenda"
 event-tooltip-template-url="tooltip.html"
 sk-value="ctrl.eventos"></sk-calendar>
 </div>

 </file>
 <file name="app.js">
 angular
 .module('app', ['snk']).controller('appController', function(){
    let self = this
    self.currentView = 'M'
    self.cargas = [{

                        daysOfWeek: [1, 2, 3, 4, 5],
                        startTime: '08:00',
                        endTime: '12:00'
                    }, {
                        daysOfWeek: [1, 2, 3, 4, 5],
                        startTime: '13:00',
                        endTime: '18:00'
                    }]

    self.eventos = [{start: new Date(),end: new Date(), allDay:false, qualquer:{}}]



 });



 </file>
 </example>
 */
angular
    .module('snk.components.calendar')

    .directive('skCalendar', ['CalendarModeCosntants', '$timeout', 'DateUtils', 'AngularUtil', '$compile', function (CalendarModeCosntants, $timeout, DateUtils, AngularUtil, $compile) {
        return {
            restrict: 'E',
            scope: {
                events: '<skValue',
                backgroundEvents: '<skBackgroundEvents',
                businessHours: '<skBusinessHours',
                dateClick: '&?skDateClick',
                eventClick: '&?skEventClick',
                bgEventClick: '&?skBgEventClick',
                eventDblClick: '&?skDblEventClick',
                view: '<skView',
                select: '&?skSelect',
                unSelect: '&?skUnSelect',
                componentCreated: '&?skOnComponentCreated',
                moreLinkClick: '&?skOnMoreLinkClick',
                dayCellContent: '&?skDayCellContent',
                eventClassNames: '&?skEventClassNames',
            },
            controller: 'SkCalendarController',
            templateUrl: 'components/calendar/calendar.tpl.html',
            link: function (scope, $element, attrs) {

                scope.parseBusinessHours = function (cargaHoraria) {
                    if (angular.isDefined(cargaHoraria))
                        return cargaHoraria.dia.map(function (d) {
                            return {
                                daysOfWeek: d.id,
                                startTime: d.inicio,
                                endTime: d.fim,
                            }
                        })

                    return undefined
                }

                var calendarEl = $element.children()[0];
                var template
                var templateBG
                var templateUrl = attrs.eventTooltipTemplateUrl
                if (!templateUrl)
                    templateUrl = 'components/calendar/event.tpl.html'

                AngularUtil.requestTemplate(templateUrl)
                    .then(function (content) {
                        template = "<div class='agenda-tooltip-container'>" + content + "</div>"
                    })

                var templateBGUrl = attrs.backgroundTooltipTemplateUrl
                if (!templateBGUrl)
                    templateBGUrl = 'components/calendar/event.tpl.html'

                AngularUtil.requestTemplate(templateBGUrl)
                    .then(function (content) {
                        templateBG = "<div class='agenda-tooltip-container'>" + content + "</div>"
                    })




                var defaults = {
                    initialView: 'dayGridMonth',
                    slotMinTime: '00:00',
                    slotMaxTime: '23:59',
                    expandRows: true,
                    headerToolbar: {
                        left: '',
                        center: '',
                        right: ''
                    },
                    initialDate: (new Date()),
                    height: 'parent',
                    navLinks: true,
                    editable: false,
                    selectable: false,
                    nowIndicator: true,
                    dayMaxEvents: true,
                    weekNumbers: false,
                    weekText: "",
                    forceEventDuration: true,
                    handleWindowResize: false,
                    windowResizeDelay: 200,
                    rerenderDelay: 200,
                    businessHours: [{

                        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday

                        startTime: '08:00', // a start time (10am in this example)
                        endTime: '12:00', // an end time (6pm in this example)
                    }, {
                        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday

                        startTime: '13:00', // a start time (10am in this example)
                        endTime: '18:00', // an end time (6pm in this example)
                    }],
                    allDaySlot: true,
                    eventDidMount: function (info) {
                        let element = $(info.el)
                        var scopeEvent = scope.$new(true)
                        let event = info.event.toPlainObject()


                        for (let i in event) {
                            scopeEvent[i] = event[i]
                        }
                        if (event.extendedProps) {
                            for (let i in event.extendedProps) {
                                scopeEvent[i] = event.extendedProps[i]
                            }

                            if (event.extendedProps.realStart)
                                scopeEvent.start = event.extendedProps.realStart
                            if (event.extendedProps.realEnd)
                                scopeEvent.end = event.extendedProps.realEnd
                        }

                        scopeEvent.context = info.context
                        let cpl
                        if (event.display == 'background')
                            cpl = $compile(templateBG.trim())(scopeEvent)
                        else
                            cpl = $compile(template.trim())(scopeEvent)

                        element.tooltip({
                            title: info.event.title || ' ',
                            placement: getTooltipPlacement(info.event.start, info.view.type),
                            trigger: 'hover',
                            container: 'body',
                            delay: 500,
                            template: cpl
                        });


                        element.on('dblclick', function (event) {
                            if (angular.isDefined(scope['eventDblClick']) && angular.isFunction(scope['eventDblClick'])) {
                                scope.eventDblClick()(event)
                            }
                        });
                    },
                    dayCellDidMount: function (info) {


                    },
                    dayHeaderDidMount: function (info) {

                    },
                    dayCellContent: function (info) {
                        return undefined
                    },
                    navLinkDayClick: function (date, jsEvent) {
                        scope.calendar.changeView(CalendarModeCosntants.D, date)
                    },
                    navLinkWeekClick: function (date, jsEvent) {
                        scope.calendar.changeView(CalendarModeCosntants.S, date)
                    }

                }


                var options = {
                    initialView: CalendarModeCosntants[attrs.skInitialView] || defaults.initialView,
                    slotMinTime: attrs.skSlotMinTime || defaults.slotMinTime,
                    slotMaxTime: attrs.skSlotMaxTime || defaults.slotMaxTime,
                    height: attrs.skHeight || defaults.height,
                    expandRows: attrs.skExpandRows || defaults.expandRows,
                    headerToolbar: attrs.skHeaderToolbar || defaults.headerToolbar,
                    initialDate: attrs.skInitialDate || defaults.initialDate,
                    navLinks: attrs.skNavLinks || defaults.navLinks,
                    editable: attrs.skEditable || defaults.editable,
                    selectable: (attrs.skSelectable || defaults.selectable) == "true",
                    nowIndicator: attrs.skNowIndicator || defaults.nowIndicator,
                    dayMaxEvents: attrs.skDayMaxEvents || defaults.dayMaxEvents,
                    weekNumbers: attrs.skWeekNumbers || defaults.weekNumbers,
                    weekText: attrs.skWeekText || defaults.weekText,
                    businessHours: scope.cargaHoraria ? scope.parseBusinessHours(scope.cargaHoraria) : defaults.businessHours,
                    allDaySlot: attrs.skAllDaySlot || defaults.allDaySlot,
                    eventDidMount: defaults.eventDidMount,
                    dayCellDidMount: defaults.dayCellDidMount,
                    dayHeaderDidMount: defaults.dayHeaderDidMount,
                    navLinkDayClick: defaults.navLinkDayClick,
                    navLinkWeekClick: defaults.navLinkWeekClick,
                    dayCellContent: handleDayCellContent,
                    displayEventTime: false,
                    displayEventEnd: false,
                    moreLinkClick: handleonMoreLinkClick,
                    eventClassNames: handleEventClassName
                }

                scope.calendar = new FullCalendar.Calendar(calendarEl, options);
                $timeout(function () {
                    scope.calendar.setOption('locale', 'pt-BR');
                    scope.calendar.render();
                })

                scope.$watch('cargaHoraria', function (newCarga) {
                    scope.calendar.setOption('businessHours', scope.parseBusinessHours(newCarga))
                })

                scope.$watch('events', function (newEvents) {
                    if (newEvents && angular.isArray(newEvents)) {
                        newEvents.forEach(function (event) {
                            event.realStart = event.start
                            event.realEnd = event.end
                            event.startStr = DateUtils.formatDate(event.start, 'HH:mm')
                            event.endStr = DateUtils.formatDate(event.end, 'HH:mm')
                            if (DateUtils.diff(event.end, event.start, 'minutes') < 30) {
                                event.end = DateUtils.add(event.start, 30, 'minutes')
                            }
                        })
                    }
                    setEventSource("events", newEvents)
                })

                scope.$watch('backgroundEvents', function (newEvents) {
                    if (newEvents) {
                        newEvents.forEach(function (event) {
                            event.display = 'background'
                        })
                    }
                    setEventSource("backgroundEvents", newEvents)
                })

                scope.$watch('view', function (newValue, oldValue) {

                    if (oldValue != newValue) {
                        scope.calendar.changeView(CalendarModeCosntants[newValue] || newValue)
                    }
                })

                function setEventSource(source, events) {
                    var eventSource = scope.calendar.getEventSourceById(source)
                    if (eventSource) eventSource.remove()
                    scope.calendar.addEventSource({id: source, "events": events})
                }

                function handleonMoreLinkClick(info) {
                    if (angular.isDefined(scope.moreLinkClick) && angular.isFunction(scope.moreLinkClick)) {
                        let resultado = scope.moreLinkClick()(info)
                        return resultado || " "
                    }
                }

                function handleDayCellContent(arg) {

                    if (angular.isDefined(scope.dayCellContent) && angular.isFunction(scope.dayCellContent)) {
                        return scope.dayCellContent()(arg)
                    }
                }

                function handleEventClassName(arg) {

                    if (angular.isDefined(scope.eventClassNames) && angular.isFunction(scope.eventClassNames)) {
                        return scope.eventClassNames()(arg)
                    }
                }

                scope.$watch(
                    function () {
                        return {
                            width: $element.parent().width(),
                            height: $element.parent().height(),
                        }
                    },
                    function (newValue, oldValue) {
                        if (newValue != oldValue) {
                            $timeout(function () {
                                scope.calendar.updateSize()
                            }, 200)
                        }

                    }, true);


                scope.calendar.on('dateClick', function (info) {
                    if (angular.isDefined(scope['dateClick']) && angular.isFunction(scope['dateClick'])) {
                        scope.dateClick()(info)
                    }
                });
                scope.calendar.on('eventClick', function (eventClickInfo) {
                    if (eventClickInfo.event.display == "background") {
                        if (angular.isDefined(scope['bgEventClick']) && angular.isFunction(scope['bgEventClick'])) {
                            scope.bgEventClick()(eventClickInfo.event, eventClickInfo.el, eventClickInfo.jsEvent, eventClickInfo.view)
                        }
                    } else {
                        if (angular.isDefined(scope['eventClick']) && angular.isFunction(scope['eventClick'])) {
                            scope.eventClick()(eventClickInfo.event, eventClickInfo.el, eventClickInfo.jsEvent, eventClickInfo.view)
                        }
                    }
                });
                scope.calendar.on('eventMouseEnter', function (mouseEnterInfo) {
                    if (angular.isDefined(scope['eventMouseEnter']) && angular.isFunction(scope['eventMouseEnter'])) {
                        scope.eventMouseEnter()(mouseEnterInfo)
                    }
                });

                scope.calendar.on('eventMouseLeave', function (mouseLeaveInfo) {
                    if (angular.isDefined(scope['eventMouseLeave']) && angular.isFunction(scope['eventMouseLeave'])) {
                        scope.eventMouseLeave()(mouseLeaveInfo)
                    }
                });


                scope.$on('$destroy', function () {
                    scope.calendar.destroy();
                });


                function getTooltipPlacement(data, viewType) {
                    if (viewType == "dayGridMonth" || viewType == 'dayGridWeek') {
                        let dia = moment(data).day()
                        if (dia <= 1) {
                            return 'right'
                        } else {
                            return 'left'
                        }

                    } else
                        return 'left'
                }

                if (attrs.skId) {
                    var id = scope.$eval(attr.skId) || attr.skId;
                    SkComponentRegistry.register(self, id, scope);
                }
            }
        }
    }])
/**
 * Created by leonardo.mendes on 10/12/2021.
 */
/**
 * @ngdoc directive
 * @name snk.components.carregando.directive:sk-carregando
 * @restrict E
 * @description
 * O componente 'sk-carregando' é utilizado para ser apresentado na primeira carga de alguma tela ou nas abas quando se necessitar. 
 * @example
     <example module="appCarregando">
         <file name="appCarregando.html">
            <sk-application>
                <sk-hbox flex>
                    <sk-carregando ng-show="true"></sk-carregando>
                </sk-hbox>
            </sk-application>
         </file>
         <file name="appCarregando.js">
            angular.module('appCarregando', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.carregando')
    .component('skCarregando', {
        templateUrl: 'components/carregando/carregando.tpl.html'
    });
angular
    .module('snk.components.changeorderbar')
    .controller('ChangeOrderBarController', ['i18n', 'DatasetEvents', 'ObjectUtils', '$scope', 'ArrayUtils', '$rootScope', '$timeout', function(i18n, DatasetEvents, ObjectUtils, $scope, ArrayUtils, $rootScope, $timeout) {
        var self = this;

        //Interceptors
        ObjectUtils.implements(self, IDataSetObserver);

        self.moveTop = moveTop;
        self.moveDown = moveDown;
        self.btnTopEnabled = true;
        self.btnDownEnabled = true;
        self.indexChange = indexChange;
        self.getdataset = getdataset;   
        self.changeRecordPosition = changeRecordPosition;

        // Implementações da interface IDataSetObserver
        self.currentLineChanged = currentLineChangedImpl;

        $scope.tooltipMoverCima = i18n('TwoList.MoveAcima');
        $scope.tooltipMoverBaixo = i18n('TwoList.MoveAbaixo');
        
        init();

        function init(){
            $scope.$watch('dataset', function(){
                if($scope.dataset){
                    $scope.dataset.addObserver(self); 
                }
            });
        }

        function moveTop(){
            $rootScope.$emit('moveRecordDataset', { move: true });
            changeRecordPosition($scope.dataset.getCurrentIndex(), -1);
        }

        function moveDown(){
            $rootScope.$emit('moveRecordDataset', { move: true });
            changeRecordPosition($scope.dataset.getCurrentIndex(), 1);
        } 

        function changeRecordPosition(index, direction){

            var indexToChange = -1;

            if(direction < 0){
                if(index > 0){
                    indexToChange = index - 1
                }
			} else {
                if(index < $scope.dataset.getRecords().length - 1){
                    indexToChange = index + 1;
                }
            }

            if(indexToChange >= 0){

                var records = $scope.dataset.getRecordsList();

                var item = records.removeItemAt(index);
                records.addItemAt(item, indexToChange);
                records.refresh(false, false, true);

                $scope.dataset.refreshDataGridCells();
                $timeout(() => {
                    $scope.dataset.gotoRow(indexToChange);
                }, 20);
            }
        }

        function indexChange(){
            if($scope.dataset.size() > 0){
				self.btnTopEnabled = $scope.dataset.getCurrentIndex() > 0;
				self.btnDownEnabled = $scope.dataset.getCurrentIndex() < $scope.dataset.getRecords().length - 1;
			} else {
				self.btnTopEnabled = false;
				self.btnDownEnabled = false;
			}
        }

        function currentLineChangedImpl(newIndex){
            indexChange()   
        }

        function getdataset(){
            return $scope.dataset;
        }
        
    }]);
/**
 * @ngdoc directive
 * @name snk.components.colorpicker.directive:sk-change-order-bar
 * @restrict E
 * @description
 * Este é o componente responsável por ordenar os registros do dataset
 * @param {SkDataset} [sk-dataset=undefined] ID do Dataset.
 */
angular
    .module('snk.components.changeorderbar')
    .directive('skChangeOrderBar',function() {
        return {
            templateUrl: 'components/changeorderbar/changeorderbar.tpl.html',
            controller: 'ChangeOrderBarController',
            controllerAs: 'ctrl',
            scope: {
                dataset: '=skDataset'
            }
        }
    });
/**
 * Created by jonathan.silva on 09/09/2020.
 */

angular
    .module('snk.components.chart')
    .controller('SkChartController', ['$scope', 'ArrayUtils', 'ColorUtils', 'ObjectUtils',
        function ($scope, ArrayUtils, ColorUtils, ObjectUtils) {
            var self = this;

            // Directives variables
            $scope.dataSource;
            $scope.type;
            $scope.chartId;
            $scope.labelValue;
            $scope.labelCategory;
            $scope.title;
            $scope.subtitle;
            $scope.orderBy;
            $scope.enableLegend;
            $scope.enableExport;
            $scope.doubleClickItem;

            // Local variables
            let dataChart = [];
            let isReverse = false;
            let isChartMultiSeries = false;
            let isChartCustomLegend = false;
            let isChartLine = false;

            // Constants variables
            const chartTypes = {
                area: 'area',
                areaspline: 'areaspline',
                bar: 'bar',
                column: 'column',
                funnel: 'funnel',
                line: 'line',
                pie: 'pie',
                spline: 'spline'
            };
            const chartsCustomLegend = [
                chartTypes.area, 
                chartTypes.areaspline,
                chartTypes.bar, 
                chartTypes.column,
                chartTypes.line,
                chartTypes.spline
            ];
            const chartsMultiSeries = [
                chartTypes.funnel,
                chartTypes.pie
            ];
            const chartsLine = [
                chartTypes.area, 
                chartTypes.areaspline,
                chartTypes.line,
                chartTypes.spline
            ];

            $scope.$watch('dataSource', loadData);

            // Load the data of chart
            function loadData() {
                if ($scope.dataSource && Array.isArray($scope.dataSource) && $scope.dataSource.length) {
                    configData();
                    orderByData(dataChart, 'value');
                    const data = getConfigChart();
                    orderByData(data.multiData, 'y');
                    renderChart(data);
                }
            }

            // Config the data of chart
            function configData() {
                if (!dataChart || !dataChart.length) {
                    dataChart = ObjectUtils.cloneJSON($scope.dataSource);
                }

                $scope.chartId = $scope.chartId || 'sk-chart';
                $scope.type = chartTypes[$scope.type] || chartTypes.column;
                $scope.enableLegend = $scope.enableLegend ? true : false;
                $scope.enableExport = $scope.enableExport ? true : false;
                $scope.labelValue = $scope.labelValue || '';
                $scope.labelCategory = $scope.labelCategory || '',

                isChartMultiSeries = chartsMultiSeries.includes($scope.type) ? true : false;
                isChartCustomLegend = chartsCustomLegend.includes($scope.type) ? true : false;
                isChartLine = chartsLine.includes($scope.type) ? true : false;
            }

            // Config the Order By chart data
            function orderByData(data, key) {
                if (data && data.length) {
                    if ($scope.orderBy && (typeof $scope.orderBy === 'string')) {
                        const orderByStr = $scope.orderBy.toUpperCase();
                        if (orderByStr.includes('ASC') || orderByStr.includes('DESC')) {
                            isReverse = orderByStr.includes('ASC') ? false : true;
                            if (Array.isArray(data[0]) || angular.isDefined(data[0].data)) {
                                data.forEach(function(item) {
                                    if (item.data) {
                                        item.data = ArrayUtils.sortByProperty(item.data, key, sortData);
                                        item.data.forEach(function(subitem, subidx) {
                                            if (angular.isDefined(subitem.x)) {
                                                subitem.x = subidx;
                                            }
                                        });
                                    } else {
                                        item = ArrayUtils.sortByProperty(item, key, sortData);
                                    }
                                });
                            } else {
                                data = ArrayUtils.sortByProperty(data, key, sortData);
                            }
                        }
                    }
                }
            }

            // Gets config the chart
            function getConfigChart() {
                const chartWidth = (100 / dataChart.length);
                const simpleData = [];
                const multiData = [];
                const zoneData = [];
                const legendData = [];

                try {
                    let filterData = [];
                    let color = '';
                    let _dataChart = dataChart;
                    if (_dataChart && _dataChart.length === 1 && Array.isArray(_dataChart[0])) {
                        _dataChart = _dataChart[0];
                    }

                    _dataChart.forEach(function (item, idx) {
                        item.internal_id = idx;

                        if (Array.isArray(item)) {
                            if (isChartMultiSeries) {
                                multiData.push({
                                    name: $scope.labelValue,
                                    size: (chartWidth * 1.9) + '%',
                                    center: [(chartWidth * (idx + 0.5)) + '%', '50%'],
                                    showInLegend: true,
                                    dataLabels: {
                                        enabled: false
                                    },
                                    data: []
                                });
                            }
                            item.forEach(function (subItem, subidx) {
                                subItem.internal_id = subidx;
                                subItem.internal_parent_id = idx;

                                if (isChartMultiSeries) {
                                    multiData[idx].data.push({
                                        name: subItem.label,
                                        y: subItem.value,
                                        internal_id: subItem.internal_id,
                                        internal_parent_id: subItem.internal_parent_id
                                    });
                                } else {
                                    filterData = multiData.filter((aux) => aux.name === subItem.label);
                                    if (!filterData.length) {
                                        color = ColorUtils.getRandomColor(color);
                                        multiData.push({
                                            name: subItem.label,
                                            showInLegend: true,
                                            color,
                                            data: [{
                                                x: idx,
                                                y: subItem.value,
                                                internal_id: subItem.internal_id,
                                                internal_parent_id: subItem.internal_parent_id
                                            }]
                                        });
                                    } else {
                                        filterData[0].data.push({
                                            x: idx,
                                            y: subItem.value,
                                            internal_id: subItem.internal_id,
                                            internal_parent_id: subItem.internal_parent_id
                                        });
                                    }
                                }
                            });
                        } else {
                            color = ColorUtils.getRandomColor(color);
                            if (isChartLine) {
                                zoneData.push({ value: item.value, color });
                            }
                            simpleData.push({
                                color,
                                name: item.label,
                                x: idx, 
                                y: item.value,
                                internal_id: item.internal_id
                            });
                            if ($scope.enableLegend && isChartCustomLegend) {
                                legendData.push({
                                    includeInDataExport: false,
                                    color, 
                                    name: item.label,
                                    data: [{
                                        color,
                                        name: item.label,
                                        x: idx,
                                        y: item.value,
                                        internal_id: item.internal_id
                                    }],
                                    marker: {
                                        symbol: 'circle'
                                    }
                                });
                            }
                        }
                    });
                } catch (error) {
                    console.error(error);
                    throw Error('Não foi possível configurar o gráfico!');
                }

                return {
                    multiData: multiData,
                    simpleData: simpleData,
                    zoneData: zoneData,
                    legendData: legendData,
                    chartWidth: chartWidth
                };
            }

            // Renders the chart
            function renderChart(data) {
                try {
                    const {multiData, simpleData, zoneData, legendData, chartWidth} = data;
                    const isMultiData = multiData.length ? true : false;

                    const dataSeries = isMultiData
                        ?   multiData
                        :   [{
                                name: $scope.labelValue,
                                colorByPoint: true,
                                showInLegend: legendData.length ? false : true,
                                data: simpleData,
                                zones: zoneData
                            },
                            ...legendData
                        ];
        
                    Highcharts.chart($scope.chartId, {
                        chart: {
                            type: $scope.type
                        },
                        title: {
                            text: $scope.title
                        },
                        subtitle: {
                            text: $scope.subtitle
                        },
                        tooltip: {
                            formatter: function () {
                                return '<b>' + (this.point.name || this.series.name) + 
                                    '</b> <br />' + $scope.labelValue + ': <b>' + this.y + '</b>';
                            }
                        },
                        plotOptions: {
                            column: {
                                grouping: isMultiData,
                                shadow: false
                            },
                            bar: {
                                grouping: isMultiData,
                                shadow: false
                            },
                            series: {
                                events: {
                                    legendItemClick: function(e) {
                                        if (isChartCustomLegend && !isMultiData) {
                                            e.preventDefault();
                                            return false;
                                        }
                                    }
                                },
                                dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b> ({point.y:,.0f})',
                                    softConnector: true
                                },
                                center: ['40%', '50%'],
                                neckWidth: isChartMultiSeries && isMultiData ? (chartWidth / 3) + '%' :'30%',
                                neckHeight: isChartMultiSeries && isMultiData ? (chartWidth / 4) + '%' :'25%',
                                width: isChartMultiSeries && isMultiData ? chartWidth + '%' : '80%'
                            }
                        },
                        legend: {
                            enabled: $scope.enableLegend,
                            align: isChartMultiSeries && isMultiData ? 'center' : 'right',
                            verticalAlign: isChartMultiSeries && isMultiData ? 'bottom' : 'middle',
                            layout: isChartMultiSeries && isMultiData ? 'horizontal' : 'vertical'
                        },
                        xAxis: {
                            type: 'category',
                            title: {
                                enabled: true,
                                text: $scope.labelCategory
                            }
                        },
                        yAxis: {
                            title: {
                                enabled: true,
                                text: $scope.labelValue
                            }
                        },
                        series: dataSeries,
                        responsive: {
                            rules: [{
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    plotOptions: {
                                        series: {
                                            dataLabels: {
                                                inside: true
                                            },
                                            center: ['50%', '50%'],
                                            width: '100%'
                                        }
                                    },
                                    legend: {
                                        align: 'center',
                                        verticalAlign: 'bottom',
                                        layout: 'horizontal'
                                    }
                                }
                            }]
                        },
                        exporting: {
                            enabled: $scope.enableExport,
                            csv: {
                                columnHeaderFormatter: function(item) {
                                    if (!item || item instanceof Highcharts.Axis) {
                                        return $scope.labelCategory;
                                    } else {
                                        return item.name;
                                    }
                                }
                            }
                        },
                        credits: {
                            enabled: false
                        }
                    }, configDblClick);
                } catch (error) {
                    console.error(error);
                    throw Error('Não foi possível renderizar o gráfico!');
                }
            }

            // Configs the double click into chart points
            function configDblClick(chart) {
                try {
                    if (angular.isFunction($scope.doubleClickItem)) {
                        if (angular.isDefined(chart)) {
                            (angular.isDefined(chart.series) ? chart.series : []).forEach((serie) => {
                                (angular.isDefined(serie.data) ? serie.data : []).forEach((point) => {
                                    if (angular.isDefined(point.graphic)) {
                                        point.graphic.on('dblclick', () => {
                                            dispatchDblClick(point);
                                        });
                                    }
                                });
                            });
                        }
                    }
                } catch (error) {
                    console.error(error);
                    throw Error('Não foi possível realizar o duplo clique no gráfico!');
                }
            }

            // Dispatches the double click into chart point
            function dispatchDblClick(point) {
                if (angular.isDefined(point.internal_parent_id)) {
                    const filterData = dataChart.filter((item) => {
                        return item.internal_id === point.internal_parent_id;
                    });
                    if (filterData.length) {
                        const item = ObjectUtils.cloneJSON(filterData[0]);
                        dispatchDblClickItem(point, item);
                    }
                } else {
                    dispatchDblClickItem(point, dataChart);
                }
            }

            // Dispatches the double click and returns chart item data
            function dispatchDblClickItem(point, data) {
                if (angular.isDefined(point.internal_id)) {
                    const filterData = data.filter((item) => {
                        return item.internal_id === point.internal_id;
                    });
                    if (filterData.length) {
                        const item = ObjectUtils.cloneJSON(filterData[0]);
                        delete item.internal_id;
                        delete item.internal_parent_id;
                        if (angular.isFunction($scope.doubleClickItem)) {
                            $scope.doubleClickItem(item);
                        }
                    }
                }
            }

            // Gets the ordened data to chart
            function sortData(a, b) {
                if (a > b) {
                    return isReverse ? -1 : 1;
                } else if (a < b) {
                    return isReverse ? 1 : -1;
                }
                return 0;
            }
        }
    ]);

/**
 * Created by jonathan.silva on 09/09/2020.
 */
/**
 * @ngdoc directive
 * @name snk.components.chart.directive:sk-chart
 * @restrict E
 * @scope
 * @description
    skChart é um componente responsável por apresentar um gráfico.
    Tipos de Gráficos Disponíveis no Componente:
    • area
    • areaspline
    • bar
    • column
    • funnel
    • line
    • pie
    • spline
 * @param {string}   'sk-chart-id'          - id único para identificar o novo gráfico renderizado.
 * @param {object}   'sk-data-source'       - lista de dados para preencher o gráfico.
 * @param {string}   'sk-label-value'       - label que representa o valor dos elementos no gráfico (eixo Y).
 * @param {string}   'sk-label-category'    - label que representa a categoria dos elementos no gráfico (eixo X).
 * @param {string}   'sk-type'              - tipo do gráfico que será renderizado.
 * @param {string}   'sk-title'             - título do gráfico que será renderizado.
 * @param {string}   'sk-subtitle'          - subtítulo do gráfico que será renderizado.
 * @param {string}   'sk-order-by'          - ordenação dos valores dos dados crescente ou decrescente.
 * @param {boolean}  'sk-enable-legend'     - flag para ativar ou desativar a legenda do gráfico.
 * @param {boolean}  'sk-enable-export'     - flag para ativar ou desativar o botão de exportar o gráfico.
 * @param {function} 'sk-double-click-item' - função que será chamada no duplo clique nos pontos do gráfico.
 * @example
     <example module="appChart">
         <file name="appChart.html">
         	<div ng-controller="ChartController">
                <sk-chart 
                    sk-chart-id="'myChart'"
                    sk-data-source="ctrl.dataList" 
                    sk-label-value="'Label que representa o Valor'" 
                    sk-label-category="'Label que representa a Categoria'" 
                    sk-type="'funnel'"
                    sk-title="'Exemplo de Gráfico'"
                    sk-subtitle="'Descrição do Gráfico'"
                    sk-order-by="'ASC' ou 'DESC'"
                    sk-enable-legend="true ou false"
                    sk-enable-export="true ou false"
                    sk-double-click-item="ctrl.dblClick"
                ></sk-chart>
         	</div>
         </file>
         <file name="appChart.js">
            angular
                .module('appChart', ['snk'])
                .controller('ChartController', ChartController);

                function ChartController($scope) {

                    var self = this;

                    // Exemplo de Lista Simples com apenas uma lista de dados
                    self.dataList = [
                        {
                            "label":"Example 1",
                            "value": 10.0
                        },
                        {
                            "label":"Example 2",
                            "value": 15.0
                        },
                        {
                            "label":"Example 3",
                            "value": 20.0
                        }
                    ];
                    
                    // Exemplo de Multi Lista com várias listas de dados
                    self.dataMultiList = [
                        [
                            {
                                "label":"Example 1",
                                "value": 10.0
                            },
                            {
                                "label":"Example 2",
                                "value": 15.0
                            },
                            {
                                "label":"Example 3",
                                "value": 20.0
                            }
                        ],
                        [
                            {
                                "label":"Example 1",
                                "value": 5.0
                            },
                            {
                                "label":"Example 2",
                                "value": 10.0
                            },
                            {
                                "label":"Example 3",
                                "value": 15.0
                            }
                        ],
                        [
                            {
                                "label":"Example 1",
                                "value": 15.0
                            },
                            {
                                "label":"Example 2",
                                "value": 20.0
                            },
                            {
                                "label":"Example 3",
                                "value": 25.0
                            }
                        ]
                    ];

                    // Exemplo de função que será chamada no duplo clique
                    self.dblClick = function(response) {
                        alert(response.label + ': ' + response.value);
                    }
                }
         </file>
     </example>
 */
angular
    .module('snk.components.chart')
    .directive('skChart', [
        function () {
            return {
                restrict: 'E',
                controller: 'SkChartController',
                templateUrl: 'components/chart/chart.tpl.html',
                scope: {
                    dataSource: '=skDataSource',
                    type: '=skType',
                    chartId: '=?skChartId',
                    labelValue: '=?skLabelValue',
                    labelCategory: '=?skLabelCategory',
                    title: '=?skTitle',
                    subtitle: '=?skSubtitle',
                    orderBy: '=?skOrderBy',
                    enableLegend: '=?skEnableLegend',
                    enableExport: '=?skEnableExport',
                    doubleClickItem: '=?skDoubleClickItem' 
                },
            }
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.checkbox.directive:sk-checkbox
 * @restrict E
 * @description
 * A diretiva 'skCheckbox' permite você utilizar o checkbox padrão do nosso tema, este checkbox tem a opção do estado
 * indeterminado.
 *
 * Com as opções de configuração do mesmo, podemos definir os valores que o checkbox deve assumir quando estiver
 * selecionado, no estado indeterminado ou deselecionado.
 *
 * @param {expression=} [false-value=false] utilizado para passar o valor em que o skCheckbox vai assumir quando não estiver selecionado.
 *
 * @param {expression=} [true-value=true] utilizado para passar o valor em que o skCheckbox vai assumir quando estiver selecionado.
 *
 * @param {expression=} indeterminate-value utilizado para passar o valor em que o skCheckbox vai assumir quando estiver no
 * estado indeterminado. O seu valor padrão é 'undefined' e só aplica o estado no skCheckbox quando o 
 * <b>acceptIndeterminate</b> estiver ligado.
 *
 * @param {boolean=} [accept-indeterminate=false] utilizado para habilitar a funcionalidade de estado indeterminado no skCheckbox.
 * @param {string=} [tabindex=0] propriedade com comportamento identico ao tabindex dos input do HTML5.
 *
 * @scope
 *
 * @requires ngModel
 *
 * @example
     <example module="app">
         <file name="exemplo.html">
            <div ng-controller="MyController as ctrl">
                <sk-checkbox ng-model="ctrl.active">Two State Checkbox - Value: {{ ctrl.active }}</sk-checkbox>
                <br/>
                <br/>
                <sk-checkbox ng-model="ctrl.indeterminate" accept-indeterminate="true" indeterminate-value="I">Three State Checkbox - Value: {{ ctrl.indeterminate }}</sk-checkbox><br/>
                <button class="btn btn-default" ng-click="ctrl.setIndeterminate()">Setar para indeterminado</button>
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope){
                    var self = this;

                    self.active = false;
                    self.indeterminate = undefined;
                    
                    self.setIndeterminate  = function() {
                        self.indeterminate = 'I';
                    };
                    
                    self.setExample  = function() {
                        self.example = "I";
                    };
                });
         </file>
     </example>
 */

/**
 * Se tiver problemas na utilização da diretiva com o ng-model ou em determinado momento necessitar
 * dela sem o ng-model, precisa alterar o 'require' para o ng-model ser opcional e também no momento
 * de inicializar o postLink e não existir o ngModelCtrl, precisa fazer 1 implementação de ng-model
 * 'fake' para o comportamento do componente funcionar corretamente.
 * Obs.: A diretiva ng-checked não funciona porque não existe esse ng-model fake, se precisar deve ser implementado.
 *
 * Author: Marlon Maxwel
 */
angular
    .module('snk.components.checkbox')
    .directive('skCheckbox', ['SkConstants', '$timeout', 'StringUtils', '$parse', function(SkConstants, $timeout, StringUtils, $parse){
        var CHECKED_CSS = 'sk-checked';
        var INDERTEMINATE_CSS = 'sk-indeterminate';

        return {
            restrict: 'E',
            transclude: true,
            require: '^ngModel',
            priority: 210,//Run before ngAria
            template: getTemplate,
            compile: compile,
            scope: {
                onChange: "&?skChange",
            }

        };

        function compile(tElement, tAttrs) {
            tAttrs.type = 'checkbox';
            tAttrs.tabindex = tAttrs.tabindex || '0';

            tElement.attr('tabindex', tAttrs.tabindex);
            tElement.attr('role', tAttrs.type);

            return function postLink(scope, element, attr, ngModelCtrl) {
                ngModelCtrl.$render = render;

                if (angular.isUndefined(attr.falseValue)) {
                    attr.falseValue = false;
                }

                if (angular.isUndefined(attr.trueValue)) {
                    attr.trueValue = true;
                }

                if (angular.isUndefined(attr.acceptIndeterminate)) {
                    attr.acceptIndeterminate = false;
                }

                if (angular.isUndefined(attr.forceInitialValue)) {
                    attr.forceInitialValue = true;
                }

                if (!StringUtils.toBoolean(attr.acceptIndeterminate) && StringUtils.toBoolean(attr.forceInitialValue)) {
					$timeout(function() {
	                    scope.$evalAsync(function() {
	                        if(ngModelCtrl.$viewValue != attr.trueValue) {
	                            ngModelCtrl.$setViewValue(attr.falseValue);
	                            ngModelCtrl.$render();
	                        }
	                    });
                    }, 0, false);
                }

                $$watchExpr('ngDisabled', 'tabindex', {
                    true: '-1',
                    false: attr.tabindex
                });

                scope.mouseActive = false;

                element.on('click', listener)
                    .on('keypress', keypressHandler)
                    .on('mousedown', function () {
                        scope.mouseActive = true;

                        $timeout(function () {
                            scope.mouseActive = false;
                        }, 100, false);
                    })
                    .on('focus', function () {
                        if (scope.mouseActive === false) {
                            element.addClass('sk-focused');
                        }
                    })
                    .on('blur', function () {
                        element.removeClass('sk-focused');
                    });

                function $$watchExpr(expr, htmlAttr, valueOpts) {
                    if (attr[expr]) {
                        scope.$watch(attr[expr], function (val) {
                            if (valueOpts[val]) {
                                element.attr(htmlAttr, valueOpts[val]);
                            }
                        });
                    }
                }

                function keypressHandler(event) {
                    var keyCode = event.which || event.keyCode;

                    if (keyCode === SkConstants.KEY_CODE.SPACE || keyCode === SkConstants.KEY_CODE.ENTER) {
                        event.preventDefault();

                        if (!element.hasClass('sk-focused')) {
                            element.addClass('sk-focused');
                        }

                        listener(event);
                    }
                }

                function listener(event) {
                    if (element[0].hasAttribute('disabled')) return;

                    scope.$apply(function () {
                        var viewValue = ngModelCtrl.$viewValue;

                        if (viewValue == undefined || viewValue == attr.falseValue) {
                            viewValue = attr.trueValue;
                        } else {
                            viewValue = attr.falseValue;
                        }
                        
                        ngModelCtrl.$setViewValue(viewValue, event && event.type);
                        ngModelCtrl.$render();
                        if(scope.onChange){
                            scope.onChange();
                        }
                    });

                    event.preventDefault();
                }

                function render() {
                    element.removeClass(CHECKED_CSS);
                    element.removeClass(INDERTEMINATE_CSS);

                    if (ngModelCtrl.$viewValue == attr.indeterminateValue && attr.acceptIndeterminate) {
                        element.addClass(INDERTEMINATE_CSS);
                    } else if (ngModelCtrl.$viewValue == attr.trueValue) {
                        element.addClass(CHECKED_CSS);
                    }
                }
            };
        }

        function getTemplate() {
            return '<div class="sk-container">' +
            '<div class="sk-icon"></div>' +
            '</div>' +
            '<div ng-transclude class="sk-label"></div>';
        }
    }]);
angular
    .module('snk.components.checkboxlist')
    .controller('SkCheckboxListController', ['$scope', 'ArrayUtils',
        function ($scope, ArrayUtils) {

            $scope.checkBoxAll = false;

            $scope.atualizaCheckBoxLista = atualizaCheckBoxLista;
            $scope.notifyChange = notifyChange;

            init();

            function init() {
                refreshDataProvider();

                $scope.$watch('options', function (newValue, oldValue) {
                    refreshDataProvider();
                });

                $scope.$watchCollection('dataProvider', function (newValue, oldValue) {
                    notifyChange();
                });

                $scope.$watchCollection('value', function (newValue, oldValue) {
                    updateCheckBoxHeader();
                    if (!newValue) {
                        atualizaCheckBoxLista();
                    }
                });
            }

            function atualizaCheckBoxLista() {
                for (var i = 0, length = $scope.options.length; i < length; i++) {
                    var item = $scope.options[i];
                    item.checked = $scope.checkBoxAll;
                }

                notifyChange();
            }

            function notifyChange(item) {
                if (!$scope.value) {
                    $scope.value = [];
                }

                if (item) {
                    if ($scope.value.indexOf(item.data) < 0) {
						if($scope.singleSelection && !angular.isUndefined($scope.options)){
							$scope.value = [];
							$scope.options.forEach(function (position) {
								position.checked = false;
							});
						}
                        $scope.value.push(item.data);
                    } else {
                        ArrayUtils.removeReference($scope.value, item.data);
                    }
                } else {
                    $scope.value.length = 0;

                    for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                        var item = $scope.dataProvider[i];

                        if ($scope.checkBoxAll === true) {
                            item.checked = true;
                            $scope.value.push(item.data);
                        } else if (item.checked) {
                            $scope.value.push(item.data);
                        }
                    }
                }
                updateCheckBoxHeader();
                $scope.onChange();
            }

            function updateCheckBoxHeader() {
                if (ArrayUtils.toArray($scope.value).length <= 0) {
                    $scope.checkBoxAll = false;
                } else if ($scope.value.length == $scope.dataProvider.length) {
                    $scope.checkBoxAll = true;
                } else {
                    $scope.checkBoxAll = 'I';
                }
            }

            function refreshDataProvider() {
                if (angular.isArray($scope.options)) {
                    $scope.dataProvider = $scope.options.slice(0);
                    if ($scope.value && $scope.value.length) {
                        $scope.value.forEach(function (selectedData) {
                            var newItem = ArrayUtils.find($scope.dataProvider, function (currItem) {
                                return currItem.data == selectedData;
                            });

                            //Se o novo item n�o existir no dataprovaider removemos ele dos values
                            if (!newItem) {
                                ArrayUtils.removeReference($scope.value, selectedData, true);
                            } else if (!newItem.hasOwnProperty('checked') || !newItem.checked) {
                                newItem.checked = true;
                            }
                        });
                    } else {
                    	$scope.checkBoxAll = false;
                    }
                    notifyChange();
                } else {
                    throw new Error('sk-checkbox-list: O atributo sk-options deve ser um array de objetos!');
                }
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.checkboxlist.directive:sk-checkbox-list
 * @restrict E
 * @scope
 * @description
    Componente para apresentação de uma lista do tipo "Checklist".
 * @param {sk-label} [sk-label=undefined]
    Label que será apresentado no cabeçalho do componente.
 *
 * @param {sk-options} [sk-options=undefined]
    Array de objetos contendo o dado e o label a ser apresentado em cada item da lista.
 *
 * @param {sk-on-change} [sk-on-change=undefined]
    Função a ser executada quando algum item da lista for marcado ou desmarcado
 *
 * @param {sk-value} [sk-value=undefined]
    Neste array será feito o bind com os objetos marcados na lista.<br>
    Atenção: Essa diretiva modifica diretamente a variável aqui informada.
 *
 * @example
     <example module="app">
         <file name="exemplo.html">
            <div ng-controller="MyController as ctrl">
                <sk-checkbox-list
                    sk-label="Usuário"
                    sk-options="ctrl.options"
                    sk-on-change="ctrl.onChange()"
                    sk-value="ctrl.value">
                </sk-checkbox-list>
                <div>
                    <span>Selected Values: {{ctrl.value}}<span>
                </div>
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope){
                    var self = this;

                    self.options = [
                        {
                            data: 'J',
                            value: 'João',
                            checked: false
                        },
                        {
                            data: 'M',
                            value: 'Maria',
                            checked: true
                        }
                    ];

                    self.value = '';

                    self.onChange = function() {
                        console.log('The selection values has changed!');
                    }
                });
         </file>
     </example>
 */
angular
    .module('snk.components.checkboxlist')
    .directive('skCheckboxList',[function() {
        var directive = {};

        directive.restrict = 'E';
        directive.templateUrl = 'components/checkboxlist/checkboxlist.tpl.html';
        directive.controller = 'SkCheckboxListController';
        directive.scope = {
            label: "@skLabel",
            options: "=skOptions",
            onChange: "&skOnChange",
            value: "=skValue",
            singleSelection: "=skSingleSelection"
        };

        return directive;
    }]);

angular
    .module('snk.components.collapse')
    .directive('collapse',['$animate',function($animate) {
        return {
            link: function (scope, element, attrs) {
                function expand() {
                    element.removeClass('collapse')
                        .addClass('collapsing')
                        .attr('aria-expanded', true)
                        .attr('aria-hidden', false);

                    $animate.addClass(element, 'in', {
                        to: {height: element[0].scrollHeight + 'px'}
                    }).then(expandDone);
                }

                function expandDone() {
                    element.removeClass('collapsing');
                    element.css({height: 'auto'});
                }

                function collapse() {
                    if (!element.hasClass('collapse') && !element.hasClass('in')) {
                        return collapseDone();
                    }

                    element
                        // IMPORTANT: The height must be set before adding "collapsing" class.
                        // Otherwise, the browser attempts to animate from height 0 (in
                        // collapsing class) to the given height here.
                        .css({height: element[0].scrollHeight + 'px'})
                        // initially all panel collapse have the collapse class, this removal
                        // prevents the animation from jumping to collapsed state
                        .removeClass('collapse')
                        .addClass('collapsing')
                        .attr('aria-expanded', false)
                        .attr('aria-hidden', true);

                    $animate.removeClass(element, 'in', {
                        to: {height: '0'}
                    }).then(collapseDone);
                }

                function collapseDone() {
                    element.css({height: '0'}); // Required so that collapse works when animation is disabled
                    element.removeClass('collapsing');
                    element.addClass('collapse');
                }

                scope.$watch(attrs.collapse, function (shouldCollapse) {
                    if (shouldCollapse) {
                        collapse();
                    } else {
                        expand();
                    }
                });
            }
        }
    }]);
angular
    .module('snk.components.colorpicker')
    .controller('SkColorPickerController', ['$scope', '$timeout', '$element', 'StringUtils', 'DropdownUtil', 'UserAgentUtils', 'NumberUtils', 'ObjectUtils', 'AngularUtil', 'ColorUtils','i18n',
        function ($scope, $timeout, $element, StringUtils, DropdownUtil, UserAgentUtils, NumberUtils, ObjectUtils, AngularUtil, ColorUtils, i18n) {
            var self = this;

            var _popupElement;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData,
                setNgModelCtrl: setNgModelCtrl
            });

            self.preSelectedColor           = angular.isDefined($scope.value) ? ColorUtils.getHexCodeFromDecimal($scope.value) : '';
            self.isMobile                   = UserAgentUtils.isMobile();
            self.collorsPallet              = getColorsPallet();

            self.togglePallet               = togglePallet;
            self.changeColorOnHover         = changeColorOnHover; 
            self.selectColor                = selectColor;
            self.keyDownHandler             = keyDownHandler;
            self.setData                    = setData;
            self.setNgModelCtrl             = setNgModelCtrl;

            self.toolTip=$scope.toolTip?i18n($scope.toolTip):i18n("Geral.tooltipSelecioneCor");

            init();

            $scope.$watch('value', function (newValue){
                
                if (self.preSelectedColor) {                  
                    if(ColorUtils.isHexaColor(newValue)){
                        selectColor(newValue);
                    }else{
                        selectColor(NumberUtils.isNumeric(newValue) ? ColorUtils.getHexCodeFromDecimal(newValue) : newValue);                                             
                    }
                }else if($scope.defaultColor){
                    self.selectedColor = $scope.defaultColor;
                }
            }, true);

            function init() {
            }

            function getColorsPallet() {
                var dp = [];
                var arr = [];

                var n = 0;

                if(angular.isArray($scope.dataProvider) && $scope.dataProvider.length > 0) {
                    $scope.dataProvider.forEach(function(item) {
                        arr.push({id:n, value: item.toLowerCase()});
                         if(arr.length == 20) {
                            dp.push(arr);
                            arr = [];
                        }
                        n++;
                    });

                    if(dp.length - 1 < 0 || dp[dp.length - 1] != arr) {
                        dp.push(arr);
                    }
                    return dp;
                }

                var spacer = "0x000000";

                var c1 = ["0x000000", "0x333333", "0x666666", "0x999999",
                    "0xCCCCCC", "0xFFFFFF", "0xFF0000", "0x00FF00",
                    "0x0000FF", "0xFFFF00", "0x00FFFF", "0xFF00FF"];

                var ra = ["00", "00", "00", "00", "00", "00",
                    "33", "33", "33", "33", "33", "33",
                    "66", "66", "66", "66", "66", "66"];

                var rb = ["99", "99", "99", "99", "99", "99",
                    "CC", "CC", "CC", "CC", "CC", "CC",
                    "FF", "FF", "FF", "FF", "FF", "FF"];

                var g = ["00", "33", "66", "99", "CC", "FF",
                    "00", "33", "66", "99", "CC", "FF",
                    "00", "33", "66", "99", "CC", "FF"];

                var b = ["00", "33", "66", "99", "CC", "FF",
                    "00", "33", "66", "99", "CC", "FF"];

                for (var x = 0; x < 12; x++) {
                    for (var j = 0; j < 20; j++) {
                        var item;

                        if (j == 0) {
                            item = c1[x];
                        } else if (j == 1) {
                            item = spacer;
                        } else {
                            var r;
                            if (x < 6) {
                                r = ra[j - 2];
                            } else {
                                r = rb[j - 2];
                            }
                            item = "0x" + r + g[j - 2] + b[x];
                        }

                        arr.push({id: n, value: item});
                        if(arr.length == 20) {
                            dp.push(arr);
                            arr = [];
                        }
                        n++;
                    }
                }
                return dp;
            }

            function togglePallet() {
                if(!$scope.enabled) {
                    return;
                }
                
                if (DropdownUtil.isOpen(_popupElement)) {
                    hidePopup();
                } else {
                    if (!_popupElement) {
                        createPopup();
                    } else {
                        showPopup();
                    }
                }
            }

            function createPopup() {
                DropdownUtil.create($scope, 'components/colorpicker/colorpickerpopup.tpl.html')
                    .then(function (popup) {
                        _popupElement = popup;

                        showPopup();
                    });
            }

            function showPopup() {
                var startHeight = self.isMobile ? 50 : 35;
                var config = {
                    width: self.isMobile ? 415 : 271,
                    maxWidth: self.isMobile ? 415 : 271,
                    height: startHeight + (14 * self.collorsPallet.length)  
                };

                DropdownUtil.open(_popupElement, $element, config);
            }

            function hidePopup() {
                DropdownUtil.close(_popupElement);
            }

            function changeColorOnHover(newColor) {
                self.preSelectedColor = pureColor(newColor);
            }

            function selectColor(color) {
            	$scope.value = self.selectedColor = angular.isDefined(color) ? pureColor(color).toUpperCase() : undefined;
                self.preSelectedColor = angular.isDefined(color) ? self.selectedColor : '';
                if(!$scope.colorPickerTreemap){
                    self.notifyChangeToDataset();
                }
                hidePopup();
            }

            function keyDownHandler(event) {
                if(event.keyCode == 13) {
                    selectColor(self.preSelectedColor);
                }
            }

            function setData(data) {
                $scope.value = data;
                self.preSelectedColor = self.selectedColor =  data ? ColorUtils.getHexCodeFromDecimal(data) : undefined;
                runOnChange();
            }

            function getData() {                
                if(($scope.fieldName || $scope.fieldIndex) && $scope.dataset){
                    var fieldMD = $scope.fieldName ? $scope.dataset.getFieldMetadata($scope.fieldName) : $scope.dataset.getFieldMetadataByIndex($scope.fieldIndex);
                    if(fieldMD && fieldMD.dataType == 'I' && angular.isDefined($scope.value) && !angular.isNumber($scope.value)){
                        return NumberUtils.hexToDecimal($scope.value);
                    }    
                }else if($scope.dataType && $scope.dataType == 'I' && angular.isDefined($scope.value) && !angular.isNumber($scope.value)){
                    return NumberUtils.hexToDecimal($scope.value);
                }

                return $scope.value;
            }

            function runOnChange() {
                if (self.onChange) {
                    $timeout(function(){
                        self.onChange($scope);
                    });
                }
            }

            function setNgModelCtrl(ngModelCtrl) {
                
            }

            function pureColor(color) {
                if(angular.isUndefined(color)) {
                    return '';
                }

                return color.toString().replace('0x', '').replace('#','');;
            }
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.colorpicker.directive:sk-color-picker
 * @restrict E
 * @description
 * Este é o componente responsável por possibilitar que uma cor seja escolhida.
 * @param {SkDataset} [sk-dataset=undefined] ID do Dataset.
 * @param {string} [sk-field-name=undefined] Nome do campo dentro do dataset.
 * @param {string} [sk-field-index=undefined] Índice do campo que este componente irá se registrar no dataset.
 * @param {boolean} [sk-enabled=true] Habilita ou não o componente para edição do usuário.
 * @param {string} [sk-value=undefined] Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset).
 * @param {Array} [sk-data-provider=undefined] Array de Strings, onde cada string representa a cor que será exibida na paleta. Ex: ["0x000000","0x00FF00"].
 * @param {function} [sk-change=undefined] Função de listener de alteração do valor do componente.
 * @param {boolean} [sk-square-mode=false] Define se o componente deve ser apresentado como um quadrado, ao invés de um círculo.
 * @param {boolean} [sk-disable-unselect-color=false] Possibilita esconder a opção de remover a cor selecionada. 
 * @param {string} [sk-default-color] cor padrão caso o sk-value seja undefined
 */
angular
    .module('snk.components.colorpicker')
    .directive('skColorPicker',function() {
        return {
            templateUrl: 'components/colorpicker/colorpicker.tpl.html',
            controller: 'SkColorPickerController',
            controllerAs: '$ctrl',
            scope: {
                dataset: '=skDataset',
                fieldName: '@?skFieldName',
                fieldIndex: '@?skFieldIndex',
                enabled: '=?skEnabled',
                value: '=?skValue',
                dataProvider: '=?skDataProvider',
                onChange: '=?skOnChange',
                squareMode: '=?skSquareMode',
                showColorTextInput: "=?skShowColorTextInput",
                disableUnselectColor: '=?skDisableUnselectColor',
                dataType: '=?skDataType',
                defaultColor: '@?skDefaultColor',
                toolTip: '@?skToolTip',
                colorPickerTreemap: '=?skColorPickerTreemap',
            }
        }
    });

/*
 * Created Italo Araujo on 27/04/2022.
 */
angular
    .module('snk.components.compactpanel')
    .controller('SkCompactPanelController', ['ArrayUtils', '$document', '$scope', 'ObjectUtils', 'i18n', 'AngularUtil', 'NumberUtils', '$interval', '$timeout','StringUtils',
        function (ArrayUtils, $document, $scope, ObjectUtils, i18n, AngularUtil, NumberUtils, $interval, $timeout, StringUtils) {
            var self = this;

            self.buildCompactPanelBottom = buildCompactPanelBottom;
            self.initCompactPanelBottom = initCompactPanelBottom;
            self.removeControl = removeControl;
            self.canShowPanel = canShowPanel;
            self.getRemovePanel = getRemovePanel;
            self.setRemovePanel = setRemovePanel;
            self.onClickBtnRefresh = onClickBtnRefresh;
            self.onClickBtnConfig = onClickBtnConfig;
            self.containerIsMaximized = containerIsMaximized;
            self.maximizeControl = maximizeControl;
            self.getDataTooltip = getDataTooltip;
            self.resizeRows = resizeRows;
            self.resizeColumns = resizeColumns;
            self.updateDataPanel = updateDataPanel;
            self.resetDashBoardLayout = resetDashBoardLayout;
            self.onResizePanel = onResizePanel;

            self.maximizedId = null;
            self.removedPanel = [];
            self.isLoad = false;

            self.showBtnMaximize = $scope.showtBtnMaximize;
            self.showBtnClose = $scope.showBtnClose;
            self.showBtnRefresh = $scope.showBtnRefresh;
            self.showBtnConfig = $scope.showBtnConfig;

            self.uid =StringUtils.nextUid();
            self.compactPanelId="compact-panel-id"+ self.uid;

            initCompactPanelBottom();

            $scope.$watch('dataPanel', function() {
                if (angular.isDefined($scope.dataPanel)) {
                    self.isLoad = false;
                    buildCompactPanelBottom();
                }
            });

            function initCompactPanelBottom() {
                if (angular.isFunction($scope.onCreated)) {
                    $scope.onCreated({component: self});
                }
            }

            function getRemovePanel(){
                return self.removedPanel;
            }

            function setRemovePanel(value){
                self.removedPanel = value;
            }

            function canShowPanel (id) {
                for (let el of self.removedPanel) {
                    if(id == el) {
                        return false;
                    }
                }
                return true;
            }

            function setMinSize(element) {
                if($scope.minHeight){
                    element.style['minHeight'] = $scope.minHeight + 'px';
                }

                if($scope.minHeight){
                    element.style['minWidth'] = $scope.minWidth + 'px';
                }
            }

            function buildCompactPanelBottom() {
                if ($scope.dataPanel) {
                    self.dataPanel = $scope.dataPanel;
                    self.isLoad = true;

                    $timeout(function() {
                        angular.forEach(self.dataPanel , function(painelInfo, id) {
                            if (angular.isObject(painelInfo.colunas)) {
                                painelInfo.colunas = Object.keys(painelInfo.colunas).map(key => painelInfo.colunas[key])
                            }

                            angular.forEach(painelInfo.colunas, function(coluna, index) {
                                let compactContanier = document.querySelectorAll('#COMPACT-PANEL-CONTAINER-'+ self.uid+ id.toString() + index);
                                let element = angular.element(compactContanier);
                                element.html('');

                                if(coluna.content){
                                    if($scope.parentCompile){
                                        setMinSize(coluna.content[0]);

                                        element.append(coluna.content);
                                        AngularUtil.compile(element, $scope.$parent);
                                    }else{
                                        let scopeKey = coluna.identificador.replace(/-/g,'_');
                                        $scope[scopeKey] = coluna;

                                        if(coluna.content.element){
                                            let conteudo = coluna.content.element;
                                            conteudo.attr($scope.tagScope, scopeKey);
                                            element.append(conteudo);
                                        }
                                        AngularUtil.compile(element, $scope);
                                    }
                                }
                            });
                        });
                    }, 100);
                }
            }

            function onResizePanel(component){
                let arraySize = [];
                let elementParent = document.querySelectorAll('sk-resizable-columns.compact-panel-resizable-column');
                if(angular.isDefined(elementParent)){
                    for(let element of elementParent) {
                        let childs = element.childNodes;
                        let len = childs.length, i = -1;

                        if(++i < len)
                            do {
                                let filho = childs[i];
                                if(filho.localName == 'sk-vbox'){
                                    let atualSize = filho.getAttribute('sk-relative-size');
                                    if(atualSize != null){
                                        arraySize.push(atualSize);
                                    }
                                }
                            } while(++i < len);

                    }
                }


                let count = 0;

                let paineis = $scope.dataPanel;
                angular.forEach(paineis, function(painelInfo, id) {
                    if (angular.isObject(painelInfo.colunas)) {
                        painelInfo.colunas = Object.keys(painelInfo.colunas).map(key => painelInfo.colunas[key])
                    }

                    angular.forEach(painelInfo.colunas, function (coluna, index) {
                        if(angular.isDefined(coluna.config)){
                            coluna.config['WIDTH'] = arraySize[count];
                            count = count + 1;
                        }
                    });
                });

                $scope.dataPanel = paineis;

                if(angular.isFunction($scope.onResizeCompactPanel)){
                    $scope.onResizeCompactPanel();
                }
            }

            function updateDataPanel(newValue){
                $scope.dataPanel = newValue;
            }

            function resizeRows(painelLines, currentLine){
                if(angular.isDefined(currentLine.config)){
                    return currentLine.config.HEIGHT;
                }else{
                    return calculateDefaultPanelHeight(painelLines) + 'px';
                }
            }

            function resizeColumns(painelColumns, painel){
                if(angular.isDefined(painel.config)){
                    return convertWidthToOffsetWidth(painelColumns.colunas, painel);
                }else{
                    let objectColumns = Object.keys(painelColumns.colunas);
                    return calculateDefaultWidth(objectColumns);
                }
            }

            function resetDashBoardLayout(){
                let paineis = $scope.dataPanel;
                let compactPanelWidth = getOffSetWidth();
                let compactPanelHeight = getOffSetHeight();

                angular.forEach(paineis, function(painelInfo, id) {
                    if (angular.isObject(painelInfo.colunas)) {
                        painelInfo.colunas = Object.keys(painelInfo.colunas).map(key => painelInfo.colunas[key])
                    }

                    let widthDefault = compactPanelWidth / painelInfo.colunas.length;

                    angular.forEach(painelInfo.colunas, function (coluna, index) {

                        if(parseInt(ObjectUtils.getProperty(coluna, 'config.WIDTH')) === parseInt(widthDefault)){
                            widthDefault = widthDefault - 1;
                        }

                        ObjectUtils.setProperty(coluna, 'config.WIDTH', widthDefault);
                    });

                    let heithtDefault = compactPanelHeight / paineis.length;
                    if(parseInt(ObjectUtils.getProperty(painelInfo, 'config.HEIGHT')) === parseInt(heithtDefault)){
                        heithtDefault = heithtDefault - 1;
                    }

                    ObjectUtils.setProperty(painelInfo, 'config.HEIGHT', heithtDefault);
                });

                $interval(function() {
                    $scope.dataPanel = paineis;
                }, 500);
            }

            function getOffSetWidth(){
                let compactPanelId = document.querySelectorAll('#'+self.compactPanelId);
                let compactPanelElement = angular.element(compactPanelId);
                let compactPanelWidth = compactPanelElement[0].offsetWidth - 100;
                return compactPanelWidth;
            }

            function getOffSetHeight(){
                let compactPanelId = document.querySelectorAll('#'+self.compactPanelId);
                let compactPanelElement = angular.element(compactPanelId);
                let compactPanelHeight = compactPanelElement[0].offsetHeight;
                return compactPanelHeight;
            }

            function calculateDefaultPanelHeight(painel){
                if(ArrayUtils.isNotEmpty(painel)){
                    let quantidade = painel.length;
                    let tamanho = getOffSetHeight() / quantidade;
                    return tamanho;
                }
            }

            function calculateDefaultWidth(painel){
                let quantidade = painel.length;
                let tamanho = getOffSetWidth() / quantidade;
                return tamanho;
            }

            function convertWidthToOffsetWidth(painelColumns, currentPainel){
                let totalWidth = 0;
                let tamanho;
                let offSet = getOffSetWidth();

                angular.forEach(painelColumns, function(painel) {
                    if(angular.isDefined(painel.config)){
                        totalWidth += NumberUtils.stringToNumber(painel.config.WIDTH);
                    }
                });

                let percent = NumberUtils.stringToNumber(currentPainel.config.WIDTH) / totalWidth * 100;
                tamanho = (offSet * percent) / 100;
                return tamanho;
            }

            function removeControl(id, titulo){
                let newDataPanel = [];

                angular.forEach($scope.dataPanel, function(painelInfo, index) {
                    let paineisNovos = [];

                    angular.forEach(painelInfo.colunas, function (coluna, index) {
                         if(coluna.identificador != id){
                             paineisNovos.push(coluna);
                         }else {
                             self.removedPanel.push(coluna);
                         }
                    })

                    painelInfo.colunas = paineisNovos;
                    newDataPanel.push(painelInfo);
                });

                $scope.dataPanel = newDataPanel;

                if(angular.isFunction($scope.closePanelFunction)){
                    $scope.closePanelFunction({id: id, titulo: titulo.toString()});
                }

                if(angular.isFunction($scope.afterClosePanelFunction)){
                    $scope.afterClosePanelFunction({id: id, titulo: titulo.toString()});
                }
            }

            function onClickBtnRefresh(id){
                if(angular.isFunction($scope.refreshPanelFunction)){
                    $scope.refreshPanelFunction({id: id});
                }
            }

            function onClickBtnConfig(id){
                if(angular.isFunction($scope.configPanelFunction)){
                    $scope.configPanelFunction({id: id});
                }
            }

            function containerIsMaximized(id) {
                return self.maximizedId === id;
            }

            function maximizeControl(id) {
                if (self.containerIsMaximized(id)) {
                    self.maximizedId = null;
                } else {
                    self.maximizedId = id;
                }

                if(angular.isFunction($scope.refreshPanelFunction)){
                    $scope.refreshPanelFunction({id: id});
                }
            }

            function getDataTooltip(id) {
                return self.containerIsMaximized(id) ? i18n('Controls.Dashboard.buttonRestaurar') :  i18n('Controls.Dashboard.buttonMaximizar');
            }

        }]);

angular
    .module('snk.components.compactpanel')
    .directive('skCompactPanel', [function () {
        return {
            templateUrl: 'components/compactpanel/compact-panel.tpl.html',
            controller: 'SkCompactPanelController',
            controllerAs: 'ctrl',
            scope: {
                onCreated: '&skOnCreated',
                dataPanel: '=skDataPanel',
                tagScope: '@?skTagScope',
                parentCompile : '=?skParentCompile',
                closePanelFunction: '&?skClosePanelFunction',
                refreshPanelFunction: '&?skRefreshPanelFunction',
                configPanelFunction: '&?skConfigPanelFunction',
                afterClosePanelFunction: '&?skAfterClosePanelFunction',
                showBtnClose : '=?skShowBtnClose',
                showtBtnMaximize : '=?skShowBtnMaximize',
                showBtnRefresh : '=?skShowBtnRefresh',
                showBtnConfig : '=?skShowBtnConfig',
                onResizeCompactPanel: '&?skOnResizeCompactPanel',
                minHeight : '=?skMinHeigh',
                minWidth : '=?skMinWidth',
            }
        }
    }]);


angular
    .module('snk.components.configurableform')
    .controller("SkConfigurableFormController", ['$scope', '$attrs', '$q', 'ArrayUtils', 'FormService', 'ObjectUtils', '$element', 'WhenReady',
        function ($scope, $attrs, $q, ArrayUtils, FormService, ObjectUtils, $element, WhenReady) {
            var self = this;

            const _mdByName = {};
            const _programaticalyChanges = {};

            let _configuration;
            let _enabledChangedByScreen = {};
            let _requiredChangedByScreen = {};
            let _formApi;
            let _whenFormReady = WhenReady();            

            $scope.hasConfig = false;

            self.formProps;
            self.formConfig;
            self.setConfig = setConfig;
            self.getMdByName = getMdByName;
            self.canChangeRequiredState = canChangeRequiredState;
            self.canChangeEnabledState = canChangeEnabledState;
            self.onCreateField = onCreateField;
            self.onFormLoaded = onFormLoaded;
            self.setFieldFocus = setFieldFocus;
            self.getPropChangedProgramaticaly = getPropChangedProgramaticaly;
            
            //Pùblic API
            self.setFieldProperty = setFieldProperty;
            self.setFieldFocus = setFieldFocus;

            init();

            function init(){
                if ($attrs.skDataset) {
                    var unWatch = $scope.$watch('dataset', function(newDs) {
                       if (newDs) {                          
                            
                            $scope.dataset.whenMetadataLoaded().then(function(){
                                buildFormPropsFromDs();
                            });
                            
                            unWatch();
                       }
                    });
                }else if($attrs.properties){

                    var unWatch = $scope.$watch('properties', function(newDs) {
                        if (newDs) {                                                                                    
                            buildLayout();                             
                            unWatch();
                        }
                     });

                }else{
                    throw new Error('[SkConfigurableFormController] A diretiva sk-dataset ou properties deve ser informada.');
                }

                if ($scope.compact == "true") {
                    $element.find('#form').addClass('compact-components');
                }

                $scope.api = ObjectUtils.buildPublicAPI(self, ['setFieldProperty', 'setFieldFocus']);

                if(angular.isFunction($scope.onCreated)) $scope.onCreated({formApi : $scope.api});
            };

            function onFormLoaded(form){
                _formApi = form;
                if(self.formProps){
                    _whenFormReady.ready();
                }
            }

            function buildFormPropsFromDs(){
                whenConfigLoaded().then(buildLayout);
            }

            function buildLayout(){
                 //Normalizando metadados
                 let dataSetMetadata = angular.copy(getMetadata()).map(normalizeItem);
                    
                 //Configuração de apresentação e ordenação
                 let datasetFields = angular.copy(dataSetMetadata).map(item => { return {name: item.fieldName}});
                 var configFields;
                 
                 if($scope.hasConfig) {
                	  if(angular.isArray(_configuration.layout.field)) {
                		  configFields = _configuration.layout.field;
                	  } else {
                		  configFields = [_configuration.layout.field]
                	  }
                 } else if($scope.availableColumnsStandard) {
                	 if(angular.isArray($scope.availableColumnsStandard)) {
                		 configFields = $scope.availableColumnsStandard;
                	 } else {
                		 configFields = [$scope.availableColumnsStandard];
                	 }
                 } else {
                	 configFields = datasetFields;
                 }
                 
                 //Configuracao de campos
                 let config = _configuration ? _configuration.metadata : undefined;
                 let mdConf;
                 
                 if(config && Object.keys(config).length > 0){
                    mdConf = angular.isArray(config.field) ? config.field : [config.field]
                 }
                 
                 datasetFields.forEach(datasetField => {
                     if (configFields.map(function(e) { return e.name; }).indexOf(datasetField.name) < 0) {
                    	 $scope.dataset.makeFieldNonRequired(datasetField.name);
                     }
                 });

                 //Propriedades temporarias para evitar o digest do agnuarjs
                 let tempProps = [];
                 
                 if ($scope.fieldsOrder) {
                	 configFields.sort(function (fieldA, fieldB) {
                         return $scope.fieldsOrder.indexOf(fieldA.name) - $scope.fieldsOrder.indexOf(fieldB.name);
                     });
                 }

                 configFields.forEach(configField => {
                     let field = _mdByName[configField.name];

                     if(!field) {
                         console.warn("[SkConfigurableFormController] Metadados do campo " + configField.name + " não encontrado.");
                         return;
                     }
                     //Configuracao de metadata
                     let fConfig;                        
                     if(mdConf){
                         fConfig = ArrayUtils.find(mdConf, fProp => fProp.name == field.fieldName );
                     }
                     
                     configureField(field, fConfig);

                     tempProps.push(field);                        
                 });

                 self.formProps = tempProps;

                if(_formApi){
                    _whenFormReady.ready();
                }
            }

            function normalizeItem(fMd){
                if(fMd.name){
                    fMd.fieldName = fMd.name;
                    delete fMd.name;
                }

                if(fMd.properties){
                    fMd.fieldProp = fMd.properties;
                    delete fMd.fieldProp;
                }

                _mdByName[fMd.fieldName] = fMd;

                return fMd;
            }

            function setConfig(config, rebuild){
                _configuration = config;

                $scope.hasConfig = _configuration != null && _configuration.layout != null && Object.keys(_configuration.layout).length > 0;

                if(rebuild){
                    self.formConfig.setConfig(_configuration);
                    buildLayout();
                }
            }

            function configureField(fieldMD, cfg){
                var fieldName =  fieldMD.fieldName;
                
                //Description
                if(getPropChangedProgramaticaly(fieldName, 'description') != undefined){
                    
                    fieldMD.description = getPropChangedProgramaticaly(fieldName, 'description');

                }else if (cfg && cfg.hasOwnProperty('userDescription')) {
                    fieldMD.description = cfg.userDescription;
                }
                
                //Required
                if(getPropChangedProgramaticaly(fieldName, 'required') != undefined){
                    fieldMD.required = getPropChangedProgramaticaly(fieldName, 'required');
                }else if (cfg && cfg.hasOwnProperty('userRequired')) {
                    fieldMD.originalRequired = angular.copy(fieldMD.required != undefined ? fieldMD.required : false);
                    fieldMD.requiredChangedByCfg = true;
                    fieldMD.required = "S" == cfg.userRequired;                   
                } else {
                   fieldMD.required = isFieldRequired(fieldMD);
                }
                
                if ($scope.dataset) {
                    if (fieldMD.required) {
                        $scope.dataset.makeFieldRequired(fieldName);
                    } else {
                        $scope.dataset.makeFieldNonRequired(fieldName);
                    }
                }
                
                //Enabled
                if(getPropChangedProgramaticaly(fieldName, 'enabled') != undefined){
                    fieldMD.enabled = getPropChangedProgramaticaly(fieldName, 'enabled');
                }else if (cfg && cfg.hasOwnProperty('userReadOnly')) {
                    fieldMD.originalEnabled = angular.copy(fieldMD.enabled != undefined ? fieldMD.enabled : false);
                    fieldMD.enabledChangedByCfg = true;
                    fieldMD.enabled = "N" == cfg.userReadOnly;
                }
                
                //GroupName
                if (cfg && cfg.hasOwnProperty('userGroupName')) {
                    fieldMD.groupName = cfg.userGroupName;
                }
            }

            function whenConfigLoaded() {
                return $q(function (resolve, reject) {
                    if ($scope.hasConfig) {
                        resolve();
                    } else {
                        let removewatch = $scope.$watch('hasConfig', function(newV){
                            if(newV != undefined){
                                removewatch();
                                resolve();
                            } else {
                                resolve();
                            }
                        });
                    }
                });
            }

            function isFieldRequired(fieldMD){
                if(fieldMD.hasDefaultValue) {
                    return false;
                }else if(fieldMD.isAutoNum){
                    return false;
                }else if(fieldMD.isNuable){
                    return false;				
                }
                return fieldMD.originalRequired != undefined ? fieldMD.originalRequired : fieldMD.required;
            }

            function getMetadata(){
                if($scope.dataset){
                    return buildFormPropsByDs($scope.dataset);
                }else{
                    return $scope.properties;
                }
            }

            function getMdByName(){
                return _mdByName;
            }

            function onCreateField(uiField){
                field = getMdByName()[uiField.fieldName];

                if(!field) return;

                if (uiField.enabled != field.originalEnabled && !field.enabledChangedByCfg) {
					_enabledChangedByScreen[field.fieldName] = uiField.enabled;
                }
                
                if (uiField.required != isFieldRequired(field) && !field.requiredChangedByCfg) {
					_requiredChangedByScreen[field.fieldName] = uiField.required;
				}

            }

            function canChangeRequiredState(fieldInfo){
                const fieldName = fieldInfo.field;
                field = getMdByName(fieldName)[fieldName];

                if (_requiredChangedByScreen.hasOwnProperty(fieldName)) {
                    return _requiredChangedByScreen[fieldName];
                } else if (field){
                    return !isFieldRequired(field);
                }

                return true;
            }

            function canChangeEnabledState(fieldInfo){
                const fieldName = fieldInfo.field;
                let field = getMdByName()[fieldName];

                if (_enabledChangedByScreen.hasOwnProperty(fieldName)) {
                    return _enabledChangedByScreen[fieldName];
                } else if(field){
                    return !field.isReadOnly;
                }

                return true;
            }

            function buildFormPropsByDs(dataset){
                
                var foreignKeysLocalName;
                if (dataset.getParentDataset() && angular.isArray(dataset.getForeignKeyFields())) {
                    foreignKeysLocalName = dataset.getForeignKeyFields().map(function(foreignKey){
                        return foreignKey.localField;
                    });
                }

                var fieldsMD = dataset.getFieldsMetadata();
                var userFieldsMD = dataset.getUserFieldsMetadata();

                if($scope.ignoreAdditionalFields){
                    var fieldsIgnoreAd = [];
                    fieldsMD.forEach(function(field) { 
                        if(!field.name.startsWith('AD_')){
                            fieldsIgnoreAd.push(field);
                        }                        
                    });

                    if (ArrayUtils.isNotEmpty(fieldsIgnoreAd)) {
                        fieldsMD = fieldsIgnoreAd;
                    }
                }

                var allFieldsMD = [...new Set([...fieldsMD ,...userFieldsMD])];

                var properties = FormService.buildPropertiesFromMD(allFieldsMD, function () {
                    return fieldProps = {
                        'sk-dataset': $scope.dataset
                    };
                }, function (fieldMD) {
                    if (fieldMD.isDescriptionField) {
                        return false;
                    }

                    if (!$scope.formInterceptor && foreignKeysLocalName && foreignKeysLocalName.indexOf(fieldMD.name) > -1){
                        return false;
                    }

                    //Regra do DBConfigurableForm.mxml
                    if(angular.isDefined(fieldMD.entityPath) && !fieldMD.standAlone && fieldMD.entityPath != $scope.dataset.getEntityName()){
                        return false;
                    }

                    if($scope.formInterceptor && !$scope.formInterceptor.acceptField(fieldMD, dataset)) {
                        return false;
                    }

                    return true;
                }, undefined, function(fieldProperty) {
                    $scope.formInterceptor && $scope.formInterceptor.interceptField(fieldProperty, $scope.dataset);
                });

                return properties;
            }

            function setFieldProperty(fieldName, propName, value){
                _whenFormReady.whenReady()
                .then(function () {
                    let hasScopeVar = FormService.SCOPE_MUTABLE_PROPERTIES.indexOf(propName) > -1;

                    if(FormService.MUTABLE_PROPERTIES.indexOf(propName) == -1 && !hasScopeVar){
                        throw new Error('[SkConfigurableFormController] setFieldProperty, propriedade ' + propName + ' não pode ser alterada.');
                    }

                    let fProp = _mdByName[fieldName];

                    if(fProp){                   

                        if(hasScopeVar){
                            _formApi.getFieldController(fieldName, true).then( (ctrl) => {
                                if(ctrl && ctrl.scope){
                                    ctrl.scope[propName] = value;
                                }
                            });
                        }else{
                            fProp[propName] = value;
                        }

                        if(propName == 'required'){
                            $scope.dataset[value == true ? 'makeFieldRequired' : 'makeFieldNonRequired'](fieldName);
                        }

                        setPropChangedProgramaticaly(fieldName, propName, value);
                    }else{
                        console.warn('[SkConfigurableFormController] setFieldProperty, Campo ' + fieldName + ' não encontrado.');
                    }
                });
            }

            function setFieldFocus(fieldName){
                _whenFormReady.whenReady()
                .then(function () {
                    _formApi.setFieldFocus(fieldName);
                })
            }

            function getPropChangedProgramaticaly(field, prop){
                if(_programaticalyChanges[field] && angular.isDefined(_programaticalyChanges[field][prop])){
                    return _programaticalyChanges[field][prop];
                }

                return undefined;
            }

            function setPropChangedProgramaticaly(field, prop, value){
                if(!_programaticalyChanges[field]){
                    _programaticalyChanges[field] = {};
                }

                _programaticalyChanges[field][prop] = value;
            }

        }]);

/**
 * @ngdoc directive
 * @name snk.configurableform.directive:sk-configurable-form
 * @restrict E
 * @scope
 * @description
    Configurable Form é o componente responsável por realizar a renderização de campos (form item) de acordo com as propriedades recebidas através do objeto de propriedades.
    Esse componente é exclusivo para renderizar os form item e aplicar o conceito de responsivo no formulário, além disso esse componente é capaz de ser configurado quando utilizado em conjunto
    com o a diretiva sk-form-config.
 *
 * @param {object=} [sk-dataset=undefined] dataset que irá se ligar ao form, quando é passado um dataset os campos apresentados no form serão os metados desse dataset
 * 
 * @param {object} properties
    - Nesse objeto devemos passar um array denominado de fields (<b>fields: []</b>).
    - Nesse array de fields podemos passar todas as propriedades utilizados na renderização de 1 <b>sk-form-item</b>, 
    as propriedades permitidas no objeto que contempla o array de fields são: 
        - <b>label</b>: Campo texto utilizado para apresentar os label nos respectivos form item.
        - <b>fieldName</b>: Campo de texto utilizado nos componentes interno para informar o nome do campo do dicionário de dados ao DataSet.
        - <b>value</b>: Valor do campo que está sendo renderizado, este é o valor que é manipulado como fonte de dados pelo DataSet.
        - <b>type</b>: Campo de texto que define o tipo do sk-form-item a ser renderizado (texto, número, data e etc).
        - <b>required</b>: Booleano para definir se o campo deverá ser requerido ou não.
        - <b>saveLastValue</b>: Não documentado.
        - <b>groupName</b>: Campo do tipo texto que define o grupo de campos que este form item vai ser renderizado, caso essa chave seja vazia ou não informada, ele vai listar os campos sem nenhum grupo de campos.
        - <b>fieldProp</b>: Esse campo recebe um objeto que pode conter N atributos/diretivas de atributos do HTML para ser aplicado nos componentes internos renderizado pelo form item.
    Para mais detalhes sobe o array de propriedades, consulte o exemplo.
 *
 * @param {object=} [sk-form-interceptor] Um objeto que implementa o IFormInterceptor, pode ser usado para remover campos do formulario, e mudar o tipo de campo que sera apresentado.
 * 
 * @param {boolean=} [sk-inline=false] Informa se o skForm deve assumir apenas 1 coluna (padrão flex) ou se terá
 * colunas responsivas conforme o novo padrão do HTML5.
 * 
 * @param {number=} [sk-columns=4] Quantidade de colunas que o formulário irá renderizar.
 * 
* @example
     <example module="app">
         <file name="ConfigurableFormExample.html">
            <sk-application ng-controller="ExampleController as ctrl" layout-padding>
                <sk-dataset entity-name="Cidade" sk-dataset-created="ctrl.onDatasetCreated(dataset)"/>
                <sk-tab>
                    <sk-tab-item label="Configurable Form dataset">		
                        <sk-dataset entity-name="Cidade" sk-dataset-created="ctrl.dsCreated(dataset)"></sk-dataset>

                        <sk-hbox>
                            <sk-navigator dataset="ctrl.dsCid"></sk-navigator>
                            <sk-form-config sk-target-form-id="CidadeFormCfg" sk-config-name="Configuração do Formulário"></sk-form-config>
                        </sk-hbox>

                        <sk-configurable-form sk-uid="CidadeFormCfg" sk-dataset="ctrl.dsCid" sk-api="ctrl.formApi"></sk-configurable-form>                     
                    </sk-tab-item>
                    <sk-tab-item label="Configurable Form properties">
                        <sk-hbox>
                                <sk-form-config sk-target-form-id="PropsFormCfg" sk-config-name="propsFormConfig"></sk-form-config>
                            </sk-hbox>
                        <sk-configurable-form sk-uid="PropsFormCfg" properties="ctrl.formProperties"></sk-configurable-form>
                    </sk-tab-item>
                </sk-tab>
            </sk-application>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('ExampleController', ['$scope', function($scope){
                    var self = this;

                    self.onDatasetCreated = onDatasetCreated;
                    self.myDS;
                    
                    self.formProperties = [
                        {
                            description: 'Razão Social',
                            fieldName: 'RAZAOSOCIAL',
                            value: 'Sankhya Tecnologia em Sistemas LTDA',
                            type: 'S',
                            required: true
                        },
                        {
                            description: 'Nome da Empresa',
                            fieldName: 'NOMEEMP',
                            value: 'Sankhya',
                            type: 'S'
                        },
                        {
                            description: 'Endereço',
                            fieldName: 'ENDERECO',
                            value: 'Av. Marcos de Freitas Costa',
                            type: 'S',
                            groupName: 'GrupoEndereco',
                            fieldProp: {}
                        }
                    ];

                    function onDatasetCreated(dataset) {
                        self.dsCid = dataset;
                        self.dsCid.addCriteriaProvider(new CriteriaProvider(Criteria('this.CODCID > 0')));
                        self.dsCid.initAndRefresh();

                        if(self.formApi) self.formApi.setFieldProperty('DISTANCIA', 'required', true);
                    }

                }]);
         </file>
     </example>
 */
angular
    .module('snk.components.configurableform')
    .directive('skConfigurableForm',[function() {
        var directive = {};

        directive.restrict = 'E';
        directive.templateUrl = 'components/configurableform/configurableform.tpl.html';
        directive.controller = 'SkConfigurableFormController';
        directive.controllerAs = 'ctrl';
        directive.scope = {
            api: '=?skApi',
            dataset: '=?skDataset',
            properties: '=?',
            formInterceptor: '=?skFormInterceptor',
            skColumns: '@?skColumns',
            inLine: "@?skInLine",
            onCreated: '&?skOnCreated',
            compact: '@?skCompact',
            availableColumnsStandard: '=?skAvailableColumnsStandard',
            ignoreAdditionalFields: "@?skIgnoreAdditionalFields",
            fieldsOrder: '=?skFieldsOrder'
        };

        return directive;
    }]);

/**
 * Created by Leonardo.mendes on 08/12/2019.
 */
angular
    .module('snk.components.cronsyntaxselector')
    .controller('SkCronSyntaxSelectorController', ['CronSelectorUtils', 'NumberUtils', '$timeout', '$scope', 'StringUtils', 'i18n', 'ServiceProxy', 'ObjectUtils', 'MessageUtils',
        function (CronSelectorUtils, NumberUtils, $timeout, $scope, StringUtils, i18n, ServiceProxy, ObjectUtils, MessageUtils) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            // Variáveis privadas
            var _errors = [];
            var _ignoreValidation = false;
            var _meses = ['janeiro', 'fevereiro', 'marco', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
            var _semana = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];
            var _expression = [
                { label: 'second', data: '*' },
                { label: 'minute', data: '*' },
                { label: 'hour', data: '*' },
                { label: 'day', data: '*' },
                { label: 'month', data: '*' },
                { label: 'week', data: '?' }
            ];
            var Tempo = {
                SECOND: 0,
                MINUTE: 1,
                HOUR: 2,
                DAY: 3,
                MONTH: 4,
                WEEK: 5
            }

            // Variavéis do controlador
            $scope.dayWeekOrder = [];
            $scope.lastDayWeekLbl;
            $scope.value;

            $scope.secondChanged = secondChanged;
            $scope.minuteChanged = minuteChanged;
            $scope.hourChanged = hourChanged;
            $scope.dayChanged = dayChanged;
            $scope.lastDayMonthChanged = lastDayMonthChanged;
            $scope.monthChanged = monthChanged;
            $scope.daysWeekChanged = daysWeekChanged;
            $scope.clearAll = clearAll;

            $scope.parseExpression = parseExpression;

            $scope.$watch('isVisible', function(newValue){
                setVisible();
            });

            init();
            function init() {
                setVisible();

                $scope.seconds = createLabelNumber('second', 60);
                $scope.minutes = createLabelNumber('minute', 60);
                $scope.hours = createLabelNumber('hour', 24);
                $scope.days = createLabelNumber('day', 31);

                $scope.months = _meses.map(function (mes) {
                    return { label: i18n('CronSyntaxSelector.' + mes + 'Label'), data: false };
                });

                $scope.daysWeek = _semana.map(function (mes) {
                    return { label: i18n('CronSyntaxSelector.' + mes + 'Label'), data: false };
                });

                $scope.all = {};
                ['second', 'minute', 'hour', 'day', 'month', 'week'].forEach(function (e) {
                    $scope.all[e] = { label: i18n('CronSyntaxSelector.lblMarcarDesmarcar'), data: false, isAllBtn: true };
                });

                if (StringUtils.isEmpty($scope.value)) {
                    if($scope.dataset){
                        $scope.value = $scope.dataset.getFieldValue($scope.fieldName);
                    }else{
                        buildExpressionCron();
                    }
                }

                $scope.initializing = true;
                parseExpression($scope.value);

                if (angular.isFunction($scope.onCronCreated)){
                    $timeout(function () {
                        $scope.onCronCreated({
                            cron: {
                                validateExpression: validateExpression,
                                clearAll: clearAll,
                                parseExpression:parseExpression
                            }
                        });
                        $scope.initializing = false;
                    }, 0, false);
                }
            }

            function setVisible(){
                $scope.isVisible = angular.isDefined($scope.isVisible) ? $scope.isVisible : true;
            }

            function setData(data){
                $scope.value = StringUtils.undefinedAsEmpty(data);

                parseExpression();              
            }

            function getData(){
                return $scope.value;
            }

            function clearAll() {
                $scope.value = undefined;
                updateDataElement($scope.seconds, false);
                updateDataElement($scope.minutes, false);
                updateDataElement($scope.hours, false);
                updateDataElement($scope.days, false);
                updateDataElement($scope.months, false);
                updateDataElement($scope.daysWeek, false);

                ['second', 'minute', 'hour', 'day', 'month', 'week'].forEach(function (e) {
                    $scope.all[e].data = false;
                });
            }

            function updateDataElement(element, condicao) {
                element.forEach(function (e) {
                    e.data = condicao;
                    e.expression = undefined;
                });
            }

            function createLabelNumber(type, value) {
                if (StringUtils.isEmpty(value)) {
                    value = 60;
                }

                var array = [];

                for (var i = 0; i <= value - 1; i++) {
                    if (type == 'day') {
                        array.push({ label: i + 1, data: false });
                    } else {
                        array.push({ label: i, data: false });
                    }
                }

                return array;
            }

            function secondChanged(value, isAllBtn) {
                var todos = true;

                for (var i = 0; i < $scope.seconds.length; i++) {
                    if (isAllBtn) {
                        $scope.seconds[i].data = value;
                    } else {
                        todos = todos && value && $scope.seconds[i].data;
                    }
                }

                if (angular.isUndefined(isAllBtn)) {
                    $scope.all.second.data = todos;
                }

                setSecond();
            }

            function minuteChanged(value, isAllBtn) {
                var todos = true;

                for (var i = 0; i < $scope.minutes.length; i++) {
                    if (isAllBtn) {
                        $scope.minutes[i].data = value;
                    } else {
                        todos = todos && value && $scope.minutes[i].data;
                    }
                }

                if (angular.isUndefined(isAllBtn)) {
                    $scope.all.minute.data = todos;
                }

                setMinute();
            }

            function hourChanged(value, isAllBtn) {
                var todos = true;

                for (var i = 0; i < $scope.hours.length; i++) {
                    if (isAllBtn) {
                        $scope.hours[i].data = value;
                    } else {
                        todos = todos && value && $scope.hours[i].data;
                    }
                }

                if (angular.isUndefined(isAllBtn)) {
                    $scope.all.hour.data = todos;
                }

                setHour();
            }

            function dayChanged(value, isAllBtn) {
                var todos = true;

                for (var i = 0; i < $scope.days.length; i++) {
                    if (isAllBtn) {
                        $scope.days[i].data = value;
                    } else {
                        todos = todos && value && $scope.days[i].data;
                    }
                }

                if (angular.isUndefined(isAllBtn)) {
                    $scope.all.day.data = todos;
                }

                setDay();
            }

            function lastDayMonthChanged(id) {
                var lastDayMonthSelect = false;

                if (lastDayMonthSelect) {
                    for (i = 0; i < $scope.days.length; i++) {
                        $scope.days[i].data = false;
                    }

                    $scope.all.day.data = false;
                }

                setDay(true);
            }

            function monthChanged(value, isAllBtn) {
                var todos = true;

                for (var i = 0; i < $scope.months.length; i++) {
                    if (isAllBtn) {
                        $scope.months[i].data = value;
                    } else {
                        todos = todos && value && $scope.months[i].data;
                    }
                }

                if (angular.isUndefined(isAllBtn)) {
                    $scope.all.month.data = todos;
                }

                setMonth();
            }

            function daysWeekChanged(value, isAllBtn) {
                var todos = true;
                $scope.dayWeekOrder = [];

                for (var i = 0; i < $scope.daysWeek.length; i++) {
                    if (isAllBtn) {
                        $scope.daysWeek[i].data = value;
                    } else {
                        if ($scope.daysWeek[i].data) {
                            $scope.dayWeekOrder.push({ id: i + 1, value: $scope.daysWeek[i].label });
                        }

                        todos = todos && value && $scope.daysWeek[i].data;
                    }
                }

                if (angular.isUndefined(isAllBtn)) {
                    $scope.all.week.data = todos;
                }

                setDaysWeek();
            }

            function validateExpression(value) {
                clearAll();

                if (StringUtils.emptyAsUndefined(value)) {
                    _errors = [];

                    _ignoreValidation = true;
                    parseExpression(value);

                    if (_errors.length > 0) {
                        var msg;
                        if (_errors.length == 1) {
                            msg = i18n('CronSyntaxSelector.msgAlertaCronValidateOpcao', { opcao: _errors[0] });
                        } else {
                            var errorsList = '<ul>';

                            _errors.forEach(function (errorDescription) {
                                errorsList += ('<li>' + errorDescription + '</li>');
                            });

                            errorsList += '</ul>';

                            msg = i18n('CronSyntaxSelector.msgAlertaCronValidateOpcao', { opcao: errorsList });
                        }

                        MessageUtils.showAlert(msg);
                    } else {
                        //Servico de validacao de expressao
                        CronSelectorUtils.validateExpression(value, {
                            callbackError: buildExpressionCron
                        });
                    }
                } else {
                    clearAll();
                }
            }


            function formatExpression(expression) {
                if (expression.length > 0) {
                    expression = expression.replace(/,+$/, '');

                    var str = start = end = auxExpression = '';
                    str = expression.split(',');

                    for (var i = 0; i < str.length; i++) {
                        if ((str[i + 1] - str[i]) == 1) {
                            if (start.length == 0) {
                                start = str[i];
                            }

                            end = str[i + 1];
                        } else {
                            if (start.length > 0 && end.length > 0) {
                                auxExpression += start + '-' + end + ',';
                            } else {
                                auxExpression += str[i] + ',';
                            }

                            start = end = '';
                        }
                    }

                    if (start.length > 0 && end.length > 0) {
                        auxExpression += start + '-' + end + ',';
                    }

                    expression = auxExpression.replace(/,+$/, '');
                } else {
                    expression = '*';
                }
                return expression;
            }

            function setSecond() {
                var expression = '';

                for (var i = 0; i < $scope.seconds.length; i++) {
                    if ($scope.seconds[i].data) {
                        expression += angular.isUndefined($scope.seconds[i].expression) ? $scope.seconds[i].label + ',' : $scope.seconds[i].expression + ',';
                    }
                }
               

                _expression[Tempo.SECOND].data = formatExpression(expression);

                buildExpressionCron();
            }

            function setMinute() {
                var expression = '';

                for (var i = 0; i < $scope.minutes.length; i++) {
                    if ($scope.minutes[i].data) {
                        expression += angular.isUndefined($scope.minutes[i].expression) ? $scope.minutes[i].label + ',' : $scope.minutes[i].expression + ',';
                    }
                }
                

                _expression[Tempo.MINUTE].data = formatExpression(expression);

                buildExpressionCron();
            }

            function setHour() {
                var expression = '';

                for (var i = 0; i < $scope.hours.length; i++) {
                    if ($scope.hours[i].data) {
                        expression += angular.isUndefined($scope.hours[i].expression) ? $scope.hours[i].label + ',' : $scope.hours[i].expression + ',';
                    }
                }
              

                _expression[Tempo.HOUR].data = formatExpression(expression);

                buildExpressionCron();
            }

            function setDay(isLast) {
                if (!_ignoreValidation && _expression[Tempo.WEEK].data != '?') {
                    MessageUtils.simpleConfirm(i18n('CronSyntaxSelector.selectDaysMessage'))
                        .then(function () {
                            buildDay();
                        }, function () {
                            updateDataElement($scope.days, false);
                            $scope.all.day.data = false;
                        });
                } else {
                    buildDay();
                    _ignoreValidation = false;
                }

                function buildDay() {
                    var expression = '';

                    if (angular.isUndefined(isLast)) {
                        if (!$scope.all.day.data) {
                            for (var i = 0; i < $scope.days.length; i++) {
                                if ($scope.days[i].data) {
                                    expression += angular.isUndefined($scope.days[i].expression) ? $scope.days[i].label + ',' : $scope.days[i].expression + ',';
                                }
                            }
                        }
                    }

                    _expression[Tempo.DAY].data = formatExpression(expression);

                    if (expression != '*' || expression != '?') {
                        $scope.all.week.data = false;

                        for (var i = 0; i < $scope.daysWeek.length; i++) {
                            $scope.daysWeek[i].data = false;
                        }

                        _expression[Tempo.WEEK].data = '?';
                    }

                    buildExpressionCron();
                }
            }

            function setMonth() {
                var expression = '';

                if (!$scope.all.month.data) {
                    for (var i = 0; i < $scope.months.length; i++) {
                        if ($scope.months[i].data) {
                            expression += angular.isUndefined($scope.months[i].expression) ? i + 1 + ',' : $scope.months[i].expression + ',';
                        }
                    }
                }

                _expression[Tempo.MONTH].data = formatExpression(expression);

                buildExpressionCron();
            }

            
            function setDaysWeek() {
                if (!_ignoreValidation && _expression[Tempo.DAY].data != '?') {
                    MessageUtils.simpleConfirm(i18n('CronSyntaxSelector.selectWeeksMessage'))
                        .then(function () {
                            buildDaysWeek();
                        }, function () {
                            updateDataElement($scope.daysWeek, false);
                            $scope.all.week.data = false;
                        });
                } else {
                    buildDaysWeek();
                    _ignoreValidation = false;
                }

                function buildDaysWeek() {
                    var expression = '';

                    if (!$scope.all.week.data) {
                        for (var i = 0; i < $scope.daysWeek.length; i++) {
                            if ($scope.daysWeek[i].data) {
                                expression += i + 1 + ',';
                            }
                        }
                    }

                    expression = formatExpression(expression);

                    _expression[Tempo.WEEK].data = expression;

                    _expression[Tempo.DAY].data = '?';

                    $scope.all.day.data = false;
                    for (var i = 0; i < $scope.days.length; i++) {
                        $scope.days[i].data = false;
                    }

                    buildExpressionCron();
                }
            }

            function parseExpression(expression) {
                if (StringUtils.isNotEmpty(expression)) {
                    var str = expression.split(/[\s\r\n]+/gim).filter(StringUtils.isNotEmpty);

                    for (var i = 0; i < str.length; i++) {
                        if (str[i] == '*' || str[i] == '?') {
                            _expression[i].data = str[i];
                        } else {
                            if (i == 0) {
                                getSecond(str[i]);
                            } else if (i == 1) {
                                getMinute(str[i]);
                            } else if (i == 2) {
                                getHour(str[i]);
                            } else if (i == 3) {
                                getDay(str[i]);
                            } else if (i == 4) {
                                getMonth(str[i]);
                            } else if (i == 5) {
                                getDaysWeek(str[i]);
                            }
                        }
                    }
                    // Formatada na expresão Cron
                    buildExpressionCron();
                }
            }

            function getSecond(str) {
                var auxExp = auxExpInter = '';
                auxExp = str.split(',');

                for (var j = 0; j < auxExp.length; j++) {
                    auxExpInter = auxExp[j].split('-');

                    for (var k = 0; k < auxExpInter.length; k++) {
                        let numSeconds = NumberUtils.stringToNumber(auxExpInter[k]);
                        if (!isNaN(numSeconds)) {
                            if (numSeconds < 0 || numSeconds > 59) {
                                _errors.push(i18n('CronSyntaxSelector.msgAlertaCronSegundos'));
                                break;
                            } else {
                                if (auxExpInter.length == 1) {
                                    $scope.seconds[numSeconds].data = true;
                                    if (auxExpInter[k] != numSeconds) {
                                        $scope.seconds[numSeconds].expression = auxExpInter[k];
                                    }
                                } else {
                                    for (var w = numSeconds; w <= NumberUtils.stringToNumber(auxExpInter[k + 1]); w++) {
                                        if ($scope.seconds[w]) {
                                            $scope.seconds[w].data = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(_errors.length > 0){
                        break;
                    }
                }

                setSecond();
            }

            function getMinute(str) {
                var auxExp = auxExpInter = '';
                auxExp = str.split(',');

                for (var j = 0; j < auxExp.length; j++) {
                    auxExpInter = auxExp[j].split('-');

                    for (var k = 0; k < auxExpInter.length; k++) {
                        let numMinutes = NumberUtils.stringToNumber(auxExpInter[k]);
                        if (!isNaN(numMinutes)) {
                            if (numMinutes < 0 || numMinutes > 59) {
                                _errors.push(i18n('CronSyntaxSelector.msgAlertaCronMinutos'));
                                break;
                            } else {
                                if (auxExpInter.length == 1) {
                                    $scope.minutes[numMinutes].data = true;
                                    if (auxExpInter[k] != numMinutes) {
                                        $scope.minutes[numMinutes].expression = auxExpInter[k];
                                    }
                                } else {
                                    for (var w = numMinutes; w <= NumberUtils.stringToNumber(auxExpInter[k + 1]); w++) {
                                        if ($scope.minutes[w]) {
                                            $scope.minutes[w].data = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(_errors.length > 0){
                        break;
                    }
                }

                setMinute();
            }

            function getHour(str) {
                var auxExp = auxExpInter = '';
                auxExp = str.split(',');

                for (var j = 0; j < auxExp.length; j++) {
                    auxExpInter = auxExp[j].split('-');

                    for (var k = 0; k < auxExpInter.length; k++) {
                        let numHours = NumberUtils.stringToNumber(auxExpInter[k]);
                        if (!isNaN(numHours)) {
                            if (numHours < 0 || numHours > 23) {
                                _errors.push(i18n('CronSyntaxSelector.msgAlertaCronHoras'));
                                break;
                            } else {
                                if (auxExpInter.length == 1) {
                                    $scope.hours[numHours].data = true;
                                    if (auxExpInter[k] != numHours) {
                                        $scope.hours[numHours].expression = auxExpInter[k];
                                    }
                                } else {
                                    for (var w = numHours; w <= NumberUtils.stringToNumber(auxExpInter[k + 1]); w++) {
                                        if ($scope.hours[w]) {
                                            $scope.hours[w].data = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(_errors.length > 0){
                        break;
                    }
                }

                setHour();
            }

            function getDay(str) {
                var auxExp = auxExpInter = '';
                var isLastDay;

                auxExp = str.split(',');

                for (var j = 0; j < auxExp.length; j++) {
                    auxExpInter = auxExp[j].split('-');

                    for (var k = 0; k < auxExpInter.length; k++) {
                        let numDays = NumberUtils.stringToNumber(auxExpInter[k]);
                        if (!isNaN(numDays)) {
                            if (numDays < 1 || numDays > 31) {
                                _errors.push(i18n('CronSyntaxSelector.msgAlertaCronDiasMes'));
                                break;
                            } else {
                                if (auxExpInter.length == 1) {
                                    $scope.days[numDays - 1].data = true;
                                    if (auxExpInter[k] != numDays) {
                                        $scope.days[numDays - 1].expression = auxExpInter[k];
                                    }
                                } else {
                                    for (var w = numDays - 1; w <= NumberUtils.stringToNumber(auxExpInter[k + 1]) - 1; w++) {
                                        if ($scope.days[w]) {
                                            $scope.days[w].data = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(_errors.length > 0){
                        break;
                    }
                }

                setDay(isLastDay);
            }

            function getMonth(str) {
                var auxExp = auxExpInter = '';
                auxExp = str.split(',');

                for (var j = 0; j < auxExp.length; j++) {
                    auxExpInter = auxExp[j].split('-');

                    for (var k = 0; k < auxExpInter.length; k++) {
                        let numMonths = NumberUtils.stringToNumber(auxExpInter[k]);
                        if (!isNaN(numMonths)) {
                            if (numMonths < 1 || numMonths > 12) {
                                _errors.push(i18n('CronSyntaxSelector.msgAlertaCronMeses'));
                                break;
                            } else {
                                if (auxExpInter.length == 1) {
                                    $scope.months[numMonths - 1].data = true;
                                    if (auxExpInter[k] != numMonths) {
                                        $scope.months[numMonths - 1].expression = auxExpInter[k];
                                    }
                                } else {
                                    for (var w = numMonths - 1; w <= NumberUtils.stringToNumber(auxExpInter[k + 1]) - 1; w++) {
                                        if ($scope.months[w]) {
                                            $scope.months[w].data = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(_errors.length > 0){
                        break;
                    }
                }

                setMonth();
            }

            function getDaysWeek(str) {
                var auxExp = auxExpInter = '';

                auxExp = str.split(',');

                for (var j = 0; j < auxExp.length; j++) {
                    auxExpInter = auxExp[j].split('-');
                    
                    for (var k = 0; k < auxExpInter.length; k++) {
                        if (!isNaN(NumberUtils.stringToNumber(auxExpInter[k]))) {
                            if (NumberUtils.stringToNumber(auxExpInter[k]) < 1 || NumberUtils.stringToNumber(auxExpInter[k]) > 7) {
                                _errors.push(i18n('CronSyntaxSelector.msgAlertaCronDiasSemana'));
                            } else {
                                if (auxExpInter.length == 1) {
                                    $scope.daysWeek[NumberUtils.stringToNumber(auxExpInter[k]) - 1].data = true;
                                    break;
                                } else {
                                    for (var w = NumberUtils.stringToNumber(auxExpInter[k]) - 1; w <= NumberUtils.stringToNumber(auxExpInter[k + 1]) - 1; w++) {
                                        if ($scope.daysWeek[w]) {
                                            $scope.daysWeek[w].data = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    
                    if(_errors.length > 0){
                        break;
                    }
                }

                daysWeekChanged(false, false);
                setDaysWeek();
            }

            function buildExpressionCron() {
                $scope.value = '';

                _expression.forEach(function (position) {
                    $scope.value += position.data + ' ';
                });

                $scope.value = StringUtils.rtrim($scope.value);

                ($scope.onChange || angular.noop)();

                if (self.useDataset($scope)) {
                    if($scope.preventEditOnInit && $scope.value === self.getData() && $scope.initializing === true){
                        return;
                    }
                    
                    $scope.$evalAsync(function(){
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }
            }

        }]);

/**
 * @ngdoc directive
 * @name snk.components.cronsyntaxselector.directive:sk-cron-syntax-selector
 * @restrict E
 * @description
 *  O cron é um programa de agendamento de tarefas. Com ele você pode programar para ser 
 *  executado qualquer coisa numa certa periodicidade ou até mesmo em um exato dia, 
 *  numa exata hora 
 *
 * @param {object} sk-dataset dataset que o label irá fazer bind
 * @param {string} sk-field-name nome do campo ao qual o label irá se ligar no dataset.
 * @param {string} [sk-value=undefined] Variável em que ocorrerá o bind entre o model e o view.
 * @param {function} [sk-change=undefined] Função a ser chamada quando alterar a expressão
 * @param {function} [sk-cron-created=undefined] Construtor onde se obter acesso aos metodos da diretiva
 *  - validateExpression
 *  - clearAll
 *  - parseExpression  
 *
 *  @example
     <example module="app">
         <file name="exemplo.html">
            <sk-vbox gap="5">
                  <sk-hbox gap="8">
                     <span>Expressão CRON: </span>
                     <span ng-bind="expressionCron"></span>
                  </sk-hbox>
                  <sk-cron-syntax-selector sk-value="expressionCron"
			                                sk-cron-created="cronCreated(cron)"
                                           sk-change="change(value)">
                  </sk-cron-syntax-selector>
             </sk-vbox>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope){

                    $scope.expressionCron = "0 * * ? * 3-4,9";
                    $scope.cronCreated = function (cron){
                        $scope.cron = cron;
                    }
                });
         </file>
     </example>
 */
angular
    .module('snk.components.cronsyntaxselector')
    .directive('skCronSyntaxSelector', ['i18n', function (i18n) {
        return {
            restrict: 'E',
            templateUrl: 'components/cronsyntaxselector/cronsyntaxselector.tpl.html',
            controller: 'SkCronSyntaxSelectorController',
            scope: {
                dataset: '=?skDataset',
                fieldName: '@?skFieldName',
                value: '=?skValue',
                onChange: '&?skChange',
                onCronCreated: '&?skCronCreated',
                isVisible : '=?skVisible',
                showClearButton: '=?skShowClearButton',
                preventEditOnInit: '=?skPreventEditOnInit'
            },
            transclude: true
        };
}]);

/**
 * Created by Leonardo.mendes on 08/12/2019.
 */
angular
    .module('snk.components.cronsyntaxselector')
    .service('CronSelectorUtils', ['StringUtils', 'i18n', 'ServiceProxy', 'ObjectUtils', 'MessageUtils',
        function (StringUtils, i18n, ServiceProxy, ObjectUtils, MessageUtils) {
            var self = this;

            self.validateExpression = validateExpression;

            function validateExpression(value, options = {}) {
                if (StringUtils.emptyAsUndefined(value)) {
                    ServiceProxy.callService('mge@ScheduledActionsSP.validateCronExpression', {
                        expression: {
                            value: value
                        }
                    }).then(function (response) {
                        var errInfo = ObjectUtils.getProperty(response, 'responseBody.errInfo.$');

                        if (angular.isDefined(errInfo)) {
                            MessageUtils.showAlert(errInfo).then(function () {
                                (options.callbackError || angular.noop)();
                            });
                        } else {
                            if (options.ignoreMsgSucess !== true) {
                                var expInfo = ObjectUtils.getProperty(response, 'responseBody.expInfo.$');
                                if (angular.isDefined(expInfo)) {
                                    MessageUtils.showInfo(i18n('CronSyntaxSelector.correctCronExpression'), expInfo);
                                }
                            }

                            (options.callbackSucess || angular.noop)();
                        }
                    });
                }
            }
        }]);
angular
    .module('snk.components.cubebase')
    .controller('CubeBase', ['i18n', 'MessageUtils', 'Base64', 'WebConnectionCaller', '$scope', 'MGEParameters', 'StringUtils','ServiceProxy', 'ObjectUtils',  function(i18n, MessageUtils, Base64, WebConnectionCaller, $scope, MGEParameters, StringUtils, ServiceProxy, ObjectUtils) {

        var self = this;
        
        self.CUBE_SOURCE = "/mge/cubeBase.jsp";
        self.isExternalCube = MGEParameters.asBoolean("global.usa.app.cubo");

        self.cubeCriteria;
        self.cubePersonalFilter;

        self.refresh = refresh;

        self.setCriteria = setCriteria;
        self.getCriteria = getCriteria;
        self.setPersonalFilter = setPersonalFilter;
        self.getPersonalFilter = getPersonalFilter;

        init();

        function init(){
            $scope.api = self;
        }

        function refresh(criteria, personalFilter, cubeLabel, method){
            let cubeCriteria = criteria ? criteria : self.cubeCriteria;
            let cubePersonalFilter = personalFilter ?  personalFilter : self.cubePersonalFilter;

            var serializedParams = buildSerializedParameters(cubeCriteria, cubePersonalFilter);

            if(serializedParams && self.isExternalCube){
                executeRemoteCube(serializedParams, cubeLabel, method);
            }
        }

        function buildSerializedParameters(criteria, personalFilter){
            let cube = '<cube>';
            let views = '<views>';
            let fieldsProperty = '<fields-property>';
			let parameters = '<env-parameters>';

            if(criteria && !StringUtils.isEmpty(criteria.getExpression())){
                let query = "<query><select>" + criteria.getExpression() + "</select>"
                
                let parameters = criteria.getParameters();

                if(parameters && parameters.length > 0){
                    var params = '<parameters>';

                    parameters.forEach(function(param){
                        params += '<param value="' + param.value + '" type="' + param.type + '"/>';
                    });

                    params += '</parameters>';
                    query += params;
                }

                query += '</query>';
                cube += query;

                if(personalFilter && !StringUtils.isEmpty(personalFilter.getExpression())){

                    if(criteria.getExpression().indexOf("${pFrom}") == -1){
                        MessageUtils.showError(i18n('Controls.CubeBase.messageErropFrom'));
                        return;
                    }
					
					if(criteria.getExpression().indexOf("${pWhere}") == -1){
                        MessageUtils.showError(i18n('Controls.CubeBase.messageErropWhere'));
                        return;
                    }
                    
                    var personal = '<personalFilter rootEntity><expression>'+ personalFilter.getExpression() + '</expression>';
                    
                    var rootEntity = personalFilter.getRootEntity();

                    var rootEntityReplaced = rootEntity ? 'rootEntity="' + rootEntity + '"' : "";

                    personal = personal.replace('rootEntity', rootEntityReplaced);
                    
                    var alias = personalFilter.getAlias();

                    if(alias && alias.length > 0){
                        alias.forEach(function(al){
                            personal += '<alias name="' + al.name + '" aliasName="' + al.aliasName + '"/>';
                        });
                    }
                    
                    let paramsFilter = personalFilter.getParams();

					if(paramsFilter && paramsFilter.length > 0){
						var pElem = '<parameters>';
                        
                        paramsFilter.forEach(function(paramFilter){
                            pElem += '<param value="' + paramFilter.value + '" type="' + paramFilter.type + '"/>'
                        })

						pElem += '</parameters>'
						personal += pElem;
                    }
                    
                    personal += '</personalFilter>';
                    cube += personal;
                }
            }

            if($scope.views){
                $scope.views.forEach(function(view){
                    var nameView = angular.isDefined(view.name) ? view.name : null;
                    var displayView = angular.isDefined(view.display) ? view.display : null;
                    var defaultView = angular.isDefined(view.defaultView) ? view.defaultView : null;

                    let vElem = '<view name="' + nameView + '" display="' + displayView + '" default="' + defaultView + '">';

                    if(view.dataFields){
                        var dElem = '<dataFields>';

                        view.dataFields.forEach(function(dataField){
                            dElem += '<field name="' + dataField.name + '"/>'
                        });

                        dElem += '</dataFields>';
                        vElem += dElem;
                    }

                    if(view.rowFields){
                        var rElem = '<rowFields>';

                        view.rowFields.forEach(function(rowField){
                            rElem += '<field name="' + rowField.name + '"/>'
                        });

                        rElem += '</rowFields>';
                        vElem += rElem;
                    }

                    if(view.colFields){
                        var cElem = '<colFields>';

                        view.colFields.forEach(function(colField){
                            cElem += '<field name="' + colField.name + '"/>'
                        });
                        cElem += '</colFields>';
                        vElem += cElem;
                    }

                    vElem += '</view>';
                    views += vElem;
                });
            }
            views += '</views>';
    
            if($scope.fieldsProperty){
                $scope.fieldsProperty.forEach(function(fieldProperty){
                    var fField = '<field name="' + fieldProperty.name +'" >';
                
                    if(fieldProperty.properties){
                        fieldProperty.properties.forEach(function(property){
                            fField += '<property name="' + property.name + '" value="' + property.value + '"/>';
                        });
                    }
                    fField += '</field>';
                });
            }
            fieldsProperty += '</fields-property>';

            cube += views;
            cube += fieldsProperty;

            if(angular.isFunction($scope.environmentParameters)) {
                var cubeParameters = $scope.environmentParameters();

                if(cubeParameters){
                    cubeParameters.forEach(function(parameter){
                        let value = parameter.value ? parameter.value : "";
                        parameters += '<param name="' + parameter.name + '" value="' + value + '"/>';
                    });
                }
            }

            parameters += '</env-parameters>';

            cube += parameters;
            cube += '</cube>';

            let encoder = Base64.encode(cube);

            return encoder.replace(/\r|\n/g, "");
        }

        function executeRemoteCube(serializedParams, cubeLabel, method){
            
            let serverName = (method && method.length > 0) ? method : "";
            let params = { encodePayload: false }

            if(cubeLabel && cubeLabel.length > 0){
                params['label'] = cubeLabel;
            }
            params['resourceID'] = 'iframe_cubo@cubeBaseApplet';

            let caller = {};
            if($scope.controlExportAcess){
                ServiceProxy.callService("mge@UsuarioSP.usuarioLogadoPodeExportarPDF", {}).then(function (result) {
                    params['permiteExportar'] = ObjectUtils.getProperty(result, 'responseBody.$');
                    caller = new WebConnectionCaller(serverName, params);
                    caller.sendCubeData(serializedParams);
                }).catch(function () {
                    params['permiteExportar'] = "N";
                    caller = new WebConnectionCaller(serverName, params);
                    caller.sendCubeData(serializedParams);
                });
            }else{
                caller = new WebConnectionCaller(serverName, params);
                caller.sendCubeData(serializedParams);
            }
        }


        function setCriteria(criteria){
            self.cubeCriteria = criteria;
        }

        function getCriteria(){
            return self.cubeCriteria;
        }

        function setPersonalFilter(personalFilter){
            self.cubePersonalFilter = personalFilter;
        }

        function getPersonalFilter(){
            return self.cubePersonalFilter;
        }

    }]);

/**
 * @ngdoc directive
 * @name snk.components.cubebase.directive:sk-cube-base
 * @restrict E
 * @description
 * Este é o componente responsável por chamar o web-connection para a abertura do cubo.
 * @param {string} [sk-api=undefined] Instância do sk-cube-base.
 * @param {array} [sk-environment-parameters=undefined] Parametros que podem ser passados para a abertura do cubo.
 * @param {array} [sk-fields-property=undefined] Propriedades dos campos.
 * @param {array} [sk-views=undefined] Estrutura que será montado as views do cubo.

 * @example
 <example module="appCubeBase">
      <file name="appCubeBase.html">
       <button ng-click="ctrl.showCube()">Show Cube</button>
          <sk-cube-base sk-api="ctrl.cubeApi" sk-views="ctrl.views" sk-environment-parameters='ctrl.environmentParameters'></sk-cube-base>
      </file>

     <file name="appCubeBase.js">
         angular
         .module('appCubeBase',['snk'])
         .controller('CubeBaseController', ['Criteria', 'PersonalizedFilterData', 'WebConnectionConstants', function(Criteria, PersonalizedFilterData, WebConnectionConstants) 

            var self = this;
    
            self.showCube = () => {
                if(self.cubeApi){
                    self.cubeApi.refresh(criteria, personalFilter, 'UF/Cidade/Bairro', WebConnectionConstants.methods.CUBE_UF_CIDADE_BAIRRO);
                }
            }

            var criteria = new Criteria();
            criteria.append('SELECT TGFTOP.GRUPO as "Grupo da TOP" , UFS.UF as "Estado" , CID.NOMECID as "Cidade" , B.NOMEBAI as "Bairro", ' +
                            'CAST(SUM((TGFITE.VLRTOT - TGFITE.VLRDESC + TGFITE.VLRIPI + TGFITE.VLRSUBST) * CASE WHEN TGFCAB.TIPMOV IN (\'O\',\'C\') THEN VCA.INDITENSSEMOUTROS ELSE VCA.INDITENS END * ' + 
                            'CASE WHEN TGFITE.USOPROD = \'M\' THEN TGFTOP.GOLMPSINAL ELSE TGFTOP.GOLSINAL END * TGFTOP.GOLDEV * CASE WHEN TGFITE.SEQUENCIA &lt; 0 THEN -1 ELSE 1 END) * -1 AS FLOAT) AS "Valor Total" ,' + 
                            'CAST(SUM(P.PESOLIQ * TGFITE.QTDNEG * CASE WHEN TGFITE.USOPROD = \'M\' THEN TGFTOP.GOLMPSINAL ELSE TGFTOP.GOLSINAL END * TGFTOP.GOLDEV * CASE WHEN TGFITE.SEQUENCIA &lt; 0 THEN -1 ELSE 1 END) * -1 AS FLOAT) AS "Peso líquido" , ' +  
                            'CAST(SUM(P.PESOBRUTO * TGFITE.QTDNEG * CASE WHEN TGFITE.USOPROD = \'M\' THEN TGFTOP.GOLMPSINAL ELSE TGFTOP.GOLSINAL END * TGFTOP.GOLDEV * CASE WHEN TGFITE.SEQUENCIA &lt; 0 THEN -1 ELSE 1 END) * -1 AS FLOAT) AS "Peso Bruto" , ' + 
                            'CAST(SUM(case when TGFCAB.VLRMOEDA = 0 then 0 else ((TGFITE.VLRTOT - TGFITE.VLRDESC + TGFITE.VLRIPI + TGFITE.VLRSUBST) * CASE WHEN TGFCAB.TIPMOV IN (\'O\',\'C\') THEN VCA.INDITENSSEMOUTROS ELSE VCA.INDITENS END * CASE WHEN TGFITE.USOPROD = \'M\' THEN TGFTOP.GOLMPSINAL ELSE TGFTOP.GOLSINAL END * TGFTOP.GOLDEV * CASE WHEN TGFITE.SEQUENCIA &lt; 0 THEN -1 ELSE 1 END) / TGFCAB.VLRMOEDA end) AS FLOAT) AS "Valor Total Moeda" '+
                            'FROM TGFCAB  LEFT JOIN TGFVEN VEN ON (TGFCAB.CODVEND = VEN.CODVEND) , VGFCAB VCA , TGFITE TGFITE , TGFPAR A , TGFTOP , TSIBAI B , TSICID CID , TSIUFS UFS , TGFPRO P ${pFrom} ' + 
                            'WHERE TGFCAB.CODPARC &lt;&gt; 0 AND TGFCAB.NUNOTA = VCA.NUNOTA AND TGFCAB.CODTIPOPER = TGFTOP.CODTIPOPER AND TGFCAB.DHTIPOPER = TGFTOP.DHALTER AND TGFCAB.STATUSNOTA = \'L\' AND TGFCAB.NUNOTA = TGFITE.NUNOTA AND TGFCAB.CODPARC = A.CODPARC AND A.CODBAI = B.CODBAI AND A.CODCID = CID.CODCID AND CID.UF = UFS.CODUF AND TGFITE.CODPROD = P.CODPROD AND TGFCAB.CODVEND = ?  AND (TGFTOP.GRUPO  IN ( ? )) ${pWhere}  GROUP BY TGFTOP.GRUPO, UFS.UF, CID.NOMECID, B.NOMEBAI');

            criteria.addParameter(Criteria.buildParameter('N', 4));                       
            criteria.addParameter(Criteria.buildParameter('S', 'SEM GRUPO'));                       

            var personalFilter = new PersonalizedFilterData();
            personalFilter.setRootEntity("ItemNota");
            personalFilter.setExpression("(ItemNota.PERCPUREZA = ?:{entidade=ItemNota;campo=PERCPUREZA})");
            personalFilter.addAlias("CabecalhoNota", "TGFCAB");
            personalFilter.addAlias("Parceiro", "A");
            personalFilter.addAlias("ViewCabecalhoNota", "VCA");
            personalFilter.addAlias("TipoOperacao", "TGFTOP");
            personalFilter.addAlias("Bairro", "B");
            personalFilter.addAlias("Cidade", "CID");
            personalFilter.addAlias("UnidadeFederativa", "UFS");
            personalFilter.addAlias("Produto", "P");
            personalFilter.addAlias("Vendedor", "VEN");

            personalFilter.addParam(4, "F");
            
            self.views = [{
                            defaultView: "true",
                            name: "ufCidBairro",
                            display: "UF/Cidade/Bairro",
                            dataFields:[{
                                            name: 'Peso Bruto' 
                                        },
                                        {
                                            name: 'Peso líquido' 
                                        },
                                        {
                                            name: 'Valor Total' 
                                        }],
                            rowFields:[{
                                            name: 'Cidade' 
                                        },
                                        {
                                            name: 'Estado' 
                                        }]
                }
            ];
         }]);
     </file>
   </example>
*/
angular
    .module('snk.components.cubebase')
    .directive('skCubeBase', [ function() {
        return {
            controller: 'CubeBase',
            controllerAs: 'ctrl',
            templateUrl: 'components/cubebase/cubebase.tpl.html',
            restrict: 'E',
            scope: {
                api: '=?skApi',
                environmentParameters: '=?skEnvironmentParameters',
                fieldsProperty: '=?skFieldsProperty',
                views: '=?skViews',
                controlExportAcess: '=?skControlExportAccess'
            },
            link: function (scope, element, attrs) {

            }
        };
    }]);
angular
    .module('snk.components.cubebase')
    .provider('PersonalizedFilterData', function () {
        
        this.$get = function () {
            return PersonalizedFilterDataService;
        };

        function PersonalizedFilterDataService() {
            return new PersonalizedFilterData();
        }
    });
angular
    .module('snk.components.dashrenderer')
    .controller('DashboardRenderer', ['$translate', 'MessageUtils', '$element', '$scope', '$q', '$interval', '$timeout',
     function($translate, MessageUtils, $element, $scope, $q, $interval, $timeout) {
        let self = this;

        const urlDashboardGOL = angular.isDefined($scope.dashboardUrl) ? $scope.dashboardUrl : '/mgecom/DashboardGOL.html5';
        let iframe = {};

        init();

        function init() {
            if(!angular.isDefined($scope.nuGdg)){
                MessageUtils.showError($translate.instant('Geral.messageInformarPropriedade', {propriedade: "nuGdg"}));
                return;
            }

            $scope.src = urlDashboardGOL + "?nuGdg=" + $scope.nuGdg + "&isGOL=true";

            iframe['element'] = $element[0].children;
            iframe['promise'] = $q.defer();
        }
      
        self.onLoad = () => {

            if (iframe) {
                let iframeElem = iframe.element;
                $scope.iframeContent = iframeElem[0].contentWindow;
                
                let interval = $interval(function () {
                    if ($scope.iframeContent) {
                        let dash = $scope.iframeContent.dashboard;
                        iframe.promise.resolve(dash);
                        $interval.cancel(interval);
                    }
                }, 100, 0, false);
            }

            self.getDashboardView()
                .then( function(dashView){
                    self.hideTopBar();
                    if(angular.isFunction($scope.filters)){
                    	
                        //Aguardando os parâmetros do dash serem carregados.
                        let intervalDashLoad = $interval(function () {
                            
                            if (dashView.dashboardLoaded) {
                                let params = $scope.filters();
                                
                                //Setamos os valores default para parâmetros que não existirem no callback filters                                
                                (Array.isArray(dashView.dashboardParams) ? dashView.dashboardParams : [])
                                .forEach(param => {
                                    if(params[param.id] == undefined){
                                        params[param.id] = -1;
                                    }
                                });

                                dashView.setPromptParams(params);
                                dashView.update();
                                $interval.cancel(intervalDashLoad);
                                $timeout(adjustLevelContainer, 500);
                                
                                $scope.$watchGroup(['filters'], function () {
                                	updateDash(dashView);
                                });
                            }

                        }, 100, 0, false);
                    }
                } 
            );
        }

        self.getDashboardView = () => {
            if (!iframe) {
                return $q(function (resolve, reject) {
                    reject();
                });
            }

            return iframe.promise.promise;
        }

        self.hideTopBar = () => {
            /*let dashWindow = $scope.iframeContent.document.getElementsByClassName("DashWindow-TopBar");
            if(dashWindow[0]) dashWindow[0].style.display = 'none';*/
            let dashWindow = $scope.iframeContent.document.getElementsByClassName("DashWindow-TopBar");

            if(dashWindow[0]){
               let tds = dashWindow[0].getElementsByTagName("td");

               for(var i = 0; i < tds.length; i++){
                    tds[i].style['display'] = 'none';
               }

            }
        }
        
        function updateDash(dashView){
        	let params = $scope.filters();
        	
        	//Setamos os valores default para parâmetros que não existirem no callback filters                                
        	(Array.isArray(dashView.dashboardParams) ? dashView.dashboardParams : [])
        	.forEach(param => {
        		if(params[param.id] == undefined){
        			params[param.id] = -1;
        		}
        	});
        	
        	dashView.setPromptParams(params);
        	dashView.update();
        	$timeout(adjustLevelContainer, 500);
        }

        function adjustLevelContainer(){
            let lvlContainer = $scope.iframeContent.document.getElementsByClassName("m-LevelContainer");
            if(lvlContainer && lvlContainer[0] && lvlContainer[0].childNodes){
                lvlContainer[0].childNodes.forEach((node, i) => {
                    if( i > 0 && node && node.innerText && node.innerText.startsWith('Não foram encontradas informa')){
                        node.innerText = '';
                    }
                });
            }

            let dashWindow = $scope.iframeContent.document.querySelector('.Dashboard-GOL.dyna-gadget .dashWindow-size');
            //Remove margens do dash
            if(dashWindow){
                dashWindow.style.margin = '0px';
                dashWindow.style.width = 'calc(100%)';
                dashWindow.style.height ='calc(100%)';
            }

        }

    }]);

/**
 * @ngdoc directive
 * @name snk.components.cubebase.directive:sk-cube-base
 * @restrict E
 * @description
 * Este é o componente responsável por chamar o web-connection para a abertura do cubo.
 * @param {string} [sk-api=undefined] Instância do sk-cube-base.
 * @param {array} [sk-environment-parameters=undefined] Parametros que podem ser passados para a abertura do cubo.
 * @param {array} [sk-fields-property=undefined] Propriedades dos campos.
 * @param {array} [sk-views=undefined] Estrutura que será montado as views do cubo.

 * @example
 <example module="dashboardRendererBase">
      <file name="dashboardRendererBase.html">
        <sk-dashboard-renderer sk-nu-gdg="10" sk-width="850px" sk-height="650px" sk-filter="self.filters"></sk-dashboard-renderer>
      </file>

     <file name="dashboardRendererBase.js">
         angular
         .module('dashboardRendererBase',['snk'])
         .controller('DashboardRendererController', ['Criteria', 'PersonalizedFilterData', 'WebConnectionConstants', function(Criteria, PersonalizedFilterData, WebConnectionConstants) 

            var self = this;

            self.filters = () => {
                let obj = {};
                obj['CODPARC'] = 11;
                return obj;
            }
         }]);
     </file>
   </example>
*/
angular
    .module('snk.components.dashrenderer')
    .directive('skDashboardRenderer', [ function() {
        return {
            controller: 'DashboardRenderer',
            controllerAs: 'ctrl',
            templateUrl: 'components/dashrenderer/dashboardrenderer.tpl.html',
            restrict: 'E',
            scope: {
                nuGdg: '@skNuGdg',
                width: '@?skWidth',
                height: '@?skHeight',
                filters: '=?skFilter',
                dashboardUrl: '@?skDashboardUrl'
            },
            link: function (scope, element, attrs) {

            }
        };
    }]);
angular
    .module('snk.components.datagrid')
    .controller('SkAgGridController', ['$scope', '$attrs', '$element', 'DomUtil', 'ObjectUtils', 'ArrayUtils', 'UserAgentUtils', 'DatasetContants', 'AngularUtil', 'GridConfigJqx', 'DateUtilsConstants', 'FormService', 'StringUtils', 'NumberUtils', 'DateUtils', '$q', '$timeout', '$document', '$compile', 'DatasetEvents', '$location', '$anchorScroll', 'DatasetObserverEvents', 'GridConfig', 'DatagridAggridTourContent', 'SanPopup', 'i18n', '$tooltip', '$rootScope', 'SanPopupStack','$sce', 'ThemeColors', 'SkApplication', 'MGEAuthorizationConstants', 'MessageUtils', '$window', 'PositionUtils', 'ServiceProxy', 'MGEParameters', 'Criteria','SkConstants',
        function ($scope, $attrs, $element, DomUtil, ObjectUtils, ArrayUtils, UserAgentUtils, DatasetContants, AngularUtil, GridConfigJqx, DateUtilsConstants, FormService, StringUtils, NumberUtils, DateUtils, $q, $timeout, $document, $compile, DatasetEvents, $location, $anchorScroll, DatasetObserverEvents, GridConfig, DatagridAggridTourContent, SanPopup, i18n, $tooltip, $rootScope, SanPopupStack, $sce, ThemeColors, SkApplication, MGEAuthorizationConstants, MessageUtils, $window, PositionUtils, ServiceProxy, MGEParameters, Criteria, SkConstants) {

            $element.data('$skDatagridController', this);

            var _allowGridConfiguration = SkApplication.instance().authIsLoadded() ? SkApplication.instance().hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG_GRID) : true;
            const _CHART_CFG_KEY = SkApplication.instance().getResourceID() + '_DataGridCharts';
            const ALL_COLS = 'all_cols';
            const configCell = {
                heightComp: 20,
                heightConf: 40
            };

            $scope.firstClick = '0';
            var shiftSelect = AngularUtil.debounce(forceShiftSelect, 500);

            //Internacionalização de termos nativos do aggrid
            var _localeText = {
                loadingOoo: ' ',                
                filterOoo: (i18n('DataGrid.pesquisar') + '...'),
                rowGroupColumns: i18n('DataGrid.lblColumnGroup'),
                valueColumns:  i18n('DataGrid.valor'),
                columns: i18n('DataGrid.colunas'),
                pivotMode: i18n('DataGrid.pivot'),
                groups: i18n('DataGrid.grupos'),
                values: i18n('DataGrid.valores'),
                pivots: i18n('DataGrid.pivot'),
                valueColumnsEmptyMessage:  i18n('DataGrid.valueColumnsEmpty'),
                pivotColumnsEmptyMessage:  i18n('DataGrid.pivotColumnsEmpty'),
                rowGroupColumnsEmptyMessage:  i18n('DataGrid.pivotColumnsEmpty'),
                toolPanelButton: i18n('DataGrid.toolPanelButton'),
                sum: i18n('DataGrid.soma'),
                min: i18n('DataGrid.minimo'),
                max: i18n('DataGrid.maximo'),
                first: i18n('DataGrid.primeiro'),
                last: i18n('DataGrid.ultimo'),
                none: i18n('DataGrid.nada'),
                count: i18n('DataGrid.contagem'),
                avg: i18n('DataGrid.media'),
                per: i18n('DataGrid.personalizado'),
                chartRange: i18n('DataGrid.chartRange'),
                pivotChartAndPivotMode: i18n('DataGrid.pivotChartAndPivotMode'),
                pivotChart: i18n('DataGrid.pivotChart'),
                columnChart: i18n('DataGrid.columnChart'),
                groupedColumn: i18n('DataGrid.groupedColumn'),
                stackedColumn: i18n('DataGrid.stackedColumn'),
                normalizedColumn: i18n('DataGrid.normalizedColumn'),
                barChart: i18n('DataGrid.barChart'),
                groupedBar: i18n('DataGrid.groupedBar'),
                stackedBar: i18n('DataGrid.stackedBar'),
                normalizedBar: i18n('DataGrid.normalizedBar'),
                pieChart: i18n('DataGrid.pieChart'),
                pie: i18n('DataGrid.pie'),
                doughnut: i18n('DataGrid.doughnut'),
                line: i18n('DataGrid.line'),
                xyChart: i18n('DataGrid.xyChart'),
                scatter: i18n('DataGrid.scatter'),
                bubble: i18n('DataGrid.bubble'),
                areaChart: i18n('DataGrid.areaChart'),
                area: i18n('DataGrid.area'),
                stackedArea: i18n('DataGrid.stackedArea'),
                normalizedArea: i18n('DataGrid.normalizedArea'),
                settings: i18n('DataGrid.settings'),
                data: i18n('DataGrid.data'),
                format: i18n('DataGrid.format'),
                categories: i18n('DataGrid.categories'),
                series: i18n('DataGrid.series'),
                barGroup: i18n('DataGrid.barGroup'),
                pieGroup: i18n('DataGrid.pieGroup'),
                lineGroup: i18n('DataGrid.lineGroup'),
                scatterGroup: i18n('DataGrid.scatterGroup'),
                areaGroup: i18n('DataGrid.areaGroup'),
                columnGroup: i18n('DataGrid.lblColumnGroup'),
                pivotChartTitle: i18n('DataGrid.pivotChartTitle'),
                rangeChartTitle: i18n('DataGrid.rangeChartTitle'),
                axis: i18n('DataGrid.axis'),
                color: i18n('DataGrid.color'),
                thickness: i18n('DataGrid.thickness'),
                xRotation: i18n('DataGrid.xRotation'),
                yRotation: i18n('DataGrid.yRotation'),
                ticks: i18n('DataGrid.ticks'),
                width: i18n('DataGrid.width'),
                length: i18n('DataGrid.length'),
                padding: i18n('DataGrid.padding'),
                chart: i18n('DataGrid.chart'),
                title: i18n('DataGrid.title'),
                font: i18n('DataGrid.font'),
                top: i18n('DataGrid.top'),
                right: i18n('DataGrid.right'),
                bottom: i18n('DataGrid.bottom'),
                left: i18n('DataGrid.left'),
                labels: i18n('DataGrid.labels'),
                size: i18n('DataGrid.size'),
                legend: i18n('DataGrid.legend'),
                position: i18n('DataGrid.position'),
                markerSize: i18n('DataGrid.markerSize'),
                markerStroke: i18n('DataGrid.markerStroke'),
                markerPadding: i18n('DataGrid.markerPadding'),
                itemPaddingX: i18n('DataGrid.itemPaddingX'),
                itemPaddingY: i18n('DataGrid.itemPaddingY'),
                strokeWidth: i18n('DataGrid.strokeWidth'),
                offset: i18n('DataGrid.offset'),
                tooltips: i18n('DataGrid.tooltips'),
                offsets: i18n('DataGrid.offsets'),
                callout: i18n('DataGrid.callout'),
                markers: i18n('DataGrid.markers'),
                shadow: i18n('DataGrid.shadow'),
                blur: i18n('DataGrid.blur'),
                xOffset: i18n('DataGrid.xOffset'),
                tOffset: i18n('DataGrid.tOffset'),
                lineWidth: i18n('DataGrid.lineWidth'),
                normal: i18n('DataGrid.normal'),
                bold: i18n('DataGrid.bold'),
                italic: i18n('DataGrid.italic'),
                boldItalic: i18n('DataGrid.boldItalic'),
                fillOpacity: i18n('DataGrid.fillOpacity'),
                strokeOpacity: i18n('DataGrid.strokeOpacity'),
                groupedColumnTooltip: i18n('DataGrid.groupedColumnTooltip'),
                stackedColumnTooltip: i18n('DataGrid.stackedColumnTooltip'),
                normalizedColumnTooltip: i18n('DataGrid.normalizedColumnTooltip'),
                groupedBarTooltip: i18n('DataGrid.groupedBarTooltip'),
                stackedBarTooltip: i18n('DataGrid.stackedBarTooltip'),
                normalizedBarTooltip: i18n('DataGrid.normalizedBarTooltip'),
                pieTooltip: i18n('DataGrid.pieTooltip'),
                doughnutTooltip: i18n('DataGrid.doughnutTooltip'),
                lineTooltip: i18n('DataGrid.lineTooltip'),
                groupedAreaTooltip: i18n('DataGrid.groupedAreaTooltip'),
                stackedAreaTooltip: i18n('DataGrid.stackedAreaTooltip'),
                normalizedAreaTooltip: i18n('DataGrid.normalizedAreaTooltip'),
                scatterTooltip: i18n('DataGrid.scatterTooltip'),
                bubbleTooltip: i18n('DataGrid.bubbleTooltip'),
                noDataToChart: i18n('DataGrid.noDataToChart')
            };

            var _enableFilterDatePeriod = false;

            function createAggGrid(){
                let isCompactMode = angular.isDefined($scope.compactMode) ? $scope.compactMode : true;
                //Id unico da grid
                $scope.uniqueid = 'ag-grid-container-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
                //Opções da grade
                $scope.gridOptions = {
                    rowHeight: isCompactMode ? configCell.heightComp : configCell.heightConf,
                    rowSelection: $scope.allowMultipleSelection == undefined ? 'multiple' : $scope.allowMultipleSelection == true ? 'multiple' : 'single',
                    //Click simples aditivo (sem ctrl) quando skKeepCheckboxSelectionOnRowClick está ativa,
                    //evita que o aggrid desmarque as demais linhas antes do onRowClicked.
                    rowMultiSelectWithClick: $scope.keepCheckboxSelectionOnRowClick === true,
                    columnDefs: $scope.columnDefs,
                    navigateToNextCell: navigateToNextCell,
                    rowModelType: 'serverSide',
                    paginationPageSize: $scope.rowsByPage,
                    cacheOverflowSize: 2,
                    maxConcurrentDatasourceRequests: 2,
                    infiniteInitialRowCount: 1,
                    maxBlocksInCache: 2,
                    onSortChanged: aggridSortFunction,
                    components: {
                        skCellEditor: SkCellEditor,
                        skFloatingFilter: SkFloatingFilter,
                        skPinnedRowRenderer: SkPinnedRowRenderer,
                        skCbxSelectionCellRenderer: CbxSelectionCellRenderer,
                        skHeaderCbxRowSelection: HeaderCbxRowSelection,
                        skCellRenderer: SkCellRenderer,
                        skDraggableRenderer: SkDraggableRenderer,
                        userCellRenderer: UserCellRenderer,
                        customLoadingCellRenderer: CustomLoadingCellRenderer,
                        skCustomTooltip: SkCustomTooltip
                    },
                    angularCompileRows: false,
                    onRowClicked: onRowClicked,
                    onCellDoubleClicked: onRowDoubleClicked,
                    sortingOrder: ['asc', 'desc'],
                    tabToNextCell: tabToNextCell,
                    overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Carregando dados da grade</span>',
                    onColumnResized: columnResized,
                    onColumnMoved: columnMoved,
                    onDragStopped: dragStopped,
                    getMainMenuItems: getMainMenuItems,
                    autoGroupColumnDef: {
                        headerName: i18n('DataGrid.lblColumnGroup'),
                        suppressSorting: false,
                        menuTabs: ['generalMenuTab'],
                        getMainMenuItems: getMainMenuItems,
                        pinned: 'left',
                        cellClass: function (params) {
                            return (('sk-group-cell ' + ($scope.compactMode ? '' : 'sk-cell-confortable-mode ')) + getPersonalizedCollorsClass(params));
                        },
                        cellRenderer: 'agGroupCellRenderer',
                        cellRendererParams: {
                            innerRenderer: function(params){
                                return params.valueFormatted ? params.valueFormatted : (params.value != undefined ? params.value : '');;
                            }
                        },
                        headerComponentParams: {
                            template: getCellHeaderTpl()
                        },
                        cellStyle: function (params) {
                            return getCellStyle(params)
                        }
                    },
                    getRowNodeId: getRowNodeId,
                    suppressPropertyNamesCheck: true,
                    getContextMenuItems: getContextMenuItems,
                    defaultColDef: {
                        floatingFilterComponent: 'SkFloatingFilter',
                        floatingFilterComponentParams: {
                            suppressFilterButton: true,
                            color: 'blue'
                        },
                        enableRowGroup: true,
                        cellRenderer: 'skCellRenderer',
                        resizable: _allowGridConfiguration,
                        suppressMovable: !_allowGridConfiguration,
                        sortable: ($scope.disableSorting == false || $scope.disableSorting == undefined),
                        filter: true,
                        tooltipComponent: 'skCustomTooltip',
                    },
                    icons: {
                        sortAscending: '<span></span>',
                        sortDescending: '<span></span>',
                        groupExpanded: '<i class="glyphicons glyphicons-chevron-down"/>',
                        groupContracted: '<i class="glyphicons glyphicons-chevron-right"/>',
                        checkboxChecked: '<span class="glyphicons glyphicons-check sk-check-box"></span>',
                        checkboxUnchecked: '<span class="glyphicons glyphicons-unchecked sk-check-box"></span>',
                    },
                    getRowHeight: getRowHeight,
                    onVirtualColumnsChanged: AngularUtil.debounce(virtualColumnsChanged, 40, $scope, false),
                    filter: true,
                    localeText: _localeText,
                    floatingFilter: false,
                    suppressDragLeaveHidesColumns: true,
                    enableCharts: isEnableCharts(),
                    enableRangeSelection: isEnableCharts(),
                    getRowStyle: function (params) {
                        if (params.node.rowPinned) {
                            return { 'background': '#F9F9F9', 'border-top': 'solid 1px #C8CCD3', 'font-weight': 'bold', 'font-size': '13px' }
                        }
                    },
                    onCellFocused: function (event) {
                        if (event.column) {
                            _self.lastFocusedCell = event.column;
                        }
                    },
                    onCellEditingStopped: function (params) {
                        _editorOpenned = false;
                        if($scope.datagridInterceptor && angular.isFunction($scope.datagridInterceptor.onEditionEnd)){
                            $scope.datagridInterceptor.onEditionEnd(params.colDef.field, params.data, $scope.dataset.getRecordByUniqueId(params.node.id), params.node.id);
                        }
                    },
                    onCellEditingStarted: function (event) {
                        _editorOpenned = true;
                        _colEditing = event.column;
                        SanPopupStack.registerActiveListener(_popUpStackObserver);
                        
                        if($scope.datagridInterceptor && angular.isFunction($scope.datagridInterceptor.onEditionStart)){
                            $scope.datagridInterceptor.onEditionStart();
                        }
                    },
                    onBodyScroll: bodyScroll,
                    getChildCount: function (data) {
                        return data ? data.countChield : 0;
                    },
                    onViewportChanged: function (evt) {
                        var firstRow = evt.firstRow;
                        var lastRow = evt.lastRow;

                        if ($scope.dataset && (!$scope.dataset.getSelectedRecords() || $scope.dataset.getSelectedRecords().length == 0) && $scope.gridOptions && $scope.gridOptions.api && $scope.gridOptions.api.getSelectedNodes().length < 2) {
                            return;
                        }
                        for (; firstRow < lastRow; firstRow++) {
                            var node = $scope.gridOptions.api.getDisplayedRowAtIndex(firstRow);
                            if (node && $scope.dataset.isSelected(node.id)) {
                                node.setSelected(true);
                                if(_ckbRowSelectionByNodeId[node.id]){
                                    _ckbRowSelectionByNodeId[node.id].check();
                                }
                            }else{
                                if(node){
                                    node.setSelected(false);
                                    if(_ckbRowSelectionByNodeId[node.id]){
                                        _ckbRowSelectionByNodeId[node.id].unCheck();
                                    }
                                }
                            }
                        }
                    },
                    onColumnRowGroupChanged: function(params) {
                        _pivotMode = params.columns.length > 0;                        
                        
                        if (getNavigatorInstanceOfDataset()) {
                            getNavigatorInstanceOfDataset().setDataGridMode(_pivotMode, _self);
                        }

                        if(params.source != 'api'){
                            _columnsGrouped = [];
                            params.columns.forEach(function(col){                               
                                _columnsGrouped.push(col.colDef.field);
                            });
                            addToolTipOnGroup();
                        }

                        if($scope.hideCbxColumn == false){
                            if(params.columns.length > 0){
                                $scope.gridOptions.columnApi.setColumnVisible ('-100000', false);
                            }else{
                                $scope.gridOptions.columnApi.setColumnVisible ('-100000', true);
                            }
                        }
                    },
                    onColumnValueChanged : function(params){
                        if(params.column && !colsAggregate.hasOwnProperty(params.column.colId) && _pivotMode){
                            $scope.gridOptions.columnApi.moveColumn(params.column.colId, 1);
                        }
                        if(_pivotMode){
                            colsAggregate = {};
                            params.columns.forEach(function(col){
                                colsAggregate[col.colId] = undefined;
                            });
                        }
                    },
                    headerHeight: getHeaderRowHeight(),
                    suppressCopyRowsToClipboard: true,
                    sendToClipboard: sendToClipboard,
                    onGridReady: onGridReady,
                    /*
                    TODO: Essa configuracao foi movida para gridconfig.service.js utilizndo o metodo 
                    gridApi.setSideBar por conta de um problema de performace no ag-grid, que ao mover colunas
                    de posição com o sidebar ativo a operação de moveColumn ficava muito lenta.
                    
                    sideBar: {
                        toolPanels: [
                            {
                                id: 'columns',
                                labelKey: 'columns',
                                iconKey: 'columns',
                                toolPanel: 'agColumnsToolPanel',
                                toolPanelParams: {
                                    suppressPivots: true,
                                    suppressPivotMode: true,
                                    suppressColumnSelectAll: true
                                }
                            }
                        ],
                        defaultToolPanel: 'columns',
                        hiddenByDefault: true,
                        filter: true,
                        resizable: true,
                    },*/
                    processChartOptions: processChartOptions,
                    getChartToolbarItems: function(){
                        return ['chartSettings', 'chartData', 'chartFormat', 'chartDownload'];
                    },
                    postProcessPopup: function(params) {
                        if(!params.ePopup) return;
                        if(params.type === 'columnMenu'){
                            const popup = params.ePopup;
                            popup.style.top = '0px';
                            popup.style.paddingTop = '0px';
                        }
                    },
                    onChartOptionsChanged: onChartOptionsChanged,
                    popupParent: document.body,
                }

                if($scope.keyProperty && $scope.parentProperty){
                    $scope.gridOptions.treeData = true;
 
                    $scope.isTreeData = true;
                    
                    $scope.gridOptions.isServerSideGroup = data => {
 
                         if(!_mapTreeItems.hasOwnProperty(data[$scope.keyProperty])){
                             _mapTreeItems = {};
                             let indexParent = $scope.dataset.getFieldIndexByName($scope.parentProperty);
                             $scope.dataset.getRecords().forEach( record => {                                
                                 if(!_mapTreeItems[record[indexParent]]){
                                     _mapTreeItems[record[indexParent]] = 0;    
                                 }
                                 _mapTreeItems[record[indexParent]]++;
                             });
                         }
 
                         return _mapTreeItems[data[$scope.keyProperty]] > 0;
                    };
                    
                    $scope.gridOptions.getServerSideGroupKey = data => {
                         return data[$scope.keyProperty];
                    };
 
                    $scope.gridOptions.rowSelection = 'single';
                 }

                if(typeof SkDashboardCellRenderer !== "undefined") {
                	$scope.gridOptions.components.skDashboardCellRenderer = SkDashboardCellRenderer;
                	$scope.gridOptions.components.skDashboardPinnedRowCellRenderer = SkDashboardPinnedRowCellRenderer;
                }
                //Compilamos a grade e adicionamos ela no dom.
                var gridCompiled = AngularUtil.compile('<div id=' + $scope.uniqueid + ' ag-grid="gridOptions" flex class="ag-theme-balham sk-datagrid-container"></div>', $scope)
                _gridElem = gridCompiled[0];
                angular.element($element[0].querySelector('.sk-aggrid-container')).replaceWith(gridCompiled);

                //busca configurações dos graficos
                loadChartPreferences();

                $scope.disableFirstSelect = $scope.disableFirstSelect === true || $scope.disableFirstSelect === 'true' ? true : false;
            }

            createAggGrid();

            var _keymap = {
                TAB: 9,
                STRG: 17,
                CTRL: 17,
                CTRLRIGHT: 18,
                SHIFT: 16,
                ENTER: 13,
                BACKSPACE: 8,
                ALT: 18,
                ALTRIGHT: 17,
                SPACE: 32,
                WIN: 91,
                MAC: 91,
                PG_UP: 33,
                PG_DOWN: 34,
                ARROW_UP: 38,
                ARROW_DOWN: 40,
                ARROW_LEFT: 37,
                ARROW_RIGHT: 39,
                ESC: 27,
                DEL: 46,
                F1: 112,
                F2: 113,
                F3: 114,
                F4: 115,
                F5: 116,
                F6: 117,
                F7: 118,
                F8: 119,
                F9: 120,
                F10: 121,
                F11: 122,
                F12: 123,
                FN: null,
                HOME: 36,
                END: 35
            };

            const distinctDataColumns = [];
            let _loadedTips = {};

            var _self = this;
            var _gridElem;
            var _onlyCustomColumns = $attrs.hasOwnProperty('skOnlyCustom');
            var _customColumnsMD = {};
            var _onlyCustomOrder = 0;
            var _descriptionFieldNames = {};
            var _originalColumnDefs = [];
            var _charToPixelRatio = 14;
            var _columnDefsByName = {};
            var _lastColumnsSorted = {};
            var _colEditing;
            var _selectNodes = [];
            var _fristLoadExecuted = false;
            var _dataSource;
            var _programmaticallySelectingRecord = false;
            var _lastColumnMoved;
            var _editorsByCols = {};
            var _columnsGrouped = [];
            var _pivotMode = false;            
            var _lengthByGroups = {};
            var _classByCols = {};
            var _iconsByCols = {};
            var _removeActiveFilterFn;
            var _footerColsAggretaion = [];
            var _ignoreKeysOnEdit = [_keymap.ARROW_DOWN, _keymap.ARROW_LEFT, _keymap.ARROW_RIGHT, _keymap.ARROW_UP, _keymap.ENTER, _keymap.ESC, _keymap.HOME, _keymap.END];
            var _editorOpenned = false;
            var _elGridMenu;
            var _keyIsPressed = false;
            var _selectAll = false;
            var _editorScope;
            var _colsOfReset = {};
            var _lockEventListeners = false;
            var _awaitSaveToEdit = false;
            var typesAcceptAgregateFunction = ['I', 'F', 'CUR'];
            var colsAggregate = {};
            var _dsSuccessCallBack;
            var _dsSuccessCallBackPending = false;
            var _dsSuccessCallBackTimeout;
            var _ckbRowSelectionByNodeId = {};
            var _ckbRowSelectionCheckeds = {};
            var _cbxHeaderRowSelection;
            var _removeDsObservers = [];
            var _gridReadyListeners = [];
            var _checked = [];
            var _defaulToolPanel = 'columns';
            var _colorMap = {};
            var _savedUserPreferenceByChartType = {};
            var _actualChartType = '';            
            var _chartPreferencesChanged = false;
            var _lockRowClick = false;
            var _customCellRendererByColumn = {};
            var _customCellEditorByColumn = {};
            var _ignoreEnterListener = false;
            var _mapTreeItems = {};
            var _recordsToSelectPgDown = [];
            var evtKeyboard;
            var clickRow;
            var isEventToSort = false;
            let _scrollContainerX;
            let _bodyViewPort;
            let _disabledBodyDiv = document.createElement('div');
            let _disabledHeaderDiv = document.createElement('div');
            let _popUpStackObserver;
            let _lastSelectedRowID;
            let _lastStartEditColId;
            let _dataGridScrolled = new CustomEvent("dataGridScrolled");

            _self.dropSelectedRow = dropSelectedRow;
            _self.refreshView = refresh;
            _self.getColumnByName = getColumnByName;
            _self.endEdit = endEdit;
            _self.startEdit = startEdit;
            _self.setViewModeToLoaded = setViewModeToLoaded;
            _self.setViewModeToLoading = setViewModeToLoading;
            _self.getColumnDefs = getColumnDefs;
            _self.setColumnDefs = setColumnDefs;
            _self.openGridConfig = openGridConfig;
            _self.startTour = startTour;
            _self.setCompactMode = setCompactMode;
            _self.getGridApi = getGridApi;
            _self.skSortFunction = skSortFunction;
            _self.addCustomColumnMD = addCustomColumnMD;
            _self.getDataset = getDataset;
            _self.getOriginalColumnDefs = getOriginalColumnDefs;
            _self.getRecords = getRecords;
            _self.getScopeId = getScopeId;
            _self.getSelectedRecords = getSelectedRecords;
            _self.getVisibleColumnDefs = getVisibleColumnDefs;
            _self.refreshCells = refreshCells;
            _self.setBottomData = setBottomData;
            _self.selectAllRecords = selectAllRecords;
            _self.unselectAllSelectedRows = unselectAllSelectedRows;
            _self.pinColumn = pinColumn;
            _self.unpinColumn = unpinColumn;
            _self.getGridOptions = getGridOptions;
            _self.getCurrentColIndexByColumnDef = getCurrentColIndexByColumnDef;
            _self.getCurrentColByFieldName = getCurrentColByFieldName;
            _self.getFilterFunction = getFilterFunction;
            _self.setFilterByColumn = setFilterByColumn;
            _self.getFilterByColumn = getFilterByColumn;
            _self.getFilterInfoColumn = getFilterInfoColumn;
            _self.removeFilterByColumn = removeFilterByColumn;
            _self.clearSearchOfCols = clearSearchOfCols;
            _self.previousRow = previousRow;
            _self.nextRow = nextRow;
            _self.hasPrevious = hasPrevious;
            _self.hasNext = hasNext;
            _self.initializeDatagrid = initializeDatagrid;
            _self.getColumnApi = getColumnApi;
            _self.resetColumnWidths = resetColumnWidths;
            _self.getColumnWidth = getColumnWidth;
            _self.updateGridOptions = updateGridOptions;
            _self.setOnDblClick = setOnDblClick;
            _self.setAllowMultipleSelection = setAllowMultipleSelection;
            _self.setSelectedRecords = setSelectedRecords;
			_self.updateGridColumn = updateGridColumn;
            _self.getGridUniqueId = getGridUniqueId;
            _self.openGridMenu = openGridMenu;
            _self.closeGridMenu = closeGridMenu;
            _self.closeToolPanel = closeToolPanel;
            _self.openToolPanel = openToolPanel;
            _self.isAllowMultipleSelection = isAllowMultipleSelection;
            _self.isEnableDynamicMode = isEnableDynamicMode;
			_self.refreshLayout = refreshLayout;
			_self.setGroupColumn = setGroupColumn;
            _self.setGroupColumns = setGroupColumns;
            _self.addGridReadyListener = addGridReadyListener;
            _self.setOrderColumn = setOrderColumn;
            _self.setEnableFilterDatePeriod = setEnableFilterDatePeriod; 
            _self.disableSearch = disableSearch;
            _self.setEnabled = setEnabled;
            _self.hasCbxColumn = hasCbxColumn;
            _self.selectNodeByIndex = selectNodeByIndex;
            _self.syncSelectOnDataset = syncSelectOnDataset;
            _self.setNextFocusCell = setNextFocusCell;
            _self.tabToNextEditableRow=tabToNextEditableRow;
            _self.setLockEvent =setLockEvent;
            _self.tabToNextEditableCell = tabToNextEditableCell;
            _self.setLastSelectedRowID = setLastSelectedRowID;
            _self.getLastStartEditColId = getLastStartEditColId;
            _self.setAwaitSaveToEdit = setAwaitSaveToEdit;
            _self.getEditorOpenned = getEditorOpenned;

            _self.lastFocusedCell;

            _self.setFocus = setFocus;
            _self.addCustomCellRenderer = addCustomCellRenderer;
            _self.addCustomEditorRenderer = addCustomEditorRenderer;

            $scope.columnDefs = [];
            $scope.endEdit = endEdit;
            $scope.rowsByPage;
            $scope.stateText = i18n("DataGrid.stateTextCarregando");
            $scope.selectRecords = i18n("DataGrid.selectedRecords");
            $scope.filterByColumn = {};
            $scope.filterColumnInfo = {};
            $scope.enableGridMenu = $scope.enableGridMenu || true;
            $scope.onSelectEntity = onSelectEntity;
            $scope.loadSuggestions = loadSuggestions;
            $scope.searchByColumn = {};
            $scope.compactMode = true;
            $scope.onGridContainerClick = onGridContainerClick;

            $scope.$on('$destroy', function() {
                //Remove observers do dataset
                _removeDsObservers.forEach(function(fnRemove){
                    if(angular.isFunction(fnRemove)){
                        fnRemove();
                    }
                });
                //Remove observers do popupstack
                SanPopupStack.removeObserver(_popUpStackObserver);
                
                // Limpa callbacks pendentes
                clearDsSuccessCallback();
            });

            angular.element($window).bind('resize', function(){
                onWindowResize();
            });

            if (!$scope.rowsByPage) {
                $scope.rowsByPage = 100;
            }

            const DEFAULT_DECIMAL_PRECISION = 2;
            const ICON_FILTER = 'glyphicons glyphicons-filter'            

            var allDataInCache;

            function setViewModeToLoading() {
                $scope.viewMode = 'loading';
            };

            function setViewModeToLoaded() {
                $scope.viewMode = 'loaded';
                AngularUtil.apply($scope);
            };

            if ($scope.editable === undefined) {
                $scope.editable = true;
            };

            $scope.$on('datasetRefreshed', function () {
                $scope.column.distinctData = undefined;
            });

            //Utilizado para travar listeners ao utilizar o menu da grade
            $scope.$watch('showMenuGrid', function(newValue){
                _lockEventListeners = newValue;

                if(newValue == true){
                    resizeGridMenu();        
                }

            });

            function resizeGridMenu(){
                $timeout(function(){
                    let eGridMenu = $element.find('.grid-menu');
                    if(eGridMenu[0]){
                        let eGridMid = eGridMenu[0].querySelector('.ui-grid-menu-mid');
                        if(eGridMid){
                            let eHeader = $element[0].querySelector('.ag-header-container');
                            let headerHeight = 0;
                            if(eHeader){
                                headerHeight = eHeader.offsetHeight;
                            }
                            eGridMid.style.maxHeight = (($element[0].offsetHeight - headerHeight) - 5) + 'px';
                        }
                    }
                });

            }

            //Editor
            function SkCellEditor() { }

            //Função utilizada para iniciar a edição quando a celula em edição receber o foco apos fechamento de um popUp
            function onGridCellEditingFocused(evt) {
                if (evt.relatedTarget && _editorOpenned && _editorScope.editor.length && _editorScope.editor.length > 0) {
                    var input = _editorScope.editor[0].querySelector('input');
                    if(input){
                        input.focus();
                    }
                }
            }

            SkCellEditor.prototype.init = function (params) {
                _editorScope = this;
                _editorScope.fieldName = params.column.colDef.field;
                _editorScope.charPress = params.charPress;
                _editorScope.eGridCell = params.eGridCell;
                _editorScope.params = params;
                
                _editorScope.personalizedEditorRenderer = getCustomCellEditor(params.column.colId);

                if ($scope.dataset) {
                    _editorScope.indexOnDataSet = $scope.dataset.getIndexByUniqueId(params.node.id);
                }

                var editor = _editorsByCols[params.column.colId];
                //Devemos sempre adicionar a coluna no scope pois o angular utiliza a mesma para criar a diretiva    
                
                if (!editor) {
                    _editorScope.ngEditorScope = $scope.$new(true);
                    _editorScope.ngEditorScope.col = params.column;
                    _editorScope.ngEditorScope['dataset'] =  $scope.dataset;
                    _editorScope.ngEditorScope.col.doDragDrop =  doDragDrop;
                    
                    if($scope.focusOut && _editorScope.ngEditorScope.col.colId) {
                    	_editorScope.ngEditorScope.col.focusOut = $scope.focusOut(_editorScope.ngEditorScope.col.colId);
                    }                  
                    
                    var template = buildEditComponentsTemplate(_editorScope.ngEditorScope.col);
                    
                    editor = AngularUtil.compile(template, _editorScope.ngEditorScope);
                    
                    if(editorIsCacheable(params.column)){
                        _editorsByCols[_editorScope.ngEditorScope.col.colId] = editor
                    }                    
               }

                SkCellEditor.prototype.setupEditor(editor);
            };

            SkCellEditor.prototype.setupEditor = function(editor){
                _editorScope.editor = angular.element(editor);
                
                _editorScope.editor[0].addEventListener('keydown', onGridCellEditKeydown);

                _editorScope.editor[0].addEventListener('dblclick', onRowDoubleClicked);
                //Utilizado para quando aberto o popup de erro ou elerta e voltar o foco para a grade, já iniciar a edição novamente
                _editorScope.eGridCell.addEventListener('focus', onGridCellEditingFocused);
                //Ajustamos o tamanho da celula por conta do confortable mode
                _editorScope.eGridCell.setAttribute('style', _editorScope.eGridCell.getAttribute('style') + ' height:' + getRowHeight() + 'px;');
            }

            SkCellEditor.prototype.getGui = function () {
                if(_editorScope.personalizedEditorRenderer && _editorScope.personalizedEditorRenderer.getGui){
                    editor = _editorScope.personalizedEditorRenderer.getGui(_editorScope.params, _editorScope.editor, _editorScope.ngEditorScope, getCustomUtils());
                    SkCellEditor.prototype.setupEditor(editor);
                    
                    if(_editorScope.editor){
                        if(_editorScope.editor.css('width') == '0px'){
                            _editorScope.editor.css('width', '100%')
                        }
                    }
                }
                return _editorScope.editor[0];
            };

            SkCellEditor.prototype.afterGuiAttached = function () {
                this.inputEl = getTextInput();
                let value = '';

				// Notifica ao dataset o valor do campo
                if($scope.dataset){
                    if(_editorScope.charPress){
                        value = _editorScope.charPress;

                        let isPhone = _editorScope.editor.find('sk-phone-input').length > 0;
                        if (isPhone) {
                            $scope.dataset.setFieldValue(_editorScope.fieldName, value);
                        }
                    }else if($scope.dataset.getFieldValue(_editorScope.fieldName)){
                        value = $scope.dataset.getFieldValue(_editorScope.fieldName);
                    }
                }

                let isSpecificEditor = (editorScope, selector) => {
                    return editorScope.editor.find(selector).length > 0;
                };
                
                let handleEditorModification = (skEditorElem, ctrl) => {
                    const excludedSelectors = ['sk-combobox', 'sk-switch'];
                    if (!excludedSelectors.includes(skEditorElem?.selector)) {
                        ctrl.modify();
                    }
                };
                
                let handleInputFocus = (inputToFocus, value, fieldName) => {
                    if (angular.isDefined(value)) {
                        const selectorsToSelect = ['sk-phone-input', 'sk-date-time-input', 'sk-combobox', 'sk-switch'];
                        let shouldSelectInput = selectorsToSelect.some(selector => isSpecificEditor(_editorScope, selector));
                        if (!shouldSelectInput) {
                            inputToFocus.val(value);
                            $timeout(() => {
                                $scope.dataset.setFieldValue(fieldName, inputToFocus.val());
                            }, 210);
                        } else {
                            inputToFocus[0].select();
                        }
                    }
                    inputToFocus[0].focus();
                };
                
                let setFocus = () => {
                    if (_editorScope.charPress && $scope.dataset) {
                        let ctrl;                            
                        let inputName = ObjectUtils.getProperty(_editorScope, 'params.colDef.inputName');
                        let skEditorElem = _editorScope.editor.find(inputName);
                
                        if (skEditorElem && skEditorElem.length > 0 && (ctrl = AngularUtil.getControllerFromElement(skEditorElem)) && angular.isFunction(ctrl.setData)) {
                            ctrl.setData(_editorScope.charPress);
                            handleEditorModification(skEditorElem, ctrl);
                            _editorScope.editorController = ctrl;
                        } else if (this.inputEl && this.inputEl.length > 0) {
                            this.inputEl[0].value = value;
                        }
                
                        var inputToFocus = getTextInput();
                        $timeout(() => {
                            if (inputToFocus && inputToFocus.length > 0) {
                                handleInputFocus(inputToFocus, value, _editorScope.fieldName);
                            }
                        });
                    } else {
                        var inputToFocus = getTextInput();
                        var valueInputItem = inputToFocus.val();
                        $timeout(function(){
                            if (inputToFocus && inputToFocus.length > 0) {
                                if (angular.isDefined(valueInputItem)) {
                                    inputToFocus[0].select()
                                }
                                inputToFocus[0].focus();
                            }
                        });
                    }
                    $scope.$broadcast('UiSelectFocusEvent');
                    AngularUtil.apply($scope);
                
                    if(_editorScope.params.charPress){
                        _self.lastEditingCell = {
                            column : _editorScope.params.column,
                            rowIndex: _editorScope.params.node.id,
                            rowPinned: _editorScope.params.column.pinned
                        };
                    }
                
                    $timeout(() => openSelectIfNeed(_editorScope.editor));
                }
                
                // Verificação necessária pois nem sempre o campo input já está devidamente construído na DOM nesse momento
                if (angular.isDefined(this.inputEl) && this.inputEl.length > 0) {
                    setFocus();
                }else{
                    $timeout(() => {
                        this.inputEl = getTextInput();
                        if (this.inputEl && this.inputEl.length > 0) {
                            setFocus(); 
                        }
                    });
                }

                $scope.gridOptions.api.setFocusedCell(_editorScope.params.rowIndex, _editorScope.params.column.colId);
            };

            function openSelectIfNeed(element){
                if(_self.skipAutoOpenSelect){
                    _self.skipAutoOpenSelect = false;
                    return;
                }

                let selectElement = element.find('sk-combobox');

                if(selectElement && selectElement.children()){
                    let scopeSelect = selectElement.children().scope();
                    if(scopeSelect && scopeSelect.$select){
                        scopeSelect.$select.toggle();
                        AngularUtil.digest(scopeSelect);
                        _self.selectScope = scopeSelect;
                    }
                }
            }

            SkCellEditor.prototype.getValue = function () {
                var record = $scope.dataset.getRecord(_editorScope.indexOnDataSet);
                
                if(_editorScope.personalizedEditorRenderer && _editorScope.personalizedEditorRenderer.getValue){
                    return _editorScope.personalizedEditorRenderer.getValue(record);
                }else{
                    if (_editorScope.editor.find('sk-controle-estoque-input').length > 0) {
                        return _editorScope.params.data.CONTROLE || "";
                    }               
                    var inputEl = getTextInput();
                    if (record) {
                        var fieldIndex = $scope.dataset.getFieldIndexByName(_editorScope.fieldName);
                        return record[fieldIndex];
                    } else if (inputEl && inputEl[0]) {
                        return inputEl[0].value || "";
                    }
                }                
            };

            SkCellEditor.prototype.destroy = function () {
                _editorOpenned = false;
                if(this.inputEl && this.inputEl.length > 0 && this.inputEl[0].blur){
                    this.inputEl[0].blur();
                }
                _editorScope.eGridCell.removeEventListener('focus', onGridCellEditingFocused);
                _editorScope.editor[0].removeEventListener('dblclick', onRowDoubleClicked);
            };

            SkCellEditor.prototype.isPopup = function () {
                return false;
            };

            function getKey (field, value){
                var fieldMd;
                if($scope.dataset){
                    fieldMd = $scope.dataset.getFieldMetadata(field);
                }

                return (value === undefined || value === '') ? ( (!fieldMd || typesAcceptAgregateFunction.indexOf(fieldMd.dataType) == -1) ? i18n('DataGrid.empty') : '0') : value;
            }

            function onGridKeyDown(evt) {
                _keyIsPressed = true;
                if(_lockEventListeners){
                    return;
                }
                if (evt.ctrlKey && evt.keyCode == 65) {
                    selectAllRows();
                }else if(evt.keyCode == _keymap.F2){
                    //A linha que está sendo edidata precisa ser a atual do dataset
                    var rowId = evt.target.parentElement.getAttribute('row-id');
                    var indexOfDataset = $scope.dataset.getIndexByUniqueId(rowId);
                    if($scope.dataset.getCurrentIndex() != indexOfDataset){
                        endEdit();
                        setNextFocusCell();
                    }
                }
            }

            function onGridKeyDownUseCapture(evt) {
                if(isLockEventListeners(evt.keyCode)){
                    evt.preventDefault();
                    return;
                }
                if((evt.keyCode == _keymap.HOME || evt.keyCode == _keymap.END) && !_editorOpenned){
                    var isHome = evt.keyCode == _keymap.HOME;

                    var allCols = $scope.gridOptions.api.gridCore.columnController.allDisplayedColumns;
                    var colId;                                  
                    if(allCols && allCols.length > 0){
                        var pos = isHome ? 0 : (allCols.length - 1);
                        colId = allCols[pos].colId;
                    }

                    //Posicionar na ultima/primeira celula e ultima linha
                    if(evt.ctrlKey || evt.metaKey){

                        var fn = function(){
                            var nodeToPosition = $scope.gridOptions.api[ isHome ? 'getFirstDisplayedRow' : 'getLastDisplayedRow']();
                            var newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(nodeToPosition);
                            newNode.setSelected(true, true);
                        }
                        
                        loadGridByIndex(isHome ? 0 : $scope.dataset.size() - 1);
                        $scope.gridOptions.api.ensureColumnVisible(colId);

                        $timeout( function(){
                            fn();
                            setFocusOnCell(colId);
                        });

                    }else{ //Posicionar na ultima/primeira coluna da linha selecionada.

                        if(colId){
                            $scope.gridOptions.api.ensureColumnVisible(colId);
                            $timeout( function(){
                                setFocusOnCell(colId);
                            });
                        }
                    }

                    evt.preventDefault();
                }else if(evt.keyCode == _keymap.ENTER){
                    evt.preventDefault();
                    evt.stopPropagation();
                } 
            }

            function gotoNewNode(current, isBack){
                var nexPos = isBack ? -1 : 1;
                var newIndex = current.rowIndex + nexPos;
                var newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(newIndex);

                if (_awaitSaveToEdit) {
                    _lockEventListeners = true;
                }
                
                if (newNode) {
                    newNode.setSelected(true, true);
                }else{ 
                    //nesse caso não exitem mais linhas, posicionamos na primeira ou ultima linha diponivél
                    var fn = function(){
                        var nodeToPosition = $scope.gridOptions.api[isBack ? 'getLastDisplayedRow' : 'getFirstDisplayedRow']();
                        var newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(nodeToPosition);
                        newNode.setSelected(true, true);
                    }

                    if(isBack){
                        loadGridByIndex($scope.dataset.size() - 1);
                        $timeout(fn);
                    }else{
                        fn();
                    }
                }
                $q.all(onRowClicked(undefined, true)).then(function () {
                    $timeout(function () {
                        /*
                        Removido pois estamos nos baseando no
                        mesmo comportamento do Google Sheets
                        
                        startEdit(current.column.colId, newIndex);
                        */
                        
                        _self.lastEditingCell = current
                        _self.lastClickedColId = newIndex;
                        if (_awaitSaveToEdit) {
                            _lockEventListeners = false;
                        }
                    }, _awaitSaveToEdit ? 500 : 50);
                    
                });
            }

            function isArrowUpOrDown(evt) {
                return (evt.keyCode == _keymap.ARROW_UP || evt.keyCode == _keymap.ARROW_DOWN);
            }

            function onGridKeyUp(evt) {
                _keyIsPressed = false;
                 evtKeyboard=evt;
                 clickRow=undefined;

                if (isLockEventListeners(evt.keyCode)) {
                    return;
                }

                if (((evt.keyCode == _keymap.ENTER || (isArrowUpOrDown(evt) && !_programmaticallySelectingRecord && _editorOpenned)) && 
                    (isAggridEditor(evt.srcElement || evt.originalTarget) || isAggridCell(evt.srcElement || evt.originalTarget))) && 
                    !_ignoreEnterListener) {

                    var currentCell = $scope.gridOptions.api.getEditingCells()[0];
                    var focusedCell = $scope.gridOptions.api.getFocusedCell();
                    let toNextRow = true;

                    let columnEditable = !!focusedCell?.column?.colDef?.editable;

                    if($scope.editable == false && !columnEditable && $scope.onDblClick){
                        toNextRow = $scope.onDblClick();
                    }
                    
                    //Se parâmetro "mgecom.usar.enter.como.tab.grade.itens" desligado, campos de pesquisa devem ser como TAB mesmo clicando ENTER
    				if (evt.keyCode == _keymap.ENTER && 
                        (angular.isDefined(ObjectUtils.getProperty(currentCell, 'column.colDef.inputName')) &&
                            currentCell.column.colDef.inputName == "sk-pesquisa-input") &&
                        (!$scope.enterAsTab || !MGEParameters.asBoolean("mgecom.usar.enter.como.tab.grade.itens"))
                    ) {
                        $scope.gridOptions.api[evt.shiftKey ? 'tabToPreviousCell' :'tabToNextCell']();
                        return;
                    }
    
                    if(!toNextRow || angular.isUndefined(toNextRow)) return;

                    if(evt.keyCode == _keymap.ENTER && $scope.enterAsTab){
                        $scope.gridOptions.api[evt.shiftKey ? 'tabToPreviousCell' :'tabToNextCell']();                        
                    }else if(!currentCell && focusedCell.column.colDef.editable){
                        startEdit(focusedCell.column.colId, focusedCell.rowIndex);
                        _self.lastEditingCell = focusedCell;
                    }else{
                        endEdit();
                        if(typeof $scope.fnSaveRowOnEnter === 'function'){
                            $scope.fnSaveRowOnEnter($scope.dataset, true,evt);
                        }else{
                            const isBack = (evt.keyCode == _keymap.ENTER && evt.shiftKey) || evt.keyCode == _keymap.ARROW_UP;
                            gotoNewNode((currentCell || focusedCell), isBack);
                        }
                        
                    }

                } else if (isArrowUpOrDown(evt) && !_programmaticallySelectingRecord && !_editorOpenned) {
                    _self.lastEditingCell = undefined;

                    var cellToFocus = $scope.gridOptions.api.getFocusedCell();

                    if (!cellToFocus && getDefaultFocusableCell()) {
                        setFocusOnCell(getDefaultFocusableCell().colId, 0);
                        cellToFocus = $scope.gridOptions.api.getFocusedCell();
                    }

                    if (cellToFocus) {
                        var newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(cellToFocus.rowIndex);
                        selectionWithArrowUpOrDown(newNode, evt);
                    }

                } else if (evt.keyCode == _keymap.PG_DOWN) {
                    if(!evt.shiftKey){
                        var indexLastNode = $scope.gridOptions.api.getLastDisplayedRow();
                        selectNodeByIndex(indexLastNode, true);
                        var indexOfDataset = $scope.dataset.getIndexByUniqueId(indexLastNode);
                        $scope.dataset.gotoRow(indexOfDataset);
                    } else {
                        let focusedNode = $scope.gridOptions.api.getDisplayedRowAtIndex($scope.dataset.getCurrentIndex());
                        let index = 0;
                        let toSelect = $scope.dataset.getRecordByUniqueId(focusedNode?.id);
                        let visibleRowsCount = getVisibleRowsCount();

                        while(index <= visibleRowsCount && angular.isDefined(toSelect)){
                            _recordsToSelectPgDown.push(toSelect);
                            focusedNode = $scope.gridOptions.api.getDisplayedRowAtIndex(angular.isDefined(focusedNode?.rowIndex) ? focusedNode.rowIndex + 1 : 1);

                            toSelect = $scope.dataset.getRecordByUniqueId(focusedNode?.id);
                            index = index + 1;
                        }  

                        $scope.dataset.setSelectedRecords(_recordsToSelectPgDown);
                        $scope.dataset.gotoRow(focusedNode?.rowIndex ? focusedNode.rowIndex : $scope.gridOptions.api.getDisplayedRowCount(), false);
                        syncSelectOnDataset();
                    }
                } else if (evt.keyCode == _keymap.PG_UP) {
                    var indexFirst = $scope.gridOptions.api.getFirstDisplayedRow();
                    selectNodeByIndex(indexFirst, true);
                    var indexOfDataset = $scope.dataset.getIndexByUniqueId(indexFirst);
                    $scope.dataset.gotoRow(indexOfDataset);
                } else if (_keymap.ESC == evt.keyCode) {
                    if ($scope.showMenuGrid) {
                        $scope.showMenuGrid = false;
                        AngularUtil.apply($scope);
                    }
                    endEdit();
                    setNextFocusCell(_self.lastFocusedCell.colId);
                    if (_editorOpenned) {
                        _colEditing = undefined;
                    }
                } else {
                    _colEditing = undefined;
                }
            }

            function selectionWithArrowUpOrDown(newNode, evt) {
                if (newNode) {
                    let setSelection = true;
                    let newNodeAux;
                    const isMultipleSelection = $scope.allowMultipleSelection != false ? true : false;
                    const value = evt.keyCode == _keymap.ARROW_DOWN ? 1 : -1;

                    // Verifica se o usuário está retornando pelas linhas já selecionadas
                    if (_selectNodes.length > 0 && evt.shiftKey) {
                        newNodeAux = $scope.gridOptions.api.getDisplayedRowAtIndex(newNode.rowIndex + value);
                        if (newNodeAux && newNodeAux.selected) {
                            _lastSelectedRowID = newNode.rowIndex + value;
                            setSelection = false;
                        }
                    }

                    if (setSelection) {
                        const lineIndex = getLineIndex(evt);
                        // Verifica se a próxima célula está com foco no momento que o listener for chamado
                        if (_selectNodes.length > 0 && _selectNodes[lineIndex].rowIndex == newNode.rowIndex) {
                            _lastSelectedRowID = newNode.rowIndex + value;
                            newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(_lastSelectedRowID);
                        } else if (_selectNodes.length > 1 && _selectNodes[lineIndex].rowIndex != newNode.rowIndex) {
                            setSelection = false;
                        } else {
                            _lastSelectedRowID = newNode.rowIndex;
                        }
                    }

                    if (newNode) {
                        // Ajuste realizado para o datagrid aceitar multipla seleção com as teclas shift e as setas do teclado pressionadas
                        if ((isMultipleSelection && evt.shiftKey && setSelection) || !evt.shiftKey) {
                            newNode.setSelected(true, isMultipleSelection ? !evt.shiftKey : true);
                            setNextFocusCell();
                        } else if (isMultipleSelection && evt.shiftKey) {
                            newNode.setSelected(false, isMultipleSelection ? !evt.shiftKey : true);
                            setNextFocusCell();
                            const rowId = newNode.id;
                            if ($scope.dataset.isSelected(rowId)) {
                                $scope.dataset.unselectRowByUniqueId(rowId, _ckbRowSelectionByNodeId[rowId] ? false : null);
                            }
                        }

                        const data = {
                            event: evt,
                            node: newNodeAux || newNode,
                            api: $scope.gridOptions.api
                        };
    
                        onRowClicked(data);
                    }
                }
            }

            function initializeDatagrid() {
                _disabledBodyDiv.classList.add('disabled-grid');
                _disabledHeaderDiv.classList.add('disabled-grid');
                
                setupColors();
                setViewModeToLoading();

                if(!$scope.gridOptions || !$scope.gridOptions.api){
                    addGridReadyListener(initializeDatagrid);
                    return;
                }

                if($element.css('height') == '0px'){
                    $element.css('height', '100%');
                }

                if(!$element.attr('id')){
                    $element.attr('id', 'datagrid-id-' + $scope.uniqueid);
                }

                $scope.dataset.addEventListener(DatasetEvents.REFRESH_CELLS, function () {
                    refreshCells();
                });	
                
                $scope.onDatagridInit({ datagrid: _self, dataset: $scope.dataset });

                _dataSource = {
                    rowCount: null,
                    getRows: function (params) {
                        var request = params.request;
                        var rowsThisPage = [];
                        var countRows = 0;
                        var rowStart = request.startRow;
                        var rowEnd = request.endRow;
                        //Função de ordenação utilizada para coluna de agrupamento
                        var sortFn;

                        function groupBy(data, field) {
                            var result = {};
                            data.forEach(function (item) {
                                var value = ObjectUtils.getProperty(item, field);
                                var key = getKey(field, value);
                                var listForThisKey = result[key];
                                if (!listForThisKey) {
                                    listForThisKey = [];
                                    result[key] = listForThisKey;
                                    _lengthByGroups[key] = 0;
                                }
                                listForThisKey.push(item);
                                _lengthByGroups[key]++;
                            });
                            return result;
                        };

                        function filterOutOtherGroups(originalData, groupKeys, rowGroupCols) {
                            var filteredData = originalData;

                            groupKeys.forEach(function (groupKey, index) {
                                var rowGroupCol = rowGroupCols[index];
                                var field = rowGroupCol.id;

                                filteredData = filter(filteredData, function (item) {
                                    var value = ObjectUtils.getProperty(item, field);
                                    if (groupKey == i18n('DataGrid.empty') || groupKey == 0) {
                                        return value === undefined || value === '' || value == 0;
                                    }
                                    return value == groupKey;
                                });

                                _lengthByGroups[groupKey] = filteredData.length;

                            });

                            return filteredData;
                        };

                        function filter(data, callback) {
                            var result = [];
                            data.forEach(function (item) {
                                if (callback(item)) {
                                    result.push(item);
                                }
                            });
                            return result;
                        };

                        function iterateObject(object, callback) {
                            if (!object) {
                                return;
                            }
                            let keys = Object.keys(object);
                            for (let i = 0; i < keys.length; i++) {
                                let key = keys[i];
                                let value = object[key];
                                callback(key, value);
                            }
                        };

                        function buildGroupsFromData(rowData, rowGroupCols, groupKeys, valueCols) {
                            var rowGroupCol = rowGroupCols[groupKeys.length];
                            var field = rowGroupCol.id;
                            var mappedRowData = groupBy(rowData, field);
                            var groups = [];

                            iterateObject(mappedRowData, function (key, rowData) {
                                var groupItem = getAgregateList(rowData, valueCols);
                                ObjectUtils.setProperty(groupItem, field, getKey(field, key));
                                groupItem['countChield'] = rowData.length;
                                groups.push(groupItem);
                            });

                            return groups;
                        };

                        //Grade em arvore
                        if($scope.isTreeData){
                            if(!allDataInCache || allDataInCache.length != $scope.dataset.size() ) {
                                allDataInCache = $scope.dataset.getRecordsObjectPaged(0, $scope.dataset.size());
                            }

                            let keyFilter = request.groupKeys.length == 0 ? 0 : request.groupKeys[request.groupKeys.length - 1];

                            allDataInCache.forEach( record => {
                                if(record[$scope.parentProperty] == keyFilter){
                                    rowsThisPage.push(record);
                                }
                            });

                            countRows = rowsThisPage.length;
                        }else if (request.rowGroupCols.length > 0) {
                            _pivotMode = true;
                            var colOrdened = $scope.gridOptions.api.sortController.getColumnsWithSortingOrdered();
                            var direction;
                            _self.fieldGroup = request.rowGroupCols[0].id;

                            if (!allDataInCache) {
                                allDataInCache = $scope.dataset.getRecordsObjectPaged(0, $scope.dataset.size());
                            }

                            var showingGroupLevel = request.rowGroupCols.length > request.groupKeys.length;
                            var dataFiltered = filterOutOtherGroups(allDataInCache, request.groupKeys, request.rowGroupCols);

                            if (showingGroupLevel) {
                                rowsThisPage = buildGroupsFromData(dataFiltered, request.rowGroupCols, request.groupKeys, request.valueCols);                                
                            } else {
                                rowsThisPage = dataFiltered;
                            }
                            
                            var aggOrdened = [];

                            colOrdened.forEach(function (col, index) {                                
                                if (isGroupCol(col)) {
                                    direction = col.sort;
                                    sortFn = getSortFn(col);                                    
                                }else{
                                    if (col.aggFunc != undefined){
                                        //aggOrdened.push( { sortFn : getSortFn(col), id : col.colId});
                                        aggOrdened.push(col);
                                    }
                                }
                            })

                            if (angular.isFunction(sortFn) && request.rowGroupCols.length > 0) {
                                rowsThisPage = ArrayUtils.sortByProperty(rowsThisPage, request.rowGroupCols[0].id, sortFn);
                                if (direction == 'desc') {
                                    rowsThisPage.reverse();
                                }
                            }

                            if (angular.isArray(aggOrdened) && request.rowGroupCols.length > 0) {

                                var rowSortFn = function (a, b) {
                                    var idx = 0,
                                        sortFn;
                                    var sortCols = aggOrdened;
                
                                    while (idx < sortCols.length) {
                                        var result;
                                        col = sortCols[idx];
                                        var field;
                
                                        if (isGroupCol(col)) {
                                            field = _columnsGrouped[0];
                                        } else {
                                            field = col.colDef.field;
                                        }
                
                                        sortFn = getSortFn(col);
                                        var valueA = a[col.colId];
                                        var valueB = b[col.colId];
                
                                        result = sortFn(valueA, valueB);
                
                                        idx++;
                
                                        if (result == 0) {
                                            continue;
                                        }
                
                                        return result == 0 ? result : col.sort == 'asc' ? result : result * -1;
                                    }
                                };

                                rowsThisPage.sort(rowSortFn);                                
                            }

                            countRows = rowsThisPage.length == 0 ? 1 : rowsThisPage.length;
                            rowsThisPage = rowsThisPage.slice(rowStart, rowEnd);
                        } else {
                            countRows = 0;
                            _pivotMode = false;
                            rowsThisPage = $scope.dataset.getRecordsObjectPaged(rowStart, rowEnd);
                            if($scope.dataset.size() == 0){
                                if(!_dsSuccessCallBackPending) {
                                    _dsSuccessCallBack = params.successCallback;
                                }
                            }else{
                                clearDsSuccessCallback();
                                countRows = $scope.dataset.size();
                            }

                            if($scope.dataset && ($scope.enableInsertion || $scope.dataset.isEnableInsertionModeGrid()) && $scope.dataset.isInsertionMode()){
                                let transientRecord = $scope.dataset.getRecordAsObject($scope.dataset.getSelectedRecords(true)[0]);
                                if (angular.isDefined(transientRecord)) {
                                    transientRecord['rowID'] = -1;
                                    rowsThisPage.push(transientRecord);
                                } else {
                                    $scope.dataset.cancelEdition();
                                }
                                countRows++;
                                
                                let showDoubleView = undefined;
                                try {
                                    showDoubleView = $scope.datagridInterceptor.getShowDoubleView();
                                } catch (e) {
                                    showDoubleView = false;
                                }
                                if(!showDoubleView){ 
                                    $timeout( () => positionOnInsertItem());
                                }

                            }
                        }
                        
                        let showDoubleView = undefined;
						try {
						   showDoubleView = $scope.datagridInterceptor.getShowDoubleView();
						}
						catch (e) {
						   showDoubleView = false;
						}
						
						if (showDoubleView){
							 params.successCallback(rowsThisPage, countRows);
						} else{
							$timeout(function () {
	                            params.successCallback(rowsThisPage, countRows);
	                        }, 0, false);							
						}
                    }
                };

                _removeDsObservers.push($scope.dataset.addObserver(_self));

                var fieldMds = ArrayUtils.copy($scope.dataset.getFieldsMetadata(), true);
                var originalIndex;

                var filteredColumns = ArrayUtils.toArray($scope.strFilteredColumns);
                var filteredColumnsByName = {};

                if (filteredColumns && filteredColumns.length > 0) {
                    fieldMds.forEach(function (fieldMD) {
                        if (ArrayUtils.isIn(filteredColumns, fieldMD.name)) {
                            filteredColumnsByName[fieldMD.name] = true;
                            fieldMD.skVisible = false;
                        }
                    });
                }

                if ($scope.datagridInterceptor) {
                    var wasSorted = $scope.datagridInterceptor.sortMetadata(fieldMds, $scope.dataset) != 'unordered';

                    if (wasSorted) {
                        originalIndex = {};

                        $scope.dataset.getFieldsMetadata().forEach(function (fieldMD, index) {
                            originalIndex[fieldMD.name] = index;
                        });
                    }

                    fieldMds.forEach(function (fieldMD) {
                        if (!filteredColumnsByName[fieldMD.name] && !$scope.datagridInterceptor.acceptColumnField(fieldMD, $scope.dataset)) {
                            fieldMD.skVisible = false;
                        }
                    });
                }

                var foreignKeyFields = {};
                var masterDescriptionFields = [];
                var descriptionFieldsByFieldsMetaData = [];
                $scope.columnDefs = [];

                if ($scope.hideCbxColumn == false) {
                    $scope.columnDefs.push({
                        headerName: '',
                        field: '-100000',
                        skName: '-100000',
                        transient: true,
                        width: 45,
                        cellClass:'sk-cell-checkbox',
                        pinned: 'left',
                        sortable: false,
                        suppressMenu: true,
                        resizable: false,
                        suppressMovable: true,
                        cellRenderer: 'skCbxSelectionCellRenderer',
                        headerComponent: 'skHeaderCbxRowSelection',
                        lockPosition: true
                    });
                }

                if ($scope.enableDrag == true) {
                    $scope.columnDefs.push({
                        headerName: '',
                        field: '-1000001',
                        skName: '-1000001',
                        transient: true,
                        width: 30,
                        pinned: 'left',
                        sortable: false,
                        suppressMenu: true,
                        resizable: false,
                        suppressMovable: true,
                        cellRenderer: 'skDraggableRenderer',
                        //headerComponent: 'skHeaderCbxRowSelection',
                        lockPosition: true
                    });
                }
                //Metadata definition
                fieldMds.forEach(function (fieldMD, index) {
                    if (originalIndex) {
                        index = originalIndex[fieldMD.name];
                    }

                    if (_onlyCustomColumns) {
                        fieldMD.skVisible = angular.isDefined(_customColumnsMD[fieldMD.name]);
                    }

                    if ($scope.datagridInterceptor && angular.isFunction($scope.datagridInterceptor.interceptColumnMetadata)) {
                        $scope.datagridInterceptor.interceptColumnMetadata(fieldMD, $scope.dataset);
                    }

                    if (foreignKeyFields.hasOwnProperty(fieldMD.name) && fieldMD.fk) {
                        masterDescriptionFields[fieldMD.fk.descriptionFieldName] = undefined;
                        _originalColumnDefs.push(fieldMD);
                        return;
                    }

                    if (masterDescriptionFields.hasOwnProperty(fieldMD.name)) {
                        _originalColumnDefs.push(fieldMD);
                        return;
                    }

                    //forma de controlar os campos de descrição para que os mesmos não sejam duplicados
                    if (fieldMD.hasOwnProperty("isDescriptionField")) {
                        if (!descriptionFieldsByFieldsMetaData.includes(fieldMD.name)) {
                            descriptionFieldsByFieldsMetaData.push(fieldMD.name);
                        } else {
                            return;
                        }
                    }

                    if (fieldMD.fk) {
                        if (!_descriptionFieldNames.hasOwnProperty(fieldMD.fk.descriptionFieldName)) {
                            _descriptionFieldNames[fieldMD.fk.descriptionFieldName] = {originalFieldFk: fieldMD};
                        }
                    }

                    if (fieldMD.width === '*') {
                        completedSizeDefined = true;
                    }

                    var customColumnMD = _customColumnsMD[fieldMD.name];

                    var isVisible = isFieldMDVisible(fieldMD);

                    var precision = fieldMD.precision;

                    if (fieldMD.userType == 'F' && !precision && precision != 0) {
                        precision = DEFAULT_DECIMAL_PRECISION;
                    }

                    if (fieldMD.userType == 'I' && !precision && precision != 0) {
                        precision = 0;
                    }

                    var liveCheck = false;

                    if (customColumnMD && fieldMD.checkbox && customColumnMD.liveCheck) {
                        liveCheck = true;
                    }

                    var isDatagridEditable = !$scope.isMobile && $scope.editable;

                    var isColumnEditable = isFieldMDEditable(fieldMD) && !liveCheck;

                    var columnDescription;

                    if (customColumnMD && customColumnMD.description) {
                        columnDescription = customColumnMD.description;
                    } else {
                        columnDescription = fieldMD.description;
                    }

                    for (var i = 0, length = $scope.dataset.getForeignKeyFields().length; i < length; i++) {
                        foreignKeyFields[$scope.dataset.getForeignKeyFields()[i].localField] = undefined;
                    }

                    var cellType = liveCheck ? 'C' : 'P';

                    /*
                        Se a coluna eh a key, ignoramos ela e fazemos a coluna de agrupamento 
                        ficar com as propriedades da coluna definida como key.
                     */
                    if($scope.keyProperty && $scope.parentProperty && fieldMD.name == $scope.keyProperty){
                        $scope.gridOptions.autoGroupColumnDef.headerName = columnDescription;
                        $scope.gridOptions.autoGroupColumnDef.suppressSorting = true;
                        $scope.gridOptions.autoGroupColumnDef.suppressMenu = true;
                        $scope.gridOptions.autoGroupColumnDef.cellRendererParams = {
                            innerRenderer: function(params){
                                if (_customColumnsMD[fieldMD.name] && _customColumnsMD[fieldMD.name].cellFormatter && angular.isDefined(params.value)) {
                                    return _customColumnsMD[fieldMD.name].cellFormatter(params.value, params.column, params.data);
                                 }else{
                                    return params.valueFormatted ? params.valueFormatted : (params.value != undefined ? params.value : '');
                                 }
                            }
                        }

                        $scope.gridOptions.autoGroupColumnDef.headerComponentParams = {
                            template: getCellHeaderTpl("TREE")                                
                        }

                        return;
                    }

                    if(_customColumnsMD[fieldMD.name] && _customColumnsMD[fieldMD.name].width){
                        fieldMD.width = _customColumnsMD[fieldMD.name].width;
                    }

                    var column = {
                        skName: fieldMD.name,
                        skOrder: fieldMD.order,
                        skOptions: fieldMD.options,
                        skFieldMdIndex: index,
                        skVisible: isVisible,
                        skVisivelPadrao: StringUtils.toBoolean(getProperties(fieldMD, 'visivelPadrao', 'S')),
                        skPassword: fieldMD.fieldProp ? fieldMD.fieldProp['sk-password'] : false,
                        skAggregateExpression: fieldMD.aggregateExpression,
                        headerName: columnDescription,
                        skDescription: columnDescription,
                        field: String(fieldMD.name),
                        editable: isColumnEditable,
                        width: (fieldMD.width || getColumnWidth(fieldMD.description)),
                        minWidth: 20,
                        hide: $scope.gridconfig ? true : !isVisible,
                        cellEditor: 'skCellEditor',
                        suppressSorting: fieldMD.enableSorting != undefined ? !fieldMD.enableSorting : false,
                        size: fieldMD.size,
                        isCheckbox: fieldMD.checkbox,
                        userType: fieldMD.fk ? 'ENTITY' : fieldMD.userType,
                        dataType: fieldMD.dataType,
                        presentationType: fieldMD.presentationType,
                        fk: fieldMD.fk,
                        skPrecision: precision,
                        skPrettyPrecision: fieldMD.prettyPrecision || precision,
                        skAllowNull: fieldMD.isNullable,
                        menuTabs: ['generalMenuTab'],
                        skFieldType: fieldMD.userType,
                        buildOptionsFn: fieldMD.buildOptionsFn,
                        lockVisible: !isVisible,
                        enableValue: isVisible,
                        enableRowGroup: isVisible,
                        cellRenderer: 'skCellRenderer',
                        transient: fieldMD.transient,
                        suppressMenu: $scope.isTreeData ? true : (fieldMD.enableColumnMenu != undefined ? !fieldMD.enableColumnMenu : false),
                        editorCachable: fieldMD.editorCachable != undefined ? fieldMD.editorCachable : true,
                        suppressKeyboardEvent: function (params) {
                            if (_ignoreKeysOnEdit.indexOf(params.event.keyCode) > -1 && params.editing) {
                                return true;
                            }
                            if(params.event.keyCode == _keymap.END || params.event.keyCode == _keymap.HOME || params.event.keyCode == _keymap.SPACE){
                                return true;
                            }
                            if(_lockEventListeners){                             
                                return true;
                            }
                            return false;
                        },
                        setEnabled: function (value) {
                            column.enableCellEdit = isDatagridEditable && value;
                            if ($scope.gridOptions && $scope.gridOptions.api) {
                            	$scope.gridOptions.api.getColumnDef(fieldMD.name).editable = value;
                            } else {
                            	addGridReadyListener(function () {
                            		$scope.gridOptions.api.getColumnDef(fieldMD.name).editable = value;
                            	});
                            }
                        },
                        setVisible: function (value) {
                            column.skVisible = value;
                            $scope.gridOptions.columnApi.setColumnVisible(column.field, value);
                        },
                        setDescription: function (value) {
                            column.headerName = value;
                            column.displayName = value;
                            $scope.gridOptions.api.getColumnDef(fieldMD.name).headerName = value;
                            $scope.gridOptions.api.refreshHeader();
                            //Atualizando label nas configs
                            GridConfig.changeColumLabel($scope.gridconfig, fieldMD.name, value);
                        },
                        pinnedRowCellRenderer: 'skPinnedRowRenderer',
                        cellClass: function (params) {
                            return (($scope.compactMode ? '' : 'sk-cell-confortable-mode') + getPersonalizedCollorsClass(params));
                        },
                        enableValue: typesAcceptAgregateFunction.indexOf(fieldMD.dataType) > -1,
                        headerComponentParams: {
                            template: getCellHeaderTpl(fieldMD.dataType)                                
                        },
                        floatingFilterComponent: 'skFloatingFilter',
                        floatingFilterComponentParams: {
                            suppressFilterButton: true,
                            color: 'blue'
                        },
                        chartDataType: typesAcceptAgregateFunction.indexOf(fieldMD.dataType) > -1 ? 'series' : 'category',
                    };

                    if($scope.showDataTips == 'true'){
                        column.tooltipField = "TOOLTIP";
                    }
                    
                    if (typeof SkDashboardCellRenderer !== "undefined") {
                    	var optionsDashboard = { 
	                        DateUtils: DateUtils,
	                        NumberUtils: NumberUtils,
	                        uidCellFormatter: $scope.uidCellFormatter
	                     }

                    	column.useFooter = fieldMD.useFooter == true ? "S" : "N"; 
                    	
                    	column.suppressPaste = true;
                    	column.cellRenderer = 'skDashboardCellRenderer';
                    	column.cellRendererParams = optionsDashboard;
                    	column.pinnedRowCellRenderer = 'skDashboardPinnedRowCellRenderer';
                    	column.pinnedRowCellRendererParams = optionsDashboard;
                    }

                    if (column.enableValue) {
                        column.allowedAggFuncs = ['sum', 'min', 'max', 'avg', 'count', 'first', 'last'];
                    }

                    var userType = FormService.getUserType(fieldMD);
                    var dataType = fieldMD.dataType;
                    if (column.skPassword === true) {
                        column.skType = 'text';
                        column.valueFormatter = function (params) {
                            var mask = "";
                            if(!StringUtils.isEmpty(params.value)){
                                mask = '********************';
                            }
                            return mask;
                        };
                    } else if (dataType === 'L' || dataType === 'LP') {
                        // Farol dos Dashboards
                        column.cellStyle = getCellStyle({ userType, dataType });
                        column.cellTextAlignment = 'center';
                        column.skType = 'text';
                        column.valueFormatter = function (params) {
                        	if (fieldMD.customCellFormatter && angular.isDefined(params.value)) {
                            	// Houve a necessidade de verificar se a recuperação dessa informação vinha do filtro. 
                              	// Isso porque é necessário apenas passar a cor selecionada do farol para visualização do filtro.
                              	if(angular.isDefined(params.isFilter) && params.isFilter){
                                	column.isFilter = true;
                             	}
                             	return fieldMD.customCellFormatter(params.value, column, params.data);
                            }

                            if (params.node && !params.node.rowPinned) {
                                var _size = dataType === 'LP' ? 15 : 20;
                                var _margin = 'margin: ' + (dataType === 'LP' ? 5 : 3) + 'px auto';
                                var _color = params.value || '#c3c3c3';
                                
                                return '<svg width="'+ _size +'" height="'+ _size +'" style="' + _margin + '"><circle cx="50%" cy="50%" r="50%" fill="' + _color + '" /></svg>';
                            }
                        };
                    } else if (dataType === 'PB') {
                        // Renderiza um progress-bar na célula do grid
                        column.cellStyle = getCellStyle({ userType, dataType });
                        column.cellTextAlignment = 'left';
                        column.skType = 'number';
                        column.valueFormatter = function (params) {
                            var _colorBack = '#A0A0A0';
                            var _colorProgress = '#008000';
                            var _colorText = '#FFFFFF';
                            var _size = params.value || 0;

                            var progressBar =  '<svg width="100%" height="20" style="margin: 3px auto">';
                            progressBar += '        <rect width="100%" height="20" fill="'+_colorBack+'"/>';
                            progressBar += '        <rect width="'+ _size + '%" height="20" fill="'+_colorProgress+'"/>';
                            progressBar += '        <text x="45%" y="15" fill="'+_colorText+'">'+ _size + '%' + '</text>';
                            progressBar += '    </svg>';

                            return progressBar;
                        };
                    } else if (dataType === 'D' || dataType === 'H' || dataType == 'T') {
                        column.cellStyle = getCellStyle({ userType, dataType });
                        column.cellTextAlignment = 'center';
                        if (dataType === 'D') {
                            column.skType = 'date';
                        } else if (dataType === 'H') {
                            column.skType = 'datetime';
                        } else {
                            column.skType = 'time';
                        }

                        if (dataType == 'T') {
                            column.valueFormatter = function (params) {
                            	if (fieldMD.customCellFormatter && angular.isDefined(params.value)) {
                                 	return fieldMD.customCellFormatter(params.value, column, params.data);
                              	}
                              	
                                if (params.value) {
                                	if (angular.isDefined(fieldMD.unlimitedHour) && fieldMD.unlimitedHour) {
                                        return DateUtils.getTimeUnlimitedHourFormatter(params.value);
                                    }
                                    return DateUtils.getTimeExtraFormatter(params.value);
                                } else {
                                    return params.value;
                                }
                            };
                        } else {
                            column.valueFormatter = function (params) {
                                if (fieldMD.customCellFormatter && angular.isDefined(params.value)) {
                                    return fieldMD.customCellFormatter(params.value, column, params.data);
                                }

                                if (DateUtils.isValidDate(params.value)) {
                                    var format;

                                    if (dataType === 'D' || params.forceDate) {
                                        format = DateUtilsConstants.DEFAULT_DATE_FORMAT;
                                    } else {
                                        if (!fieldMD.fieldProp || (fieldMD.fieldProp && (!fieldMD.fieldProp.hasOwnProperty('includeSeconds') || fieldMD.fieldProp.includeSeconds === false))) {
                                            format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS;
                                            column.includeSeconds = false;
                                        } else {
                                            format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT;
                                        }
                                    }

                                    return DateUtils.formatDate(params.value, format);
                                }

                                return params.value;
                            };
                        }
                    } else if (dataType == 'I' || dataType == 'F' || dataType == 'CUR' ) {
                        column.cellStyle = getCellStyle({ userType, dataType });
                        column.cellTextAlignment = 'right';
                        column.skType = 'number';
                        //column.headerName = '<span style="flex: 100; text-align: right;">' + column.headerName + '</span>';

                        if (fieldHasOptions(fieldMD)) {
						   column.valueFormatter = optionsCellFormatter;
                        } else {
                           column.valueFormatter = function (params) {
                              if (fieldMD.customCellFormatter && angular.isDefined(params.data)) {
                                var valueAux = '';
                                /* Exportação dos dados sem mascara para o cubo e planilha */
                                if (angular.isDefined(params.column) && angular.isDefined(params.column.isExportingFromDashboard) && params.column.isExportingFromDashboard) {
                                    valueAux = fieldMD.customCellFormatter(params.value, params.column, params.data);
                                } else {
                                    valueAux = fieldMD.customCellFormatter(params.value, column, params.data);
                                }
                                return angular.isDefined(valueAux) ? valueAux : angular.isDefined(params.value) ? params.value : '';
                              }

                              if (angular.isUndefined(params.value)){
                                let valueParams = '';
                                
                                // Verifica se array das colunas mapeadas para o totalizador existe elementos
                                if (!ObjectUtils.isEmpty(params.data)) {
                                    // Varrer array para adicionar valor do totalizador
                                    ObjectUtils.forEachInObject(params.data, function(key, value) {
                                        if (key === params.colDef.field) {
                                            valueParams = NumberUtils.format(value, DEFAULT_DECIMAL_PRECISION);
                                            return false;
                                        }
                                    });
                                }
                                
                                return valueParams;
                              }
                              
                              if (userType == 'F') {
                                let metaDatakey = $scope.dataset.getRowMetadataProperty(fieldMD.name, "rm_precision");
                                if (metaDatakey != undefined) {
                                    precision = $scope.dataset.getRowMetadata($scope.dataset.getRecordByUniqueId(params.data.rowID), metaDatakey);
                                }
                              }

                              if (userType == 'F' && precision >= 0) {
                                 return NumberUtils.format(params.value, precision);
                              } else if (userType == 'CUR') {
                                 return NumberUtils.format(params.value, 2);
                              } else {
                                 return params.value;
                              }
                           }
                        }
                    } else if (userType == 'ENTITY') {
                        if (dataType == 'I' || dataType == 'F') {
                            column.cellStyle = getCellStyle({ userType, dataType });
                            column.cellTextAlignment = 'right';
                            column.skType = 'number';
                            //column.headerName = '<span style="flex: 100; text-align: right;">' + column.headerName + '</span>';
                        }
                        else {
                            column.cellStyle = getCellStyle({ userType, dataType });
                            column.cellTextAlignment = 'left';
                            column.skType = 'text';
                        }
                    } else {
                        column.cellStyle = getCellStyle({ userType, dataType });
                        column.cellTextAlignment = 'left';
                        column.skType = 'text';

                        if (fieldHasOptions(fieldMD)) {
                            column.valueFormatter = optionsCellFormatter;
                        } else if (userType == 'Phone') {
                            column.valueFormatter = function (params) {
                                if (params.value) {
                                    return StringUtils.toPhone(params.value);
                                }
                            };
                        } else if (userType == 'CGC_CPF') {
                            column.valueFormatter = function (params) {
                                if (params.value) {
                                    return StringUtils.formatCgcCpf(params.value);
                                }
                            };
                        } else if ((userType == 'C' && column.presentationType != 'H') || fieldMD.size > 100) {
                            column.cellType = 'TA';
                        } else {
                            column.valueFormatter = function (params) {
                                if (fieldMD.customCellFormatter && angular.isDefined(params.data)) {
                                    return fieldMD.customCellFormatter(params.value, column, params.data);
                                }
                                if (angular.isUndefined(params.value)) {
                                    return '';
                                }
                                return params.value;
                            };
                        }
                    }

                    if ($scope.datagridInterceptor) {
                        var innerStyle = column.cellStyle;
                        column.cellStyle = function(params){
                            if (params.node.id == undefined) {
                                return;
                            }
                            var cellColors;
                            try{
                                cellColors = $scope.datagridInterceptor.getCellColors({entity : $scope.dataset.getRecordByUniqueId(params.node.id)}, params.colDef, params.rowIndex, params.colDef.skOrder, params.api, {dataset: $scope.dataset});
                            }catch(e){
                                console.warn('Erro no interceptor getCellColors.', e);
                            }                            
                            var newStyle = {};
                            if(angular.isObject(innerStyle)){
                                Object.keys(innerStyle).forEach(function(key){
                                    newStyle[key] = innerStyle[key];
                                });
                            }
                            
                            if (angular.isObject(cellColors)) {
                                if (cellColors.textColor) {
                                    if (!ThemeColors.isValidColor(cellColors.textColor)) {
                                        newStyle['color'] = cellColors.textColor;
                                    }
                                }
                                if (cellColors.bgColor) {
                                    if (!ThemeColors.isValidColor(cellColors.bgColor)) {
                                        newStyle['backgroundColor'] = cellColors.bgColor;
                                    }
                                }
                            } else if (angular.isDefined(cellColors)) {
                                if (!ThemeColors.isValidColor(cellColors)) {
                                    newStyle['color'] = cellColors;
                                }
                            }

                            return newStyle;
                        }
                    }
          
                    if (customColumnMD && customColumnMD.cellFormatter) {                        
                        column.cellRenderer = function (params) {
                            if (!params.data) {
                                return '';
                            }
                            var row = $scope.dataset.getRecordByUniqueId(params.data.rowID);
                            var record = angular.isObject(row) && row.hasOwnProperty('entity') ? row.entity : row;
                            if (!row || !record) {
                                return '';
                            } else {
                                var fieldIndexDs = $scope.dataset.getFieldIndexByName(column.field);
                                var value = record[fieldIndexDs];
                                var formatter = customColumnMD.cellFormatter(params.column, value, record);
                                if(formatter && formatter.hasOwnProperty('$$unwrapTrustedValue')){
                                    return formatter.$$unwrapTrustedValue()
                                }else{
                                    return formatter;
                                }
                            }                            
                        };                                             
                    }

                    //textAlign - datagridCustomColumn
                    if(customColumnMD && customColumnMD.textAlign){
                        column.cellStyle = { 'text-align': customColumnMD.textAlign};
                        column.cellTextAlignment = customColumnMD.textAlign;
                        column.headerComponentParams = {
                            template: getCellHeaderTpl(customColumnMD.textAlign)
                        }
                    }

                    //livecheckbox
                    if (customColumnMD && fieldMD.checkbox && customColumnMD.liveCheck) {
                        column.cellRenderer = function (params) {
                            let dsItem = $scope.dataset.getRecordByUniqueId(params.node.id);
                            let personalizedItem;

                            if($scope.datagridInterceptor){
                                personalizedItem = $scope.datagridInterceptor.interceptCellRenderer(params.column, params.getValue(), params.eGridCell, {datasetItem: dsItem, gridItem: params.data});
                            }

                            if(personalizedItem){
                                let eGui = document.createElement("span");
                                eGui.style.display = 'flex';
                                eGui.style.alignItems = 'center';
                                eGui.style.height = '100%';
                                eGui.style.justifyContent = personalizedItem.align;
                                
                                personalizedItem.element.style.lineHeight = '0px'

                                eGui.appendChild(personalizedItem.element);

                                return eGui;
                            }else{
                                if(!params.data){
                                    return '';
                                }
                                var elem = getLiveCheckBoxElement(params.value, params.colDef.field, params.node);
                                return elem;
                            }                 
                        };               
                    }

                    // Criar atributo title para campo texto quando nao foi definido cellRenderer
                    if (!angular.isFunction(column.cellRenderer) && ('S' === dataType || 'C' === dataType)) {
                        column.cellRenderer = function (params) {
                            let dsItem = $scope.dataset.getRecordByUniqueId(params.node.id);
                            let eGui;
                            let personalizedItem;
                            if ($scope.datagridInterceptor) {
                                personalizedItem = $scope.datagridInterceptor.interceptCellRenderer(params.column, params.getValue(), params.eGridCell, { datasetItem: dsItem, gridItem: params.data });
                            }

                            if (personalizedItem) {
                                eGui = personalizedItem.element;
                            } else {
                                eGui = document.createElement("span");
                                eGui.style.display = 'flex';
                                eGui.style.alignItems = 'center';
                                eGui.style.height = '100%';

                                let _value = '';
                                if (StringUtils.isNotEmpty(params.valueFormatted)) {
                                    _value = params.valueFormatted;
                                } else if (StringUtils.isNotEmpty(params.value)) {
                                    _value = params.value;
                                }

                                if (_value.length > 50) {
                                    eGui.setAttribute("title", _value);
                                }
                                
                                if (column.presentationType === 'H' || StringUtils.containsHtml(_value)) {
                                    eGui.innerHTML = angular.isString(_value) ? StringUtils.toHtmlText(_value) : _value;
                                } else {
                                    eGui.appendChild(document.createTextNode(_value));
                                }
                            }

                            return eGui;
                        };
                    }

                    $scope.columnDefs.push(column);
                    _originalColumnDefs.push(column);
                    _columnDefsByName[column.field] = column;

                    for (var i = 0; i < $scope.columnDefs.length; i++) {
                        var column = $scope.columnDefs[i];
                        if (_descriptionFieldNames.hasOwnProperty(column.field)) {
                            column.editable = false;
                        }
                    }

                    //Definição das opções de agregação no rodapé da grade
                    if (fieldMD.properties) {
                        var classAdded = false;
                        for (var i = 0; i < fieldMD.properties.length; i++) {
                            var propertie = fieldMD.properties[i];
                            if (propertie.name === 'gridFooterOper') {
                                _footerColsAggretaion.push({field: fieldMD.name, functionAgg: propertie.value});
                            }
                        }
                    }

                    //Filtro de formulário
                    if (fieldMD.fieldProp && fieldMD.fieldProp['sk-form-criteria']) {
                        column.formCriteria = fieldMD.fieldProp['sk-form-criteria'];
                    } else if (angular.isDefined(fieldMD.fk) && angular.isDefined(fieldMD.fk.formCriteria)) {
                        column.formCriteria = ObjectUtils.getProperty(fieldMD.fk, 'formCriteria');
                    }

                    //User cellRenderer (esse renderer deve sobrescrever qualquer outro definido anteriormente)
                    if(_customCellRendererByColumn[fieldMD.name] || _customCellRendererByColumn[ALL_COLS]){
                        column.cellRenderer = 'userCellRenderer'
                    }
                });

                /*
                Bug no aggrid, ao executar o setColumnDefs com a mesma configuracao que ja esta setada,
                o aggrid não renderiza as colunas novamente.
                */
                $scope.gridOptions.api.setColumnDefs([]);

                /**
                 * Implementação da opção de agrupar as colunas.
                 */
                if($scope.groupColumns){

                    $scope.groupColumnsByUser = [];

                    if(angular.isObject($scope.groupColumns)){
                        $scope.groupColumns = [$scope.groupColumns];
                    }

                    if(angular.isArray($scope.groupColumns)){

                        for(var index = 0; index<$scope.groupColumns[0].length; index++){

                            var group = $scope.groupColumns[0][index];

                            var groupColumns = {
                                headerName: group.headerName, 
                                field: '-1000003',
                                skName: '-1000003',
                                headerClass: 'text-align-center',
                                transient: true,
                                sortable: false,
                                suppressMenu: true,
                                resizable: false,
                                suppressMovable: true,
                                lockPosition: true,
                                children: []
                            }

                            if(typeof group.childrens === 'string'){
                                group.childrens = group.childrens.split(',');
                            }

                            for(var children = 0; children < group.childrens.length; children++){
                                for(var columnDef = 0; columnDef < $scope.columnDefs.length; columnDef++){
                                    if($scope.columnDefs[columnDef].skName === group.childrens[children]){
                                        groupColumns.children.push($scope.columnDefs[columnDef]);
                                        $scope.columnDefs.splice(columnDef, 1);
                                    }
                                }
                            }

                            $scope.groupColumnsByUser.push(groupColumns);

                        }
                    }
                }

                if($scope.groupColumnsByUser && $scope.groupColumnsByUser.lenght != 0){
                    $scope.columnDefs = $scope.columnDefs.concat($scope.groupColumnsByUser);
                } 

                if($attrs.hasOwnProperty('skOrderColumms')){
                    $scope.columnDefs = $scope.columnDefs.sort( function(colA, colB){ 
                        return $scope.fnOrderColumns(colA, colB);
                    });
                }
                
                $scope.gridOptions.api.setColumnDefs($scope.columnDefs);
                
                $timeout(function () {
                    //Inicializando listeners
                    _gridElem.removeEventListener('keydown', onGridKeyDown);
                    _gridElem.addEventListener('keydown', onGridKeyDown);

                    //Listeners para home e end
                    _gridElem.removeEventListener('keydown', onGridKeyDownUseCapture);
                    _gridElem.addEventListener('keydown', onGridKeyDownUseCapture, true);

                    _gridElem.removeEventListener('keyup', onGridKeyUp);
                    _gridElem.addEventListener('keyup', onGridKeyUp);

                    //Criação do menu da grid  
                    $scope.menuIte = [
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-menu-item-search" layout layout-align="left center">'
                                + ' <sk-icon font-icon="binoculars"></sk-icon>'
                                + ' <sk-typeahead-input ng-click="action($event, title)" sk-get-options="loadSuggestions" sk-is-loading="searching"'
                                + ' sk-key="key" sk-label="label" sk-on-select="onSelectEntity" sk-show-more="false"'
                                + ' sk-append-to-body="true"'
                                + ' sk-placeholder="' + i18n('DataGrid.encontrarColuna') + '"'
                                + ' sk-min-length="0"'
                                + ' sk-load-on-focus="false"'
                                + ' sk-i18n'
                                + ' class="datagrid-menu-typeahead">'
                                + ' </sk-typeahead-input>'
                                + ' </div>',
                            skGridMenuID: 'findColumn',
                            context: $scope,
                            order: 0,
                            shown: function () {
                                return true;
                            },
                            action: function ($event) {
                                $event.stopPropagation();
                            }
                        }
                    ].concat(($scope.disableSearch === true) ? [] : [
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-search-menu-item" layout layout-align="left center" tooltip="Habilita a pesquisa por coluna" tooltip-placement="left">'
                                + ' <sk-icon font-icon="search"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.pesquisar') + '</div>',
                            skGridMenuID: 'search',
                            order: 1,
                            shown: function () {
                                return !$scope.gridOptions.floatingFilter;
                            },
                            action: function ($event) {
                                enableSearch();
                            }
                        },
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-search-menu-item" layout layout-align="left center" tooltip="Desabilita a pesquisa por coluna" tooltip-placement="left">'
                                + ' <sk-icon font-icon="delete"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.limparPesquisa') + '</div>',
                            skGridMenuID: 'clearAllSearch',
                            order: 1,
                            context: $scope,
                            action: function ($event) {
                                clearSearchOfCols();
                            },
                            shown: function () {
                                return $scope.gridOptions.floatingFilter;
                            }
                        }
                    ]).concat([
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-selectall-menu-item" layout layout-align="left center" tooltip="Seleciona todos os registros da grade (Ctrl+A)" tooltip-placement="left">'
                                + ' <sk-icon font-icon="check" style="bottom: 0px;"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.selecionarTodos') + '</div>',
                            skGridMenuID: 'selectAll',
                            order: 4,
                            shown: function () {
                                return !_selectAll && $scope.allowMultipleSelection != false;
                            },
                            action: function ($event) {                                
                                selectRangeRows();                                
                                selectAllRows();
                            }
                        },
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-selectall-menu-item" layout layout-align="left center" tooltip="Desfaz a seleção de todos registros da grade" tooltip-placement="left">'
                                + ' <sk-icon font-icon="unchecked" style="bottom: 0px;"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.desfazerSelecao') + '</div>',
                            skGridMenuID: 'unselectAll',
                            order: 4,
                            context: $scope,
                            action: function ($event) {
                                unselectAll();
                            },
                            shown: function () {
                                return _selectAll && $scope.allowMultipleSelection != false;
                            }
                        },
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-dynamic-mode-item" layout layout-align="left center" tooltip="Permite criar agrupamentos e agregações" tooltip-placement="left">'
                                + ' <sk-icon font-icon="menu-hamburger" style="bottom: 0px;"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.mostrarPanelDeFerramentas') + '</div>',
                            skGridMenuID: 'showToolPanel',
                            order: 5,
                            context: $scope,
                            action: openToolPanel,
                            shown: function () {
                                return $scope.enableToolPanel != false && !$scope.gridOptions.api.isSideBarVisible()  && isEnableDynamicMode();
                            }
                        },
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-dynamic-mode-item" layout layout-align="left center" tooltip="Esconde o painel do Modo Dinâmico mantendo sua configuração" tooltip-placement="left">'
                                + ' <sk-icon font-icon="minus" style="bottom: 0px;"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.esconderPanelDeFerramentas') + '</div>',
                            skGridMenuID: 'hideToolPanel',
                            order: 5,
                            context: $scope,
                            action: closeToolPanel,
                            shown: function () {
                                return $scope.enableToolPanel != false && $scope.gridOptions.api.isSideBarVisible();
                            }
                        },
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-comfortable-item" layout layout-align="left center" tooltip="Aumenta o espaço entre as colunas" tooltip-placement="left">'
                                + ' <sk-icon font-icon="list-alt"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.modoConfortavel')
                                + ' </div>',
                            skGridMenuID: 'comfortableMode',
                            order: 2,
                            action: function ($event) {
                                setCompactMode(false);
                                if ($scope.gridconfig) {
                                    GridConfig.setCompactMode($scope.gridconfig, false);
                                }
                            },
                            shown: function () {
                                return $scope.compactMode;
                            }
                        },
                        {
                            templateHtml: '<div class="datagrid-menu-item datagrid-comfortable-item" layout layout-align="left center" tooltip="Reduz o espaço entre as colunas (modo padrão)" tooltip-placement="left">'
                                + ' <sk-icon font-icon="compressed"></sk-icon>'
                                + ' &nbsp&nbsp' + i18n('DataGrid.modoCompacto')
                                + ' </div>',
                            skGridMenuID: 'compactMode',
                            order: 2,
                            action: function ($event) {
                                setCompactMode(true);
                                if ($scope.gridconfig) {
                                    GridConfig.setCompactMode($scope.gridconfig, true);
                                }
                            },
                            shown: function () {
                                return !$scope.compactMode;
                            }
                        },
    				]).concat(($scope.disableTour === true) ? [] : [
                        {
                            templateHtml: '<div class="datagrid-menu-item" layout layout-align="left center">'
                                + ' <sk-icon font-icon="train"></sk-icon>&nbsp&nbsp'
                                + ' <span sk-i18n>EntityStartPage.sideMenu.lblIniciarTour</span>'
                                + ' </div>',
                            skGridMenuID: 'initTour',
                            order: 3,
                            action: function(){ startTour() },
                            shown: function () {
                                return true;
                            }
                        }
                    ]);

                    //Criação de menu da grade
                    var el = $('<div class="ui-grid-menu-button ag-grid-menu" ng-click="toggleMenuGrid()" ng-if="enableGridMenu" id="gridMenu">'
                        + ' <div class="ui-grid-icon-container"><sk-icon sk-i18n font-icon="menu-hamburger" tooltip="DataGrid.opcoesGrade"'
                        + ' tooltip-placement="left" tooltip-append-to-body="true" id="iconGridMenu"></sk-icon></div>'
                        + ' <div class="ui-grid-menu" ng-if="showMenuGrid" id="sk-grid-menu" tabindex="-1"><div class="ui-grid-menu-mid"> <div class="ui-grid-menu-inner">'
                        + ' <ul class="ui-grid-menu-items"><div ng-if="ite.shown()" ng-click="ite.action($event, ite.skGridMenuID)" ng-repeat="ite in menuIte | orderBy: order"><div sk-bind-html="ite.templateHtml"></div></div></div></div>');

                    $element.find('.grid-menu')[0].appendChild(el[0]);

                    _elGridMenu = $compile(el)($scope);
                    /*
                        Caso tenha chegado até esse ponto e a api da grade nao exista mais 
                        pode ser que a criação da grade tenha sido cancelada,por um 
                        popup fechado por exempo.                    
                    */
                    if ($scope.gridOptions && $scope.gridOptions.api) {
                    	$scope.gridOptions.api.setServerSideDatasource(_dataSource);
                    	$scope.onDatagridLoaded({ datagrid: _self, dataset: $scope.dataset });
                    }

                    let headerRow = $element.find('.ag-header-viewport .ag-header-container .ag-header-row');

                    if(headerRow.length > 0){
                        headerRow.on('mouseover', () => {
                            verifyCtxMenu();
                        });

                        headerRow.on('mouseout', () => {
                            verifyCtxMenu();
                        });
                    }

                    _scrollContainerX =  $element.find('.ag-body-horizontal-scroll-viewport');
                    _bodyViewPort = $element.find('.ag-body-viewport');
                });
                /*
                    Caso tenha chegado até esse ponto e a api da grade nao exista mais 
                    pode ser que a criação da grade tenha sido cancelada, por um 
                    popup fechado por exempo.                    
                */
                if ($scope.gridconfig && $scope.gridOptions.api) {
                    GridConfig.loadConfigurations($scope.gridconfig);
                }
                
                if ($scope.dataset) {
                    _removeDsObservers.push($scope.dataset.addEventListener(DatasetEvents.ADD_RECORDS_AS_OBJECT_END, ()=>{onDatasetRefresh(DatasetEvents.REFRESH_REASON_RECORDS_ADDED)}));
                    _removeDsObservers.push($scope.dataset.addEventListener(DatasetEvents.ADD_RECORDS_AS_ARRAY_END, onDatasetRefresh));
                }

                _popUpStackObserver = {
                    popUpClosed: function (popup) {
                        _lockEventListeners = false;
                        $timeout( () => _ignoreEnterListener = false , 200);
                        if (!_programmaticallySelectingRecord && $scope.editable != false) {
                            _self.skipAutoOpenSelect = true;
                            $timeout(function(){
                                setNextFocusCell();
                                if (typeof $scope.autoClearEdition === 'function' && isInsertionOnGrid() && _lastStartEditColId && !$scope.dataset.isCopyingRecord()) {
                                    selectNodeByIndex($scope.dataset.size(),true);
                                    getGridApi().setFocusedCell($scope.dataset.size(), _lastStartEditColId);
                                    startEdit(_lastStartEditColId, $scope.dataset.size());
                                    setLastSelectedRowID($scope.dataset.size());
                                } else {
                                    startEdit();
                                }
                            });
                        }
                    },
                    popUpOpened: function (popup) {
                        _lockEventListeners = true;
                        _ignoreEnterListener = true;
                    }
                }
                SanPopupStack.addObserver(_popUpStackObserver);
            };

            function verifyCtxMenu(){

                if(!_scrollContainerX                            || 
                   !_bodyViewPort                                || 
                   _scrollContainerX.length == 0                 ||
                   _bodyViewPort.length == 0                     ||
                   !DomUtil.hasScrolling(_scrollContainerX, 'x') ||
                   DomUtil.hasScrolling(_bodyViewPort, 'y') ){
                    return;
                }

                let atual = $element.find('.ag-column-hover')[0]
                let ultima = $element.find('.ag-column-hover');
                if(ultima.length > 0 ){
                    ultima = ultima[0].parentElement.lastElementChild;
                }else{
                    ultima = undefined;  
                }
                if($element.find(('.ag-column-hover').length > 0) && (atual != undefined && atual == ultima)){
                    $element.find('.ui-grid-menu-button.ag-grid-menu').css('display', 'none');
                }else{
                    $element.find('.ui-grid-menu-button.ag-grid-menu').css('display', 'block');
                }
            }

            $scope.toggleMenuGrid = function () {
                $scope.showMenuGrid = !$scope.showMenuGrid;
                $timeout(function () {
                    if ($scope.showMenuGrid) {
                        try{
                            var menuElement = $element.find('#sk-grid-menu')
                            menuElement.find('input').focus();
                            var menuContent = menuElement.find('.ui-grid-menu-mid');
                            var gridBodyHeight = $element.find('.ag-body').height();
                            var menuContentHeight = menuContent.height();
                            if(gridBodyHeight < menuContentHeight){
                                menuContent.height($element.find('.ag-body').height());
                            }
                        }catch(e){
                            console.log('Erro ao recalcular gridMenu', e);
                        }
                    }
                }, 50);
            }

            function init() {
                $attrs.$observe('skGridConfig', updateGridConfigName);
                $attrs.$observe('skConfigName', updateGridConfigName);
            };

            init();

            function getRowNodeId(data) {
                return data.rowID;
            };

            function getProperties(fieldMD, attName, defaultValue) {
                var atributo = ArrayUtils.find(ArrayUtils.toArray(fieldMD.properties), (e) => e.name == attName);
                return atributo ? atributo.value : defaultValue;
            }

            $scope.$watch('dataset', function (newV) {
                if ($scope.dataset && $scope.dataset.isLoaded() && !_fristLoadExecuted) {
                    initializeDatagrid();
                    _fristLoadExecuted = true;
                }
                if (newV) {
                   
                    $scope.$watch('enableInsertion', function (newV) {
                        if(newV !== undefined && $scope.dataset){
                            $scope.dataset.setEnableInsertionModeGrid(newV);
                        }
                    });

                    var fn = function () {
                        initializeDatagrid();
                    };
                    var removeBackgroundLoadListener = $scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD, function (page) {
                        if (page.pageNumber == 2 && !_fristLoadExecuted) {
                            fn();
                            syncSelectOnDataset();
                            _fristLoadExecuted = true;
                        }
                    });
                    var removeAddRecordsListener = $scope.dataset.addEventListener(DatasetEvents.ADD_RECORDS_AS_OBJECT_END, function () {
                        purgeServerSideCache();
                        $timeout(function () {
                            syncSelectOnDataset();
                        });
                    });
                    var removeAMetadataUpdateListener = $scope.dataset.addEventListener(DatasetEvents.ON_METADATA_UPDATED, fn);
                    _removeDsObservers.push(removeBackgroundLoadListener, removeAddRecordsListener, removeAMetadataUpdateListener);

                    /*necessário para que os dados na grid sejam disponibilizados na carga da primeira pagina.*/
                    $scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD, function (page) {
                        if( page && (parseInt(page.pageNumber)) == 2) {
							 selectNodeByIndex($scope.dataset.size());
				             purgeServerSideCache();
						}                   
                    });
                }
            });

            $scope.$watch('enableDrop', function(newV){
                setupDrop(newV);
            });

            function isFieldMDVisible(fieldMD) {
                var customColumnMD = _customColumnsMD[fieldMD.name];

                if (angular.isUndefined(customColumnMD) && fieldMD.codeFieldName) {
                    customColumnMD = _customColumnsMD[fieldMD.codeFieldName];
                }

                var isVisible;

                if (customColumnMD && customColumnMD.hasOwnProperty('visible')) {
                    isVisible = customColumnMD.visible;
                } else if(_descriptionFieldNames.hasOwnProperty(fieldMD.name)){
                    isVisible = false;
                    if (angular.isUndefined(fieldMD.skVisible)) {
                        isVisible = isFieldMDVisible(_descriptionFieldNames[fieldMD.name].originalFieldFk);
                        if (!isVisible && $scope.showInvisibleFkFields !== false) {
                            isVisible =  fieldMD.visible
                        } 
                    }
                } else {
                    isVisible = fieldMD.userType === 'B' ? false : fieldMD.visible;
                }

                if (angular.isUndefined(isVisible)) {
                    isVisible = true;
                }

                return (isVisible && fieldMD.skVisible !== false);
            };


            function isFieldMDEditable(fieldMD) {
                if(fieldMD.liveCheck == true){
                    return false;
                }
                
                var isDatagridEditable = !$scope.isMobile && $scope.editable;

                var isColumnEditable;

                if (isDatagridEditable) {
                    var customColumnMD = _customColumnsMD[fieldMD.name];

                    if (customColumnMD && customColumnMD.hasOwnProperty('enabled')) {
                        isColumnEditable = customColumnMD.enabled;
                    } else {
                        if (ArrayUtils.isIn($scope.dataset.getPrimaryKeys(), fieldMD.name)) {
                            isColumnEditable = $scope.dataset.getAllowPkModification();
                        } else {
                            isColumnEditable = !fieldMD.readOnly;
                        }
                    }
                } else {
                    isColumnEditable = false;
                }

                return isColumnEditable;
            };


            function getColumnWidth(description) {
                let _size = StringUtils.undefinedAsEmpty(description).length;
                if (_size <= 10) {
                    return Math.max((Math.min(_size, 30) * _charToPixelRatio), 100);
                } else {
                    return Math.max((Math.min(_size, 30) * (_charToPixelRatio - 5)), 100);
                }
            };

            function optionsCellFormatter(col) {
                if (angular.isDefined(col.value)) {
                    for (var i = 0; i < col.colDef.skOptions.length; i++) {
                        var opt = col.colDef.skOptions[i];

                        opt.data = opt.data === "null" || opt.data === "undefined" ? "" : opt.data;

                        if (opt.data == col.value) {
                            return opt.value;
                        }
                    }

                    return col.value;
                }
            };

            function optionsUserCellFormatter(params) {
                var value = params.value;
                var col = params.column;
                if (!angular.isFunction(col.colDef.buildOptionsFn)) {
                    throw new MessageError('buildOptionsFn não definida para a coluna ' + col.colDef.displayName);
                }

                var actualRow = $scope.dataset ? $scope.dataset.getCurrentRowAsObject() : undefined;
                var options = col.colDef.buildOptionsFn(actualRow, true);

                if (angular.isDefined(value)) {
                    for (var i = 0; i < options.length; i++) {
                        var opt = options[i];

                        if (opt.data == value || opt.DATA == value) {
                            return opt.value == undefined ? opt.VALUE : opt.value;
                        }
                    }

                    return value;
                }
            }

            var suggestedNextCell;
            var previousCell;

            function navigateToNextCell(params) {
                previousCell = params.previousCellPosition;
                suggestedNextCell = params.nextCellPosition;
                switch (params.key) {
                    case _keymap.ARROW_DOWN:
                        if(suggestedNextCell !== null){
                            loadGridByIndex(suggestedNextCell.rowIndex);
                        }else if($scope.newRowOnArrowDown === true && ($scope.dataset.isInsertionMode() || $scope.dataset.isEditMode())){
                            if(typeof $scope.fnSaveRowOnArrowDown === 'function'){
                                $scope.fnSaveRowOnArrowDown($scope.dataset, true);
                            }else{
                                $scope.dataset.goToInsertionMode().then(function () {
                                    _selectNodes = [];
                                    setNextFocusCell();
                                });
                            }
                        }else{
                            loadGridByIndex(previousCell.rowIndex); 
                        }
                                              
                        return suggestedNextCell;
                    case _keymap.ARROW_UP:
                        if(previousCell.rowIndex==0){
                            if(angular.isFunction($scope.arrowFocusField)){
                                $scope.arrowFocusField();
                            }
                        }
                        loadGridByIndex(previousCell !== null ? previousCell.rowIndex : suggestedNextCell.rowIndex);
                        return suggestedNextCell;
                    case _keymap.ARROW_LEFT:
                        _colEditing = suggestedNextCell.column;
                        return suggestedNextCell;
                    case _keymap.ARROW_RIGHT:
                        _colEditing = suggestedNextCell.column;
                        return suggestedNextCell;
                }
            };

            function fieldHasOptions(fieldMD) {
                return fieldMD.options && fieldMD.options.length > 0;
            };

            function executeDsSuccessCallbackSafely() {
                if (!_dsSuccessCallBack || $scope.dataset.size() === 0 || _dsSuccessCallBackPending) {
                    return;
                }
                
                _dsSuccessCallBackPending = true;
                
                if (_dsSuccessCallBackTimeout) {
                    AngularUtil.cancelTimeout(_dsSuccessCallBackTimeout);
                }
                
                _dsSuccessCallBackTimeout = AngularUtil.timeout(function() {
                    try {
                        if (_dsSuccessCallBack && $scope.dataset.size() > 0) {
                            _dsSuccessCallBack([], $scope.dataset.size());
                        }
                    } catch (error) {
                        console.error('Erro ao executar dsSuccessCallback:', error);
                    } finally {
                        clearDsSuccessCallback();
                    }
                }, 10);
            }

            function clearDsSuccessCallback() {
                _dsSuccessCallBack = undefined;
                _dsSuccessCallBackPending = false;
                
                if (_dsSuccessCallBackTimeout) {
                    AngularUtil.cancelTimeout(_dsSuccessCallBackTimeout);
                    _dsSuccessCallBackTimeout = null;
                }
            }

            //data set observer
            ObjectUtils.implements(_self, IDataSetObserver);
            _self.refreshed = onDatasetRefresh;
            _self.currentLineChanged = onDatasetCurrentLineChanged;
            _self.editionCanceled = editionCanceled;
            _self.dataSaved = dataSaved;
            _self.allEvents = onAllEvents;
            _self.cleared = onDatasetCleared;
            _self.currentRecordRefreshed = currentRecordRefreshed;
            _self.insertionModeActivated = insertionModeActivated;
            _self.insertionCanceled = insertionCanceled;

            function onDatasetRefresh(event) {
                allDataInCache = undefined;

                _lastSelectedRowID = undefined;

                if (!event || (event == DatasetEvents.REFRESH_REASON_RESET || event == DatasetEvents.REFRESH_REASON_FILTER || event == DatasetEvents.REFRESH_REASON_RECORDS_ADDED) && $scope.gridOptions && $scope.gridOptions.api) {
                    // Remoção do ícone de filtro de todas as colunas filtradas
                    if(event == DatasetEvents.REFRESH_REASON_RESET || event == DatasetEvents.REFRESH_REASON_RECORDS_ADDED){
                        removeAllFilters();
                    }

                    _selectAll = false;

                    if (event == DatasetEvents.REFRESH_REASON_RESET || event == DatasetEvents.REFRESH_REASON_FILTER) {
                        if ($scope.gridOptions && $scope.gridOptions.api) {
                            $scope.gridOptions.api.clearRangeSelection();
                        }
                    }

                    if (!$scope.gridOptions.floatingFilter) {
                        syncSelectOnDataset(true);
                    }
                    purgeServerSideCache();
                    
                    executeDsSuccessCallbackSafely();
                    
                    if (!$scope.gridOptions.floatingFilter) {
                        $timeout(function () {
                            if($scope.focusToAfterRefresh == undefined || $scope.focusToAfterRefresh == true) {
                               if($scope.nextRowAfterSave && !isEventToSort){
                                    tabToNextEditableRow();
                                    $scope.nextRowAfterSave=undefined;
                                    addEventoTeclado(event);
                                }else{ 
                                    isEventToSort = isEventToSort ? false : isEventToSort;
                                    setNextFocusCell();
                                }
                            };
                        }, 200)
                    }
                }
                setBottomData();
                $timeout(refreshCkbRowSelection);
                $timeout(formatValueFormatter);
                _loadedTips = {};
            };

            function onDatasetCurrentLineChanged(newIndex, reason) {
                _lastSelectedRowID = newIndex;

                if (!_pivotMode && reason != DatasetEvents.REFRESH_REASON_SORT && newIndex > -1 && !$scope.isTreeData) {
                    syncSelectOnDataset();
                    $timeout(function(){
                        syncSelectOnDataset();
                    },0,false)
                }
            
                const currentIndex = $scope.dataset.getCurrentIndex();
                if ($scope.disableFirstSelect && currentIndex === 0) {
                    _mapTreeItems = {};
                    return;
                }
            
                if ($scope.hideCbxColumn == false && $scope.dataset.getCurrentRow()) {
                    $scope.dataset.setSelectedRecords([$scope.dataset.getCurrentRow()]);
                }

                _mapTreeItems = {};
            };

            function editionCanceled() {
                endEdit(true);
                purgeServerSideCache();
                _colEditing = undefined;
                if (_self.lastFocusedCell) {
                    $timeout(function () {
                        setNextFocusCell(_self.lastFocusedCell.colId);
                    });
                }
            };

            function insertionCanceled() {
                purgeServerSideCache();
            };

            function dataSaved(isNew, records) {
                setNewData(isNew, records);
            };

            function currentRecordRefreshed(records) {
                setNewData(false, records);
            };

            function setNewData(isNew, records) {
                allDataInCache = undefined;
                if (!isNew) {
                    if (_pivotMode && !$scope.isTreeData) {
                        purgeServerSideCache();
                    } else if(!$scope.isTreeData){
                    	
                    	if(records.length == 0 && $scope.gridOptions && $scope.gridOptions.api){
                            purgeServerSideCache();
                        }
                    	
                        for (var i = 0; i < records.length; i++) {
                            var rowId = $scope.dataset.getRowMetadata(records[i]).rowID;
                            var index = $scope.dataset.getIndexByUniqueId(rowId);
                            if(index > -1){
                                var node = getNodeByIndexOfDataset(index);
                                if(StringUtils.isNotEmpty(node)){
									node.setData($scope.dataset.getRecordAsObject(records[i], undefined, true));	
								}
                            }
                        }
                    }
                } else {
                    executeDsSuccessCallbackSafely();
                    purgeServerSideCache();
                    $timeout(function() {
                        syncSelectOnDataset(true);
                    });
                }
                setBottomData();
                setNextFocusCell();
            };

            function onDatasetCleared(){
                purgeServerSideCache();
            }

            function insertionModeActivated(){
                if ($scope.gridOptions && $scope.gridOptions.api){
                    purgeServerSideCache();
                    $timeout(() => {
                        selectNodeByIndex($scope.dataset.size());
                    });
                }
                onDatasetCurrentLineChanged($scope.dataset.getCurrentIndex());
            }

            function onAllEvents(evt, params) {
                if (evt == DatasetObserverEvents.EVENT_RECORD_EDITED && (!$scope.dataset.isInsertionMode() || $scope.enableInsertion)) {
                    /*
                    Caso algum evento de edição tenha sido ignorado anteriormente, atualizamos todos os campos do node
                    para que registro fique atualizado na grid (caso de uso, GradeItnes das centrais, inicializaProduto)
                    */
                    if( $scope.dataset.hasObserverIgnored(DatasetObserverEvents.EVENT_RECORD_EDITED)){

                        let selectedNodes = $scope.gridOptions.api.getSelectedNodes();
                        
                        if(selectedNodes.length > 0){
                            let row = $scope.dataset.getCurrentRow();
                            let rowAsObject = $scope.dataset.getRecordAsObject(row, undefined, true)

                            if(selectedNodes.length >  1 && isInsertionOnGrid() && $scope.dataset.isCopyingRecord()){
                                selectedNodes[selectedNodes.length - 1].setData(rowAsObject);
                            }else{
                                selectedNodes[0].setData(rowAsObject);
                            }

                        }

                    }else{
                        var actualNode = (_selectNodes && _selectNodes.length > 0) ? _selectNodes[0] : undefined;

                        if (!actualNode) {
                            syncSelectOnDataset();
                            actualNode = $scope.gridOptions.api.getSelectedNodes()[0];
                        }
                        if (actualNode) {
                            var oldValueGrid = actualNode.data[params.modifiedFieldId];
                            if (params.newValue != oldValueGrid) {
                                actualNode.setDataValue(params.modifiedFieldId, params.newValue);
                            }
                        }
                    }
                    allDataInCache = undefined;
                } else if (evt == DatasetObserverEvents.EVENT_RECORD_REMOVED) {
                    purgeServerSideCache();
                    setBottomData();
                    allDataInCache = undefined;
                    $timeout(function(){
                        syncSelectOnDataset(true);
                    }, 0, true);                    
                    //Caso o dataset fique vazio, é necessário apagar os nós selecionados
                    if($scope.dataset.size() == 0){
                        _selectNodes = [];
                    }

                    if($scope.isTreeData){
                        let parentIndex = $scope.dataset.getFieldIndexByName($scope.parentProperty);
                        let parentValue = params.recordReference[parentIndex];
                        _mapTreeItems[parentValue]--;
                    }
                }
            };

            function aggridSortFunction(order) {
                if (typeof $scope.beforeSort === 'function' && $scope.dataset.isInsertionMode()) {
                    $scope.dataset.cancelEdition();
                }

                if (typeof $scope.beforeSort === 'function' && $scope.dataset.isEditMode() && $scope.dataset.isRecordDirty()) {
                        isEventToSort = true;
                        $scope.beforeSort().then(function () {
                            aggridSort(order);
                        });
                } else {
                    aggridSort(order);
                }
            };

            function aggridSort(order) {
                var param = {
                    columns: order.api.sortController.getColumnsWithSortingOrdered()
                };

                for (var i = 0; i < param.columns.length; i++) {
                    if (isGroupCol(param.columns[i])) {
                        return;
                    }
                }

                skSortFunction(param);
                
                const ignoreRowChangeOnNextAggridSortFunction = !!($scope.dataset?.ignoreRowChangeOnNextAggridSortFunction);

                if (ignoreRowChangeOnNextAggridSortFunction == false && $scope.alwaysPositionFirst !== false) {
                    //Comportamento padrão é sempre posicionar o primeiro registro da grade após a ordenação.
                    $timeout(function () {
                        $scope.dataset.gotoRow(0).then(function () {
                            loadGridByIndex(($scope.dataset.getCurrentIndex() - 1));
                            syncSelectOnDataset(true);
                        });
                    });
                }else if(ignoreRowChangeOnNextAggridSortFunction){
                    delete $scope.dataset.ignoreRowChangeOnNextAggridSortFunction;
                }
            }

            function removeClassAllElements(className) {
                var elRemoveClass = document.getElementsByClassName(className);

                var count = elRemoveClass.length;

                for (var i = 0; i < count; i++) {
                    angular.element(elRemoveClass[0]).removeClass(className);
                }
            }

            function skSortFunction(params) {
                var sortCols = params.columns;
                for (var i = 0; i < sortCols.length; i++) {
                    var field;
                    if (isGroupCol(sortCols[i])) {
                        field = sortCols[i].colId;
                    } else {
                        field = sortCols[i].colDef.field;
                    }
                    if (_lastColumnsSorted.hasOwnProperty(sortCols[i].colDef.name) && _lastColumnsSorted[sortCols[i].colDef.field] && _lastColumnsSorted[sortCols[i].colDef.field].sort == sortCols[i].sort && _lastColumnsSorted[sortCols[i].colDef.name].priority == sortCols[i].priority) {
                        continue;
                    }
                    else {
                        _lastColumnsSorted[field] = {
                            direction: sortCols[i].sort,
                            priority: sortCols[i].priority
                        };
                    }
                }

                if (sortCols.length === 0) {
                    if ($scope.dataset.existsSortFunction()) {
                        $scope.dataset.removeSort();
                        _lastColumnsSorted = {};
                    }
                    syncSelectOnDataset();
                    return;
                }

                sortCols = sortCols.sort(prioritySort);

                var rowSortFn = function (a, b) {
                    var idx = 0,
                        sortFn;

                    while (idx < sortCols.length) {
                        var result;
                        col = sortCols[idx];
                        direction = col.sort;
                        var field;

                        if (isGroupCol(col)) {
                            field = _columnsGrouped[0];
                        } else {
                            field = col.colDef.field;
                        }

                        sortFn = getSortFn(col);
                        var colPosition = $scope.dataset.getFieldIndexByName(field);
                        var valueA = a[colPosition];
                        var valueB = b[colPosition];
                        
                        
                        if(_customColumnsMD[col.colId] && angular.isFunction(_customColumnsMD[col.colId].cellFormatter)){
                            if(!valueA){
                                valueA = _customColumnsMD[col.colId].cellFormatter(col, valueA, a);
                            }
                            if(!valueB){
                                valueB = _customColumnsMD[col.colId].cellFormatter(col, valueB, b);
                            }                            
                        }

                        result = sortFn(valueA, valueB);

                        idx++;

                        if (result == 0) {
                            continue;
                        }

                        return result == 0 ? result : direction == 'asc' ? result : result * -1;
                    }
                };
                $scope.dataset.setSortFunction(rowSortFn);
                $scope.dataset.sortRecords();
            };

            function getSortFn(col) {
                if (isGroupCol(col)) {
                    var skType = $scope.gridOptions.columnApi.getColumn(_columnsGrouped[0]).colDef.skType;
                    col.colDef['skType'] = skType;
                }
                
                if(_customColumnsMD[col.colId] && _customColumnsMD[col.colId].customSort){
                    if(angular.isFunction(_customColumnsMD[col.colId].customSort)){
                        return _customColumnsMD[col.colId].customSort;
                    }else{
                        console.warn('sk-custom-sort definido para o campo ' + col.colId + ' não é uma função, por isso será ignorada.');
                    }
                }
                
                switch (col.colDef.skType) {
                    case "number":
                    case "time":
                        return sortNumber;
                    case "text":
                        return sortAlpha;
                    case "date":
                        return sortDate;
                    case "datetime":
                        return sortDate;
                    default:
                        throw new Error('No sorting function found for type:' + col.colDef.type);
                }
            };

            function sortNumber(a, b) {
                a = NumberUtils.stringToNumber(a);
                b = NumberUtils.stringToNumber(b);
                var nulls = handleNulls(a, b);
                if (nulls !== null) {
                    return nulls;
                } else {
                    return a - b;
                }
            };

            function sortAlpha(a, b) {
                a = String(a);
                b = String(b);
                var nulls = handleNulls(a, b);
                if (nulls !== null) {
                    return nulls;
                } else {
                    return ('' + a).localeCompare(b);
                }
            };

            function sortDate(a, b) {
                var nulls = handleNulls(a, b);
                if (nulls !== null) {
                    return nulls;
                } else {

                    if(a.constructor === String){
                        let dateA = a.substring(0, a.indexOf("("));
                        a = new Date(a);
                    }

                    if(b.constructor === String){
                        let dateB = b.substring(0, b.indexOf("("));
                        b = new Date(b);
                    }

                    var timeA = a.getTime(),
                        timeB = b.getTime();

                    return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
                }
            };

            function handleNulls(a, b) {
                // We want to allow zero values and false values to be evaluated in the sort function
                if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                    // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                    if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                        return 0;
                    }
                    else if (!a && a !== 0 && a !== false) {
                        return -1;
                    }
                    else if (!b && b !== 0 && b !== false) {
                        return 1;
                    }
                }
                return null;
            };

            function prioritySort(a, b) {
                // Both columns have a sort priority
                if (a.priority !== undefined && b.priority !== undefined) {
                    // A is higher priority
                    if (a.priority < b.priority) {
                        return -1;
                    }
                    // Equal
                    else if (a.priority === b.priority) {
                        return 0;
                    }
                    // B is higher
                    else {
                        return 1;
                    }
                }
                // Only A has a priority
                else if (a.priority || a.priority === 0) {
                    return -1;
                }
                // Only B has a priority
                else if (b.priority || b.priority === 0) {
                    return 1;
                }
                // Neither has a priority
                else {
                    return 0;
                }
            };

            //Feito para forçar a seleção dos registros com o shift em massa de dados grande
            function forceShiftSelect(){
                let firstRow = NumberUtils.stringToNumber($scope.firstClick);
                let lastRow = NumberUtils.stringToNumber($scope.lastClick);

                    // Assegura a ordem correta das linhas
                    if (firstRow > lastRow) {
                        [firstRow, lastRow] = [lastRow, firstRow];
                    }

                    const selectedIndexes = [];

                    for (let index = firstRow; index <= lastRow; index++) {
                        const node = $scope.gridOptions.api.getDisplayedRowAtIndex(index);
                        if (node) { 
                            node.setSelected(true);
                        }
                        selectedIndexes.push(index);
                    }
                    $scope.dataset.addSelectedRecordsByUniqueIds(selectedIndexes);
            }
            
            function getRowIndexSelect(event) {
                return event?.event?.target?.parentElement?.getAttribute('row-index');
            }

            function isAlreadyEditingThisCell(rowIndex, colId) {
                const currentEditingCells = $scope.gridOptions.api.getEditingCells();

                if(currentEditingCells.length <= 0) {
                    return false;
                }

                if(currentEditingCells[0].rowIndex !== rowIndex) {
                    return false;
                }

                if(currentEditingCells[0].column.colId !== colId) {
                    return false;
                }

                return true;
            }

            //Limpa a seleção provocada pelo click simples na linha. Quando skKeepCheckboxSelectionOnRowClick
            //está ativa, as seleções feitas pela coluna de checkbox são preservadas (coexistem com o click).
            function clearRowClickSelection() {
                if ($scope.keepCheckboxSelectionOnRowClick === true) {
                    var keptRecords = ($scope.dataset.getSelectedRecords() || []).filter(function (row) {
                        var md = $scope.dataset.getRowMetadata(row);
                        return md && _checked[md.rowID] && _checked[md.rowID].value === true;
                    });
                    $scope.dataset.setSelectedRecords(keptRecords);
                } else {
                    $scope.dataset.setSelectedRecords([]);
                }
            }

            function onRowClicked(event, programatically) {
                _recordsToSelectPgDown = [];

                let saveClick = true;

                if (typeof $scope.autoClearEdition === 'function' && isInsertionOnGrid() && $scope.dataset.size() > event?.node?.rowIndex) {
                    $scope.autoClearEdition(event);
                    saveClick = false;
                } else if($scope.dataset.isInsertionMode() && $scope.dataset.getCurrentIndex() !== event?.node?.id){
                    if ($scope.dataset.isCopyingRecord() && typeof $scope.autoClearEdition === 'function') {
                        $scope.dataset.setCurrentIndex(-1);
                    } else {
                        $scope.dataset.clearEdition();
                    }
                }

                var deferred = $q.defer();
                var isLiveCheck = (event && event.event && event.event.target && event.event.target.getAttribute('live-checkbox') == 'true');

                if (event && event.node) {
                    _lastSelectedRowID = event.node.rowIndex;
                    clickRow = _lastSelectedRowID;
                } else {
                    _lastSelectedRowID = undefined;
                }

                if($scope.showMenuGrid){
                    $scope.showMenuGrid = false;
                    AngularUtil.apply($scope);
                }

                if(event && event.event && event.event.target && event.event.target.getAttribute('name') == 'sk-cbx-row-selection' || _lockRowClick){
                    return deferred.reject(event);
                }

                if ($scope.onClick) {
                    $scope.onClick();
                }
                
                if (_programmaticallySelectingRecord) {
                    _programmaticallySelectingRecord = false;
                    syncSelectOnDataset();
                    return deferred.reject(event);
                }
                if (!programatically && !isLiveCheck) {
                    //Verificamos se a linha que está sendo clicada é a atual selecionada atual selecionada, se for igual iniciamos a edição
                    var indexOfDataset = $scope.dataset.getIndexByUniqueId(event.node.id);

                    if (((((indexOfDataset != -1 || $scope.dataset.getCurrentIndex() != -1) && indexOfDataset == $scope.dataset.getCurrentIndex() && !$scope.editGridEvent) || isInsertionOnGrid()) && !_selectAll) && saveClick) {
                        if((indexOfDataset != $scope.dataset.getCurrentIndex() && isInsertionOnGrid())){
                            return deferred.reject(event);
                        }
                        if(!event.event.target.parentElement){
                            return deferred.reject(event);
                        }

                        var colId =  getColId(event);
                        var col = $scope.gridOptions.columnApi.getColumn(colId);
                        var rowIndex = event.event.target.parentElement.getAttribute('row-index');
                        
                        let shouldRestartEdit = true;
                        
                        if($scope.avoidFocusOutWhileEditing) {
                            if (!rowIndex && event.node) {
                                rowIndex = event.node.rowIndex;
                            }

                            const numericRowIndex = parseInt(rowIndex, 10);
                            shouldRestartEdit = !isAlreadyEditingThisCell(numericRowIndex, colId);
                        }

                        if (col && col.colDef.editable && (col.colId === _self.lastClickedColId || $scope.editOnClick) && 
                            document.activeElement?.parentElement?.tagName !== 'SK-TIME-INPUT' && shouldRestartEdit) {
                            endEdit();
                            startEdit(colId, rowIndex);

                            _self.lastClickedColId = col.colId;
                        }else if(col){
                            _self.lastClickedColId = col.colId;
                        }

                        
                        clearRowClickSelection();
                        $scope.dataset.addSelectedRecordByUniqueId(event.node.id, _ckbRowSelectionByNodeId[event.node.id] ? true : null);
                        
                        _selectNodes = ArrayUtils.sortByNumberProperty($scope.gridOptions.api.getSelectedNodes(), 'rowIndex');
                        refreshCkbRowSelection();
                        //Necessário pos a grade não dispara ciclos digest.
                        AngularUtil.digest($scope);
                        return deferred.reject(event);
                    }
		    
		    if($scope.editGridEvent){
                        var colId =  getColId(event);
                        var col = $scope.gridOptions.columnApi.getColumn(colId);
                        _selectNodes = ArrayUtils.sortByNumberProperty($scope.gridOptions.api.getSelectedNodes(), 'rowIndex');
                        
                        let shouldRestartEdit = true;

                        if($scope.avoidFocusOutWhileEditing) {
                            const currentSelectedRowIndex = _selectNodes.length > 0 ? _selectNodes[0].rowIndex : null;
                            shouldRestartEdit = !(currentSelectedRowIndex !== null && isAlreadyEditingThisCell(currentSelectedRowIndex, colId));
                        }

                        if (shouldRestartEdit) {
                            endEdit(true);
                            startEdit(colId, _selectNodes[0].rowIndex);
                        }
                        
                        _self.lastClickedColId = col.colId;
                        $scope.dataset.addSelectedRecordByUniqueId(event.node.id, _ckbRowSelectionByNodeId[event.node.id] ? true : null);
                        $scope.dataset.setCurrentIndex(_selectNodes[0].rowIndex);
                        $scope.dataset.refreshBinders();
                    }

                    if (!event.event.shiftKey && $scope.forceShiftSelect === true) {
                        $scope.firstClick = getRowIndexSelect(event);
                    }

                    //Seleção de registros com shift
                    if (event.event.shiftKey && $scope.allowMultipleSelection != false) {
                        $scope.lastClick = getRowIndexSelect(event);

                        _selectAll = true;
                        _selectNodes = ArrayUtils.sortByNumberProperty(event.api.getSelectedNodes(), 'rowIndex');
                       
                        if ($scope.forceShiftSelect === true && _selectNodes.length == 1) {
                            shiftSelect();
                        } else if($scope.callSelectedOnce === true){
                            $scope.dataset.addSelectedRecordsByUniqueIds(_selectNodes.map(row => row.id));
                        }else{
                            _selectNodes.forEach(function (node) {
                                $scope.dataset.addSelectedRecordByUniqueId(node.id, _ckbRowSelectionByNodeId[node.id] ? true : null);
                            })
                        }
                        //Necessário pos a grade não dispara ciclos digest.
                        AngularUtil.digest($scope);
                    }

                    //Seleção multipla utilizando tecla ctrl (o aggrid não da suporte para isso com infinity scroll)
                    //Com skKeepCheckboxSelectionOnRowClick o click simples se comporta como ctrl+click (toggle aditivo).
                    if (!event.event.shiftKey && (event.event.ctrlKey || $scope.keepCheckboxSelectionOnRowClick === true) && $scope.allowMultipleSelection != false) {
                        _selectAll = true;
                        var rowId = event.node.id;
                        event.node.setSelected(!$scope.dataset.isSelected(rowId));
                        if (!$scope.dataset.isSelected(rowId)) {
                            $scope.dataset.addSelectedRecordByUniqueId(rowId, _ckbRowSelectionByNodeId[rowId] ? true : null);
                        } else {
                            $scope.dataset.unselectRowByUniqueId(rowId, _ckbRowSelectionByNodeId[rowId] ? false : null);
                        }

                        _selectNodes = ArrayUtils.sortByNumberProperty(event.api.getSelectedNodes(), 'rowIndex');
                        //Em alguns momentos a selecao da grade fica dessincronizada com o dataset, nesse caso atualizamos o data set de acordo com a seleção da grade
                        if(_selectNodes.length != $scope.dataset.getSelectedRecords().length){
                            _selectNodes.forEach(function(node){
                                $scope.dataset.addSelectedRecordByUniqueId(node.id, _ckbRowSelectionByNodeId[node.id] ? true : null); 
                            })
                        }

                        var cellFocus = $scope.gridOptions.api.getFocusedCell();
                        if(cellFocus) setNextFocusCell( cellFocus.column.colId );

                        //Necessário pois a grade não dispara ciclos digest.
                        AngularUtil.digest($scope);

                        if(_ckbRowSelectionByNodeId[event.node.id]){
                            _ckbRowSelectionByNodeId[event.node.id].check();
                        }
                        refreshCkbRowSelection();
                        return deferred.resolve(_selectNodes);
                    }

                    //Desabilita a seleção de todos os registros
                    if (event.api.getSelectedNodes().length <= 1) {
                        _selectAll = false;
                    }

                    refreshCkbRowSelection();

                    //Caso o select all seja executado não podemos fazer a navegação.
                    if (_selectAll) {
                        return deferred.resolve(_selectNodes);
                    }
                }

                if(event && event.event && event.event.target){
                    _self.lastClickedColId = event.event.target.getAttribute('col-id');
                }

                var f = function (uniqueId) {

                    if($scope.gridOptions.api == null || $scope.gridOptions.api == undefined){
                        return;
                    }
                    
                    _selectNodes = ArrayUtils.sortByNumberProperty($scope.gridOptions.api.getSelectedNodes(), 'rowIndex');
                    clearRowClickSelection();
                    if (_selectNodes.length > 0 || uniqueId != undefined) {
                        var newIndex;
                        if(uniqueId != undefined){
                            newIndex = uniqueId;
                        }else{
                            newIndex = _selectNodes[0].data ? $scope.dataset.getIndexByUniqueId(_selectNodes[0].id) : 0;
                        }
                        //Com skKeepCheckboxSelectionOnRowClick o gotoRow não pode limpar a seleção múltipla,
                        //senão desfaz a preservação feita em clearRowClickSelection.
                        $scope.dataset.gotoRow(newIndex, $scope.keepCheckboxSelectionOnRowClick === true ? false : true).then(function (index) {
                            _selectNodes.forEach(function (node) {
                                var uniqueId = node.id;
                                if (uniqueId != undefined) {
                                    $scope.dataset.addSelectedRecordByUniqueId(uniqueId, _ckbRowSelectionByNodeId[uniqueId] ? true : null);
                                }
                            });

                            if($scope.isTreeData && event){
                                $timeout( () => {
                                    event.node.setSelected(true, true);
                                    if (_self.lastFocusedCell && $scope.focusToAfterRefresh != false) {
                                        setFocusOnCell(_self.lastFocusedCell.colId, event.node.rowIndex);
                                    }
                                });
                            }else{
                                if (_self.lastFocusedCell) {
                                    setNextFocusCell(_self.lastFocusedCell.colId);
                                }
                            }                            
                            refreshCkbRowSelection();
                        }, function () {
                            syncSelectOnDataset();
                        });
                    }
                }

                $scope.dataset.save(false, undefined, {preventSort : true, preventFilter: true}).then(function () {
                    f( ($scope.isTreeData && event) ? event.node.id : undefined );
                }, function (error) {
                    if (error === DatasetContants.RECORD_IS_NOT_DIRTY) {
                        f(($scope.isTreeData && event) ? event.node.id : undefined);
                    } else {
                        const saveInsertionClick = typeof $scope.autoClearEdition === 'function' && isInsertionOnGrid() && $scope.dataset.size() > event?.node?.rowIndex;
                        if (!_pivotMode) {
                            syncSelectOnDataset(true);
                            if (saveInsertionClick) {
                                $scope.fnSaveOnClick(true);
                            }
                        } else if (_selectNodes.length > 0) {
                            _selectNodes[0].setSelected(true, true);
                        }
                        if (_self.lastFocusedCell) {
                            $timeout(function () {
                                if (!saveInsertionClick) {
                                    startEdit(_self.lastFocusedCell.colId);
                                    setNextFocusCell(_self.lastFocusedCell.colId);
                                }
                            })
                        }
                    }

                    return deferred.resolve(_selectNodes);
                });
                return deferred.promise;
            };


            function getColId(event){
                var colId = event.event.target.getAttribute('col-id');

                if(angular.isUndefined(colId)){
                    colId = event.event.target.closest("[col-id]")?.getAttribute("col-id");
                }

                return colId;
            }

            function refresh() {
                if (_pivotMode && $scope.gridOptions.api.getSelectedNodes().length > 0) {
                    var selectedNodes = $scope.gridOptions.api.getSelectedNodes();
                    loadGridByIndex($scope.gridOptions.api.getSelectedNodes()[0].rowIndex);
                } else {
                    $timeout(function () {
                        loadGridByIndex(($scope.dataset.getCurrentIndex() - 1));
                        syncSelectOnDataset(true);
                    });
                }
            };

            function selectNodeByIndex(newIndex, forceSelect, ignoreFocusOnCell) {
                if (_selectNodes && _selectNodes.length > 0 && _selectNodes[0].rowIndex === newIndex && !forceSelect) {
                        for(var id in _ckbRowSelectionByNodeId){
                            if(id != _selectNodes[0].id){
                                _ckbRowSelectionByNodeId[id].unCheck();
                            }
                        }
                        refreshCkbRowSelection();                    
                    return;
                }
                if ($scope.gridOptions && $scope.gridOptions.api && newIndex != -1) {
                    var newNode;
                    if (angular.isArray(newIndex)) {
                        newIndex.forEach(function (index, i) {
                            newNode = getNodeByIndexOfDataset(index);
                            if (newNode) {
                                newNode.setSelected(true, i == 0 ? true : false);
                               if(_ckbRowSelectionByNodeId[newNode.id]){
                                    _ckbRowSelectionByNodeId[newNode.id].check();
                               }
                            }
                        })
                    } else {
                        $scope.gridOptions.api.deselectAll();
                        newNode = getNodeByIndexOfDataset(newIndex);
                        if (newNode) {
                            if (newNode.id == undefined) {
                                $scope.nodePendingSelect = newNode;

                                AngularUtil.addConditionalRemoveWatch($scope, 'nodePendingSelect.id', function(){
                                    $scope.nodePendingSelect.setSelected(true, true);
                                }, function(){
                                    return true;
                                });

                            } else {
                            	newNode.setSelected(true, true);
                        	}
                            
                        }
                    }
                    if(!ignoreFocusOnCell) loadGridByIndex(newNode ? newNode.rowIndex : 0);
                    _selectNodes = ArrayUtils.sortByNumberProperty($scope.gridOptions.api.getSelectedNodes(), 'rowIndex');
                } else if ($scope.gridOptions && $scope.gridOptions.api && newIndex === -1) {
                    $scope.gridOptions.api.deselectAll();
                }
                if (!ignoreFocusOnCell && ($scope.focusToAfterRefresh == undefined || $scope.focusToAfterRefresh == true)) {
                    let showDoubleView = undefined;
                    try {
                       showDoubleView = $scope.datagridInterceptor.getShowDoubleView();
                    }
                    catch (e) {
                       showDoubleView = false;
                    }
                    if(!showDoubleView){ 
                        setNextFocusCell();
                    }
                }
                refreshCkbRowSelection();
            };

            function getNodeByIndexOfDataset(index) {
                var newNode;
                if (_pivotMode) {
                    $scope.gridOptions.api.forEachNode(function (node) {
                        if (node.rowIndex === index) {
                            newNode = node;
                        }
                    });
                } else {
                    newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(index);
                }
                return newNode;
            }

            function syncSelectOnDataset(forceSync, ignoreFocusOnCell) {
                var dsIndex = [];
                var selectedRecords = $scope.dataset.getSelectedRecords();
                if ((selectedRecords || []).length > 0 && angular.isDefined(selectedRecords[0])) {
                    selectedRecords.forEach(function (row) {
                        if(angular.isDefined($scope.dataset.getRowMetadata(row))){
                            var rowId = $scope.dataset.getRowMetadata(row).rowID;
                            var rowIndex = $scope.dataset.getIndexByUniqueId(rowId);
                            dsIndex.push(rowIndex);
                        }else {
                            const currentIndex = $scope.dataset.getCurrentIndex();
                            dsIndex = $scope.disableFirstSelect && currentIndex === 0 ? -1 : currentIndex;
                        }
                    })
                } else {
                    const currentIndex = $scope.dataset.getCurrentIndex();
                    dsIndex = $scope.disableFirstSelect && currentIndex === 0 ? -1 : currentIndex;
                }
                selectNodeByIndex(dsIndex, forceSync, ignoreFocusOnCell);
            };

            function getColumnByName(fieldName) {
                return _columnDefsByName[fieldName];
            };

            function endEdit(cancel) {
                if ($scope.gridOptions && $scope.gridOptions.api) {
                    $scope.gridOptions.api.stopEditing(cancel || false);
                    $scope.gridOptions.api.clearFocusedCell();
                    _editorOpenned = false;

                    $timeout(function () {
                        $document.scroll();
                        AngularUtil.apply($scope);
                    });
                }
            };

            function onGridCellEditKeydown(evt) {
                _recordsToSelectPgDown = [];

                if (evt.keyCode == _keymap.TAB) {
                    var colBeforeStop = _colEditing ? _colEditing.colId : null;
                    $scope.gridOptions.api.stopEditing();
                    $scope.gridOptions.keyPressed = evt.keyCode;
                    
                    if ($scope.tabBetweenEditableColumns) {
                        const tabFn = evt.shiftKey ? tabToPreviousEditableCell : tabToNextEditableCell;
                        tabFn(colBeforeStop);
                    } else if (!evt.shiftKey) {
                        tabToNextEditableCellOriginal();
                    }
                
                    evt.stopPropagation();
                    evt.preventDefault();

                }else if (evt.keyCode == _keymap.ARROW_DOWN && $scope.newRowOnArrowDown === true && ($scope.dataset.isInsertionMode() || $scope.dataset.isEditMode())) {
                                        
                    if(evt.keyCode == _keymap.ARROW_DOWN && typeof $scope.fnSaveRowOnArrowDown === 'function'){
                        $scope.fnSaveRowOnArrowDown($scope.dataset, true);
                    }else{
                        $scope.dataset.goToInsertionMode().then(function () {
                            _selectNodes = [];
                            setNextFocusCell();
                        });
                    }
                }
            }

            function onRowDoubleClicked(params) {
                if (params.column) {
                    var colClicked = params.column;
                    if (!_editorOpenned) {
                        callDblClickIfCan(params);
                    }
                } else {
                    callDblClickIfCan(params);
                }
            };

            function callDblClickIfCan(params) {
                if (angular.isFunction($scope.onDblClick)) {
                    endEdit();
                    $timeout(function () {
                        $scope.onDblClick({'params': params});
                    }, 0, false);
                }
            }

            function loadGridByIndex(index) {
                if ($scope.gridOptions && $scope.gridOptions.api) {
                    if ($scope.gridOptions.api.paginationProxy.rowModel.getRowCount() < index) {
                        purgeServerSideCache();
                    }

                    $timeout(function () {
                        try {
                            $scope.gridOptions?.api?.ensureIndexVisible(index);
                        } catch (error) {
                            //Em algums momentos o aggrid pode lançar erros que não nos interessa nesse ponto
                            console.log(error);
                        }
                    }, 0, false);
                }
            };

            function startEdit(colId, rowIndex) {
                if (colId) {
                    _lastStartEditColId = colId;
                }
                
                if(!isInsertionOnGrid()){
                    if(($scope.dataset && $scope.dataset.size() == 0) || _selectNodes.length > 1 || !$scope.gridOptions || !$scope.gridOptions.api || $scope.gridOptions.api.getDisplayedRowCount() == 0){
                        return;
                    }
                }

                if ((_selectNodes.length > 0 && _colEditing) || ((rowIndex || _selectNodes.length > 0) && (colId || _colEditing))) {
                	try{
                        rowIndex = rowIndex || _selectNodes[0].rowIndex;
                        if(angular.isDefined(rowIndex)){//So abrimos a edicao para linha se existir algum valor
                            //Abrindo celula edicao
                            $scope.gridOptions.api.startEditingCell({
                                rowIndex: rowIndex,
                                colKey: colId || _colEditing.colId
                            });
                            
                            $scope.$broadcast('UiSelectFocusEvent');
                        }
                	} catch(e){
                		// O datagrid está com um registro em modo de edição, quando o grid é recarregado o AgGrid entende que a célula ainda está em edição 
                		// ocasionando o erro RowTop.
                		console.log(e);
                	}
                }
            };

            function isInsertionOnGrid(){
                return angular.isDefined($scope.dataset) && $scope.dataset.isInsertionMode() && $scope.enableInsertion;
            }

            function setLastSelectedRowID(value) {
                _lastSelectedRowID = value;
            }

            function getLastStartEditColId() {
                return _lastStartEditColId;
            }            

            function setNextFocusCell(colId) {
                if (!$scope.gridOptions || !$scope.gridOptions.api) {
                    return;
                }

                var col = colId || (_self.lastFocusedCell ? _self.lastFocusedCell.colId : undefined) || (_colEditing ? _colEditing.colId : '');
                if (col && _selectNodes.length > 0) {
                    let rowToFocus = _lastSelectedRowID >= 0 ? _lastSelectedRowID : _selectNodes[_selectNodes.length - 1].rowIndex;
                    if(!$scope.editGridEvent){
                        clearAndSetFocusRow(rowToFocus, col);
                    }
                } else {
                    let defaultCell = getDefaultFocusableCell();

                    if (defaultCell) {
                        clearAndSetFocusRow(0, defaultCell.colId);
                    }
                }
            };

            /**
             * Comportamento original de Tab: navega para a próxima coluna editável
             * na mesma linha, sem troca automática de linha.
             * Ativo quando sk-tab-between-editable-columns não está habilitado.
             */
            function tabToNextEditableCellOriginal(colId) {
                var curCol = (_colEditing ? _colEditing.colId : '') || (_self.lastFocusedCell ? _self.lastFocusedCell.colId : undefined);
                var index = 0;

                while ($scope.columnDefs[index]) {
                    if ($scope.columnDefs[index].field == (colId ? colId : curCol)) {
                        var fromThisIndex = index;

                         while($scope.columnDefs[fromThisIndex]){
                            var fieldEditable = $scope.gridOptions.api.getColumnDef($scope.columnDefs[fromThisIndex + 1].field).editable

                            if (fieldEditable) {
                                let rowToFocus = _lastSelectedRowID >= 0 ? _lastSelectedRowID : _selectNodes[_selectNodes.length - 1].rowIndex;

                                clearAndSetFocusRow(rowToFocus, $scope.columnDefs[fromThisIndex + 1].field);
                                startEdit($scope.columnDefs[fromThisIndex + 1].field, rowToFocus);
                                break;
                            } else {
                                fromThisIndex = fromThisIndex + 1;
                            }
                        }
                    }
                    index = index + 1;
                }
            }

            // ==================================================================================
            // Navegação por Tab entre colunas editáveis (sk-tab-between-editable-columns)
            //
            // Comportamento análogo ao DBDataGrid do Flex:
            //   Tab        → próxima coluna editável → se última, primeira editável da próxima linha
            //   Shift+Tab  → coluna editável anterior → se primeira, última editável da linha anterior
            //
            // O dataset.autoSave é suprimido durante a troca de linha porque o salvamento
            // é responsabilidade da tela (via sk-focus-out → backend), não do dataset.
            // ==================================================================================

            /**
             * Retorna o field da coluna em edição ou com foco.
             */
            function getCurrentEditingColumnField(colId) {
                if (colId){
                    return colId;
                }
                
                if (_colEditing) {
                    return _colEditing.colId;
                }
                
                return _self.lastFocusedCell ? _self.lastFocusedCell.colId : undefined;
            }


            /**
             * Retorna o índice da linha atualmente selecionada/em foco.
             */
            function getCurrentEditingRowIndex() {
                if (_lastSelectedRowID >= 0) {
                    return _lastSelectedRowID;
                }
                
                return _selectNodes.length > 0 ? _selectNodes[_selectNodes.length - 1].rowIndex : 0;
            }


            /**
             * Retorna a lista de colunas exibidas no grid que são editáveis,
             * na ordem em que aparecem visualmente.
             * Usa a AgGrid Column API para considerar apenas colunas visíveis.
             */
            function getDisplayedEditableColumns() {
                var cols = $scope.gridOptions.columnApi.getAllDisplayedColumns();
                var result = [];
                for (var i = 0; i < cols.length; i++) {
                    if (cols[i].colDef && cols[i].colDef.editable === true) {
                        result.push(cols[i].colId);
                    }
                }
                return result;
            }

            /**
             * Retorna o field da primeira coluna editável visível no grid.
             */
            function findFirstEditableColumnField() {
                var cols = getDisplayedEditableColumns();
                return cols.length > 0 ? cols[0] : null;
            }

            /**
             * Retorna o field da última coluna editável visível no grid.
             */
            function findLastEditableColumnField() {
                var cols = getDisplayedEditableColumns();
                return cols.length > 0 ? cols[cols.length - 1] : null;
            }

            /**
             * Procura a próxima coluna editável após 'currentField'.
             * Retorna o field encontrado ou null se não houver.
             */
            function findNextEditableColumnField(currentField) {
                var cols = getDisplayedEditableColumns();
                for (var i = 0; i < cols.length; i++) {
                    if (cols[i] == currentField && i + 1 < cols.length) {
                        return cols[i + 1];
                    }
                }
                return null;
            }

            /**
             * Procura a coluna editável anterior a 'currentField'.
             * Retorna o field encontrado ou null se não houver.
             */
            function findPreviousEditableColumnField(currentField) {
                var cols = getDisplayedEditableColumns();
                for (var i = 0; i < cols.length; i++) {
                    if (cols[i] == currentField && i - 1 >= 0) {
                        return cols[i - 1];
                    }
                }
                return null;
            }

            /**
             * Posiciona o foco e inicia edição em uma célula específica.
             */
            function focusAndEdit(rowIndex, field) {
                clearAndSetFocusRow(rowIndex, field);
                startEdit(field, rowIndex);
            }

            /**
             * Navega o dataset para outra linha suprimindo o auto-save,
             * e após a navegação posiciona o foco na célula indicada.
             *
             * O auto-save é suprimido porque durante a navegação por Tab
             * o salvamento dos dados é responsabilidade da tela (via sk-focus-out),
             * não do dataset. Sem isso, gotoRow() dispara o dialog "O registro
             * atual foi alterado. O que deseja fazer?".
             */
            function navigateToRowAndEdit(targetRowIndex, targetField) {
                _lockNavigateTab = true;
                endEdit(true);

                var ignoreAutoSaveState = $scope.dataset.isIgnoreAutoSave();
                $scope.dataset.setIgnoreAutoSave(true);
                $scope.dataset.clearEdition();

                function restore() {
                    $scope.dataset.setIgnoreAutoSave(ignoreAutoSaveState);
                    _lockNavigateTab = false;
                }

                $scope.dataset.gotoRow(targetRowIndex).then(function () {
                    restore();
                    focusAndEdit(targetRowIndex, targetField);
                }, restore);

            }

            /**
             * Tab → avança para a próxima célula editável.
             *
             * - Próxima coluna editável na mesma linha → foca nela
             * - Sem mais colunas + há próxima linha → primeira editável da próxima linha
             * - Última linha + newRowOnTab → cria nova linha via dataset.goToInsertionMode()
             * - Nenhuma das anteriores → chama afterGridFunction (foco sai do grid)
             */
            function tabToNextEditableCell(colId) {
                var curCol = getCurrentEditingColumnField(colId);
                var curRow = getCurrentEditingRowIndex();

                var nextCol = findNextEditableColumnField(curCol);
                if (nextCol) {
                    focusAndEdit(curRow, nextCol);
                    return;
                }

                var firstCol = findFirstEditableColumnField();
                if (!firstCol) {
                    return;
                }

                if (!isLastRecord() && !$scope.dataset.isInsertionMode()) {
                    navigateToRowAndEdit(curRow + 1, firstCol);
                    return;
                }

                if ($scope.newRowOnTab === true && $scope.enableInsertion !== false) {
                    endEdit(true);
                    var autoSaveState = $scope.dataset.isConditionalAutoSave();
                    $scope.dataset.setConditionalAutoSave(false);

                    $scope.dataset.goToInsertionMode().then(function () {
                        _selectNodes = [];
                        setNextFocusCell();
                        $scope.dataset.setConditionalAutoSave(autoSaveState);
                        positionOnInsertItem();
                    }, function () {
                        $scope.dataset.setConditionalAutoSave(autoSaveState);
                    });
                    return;
                }

                if (angular.isFunction($scope.afterGridFunction)) {
                    $scope.afterGridFunction();
                }
            }

            /**
             * Shift+Tab → volta para a célula editável anterior.
             *
             * - Coluna editável anterior na mesma linha → foca nela
             * - Sem mais colunas + há linha anterior → última editável da linha anterior
             */
            function tabToPreviousEditableCell(colId) {
                var curCol = getCurrentEditingColumnField(colId);
                var curRow = getCurrentEditingRowIndex();

                // Coluna editável anterior na mesma linha
                var prevCol = findPreviousEditableColumnField(curCol);
                if (prevCol) {
                    focusAndEdit(curRow, prevCol);
                    return;
                }

                // Há linha anterior → navega para ela
                var lastCol = findLastEditableColumnField();
                if (!lastCol || curRow <= 0) {
                    return;
                }

                navigateToRowAndEdit(curRow - 1, lastCol);
            }

            function clearAndSetFocusRow(rowIndex, colId) {
                $scope.gridOptions.api.clearFocusedCell();
                if (_selectNodes.length === 1) {
                    $scope.gridOptions.api.clearRangeSelection();
                }
                $scope.gridOptions.api.setFocusedCell(rowIndex, colId, null);
            };
            
            function setFocusOnCell(colId, rowId) {
                if(!$scope.gridOptions || !$scope.gridOptions.api){
                    return;
                }

                if(rowId == undefined){
                    var selectedNodes = $scope.gridOptions.api.getSelectedNodes();
                    if(selectedNodes && selectedNodes.length > 0){
                        rowId = selectedNodes[0].rowIndex;
                    }
                }

                $scope.gridOptions.api.setFocusedCell(rowId, colId, null);
            };

            function clearFocusedCell() { }

            var _lockNavigateTab = false;

            function tabToNextCell(params) {
                if (_lockNavigateTab && !$scope.enterAsTab) {
                    return;
                }
                var nextCell = params.nextCellPosition;
                var previousCell = params.previousCellPosition;

                if(previousCell.column===getLastColumn() && nextCell===null){
                    // TODO focus no em campo externo ao datagrid                 
                    if(angular.isFunction($scope.afterGridFunction)){
                        $scope.afterGridFunction();
                    }
                 }

                if (nextCell) {

                    endEdit(true);

                    var result;

                    if (nextCell.rowIndex != $scope.dataset.getCurrentIndex() && !$scope.dataset.isInsertionMode()) {
                        _lockNavigateTab = true;
                        
                        $scope.dataset.gotoRow(nextCell.rowIndex).then(function(){
                            _lockNavigateTab = false;
                        }, function(){
                            _lockNavigateTab = false;
                        });

                        //Caso esteja editando a responsabilidade de posicionar em nova linha é do evento current line changed
                        if($scope.dataset.isRecordDirty() && previousCell){
                            _self.lastFocusedCell = nextCell.column;
                        }
                    }
                    
                    if($scope.enterAsTab || $scope.gridOptions.keyPressed == _keymap.TAB){
	                    $timeout(() => {
	                        startEdit(nextCell.column.colId, nextCell.rowIndex);
	                    });
                    }

                    result = {
                        rowIndex: nextCell.rowIndex,
                        column: nextCell.column,
                        floating: false//nextCell.floating
                    }
                    return result;
                } else if ($scope.newRowOnTab == true && (isLastRecord() || ( $scope.dataset.isInsertionMode() && $scope.enableInsertion ))) {                    
                    
                    let  autoSaveState = $scope.dataset.isConditionalAutoSave();
                    $scope.dataset.setConditionalAutoSave(false);
                    
                    $scope.dataset.goToInsertionMode().then(function () {
                        _selectNodes = [];
                        setNextFocusCell();
                        $scope.dataset.setConditionalAutoSave(autoSaveState);
                        positionOnInsertItem();                      

                    }, () => $scope.dataset.setConditionalAutoSave(autoSaveState));
                }
            };
            
            
            function positionOnInsertItem(){
                $timeout(() => {
                    let firstCol = getFirstColumn();
                    if(firstCol){
                        $scope.gridOptions.api.ensureColumnVisible(firstCol.colId);
                        let selectedNodes = $scope.gridOptions.api.getSelectedNodes();

                        if(selectedNodes.length > 0){
                            if(selectedNodes.length > 1 && $scope.dataset.isCopyingRecord() && isInsertionOnGrid()){
                                selectNodeByIndex(selectedNodes[selectedNodes.length - 1].rowIndex, true);
                                $scope.gridOptions.api.setFocusedCell(selectedNodes[selectedNodes.length - 1].rowIndex, firstCol.colId);
                            }else{
                                $scope.gridOptions.api.setFocusedCell(selectedNodes[0].rowIndex, firstCol.colId);
                            }
                        }
                    }
                });
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para a coleção de colunas do Datagrid. <br/>
             *  OBS1: Serão retornadas as colunas de agrupamento, checkbox, metadados do Datagrid e a coluna em branco. <br/>
             *  OBS2: Qualquer alteração realizada nas colunas refletirá no Datagrid por tratar-se de uma referência. <br/>
             *    Recomenda-se fazer uma cópia da lista retornada e trabalhar em cima da cópia.
             * @example var columnDefsCollection = datagridController.getColumnDefs();
             */
            function getColumnDefs() {
                return $scope.columnDefs;
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#setColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Seta o columnsDef do scope do datagrid para um novo array de columnsDefs. <br/>
             *  OBS: Deve ser um array de ColumnsDef
             * @example datagridController.setColumnDefs(updatedColumnDefs);
             */
            function setColumnDefs(colDefs){
                $scope.columnDefs = colDefs;
            }

            function updateGridConfigName(gridConfigName) {
                $scope.gridconfig = gridConfigName;

                //Registra o controlador da grade para o gridconfig informado, caso ele exista
                if ($scope.gridconfig) {
                    GridConfig.registerTargetGridController($scope.gridconfig, _self);
                }
            };

            function openGridConfig(options) {
                if ($scope.gridconfig) {
                    GridConfig.openGridconfig($scope.gridconfig, options);
                }
            };

            function startTour(tourVersion) {
                if (!$scope.tour) {
                    $scope.tour = DatagridAggridTourContent.getTourContent(_self, tourVersion);
                }

                $scope.tour.startTour = true;
            };

            function setCompactMode(isCompact, force) {
                if (force || !UserAgentUtils.isMobile()) {
                    $scope.compactMode = isCompact || false;
                    purgeServerSideCache();
                    if ($scope.gridOptions && $scope.gridOptions.api) {
                        $scope.gridOptions.api.checkGridSize();
                    }
                }
                _editorsByCols = {};
            };

            function getGridApi() {
                return $scope.gridOptions.api;
            };

            function addCustomColumnMD(customColumnMD) {
                _customColumnsMD[customColumnMD.fieldName] = customColumnMD;

                if (_onlyCustomColumns) {
                    customColumnMD.order = _onlyCustomOrder++;
                }
            };

            function columnResized(param) {
                if (param.finished === true && param.source === 'uiColumnDragged') {
                    var col = param.columns[0];
                    var newWidth = col.actualWidth;
                    if ($scope.gridconfig) {
                        GridConfig.updateColumnWidth($scope.gridconfig, col.colId, undefined, newWidth);
                    } else if (angular.isDefined($scope.columnDefs)) {
                        for (var i = 0, len = $scope.columnDefs.length; i < len; i++) {
                            var columnDef = $scope.columnDefs[i];
                            if (columnDef.skName === col.colId) {
                                columnDef.width = newWidth;
                                break;
                            }
                        }
                    }
                }
            };

            function columnMoved(param) {
                if (param.source != 'uiColumnDragged') {
                    return;
                }
                _lastColumnMoved = {
                    colId: param.column.colId,
                    newIndex: hasCbxColumn() ? param.toIndex - 1 : param.toIndex
                };
            };

            function dragStopped(param) {
            	
            	if($scope.gridOptions && $scope.gridOptions.api){
                    $scope.gridOptions.api.redrawRows();
                }
            	
                if (_lastColumnMoved) {
                    GridConfig.updateColumnOrder($scope.gridconfig, _lastColumnMoved.newIndex, _lastColumnMoved.colId);
                    _lastColumnMoved = undefined;
                }
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getDataset
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para o Dataset no qual o Datagrid está baseado.<br/>
             * @example var dataset = datagridController.getDataset();
             */
            function getDataset() {
                return $scope.dataset;
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getOriginalColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para a coleção de colunas originais do Datagrid, vindas do Dataset. <br/>
             *  OBS: Alterações de posicionamento e redimensionamento de colunas não serão vistas na coleção retornada. Para isso
             *  utilize o método <i>getColumnDefs()</i>
             * @example var originalColumnDefsCollection = datagridController.getOriginalColumnDefs();
             */
            function getOriginalColumnDefs() {
                return _originalColumnDefs;
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para a coleção de registros apresentados no Datagrid no momento da chamada da função.<br/>
             * @example var recordsCollection = datagridController.getRecords();
             */
            function getRecords() {
                return $scope.dataset.getRecords();
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getScopeId
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna o ID do escopo do controlador, criado pela diretiva.<br/>
             * @example var datagridScopeID = datagridController.getScopeId();
             */
            function getScopeId() {
                return $scope.$id;
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getSelectedRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna todos os registros(linhas) selecionadas no sk-datagrid no momento.
             * @return {array} Array de recordes
             * @example <pre>datagridController.getSelectedRecords();</pre>
             */
            function getSelectedRecords() {
                if ($scope.gridOptions && $scope.gridOptions.api && $scope.gridOptions.api.getSelectedNodes()) {
                    return $scope.gridOptions.api.getSelectedNodes().map(node => node.data);
                }
                return [];
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getVisibleColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma lista (cópia) apenas com os metadados visíveis na grade no momento da chamada da função. <br/>
             *  OBS: As colunas de agrupamento, checkbox e a coluna em branco não são retornadas.
             * @example var visibleColumnDefsCollection = datagridController.getVisibleColumnDefs();
             */
            function getVisibleColumnDefs() {
                if ($scope.gridOptions && $scope.gridOptions.api) {
                    var result = [];
                    var allColumns = $scope.gridOptions.api.columnController.columnApi.getAllGridColumns();
                    for (var i = 0; i < allColumns.length; i++) {
                        var col = $scope.gridOptions.columnApi.getColumn(allColumns[i].colId);
                        if (col.visible && !isGroupCol(col)) {
                        	col.colDef.width = col.actualWidth;
                            result.push(ObjectUtils.clone(col.colDef));
                        }
                    }
                    return result;
                } else {
                    return [];
                }
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#isEditable
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Informa se a grade é editável ou não
             * @return {object} True caso a grade seja editável, false do contrário
             * @example <pre>datagridController.isEditable();</pre>
             */
            function isEditable() {
                return $scope.editable;
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#refreshCells
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Função que solicita o update das celulas do grid.<br/>
             *  Usado quando o valor é modificado programaticamente dentro da lista.<br/>
             * @example datagridController.refreshCells();
             */
            function refreshCells() {
                purgeServerSideCache();
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#selectedAllRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Seleciona todas as linhas da grade
             * @example <pre>datagridController.selectedAllRecords();</pre>
             */
            function selectAllRecords() {
                selectAllRows(true);
            };


            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#unselectAllSelectedRows
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Deseleciona todas as linhas selecionadas no sk-datagrid no momento.
             * @example <pre>datagridController.unselectAllSelectedRows();</pre>
             */
            function unselectAllSelectedRows() {
                unselectAll();
            };

            function pinColumn(fieldName, saveOnConfig, position) {
                $scope.gridOptions.columnApi.setColumnPinned(fieldName, position ? position : 'left');
                if ($scope.gridconfig && saveOnConfig) {
                    GridConfig.togglePinColumn($scope.gridconfig, fieldName, true, position);
                }
                if($scope.columnDefs.length > 0){
                    $scope.gridOptions.api.ensureColumnVisible($scope.columnDefs[0].field);
                }
            };

            function unpinColumn(fieldName, saveOnConfig) {
                $scope.gridOptions.columnApi.setColumnPinned(fieldName, null);
                if ($scope.gridconfig && saveOnConfig) {
                    GridConfig.togglePinColumn($scope.gridconfig, fieldName, false);
                }
            };

            function getGridOptions() {
                endEdit(true);
                return $scope.gridOptions;
            };

            function buildEditComponentsTemplate(col) {

                if (angular.isFunction(col.colDef.buildOptionsFn)) {
                    var actualRow = $scope.dataset ? $scope.dataset.getCurrentRowAsObject() : undefined;
                    col.colDef.skOptions = col.colDef.buildOptionsFn(actualRow);
                    col.colDef.options = col.colDef.skOptions;
                    col.colDef.valueFormatter = optionsUserCellFormatter;
                    col.colDef.skAllowNull = false;
                }

                var inputInfo = FormService.getInputInfo(FormService.getUserType(col.colDef), col.colDef.isCheckbox, col.colDef.presentationType,
                    col.colDef.skOptions, col.colDef.size);

                col.colDef.inputName = inputInfo.inputName;
                
                //Adiciona listeners de eventos na api do ag-grid (ver eventos em https://www.ag-grid.com/javascript-grid-events/)
                col.colDef.eventListeners = [];
                col.colDef.addEventListener = function(name, action) {
                    var index = col.colDef.eventListeners.findIndex(function(prop) { return prop.name === name});
                    if(index != -1) {
                        col.colDef.eventListeners[index] = {name: name, action: action};
                    } else {
                        col.colDef.eventListeners.push({name: name, action: action});
                    }
                }

                //Adiciona atributos no elemento de input que será renderizado na celula
                col.colDef.customProperties = [];
                col.colDef.addCustomProperty = function(name, value) {
                    var index = col.colDef.customProperties.findIndex(function(prop) { return prop.name === name});
                    if(index != -1) {
                        col.colDef.customProperties[index] = {name: name, value: value};
                    } else {
                        col.colDef.customProperties.push({name: name, value: value});
                    }
                }

                //Chama o interceptor de item editor, caso haja
                if ($scope.datagridInterceptor && angular.isFunction($scope.datagridInterceptor.interceptItemEditor)) {
                    $scope.datagridInterceptor.interceptItemEditor(col.colDef, $scope.dataset);
                }

                var gridApi = getGridApi();
                
                if(angular.isArray(col.colDef.eventListeners)){
                    col.colDef.eventListeners.forEach(function(event) {
                        var actions = getGridAsyncListners(gridApi).get(event.name);
                        
                        var func = function(e) {
                            if(e.colDef && e.colDef.skName === col.colDef.skName) {
                                if(event.action && angular.isFunction(event.action)) {
                                    event.action(event);
                                }
                            }
                        };

                        if(angular.isDefined(actions)) {
                            if(angular.isArray(actions)) {
                                actions.push(func)
                            } else {
                                actions.add(func);
                            }
                        } else {
                            actions = [];
                            actions.push(func);
                        }

                        getGridAsyncListners(gridApi).set(event.name, actions);
                    });
                }

                var gridcolumn = $scope.gridOptions.columnApi.getColumn(col.colDef.field);

                var editorHeight = getRowHeight();

                var precision = "";

                if (angular.isFunction(col.colDef.skPrecision)) {
                    precision = col.colDef.skPrecision();
                } else {
                    precision = col.colDef.skPrecision;
                }
                
                var ignoreRmPrecision = col.colDef.customProperties.filter(prop => {
					return prop.name == "sk-ignore-rm-precision" && prop.value == true;
				}).length > 0;
                
                // Colunas sem definicao completa ficam de fora desta regra, para nao interromper a montagem do editor
                if($scope.dataset && col.colDef && !ignoreRmPrecision){
                    let metaDatakey = $scope.dataset.getRowMetadataProperty(col.colDef.field, "rm_precision");
                    if (metaDatakey != undefined) {
                        if($scope.dataset.getRowMetadata(undefined, metaDatakey) != undefined){
                              precision = $scope.dataset.getRowMetadata(undefined, metaDatakey);
                              // As casas decimais desta coluna mudam conforme a linha; o editor nao pode ser reaproveitado, senao a configuracao da primeira linha editada valeria para todas as outras
							  col.colDef.editorCachable = false;    
                        }
                    }
                }

                var template = '<div>' +
                    '<form name="inputForm" style="width: ' + (gridcolumn.actualWidth - 3) + 'px; height: ' + editorHeight + 'px;"';

                if ($scope.compactMode) {
                    template += 'class="aggrid-editor aggrid-editor-compact-mode" ';
                }
                else {
                    template += 'class="aggrid-editor aggrid-editor-confortable-mode" ';
                }

                var targetField = ObjectUtils.getProperty(col, 'colDef.fk.targetField');

                if (angular.isFunction(col.colDef.buildOptionsFn)) {
                    var actualRow = $scope.dataset ? $scope.dataset.getCurrentRowAsObject() : undefined;
                    col.colDef.skOptions = col.colDef.buildOptionsFn(actualRow);
                }

                var fieldMd = $scope.dataset.getFieldMetadata(col.colDef.field);

                var useGridEditor = 'sk-switch,sk-combobox,'.indexOf(col.colDef.inputName) > -1;

                var customAttributes = "";

                col.colDef.customProperties.forEach(function(property) {
                    if(angular.isFunction(property.value)) {
                        var index = col.colDef.customProperties.indexOf(property);

                        var fstr = property.value.toString();
                        var atributeNames = fstr.match(/\(.*?\)/)[0].replace(/[()]/gi,'').replace(/\s/gi,'');

                        customAttributes += property.name + '="col.colDef.customProperties[' + index + '].value(' + atributeNames + ')" ';
                    } else {
                        customAttributes += property.name + '="' + property.value + '" ';
                    }
                });

                template += '>' +
                    '<' + col.colDef.inputName +
                    ' class="' + "sk-grid-editor " + col.colDef.skClass + '" ' +
                    ' ng-class="\'colt\' + col.uid" ' +
                    (col.colDef.inputName=='sk-text-input'?'sk-drop-enabled=true sk-drag-drop=col.doDragDrop() ':'')+
                    ('sk-datagrid-editor="' + useGridEditor + '"'  )+
                    'sk-dataset="dataset"' +
                    'sk-field-index="' + col.colDef.skFieldMdIndex + '" ' +
                    'sk-append-to-body="true" ' +
                    'sk-align="' + col.colDef.cellTextAlignment + '" ' +
                    'sk-options="col.colDef.skOptions"' +
                    //No caso do sk-select-distinct-input ele sempre irá buscar a entity name do dataset
                    (col.colDef.inputName != "sk-select-distinct-input" ? ('sk-entity-name="' + (angular.isDefined(col.colDef.fk) ? (col.colDef.fk.relationShipName || col.colDef.fk.entity) : "") + '" ') : "") +
                    'sk-size="' + col.colDef.size + '" ' +
                    'sk-data-type="col.colDef.dataType"' +
                    'sk-precision="' + precision + '" ' +
                    'sk-pretty-precision="col.colDef.skPrettyPrecision"' +
                     (col.focusOut ? 'sk-focus-out="col.focusOut()"' : '')+
                    'sk-mask="' + col.colDef.skMask + '"' +
                    'sk-allow-null="' + col.colDef.skAllowNull + '"' +
                    (targetField ? 'sk-target-field="' + targetField + '"' : '') +
                    'sk-dependent-fields="col.colDef.fk.dependentFields"' +
                    'sk-enviroment-criteria="col.colDef.enviromentCriteria()"' +
                    'sk-include-mask="col.colDef.skIncludeMask"' +
                    ((col.colDef.inputName == 'sk-combobox' && fieldMd) ? 'sk-required="' + fieldMd.required + '"' : '') +
                    (col.colDef.skPassword ? 'sk-password' : '' ) +
                    (col.colDef.formCriteria ? 'sk-form-criteria="' + col.colDef.formCriteria + '"' : '') +
                    customAttributes +
                    ' aggrid>' +
                    '</' + col.colDef.inputName + '>' +
                    '</form>' +
                    '</div>';


                return template;
            };

            function getMainMenuItems(param) {
                endEdit(true);
                var col = param.column;
                let isGroup = isGroupCol(col);

                var menuItems = [];
                
                if(!isGroup){
	                if(!$scope.disableSorting){
	                    menuItems.push({
	                        name: i18n('DataGrid.ordenarAsc'),
	                        action: function () {
	                            setOrderColumn(param.column.colDef.field, 'asc');
	                        },
	                        icon: '<i class="glyphicons glyphicons-sort-by-attributes"></i>'
	                    },
	                    {
	                        name: i18n('DataGrid.ordenarDesc'),
	                        action: function () {
	                            setOrderColumn(param.column.colDef.field, 'desc');
	                        },
	                        icon: '<i class="glyphicons glyphicons-sort-by-attributes-alt"></i>'
	                    });
	                }
	                menuItems.push(                  
	                    {
	                        name: i18n('DataGrid.filtrar'),
	                        action: function () { openFilterModal(param.column) },
	                        icon: '<i class="' + ICON_FILTER + '"></i>'
	                    }                    
	                );
	
	                if(!colsAggregate.hasOwnProperty(col.colId) || !_pivotMode){
	                    menuItems.push(
	                        {
	                            name: _columnsGrouped.indexOf(col.colDef.field) > -1 ? i18n('DataGrid.desagrupar') : i18n('DataGrid.agrupar'),
	                            action: buildFnGroupColumn(col),
	                            icon: '<i class="ui-grid-icon-indent-right"></i>'
	                        }
	                    );
	                }
	
	                if (_allowGridConfiguration) {
		                if (col.pinned) {
		                    menuItems.push(
		                        {
		                            name: i18n('DataGrid.desafixarCol'),
		                            action: buildFnPinColumn(col, 'left'),
		                            icon: '<i class="ui-grid-icon-cancel"></i>'
		                        }
		                        /*
		                        //Cancelamos a opção de fixar a direita pois em algumas situações o aggrid se comporta de forma errada
		                        //quando existem poucas columas na grade fica um espaço em branco entre a coluna fixada e a ultima coluna                        ,
		                        {
		                            name: col.pinned == 'left' ? 'Fixar a Direita' : 'Fixar a Exquerda',
		                            action: buildFnPinColumn(col, col.pinned == 'left' ? 'right' : 'left', true),
		                            icon: col.pinned == 'left' ? '<i class="glyphicons glyphicons-chevron-right"></i>' : '<i class="glyphicons glyphicons-chevron-left"></i>'
		                        }*/
		                    );
		                } else {
		                    menuItems.push(
		                        {
		                            name: i18n('DataGrid.fixarCol'),
		                            action: buildFnPinColumn(col, 'left'),
		                            icon: '<i class="glyphicons glyphicons-chevron-left"></i>'
		                            /*                            
		                            //Cancelamos a opção de fixar a direita pois em algumas situações o aggrid se comporta de forma errada
		                            //quando existem poucas columas na grade fica um espaço em branco entre a coluna fixada e a ultima coluna
		                            
		                            name: i18n('DataGrid.fixarCol'),
		                            icon: '<i class="glyphicons glyphicons-pushpin"></i>',
		                            subMenu: [
		                                {
		                                    name: i18n('DataGrid.direita'),
		                                    action: buildFnPinColumn(col, 'right'),
		                                    icon: '<i class="glyphicons glyphicons-chevron-right"></i>'
		                                },
		                                {
		                                    name: i18n('DataGrid.esquerda'),
		                                    action: buildFnPinColumn(col, 'left'),
		                                    icon: '<i class="glyphicons glyphicons-chevron-left"></i>'
		                                }
		                            ]*/
		                        }
		                    );
		                }
	                }
                }else{
                  menuItems.push({
                      name: i18n('DataGrid.desagrupar'),
                      action: function () {
                          $scope.gridOptions.columnApi.setRowGroupColumns(null);
                          _columnsGrouped.length = 0;
                          getNavigatorInstanceOfDataset().setDataGridMode(false, _self);
                          if ($scope.gridconfig) {
                              GridConfig.loadConfigurations($scope.gridconfig);
                          }
                      },
                      icon: '<i class="ui-grid-icon-indent-right"></i>'
                  });
                }

                $timeout(positionPopUpColumnOptions);

                return menuItems;
            };
            
            function positionPopUpColumnOptions(){
                let popupElement = $document.find('.ag-menu.ag-ltr');                
                let positionOfGrid;

                if($element[0]){
                    positionOfGrid = $element[0].getBoundingClientRect();
                }

                if(popupElement && positionOfGrid){
                    let tabHeader = popupElement.find('.ag-tab-header');
                    let tabBody = popupElement.find('.ag-tab-body');

                    let elemOffset = popupElement[0].getBoundingClientRect();

                    if(tabHeader){
                       tabHeader.css('display', 'flex');
                       tabHeader.css('direction', 'ltr');
                    }
                    if(tabBody){
                        tabBody.css('display', 'block');
                    }

					let top = positionOfGrid.top;

                    if($window.scrollY > 0){
                        top = top + $window.scrollY;
                    }
                    
                    popupElement.css('top', (top + 'px') );

                    // Ajuste do popup de opções para que nao corte quando o tamanho do popup é maior que a tela
                    if (elemOffset.left + popupElement[0].clientWidth > positionOfGrid.width){
                        let selectedTab = popupElement.find('.ag-tab-selected'); 
                        let selectedTabOffset = selectedTab[0].getBoundingClientRect();

                        let recover = selectedTabOffset.left + selectedTabOffset.width - popupElement[0].clientWidth - 14;

                        // altera a direção do icone e seta o left de acordo com o icone da tab antes mesmo de alterar o lado.
                        tabHeader.css('direction', 'rtl');
                        popupElement.css('left', (recover + 'px'));  
                    }
                }
            }

            function buildFnPinColumn(col, position, forcePin) {
                var fn = function () {
                    if (col.pinned == null || forcePin) {
                        pinColumn(col.colDef.field, true, position);
                    } else {
                        unpinColumn(col.colDef.field, true);
                    }
                }

                return fn;
            };

            function buildFnGroupColumn(col) {
                var fn = function () {
                    setGroupColumn(col.colDef.field);
                }
                return fn;
            };

            function openFilterModal(column) {
                var textoVazio = i18n('DataGrid.empty');
                
                if (!angular.isDefined(column.distinctData) || hasDistinctChanged(column, $scope.dataset.getRecordsList().getListVersion())) {
                    if(!distinctDataColumns.hasOwnProperty(column.colId)) distinctDataColumns.push(column.colId);
                    column.filterVersion = $scope.dataset.getRecordsList().getListVersion();
                    column.distinctData = {};
                    var mapDescriptions = {};
                    var originalRecords = $scope.dataset.getOriginalRecords();

                    //Aplicamos os filtros de todas as colunas filtradas anteriormente a que estamos filtrando atualmente.
                    let fiteredCols = Object.keys($scope.filterByColumn);
                    let length = fiteredCols.indexOf(column.colId);
                
                    if(length == -1) {
                        for(let filter in $scope.filterByColumn){
                            let gridCol = $scope.gridOptions.columnApi.getColumn(filter);
                            if(gridCol) originalRecords = originalRecords.filter(getFilterFunction('i', gridCol, true)); 
                        }
                    }else{
                        for(i = 0 ; i < length; i++){
                            let gridCol = $scope.gridOptions.columnApi.getColumn(fiteredCols[i]);
                            if(gridCol) originalRecords = originalRecords.filter(getFilterFunction('i', gridCol, true)); 
                        }
                    }

                    var allRecords = $scope.dataset.getRecords();

                    for (var i = 0; i < originalRecords.length; i++) {
                        var originalRecord = originalRecords[i];
                        var data = '';

                        if ((originalRecord[column.colDef.skFieldMdIndex] === '' || originalRecord[column.colDef.skFieldMdIndex] == undefined) 
                            && !angular.isFunction(column.colDef.valueFormatter)) {
                            data = textoVazio;
                        } else {
                            data = angular.isFunction(column.colDef.valueFormatter) 
                                ? column.colDef.valueFormatter({ 
                                    value: originalRecord[column.colDef.skFieldMdIndex], 
                                    data: originalRecord[originalRecord.length - 1], 
                                    colDef: column.colDef, 
                                    column: column, 
                                    api: $scope.gridOptions.api, 
                                    columnApi: $scope.gridOptions.columnApi, 
                                    context: this, 
                                    isFilter: true
                                }) : originalRecord[column.colDef.skFieldMdIndex];
                            data = angular.isUndefined(StringUtils.emptyAsNull(data)) ? textoVazio : data;

                            if(column.colDef.cellRenderer === 'skDashboardCellRenderer'){
                                 mapDescriptions[data] = originalRecord[column.colDef.skFieldMdIndex];
                           	}else { 
                              if (column.colDef.skFieldType !== 'F' && column.colDef.skFieldType !== 'I' && column.colDef.type !== 'number') {
                                 mapDescriptions[data] = originalRecord[column.colDef.skFieldMdIndex];
                              }
                           }
                        }

                        var found = column.distinctData.hasOwnProperty(data);
                        if (!found && (angular.isDefined(data) && data != 'undefined' && (data.toString().trim().length > 0 || data == ' ')	)) {
                            column.distinctData[data] = true;

                            if (!$scope.dataset.existsFilterFunction()) {
                                column.distinctData[data] = true;
                            }
                            else {
                                var breaked = false;
                                if (allRecords) {
                                    for (var j = 0; j < allRecords.length; j++) {
                                        var actualValue = angular.isFunction(column.colDef.valueFormatter) 
                                            ? column.colDef.valueFormatter({ 
                                                value: allRecords[j][column.colDef.skFieldMdIndex], 
                                                data: allRecords[j][allRecords[j].length - 1], 
                                                colDef: column.colDef, 
                                                column: column, 
                                                api: $scope.gridOptions.api, 
                                                columnApi: $scope.gridOptions.columnApi, 
                                                context: this 
                                            }) : allRecords[j][column.colDef.skFieldMdIndex];
                                        if((column.colDef.skFieldType == 'LP' || column.colDef.skFieldType == 'L')&& ( actualValue.indexOf('fill="'+data+'"')!=-1)){
                                            column.distinctData[data] = true;
                                            breaked = true;
                                            break;
                                        }else if ((actualValue == data || (mapDescriptions && actualValue == mapDescriptions[data])) && StringUtils.isNotEmpty(data)) {
                                            column.distinctData[data] = true;
                                            breaked = true;
                                            break;
                                        }
                                        else if (data == textoVazio && (actualValue == undefined || actualValue == '')) {
                                            column.distinctData[textoVazio] = true;
                                            breaked = true;
                                            break;
                                        }
                                    }
                                }
                                if (!breaked) {
                                    column.distinctData[data] = false;
                                }
                            }
                        }
                    }

                    if (Object.keys(mapDescriptions).length > 0) {
                        column.mapDescriptions = mapDescriptions;
                    }
                }

                column.sortFn = getSortFn(column);

                $scope.onSuccessFilterModal = function () {
                    $scope.filterModal.success();
                }

                //Prepara as variaveis de texto a serem passadas para o popup
                var filterForColumnText = i18n('DataGrid.filtroParaCol');
                var applyText = i18n('Geral.lblAplicar');
                var cancelText = i18n('Geral.lblCancelar');
                var clearText = i18n('Geral.lblLimpar');
                var type = (column.colDef.type || column.colDef.skType);   
                var size = _enableFilterDatePeriod == true && (type == 'date' || type == 'datetime') ? 'sm' : 'md';
                $timeout(function () {
                    $scope.filterModal = SanPopup.open({
                        scope: $scope,
                        title: filterForColumnText + ' \"' + column.colDef.skDescription + '\"',
                        templateUrl: 'components/datagrid/filtermodal/filtermodal.tpl.html',
                        controller: 'FilterModalController',
                        type: 'default',
                        okBtnLabel: clearText,
                        okBtnClass: 'btn-default',
                        noBtnClass: 'btn-primary',
                        noBtnLabel: applyText,
                        cancelBtnLabel: cancelText,
                        showBtnCancel: true,
                        windowClass: 'datagrid-modal-window',
                        cancelBtnClass: 'btn-default',
                        bodyPadding: false,
                        showBtnNo: true,
                        scrollContainer: false,
                        size: size,
                        resolve: {
                            column: function () {
                                return column;
                            },
                            dataset: function () {
                                return $scope.dataset;
                            },
                            gridController: function () {
                                return _self;
                            },
                            data: {
                                enableFilterDatePeriod: _enableFilterDatePeriod == true
                            }
                        }
                    });
                }, 10)
            };

            function hasDistinctChanged(actualCol, currentVersion){
                let length = distinctDataColumns.indexOf(actualCol.colId);
                
                if(length == -1) return false;

                for(i = 0 ; i <= length; i++){
                    let col = $scope.gridOptions.columnApi.getColumn(actualCol.colId);
                    if(col && col.filterVersion != currentVersion){
                        return true;
                    }
                }

                return false;
            }

            function getCurrentColIndexByColumnDef(columnDef) {
                return _originalColumnDefs.indexOf(columnDef);
            };

            function getCurrentColByFieldName(fieldName){

                for(var index in _originalColumnDefs){
                    if(_originalColumnDefs[index].field == fieldName){
                        return _originalColumnDefs[index];
                    }
                }

                return [];
            }

            function getFilterFunction(regexpFlags, column, especificColumn) {
                var getColumnFromColumnDef = function (columDef) {
                    return ArrayUtils.find($scope.gridOptions.columnApi.getAllGridColumns(), function (col) {
                        return col.colDef.field == columDef.field;
                    });
                };

                var filterFunction = function (value) {
                    //Realiza o filtro baseado nas informações do filtro por coluna ("distinct filter")
                    for (var field in $scope.filterByColumn) {
                        
                        if(especificColumn == true && field != column.colDef.field){
                            continue;
                        }
                        
                        // Recupera o index do valor em questão no metadado
                        let valueIndex = $scope.dataset.getFieldIndexByName(field);

                        if (valueIndex < 0) {
                            continue;
                        }

                        let colDef = getCurrentColByFieldName(field);

                        if (Array.isArray(colDef) && colDef.length == 0) {
                            continue;
                        }

                        let containsRE;
                        let columnValue;
                        let columnsValues = StringUtils.replaceAccentuatedChars($scope.filterByColumn[field]);

                        containsRE = new RegExp(columnsValues, regexpFlags);

                        columnValue = StringUtils.replaceAccentuatedChars(angular.isFunction(colDef.valueFormatter) 
                                ? colDef.valueFormatter({ colDef: colDef, value: value[valueIndex], data: value[value.length - 1] }) 
                                : value[valueIndex]);

                        if (!containsRE.test(StringUtils.replaceAccentuatedChars(columnValue))) {
                            return false;
                        }
                    }

                    //Realiza o filtro baseado nas informações de pesquisa nas colunas (texto digitado)
                    for (var field in $scope.searchByColumn) {

                        if (!field) {
                            continue;
                        }

                        if (StringUtils.isEmpty($scope.searchByColumn[field])) {
                            continue;
                        }

                        // Recupera o index do valor em questão no metadado
                        let valueIndex = $scope.dataset.getFieldIndexByName(field);

                        if (valueIndex < 0) {
                            continue;
                        }

                        let colDef = getCurrentColByFieldName(field);

                        if (Array.isArray(colDef) && colDef.length == 0) {
                            continue;
                        }

                        let containsRE;

                        let textTerm = $scope.searchByColumn[field].replace(/[!@#\$%\^\&*\)\(+=._-]+/gi, function (v) {
                            return '\\' + v;
                        });

                        containsRE = new RegExp(StringUtils.replaceAccentuatedChars(textTerm), regexpFlags);

                        let columnValue = StringUtils.replaceAccentuatedChars(angular.isFunction(colDef.valueFormatter) 
                            ? colDef.valueFormatter({ colDef: colDef, value: value[valueIndex], data: value[value.length - 1] }) 
                            : value[valueIndex]);

                        if (!containsRE.test(columnValue)) {
                            return false;
                        }
                    }
                    return true;
                };

                return filterFunction;
            };

            function setFilterByColumn(columnIndex, term, columnId, column) {
                $scope.filterByColumn[columnId] = term;
                $scope.filterColumnInfo[columnId] = column;
                addIconInCol(columnId, ICON_FILTER);
            };

            function getFilterByColumn(columnId) {
                return $scope.filterByColumn[columnId];
            };

            function getFilterInfoColumn() {
                return $scope.filterColumnInfo;
            };

            function removeFilterByColumn(column, columnId) {
                delete $scope.filterByColumn[columnId];
                delete $scope.filterColumnInfo[columnId];
                removeIconInCol(columnId);
            };

            function removeSearchByColumn(columnId) {
                delete $scope.searchByColumn[columnId];
                if (!$scope.filterByColumn.hasOwnProperty(columnId)) {
                    removeIconInCol(columnId);
                }
            }

            function getNavigatorInstanceOfDataset() {
                if ($scope.dataset) {
                    elList = document.getElementsByTagName("sk-navigator");
                    for (var i = 0; i < elList.length; i++) {
                        var ds = angular.element(elList[i]).controller('skNavigator').getDataset();
                        if (ds && ds.getDatasetId() == $scope.dataset.getDatasetId()) {
                            return angular.element(elList[i]).controller('skNavigator');
                        }
                    }
                }
                return undefined;
            };

            function previousRow() {
                navigateNextRow('previous');
            }

            function nextRow() {
                navigateNextRow('next');
            }

            function navigateNextRow(direction, index) {
                var selectedNodes = $scope.gridOptions.api.getSelectedNodes();
                var newIndex = (index || (selectedNodes.length > 0 && selectedNodes[0].rowIndex) || 0) + (direction == 'next' ? 1 : -1);
                $scope.gridOptions.api.forEachNode(function (node) {
                    if (node.rowIndex == newIndex) {
                        if ((node.group && ((direction == 'previous' && !isFristRow(node) || (direction == 'next' && !isLastRow(node))))) || (node.group && !node.expanded)) {
                            //Precisamos tratar caso a navegação esteja voltando e o nó não esteja expandido, nesse caso expandimos o nó e
                            //posicionamos a grid no indice na ultima linha daquele agrupamento
                            if (direction == 'previous') {
                                var expanded = node.expanded;
                                node.setExpanded(true);
                                $timeout(function () {
                                    var newNode;
                                    //Caso o no nao esteja expandido temos que pegar a ultima linha do no que acabou de ser expandido
                                    if (!expanded) {
                                        newNode = $scope.gridOptions.api.getDisplayedRowAtIndex(newIndex + _lengthByGroups[node.key]);
                                    }
                                    if (newNode && !newNode.group) {
                                        loadGridByIndex(newNode.rowIndex);
                                        $timeout(function () {
                                            newNode.setSelected(true, true);
                                            onRowClicked(undefined, true);
                                        });
                                    } else if (newNode && newNode.level > 0) {
                                        node.setExpanded(true);
                                        $timeout(function () {
                                            navigateNextRow('next', newIndex);
                                        })
                                    } else {
                                        navigateNextRow(direction, newIndex);
                                        return;
                                    }
                                }, 5)
                            } else {
                                if (!node.expanded) {
                                    node.setExpanded(true);
                                }
                                var indexToLoad = angular.copy(newIndex);
                                loadGridByIndex(++indexToLoad);
                                $timeout(function () {
                                    navigateNextRow(direction, newIndex);
                                }, 5)
                                return;
                            }
                        } else {
                            node.setSelected(true, true);
                            onRowClicked(undefined, true);
                        }
                    }
                });
            }

            function isFristRow(node) {
                return node.rowIndex == 0;
            };

            function isLastRow(node) {
                return node.rowIndex == $scope.gridOptions.api.getLastDisplayedRow();
            };

            function hasPrevious() {
                return true;
            };

            function hasNext() {
                return true;
            };

            function getContextMenuItems(params) {
                return isEnableCharts() ? ['chartRange'] : [];
            };

            function loadSuggestions(value) {
                _searchingColumn = true;

                var deferred = $q.defer();

                var suggestions = [];
                var allCols = $scope.gridOptions.columnApi.getAllColumns();
                for (var i = 0; i < allCols.length; i++) {
                    var column = allCols[i];
                    if (column.visible && (value === '' || (StringUtils.isEmpty(value) || StringUtils.replaceAccentuatedChars(column.colDef.skDescription).toLowerCase().indexOf(StringUtils.replaceAccentuatedChars(value).toLowerCase()) > -1))) {
                        var suggestion = {
                            key: column.colId,
                            label: column.colDef.skDescription
                        };
                        suggestions.push(suggestion);
                    }
                }
                suggestions = ArrayUtils.sortByProperty(suggestions, "label", sortAlpha);
                deferred.resolve(suggestions);
                return deferred.promise;
            };

            function onSelectEntity(item) {

                Object.keys(_classByCols).forEach(function (col, i) {
                    _classByCols[col].forEach(function (classObj, j) {
                        if (classObj.clas == 'sk-highlighted-col') {
                            _classByCols[col].splice(j, 1);
                        }
                    })
                })

                $scope.gridOptions.api.refreshHeader();

                $scope.gridOptions.api.ensureColumnVisible(item.key);
                $scope.toggleMenuGrid();
                addClassOfHeaderCol(item.key, 'sk-highlighted-col', '.ag-header-cell-label');
            };

            function virtualColumnsChanged(params) {
                if (Object.keys(_colsOfReset).length > 0) {
                    Object.keys(_colsOfReset).forEach(function(key){
                        _colsOfReset[key].forEach(function(clas){
                            if (clas == 'icon') {
                                removeIconInCol(key);
                            } else {
                                removeClassOfHeaderCol(key, clas);
                            }
                        });
                        delete _colsOfReset[key];
                    });
                }
                
                if (existsColunsPersonalized()) {
                    var allDisplayedCols = $scope.gridOptions.columnApi.getAllDisplayedVirtualColumns();
                    allDisplayedCols.forEach(function (col) {
                        if (_classByCols.hasOwnProperty(col.colId)) {
                            _classByCols[col.colId].forEach(function (clasObj) {
                                addClassOfHeaderCol(col.colId, clasObj.clas, clasObj.chieldSelector);
                            })
                        }
                        if (_iconsByCols.hasOwnProperty(col.colId)) {
                            addIconInCol(col.colId, _iconsByCols[col.colId]);
                        }
                        if ($scope.gridOptions.floatingFilter && $scope.searchByColumn.hasOwnProperty(col.colId)) {
                            document.getElementById('search-of-col-' + col.colId).value = $scope.searchByColumn[col.colId];
                        }
                    });
                }
            };

            function existsColunsPersonalized() {
                return Object.keys(_classByCols).length > 0 || Object.keys(_iconsByCols).length > 0 || Object.keys($scope.searchByColumn).length > 0;
            }

            function addClassOfHeaderCol(colId, clas, chieldSelector) {
                var colElement = angular.element(_gridElem.querySelector('[col-id="' + colId + '"]'));
                if (chieldSelector) {
                    colElement = angular.element(colElement.context.querySelector(chieldSelector));
                }
                colElement.addClass(clas);
                if (!_classByCols.hasOwnProperty(colId)) {
                    _classByCols[colId] = [];
                }
                _classByCols[colId].push({ clas: clas, chieldSelector: chieldSelector });
            };

            function removeClassOfHeaderCol(colId, clas) {
                if(!_gridElem){
                    addColOfReset(colId, clas);
                    delete _classByCols[colId];
                    return;
                }
                var colElement = angular.element(_gridElem.querySelector('[col-id="' + colId + '"]'));
                if(colElement){
                    colElement.removeClass(clas);
                }else{
                    addColOfReset(colId, clas);
                }
                delete _classByCols[colId];
            };

            function addIconInCol(colName, ico) {
                removeIconInCol(colName);
                var colElement = angular.element(_gridElem.querySelector('[col-id="' + colName + '"]'));
                var filterElent = angular.element(colElement.context.querySelector('[ref="skFilter"]'));
                filterElent.append('<i style="color: red" class=" ' + ico + ' "></i>');
                _iconsByCols[colName] = ico;
            };

            function removeIconInCol(colName) {
                var colElement = angular.element(_gridElem.querySelector('[col-id="' + colName + '"]'));
                if(colElement.context){
                    var filterElent = colElement.context.querySelector('[ref="skFilter"]');
                    while (filterElent.firstChild) {
                        filterElent.removeChild(filterElent.firstChild);
                    }
                }else{
                    addColOfReset(colName, 'icon');                    
                }
                delete _iconsByCols[colName];
            };

            function enableSearch() {
                $scope.gridOptions.floatingFilter = true;
                $scope.gridOptions.api.refreshHeader();
                virtualColumnsChanged({});
            };

            function clearSearchOfCols() {
                $scope.gridOptions.floatingFilter = false;
                $scope.gridOptions.api.refreshHeader();

                for (var field in $scope.searchByColumn) {
                    removeFilterByColumn(undefined, field);
                }

                for (var field in $scope.filterByColumn) {
                    removeFilterByColumn(undefined, field);
                }
                $scope.searchByColumn = {};
                $scope.dataset.removeFilter();
                virtualColumnsChanged({});
            };

            function removeAllFilters(){
                $scope.gridOptions.floatingFilter = false;
                $scope.gridOptions.api.refreshHeader();

                for (var field in $scope.searchByColumn) {
                    removeSearchByColumn(field);
                }

                for (var field in $scope.filterByColumn) {
                    removeFilterByColumn(undefined, field);
                }
                
                //Remove distinct data das colunas
                distinctDataColumns.forEach(colId => {
                    let col = $scope.gridOptions.columnApi.getColumn(colId);
                    if(col) delete col.distinctData;
                });
                distinctDataColumns.length = 0;
            }

            function SkFloatingFilter() {
            }

            SkFloatingFilter.prototype.init = function (params) {
                var width = params.column.actualWidth;
                this.onFloatingFilterChanged = params.onFloatingFilterChanged;
                this.eGui = document.createElement('div');
                this.eGui.innerHTML = ('<input id="search-of-col-' + params.column.colId + '" type="text"/>');
                this.currentValue = null;
                this.eFilterInput = this.eGui.querySelector('input');
                this.eFilterInput.style.color = params.color;

                const debouncedFilter = AngularUtil.debounce(function(column, term, evt) {
                    skFilterFunction({ column: column, term: term });

                    // Forçar o focus novamente para o input que chamou o evento
                    $timeout(function () {
                        evt.srcElement.focus();
                    });
                }, 2000);

                function onInputBoxChanged(evt) {
                    endEdit(true);
                    const value = evt.currentTarget.value;
                    const keyCode = evt.keyCode;

                    if(hasPressedEnter(keyCode)){
                        skFilterFunction({ column: params.column, term: value });
                    }

                    if(canTriggerSearch(value) || hasPressedBackspace(keyCode)) {
                        debouncedFilter(params.column, value, evt);
                    }
                }

                this.eFilterInput.addEventListener('keyup', onInputBoxChanged);
            };

            SkFloatingFilter.prototype.onParentModelChanged = function (parentModel) {

            };

            SkFloatingFilter.prototype.getGui = function () {
                return this.eGui;
            };

            function canTriggerSearch(value){
                return value && value.length;
            }

            function hasPressedEnter(keyCode) {
                return keyCode == 13;
            }

            function hasPressedBackspace(keyCode) {
                return keyCode == 8;
            }

            function skFilterFunction(params) {
                var column = params.column;
                var colId = column.colId;
                var term = params.term;
                var regexpFlags = 'i'; //Case insensitive

                if ($scope.searchByColumn.hasOwnProperty(colId) && $scope.searchByColumn[colId] == term) {
                    return;
                }

                endEdit();

                $scope.searchByColumn[colId] = term;

                if (!StringUtils.isEmpty($scope.searchByColumn[colId])) {
                    addIconInCol(colId, ICON_FILTER);
                } else {
                    removeSearchByColumn(colId);
                }

                if (_removeActiveFilterFn) {
                    _removeActiveFilterFn();
                }

                var filterFn = getFilterFunction(regexpFlags, column);

                _removeActiveFilterFn = $scope.dataset.addFilterFunction(filterFn, true);

                $scope.dataset.filterRecords();
            };

            function setBottomData() {
                if (_footerColsAggretaion.length > 0) {
                    var result = {};

                    _footerColsAggretaion.forEach(function (data) {
                        if (data.functionAgg == 'false') {
                            result[data.field] = undefined;
                        } else {
                            var colGrid = $scope.gridOptions.columnApi.getColumn(data.field);
                            if (colGrid.colDef.skVisible) {
                                result[data.field] = getFooterAggregation(data.functionAgg, colGrid.colDef);
                            }
                        }
                    });

                    $scope.gridOptions.api.pinnedRowModel.setPinnedBottomRowData([result]);
                }
            };

            function SkPinnedRowRenderer() {}

            SkPinnedRowRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.setAttribute("style", "font-size: 13px; font-weight: bold;");
                if (angular.isFunction(params.colDef.valueFormatter)) {
                    params.value = params.colDef.valueFormatter(params);
                }
                this.eGui.innerHTML = angular.isDefined(params.value) ? params.value : '';
            };

            SkPinnedRowRenderer.prototype.getGui = function () {
                return this.eGui;
            };

            function getColumnApi() {
                return $scope.gridOptions.columnApi;
            };

            function resetColumnWidths() {
                var allCols = ArrayUtils.toArray($scope.gridOptions.columnApi.getAllColumns());
                
                for (var i = 0; i < allCols.length; i++) {
                    var column = allCols[i];
                    if (column.colDef && column.colDef.headerName) {
                        column.colDef.width = column.width;
                    }
                }
                $scope.gridOptions.api.refreshHeader();
            };

            function updateGridOptions() {
                if ($scope.gridconfig) {
                    var pinnedColumns = GridConfig.getPinnedColumns($scope.gridconfig);

                    if (pinnedColumns && pinnedColumns.length > 0) {
                        pinnedColumns.forEach(function (pinnedColumn) {
                            $scope.gridOptions.api.setColumnPinned(pinnedColumn.field, pinnedColumn.position);
                        });
                    }
                }
            };

            /**
            * @ngdoc
            * @name snk.components.datagrid.directive:sk-datagrid#updateColumnLabels
            * @methodOf snk.components.datagrid.directive:sk-datagrid
            * @description
            *  Atualiza os labels das colunas da grade com base no metadados do dataset.<br/>
            *  Utilize esta função quando os labels das colunas forem alterados no dataset.
            */
            function updateColumnLabels() {
                var fieldsMD = $scope.dataset.getFieldsMetadata();

                for (var i = 0, length = fieldsMD.length; i < length; i++) {
                    for (var j = 0, lenghtj = $scope.columnDefs.length; j < lenghtj; j++) {
                        if (fieldsMD[i].name == $scope.columnDefs[j].skName) {
                            var colDef = $scope.columnDefs[j];
                            var fieldMD = fieldsMD[i];
                            colDef.headerName = fieldMD.description;

                            var isEditable = isFieldMDEditable(fieldMD);

                            colDef.editable = isEditable;
                            break;
                        }
                    }
                }

                $scope.gridOptions.api.refreshHeader();
            };

            function isGroupCol(col) {
                return col.colId == 'ag-Grid-AutoColumn';
            };

            function getOfCountGroup(columm) {
                var cols = $scope.gridOptions.columnApi.getRowGroupColumns();
                cols.forEach(function (col) {
                    if (col.colId == column.colId) {

                    }
                });
            };

            function bodyScroll(params) {
                window.dispatchEvent(_dataGridScrolled);

                if (params.direction == "horizontal") {
                    return
                }
                if (_editorOpenned) {
                    $timeout(function () {
                        $document.scroll();
                        AngularUtil.apply($scope);
                    });
                    
                    if (_self.lastFocusedCell && !_keyIsPressed) {
                        setNextFocusCell(_self.lastFocusedCell.colId);
                    }
                }
            };

            function isAggridEditor(srcElement) {
                if (srcElement) {
                    return srcElement.form ? srcElement.form.classList.contains('aggrid-editor') : false;
                }
                return false;
            };

            function isAggridCell(srcElement) {
                if (srcElement) {
                    return srcElement.classList.contains('ag-cell')
                }
                return false;
            };
			
			function getHeaderRowHeight(){
                let headerHeight = configCell.heightComp + 5;

                if (angular.isDefined($scope.cellStyle)) {
                    let newHeight;

                    if ($scope.cellStyle.hasOwnProperty('font-size')) {
                        /**  Recupera apenas o valor informado */
                        newHeight = parseInt($scope.cellStyle['font-size'], 10);

                        if (newHeight > 20) {
                            return newHeight * 1.4;
                        }
                    }
                }

                return headerHeight;
            }
			
			function getBottomLinesAggregated (defaultSize) { 
                var qtdLines = 1;
                var columns = $scope.gridOptions.api.columnController.allDisplayedColumns;

                columns.forEach(function (column) {
                    var aggregates = column.colDef.skAggregateExpression;
                    if (angular.isDefined(aggregates) && aggregates.length > qtdLines) {
                        qtdLines = aggregates.length;
                    }
                });

                return qtdLines * defaultSize;
            }

            function getRowHeight(params) {
                let isCompactMode = angular.isDefined($scope.compactMode) ? $scope.compactMode : true;
            	let defaultSize = isCompactMode ? configCell.heightComp : configCell.heightConf;

                if (angular.isDefined($scope.cellStyle)) {
                    let newHeight;
                    
                    if ($scope.cellStyle.hasOwnProperty('font-size')) {
                        /**  Recupera apenas o valor informado */
                        newHeight = parseInt($scope.cellStyle['font-size'], 10); 

                        if (newHeight > 20) {
                            /** Calculo para recuperar o height de acordo com as agregações definidas */
                            if (params && params.node && params.node.rowPinned) {
                                newHeight = getBottomLinesAggregated(newHeight);
                            }

                            return newHeight * 1.4;
                        }  
                    }
                }

                if (params && params.node && params.node.rowPinned) {
                    return getBottomLinesAggregated(defaultSize);
                } else {
                    return defaultSize; 
                }
            };

            function selectAllRows(force) {
                if($scope.allowMultipleSelection == false && !force){
                    return;
                }
                _selectAll = true;
                if ($scope.dataset) {
                    $scope.dataset.selectAllRecords();
                }
                selectOrUnselectVisibleNodes(true);

                var selectedRows = $scope.dataset.getSelectedRecords()
                for (var i in selectedRows) {
                    var md = $scope.dataset.getRowMetadata(selectedRows[i]);
                    if (!_checked[md.rowID]) {
                        _checked[md.rowID] = {};
                    }
                    _checked[md.rowID].value = true;
                }
            }

            function unselectAll() {
                _selectAll = false;
                if ($scope.dataset) {
                    $scope.dataset.unselectAll();
                }
                selectOrUnselectVisibleNodes(false);
                unselectRangeRows();
                _checked = [];
            }

            function selectOrUnselectVisibleNodes(select) {
                _selectNodes = ArrayUtils.sortByNumberProperty($scope.gridOptions.api.getSelectedNodes(), 'rowIndex');
                syncSelectOnDataset();
                $timeout(function(){
                    var firstRow = $scope.gridOptions.api.getFirstDisplayedRow();
                    var lastRow = ($scope.gridOptions.api.getLastDisplayedRow() + 1);
                    
                    for (; firstRow <= lastRow; firstRow++) {
                        var node = $scope.gridOptions.api.getDisplayedRowAtIndex(firstRow);
                        if (node) {
                            node.setSelected(select)
                        }
                    }
                    refreshCkbRowSelection();
                }, 500);
            }

            function setOnDblClick(dblClick) {
                $scope.onDblClick = dblClick;
            }

            function setAllowMultipleSelection(value) {
                if (value === undefined) {
                    $scope.allowMultipleSelection = true;
                } else {
                    $scope.allowMultipleSelection = value;
                }
                $scope.gridOptions.rowSelection = $scope.allowMultipleSelection == undefined ? 'multiple' : $scope.allowMultipleSelection == true ? 'multiple' : 'single';
            }

            function addColOfReset(colId, clas){
                if(!_colsOfReset[colId]){
                    _colsOfReset[colId] = [];
                }
                _colsOfReset[colId].push(clas);
            }

            function setSelectedRecords(rowsEntitySet) {
                var f = function () {
                    let selectedRecordsID = [];

                    for (var i = 0; i < rowsEntitySet.length; i++) {
                        var md = $scope.dataset.getRowMetadata(rowsEntitySet[i]);
                        var node = $scope.gridOptions.api.getDisplayedRowAtIndex(md.rowID);
                        if(node){
                            node.setSelected(true);
                        }
                    }

                    let selectedRecordsDs = [];
                    
                    selectedRecordsID.forEach((rowID) => {
                        let record = $scope.dataset.getRecordByUniqueId(rowID)
                        selectedRecordsDs.push(record);
                    });

                    $scope.dataset.setSelectedRecords(selectedRecordsDs)
                    
                    $timeout(function () {
                        syncSelectOnDataset(undefined, true);
                    });
                }

                if ($scope.gridOptions && $scope.gridOptions.api) {
                    f();
                } else {
                    $timeout(f, 0, false);
                }
            }

            function getAgregateList(rowData, valueCols) {
                var result = {};

                valueCols.forEach(function (valueCol) {
                    var field = valueCol.id;
                    var values = [];
                    var colGrid = $scope.gridOptions.columnApi.getColumn(valueCol.field);

                    rowData.forEach(function (childItem) {
                        var value = childItem[field];
                        if (value !== undefined) {
                            values.push(value);
                        }
                    });

                    var tmpResult = getResultOfAgregation(valueCol.aggFunc, values, colGrid.colDef, rowData);

                    Object.keys(tmpResult).forEach(function(key){
                        result[key] = tmpResult[key] || 0;
                    });
                });

                return result;
            }

            function getResultOfAgregation(aggFuncName, values, colDef, rowData){
                var field = colDef.field;
                var type = colDef.dataType;
                var valueFormatter = colDef.valueFormatter;
                var resultObj = {};
                var result;

                switch (aggFuncName) {
                    case 'sum':
                        var sum = 0;
                        values.forEach(function (value) {
                            if (!isNaN(value)){
                                sum += ajustTimeToSeconds(value, type);
                            }
                        });
                        result = sum;
                    break;
                    case 'min':
                        var min = null;
                        values.forEach(function (value) {
                            if (!isNaN(value)) {
                                value = ajustTimeToSeconds(value, type);
                                if (min === null || min > value) {
                                    min = value;
                                }
                            }
                        });
                        result = min;
                    break;
                    case 'max':
                        var max = null;
                        values.forEach(function (value) {
                            if (!isNaN(value)) {
                                value = ajustTimeToSeconds(value, type);
                                if (max === null || max < value) {
                                    max = value;
                                }
                            }
                        });
                        result = max;
                    break;
                    case 'avg':
                        var sum = 0, count = 0;
                        values.forEach(function (value) {
                            if (!isNaN(value)){
                                sum += ajustTimeToSeconds(value, type);
                            }
                            count++;
                        });
                        result = (sum / count);
                    break;
                    case 'count':
                        result = (rowData ? rowData.length : 0);
                    break;
                    case 'first':                        
                        result = (rowData.length > 0 ? rowData[0][[field]] : '');
                    break;
                    case 'last':
                        result = (rowData.length > 0 ? rowData[rowData.length - 1][[field]] : '');
                    break;
                }

                if (type == 'T') {
                    result = ajustSecondsToTime(result);
                }

                resultObj[field] = result;

                return resultObj;
            }
            
            function getFooterAggregation(aggFuncName, colDef){
                var field = colDef.field;
                var type = colDef.dataType;
                var result = '';

                if (aggFuncName == 'per') {
                	colDef.hasPerAggregation = true;
                    var expressions = colDef.skAggregateExpression;
                    var precision;

                    if(['F', 'CUR', 'I'].includes(type)){
						if (colDef.skPrecision) {
						    precision = colDef.skPrecision;
						} else if (type == 'I') {
						    precision = 0;
						} else {
						    precision = 2;
						}
					}
                    
                    // Nos Dashboards uma agregação personalizada pode conter uma lista de agregações
                    expressions.forEach(function(expression) {
                     var expType = expression.Aggregator;
                    
                     if(angular.isDefined(expType)){
                        expType = expType.toLowerCase();
                        
                        if(expType == 'per' && angular.isUndefined(expression.Text) && angular.isUndefined(expression.Personalized)){
                           return;
                        }else{
                           result += '<p style="line-height: 13px; margin-top:6px">';
                           // Nessa lista de agregações pode conter Fórmula Personalizada, Soma, Média, Mínimo, etc.
                           if (expType == 'per') {
                            result += '<span style="float: left">';
                            result += (expression.Text != '' ? expression.Text : _localeText[expType]);
                            result += ':</span> ';

                            const value = calcAggPersonalizedValue(expression.Personalized, type);

                            if(type == 'T'){
                              result += "<span>" ; 
                              result += value;
                              result += "</span>" ; 
                            }else{
                              // Se a coluna já possui um cellRenderer não devemos formatar o valor, pois isso irá afetar no resultado final do celRenderer configurado
                              if(colDef.cellRenderer){
                                result += "<span>" ;
                                result += value;
                                result += "</span>" ;
                              }else{
                                result += "<span isFormatted = 'true'>" ;
                                result += NumberUtils.format(value, precision);
                                result += "</span>" ;
                              }
                            }
                         } else {
                            result += '<span style="float: left">';
                            result += _localeText[expType];
                            result += ':</span> ';

                            const value = calcAggPersonalizedValue(expType, field, type, false);

                            if(type == 'T'){
                              result += "<span>" ; 
                              result += value;
                              result += "</span>" ;
                            }else{
                              // Se a coluna já possui um cellRenderer não devemos formatar o valor, pois isso irá afetar no resultado final do celRenderer configurado
                              if(colDef.cellRenderer){
                                result += "<span>" ;
                                result += value;
                                result += "</span>" ;
                              }else{
                                result += "<span isFormatted = 'true'>" ;
                                result += NumberUtils.format(value, precision);
                                result += "</span>" ;
                              }
                            }
                         }
                         
                         result += '</p>';
                      }
                   }
                });
              } else {
                  result = calcAggValueByOperator(aggFuncName, field, type, false);
              }

                return result;
            }


            function calcAggValueByOperator(aggFuncName, field, type, isPersonalized) {
                if (!$scope.dataset.isLoaded() || $scope.dataset.isEmpty()) {
                    return 0;
                }

                var result = 0, datasetAsObject = isPersonalized ? $scope.dataset.getRecordsAsObjects() : $scope.dataset.getRecords();

                if (aggFuncName == 'count') {
                    result = datasetAsObject.length;
                } else if (aggFuncName == 'first') {
                    result = getAggFieldValue(field, type, datasetAsObject[0], isPersonalized);
                } else if (aggFuncName == 'last') {
                    result = getAggFieldValue(field, type, datasetAsObject[datasetAsObject.length-1], isPersonalized);
                } else {
                    var sum = 0, count = 0;

                    datasetAsObject.forEach(function (record) {
                 		var value = getAggFieldValue(field, type, record, isPersonalized);                  
                 
                	 	if (count == 0) {
	                        result = value;
	                        sum = value;
	                        count++;
	                    }else if (!isNaN(value)) {
	                        if (aggFuncName == 'sum') {
	                           result += value;
	                        } else if (aggFuncName == 'min' && result > value) {
	                           result = value;
	                        } else if (aggFuncName == 'max' && result < value) {
	                           result = value;
	                        } else if (aggFuncName == 'avg') {
	                           count++;
	                           sum += value;
	                        }
	                     }
                  	});

					if (aggFuncName == 'avg') {
						result = sum / count;
					}
                }

                if (type == 'T') {
                    result = ajustSecondsToTime(result);
                }

                return result;
            }

            function calcAggPersonalizedValue(expression, type) {
                try {
                    if (!$scope.dataset.isLoaded() || $scope.dataset.isEmpty()) {
                        return 0;
                    }
    
                    var findUnevaluables = /[\$a-zA-Z_]/m;
                    var result = angular.copy(expression);
                    
                    var countPreventInfinitLoop = 0;

                    while (findUnevaluables.exec(result) != null) {
                        var findFunctions = /([SUM|AVG|MIN|MAX]+)\s*\(\s*([\$0-9_\+\-\*\/\s*\w]+)\)/gi;
                        var found;
    
                        while ((found = findFunctions.exec(expression)) !== null) {
                            var aggFunc = found[1].toLowerCase();
                            var field = found[2].trim();
    
                            result = result.replace(found[0], calcAggValueByOperator(aggFunc, field, type, true));
                        }
                        if(expression == result && found == null){
                            countPreventInfinitLoop++;
                        }else{
                            countPreventInfinitLoop = 0;
                        }

                        expression = angular.copy(result);
                        
                        if(countPreventInfinitLoop >= 1000){
                            throw new Error("Um ou mais termos da expressão não possuem agregação");
                        }
                    }
    
                    let finalResult = eval(result);
                    
                    return isFinite(finalResult) ? finalResult : 0
                } catch (error) {
                    console.error(error);
                    console.error("Expressao avaliada " + expression);
                    throw new Error(i18n('DataGrid.customCalcFieldError') + "\n" + error);
                }
            }

            function getAggFieldValue(field, type, record, isPersonalized) {
                var result = 0;
                let recAsArr = angular.isArray(record);
                let valueField;

                if (isPersonalized) {
                    var found, findFieldNames = /\$([\w]+)/g;
                    var fieldExp = angular.copy(field);

                    while ((found = findFieldNames.exec(field)) !== null) {
                        var foundName = found[1];
                        var foundType = $scope.gridOptions.columnApi.getColumn(foundName).colDef.dataType;

                        fieldExp = fieldExp.replace(found[0], ajustTimeToSeconds(record[recAsArr ? $scope.dataset.getFieldIndexByName(foundName) : foundName], foundType));
                    }

                    result = eval(fieldExp) || 0;
                } else {
                    valueField = record[recAsArr ? $scope.dataset.getFieldIndexByName(field) : field];

                    if(typeof valueField != 'number') {
                        valueField = Number(valueField);
                    }

                    if (!isNaN(valueField)) {
                        result = ajustTimeToSeconds(valueField, type);
                    }
                }

                return result;
            }

            function ajustTimeToSeconds(value, type) {
                if (type == 'T') {
					// necessário converter para string para recuperar partes dela e converter posteriormente para segundos.
					value = String(value);
					  
					var minutes = parseInt(value.substring(value.length - 2));
					var hour = value.substring(0, value.length - 2);
					var totalInSeconds = (hour * 3600) + (minutes *60);  
					  
					return totalInSeconds;
               } else {
                    return value;
               }
            }

            function ajustSecondsToTime(totalSeconds) {
                var time = '0000';

               	if (!isNaN(totalSeconds) && totalSeconds > 0) {
                  var hours   = Math.floor(totalSeconds / 3600);
                  var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);

                  if (hours < 10) {
                     hours = '0' + hours;
                  }

                  if (minutes < 10) {
                     minutes = '0' + minutes;
                  }
                  // Conversão necessária para concatenar as duas partes individualmente e não somar.
                  time = String(hours) + String(minutes) ;
               }

               return time;
            }

            function updateGridColumn() {
                if ($scope.gridOptions && $scope.gridOptions.api) {
                    $scope.gridOptions.api.refreshCells({force: true});
                }
            }

            function getGridUniqueId(){
                return angular.copy($scope.uniqueid);
            }

            function openGridMenu() {                
                $scope.showMenuGrid = true;                
            }

            function closeGridMenu() {                
                $scope.showMenuGrid = false;                
            }

            function openToolPanel($event, show) {
                let hasShow = show || !$scope.gridOptions.api.isSideBarVisible();

                if(hasShow){

                    getGridApi().setSideBar({
                        toolPanels: [
                            {
                                id: 'columns',
                                labelKey: 'columns',
                                iconKey: 'columns',
                                toolPanel: 'agColumnsToolPanel',
                                toolPanelParams: {
                                    suppressPivots: true,
                                    suppressPivotMode: true,
                                    suppressColumnSelectAll: true
                                }
                            }
                        ],
                        defaultToolPanel: 'columns',
                        hiddenByDefault: true,
                        filter: true,
                        resizable: true,
                    });

                }

                $scope.gridOptions.api.openToolPanel(_defaulToolPanel);
                $scope.gridOptions.api.setSideBarVisible(hasShow);

                //Alterando icones, focando na pesquisa
                var toolPanel = document.querySelector('.ag-column-panel');   
                if(toolPanel){
                    toolPanel.addEventListener('click', function(){
                        if($scope.showMenuGrid){
                            $scope.showMenuGrid = false;
                            AngularUtil.apply($scope);
                        }
                    })
                    var inputSearchToolPanel = toolPanel.querySelector('.ag-column-name-filter');
                    if(inputSearchToolPanel){
                        inputSearchToolPanel.focus();
                    }
                    
                    var uncheckedToolPanel = toolPanel.querySelector('[ref="eSelectUnchecked"]');
                    var checkedToolPanel = toolPanel.querySelector('[ref="eSelectChecked"]');
                    var checkedDisToolPanel = toolPanel.querySelector('[ref="eSelectChecked"]');
                                                     
                    if(uncheckedToolPanel){
                        uncheckedToolPanel.removeAttribute('class');
                        uncheckedToolPanel.setAttribute('class', 'sk-check-box glyphicons glyphicons-unchecked ag-hidden');
                    }                                    
                    if(checkedToolPanel){
                        checkedToolPanel.removeAttribute('class');
                        checkedToolPanel.setAttribute('class', 'sk-check-box glyphicons glyphicons-check ag-hidden');
                    }
                }

                if(hasShow) setupToolPanel();
            }

            function setupToolPanel(){
                let toolPanelElem = $element.find('.ag-side-bar');
                let levels = 3;

                if(toolPanelElem){
                    let allBtns = toolPanelElem[0].querySelectorAll('.ag-icon.ag-icon-checkbox-unchecked-readonly');
                    
                    allBtns.forEach(function(elem){
                        var parent = elem.parentElement;
                        
                        for(var i = 0; i < levels; i++){
                            
                            if(!parent){
                                break;
                            }

                            parent = parent.parentElement;
                        }
                        
                        if(parent){
                            parent.style.display = 'none';
                        }
                    });

                }

            };

            function closeToolPanel($event){
                $scope.gridOptions.api.setSideBarVisible(!$scope.gridOptions.api.isSideBarVisible());                
            }

            function isEnableDynamicMode(){
            	let isVisible =0;
                for(var columns in _self.getColumnDefs()){
                    if(_self.getColumnDefs()[columns].skVisible){
                        isVisible++;
                    }
                }
                return $scope.enableToolPanel != false && isVisible > 2;
            }
            
            function disableSearch(){
                return $scope.disableSearch ? $scope.disableSearch : false;
            }

            function isAllowMultipleSelection(){
                return $scope.allowMultipleSelection != false;
            }

            function addToolTipOnGroup(){
                var tooltipGroup = '';
                for (var i = 0; i < _columnsGrouped.length; i++) {
                    var separator = i != 0 ? ' > ' : '';
                    var gridCol = $scope.gridOptions.columnApi.getColumn(_columnsGrouped[i]);
                    tooltipGroup += separator + gridCol.colDef.skDescription;
                }

                $scope.gridOptions.autoGroupColumnDef['headerTooltip'] = tooltipGroup;
                $scope.gridOptions.api.refreshHeader();
            }

            //Cell Renderer of cbx selection colun 
            function CbxSelectionCellRenderer() {                         
            }

            CbxSelectionCellRenderer.prototype.init = function (params) {
                var ctxRender = this;

                ctxRender.eGui = document.createElement('span');
                ctxRender.eGui.classList.add('ag-selection-checkbox');

                ctxRender.icon = document.createElement('span');
                ctxRender.icon.classList.add('ag-icon');
                ctxRender.icon.classList.add('ag-icon-checkbox-unchecked');

                ctxRender.icon.setAttribute('name', 'sk-cbx-row-selection');

                $scope.$watch('compactMode', function () {
                    if ($scope.compactMode) {
                        ctxRender.icon.setAttribute('style', 'top: 0px !important;');
                    } else {
                        ctxRender.icon.setAttribute('style', 'top: 6px !important;');
                    }
                });

                ctxRender.eGui.appendChild(ctxRender.icon);
                ctxRender.node = params.node;

                ctxRender.onClick = function (e) {
                    if ($scope.allowMultipleSelection != false) {
                    	if (ctxRender.icon.classList.contains('ag-icon-checkbox-checked')) {
                            ctxRender.unCheck();
                            $scope.dataset.unselectRowByUniqueId(ctxRender.node.id, false);

                            if (!_checked[ctxRender.node.id]) {
                                _checked[ctxRender.node.id] = {};
                            }
                            _checked[ctxRender.node.id].value = false;
                        } else {
                            ctxRender.check();                        
                            $scope.dataset.addSelectedRecordByUniqueId(ctxRender.node.id, true);

                            if (!_checked[ctxRender.node.id]) {
                                _checked[ctxRender.node.id] = {};
                            }
                            _checked[ctxRender.node.id].value = true;
                        }
                    } else {
                        onRowClicked(undefined, true);
                    }

                    $timeout(function(){
                        syncSelectOnDataset(undefined, true);
                    });
                };

                ctxRender.eGui.addEventListener('click', ctxRender.onClick);

                _ckbRowSelectionByNodeId[ctxRender.node.id] = this;
                
                if($scope.dataset.isSelected(ctxRender.node.id)){
                    ctxRender.check();
                    $scope.dataset.addSelectedRecordByUniqueId(ctxRender.node.id, true);
                }else{
                    ctxRender.unCheck();
                    $scope.dataset.unselectRowByUniqueId(ctxRender.node.id, false);
                }             
            };

            CbxSelectionCellRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            
            CbxSelectionCellRenderer.prototype.check = function () {
                this.icon.classList.remove('ag-icon-checkbox-unchecked');
                this.icon.classList.add('ag-icon-checkbox-checked');
                _ckbRowSelectionCheckeds[this.node.id] = true;
            };
            
            CbxSelectionCellRenderer.prototype.unCheck = function () {
                this.icon.classList.remove('ag-icon-checkbox-checked');
                this.icon.classList.add('ag-icon-checkbox-unchecked');
                delete _ckbRowSelectionCheckeds[this.node.id];
            };

            function refreshCkbRowSelection(){
                if ($scope.hideCbxColumn != false) {
                    return;
                }

                var selectedRows = $scope.dataset.getSelectedRecords();

                Object.keys(_ckbRowSelectionCheckeds).forEach(function(id){
                    _ckbRowSelectionByNodeId[id].unCheck();
                });

                if (selectedRows && selectedRows.length > 0) {
                    selectedRows.forEach(function(row){
                        var id = $scope.dataset.getRowMetadata(row).rowID;
                        if (_ckbRowSelectionByNodeId[id]) {
                            _ckbRowSelectionByNodeId[id].check();
                        }
                    })
                }
                
                if ($scope.dataset.getSelectedRecords() && $scope.dataset.getSelectedRecords().length == $scope.dataset.size() && _cbxHeaderRowSelection && $scope.dataset.size() != 0) {
                    _cbxHeaderRowSelection.check();
                } else {
                    _cbxHeaderRowSelection.unCheck();
                }
            }

            function HeaderCbxRowSelection() {                         
            }

            HeaderCbxRowSelection.prototype.init = function (agParams) {
                _cbxHeaderRowSelection = this;
                var componentCtx = this;
                
                componentCtx.agParams = agParams;
                componentCtx.eGui = document.createElement('div');
                componentCtx.eGui.innerHTML = '' + '<span class="ag-header-select-all" role="presentation"></span>';

                componentCtx.elemChecked = document.createElement('span');
                componentCtx.elemChecked.classList.add('ag-checkbox-checked');
                componentCtx.elemChecked.innerHTML =  '<span class="ag-icon ag-icon-checkbox-checked">';

                componentCtx.elemChecked.addEventListener('click', function(event){
                    componentCtx.unCheck();
                    unselectAll();
                });

                componentCtx.elemUnchecked = document.createElement('span');
                componentCtx.elemChecked.classList.add('ag-checkbox-unchecked');
                componentCtx.elemUnchecked.innerHTML = '<span class="ag-icon ag-icon-checkbox-unchecked">';

                componentCtx.elemUnchecked.addEventListener('click', function(event){
                    componentCtx.check();
                    selectAllRows();
                });

                componentCtx.elemIndeterminate = document.createElement('span');
                componentCtx.elemIndeterminate.classList.add('ag-checkbox-indeterminate');
                componentCtx.elemIndeterminate.innerHTML = '<span class="ag-icon ag-icon-checkbox-indeterminate">';
                
                if ($scope.allowMultipleSelection == false) {    
                    componentCtx.eGui.appendChild(componentCtx.elemIndeterminate);
                } else {
                    componentCtx.eGui.appendChild(componentCtx.elemUnchecked);
                }

                componentCtx.check = function(){
                    if (componentCtx.eGui && componentCtx.eGui.contains(componentCtx.elemUnchecked)) {
                        componentCtx.eGui.removeChild(componentCtx.elemUnchecked);
                        componentCtx.eGui.appendChild(componentCtx.elemChecked);
                    }
                }

                componentCtx.unCheck = function () {
                    if (componentCtx.eGui && componentCtx.eGui.contains(componentCtx.elemChecked)) {
                        componentCtx.eGui.removeChild(componentCtx.elemChecked);
                        componentCtx.eGui.appendChild(componentCtx.elemUnchecked);
                    }
                };

                refreshCkbRowSelection();
            };
            
            HeaderCbxRowSelection.prototype.getGui = function () {
                return this.eGui;
            };
            
            HeaderCbxRowSelection.prototype.destroy = function () {
            };


            function setFocus(){
                try{
                    let cellToFocus = _self.lastFocusedCell;

                    if(!cellToFocus){
                        cellToFocus = getDefaultFocusableCell();
                    }

                    if(cellToFocus){
                        $timeout(function(){                        
                            setFocusOnCell(cellToFocus.colId);                        
                        });
                    
                    }
                }catch(e){
                    console.warn('[SkAgGridController] Erro ao realizar foco no datagrid', e);
                }
            }

            function onGridContainerClick($event){
                var targetId;
                var parentId;

                if ($event.originalEvent.target) {
                    targetId = $event.originalEvent.target.getAttribute('id');
                    if($event.originalEvent.target.parentElement){
                        parentId = $event.originalEvent.target.parentElement.getAttribute('id');
                    }
                }

                if (parentId != "iconGridMenu" && targetId != 'gridMenu' && $scope.showMenuGrid) {
                    $scope.showMenuGrid = false;
                }
            }

            function sendToClipboard(params){                
                var cellGrid = $scope.gridOptions.api.getFocusedCell();
                var value;

                if (cellGrid) {

                    if (cellGrid && cellGrid.column && cellGrid.column.colDef && cellGrid.column.colDef.valueFormatter) {
                        value = cellGrid.column.colDef.valueFormatter({ 
                            value: params.data, 
                            data: "", 
                            colDef: cellGrid.column.colDef, 
                            column: cellGrid.column, 
                            api: $scope.gridOptions.api, 
                            columnApi: $scope.gridOptions.columnApi, 
                            context: this
                        });
                    } else {
                        value = params.data;
                    }

                    AngularUtil.sendTextToClipboard(value, _gridElem);
                }
            }

            function refreshLayout(){
                if ($scope.gridOptions && $scope.gridOptions.api) {
                    $timeout(function(){
                        $scope.gridOptions.api.doLayout();
                    });
                }
            }

            function SkCellRenderer () {}

            SkCellRenderer.prototype.buildPersonalizedRenderer = function(params, oldElem) {                
                this.eGui = document.createElement("span");
                this.eGui.style.display = 'flex';
                this.eGui.style.alignItems = 'center';
                this.eGui.style.height = '100%';
                this.eGui.style.justifyContent = this.personzedRenderer.align;
                this.personzedRenderer.element.style.lineHeight = '0px'
                if(oldElem){
                	/*
                	 * Em alguns momentos o oldElem ja pode ter sido removido
                	 * pela propria API a grid, isso faz disparar o erro The node to be removed is not a child of this node.
                	 * nesses casos ignoramos a erro.
                	 * */
                	try{
                		this.eGui.removeChild(oldElem);
                	}catch(ignored){
                		
                	}
                }
                this.eGui.appendChild(SkCellRenderer.prototype.personzedRenderer.element);
            }
            
            SkCellRenderer.prototype.init = function(params) {
                if($scope.datagridInterceptor){
                    let dsItem = $scope.dataset.getRecordByUniqueId(params.node.id);
                    SkCellRenderer.prototype.personzedRenderer = $scope.datagridInterceptor.interceptCellRenderer(params.column, params.getValue(), params.eGridCell, {datasetItem: dsItem, gridItem: params.data});
                }
                

                if(SkCellRenderer.prototype.personzedRenderer){
                    SkCellRenderer.prototype.buildPersonalizedRenderer(params);
                }else{
                    const conteudo = params.valueFormatted ? params.valueFormatted : (params.value != undefined ? params.value : '')
                    
                    params.eGridCell.innerHTML = angular.isString(conteudo) ? StringUtils.toHtmlText(conteudo) : conteudo;
                }              
            };
            
            SkCellRenderer.prototype.getGui = function() {
                if(this.personzedRenderer) return this.eGui;
            };
            
            SkCellRenderer.prototype.refresh = function(params) {
                var oldElem;

                if($scope.datagridInterceptor){
                    let dsItem = $scope.dataset.getRecordByUniqueId(params.node.id);
                    oldElem = SkCellRenderer.prototype.personzedRenderer ? SkCellRenderer.prototype.personzedRenderer.element : undefined;
                    SkCellRenderer.prototype.personzedRenderer = $scope.datagridInterceptor.interceptCellRenderer(params.column, params.getValue(), params.eGridCell, {datasetItem: dsItem, gridItem: params.data});
                }
                
                if(SkCellRenderer.prototype.personzedRenderer){
                    SkCellRenderer.prototype.buildPersonalizedRenderer(params, oldElem);
                    return false;
                }else{
                    params.eGridCell.innerText = params.valueFormatted ? params.valueFormatted : (params.value != undefined ? params.value : '');
                    return true;
                }
            };
            
            SkCellRenderer.prototype.destroy = function() {
            };

            function getPersonalizedCollorsClass(params){                
                if ($scope.datagridInterceptor) {
                    var classList = '';
                    if (params.node.id == undefined) {
                        return;
                    }

                    var cellColors;
                    try{
                        cellColors = $scope.datagridInterceptor.getCellColors({entity : $scope.dataset.getRecordByUniqueId(params.node.id)}, params.colDef, params.rowIndex, params.colDef.skOrder, params.api, {dataset: $scope.dataset});
                    }catch(e){
                        console.warn('Erro no interceptor getCellColors.', e);
                    }
                    if (angular.isObject(cellColors)) {
                        if (cellColors.textColor){
                            classList  += ' ' +  (ThemeColors.isValidColor(cellColors.textColor) ? ThemeColors.getTextColorClass(cellColors.textColor) : '');
                        }
                        if (cellColors.bgColor) {
                            classList  += ' ' +  (ThemeColors.isValidColor(cellColors.bgColor) ? ThemeColors.getBgColorClass(cellColors.bgColor) : '');
                        }
                    } else if (angular.isDefined(cellColors)) {
                        classList += ' ' +  (ThemeColors.isValidColor(cellColors) ? ThemeColors.getTextColorClass(cellColors) : '');
                    }

                    return classList;
                }
                return '';
            }

            function groupColumn() {
                $scope.gridOptions.columnApi.setPivotMode(false);               
                addToolTipOnGroup();
                $scope.gridOptions.columnApi.setRowGroupColumns(_columnsGrouped);

                if ($scope.gridconfig) {
                    GridConfig.loadConfigurations($scope.gridconfig);
                }
            }

            function setGroupColumn(fieldName) {
                if (_columnsGrouped.indexOf(fieldName) > -1) {
                    _columnsGrouped.splice(_columnsGrouped.indexOf(fieldName), 1);
                } else {
                    _columnsGrouped.push(fieldName);
                }

                alignColumnGroup(fieldName);

                $scope.dataset.removeEventListener(DatasetEvents.BACKGROUND_LOAD_END, groupColumn);
                $scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD_END, groupColumn);
                groupColumn();
            }

            function setGroupColumns(columnsNames){
                columnsNames.forEach(setGroupColumn);
            }

            function setOrderColumn(fieldName, order){
                $scope.gridOptions.api.setSortModel([{ colId: fieldName, sort: order }]);
            }

            function alignColumnGroup(fieldName){
                let column = $scope.gridOptions.columnApi.getColumn(fieldName);

                if(column){
                    let dataType = column.colDef.dataType;
                    let userType = column.colDef.userType;
                    
                    column.colDef.cellStyle = getCellStyle({ userType, dataType });
                }
            }

            function addGridReadyListener(fn){
                if (_gridReadyListeners.indexOf(fn) > -1) {
                    return;
                }
                _gridReadyListeners.push(fn);
            }

            function onGridReady(){
                _gridReadyListeners.forEach(function(fn){
                    fn();
                });

                if($scope.isTreeData){
                    $timeout(() =>  $scope.gridOptions.api.sizeColumnsToFit(), 300);
                }
            }

			function getLiveCheckBoxElement(actualValue, fieldName, node){               

                var col = node.columnApi.getColumn(fieldName).colDef;

                var trueValue = 'S';
                var falseValue = 'N';

                if(col && col.skOptions){
                    if(col.skOptions.length != 2){
                        throw "Options para datagrid liveCheck deve conter duas opções";
                    }
                    
                    if(!(('S' == col.skOptions[0].data && 'N' == col.skOptions[1].data) || ('N' == col.skOptions[0].data && 'S' == col.skOptions[1].data))) { 
	                    trueValue = col.skOptions[0].data;
	                    falseValue = col.skOptions[1].data;
                	}	
				}


                var skSwitch = document.createElement('sk-switch');                
                var rootSpan = document.createElement('span');

                rootSpan.classList.add('sk-container');

                var input = document.createElement('input');
                input.setAttribute('type','checkbox');

                var label = document.createElement('label');
                
                var spanChecked = document.createElement('span');
                spanChecked.classList.add('checked');

                var spanToggle = document.createElement('span');
                spanToggle.classList.add('toggle');

                label.appendChild(spanChecked);
                label.appendChild(spanToggle);

                rootSpan.appendChild(input);
                rootSpan.appendChild(label);
                
                skSwitch.appendChild(rootSpan);
                skSwitch.setAttribute('live-checkbox', 'true');

                if(actualValue === trueValue){
                    input.checked = true;
                }else{
                    input.checked = false;
                }               
                  
                skSwitch.addEventListener('click', function(event){
                    _selectNodes = ArrayUtils.sortByNumberProperty(node, 'rowIndex');

                    var indexOfDataset = $scope.dataset.getIndexByUniqueId(node.id);
                    
                    _lockRowClick = true;
                    $scope.dataset.lockChangeRowAutoSave(true);

                    $scope.dataset.gotoRow(indexOfDataset).then(function (index) {
                        _lockRowClick = false;
                        $scope.dataset.lockChangeRowAutoSave(false);
                        if (input.checked) {
                            $scope.dataset.setFieldValue(fieldName, falseValue);
                            input.checked = false;
                        } else {
                            $scope.dataset.setFieldValue(fieldName, trueValue);
                            input.checked = true;
                        }

                    }, function(){
                        $scope.dataset.lockChangeRowAutoSave(false);
                    });
                });

                return skSwitch;
            }

            function editorIsCacheable(col){

                let customEditor = getCustomCellEditor(col.colId);
                let customCacheble = true;
                
                if(customEditor && customEditor.isCachable){
                    customCacheble = customEditor.isCachable(col);
                }

                return (!angular.isFunction(col.colDef.buildOptionsFn) && customCacheble) && col.colDef.editorCachable != false;
            }

            function getCellHeaderTpl(type){
                var tpl =   '<div class="ag-cell-label-container" role="presentation">' +
                                '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                                '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                                '    <span ref="eSortAsc" class="sk-col-orderned-asc"></span>' +
                                '    <span ref="eSortDesc" class="sk-col-orderned-desc" ></span>' +
                                '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                                '    <span ref="eText" class="ag-header-cell-text [class_column_type]" role="columnheader" style="width: calc(100% - 4px); display: block; font-size: [font_style];"></span>' +
                                '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                                '    <span ref="skFilter" class="ag-header-icon"></span>' +
                                '  </div>' +
                            '</div>';

                if('center,left,right'.indexOf(type) > -1){
                    tpl = tpl.replace('[class_column_type]', ('text-align-' + type));
                }else if(type === 'I' || type == 'F' || type == 'CUR' ){
                    tpl = tpl.replace('[class_column_type]', 'header-number');
                }else if(type === 'D' || type === 'H' || type == 'T' || type == "TREE"){
                    tpl = tpl.replace('[class_column_type]', 'header-date');
                }else{
                    tpl = tpl.replace('[class_column_type]', '');
                }

				if (angular.isDefined($scope.cellStyle)) {
                    let newFontSize;

                    if ($scope.cellStyle.hasOwnProperty('font-size')) {
                        newFontSize = $scope.cellStyle['font-size']            
                        tpl = tpl.replace('[font_style]', newFontSize);
                    }
                }

                return tpl;
            }
            /**
             * Esses metodos terao que ser reimplementados na proxima atualizacao do aggrid,
             * pois alguns bugs foram corrigidos aqui, por exemplo, listener para monitorar alteracao
             * no titulo co grafico, e adicionar botao de resetar configs forao feitos na mao
             */
            function processChartOptions(params){

                var lblFormatter = function(params) {
                    let valueToFormat = params.value.value || params.value;
                    var valToReturn = valueToFormat && valueToFormat.toLocaleDateString ? valueToFormat.toLocaleDateString() : valueToFormat;
                    valToReturn += ' ' + (valueToFormat && valueToFormat.toLocaleTimeString ? valueToFormat.toLocaleTimeString() : '');
                    return valToReturn;
                }
                
                $timeout(setupChart);

                var options = params.options;
                var overriddenChartOptions;

                _actualChartType = params.type; 

                // use saved chart options for specific chart type
                if (_savedUserPreferenceByChartType[_actualChartType]) {
                    overriddenChartOptions = _savedUserPreferenceByChartType[_actualChartType];
                }

                //Utilizado para formatacao de datas
                if (options.xAxis && options.yAxis) {
                    options.xAxis.label.formatter = lblFormatter;
                    options.yAxis.label.formatter = lblFormatter;
                }

                if(options.seriesDefaults.fill.colors[0] === '#f3622d' && (!overriddenChartOptions || Object.keys(overriddenChartOptions).length === 0)){
                    var seriesDefaults = options.seriesDefaults;
                    seriesDefaults.fill.colors = _colorMap.charts.fills;
                    seriesDefaults.fill.opacity = 0.9;
                    seriesDefaults.stroke.colors = ['black'];
                    seriesDefaults.stroke.opacity = 0;
                    
                    seriesDefaults.highlightStyle = {
                        fill : {color: _colorMap.charts.onHover, opacity: 0.3}
                    };

                    seriesDefaults.shadow = {
                        color: 'rgba(0, 0, 0, 0.3)',
                        offset: [5, 5],
                        blur: 8
                    };

                    options.padding = {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20
                    };

                    if(_actualChartType === "line"){
                        seriesDefaults.stroke.opacity = 1;
                    }

                    if(options.xAxis) options.xAxis.label.rotation = 20;

                    if(options.title && !options.title.text){
                        options.title.text = '';
                    }

                    return options;
                }else{
                    if((overriddenChartOptions && Object.keys(overriddenChartOptions).length > 0)){
                        if (overriddenChartOptions.xAxis && overriddenChartOptions.yAxis) {
                            overriddenChartOptions.xAxis.label.formatter = lblFormatter;
                            overriddenChartOptions.yAxis.label.formatter = lblFormatter;
                        }   
                        return overriddenChartOptions;
                    }else{
                        return options; 
                    }
                }
            }

            function setupColors(){
                _colorMap.charts = { fills: [] };
                
                //Default colors
                _colorMap.charts.fills[1] = '#631502';
                _colorMap.charts.fills[2] = '#01082e';
                _colorMap.charts.fills[3] = '#290125';
                _colorMap.charts.fills[4] = '#48094d';
                _colorMap.charts.fills[5] = '#58615c';
                _colorMap.charts.fills[6] = '#82f5e9';
                _colorMap.charts.fills[7] = '#f0d1ee';
                _colorMap.charts.fills[8] = '#0d00ff';
                _colorMap.charts.fills[9] = '#6b650f';

                if( SkApplication.instance().isJivaW()  ){
                    _colorMap.charts.fills[0] = '#ad5603';
                    _colorMap.charts.onHover = '#6e4103';
                }else{
                    _colorMap.charts.fills[0] = '#004a14';
                    _colorMap.charts.onHover = '#002606';
                }
            }

            function loadChartPreferences(){
                try{
                    var app = SkApplication.instance();
                    var user = app.getUserID();
                    
                    SkApplication.instance().loadMgeConfig(_CHART_CFG_KEY, user).then(function(cfgs){
                        if(cfgs && cfgs.config && cfgs.config.chart) _savedUserPreferenceByChartType = JSON.parse(cfgs.config.chart);
                    });
                }catch(e){
                    console.warn('[SkSataGridAggrid] erro ao buscar configurações de gráficos')
                }
            }

            function onChartOptionsChanged(event){                
                var chartOptions = event.chartOptions;
                _savedUserPreferenceByChartType[event.chartType] = chartOptions;
                _chartPreferencesChanged = true;
            }

            function setupChart(){
                let chartMenu = document.querySelector('.ag-chart-menu');
                let titleBarBtns = document.querySelector('.ag-title-bar-buttons');
                
                let menuExpand;
                let menuClose;
                
                if(titleBarBtns){
                    menuExpand = titleBarBtns.querySelector('.ag-icon.ag-icon-maximize');
                    menuClose = titleBarBtns.querySelector('.ag-icon.ag-icon-cross');                    
                }

                _chartPreferencesChanged = false;

                if(!chartMenu){
                    console.warn('[skDataAggrid] não foi possível criar o botão reset chart, chart menu não encontrado.');
                    return;
                }
                
                let btnReset = chartMenu.querySelector('.btn-reset-chart');

                if(btnReset) return;

                btnReset = document.createElement('span');

                btnReset.setAttribute('class', 'btn-reset-chart');                
                btnReset.addEventListener('click', resetChart);

                let icon = document.createElement('i');
                icon.setAttribute('class', 'glyphicons glyphicons-restart icon-reset-chart');

                btnReset.appendChild(icon);
                chartMenu.appendChild(btnReset);

                //Criar tooltips
                let btnCfg = chartMenu.querySelector('.ag-icon.ag-icon-menu');
                let btnUnlink = chartMenu.querySelector('.ag-icon.ag-icon-linked');
                let btnSave = chartMenu.querySelector('.ag-icon.ag-icon-save');
                
                btnReset.setAttribute('title', i18n('DataGrid.btnResetChartTooltip'));
                
                if(btnCfg) btnCfg.setAttribute('title', i18n('DataGrid.btnCfgTooltip'));
                if(btnUnlink) btnUnlink.setAttribute('title', i18n('DataGrid.btnUnlinkTooltip'));
                if(btnSave) btnSave.setAttribute('title', i18n('DataGrid.btnSaveTooltip'));
                if(menuExpand) menuExpand.setAttribute('title', i18n('DataGrid.expandChart'));
                if(menuClose) menuClose.setAttribute('title', i18n('DataGrid.closeChart'));

                var titleBar = document.querySelector('[ref="eTitleBar"].ag-title-bar.ag-unselectable');
                if(titleBar) {
                    let btnCloseModal = titleBar.querySelector('.ag-title-bar-buttons .ag-button .ag-icon.ag-icon-cross');
                    if(btnCloseModal) btnCloseModal.addEventListener('click', onChartClosed)
                }
            }

            function resetChart(){
                MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('DataGrid.resetChartConfirm'), undefined, undefined, undefined, undefined, {showBtnCancel: false}).then(function(){
                    _savedUserPreferenceByChartType[_actualChartType] = {};
                    onChartOptionsChanged(createChartChangeEvt());
                    onChartClosed();
                    $scope.gridOptions.api.chartService.destroyAllActiveCharts();
                });

                AngularUtil.apply($scope);
            }

            function createChartChangeEvt(){
                return {chartOptions: _savedUserPreferenceByChartType[_actualChartType], chartType: _actualChartType};
            }

            function onChartClosed(){
                if (!_chartPreferencesChanged) {
                    unselectAll();
                    return;
                }
                var app = SkApplication.instance();
                var user = app.getUserID();
                app.saveMgeConfig(_CHART_CFG_KEY, { chart: JSON.stringify(_savedUserPreferenceByChartType)}, user);                
                unselectAll();
            }           


            //Cell Renderer of drag and drop row
            function SkDraggableRenderer() {                         
            }

            SkDraggableRenderer.prototype.init = function (params) {
                var ctxRender = this;

                ctxRender.eGridCell = params.eGridCell;
                ctxRender.eGui = document.createElement('span');
                ctxRender.eGui.classList.add('ag-selection-checkbox');

                ctxRender.icon = document.createElement('span');
                ctxRender.icon.classList.add('ag-icon');
                ctxRender.icon.classList.add('ag-icon-grip');

                ctxRender.icon.setAttribute('name', 'sk-cbx-row-selection');

                $scope.$watch('compactMode', function () {
                    if ($scope.compactMode) {
                        ctxRender.icon.setAttribute('style', 'top: 0px !important;');
                    } else {
                        ctxRender.icon.setAttribute('style', 'top: 6px !important;');
                    }
                });
                
                ctxRender.eGui.appendChild(ctxRender.icon);
                ctxRender.node = params.node;

                //Elemento para ser apresentado no drag and drop (icone)
                ctxRender.iconDrag = document.getElementById('aggrid-drag-and-drop-icon');
                
                if(!ctxRender.iconDrag){
                    var div = document.createElement('div');
                    div.style.display = 'inline-flex';
                    div.style.position = "absolute"; div.style.top = "0px"; div.style.left = "-100px";
                    div.setAttribute('id', 'aggrid-drag-and-drop-icon');

                    var icon = document.createElement('span');
                    icon.style.marginTop = '-3px';
                    icon.classList.add('ag-icon');
                    icon.classList.add('ag-icon-grip');                    

                    var text = document.createElement('label');
                    text.innerText = '';

                    div.appendChild(icon);
                    div.appendChild(text);

                    document.body.appendChild(div);
                    
                    ctxRender.iconDrag = div;
                }

                function ondragstart(event){
                    let label;
                    let defaultLbl = 'Reistro ' + ctxRender.node.rowIndex;
                    let data = ctxRender.node.data;
                    var id = $element.attr('id');

                    if($scope.draggableField){
                        label = data[$scope.draggableField];
                    }else if($scope.dataset && $scope.dataset.getEntityPresentationFieldName()){
                        label = data[$scope.dataset.getEntityPresentationFieldName()];
                    }

                    if(!label){
                        label = defaultLbl;
                    }
                    ctxRender.iconDrag.getElementsByTagName('label')[0].innerText = label;
                    event.originalEvent.dataTransfer.setDragImage(ctxRender.iconDrag, 0, 0);                    
                    
                    var items = {items: [data], indexOfDataset: $scope.dataset.getIndexByUniqueId(ctxRender.node.id)};
                    event.originalEvent.dataTransfer.setData('items', JSON.stringify(items) );
                    event.originalEvent.dataTransfer.setData('id', id);
                    event.originalEvent.dataTransfer.setData('row-id', ctxRender.node.id);

                    if($scope.dragStart) $scope.dragStart({event : event});                
                };

                function dragend(event){
                    if($scope.dragEnd) $scope.dragEnd({event : event});
                }
                
                ctxRender.eGridCell.setAttribute('draggable', true);
                //Isso foi necessario, pois por padrao no drag and drop
                //trabalhamos com eventos do angular, e nao nativos do js
                var gridCellAngularElement = angular.element(ctxRender.eGridCell);
                gridCellAngularElement.on('dragstart', ondragstart);
                gridCellAngularElement.on('dragend', dragend);
            };

            SkDraggableRenderer.prototype.getGui = function () {
                return this.eGui;
            };

            function dragenter(event){
                if($scope.dragEnter) $scope.dragEnter({event : event});
            }
            
            function dragover(event){
                if($scope.dragOver) $scope.dragOver({event : event});
                event.preventDefault();
            }
            
             function drop(event){
                if($scope.dragDrop) $scope.dragDrop({event : event});
		if($scope.editGridEvent) dropSelectedRow();
            }

            function setupDrop(enable){
                $element.off('dragenter', dragenter);
                $element.off('dragover', dragover);
                $element.off('drop', drop);

                if(enable){
                    $element.on('dragenter', dragenter);
                    $element.on('dragover', dragover);
                    $element.on('drop', drop);
                }
            }

            function selectRangeRows(){
                
                if(!isEnableCharts()) return;

                let columns = _self.getVisibleColumnDefs();
                let rows = _self.getRecords();

                if(columns && rows && columns.length > 0 && rows.length > 0){
                    $scope.gridOptions.api.clearRangeSelection();
                    $scope.gridOptions.api.addCellRange({
                        rowStartIndex: 0,
                        rowEndIndex: rows.length-1,
                        columnStart: columns[0].field,
                        columnEnd: columns[columns.length-1].field,
                    });
                }
            }

            function unselectRangeRows(){
                if(!isEnableCharts()) return;
                $scope.gridOptions.api.clearRangeSelection();
            }

            function isEnableCharts(){
                return !$scope.enableDrag;
            }

            function onWindowResize(){
                $scope.showMenuGrid = false;
            }

            function addCustomCellRenderer(colId, cellRendererImpl){
                if(!colId){
                    _customCellRendererByColumn[ALL_COLS] = cellRendererImpl;
                }else{
                    colId.split(',').forEach(function(id){
                        _customCellRendererByColumn[id] = cellRendererImpl;
                    })                    
                }
            }

            function UserCellRenderer () {
            }
                        
            UserCellRenderer.prototype.init = function(params) { 
                this.delegate = _customCellRendererByColumn[params.column.colId];
                this.eGridCell = params.eGridCell;
                this.valueFormatted = params.valueFormatted;
                this.value = params.value;
                this.columm = params.column;
                this.rowId = params.rowIndex;
                this.params = params;
                this.node = params.node;

                if(!this.delegate){
                    this.delegate = _customCellRendererByColumn[ALL_COLS];                    
                }
            };

            UserCellRenderer.prototype.getGui = function() {
                if(this.delegate && this.delegate.getGui){
                    this.eGridCell.innerHTML = ''
                    
                    var customItem = this.delegate.getGui(this.params, this.eGridCell, $scope, getCustomUtils());
                    var customEl;
                    var align;
                   
                    if(customItem && customItem.element){
                        customEl = customItem.element;
                        align = customItem.align;
                    }else{
                        customEl = customItem;
                    }

                    customEl = angular.element(customEl);
                    customEl.css('lineHeight', '0px');

                    this.eGridCell.style.display = 'flex';
                    this.eGridCell.style.alignItems = 'center';
                    this.eGridCell.style.height = '100%';
                    
                    if(align){
                        this.eGridCell.style.justifyContent = align;
                    }else{
                        this.eGridCell.style.justifyContent = 'center';
                    }

                    var node = this.node;
                    customEl.attr('col-id', this.columm.colId);
                    customEl.attr('row-id', this.node.id);
                    customEl.on('click', function (event){
                        event.node = node;
                        event.event = event;
                        event.api = $scope.gridOptions.api;
                        onRowClicked(event);
                    });
                    
                    this.eGridCell.append(customEl[0]);
                }else{                
                    this.eGridCell.innerHTML = this.valueFormatted ? this.valueFormatted : (this.value != undefined ? this.value : '');
                }
            };
                        
            UserCellRenderer.prototype.refresh = function(params) {
                if(this.delegate && this.delegate.refresh){
                    let isRefresh = this.delegate.refresh(params);

                    if(isRefresh && this.delegate && this.delegate.getGui){
                        this.getGui();
                        return true;
                    }else{
                        this.eGridCell.innerHTML = this.valueFormatted ? this.valueFormatted : (this.value != undefined ? this.value : '');
                        return isRefresh;
                    }

                }else{
                    return true;
                }
            };
                        
            UserCellRenderer.prototype.destroy = function() {
                if(this.delegate && this.delegate.destroy) this.delegate.destroy();
            };

            function addCustomEditorRenderer(colId, cellRendererImpl){
                if(!colId){
                    _customCellEditorByColumn[ALL_COLS] = cellRendererImpl;
                }else{
                    colId.split(',').forEach(function(id){
                        _customCellEditorByColumn[id] = cellRendererImpl;
                    })                    
                }
            }

            function getCustomCellEditor(colId){
                if(_customCellEditorByColumn[colId]){
                    return _customCellEditorByColumn[colId]
                }else if(_customCellEditorByColumn[ALL_COLS]){
                    return _customCellEditorByColumn[ALL_COLS];
                }                
            }

            function getCustomUtils(){
                return {
                    createDirective : AngularUtil.createDirective,
                    callService : ServiceProxy.callService,
                    mgeParameters : MGEParameters,
                    criteria : Criteria
                }
            }

            function getDefaultFocusableCell(){
                var allCols = $scope.gridOptions.api.gridCore.columnController.allDisplayedColumns;

                if(allCols && allCols.length > 0){                                
                    return allCols[0];
                }

                return undefined;
            }

            function CustomLoadingCellRenderer() {}

            CustomLoadingCellRenderer.prototype.init = function(params) {                
                this.eGui = document.createElement('div');
            };

            CustomLoadingCellRenderer.prototype.getGui = function() {
                return this.eGui;
            };
            
            function recalcLastCellSize(){
                try{
                    let agViewPort = $element.find('.ag-body-viewport');

                    //Caso a o container tenha scroll ignoramos o recalculo.
                    if(agViewPort && DomUtil.hasScrolling(agViewPort)){
                        return;
                    }

                    let scroll =  $element.find('.ag-body-horizontal-scroll-viewport');

                    if(scroll && scroll[0]){
                        let cols = $scope.gridOptions.columnApi.getAllDisplayedColumns();
                        if(cols && cols.length > 0){
                            $timeout(() => {
                                lastCol = cols[cols.length - 1];
                                elementsToResize = $element[0].querySelectorAll('.ag-cell-value[aria-colindex="' + (cols.length) + '"]');
                                
                                elementsToResize.forEach((element) => {
                                    if(element.style.textAlign == 'right') element.style.width = (lastCol.actualWidth - 15 + 'px');
                                });
                            })                                
                        }
                    }
                }catch(e){
                    console.warn('[SkAgGridController] Erro ao executar recaulculo da ultima coluna.', e);
                }
            }
            
            function getCellStyle(options) {
                // emerson

                let cellStyle = {}

                if (angular.isDefined($scope.cellStyle)) {
                    ObjectUtils.forEachInObject($scope.cellStyle, function (key, value) {

                        cellStyle[key] = value;

                        /** É necessário forçar essa inserção para que o item seja alinhado corretamente */
                        if(key == 'font-size'){
                            cellStyle['align-items'] = 'center'
                            cellStyle['display'] = 'grid'
                        }
                    });
                }

                /** Se a propriedade text-align não for definida, será utilizada a default */
                if (!cellStyle.hasOwnProperty('text-align')) {
                    if (options.dataType === 'L' || options.dataType === 'LP') {
                        cellStyle['text-align'] = 'center'
                    } else if (options.dataType === 'PB') {
                        cellStyle['text-align'] = 'left'
                    } else if(options.dataType === 'D' || options.dataType === 'H' || options.dataType == 'T') {
                        cellStyle['text-align'] = 'center'
                    } else if(options.dataType == 'I' || options.dataType == 'F' || options.dataType == 'CUR') {
                        cellStyle['text-align'] = 'right'
                    }else if (options.userType == 'ENTITY') {
                        if (options.dataType == 'I' || options.dataType == 'F' || options.dataType == 'CUR') {
                            cellStyle['text-align'] = 'right'
                        } else {
                            cellStyle['text-align'] = 'left'
                        }
                    }else {
                        cellStyle['text-align'] = 'left'
                    }
                }

                return cellStyle;
            }

			function SkCustomTooltip() {}

            SkCustomTooltip.prototype.init = function(params) {
                var eGui = (this.eGui = document.createElement('div'));
                //var color = params.color || 'white';
                var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;

                if(data && data.TOOLTIP){
                    eGui.innerHTML = 'Carregando...'
                    getRowToolTip(data.TOOLTIP).then(toolTip => {
                        eGui.innerHTML = toolTip;
                    });
                }

                eGui.classList.add( $scope.datatipClass || 'custom-tooltip');
            };

            SkCustomTooltip.prototype.getGui = function() {
                return this.eGui;
            };

            function getRowToolTip(key){
                let deferred = $q.defer();
                let resultRegex = new RegExp("^ServerSideToolTip\\((.+)\\)$").exec(key);

                if(resultRegex){
                    resultRegex = resultRegex[1];
                }
                
                if(_loadedTips.hasOwnProperty(key)){
                    deferred.resolve(_loadedTips[key]);
                }else{

                    let req = {
                        source:{
                            $: resultRegex
                        }
                    };

                    ServiceProxy.callService("mge@SystemUtilsSP.loadDynamicToolTip", req)
                        .then(function(result){
                            var text = result.responseBody.toolTip.$ || '';
                            
                            var parseText = replaceSizetoStyleSize(text);
                            
                            parseText = StringUtils.barScape(parseText);
                            
                            _loadedTips[key] = parseText;

                            deferred.resolve(_loadedTips[key]);
                        });

                }

                return deferred.promise;
            }

            function replaceSizetoStyleSize(textHtml){
                var regex = /\b(size)\s*=\s*"(.*?)"/g;

                var parseSize = regex.exec(textHtml);

                while(parseSize != null){
                    var sizeInPx = parseSize[2] + "px";

                    var newExpression = ' sytle="{font-size: ' + sizeInPx + '}"';
                    
                    textHtml = textHtml.replace(parseSize[0], newExpression);

                    parseSize = regex.exec(textHtml);
                }

                return textHtml;
            }

            function getGridAsyncListners(datagridApi) {
                return datagridApi.eventService.allAsyncListeners;
            }

 	    	function isLastRecord() {
               return $scope.dataset.getCurrentIndex() >= $scope.dataset.size() - 1;
            }
            
            function getFirstColumn(){
                let cols = $scope.gridOptions.columnApi.getAllDisplayedColumns();
                if(cols.length > 0){
                    return cols[0];
                }
            }

            function getLastColumn(){
                let cols = $scope.gridOptions.columnApi.getAllDisplayedColumns();
                if(cols.length > 0){
                    return cols[cols.length - 1];
                }
            }

            function setEnabled(value){
                let header = $element.find('.ag-header .ag-header-viewport');
                let body = $element.find('.ag-root .ag-body-viewport .ag-center-cols-viewport .ag-center-cols-container');
                
                let existsOnBody = body.find('div.disabled-grid').length > 0;
                let existsOnHeader = header.find('div.disabled-grid').length > 0;

                if(value == false){
                        if(!existsOnHeader){
                            header.append(_disabledHeaderDiv);
                        }
    
                       if(!existsOnBody){
                            body.append(_disabledBodyDiv);
                        }                                    
                }else{
                    if(existsOnHeader){
                        _disabledHeaderDiv.remove();
                    }

                    if(existsOnBody){
                        _disabledBodyDiv.remove();
                    }
                }
            }

            function hasCbxColumn() {
                return $scope.hideCbxColumn == false;
            }

            function getLineIndex(evt) {
                let lineIndex = 0;
                if (angular.isDefined(evt)) {
                    const isMultipleSelection = $scope.allowMultipleSelection != false ? true : false;
                    lineIndex = isMultipleSelection && _selectNodes.length > 0 
                        && evt.keyCode == _keymap.ARROW_DOWN ? (_selectNodes.length - 1) : lineIndex;
                }
                return lineIndex;
            }

            function formatValueFormatter() {
                var originalRecords = $scope.dataset.getOriginalRecords();
                for (var i = 0; i < $scope.columnDefs.length; i++) {
                    var column = $scope.columnDefs[i];
                    if (angular.isFunction(column.valueFormatter)) {
                        for (var j = 0; j < originalRecords.length; j++) {
                            var originalRecord = originalRecords[j];
                            if (angular.isUndefined(originalRecord[column.skFieldMdIndex])) {
                                originalRecord[column.skFieldMdIndex] = column.valueFormatter({
                                    value: originalRecord[column.skFieldMdIndex],
                                    data: originalRecord[originalRecord.length - 1],
                                    colDef: column,
                                    column: column,
                                    api: $scope.gridOptions.api,
                                    columnApi: $scope.gridOptions.columnApi,
                                    context: this,
                                    isFilter: true
                                });
                            }
                        }
                    }
                }
            }

            function purgeServerSideCache() {
				let showDoubleView = undefined;
				try {
				   showDoubleView = $scope.datagridInterceptor.getShowDoubleView();
				}
				catch (e) {
				   showDoubleView = false;
				}
				 
				if (showDoubleView && $scope.gridOptions && $scope.gridOptions.api) {
					$scope.gridOptions.api.purgeServerSideCache();
				} else {
					$timeout(function () {
						if ($scope.gridOptions && $scope.gridOptions.api) {
							$scope.gridOptions.api.purgeServerSideCache();
						}
					}, 0, false);
				}
            }

            function setEnableFilterDatePeriod(enable){
                _enableFilterDatePeriod = enable;
            }

            function getTextInput() {
                if (!_editorScope || !_editorScope.editor) {
                    return;
                }

                let inputEl = _editorScope.editor.find('input');

                if (!inputEl || !inputEl.length) {
                    inputEl = _editorScope.editor.find('textarea');
                }
                
                if (!inputEl || !inputEl.length) {
                    return;
                }

                return inputEl;
            }

            function getVisibleRowsCount(){
                let currentGridVerticalRange = $scope.gridOptions.api.getVerticalPixelRange();
                let rowHeight = $scope.gridOptions.rowHeight;

                return Math.floor((currentGridVerticalRange.bottom - currentGridVerticalRange.top) / rowHeight);
            }
        
            function doDragDrop ()  {
                if(angular.isFunction($scope.dropTree)){
                    $scope.dropTree($scope);
                }                
            }

            function tabToNextEditableRow(){
                 var curCol = (_colEditing ? _colEditing.colId : '') || (_self.lastFocusedCell ? _self.lastFocusedCell.colId : undefined);
                 
                 var index = $scope.dataset.getCurrentIndex() ;
                 var fieldEditable= $scope.gridOptions.api.getColumnDef(curCol)?.editable;
                 const value = (evtKeyboard?.keyCode == _keymap.ARROW_DOWN||evtKeyboard?.keyCode == _keymap.ENTER) ? 1 : -1;

                 let row = index+value;

                 if ($scope.clickRowFocus == true) {
                     if (angular.isDefined(clickRow)) {
                        row = clickRow;
                     }
                 }
 
                 if(fieldEditable){
                     $scope.dataset.gotoRow(row).then(function(){
                         selectNodeByIndex(row,true);
                         clearAndSetFocusRow(row, curCol);
                         startEdit(curCol, row);                        
                     })                  
                 }
                             
             }
            function addEventoTeclado(event){
                let recordsLength= $scope.dataset.getRecordsAsObjects().length;
                let selectedIndex = $scope.dataset.getCurrentIndex();
                let lastIndex=recordsLength-1;
                let clickRowFocus=undefined;
                if ($scope.clickRowFocus == true && angular.isDefined(clickRow)) {
                    clickRowFocus = clickRow;
                }
                if(lastIndex==selectedIndex && event.keyCode!=SkConstants.KEY_CODE.UP_ARROW && angular.isUndefined(clickRowFocus)){
                    $scope.dataset.goToInsertionMode();
                  setTimeout(function () {
                      let cpFieldMD = $scope.dataset.getFieldMetadata('CODPROD');
                      
                      if(cpFieldMD.visible && !cpFieldMD.readOnly){
                            startEdit('CODPROD');
                      }
                  },200);
            }}

            function setLockEvent(value){
                _lockEventListeners=value;
             }
            
            function setAwaitSaveToEdit(value) {
                _awaitSaveToEdit = value;
            }

            function dropSelectedRow(){
                const selectedId =  selectedItemTree?.id;
                let prefix;

                if (selectedItemTree.category == 'fields' || selectedItemTree.category ==  'var') {
                    prefix = "$"
                } else {
                    prefix = ":"
                }

                self.text = prefix + selectedId;
                $scope.dataset.setFieldValue('value', self.text);
            }

            function isLockEventListeners(keyCode){
                if(_lockEventListeners) {
                    return true;
                }

                const select = _self.selectScope?.$select;

                if(!select || !select?.open) {
                   return false;
                }

                if([_keymap.ARROW_UP, _keymap.ARROW_DOWN, _keymap.ENTER].includes(keyCode)) {
                    return true;
                }

                return false;
            }
            
            function getEditorOpenned(){
				return _editorOpenned;
			}
    
        }]);

/**
 * Created by bruno.brandao on 03/02/2017.
 */
angular
    .module('snk.components.datagrid')
    .service('DatagridAggridTourContent', ['GridConfig', function(GridConfig) {
        var self = this;

        self.getTourContent = getTourContent;
        self.getGridConfigTourContent = getGridConfigTourContent;

        function getTourContent(datagridController, tourVersion) {
            return {
                startTour: false,
                onFinish: function () {
                    datagridController.closeGridMenu();
                },
                tourConfig: getTourSteps(datagridController, tourVersion)
            }
        }

        function getGridConfigTourContent() {
            return {
                startTour: true,
                onFinish: function () {

                },
                tourConfig: getGridConfigTourSteps()
            }
        }

        function getGridConfigTourSteps() {
            return [
                //Configurador da Grade (GridConfig)
                {
                    type: "title",
                    heading: "Configurador de grade",
                    html: "O configurador de grade permite que você configure quais colunas ficarão visíveis na grade, a ordem em que elas aparecerão, e até mesmo a ordenação inicial dos dados.<br/><br/>" +
                    "Vamos explorar como definir tais configurações...",
                    placement: "center",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: 'function',
                    fn: function() {
                        GridConfig.openGroup(0);
                    }
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-disponiveis",
                    heading: "Colunas disponíveis",
                    html: "Aqui você encontrará as colunas disponíveis. As colunas selecionadas ficam invisíveis na grade.",
                    placement: "right",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-disponiveis-search",
                    heading: "Pesquisa de colunas disponíveis",
                    html: "Através desta pesquisa você pode localizar uma coluna disponível.<br/><br/><a class=\"link\" ng-click=\"fnExperimente()\">Experimente!</a>",
                    actions: {
                        fnExperimente: function () {
                            var input = document.querySelectorAll('.gridconfig-colunas-disponiveis-search sk-text-input input');
                            angular.element(input).focus();
                        }
                    },
                    placement: "right",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-colunas-disponiveis-container",
                    heading: "Colunas disponíveis",
                    html: "Aqui você encontra uma lista com todas as colunas disponíveis, podendo arrastá-las com o mouse (ou com o dedo, se houver suporte) para a lista de colunas selecionadas, caso deseje.",
                    placement: "right",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-all-to-right",
                    heading: "Mover todos para a direita",
                    html: "Este botão move todos os registros da esquerda para a direita.",
                    placement: "bottom",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-selected-to-right",
                    heading: "Mover selecionadas para a direita",
                    html: "Este botão move os registros selecionados da esquerda para a direita.",
                    placement: "bottom",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-selected-to-left",
                    heading: "Mover selecionadas para a esquerda",
                    html: "Este botão move os registros selecionados da direita para a esquerda.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-all-to-left",
                    heading: "Mover todos para a esquerda",
                    html: "Este botão move todos os registros da direita para a esquerda.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-selecionadas",
                    heading: "Colunas selecionadas",
                    html: "Aqui você encontrará as colunas selecionadas. As colunas disponíveis ficam visíveis na grade.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-selecionadas-search",
                    heading: "Pesquisa de colunas selecionadas",
                    html: "Através desta pesquisa você pode localizar uma coluna selecionada para aparecer na grade.<br/><br/><a class=\"link\" ng-click=\"fnExperimente()\">Experimente!</a>",
                    actions: {
                        fnExperimente: function () {
                            var input = document.querySelectorAll('.gridconfig-colunas-selecionadas-search sk-text-input input');
                            angular.element(input).focus();
                        }
                    },
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-colunas-selecionadas-container",
                    heading: "Colunas selecionadas",
                    html: "Aqui você encontra uma lista com todas as colunas selecionadas, podendo arrastá-las com o mouse (ou com o dedo, se houver suporte) para a lista de colunas disponíveis, caso deseje.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-up-all",
                    heading: "Mover para o topo",
                    html: "Este botão move o registro selecionado para a primeira posição.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-up",
                    heading: "Mover para cima",
                    html: "Este botão move os registros selecionados uma posição acima.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-down",
                    heading: "Mover para baixo",
                    html: "Este botão move os registros selecionados uma posição abaixo.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-down-all",
                    heading: "Mover a última posição",
                    html: "Este botão move o registro selecionado para a última posição.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "title",
                    heading: "Ordenação dos dados",
                    html: "Vamos explorar agora a funcionalidade que define a ordenação inicial dos dados na grade. ",
                    placement: "center",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "function",
                    fn: function (next) {
                        if (next) {
                            GridConfig.openGroup(1);
                        } else {
                            GridConfig.openGroup(0);
                        }
                    }
                },
                {
                    type: "title",
                    heading: "Ordenação dos dados",
                    html: "Os registros podem ser ordenados por quaisquer colunas marcadas como selecionadas no passo anterior.<br/><br/>" +
                    "Para ordenar os dados por alguma coluna, basta marcar o checkbox à esquerda. Um ícone aparecerá à direita para que seja configurado se a ordenação será ascendente (crescente) ou descendente (decrescente). Para alterar a configuração, basta clicar no ícone que aparece mais à direita.<br/><br/>" +
                    "A imagem abaixo ilustra uma configuração de ordenação.<br/><br/>" +
                    "<img width='425px' src='/mge/assets/img/grdcfg-ordenacao.PNG'><br/><br/>",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "title",
                    heading: "Ordenação dos dados",
                    html: "A configuração ilustrada pela imagem indica que a grade, ao ser carregada, terá suas linhas ordenadas da seguinte maneira:<br/><br/>" +
                    "Os registros serão ordenados, primeiramente, pela coluna Nome, de forma descendente.<br/><br/>" +
                    "Como segundo critério de ordenação, tem-se a coluna Nome do Correio, configurada para ordenar os registros de forma ascendente.<br/><br/>" +
                    "As demais colunas, como não estão marcadas pelo checkbox, não influenciarão a ordenação dos dados.<br/><br/>" +
                    "<img width='425px' src='/mge/assets/img/grdcfg-ordenacao.PNG'><br/><br/>",
                    placement: "center",
                    scroll: true,
                    attachToBody: true
                }
            ]
        }


        function getTourSteps(datagridController, tourVersion) {
           /**
            * Quando tourVersion for undefined o tour deve ser exibido por comple, não tratando o versionamento.
            */
            var idGrid = datagridController.getGridUniqueId()
            
            var steps =[];
            
            if(!tourVersion || tourVersion <= 2){
                steps.push(
                    {
                        type: "element",
                        heading: "Menu da Grade",
                        selector: "#" + idGrid + '-root' + " .ui-grid-menu-button.ag-grid-menu",
                        html: "O menu da grade exibe uma série de opções relacionadas à mesma.<br/><br/>Vamos conhecê-las...",
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        preventDisableClick: true
                    },
                    {
                        type: "function",
                        fn: function (next) {
                            if (next) {
                                datagridController.openGridMenu();
                            } else {
                                datagridController.closeGridMenu();
                            }
                        }
                    },
                    {
                        type: "element",
                        heading: "Busca de Colunas",
                        selector: "#" + idGrid + '-root' + " .ui-grid-menu .datagrid-menu-item.datagrid-menu-item-search",
                        html: "Muitas colunas na grade? Não se preocupe!<br/><br/>" +
                        "Utilize esta busca para encontrar uma coluna e ir diretamente até ela. Fácil, rápido e eficiente.",
                        placement: "left",
                        scroll: true,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Pesquisar nas Colunas",
                        selector: "#" + idGrid + '-root' + " .ui-grid-menu .datagrid-menu-item.datagrid-search-menu-item",
                        html: "Ao clicar aqui, campos de pesquisa surgirão logo abaixo do nome de cada coluna para que você possa filtrar os registros informando critérios para cada uma delas.",
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        isEnabled: !datagridController.disableSearch()
                    },
                    {
                        type: "element",
                        heading: "Modo Confortável/Compacto",
                        selector: "#" + idGrid + '-root' + " .ui-grid-menu .datagrid-menu-item.datagrid-comfortable-item",
                        html: "Através desta opção é possível configurar a grade para o modo confortável ou modo compacto.<br/><br/>" +
                        "O modo confortável faz com que as linhas da grade fiquem mais largas, tornando-as mais fáceis de serem clicadas.<br/><br/>" +
                        "O modo compacto diminui a largura das linhas, fazendo com que mais dados caibam na tela.",
                        placement: "left",
                        scroll: true,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Selecionar/Deselecionar Todos",
                        selector: "#" + idGrid + '-root' + " .ui-grid-menu .datagrid-menu-item.datagrid-selectall-menu-item",
                        html: "Caso a múltipla seleção esteja disponível para a grade, clicando aqui é possível selecionar e/ou deselecionar todos os registros.</br>" +
                            "Você também pode utilizar o atalho <b> 'Ctrl + A' </b> ." ,
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        isEnabled: datagridController.isAllowMultipleSelection
                    },
                    {
                        type: "element",
                        heading: "Modo Dinâmico",
                        selector: "#" + idGrid + '-root' + " .ui-grid-menu .datagrid-menu-item.datagrid-dynamic-mode-item",
                        html: "Essa opção habilita o modo dinâmico da grade.</br>" + 
                            "Com ela é possível criar agrupamentos e funções de agregação para colunas numéricas. Possibilita também esconder ou apresentar colunas.",
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        isEnabled: datagridController.isEnableDynamicMode
                    },
                    
                    {
                        type: "function",
                        fn: function(next){
                            if(next){ 
                                datagridController.closeGridMenu();
                            }else{
                                datagridController.openGridMenu();
                            } 
                        }
                    },
                    //Modo dinâmico
                    {
                        type: "function",
                        fn: function(next){
                            datagridController.openToolPanel(undefined, next);                        
                        },
                        isEnabled: datagridController.isEnableDynamicMode
                    },
                    {
                        type: "element",
                        heading: "Modo Dinâmico - Seleção de Colunas",
                        selector: "#" + idGrid + " .ag-side-bar .ag-column-panel .ag-column-select-panel",
                        html: "Essa opção habilita o modo dinâmico da grade. Com ela é possível criar agrupamentos e funções de agregação para colunas numéricas. Possibilita também esconder ou apresentar colunas.</br></br>"
                            + "Lembrando que as alterações realizadas aqui são temporárias, logo não são salvas nas configurações da grade.",
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        isEnabled: datagridController.isEnableDynamicMode
                    },
                    {
                        type: "element",
                        heading: "Modo Dinâmico - Agrupamentos",
                        selector: "#" + idGrid + " .ag-side-bar .ag-column-panel .ag-column-drop.ag-column-drop-row-group",
                        html: "Para realizar um agrupamento basta arrastar e soltar uma coluna até esse painel.</br></br>" + 
                            "<img style='margin-left:70px;' src='/mge/assets/img/agrupamento-modo-dinamico.gif' width='240px' height='250px'>",
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        isEnabled: datagridController.isEnableDynamicMode
                    },
                    {
                        type: "element",
                        heading: "Modo dinâmico - Agregação de Colunas",
                        selector: "#" + idGrid + " .ag-side-bar .ag-column-panel .ag-column-drop.ag-column-drop-values",
                        html: "Para realizar agregação de valores de uma coluna numérica basta arrastar e soltá-la nesse painel, depois selecionar a função de agregação desejada.</br></br>" + 
                            "<img style='margin-left:25px;' src='/mge/assets/img/agregacao-modo-dinamico.gif' width='324px' height='260px'>",
                        placement: "left",
                        scroll: true,
                        attachToBody: true,
                        isEnabled: datagridController.isEnableDynamicMode
                        
                    },
                    {
                        type: "function",
                        fn: function(next){
                            datagridController.openToolPanel(undefined, !next);                        
                        },
                        isEnabled: datagridController.isEnableDynamicMode
                    },
                    //Menu das Colunas da Grade
                    {
                        type: "element",
                        heading: "Menu das colunas",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Cada coluna possui um menu com opções referentes à ela, conforme ilustra a imagem a seguir.<br/><br/>" +
                        "<img style='margin-left:10px;' src='/mge/assets/img/menu-grade-aggrid.gif'><br/><br/>" +
                        "Vamos conhecer cada uma delas...",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Ordenar Ascendente",
                        selector: "#" + idGrid + " .ag-header-viewport",
                        html: "Ordena os registros da grade pela coluna selecionada em ordem ascendente (ou crescente).<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt1.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Ordenar Ascendente",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Conforme ilustra a imagem abaixo, após a ordenação, uma barra verde aparecerá sobre a coluna indicando que os registros estão ordenados em ordem ascendente.<br/><br/>" +
                        "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-aggrid-opt1-2.png' width='290px' height='141px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Ordenar Descendente",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Ordena os registros da grade pela coluna selecionada em ordem descendente (ou decrescente).<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt2.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Ordenar Descendente",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Conforme ilustra a imagem abaixo, após a ordenação, uma barra vermelha aparecerá sobre a coluna indicando que os registros estão ordenados em ordem descendente.<br/><br/>" +
                        "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-aggrid-opt2-2.png' width='285px' height='120px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Filtrar",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Filtra os registros da grade.<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt3.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Filtrar",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Conforme ilustra a imagem abaixo, um popup aparecerá para que os registros possam ser filtrados.<br/><br/>" +
                        "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-opt3-2.png' width='284px' height='240px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Agrupar",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Agrupa os registros segundo a coluna indicada.<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt4.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Agrupar",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Conforme ilustra a imagem abaixo, após serem agrupados, uma coluna nova é adicionada à grade para que seja possível expandir e recolher um grupo de registros.<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt4-2.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Fixar Coluna",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Fixa a coluna escolhida no lado esquerdo da grade, fazendo com que a mesma e seu conteúdo estejam sempre visíveis.<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt5.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    },
                    //Scroll infinito da grade 
                    {
                        type: "element",
                        heading: "Scroll Infinito",
                        selector:  "#" + idGrid + ".sk-tour-infinitt-scroll-ref",
                        html: "Agora a grade conta com o scroll infinito. Basta rolar para baixo que os registros são carregados automaticamente de forma inteligente. </br> Maior rapidez e eficiência para você!",
                        placement: "left",
                        scroll: false,
                        attachToBody: true
                    },
                    {
                        type: "element",
                        heading: "Fixar Coluna",
                        selector:  "#" + idGrid + " .ag-header-viewport",
                        html: "Fixa a coluna escolhida no lado esquerdo da grade, fazendo com que a mesma e seu conteúdo estejam sempre visíveis.<br/><br/>" +
                        "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-aggrid-opt5.png' width='324px' height='190px'><br/><br/>",
                        placement: "bottom",
                        scroll: false,
                        attachToBody: true
                    }
                );
            }


            if(!tourVersion || tourVersion <= 3){
                steps.push(
                    {
                        type: "title",
                        heading: "Gráficos na grade",
                        html: "É muito simples criar seus gráficos, basta selecionar os dados que você deseja, clicar com o botão direito do mouse e escolher o tipo de gráfico desejado.<br/><br/>" +                        
                            "<img width='425px' src='/mge/assets/img/chart_datagrid.gif'><br/><br/>",
                        placement: "center",
                        scroll: true,
                        attachToBody: true
                    },
                    {
                        type: "title",
                        heading: "Configuração de Gráficos",
                        html: "Também é possível alterar o tipo de gráfico exibido e sua combinação de cores.<br/><br/>" +
                            "<img width='425px' src='/mge/assets/img/chart_config_datagrid.gif'><br/><br/>",
                        placement: "center",
                        scroll: true,
                        attachToBody: true
                    },
                    {
                        type: "title",
                        heading: "Dados do Gráfico",
                        html: "Você pode alterar a exibição dos dados no gráfico.<br/><br/>" +
                            "<img width='425px' src='/mge/assets/img/chart_datagrid_dados.gif'><br/><br/>",
                        placement: "center",
                        scroll: true,
                        attachToBody: true
                    },
                    {
                        type: "title",
                        heading: "Formatação do Gráfico",
                        html: "E por último, é possível alterar a formatação do gráfico.<br/><br/>" +
                            "<img width='425px' src='/mge/assets/img/chart_datagrid_format.gif'><br/><br/>",
                        placement: "center",
                        scroll: true,
                        attachToBody: true
                    },
                );
            }

            return steps;
            
        }

    }]);

/**
 * Created by cleverson.puche on 10/06/2015.
 */

angular
    .module('snk.components.datagrid')
    .controller('SkDataGridController',

        function ($rootScope, $q, $scope, $attrs, $timeout, $translate, $window, $compile, $element, DatasetEvents,
                  DatasetContants, ObjectUtils, i18nService, StringUtils, uiGridConstants, DateUtils,
                  AngularUtil, DateUtilsConstants, FormService, uiGridEditConstants, SanPopup,
                  UserAgentUtils, SkApplication, KeyboardEvents, ArrayUtils, MessageUtils,
                  NumberUtils, DynaformConstants, ClipboardUtils, ThemeColors, DatagridTourContent, TextAreaPopupService, $injector) {

            $element.data('$skDatagridController', this);

            var GridConfig;

            $injector.invoke(['GridConfigUiGrid', function(gridCfgUiGrid){
                GridConfig = gridCfgUiGrid;
            }]); 

            //Definição das variáveis locais 
            var _self = this;
            var _metaDataUpdated = false;
            var _shiftIsPressed = false;
            var _tabIsPressed = false;
            var _downIsPressed = false;
            var _enterIsPressed = false;
            var _upIsPressed = false;
            var _pagedownIsPressed = false;
            var _pageupIsPressed = false;
            var _programmaticallySelectingRecord = false;
            var _columnMenuClosed = '';
            var _charToPixelRatio = 14;
            var _lastSelectionIndex = -1;
            var _lastSelectedGridRow = undefined;
            var _lastSelectedGridCol = undefined;
            var _footerColumnFound = false;
            var _canEditNow = false;
            var _lockEdition = true;
            var _descriptionFieldNames = {};
            var _lastColumnsSorted = {};
            var _originalColumnDefs = [];
            var _lastColumnFound = undefined;
            var _firstFullLoadCompleted = false;
            var _searchingColumn = false;
            var _lockSort = false;
            var _checkboxColumnClicked = false;
            var _columnMinWidth = 50;
            var _initialSort = false;
            var notifyDatasetOfChangeRowDebounced = AngularUtil.debounce(notifyDatasetOfChangeRow, 150, $scope, true);
            var scrollToFocusDebounced = AngularUtil.debounce(scrollToFocus, 150, $scope, true);
            var _showingMsgColumnNumberException = false;
            var _uiGridCreated = false;
            var _rowClicked = false;
            var _columnDefsByName = {};
            var _focusOnFindColumn;
            var _internalUID = StringUtils.nextUid();
            var _removeActiveFilterFn;
            var _fireDblClick = false;
            var _lastLiveCheckChange = -1;

            var updateGridColumnDebounced = AngularUtil.debounce(updateGridColumn, 150, $scope, true);
            var refreshedDebounced = AngularUtil.debounce(refresh, 155, $scope, true);

            //Colunas personalizadas
            var _onlyCustomColumns = $attrs.hasOwnProperty('skOnlyCustom');
            var _customColumnsMD = {};
            var _onlyCustomOrder = 0;

            var _datagridInterceptor;

            //Definição de constantes
            const SAFETEXT_PORTUGUES = 'Aguarde, carregando os dados da grade...';
            const SAFETEXT_INGLES = 'Wait, loading grid data...';
            const DEFAULT_DECIMAL_PRECISION = 2;
            const CHECKBOX_COLUMN_FIELD = '-100000';

            const ROW_HEIGHT = 35;
            const ROW_HEIGHT_COMPACT = 23;

            var _keymap = {
                TAB: 9,
                STRG: 17,
                CTRL: 17,
                CTRLRIGHT: 18,
                SHIFT: 16,
                ENTER: 13,
                BACKSPACE: 8,
                ALT: 18,
                ALTRIGHT: 17,
                SPACE: 32,
                WIN: 91,
                MAC: 91,
                PG_UP: 33,
                PG_DOWN: 34,
                UP: 38,
                DOWN: 40,
                LEFT: 37,
                RIGHT: 39,
                ESC: 27,
                DEL: 46,
                F1: 112,
                F2: 113,
                F3: 114,
                F4: 115,
                F5: 116,
                F6: 117,
                F7: 118,
                F8: 119,
                F9: 120,
                F10: 121,
                F11: 122,
                F12: 123,
                FN: null
            };

            //Definição das variáveis de escopo
            $scope.viewMode = 'loading';
            $scope.compactMode = !UserAgentUtils.isMobile();
            $scope.lang = $translate.use();
            $scope.records = [];
            $scope.columnDefs = [];
            $scope.existeCampoDeApresentacao = undefined;
            $scope.presentationField = undefined;
            $scope.checkboxHeight = $scope.compactMode ? ROW_HEIGHT_COMPACT : ROW_HEIGHT;
            $scope.allSelected = false;
            $scope.showMenu = false;
            $scope.showingFilters = false;
            $scope.isMobile = UserAgentUtils.isMobile();
            $scope.filterByColumn = {};
            $scope.searchByColumn = {};
            $scope.datagridOperationInProgress = false;

            $timeout(function () {
                $scope.headerCaption = i18nService.getSafeText('sort.headerCaption');
                $scope.columnMenu = i18nService.getSafeText('menu.columnMenu');
                $scope.clearAllSearchText = i18nService.getSafeText('search.clearAllSearch');
                $scope.checkUncheckAllText = i18nService.getSafeText('search.checkUncheckAllText');
                $scope.searchText = i18nService.getSafeText('search.searchText');
                $scope.findColumnText = i18nService.getSafeText('general.findColumn');
                $scope.comfortableModeText = i18nService.getSafeText('general.comfortableMode');
                $scope.compactModeText = i18nService.getSafeText('general.compactMode');
                $scope.lblPagina = i18nService.getSafeText('general.lblPagina');
                $scope.lblDe = i18nService.getSafeText('search.lblOf');
                $scope.lblNenhumaPagina = i18nService.getSafeText('general.lblNenhumaPagina');
                $scope.columnOptionsText = i18nService.getSafeText('general.columnOptionsText');
                $scope.datagridOptionsText = i18nService.getSafeText('general.datagridOptionsText');
                $scope.columnFilterActiveText = i18nService.getSafeText('general.columnFilterActiveText');

                $scope.firstPageText = i18nService.getSafeText('pagination.firstPageText');
                $scope.previousPageText = i18nService.getSafeText('pagination.previousPageText');
                $scope.nextPageText = i18nService.getSafeText('pagination.nextPageText');
                $scope.lastPageText = i18nService.getSafeText('pagination.lastPageText');
                $scope.lblExpandCell = i18nService.getSafeText('general.lblExpandCell');
            }, 0, false);

            //Definição das funções de escopo
            $scope.creationComplete = creationComplete;
            $scope.textToColor = StringUtils.textToColor;
            $scope.buildNick = buildNick;
            $scope.checkAllRows = checkAllRows;
            $scope.cellNavHandler = cellNavHandler;
            $scope.getSelectedItems = getSelectedRecords;
            $scope.keydownHandler = keydownHandler;
            $scope.keyupHandler = keyupHandler;
            $scope.updateGridOptions = updateGridOptions;
            $scope.clearSearch = clearSearch;
            $scope.changeColumnSearchVisibility = changeColumnSearchVisibility;
            $scope.rowClickHandler = rowClickHandler;
            $scope.refresh = refresh;
            $scope.clearDomOfFocusedCell = clearDomOfFocusedCell;
            $scope.checkboxRowClickHandler = checkboxRowClickHandler;
            $scope.lockEdition = lockEdition;
            $scope.endEdit = endEdit;
            $scope.isFiltering = isFiltering;
            $scope.liveCheckChanged = liveCheckChanged;
            $scope.openTextAreaEditor = openTextAreaEditor;

            //Definição das funções públicas
            _self.startTour = startTour;
            _self.setCompactMode = setCompactMode;
            _self.refreshView = refresh;
            _self.getOriginalColumnDefs = getOriginalColumnDefs;
            _self.getColumnByName = getColumnByName;
            _self.getColumnDefs = getColumnDefs;
            _self.getVisibleColumnDefs = getVisibleColumnDefs;
            _self.getDataset = getDataset;
            _self.getScopeId = getScopeId;
            _self.getRecords = getRecords;
            _self.getGridApi = getGridApi;
            _self.enableSearch = enableSearch;
            _self.setFilterByColumn = setFilterByColumn;
            _self.removeFilterByColumn = removeFilterByColumn;
            _self.getFilterFunction = getFilterFunction;
            _self.getCurrentColIndexByColumnDef = getCurrentColIndexByColumnDef;
            _self.resetColumnWidths = resetColumnWidths;
            _self.getColumnWidth = getColumnWidth;
            _self.skSortFunction = skSortFunction;
            _self.endEdit = endEdit;
            _self.updateGridOptions = updateGridOptions;
            _self.updatePinnedColumns = updatePinnedColumns;
            _self.updateGridColumn = updateGridColumn;
            _self.updateAllOptions = updateAllOptions;
            _self.openGridMenu = openGridMenu;
            _self.closeGridMenu = closeGridMenu;
            _self.updateColumnLabels = updateColumnLabels;
            _self.getTotalPages = getTotalPages;
            _self.getCurrentPage = getCurrentPage;
            _self.setSelectedRecords = setSelectedRecords;
            _self.getSelectedRecords = getSelectedRecords;
            _self.unselectAllSelectedRows = unselectAllSelectedRows;
            _self.selectAllRecords = selectAllRecords;
            _self.addCustomColumnMD = addCustomColumnMD;
            _self.openGridConfig = openGridConfig;
            _self.refreshCells = refreshCells;
            _self.isHideCbxColumn = isHideCbxColumn;
            _self.avoidFocusOutWhileEditing = avoidFocusOutWhileEditing;

            _self.setViewModeToLoading = setViewModeToLoading;
            _self.setViewModeToLoaded = setViewModeToLoaded;

            _self.pinColumn = pinColumn;
            _self.unpinColumn = unpinColumn;
            _self.setOnDblClick = setOnDblClick;
            _self.setAllowMultipleSelection = setAllowMultipleSelection;            
            _self.initializeDatagrid = initializeDatagrid;

            //Coloca a grade como um observer do dataset
            ObjectUtils.implements(_self, IDataSetObserver);

            //Caso haja um interceptor, verifica se ele é uma implementação de IDatagridInterceptor
            if ($scope.datagridInterceptor) {
                ObjectUtils.isImplementorOf($scope.datagridInterceptor, IDatagridInterceptor);
            }

            //Definição das funções chamadas pelo dataset
            _self.refreshed = onDatasetRefresh;
            _self.currentLineChanged = onDatasetCurrentLineChanged;
            _self.editionCanceled = editionCanceled;
            _self.dataSaved = dataSaved;
            _self.dataModified = dataModified;

            //Watches & Listeners
            $rootScope.$on('refreshCanvasCompleted',function(evt, targetUID) {
                if($scope.viewMode == 'loading' && _internalUID === targetUID) {
                    $timeout(function() {
                        AngularUtil.apply($scope,setViewModeToLoaded);
                        refresh();
                    }, 500, false);
                }
            });

            $scope.$on("destroy", function () {
                $timeout.cancel();
            });

            $scope.$on('datasetRefreshed', function () {
                $scope.column.distinctData = undefined;
            });

            $scope.$watchCollection('records', function (newVal, oldVal) {
                $timeout(function () {
                    if($scope.gridApi){
                        for (var i = 0; i < $scope.gridApi.grid.columns.length; i++) {
                            var column = $scope.gridApi.grid.columns[i];
                            if (angular.isFunction(column.updateAggregationValue)) {
                                column.updateAggregationValue();
                            }
                        }
                    }
                }, 0, false);
            });

            $scope.$on('hide-menu', function ($event) {
                if (angular.isDefined($event.currentScope.col)) {
                    $event.currentScope.col.colDef.showMenu = false;
                    _columnMenuClosed = $event.currentScope.col.colDef.displayName;
                }
            });

            $scope.$on('menu-hidden', function ($event) {
                if (angular.isDefined($event.currentScope.col)) {
                    if (_columnMenuClosed !== $event.currentScope.col.colDef.displayName && _columnMenuClosed !== "") {
                        _columnMenuClosed = $event.currentScope.col.colDef.displayName;
                    }
                    else {
                        if (angular.isDefined($event.currentScope.col)) {
                            $event.currentScope.col.colDef.showMenu = false;
                            _columnMenuClosed = $event.currentScope.col.colDef.displayName;
                        }
                    }
                }
            });

            $scope.$on('datagridRecalculate', function ($event) {
                refresh();
            });

            $scope.$watch('dataset', function(newV) {
                if (newV) {
                    var fn = function () {
                        initializeDatagrid();
                        _metaDataUpdated = true;
                    };

                    if ($scope.dataset.isLoaded()) {
                        fn();
                    }

                    //Executada quando o evento "Metadata updated" do dataset é disparado
                    $scope.dataset.addEventListener(DatasetEvents.ON_METADATA_UPDATED, fn);
                }
            });

            init();

            function init() {
            	$attrs.$observe('skGridConfig', updateGridConfigName);
                $attrs.$observe('skConfigName', updateGridConfigName);                
            }
            
            function updateGridConfigName(gridConfigName) {
            	$scope.gridconfig = gridConfigName;
            	
            	//Registra o controlador da grade para o gridconfig informado, caso ele exista
 	           if ($scope.gridconfig) {
 	               GridConfig.registerTargetGridController($scope.gridconfig, _self);
 	           }
            }

            function openGridConfig(options) {
                if ($scope.gridconfig) {
                    GridConfig.openGridconfig($scope.gridconfig, options);
                }
            }

            function startTour() {
                if (!$scope.tour) {
                    $scope.tour = DatagridTourContent.getTourContent(_self);
                }

                $scope.tour.startTour = true;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#refresh
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Função que solicita o recálculo das dimensões internas e externas do Datagrid.<br/>
             *  Esta função não contacta o Dataset para atualizar dados ou metadados.<br/>
             *  <b><i>Renderization cost-level: high</i></b>
             * @example datagridController.refesh();
             */
            function refresh() {
                $scope.$broadcast('uiGridRecalculate');
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#refreshCells
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Função que solicita o update das celulas do grid.<br/>
             *  Usado quando o valor é modificado programaticamente dentro da lista.<br/>
             * @example datagridController.refreshCells();
             */
            function refreshCells() {
                if ($scope.gridApi && $scope.gridApi.grid) {
                    $scope.gridApi.grid.callDataChangeCallbacks('edit');
                }
            }

            function isHideCbxColumn() {
              return ($scope.hideCbxColumn !== true);
            }

            function avoidFocusOutWhileEditing(){
                return $scope.avoidFocusOutWhileEditing ? $scope.avoidFocusOutWhileEditing : false;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#setCompactMode
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Função utilizada para alterar o modo de visuzalição da grade.<br/>
             *  No caso de apesentação mobile, o padrão é sempre não compacto.<br/>
             * @param {boolean} isCompact Se a visualização será compacta ou não
             * @param {boolean} force Usado para forçar o set mesmo em mobile
             */
            function setCompactMode(isCompact, force) {
                if (force || !UserAgentUtils.isMobile()) {
                    $scope.compactMode = isCompact;

                    $scope.checkboxHeight = isCompact ? ROW_HEIGHT_COMPACT : ROW_HEIGHT;
                    $scope.datagrid.rowHeight = isCompact ? ROW_HEIGHT_COMPACT : ROW_HEIGHT;
                }
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para a coleção de colunas do Datagrid. <br/>
             *  OBS1: Serão retornadas as colunas de agrupamento, checkbox, metadados do Datagrid e a coluna em branco. <br/>
             *  OBS2: Qualquer alteração realizada nas colunas refletirá no Datagrid por tratar-se de uma referência. <br/>
             *    Recomenda-se fazer uma cópia da lista retornada e trabalhar em cima da cópia.
             * @example var columnDefsCollection = datagridController.getColumnDefs();
             */
            function getColumnDefs() {
                return $scope.columnDefs;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getOriginalColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para a coleção de colunas originais do Datagrid, vindas do Dataset. <br/>
             *  OBS: Alterações de posicionamento e redimensionamento de colunas não serão vistas na coleção retornada. Para isso
             *  utilize o método <i>getColumnDefs()</i>
             * @example var originalColumnDefsCollection = datagridController.getOriginalColumnDefs();
             */
            function getOriginalColumnDefs() {
                return _originalColumnDefs;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getColumnByName
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para os metadados da coluna com este fieldName.
             * @param {string} fieldName Nome da coluna.
             * @return {object} Metadados da coluna
             * @example <pre>datagridController.getColumnByName();</pre>
             */
            function getColumnByName(fieldName) {
                return _columnDefsByName[fieldName];
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#isEditable
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Informa se a grade é editável ou não
             * @return {object} True caso a grade seja editável, false do contrário
             * @example <pre>datagridController.isEditable();</pre>
             */
            function isEditable() {
                return $scope.editable;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getVisibleColumnDefs
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma lista (cópia) apenas com os metadados visíveis na grade no momento da chamada da função. <br/>
             *  OBS: As colunas de agrupamento, checkbox e a coluna em branco não são retornadas.
             * @example var visibleColumnDefsCollection = datagridController.getVisibleColumnDefs();
             */
            function getVisibleColumnDefs() {
                if ($scope.gridApi) {
                    var result = [];
                    var startIndex = ($scope.hideCbxColumn !== true) ? 2 : 1;

                    for (var i = startIndex; i < $scope.gridApi.grid.columns.length - 1; i++) {
                        var col = $scope.gridApi.grid.columns[i];
                        if (col.colDef.visible) {
                            result.push(col.colDef);
                        }
                    }

                    return result;
                } else {
                    return [];
                }
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getGridApi
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna a API do componente 'ui-grid'.<br/>
             *  Através da API é possível alterar, em tempo de execução, as configurações do Datagrid.
             * @example var datagridApi = datagridController.getGridApi();
             */
            function getGridApi() {
                return $scope.gridApi;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getDataset
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para o Dataset no qual o Datagrid está baseado.<br/>
             * @example var dataset = datagridController.getDataset();
             */
            function getDataset() {
                return $scope.dataset;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getScopeId
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna o ID do escopo do controlador, criado pela diretiva.<br/>
             * @example var datagridScopeID = datagridController.getScopeId();
             */
            function getScopeId() {
                return $scope.$id;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna uma referência para a coleção de registros apresentados no Datagrid no momento da chamada da função.<br/>
             * @example var recordsCollection = datagridController.getRecords();
             */
            function getRecords() {
                return $scope.records;
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#updateColumnLabels
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Atualiza os labels das colunas da grade com base no metadados do dataset.<br/>
             *  Utilize esta função quando os labels das colunas forem alterados no dataset.
             */
            function updateColumnLabels() {
                var fieldsMD = $scope.dataset.getFieldsMetadata();

                for (var i = 0, length = fieldsMD.length; i < length; i++) {
                    for (var j = 0, lenghtj = $scope.columnDefs.length; j < lenghtj; j++) {
                        if (fieldsMD[i].name == $scope.columnDefs[j].skName) {
                            var colDef = $scope.columnDefs[j];
                            var fieldMD = fieldsMD[i];

                            colDef.displayName = fieldMD.description;

                            var isEditable = isFieldMDEditable(fieldMD);

                            colDef.enableCellEdit = isEditable;
                            colDef.enableCellEditOnFocus = isEditable;
                            break;
                        }
                    }
                }

                updateGridColumn();
            }

            function setInitialSort(value) {
                _initialSort = value;
            }

            function creationComplete() {
                //Nada a fazer.
            }

            function setViewModeToLoading() {
                $scope.viewMode = 'loading';
            }

            function buildNick(row) {
                var descr = row.entity[$scope.presentationField];

                if (StringUtils.isEmpty(descr)) {
                    var pkField = $scope.dataset.getPrimaryKeys()[0];

                    if (pkField) {
                        var pkFieldIndex = $scope.dataset.getFieldIndexByName(pkField);

                        var pkValue = row.entity[pkFieldIndex];

                        if (angular.isNumber(pkValue)) {
                            descr = StringUtils.stringZero(pkValue, 3, false);
                        } else {
                            descr = pkValue;
                        }
                    }
                }

                if (descr && angular.isFunction(descr.trim)) {
                    descr = descr.trim();

                    return descr.substr(0, Math.min(3, descr.length)).toUpperCase();
                } else {
                    return '';
                }
            }

            function setViewModeToLoaded() {
                $scope.viewMode = 'loaded';
                refreshCheckboxHeaderState();
            }

            //Define o idioma da grade
            i18nService.setCurrentLang($scope.lang);

            //Não é possível buscar a internacionalização a partir do arquivo de configuração do ui-grid
            //pois seria necessário aguardar 1 ciclo digest, atrasando assim a apresentação da mensagem.
            //Por isso, setamos o stateText de forma manual no ciclo atual.
            if ($scope.lang == 'pt_BR') {
                $scope.stateText = SAFETEXT_PORTUGUES;
            }
            else if ($scope.lang == 'en_US') {
                $scope.stateText = SAFETEXT_INGLES;
            }

            //Por padrão, habilitamos a edição na grade caso o atributo 'sk-edition-mode' não seja informado
            if ($scope.editable === undefined) {
                $scope.editable = true;
            }

            //Por padrão, habilitamos a múltipla seleção na grade caso o atributo 'sk-allow-multiple-selection' não seja informado
            if ($scope.allowMultipleSelection === undefined) {
                $scope.allowMultipleSelection = true;
            }

            //Definição das configurações da grade
            $scope.datagrid = {
                internalUID: _internalUID,
                data: 'records',
                columnDefs: $scope.columnDefs,
                enableFiltering: true,
                enableColumnResizing: true,
                enableRowHeaderSelection: false,
                enableRowSelection: true,
                enableSelectAll: true,
                multiSelect: $scope.allowMultipleSelection,
                showGridFooter: false,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                modifierKeysToMultiSelect: true,
                showColumnFooter: true,
                noUnselect: true,
                enableMinHeightCheck: false,
                enableSelectionBatchEvent: true,
                rowHeight: $scope.compactMode ? ROW_HEIGHT_COMPACT : ROW_HEIGHT,
                selectionRowHeaderWidth: $scope.selectionRowHeaderWidth,
                rowTemplate: 'components/datagrid/templates/uigridrow.tpl.html',
                useExternalSorting: true,
                useExternalFiltering: true,
                externalSortFunction: skSortFunction,
                externalFilterFunction: skFilterFunction,
                browser: UserAgentUtils.getBrowserInfo(),
                dblClickHandler: function(element, row, rowIndex) {
                    _fireDblClick = true;

                    //Se a linha clicada já é a corrente, então já disparamos o DblClick
                    //Se não é, o pós troca de linha fará o serviço.
                    if (rowIndex == $scope.dataset.getCurrentIndex()) {
                        fireDblClickIfNeeded();
                    }
                },
                focusOnFindColumn: !UserAgentUtils.isIOS(),
                //headerRowHeight: 20, --- ATRIBUTO DEFNIDO VIA CSS, CONSULTE uigridheadercell.tpl.html e datagrid.less
                onSortColumnStart: onSortColumnStart,
                gridMenuCustomItems: getDatagridMenu(),
                onRegisterApi: function (gridApi) {
                    $scope.gridApi = gridApi;

                    $scope.gridApi.colResizable.on.columnSizeChanged($scope, function (colDef, deltaChange, newWidth) {
                        if ($scope.gridconfig) {
                            GridConfig.updateColumnWidth($scope.gridconfig, colDef.skName, deltaChange, newWidth);
                        } else if(angular.isDefined($scope.columnDefs)) {
                        	for(var i = 0, len = $scope.columnDefs.length; i < len; i++) {
                        		var columnDef = $scope.columnDefs[i];
                        		if(columnDef.skName === colDef.skName) {
                        			if(angular.isDefined(newWidth)) {
                        				columnDef.width = newWidth;
                        			} else if(angular.isDefined(deltaChange)) {
                        				columnDef.width += deltaChange;
                        			}
                        			break;
                        		}
                        	}
                        }
                        refresh();
                    });

                    $scope.gridApi.colMovable.on.columnPositionChanged($scope, function (colDef, originalPosition, newPosition) {
                        //Nesse contexto, estamos lidando com o objeto Column do ui-grid.
                        //Sendo assim, newPosition e originalPosition devem ser subtraídos de 2 (descontamos a coluna de agrupamento e a
                        //coluna de checkbox)
                        if ($scope.gridconfig) {
                            GridConfig.updateColumnOrder($scope.gridconfig, originalPosition - 2, newPosition - 2);
                        }
                    });

                    if ($scope.dataset) {
                        if ($scope.gridApi.grid.rows[$scope.dataset.getCurrentIndex()]) {
                            $scope.gridApi.grid.rows[$scope.dataset.getCurrentIndex()].isSelected = true;
                            refreshCheckboxHeaderState();
                        }
                    }

                    $scope.gridApi.selection.on.rowSelectionChangedBatch($scope, function (changedRows, event) {
                        endEdit();
                    });

                    $scope.gridApi.selection.on.rowSelectionChanged($scope, function (row, event) {
                        endEdit();
                        if (row && UserAgentUtils.isMobile()) {
                            var rowIndex = getEntityIndex(row.entity);
                            if (rowIndex && rowIndex != $scope.dataset.getCurrentIndex() && getSelectedRecords().length == 1) {
                                //A linha atual no dataset só é modificada caso não aja mais de um registro selecionado
                                notifyDatasetOfChangeRowDebounced(row, true);
                            }
                        }
                    });

                    $scope.gridApi.cellNav.on.navigate($scope, function (newRowCol, oldRowCol, evt) {
                        onCellNavigate(newRowCol, oldRowCol, evt);
                    });

                    $scope.gridApi.pagination.on.paginationChanged($scope, function (currentPage, paginationSize) {
                        if (angular.isDefined($scope.gridApi.grid.previousPageByPageUp) && $scope.gridApi.grid.previousPageByPageUp) {
                            var scrollHeight = $scope.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[1].scrollHeight;
                            $scope.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[1].scrollTop = scrollHeight;
                            $scope.gridApi.grid.previousPageByPageUp = false;
                        }
                        clearDomOfFocusedCell();
                    });

                    $scope.gridApi.edit.on.afterCellEdit($scope, function (entity, cellModel, colDef, origCellValue) {
                        if(!_enterIsPressed) {
                            $scope.gridApi.grid.isEditing = false;
                        }
                    });

                    $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {

                    });

                    $scope.gridApi.pinning.on.columnPinned($scope, function (colDef, container, programatically) {
                        if (!programatically && $scope.gridconfig) {
                            GridConfig.togglePinColumn($scope.gridconfig, colDef, angular.isDefined(container));
                        }

                        colDef.pinnedLeft = angular.isDefined(container);
                    });

                    if($scope.disablePagination === true) {
                        $scope.datagrid.enablePagination = false;
                        $scope.datagrid.enablePaginationControls = false;
                    } else {
                        $scope.datagrid.enablePagination = true;
                        $scope.datagrid.columnVirtualizationThreshold = 30;
                        $scope.datagrid.excessColumns = 20;
                        $scope.datagrid.excessRows = 5;
                        $scope.datagrid.paginationPageSizes = [38];
                        $scope.datagrid.paginationPageSize = 38;
                    }
                }
            }

            /*if($scope.datagridInterceptor) {
                $scope.datagrid.getCellValue = function(row, col) {
                    var rowAsObject = $scope.dataset.getRowAsObject(row.entity);
                    return $scope.datagridInterceptor.getCellValue(rowAsObject, col.colDef.skName);
                }
            }*/

            function getDatagridMenu() {
                return [
                    {
                        templateUrl: 'components/datagrid/templates/gridmenuitems/findcolumn.tpl.html',
                        skGridMenuID: 'findColumn',
                        context: $scope,
                        order: 0,
                        shown: function () {
                            return true;
                        },
                        action: function ($event) {
                            $event.stopPropagation();
                        }
                    }
                ].concat(($scope.disableSearch === true) ? [] : [
                    {
                        templateUrl: 'components/datagrid/templates/gridmenuitems/search.tpl.html',
                        skGridMenuID: 'search',
                        order: 1,
                        shown: function () {
                            return !$scope.showingFilters;
                        },
                        action: function ($event) {
                            enableSearch();
                        }
                    },
                    {
                        templateUrl: 'components/datagrid/templates/gridmenuitems/clearsearch.tpl.html',
                        skGridMenuID: 'clearAllSearch',
                        order: 1,
                        context: $scope,
                        action: function ($event) {
                            clearSearch();
                            changeColumnSearchVisibility(true, false);
                        },
                        shown: function () {
                            return $scope.showingFilters;
                        }
                    }
                ]).concat([
                    {
                        templateUrl: 'components/datagrid/templates/gridmenuitems/comfortablemode.tpl.html',
                        skGridMenuID: 'comfortableMode',
                        order: 2,
                        action: function ($event) {
                            setCompactMode(false);
                            GridConfig.setCompactMode($scope.gridconfig, false);
                            for (var i = 0; i < $scope.gridApi.grid.gridMenuScope.menuItems.length; i++) {
                                var menuItem = $scope.gridApi.grid.gridMenuScope.menuItems[i];
                                if (menuItem.skGridMenuID === 'comfortableMode') {
                                    menuItem.shown = function () {
                                        return false;
                                    }
                                }
                                else if (menuItem.skGridMenuID === 'compactMode') {
                                    menuItem.shown = function () {
                                        return true;
                                    }
                                }
                            }
                            updateGridOptions();
                        },
                        shown: function () {
                            return $scope.compactMode;
                        }
                    },
                    {
                        templateUrl: 'components/datagrid/templates/gridmenuitems/compactmode.tpl.html',
                        skGridMenuID: 'compactMode',
                        order: 2,
                        action: function ($event) {
                            setCompactMode(true);
                            GridConfig.setCompactMode($scope.gridconfig, true);
                            for (var i = 0; i < $scope.gridApi.grid.gridMenuScope.menuItems.length; i++) {
                                var menuItem = $scope.gridApi.grid.gridMenuScope.menuItems[i];
                                if (menuItem.skGridMenuID === 'comfortableMode') {
                                    menuItem.shown = function () {
                                        return true;
                                    }
                                }
                                else if (menuItem.skGridMenuID === 'compactMode') {
                                    menuItem.shown = function () {
                                        return false;
                                    }
                                }
                            }
                            updateGridOptions();
                        },
                        shown: function () {
                            return !$scope.compactMode;
                        }
                    },
                ]).concat(($scope.disableTour === true) ? [] : [
                    {
                        templateUrl: 'components/datagrid/templates/gridmenuitems/inittour.tpl.html',
                        skGridMenuID: 'initTour',
                        order: 3,
                        action: startTour,
                        shown: function () {
                            return true;
                        }
                    }
                ]);
            }

            function fireDblClickIfNeeded() {
                if (_fireDblClick && angular.isFunction($scope.onDblClick)) {
                    endEdit();
                    $timeout(function () {
                        $scope.onDblClick();
                    }, 0, false);
                }

                _fireDblClick = false;
            }

            function onCellNavigate(newRowCol, oldRowCol, evt) {
                if (_tabIsPressed && _lastSelectedGridRow == newRowCol.row) {
                    endEdit();
                    _canEditNow = true;
                    return;
                }

                if(evt && evt.keyCode == 13 && evt.shiftKey) {
                    _canEditNow = false;
                    endEdit();
                    return;
                }

                if (oldRowCol && newRowCol && (newRowCol.row !== oldRowCol.row || (evt && evt.keyCode == 13))) {
                    cellNavHandler(newRowCol, oldRowCol, evt);
                    refreshCheckboxHeaderState();

                    if(evt && evt.keyCode == 13) {
                        if(newRowCol.row == oldRowCol.row && $scope.gridApi.grid.rows.indexOf(newRowCol.row) == ($scope.gridApi.grid.rows.length - 1)) {
                            _enterIsPressed = false;
                            _canEditNow = false;
                            endEdit();
                        }

                        _lastSelectedGridRow = newRowCol.row;
                    }

                    _rowClicked = false;

                    return;
                }

                if (!_rowClicked && !_enterIsPressed && !_tabIsPressed && !_pagedownIsPressed && !_pageupIsPressed) {
                    _canEditNow = false;
                    endEdit();

                    return;
                }

                _rowClicked = false;

                if (!_checkboxColumnClicked && _lastSelectedGridCol === newRowCol.col && (_lastSelectedGridRow === newRowCol.row|| oldRowCol == newRowCol)) {
                    _canEditNow = true;
                }
                else {
                    endEdit();

                    if (_lastSelectedGridRow != newRowCol.row) {
                        if(angular.isUndefined(oldRowCol)) {
                            _lastSelectedGridRow = newRowCol.row;
                        }
                        cellNavHandler(newRowCol, oldRowCol);
                        _canEditNow = false;
                    }
                    else if (_lastSelectedGridCol != newRowCol.col) {
                        _lastSelectedGridCol = newRowCol.col;
                        if (!_checkboxColumnClicked && _lastSelectedGridRow === newRowCol.row) {
                            _canEditNow = true;
                        }
                    }

                    if ($scope.dataset.getSelectedRecords() != getSelectedRecords()) {
                        $scope.dataset.setSelectedRecords(getSelectedRecords());
                        refreshCheckboxHeaderState();
                    }

                    if (_checkboxColumnClicked) {
                        _checkboxColumnClicked = false;
                    }
                }
            }

            function skFilterFunction(params) {
                var column = params.column;
                var columnIndex = $scope.gridApi.grid.columns.indexOf(column);
                var filter = params.filters;
                var regexpFlags = 'i'; //Case insensitive

                if (_originalColumnDefs.indexOf(column.colDef) < 0) {
                    column.isFiltering = false;
                    return;
                }

                if ($scope.searchByColumn.hasOwnProperty(columnIndex) && $scope.searchByColumn[columnIndex] == filter[0].term) {
                    return;
                }

                $scope.searchByColumn[columnIndex] = filter[0].term;

                if (_removeActiveFilterFn) {
                    _removeActiveFilterFn();
                }

                var filterFn = getFilterFunction(regexpFlags, column);

                _removeActiveFilterFn = $scope.dataset.addFilterFunction(filterFn);

                $scope.dataset.filterRecords();
            }

            function getFilterFunction(regexpFlags, column) {
                var setIsFiltering = function (value) {
                    if (column) {
                        column.isFiltering = value;
                    }
                };

                var getColumnFromColumnDef = function(columDef) {
                    return ArrayUtils.find($scope.gridApi.grid.columns, function(col) {
                        return col.colDef == columDef;
                    });
                };

                var filterFunction = function (value) {
                    //Realiza o filtro baseado nas informações do filtro por coluna ("distinct filter")
                    for (var field in $scope.filterByColumn) {
                        var containsRE;
                        var valueIndex = field;
                        if (valueIndex < 0) {
                            continue;
                        }

                        let columnsValues = StringUtils.replaceAccentuatedChars($scope.filterByColumn[field]);
                        containsRE = new RegExp(columnsValues, regexpFlags);

                        if (_originalColumnDefs[valueIndex]) {
                            var colDef = _originalColumnDefs[valueIndex];
                            var col = getColumnFromColumnDef(colDef);

                            var columnValue = StringUtils.replaceAccentuatedChars(colDef.cellFormatter(col, value[valueIndex]));

                            if (!containsRE.test(StringUtils.replaceAccentuatedChars(columnValue))) {
                                setIsFiltering(true);
                                return false;
                            }
                        }
                    }

                    //Realiza o filtro baseado nas informações de pesquisa nas colunas (texto digitado)
                    for (var field in $scope.searchByColumn) {
                        var containsRE;
                        var valueIndex = _originalColumnDefs.indexOf($scope.gridApi.grid.columns[field].colDef);
                        if (valueIndex < 0) {
                            continue;
                        }

                        if (StringUtils.isEmpty($scope.searchByColumn[field])) {
                            continue;
                        }

                        var textTerm = $scope.searchByColumn[field].replace(/[!@#\$%\^\&*\)\(+=._-]+/gi, function (v) {
                            return '\\' + v;
                        });

                        //startsWithRE = new RegExp('^' + textTerm, regexpFlags);
                        containsRE = new RegExp(StringUtils.replaceAccentuatedChars(textTerm), regexpFlags);

                        if (_originalColumnDefs[valueIndex]) {
                            var colDef = _originalColumnDefs[valueIndex];
                            var col = getColumnFromColumnDef(colDef);

                            var columnValue = StringUtils.replaceAccentuatedChars(colDef.cellFormatter(col, value[valueIndex]));

                            if (!containsRE.test(columnValue)) {
                                return false;
                            }
                        }
                    }

                    return true;
                };

                return filterFunction;
            }

            function skSortFunction(params) {
                if (_lockSort) {
                    removeDatagridProgressBar();
                    return;
                }

                var columns = params.columns;
                var rows = params.rows;

                var sortCols = [];
                var lastColToPositioning = _lastSelectedGridCol;

                columns.forEach(function (col) {
                    if (col.sort && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
                        sortCols.push(col);
                        lastColToPositioning = col;
                    }
                });

                //O controle abaixo é necessário, pois o ui-grid chama essa função a cada CellNav.
                //Sendo assim, verificamos se é necessário reordenar.
                var nothingToDo = true;
                for (var i = 0; i < sortCols.length; i++) {
                    if (_lastColumnsSorted.hasOwnProperty(sortCols[i].colDef.name) && _lastColumnsSorted[sortCols[i].colDef.name].direction == sortCols[i].sort.direction && _lastColumnsSorted[sortCols[i].colDef.name].priority == sortCols[i].sort.priority) {
                        continue;
                    }
                    else {
                        _lastColumnsSorted[sortCols[i].colDef.name] = {
                            direction: sortCols[i].sort.direction,
                            priority: sortCols[i].sort.priority
                        };

                        nothingToDo = false;
                    }
                }
                if (nothingToDo) {
                    removeDatagridProgressBar();
                    return;
                }

                if (sortCols.length === 0) {
                    if ($scope.dataset.existsSortFunction()) {
                        $scope.dataset.removeSort();
                        _lastColumnsSorted = {};
                    }
                    removeDatagridProgressBar();
                    return;
                }

                sortCols = sortCols.sort(prioritySort);

                // Re-usable variables
                var col, direction;

                // put a custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
                var setIndex = function (row, idx) {
                    row.entity.$$uiGridIndex = idx;
                };
                rows.forEach(setIndex);

                // IE9-11 HACK.... the 'rows' variable would be empty where we call rowSorter.getSortFn(...) below. We have to use a separate reference
                // var d = data.slice(0);
                var r = rows.slice(0);

                // Now actually sort the data
                var rowSortFn = function (a, b) {
                    var tem = 0,
                        idx = 0,
                        sortFn;

                    while (tem === 0 && idx < sortCols.length) {
                        // grab the metadata for the rest of the logic
                        col = sortCols[idx];
                        direction = sortCols[idx].sort.direction;

                        sortFn = getSortFn(col);

                        var valueA = a[col.field];
                        var valueB = b[col.field];

                        if (col.colDef.dataType == 'S'){
                            valueA = col.colDef.cellFormatter(col, a[col.field], a);
                            valueB = col.colDef.cellFormatter(col, b[col.field], b);
                        }

                        tem = sortFn(valueA, valueB);

                        idx++;
                    }

                    // Chrome doesn't implement a stable sort function.  If our sort returns 0
                    // (i.e. the items are equal), and we're at the last sort column in the list,
                    // then return the previous order using our custom
                    // index variable
                    if (tem === 0) {
                        return a.$$uiGridIndex - b.$$uiGridIndex;
                    }


                    // Made it this far, we don't have to worry about null & undefined
                    if (direction === uiGridConstants.ASC) {
                        return tem;
                    } else {
                        return 0 - tem;
                    }
                };

                var currentGridRowEntity = _lastSelectedGridRow != undefined ? _lastSelectedGridRow.entity : undefined;

                $scope.dataset.setSortFunction(rowSortFn);
                $scope.dataset.sortRecords();

                // remove the custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
                var clearIndex = function (row, idx) {
                    delete row.entity.$$uiGridIndex;
                };
                rows.forEach(clearIndex);

                $timeout(function () {
                    navigateToCurrentRow();
                    removeDatagridProgressBar();
                }, 0, false);
            }

            function navigateToCurrentRow() {
                var currentIndex = $scope.dataset.getCurrentIndex() + 1;
                var rowPage = Math.max(Math.ceil(currentIndex / $scope.datagrid.paginationPageSize), 1);
                if (rowPage > 0) {
                    $scope.gridApi.pagination.seek(rowPage);
                }
            }

            function prioritySort(a, b) {
                // Both columns have a sort priority
                if (a.sort.priority !== undefined && b.sort.priority !== undefined) {
                    // A is higher priority
                    if (a.sort.priority < b.sort.priority) {
                        return -1;
                    }
                    // Equal
                    else if (a.sort.priority === b.sort.priority) {
                        return 0;
                    }
                    // B is higher
                    else {
                        return 1;
                    }
                }
                // Only A has a priority
                else if (a.sort.priority || a.sort.priority === 0) {
                    return -1;
                }
                // Only B has a priority
                else if (b.sort.priority || b.sort.priority === 0) {
                    return 1;
                }
                // Neither has a priority
                else {
                    return 0;
                }
            }

            function getSortFn(col) {
                switch (col.colDef.type) {
                    case "number":
                    case "time" :
                        return sortNumber;
                    case "string":
                        return sortAlpha;
                    case "date":
                        return sortDate;
                    case "datetime":
                        return sortDate;
                    default:
                        throw new Error('No sorting function found for type:' + col.colDef.type);
                }
            }

            function handleNulls(a, b) {
                // We want to allow zero values and false values to be evaluated in the sort function
                if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                    // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                    if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                        return 0;
                    }
                    else if (!a && a !== 0 && a !== false) {
                        return -1;
                    }
                    else if (!b && b !== 0 && b !== false) {
                        return 1;
                    }
                }
                return null;
            }

            function sortNumber(a, b) {
                var nulls = handleNulls(a, b);
                if (nulls !== null) {
                    return nulls;
                } else {
                    return a - b;
                }
            }

            function sortAlpha(a, b) {
                var nulls = handleNulls(a, b);
                if (nulls !== null) {
                    return nulls;
                } else {
                    var strA = a.toString().toLowerCase(),
                        strB = b.toString().toLowerCase();

                    return strA === strB ? 0 : (strA < strB ? -1 : 1);
                }
            }

            function sortDate(a, b) {
                var nulls = handleNulls(a, b);
                if (nulls !== null) {
                    return nulls;
                } else {
                    var timeA = a.getTime(),
                        timeB = b.getTime();

                    return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
                }
            }

            function removeDatagridProgressBar() {
                $scope.datagridOperationInProgress = false;
            }

            function clearDomOfFocusedCell() {
                $scope.$broadcast('skClearDomOfFocusedCell');
                if($scope.gridApi){
                	$scope.gridApi.grid.cellNav.clearFocus();
                }
            }

            function updateGridOptions() {
                updatePinnedColumns();

                if ($scope.gridApi) {
                    $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
                }

                setFocusAfter();
            }

            function updateGridColumn() {
                if ($scope.gridApi) {
                    $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                }
            }

            function updateAllOptions() {
                if ($scope.gridApi) {
                    $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                }
            }

            function updatePinnedColumns() {
                if ($scope.gridconfig) {
                    var pinnedColumns = GridConfig.getPinnedColumns($scope.gridconfig);

                    if (pinnedColumns && pinnedColumns.length > 0) {
                        pinnedColumns.forEach(function (pinnedColumn) {
                            var colDef = _columnDefsByName[pinnedColumn];

                            if (colDef) {
                                colDef.pinnedLeft = true;
                            }
                        });
                    }
                }
            }

            function pinColumn(fieldName) {
                var column = getGridColumn(fieldName);
                
                if (column) {
                    $scope.gridApi.pinning.pinColumn(column, 'left', true);
                }
            }

            function unpinColumn(fieldName) {
                var column = getGridColumn(fieldName);
                
                if (column) {
                    $scope.gridApi.pinning.pinColumn(column, '', true);
                }
            }

            function getGridColumn(fieldName) {
                if ($scope.gridApi && $scope.gridApi.grid) {
                    return ArrayUtils.find($scope.gridApi.grid.columns, function(col) {
                        return col.colDef.skName == fieldName;
                    });
                }
            }

            function setFocusAfter() {
                if ($scope.focusToAfterRefresh && angular.isElement($scope.focusToAfterRefresh[0])) {
                    angular.element($scope.focusToAfterRefresh[0]).focus();
                }
            }

            function resetColumnWidths() {
                for (var i = 0; i < $scope.gridApi.grid.columns.length; i++) {
                    var column = $scope.gridApi.grid.columns[i];
                    if (column.colDef && column.colDef.displayName) {
                        var internalColumn = $scope.gridApi.grid.getColumn(column.colDef.field);
                        internalColumn.width = getColumnWidth(column.colDef.displayName);
                        column.colDef.width = column.width;
                    }
                }
                refresh();
            }

            $scope.$on(DynaformConstants.EVENT_METADATA_UPDATED, function () {
                updateColumnLabels();
            });

            $scope.onSelectEntity = function (item) {
                clearLastColumnFoundHighlight();

                _lastColumnFound = parseInt(item.key);
                $scope.gridApi.grid.columns[_lastColumnFound].highlight = true;
                _enterIsPressed = false;

                $scope.$broadcast('hide-menu');

                scrollTo(0, _lastColumnFound);
            }

            $scope.loadSuggestions = function (value) {
                _searchingColumn = true;

                var deferred = $q.defer();

                var suggestions = [];
                for (var i = 0; i < $scope.gridApi.grid.columns.length - 1; i++) {
                    var column = $scope.gridApi.grid.columns[i];
                    if (column.visible && column.field >= 0 && (value === '' || (StringUtils.isEmpty(value) || StringUtils.replaceAccentuatedChars(column.displayName).toLowerCase().indexOf(StringUtils.replaceAccentuatedChars(value).toLowerCase()) > -1))) {
                        var suggestion = {
                            key: i,
                            label: column.displayName
                        };
                        suggestions.push(suggestion);
                    }
                }
                suggestions = ArrayUtils.sortByProperty(suggestions, "label", sortAlpha);
                deferred.resolve(suggestions);
                return deferred.promise;
            };

            function clearLastColumnFoundHighlight() {
                if (angular.isDefined(_lastColumnFound)) {
                    $scope.gridApi.grid.columns[_lastColumnFound].highlight = undefined;
                    _lastColumnFound = undefined;
                }
            }

            function clearSearch() {
                angular.element($element[0].querySelectorAll('.ui-grid-render-container-body .ui-grid-viewport')).removeClass('datagrid-filter-opened');
                angular.element($element[0].querySelectorAll('.ui-grid-viewport')).removeClass('datagrid-filter-opened');
                angular.element($element[0].querySelectorAll('.ui-grid-render-container-left .ui-grid-footer.ui-grid-footer-viewport')).removeClass('datagrid-with-footer');

                for (var i = 0; i < $scope.columnDefs.length; i++) {
                    $scope.columnDefs[i].enableFiltering = false;
                }

                for (var field in $scope.searchByColumn) {
                    var f = parseInt(field);
                    $scope.gridApi.grid.columns[f].filters[0].term = '';
                    delete $scope.searchByColumn[field];
                }

                for (var field in $scope.filterByColumn) {
                    delete $scope.filterByColumn[field];
                }

                for (var i = 0; i < $scope.gridApi.grid.columns.length; i++) {
                    $scope.gridApi.grid.columns[i].isFiltering = false;
                }

                changeColumnSearchVisibility(true, false);

                $scope.dataset.removeFilter();

                $scope.showingFilters = false;
            };

            function changeColumnSearchVisibility(searchVisibility, clearAllSearchVisibility) {
                if ($scope.gridApi.grid.gridMenuScope.menuItems) {
                    for (var i = 0; i < $scope.gridApi.grid.gridMenuScope.menuItems.length; i++) {
                        var menuItem = $scope.gridApi.grid.gridMenuScope.menuItems[i];
                        if (angular.isDefined(menuItem.skGridMenuID) && menuItem.skGridMenuID === 'search') {
                            menuItem.shown = function () {
                                return searchVisibility;
                            };
                        }
                        if (angular.isDefined(menuItem.skGridMenuID) && menuItem.skGridMenuID === 'clearAllSearch') {
                            menuItem.shown = function () {
                                return clearAllSearchVisibility;
                            };
                        }
                    }
                }

                updateGridColumn();
            }

            function scrollTo(rowIndex, colIndex) {
                var f = function () {
                    $scope.gridApi.core.scrollTo($scope.records[rowIndex], $scope.gridApi.grid.columns[colIndex].colDef);
                };

                if ($scope.gridApi) {
                    f();
                } else {
                    $timeout(function () {
                        f();
                    }, 0, false);
                }
            }

            function scrollToFocus(rowIndex, colIndex) {
                var f = function () {
                    if ($scope.gridApi.grid.columns[colIndex]) {
                        $scope.gridApi.cellNav.scrollToFocus($scope.records[rowIndex], $scope.gridApi.grid.columns[colIndex].colDef);
                    }
                };

                if ($scope.gridApi) {
                    f();
                } else {
                    $timeout(function () {
                        f();
                    }, 0, false);
                }
            }

            function initializeDatagrid() {
                setViewModeToLoading();

                $scope.onDatagridInit({datagrid: _self, dataset: $scope.dataset});

                $scope.dataset.addObserver(_self);

                $scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD_START, function () {
                    _lockSort = true;
                });

                $scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD_END, function () {
                    _lockSort = false;
                    refreshCheckboxHeaderState();
                    scrollToFocus(0,2);
                });

                definePresentationField();
                var fieldMds = ArrayUtils.copy($scope.dataset.getFieldsMetadata(), true);

                $scope.columnDefs.length = 0;
                _originalColumnDefs.length = 0;

                //Checkbox Column
                if($scope.hideCbxColumn !== true) {
                    var checkboxCol = {
                        skOrder: -100000,
                        transient: true,
                        field: CHECKBOX_COLUMN_FIELD,
                        displayName: '',
                        allowCellFocus: false,
                        width: $scope.selectionRowHeaderWidth,
                        enableColumnResizing: false,
                        enableCellEdit: false,
                        enableCellEditOnFocus: false,
                        pinnedLeft: true,
                        headerCellTemplate: 'components/datagrid/templates/checkboxheadercell.tpl.html',
                        cellTemplate: 'components/datagrid/templates/uigridselectionrowheaderbuttons.tpl.html',
                        type: 'string' //Necessário definir um tipo para que o ui-grid não tente inferí-lo automaticamente erroneamente, gerando problemas
                    };

                    $scope.columnDefs.push(checkboxCol);
                }

                var foreignKeyFields = {};
                var masterDescriptionFields = {};

                for (var i = 0, length = $scope.dataset.getForeignKeyFields().length; i < length; i++) {
                    foreignKeyFields[$scope.dataset.getForeignKeyFields()[i].localField] = undefined;
                }

                var originalIndex;

                var filteredColumns = ArrayUtils.toArray($scope.strFilteredColumns);
                var filteredColumnsByName = {};

                if (filteredColumns && filteredColumns.length > 0) {
                    fieldMds.forEach(function (fieldMD) {
                        if (ArrayUtils.isIn(filteredColumns, fieldMD.name)) {
                            filteredColumnsByName[fieldMD.name] = true;
                            fieldMD.visible = false;
                        }
                    });
                }

                if ($scope.datagridInterceptor) {
                    wasSorted = $scope.datagridInterceptor.sortMetadata(fieldMds, $scope.dataset) != 'unordered';

                    if (wasSorted) {
                        originalIndex = {};

                        $scope.dataset.getFieldsMetadata().forEach(function(fieldMD, index) {
                            originalIndex[fieldMD.name] = index;
                        });
                    }

                    fieldMds.forEach(function (fieldMD) {
                    	if (!filteredColumnsByName[fieldMD.name] && !$scope.datagridInterceptor.acceptColumnField(fieldMD, $scope.dataset)) {
                            fieldMD.visible = false;
                        }
                    });
                }

                var completedSizeDefined = false;

                //Metadata definition
                fieldMds.forEach(function (fieldMD, index) {
                    if (originalIndex) {
                        index = originalIndex[fieldMD.name];
                    }
                    
                    if (_onlyCustomColumns) {
            			    fieldMD.visible = angular.isDefined(_customColumnsMD[fieldMD.name]);
                	  }

                    if ($scope.datagridInterceptor && angular.isFunction($scope.datagridInterceptor.interceptColumnMetadata)) {
                        $scope.datagridInterceptor.interceptColumnMetadata(fieldMD, $scope.dataset);
                    }

                    if (foreignKeyFields.hasOwnProperty(fieldMD.name) && fieldMD.fk) {
                        masterDescriptionFields[fieldMD.fk.descriptionFieldName] = undefined;
                        _originalColumnDefs.push(fieldMD);
                        return;
                    }

                    if (masterDescriptionFields.hasOwnProperty(fieldMD.name)) {
                        _originalColumnDefs.push(fieldMD);
                        return;
                    }

                    if (fieldMD.fk) {
                        if (!_descriptionFieldNames.hasOwnProperty(fieldMD.fk.descriptionFieldName)) {
                            _descriptionFieldNames[fieldMD.fk.descriptionFieldName] = {originalFieldFk: fieldMD};
                        }
                    }

                    if(fieldMD.width === '*') {
                        completedSizeDefined = true;
                    }

                    var customColumnMD = _customColumnsMD[fieldMD.name];

                    var isVisible = isFieldMDVisible(fieldMD);

                    var precision = fieldMD.precision;

                    if (fieldMD.userType == 'F' && !precision && precision != 0) {
                        precision = DEFAULT_DECIMAL_PRECISION;
                    }

                    var isDatagridEditable = !$scope.isMobile && $scope.editable;

                    var isColumnEditable = isFieldMDEditable(fieldMD);

                    var columnDescription;

                    if (customColumnMD && customColumnMD.description) {
                        columnDescription = customColumnMD.description;
                    } else {
                        columnDescription = fieldMD.description;
                    }

                    var liveCheck = false;

                    if (customColumnMD && fieldMD.checkbox && customColumnMD.liveCheck) {
                        liveCheck = true;
                    }

                    var cellType = liveCheck ? 'C' : 'P';
                    var cellTemplate = liveCheck ? 'components/datagrid/templates/uigridcell.check.tpl.html' : 'components/datagrid/templates/uigridcell.tpl.html';

                    var column = {
                        skName: fieldMD.name,
                        skOrder: fieldMD.order,
                        skFieldMdIndex: index,
                        displayName: columnDescription,
                        field: String(index),
                        skVisible: isVisible,
                        skFieldType: fieldMD.userType,
                        skPrecision: precision,
                        skPrettyPrecision: fieldMD.prettyPrecision || precision,
                        skAllowNull: fieldMD.isNullable,
                        visible: $scope.gridconfig ? false : isVisible,
                        minWidth: _columnMinWidth,
                        width: fieldMD.width || getColumnWidth(StringUtils.undefinedAsEmpty(fieldMD.description).toString()),
                        enableHiding: false,
                        cellTooltip: false,
                        showMenu: false,
                        enableFiltering: false,
                        distinctData: undefined,
                        enableCellEdit: isColumnEditable,
                        enableCellEditOnFocus: isColumnEditable,
                        userType: fieldMD.fk ? 'ENTITY' : fieldMD.userType,
                        dataType: fieldMD.dataType,
                        presentationType: fieldMD.presentationType,
                        options: fieldMD.options,
                        cellEditableCondition: cellEditableCondition,
                        editableCellTemplate: buildEditComponentsTemplate,
                        cellTemplate: cellTemplate,
                        footerCellTemplate: 'ui-grid/uiGridFooterCell',
                        isCheckbox: fieldMD.checkbox,
                        cellType: cellType,
                        skOptions: fieldMD.options,
                        properties: fieldMD.properties,
                        fk: fieldMD.fk,
                        size: fieldMD.size,
                        enableSorting: fieldMD.enableSorting != undefined ? fieldMD.enableSorting : true,
                        buildOptionsFn: fieldMD.buildOptionsFn,
                        cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex, element) {
                            if($scope.datagridInterceptor) {
                                var cellColors = $scope.datagridInterceptor.getCellColors(row, col, rowRenderIndex, colRenderIndex, grid);
                                
                                if (angular.isUndefined(cellColors)) {
                                    element.parent().parent().addClass('default-colors');
                                    return 'ui-grid-cell-contents-black';
                                }

                                if(!angular.isObject(cellColors)) {
                                    element.parent().parent().addClass('default-colors');

                                    if(ThemeColors.isValidColor(cellColors)) {
                                        return ThemeColors.getTextColorClass(cellColors);
                                    } else if(cellColors.startsWith('#')) {
                                        element.css('color', cellColors);
                                    }

                                    return cellColors;
                                }

                                var textColorClass = ThemeColors.getTextColorClass(cellColors.textColor);
                                var bgColorClass = ThemeColors.getBgColorClass(cellColors.bgColor);

                                if(textColorClass.startsWith('#')) {
                                    element.css('color', textColorClass);
                                }

                                if(StringUtils.isEmpty(bgColorClass)) {
                                    element.parent().parent().addClass('default-colors');
                                } /*else if(bgColorClass.startsWith('#')) {
                                    element.css('background-color', bgColorClass);
                                }*/

                                return textColorClass + ' ' + bgColorClass;
                            } else {
                                element.parent().parent().addClass('default-colors');
                            }
                        },
                        cellFormatter: function (col, value) {
                            return value;
                        },
                        setEnabled: function(value) {
                            column.enableCellEdit = isDatagridEditable && value;
                            column.enableCellEditOnFocus = column.enableCellEdit;
                            updateGridColumnDebounced();
                        },
                        setVisible: function(value) {
                            column.visible = value;
                            column.skVisible = value;
                            updateGridColumnDebounced();
                        },
                        setDescription: function(value) {
                            column.displayName = value;
                            updateGridColumnDebounced();
                        },
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        },
                        /*
                         filter: {
                         placeholder: $scope.searchText
                         },*/
                        menuItems: [
                            {
                                title: i18nService.getSafeText('search.filter'),
                                icon: 'ui-grid-icon-filter',
                                action: function ($event) {
                                    openFilterModal($scope.col);
                                },
                                context: $scope
                            },
                            {
                                title: i18nService.getSafeText('general.removeColumnSearchMarkup'),
                                icon: 'ui-grid-icon-cancel',
                                context: $scope,
                                action: function ($event) {
                                    clearLastColumnFoundHighlight();
                                },
                                shown: function () {
                                    return (parseInt(this.context.col.field) + 1) === _lastColumnFound;
                                }
                            }
                        ]
                    };

                    //Definição das opções de agregação
                    if (fieldMD.properties) {
                        var classAdded = false;
                        for (var i = 0; i < fieldMD.properties.length; i++) {
                            var propertie = fieldMD.properties[i];
                            if (propertie.name === 'gridFooterOper') {
                                _footerColumnFound = true;
                                if (propertie.value === 'sum') {
                                    column.aggregationType = uiGridConstants.aggregationTypes.sum;
                                }
                                column.aggregationLabel = 'Total: ';

                                if (!classAdded) {
                                    $timeout(function () {
                                        angular.element($element[0].querySelectorAll('.ui-grid-render-container-body .ui-grid-viewport')).addClass('datagrid-with-footer');
                                        angular.element($element[0].querySelectorAll('.ui-grid-viewport')).addClass('datagrid-with-footer');
                                    }, 0, false);
                                    classAdded = true;
                                }
                            }
                        }
                    }

                    var userType = FormService.getUserType(fieldMD);
                    var dataType = fieldMD.dataType;

                    if (dataType === 'D' || dataType === 'H' || dataType == 'T') {
                        column.headerClass = 'datagrid-header-center';
                        column.cellTextAlignment = 'center';
                        if (dataType === 'D') {
                            column.type = 'date';
                        } else if (dataType === 'H') {
                            column.type = 'datetime';
                        } else {
                            column.type = 'time';
                        }

                        if (dataType == 'T') {
                            column.cellFormatter = function (col, value) {
                                if (value) {
                                    return DateUtils.getTimeExtraFormatter(value);
                                } else {
                                    return value;
                                }
                            };
                        } else {
                            column.cellFormatter = function (col, value, options) {
                                if(fieldMD.customCellFormatter) {
                                    return fieldMD.customCellFormatter(value, col);
                                }

                                if (angular.isDate(value)) {
                                    var format;

                                    if (dataType === 'D') {
                                        format = DateUtilsConstants.DEFAULT_DATE_FORMAT;
                                    } else {
                                        if (!options || !(options.includeSeconds === false)) {
                                            format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS;
                                        } else {
                                            format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT;
                                        }
                                    }

                                    return DateUtils.formatDate(value, format);
                                }

                                return value;
                            };
                        }
                    } else if (dataType == 'I' || dataType == 'F') {
                        column.headerClass = 'datagrid-header-right';
                        column.cellTextAlignment = 'right';
                        column.type = 'number';

                        if (fieldHasOptions(fieldMD)) {
                            column.cellFormatter = optionsCellFormatter;
                        } else {
                            column.cellFormatter = function (col, value) {
                                return angular.isDefined(value) ? ((userType == 'F' && precision >= 0) ? NumberUtils.format(value, precision) : value) : '';
                            }
                        }
                    } else if (userType == 'ENTITY') {
                        if (dataType == 'I' || dataType == 'F') {
                            column.headerClass = 'datagrid-header-right';
                            column.cellTextAlignment = 'right';
                            column.type = 'number'
                        }
                        else {
                            column.headerClass = 'datagrid-header-left';
                            column.cellTextAlignment = 'left';
                            column.type = 'string';
                        }
                    } else {
                        column.headerClass = 'datagrid-header-left';
                        column.cellTextAlignment = 'left';
                        column.type = 'string';

                        if (fieldHasOptions(fieldMD)) {
                            column.cellFormatter = optionsCellFormatter;
                        } else if (userType == 'Phone') {
                            column.cellFormatter = function (col, value) {
                                if (value) {
                                    return StringUtils.toPhone(value);
                                }
                            };
                        } else if (userType == 'CGC_CPF') {
                            column.cellFormatter = function (col, value) {
                                if (value) {
                                    return StringUtils.formatCgcCpf(value);
                                }
                            };
                        } else if ((userType == 'C' && column.presentationType != 'H') || fieldMD.size > 100) {
                            column.cellType = 'TA';
                            column.cellTemplate = 'components/datagrid/templates/uigridcell.textarea.tpl.html';
                        }
                    }

                    if (customColumnMD && customColumnMD.cellFormatter) {
                        column.cellFormatter = function(col, value, row) {
                        	var record = angular.isObject(row) && row.hasOwnProperty('entity') ? row.entity : row;
                        	return customColumnMD.cellFormatter(col, value, record);
                        };
                    }


                    $scope.columnDefs.push(column);
                    _originalColumnDefs.push(column);

                    _columnDefsByName[column.skName] = column;
                });

                //Blank Column
                var blankColumn = {
                    field: '9999',
                    transient: true,
                    displayName: '',
                    width: completedSizeDefined ? 30 : '*',
                    minWidth: 30,
                    enableColumnResizing: false,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    enableColumnMenu: false,
                    enableSorting: false,
                    enableFiltering: false,
                    type: 'string' //Necessário definir um tipo para que o ui-grid não tente inferí-lo automaticamente, gerando problemas
                };

                $scope.columnDefs.push(blankColumn);

                if (!_footerColumnFound) {
                    $scope.datagrid.showColumnFooter = false;
                }

                if ($scope.gridconfig) {
                    GridConfig.loadConfigurations($scope.gridconfig);
                }

                //Percorre as colunas desabilitando a edição de campos de apresentação de FKs
                for (var i = 0; i < $scope.columnDefs.length; i++) {
                    var column = $scope.columnDefs[i];
                    if (_descriptionFieldNames.hasOwnProperty(column.skName)) {
                        column.enableCellEdit = false;
                        column.enableCellEditOnFocus = false;
                    }
                }

                loadRecords();
                onDatasetRefresh();

                $timeout(function () {
                    //Caso haja gridconfig, ele é o responsável por chamar o refesh assim que
                    //terminar de carregar as configurações
                    if (!$scope.gridconfig) {
                        refresh();
                        $rootScope.$emit('dataGridMetadataChanged', _internalUID);
                    }
                    $scope.onDatagridLoaded({datagrid: _self, dataset: $scope.dataset});
                }, 0, false);
            }

            function isFieldMDVisible(fieldMD) {
                var customColumnMD = _customColumnsMD[fieldMD.name];

                if (angular.isUndefined(customColumnMD) && fieldMD.codeFieldName) {
                    customColumnMD = _customColumnsMD[fieldMD.codeFieldName];
                }

                var isVisible;

                if (customColumnMD && customColumnMD.hasOwnProperty('visible')) {
                    isVisible = customColumnMD.visible;
                } else if(_descriptionFieldNames.hasOwnProperty(fieldMD.name)){
                    isVisible = isFieldMDVisible(_descriptionFieldNames[fieldMD.name].originalFieldFk)
                }else{
                    isVisible = fieldMD.userType === 'B' ? false : fieldMD.visible;
                }

                if (angular.isUndefined(isVisible)) {
                    isVisible = true;
                }

                return isVisible;
            }

            function isFieldMDEditable(fieldMD) {
                var isDatagridEditable = !$scope.isMobile && $scope.editable;

                var isColumnEditable;

                if (isDatagridEditable) {
                    var customColumnMD = _customColumnsMD[fieldMD.name];

                    if (customColumnMD && customColumnMD.hasOwnProperty('enabled')) {
                        isColumnEditable = customColumnMD.enabled;
                    } else {
                        if (ArrayUtils.isIn($scope.dataset.getPrimaryKeys(), fieldMD.name)) {
                            isColumnEditable = $scope.dataset.getAllowPkModification();
                        } else {
                            isColumnEditable = !fieldMD.readOnly;
                        }
                    }
                } else {
                    isColumnEditable = false;
                }

                return isColumnEditable;
            }

            function fieldHasOptions(fieldMD) {
                return fieldMD.options && fieldMD.options.length > 0;
            }

            function optionsCellFormatter(col, value, params) {                
                if (angular.isDefined(value)) {
                    for (var i = 0; i < this.options.length; i++) {
                        var opt = this.options[i];

                        if (opt.data == value) {
                            return opt.value;
                        }
                    }

                    return value;
                }
            }

            function optionsUserCellFormatter(col, value) {
                if(!angular.isFunction(col.colDef.buildOptionsFn)){
                    throw new MessageError('buildOptionsFn não definida para a coluna ' + col.colDef.displayName);
                }

                var actualRow = $scope.dataset ? $scope.dataset.getCurrentRowAsObject() : undefined; 
                var options = col.colDef.buildOptionsFn(actualRow, true);
                
                if (angular.isDefined(value)) {
                    for (var i = 0; i < options.length; i++) {
                        var opt = options[i];

                        if (opt.data == value || opt.DATA == value) {
                            return opt.value == undefined ? opt.VALUE : opt.value;
                        }
                    }

                    return value;
                }
            }

            function getColumnWidth(description) {
                if (description.length <= 10) {
                    return Math.max((Math.min(description.length, 30) * _charToPixelRatio), 100);
                }
                else {
                    return Math.max((Math.min(description.length, 30) * (_charToPixelRatio - 5) ), 100);
                }
            }

            function buildEditComponentsTemplate(col) {
                
                if(angular.isFunction(col.colDef.buildOptionsFn)){
                    var actualRow = $scope.dataset ? $scope.dataset.getCurrentRowAsObject() : undefined; 
                    col.colDef.skOptions = col.colDef.buildOptionsFn(actualRow);
                    col.colDef.options = col.colDef.skOptions;
                    col.colDef.cellFormatter = optionsUserCellFormatter;
                    col.colDef.skAllowNull = false;
                }

                var inputInfo = FormService.getInputInfo(FormService.getUserType(col.colDef), col.colDef.isCheckbox, col.colDef.presentationType,
                    col.colDef.skOptions, col.colDef.size);

                col.colDef.inputName = inputInfo.inputName;

                //Chama o interceptor de item editor, caso haja
                if ($scope.datagridInterceptor && angular.isFunction($scope.datagridInterceptor.interceptItemEditor)) {
                    $scope.datagridInterceptor.interceptItemEditor(col.colDef, $scope.dataset);
                }

                var template = '<div>' +
                    '<form name="inputForm" ';
                if ($scope.compactMode) {
                    template += 'class="datagrid-compact-mode" ';
                }
                else {
                    template += 'class="datagrid-comfortable-mode" ';
                }

                var targetField = ObjectUtils.getProperty(col, 'colDef.fk.targetField');

                var precision = "";

                if(angular.isFunction(col.colDef.skPrecision)){
                    precision = col.colDef.skPrecision();
                }else{
                    precision = col.colDef.skPrecision;
                }

                template += '>' +
                    '<' + col.colDef.inputName +
                    ' class="' + col.colDef.skClass + '" ' +
                    ' ng-class="\'colt\' + col.uid" ' +
                    'sk-datagrid-editor="true" ' +
                    'sk-dataset="grid.appScope.dataset" ' +
                    'sk-field-index="' + col.colDef.field + '" ' +
                    'sk-append-to-body="true" ' +
                    'sk-align="' + col.colDef.cellTextAlignment + '" ' +
                    'sk-options="col.colDef.skOptions"' +
                    'sk-entity-name="' + (angular.isDefined(col.colDef.fk) ? (col.colDef.fk.relationShipName || col.colDef.fk.entity) : "") + '" ' +
                    'sk-size="' + col.colDef.size + '" ' +
                    'sk-data-type="col.colDef.dataType"' +
                    'sk-precision="' + precision + '" '+ 
                    'sk-pretty-precision="col.colDef.skPrettyPrecision"' +
                    'sk-mask="' + col.colDef.skMask + '"' +
                    'sk-allow-null="' + col.colDef.skAllowNull + '"' +
                    (targetField ? 'sk-target-field="' + targetField + '"' : '') +
                    'sk-dependent-fields="col.colDef.fk.dependentFields"' +
                    'sk-enviroment-criteria="col.colDef.enviromentCriteria()"' +
                    'sk-include-mask="col.colDef.skIncludeMask"' +
                    '>' +
                    '</' + col.colDef.inputName + '>' +
                    '</form>' +
                    '</div>';


                return template;
            }

            //Executada quando o dataset é atualizado
            function onDatasetRefresh(reason) {
                _fireDblClick = false;
                clearLastColumnFoundHighlight();
                clearDomOfFocusedCell();

                _firstFullLoadCompleted = true;

                if (reason != DatasetEvents.REFRESH_REASON_FILTER) {
                    endEdit();
                }
                if ($scope.records !== $scope.dataset.getRecords()) {
                    //Início da implementação do popup que instrui a diminuir o número de colunas na grade
                    /*
                     if($scope.columnDefs.length > $scope.datagrid.columnVirtualizationThreshold && $scope.gridconfig) {
                     if(!_showingMsgColumnNumberException) {
                     _showingMsgColumnNumberException = true;
                     var msg = "Atenção! Existe uma quantidade grande de colunas configuradas para essa grade. Isso pode tornar a navegação lateral lenta. Deseja configurar as colunas a serem exibidas agora?";
                     MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, msg).then(function () {
                     GridConfig.openGridconfig($scope, $scope.gridconfig);
                     }, function (reason) {
                     $scope.records = $scope.dataset.getRecords();
                     updateGridOptions();
                     _showingMsgColumnNumberException = false;
                     });
                     }
                     } else {
                     $scope.records = $scope.dataset.getRecords();
                     updateGridOptions();
                     }
                     */

                    loadRecords();
                }
            }

            //Executada quando o dataset muda a seleção
            function onDatasetCurrentLineChanged(newIndex, reason) {
                if (!$scope.gridApi || _programmaticallySelectingRecord) {
                    return;
                }

                var f = function () {
                    _shiftIsPressed = false;

                    if (!_checkboxColumnClicked) {
                        unselectAllSelectedRows();
                    }

                    if ($scope.gridApi.grid.rows[newIndex]) {
                        if($scope.allowMultipleSelection !== false || getSelectedRecords().length == 0) {
                            $scope.gridApi.grid.rows[newIndex].isSelected = true;
                        }
                        //_lastSelectedGridRow = $scope.gridApi.grid.rows[newIndex];
                        _lastSelectionIndex = newIndex;

                        var currentPage = $scope.gridApi.grid.options.paginationCurrentPage;
                        var ceilLimit = currentPage * $scope.datagrid.paginationPageSize - 1;
                        var floorLimit = (currentPage - 1) * $scope.datagrid.paginationPageSize;
                        if (newIndex > ceilLimit) {
                            $scope.gridApi.pagination.nextPage();
                        }
                        else if (newIndex < floorLimit) {
                            $scope.gridApi.pagination.previousPage();
                        }

                        if (_checkboxColumnClicked) {
                            _checkboxColumnClicked = false;
                        }

                        _lockEdition = true;
                        refreshCheckboxHeaderState();
                    }

                    var selectedRecordsEntities = $scope.dataset.getSelectedRecords();
                    if (angular.isDefined(selectedRecordsEntities)) {
                        setSelectedRecords(selectedRecordsEntities);
                    }

                    if (reason != DatasetEvents.REFRESH_REASON_FILTER) {
                        if(_enterIsPressed) {
                            _enterIsPressed = false;
                        } /*else {
                            $scope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
                        }*/
                    }

                    /*if(_lastSelectedGridCol && _lastSelectedGridRow) {
                        var columnIndex = $scope.gridApi.grid.columns.indexOf(_lastSelectedGridCol);
                        var rowIndex = $scope.gridApi.grid.rows.indexOf(_lastSelectedGridRow);
                        scrollToFocusDebounced(rowIndex, columnIndex);
                    }*/
                };


                $timeout(f);
                setFocusAfter();
            }

            function loadRecords() {
                $scope.records = $scope.dataset.getRecords();

                if ($scope.dataset.getCurrentRow()) {
                    setSelectedRecords(new Array($scope.dataset.getCurrentRow()));
                    _lockEdition = true;
                }

                refreshCheckboxHeaderState();


                if (_initialSort && getSelectedRecords().length > 0) {
                    _initialSort = false;
                    notifyDatasetOfChangeRowDebounced($scope.gridApi.grid.rows[0]);
                }
            }

            function editionCanceled() {
                $scope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
            }

            function dataSaved() {
                if(!_programmaticallySelectingRecord) {
                    endEdit();
                } else {
                    _programmaticallySelectingRecord = false;
                }
            }

            function endEdit() {
                $scope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
                if(!_enterIsPressed && $scope.gridApi) {
                    $scope.gridApi.grid.isEditing = false;
                }
            }

            function getCurrentColIndex() {
                if ($scope.gridApi && $scope.gridApi.cellNav.getFocusedCell()) {
                    var currentCol = $scope.gridApi.cellNav.getFocusedCell().col;
                    return parseInt($scope.gridApi.grid.columns.indexOf(currentCol));
                }
                return null;
            }

            function getCurrentCol() {
                if ($scope.gridApi && $scope.gridApi.cellNav.getFocusedCell()) {
                    var currentCol = $scope.gridApi.cellNav.getFocusedCell().col;
                    return parseInt($scope.gridApi.grid.columns.indexOf(currentCol));
                }
                return null;
            }

            function definePresentationField() {
                $scope.presentationField = $scope.dataset.getEntityPresentationFieldIndex();
                $scope.existeCampoDeApresentacao = $scope.presentationField !== undefined;
                if ($scope.existeCampoDeApresentacao) {
                    $scope.selectionRowHeaderWidth = 55;
                }
                else {
                    $scope.selectionRowHeaderWidth = 30;
                }
            };

            function checkAllRows() {
                if (!$scope.allowMultipleSelection) {
                    return;
                }

                if (getSelectedRecords().length === $scope.records.length) {
                    $scope.gridApi.selection.clearSelectedRows();
                    $scope.allSelected = false;
                }
                else {
                    $scope.gridApi.selection.selectAllVisibleRows();
                    $scope.allSelected = true;

                }
                updateGridOptions();
                $scope.dataset.setSelectedRecords(getSelectedRecords());
            };

            function getEntityIndex(entity) {
                return $scope.records.indexOf(entity);
            }

            function cellNavHandler(newRowCol, oldRowCol, evt) {
                //A verificação abaixo é necessária pois newRowCol.row.entity torna-se um objeto quando se navega
                //até a célula de expansão do agrupamento. Neste caso, não precisamos executar nada aqui.
                if (!angular.isArray(newRowCol.row.entity)) {
                    return;
                }

                var rowChanged = newRowCol.row;
                var rowChangedIndex = getEntityIndex(rowChanged.entity);

                if (!_searchingColumn && (_downIsPressed || _upIsPressed || _enterIsPressed || (evt && evt.keyCode == 13))) {
                    if (!_shiftIsPressed) {
                        if(!_enterIsPressed && !(evt && evt.keyCode == 13)) {
                            unselectAllSelectedRows();
                            newRowCol.row.isSelected = !newRowCol.row.isSelected;
                            _canEditNow = false;
                        } else {
                            endEdit();

                            _canEditNow = true;

                            if($scope.gridApi.grid.isEditing) {
                                unselectAllSelectedRows();
                                newRowCol.row.isSelected = !newRowCol.row.isSelected;
                                _programmaticallySelectingRecord = true;

                                if(_enterIsPressed) {
                                    _canEditNow = true;
                                } else {
                                    _canEditNow = false;
                                }
                            }

                            notifyDatasetOfChangeRow(newRowCol.row, oldRowCol ? oldRowCol.row : undefined);
                            return;
                        }
                    } else if (_shiftIsPressed && oldRowCol && oldRowCol.row.isSelected && rowChanged.isSelected) {
                        oldRowCol.row.isSelected = !oldRowCol.row.isSelected;
                    } else {
                        newRowCol.row.isSelected = !newRowCol.row.isSelected;
                    }

                    if (_lastSelectionIndex !== rowChangedIndex) {
                        _lastSelectionIndex = rowChangedIndex;
                    }
                } else if (_pageupIsPressed || _pagedownIsPressed) {
                    unselectAllSelectedRows();
                    newRowCol.row.isSelected = !newRowCol.row.isSelected;

                    if (_lastSelectionIndex !== rowChangedIndex) {
                        _lastSelectionIndex = rowChangedIndex;
                    }

                    _pagedownIsPressed = false;
                    _pageupIsPressed = false;
                } else {
                    if (_searchingColumn) {
                        _searchingColumn = false;
                        _enterIsPressed = false;
                    }
                    if (_lastSelectionIndex !== rowChangedIndex) {
                        _lastSelectionIndex = rowChangedIndex;
                        _lockEdition = false;
                    }
                }

                //Ajusta o checkbox de 3 estados.
                refreshCheckboxHeaderState();

                //Avisa o dataset que o registro corrente foi alterado
                if (getSelectedRecords().length === 1 && (!evt || (!evt.shiftKey && !evt.ctrlKey))) {
                    endEdit();

                    if(_enterIsPressed) {
                        _canEditNow = true;
                    } else {
                        _canEditNow = false;
                    }

                    notifyDatasetOfChangeRowDebounced(newRowCol.row, oldRowCol ? oldRowCol.row : undefined);
                }
            }

            function refreshCheckboxHeaderState() {
                var selectedItems = getSelectedRecords();
                if (!angular.isDefined(selectedItems) || selectedItems.length === 0) {
                    $scope.allSelected = false;
                }
                else if (selectedItems.length < $scope.records.length) {
                    $scope.allSelected = 'I';
                }
                else {
                    $scope.allSelected = true;
                }
            }

            function notifyDatasetOfChangeRow(newRow, notUnselect) {
                var defer = $q.defer();
                var newIndex = getEntityIndex(newRow.entity);

                var f = function () {
                    try {
                        _programmaticallySelectingRecord = true;

                        $scope.dataset.gotoRow(newIndex).then(function(){
                            fireDblClickIfNeeded();
                        }, function (lastSelectedIndex) {
                            if (!notUnselect) {
                                unselectAllSelectedRows();
                            }
                            if ($scope.gridApi) {
                                $scope.gridApi.grid.rows[lastSelectedIndex].isSelected = true;
                                clearDomOfFocusedCell();
                                updateGridOptions();
                            }
                        });
                    }
                    finally {
                        _programmaticallySelectingRecord = false;
                        refreshCheckboxHeaderState();
                        defer.resolve();
                    }
                };


                $scope.dataset.save(false).then(function () {
                    //$scope.dataset.refreshCurrentRow();
                    f();
                }, function (error) {
                    if (error === DatasetContants.RECORD_IS_NOT_DIRTY) {
                        f();
                    } else {
                        if (newRow && $scope.gridApi) {
                            _canEditNow = false;
                            endEdit();                          
                            var datasetRow = $scope.gridApi.grid.rows[$scope.dataset.getCurrentIndex()];
                            if (datasetRow) {
                                newRow.isSelected = false;
                                datasetRow.isSelected = true;
                                clearDomOfFocusedCell();
                            }
                        }
                    }
                });

                return defer.promise;
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#unselectAllSelectedRows
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Deseleciona todas as linhas selecionadas no sk-datagrid no momento.
             * @example <pre>datagridController.unselectAllSelectedRows();</pre>
             */
            function unselectAllSelectedRows() {
                var selectedItems = getSelectedRecords();
                for (var i = 0, length = selectedItems.length; i < length; i++) {
                    var selectedItemIndex = getEntityIndex(selectedItems[i]);
                    if ($scope.gridApi.grid.rows[selectedItemIndex]) {
                        $scope.gridApi.grid.rows[selectedItemIndex].isSelected = false;
                    }
                }

                refreshCheckboxHeaderState();
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#selectedAllRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Seleciona todas as linhas da grade
             * @example <pre>datagridController.selectedAllRecords();</pre>
             */
            function selectAllRecords() {
                setSelectedRecords(getRecords());
            }

            function addCustomColumnMD(customColumnMD) {
                _customColumnsMD[customColumnMD.fieldName] = customColumnMD;

                if (_onlyCustomColumns) {
                    customColumnMD.order = _onlyCustomOrder++;
                }
            }

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#getSelectedRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Retorna todos os registros(linhas) selecionadas no sk-datagrid no momento.
             * @return {array} Array de recordes
             * @example <pre>datagridController.getSelectedRecords();</pre>
             */
            function getSelectedRecords() {
                if ($scope.gridApi) {
                    return $scope.gridApi.selection.getSelectedRows();
                }
                return [];
            };

            /**
             * @ngdoc
             * @name snk.components.datagrid.directive:sk-datagrid#setSelectedRecords
             * @methodOf snk.components.datagrid.directive:sk-datagrid
             * @description
             *  Seta a linhas que devem ser selecionadas no sk-datagrid no momento.
             * @param {array} Array de Records
             * @example <pre>datagridController.setSelectedRecords(datagridController.getRecords());</pre>
             */
            function setSelectedRecords(rowsEntitySet) {
                var f = function () {
                    unselectAllSelectedRows();
                    for (var i = 0; i < rowsEntitySet.length; i++) {
                        var rowEntity = rowsEntitySet[i];
                        var rowIndex = getEntityIndex(rowEntity);
                        if ($scope.gridApi && $scope.gridApi.grid.rows[rowIndex]) {
                            $scope.gridApi.grid.rows[rowIndex].setSelected(true);
                        }
                    }
                    refreshCheckboxHeaderState();
                    $scope.dataset.setSelectedRecords(getSelectedRecords());
                }

                if ($scope.gridApi) {
                    f();
                } else {
                    $timeout(f, 0, false);
                }
            }

            function keydownHandler($event) {
                var e = $event;

                if (e.keyCode === _keymap.TAB) {
                    _tabIsPressed = true;
                }
                else if (e.keyCode === _keymap.ENTER) {
                    _enterIsPressed = true;
                }
                else if (e.keyCode === _keymap.SHIFT) {
                    _shiftIsPressed = true;
                }
                else if (e.keyCode === _keymap.DOWN) {
                    _downIsPressed = true;
                }
                else if (e.keyCode === _keymap.UP) {
                    _upIsPressed = true;
                }
                else if (e.keyCode === _keymap.PG_UP) {
                    _pageupIsPressed = true;
                }
                else if (e.keyCode === _keymap.PG_DOWN) {
                    _pagedownIsPressed = true;
                }
                else if (e.keyCode === _keymap.ESC) {
                    _canEditNow = false;
                    endEdit();
                } else if(e.keyCode == 67 && e.ctrlKey) {
                    copyCellContent();
                }

                if ((e.keyCode >= 48 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105)) {
                    //_canEditNow = true;
                }
            };

            function keyupHandler($event) {
                var e = $event;

                if (e.keyCode === _keymap.TAB) {
                    _tabIsPressed = false;
                }
                else if (e.keyCode === _keymap.ENTER) {

                }
                else if (e.keyCode === _keymap.SHIFT) {
                    _shiftIsPressed = false;
                }
                else if (e.keyCode === _keymap.DOWN) {
                    _downIsPressed = false;
                }
                else if (e.keyCode === _keymap.UP) {
                    _upIsPressed = false;
                }
                else if (e.keyCode === _keymap.PG_UP) {
                    _pageupIsPressed = false;
                }
                else if (e.keyCode === _keymap.PG_DOWN) {
                    _pagedownIsPressed = false;
                }
                else if ((e.keyCode >= 48 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105)) {
                    _canEditNow = false;
                }
            };

            function cellEditableCondition(col, row) {
                if (col.colDef.cellType == 'TA' || col.colDef.cellType == 'C') {
                    return false;
                }

                if ($scope.gridApi) {
                    $scope.gridApi.grid.isEditing = _canEditNow;
                }

                return _canEditNow;
            };

            function rowClickHandler($event, col, row) {
                col.colDef.showMenu = false;
                _rowClicked = true;
                //$scope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);

                if ($event.ctrlKey === true) {
                    $scope.datagrid.noUnselect = false;
                } else {
                    $scope.datagrid.noUnselect = true;
                }

                if ($scope.onClick) {
                    $scope.onClick();
                }
            };

            function openFilterModal(column) {
                var textoVazio = i18nService.getSafeText('general.empty');

                var currListVersion = $scope.dataset.getRecordsList().getListVersion();

                if (!angular.isDefined(column.distinctData) || column.distinctDataVersion != currListVersion) {
                    column.distinctDataVersion = currListVersion;
                    column.distinctData = {};
                    var mapDescriptions = {};
                    var originalRecords = $scope.dataset.getOriginalRecords();

                    for (var i = 0; i < originalRecords.length; i++) {
                        var originalRecord = originalRecords[i];
                        var data = '';

                        if (originalRecord[column.field] === '' || originalRecord[column.field] == undefined) {
                            data = textoVazio;
                        } else {
                            data = column.colDef.cellFormatter(column, originalRecord[column.field]).toString();

                            if (column.colDef.skFieldType !== 'F' && column.colDef.skFieldType !== 'I' && column.colDef.type !== 'number') {
                                mapDescriptions[data] = originalRecord[column.field];
                            }
                        }

                        var found = column.distinctData.hasOwnProperty(data);
                        if (!found) {
                            column.distinctData[data] = true;

                            if (!$scope.dataset.existsFilterFunction()) {
                                column.distinctData[data] = true;
                            }
                            else {
                                var breaked = false;
                                for (var j = 0; j < $scope.records.length; j++) {
                                    if (($scope.records[j][column.field] == data || (mapDescriptions && $scope.records[j][column.field] == mapDescriptions[data]) ) && data != undefined && data != '') {
                                        column.distinctData[data] = true;
                                        breaked = true;
                                        break;
                                    }
                                    else if (data == textoVazio && ($scope.records[j][column.field] == undefined || $scope.records[j][column.field] == '')) {
                                        column.distinctData[textoVazio] = true;
                                        breaked = true;
                                        break;
                                    }
                                }
                                if (!breaked) {
                                    column.distinctData[data] = false;
                                }
                            }
                        }
                    }

                    if (Object.keys(mapDescriptions).length > 0) {
                        column.mapDescriptions = mapDescriptions;
                    }
                }

                if (!angular.isDefined(column.distinctData[textoVazio])) {
                    column.distinctData[textoVazio] = false;
                }

                column.sortFn = getSortFn(column);

                //Prepara as variaveis de texto a serem passadas para o popup
                var filterForColumnText = i18nService.getSafeText('general.filterForColumn');
                var applyText = i18nService.getSafeText('general.apply');
                var cancelText = i18nService.getSafeText('general.cancel');
                var clearText = i18nService.getSafeText('general.clear');

                $scope.filterModal = SanPopup.open({
                    scope: $scope,
                    title: filterForColumnText + ' \"' + column.colDef.displayName + '\"',
                    templateUrl: 'components/datagrid/filtermodal/filtermodal.tpl.html',
                    controller: 'FilterModalController',
                    type: 'default',
                    okBtnLabel: clearText,
                    okBtnClass: 'btn-default',
                    noBtnClass: 'btn-primary',
                    noBtnLabel: applyText,
                    cancelBtnLabel: cancelText,
                    showBtnCancel: true,
                    windowClass: 'datagrid-modal-window',
                    cancelBtnClass: 'btn-default',
                    showBtnNo: true,
                    scrollContainer: false,
                    resolve: {
                        column: function () {
                            return column;
                        },
                        dataset: function () {
                            return $scope.dataset;
                        },
                        gridController: function () {
                            return _self;
                        }
                    }
                });
            };

            function enableSearch() {
                angular.element($element[0].querySelectorAll('.ui-grid-render-container-body .ui-grid-viewport')).addClass('datagrid-filter-opened');
                angular.element($element[0].querySelectorAll('.ui-grid-viewport')).addClass('datagrid-filter-opened');

                if (_footerColumnFound) {
                    angular.element($element[0].querySelectorAll('.ui-grid-render-container-body .ui-grid-viewport.datagrid-filter-opened')).addClass('datagrid-with-footer');
                    angular.element($element[0].querySelectorAll('.ui-grid-viewport.datagrid-filter-opened')).addClass('datagrid-with-footer');
                    angular.element($element[0].querySelectorAll('.ui-grid-render-container-left .ui-grid-footer.ui-grid-footer-viewport')).addClass('datagrid-with-footer');
                }

                for (var i = 0; i < $scope.columnDefs.length - 1; i++) {
                    $scope.columnDefs[i].enableFiltering = true;
                }

                changeColumnSearchVisibility(false, true);
                $scope.showingFilters = true;
            }

            function setFilterByColumn(column, term) {
                $scope.filterByColumn[column] = term;
            }

            function removeFilterByColumn(column) {
                delete $scope.filterByColumn[column];
            }

            function getCurrentColIndexByColumnDef(columnDef) {
                return _originalColumnDefs.indexOf(columnDef);
            }

            function checkboxRowClickHandler(row, oldSelected) {
                $scope.datagrid.modifierKeysToMultiSelect = false;
                _checkboxColumnClicked = true;
                _canEditNow = false;

                $timeout(function () {
                    $scope.datagrid.modifierKeysToMultiSelect = true;
                    if ($scope.existeCampoDeApresentacao && getSelectedRecords().length > 1) {
                        $scope.datagrid.noUnselect = false;
                    }
                    else if (oldSelected === false && getSelectedRecords().length > 1) {
                        row.isSelected = false;
                    }

                    $scope.dataset.setSelectedRecords(getSelectedRecords());
                    refreshCheckboxHeaderState();
                }, 0, false);
            }

            function lockEdition() {
                _checkboxColumnClicked = true;
                _canEditNow = false;
            }

            function onSortColumnStart() {
                $scope.datagridOperationInProgress = true;
            }

            function isFiltering(col) {
                var isFiltering = col.isFiltering || (col.filters[0].term != null && col.filters[0].term != '' && col.filters[0] != undefined);
                return isFiltering;
            }

            function liveCheckChanged(row, col) {
                var editedIndex = getEntityIndex(row.entity);

                var updateDataset = function() {
                    var currValue = row.entity[col.colDef.field];
                    var oldValue = (currValue == 'S') ? 'N' : 'S';

                    row.entity[col.colDef.field] = oldValue;

                    $scope.dataset.setFieldValueAsString(col.colDef.skName, currValue);
                };

                if ($scope.dataset.getCurrentIndex() != editedIndex) {
                    var unreg = $scope.dataset.addLineChangeListener(function(index) {
                       updateDataset();
                       unreg();
                    });
                } else {
                    updateDataset();
                }

                _lastLiveCheckChange = editedIndex;
            }

            function openTextAreaEditor(row, col, value, updateCell) {
                TextAreaPopupService
                    .open(col.colDef.displayName, value, col.colDef.enableCellEdit)
                    .then(function (result) {
                        if (value != result) {
                            $scope.dataset.setFieldValue(col.colDef.skName, result);
                            updateCell();
                        }
                    });
            }

            function openGridMenu() {
                if ($scope.gridApi && angular.isFunction($scope.gridApi.grid.toggleGridMenu)) {
                    _focusOnFindColumn = $scope.gridApi.grid.options.focusOnFindColumn;

                    $scope.gridApi.grid.toggleGridMenu();
                    $scope.gridApi.grid.options.focusOnFindColumn = false;
                    $scope.gridApi.grid.options.lockGridMenu = true;
                }
            }

            function closeGridMenu() {
                if ($scope.gridApi && $scope.gridApi.grid.options.lockGridMenu === true) {
                    $scope.gridApi.grid.options.lockGridMenu = false;
                    $scope.gridApi.grid.options.focusOnFindColumn = _focusOnFindColumn;
                    $scope.gridApi.grid.toggleGridMenu();
                }
            }

            function getTotalPages() {
                if ($scope.gridApi) {
                    return $scope.gridApi.pagination.getTotalPages();
                }
                return 0;
            }

            function getCurrentPage() {
                if ($scope.gridApi) {
                    return $scope.gridApi.options.paginationCurrentPage;
                }
                return 0;
            }

            function copyCellContent() {
                if ($scope.gridApi) {
                    var focusedCell = $scope.gridApi.cellNav.getFocusedCell();
                    if (focusedCell && angular.isFunction(focusedCell.col.colDef.cellFormatter)) {
                        var value = focusedCell.col.colDef.cellFormatter(focusedCell.col, focusedCell.row.entity[focusedCell.col.name]);
                        ClipboardUtils.copyTextToClipboard(value);
                    }
                }
            }

            function setOnDblClick(dblClick){
                $scope.onDblClick = dblClick;
            }

            function setAllowMultipleSelection(value){
                if (value === undefined) {
                    $scope.allowMultipleSelection = true;
                    $scope.datagrid.multiSelect = true;
                } else {
                    $scope.allowMultipleSelection = value;
                    $scope.datagrid.multiSelect = value;
                }
            }

            function dataModified(field){
                $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
            }
        });
/**
 * @ngdoc directive
 * @name snk.components.datagrid.directive:sk-datagrid
 * @restrict E
 * @scope
 * @description
    Datagrid é o componente de grade do framework escrito em HTML5.

    É possível realizar algumas personalizações de colunas através do HTML, para isso
    basta informar elementos <sk-datagrid-custom-column> como filhas da grade. Mais informações em {@link snk.form.directive:sk-datagrid-custom-column}

 * @param {SkDataset} sk-dataset ID do Dataset que contém os dados a serem renderizados pelo Datagrid.
 * @param {string} sk-config-name Nome da configuração do grid, caso haja.
 * @param {boolean} sk-editable Habilita/Desabilita a edição na grade.
 * @param {boolean} sk-allow-multiple-selection Habilita/Desabilita a múltipla seleção na grade.
 * @param {function} sk-on-dbl-click Função a ser executada quando um duplo clique for realizado em qualquer linha da grade.
 * @param {function} sk-on-click Função a ser executada quando um clique for realizado em qualquer linha da grade.
 * @param {function} sk-focus-to-after-refresh Função a ser executada quando quando for necessário setar o foco em um componente após o refresh no datagrid.
 * @param {function} sk-on-datagrid-loaded Função a ser chamada quando o datagrid estiver carregado.
 * @param {function} sk-datagrid-interceptor Define um interceptor para o datagrid.
 * @param {boolean} sk-hide-cbx-column Permite ocultar a coluna de checkbox da grade.
 * @param {boolean} sk-disable-pagination Desabilita a paginação na grade. Atenção: desabilitar a paginação pode causar sérios problemas de desempenho.
 * @param {boolean} sk-disable-search Desabilita a busca na grade
 * @param {boolean} sk-disable-tour Desabilita o Tour na grade
 * @param {boolean} sk-drag-enabled ativa a função de arrastar a linha(drag-and-drop)
 * @param {boolean} sk-drop-enabled ativa a função de soltar a linha(drag-and-drop)
 * @param {string} sk-drag-field-presentation nome do campo do data set que seu valor será apresentado no drag da linha
 * @param {function} sk-drag-start Acionado quando o usuário começa a arrastar uma linha
 * @param {function} sk-drag-enter Acionado quando uma linha entra em um ponto de soltura
 * @param {function} sk-drag-over Acionado quando uma linha está sendo arrastado sobre um ponto de soltura válido
 * @param {function} sk-drop Acionado quando uma linha é solta em um ponto d soltura (drop target) válido.
 * @param {function} sk-drag-end Acionado quando uma operação de arrastar está terminando
 * @param {function} sk-order-columms Função chmada para fazer a ordenação de colunas (esse é sobrescrita pela configuração da grade, quando existir)
 * @param {string} sk-key-property nome do campo chave para apresentar a grid em modo de arvore (esse parâmetro trabalha em conjunto com o sk-parent-property, se os dois forem informados a grade irá funcionar em modo arvore).
 * @param {string} sk-parent-property nome da propriedade que irá informar qual é o campo que estará fazendo o ligação com o registro pai na arvore (esse parâmetro trabalha em conjunto com o sk-key-property, se os dois forem informados a grade irá funcionar em modo arvore).
 * @param {boolean} sk-disable-first-select Desabilita a Seleção automática do primeiro item do grid
 * @param {boolean} sk-enable-grid-menu Desabilita o menu da grid. (default=true)
 * @param {boolean} sk-show-invisible-fk-fields Mostra campos de apresentação na grade mesmo que sejam provenientes de um campo de ligação com visible = 'false'.

 * @example
     <example module="app">
         <file name="exemplo.html">
            <sk-application ng-controller="MyController as ctrl" flex layout="column" style="height:300px">

            <sk-dataset
                    sk-presentation-field="CAMPOSTR"
                    sk-refresh-handler="ctrl.refreshHandler(request)"
                    sk-dataset-created="ctrl.onDatasetCreated(dataset)" 
            sk-standalone>
                <sk-dsfield-md name="CAMPOSTR" description="Campo Apresentação"></sk-dsfield-md>
                <sk-dsfield-md name="ICO" description="Campo Icone"></sk-dsfield-md>
                <sk-dsfield-md name="BTN" description="Campo Editor"></sk-dsfield-md>
            </sk-dataset>

            <sk-datagrid sk-dataset="ctrl.dataset">
                <sk-cell-renderer>                            
                    <script columns="ICO">
                        function renderer(){
                            return {
                                getGui: function(params, originalItem, scope, utils){
                                    var eGui = utils.createDirective('sk-icon', {'font-icon': scope.dataset.getFieldValue('ICO')} ,scope);
                                    //return {element: eGui, align: 'left'};
                                    return eGui;
                                },

                                refresh: function(params){
                                    return true;
                                },

                                destroy: function(){
                                    console.log('destroy');
                                }
                            }
                        }                                
                    </script>
                </sk-cell-renderer>
                <sk-editor-renderer>
                 <script columns="BTN">
                        function renderer(){
                            return {                                        
                                getGui: function(params, originalEditor, scope, utils){
                                    
                                    scope.onBtnClick = function(){
                                        alert('Booo!');
                                    }

                                    var eGui = utils.createDirective('button', {'ng-click': 'onBtnClick()'} ,scope);
                                    eGui[0].innerText = 'Click me'
                                    eGui.css('heigth', '3px');
                                    
                                    return eGui;
                                },

                                refresh: function(params){
                                    return true;
                                },

                                isCachable: function(col) {
                                    return false;
                                },

                                destroy: function(){
                                    console.log('destroy');
                                }
                            }
                        }                                
                    </script>
                <sk-editor-renderer>
            </sk-datagrid>
               
            </<sk-application>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope, $q){
                    
                    var self = this;

                    self.refreshHandler = refreshHandler;
                    self.onDatasetCreated = onDatasetCreated;

                    self.dataset;

                    function refreshHandler(request) {

                        return $q(function (resolve, reject) {                                
                            resolve([
                                ['Icone1', 'dog', 'Clique!'],
                                ['Icone2', 'user', 'Clique!'],
                                ['Icone3', 'car', 'Clique!'],
                                ['Icone4', 'camera', 'Clique!']
                            ]);                                
                        });
                    }

                    function onDatasetCreated(dataset) {
                        self.dataset = dataset;
                        dataset.initAndRefresh();
                    }
                    
                });
         </file>
     </example>
 */
angular
    .module('snk.components.datagrid')
    .directive('skDatagrid', ['DatasetUtils', 'UserAgentUtils', '$templateCache', function (DatasetUtils, UserAgentUtils, $templateCache) {
        var directive = {};

        directive.transclude = true;
        directive.restrict = 'E';
        directive.priority = 1;
        directive.template = getTemplate;
        directive.controller = '@';
        directive.name = "controllerName";

        directive.scope = {
            dataset: "=?skDataset",
            gridconfig: "@?skGridConfig",
            configName: "@?skConfigName",
            editable: "=?skEditable",
            allowMultipleSelection: "=?skAllowMultipleSelection",
            onDblClick: "&?skOnDblClick",
            onClick: '&?skOnClick',
            focusToAfterRefresh: "=skFocusToAfterRefresh",
            onDatagridLoaded: '&skOnDatagridLoaded',
            onDatagridInit: '&skOnDatagridInit',
            datagridInterceptor: '=?skDatagridInterceptor',
            hideCbxColumn: '=?skHideCbxColumn',
            avoidFocusOutWhileEditing: '=?skAvoidFocusOutWhileEditing',
            disablePagination: '=?skDisablePagination',
            disableSearch: '=?skDisableSearch',
            strFilteredColumns: '@?skStrFilteredColumns',
            enableToolPanel: "=?skEnableToolpanel",
            uidCellFormatter: '=?skUidCellFormatter',
            disableSorting: "=?skDisableSorting",
            disableTour: '=?skDisableTour',
            standaloneDatasetObject: '=?skStandaloneDatasetObject',
            enableDrag: '=?skDragEnabled',
            enableDrop: '=?skDropEnabled',
            draggableField: '@?skDragFieldPresentation',
            dragStart: '&?skDragStart',
            dragEnter: '&?skDragEnter',
            dragOver: '&?skDragOver',
            dragDrop: '&?skDrop',
            dragEnd: '&?skDragEnd',
            groupColumns: '=?skGroupColumns',
            fnOrderColumns: "=?skOrderColumms",
            keyProperty: "@?skKeyProperty",
            parentProperty: "@?skParentProperty",
            alwaysPositionFirst:'=?skAlwaysPositionFirst',
            cellStyle: '=?skCellStyle',
	    	showDataTips: '@?skShowDatatips',
            datatipClass: '@?skDatatipClass',
            editOnClick: "=?skEditOnClick",
	    	enableInsertion: '=?skEnableInsertion',
            fnSaveRowOnArrowDown: '=?skFnSaveRowOnArrowDown',
            newRowOnArrowDown: '=?skNewRowOnArrowDown',
            newRowOnTab: '=?skNewRowOnTab',
            tabBetweenEditableColumns: '=?skTabBetweenEditableColumns',
            enterAsTab: "=?skEnterAsTab",
            fnSaveRowOnEnter:"=?skFnSaveRowOnEnter",
            enabled: "=?skEnabled",
            disableFirstSelect: "=?skDisableFirstSelect",
            enableGridMenu: "=?skEnableGridMenu",
            showInvisibleFkFields: "=?skShowInvisibleFkFields",
            dropTree: "=?skDropTree",
            afterGridFunction: "=?skAfterGridFunction",
            arrowFocusField: "=?skArrowFocusField",
            nextRowAfterSave: "=?skNextrowAftersave",
            focusOut: '=?skFocusOut',
            clickRowFocus: '=?skClickRowFocus',
            autoClearEdition: '=?skAutoClearEdition',
            beforeSort: '=?skBeforeSort',
            fnSaveOnClick: '=?skFnSaveOnClick',
            editGridEvent: "=?skEditGridEvent",
            callSelectedOnce: '=?skCallSelectedOnce',
            forceShiftSelect: '=?skForceShiftSelect',
            keepCheckboxSelectionOnRowClick: '=?skKeepCheckboxSelectionOnRowClick'
        };

        function getTemplate(tElem, tAttrs) {             
            var urlTpl = 'components/datagrid/templates/datagrid.aggrid.tpl.html'; ;
            if (tAttrs.hasOwnProperty('jqx')) {
                urlTpl = 'components/datagrid/templates/datagrid.jqx.tpl.html';
            }else if (tAttrs.hasOwnProperty('uigrid')){
                urlTpl = 'components/datagrid/templates/datagrid.tpl.html';
            }

            return $templateCache.get(urlTpl);
        }

        directive.compile = compile;
        
        function compile(element, attrs) {
        	if (attrs.hasOwnProperty('jqx')) {
        		attrs.$set('controllerName', 'SkJqxDataGridController');
        	} else if(attrs.hasOwnProperty('uigrid')){                
                attrs.$set('controllerName', 'SkDataGridController');   
            }else{
                attrs.$set('controllerName', 'SkAgGridController');                
        	}
        	
        	return linker;
        }

        function resolveCustomRenderer(controller, element){
            let customCellRenderer = element[0].querySelector('sk-cell-renderer');
            let customEditorRenderer = element[0].querySelector('sk-editor-renderer');

            if(customCellRenderer){
                let scriptsElements = customCellRenderer.querySelectorAll('script');
                
                scriptsElements.forEach(function(script){
                    var renderer = eval(script.innerText + ';renderer();');
                    if(renderer){
                        controller.addCustomCellRenderer(script.getAttribute('columns'), renderer);
                    }else{
                        console.warn('[skDatagrid] o sk-cell-renderer não retornou nenhum, renderer válido.');
                    }
                });
            }

            if(customEditorRenderer){
                let scriptsElements = customEditorRenderer.querySelectorAll('script');
                
                scriptsElements.forEach(function(script){
                    var renderer = eval(script.innerText + ';renderer();');
                    if(renderer){
                        controller.addCustomEditorRenderer(script.getAttribute('columns'), renderer);
                    }else{
                        console.warn('[skDatagrid] o sk-editor-renderer não retornou nenhum, renderer válido.');
                    }
                });
            }
        }

        function linker(scope, element, attrs, controller) {

            if(scope.standaloneDatasetObject){
                scope.dataset = DatasetUtils.buildDatasetStandaloneAtObject(scope.standaloneDatasetObject, scope);
                scope.dataset.initAndRefresh();
             }
           
            if (UserAgentUtils.isMobile()) {
                element.addClass('is-mobile');
            }
            
            if (!attrs.hasOwnProperty('flex')) {
            	element.attr('flex', '');
            }

            if (!attrs.hasOwnProperty('layout')) {
                element.attr('layout', 'column');
            }

            if (attrs.id) {
                scope.$parent[attrs.id] = controller;
            }

            if(attrs.controllerName == 'SkAgGridController'){
                resolveCustomRenderer(controller, element);
            }

            scope.$watch('enabled', (newValue) => {
                controller.setEnabled(newValue);
            });

            if (attrs.hasOwnProperty('skEnableGridMenu')) {
                scope.enableGridMenu = attrs.skEnableGridMenu == undefined || attrs.skEnableGridMenu == "true";
            }
        }

        return directive;
    }]);

angular
    .module('snk.components.datagrid')
    .controller('SkJqxDataGridController', ['$scope', '$attrs', '$element', 'DomUtil', 'ObjectUtils', 'ArrayUtils', 'UserAgentUtils', 'DatasetContants', 'AngularUtil', 'GridConfigJqx', 'DateUtilsConstants', 'FormService', 'StringUtils', 'NumberUtils', 'DateUtils', 'SkJqxDatagridI18n', function ($scope, $attrs, $element, DomUtil, ObjectUtils, ArrayUtils, UserAgentUtils, DatasetContants, AngularUtil, GridConfigJqx, DateUtilsConstants, FormService, StringUtils, NumberUtils, DateUtils, SkJqxDatagridI18n) {
        var self = this;

        var CHAR_TO_PIXEL_RATIO = 14;
        var FAKE_EMPTY_COLUMN = 'FAKE_EMPTY_COLUMN';
        var DEFAULT_DECIMAL_PRECISION = 2;

        //Coloca a grade como um observer do dataset
        ObjectUtils.implements(self, IDataSetObserver);

        var _jqx = angular.element(DomUtil.select($element, '.jqx-grid-container'));

        var _observerRemoveHandler;

        var _metaDataUpdated = false;

        var _originalColumns = [];
        var _columns = [];
        var _columnsByDataField = {};
        var _columnsByName = {};
        var _records = [];

        var _formattedRowsCache = {};

        var _jqxDataSource = {
            localdata: _records,
            sort: gridSortFn,
            datatype: "array"
        };

        var _jqxDataSourceAdapter = new $.jqx.dataAdapter(_jqxDataSource);

        var _isMobile = UserAgentUtils.isMobile();

        var _rowsHeight = 0;
        var _fontSize = 12;
        var _sortable = true;
        var _sortToggleStates = 1;
        var _showAggregates = false;
        var _selectionMode = 'singlerow';
        var _isMultipleSelection = $scope.allowMultipleSelection;

        var bindJqxDataSoureDebounced = AngularUtil.debounce(bindJqxDataSoure, 100);

        //Definição das funções chamadas pelo dataset
        self.refreshed = onDatasetRefresh;

        self.getColumnMDByName = getColumnMDByName;
        self.setColumns = setColumns;
        self.getColumns = getColumns;
        self.refreshColumns = refreshColumns;
        self.hideColumn = hideColumn;
        self.showColumn = showColumn;
        self.refreshView = refreshView;

        init();

        function init() {
            var columnHeight = _fontSize;

            if (_isMultipleSelection) {
                _selectionMode = _isMobile ? 'multiplerows' : 'multiplerowsextended';
            }

            _jqx.jqxGrid({
                theme: 'metro',
                localization: SkJqxDatagridI18n.getI18n(),
                source: _jqxDataSourceAdapter,
                width: '99%',
                height: '100%',
                columnsheight: (columnHeight + 12),
                columnsmenuwidth: (_isMobile ? 30 : 24),
                autoshowcolumnsmenubutton: !_isMobile,
                rowsheight: getRowsHeight(),
                columnsreorder: true,
                columnsresize: true,
                sortable: _sortable,
                virtualmode: true,
                altrows: true,
                filterable: false,//filterable: true,TODO
                enabletooltips: true,
                sorttogglestates: _sortToggleStates,
                rendergridrows: renderGridRows,
                selectionmode: _selectionMode,
                showfiltercolumnbackground: false,
                showsortcolumnbackground: false,
                showstatusbar: _showAggregates,
                statusbarheight: 20,
                showaggregates: _showAggregates,
                clipboard: false,
                enablebrowserselection: true,
                columnmenuopening: function (menu, datafield) {
                    menu.height("auto");
                    menu.addClass("custom-menu-column");
                }
            });

            bindJqxEvents();

            $scope.$watch('dataset', function (newV) {
                if (_observerRemoveHandler) {
                    _observerRemoveHandler();
                }

                if (newV) {
                    _observerRemoveHandler = $scope.dataset.addObserver(self);

                    $scope.dataset.whenMetadataLoaded().then(loadMetadata);
                }
            });

            $scope.$watchCollection(function () {
                if ($scope.dataset) {
                    return $scope.dataset.getRecordsList().getListVersion();
                }
            }, bindJqxDataSoureDebounced);

            $attrs.$observe('skGridConfig', updateGridConfigName);
            $attrs.$observe('skConfigName', updateGridConfigName);
        }

        function updateGridConfigName(gridConfigName) {
            $scope.gridconfig = gridConfigName;
        }

        function getColumnWidth(description) {
            if (description.length <= 10) {
                return Math.max((Math.min(description.length, 30) * CHAR_TO_PIXEL_RATIO), 100);
            }
            else {
                return Math.max((Math.min(description.length, 30) * (CHAR_TO_PIXEL_RATIO - 5) ), 100);
            }
        }

        function bindJqxEvents() {
            angular.forEach({
                'rowclick': handleClick,
                'rowselect': handleRowSelect,
                'rowdoubleclick': handleDblClick,
                'columnresized': handleColumnResized,
                'columnreordered': handleColumnReordered
            }, function (fn, eventName) {
                _jqx.on(eventName, function (event) {
                    fn(event);
                });
            });
        }

        function handleColumnResized(event) {
            if (angular.isDefined($scope.gridconfig)) {
                GridConfigJqx.save($scope.gridconfig, self);
            }
        }

        function handleColumnReordered(event) {
            if (angular.isDefined($scope.gridconfig)) {
                GridConfigJqx.save($scope.gridconfig, self);
            }
        }

        function handleRowSelect(event) {
            var rowIndex = event.args.rowindex;

            $scope.dataset
                .save(false)
                .then(function () {
                    gotoRowOnDataset(rowIndex);
                }, function (error) {
                    if (error === DatasetContants.RECORD_IS_NOT_DIRTY) {
                        gotoRowOnDataset(rowIndex);
                    }
                });
        }

        function gridSortFn(column, direction) {
            var callBind = false;

            if (typeof direction == 'string') {
                direction = (direction.indexOf('asc') > -1) ? true : false;
                callBind = true;
            }

            if (direction == null) {
                $scope.dataset.setSortFunction(undefined);
            } else {
                var typedSortFn = getSortFn(column);

                $scope.dataset.setSortFunction(function (valueA, valueB) {
                    var result = typedSortFn(valueA[column], valueB[column]);

                    return direction ? result : 0 - result;
                });
            }


            $scope.dataset.refreshRecordsList();

            if (callBind) {
                bindJqxDataSoureDebounced();
            }
        }

        function getColumnMDByName(name) {
            return _columnsByName[name];
        }

        function getSortFn(colIndex) {
            var columnMD = _columnsByDataField[colIndex];

            switch (columnMD.type) {
                case "number":
                case "time" :
                    return sortNumber;
                case "date":
                    return sortDate;
                case "datetime":
                    return sortDate;
                default:
                    return sortAlpha;
            }
        }

        function handleNulls(a, b) {
            // We want to allow zero values and false values to be evaluated in the sort function
            if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
                // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
                if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
                    return 0;
                }
                else if (!a && a !== 0 && a !== false) {
                    return -1;
                }
                else if (!b && b !== 0 && b !== false) {
                    return 1;
                }
            }
            return null;
        }

        function sortNumber(a, b) {
            var nulls = handleNulls(a, b);
            if (nulls !== null) {
                return nulls;
            } else {
                return a - b;
            }
        }

        function sortAlpha(a, b) {
            var nulls = handleNulls(a, b);
            if (nulls !== null) {
                return nulls;
            } else {
                var strA = a.toString().toLowerCase(),
                    strB = b.toString().toLowerCase();

                return strA === strB ? 0 : (strA < strB ? -1 : 1);
            }
        }

        function sortDate(a, b) {
            var nulls = handleNulls(a, b);
            if (nulls !== null) {
                return nulls;
            } else {
                var timeA = a.getTime(),
                    timeB = b.getTime();

                return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
            }
        }

        function gotoRowOnDataset(rowIndex) {
            $scope.dataset.gotoRow(rowIndex);
        }

        function handleClick() {
            $scope.onClick();
        }

        function handleDblClick() {
            $scope.onDblClick();
        }

        function loadMetadata() {
            var fieldMds = ArrayUtils.copy($scope.dataset.getFieldsMetadata(), true);

            _columns = [];
            _columnsByDataField = {};

            fieldMds.forEach(function (fieldMD, index) {
                var isVisible;

                //TODO
                //if (customColumnMD && customColumnMD.hasOwnProperty('visible')) {
                //    isVisible = customColumnMD.visible;
                //} else {
                    isVisible = fieldMD.userType === 'B' ? false : fieldMD.visible;
                //}

                if (angular.isUndefined(isVisible)) {
                    isVisible = true;
                }

                var userType = FormService.getUserType(fieldMD);
                var dataType = fieldMD.dataType;

                var columnMD = {
                    transientColumn: false,
                    name: fieldMD.name,
                    text: fieldMD.description,
                    datafield: String(index),
                    width: getColumnWidth(fieldMD.description),
                    hidden: angular.isDefined($scope.gridconfig) ? true : !isVisible,
                    filtertype: 'custom',
                    createfilterpanel: createColumnFilterPanel,
                    skVisible: isVisible,
                    userType: userType,
                    dataType: dataType,
                    type: 'string'
                };

                if (dataType === 'D' || dataType === 'H' || dataType == 'T') {
                    if (dataType === 'D') {
                        columnMD.type = 'date';
                    } else if (dataType === 'H') {
                        columnMD.type = 'datetime';
                    } else {
                        columnMD.type = 'time';
                    }
                } else if (dataType == 'I' || dataType == 'F') {
                    columnMD.type = 'number';
                    columnMD.align = 'right';
                    columnMD.cellsalign = 'right';
                }

                _columns.push(columnMD);
                _columnsByDataField[columnMD.datafield] = columnMD;
                _columnsByName[columnMD.name] = columnMD;
            });

            _columns.push({
                text: ' ',
                datafield: FAKE_EMPTY_COLUMN,
                menu: false,
                filterable: false,
                sortable: false,
                resizable: false,
                draggable: false,
                useAggregates: false,
                transientColumn: true,
                hidden: false,
                skVisible: true
            });

            _metaDataUpdated = true;

            backupOriginalColumns();

            setColumns(_columns, false);
            onDatasetRefresh();

            if (angular.isDefined($scope.gridconfig)) {
                GridConfigJqx.load($scope.gridconfig).then(setConfiguration);
            }
        }

        function backupOriginalColumns() {
            _originalColumns = _columns.map(function(col) {
                return angular.copy(col);
            });
        }

        function restoreOriginalColumns(interceptor) {
            _columns = _originalColumns.map(function(col) {
                var newCol = angular.copy(col);
                interceptor && interceptor(newCol);
                return newCol;
            });
        }

        function setConfiguration(resultConfig) {
            if (angular.isUndefined(resultConfig)) {
                resultConfig = {};
            }

            //TODO
            //resultConfig.restrictBySup
            //gridConfig.pinnedColumns = resultConfig.pinnedColumns;
            //if (resultConfig.hasOwnProperty('compactMode')) {
            //    compactMode = resultConfig.compactMode;
            //}

            //TODO: getOrderFieldsFromConfiguration

            if (resultConfig.restrict) {
                //TODO
            } else {
                var fieldsResult = resultConfig.field;

                if (!fieldsResult || fieldsResult.length == 0) {
                    restoreOriginalColumns(function(col) {
                        if (col.skVisible) {
                            col.hidden = false;
                        }
                    });

                    refreshColumns();
                } else {
                    var newColumns = [];
                    var configCols = {};

                    for (var i = 0, len = fieldsResult.length; i < len; i++) {
                        var fieldResult = fieldsResult[i];

                        if (configCols[fieldResult.name]) {
                            continue;
                        }

                        var column = getColumnMDByName(fieldResult.name);

                        if (!column) {
                            continue;
                        }

                        if (!isNaN(Number(fieldResult.orderIndex))) {
                            column.sortIndex = Number(fieldResult.orderIndex);
                        }

                        if (fieldResult.hasOwnProperty('ascending')) {
                            column.sortAscending = fieldResult.ascending;
                        }

                        if (!isNaN(Number(fieldResult.width))) {
                            column.width = Number(fieldResult.width);
                        }

                        column.hidden = !column.skVisible;

                        configCols[column.name] = column;

                        newColumns.push(column);
                    }

                    getColumns().forEach(function (column) {
                        if (!configCols[column.name]) {
                            if (!column.transientColumn) {
                                column.hidden = true;
                            }

                            newColumns.push(column);
                        }
                    });

                    setColumns(newColumns);
                }
            }
        }

        function onDatasetRefresh() {
            bindJqxDataSoure();
        }

        function clearCache() {
            _formattedRowsCache = {};
        }

        function bindJqxDataSoure() {
            clearCache();

            if ($scope.dataset) {
                if (_records !== $scope.dataset.getRecords()) {
                    _records = $scope.dataset.getRecords();
                }

                _jqxDataSource.localdata = _records;

                _jqx.jqxGrid({source: _jqxDataSource});
            }
        }

        function fieldHasOptions(fieldMD) {
            return fieldMD.options && fieldMD.options.length > 0;
        }

        function optionsCellFormatter(value, options) {
            if (angular.isDefined(value)) {

                for (var i = 0; i < options.length; i++) {
                    var opt = options[i];

                    if (opt.data == value) {
                        return opt.value;
                    }
                }
            }

            return value;
        }

        function createColumnFilterPanel(datafield, filterPanel) {
            var i18n = getI18n();

            var newItem = angular.element("<li class='custom-item-filter jqx-item jqx-menu-item-top jqx-rc-all'></li>");
            //newItem.text(i18n.filterstring);

            //var clearItem = angular.element("<li class='custom-item-filter jqx-item jqx-menu-item-top jqx-rc-all jqx-fill-state-disabled'><div class='jqx-grid-filter-clear-icon'></div>" + i18n.filterremovestring + "</li>");

            var enableRemoveFilter = false;

            newItem.on('click', function() {
                openDistinctFilterPopup(datafield);
                _jqx.jqxGrid('closemenu');
            });

            /*clearItem.on('click', function() {
                if (enableRemoveFilter) {
                    clearDistinctFilter(datafield);
                    _jqx.jqxGrid('closemenu');
                }
            });*/

            _jqx.on('filterChange', function(event, info) {
                if (info.datafield == dataField) {
                    enableRemoveFilter = info.filtrated;

                    if (enableRemoveFilter) {
                        clearItem.removeClass('jqx-fill-state-disabled');
                    } else {
                        clearItem.addClass('jqx-fill-state-disabled');
                    }
                }
            });

            filterPanel = angular.element(filterPanel);
            filterPanel = filterPanel.addClass('jqx-custom-menu-filter');

            filterPanel.append(newItem);
            filterPanel.append(clearItem);
        }

        function openDistinctFilterPopup(dataField) {
            console.log(dataField);
        }

        function clearDistinctFilter(dataField) {
            console.log(dataField);
        }

        function beginUpdate(suspendAll) {
            _jqx.jqxGrid('beginupdate', suspendAll);
        }

        function endUpdate() {
            _jqx.jqxGrid('endupdate');
        }

        function setColumns(columns, useCachedUpdate) {
            useCachedUpdate = angular.isUndefined(useCachedUpdate) ? true : useCachedUpdate;

            _columns = columns;

            if (useCachedUpdate) {
                beginUpdate();
            }


            _jqx.jqxGrid({columns: _columns});

            if (useCachedUpdate) {
                endUpdate();
            }
        }

        function refreshColumns() {
            setColumns(getColumns());
        }

        function refreshView() {
            updateBoundData();
        }

        function showColumn(name) {
            var columnMD = !isNaN(Number(name)) ? _columnsByDataField[name] : _columnsByName[name];

            if (columnMD) {
                columnMD.hidden = false;
                _jqx.jqxGrid('showcolumn', columnMD.datafield);
            }
        }

        function hideColumn(name) {
            var columnMD = !isNaN(Number(name)) ? _columnsByDataField[name] : _columnsByName[name];

            if (columnMD) {
                columnMD.hidden = true;
                _jqx.jqxGrid('hidecolumn', columnMD.datafield);
            }
        }

        function updateBoundData(reason) {
            if (reason) {
                _jqx.jqxGrid('updatebounddata', reason);
            } else {
                _jqx.jqxGrid('updatebounddata');
            }
        }

        function getColumns() {
            return _columns;
        }

        function renderGridRows(params) {
            if (!_metaDataUpdated) {
                return params.data;
            }

            var startindex = params.startindex;
            var endindex = Math.min(params.endindex, params.data.length);
            var newData = new Array(endindex - startindex);

            for (var i = startindex; i < endindex; i++) {
                var row = params.data[i];
                var formattedRow = _formattedRowsCache[row.uid];

                if (!formattedRow) {
                    formattedRow = {};

                    _columns.forEach(function(column) {
                        var currValue = row[column.datafield];
                        var formattedValue = currValue;

                        if (!column.transientColumn && angular.isDefined(currValue)) {
                            formattedValue = formatColumnCell(column, currValue);
                        }

                        formattedRow[column.datafield] = formattedValue;
                    });

                    _formattedRowsCache[row.uid] = formattedRow;
                }

                newData[i] = formattedRow;
            }

            return newData;
        }

        function formatColumnCell(column, value) {
            var fieldMD = $scope.dataset.getFieldMetadataByIndex(column.datafield);

            //TODO tratar customCellFormatter

            if (fieldHasOptions(fieldMD)) {
                return optionsCellFormatter(value, fieldMD.options);
            } else {

                var dataType = fieldMD.dataType;
                var userType = FormService.getUserType(fieldMD);

                switch (dataType) {
                    case 'S':
                        if (userType == 'Phone') {
                            return StringUtils.toPhone(value);
                        } else if (userType == 'CGC_CPF') {
                            return StringUtils.formatCgcCpf(value);
                        } else {
                            return value;
                        }
                    case 'I':
                        return value;
                    case 'F':
                        return NumberUtils.format(value, fieldMD.precision || DEFAULT_DECIMAL_PRECISION);
                    case 'T':
                        return DateUtils.getTimeExtraFormatter(value);
                    case 'D':
                    case 'H':
                        if (angular.isDate(value)) {
                            var format;

                            if (dataType === 'D') {
                                format = DateUtilsConstants.DEFAULT_DATE_FORMAT;
                            } else {
                                //TODO tratar esse options
                                // if (!options || !(options.includeSeconds === false)) {
                                    format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS;
                                //} else {
                                //    format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT;
                                //}
                            }

                            return DateUtils.formatDate(value, format);
                        }
                        break;

                        return value;


                }

                return value;
            }
        }

        function getRowsHeight() {
            var gap = 14;

            if (_rowsHeight > 0) {
                return _rowsHeight + gap;
            }

            return _fontSize + gap;
        }
    }]);

/**
 * Created by bruno.brandao on 22/05/2017.
 */
angular
    .module('snk.components.datagrid')
    .service('SkJqxDatagridI18n', ['SkI18nService', function (SkI18nService) {

        this.getI18n = getI18n;

        function getI18n() {
            switch (SkI18nService.getLang().toUpperCase()) {
                case 'EN_US':
                    return getEnUs();

                case 'ES_ES':
                    return getEsEs();

                default:
                    return getPtBr();
            }
        }

        function getPtBr() {
            return {
                '/': "/",
                ':': ":",
                firstDay: 0,
                days: {
                    names: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
                    namesAbbr: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "SÃ¡b"],
                    namesShort: ["D", "S", "T", "Q", "Q", "S", "S"]
                },
                months: {
                    names: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                    namesAbbr: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez", ""]
                },
                AM: ["AM", "am", "AM"],
                PM: ["PM", "pm", "PM"],
                eras: [
                    {"name": "d.D.", "start": null, "offset": 0}
                ],
                twoDigitYearMax: 2029,
                patterns: {
                    d: "dd/MM/yyyy",
                    D: "dddd, d' de 'MMMM' de 'yyyy",
                    t: "HH:mm",
                    T: "HH:mm:ss",
                    f: "dddd, d' de 'MMMM' de 'yyyy HH:mm",
                    F: "dddd, d' de 'MMMM' de 'yyyy HH:mm:ss",
                    M: "dd' de 'MMMM",
                    Y: "MMMM' de 'yyyy",
                    S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                    ISO: "yyyy-MM-dd hh:mm:ss",
                    ISO2: "yyyy-MM-dd HH:mm:ss",
                    d1: "dd.MM.yyyy",
                    d2: "dd-MM-yyyy",
                    d3: "dd-MMMM-yyyy",
                    d4: "dd-MM-yy",
                    d5: "H:mm",
                    d6: "HH:mm",
                    d7: "HH:mm tt",
                    d8: "dd/MMMM/yyyy",
                    d9: "MMMM-dd",
                    d10: "MM-dd",
                    d11: "MM-dd-yyyy"
                },
                percentsymbol: "%",
                currencysymbol: "R$",
                currencysymbolposition: "before",
                decimalseparator: ',',
                thousandsseparator: '.',
                pagergotopagestring: "Ir para a página:",
                pagershowrowsstring: "Mostrar linhas:",
                pagerrangestring: " de ",
                pagerpreviousbuttonstring: "anterior",
                pagernextbuttonstring: "Próxima",
                pagerfirstbuttonstring: "Primeira",
                pagerlastbuttonstring: "Última",
                groupsheaderstring: "Arraste uma coluna e solte aqui para agrupar por essa coluna",
                sortascendingstring: "Ordenar crescente",
                sortdescendingstring: "Ordenar decrescente",
                sortremovestring: "Remover ordenação",
                groupbystring: "Agrupar por essa coluna",
                groupremovestring: "Remover agrupamentos",
                filterclearstring: "Limpar",
                filterstring: "Filtrar",
                filterremovestring: "Remover filtro",
                filtershowrowstring: "Mostrar linhas enquanto:",
                filterorconditionstring: "Ou",
                filterandconditionstring: "E",
                filterselectallstring: "(Selecionar todos)",
                filterchoosestring: "Por favor escolha:",
                filterstringcomparisonoperators: ['vazio', 'não vazio', 'contém', 'contém (casar caixa)',
                    'não contém', 'não contém (casar caixa)', 'começando com', 'começando com (casar caixa)',
                    'terminando em', 'terminando em (casar caixa)', 'igual', 'igual (casar caixa)', 'nulo', 'não nulo'],
                filternumericcomparisonoperators: ['igual', 'diferente', 'menor que', 'menor ou igual que', 'maior que', 'maior ou igual que', 'null', 'not null'],
                filterdatecomparisonoperators: ['igual', 'diferente', 'menor que', 'menor ou igual que', 'maior que', 'maior ou igual que', 'null', 'not null'],
                filterbooleancomparisonoperators: ['igual', 'diferente'],
                validationstring: "Valor inserido inválido",
                emptydatastring: "Nenhuma linha para apresentar",
                filterselectstring: "Selecionar Filtro",
                loadtext: "Carregando...",
                clearstring: "Limpar",
                todaystring: "Hoje"
            };
        }

        function getEnUs() {
            return {
                '/': "/",
                ':': ":",
                firstDay: 0,
                days: {
                    names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
                },
                months: {
                    names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""],
                    namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""]
                },
                AM: ["AM", "am", "AM"],
                PM: ["PM", "pm", "PM"],
                eras: [
                    {"name": "d.D.", "start": null, "offset": 0}
                ],
                twoDigitYearMax: 2029,
                patterns: {
                    d: "M/d/yyyy",
                    D: "dddd, MMMM dd, yyyy",
                    t: "h:mm tt",
                    T: "h:mm:ss tt",
                    f: "dddd, MMMM dd, yyyy h:mm tt",
                    F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                    M: "MMMM dd",
                    Y: "yyyy MMMM",
                    S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss"
                },
                percentsymbol: "%",
                currencysymbol: "$",
                currencysymbolposition: "before",
                decimalseparator: '.',
                thousandsseparator: ',',
                pagergotopagestring: "Go to page:",
                pagershowrowsstring: "Show rows:",
                pagerrangestring: " of ",
                pagerpreviousbuttonstring: "Previous",
                pagernextbuttonstring: "Next",
                pagerfirstbuttonstring: "First",
                pagerlastbuttonstring: "Last",
                groupsheaderstring: "Drag a column and drop it here to group by that column",
                sortascendingstring: "Sort Ascending",
                sortdescendingstring: "Sort Descending",
                sortremovestring: "Remove Sort",
                groupbystring: "Group By this column",
                groupremovestring: "Remove from groups",
                filterclearstring: "Clear",
                filterstring: "Filter",
                filtershowrowstring: "Show rows where:",
                filtershowrowdatestring: "Show rows where date:",
                filterorconditionstring: "Or",
                filterandconditionstring: "And",
                filterselectallstring: "(Select All)",
                filterchoosestring: "Please Choose:",
                filterstringcomparisonoperators: ['empty', 'not empty', 'contains', 'contains(match case)',
                    'does not contain', 'does not contain(match case)', 'starts with', 'starts with(match case)',
                    'ends with', 'ends with(match case)', 'equal', 'equal(match case)', 'null', 'not null'],
                filternumericcomparisonoperators: ['equal', 'not equal', 'less than', 'less than or equal', 'greater than', 'greater than or equal', 'null', 'not null'],
                filterdatecomparisonoperators: ['equal', 'not equal', 'less than', 'less than or equal', 'greater than', 'greater than or equal', 'null', 'not null'],
                filterbooleancomparisonoperators: ['equal', 'not equal'],
                validationstring: "Entered value is not valid",
                emptydatastring: "No data to display",
                filterselectstring: "Select Filter",
                loadtext: "Loading...",
                clearstring: "Clear",
                todaystring: "Today"
            };
        }

        function getEsEs() {
            return {
                '/': "/",
                ':': ":",
                firstDay: 0,
                days: {
                    names: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
                    namesAbbr: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
                    namesShort: ["D", "L", "M", "X", "J", "V", "S"]
                },
                months: {
                    names: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Julio", "Julho", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre", ""],
                    namesAbbr: ["En", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic", ""]
                },
                AM: ["AM", "am", "AM"],
                PM: ["PM", "pm", "PM"],
                eras: [
                    {"name": "d.D.", "start": null, "offset": 0}
                ],
                twoDigitYearMax: 2029,
                patterns: {
                    d: "dd/MM/yyyy",
                    D: "dddd, d' de 'MMMM' de 'yyyy",
                    t: "HH:mm",
                    T: "HH:mm:ss",
                    f: "dddd, d' de 'MMMM' de 'yyyy HH:mm",
                    F: "dddd, d' de 'MMMM' de 'yyyy HH:mm:ss",
                    M: "dd' de 'MMMM",
                    Y: "MMMM' de 'yyyy",
                    S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                    ISO: "yyyy-MM-dd hh:mm:ss",
                    ISO2: "yyyy-MM-dd HH:mm:ss",
                    d1: "dd.MM.yyyy",
                    d2: "dd-MM-yyyy",
                    d3: "dd-MMMM-yyyy",
                    d4: "dd-MM-yy",
                    d5: "H:mm",
                    d6: "HH:mm",
                    d7: "HH:mm tt",
                    d8: "dd/MMMM/yyyy",
                    d9: "MMMM-dd",
                    d10: "MM-dd",
                    d11: "MM-dd-yyyy"
                },
                percentsymbol: "%",
                currencysymbol: "R$",
                currencysymbolposition: "before",
                decimalseparator: ',',
                thousandsseparator: '.',
                pagergotopagestring: "Ir a la página:",
                pagershowrowsstring: "Mostrar líneas:",
                pagerrangestring: " hasta ",
                pagerpreviousbuttonstring: "Anterior",
                pagernextbuttonstring: "Siguiente",
                pagerfirstbuttonstring: "Primera",
                pagerlastbuttonstring: "Último",
                groupsheaderstring: "Arrastre una columna y suelte aquí para agrupar por esa columna",
                sortascendingstring: "Ordenar creciente",
                sortdescendingstring: "Ordenar descendente",
                sortremovestring: "Eliminar ordenación",
                groupbystring: "Agrupar por esa columna",
                groupremovestring: "Quitar agrupaciones",
                filterclearstring: "Limpiar",
                filterstring: "Filtrar",
                filterremovestring: "Eliminar filtro",
                filtershowrowstring: "Mostrar las líneas como:",
                filterorconditionstring: "U",
                filterandconditionstring: "y",
                filterselectallstring: "(Seleccionar todos)",
                filterchoosestring: "Por favor seleccione:",
                filterstringcomparisonoperators: ['Vacío', 'no vacío', 'contiene', 'contiene (caso de coincidencia)',
                    'No contiene', 'no contiene (case match)', 'comienza con', 'comienza con (case match)',
                    'Termina con', 'termina con (caso de coincidencia)', 'igual', 'igual (caso de coincidencia)', 'nulo', 'no nulo'],
                filternumericcomparisonoperators: ["Igual", "diferente", "menor que", "menor o igual que", "mayor que", "mayor o igual que", 'null', 'no null'],
                filterdatecomparisonoperators: ['Igual', 'diferente', 'menor que', 'menor o igual que', 'mayor que', 'mayor que igual,', 'null', 'not null'],
                filterbooleancomparisonoperators: ['igual', 'diferente'],
                validationstring: "Valor insertado no válido",
                emptydatastring: "Ninguna línea para presentar",
                filterselectstring: "Seleccionar filtro",
                loadtext: "Cargando...",
                clearstring: "Limpiar",
                todaystring: "Hoy"
            };
        }
    }]);
/**
 * Created by bruno.brandao on 03/02/2017.
 */
angular
    .module('snk.components.datagrid')
    .service('DatagridTourContent', ['GridConfig', function(GridConfig) {
        var self = this;

        self.getTourContent = getTourContent;
        self.getGridConfigTourContent = getGridConfigTourContent;

        function getTourContent(datagridController) {
            return {
                startTour: false,
                onFinish: function () {
                    datagridController.closeGridMenu();
                },
                tourConfig: getTourSteps(datagridController)
            }
        }

        function getGridConfigTourContent() {
            return {
                startTour: true,
                onFinish: function () {

                },
                tourConfig: getGridConfigTourSteps()
            }
        }

        function getGridConfigTourSteps() {
            return [
                //Configurador da Grade (GridConfig)
                {
                    type: "title",
                    heading: "Configurador de grade",
                    html: "O configurador de grade permite que você configure quais colunas ficarão visíveis na grade, a ordem em que elas aparecerão, e até mesmo a ordenação inicial dos dados.<br/><br/>" +
                    "Vamos explorar como definir tais configurações...",
                    placement: "center",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: 'function',
                    fn: function() {
                        GridConfig.openGroup(0);
                    }
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-disponiveis",
                    heading: "Colunas disponíveis",
                    html: "Aqui você encontrará as colunas disponíveis. As colunas selecionadas ficam invisíveis na grade.",
                    placement: "right",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-disponiveis-search",
                    heading: "Pesquisa de colunas disponíveis",
                    html: "Através desta pesquisa você pode localizar uma coluna disponível.<br/><br/><a class=\"link\" ng-click=\"fnExperimente()\">Experimente!</a>",
                    actions: {
                        fnExperimente: function () {
                            var input = document.querySelectorAll('.gridconfig-colunas-disponiveis-search sk-text-input input');
                            angular.element(input).focus();
                        }
                    },
                    placement: "right",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-colunas-disponiveis-container",
                    heading: "Colunas disponíveis",
                    html: "Aqui você encontra uma lista com todas as colunas disponíveis, podendo arrastá-las com o mouse (ou com o dedo, se houver suporte) para a lista de colunas selecionadas, caso deseje.",
                    placement: "right",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-all-to-right",
                    heading: "Mover todos para a direita",
                    html: "Este botão move todos os registros da esquerda para a direita.",
                    placement: "bottom",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-selected-to-right",
                    heading: "Mover selecionadas para a direita",
                    html: "Este botão move os registros selecionados da esquerda para a direita.",
                    placement: "bottom",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-selected-to-left",
                    heading: "Mover selecionadas para a esquerda",
                    html: "Este botão move os registros selecionados da direita para a esquerda.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-move-all-to-left",
                    heading: "Mover todos para a esquerda",
                    html: "Este botão move todos os registros da direita para a esquerda.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-selecionadas",
                    heading: "Colunas selecionadas",
                    html: "Aqui você encontrará as colunas selecionadas. As colunas disponíveis ficam visíveis na grade.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: ".gridconfig-colunas-selecionadas-search",
                    heading: "Pesquisa de colunas selecionadas",
                    html: "Através desta pesquisa você pode localizar uma coluna selecionada para aparecer na grade.<br/><br/><a class=\"link\" ng-click=\"fnExperimente()\">Experimente!</a>",
                    actions: {
                        fnExperimente: function () {
                            var input = document.querySelectorAll('.gridconfig-colunas-selecionadas-search sk-text-input input');
                            angular.element(input).focus();
                        }
                    },
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-colunas-selecionadas-container",
                    heading: "Colunas selecionadas",
                    html: "Aqui você encontra uma lista com todas as colunas selecionadas, podendo arrastá-las com o mouse (ou com o dedo, se houver suporte) para a lista de colunas disponíveis, caso deseje.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-up-all",
                    heading: "Mover para o topo",
                    html: "Este botão move o registro selecionado para a primeira posição.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-up",
                    heading: "Mover para cima",
                    html: "Este botão move os registros selecionados uma posição acima.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-down",
                    heading: "Mover para baixo",
                    html: "Este botão move os registros selecionados uma posição abaixo.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    selector: "#grdcfg-btn-down-all",
                    heading: "Mover a última posição",
                    html: "Este botão move o registro selecionado para a última posição.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "title",
                    heading: "Ordenação dos dados",
                    html: "Vamos explorar agora a funcionalidade que define a ordenação inicial dos dados na grade. ",
                    placement: "center",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "function",
                    fn: function (next) {
                        if (next) {
                            GridConfig.openGroup(1);
                        } else {
                            GridConfig.openGroup(0);
                        }
                    }
                },
                {
                    type: "title",
                    heading: "Ordenação dos dados",
                    html: "Os registros podem ser ordenados por quaisquer colunas marcadas como selecionadas no passo anterior.<br/><br/>" +
                    "Para ordenar os dados por alguma coluna, basta marcar o checkbox à esquerda. Um ícone aparecerá à direita para que seja configurado se a ordenação será ascendente (crescente) ou descendente (decrescente). Para alterar a configuração, basta clicar no ícone que aparece mais à direita.<br/><br/>" +
                    "A imagem abaixo ilustra uma configuração de ordenação.<br/><br/>" +
                    "<img width='425px' src='/mge/assets/img/grdcfg-ordenacao.PNG'><br/><br/>",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "title",
                    heading: "Ordenação dos dados",
                    html: "A configuração ilustrada pela imagem indica que a grade, ao ser carregada, terá suas linhas ordenadas da seguinte maneira:<br/><br/>" +
                    "Os registros serão ordenados, primeiramente, pela coluna Nome, de forma descendente.<br/><br/>" +
                    "Como segundo critério de ordenação, tem-se a coluna Nome do Correio, configurada para ordenar os registros de forma ascendente.<br/><br/>" +
                    "As demais colunas, como não estão marcadas pelo checkbox, não influenciarão a ordenação dos dados.<br/><br/>" +
                    "<img width='425px' src='/mge/assets/img/grdcfg-ordenacao.PNG'><br/><br/>",
                    placement: "center",
                    scroll: true,
                    attachToBody: true
                }
            ]
        }


        function getTourSteps(datagridController) {
            return [
                {
                    type: "element",
                    heading: "Menu da Grade",
                    selector: ".datagrid .ui-grid-menu-button .ui-grid-icon-container sk-icon span",
                    html: "O menu da grade exibe uma série de opções relacionadas à mesma.<br/><br/>Vamos conhecê-las...",
                    placement: "left",
                    scroll: true,
                    attachToBody: true,
                    preventDisableClick: true
                },
                {
                    type: "function",
                    fn: function (next) {
                        if (next) {
                            datagridController.openGridMenu();
                        } else {
                            datagridController.closeGridMenu();
                        }
                    }
                },
                {
                    type: "element",
                    heading: "Busca de Colunas",
                    selector: ".datagrid-menu-item-search",
                    html: "Muitas colunas na grade? Não se preocupe!<br/><br/>" +
                    "Utilize esta busca para encontrar uma coluna e ir diretamente até ela. Fácil, rápido e eficiente.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Pesquisar nas Colunas",
                    selector: ".datagrid-search-menu-item",
                    html: "Ao clicar aqui, campos de pesquisa surgirão logo abaixo do nome de cada coluna para que você possa filtrar os registros informando critérios para cada uma delas.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Modo Confortável/Compacto",
                    selector: ".datagrid-comfortable-item",
                    html: "Através desta opção é possível configurar a grade para o modo confortável ou modo compacto.<br/><br/>" +
                    "O modo confortável faz com que as linhas da grade fiquem mais largas, tornando-as mais fáceis de serem clicadas.<br/><br/>" +
                    "O modo compacto diminui a largura das linhas, fazendo com que mais dados caibam na tela.",
                    placement: "left",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "function",
                    fn: function (next) {
                        if (next) {
                            datagridController.closeGridMenu();
                        } else {
                            datagridController.openGridMenu();
                        }
                    }
                },
                {
                    type: "element",
                    heading: "Selecionar/Deselecionar Todos",
                    selector: ".datagrid-cbx-header",
                    html: "Caso a múltipla seleção esteja disponível para a grade, clicando aqui é possível selecionar e/ou deselecionar todos os regristros.",
                    placement: "right",
                    scroll: false,
                    attachToBody: true
                },
                //Menu das Colunas da Grade
                {
                    type: "element",
                    heading: "Menu das colunas",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Cada coluna possui um menu com opções referentes à ela, conforme ilustra a imagem a seguir.<br/><br/>" +
                    "<img style='margin-left:43px;' src='/mge/assets/img/html5-column-menu.gif'><br/><br/>" +
                    "Vamos conhecer cada uma delas...",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Ordenar Ascendente",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Ordena os registros da grade pela coluna selecionada em ordem ascendente (ou crescente).<br/><br/>" +
                    "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-opt1.png' width='324px' height='226px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Ordenar Ascendente",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Conforme ilustra a imagem abaixo, após a ordenação, uma barra verde aparecerá sobre a coluna indicando que os registros estão ordenados em ordem ascendente.<br/><br/>" +
                    "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-opt1-2.png' width='290px' height='141px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Ordenar Descendente",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Ordena os registros da grade pela coluna selecionada em ordem descendente (ou decrescente).<br/><br/>" +
                    "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-opt2.png' width='324px' height='226px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Ordenar Descendente",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Conforme ilustra a imagem abaixo, após a ordenação, uma barra vermelha aparecerá sobre a coluna indicando que os registros estão ordenados em ordem descendente.<br/><br/>" +
                    "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-opt2-2.png' width='290px' height='141px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Filtrar",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Filtra os registros da grade.<br/><br/>" +
                    "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-opt3.png' width='324px' height='226px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Filtrar",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Conforme ilustra a imagem abaixo, um popup aparecerá para que os registros possam ser filtrados.<br/><br/>" +
                    "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-opt3-2.png' width='284px' height='240px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Agrupar",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Agrupa os registros segundo a coluna indicada.<br/><br/>" +
                    "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-opt4.png' width='324px' height='226px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Agrupar",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Conforme ilustra a imagem abaixo, após serem agrupados, os registros são ordenados em ordem ascendente e uma coluna nova é adicionada à grade para que seja possível expandir e recolher um grupo de registros.<br/><br/>" +
                    "<img style='margin-left:43px;' src='/mge/assets/img/column-menu-opt4-2.png' width='290px' height='141px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Fixar Coluna",
                    selector: ".ui-grid-render-container-body .ui-grid-header-viewport",
                    html: "Fixa a coluna escolhida no lado esquerdo da grade, fazendo com que a mesma e seu conteúdo estejam sempre visíveis.<br/><br/>" +
                    "<img style='margin-left:25px;' src='/mge/assets/img/column-menu-opt5.png' width='324px' height='226px'><br/><br/>",
                    placement: "bottom",
                    scroll: false,
                    attachToBody: true
                },
                //Painel de paginação da grade
                {
                    type: "element",
                    heading: "Painel de paginação",
                    selector: ".ui-grid-pager-panel",
                    html: "A nova grade possui agora uma maneira mais eficiente de se organizar os registros: a paginação.<br/><br/>" +
                    "A paginação faz com que os registros fiquem organizados em páginas, permitindo que você foque naquilo que realmente importa.<br/><br/>" +
                    "Vamos conhecer o conteúdo do painel de paginação...",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Voltar para a primeira página",
                    selector: ".datagrid-btn-first-page",
                    html: "Através deste botão é possível voltar para a primeira página de registros, caso você não esteja nela.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true,
                    isEnabled: function () {
                        return datagridController.getTotalPages() > 1;
                    }
                },
                {
                    type: "element",
                    heading: "Voltar para a página anterior",
                    selector: ".datagrid-btn-previous-page",
                    html: "Através deste botão é possível voltar para a página anterior de registros, caso ela exista.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true,
                    isEnabled: function () {
                        return datagridController.getTotalPages() > 1;
                    }
                },
                {
                    type: "element",
                    heading: "Indicador de páginas",
                    selector: ".datagrid-pagination-indicator",
                    html: "Mostra qual é a página atual e a quantidade total de páginas.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true
                },
                {
                    type: "element",
                    heading: "Próxima página de registros",
                    selector: ".datagrid-btn-next-page",
                    html: "Através deste botão é possível avançar para a próxima página de registros, caso ela exista.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true,
                    isEnabled: function () {
                        return datagridController.getTotalPages() > 1;
                    }
                },
                {
                    type: "element",
                    heading: "Última página de registros",
                    selector: ".datagrid-btn-last-page",
                    html: "Através deste botão é possível avançar para a última página de registros, caso você não esteja nela.",
                    placement: "top",
                    scroll: true,
                    attachToBody: true,
                    isEnabled: function () {
                        return datagridController.getTotalPages() > 1;
                    }
                }
            ];
        }

    }]);
/**
 * @ngdoc directive
 * @name snk.form.directive:sk-datagrid-custom-column
 * @restrict E
 * @scope
 * @description
    Esse componente deve ser utilizado apenas como filho do sk-datagrid ou sk-dynaform.
    <br>
 *
 * @param {String} [sk-field-name] Essa propriedade define o nome do campo que ele representa no dataset para
 * buscar descrição ou até mesmo os metadados do campo a ser renderizado (dataset informado no datagrid).
 * 
 * @param {String} [sk-description] Expressão envolvida em {{ }} para ser avaliada e retornar uma descrição
 * para a coluna, também poderá ser informado a string direta.
 * 
 * @param {boolean} [sk-visible] Define se a coluna será exibida ou não exibido.
 * 
 * @param {boolean} [sk-enabled] Define se a coluna será editável ou não.

 * @param {function} [sk-cell-formatter] Função que recebe os parâmetros(col,value,record) e deve retornar o valor da célula.
 */
angular
    .module('snk.components.datagrid')
    .directive('skDatagridCustomColumn', ['i18n', '$parse', 'StringUtils', function(i18n, $parse, StringUtils) {
        return {
            restrict: 'E',
            require: ['^?skDatagrid', '^?skDynaform'],
            compile: function(tElement, tAttr) {
                return function(scope, element, attr, controllers) {
                    var alignments = ['right', 'left', 'center'];
                    var gridController = controllers[0];
                    var dynaformController = controllers[1];

                    if (!gridController && !dynaformController) {
                        throw Error('SkDatagridCustomColumn deve ser filha de um Datagrid ou Dynaform.');
                    }

                    var fieldNames = attr.skFieldName;
                    var description = attr.skDescription;

                    if (!fieldNames) {
                        throw Error('sk-datagrid-custom-column deve possuir sk-field-name');
                    }

                    fieldNames = fieldNames.split(",");

                    fieldNames.forEach(fieldName => {

                        var columnMD = {
                            fieldName: fieldName,
                            description: i18n(description),
                            visible: true,
                            liveCheck: attr.skLiveCheck == 'true'
                        };

                        if (attr.skVisible) {
                            scope.$watch(attr.skVisible, function(newValue) {
                                if (columnMD.visible != newValue) {
                                    columnMD.visible = newValue;

                                    if (getGridController()) {
                                        var column = getGridController().getColumnByName(fieldName);
                                        if (column) {
                                            column.setVisible(newValue);
                                        }
                                    }
                                }
                            });
                        }

                        if (attr.skEnabled) {
                            columnMD.enabled = true;

                            scope.$watch(attr.skEnabled, function(newValue) {
                                if (columnMD.enabled != newValue) {
                                    columnMD.enabled = newValue;

                                    if (getGridController()) {
                                        var column = getGridController().getColumnByName(fieldName);

                                        if (column) {
                                            column.setEnabled(newValue);
                                        }
                                    }
                                }
                            });
                        }

                        if (attr.skTextAlign && alignments.indexOf(attr.skTextAlign) > -1) {
                            columnMD.textAlign = attr.skTextAlign;
                        }

                        if (attr.skCellFormatter) {
                            columnMD.cellFormatter = $parse(attr.skCellFormatter)(scope);
                        }

                        if (attr.skCheckBoxFormatter) {
                            columnMD.checkBoxFormatter = $parse(attr.skCheckBoxFormatter)(scope);
                        }

                        if (attr.skCustomSort) {
                            columnMD.customSort = $parse(attr.skCustomSort)(scope);
                        }

                        if (attr.width) {
                            columnMD.width = attr.width;
                        }

                        attr.$observe('skDescription', function(newValue) {
                            if (description != newValue) {
                                columnMD.description = description = i18n(newValue);

                                if (getGridController()) {
                                    var column = getGridController().getColumnByName(fieldName);
                                    if (column) {
                                        column.setDescription(description);
                                    }
                                }
                            }
                        });

                        function getGridController() {
                            if (gridController) {
                                return gridController;
                            } else {
                                return dynaformController.getGridController();
                            }
                        }

                        if (gridController) {
                            gridController.addCustomColumnMD(columnMD);
                        } else {
                            var parentElemName = element.parent().prop('tagName').toLowerCase();

                            var entityName = dynaformController.getEntityName();

                            //Significa que estamos dentro de um bloco de personalização
                            // de entidade do dynaform
                            if (parentElemName != 'sk-dynaform') {
                                entityName = StringUtils.toCapitalCase(parentElemName.replace('dynaform-', ''), true).replace('-', '');;
                            }

                            dynaformController.addCustomColumnMD(columnMD, entityName);
                        }

                    });

                }
            }
        };
    }]);

angular
.module('snk.components.datagrid')
.directive('agGridMenu', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants',
            function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants) {
                var uiGridMenu = {
                    priority: 0,
                    scope: {
                        // shown: '&',
                        menuItems: '=',
                        autoHide: '=?'
                    },
                    require: '?^uiGrid',
                    templateUrl: 'ui-grid/uiGridMenu',
                    replace: false,
                    link: function ($scope, $elm, $attrs, uiGridCtrl) {
                        var self = this;
                        var menuMid;
                        var $animate;

                        // *** Show/Hide functions ******
                        self.showMenu = $scope.showMenu = function (event, args) {
                            if (!$scope.shown) {
                                $timeout(function () {
                                    var typeahead = document.getElementsByClassName('datagrid-menu-typeahead');
                                    if (typeahead.length > 0) {
                                        var input = typeahead[0].children[0];
                                        //AQUI!!!
                                        if (angular.isDefined(input) && angular.isDefined(input.focus) && $scope.$parent.grid.options.focusOnFindColumn) {
                                            $timeout(function () {
                                                $timeout(function() {
                                                    input.focus();
                                                    $timeout(function() {
                                                        input.select();
                                                    });
                                                });
                                            });
                                        }
                                    }
                                });

                                /*
                                 * In order to animate cleanly we remove the ng-if, wait a digest cycle, then
                                 * animate the removal of the ng-hide.  We can't successfully (so far as I can tell)
                                 * animate removal of the ng-if, as the menu items aren't there yet.  And we don't want
                                 * to rely on ng-show only, as that leaves elements in the DOM that are needlessly evaluated
                                 * on scroll events.
                                 *
                                 * Note when testing animation that animations don't run on the tutorials.  When debugging it looks
                                 * like they do, but angular has a default $animate provider that is just a stub, and that's what's
                                 * being called.  ALso don't be fooled by the fact that your browser has actually loaded the
                                 * angular-translate.js, it's not using it.  You need to test animations in an external application.
                                 */
                                $scope.shown = true;

                                $timeout(function () {
                                    $scope.shownMid = true;
                                    $scope.$emit('menu-shown');
                                });
                            } else if (!$scope.shownMid) {
                                // we're probably doing a hide then show, so we don't need to wait for ng-if
                                $scope.shownMid = true;
                                $scope.$emit('menu-shown');
                            }

                            var docEventType = 'click';
                            if (args && args.originalEvent && args.originalEvent.type && args.originalEvent.type === 'touchstart') {
                                docEventType = args.originalEvent.type;
                            }

                            // Turn off an existing document click handler
                            angular.element(document).off('click touchstart', applyHideMenu);

                            // Turn on the document click handler, but in a timeout so it doesn't apply to THIS click if there is one
                            $timeout(function () {
                                angular.element(document).on(docEventType, applyHideMenu);
                            });
                        };


                        self.hideMenu = $scope.hideMenu = function (event, args) {
                            if(uiGridCtrl && uiGridCtrl.grid.options.lockGridMenu) {
                                return;
                            }

                            if ($scope.shown) {
                                /*
                                 * In order to animate cleanly we animate the addition of ng-hide, then use a $timeout to
                                 * set the ng-if (shown = false) after the animation runs.  In theory we can cascade off the
                                 * callback on the addClass method, but it is very unreliable with unit tests for no discernable reason.
                                 *
                                 * The user may have clicked on the menu again whilst
                                 * we're waiting, so we check that the mid isn't shown before applying the ng-if.
                                 */
                                $scope.shownMid = false;
                                $timeout(function () {
                                    if (!$scope.shownMid) {
                                        $scope.shown = false;
                                        $scope.$emit('menu-hidden');
                                    }
                                }, 200), false;
                            }

                            angular.element(document).off('click touchstart', applyHideMenu);
                        };

                        $scope.$on('hide-menu', function (event, args) {
                            $scope.hideMenu(event, args);
                        });

                        $scope.$on('show-menu', function (event, args) {
                            $scope.showMenu(event, args);
                        });


                        // *** Auto hide when click elsewhere ******
                        var applyHideMenu = function () {
                            if ($scope.shown) {
                                if (!$scope.$root.$$phase) {
                                    $scope.$apply(function () {
                                        $scope.hideMenu();
                                    });
                                }
                                else {
                                    $scope.hideMenu();
                                }
                            }
                        };

                        if (typeof($scope.autoHide) === 'undefined' || $scope.autoHide === undefined) {
                            $scope.autoHide = true;
                        }

                        if ($scope.autoHide) {
                            angular.element($window).on('resize', applyHideMenu);
                        }

                        $scope.$on('$destroy', function () {
                            angular.element(document).off('click touchstart', applyHideMenu);
                        });


                        $scope.$on('$destroy', function () {
                            angular.element($window).off('resize', applyHideMenu);
                        });

                        if (uiGridCtrl) {
                            $scope.$on('$destroy', uiGridCtrl.grid.api.core.on.scrollBegin($scope, applyHideMenu));
                        }

                        $scope.$on('$destroy', $scope.$on(uiGridConstants.events.ITEM_DRAGGING, applyHideMenu));
                    },


                    controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
                        var self = this;
                    }]
                };

                return uiGridMenu;
            }])

        .directive('agGridMenuItem', ['gridUtil', '$compile', 'i18nService', function (gridUtil, $compile, i18nService) {
            var uiGridMenuItem = {
                priority: 0,
                scope: {
                    name: '=',
                    active: '=',
                    action: '=',
                    icon: '=',
                    shown: '=',
                    context: '=',
                    templateUrl: '=',
                    leaveOpen: '='
                },
                require: ['?^uiGrid', '^uiGridMenu'],
                templateUrl: 'ui-grid/uiGridMenuItem',
                replace: true,
                compile: function ($elm, $attrs) {
                    return {
                        pre: function ($scope, $elm, $attrs, controllers) {
                            var uiGridCtrl = controllers[0],
                                uiGridMenuCtrl = controllers[1];

                            if ($scope.templateUrl) {
                                gridUtil.getTemplate($scope.templateUrl)
                                    .then(function (contents) {
                                        var template = angular.element(contents);

                                        var newElm = $compile(template)($scope);
                                        $elm.replaceWith(newElm);
                                    });
                            }
                        },
                        post: function ($scope, $elm, $attrs, controllers) {
                            var uiGridCtrl = controllers[0],
                                uiGridMenuCtrl = controllers[1];

                            // TODO(c0bra): validate that shown and active are functions if they're defined. An exception is already thrown above this though
                            // if (typeof($scope.shown) !== 'undefined' && $scope.shown && typeof($scope.shown) !== 'function') {
                            //   throw new TypeError("$scope.shown is defined but not a function");
                            // }
                            if (typeof($scope.shown) === 'undefined' || $scope.shown === null) {
                                $scope.shown = function () {
                                    return true;
                                };
                            }

                            $scope.itemShown = function () {
                                var context = {};
                                if ($scope.context) {
                                    context.context = $scope.context;
                                }

                                if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
                                    context.grid = uiGridCtrl.grid;
                                }

                                return $scope.shown.call(context);
                            };

                            $scope.itemAction = function ($event, title) {
                                // gridUtil.logDebug('itemAction');
                                //$event.stopPropagation();

                                if (typeof($scope.action) === 'function') {
                                    var context = {};

                                    if ($scope.context) {
                                        context.context = $scope.context;
                                    }

                                    // Add the grid to the function call context if the uiGrid controller is present
                                    if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
                                        context.grid = uiGridCtrl.grid;
                                    }

                                    $scope.action.call(context, $event, title);

                                    if (!$scope.leaveOpen) {
                                        $scope.$emit('hide-menu');
                                    }
                                }
                            };

                            $scope.i18n = i18nService.get();
                        }
                    };
                }
            };

            return uiGridMenuItem;
        }]);
angular
    .module('snk.components.datagrid')
    .directive('skDatagridPesquisaEditor', ['uiGridConstants', 'uiGridEditConstants','$timeout',
function (uiGridConstants, uiGridEditConstants, $timeout) {
    return {
        require: ['?^uiGrid', '?^uiGridRenderContainer'],
        compile: function () {
            return {
                pre: function ($scope, $elm, $attrs) {

                },
                post: function ($scope, $elm, $attrs, controllers) {

                    var uiGridCtrl, renderContainerCtrl;
                    if (controllers[0]) { uiGridCtrl = controllers[0]; }
                    if (controllers[1]) { renderContainerCtrl = controllers[1]; }

                    if(!uiGridCtrl && !renderContainerCtrl) {
                        return;
                    }

                    //set focus at start of edit
                    $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
                        if(angular.isDefined($elm[0].focus)) {
                            //$elm[0].focus();
                        }
                        if(angular.isDefined($elm[0].select)) {
                            //$elm[0].select();
                        }
                    });

                    $scope.stopEdit = function (evt) {
                        $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
                    };

                    $elm.on('keydown', function (evt) {
                        switch (evt.keyCode) {
                            case uiGridConstants.keymap.ESC:
                                evt.stopPropagation();
                                $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                                break;
                            case uiGridConstants.keymap.ENTER:
                                // Enter (Leave Field). Controlled by CellNavService
                                /*Nothing to do here.*/
                                break;
                            case uiGridConstants.keymap.TAB:
                                var parentElement = $elm[0].parentElement;
                                var firstSKElementName = undefined;
                                while(parentElement) {
                                    if(!firstSKElementName && parentElement.tagName.indexOf('SK') > -1) {
                                        firstSKElementName = parentElement.tagName;
                                    }
                                    if(parentElement.tagName.indexOf('SK-DATE-TIME-INPUT') > -1) {
                                        if(firstSKElementName == 'SK-DATE-INPUT' && !evt.shiftKey) {
                                            evt.stopPropagation();
                                            break;
                                        }
                                        else if(firstSKElementName == 'SK-TIME-INPUT' && evt.shiftKey) {
                                            evt.stopPropagation();
                                            break;
                                        }
                                    }
                                    else if(parentElement.tagName.indexOf('SK-PHONE-INPUT') > -1) {
                                        if($elm[0] == parentElement.children[0] && !evt.shiftKey) {
                                            evt.stopPropagation();
                                            break;
                                        }
                                        else if($elm[0] == parentElement.children[1]) {
                                            evt.stopPropagation();
                                            break;
                                        }
                                        else if($elm[0] == parentElement.children[2] && evt.shiftKey) {
                                            evt.stopPropagation();
                                            break;
                                        }
                                    }
                                    parentElement = parentElement.parentElement;
                                }

                                break;
                            case uiGridConstants.keymap.LEFT:
                                evt.stopPropagation();
                                break;
                            case uiGridConstants.keymap.RIGHT:
                                evt.stopPropagation();
                                break;
                            case uiGridConstants.keymap.UP:
                                $scope.stopEdit(evt);
                                break;
                            case uiGridConstants.keymap.DOWN:
                                $scope.stopEdit(evt);
                                break;
                            default:
                                // Pass the keydown event off to the cellNav service. In this case, it ever exists
                                if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
                                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
                                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
                                        $scope.stopEdit(evt);
                                    }
                                }
                        }

                        return true;
                    });
                }
            };
        }
    };
}]);
angular
    .module('snk.components.datagrid')
    .controller('FilterModalController', FilterModalController);

function FilterModalController($scope, $timeout, $popupInstance, column, dataset, DateUtils, gridController, i18n, StringUtils, data, ObjectUtils) {
    var self = this;

    $scope.column = column;
    
    $scope.checkAll = i18n('DataGrid.checkAll');
    $scope.uncheckAll = i18n('DataGrid.uncheckAll');
    $scope.labelPesquisar = i18n('Geral.buttonPesquisar');
    $scope.labelFiltraDataVazia = i18n('DataGrid.filtraDataVazia');
    $scope.labelDefinaPeriodo = i18n('DataGrid.definaPeriodo');
    $scope.selectList = selectList;
    $scope.listNameAll = "ALL";
    $scope.listNameFiltered = "FILTERED";
    $scope.allSelected = true;
    $scope.onCheckAllClick = onCheckAllClick;
    $scope.keys = {};
    $scope.periodo = {
        dtIni: null,
        dtFim: null
    }
    
    /* As chaves são definidas no carregamento do componente */
    var initialData = {};
    var initialDataWasLoaded = false;
    var textoVazio = i18n('DataGrid.empty');

    const VER_FILTRADOS = "Filtrados [$QTD]"
    

    $scope.verFiltradosLbl = VER_FILTRADOS.replace("$QTD", "0");
    $scope.selectedList = $scope.listNameAll;

    loadKeys();
    function loadKeys() {
        let keys = {};

        for (let key in column.distinctData) {
            if (column.distinctData.hasOwnProperty(key)) {
                keys[key] = column.distinctData[key];
            }
        }

        if (!initialDataWasLoaded) {
            initialData = { ...keys };
            initialDataWasLoaded = true;
        }

        var type = (column.colDef.type || column.colDef.skType);

        if (type == 'date' || type == 'datetime') {
            $scope.keys[$scope.listNameAll] = sortData(keys, column.mapDescriptions, column.sortFn);

            $scope.utilizaFiltroPeriodo = data.enableFilterDatePeriod;
            if ($scope.utilizaFiltroPeriodo) {
                if (column.periodo) {
                    $scope.periodo = angular.copy(column.periodo);
                }
                column.includeDtEmpty = column.includeDtEmptyActive == true;
            }
        } else {
            $scope.keys[$scope.listNameAll] = sortData(keys, undefined, column.sortFn);
        }

        updateStateLists();
    }

    $popupInstance.result.then(function () {
        clearFilter();
    }, function (reason) {
        if (reason == 'no') {
            apply();
        }
        else if (reason == 'cancel' || reason == 'close') {
            cancel();
        }
    });

    function sortData(obj, mapDescriptions, sortFn) {
        var temp_array = [];

        for (var key in obj) {
            if (mapDescriptions && mapDescriptions[key]) {
                temp_array.push(mapDescriptions[key]);
            } else {
                temp_array.push(key);
            }
        }

        // Ordenação definida pelo componente que chamou o filtermodal
        if (sortFn) {
            temp_array.sort(sortFn);
        } else {
            temp_array.sort();
        }

        if(mapDescriptions) {
            var final_array = [];
            for (var i = 0, length = temp_array.length; i < length; i++) {
                for (var o in mapDescriptions) {
                    if (mapDescriptions[o] == temp_array[i]) {
                        final_array.push(o);
                        break;
                    }
                }
            }
            final_array = [textoVazio].concat(final_array);
            return final_array;
        } else {
            return temp_array;
        }
    };

    function apply() {

        if ($scope.utilizaFiltroPeriodo) {
            if (filterDataPeriodEmpty()) {// Nao marcar nada e o mesmo que não selecionar nada
                $scope.checkAllData(false);
            } else {
                const _dtIni = $scope.periodo.dtIni;
                const _dtFim = $scope.periodo.dtFim;

                avaliadaPeriodo(_dtIni, _dtFim, column.includeDtEmpty, column);
            }

            column.periodo = $scope.periodo;
            column.includeDtEmptyActive = column.includeDtEmpty;
        }

        if(!dataWasChanged()) return;
        
        var columnIndex = -1;
        var originalCols = gridController.getOriginalColumnDefs();
        
        for(var i = 0; i < originalCols.length; i++){
            if((column.colDef.field || column.colDef.colId) === originalCols[i].field){
                columnIndex = i;
                break;
            }
        }

        if(isAllDataUnselected()) { //Seta uma função de filtro que sempre retorna false            
            column.isFiltering = true;
            gridController.setFilterByColumn(columnIndex, '', column.colId, column);
            dataset.setFilterFunction(function(value) { return false; }, true);
            dataset.filterRecords();            
        } else {
            applyFilterFunction(column, columnIndex);

            dataset.filterRecords();

            column.isFiltering = true;
            column.refreshView = true;
        }
    };

    function avaliadaPeriodo(_dtIni, _dtFim, includeDtEmpty, col) {
        for (let term in col.distinctData) {
            let _acceptLine = false;
            let _dtColumn = term == textoVazio ? null : DateUtils.stringToDate(term);
            
            if (_dtColumn == null) {
                _acceptLine = includeDtEmpty;
            } else {
                if (_dtIni && !_dtFim && DateUtils.compareOnlyDate(_dtColumn, _dtIni) >= 0) {
                    _acceptLine = true;
                } else if (!_dtIni && _dtFim && DateUtils.compareOnlyDate(_dtColumn, _dtFim) <= 0) {
                    _acceptLine = true;
                } else if (DateUtils.compareOnlyDate(_dtColumn, _dtIni) >= 0 && DateUtils.compareOnlyDate(_dtColumn, _dtFim) <= 0) {
                    _acceptLine = true;
                }
            }

            col.distinctData[term] = _acceptLine;
        }
    }

    function applyFilterFunction(col, columnIndex) {
        var searchTerm = '';
        for (var term in col.distinctData) {
            if (col.distinctData[term]) {
                if (searchTerm !== '') {
                    searchTerm += '|';
                }

                if (term == textoVazio) {
                    searchTerm += '^' + 'undefined' + '$';
                    searchTerm += '|^' + '' + '$';
                }
                else {
                    var type = (col.colDef.type || col.colDef.skType);
                    if (col.colDef.skFieldType == 'LP' || col.colDef.skFieldType == 'L') {
                        searchTerm += term;
                    } else if (type != 'date' && type != 'datetime' && (!col.colDef.skOptions || col.colDef.skOptions.length < 1)
                        && col.mapDescriptions && !angular.isFunction(col.colDef.valueFormatter)) {
                        searchTerm += `^${StringUtils.replaceCharacterSpecial(StringUtils.replaceAccentuatedChars(col.mapDescriptions[term]))}$`;
                    }
                    else {
                        searchTerm += `^${StringUtils.replaceCharacterSpecial(StringUtils.replaceAccentuatedChars(term))}$`;
                    }
                }
            }
        }

        gridController.setFilterByColumn(columnIndex, searchTerm, col.colId, col);

        dataset.setFilterFunction(gridController.getFilterFunction('i', col), true);
    }

    function cancel() {
        $popupInstance.dismiss('cancel');
        column.distinctData = initialData;
        column.refreshView = true;
    };

    $scope.itemClickHandler = function (data) {
        column.distinctData[data] = !column.distinctData[data];
        updateStateLists();
    };

    $scope.checkAllData = function (flag) {
        for (var data in column.distinctData) {
            column.distinctData[data] = flag;
        }
        loadKeys();
        updateStateLists();
    };

    function clearFilter() {
        var originalCols = gridController.getOriginalColumnDefs();
        var columnIndex, columnId;
        for(var i = 0; i < originalCols.length; i++){
            if((column.colDef.field || column.colDef.colId) === originalCols[i].field){
                columnIndex = i;
                columnId = originalCols[i].field;
                break;
            }
        }

        if (data.enableFilterDatePeriod) {
            // Precisamos reavaliar as colunas de periodo pois podem ser necessario reaplicar o filtro
            ObjectUtils.forEachInObject(gridController.getFilterInfoColumn(), (fieldName, col) => {
                if (columnId != fieldName) {
                    var type = (col.colDef.type || col.colDef.skType);
                    if (type == 'date' || type == 'datetime') {
                        col.distinctData = {};

                        dataset.getOriginalRecordsAsObject(fieldName).forEach(f => {
                            if(angular.isUndefined(f[fieldName])){
                                col.distinctData[textoVazio] = true;
                            }else{
                                col.distinctData[col.colDef.valueFormatter({ value: f[fieldName], data: f[fieldName], column: col })] = true;
                            }
                        });

                        avaliadaPeriodo(col.periodo.dtIni, col.periodo.dtFim, col.includeDtEmpty, col);

                        applyFilterFunction(col, i);
                    }
                }
            });
        }

        gridController.removeFilterByColumn(columnIndex, columnId);

        dataset.removeFilter();
        dataset.setFilterFunction(gridController.getFilterFunction('i', column), true);

        dataset.filterRecords();

        $popupInstance.dismiss();
        column.isFiltering = false;
        column.distinctData = undefined;
        
        if ($scope.utilizaFiltroPeriodo) {
            column.includeDtEmptyActive = false;
            column.includeDtEmpty = false;
            column.periodo = undefined;
        }
    };

    function isAllDataSelected() {
        for (var data in column.distinctData) {
            if (!column.distinctData[data]) {
                return false;
            }
        }
        return true;
    };

    function isAllDataUnselected() {
        for (var data in column.distinctData) {
            if (column.distinctData[data]) {
                return false;
            }
        }
        return true;
    };

    function dataWasChanged(){
        for (let data in column.distinctData) {
            if (column.distinctData[data] != initialData[data]) {
                return true;
            }
        }
        return false;
    }

    function filterDataPeriodEmpty() {
        return !$scope.periodo.dtIni && !$scope.periodo.dtFim && !column.includeDtEmpty;
    }

    function selectList(newList){
        $scope.selectedList = newList;
    }

    function onCheckAllClick(){
        $timeout(() => $scope.checkAllData($scope.allSelected))
    }

    function filteredFilterFn(key){
        return !column.distinctData[key];
    }

    function updateStateLists(){
        //Atualizando lista de filtrados
        $scope.keys[$scope.listNameFiltered] = $scope.keys[$scope.listNameAll].filter(filteredFilterFn);
        //Atualizando label de filtrados
        let filteredLength = $scope.keys[$scope.listNameFiltered].length;
        $scope.verFiltradosLbl = VER_FILTRADOS.replace("$QTD", filteredLength == $scope.keys[$scope.listNameAll].length ? "Todos" : filteredLength);
        //Atualizando checkbox de selecionar todos
        $scope.allSelected = $scope.keys[$scope.listNameFiltered].length == 0;
    }
 }

angular
    .module('snk.components.datagrid')
    .directive('skFilterModal', skFilterModal);

function skFilterModal() {
    return {
        restrict: 'E',
        templateUrl: 'components/datagrid/filtermodal/filtermodal.tpl.html'
    }
}
/**
 * @ngdoc interface
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Interface utilizada para interceptar os metadados da grade.
 */
function IDatagridInterceptor() {}

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#interceptColumnMetadata
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Função chamada para interceptar os metadados da grade durante sua construção.
 * @param {object} fieldMetadata Metadados de uma determinada coluna da grade.
 * @param {object} dataset Instância do dataset vinculada à grade.
 */
IDatagridInterceptor.prototype.interceptColumnMetadata = function (fieldMetadata, dataset) {

};

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#interceptItemEditor
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Função chamada para interceptar os metadados de uma coluna antes de uma edição iniciar.
 * @param {object} configObj Objeto de configuração para a célula em edição.
 * @param {object} dataset Instância do dataset vinculada à grade.
 */
IDatagridInterceptor.prototype.interceptItemEditor = function (configObj, dataset) {
};

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#sortMetadata
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Função chamada no momento oportuno para se alterar a ordem das colunas no momento da construção da grade.
 * @param {array} fieldsMD Lista de fields metadata a serem ordenados.
 * @param {object} dataset Instância do dataset vinculada à grade.
 */
IDatagridInterceptor.prototype.sortMetadata = function (fieldsMD, dataset) {
    return 'unordered';
};

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#acceptColumnField
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Função chamada para verificar se cada coluna deverá ser apresentada na grade.
 * @param {object} fieldMD Metadados do campo.
 * @param {object} dataset Instância do dataset vinculada à grade.
 */
IDatagridInterceptor.prototype.acceptColumnField = function (fieldMD, dataset) {
    return true;
};

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#getCellColors
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Permite definir a cor do texto e/ou a cor do fundo de cada célula da grade. <br>
 *  Deve retornar a string da cor ou nome de uma classe ou um objeto com as seguintes propriedades:<br/>
 *  <ul>
 *      <li>textColor</li>
 *      <li>bgColor</li>
 *  </ul><br/>
 * Consulte {@link snk.core.theme.service:ThemeColors ThemeColors} para verificar as cores e os métodos disponíveis.
 * @param {object} row Linha da grade.
 * @param {object} col Coluna da grade.
 * @param {object} rowIndex Índice da linha da grade.
 * @param {object} colIndex Índice da coluna da grade.
 * @param {object} gridApi  Api da grade para possiveis alterações.
 * @param {object} params   Extra parametros para o interceptor.
 *                          {
 *                              dataset: dataset Dataset da grid
 *                          }
 * @example <pre>
 *     function getCellColors(row, col, rowIndex, colIndex) {
 *          return {
 *              textColor: 'warning',
 *              bgColor: 'brand'
 *          };
 *     }
 *
 *     function getCellColors(row, col, rowIndex, colIndex) {
 *          return {
 *              bgColor: 'brand'
 *          };
 *     }
 *
 *     function getCellColors(row, col, rowIndex, colIndex) {
 *          //Neste caso, apenas a COR DO TEXTO será alterada
 *          return 'brand';
 *     }
 *
 *     function getCellColors(row, col, rowIndex, colIndex) {
 *          //Neste caso, apenas a COR DO TEXTO será alterada
 *          return '#D3D3D3';
 *     }
 * </pre>
 */
IDatagridInterceptor.prototype.getCellColors = function (row, col, rowIndex, colIndex, gridApi, params) {
};

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#getCellValue
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Permite alterar o conteúdo de uma célula
 * @param {object} row Objeto com os campos e seus respectivos valores.
 * @param {String} colName Nome a coluna que está sendo avaliada naquele momento.
 */
IDatagridInterceptor.prototype.getCellValue = function (row, colName) {
    return 'no-cell-value';
};



/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#interceptItemEditor
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description Função chamada para interceptar a renderização de uma celula.
 * @param {object} cell Objeto com as informações da celula que esta sendo renderizada.
 * @param {object} data Objeto com o valor que esta na celula.
 * @param {object} eGridCell Html que esta sendo renderizado por padrão na celula.
 * @param {array} data um array contendo 2 atributos, datasetItem:Array (contendo a linha do data set) e gridItem:Object contendo a linha da grade.
 * Deve retornar um objeto com dois atributos um chamado 'element' html com o conteudo a ser apresentado na celula e outro 
 * chamado 'align(center|flex-start|flex-end)', informando o alinhamento do item. 
 */
IDatagridInterceptor.prototype.interceptCellRenderer = function (cell, value, eGridCell, data) {
};


/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#onEditionEnd
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description quando a edição de uma celula é finalizada
 * @param {string} colId Nome da coluna que está sendo alterada.
 * @param {object} dataObject Objeto da linha atual, representa o registro da grid.
 * @param {object} datasetArray Array da linha atual do dataset, representa o registro do dataset.
 * @param {number} id ID da linha atual da grid.
 */
IDatagridInterceptor.prototype.onEditionEnd = function (colId ,ataObject, datasetArray, id) {
};


/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDatagridInterceptor#onEditionEnd
 * @methodOf snk.components.datagrid.interfaces:IDatagridInterceptor
 * @description quando a edição de uma celula é inicializada
 * @param {string} colId Nome da coluna que está sendo alterada.
 * @param {object} dataObject Objeto da linha atual, representa o registro da grid.
 * @param {object} datasetArray Array da linha atual do dataset, representa o registro do dataset.
 * @param {number} id ID da linha atual da grid.
 */
IDatagridInterceptor.prototype.onEditionStart = function (colId ,ataObject, datasetArray, id) {
};




(function () {
    angular.module('ui.grid').config(['$provide', function($provide) {
        $provide.decorator('i18nService', ['$delegate', function($delegate) {
            $delegate.add('pt_BR', {
                aggregate: {
                    label: 'itens'
                },
                general: {
                    apply: 'Aplicar',
                    cancel: "Cancelar",
                    clear: 'Limpar',
                    toFilter: 'Filtrar',
                    filterForColumn: 'Filtro para a coluna',
                    checkAll: 'Marcar todos',
                    uncheckAll: 'Desmarcar todos',
                    empty: '(Vazio)',
                    comfortableMode: 'Modo Confortável',
                    compactMode: 'Modo Compacto',
                    findColumn: 'Encontrar Coluna',
                    removeColumnSearchMarkup: 'Remover Marcação de Busca',
                    lblPagina: 'Página',
                    lblNenhumaPagina: 'Nenhuma Página',
                    columnOptionsText: 'Opções da Coluna',
                    datagridOptionsText: 'Opções da Grade',
                    columnFilterActiveText: 'Existem filtros ativos para esta coluna',
                    lblExpandCell: 'Expandir'
                },
                groupPanel: {
                    description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
                },
                search: {
                    placeholder: 'Procurar...',
                    showingItems: 'Mostrando:',
                    selectedItems: 'Selecionados:',
                    totalItems: 'Total de Itens:',
                    size: 'Tamanho da Página:',
                    first: 'Primeira Página',
                    next: 'Próxima Página',
                    previous: 'Página Anterior',
                    last: 'Última Página',
                    filter: 'Filtrar',
                    searchText: 'Pesquisar',
                    clearSearch: 'Limpar Pesquisa',
                    clearAllSearch: 'Limpar Filtros/Pesquisas',
                    records: 'Registros:',
                    lblSelectedRecords: 'registros selecionados',
                    lblOf: 'de',
                    aguardeCarregando: 'Aguarde, carregando...',
                    checkUncheckAllText: 'Marcar/Desmarcar Todos'
                },
                menu: {
                    text: 'Selecione as colunas:',
                    columnMenu: 'Opções'
                },
                sort: {
                    ascending: 'Ordenar Ascendente',
                    descending: 'Ordenar Descendente',
                    remove: 'Remover Ordenação',
                    headerCaption: 'Clique para Ordenar'
                },
                column: {
                    hide: 'Esconder coluna'
                },
                aggregation: {
                    count: 'total de linhas: ',
                    sum: 'total: ',
                    avg: 'med: ',
                    min: 'min: ',
                    max: 'max: '
                },
                pinning: {
                    pinLeft: 'Fixar Coluna',
                    pinRight: 'Fixar Direita',
                    unpin: 'Desafixar Coluna'
                },
                gridMenu: {
                    columns: 'Colunas:',
                    importerTitle: 'Importar arquivo',
                    exporterAllAsCsv: 'Exportar todos os dados como csv',
                    exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
                    exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
                    exporterAllAsPdf: 'Exportar todos os dados como pdf',
                    exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
                    exporterSelectedAsPdf: 'Exportar dados selecionados como pdf'
                },
                importer: {
                    noHeaders: 'Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?',
                    noObjects: 'Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?',
                    invalidCsv: 'Arquivo não pode ser processado. É um CSV válido?',
                    invalidJson: 'Arquivo não pode ser processado. É um Json válido?',
                    jsonNotArray: 'Arquivo json importado tem que conter um array. Abortando.'
                },
                pagination: {
                    sizes: 'itens por página',
                    totalItems: 'itens',
                    firstPageText: 'Primeira Página',
                    previousPageText: 'Página Anterior',
                    nextPageText: 'Próxima Página',
                    lastPageText: 'Última Página',
                },
                grouping: {
                    group: 'Agrupar',
                    ungroup: 'Desagrupar',
                    aggregate_count: 'Agr: Contar',
                    aggregate_sum: 'Agr: Soma',
                    aggregate_max: 'Agr: Max',
                    aggregate_min: 'Agr: Min',
                    aggregate_avg: 'Agr: Med',
                    aggregate_remove: 'Agr: Remover'
                }
            });

            $delegate.add('en_US', {
                aggregate: {
                    label: 'items'
                },
                groupPanel: {
                    description: 'Drag a column header here and drop it to group by that column.'
                },
                general: {
                    apply: 'Apply',
                    cancel: "Cancel",
                    clear: 'Clear',
                    toFilter: 'Filter',
                    filterForColumn: 'Filter for column',
                    checkAll: 'Check all',
                    uncheckAll: 'Uncheck all',
                    empty: '(Empty)',
                    comfortableMode: 'Comfortable Mode',
                    compactMode: 'Compact Mode',
                    findColumn: 'Find Column',
                    removeColumnSearchMarkup: 'Remove Search Markup',
                    lblPagina: 'Page',
                    lblNenhumaPagina: 'No Pages',
                    columnOptionsText: 'Column Options',
                    datagridOptionsText: 'Grid Options',
                    columnFilterActiveText: 'Filters are actives this column',
                    lblExpandCell: 'Expandir'
                },
                search: {
                    placeholder: 'Search...',
                    showingItems: 'Showing Items:',
                    selectedItems: 'Selected:',
                    totalItems: 'Total Items:',
                    size: 'Page Size:',
                    first: 'First Page',
                    next: 'Next Page',
                    previous: 'Previous Page',
                    last: 'Last Page',
                    filter: 'Filter',
                    searchText: 'Search',
                    clearSearch: 'Clear Search',
                    clearAllSearch: 'Clear Filters/Search',
                    records: 'Records:',
                    lblSelectedRecords: 'selected records',
                    lblOf: 'of',
                    aguardeCarregando: 'Wait, loading...',
                    checkUncheckAllText: 'Check/Uncheck All'
                },
                menu: {
                    text: 'Choose Columns:',
                    columnMenu: 'Options'
                },
                sort: {
                    ascending: 'Sort Ascending',
                    descending: 'Sort Descending',
                    remove: 'Remove Sort',
                    headerCaption: 'Click to Sort'
                },
                column: {
                    hide: 'Hide Column'
                },
                aggregation: {
                    count: 'total rows: ',
                    sum: 'total: ',
                    avg: 'avg: ',
                    min: 'min: ',
                    max: 'max: '
                },
                pinning: {
                    pinLeft: 'Pin Column',
                    pinRight: 'Pin Right',
                    unpin: 'Unpin Column'
                },
                gridMenu: {
                    columns: 'Columns:',
                    importerTitle: 'Import file',
                    exporterAllAsCsv: 'Export all data as csv',
                    exporterVisibleAsCsv: 'Export visible data as csv',
                    exporterSelectedAsCsv: 'Export selected data as csv',
                    exporterAllAsPdf: 'Export all data as pdf',
                    exporterVisibleAsPdf: 'Export visible data as pdf',
                    exporterSelectedAsPdf: 'Export selected data as pdf'
                },
                importer: {
                    noHeaders: 'Column names were unable to be derived, does the file have a header?',
                    noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
                    invalidCsv: 'File was unable to be processed, is it valid CSV?',
                    invalidJson: 'File was unable to be processed, is it valid Json?',
                    jsonNotArray: 'Imported json file must contain an array, aborting.'
                },
                pagination: {
                    sizes: 'items per page',
                    totalItems: 'items',
                    firstPageText: 'First Page',
                    previousPageText: 'Previous Page',
                    nextPageText: 'Next Page',
                    lastPageText: 'Last Page',
                },
                grouping: {
                    group: 'Group',
                    ungroup: 'Ungroup',
                    aggregate_count: 'Agg: Count',
                    aggregate_sum: 'Agg: Sum',
                    aggregate_max: 'Agg: Max',
                    aggregate_min: 'Agg: Min',
                    aggregate_avg: 'Agg: Avg',
                    aggregate_remove: 'Agg: Remove'
                }
            });
            return $delegate;
        }]);
    }]);
})();
angular
    .module('snk.components.dataset.dataimporter')
    .service('DataImporter', ['$q', 'i18n', 'ServiceProxy', 'StringUtils', 'SkApplication', 'ObjectUtils', 'MessageUtils', 'SanPopup', 'DynaformConstants', 'AngularUtil', 'ArrayUtils',
        function ($q, i18n, ServiceProxy, StringUtils, SkApplication, ObjectUtils, MessageUtils, SanPopup, DynaformConstants, AngularUtil, ArrayUtils) {
            var self = this;

            var _defaultOpenOptions = {
               title: i18n('Geral.lblImportadorDados'),
               okBtnLabel: i18n('Geral.confirmar'),
               cancelBtnLabel: i18n('Geral.lblFechar'),
               height: 700
            };

            self.open = open;

            function open(dataset, options) {
                if (angular.isUndefined(options.serviceName)) {
                    throw Error(i18n('Geral.msgNenhumServicoImportDados'));
                }

                var fieldsFilter = ArrayUtils.toArray(options.fieldsFilter);

                if (fieldsFilter.length == 0) {
                    throw Error(i18n('Geral.msgNenhumCampoBuscaImportDados'));
                }

                var customFieldsFilter = ArrayUtils.toArray(options.customFieldsFilter);

                var popupOptions = angular.copy(_defaultOpenOptions);
                angular.extend(popupOptions, options);

                var promise = $q.defer();

                var popupInstance = SanPopup.open({
                    templateUrl: 'components/dataset/dataimporter/dataimporter.tpl.html',
                    title: popupOptions.title,
                    size: 'lg',
                    height: popupOptions.height,
                    okBtnLabel: popupOptions.okBtnLabel,
                    cancelBtnLabel: popupOptions.cancelBtnLabel,
                    controller: 'SkDataImporterPopupController',
                    controllerAs: 'ctrl',
                    grayBG: true,
                    resolve: {
                        properties: {
                            dataSet: dataset,
                            serviceName: options.serviceName,
                            loadFieldsParam: options.loadFieldsParam,
                            fieldsFilter: fieldsFilter,
                            useDatasetFields: options.useDatasetFields,
                            datasetFieldsFilter: options.datasetFieldsFilter,
                            insertionMode: options.insertionMode,
                            fieldsFilterInterceptor: options.fieldsFilterInterceptor,
                            customFieldsFilter: customFieldsFilter,
                            msgInfomacaoWS: popupOptions.title,
                            afterInitializeFilters: options.afterInitializeFilters,
                            interceptFilterFormField: options.interceptFilterFormField,
                            interceptImportFormField: options.interceptImportFormField,
                            beforeConfirm: options.beforeConfirm
                        }
                    }
                });

                popupInstance.result.then(function (result) {                	
                    promise.resolve();
                }, function (reason) {
                    promise.reject();
                });

                return promise.promise;
            }

        }]);

angular
    .module('snk.components.dataset.dataimporter')
    .controller('SkDataImporterPopupController', ['$scope', '$q', 'properties', 'ServiceProxy', '$window', 'FormService', 'MessageUtils', 'i18n', '$timeout', 'StringUtils', 'ObjectUtils', 'SkApplication', 'KeyboardEvents', 'UserAgentUtils','GridConfig', '$popupInstance', 'Criteria', 'MetadataProvider', 'AngularUtil', 'ArrayUtils',
        function ($scope, $q, properties, ServiceProxy, $window, FormService, MessageUtils, i18n, $timeout, StringUtils, ObjectUtils, SkApplication, KeyboardEvents, UserAgentUtils, GridConfig, $popupInstance, Criteria, MetadataProvider, AngularUtil, ArrayUtils) {
            var self = this;

            // Interceptors
            ObjectUtils.implements(self, IDataSetObserver);

            // Variáveis privadas
            var _serviceName = properties.serviceName;
            var _loadFieldsParam = properties.loadFieldsParam;
            var _fieldsFilter = properties.fieldsFilter;
            var _dsBase = properties.dataSet;
            var _useDatasetFields = properties.useDatasetFields;
            var _datasetFieldsFilter = properties.datasetFieldsFilter;
            var _insertionMode = properties.insertionMode;
            var _fieldsFilterInterceptor = properties.fieldsFilterInterceptor;
            var _afterInitializeFilters = properties.afterInitializeFilters;
            var _interceptFilterFormField = properties.interceptFilterFormField;
            var _interceptImportFormField = properties.interceptImportFormField;
            var _beforeConfirm = properties.beforeConfirm;
            var _alerta;
            // Variáveis dispoiveis no controller
            self.msgOfDivergences;
            self.selectedTabIndex = 0;
            self.insertionMode = _insertionMode;
            self.customFieldsFilter = properties.customFieldsFilter;

            // Funções dispoiveis no controller
            self.onDatasetCreated = onDatasetCreated;
            self.refreshHandler = refreshHandler;
            self.importData = importData;
            
            if ((StringUtils.emptyAsUndefined(properties.msgInfomacaoWS) != undefined) &&
            (properties.msgInfomacaoWS.indexOf('SEFAZ') > -1)) {
                self.msgInfomacaoWS = i18n('Geral.msgImportSEFAZ');
            } else {
                self.msgInfomacaoWS = i18n('Geral.msgImportReceitaWS');
            }

            // Implementações da interface IDataSetObserver
            self.dataModified = dataModified;

            // Implementações da interface IFormInterceptor
            self.formFilterInterceptor = new IFormInterceptor();
            self.formFilterInterceptor.interceptField = _interceptFilterFormField ? _interceptFilterFormField : interceptField;
            self.formFilterInterceptor.acceptField = function(fieldMD) {
                return ArrayUtils.isIn(_fieldsFilter, fieldMD.name);
            };

            self.formImportInterceptor = new IFormInterceptor();
            self.formImportInterceptor.interceptField = _interceptImportFormField ? _interceptImportFormField : interceptField;
            self.formImportInterceptor.acceptField = function(fieldMD) {
                return !ArrayUtils.isIn(self.dsImport.getPrimaryKeys(), fieldMD.name);
            };

            // Função ao confirmar o popup
            $scope.$success = confirm;

            function importData() {
                self.dsImport.refresh();
            }

            function interceptField(fieldMD) {
                fieldMD.required = false;
            };

            function confirm() {
            	           	
                var fieldsMetadata = self.dsImport.getFieldsMetadata();
                var hasDataImport = false;

                var whenInInsertion;
                var cancelInsertion = false;

                if (
                    (_insertionMode && !_dsBase.isInsertionMode()) ||
                    !_dsBase.getCurrentRow()
                ) {
                    whenInInsertion = _dsBase.goToInsertionMode();
                    cancelInsertion = true;
                }

                $q.when(whenInInsertion)
                    .then(function() {
                        if (angular.isFunction(_beforeConfirm)) {
                            _beforeConfirm(_dsBase, self.dsImport);
                        }
                        fieldsMetadata.forEach(function(fieldMetadata) {
                            var value = self.dsImport.getFieldValue(fieldMetadata.name);

                            if (!StringUtils.isEmpty(value)) {
                                hasDataImport = true;

                                _dsBase.setFieldValue(fieldMetadata.name, value);
                            }
                        });

                        if (hasDataImport) {
                            _alerta=[];
                            var msgAlerta = _alerta[self.dsImport.getFieldValueAsString("IDENTINSCESTAD")];
                            if (angular.isDefined(msgAlerta)) {
                                MessageUtils.showAlert(msgAlerta);
                            }
                            $popupInstance.success();
                        } else {
                            if (_insertionMode && cancelInsertion) {
                                _dsBase.cancelEdition();
                            }

                            MessageUtils.showAlert(i18n('Geral.msgNaoExistemDadosImport'));
                        }
                    });
            }

            function onDatasetCreated(dataset) {
                if (dataset.getEntityName() == "DataSetImport") {
                    self.dsImport = dataset;

                    self.dsImport.addObserver(self);

                    self.dsImport.addRefreshedListener(function() {
                        if (self.dsImport.getCurrentRow()){
                            checkDifferences();
                        }
                    });
                    
                    self.dsImport.addLineChangeListener(function(indice) {
                        checkDifferences(true);
                        if(indice > -1 &&  self.dsImport.size() > 1){
                            self.msgVariosRegistros = i18n('Geral.msgVariosRegistros',[indice + 1, self.dsImport.size()]);
                        }
                    });

                    if (_useDatasetFields) {
                        var entityName = _dsBase.getEntityName();
                        var dataSetFields = [];

                        _dsBase.getFieldsMetadata().forEach(function(fieldMD) {
                            if (!fieldMD.isDescriptionField && !_dsBase.isPrimaryKey(fieldMD.name) && (!_datasetFieldsFilter || _datasetFieldsFilter(fieldMD.name))) {
                                dataSetFields.push(fieldMD.name);
                            }
                        });

                        afterLoadDatasetInfo(entityName, dataSetFields.join(','));
                    } else {
                        ServiceProxy.callService(_serviceName, _loadFieldsParam ? _loadFieldsParam : {})
                            .then(function (result) {
                                var entityName = result.responseBody.entityName;
                                var dataSetFields = result.responseBody.dataSetFields;

                                afterLoadDatasetInfo(entityName, dataSetFields);
                            });
                    }
                    
                    
                } else if (dataset.getEntityName() == "DataSetFilter") {
                    self.dsFilter = dataset;
                    self.dsFilter.setEntityName(_dsBase.getEntityName());

                   self.dsFilter.addFieldsRequestInfo({
                        pattern: _fieldsFilter.join(',')
                    });

                    self.dsFilter.initializeDataSet().then(initializeFilters);
                }
            }

            function afterLoadDatasetInfo(entityName, dataSetFields) {
                self.dsImport.setEntityName(entityName);

                self.dsImport.addFieldsRequestInfo({
                    pattern: dataSetFields
                });

                self.dsImport.init()
                    .then(function(){
                        if (_insertionMode) {
                            self.dsImport.refresh();
                        }
                    });
            }

            function refreshHandler(request) {
            	return $q(function(resolve, reject) {
                    ServiceProxy.callService(_serviceName, {
                        "fieldsFilter": getFieldsValue(self.dsFilter),
                        "insertionMode": _insertionMode,
                        "loadRecordsRequest": request
                        }).then(function (result) {
                            if (!StringUtils.isEmpty(result.responseBody.erro)) {
                                MessageUtils.showError(
                                    result.responseBody.erro
                                );
                                reject();
                            } else {
                                _alerta = result.responseBody.alerta;
                                if (!angular.isObject(_alerta) && !StringUtils.isEmpty(_alerta)) {
                                    MessageUtils.showAlert(_alerta);
                                }
                                else if(angular.isDefined(_alerta) && StringUtils.isNotEmpty(_alerta.alertMessage)){
                                    MessageUtils.showAlert(_alerta.alertMessage);
                                }
                                resolve(result.responseBody.result);
                            }
                        }, reject);  
            	});
            }

            function dataModified(fieldName) {
                checkDifferences();
            }

            function getFieldsValue(ds) {
                var fields = [];

                _fieldsFilter.forEach(function(fieldName) {
                    var fieldValue = ds.getFieldValue(fieldName);

                    if (!angular.isUndefined(fieldValue)) {
                        var field = {};
                        field[fieldName] = fieldValue;
                        fields.push(field);
                    }
                });

                if (_fieldsFilterInterceptor) {
                    _fieldsFilterInterceptor(fields);
                }

                return fields;
            }

            function initializeFilters() {
                self.dsFilter.goToInsertionMode()
                    .then(function(){
                        var fieldsMetadata = self.dsFilter.getFieldsMetadata();
                        var hasValue = false;
                        
                        fieldsMetadata.forEach(function(fieldMetadata) {
                            var value = _dsBase.getFieldValue(fieldMetadata.name);

                            if (!StringUtils.isEmpty(value)) {
                                self.dsFilter.setFieldValue(fieldMetadata.name, value);
                                hasValue = true;
                            }
                        });
                        
                        if (angular.isFunction(_afterInitializeFilters)) {
                            _afterInitializeFilters(_dsBase, self.dsFilter, self.dsImport);
                        } else {
                            if (hasValue) {
                                self.dsImport.refresh();                            	
                            }
                        }
                    });
            }

            function checkDifferences(ignoreTabIndex) {
                var fieldsMetadata = ArrayUtils.toArray(self.dsImport.getFieldsMetadata());                
                var msgOfDivergences = undefined;

                fieldsMetadata.forEach(function(fieldMetadata) {
                    if (fieldMetadata.isDescriptionField) {
                        return;
                    }

                    var valueOrig = _dsBase.getFieldValueAsString(fieldMetadata.name);
                    var valueImport = self.dsImport.getFieldValueAsString(fieldMetadata.name);

                    if (!StringUtils.isEmpty(valueImport) && !StringUtils.isEmpty(valueOrig)) {
                        if (fieldMetadata.userType == 'Phone') {
                            valueOrig = valueOrig.replace(/\s/g, '');
                        }

                        if (valueOrig != valueImport) {
                            if (angular.isUndefined(msgOfDivergences)) {
                                msgOfDivergences = i18n('Geral.msgDadosInformadosCadastro')+":\n";
                            }

                            if (msgOfDivergences.length > 0) {
                                msgOfDivergences = msgOfDivergences+"\n";
                            }

                            if (fieldMetadata.fk && fieldMetadata.fk.descriptionFieldName) {
                                var descriptionValue = _dsBase.getFieldValueAsString(fieldMetadata.fk.descriptionFieldName);

                                if (!StringUtils.isEmpty(valueOrig) && angular.isDefined(descriptionValue)) {
                                    valueOrig += ' - ' + descriptionValue;
                                }
                            }

                            if (StringUtils.isEmpty(valueOrig)) {
                                valueOrig = i18n('Geral.lblDadoNaoInformado');
                            }

                            msgOfDivergences = msgOfDivergences + fieldMetadata.description +": "+ valueOrig;
                        }
                    }

                    self.msgOfDivergences = msgOfDivergences;

                    if (!ignoreTabIndex && angular.isUndefined(self.msgOfDivergences)) {
                        self.selectedTabIndex = 0;
                    }
                });
            }
        }]);

angular
    .module('snk.components.dataset')
    .constant("DatasetContants", {
        "RECORD_IS_NOT_DIRTY": "dataset.constants.RECORD_IS_NOT_DIRTY",
        "DEFAULT_USER_FIELDS": "$USERFIELDS"
    })
    .constant("DatasetEvents", {
        "ON_METADATA_UPDATED": "dataset.event.ON_METADATA_UPDATED",
        "BACKGROUND_LOAD": "dataset.event.BACKGROUND_LOAD",
        "REFRESH_CELLS": 'dataset.event.REFRESH_CELLS',
        "REFRESH_REASON_SORT": "dataset.event.refresh.sort",
        "REFRESH_REASON_RESET": "dataset.event.refresh.reset",
        "REFRESH_REASON_FILTER": "dataset.event.refresh.filter",
        "REFRESH_REASON_RECORDS_ADDED": "dataset.event.refresh.records.added",
        "LINE_CHANGE_BY_RECORD_REMOVED": "dataset.event.line.change.by.record.removed",
        "RECORD_CHANGED_REASON_INSERT": "dataset.event.record.changed.insert",
        "BACKGROUND_LOAD_END": "dataset.event.background.load.end",
        "BACKGROUND_LOAD_START": "dataset.event.background.load.start",
        "ADD_RECORDS_AS_OBJECT_END": "dataset.event.add.records.as.objects",
        "ADD_RECORDS_AS_ARRAY_END": "dataset.event.add.records.as.array"
    })
    .constant("DatasetObserverEvents", {
        "EVENT_RECORD_EDITED": "dataset.observer.EVENT_RECORD_EDITED",
        "EVENT_CURRENT_RECORD_CHANGED": "dataset.observer.EVENT_CURRENT_RECORD_CHANGED",
        "EVENT_DATA_SET_REFRESHED": "dataset.observer.EVENT_DATA_SET_REFRESHED",
        "EVENT_DATA_SET_CLOSED": "dataset.observer.EVENT_DATA_SET_CLOSED",
        "EVENT_DATA_SAVED": "dataset.observer.EVENT_DATA_SAVED",
        "EVENT_INSERT_MODE": "dataset.observer.EVENT_INSERT_MODE",
        "EVENT_RECORD_REMOVED": "dataset.observer.EVENT_RECORD_REMOVED",
        "EVENT_EDITION_CANCELED": "dataset.observer.EVENT_EDITION_CANCELED",
        "EVENT_EDITION_STARTED": "dataset.observer.EVENT_EDITION_STARTED",
        "EVENT_SAVE_AVOID": "dataset.observer.EVENT_SAVE_AVOID",
        "EVENT_SELECTION_CHANGED": "dataset.observer.EVENT_SELECTION_CHANGED",
        "EVENT_EDIT_MODE": "dataset.observer.EVENT_EDIT_MODE",
        "EVENT_DATA_SET_UPLOADING": "dataset.observer.EVENT_DATA_SET_UPLOADING",
        "EVENT_DATA_SET_CLEARED": "dataset.observer.EVENT_DATA_SET_CLEARED",
        "EVENT_CURRENT_RECORD_REFRESHED": "dataset.observer.EVENT_CURRENT_RECORD_REFRESHED",
        "EVENT_ROW_METADATA_CHANGED": "dataset.observer.EVENT_ROW_METADATA_CHANGED",
        "EVENT_INSERTION_CANCELED": "dataset.observer.EVENT_INSERTION_CANCELED",
        "EVENT_RELOAD_FIELDS": "dataset.observer.RELOAD_FIELDS",
        "EVENT_FINISHED_EDITION": "dataset.observer.EVENT_FINISHED_EDITION"
    });
angular
    .module('snk.components.dataset')
    .controller('SkDatasetController', SkDatasetController);

SkDatasetController.$inject = ['$scope', '$attrs', '$translate', '$log', '$q', 'SkI18nService', 'MetadataProvider', 'DatasetEvents', 'DatasetContants', 'DatasetObserverEvents', 'ObjectUtils', 'StringUtils', 'ServiceProxy', 'Base64', 'ArrayUtils', 'DateUtils', 'DateUtilsConstants', 'DatasetUtils', 'SkApplication', 'KeyboardEvents', 'MessageUtils', 'AngularUtil', 'MGEAuthorizationConstants', '$timeout', 'SkPesquisaService', 'i18n', 'NumberUtils'];

function SkDatasetController($scope, $attrs, $translate, $log, $q, SkI18nService, MetadataProvider, DatasetEvents, DatasetContants, DatasetObserverEvents, ObjectUtils, StringUtils, ServiceProxy, Base64, ArrayUtils, DateUtils, DateUtilsConstants, DatasetUtils, SkApplication, KeyboardEvents, MessageUtils, AngularUtil, MGEAuthorizationConstants, $timeout, SkPesquisaService, i18n, NumberUtils) {
    var self = this;

    ObjectUtils.extend(self, EventBus);
    ObjectUtils.implements(self, DataSource);

    var msgControleAcesso = $translate.instant('Dataset.msgtitleControleAcesso');

    var _rowUniqueID = 0;

    var _rowsByUniqueID = [];

    var _baseEntity;

    var _fieldsByEntity = {};
    var _fieldIndexByName = {};
    var _fields = [];
    var _hierarchyMask;
    var PARENT_FIELD_SUFIX = 'PAI';
    var ROOT_KEY_VALUE = -9999;
    var _initDatasetLazyLoad = false;
    var _parentPropertyName;
    var _alternativeParentPropertyName;
    var _localPropertyName;
    var _localPathHierarchy;	
    var _ignoreExportName = false;
    let _rowMetadataCache = {};
    let _ignoreRMDOnInsert = false;
    var _timeoutFindPk;
    var _findRowPk;
    var _nonHierarchyRecords = [];
    var fieldsToAddExpression =[];

    var _standAlone = $attrs.hasOwnProperty('skStandalone');

    var _fieldBinders = {};
    var _modifiedBinders = {};
    var _programmaticalModifiedValues = {};

    var _datasetObservers = [];
    var _recordValidators = [];

    var _isMetadataAvailable;
    var _pendingActions = [];
    var _parentDataSet;
    var _currentIndex = -1;
    var _metadataFieldsRequestInfo = [];
    var _userFieldsMetadata = [];
    var _rootFieldsRequestInfo;
    var _pageRefreshing = false;
    var _conditionalAutoSave = true;
    var _cancelPopUpAutoSave = false;
    var _ignoreAutoSave = false;
    var _ignoreTxPropertiesOnChangeRow = false;

    var _processingAutosave = false;

    var _parallelLoader = true;

    var _copyingRecord = false;
    var _cleanRecord;
    var _recordCloned;
    var _recordIsDirty = false;
    var _editionStarted = false;
    var _indexBeforeInsertionMode = -1;

    var _canInsert = true;
    var _canEdit = true;
    var _canCopy = true;
    var _msgCopy = null;
    var _canRemove = true;
    var _msgRemove = null;

    var _transientRecord = null;
    var _isInsertionMode = false;

    var _isUploading = false;

    var _allowPKModification = false;

    var _selectedRecords;
    var _multiEditMode = false;

    var _clearSelectionAfterRefresh;

    var _primaryKeyFields = [];

    var _criteriaProviders = [];

    var _records = new ArrayList();

    var _txProperties;

    var _includePresentationFields;

    var _showBlobFields;

    var _datasetID = angular.isDefined($scope.uniqueId) ? $scope.uniqueId : StringUtils.nextUid();

    var _entityPresentationFieldName = $attrs.skPresentationField;

    var _avoidRefreshDetails;
    var _listenToModifications = true;

    var _lastPromiseForLoadRecords;

    var _beforePostAction = [];
    var _beforeCopyAction;
    var _beforeDeleteAction;
    var _beforeCancelAction;

    var _afterCopyAction = [];

    var _detailDataSets = [];
    var _foreingKeyFields = [];
    var _listenToParentRefreshRequest = true;

    var _preventAddShortcut = false;

    var _eventsWithFieldEvaluator = [DatasetObserverEvents.EVENT_RECORD_EDITED];
    
    var _fieldValueEvaluators = [];

    var _userFieldMDInterceptor;

    var _autoInsertValues;

    var debouncedErrorChangingPK = AngularUtil.debounce(showErrorChangingPK, 200, $scope, true);
    var debouncedShowAlertFormAltNaoSalvas = AngularUtil.debounce(showAlertFormAltNaoSalvas, 200, $scope, true);
    
    var _customEntityDescription;

    var _removeRowConfirmInterceptor;

    var _fieldInterceptors = {};

    var _fieldsPersonalizedValidation = {};

    var _selectedRecordsByUniqueId = {};

    var _fieldsDescriptionStandAlone = [];

    var _transientFieldsName = [];

    var _defaultOptionsToSave = {
        preventSort : false,
        preventFilter: false
    }
	var _isRequiredMembroPK = true;
	var _filterFunctionsToRemoveOnRefresh = [];

    var _lockChangeRowAutoSave = false;
    var _observersEnabled = true;

    var _exceptFieldsByEntity = {};
    var _entityForceUserFields = {};
    let _enableInsertionModeGrid = false;
    var _tryJoinedFields = $scope.tryJoinedFields === undefined ? true : $scope.tryJoinedFields;

    var _beforeLoadRowMetadata = [];
    var _pkHistorica = false;

    var _enableDeleteFromNavigator = false;

    var _keepMetadataWhileConverting = false;

    const LOAD_ROW_METADATA  = 'loadRowMetadata';

    const _evtObserversIgnored = {};

    self.init = init;
    self.initAndRefresh = initAndRefresh;
    self.initializeDataSet = initializeDataSet;
    var lastModifiedField="";

    //Dataset actions
    self.refresh = refresh;
    self.refreshCurrentRow = refreshCurrentRow;
    self.gotoRow = gotoRow;
    self.save = save;
    self.removeCurrentRow = removeCurrentRow;
    self.copyCurrentRow = copyCurrentRow;
    self.removeSort = removeSort;
    self.removeFilter = removeFilter;
    self.sortRecords = sortRecords;
    self.filterRecords = filterRecords;
    self.autoSaveFromMaster = autoSaveFromMaster;
    self.autoSave = autoSave;
    self.resetRecords = resetRecords;
    self.addRecords = addRecords;
    self.addRecordsAsObjects = addRecordsAsObjects;
    self.makeFieldRequired = makeFieldRequired;
    self.makeFieldNonRequired = makeFieldNonRequired;
    self.addTXProperty = addTXProperty;
    self.removeTXProperty = removeTXProperty;
    self.saveCriteria = saveCriteria;
    self.beforePostAction = beforePostAction;
    self.beforeCopyAction = beforeCopyAction;
    self.beforeRefreshAction = beforeRefreshAction;
    self.clearDataSet = clearDataSet;
    self.readAuthorizarionData = readAuthorizarionData;
    self.readAuthorizationData = readAuthorizarionData; //Expondo com o nome correto, pois nasceu errado.
    self.reduce = reduce;
    self.makeFieldPersonalizedValidator = makeFieldPersonalizedValidator;
    self.buildStandAloneRecord = buildStandAloneRecord;
    self.unconditionalRemoveCurrentRecord = unconditionalRemoveCurrentRecord;
    self.addTransientField = addTransientField;
    self.lockChangeRowAutoSave = lockChangeRowAutoSave;
    self.updateRecord = updateRecord;
    self.changeRow = changeRow;
    self.loadRecordsByLevel = loadRecordsByLevel;
    self.setInitDatasetLazyLoad = setInitDatasetLazyLoad;
    self.isInitDataSetLazyLoad = isInitDataSetLazyLoad;
    self.isAlternativeParentKey = isAlternativeParentKey;
    self.isLazyLoad = isLazyLoad;
    self.setLazyLoad = setLazyLoad;
    self.onFocusout = onFocusout;
    self.addBeforeLoadRowMetadata = addBeforeLoadRowMetadata;
    self.setIgnoreRMDOnInsert = setIgnoreRMDOnInsert;
    self.getIgnoreRMDOnInsert = getIgnoreRMDOnInsert;
    self.setUseDefaultRowsLimit = setUseDefaultRowsLimit;
    self.clearEdition = clearEdition;
    self.updateRMD = updateRMD;
    self.addFieldsHierarchyExpression = addFieldsHierarchyExpression;
    self.hierarchyCriteriaFunction;
    self.refreshBinders = refreshBinders;
    
    //Dataset crud
    self.cancelEdition = cancelEdition;
    self.askAndCancelEdition = askAndCancelEdition;
    self.notifyEditionStart = notifyEditionStart;
    self.notifyFinishedEdition = notifyFinishedEdition;
    self.notifyUploadState = notifyUploadState;
    self.setModified = setModified;
    self.goToInsertionMode = goToInsertionMode;
    self.beginEdition = beginEdition;
    self.cancelPagination = cancelPagination;
    self.isSelected = isSelected;
    self.addSelectedRecordByUniqueId = addSelectedRecordByUniqueId;
    self.addSelectedRecordsByUniqueIds = addSelectedRecordsByUniqueIds;
    self.getRecordByUniqueId = getRecordByUniqueId;
    self.isFieldVisible = isFieldVisible;

    //Dataset setters
    self.setEntityName = setEntityName;
    self.setFilterCriteria = setFilterCriteria;
    self.setSelectedRecords = setSelectedRecords;
    self.setSelectedRecordsByPks = setSelectedRecordsByPks;
    self.setParentDataSet = setParentDataSet;
    self.addChildDataSet = addChildDataSet;
    self.setFieldValue = setFieldValue;
    self.setFieldValueAsString = setFieldValueAsString;
    self.setFieldValueAsJson = setFieldValueAsJson;
    self.setSortFunction = setSortFunction;
    self.setObjectSortFunction = setObjectSortFunction;
    self.sortWithObjectFunction = sortWithObjectFunction;
    self.setFilterFunction = setFilterFunction;
    self.addFilterFunction = addFilterFunction;
    self.addObjectFilterFunction = addObjectFilterFunction;
    self.setParallelLoader = setParallelLoader;
    self.setAllowPkModification = setAllowPkModification;
    self.setIgnoreTxPropertiesOnChangeRow = setIgnoreTxPropertiesOnChangeRow;
    self.setUserFieldMDInterceptor = setUserFieldMDInterceptor;
    self.setOrderByExpression = setOrderByExpression;
    self.setConditionalAutoSave = setConditionalAutoSave;
    self.cancelPopUpAutoSave = cancelPopUpAutoSave;
    self.setSaveHandler = setSaveHandler;
    self.setRefreshHandler = setRefreshHandler;
    self.setRemoveHandler = setRemoveHandler;
    self.selectAllRecords = selectAllRecords;
    self.unselectAll = unselectAll;
    self.setIgnoredMethodListener = setIgnoredMethodListener;
    self.setIgnoreExportName = setIgnoreExportName;

    self.setRemoveRowConfirmInterceptor = setRemoveRowConfirmInterceptor;
    self.setSelectFirstOnRefresh = setSelectFirstOnRefresh;
    self.setSelectSelectedRow = setSelectSelectedRow;
    self.setEnableDeleteFromNavigator = setEnableDeleteFromNavigator;
    self.setCurrentIndex = setCurrentIndex;

    //Auth
    self.setCanInsert = setCanInsert;
    self.setCanEdit = setCanEdit;
    self.setCanCopy = setCanCopy;
    self.setCanRemove = setCanRemove;

    self.canInset = canInsert;
    self.canEdit = canEdit;
    self.canCopy = canCopy;
    self.canRemove = canRemove;

    self.setCrudListener = setCrudListener;
    self.setWorkerClass = setWorkerClass;
    self.afterCopyAction = afterCopyAction;
    self.addAfterCopyAction = addAfterCopyAction;
    self.beforeDeleteAction = beforeDeleteAction;
    self.beforeCancelAction = beforeCancelAction;

    //Dataset getters
    self.getPrimaryKeys = getPrimaryKeys;
    self.getPrimaryKeyValues = getPrimaryKeyValues;
    self.getPrimaryKeyObject = getPrimaryKeyObject;
    self.getSelectedRecords = getSelectedRecords;
    self.getSelectedRecordsAsObjects = getSelectedRecordsAsObjects;
    self.getSelectedRecordsPks = getSelectedRecordsPks;
    self.getEntityPresentationFieldName = getEntityPresentationFieldName;
    self.getEntityPresentationFieldIndex = getEntityPresentationFieldIndex;
    self.getFieldIndexByName = getFieldIndexByName;
    self.getFieldsMetadata = getFieldsMetadata;
    self.getFieldMetadata = getFieldMetadata;
    self.getFieldMetadataByIndex = getFieldMetadataByIndex;
    self.getUserFieldMetadata = getUserFieldMetadata;
    self.getUserFieldsMetadata = getUserFieldsMetadata;
    self.getEntityName = getEntityName;
    self.getCurrentIndex = getCurrentIndex;
    self.getCurrentRow = getCurrentRow;
    self.getCurrentRowAsObject = getCurrentRowAsObject;
    self.getRowAsObject = getRowAsObject;
    self.getAllowPkModification = getAllowPkModification;
    self.getModifyingFields = getModifyingFields;
    self.getFieldNames = getFieldNames;
    self.getStandAloneFieldsMD = getStandAloneFieldsMD;
    self.getDataSetElement = getDataSetElement;
    self.getParallelLoader = getParallelLoader;
    self.getLastModifiedField=getLastModifiedField;
    self.setPkHistorica=setPkHistorica;

    self.getRecords = getRecords;
    self.getRecordsAsObjects = getRecordsAsObjects;
    self.getRecordsList = getRecordsList;
    self.refreshRecordsList = refreshRecordsList;
    self.refreshDataGridCells = refreshDataGridCells;
    self.getRecord = getRecord;
    self.getRecordAsObject = getRecordAsObject;
    self.getRecordsAsObject = getRecordsAsObject;
    self.getRecordAndHierarchy = getRecordAndHierarchy;
    self.getOriginalRecords = getOriginalRecords;
    self.getOriginalRecordsAsObject = getOriginalRecordsAsObject;
    self.size = size;
    self.strToTypedData = strToTypedData;
    self.dataToString = DatasetUtils.dataToString;
    self.getFieldValue = getFieldValue;
    self.getFieldValueAsString = getFieldValueAsString;
    self.getFieldValueAsFormattedString = getFieldValueAsFormattedString;
    self.getFieldValueAsJson = getFieldValueAsJson;
    self.getFieldValueAsNumber = getFieldValueAsNumber;
    self.getFieldValueAsNumberOrZero = getFieldValueAsNumberOrZero;
    self.getFieldValueAsBoolean = getFieldValueAsBoolean;
    self.getListenToParentRefreshRequest = getListenToParentRefreshRequest;
    self.setListenToParentRefreshRequest = setListenToParentRefreshRequest;
    self.getRowMetadata = getRowMetadata;
    self.getParentDataset = getParentDataset;
    self.getParentEntityName = getParentEntityName;
    self.getForeignKeyFields = getForeignKeyFields;
    self.isFieldRequired = isFieldRequired;
    self.isFieldReadOnly = isFieldReadOnly;
    self.isPrimaryKey = isPrimaryKey;
    self.getEntityDescription = getEntityDescription;
    self.setEntityDescription = setEntityDescription;
    self.getIndexBeforeInsertionMode = getIndexBeforeInsertionMode;
    self.isView = isView;
    self.isFieldEmpty = isFieldEmpty;
    self.isFieldEmptyOrZero = isFieldEmptyOrZero;
    self.preventAddShortcut = preventAddShortcut;
    self.isStandAlone = isStandAlone;
    self.setStandAlone = setStandAlone;
    self.getRecordsObjectPaged = getRecordsObjectPaged;
    self.getIndexByUniqueId = getIndexByUniqueId;
    self.getDatasetId = getDatasetId;
    self.containsField = containsField;
    self.setEnableInsertionModeGrid = setEnableInsertionModeGrid;
    self.isEnableInsertionModeGrid = isEnableInsertionModeGrid;
    self.setKeepMetadataWhileConverting = setKeepMetadataWhileConverting;
    self.fieldIsHierarchyEntity = fieldIsHierarchyEntity;
    self.getEnableDeleteFromNavigator = getEnableDeleteFromNavigator;

    //Dataset configs
    self.addFieldsRequestInfo = addFieldsRequestInfo;
    self.addUserFieldMetadata = addUserFieldMetadata;
    self.addFieldBinder = addFieldBinder;
    self.hasFieldBinder = hasFieldBinder;
    self.removeFieldBinder = removeFieldBinder;
    self.addObserver = addObserver;
    self.removeObserver = removeObserver;
    self.addLineChangeListener = addLineChangeListener;
    self.addSelectionChangeListener = addSelectionChangeListener;
    self.addRefreshedListener = addRefreshedListener;
    self.addInsertionModeListener = addInsertionModeListener;
    self.addSaveAvoidListener = addSaveAvoidListener;
    self.addRecordRemovedListener = addRecordRemovedListener;
    self.addFinishedEditionListener = addFinishedEditionListener;
    self.addAllObserverEventsListener = addAllObserverEventsListener;
    self.addCriteriaProvider = addCriteriaProvider;
    self.getCriteriaProvider = getCriteriaProvider;
    self.removeCriteriaProvider = removeCriteriaProvider;
    self.removeCriteriaProviderIndex = removeCriteriaProviderIndex;
    self.addRecordValidator = addRecordValidator;
    self.addFieldValueEvaluator = addFieldValueEvaluator;
    self.addAutoInsertValue = addAutoInsertValue;
    self.addFieldModifiedListener = addFieldModifiedListener;
    self.addDataModifiedListener = addDataModifiedListener;
    self.addDataSavedListener = addDataSavedListener;
    self.addEditionCanceledListener = addEditionCanceledListener;
    self.addFieldMetadataInterceptor = addFieldMetadataInterceptor;
    self.findRecordIndexByPk = findRecordIndexByPk;
    self.findAllIndexByPk = findAllIndexByPk;
    self.setRequiredMembroPK = setRequiredMembroPK;
    self.silentSave = silentSave;
    self.getRowMetadataProperty = getRowMetadataProperty;
    self.addRowMetaDataListener = addRowMetaDataListener;
    self.autoInsert = autoInsert;
    self.addFunctionToQueue = addFunctionToQueue;

    //Observer
    self.notifyReloadFields = notifyReloadFields;

    //Dataset states
    self.isMultiRecordEditMode = isMultiRecordEditMode;
    self.isEditMode = isEditMode;
    self.isAnyEditMode = isAnyEditMode;
    self.isInsertionMode = isInsertionMode;
    self.isCopyingRecord = isCopyingRecord;
    self.isRecordDirty = isRecordDirty;
    self.isModifyingField = isModifyingField;
    self.isRefreshing = isRefreshing;
    self.isLoaded = isLoaded;
    self.isEmpty = isEmpty;
    self.allowDetailEdition = allowDetailEdition;
    self.whenMetadataLoaded = whenMetadataLoaded;
    self.existsFilterFunction = existsFilterFunction;
    self.existsSortFunction = existsSortFunction;
    self.getNextUniqueID = getNextUniqueID;
    self.unselectRowByUniqueId = unselectRowByUniqueId;
    self.getExceptFieldsByEntity = getExceptFieldsByEntity;
    self.getEntityForceUserFields = getEntityForceUserFields;
    self.setObserversEnabled = setObserversEnabled;
    self.validateRecord = validateRecord;
    self.hasObserverIgnored = hasObserverIgnored;
    self.isConditionalAutoSave = isConditionalAutoSave;
    self.isIgnoreAutoSave = isIgnoreAutoSave;
    self.setIgnoreAutoSave = setIgnoreAutoSave;

    //Dataset navigations
    self.first = first;
    self.previous = previous;
    self.next = next;
    self.last = last;
    self.hasPrevious = hasPrevious;
    self.hasNext = hasNext;

    self.locateByPk = locateByPk;
    
    self.cancelRefresh = false;
    
    self.hasPages = false;

    doInit();

    //Initialize
    function doInit() {
        AngularUtil.addSingleWatch($scope, 'parentDataset', setParentDataSet);

        var defaultKeyHandlers = {};
        defaultKeyHandlers[KeyboardEvents.ADD_KEY] = addKeyHandler;
        defaultKeyHandlers[KeyboardEvents.CANCEL_KEY] = cancelKeyHandler;
        defaultKeyHandlers[KeyboardEvents.DELETE_KEY] = deleteKeyHandler;
        defaultKeyHandlers[KeyboardEvents.SAVE_KEY] = saveKeyHandler;
        defaultKeyHandlers[KeyboardEvents.NEXT_KEY] = nextKeyHandler;
        defaultKeyHandlers[KeyboardEvents.PREVIOUS_KEY] = previousKeyHandler;
        defaultKeyHandlers[KeyboardEvents.REFRESH_DS] = refreshKeyHandler;

        ObjectUtils.forEachInObject(defaultKeyHandlers, function (key, handler) {
            if ($scope.restrictKeyHandlers) {
                if ($scope.restrictKeyHandlers.length > 0 && $scope.restrictKeyHandlers.indexOf(key) > -1) {
                    SkApplication.instance().addEventListener(key, handler);
                }
            } else {
                SkApplication.instance().addEventListener(key, handler);
            }
        });

        addRecordValidator(new RequiredRecordValidator(self, MessageUtils, $translate));

        $timeout(function () {
            $scope.datasetCreated({
                dataset: self
            });
        }, 0, false);
    }

    function addKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self) {
            if (!ds.preventAddShortcut() && !isView()) {
                ds.goToInsertionMode();
            }

            evt.preventDefault();
        }
    }

    function cancelKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self) {
            if (_recordIsDirty || isInsertionMode() || _multiEditMode) {
                ds.cancelEdition();
                evt.preventDefault();
            }
        }
    }

    function saveKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self) {
            ds.save();
            evt.preventDefault();
        }
    }

    function nextKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self) {
            ds.next();
            evt.preventDefault();
        }
    }

    function previousKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self) {
            ds.previous();
            evt.preventDefault();
        }
    }

    function refreshKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self) {
            ds.refresh();
            evt.preventDefault();
        }
    }

    function deleteKeyHandler(params, evt) {
        var ds = getUiDataSet(params.target);

        if (ds == self && ds.getEnableDeleteFromNavigator() && !isView() && canRemove())  {
            ds.removeCurrentRow();
            evt.preventDefault();
        }
    }

    function getUiDataSet(ui) {
        if (!ui) {
            return undefined;
        }

        var elementScope = angular.element(ui).scope();

        if (elementScope) {
            var ds = elementScope.dataset;

            if (ds && ds.__proto__.constructor == SkDatasetController) {
                return ds;
            }
        }

        if (ui.parentElement && !(ui.parentElement === document.body)) {
            return getUiDataSet(ui.parentElement);
        }

        return undefined;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setCanInsert
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @description
     *  Registra a possibilidade de inclusão de registros no dataset.
     */
    function setCanInsert(canInsert) {
        _canInsert = canInsert;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#canInsert
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna a possibilidade de inclusão de registros no dataset.
     */
    function canInsert() {
        return _canInsert;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setCanEdit
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Registra a possibilidade de edição de registros no dataset.
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function setCanEdit(canEdit) {
        _canEdit = canEdit;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#canEdit
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna a possibilidade de edição de registros no dataset.
     * @return {boolean} Se o dataset pode ser editado ou não.
     */
    function canEdit() {
        return _canEdit;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setCanCopy
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Registra a possibilidade de cópia de registros no dataset.
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function setCanCopy(canCopy, msgCopy=null) {
        _canCopy = canCopy;
        _msgCopy = msgCopy;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#canCopy
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna a possibilidade de cópia de registros no dataset.
     * @return {boolean} Se o dataset pode ser copiar linhas ou não.
     */
    function canCopy() {
        return _canCopy;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setCanCopy
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Registra a possibilidade de cópia de registros no dataset.
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function setCanRemove(canRemove, msgRemove=null) {
        _canRemove = canRemove;
        _msgRemove = msgRemove;
        
        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#canRemove
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna a possibilidade de remoção de registros no dataset.
     * @return {boolean} Se o dataset pode ser remover linhas ou não.
     */
    function canRemove() {
        return _canRemove;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setCrudListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Seta um CrudListener no Dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function setCrudListener(crudListener) {
        $scope.crudListener = crudListener;

        return self;
    }
    
    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setWorkerClass
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Opção para delegar a implementação do lado server para determinada classe específica
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function setWorkerClass(workerClass) {
    	$scope.workerClass = workerClass;
    	
    	return self;
    }

    /**
     * @ngdoc
     * @deprecated
     * @name snk.components.dataset.directive:sk-dataset#afterCopyAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Seta uma função a ser executada após realizar a cópia de um registro
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function afterCopyAction(afterCopyAction) {
        _afterCopyAction.push(afterCopyAction);

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addAfterCopyAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Seta uma função a ser executada após realizar a cópia de um registro
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function addAfterCopyAction(afterCopyAction) {
        _afterCopyAction.push(afterCopyAction);

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#first
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Envia a seleção para a primeira linha.
     * return {Promise} Promessa de troca de linha.
     * @example <pre>dataset.first();</pre>
     */
    function first() {
        return gotoRow(0);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#previous
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Envia a seleção para a linha anterior.
     * return {Promise} Promessa de troca de linha.
     * @example <pre>dataset.previous();</pre>
     */
    function previous() {
        return gotoRow(Math.max(0, getCurrentIndex() - 1));
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#next
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Envia a seleção para a próxima linha.
     * return {Promise} Promessa de troca de linha.
     * @example <pre>dataset.next();</pre>
     */
    function next() {
        return gotoRow(Math.min(size() - 1, getCurrentIndex() + 1));
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#last
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Envia a seleção para a última linha.
     * return {Promise} Promessa de troca de linha.
     * @example <pre>dataset.last();</pre>
     */
    function last() {
        return gotoRow(size() - 1);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#hasPrevious
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna se o dataset contem uma linha anterior a seleção corrente.
     * @example <pre>dataset.hasPrevious();</pre>
     * @returns {boolean} true caso exista uma linha anterior em relação a seleção, false caso contrário.
     */
    function hasPrevious() {
        return getCurrentIndex() > 0;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#hasNext
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna se o dataset contem uma linha após a seleção corrente.
     * @example <pre>dataset.hasNext();</pre>
     * @returns {boolean} true caso exista uma próxima linha em relação a seleção, false caso contrário.
     */
    function hasNext() {
        return getCurrentIndex() < size() - 1;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getEntityName
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna o nome da entidade do dataset.
     * @example <pre>dataset.getEntityName();</pre>
     * @returns {string} Retorna o nome da entidade do dataset.
     */
    function getEntityName() {
        return $scope.entityName;
    }

    function loadParentPropertyName() {
        var fieldsMetadata = getFieldsMetadata();

        ArrayUtils.forEach(fieldsMetadata, function (fieldMD) {
            if (hasPathHierarchy(fieldMD)) {
                _localPathHierarchy = fieldMD.name;
            }

            if (!_hierarchyMask) {
                if (hasMask(fieldMD)) {
                    resolveHierarchyMaskAndParent(fieldMD);
                } else if (isPrimaryKey(fieldMD.name)) {
                    resolveAlternativeParent(fieldMD);
                }
            }
        });
    }


    function hasPathHierarchy(fieldMD) {
        return !!ArrayUtils.find(fieldMD.properties, function (prop) {
            return prop.name === 'pathHierarquia';
        });
    }

    function hasMask(fieldMD) {
        return !!ArrayUtils.find(fieldMD.properties, function (prop) {
            return prop.name === 'mask';
        });
    }

    function resolveHierarchyMaskAndParent(fieldMD) {
        var maskProp = ArrayUtils.find(fieldMD.properties, function (prop) {
            return prop.name === 'mask';
        });

        _hierarchyMask = StringUtils.expandHierarchyMask(maskProp.value);
        _localPropertyName = fieldMD.name;

        var parentKeyNameProp = ArrayUtils.find(fieldMD.properties, function (prop) {
            return prop.name === 'parentKeyName';
        });

        _parentPropertyName = parentKeyNameProp && parentKeyNameProp.value
            ? parentKeyNameProp.value
            : fieldMD.name + PARENT_FIELD_SUFIX;
    }


    function resolveAlternativeParent(fieldMD) {
        _alternativeParentPropertyName = fieldMD.name + PARENT_FIELD_SUFIX;
        _localPropertyName = fieldMD.name;
    }


    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getEntityName
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Configura o nome da entidade do dataset.
     * @example <pre>dataset.setEntityName("Parceiro");</pre>
     */
    function setEntityName(entityName) {
        return $scope.entityName = entityName;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getEntityDescription
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna a descrição da entidade do dataset.
     * @example <pre>dataset.getEntityDescription();</pre>
     * @returns {string} Retorna a descrição da entidade do dataset.
     */
    function getEntityDescription(orEntityName) {
    	var description;
    	
    	if (_customEntityDescription){
    		description = _customEntityDescription;
    	}else{
    		description = _baseEntity && _baseEntity.description;
    		
    		if (!description) {
    			description = orEntityName ? getEntityName() : '...';
    		}
    	}

        return description;
    }
    
    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setEntityDescription
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Altera a descrição da entidade do dataset.
     * @example <pre>dataset.setEntityDescription();</pre>
     * @returns {string} Altera a descrição da entidade do dataset.
     */
    function setEntityDescription(entityDescription) {
    	_customEntityDescription = entityDescription;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getIndexBeforeInsertionMode
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna o índice anterior ao inicio edição
     * @example <pre>dataset.getIndexBeforeInsertionMode();</pre>
     * @returns {int} índice anterior ao inicio edição.
     */
    function getIndexBeforeInsertionMode() {
        return _indexBeforeInsertionMode;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isView
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Get para informação sobre a entidade vinculada ser uma view ou não.
     * @example <pre>dataset.isView();</pre>
     * @returns {boolean} True se for uma view, False caso contrário
     */
    function isView() {
        return _baseEntity && _baseEntity.isView;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setParentDataSet
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Adiciona um dataset como parent
     * @example <pre>dataset.setParentDataSet(parentDataSet);</pre>
     * @param {string} parentDataSet Dataset pai
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     */
    function setParentDataSet(parentDataSet) {
        if (_parentDataSet) {
            throw new Error('ParentDataset não é alteravel.');
        }

        _parentDataSet = parentDataSet;

        parentDataSet.addChildDataSet(self);

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getListenToParentRefreshRequest
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Captura o flag que determina se o dataset está ouvindo ou não um refresh do pai.
     * @example <pre>dataset.getListenToParentRefreshRequest();</pre>
     * @returns {boolean} Retorna true se ele escuta um refresh do pai, false do contrário.
     */
    function getListenToParentRefreshRequest() {
        return _listenToParentRefreshRequest;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setListenToParentRefreshRequest
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Altera o flag que determina se o dataset está ouvindo ou não um refresh do pai.
     * @example <pre>dataset.setListenToParentRefreshRequest(true);</pre>
     * @param {boolean} value Recebe true para escutar um refresh do pai, false do contrário.
    */
    function setListenToParentRefreshRequest(value) {
        _listenToParentRefreshRequest = value ? true : false;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addChildDataSet
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Adiciona um dataset como filho
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example <pre>dataset.addChildDataSet(childDataset);</pre>
     * @param {string} childDataset Dataset filho
     */
    function addChildDataSet(childDataset) {
        _detailDataSets.push(childDataset);

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldIndexByName
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna o índice da coluna de nome igual ao parâmetro.
     * @example <pre>dataset.getFieldIndexByName('CODPARC');</pre>
     * @param {string} fieldName Nome do campo
     * @returns {Number} Índice do campo.
     */
    function getFieldIndexByName(fieldName) {
        return Number(_fieldIndexByName[fieldName]);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getEntityPresentationFieldName
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna o nome do campo de apresentação da entidade do dataset.
     * @example <pre>dataset.getEntityPresentationFieldName();</pre>
     * @returns {string} Retorna o nome do campo de apresentação da entidade do dataset.
     */
    function getEntityPresentationFieldName() {
        return _entityPresentationFieldName;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getEntityPresentationFieldIndex
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna o índice do campo de apresentação da entidade do dataset.
     * @example <pre>dataset.getEntityPresentationFieldIndex();</pre>
     * @returns {string} Retorna o índice do campo de apresentação da entidade do dataset.
     */
    function getEntityPresentationFieldIndex() {
        return getFieldIndexByName(getEntityPresentationFieldName());
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isEmpty
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna se o dataset contém ou não registros.
     * @example <pre>dataset.isEmpty();</pre>
     * @returns {boolean} Retorna <b>true</b> caso o dataset não contenha registros ou <b>false</b>, caso contenha.
     */
    function isEmpty() {
        return size() === 0;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isRefreshing
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna se o dataset em processo de refresh.
     * @example <pre>dataset.isRefreshing();</pre>
     * @returns {boolean} Retorna <b>true</b> caso o dataset esteja em processo de refresh ou <b>false</b> caso contrário.
     */
    function isRefreshing() {
        return _pageRefreshing;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#size
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.size();</pre>
     * @returns {int} Retorna a quantidade de registros contidos no dataset.
     */
    function size() {
        return angular.isArray(_records.getItems()) ? _records.length() : 0;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isLoaded
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isLoaded();</pre>
     * @returns {boolean} Indica se o dataset já teve seus metadados carregados ou não.
     */
    function isLoaded() {
        return _isMetadataAvailable;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isInsertionMode
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isInsertionMode();</pre>
     * @returns {boolean} Indica se o dataset está em modo de inserção de registro.
     */
    function isInsertionMode() {
        return _isInsertionMode;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isCopyingRecord
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isCopyingRecord();</pre>
     * @returns {boolean} Indica se o dataset está em modo de cópia de registro.
     */
    function isCopyingRecord() {
        return _copyingRecord;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isRecordDirty
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isRecordDirty();</pre>
     * @returns {boolean} Indica se o registro foi alterado ou não.
     */
    function isRecordDirty() {
        return _recordIsDirty;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isModifyingField
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @param {string} fieldName Nome do campo que será validado.
     * @example <pre>dataset.isModifyingField('CODPARC');</pre>
     * @returns {boolean} True se o campo foi alterado ou false caso contrário.
     */
    function isModifyingField(fieldName) {
        return _modifiedBinders.hasOwnProperty(fieldName) || _programmaticalModifiedValues.hasOwnProperty(fieldName);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getModifyingFields
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.getModifyingFields();</pre>
     * @returns {Array} Retorna os campos que foram alterados
     */
    function getModifyingFields() {
        return Object.keys(_modifiedBinders).concat(Object.keys(_programmaticalModifiedValues));
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isMultiRecordEditMode
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isMultiRecordEditMode();</pre>
     * @returns {boolean} Indica se o dataset está em modo de edição múltipla.
     */
    function isMultiRecordEditMode() {
        return _multiEditMode;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isEditMode
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isEditMode();</pre>
     * @returns {boolean} Indica se o dataset está em modo de edição.
     */
    function isEditMode() {
        return _editionStarted;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isAnyEditMode
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.isAnyEditMode();</pre>
     * @returns {boolean} Indica se o dataset está em modo de edição ou edição múltipla.
     */
    function isAnyEditMode() {
        return _editionStarted || _multiEditMode;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getCurrentIndex
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o índice do array de registros em que o dataset está posicionado.
     * @example <pre>dataset.getCurrentIndex();</pre>
     * @returns {int} Caso não haja registros retornará -1.
     */
    function getCurrentIndex() {
        return _currentIndex;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setCurrentIndex
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Seta o índice do array de registros em que o dataset está posicionado.
     * @example <pre>dataset.setCurrentIndex();</pre>
     */

    function setCurrentIndex(value) {
        _currentIndex = value;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValue
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado.
     * @example <pre>dataset.getFieldValue('CODPARC');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {object} Valor do campo referente ao registro selecionado.
     */
    function getFieldValue(fieldName) {
        var currentRow = getCurrentRow();

        if (angular.isDefined(currentRow)) {
            var fieldIndex = _fieldIndexByName[fieldName];

            return currentRow[fieldIndex];
        }

        return undefined;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isFieldEmpty
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna se valor do campo referente ao registro selecionado está vazio ou não.
     * @example <pre>dataset.isFieldEmpty('CODPARC');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {boolean} True se o campo estiver vazio, False do contrário.
     */
    function isFieldEmpty(fieldName) {
        var currentRow = getCurrentRow();

        if (angular.isDefined(currentRow)) {
            var fieldIndex = _fieldIndexByName[fieldName];
            var value = currentRow[fieldIndex];

            return angular.isUndefined(value) || value == '';
        }

        return true;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isFieldEmptyOrZero
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna se valor do campo referente ao registro selecionado está vazio ou igual a zero.
     * @example <pre>dataset.isFieldEmptyOrZero('CODPARC');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {boolean} True se o campo estiver vazio ou zero, False do contrário.
     */
    function isFieldEmptyOrZero(fieldName) {
        var currentRow = getCurrentRow();

        if (angular.isDefined(currentRow)) {
            var fieldIndex = _fieldIndexByName[fieldName];
            var value = currentRow[fieldIndex];

            return angular.isUndefined(value) || value == '' || value == 0;
        }

        return true;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#preventAddShortcut
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Setter e getter de eventos de atalho de inserção.
     * @example <pre>dataset.preventAddShortcut(true);</pre>
     * @param {boolean} value Indica se o dataset deve ouvir ou não os eventos de atalho de inserção.
     * @returns {boolean} True|False se o dataset deve ouvir ou não os eventos de atalho de inserção.
     */
    function preventAddShortcut(value) {
        if (angular.isDefined(value)) {
            _preventAddShortcut = value;
        }

        return _preventAddShortcut;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValueAsString
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado.
     * @example </pre>dataset.getFieldValueAsString('CODPARC');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {string} Valor do campo referente ao registro selecionado convertido em string.
     */
    function getFieldValueAsString(fieldName) {
        var value = getFieldValue(fieldName);

        return self.dataToString(value);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValueAsFormattedString
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado formatado de acordo com o tipo do campo.
     * @example <pre>dataset.getFieldValueAsFormattedString('DTNASC');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {string} Valor do campo formatado de acordo com seu tipo.
     */
    function getFieldValueAsFormattedString(fieldName) {
        const value = getFieldValue(fieldName);
        const fieldMetadata = getFieldMetadata(fieldName);
        
        if (DatasetUtils.isDateType(fieldMetadata.dataType)) {
            return DatasetUtils.formatDate(value, fieldMetadata.dataType);
        }
        
        return self.dataToString(value);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValueAsJson
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado.
     * @example </pre>dataset.getFieldValueAsJson('CONFIG');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {string} Valor do campo referente ao registro selecionado convertido para Json.
     */
    function getFieldValueAsJson(fieldName) {
        var value = getFieldValue(fieldName);
        if(angular.isDefined(value)){
            try {
                value  = angular.fromJson(self.dataToString(value));
            } catch (error) {
                throw new MessageError('SanDB.DataSet.messageErroConversaoJson', [fieldName]);
            }
         }
        return value;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValueAsBoolean
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado.
     * @example <pre>dataset.getFieldValueAsBoolean('FORNECEDOR');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {boolean} Valor do campo referente ao registro selecionado.
     */
    function getFieldValueAsBoolean(fieldName) {
        return getFieldValueAsString(fieldName) == 'S';
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValueAsNumber
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado.
     * @example <pre>dataset.getFieldValueAsNumber('VLRITEM');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {number} Valor do campo referente ao registro selecionado.
     */
    function getFieldValueAsNumber(fieldName) {
        var fieldValue = getFieldValue(fieldName);

        if (angular.isDefined(fieldValue)) {
            fieldValue = Number(fieldValue);

            if (isNaN(fieldValue)) {
                throw new MessageError('SanDB.DataSet.messageErroConversaoNumerica', [fieldName]);
            }
        }

        return Number(fieldValue);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldValueAsNumberOrZero
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o valor do campo referente ao registro selecionado.
     * @example <pre>dataset.getFieldValueAsNumberOrZero('VLRITEM');</pre>
     * @param {string} fieldName Nome do campo.
     * @returns {number} Valor do campo referente ao registro selecionado ou 0 caso indefinido.
     */
    function getFieldValueAsNumberOrZero(fieldName) {
        var fieldValue = getFieldValueAsNumber(fieldName);

        if (isNaN(fieldValue)) {
            fieldValue = 0;
        }

        return fieldValue;
    }


    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldsMetadata
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @example <pre>dataset.getFieldsMetadata();</pre>
     * @returns {array} Retorna um array com os metadados dos campos do dataset.
     */
    function getFieldsMetadata() {
        return _fields;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldMetadata
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna os metadados do campo antes do init.
     * @example <pre>dataset.getUserFieldMetadata('CODPARC');</pre>
     * @param {string} fieldName Nome do campo
     * @returns {object} Retorna os metadados do campo antes do init
     */
    function getUserFieldMetadata(fieldName) {
        var field = _userFieldsMetadata.find(function(f){
            return f.name == fieldName;
        });

        return field;
    }

    function getUserFieldsMetadata() {
        return _userFieldsMetadata;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldMetadata
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna os metadados do campo.
     * @example <pre>dataset.getFieldMetadata('CODPARC');</pre>
     * @param {string} fieldName Nome do campo
     * @returns {object} Retorna os metadados do campo
     */
    function getFieldMetadata(fieldName) {
        var fieldIndex = _fieldIndexByName[fieldName];
        return _fields[fieldIndex];
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldMetadataByIndex
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna os metadados do campo.
     * @example <pre>dataset.getFieldMetadataByIndex(1);</pre>
     * @param {string} fieldIndex Índice do campo
     * @returns {object} Retorna os metadados do campo com determinado indice.
     */
    function getFieldMetadataByIndex(fieldIndex) {
        return _fields[fieldIndex];
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRecords
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o array de registros do dataset.
     * @example <pre>dataset.getRecords();</pre>
     * @returns {Array} Caso não haja registros retornará undefined.
     */
    function getRecords() {
        return _records.getItems();
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#reduce
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Aplica a função de reduce no array do dataset.
     * @example <pre>dataset.reduce(function(total, linha) {
     * }, 0, 'VALOR');</pre>
     * @returns {Object} Retorna o valor processado.
     */
    function reduce(reduceFn, initial, fields) {
        if (fields) {
            fields = ArrayUtils.toArray(fields);

            return _records.getItems().reduce(function (total, curr) {
                return reduceFn(total, getRecordAsObject(curr, fields));
            }, initial);
        } else {
            return _records.getItems().reduce(reduceFn, initial);
        }
    }


    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRecordsList
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o array de registros do dataset.
     * @example <pre>dataset.getRecordsList();</pre>
     * @returns {ArrayList} ArrayList com os registros do dataset.
     */
    function getRecordsList() {
        return _records;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#refreshRecordsList
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Realiza um refresh na collection interna do dataset.
     * @example <pre>dataset.refreshRecordsList();</pre>
     */
    function refreshRecordsList() {
        _records.refresh();
    }
    
    function refreshDataGridCells(){
        self.dispatchEvent(DatasetEvents.REFRESH_CELLS);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRecordsAsObject
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável disponibilizar o registro atual em forma de objeto
     * @param {array|string} fields Array ou String com separação por virgulas.
     * Se passado, será usado como base para criação da linha, assim não montando uma copia completa da linha atual.
     * Cada item fieldName poderá ser exportado com outro nome, basta seguir o seguinte padrão fieldName:exportName
     * @example <pre>dataset.getRecordsAsObject('CODPARC:MEUCODIGO');</pre>
     */
    function getRecordsAsObject(fields, parseTypedData, params = {}) {
        let allRecors = angular.copy(_records.getItems());
        
        if(params.concatTransient && _transientRecord){
            allRecors.push(_transientRecord)
        }
        
        return _convertRecordsAsObject(allRecors, fields, parseTypedData);
    }

    function _convertRecordsAsObject(records, fields, parseTypedData) {
        if (records) {
            var recordsAsObjects = [];

            if (angular.isString(fields)) {
                fields = fields.split(',');
            }

            records.forEach(function (record) {
                var recordObj = {};
                recordsAsObjects.push(recordObj);

                if (angular.isArray(fields)&& fields.length > 0){
                    fields.forEach(function (key) {
                        key = key.split(':');

                        if (key.length == 1) {
                            key.push(key[0]);
                        }

                        var fieldIndex = getFieldIndexByName(key[0].trim());

                        if (fieldIndex > -1) {
                            var _value = record[fieldIndex];
                            if (parseTypedData === true && angular.isString(_value)) {
                                recordObj[key[1].trim()] = strToTypedData(_value, fieldMD.dataType);
                            } else {
                                recordObj[key[1].trim()] = _value;
                            }
                        }
                    });
                } else {
                    _fields.forEach(function (fieldMD) {
                        var _value = record[_fieldIndexByName[fieldMD.name]];
                        if (parseTypedData === true && angular.isString(_value)) {
                            recordObj[fieldMD.name] = strToTypedData(_value, fieldMD.dataType);
                        } else {
                            recordObj[fieldMD.name] = _value;
                        }
                    });
                }
            });

            return recordsAsObjects;
        }

        return undefined;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRecord
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o registro referente ao índice informado.
     * @example <pre>dataset.getRecord(1);</pre>
     * @returns {array} Linha referente ao índice ou undefined caso índice menor que zero ou maior que a lista.
     */
    function getRecord(index) {
        if (index > -1 && index < size()) {
            return _records.getItem(index);
        }

        return undefined;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRecordAsObject
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna o registro referente ao índice informado como objeto.
     * @param {number|array} obj Indice desejado ou array da linha.
     * @param {array|string} fields Array ou String com separação por virgulas.
     * Se passado, será usado como base para criação da linha, assim não montando uma copia completa da linha atual.
     * Cada item fieldName poderá ser exportado com outro nome, basta seguir o seguinte padrão fieldName:exportName
     * @example <pre>dataset.getRecordAsObject(1, 'CODPARC:MEUCODIGO');</pre>
     * @returns {object} Objeto referente ao índice ou undefined caso índice menor que zero ou maior que a lista.
     */
    function getRecordAsObject(obj, fields, considerHierarchy) {
        var row;

        if (angular.isArray(obj)) {
            row = obj;
        } else if (obj > -1 && obj < size()) {
            row = _records.getItem(obj);
        }

        if (row) {
            var rowAsObject = {};

             if (angular.isString(fields)) {
                fields = fields.split(',');
            }

            if (angular.isArray(fields)) {
                fields.forEach(function (key) {
                    key = key.split(':');

                    if (key.length == 1) {
                        key.push(key[0]);
                    }

                    var fieldIndex = getFieldIndexByName(key[0].trim());

                    if (fieldIndex > -1) {
                        rowAsObject[key[1].trim()] = row[fieldIndex];
                    }
                });
            } else {
                for(var i = 0; i < _fields.length; i++){                    
                    var fieldMD = _fields[i];                    
                    if(considerHierarchy){
                        rowAsObject = ObjectUtils.setPropetyWithHierarchy(rowAsObject, fieldMD.name, row[_fieldIndexByName[fieldMD.name]]);
                    }else{
                        rowAsObject[fieldMD.name] = row[_fieldIndexByName[fieldMD.name]];
                    }
                }
            }

            if(angular.isObject(row[row.length -1])){
                var mdRow = row[row.length -1];
                Object.keys(mdRow).forEach(function(key){
                    if(key == 'rowID'){
                        rowAsObject['rowID'] = mdRow['rowID'];
                    }
                })
            }

            return rowAsObject;
        } else {
            return undefined;
        }
    }

    function getOriginalRecordsAsObject(fields, parseTypedData) {
        return _convertRecordsAsObject(getOriginalRecords(), fields, parseTypedData);
    }

    function getOriginalRecords() {
        return _records.getOriginalRecords();
    }

    function existsFilterFunction() {
        return _records.existsFilterFunction();
    }

    function existsSortFunction() {
        return _records.existsSortFunction();
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addFieldsRequestInfo
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado pela diretiva sk-field para inputar as colunas adicionais que serão requisitadas por este dataset.
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example <pre>dataset.addFieldsRequestInfo({
                path: 'Produto',
                pattern: 'CODPROD'
            });</pre>
     */
    function addFieldsRequestInfo(field) {
        //Except fields pattern
        if(field.except === true){
            var entity = field.path || $scope.entityName;

            if(!_exceptFieldsByEntity.hasOwnProperty(entity)){
                _exceptFieldsByEntity[entity] = [];
            }

            _exceptFieldsByEntity[entity] = _exceptFieldsByEntity[entity].concat(field.pattern.split(','));
        }else if(field.pattern == DatasetContants.DEFAULT_USER_FIELDS){
            _entityForceUserFields[field.path || $scope.entityName] = true;
        } else{
            _metadataFieldsRequestInfo.push(field);
        }

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addUserFieldMetadata
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado pela diretiva sk-dsfield-md para informar ao dataset a list de campos que deverá ser utilizado.
     */
    function addUserFieldMetadata(field) {
        field.order = _userFieldsMetadata.length;

        _userFieldsMetadata.push(field);

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addFieldValueEvaluator
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para adicionar um evaluator ao dataset, que fará com que um campo seja recalculado sempre que um outro for alterado
     * @param {string} fieldName Nome do campo que deverá ser alterado com base em outros.
     * @param {function} evaluateFn Função chamada para recalcular o valor.
     * @param {string} triggerFields Campos que dispararão o recalculo do fieldName
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example <pre>dataset.addFieldValueEvaluator('CODREG', function(){
                return 0; //Sempre que CODBAI ou CODCID mudar, o campo CODREG será atualizado com 0.
            }, 'CODBAI,CODCID');</pre>
     */
    function addFieldValueEvaluator(fieldName, evaluateFn, triggerFields) {
        var fieldValueEvaluator = {
            fieldName: fieldName,
            evaluateFn: evaluateFn,
            triggerFields: ArrayUtils.toArray(triggerFields).map(function (value) {
                return value.trim();
            })
        };

        _fieldValueEvaluators.push(fieldValueEvaluator);

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addAutoInsertValue
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Insere informações de auto inclusão no dataset.
     * No próximo refresh do dataset, caso não seja carregadao nenhum registro
     * o dataset entrará em inclusão com os valores inseridos por este método.
     * @param {string} fieldName Nome do campo.
     * @param {string} value Valor do campo.
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example <pre>dataset.addAutoInsertValue('CODPARC', '1');</pre>
     */
    function addAutoInsertValue(fieldName, value) {
        if (getFieldMetadata(fieldName)) {
            if (!_autoInsertValues) {
                _autoInsertValues = {};
            }

            _autoInsertValues[fieldName] = value;
        }

        return self;
    }

    function autoInsert() {
        if (_autoInsertValues) {
            goToInsertionMode()
                .then(function () {
                    for (var field in _autoInsertValues) {
                        setFieldValueAsString(field, _autoInsertValues[field]);
                    }

                    _autoInsertValues = undefined;
                });
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setSelectedRecords
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Seta os registros na seleção do dataset.
     * @param {array} newSelectedRecords selectedRecords nova seleção.
     * @example <pre>dataset.setSelectedRecords(selectedRecords);</pre>
     */
    function setSelectedRecords(newSelectedRecords) {
        _selectedRecordsByUniqueId = {};
        _selectedRecords = newSelectedRecords.slice(0);
        _selectedRecords.forEach(function(record){
            var recordMd = getRowMetadata(record);
            if(recordMd){
                _selectedRecordsByUniqueId[recordMd.rowID] = true;
            }
        });
        notifyDataSetObservers(DatasetObserverEvents.EVENT_SELECTION_CHANGED);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setSelectedRecordsByPks
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Seta os registros na seleção do dataset.
     * @param {array} pkObjects lista com as PKs  dos registros a serem selecionados.
     * @example <pre>dataset.setSelectedRecordsByPks(pkObjects);</pre>
     */
    function setSelectedRecordsByPks(pkObjects) {
        if (!angular.isArray(pkObjects) || pkObjects.length == 0) {
            return;
        }

        var pkObjectCopy = angular.copy(pkObjects);

        var selectedRecords = [];

        ArrayUtils.forEach(getRecords(), function(currRecord) {
            var currRecordPK = buildPkObject(currRecord, false, false);

            ArrayUtils.forEach(pkObjectCopy, function(currPk, currPkIndex){

                if (angular.equals(currRecordPK, currPk)) {
                    ArrayUtils.removeAtIndex(pkObjectCopy, currPkIndex);

                    selectedRecords.push(currRecord);

                    return false;
                }
            });

            if (pkObjectCopy.length == 0) {
                return false;
            }
        });

        setSelectedRecords(selectedRecords);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getPrimaryKeys
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna o nome dos campos chave da entidade.
     * @example <pre>dataset.getPrimaryKeys();</pre>
     * @returns {array} Retorna um array com as chaves da entidade.
     */
    function getPrimaryKeys() {
        return _primaryKeyFields || [];
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getPrimaryKeyValues
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna os valores de chave do registro selecionado
     * @example <pre>dataset.getPrimaryKeyValues();</pre>
     * @returns {array} Retorna um array com os valores da chave da entidade ou undefined caso não tenha entidade selecionada.
     */
    function getPrimaryKeyValues(asString) {
        var currentRow = getCurrentRow();

        if (currentRow && getPrimaryKeys()) {
            var pkValues = [];

            getPrimaryKeys().forEach(function (pkName) {
                var value = currentRow[getFieldIndexByName(pkName)];

                if (asString) {
                    value = self.dataToString(value);
                }

                pkValues.push(value);
            });

            return pkValues;
        } else {
            return undefined;
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getPrimaryKeyObject
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna um objeto com chave e valor representando a pk do registro selecionado.
     * @example <pre>dataset.getPrimaryKeyValues();</pre>
     * @param {boolean} required determina se deve ser lançada uma exceção caso algum valor da pk não esteja preenchido.
     * @param {boolean} toString converte os valores para sua forma em string.
     * @returns {object} Retorna um objeto nomes e valores da chave da entidade ou undefined caso não tenha entidade selecionada.
     */
    function getPrimaryKeyObject(required, toString) {
        var currentRow = getCurrentRow();

        if (currentRow && getPrimaryKeys()) {
            return buildPkObject(currentRow, required, toString);
        } else {
            return undefined;
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getSelectedRecords
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna os registros da seleção do dataset.
     * @param {boolean} forceSingleResult Força o dataset a retornar um array, ainda que haja apenas UM registro selecionado.
     * @example <pre>dataset.getSelectedRecords();</pre>
     * @returns {array} Retorna um array com os registros da seleção do dataset.
     */
    function getSelectedRecords(forceSingleResult) {
        if (_selectedRecords) {
            return _selectedRecords;
        }

        if (forceSingleResult && getCurrentRow()) {
            return [getCurrentRow()];
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getAllowPkModification
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Define se o dataset aceita ou não modificação de PK.
     * @return {boolean} Retorna true caso o dataset aceita modificação de PK, false caso contrário.
     * @example dataset.getAllowPkModification();
     */
    function getAllowPkModification() {
        return _allowPKModification;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getSelectedRecordsPks
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna as pks dos registros da seleção do dataset.
     * @param {boolean} forceSingleResult Força o dataset a retornar um array, ainda que haja apenas UM registro selecionado.
     * @example <pre>dataset.getSelectedRecordsPks();</pre>
     * @returns {array} Retorna as pks dos registros da seleção do dataset.
     */
    function getSelectedRecordsPks(forceSingleResult) {
        return getSelectedRecordsAsObjects(getPrimaryKeys(), forceSingleResult);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getSelectedRecordsAsObjects
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna os registros da seleção do dataset em forma de objetos.
     * @param {array|string} fields Array ou String com separação por virgulas.
     * Se passado, será usado como base para criação da linha, assim não montando uma copia completa da linha atual.
     * Cada item fieldName poderá ser exportado com outro nome, basta seguir o seguinte padrão fieldName:exportName
     * @param {boolean} forceSingleResult Força o dataset a retornar um array, ainda que haja apenas UM registro selecionado.
     * @example <pre>dataset.getSelectedRecordsAsObjects('CODPARC:CODIGO');</pre>
     */
    function getSelectedRecordsAsObjects(fields, forceSingleResult) {
        var records = getSelectedRecords(forceSingleResult);

        return (records || []).map(function (record) {
            return getRowAsObject(record, fields);
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getFieldNames
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna um array com os nomes dos campos do dataset
     * @example <pre>dataset.getFieldNames();</pre>
     */
    function getFieldNames(includeStandAloneFields) {
        return getFieldNamesForRequest(includeStandAloneFields);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRecordsAsObjects
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna todos os registros do dataset em forma de objetos.
     * @example <pre>dataset.getRecordsAsObjects();</pre>
     */
    function getRecordsAsObjects(params = {}) {
        var records = angular.copy(getRecords());
        
        if(params.concatTransient && _transientRecord){
            records.push(_transientRecord)
        }

        return (records || []).map(function (record) {
            return getRowAsObject(record, getFieldNamesForRequest(true));
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setFilterCriteria
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para adicionar um {@link util.common:Criteria} ao dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @param {Criteria} criteria a ser registrado no dataset.
     */
    function setFilterCriteria(criteria) {
        $scope.filterCriteria = criteria;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addCriteriaProvider
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para adicionar um {@link util.common.interface:CriteriaProvider} ao dataset.
     * Pode ser passado também apenas um ponteiro de função, que então será convertido para um CriteriaProvider
     * @return {Function} Retorna uma função que remove o criteriaProvider.
     * @param {CriteriaProvider} criteriaProvider provider a ser registrado no dataset.
     */
    function addCriteriaProvider(criteriaProvider) {
        try {
            ObjectUtils.isImplementorOf(criteriaProvider, CriteriaProvider);
        } catch (e) {
            if (angular.isFunction(criteriaProvider)) {
                criteriaProvider = CriteriaProvider.build(criteriaProvider);
            } else {
                throw e;
            }
        }

        if (_criteriaProviders.indexOf(criteriaProvider) < 0) {
            _criteriaProviders.push(criteriaProvider);
        }

        return function () {
            removeCriteriaProvider(criteriaProvider);
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getCriteriaProvider
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para retornar o CriteriaProvider existente no dataset 
     * @return {CriteriaProvider} Retorna um criteriaProvider provider registrado no dataset.
     */
    function getCriteriaProvider() {
        return _criteriaProviders;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeCriteriaProvider
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para remover um {@link util.common:CriteriaProvider} do dataset
     * @param {CriteriaProvider} criteriaProvider provider a ser removido do dataset.
     */
    function removeCriteriaProvider(criteriaProvider) {
        ObjectUtils.isImplementorOf(criteriaProvider, CriteriaProvider);

        var index = _criteriaProviders.indexOf(criteriaProvider);

        if (index > -1) {
            _criteriaProviders.splice(index, 1);
        }
    }


    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addFieldBinder
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado adicionar um {@link snk.components.dataset.interface:FieldBinder} ao dataset
     * @return {Function} Retorna uma função que remove o fieldBinder
     * @param {FieldBinder} fieldBinder a ser adicionado ao dataset.
     */
    function addFieldBinder(fieldBinder) {
        ObjectUtils.isImplementorOf(fieldBinder, FieldBinder);

        var arrFieldBinders = _fieldBinders[fieldBinder.getFieldName()];

        if (!angular.isArray(arrFieldBinders)) {
            arrFieldBinders = [];
            _fieldBinders[fieldBinder.getFieldName()] = arrFieldBinders;
        }

        //Já registrado
        if (arrFieldBinders.length > 0 && arrFieldBinders.indexOf(fieldBinder) > -1) {
            return;
        }

        try{
            if(angular.isUndefined(fieldBinder.element) && 
            getFieldsMetadata() != undefined &&
            getFieldMetadata(fieldBinder.getFieldName()) != undefined &&
            getFieldMetadata(fieldBinder.getFieldName()).userType == "SELECTDISTINCT"){
                return;
            } 
        }catch(err){
            console.log(err);
        }
        

        arrFieldBinders.push(fieldBinder);

        refreshBinder(fieldBinder);

        return function () {
            removeFieldBinder(fieldBinder);
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#hasFieldBinder
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para verificar a existencia de um FieldBinder para um campo
     * @param {string} fieldName a ser verificado no dataset.
     */
    function hasFieldBinder(fieldName) {
        return _fieldBinders.hasOwnProperty(fieldName);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeFieldBinder
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado remover um {@link snk.components.dataset.interface:FieldBinder} do dataset
     * @param {FieldBinder} fieldBinder a ser removido ao dataset.
     */
    function removeFieldBinder(fieldBinder) {
        ObjectUtils.isImplementorOf(fieldBinder, FieldBinder);

        var arrFieldBinders = _fieldBinders[fieldBinder.getFieldName()];

        if (angular.isArray(arrFieldBinders) && arrFieldBinders.length > 0) {
            var index = arrFieldBinders.indexOf(fieldBinder);

            if (index > -1) {
                ArrayUtils.removeAtIndex(arrFieldBinders, index);
            }
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#refreshBinder
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método utilizado para realizar o refresh de um {@link snk.components.dataset.interface:FieldBinder}
     * @param {FieldBinder} fieldBinder a ser realizado o refresh.
     */
    function refreshBinder(fieldBinder, options) {
        try {
            // Desligamos o listener de modificações, pois os binders podem entender o método setData como uma alteração externa.
            _listenToModifications = false;

            var record = getCurrentRow();

            var value;

            if (angular.isDefined(record)) {
                var fieldId = fieldBinder.getFieldName();
                value = record[_fieldIndexByName[fieldId]];
            }

            setDataOnFieldBinder(fieldBinder, value, options);
        } finally {
            _listenToModifications = true;
        }
    }

    function setDataOnFieldBinder(fieldBinders, value, options) {
    	if (angular.isUndefined(fieldBinders)) {
            return;
        }
    	
        if (!angular.isArray(fieldBinders)) {
            fieldBinders = [fieldBinders];
        }

        fieldBinders.forEach(function (fieldBinder) {
            fieldBinder.beforeSetData(value);
            fieldBinder.setData(value, options);
            fieldBinder.afterSetData(value);
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#notifyEditionStart
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por avisar ao dataset que um {@link snk.components.dataset.interface:FieldBinder} foi alterado
     * @param {FieldBinder} fieldBinder FieldBinder alterado.
     */
    function notifyEditionStart(fieldBinder) {
        if (!isLoaded()) {
            return;
        }

        if (!_editionStarted && _canEdit) {
            _editionStarted = true;

            var fieldName;

            if (angular.isDefined(fieldBinder)) {
                fieldName = fieldBinder.getFieldName();
            }

            notifyDataSetObservers(DatasetObserverEvents.EVENT_EDITION_STARTED, {
                editedFieldName: fieldName
            });
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#notifyUploadState
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por avisar ao dataset sobre o status de upload de um arquivo.
     * @param {boolean} uploading Status do upload.
     */
    function notifyUploadState(uploading) {
        _isUploading = uploading;

        notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SET_UPLOADING, {
            isUploading: _isUploading
        });

    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#askAndCancelEdition
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável cancelar uma edição iniciada no dataset com opção de autosave.
     * @return {Promise} Retorna uma promessa que será executada após o autosave
     */
    function askAndCancelEdition() {
        return $q(function (resolve) {
            autoSave().then(function () {
                cancelEdition();
                resolve();
            });
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#cancelEdition
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável cancelar uma edição iniciada no dataset.
     */
    function cancelEdition() {
        if (angular.isFunction(_beforeCancelAction)) {
            _beforeCancelAction().then(function() {
                canceling();
            })
        } else {
            canceling(); 
        } 
    }

    function canceling() {
        if (_recordIsDirty || isInsertionMode() || _multiEditMode) {

            if (!isInsertionMode() && angular.isDefined(_cleanRecord)) {
                var resetToCleanRecord = function (cleanRecord) {
                    var recordConfig = getRowMetadata(cleanRecord);

                    var record = _rowsByUniqueID[recordConfig.rowID];

                    angular.copy(cleanRecord, record);
                };

                if (_multiEditMode) {
                    angular.forEach(_cleanRecord, function (cleanRecord) {
                        resetToCleanRecord(cleanRecord);
                    });
                } else {
                    resetToCleanRecord(_cleanRecord);
                }
            }

            var isMultEditMode = _multiEditMode;
            var indexBeforeInsertionMode = _indexBeforeInsertionMode;

            clearEdition();

            if (!isMultEditMode) {
                var oldIndex = indexBeforeInsertionMode > -1 ? indexBeforeInsertionMode : getCurrentIndex();

                changeRow(oldIndex);
            }

            notifyDataSetObservers(DatasetObserverEvents.EVENT_EDITION_CANCELED);
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#goToInsertionMode
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável iniciar o modo de inserção do dataset.
     */
    function goToInsertionMode() {
        return $q(function (resolve, reject) {
            if (_canInsert) {
                autoSave().then(function () {
                    if (isLoaded()) {
                        setInsertionMode(true).then(_ => {
                            notifyDataSetObservers(DatasetObserverEvents.EVENT_ROW_METADATA_CHANGED, {reason: "ROW_CHANGED", providerChanged: false } );
                            resolve();
                        });
                    } else {
                        addFunctionToQueue(function () {
                            goToInsertionMode().then(resolve);
                        });
                    }
                });
            } else {
                MessageUtils.showAlert(msgControleAcesso, $translate.instant('Dataset.messageNaoPermitidoInserir'));
                reject();
            }
        });

    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#beginEdition
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável iniciar o modo de edição dataset.
     */
    function beginEdition() {
        if (isMultiSelection()) {
            _multiEditMode = true;

            var nullValue = '__$nullValue$__';

            _transientRecord = {};

            for (var fieldName in _fieldIndexByName) {
                var fieldIndex = _fieldIndexByName[fieldName];

                var value = nullValue;

                for (var i = 0; i < _selectedRecords.length; i++) {
                    var record = _selectedRecords[i];

                    if (value === nullValue) {
                        value = record[fieldIndex];
                    } else if (value !== record[fieldIndex]) {
                        value = undefined;
                        break;
                    }
                }

                _transientRecord[fieldIndex] = value;
            }

            refreshBinders();
        } else {
            _multiEditMode = false;
        }

        notifyDataSetObservers(DatasetObserverEvents.EVENT_EDIT_MODE, { multiEditMode: _multiEditMode });
    }

    function isMultiSelection() {
        return angular.isDefined(_selectedRecords) && _selectedRecords.length > 1;
    }

    function canChangePK() {
        return false;
    }

    function setInsertionMode(doChangeRow) {
        var defer = $q.defer();

        if (!_isInsertionMode) {
            var indexBeforeInsertionMode = _currentIndex;

            var doSetInsertionMode = function () {
                _isInsertionMode = true;
                _transientRecord = createTransientRecord();

                _indexBeforeInsertionMode = indexBeforeInsertionMode;

                //Notificar os observers que entrou em modo de insersão;
                notifyDataSetObservers(DatasetObserverEvents.EVENT_INSERT_MODE, { indexBeforeInsert: _indexBeforeInsertionMode });

                defer.resolve();
            };

            if (doChangeRow === true) {
                changeRow(-1, false).then(function () {
                    doSetInsertionMode();
                }, defer.reject);
            } else {
                doSetInsertionMode();
            }
        } else {
            defer.resolve();
        }

        return defer.promise;
    }

    function createTransientRecord() {
        var newRecord = [];
        newRecord.length = _fields.length;

        if (angular.isDefined(_parentDataSet)) {
            for (var index in _foreingKeyFields) {
                var fkField = _foreingKeyFields[index];

                var fieldName = fkField['localField'];

                var fieldIndex = _fieldIndexByName[fieldName];

                newRecord[parseInt(fieldIndex)] = _parentDataSet.getFieldValue(fkField['parentFieldName']);
            }
        }

        return newRecord;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setFieldValueAsJson
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por alterar o valor de um campo no registro selecionado.
     * @param {string} fieldName Nome do campo
     * @param {string} newValue Novo valor
     * @param {boolean} [transientMode=false] Se é uma mudança transiente ou não
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset
     *  .setFieldValueAsJson('CAMPO1', 'A')
     *  .setFieldValueAsJson('CAMPO2', 'B');
     * </pre>
     */
    function setFieldValueAsJson(fieldName, newValue, transientMode) {
        if(angular.isDefined(newValue)){
            newValue = angular.toJson(newValue);
        }
        
        return setFieldValueAsString(fieldName, newValue, transientMode);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setFieldValueAsString
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por alterar o valor de um campo no registro selecionado.
     * @param {string} fieldName Nome do campo
     * @param {string} newValue Novo valor
     * @param {boolean} [transientMode=false] Se é uma mudança transiente ou não
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset
     *  .setFieldValueAsString('CAMPO1', 'A')
     *  .setFieldValueAsString('CAMPO2', 'B');
     * </pre>
     */
    function setFieldValueAsString(fieldName, newValue, transientMode) {
        var fieldIndex = _fieldIndexByName[fieldName];
        var fieldMetadata = _fields[fieldIndex];

        if (angular.isUndefined(fieldMetadata)) {
            throw new Error('Metadados não encontrados para o campo: ' + fieldName);
        }

        newValue = strToTypedData(newValue, fieldMetadata.dataType);

        return setFieldValue(fieldName, newValue, transientMode);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setFieldValue
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por alterar o valor de um campo no registro selecionado.
     * @param {string} fieldName Nome do campo
     * @param {object} newValue Novo valor
     * @param {boolean} [transientMode=false] Se é uma mudança transiente ou não
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset
     *  .setFieldValue('CAMPO1', 'A')
     *  .setFieldValue('CAMPO2', 'B');
     *  
     * </pre>
     */
    function setFieldValue(fieldName, newValue, transientMode) {
        var currentRow = getCurrentRow();

        if (angular.isUndefined(currentRow)) {
            throw new Error('Nenhum registro selecionado.');
        }

        var fieldIndex = _fieldIndexByName[fieldName];
        var fieldMetadata = _fields[fieldIndex];

        if (angular.isUndefined(fieldMetadata)) {
            throw new Error('Metadados não encontrados para o campo: ' + fieldName);
        }

        var oldValue = angular.isDefined(currentRow) ? currentRow[fieldIndex] : undefined;

        if (valueWasChanged(oldValue, newValue)) {
            if (!parentAllowDetailEdition()) {
                setDataOnFieldBinder(_fieldBinders[fieldName], oldValue);
                return;
            }

            if (!isInsertionMode()) {
                if (!_canEdit) {
                    MessageUtils.showAlert(msgControleAcesso, $translate.instant('Dataset.messageNaoPermitidoAlterar'));
                    return;
                } else if (size() > 0 && isPrimaryKey(fieldName) && !canChangePK() && !_allowPKModification) {
                    debouncedErrorChangingPK();
                    return;
                }
            }

            if (angular.isUndefined(transientMode) || transientMode === false) {
                _programmaticalModifiedValues[fieldName] = newValue;
            }

            updateCurrentRecord(fieldName, fieldIndex, newValue, undefined, transientMode, { programmatically: true });
        }

        return self;
    }

    function showErrorChangingPK() {
        throw new Error($translate.instant('Dataset.messageErroAlterarPK'));
    }

    function setModified(fieldBinder, isEnd) {
        if (_listenToModifications && isLoaded()) {

            var fieldName = fieldBinder.getFieldName();
            var fieldIndex = _fieldIndexByName[fieldName];
            var fieldMetadata = _fields[fieldIndex];

            if (angular.isUndefined(fieldMetadata)) {
                throw new Error('Metadados não encontrados para o campo: ' + fieldName);
            }

            var currentRow = getCurrentRow();

            var oldValue = angular.isDefined(currentRow) ? currentRow[fieldIndex] : undefined;

            var newValue = strToTypedData(self.dataToString(fieldBinder.getData()), fieldMetadata.dataType);

            if (valueWasChanged(oldValue, newValue)) {
                if (!parentAllowDetailEdition()) {
                    setDataOnFieldBinder(fieldBinder, oldValue);
                    return;
                }

                if (!isInsertionMode()) {
                    if (!_canEdit) {
                        setDataOnFieldBinder(fieldBinder, oldValue);
                        MessageUtils.showAlert(msgControleAcesso, $translate.instant('Dataset.messageNaoPermitidoAlterar'));
                        return;
                    } else if (size() > 0 && isPrimaryKey(fieldName) && !canChangePK() && !_allowPKModification) {
                        _findRowPk = false;
                        _timeoutFindPk && $timeout.cancel(_timeoutFindPk);
                        _timeoutFindPk = $timeout(() => {
                            getRecordsAsObjects().forEach((record, index) => {
                                if(record[fieldName] == newValue) {
                                    gotoRow(index);
                                    _findRowPk = true;
                                    return;
                                }
                            })

                            if(!_findRowPk) {
                                if(angular.isArray(_primaryKeyFields) && _primaryKeyFields.length > 1){
                                    setDataOnFieldBinder(fieldBinder, oldValue);
                                    debouncedErrorChangingPK();
                                }else{
                                    setDataOnFieldBinder(fieldBinder, null);
                                    gotoRow(-1);
                                }
                            }
                        }, 300);
                        return;
                    }
                }
                lastModifiedField=fieldName;
                
                _modifiedBinders[fieldName] = fieldBinder;

                //Caso o usuário faça uma alteração (esse método) depois do programador
                //(_programmaticalModifiedValues), descarta-se a do programador.
                delete _programmaticalModifiedValues[fieldName];

                if (size() <= 0 && !_isInsertionMode) {
                    if(canInsert()){
                    setInsertionMode();
                    }else{
                        return;
                    }

                }

                updateCurrentRecord(fieldName, fieldIndex, newValue, fieldBinder, undefined, {isEnd: isEnd});
            }
        }
    }

    function updateCurrentRecord(fieldID, fieldIndex, newValue, fieldBinder, transientChange, options) {
        var record = getCurrentRow();
        if (angular.isUndefined(_cleanRecord)) {
            if (_multiEditMode) {
                _cleanRecord = {};
                for (var i = 0; i < _selectedRecords.length; i++) {
                    _cleanRecord[i] = angular.copy(_selectedRecords[i]);
                }
            } else {
                _cleanRecord = angular.copy(record);
            }
        }
        
        var oldValue;
        if(record) {
            oldValue = record[fieldIndex];
        }
  
        if (_multiEditMode) {
            for (var i = 0; i < _selectedRecords.length; i++) {
                var selRecord = _selectedRecords[i];
                selRecord[fieldIndex] = newValue;
            }
        } else {
            if(record) {
                record[fieldIndex] = newValue;
            }
        }

        refreshBinders(fieldID, fieldBinder, options);

        if (angular.isUndefined(transientChange) || !transientChange) {
            _recordIsDirty = true;

            var params = {
                modifiedFieldId: fieldID,
                oldValue: oldValue,
                newValue: newValue
            };

            notifyDataSetObservers(DatasetObserverEvents.EVENT_RECORD_EDITED, params);
        }

        if(!options || options.isEnd == true || options.isEnd == undefined){
            updateRMD(fieldID, record);
        }
    }

    function updateRMD(fieldID, record){
        var fm = getFieldMetadata(fieldID);
            
        if(fm != undefined){

            if (fm.entityPath === $scope.entityName && isInsertionMode() && getIgnoreRMDOnInsert()) {
                return;
            }

            var rmp = ArrayUtils.find(fm.properties, prop => prop && prop.name == 'rmp');
            if(rmp && StringUtils.isNotEmpty(rmp.value)){
                //Nesse caso o campo é provedor de metadados de linha, então precisamos acionar o mecanismo de atualização.
                doUpdateRMD(fm, rmp.value, record);
            }
        }
    }

    function isPrimaryKey(fieldId) {
        for (var i = 0; i < _primaryKeyFields.length; i++) {
            if (_primaryKeyFields[i] == fieldId) {
                return true;
            }
        }

        return false;
    }

    function valueWasChanged(oldValue, newValue) {
        if (oldValue === '') {
            oldValue = undefined;
        }

        if (newValue === '') {
            newValue = undefined;
        }

        return !angular.equals(oldValue, newValue);
    }

    function refreshBinders(fieldName, changeOwner, options) {
        var arrFieldBinders;
        var fieldBinder;

        if (angular.isUndefined(fieldName)) {

            angular.forEach(_fieldBinders, function (arrFieldBinders) {
                for (var i = 0; i < arrFieldBinders.length; i++) {
                    fieldBinder = arrFieldBinders[i];

                    if (fieldBinder !== changeOwner) {
                        refreshBinder(fieldBinder, options);
                    }
                }
            });
        } else {
            if (_fieldBinders.hasOwnProperty(fieldName)) {
                arrFieldBinders = _fieldBinders[fieldName];

                for (var i = 0; i < arrFieldBinders.length; i++) {
                    fieldBinder = arrFieldBinders[i];

                    if (fieldBinder !== changeOwner) {
                        refreshBinder(fieldBinder, options);
                    }
                }
            }
        }
    }

    function buildIdentifier(record) {
        var id = '';

        for (var index in _primaryKeyFields) {
            var pkField = _primaryKeyFields[index];

            var pkFieldMD = getFieldMetadata(pkField);

            var toStringOptions;

            if (pkFieldMD && pkFieldMD.dataType == 'D') {
                toStringOptions = {
                    dateFormat: DateUtilsConstants.DEFAULT_DATE_FORMAT
                };
            }

            var pkValue = self.dataToString(record[_fieldIndexByName[pkField]], false, toStringOptions);

            id = StringUtils.substitute("{0}:{1}:{2}", id, pkField, pkValue);
        }

        return !StringUtils.isEmpty(id) ? id : ObjectUtils.objectToHash(record);
    }

    function setRequiredMembroPK(enable) {
        _isRequiredMembroPK = enable;
    }

    function buildPkObject(record, required, toString) {
        var pk = {};

        if (angular.isUndefined(toString)) {
            toString = true;
        }

        for (var index in _primaryKeyFields) {
            var pkField = _primaryKeyFields[index];

            var value = record[_fieldIndexByName[pkField]];

            if (toString) {
                value = self.dataToString(value);
            }

            if (_isRequiredMembroPK !== false && required === true && (angular.isUndefined(value) || value === '')) {
                throw new Error('Membro de PK não preenchido no elemento.');
            }

            pk[pkField] = value;
        }

        return pk;
    }

    function buildOldPkObject() {
        if (_cleanRecord) {
            if (_multiEditMode) {
                var ehAlteracaoPK = false;
                for (let i = 0; i < _primaryKeyFields.length; i++) {
                    if (isModifyingField(_fieldIndexByName[_primaryKeyFields[i]])) {
                        ehAlteracaoPK = true;
                        break;
                    }
                }

                if (ehAlteracaoPK) {
                    throw new Error('Formulário não preparado para alteração de PKs e múltipla edição.');
                }
            } else {
                var pk = {};

                for (var index in _primaryKeyFields) {
                    var pkField = _primaryKeyFields[index];

                    var value = self.dataToString(_cleanRecord[_fieldIndexByName[pkField]]);

                    pk[pkField] = value;
                }

                return pk;
            }
        }

        return undefined;
    }

    function buildForeignKeyObject(required) {
        var fk = {};

        if (!_parentDataSet) {
            return fk;
        }

        for (var index in _foreingKeyFields) {
            var fkField = _foreingKeyFields[index];

            var fieldName = fkField['localField'];

            var value = self.dataToString(_parentDataSet.getFieldValue(fkField['parentFieldName']));

            if (_isRequiredMembroPK !== false && required === true && (angular.isUndefined(value) || value === '')) {
                if (_parentDataSet.isInsertionMode()) {
                    throw new Error($translate.instant('Dataset.messageSalvarAntesDeIncluir'));
                } else {
                    throw new Error($translate.instant('Dataset.messageSelecioneRegistro'));
                }
            }

            fk[fieldName] = value;
        }

        return fk;
    }

    function cancelPagination() {
        finalizeLoadRecords();
        
        var request = {
            dataSetID: _datasetID
        };

        if (angular.isDefined($scope.workerClass)) {
        	request.workerClass = $scope.workerClass;
        }

        ServiceProxy.callService('DatasetSP.cancelPagination', request);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#beforePostAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método responsável por definir um ação do tipo <i>beforePost</i> no Dataset.
     *  Caso a função retorne <strong>false</strong> o dataset cancelará o save.
     * @param {function} [action=undefined] Caso seja fornecido, será atribuída uma ação do tipo <i>beforePost</i> no Dataset.
     * @example
     * <pre>
     * dataset.beforePostAction(function(dataset) {
     * });
     * </pre>
     */
    function beforePostAction(action) {
    	if (_beforePostAction.indexOf(action) < 0) {
    		_beforePostAction.push(action);
    	}
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#beforeRefreshAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método responsável por definir um ação do tipo <i>beforeRefresh</i> no Dataset.
     *  Caso a função retorne <strong>false</strong> o dataset cancelará o refresh.
     * @param {function} [action=undefined] Caso seja fornecido, será atribuída uma ação do tipo <i>beforeRefresh</i> no Dataset.
     * @example
     * <pre>
     * dataset.beforeRefreshAction(function(dataset) {
     * });
     * </pre>
     */
    function beforeRefreshAction(action) {
        $scope.beforeRefreshAction = action;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#beforeCopyAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método responsável por definir um ação do tipo <i>beforeCopy</i> no Dataset.
     *  Caso a função retorne <strong>false</strong> o dataset cancelará o save.
     * @param {function} [action=undefined] Caso seja fornecido, será atribuída uma ação do tipo <i>beforeCopy</i> no Dataset.
     * @example
     * <pre>
     * beforeCopyAction(function(dataset) {
     * });
     * </pre>
     */
    function beforeCopyAction(action) {
        _beforeCopyAction = action;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#beforeDeleteAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método responsável por definir um ação do tipo <i>beforeDelete</i> no Dataset.
     * @param {function} [action=undefined] Caso seja fornecido, será atribuída uma ação do tipo <i>beforeDelete</i> no Dataset.
     * @example 
     * <pre>
     * dataset.beforeDeleteAction(function(dataset) {
    *       return true; 
     * });
     * </pre>
     */
    function beforeDeleteAction(action) {
        _beforeDeleteAction = action;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#beforeCancelAction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método responsável por definir um ação do tipo <i>beforeCancel</i> no Dataset.
     * @param {function} [action=undefined] Caso seja fornecido, será atribuída uma ação do tipo <i>beforeCancel</i> no Dataset.
     * @example 
     * <pre>
     * dataset.beforeCancelAction(function(dataset) {
    *       return true; 
     * });
     * </pre>
     */
    function beforeCancelAction(action) {
        _beforeCancelAction = action;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#save
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método responsável por salvar o registro corrente, caso tenha sido modificado.
     * @param {boolean} [refreshAllRecords=false] Se verdadeiro, forçará um refresh em todo dataset.
     * @param {function} [afterSave=undefined] Caso seja fornecido, será executado após o save ser realizado
     * @return {Promise} Retorna uma promessa que será executada após o save terminar
     * @example
     * <pre>
     * dataset.save()
     *  .then(function(){
     *      console.log('salvou');
     *  });
     * </pre>
     */
    function save(refreshAllRecords, afterSave, options) {  
        options = angular.extend({}, _defaultOptionsToSave, angular.isObject(options) ? options : {});

        var saveDeferred = $q.defer();

        if (!_recordIsDirty) {
            saveDeferred.reject(DatasetContants.RECORD_IS_NOT_DIRTY);
            return saveDeferred.promise;
        }

        var recordsToSave = [];
        var requestRecords = [];
        var recordByPK = {};
        var promisses = [];

        if (_isInsertionMode) {
            recordsToSave.push(_transientRecord);
        } else if (_multiEditMode) {
            recordsToSave = _selectedRecords.slice(0);
        } else {
            recordsToSave.push(getCurrentRow());
        }

        var processField = function (fieldName, value, recordValues, processedFields) {
            if (!processedFields.hasOwnProperty(fieldName)) {
                processedFields[fieldName] = fieldName;

                var fieldIndex = _fieldIndexByName[fieldName];
                var fieldMD = getFieldMetadataByIndex(fieldIndex);

                if (fieldMD.standAlone && !_standAlone) {
                    return;
                }

                recordValues[String(fieldIndex)] = self.dataToString(value);
            }
        };

        var processedFields = [];
        for (var j in recordsToSave) {
            processedFields[j] = {};

            var recordToSave = recordsToSave[j];

            if (_multiEditMode) {
                recordByPK[buildIdentifier(recordToSave)] = recordToSave;
            }

            var recordValues = {};

            angular.forEach(_programmaticalModifiedValues, function (value, key) {
                processField(key, value, recordValues, processedFields[j]);
            });

            angular.forEach(_modifiedBinders, function (value, key) {
                var data = value.getData({acceptPromise: $scope.acceptPromiseSearchField !== false});
                if(data == null || !angular.isFunction(data.then)) {
                    processField(key, data, recordValues, processedFields[j]);
                } else {
                    var promise = $q.when(data);
                    promisses.push(promise);
                    promise.index = j;

                    promise.then(function(value) {
                        processField(key, value, requestRecords[promise.index].values, processedFields[promise.index]);
                    });
                }

            });

            var requestRecord = {
                pk: isInsertionMode() ? undefined : buildPkObject(recordToSave, false),
                oldPk: (!isInsertionMode() && _allowPKModification) ? buildOldPkObject() : undefined,
                foreignKey: _parentDataSet ? buildForeignKeyObject(true) : undefined,
                values: recordValues
            };

            requestRecords.push(requestRecord);
        }

        $q.all(promisses).then(function(){
            var continueSave = false;

            var temBeforePostAction = _beforePostAction.length > 0;
            if (temBeforePostAction) {
                for (var i = 0; i < _beforePostAction.length; i++) {
                    var _postAction = _beforePostAction[i]

                    if (angular.isFunction(_postAction)) {
                        var beforePostResult = _postAction(self);

                        if (angular.isUndefined(beforePostResult) || beforePostResult === true) {
                            continueSave = true;
                        } else if (beforePostResult === false) {
                            continueSave = false;
                           break;
                        } else {
                            continueSave = beforePostResult;
                        }
                    }
                }
                
                if(!continueSave){
                    saveDeferred.reject();
                    return saveDeferred.promise;
                }
            } else {
                continueSave = true;
            }

             $q.when(continueSave).then(function() {
                if (temBeforePostAction) {
                    //Atualizamos possíveis mudanças realizadas pelo beforePost
                    angular.forEach(requestRecords, function (requestRecord, index) {
                        angular.forEach(_programmaticalModifiedValues, function (value, key) {
                            processField(key, value, requestRecord.values, processedFields[index]);
                        });
                    });    
                }

                var nullFieldNames = [];
                
                if(continueSave){
                    continueSave = validateRecord(recordsToSave[j], nullFieldNames);
                }

                if (!continueSave) {
                    notifyDataSetObservers(DatasetObserverEvents.EVENT_SAVE_AVOID, { nullFieldNames: nullFieldNames });
                    saveDeferred.reject();
                    return saveDeferred.promise;
                }

                var customSave = angular.isDefined($scope.saveHandler);

                var request = {
                    dataSetID: _datasetID,
                    entityName: $scope.entityName,
                    standAlone: _standAlone,
                    fields: getFieldNamesForRequest(customSave),
                    standAloneFieldsMD: getStandAloneFieldsMD(),
                    records: requestRecords
                };

                if (_includePresentationFields) {
                    request.includePresentationFields = true;
                }

                if (_showBlobFields) {
                    request.showBlobFields = true;
                }

                if (angular.isDefined($scope.crudListener)) {
                    request.crudListener = $scope.crudListener;
                }
                
                if (angular.isDefined($scope.workerClass)) {
                	request.workerClass = $scope.workerClass;
                }

                if(isCopyingRecord()){
                   addTXProperty('is.copying.record', true);
                   
                   for (var i = 0; i < _primaryKeyFields.length; i++) {
                       var fieldName = _primaryKeyFields[i];
                       var clonedField = _recordCloned[getFieldIndexByName(fieldName)];

                        if (clonedField instanceof Date) {
                            addTXProperty('copied.record.pk.field:' + fieldName, DateUtils.dateToString(clonedField, DateUtilsConstants.DEFAULT_DATETIME_FORMAT));
                        } else {
                            addTXProperty('copied.record.pk.field:' + fieldName, clonedField);
                        }
                   }
                } 

                putTxPropertiesOnRequest(request);

                var processingAutosave = _processingAutosave;

                var saveServicePromise;

                if (customSave) {
                    if (_multiEditMode) {
                        throw new Error('Edição múltipla ainda não suportada para nesta grade');
                    }

                    saveServicePromise = $q.when($scope.saveHandler({ request: request }));
                } else {
                    if (_standAlone) {
                        saveServicePromise = $q.when(recordsToSave);
                    } else {
                        request.ignoreListenerMethods = getIgnoreListenerMethods();
                        saveServicePromise = ServiceProxy.callService('DatasetSP.save', request);
                    }
                }

                saveServicePromise.then(function (result) {
                    if (refreshAllRecords) {
                        clearEdition();

                        refresh().then(function () {
                            saveDeferred.resolve();
                            (afterSave || angular.noop)();
                        }, saveDeferred.reject);

                        return saveDeferred.promise;
                    }

                    var entities;

                    if (customSave) {
                        if (angular.isDefined(result) && !angular.isArray(result)) {
                            result = ObjectUtils.getProperty(result, 'responseBody.result');
                        }

                        entities = angular.isDefined(result) ? result : recordsToSave;
                    } else {
                        entities = _standAlone ? result : result.responseBody.result;
                    }

                    var isInsertion = isInsertionMode();
                    var currentIndex = getCurrentIndex();
                    var lastInsertedRecord;

                    var changedRecords = [];

                    for (var index in entities) {
                        var newRecord = getRecordAsArray(entities[index], false);

                        newRecord = buildDSRecord(newRecord, isInsertion || isStandAlone());


                        if (isInsertion) {
                            _records.addItem(newRecord);

                            lastInsertedRecord = newRecord;
                        } else if (_multiEditMode && !_pkHistorica) {
                            var identifier = buildIdentifier(newRecord);

                            var oldRecord = recordByPK[identifier];

                            var rowMD = getRowMetadata(oldRecord);

                            angular.copy(newRecord, oldRecord);

                            oldRecord[_fields.length] = rowMD;
                            newRecord[_fields.length] = rowMD;
                        } else {
                            var oldReference = _records.getItem(currentIndex);

                            var rowMD = getRowMetadata(oldReference);

                            if(oldReference){
                                angular.copy(newRecord, oldReference);
                            }else{
                                oldReference=angular.copy(newRecord);
                            }

                            oldReference[_fields.length] = rowMD;
                            newRecord[_fields.length] = rowMD;
                        }

                        changedRecords.push(newRecord);
                    }

                    _records.refresh(options.preventSort, options.preventFilter);

                    var reason;

                    if (lastInsertedRecord) {
                        reason = DatasetEvents.RECORD_CHANGED_REASON_INSERT;

                        currentIndex = _records.indexOf(lastInsertedRecord);

                        if (currentIndex == -1) {
                            currentIndex = _records.length() - 1;
                        }
                    }

                    var isMultEdit = _multiEditMode;

                    clearEdition();

                    if(!_lockChangeRowAutoSave){
                        changeRow(currentIndex, !processingAutosave, !isMultEdit, reason);
                    }else{
                        _lockChangeRowAutoSave = false;
                    }

                    notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SAVED, {
                        isNew: isInsertion,
                        records: changedRecords
                    });

                    (afterSave || angular.noop)();

                    saveDeferred.resolve();
                }, function () {
                    saveDeferred.reject();
                });
            }, function() {
                saveDeferred.reject(); 
            });
        });

        return saveDeferred.promise;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#refreshCurrentRow
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por realizar um reload da linha selecionada.
     * @return {Promise} Retorna uma promessa que será executada após o refresh terminar
     * @example
     * <pre>
     *      dataset.refreshCurrentRow()
     *          .then(function(){
     *              console.log('refresh terminado');
     *          });
     * </pre>
     */
    function refreshCurrentRow(afterRefresh) {
        var deferred = $q.defer();

        var record = getCurrentRow();

        if (angular.isUndefined(record)) {
            deferred.reject();
            return deferred.promise;
        }

        var recordsToReload = ( angular.isUndefined(_selectedRecords) || ( Array.isArray(_selectedRecords) && _selectedRecords.length == 0) ) ? [record] : _selectedRecords;

        var recordByPK = {};

        var pks = [];

        for (var index in recordsToReload) {
            var record = recordsToReload[index];

            pks.push(buildPkObject(record, true));

            recordByPK[buildIdentifier(record)] = record;
        }

        var request = {
            dataSetID: _datasetID,
            entityName: $scope.entityName,
            pks: pks,
            fields: getFieldNamesForRequest(undefined, undefined, true),
            tryJoinedFields: _tryJoinedFields
        };

        if (angular.isDefined($scope.workerClass)) {
        	request.workerClass = $scope.workerClass;
        }

        if (_includePresentationFields) {
            request._includePresentationFields = true;
        }

        if (_showBlobFields) {
            request._showBlobFields = true;
        }

        if (angular.isDefined($scope.crudListener)) {
            request.crudListener = $scope.crudListener;
        }

        request.ignoreListenerMethods = getIgnoreListenerMethods();

        putTxPropertiesOnRequest(request);

        var beforeIndex = getCurrentIndex();

        ServiceProxy.callService('DatasetSP.loadRecord', request)
            .then(function (result) {
                var entities = result.responseBody.result;

                if (entities) {
                    _avoidRefreshDetails = true;

                    try {
                        var newSelectedRecords = [];

                        for (var index in entities) {
                            var newRecord = entities[index];

                            var recordID = buildIdentifier(newRecord);

                            var oldRecord = recordByPK[recordID];

                            delete recordByPK[recordID];

                            var recordIndex = _records.originalIndexOf(oldRecord);

                            if (recordIndex >= 0) {
                                newRecord = buildDSRecord(newRecord, false);
                                updateUniqueId(oldRecord, newRecord);
                                _records.markToReset(newRecord, recordIndex);
                                newSelectedRecords.push(newRecord);
                            }
                        }
                    } finally {
                        _avoidRefreshDetails = false;
                    }

                    for (var recordPk in recordByPK) {
                        beforeIndex = 0;
                        _records.removeItem(recordByPK[recordPk]);
                    }
                    _records.refresh(true, true);

                    if (size() == 0) {
                        beforeIndex = -1;
                    }

                    clearEdition();

                    if (newSelectedRecords.length > 1) {
                        setSelectedRecords(newSelectedRecords);
                        changeRow(beforeIndex, true, false);
                    } else {
                        changeRow(beforeIndex);
                    }

                    if (angular.isDefined(afterRefresh)) {
                        afterRefresh();
                    }

                    deferred.resolve();

                    notifyDataSetObservers(DatasetObserverEvents.EVENT_CURRENT_RECORD_REFRESHED, {
                        records: newSelectedRecords
                    });

                    executePendingActions();

                    _txProperties = undefined;
                }
            },
            function () {
                serviceCallFailureHandler();
            });

        return deferred.promise;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#allowDetailEdition
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável informar se seus filhos poderão iniciar uma edição.
     * @example <pre>dataset.allowDetailEdition();</pre>
     */
    function allowDetailEdition() {
        return !(isInsertionMode() || isRecordDirty());
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#whenMetadataLoaded
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Método que pode ser utilizado para executar um método uma vez, quando houver metadados carregados
     *  ou quando os metadados chegarem.
     * @example <pre>dataset.whenMetadataLoaded()
     *                  .then(function(){
     *                          console.log('loaded')
     *                  });</pre>
     * @returns {promise} Promise que será resolvida instantaneamente quando houverem metadados disponíveis ou quando os metadados chegarem.
     */
    function whenMetadataLoaded() {
        return $q(function (resolve, reject) {
            if (_isMetadataAvailable) {
                resolve();
            } else {
                var destroyHandler = self.addEventListener(DatasetEvents.ON_METADATA_UPDATED, function () {
                    destroyHandler();
                    resolve();
                });
            }
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#copyCurrentRow
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por realizar a cópia do registro selecionado.
     * @return {Promise} Retorna a promessa do registro duplicado
     * @example
     * <pre>
     * dataset.copyCurrentRow()
     *  .then(function(){
     *      dataset
     *          .setFieldValue('CAMPO1', 'A')
     *          .setFieldValue('CAMPO2', 'B'); 
     * });
     *  
     * </pre>
     */
    function copyCurrentRow() {
        var deferred = $q.defer();

        if (!parentAllowDetailEdition()) {
            deferred.reject();
            return deferred.promise;
        }

        if (_canInsert && _canCopy) {
            autoSave().then(function () {
                var currentRow = getCurrentRow();

                if (angular.isDefined(currentRow)) {
                    _copyingRecord = true;

                    if (_beforeCopyAction != null) {
                        if (_beforeCopyAction(this) === false) {
                            return;
                        }
                    }

                    setInsertionMode();

                    var cloned = angular.copy(currentRow);
                    _recordCloned = angular.copy(currentRow);

                    for (var pkIndex in _primaryKeyFields) {
                        var pkField = _primaryKeyFields[pkIndex];

                        if (getFieldMetadata(pkField).isAutoNum) {
                            cloned[_fieldIndexByName[pkField]] = undefined;
                        }
                    }

                    for (var fieldIndex in _fields) {
                        var fieldName = _fields[fieldIndex].name;
                        var value = cloned[fieldIndex];

                        if (angular.isDefined(value)) {
                            setFieldValue(fieldName, value);
                        } else {
                            refreshBinders(fieldName);
                        }
                    }

                    refreshDetails();

                    ArrayUtils.callEachFunctionWith(_afterCopyAction, this);

                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            });
        } else {
            if (!_canCopy) {
                MessageUtils.showAlert(msgControleAcesso, _msgCopy ?? $translate.instant('Dataset.messageNaoPermitidoCopiar'));
            } else {
                MessageUtils.showAlert(msgControleAcesso, $translate.instant('Dataset.messageNaoPermitidoInserir'));
            }

            deferred.reject();
        }

        return deferred.promise;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeCurrentRow
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por realizar a deleção de um registro do dataset.
     * @param {boolean} [unconditionRemove=false] Caso true, a remoção será realizada sem confirmação.
     * @returns {Promise} É retornada uma promessa de quando o registro for removido.
     * @example 
     * <pre>
     * dataset.removeCurrentRow()
     *  .then(function(){
     *      console.log('removido');
     *  });
     * </pre>
     */
    function removeCurrentRow(unconditionalRemove) {
        return $q(function (resolve, reject) {

            if (_canRemove) {
                if (unconditionalRemove) {
                    unconditionalRemoveCurrentRecord().then(resolve, reject);
                } else {
                    var confirmMessage = MessageUtils
                        .simpleConfirmBuilder()
                        .title('Dataset.messageTitleExluir');

                    if (isMultiSelection()) {
                        confirmMessage.msg('Dataset.messageApagarMultiplosRegistros', { count: _selectedRecords.length });
                    } else {
                        confirmMessage.msg('Dataset.messageApagarRegistro');
                    }

                    confirmMessage
                        .okTheme('danger')
                        .okLabel('Dataset.lblSimDeletar');

                    if (_removeRowConfirmInterceptor) {
                        _removeRowConfirmInterceptor(confirmMessage, isMultiSelection() ? _selectedRecords.length : 1);
                    }

                    confirmMessage
                        .show().then(function () {
                            unconditionalRemoveCurrentRecord().then(resolve, reject);
                        }, reject);
                }
            } else {
                reject();
                MessageUtils.showAlert(msgControleAcesso,_msgRemove ?? $translate.instant('Dataset.messageNaoPermitidoRemover'));
            }
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#unconditionalRemoveCurrentRecord
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por realizar a deleção de um registro forçadamente do dataset, mesmo efeito que o "removeCurrentRow(true)".
     * @returns {Promise} É retornada uma promessa de quando o registro for removido.
     * @example 
     * <pre>
     * dataset.unconditionalRemoveCurrentRecord()
     *  .then(function(){
     *      console.log('removido');
     *  });
     * </pre>
     */
    function unconditionalRemoveCurrentRecord() {
        var removePromise = $q.defer();

        if (angular.isFunction(_beforeDeleteAction) && _beforeDeleteAction(self) === false) {
            removePromise.reject();
            return removePromise.promise;
        }

        var record = getCurrentRow();

        if (angular.isUndefined(record)) {
            removePromise.reject();
            return removePromise.promise;
        }

        var recordsToRemove = angular.isUndefined(_selectedRecords) ? [record] : _selectedRecords;

        var pks = [];

        for (var index in recordsToRemove) {
            var record = recordsToRemove[index];

            pks.push(buildPkObject(record, !_standAlone));
        }

        var request = {
            dataSetID: _datasetID,
            entityName: $scope.entityName,
            standAlone: _standAlone,
            pks: pks,
            standAloneFieldsMD: getStandAloneFieldsMD()
        };

        if (angular.isDefined($scope.crudListener)) {
            request.crudListener = $scope.crudListener;
        }
        
        if (angular.isDefined($scope.workerClass)) {
        	request.workerClass = $scope.workerClass;
        }

        putTxPropertiesOnRequest(request);

        var servicePromise;

        if ($scope.removeHandler) {
            servicePromise = $q.when($scope.removeHandler({ request: request }));
        } else {
            if (_standAlone) {
                servicePromise = $q.when(undefined);
            } else {
                request.ignoreListenerMethods = getIgnoreListenerMethods();
                servicePromise = ServiceProxy.callService('DatasetSP.removeRecord', request);
            }
        }

        servicePromise
            .then(function (result) {
                afterRemoveRows(recordsToRemove, removePromise, result);
            },
            function () {
                serviceCallFailureHandler(removePromise);
            });

        return removePromise.promise;
    }

    function afterRemoveRows(recordsToRemove, removePromise) {
        var beforeIndex = getCurrentIndex();

        for (var index in recordsToRemove) {
            var removedRecord = recordsToRemove[index];
            _records.removeItem(removedRecord);
            
            let removeUniqueId = recordsToRemove[index][recordsToRemove[index].length - 1].rowID;
            _rowsByUniqueID = _rowsByUniqueID.filter((row) => row[row.length - 1].rowID != removeUniqueId);
        }

        _records.refresh();

        if (size() == 0) {
            beforeIndex = -1;
        }

        clearEdition();

        changeRow(Math.min(beforeIndex, size() - 1), undefined, undefined, DatasetEvents.LINE_CHANGE_BY_RECORD_REMOVED);

        executePendingActions();

        notifyDataSetObservers(DatasetObserverEvents.EVENT_RECORD_REMOVED, {
            recordReference: recordsToRemove[0],
            allReferences: recordsToRemove
        });

        _txProperties = undefined;

        removePromise.resolve();
    }

    function parentAllowDetailEdition() {
        if (angular.isDefined(_parentDataSet) && !_parentDataSet.allowDetailEdition()) {
        	debouncedShowAlertFormAltNaoSalvas();
            return false;
        }

        return true;
    }
    
    function showAlertFormAltNaoSalvas() {
    	MessageUtils.showAlert(MessageUtils.TITLE_WARNING, (i18n('Geral.lblAvisoSalvar')));
    }

    function getFieldNamesForRequest(includeStandAloneFields, ignoreDescriptionFields, ignoreTransientFields) {
        var requestFields = [];

        for (var index in _fields) {
            var field = _fields[index];

            if ( (field.standAlone && !(includeStandAloneFields === true)) || (field.isDescriptionField && ignoreDescriptionFields) || (field.hasTransient && ignoreTransientFields)) {
                continue;
            }

            requestFields.push(field.name);
        }

        return requestFields;
    }

    function getStandAloneFieldsMD() {
        if (_userFieldsMetadata.length > 0 || _transientFieldsName.length > 0) {
            var standAloneMDs = {};

            _userFieldsMetadata.forEach(function (userFieldMD) {
                var fieldMD = getFieldMetadata(userFieldMD.name);
                standAloneMDs[userFieldMD.name] = {
                    fieldType: fieldMD.dataType,
                    userType: fieldMD.userType
                };
            });
            
            _transientFieldsName.forEach(function (name) {
                var fieldMD = getFieldMetadata(name);
                standAloneMDs[name] = {
                    fieldType: fieldMD.dataType,
                    userType: fieldMD.userType
                };
            });

            return standAloneMDs;
        }

        return undefined;
    }

    function refreshDetails() {
        if (_avoidRefreshDetails) {
            return;
        }

        for (var index in _detailDataSets) {
            var detail = _detailDataSets[index];

            if (detail.getListenToParentRefreshRequest()) {
                detail.refresh();
            }
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#clearDataSet
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável resetar o dataset.
     * @param {Criteria} [fastCriteria=undefined] {@link util.common:Criteria} a ser utilizado na busca.
     * @param {Object} [pkToFind=undefined] Caso seja fornecido, após a carga dos registros o dataset procurará por um registro com a pk fornecida e caso encontre o posicionará nele.
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example <pre>dataset.clearDataSet();</pre>
     */
    function clearDataSet() {
        _records.clear();
        clearEdition();
        changeRow(-1);
        notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SET_CLEARED);
        return self;
    }


    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#refresh
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por iniciar uma requisição de busca de registros.
     * @param {Criteria} [fastCriteria=undefined] {@link util.common:Criteria} a ser utilizado na busca.
     * @param {Object} [pkToFind=undefined] Caso seja fornecido, após a carga dos registros o dataset procurará por um registro com a pk fornecida e caso encontre o posicionará nele.
     * @return {Promise} Retorna uma promise de quando o refresh for concluído.
     * @example 
     * <pre>
     * dataset.refresh()
     *  .then(function(){
     *      console.log('refreshed');
     *  });
     * </pre>
     */
    function refresh(fastCriteria, pkToFind, options) {
        var refreshDefer = $q.defer();

        autoSave().then(function () {
            if (!isLoaded()) {
                addFunctionToQueue(function () {
                    var defer = refresh(fastCriteria, pkToFind, options);

                    AngularUtil.syncPromise(defer, refreshDefer);
                });

                return refreshDefer.promise;
            }

            if (angular.isDefined($scope.beforeRefreshAction)) {
                if ($scope.beforeRefreshAction() === false) {
                    refreshDefer.reject();
                    return refreshDefer.promise;
                }
            }

            // Se esta instancia eh filha e o pai nao tem registro corrente,
            // limpa os dados e retorna sem chamar o servico.
            if (angular.isDefined(_parentDataSet) && (_parentDataSet.isInsertionMode() || _parentDataSet.getCurrentIndex() < 0 || _parentDataSet.isEmpty() || !fkIsFilled())) {
                clearDataSet();
                executePendingActions();
                refreshDefer.reject();
                return refreshDefer.promise;
            }

            var customRefresh = angular.isDefined($scope.refreshHandler);

            var refreshRequest = buildRefreshRequest(customRefresh, options);

            //var variableParameters = [];
            var requestExpression = '';
            var requestParameters = [];
            var criteriaToUse = $scope.filterCriteria;
            var useCriteriaProviders = true;
            var keepCriteriaProviders = options && options.keepCriteriaProviders;

            // Caso haja criterios de filtro, monta o elemento correspondente.
            if (angular.isDefined(fastCriteria)) {
                criteriaToUse = fastCriteria;
                useCriteriaProviders = keepCriteriaProviders || false;
            }

            var doRequest = function () {
                //Em alguns casos o refreshHandler não é resolvido, fazendo com que o uniqueId fique inválido para a nova grade
               //nesse caso chamaremos o resetUniqueIDCache só depois que o refreshHandler for resolvido no doRefresh.
                if(!$scope.refreshHandler){
                    resetUniqueIDCache();
                }

                
                var userTypeToParameterType = function (userType) {
                    switch (userType) {
                        case 'I':
                        case 'N':
                        case 'F':
                            return CriteriaParameter.TYPE_NUMBER;
                        case 'D':
                        case 'H':
                            return CriteriaParameter.TYPE_DATE;
                        default:
                            return CriteriaParameter.TYPE_STRING;
                    }
                };

                if (_foreingKeyFields.length > 0 && angular.isDefined(_parentDataSet)) {
					
					var allFkDefined = true;
					for (var index in _foreingKeyFields) {
                        var fkField = _foreingKeyFields[index];
                        
                        if(!angular.isDefined(_parentDataSet.getFieldValue(fkField.parentFieldName))) {
							allFkDefined = false;
							break;
						}
					}					

					if (allFkDefined) {
	                    for (var index in _foreingKeyFields) {
	                        var fkField = _foreingKeyFields[index];
	
	                        var parentFieldValue = self.dataToString(_parentDataSet.getFieldValue(fkField.parentFieldName));
	
	                        var localField = fkField['localField'];
	
	                        if (requestExpression.length > 0) {
	                            requestExpression += ' AND ';
	                        }
	
	                        var localFieldMD = getFieldMetadata(localField);
	
	                        if (!localFieldMD) {
	                            throw new Error('Metadados não encontrados para o campo: ' + localField);
	                        }
	                        
	                        if(localFieldMD.userType == 'D') {
	                            requestExpression += ' (' + localField + ' = onlydate(?)) ';
	                        } else {
	                            requestExpression += ' (' + localField + ' = ?) ';
	                        }
	
	                        requestParameters.push({
	                            type: userTypeToParameterType(localFieldMD.userType),
	                            value: parentFieldValue
	                        });
	                    }
                    }
                }

                if ($scope.lazyLoad && !hasPersonalizedFilter(requestExpression)) {
                    if (!_initDatasetLazyLoad) {
                        setInitDatasetLazyLoad(true);
                    }

                    loadParentPropertyName();

                    if (angular.isDefined(_parentPropertyName)) {
                        var fieldMd = getFieldMetadata(_parentPropertyName);
                        requestExpression = requestExpression.length > 0 ? `${requestExpression} AND ` : '';
                        requestExpression = `(${requestExpression}(${_localPropertyName} != 0) AND (${_parentPropertyName} IS NULL OR ${_parentPropertyName} = 0 OR ${_parentPropertyName} <= ?))`;

                        requestParameters.push({
                            type: userTypeToParameterType(fieldMd.dataType),
                            value: ROOT_KEY_VALUE
                        });

                        refreshRequest['orderByExpression'] = 'this.' + (_localPathHierarchy ? _localPathHierarchy : _localPropertyName);

                    } else {
                            setInitDatasetLazyLoad(false);
                    }
                } else {
                    setInitDatasetLazyLoad(false);
                }

                if (requestExpression.length > 0) {

                    refreshRequest.criteria = {
                        expression: requestExpression,
                        parameters: requestParameters
                    };
                }

                var defer = doRefresh(refreshRequest, pkToFind, options);

                AngularUtil.syncPromise(defer, refreshDefer);
            };

            if (angular.isDefined(criteriaToUse) || _criteriaProviders.length > 0) {

                var hasNullParameters = false;

                var appendCriteria = function (criteria) {
                    if (angular.isDefined(criteria)) {
                        var thisCriteriaExpression = criteria.getExpression();

                        if (angular.isDefined(thisCriteriaExpression) && thisCriteriaExpression.length > 0) {
                            if (requestExpression.length > 0) {
                                requestExpression += " AND ";
                            }

                            requestExpression += "(" + thisCriteriaExpression + ")";

                            criteria.getParameters().forEach(function (param) {

                                var i = requestParameters.length;

                                /*if (param instanceof VariableCriteriaParameter) {
                                 variableParameters.push({
                                 index: i,
                                 param: param,
                                 pro
                                 });
                                 }*/

                                if (!angular.isDefined(param.value) || param.value === '') {
                                    hasNullParameters = true;
                                }

                                var paramObj = {
                                    type: param.type,
                                    value: param.value
                                };

                                requestParameters[i] = paramObj;
                            });
                        }
                    }
                };

                if (angular.isDefined(criteriaToUse)) {
                    appendCriteria(criteriaToUse);
                }

                if (useCriteriaProviders) {
                    var criteriaPromises = [];

                    _criteriaProviders.forEach(function (criteriaProvider) {
                        var criteria = criteriaProvider.getCriteria(_datasetID);
                        if (angular.isDefined(criteria)) {
                            var criteriaPromise = $q.when(criteria);
                            criteriaPromises.push(criteriaPromise);
                        }
                    });

                    Promise.allSettled(criteriaPromises)
                        .then(function (resolvedCriterias) {
							self.cancelRefresh = false;
							if(resolvedCriterias.some(e => e.status === 'rejected')){
								self.cancelRefresh = true;
							} else {
								resolvedCriterias.forEach(function (resolvedCriteria) {
	                                if(resolvedCriteria.status == "fulfilled"){
	                                    appendCriteria(resolvedCriteria.value);
	                                }
	                            });	
							}
                        })
                        .finally(() => {
							if(!self.cancelRefresh){
								doRequest()
							}
						});
                } else {
                    doRequest();
                }
            } else {
                doRequest();
            }
        });

        return refreshDefer.promise;
    }

    function hasPersonalizedFilter(requestExpression) {
        return requestExpression.includes('HAS_PERSONALIZED_FILTER');
    }
    
    function recordAlreadyExists(recordToCheck) {
        var pkName = getPrimaryKeys()[0];
        var pkFieldIndex = getFieldIndexByName(pkName);
        var records = getRecords();
        var exists = false;
    
        for (var i = 0; i < records.length; i++) {
            var record = records[i];
            if (record[pkFieldIndex] === recordToCheck[pkFieldIndex]) {
                exists = true;
                break;
            }
        }
    
        return exists;
    }
    

    function standardizeHierarchyRecords(fields, nonHierarchy = false){
        
        let standardizedFields = [];
        let buildDSRecordFrom = [];

        ObjectUtils.forEachInObject(fields, (key, value) => {
            if(typeof value  === 'object'){
                let standardizedNode = standardizeHierarchyRecords(value, nonHierarchy);

                standardizedFields.push(standardizedNode);

            } else {
                if(value === '-'){
                    standardizedFields.push('');
                    buildDSRecordFrom.push('');
                } else {
                    standardizedFields.push(value);
                    buildDSRecordFrom.push(value);
                }
            }
        })

        _nonHierarchyRecords.push(buildDSRecord(buildDSRecordFrom));
        
        if(!recordAlreadyExists(buildDSRecord(buildDSRecordFrom))){
            _records.addItem(buildDSRecord(buildDSRecordFrom));
            _records.refresh();
        }

        if(nonHierarchy){
            return _nonHierarchyRecords;
        } else {
            return standardizedFields;
        }
    }

    function buildHierarchyExpression(value){
        let expression = '';

        _primaryKeyFields.forEach(pkField => {
            if(expression == ''){
                expression = 'UPPER(' + pkField + ") LIKE UPPER('%" + value + "%') ";
            } else {
                expression = expression + "OR UPPER(" + pkField +") LIKE UPPER('%" + value + "%') ";
            }
        });

        //cenario onde preciso considerar mais campos na busca
        if(ArrayUtils.isNotEmpty(fieldsToAddExpression)){
            fieldsToAddExpression.forEach(field => {
                expression = expression + "OR UPPER(" + field + ") LIKE UPPER('%" + value + "%')";
             })
        }

        expression = expression + "OR UPPER(" + _entityPresentationFieldName + ") LIKE UPPER('%" + value + "%')";

        if(typeof self.hierarchyCriteriaFunction === 'function' && StringUtils.isNotEmpty(self.hierarchyCriteriaFunction())){
            expression = "(" + self.hierarchyCriteriaFunction() + ") and (" + expression + ")";
        }

        return expression;
    }

    function getRecordAndHierarchy(searchTerm){

        var defer = $q.defer();
        
        if(!searchTerm){
            return;
        }

        let request = {
            entityName: getEntityName(),
            childName: _primaryKeyFields[0],
            fatherName: _parentPropertyName || _alternativeParentPropertyName,
            expression: buildHierarchyExpression(searchTerm),
            fields: getFieldNamesForRequest()
        }

        var promiseHierarchy = ServiceProxy.callService('DatasetSP.getParametrosComoEstrutura', request);

        AngularUtil.syncPromise(promiseHierarchy, defer);

        promiseHierarchy.then( result => {
            let response = result.responseBody
            let treeStructure = undefined;

            if(result.responseBody.result){
                _nonHierarchyRecords = [];
                treeStructure = standardizeHierarchyRecords(result.responseBody.result.node)
            }

            response.result = treeStructure;

            return response.result;

        }, function () {
            serviceCallFailureHandler();
        });

        return defer.promise;
    }

    function loadRecordsByLevel(item){

        if(!item){
            return;
        }
        
        /* validação necessária para que exista comunicação entre o dataset
         * e os componentes que utilizam das função beforeRefreshAction, mantendo
         * as variáveis no mesmo estado
         * */
        if ($scope.beforeRefreshAction && $scope.beforeRefreshAction() == false) {
            return
        }

        var refreshDefer = $q.defer();

        var request = buildRefreshRequest();
        
        // necessário para garantir que seja inserida as properties
        putTxPropertiesOnRequest(request);

        var requestParameters = [];

        var expression = '( ' + _parentPropertyName + ' = ?)';
    
        requestParameters.push({
            type: 'N',
            value: item
        });

        request.criteria = {
            expression: expression,
            parameters: requestParameters
        };

        request['orderByExpression'] = 'this.' + (_localPathHierarchy ? _localPathHierarchy : _localPropertyName);
        //setOrderByExpression('this.' + _parentPropertyName);
		if (isStandAlone() && $scope.refreshHandler){
            _lastPromiseForLoadRecords = $q.when($scope.refreshHandler({ request: {chave: item} }));
		} else {
            _lastPromiseForLoadRecords = ServiceProxy.callService('DatasetSP.loadRecords', request, {aditionalUrlParameters: {'allowConcurrentCalls': 'true'}});
		}

        AngularUtil.syncPromise(_lastPromiseForLoadRecords, refreshDefer);

        _lastPromiseForLoadRecords.then(function (result) {
            var response = result.responseBody;
            
            if (angular.isArray(response.result)) {

                var recordsLength = _records.length();

                for (var i = 0; i < response.result.length; i++) {
                    var record = response.result[i];
                    if(!recordAlreadyExists(buildDSRecord(record))){                        
                        _records.addItem(buildDSRecord(record));
                    }
                }

                _records.refresh();
            }

            var recordsArray = _records.getOriginalRecords();

            response.result = recordsArray.slice(recordsLength);

            return response.result;

        }, function () {
            serviceCallFailureHandler();
        });
    
        return refreshDefer.promise;
    }

    function buildRefreshRequest(customRefresh, options){
        var refreshRequest = {
            dataSetID: _datasetID,
            entityName: $scope.entityName,
            standAlone: _standAlone,
            orderByExpression: $scope.orderByExpression,
            fields: getFieldNamesForRequest(customRefresh || _userFieldsMetadata.length > 0 || _transientFieldsName.length > 0),
            standAloneFieldsMD: getStandAloneFieldsMD(),
            tryJoinedFields: _tryJoinedFields
        };

        if (!customRefresh) {
            refreshRequest.parallelLoader = _parallelLoader;
        }

        if (angular.isDefined(_parentDataSet)) {
            refreshRequest.parentEntityName = _parentDataSet.getEntityName();
        }

        if (angular.isDefined($scope.crudListener)) {
            refreshRequest.crudListener = $scope.crudListener;
        }

        if (angular.isDefined($scope.workerClass)) {
            refreshRequest.workerClass = $scope.workerClass;
        }

        if (angular.isDefined(options)) {
            if (angular.isDefined(options.finderInterceptors)) {
                refreshRequest.finderInterceptors = options.finderInterceptors;
            }
        }

        return refreshRequest;

    }

    function saveCriteria(id, criteria, criteriaParsed) {
        var encoded = criteriaParsed ? Base64.encode(JSON.stringify(criteriaParsed)) : '';

        addTXProperty('ConfigToSaveAt:' + id, encoded);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addTXProperty
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma propriedade que será enviada ao servidor nas requisições do dataset.
     * @param {String} propName Nome da propriedade
     * @param {String} propValue Valor da propriedade
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example 
     * <pre>
     * dataset
     *  .addTXProperty('prop1', 'value1')
     *  .addTXProperty('prop2', 'value2')
     *  
     * </pre>
     */
    function addTXProperty(propName, propValue) {
        if (StringUtils.isNotEmpty(propName) && StringUtils.isNotEmpty(propValue)) {
            if (!_txProperties) {
                _txProperties = {};
            }

            _txProperties[propName] = propValue;
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeTXProperty
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por remover uma propriedade de requisição.
     * @param {String} propName Nome da propriedade
     * @return {Dataset} Retorna o próprio dataset para encadeamento.
     * @example 
     * <pre>
     * dataset
     *  .removeTXProperty('prop1')
     *  .removeTXProperty('prop2')
     *  
     * </pre>
     */
    function removeTXProperty(propName) {
        if (_txProperties && StringUtils.isNotEmpty(propName)) {
            delete _txProperties[propName];
        }
    }

    function putTxPropertiesOnRequest(request) {
        if (angular.isDefined(_txProperties)) {
            request.txProperties = angular.copy(_txProperties);
        }
    }

    function resetRecords() {
        _records.clear();
        _currentIndex = -1;
        
        /* Ao resetar os records, é necessário resetar o ID para que na construção novamente da grade o rowId não 
        continue incrementando. Devido ao incremento estava ocorrendo um erro na pesquisa que tava construindo as 
        rows com ID's que não existiam na hora de selectedDataGrid dentro do pesquisacontent.controller.js */
        resetUniqueIDCache();
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addRecordsAsObjects
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar registros no dataset.
     * @param {Array} records Array de objetos, com os nomes de campo esperados pelo Dataset.
     * @param {function} [valueInterceptor=undefined] Função que poderá ser passada para transformar o valor do campo.
     * @example
     * <pre>
     * dataset.addRecords([
     *	{campo1: {$: 'valor1'}, campo2: {$: 'valor2'}}
     * ], function(value, fieldMd) {
     * 	return value.$; 
     * });
     * </pre>
     */
  function addRecordsAsObjects(records, valueInterceptor, standAloneFields, params) {
        if (!angular.isArray(records)) {
            records = [records];
        }

        records.forEach(function (objRow) {
            var arrRow = [];
			var getFieldMtdata = getFieldsMetadata();

		    if (standAloneFields === true) {
				getFieldMtdata = getUserFieldsMetadata();
		    }

		    (getFieldMtdata || []).forEach(function(field) {
                var value = objRow ? objRow[field.name] : null;

                if (valueInterceptor) {
                    value = valueInterceptor(value, angular.copy(field));
                }

                arrRow.push(value);
            });

            if(_keepMetadataWhileConverting && objRow && objRow['_rmd']){
                arrRow[arrRow.length] = objRow ? objRow['_rmd'] : null;
            }

			_records.addItem(buildDSRecord(arrRow, undefined, standAloneFields));
        });

        _records.refresh();

        if(!params || params.prevent != true){
            self.dispatchEvent(DatasetEvents.ADD_RECORDS_AS_OBJECT_END);
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addRecords
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar registros no dataset.
     * @param {Array} records Array de arrays, na ordem esperada pelo Dataset.
     * @example
     * <pre>
     * dataset.addRecords([
     *	['valor1', 'valor2'],
     *	['valor3', 'valor4']
     * ]);
     * </pre>
     */
    function addRecords(records) {
        if (!angular.isArray(records)) {
            records = [records];
        }

        records.forEach(function (record) {
            _records.addItem(buildDSRecord(record));
        });

        _records.refresh();

        self.dispatchEvent(DatasetEvents.ADD_RECORDS_AS_ARRAY_END);
    }

    function resetUniqueIDCache() {
        _rowUniqueID = 0;
        _rowsByUniqueID = [];
    }

    function getRecordAsArray(record, parseTypedData) {
        if (angular.isUndefined(record)) {
            return undefined;
        } else if (angular.isArray(record)) {
            return record;
        } else if (angular.isObject(record)) {
            var recordAsArr = [];

            for (var index = 0; index < _fields.length; index++) {
                var fieldMD = _fields[index];
                var value = record[fieldMD.name];

                //Essa tratativa existe para utilização do standalone e outros apartir de 1 serviço antigo que trabalha com XML
                if (angular.isObject(value) && value.hasOwnProperty('$')) {
                    value = value['$'];
                }

                if (angular.isUndefined(parseTypedData) || parseTypedData === true) {
                    value = strToTypedData(record[fieldMD.name], fieldMD.dataType);
                }

                recordAsArr.push(value);
            }

            return recordAsArr;
        } else if (!angular.isArray(record)) {
            throw new Error('Registro do dataset deve ser um objeto ou array');
        }
    }

    function doRefresh(request, pkToFind, options = {}) {
        var refreshDefer = $q.defer();

        abortLastPromiseForLoadRecords();

        putTxPropertiesOnRequest(request);

        request.dataSetID = _datasetID;

        if (angular.isDefined($scope.workerClass)) {
        	request.workerClass = $scope.workerClass;
        }

        // Itera através dos filtros removendo-os do ultimo para o primeiro
        for (let i = _filterFunctionsToRemoveOnRefresh.length - 1; i >= 0; i--) {
            // Chama a função
            _filterFunctionsToRemoveOnRefresh[i]();
            
            // Remove a função do array
            _filterFunctionsToRemoveOnRefresh.splice(i, 1);            
        }

        if ($scope.refreshHandler) {
            _lastPromiseForLoadRecords = $q.when($scope.refreshHandler({ request: request }));

            AngularUtil.syncPromise(_lastPromiseForLoadRecords, refreshDefer);

            _lastPromiseForLoadRecords.then(function (result) {
                let _result = angular.copy(result);
                resetUniqueIDCache();
                if (angular.isDefined(_result) && !angular.isArray(_result)) {
                    _result = ObjectUtils.getProperty(_result, 'responseBody.result');
                }

                _records.clear();

                if (angular.isArray(_result)) {
                    for (var i = 0; i < _result.length; i++) {
                        var record = getRecordAsArray(_result[i], false);
                        _records.addItem(buildDSRecord(record));
                    }

                    _records.refresh();

                    finalizeLoadRecords(pkToFind);

                    if ($scope.selectFirstOnRefresh == false) {
                        gotoRow(-1)
                           .then(refreshDefer.resolve, refreshDefer.reject);
                    } else if (_records.length() > 0) {
                       gotoRow(0)
                           .then(refreshDefer.resolve, refreshDefer.reject);
                   } else {
                       refreshDefer.resolve();
                   }
                }
            }, function (error) {
                refreshDefer.reject();
            });
        } else if (request.entityName != "StandAloneEntity") {
            request.ignoreListenerMethods = getIgnoreListenerMethods();
            request.useDefaultRowsLimit = $scope.useDefaultRowsLimit != undefined ? $scope.useDefaultRowsLimit : true;
			_lastPromiseForLoadRecords = ServiceProxy.callService('DatasetSP.loadRecords', request, {aditionalUrlParameters: {'allowConcurrentCalls': 'true'}, ignoreLoadingBar: options.ignoreLoadingBar});

            AngularUtil.syncPromise(_lastPromiseForLoadRecords, refreshDefer);

            _lastPromiseForLoadRecords.then(function (result) {
                try {
                    var response = result.responseBody;

                    var isFirstLoad = !request.hasOwnProperty('pagerID');

                    if (isFirstLoad) {
                        resetRecords();
                        request.pageNumber = 2;
                        request.totalRecordsCount = 0;
                    } else {
                        request.pageNumber = parseInt(request.pageNumber) + 1;
                    }

                    request.totalRecordsCount += parseInt(response.total);

                    var onlyFirstPage = (options && options.onlyFirstPage);

                    options.ignoreLoadingBar = request.pageNumber > 2;

                    if (response.pagerID && !onlyFirstPage) {
                        _pageRefreshing = true;
                        request.pagerID = response.pagerID;
                        if (isFirstLoad) {
                            self.dispatchEvent(DatasetEvents.BACKGROUND_LOAD_START);
                        }

                        let aksRowsLimit = parseInt(response.askRowsLimit);
                        
                        if(aksRowsLimit > 0 && request.totalRecordsCount >= aksRowsLimit && !request.choiceLoadAll){
                            
                            MessageUtils.simpleConfirmOptionApplyForAll(MessageUtils.TITLE_WARNING, 
                                                                        "teste", 
                                                                        undefined, 
                                                                        undefined, 
                                                                        {   focusOnButton: 'ok',
                                                                            fnGetTpl : () => {
                                                                                var template =  StringUtils.newBuffer();
                                                                                template.append('<table>');
                                                                                
                                                                                template.append('   <tr><td>')
                                                                                .append("Uma quantidade muito grande de registros está sendo carregada. Recomendamos que a paginação seja cancelada ")
                                                                                .append("e que seja criado um filtro para os registros. <br><b>Deseja cancelar o carregamento?</b></br>")
                                                                                .append(' <tr><td><p></p></td></tr> ');
                                                                                
                                                                                template.append('   <tr><td>');
                                                                                template.append('      <sk-checkbox ng-model="indeterminate"> Carregar tudo </sk-checkbox>');
                                                                                template.append('   </td></tr>');
                                                                                template.append('</table>');
                                                                                    
                                                                                return template.toString();
                                                                            }
                                                                        })
                            .then( () => {
                                cancelPagination();
                            }, result => {
                                request.choiceLoadAll = result;
                                doRefresh(request, pkToFind, options);
                            });

                            request.totalRecordsCount = 0;
                        }else{
                            doRefresh(request, pkToFind, options);
                        }
                    }

                    if (angular.isArray(response.result)) {
                        for (var i = 0; i < response.result.length; i++) {
                            var record = response.result[i];
                            _records.addItem(buildDSRecord(record));
                        }

                        _records.refresh(response.pagerID ? true : false);
                    }

                    if (response.pagerID) {
                        if (isFirstLoad) {
                            if ($scope.selectFirstOnRefresh == false) {
                                gotoRow(-1);
                            } else {
                                if(angular.isUndefined(pkToFind)){
                                	gotoRow(0);
                                }
                            }
                        }

                        self.dispatchEvent(DatasetEvents.BACKGROUND_LOAD, {
                            pageNumber: String(request.pageNumber)
                        });
                    } else {
                        if (_pageRefreshing) {
                            finalizeLoadRecords(pkToFind);
                        } else {
                            updateRecordsCollection(DatasetEvents.REFRESH_REASON_RESET, pkToFind);
                        }
                    }

                    if (isEmpty()) {
                        autoInsert();
                    }
                } catch (error) {
                    _pageRefreshing = false;
                    throw error;
                }
            }, function () {
                serviceCallFailureHandler();
            });
        } else {
        	refreshDefer.resolve();
        }

        return refreshDefer.promise;
    }

    function buildStandAloneRecord(record) {
        var dsRecord = [];

        for (var index = 0; index < _fields.length; index++) {
            var fieldMD = _fields[index];
            
            var value = record[index];
            
            if (value == null) {	
            	value = undefined;
            } else if (angular.isDefined(value) && fieldMD.dataType != 'S' && angular.isString(value)) {
            	value = strToTypedData(value, fieldMD.dataType);
            } 
            
            dsRecord[fieldMD.name] = value;
        }

        addMetadataToRecord(dsRecord);
        
        return dsRecord;
    }

	function buildDSRecord(record, addMetadata, standAloneFields) {
        var dsRecord = [];

		if (standAloneFields === true) {
		  _fields = _userFieldsMetadata;
        }
        
        let rmd;

        // Este IF previne um erro de estourar UNDEFINED que não foi possivel simular (erro acontecia esporadicamente)
        // A variável _fields provavelmente estava chegando undefined, visto que era erro de Undefined na propriedade '_fields.length'
        // OS do erro em questão: 3947230
        if(angular.isArray(_fields) && record){
            for (var index = 0; index < _fields.length; index++) {
                var fieldMD = _fields[index];
                
                var value = record[index];
    
                if(angular.isObject(value) && value.hasOwnProperty('_rmd')){
                    rmd = value;
                    value = undefined;
                }
                
                if (value == null) {	
                    value = undefined;
                } else if (angular.isDefined(value) && fieldMD.dataType != 'S' && angular.isString(value)) {
                    value = strToTypedData(value, fieldMD.dataType);
                } 
                
                dsRecord[index] = value;
            }
    
            if(record.length > _fields.length){
                rmd = record[record.length - 1];            
            }
    
            if (addMetadata === undefined || addMetadata) {
                addMetadataToRecord(dsRecord, rmd);
            }else if(rmd){
                addMetadataToRecord(dsRecord, rmd, true);
            }
        }

        return dsRecord;
    }

    function addMetadataToRecord(record, rmd, onlyRmd = false) {
        if(onlyRmd){
            if(!rmd) return;

            if(!record[_fields.length]){
                record[_fields.length] = { rmd:  undefined };  
            }
            
            if(rmd && angular.isObject(rmd)){
                record[_fields.length].rmd =  rmd['_rmd'];
            }
            
        }else{
            var md = {
                rowID: _rowUniqueID
            };

            if(rmd && angular.isObject(rmd)){
                md['rmd'] = rmd['_rmd']; 
            }

            record[_fields.length] = md;

            _rowsByUniqueID[_rowUniqueID] = record;
            _rowUniqueID++;
        }
    }

    function serviceCallFailureHandler(promise) {
        _pageRefreshing = false;
        _pendingActions = [];
        _txProperties = undefined;
        finalizeLoadRecords(undefined, true);

        if (promise) {
            promise.reject();
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#sortRecords
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável realizar a ordenação do dataset programaticamente.
     * @example <pre>dataset.sortRecords();</pre>
     */
    function sortRecords() {
        if (!_isInsertionMode) {
            updateRecordsCollection(DatasetEvents.REFRESH_REASON_SORT);
        }
    }

    function filterRecords(forceCopy) {
        updateRecordsCollection(DatasetEvents.REFRESH_REASON_FILTER, undefined, undefined, {forceCopy: forceCopy});
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRowMetadata
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável retornar o objeto de metadados da linha
     * @param {object} row linha que contem os metadados.
     * @param {string} prop propriedade que queremos dos metadados, se undefined, retorna todas.
     * @example <pre>dataset.getRowMetadata();</pre>
     */
    function getRowMetadata(row, prop) {
        if(!row){
            row = getCurrentRow();
            if(!row) return;
        }
        
        if(prop){
            if(row[_fields.length] && row[_fields.length]['rmd']){
                return getProp(row[_fields.length]['rmd'], prop);
            }else{
                return undefined;
            }
        }else{
            return row[_fields.length];
        }
    }

    function getProp(objParam, key){
        if(objParam == undefined || key == undefined){
            return undefined;
        }
        var obj = objParam;
        var pos = key.indexOf(".");
        if(pos > -1){
            obj = obj[key.substr(0, pos)];
            key = key.substr(pos + 1);
            if(obj){
                return getProp(obj, key);
            }else if(objParam[key] != undefined){
                return objParam[key];
            }
        }
        return obj[key];
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getParentDataset
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna o parentDataset
     * @example <pre>dataset.getParentDataset();</pre>
     */
    function getParentDataset() {
        return _parentDataSet;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getParentEntityName
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna o nome da entidade do parentDataset, se houver
     * @example <pre>dataset.getParentEntityName();</pre>
     */
    function getParentEntityName() {
        return _parentDataSet ? _parentDataSet.getEntityName() : undefined;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getForeignKeyFields
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *  Retorna os campos que são foreign key entre este dataset e seu parent
     * @example <pre>dataset.getForeignKeyFields();</pre>
     */
    function getForeignKeyFields() {
        return _foreingKeyFields;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getCurrentRow
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável disponibilizar o registro atual
     * @example <pre>dataset.getCurrentRow();</pre>
     */
    function getCurrentRow() {
        if (_isInsertionMode || _multiEditMode) {
            return _transientRecord;
        }

        var index = getCurrentIndex();

        if (size() == 0 || index < 0 || index >= size()) {
            return undefined;
        }

        return _records.getItem(index);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getCurrentRowAsObject
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável disponibilizar o registro atual em forma de objeto
     * @param {array|string} fields Array ou String com separação por virgulas.
     * Se passado, será usado como base para criação da linha, assim não montando uma copia completa da linha atual.
     * Cada item fieldName poderá ser exportado com outro nome, basta seguir o seguinte padrão fieldName:exportName
     * @example <pre>dataset.getCurrentRowAsObject('CODPARC:CODIGO');</pre>
     */
    function getCurrentRowAsObject(fields) {
        return getRowAsObject(getCurrentRow(), fields);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRowAsObject
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável converter um registro em forma de array para forma de objeto
     * @param {array|string} fields Array ou String com separação por virgulas.
     * Se passado, será usado como base para criação da linha, assim não montando uma copia completa da linha atual.
     * Cada item fieldName poderá ser exportado com outro nome, basta seguir o seguinte padrão fieldName:exportName
     * @example <pre>dataset.getRowAsObject([1], 'CODPARC:CODIGO');</pre>
     */
    function getRowAsObject(row, fields) {
        if (row) {
            var currentRowAsObject = {};

            if (angular.isString(fields)) {
                fields = fields.split(',');
            }

            if (fields && fields.length > 0) {
                fields.forEach(function (key) {
                	if (_ignoreExportName) {
                		key = [key, key];
                		
                	} else {
                		key = key.split(':');
                		
                		if (key.length == 1) {
                			key.push(key[0]);
                		}
                	}

                    var fieldIndex = getFieldIndexByName(key[0].trim());

                    if (fieldIndex > -1 && fieldIndex < row.length) {
                        currentRowAsObject[key[1].trim()] = row[fieldIndex];
                    }
                });
            } else {
                if(angular.isDefined(_fields)){
                	_fields.forEach(function (fieldMD) {
	                    var fieldIndex = _fieldIndexByName[fieldMD.name];
	                    currentRowAsObject[fieldMD.name] = row[fieldIndex];
	                });
                } 
            }

            if(_keepMetadataWhileConverting){
                let metadata = getRowMetadata(row);

                if(metadata != undefined){
                    /*
                    | Essa mudança no nome é necessária pois o getRowMetadata retorna uma propriedade chamada 'rmd'
                    | mas a função addMetadataToRecord no dataset.controller busca por uma chamada '_rmd'
                    */
                    if(metadata.rmd){
                        metadata._rmd = { ...metadata.rmd };
                        delete metadata.rmd;
                    }
                    currentRowAsObject._rmd = metadata;
                }
            }

            return currentRowAsObject;
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#gotoRow
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável alterar programaticamente a linha corrente do dataset
     * @param {int} newIndex O novo indice selecionado do dataset.
     * @param {boolean} clearMultipleSelection Se true ou undefined, o dataset limpa os registros previamente selecionados ao mudar de linha.
     * @example <pre>dataset.gotoRow(2);</pre>
     */
    function gotoRow(rowIndex, clearMultipleSelection = true) {
        if (rowIndex != _currentIndex) {
            return changeRow(rowIndex, true, clearMultipleSelection);
        }

        return $q(function (resolve) {
            resolve(getCurrentIndex());
        });
    }

    function changeRow(newIndex, notifyObservers, clearMultipleSelection, reason, properties) {
        var rowChangedDeferred = $q.defer();
	    		
        autoSave().then(function () {
            if (angular.isUndefined(clearMultipleSelection) || clearMultipleSelection === true) {
                _selectedRecords = undefined;
            }

            _currentIndex = Math.max(-1, newIndex);
            loadFkDescriptionsCurrentRowIfNeeded();
            clearEdition(_ignoreTxPropertiesOnChangeRow);
            refreshBinders();
            refreshDetails();

            if (angular.isUndefined(notifyObservers) || notifyObservers === true) {
                notifyDataSetObservers(DatasetObserverEvents.EVENT_CURRENT_RECORD_CHANGED, {
                    reason: reason,
                    properties: properties
                });
            }

            if(!_isInsertionMode){
                notifyDataSetObservers(DatasetObserverEvents.EVENT_ROW_METADATA_CHANGED, {reason: "ROW_CHANGED", providerChanged: false } );
            }

            rowChangedDeferred.resolve(getCurrentIndex());
        }, function () {
            rowChangedDeferred.reject(getCurrentIndex());
        });

        return rowChangedDeferred.promise;
    }
    
    function autoSaveFromMaster() {
        return autoSave();
    }

    function autoSave() {
        var defer = $q.defer();
        
        if(_ignoreAutoSave){
        	defer.resolve();
        	return defer.promise;
        }

        var detailPromises = [];

        for (var index in _detailDataSets) {
            var detail = _detailDataSets[index];

            detailPromises.push(detail.autoSaveFromMaster(defer));
        }

        if (detailPromises.length > 0) {
            $q.all(detailPromises).then(function () {
                doAutoSave(defer);
            });
        } else {
            doAutoSave(defer);
        }

        return defer.promise;
    }

    function doAutoSave(defer) {
        /*
        Quando for um view, devemos permitir save apenas pelo botão de salvar,
        pois, views não podem ser salvas automaticamente pelo framework.
        Retirado a condição de nao salvar views pois afetou o cliente gerando uma P1, falado com leonardo Jorge autor: Kleber        
        */
        if (_recordIsDirty) {

            if (_conditionalAutoSave) {
                MessageUtils
                    .confirm(SkI18nService.instant('Dataset.msgtitleSalvarRegistro', { entityName: getEntityDescription(true) }), SkI18nService.instant('Dataset.messageSalvarRegistro'), SkI18nService.instant('Geral.lblSalvar'), SkI18nService.instant('Geral.lblDescartar'), true)
                    .then(function () {
                        try {
                            _processingAutosave = true;
                            save().then(defer.resolve, defer.reject);
                        } finally {
                            _processingAutosave = false;
                        }
                    }, function (reason) {
                        if (reason === 'no') {
                            cancelEdition();
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    });
            } else {
                if(_cancelPopUpAutoSave) {
                    defer.reject();
                } else {
                    try {
                        _processingAutosave = true;
                        save().then(defer.resolve, defer.reject);
                    } finally {
                        _processingAutosave = false;
                    }
                }
            }
        } else {
            if(isView()) console.warn('[SkDatasetController] Ignorando auto save pois a entidade é uma view.');
            defer.resolve();
        }

        return defer.promise;
    }

    function clearEdition(ignoreTxProperties) {
        _copyingRecord = false;
        
        if (!(angular.isDefined(ignoreTxProperties) && ignoreTxProperties === true)) {
        	_txProperties = undefined;
        }

        _modifiedBinders = {};
        _programmaticalModifiedValues = {};

        closeInsertionMode();

        _cleanRecord = undefined;
        _recordIsDirty = false;
        _editionStarted = false;
        _multiEditMode = false;
    }

    function closeInsertionMode() {
        if (_isInsertionMode) {
            notifyDataSetObservers(DatasetObserverEvents.EVENT_INSERTION_CANCELED);
        }

        _transientRecord = undefined;
        _isInsertionMode = false;
        _indexBeforeInsertionMode = -1;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setSortFunction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por definir uma lista de funções de ordenação no dataset.
     * @example
     * <pre>
     *  dataset.setSortFunctions(function(a,b) {
     *      return a-b;
     *  });
     * </pre>
     */
    function setSortFunction(f) {
        _records.setSortFunction(f);
    }

   	/** * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setObjectSortFunction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de sort no dataset
     * O valor passado a função será o record no formato de objeto.
     * @param {function} userFilterFn Uma função de filtro
     * @param {array|string} fields Filtro de campos, vide método {@link snk.components.dataset.directive:sk-dataset#getRowAsObject}
     * @returns {function} Retorna uma função que se executada, remove a função que foi inserida
     * @example <pre>
     *  var removeSortFn = dataset.setObjectSortFunction(function(recordA, recordB) {
     *      return recordA.VALOR - recordB.VALOR; 
     *  });
     * 
     * removeSortFn(); //Removendo filtro;
     * </pre>
     */
    function setObjectSortFunction(userFilterFn, fields) {
        return _records.setSortFunction(function (recordArray1, recordArray2) {
            var recordObj1 = getRowAsObject(recordArray1, fields);
            var recordObj2 = getRowAsObject(recordArray2, fields);

            return userFilterFn(recordObj1, recordObj2);
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#sortWithObjectFunction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável realizar ordenação momentânea no dataset.
     * O valor passado a função será o record no formato de objeto.
     * @param {function} userFilterFn Uma função de filtro
     * @param {array|string} fields Filtro de campos, vide método {@link snk.components.dataset.directive:sk-dataset#getRowAsObject}
     * @example <pre>
     *  dataset.sortWithObjectFunction(function(recordA, recordB) {
     *      return recordA.VALOR - recordB.VALOR; 
     *  });
     * </pre>
     */
    function sortWithObjectFunction(userFilterFn, fields) {
        var oldSortFn = _records.getSortFunction();

        var removeSort = setObjectSortFunction(userFilterFn, fields);

        _records.refresh();

        _records.setSortFunction(oldSortFn);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setFilterFunction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por definir uma função de filtro no dataset
     * @param {function} f Uma função de filtro
     * @returns {function} Retorna uma função que se executada, remove a função que foi inserida
     * @example
     * <pre>
     * var removeFilterFn = dataset.setFilterFunction(function(value) {
     *      return value >= 10; 
     *  });
     * 
     * removeFilterFn(); //Removendo filtro;
     * </pre>
     */
    function setFilterFunction(f, removeOnRefresh = false) {
        let functionToRemoveFilter = _records.setFilterFunction(f);
        
        if(removeOnRefresh){
          _filterFunctionsToRemoveOnRefresh.push(functionToRemoveFilter);
        }

        return functionToRemoveFilter;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addFilterFunction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de filtro no dataset
     * O valor passado a função será o record no formato de array.
     * @param {function} f Uma função de filtro
     * @returns {function} Retorna uma função que se executada, remove a função que foi inserida
     * @example
     * <pre>
     *  var removeFilterFn = dataset.addFilterFunction(function(value) {
     *      return value[0] >= 10; 
     *  });
     *  
     * removeFilterFn(); //Removendo filtro;
     * </pre>
     */
    function addFilterFunction(f, removeOnRefresh = false) {
        let functionToRemoveFilter = _records.addFilterFunction(f);

        if(removeOnRefresh){
          _filterFunctionsToRemoveOnRefresh.push(functionToRemoveFilter);
        }

        return functionToRemoveFilter;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addObjectFilterFunction
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de filtro no dataset
     * O valor passado a função será o record no formato de objeto.
     * @param {function} userFilterFn Uma função de filtro
     * @param {array|string} fields Filtro de campos, vide método {@link snk.components.dataset.directive:sk-dataset#getRowAsObject}
     * @returns {function} Retorna uma função que se executada, remove a função que foi inserida
     * @example <pre>
     *  var removeFilterFn = dataset.addObjectFilterFunction(function(value) {
     *      return value.VALOR >= 10; 
     *  });
     * 
     * removeFilterFn(); //Removendo filtro;
     * </pre>
     */
    function addObjectFilterFunction(userFilterFn, fields) {
        return _records.addFilterFunction(function (recordArray) {
            var recordObj = getRowAsObject(recordArray, fields);

            return userFilterFn(recordObj);
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setParallelLoader
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método responsável por definir se o dataset irá paginar ou não.
     * @param {boolean} value Determina se o dataset irá paginar ou não.
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example dataset.setParallelLoader(true);
     */
    function setParallelLoader(value) {
        _parallelLoader = value;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getParallelLoader
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método responsável para retornar o valor da variavel _parallelLoader (responsável por paginacao)
     * @example dataset.getParallelLoader();
     */
     function getParallelLoader() {
        return _parallelLoader;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setAllowPkModification
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método responsável por definir se o dataset permite alteração de pk.
     * @param {boolean} allow Determina se o dataset permite ou não a alteração de pk.
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example dataset.setAllowPkModification(true);
     */
    function setAllowPkModification(allow) {
        _allowPKModification = allow;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setUserFieldMDInterceptor
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método chamado na carga dos campos personalizados
     * @param {function} interceptor Função que será chamada para cada campo do dataset.
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.setUserFieldMDInterceptor(function(field) {
     *  if (field.name == "CODPROD"){
     *      field.description = 'Código do Produto'
     *  }
     * });
     * </pre>
     */
    function setUserFieldMDInterceptor(interceptor) {
        _userFieldMDInterceptor = interceptor;
        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setOrderByExpression
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado para adicionar uma expressão de orderBy ao dataset.
     * @param {String} orderBy Expressão de orderBy
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.setOrderByExpression('this.CAMPO1');
     * </pre>
     */
    function setOrderByExpression(orderBy) {
        $scope.orderByExpression = orderBy;
        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setConditionalAutoSave
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado alterar se o autosave do dataset ira perguntar algo ao usuário.
     * @param {String} value Se o dataset irá perguntar ou não se o registro deve ser salvo;
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.setConditionalAutoSave(false);
     * </pre>
     */
    function setConditionalAutoSave(value) {
        _conditionalAutoSave = value;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#cancelPopUpAutoSave
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado para ignorar o popup exibido apartir do autosave sem perder as alterações
     * @param {String} value Se o dataset irá fechar ou não o popup de auto save
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.cancelPopUpAutoSave(false);
     * </pre>
     */
     function cancelPopUpAutoSave(value) {
        _cancelPopUpAutoSave = value;

        return self;
    }

     /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isConditionalAutoSave
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado verificar se o autosave do dataset ira perguntar algo ao usuário.
     * @return {Dataset} Retorna se o condicional autosave está ativo ou não, se true, significa que o dataset ira
     * questionar o usuário se deseja salvar as alteração, se false, o salvamento é automatico.
     * @example
     * <pre>
     * dataset.isConditionalAutoSave();
     * </pre>
     */
    function isConditionalAutoSave(){
        return _conditionalAutoSave;
    }
    
    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setIgnoreTxPropertiesOnChangeRow
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado para ignorar o undefined nas propriedades de sessão ao mudar de linha o cursor do dataset.
     * @param {String} value Se devemos ou não ignorar limpar as propriedades de sessão.
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.setIgnoreTxPropertiesOnChangeRow(false);
     * </pre>
     */
    function setIgnoreTxPropertiesOnChangeRow(value) {
        _ignoreTxPropertiesOnChangeRow = value;
        return self;
    }
    
    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setIgnoreAutoSave
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado para ignorar o autosave do dataset.
     * @param {String} value Se devemos ou não ignorar o savamento automático;
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.setIgnoreAutoSave(false);
     * </pre>
     */
    function setIgnoreAutoSave(value) {
        _ignoreAutoSave = value;
        return self;
    }

     /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isIgnoreAutoSave
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado para ignorar o autosave do dataset.
     * @param {String} value Se devemos ou não ignorar o savamento automático;
     * @example
     * <pre>
     * dataset.isIgnoreAutoSave();
     * </pre>
     */
    function isIgnoreAutoSave(){
        return _ignoreAutoSave;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setRemoveRowConfirmInterceptor
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     *      Método utilizado para adicionar um interceptor de mensagem de delete do dataset.
     * @param {function} interceptor Função que será chamada para interceptar o popup de confirmação;
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example
     * <pre>
     * dataset.setRemoveRowConfirmInterceptor(function(confirmMessage, qtdRegistros){
     *      confirmMessage
     *          .title('MinhaTela.meuTitle)
     *          .msg('MinhaTela.minhaMsg')
     *          .focusOnButton('no');
     * });
     * </pre>
     */
    function setRemoveRowConfirmInterceptor(interceptor) {
        _removeRowConfirmInterceptor = interceptor;

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeSort
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por remover a ordenação do dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento 
     * @example <pre>dataset.removeSort();</pre>
     */
    function removeSort() {
        _records.removeSort();
        updateRecordsCollection(DatasetEvents.REFRESH_REASON_SORT, getPrimaryKeyObject(false), true);
        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeFilter
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por remover o filtro do dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example <pre>dataset.removeSort();</pre>
     */
    function removeFilter() {
        _records.removeFilter();
        updateRecordsCollection(DatasetEvents.REFRESH_REASON_FILTER, getPrimaryKeyObject(false), true, {forceCopy: true});
        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#clearDataSet
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por limpar o dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @example <pre>dataset.clearDataSet();</pre>
     */
    function clearDataSet() {
        _records.clear();
        clearEdition();
        changeRow(-1);
        notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SET_CLEARED);
        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#readAuthorizationData
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por ler um AuthorizationData e realizar update nas autorizações deste dataset
     * @return {Dataset} Retorna o próprio dataset para encadeamento
     * @param {MGEAuthorizationData} authData objeto de autorização para se atualizar o dataset.
     */
    function readAuthorizarionData(authData) {
        setCanInsert(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT));
        setCanEdit(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE));
        setCanCopy(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_CLONE));
        setCanRemove(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE));

        return self;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#locateByPk
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por pesquisar um registro pela PK na coleção corrente do dataset.
     * @param {Object} pkToFind Objeto com os valores da PK
     * @return {Promise} Retorna uma promise que será resolvida caso ache um registro e rejeitada caso contrário
     */
    function locateByPk(pkToFind) {
        var newIndex = findRecordIndexByPk(pkToFind);

        if (newIndex > -1) {
            return $q(function (resolve, reject) {
                gotoRow(newIndex).then(resolve, reject);
            });
        } else {
            return $q(function (resolve, reject) {
                reject();
            })
        }
    }

    function updateRecordsCollection(reason, pkToFind, doChangeRow, options) {
        var forceCopy = options ? options.forceCopy : false;

        if (angular.isUndefined(doChangeRow)) {
            doChangeRow = true;
        }

        clearEdition();

        var locateByPk = false;

        if (doChangeRow === true) {
            var newIndex = -1;

            if (_records.existsSortFunction() || _records.existsFilterFunction()) {
                var curRow = getCurrentRow();

                _records.refresh(undefined, undefined, forceCopy);

                if (angular.isDefined(curRow) && (reason == DatasetEvents.REFRESH_REASON_SORT || reason == DatasetEvents.REFRESH_REASON_FILTER)) {
                    for (var i = 0; i < _records.length(); i++) {
                        if (_records.getItem(i) == curRow) {
                            newIndex = i;
                            break;
                        }
                    }
                }
            }

            if (newIndex == -1) {
                if (angular.isDefined(pkToFind)) {
                    newIndex = findRecordIndexByPk(pkToFind);

                    if (newIndex > -1) {
                        locateByPk = true;
                    }

                }else if (($scope.selectSelectedRow == true)){
                    if (getCurrentIndex() >= 0) {
                        newIndex = getCurrentIndex();
                    }else{
                       newIndex = 0; 
                    }                    
                }else if (!($scope.selectFirstOnRefresh == false)){
                    newIndex = 0;
                } 
            }

            if (!(_records.existsSortFunction() || _records.existsFilterFunction())) {
                _records.refresh(undefined, undefined, forceCopy);
            }

            if (_clearSelectionAfterRefresh || angular.isUndefined(_records) || _records.length() === 0) {
                newIndex = -1;
            }

            changeRow(newIndex, undefined, undefined, reason, {
                locateByPk: locateByPk
            }).then(function () {
                notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SET_REFRESHED, {
                    reason: reason
                });

                executePendingActions();
            });
        } else {
            notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SET_REFRESHED, {
                reason: reason
            });

            executePendingActions();
        }
    }

    function abortLastPromiseForLoadRecords() {
        if (angular.isDefined(_lastPromiseForLoadRecords)) {
            if (_lastPromiseForLoadRecords.abort) {
                _lastPromiseForLoadRecords.abort();
            }

            _lastPromiseForLoadRecords = undefined;
        }
    }

    function finalizeLoadRecords(pkToFind, hasError) {
        if (angular.isUndefined(hasError)) {
            hasError = false;
        }

        abortLastPromiseForLoadRecords();

        self.dispatchEvent(DatasetEvents.BACKGROUND_LOAD_END);

        _pageRefreshing = false;

        if (!hasError) {
            updateRecordsCollection(DatasetEvents.REFRESH_REASON_RESET, pkToFind, true);
        }
    }

    function findRecordIndexByPk(pkToFind) {
        for (var i = 0; i < _records.length(); i++) {
            var isThis = true;

            var record = _records.getItem(i);

            for (var index in _primaryKeyFields) {
                var pkField = _primaryKeyFields[index];

                if (!pkToFind.hasOwnProperty(pkField)) {
                    throw new Error('Campo ' + pkField + ' não foi encontrado na entidade' + $scope.entityName);
                }

                if (self.dataToString(pkToFind[pkField]) != self.dataToString(record[_fieldIndexByName[pkField]])) {
                    isThis = false;
                    break;
                }
            }

            if (isThis) {
                return i;
            }
        }

        return -1;
    }

    function findAllIndexByPk(pkToFind) {
        var ocurrences = [];
        for (var i = 0; i < _records.length(); i++) {
            var isThis = true;

            var record = _records.getItem(i);

            for (var index in _primaryKeyFields) {
                var pkField = _primaryKeyFields[index];

                if (!pkToFind.hasOwnProperty(pkField)) {
                    throw new Error('Campo ' + pkField + ' não foi encontrado na entidade' + $scope.entityName);
                }

                if (self.dataToString(pkToFind[pkField]) != self.dataToString(record[_fieldIndexByName[pkField]])) {
                    isThis = false;
                    break;
                }
            }

            if (isThis) {
                ocurrences.push(i);
            }
        }
        return ocurrences;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#strToTypedData
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Realiza a conversão de uma <b>String</b> para um valor tipado.
     * @example dataset.strToTypedData('1', 'I');
     * @param {string} value Valor a ser convertido
     * @param {string} type Tipo em que será convertido [I, F, T, D, CUR ou H]
     * @param {boolean} [isEncodedTransport=false] Caso seja fornecido como <b>true</b>, o valor derá decodado de Base64 antes da conversão.
     * @returns {object} Retorna o valor tipado.
     */
    function strToTypedData(value, type, isEncodedTransport) {
        if (!value) {
            return undefined;
        }

        if (isEncodedTransport === true) {
            value = Base64.decode(value);
        }

        switch (type) {
            case "I":
            case "F":
            case "CUR": // Tipo Currency [moeda] é utilizado no Dashboard do BI
            case "T":
                return NumberUtils.getNumberOrNull(value);
            case "D":
            case "H":
                return DateUtils.strToDate(value);
        }

        return value;
    }

    function addFunctionToQueue(f) {
        _pendingActions.push(f);
    }

    function executePendingActions() {
        if (_pendingActions.length > 0) {
            var f = _pendingActions.pop();
            f();
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addObserver
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar um objeto observador ao dataset, que será notificado de acordo com algumas mudanças de estado do dataset.
     * <br> Veja: {@link util.common:IDataSetObserver}
     * @param {IDataSetObserver} observer Observer a ser adicionado ao dataset.
     * @returns {function} Retorna uma função que se chamada removerá o observer do dataset.
     * @example
     * <pre>
     *  var removeObserver = dataset.addObserver(IDataSetObserver);
     *  removeObserver();// Removendo observer
     * </pre>
     */
    function addObserver(observer) {
        ObjectUtils.isImplementorOf(observer, IDataSetObserver);

        if (_datasetObservers.indexOf(observer) < 0) {
            _datasetObservers.push(observer);
        }

        return function () {
            removeObserver(observer);
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addLineChangeListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener de troca de linha no dataset.
     * @param {function} listener Função que será chamada na mudança de linha
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = dataset.addLineChangeListener(function(newIndex){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addLineChangeListener(listener) {
        var obs = new IDataSetObserver();
        obs.currentLineChanged = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addSelectionChangeListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener de mudança de selação no dataset.
     * @param {function} listener Função que será chamada na mudança de seleção.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = dataset.addSelectionChangeListener(function(){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addSelectionChangeListener(listener) {
        var obs = new IDataSetObserver();
        obs.selectionChanged = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addRefreshedListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener de refresh no dataset.
     * @param {function} listener Função que será chamada no refresh do dataset.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = addRefreshedListener(function(reason){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addRefreshedListener(listener) {
        var obs = new IDataSetObserver();
        obs.refreshed = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addDataModifiedListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por executar uma função de listener quando algum campo do dataset for modificado.
     * @param {function} listener Função que será chamada na modificação do campo no dataset.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = addDataModifiedListener(function(fieldName){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addDataModifiedListener(listener) {
        var obs = new IDataSetObserver();
        obs.dataModified = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addFieldModifiedListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por executar uma função de listener quando o campo do dataset informado for modificado.
     * @param {arraylike} fields Nome dos campos que terá o listener adicionado.
     * @param {function} listener Função que será chamada na modificação do campo no dataset.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = addFieldModifiedListener('TESTE,TESTE2', function(fieldName, newValue, oldValue){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addFieldModifiedListener(fields, listener) {
        var obs = new IDataSetObserver();
        obs.fieldsMap = {};

        ArrayUtils.toArray(fields).forEach(function(fieldName){
            obs.fieldsMap[fieldName] = undefined;
        });

        obs.dataModified = function(fieldName) {
            if (obs.fieldsMap.hasOwnProperty(fieldName)) {
                var newValue = getFieldValue(fieldName);
                var oldValue = !_multiEditMode && _cleanRecord ? _cleanRecord[getFieldIndexByName(fieldName)] : undefined;

                listener(fieldName, newValue, oldValue);
            }
        };

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addDataSavedListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por executar uma função de listener quando o dataset salvar um registro.
     * @param {function} listener Função que será chamada sempre que o dataset salvar um registro.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = addDataSavedListener(function(isNew, records){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addDataSavedListener(listener) {
        var obs = new IDataSetObserver();
        obs.dataSaved = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addEditionCanceledListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por executar uma função de listener quando o dataset cancelar uma edição.
     * @param {function} listener Função que será chamada sempre que o dataset cancelar um registro.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * </pre>
     * var removeListener = addEditionCanceledListener(function(){
     * });
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addEditionCanceledListener(listener) {
        var obs = new IDataSetObserver();
        obs.editionCanceled = listener;

        return addObserver(obs);
    }

    function addFieldMetadataInterceptor(fieldName, interceptor) {        
        var interceptors = _fieldInterceptors[fieldName];

        if (!interceptors) {
            _fieldInterceptors[fieldName] = interceptors = [];
        }

        interceptors.push(interceptor);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addInsertionModeListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener de modo de inserção do dataset.
     * @param {function} listener Função que será chamada ao entrar em insersção.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * <pre>
     * var removeListener = dataset.addInsertionModeListener(function(indexBeforeInsert, dataset){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addInsertionModeListener(listener) {
        var obs = new IDataSetObserver();
        obs.insertionModeActivated = listener;

        return addObserver(obs);
    }
    
    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addRowMetaDataListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener ao haver alteração de metadata.
     * @param {function} listener Função que será chamada ao haver alteraçao de metadata.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * <pre>
     * var removeListener = dataset.addRowMetaDataListener(function(indexBeforeInsert, dataset){});
     * removeListener(); //Removendo listener
     * </pre>
     */

    function addRowMetaDataListener(listener) {
        var obs = new IDataSetObserver();
        obs.rowMetadataChanged = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getRowMetadataProperty
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por retornar o valor da property mapeado no dicionario de dados do campo.
     * @param {function} fieldName nome do campo.
     * @param {function} String descrição rm. Ex: rm_precision, rm_controle.
     * @returns {function} Retorna o valor da propriedade do campo
     * @example
     * <pre>
     * var metadataValue = dataset.getRowMetadataProperty(fieldName, "rm_precision");
     * </pre>
     */

    function getRowMetadataProperty(fieldName, nameRm) {
        var _value = undefined;
        var _properties = ArrayUtils.toArray(ObjectUtils.getProperty(getFieldMetadata(fieldName), 'properties'));
        for (let i = 0; i < _properties.length; i++) {
            if (_properties[i].name == nameRm) {
                _value = _properties[i].value;
                break;
            }
        }
        return _value;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addRecordRemovedListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener de exclusão de registros no dataset.
     * @param {function} listener Função que será chamada ao deletar um registro.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * <pre>
     * var removeListener = dataset.addRecordRemovedListener(function(record){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addRecordRemovedListener(listener) {
        var obs = new IDataSetObserver();
        obs.recordRemoved = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addAllObserverEventsListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener que será disparado em todos os eventos do observer.
     * @param {function} listener Função que será chamada nos eventos do observer.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * <pre>
     * var removeListener = dataset.addAllObserverEventsListener(function(event, parameters){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addAllObserverEventsListener(listener) {
        var obs = new IDataSetObserver();
        obs.allEvents = listener;

        return addObserver(obs);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addSaveAvoidListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar uma função de listener cancelamento de save.
     * @param {function} listener Função que será chamada a cancelar um save por erro de validação.
     * @returns {function} Retorna uma função que se chamada removerá o listener do dataset.
     * @example
     * <pre>
     * var removeListener = dataset.addSaveAvoidListener(function(nullFieldNames, dataset){});
     * removeListener(); //Removendo listener
     * </pre>
     */
    function addSaveAvoidListener(listener) {
        var obs = new IDataSetObserver();
        obs.saveAvoided = listener;

        return addObserver(obs);
    }


    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addRecordValidator
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por adicionar um objeto validador ao dataset, que realizará a validação dos registros antes da persistência.
     * <br> Veja: {@link components.dataset.validators.interface:RecordValidator}
     * @param {RecordValidator} validator Validador a ser adicionado ao dataset.
     * @example <pre>dataset.addRecordValidator(validator);</pre>
     */
    function addRecordValidator(validator) {
        ObjectUtils.isImplementorOf(validator, RecordValidator);

        _recordValidators.push(validator);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#notifyReloadFields
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável disparar uma notificacao de mudança de linha.
     * @example
     * </pre>
     *      dataset.notifyLineChange();
     * </pre>
     */
    function notifyReloadFields() {
        notifyDataSetObservers(DatasetObserverEvents.EVENT_RELOAD_FIELDS);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#removeObserver
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por remover um objeto observador ao dataset.
     * <br> Veja: {@link util.common:IDataSetObserver}
     * @param {IDataSetObserver} observer Observer a ser removido do dataset.
     * @example <pre>dataset.removeObserver(IDataSetObserver);</pre>
     */
    function removeObserver(observer) {
        ObjectUtils.isImplementorOf(observer, IDataSetObserver);

        var index = _datasetObservers.indexOf(observer);

        if (index > -1) {
            _datasetObservers.splice(index, 1);
        }
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isFieldRequired
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por indicar se um campo é requerido ou não no dataset
     * @param {string} fieldName Nome do campo a ser avaliado.
     * @example <pre>dataset.isFieldRequired('NOMECAMPO');</pre>
     */
    function isFieldRequired(fieldName) {
        var field = getFieldMetadata(fieldName);

        if (!field) {
            throw new Error('Campo não definido:' + fieldName);
        }

        if (field.entityPath !== $scope.entityName) {
            return false;
        }

        if (field.hasDefaultValue && isInsertionMode()) {
            return false;
        }

        if (field.isAutoNum) {
            return false;
        }

        return !field.isNullable;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#isFieldReadOnly
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por indicar se um campo é readonly ou não no dataset
     * @param {string} fieldName Nome do campo a ser avaliado.
     * @example <pre>dataset.isFieldReadOnly('NOMECAMPO');</pre>
     */
    function isFieldReadOnly(fieldName) {
        var field = getFieldMetadata(fieldName);
        return ObjectUtils.getProperty(field, 'readOnly');
    }

    function notifyDataSetObservers(event, parameters) {
        
        if (!_observersEnabled) {
            _evtObserversIgnored[event] = true;            
            return;
        }

        _datasetObservers.forEach(function (observer) {
            switch (event) {
                case DatasetObserverEvents.EVENT_CURRENT_RECORD_CHANGED:
                    observer.currentLineChanged(getCurrentIndex(), parameters.reason, parameters.properties || {}, self);
                    break;
                case DatasetObserverEvents.EVENT_INSERT_MODE:
                    observer.insertionModeActivated(parameters.indexBeforeInsert, self);
                    break;
                case DatasetObserverEvents.EVENT_RECORD_EDITED:
                    observer.dataModified(parameters.modifiedFieldId);
                    break;
                case DatasetObserverEvents.EVENT_DATA_SET_CLOSED:
                    observer.closed();
                    break;
                case DatasetObserverEvents.EVENT_DATA_SET_REFRESHED:
                    observer.refreshed(parameters.reason);
                    break;
                case DatasetObserverEvents.EVENT_DATA_SAVED:
                    observer.dataSaved(parameters.isNew, parameters.records);
                    break;
                case DatasetObserverEvents.EVENT_RECORD_REMOVED: {
                    /* TODO / Sugestão de melhoria: disparar os eventos para todas as linhas que estão sendo excluídas em vez de somente para a primeira
                    let rows = [];

                    if(parameters?.allReferences?.length){
                        rows = parameters.allReferences;
                    }else if(parameters.recordReference){
                        rows = [parameters.recordReference];
                    }

                    for(let row of rows){
                        observer.recordRemoved(row);
                    }
                    */
                    observer.recordRemoved(parameters.recordReference);
                    break;
                }
                case DatasetObserverEvents.EVENT_EDITION_CANCELED:
                    observer.editionCanceled();
                    break;
                case DatasetObserverEvents.EVENT_EDITION_STARTED:
                    //neste caso não há ação para observers.
                    break;
                case DatasetObserverEvents.EVENT_SELECTION_CHANGED:
                    /** 
                     * Verifica se o checkbox foi marcado ou desmarcado no datagrid 
                     * através dos métodos addSelectedRecordByUniqueId e unselectRowByUniqueId
                    */
                    if (angular.isDefined(parameters)) {
                        observer.selectionChanged(parameters);
                    } else {
                        observer.selectionChanged();
                    }
                    break;
                case DatasetObserverEvents.EVENT_EDIT_MODE:
                    observer.editionModeActivated(parameters.multiEditMode);
                    break;
                case DatasetObserverEvents.EVENT_SAVE_AVOID:
                    observer.saveAvoided(parameters.nullFieldNames);
                    break;
                case DatasetObserverEvents.EVENT_DATA_SET_UPLOADING:
                    observer.uploadingFile(parameters.isUploading);
                    break;
                case DatasetObserverEvents.EVENT_DATA_SET_CLEARED:
                    observer.cleared();
                    break;
                case DatasetObserverEvents.EVENT_CURRENT_RECORD_REFRESHED:
                    observer.currentRecordRefreshed(parameters.records);
                break;
                case DatasetObserverEvents.EVENT_ROW_METADATA_CHANGED:
                    self.whenMetadataLoaded().then(() => {
                        observer.rowMetadataChanged(parameters.reason, parameters.providerChanged);
                    });
                break;
                case DatasetObserverEvents.EVENT_INSERTION_CANCELED:
                    observer.insertionCanceled();
                break;
                case DatasetObserverEvents.EVENT_RELOAD_FIELDS:
                    observer.reloadFields();
                break;
                case DatasetObserverEvents.EVENT_FINISHED_EDITION:
                    observer.onFinishEdition(parameters.fieldName, parameters.newValue, parameters.oldValue);
                break;
            }

            observer.allEvents(event, parameters);
        });

        removeObserverIgnored(event);

        if (_eventsWithFieldEvaluator.indexOf(event) > -1) {
            var modifiedFieldId = parameters.modifiedFieldId;

            _fieldValueEvaluators.forEach(function (evaluateInfo) {
                var triggerFields = evaluateInfo.triggerFields;

                if (triggerFields.length == 0 || (triggerFields.indexOf(modifiedFieldId) > -1)) {
                    var promise = evaluateInfo.evaluateFn(self, self.getCurrentRowAsObject(evaluateInfo.triggerFields.concat(evaluateInfo.fieldName)), modifiedFieldId);

                    $q.when(promise, function (newValue) {
                        self.setFieldValue(evaluateInfo.fieldName, newValue);
                    });
                }
            });
        }
    }

    function removeObserverIgnored(event){
        delete _evtObserversIgnored[event];
    }

    function hasObserverIgnored(event){
        return _evtObserversIgnored.hasOwnProperty(event) && _evtObserversIgnored[event] == true;
    }

    function buildStandAloneEntity() {
        if (_userFieldMDInterceptor) {
            _userFieldsMetadata.forEach(_userFieldMDInterceptor);
        }

        var pkFields = _userFieldsMetadata.filter(function (field) {
            return field.isPk;
        }).map(function (field) {
            return field.name;
        });

        return {
            name: 'StandAloneEntity',
            description: 'StandAlone',
            fields: _userFieldsMetadata,
            pk: pkFields
            //relations:Array[1]
        };
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#init
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Método responsável por inicializar o dataset.
     * @return {Promise} Retorna uma promessa de finalização de carga dos metadados, indicando que está pronto para uso.
     * @example
     * <pre>
     *  dataset.init()
     *      .then(function(){
     *          console.log('Metadados carregados');
     *      });
     * </pre>
     */
    function init() {
        return initializeDataSet();
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#initAndRefresh
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Método responsável por inicializar o dataset e realizar um refresh em seguida.
     * @return {Promise} Retorna uma promessa de finalização de refresh
     * @example
     * <pre>
     *  dataset.initAndRefresh()
     *      .then(function(){
     *          console.log('Refresh realizado')
     *      });
     * </pre>
     */
    function initAndRefresh() {
        return $q(function(resolve, reject){
            init().then(function() {
                refresh().then(resolve, reject);
            }, reject);
        });
    }

    function initializeDataSet() {
        clearDataSet();

        _isMetadataAvailable = false;

        if($scope.lazyLoad){
            _initDatasetLazyLoad = true;
        }

        if (_standAlone && _userFieldsMetadata.length > 0 && !$scope.entityName) {
            var staEntity = buildStandAloneEntity();

            $scope.entityName = staEntity.name;

            var entities = {};
            entities[$scope.entityName] = staEntity;

            DatasetUtils
                .prepareMetadata({
                    entities: entities
                }).then(setMetadata);
        } else if (angular.isDefined($scope.metadataProvider)) {
            if (!$scope.entityName) {
                $scope.entityName = _datasetID;
            }

            var customMP = $scope.metadataProvider;

            if (angular.isFunction(customMP)) {
                customMP(setMetadata);
            } else {
                throw new Error('MetadataProvider inválido.');
            }
        } else {
            if (angular.isUndefined($scope.entityName)) {
                throw new Error('Nome da entidade deve ser informado.');
            }

            var entitiesRequestInfo = DatasetUtils.buildEntitiesRequestInfo($scope.entityName, _metadataFieldsRequestInfo);

            _rootFieldsRequestInfo = entitiesRequestInfo.rootFieldsRequestInfo;

            MetadataProvider
                .getEntityAndRelationsMetadata(entitiesRequestInfo.entitiesForRequest)
                .then(function (md) {
                    DatasetUtils.processEntitiesRequestPaths(md, entitiesRequestInfo);

                    if (_standAlone || _userFieldsMetadata.length > 0) {
                        var standAloneEntity = buildStandAloneEntity();
                        md.entities[standAloneEntity.name] = standAloneEntity;
                    }

                    DatasetUtils.prepareMetadata(md, isRequestedField, getParentEntityName(), $scope.entityName)
                        .then(setMetadata);

                }, onFailGetEntityMetadata);
        }

        return whenMetadataLoaded();
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#makeFieldNonRequired
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável marcar um campo como não obrigatório
     * @param {string} fieldName Nome do campo.
     * @example <pre>dataset.makeFieldNonRequired('NOMECAMPO');</pre>
     */
    function makeFieldNonRequired(fieldName) {
        _recordValidators.forEach(function (validator) {
            if (validator instanceof RequiredRecordValidator) {
                validator.addExceptField(fieldName);
            }
        });
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#makeFieldRequired
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável marcar um campo como obrigatório
     * @param {string} fieldName Nome do campo.
     * @example <pre>dataset.makeFieldRequired('NOMECAMPO');</pre>
     */
    function makeFieldRequired(fieldName) {
        _recordValidators.forEach(function (validator) {
            if (validator instanceof RequiredRecordValidator) {
                validator.addRequiredField(fieldName);
            }
        });
    }

	function isRequestedField(entity, field) {
        let exceptFields = angular.isDefined(_parentDataSet) ? _parentDataSet.getExceptFieldsByEntity() : _exceptFieldsByEntity;
        let entityForceUserFields = angular.isDefined(_parentDataSet) ? _parentDataSet.getEntityForceUserFields() : _entityForceUserFields

        if(entityForceUserFields[entity.name] && field.name.startsWith('AD_')){
            return true;
        }

        if(exceptFields[entity.name] && exceptFields[entity.name].indexOf(field.name) > -1){
            return false;
        }

        if (_metadataFieldsRequestInfo.length == 0 || field.standAlone === true) {
            return true;
        }

        if (angular.isDefined(_rootFieldsRequestInfo) && entity.name === $scope.entityName) {
            if (_rootFieldsRequestInfo.pattern === '*') {
                /**
                 * Caso a ligação seja merge-on-root, temos que validar
                 * se a entidade que esta fazendo merge na entidade root
                 * está mapeada no _metadataFieldsRequestInfo, comportamento
                 * herdado do frame flex.
                 */
                if(field.mergedFrom != undefined){
                    return mergeOnRootRequested(field);
                }
                
                return true;
            } else if (ArrayUtils.isIn(entity.pk, field.name)) {
                return true;
            }

			var requestedFields = _rootFieldsRequestInfo.pattern.split(',');

            for (var i = 0; i < requestedFields.length; i++) {
                if (field.name === requestedFields[i].trim()) {
                    return true;
                }
            }
        } else {
            for (var i = 0; i < _metadataFieldsRequestInfo.length; i++) {
                var fieldsRequestInfo = _metadataFieldsRequestInfo[i];

                if (fieldsRequestInfo.path === entity.name) {
                    if (fieldsRequestInfo.pattern === '*') {
                        return true;
                    }
                    var requestedFields = fieldsRequestInfo.pattern.split(',');

                    for (var j = 0; j < requestedFields.length; j++) {
                        if (field.name === requestedFields[j].trim()) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    
    function validateRequestedFields(field, requestedFields){
    	
        for (var i = 0; i < requestedFields.length; i++) {
            if (field.name === requestedFields[i].trim() || forceUserFields(field, requestedFields[i])) {
                return true;
            }
        }
        
    	return false;
    }
    
    function forceUserFields(field, requestedField){
    	
        return (field.isUserField && requestedField.trim() === DatasetContants.DEFAULT_USER_FIELDS);
        
    }

    function mergeOnRootRequested(field){
        if(_metadataFieldsRequestInfo.length == 0){
            return true;
        }

        let entityReq = _metadataFieldsRequestInfo.filter( (req) =>  req.entity == field.mergedFrom);

        if(entityReq.length == 0){
            return false;
        }

        if(entityReq[0].pattern === '*'){
            return true;
        }

        var requestedFields = fieldsRequestInfo.pattern.split(',');
        
        for (var j = 0; j < requestedFields.length; j++) {
            if (field.name === requestedFields[j].trim()) {
                return true;
            }
        }

        return false;
    }

    function setMetadata(metadata) {
        _fieldsByEntity = metadata.fieldsByEntity;
        _foreingKeyFields = metadata.foreingKeyFields;

        _baseEntity = metadata.entitiesMetadata[$scope.entityName];

        _primaryKeyFields = _baseEntity.pk;
        
        if (angular.isUndefined(_entityPresentationFieldName)) {
            _entityPresentationFieldName = _baseEntity.presentationField;
        }

        var fieldsMD = metadata.allFields;

        var metadataInterceptor = $scope.metadataInterceptor;

        if (angular.isFunction(metadataInterceptor)) {
            metadataInterceptor(fieldsMD, self);
        }

        _fieldIndexByName = {};

        for (var index in fieldsMD) {
            var field = fieldsMD[index];
            _fieldIndexByName[field.name] = index;

            if (_fieldInterceptors[field.name]) {
                _fieldInterceptors[field.name].forEach(function(interceptor) {
                    interceptor(field, self);
                });
            }
        }

        _fields = fieldsMD;

        if($scope.lazyLoad){
            // Adicionamos o campo HASCHILDREN para o listener HierarchyCrudListener setar se o campo tem filhos ou não
            addTransientField({
                name: 'HASCHILDREN',
                userType: 'S',
                dataType: 'S',
                visible: false,
                description: '',
                isPk: false,
                standAlone : true,
                properties: []
            });
        }

        addDescriptionFieldsMdStandAlone().then(function(){
            _isMetadataAvailable = true;

            executePendingActions();

            self.dispatchEvent(DatasetEvents.ON_METADATA_UPDATED);
        });
    }

    function onFailGetEntityMetadata(response) {
        throw new Error('Falha ao carregar os metadados');
    }

    function fkIsFilled() {
        var allFksFilled = true;

        if (_isRequiredMembroPK !== false && (_foreingKeyFields.length > 0 || _parentDataSet == null)) {
            for (var index in _foreingKeyFields) {
                var fk = _foreingKeyFields[index];

                if (_parentDataSet.getFieldValue(fk.parentFieldName) == null) {
                    allFksFilled = false;

                    break;
                }
            }
        }

        return allFksFilled;
    }

    function isStandAlone() {
        return _standAlone;
    }

    function setStandAlone(cond) {
        _standAlone = cond;
    }

     /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getNextUniqueID
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por retornar o id unico da próxima linha que será inserida no dataSet
     * @return {var} Retorna uma cópia do id unico da próxima linha que será inserida no dataSet
     * @example <pre>dataset.getNextUniqueID();</pre>
     */
    function getNextUniqueID(){
        return angular.copy(_rowUniqueID);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#makeFieldPersonalizedValidator
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por marcar um campo com uma validação de não nulo personalizada.
     * @param {string} fieldName Nome do campo.
     * @param {function} functionValid Função que fará a validação do campo, essa deve retornar true se a validação estiver ok e false caso contrário.
     * @param {boolean} ignoreOthers Se a validação deve ignorar o restante dos validadores.
     * @example <pre>dataset.makeFieldPersonalizedValidator('NOMECAMPO', function(){ return true;}, true);</pre>
     */
    function makeFieldPersonalizedValidator(fieldName, functionValid, ignoreOthers) {
        if(ignoreOthers){
            _recordValidators.forEach(function (validator) {
                if (validator instanceof RequiredRecordValidator) {
                    validator.addExceptField(fieldName);
                }
            });
        }
        _fieldsPersonalizedValidation[fieldName] = functionValid;
    }

    function setRefreshHandler(fn) {
        $scope.refreshHandler = fn;
    }

    function setSaveHandler(fn) {
        $scope.saveHandler = fn;
    }

    function setRemoveHandler(fn) {
        $scope.removeHandler = fn;
    }

    function setSelectFirstOnRefresh(status) {
        $scope.selectFirstOnRefresh = status;
    }

    function setSelectSelectedRow(status) {
        $scope.selectSelectedRow = status;
    }

	function getRecordsObjectPaged(start, end){
        var records = getRecordsPaged(start, end);
        var objectRecords = [];
        records.forEach(function(record, i){
            var recorObj = getRecordAsObject(i + start, undefined ,true);
            objectRecords.push(recorObj);
        });
        return objectRecords;
    }

    function getRecordsPaged(start, end){
        return _records.getItemsPaged(start, end);
    }

    function getIndexByUniqueId(uniqueId) {
        if (uniqueId == undefined) {
            return -1;
        }
        const itemSelected = _rowsByUniqueID
            .filter(i => angular.isArray(i) ? i.filter(j => j && j.rowID && j.rowID === uniqueId).length > 0 : false);
        return _records.indexOf(itemSelected && itemSelected[0] ? itemSelected[0] : _rowsByUniqueID[uniqueId]);
    }

    function getDatasetId(){
        return angular.copy(_datasetID);
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#containsField
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Retorna um boleano se o nome do campo contem no dataset
     * @example <pre>dataset.containsField(fieldName);</pre>
     */
    function containsField(fieldName) {
        var contains = false;

        if (StringUtils.isNotEmpty(fieldName)) {
            for (var i = 0; i < _fields.length; i++) {
                if (_fields[i].name == fieldName) {
                    contains = true;
                    break;
                }
            }
        }

        return contains;
    }


    function selectAllRecords(){
        setSelectedRecords(_records.getItems());        
    }

    function unselectAll(){
        setSelectedRecords([]);
    }

    function isSelected(uniqueId){
        return _selectedRecordsByUniqueId.hasOwnProperty(uniqueId);
    }

    function unselectRowByUniqueId(uniqueId, isChecked){
        var rowIndex = -1;
        var items =  _records.getItems();
        delete _selectedRecordsByUniqueId[uniqueId];
        for(var i = 0; i < (_selectedRecords || []).length; i++){
            var md = getRowMetadata(_selectedRecords[i]);
            if(md.rowID == uniqueId){
                rowIndex = items.indexOf(_selectedRecords[i]);
                ArrayUtils.removeReference(_selectedRecords, _selectedRecords[i]);
                if (isChecked === false) {
                    notifyDataSetObservers(DatasetObserverEvents.EVENT_SELECTION_CHANGED, { rowID: uniqueId, rowIndex, isChecked });
                } else {
                    notifyDataSetObservers(DatasetObserverEvents.EVENT_SELECTION_CHANGED);
                }
                break;
            }
        }
    }

    function addSelectedRecordByUniqueId(uniqueId, isChecked){
        var rowIndex = -1;
        var items =  _records.getItems();
        if(!_selectedRecords){
            _selectedRecords = [];
        }
        for(var i=0; i < items.length; i++){
            var item = items[i];
            var md = getRowMetadata(item);
            if(md.rowID == uniqueId && _selectedRecords.indexOf(item) == -1){
                rowIndex = i;
                _selectedRecordsByUniqueId[uniqueId] = true;
                _selectedRecords.push(item);
                if (isChecked === true) {
                    notifyDataSetObservers(DatasetObserverEvents.EVENT_SELECTION_CHANGED, { rowID: uniqueId, rowIndex, isChecked });
                } else {
                    notifyDataSetObservers(DatasetObserverEvents.EVENT_SELECTION_CHANGED);
                }
                break;
            }
        }
    }

    function addSelectedRecordsByUniqueIds(uniqueIds){
        var rowIndex = -1;
        var items =  _records.getItems();
        if(!_selectedRecords){
            _selectedRecords = [];
        }
        
        uniqueIds.forEach(uniqueId =>{
            for(var i=0; i < items.length; i++){
                var item = items[i];
                var md = getRowMetadata(item);
                if(md.rowID == uniqueId && _selectedRecords.indexOf(item) == -1){
                    rowIndex = i;
                    _selectedRecordsByUniqueId[uniqueId] = true;
                    _selectedRecords.push(item);
                    break;
                }
            }
        });

        

        notifyDataSetObservers(DatasetObserverEvents.EVENT_SELECTION_CHANGED);
    }
    
    function getRecordByUniqueId(uniqueId){
       return _rowsByUniqueID[uniqueId];
    }

    function updateUniqueId(oldRecord, newRecord){
        var oldUniqueId = getRowMetadata(oldRecord).rowID
        
        if(!newRecord[_fields.length]){
            newRecord[_fields.length] = {}; 
        }

        newRecord[_fields.length].rowID = oldUniqueId;
        _rowsByUniqueID[oldUniqueId] = newRecord;
    }

    function loadFkDescriptionsCurrentRowIfNeeded() {
        var currentRecord = getCurrentRow();

        if (currentRecord) {
            _fieldsDescriptionStandAlone.forEach(function (fieldMD) {
                var localfieldIndex = getFieldIndexByName(fieldMD.name);
                var codeValue = currentRecord[getFieldIndexByName(fieldMD.codeFieldName)]

                if (angular.isUndefined(currentRecord[localfieldIndex]) && codeValue) {
                    loadFieldDescripion(fieldMD.name.split('.')[0], codeValue, fieldMD);
                }
            });
        }
    }

    function loadFieldDescripion(entityName, codeValue, fieldMD) {
        SkPesquisaService.loadSuggestionsByPk(entityName, codeValue, undefined, undefined, {showFinderError: false}).then(function (entity) {
            var entityData = entity.data[0];
            if (entityData && entity.data[0][entity.descriptionField]) {
                setFieldValue(fieldMD.name, entity.data[0][fieldMD.descriptionFieldName], true);
            }
        });
    }

    function getPresentationFieldMdOfFkMetadata(fMD) {
        var defer = $q.defer();

        if (!fMD) {
            defer.reject('Parâmetro field Metada deve ser informado.');
            return defer.promise;
        }

        var promise = fMD.descriptionFieldName ? angular.noop : MetadataProvider.getEntityMetadata(fMD.fk.entity);

        $q.when(promise).then(function (entitiesMetadata) {
            var descriptionFieldName = fMD.fk.descriptionFieldName || (entitiesMetadata ? entitiesMetadata[fMD.fk.entity].presentationField : undefined);

            if (!descriptionFieldName) {
                defer.reject("Não foi possivél resolver o campo de descrição da entidade: " + fMD.fk.entity);
                return defer.promise;
            }

            var fkDescriptionField = angular.copy(fMD);
            var fkName = fMD.fk.entity + '.' + descriptionFieldName;

            fMD.fk.descriptionFieldName = fkName;
            fkDescriptionField.name = fkName;
            fkDescriptionField.descriptionFieldName = descriptionFieldName;
            fkDescriptionField.codeFieldName = fMD.name;
            fkDescriptionField.isDescriptionField = true;
            fkDescriptionField.required = false;
            fkDescriptionField.dataType = 'S';
            fkDescriptionField.insertPosition = getFieldsMetadata().indexOf(fMD);

            defer.resolve(fkDescriptionField);
        });

        return defer.promise;
    }

    function addDescriptionFieldsMdStandAlone() {
        var allPromises = [];
        var defer = $q.defer();

        if (!$scope.loadDescriptionFieldsStandAlone) {
            defer.resolve();
            return defer.promise;
        }

        getFieldsMetadata().forEach(function (fMD) {
            if (fMD.fk && fMD.standAlone) {
                allPromises.push(getPresentationFieldMdOfFkMetadata(fMD));
            }
        });

        if (allPromises.length > 0) {

            $q.all(allPromises).then(function (data) {

                data.forEach(function (fieldDescriptionMD) {
                    var insertAtPos = fieldDescriptionMD.insertPosition + 1;

                    if (_fieldInterceptors[fieldDescriptionMD.name]) {
                        _fieldInterceptors[fieldDescriptionMD.name].forEach(function (interceptor) {
                            interceptor(fieldDescriptionMD, self);
                        });
                    }

                    ArrayUtils.insertAtIndex(_fields, insertAtPos, fieldDescriptionMD);
                    _fieldsDescriptionStandAlone.push(fieldDescriptionMD);
                });

                //Se algum field metadata foi adicionado temos que atualizar o _fieldIndexByName
                if (data.length > 0) {
                    getFieldsMetadata().forEach(function (field, index) {
                        _fieldIndexByName[field.name] = index;
                    });
                }

                defer.resolve();
            }, function (err) {
                defer.reject(err);
            });

        } else {
            defer.resolve();
        }

        return defer.promise;
    }
    
    function isFieldVisible(fieldName) {
        var fieldMd = getFieldMetadata(fieldName);
        if(fieldMd){
            return fieldMd.visible;
        }
        return false;
    }

    function addTransientField(fieldMD){
        fieldMD.hasTransient = true;
        fieldMD = angular.copy(DatasetUtils.buildStandAloneFieldMD(fieldMD));
       _fields.push(fieldMD);

       _fieldIndexByName[fieldMD.name] = _fields.length - 1;
       _transientFieldsName.push(fieldMD.name);

       if(StringUtils.toBoolean(fieldMD.isPk)){
           _primaryKeyFields.push(fieldMD.name);
       }
    }

    function getIgnoreListenerMethods(){
        if($scope.ignoreListenerMethods){
            return $scope.ignoreListenerMethods;
        }else{
            return '';
        }
    }
  /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setIgnoredMethodListener
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Metodo responsavél passar os metodos (interceptMetadata | interceptMetadataFields | interceptEntitiesElement) do crud listener que foram 
       implementados no frontend e não precisam mais ser validados e lançados os avisos.
     * @param {string} methodsIgnore Nome dos metodos, separados pos virgula, que devem ser ignorados.
     */
    function setIgnoredMethodListener(methodsIgnore){
        $scope.ignoreListenerMethods = methodsIgnore;
    }
    
    function setIgnoreExportName(value) {
    	_ignoreExportName = value;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#lockChangeRowAutoSave
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Metodo para travar a mudança de linha no dataset durante a mudança de linha (goToRow)
     * @param {boolean} lock Condição do lock.
     */
    function lockChangeRowAutoSave(lock){
        _lockChangeRowAutoSave = lock;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getExceptFieldsByEntity
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna campos que não devem ser adicionados no dynaform.
     */
    function getExceptFieldsByEntity(){
        return _exceptFieldsByEntity;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#getEntityForceUserFields
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description Retorna entidades que vão ser forçadas a carregar os campos adicionais.
     */
    function getEntityForceUserFields(){
        return _entityForceUserFields;
    }

    function updateRecord(oldRecord, newRecord) {
        if (!oldRecord && !newRecord) {
            return;
        }

        var isInsertion = isInsertionMode();

        newRecord = buildDSRecord(newRecord, false);

        var rowMD = getRowMetadata(oldRecord);

        angular.copy(newRecord, oldRecord);

        oldRecord[_fields.length] = rowMD;
        newRecord[_fields.length] = rowMD;

        _records.refresh(true, true);

        notifyDataSetObservers(DatasetObserverEvents.EVENT_DATA_SAVED, {
            isNew: isInsertion,
            records: [newRecord]
        });

    }

    function setInitDatasetLazyLoad(lazyLoad){
        _initDatasetLazyLoad = lazyLoad;
    }

    function isInitDataSetLazyLoad(lazyLoad){
        return _initDatasetLazyLoad;
    }

    function isAlternativeParentKey(){
        return !!_alternativeParentPropertyName;
    }

    function isLazyLoad(){
        return $scope.lazyLoad;
    }

    function setLazyLoad(lazyLoad){
        $scope.lazyLoad = lazyLoad;
    }

    function removeCriteriaProviderIndex(criteriaProviderIndex) {
        if(_criteriaProviders){
            if (criteriaProviderIndex > -1 && _criteriaProviders[criteriaProviderIndex]) {
                _criteriaProviders.splice(criteriaProviderIndex, 1);
            }
        }
    }

    function doUpdateRMD(fieldMetadata, metadataName, record){
        let fieldName = fieldMetadata.name;
        let rowMetadata;

        //percorrer o Array de funções e cada função armazenada será chamada
        if (angular.isArray(_beforeLoadRowMetadata) && _beforeLoadRowMetadata.length) {
            _beforeLoadRowMetadata.forEach(($callback) => {
                if (angular.isFunction($callback)) {
                    $callback(self);
                }
            });
        }

        //esse esquema de cache de metadata é útil para evitar o roundtrip para o servidor
        //pois é possível que algum registro já o tenha...
        if(_rowMetadataCache != undefined){
            rowMetadata = _rowMetadataCache[buildCacheKey(fieldName, metadataName, record)];
        }
        
        if(rowMetadata != null){
            assignRowMetadata(record, fieldName, metadataName, rowMetadata);
        } else {

            var request = {
                dataSetID: _datasetID,
                entityName: $scope.entityName,
                standAlone: _standAlone,
                fields: getFieldNamesForRequest(false, true, true).filter(f => f.indexOf('.') == -1 ),
                standAloneFieldsMD: getStandAloneFieldsMD(),
                metadataName: metadataName,
                fieldName: fieldName
            };

            let valueToSave = {};

            record.forEach((value, i) => {
                let field = _fields[i];
                let fieldIndex = field ? request.fields.indexOf(field.name) : -1;
                if(fieldIndex > -1){
                    valueToSave[fieldIndex] = strToTypedData(value, field.dataType);
                }
            });
            
            //Removemos o rowmetadata
            if(valueToSave.hasOwnProperty(_fields.length)){
                delete valueToSave[_fields.length];
            }

            request.record = {
                pk: isInsertionMode() ? undefined : buildPkObject(record, false),
                oldPk: (!isInsertionMode() && _allowPKModification) ? buildOldPkObject() : undefined,
                foreignKey: _parentDataSet ? buildForeignKeyObject(true) : undefined,
                values: valueToSave
            };

            putTxPropertiesOnRequest(request);
            
            ServiceProxy.callService(
                'DatasetSP.' + LOAD_ROW_METADATA,
                request,                
            ).then(function(result){
                processRowMetadata(result.responseBody._rmd, record);
                _txProperties = undefined;
            },
            () => serviceCallFailureHandler() );
        }
    }

    function buildCacheKey(fieldName, metadataName, record){
        let fIndex = getFieldIndexByName(fieldName);
        return fieldName + "_" + metadataName + "_" + DatasetUtils.dataToString(record[fIndex]);
    }

    function processRowMetadata(rowMetadata, record){
        if(rowMetadata){
            if(!angular.isArray(rowMetadata)) rowMetadata = [rowMetadata];

            rowMetadata.forEach( metadataItem => {
                var fieldName = Object.keys(metadataItem).filter( item => item != 'provider' )[0];
                var metadataname = metadataItem.provider;
                
                assignRowMetadata(record, fieldName, metadataname, metadataItem);
                
                if(_rowMetadataCache == null){
                    _rowMetadataCache = {};
                }

                _rowMetadataCache[buildCacheKey(fieldName, metadataname, record)] = metadataItem;
            });
        }
    }

    function assignRowMetadata(record, fieldName, metadataName, rowMetadata){
        var recordMetadata = record[_fields.length] ? record[_fields.length].rmd : undefined;
        var providerChanged = false;
        
        if(!recordMetadata){
            recordMetadata = {};            
        } else {
            providerChanged = true;
        }

        if(!record[_fields.length]){
            record[_fields.length] = {};
        }
        
        record[_fields.length].rmd = rowMetadata;       
        
        if(record == getCurrentRow()){            
            notifyDataSetObservers(DatasetObserverEvents.EVENT_ROW_METADATA_CHANGED, {reason: "PROVIDER_CHANGED", providerChanged: providerChanged } );
        }
    }

    function onFocusout(fieldBinder){
        updateRMD(fieldBinder.getFieldName(), getCurrentRow());
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#setObserversEnabled
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Metodo para habilitar/desabilitar as notificações(observers) do dataset
     * @param {boolean} Condição para habilitar/desabilitar as notificações do dataset.
     */
    function setObserversEnabled(value){
        _observersEnabled = value;
    }

     /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#validateRecord
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por validar os registros do dataset
     * @return {boolean} Retorna um booleano
     * @example
     * <pre>
     *      dataset.validateRecord();
     * </pre>
     */
    function validateRecord(recordToValidade, nullFieldNames = []) {
        var continueSave = true;

        ObjectUtils.forEachInObject(_fieldsPersonalizedValidation, function(key, fn){
            var result = true;
            if(angular.isFunction(fn)){
                result = fn();
                if(!angular.isUndefined(result)){
                    continueSave = result;
                }
            }
           return !result;
        });

        if (continueSave) {
            if (StringUtils.isEmpty(recordToValidade)) {
                recordToValidade = [];
                if (_isInsertionMode) {
                    recordToValidade.push(_transientRecord);
                } else if (_multiEditMode) {
                    recordToValidade = _selectedRecords.slice(0);
                } else {
                    recordToValidade.push(getCurrentRow());
                }
            } else if (angular.isObject(recordToValidade)) {
                recordToValidade = [recordToValidade];
            }
    
            for (var i in _recordValidators) {
                var validator = _recordValidators[i];
    
                for (var j in recordToValidade) {
                    var recordToSave = recordToValidade[j];
    
                    if (validator.validate(recordToSave, nullFieldNames) === false) {
                        return false;
                    }
                }
            }
        }

        return continueSave;
    }

    /**
     * @ngdoc
     * @name snk.components.dataset.directive:sk-dataset#addBeforeLoadRowMetadata
     * @methodOf snk.components.dataset.directive:sk-dataset
     * @description
     * Método responsável por receber por parâmetro uma função que será armazenada em um array de funções,
     * que serão chamadas antes de carregar os metadados de linha ao acionar o mecanismo de atualização.
     * @example <script> dataset.addBeforeLoadRowMetadata(() => {...}); </script>
     * @param {function} $callback função para ser chamada no mecanismo de atualização.
     */
    function addBeforeLoadRowMetadata($callback) {
        if (angular.isFunction($callback)) {
            let newElement = true;

            if (angular.isArray(_beforeLoadRowMetadata) && _beforeLoadRowMetadata.length) {
                newElement = _beforeLoadRowMetadata.indexOf($callback) === -1 && 
                            !_beforeLoadRowMetadata.includes($callback) ? true : false;

                if (newElement) {
                    if (angular.isDefined($callback.name) && !StringUtils.isEmpty($callback.name)) {
                        newElement = _beforeLoadRowMetadata
                            .filter(($element) => $element.name === $callback.name).length ? false : true;
                    } else {
                        newElement = _beforeLoadRowMetadata
                            .filter(($element) => $element.toString() === $callback.toString()).length ? false : true;
                    }
                }
            }

            if (newElement) {
                _beforeLoadRowMetadata.push($callback);
            } else {
				console.warn(`[SkDatasetController.addBeforeLoadRowMetadata] A função ${$callback.name || 'anônima'} já foi adicionada!`);
            }

        } else {
            throw new Error('O elemento adicionado não é uma função válida!');
        }
    }

    function setEnableInsertionModeGrid(value){
        _enableInsertionModeGrid = value;
    }

    function isEnableInsertionModeGrid(){
        return _enableInsertionModeGrid;
    }

    function setKeepMetadataWhileConverting(value){
        _keepMetadataWhileConverting = value;
    }

    function getDataSetElement(appendTxProperties = false) {
        var dataSetElement = {
            rootEntity: $scope.entityName
        };

        dataSetElement.entity = buildEntityList();

        if (angular.isDefined($scope.crudListener)) {
            dataSetElement.crudListener = $scope.crudListener;
        }

        if (angular.isDefined($scope.orderByExpression)) {
            dataSetElement.orderByExpression = $scope.orderByExpression;
        }

        if (angular.isDefined(_parentDataSet)) {
            dataSetElement.parentEntity = _parentDataSet.getEntityName();
        }

        if (angular.isDefined(_showBlobFields)) {
            dataSetElement.showBlobFields = "S";
        }

        dataSetElement.includePresentationFields = "S";
        dataSetElement.parallelLoader = _parallelLoader;

        /* TODO - ver caso de uso para implementar
        for (fkElem of _foreingKeyFields) {
           
        }
        if (appendTxProperties) {
            
        }*/

        return dataSetElement;
    }

    function buildEntityList() {
        var entityList = [];
        var entities = {};
        for (field of _fields) {
            var path = field.entityPath;

            if (!angular.isDefined(path)) {
                path = "<LOCAL>";
            }

            var entityElement = entities[path];
            if (entityElement) {
                continue;
            }

            entityElement = {};
            if ($scope.entityName == field.entityPath) {
                entities[path] = path;
                entityElement.fieldset = { list: "*" };
            } else {
                var name = field.name;
                var entityName = "";

                if (name.indexOf(".") > -1) {
                    entityName = name.substr(0, name.indexOf("."));
                }

                entities[entityName] = entityName;
                entityElement.path = entityName;
                entityElement.field = { name: field.id };
            }

            entityList.push(entityElement);
        }

        return entityList;
    }

    function silentSave() {
    	var options = angular.extend({}, _defaultOptionsToSave, angular.isObject(options) ? options : {});
    	
    	var newRecord = buildDSRecord(getCurrentRow(), _isInsertionMode);
    	
    	var currentIndex = getCurrentIndex();
    	var lastInsertedRecord;

        if (_isInsertionMode) {
            _records.addItem(newRecord);
            
            lastInsertedRecord = newRecord;

        } else {
            var oldReference = _records.getItem(currentIndex);

            var rowMD = getRowMetadata(oldReference);

            angular.copy(newRecord, oldReference);

            oldReference[_fields.length] = rowMD;
            newRecord[_fields.length] = rowMD;
        }
        
        _records.refresh(options.preventSort, options.preventFilter);

        var reason;

        if (lastInsertedRecord) {
            reason = DatasetEvents.RECORD_CHANGED_REASON_INSERT;

            currentIndex = _records.indexOf(lastInsertedRecord);

            if (currentIndex == -1) {
                currentIndex = _records.length() - 1;
            }
        }

        clearEdition();

        return changeRow(currentIndex, !_processingAutosave, false, reason);
    }

    function setIgnoreRMDOnInsert(value) {
        _ignoreRMDOnInsert = value;
    }

    function getIgnoreRMDOnInsert() {
        return _ignoreRMDOnInsert;
    }

    function setUseDefaultRowsLimit(value){
        $scope.useDefaultRowsLimit = value;
    }

    function fieldIsHierarchyEntity(fieldName) {
        return ArrayUtils.findIndex(getFieldsMetadata(), function (fieldMD) {
            return fieldMD.name === fieldName && angular.isDefined(fieldMD.fk) && StringUtils.toBoolean(fieldMD.fk.isHierarchyEntity);
        }) > -1;
    }

    function getLastModifiedField(){
        return lastModifiedField;
    }

    function notifyFinishedEdition(fieldName, newValue, oldValue){
        notifyDataSetObservers(DatasetObserverEvents.EVENT_FINISHED_EDITION, {fieldName, newValue, oldValue})
    }

    function addFinishedEditionListener(listener) {
        var obs = new IDataSetObserver();
        obs.onFinishEdition = listener;

        return addObserver(obs);
    }
    
    function setPkHistorica(value){
		_pkHistorica = value;
	}

    function addFieldsHierarchyExpression (fields){
        fieldsToAddExpression=ArrayUtils.toArray(fields);
    }

    function setEnableDeleteFromNavigator(value){
        _enableDeleteFromNavigator = value;
    }

    function getEnableDeleteFromNavigator(){
        return _enableDeleteFromNavigator;
    }
}

/**
 * @ngdoc directive
 * @name snk.components.dataset.directive:sk-dataset
 * @restrict E
 * @scope
 * @description
    <p align="justify"> Dataset é o componente responsável por realizar o controle dos registros de uma entidade no lado do cliente.
    É um componente de mais baixo nível em relação aos componentes do sankhya-js,
    pois os demais componentes utilizam como base as informações providas por este componente.
    Ele possui métodos que realizam o carregamento, edição, e persistência dos registros, 
    bem como uma vasta gama de eventos que são disparados antes e depois de cada uma destas rotinas acimas serem executadas.</p>
 
 * @param {string} entityName Nome da entidade base que o dataset representará caso não seja standalone
 * 
 * @param {Dataset} parentDataset Referencia de um dataset que será tratado como master.
 
 * @param {function}  metadata-provider 
    - Função responsável por carregar de forma personalizada os metadados para o dataset
    - Recebe como argumento a função <b>setMetadata</b> que deve ser chamada ao finalizar a construção dos metadados,
    passando os metadados como parâmetro
    
 * @param {function} metadata-interceptor
    - Interceptador de metadados chamado durante o carregamento do dataset
    - Recebe como argumento os objetos <b>fieldMds</b>, e <b>dataset</b>

 * @param {function} before-refresh-action
    - Função que será executada antes de uma chamada de <b>refresh</b>, caso a mesma retorne <b>false</b> então o processo é cancelado.

* @param {function} before-post-action
    - Função que será executada antes de uma chamada de <b>save</b>, caso a mesma retorne <b>false</b> então o processo é cancelado.
    
 * @param {string} order-by
    - Responsável para passar ao dataset uma string de <b>ORDER BY</b>

 * @param {function} sk-save-handler
    - Função que irá executar um save específico e não o padrão do dataSet, isso se faz necessário em alguns casos onde o save utilizado é uma chamada de serviço.
    - O único parametro é "request", um objeto que contém todas as informações necessárias para realizar o save.
    - O retorno desta função é opcional e pode ser um resultado direto ou uma promessa, onde o valor deve ser um array de arrays ou objetos com os novos valores, caso o retorno seja um objeto e contenha a propriedade 'responseBody' então o valor é pego lá de dentro, padrão de nossas chamadas de serviço.

* @param {function} sk-remove-handler
    - Função que irá executar um remove específico e não o padrão do dataSet, isso se faz necessário em alguns casos onde o remove utilizado é uma chamada de serviço.
    - o único parametro é "request", um objeto que contém todas as informações necessárias para realizar o remove.

* @param {function} sk-refresh-handler
    - Função que irá executar um refresh específico e não o padrão do dataSet, isso se faz necessário em alguns casos onde o refresh utilizado é uma chamada de serviço.
    - O único parametro é "request", um objeto que contém todas as informações necessárias para realizar o refresh.
    - O retorno desta função pode ser um resultado direto ou uma promessa, onde o valor deve ser um array de arrays
     ou objetos com os novos valores, caso o retorno seja um objeto e contenha a propriedade 'responseBody' então o valor é pego lá de dentro,
     padrão de nossas chamadas de serviço.

* @param {function} sk-dataset-created Função que será chamada quando a construção do dataset for finalizada. Esta
    deve ser utilizada para guardar o ponteiro do dataset e realizar as configurações necessárias no mesmo.

* @param {string} crud-listener Nome da implementação do CRUDListener que será chamado no servidor quando o dataset interagir com o mesmo.

* @param {string} sk-restrict-key-handlers Array que pode ser passado para o dataset para limitar os binds que serão feitos

* @param {string} sk-presentation-field Usado para forçar um campo de apresentação no dataset.

* @param {boolean} [sk-load-description-fields-stand-alone=undefined] Usado para forçar o dataset carregar os metadados e dados do campo de descrição de um campo fk stand alone.

* @param {string} [sk-ignore-listener-methods] parametro utilizado para passar os metodos (interceptMetadata | interceptMetadataFields | interceptEntitiesElement) do crud listener que foram 
implementados no frontend e não precisam mais ser validados e lançados os avisos. Exemplo: <sk-dataset sk-ignore-listener-methods="interceptMetadata,interceptMetadataFields,interceptEntitiesElement"></sk-dataset>

* @param {string} [try-joined-Fields='true'] parâmetro utilizado como 'false' será nos casos quando existir 'crudListener' e nela for alterado valor da propriedade de ligação, será buscado no DynamicVO não no tryJoinedFields.

* @example
     <example module="app">
         <file name="exemplo1.html">
                <sk-application ng-controller="ExampleController as ctrl" layout-padding sk-bg-color="white" style="height: 400px;">
                    <sk-dataset
                        sk-presentation-field="CAMPOSTR"
                        sk-save-handler="ctrl.saveHandler(request)"
                        sk-remove-handler="ctrl.removeHandler(request)"
                        sk-refresh-handler="ctrl.refreshHandler(request)" 
                        sk-dataset-created="ctrl.onDatasetCreated(dataset)" sk-standalone>
                            <sk-dsfield-md name="CAMPOSTR" description="Campo String"></sk-dsfield-md>
                            <sk-dsfield-md name="CAMPONUM" description="Campo Numerico" user-type="I" group-name="Grupo 1"></sk-dsfield-md>
                            <sk-dsfield-md name="CAMPOSW" description="Campo Switch" presentation-type="S" group-name="Grupo 2"></sk-dsfield-md>
                            <sk-dsfield-md name="CAMPOCOMBO" description="Campo Combo" group-name="Grupo 2">
                                <sk-options>
                                    <sk-option data="A" label="Opcao A"></sk-option>
                                    <sk-option data="B" label="Opcao B"></sk-option>
                                    <sk-option data="C" label="Opcao C"></sk-option>
                                </sk-options>
                            </sk-dsfield-md>
                    </sk-dataset>
                    <sk-double-face-panel flex>
                        <sk-top-bar layout-bottom-padding>
                            <sk-navigator dataset="ctrl.myDS"></sk-navigator>
                        </sk-top-bar>
                        <sk-face-one>
                            <sk-form sk-dataset="ctrl.myDS" white flex></sk-form>
                        </sk-face-one>
                        <sk-face-two>
                            <sk-datagrid sk-dataset="ctrl.myDS" sk-margin="10"></sk-datagrid>
                        </sk-face-two>
                    </sk-double-face-panel>
                </sk-application>
         </file>
         <file name="app.js">
             angular
                .module('app', ['snk'])
                .controller('ExampleController', ['$q', 'Criteria', function($q, Criteria){
                    var self = this;
                    
                    self.myDS;

                    self.onDatasetCreated = onDatasetCreated;
                    self.saveHandler = saveHandler;
                    self.removeHandler = removeHandler;
                    self.refreshHandler = refreshHandler;

                    function saveHandler(request) {
                        //No saveHandler não é necessário retornar algo, o dataset irá guardar como salvo a linha em memoria.
                        //Mas geralmente, após salvarmos um registro esse pode ser modificado por triggers ou listeners no servidor
                        //então nesses casos devemos retornar para o dataset a versão atualizada do registro salvo.
                        
                        //Apenas para demonstrar uma alteração que o o servidor faria
                        var currentRow = self.myDS.getCurrentRow();
                        currentRow[0] = 'Campo Modificado';
                        return [
                            currentRow
                        ];
                    }

                    function removeHandler(request) {
                        console.log(request);
                    }

                    function refreshHandler(request) {
                        console.log(request);

                        return $q(function(resolve, reject) { //Simulando uma carga assíncrona
                            //chame a função "reject" para abortar a carga

                            setTimeout(function() {
                                resolve([
                                    ['Campo1', 1, 'S'],
                                    ['Campo1', 2, 'N'],
                                    ['Campo1', 3, 'S'],
                                    ['Campo1', 4, 'N']
                                ]);
                            }, 3000);
                        });
                    }
                    
                    function onDatasetCreated(dataset) {
                        self.myDS = dataset;

                        dataset.addCriteriaProvider(new CriteriaProvider(Criteria('this.CODCID > 0')));

                         dataset.initAndRefresh().then(function() {
                            console.log('Refresh realizado');
                        });
                    }
                }]);
         </file>
     </example>

 */

angular
    .module('snk.components.dataset')
    .directive('skDataset', ['SkApplication', function(SkApplication) {
        return {
            priority: 5000,
            restrict: 'E',
            scope: {
                uniqueId: '@',
                id: '@',
                entityName: '@',
                parentDataset: '=?',
                metadataProvider: '=',
                metadataInterceptor: '=?',
                beforeRefreshAction: '=?',
                beforePostAction: '=',
                saveHandler: '&?skSaveHandler',
                removeHandler: '&?skRemoveHandler',
                refreshHandler: '&?skRefreshHandler',
                datasetCreated: '&skDatasetCreated',
                orderByExpression: '@orderBy',
                crudListener: '@?',
                restrictKeyHandlers: '=?skRestrictKeyHandlers',
                selectFirstOnRefresh: '=?skFirstOnRefresh',
                loadDescriptionFieldsStandAlone: '=?skLoadDescriptionFieldsStandAlone',
                workerClass: '@?',
                //skPresentationField Apenas attr
                ignoreListenerMethods: '@?skIgnoreListenerMethods',
                lazyLoad: '=?skLazyLoad',
                tryJoinedFields: '=?',
                useDefaultRowsLimit: '=?skUseDefaultRowsLimit',
                acceptPromiseSearchField: '=?skAcceptPromiseSearchField'
            },
            controller: 'SkDatasetController',
            link: function (scope, element, attrs, controller) {
                if (attrs.id) {
                    scope.$parent[scope.id] = controller;

                    var appCtrl = SkApplication.instance().getAppController(); 

                    if (appCtrl) {
                        appCtrl[scope.id] = controller;
                    }
                }
            }
        };
}]);


angular
    .module('snk.components.dataset')
    .service('DatasetUtils', ['NumberUtils', '$compile', '$q', 'ObjectUtils', 'MetadataProvider', 'DateUtils', 'DateUtilsConstants', 'Base64', 'StringUtils', 'SkI18nService', 'ArrayUtils', 'Criteria', 'DatasetContants',
        function (NumberUtils, $compile, $q, ObjectUtils, MetadataProvider, DateUtils, DateUtilsConstants, Base64, StringUtils, SkI18nService, ArrayUtils, Criteria, DatasetContants) {
            var self = this;

            var MAIN_TAB_NAME = self.MAIN_TAB_NAME = '__main';

            const DEFAULT_FIELD_MD = {                
                userType: 'S',
                dataType: 'S',
                visible: true,                                        
                description: ''
            };

            self.prepareMetadata = prepareMetadata;
            self.dataToString = dataToString;
            self.formatDate = formatDate;
            self.isDateType = isDateType;
            self.isDefined = isDefined;
            self.buildPkHash = buildPkHash;
            self.buildDependentFieldsCriteria = buildDependentFieldsCriteria;
            self.buildDatasetStandaloneAtObject = buildDatasetStandaloneAtObject;
            self.buildTagDsfieldMd = buildTagDsfieldMd;
            self.getCriteriaParameterFromDataset = getCriteriaParameterFromDataset;
            self.buildEntitiesRequestInfo = buildEntitiesRequestInfo;
            self.processEntitiesRequestPaths = processEntitiesRequestPaths;
            self.buildStandAloneFieldMD = buildStandAloneFieldMD;
            self.convertObjectFieldToDatasetField = convertObjectFieldToDatasetField;
            self.orderFieldsFromGroupName = orderFieldsFromGroupName;

            function buildEntitiesRequestInfo(entityName, metadataFieldsRequestInfo) {
                var entitiesForRequest = [entityName];
                var entitiesForRequestPaths = {};

                if (metadataFieldsRequestInfo.length > 0) {
                    var rootFieldsRequestInfo = undefined;

                    angular.forEach(metadataFieldsRequestInfo, function (requestInfo) {
                        if(requestInfo.except == true || requestInfo.pattern === DatasetContants.DEFAULT_USER_FIELDS){
                            return;
                        }
                        if (!angular.isDefined(requestInfo.path)) {

                            if (angular.isDefined(rootFieldsRequestInfo)) {                               
                                throw new Error('Não é possível definir os campos da instância principal mais de uma vez.');
                            }

                            rootFieldsRequestInfo = requestInfo;
                        }

                        if (requestInfo.path) {
                            var path = requestInfo.path.split('.');

                            path.forEach(function (entityName, index) {
                                if (entitiesForRequest.indexOf(entityName) == -1) {
                                    entitiesForRequest.push(entityName);
                                }

                                if (index == (path.length - 1)) {
                                    entitiesForRequestPaths[requestInfo.path] = entityName;
                                }
                            });
                        }
                    });
                }

                return {
                    rootFieldsRequestInfo: rootFieldsRequestInfo,
                    entitiesForRequest: entitiesForRequest,
                    entitiesForRequestPaths: entitiesForRequestPaths
                }
            }

            function processEntitiesRequestPaths(md, entitiesRequestInfo) {
                angular.forEach(entitiesRequestInfo.entitiesForRequestPaths, function (entityName, path) {
                    if (path !== entityName) {
                        var entityMD = ObjectUtils.cloneJSON(md.entities[entityName]);
                        entityMD.name = path;
                        md.entities[path] = entityMD;

                        if (md.relations) {
                            entityMD = md.relations[entityName];
                            if (entityMD) {
                                entityMD.fields.forEach(function (field) {
                                    if (field.fk) {
                                        field.fk.relationShipName = path;
                                    }
                                });
                            }
                        }
                    }
                });
            }

            function dataToString(value, isEncodedTransport, options) {
                if (value == null) {
                    return '';
                }

                var type = typeof (value);
                var strValue;

                switch (type) {
                    case 'number':
                    case 'string':
                        strValue = value.toString();
                        break;
                    case "object":
                        if (value instanceof Date) {
                            var format = DateUtilsConstants.DEFAULT_DATETIME_FORMAT;

                            if (options && options.dateFormat) {
                                format = options.dateFormat;
                            }

                            strValue = DateUtils.formatDate(value, format);
                        } else if (value instanceof Object) {							
							angular.forEach(value[0], function(vlr) {
                                strValue = vlr;
                            });
						} else {
                            throw new Error('Falha ao converter valor: [' + value + ',' + type + ']');
                        }
                        break;
                    default:
                        strValue = value.toString();
                }


                if (isEncodedTransport === true) {
                    strValue = Base64.encode(strValue);
                }

                return strValue;
            }

            function isDateType(dataType) {
                return (dataType === 'D' || dataType === 'H' || dataType === 'T');
            }

            function formatDate(value, dataType) {
                if (!dataType || !value) {
                    return value;
                }

                if (value instanceof Date) {
                    if (dataType === 'D') {
                        return dataToString(value, false, { dateFormat: 'DD/MM/YYYY' });
                    } else if (dataType === 'H') {
                        return dataToString(value, false, { dateFormat: 'DD/MM/YYYY HH:mm:ss' });
                    } else if (dataType === 'T') {
                        return dataToString(value, false, { dateFormat: 'HH:mm:ss' });
                    }
                }

                return value;
            }

            function prepareMetadata(md, fieldFilter, parentEntityName, baseEntityName) {
                var deferred = $q.defer();

                if (parentEntityName) {
                    MetadataProvider.getEntityMetadata(parentEntityName)
                        .then(function (entityMD) {
                            deferred.resolve(doPrepareMetadata(md, fieldFilter, entityMD[parentEntityName], baseEntityName));
                        });
                } else {
                    deferred.resolve(doPrepareMetadata(md, fieldFilter, undefined, baseEntityName));
                }

                return deferred.promise;
            }

            function getParentRelation(parentEntityMD, entityName) {

                if (parentEntityMD) {
                    for (var i = 0; i < parentEntityMD.relations.length; i++) {
                        var relation = parentEntityMD.relations[i];

                        if (relation.toEntity == entityName) {
                            return relation;
                        }
                    }
                }

                return undefined;
            }

            function buildPkHash(pk) {
                var strPk = '';

                angular.forEach(pk, function (value, key) {
                    strPk += (key + '=' + value + ';');
                });

                return strPk;
            }

            function doPrepareMetadata(md, fieldFilter, parentEntityMD, baseEntityName) {
                var entitiesMetadata = md.entities;
                var relationsMetadata = md.relations || {};

                var fieldsByEntity = {};
                var foreingKeyFields = [];

                var allFields = [];

                var baseEntityDescription = ObjectUtils.getProperty(entitiesMetadata, baseEntityName + '.description');

                ObjectUtils.forEachInObject(entitiesMetadata, function (entityName, entityMD) {
                    var entityFields = [];

                    if (baseEntityName === entityName) {
                        var parentRelation = getParentRelation(parentEntityMD, entityName);

                        if (parentRelation) {
                            angular.forEach(parentRelation.fields, function (fkField) {
                                foreingKeyFields.push({
                                    localField: fkField.toField,
                                    parentFieldName: fkField.fromField
                                });
                            });
                        }
                    }

                    entityMD.fields.forEach(function (field) {
                        if (fieldFilter && !fieldFilter(entityMD, field)) {
                            return;
                        }

                        if (!field.entityDescription && entityMD.description) {
                            field.entityDescription = entityMD.description;
                        }

                        if (angular.isDefined(baseEntityName) && baseEntityName != entityName && !field.standAlone) {
                            field.name = entityName + '.' + field.name;
                        }

                        field.entityPath = entityName;

                        if (!field.dataType) {
                            field.dataType = field.userType;
                        }

                        if (isMainPainelField(entityMD, field)) {
                            field.tabId = MAIN_TAB_NAME;
                            field.tabName = MAIN_TAB_NAME;
                        } else {
                            var propTabId = ArrayUtils.find(field.properties, function (prop) {
                                return prop.name == 'tabId';
                            });

                            if (propTabId) {
                                field.tabId = propTabId.value;

                                if (['Geral', 'abaGeral'].indexOf(field.tabId) > -1) {
                                    field.tabId = 'general';
                                }

                                var propTabName = ArrayUtils.find(field.properties, function (prop) {
                                    return prop.name == 'UITabName';
                                });

                                field.tabName = propTabName && propTabName.value;
                            } else {
                                field.tabId = 'general';
                                field.tabName = SkI18nService.instant('Geral.lblGeral');
                            }
                        }

                        entityFields.push(field);
                    });

                    entityFields.sort(function (f1, f2) {
                        var diff = parseInt(f1.order) - parseInt(f2.order);
                        var f1IsRoot = String(entityMD.tableName) === String(f1.tableName);
                        var f2IsRoot = String(entityMD.tableName) === String(f2.tableName);

                        if ((f1IsRoot && f2IsRoot) || (!f1IsRoot && !f2IsRoot)) {
                            return diff;
                        } else if (f1IsRoot && !f2IsRoot) {
                            return -1;
                        } else {
                            return 1;
                        }
                    });

                    fieldsByEntity[entityName] = entityFields;
                    allFields = allFields.concat(entityFields);
                });

                //Se tem metadados de relação 1-1, então devemos incluir os campos de apresentação ao lado dos campos de fk.
                if (angular.isDefined(relationsMetadata)) {
                    var fieldsToAddDescription = baseEntityName ? fieldsByEntity[baseEntityName] : allFields;
                    let fieldsAdded = {};

                    fieldsToAddDescription.forEach(function (field) {
                        if (angular.isDefined(field.fk) && !field.standAlone) {
                            var targetEntity = field.fk.relationShipName;
                            let descFmd = field.fk.fmdPresentation;
                            let descFmdFromRootEntity = descFmd && Object.keys(descFmd).length > 0;

                            if (!angular.isDefined(relationsMetadata[targetEntity]) && !descFmdFromRootEntity) {
                                //throw new Error('Entidade de campo FK não encontrado na lista de relações [' + field.name + '@' + targetEntity + ']');
                                console.warn('Entidade de campo FK não encontrado na lista de relações [' + field.name + '@' + targetEntity + ']');
                                return;
                            }

                            var relationEntity = relationsMetadata[targetEntity];

                            if (relationEntity || descFmdFromRootEntity) {

                                var fkDescriptionFieldName; 

                                if(!descFmdFromRootEntity){
                                    if (field.properties) {
                                        var prop = ArrayUtils.find(field.properties, function (prop) {
                                            return prop.name == 'apresentacao';
                                        });

                                        if (prop) {
                                            fkDescriptionFieldName = prop.value;
                                        }
                                    }

                                    if (angular.isUndefined(fkDescriptionFieldName)) {
                                        fkDescriptionFieldName = relationEntity.presentationField;
                                    }
                                }else {
                                    fkDescriptionFieldName = descFmd.name;
                                }

                             
                                if (angular.isDefined(fkDescriptionFieldName)) {
                                    var fkDescriptionField;

                                    if(!descFmdFromRootEntity){                                        
                                        relationEntity.fields.forEach(function (fkField) {
                                            if (fkField.name === fkDescriptionFieldName) {
                                                fkDescriptionField = angular.copy(fkField);
                                                return;
                                            }
                                        });
                                    }else{
                                        fkDescriptionField = descFmd;
                                    }

                                    if (angular.isDefined(fkDescriptionField)) {
                                        var fkName = '';

                                        if (field.mergedFrom) {
                                            fkName += field.mergedFrom + '.';
                                        }

                                        fkName += targetEntity + '.' + fkDescriptionField.name;

                                        field.fk.descriptionFieldName = fkName;
                                        fkDescriptionField.name = fkName;
                                        fkDescriptionField.codeFieldName = field.name;
                                        fkDescriptionField.isDescriptionField = true;
                                        fkDescriptionField.required = false;

                                        if (relationEntity && relationEntity.description) {
                                            fkDescriptionField.entityDescription = relationEntity.description;
                                        }else{
                                            fkDescriptionField.entityDescription = descFmd.relationEntityName;
                                        }

                                        var relationShipDescription = field.fk.relationShipDescription;

                                        if (angular.isUndefined(relationShipDescription)) {
                                            if(!descFmdFromRootEntity){
                                                relationShipDescription = relationEntity.description
                                            }else{
                                                relationShipDescription = descFmd.relationEntityName;
                                            }
                                        }

                                        field.$relationShipDescription = relationShipDescription;
                                        fkDescriptionField.$tmpRelationShipDescription = relationShipDescription;
                                        
                                        if (fieldsAdded.hasOwnProperty(fkDescriptionField.description)) {
                                            /*
                                            Caso já exista um campo com o label atual, temos
                                            que adicionar o nome da ligação no label deste
                                            campo tambem, caso contrario ele ficara sem a
                                            info e não saberemos de onde vem esse campo.
                                            */
                                            if (angular.isObject(fieldsAdded[fkDescriptionField.description])) {

                                                let oldField = fieldsAdded[fkDescriptionField.description];
                                                oldField.description = oldField.description + ' (' + oldField.$tmpRelationShipDescription + ')';
                                                delete oldField.$tmpRelationShipDescription;
                                                fieldsAdded[fkDescriptionField.description] = true;

                                            }

                                            fkDescriptionField.description = fkDescriptionField.description + ' (' + relationShipDescription + ')';
                                        } else {
                                            fkDescriptionField.description = fkDescriptionField.description;
                                            fieldsAdded[fkDescriptionField.description] = fkDescriptionField;
                                        }

                                        fkDescriptionField.dataType = 'S';

                                        var fieldIndex = allFields.indexOf(field);
                                        ArrayUtils.insertAtIndex(allFields, fieldIndex + 1, fkDescriptionField);
                                    } else {
                                        throw Error('Campo de descrição não na entidade de destino [' + fkDescriptionFieldName + '@' + targetEntity + ']')
                                    }
                                }
                            }
                        }
                    });
                }

                var ambiguousfields = {};
                var hasAmbiguousFields = false;

                allFields.forEach(function (field, index) {
                    field.order = index;

                    var isAmbiguous = addToAmbiguousFields(ambiguousfields, field, baseEntityDescription);

                    if (!hasAmbiguousFields && isAmbiguous) {
                        hasAmbiguousFields = true;
                    }
                });
                
                

                if (hasAmbiguousFields) {
                    ObjectUtils.forEachInObject(ambiguousfields, function (key, value) {
                        if (angular.isArray(value) && value.length > 1) {
                            value.forEach(function (ambField) {
                                if (!ambField.isDescriptionField) {
                                	var isDashboardGrid = ambField.entityDescription === 'DashboardGridPersonalizedEntity';

	                                if (!isDashboardGrid && ambField.entityDescription != baseEntityDescription) {
	                                    ambField.description = ambField.description + ' (' + (ambField.$relationShipDescription || ambField.entityDescription) + ')';
	                                }
                                }
                            });
                        }
                    });
                }

                return {
                    entitiesMetadata: entitiesMetadata,
                    fieldsByEntity: fieldsByEntity,
                    foreingKeyFields: foreingKeyFields,
                    allFields: allFields
                };
            }

            function isMainPainelField(entityMD, fieldMD) {
                return (entityMD.presentationField == fieldMD.name) || (entityMD.pk && entityMD.pk.indexOf(fieldMD.name) > -1);
            }

            function addToAmbiguousFields(ambiguousfields, field, baseEntityDescription) {
                if (!field.visible || field.standAlone || field.entityDescription == baseEntityDescription) {
                    /**
                     * caso seja a entidade base, devemos adicionar o campo como ambiguo, pois,
                     * se o mesmo label aparecer em uma entidade relacionamento, devera ser adicionado
                     * o label da entidade de ligação.
                     * Exemplo: Financeiro.CGC_CPF_PARC
                     *          Financeiro.Parceiro.CGC_CPF
                     * No exemplo acima, os dois campos ficavam com label CNPJ / CPF, sem ter como 
                     * saber referente a qual entidade é o CNPJ / CPF
                     */
                    if(field.entityDescription == baseEntityDescription){
                        
                        var ambFieldsList = ambiguousfields[field.description];
                        
                        if (angular.isArray(ambFieldsList)) {
                            ambFieldsList.push(field);
                        } else {
                            ambFieldsList = [field];
                            ambiguousfields[field.description] = ambFieldsList;
                        }

                    }
                    
                    return false;
                }

                var ambFieldsList = ambiguousfields[field.description];
                var isAmbiguous = false;

                if (angular.isArray(ambFieldsList)) {
                    ambFieldsList.push(field);
                    isAmbiguous = true;
                } else {
                    ambFieldsList = [field];
                    ambiguousfields[field.description] = ambFieldsList;
                }

                return isAmbiguous;
            }

            function buildDependentFieldsCriteria(dependentFields, dataset) {
                var criteria;

                if ((dependentFields && dependentFields.length > 0) && dataset) {
                    criteria = Criteria();

                    dependentFields.forEach(function (dependentField) {
                        var searchField = dependentField;

                        if (dependentField.indexOf('=>') > -1) {
                            var parts = dependentField.split('=>');

                            dependentField = parts[0];
                            searchField = parts[1];
                        }

                        if(dataset.isFieldVisible(dependentField)){
                        criteria.and(searchField + ' = ?', getCriteriaParameterFromDataset(dataset, dependentField, true));
                        }
                    });

                }
                return criteria;
            }

            function buildDatasetStandaloneAtObject(records, scope){

                if (!angular.isObject(records)) {
                    return;
                }

                if (!angular.isArray(records)) {
                    records = scope.standaloneDatasetObject = [records];
                }

                var fields = [];
                var hasFieldsMetadata = false;

                if(records.length == 1){
                    fields = records[0].fields;
                    hasFieldsMetadata = true;
                } else {
                	fields = records;
                }

                scope.refreshHandler = function(request){
                    return $q(function(resolve, reject) {

                        var rows = [];

                        var records = (scope.standaloneDatasetObject.length == 1) ? scope.standaloneDatasetObject[0].records : scope.standaloneDatasetObject;

                        records.forEach(function(record){
                            var keys = Object.keys(record);
                            
                            keys = keys?.sort();

                            var row = [];

                            for(var index in keys){
                                var attr = keys[index];
                                var index = scope.dataset.getFieldIndexByName(attr);
                                row.splice(index, 0, record[attr]);
                            }
                            rows.push(row);

                        }, rows);

                        resolve(rows);
                          
                    });
                }

                var fieldsName = [];

                var datasetStandalone = '<sk-dataset id="datasetStandaloneObject" sk-refresh-handler="refreshHandler(request)" sk-standalone>';

                fields.forEach(function(record){

                    var keys = Object.keys(record);

                    if(hasFieldsMetadata){
                        datasetStandalone += buildTagDsfieldMd(record, null, hasFieldsMetadata);
                    } else{
                        for(var index in keys){

                            var attr = keys[index];
    
                            if(fieldsName.indexOf(attr) == -1){
                                fieldsName.push(attr)
                                datasetStandalone += buildTagDsfieldMd(record, attr, hasFieldsMetadata);
                            }
                        }
                    }
                
                }, datasetStandalone, hasFieldsMetadata);

                datasetStandalone += '</sk-dataset>';

                var dataset = $compile(datasetStandalone)(scope);

                return dataset.data().$skDatasetController;

            }

            function buildTagDsfieldMd(record, attr, hasFieldsMetadata){
               
                var dsfieldMd = '';

                if(!hasFieldsMetadata){
                    dsfieldMd = '<sk-dsfield-md name="' + attr + '" user-type=';
                   
                    var value = record[attr];
    
                    if(typeof value === 'number'){
                        dsfieldMd += '"I"';
                    } else if(typeof value === 'string'){
                        dsfieldMd += '"S"';
                    } else if(value instanceof Date){
                        dsfieldMd += '"D"';
                    } else {
                        dsfieldMd += '"S"';
                    }

                } else {
                    dsfieldMd = '<sk-dsfield-md ';

                    if(record['name']){
                        dsfieldMd += ' name="' + record['name'] + '" ';
                    }

                    if(record['description']){
                        dsfieldMd += ' description="' + record['description'] + '" ';
                    }
                    
                    if(record['userType']){
                        dsfieldMd += ' user-type="' + record['userType'] + '" ';
                    }

                    if(record['dataType']){
                        dsfieldMd += ' data-type="' + record['dataType'] + '" ';
                    }

                    if(record['precision']){
                        dsfieldMd += ' precision="' + NumberUtils.getNumberOrDefault(record['precision'], 2) + '" ';
                    }

                    if(record['prettyPrecision']){
                        dsfieldMd += ' name="' + (record['userType'] == 'I') ? 0 : NumberUtils.getNumberOrDefault(record['prettyPrecision'], -1) + '" ';
                    }

                    if(record['size']){
                        dsfieldMd += ' size="' + NumberUtils.getNumberOrDefault(record['size'], -1) + '" ';
                    }

                    if(record['visible']){
                        dsfieldMd += ' visible="' + record['visible'] + '" ';
                    }

                    dsfieldMd += ' is-description-field="' + isDefined(record['isDescriptionField']) + '" ';
                    dsfieldMd += ' read-only="' + isDefined(record['readOnly']) + '" ';
                    dsfieldMd += ' required="' + isDefined(record['required'])  + '" ';
                }

                dsfieldMd += ' ></sk-dsfield-md> ';

                return dsfieldMd;
            }

            function isDefined(object){
                return(angular.isDefined(object) && object == 'true') ? 'true': 'false';
            }

            function getCriteriaParameterFromDataset(dataset, fieldName, required) {
                var fValue = StringUtils.emptyAsNull(dataset.getFieldValueAsString(fieldName));
                var fMetadata = dataset.getFieldMetadata(fieldName);

                if (fValue == undefined && required) {
                    var message;

                    if (!fMetadata) {
                        message = SkI18nService.instant("PesquisaInput.messageCampoNaoMapeadoPesquisa", { nome: fieldName });
                    } else {
                        message = SkI18nService.instant("PesquisaInput.messageFaltaCampo", { nome: fMetadata.description });
                    }

                    throw new CriteriaError(CriteriaError.ILLEGAL_CRITERIA_VALUE, message);
                }

                return Criteria.buildParameter(fMetadata ? (fMetadata.userType == 'ENTITY' ? fMetadata.dataType : fMetadata.userType) : 'S', fValue ? fValue : '');
            }

            function buildStandAloneFieldMD(fieldMD){
                if(!fieldMD.name){
                    throw "buildStandAloneFieldMD: O atributo name é obrigatório.";
                }
                return angular.extend(DEFAULT_FIELD_MD, fieldMD);
            }

            function convertObjectFieldToDatasetField(dataset, fieldsSource){
                var fields = [];
                var hasAnyOrder = false;
                if (angular.isDefined(fieldsSource) && !Array.isArray(fieldsSource)) {
                    fieldsSource = [fieldsSource];
                }
                for(var index in fieldsSource){

                    var fieldElem = fieldsSource[index] ? (fieldsSource[index].campo ? fieldsSource[index].campo : fieldsSource[index]) : fieldsSource;
                   
                    var field = {};

                    field.name               = fieldElem["nome"];
                    field.entityPath         = fieldElem["entidade"];
			 	    field.description        = fieldElem["descricao"];
			 	    field.type               = fieldElem["tipo"];
                    field.width              = fieldElem["tamanho"];
                    field.standAlone         = true;
                    
                    if(fieldElem["ordem"]){
                        field.order = fieldElem["ordem"];
                        hasAnyorder = true;
                    }
                    field.isNuable           = fieldElem["requerido"] != "true";
                    field.isPrimaryKey       = fieldElem["primaryKey"];
                    field.isReadOnly         = fieldElem["editavel"] == "false";
   
                    if(fieldElem["visivel"] && fieldElem["visivel"] == "false") {
                        field.visibleAttribute = "N";
                    }
                    
                    if(fieldElem["nuCasasDecimais"]) {
                        field.precision = fieldElem["nuCasasDecimais"];
                    }
   
                    if(fieldElem["groupName"]) {
                        field.groupName = fieldElem["groupName"];
                    }
                   
                    if(fieldElem["uiTabName"]) {
                        field.tabName = fieldElem["uiTabName"];
                    }
   
                   if(fieldElem["campoDestino"]){
                        field.fkTargetFieldName  = fieldElem["campoDestino"];
                        field.fkTargetEntityName = fieldElem["entidadeDestino"];
                        field.fkRelationName     = fieldElem["nomeRelacionamento"];
   
                        if(fieldElem["campoApresentacao"]){
                            field.fkDescriptionField = fieldElem["campoApresentacao"];
                        }
   
                        if(fieldElem["formCriteria"]){
                            field.formCriteria = fieldElem["formCriteria"];
                        }
                    }

                    if(fieldElem["criteriosRelacionamento"]){
                        var dependentFields = fieldElem["criteriosRelacionamento"];
        
                        if(!StringUtils.isEmpty(dependentFields)){
                             var dependentFieldsArray = [];

                             dependentFields = dependentFields.split(",");

                             for(var index in dependentFields){
                                var f = dependentFields[index].split("->");

                                if(f.length > 1){
                                    dependentFieldsArray.push({'localName': f[0], 'targetName': f[1]});
                                }else{
                                    dependentFieldsArray.push({'localName': f[0]});
                                }

                             }
                             
                            field.fkDependentFields = dependentFieldsArray;
                        }
                    }

                    fields.push(field);
                }
                
                if(hasAnyOrder){
                    fields.sort(function(a, b){
                         return b.order < a.order ?  1 
                                : b.order > a.order ? -1 
                                : 0;
                    });
                }

                return orderFieldsFromGroupName(fields);

            }

            function orderFieldsFromGroupName(fields){

                var lastFieldByGroup = new Object();
                var fieldsCol= [];
                var lastUngroupedField = null;
                var lastIndex = null;
                
                for(var index in fields){
                    var field = fields[index];
                    var groupName = field.groupName;

                    if(groupName){
                        if(lastFieldByGroup[groupName]){
                            fieldsCol.splice(fieldsCol.indexOf(lastFieldByGroup[groupName])+1, 0, field);
                        } else {
                            fieldsCol.push(field);
                        }
                        lastFieldByGroup[groupName] = field;
                    } else {
                        var i  = angular.isUndefined(lastUngroupedField) ? 0 : Number(index);
                        fieldsCol.splice(i, 0, field);
                        lastUngroupedField = field;
                        lastIndex = i;
                    }
                }
                
                return fieldsCol;

            }
        }]);

/**
 * Created by bruno.brandao on 29/11/2016.
 */
angular
    .module("snk.core.util")
    .provider('DatasetCreationSync', [function () {

        this.$get = ['$q', function ($q) {
            return function() {
            	return new DatasetCreationSync();
            }
            
            function DatasetCreationSync() {
                var self = this;

                var datasetCreationFuncs = [];

                self.add = add;
                self.whenAllCreated = whenAllCreated;

                function add(datasetCreationFunc) {
                    var deferred = $q.defer();

                    datasetCreationFuncs.push(deferred.promise);

                    return function(dataset) {
                        datasetCreationFunc(dataset);

                        deferred.resolve();
                    }
                }

                function whenAllCreated() {
                    return $q.all(datasetCreationFuncs);
                }
            }
        }];
    }]);
/**
 * @ngdoc directive
 * @name snk.components.dataset.directive:sk-field
 * @restrict E
 * @description
    sk-field é responsável por configurar no sk-dataset a lista de campos que serão utilizados para a entidade base
    e outras entidades que a mesma possuir ligação.

    <sk-field pattern="DESCRPROD,COMPLDESC" except="true"></sk-field> caso o carâmetro except seja passado como true, os campos contidos no parâmetro pattern
    não serão incluidos no dataset.

    <sk-field pattern="$USERFIELDS"></sk-field> caso o pattern seja igual a $USERFIELDS, todos os campos adicionais da entidade serão incluidos no dataset
    independente que qualquer outra regra configurada.


 * @example
 <example module="snk">
     <file name="exemplo.html">
        <!-- ONLY AS DEMONSTRATION
            <sk-dataset entity-name="ItemNota">
                <sk-field pattern="*" ></sk-field>
                <sk-field pattern="DESCRPROD,COMPLDESC" path="Produto"></sk-field>
            </sk-dataset>
        -->
     </file>
 </example>
 */
angular
    .module('snk.components.dataset')
    .directive('skField', [function() {
        return {
            restrict: 'E',
            require: ['^?skDataset', '^?skDynaform'],
            link: function link(scope, element, attrs, controllers) {
                var ctrl = controllers[0];

                if (!ctrl) {
                    ctrl = controllers[1];
                }

                if (!ctrl) {
                    throw new Error('Não foi encontrado o componente pai sk-dataset ou sk-dynaform');
                }

                ctrl.addFieldsRequestInfo({
                    path: attrs.path,
                    pattern: attrs.pattern,
                    except: attrs.except === 'true'
                });
            }
        };
    }]);



/**
 * @ngdoc directive
 * @name snk.components.dataset.directive:sk-dsfield-md
 * @restrict E
 * @description
    Diretiva responsável por configurar no sk-dataset a lista de campos que serão usados no modo standalone.<br/>
    Para mais informações sobre como utilizar essa diretiva, acesse a documentação do {@link snk.components.dataset.directive:sk-dataset sk-dataset}.
* @param {string} user-type Tipo do campo ['S'|'I'|'F'|'T'|'D'|'H'].
* @param {string} [presentation-type="P"] Tipo de apresentação do campo ['S'|'P'], onde 'S' = 'switch' e P = 'padrão'.
* @param {string} name Nome do campo.
* @param {string} description Label do campo.
* @param {boolean} is-pk Define se o campo faz parte da PK.
* @param {boolean} read-only Define se o campo é "somente-leitura".
* @param {boolean} required Define se o campo é obrigatório.
* @param {boolean} visible Define se o campo estará visível.
 */
angular
    .module('snk.components.dataset')
    .directive('skDsfieldMd', ['NumberUtils', 'ObjectUtils', 'i18n', function (NumberUtils, ObjectUtils, i18n) {
        return {
            restrict: 'E',
            require: '^skDataset',
            scope: {
                visibleField : '=?skVisibleField'
            },
            link: function link(scope, element, attrs, DatasetController) {
                var FK_PROPERTIES = {
                    'targetEntity': 'entity',
                    'targetField': '=',
                    'descriptionFieldName': '=',
                    'relationShipName': '=',
                    'isHierarchyEntity': '='
                };

                var name;

                init();

                function init() {
                    var userType = attrs.userType || 'S';
                    name = attrs.name;
                    var buildPrecisionFn;
                    if(attrs.buildprecisionfn){
                        buildPrecisionFn = ObjectUtils.getProperty(scope.$parent, attrs.buildprecisionfn);
                    }
                    var fieldMd = {
                        name: name,
                        description: attrs.emptyDescription == 'S' ? '' :  (i18n(attrs.description) || attrs.name),
                        isPk: angular.isDefined(attrs.isPk) ? (attrs.isPk == 'true') : false,
                        userType: userType,
                        dataType: attrs.dataType,
                        precision: (userType == 'I') ? 0 : angular.isFunction(buildPrecisionFn) ? buildPrecisionFn : NumberUtils.getNumberOrDefault(attrs.precision, 2),
                        prettyPrecision: (userType == 'I') ? 0 : NumberUtils.getNumberOrDefault(attrs.prettyPrecision, -1),
                        readOnly: angular.isDefined(attrs.readOnly) ? (attrs.readOnly == 'true') : false,
                        required: angular.isDefined(attrs.required) ? (attrs.required == 'true') : false,
                        size: NumberUtils.getNumberOrDefault(attrs.precision, -1),
                        visible: angular.isDefined(attrs.visible) ? (attrs.visible == 'true') 
                            : angular.isDefined(scope.visibleField) ? (scope.visibleField == true) : true,
                        fk: buildFkProperty(name),
                        options: buildOptionsProperty(),
                        properties: buildPropertiesObject(),
                        presentationType: attrs.presentationType,
                        standAlone: true,
                        isDescriptionField: angular.isDefined(attrs.isDescriptionField) ? (attrs.isDescriptionField == 'true') : false,
                        buildOptionsFn: getBuildOptionsFn(),//Esta propriedade só funciona no datagrid, caso necessário terá que ser implementada nos outros locais
                        width: angular.isDefined(attrs.width) ? NumberUtils.getNumberOrDefault(attrs.width, 100) : undefined
                    };

                    fieldMd.isNullable = (fieldMd.required == false);

                    if (userType == 'S' && fieldMd.presentationType == 'S') {
                        fieldMd.checkbox = true;

                        if (!fieldMd.options) {
                            fieldMd.options = [
                                { data: 'S', value: i18n('Geral.buttonSim') },
                                { data: 'N', value: i18n('Geral.buttonNao') },
                            ];
                        }
                    }

                    DatasetController.addUserFieldMetadata(fieldMd);
                }

                function buildPropertiesObject() {
                    var properties;

                    var propertiesAttrs = ['groupName:UIGroupName', 'gridFooterOper:gridFooterOper'];

                    propertiesAttrs.forEach(function (attrInfo) {
                        var infoSplit = attrInfo.split(':');

                        var attrName = infoSplit[0];
                        var exportName = infoSplit[1];

                        var value = attrs[attrName];

                        if (value) {
                            if (!properties) {
                                properties = [];
                            }

                            properties.push({
                                name: exportName,
                                value: i18n(value)
                            });
                        }
                    });

                    return properties;
                }

                function buildFkProperty(fieldName) {
                    var userProps;

                    ObjectUtils.forEachInObject(FK_PROPERTIES, function (key, value) {
                        var attrPropName = key;
                        var destPropName = (value == '=') ? key : value;

                        if (angular.isDefined(attrs[attrPropName])) {
                            userProps = userProps || {};
                            userProps[destPropName] = attrs[attrPropName];
                        }
                    });

                    if (userProps) {
                        userProps.isHierarchyEntity = userProps.isHierarchyEntity == 'true';
                        userProps.relationShipName = userProps.relationShipName || userProps.entity;
                        userProps.targetField = userProps.targetField || fieldName;

                        if (Object.keys(userProps).length != Object.keys(FK_PROPERTIES).length) {
                            throw new Error('Todas as informações de fk de um campo são obrigatórias, verifique a documentação.');
                        }
                    }

                    return userProps;
                }

                function buildOptionsProperty() {
                    var optionsElem = element.find('sk-options')[0];

                    if (!optionsElem) {
                        return undefined;
                    }

                    optionsElem = element.find('sk-option');

                    if (optionsElem.length) {
                        var fieldOptions = [];

                        for (var i = 0; i < optionsElem.length; i++) {
                            var option = angular.element(optionsElem[i]);
                            var data = option.attr('data');
                            var label = option.attr('label') || data;

                            if (!data) {
                                throw new Error('Campo "' + name + '" com opção sem chave');
                            }

                            fieldOptions.push({
                                data: data,
                                value: i18n(label)
                            });
                        }

                        return fieldOptions;
                    } else {
                        return undefined;
                    }
                }

                function getBuildOptionsFn(){
                    var optionsElement = angular.element(element.find('sk-options'));
                    var optionFn = optionsElement.attr('sk-build-options');
                    if(optionFn){
                        optionFn = scope.$parent[optionFn];
                        if(angular.isFunction(optionFn)){
                            return optionFn;
                        }
                    }
                    return undefined;
                    
                }
            }
        };
    }]);



/**
 * Created by bruno.brandao on 14/09/2017.
 */
angular
    .module('snk.components.imagepopup')
    .controller('DeepCopyPopUpController', ['$scope', '$popupInstance', '$q', 'options', function ($scope, $popupInstance, $q, options) {
        var self = this;
        
        self.metadata;
        self.selectedMD;
        self.keepChoice = false;

        $scope.$success = confirmDeepCopy;
        
        var _originalMD;

        init();

        function init(){
            _originalMD = options.metadata;
            self.metadata = [];

            _originalMD.forEach(function(md){
                self.metadata.push({data: md.name, value: md.description, checked: md.includeInCopy == 'S'});
            });

            self.keepChoice = options.keepChoice;
        }

        function confirmDeepCopy(){
            
            if(_originalMD){
                var selectedEntities = {};
                
                self.selectedMD.forEach(function(entity){
                    selectedEntities[entity] = true;
                });

                _originalMD.forEach(function(md){
                    md.includeInCopy = (selectedEntities.hasOwnProperty(md.name) ? "S" : "N");
                    md.answered = options.keepChoice ? "S" : "N";
                });
            }

            $popupInstance.success({metadata: _originalMD, keepChoice: self.keepChoice});
        }
     
    }]);
/**
 * @ngdoc service
 * @name snk.components.dataset.service:DatasetOnlineFilter
 *
 * @description
 * Disponibiliza funções para trabalhar filtros em tela no dataset.
 */
angular
    .module('snk.components.dataset')
    .provider('DatasetOnlineFilter', [function () {
        var StringUtils;
        var DatasetUtils;

        this.$get = ['StringUtils', 'DatasetUtils', function (_StringUtils, _DatasetUtils) {
            StringUtils = _StringUtils;
            DatasetUtils = _DatasetUtils;

            return DatasetOnlineFilter;
        }];

        function DatasetOnlineFilter(dataset) {
            this.dataset = dataset;
        }

        DatasetOnlineFilter.prototype.activeFilterRemoveHandler;

        DatasetOnlineFilter.prototype.buildRegexForTerm = buildRegexForTerm;
        DatasetOnlineFilter.prototype.getValueAsString = getValueAsString;
        DatasetOnlineFilter.prototype.andFilter = andFilter;
        DatasetOnlineFilter.prototype.orFilter = orFilter;
        DatasetOnlineFilter.prototype.inFilter = inFilter;
        DatasetOnlineFilter.prototype.filter = filter;
        DatasetOnlineFilter.prototype.clearFilter = clearFilter;
        DatasetOnlineFilter.prototype.setFilterFn = setFilterFn;

        function filter(queryObj) {
            this.setFilterFn(function (recordObj) {
                return processFilter(recordObj, queryObj);
            });
        }

        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#andFilter
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {object} queryObj Objeto contendo os campos e valores para o filtro
         * @description
         *  Permite realizar um filtro rápido do tipo "AND" no dataset.<br/><br/>
         *  No exemplo abaixo, registros que contenham CAMPO1 = 'valor1' <b>e</b> CAMPO2 = 'valor2' <b>e</b> CAMPON = 'valorN' serão retornados.
         * @example 
         *      <pre>var dsFilter = new DatasetOnlineFilter(dataset);
         *      dsFilter.andFilter(<br/>
         *          {
         *              CAMPO1: 'valor1',
         *              CAMPO2: 'valor2',
         *              CAMPON: 'valorN'
         *          }
         *      )</pre>
         */
        function andFilter(queryObj) {
            this.setFilterFn(function (recordObj) {
                return processANDFilter(recordObj, queryObj);
            });
        }

        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#orFilter
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {object} queryObj Objeto contendo os campos e valores para o filtro
         * @description
         *  Permite realizar um filtro rápido do tipo "OR" no dataset.<br/><br/>
         *  No exemplo abaixo, registros que contenham CAMPO1 = 'valor1' <b>ou</b> CAMPO2 = 'valor2' <b>ou</b> CAMPON = 'valorN' serão retornados.
         * @example 
         *      <pre>var dsFilter = new DatasetOnlineFilter(dataset);
         *      dsFilter.orFilter(<br/>
         *          {
         *              CAMPO1: 'valor1',
         *              CAMPO2: 'valor2',
         *              CAMPON: 'valorN'
         *          }
         *      )</pre>
         */
        function orFilter(queryObj) {
            this.setFilterFn(function (recordObj) {
                return processORFilter(recordObj, queryObj);
            });
        }
        
        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#inFilter
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {string} fieldName Nome do campo onde o filtro será aplicado
         * @param {array} filterArray Array contendo os valores para o filtro
         * @param {boolean} notIn Inverte o resultado do filtro, simulando um NOT IN.
         * @description
         *  Permite realizar um filtro rápido do tipo "IN" no dataset.<br/><br/>
         *  No exemplo abaixo, registros que contenham CAMPO1 = 1, 2, 3, 4 ou 5 serão retornados.
         * @example 
         *      <pre>var dsFilter = new DatasetOnlineFilter(dataset);
         *      dsFilter.inFilter('CAMPO1', [1, 2, 3, 4, 5]);</pre>
         */
        function inFilter(fieldName, filterArray, notIn) {
            this.setFilterFn(function (recordObj) {
                var currentValue = recordObj[fieldName];

                var result = filterArray.indexOf(currentValue) > -1;
                
                if (notIn === true) {
                	return !result;
                }
                
                return result;
            });
        }

        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#setFilterFn
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {function} filterFunction Função de filtro a ser definida
         * @description
         *  Define uma função de filtro a ser executada.
         * @example 
         *      <pre>var dsFilter = new DatasetOnlineFilter(dataset);
         *      dsFilter.setFilterFn(<br/>
         *          {
         *              CAMPO1: 'valor1',
         *              CAMPO2: 'valor2',
         *              CAMPON: 'valorN'
         *          }
         *      )</pre>
         */
        function setFilterFn(filterFunction) {
            this.clearFilter(true);

            if (this.dataset) {
                this.activeFilterRemoveHandler = this.dataset.addObjectFilterFunction(filterFunction);
                this.dataset.filterRecords();
            }
        }


        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#refresh
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @description
         *  Permite realizar um filtro rápido do tipo "IN" no dataset.<br/><br/>
         *  No exemplo abaixo, registros que contenham CAMPO1 = 1, 2, 3, 4 ou 5 serão retornados.
         * @example 
         *      <pre>dsFilter.refresh();</pre>
         */
        function refresh() {
            this.dataset.filterRecords();
        }

        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#clearFilter
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {boolean} preventFilterRecords Previne o recarregamento do dataset
         * @description
         *  Remove os filtros existentes no dataset.
         * @example 
         *      <pre>var dsFilter = new DatasetOnlineFilter(dataset);
         *      dsFilter.clearFilter()(
         *      </pre>
         */
        function clearFilter(preventFilterRecords) {
            if (this.activeFilterRemoveHandler) {
                this.activeFilterRemoveHandler();
            }

            this.activeFilterRemoveHandler = undefined;

            if (this.dataset && !(preventFilterRecords === true)) {
                this.dataset.filterRecords(true);
            }
        }

        function processFilter(record, filterObject) {
            if (filterObject['$AND']) {
                return processANDFilter(record, filterObject['$AND']);
            } else if (filterObject['$OR']) {
                return processORFilter(record, filterObject['$OR']);
            } else {
                return processANDFilter(record, filterObject);
            }
        }

        function processANDFilter(record, filterObject) {
            for (var filterName in filterObject) {
                var regex = buildRegexForTerm(getValueAsString(filterObject[filterName]));
                var filterValue = getValueAsString(record[filterName]);

                if (!regex.test(filterValue)) {
                    return false;
                }
            }

            return true;
        }

        function processORFilter(record, filterObject) {
            for (var filterName in filterObject) {
                var regex = buildRegexForTerm(getValueAsString(filterObject[filterName]));
                var filterValue = getValueAsString(record[filterName]);

                if (regex.test(filterValue)) {
                    return true;
                }
            }

            return false;
        }

        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#buildRegexForTerm
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {string} textTerm Termo a ser filtrado
         * @description
         *  Retorna uma expressão regular (RegExpr) que engloba o termo passado como parâmetro.
         */
        function buildRegexForTerm(textTerm) {
            var regexTerm = textTerm.replace(/[!@#\$%\^\&*\)\(+=._-]+/gi, function (v) {
                return '\\' + v;
            });

            return RegExp(regexTerm, 'i');
        }

        /**
         * @ngdoc
         * @name snk.components.dataset.service:DatasetOnlineFilter#getValueAsString
         * @methodOf snk.components.dataset.service:DatasetOnlineFilter
         * @param {object} value Valor a ser convertido para String
         * @description
         *  Converte o dado para String, substituindo os caracteres especiais.
         */
        function getValueAsString(value) {
            return StringUtils.replaceAccentuatedChars(DatasetUtils.dataToString(value));
        }

    }]);

angular
    .module('snk.components.dateperiod')
    .controller('SkDatePeriodController', ['$scope', 'DateUtils', '$timeout', 'DropdownUtil', '$element', 'SkConstants', '$document', 'StringUtils', '$attrs', function ($scope, DateUtils, $timeout, DropdownUtil, $element, SkConstants, $document, StringUtils, $attrs) {
        var DT_YESTERDAY = 'yesterday';
        var DT_LAST_7_DAYS = 'last7days';
        var DT_LAST_30_DAYS = 'last30days';
        var DT_CURRENT_MONTH = 'currentMonth';
        var DT_LAST_MONTH = 'lastMonth';

        var self = this;
        var popupElem;
        var closeOnClick = false;
        var inputsElem = angular.element($element[0].querySelectorAll('input.form-control'));

        self.notifyChange = notifyChange;
        self.openCalendar = openCalendar;
        self.openOnFocus = openOnFocus;
        self.onChange = onChange;

        $scope.selectDate = selectDate;
        $scope.selectDt = selectDt;
        $scope.isRequired = angular.isDefined($scope.isRequired) ? $scope.isRequired : false;
        $scope.buttonMode = angular.isDefined($scope.buttonMode) ? StringUtils.toBoolean($scope.buttonMode) : false;
        $scope.enabled = angular.isDefined($scope.enabled) ? $scope.enabled : true;
        $scope.onCreateDtPickerInit = onCreateDtPickerInit;
        $scope.onCreateDtPickerFim = onCreateDtPickerFim;

        init();

        function init() {
            if (!$scope.value) {
                $scope.value = {};
            }

            $scope.$watch('value', function(newValue) {
                if (angular.isDefined(newValue)) {
                    if (angular.isDefined(newValue.dtIni)) {
                        selectDate(true, true);
                    } else {
                        self.dtIni = undefined;
                    }

                    if (angular.isDefined(newValue.dtFim)) {
                        selectDate(false, true);
                    } else {
                        self.dtFim = undefined;
                    }
                } else {
                    self.dtIni = self.dtFim = undefined;
                }
            }, true);

            if (!$scope.buttonMode) {
                inputsElem.on(SkConstants.EVENTS.FOCUS, focusHandler);
            }

            $scope.$on(SkConstants.EVENTS.DESTROY, function () {
                unregisterEventsPopup();
            });
        }

        function registerEventsPopup() {
            $document.on(SkConstants.MOUSE.WHELL, hidePopup);
            $element.on(SkConstants.EVENTS.KEY_DOWN, keyDownHandler);
        }

        function unregisterEventsPopup() {
            $document.off(SkConstants.MOUSE.WHELL, hidePopup);
            $element.off(SkConstants.EVENTS.KEY_DOWN, keyDownHandler);
        }

        function focusHandler() {
            this.select();
        }

        function notifyChange(isDtIni) {
            $timeout(function(){
                var dtIni = DateUtils.strToDate(self.dtIni);
                var dtFimChanged = false;
                var dtFim;
                var strDtIni;
                var strDtFim;

                if (isDtIni || angular.isUndefined(isDtIni)) {
                    if (dtIni) {
                        strDtIni = DateUtils.formatDate(dtIni);
                    }

                    if (!$scope.value) {
                        $scope.value = {};
                    }

                    self.dtIni = strDtIni;
                    $scope.value.dtIni = dtIni;
                }

                if (!isDtIni || angular.isUndefined(isDtIni)) {
                    dtFim = DateUtils.strToDate(self.dtFim);

                    if (!$scope.value.dtIni || (dtIni && dtFim && dtIni.getTime() <= dtFim.getTime())) {
                        if (dtFim) {
                            strDtFim = DateUtils.formatDate(dtFim);
                        }

                        self.dtFim = strDtFim;

                        if ((!$scope.value.dtFim && dtFim) || $scope.value.dtFim && dtFim && $scope.value.dtFim.getTime() != dtFim.getTime()) {
                            dtFimChanged = true;
                        }

                        if (!$scope.value) {
                            $scope.value = {};
                        }

                        $scope.value.dtFim = dtFim;
                    } else {
                        self.dtFim = undefined;

                        if (!$scope.value) {
                            $scope.value = {};
                        }

                        $scope.value.dtFim = self.dtFim;
                    }
                }

                if (angular.isDefined(isDtIni) && !isDtIni && isValidDate() && dtFimChanged) {
                    runOnChange();
                }

                hidePopup();
            });
        }

        function runOnChange() {
            if ($attrs.skChange) {
                $timeout(function(){
                    $scope.onChange();
                });
            }
        }

        function openCalendar() {
            if($scope.enabled){
                if (DropdownUtil.isOpen(popupElem)) {
                    hidePopup();
                } else {
                    if (!popupElem) {
                        createPopup();
                    } else {
                        showPopup(true);
                    }
                }
            }
        }

        function openOnFocus(isDtIni) {
        	$timeout(() => {
                if (!DropdownUtil.isOpen(popupElem)) {
                    if (!popupElem) {
                        createPopup();
                    } else {
                        showPopup();
                    }
                }
            });
        }

        function createPopup() {
            DropdownUtil.create($scope, 'components/dateperiod/popup.tpl.html')
                .then(function(popup){
                    popupElem = popup;
                    popupElem.addClass('sk-dropdown-dateperiod');

                    if ($scope.buttonMode) {
                        popupElem.addClass('button-mode');
                    }

                    showPopup();
                });
        }

        function showPopup(focusFirstInput) {
            var config = {};
            config.width = 'auto';
            config.eventBubbles = 'mousedown';
            config.disableBubblesTarget = true;

            DropdownUtil.open(popupElem, $element, config);

            registerEventsPopup();

            if (focusFirstInput && !$scope.buttonMode) {
                inputsElem[0].focus();
            }
        }

        function keyDownHandler(event) {
            if (event.keyCode == SkConstants.KEY_CODE.ESCAPE) {
                event.preventDefault();
                event.stopPropagation();

                hidePopup();
            }
        }

        function hidePopup() {
            unregisterEventsPopup();

            DropdownUtil.close(popupElem);
        }

        function selectDate(isDtIni, externalChange) {
            if (isDtIni || angular.isUndefined(isDtIni)) {
                self.dtIni = DateUtils.formatDate($scope.value.dtIni);
            }

            if (!isDtIni || angular.isUndefined(isDtIni)) {
                self.dtFim = DateUtils.formatDate($scope.value.dtFim);
            }

            validDates(externalChange);
        }

        function validDates(externalChange) {
            if (!$scope.value) {
                return;
            }

            if ($scope.value.dtIni && $scope.value.dtFim && $scope.value.dtFim.getTime() < $scope.value.dtIni.getTime()) {
                $scope.value.dtFim = undefined;

                self.dtFim = undefined;
            }

            //if (closeOnClick && $scope.value.dtIni && $scope.value.dtFim) {
            if (isValidDate() && angular.isUndefined(externalChange)) {
                hidePopup();
                runOnChange();

                closeOnClick = false;
            }
        }

        function isValidDate() {
            return $scope.value && $scope.value.dtIni && $scope.value.dtFim;
        }

        function selectDt(mode) {
            var dtIni;
            var dtFim;
            var dt = DateUtils.getToday();

            if (mode == DT_YESTERDAY) {
                dt = DateUtils.subtract(dt, 1);
                dtIni = dtFim = dt;
            } else if (mode == DT_LAST_7_DAYS) {
                dtIni = DateUtils.subtract(dt, 7);
                dtFim = dt;
            } else if (mode == DT_LAST_30_DAYS) {
                dtIni = DateUtils.subtract(dt, 30);
                dtFim = dt;
            } else if (mode == DT_CURRENT_MONTH) {
                dtIni = DateUtils.getFirstDay();
                dtFim = DateUtils.getLastDay();
            } else if (mode == DT_LAST_MONTH) {
                dt = DateUtils.subtract(dt, 1, DateUtils.UNIT.MONTHS);

                dtIni = DateUtils.getFirstDay(dt);
                dtFim = DateUtils.getLastDay(dt);
            } else {
                dtIni = dtFim = dt;
            }

            if (!$scope.value) {
                $scope.value = {};
            }

            $scope.value.dtIni = dtIni;
            $scope.value.dtFim = dtFim;

            closeOnClick = true;

            selectDate();
        }

        function onCreateDtPickerInit(datepicker){
            self.datepickerInit = datepicker;
        }

        function onCreateDtPickerFim(datepicker){
            self.datepickerFim = datepicker;
        }

        function onChange(isDtIni){
            if(self.datepickerInit && isDtIni && StringUtils.isEmpty(self.dtIni) && $scope.value && self.dtIni != $scope.value.dtIni){
                self.datepickerInit.resetValue();
            }else if(self.datepickerFim && StringUtils.isEmpty(self.dtFim) && $scope.value && self.dtFim != $scope.value.dtFim){
                self.datepickerFim.resetValue();
            }
        }

    }]);
angular
    .module('snk.components.dateperiod')
    .directive('skDatePeriod', [function () {
        return {
            scope: {
                value: '=skValue',
                isRequired: '=?skRequired',
                buttonMode: '@?skButtonMode',
                onChange: '&?skChange',
                enabled: '=?skEnabled'
            },
            controller: 'SkDatePeriodController',
            controllerAs: 'ctrl',
            restrict: 'E',
            templateUrl: 'components/dateperiod/dateperiod.tpl.html'
        };
    }]);
angular
    .module('snk.components.datepicker')
    .constant('skDatepickerConfig', {
        formatDay: 'dd',
        formatMonth: 'MMMM',
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM yyyy',
        formatMonthTitle: 'yyyy',
        datepickerMode: 'day',
        minMode: 'day',
        maxMode: 'year',
        showWeeks: true,
        onlyCurrentMonth: false,
        startingDay: 0,
        yearRange: 20,
        minDate: null,
        maxDate: null,
        shortcutPropagation: false
    });

angular
    .module('snk.components.datepicker')
    .controller('SkDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'skDatepickerConfig', function ($scope, $attrs, $parse, $interpolate, $log, dateFilter, skDatepickerConfig) {
        var self = this;
        var ngModelCtrl = {$setViewValue: angular.noop};//nullModelCtrl;

        self.error = 'Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.';

        // Modes chain
        self.modes = ['day', 'month', 'year'];

        // Configuration attributes
        angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
            'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function (key, index) {
            self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : skDatepickerConfig[key];
        });

        // Watchable date attributes
        angular.forEach(['minDate', 'maxDate'], function (key) {
            if ($attrs[key]) {
                $scope.$parent.$watch($parse($attrs[key]), function (value) {
                    self[key] = value ? new Date(value) : undefined;
                    self.refreshView();
                });
            } else {
                self[key] = skDatepickerConfig[key] ? new Date(skDatepickerConfig[key]) : undefined;
            }
        });

        angular.forEach(['minMode', 'maxMode'], function(key) {
            if ($attrs[key]) {
                $scope.$parent.$watch($parse($attrs[key]), function(value) {
                    self[key] = angular.isDefined(value) ? value : $attrs[key];
                    $scope[key] = self[key];
                    if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
                        $scope.datepickerMode = self[key];
                    }
                });
            } else {
                self[key] = skDatepickerConfig[key] || null;
                $scope[key] = self[key];
            }
        });

        $scope.datepickerMode = $scope.datepickerMode || skDatepickerConfig.datepickerMode;
        $scope.maxMode = self.maxMode;
        $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

        if (angular.isDefined($attrs.initDate)) {
            this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
            $scope.$parent.$watch($attrs.initDate, function (initDate) {
                if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                    self.activeDate = initDate;
                    self.refreshView();
                }
            });
        } else {
            this.activeDate = new Date();
        }

        $scope.isActive = function (dateObject) {
            if (self.compare(dateObject.date, self.activeDate) === 0) {
                $scope.activeDateId = dateObject.uid;
                return true;
            }
            return false;
        };

        this.init = function (ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;

            ngModelCtrl.$render = function () {
                self.render();
            };

            ($scope.onCreate || angular.noop)({datepicker: self});
        };

        this.render = function () {
            if (ngModelCtrl.$viewValue) {
                var date = new Date(ngModelCtrl.$viewValue),
                    isValid = !isNaN(date);

                if (isValid) {
                    this.activeDate = date;
                } else {
                    if(typeof ngModelCtrl.$viewValue === 'string'){
                        var parseDate = ngModelCtrl.$viewValue.split('/'); 
                        
                        if(parseDate.length === 3){

                            if(parseDate[1] !== 0){
                                parseDate[1]--; 
                            }

                            date = new Date(parseDate[2], parseDate[1], parseDate[0]);
                            this.activeDate = date;
                        } else {
                            $log.error(self.error);
                        }
                    } else{
                        $log.error(self.error);
                    }

                }
            }
            this.refreshView();
        };

        this.refreshView = function () {
            if (this.element) {
                this._refreshView();

                var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : undefined;
                ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
            }
        };

        this.createDateObject = function (date, format) {
            var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : undefined;
            return {
                date: date,
                label: dateFilter(date, format),
                selected: model && this.compare(date, model) === 0,
                disabled: this.isDisabled(date),
                current: this.compare(date, new Date()) === 0,
                customClass: this.customClass(date)
            };
        };

        this.isDisabled = function (date) {
            return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({
                date: date,
                mode: $scope.datepickerMode
            })));
        };

        this.customClass = function (date) {
            return $scope.customClass({date: date, mode: $scope.datepickerMode});
        };

        // Split array into smaller arrays
        this.split = function (arr, size) {
            var arrays = [];
            while (arr.length > 0) {
                arrays.push(arr.splice(0, size));
            }
            return arrays;
        };

        // Fix a hard-reprodusible bug with timezones
        // The bug depends on OS, browser, current timezone and current date
        // i.e.
        // var date = new Date(2014, 0, 1);
        // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
        // can result in "2013 11 31 23" because of the bug.
        this.fixTimeZone = function (date) {
            var hours = date.getHours();
            date.setHours(hours === 23 ? hours + 2 : 0);
        };

        $scope.select = function (date, $event) {
            if ($scope.datepickerMode === self.minMode) {
                var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
                dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                ngModelCtrl.$setViewValue(dt);
                ngModelCtrl.$render();

                ($scope.onSelectDate || angular.noop)();
            } else {
                self.activeDate = date;
                $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
                
                if ($event) {
                    $event.preventDefault();
                }
            }
        };

        $scope.move = function (direction) {
            var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
                month = self.activeDate.getMonth() + direction * (self.step.months || 0);
            self.activeDate.setFullYear(year, month, 1);
            self.refreshView();

            if(!isNaN(new Date(self.activeDate))){
                ($scope.onChangeMonth || angular.noop)({activeDate: self.activeDate});
            }
        };

        $scope.toggleMode = function (direction, $event) {
            direction = direction || 1;

            if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
                return;
            }

            $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];

            if ($event) {
                $event.preventDefault();
            }
        };

        // Key event mapper
        $scope.keys = {
            13: 'enter',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down'
        };

        var focusElement = function () {
            self.element[0].focus();
        };

        var adjustActiveDate = function () {
            if (self._refreshView) {
                var startDate = $scope.$parent.$eval($attrs.startDate);
                self.activeDate = angular.copy(ngModelCtrl.$viewValue) || angular.copy(startDate) || $scope.$parent.$eval($attrs.initDate) || new Date();
                self._refreshView();
            }
        };

        var adjustViewValue = function (event, opt) {
        	if (opt) {
                ngModelCtrl.$setViewValue(opt.value);
            } else {
                ngModelCtrl.$setViewValue(null);
            }
        };

        // Listen for focus requests from popup directive
        $scope.$on('datepicker.focus', focusElement);
        $scope.$on('datepicker.adjustActiveDate', adjustActiveDate);
        $scope.$on('datepicker.adjustViewValue', adjustViewValue);

        $scope.keydown = function (evt) {
            var key = $scope.keys[evt.which];

            if (!key || evt.shiftKey || evt.altKey) {
                return;
            }

            evt.preventDefault();
            if (!self.shortcutPropagation) {
                evt.stopPropagation();
            }

            if (key === 'enter' || key === 'space') {
                if (self.isDisabled(self.activeDate)) {
                    return; // do nothing
                }
                $scope.select(self.activeDate);
                focusElement();
            } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
                $scope.toggleMode(key === 'up' ? 1 : -1);
                focusElement();
            } else {
                self.handleKeyDown(key, evt);
                self.refreshView();
            }
        };

        self.resetValue = function(){
            ngModelCtrl.$setViewValue("");
        };
    }])

angular
    .module('snk.components.datepicker')
    .directive('skDatepicker', [function () {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'components/datepicker/template/datepicker.tpl.html',
            scope: {
                datepickerMode: '=?',
                dateDisabled: '&',
                onlyCurrentMonth: '=?',
                customClass: '&',
                shortcutPropagation: '&?',
                onSelectDate: '&?',
                onCreate: '&?',
                onChangeMonth: '&?'
            },
            require: ['skDatepicker', '?^ngModel'],
            controller: 'SkDatepickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0];
                var ngModelCtrl = ctrls[1];

                if (ngModelCtrl) {
                    datepickerCtrl.init(ngModelCtrl);
                }
            }
        };
    }]);
angular
    .module('snk.components.datepicker')
    .constant('skDatepickerPopupConfig', {
        datepickerPopup: 'yyyy-MM-dd',
        datepickerPopupTemplateUrl: 'components/datepicker/template/popup.tpl.html',
        datepickerTemplateUrl: 'components/datepicker/template/datepicker.tpl.html',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        currentText: 'Today',
        clearText: 'Clear',
        closeText: 'Done',
        closeOnDateSelection: true,
        appendToBody: false,
        showButtonBar: true,
        onOpenFocus: true
    });

angular
    .module('snk.components.datepicker')
    .directive('skDatepickerPopup', ['$compile', '$parse', '$document', '$rootScope', 'PositionUtils', 'dateFilter', '$timeout', 'DateUtils', 'skDatepickerPopupConfig', function ($compile, $parse, $document, $rootScope, PositionUtils, dateFilter, $timeout, DateUtils, skDatepickerPopupConfig) {
        return {
            restrict: 'EA',
            require: 'ngModel',
            scope: {
                isOpen: '=?',
                currentText: '@',
                clearText: '@',
                closeText: '@',
                dateDisabled: '&',
                customClass: '&',
                onSelectDate: '&'
            },
            link: function (scope, element, attrs, ngModel) {
                var dateFormat;
                var closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : skDatepickerPopupConfig.closeOnDateSelection;
                var appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : skDatepickerPopupConfig.appendToBody;
                var isHtml5DateInput = false;

                scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : skDatepickerPopupConfig.showButtonBar;

                scope.getText = function (key) {
                    return scope[key + 'Text'] || skDatepickerPopupConfig[key + 'Text'];
                };

                if (skDatepickerPopupConfig.html5Types[attrs.type]) {
                    dateFormat = skDatepickerPopupConfig.html5Types[attrs.type];
                    isHtml5DateInput = true;
                } else {
                    dateFormat = attrs.datepickerPopup || skDatepickerPopupConfig.datepickerPopup;
                    attrs.$observe('skDatepickerPopup', function (value, oldValue) {
                        var newDateFormat = value || skDatepickerPopupConfig.datepickerPopup;
                        // Invalidate the $modelValue to ensure that formatters re-run
                        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                            ngModel.$modelValue = undefined;

                            if (!dateFormat) {
                                throw new Error('datepickerPopup must have a date format specified.');
                            }
                        }
                    });
                }

                if (!dateFormat) {
                    throw new Error('datepickerPopup must have a date format specified.');
                }

                if (isHtml5DateInput && attrs.datepickerPopup) {
                    throw new Error('HTML5 date input types do not support custom formats.');
                }

                // popup element used to display calendar
                var popupEl = angular.element('<div class="date-picker-popup" sk-datepicker-popup-wrap><div sk-datepicker></div></div>');
                popupEl.attr({
                    'ng-model': 'date',
                    'ng-change': 'dateSelection(date)'
                });

                function cameltoDash(string) {
                    return string.replace(/([A-Z])/g, function ($1) {
                        return '-' + $1.toLowerCase();
                    });
                }

                //datepicker element
                var datepickerEl = angular.element(popupEl.children()[0]);
                if (isHtml5DateInput) {
                    if (attrs.type == 'month') {
                        datepickerEl.attr('datepicker-mode', '"month"');
                        datepickerEl.attr('min-mode', 'month');
                    }
                }

                if (attrs.datepickerOptions) {
                    var options = scope.$parent.$eval(attrs.datepickerOptions);

                    if (options && options.initDate) {
                        scope.initDate = options.initDate;
                        scope.startDate = angular.copy(options.initDate);

                        datepickerEl.attr('init-date', 'initDate');
                        datepickerEl.attr('start-date', 'startDate');

                        delete options.initDate;
                    }

                    angular.forEach(options, function (value, option) {
                        datepickerEl.attr(cameltoDash(option), value);
                    });
                }

                scope.watchData = {};
                angular.forEach(['minMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function (key) {
                    if (attrs[key]) {
                        var getAttribute = $parse(attrs[key]);
                        scope.$parent.$watch(getAttribute, function (value) {
                            scope.watchData[key] = value;
                        });
                        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

                        // Propagate changes from datepicker to outside
                        if (key === 'datepickerMode') {
                            var setAttribute = getAttribute.assign;

                            scope.$watch('watchData.' + key, function (value, oldvalue) {
                                if (angular.isFunction(setAttribute) && value !== oldvalue) {
                                    setAttribute(scope.$parent, value);
                                }
                            });
                        }
                    }
                });
                if (attrs.dateDisabled) {
                    datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
                }

                if (attrs.showWeeks) {
                    datepickerEl.attr('show-weeks', attrs.showWeeks);
                }

                if (attrs.customClass) {
                    datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
                }

                if(attrs.skBindPopOverId){
                    datepickerEl.attr('sk-bind-pop-over-dad-id', attrs.skBindPopOverId); 
                }

                function parseDate(viewValue) {
                    var value;

                    if (angular.isNumber(viewValue)) {
                        // presumably timestamp to date object
                        value = new Date(viewValue);
                    }

                    if (!viewValue) {
                        value = undefined;
                    } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                        value = viewValue;
                    } else if (angular.isString(viewValue)) {
                        var date = DateUtils.strToDate(viewValue);
                        if (isNaN(date)) {
                            value = undefined;
                        } else {
                            value = date;
                        }
                    } else {
                        value = undefined;
                    }

                    return value;
                }

                function validator(modelValue, viewValue) {
                    var value = modelValue || viewValue;

                    if (!attrs.ngRequired && !value) {
                        return true;
                    }

                    if (angular.isNumber(value)) {
                        value = new Date(value);
                    }
                    if (!value) {
                        return true;
                    } else if (angular.isDate(value) && !isNaN(value)) {
                        return true;
                    } else if (angular.isString(value)) {
                        var date = DateUtils.parse(value, dateFormat);
                        return !isNaN(date);
                    } else {
                        return false;
                    }
                }

                if (!isHtml5DateInput) {
                    // Internal API to maintain the correct ng-invalid-[key] class
                    ngModel.$$parserName = 'date';
                    //ngModel.$validators.date = validator;
                    //ngModel.$parsers.unshift(parseDate);
                    ngModel.$formatters.push(function (value) {
                        scope.date = value;
                        return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
                    });
                }
                else {
                    ngModel.$formatters.push(function (value) {
                        scope.date = value;
                        return value;
                    });
                }

                // Inner change
                scope.dateSelection = function (dt) {
                    scope.date = dt;
                    
                    var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
                    element.val(date);
                    ngModel.$setViewValue(date);

                    scope.onSelectDate();

                    if (closeOnDateSelection) {
                        scope.isOpen = false;
                        element[0].focus();
                    }
                };

                //// Detect changes in the view from the text box
                //ngModel.$viewChangeListeners.push(function () {
                //    scope.date = DateUtils.strToDate(ngModel.$viewValue);
                //});

                var documentClickBind = function (event) {
                    if (event.isDefaultPrevented()){
                        return;
                    }
                    
                    if (scope.isOpen && !(element[0].contains(event.target) || popupEl[0].contains(event.target))) {
                        scope.$apply(function () {
                            scope.isOpen = false;
                        });
                    }
                };

                var inputKeydownBind = function (evt) {
                    if (evt.which === 27 && scope.isOpen) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        scope.$apply(function () {
                            scope.isOpen = false;
                        });
                        element[0].focus();
                    } else if (evt.which === 40 && !scope.isOpen) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        scope.$apply(function () {
                            scope.isOpen = true;
                        });
                    }
                };
                element.bind('keydown', inputKeydownBind);

                scope.keydown = function (evt) {
                    if (evt.which === 27) {
                        scope.isOpen = false;
                        element[0].focus();
                    }
                };

                scope.$watch('isOpen', function (value) {
                    if (value) {
                        var targetElem = element;

                        if (targetElem.css('display') == 'none') {
                            targetElem = element.parent();
                        }

                        var newPosition = appendToBody ? PositionUtils.offset(targetElem, true) : PositionUtils.position(element);

                        $popup.css('visibility', 'hidden');

                        scope.position = {};

                        $timeout(function () {
                            var offset = PositionUtils.offset($popup);
                            var posX = offset.width + newPosition.left + 20;
                            var posY = offset.height + newPosition.top;

                            if (posX > $document[0].documentElement.clientWidth) {
                                var diffPos = posX - $document[0].documentElement.clientWidth;

                                newPosition.left -= diffPos;
                            }

                            if (posY > $document.scrollTop() + $document[0].documentElement.clientHeight) {
                                var elemHeight = targetElem.prop('offsetHeight');

                                newPosition.top = newPosition.top + (offset.height * -1);
                            } else {
                                newPosition.top += targetElem.prop('offsetHeight');
                            }

                            scope.$broadcast('datepicker.focus');
                            scope.position = newPosition;
                            $popup.css({
                                'visibility': 'visible',
                                'top': newPosition.top + 'px',
                                'left': newPosition.left + 'px'
                            });

                            setTimeout(function(){
                                $document.bind('click', documentClickBind);
                            }, 0, false);
                        }, 0, false);
                    } else {
                        // scope.$broadcast('datepicker.adjustActiveDate');
                        $document.unbind('click', documentClickBind);
                    }
                });

                scope.select = function (date) {
                    if (date === 'today') {
                        var today = new Date();

                        if (angular.isDate(scope.date)) {
                            date = new Date(scope.date);

                            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                        } else {
                            date = new Date(today.setHours(0, 0, 0, 0));
                        }
                    }

                    scope.dateSelection(date);

                    if (!date) {
                        scope.$broadcast('datepicker.adjustViewValue');
                        scope.$broadcast('datepicker.adjustActiveDate');
                    }
                };

                scope.close = function () {
                    scope.isOpen = false;

                    element[0].focus();
                };

                var $popup = $compile(popupEl)(scope);
                // Prevent jQuery cache memory leak (template is now redundant after linking)
                popupEl.remove();

                if (appendToBody) {
                    $document.find('body').append($popup);
                } else {
                    element.after($popup);
                }

                scope.$on('$destroy', function () {
                    if (scope.isOpen === true) {
                        if (!$rootScope.$$phase) {
                            scope.$apply(function () {
                                scope.isOpen = false;
                            });
                        }
                    }

                    $popup.remove();
                    element.unbind('keydown', inputKeydownBind);
                    $document.unbind('click', documentClickBind);
                });
            }
        };
    }]);
angular
    .module('snk.components.datepicker')
    .directive('skDatepickerPopupWrap', [function () {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: 'components/datepicker/template/popup.tpl.html',
            link:function (scope, element, attrs) {
                element.bind('mousedown', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        };
    }]);
angular
    .module('snk.components.datepicker')
    .directive('skDaypicker', ['dateFilter', 'SkI18nService', function (dateFilter, SkI18nService) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'components/datepicker/template/day.tpl.html',
            require: '^skDatepicker',
            link: function (scope, element, attrs, ctrl) {
                scope.showWeeks = ctrl.showWeeks;

                ctrl.step = {months: 1};
                ctrl.element = element;

                var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

                var MONTHS_IN_YEARS = ['janeiro', 'fevereiro', 'mar�o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

                function getDaysInMonth(year, month) {
                    return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
                }

                function getDates(startDate, n) {
                    var dates = new Array(n), current = new Date(startDate), i = 0, date;
                    while (i < n) {
                        date = new Date(current);
                        ctrl.fixTimeZone(date);
                        dates[i++] = date;
                        current.setDate(current.getDate() + 1);
                    }
                    return dates;
                }

                ctrl._refreshView = function () {
                    var year = ctrl.activeDate.getFullYear(),
                        month = ctrl.activeDate.getMonth(),
                        firstDayOfMonth = new Date(year, month, 1),
                        difference = ctrl.startingDay - firstDayOfMonth.getDay(),
                        numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : -difference,
                        firstDate = new Date(firstDayOfMonth);
                    if (numDisplayedFromPreviousMonth > 0) {
                        firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
                    }

                    // 42 is the number of days on a six-month calendar
                    var days = getDates(firstDate, 42);
                    for (var i = 0; i < 42; i++) {
                        days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
                            secondary: days[i].getMonth() !== month,
                            uid: scope.uniqueId + '-' + i
                        });
                    }

                    scope.labels = new Array(7);
                    for (var j = 0; j < 7; j++) {
                        scope.labels[j] = {
                            abbr: SkI18nService.instant('DateInput.descAbrr.' + dateFilter(days[j].date, ctrl.formatDayHeader)),
                            full: SkI18nService.instant('DateInput.descFull.' + dateFilter(days[j].date, 'EEEE'))
                        };
                    }

                    scope.title = i18nMonth(dateFilter(ctrl.activeDate, ctrl.formatDayTitle));
                    scope.rows = ctrl.split(days, 7);

                    if (scope.showWeeks) {
                        scope.weekNumbers = [];
                        var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
                            numWeeks = scope.rows.length;
                        for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                            scope.weekNumbers.push(
                                getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
                        }
                    }
                };

                ctrl.compare = function (date1, date2) {
                    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()) );
                };

                function i18nMonth(title){
                    for(var i=0; i < MONTHS_IN_YEARS.length; i++){
                        if(title.indexOf(MONTHS_IN_YEARS[i]) > -1){
                            return title.replace(MONTHS_IN_YEARS[i], SkI18nService.instant('DateInput.month.' + MONTHS_IN_YEARS[i]));
                        }
                    }
                    return title;
                }

                function getISO8601WeekNumber(date) {
                    var checkDate = new Date(date);
                    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
                    var time = checkDate.getTime();
                    checkDate.setMonth(0); // Compare with Jan 1
                    checkDate.setDate(1);
                    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
                }

                ctrl.handleKeyDown = function (key, evt) {
                    var date = ctrl.activeDate.getDate();

                    if (key === 'left') {
                        date = date - 1;   // up
                    } else if (key === 'up') {
                        date = date - 7;   // down
                    } else if (key === 'right') {
                        date = date + 1;   // down
                    } else if (key === 'down') {
                        date = date + 7;
                    } else if (key === 'pageup' || key === 'pagedown') {
                        var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
                        ctrl.activeDate.setMonth(month, 1);
                        date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
                    } else if (key === 'home') {
                        date = 1;
                    } else if (key === 'end') {
                        date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
                    }
                    ctrl.activeDate.setDate(date);
                };

                ctrl.refreshView();
            }
        };
    }]);
angular
    .module('snk.components.datepicker')
    .directive('skMonthpicker', ['dateFilter', 'SkI18nService', function (dateFilter, SkI18nService) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'components/datepicker/template/month.tpl.html',
            require: '^skDatepicker',
            link: function (scope, element, attrs, ctrl) {
                ctrl.step = {years: 1};
                ctrl.element = element;

                ctrl._refreshView = function () {
                    var months = new Array(12),
                        year = ctrl.activeDate.getFullYear(),
                        date;

                    for (var i = 0; i < 12; i++) {
                        date = new Date(year, i, 1);
                        ctrl.fixTimeZone(date);
                        months[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatMonth), {
                            uid: scope.uniqueId + '-' + i
                        });
                    }

                    for(var i=0; i < months.length; i++){
                        months[i].label = SkI18nService.instant('DateInput.month.' + months[i].label);
                    }

                    scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
                    scope.rows = ctrl.split(months, 3);
                };

                ctrl.compare = function (date1, date2) {
                    return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
                };

                ctrl.handleKeyDown = function (key, evt) {
                    var date = ctrl.activeDate.getMonth();

                    if (key === 'left') {
                        date = date - 1;   // up
                    } else if (key === 'up') {
                        date = date - 3;   // down
                    } else if (key === 'right') {
                        date = date + 1;   // down
                    } else if (key === 'down') {
                        date = date + 3;
                    } else if (key === 'pageup' || key === 'pagedown') {
                        var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
                        ctrl.activeDate.setFullYear(year);
                    } else if (key === 'home') {
                        date = 0;
                    } else if (key === 'end') {
                        date = 11;
                    }
                    ctrl.activeDate.setMonth(date);
                };

                ctrl.refreshView();
            }
        };
    }]);
angular
    .module('snk.components.datepicker')
    .directive('skYearpicker', ['dateFilter', function (dateFilter) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'components/datepicker/template/year.tpl.html',
            require: '^skDatepicker',
            link: function (scope, element, attrs, ctrl) {
                var range = ctrl.yearRange;

                ctrl.step = {years: range};
                ctrl.element = element;

                function getStartingYear(year) {
                    return parseInt((year - 1) / range, 10) * range + 1;
                }

                ctrl._refreshView = function () {
                    var years = new Array(range), date;

                    for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
                        date = new Date(start + i, 0, 1);
                        ctrl.fixTimeZone(date);
                        years[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatYear), {
                            uid: scope.uniqueId + '-' + i
                        });
                    }

                    scope.title = [years[0].label, years[range - 1].label].join(' - ');
                    scope.rows = ctrl.split(years, 5);
                };

                ctrl.compare = function (date1, date2) {
                    return date1.getFullYear() - date2.getFullYear();
                };

                ctrl.handleKeyDown = function (key, evt) {
                    var date = ctrl.activeDate.getFullYear();

                    if (key === 'left') {
                        date = date - 1;   // up
                    } else if (key === 'up') {
                        date = date - 5;   // down
                    } else if (key === 'right') {
                        date = date + 1;   // down
                    } else if (key === 'down') {
                        date = date + 5;
                    } else if (key === 'pageup' || key === 'pagedown') {
                        date += (key === 'pageup' ? -1 : 1) * ctrl.step.years;
                    } else if (key === 'home') {
                        date = getStartingYear(ctrl.activeDate.getFullYear());
                    } else if (key === 'end') {
                        date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
                    }
                    ctrl.activeDate.setFullYear(date);
                };

                ctrl.refreshView();
            }
        };
    }]);
angular
    .module('snk.components.defaultfilter')
    .controller('SkDefaultFilterPopup', ['$scope', 'properties', '$popupInstance', 'SkFilter', 'SkI18nService', 'SkApplicationInstance', 'MessageUtils', 'i18n', 'ObjectUtils', 'SanPopup', 'AngularUtil',
    function ($scope, properties, $popupInstance, SkFilter, SkI18nService, SkApplicationInstance, MessageUtils, i18n, ObjectUtils, SanPopup, AngularUtil) {
        var self = this;

        var _filterPFDeleted = false;

        self.resourceId = properties.resourceId;
        self.entityName = properties.entityName;

        $scope.transientFilter = properties.filter;
        $scope.filterPF = properties.filterPF;

        $scope.$success = onSuccess;
        $scope.$dismiss = onDismiss;

        $scope.deleteFilterPF = deleteFilterPF;
        $scope.visualizarFiltroLegado = visualizarFiltroLegado;

        function onSuccess() {
            var result = {
                filterPFDeleted: _filterPFDeleted
            };

            SkFilter.buildExpression($scope.transientFilter);

            if (!$scope.transientFilter || (angular.isDefined($scope.transientFilter) && !($scope.transientFilter.filterModel.expression || $scope.transientFilter.filterModel.assistent))) {
                $popupInstance.success(result);
                return;
            }

            if (isValid()) {
                result.expression = SkFilter.getExpression($scope.transientFilter);
                result.filter = $scope.transientFilter;

                $popupInstance.success(result);
            }
        }

        function onDismiss() {
            $popupInstance.dismiss({
                filterPFDeleted: _filterPFDeleted
            });
        }

        function visualizarFiltroLegado() {
            var clipBoard = undefined;

            var deleteFilterBtn = angular.element('<button class="btn btn-default">' + i18n('DynaformConfig.lblRemoverFiltro') + '</button>');
            deleteFilterBtn.on('click', deleteFilterPF);

            var copyFilterBtn = AngularUtil.createDirective('button',  {
                'class': 'btn btn-default',
                'sk-i18n': 'Geral.lblCopiar',
                'tooltip': 'Geral.lblCopiarAreaTransf'
            }, $scope);

            var popupInstance = SanPopup.open({
                title: i18n('DynaformConfig.lblFiltroLegadoHerdado'),
                template: '<sk-text-area autofocus sk-value="filterPF" sk-enabled="false" flex></sk-text-area>',
                showBtnCancel: false,
                size: 'md',
                leftBottomBar: [deleteFilterBtn, copyFilterBtn],
                resolve: {
                    filterPF: function() {
                        return $scope.filterPF;
                    }
                }
            });

            popupInstance.opened.then(function() {
                clipBoard = new Clipboard(copyFilterBtn[0], {
                    text: function(trigger) {
                        return $scope.filterPF;
                    }
                });
            });
        }

        function deleteFilterPF() {
            _filterPFDeleted = true;

            SkApplicationInstance
                .removeMgeConfig(self.resourceId + '_default', 'F', 0)
                .then(function() {
                    MessageUtils.showInfo(i18n('DynaformConfig.lblFiltroLegadoDeleted'));
                });
        }

        function isValid() {
            var expression = $scope.transientFilter.filterModel.expression;
            var assistent = $scope.transientFilter.filterModel.assistent;

            if (expression || assistent) {
                if (angular.isDefined(assistent) && $scope.transientFilter.mode == SkFilter.MODE_ASSISTENT) {
                    return true;
                } else if (angular.isDefined(expression) && $scope.transientFilter.mode == SkFilter.MODE_EXPRESSION) {
                    return true;
                } else {
                    throw new Error(SkI18nService.instant('FiltroPersonalizado.msgFiltroSemAssisExp'));
                }
            }
        }
    }]);
angular
    .module('snk.components.defaultfilter')
    .service('SkDefaultFilter', ['SanPopup', 'SkI18nService', function (SanPopup, SkI18nService) {
        //private
        var self = this;

        //public
        self.open = open;

        function open(entityName, resourceId, filter, filterPF) {
            var popupInstance = SanPopup.open({
                templateUrl: 'components/defaultfilter/defaultfilter.tpl.html',
                controller: 'SkDefaultFilterPopup',
                controllerAs: 'ctrl',
                title: SkI18nService.instant('FiltroPersonalizado.titleFiltroPadrao'),
                size: 'lg',
                okBtnLabel: SkI18nService.instant('Geral.lblConcluir'),
                resolve: {
                    properties: function () {
                        return {
                            resourceId: resourceId,
                            entityName: entityName,
                            filter: filter, 
                            filterPF: filterPF
                        }
                    }
                }
            });

            return popupInstance.result;
        }
    }]);
/**
 * Created by jonathan.silva on 29/09/2020.
 */

/**
 * @ngdoc component
 * @name snk.components.diagram.component:sk-diagram
 * @restrict E
 *
 * @description
 * Componente para renderizar diagramas nas telas em HTML5.
 *
 * @param {DataSource} sk-data-set               - objeto com os dados que serão renderizados no diagrama.
 * @param {function}   sk-diagram-created        - função que receberá o retorno da instância do componente diagrama.
 * @param {string}     sk-field-name             - nome do campo ao qual o label irá se ligar no dataset.
 * @param {function}   sk-element-build-function - função para controle de imagem, menu e permissões de cada elemento do diagrama.
 * @param {integer}    sk-image-width            - largura desejada para aplicar na imagem de cada elemento do diagrama.
 * @param {integer}    sk-image-height           - altura desejada para aplicar na imagem de cada elemento do diagrama.
 * @param {boolean}    sk-enable-open-menu-over  - flag para habilitar ou desabilitar a abertura do menu pelo mouseover.
 * @example
    <div>
        <sk-dataset entity-name="FluxoDiagnosticoOS" sk-dataset-created="ctrl.onDsItemCreated(dataset)" 
          crud-listener="br.com.sankhya.modelcore.crudlisteners.FluxoDiagnosticoOSCRUDListener">
          <sk-field pattern="*"></sk-field>
			    <sk-field pattern="FLUXO" path="FluxoDiagnostico"></sk-field>
        </sk-dataset>            
        
        <sk-datagrid sk-height="200px" sk-dataset="ctrl.dsItem"></sk-datagrid>

        <button ng-click="ctrl.onChangeDiagram()">Change Diagram</button>
        
        <sk-diagram 
            sk-dataset="ctrl.dsItem" 
            sk-diagram-created="ctrl.onDiagramCreated(diagram)"
            sk-field-name="FluxoDiagnostico.FLUXO" 
            sk-element-build-function="ctrl.elementBuildFunction"
            sk-enable-open-menu-over="false"
            sk-image-width="auto"
            sk-image-height="auto">
        </sk-diagram>
    </div>

    <script>
      angular
        .module('ExampleApp', ['snk'])
        .controller('ExampleController', ['ObjectUtils', function (ObjectUtils) {
          var self = this;

          self.onDsItemCreated = function (dataset) {
            self.dsItem = dataset;
            self.dsItem.addObserver(self);
            self.dsItem.initAndRefresh();
          }

          // Variável que receberá a instância do diagrama
          self.dbDiagram;

          // Exemplo de método que recebe a instância do diagrama renderizado na tela
          self.onDiagramCreated = function (diagram) {
            self.dbDiagram = diagram;
          }

          // Exemplo de um método para alterar os dados do basenode do diagrama
          self.onChangeDiagram = function () {
            self.dbDiagram.graphSrc.diagram.basenode[0].name = 'NOVO NOME';
            self.dbDiagram.graphSrc.diagram.basenode[0].qtdResp = 0;
            self.dbDiagram.reload();
          }

          // Exemplo de um método que será chamado no clique da opção do menu
          function callback(obj) {
            console.log('Elemento: ' + obj.name);
          }

          // Exemplo de um método que será passado pelo "sk-element-build-function" do diagrama
          * @param  {object} conf é um dos elementos do diagrama, é um "node" do "basenode" 
          * @return {DiagramNode} retorna uma nova instância da classe modelo do item do diagrama (diagramNode)
          self.elementBuildFunction = function (conf) {
            // O "body" corresponde ao corpo do item do diagrama
            * 
            * {string} image: url ou diretório da imagem daquele determinado elemento do diagrama
            const body = {
              image: ''
            };

            if (conf.qtdResp === 0) {
              body.image = 'https://i.pinimg.com/originals/35/90/4f/35904fbe98f1ececbb7c0d77564e961e.png';
            } else {
              body.image = 'https://www.iconfinder.com/data/icons/website-21/64/10_popup_form_website_page_ui_content-512.png';
            }
          
            // O "menu" corresponde às opções que aparecerão ao clicar em cada elemento do diagrama
            *
            * {string}   label     - texto da opção do menu.
            * {function} fn        - método ou função que será chamada no clique daquela determinada opção do menu.
            * {string}   link      - url que será chamada ao clicar naquela determinada opção do menu.
            * {boolean}  disabled  - flag que controla se aquela determinada opção do meu será desabilitada ou habilitada (padrão).
            * {boolean}  separator - flag que indica se haverá uma linha divisória após aquele determinado item do menu.
            * {object}   icon      - pode ser "image", que será uma url ou diretório de uma imagem, 
            *                        ou pode passar uma "classList" em formato de array ou string,
            *                        e o "name", que pode ser o nome do icone, por exemplo, os icones do material design.
            const menu = [{
              label: 'Opção 1',
              fn: callback,
              link: 'https://www.sankhya.com.br/',
              icon: {
                classList: ['glyphicon', 'glyphicon-book']
              }
            }, {
              label: 'Opção 2',
              fn: callback,
              icon: {
                image: 'https://simpleicon.com/wp-content/uploads/bag-6.svg'
              }
            }, {
              label: 'Opção 3',
              fn: callback,
              icon: {
                classList: ['glyphicon', 'glyphicon-car']
              },
              separator: true
            }, {
              label: 'Opção 4',
              fn: callback,
              icon: {
                classList: 'material-icons',
                name: 'analytics'
              },
              disabled: (conf.qtdResp === 0) ? true : false
            }, {
              label: 'Opção 5',
              fn: callback,
              link: 'https://www.sankhya.com.br/',
              icon: {
                classList: 'glyphicon glyphicon-list'
              },
              disabled: (conf.qtdResp === 0) ? true : false
            }];
        
            return new DiagramNode(body, menu);
          };
        }]);
    </script>
 */
angular
  .module('snk.components.diagram')
  .component('skDiagram', {
    templateUrl: 'components/diagram/diagram.tpl.html',
    controller: 'SkDiagramController',
    bindings: {
      dataset: '<skDataset',
      diagramCreated: '&?skDiagramCreated',
      fieldName: '@skFieldName',
      elementBuildFunction: '&?skElementBuildFunction',
      imageWidth: '=?skImageWidth',
      imageHeight: '=?skImageHeight',
      enableOpenMenuOver: '=?skEnableOpenMenuOver',
      onDblClick: "&?skOnDblClick"
    }
  });
/*
    Example of field value with the chart configuration.
    {
        "baseNode": [
            {
            "name": "Interrogatório",
            "nodeId": "questionario_1_2",
            "x": "178",
            "y": "182",
            "width": "100",
            "height": "55",
            "codQuest": "2",
            "qtdPerg": "0",
            "qtdResp": "0",
            "qtdPergObrig": "0",
            "qtdRespObrig": "0",
            "aplicavel": "S"
            },
            {
            "name": "QUESTIONÁRIO PADRÃO",
            "nodeId": "questionario_1_1",
            "x": "1606",
            "y": "165",
            "width": "155",
            "height": "55",
            "codQuest": "1",
            "qtdPerg": "6",
            "qtdResp": "0",
            "qtdPergObrig": "0",
            "qtdRespObrig": "0",
            "aplicavel": "S"
            }
        ],
        "links": {
            "link": [
            {
                "linkName": "teste",
                "orig": "questionario_1_2",
                "dest": "questionario_1_1",
                "bidirecional": "S",
                "linkType": "default"
            }
            ]
        }
    }
*/

angular
    .module('snk.components.diagram')
    .controller('SkDiagramController', ['$element', '$window', '$q', '$interval', 'AngularUtil', '$timeout',
        function ($element, $window, $q, $interval, AngularUtil, $timeout) {
            // Internal constants
            const self = this;
            const NODES_BY_ID = {};
            const noImage = '/mge/assets/img/no_image.png';
            const imageSize = 50;

            // Variables
            let snapSvg;
            let diagramNode;
            let diagramWidth;
            let $diagramArea;
            let configImage;
            let configElement;
            let isReload = false;

            // Component variables's
            self.dataset;
            self.fieldName;
            self.enableOpenMenuOver;
            self.imageWidth;
            self.imageHeight;
            self.elementBuildFunction;
            self.diagramCreated;
            self.onDblClick;

            // Life cicle
            self.$onChanges = onChange;
            self.reload = function() {
                isReload = true;
                init();
            };

            // Scope variables
            self.graphSrc = null;
            self.svgID = "svg-element";

            // Event to apply and update component when screen resizes
            angular.element($window).bind('resize', init);

            // Functions

            // Dispatches when change diagram dataset
            function onChange(changesObj) {
                if (changesObj.hasOwnProperty('dataset') && changesObj.dataset.currentValue) {
                    init();
                }
            }

            // Inits the diagram SVG
            function init() {
                try {
                    setDiagramWidth();

                    getSvg().then(() => {
                        snapSvg = Snap('#' + self.svgID);
                        snapSvg.attr({
                            width: diagramWidth
                        });
                        self.dataset.addLineChangeListener(onDatasetChangeLine);
                        processGraph();
                    });

                } catch (error) {
                    console.error(error);
                    throw Error('Não foi possível inicializar o diagrama!');
                }
            }

            // Gets SVG element
            function getSvg() {
                let defer = $q.defer();

                let svgEl = $element.find('#' + self.svgID);

                if (svgEl.length > 0) {
                    defer.resolve(svgEl);
                } else {
                    let intervalPromisse = $interval(() => {
                        let svgEl = $element.find('#' + self.svgID);

                        if (svgEl.length > 0) {
                            defer.resolve(svgEl);
                            $interval.cancel(intervalPromisse);
                        }
                    }, 1000);
                }

                return defer.promise;
            }

            function setDiagramWidth() {
                $diagramArea = document.querySelector('.sk-diagram');

                diagramWidth = $diagramArea.clientWidth;

                if (diagramWidth === 0) {
                    diagramWidth = 1300;
                }

                configImage = {
                    width: self.imageWidth || imageSize,
                    height: self.imageHeight || imageSize
                };

                configElement = {
                    width: (configImage.width * 2.25),
                    height: (configImage.height * 2)
                };
            }

            // Dispatches when change diagram line
            function onDatasetChangeLine() {
                processGraph();
            }

            // Creates the node menu
            function createMenu($box, $image, obj, menuValue) {
                if (angular.isDefined(diagramNode) && angular.isDefined(diagramNode.menu)) {
                    const menuList = diagramNode.menu;

                    const $arrow = document.createElement('span');
                    $arrow.className = 'sk-diagram-arrow';
                    $arrow.setAttribute('data-diagram-arrow', menuValue);

                    const $menu = document.createElement('div');
                    $menu.className = 'sk-diagram-menu';
                    $menu.setAttribute('data-diagram-menu', menuValue);

                    let countLabel = 0;
                    let countIcon = 0;
                    menuList.forEach((item) => {
                        if (angular.isUndefined(item.label) && (angular.isUndefined(item.icon) || !Object.keys(item.icon).length)) {
                            return;
                        }

                        const typeTag = angular.isDefined(item.link) ? 'a' : 'span';
                        const $item = document.createElement(typeTag);
                        $item.className = 'sk-diagram-menu-item';

                        if (angular.isDefined(item.label)) {
                            $item.textContent = item.label;
                            countLabel++;
                        }

                        if (angular.isDefined(item.disabled) && item.disabled) {
                            $item.setAttribute('disabled', 'disabled');
                        } else {
                            if (angular.isDefined(item.fn)) {
                                $item.addEventListener('click', function (event) {
                                    item.fn(obj, menuValue, menuList);
                                });
                            }

                            if (angular.isDefined(item.link)) {
                                $item.href = item.link;
                                $item.target = '_blank';
                            }
                        }

                        if (angular.isDefined(item.icon) && Object.keys(item.icon).length) {
                            let $icon;
                            if (angular.isDefined(item.icon.image)) {
                                $icon = document.createElement('img');
                                $icon.src = item.icon.image;
                            } else if (angular.isDefined(item.icon.classList)) {
                                $icon = document.createElement('span');
                                let classList = item.icon.classList;
                                classList = angular.isArray(classList) ? classList :
                                            angular.isString(classList) ? classList.split(' ') : null;
                                if (angular.isDefined(classList)) {
                                    classList.forEach((className) => {
                                        $icon.classList.add(className);
                                    });
                                }
                                if (angular.isDefined(item.icon.name)) {
                                    $icon.textContent = item.icon.name;
                                }
                            }
                            if (angular.isDefined($icon)) {
                                $icon.classList.add('sk-diagram-menu-item-icon');

                                if (angular.isUndefined(item.label)) {
                                    $icon.classList.add('sk-diagram-menu-item-icon--single');
                                }

                                $item.prepend($icon);
                                countIcon++;
                            }
                        }

                        if (countLabel + $item.childElementCount > 0) {
                            $menu.append($item);
                        }

                        if (angular.isDefined(item.separator)) {
                            const $separator = document.createElement('span');
                            $separator.className = 'sk-diagram-menu-separator';
                            $menu.append($separator);
                        }
                    });

                    if ($menu.childElementCount > 0) {
                        if (angular.isDefined(menuList) && menuList.length) {
                            if (countLabel === 0) {
                                // Only icons, enlarge images
                                $menu.classList.add('sk-diagram-menu--enlarge');
                            } else if (countIcon > 0 && countIcon !== menuList.length) {
                                // Texts without icons, adapt padding
                                $menu.classList.add('sk-diagram-menu--adapt');
                            } else if (countIcon === 0) {
                                // Only text, uniform padding
                                $menu.classList.add('sk-diagram-menu--uniform');
                            }
                        }

                        addMenuEvents($box, $arrow);
                        $image.append($arrow);
                        $box.classList.add('sk-diagram-box--actived');
                        $diagramArea.append($menu);
                    }
                }
            }

            // Closes arrow icon or menu opened
            function closeArrowMenuOpened($target) {
                let $arrowChild;
                let arrowValue;
                if (angular.isDefined($target)) {
                    $arrowChild = $target.querySelector('[data-diagram-arrow]');
                    arrowValue = $arrowChild.dataset.diagramArrow;
                }

                const $menuOpen = document.querySelector('.sk-diagram-menu--show');
                if (angular.isDefined($menuOpen) && arrowValue !== $menuOpen.dataset.diagramMenu) {
                    $menuOpen.removeAttribute('style');
                    $menuOpen.classList.remove('sk-diagram-menu--show');
                }

                const $arrowOpen = document.querySelector('.sk-diagram-arrow--show');
                if (angular.isDefined($arrowOpen) && arrowValue !== $arrowOpen.dataset.diagramArrow) {
                    $arrowOpen.classList.remove('sk-diagram-arrow--show');
                }

                const $tooltipOpen = document.querySelector('.sk-diagram-tooltip--show');
                if (angular.isDefined($tooltipOpen) && arrowValue !== $tooltipOpen.dataset.diagramTooltip) {
                    $tooltipOpen.removeAttribute('style');
                    $tooltipOpen.classList.remove('sk-diagram-tooltip--show');
                }
            }

            // Adds click and mouseover/out events to control the menu
            function addMenuEvents($box, $arrow) {
                $box.addEventListener('mouseover', function (event) {
                    const $target = event.currentTarget;
                    closeArrowMenuOpened($target);

                    const $arrow = $target.querySelector('.sk-diagram-arrow');
                    if (angular.isDefined($arrow)) {
                        if (self.enableOpenMenuOver) {
                            controlMenu($arrow, event);
                        } else {
                            $arrow.classList.add('sk-diagram-arrow--show');
                        }
                        controlTooltip($arrow, event);
                    }
                });

                document.addEventListener('mouseover', function (event) {
                    const $target = event.target;
                    if (angular.isDefined($target) && !$target.closest('.sk-diagram-box') && !$target.closest('.sk-diagram-menu')) {
                        closeArrowMenuOpened();
                    }
                });

                if (!self.enableOpenMenuOver) {
                    $arrow.addEventListener('click', function (event) {
                        const $arrow = event.currentTarget;
                        controlMenu($arrow, event);
                    });
                }
            }

            // Controls the tooltip arrow's selected
            function controlTooltip($arrow, event) {
                const arrowValue = $arrow.dataset.diagramArrow;
                const $tooltip = $diagramArea.querySelector(`[data-diagram-tooltip*="${arrowValue}"]`);
                if (angular.isDefined($tooltip)) {
                    const top = event.clientY - 90;
                    const left = event.clientX - ($tooltip.clientWidth / 2);
                    $tooltip.style.top = `${top}px`;
                    $tooltip.style.left = `${left}px`;
                    $tooltip.classList.add('sk-diagram-tooltip--show');
                }
            }

            // Controls the menu arrow's selected
            function controlMenu($arrow, event) {
                const arrowValue = $arrow.dataset.diagramArrow;
                const $menu = $diagramArea.querySelector(`[data-diagram-menu*="${arrowValue}"]`);
                if (angular.isDefined($menu)) {
                    const top = event.clientY + 11;
                    const left = event.clientX;
                    $menu.style.top = `${top}px`;
                    $menu.style.left = `${left}px`;
                    $menu.classList.add('sk-diagram-menu--show');
                }
            }

            // Creates the node image
            function createImage($image) {
                if (angular.isDefined(diagramNode) && angular.isDefined(diagramNode.body)) {
                    const body = diagramNode.body;
                    const $img = document.createElement('img');
                    $img.className = 'sk-diagram-image-img';
                    $img.setAttribute('src', body.image || noImage);
                    $image.style.maxWidth = `${configImage.width}px`;
                    $image.style.maxHeight = `${configImage.height}px`;
                    $image.append($img);
                }
            }

            // Creates tooltip into element
            function createTooltip(menuValue) {
                if (angular.isDefined(diagramNode) && angular.isDefined(diagramNode.body)) {
                    const body = diagramNode.body;
                    if (angular.isDefined(body.tooltip) && body.tooltip !== '') {
                        const $tooltip = document.createElement('div');
                        $tooltip.className = 'sk-diagram-tooltip';
                        $tooltip.innerHTML = body.tooltip;
                        $tooltip.setAttribute('data-diagram-tooltip', menuValue);
                        $diagramArea.append($tooltip);
                    }
                }
            }

            // Creates element box
            function createElement(obj, keyName, keyX, keyY, menuValue) {
                if (angular.isDefined(obj)) {
                    const $image = document.createElement('div');
                    $image.className = 'sk-diagram-image';
    
                    const $box = document.createElement('div');
                    $box.style.width = `${configElement.width}px`;
                    $box.className = 'sk-diagram-box';
    
                    createImage($image);
                    createMenu($box, $image, obj, menuValue);
                    createTooltip(menuValue);
    
                    $box.append($image);
    
                    if (angular.isDefined(obj[keyName])) {
                        const $label = document.createElement('span');
                        $label.textContent = obj[keyName];
                        $label.className = 'sk-diagram-label';
                        $box.append($label);
                    }

                    const $foreignObj = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
                    $foreignObj.setAttribute('x', obj[keyX] || 0);
                    $foreignObj.setAttribute('y', obj[keyY] || 0);
                    $foreignObj.setAttribute('width', configElement.width);
                    $foreignObj.setAttribute('height', configElement.height);
                    $foreignObj.append($box);

                    $foreignObj.addEventListener('dblclick', function (event) {
                        if (angular.isFunction(self.onDblClick)) {
                            let onDblClick = self.onDblClick();
                            onDblClick(obj);
                        }
                    });
    
                    return $foreignObj;
                }

                return null;
            }

            // Creates line label
            function createLabel(startBox, endBox, obj, keyName) {
                const labelWidth = configElement.width / 2;
                const labelHeight = configElement.height / 4;
                const labelPosition = {
                    horizontal: (startBox.x + endBox.x + labelWidth) / 2,
                    vertical: (startBox.y + (startBox.height / 2) +
                        endBox.y + (endBox.height / 2) - labelHeight) / 2
                };
                const $foreignObj = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
                $foreignObj.setAttribute('x', labelPosition.horizontal);
                $foreignObj.setAttribute('y', labelPosition.vertical);
                $foreignObj.setAttribute('width', labelWidth);
                $foreignObj.setAttribute('height', labelHeight);

                const $link = document.createElement('span');
                $link.textContent = obj[keyName];
                $link.className = 'sk-diagram-link';

                const $block = document.createElement('div');
                $block.className = 'sk-diagram-block';

                $block.append($link);
                $foreignObj.append($block);

                return $foreignObj;
            }

            // Removes all appended menu into body
            function removeAllMenus() {
                document.querySelectorAll('.sk-diagram-menu')
                    .forEach(($menu) => $menu.remove());
            }

            // Processes the diagram data
            function processGraph() {
                try {
                    snapSvg.clear();

                    removeAllMenus();

                    if ((isReload && angular.isUndefined(self.graphSrc)) || !isReload) {
                        self.graphSrc = self.dataset.getFieldValue(self.fieldName);
    
                        // Treatment to structure and normalize json
                        if (angular.isDefined(self.graphSrc)) {
                            self.graphSrc = AngularUtil.xmlStringToJson(self.graphSrc);
                        }
                    }

                    if (angular.isDefined(self.graphSrc)) {
                        const diagram = self.graphSrc.diagram;

                        if (angular.isDefined(diagram)) {
                            if (angular.isDefined(diagram.basenode) && !angular.isArray(diagram.basenode)) {
                                diagram.basenode = [diagram.basenode];
                            }

                            if (angular.isDefined(diagram.links) && !angular.isArray(diagram.links.link)) {
                                diagram.links.link = [diagram.links.link];
                            } else if (angular.isUndefined(diagram.links)) {
                                diagram.links = { link: [] };
                            }
                        }
                    }

                    createNodeElement();
                    createLineLink();

                    $timeout(function () {
                        self.diagramCreated({
                            diagram: self
                        });
                    }, 0, false);

                    isReload = false;

                } catch (error) {
                    console.error(error);
                    throw Error('Não foi possível renderizar o diagrama!');
                }
            }

            // Creates rect node and diagram element
            function createNodeElement() {
                if (angular.isDefined(self.graphSrc) && angular.isDefined(self.graphSrc.diagram)) {
                    self.graphSrc.diagram.basenode.forEach((node, index) => {
                        const limitValue = (configElement.width * 1.9);
                        const widthTotal = node.x + limitValue;
                        node.x = (widthTotal > diagramWidth) ? (diagramWidth - limitValue) : node.x;
                        const rectNode = snapSvg.rect(node.x, node.y, configElement.width, configElement.height);

                        rectNode.attr({
                            fill: '#ffffff',
                            fillOpacity: 0.0
                        });

                        NODES_BY_ID[node.nodeid] = rectNode;

                        if (angular.isFunction(self.elementBuildFunction)) {
                            const elementBuildFunction = self.elementBuildFunction();
                            const diagramNodeReturn = elementBuildFunction(node);
                            if (diagramNodeReturn instanceof DiagramNode) {
                                diagramNode = diagramNodeReturn;
                            }
                        }

                        rectNode.parent().append(createElement(node, 'name', 'x', 'y', index));
                    });
                }
            }

            // Creates diagram line link and label
            function createLineLink() {
                if (angular.isDefined(self.graphSrc) && angular.isDefined(self.graphSrc.diagram)) {
                        self.graphSrc.diagram.links.link.forEach(link => {
                        const color = '#888888';
                        const attr = { fill: color };
                        const points = [0, 4, 4, 4, 2, 0, 0, 4];
                        const startBox = NODES_BY_ID[link.orig].node.getBBox();

                        if (startBox.height === 0) {
                            let nodeOrig = getNodeByNodeId(self.graphSrc.diagram.basenode, link.orig);

                            startBox.height = 100;
                            startBox.width = 100;
                            if (nodeOrig) {
                                startBox.x = nodeOrig.x;
                                startBox.y = nodeOrig.y;
                            }
                        }

                        const endBox = NODES_BY_ID[link.dest].node.getBBox();
                        if (endBox.height === 0) {
                            let nodeDest = getNodeByNodeId(self.graphSrc.diagram.basenode, link.dest);

                            endBox.height = 100;
                            endBox.width = 100;
                            if (nodeDest) {
                                endBox.x = nodeDest.x;
                                endBox.y = nodeDest.y;
                            }
                        }
                        
                        const arrowEnd = snapSvg.polygon(points).attr(attr).transform('r90');
                        const markerEnd = arrowEnd.marker(0, 0, 4, 4, 3, 2);
                        const lineNode = snapSvg.line(startBox.x + configElement.width,
                            startBox.y + (startBox.height / 2), endBox.x, endBox.y + (endBox.height / 2));

                        if (angular.isDefined(link.bidirecional) && link.bidirecional.toUpperCase() === 'S') {
                            const arrowStart = snapSvg.polygon(points).attr(attr).transform('r270');
                            const markerStart = arrowStart.marker(0, 0, 4, 4, 1, 2);
                            lineNode.attr({ stroke: color, strokeWidth: 3, markerEnd, markerStart });
                        } else {
                            lineNode.attr({ stroke: color, strokeWidth: 3, markerEnd });
                        }

                        if (angular.isDefined(link.linkname)) {
                            lineNode.parent().append(createLabel(startBox, endBox, link, 'linkname'));
                        }
                    });
                }
            }

            function getNodeByNodeId(baseNode, nodeId) {
                for (node of baseNode) {
                    if (node.nodeid == nodeId) {
                        return node;
                    }
                }

                return undefined;
            }

        }]);
/**
 * @ngdoc directive
 * @name snk.components.dividedbox.directive:sk-hdividedbox
 * @restrict E
 * @description
     Componente de agrupamento horizontal com funcionalidade de redimensionamento
     <br>
     <b style="color: red;">Esse componente está em fase de criação e ainda não suporta o redimensionamento.</b>
 * @example
     <example module="hboxExample">
         <file name="hboxExample.html">
            <sk-hdividedbox sk-margin="10">
                <sk-divided-content>
                    <span>First</span>
                </sk-divided-content>
                <sk-divided-content>
                    <span>Second</span>
                </sk-divided-content>
                <sk-divided-content>
                    <span>Third</span>
                </sk-divided-content>
            </sk-hdividedbox>
         </file>
         <file name="hboxExample.js">
            angular
                .module('hboxExample', ['snk']);
         </file>
     </example>
 */

/**
 * @ngdoc directive
 * @name snk.components.dividedbox.directive:sk-vdividedbox
 * @restrict E
 * @description
     Componente de agrupamento vertical com funcionalidade de redimensionamento
     <br>
     <b style="color: red;">Esse componente está em fase de criação e ainda não suporta o redimensionamento.</b>
 * @example
     <example module="vboxExample">
         <file name="vboxExample.html">
            <sk-vdividedbox sk-padding="20">
                <sk-hdividedbox>
                    <span>First</span>
                </sk-hdividedbox>
                <sk-hdividedbox>
                    <span>Second</span>
                </sk-hdividedbox>
                <sk-hdividedbox>
                    <span>Third</span>
                </sk-hdividedbox>
            </sk-vdividedbox>
         </file>
         <file name="vboxExample.js">
            angular
                .module('vboxExample', ['snk']);
         </file>
     </example>
 */
[
    {name: 'skHdividedbox', direction: 'row'},
    {name: 'skVdividedbox', direction: 'column'}
]
.forEach(function(directiveMD) {
    angular
        .module('snk.components.dividedbox')
        .component(directiveMD.name, {
            restrict: 'E',
            controller: function($element) {
                this.$postLink = function() {
                    $element.attr('layout', directiveMD.direction);
                };
            }
        });
});
angular
    .module('snk.components.dividedbox')
    .component('skDividedContent', {
        restrict: 'E',
        controller: function($element) {
            this.$postLink = function() {
                $element.attr('layout', 'column');
            };
        }
    });
/**
 * @ngdoc directive
 * @name snk.components.divider:sk-divider
 * @restrict E
 * @description
 * Esse componente é um separador de conteúdo dentro de listas ou layouts que necessitam de divisões visuais.
 * Ele apresenta uma borda fina e leve o suficiente para não distrair o usuário do conteúdo.
 *
 */
angular
    .module('snk.components.divider')
    .directive('skDivider', [function(){
        return {
            restrict: 'E',
            compile: function(elem){
                elem.addClass('sk-divider');
            }
        };
    }]);
angular
    .module('snk.components.doublefacepanel')
    .controller('SkDoubleFacePanelController', ['$scope', '$element', '$q', '$timeout', 'ObjectUtils', 'SkApplication', 'DoubleFacePanelConstants', 'KeyboardEvents', 'AngularUtil', '$attrs', 'i18n', 
        function ($scope, $element, $q, $timeout, ObjectUtils, SkApplication, DoubleFacePanelConstants, KeyboardEvents, AngularUtil, $attrs, i18n) {
        var self = this;

        ObjectUtils.implements(self, IDataSetObserver);

        var _selectedIndex;
        var _internalActions = [];
        var _doubleViewActived = false;

        self.insertionModeActivated = insertionModeActivated;
        self.setSelectedIndex = setSelectedIndex;
        self.editionModeActivated = editionModeActivated;
        self.addInternalAction = addInternalAction;
        self.getDoubleViewActived = getDoubleViewActived;
        self.setDoubleViewActived = setDoubleViewActived;

        $scope.changeFace = self.changeFace = changeFace;
        $scope.getSelectedIndex = self.getSelectedIndex = getSelectedIndex;
        $scope.getInternalActions = getInternalActions;

        init();

        function init() {
            $scope.$watch('showDoubleView', function(newValue) {
                if (newValue) {
                    addInternalAction({
                        showCheck: true,
                        label: i18n('DoubleFacePanel.lblMostrarGradeForm'),
                        action: function() {
                            setDoubleViewActived(!_doubleViewActived);
                        }
                    });
                }
            });

            if ($attrs.skDataset) {
                var unWatch = $scope.$watch('dataset', function(dataset){
                    if (dataset) {
                        dataset.addObserver(self);

                        unWatch();
                    }
                })
            }

            setSelectedIndex($scope.defaultFaceIndex);

            var changeFaceDereg = SkApplication.instance().addEventListener(KeyboardEvents.CHANGE_FACE_KEY, changeFaceKeyHandler);
            AngularUtil.onDestroyScope($scope, changeFaceDereg);

            if ($scope.onPanelCreated) {
                $timeout(function() {
                    $scope.onPanelCreated({doubleFacePanel: self});
                }, 0, false);
            }

            $scope.toolTipPlacement = $scope.toolTipPlacement || 'bottom';
        }

        function changeFaceKeyHandler(params,evt) {
            if (AngularUtil.checkHandleThisEvent($element, params.target)) {
                evt.preventDefault();
                changeFace();
            }
        }

        function resolveFocus() {
            $timeout(function() {
                var activeFace;

                if (_selectedIndex === 0) {
                    activeFace = 'sk-face-one';
                } else {
                    activeFace = 'sk-face-two';
                }

                $scope.focusResolver({index: _selectedIndex, faceSelector: activeFace});
            }, 0, false);
        }

        function setSelectedIndex(newIndex){
            if (newIndex) {
                if (angular.isNumber(newIndex)){
                    _selectedIndex = newIndex;

                    if (_selectedIndex < 0 || _selectedIndex > 1){
                        _selectedIndex = 0;
                    }
                } else {
                    _selectedIndex = DoubleFacePanelConstants[newIndex] || 0;
                }
            } else {
                _selectedIndex = 0;
            }
            refreshState();
        }

        function insertionModeActivated() {
            if($scope.dataset && !$scope.dataset.isEnableInsertionModeGrid()){
                setSelectedIndex(0);
            }
            AngularUtil.digest($scope);
        }

        function updateIconAndTooltip() {
            if (getSelectedIndex() == 0) {
                $scope.iconChangeFace = 'table';
            } else {
                if($scope.customFormIcon) {
                    $scope.iconChangeFace = $scope.customFormIcon;
                } else {
                    $scope.iconChangeFace = 'list';
                }
            }
        }

        function getSelectedIndex() {
            return _selectedIndex;
        }

        function changeFace() {
            _selectedIndex = _selectedIndex ^ 1;
            refreshState();
        }

        function editionModeActivated(multiEditMode) {
            if (multiEditMode) {
                insertionModeActivated();
            }
        }

        function addInternalAction(action) {
            _internalActions.push(action);
        }

        function getInternalActions() {
            if(angular.isUndefined($scope.changeButtonActions)) {
                $scope.changeButtonActions = [];
            }
            return $scope.changeButtonActions.concat(_internalActions);
        }

        function refreshState() {
            updateIconAndTooltip();
            AngularUtil.digest($scope);

            resolveFocus();

            $scope.$broadcast('datagridRecalculate');

            ($scope.onChangeFace || angular.noop)({'face':_selectedIndex});
        }

        function getDoubleViewActived() {
            return _doubleViewActived;
        }

        function setDoubleViewActived(value) {
            if (_doubleViewActived !== value) {
                _doubleViewActived = value;
                if (angular.isFunction($scope.onChangeDoubleView)) {
                    $timeout(function() {
                        $scope.onChangeDoubleView(value);
                    }, 0, false);
                }
            }
        }
    }]);

/**
 * @ngdoc directive
 * @name snk.components.doublefacepanel.directive:sk-double-face-panel
 * @restrict E
 * @scope
 * @description
    Preencher
 *
 * @example
     <example module="appDoubleFacePanel">
         <file name="appDoubleFacePanel.html">
            <sk-application ng-controller="TesteController as ctrl" style="height: 210px;">
                <sk-double-face-panel>
                    <sk-top-bar>
                        <button class="btn btn-default" ng-click="meuBotao()">Meu Botão</button>
                    </sk-top-bar>
                    <sk-face-one>FaceOne</sk-face-one>
                    <sk-face-two>FaceTwo</sk-face-two>
                </sk-double-face-panel>
            </sk-application>
         </file>
         <file name="appDoubleFacePanel.js">
             angular
             .module('appDoubleFacePanel', ['snk'])
             .controller('TesteController', function ($scope){
                    $scope.meuBotao = function(){
                        alert('Minha ação');
                    };
                });
         </file>
     </example>
 */
angular
    .module('snk.components.doublefacepanel')
    .directive('skDoubleFacePanel', ['$compile', function ($compile) {
        return {
            scope: {
                showTopBar: '=?skShowTopBar',
                dataset: '=?skDataset',
                defaultFaceIndex: '@?skDefaultFaceIndex',
                changeButtonActions: '=?skChangeButtonActions',
                focusResolver: '&skFocusResolver',
                onPanelCreated: '&?skDoubleFacePanelCreated',
                hideButtonGridForm: '=?skHideButtonGridForm',
                toolTipPlacement: '@?skToolTipPlacement',
                customFormIcon: '@?skCustomFormIcon',
                customFormTooltip: '@?skCustomFormTooltip',
                onChangeFace: '&?skOnChangeFace',
                hideButtonDoubleFace: '=?skHideButtonDoubleFace',
                showDoubleView: '=?skShowDoubleView',
                onChangeDoubleView: '=?skChangeDoubleView'
            },
            controller: 'SkDoubleFacePanelController',
            controllerAs: 'ctrl',
            templateUrl: 'components/doublefacepanel/doublefacepanel.tpl.html',
            transclude: true,
            link: function ($scope, $element, $attr, controller) {
                $scope.showTopBar = angular.isDefined($scope.showTopBar) ? $scope.showTopBar : true;

                var topBar = angular.element($element[0].querySelector('.top-bar'));
                var contentElem = angular.element($element[0].querySelector('.content'));
                var userTopBar = $element.find('sk-top-bar');
                var taskBar = $element.find('sk-taskbar');

                if ($attr.id) {
                    $scope.$parent[$attr.id] = controller;
                    controller.id = $attr.id;
                }

                $element.attr('layout', 'column');
                $element.attr('flex', $attr.flex || '');

                contentElem.attr('layout', 'column');
                contentElem.attr('flex', $attr.flex || '');

                if (!$scope.showTopBar) {
                    topBar.remove();
                } else {
                    if(taskBar && taskBar[0]) {
                        taskBar.detach();

                        if (taskBar.attr('layout')) {
                            topBar.attr('layout', taskBar.attr('layout'));
                        } else {
                            topBar.attr('layout', '')
                            topBar.attr('layout-padding', '');
                        }

                        topBar.append(taskBar);
                    }

                    if (userTopBar && userTopBar[0]) {
                        userTopBar.detach();

                        if (userTopBar.attr('layout')) {
                            topBar.attr('layout', userTopBar.attr('layout'));
                        } else {
                            topBar.attr('layout', 'row');
                        }

                        if (userTopBar.attr('layout-align')) {
                            topBar.attr('layout-align', userTopBar.attr('layout-align'));
                        }

                        if (userTopBar.attr('flex')) {
                            topBar.attr('flex', userTopBar.attr('flex'));
                        }

                        var toTransferAttrs = [
                            'layout-padding',
                            'layout-top-padding',
                            'layout-bottom-padding',
                            'layout-left-padding',
                            'layout-right-padding'
                        ];

                        toTransferAttrs.forEach(function (attr) {
                            if (userTopBar[0].attributes.hasOwnProperty(attr)) {
                                topBar.attr(attr, userTopBar.attr(attr));
                            }
                        });

                        if (!userTopBar[0].attributes.hasOwnProperty('white')) {
                            topBar.addClass('high-contrast-panel');
                        }

                        if (userTopBar[0].attributes.hasOwnProperty('filter-panel-btn')) {
                            var filterPanelBtn = angular.element('<sk-filter-panel-btn></sk-filter-panel-btn>');
                            topBar.prepend($compile(filterPanelBtn)($scope));
                        }

                        topBar.append(userTopBar.children());
                    }
                }
            }
        };
    }]);

angular
    .module('snk.components.doublefacepanel')
    .constant("DoubleFacePanelConstants", {
        "FORM_FACE": 0,
        "GRID_FACE": 1
    });
/**
 * @ngdoc directive
 * @name snk.components.doublefacepanel.directive:sk-face
 * @restrict E
 * @scope
 * @description
    Preencher
 */

['One', 'Two'].forEach(function(suffix, index){
    var _directiveName = 'skFace' + suffix;
    var _index = index;

    angular
        .module('snk.components.doublefacepanel')
        .directive(_directiveName, [function (){
            return {
                scope: {
                    selected: '=selected'
                },
                require: '^skDoubleFacePanel',
                template: getTemplate,
                compile: compileFn,
                transclude: true
            };

            function getTemplate(tElem, tAttrs) {
                var template = angular.element('<div ng-show="isSelected()" ng-transclude></div>');
                template.attr('layout', 'column');
                template.attr('flex', tAttrs.flex || '');
                return template;
            }

            function compileFn(tElement) {
                tElement.addClass(tElement[0].tagName.toLowerCase());

                return function postLink(scope, iElement, iAttrs, ctrl) {
                    iElement.attr('layout', 'column');
                    iElement.attr('flex', iAttrs.flex || '');

                    scope.isSelected = function() {
                        var isSelected = ctrl.getSelectedIndex() == _index;

                        iElement[isSelected ? 'removeClass' : 'addClass']('unselected');

                        return isSelected;
                    }
                }
            }
        }]);
});
angular
    .module('snk.components.dragdrop')
    .directive('droppable', function() {
        return {
            scope: {
                drop: '&?',
                dragExit: '&?',
                dragOver: '&?',
                dragEnd: '&?',
                dragLeave: '&?'
            },
            link: function(scope, element) {
                let el = element[0];               
                
                el.addEventListener('dragover', (event) => {
                    (scope.dragOver || angular.noop)( { $event: event } );
                    event.stopPropagation();
                    event.preventDefault();
                });

                el.addEventListener('dragexit', (event) => (scope.dragExit || angular.noop)( { $event: event } ));
                
                el.addEventListener('drop', (event) => (scope.drop || angular.noop)( { $event: event } ));

                el.addEventListener('dragend', (event) => (scope.dragEnd || angular.noop)( { $event: event } ));

                el.addEventListener('dragleave', (event) => (scope.dragLeave || angular.noop)( { $event: event } ));                	
            }
        }
    });
angular
    .module('snk.components.dragdrop')
    .directive('simpleDraggable', function() {
        return {
            scope: {
                dragStart: '&?'
            },
            link: function(scope, element) {
                let el = element[0];

                el.setAttribute('draggable', true);

                el.addEventListener('dragstart', (event) => (scope.dragStart || angular.noop)( { $event: event } ));
            }
        }
    });
/**
 * @ngdoc directive
 * @name snk.components.draggable.directive:sk-draggable
 * @restrict A
 * @description
 * A diretiva 'skDraggable' permite você fazer uma marcação em um determinado elemento HTML que deseja mover o mesmo na tela.
 *
 * Ele permite você configurar também em qual pai vai ocorrer a ação para mover na tela o componente.
 *
 * @element ANY
 *
 * @param {number=} [draggableLevel=0] utilizado para informar em qual nível superior será aplicado os eventos de mouse para mover o elemento marcado.
 *
 * @example
     <example module="app">
         <file name="DraggableIndex.html">
            <div style="width:100%;height:120px;position:relative;">
                <div sk-draggable draggable-level="0" style="width:100px;height:100px;background:#000;cursor:move;"></div>
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.draggable')
    .directive('skDraggable', ['$document', 'UserAgentUtils', 'PositionUtils', function ($document, UserAgentUtils, PositionUtils) {
        return {
            restrict: 'A',
            link: linkFn
        };

        function linkFn(scope, element, attr) {
            var startX = 0;
            var startY = 0;
            var x = 0;
            var y = 0;
            var dragElem = element;
            var dragLevel = parseInt(attr.draggableLevel || 0);
            var i = dragLevel;

            var _docOffset;
            var _dragElemOffset;
            var _bodyElem = angular.element($document[0].body);

            while (i > 0) {
                dragElem = dragElem.parent();

                if (angular.isUndefined(dragElem) || dragElem === null) {
                    throw new Error('Undefined parent at level ' + dragLevel + '.');
                }

                i--;
            }

            dragElem.css('position', 'absolute');

            element.on('mousedown', handlerDown);
            element.on('touchstart', handlerDown);

            function handlerDown(event) {
                if (event.target.attributes.hasOwnProperty('sk-draggable-off')) {
                    return;
                }

                eventEmited = false;

                var dragBounds = element[0].getBoundingClientRect();

                x = dragBounds.left;
                y = dragBounds.top;

                // Prevent default dragging of selected content
                event.preventDefault();

                var clients = getEventPosition(event);

                startX = clients.clientX;
                startY = clients.clientY;

                $document.on('mousemove', mousemove);
                $document.on('mouseup', mouseup);

                $document.on('touchmove', mousemove);
                $document.on('touchend', mouseup);

                _docOffset = PositionUtils.offset(_bodyElem);
                _dragElemOffset = PositionUtils.offset(dragElem);
            }

            function mousemove(event) {
                var clients = getEventPosition(event);

                x += clients.clientX - startX;
                y += clients.clientY - startY;

                if (x < 0) {
                    x = 0;
                } else if ((x + _dragElemOffset.width) > _docOffset.width) {
                    x = _docOffset.width - _dragElemOffset.width;
                }

                if (y < 0) {
                    y = 0;
                } else if ((y + _dragElemOffset.height) > _docOffset.height + _bodyElem.scrollTop()) {
                    y = _docOffset.height - _dragElemOffset.height;
                    console.log('com scroll');
                }

                startX = clients.clientX;
                startY = clients.clientY;

                dragElem.css({
                    top: y + 'px',
                    left: x + 'px'
                });
            }

            function mouseup() {
                $document.off('mousemove', mousemove);
                $document.off('mouseup', mouseup);

                $document.off('touchmove', mousemove);
                $document.off('touchend', mouseup);
            }

            function getEventPosition(event) {
                var clientX;
                var clientY;

                if (event.type.indexOf('touch') > -1) {
                    clientX = event.originalEvent.touches[0].clientX;
                    clientY = event.originalEvent.touches[0].clientY;
                } else {
                    clientX = event.clientX;
                    clientY = event.clientY;
                }

                return {
                    'clientX': clientX,
                    'clientY': clientY
                };
            }
        };
    }]);
angular
    .module('snk.components.draggablelist')
    .controller('SkDraggableListController', ['$scope', '$attrs', '$element', 'ArrayUtils', 'i18n', 'ObjectUtils', 'AngularUtil', '$timeout',
        function ($scope, $attrs, $element, ArrayUtils, i18n, ObjectUtils, AngularUtil, $timeout) {
            var self = this;
            var _lastSrcSelected;            
            var _firstDragEventsAdded = false;
            var _lockDrop = false;
            var _dragItem = undefined;
            var _dragIsInternal = false;

            $scope.selectedItems = [];
            $scope.selectItem = selectItem;
            $scope.addDragItem = addDragItem;
            $scope.onMouseDown = onMouseDown;

            self.setSelectedItems = setSelectedItems;
            self.unselectAllItems = unselectAllItems;
            self.getScopeApi = getScopeApi;

            init();

            function init() {
                $scope.api = self;

                $element.attr('layout', 'column');

                if (angular.isDefined($attrs['skSrcTitle'])) {
                    $scope.srcTitle = i18n($attrs['skSrcTitle']);
                }

                if (angular.isDefined($attrs['skDestTitle'])) {
                    $scope.destTitle = i18n($attrs['skDestTitle']);
                }

                var controllerInfo = AngularUtil.getContextControllerInfo($element);
                var controllerAs = ObjectUtils.getProperty(controllerInfo, 'controllerAs');
                if (controllerAs) {
                    $scope[controllerAs] = controllerInfo.controllerInstance;
                }
                

                $scope.srcData = $scope.srcData || [];                

                $scope.$watch('srcData', function(newV, oldV) {
                    if (newV !== oldV) {
                        unselectAllItems();

                        if (newV && newV.length > 0) {
                            selectItem(newV[0]);
                        }
                    }

                    if(!_firstDragEventsAdded) addDragEvents();
                });

                $scope.$watchCollection('srcData', function(newV, oldV) {
                    if (newV !== oldV) {
                        addDragEvents();
                    }
                    if(newV.length != oldV.length){
                        unselectAllItems();
                    }
                });

            }

          function onMouseDown(item, $event){
            var itemSelected = true;
            var listItens = $scope.selectedItems;
            
            for (const i of listItens) {
                if(i.id == item.id) itemSelected = false;
            }

            if ($event && !$event.ctrlKey && !$event.shiftKey && itemSelected) {
                unselectAllItems();
                $scope.selectedItems.push(item);
                _lastSrcSelected = item;
            }

          }

            function selectItem(item, $event) {
                if ($event && !$event.ctrlKey && !$event.shiftKey) {
                    unselectAllItems();
                    $scope.selectedItems.push(item);
                    _lastSrcSelected = item;
                } else if ($event && $event.shiftKey) {
                    var lastSelectedIndex;
                    var currentIndex;
                    lastSelectedIndex = $scope.srcData.indexOf(_lastSrcSelected);
                    currentIndex = $scope.srcData.indexOf(item);
                    _lastSrcSelected = item;

                    if (lastSelectedIndex < currentIndex) {
                        for (var i = lastSelectedIndex; i <= currentIndex; i++) {
                            $scope.selectedItems.push($scope.srcData[i]);
                        }
                    } else {
                        for (var i = lastSelectedIndex; i >= currentIndex; i--) {
                            $scope.selectedItems.push($scope.srcData[i]);
                        }
                    }
                } else {                    
                    if ($scope.selectedItems.indexOf(item) < 0) {
                        $scope.selectedItems.push(item);
                        _lastSrcSelected = item;
                    } else {
                        ArrayUtils.removeReference($scope.selectedItems, item);
                    }
                }
            }

            function unselectAllItems() {
                $scope.selectedItems.length = 0;
            }

            function setSelectedItems(items){

                if(!angular.isArray(items)){
                    items = [items];
                }

                unselectAllItems();

                items.forEach(function(item){
                    selectItem(item)
                });
            }

            function addDragEvents(){
                $timeout(function(){
                    let items = $element[0].querySelectorAll('.draggable-item');

                    $element.off('dragenter');
                    $element.off('dragover');
                    $element.off('drop');
                    
                    $element.on('dragenter', ondragenter);
                    $element.on('dragover', ondragover);
                    $element.on('drop', ondrop);
                    
                    items.forEach(function(item){
                        item = angular.element(item);

                        item.off('dragstart');                        
                        item.off('dragend');                        
                        item.off('drop');

                        item.on('dragstart', ondragstart);
                        
                        item.on('dragend', ondragend);
                        
                        item.on('drop', ondrop);

                        item.attr('id', $element.attr('id'));
                    });
                    
                    _firstDragEventsAdded = true;
                });
            }

            function ondragstart(event){
                var id = angular.copy($element.attr('id'));
                event.originalEvent.dataTransfer.setData('id', id);

                var indexs = [];
                
                if(_dragItem && $scope.selectedItems.indexOf(_dragItem) == -1){
                    $scope.selectedItems.push(_dragItem);
                }

                $scope.selectedItems.forEach(function(item){
                    indexs.push($scope.srcData.indexOf(item));
                });

                event.originalEvent.dataTransfer.setData('items', JSON.stringify({'items' : angular.copy($scope.selectedItems), 'indexs': indexs}) );

                if($scope.dragStart){
                    $scope.dragStart({event: event})
                }

                _dragIsInternal = true;
            }

            function ondragenter(event){
                if($scope.dragEnter) $scope.dragEnter({event : event});
            }

            function ondragover(event){
                if($scope.dragOver) $scope.dragOver({event : event});
                event.preventDefault();                
            }

            function ondrop(event){

                if(_lockDrop){
                	unselectAllItems();
                    return;
                }

                let itemToOverwrite = getItemToOverwrite(event);

                let itemsToInsert = [];

                if(event.originalEvent.dataTransfer.getData('items')){
                    var parseItems = JSON.parse(event.originalEvent.dataTransfer.getData('items'));
                    
                    if(parseItems.indexs){
                        parseItems.indexs.forEach(function(index){
                            itemsToInsert.push($scope.srcData[index]);
                        });
                    }
                }
                
                if(itemToOverwrite){                        
                    _lockDrop = true;

                    if(_dragIsInternal){
                        insertItems(itemsToInsert, itemToOverwrite);
                    }

                    $timeout(function(){
                        _lockDrop = false;
                    });
                }else if(_dragIsInternal){
                    insertItems(itemsToInsert, itemToOverwrite);
                }

                event.itemToOverwrite = JSON.stringify(itemToOverwrite);

                if($scope.drop) $scope.drop({event : event});

                _dragItem = undefined;

                AngularUtil.digest($scope);
            }

            function ondragend(event){
                if($scope.dragEnd) $scope.dragEnd({event : event});
            }

            function getItemToOverwrite(event){
                let index = event.currentTarget.getAttribute('index');
                if(index){
                    return $scope.srcData[index];
                }

                return undefined;
            }

            function insertItems(items, itemToOverwrite){
                if(!angular.isArray(items)){
                    items = [items];
                }

                let positionToInsert = $scope.srcData.indexOf(itemToOverwrite);

                items.forEach(function(item){
                    //Já existe nos itens, devemos apenas reordenar;
                    if($scope.srcData.indexOf(item) > -1){ 
                        ArrayUtils.removeReference($scope.srcData, item, false);
                        if(positionToInsert == -1){
                            ArrayUtils.insertAtIndex($scope.srcData, $scope.srcData.length, item);                            
                        }else{
                            ArrayUtils.insertAtIndex($scope.srcData, positionToInsert, item);
                        }
                    }else{//Apenas inserimos no fim da lista
                        $scope.srcData.push(item);
                    }

                    if(angular.isFunction($scope.onChangeItem)){
                        $scope.onChangeItem({item: item, positionToInsert: (positionToInsert == -1 ? $scope.srcData.length : positionToInsert)});
                    }

                });                
            }

            function addDragItem(item){
                _dragItem = item;
            }
            
            function getScopeApi(){
                return $scope;
            }

        }        
    ]);

/**
 * @ngdoc directive
 * @name snk.components.draggablelist.directive:sk-draggable-list
 * @scope
 * @description
 * DraggableList é o componente utilizado quando se precisa manipular uma lista com drag an drop na ordenação dos elementos e drag and drop para outros componentes.<br/>
 * @param {Array} [sk-src-data=undefined] Array de objetos com a lista a ser renderizada. As alterações relizadas pelo sk-list(ordenção, adição) são refletidas nesse array.
 * @param {Array} [sk-selected-items] Array que irá armazenar os itens que estão selecionados na lista.
 * @param {Object} [sk-api] Varivel onde a api do componente sera injetada.
 * @param {function} sk-on-change-item Função a ser chamada quando um item da lista é movido ou adicionado. Recebe como parâmetro o item e o novo indice.
 * @param {function} sk-drag-start Acionado quando o usuário começa a arrastar um item do list
 * @param {function} sk-drag-enter Acionado quando uma linha entra em um ponto de soltura
 * @param {function} sk-drag-over Acionado quando um item da lista está sendo arrastado sobre um ponto de soltura válido
 * @param {function} sk-drop Acionado quando um item é solto em um ponto de soltura (drop target) válido
 * @param {function} sk-drag-end Acionado quando uma operação de arrastar está terminando
 
 * @example
 <example module="app">
     <file name="exemplo.html">
        <div ng-controller="MyController as ctrl" layout="row" flex style="height:150px;width:100%">
            <!-- normal-mode -->

            <sk-draggable-list flex="50"
                    id="draggable-list-id"
		            sk-src-data="ctrl.srcData"
                    sk-selected-items="ctrl.selecteds"
                    sk-api="ctrl.listApi"
                    sk-drop="ctrl.listDrop(event)"
		            layout-padding>
		            <sk-item-tpl>
		                <div>{{item.sobrenome +', '+ item.nome}}</div>
		            </sk-item-tpl>
            </sk-draggable-list>

            <div flex="50">
                <button ng-click="ctrl.selectItems()">Select items</button>
                <button ng-click="ctrl.unselectAll()">Unselect items</button>
                <div>SelectedItens: {{ctrl.selecteds}}</div>
                 <div>srcData: {{ctrl.srcData}}</div>
            </div> 

        </div>
            
     </file>
     <file name="app.js">
         angular
         .module('app', ['snk'])
         .controller('MyController', function($scope, StringUtils){
                var self = this;

                self.selecteds = [];
                self.listApi;

                self.selectItems = selectItems;
                self.unselectAll = unselectAll;

                self.srcData = [
                {
                    nome: 'Leonardo',
                    sobrenome: 'Jorge'
                },
                {
                    nome: 'João',
                    sobrenome: 'Silva'
                },
                {
                    nome: 'Maria',
                    sobrenome: 'Júlia'
                }
            ];

            function selectItems(){
             self.listApi.setSelectedItems([self.srcData[0], self.srcData[2]]);
            }

            function unselectAll(){
                self.listApi.unselectAllItems();
            }

                
            });
         </file>
 </example>
**/
angular
    .module('snk.components.draggablelist')
    .directive('skDraggableList',[
       function() {
           return {
               restrict: 'E',
               templateUrl: 'components/draggablelist/draggablelist.tpl.html',
               controller: 'SkDraggableListController',
               transclude: {
                   itemTpl: '?skItemTpl',
               },
               scope: {
                   srcData: '=?skSrcData',
                   selectedItems: '=?skSelectedItems',
                   api: '=?skApi',
                   onChangeItem: '&?skOnChangeItem',
                   dragStart: '&?skDragStart',
                   dragEnter: '&?skDragEnter',
                   dragOver: '&?skDragOver',
                   drop: '&?skDrop',
                   dragEnd: '&?skDragEnd'
               }
           }
       }
    ]);
angular
    .module('snk.components.dropdown')
    .directive('dropdownMenu', [function () {
        return {
            restrict: 'AC',
            require: '?^dropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl) {
                    return;
                }
                dropdownCtrl.dropdownMenu = element;
            }
        };
    }]);
angular
    .module('snk.components.dropdown')
    .directive('dropdownToggle', ['SkTourService', function (SkTourService) {
        return {
            require: '?^dropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl) {
                    return;
                }

                dropdownCtrl.toggleElement = element;

                var toggleDropdown = function (event) {
                    if (SkTourService.isOnTour()){
                        return;
                    }

                    event.preventDefault();

                    if (!element.hasClass('disabled') && !attrs.disabled) {
                        scope.$apply(function () {
                            dropdownCtrl.toggle();
                        });
                    }
                };

                element.bind('click', toggleDropdown);

                // WAI-ARIA
                element.attr({'aria-haspopup': true, 'aria-expanded': false});
                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
                    element.attr('aria-expanded', !!isOpen);
                });

                scope.$on('$destroy', function () {
                    element.unbind('click', toggleDropdown);
                });
            }
        };
    }]);
angular
    .module('snk.components.dropdown')
    .constant('dropdownConfig', {
        openClass: 'open'
    });
angular
    .module('snk.components.dropdown')
    .controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', 'PositionUtils', '$document', '$timeout', 'StringUtils', function ($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, PositionUtils, $document, $timeout, StringUtils) {
        var self = this;
        var scope = $scope.$new();//create a child scope so we are not polluting original one
        var openClass = dropdownConfig.openClass;
        var getIsOpen;
        var setIsOpen = angular.noop;
        var toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;
        var appendToBody = false;
        var windowElem = angular.element(window);

        self.init = init;
        self.toggle = toggle;
        self.isOpen = isOpen;

        function init(element) {
            self.$element = element;

            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                $scope.$watch(getIsOpen, function (value) {
                    scope.isOpen = !!value;
                });
            }

            appendToBody = angular.isDefined($attrs.dropdownAppendToBody);

            if (appendToBody && self.dropdownMenu) {
                self.dropdownMenu[0].originalParent = self.dropdownMenu[0].parentElement;
                $document.find('body').append(self.dropdownMenu);
                element.on('$destroy', function handleDestroyEvent() {
                    self.dropdownMenu.remove();
                });
            }

            windowElem.on('resize', function() {
                scope.isOpen = false;
            });
        }

        function toggle(open) {
            return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
        }

        // Allow other directives to watch status
        function isOpen() {
            return scope.isOpen;
        }

        scope.getToggleElement = function () {
            return self.toggleElement;
        };

        scope.getAutoClose = function () {
            return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
        };

        scope.getElement = function () {
            return self.$element;
        };

        scope.focusToggleElement = function () {
            if (self.toggleElement) {
                self.toggleElement[0].focus();
            }
        };

        scope.$watch('isOpen', function (isOpen, wasOpen) {
            if (appendToBody && self.dropdownMenu) {
                var hPlacement = $attrs.hPlacement;

                if (!hPlacement) {
                    hPlacement = 'left';
                }

                var pos = PositionUtils.positionElements(self.$element, self.dropdownMenu, 'bottom-' + hPlacement, true, false);
                var left = pos.left;

                self.dropdownMenu.css({
                    display: isOpen ? 'block' : 'none'
                });

                if (isOpen) {
                    self.dropdownMenu.css('visibility', 'hidden');

                    $timeout(function(){
                        var offset = PositionUtils.offset(self.dropdownMenu, true);
                        var wWidth = $document[0].documentElement.clientWidth;

                        var diff = wWidth - (left + offset.width);

                        if (diff < 0) {
                            left = (left - offset.width) + self.$element[0].clientWidth;
                        }

                        if (hPlacement == 'right' ) {
                            if ((left - offset.width) > 0) {
                                left = left - offset.width;
                            }
                        }

                        var top;
                        var activeScroll  = false;
                        var elemOffset = PositionUtils.offset(self.$element[0], true);
                        var topBiggerElementLeft = elemOffset.top > elemOffset.bottom ? true : false;
                        var fullHeight = PositionUtils.scrollTop($document, true) + $document[0].documentElement.clientHeight;

                        // topBiggerElementLeft = Valida qual elemento restante é maior, utilizando o mesmo para alocar o scroll
                        if(elemOffset.top + self.dropdownMenu[0].clientHeight > fullHeight) {
                           if(!topBiggerElementLeft){
                              top = pos.top;
                           }else{
                              top = pos.top - self.$element[0].clientHeight - self.dropdownMenu[0].clientHeight - 5;
                           }

                           activeScroll = true;
                        } else {
                           top = pos.top;
                        }

                        if ($attrs.topOffset) {
                           top = top + Number($attrs.topOffset); 
                        }

						// Scroll adicionado quando o elemento não tem espaço suficiente para mostrar na tela.
                        if(activeScroll){
                           if(topBiggerElementLeft){
                              self.dropdownMenu[0].style.height = self.dropdownMenu[0].offsetHeight + top + 'px';
                              top = 0;
                           }
                           self.dropdownMenu[0].style.overflow = 'auto';
                        }else {
                           self.dropdownMenu[0].style.height = 'auto';
                        }

                        self.dropdownMenu.css({
                            left: StringUtils.toPX(left),
                            top: StringUtils.toPX(top),
                            visibility: 'visible'
                        });
                    }, 0, false);

                    //FIXME: ADICIONAR EVENTO DE SCROLL PARA OCULTAR O DROPDOWN
                } else {
                     self.dropdownMenu[0].style.height = 'auto'
                }
            }

            $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);

            if (isOpen) {
                scope.focusToggleElement();
                dropdownService.open(scope);
            } else {
                dropdownService.close(scope);
            }

            setIsOpen($scope, isOpen);
            if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
                toggleInvoker($scope, {open: !!isOpen});
            }
        });

        $scope.$on('$locationChangeSuccess', function () {
            scope.isOpen = false;
        });

        $scope.$on('$destroy', function () {
            scope.$destroy();
        });
    }]);
angular
    .module('snk.components.dropdown')
    .directive('skDropdown', ['AngularUtil', '$compile', '$parse',
        function (AngularUtil, $compile, $parse) {
            return {
                scope: {
                    value: '=skValue',
                    fontIcon: '@?skFontIcon',
                    svgUrl: '@?skSvgUrl',
                    text: '@?skText'
                },
                templateUrl: 'components/dropdown/dropdown.tpl.html',
                restrict: 'E',
                link: postLink,
                transclude: true
            };

            function postLink(scope, element, attr, controller, transclude) {

                transclude(function (clone) {

                    var dropdownMenu = element[0].querySelector('.dropdown-menu');
                    var valueIndex = 0;

                    angular.forEach(clone, function (item) {

                        var li;

                        switch (item.nodeName.toLowerCase()) {
                            case 'sk-dropdown-header':
                                li = angular.element(document.createElement('li'));
                                li.addClass('dropdown-header');
                                li.text(item.textContent);

                                $compile(li)(scope);

                                li.bind('click', function (evt) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                });

                                break;

                            case 'sk-dropdown-separator':
                                li = angular.element(document.createElement('li'));
                                li.addClass('divider');
                                li.attr('role', 'separator');

                                break;

                            case 'sk-dropdown-item':
                                var value = angular.element(item).attr('value') || valueIndex++;

                                li = AngularUtil.createDirective('li', {
                                    'ng-class': "{'selected': value == '" + value + "'}",
                                    'ng-click': 'value = \'' + value + '\''
                                }, scope);

                                var a = AngularUtil.createDirective('a', {
                                    'translate': item.textContent
                                }, scope);

                                li.append(a);

                                break;

                          case 'sk-dropdown-switch':
                              li = angular.element(document.createElement('li'));

                              li.bind('click', function (evt) {
                                evt.preventDefault();
                                evt.stopPropagation();
                              });

                              var a = angular.element(document.createElement('a'));
                              a.addClass('dropdown-switch');
                              a.append(item);

                              li.append(a);
                              break;

                            default:
                        }

                        if (li) {
                            dropdownMenu.appendChild(li[0]);
                        }
                    });
                });
            }
        }])
    .directive('skDropdownSwitch', ['i18n',
      function (i18n) {
        return {
          scope: {
            switchValue: '=skValue',
            change: '&?skChange'
          },
          template: '<sk-switch sk-value="switchValue" sk-true-value="true" sk-false-value="false" sk-change="onChangeValue()"></sk-switch><span class="dropdown-switch-label"></span>',
          restrict: 'E',
          transclude: true,
          link: function postLink(scope, element, attrs, controller, transclude) {
            transclude(function (clone) {
              angular.element(element.children()[1]).text(i18n((clone.text() || '').trim()));
            });

            scope.onChangeValue = function() {
              if (scope.change) {
                scope.change({$value: scope.switchValue});
              }
            }
          }
        }
    }]);
angular
    .module('snk.components.dropdown')
    .service('dropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
        var self = this;
        var openScope = null;
        
        self.open = open;
        self.close = close;

         $rootScope.$on('MessageOpened',function() {
             doClose();
         });

        function open(dropdownScope) {
            if (!openScope) {
                $document.on('click touchstart', closeDropdown);
                $document.on('keydown', escapeKeyBind);
            }

            if (openScope && openScope !== dropdownScope) {
                openScope.isOpen = false;
            }

            openScope = dropdownScope;
        }

        function close(dropdownScope) {
            if (openScope === dropdownScope) {
                openScope = null;
                $document.off('click touchstart', closeDropdown);
                $document.off('keydown', escapeKeyBind);
            }
        }

        function closeDropdown(evt) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope) {
                return;
            }

            if (evt && openScope.getAutoClose() === 'disabled') {
                return;
            }

            var toggleElement = openScope.getToggleElement();

            if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                return;
            }

            var $element = openScope.getElement();
            var isSearchField = false;

            if (evt && evt.target) {
                try{
                    var parentElement = angular.element(evt.target).parent().parent();
                    isSearchField = parentElement[0] && parentElement[0].nodeName == 'SK-SEARCH-INPUT';
                } catch(ignored) {
                }
            }

            if (!isSearchField) {
                if (evt && openScope.getAutoClose() === 'outsideClick' && $element && $element[0].contains(evt.target)) {
                    return;
                } else if(evt && openScope.getAutoClose() === 'outsideClick' && evt) {
                    var elem = evt.target;
                    while(elem.parentElement) {
                        if(elem.originalParent == $element[0]) {
                            return;
                        }
                        elem = elem.parentElement;
                    }
                }
            }

            doClose();
        }

        function doClose() {
            if(openScope) {
                openScope.isOpen = false;

                if (!$rootScope.$$phase) {
                    openScope.$apply();
                }
            }
        }

        function escapeKeyBind(evt) {
            if (evt.which === 27) {
                openScope.focusToggleElement();
                closeDropdown();
            }
        }
    }]);
angular
    .module('snk.components.dropdown')
    .directive('dropdown', [function () {
        return {
            controller: 'DropdownController',
            link: function (scope, element, attrs, dropdownCtrl) {
                dropdownCtrl.init(element);
            }
        };
    }]);
angular
    .module('snk.components.dropdownmenu')
    .controller('SkDropdownMenuController', ['$scope', 'i18n', '$element', '$rootScope', 'UserAgentUtils', 'StringUtils', '$timeout',
        function ($scope, i18n, $element, $rootScope, UserAgentUtils, StringUtils, $timeout) {
            var self = this;

            self.toggleActionVisibility = toggleActionVisibility;
            self.toggleActionEnabled = toggleActionEnabled;

            self.setOptionsLoaded = setOptionsLoaded;

            self.dropdownName = $scope.dropdownName;

            $scope.tooltipBtn = $scope.tooltip ? i18n($scope.tooltip) : i18n('Geral.buttonOutrasOpcoes');
            $scope.onClick = onClick;

            var _lblGeral = i18n('Geral.lblGeral');

            var _optionsLoaded;

            var _lastSelectedAction = undefined;
            var _defaultAction = undefined;
            var _optionsById = {};
            var _popOver;
            var _chields = [];
            
            $scope.api = self;

            init();

            function init() {
            	if (!$scope.fontIcon && !$scope.svgIcon && !$scope.hidenIcon) {
            		$scope.fontIcon = 'more';
                }
            	
                $timeout(function(){
                    getOptions();

                    if($scope.hidenIcon == true){
                        let lblContainer = $element.find('.button-label');
    
                        lblContainer.css('padding-left', '7px');
                    }

 		            if($scope.onDropdownLoaded) {
                        $scope.onDropdownLoaded(self);
                    }
                }, 0, false);
            }

            self.popoverListener = {
                onCreate: function(popover) {
                    _popOver = popover;
                },
                onScroll: function(){
                    hideAllChild();
                }
            };

            self.listenerPopOverLinkedList = { 
                onCreate: onCreatePopOverLinkedList 
            };

            self.getPopoverProperties = function () {
                return {
                    textToColor: StringUtils.textToColor,
                    buildNick: StringUtils.buildNick,
                    groupedOptions: getOptions(),
                    itemClickAction: itemClickAction,
                    getPopoverOptionsProperties: getPopoverOptionsProperties,
                    listenerPopOverLinkedList: self.listenerPopOverLinkedList,
                    parameters: $scope.parameters,
                    squareMode: $scope.squareMode
                };
            };

            function toggleActionVisibility(actionId, visible){
                var action = _optionsById[actionId];

                if (action) {
                    action.visible = visible;
                }
            }

            function toggleActionEnabled(actionId, enabled){
                var action = _optionsById[actionId];

                if (action) {
                    action.enabled = enabled;
                }
            }

            function onClick($event) {
                let isBtnAction = $event.delegateTarget.getAttribute('id') == 'btn-action';
                
                if ($scope.openAlways || !isBtnAction) {
                    _popOver.show($event);
                } else {
                    if (angular.isFunction($scope.onClickBtn)) {
                        $scope.onClickBtn({ $event: $event });
                    } else if ($scope.uselastSelectedAction == true && _lastSelectedAction) {
                        itemClickAction(_lastSelectedAction, $event);
                    } else if (_defaultAction) {
                        itemClickAction(_defaultAction, $event);
                    }

                    if ($rootScope.otherOptionsLoader !== undefined || $scope.buildOnEveryClick == true) {
                        getOptions();
                    }
                }
            }

            function getOptions(){
                var options = _optionsLoaded || $scope.buildOptions({$instance: self});

                if($rootScope.otherOptionsLoader !== undefined){
                    options = $rootScope.otherOptionsLoader;
                }
                
                if (angular.isArray(options)) {
                    var optionsByGroup = {};
                    options.forEach(function (option) {
                        option.uid = StringUtils.nextUid();
                        var optionGroup = option.group || _lblGeral;

                        var optionsByGroupList = optionsByGroup[optionGroup];

                        if (optionsByGroupList) {
                            optionsByGroupList.push(option);
                        } else {
                            optionsByGroup[optionGroup] = [option];
                        }

                        if (option.id) {
                            _optionsById[option.id] = option;
                        }

                        if (!option.hasOwnProperty('visible')) {
                            option.visible = true;
                        }
                        
                        if (!option.hasOwnProperty('enabled')) {
                            option.enabled = true;
                        }

                        if(option.default){
                            _defaultAction = option;
                        }
                    });

                    if($scope.buildOnEveryClick != true) _optionsLoaded = options;

                    var groupedOptions = [];

                    angular.forEach(optionsByGroup, function(optionList, groupName) {
                        groupedOptions.push({
                            groupName: groupName,
                            options: optionList,
                            visible: optionList.filter(function(option){
                                return option.visible
                            }).length > 0
                        });
                    });

                    return groupedOptions;
                } else {
                    return undefined;
                }
            }

            function itemClickAction(item, $event){
                if(item.enabled === false) {
                    throw new Error("Esta opção não está disponível para uso.");
                } else {
                    for(let i = 0; i < _chields.length; i++) {
                        if(_chields[i].popUpIsOpen() == true) {
                            _chields[i].hide();
                        }
                    }                    
                    _lastSelectedAction = item;
                    if(item.type == 'check') item.checked = !item.checked;
                    item.action && item.action($event, $scope.parameters, item.checked);
                    if(_popOver && item && !item.child){ 
                        _popOver.hide();
                        hideAllChild();
                    }
                    
                }
            }

            function getPopoverOptionsProperties(option){                
                return {
                    options: option.child,
                    value:   option.value,
                    hidePrincipal: _popOver.hide,
                    listenerPopOverLinkedList: self.listenerPopOverLinkedList
                };
            }

            function hideAllChild(){
                _chields.forEach(function(popover){
                    popover.hide();
                });
            }

            function onCreatePopOverLinkedList(popover){
                _chields.push(popover);
            }

	   		function setOptionsLoaded(options) {
                _optionsLoaded = options;
                getOptions();
            }
        }
]);

/**
 * @ngdoc directive
 * @name snk.components.dropdownmenu.directive:sk-dropdown-menu
 * @restrict E
 * @description
 *   	Esse componente é responsável por criar um dropdown com opções. 
 *
 * @param {function} [sk-build-options=undefined] Nesse parametro deve ser informado uma função que retorne um array de objetos contendo label e action.
 * @param {boolean} [sk-open-always=false] Nesse parametro deve ser informado se deseja sempre abrir as opções ou executar a última utilizada direto.
 * @param {string} [sk-font-icon='more'] Nesse parametro deve ser informado o nome do icone.
 * @param {string} [sk-svg-icon=undefined] Nesse parametro deve ser informado o caminho de uma imagem tipo svg.
 * @param {string} [sk-label=undefined] Nesse parametro deve ser informado o texto do dropdown.
 * @param {string} [sk-tooltip=undefined] Nesse parametro deve ser informado o tooltip do dropdown.
 * @param {string} [sk-hiden-icon=false] Nesse parametro deve ser informado se deseja ocultar o icone padrão.
 * @param {Object} sk-parameters] Parâmetros a serem passados na chamada da função action.
 * @param {boolean} [sk-square-mode=false] Informa o tipo de exibição dos items do menu outras opções.

 * @example
     <example module="app">
         <file name="DropdownMenuExample.html">
            <div ng-controller="MyController as ctrl">
	            <sk-hbox>
		                <sk-dropdown-menu sk-open-always="true" 
		                				  sk-tooltip="Exemplo teste" 
		                				  sk-label="Opções" 
		                				  sk-build-options="ctrl.buildNfeButtonOptions()"
		                				  sk-padding="10px">
		                </sk-dropdown-menu>
		                <sk-dropdown-menu sk-tooltip="Exemplo teste"
		                				  sk-font-icon="show-thumbnails-with-lines" 
		                				  sk-build-options="ctrl.buildNfeButtonOptions()"
		                				  sk-padding="10px">
		                </sk-dropdown-menu>
		                <sk-dropdown-menu sk-open-always="true" 
		                				  sk-tooltip="Exemplo teste" 
		                				  sk-label="Opções" 
		                				  sk-build-options="ctrl.buildNfeButtonOptions()"
		                				  sk-hiden-icon="true"
		                				  sk-padding="10px">
                        </sk-dropdown-menu>
                        <sk-dropdown-menu sk-tooltip="Exemplo teste 4"
                                          sk-label="Exemplo Btn Click"		                				  
		                				  sk-build-options="ctrl.buildNfeButtonOptions()"
                                          sk-padding="10px"
                                          sk-on-click-btn="ctrl.btnClick($event)"
                                          sk-hiden-icon="true">
		                </sk-dropdown-menu>
	            </sk-hbox>
            </div>
         </file>
         <file name="app.js">
                angular
                    .module('app', ['snk'])
                    .controller('MyController', function($scope){
                        var self = this;
                                    
//		                self.buildNfeButtonOptions = buildNfeButtonOptions;
//		                self.exemploUm = exemploUm;
//		                self.exemploDois = exemploDois;
//                      self.btnClick = btnClick;
//		     
//			            function buildNfeButtonOptions() {
//			                return [
//			                    {
//			                        label: 'Teste1',
//			                        action: exemploUm,
//			                    },
//			                    {
//			                        label: 'Teste2',
//			                        action: exemploDois,
//			                    }
//			                ]
//			            };
//			            
//			            function exemploUm(){
//			            	alert('Minha ação 1');
//			            };
//			            function exemploDois(){
//			            	alert('Minha ação 2');
//			            };
//
//                      function btnClick($event){
//                         alert('btnClick action');
//                         console.log($event);
//                      }
                });
         </file>
     </example>
 */
angular
    .module('snk.components.dropdownmenu')
    .directive('skDropdownMenu', function () {
        return {
            templateUrl: 'components/dropdownmenu/dropdownmenu.tpl.html',
            restrict: 'E',
            controller: 'SkDropdownMenuController',
            controllerAs: 'ctrl',
            scope: {
            	api: '=?skApi',
                buildOptions: '&skBuildOptions',
                openAlways: '=skOpenAlways',
                fontIcon: '@?skFontIcon',
                svgIcon: '@?skSvgIcon',
                label: '@?skLabel',
                tooltip: '@?skTooltip',
                tooltipPlacement: '@?skTooltipPlacement',
                hidenIcon:'=?skHidenIcon',
                parameters: '=?skParameters',
                colorBtn: '@?skColorBtn', // default, primary, info, warning, danger
                onClickBtn: '&?skOnClickBtn',
                buildOnEveryClick: '=?skBuildOnEveryClick',
                disabled: '=?skBtnDisabled',
                popOverMaxHeight: "=?skPopoverMaxHeight",
		        onDropdownLoaded: '=?skDropdownLoaded',
                dropdownName: '@?skDropName',
				iconVersion: '@?iconVersion',
		        squareMode: "=?skSquareMode",
                uselastSelectedAction:'=?skUseLastSelectedAction'
            }
        };
    });

/**
 * Created by bruno.brandao on 29/02/2016.
 */
angular
    .module('snk.components.dynaform')
    .controller('SkCustomRelationBlockController', ['$scope', 'StringUtils', '$timeout', '$translate', 'BlockProperties', 'MGEAuthorizationService', 'GridConfigInstance', 'DoubleFacePanelConstants', 'ObjectUtils',
        function ($scope, StringUtils, $timeout, $translate, BlockProperties, MGEAuthorizationService, GridConfigInstance, DoubleFacePanelConstants, ObjectUtils) {
            var DEFAULT_BLOCK_PROPS = {
                showNavigation: true, 
                showAddButton: true,
                showCopyButton: true,
                showRemoveButton: true,
                showRefreshButton: true,
                showCancelButton: true,
                showSaveButton: true
            };

            var _dblFacePanel;
            var _gridConfig = GridConfigInstance(BlockProperties.gridConfigId);

            $scope.BlockProperties = BlockProperties;

            $scope.gridConfigId = BlockProperties.gridConfigId;


            $scope.datagrid;


            $scope.changeButtonActions = [
                _gridConfig.buildOpenMenuOption()
            ];

            $scope.onDatagridLoaded = function(datagrid) {
                $scope.datagrid = datagrid;
                if(BlockProperties.onDatagridLoaded){
                    BlockProperties.onDatagridLoaded($scope.datagrid);
                }
            };

            $scope.onDoubleFacePanelCreated = function(dblFacePanel) {
                _dblFacePanel = dblFacePanel;
            };

            $scope.onDatasetCreated = onDatasetCreated;

            $scope.onGridDoubleClick = function() {
                _dblFacePanel.setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
            };

            init();

            function init() {
                ObjectUtils.defaultValues(BlockProperties, DEFAULT_BLOCK_PROPS);
            }
 
            function onDatasetCreated(dataset) {
                if (BlockProperties.resourceId) {
                    MGEAuthorizationService.loadAuthorization(BlockProperties.resourceId)
                        .then(function (authData) {
                            $scope.blockDataset.readAuthorizarionData(authData);
                        });
                }

                if (BlockProperties.datasetFields) {
                    BlockProperties.datasetFields.forEach(function (dsFields) {
                        $scope.blockDataset.addFieldsRequestInfo(dsFields);
                    });
                }

                if (BlockProperties.dsObserver) {
                    $scope.blockDataset.addObserver(BlockProperties.dsObserver);
                }

                if (BlockProperties.dsBeforePostAction){
                    $scope.blockDataset.beforePostAction(BlockProperties.dsBeforePostAction);
                }

                if (BlockProperties.dsAfterCopyAction) {
                    $scope.blockDataset.afterCopyAction(BlockProperties.dsAfterCopyAction);
                }

                if (BlockProperties.dsBeforeDeleteAction) {
                    $scope.blockDataset.beforeDeleteAction(BlockProperties.dsBeforeDeleteAction);
                }

                if (BlockProperties.interceptDataset) {
                    BlockProperties.interceptDataset($scope.blockDataset);
                }

                $scope.blockDataset.initializeDataSet()
                    .then(function(){
                        $scope.blockDataset.refresh();
                    });
            }
        }
    ]);
angular
	.module('snk.components.dynaform')
	.controller('MaximizedTabController', ['data', '$scope','AngularUtil',
		function (data, $scope, AngularUtil) {
            var self = this;

			self.tabInfo = data.tabInfo;
			self.formColumnNumberConfig = data.formColumnNumberConfig;
			self.formConfigColumnKey = data.formConfigColumnKey;
			self.formInterceptor = data.formInterceptor;
			self.formCreationComplete = data.formCreationComplete;
			self.getResourceId = data.getResourceId;
			self.createDynaformTabIfNotExists = createDynaformTabIfNotExists;
			self.dynaScope = data.dynaScope;
			

			self.init = init;

			function init(){
				if(self.tabInfo.type != 'form'){
					self.createDynaformTabIfNotExists(self.tabInfo)
				}
			}

			function createDynaformTabIfNotExists(tabInfo) {
				if (tabInfo.entityName) {
					let childProps = {
						'sk-entity-name': tabInfo.entityName,
                            'sk-resource-id': self.getResourceId() + '.dynaform.' + self.tabInfo.entityName,
                            'sk-parent-dynaform': 'controller',
                            'layout': 'column',
                            'creation-complete': 'childDyanformCreationComplete()',
                            'flex': '',
                            'sk-show-filter': self.tabInfo.showFilter,
                            'sk-init-dynaform': 'initChildDynaform(dynaform)',
                            'sk-on-dynaform-loaded': 'onChildDynaformLoaded(dynaform,dataset)',
                            'sk-on-datagrid-loaded': 'onDynaformDatagridLoaded(datagrid,dataset)',
                            'sk-on-datagrid-init': 'onDynaformDatagridInit(datagrid, dataset)',
                            'sk-custom-tabs-loader': 'onChildCustomTabsLoader(entityName)',
                            'sk-dynaform-interceptor': 'dynaformInterceptor',
                            'sk-datagrid-interceptor': 'datagridInterceptor',
                            'sk-form-interceptor': 'formInterceptor',
                            'sk-grid-printer-interceptor' : 'gridPrinterInterceptor',
                            'sk-hide-entity-card': 'skHideEntityCard',
                            'sk-hide-button-entity-attach': 'hideButtonEntityAttach',
                            'sk-hide-buttons-config': 'hideButtonsConfig',
                            'sk-hide-tour': true,
                            'sk-ignored-config-entity': self.dynaScope.ignoredConfigEntity == true,
                            'sk-form-column-number-config': self.dynaScope.formColumnNumberConfig
					};

					if (tabInfo.relationInfo) {
						let objKey = 'relationInfo' + tabInfo.tabId;
						$scope[objKey] = tabInfo.relationInfo;
						childProps['sk-relation-info'] = objKey;
					}

					if ($scope.recursiveHelper) {
						childProps['sk-recursive-helper'] = 'recursiveHelper';
						childProps['sk-helper-class-name'] = $scope.helperClassName;
					}

					$scope.actualOptions = [];

					if (angular.isArray($scope.otherOptionsChildren)) {
						$scope.otherOptionsChildren.forEach(function (option) {
							if (angular.isArray(option.entitiesName)) {
								option.entitiesName.forEach(function (entityName) {
									if (entityName == tabInfo.entityName) {
										$scope.actualOptions.push(option);                                            
									}
								});
							}
						});
					}

					childProps['sk-other-options-children'] = 'allOptionsLoadded';
					childProps['sk-other-options-loader'] = 'actualOptions';

					let dynaformElem = AngularUtil.createDirective('sk-dynaform', childProps, self.dynaScope);

					let container = angular.element(document.getElementById('hboxDynaform'));

					container.append(dynaformElem);

				}
			}
		}
	]);

/**
 * Created by bruno.brandao on 29/02/2016.
 */
angular
    .module('snk.components.dynaform')
    .controller('DynaformRelationBlockController', ['BlockProperties', function(BlockProperties){
        var self = this;

        self.onDynaformLoaded = onDynaformLoaded;
        self.onDatagridLoaded = onDatagridLoaded;
        self.customTabsLoader = customTabsLoader;
        self.otherOptionsLoader = otherOptionsLoader;
        
        self.getResourceId = getResourceId;
        
        function getResourceId() {
        	return BlockProperties.dynaform.getResourceId() + '.dynaform.' + BlockProperties.entityName;
        }

        //Delegamos o loaded para o master
        function onDynaformLoaded(dynaform, dataset) {
            BlockProperties.dynaform.onChildDynaformLoaded(dynaform, dataset);
        }

        function onDatagridLoaded(datagrid, dataset) {
            BlockProperties.dynaform.onChildDatagridLoaded(datagrid, dataset);
        }

        //Delegamos o loader para o master
        function customTabsLoader(entityName) {
            return BlockProperties.dynaform.customTabsLoader(entityName);
        }

        //Delegamos o loader para o master
        function otherOptionsLoader(dynaform, $dropdownMenu) {
            return BlockProperties.dynaform.otherOptionsLoader(dynaform, $dropdownMenu);
        }
    }]);
angular
    .module('snk.components.dynaform')
    .constant("DynaformModes", {
        MASTER_DYNAFORM: 'master',
        DETAIL_DYNAFORM: 'detail'
    })
    .constant("DynaformConstants", {
        EVENT_PROCESS_METADATA: 'EventProcessMetadata',
        EVENT_METADATA_UPDATED: 'EventMetadataUpdated',
        EVENT_FIELD_FIND: 'EventFieldFind',
        EVENT_SHOW_GRID: 'EventShowGrid',
        EVENT_CREATE_GRID: 'EventCreateGrid',
        EVENT_VIEW_MODE_CHANGED: 'EventViewModeChanged'
    });

angular
    .module('snk.components.dynaform')
    .controller('SkDynaformController', ['$scope', '$element', '$attrs', '$window', '$translate', 'DynaformConstants', 'DynaformModes', 'MetadataProvider', 'StringUtils', 'ObjectUtils', 'NumberUtils', 'DateUtils', 'FixedBarConstants', 'FormHighlithKind', '$q', '$timeout', 'SkPesquisaService', 'SkI18nService', 'SkApplication', 'ServiceProxy', 'EntityCardConstants', 'KeyboardEvents', 'SanPopup', 'NumberConfig', 'MGEAuthorizationConstants', 'SkComponentRegistry', 'FormService', 'AngularUtil', 'DatasetUtils', 'PositionUtils', 'WhenReady', 'UserAgentUtils', 'skMedia', 'DomUtil', 'uiGridEditConstants', 'MessageUtils', 'MGEParameters', 'DynaformTourContent', 'ArrayUtils', 'Criteria', 'SkFilter', 'DataImporter', 'TabNavigatorConstants', 'MGEAuthorizationService', 'FormColumnConfig', 'FormConfigColumnsPopUp', 'SkTourService', '$injector', 'KeyboardManager', 'DatasetContants', 'SkApplicationInstance', 'XmlJson', 'i18n',
        function ($scope, $element, $attrs, $window, $translate, DynaformConstants, DynaformModes, MetadataProvider, StringUtils, ObjectUtils, NumberUtils, DateUtils, FixedBarConstants, FormHighlithKind, $q, $timeout, SkPesquisaService, SkI18nService, SkApplication, ServiceProxy, EntityCardConstants, KeyboardEvents, SanPopup, NumberConfig, MGEAuthorizationConstants, SkComponentRegistry, FormService, AngularUtil, DatasetUtils, PositionUtils, WhenReady, UserAgentUtils, skMedia, DomUtil, uiGridEditConstants, MessageUtils, MGEParameters, DynaformTourContent, ArrayUtils, Criteria, SkFilter, DataImporter, TabNavigatorConstants, MGEAuthorizationService, FormColumnConfig, FormConfigColumnsPopUp, SkTourService, $injector, KeyboardManager, DatasetContants, SkApplicationInstance, XmlJson, i18n) {
            var self = this;

            const CHAVE_TOUR_VERSION_FORM_CFG = "br.com.sankhya.formconfig.tourversion";
            
            const PARENT_FIELD_SUFIX = 'PAI';
            const ROOT_KEY_VALUE = -9999;
            const MOSTRAR_HIERARQUIA = "mostrarHierarquia";
            const PREFERENCE_CONFIG_ID = ".prefite"

            var RESOURCE_ID_PREFIX = 'br.com.sankhya.dynaform';
            var CHAVE_VIZUALIZACAO_TOUR = "mge.html5.show.dynaform.tour";
            var CHAVE_VIZUALIZACAO_TOUR_HIERARCHY = "mge.html5.show.dynaform.tour.hierarchy";
            var CHAVE_VIZUALIZACAO_TOUR_VERSION = "mge.html5.show.dynaform.tour.version";

            var ENTITYSTARTPAGE_FINDERINTERCEPTOR = 'br.com.sankhya.modelcore.helper.dynaform.DynaformEntityStartPageFinderInterceptor';
            var VARIABLE_DEFAULT_VALUES = ["${usuario}", "${usuario.empresa}", "${usuario.vendedor}", "${usuario.centroresultado}"];

            var MAIN_TAB_NAME = '__main';

            var DYNAFORM_TOUR_VERSION = 4;

            var _showTour = false;
            var _showTourHierarchy = false;
            var _currentViewedTourVersion = 0;
            var _ehModoFlow = StringUtils.isNotEmpty(SkApplication.instance().getUrlParam('flowID'));

            var _authData;

            var _isHierarchyDynaform = $attrs.hasOwnProperty('skHierarchy');

            var _dynaformScrollContainer = angular.element(document.body);

            var dynaformContainer = $element[0].querySelector('.container');
            var dynaformSideNav;
            var dynaformBody = dynaformContainer.querySelector('.dynaform-body');
            var dynaformContent = dynaformBody.querySelector('.content');
            var dynaformGridContent = dynaformBody.querySelector('.sk-grid-content');
            var dynaformTopbar = dynaformBody.querySelector('.top-bar');
            var dynaformTopLeftBar = dynaformTopbar.querySelector('.left-container');
            var dynaformTopRightBar = dynaformTopbar.querySelector('.right-container');
            var dynaformStackContainer = dynaformContent.querySelector('.stack-container');
            var dynaformViewstack = dynaformStackContainer.querySelector('sk-viewstack');
            var dynaformCustomFilterContainer = dynaformContainer.querySelector('.custom-filters');

            var _hierarchyBreadcrumbsElem;

            var _betaWarningElem = document.body.querySelector('.beta-app-warning');
            var _newLayoutWarningElem = document.body.querySelector('#firstAccessHtml5');

            var whenReadyDatagridElement = WhenReady();
            var _whenDatasetReady = WhenReady();

            var datagridElement;

            var _hasSomeDynamicFilterData;

            var effectiveActionButtonResourceID = undefined;

            angular.element($window).bind('resize', recalculateSizes);
            angular.element($window.document).bind('scroll', function () {
                adjustFilterSidenavPosition();
            });

            SkApplication.instance().addEventListener(KeyboardEvents.FIND, findFieldKeyHandler);
            SkApplication.instance().addEventListener(KeyboardEvents.FIND_ENTITY, findEntityKeyHandler);
            SkApplication.instance().addEventListener(KeyboardEvents.CHANGE_FACE_KEY, changeFaceKeyHandler);
            SkApplication.instance().addEventListener(KeyboardEvents.PREVIOUS_TAB, previousTabHandler);
            SkApplication.instance().addEventListener(KeyboardEvents.NEXT_TAB, nextTabHandler);

            ObjectUtils.implements(self, IDataSetObserver);

            var _metadataReady = false;
            var _initialized = false;
            var _firstRefresh = false;

            var _customColumnsMDByEntity = {};
            var _metadataFieldsRequestInfo = [];

            var _lastShowEntityCard;

            var _favoriteCache = {};

            var _highlightInfo;

            var _defaultValueByField = {};
            var _fieldsToCleanOnCopy = {};
            var _dynaformConfig;

            var _gridCreated = false;
            var _metadata;
            var _processedMetadata;

            var _createdTabs = {};
            var _criteriaDefaultFilter;

            var tabScrollPosition = {};

            var _tabOrder;
            var _customTabOrderConfig;

            var selectTab = doSelectTab;//AngularUtil.debounce(doSelectTab, 300);
            var updateTabRequiredStatusDebounced = AngularUtil.debounce(updateTabRequiredStatus, 200);

            var _childDynaformArray = [];

            var _defaultFilter;

            var _mostraAvisoPaginaInicial = MGEParameters.asBoolean("br.com.sankhya.mge.mostra.aviso.pagina.inicial");

            var _customBlocks = {};

            var _dynaformDefValues;

            var _tabByField = {};
            var _invisibleFieldsByName = {};

            var _mutableFieldProperties = ['enabled', 'required', 'description', 'visible', 'somenteAnalitico', 'nullable'];

            var _fieldPropertyEvaluators = [];

            var _metadataUpdateListeners = [];
            var _treeCreatedListeners = [];

            var _fieldLoadedListeners = {};
            var _gridFieldLoadedListeners = {};

            var _dynaformHelperData;
            var _dynaformInvisibleReferences;
            var _dynaformVisibleReferences;

            var _loadingByPK = false;

            var _datagridLoaded = false;

            var _hiddenFieldsByProgrammer = {};
            var _hiddenFieldsFromConfig = {};
            var _forceShowOnConfig = {};

            var _flatTreeInstance;
            var _treeInstance;

            var _customFilterPanel;

            var _openedPopovers = [];

            var GridConfig;
            
            var _sortFields = false;

            var _exceptFieldsByEntity = {};
            var _entityForceUserFields = {};

            var _filterPanelInstace;

            var _currentTourFormConfigVersion;

            var _navigatorAPI;

	    	const _unAcceptFields = {};

            $injector.invoke(["GridConfig", function(service){
                GridConfig = service;
            }]);

            $scope.toolTipConfigTela = SkI18nService.instant('DynaformConfig.titleConfigTela');

            $scope.refreshDatasetToTree = angular.isDefined($scope.refreshDatasetToTree) ? $scope.refreshDatasetToTree : true;

            $scope.enableSearchInputHierarchy = angular.isDefined($scope.enableSearchInputHierarchy) ? $scope.enableSearchInputHierarchy : true;
            $scope.treeAdvSearch = angular.isDefined($scope.treeAdvSearch) ? $scope.treeAdvSearch : true;
            $scope.skipStartPage = _ehModoFlow || StringUtils.toBoolean($scope.skipStartPage);
            $scope.applyPersonalizedFilterOnLoad = _ehModoFlow || StringUtils.toBoolean($scope.applyPersonalizedFilterOnLoad);
            $scope.creationPolicy=angular.equals($scope.creationPolicy,"all")?"all":"auto";
            $scope.tabsLimit = 10;
            $scope.controller = self;
            $scope.uid = StringUtils.nextUid();
            $scope.viewMode = 'form';
            $scope.iconChangeFace = 'table';
            $scope.createGrid = createGrid;
            $scope.addButtonEnabled = true;
            $scope.entityDescription;
            $scope.customEntityDescription;
            $scope.tabsCollapsePanel = false;
            $scope.gridController = undefined;
            $scope.entityStartPageId = 'entity-start-page';
            $scope.personalizedFilterId = 'personalized-filter-' + $scope.uid;
            $scope.otherOptions = true;
            $scope.allowConfiguration = SkApplication.instance().hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG);
            $scope.allowGridConfiguration = SkApplication.instance().authIsLoadded() ? SkApplication.instance().hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG_GRID) : true;
            $scope.showPersonalizedFilterButton = showPersonalizedFilterButton;
            $scope.onDynaformDatagridLoaded = onDynaformDatagridLoaded;
            $scope.onDynaformDatagridInit = onDynaformDatagridInit;
            $scope.getParentDataset = getParentDataset;
            $scope.getMasterDynaformResourceId = getMasterDynaformResourceId;
            $scope.isTabNavBorderBottom = isTabNavBorderBottom;
            $scope.onDynamicFilterCreated = onDynamicFilterCreated;
            $scope.hasDynamicFilter = false;
            $scope.hasSomeActiveFilter = { value: false };
            $scope.userConfigFormColumns = MGEParameters.asInteger("mge.core.config.form.html5") == FormColumnConfig.POR_USUARIO;
            $scope.loadOnInitialize = MGEParameters.asBoolean("global.carregar.registros.iniciar.tela");
            $scope.formConfigColumnKey = FormColumnConfig.FORM_COL_CONFIG_PREFIX + getMasterDynaformResourceId();
            $scope.treeHierarchyKey = FormColumnConfig.HIERARCHY_CONFIG_PREFIX + getMasterDynaformResourceId();
            $scope.width = 0;
            $scope.actionBtnDisabled = {
                status: false
            };

            $scope.states = {
                isSideNavOpen: false
            };

            $scope.filtersActive = {
                custom: false,
                personalized: false,
                dynamic: false
            };

            $scope.dropdownConfig = {
                isOpen: false
            };

            $scope.favoriteEntities;
            $scope.recentsEntities;
            $scope.isHierarchyActivated = true;
            $scope.treeSearchText;

            $scope.onSelectEntityOnStartPage = onSelectEntityOnStartPage;
            $scope.onSelectNewEntityOnStartPage = onSelectNewEntityOnStartPage;
            $scope.onSelectShowGridOnStartPage = onSelectShowGridOnStartPage;
            $scope.onShowAllActionOnStartPage = onShowAllActionOnStartPage;
            $scope.onSelectHierarchyOnStartPage = onSelectHierarchyOnStartPage;
            $scope.onApplyFilterOnStartPage = onApplyFilterOnStartPage;
            $scope.onFlatTreeCreated = onFlatTreeCreated;
            $scope.onTreeCreated = onTreeCreated;
            $scope.newRecord = newRecord;
            $scope.showEntityStartPage = showEntityStartPage;
            $scope.getEntitdadesRecentesProperties = getEntitdadesRecentesProperties;
            $scope.getEntitdadesFavoritasProperties = getEntitdadesFavoritasProperties;
            $scope.showEntityCard = showEntityCard;
            $scope.changeViewMode = changeViewMode;
            $scope.showTabRequiredIcon = showTabRequiredIcon;
            $scope.showTabCustomIcon = showTabCustomIcon;
            $scope.openGridConfig = openGridConfig;
            $scope.launchConfiguration = launchConfiguration;
            $scope.goToStartPage = goToStartPage;
            $scope.isHtml5ParamToOffer = isHtml5ParamToOffer;
            $scope.startTour = startTour;
            $scope.buildOtherOptions = buildOtherOptions;
            $scope.onChildDynaformLoaded = onChildDynaformLoaded;
            $scope.initChildDynaform = initChildDynaform;
            $scope.onChildCustomTabsLoader = onChildCustomTabsLoader;
            $scope.getFlatTreeConfigName = getFlatTreeConfigName;
            $scope.$customCriteriaLoader = $customCriteriaLoader;
            $scope.beforeOpenFixedBar = beforeOpenFixedBar;
            $scope.closeAllPopovers = closeAllPopovers;
            $scope.controlActiveHierarchy = controlActiveHierarchy;
            $scope.isHierarchyDynaformActivated = isHierarchyDynaformActivated;
            $scope.showMasterHierarchyDynaform = showMasterHierarchyDynaform;
            $scope.isTreeSearchActived = isTreeSearchActived;
            $scope.maximizeTab = maximizeTab;

            $scope.isActiveOnToolBarManager = isActiveOnToolBarManager;

            $scope.isHierarchyDynaform = isHierarchyDynaform;

            $scope.isBtnConfigEnabled = isBtnConfigEnabled;
            $scope.showBtnAddRecord = showBtnAddRecord;

            $scope.getSidenavId = getSidenavId;

            $scope.isMobile = UserAgentUtils.isMobile();

            $scope.selectTab = selectTab;
            $scope.onSelectTab = function (selected) {
                if (selected > -1) {
                    doSelectTab($scope.tabsInfo[selected], undefined, true);
                }
            };

            //$scope.toggleTabCollapse = toggleTabCollapse;

            $scope.openNumberConfig = openNumberConfig;

            $scope.datasetIsDirty = false;

            $scope.forceFixedBarContext = forceFixedBarContext;
            $scope.contextIsActive = contextIsActive;

            $scope.useClassicLayoutVersion = useClassicLayoutVersion;

            $scope.dynamicFilterClickHandler = dynamicFilterClickHandler;

            $scope.onHierarchyPathItemClick = onHierarchyPathItemClick;

            $scope.onClickUserConfiguration = onClickUserConfiguration;
            $scope.onChangeUserConfiguration = onChangeUserConfiguration;
            $scope.isShowNumberConfig = isShowNumberConfig;
            $scope.isShowFormLayoutConfig = isShowFormLayoutConfig;

            $scope.isView;

            $scope.loadActionButtonsByService = loadActionButtonByService;
            $scope.getActionButtonResourceId = getActionButtonResourceId;
            $scope.getActionButtonAccessResourceId = getActionButtonAccessResourceId;

            /** Navigator props */
            $scope.navigatorOptions = {
                disableNavigator: false,
                showNavigation: true,
                showAddButton: true,
                showCopyButton: !isHierarchyDynaform(),
                showRemoveButton: true,
                showRefreshButton: true,
                showCancelButton: true,
                showSaveButton: true,
                showEditButton: true,
                disableSearch: false
            };
            self.navigatorApi = undefined;
            self.loadMetadata = loadMetadata;

            self.isMasterDynaform = $scope.isMasterDynaform = isMasterDynaform;
            self.isDetailDynaform = $scope.isDetailDynaform = isDetailDynaform;
            self.isHierarchyDynaform = isHierarchyDynaform;
            self.parentDynaformIsMaster = $scope.parentDynaformIsMaster = parentDynaformIsMaster;
            self.parentDynaformIsHierarchy = $scope.parentDynaformIsHierarchy = parentDynaformIsHierarchy;
            self.showClassicLayoutVersionLink = $scope.showClassicLayoutVersionLink = showClassicLayoutVersionLink;

            self.setTabsInfo = setTabsInfo;
            self.setDynaformConfig = setDynaformConfig;
            self.addFieldDefaultValue = addFieldDefaultValue;

            self.getDataset = getDataset;
            self.hasDynamicFilter = hasDynamicFilter;
            self.whichViewMode = whichViewMode;
            self.hasStartPage = hasStartPage;
            self.hasEntityCard = hasEntityCard;
            self.hasGridButton = hasGridButton;
            self.hasConfigButton = hasConfigButton;
            self.hasActionButtons = hasActionButtons;
            self.hasRecentsButton = hasRecentsButton;
            self.hasFavoriteButton = hasFavoriteButton;
            self.hasEntityAttachButton = hasEntityAttachButton;
            self.hasEntitySearchFieldButton = hasEntitySearchFieldButton;
            self.hasForceEnablePersonalizedFilter = hasForceEnablePersonalizedFilter;
            self.getTree = getTree;
            self.getEntityName = getEntityName;
            self.getParentEntityName = getParentEntityName;
            self.getDynaformId = $scope.getDynaformId = getDynaformId;
            self.getDynaformElement = getDynaformElement;
            self.getMasterDynaformId = $scope.getMasterDynaformId = getMasterDynaformId;
            self.getMasterDynaform = $scope.getMasterDynaform = getMasterDynaform;
            self.getMasterDynaformElement = getMasterDynaformElement;
            self.getMasterDynaformResourceId = getMasterDynaformResourceId;
            self.getLayoutInfo = getLayoutInfo;
            self.getEntityCardProps = getEntityCardProps;
            self.getResourceId = getResourceId;
            self.getDynaformConfig = getDynaformConfig;
            self.getAutoNumFieldName = getAutoNumFieldName;
            self.getSelectedTab = getSelectedTab;
            self.getFilterPanelInstance = getFilterPanelInstance;
            $scope.getEntityDescription = self.getEntityDescription = getEntityDescription;
            $scope.onToggleSidenav = onToggleSidenav;
            self.onSelectShowGridOnStartPage = onSelectShowGridOnStartPage;
            self.onShowAllActionOnStartPage = onShowAllActionOnStartPage;
            self.goToStartPage = goToStartPage;
            self.showDyanformView = showDyanformView;
            self.getGridController = getGridController;
            self.openGridConfig = openGridConfig;
            self.forceCloseGridConfig = forceCloseGridConfig;
            self.launchConfiguration = launchConfiguration;
            self.getDynaformHelperData = getDynaformHelperData;
            self.setDynaformHelperData = setDynaformHelperData;
            self.onChildDynaformLoaded = onChildDynaformLoaded;
            self.initChildDynaform = initChildDynaform;
            self.onChildDatagridLoaded = onChildDatagridLoaded;
            self.getDatagridInterceptor = getDatagridInterceptor;
            self.getDynaformInterceptor = getDynaformInterceptor;
            self.getFormInterceptor = getFormInterceptor;
            self.customTabsLoader = customTabsLoader;
            self.otherOptionsLoader = otherOptionsLoader;
            self.getHelperClassName = getHelperClassName;
            self.isRecursiveHelper =  isRecursiveHelper;
            self.hasAccess = hasAccess;
            self.addFieldsRequestInfo = addFieldsRequestInfo;
            self.addCustomColumnMD = addCustomColumnMD;
            self.closeAllPopovers = closeAllPopovers;

            self.addChildDynaform = addChildDynaform;

            self.resolveFocus = resolveFocus;

            self.highlightFields = highlightFields;
            self.unHighlightFields = unHighlightFields;

            self.goToFormView = goToFormView;
            self.goToGridView = goToGridView;

            self.openConfiguration = openConfiguration;
            self.rebuildLayout = rebuildLayout;

            self.whenLoaded = whenLoaded;

            self.loadByPK = loadByPK;

            self.changeBlockVisibility = changeBlockVisibility;
            self.changeBlockEnabled = changeBlockEnabled;
            self.selectBlockTab = selectBlockTab;
            self.selectTabByLabel = selectTabByLabel;
            self.selectTabById = doSelectTab;

            self.changeOtherOptionEnabled = changeOtherOptionEnabled;

            self.hasDefaultValue = hasDefaultValue;

            self.setFieldProperty = setFieldProperty;
            self.addFieldPropertyEvaluator = addFieldPropertyEvaluator;
            self.addMetadataUpdateListener = addMetadataUpdateListener;
            self.addTreeCreatedListener = addTreeCreatedListener;

            self.showFieldTooltip = showFieldTooltip;
            self.addCustomFormItemVisible = addCustomFormItemVisible;
            
            self.hideBtnIsFavorite = hideBtnIsFavorite;
            
            //DatasetObserverImpl
            self.refreshed = onDatasetRefresh;
            self.currentLineChanged = onDatasetCurrentLineChanged;
            self.dataModified = dataModified;
            self.editionModeActivated = onDatasetEditionModeActivated;
            self.dataSaved = onDatasetDataSaved;
            self.recordRemoved = onDatasetRecordRemoved;
            self.insertionModeActivated = onDatasetInsertionModeActivated;
            self.editionCanceled = onDatasetEditionCanceled;
            self.saveAvoided = saveAvoided;
            self.loadFiltersOnCreate = loadFiltersOnCreate;
            self.allEvents = allEvents;

            self.isFieldVisible = isFieldVisible;
            self.isFieldEnabled = isFieldEnabled;
            self.getFieldTabName = getFieldTabName;

            self.getHiddenFieldsFromConfig = getHiddenFieldsFromConfig;
            self.getHiddenFieldsByProgrammer = getHiddenFieldsByProgrammer;

            self.setBtnNewCompact = setBtnNewCompact;
            self.getBtnNewCompact = getBtnNewCompact;

            self.setCustomFilterPanel = setCustomFilterPanel;

            self.setAllTabsEnabled = setAllTabsEnabled;

            self.setTabEnabled = setTabEnabled;
            
            self.selectTabPerId = selectTabPerId;

            self.getTabsInfo = getTabsInfo;

            self.setVisibleReferences = setVisibleReferences;
            
            self.getFormColConfig = getFormColConfig;
            self.getHierarchyConfig = $scope.getHierarchyConfig =  getHierarchyConfig;

            self.adjustFilterSidenavPosition = adjustFilterSidenavPosition;

            self.setTabOrderConfig = setTabOrderConfig;
            self.setTabOrder = setTabOrder;

            self.enableSortFields = enableSortFields;

            self.addShortcut = addShortcut;
            self.isVariation = isVariation;
            self.otherOptionsInterceptor = otherOptionsInterceptor;

            $scope.pesqEntitySelect = pesqEntitySelect;
            $scope.pesqFieldSelect = pesqFieldSelect;
            $scope.showMoreEntityPesqResults = showMoreEntityPesqResults;
            $scope.loadEntitySuggestions = loadEntitySuggestions;
            $scope.loadFieldSuggestions = loadFieldSuggestions;

            $scope.closeSidenav = closeSidenav;
            $scope.isSidenavLocked = isSidenavLocked;

            $scope.formConfigColumns = formConfigColumns;

            $scope.btnTourExplicito=angular.isDefined($scope.btnTourExplicito)?$scope.btnTourExplicito:false;
            
            self.getNavigatorAPI = getNavigatorAPI;
            self.setOtherConfig = setOtherConfig;
            self.getOtherConfig = getOtherConfig;
            self.isAutoNum = isAutoNum;
            self.setAutoNum = setAutoNum;
            self.configCopied = configCopied; 

			self.setFieldRequireInTab = setFieldRequireInTab;
            self.getExceptFieldsByEntity = getExceptFieldsByEntity;
            self.getEntityForceUserFields = getEntityForceUserFields;
            self.setNavigatorSaveHandler = setNavigatorSaveHandler;
            self.filterFieldsPersonalizedFilter = filterFieldsPersonalizedFilter;
	   		self.showTourDynamicFilter = showTourDynamicFilter;
            self.setNavigatorAddHandler = setNavigatorAddHandler;
            self.actionBtnToggle = actionBtnToggle;

            self.getFieldProperty = getFieldProperty;

            $scope.criteriaProvaiderStartPage = {};
            ObjectUtils.implements($scope.criteriaProvaiderStartPage, CriteriaProvider);
            $scope.criteriaProvaiderStartPage.getCriteria = getCriteriaStartPage;

            self.getActionButtonResourceID = function() {
                if ($scope.actionButtonResourceID != undefined) {
                    return $scope.actionButtonResourceID;
                }
                if ($scope.parentDynaform && $scope.parentDynaform.getActionButtonResourceID) {
                    return $scope.parentDynaform.getActionButtonResourceID();
                }
                return undefined;
            }

            //ctrl + f
            $(document).keydown(function (e) {
                if (e.ctrlKey && e.keyCode === 70) {
                    AngularUtil.apply($scope, function () {
                    $scope.dropdownConfig.isOpen = true;
                    });
                }
            });

            init();

            function init() {
                loadPreferences();

                _navigatorAPI = ObjectUtils.buildPublicAPIFromObject($scope.navigatorOptions);

                if ($attrs.skParentDynaform || $attrs.skParentEntityName) {
                    $scope.mode = DynaformModes.DETAIL_DYNAFORM;
                } else if (angular.isDefined($scope.defaultMode)) {
                    if ($scope.defaultMode != DynaformModes.DETAIL_DYNAFORM && $scope.defaultMode != DynaformModes.MASTER_DYNAFORM) {
                        throw new Error("Atributo sk-default-mode inválido para a diretiva sk-dynaform.");
                    }
                    $scope.mode = $scope.defaultMode;
                } else {
                    $scope.mode = DynaformModes.MASTER_DYNAFORM;
                }

                if ($attrs.hasOwnProperty('compact')) {
                    $element.addClass('compact');
                    angular.element(dynaformViewstack).addClass('compact');
                }

                $scope.tabSelectedIndex = isMasterDynaform() ? -1 : 0;
                $scope.showNavigatorAddButton = isDetailDynaform();

                if ($scope.skipStartPage) {
                    showDyanformView().then(function () {
                        if ($scope.applyPersonalizedFilterOnLoad) {
                            
                            let promissesBeforeRefresh = [$scope.dataset.whenMetadataLoaded()];

                            if(_filterPanelInstace) promissesBeforeRefresh.push(_filterPanelInstace.whenPersonalizedFilterLoad());
                            
                            $q.all(promissesBeforeRefresh).then(function () {
                                let personalizedFilter;

                                if(_filterPanelInstace){
                                    personalizedFilter = _filterPanelInstace.getPersonalizedFilter().getInstance();
                                }
                                
                                let personalizedFilterLoadPromisse = personalizedFilter ? personalizedFilter.onCriteriaReady() : angular.noop;
                                
                                $q.when(personalizedFilterLoadPromisse).then(() => {
                                    if($scope.loadOnInitialize || isDetailDynaform()) {
                                        $scope.dataset.refresh();
                                    }
                                });
                                
                            });
                        }
                    });
                } else if ($scope.mode == DynaformModes.MASTER_DYNAFORM) {
                    $scope.view = 'start';
                } else {
                    showDyanformView().then(function () {
                        goToGridView().then(function () {
                            $scope.dataset.whenMetadataLoaded().then(function () {
                                if($scope.loadOnInitialize || isDetailDynaform()) {
                                    $scope.dataset.refresh();
                                }
                            });
                        });
                    });
                }

                if ($scope.dynaformInterceptor) {
                    ObjectUtils.isImplementorOf($scope.dynaformInterceptor, IDynaformInterceptor);
                }

                if (isHierarchyDynaformActivated()) {
                    if ($scope.dynaformInterceptor) {
                        var userInterceptor = $scope.dynaformInterceptor.interceptFieldMetadata;

                        $scope.dynaformInterceptor.interceptFieldMetadata = function (fieldProperty, dataset) {
                            userInterceptor(fieldProperty, dataset);
                            hierarchyDynaformInterceptField(fieldProperty, dataset);
                        };
                    } else {
                        $scope.dynaformInterceptor = new IDynaformInterceptor();
                        $scope.dynaformInterceptor.interceptFieldMetadata = hierarchyDynaformInterceptField;
                    }
                }

                $scope.$on(DynaformConstants.EVENT_METADATA_UPDATED, onMetadataUpdated);
                $scope.$root.$on(EntityCardConstants.ENTITYCARD_FAVORITE_UPDATED, onFavoriteCardUpdated);

                $scope.$root.$on('$dynaform.changeDefaultFilterExpression', function (e, newExpression) {
                    _defaultFilter = angular.isDefined(newExpression) ? new Criteria( newExpression ) : newExpression;

                    if (isMasterDynaform()) {
                        SkComponentRegistry.get($scope.entityStartPageId).then(function (instance) {
                            instance.setDefaultFilter(_defaultFilter);
                        });
                    }
                });

                $scope.$root.$on('$dynaform.addOpenedPopover', function (event, opt) {
                    _openedPopovers.push(opt.popover);
                });

                $scope.$watch('dropdownConfig.isOpen', function (value) {
                    AngularUtil.timeout(function () {
                        onConfigPopupToggle(value);
                    });
                });

                SkComponentRegistry.get(getSidenavId()).then(function (instance) {
                    instance.redraw = notifyFixedBarToReset;
                });

                SkComponentRegistry.get($scope.personalizedFilterId).then(function (instance) {
                    instance.loadFilters();
                });

                if ($scope.mode == DynaformModes.MASTER_DYNAFORM && $attrs.hasOwnProperty('skPkListener')) {
                    SkApplication.instance().addPKChangeListener(loadByPK);
                }

                $element.addClass('dynaform-tour-' + $scope.uid);
                if ($scope.showTour) {
                    initTour();
                }

                SkFilter.getFilterPanelFields($scope.entityName).then(function (fields) {
                    if (fields && fields.length > 0 && $scope.showFilter !== 'false') {
                        $scope.hasDynamicFilter = true;
                        $scope.hasDynamicFilterByDataDictionary = true;
                    }
                });


                  if (isHierarchyDynaformActivated()) {
                    AngularUtil.timeout(function () {
                      var fixedBar = angular.element($element[0].querySelector('sk-fixed-bar'));
                      fixedBar.css('top', '32px');
                    });
                  }


                $scope.$on("warnNewLayoutClosed", adjustFilterSidenavPosition);
            }

            function beforeOpenFixedBar($fixedBar) {
            	if (isHierarchyDynaformActivated()) {
            		$fixedBar.getElement().css('top', getHierarchyBreadcrumbContainer().offsetHeight);
            	}
        	}

            function hierarchyDynaformInterceptField(fieldProperty, dataset) {
                if (fieldProperty.type == 'MASKEDINPUT') {
                    fieldProperty.fieldProp['sk-fill-left-from-right'] = 'true';
                    var dataType = fieldProperty.fieldProp['sk-data-type'];

                    if (dataType == 'I') {
                        fieldProperty.fieldProp['sk-align'] = 'right';
                    }
                }
            }

            function actionBtnToggle(status){
                if(status == true){
                    $scope.actionBtnDisabled.status = true;
                } else {
                    $scope.actionBtnDisabled.status = false;
                }
            }

            function buildOtherOptions($dropdownMenu) {
                if (!angular.isFunction($scope.otherOptionsLoader) && !$scope.otherOptionsChildren && $scope.otherOptionsChildren.length <= 0) {                    
                    return $scope.otherOptions;
                }

                if (angular.isArray($scope.otherOptions)) {
                    return $scope.otherOptions;
                }
                
                if (!angular.isFunction($scope.otherOptionsLoader)) {
                    return $scope.otherOptions;
                }

                $scope.allOptionsLoadded;

                if(angular.isArray($scope.otherOptionsChildren)){
                    $scope.allOptionsLoadded = $scope.otherOptionsChildren;
                }else{
                    $scope.allOptionsLoadded = otherOptionsLoader(self, $dropdownMenu);                                        
                }                
                var containsEntitiesName = false;
                if (angular.isArray($scope.allOptionsLoadded)) {
                    $scope.allOptionsLoadded.forEach(function (option) {                        
                        if (!option.entitiesName) {
                            if (!angular.isArray($scope.otherOptions)) {
                                $scope.otherOptions = [];
                            }
                            $scope.otherOptions.push(option);
                            if(!containsEntitiesName){
                                $scope.allOptionsLoadded = undefined;
                            }
                        } else {
                            containsEntitiesName = true;
                            option.entitiesName.forEach(function(entityName){
                                if(entityName == $scope.entityName){
                                    if (!angular.isArray($scope.otherOptions)) {
                                        $scope.otherOptions = [];
                                    }
                                    $scope.otherOptions.push(option);
                                }
                            });
                        }
                    })
                }

                _whenDatasetReady.whenReady()
                    .then(function () {
                        if (angular.isArray($scope.otherOptions)) {
                            $scope.otherOptions.forEach(function (option) {
                                if (option.type == 'DataImporter') {
                                    processDataImporterOption(option);
                                }else if (option.type == 'check'){
                                    setupCheckBoxOption(option);
                                }
                            });
                        }
                    });
                if(!angular.isArray($scope.otherOptions) || $scope.otherOptions.length < 1){
                    $scope.otherOptions = false;
                }
                return $scope.otherOptions;
            }

            function processDataImporterOption(option) {
                option.action = function () {
                    if (angular.isUndefined(option.properties)) {
                        throw Error("Propriedades do DataImporter não foram informados.");
                    }

                    if(! (hasAccess(MGEAuthorizationData.ACCESS_CONTROL_UPDATE) || (hasAccess(MGEAuthorizationData.ACCESS_CONTROL_INSERT) && $scope.dataset.isInsertionMode()))){
                        MessageUtils.showAlert(SkI18nService.instant('SanDB.DataSet.msgtitleControleAcesso'), SkI18nService.instant('SanDB.DataSet.messageNaoPermitidoAlterar'));
                    }else{
                        DataImporter.open($scope.dataset, option.properties);
                    }
                };

                option.enabled = false;

                $scope.dataset.addAllObserverEventsListener(function () {
                    option.enabled = angular.isDefined($scope.dataset.getCurrentRow());
                });
            }

            function setupCheckBoxOption(option){
                const fnChange = option.action;
                option.action = function($event, parameters, checked){
                    fnChange($event, parameters, checked);
                }
            }
            
            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setBtnNewCompact
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @param {boolean} [value=false] True, caso deseje que o botão novo fique em modo compacto.
             * @description
             *  Define se o botão novo estará no formato compacto.
             */
            function setBtnNewCompact(value) {
                $scope.btnNewCompact = value;
            }

          /**
           * @ngdoc
           * @name snk.components.dynaform.directive:sk-dynaform#changeOtherOptionEnabled
           * @methodOf snk.components.dynaform.directive:sk-dynaform
           * @description Usado para desabilitar opções do Menu do dynaform.
           * @param {String} id O indetificação da aba 
           * @param {boolean} value A condição true ou false
           */
            function changeOtherOptionEnabled(id, value) {
                var option = ArrayUtils.find($scope.otherOptions, function (item) {
                    return item.id == id;
                });

                if (option) {
                    option.enabled = value;
                }
            }

            function onFavoriteCardUpdated(e, args) {
                if (args.entityName != getEntityName()) {
                    return;
                }

                var pk = $scope.dataset.getPrimaryKeyObject(false, false);

                if (angular.equals(pk, args.pk) && $scope.entityCardProps) {
                    $scope.entityCardProps.isFavorite = args.isFavorite;
                }

                var pkHash = DatasetUtils.buildPkHash(args.pk);

                _favoriteCache[pkHash] = args.isFavorite;

                $scope.favoriteEntities = undefined;
                $scope.recentsEntities = undefined;
            }

            function onConfigPopupToggle(value) {
                if (value && !UserAgentUtils.isMobile()) {
                    var controller = AngularUtil.getControllerFromElement(document.querySelector('.fieldSearchField-' + $scope.uid));
                    if (angular.isDefined(controller)) {
                        controller.setFocus();
                    }
                }
            }

            function startTour() {
                $scope.dropdownConfig.isOpen = false;

                goToStartPage().then(function () {
                    if (!$scope.showTour) {
                        $scope.showTour = true;
                        initTour();
                    }

                    if(!$scope.hideTour){
                    	$scope.tour.startTour = true;
                    }
                    
                });
            }

            function initTour() {
                if(!$scope.hideTour){
                    $scope.tour = DynaformTourContent.getDynaformTourContent($element, $scope, self, _currentViewedTourVersion, DYNAFORM_TOUR_VERSION, !_showTour, !_showTourHierarchy, function () {
	                    _showTour = false;
	                    _showTourHierarchy = false;
	
	                    _currentViewedTourVersion = DYNAFORM_TOUR_VERSION;
	
	                    initTour();//Fazemos isso para recriar o tour após mudarmos as variáveis acima.
                    },
                    '.dynaform-tour-' + $scope.uid);
                }
            }

            function getGridController() {
                return $scope.gridController;
            }

            function isSidenavLocked() {
                return skMedia('min-width: 900px');
            }

            function closeSidenav() {
                var deferred = $q.defer();

                if (!isSidenavLocked()) {
                    SkComponentRegistry.get(getSidenavId()).then(function (instance) {
                        instance.close().then(deferred.resolve);
                    });
                } else {
                    deferred.reject();
                }

                return deferred.promise;
            }

            function openSidenav() {
                var deferred = $q.defer();

                SkComponentRegistry.get(getSidenavId()).then(function (instance) {
                    instance.open().then(deferred.resolve);
                });

                return deferred.promise;
            }

            function onToggleSidenav() {
                recalculateSizes();

                $scope.$broadcast('datagridRecalculate');
            }

            function getDynaformSideNav() {
                if (!dynaformSideNav) {
                    dynaformSideNav = dynaformContainer.querySelector('.side-nav');
                }

                return dynaformSideNav;
            }

            function getHierarchyBreadcrumbContainer() {
              if (!_hierarchyBreadcrumbsElem) {
                _hierarchyBreadcrumbsElem = $element[0].querySelector('.hierarchy-breadcrumbs');
              }

              return _hierarchyBreadcrumbsElem;
            }

            function getDynaformTabsElem() {
                return getDynaformSideNav() && getDynaformSideNav().querySelector('.tabs');
            }

            function enableDisableNumberConfig() {
                if (!SkApplication.instance().hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG_NUMBER) || StringUtils.isEmpty($scope.autoNumField)) {
                    self.enableNumberConfig = false;
                } else {
                    self.enableNumberConfig = true;
                }
            }

            function hasAccess(action) {
                return SkApplication.instance().hasAuthorization(action);
            }

            function loadByPK(pkObj) {
                if (!pkObj) {
                    return;
                }

                _loadingByPK = true;

                var pk = [];

                if (pkObj.ACTION_PARAMETERS) {
                    angular.forEach(pkObj.ACTION_PARAMETERS, function (param) {
                        pk.push({
                            name: param.fieldName,
                            value: param.value
                        });
                    });
                } else {
                    angular.forEach(pkObj, function (value, key) {
                        pk.push({
                            name: key,
                            value: value
                        });
                    });
                }

                whenLoaded().then(function () {
                    showDyanformView().then(function () {
                        refreshDatasetByPk(pk, angular.isDefined(pkObj.ACTION_PARAMETERS));
                    });
                });
            }

            function goToStartPage() {
                return $q(function (resolve, reject) {
                    $scope.dataset.askAndCancelEdition().then(function () {
                        $scope.view = 'start';

                        SkComponentRegistry.get($scope.entityStartPageId).then(function (instance) {
                            instance.loadFilters();
                            instance.setFocus();
                        });

                        resolve();
                    }, reject);
                });
            }

            function reloadConfiguration() {
                var dynaformConfig = getDynaformConfig();

                dynaformConfig.loadConfiguration(self);

                _defaultFilter = dynaformConfig.getDefaultFilterAsCriteria();

                if (isMasterDynaform()) {
                  SkComponentRegistry.get($scope.entityStartPageId).then(function (instance) {
                    instance.setDefaultFilter(_defaultFilter);
                  });
                }

                return dynaformConfig;
            }

            function loadFiltersOnCreate() {
                if (isMasterDynaform()) {
                    return 'false';
                } else {
                    return 'true';
                }
            }

            function forceFixedBarContext() {
                return $scope.dataset && ($scope.dataset.isRecordDirty() || $scope.dataset.isInsertionMode());
            }

            function contextIsActive() {
                if (isMasterDynaform()) {
                    return true;
                } else {
                    var tab = $scope.parentDynaform.getSelectedTab();
                    return tab && tab.type == 'dynaform' && tab.entityName == getEntityName();
                }
            }

            function getSelectedTab() {
                return $scope.tabSelected;
            }

            function notifyFixedBarToReset() {
                $scope.$root.$emit(FixedBarConstants.EVENT_FIXED_BAR_RESET, 'dynaform-top-bar-' + getMasterDynaformId());
            }

            function updateDatasetState() {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                var multiEdit = $scope.dataset.isMultiRecordEditMode();

                var clean = !(dirty || insertionMode || multiEdit);

                $scope.showSaveCancelOnCompactTopBar = !clean;
                $scope.addButtonEnabled = clean;
                $scope.showNavigatorAddButton = clean && (isDetailDynaform() || $scope.viewMode == 'grid');
            }

            function onDatasetRefresh() {
                unHighlightFields();
                updateDatasetState();
                adjustFilterSidenavPosition();
                createGrid();

                if (isHierarchyDynaformActivated() && !_firstRefresh) {
                    _firstRefresh = true;
                    $scope.states.isSideNavOpen = true;
                }
            }

            function onDatasetCurrentLineChanged() {
                unHighlightFields();
                updateDatasetState();
                if (isHierarchyDynaformActivated() && $scope.viewMode == 'form') {
                    createGrid();
                }
            }

            function onDatasetInsertionModeActivated() {
                $scope.viewMode = 'form';

                if (!$scope.dataset.isCopyingRecord()) {
                    angular.forEach(_defaultValueByField, function (value, field) {
                        var defValue = getDefaultValue(field);

                        if (angular.isDefined(defValue)) {
                            $scope.dataset.setFieldValue(field, defValue);
                        }
                    });
                }

                updateDatasetState();
                updateTabRequiredStatus();
                AngularUtil.timeout(resolveFocus);
            }

            function onDatasetEditionModeActivated(multiEditMode) {
                if (multiEditMode) {
                    goToFormView();
                }

                updateDatasetState();
            }

            function dataModified() {
                updateTabRequiredStatusDebounced();
                updateDatasetState();
            }

            function onDatasetDataSaved() {
                invalidateRecents();
                invalidateFavorites();
                updateDatasetState();
                notifyFixedBarToReset();
            }

            function onDatasetRecordRemoved() {
                invalidateRecents();
                updateDatasetState();
            }

            function onDatasetEditionCanceled() {
                unHighlightFields(FormHighlithKind.ERROR);
                updateDatasetState();
                notifyFixedBarToReset();
            }

            function saveAvoided(nullFieldNames) {
                var firstField;
                for (var i = 0, length = nullFieldNames.length; i < length; i++) {
                    if (isFieldVisible(nullFieldNames[i])) {
                        firstField = nullFieldNames[i];
                        break;
                    }
                }

                if (firstField && _tabByField[firstField]) {
                    loadTabAndHighlightField(_tabByField[firstField].tabInfo, firstField, FormHighlithKind.ERROR);
                }
            }

            function updateTabRequiredStatus() {
                var stateByTab = {};

                for (var requiredFieldName in $scope.requiredTabByField) {
                    var tabInfo = $scope.requiredTabByField[requiredFieldName];
                    var tabId = tabInfo.tabId;

                    var value = $scope.dataset.getFieldValue(requiredFieldName);

                    if (!stateByTab[tabId]) {
                        stateByTab[tabId] = {
                            tabInfo: tabInfo,
                            showIcon: false
                        };
                    }

                    if (!stateByTab[tabId].showIcon && angular.isUndefined(value)) {
                        stateByTab[tabId].showIcon = true;
                    }
                }

                for (var tabId in stateByTab) {
                    stateByTab[tabId].tabInfo.hasRequiredFieldUndefined = stateByTab[tabId].showIcon;
                }
            }

            function getLayoutInfo() {
                var finalInvisibleFields = [];

                var allGeneralField = $scope.allFields.slice(0);
                for (var key in _invisibleFieldsByName) {
                    allGeneralField.push(_invisibleFieldsByName[key]);
                }

                $scope.invisibleFields.forEach(function (invisibleField) {
                    if (_hiddenFieldsFromConfig.hasOwnProperty(invisibleField.name) || !isFieldVisible(invisibleField.name)) {
                       finalInvisibleFields.push(invisibleField);
                   }
                });

                return {
                    mainTabInfo: $scope.mainTabInfo,
                    tabsInfo: $scope.allTabsInfo,
                    invisibleFields: finalInvisibleFields,
                    allFields: $scope.allFields,
                    allGeneralFields: allGeneralField
                };
            }

            function addFieldDefaultValue(fieldName, defValue) {
                _defaultValueByField[fieldName] = defValue;
            }

            function removeFieldDefaultValue(fieldName) {
                delete _defaultValueByField[fieldName];
            }

            function getDefaultValue(fieldName, fieldType) {
                if (angular.isUndefined(fieldType)) {
                    fieldType = $scope.dataset.getFieldMetadata(fieldName).userType;
                }

                var typedValue;
                var strValue = _defaultValueByField[fieldName];

                if (strValue && strValue !== '') {
                    if (_dynaformDefValues) {
                        ArrayUtils.forEach(VARIABLE_DEFAULT_VALUES, function (key) {
                            if (key === strValue) {
                                strValue = _dynaformDefValues[key];
                                return false;
                            }
                        });
                    }

                    switch (fieldType) {
                        case 'I':
                        case 'F':
                        case 'T':
                            typedValue = NumberUtils.stringToNumber(strValue);
                            break;
                        case 'D':
                        case 'H':
                            typedValue = strToDate(strValue);
                            break;
                        default:
                            typedValue = strValue;
                    }
                }

                return typedValue;
            }

            function strToDate(strValue) {
                var dateValue;

                if (String(strValue).toLowerCase() == '${datahora}') {
                    dateValue = DateUtils.getToday(false);
                } else if (String(strValue).toLowerCase() == '${data}') {
                    dateValue = DateUtils.getToday(true);
                } else {
                    dateValue = DateUtils.strToDate(strValue);
                }

                return dateValue;
            }

            function setDynaformConfig(dynaformConfig) {
                _dynaformConfig = dynaformConfig;
                _dynaformConfig.addObserver(self);

                if (angular.isDefined(_dynaformConfig)) {
                    reloadConfiguration();
                }
            }

            function getDynaformConfig() {
                if (!_dynaformConfig) {
                    throw Error('Configuração do dynaform ainda não foi iniciada');
                }

                return _dynaformConfig;
            }

            function setTabsInfo(tabsInfo) {
                $scope.tabsInfo = tabsInfo;
            }

            function invalidateRecents() {
                $scope.recentsEntities = undefined;
            }

            function hideBtnIsFavorite(enable) {
                $scope.hideButtonFavorite = enable;
            }

            function invalidateFavorites() {
                $scope.favoriteEntities = undefined;
            }

            function highlightFields(tabInfo, highlightKind, fieldNames, options) {
                if(!angular.isArray(fieldNames)){
                    fieldNames = [fieldNames];
                }
                unHighlightFields(highlightKind);

                if (!_highlightInfo) {
                    _highlightInfo = {};
                }
                
                if(!tabInfo){
                    if(_tabByField.hasOwnProperty(fieldNames[0])){
                        loadTabFormController(_tabByField[fieldNames[0]].tabInfo);
                    }
                    tabInfo = _tabByField[fieldNames[0]].tabInfo;
                }
                
                _highlightInfo[highlightKind] = {
                    tabInfo: tabInfo,
                    fieldNames: fieldNames
                };

                tabInfo.formController.highlightFields(highlightKind, fieldNames, options);
            }

              function unHighlightFields(onlyThisKind, fields) {
                if (_highlightInfo) {
                    angular.forEach(_highlightInfo, function (highlightInfo, highlightKind) {
                        if (angular.isUndefined(onlyThisKind) || highlightKind == onlyThisKind) {
                            highlightInfo.tabInfo.formController.unHighlightFields(highlightKind, fields);
                        }
                    });

                    if (angular.isDefined(onlyThisKind)) {
                        delete _highlightInfo[onlyThisKind];
                    } else {
                        _highlightInfo = undefined;
                    }
                }
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#isMasterDynaform
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Informa se o dynaform é master.
             * @return {boolean} Retorna true caso seja master, falso caso contrário
             */
            function isMasterDynaform() {
                return $scope.mode == DynaformModes.MASTER_DYNAFORM;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#isDetailDynaform
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Informa se o dynaform é detail.
             * @return {boolean} Retorna true caso seja detail, falso caso contrário
             */
            function isDetailDynaform() {
                return $scope.mode == DynaformModes.DETAIL_DYNAFORM;
            }
            
            function whichViewMode() {
                return $scope.viewMode
            }

            function hasStartPage() {
                return !$scope.skipStartPage == true;
            }

            function hasEntityCard() {
                return !($scope.skHideEntityCard === true) && $scope.entityCardProps
            }
            
            function hasGridButton() {
                return !$scope.hideButtonGrid == true;
            }
            
            function hasActionButtons() {
                return !$scope.showActionButton == true;
            }
            
            function hasRecentsButton() {
                return !$scope.hideButtonRecents == true;
            }
            
            function hasConfigButton() {
                return !$scope.hideButtonsConfig == true;
            }
                    
            function hasFavoriteButton() {
                return !$scope.hideButtonFavorite == true;
            }
            
            function hasEntitySearchFieldButton() {
                return !$scope.hideEntitySearchField == true;
            }
            
            function hasEntityAttachButton() {
                return !$scope.hideButtonEntityAttach == true;
            }

            function showEntityStartPage() {
                return $scope.mode == DynaformModes.MASTER_DYNAFORM && !$scope.skipStartPage;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getDataset
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Retorna o dataset
             * @return {Dataset} Retorna o dataset do dynaform;
             */
            function getDataset() {
                return $scope.dataset;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#hasDynamicFilter
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Determina se o Dynaform possui ou não um painel de filtros
             * @return {boolean} Retorna true se houver painel de filtros, false do contrário.
             */
            function hasDynamicFilter() {
                return $scope.hasDynamicFilter == true;
            }

            function showTourDynamicFilter(){
                var element = $element.find(".container sk-filter-panel:first")
                return element.length > 0 && hasDynamicFilter();
            }
            
            function hasForceEnablePersonalizedFilter(){
            	return $scope.forceEnablePersonalizedFilter == true;
            }

            /**
            * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getTree
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Retorna a árvore hierárquica do dynaform
             * @return {FlatTree} Retorna a tree do dynaform;
             */
            function getTree() {
                if (isHierarchyDynaform()) {
                    if(_treeInstance){
                        return _treeInstance;
                    }

                    if(_flatTreeInstance){
                        return _flatTreeInstance;
                    }

                    return undefined;

                } else {
                    throw Error('Método \'getTree\' está disponível apenas para dynaforms hierárquicos. ')
                }
            }

            /**
            * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#addFieldsRequestInfo
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             * Método utilizado pela diretiva sk-field para inputar as colunas adicionais que serão requisitadas por este dynaform.
             * @return {Dynaform} Retorna o próprio dynaform para encadeamento.
             * @example <pre>dynaform.addFieldsRequestInfo({
                path: 'Produto',
                pattern: 'CODPROD'
            });</pre>
             */
            function addFieldsRequestInfo(field) {
                //Except fields pattern
                if(field.except === true){
                    var entity = field.path || $scope.entityName;

                    if(!_exceptFieldsByEntity.hasOwnProperty(entity)){
                        _exceptFieldsByEntity[entity] = [];
                    }

                    _exceptFieldsByEntity[entity] = _exceptFieldsByEntity[entity].concat(field.pattern.split(','));
                }if(field.pattern == DatasetContants.DEFAULT_USER_FIELDS){
                    _entityForceUserFields[field.path || $scope.entityName] = true;
                }else{
                    _metadataFieldsRequestInfo.push(field);
                }

                return self;
            }

            function addCustomColumnMD(customColumnMD, entityName) {
                if (!entityName) {
                    entityName = getEntityName();
                }

                var customMDs = _customColumnsMDByEntity[entityName];

                if (!customMDs) {
                    customMDs = [];
                    _customColumnsMDByEntity[entityName] = customMDs;
                }

                customMDs.push(customColumnMD);
            }

             /**
             * @ngdoc
            * @name snk.components.dynaform.directive:sk-dynaform#getEntityName
            * @methodOf snk.components.dynaform.directive:sk-dynaform
            * @description
            *  Retorna o nome da entidade do dynaform
            * @return {String} Nome da entidade do dynaform;
            */
            function getEntityName() {
                return $scope.entityName;
            }

            function getSidenavId() {
                return getResourceId() + '.sidenav';
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getResourceId
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Resolve o resourceID da tela
             * @param {String} [entityName=undefined] Nome da entidade.
             * @return {String} ResourceID
             */
            function getResourceId(entityName) {
                var id;
                
                if (!entityName || (isMasterDynaform() && getMasterDynaform().getEntityName() === entityName)) {
                    if ($scope.resourceId) {
                        id = $scope.resourceId;
                    } else {
                        id = SkApplication.instance().getResourceID();
                    }
                } else {
                    id = RESOURCE_ID_PREFIX + '.' + entityName + getVariationSufix();
                }

                if (!id) {
                    throw new Error(SkI18nService.instant('Dynaform.messageResIDNaoEncontrado'));
                }

                return id;
            }

            function getDynaformId() {
                return $scope.uid;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getParentEntityName
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Retorna o nome da entidade do dynaform parent ou undefined caso não haja um.
             * @return {String} Nome da entidade do dynaform parent ou undefined caso não haja um.
             */
            function getParentEntityName() {
                return $scope.parentDynaform ? $scope.parentDynaform.getEntityName() : ($attrs.hasOwnProperty('skParentEntityName') ? $attrs.skParentEntityName : undefined);
            }

            function parentDynaformIsMaster() {
                if ($scope.parentDynaform) {
                    $scope.parentDynaform.addChildDynaform(self);
                    return $scope.parentDynaform.getDynaformId() == $scope.getMasterDynaformId();
                } else {
                    return false;
                }
            }

            function parentDynaformIsHierarchy() {
                if ($scope.parentDynaform) {
                    return $scope.parentDynaform.isHierarchyDynaform();
                } else {
                    return false;
                }
            }

            /**
            * @ngdoc
            * @name snk.components.dynaform.directive:sk-dynaform#getNavigatorAPI
            * @methodOf snk.components.dynaform.directive:sk-dynaform
            * @description
            *  Retorna uma classe com os seguintes gets e sets
                - disableNavigator
                - showNavigation
                - showAddButton
                - showCopyButton
                - showRemoveButton
                - showRefreshButton
                - showCancelButton
                - showSaveButton
                - disableSearch
            * @return {function} Classe de API para habilitar/desabilitar opções no navigator do dynaform
            * @example
            * <pre>
            *  dynaform.getNavigatorAPI()
            *      .showAddButton(false)
            *      .showCopyButton(false);
            * </pre>
            */
            function getNavigatorAPI() {
                return _navigatorAPI;
            }

            function addChildDynaform(childDynaform) {
                if (_childDynaformArray.indexOf(childDynaform) < 0) {
                    _childDynaformArray.push(childDynaform);
                }
            }

            function getMasterDynaformId() {
                if ($scope.parentDynaform) {
                    return $scope.parentDynaform.getMasterDynaformId();
                } else {
                    return getDynaformId();
                }
            }

            function getMasterDynaform(path) {
                if (angular.isArray(path)) {
                    path.push(self.getEntityDescription());
                }

                if ($scope.parentDynaform) {
                    return $scope.parentDynaform.getMasterDynaform(path);
                } else {
                    if (angular.isArray(path)) {
                        path.reverse();
                    }

                    return self;
                }
            }

            function getDynaformElement() {
                return $element;
            }

            function getMasterDynaformElement() {
                return getMasterDynaform().getDynaformElement();
            }

            function getMasterDynaformResourceId(entityName) {
                if ($scope.parentDynaform) {
                    return $scope.parentDynaform.getMasterDynaformResourceId(entityName);
                } else {
                    return getResourceId(entityName);
                }
            }

            function isTabNavBorderBottom(index) {
                if ($scope.tabSelectedIndex > -1 && $scope.tabSelectedIndex == index) {
                    var selectedTab = $scope.tabsInfo[index];

                    if (selectedTab.type == 'dynaform') {
                        return true;
                    } else {
                        return (selectedTab.grayTabNav || selectedTab.tabNavBorderBottom) == true;
                    }
                }

                return false;
            }

            function isPureDynaform() {
                return SkApplication.instance().isPureDynaform();
            }

            function loadPropertiesFromServer() {
                return isDetailDynaform() || !isPureDynaform();
            }

            function loadMetadata() {
                var loadPromises = [];

                if (angular.isFunction($scope.initDynaform) && isDetailDynaform()) {
                    $scope.initDynaform({dynaform: self});
                }

                var entitiesRequestInfo = DatasetUtils.buildEntitiesRequestInfo($scope.entityName, _metadataFieldsRequestInfo);

                loadPromises.push(MetadataProvider.getEntityAndRelationsMetadata(entitiesRequestInfo.entitiesForRequest, undefined, true));

			 	var propertiesPromise = getDynaformInitProperties(loadPropertiesFromServer());
                loadPromises.push(propertiesPromise);

                effectiveActionButtonResourceID = $scope.actionButtonResourceID ||
                ($scope.parentDynaform && $scope.parentDynaform.getActionButtonResourceID ?
                    $scope.parentDynaform.getActionButtonResourceID() : undefined);
            
                effectiveActionButtonResourceID = effectiveActionButtonResourceID != '' ? effectiveActionButtonResourceID : undefined;
            
                if(effectiveActionButtonResourceID != undefined){
                    var actionButtonProperties = loadActionButtonByService(effectiveActionButtonResourceID);
                    loadPromises.push(actionButtonProperties);
                }

                $scope.view = 'loading';

                $q.all(loadPromises)
                    .then(function (result) {

                        if (!_loadingByPK) {
                            propertiesPromise.then(function (configs) {
                                AngularUtil.timeout(function () {
                                    if (!$scope.skipStartPage) {
                                        if (isMasterDynaform()) {
                                            $scope.view = 'start';
                                        } else {
                                            $scope.view = 'dynaform';
                                        }
                                    }
                                }, 0, true);
                            });
                        }
                        
                        if(effectiveActionButtonResourceID != undefined){
                            result[1].hasActionButtons = angular.isArray(result[2]) && result[2].length > 0;
                        }

                        buidDynaformInitConfigs(result[1], loadPropertiesFromServer());

                        var resourceID = getResourceId(isMasterDynaform() ? undefined : $scope.entityName)

                        $scope.isView = SkApplication.instance().getConfiguracaoTela(resourceID + ".isView");

                        if(isHierarchyDynaform){
                            $scope.treeHierarchyConfig = SkApplication.instance().getConfiguracaoTela($scope.treeHierarchyKey);
        
                            if($scope.treeHierarchyConfig && $scope.treeHierarchyConfig.config){
                                $scope.treeHierarchyConfig = $scope.treeHierarchyConfig.config;
                            }
        		}

                        var metadata = result[0];

                        DatasetUtils.processEntitiesRequestPaths(metadata, entitiesRequestInfo);

                        processMetadata(metadata);

                        buildCustomFilterIfNeeded()
                    }, function (err) {
                        MessageUtils.showError(MessageUtils.TITLE_ERROR, err.message);
                    });
            }

            function buildCustomFilterIfNeeded() {
                //Constroi o painel de filtros, se necessário
                if ($scope.hasDynamicFilter && isMasterDynaform() && !$scope.forceEnablePersonalizedFilter) {
                    $scope.isFilterOpen = !_ehModoFlow;
                    $scope.hasActiveDynamicFilter = false;
                    $scope.onFilterCreated = function ($filter) {
                        if (_customFilterPanel) {
                            $filter.setCustomFiltersElement(_customFilterPanel.detach());
                        }
                        _filterPanelInstace = $filter;

                        $scope.onFilterToggle(_filterPanelInstace.panelIsOpen());
                    };

                    $scope.onFilterToggle = function (isOpen) {
                        resizeFooter(isOpen);
                        resizeUserHeader(isOpen);
                    };

                    var filterPanelElement = angular.element(AngularUtil.createDirective('sk-filter-panel', {
                        'sk-data-source': 'dataset',
                        'sk-resource-id': getResourceId($scope.entityName),
                        'sk-entity-name': $scope.entityName,
                        'sk-filter-panel-interceptor': 'filterPanelInterceptor',
                        'sk-on-filter-created': 'onFilterCreated($filter)',
                        'sk-on-dynamic-filter-created': 'onDynamicFilterCreated($component)',
                        'sk-custom-criteria-loader': '$customCriteriaLoader()',
                        'sk-is-fixed-mode': 'true',
                        'sk-is-open': 'isFilterOpen',
                        'sk-pf-expanded': 'true',
                        'sk-has-some-active-filter': 'hasSomeActiveFilter.value',
                        'sk-show-label-others-filters' : $scope.showLabelOthersFilters,
                        'sk-apply-function': ($scope.filterPanelApplyFunction ?  'filterPanelApplyFunction()' : undefined),
                        'class': 'compact',
                        'sk-on-toggle': 'onFilterToggle(isOpen)',
                        'sk-instancia-name': $scope.filterInstanceName
                    }, $scope));

                    angular.element(dynaformCustomFilterContainer).removeClass('ng-hide');
                    angular.element(dynaformCustomFilterContainer).append(filterPanelElement);
                }
            }            

            function resizeFooter(isOpen){
                let userFooter = $element.find('#user-footer-container');
                if(isOpen){
                    userFooter.addClass('user-footer-filter-container');
                    userFooter.removeClass('user-footer-container');
                } else{
                    userFooter.addClass('user-footer-container');
                    userFooter.removeClass('user-footer-filter-container');                        
                }
            }

            function resizeUserHeader(isOpen){
                let userHeader = $element.find('#user-header-container');
                    if(isOpen){
                        userHeader.addClass('user-header-filter-container');
                        userHeader.removeClass('user-header-container');
                    } else{
                        userHeader.addClass('user-header-container');
                        userHeader.removeClass('user-header-filter-container');
                    }
            }

            function onDynamicFilterCreated($component) {
                _hasSomeDynamicFilterData = $component.hasSomeDynamicFilterData;
            }

            function adjustDynaformHelperData() {
                var propertiesToAdjust = ['ignoredFields', 'invisibleFields'];

                for (key in _dynaformHelperData) {
                    //Por enquanto fazemos apenas para as propriedades que temos caso de uso
                    if (propertiesToAdjust.indexOf(key) > -1 && angular.isArray(_dynaformHelperData[key])) {
                        for (var i = 0, length = _dynaformHelperData[key].length; i < length; i++) {
                            _dynaformHelperData[key][i] = _dynaformHelperData[key][i].trim();
                        }
                    }
                }
            }

            function getDynaformInitProperties(needToLoadProperties, options) {

                var forceLoadDefaults = (options && options.forceLoadDefaults);

                var request = {
                    resourceId: getMasterDynaformResourceId($scope.entityName),
                    entityName: $scope.entityName,
                    ignoreKeys: (isPureDynaform() || forceLoadDefaults) ? ['dynaform.default.values'] : undefined,
                    includeKeys: !needToLoadProperties ? ['isVariation'] : undefined,
                    isDetail: isDetailDynaform()
                };

                //Se a config do dynaform estiver sendo ignorada, não devemos carrega-la.
                if($scope.suppressScreenConfig){
                    if(!request.ignoreKeys) request.ignoreKeys = [];
                    request.ignoreKeys.push(getMasterDynaformResourceId($scope.entityName));
                }

                if ($scope.relationInfo) {
                   request.accessResourceID = $scope.relationInfo.properties.accessresourceid;
                   request.relationName = $scope.relationInfo.toEntity;
                }

                if (isDetailDynaform()) {
                    request.masterResourceID = self.getMasterDynaformResourceId();
                }else if (effectiveActionButtonResourceID != undefined) {
                   request.masterResourceID = SkApplication.instance().getResourceID();
                } 

                if ($scope.helperClassName) {
                    request['helperClassName'] = $scope.helperClassName;
                }

                if($scope.ignoreListenerMethods){
                    request['ignoreListenerMethods'] = $scope.ignoreListenerMethods;
                }

                return $q(function (resolve, reject) {
                    if($scope.ignoredConfigEntity){
                        resolve([]);
                    }else{
                    ServiceProxy.callService('DynaformBuilder.getDynaformInitProperties', request)
                        .then(function (result) {
                            resolve(result.responseBody.configs);
                        }, function (error) {
                            reject(error);
                        });
                    }
                });
            }

            function getAutoNumFieldName() {
                return $scope.autoNumField;
            }


            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getEntityDescription
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Retorna a descrição da entidade do dataset do dynaform, vide {@link snk.components.dataset.directive:sk-dataset#getEntityDescription}
             * @return {String} Descrição da entidade.
             */
            function getEntityDescription() {
                return $scope.dataset && $scope.dataset.getEntityDescription();
            }

            function getDynaformHelperData() {
                return _dynaformHelperData;
            }

            function setDynaformHelperData(data) {
                if(_dynaformHelperData && angular.isObject(data)){ //Caso já exista as propriedades vindas do backend, devemos mante-las e apenas adicionar as novas.

                    Object.keys(data).forEach((key) => {
                        if(!_dynaformHelperData.hasOwnProperty(key)){
                            _dynaformHelperData[key] = [];
                        }

                        if(angular.isArray(_dynaformHelperData[key])){
                            _dynaformHelperData[key] = _dynaformHelperData[key].concat(data[key]);
                        }else {
                            _dynaformHelperData[key] = data[key];
                        }
                        
                    });

                }else{
                    _dynaformHelperData = data;
                }
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setVisibleReferences
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Define quais referencias serao criadas se nao for informado, sobrescreve o dicionario
             * @param {*} visibleReferences array de referencias
             */
            function setVisibleReferences(visibleReferences) {
                _dynaformVisibleReferences = visibleReferences;
            }

            function processMetadata(entitiesMetadata) {
                $scope.entityMetadata = entitiesMetadata.entities[$scope.entityName];

                $scope.autoNumField = $scope.entityMetadata.autoNumField;

                enableDisableNumberConfig();

                DatasetUtils.prepareMetadata(entitiesMetadata, function (entityMD, field) {
                    let hasRequested = undefined;

                    if (_dynaformHelperData && _dynaformHelperData.ignoredFields) {
                        if (field.tableName == $scope.entityMetadata.tableName) {
                            // Carregar os metadata dos campos mesmo que que sejam ignorados
                            if (_dynaformHelperData.ignoredFields.indexOf(field.tableName + '.' + field.name) > -1) {
                                field.visible = false;
                            }
                            return true;
                        } else {
                            hasRequested = _dynaformHelperData.ignoredFields.indexOf(field.tableName + '.' + StringUtils.getOnlyFieldName(field.name)) == -1;
                        }
                    }
                    
                    if(hasRequested || hasRequested == undefined){
                        return isRequestedField(entityMD, field);
                    }else{
                        return hasRequested;
                    }
                    
                }, getParentEntityName(), getEntityName())
                    .then(function (processedMetadata) {
                        $scope.entityDescription = processedMetadata.entitiesMetadata[$scope.entityName].description;
                        $scope.customEntityDescription = angular.isDefined($scope.skCustomEntityDescription) ? SkI18nService.instant($scope.skCustomEntityDescription) : $scope.entityDescription;

                        $scope.dataset = buildDataset(processedMetadata);
                        $scope.datasetActionButtonContext = new DatasetActionButtonContext($scope.dataset);

                        _metadata = entitiesMetadata;
                        _processedMetadata = processedMetadata;

                        $scope.autoNum = SkApplication.instance().getConfiguracaoTela(getResourceId() + '.numeracao');

                        _dynaformDefValues = SkApplication.instance().getConfiguracaoTela('dynaform.default.values');

                        //usado para selecionar campo antes de terminar o refresh da tela
                        $scope.dataset.setSelectSelectedRow(true);

                        $scope.dataset.initializeDataSet().then(function () {
                            $scope.onDynaformLoaded({
                                dynaform: self,
                                dataset: $scope.dataset
                            });

                            buildEntityCard();

                            rebuildLayout();

                            buildOtherConfigs();

                            if (!$scope.isHierarchyActivated) {
                                $timeout(function() {
                                    $scope.dataset.initAndRefresh();
                                });
                            }
                        });

                        _showTour = SkApplication.instance().getConfiguracaoTela(CHAVE_VIZUALIZACAO_TOUR, false);
                        _showTourHierarchy = isHierarchyDynaformActivated() && SkApplication.instance().getConfiguracaoTela(CHAVE_VIZUALIZACAO_TOUR_HIERARCHY, false);
                        _currentViewedTourVersion = SkApplication.instance().getConfiguracaoTela(CHAVE_VIZUALIZACAO_TOUR_VERSION, 0);
                        _currentTourFormConfigVersion = SkApplication.instance().getConfiguracaoTela(CHAVE_TOUR_VERSION_FORM_CFG, -1);

                        if (_showTour || _showTourHierarchy || (_currentViewedTourVersion != DYNAFORM_TOUR_VERSION)) {
                            startTour();
                        }
                    });
            }

            function buildOtherConfigs() {
                if (!angular.isFunction($scope.otherConfigLoader)) {
                    return;
                }

                var configs = $scope.otherConfigLoader({ dynaform: self });

                if (angular.isArray(configs)) {
                    $scope.otherConfigurations = {
                        items: configs,
                        byId: {}
                    };

                    configs.forEach(function (conf) {
                        if ($scope.otherConfigurations.byId[conf.id]) {
                            throw Error('otherConfigurations carregou configurações com ids duplicados:' + conf.id);
                        }

                        $scope.otherConfigurations.byId[conf.id] = conf;
                    });
                }
            }

            function onClickUserConfiguration(conf) {
                if (!(conf.type == 'switch')) {
                    $scope.dropdownConfig.isOpen = false;
                }

                if (conf.onClick) {
                    conf.onClick(self, conf);
                }
            }

            function onChangeUserConfiguration(conf) {
                if (conf.onChange) {
                    conf.onChange(self, conf);
                }
            }

            function setOtherConfig(id, value) {
                if ($scope.otherConfigurations && $scope.otherConfigurations.byId[id]) {
                    $scope.otherConfigurations.byId[id] = value;
                }
            }

            function getOtherConfig(id) {
                return $scope.otherConfigurations && $scope.otherConfigurations.byId[id];
            }

            function isRequestedField(entity, field) {
                let exceptFields = isDetailDynaform() ? getMasterDynaform().getExceptFieldsByEntity() : _exceptFieldsByEntity;
                let entityForceUserFields = isDetailDynaform() ? getMasterDynaform().getExceptFieldsByEntity() : _entityForceUserFields;

                if(entityForceUserFields[entity.name] && field.name.startsWith('AD_')){
                    return true;
                }
                
                if(exceptFields[entity.name] && exceptFields[entity.name].indexOf(field.name) > -1){
                    return false;
                }

                if (_metadataFieldsRequestInfo.length == 0 || entity.name === $scope.entityName) {
                    return true;
                }

                for (var i = 0; i < _metadataFieldsRequestInfo.length; i++) {
                    var fieldsRequestInfo = _metadataFieldsRequestInfo[i];

                    if (fieldsRequestInfo.path === entity.name) {
                        if (fieldsRequestInfo.pattern === '*') {
                            return true;
                        }

                        var requestedFields = fieldsRequestInfo.pattern.split(',');

                        for (var j = 0; j < requestedFields.length; j++) {
                            if (field.name === requestedFields[j].trim()) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            }

            function onMetadataUpdated() {
                _metadataReady = true;
            }

            function goToFormView() {
                $scope.viewMode = 'form';
                $scope.iconChangeFace = 'table';
                updateDatasetState();
                
                if(!SkTourService.isOnTour() && _currentTourFormConfigVersion == 0 && isMasterDynaform() && $scope.userConfigFormColumns && isShowFormLayoutConfig() && !$scope.hideTour ){
                    $timeout(() => {
                        $scope.dropdownConfig.isOpen = true;
                        $scope.showTour = true;
                        $timeout(() => {
                            $scope.tour = DynaformTourContent.getFormConfigTour($element, self, endTourConfigForm, '.dynaform-tour-' + $scope.uid);
                            $scope.tour.startTour = true;
                        });
                    });                    
                }
            }

            function endTourConfigForm(openConfig){
                initTour();

                $scope.tour.startTour = false;
                $scope.dropdownConfig.isOpen = false;
                _currentTourFormConfigVersion++;

                SkApplication.instance().saveMgeConfig(CHAVE_TOUR_VERSION_FORM_CFG, {version : _currentTourFormConfigVersion});

                if(openConfig){
                    formConfigColumns();
                }
            }

            function dynaformAcceptField(fieldMD) {
                if (_dynaformHelperData) {
                    var fieldName = fieldMD.tableName + '.' + fieldMD.id;

                    if (!fieldMD.isUserField && ArrayUtils.isNotEmpty(_dynaformHelperData.onlyVisibleFields)) {
                        if (!ArrayUtils.isIn(_dynaformHelperData.onlyVisibleFields, fieldName)) {
                            return false;
                        }
                    }

                    if (ArrayUtils.isIn(_dynaformHelperData.ignoredFields, fieldName)) {
                        return false;
                    }

                    if (ArrayUtils.isIn(_dynaformHelperData.invisibleFields, fieldName)) {
                        return false;
                    }
                }

                return true;
            }

            function createGrid(resolveOnShow, clearContent) {
                var gridCreatedPromise = $q.defer();

                if (clearContent) {
                    _gridCreated = false;
                    angular.element(dynaformGridContent).children().remove();
                }

                if (!_gridCreated) {
                    //Antes de começar a construir a grade, registramos seu gridconfig
                    var gridconfigId = 'grdcgf-' + getResourceId();
                    var configName = getResourceId();

                    GridConfig.registerGridConfig(gridconfigId, configName, undefined, true, $scope.ignoredConfigEntity);

                    $scope.onDatagridCreated = function () {
                        if (resolveOnShow) {
                            gridCreatedPromise.resolve();
                        }

                        AngularUtil.timeout(function () {
                            datagridElement.removeClass('loading');
                        });
                    };

                    var userAcceptColumnFn;

                    if ($scope.datagridInterceptor) {
                        userAcceptColumnFn = $scope.datagridInterceptor.acceptColumnField;
                    } else {
                        $scope.datagridInterceptor = new IDatagridInterceptor();
                    }

                    var dtgRespectForm = dtgRespectFormConfig();

                    $scope.datagridInterceptor.acceptColumnField = function (fieldMD, dataset) {
                        if (canResolveHiddenColumn(fieldMD, dataset)) {	
                            if ($scope.disableRemoveInvisibleFields !== false) {
                                fieldMD.visible = false;
                            } else {
                                return false;
                            }
                        }

                        return userAcceptColumnFn ? userAcceptColumnFn(fieldMD, dataset) : true;
                    };

                    datagridElement = angular.element(AngularUtil.createDirective('sk-datagrid', {
                        'id': 'datagrid',
                        'sk-dataset': 'dataset',
                        'creation-complete': 'onDatagridCreated()',
                        'sk-grid-config': gridconfigId,
                        'sk-on-dbl-click': 'changeViewMode()',
                        'sk-on-datagrid-loaded': 'onDynaformDatagridLoaded(datagrid, dataset)',
                        'sk-on-datagrid-init': 'onDynaformDatagridInit(datagrid, dataset)',
                        'sk-datagrid-interceptor': 'datagridInterceptor',
                        'sk-hide-cbx-column': 'hideCbxColumn',
                        'sk-allow-multiple-selection':'allowMultipleSelection',
                        'sk-disable-tour': !isMasterDynaform(),
                        'aggrid' : ''
                    }, $scope));

                    angular.element(dynaformGridContent).append(datagridElement);

                    AngularUtil.timeout(function () {
                        $scope.gridController = datagridElement.data('$skDatagridController');
                        self.gridController = $scope.gridController;

                        whenReadyDatagridElement.ready();

                        if (gridCreatedPromise && !resolveOnShow) {
                            gridCreatedPromise.resolve();
                        }
                    });

                    _gridCreated = true;
                } else {
                    if($scope.dataset.isLazyLoad() && $scope.dataset.isInitDataSetLazyLoad()){
                        $scope.datagrid.refreshCells(); 
                    }

                    gridCreatedPromise.resolve();
                }

                return gridCreatedPromise.promise;
            }
            
            function canResolveHiddenColumn(fieldMD, dataset) {
                var _canResolve = !dynaformAcceptField(fieldMD);
                
                if($scope.ignoreAcceptColumnEntityName){
                	_canResolve = _canResolve && dataset.getEntityName() == getEntityName(); 
                }
                
                if(!_canResolve){
                    var dtgRespectForm = dtgRespectFormConfig();
	                
	                if(dtgRespectForm && _invisibleFieldsByName[fieldMD.name]){
	                	_canResolve = true;
	                }
                }
                
                return _canResolve;
            }

            function createDynaformTabIfNotExists(tabInfo, tabOrder) {
                var defer = $q.defer();

                if (!_createdTabs.hasOwnProperty(tabInfo.tabId)) {
                    var tabIndex = $scope.tabsInfo !== undefined ? $scope.tabsInfo.indexOf(tabInfo) : tabOrder;

                    //Aba de relacionamento
                    if (tabInfo.entityName) {
                        var childProps = {
                            'sk-entity-name': tabInfo.entityName,
                            'sk-resource-id': getResourceId() + '.dynaform.' + tabInfo.entityName,
                            'sk-parent-dynaform': 'controller',
                            'layout': 'column',
                            'creation-complete': 'childDyanformCreationComplete()',
                            'flex': '',
                            'sk-show-filter': tabInfo.showFilter,
                            'sk-init-dynaform': 'initChildDynaform(dynaform)',
                            'sk-on-dynaform-loaded': 'onChildDynaformLoaded(dynaform,dataset)',
                            'sk-on-datagrid-loaded': 'onDynaformDatagridLoaded(datagrid,dataset)',
                            'sk-on-datagrid-init': 'onDynaformDatagridInit(datagrid, dataset)',
                            'sk-custom-tabs-loader': 'onChildCustomTabsLoader(entityName)',
                            'sk-dynaform-interceptor': 'dynaformInterceptor',
                            'sk-datagrid-interceptor': 'datagridInterceptor',
                            'sk-form-interceptor': 'formInterceptor',
                            'sk-grid-printer-interceptor' : 'gridPrinterInterceptor',
                            'sk-hide-entity-card': 'skHideEntityCard',
                            'sk-hide-button-entity-attach': 'hideButtonEntityAttach',
                            'sk-hide-buttons-config': 'hideButtonsConfig',
                            'sk-hide-tour': true,
                            'sk-ignored-config-entity': $scope.ignoredConfigEntity == true,
                            'sk-form-column-number-config': $scope.formColumnNumberConfig
                        };

                        if (tabInfo.relationInfo) {
                            var objKey = 'relationInfo' + tabInfo.tabId;
                            $scope[objKey] = tabInfo.relationInfo;
                            childProps['sk-relation-info'] = objKey;
                        }

                        if ($scope.recursiveHelper) {
                            childProps['sk-recursive-helper'] = 'recursiveHelper';
                            childProps['sk-helper-class-name'] = $scope.helperClassName;
                        }

                        $scope.actualOptions = [];

                        if (angular.isArray($scope.otherOptionsChildren)) {
                            $scope.otherOptionsChildren.forEach(function (option) {
                                if (angular.isArray(option.entitiesName)) {
                                    option.entitiesName.forEach(function (entityName) {
                                        if (entityName == tabInfo.entityName) {
                                            $scope.actualOptions.push(option);                                            
                                        }
                                    });
                                }
                            });
                        }

                        childProps['sk-other-options-children'] = 'allOptionsLoadded';
                        childProps['sk-other-options-loader'] = 'actualOptions';
                        childProps['sk-accept-promise-search-field'] = $scope.acceptPromiseSearchField !== false;
                        
                        $scope.childDyanformCreationComplete = function(){
                            defer.resolve();
                        };

                        var dynaformElem = AngularUtil.createDirective('sk-dynaform', childProps, $scope);

                        if (tabIndex > -1) {
                            var currentIteration = 0;
                            var maxIteration = 10;

                            //Isso é necessário pois o container é lazy load
                            // e ele pode não estar pronto imediatamente.
                            var attachDynaformFn = function () {
                                AngularUtil.timeout(function () {
                                    var viewstackContent;

                                    try {
                                        viewstackContent = dynaformViewstack.children[tabIndex].children[0];
                                    } catch (e) {
                                        throw Error('ViewstackContent [' + tabIndex + ',' + tabInfo.tabName + '] não encontrado');
                                    }

                                    if (viewstackContent) {
                                        angular.element(viewstackContent).append(dynaformElem);
                                    } else {
                                        if (currentIteration < maxIteration) {
											currentIteration++;
                                            attachDynaformFn();
                                        } else {
                                            throw new Error('Não foi possível construir a aba detalhe, container não encontrado. [' + tabInfo.tabName + ']');
                                        }
                                    }
                                }, 200);
                            };

                            attachDynaformFn();
                        }
                    } else {
                        $scope.formCreationComplete = defer.resolve;
                    }

                    _createdTabs[tabInfo.tabId] = undefined;
                } else {
                    defer.resolve();
                }

                return defer.promise;
            }

            function getParentDataset() {
                return $scope.parentDynaform && $scope.parentDynaform.getDataset();
            }

            function buildDataset(processedMetadata) {
                $scope.datasetMetadataProvider = function (setMetadata) {
                    setMetadata(processedMetadata);
                };

                var dsProperties = {
                    'entity-name': $scope.entityName,
                    'metadata-provider': 'datasetMetadataProvider',
                    'parent-dataset': 'getParentDataset()'
                };

                if (isHierarchyDynaformActivated() && getHierarchyConfig()) {
                    dsProperties['crud-listener'] = 'br.com.sankhya.modelcore.crudlisteners.HierarchyCrudListener';
                    dsProperties['sk-lazy-load'] = true;
                }
                
                dsProperties['sk-accept-promise-search-field'] = $scope.acceptPromiseSearchField !== false;

                var datasetElem = angular.element(AngularUtil.createDirective('sk-dataset', dsProperties, $scope));
                var datasetController = datasetElem.data('$skDatasetController');
                angular.element(dynaformContainer).append(datasetElem);

                datasetController.addObserver(self);

                datasetController.addAfterCopyAction(function () {
                    angular.forEach(_fieldsToCleanOnCopy, function (value, key) {
                        datasetController.setFieldValue(key, getDefaultValue(key));
                    });
                });

                datasetController.readAuthorizarionData(_authData || SkApplication.instance().getAuthorizationData());

                if ($scope.dynaformInterceptor) {
                    $scope.dynaformInterceptor.interceptDataset(self, datasetController);
                }

                if (isHierarchyDynaformActivated() && !$scope.keepParallelLoader) {
                    datasetController.setParallelLoader(false);
                }

                _whenDatasetReady.ready();

                return datasetController;
            }

            function $customCriteriaLoader() {
                if ($scope.customCriteriaLoader) {
                    return $scope.customCriteriaLoader();
                }

                return undefined;
            }

            function buildEntityCard(clearContainer) {
                if (clearContainer) {
                    const container = angular.element(dynaformContent.querySelector('.entity-card-container'));
                    if (angular.isDefined(container) && container.length > 0) {
                        container.children().remove();
                    }
                }

                if (angular.isUndefined($scope.entityCardProps) || clearContainer) {
                    buildEntityCardProps();
                }

                doBuildEntityCard();
            }
            
            function getValueHierarchyAsString(fieldName) {
                /*  
                    Devido o retorno da função getTree() devolver um throw quando não é identificado como arvore, é necessário
                    validar anteriormente a informação para assegurar esse erro em um try {} catch; 
                */

                let hasTree;

                try {
                    hasTree = self.getTree();
                } catch (error) {
                    hasTree = false;
                }

                if (angular.isDefined(hasTree) && hasTree){
                    /* 
                        Geralmente esses valores são definidos nas propriedades dos metadados, mas caso não seja possível recuperar, os valores defaults estão definidos
                        conforme as informações do componente tree.controller.js
                    */ 

                    let _hierarchyConfig = {
                        mask: angular.isDefined(self.getTree().getHierarchyConfig()) ? self.getTree().getHierarchyConfig().mask : null || null,
                        fromLeft: angular.isDefined(self.getTree().getHierarchyConfig()) ? self.getTree().getHierarchyConfig().fromLeft : true || true,
                        defaultChar: angular.isDefined(self.getTree().getHierarchyConfig()) ? self.getTree().getHierarchyConfig().defaultChar : '' || '',
                    };

                    let fieldsMD = $scope.dataset.getFieldMetadata(fieldName);

                    if (!angular.isArray(fieldsMD)) {
                        fieldsMD = [fieldsMD];
                    }

                    ArrayUtils.forEach(fieldsMD, function (fieldMD) {
                        let _localProperty;

                        let _parentProperty;
                        let _parentPropertyName;

                        let _pathHierarchy;

                        if (angular.isUndefined(_hierarchyConfig.mask) || _hierarchyConfig.mask === '') {
                            /* Se esse valor não estiver definido na tela, será buscado a informação nos metadados da coluna */
                            let hasMaskProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                                return prop.name == 'mask';
                            });

                            if (hasMaskProp) {
                                _hierarchyConfig.mask = StringUtils.expandHierarchyMask(hasMaskProp.value);
                            }
                        }else {
                            /*  
                                Quando a pk definida é readOnly, significa que existe uma coluna na tabela que esta utilizando a propriedade pathHierarquia na qual
                                esta que será utilizada a máscara. Nesse caso, quando isso ocorrer, não atualizaremos o valor da coluna pk no formato da máscara.
                                Ex.: Tela de Endereço de Armazenagem
                            */

                            let pkIsReadOnly = ArrayUtils.find(fieldMD.properties, function (prop) {
                                return prop.name == 'readOnly';
                            });

                            if (pkIsReadOnly && pkIsReadOnly.value == 'S' ){
                                return undefined;
                            }
                        }

                        let parentKeyNameProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                            return prop.name == 'parentKeyName';
                        });

                        if (parentKeyNameProp && parentKeyNameProp.value) {
                            _parentPropertyName = parentKeyNameProp.value;
                        } else {
                            _parentPropertyName = fieldMD.name + PARENT_FIELD_SUFIX;
                        }

                        _localProperty = $scope.dataset.getFieldIndexByName(fieldMD.name);
                        _parentProperty = $scope.dataset.getFieldIndexByName(_parentPropertyName);

                        let hasPathProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                            return prop.name == 'pathHierarquia';
                        });

                        if (hasPathProp) {
                            _pathHierarchy = $scope.dataset.getFieldIndexByName(fieldMD.name);
                        }

                        let itemIdentifier = $scope.dataset.getCurrentRow()[_pathHierarchy || _localProperty]
                        let parentIdentifier = $scope.dataset.getCurrentRow()[_parentProperty];

                        let maskedValue;

                        if ((angular.isUndefined(parentIdentifier) || parentIdentifier <= ROOT_KEY_VALUE || parentIdentifier == 0) && itemIdentifier == 0) {
                            maskedValue = StringUtils.replicate('0', _hierarchyConfig.mask?.indexOf('.'));
                        } else {
                            const { mask, fromLeft, defaultChar } = _hierarchyConfig;
                            maskedValue = StringUtils.applyHierarchyMask(mask, itemIdentifier, false, fromLeft, defaultChar);
                        }

                        _hierarchyConfig.maskedValue = maskedValue;
                    });

                    return _hierarchyConfig;
                }
                
                return undefined;
            }

            function doBuildEntityCard() {
                var entityCardProps = {
                    'sk-entity-name': 'entityName',
                    'sk-pk-field': 'entityCardProps.entity.pkField',
                    'sk-all-pks': 'entityCardProps.entity.allPks',
                    'sk-description-field': 'entityCardProps.entity.descriptionField',
                    'sk-has-image': 'false',
                    'sk-is-favorite': 'entityCardProps.isFavorite',
                    'sk-data': 'entityCardProps.data',
                    'sk-fields-metadata': 'entityCardProps.entity.fieldsMetadata',
                    'sk-enable-show-details': 'false',
                    'sk-single-column': 'false',
                    'sk-compact': 'true',
                    'ng-show': 'showEntityCard()'
                };

                var eCElem = angular.element(AngularUtil.createDirective('sk-entity-card', entityCardProps, $scope));
                angular.element(dynaformContent.querySelector('.entity-card-container')).append(eCElem);

                var observer = new IDataSetObserver();
                observer.refreshed = changeDatasetRow;
                observer.currentLineChanged = changeDatasetRow;
                $scope.dataset.addObserver(observer);
            }

            function changeDatasetRow() {
                if ($scope.entityCardProps) {
                    $scope.entityCardProps.data = undefined;
                }

                var currentRow = $scope.dataset.getCurrentRow();

                if (currentRow) {
                    var pkFields = $scope.dataset.getPrimaryKeys();
                    var foreignKeys = $scope.dataset.getForeignKeyFields();

                    var buildData = function (loadingEntityCard) {
                        var data = {};

                        var allPkFields = ($scope.entityCardProps.entity.allPks && $scope.entityCardProps.entity.allPks.length > 0) ?  $scope.entityCardProps.entity.allPks :  [$scope.entityCardProps.entity.pkField];
                        
                        allPkFields.forEach(function(pkName){
                            /* Montar o title com a máscara se for arvore. */
                            let hasMask = getValueHierarchyAsString(pkName);
                            if (angular.isDefined(hasMask)) {
                                data[pkName + '_MASK'] = hasMask.maskedValue;
                            }

                            data[pkName] = $scope.dataset.getFieldValueAsString(pkName);
                        });

                        var descriptionField = $scope.entityCardProps.entity.descriptionField;
                        var descriptionFieldIndex = $scope.dataset.getFieldIndexByName(descriptionField);

                        data[descriptionField] = currentRow[descriptionFieldIndex];
                        
                        if ($scope.hideButtonFavorite !== true) {
                            if (loadingEntityCard) { //Na carga da entidade nós temos a informação de favorite
                                $scope.entityCardProps.isFavorite = $scope.entityCardProps.entity.data[0].__isFavorite;

                                //Se temos um dynaform parent, isolamos a pk local
                                if ($scope.dataset.getParentDataset()) {
                                    var foreignKeysNames = foreignKeys.map(function (field) {
                                        return field.localField;
                                    });

                                    var pksLocais = pkFields.filter(function (pkField) {
                                        return foreignKeysNames.indexOf(pkField) == -1;
                                    });

                                    if (pksLocais.length > 0) {
                                        $scope.entityCardProps.entity.pkField = pksLocais[0];
                                    }
                                }
                            } else { //Como durante a navegação aproveitamos os metadados e reconstruimos o card apenas com o dataset, temos que pesquisar se é favorito
                                var pkHash = DatasetUtils.buildPkHash($scope.dataset.getPrimaryKeyObject());

                                if (_favoriteCache.hasOwnProperty(pkHash)) {
                                    $scope.entityCardProps.isFavorite = _favoriteCache[pkHash];
                                } else {
                                    var currentDatasetIndex = $scope.dataset.getCurrentIndex();
                                    
                                    let pkValues = getPkValues();   
                                    if (pkValues.length > 0) {

	                                    SkPesquisaService.isFavorite($scope.entityName, pkValues)
	                                        .then(function (isFavorite) {
	                                            _favoriteCache[pkHash] = isFavorite;
	
	                                            if (currentDatasetIndex == $scope.dataset.getCurrentIndex()) { //Se não navegou durante a pesquisa
	                                                $scope.entityCardProps.isFavorite = isFavorite;
	                                            }
	                                        });
	                                }
                                }
                            }
                        }
                        $scope.entityCardProps.data = data;
                    };

                    if (angular.isUndefined($scope.entityCardProps)) {
                        buildEntityCardProps();
                        buildData(true);
                    } else {
                        buildData(false);
                    }
                }
            }

            function getPkValues() {
                var pkValues = [];
                var pkFields = $scope.dataset.getPrimaryKeys();

                var todosVazios=true; 

                angular.forEach(pkFields, function (pkField) {
                    var pkValue = $scope.dataset.getFieldValueAsString(pkField);
					
					if (StringUtils.isNotEmpty(pkValue)){
                    	todosVazios=false;
                    }
					pkValues.push(pkValue);
                });

				if (todosVazios) {
					return [];					
				} else {
                	return pkValues;					
				}
                
            }

            function buildEntityCardProps() {
                $scope.entityCardProps = {
                    entity: {
                        pkField: $scope.dataset.getPrimaryKeys()[0],
                        allPks: $scope.dataset.getPrimaryKeys(),
                        descriptionField: $scope.dataset.getEntityPresentationFieldName()
                    }
                };
            }

            function adjustTopBarPosition() {
                AngularUtil.timeout(function () {
                    var topBarWidth = dynaformTopLeftBar.getBoundingClientRect().width + dynaformTopRightBar.getBoundingClientRect().width;
                    var dynaformWidth = dynaformBody.getBoundingClientRect().width;

                    if (topBarWidth > 0 && (topBarWidth + 50) > dynaformWidth) {
                        angular.element(dynaformTopRightBar).addClass('float-left')
                    } else {
                        angular.element(dynaformTopRightBar).removeClass('float-left')
                    }
                });
            }

            function adjustFilterSidenavPosition() {
                if (!$scope.hasDynamicFilter) {
                    return;
                }

                var betaElemHeight = 0;
                var filterPanel = angular.element(dynaformCustomFilterContainer.querySelector('sk-filter-panel'));
                var topBarHeight = angular.element(dynaformTopbar).height();
                var topBarDoubleRows  = topBarHeight > 100;
                var userHeaderContainer = angular.element(dynaformTopbar).find('#user-header-container');

                if(userHeaderContainer.length > 0){
                    topBarHeight -= (topBarDoubleRows ? userHeaderContainer[0].offsetTop : userHeaderContainer[0].scrollHeight);
                }
                var topPosition = topBarHeight - PositionUtils.scrollTop();

                var tempTop = undefined;
                var zoomTop = false;
                var tempHeight = undefined;
                var zoomHeight = false;
                
                if(PositionUtils.scrollTop() < 1.5){
                    if(_newLayoutWarningElem){
                        betaElemHeight = _newLayoutWarningElem.offsetHeight;
                    }

                    tempHeight = getAvailablePageHeight() - topBarHeight - 3;
                    tempTop = 0;
                }else{
                    tempHeight = getAvailablePageHeight(); 
                    zoomHeight = true;
                    
                    var winTopScroll = $(window).scrollTop();
                    var divTopDistance = $('sk-filter-panel').offset().top - parseFloat($('sk-filter-panel').css('top'));
                    tempTop = winTopScroll - divTopDistance;
                    zoomTop = true;
                }

                if(userHeaderContainer.length > 0){
                    tempHeight = zoomHeight ? tempHeight : (getAvailablePageHeight() - (topBarDoubleRows ? userHeaderContainer[0].offsetTop : userHeaderContainer[0].scrollHeight));
                    tempTop = zoomTop ? tempTop : (topPosition * -1);
                }

                filterPanel.css({
                    top: tempTop,
                    height: tempHeight
                });
            }

            function getAvailablePageHeight() {
              var height = document.body.offsetHeight;

              if (isHierarchyDynaformActivated()) {
                height -= (getHierarchyBreadcrumbContainer().offsetHeight + 2);
              }

               if(_newLayoutWarningElem){
                height -= (_newLayoutWarningElem.clientHeight + 2);
              }

              return height;
            }

            function recalculateSizes() {
                adjustFilterSidenavPosition();
                adjustTopBarPosition();
                adjustDyanformContentWidthIE();
                if(_filterPanelInstace){
                    $timeout(() => {
                        resizeUserHeader(_filterPanelInstace.panelIsOpen());
                        resizeFooter(_filterPanelInstace.panelIsOpen());
                    })                    
                }
            }

            function adjustDyanformContentWidthIE() {
                if (UserAgentUtils.isIE()) {
                    var bodyWidth = dynaformTopbar.offsetWidth;
                    angular.element(dynaformStackContainer).css('width', (bodyWidth - 10) + 'px');
                }
            }

            function isBtnConfigEnabled() {
                return $scope.allowConfiguration && isActiveOnToolBarManager('useFormConfigger') && !$scope.suppressScreenConfig && !hasFormChanged();
            }

            function showBtnAddRecord() {
                if ($scope.isView || $scope.editUniqueRecord) {
                    return false;
                } else if (!isActiveOnToolBarManager('useNavigator') || !isActiveOnToolBarManager('useNavAddButton')) {
                    return false;
                } else {
                    return $scope.navigatorOptions.showAddButton;
                }
            }

            function isActiveOnToolBarManager(component) {
                var toolbarManager = _dynaformHelperData && _dynaformHelperData.toolBarManager;

                if (angular.isUndefined(toolbarManager)) {
                    return true;
                } else {
                    return toolbarManager[component];
                }
            }

            function isHierarchyDynaform() {
                return _isHierarchyDynaform;
            }

            function buildLayoutInfo(metadata, entitiesMetadata, fields, foreingKeyFields) {
                return $q(function (resolve) {
                    $q.when(customTabsLoader(getEntityName()))
                        .then(function (customTabs) {
                            resolve(doBuildLayoutInfo(metadata, entitiesMetadata, fields, foreingKeyFields, customTabs));
                        });
                });
            }

            function doBuildLayoutInfo(metadata, entitiesMetadata, fields, foreingKeyFields, customBlocks) {
                var tabs = [];
                var requiredTabByField = {};
                var orderMap = {};
                var hasConfig;
                var hasTabOrder;
                var hasFieldOrder;
                var invisibleFields = [];
                var lblGeral = SkI18nService.instant('Geral.lblGeral');
                var isConfigSavedInHtml5 = false;

                var dynaformConfig = reloadConfiguration();

                var mainTabInfo;

                hasConfig = dynaformConfig.hasConfig();
                hasTabOrder = dynaformConfig.hasTabOrder();
                hasFieldOrder = dynaformConfig.hasFieldOrder();
                isConfigSavedInHtml5 = dynaformConfig.configSavedInHtml5();

                _tabByField = {};
                _invisibleFieldsByName = {};
                _defaultValueByField = {};
                _fieldsToCleanOnCopy = {};

                var codeFieldNameOrder = {};

                var order = hasTabOrder ? (dynaformConfig.getMaxTabOrder() + 1) : 1;

                self.userAllowPersonalizedFilter = String(dynaformConfig.userAllowPersonalizedFilter());

                if (!_criteriaDefaultFilter) {
                    _criteriaDefaultFilter = new CriteriaProvider();

                    $scope.dataset.addCriteriaProvider(_criteriaDefaultFilter);
                }

                _criteriaDefaultFilter.getCriteria = function () {
                    return Criteria(_defaultFilter);
                };

                //Montamos as abas de campos
                for (var i = 0; i < fields.length; i++) {
                    var field = fields[i];

                    if (hasConfig && dynaformConfig.fieldHasConfig(field.name)) {
                    	var fieldConfig = dynaformConfig.getFieldConfig(field.name);
                    	
                    	if (fieldConfig.default) {
                            addFieldDefaultValue(field.name, fieldConfig.default.$);
                        } else {
                            removeFieldDefaultValue(field.name);
                        }
                    } else {
                        removeFieldDefaultValue(field.name);
                    }
                    
                    if (!dynaformAcceptField(field)) {
                        continue;
                    }

                    var isAForeingField = isForeingField(field.name, foreingKeyFields);

                    if (field.isDescriptionField || !field.visible || isAForeingField) {
                        if (field.isDescriptionField) {
                            if (codeFieldNameOrder[field.codeFieldName]) {
                                field.order += 1000;
                            }
                        }

                        if (_forceShowOnConfig.hasOwnProperty(field.name)) {
                            invisibleFields.push(field);
                            _invisibleFieldsByName[field.name] = field;
                        }

                        if (isAForeingField) {
                            field.visible = false;
                        }

                        continue;
                    }

                    var cleanOnCopy = field.cleanOnCopy;

                    if (hasConfig && dynaformConfig.fieldHasConfig(field.name)) {
                        dynaformConfig.addOriginalField(field);

                        var fieldConfig = dynaformConfig.getFieldConfig(field.name);

                        field.description = fieldConfig.userDescription || dynaformConfig.getOriginalField(field.name).description;

                        field.readOnly = (dynaformConfig.getOriginalField(field.name).readOnly == true || fieldConfig.userReadOnly == 'S');

                        field.required = (dynaformConfig.getOriginalField(field.name).required == true || fieldConfig.userRequired == 'S');

                        if (fieldConfig.hasOwnProperty('cleanOnCopy')) {
                            cleanOnCopy = fieldConfig.cleanOnCopy == 'S';
                        }
                    }

                    /* Validação similar à feita na função isReadOnly no dynaformconfig.controller */
                    if (isDetailDynaform() && field.isAutoNum) {
                        field.readOnly = true;
                    }

                    if (cleanOnCopy) {
                        _fieldsToCleanOnCopy[field.name] = true;
                    }

                    var tabName = dynaformConfig.getFieldTab(field.name);

                    if (_hiddenFieldsByProgrammer.hasOwnProperty(field.name) || (hasConfig && !tabName)) {
                        if (field.tabId && !canCreateTab(field.tabId, false)) {
                            continue;  
                        } else {
                            invisibleFields.push(field);
                            _invisibleFieldsByName[field.name] = field;
                            $scope.dataset.makeFieldNonRequired(field.name);
                            continue; //campo não escolhido;
                        }
                    } else if (!tabName) {
                        tabName = getFieldTabName(field.name);
                    }

                    if (field.required) {
                        $scope.dataset.makeFieldRequired(field.name);
                    } else {
                        $scope.dataset.makeFieldNonRequired(field.name);
                    }

                    var tabIsMain = false;
                    var tabId;

                    if (angular.isUndefined(tabName)) {
                        tabId = 'general';
                        tabName = lblGeral;
                    } else {
                        if (field.tabName === tabName) {
                            tabId = field.tabId;
                        } else {
                            tabId = tabName;
                        }
                    }

                    if (tabName == MAIN_TAB_NAME) {
                        tabIsMain = true;
                    }

                    if(!canCreateTab(tabName, false)) continue;

                    if (angular.isUndefined(orderMap[tabName])) {
                        var tabOrder = -1;

                        if (tabIsMain) {
                            tabOrder = 0;
                        } else if (hasTabOrder) {
                            if (angular.isDefined(dynaformConfig.getTabOrder(tabName))) {
                                tabOrder = dynaformConfig.getTabOrder(tabName) + 1;
                            }
                        }else if($attrs.hasOwnProperty('skTabOrderFunction')) {
                            tabOrder = $scope.tabOrderFunction({tabName: tabName});
                        }

                        if (tabOrder < 0) {
                          tabOrder = order++;
                        }

                        orderMap[tabName] = tabOrder;

                        tabs[tabOrder] = {
                            hasRequired: false,
                            enabled: true,
                            visible: !dynaformConfig.tabIsInvisible(tabName),
                            tabId: tabIsMain ? 'mainTab' : (tabId || StringUtils.nextUid()),
                            tabName: tabName,
                            fields: [field],
                            type: 'form'
                        };

                        if (tabIsMain) {
                           mainTabInfo = tabs[tabOrder];
                        }
                    } else {
                        tabs[orderMap[tabName]].fields.push(field);
                    }

                    if (field.required) {
                        requiredTabByField[field.name] = tabs[orderMap[tabName]];

                        if (!tabs[orderMap[tabName]].hasRequired) {
                            tabs[orderMap[tabName]].hasRequired = true;
                        }
                    }

                    if (hasFieldOrder) {
                        field.order = dynaformConfig.getFieldOrder(field.name);

                        if (!tabIsMain) {
                            field.order += 1000;

                            if (field.fk) {
                                codeFieldNameOrder[field.name] = true;
                            }
                        }
                    }
                }

                /*
                Nao podemos fazer essa alteracao devemos sempre respeitar a definicao feito na configuracao 
                OS:1487140, 1534397 
                Esse trecho copiava o campo da aba geral para a main quando existia somente um campo na geral
                for(var index in tabs){
                    if(tabs[index].tabName === lblGeral && tabs[index].fields.length == 1 && orderMap[MAIN_TAB_NAME] != undefined){
                        var indexMainTab = orderMap[MAIN_TAB_NAME];
                        tabs[indexMainTab].fields.push(tabs[index].fields[0]);
                        ArrayUtils.removeReference(tabs[index]);
                    }
                }
               */ 
                
                var foreignKeysByName = {};

                for (var i = 0; i < foreingKeyFields.length; i++) {
                    var fk = foreingKeyFields[i];

                    foreignKeysByName[fk.localField] = undefined;
                }

                angular.forEach(tabs, function (tab) {
                    if (hasFieldOrder) {
                        tab.fields.sort(function (fA, fB) {
                            return fA.order - fB.order;
                        });
                    }

                    if (!tab.visible) {
                        return;
                    }

                    tab.formFields = FormService.buildPropertiesFromMD(tab.fields, function (fieldMD) {
                        var fieldProp = {
                            'sk-dataset': $scope.dataset,
                            'entityLinkCriteriaBuilder': function (entityName, fieldName) {
                                var fieldMd = $scope.dataset.getFieldMetadata(fieldName);

                                if (fieldMd && fieldMd.fk) {
                                    return DatasetUtils.buildDependentFieldsCriteria(fieldMd.fk.dependentFields, $scope.dataset);
                                }
                            },
                            'avoid-copying-record': false
                        };

    					if(_fieldsToCleanOnCopy.hasOwnProperty(fieldMD.name)){
    						fieldProp['avoid-copying-record'] = true;
    					}

                        if (fieldMD.name === $scope.autoNumField) { 
                        	 var isAutoNum = $scope.autoNum ? StringUtils.toBoolean($scope.autoNum.isAutoNum) : undefined;
                             /**
                              * Se o campo auto numérico for readOnly e a numeração estiver como manual setamos como false para habilitar a edição.
                              */

                             if(fieldMD.readOnly == true && isAutoNum == false){
                            	 fieldMD.required = true;
                             } else if ($scope.autoNum !== undefined) {
                                 fieldMD.required = !isAutoNum;
                                 fieldProp['sk-disable-on-insertion'] = verifyAutoNumHierarchy(fieldMD, isAutoNum);

                                 $scope.dataset[fieldMD.required ? 'makeFieldRequired' : 'makeFieldNonRequired'](fieldMD.name);
                             } else {
                                fieldProp['sk-disable-on-insertion'] = verifyAutoNumHierarchy(fieldMD, true);
                            }
                        }


                        return fieldProp;
                    }, function (fieldMD) {
                        var accept = !foreignKeysByName.hasOwnProperty(fieldMD.name);

                        if (accept) {
                            if ($scope.dynaformInterceptor) {
                                var visible = $scope.dynaformInterceptor.acceptField(fieldMD, self, $scope.dataset);
                                //fieldMD.visible = visible;
                                _unAcceptFields[fieldMD.name] = visible;
                                return visible;
                            } else if ($scope.formInterceptor) {
                                var visible = $scope.formInterceptor.acceptField(fieldMD, $scope.dataset);
                                //fieldMD.visible = visible;
                                _unAcceptFields[fieldMD.name] = visible;
                                return visible;
                            }
                        }
                        _unAcceptFields[fieldMD.name] = accept;
                        fieldMD.visible = accept;
                        return accept;
                    },
                    _sortFields// Habilita ou nao a reordeanacao dos campos
                    , function (fieldProperty) {
                        if ($scope.dynaformInterceptor) {
                            $scope.dynaformInterceptor.interceptFieldMetadata(fieldProperty, $scope.dataset, self);
                        }
                    });

                    tab.fields.forEach(function (field) {
                        _tabByField[field.name] = {
                            tabInfo: tab,
                            fieldMD: field
                        };

                        var listeners = _fieldLoadedListeners[field.name];

                        if (listeners) {
                            angular.forEach(listeners, function (listener) {
                                listener && listener();
                            });
                        }
                    });
                });

                //Montamos as abas de relacionamento
                if (metadata.oneToManyRelations) {
                    var baseEntityMD = entitiesMetadata[$scope.entityName];
                    var oneToManyRelationsInfos = baseEntityMD.relations
                        .filter(function (relation) {
                            if (_dynaformHelperData && _dynaformHelperData.invisibleOneToManyRelations) {
                                if (_dynaformHelperData.invisibleOneToManyRelations.indexOf(relation.toEntity) > -1) {
                                    return false;
                                }
                            }

                            return relation.type == '1-N';
                        });

                    angular.forEach(metadata.oneToManyRelations, function (entityMD, entityName) {
                        var relation;

                        for (var i = 0; i < oneToManyRelationsInfos.length; i++) {
                            if (oneToManyRelationsInfos[i].toEntity == entityName) {
                                relation = oneToManyRelationsInfos[i];
                            }
                        }

                        if (relation) {
                            var showOnUi = true;
                            var showFilter = false;

                            if (ArrayUtils.isIn(_dynaformInvisibleReferences, relation.toEntity)) {
                                showOnUi = false;
                            }

                            if (showOnUi) {
                                for (var i = 0; i < relation.properties.length; i++) {
                                    var prop = relation.properties[i];

                                    if (prop.name == 'show-on-ui') {
                                        showOnUi = prop.value == 'true';

                                        if (!showOnUi) {
                                            break;
                                        }
                                    } else if (prop.name === 'allowpersonalizedfilter') {
                                        showFilter = StringUtils.toBoolean(prop.value);
                                    }
                                }
                            }

                            //Forca quais referencias devem ser apresentadas no dynaform, se nao constar no array nao apresenta
                            if (angular.isArray(_dynaformVisibleReferences)) {
                                showOnUi = ArrayUtils.isIn(_dynaformVisibleReferences, relation.toEntity);
                            } 
                            
                            var tabName = relation.description || entityMD.description;

                            if (showOnUi && canCreateTab(tabName, false)) {
                                var tabOrder;

                                if (hasTabOrder) {
                                    tabOrder = angular.isDefined(dynaformConfig.getTabOrder(tabName)) ? (dynaformConfig.getTabOrder(tabName) + 1) : order++;
                                } else if ($attrs.hasOwnProperty('skTabOrderFunction')){
                                    tabOrder = $scope.tabOrderFunction({tabName: tabName});
                                    if(tabOrder < 0){
                                        tabOrder = order++;
                                    }
                                }else{
                                    tabOrder = order++;
                                }

                                orderMap[tabName] = tabOrder;

                                var relationInfo = angular.copy(relation);
                                relationInfo.properties = {};

                                relation.properties.forEach(function (prop) {
                                    relationInfo.properties[prop.name] = prop.value;
                                });

                                tabs[tabOrder] = {
                                    hasRequired: false,
                                    enabled: true,
                                    visible: !dynaformConfig.tabIsInvisible(tabName),
                                    tabId: 'entity_' + entityName,
                                    tabName: tabName,
                                    entityName: entityName,
                                    type: 'dynaform',
                                    showFilter: showFilter,
                                    relationInfo: relationInfo
                                };

                                tabs[tabOrder].isLazyLoad = angular.isFunction($scope.isLazyLoad) ? $scope.isLazyLoad({tabInfo: angular.copy(tabs[tabOrder])}) : true;
                                tabs[tabOrder].isLazyLoad = tabs[tabOrder].isLazyLoad == undefined ? true : tabs[tabOrder].isLazyLoad;
                               
                                if(!tabs[tabOrder].isLazyLoad){
                                    createDynaformTabIfNotExists(tabs[tabOrder], tabOrder-1);
                                }
                            }
                        }
                    });
                }

                if (customBlocks) {
                    var tabsToReorder = {};

                    customBlocks.forEach(function (customBlock) {
                        processDefaultBlocks(customBlock);

                        var blockId = customBlock.blockId;
                        var blockDescription = customBlock.description;
                        var templateUrl = customBlock.templateUrl;
                        var templateStr = customBlock.template;

                        if (!blockId) {
                            throw new MessageError(undefined, 'Bloco customizado deve possuir blockId');
                        }

                        if (!templateUrl && !templateStr) {
                            throw new MessageError(undefined, 'Bloco customizado deve possuir deve possuir templateUrl ou template. [' + blockId + ']');
                        }

                        if (!blockDescription) {
                            throw new MessageError(undefined, 'Bloco customizado deve possuir deve possuir uma descrição. [' + blockId + ']');
                        }

                        var tabOrder;
                        var tabName = dynaformConfig.getFieldTab(blockId);
                        var fieldConfig = dynaformConfig.getFieldConfig(blockId);

                        if (fieldConfig && fieldConfig.userDescription) {
                            customBlock.description = blockDescription = fieldConfig.userDescription;
                        }

                        var includeBlock = hasConfig ? angular.isDefined(tabName) : true;

                        if (!tabName) {
                            tabName = blockDescription;
                        }

                        if(!canCreateTab(tabName, true)) return;
                        var tabAlias = tabName+"_"+blockId;
                        if (angular.isUndefined(orderMap[tabAlias])) {
                            if (hasTabOrder) {
                                tabOrder = angular.isDefined(dynaformConfig.getTabOrder(tabName)) ? (dynaformConfig.getTabOrder(tabName) + 1) : order++;
                            } else if($attrs.hasOwnProperty('skTabOrderFunction')) {
                                tabOrder = $scope.tabOrderFunction({tabName: tabName});
                                if(tabOrder < 0){
                                    tabOrder = order++;
                                }
                            }else{
                                tabOrder = order++;
                            }

                            orderMap[tabAlias] = tabOrder;

                            let isVisible = true;
                            if(dynaformConfig.tabIsInvisible(tabName) || (hasTabOrder && angular.isDefined(dynaformConfig.getTabOrder(tabName)) == false)){
                                isVisible = false;
                            }

                            tabs[tabOrder] = {
                                customBlockTab: true,
                                blockId: blockId,
                                hasRequired: false,
                                enabled: true,
                                visible: isVisible,
                                tabId: blockId,
                                tabName: tabName,
                                type: 'form',
                                grayTabNav: customBlock.grayTabNav || ArrayUtils.isIn(['DynaformRelationBlock', 'CustomRelationBlock'], customBlock.type),
                                fields: [],
                                formFields: [],
                                isLazyLoad: customBlock.isLazyLoad != undefined ? customBlock.isLazyLoad : true
                            };
                        } else {
                            tabOrder = orderMap[tabAlias];
                        }

                        var tabInfo = tabs[tabOrder];

                        var blockInfo = {
                            name: blockId,
                            userType: 'customBlock',
                            description: blockDescription,
                            visible: angular.isDefined(customBlock.visible) ? customBlock.visible : true,
                            tabInfo: tabInfo
                        };

                        angular.extend(blockInfo, customBlock);

                        var eventBus = ObjectUtils.getProperty(blockInfo, 'properties.eventBus');
                        if (!eventBus) {
                            eventBus = new EventBus();
                            ObjectUtils.setProperty(blockInfo, 'properties.eventBus', eventBus);
                        }

                        ObjectUtils.setProperty(blockInfo, 'properties.dataset', $scope.dataset);
                        ObjectUtils.setProperty(blockInfo, 'properties.dynaform', self);

                        if (includeBlock && hasFieldOrder) {
                            blockInfo.order = dynaformConfig.getFieldOrder(blockId) + 1000;

                            if (!tabInfo.customBlockTab) {
                                tabsToReorder[tabInfo.tabId] = tabInfo;
                            }
                        }

                        if(!includeBlock && angular.isDefined(tabName) == undefined){
                            includeBlock = (tabInfo.blockId === blockInfo.blockId) ? true : includeBlock;
                        }
                        /**
                            OS: 1507906 / 1531593 - No html o custom block é considerado como um campo (e uma aba criada dinamicamente, quando necessario)
                            porem, no flex, esse tipo de configuracao nao existe, fazendo com que alguns custom blocks que estao configurados como
                            aba no flex, nao sejam apresentados no html5, para tratar esse caso, temos que considerar a configuracao de tab order
                            do flex, quando nao houver configuracao especifica para o customblock do html5.
                        */
                        else if(!includeBlock && hasTabOrder && orderMap.hasOwnProperty(tabAlias) && tabInfo.visible && !isConfigSavedInHtml5) {
                            includeBlock = true;
                        }

                        if (includeBlock) {
                        	if (!angular.isDefined(tabInfo.formFields)) {
                            	tabInfo.formFields = [];
                            }
                            if (!angular.isDefined(tabInfo.fields)) {
                            	tabInfo.fields = [];
                            }
                            tabInfo.formFields.push(blockInfo);
                            tabInfo.fields.push(blockInfo);
                            var fieldCustomBlock = fieldRequiredCustomBlock(blockInfo, tabInfo);
                            if(fieldCustomBlock){
                                requiredTabByField[fieldCustomBlock.name] = tabInfo; 
                                tabInfo.hasRequired = true;
                            }
                        } else {
                            invisibleFields.push(blockInfo)
                        }

                        _customBlocks[blockId] = blockInfo;
                    });

                    angular.forEach(tabsToReorder, function (tab) {
                        tab.fields.sort(function (fA, fB) {
                            return fA.order - fB.order;
                        });

                        tab.formFields.sort(function (fA, fB) {
                            return fA.order - fB.order;
                        });
                    });
                }

                var adjustedTabs = [];

                tabs.forEach(function (tab) {
                    if (tab) {
                        if (tab.type === 'form' && tab.fields.length === 0) {
                            //continue;
                        } else {
                            //tab.tabName = decodeURIComponent((escape(tab.tabName)));
                            adjustedTabs.push(tab);
                        }
                    }
                });

                if (!hasTabOrder) {//Se não temos ordenação do usuário,
                    // podemos ordenar pelo padrão que o programador desejou.
                    if (_customTabOrderConfig) {
                        var newTabs = reorderTabsByConfig(adjustedTabs);

                        if (newTabs.length == adjustedTabs.length) {
                            adjustedTabs = newTabs;
                        }
                    } else if (_tabOrder) {
                        adjustedTabs = reorderTabsByTabOrder(adjustedTabs);
                    }
                }

                return {
                    mainTabInfo: mainTabInfo,
                    tabsInfo: adjustedTabs,
                    allFields: fields,
                    invisibleFields: invisibleFields,
                    requiredTabByField: requiredTabByField
                };
            }

            function isForeingField(fieldName, foreingKeyFields) {
                if (angular.isArray(foreingKeyFields)) {
                    for (var i = 0, len = foreingKeyFields.length; i < len; i++) {
                        if (foreingKeyFields[i].localField == fieldName) {
                            return true;
                        }
                    }
                    return false;
                }
            }

            function selectBlockTab(blockId) {
                if (_metadataReady) {
                    if (_customBlocks[blockId]) {
                        var blockInfo = _customBlocks[blockId];
                        var tabInfo = blockInfo.tabInfo;

                        if (tabInfo) {
                            doSelectTab(tabInfo);
                        }
                    }
                } else {
                    throw Error('Não é possível selecionar o bloco pois os metadados não foram inicializados.');
                }
            }

            function selectTabByLabel(label) {
                if (_metadataReady) {
                    var labelArr = ArrayUtils.toArray(label);

                    var tabInfo = ArrayUtils.find($scope.tabsInfo, function (tab) {
                        return ArrayUtils.isIn(labelArr, tab.tabName);
                    });

                    if (tabInfo) {
                        selectTab(tabInfo);
                    }
                } else {
                    throw Error('Não é possível selecionar a aba pois os metadados não foram inicializados.');
                }
            }

            function changeBlockEnabled(blockID, enabled) {
                var blockList = [];

                if (blockID == '*') {
                    angular.forEach(_customBlocks, function (blockInfo) {
                        blockList.push(blockInfo);
                    });
                } else {
                    var ids = ArrayUtils.toArray(blockID);

                    ids.forEach(function (id) {
                        if (_customBlocks[id]) {
                            blockList.push(_customBlocks[id]);
                        }
                    });
                }

                blockList.forEach(function (blockInfo) {
                    blockInfo.enabled = enabled;

                    var tabInfo = blockInfo.tabInfo;

                    if (tabInfo.customBlockTab && tabInfo.fields.length == 1) {
                        tabInfo.enabled = enabled;
                    }
                });
            }

            function changeBlockVisibility(blockID, visible) {
                var blockInfo = _customBlocks[blockID];

                if (!blockInfo) {
                    return;
                }

                if (blockInfo.visible === visible) {
                    return;
                }

                blockInfo.visible = visible;

                var tabInfo = blockInfo.tabInfo;

                //Se existir apenas o bloco na aba, setamos a config. de visibilidade na aba toda
                if (tabInfo.customBlockTab && tabInfo.fields.length == 1) {
                    var dynaformConfig = getDynaformConfig();
                    tabInfo.visible = visible ? !dynaformConfig.tabIsInvisible(tabInfo.tabName) : false;
                    tabInfo.hidden = !tabInfo.visible;

                    refreshTabsInfo();
                }
            }

            function processDefaultBlocks(customBlock) {
                if (customBlock.type == 'DynaformRelationBlock') {
                    var properties = customBlock.properties;

                    if (!properties) {
                        throw new MessageError(undefined, 'Bloco customizado do tipo DynaformRelation deve possuir um objeto de propriedades. [' + customBlock.blockId + ']');
                    }

                    if (!properties.entityName) {
                        throw new MessageError(undefined, 'Bloco customizado do tipo DynaformRelation deve possuir entityName em suas propriedades. [' + customBlock.blockId + ']');
                    }

                    if (!properties.dynaform) {
                        properties.dynaform = self;
                    }

                    customBlock.templateUrl = 'components/dynaform/defaultblocks/relation/dynaformRelationBlock.tpl.html';
                    customBlock.controller = 'DynaformRelationBlockController';
                    customBlock.controllerAs = 'ctrl';
                } else if (customBlock.type == 'CustomRelationBlock') {
                    var properties = customBlock.properties;

                    if (!properties) {
                        throw new MessageError(undefined, 'Bloco customizado do tipo CustomRelationBlock deve possuir um objeto de propriedades. [' + customBlock.blockId + ']');
                    }

                    if (!properties.entityName) {
                        throw new MessageError(undefined, 'Bloco customizado do tipo CustomRelation deve possuir entityName em suas propriedades. [' + customBlock.blockId + ']');
                    }

                    customBlock.templateUrl = 'components/dynaform/defaultblocks/customrelation/customrelationblock.tpl.html';
                    customBlock.controller = 'SkCustomRelationBlockController'
                }
            }

            function setScrollToSelectedRow() {
                if ($scope.dataset && $scope.datagrid && !$scope.dataset.isInsertionMode()) {
                    const gridOptions = $scope.datagrid.getGridOptions();
                    gridOptions.api.clearFocusedCell();
                    gridOptions.api.clearRangeSelection();

                    const currentIndex = $scope.dataset.getCurrentIndex();
                    $scope.datagrid.selectNodeByIndex(currentIndex, true);

                    $scope.dataset.setSelectedRecords([$scope.dataset.getCurrentRow()]);
                    $scope.datagrid.syncSelectOnDataset(true);

                    $timeout(function() {
                        $scope.datagrid.setNextFocusCell();
                    });
                }
            }

            function goToGridView() {
                var deferred = $q.defer();
                $scope.viewMode = 'grid';
                $scope.iconChangeFace = 'list';
                $scope.showNavigatorAddButton = true;

                createGrid(true).then(function(){
                    deferred.resolve();
                    if ($scope.gridController) {
                        $scope.gridController.setFocus();
                        $timeout(setScrollToSelectedRow);
                    }
                });

                return deferred.promise;
            }

            function resolveFocus(changingTab) {
                if ($scope.viewMode == 'form') {
                    var currentTab = (!changingTab && $scope.mainTabInfo) || $scope.tabsInfo[$scope.tabSelectedIndex];

                    if (currentTab == undefined || $scope.dataset.isRecordDirty()) { 
                    	return;
                    }

                    if (currentTab.type == 'form' && currentTab.enabled) {
                        var formElem = getFormElement(currentTab.tabName == MAIN_TAB_NAME ? -1 : $scope.tabSelectedIndex);
                        var autoFocusInput;
                        var controller;

                        if (formElem && formElem[0]) {
                            autoFocusInput = formElem[0].querySelector('[autofocus]');
                        }

                        if (autoFocusInput) {
                            controller = AngularUtil.getControllerFromElement(autoFocusInput);
                        }

                        AngularUtil.timeout(function () {
                            if (controller && controller.setFocus) {
                                controller.setFocus();
                            } else {
                                angular.element(autoFocusInput).focus();
                            }
                        });
                    } else {
                        //var childDynaformElem = getChildDynaformElement($scope.tabSelectedIndex);
                        //var childDynaformCtrl = angular.element(childDynaformElem).data('$skDynaformController');
                        //childDynaformCtrl.resolveFocus();
                    }
                } else {
                    whenReadyDatagridElement.whenReady()
                        .then(function () {
                            AngularUtil.timeout(function () {
                                var dgFocus = datagridElement[0].querySelector('.ui-grid-viewport');
                                angular.element(dgFocus).focus();
                            });
                        });
                }
            }

            function changeFaceKeyHandler(params, evt) {
                if((params.target && params.target === document.body) || AngularUtil.checkHandleThisEvent($element, params.target)) {
                    evt.preventDefault();
                    changeViewMode();
                }
            }

            function getTabsInfo() {
                return ArrayUtils.copy($scope.allTabsInfo, false);
            }

            function nextTabHandler(e) {
                if (AngularUtil.checkHandleThisEvent($element, e.target)) {
                    var tabsSize = $scope.tabsInfo.length;

                    if (tabsSize <= 1) {
                        return;
                    }

                    var currentTab = $scope.tabSelectedIndex;
                    var newTab;

                    if (currentTab == (tabsSize - 1)) {
                        newTab = $scope.tabsInfo[0];
                    } else {
                        newTab = $scope.tabsInfo[$scope.tabSelectedIndex + 1];
                    }

                    selectTab(newTab, undefined, true);
                }
            }

            function previousTabHandler(e) {
                if (AngularUtil.checkHandleThisEvent($element, e.target)) {
                    var tabsSize = $scope.tabsInfo.length;

                    if (tabsSize <= 1) {
                        return;
                    }

                    var currentTab = $scope.tabSelectedIndex;
                    var newTab;

                    if (currentTab == 0) {
                        newTab = $scope.tabsInfo[(tabsSize - 1)];
                    } else {
                        newTab = $scope.tabsInfo[$scope.tabSelectedIndex - 1];
                    }

                    selectTab(newTab, undefined, true);
                }
            }

            function changeViewMode() {
                if ($scope.gridController) {
                    $scope.gridController.endEdit();
                    $scope.gridController.refreshLayout();
                }
                var defer = $q.defer();

                showDyanformView()
                    .then(function () {
                        if ($scope.viewMode == 'form') {
                            goToGridView().then(defer.resolve);
                        } else {
                            goToFormView();
                            defer.resolve();
                        }

                        $scope.$root.$broadcast(DynaformConstants.EVENT_VIEW_MODE_CHANGED, $scope.viewMode);
                        $scope.$broadcast('datagridRecalculate');
                    });

                defer.promise.then(resolveFocus);

                return defer.promise;
            }

            function showDyanformView(avoidShowDynaform) {
                var dynaformLoadedPromise = $q.defer();

                var doShowDynaform = function () {
                    if ($scope.view === 'start' || $scope.view === 'loading') {
                        //Carrega os filtros do dynaform master, pois ele pode ser modificado tanto no dynaform, quanto no entityStartPage
                        SkComponentRegistry.get($scope.personalizedFilterId).then(function (instance) {
                            instance.loadFilters();
                        });
                    }

                    if (!avoidShowDynaform) {
                        $scope.view = 'dynaform';

                        if ($scope.tabSelectedIndex === -1) {
                            $scope.tabSelectedIndex = 0;
                        }

                        $scope.$root.$emit(TabNavigatorConstants.EVENT_UPDATE_PAGINATION);

                        AngularUtil.timeout(function () {
                          recalculateSizes();
                        });
                    }

                    if (!_initialized) {
                        //Necessário por termos que esperar o próximo ciclo, onde a promise acima já foi resolvida
                        AngularUtil.timeout(function () {
                            _whenDatasetReady.whenReady()
                                .then(function () {
                                    $scope.dataset.whenMetadataLoaded().then(function () {
                                        $scope.dataset.isLoadingByPk = _loadingByPK;
                                        dynaformLoadedPromise.resolve();
                                    });
                                });

                            _initialized = true;
                        });
                    } else {
                        dynaformLoadedPromise.resolve();
                    }
                };

                if (_metadataReady) {
                    doShowDynaform();
                } else {
                    $scope.view = 'loading';

                    var deRegister = $scope.$on(DynaformConstants.EVENT_METADATA_UPDATED, function () {
                        doShowDynaform();
                        deRegister();
                    });
                }

                return dynaformLoadedPromise.promise;
            }

            function getEntityCardProps() {
                return $scope.entityCardProps;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#whenLoaded
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Retorna uma promessa de quando os metadados do dynaform estiverem prontos.
             * @return {Promise} Promessa de metadados atualizados
             */
            function whenLoaded() {
                var deferred = $q.defer();

                if (_metadataReady) {
                    deferred.resolve();
                } else {
                    var deRegister = $scope.$on(DynaformConstants.EVENT_METADATA_UPDATED, function () {
                        deferred.resolve();

                        deRegister();
                    });
                }

                return deferred.promise;
            }

            function onHierarchyPathItemClick(item) {
                if (item && item.identifier) {
                    _flatTreeInstance.openLevelByIdentifier(item.identifier, true);
                } else {
                    _flatTreeInstance.goToRoot();
                }
            }

            function onTreeCreated($component) {
                _treeInstance = $component;
                ArrayUtils.callEachFunctionWith(_treeCreatedListeners, _treeInstance);
            }

            function onFlatTreeCreated($component) {
                _flatTreeInstance = $component;

                _flatTreeInstance.addSelectionChangeListener(function (event) {
                    var hierarchyPath = _flatTreeInstance.getHierarchyPath();

                    if (hierarchyPath) {
                        var arrSize = hierarchyPath.length;
                        hierarchyPath = hierarchyPath.map(function (item, index) {
                            return {
                                identifier: item.identifier,
                                label: item.maskedIdentifier + ' - ' + item.description,
                                active: index == (arrSize - 1)
                            };
                        });

                        if (hierarchyPath.length > 0) {
                            hierarchyPath.unshift({
                                identifier: undefined,
                                icon: 'home',
                                tooltip: 'Início'
                            })
                        }
                    }

                    $scope.currentHierarchyPath = hierarchyPath;
                });

                if (UserAgentUtils.isMobile()) {
                    _flatTreeInstance.addItemClickListener(function (item) {
                    if (!item.children) {
                      closeSidenav();
                    }
                  });
                }

                if(_treeInstance){
                    _flatTreeInstance.setHierarchyConfig(_treeInstance.getHierarchyConfig());
                    _treeInstance = undefined;
                }

                ArrayUtils.callEachFunctionWith(_treeCreatedListeners, _flatTreeInstance);
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#newRecord
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Inicia uma inclusão no dynaform
             */
            function newRecord() {
                $scope.showNavigatorAddButton = false;
                $scope.dataset.goToInsertionMode();

                var tabInfo = $scope.tabsInfo[0];

                if (tabInfo && tabInfo.type == 'dynaform') {
                    for (var i = 1, len = $scope.tabsInfo.length; i < len; i++) {
                        tabInfo = $scope.tabsInfo[i];

                        if (tabInfo.type == 'form') {
                            break;
                        }
                    }
                }

                if (tabInfo) {
                    doSelectTab($scope.tabsInfo[0], function () {
                        //AngularUtil.timeout(resolveFocus);
                    }, true);
                }
            }

            function showTabRequiredIcon(tabInfo) {
                if (tabInfo.hasRequired && $scope.dataset) {
                    var insertionMode = $scope.dataset.isInsertionMode();
                    var dirty = $scope.dataset.isRecordDirty();
                    var multiEdit = $scope.dataset.isMultiRecordEditMode();

                    var clean = !(dirty || insertionMode || multiEdit);

                    if (!clean) {
                        return tabInfo.hasRequiredFieldUndefined;
                    }
                }

                return false;
            }

            function showTabCustomIcon(tabInfo) {
                if (tabInfo.customBlockTab) {
                    return false;
                }

                if (tabInfo.type == "dynaform" && tabInfo.entityName && !$scope.entityName.startsWith("AD_")) {
                  return tabInfo.entityName.startsWith("AD_");
                }

                return false;
            }

            function showEntityCard() {
                var showEntityCard = !($scope.skHideEntityCard === true) && $scope.entityCardProps && $scope.dataset.getCurrentRow() && !($scope.dataset.isInsertionMode() || $scope.dataset.isMultiRecordEditMode());

                if (showEntityCard != _lastShowEntityCard) {
                    _lastShowEntityCard = showEntityCard;
                }

                return showEntityCard;
            }

            function pesqFieldSelect(item, highlightKind) {
                loadTabAndHighlightField(item.tabInfo, item.fieldName);
            }

            function loadTabAndHighlightField(tabInfo, fieldName, highlightKind) {
                //Não fazemos highlight em campos invisíveis pois eles podem não estar registrados no formulário
                /*if(!isFieldVisible(fieldName, tabInfo)) {
                    return;
                }*/
                goToFormView();

                //FIXME: COLOCAR TIMEOUT DE 500MS APENAS QUANDO FOR MOBILE
                var timeout = 0;
                $scope.dropdownConfig.isOpen = false;

                var afterSelectTab = function () {
                    AngularUtil.timeout(function () {
                        loadTabFormController(tabInfo);
                        highlightFields(tabInfo, highlightKind || FormHighlithKind.SEARCH, fieldName);
                    }, timeout);
                };

                if (tabInfo.tabName == MAIN_TAB_NAME) {
                    afterSelectTab();
                } else {
                    doSelectTab(tabInfo, afterSelectTab, true);
                }
            }

            function loadTabFormController(tabInfo) {
                if (!tabInfo.formController) {
                    var tabIndex = $scope.tabsInfo.indexOf(tabInfo);
                    var tabElem = getFormElement(tabIndex);
                    var formController = tabElem.data('$skFormController');

                    if (!formController) {
                        throw new Error('Não foi possível resolver o controlador do formulário da aba ' + tabInfo.tabName);
                    }

                    tabInfo.formController = formController;
                }
            }

            function pesqEntitySelect(item) {
                var pk = [{
                    name: item.pkField,
                    value: item.key
                }];

                if (item.otherEntityPks) {
                    item.otherEntityPks.forEach(function (pkName) {
                        pk.push({
                            name: pkName,
                            value: item.data[pkName]
                        });
                    });
                }

                refreshDatasetByPk(pk);

                self.entitySearch = '';

                goToFormView();

                closeSidenav();
            }

            function getFormElement(tabIndex) {
                if (angular.isUndefined(tabIndex) || tabIndex < 0) {//mainTab
                    return angular.element(dynaformContent).find('sk-form');
                } else {
                    return angular.element(ObjectUtils.getProperty(dynaformViewstack, 'children.' + tabIndex + '.children.0')).find('sk-form');
                }
            }

            function getChildDynaformElement(tabIndex) {
                return angular.element(dynaformViewstack.children[tabIndex].children[0]).find('sk-dynaform');
            }

            function doSelectTab(tabInfo, creationCallback, scrollToTab) {

                //Se a info é uma string, consideramos como o ID
                if(angular.isString(tabInfo)){
                    let tabId = tabInfo;

                    tabInfo = $scope.allTabsInfo.find((tabInfo) => tabInfo.tabId == tabId);

                    if(!tabInfo){
                        console.warn('[SkDynaformController.doSelectTab] tab ' + tabId + ' não encontrada.');
                        return;
                    }
                }

                if ($scope.tabSelectedIndex > -1) { //Se temos uma aba selecionada
                    var currentTab = $scope.tabsInfo[$scope.tabSelectedIndex];

                    if (currentTab == tabInfo == $scope.tabSelected) {
                        if (creationCallback) {
                            creationCallback();
                        }

                        return;
                    }

                    if (currentTab) { //Salvamos a posição de scroll dela
                        tabScrollPosition[currentTab.tabId] = _dynaformScrollContainer.scrollTop();
                    }
                }

                $scope.tabSelectedIndex = $scope.tabsInfo.indexOf(tabInfo);
                $scope.tabSelected = tabInfo;

                if (angular.isFunction($scope.selectedTabNavigator)) {
                    $scope.selectedTabNavigator({tabInfo : tabInfo});
                }

                createDynaformTabIfNotExists(tabInfo)
                    .then(function () {
                        if (creationCallback) {
                            creationCallback();
                        }

                        resolveFocus(true);
                    });

                AngularUtil.timeout(function () {
                    var newScrollPosition = tabScrollPosition[tabInfo.tabId] || 0; //Se temos uma posição desta aba, usamos ela
                    DomUtil.scrollTo(_dynaformScrollContainer, newScrollPosition, notifyFixedBarToReset, 100);

                    if (scrollToTab === true) {
                        if ($scope.tabSelectedIndex + 1 > $scope.tabsLimit) {
                            $scope.tabsCollapsePanel = false;
                        }

                        var tabsElem = getDynaformTabsElem();

                        if (tabsElem) {
                            var selectedTab = tabsElem.querySelector('.tab-item.active');
                            scrollTabViewTo(selectedTab);
                        }
                    }
                });
            }

            function scrollTabViewTo(tabElement) {
                AngularUtil.timeout(function () {
                    var selectedTabPosition = PositionUtils.position(tabElement);
                    var tabTop = selectedTabPosition.top;
                    var tabBottom = (selectedTabPosition.height + tabTop);

                    var dynaformTabsElem = getDynaformTabsElem();

                    if (dynaformTabsElem) {
                        if (tabBottom > getDynaformTabsElem().offsetHeight) {
                            var diff = tabBottom - getDynaformTabsElem().offsetHeight;

                            DomUtil.scrollTo(dynaformTabsElem, dynaformTabsElem.scrollTop + diff);
                        } else if (tabTop < getDynaformTabsElem().scrollTop) {
                            DomUtil.scrollTo(dynaformTabsElem, tabTop);
                        }
                    }
                });
            }

            function onSelectNewEntityOnStartPage() {
                showDyanformView().then(function () {
                    newRecord();
                    closeSidenav();
                });
            }

            function onApplyFilterOnStartPage(criteria) {
                showDyanformView().then(function () {
                    goToGridView();
                    $scope.dataset.refresh(criteria);
                });
            }

            function onSelectEntityOnStartPage(entity, data, currentQuery) {
                showDyanformView().then(function () {
                    let pk = {};

                    if (entity.allPks) {
                        entity.allPks.forEach(function (pkName) {
                            pk[pkName] = data[pkName];
                        });
                    }

                    let pks = [];

                    if(entity.allPks){
                        entity.allPks.forEach(function (pkName) {
                            pks.push({
                                name: pkName,
                                value: data[pkName]
                            });
                        });
                    }

                    refreshDatasetByPk(pks);

                    goToFormView();
                    closeSidenav();
                });
            }

            function insertHierarchyDynaformCommentOnCriteria(criteria) {
                if (criteria && isHierarchyDynaformActivated() && criteria.getSize() > 0) {
                    //No caso o hierarquico, devemos forçar essa string para que o CRUDListener dele entre em ação.
                    criteria.append(' /*HAS_PERSONALIZED_FILTER*/ ');
                }
            }

            function onShowAllActionOnStartPage(currentQuery) {
                onSelectShowGridOnStartPage(currentQuery, { isShowAllAction: true });
            }

            function onSelectShowGridOnStartPage(currentQuery, options) {
                if (SkTourService.isOnTour() || !_mostraAvisoPaginaInicial || $scope.hasSomeActiveFilter.value || !$scope.loadOnInitialize) {
                    doOnSelectShowGridOnStartPage(currentQuery, options);
                } else if (angular.isFunction(_hasSomeDynamicFilterData)) {
                    _hasSomeDynamicFilterData().then(function (hasDynamicFilterData) {
                        if (hasDynamicFilterData) {
                            doOnSelectShowGridOnStartPage(currentQuery, options);
                        } else {
                            showMessageLoadAllSlow()
                                .then(function () {
                                    $scope.view = 'dynaform';
                                    goToGridView();
                                }, function (reason) {
                                    if (reason == 'no') {
                                        doOnSelectShowGridOnStartPage(currentQuery, options);
                                    }
                                }
                            );
                        }
                    });
                } else {
                	if (StringUtils.isNotEmpty(currentQuery)) {
                		doOnSelectShowGridOnStartPage(currentQuery, options);
                	} else {
	                    showMessageLoadAllSlow().then(function () {
	                        SkComponentRegistry.get($scope.personalizedFilterId).then(function (instance) {
	                            instance.openFilter();
	                        });
	                    }, function (reason) {
	                        if (reason == 'no') {
	                            doOnSelectShowGridOnStartPage(currentQuery, options);
	                        }
	                    });
                	}
                }
            }

          function onSelectHierarchyOnStartPage(currentQuery) {
            showDyanformView()
                .then(function () {
                  goToFormView();
                  $scope.dataset.whenMetadataLoaded().then($scope.dataset.refresh);
                });
          }

            function showMessageLoadAllSlow() {
                return  MessageUtils.confirm(
                    MessageUtils.TITLE_CONFIRMATION,
                    SkI18nService.instant('Dynaform.msgLoadLow'),
                    SkI18nService.instant('Dynaform.btnVerifFiltros'),
                    SkI18nService.instant('Dynaform.btnCarregarTudo'),
                    true
                );
            }

            function doOnSelectShowGridOnStartPage(currentQuery, options) {
                showDyanformView(true).then(function () {
                    $scope.view = 'loading';

                    if (StringUtils.isNotEmpty(currentQuery) && options && options.isShowAllAction) {
                        $scope.dataset.whenMetadataLoaded().then(function () {
                            var criteria = Criteria('1 = 1', Criteria.buildStringParameter(currentQuery));

                            if (_defaultFilter) {
                                criteria.and(_defaultFilter);
                            }

                            if ($scope.loadOnInitialize || isDetailDynaform() || (options && options.isShowAllAction)) {
                                $scope.dataset.refresh(criteria, undefined, {
                                    finderInterceptors: [ENTITYSTARTPAGE_FINDERINTERCEPTOR]
                                });
                            } else {
                                $scope.dataset.clearDataSet();
                            }
                        });
                    } else if ($scope.loadOnInitialize || isDetailDynaform() || (options && options.isShowAllAction)) {
                        $scope.dataset.whenMetadataLoaded().then(function () {
                            var criteria = Criteria();

                            if (_defaultFilter) {
                                criteria.and(_defaultFilter);
                            }

                            $scope.dataset.refresh(criteria, undefined, {
                                ...options, 
                                keepCriteriaProviders: true
                            });
                        });
                    } else {
                        $scope.dataset.clearDataSet();
                    }

                    goToGridView().then(function () {
                        $scope.view = 'dynaform';
                        adjustTopBarPosition();

                        AngularUtil.timeout(function () {
                            adjustFilterSidenavPosition();
                            if ($scope.gridController) {
                                $scope.gridController.endEdit();
                                $scope.gridController.refreshLayout();
                            }
                        });
                    });
                });
            }

            //A pedido do Gualberto em 28/04/2016 sempre mostraremos todas as abas.
            //Caso, um dia, deseje-se reabilitar a funcionalidade "ver mais" no sidenav, descomentar
            //o método abaixo e descomentar onde usa no dyanform.tpl.html
            /*
            function toggleTabCollapse() {
                $scope.tabsCollapsePanel = !$scope.tabsCollapsePanel;

                var tabsElem = getDynaformTabsElem();

                if (!$scope.tabsCollapsePanel && tabsElem) {
                    var selectedTab = tabsElem.querySelectorAll('.tab-item')[$scope.tabsLimit];

                    if (selectedTab) {
                        AngularUtil.timeout(function () {
                            scrollTabViewTo(selectedTab);
                        });
                    }
                }
            }
            */

            function findFieldKeyHandler(evt) {
                if (AngularUtil.checkHandleThisEvent($element, evt.target)) {
                    AngularUtil.apply($scope, function () {
                        $scope.dropdownConfig.isOpen = true;
                    });
                }
            }

            function findEntityKeyHandler(e) {
                if (isMasterDynaform()) {
                    var field;

                    if (isHierarchyDynaformActivated()) {
                        field = getDynaformSideNav().querySelector('sk-flat-tree sk-search-input');
                    } else {
                        field = dynaformTopbar.querySelector('#entitySearchField');
                    }

                    if (field) {
                        var doFocus = function () {
                            var searchController = AngularUtil.getControllerFromElement(field);
                            searchController.setFocus();
                        };

                        if (isHierarchyDynaformActivated()) {
                            openSidenav().then(doFocus);
                        } else {
                            doFocus();
                        }
                    }
                }
            }

            function refreshTabsInfo() {
                $scope.tabsInfo = $scope.allTabsInfo.filter(function (tab) {
                    return tab.visible && tab.tabId != 'mainTab';
                });

                var newIndex = angular.isDefined($scope.tabSelected) ? $scope.tabsInfo.indexOf($scope.tabSelected) : -1;

                if (newIndex == -1) {
                    if ($scope.tabSelectedIndex >= $scope.tabsInfo.length) {
                        newIndex = $scope.tabsInfo.length - 1;
                    } else {
                        newIndex = $scope.tabSelectedIndex;
                    }
                }

                if ($scope.tabSelectedIndex !== newIndex) {
                    $scope.tabSelectedIndex = newIndex;
                    $scope.tabSelected = $scope.tabsInfo[$scope.tabSelectedIndex];
                }

                let tabsInvisible = $scope.allTabsInfo.filter(function (tab) {
                    return !tab.visible && tab.tabId != 'mainTab';
                });

                for (tab of tabsInvisible) {
                    if (_createdTabs.hasOwnProperty(tab.tabId)) {
                        delete _createdTabs[tab.tabId];
                    }
                }
            }

            function setAllTabsEnabled(value) {
                if ($scope.allTabsInfo) {
                    $scope.allTabsInfo.forEach(function (tab) {
                        if (tab.tabName != MAIN_TAB_NAME) {
                            tab.enabled = value;
                        }
                    });
                }
            }

            function setTabEnabled(tabId, value) {
                if ($scope.allTabsInfo) {
                    var tab = ArrayUtils.find($scope.allTabsInfo, function(tab) {
                        return tab.tabId == tabId;
                    });
 
                    if (tab) {
                        tab.enabled = value;
                    }
                }
            }
            function rebuildLayout(reload) {
                return buildLayoutInfo(_metadata, _processedMetadata.entitiesMetadata, _processedMetadata.allFields, _processedMetadata.foreingKeyFields)
                    .then(function (info) {
                        $scope.mainTabInfo = info.mainTabInfo;
                        $scope.allTabsInfo = info.tabsInfo;

                        refreshTabsInfo();

                        if (reload === true) {
                            $scope.dataset.refresh();
                        }

                        $scope.allFields = info.allFields;
                        $scope.invisibleFields = info.invisibleFields;
                        $scope.requiredTabByField = info.requiredTabByField;

                        $scope.entityDescription = $scope.dataset.getEntityDescription()? $scope.dataset.getEntityDescription() : $scope.entityDescription;

                        $scope.tabsSize = $scope.tabsInfo.length;

                        if ($scope.tabsSize > 0) {
                            doSelectTab($scope.tabsInfo[0]);
                        }

                        $scope.$broadcast(FixedBarConstants.EVENT_FIXED_HEIGHT_CHANGED);
                        $scope.$broadcast(DynaformConstants.EVENT_METADATA_UPDATED);
                        $scope.$emit(DynaformConstants.EVENT_METADATA_UPDATED);

                        ArrayUtils.callEachFunctionWith(_metadataUpdateListeners, self);
                    });
            }

            function refreshDatasetByPk(pks, autoInsertPKs, withDefaultFilter) {
                if (!angular.isArray(pks)) {
                    pks = [pks];
                }

                var criteria = Criteria();

                for (var index in pks) {
                    var pk = pks[index];

                    var pkMD = $scope.dataset.getFieldMetadata(pk.name);

                    if (pkMD) {
                        criteria.and(pk.name + ' = ?');
                        criteria.addParameter(Criteria.buildParameter(pkMD.dataType, pk.value));

                        if (autoInsertPKs) {
                            $scope.dataset.addAutoInsertValue(pk.name, pk.value);
                        }
                    } else {
                        throw new Error('Campo de PK desconhecido: ' + pk.name);
                    }
                }

                insertHierarchyDynaformCommentOnCriteria(criteria);

                if (_defaultFilter) {
                    criteria.and(_defaultFilter);
                }

                $scope.dataset.refresh(criteria)
                    .then(function () {
                        _loadingByPK = false;

                        if (_treeInstance && isHierarchyDynaformActivated()) {
                            _treeInstance.selectAndOpen($scope.dataset.getRecordByUniqueId(0));
                        } else if (_flatTreeInstance) {
                            _flatTreeInstance.selectPKAfterRefresh(pks);
                        }
                    });
            }

            function showMoreEntityPesqResults() {

                buildCriteriaRequestFromDs().then(function(dsCriteria){
                    let criteria;

                    if(dsCriteria && $scope.useDsCriteriaInEntitySearch){
                        criteria = new Criteria(dsCriteria.externalCriteria.query.$);
                        dsCriteria.externalCriteria.params.param.forEach(function(par){
                            criteria.addParameter(par.$);
                        });
                    }

                    let options = { loadOnCreate: true, showInactives: true };

                    if(criteria){
                        options.criteria = criteria;
                    }

                    SkPesquisaService.openPesquisaPopUp($scope.entityName, self.entitySearch, options).then(pesqEntitySelect);
                    self.entitySearch = '';

                });
            }

			function loadFieldSuggestions(value) {
                if (StringUtils.isEmpty(value)) {
                    return [];
                }

                var deferred = $q.defer();

                var matches = [];

                var tabsInfo = [];

                if ($scope.mainTabInfo) {
                    tabsInfo.push($scope.mainTabInfo);
                }

                ArrayUtils.pushAll(tabsInfo, $scope.tabsInfo);

                tabsInfo.forEach(function (tabInfo) {
                    if (!tabInfo.entityName) { //Não é Dynaform...
                        tabInfo.fields.forEach(function (field, index) {
                            if (field.visible && _unAcceptFields[field.name] !== false && !_hiddenFieldsByProgrammer.hasOwnProperty(field.name) && field.userType != "customBlock" && StringUtils.replaceAccentuatedChars(field.description).toLowerCase().indexOf(StringUtils.replaceAccentuatedChars(value).toLowerCase()) > -1) {
                                var tabName;
                                if (tabsInfo.length > 1) {
                                    if (tabInfo.tabName == MAIN_TAB_NAME) {
                                        tabName = SkI18nService.instant('Dynaform.lblPainelPrincipal');
                                    } else {
                                        tabName = tabInfo.tabName;
                                    }
                                } else {
                                    tabName = '';
                                }
                                matches.push({
                                    key: field.name,
                                    label: field.description,
                                    fieldName: field.name,
                                    fieldIndex: index,
                                    description: field.description,
                                    tabName: tabName,
                                    tabInfo: tabInfo
                                });
                            }
                        });
                    }
                });

                deferred.resolve(matches);
                return deferred.promise;
            }

            function loadEntitySuggestions(value) {
                if (StringUtils.isEmpty(value)) {
                    return [];
                }

                var deferred = $q.defer();
                $scope.isSearchingEntity = true;

                var criteria = angular.isDefined(_defaultFilter) ? Criteria(_defaultFilter) : undefined;


                buildCriteriaRequestFromDs().then(function(dsCriteria){

                    if(dsCriteria && $scope.useDsCriteriaInEntitySearch){
                        
                        if(!criteria){
                            criteria = new Criteria(dsCriteria.externalCriteria.query.$);
                        }else{
                            criteria.and(dsCriteria.externalCriteria.query.$);                            
                        }

                        dsCriteria.externalCriteria.params.param.forEach(function(par){
                            criteria.addParameter(par.$);
                        });
                        
                    }
                   
                    if(angular.isDefined($scope.additionalCriteria)){
                        if(angular.isDefined(criteria)){
                            criteria.and($scope.additionalCriteria)
                        }else{
                            criteria = $scope.additionalCriteria;
                        }
                    }
                    var optionsEntitySearch ={
						localEntityName: $scope.entityName
					}
					if($scope.ignoreFinderListenerInEntitySearch){
						optionsEntitySearch.ignoreFinderListener ='true'
					}
                    
                    SkPesquisaService.loadSuggestions($scope.entityName, value, true, 5, criteria,  optionsEntitySearch)
                        .then(function (entity) {

                            $scope.entity = entity;

                            $scope.hasMoreResults = entity.hasMore;

                            var options = entity.data.map(function (item) {
                                var option = {
                                    key: item[entity.pkField],
                                    label: item[entity.descriptionField],

                                    entityName: $scope.entityName,
                                    pkField: entity.pkField,
                                    descriptionField: entity.descriptionField,
                                    entityDescription: entity.entityDescription,
                                    hasImage: item.__hasImage,
                                    isFavorite: item.__isFavorite,
                                    imageField: entity.imageField,
                                    data: item,
                                    fieldsMetadata: entity.fieldsMetadata,
                                    //resourceID: entity.resourceID,
                                    otherEntityPks: entity.otherEntityPks,
                                    allPks: $scope.entityCardProps.entity.allPks,
                                    resolvePkEntity: $scope.resolvePkEntity
                                };

                                return option;
                            });

                            deferred.resolve(options);
                        }).finally(function () {
                            $scope.isSearchingEntity = false;
                        });
                    });

                return deferred.promise;
            }

            function getEntitdadesRecentesProperties() {
                return getEntitdadesRecentesFavoritosProperties('R');
            }

            function getEntitdadesFavoritasProperties() {
                return getEntitdadesRecentesFavoritosProperties('F');
            }

            function getEntitdadesRecentesFavoritosProperties(type) {
                var deferred = $q.defer();

                var entitiesData;

                if (type == 'F') {
                    entitiesData = $scope.favoriteEntities;
                } else if (type == 'R') {
                    entitiesData = $scope.recentsEntities;
                }

                var doResolve = function () {
                    deferred.resolve({
                        entityName: $scope.entityName,
                        entitiesData: entitiesData,
                        onSelectEntity: onSelectEntityOnStartPage,
                        type: type,
                        showFavoritesSearch: function () {
                            SkPesquisaService.openPesquisaPopUp($scope.entityName, undefined, {
                                listener: 'br.com.sankhya.modelcore.helper.pesquisa.listeners.PesquisaFavoritosListener',
                                enableRowsCounter: true
                            }).then(pesqEntitySelect);
                        }
                    });
                };

                if (entitiesData) {
                    doResolve();
                } else {
                    buildCriteriaRequestFromDs().then(function(criteria){
                        request = {
                            entityName: $scope.entityName,
                            resourceId: $scope.resourceId,
                            type: type
                        }

                        if(criteria){
                            request.criteria = criteria;
                        }

                        ServiceProxy.callService('PesquisaSP.getRecentesFavoritos', request).then(function (result) {
                            if (type == 'F') {
                                $scope.favoriteEntities = entitiesData = result.responseBody;
                            } else if (type == 'R') {
                                $scope.recentsEntities = entitiesData = result.responseBody;
                            }

                            doResolve();
                        });
                    });
                }

                return deferred.promise;
            }

            function buildCriteriaRequestFromDs(){
                let deferred = $q.defer();

                let query = '';
                let params = [];
                let getCriteriaPromisses = [];
                let criteria;

                if($scope.useDsCriteriaInEntitySearch && $scope.dataset && $scope.dataset.getCriteriaProvider() && $scope.dataset.getCriteriaProvider().length > 0){
                
                    $scope.dataset.getCriteriaProvider().forEach(function(criteriaProvider){
                        if (angular.isDefined(criteriaProvider)) {
                            getCriteriaPromisses.push(criteriaProvider.getCriteria());
                        }
                    });

                    if(getCriteriaPromisses.length > 0){
                        $q.all(getCriteriaPromisses).then(function(resolvedCriterias){
                            resolvedCriterias.forEach(function(crit){
                                if (angular.isDefined(crit)) {
                                    var thisCriteriaExpression = crit.getExpression();
            
                                    if (angular.isDefined(thisCriteriaExpression) && thisCriteriaExpression.length > 0) {
                                        if (query.length > 0) {
                                            query += " AND ";
                                        }
            
                                        query += "(" + thisCriteriaExpression + ")";
            
                                        crit.getParameters().forEach(function (param) {
                                            params.push({type: param.type, $: param.value});
                                        });
                                    }
                                }
                            });

                            if(query){
                                criteria = {
                                    externalCriteria: {
                                        query: { $: query},
                                        params: {
                                            param: params
                                        } 
                                    }
                                };
                            }

                            deferred.resolve(criteria);
                        });
                    }else{
                        deferred.resolve(false);
                    }
                }else{
                    if(angular.isFunction($scope.customCriteriaLoader)){
                        let criter = $scope.customCriteriaLoader();
                        if (angular.isDefined(criter)) {
                            var thisCriteriaExpression = criter.getExpression();
    
                            if (angular.isDefined(thisCriteriaExpression) && thisCriteriaExpression.length > 0) {
                                if (query.length > 0) {
                                    query += " AND ";
                                }
    
                                query += "(" + thisCriteriaExpression + ")";
    
                                criter.getParameters().forEach(function (param) {
                                    params.push({type: param.type, $: param.value});
                                });
                            }
                        }
                        if(query){
                            criteria = {
                                externalCriteria: {
                                    query: { $: query},
                                    params: {
                                        param: params
                                    } 
                                }
                            };
                        }
                        deferred.resolve(criteria);
                    }
                    deferred.resolve(false);
                }
                
                return deferred.promise;
            }

            function openGridConfig(options) {
                AngularUtil.timeout(function () {
                    createGrid().then(function () {
                        GridConfig.openGridconfig('grdcgf-' + getResourceId(), options);
                    });
                });
            }

            function closeGridConfig() {
                GridConfig.closeGridConfig();
            }

            function forceCloseGridConfig() {
                GridConfig.forceCloseGridConfig();
            }

            function launchConfiguration() {
                var path = [];
                getMasterDynaform(path);
                openConfiguration(self, path);
                $scope.dropdownConfig.isOpen = false;
            }

            function openConfiguration(sourceDynaform, path) {
                var oldView = $scope.view;
                $scope.view = 'config';

                getDynaformConfig().openConfiguration(sourceDynaform, path).then(function () {
                    $scope.view = oldView;

                    reloadConfiguration();
                });
            }

            function openNumberConfig(event) {
                if (!self.enableNumberConfig) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

                $scope.dropdownConfig.isOpen = false;

                NumberConfig.showInfo($scope.entityName, getResourceId())
                    .then(function (value) {
                        $scope.autoNum = {
                            isAutoNum: value.isNumeracaoAutomatica
                        };

                        $scope.dataset.askAndCancelEdition()
                            .then(function () {
                                rebuildLayout();
                            });
                    });
            }

            function useClassicLayoutVersion() {
                $scope.dropdownConfig.isOpen = false;

                $scope.dataset.askAndCancelEdition().then(function () {
                    MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, SkI18nService.instant('Dynaform.msgConfirmaUtilizLayoutClassico'))
                        .then(function () {
                            var resourceId = getResourceId();

                            var params = {
                                param: {
                                    choice: 'N',
                                    resourceID: resourceId
                                }
                            };

                            ServiceProxy.callService('WorkspaceSP.changeHtml5ScreenConfig', params)
                                .then(function (result) {
                                    SkApplication.instance().reloadApp(resourceId);
                                });
                        }, function (reason) {
                            //Nada a fazer
                        });
                });
            }

            function showClassicLayoutVersionLink() {
                return false;
            }

            function isHtml5ParamToOffer() {
                return MGEParameters.asInteger('mge.core.habilita.tela.html5') === 1;
            }

            function dtgRespectFormConfig() {
                return MGEParameters.asBoolean('com.configuracao.grade.respeita.config.tela') && !$scope.allowConfiguration;
            }

            function hasDefaultValue(fieldName) {
                var strValue = angular.isUndefined(_defaultValueByField) ? _defaultValueByField : _defaultValueByField[fieldName];

                return angular.isDefined(strValue) && strValue !== "";
            }

            function isFieldEnabled(fieldName) {
                return $scope.dataset.getFieldMetadata(fieldName).readOnly !== true;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#isFieldVisible
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Verifica se o campo está visível.
             * @param {String} fieldName Nome do campo que se deseja verificar a visibilidade.
             * @return {boolean} True se o campo estiver visível no dynaform, ou false caso contrário.
             */
            function isFieldVisible(fieldName) {
                /*Ordem:
                    1 - Campos já desenhados;
                    2 - Configuração do usuário;
                    3 - Campos alterados pela tela (programador);
                    4 - Metadatados do dataset;
                */

                if (!fieldName || fieldName == "") {
                    return false;
                }

                var config = _dynaformConfig.getUserConfig();

                if (_tabByField[fieldName]) {
                    var tabInfo = _tabByField[fieldName].tabInfo;
                    for (var i = 0, length = tabInfo.formFields.length; i < length; i++) {
                        var field = tabInfo.formFields[i];
                        if (field.fieldName == fieldName && field.visible == true) {
                            return true;
                        }
                    }
                } else if (config) {
                    return _dynaformConfig.isFieldVisibleByUserConfig(fieldName);
                } else if (_hiddenFieldsByProgrammer.hasOwnProperty(fieldName)) {
                    //Se não tem config de usuário devemos verificar se o campo está sendo forçado a ser exibido nas configs
                    return _forceShowOnConfig.hasOwnProperty(fieldName) ? true : false;
                } else if (_processedMetadata) {
                    var fieldMD = ArrayUtils.find(_processedMetadata.allFields, function (field) {
                        return field.name == fieldName;
                    });

                    return fieldMD && fieldMD.visible === true;
                } else {
                    throw Error('Não foi possível determinar a visibilidade do campo \'' + fieldName + '\'');
                }

                return false;
            }

            function showPersonalizedFilterButton() {
                if (!isActiveOnToolBarManager('usePersonalizedFilter')) {
                    return false;
                } else if (isMasterDynaform() && $scope.showFilter === 'false') {
                    return false;
                } else if (isDetailDynaform()) {
                    return StringUtils.toBoolean(self.userAllowPersonalizedFilter);
                } else if ($scope.hasDynamicFilter) {
                    return $scope.viewMode == 'form';
                } else {
                    return !$scope.editUniqueRecord;
                }
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setFieldProperty
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Realiza a alteração de metadados de um campo do dynaform.
             *  Limitado a apenas as seguintes propriedades: ['enabled', 'required', 'description', 'visible', 'somenteAnalitico', 'nullable']
             * @param {ArrayLike} fieldNames Nome/Nomes dos campos que sofrerão a alteração.
             * @param {String} propertyName Nome da propriedade que será alterada.
             * @param {Any} propertyValue Valor da propriedade, pode ser uma promessa de um valor.
             * @returns {Dynaform} retorna o dynaform para encadeamento.
             * @example
             * <pre>
             *  dynaform.setFieldProperty('CAMPO1,CAMPO2', 'enabled', false);
             * </pre>
             */
            function setFieldProperty(fieldNames, propertyName, propertyValue, options) {
                ArrayUtils.toArray(fieldNames).forEach(function (fieldName) {
                    doSetFieldProperty(fieldName, propertyName, propertyValue, options);
                });

                return self;
            }

            function doSetFieldProperty(fieldName, propertyName, propertyValue, options) {
                if (_mutableFieldProperties.indexOf(propertyName) < 0) {
                    throw new Error("A propriedade '" + propertyName + "' não pode ser modificada.");
                }

                var fieldMD = $scope.dataset.getFieldMetadata(fieldName);

                if (!fieldMD) {
                    //Se os metadados não forem encontrados, retornamos ao invés de lançar um Error.
                    //Neste caso, o DynaformHelper pode ter ignorado o campo, por isso ele não consta na lista.
                    /*throw new Error('Metadados do campo não encontrados: ' + fieldName);*/
                    console.error('Metadados do campo não encontrados:', fieldName)
                    return;
                }

                var fieldInfo = _tabByField[fieldName];
                var tabInfo;
                var formField;

                if (!fieldInfo) {
                    var listener = function () {
                        delete _fieldLoadedListeners[fieldName][propertyName];
                        setFieldProperty(fieldName, propertyName, propertyValue);
                    };

                    if (!_fieldLoadedListeners[fieldName]) {
                        _fieldLoadedListeners[fieldName] = {};
                    }

                    _fieldLoadedListeners[fieldName][propertyName] = listener;

                    if (propertyName == 'visible') {
                    	fieldMD.visible = propertyValue;
                    }
                } else {
                    tabInfo = fieldInfo.tabInfo;

                    var formFieldIndex = tabInfo.fields.indexOf(fieldMD);
                    formField = tabInfo.formFields[formFieldIndex];

                    if(!formField){
                        formField = ArrayUtils.find(tabInfo.fields, function(ite){
                            return ite.id === fieldMD.id;
                        });
                    }

                    if (formField && fieldMD.name != formField.fieldName) {
                        formField = undefined;
                        _tabByField[fieldName].tabInfo.formFields.every(function (field) {
                            if (field.fieldName == fieldMD.name) {
                                formField = field;
                            }
                            return angular.isUndefined(formField);
                        });

                        if (angular.isUndefined(formField)) {
                            throw new Error("Erro: campo '" + fieldName + "' não encontrado nos metadados do formulário.");
                        }
                    }
                }

                var columnMD = _datagridLoaded && $scope.gridController && $scope.gridController.getColumnByName(fieldName);

                if (!columnMD) {
                    var listener = function () {
                        delete _gridFieldLoadedListeners[fieldName][propertyName];
                        setFieldProperty(fieldName, propertyName, propertyValue);
                    };

                    if (!_gridFieldLoadedListeners[fieldName]) {
                        _gridFieldLoadedListeners[fieldName] = {};
                    }

                    _gridFieldLoadedListeners[fieldName][propertyName] = listener;
                }

                $q.when(propertyValue, function (value) {
                    switch (propertyName) {
                        case "nullable":
                            fieldMD.isNullable = value;

                            if (formField) {
                                formField.fieldProp['sk-allow-null'] = value;
                            }

                            if (columnMD) {
                                columnMD.skAllowNull = value
                            }

                            break;
                        case "enabled":
                            fieldMD.readOnly = !value;

                            if (formField) {
                                formField.enabled = value;
                            }

                            if (columnMD) {
                                columnMD.setEnabled(value);
                            }

                            break;
                        case "visible":
                            if (formField) {
                                formField.visible = value;
                            }

                            if (columnMD) {
                                //Falta caso de uso e não iremos fazer.
                                //columnMD.setVisible(value);
                            }

                            if (value === false) {
                                _hiddenFieldsByProgrammer[fieldName] = undefined;

                                if (ObjectUtils.getProperty(options, 'hideFromConfig') === true) {
                                    _hiddenFieldsFromConfig[fieldName] = undefined;
                                } else if (ObjectUtils.getProperty(options, 'showOnConfig') === true) {
                                    _forceShowOnConfig[fieldName] = undefined;
                                }
                            } else if (_dynaformConfig.isFieldVisibleByUserConfig(fieldName)) {
                                delete _hiddenFieldsByProgrammer[fieldName];
                                delete _hiddenFieldsFromConfig[fieldName];
                            }
                            break;
                        case 'required':
                            fieldMD.required = value;

                            if (formField) {
                                formField.required = value;

                                if (value) {
                                    tabInfo.hasRequired = true;
                                } else {
                                    tabInfo.hasRequired = angular.isDefined(ArrayUtils.find(tabInfo.formFields, function (field) {
                                        return field.required;
                                    }));
                                }

                                if ($scope.requiredTabByField) {
                                    if (value === true) {
                                        $scope.requiredTabByField[fieldMD.name] = tabInfo;
                                    } else {
                                        delete $scope.requiredTabByField[fieldMD.name];
                                    }
                                }

                                $scope.dataset[fieldMD.required ? 'makeFieldRequired' : 'makeFieldNonRequired'](fieldMD.name);

                                updateTabRequiredStatusDebounced();
                            }

                            break;
                        case 'description':
                            fieldMD.description = value;

                            if (formField) {
                                formField.description = value;
                            }

                            if (columnMD) {
                                //Falta caso de uso e não iremos fazer.
                                //columnMD.setDescription(value);
                            }
                            break;
                        case 'somenteAnalitico':
                            if (!fieldMD.fk) {
                                throw new MessageError('Campo ' + fieldName + ' não é do tipo "pesquisa" e não pode ter a propriedade ' + propertyName + ' alterada.');
                            }

                            fieldMD.fk.somenteAnalitico = value;

                            if (formField) {
                                formField.fieldProp['sk-somente-analitico'] = value;
                            }

                            if (columnMD && columnMD.fk) {
                                columnMD.fk.somenteAnalitico = value;
                            }
                            break;
                    }
                });

                return self;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#addFieldPropertyEvaluator
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Adiciona um listener no Dynaform que será chamado sempre que o dataset sofrer modificações para calcular
             *  um novo estado de algum campo.
             *  Possui a mesma limitações de propriedades do método {@link snk.components.dynaform.directive:sk-dynaform#setFieldProperty}
             * @param {String} fieldName Nome do campo que sofrerá a alteração.
             * @param {String} propertyName Nome da propriedade que será alterada.
             * @param {function} evaluateFn Função responsável por calcular o novo estado, o resultado pode ser uma promessa de um valor. Caso o valor seja "undefined" o processo é abortado.
             * @param {ArrayLike} [dependentFields=undefined] Quando for uma alteração de valores e este parametro seja informado, o dataset
             * o dynaform só reavaliará o estado caso um destes campos tenha sido modificado.
             * @param {Object} [options=undefined] Objeto que pode ser usado para guardar informações.
             * @returns {Dynaform} retorna o dynaform para encadeamento
             * @example
             * <pre>
             *  //Exemplo 1
             *  dynaform.addFieldPropertyEvaluator('CAMPO', 'enabled', function(dataset, dynaform, event, parameters, options){
             *      return dataset.getFieldValue('CAMPO2') == 'teste' ? true : false;
             * }, 'CAMPO2');
             *
             * //Exemplo 2
             * dynaform.addFieldPropertyEvaluator('CAMPO', 'enabled', function(dataset, dynaform, event, parameters, options, cancel){
             *      if (event === 'MODIFICACAO') {
             *          return dataset.getFieldValue('CAMPO2') == 'teste' ? true : false;
             *      }
             * }, 'CAMPO2');

             * //Exemplo 3
             * dynaform.addFieldPropertyEvaluator('CAMPO', 'enabled', function(dataset, dynaform, event, parameters, options, cancel){
             *      return $q(function(resolve, reject) {
             *              ServiceProxy.callService('SPBean.habilitaCampo', {param1: 'param'})
             *                  .then(function(result){
             *                      resolve(result.responseBody.habilitaCampo);
             *                  }, reject);
             *
             *          });
             * }, 'CAMPO2');
             * </pre>
             */
            function addFieldPropertyEvaluator(fieldNames, propertyName, evaluateFn, dependentFields, options) {
                var fieldPropertyEvaluator = {
                    fieldNames: ArrayUtils.toArray(fieldNames).map(StringUtils.trim),
                    propertyName: propertyName,
                    evaluateFn: evaluateFn,
                    options: options,
                    dependentFields: ArrayUtils.toArray(dependentFields).map(StringUtils.trim)
                };

                _fieldPropertyEvaluators.push(fieldPropertyEvaluator);

                return self;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#addMetadataUpdateListener
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Adiciona um listener no dynaform que será chamado quando o dynaform tiver seus metadados recarregados.
             * @param {function} listener Função que será chamada após a carga dos metadados.
             * @example
             * <pre>
             *      dynaform.addMetadataUpdateListener(function(){
             *          console.log('metadataUpdated');
             *      });
             * </pre>
             */
            function addMetadataUpdateListener(listener) {
                _metadataUpdateListeners.push(listener);
            }

            function addTreeCreatedListener(listener) {
                if (_treeInstance && getHierarchyConfig()) {
                    listener(_treeInstance);
                } else if(_flatTreeInstance && !getHierarchyConfig()){
                    listener(_flatTreeInstance);
                } else {
                    _treeCreatedListeners.push(listener);
                }
            }

            function allEvents(event, parameters) {
                _fieldPropertyEvaluators.forEach(function (evaluator) {
                    var shouldEvaluate = angular.isDefined(ObjectUtils.getProperty(parameters, 'modifiedFieldId')) && evaluator.dependentFields.length > 0 ? evaluator.dependentFields.indexOf(parameters.modifiedFieldId) > -1 : true;
 
                    if (shouldEvaluate) {
                        ArrayUtils.forEach(evaluator.fieldNames, function (fieldName) {
                            if (_invisibleFieldsByName.hasOwnProperty(fieldName)) {
                                shouldEvaluate = false;
                            }
 
                            return shouldEvaluate;
                        });
                    }
 
                    if (shouldEvaluate) {
                        var result = evaluator.evaluateFn($scope.dataset, self, event, parameters, evaluator.options);
 
                        $q.when(result).then(function(data){
 
                            evaluator.fieldNames.forEach(function (fieldName) {
                                if (!_invisibleFieldsByName.hasOwnProperty(fieldName)) {
                                    if (evaluator.options && evaluator.options.interceptValue) {
                                        data = evaluator.options.interceptValue(fieldName, data, $scope.dataset, self, event, parameters, evaluator.options);
                                    }
 
                                    if (angular.isDefined(data)) {
                                        setFieldProperty(fieldName, evaluator.propertyName, data);
                                    }
                                }
                            });
 
                        })
                    }
                });
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#showFieldTooltip
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Utilizado para apresentar um tooltip em cima de algum campo do dynaform.
             * @param {String} id Id único deste tooltip
             * @param {String} fieldName Nome do campo onde o tooltip deve aparecer
             * @param {String} i18nKey descrição ou chave de internaciionalização do tootip
             * @param {int} duration Duração que o tooltip deverá permanecer aberto
             * @example
             * <pre>
             *  dynaform.showFieldTooltip('informe.cnpj.cpf', 'CPF', i18n('Core.Parceiro.messagePreencherCPF'), 10000);
             * </pre>
             */
            function showFieldTooltip(id, fieldName, i18nKey, duration) {
                var tabInfo = _tabByField.hasOwnProperty(fieldName) ? _tabByField[fieldName].tabInfo : undefined;

                if (tabInfo) {
                    loadTabFormController(tabInfo);
                    tabInfo.formController.showFieldTooltip(id, fieldName, i18nKey, duration);
                }
            }

            function addCustomFormItemVisible(fieldName, condicao) {
                var tabInfo = _tabByField.hasOwnProperty(fieldName) ? _tabByField[fieldName].tabInfo : undefined;

                if (tabInfo && $scope.tabsInfo) {
                    loadTabFormController(tabInfo);
                    tabInfo.formController.addCustomFormItem({'fieldName': fieldName, 'visible': condicao});
                }
            }

            function getFlatTreeConfigName() {
                return getResourceId() + '.flatTreeConfig';
            }

            function onChildDynaformLoaded(dynaform, dataset) {
                $scope.onDynaformLoaded({ dynaform: dynaform, dataset: dataset });
            }

            function initChildDynaform(dynaform) {
                $scope.initDynaform({ dynaform: dynaform});
            }

            function onChildCustomTabsLoader(entityName) {
                return customTabsLoader(entityName);
            }

            function onChildDatagridLoaded(datagrid, dataset) {
                onDynaformDatagridLoaded(datagrid, dataset);
            }

            function onDynaformDatagridInit(datagrid, dataset) {
                var customMDs = _customColumnsMDByEntity[$scope.dataset.getEntityName()];

                if (angular.isArray(customMDs)) {
                    customMDs.forEach(datagrid.addCustomColumnMD);
                }

                $scope.datagrid = datagrid;

                $scope.onDatagridInit({ datagrid: datagrid, dataset: dataset });
            }

            function onDynaformDatagridLoaded(datagrid, dataset) {
                if ($scope.dataset == dataset) {
                    _datagridLoaded = true;
                }

                $scope.onDatagridLoaded({ datagrid: datagrid, dataset: dataset });

                angular.forEach(_gridFieldLoadedListeners, function (propertyListeners) {
                    angular.forEach(propertyListeners, function (listener) {
                        listener && listener();
                    });
                });
            }

            function getDynaformInterceptor() {
                return $scope.dynaformInterceptor;
            }

            function getFormInterceptor() {
                return $scope.formInterceptor;
            }

            function getHelperClassName() {
                return $scope.helperClassName;
            }

            function isRecursiveHelper() {
                return $scope.recursiveHelper;
            }

            function getDatagridInterceptor() {
                return $scope.datagridInterceptor;
            }

            function customTabsLoader(entityName) {
                return $scope.customTabsLoader({ entityName: entityName });
            }

            function otherOptionsLoader(dynaform, $dropdownMenu) {
                return $scope.otherOptionsLoader({ dynaform: dynaform, $dropdownMenu: $dropdownMenu });
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#hasAccess
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Verifica se o usuário tem acesso à ação solicitada.
             * @param {String} action Nome da ação para verificação do acesso.
             * @return {boolean} Retorna se o usuário tem ou não acesso.
             */
            function hasAccess(action) {
                if (_authData) {
                    return _authData.hasAccess(action);
                } else {
                    return SkApplication.instance().hasAuthorization(action);
                }
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getFieldTabName
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Obtém o nome da aba na qual o campo se encontra
             * @param {String} fieldName Nome do campo que se deseja verificar.
             * @return {String} Nome da aba na qual o campo se encontra. Lança um erro caso o campo não seja encontrado.
             */
            function getFieldTabName(fieldName) {
                if (!fieldName || fieldName == "") {
                    return undefined;
                }

                /*Ordem:
                    1 - Campos já desenhados;
                    2 - Configuração do usuário;
                    3 - Metadados do dataset;
                */

                if (_tabByField[fieldName]) {
                    if (ObjectUtils.getProperty(_tabByField[fieldName], 'tabInfo.tabName')) {
                        return ObjectUtils.getProperty(_tabByField[fieldName], 'tabInfo.tabName');
                    }
                }

                var config = _dynaformConfig.getUserConfig();
                if (config) {
                    if (ObjectUtils.getProperty(config, 'layout.workspace.mainPanel.field')) {
                        for (var i = 0, len = config.layout.workspace.mainPanel.field.length; i < len; i++) {
                            if (config.layout.workspace.mainPanel.field[i].name == fieldName) {
                                //Retornamos o nome da aba "Geral"
                                return MAIN_TAB_NAME;
                            }
                        }
                    }

                    if (ObjectUtils.getProperty(config, 'layout.workspace.tab')) {
                        var tabName;
                        for (var i = 0, len = config.layout.workspace.tab.length; i < len; i++) {
                            tabName = config.layout.workspace.tab[i].title;
                            var field = config.layout.workspace.tab[i].field;
                            if (field) {
                                for (var j = 0, length = field.length; j < length; j++) {
                                    if (field[j].name == fieldName) {
                                        return tabName;
                                    }
                                }
                            }
                        }
                    }
                }

                if (_processedMetadata && _processedMetadata.allFields) {
                    for (var i = 0, len = _processedMetadata.allFields.length; i < len; i++) {
                        var field = _processedMetadata.allFields[i];

                        if (field.name == fieldName) {
                            var tabName;

                            if (field.properties) {
                                var propTabName = ArrayUtils.find(field.properties, function (prop) {
                                    return prop.name == 'UITabName';
                                });

                                tabName = propTabName && propTabName.value;
                            }

                            if (tabName) {
                                return tabName;
                            } else {
                                if ($scope.dataset.isPrimaryKey(field.name) || field.name == $scope.dataset.getEntityPresentationFieldName()) {
                                    return MAIN_TAB_NAME;
                                } else {
                                    return SkI18nService.instant('Geral.lblGeral');
                                }
                            }
                        }
                    }
                }

                if (_customBlocks && _customBlocks[fieldName]) {
                    return _customBlocks[fieldName].description;
                }

                throw new Error("Não foi possível encontrar a aba para o campo '" + fieldName + "'.");
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setBtnNewCompact
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @param {boolean} [value=false] True, caso deseje que o botão novo fique em modo compacto.
             * @description
             *  Define se o botão novo estará no formato compacto.
             */
            function setBtnNewCompact(value) {
                $scope.btnNewCompact = value;
            }

          /**
           * @ngdoc
           * @name snk.components.dynaform.directive:sk-dynaform#setTabOrderConfig
           * @methodOf snk.components.dynaform.directive:sk-dynaform
           * @description
           *  Usado para customizar a ordenação default das abas do dynaform.
           *  <b>OBS:</b> Só é aplicado quando o dynaform não possui uma configuração de usuário.
           *
           *  As variáveis possíveis são:
           *  * general (aba Geral)
           *  * form (abas dinamicas geradas pelo UITabName)
           *  * relation (abas dinamicas geradas pelos relacionamentos 1xN)
           *  * custom (abas estáticas carregadas via customTabsLoader)
           *
           *  O array deve conter na ordem desejada as variáveis acima para que o dynaform as respeite, ex:
           *  <pre>
           *    ['relation,
                 'custom',
                 'form',
                 'general']
           *  </pre>
           *  Isso fará com que primeiro sejam carregadas as abas de relação, em seguida as estáticas,
           *  depois as dinâmicas e por último a aba Geral.
           *
           *  Também é possível customizar a ordem dentro de cada grupo acima, exemplo:
           *  <pre>
           *    ['form[uiTabName1,uiTabName2]', //Apenas as duas abas com esses nomes
                 'relation[entityName1]', //Apenas a relação com a entidade 1.
                 'custom[id2,id3]', //As customizadas com id2 e id3
                 'relation',
                 'form', //O restante das abas dinâmicas
                 ]
           *  </pre>
           *
           *  Quando o 'general' não é informado, ele fica na primeira posição, por padrão.
           *
           *  Caso alguma aba não tenha encaixado na configuração acima, ela será renderizada
           *  na ordenação padrão e na ordem padrão do sistema após todas as que foram definidas.
           *  Ordem padrão: form,relation,custom
           *
           *  Exemplo:
           *  <pre>
           *    ['form[uiTabName1,uiTabName2]', //Apenas as duas abas com esses nomes
                 'relation[entityName1]', //Apenas a relação com a entidade 1.
                 'custom[id2,id3]', //As customizadas com id2 e id3
                ]
           *  </pre>
           *  Como não definimos onde encaixará o restante das abas form,relation e custom,
           *  elas irão para o final na ordem padrão citada acima.
           *
           * @param {array} config Array com as configurações de ordem.
           */
            function setTabOrderConfig(config) {
              _customTabOrderConfig = config;
            }

            function reorderTabsByConfig(tabsInfo) {
                if (!_customTabOrderConfig) {
                    return;
                }

                var reorderInfo = {
                    general: undefined,
                    form: [],
                    relation: {},
                    custom: {},
                    relationOrigOrder: [],
                    customOrigOrder: [],
                    formOrigOrder: []
                };

                //Aqui quebramos a lista com todas as abas para a estrutura acima,
                //para facilitar o controle
                tabsInfo.forEach(function (tab) {
                    if (tab.tabId == 'general') {
                        if (reorderInfo.general) {
                            throw Error('Estado inválido, foram encontradas duas abas \'Geral\'');
                        }

                        reorderInfo.general = tab;
                    } else if (tab.blockId) {
                        if (reorderInfo.custom[tab.blockId]) {
                            throw Error('Estado inválido, foram encontradas duas abas estáticas com id: ' + tab.blockId);
                        }

                        reorderInfo.custom[tab.blockId] = tab;
                        reorderInfo.customOrigOrder.push(tab);
                    } else if (tab.type == 'dynaform') {
                        if (reorderInfo.relation[tab.entityName]) {
                            throw Error('Estado inválido, foram encontradas duas abas de relacionamento com a entidade: ' + tab.entityName);
                        }

                        reorderInfo.relation[tab.entityName] = tab;
                        reorderInfo.relationOrigOrder.push(tab);
                    } else if (tab.type == 'form') {
                        if (reorderInfo.relation[tab.tabId]) {
                            throw Error('Estado inválido, foram encontradas duas abas dinâmicas com o id: ' + tab.tabId);
                        }

                        reorderInfo.form[tab.tabId] = tab;
                        reorderInfo.formOrigOrder.push(tab);
                    } else {
                        throw Error('Estado inválido, tipo de aba não conhecido: ' + tab.tabName);
                    }
                });

                var newTabs = [];

                //Agora iremos iterar na lista de ordenação desejada
                _customTabOrderConfig.forEach(function (orderItem) {
                    if (orderItem == 'general') {
                        newTabs.push(reorderInfo.general);
                        delete reorderInfo.general;
                    } else {
                        var result = /(\w+)(?:\[(.+)\])?/g.exec(orderItem);

                        if (result == null || !result[1] || !reorderInfo.hasOwnProperty(result[1])) {
                            throw Error('Tipo de ordenação não disponível: ' + result[1]);
                        }

                        var type = result[1];
                        var ids = result[2];

                        if (ids) { //Apenas os ids passados como parâmetro
                            ids.split(',').forEach(function (id) {
                                if (reorderInfo[type]) {
                                    var tab = reorderInfo[type][id];

                                    if (tab) {
                                        newTabs.push(tab);

                                        //Limpamos dos controles
                                        delete reorderInfo[type][id];

                                        var index = reorderInfo[type + 'OrigOrder'].indexOf(tab);

                                        if (index > -1) {
                                            reorderInfo[type + 'OrigOrder'].splice(index, 1);
                                        }
                                    }
                                }
                            });

                        } else { //todos
                            var tabsById = reorderInfo[type + 'OrigOrder'];

                            tabsById.forEach(function (tab) {
                                newTabs.push(tab);
                            });

                            tabsById.length = 0;
                            reorderInfo[type] = {};
                        }
                    }
                });

                if (reorderInfo.general) {
                    newTabs.splice(0, 0, reorderInfo.general);
                }

                if (reorderInfo.formOrigOrder.length > 0) {
                    reorderInfo.formOrigOrder.forEach(function (tab) {
                        newTabs.push(tab);
                    });
                }

                if (reorderInfo.relationOrigOrder.length > 0) {
                    reorderInfo.relationOrigOrder.forEach(function (tab) {
                        newTabs.push(tab);
                    });
                }

                if (reorderInfo.customOrigOrder.length > 0) {
                    reorderInfo.customOrigOrder.forEach(function (tab) {
                        newTabs.push(tab);
                    });
                }

                return newTabs;
            }

            function enableSortFields(sortFields) {
                _sortFields = sortFields;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setTabOrderConfig
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Usado para customizar a ordenação default das abas do dynaform.
             *  <b>OBS:</b> Só é aplicado quando o dynaform não possui uma configuração de usuário.
             *
             *  O sistema irá realizar a ordenação com base no array passado, por exemplo:
             *  <pre>
             *      ['uiTabName1', 'uiTabName2', 'general', 'entityName_Entidade1', 'idAbaEstatica'];
             *  </pre>
             *
             *  Assim o sistema ordenará as abas na ordem descrita acima, não modificando a ordem
             *  das demais que não foram citadas e deixando elas no final.
             *
             * @param {array} tabOrder Array com os ids das abas na ordem desejada.
             */
            function setTabOrder(tabOrder) {
                _tabOrder = tabOrder;
            }

            function reorderTabsByTabOrder(tabsInfo) {
                if (!_tabOrder) {
                    return;
                }

                return tabsInfo.sort(function (tabA, tabB) {
                    if (tabA.tabId == 'mainTab' || tabB.tabId == 'mainTab') {
                        return tabA.tabId == 'mainTab' ? -1 : 1;
                    }

                    var aIndex = _tabOrder.indexOf(tabA.tabId);
                    var bIndex = _tabOrder.indexOf(tabB.tabId);

                    if (aIndex == -1 && bIndex == -1) {
                        return 0;
                    } else if (aIndex != -1 && bIndex == -1) {
                        return -1;
                    } else if (aIndex == -1 && bIndex != -1) {
                        return 1;
                    } else {
                        return aIndex - bIndex;
                    }
                });
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getBtnNewCompact
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Verifica se o botão novo está no modo compacto.
             * @return {boolean} True, caso o botão novo esteja no modo compacto ou false caso contrário.
             */
            function getBtnNewCompact() {
                return $scope.btnNewCompact;
            }

            function getHiddenFieldsFromConfig() {
                return _hiddenFieldsFromConfig;
            }

            function getHiddenFieldsByProgrammer() {
                return _hiddenFieldsByProgrammer;
            }

            function dynamicFilterClickHandler() {
                $scope.isFilterOpen = !$scope.isFilterOpen;
            }

            function setCustomFilterPanel(customFilterPanel) {
                _customFilterPanel = customFilterPanel;

                if (angular.isDefined(_customFilterPanel)) {
                    $scope.hasDynamicFilter = true;
                }
            }

            function formConfigColumns() {
                var key = FormColumnConfig.FORM_COL_CONFIG_PREFIX + getResourceId();

                FormConfigColumnsPopUp.open(key, isHierarchyDynaformActivated())
                    .then(function (response) {
                        if (response.configChanged === true) {
                            rebuildLayout();
                            
                            _childDynaformArray.forEach((e) => {
                                (e.rebuildLayout || angular.noop)();
                            });
                        }
                    });

                $scope.dropdownConfig.isOpen = false;
            }

            function getFormColConfig() {
                return $scope.formConfigColumnKey;
            }

            function getHierarchyConfig() {
                return $scope.treeHierarchyConfig !== 'S' ? true : false;
            }
            
            function selectTabPerId(tabId, fn) {
                if ($scope.allTabsInfo) {
                    var indexSelect = -1;
                    var tab = ArrayUtils.find($scope.allTabsInfo, function(tab, index) {
                        var isTab = tab.tabId == tabId;
                        indexSelect = isTab ? index: -1;

                        return isTab
                    });

                    if (tab && indexSelect !== -1) {
                        if ($scope.tabSelectedIndex !== indexSelect) {
                            $scope.tabSelectedIndex = indexSelect;
                            $scope.tabSelected = tab;
                        }
                    }
                }

                if (angular.isFunction(fn)) {
                    fn();
                }
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#isAutoNum
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Retorna se o dynaform está configurado para ser auto numérico.
             * @return {boolean} Retorna true caso seja auto numérico, falso caso contrário.
             */
            function isAutoNum(){
                return $scope.autoNum && StringUtils.toBoolean($scope.autoNum.isAutoNum);
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setAutoNum
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Altera se o dynaform está configurado para ser auto numérico.
             * @param {boolean} enable altera a opção de numeração automatica
             */
            function setAutoNum(enable) {
                $scope.autoNum = {
                    isAutoNum: false
                };
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#addShortcut
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Adiciona um atalho com uma ação no dynaform
             * @param {string} label Atalho a ser utilizado sendo concatenado com '+', ex: 'ctrl+R'
             * @param {function} fn função a ser executada com o atalho. 
             */
            function addShortcut(label, fn){
            	KeyboardManager.bind(label, fn, {target: $element[0]});
            }

            function getVariationSufix() {
                var variationSufix = "";
                
                if(getMasterDynaform().isVariation() === true) {
                    var parentResourceID = getMasterDynaform().getResourceId();
                    var separatorIndex = parentResourceID.indexOf("__");                    
                    if(separatorIndex != -1) {
                        variationSufix = parentResourceID.substr(separatorIndex, parentResourceID.length -1);
                    }
                }
                
                return variationSufix;
            }

            function isVariation(){
                return SkApplication.instance().getConfiguracaoTela(getResourceId() + ".isVariation");
            }

			function fieldRequiredCustomBlock(blockInfo, tabInfo){
                if(blockInfo !== undefined){
                    var fields = blockInfo.properties.dataset.getFieldsMetadata();

                    for(var i=0; i<fields.length; i++){
                        if(fields[i].required && fields[i].tabName === tabInfo.tabName){
                            return fields[i];
                        }
                    }
                }
                return false;
            }

            function configCopied(srcUser, destUSers){
                if(destUSers.indexOf(SkApplication.instance().getUserID()) > -1){
                    reloadScreenCfg();
                }
            }

            function reloadScreenCfg(){
                getDynaformInitProperties(true, {forceLoadDefaults: true}).then(function(configs){
                    buidDynaformInitConfigs(configs, true);
                    rebuildLayout();
                });
            }

            function buidDynaformInitConfigs(configs, needToLoadProperties) {

                var skApp = SkApplication.instance();

                angular.forEach(configs, function (value, key) {
                    if (key == 'hasActionButtons') {
                        $scope.showActionButton = value;
                    } else if (key == 'dynaform.helper') {
                        _dynaformHelperData = value;
                        adjustDynaformHelperData();
                    } else if (key == 'invisibleReferences') {
                        _dynaformInvisibleReferences = value;
                    } else if (key == 'access.resourceid') {
                        _authData = MGEAuthorizationService.parseFromJSON(value);
                    } else {
                        skApp.putConfiguracaoTela(key, value);
                    }
                });

                if (!needToLoadProperties) { //Assumimos que as configurações já podem ter sido carregadas nas configurações de tela
                    $scope.showActionButton = skApp.getConfiguracaoTela('hasActionButtons');
                    _dynaformInvisibleReferences = skApp.getConfiguracaoTela('invisibleReferences');
                }
            }

            function verifyAutoNumHierarchy(fieldMD, isAutoNum){

                // Verificamos se o fieldMD possui a propertie mascaraHierarquia 
                // se tiver retornamos false para que o modo de Inserção não bloqueie o campo.
            	let result = isAutoNum;
                if(fieldMD.properties != null){
                    for(var i=0; i < fieldMD.properties.length; i++){
                        if(fieldMD.properties[i].name === 'mascaraHierarquia'){
                            result = false;           
                        } else if (isAutoNum == true && fieldMD.properties[i].name === 'readOnly' && fieldMD.properties[i].value == 'S') {
                            return true;
                        }
                    }
                }
                
                return result;
            }

            function closeAllPopovers() {
                if (!_openedPopovers.isEmpty) {
                    _openedPopovers.forEach(function (openedPoppover) {
                        if (openedPoppover.isOpen && openedPoppover.isPopover) {
                            openedPoppover.hide();
                        }
                    });
                    _openedPopovers = [];
                }
            }

            function setFieldRequireInTab(fieldsId, tabId) {

                if(angular.isString(fieldsId)){
                    fieldsId = fieldsId.split(',');   
                }

                var tab = ArrayUtils.find($scope.allTabsInfo, function (tabItem) {return tabItem.tabId == tabId});

                if(!tab){
                    throw new Error('Aba ' + tabId + ' não encontrada no dynaform ' + $scope.entityName);
                }

                fieldsId.forEach(function (fieldId) {
                    $scope.requiredTabByField[fieldId] = tab;

                    if (!tab.hasRequired) {
                        tab.hasRequired = true;
                    }
                })
            }
            
            function canCreateTab(tabId, hasCustom){
                const interceptor = getDynaformInterceptor();

                if(interceptor){
                    return interceptor.acceptTab(tabId, self, $scope.dataset, hasCustom);
                }

                return true;
            }
            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getExceptFieldsByEntity
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Retorna campos que não devem ser adicionados no dynaform.
             */
            function getExceptFieldsByEntity(){
                return _exceptFieldsByEntity;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getEntityForceUserFields
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Retorna entidades que vão ser forçadas a carregar os campos adicionais.
             */
            function getEntityForceUserFields(){
                return _entityForceUserFields;
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setNavigatorSaveHandler
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Função a ser chamada quando o botão de salvar for clicado.
             */
            function setNavigatorSaveHandler(fn){
            	self.navigatorApi.setSaveHandler(fn);
            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#setNavigatorAddHandler
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description Função a ser chamada quando o botão de adicionar(+) for clicado.
             */
            function setNavigatorAddHandler(fn){
            	self.navigatorApi.setAddHandler(fn);
            }
            
            function getCriteriaStartPage(){
                let deferred = $q.defer();

                buildCriteriaRequestFromDs().then(function(dsCriteria){
                    if(dsCriteria && $scope.useDsCriteriaInEntitySearch){
                        criteria = new Criteria(dsCriteria.externalCriteria?.query?.$);
                        
                        dsCriteria.externalCriteria.params.param.forEach(function(par){
                            criteria.addParameter(par.$);
                        });

                        deferred.resolve(criteria);
                    }else{
                        deferred.resolve();
                    }
                });

                return deferred.promise;
            }
            
            function otherOptionsInterceptor(){
                return self.dropdownApi;
            }

            function isShowNumberConfig(){ 
                return !$scope.hideNumberConfig;
            }

            function isShowFormLayoutConfig(){
                return !$scope.hideFormLayoutConfig;
            }

            function filterFieldsPersonalizedFilter(item, index, arr){
                if($scope.fnFilterPersonalizedFilter){
                    return $scope.fnFilterPersonalizedFilter(item, index, arr);
                }else{
                    return true;
                }
            }

            function getFilterPanelInstance() {
            	return _filterPanelInstace;
            }

            function hasFormChanged() {
                if (angular.isUndefined($scope.dataset)) {
                    return;
                }

                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                var multiEdit = $scope.dataset.isMultiRecordEditMode();

                return dirty || insertionMode || multiEdit;
            }

            function controlActiveHierarchy() {
                if (isHierarchyDynaform()) {
                    $scope.isHierarchyActivated = !$scope.isHierarchyActivated;

                    savePreferences();

                    if(!$scope.ignoreRefreshConfig){
                        refreshDatasetByConfig();
                    }                    
                }
            }

            function refreshDatasetByConfig() {
                $scope.dataset = buildDataset(_processedMetadata);
                $scope.datasetActionButtonContext = new DatasetActionButtonContext($scope.dataset);
                $scope.dataset.initializeDataSet().then(function () {
                    $scope.onDynaformLoaded({
                        dynaform: self,
                        dataset: $scope.dataset
                    });

                    buildEntityCard(true);

                    rebuildLayout();

                    buildOtherConfigs();

                    $timeout(function() {
                        $scope.dataset.initAndRefresh().then(function() {
                            createGrid(undefined, true);
                        });
                    });
                });
            }

            function isHierarchyDynaformActivated() {
                return isHierarchyDynaform() && $scope.isHierarchyActivated;
            }

            function showMasterHierarchyDynaform() {
                return isMasterDynaform() && isHierarchyDynaformActivated();
            }

            function savePreferences() {
            	var config = {}
                
            	config[MOSTRAR_HIERARQUIA] = String($scope.isHierarchyActivated);

            	var configElem = XmlJson.create("config", {
        			chave: SkApplicationInstance.getScreenResourceID() + PREFERENCE_CONFIG_ID,
        			tipo: "T"
            	});
                
                for (var name in config) {
                	XmlJson.append(configElem, XmlJson.create(name, undefined, config[name]));
                }

                ServiceProxy.callService("mge@SystemUtilsSP.saveConf", configElem, {normalizedJson:true})
                    .then(function(params, result) {});
            }

            function loadPreferences() {
                var configElem = XmlJson.create("config", 
                    { chave: SkApplicationInstance.getScreenResourceID() + PREFERENCE_CONFIG_ID, tipo: "T" });

                ServiceProxy.callService("mge@SystemUtilsSP.getConf", configElem, { normalizedJson: true })
                    .then(result => {
                        if (XmlJson.isNormalized(result)) {
                            XmlJson.denormalize(result);
                        }

                        var config = ObjectUtils.getProperty(result, 'responseBody.config');

                        if (config) {
                            const mostrarHierarquia = ObjectUtils.getProperty(config, MOSTRAR_HIERARQUIA+'.$');
                            $scope.isHierarchyActivated = mostrarHierarquia == "false" ? false : true;
                        }
                    });
            }

            function isTreeSearchActived() {
                return $scope.treeSearchActived;
            }
            
            function maximizeTab(tabInfo){

                SanPopup.open({
					title: tabInfo.tabName + ' (Aba maximizada)',
                    templateUrl: 'components/dynaform/defaultblocks/maximizedTab/MaximizedTab.tpl.html',
					controller: 'MaximizedTabController',
                    controllerAs: 'ctrl',
                    size: 'fullscreen',
                    showBtnOk: false,
                    showBtnCancel: false,
                    disableMovement: true,
					resolve: {
						data: {
                            tabInfo: tabInfo,
                            formColumnNumberConfig: $scope.formColumnNumberConfig,
                            formConfigColumnKey: FormColumnConfig.FORM_COL_CONFIG_PREFIX + getMasterDynaformResourceId(),
                            formInterceptor: $scope.formInterceptor,
                            formCreationComplete: $scope.formCreationComplete,
                            getResourceId: getResourceId,
                            dynaScope: $scope

						}
					}
				});

            }

            /**
             * @ngdoc
             * @name snk.components.dynaform.directive:sk-dynaform#getFieldProperty
             * @methodOf snk.components.dynaform.directive:sk-dynaform
             * @description
             *  Realiza a busca de metadados de um ou mais campos do dynaform.
             * @param {ArrayLike} fieldNames Nome/Nomes dos campos.
             * @returns {Array} retorna um array com as propriedades dos elementos.
             * @example
             * <pre>
             *  dynaform.getFieldProperty('CAMPO1,CAMPO2');
             * </pre>
             */
            function getFieldProperty(fieldNames) {
                var _fieldProperty = [];

                ArrayUtils.toArray(fieldNames).forEach(function (fieldName) {
                    _fieldProperty.push(ObjectUtils.getProperty($scope.dataset.getFieldMetadata(fieldName), 'properties'));
                });

                return _fieldProperty;
            }

            function loadActionButtonByService(resourceID){
                var rid = resourceID || $scope.actionButtonResourceID;

                return $q(function (resolve, reject) {
                    var param={ 
                        param: {
                           entityName: self.getEntityName(),
                           resourceID: rid,
                           accessResourceID: ""                      
                         }
                       }
    
                    ServiceProxy.callService('ActionButtonsSP.getActions', param).then(function (result) {
                        resolve(ObjectUtils.getProperty(result, 'responseBody.actions.action') || []);               
                    }).catch(err => {
                        resolve([]);
                    });
                });
            }

            function getActionButtonResourceId(){
                if ($scope.actionButtonResourceID != undefined) {
                    return $scope.actionButtonResourceID;
                }
                if (effectiveActionButtonResourceID != undefined) {
                    var inheritedResourceID = $scope.parentDynaform && $scope.parentDynaform.getActionButtonResourceID ?
                        $scope.parentDynaform.getActionButtonResourceID() : undefined;
                    return inheritedResourceID != undefined ? inheritedResourceID : $scope.resourceId;
                }
                return $scope.resourceId;
            }

            function getActionButtonAccessResourceId(){
                if ($scope.actionButtonResourceID != undefined) {
                    return "";
                }
                if (effectiveActionButtonResourceID != undefined) {
                    var inheritedResourceID = $scope.parentDynaform && $scope.parentDynaform.getActionButtonResourceID ?
                        $scope.parentDynaform.getActionButtonResourceID() : undefined;
                    return inheritedResourceID != undefined ? "" : $scope.getMasterDynaformResourceId();
                }
                return $scope.getMasterDynaformResourceId();
            }

        }]);                        

/**
 * @ngdoc directive
 * @name snk.components.dynaform.directive:sk-dynaform
 * @restrict E
 * @scope
 * @description
     Dynaform � o componente respons�vel por realizar o controle dos registros de uma entidade no lado do cliente.
     � um componente de mais baixo n�vel em rela��o aos componentes do sandb-js,
     pois os demais componentes utilizam como base as informa��es providas por este componente.
     Ele possui m�todos que realizam o carregamento, edi��o, e persist�ncia dos registros.
     Bem como uma vasta gama de eventos que s�o disparados antes e depois de cada uma destas rotinas acimas serem executadas.

     � poss�vel personalizar algumas funcionalidades do dynaform atrav�s do html, para isso informe a tag 'dynaform-nome-entidade'
     e coloque as personaliza��es dentro, assim � poss�vel personalizar a entidade principal e detalhes.

     Aualmente suportamos as tags:
        <p><b><i>sk-right-top-bar</i></b> - O que for informado dentro desta tag ser� adicionado na barra superior direita do dynaform.</p>
        <p><b><i>sk-datagrid-custom-column</i></b> - Personaliza��o de colunas do grid, mais informa��es em {@link snk.form.directive:sk-datagrid-custom-column}</p>
        <p><b><i>sk-custom-filter-panel</i></b> - Adi��o/personaliza��o de painel de filtros, mais informa��es em {@link snk.components.filterpanel.directive:sk-filter-panel sk-filter-panel}</p>

 * @param {string} sk-entity-name Nome da entidade base que o sk-dataset representar�.
 * @param {string=} [sk-entity-description=Descri��o da entidade no dicion�rio de dados] Descri��o personalizada para os Dynaform Detail.
 * @param {string=} [sk-form-columns=4] Quantidade m�xima de colunas que o form pode assumir. Esse valor s� pode ser modificado em casos espec�ficos.
 * @param {string} sk-resource-id ResourceID do Dynaform. Se n�o for informado, o resourceID provido pelo sk-application ser� utilizado.
 * @param {function} sk-init-dynaform Fun��o a ser invocada antes de realizar o loadMetadata do sk-dynaform . Dando a oportunidade de alterar propriedades que s�o utilizadas para carregar os metadados de campo. 
 * @param {function} sk-on-dynaform-loaded Fun��o a ser invocada quando o sk-dynaform estiver carregado. Dando a oportunidade de fazer ajustes no dataset e alterar os metadados de campo antes de montar o formul�rio.
 * @param {function} sk-on-datagrid-loaded Fun��o a ser invocada quando o sk-datagrid do sk-dynaform estiver carregado.
 * @param {object} sk-parent-dynaform ID do sk-dynaform parent.
 * @param {boolean} sk-show-filter Habilita/desabilita o bot�o de filtro.
 * @param {function} sk-other-options-loader Fun��o chamada para carregar as outras op��es do sk-dynaform.
 * @param {boolean} sk-skip-start-page Habilita/desabilita a p�gina inicial do sk-dynaform.
 * @param {boolean} sk-edit-unique-record Habilita/desabilita a edi��o de um �nico registro no sk-dynaform.
 * @param {boolean} sk-hide-entity-card Utilizado para ocultar a chave da entidade no  modo formul�rio.
 * @param {boolean} sk-default-mode Define se o sk-dynaform ser� ['master' | 'detail'].
 * @param {object} sk-dynaform-interceptor Refer�ncia para um IDynaformInterceptor.
 * @param {object} sk-datagrid-interceptor Refer�ncia para um IDatagridInterceptor.
 * @param {object} sk-form-interceptor Refer�ncia para um IFormInterceptor.
 * @param {object} sk-filter-panel-interceptor Refer�ncia para um IFilterPanelInterceptor.
 * @param {string} sk-helper-class-name <i>Full Qualified Name</i> da classe a ser utilizada como Helper.
 * @param {boolean} sk-recursive-helper Indica se a classe helper ser� chamada tamb�m para os sk-dynaform filhos deste sk-dynaform.
 * @param {boolean} sk-can-back-to-old-layout Indica se, quando poss�vel, a op��o para voltar ao layout anterior estar� habilitada.
 * @param {function} sk-before-post-config Fun��o que recebe a configura��o do form como par�metro e deve retornar true para permitir salvar a configura��o da tela, ou false caso contr�rio.
 * @param {boolean=} [sk-show-detail-description=true] Regra extra para apresentar ou n�o a descri��o de 1 dynaform detail. 
 * @param {function} sk-btn-new-compact Define se o bot�o novo ser� apresentado no modo compacto.
 * @param {boolean} sk-hierarchy Atributo que define se o dynaform � hierarquico.
 * @param {boolean} sk-tree-search-actived Atributo que define se o campo de busca do sk-tree ir� aparecer.
 * @param {function} sk-pk-listener Atributo que define se o dynaform ir� tentar carregar uma PK automaticamente pelo SkApplication.
 * @param {function} sk-show-label-others-filters Par�metro que determina se a label de Outros ser� apresentada no sk-custom-filter-panel
 * @param {function} sk-custom-tabs-loader Fun��o chamada para carregar poss�vel abas (ou blocos) personalizados.
 *  Esta fun��o deve retornar um array com os metadados dos blocos, sendo eles: (* Parametros opcionais)
 *  blockId: Id �nico para o block.
 *  description: Descri��o ou chave de internacionaliza��o para a descri��o do block.
 *  controller: Nome do controlador do bloco.
 *  controllerAs*: Alias para o controlador.
 *  templateUrl: Url do template do bloco.
 *  eventBus*: Um EventBus que pode ser passado para comunica��o com este bloco, entrgue ao bloco como 'BlockEventBus'
 *  properties*: Um objeto com qualquer informa��o, entregue ao bloco como 'BlockProperties'
 *
 *  O controlador do bloco recebe o parametro BlockProperties que contem os 'properties' passados, al�m de:
 *  dynaform: O dynaform que criou o bloco.
 *  dataset: O dataset do dynaform criador do bloco.
 *
 *  O controlador do bloco tamb�m recebe o par�metro BlockCreationCompleted, que � uma promise de quando o bloco foi carregado no formul�rio.
 *  
 *  Exemplo:
 *     <pre>
 *     return [{
 *         blockId: 'meuBloco1',
 *         description: i18n('Geral.lblGeral'),
 *         controller: 'MeuBlocoController',
 *         controllerAs: 'ctrl',
 *         templateUrl: 'html5/MinhaTela/abas/meubloco1/meubloco1.tpl.html',
 *         eventBus: _eventBus,
 *         properties: {
 *             oquevcquiser: 'valordoquevcquiser'
 *         }
 *     }]
 *     </pre>
 * @param {boolean} sk-hide-tour Regra para apresentar ou n�o o Tour da nova funcionalidade HTML 5.
 * @param {boolean} sk-ignored-config-entity - O Dynaform por padr�o carrega e salva a configura��o da entidade.
 * @param {boolean} sk-ignore-accept-column-entity-name caso ativado ignora o acceptColumnField do datagridInterceptor.
 * @param {boolean} sk-tree-adv-search Repassa para o componente sk-tree (em casos de Dynaforms hierarquicos) se o componente deve usar servico de busca ao pesquisar.
 * @param {boolean} sk-suppress-screen-config essa propriedade tem a fun��o de desabilitar o bot�o de configura��o do dynaform,
 * al�m de impedir o carregamento da configura��o caso a mesma esteja salva no banco, diferente do par�metro sk-hide-form-layout-config que permite com que
 * a configura��o da tela seja carregada caso a mesma esteja salva. 
 * @param {Function} sk-tab-order-function Fun��o que pode ser utilizada para definir uma ordem padr�o para as abas, essa fun��o N�O sobrescreve a configura��o
 * do dynaform, ou seja, s� � chamada quando n�o existe uma configura��o de ordena��o da aba salva.
 * PS: A contagem das abas se inicia de 1, diferente desssa funcionalidade do flex que se inicia de 0. 
 * @param {boolean} sk-disable-remove-invisible-fields - Configura��o do comportamento do invisibleFields do controller, sendo o padr�o 'false', 
 * para remover os fields invis�veis do dataset, mas alterando para 'true', muda o comportamento para apenas alterar o atributo visible para 'false' dos fields.
 * @param {Array} sk-fields-orders - retorna a ordem dos campos
 * @param {Criteria} sk-additional-criteria - Adiciona um crit�ria adicional ao request do dataset
   @param {boolean} sk-enable-search-input-hierarchy - Habilita o uso do parametro 'sk-search-term' na hierarquia (sk-tree) ao invés do padrao
   @param {string} sk-parent-entity-name - Nome da entidade pai do dataset
   @param {boolean} sk-refresh-dataset-to-tree - Inicia a tela com a arvore carregada caso 'true', caso 'false' inicia a tela sem registros carregados na arvore
 */

angular
    .module('snk.components.dynaform')
    .directive('skDynaform', ['StringUtils', 'AngularUtil', function (StringUtils, AngularUtil) {
        return {
            scope: {
                entityName: '@skEntityName',
                resourceId: '@skResourceId',
                initDynaform: '&skInitDynaform',
                onDynaformLoaded: '&skOnDynaformLoaded',
                onDatagridLoaded: '&skOnDatagridLoaded',
                onDatagridInit: '&skOnDatagridInit',
                parentDynaform: '=skParentDynaform',
                showFilter: '@skShowFilter',
                customTabsLoader: '&skCustomTabsLoader',
                otherOptionsLoader: '&skOtherOptionsLoader',
                otherConfigLoader: '&?skOtherConfigLoader',
                skipStartPage: '=?skSkipStartPage',
                applyPersonalizedFilterOnLoad: '=?skApplyPersonalizedFilterOnLoad',
                editUniqueRecord: '=skEditUniqueRecord',
                defaultMode: '@skDefaultMode',
                dynaformInterceptor: '=?skDynaformInterceptor',
                datagridInterceptor: '=?skDatagridInterceptor',
                filterPanelInterceptor: '=?skFilterPanelInterceptor',
                formInterceptor: '=?skFormInterceptor',
                helperClassName: '@skHelperClassName',
                recursiveHelper: '=skRecursiveHelper',
                canBackToOldLayout: '=skCanBackToOldLayout',
                skCustomEntityDescription: '@?skEntityDescription',
                formColumns: '@?skFormColumns',
                btnNewCompact: '=?skBtnNewCompact',
                showDetailDescription: '=?skShowDetailDescription',
                beforePostConfig: '&?skBeforePostConfig',
                hideCbxColumn: '=?skGridHideCbxColumn',
                allowMultipleSelection: "=?skGridAllowMultipleSelection",
                relationInfo: '=?skRelationInfo',
                customCriteriaLoader: '&?skCustomCriteriaLoader',
                skHideEntityCard:'=?skHideEntityCard',
                otherOptionsChildren:'=?skOtherOptionsChildren',
                hideEntitySearchField: '=?skHideEntitySearchField',
                hideButtonFavorite: '=?skHideButtonFavorite',
                hideButtonRecents: '=?skHideButtonRecents',
                hideButtonEntityAttach: '=?skHideButtonEntityAttach',
                selectedTabNavigator: '&skSelectedTabNavigator',
                showLabelOthersFilters: '=?skShowLabelOthersFilters',
                hideButtonsConfig: '=?skHideButtonsConfig',
                hideButtonGrid: '=?skHideButtonGrid',
                showSearchField: '=?skShowSearchField',
                hideTour: '&?skHideTour',
                isLazyLoad: '&?skIsLazyLoad',
                filterPanelApplyFunction: '&?skFilterPanelApplyFunction',
                ignoredConfigEntity: '=?skIgnoredConfigEntity',
                formColumnNumberConfig:'@?skFormColumnNumberConfig',
                useDsCriteriaInEntitySearch: '@?skUseDsCriteriaInEntitySearch',
                ignoreFinderListenerInEntitySearch: '@?skIgnoreFinderListenerInEntitySearch',
                forceEnablePersonalizedFilter: '=?skForceEnablePersonalizedFilter',
                hideNumberConfig: '=?skHideNumberConfig',
                hideFormLayoutConfig: '=?skHideFormLayoutConfig',
                ignoreListenerMethods: '@?skIgnoreListenerMethods',
                popupMode: '=?skPopupMode',
                fnFilterPersonalizedFilter: '=skFnFilterPersonalizedFilter',
                suppressScreenConfig: "=?skSuppressScreenConfig",
                tabOrderFunction: "&skTabOrderFunction",
                customConfigGridPrinter: "=?skCustomConfigGridPrinter",
                hideCustomFilterPanel:"=?skHideCustomFilterPanel",
                filterInstanceName: '@skFilterInstanceName',
                disableRemoveInvisibleFields: "=?skDisableRemoveInvisibleFields",
                gridPrinterInterceptor : '=?skGridPrinterInterceptor',
                limitCopyConfig : '=?skLimitCopyConfig',
                btnTourExplicito : '=?skBtnTourExplicito',
                creationPolicy : '@?skCreationPolicy',
                keepParallelLoader: '=?skKeepParallelLoader',
                fieldsOrder: '=?skFieldsOrder',
                customClassTopBar: '@?skCustomClassTopBar',
                treeSearchActived: '=?skTreeSearchActived',
                additionalCriteria: '=?skAdditionalCriteria',
                ignoreAcceptColumnEntityName: '=?skIgnoreAcceptColumnEntityName',
                enableSearchInputHierarchy: '=?skEnableSearchInputHierarchy',
                parentEntityName: '&skParentEntityName',
                treeAdvSearch: '=?skTreeAdvSearch',
                imageValidation: '=?skImageValidation',
                actionButtonResourceID: '@?skActionButtonResourceId',
                refreshDatasetToTree: '=?skRefreshDatasetToTree',
                ignoreRefreshConfig: '=?skIgnoreRefreshConfig',
                resolvePkEntity: '=?skResolvePkEntity',
                acceptPromiseSearchField: '=?skAcceptPromiseSearchField',
            },
            controller: 'SkDynaformController',
            controllerAs: 'dynaformCtrl',
            link: linker,
            templateUrl: 'components/dynaform/dynaform.tpl.html',
            restrict: 'E',
            transclude: true
        };

        function linker(scope, element, attrs, controller) {
            if (attrs.id) {
                scope.$parent[attrs.id] = controller;
            }
            
            scope.forceEnablePersonalizedFilter = angular.isDefined(scope.forceEnablePersonalizedFilter) ? 
                StringUtils.toBoolean(scope.forceEnablePersonalizedFilter) : false;

            scope.disableRemoveInvisibleFields = angular.isDefined(scope.disableRemoveInvisibleFields) ? 
                StringUtils.toBoolean(scope.disableRemoveInvisibleFields) : false;

            scope.keepParallelLoader = angular.isDefined(scope.keepParallelLoader) ? 
                StringUtils.toBoolean(scope.keepParallelLoader) : false;

            scope.treeSearchActived = angular.isDefined(scope.treeSearchActived) ? 
                StringUtils.toBoolean(scope.treeSearchActived) : true;

            element.attr('flex', '');
            element.attr('layout', 'column');
            
            resolveTransclude(scope.entityName, controller.getMasterDynaformElement(), element, controller, scope);

            if (attrs.skParentDynaform) {
            	AngularUtil.addSingleWatch(scope, 'parentDynaform', controller.loadMetadata);
            } else {
            	controller.loadMetadata();
            }
        }

        function resolveTransclude(entityName, masterDynaformElem, currentDynaformElem, dynaformController, scope) {
            var transcludeDynaformElem = masterDynaformElem.find('dynaform-' + StringUtils.toDashCase(entityName));

            var userLeftContainer = angular.element(currentDynaformElem[0].querySelector('.user-left-container'));
            var userRightContainer = angular.element(currentDynaformElem[0].querySelector('.user-right-container'));
            var userHeaderContainer = angular.element(currentDynaformElem[0].querySelector('.user-header-container'));
            var userFooterContainer = angular.element(currentDynaformElem[0].querySelector('#user-footer-container'));
            var userFooter = angular.element(currentDynaformElem[0].querySelector('#user-footer'));
            var userContainerFormGrid = angular.element(currentDynaformElem[0].querySelector('#user-container-form-grid'));
            var userBottomGridPanel = angular.element(currentDynaformElem[0].querySelector('#user-bottom-grid-panel'));
            
            if (transcludeDynaformElem.length > 0) {
                var leftUserTopBar = transcludeDynaformElem.find('sk-left-top-bar');
                var rightUserTopBar = transcludeDynaformElem.find('sk-right-top-bar');
                var headerBar = transcludeDynaformElem.find('sk-header-bar');
                var customFilterPanel = transcludeDynaformElem.find('sk-custom-filter-panel');
                var containerFormGrid = transcludeDynaformElem.find('sk-container-form-grid');
                var bottomGridPanel = transcludeDynaformElem.find('sk-bottom-grid-panel')

                /**
                 * Para a utiliza��o do sk-footer-bar e sk-footer-filter-bar, devemos passar o tamanho do elemento filho para ser reenderiza a barra final para n�o cobrir 
                 * os dados ou a grid.
                 *  Exemplo
                 *   <sk-footer-bar>
                 *      <div style="height:60px">
                 *  </sk-footer-bar>
                 *
                 */
                var footerBar = transcludeDynaformElem.find('sk-footer-bar');
                var footerFilterBar = transcludeDynaformElem.find('sk-footer-filter-bar');

                if(angular.isDefined(customFilterPanel) && customFilterPanel.length > 0) {
                	let isHideCustomFilterPanel = angular.isDefined(scope.hideCustomFilterPanel) ? scope.hideCustomFilterPanel : false;

                    if (!isHideCustomFilterPanel) {
                        dynaformController.setCustomFilterPanel(customFilterPanel);
                    }
                }

                moveElement(leftUserTopBar, userLeftContainer);
                moveElement(rightUserTopBar, userRightContainer);
                moveElement(headerBar, userHeaderContainer);
                moveElement(bottomGridPanel, userBottomGridPanel);

                if(footerBar.length > 0 && footerBar[0].children.length > 0){
                    userFooterContainer[0].className = 'user-footer-container';
                    userFooter[0].style.height = footerBar[0].children[0].style.height;
                    userFooter[0].className = 'user-footer';
                    moveElement(footerBar, userFooterContainer);
                }

                if(footerFilterBar.length > 0 && footerFilterBar[0].children.length > 0){
                    userFooterContainer[0].className = 'user-footer-filter-container';
                    userFooter[0].className = 'user-footer';
                    userFooter[0].style.height = footerFilterBar[0].children[0].style.height;
                    moveElement(footerFilterBar, userFooterContainer);
                }

                if(containerFormGrid.length > 0){
                    userContainerFormGrid[0].className = 'user-container-form-grid';
                    moveElement(containerFormGrid, userContainerFormGrid);
                }
            } else {
                userLeftContainer.remove();
                userRightContainer.remove();
                userHeaderContainer.remove();
                userContainerFormGrid.remove();
                userBottomGridPanel.remove();
            }
        }

        function moveElement(origElem, destElem) {
            if (origElem && origElem.length > 0) {
                origElem.detach();

                destElem.append(origElem.children());
            } else {
                destElem.detach();
            }
        }
    }]);

angular
    .module('snk.components.dynaform')
    .service('DynaformTourContent', ['$timeout', 'SkApplication', 'GridConfig', 'ObjectUtils', 'ArrayUtils', 'AngularUtil',
        function ($timeout, SkApplication, GridConfig, ObjectUtils, ArrayUtils, AngularUtil) {

            var self = this;

            self.getDynaformTourContent = getDynaformTourContent;

            self.getFormConfigTour = getFormConfigTour;

            function getDynaformTourContent($element, $scope, dynaformController, currentTourVersion, dynaformTourVersion, tourViewed, tourHierarchyViewed, afterEndTour, rootSelector) {
                var sideNavQueryInput = '.top-bar .entity-search-container #entitySearchField input';
                var dynaformHeaderStringSelector = '.dynaform-top-bar-' + dynaformController.getMasterDynaformId();
                var dynaformContentStringSelector = '.dynaform-content-' + dynaformController.getMasterDynaformId();
                var dynaformBodyStringSelector = '.dynaform-body-' + dynaformController.getMasterDynaformId();

                var steps = getTourSteps(rootSelector);

                if ((isDifferentTourVersion() && currentTourVersion > 0) || isOnlyHierarchyTour()) {
                    steps = steps
                        .filter(function (step) {
                            if (step.vc) {//VersionControl
                                if (step.vc.isOnlyHierarchyTour && isOnlyHierarchyTour()) {
                                    return true;
                                } else if (step.vc.version > currentTourVersion) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }

                            return true;
                        });
                }

                function onFinishTour(executeAfter) {
                    var chave = 'SHOWHTML5TOUR';

                    saveVisualizedTourParameter(chave);

                    saveVersionTourParameter(chave + 'V');

                    if (dynaformController.isHierarchyDynaform()) {
                        saveVisualizedTourParameter(chave + 'H', true);
                    }

                    dynaformController.getGridController() && dynaformController.getGridController().closeGridMenu();
                    dynaformController.forceCloseGridConfig();

                    afterEndTour && afterEndTour();

					document.querySelectorAll('.ng-joyride-title').forEach(tour => {
					    tour.remove(); 
					});			

                    if (executeAfter) {
                        executeGridTourAfter();
                    }
                }

                return {
                    startTour: true,
                    tourConfig: steps,
                    onFinish: () => onFinishTour(true),
                    onSkip: () => onFinishTour()
                };
                 
                function isOnlyHierarchyTour() {
                    return dynaformController.isHierarchyDynaform() && tourViewed && !tourHierarchyViewed;
                }

                function isDifferentTourVersion() {
                    return currentTourVersion != dynaformTourVersion;
                }

                function showGridTourAfter() {
                    return !isOnlyHierarchyTour() && (!isDifferentTourVersion() || !tourViewed);
                }

                function executeGridTourAfter () {
                    if (showGridTourAfter()) {
                        AngularUtil.timeout(function () {
                            dynaformController
                            .goToGridView()
                            .then(function () {
                                if (dynaformController.getGridController()) {
                                    dynaformController.getGridController().startTour();
                                }
                            });
                        });
                    }
                }

                function getTourSteps(rootSelector) {
                    let steps = [];

                    if (dynaformController.hasStartPage()) { 
                        steps = welcomeSteps();
                        ArrayUtils.pushAll(steps, startPageTourSteps());
                    }

                    if (!isOnlyHierarchyTour() || currentTourVersion < dynaformTourVersion) {
                        steps.push({
                            type: "function",
                            fn: function (next) {
                                if (next) {
                                    dynaformController.onSelectShowGridOnStartPage(undefined, {
                                        onlyFirstPage: true
                                    });
                                } else {
                                    dynaformController.goToStartPage();
                                }
                            }
                        });

                        var gridSteps = gridModeSteps(rootSelector);
                        
                        if(!angular.equals($scope.showFilter,"true")){
                            gridSteps.splice(3,1);
                        }

                        ArrayUtils.pushAll(steps, gridSteps);

                    }

                    ArrayUtils.pushAll(steps, [{
                        type: "function",
                        fn: function (next) {
                            dynaformController.showDyanformView()
                                .then(function() {
                                    if (next) {
                                        dynaformController.goToFormView();
                                    } else {
                                        dynaformController.goToGridView();
                                    };
                                })
                        }
                    }]);

                    ArrayUtils.pushAll(steps, formModeSteps(rootSelector));

                    if (dynaformController.isHierarchyDynaform() && !dynaformController.getHierarchyConfig()) {
                        ArrayUtils.pushAll(steps, hierarchySideNavSteps());
                    }
                    
                    if(currentTourVersion == 2 || currentTourVersion == 3){
                        steps.push(
                            {
                                type: "function",
                                fn: function (next) {
                                    if (next) {                                                                                    
                                        dynaformController.showDyanformView().then(function() {
                                            dynaformController.onSelectShowGridOnStartPage(undefined, {onlyFirstPage: true});
                                            $timeout(function(){
                                                        dynaformController.getGridController().startTour(currentTourVersion);
                                                    }, 1500, false);
                                        });
                                    }else {
                                        dynaformController.goToStartPage();
                                    }; 
                                }
                            } 
                        );
                    }

                    ArrayUtils.pushAll(steps, finalSteps());

                    return steps;
                }

                function welcomeSteps() {
                    var steps = [];

                    if (isOnlyHierarchyTour()) {
                        var html = "Percebemos que você já visualizou o tour do novo layout.<br/><br/>" +
                            "Porém, esta tela é hierárquica e possui algumas diferenças do layout convencional, que tal conhecê-las?<br/>";

                        if (isDifferentTourVersion() && tourViewed) {
                            html += "<br/>Também houveram algumas mudanças no layout que você deveria conhecer."
                        }

                        steps.push({
                            type: "title",
                            heading: "Bem-vindo ao novo layout hierárquico",
                            html: html,
                            scroll: true,
                            attachToBody: true
                        });
                    } else {
                        var html;
                        if(currentTourVersion == 3){
                            html = html = "Temos uma novidade para lhe apresentar, agora você pode gerar seus gráficos diretamente na grade, vamos começar?"
                        } else if(currentTourVersion == 2){
                            html = "Temos uma nova grade para lhe apresentar, mais rápida, elegante e com novas funcionalidades, vamos começar?"                            
                        }else if (isDifferentTourVersion() && tourViewed) {
                            html = "Houveram algumas mudanças no layout de telas, que tal conhecê-las?" +
                                "<br/>Vai ser um tour bem rápido, mostrando apenas algumas novidades e funcionalidades."
                        } else {
                            html = "Este é o novo layout de telas do sistema.<br/><br/>" +
                                "A nova versão do layout de telas é mais rápida, moderna e foi projetada para que você tenha as ferramentas e recursos que necessita sempre à mão.<br/><br/>";
                        }

                        steps.push({
                            type: "title",
                            heading: currentTourVersion === 3 ? "Nova funcionalidade" : "Bem-vindo ao novo layout",
                            html: html,
                            scroll: true,
                            attachToBody: true
                        });
                    }

                    return steps;
                }

                function finalSteps() {
                    var steps = [];

                    if (isOnlyHierarchyTour()) {
                        steps.push({
                            type: "title",
                            heading: "Fim do tour",
                            html: "Você conheceu as principais novidades do novo layout de telas hierárquicas. Você pode iniciar o tour completo à qualquer momento clicando sobre a opção <i>Iniciar Tour</i> na página inicial da tela ou do menu de configuração da tela.",
                            placement: "center",
                            scroll: false,
                            attachToBody: true,
                            vc: {
                                version: 2,
                                isOnlyHierarchyTour: true
                            }
                        });
                    } else {
                        var finalStep = {
                            type: "title",
                            heading: "Fim do tour",
                            html: "Você conheceu as principais novidades do novo layout de telas. Você pode iniciar o tour à qualquer momento " +
                            "clicando sobre a opção <i>Iniciar Tour</i> na página inicial da tela ou do menu de configuração da tela.",
                            placement: "center",
                            scroll: false,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        };

                        if (showGridTourAfter()) {
                            finalStep.html += "<br/><br/>Que tal já aproveitar e ver o tour da grade?";
                            finalStep.finishText = 'Ver tour da grade';
                            finalStep.hideSkipBtn = false;
                        }

                        steps.push(finalStep);
                    }

                    return steps;
                }

                function formModeSteps(rootSelector) {
                    var steps = [];

                    var introHtml = "Esse é o novo modo Formulário.";

                    if (isDifferentTourVersion() && dynaformTourVersion == 2) {
                        introHtml += "<br/>Fizemos alguns ajustes para melhorar a usabilidade, como alterar as cores de fundo e" +
                            "<br/>colocamos um painel principal no topo, onde você poderá ver alguns campos independente da aba selcionada."
                    }

                    return steps.concat([{
                        type: "title",
                        heading: "Modo Formulário",
                        html: introHtml,
                        placement: "center",
                        scroll: false,
                        attachToBody: true,
                        vc: {
                            version: 1
                        }
                    },
                        {
                            type: "element",
                            heading: "Fomulário",
                            selector: rootSelector + " .container .content sk-tabnavigator:first",
                            html: 'Agora as abas da tela aparecerão sempre aqui e ficarão sempre na horizontal,' +
                            '<br/>também adicionamos uma opção que mostra todas as abas disponíveis e que possibilita pesquisar uma aba facilmente',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            heading: "Barra de ferramentas",
                            selector: rootSelector + " " + dynaformHeaderStringSelector + " .buttons-container:first",
                            html: "A barra de ferramentas do modo formulário possui as mesmas funcionalidades tanto no modo grade quanto no modo formulário.<br/><br/>" +
                            "Dessa forma, você terá as opções que precisa sempre à mão.",
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            heading: "Cartão do registro",
                            selector: rootSelector + " " + dynaformContentStringSelector + ' .entity-card-container:first',
                            html: "O cartão do registro exibe o código e descrição do registro selecionado, conforme ilustra a imagem abaixo.<br/><br/>" +
                            "<img src='/mge/assets/img/entity-card.png'><br/><br/>" +
                            "Para marcar/desmarcar um registro como favorito, basta clicar sobre a estrela que aparece antes do código do mesmo.<br/><br/>" +
                            "Se você não está visualizando o cartão do registro, não se preocupe. Assim que adicionar um registro, você o verá.",
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            isEnabled: dynaformController.hasEntityCard(),
                            vc: {
                                version: 2
                            }
                        }
                    ]);
                }

                function hierarchySideNavSteps() {
                    return [
                        {
                            type: "element",
                            heading: "Nova navegação hierárquica",
                            selector: ".container sk-flat-tree",
                            html: "Este é o novo modo hierárquico. Ele foi redesenhado para que você navegue e encontre o que precisa mais rapidamente.<br/><br/>" +
                            "<span class='text-danger'>(1)</span> A pesquisa rápida serve para filtrar o que já está carregado no momento.<br/><br/>" +
                            "<span class='text-danger'>(2)</span> Para acessar os filhos de um registro, basta clicar na seta em frente à ele.<br/><br/>" +
                            "<img style='margin-left:55px;' src='/mge/assets/img/dynaform-hierarchy-tree1.PNG'><br/>",
                            placement: "right",
                            scroll: false,
                            attachToBody: true,
                            isEnabled: dynaformController.isHierarchyDynaform(),
                            vc: {
                                version: 1,
                                isOnlyHierarchyTour: true
                            }
                        },
                        {
                            type: "element",
                            heading: "Nova navegação hierárquica",
                            selector: ".container sk-flat-tree",
                            html: "Quando estiver dentro de um nível, você verá a árvore conforme a imagem.<br/><br/>" +
                            "<span class='text-danger'>(1)</span> Através do painel superior você pode voltar para a raiz ou voltar o nível anterior, usando os botões na lateral.<br/><br/>" +
                            "<span class='text-danger'>(2)</span> Você também pode voltar diretamente à qualquer nível, através dos números clicáveis da máscara.<br/><br/>" +
                            "<img style='margin-left:35px;' src='/mge/assets/img/dynaform-hierarchy-tree2.PNG'><br/><br/>",
                            placement: "right",
                            scroll: false,
                            attachToBody: true,
                            isEnabled: dynaformController.isHierarchyDynaform(),
                            vc: {
                                version: 1,
                                isOnlyHierarchyTour: true
                            }
                        }
                    ];
                }

                function startPageTourSteps() {
                    var entityStartPageQueryInput = 'sk-entity-start-page sk-pesquisa-content .sk-pesquisa-search-container .query-input';

                    return [
                        {
                            type: "title",
                            heading: "Uma nova maneira de ver as coisas",
                            html: "Sempre que abrir uma tela, você verá esta página, chamada de <i>Página inicial.</i> Aqui você encontrará as principais opções para um acesso rápido e direto, e você pode voltar aqui quando quiser, conforme mostraremos mais adiante.</i><br/></br>" +
                            "Vamos conhecer os recursos da página inicial...",
                            placement: "center",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: "sk-entity-start-page .actions",
                            heading: "Opções da tela inicial",
                            html: "Com estas opções você vai direto ao assunto, realizando diretamente a tarefa que deseja.<br/><br/>" +
                            "Vamos conhecer cada uma das opções...",
                            placement: "right",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: "sk-entity-start-page .new-entity",
                            heading: "Novo Registro",
                            html: "Crie novos registros rapidamente com um clique utilizando esta opção.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: "sk-entity-start-page .show-grid",
                            heading: "Mostrar grade",
                            html: "Essa opção vai direto para a grade, exibindo os registros de acordo os filtros previamente aplicados. ",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: !dynaformController.isHierarchyDynaform(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: "sk-entity-start-page .show-filter",
                            heading: "Mostrar filtros",
                            html: "Essa opção abrirá os filtros personalizados, assim você poderá criar ou ligar/desligar alguns filtros antes de ir para a grade.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            selector: "sk-entity-start-page .open-help",
                            heading: "Ajuda",
                            html: "Esta opção abre a ajuda do sistema em uma outra janela.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: "sk-entity-start-page .start-tour",
                            heading: "Tour",
                            html: "Esta opção inicia o tour a qualquer momento.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: entityStartPageQueryInput,
                            heading: "Pesquisa de Registros",
                            html: "Digite aqui qualquer termo para buscar rapidamente os registros.<br/><br/><a class=\"link\" ng-click=\"fnExperimente()\">Experimente!</a>",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            actions: {
                                fnExperimente: function () {
                                    var input = $element[0].querySelector(entityStartPageQueryInput);
                                    angular.element(input).focus();
                                }
                            },
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "title",
                            heading: "Pronto para mais novidades?",
                            html: "Vamos conhecer agora o novo modo grade.",
                            placement: "top",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        }
                    ];
                }

                function gridModeSteps(rootSelector) {

                    var steps = [{
                        type: "title",
                        heading: "Modo Grade",
                        html: "Esse é o novo modo grade." +
                        "<br/><br/>Vamos explorar suas funcionalidades." +
                        "<br/><br/><i>Carregaremos apenas alguns registros para melhorar a experiência do tour.</i>",
                        placement: "center",
                        scroll: true,
                        attachToBody: true,
                        vc: {
                            version: 1
                        }
                    },
                        //Barra de Ferramentas do Modo Grade
                        {
                            type: "element",
                            selector: rootSelector + " .container .dynaform-body .top-bar:first",
                            heading: "Barra de ferramentas",
                            html: "Essa é a nova barra de ferramentas. Nela você encontra facilmente as opções mais utilizadas para o contexto atual.<br/><br/>O que você precisa apenas quando você precisa!",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .top-bar .btn-start-page:first",
                            heading: "Início",
                            html: "Esta opção volta para a página inicial.",
                            placement: "right",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.hasStartPage(),
                            vc: {
                                version: 1
                            }
                        },
                        /* Inicio botão de filtro */
                        {
                            type: "element",
                            heading: "Botão de Filtro",
                            selector: rootSelector + " .top-bar sk-personalized-filter:first",
                            html: "Este botão fica vermelho quando algum filtro estiver aplicado.<br/><br/>" +
                            "Ao clicar no ícone de filtro é possível visualizar os filtros existentes e configurar novos filtros, conforme mostraremos em breve.<br/><br/>" +
                            "Adicionalmente, é possível clicar na setinha para ativar ou desativar os filtros previamente cadastrados.<br/><br/>" +
                            "<img style='margin-left:45px;' src='/mge/assets/img/personalized-filter-menu.PNG'>",
                            placement: "right",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: !dynaformController.hasDynamicFilter() || dynaformController.hasForceEnablePersonalizedFilter(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            heading: "Botão de Filtro",
                            selector: rootSelector + " .top-bar sk-filter-panel-btn:first",
                            html: "Este botão azul fica vermelho quando algum filtro estiver aplicado.<br/><br/>" +
                            "Ao clicar no ícone de filtro é possível abrir e fechar o painel de filtros.<br/><br/>",
                            placement: "right",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.hasDynamicFilter() && !dynaformController.hasForceEnablePersonalizedFilter(),
                            vc: {
                                version: 2
                            }
                        },
                        /* Fim botão de filtro */
                        {
                            type: "element",
                            selector: rootSelector + " .top-bar .btn-change-face-group:first",
                            heading: "Botão de troca de modo",
                            html: "Utilize esta opção para alternar entre os modos grade e formulário.<br/><br/>A setinha ao lado abre a opção para configurar a grade, conforme ilustra a imagem abaixo.<br/>Dentro da configuração da grade você encontrará outro botão de tour para lhe auxiliar quando precisar.<br/><br/>" +
                            "<img style='margin-left: 78px' src='/mge/assets/img/opt-configurar-grade.PNG'><br/><br/>",
                            placement: "right",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasGridButton(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .top-bar sk-navigator sk-btn-novo:first",
                            heading: "Novo Registro",
                            html: "Este é novo botão para inclusão de registros.<br/><br/>Ele fica sempre em destaque.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.getNavigatorAPI().showAddButton(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .btn-nav .btn-control:first",
                            heading: "Navegação entre registros",
                            html: "Estas opções permitem a navegação entre os registros da tela.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.getNavigatorAPI().showNavigation(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .btn-nav .btn-remove:first",
                            heading: "Botão de exclusão",
                            html: "Utilize este botão para excluir os registros selecionados.<br/><br/>Fique tranquilo, uma mensagem de confirmação será apresentada antes.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.getNavigatorAPI().showRemoveButton(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .btn-nav .btn-change-face:first",
                            heading: "Botão duplicar",
                            html: "Esta opção duplica o registro selecionado.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.getNavigatorAPI().showCopyButton(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .btn-nav .btn-refresh:first",
                            heading: "Botão atualizar",
                            html: "Esta opção recarrega os registros, respeitando os filtros ativos, caso haja algum.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: dynaformController.getNavigatorAPI().showRefreshButton(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            heading: "Pesquisa de Registros",
                            selector: rootSelector + " .top-bar .entity-search-container:first",
                            html: "Aqui você pode pesquisar por registros.<br/><br/><a class=\"link\" ng-click=\"fnExperimente()\">Experimente!</a>",
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            actions: {
                                fnExperimente: function () {
                                    var input = $element[0].querySelector(sideNavQueryInput);
                                    angular.element(input).focus();
                                }
                            },
                            isEnabled: !dynaformController.isHierarchyDynaform() && dynaformController.hasEntitySearchFieldButton(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            heading: "Favoritos",
                            selector: rootSelector + " .top-bar .btn-favorite:first",
                            html: "Esta opção mostra os registros favoritos. Para marcar um registro como favorito, basta clicar sobre o ícone de estrela do registro.<br/><br/>" +
                            "Veremos como marcar um registro como favorito em breve.",
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasFavoriteButton(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            heading: "Recentes",
                            selector: rootSelector + " .top-bar .btn-recents:first",
                            html: "Esta opção mostra os registros recentemente editados.",
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasRecentsButton(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .btn-export:first",
                            heading: "Exportar dados da grade",
                            html: "Aqui você tem acesso as opções para exportar e imprimir os dados da grade, além dos relatórios personalizados da tela.<br/><br/>" +
                            "Clique no ícone para exportar os dados na grade diretamente para PDF ou clique na setinha para ver as demais opções.<br/><br/>" +
                            "<img width='378px' src='/mge/assets/img/gridprinter-menu.PNG'>",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasConfigButton(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container #dynAttach:first",
                            heading: "Anexos",
                            html: "Aqui você pode anexar documentos e visualizá-los quando quiser.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasEntityAttachButton(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container sk-action-button:first",
                            heading: "Ações",
                            html: "As ações criadas para esta tela serão apresentadas quando este botão for clicado.",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasActionButtons(),
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            selector: rootSelector + " .container .btn-group-config:first",
                            heading: "Configuração da tela",
                            html: "Esse é o botão de configuração da tela.<br/><br/>" +
                            "Através dessa opção é possível configurar a tela sobre vários aspectos, tais como: marcar um campo como obrigatório, criar uma nova aba, reordenar os campos, entre tantas coisas.<br/><br/>" +
                            "Ao clicar no ícone da engrenagem você terá acesso à configuração da tela. Clicando na setinha você pode pesquisar um campo na tela, configurar a numeração da mesma, configurar o layout do formulário, iniciar o tour ou voltar ao layout anterior do sistema.<br/>(As opções de Numeração, Layout do Formulário e Utilizar Layout Anterior podem não estar disponível para você).<br/><br/>" +
                            "<img style='margin-left:85px; width: 200px;' src='/mge/assets/img/dynaform-config-menu.PNG'>",
                            placement: "left",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: /*!dynaformController.isHierarchyDynaform() && */ dynaformController.hasConfigButton(),
                            vc: {
                                version: 2
                            }
                        },
                        {
                            type: "element",
                            heading: "Contador de registros",
                            selector: rootSelector + " .container .btn-rows-counter:first",
                            html: "Informa a quantidade de registros sendo exibidos no momento.<br/><br/>Este número varia de acordo com a quantidade de filtros aplicados e os parâmetros à eles informados.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 1
                            }
                        },
                        {
                            type: "element",
                            heading: "Nova grade",
                            selector: dynaformBodyStringSelector + " sk-datagrid .ui-grid-menu-button",
                            html: "A nova grade está cheia de novidades, por isso criamos um tour separado para ela. Para acessar basta selecionar a opção de tour no menu da grade." +
                            "<br/><br/><img src='/mge/assets/img/dynaform-grid-menu.png'>",
                            placement: "left",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        }];

                    if (dynaformController.showTourDynamicFilter()) {
                        steps.push({
                            type: "element",
                            heading: "Painel de filtros",
                            selector: rootSelector + " .container sk-filter-panel:first",
                            html: "Este é o painel de filtros, aqui você consegue ligar e desligar rapidamente os filtros personalizados, criar um novo e  também realizar filtros rápidos da tela.",
                            placement: "right",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        });
                    } else if (!dynaformController.isHierarchyDynaform()) {
                        steps.push({
                            type: "title",
                            heading: "Painel de filtros",
                            html: "Quando a tela possuir filtros rápidos, " +
                            "eles aparecerão em um painel lateral, mostrando os filtros personalizados e os filtros rápidos." +
                            "<br/><br/><img style='margin-left:55px;' src='/mge/assets/img/painel-filtros.PNG'>",
                            placement: "center",
                            scroll: true,
                            attachToBody: true,
                            vc: {
                                version: 2
                            }
                        });
                    }

                    return steps;
                }

                function saveVisualizedTourParameter(name, hierarchy) {
                    var description = 'Mostrar tour nas novas telas' + hierarchy ? ' hierarquicas ' : ' ' +'HTML5?';

                    if (SkApplication.instance().isSup()) {
                        name += 'S';
                        description += ' (SUP)';
                    }

                    SkApplication.instance().saveMGECoreParameter({
                        name: name,
                        type: 'L',
                        description: description,
                        $: 'N'
                    }, true);
                }

                function saveVersionTourParameter(name) {
                    var description = 'Versão do tour HTML5';

                    if (SkApplication.instance().isSup()) {
                        name += 'S';
                        description += ' (SUP)';
                    }

                    SkApplication.instance().saveMGECoreParameter({
                        name: name,
                        type: 'I',
                        description: description,
                        $: dynaformTourVersion
                    }, true);
                }
            }


            function getFormConfigTour($element, dynaformCtrl, afterEndTour, rootSelector){
                const steps = [];

                steps.push({
                    type: "element",
                    selector: rootSelector + ".form-cfg-columns",
                    heading:"Sabia que você pode configurar o layout do formulário do seu jeito?",
                    html: "<div>No menu de 'Layout do Formulário' você tem três opções de layout, e pode escolher a opção que melhor te atende, sendo elas: Coluna Única Compacta(Configuração Padrão), Coluna Única e Multi-Colunas. <a href='#' ng-click='fnConfigForm()'>Utilize agora</a> </div>",
                    scroll: true,
                    placement: "left",
                    actions: {
                        fnConfigForm: function () {
                            afterEndTour(true);
                        }
                    },
                });

                return {
                        tourConfig : steps,
                        startTour: false,
                        onFinish: () => afterEndTour(false),
                        onSkip: () => afterEndTour(false)
                    };
            }
        }]);

/**
 * @ngdoc overview
 * @name snk.components.dynaform
 *
 * @description
 Módulo de configuração para utilização do Dynaform
 */
angular
    .module('snk.components.dynaform')
    .controller('CopyConfigurationController', ['$scope', 'resourceId', '$popupInstance', 'ServiceProxy', 'MessageUtils', 'SkI18nService', '$timeout', 'SkApplication', function ($scope, resourceId, $popupInstance, ServiceProxy, MessageUtils, SkI18nService, $timeout, SkApplication) {

        $scope.copyCfgOptions = [
            {data: 'T', value: SkI18nService.instant('DynaformConfig.CopyConfig.lblTela')},
            {data: 'F', value: SkI18nService.instant('DynaformConfig.CopyConfig.lblFiltros')},
            {data: 'C', value: SkI18nService.instant('DynaformConfig.CopyConfig.lblAmbos')}];

        $scope.copyCfgRemoverOptions = [
            {data: 'S', value: SkI18nService.instant('Geral.buttonSim')},
            {data: 'N', value: SkI18nService.instant('Geral.buttonNao')}
        ];

        $scope.onCancelWizard = onCancelWizard;
        $scope.onFinishWizard = onFinishWizard;

        $scope.updateCanNext = updateCanNext;

        function onCancelWizard() {
            $popupInstance.dismiss('canceled');
        }

        function onFinishWizard($step) {

            $step.setCanFinish(false);

            var param = {
                TIPOCOPIA: $step.wizardContext.tipCopia,
                MANTERCONFIG: $step.wizardContext.forceRemove,
                RESOURCEID: resourceId,
                usuariosDestino: {
                    CODUSU: []
                }
            };

            var paramOnSuccess = {
                srcUser : undefined,
                destUsers: []
            };

            if ($step.wizardContext.useCurrentUser) {
                param.USARUSULOGADO = true;
            } else {
                param.USARUSULOGADO = false;
                param.CODUSUORIGEM = $step.wizardContext.codUserOrigem;
                paramOnSuccess.srcUser = $step.wizardContext.codUserOrigem;
            }

            for (var i = 0, len = $step.wizardContext.selectedCodUsers.length; i < len; i++) {
                param.usuariosDestino.CODUSU.push({$: $step.wizardContext.selectedCodUsers[i]});
                paramOnSuccess.destUsers.push($step.wizardContext.selectedCodUsers[i]);
            }

            if(paramOnSuccess.srcUser == undefined){
                paramOnSuccess.srcUser = SkApplication.instance().getUserID();
            }

            ServiceProxy.callService('mge@UsuarioSP.copiarConfiguracoes', {param: param})
                .then(function () {
                    MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, SkI18nService.instant('DynaformConfig.CopyConfig.msgInfoCopiabemSucedida'))
                        .then(function () {
                            $popupInstance.success(paramOnSuccess.srcUser, paramOnSuccess.destUsers);
                            $popupInstance.dismiss();
                        }, function () {
                            $popupInstance.success(paramOnSuccess.srcUser, paramOnSuccess.destUsers);
                            $popupInstance.dismiss();
                        });
                }, function () {
                    $step.setCanFinish(true);
                });
        }

        function updateCanNext($step) {
            $timeout(function(){
                var tipCopia = $step.wizardContext.tipCopia;
                var forceRemove = $step.wizardContext.forceRemove;

                $step.setCanNext(angular.isDefined(tipCopia) && angular.isDefined(forceRemove));
            }, 0, false);
        }
    }]);
angular
    .module('snk.components.dynaform')
    .controller('StepUsuDestinoController', ['$scope', '$timeout', '$wizard', '$step', 'ServiceProxy', 'StringUtils', 'DateUtils', 'SkComponentRegistry', 'AngularUtil', 'ArrayUtils', 'Criteria',
        function ($scope, $timeout, $wizard, $step, ServiceProxy, StringUtils, DateUtils, SkComponentRegistry, AngularUtil, ArrayUtils, Criteria) {
            $scope.wizardContext = $wizard.context;

            var PESQCONTENT_DEST = 'copyCfgPesqUserDest';
            var SELECTED_USER_LIST = 'selectedUserListId';

            var pesqContentInstance;
            var sectedUsersListInstance;

            $scope.wizardContext.selectedCodUsers = [];

            $scope.onCodUsuChange = onCodUsuChange;

            $scope.selectData = selectData;
            $scope.updateCanNext = updateCanNext;
            $scope.selectedDestUsersEntity = [];
            $scope.selectAllUsers = selectAllUsers;
            $scope.getAvailableListSize = getAvailableListSize;
            $scope.selectUser = selectUser;
            $scope.unselectUser = unselectUser;
            $scope.unselectAllUsers = unselectAllUsers;
            $scope.copyCfgPesqUserDestId = PESQCONTENT_DEST;
            $scope.selectedUserListId = SELECTED_USER_LIST;

            init();

            function init() {
                updateCanNext();

                SkComponentRegistry.get(PESQCONTENT_DEST)
                    .then(function (instance) {
                        pesqContentInstance = instance;
                    });

                SkComponentRegistry.get(SELECTED_USER_LIST)
                    .then(function (instance) {
                        sectedUsersListInstance = instance;
                    });

                $scope.criteriaProvider = new CriteriaProvider();
                $scope.criteriaProvider.getCriteria = function () {
                    var criteria = Criteria('this.CODUSU != 0 AND (this.DTLIMACESSO IS NULL or this.DTLIMACESSO > ?)', new CriteriaParameter(CriteriaParameter.TYPE_DATE, DateUtils.formatDate(DateUtils.getToday())));

                    if ($scope.codGrupoUsuario) {
                        criteria.and('this.CODGRUPO = ?', Criteria.buildNumberParameter($scope.codGrupoUsuario));
                    }

                    $scope.wizardContext.selectedCodUsers.forEach(function (value) {
                        criteria.and('this.CODUSU != ? ', Criteria.buildNumberParameter(value));
                    });

                    return criteria;
                };
            }

            function onCodUsuChange(){
                pesqContentInstance && pesqContentInstance.loadSuggestions();
            }

            function selectUser() {
                var entityReference = pesqContentInstance.getEntityReference();

                if (entityReference && entityReference.data) {
                    var selectedIndex = pesqContentInstance.getSelectedIndex();

                    var selectedData = entityReference.data[selectedIndex];

                    if (selectedData) {
                        ArrayUtils.removeAtIndex(entityReference.data, selectedIndex);

                        addToSelection(entityReference, selectedData);
                    }
                }
            }

            function selectAllUsers() {
                var entityReference = pesqContentInstance.getEntityReference();

                if (entityReference) {
                    entityReference.data.forEach(function (data) {
                        addToSelection(entityReference, data);
                    });

                    entityReference.data.length = 0;
                }
            }

            function unselectUser() {
                var selections = sectedUsersListInstance.removeSelections();

                var hasChange = false;

                for (var i = 0, len = selections.length; i < len; i++) {
                    removeFromSelection(selections[i]);
                    hasChange = true;
                }

                hasChange && pesqContentInstance.loadSuggestions();
            }

            function unselectAllUsers() {
                var hasChange = false;

                var data;
                while (data = $scope.selectedDestUsersEntity.pop()) {
                    removeFromSelection(data);
                    hasChange = true;
                }

                hasChange && pesqContentInstance.loadSuggestions();
            }

            function addToSelection(entity, data) {
                if (!$scope.entitiesData) {
                    $scope.entitiesData = entity;
                }

                $scope.selectedDestUsersEntity.push(data);
                $scope.wizardContext.selectedCodUsers.push(data['CODUSU']);

                updateCanNext();
            }

            function removeFromSelection(data) {
                ArrayUtils.removeReference($scope.selectedDestUsersEntity, data);
                ArrayUtils.removeReference($scope.wizardContext.selectedCodUsers, data['CODUSU']);

                updateCanNext();
            }

            function selectData(entity, data) {
                addToSelection(entity, data);
            }

            function updateCanNext() {
                $step.setCanNext($scope.selectedDestUsersEntity.length > 0);
            }

            function getAvailableListSize() {
                if (pesqContentInstance) {
                    var entityRef = pesqContentInstance.getEntityReference();

                    return entityRef && entityRef.data ? entityRef.data.length : 0;
                } else {
                    return 0;
                }
            }
        }]);
angular
    .module('snk.components.dynaform')
    .controller('StepUsuOrigemController', ['$scope', '$wizard', '$step', 'ServiceProxy', 'StringUtils', 'DateUtils', 'Criteria',
        function ($scope, $wizard, $step, ServiceProxy, StringUtils, DateUtils, Criteria) {
            $scope.wizardContext = $wizard.context;

            $scope.wizardContext.useCurrentUser = true;
            $scope.wizardContext.codUserOrigem;

            $scope.selectData = selectData;
            $scope.updateCanNext = updateCanNext;

            init();

            function init(){
                updateCanNext();

                $scope.criteriaProvider = new CriteriaProvider();
                $scope.criteriaProvider.getCriteria = function () {
                    return Criteria('this.CODUSU != 0 AND (this.DTLIMACESSO IS NULL or this.DTLIMACESSO > ?)', Criteria.buildDateParameter(DateUtils.formatDate(DateUtils.getToday())));
                };

            }

            function selectData(entity, item) {
                $scope.wizardContext.codUserOrigem = item['CODUSU'];
                updateCanNext();

                $wizard.next();
            }

            function updateCanNext() {
                $step.setCanNext($scope.wizardContext.useCurrentUser || angular.isDefined($scope.wizardContext.codUserOrigem));
            }
        }]);
angular
    .module('snk.components.dynaform').constant("DynaformConfigConstants", {
        "CFG_COPIED": "dynaform.config.copied"
    })
    .controller('SkDynaformConfigController', ['$scope', '$q', '$timeout', '$document', 'SkApplication', 'ServiceProxy', 'FormService', 'ArrayUtils', 'MessageUtils', '$translate', 'AngularUtil', 'StringUtils', 'SkDefaultFilter', '$element', 'SanPopup', 'SkI18nService', 'UserAgentUtils', 'DynaformConfigTourContent', 'ObjectUtils', 'DynaformConfigConstants',
        function ($scope, $q, $timeout, $document, SkApplication, ServiceProxy, FormService, ArrayUtils, MessageUtils, $translate, AngularUtil, StringUtils, SkDefaultFilter, $element, SanPopup, SkI18nService, UserAgentUtils, DynaformConfigTourContent, ObjectUtils, DynaformConfigConstants) {
            var self = this;

            var MAIN_PANEL_NAME = '__main';
            var _fieldConfigProps = ['name', 'userDescription', 'userRequired', 'userReadOnly', 'cleanOnCopy', 'default'];
            var _config;
            var _configuredFields;
            var _originalFields = {};
            var _invisibleTabs;
            var _tabOrder;
            var _tabByField;
            var _fieldOrder;
            var _maxTabOrder = 0;
            var _tabsWithoutField;
            var _updatedFields;
            var _updatedInvisibleTabs;
            var _changed = false;
            var _sourceDynaform;
            var _defaultFilter;
            var _defaultFilterPF;
            var _defaultFilterAssistent;
            var _defaultFilterChanged = false;
            var _openedPopover;
            var closeConfigPromise;
            var configsByDynaform = {};
            var btnDefaultFilterElem;
            var _fieldDictionary = {};

            var _hiddenFieldsByProgrammer = [];
            var _hiddenFieldsFromConfigByProgrammer = [];

            var _obsrevers = [];
            var _tabnavigator;

            $scope.applyConfig = applyConfig;
            $scope.updateFieldConfig = updateFieldConfig;
            $scope.toggleTabVisibility = toggleTabVisibility;
            $scope.restoreConfig = restoreConfig;
            $scope.notifyChange = notifyChange;
            $scope.cancelConfig = cancelConfig;
            $scope.openFilterDefault = openFilterDefault;
            $scope.isFilterDefaultActive = isFilterDefaultActive;
            $scope.openCopyCfg = openCopyCfg;
            $scope.startTour = startTour;

            $scope.$watch('configInfo', function (configInfo) {
                if (configInfo) {
                    $scope.tabsInfo = configInfo.tabsInfo;
                    selectTabIndex(0);
                }
            });

            $scope.onTabnavigatorCreated = onTabnavigatorCreated;
            $scope.onTabChange = onTabChange;
            $scope.selectTabIndex = selectTabIndex;
            $scope.fieldEditPopoverContainer = fieldEditPopoverContainer;
            $scope.getFieldConfigProperties = getFieldConfigProperties;
            $scope.newTab = newTab;
            $scope.deleteTab = deleteTab;
            $scope.sendFieldToSelectedTab = sendFieldToSelectedTab;
            $scope.sendAllFieldsToSelectedTab = sendAllFieldsToSelectedTab;
            $scope.sendFieldToInvisibleFields = sendFieldToInvisibleFields;
            $scope.sendAllFieldsToInvisibleFields = sendAllFieldsToInvisibleFields;
            $scope.sendAllFieldsWithSameTab = sendAllFieldsWithSameTab;
            $scope.filterFields = filterFields;
            $scope.canSendAllFieldsToCurrentTab = canSendAllFieldsToCurrentTab;
            $scope.canRemoveAllFieldsFromCurrentTab = canRemoveAllFieldsFromCurrentTab;

            $scope.isSup = SkApplication.instance().isSup();

            $scope.invisibleFieldsSortableConfig = {
                animation: 0,
                group: 'fields',
                sort: false,
                ghostClass: 'field-item-container sortable-ghost col-xs-12 col-sm-6 col-md-4 col-lg-3',
                onAdd: function () {
                    $scope.configInfo.invisibleFields = ArrayUtils.sortByProperty($scope.configInfo.invisibleFields, 'userDescription', stringSortComparator);
                    $scope.fieldQuery = '';
                    $scope.notifyChange();
                },
                onUpdate: notifyChange
            };

            $scope.fieldSortableConfig = {
                animation: 0,
                group: 'fields',
                filter: '.sk-popover',
                onUpdate: notifyChange,
                onAdd: notifyChange
            };

            $scope.tabsSortableConfig = {
                animation: 0,
                group: 'tabs',
                onSort: function (evt) {
                    if (evt.newIndex != $scope.currentIndex) {
                        selectTabIndex(evt.newIndex);
                    }
                },
                filter: function(evt, target, sortable, index) {
                    return index == 0;
                },
                acceptSort: function(evt, target, index) {
                    return index != 0;
                },
                onUpdate: notifyChange,
                onAdd: notifyChange,
                onOverOtherGroupThrottle: 500,
                onOverOtherGroup: function (evt) {
                    if (evt.sourceGroup == 'fields' && evt.destGroup == 'tabs' && evt.destGroupIndex != $scope.currentIndex) {
                        var newIndex = evt.destGroupIndex;

                        if ($scope.tabsInfo[newIndex]) {
                            AngularUtil.apply($scope, function () {
                                selectTabIndex(evt.destGroupIndex);
                            });
                        }
                    }

                }
            };

            $scope.popoverListener = {
                onOpen: function (popoverInstance) {
                    _openedPopover = popoverInstance;

                    $scope.configOpen = true;
                    $scope.fieldSortableConfig.disabled = true;
                    $scope.invisibleFieldsSortableConfig.disabled = true;
                    $scope.tabsSortableConfig.disabled = true;
                },
                onClose: function () {
                    _openedPopover = undefined;
                    $scope.configOpen = false;
                    $scope.fieldSortableConfig.disabled = false;
                    $scope.invisibleFieldsSortableConfig.disabled = false;
                    $scope.tabsSortableConfig.disabled = false;
                }
            };

            self.loadConfiguration = loadConfiguration;
            self.openConfiguration = openConfiguration;
            self.cancelConfig = cancelConfig;
            self.tabIsInvisible = $scope.tabIsInvisible = tabIsInvisible;
            self.hasConfig = hasConfig;
            self.saveConfig = saveConfig;
            self.hasTabOrder = hasTabOrder;
            self.hasFieldOrder = hasFieldOrder;
            self.fieldHasConfig = fieldHasConfig;
            self.getFieldConfig = getFieldConfig;
            self.getTabOrder = getTabOrder;
            self.getFieldTab = getFieldTab;
            self.getFieldOrder = getFieldOrder;
            self.addOriginalField = addOriginalField;
            self.userAllowPersonalizedFilter = userAllowPersonalizedFilter;
            self.showAllowPersonalizedFilter = showAllowPersonalizedFilter;
            self.getMaxTabOrder = getMaxTabOrder;
            self.getOriginalField = getOriginalField;
            self.isFieldVisibleByUserConfig = isFieldVisibleByUserConfig;
            self.getUserConfig = getUserConfig;
            self.getDefaultFilterAsCriteria = getDefaultFilterAsCriteria;
            self.addObserver = addObserver;
            self.configSavedInHtml5 = configSavedInHtml5;

            //Deve ser a última coisa a ser executada, antes da função de init.
            $scope.dynaformInstance.setDynaformConfig(self);

            init();

            function init() {
                if (UserAgentUtils.isMobile()) {
                    $scope.fieldSortableConfig.handle = '.handle';
                    $scope.invisibleFieldsSortableConfig.handle = '.handle';
                    $scope.tabsSortableConfig.handle = '.handle';
                }
            }

            function openCopyCfg() {
                var popUpInstance = SanPopup.open({
                    title: SkI18nService.instant('DynaformConfig.CopyConfig.lblCopiarPersonalizacao'),
                    templateUrl: 'components/dynaform/dynaformconfig/copyconfig/configcopy.tpl.html',
                    controller: 'CopyConfigurationController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    windowClass: 'modal-message',
                    backdrop: 'static',
                    showBtnOk: false,
                    showBtnCancel: false,
                    showBtnNo: false,
                    resolve: {
                        resourceId: function () {
                            return getResourceId();
                        }
                    }
                });

                popUpInstance.success = function(srcUser, destUsers){
                    notifyObservers(DynaformConfigConstants.CFG_COPIED, {userSrc : srcUser, usersDest: destUsers});
                }
            }

            function startTour() {
                if (!$scope.showTour) {
                    $scope.showTour = true;
                    initTour();
                }

                $scope.tour.startTour = true;
            }

            function initTour() {
                $scope.tour = DynaformConfigTourContent.getDynaformConfigTourContent({
                    startNode: $element,
                    isSup: $scope.isSup
                });
            }

            function filterFields(field) {
                if (!$scope.fieldQuery) {
                    return true;
                }

                var text = StringUtils.replaceAccentuatedChars(field.userDescription.toLowerCase());
                var search = StringUtils.replaceAccentuatedChars($scope.fieldQuery.toLowerCase());

                return text.indexOf(search) > -1;
            }

            function getDefaultFilterAsCriteria() {
                if (_defaultFilter || _defaultFilterPF) {
                    var defaultCriteria = new Criteria();

                    if (_defaultFilter) {
                        defaultCriteria.append('(').append(_defaultFilter).append(')');

                    }

                    if (_defaultFilterPF) {
                        defaultCriteria.and('(').append(_defaultFilterPF).append(')');
                    }

                    return defaultCriteria;
                } else {
                    return undefined;
                }
            }

            function isFilterDefaultActive() {
                return angular.isDefined(getDefaultFilterAsCriteria());
            }

            function openFilterDefault() {
                var defaultFilter = SkDefaultFilter.open(_sourceDynaform.getEntityName(), getResourceId(), _defaultFilterAssistent, _defaultFilterPF);

                defaultFilter.then(function (result) {
                    if (!result) {
                        return;
                    }

                    if (result.filterPFDeleted) {
                        filterPFDeleted();
                    }

                    if (_defaultFilter != result.expression) {
                        _defaultFilterChanged = true;
                    }

                    if (result.expression) {
                        _defaultFilter = result.expression;
                    } else {
                        _defaultFilter = undefined;
                    }

                    if (result.filter) {
                        _defaultFilterAssistent = result.filter;
                    } else {
                        _defaultFilterAssistent = undefined;
                    }

                    if (result.expression || result.filter) {
                        _changed = true;
                    }

                    applyClassBtnFilter();
                }, function (result) {
                    if (result && result.filterPFDeleted) {
                        filterPFDeleted();
                        applyClassBtnFilter();
                    }
                });
            }

            function filterPFDeleted() {
                _defaultFilterPF = undefined;

                var config = SkApplication.instance().getConfiguracaoTela(getResourceId());

                if (config) {
                    delete config.defaultFilterPF;
                    SkApplication.instance().putConfiguracaoTela(getResourceId(), config);
                }

                _defaultFilterChanged = true;
            }


            function loadConfiguration(sourceDynaform) {
                _sourceDynaform = $scope.sourceDynaform = sourceDynaform;
                _hiddenFieldsFromConfigByProgrammer = _sourceDynaform.getHiddenFieldsFromConfig();
                _hiddenFieldsByProgrammer = _sourceDynaform.getHiddenFieldsByProgrammer();

                var config = SkApplication.instance().getConfiguracaoTela(getResourceId());

                readConfig(config);
            }

            function getResourceId() {
                return _sourceDynaform.getResourceId(_sourceDynaform.getEntityName());
            }

            function openConfiguration(sourceDynaform, path) {
                if (closeConfigPromise) {
                    closeConfigPromise.reject();
                }

                closeConfigPromise = $q.defer();

                closeConfigPromise.promise.finally(function () {
                    showBodyScroll();

                    if (_openedPopover) {
                        _openedPopover.hide();
                    }
                });

                loadConfiguration(sourceDynaform);

                $scope.configInfo = buildConfigInfo();
                $scope.entityPath = path;

                $scope.fieldQuery = '';

                return closeConfigPromise.promise;
            }

            function readConfig(config) {
                if (_config == config) {
                    return;
                }

                _config = config;

                self.allowPersonalizedFilter = _config && StringUtils.toBoolean(_config.allowPersonalizedFilter) ? 'S' : 'N';

                _changed = false;
                _tabsWithoutField = {};

                _configuredFields = buildConfiguredFields();
                _invisibleTabs = buildInvisibleTabs();
                _tabOrder = buildTabOrder();

                buildDefaultFilter();

                if (_config && _config.ignoreValidation === true) {
                    _config = undefined;
                }

                var tabByFieldAndOrder = buildTabByFieldAndOrder();

                if (tabByFieldAndOrder) {
                    _tabByField = tabByFieldAndOrder.tabByField;
                    _fieldOrder = tabByFieldAndOrder.fieldOrder;
                } else {
                    _tabByField = _fieldOrder = undefined;
                }
            }

            function buildDefaultFilter() {
                if (_config && _config.defaultFilterAssistent) {
                    _defaultFilterAssistent = _config.defaultFilterAssistent;
                } else {
                    _defaultFilterAssistent = undefined;
                }

                if (_config) {
                    _defaultFilterPF = ObjectUtils.getProperty(_config, 'defaultFilterPF.$');
                }

                if (_config && _config.defaultFilter && _config.defaultFilter.hasOwnProperty('$') && !StringUtils.isEmpty(_config.defaultFilter['$'])) {
                    _defaultFilter = _config.defaultFilter['$'];

                    //Efetuamos essas tratativas abaixo, pois se é um filtro criado/editado no Flex, precisamos atualizar a expressão
                    if (!_defaultFilterAssistent) {
                        _defaultFilterAssistent = {};
                    }

                    if (!_defaultFilterAssistent.filterModel) {
                        _defaultFilterAssistent.filterModel = {};
                    }

                    var expression = {};
                    expression['$'] = _defaultFilter;

                    //Caso um filtro tenha sido inserido/editado no Flex, garantimos que nunca haverá o modo assistente para esse filtro.
                    if (_defaultFilterAssistent.filterModel.expression && _defaultFilterAssistent.filterModel.expression.hasOwnProperty('$')) {
                        if (_defaultFilterAssistent.filterModel.expression['$'] != _defaultFilter) {
                            if (_defaultFilterAssistent.filterModel.assistent) {
                                delete _defaultFilterAssistent.filterModel.assistent;
                            }
                        }
                    }

                    _defaultFilterAssistent.filterModel.expression = expression;
                } else {
                    _defaultFilter = undefined;
                }

                applyClassBtnFilter();
            }

            function applyClassBtnFilter() {
                if (!btnDefaultFilterElem) {
                    var elems = $element[0].querySelector('.btn-filter-default');

                    if (elems) {
                        btnDefaultFilterElem = angular.element(elems);
                    }
                }

                if (btnDefaultFilterElem) {
                    btnDefaultFilterElem[isFilterDefaultActive() ? 'addClass' : 'removeClass']('btn-danger');
                }
            }

            function canSendFieldToOtherGroup(field) {
                return $scope.currentTab && $scope.currentTab.type == 'form' && !$scope.configOpen;
            }

            function canSendAllFieldsToCurrentTab() {
                return canSendFieldToOtherGroup() && $scope.configInfo.invisibleFields.length > 0;
            }

            function canRemoveAllFieldsFromCurrentTab() {
                return canSendFieldToOtherGroup() && $scope.currentTab.fields.length > 0;
            }

            function sendAllFieldsToSelectedTab() {
                var filteredList = $scope.configInfo.invisibleFields.filter(filterFields);

                for (var i = 0, len = filteredList.length; i < len; i++) {
                    var field = filteredList[i];

                    $scope.currentTab.fields.push(field);

                    ArrayUtils.removeReference($scope.configInfo.invisibleFields, field);

                    _changed = true;
                }
            }

            function sendAllFieldsToInvisibleFields() {
                for (var i = 0, len = $scope.currentTab.fields.length; i < len; i++) {
                    var field = $scope.currentTab.fields[i];
                    $scope.configInfo.invisibleFields.push(field);
                }

                $scope.currentTab.fields.length = 0;
                _changed = true;
            }

            function sendFieldToSelectedTab(field) {
                if (canSendFieldToOtherGroup(field)) {
                    ArrayUtils.removeReference($scope.configInfo.invisibleFields, field);

                    $scope.currentTab.fields.push(field);
                    _changed = true;
                }
            }

            function sendFieldToInvisibleFields(field) {
                if (canSendFieldToOtherGroup(field)) {
                    ArrayUtils.removeReference($scope.currentTab.fields, field);

                    $scope.configInfo.invisibleFields.push(field);

                    ArrayUtils.sortByProperty($scope.configInfo.invisibleFields, 'userDescription', stringSortComparator);

                    $scope.fieldQuery = '';

                    _changed = true;
                }
            }

            function sendAllFieldsWithSameTab(field) {
                var tab = ArrayUtils.find($scope.configInfo.tabsInfo, function(currTab) {
                    return field.tabId == currTab.tabName;
                });

                if (tab) {
                    selectTabIndex($scope.tabsInfo.indexOf(tab));
                } else {
                    tab = createTab(field.tabName);
                }

                $scope.configInfo.invisibleFields.filter(function(currField) {
                    return currField.tabId == tab.tabName;
                }).forEach(sendFieldToSelectedTab);
            }

            function validateConfig() {
                if (_config) {
                    if (!_config.layout) {
                        if (_config.ignoreValidation === true) {
                            return false;
                        }

                        throw new Error('A configuração com ResourceID = ' + getResourceId() + ' não é válida');
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            }

            function addOriginalField(field) {
                if (_originalFields && _originalFields[field.name]) {
                    return;
                }

                _originalFields[field.name] = angular.copy(field);
            }

            function getOriginalField(fieldName) {
                return _originalFields && _originalFields[fieldName];
            }

            function hasConfig() {
                return angular.isDefined(_config);
            }

            function userAllowPersonalizedFilter() {
                return angular.isDefined(_config) ? _config.allowPersonalizedFilter : false;
            }

            function hasTabOrder() {
                return angular.isDefined(_tabOrder);
            }

            function getTabOrder(tabDescr) {
                return _tabOrder[tabDescr];
            }

            function getMaxTabOrder() {
                return _maxTabOrder;
            }

            function hasFieldOrder() {
                return angular.isDefined(_fieldOrder);
            }

            function getFieldOrder(name) {
                return _fieldOrder ? _fieldOrder[name] : -1;
            }

            function tabIsInvisible(title) {
                return (_invisibleTabs && _invisibleTabs.hasOwnProperty(title) ? true : false);
            }

            function toggleTabVisibility(tab) {
                tab.visible = !tab.visible;

                if (!_updatedInvisibleTabs) {
                    _updatedInvisibleTabs = {};
                }

                _updatedInvisibleTabs[tab.tabName] = tab.visible;

                notifyChange();
            }

            function fieldHasConfig(name) {
                return _configuredFields && _configuredFields.hasOwnProperty(name) ? true : false;
            }

            function getFieldConfig(name) {
                return fieldHasConfig(name) ? _configuredFields[name] : undefined;
            }

            function getFieldTab(fieldName) {
                return _tabByField ? _tabByField[fieldName] : undefined;
            }

            function notifyChange() {
                _changed = true;
            }

            function updateFieldConfig(fieldConfig) {
                _updatedFields = _updatedFields || {};

                fieldConfig = angular.copy(fieldConfig);

                angular.forEach(fieldConfig, function (value, key) {
                    if (_fieldConfigProps.indexOf(key) == -1) {
                        delete fieldConfig[key];
                    }

                    if (key == 'default') {
                        var defaultValue = fieldConfig.default.type == 'F' ? fieldConfig.default.fixedValue : fieldConfig.default.variableValue;
                        value.$ = angular.isDefined(defaultValue) ? defaultValue.toString() : '';

                        delete value['fixedValue'];
                        delete value['variableValue'];
                    }
                });

                _updatedFields[fieldConfig.name] = fieldConfig;
            }

            function buildTabByFieldAndOrder() {
                if (!validateConfig()) {
                    return;
                }

                var configTabs = _config.layout.workspace.tab;

                var tabByField;
                var fieldOrder;

                if (angular.isArray(configTabs)) {
                    tabByField = {};
                    fieldOrder = {};

                    extraTabs = [];
                    
                    configTabs.forEach(function (tab, tabOrder) {
                        var tabName = tab.title;

                        if (tab.field && tab.field.length > 0) {
                            var tabWithExtraFields = false;
                            tab.field.forEach(fieldTest => {
                                if(_fieldDictionary[fieldTest.name] && _fieldDictionary[fieldTest.name].userType == "customBlock"){
                                    tabWithExtraFields = true;
                                }
                            })
                            
                            if(tabWithExtraFields && tab.field.length > 1){
                                tempFields = [];
                                var order = 0;
                                tab.field.forEach(field => {
                                    if(_fieldDictionary[field.name] && _fieldDictionary[field.name].userType == "customBlock"){
                                        var fieldName = field.name;
    
                                        tabByField[fieldName] = tabName;
                                        fieldOrder[fieldName] = order++;
                                    } else{
                                        tempFields.push(field);
                                        extraTabs.push({tabName: `${tabName} `, tabField: tempFields});
                                    }
                                });
                            } else{
                                var order = 0;

                                tab.field.forEach(function (field) {
                                    var fieldName = field.name;
    
                                    tabByField[fieldName] = tabName;
                                    fieldOrder[fieldName] = order++;
                                });
                            }
                        } else {
                            _tabsWithoutField[tabName] = tabOrder;
                        }
                    });

                    if(extraTabs.length > 0){
                        extraTabs.forEach(extraTab => {
                            var order = 0;

                            extraTab.tabField.forEach(function (field) {
                                var fieldName = field.name;

                                tabByField[fieldName] = extraTab.tabName;
                                fieldOrder[fieldName] = order++;
                            });
                        })
                    }
                }

                var mainPanelFields = _config.layout.workspace.mainPanel;

                if (mainPanelFields && angular.isArray(mainPanelFields.field)) {
                    if (!tabByField) {
                        tabByField = {};
                    }

                    if (!fieldOrder) {
                        fieldOrder = {};
                    }

                    var tabName = MAIN_PANEL_NAME;
                    var order = 0;

                    mainPanelFields.field.forEach(function (field) {
                        var fieldName = field.name;

                        tabByField[fieldName] = tabName;
                        fieldOrder[fieldName] = order++;
                    });
                }

                return {
                    tabByField: tabByField,
                    fieldOrder: fieldOrder
                };
            }

            function buildConfiguredFields() {
                if (!validateConfig()) {
                    return;
                }

                var fieldsJson = _config.fields ? _config.fields.field : undefined;

                if (!fieldsJson) {
                    return undefined;
                }

                var configuredFields = {};
                
                if(!angular.isArray(fieldsJson)) {
                    fieldsJson = [fieldsJson];
                }

                fieldsJson.forEach(function (field) {
                    configuredFields[field.name] = field;
                });

                return configuredFields;
            }

            function buildInvisibleTabs() {
                if (!validateConfig()) {
                    return;
                }

                var invisibleTabs = _config.layout.workspace.invisibleTabs;

                if (!invisibleTabs || !angular.isArray(invisibleTabs.tab)) {
                    return undefined;
                }

                var processedInvTabs = {};

                invisibleTabs.tab.forEach(function (item) {
                    processedInvTabs[item.title] = undefined;
                });

                return processedInvTabs;
            }

            function buildTabOrder() {
                if (!validateConfig()) {
                    return;
                }

                var tabOrder = _config.layout.workspace.tabOrder;

                if (!tabOrder || !angular.isArray(tabOrder.tab)) {
                    return undefined;
                }

                var processedTabOrder = {};

                tabOrder.tab.forEach(function (tab, index) {
                    processedTabOrder[tab.title] = index;
                });

                _maxTabOrder = tabOrder.tab.length;

                return processedTabOrder;
            }

            function buildConfigInfo() {
                _changed = false;

                var layoutInfo = ObjectUtils.clone(_sourceDynaform.getLayoutInfo());//angular.copy(_sourceDynaform.getLayoutInfo());
                var isConfigSavedInHtml5 = self.configSavedInHtml5();

                var info = {
                    invisibleFields: [],
                    allFields: {}
                };

                (ObjectUtils.clone(layoutInfo.invisibleFields)/*angular.copy(layoutInfo.invisibleFields)*/ || []).forEach(function (field) {
                    if (!_hiddenFieldsFromConfigByProgrammer.hasOwnProperty(field.name)) {
                        var configField = buildConfigFieldFromMD(field);

                        info.invisibleFields.push(configField);
                        info.allFields[field.name] = configField;
                    }

                });

                info.invisibleFields = info.invisibleFields.sort(function (itemA, itemB) {
                    var valueA = itemA.userDescription || itemA.systemDescription;
                    var valueB = itemB.userDescription || itemB.systemDescription;

                    return stringSortComparator(valueA, valueB);
                });

                info.tabsInfo = [
                    buildTabConfigMd(layoutInfo.mainTabInfo || {
                        tabName: MAIN_PANEL_NAME,
                        fields: [],
                        type: 'form',
                        visible: true
                    }, info)
                ]
                .concat(layoutInfo
                    .tabsInfo
                    .filter(function (tab) {
                        return tab.customBlockTab ? !tab.hidden : tab.tabName != MAIN_PANEL_NAME;
                    })
                    .map(function(tab) {
                        return buildTabConfigMd(tab, info);
                    })
                );

                angular.forEach(_tabsWithoutField, function (tabOrder, tabName) {
                    if (info.tabsInfo.findIndex(item => item.tabName === tabName) === -1) {
                        if (_tabOrder && _tabOrder.hasOwnProperty(tabName)) {
                            tabOrder = _tabOrder[tabName] + 1;
                        }
                        ArrayUtils.insertAtIndex(info.tabsInfo, tabOrder, {
                            tabName: tabName,
                            type: 'form',
                            fields: [],
                            visible: !tabIsInvisible(tabName)
                        });
                    } else if (!isConfigSavedInHtml5) {
                        delete _tabsWithoutField[tabName];
                    }
                });

                var allGeneralFields = {};
                layoutInfo.allGeneralFields.forEach(function (field) {
                    allGeneralFields[field.name] = field;
                });

                info.allGeneralFields = allGeneralFields;

                return info;
            }

            function buildTabConfigMd(tab, info) {
                var configTab = {
                    tabName: tab.tabName,
                    type: tab.type,
                    visible: tab.visible
                };

                if (configTab.tabName == MAIN_PANEL_NAME) {
                    configTab.title = SkI18nService.instant('Dynaform.lblPainelPrincipal');
                }

                if (tab.type != 'dynaform' && tab.fields) { //não é relacionamento
                    var configFields = [];

                    tab.fields.forEach(function (field) {
                        var configField = buildConfigFieldFromMD(field);
                        configFields.push(configField);
                        info.allFields[field.name] = configField;
                    });

                    for (hiddenField in _hiddenFieldsByProgrammer) {
                        if (!_hiddenFieldsFromConfigByProgrammer.hasOwnProperty(hiddenField) && isFieldVisibleByUserConfig(hiddenField)) {
                            var tabName = _sourceDynaform.getFieldTabName(hiddenField);
                            if (tabName == tab.tabName) {
                                var configField = buildConfigFieldFromMD(_sourceDynaform.getDataset().getFieldMetadata(hiddenField));
                                configFields.push(configField);
                            }
                        }
                    }
                    configTab.fields = configFields;
                }

                return configTab;
            }

            function buildConfigFieldFromMD(field) {
                if(!_fieldDictionary[field.name]){
                    _fieldDictionary[field.name] = field;
                }
                
                var fieldConfig = getFieldConfig(field.name);

                var origField = (_originalFields && _originalFields[field.name]) || field;

                var required = isRequired(origField) ? 'S' : 'N';
                var readOnly = isReadOnly(origField) ? 'S' : 'N';

                var hasDefault = fieldConfig && fieldConfig.default;
                var defaultType = hasDefault ? fieldConfig.default.type : 'F';

                var isFixed = defaultType == 'F';

                var userRequired = fieldConfig && fieldConfig.hasOwnProperty('userRequired') ? fieldConfig.userRequired : required;
                var userReadOnly = fieldConfig && fieldConfig.hasOwnProperty('userReadOnly') ? fieldConfig.userReadOnly : readOnly;

                var cleanOnCopy = fieldConfig && fieldConfig.hasOwnProperty('cleanOnCopy') ? fieldConfig.cleanOnCopy : (field.cleanOnCopy ? 'S' : 'N');

                var tabId = _sourceDynaform.getFieldTabName(field.name);
                var tabName =  tabId;
                
                if (tabName == MAIN_PANEL_NAME) {
                    tabName = SkI18nService.instant('Dynaform.lblPainelPrincipal');
                }

                return {
                    systemDescription: origField.description,
                    userDescription: fieldConfig ? fieldConfig.userDescription || field.description : field.description,
                    dataType: field.dataType,
                    userType: FormService.getUserType(field),
                    checkbox: field.checkbox,
                    name: field.name,
                    fk: field.fk,
                    allowDefault: allowDefault(field) ? 'S' : 'N',
                    systemRequired: required,
                    userRequired: userRequired,
                    systemReadOnly: readOnly,
                    userReadOnly: userReadOnly,
                    cleanOnCopy: cleanOnCopy,
                    'default': {
                        type: defaultType,
                        fixedValue: hasDefault && isFixed ? fieldConfig.default.$ : '',
                        variableValue: hasDefault && !isFixed ? fieldConfig.default.$ : ''
                    },
                    tabId: tabId,
                    options:field.options,
                    tabName: tabName
                };
            }

            function isRequired(field) {
                return field.required;
            }

            function isReadOnly(field) {
                if (_sourceDynaform.isDetailDynaform() && field.name == _sourceDynaform.getAutoNumFieldName()) {
                    return true;
                }

                return field.readOnly;
            }

            function allowDefault(field) {
                return 'B' !== field.userType && field.allowDefault;
            }

            function cancelConfig() {
                if (_changed) {
                    MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, SkI18nService.instant('DynaformConfig.msgConfirmCancelarConfiguracao'), SkI18nService.instant('Geral.lblSalvar'), SkI18nService.instant('Geral.lblDescartar'), true)
                        .then(function () {
                            applyConfig();
                        }, function (reason) {
                            if (reason == 'no') {
                                applyConfig(true);
                                closeConfigPromise.resolve();
                            }
                            else if (reason == 'cancel') {
                                //Nada a fazer
                            }
                        });

                } else {
                    closeConfigPromise.resolve();
                }
            }

            function applyConfig(discardEdit) {
                
                if (!_changed && angular.isUndefined($scope.imageValidation)) {
                    closeConfigPromise.resolve();
                    return;
                }

                var tabOrder = [];
                var tabs = [];
                var invisibleTabs = [];
                var fields;
                var mainPanel;

                if (_updatedFields) {
                    if (!_configuredFields) {
                        _configuredFields = {};
                    }

                    angular.forEach(_updatedFields, function (value, key) {
                        _configuredFields[key] = value;
                    });
                }

                if (_configuredFields) {
                    angular.forEach(_configuredFields, function (value) {
                        if (!fields) {
                            fields = [];
                        }

                        fields.push(value);
                    });
                }

                if (_updatedInvisibleTabs) {
                    if (!_invisibleTabs) {
                        _invisibleTabs = {};
                    }

                    angular.forEach(_updatedInvisibleTabs, function (value, key) {
                        if (value) {
                            delete _invisibleTabs[key];
                        } else {
                            _invisibleTabs[key] = undefined;
                        }
                    });
                }

                if (_invisibleTabs) {
                    angular.forEach(_invisibleTabs, function (value, key) {
                        invisibleTabs.push({
                            title: key
                        });
                    });
                }

                $scope.configInfo.tabsInfo.forEach(function (tab) {
                    if (tab.tabName != MAIN_PANEL_NAME) {
                        tabOrder.push({
                            title: tab.tabName
                        });
                    }

                    if (tab.type == 'form') {
                        var tabElem = {
                            field: tab.fields.map(function (field) {
                                return {
                                    name: field.name
                                };
                            })
                        };

                        if (tab.tabName == MAIN_PANEL_NAME) {
                            mainPanel = tabElem;
                        } else {
                            tabElem.title = tab.tabName;
                            tabs.push(tabElem);
                        }
                    }
                });

                var formConfig = {
                    resourceID: getResourceId(),
                    allowPersonalizedFilter: self.allowPersonalizedFilter,
                    fields: {
                        field: fields
                    },
                    layout: {
                        workspace: {
                            invisibleTabs: {
                                tab: invisibleTabs
                            },
                            tabOrder: {
                                tab: tabOrder
                            },
                            mainPanel: mainPanel,
                            tab: tabs
                        }
                    }
                };

                if (!StringUtils.isEmpty(_defaultFilter)) {
                    formConfig.defaultFilter = {
                        '$': _defaultFilter
                    };
                }

                if (_defaultFilterAssistent) {
                    formConfig.defaultFilterAssistent = _defaultFilterAssistent;
                }
                
                if ($scope.imageValidation) {
                    if(angular.isDefined(_updatedFields) && _updatedFields.hasOwnProperty("IMAGEM")){
                        if(_updatedFields.IMAGEM.userReadOnly=='S' && _updatedFields.IMAGEM.userRequired=='S'){
                          
                            if(angular.isUndefined(discardEdit)){
                                MessageUtils.showAlert('O Campo de "IMAGEM" não pode ser habilitado como obrigatório e protegido simultaneamente!');
                                return;
                            }
                            var configField = $scope.configInfo.allGeneralFields["IMAGEM"];
    
                            if(!configField.required){
                                formConfig.fields.field[0].userRequired='N';
                            }
                            if(!configField.readOnly){
                                formConfig.fields.field[0].userReadOnly='N';
                            }
                            
                            readConfig(formConfig);
                        }
                    }
                }

                saveConfig(formConfig).then(function () {
                    closeConfigPromise.resolve();
                });
            }

            function saveConfig(formConfig) {
                var tabs = ObjectUtils.getProperty(formConfig, 'layout.workspace.tab');

                tabs.forEach(function (tab) {
                    for (hiddenField in _hiddenFieldsFromConfigByProgrammer) {
                        var tabName = _sourceDynaform.getFieldTabName(hiddenField);
                        if (isFieldVisibleByUserConfig(hiddenField) && tabName == tab.title) {
                            tab.field.push({name: hiddenField});
                        }
                    }
                });

                if (angular.isDefined($scope.beforePostConfig) && $scope.beforePostConfig({formConfig: formConfig}) === false) {
                    return $q(function (resolve, reject) {
                        reject();
                    });
                }

                formConfig['isHtml5'] = true;

                return ServiceProxy.callService('DynaformBuilder.saveFormConfig', {
                    formConfig: formConfig
                }).then(function () {
                    if (_defaultFilterPF) {
                        formConfig.defaultFilterPF = {
                            $: _defaultFilterPF
                        };
                    }

                    SkApplication.instance().putConfiguracaoTela(getResourceId(), formConfig);

                    readConfig(formConfig);

                    _sourceDynaform.rebuildLayout(_defaultFilterChanged);
                    _sourceDynaform.getDataset().refreshCurrentRow();
                });
            }

            function restoreConfig() {
                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, SkI18nService.instant('DynaformConfig.msgConfirmRestauracao'))
                    .then(function () {
                        ServiceProxy.callService('DynaformBuilder.restoreConfig', {
                            formConfig: {
                                resourceID: getResourceId(),
                                html5: true
                            }
                        }).then(function (result) {
                            var newConfig = ObjectUtils.getEmptyAsUndefined(result.responseBody);

                            SkApplication.instance().putConfiguracaoTela(getResourceId(), newConfig);

                            readConfig(newConfig);

                            _sourceDynaform.rebuildLayout(_defaultFilterChanged);
                            _sourceDynaform.getDataset().refreshCurrentRow();

                            closeConfigPromise.resolve();
                        });
                    });
            }

            function onTabnavigatorCreated(ctrl) {
                _tabnavigator = ctrl;
            }

            function onTabChange() {
                $scope.currentTab = $scope.tabsInfo[_tabnavigator.getCurrentTabIndex()];
            }

            function createTab(tabName) {
                if (!tabName) {
                    throw Error('Nome da aba não pode ser vazio.');
                }

                var tab = {
                    tabName: tabName,
                    type: 'form',
                    visible: true,
                    fields: []
                };

                $scope.tabsInfo.push(tab);

                selectTabIndex($scope.tabsInfo.length - 1);

                $scope.notifyChange();

                return tab;
            }

            function newTab(tabName) {
                if (!tabName || '' == tabName) {
                    return false;
                }

                createTab(tabName);

                return true;
            }

            function fieldEditPopoverContainer(e, popOpverElem) {
                var curElem = e.currentTarget;

                var clickedBlock;
                do {
                    if (curElem.attributes.hasOwnProperty('field-block-reference')) {
                        clickedBlock = angular.element(curElem);
                        break;
                    }
                } while ((curElem = curElem.parentElement) != undefined);

                if (clickedBlock) {
                    var container = clickedBlock[0].parentElement;
                    var containerChilds = container.children;
                    var clickedBlockIndex = clickedBlock.index();
                    var clickedBlockYPos = clickedBlock.offset().top;

                    var referenceBlock = clickedBlock;

                    for (var i = (clickedBlockIndex + 1); i < containerChilds.length; i++) {
                        var nextRef = angular.element(containerChilds[i]);

                        if (nextRef.offset().top == clickedBlockYPos) {
                            referenceBlock = nextRef;
                        } else {
                            break;
                        }
                    }

                    popOpverElem.css('position', 'relative');
                    popOpverElem.css('float', 'left');
                    popOpverElem.css('width', '100%');
                    referenceBlock.after(popOpverElem);
                } else {
                    throw new Error('Não foi possível determinar o ponto de inclusão do formulário de edição de campos.');
                }
            }

            function setFieldModified(newConfigField) {
                var configField = $scope.configInfo.allGeneralFields[newConfigField.name];

                var isSystemRequired = newConfigField.systemRequired == 'S';

                var isUserRequired = newConfigField.userRequired == 'S';
                var oldIsUserRequired = configField.userRequired == 'S';

                var oldIsRequired = isSystemRequired || oldIsUserRequired;
                var isRequired = isSystemRequired || isUserRequired;

                var hasChanged = false;

                if (!isSystemRequired) {
                    if (isRequired) {
                        configField.userRequired = 'S';
                    } else {
                        delete configField['userRequired'];
                    }

                    hasChanged = oldIsRequired != isRequired;
                }

                if (configField.systemDescription != newConfigField.userDescription) {

                    if (StringUtils.isEmpty(newConfigField.userDescription)) {
                        configField.userDescription = configField.systemDescription;
                    } else {
                        configField.userDescription = newConfigField.userDescription;
                    }

                    hasChanged = true;
                } else if (configField.hasOwnProperty('userDescription')) {
                    delete configField['userDescription'];
                    hasChanged = true;
                }

                if (!angular.equals(configField.default, newConfigField.default)) {
                    var isFixedDefault = newConfigField.default.type == 'F';
                    var newDefaultValue = newConfigField.default[isFixedDefault ? 'fixedValue' : 'variableValue'];

                    if (StringUtils.isEmpty(newDefaultValue) && isFixedDefault) {
                        delete configField['default'];
                    } else {
                        configField.default = newConfigField.default;
                    }

                    hasChanged = true;
                }

                if (newConfigField.userReadOnly == 'S') {
                    hasChanged = true;
                    configField.userReadOnly = 'S';
                } else {
                    delete configField['userReadOnly'];
                    hasChanged = true;
                }

                if (newConfigField.hasOwnProperty('cleanOnCopy')) {
                    hasChanged = true;
                    configField.cleanOnCopy = newConfigField.cleanOnCopy;
                } else {
                    delete configField['cleanOnCopy'];
                    hasChanged = true;
                }

                if (hasChanged) {
                    $scope.updateFieldConfig(configField);
                    $scope.notifyChange();
                }
            }

            function getFieldConfigProperties(field) {
                var configField = angular.copy(field);

                var uptatedProps = _updatedFields && _updatedFields[field.name];

                if (uptatedProps) {
                    ['cleanOnCopy', 'userDescription', 'userRequired', 'userReadOnly'].forEach(function(propName) {
                        if (uptatedProps.hasOwnProperty(propName)) {
                            configField[propName] = uptatedProps[propName];
                        }
                    });
                }

                return {
                    field: configField,
                    setFieldModified: setFieldModified
                }
            }

            function deleteTab(currentTab) {
                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, SkI18nService.instant('DynaformConfig.msgConfirmDeletarAba'))
                    .then(function () {
                        doDeleteTab(currentTab);
                    });
            }

            function doDeleteTab(currentTab) {
                var field;
                while (field = currentTab.fields.pop()) {
                    $scope.configInfo.invisibleFields.push(field);
                }

                $scope.configInfo.invisibleFields = ArrayUtils.sortByProperty($scope.configInfo.invisibleFields, 'userDescription', stringSortComparator);

                ArrayUtils.removeReference($scope.tabsInfo, currentTab);

                selectTabIndex($scope.tabsInfo.length - 1);

                $scope.notifyChange();
            }

            function stringSortComparator(a, b) {
                var strA = a.toString().toLowerCase();
                var strB = b.toString().toLowerCase();

                return strA === strB ? 0 : (strA < strB ? -1 : 1);
            }

            function selectTabIndex(newIndex) {
                if (newIndex > -1) {
                    $scope.tabSelectedIndex = newIndex;
                    $scope.currentTab = $scope.tabsInfo[newIndex];

                    $scope.currentTabVisible = !$scope.tabIsInvisible($scope.currentTab.tabName);
                }
            }

            function showAllowPersonalizedFilter() {
                return _sourceDynaform ? _sourceDynaform.isDetailDynaform() : false;
            }

            function showBodyScroll() {
                $document.find('body').css('position', 'static');
            }

            function isFieldVisibleByUserConfig(fieldName) {
                if (!fieldName || fieldName == "") {
                    return false;
                }

                var config = getUserConfig();

                //Se não há configuração do usuário, então o campo "está visível".
                //Pode ser que outro mecanismo oculte o campo, mas pela config. do usuário o campo está visível.
                if (angular.isUndefined(config)) {
                    return true;
                }

                if (ObjectUtils.getProperty(config, 'layout.workspace.mainPanel.field')) {
                    for (var i = 0, len = config.layout.workspace.mainPanel.field.length; i < len; i++) {
                        if (config.layout.workspace.mainPanel.field[i].name == fieldName) {
                            return true;
                        }
                    }
                }

                if (ObjectUtils.getProperty(config, 'layout.workspace.tab')) {
                    for (var i = 0, len = config.layout.workspace.tab.length; i < len; i++) {
                        var field = config.layout.workspace.tab[i].field;
                        if (field) {
                            for (var j = 0, length = field.length; j < length; j++) {
                                if (field[j].name == fieldName) {
                                    return true;
                                }
                            }
                        }
                    }
                }

                return false;
            }

            function getUserConfig() {
                return SkApplication.instance().getConfiguracaoTela(getResourceId());
            }

            function addObserver(observer){
                ObjectUtils.isImplementorOf(observer, IDynaformConfigObserver);

                if(_obsrevers.indexOf(observer) == -1){
                    _obsrevers.push(observer);
                }
            }

            function notifyObservers(evt, param){
                _obsrevers.forEach(function(obs){
                    switch(evt){
                        case DynaformConfigConstants.CFG_COPIED:
                            obs.configCopied(param.userSrc, param.usersDest);
                        break;
                    }
                })
            }

            function configSavedInHtml5() {
                return angular.isDefined(_config) && StringUtils.toBoolean(_config.isHtml5);
            }
        }]);

angular
    .module('snk.components.dynaform')
    .directive('skDynaformConfig', function(){
        function linker(scope, element, attrs, controller) {
            if (attrs.id) {
                scope.$parent[attrs.id] = controller;
            }
        }

        return {
            restrict: 'E',
            templateUrl: 'components/dynaform/dynaformconfig/dynaformconfig.tpl.html',
            controller: 'SkDynaformConfigController',
            controllerAs: 'ctrl',
            scope: {
                entityName: '@skEntityName',
                resourceId: '@skResourceId',
                dynaformInstance: '=skDynaformInstance',
                allowConfig: '=skAllowConfig',
                beforePostConfig: '&?skBeforePostConfig',
                imageValidation: '=?skImageValidation'
            },
            link: linker
        }
    });
angular
    .module('snk.components.dynaform')
    .controller('SkDynaformConfigFieldConfigController', ['$scope', '$translate', '$timeout', 'FormService', 'StringUtils', 'DatasetUtils', 'MessageUtils', '$q', function ($scope, $translate, $timeout, FormService, StringUtils, DatasetUtils, MessageUtils, $q) {
        var _formLoaded = false;
        var _ignoreNextChange = false;

        var _vlrPadraoFixoProps;
        var _vlrPadraoVariavelProps;

        var _VARS_BY_TYPE = {
            D: [{value: $translate.instant("DynaformConfig.labelVarData"), data: "${data}"}],
            H: [{value: $translate.instant("DynaformConfig.labelVarDataHora"), data: "${datahora}"}],
            I: [
                {value: $translate.instant("DynaformConfig.labelVarCodUsu"), data: "${usuario}"},
                {value: $translate.instant("DynaformConfig.labelVarEmpresa"), data: "${usuario.empresa}"},
                {value: $translate.instant("DynaformConfig.labelVarVendedor"), data: "${usuario.vendedor}"},
                {value: $translate.instant("DynaformConfig.labelVarCentResultado"), data: "${usuario.centroresultado}"}
            ]
        };

        init();

        function init() {
            var defaultType = $scope.field.userType == 'ENTITY' ? $scope.field.dataType : $scope.field.userType;

            var allowDefault = $scope.field.allowDefault == 'S';
            var hasVariableVar = _VARS_BY_TYPE.hasOwnProperty(defaultType);

            $scope.$watch('field', function (model, oldModel) {
                onModelChange(model, oldModel);
            }, true);

            $scope.formFields = [
                FormService.buildProperty('userDescription', 'Nome do campo', 'S', 'P', true),
                FormService.buildProperty('userRequired', 'Campo obrigatório', 'S', 'P', false, ($scope.field.systemRequired != 'S'), undefined, true),
                FormService.buildProperty('userReadOnly', 'Campo protegido', 'S', 'P', false, ($scope.field.systemReadOnly != 'S'), undefined, true),
                FormService.buildProperty('cleanOnCopy', 'Limpar ao duplicar', 'S', 'P', false, true, undefined, true),
                FormService.buildProperty('default.type', 'Tipo de valor padrão', 'O', 'P', true, allowDefault && hasVariableVar, undefined, false, 0, {
                    'sk-options': [
                        {value: $translate.instant("DynaformConfig.itemValorFixo"), data: "F"},
                        {value: $translate.instant("DynaformConfig.itemVariavel"), data: "V"}
                    ]
                })
            ];

            _vlrPadraoFixoProps = FormService.buildPropertyFromMD($scope.field);
            _vlrPadraoFixoProps.fieldName = 'default.fixedValue';
            _vlrPadraoFixoProps.description = 'Valor padrão';
            _vlrPadraoFixoProps.required = false;
            _vlrPadraoFixoProps.visible = false;
            _vlrPadraoFixoProps.enabled = allowDefault;

            $scope.formFields.push(_vlrPadraoFixoProps);

            _vlrPadraoVariavelProps = FormService.buildProperty('default.variableValue', 'Valor padrão', 'O', 'P', false, allowDefault, undefined, false, 0, {
                'sk-options': _VARS_BY_TYPE[defaultType],
                'sk-allow-null': true
            });

            _vlrPadraoVariavelProps.visible = false;

            $scope.formFields.push(_vlrPadraoVariavelProps);

            $timeout(function () {
                _formLoaded = true;
            }, 0, false);
        }

        function onModelChange(model, oldModel) {
            if (_ignoreNextChange){
                _ignoreNextChange = false;
                return;
            }

            var isFixedDefault = !model.default || model.default.type == 'F';

            _vlrPadraoFixoProps.visible = isFixedDefault;
            _vlrPadraoVariavelProps.visible = !isFixedDefault;

            if (!_formLoaded) {
                return;
            }
            var confirmProm = angular.noop;
            if (model.userRequired == 'S' && model.userReadOnly == 'S') {
                var defaultValue = model.default[isFixedDefault ? 'fixedValue' : 'variableValue'];

                if (StringUtils.isEmpty(defaultValue)) {
                    var msg = 'Ao marcar como protegido alguns usuários poderão não conseguir alterar o campo. Deseja marcar?';
                    confirmProm = MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_WARNING, msg);

                    $q.when(confirmProm).then(function(){
                     
                    },function(){
                        if (oldModel.userReadOnly != model.userReadOnly) {
                            model.userReadOnly = 'N';
                        } else if (oldModel.userRequired != model.userRequired) {
                            model.userRequired = 'N';
                        } else {
                            var oldDefaultValue = oldModel.default[isFixedDefault ? 'fixedValue' : 'variableValue'];
                            
                            model.default[isFixedDefault ? 'fixedValue' : 'variableValue'] = oldDefaultValue;
                        }
                        
                        _ignoreNextChange = true;
                        $scope.setFieldModified(model);
                    })
                }
            }
            $scope.setFieldModified(model);
            
        }
    }]);

angular
    .module('snk.components.dynaform')
    .service('DynaformConfigTourContent',[
        function() {

            var self = this;

            self.getDynaformConfigTourContent = getDynaformConfigTourContent;

            function getDynaformConfigTourContent(options) {
                return {
                    startTour: true,
                    options: {
                        startNode: options.startNode,
                    },
                    onFinish: function(){
                        //do nothing
                    },
                    tourConfig: [
                        {
                            type: "title",
                            heading: "Bem-vindo à configuração da tela",
                            html: "Está é a página de configuração da tela. Vamos explorar os recursos desta página...",
                            placement: "center",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#btn-start-tour-dfrm-cfg",
                            heading: "Iniciar Tour",
                            html: "Clicando aqui você pode iniciar o tour pela configuração da tela quando desejar.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#btn-copy-cfg",
                            heading: "Copiar personalização",
                            html: "Abre um assistente para copiar as configurações desta tela, de um usuário para outro(s).",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#btn-default-filter",
                            heading: "Filtro padrão",
                            html: "Através desta opção é possível configurar o filtro padrão, que será aplicado para todos os usuários assim que a tela for carregada.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true,
                            isEnabled: function() {
                                return options.isSup;
                            }
                        },
                        {
                            type: "element",
                            selector: "#btn-cancel-dyfm-cfg",
                            heading: "Cancelar alterações",
                            html: "Cancela as alterações realizadas. Uma mensagem de confirmação será exibida antes.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#btn-restore-dyfm-cfg",
                            heading: "Restaurar configurações",
                            html: "Restaura as configurações originais da tela. Uma mensagem de confirmação será exibida antes.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: ".dynaform-config .left-container",
                            heading: "Campos disponíveis",
                            html: "Aqui você encontra os campos disponíveis, ou seja, campos que não estão visíveis na tela no momento.<br/><br/>" +
                            "Caso a lista de campos disponíveis seja muito grande, você pode filtrá-los utilizando o campo de pesquisa.<br/><br/>" +
                            "Para adicionar um campo disponível na tela basta arrastá-lo para o lado direito da tela ou dar um duplo clique sobre o mesmo.",
                            placement: "right",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#tab-navigator-info",
                            heading: "Lista de abas",
                            html: "As abas da tela ficarão listadas aqui.<br/><br/>" +
                            "Você pode alterar a ordem em que as abas aparecem arrastando uma aba sobre a outra.<br/><br/>" +
                            "Para mover um campo de uma aba para outra, basta arrastar o campo para cima do nome de uma aba para ter acesso à ela e poder soltar o campo dentro dela." +
                            "<img src='/mge/assets/img/gif-moving-field.gif' width='380px'>",
                            placement: "bottom",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#btn-toggle-tab-visibility",
                            heading: "Mostrar/Esconder aba",
                            html: "Marca uma aba como visível ou invisível, fazendo com que ela apareça ou não na tela.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: "#btn-delete-tab",
                            heading: "Remover aba",
                            html: "Remove uma aba da tela. Caso a aba possua campos, os campos irão para a lista de campos disponíveis.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            selector: ".btn-nova-aba",
                            heading: "Criar nova aba",
                            html: "Cria uma nova aba na tela.",
                            placement: "left",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "title",
                            heading: "Campos na tela",
                            html: "Os campos configurados para compor um aba, aparecem logo abaixo do nome da aba e possuem a seguinte aparência:" +
                            "<img style='margin-left:85px;' src='/mge/assets/img/dfm-cfg-field.png'><br/><br/>" +
                            "Ao clicar no 'x' o campo é retirado da aba e movido para a lista de campos disponíveis.<br/><br/>" +
                            "Ao clicar ícone de engrenagem, um painel referente às configurações do campo será exibido, conforme ilustra o próximo passo.",
                            placement: "center",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "title",
                            heading: "Campos na tela",
                            html: "O painel de configurações do campo permite que vários atributos do mesmo sejam alterados, tais como: definir um valor padrão para o campo, marcá-lo como obrigatórios, etc.<br/><br/>" +
                            "Um campo fica vermelho quando é marcado como obrigatório e azul caso contrário.<br/><br/>" +
                            "<img src='/mge/assets/img/dfm-cfg-field-panel.PNG' width='425px'>",
                            placement: "center",
                            scroll: true,
                            attachToBody: true
                        },
                        {
                            type: "title",
                            heading: "Coniguração da tela",
                            html: "Agora você já conhece um pouco mais sobre a configuração da tela. Você pode iniciar esse tour novamente à qualquer momento, clicando no botão <i>Iniciar Tour</i>.",
                            placement: "center",
                            scroll: true,
                            attachToBody: true
                        }
                    ]
                }
            }
        }
    ]);
/**
 * @ngdoc interface
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Interface utilizada para definir um interceptor para o Dynaform
 */
function IDynaformInterceptor() {}

/**
 * @ngdoc
 * @name snk.components.datagrid.interfaces:IDynaformInterceptor#interceptFieldMetadata
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para interceptar os metadados do dynaform.
 * @param {object} fieldMetadata Metadados de um campo.
 * @param {object} dataset Instância do dataset vinculada ao dynaform.
 * @param {object} dynaform Instância do dynaform.
 */
IDynaformInterceptor.prototype.interceptFieldMetadata = function (fieldMetadata, dataset, dynaform) {

};

/**
 * @ngdoc
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor#interceptDataset
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para interceptar os metadados do dynaform.
 * @param {object} dynaform Instância do dynaform.
 * @param {object} dataset Instância do dataset.
 */
IDynaformInterceptor.prototype.interceptDataset = function (dynaform, dataset) {

};

/**
 * @ngdoc
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor#interceptPersonalizedFilter
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para interceptar o filtro personalizado vinculado ao dynaform.
 * @param {object} personalizedFilter Instância do Filtro Personalizado.
 * @param {object} dynaform Instância do Dynaform.
 */
IDynaformInterceptor.prototype.interceptPersonalizedFilter = function (personalizedFilter, dataset) {

};

/**
 * @ngdoc
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor#interceptNavigator
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para interceptar a barra de navegação do dynaform.
 * @param {object} navigator Instância da barra de navegação.
 * @param {object} dynaform Instância do Dynaform.
 */
IDynaformInterceptor.prototype.interceptNavigator = function (navigator, dynaform) {

};

/**
 * @ngdoc
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor#interceptDynaform
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para interceptar o dynaform.
 * @param {object} dynaform Instância do Dynaform.
 */
IDynaformInterceptor.prototype.interceptDynaform = function (dynaform) {

};

/**
 * @ngdoc
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor#acceptField
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para verificar se determinado campo deverá ser apresentado no formulário
 * @param {object} fieldMD Metadados do campo.
 * @param {object} dynaform Instancia do dynaform.
 * @param {object} dataset Instancia do dataset.
 * @returns {boolean} True caso o campo seja aceito, falso do contrário.
 */
IDynaformInterceptor.prototype.acceptField = function (fieldMD, dynaform, dataset) {
    return true;
};

/**
 * @ngdoc
 * @name snk.components.dynaform.interfaces:IDynaformInterceptor#acceptTab
 * @methodOf snk.components.dynaform.interfaces:IDynaformInterceptor
 * @description Função chamada para verificar se determinada aba deverá ser criada no dynaform
 * @param {object} fieldMD Id da aba.
 * @param {object} dynaform Instancia do dynaform.
 * @param {object} dataset Instancia do dataset.
 * @param {boolean} isCustomBlock Informa se a aba é customizada.
 * @returns {boolean} True caso a aba seja criada, falso do contrário.
 */
IDynaformInterceptor.prototype.acceptTab = function (tabId, dynaform, dataset, isCustomBlock) {
    return true;
};
angular
    .module('snk.components.dynaform')
    .controller('SkNumberConfigController', ['$scope', 'ServiceProxy', 'properties', '$popupInstance','StringUtils',
        function ($scope, ServiceProxy, properties, $popupInstance, StringUtils) {

            var numeroInicial;
            var isNumeracaoAutomatica;

            $scope.validValue = validValue;

            init();

            function init() {
                ServiceProxy.callService('DynaformBuilder.getNumberConfig', {
                    paramsConfig: {
                        resourceID: properties.resourceId,
                        entityName: properties.entityName,
                        codEmp: properties.codEmp
                    }
                }).then(function (result) {
                    $scope.checkNumAutomatica = isNumeracaoAutomatica = StringUtils.toBoolean(result.responseBody.config.isAutoNum);
                    $scope.numeroInicial = numeroInicial = result.responseBody.config.numeroInicial;
                    $scope.$success = function () {
                        $popupInstance.success(getDataValue());
                    }
                });
            }

            function getDataValue() {
                return {
                    isNumeracaoAutomatica: $scope.checkNumAutomatica,
                    numeroInicial: $scope.numeroInicial,
                    isSave: ($scope.numeroInicial != numeroInicial || $scope.checkNumAutomatica != isNumeracaoAutomatica),
                    isReload: ($scope.checkNumAutomatica != isNumeracaoAutomatica)
                };
            }

            function validValue() {
                if (angular.isDefined($popupInstance?.popupOptions)) {
                    const btnOk = $popupInstance.element[0]?.querySelector('.btn-popup-ok');
                    if (angular.isElement(btnOk)) {
                        const dataValue = getDataValue();
                        const isSave = dataValue.isSave;
                        const enableBtnOk = (angular.isDefined($scope.numeroInicial) && isSave) || !$scope.checkNumAutomatica;
                        $popupInstance.popupOptions.enableBtnOk = enableBtnOk;
                        btnOk.disabled = !$popupInstance.popupOptions.enableBtnOk;
                    }
                }
            }
        }]);
angular
    .module('snk.components.dynaform')
    .service('NumberConfig', ['SanPopup', '$translate', '$q','ServiceProxy', function (SanPopup, $translate, $q, ServiceProxy) {
        var self = this;

        self.showInfo = showInfo;

        function showInfo(entityName, resourceId) {
            var deferred = $q.defer();

            var codEmp = "";
            /*
             Isso é usado no fornecedor, é necessário que o codEmp esteja injetado no dynaform
             if(_dynaformKeyGen != null){
             codEmp = _dynaformKeyGen.getInfoNumeracao().codEmp;
             }

             if(isNaN(Number(codEmp))){
             codEmp = "";
             }*/

            var popupInstance = SanPopup.open({
                templateUrl: 'components/dynaform/numeracaoconfig/numeracaoconfig.tpl.html',
                title: $translate.instant('NumberConfig.titulo'),
                size: 'sm',
                okBtnLabel: $translate.instant('NumberConfig.salvar'),
                enableBtnOk: false,
                controller: 'SkNumberConfigController',
                windowClass: 'sk-popup-numeracao',
                resolve: {
                    properties: function(){
                        return{
                            entityName: entityName,
                            resourceId: resourceId,
                            codEmp: codEmp
                        }
                    }
                }
            });

            popupInstance.result.then(function (dataValue) {

                if (dataValue && dataValue.isSave) {

                    var params = {
                        paramsConfig: {
                            resourceID: resourceId,
                            entityName: entityName,
                            isAutoNum: dataValue.isNumeracaoAutomatica,
                            numInicial: dataValue.numeroInicial,
                            codEmp: codEmp
                        }
                    };

                    ServiceProxy.callService('DynaformBuilder.saveNumberConfig',
                        params
                    ).then(function (result) {
                        if (dataValue.isReload) {
                            deferred.resolve(dataValue);
                        }
                    });

                }
            },function(e){
                deferred.reject(e);
            });

            return deferred.promise;
        }

    }]);
angular
    .module('snk.components.dynamicfilterpanel')
    .controller('DynamicFilterPanelController', ['$rootScope', '$attrs', '$scope', '$q', 'i18n', 'ObjectUtils', '$timeout', 'PopUpParameter', 'DatasetUtils', 'StringUtils', '$element', 'SkConstants', 'AngularUtil', 'ArrayUtils', 'NumberUtils', 'MessageUtils', 'SkFilter', 'WhenReadyBuilder', 'DomUtil', 'PositionUtils', 'FormService', 'SkApplication', 'Base64', 'DateUtils', 'SkComponentRegistry', 'Criteria', 'SkApplicationInstance',
        function ($rootScope, $attrs, $scope, $q, i18n, ObjectUtils, $timeout, PopUpParameter, DatasetUtils, StringUtils, $element, SkConstants, AngularUtil, ArrayUtils, NumberUtils, MessageUtils, SkFilter, WhenReadyBuilder, DomUtil, PositionUtils, FormService, SkApplication, Base64, DateUtils, SkComponentRegistry, Criteria, SkApplicationInstance) {
            var self = this;

            ObjectUtils.implements(self, CriteriaProvider);

            const PROGRAMMER_CRITERIA = 'progCriteria';

            var CONFIG_SUFFIX = '.DynamicFilterAccordion';
            var SYNC_EVENT_NAME = 'SYNC_DYNAMIC_FILTER_PANEL_EVENT';

            var ALL = '__ALL__';
            var VOID = '__VOID__';
            var NON_VOID = '__NON_VOID__';

            var typeTranslations = {
                N: 'I',
                B: 'S',
                SO: 'S',
                DT: 'D',
                DH: 'D',
                T: 'S',
                ENTITY: 'ENTITY',
                BLIST: 'CHECKLIST',
                P: 'DP',
                ENTITYLIST: 'ENTITYLIST'
            };

            var _filterReady = WhenReadyBuilder.$new();
            var _paramsByName = {};
            var _filterLastValues;
            var _entityListCtrls = {};
            var _entityListLastValues = {};

            $scope.hasFilterInfos = false;

            $scope.filterModel = {};
            $scope.defaultTab = {
                isOpen: false,
                removeHeader: false,
                name: i18n('DynamicFilterPanel.lblFiltrosRapidos'),
                list: []
            };
            $scope.onEntityListCreated = onEntityListCreated;
            $scope.onKeyDown = onKeyDown;

            self.getCriteria = getCriteria;
            self.clearFilter = $scope.clearFilter = clearFilter;
            self.setCustomFiltersElement = setCustomFiltersElement;
            self.onFilterLoaded = onFilterLoaded;
            self.hasSomeDynamicFilterData = hasSomeDynamicFilterData;
            self.setFilterFieldValue = setFilterFieldValue;

            var _publicAPI = ObjectUtils.buildPublicAPI(self, [
                'clearFilter', 'setCustomFiltersElement', 'onFilterLoaded', 'hasSomeDynamicFilterData','setFilterFieldValue'
            ]);

            //initialize
            init();

            function init() {
                if (angular.isUndefined($scope.groupOthers)) {
                    $scope.groupOthers = true;
                }

                if (angular.isDefined($scope.filterPanelInterceptor)) {
                    ObjectUtils.isImplementorOf($scope.filterPanelInterceptor, IFilterPanelInterceptor);
                }

                if ($attrs.skDataSource) {
                    AngularUtil.addSingleWatch($scope, 'dataSource', function (newDs) {
                        ObjectUtils.isImplementorOf(newDs, DataSource);

                        if (!$scope.entityName && angular.isFunction(newDs.getEntityName) && (!angular.isFunction(newDs.isStandAlone) || !newDs.isStandAlone())) {
                            $scope.entityName = newDs.getEntityName();
                        }

                        if (!$scope.entityName && (!angular.isFunction(newDs.isStandAlone) || !newDs.isStandAlone())) {
                            throw Error('[dynamic-filter-panel] É obrigatório informar um entityName ou ter um entityName no DataSource');
                        }

                        newDs.addCriteriaProvider(self);
                        
                        var loadEntityFilters = true;
                        
                        if (angular.isFunction(newDs.isStandAlone)) {
                        	loadEntityFilters = !newDs.isStandAlone();
                        }

                        if (loadEntityFilters) {
                        	loadFilters();
                        } else {
                        	_filterReady.ready();
                        }
                    });
                } else {
                    throw Error('[dynamic-filter-panel]  Deve-se informar um dataSource.');
                }

                $rootScope.$on(SYNC_EVENT_NAME, function (e, args) {
                    if (args.filterReference != self && ($scope.resourceId + CONFIG_SUFFIX) == args.configId) {
                        loadLastValues();
                    }
                });

                loadLastValues();

                if ($scope.componentCreated) {
                    $scope.componentCreated({$component: _publicAPI});
                }
            }

            function loadFilters() {
                SkFilter.getFilterPanelFields($scope.entityName).then(function (fields) {
                    $scope.hasFilterInfos = fields && fields.length > 0;

                    if ($scope.hasFilterInfos) {
                        processFieldFilterInfo(fields);
                    }

                    _filterReady.ready();
                });
            }

            function loadLastValues() {
                var lastValues = SkApplication.instance().getConfiguracaoTela($scope.resourceId + CONFIG_SUFFIX);

                if (angular.isUndefined(lastValues)) {
                    SkApplicationInstance.loadMgeConfig($scope.resourceId + CONFIG_SUFFIX)
                        .then(function (result) {
                            var params = angular.copy(result.params);
                            if(params){
                                delete result.params.param;
                                result['param'] = params.param;
                            }
                            processLastValues(result);
                        });
                } else {
                    processLastValues(lastValues);
                }
            }

            function processLastValues(lastValues) {
                if (lastValues && lastValues.param) {
                    _filterLastValues = {};

                    ArrayUtils.toArray(lastValues.param).forEach(function (param) {
                        _filterLastValues[param.id] = param.$;
                    });
                }

                if (_paramsByName) {
                    angular.forEach(_paramsByName, function (formField) {
                        updateLastValueForField(formField, formField.fieldProp.filterFieldInfo);
                    });
                }

                if (angular.isDefined($scope.filterPanelInterceptor)) {
                    var params = [];
                    if(lastValues.params){
                        params = lastValues.params[PROGRAMMER_CRITERIA];
                    }else{
                        params = lastValues[PROGRAMMER_CRITERIA];
                    }

                    var progData = {};

                    ArrayUtils.toArray(params).forEach(function (progItem) {
                        var value = progItem.$;
                        if (angular.isDefined(value) && value.startsWith('$') && value.endsWith('$')) {
                            value = value.substr(1, value.length - 2);
                            progData[progItem.id] = JSON.parse(value);
                        } else {
                            progData[progItem.id] = progItem.$;
                        }
                    });

                    $scope.filterPanelInterceptor.interceptAfterLoad(progData);
                }
            }

            function processFieldFilterInfo(fields) {
                //Aqui os grupos são dividos apenas em campos que não são ENTITYLIST e os que são
                //Para cada formulário criado ainda temos os grupos de campo dentro deles.

                $scope.defaultTab.list = [];
                $scope.defaultTab.isOpen = false;

                var groupList = [];

                fields.forEach(function (field) {
                    var filterFieldInfo = field.fieldFilterInfo;
                    var type = filterFieldInfo.type;
                    var allowNull = field.isNullable;
                    var isEntityList = false;

                    var fieldProps = {
                        filterFieldInfo: filterFieldInfo,
                        useLiteralValue: (type == 'BLIST' || type == 'ENTITYLIST')
                    };

                    FormService.addDefaultFieldProps(field, fieldProps);
                    delete fieldProps['sk-form-criteria'];

                    if (type == 'BLIST') {
                        fieldProps['sk-label'] = filterFieldInfo.label;
                        insertConstOptions(fieldProps, false, allowNull);
                    } else if (type == 'SO') {
                        fieldProps['sk-allow-null'] = allowNull;
                        insertConstOptions(fieldProps, true, allowNull);
                    } else if (type == 'ENTITYLIST') {
                        fieldProps['sk-entity-name'] = filterFieldInfo.pesquisaInfo.entityName;
                        isEntityList = true;
                        filterFieldInfo.groupName = undefined;
                    } else {
                        //Regra do form.service getUserType campo virar pesquisa
                        if (field.fk && !(field.options && field.options.length > 0)) {
                            type = 'ENTITY';
                        }
                        
                        if (type == 'ENTITY') {
                            /* Força a entidade a fazer o carregamento do último valor salvo ao iniciar, mesmo que seja um registro inativo */
                            if (fieldProps['sk-options'] == undefined) fieldProps['sk-options'] = {};

                            fieldProps['sk-options'].overwriteNextShowInactives = true;

                            if (filterFieldInfo.isConsFilLig) {
                                if (($scope.entityName !== null) && ($scope.entityName.length > 0)) {
                                    fieldProps['sk-local-entity-name'] = $scope.entityName;
                                } else {
                                    fieldProps['sk-local-entity-name'] = filterFieldInfo.pesquisaInfo.entityName;
                                }
                            }
                        }
                    }

                    //Convertemos para o tipo padrão do sistema
                    type = typeTranslations[type] || 'S';

                    var formField = FormService.buildProperty(filterFieldInfo.id, filterFieldInfo.label, type, field.presentationType, filterFieldInfo.isRequired, true, filterFieldInfo.groupName, false, getSizeField(field, type), fieldProps);

                    if (isEntityList) {
                        groupList.push({
                            isOpen: false,
                            id: filterFieldInfo.id,
                            name: filterFieldInfo.label,
                            entityName: filterFieldInfo.pesquisaInfo.entityName,
                            md: formField
                        });
                    } else {
                        $scope.defaultTab.isOpen = true;
                        if(formField.fieldProp && formField.fieldProp['sk-options'] && formField.fieldProp['sk-allow-show-hierarchical-mode']){
                            formField.fieldProp['sk-options'].originalEntityName = $scope.entityName;
                        }
                        $scope.defaultTab.list.push(formField);
                    }

                    _paramsByName[formField.fieldName] = formField;

                    updateLastValueForField(formField, filterFieldInfo);
                });

                if (!$scope.defaultTab.isOpen && groupList.length > 0) {
                    groupList[0].isOpen = true;
                }

                $scope.groupsInfo = groupList;
            }

            function getSizeField(field, type) {
                //Nulo/Zero e falso
                if (field.size) {
                    if (type == 'S' && field.size > 100) {
                        //Quando String maior q 100 o filtro vira textarea e nao funciona o filtro
                        return 100;
                    }

                    return field.size;
                }

                return field.fieldFilterInfo.precision;
            }

            function updateLastValueForField(formField, filterFieldInfo) {
                if ((_filterLastValues && _filterLastValues[filterFieldInfo.id] && filterFieldInfo.isKeepLast) || (angular.isDefined(filterFieldInfo.defaultValue) && !filterFieldInfo.isKeepLast)) {
                    var strValue = angular.isDefined(filterFieldInfo.defaultValue) && !filterFieldInfo.isKeepLast ? filterFieldInfo.defaultValue: _filterLastValues[filterFieldInfo.id];

                    if (!strValue) {
                        return;
                    }

                    var typedValue;

                    if (filterFieldInfo.type == 'BLIST') {
                        var a = [];

                        var values = strValue.split(',');
                        for (var i in values) {
                            var s = values[i];

                            a.push(s.replace(/^'?([^']*)'?$/gi, '$1'));
                        }

                        typedValue = a;
                    } else if (filterFieldInfo.type == 'ENTITYLIST') {
                        strValue = Base64.decode(strValue);

                        var options = AngularUtil.xmlStringToJson(strValue);

                        if (options && options.items) {
                            if (!angular.isArray(options.items.item)) {
                                options.items.item = [options.items.item];
                            }

                            var targetName = filterFieldInfo.pesquisaInfo.targetFieldName;

                            var dataProvider = options.items.item.map(function (item) {
                                return {
                                    data: item[targetName.toLowerCase()].$,
                                    checked: item.selected
                                }
                            });

                            if (_entityListCtrls[filterFieldInfo.id]) {
                                _entityListCtrls[filterFieldInfo.id].setDataProvider(dataProvider);
                            } else {
                                _entityListLastValues[filterFieldInfo.id] = dataProvider;
                            }
                        }

                        //parsear para o modo que o componente trabalhará.
                    } else if (filterFieldInfo.type == 'P') {
                        if (strValue) {
                            var dates = strValue.split(',');

                            if (dates[0]) {
                                if (!typedValue) {
                                    typedValue = {};
                                }

                                typedValue.dtIni = DateUtils.strToDate(dates[0]);
                            }

                            if (dates[1]) {
                                if (!typedValue) {
                                    typedValue = {};
                                }

                                typedValue.dtFin = DateUtils.strToDate(dates[1]);
                            }
                        }
                    } else {

                        if (formField.type == 'N') {
                            typedValue = Number(strValue);
                        } else if (formField.type == 'D' || formField.type == 'H') {
                            typedValue = DateUtils.strToDate(strValue);
                        } else {
                            typedValue = strValue;
                        }

                        if (filterFieldInfo.type == 'SO') {
                            var hasOption = ArrayUtils.find(formField.fieldProp['sk-options'], function (option) {
                                return typedValue === option.data;
                            });

                            if (!hasOption) {
                                typedValue = undefined;
                            }
                        }
                    }

                    $scope.filterModel[filterFieldInfo.id] = typedValue;
                }
            }

            function setFilterFieldValue(field, value){
                $scope.filterModel[field] = value;
            }

            function insertConstOptions(fieldProps, useAllOption, useVoidOption) {
                var opts = fieldProps['sk-options'] || [];

                if (useAllOption) {
                    opts.unshift({data: ALL, value: 'Todos'});
                }

                // Funcionalidade foi removida por solicitação da OS 1497668, pois estava causando confusão aos usuários.
				// No futuro este recurso poderá ser revisto com a equipe de UX, caso haja necessidade de manter a funcionalidade.
                /*if (useVoidOption) {
                    opts.unshift({data: VOID, value: 'Não informado'});
                    opts.unshift({data: NON_VOID, value: 'Informado'});
                }*/

                fieldProps['sk-options'] = opts;
            }

            function getCriteria() {
                return _filterReady.whenReady(undefined, doGetCriteria());
            }

            function onFilterLoaded() {
                return _filterReady.whenReady(undefined, _publicAPI);
            }

            function setAttributesObserver(element) {
                if (angular.isElement(element) && angular.isFunction(MutationObserver)) {
                    const config = { attributes: true, childList: false, subtree: false };
                    const callback = function(mutationsList) {
                        for(let mutation of mutationsList) {
                            if (mutation.type === 'attributes') {
                                loadCustomIcon();
                            }
                        }
                    };
                    const observer = new MutationObserver(callback);
                    observer.observe(element, config);
                }
            }

            function setCustomFiltersElement(element) {
                var customDefaultGroupElement = DomUtil.select(element, 'default-group');

                setAttributesObserver(customDefaultGroupElement);

                var customGroupsElem = DomUtil.selectAll(element, 'custom-group');

                var customGroupsInfo = [];

                angular.forEach(customGroupsElem, function (customGroupElem) {

                    setAttributesObserver(customGroupElem);

                    customGroupElem = angular.element(customGroupElem);

                    var label = i18n(customGroupElem.attr('label'));
                    var isRequired = StringUtils.toBoolean(customGroupElem.attr('is-required'));

                    if (StringUtils.isEmpty(label)) {
                        throw Error('As tags \'custom-group\' devem possuir um label. Confira a documentação.');
                    }

                    customGroupsInfo.push({
                        label: label,
                        elem: customGroupElem,
                        noPadding: customGroupElem[0].hasAttribute('no-padding'),
                        isOpen: false,
                        isRequired: isRequired
                    });
                });

                $scope.customGroupsInfo = customGroupsInfo;

                if (customDefaultGroupElement) {
                    var defaultGroupLabel = angular.element(customDefaultGroupElement).attr('label');

                    if (customDefaultGroupElement.hasAttribute('remove-header')) {
                        $scope.defaultTab.removeHeader = true;
                    }

                    if (defaultGroupLabel) {
                        $scope.defaultTab.name = i18n(defaultGroupLabel);
                    }
                } else if (!customDefaultGroupElement && customGroupsInfo.length == 0) {
                    customDefaultGroupElement = element;
                }

                if (customDefaultGroupElement && !$scope.defaultTab.isOpen) {
                    $scope.defaultTab.isOpen = true;
                }

                if (customDefaultGroupElement) {
                    $scope.defaultTab.hasCustomDefault = true;
                }

                //Damos o tempo pro angular compilar os elementos e inserirmos nossas coisas no meio
                AngularUtil.timeout(function () {
                    if (customDefaultGroupElement) {
                        if ($scope.hasFilterInfos && $scope.groupOthers) {
                            var container = angular.element('<div layout="column"><label class="group-label other-group">' + ($scope.showLabelOthersFilters == 'false' ? '' : i18n('Geral.lblOutros')) + '</label></div>');
                            container.append(customDefaultGroupElement);

                            customDefaultGroupElement = container;
                        }

                        var transcludeElem = angular.element(DomUtil.select($element, '.custom-filter-container'));
                        transcludeElem.append(customDefaultGroupElement);
                    }

                    if (customGroupsInfo.length > 0) {
                        var customGroupContainers = DomUtil.selectAll($element, '.custom-group-element .panel-body');

                        if (customGroupContainers.length != customGroupsInfo.length) {
                            throw Error('Número de elementos customizados inválidos no DynamicFilterPanel');
                        }

                        customGroupsInfo.forEach(function (customGroupInfo, index) {
                            var container = angular.element(customGroupContainers[index]);

                            if (customGroupInfo.noPadding) {
                                container.addClass('no-padding');
                            }

                            container.append(customGroupInfo.elem);
                        });

                        if (!$scope.defaultTab.isOpen) {
                            customGroupsInfo[0].isOpen = true;
                        }
                    }

                    $rootScope.$broadcast('customGroupLoaded', '');

                    $timeout(loadCustomIcon);
                });
            }

            function clearFilter($event) {
                $event.stopPropagation();
                $event.preventDefault();

                $scope.filterModel = {};

                angular.forEach(_entityListCtrls, function (instance) {
                    instance.setDataProvider(undefined);
                });

                if ($scope.filterPanelInterceptor) {
                    $scope.filterPanelInterceptor.clearFilter();
                }
            }

            function onKeyDown($event) {
                var keyCode = $event.which || $event.keyCode;

                if (keyCode === SkConstants.KEY_CODE.ENTER) {
                    $scope.requestRefreshFn({$event: $event});
                }
            }

            function onEntityListCreated(instance, name) {
                _entityListCtrls[name] = instance;

                if (_entityListLastValues[name]) {
                    instance.setDataProvider(_entityListLastValues[name]);
                }
            }

            function filterUndefinedCriteria(model) {
                if (angular.isObject(model)) {
                    if ((model.hasOwnProperty('dtIni') && model.dtIni === undefined) && (model.hasOwnProperty('dtFin') && model.dtFin === undefined)) {
                        return false
                    }else{
                        return true;
                    }
                } else {
                    return model !== undefined
                }
            }
            
            function doGetCriteria() {
                var criteria = Criteria();

                if (_paramsByName) {
                	const newFilterModel = ObjectUtils.filterOnObject($scope.filterModel, filterUndefinedCriteria);
                	
                    angular.forEach(_paramsByName, function (field) {
                        var filterFieldInfo = field.fieldProp.filterFieldInfo;

                        var value = newFilterModel[field.fieldName];

                        if (StringUtils.isNotEmpty(value)) {
                            var sqlExpression = getSqlExpression(field, value);

                            if (angular.isDefined(sqlExpression)) {
                                if (!filterFieldInfo.isVoidExpression) {
                                    criteria.and(sqlExpression);
                                }
                            }
                        } else {
                            if (field.required) {
                                throw new AlertError(undefined, 'DynamicFilterPanel.msgParamFilNaoInfo', {
                                    id: field.description
                                });
                            }
                        }
                    });
                }

                var translatePeriodNames = {
                    INI: 'dtIni',
                    FIN: 'dtFin'
                };

                criteria.replaceOnExpression(/:([-_a-z0-9]+).?(INI|FIN)?\b/gi, function () {
                    //Essa função é chamada pelo replace sempre que o padrão de :PARAM casar.
                    //A variável "arguments" é contextualizada pelo próprio replace.
                    //O que for retornado aqui será aplicado no replace...
                    var field = _paramsByName[arguments[1]];
                    if (!field) {
                        //Caso não encontremos um parâmetro na lista, significa que não é um
                        //parâmetro "resolvível" então deixamos como está...
                        return arguments[0];//retorno da closure, não da função
                    }

                    var data = $scope.filterModel[field.fieldName];

                    if (field.fieldProp.useLiteralValue) {
                        //Alguns valores, por exemplo "this.PARAMETRO IN (:PARAMETRO)"
                        //podem ser trocados por "this.PARAMETRO IN (1,2,3,4)" ao invés de
                        //"this.PARAMETRO IN (?,?,?,?)" ao invés de

                        var newData = [];

                        data.forEach(function(value) {
                          if (value != NON_VOID && value != VOID) {
                            if (field.type != 'N') {
                              value = '\'' + value + '\'';
                            }

                            newData.push(value);
                          }
                        });

                        return newData.join(','); //retorno da closure, não da função
                    }

                    if (arguments[2] && data) {
                        var translatedName = translatePeriodNames[arguments[2]];

                        if (translatedName && data.hasOwnProperty(translatedName)) {
                            //Exclusivo para o caso de períodos, o casamento se estende a .INI e .FIN, nesse caso
                            //o segundo grupo determina qual atributo será usado de {INI: data, FIN: outraData};

                            if (!data?.dtIni || !data?.dtFin) {
                                throw new AlertError(undefined, i18n('DynamicFilterPanel.msgParamDataFilNaoInfor', {
                                    tipDt: arguments[2] == 'INI' ? i18n('DynamicFilterPanel.lblFinal') : i18n('DynamicFilterPanel.lblInicial'),
                                    id: arguments[2] == 'INI' ? 'Dt. ' + i18n('DynamicFilterPanel.lblInicial') : 'Dt. ' + i18n('DynamicFilterPanel.lblFinal')
                                }));
                            }

                            data = data[translatedName];
                        }
                    }

                    var value = DatasetUtils.dataToString(data);

                    validateRange(field, value);

                    criteria.addParameter(Criteria.buildParameter(field.fieldProp['sk-data-type'], value));
                    return ("?" + ( (arguments[0] && typeof arguments[0] == 'string' && arguments[0].endsWith(' ')) ? ' ' : ''));//retorno da closure, não da função
                });

                if ($scope.customCriteriaLoader) {
                    return $q(function (resolve, reject) {
                        $q.when($scope.customCriteriaLoader())
                            .then(function (userCriteria) {
                                if (userCriteria && userCriteria.getSize() > 0) {
                                    criteria.and(userCriteria);
                                }

                                saveFilterState(criteria);
                                resolve(criteria);
                            }, reject);
                    });
                } else {
                    saveFilterState(criteria);
                    return criteria;
                }
            }

            function setCustomIcon(selectorParent, selectorTarget) {
                var listGroup = DomUtil.selectAll($element, selectorParent);
                angular.forEach(listGroup, function(element) {
                    var heading = DomUtil.select(element, '.panel-heading');
                    if (angular.isDefined(heading)) {
                        var link = DomUtil.select(heading, '.panel-title > a');
                        if (angular.isDefined(link)) {
                            var targetGroup = DomUtil.select(element, selectorTarget);
                            var skIcon = DomUtil.select(link, '.panel-title-icon');
                            if (angular.isDefined(skIcon)) {
                                angular.element(skIcon).remove();
                            }
                            if (angular.isDefined(targetGroup)) {
                                var iconName = targetGroup.getAttribute('icon');
                                if (angular.isDefined(iconName) && iconName !== '') {
                                    var clear = DomUtil.select(link, '.clear-filter-text');
                                    var icon = document.createElement('sk-icon');
                                    icon.setAttribute('font-icon', iconName);
                                    icon.classList.add('panel-title-icon');
                                    if (angular.isDefined(clear)) {
                                        icon.classList.add('panel-title-icon--away');
                                    }
                                    skIcon = AngularUtil.compile(icon);
                                    angular.element(link).append(skIcon);
                                }
                            }
                        }
                    }
                });
            }

            function loadCustomIcon() {
                setCustomIcon('.panel-default', 'default-group');
                setCustomIcon('.custom-group-element', 'custom-group');
            }

            function saveFilterState(criteria) {
                var criteriaToSave = buildCriteriaToSave();

                var configId = $scope.resourceId + CONFIG_SUFFIX;

                if ($scope.filterPanelInterceptor) {
                    var programmerCriteriaData = buildProgrammerCriteriaData($scope.filterPanelInterceptor.interceptBeforeSave($scope.dataSource));

                    if (angular.isArray(programmerCriteriaData)) {
                        if (angular.isUndefined(criteriaToSave)) {
                            criteriaToSave = {};
                        }

                        criteriaToSave[PROGRAMMER_CRITERIA] = programmerCriteriaData;
                    }
                }

                SkApplication.instance().putConfiguracaoTela(configId, criteriaToSave);

                $rootScope.$broadcast(SYNC_EVENT_NAME, {configId: configId, filterReference: self});

                $scope.saveCriteriaFn({
                    resourceId: $scope.resourceId + CONFIG_SUFFIX,
                    criteria: criteria,
                    criteriaToSave: criteriaToSave
                });

                $scope.hasFilter = criteria.getSize() > 0;
            }

            function buildProgrammerCriteriaData(programmerObj) {
                var programmerCriteriaData = [];

                for (var key in programmerObj) {
                    var content;
                    if (angular.isArray(programmerObj[key]) || angular.isObject(programmerObj[key])) {
                        content = '$' + JSON.stringify(programmerObj[key]) + '$';
                    } else {
                        content = programmerObj[key];
                    }

                    programmerCriteriaData.push({
                        id: key,
                        $: content
                    });
                }

                return programmerCriteriaData;
            }

            function validateRange(field, value) {
                var range = field.fieldProp.filterFieldInfo.range;

                if (range) {
                    value = NumberUtils.stringToNumber(value);

                    if (NumberUtils.stringToNumber(range.start) > value || NumberUtils.stringToNumber(range.end) < value) {
                        throw new AlertError(undefined, 'DynamicFilterPanel.msgIntervalVlrFiltro', {
                            id: field.description,
                            start: range.start,
                            end: range.end
                        });
                    }
                }

            }

            function getValueToSave(filterFieldInfo, value) {

                if (filterFieldInfo.type == 'ENTITYLIST') {
                    var entityListController = _entityListCtrls[filterFieldInfo.id];

                    var dataProvider = entityListController.getDataProvider();

                    if (dataProvider && dataProvider.length > 0) {
                        var targetName = filterFieldInfo.pesquisaInfo.targetFieldName;

                        var strXml = '<items>';

                        var baseItemStr = '<item{SELECTED}>';
                        baseItemStr += '<' + targetName + '>{VALUE}</' + targetName + '>';
                        baseItemStr += '</item>';

                        for (var i = 0, len = dataProvider.length; i < len; i++) {
                            var item = dataProvider[i];

                            strXml += StringUtils.substitute(baseItemStr, {
                                SELECTED: filterFieldInfo.isKeepLast ? ' selected="' + item.checked + '"' : '',
                                VALUE: item.data
                            });

                        }

                        strXml += '</items>';

                        return Base64.encode(strXml);
                    }
                } else if (filterFieldInfo.type == 'BLIST') {
                    return value.toString();
                } else if (filterFieldInfo.type == 'P') {
                    var strValue = '';

                    if (!value || (!value.dtIni && !value.dtFin)) {
                        return strValue;
                    }

                    if (value.dtIni) {
                        strValue += DateUtils.formatDate(value.dtIni);
                    }

                    strValue += ',';

                    if (value.dtFin) {
                        strValue += DateUtils.formatDate(value.dtFin);
                    }

                    return strValue;
                } else {
                    return DatasetUtils.dataToString(value);
                }
            }

            function buildCriteriaToSave() {
                var params;

                if (_paramsByName) {
                    angular.forEach(_paramsByName, function (field) {
                        var filterFieldInfo = field.fieldProp.filterFieldInfo;

                        var value = $scope.filterModel[field.fieldName];

                        if (filterFieldInfo.type && StringUtils.isNotEmpty(value)) {

                            if (filterFieldInfo.type == 'ENTITYLIST' || filterFieldInfo.isKeepLast) {
                                if (!params) {
                                    params = [];
                                }

                                params.push({
                                    id: filterFieldInfo.id,
                                    $: getValueToSave(filterFieldInfo, value)
                                })
                            }
                        }
                    });
                }

                if (params) {
                    return {param: params};
                } else {
                    return undefined;
                }
            }

            function getSqlExpression(param, value) {
                if (value == undefined || value == ALL) {
                    return undefined;
                } else if (value == VOID) { //em javascript: 'X' == ['X']
                    return 'this.' + param.fieldName + ' IS NULL';
                } else if (value == NON_VOID) { //em javascript: 'X' == ['X']
                    return 'this.' + param.fieldName + ' IS NOT NULL';
                }

                if (param.type == 'CHECKLIST') {
                    var options = ObjectUtils.getProperty(param, 'fieldProp.sk-options');

                    if (options && options.length == value.length) {
                      return undefined;
                    }
                }

                var filterFieldInfo = param.fieldProp.filterFieldInfo;

                if (angular.isDefined(filterFieldInfo.sql)) {
                    if(filterFieldInfo.type == "P"){
                        if(value.dtIni && value.dtFin){
                            return '(' + filterFieldInfo.sql + ')';
                        }
                    } else {
                        return '(' + filterFieldInfo.sql + ')';
                    }
                }

                if (param.isCheckbox) {
                    if (value == 'S') {
                        return 'this.' + param.fieldName + ' = \'S\'';
                    }

                    return undefined;
                }

                if (filterFieldInfo.type == "P") {
                    if (!value || (!value.dtIni && !value.dtFin)) {
                        return undefined;
                    }

                    if (value.dtIni && !value.dtFin) {
                        return "this." + param.fieldName + " >= :" + param.fieldName + ".INI";
                    } else if (!value.dtIni && value.dtFin) {
                        return "this." + param.fieldName + " <= :" + param.fieldName + ".FIN";
                    } else {
                        return "this." + param.fieldName + " BETWEEN :" + param.fieldName + ".INI AND :" + param.fieldName + ".FIN";
                    }
                } else if (filterFieldInfo.type == "BLIST" || filterFieldInfo.type == "ENTITYLIST") {
                    var sql = "this." + param.fieldName + " IN (:" + param.fieldName + ")";

                    if (filterFieldInfo.type == "BLIST" && angular.isArray(value)) {
                        if (value.indexOf(NON_VOID) > -1) { //Se marcou 'Informado' então é todos
                          sql = 'this.' + param.fieldName + ' IS NOT NULL';
                        } else if (value.indexOf(VOID) > -1) {
                          sql = '(this.' + param.fieldName + ' IS NULL OR ' + sql + ')';
                        }
                    }

                    return sql;
                }

                return 'this.' + param.fieldName + ' = :' + param.fieldName;
            }

            function hasSomeDynamicFilterData() {
                var defer = $q.defer();
                
                getCriteria().then(function(criteria) {
                    defer.resolve(angular.isDefined(criteria.getExpression()));
                });

                return defer.promise;
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.dynamicfilterpanel.directive:sk-dynamic-filter-panel
 * @restrict E
 * @scope
 * @description
 * Componente para utilização do painel de filtros dinâmicos nas telas em HTML5.
 *
 * @param {DataSource} sk-data-source Objeto para informar a fonte de dados do filtro, que pode ser um dataset ou qualquer classe que implemente o {@link util.common.interface:DataSource DataSource}.
 * @param {string} sk-resource-id Resource ID para ser utilizado no momento de salvar o filtro e também no momento de fazer a carga do mesmo.
 * @param {string=} [sk-entity-name=undefined] Nome da entidade para ser utilizado na carga e salvamento de informações. Quando esse parametro não
 * é informado, o filtro tenta acessar uma função denominada de getEntityName do DataSource repassado.
 * @param {function} sk-show-label-others-filters Parâmetro que determina se a label de Outros será apresentada no sk-custom-filter-panel
 * @example
    <example>
        <file name="exemplo.html">
            <p>Esse componente não possui demo, pois ele é um componente dependente de metadados ainda não existe a possibilidade de apresentação nesse contexto.</p>
        </file>
    </example>
 */
angular
    .module('snk.components.dynamicfilterpanel')
    .directive('skDynamicFilterPanel', [function () {
        return {
            restrict: 'E',
            templateUrl: 'components/dynamicfilterpanel/dynamic-filter-panel.tpl.html',
            scope: {
                dataSource: '=skDataSource',
                resourceId: "@skResourceId",
                entityName: '@?skEntityName',
                saveCriteriaFn: '&skSaveCriteriaFn',
                requestRefreshFn: '&skRequestRefreshFn',
                hasFilter: '=?skHasFilter',
                hasFilterInfos: '=?skHasFilterInfos',
                groupOthers: '=?skGroupOthers',
                filterPanelInterceptor: '=?skFilterPanelInterceptor',
                componentCreated: '&?skComponentCreated',
                customCriteriaLoader: '&?skCustomCriteriaLoader',
                showLabelOthersFilters: '=?skShowLabelOthersFilters'
            },
            controller: 'DynamicFilterPanelController',
            controllerAs: 'ctrl'
        };
    }]);
angular
    .module('snk.components.entityattach')
    .controller('SkEntityAttachController', ['$scope', '$element', '$q', 'SkI18nService', 'ServiceProxy', 'StringUtils', 'SkApplication', 'ObjectUtils', 'MessageUtils', 'SanPopup', 'DynaformConstants', 'DatasetUtils',
        function ($scope, $element, $q, SkI18nService, ServiceProxy, StringUtils, SkApplication, ObjectUtils, MessageUtils, SanPopup, DynaformConstants, DatasetUtils) {
            var self = this;

            ObjectUtils.implements(self, IDataSetObserver);

            $scope.getProperties = getProperties;
            $scope.showInfo = showInfo;
            self.hideOptionsExtra = $scope.hideOptionsExtra;
            self.deleteOnlyByOwner = $scope.deleteOnlyByOwner;

            $scope.tooltipAnexo = SkI18nService.instant('Attach.anexo');
            
            var unregistryDsWatch = $scope.$watch('dataset', function (ds) {
                if (ds) {
                    ds.addObserver(self);
	                enableDisableAttachButton();
                    unregistryDsWatch();
                }
            });
            
            self.allEvents = function () {
                enableDisableAttachButton();
            };

            function enableDisableAttachButton() {
                var insertionMode = $scope.dataset.isInsertionMode();
                var size = $scope.dataset.size();

                if (angular.isDefined($scope.forceDisable) && $scope.forceDisable) {
                    $scope.configDisabled = $scope.forceDisable;
                }else {
                    $scope.configDisabled = (insertionMode || size == 0);
                }

            }

            function getProperties() {
                var deferred = $q.defer();

                $scope.dataset.whenMetadataLoaded()
                    .then(function () {
                        deferred.resolve({
                            pkRegistro: buildPkObj(),
                            entityName: $scope.entityName,
                            resourceId: $scope.resourceId,
                            setDescription: $scope.setDescription
                        });
                    });

                return deferred.promise;
            }

            function buildPkObj() {
                let pkArray = $scope.dataset.getPrimaryKeyValues(true);
                //Quando o flex realiza o toString na data, ele retorna com hora
                //0:00:00 enquanto o html5 retorna 00:00:00, fazendo com que não
                //fosse possível compartilhar os anexos entre os dois frameworks. (bruno.machado)
                var regex = /(\d{2}\/\d{2}\/\d{4}\s)(\d{2})(:\d{2}:\d{2})/;
                pkArray.forEach( (pkItem, index) => {
                    var match = regex.exec(DatasetUtils.dataToString(pkItem));
                    if(match && angular.isDefined(match[2]) && match[2].startsWith('0')) {
                        pkArray[index] = match[1] + match[2][1] + match[3];
                    }
                });
                var pkObject = pkArray.join('_');
                if(pkObject) pkObject = StringUtils.rtrim(pkObject);
                return pkObject;
            }

            function showInfo() {
                var promise = $q.defer();

                var popupInstance = SanPopup.open({
                    id: 'AttachPopup',
                    templateUrl: 'attach.html',
                    title: SkI18nService.instant('Attach.lblAnexos'),
                    size: 'lg',
                    showBtnOk: false,
                    cancelBtnLabel: SkI18nService.instant('Geral.buttonOK'),
                    controller: 'SkAttachPopupController',
                    controllerAs: 'ctrl',
                    resolve: {
                        properties: getProperties,
                        hideOptionsExtra: self.hideOptionsExtra,
                        deleteOnlyByOwner: self.deleteOnlyByOwner
                    },
                    windowClass: 'sk-entity-attach-popup',
                    useCache: false
                });

                popupInstance.result.then(function (result) {
                    promise.resolve();
                }, function (reason) {
                    promise.reject();
                });

                return promise.promise;
            }

        }]);

angular
    .module('snk.components.entityattach')
    .controller('SkAttachPopupController', ['SkApplicationInstance','$scope', '$q', 'deleteOnlyByOwner',  'hideOptionsExtra' ,'properties', 'ServiceProxy', '$window', 'FormService', 'MessageUtils', 'SkI18nService', '$timeout', 'StringUtils', 'ObjectUtils', 'SkApplication', 'KeyboardEvents', 'UserAgentUtils','GridConfig', '$popupInstance', 'Criteria', 'AngularUtil',
        function (SkApplicationInstance,$scope, $q, deleteOnlyByOwner, hideOptionsExtra,properties, ServiceProxy, $window, FormService, MessageUtils, SkI18nService, $timeout, StringUtils, ObjectUtils, SkApplication, KeyboardEvents, UserAgentUtils, GridConfig, $popupInstance, Criteria, AngularUtil) {
            var self = this;

            $popupInstance.rendered.then(creationComplete);
            $popupInstance.opened.then(onOpen);
            $popupInstance.result.then(onResult, onResult);

            var fieldNames = {
                DESCRICAO: 0,
                TIPOAPRES: 1,
                TIPOACESSO: 2,
                LINK: 3,
                NOMEARQUIVO: 4
            };

            var KEY_SESSION = "ANEXO_SISTEMA";
            var elemFocus;

            $scope.properties = angular.copy(properties);

            $scope.isFileSelected = false;

            $scope.buildFileKey = buildFileKey;
            $scope.deleteAttach = deleteAttach;
            $scope.downloadAttach = downloadAttach;
            $scope.newAttach = newAttach;
            $scope.cancelAttach = cancelAttach;
            $scope.saveAttach = saveAttach;
            $scope.selectedIndex = 0;
            $scope.hasRegister = false;
            $scope.setSelectedIndex = setSelectedIndex;
            $scope.uploaded = true;
            $scope.gridConfigId = 'grdcfg.dynaform.anexo.' + $scope.properties.entityName;
            $scope.$dismiss = dismiss;
            $scope.validateAndSave = validateAndSave;
            $scope.formInterceptor = new IFormInterceptor();
            $scope.formInterceptor.interceptFieldElement = interceptFieldElement;
            $scope.formInterceptor.interceptBuildField = interceptBuildField;
            $scope.datagridInterceptor = new IDatagridInterceptor();
            $scope.datagridInterceptor.acceptColumnField = acceptColumnField;
            $scope.setDescription =$scope.properties.setDescription;

            var configName = $scope.gridConfigId;

            let _uploadCallBacks = {};

            GridConfig.registerGridConfig($scope.gridConfigId,configName,undefined,true);

            function uploadState(state){
                if(state === 'upload-success'){
                    $scope.uploaded = false;
                    $scope.isFileSelected = true;
                    if($scope.setDescription){
                        setDescriptionField();
                    }
                }
            }

            function setDescriptionField(){
                var splitFileName = $scope.dsAnexo.getFieldValueAsString('NOMEARQUIVO');
                var fileName = splitFileName.split('.');
                $scope.dsAnexo.setFieldValue('DESCRICAO', fileName[0]);
            }

            self.isMobile = isMobile;
            self.hideOptionsExtra = hideOptionsExtra;

            self.isDeletable = isDeletable;

            function isDeletable(){
                return !deleteOnlyByOwner || $scope.dsAnexo.getFieldValue('CODUSUALT') == SkApplicationInstance.getUserID();
            }

            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, CriteriaProvider);

            function setFormFocus(){
                $timeout(function () {
                    if (!elemFocus) {
                        elemFocus = $popupInstance.element[0].querySelectorAll('sk-form [autofocus]')[0];
                    }

                    if (elemFocus){
                        elemFocus.focus();
                    }
                }, 0, false);
            }

            function interceptFieldElement(fieldName, element, controller) {
                if (fieldName == 'NOMEARQUIVO') {
                    $scope.controllerNomeArquivo = controller;
                }
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                                
                if (fieldName == 'NOMEARQUIVO') {
                    fieldProp['sk-file-key'] = buildFileKey();
                    fieldProp['sk-name-as-value'] = 'true';
                    fieldProp['sk-upload-state'] = 'uploadState($state)';
                    scope.uploadState = uploadState;

                    return AngularUtil.createDirective('sk-file-input', fieldProp, scope);
                }else if (fieldName == 'LINK') {
                    return AngularUtil.createDirective('sk-text-input', fieldProp, scope);
                }
            }

            function setSelectedIndex(index) {
                $scope.selectedIndex = index;

                setFormFocus();
            }

             // Função chamada para interceptar a coluna da datagrid
             function acceptColumnField(fieldMD, dataset) {
                if(hideOptionsExtra){
                    return fieldMD.name != 'TIPOACESSO' && fieldMD.name != 'TIPOAPRES';
                } else {
                    return true;
                } 
            }

            function creationComplete() {
                $scope.dsAnexo.initializeDataSet();
                
                $scope.dsAnexo.addDataSavedListener(function(isNew, records) {
                    var nuAttachIndex = $scope.dsAnexo.getFieldIndexByName('NUATTACH');
                    $scope.dsAnexo.refresh(undefined,{NUATTACH: records[0][nuAttachIndex]});
                });

                             
                $scope.dsAnexo.whenMetadataLoaded().then(function () {
                    $scope.formFields = FormService.buildPropertiesFromMD($scope.dsAnexo.getFieldsMetadata(), function (fieldMD) {

                        var fieldProps = {
                            'sk-dataset': $scope.dsAnexo
                        };
                        
                        if ("TIPOAPRES" == fieldMD.id || "TIPOACESSO" == fieldMD.id) {
                            fieldMD.required = false;
                        }

                        if(hideOptionsExtra){
                           if(fieldMD.name == "TIPOACESSO" || fieldMD.name == "TIPOAPRES"){
                                fieldMD.visible = false;
                           }
                        }

                        return fieldProps;
                    }, function (fieldMD) {
                        return fieldNames.hasOwnProperty(fieldMD.name)
                    });

                    $scope.formFields.sort(function (fieldA, fieldB) {
                        return fieldNames[fieldA.fieldName] - fieldNames[fieldB.fieldName];
                    });
                });
            }

            function onOpen(){
                $scope.dsAnexo.addObserver(self);
                $scope.dsAnexo.addCriteriaProvider(self);

                $scope.dsAnexo.addInsertionModeListener(function(indexBeforeInsert, dataset){
                    if(StringUtils.isNotEmpty(self.hideOptionsExtra) && self.hideOptionsExtra == 'true') {
                        dataset.setFieldValue('TIPOACESSO', 'ALL' );
                        dataset.setFieldValue('TIPOAPRES', 'LOC' );
                    }

                });

                $scope.dsAnexo.whenMetadataLoaded().then(function () {
                    if ($scope.controllerNomeArquivo){
                        $scope.controllerNomeArquivo.setFileKey(buildFileKey());
                    }

                    $scope.dsAnexo.refresh();
                });
            }

            function onResult(){
                $scope.lastProperties = $scope.properties;

                $scope.dsAnexo.resetRecords();

                $scope.dsAnexo.removeObserver(self);
                $scope.dsAnexo.removeCriteriaProvider(self);
            }

            function buildFileKey() {
                return KEY_SESSION + '_' + $scope.properties.entityName + '_' + $scope.properties.pkRegistro;
            }

            function deleteAttach() {
                if (StringUtils.isEmpty($scope.dsAnexo.getFieldValueAsString("NUATTACH"))) {
                    return;
                }

                var titleConfirmaExclusao = SkI18nService.instant('FiltroPersonalizado.lblTitleConfirmExclusao');
                var msgConfirmaDelecao = SkI18nService.instant('Dataset.messageApagarRegistro');

                MessageUtils
                    .simpleConfirm(titleConfirmaExclusao, msgConfirmaDelecao)
                    .then(function () {
                        ServiceProxy.callService('AnexoSistemaSP.excluir', {
                            paramsDelete: {
                                nuAttach: $scope.dsAnexo.getFieldValueAsString("NUATTACH"),
                                pkEntity: $scope.properties.pkRegistro,
                                nameEntity: $scope.properties.entityName,
                                nameAttach: $scope.dsAnexo.getFieldValueAsString("NOMEARQUIVO"),
                                keyAttach: $scope.dsAnexo.getFieldValueAsString("CHAVEARQUIVO")
                            }
                        }).then(function (result) {
                            $scope.dsAnexo.refresh();
                        });
                    }, function (reason) {
                        //Nada a fazer
                    });
            }

            function downloadAttach() {
                var link = StringUtils.emptyAsUndefined($scope.dsAnexo.getFieldValueAsString("LINK"));
                if (angular.isDefined(link)) {
                    SkApplication.instance().openWindow(link);
                    return;
                }


                if (StringUtils.isEmpty($scope.dsAnexo.getFieldValueAsString("NUATTACH"))) {
                    return;
                }

                ServiceProxy.callService('AnexoSistemaSP.baixar', {
                    paramsDown: {
                        nuAttach: $scope.dsAnexo.getFieldValueAsString("NUATTACH"),
                        pkEntity: $scope.properties.pkRegistro,
                        nameEntity: $scope.properties.entityName,
                        nameAttach: $scope.dsAnexo.getFieldValueAsString("NOMEARQUIVO"),
                        keyAttach: $scope.dsAnexo.getFieldValueAsString("CHAVEARQUIVO")
                    }
                }).then(function (result) {
                    let chave = result.responseBody.chave.valor;

                    if (UserAgentUtils.isElectron()) {
                        $window.open('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave);
                    }else {
                        $window.open('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave + "&forcarDownload=S");
                    }

                });
            }

            function newAttach() {
            	$scope.dsAnexo.goToInsertionMode().then(() => {
                    $scope.dsAnexo.setFieldValue("TIPOAPRES", "GLO");
                    $scope.dsAnexo.setFieldValue("TIPOACESSO", "ALL");
                });

                $scope.selectedIndex = 1;
                setFormFocus();
            }

            function finalizaEdition() {
                $scope.selectedIndex = 0;
                $scope.uploaded = true;

                $scope.isFileSelected = false;

                $timeout(function () {
                    var elemDataGrid = angular.element(document.getElementById('attachDatagrid'));
                    var dataGridController = elemDataGrid.controller('skDatagrid');

                    $scope.dataGridController = dataGridController;
                }, 0, false);
            }

            function cancelAttach() {
                $scope.dsAnexo.cancelEdition();
                finalizaEdition();
            }

            function saveAttach() {
                var saveDeferred = $q.defer();

                var continueSave = true;
                
                var link = StringUtils.emptyAsUndefined($scope.dsAnexo.getFieldValueAsString('LINK'));
                var nameFile = StringUtils.emptyAsUndefined($scope.dsAnexo.getFieldValueAsString("NOMEARQUIVO"));
                if(angular.isUndefined(link) && angular.isUndefined(nameFile)){
                    MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, SkI18nService.instant('Attach.arquivoAnexo'));
                    saveDeferred.reject();
                    continueSave = false;
                }

                if(angular.isDefined(link) && angular.isDefined(nameFile)){
                    MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, SkI18nService.instant('Attach.linkArquivo'));
                    saveDeferred.reject();
                    continueSave = false;
                }

                if (($scope.dsAnexo.isRecordDirty() || $scope.dsAnexo.isInsertionMode()) && continueSave) {
                    var numAttach = $scope.dsAnexo.getFieldValueAsString("NUATTACH");
                    var paramsElem = {
                        params: {
                            pkEntity: $scope.properties.pkRegistro,
                            keySession: buildFileKey(),
                            nameEntity: $scope.properties.entityName,
                            description: $scope.dsAnexo.getFieldValueAsString("DESCRICAO"),
                            keyAttach: $scope.dsAnexo.getFieldValueAsString("CHAVEARQUIVO"),
                            typeAcess: $scope.dsAnexo.getFieldValueAsString("TIPOACESSO"),
                            typeApres: $scope.dsAnexo.getFieldValueAsString("TIPOAPRES"),
                            nuAttach: numAttach,
                            nameAttach: nameFile,
                            link:link
                        }
                    };

                    if ($scope.dsAnexo.getFieldValueAsString("TIPOAPRES") == "LOC") {
                        paramsElem.params['resourceID'] = $scope.properties.resourceId;
                    }

                    if ($scope.isFileSelected) {
                        paramsElem.params.fileSelect = 1;
                    }else{
                        paramsElem.params.fileSelect = 0;
                    }

                    if(numAttach == ""){
                        paramsElem.params.oldFile = "";
                    }else{
                        paramsElem.params.oldFile = nameFile;
                    }

                    ServiceProxy.callService('AnexoSistemaSP.salvar',
                        paramsElem
                    ).then(function (result) {
                        var nuAttach = result.responseBody.chave.valor;
                        var currentRow = $scope.dsAnexo.getCurrentRowAsObject('NUATTACH');
                        currentRow.NUATTACH = nuAttach;

                        finalizaEdition();

                        saveDeferred.resolve([currentRow]);
                    });

                } else if(continueSave){
                    cancelAttach();
                    saveDeferred.reject();
                }

                return saveDeferred.promise;
            }

            function validateAndSave() {
                var link = StringUtils.emptyAsUndefined($scope.dsAnexo.getFieldValueAsString('LINK'));
                var nameFile = StringUtils.emptyAsUndefined($scope.dsAnexo.getFieldValueAsString("NOMEARQUIVO"));

                if (angular.isUndefined(link) && angular.isUndefined(nameFile)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, SkI18nService.instant('Attach.arquivoAnexo'));
                } else {
                    $scope.dsAnexo.save();
                }
            }

            function updateHasRegister() {
                $scope.hasRegister = StringUtils.isEmpty($scope.dsAnexo.getFieldValueAsString("NUATTACH"));
            }

            self.currentLineChanged = function () {
                updateHasRegister();
            };

            self.refreshed = function () {
                updateHasRegister();
            };

            self.dataModified = function() {
                $scope.uploaded = false;
            };

            self.editionCanceled = function(){
                $scope.selectedIndex = 0;
            };

            self.getCriteria = function () {
                var criterio = Criteria();

                criterio.append('(this.PKREGISTRO = ? AND this.NOMEINSTANCIA = ?)');
                criterio.addParameter(Criteria.buildStringParameter(($scope.properties.pkRegistro + '_' + $scope.properties.entityName)));
                criterio.addParameter(Criteria.buildStringParameter($scope.properties.entityName));
                
                var resourceID = $scope.properties.resourceId;
                var resourceIdCompatibleFlex;

                if (!resourceID && SkApplication.instance()) {
                	resourceID = SkApplication.instance().getResourceID();
                }

                if(SkApplication.instance()){
                    resourceIdCompatibleFlex = SkApplication.instance().getResourceID();
                }

                if (resourceID) {
                    criterio.append(' AND ((this.TIPOAPRES = \'GLO\') OR (this.TIPOAPRES = \'LOC\' AND (this.RESOURCEID = ?  OR this.RESOURCEID = ?) ))');
                    criterio.addParameter(Criteria.buildStringParameter(resourceID));
                    //Isso foi necessário pois o resourceId de abas de relacionamento é montado de forma diferenteno flex.
                    criterio.addParameter(Criteria.buildStringParameter(resourceIdCompatibleFlex));
                }

                return criterio;
            };

            function isMobile() {
                return UserAgentUtils.isMobile() && $scope.selectedIndex == 0;
            }

            function dismiss(reason){
                $scope.dsAnexo.askAndCancelEdition().then(function(result){
                    $popupInstance.dismiss(reason);
                });
            }

        }]);

/**
 * @ngdoc directive
 * @name snk.components.entityattach.directive:sk-entity-attach
 * @restrict E
 * @description
 * A diretiva 'skEntityAttach' permite anexar/vincular arquivos a telas do sistema.
 *
 * @param {string} [sk-entity-name=undefined] Nome da entidade base que o dataset representará
 *
 * @param {string} [sk-resource-id=undefined]  Nesse parametro deve ser informado o resourceId da tela que está sendo usado o componente de anexo.
 *
 * @param {string} [sk-dataset=undefined]  Nesse parametro deve ser informado o dataSet da entidade que será gravado os anexos
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
         <div ng-controller="MyController as ctrl">
             <sk-entity-attach sk-dataset="dataset" sk-entity-name="{{::entityName}}" sk-resource-id="{{::resourceId}}">
             </sk-entity-attach>
         </div>
     </file>
     <file name="appEntityAttach.js">
     angular
     .module('appEntityAttach', ['snk'])
     .controller('MyController', function(){

     });
     </file>
 </example>
 *
 * Author: Deivid Rodrigues
 */

angular
    .module('snk.components.entityattach')
    .directive('skEntityAttach', function () {
        return {
            templateUrl: 'components/entityattach/entityattach.tpl.html',
            restrict: 'E',
            controller: 'SkEntityAttachController',
            scope: {
                entityName: '@skEntityName',
                resourceId: '@skResourceId',
                dataset: '=skDataset',
                hideOptionsExtra: '@skHideOptionsExtra',
                deleteOnlyByOwner: '=skDeleteOnlyByOwner',
                forceDisable: '=skForceDisable',
                setDescription: '@skSetDescription'
            }
        };
    });

angular
    .module('snk.components.entitycard')
    .constant('EntityCardConstants', {
        'ENTITYCARD_FAVORITE_UPDATED': 'event.entitycard.favorite.updated'
    });
/**
 * @ngdoc directive
 * @name snk.components.entitycard.directive:sk-entity-card
 * @restrict E
 * @description
 *  Diretiva que renderiza um cartão de visita de uma entidade do sistema.
 *
 * @element E
 *
 * @example
 <example module="app">
 <file name="appEntityCard.html">
 <sk-entity-card sk-entity-name="Produto" sk-pk-field="CODPROD" sk-description-field="DESCRPROD">
 </sk-entity-card>
 </file>
 </example>
 */
angular
    .module('snk.components.entitycard')
    .directive('skEntityCard', ['$window', '$translate', 'SkI18nService', 'EntityCardConstants', 'StringUtils', 'UserAgentUtils',  'ObjectUtils', 'SkApplication', 'SkPesquisaService', '$http', '$q', 'DateUtils', 'ArrayUtils', 'NumberUtils', 'MGEParameters',
        function ($window, $translate, SkI18nService, EntityCardConstants, StringUtils, UserAgentUtils, ObjectUtils, SkApplication, SkPesquisaService, $http, $q, DateUtils, ArrayUtils, NumberUtils, MGEParameters) {
            var DEFAULT_FIELDS_LIMIT = 6;

            return {
                restrict: 'E',
                scope: {
                    entityName: '=skEntityName',
                    pkField: '=skPkField',
                    otherEntityPks: '=skOtherEntityPks',
                    descriptionField: '=skDescriptionField',
                    isFavorite: '=?skIsFavorite',
                    imageField: '=?skImageField',
                    resourceId: '=?skResourceId',
                    data: '=?skData',
                    fieldsMetadata: '=skFieldsMetadata',
                    enableShowDetails: '=?skEnableShowDetails',
                    singleColumn: '=?skSingleColumn',
                    compact: '@skCompact',
                    allPks: '=skAllPks',
                    disableFavoriteOpt: '=?skDisableFavoriteOpt',
                    highlightOn: '=?skHighlightOn',
                    fieldsLimit: '@skFieldsLimit',
                    resolvePkEntity: '=?skResolvePkEntity'
                },
                templateUrl: 'components/entitycard/entitycard.tpl.html',
                link: linkFn
            };

            function linkFn(scope, element) {
                var URL_IMG_TEMPLATE = '/mge/image/entity/{pk}.jpg?w=70&h=70&entity={entityName}&imgField={imageField}&acceptNoImage=false{pkOthers}';
                var self = this;

                var isMultiAbas = MGEParameters.asInteger('mge.ativa.multi.abas') === 0 || 1 ? true : false;
                var ofereceHTML5 = MGEParameters.asInteger('mge.core.habilita.tela.html5') == 1 ? true : false;

                scope.lblSemInformacoes = SkI18nService.instant('EntityCard.semInformacoes', {entityName: scope.entityName});

                scope.highlightOptions = {
                    splitQuery: ','
                };

                var _compact = (scope.compact == 'true');
                var _lastLoadedUrl;
                var _pkFieldMetadata;
                var _descriptionFieldMetadata;

                var regexEmail = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i;
                var regexUrl = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;


                if (_compact) {
                    element.addClass('compact');
                }

                if (!_compact && angular.isUndefined(scope.enableShowDetails)) {
                    scope.enableShowDetails = true;
                }

                if (angular.isUndefined(scope.singleColumn)) {
                    scope.singleColumn = true;
                }

                scope.loadingImage = false;

                scope.$watch('data', function (data) {
                    element[data ? 'removeClass' : 'addClass']('no-data');

                    if (data) {
                        angular.forEach(data, function (value, key) {
                            if (angular.isString(value)) {
                                var fieldMD = getFieldMetadata(key);

                                if (fieldMD && fieldMD.type == 'D') {
                                    data[key] = value.replace('00:00:00', '');
                                }
                            }
                        });
                    }

                    loadImage();

                    if (_compact) {
                        scope.nick = buildNick();
                        scope.title = buildTitle();
                    } else {
                        buildEntityFields();
                    }
                });

                scope.textToColor = function (args) {
                    if (scope.descriptionField) {
                        return StringUtils.textToColor(args);
                    } else {
                        return '#ccc';
                    }
                };

                scope.getFavoriteIconTooltip = function () {
                    if (scope.isFavorite) {
                        return $translate.instant('EntityCard.desmarcarFavorito');
                    } else {
                        return $translate.instant('EntityCard.marcarFavorito');
                    }
                };

                 function buildTitle() {
                    if (!scope.data) {
                        return '';
                    }

                    var title;
                    var hasMask = '_MASK';
                    var pkFieldMD = getPkFieldMetadata();
                    
                     if (angular.isDefined(scope.data[scope.pkField + hasMask])) {
                        title = valueToString(scope.data[scope.pkField + hasMask], pkFieldMD);
                    } else {
                        title = valueToString(scope.data[scope.pkField], pkFieldMD);
                    }

                    if (!(scope.pkField == scope.descriptionField) && scope.descriptionField && scope.data[scope.descriptionField]) {
                        title = (title || '').toString() + ' - ' + scope.data[scope.descriptionField];
                    }

                    var matches = scope.data['__matchFields'];

                    if (angular.isArray(matches)) {
                        if (ArrayUtils.isIn(matches, scope.pkField)) {
                            return highlithValue(undefined, title, pkFieldMD, true);
                        } else if (ArrayUtils.isIn(matches, scope.descriptionField)) {
                            return highlithValue(undefined, title, getDescriptionFieldMetadata(), true);
                        }
                    }

                    return title;
                };

                 function buildNick() {
                     if (!scope.data) {
                         return '';
                     }

                    var descr = scope.data[scope.descriptionField];

                    if (StringUtils.isEmpty(descr)) {
                        var pkFieldMD = getPkFieldMetadata();
                        var pkValue = scope.data[scope.pkField];

                        descr = valueToString(pkValue, pkFieldMD);
                    }

                    if (descr != undefined) {
                        if(typeof descr != 'string'){
                            try{
                                descr = String(descr);
                            }catch{
                                descr = '';
                            }    
                        }
                        
                        descr = descr.trim();

                        return descr.substr(0, Math.min(3, descr.length));
                    } else {
                        return '';
                    }
                };

                scope.updateFavorite = function ($event) {
                    var oldIsFavoriteValue = scope.isFavorite;

                    $event.preventDefault();
                    $event.stopPropagation();

                    scope.isFavorite = !scope.isFavorite;

                    var pkObj = {};
                    var pkArr = [];

                    if(scope.data){
                        var pkField = scope.pkField;

                        pkObj[pkField] = scope.data[pkField];

                        if(scope.allPks){
                            scope.allPks.forEach(function (pkName) {
                                pkObj[pkName] = scope.data[pkName];
                                pkArr.push(pkObj[pkName]);
                            });
                        }                
                    }
                    SkPesquisaService.updateFavorite(scope.entityName, pkArr, scope.isFavorite).then(function () {
                        scope.$root.$emit(EntityCardConstants.ENTITYCARD_FAVORITE_UPDATED, {
                            entityName: scope.entityName,
                            pk: pkObj,
                            isFavorite: scope.isFavorite
                        });
                    }, function (error) {
                        scope.isFavorite = oldIsFavoriteValue;
                    });
                };

                scope.showDetails = function ($event) {
                    $event.stopPropagation();
                    $event.preventDefault();

                    var pkField = scope.pkField;

                    var pk;

                    if (scope.data) {
                        pk = {};
                        pk[pkField] = scope.data[pkField];

                        if (scope.allPks) {
                            scope.allPks.forEach(function (pkName) {
                                if (scope.data[pkName]) {
                                    pk[pkName] = scope.data[pkName];
                                }
                            });
                        }
                        
                    }

                    if(isMultiAbas && ofereceHTML5){
                        if(UserAgentUtils.isFirefox() && $window.parent.__multTabs){
                            $window.parent.__multTabs.openWorkspaceView();
                        } else {
                            $window.open('', 'workspaceView');
                        }
                    }

                    SkApplication.instance().openApp(scope.resourceId, pk);
                };

                function getFieldMetadata(fieldName) {
                    if (scope.fieldsMetadata) {
                        for (var i = 0, len = scope.fieldsMetadata.length; i < len; i++) {
                            var curr = scope.fieldsMetadata[i];
                            if (curr.fieldName == fieldName) {
                                return curr;
                            }
                        }
                    }

                    return undefined;
                }

                function getValueAsString(fieldName, fieldMD) {
                    return valueToString(scope.data[fieldName], fieldMD);
                }

                function loadImage() {
                    if (!scope.data || StringUtils.isEmpty(scope.imageField) || _compact) {
                        scope.hasImage = false;
                        return;
                    } else {
                        var pkFieldMD = getPkFieldMetadata();
                        var pkOthers;
                        var pk;

                        if (angular.isFunction(scope.resolvePkEntity)) {
                            var pksResolve = scope.resolvePkEntity(scope.pkField, pkFieldMD, scope.otherEntityPks, getValueAsString);

                            pk = pksResolve.pk;

                            if (angular.isDefined(pksResolve.pkOthers)) {
                                pkOthers =  '&pkOthers=' + pksResolve.pkOthers;
                            }
                        }

                        if (angular.isUndefined(pk)) {
                            pk = getValueAsString(scope.pkField, pkFieldMD);
                            
                            if (angular.isArray(scope.otherEntityPks) && scope.otherEntityPks.length > 0) {
                                pkOthers = '&pkOthers=';
    
                                scope.otherEntityPks.forEach(function (otherEntityPk) {
                                    pkOthers += getValueAsString(otherEntityPk);
                                })
                            }
                        }

                        var url = StringUtils.substitute(URL_IMG_TEMPLATE, {
                            pk,
                            entityName: scope.entityName,
                            imageField: scope.imageField,
                            pkOthers
                        });

                        _lastLoadedUrl = url;

                        scope.loadingImage = true;

                        $http.get(url, {responseType: 'blob'})
                            .then(function (response) {
                                scope.hasImage = true;

                                encodeImage(response.data)
                                    .then(function (fileEncoded) {
                                        scope.fileEncoded = fileEncoded;
                                    }).finally(function () {
                                    scope.loadingImage = false;
                                });
                            }, function () {
                                scope.hasImage = false;
                                scope.loadingImage = false;
                            });
                    }
                }

                function valueToString(value, fieldMD, stringZero) {
                    if (fieldMD && fieldMD.options) { //Se temos options, então devemos procurar o label correspondente.
                        for (key in fieldMD.options) {
                            if (key == value && angular.isDefined(fieldMD.options[key])) {
                                return fieldMD.options[key];
                            }
                        }
                    }

                    if (angular.isNumber(value)) {
                        if (ObjectUtils.getProperty(fieldMD, 'dataType') == 'F') {
                            value = NumberUtils.format(value, 2, 9);
                        } else if ((angular.isUndefined(stringZero) || stringZero)) {
                            value = StringUtils.stringZero(value, 3, false);
                        }

                        if (fieldMD && fieldMD.mask) {
                            if (!fieldMD.expandedMask) {
                                fieldMD.expandedMask = StringUtils.expandHierarchyMask(fieldMD.mask);
                            }

                            value = StringUtils.applyHierarchyMask(fieldMD.expandedMask, value, true);
                        }

                        return value;
                    } else if (angular.isDate(value)) {
                        var userType = fieldMD && fieldMD.userType;
                        return DateUtils.formatDate(value, (userType == 'H' ? DateUtils.DEFAULT_DATETIME_FORMAT : DateUtils.DEFAULT_DATE_FORMAT));
                    } else {
                        if (fieldMD && fieldMD.uiType) {
                            switch (fieldMD.uiType) {
                                case 'CGC_CPF':
                                    value = StringUtils.formatCgcCpf(value);
                                    break;
                                case 'Phone':
                                    value = StringUtils.toPhone(value);
                                    break;
                            }
                        }

                        return value;
                    }
                }

                function encodeImage(image) {
                    var defer = $q.defer();

                    var reader = new FileReader();

                    reader.onload = function (evt) {
                        defer.resolve(evt.target.result);
                    };

                    reader.onerror = function (evt) {
                        defer.reject(evt);
                    };

                    reader.readAsDataURL(image);

                    return defer.promise;
                }

                function getPkFieldMetadata() {
                    if (!_pkFieldMetadata) {
                        if (scope.pkField && scope.fieldsMetadata) {
                            for (var i = 0, len = scope.fieldsMetadata.length; i < len; i++) {
                                var curr = scope.fieldsMetadata[i];

                                if (scope.pkField == curr.fieldName) {
                                    _pkFieldMetadata = curr;
                                    break;
                                }
                            }
                        }
                    }

                    return _pkFieldMetadata;
                }

                function getDescriptionFieldMetadata() {
                    if (!_descriptionFieldMetadata) {
                        if (scope.descriptionField && scope.fieldsMetadata) {
                            _descriptionFieldMetadata = ArrayUtils.find(scope.fieldsMetadata, function(curr) {
                                return scope.descriptionField == curr.fieldName;
                            });
                        }
                    }

                    return _descriptionFieldMetadata;
                }



                function buildEntityFields() {
                    scope.fields = [];

                    if (!scope.data) {
                        return;
                    }

                    scope.nick = buildNick();
                    scope.title = buildTitle();

                    var fieldsLimit = scope.fieldsLimit || DEFAULT_FIELDS_LIMIT;

                    var values = {};

                    if (scope.descriptionField && scope.data) {
                        values[scope.data[scope.descriptionField]] = undefined;
                    }

                    var mdByName = {};

                    var fieldsMetadata = scope.fieldsMetadata.filter(function(field) {
                        var accept = StringUtils.isNotEmpty(scope.data[field.fieldName]) && field.visible !== false && field.type != 'B' && scope.pkField != field.fieldName &&
                            scope.descriptionField != field.fieldName && (field.isPrimaryKey || !field.isLinkField) && !(field.type == 'S' && field.presentationType == 'H');

                        if (accept) {
                            mdByName[field.fieldName] = field;
                        }
                        
                        //Condição que trata o problema de trazer imagem no entityCard na pesquisa de registros
                        if(typeof scope.data[field.fieldName] === 'string' && (scope.data[field.fieldName].indexOf('<img') > -1 || scope.data[field.fieldName].indexOf('<svg') > -1)){
                            return false;
                        }

                        return accept;
                    });

                    var matchFields = scope.data['__matchFields'];

                    if (angular.isArray(matchFields)) {
                        matchFields.forEach(function(macthField) {
                            var fieldMD = ArrayUtils.removeReference(fieldsMetadata, mdByName[macthField]);

                            if (fieldMD) {
                                fieldsMetadata.unshift(fieldMD);
                            }
                        });
                    }

                    ArrayUtils.forEach(fieldsMetadata, function (field) {
                        var value = scope.data[field.fieldName];

                        var type;

                        if (regexEmail.test(value)) {
                            type = 'E';
                        } else if (field.type == 'L' || regexUrl.test(value)) {
                            type = 'L';
                        } else {
                            type = 'S';
                        }

                        value = valueToString(value, field);

                        if (value && value.trim() && !values.hasOwnProperty(value)) {
                            scope.fields.push({
                                label: field.description,
                                value: highlithValue(matchFields, value, field),
                                type: type
                            });

                            values[value] = undefined;
                        }

                        return scope.fields.length < fieldsLimit;
                    });
                }

                function highlithValue(matchFields, value, fieldMD, forceMatch) {
                    if (scope.highlightOn && (forceMatch || ArrayUtils.isIn(matchFields, fieldMD.fieldName))) {
                        var replacements = scope.highlightOn.split(/%|,|\s+/);

                        var lastMatchIndex = 0;
                        var cleanText = StringUtils.replaceAccentuatedChars(value);

                        replacements.forEach(function(r) {
                            if (r) {
                                r = StringUtils.replaceAccentuatedChars(r);

                                let specialChars = StringUtils.getSpecialCharacters(r);

                                if (angular.isDefined(specialChars) && specialChars.length > 0){
                                    r = StringUtils.removeSpecialCharacters(r);
                                }

                                if (fieldMD.mask || fieldMD.uiType == 'CGC_CPF' || fieldMD.uiType == 'Phone') {
                                    //Fazemos isso para descondirerar os caracteres especiais de formatação da string
                                    r = r.split('').join('\\.?\\-?\\/?\\(?\\)?');
                                }

                                var regex = new RegExp(r, "ig");
                                regex.lastIndex = lastMatchIndex;
                                var match = regex.exec(cleanText);

                                if (match && match.length > 0) {
                                    lastMatchIndex = match.index;
                                    var sizeMatch = match[0].length;

                                    var txtToColor = value.substring(lastMatchIndex, lastMatchIndex + sizeMatch);
                                    var txtColored = "<span class='highlight'>" + txtToColor + "</span>";

                                    var start = value.substring(0, lastMatchIndex);
                                    var end = value.substring(lastMatchIndex + sizeMatch);

                                    value = start + txtColored + end;
                                    lastMatchIndex = lastMatchIndex + txtColored.length;

                                    cleanText = StringUtils.replaceAccentuatedChars(value);
                                }
                            }
                        });

                        return  value;
                    } else {
                        return  value;
                    }
                }
            }
        }]);

/**
 * Created by bruno.brandao on 28/05/2015.
 */
/**
 * @ngdoc directive
 * @name snk.components.entitycard.directive:sk-entity-card-link
 * @restrict E
 * @description
 *  Diretiva que renderiza um cartão de visita de uma entidade do sistema.
 *
 * @element ANY
 *
 * @example
    <example module="app">
        <file name="index.html">
            <sk-entity-card>
            </sk-entity-card>
         </file>
         <file name="app.js">
             angular
             .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.entitycard')
    .directive('skEntityCardLink', ['$q', 'StringUtils', 'SkPesquisaService', 'EntityCardConstants', '$compile',
function ($q, StringUtils, SkPesquisaService, EntityCardConstants, $compile) {
    return {
        restrict: 'E',
        scope: {
            entityName: '@skEntityName',
            label: '=skLabel',
            value: '=skValue',
            pkFieldName: '@skPkFieldName',
            criteriaBuilder: '&skCriteriaBuilder',
            targetResourceId: '@?skTargetResourceId'
        },
        template: '<span ng-bind="label" class="link" sk-popover popover-template-url="components/entitycard/labellink/entitycardpopup.tpl.html" create-on-load="false" show-btn-apply="false" show-btn-close="false" always-load-properties="true" width="auto" height="auto" properties="getProperties" popover-placement="top" hide-on-scroll="true" popover-class="entity-card-link-popover"></span>',
        link: linkFn
    };

    function linkFn(scope, element) {
        scope.$root.$on(EntityCardConstants.ENTITYCARD_FAVORITE_UPDATED, function (e, args) {
            if (args.entityName != scope.entityName) {
                return;
            }
            
            var changedPk = args.pk;
            var thisPk = buildPkObject();

            if (angular.isDefined(thisPk) && angular.equals(changedPk, thisPk)) {
                scope.entity.data[0].__isFavorite = args.isFavorite;
            }
        });

        function buildPkObject() {
            if (scope.entity && scope.entity.data && scope.entity.data[0]){
                var data = scope.entity.data[0];
                var pk = {};

                scope.entity.allPks.forEach(function (pkName) {
                    pk[pkName] = data[pkName];
                });

                return pk;
            }
        }

        function buildProperties(){
            return {
                entityName: scope.entityName,
                entity: scope.entity,
                data: scope.entity && scope.entity.data[0] ? scope.entity && scope.entity.data[0] : undefined,
                hasImage: scope.entity && scope.entity.data[0] ? scope.entity.data[0].__hasImage : false,
                isFavorite: scope.entity && scope.entity.data[0] ? scope.entity.data[0].__isFavorite : false,
                imageField: scope.entity ? scope.entity.imageField : undefined,
                showDetails: true
            };
        }

        function buildOptions(){
            return {
                pkFieldName: scope.pkFieldName
            }
        }

        function buildCriteria() {
            var criteriaBuider = scope.criteriaBuilder();

            if (criteriaBuider) {
                return criteriaBuider(scope.entityName, scope.pkFieldName);
            } else {
                return undefined;
            }
        }

        scope.getProperties = function(){
            var deferred = $q.defer();

            if (StringUtils.isEmpty(scope.value)){
                scope.entity = undefined;
                deferred.resolve(buildProperties());
            } else if (scope.lastLoadedPk != scope.value){
                SkPesquisaService.loadSuggestionsByPk(scope.entityName, scope.value, undefined, buildCriteria(), buildOptions())
                    .then(function(entity){
                        scope.lastLoadedPk = entity.data[0][entity.pkField];
                        scope.entity = entity;
                        (scope.targetResourceId) ? entity.resourceID = scope.targetResourceId : undefined;
                        deferred.resolve(buildProperties());
                    });
            } else {
                deferred.resolve(buildProperties());
            }

            return deferred.promise;
        };
    }
}]);

angular
    .module('snk.components.entitycard')
    .component('skStandaloneEntityCard', {
        bindings: {
            data: '=?skData'
        },
        template: '<sk-entity-card sk-single-column="false" sk-disable-favorite-opt="true" sk-entity-name="$ctrl.data.entityName" sk-pk-field="$ctrl.data.pkField"'
                + 'sk-other-entity-pks="$ctrl.data.otherEntityPks" sk-description-field="$ctrl.data.descriptionField" sk-has-image="$ctrl.data.hasImage"'
                + 'sk-is-favorite="$ctrl.data.isFavorite" sk-image-field="$ctrl.data.imageField" sk-resource-id="$ctrl.data.resourceID"'
                + 'sk-data="$ctrl.data.data[0]" sk-fields-metadata="$ctrl.data.fieldsMetadata"></sk-entity-card>'
    });
angular
    .module('snk.components.entitylist')
    .controller("SkEntityListController", ['$scope', '$translate', 'SkPesquisaService', 'ArrayUtils', 'MessageUtils', 'ServiceProxy', 'StringUtils', 'AngularUtil', '$element', 'DomUtil', '$q', '$timeout', 'SnackbarService',
        function ($scope, $translate, SkPesquisaService, ArrayUtils, MessageUtils, ServiceProxy, StringUtils, AngularUtil, $element, DomUtil, $q, $timeout, SnackbarService) {
            var self = this;

            $scope.options = [];
            $scope.checkBoxAll = false;

            $scope.atualizaCheckBoxLista = atualizaCheckBoxLista;
            $scope.addItem = addItem;
            $scope.removeSelectedItems = removeSelectedItems;
            $scope.clearAll = clearAll;
            $scope.selectItem = selectItem;
            $scope.notifyChange = notifyChange;
            $scope.getSelectedItems = getSelectedItems;
            $scope.hasData = hasData;
            $scope.saveState = saveState;
            $scope.saveStateOnCheck = saveStateOnCheck;
            $scope.onCheckboxClick = onCheckboxClick;

            self.getDataProvider = getDataProvider;
            self.setDataProvider = setDataProvider;
            self.clearDataProvider = clearAll;
            self.getSelectedItems = getSelectedItems;
            self.getCheckedItems = getCheckedItems;

            var _lastSelectedItem;
            var _bodyEl;

            init();

            function init() {
                var parent = $element.parent();
                if(parent.length > 0 && (parent[0].id == "simple-item-content" || parent[0].id == "simple-item-content-inline")){
                    parent = parent[0]
                    while (parent.tagName != "SK-SIMPLE-FORM"){
                        if (parent.tagName == "SK-SIMPLE-ITEM"){
                            parent.classList.add('simple-entity-list')
                        }
                        parent = parent.parentElement
                    }
                    parent.classList.add('simple-form-entity-list')
                }

                if ($scope.visible == undefined) {
                    $scope.visible = true;
                }

                if ($scope.showCheckBox == undefined) {
                    $scope.showCheckBox = true;
                }

                if (!$scope.standAloneMode) {
                    //loadState();
                } else if ($scope.records) {
                    refreshDataProvider();
                }

                if (!$scope.onlyOneSelection) {
                    $scope.$watch('value', function (newValue) {
                        setDataProvider((newValue || []).map(function (item) {

                            if(item.pkFields){
                                return {
                                    pkFields: item.pkFields,
                                    data: item.data,
                                    checked: true
                                }
                            } else if (item.data) {
                            	return {
                            		data: item.data,
                                    checked: item.hasOwnProperty('checked') ? item.checked : true
                            	}
                            }

                            return {
                                data: item,
                                checked: true
                            };
                        }));
                    });
                }

                if ($scope.componentCreated) {
                    $scope.componentCreated({ $component: self });
                }
                
                loadState();

                if ($scope.standAloneMode) {
                    $scope.$watch('records', function (newValue) {
                        if ($scope.records) {
                            refreshDataProvider();
                        }
                    });
                }
            }

            function sortDataProvider() {
                if(!$scope.standAloneMode) {             
                     ArrayUtils.sortByStringProperty($scope.dataProvider, 'label');
                }              
            }

            function hasData() {
                return !$scope.disableActions && $scope.dataProvider && $scope.dataProvider.length > 0;
            }

            function getDataProvider() {
                return $scope.dataProvider;
            }

            function setDataProvider(dataProvider) {
                $scope.dataProvider = dataProvider;
                
                if (!dataProvider) {
                    return;
                }                

                for (data of dataProvider) {
                    data.checked =  data.checked == true || data.checked == "true" ? true : false;
                }

                loadEntityListDescriptions(dataProvider);

                
            }

            function loadEntityListDescriptions(dataProvider) {
                if (!dataProvider) {
                    return;
                }

                var itens = dataProvider.map(function (item) {

                    if(item.pkFields){
                        return {
                            pkFields: item.pkFields,
                            data: item.data,
                        }
                    }

                    return {
                        data: item.data
                    }
                });

                let req = {
                    entityName: $scope.entityName,
                    itens: itens
                }

                if($scope.descriptionField){
                    req.descriptionField = $scope.descriptionField;
                }

                ServiceProxy.callService('SystemUtilsSP.loadEntityListDescriptions', req).then(function (result) {
                    var itens = result.responseBody.itens;
                    var item;

                    while (item = itens.pop()) {
                        for (var i = 0, length = dataProvider.length; i < length; i++) {
                            var dpItem = dataProvider[i];
                           
                            if (dpItem.data == item.data) {
                                if(angular.isUndefined(item.label)){
                                    item.label = '';
                                }
                                dpItem.value = (item.data + ' - ' + item.label);       
                                dpItem.label = item.label;                   
                                break;
                            }
                        }
                    }
                    $scope.dataProvider=dataProvider;
                    sortDataProvider();
                    notifyChange();
                });
            }

            function atualizaCheckBoxLista() {
                if ($scope.dataProvider) {
                    for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                        var item = $scope.dataProvider[i];
                        item.checked = $scope.checkBoxAll;
                    }
                }

                notifyChange();
            }

            function notifyChange(item, checked) {
                checked = checked!= undefined ? checked : true;
                if (!$scope.dataProvider) {
                    return;
                }

                if (!$scope.value) {
                    $scope.value = [];
                }

                if (item) {
                    if($scope.onlyOneSelection){
                        $scope.value.length = 0;
                        $scope.value.push(item);
                        $scope.valueSelected = item.data;
                    }else{
                        if(item.pkFields){
                            if ($scope.value.indexOf(item) < 0) {
                                $scope.value.push(item);
                                _lastSelectedItem = item;
                            }else{
                                ArrayUtils.removeReference($scope.value, item);
                            }
                        }else{
                            if ($scope.value.indexOf(item.data) < 0 && checked) {
                                $scope.value.push(item.data);
                                _lastSelectedItem = item;
                            }else{
                                ArrayUtils.removeReference($scope.value, item.data);
                            }   
                        }                      
                    }
                    for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                        $scope.dataProvider[i].selected = $scope.dataProvider[i].data === item.data;
                    }
                } else {
                    $scope.value.length = 0;
                    $scope.checkBoxAll = false;

                    for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                        var item = $scope.dataProvider[i];

                        if ($scope.onlyOneSelection) {
                            if (item.selected) {
                                item.checked = true;
                                $scope.valueSelected = item.data;
                                $scope.value.push(item);
                                break;
                            }
                        } else {
                            if(item.pkFields){
                                $scope.value.push(item);
                            } else if(item.checked != false){ 
                                $scope.value.push(item.data);
                            } 
                        }
                    }
                }

                updateCheckBoxHeader();

                if ($scope.onChange) {
                    $scope.onChange();
                }
            }

            function updateCheckBoxHeader() {
                if ($scope.value.length <= 0) {
                    $scope.checkBoxAll = false;
                }
                else if ($scope.value.length == $scope.dataProvider.length) {
                    $scope.checkBoxAll = true;
                } else {
                    $scope.checkBoxAll = 'I';
                }
            }

            function refreshDataProvider() {
                if ($scope.standAloneMode && $scope.records) {
                    $scope.dataProvider = $scope.records.slice(0);
                    sortDataProvider();
                    notifyChange();
                }
            }

            function selectItem(item, $event) {
                if (!$event.ctrlKey && !$event.shiftKey) {
                    for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                        $scope.dataProvider[i].selected = $scope.dataProvider[i].data === item.data;
                    }
                    _lastSelectedItem = item;
                } else if ($event.ctrlKey) {
                    item.selected = !item.selected;
                } else if ($event.shiftKey) {
                    var lastSelectedIndex = $scope.dataProvider.indexOf(_lastSelectedItem);
                    var currentSelectedIndex = $scope.dataProvider.indexOf(item);

                    if (lastSelectedIndex > -1 && currentSelectedIndex > -1) {
                        var firstIndex = 0;
                        var lastIndex = 0;
                        if (currentSelectedIndex > lastSelectedIndex) {
                            firstIndex = lastSelectedIndex;
                            lastIndex = currentSelectedIndex;
                        } else if (lastSelectedIndex > currentSelectedIndex) {
                            firstIndex = currentSelectedIndex;
                            lastIndex = lastSelectedIndex;
                        }

                        for (var i = firstIndex; i <= lastIndex; i++) {
                            $scope.dataProvider[i].selected = true;
                        }
                    }
                }
                
                if ($scope.onlyOneSelection) {
                	notifyChange(item);
                }
            }

            function getSelectedItems() {
                var selectedItems = [];

                if ($scope.disableActions) {
                    return selectedItems;
                }

                if (!$scope.dataProvider) {
                    return selectedItems;
                }

                for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                    var item = $scope.dataProvider[i];
                    if (item.selected) {
                        selectedItems.push(item);
                    }
                }

                return selectedItems;
            }

            function addItem() {
                var options = {
                    keepOpenOnSelect: true,
                    enviromentCriteria: $scope.enviromentCriteria,
                    allowShowHierarchicalMode: StringUtils.toBoolean($scope.allowShowHierarchicalMode),
                    fieldName: $scope.fieldName,
                    handleOnlyAnalytics: StringUtils.toBoolean($scope.handleOnlyAnalytics),
                    pkFieldName: $scope.pkApresentation,
                    resourceIdCadastro: $scope.resourceIdCadastro,
                };

                SkPesquisaService.openPesquisaPopUp($scope.entityName, '', options).then(undefined, undefined, function (item) {
                    var temp = { data: item.key, value: item.key + " - " + item.label, checked: $scope.onlyOneSelection ? false : true, selected: true, rowData: item.data, label: item.label };
                    
                    if($scope.pkFields){
                        var pks = $scope.pkFields.replace(/\s/g, '').split(",");

                        var data = {};

                        for(var index in pks){
                            data[pks[index]] = item.data[pks[index]];
                        }

                        temp["pkFields"] = data;
                    }

                    doAddItem(temp);
                });
            }

            function doAddItem(temp, ignoreSave){
                var itemFound = false;

                if ($scope.dataProvider) {
                    for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                        if ($scope.dataProvider[i].data === temp.data) {
                            itemFound = true;
                            break;
                        }
                    }
                }

                if (!itemFound) {
                    if (!$scope.dataProvider) {
                        $scope.dataProvider = [];
                    }

                    $scope.dataProvider.push(temp);
                    sortDataProvider();
                    notifyChange(temp, temp.checked);

                    if (angular.isDefined($scope.snackbarMessageOk)) {
                        const duration = angular.isDefined($scope.snackbarDuration) ? $scope.snackbarDuration : 5;
                        SnackbarService.open({ 
                            message: $scope.snackbarMessageOk,
                            customClass: 'entitylist-snackbar-ok',
                            iconName: 'ok',
                            duration: duration
                        });
                    }

                    try{
                        if(!_bodyEl){
                            _bodyEl = $element[0].querySelector('.checkbox-list-body-container');
                        }
                        DomUtil.scrollTo(_bodyEl, (_bodyEl.scrollHeight + 30));
                    }catch(e){
                        /*silent*/
                    }
                } else {
                    if (angular.isDefined($scope.snackbarMessageError)) {
                        const duration = angular.isDefined($scope.snackbarDuration) ? $scope.snackbarDuration : 5;
                        SnackbarService.open({ 
                            message: $scope.snackbarMessageError,
                            customClass: 'entitylist-snackbar-error',
                            iconName: 'alert',
                            duration: duration
                        });
                    }
                }

                if(!ignoreSave) saveState();
            }

            function removeSelectedItems() {
                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, $translate.instant('EntityList.msgConfirmacaoRemover'))
                    .then(function () {
                        if ($scope.dataProvider) {
                            for (var i = 0, dpLength = $scope.dataProvider.length; i < dpLength;) {
                                var item = $scope.dataProvider[i];

                                if (item && item.selected) {
                                    ArrayUtils.removeReference($scope.dataProvider, item);
                                    ArrayUtils.removeReference($scope.value, item.data);
                                } else {
                                    i++;
                                }
                            }
                        }

                        notifyChange();
                        saveState();
                    }, function () {

                    });
            }

            function clearAll(msg) {
                if (angular.isUndefined(msg)) {
                    msg = 'EntityList.msgConfirmacaoLimpar';
                }

                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, $translate.instant(msg))
                    .then(function () {
                        if ($scope.dataProvider) {
                            $scope.dataProvider.length = 0;
                        }

                        if ($scope.value) {
                            $scope.value.length = 0;
                        }

                        notifyChange();
                        saveState();
                    }, function () {

                    });
            }

            function saveState(){
                var defer = $q.defer();

                if(!$scope.resourceId || $scope.standAloneMode == true){
                    defer.reject();
                    return;
                }
                    
                ServiceProxy.callService(
                    "mge@SystemUtilsSP.saveConf",
                     getListSource(false)
                ).then(function(response){
                    defer.resolve();
                });

                defer.promise;
            }

            function getListSource(includeDescription){
                var configToSave = {                    
                    config: {
                        chave: getResourceId(),
                        tipo: 'T',
                    }
                };

                let itemHasArray = (($scope.dataProvider || []).length > 1);

                if(itemHasArray){
                    configToSave.config.item = [];
                }else{
                    configToSave.config.item = {};
                }

                ($scope.dataProvider || []).forEach(record => {
                    var itemToSave = {
                        item:{
                            data: record.data,
                            selected: record.checked
                        }
                    };

                    if($scope.pkFields){
                        var pks = $scope.pkFields.replace(/\s/g, '').split(",");
                        
                        var otherPks;                     

                        var hasOtherPk = false;                        
                        
                        if(record.rowData){
                            
                            itemToSave.item.row =  {};

                            for (const key in record.rowData) {
                                itemToSave.item.row[key] = { $ : ( record.rowData[key].$ || record.rowData[key] ) }
                            }
                        }

                        let hasArray = $scope.pkFields.length > 1;

                        if(hasArray){
                            otherPks = [];
                        }else{
                            otherPks = {};
                        }

                        itemToSave.item.pkFields = {};

                        if(record.pkFields){

                            pks.forEach( (pk) => {
                                let value = record.pkFields[pk];
                                let pkElemt = {name: pk, $: value};
                                
                                if(hasArray){
                                    otherPks.push(pkElemt);
                                }else{
                                    otherPks = pkElemt;
                                }
                                
                                hasOtherPk = true;
                            });

                            if(hasOtherPk){
                                itemToSave.item.pkFields.pk = otherPks;
                            }
                        }
                    }

                    if(includeDescription){
                        itemToSave.item.label = record.value;
                    }

                    if(itemHasArray){
                        configToSave.config.item.push(itemToSave.item);
                    }else{
                        configToSave.config.item = itemToSave.item;
                    }
                });

                return configToSave;
            }

            function getResourceId(){
                return $scope.resourceId + ".list." + $scope.entityName;
            }

            function loadState(){
                /*_lista.removeAll();
                _listaChaves = new Object();
                _dataChanged = false;
                _listBox.validateProperties();*/

                if(!$scope.resourceId || $scope.standAloneMode == true){
                    return;
                }
                
                var params = { config: {
                        chave: getResourceId(),
                        entityName: $scope.entityName
                    }
                };

                /*
                    No flex isso estรก sendo feito, porem, nao eh utilizado, manteremos o mesmo no html5
                    insertEnvironmentCriteria(params);
                */
    
                ServiceProxy.callService(
                    "mge@SystemUtilsSP.getConfigFromEntityList", params).then(function(response){
                        let config = response.responseBody.config;
                        setConfig(config);
                    });
            }


            function setConfig(config){
                $scope.dataProvider.length = 0;                

                if(config && config.item){

                    if(!angular.isArray(config.item)){
                        config.item = [config.item];
                    }

                    config.item.forEach((conf) => {
                        let data = conf.data;

                        if(!isNaN(data)){
                            data = Number(data);
                        }

                        let record = {
                            data: data,
                            value: conf.data + ' - ' + conf.label,
                            checked: conf.selected == 'true',  
                            label: conf.label                          
                        };

                        if(conf.row){
                            record.rowData = conf.row;
                        }

                        if(conf.pkFields && conf.pkFields.pk){
                            let pks = conf.pkFields.pk;

                            record.pkFields = {};

                            (angular.isArray(pks) ? pks : [pks]).forEach((pk) => {
                                record.pkFields[pk.name] = pk.$;
                            });
                        }

                        doAddItem(record, true);
                    });
                }
            }

            function insertEnvironmentCriteria(params){
                if(angular.isFunction($scope.enviromentCriteria)){
                    
                    var criteria = $scope.enviromentCriteria();

                    if(criteria){

                        params.criterioLiteral = {
                            expressao: {
                                $: criteria.getExpression()
                            }
                        }

                        let paramsCriteria = (criteria.getParameters() || []);

                        let hasArray = paramsCriteria.length > 0;
                        
                        params.criterioLiteral.parametro = hasArray ? [] : {};

                        paramsCriteria.forEach((p) => {
                            let paramToAdd = {tipo: p.type, $: p.value};
                            if(hasArray){
                                params.criterioLiteral.parametro.push(paramToAdd);
                            }else{
                                params.criterioLiteral.parametro = paramToAdd;
                            }
                        });
                    }
                }
            }

            function saveStateOnCheck(){
                $timeout(saveState);
            }

            function onCheckboxClick(item){
                notifyChange(item, !item.checked);
            }

            function getCheckedItems() {
                var checkedItems = [];

                if ($scope.disableActions) {
                    return checkedItems;
                }

                if (!$scope.dataProvider) {
                    return checkedItems;
                }

                for (var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                    var item = $scope.dataProvider[i];
                    if (item.checked) {
                        checkedItems.push(item);
                    }
                }

                return checkedItems;
            }

        }]);

/**
 * @ngdoc directive
 * @name snk.components.entitylist.directive:sk-entity-list
 * @restrict E
 * @scope
 * @description
 Componente para apresentação de uma lista do tipo "Checklist" baseado em uma entidade.
 *
 * @param {sk-component-created} [sk-component-created=undefined]
 Função que será chamada quando a construção do componente entityList for finalizada. 
 Esta deve ser utilizada para guardar o ponteiro do entityList e realizar as configurações necessárias no mesmo.
 * 
 * @param {sk-entity-name} [sk-entity-name=undefined]
 Nome da entidade na qual o componente será baseado.
 *
 * @param {sk-value} [sk-value=undefined]
 Lista na qual armazenados os campos 'data' dos objetos selecionados.
 *
 * @param {sk-show-label} [sk-show-label=false]
 Define se o label deverá ser apresentado no componente.
 *
 * @param {sk-label} [sk-label=undefined]
 Label a ser apresentado no cabeçalho do componente.
 *
 * @param {sk-show-checkbox} [sk-show-checkbox=true]
 Define se deverá ser apresentado um checkbox para cada valor da lista.
 *
 * @param {sk-stand-alone-mode} [sk-stand-alone-mode=false]
 Define se o componente vai ser utilizado em modo <i>standalone</i><br>
 Caso este parâmetro esteja ligado, o componente não assume a responsabilidade de carregar
 e gravar as configurações.
 *
 * @param {sk-on-change} [sk-on-change=false]
 Função a ser chamada quando qualquer item da lista for marcado ou desmarcado.
 *
 * @param {sk-records} [sk-records=undefined]
 Lista de registros que farão parte dos itens.<br>
 Atenção: Essa lista só será utilizada caso o atributo <i>sk-stand-alone-mode</i> estiver ligado.<br>
 Ex: Estrutura do objeto:<i> records.push({data: 1, value: '1 - Nome', checked: true}); </i>
 * @param {sk-only-one-selection} [sk-only-one-selection=undefined]
 Parâmetro utilizado para que a sk-entity-list permita a seleção apenas de um registro.
 * @param {sk-selected-items} [sk-selected-items=undefined]
 Array com a chave dos registros a serem marcados no momento de que o sk-entity-list for carregado.
 Atenção: Esse só irá funcionar caso o parâmetro sk-only-one-selection estiver ligado.
 * 
 * @param {String} [sk-resource-id-cadastro=undefined] resource id da tela de cadastro da entidade, utilizado para apresentar a opção "Ir para cadastro"
 no popup de pesquisa.
 * 
 * @param {sk-snackbar-message-ok} [sk-snackbar-message-ok=undefined]
 Define a mensagem que irá aparecer no snackbar de notificação de item adicionado com sucesso.
 * @param {sk-snackbar-message-error} [sk-snackbar-message-error=undefined]
 Define a mensagem que irá aparecer no snackbar de notificação de item já adicionado.
 * @param {sk-snackbar-duration} [sk-snackbar-duration=5]
 Define o tempo de duração em segundos para o snackbar de notificação fechar (o valor padrão é 5 segundos).
 *
 * @param {sk-disable-actions} [sk-disable-actions=false]
 Define se as ações (botão adicionar, remover, limpar e checkboxes da lista) serão desabilitados.
 *
 */

angular
    .module('snk.components.entitylist')
    .directive('skEntityList',[function() {
        var directive = {};

        directive.restrict = 'E';
        directive.templateUrl = 'components/entitylist/entitylist.tpl.html';
        directive.controller = 'SkEntityListController';
        directive.scope = {
            componentCreated: '&?skComponentCreated',
            entityName: "@skEntityName",
            fieldName: "@?skFieldName",
            value: "=skValue",
            showLabel: "=?skShowLabel",
            label: "@?skLabel",
            showCheckBox: "=?skShowCheckBox",
            standAloneMode: "=?skStandAloneMode",
            allowShowHierarchicalMode: "=?skAllowShowHierarchicalMode",
            handleOnlyAnalytics: "=?skHandleOnlyAnalytics",
            onChange: "&?skOnChange",
            records: "=?skRecords",
            onlyOneSelection: "=?skOnlyOneSelection",
            selectedItems: "=?skSelectedItems",
            enviromentCriteria: '&?skEnviromentCriteria',
            pkFields: '@?skPkFields',
            pkApresentation: '@?skPkApresentation',
            resourceId: '@?skResourceId',
            resourceIdCadastro: '@?skResourceIdCadastro',
            descriptionField: '@?skDescriptionField',
            snackbarMessageOk: '=?skSnackbarMessageOk',
            snackbarMessageError: '=?skSnackbarMessageError',
            snackbarDuration: "=?skSnackbarDuration",
            disableActions: '=?skDisableActions'
        };

        return directive;
    }]);

angular
    .module('snk.components.entitystartpage')
    .controller('SkEntityStartPageController', ['$scope', '$log', '$q', '$timeout', '$element', 'AngularUtil', 'SkComponentRegistry', 'SkApplication', 'StringUtils', 'Criteria', 'MGEParameters',
        function ($scope, $log, $q, $timeout, $element, AngularUtil, SkComponentRegistry, SkApplication, StringUtils, Criteria, MGEParameters) {
            var self = this;

            var _criteria;
            let _needsToRefreshDataSource = false;

            $scope.dataSource;
            $scope.onSelectData = onSelectData;
            $scope.onOpenHelp = onOpenHelp;
            $scope.personalizedFilterApply = personalizedFilterApply;
            $scope.gotoMode = gotoMode;
            $scope.viewMode = 'menu';
            $scope.personalizedFilterId = 'filter-entity-start-page';
            $scope.saveDynamicFilterCriteria = saveDynamicFilterCriteria;
            $scope.hasStartTour = angular.isFunction($scope.startTourFn);
            $scope.startTour = startTour;
            $scope.isView = isView;
            $scope.getCurrentQuery = getCurrentQuery;
            $scope.showAllAction = showAllAction;
            $scope._paramCarregInitTela=MGEParameters.asBoolean("global.carregar.registros.iniciar.tela");
            $scope.onSelectShowFilter = onSelectShowFilter;

            self.loadFilters = loadFilters;
            self.setDefaultFilter = setDefaultFilter;
            self.setFocus = setFocus;

            init();

            function init() {
                if (!StringUtils.isEmpty($scope.id)) {
                    SkComponentRegistry.register(self, $scope.id);
                }

                AngularUtil.timeout(function(){
                    var criteriaProvider = new CriteriaProvider();
                    criteriaProvider.getCriteria = function() {
                        return _criteria;
                    };

                    $scope.dataSource = angular.element($scope.pesquisaContent).data('$skPesquisaContentController');
                    $scope.dataSource.addCriteriaProvider(criteriaProvider);

                    AngularUtil.timeout($scope.dataSource.setFocus);
                }, 200);

                loadFilters();
            }

            function setFocus() {
                if ($scope.dataSource) {
                    $scope.dataSource.setFocus();
                }
            }

            function onSelectShowFilter() {
                SkComponentRegistry.get($scope.personalizedFilterId).then(function(instance){
                   instance.openFilter();
                });
            }

            function setDefaultFilter(defaultFilter) {
                _criteria = defaultFilter;
                _needsToRefreshDataSource = true; 
            }

            function startTour() {
                if(angular.isFunction($scope.startTourFn)) {
                    $scope.startTourFn();
                }
            }

            function getCurrentQuery() {
               return $scope.dataSource.getCurrentQuery();
            }

            function saveDynamicFilterCriteria(resourceId, criteriaToSave) {
            }

            function gotoMode(mode){
                $scope.viewMode = mode;
            }

            function onOpenHelp(){
                workspace.openHelp();
            }

            function onSelectData(entity, data, currentQuery){
                if (angular.isDefined($scope.onSelectEntity)){
                    $scope.onSelectEntity(entity, data, currentQuery);
                }
            }

            function showAllAction(currentQuery) {
                if (angular.isFunction($scope.onShowAllAction)) {
                    $scope.onShowAllAction(currentQuery);
                } else if (angular.isFunction($scope.onSelectShowGrid)) {
                    $scope.onSelectShowGrid(currentQuery);
                }
            }

            function personalizedFilterApply(){
                SkComponentRegistry.get($scope.personalizedFilterId).then(function(instance){
                    $scope.onApplyFilter();

                    /*instance.getCriteria().then(function(criteria){
                    	if (angular.isDefined(_criteria)) {
                    		criteria.and(_criteria);
                    	}

                        $scope.onApplyFilter(criteria);
                    });*/
                });
            }

            function loadFilters() {
                SkComponentRegistry.get($scope.personalizedFilterId).then(function(instance){
                    instance.loadFilters();
                });

                if(_needsToRefreshDataSource){
                    $scope.dataSource?.refresh();
                    _needsToRefreshDataSource= false;
                }
            }

            function isView() {
                return SkApplication.instance().getConfiguracaoTela($scope.resourceId + ".isView");
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.navigator.directive:sk-entity-start-page
 * @restrict E
 * @scope
 * @description
 Preencher
 *
 * @example
     <example module="app">
     <file name="index.html">
        <sk-entity-start-page></sk-entity-start-page>
     </file>
     </example>
 */
angular
    .module('snk.components.entitystartpage')
    .directive('skEntityStartPage', function () {
        return {
            scope: {
                entityName: '@skEntityName',
                resourceId: '@skResourceId',
                onSelectEntity: '=skOnSelectEntity',
                onSelectNewEntity: '=skOnSelectNewEntity',
                onSelectShowGrid: '=skOnSelectShowGrid',
                onSelectHierarchy: '=skOnSelectHierarchy',
                onShowAllAction: '=?skOnShowAllAction',
                isHierarchy: '=skHierarchy',
                onApplyFilter: '=skOnApplyFilter',
                startTourFn: '=skStartTourFn',
                showNewEntityLink: '&skShowNewEntityLink',
                criteriaProvider: '=?skCriteriaProvider',
                id: '@?id',
                resolvePkEntity: '=?skResolvePkEntity'
            },
            compile: function($element){
                $element.attr('layout', 'column');
            },
            controller: 'SkEntityStartPageController',
            templateUrl: 'components/entitystartpage/entitystartpage.tpl.html'
        };
    });
/**
 * Created by cleverson.puche on 23/11/2016.
 */

/**
 * @ngdoc directive
 * @name snk.components.filterpanel.directive:sk-filter-panel
 * @restrict E
 * @description
 * O componente 'sk-filter-panel' deve ser utilizado sempre que for necessário exibir um painel de filtros.<br/>
 * Este componente carrega automaticamente os filtros configurados no dicionário de dados, bem como permite que o programador configure seus próprios filtros,
 * para isso basta inserir os filtros como filhos deste componente.
 *
 * <h2>Personalização de filtros</h2>
 * Os filhos diretos que forem colocados serão considerados como fitros do accordion padrão. Caso haja filtros de dicionários, esses adicionais
 * são colocados abaixo dos filtros de dicionario de dados.
 *
 * Caso deseje modificar o accordion padrão, use a tag 'default-group' e coloque os filtros dentro.
 * As personalizações aceitas para esta tag são 'label' para modificar o título e 'remove-header' para que o header não seja apresentado.
 * Nenhum atributo é obrigatório.
 * <p>
 *     <b class="text-danger">ATENÇÃO: </b>Não se deve usar a tag 'remove-header' caso haja outros painéis de accordion.
 * </p>
 * Exemplo:
 * <pre>
 *     <default-group label="Modulo.tela.chaveI18n" remove-header>
 *         Meu conteúdo
 *     </default-group>
 * </pre>
 *
 * Caso deseje adicionar accordions customizados, utilize a tag 'custom-group', nesta tag o 'label' é obrigatório.
 * A personalização aceita para esta tag é 'no-padding' para remover o padding padrão do container.
 * Exemplo:
 * <pre>
 *     <custom-group label="Modulo.tela.chaveI18n" no-padding>
 *         Meu conteúdo
 *     </custom-group>
 * </pre>
 *
 * Este componente deve ser usado em conjunto com o {@link snk.components.filterpanel.directive:sk-filter-panel-btn sk-filter-panel-btn}
 * <p>
 *     <b class="text-danger">ATENÇÃO: </b>
 *     Devido a coloração deste botão ser baseada nos filtros aplicados
 *     temos sempre que implementar o 'sk-custom-criteria-loader' que retorna
 *     o criterio dos filtros adicionais, do contrário a coloração não funcionará devidamente.
 * </p>
 *
 * <h2>Exemplo de uso</h2>
 * Bons exemplos de uso deste componente pode ser encontrado nas telas MovimentacaoBancaria, NotasCanceladas e ConciliacaoBancaria
 *
 * @param {SkDataset} sk-data-source Origem dos dados. Deve ser uma implementação da interface DataSource, por exemplo, um dataset.
 * @param {String} sk-resource-id ResourceID utilizado para salvar os últimos valores dos filtros.
 * @param {String} sk-entity-name Nome da entidade na qual o filtro se baseia (não precisa ser informado, caso seja a mesma entidade do sk-data-source).
 * @param {boolean} sk-is-open Define se o painel deve carregar aberto ou não.
 * @param {boolean} sk-has-active-filter Variável onde será feito o bind para informar se existe algum filtro personalizado ativo no momento. Pode ser utilizada, por exemplo, para alterar a cor de um botão.
 * @param {boolean} sk-dynamic-filter Variável onde será feito o bind para informar se existe algum filtro dinâmico (vindo do dicionário de dados) ativo no momento. Pode ser utilizada, por exemplo, para alterar a cor de um botão.
 * @param {boolean} sk-disable-personalized-filter Permite desabilitar o filtro personalizado no painel de filtros.
 * @param {IFilterPanelInterceptor} sk-filter-panel-interceptor Interceptor para o painel de filtros. Deve ser uma implementação de IFilterPanelInterceptor.
 * @param {String} sk-panel-width Permite definir o tamanho do painel de filtros.
 * @param {boolean} sk-hide-btn-apply Permite ocultar o botão de aplicar.
 * @param {function} [sk-apply-function=refresh()] sk-apply-function Função chamada no momento em que o usuário aplicar o filtro. Caso essa
 * função não seja informada, o filtro assume como padrão a função {@link util.common.interface:DataSource refresh()} da interface DataSource.
 * @param {String} [sk-btn-apply-label="Aplicar"] sk-btn-apply-label Permite alterar o label do botão Aplicar.
 * @param {function} [sk-field-filter-function=undefined] Função que pode ser passada ao componente para filtrar os campos que serão apresentados no popup de seleção de campos.
 * @param {function} [sk-link-filter-function=undefined] Função que pode ser passada ao componente para filtrar as ligações que serão apresentados no popup de seleção de campos.
 * @param {boolean} [sk-pf-expanded=true] Flag que determina se o filtro personalizado será apesentado na forma expandida ou não.
 * @param {function} [sk-custom-criteria-loader=undefined] Função que deve ser implementada para retornar o {@link util.common.object:Criteria criterio} dos filtros adicionais que foram passados ao componente.
 * @param {function} sk-show-label-others-filters Parâmetro que determina se a label de Outros será apresentada no sk-custom-filter-panel
 * @param {string} [sk-tooltip-apply=undefined] Nesse parametro deve ser informado o tooltip do botão aplicar.
 * @param {boolean} sk-hide-apply Permite ocultar o botão de aplicar dentro da tela de criação de filtro. 
*/

angular
    .module('snk.components.filterpanel')
    .component('skFilterPanel', {
        templateUrl: 'components/filterpanel/filterpanel.tpl.html',
        controller: 'SkFilterPanelController',
        transclude: true,
        bindings: {
            dataSource: '<skDataSource',
            resourceId: "@skResourceId",
            entityName: '@?skEntityName',
            instanciaName:'@?skInstanciaName',
            isOpen: '=?skIsOpen',
            hasActiveFilter: '=?skHasActiveFilter',
            hasSomeActiveFilter: '=?skHasSomeActiveFilter',
            disablePersonalizedFilter: '=?skDisablePersonalizedFilter',
            filterPanelInterceptor: '=?skFilterPanelInterceptor',
            hasDynamicFilter: '=?skHasDynamicFilter',
            width: '@?skPanelWidth',
            hideBtnApply: '=?skHideBtnApply',
            applyFunction: '&?skApplyFunction',
            btnApplyLabel: '@?skBtnApplyLabel',
            fieldFilterFunction: '=skFieldFilterFunction',
            linkFilterFunction: '=skLinkFilterFunction',
            onFilterCreated: '&?skOnFilterCreated',
            onDynamicFilterCreated: '&?skOnDynamicFilterCreated',
            isFixedMode: '=?skIsFixedMode',
            personalizedFilterExpanded: '=?skPfExpanded',
            customCriteriaLoader: '&?skCustomCriteriaLoader',
            pfStandalone: '=?skPfStandalone',
            groupOthers: '=?skGroupOthers',
            hideFilter: '=?skHideFilter',
            showBtnApplyDynamicFilter:'=?skShowBtnApplyDynamicFilter',
            showLabelOthersFilters: '@?skShowLabelOthersFilters',
            tooltipApply: '@?skTooltipApply',
            onToggle: '&skOnToggle',
            hideApply: '=?skHideApply'
        }
    })
    .controller('SkFilterPanelController', ['$scope', '$attrs', '$element', 'SkI18nService', 'ObjectUtils', 'SkConstants', 'DomUtil', 'AngularUtil', 'FilterPanelService', '$q', 'UserAgentUtils',
        function ($scope, $attrs, $element, SkI18nService, ObjectUtils, SkConstants, DomUtil, AngularUtil, FilterPanelService, $q, UserAgentUtils) {
            var self = this;

            ObjectUtils.extend(self, EventBus);

            var _dynamicFilterPanel;
            var _personalizedFilter;
            var _pendingCustomFiltersElement;

            self.hasActivePersFilter = false;
            self.hasActiveDynFilter = false;

            self.hasCustomFilter = false;

            self.$postLink = $postLink;

            self.apply = apply;
            self.saveCriteriaProxy = saveCriteriaProxy;
            self.onKeyDown = onKeyDown;

            self.onPersonalizedFilterCreated = onPersonalizedFilterCreated;
            self.$onDynamicFilterCreated = $onDynamicFilterCreated;
            self.$customCriteriaLoader = $customCriteriaLoader;

            self.clearFilter = clearFilter;

            self.getPersonalizedFilter = getPersonalizedFilter;
            self.whenPersonalizedFilterLoad = whenPersonalizedFilterLoad;
            self.setCustomFiltersElement = setCustomFiltersElement;
            self.toggle = toggle;
            self.open = open;
            self.close = close;
            self.addHasFilterListener = addHasFilterListener;
            self.panelIsOpen  = panelIsOpen;

            $scope.personalizedFilterWasLoaded = false;

            self.tooltipApply = $scope.tooddltipApply ? $scope.tooltipApply : 'Geral.buttonAplicarTooltip';

            var _publicAPI = ObjectUtils.buildPublicAPI(self, [
                'setCustomFiltersElement', 'toggle', 'open', 'close', 'whenPersonalizedFilterLoad', 'getPersonalizedFilter',
                'addHasFilterListener', 'panelIsOpen'
            ]);

            init();

            function init() {
                if (angular.isDefined(self.filterPanelInterceptor)) {
                    ObjectUtils.isImplementorOf(self.filterPanelInterceptor, IFilterPanelInterceptor);
                }

                if (angular.isUndefined(self.personalizedFilterExpanded)) {
                    self.personalizedFilterExpanded = true;
                }

                $element.attr('sk-disable-attr-width', '');

                self.finalBtnApplyLabel = SkI18nService.instant(self.btnApplyLabel || 'Geral.lblAplicar');

                if (angular.isUndefined($attrs.$attr.layout)) {
                    $element.attr('layout', '');
                }

                $scope.$watchGroup(['$ctrl.hasActivePersFilter', '$ctrl.hasActiveDynFilter', '$ctrl.hasSomeActiveFilter'], function(newValues, oldValues) {
                    if (newValues == oldValues) {
                        return;
                    }

                    self.dispatchEvent('hasFilter', newValues[2]);
                });

                FilterPanelService(self.instanciaName).register(_publicAPI);

                if($attrs.skWidth && !$scope.width){
                    self.width = $attrs.skWidth;
                }
            }

            function $onDynamicFilterCreated($component) {
                _dynamicFilterPanel = $component;

                if (self.onDynamicFilterCreated) {
                    self.onDynamicFilterCreated({$component: $component});
                }

                if (_pendingCustomFiltersElement) {
                    setCustomFiltersElement(_pendingCustomFiltersElement);
                    _pendingCustomFiltersElement = undefined;
                }
            }

            function $customCriteriaLoader() {
                if (self.customCriteriaLoader) {
                    return self.customCriteriaLoader();
                }

                return undefined;
            }

            function setCustomFiltersElement(element) {
                if (_dynamicFilterPanel) {

                    _dynamicFilterPanel
                        .onFilterLoaded()
                        .then(function () {
                            _dynamicFilterPanel.setCustomFiltersElement(element);
                        });

                    self.hasCustomFilter = true;
                } else {
                    _pendingCustomFiltersElement = element;
                }
            }

            function onPersonalizedFilterCreated($filter) {
                _personalizedFilter = $filter;
                $scope.personalizedFilterWasLoaded = true;
            }

            function whenPersonalizedFilterLoad() {
                return $q(function (resolve, reject) {
                    if (_personalizedFilter) {
                        resolve();
                    } else {
                        let destroyHandler = $scope.$watch('personalizedFilterWasLoaded', function(newValue){
                            if(newValue){
                                destroyHandler();
                                resolve();
                            }
                        })
                    }
                });
            }

            function clearFilter() {
                if (_dynamicFilterPanel) {
                    _dynamicFilterPanel.clearFilter();
                }
            }

            function apply() {
                if (self.dataSource && !self.applyFunction) {
                    self.dataSource.refresh().then(() => {
                        closeOnApply();
                    });
                } else {
                    $q.when((self.applyFunction || angular.noop)()).then((applyResult) => {
                        if(applyResult){
                            closeOnApply();
                        }
                    });
                }
            }

            function closeOnApply(){
                if(UserAgentUtils.isMobile()){
                    close();
                }
            }

            function saveCriteriaProxy(resourceId, criteria, criteriaToSave) {
                self.dataSource.saveCriteria(resourceId, criteria, criteriaToSave);
            }

            function onKeyDown($event) {
                var keyCode = $event.which || $event.keyCode;

                if ($event.ctrlKey && keyCode === SkConstants.KEY_CODE.ENTER) {
                    apply();
                }
            }

            function getPersonalizedFilter() {
                if (_personalizedFilter) {
                    return _personalizedFilter;
                } else if (self.disablePersonalizedFilter) {
                    throw Error('[sk-filter-panel] Não existe filtro personalizado pois o "disablePersonalizedFilter" foi ligado.');
                } else {
                    throw Error('[sk-filter-panel] Instância de filtro personalizado ainda não carregada.');
                }
            }

            function toggle() {
                self.isOpen = !!!self.isOpen;
                self.onToggle({isOpen: self.isOpen});
                return self.isOpen;
            }

            function open() {
                self.isOpen = true;
            }

            function close() {
                self.isOpen = false;
            }

            function addHasFilterListener(listener) {
                self.addEventListener('hasFilter', listener);
            }

            function $postLink() {
                if (self.onFilterCreated) {
                    self.onFilterCreated({$filter: _publicAPI});
                }

                AngularUtil.timeout(function () {
                    var transcludeElem = angular.element(DomUtil.select($element, '[ng-transclude].filter-panel-transclude'));

                    if (transcludeElem.length > 0 && transcludeElem.children().length > 0) {
                        var filtersContainer = angular.element('<sk-custom-filter-panel></sk-custom-filter-panel>');
                        var filterHeader = undefined;

                        transcludeElem.children().each(function (index, child) {
                            if (child.tagName == 'FILTER-HEADER') {
                                if (filterHeader) {
                                    throw Error('[sk-filter-panel] Não é possível informar dois \'filter-header\'.');
                                } else {
                                    filterHeader = child;
                                }
                            } else {
                                filtersContainer.append(angular.element(child));
                            }
                        });

                        if (filterHeader) {
                            var filterHeaderPanel = angular.element(DomUtil.select($element, '.filter-header-panel'));
                            
                            filterHeaderPanel.removeClass('hide');
                            filterHeaderPanel.append(filterHeader);
                        }

                        setCustomFiltersElement(filtersContainer);
                    }
                });
            }

            function panelIsOpen(){
                return angular.copy(self.isOpen);
            }
        }
    ]);

/**
 * @ngdoc service
 * @name snk.components.filterpanel.service:FilterPanelService
 *
 * @description
 * Serviço de controle do SkFilterPanel.
 * Geralmente é usado apenas internamente pelo Framework.
 *
 */

angular
    .module("snk.components.filterpanel")
    .provider('FilterPanelService', [function () {

        var _filtersByName = {};

        this.$get = ['$q', 'AngularUtil', function ($q, AngularUtil) {

            function FilterPanelService(name) {
                this.name = name;
            }

            /**
             * @ngdoc
             * @name snk.components.filterpanel.service:FilterPanelService#register
             * @methodOf snk.components.filterpanel.service:FilterPanelService
             * @description
             *  Registra o componente de filtro.
             * @return {String} name Nome do filtro.
             * @return {String} instance Instancia do SkFilterPanel.
             */
            FilterPanelService.prototype.register = function (instance) {
                var defer = _filtersByName[this.name];

                if (defer) {
                    if (AngularUtil.isDeffered(defer)) {
                        defer.resolve(instance);
                    } else {
                        throw Error('Instancia de FilterPanel ' + this.name + ' já foi definida.');
                    }
                }

                _filtersByName[this.name] = instance;
            };

            /**
             * @ngdoc
             * @name snk.components.filterpanel.service:FilterPanelService#toggle
             * @methodOf snk.components.filterpanel.service:FilterPanelService
             * @description
             *  Função utilizada para abrir/fechar o componente.
             * @return {Promise} Retorna o novo estado do componente.
             */
            FilterPanelService.prototype.toggle = function () {
                try {
                    return $q(function (resolve, reject) {
                        getInstancePromise(this.name)
                            .then(function (instance) {
                                resolve(instance.toggle());
                            }, reject);
                    }.bind(this));
                } catch (error) {
                    throw Error('A Instancia do filterPanel ou filterPanelBtn não foi definida corretamente.');
                }
            };

            /**
             * @ngdoc
             * @name snk.components.filterpanel.service:FilterPanelService#open
             * @methodOf snk.components.filterpanel.service:FilterPanelService
             * @description
             *  Função utilizada para abrir o componente.
             */
            FilterPanelService.prototype.open = function() {
                return $q(function(resolve, reject) {
                    getInstancePromise(this.name)
                        .then(function(instance) {
                            instance.open();
                            resolve();
                        }, reject);
                }.bind(this));
            };

            /**
             * @ngdoc
             * @name snk.components.filterpanel.service:FilterPanelService#close
             * @methodOf snk.components.filterpanel.service:FilterPanelService
             * @description
             *  Função utilizada para abrir o componente.
             */
            FilterPanelService.prototype.close = function() {
                return $q(function(resolve, reject) {
                    getInstancePromise(this.name)
                        .then(function(instance) {
                            instance.close();
                            resolve();
                        }, reject);
                }.bind(this));
            };

            /**
             * @ngdoc
             * @name snk.components.filterpanel.service:FilterPanelService#addHasFilterListener
             * @methodOf snk.components.filterpanel.service:FilterPanelService
             * @description
             *  Adiciona um listener para ser notificado quando o estado de filtro mudar.
             * @param {function} listener Função de notificação.
             */
            FilterPanelService.prototype.addHasFilterListener = function(listener) {
                return $q(function(resolve, reject) {
                    getInstancePromise(this.name)
                        .then(function(instance) {
                            resolve(instance.addHasFilterListener(listener));
                        }, reject);
                }.bind(this));
            };



            function getInstancePromise(name) {
                var filter = _filtersByName[name];

                if (filter) {
                    if (AngularUtil.isDeffered(filter)) {
                        return filter;
                    } else {
                        return $q.when(filter);
                    }
                } else {
                    var defer = $q.defer();

                    _filtersByName[name] = defer;

                    return defer.promise;
                }
            }

            return function (name) {
                return new FilterPanelService(name);
            };
        }];
    }]);
/**
 * Created by bruno.brandao on 02/02/2017.
 */

/**
 * @ngdoc directive
 * @name snk.components.filterpanel.directive:sk-filter-panel-btn
 * @restrict E
 * @description
 * O componente 'sk-filter-panel-btn' deve ser utilizado com o {@link snk.components.filterpanel.directive:sk-filter-panel sk-filter-panel}.
 * É este botão que fica encarregado de abrir e fechar o painel de filtros.
 *
 * Por convencão sempre existe apenas um painel de filtro tela, e esse botão se liga diretamente com ele, caso encontre.
 * Podem haver quantos botões necessários.
 */
angular
    .module('snk.components.filterpanel')
    .component('skFilterPanelBtn', {
        templateUrl: 'components/filterpanel/filterpanelbtn/filterpanelbtn.tpl.html',
        controller: 'SkFilterPanelBtnController',
        bindings: {
            instanciaName:'@?skInstanciaName'
        }
    })
    .controller('SkFilterPanelBtnController', ['FilterPanelService','StringUtils', function(FilterPanelService,StringUtils) {
        var self = this;

        var _filterService;

        self.$onInit = $onInit;

        self.clickHandler = clickHandler;

        function $onInit() {
            self.instanciaName = StringUtils.isEmpty(self.instanciaName) ? undefined : self.instanciaName;

            _filterService = FilterPanelService(self.instanciaName);

            _filterService.addHasFilterListener(function(hasFilter) {
                self.hasFilter = hasFilter;
            });
        }

        function clickHandler() {
            _filterService.toggle();
        }
    }]);
/**
 * @ngdoc interface
 * @name snk.components.filterpanel.interfaces:IFilterPanelInterceptor
 * @description Interface utilizada para interceptar o componente sk-filter-panel.
 */
function IFilterPanelInterceptor() {}

/**
 * @ngdoc
 * @name snk.components.filterpanel.interfaces:IFilterPanelInterceptor#getCriteria
 * @methodOf snk.components.filterpanel.interfaces:IFilterPanelInterceptor
 * @description Função chamada para se obter um CriteriaProvider referente aos campos inseridos pelo programados no sk-filter-panel.
 * Deve retornar um CriteriaProvider.
 * @param {object} dataSource DataSource informado.
 */
IFilterPanelInterceptor.prototype.getCriteria = function (dataSource) {

};

/**
 * @ngdoc
 * @name snk.components.filterpanel.interfaces:IFilterPanelInterceptor#interceptBeforeSave
 * @methodOf snk.components.filterpanel.interfaces:IFilterPanelInterceptor
 * @description Função chamada antes de salvar os valores dos campos filtrados.<br/><br/>
 * Deve retornar um CriteriaProvider com o criterio a ser salvo.
 * @param {object} dataSource DataSource informado.
 */
IFilterPanelInterceptor.prototype.interceptBeforeSave = function (dataSource) {

};

/**
 * @ngdoc
 * @name snk.components.filterpanel.interfaces:IFilterPanelInterceptor#interceptAfterLoad
 * @methodOf snk.components.filterpanel.interfaces:IFilterPanelInterceptor
 * @description Função chamada após carregar os últimos valores utilizados no filtro.
 * @param {object} lastValues Últimos valores salvos no filtro.
 */
IFilterPanelInterceptor.prototype.interceptAfterLoad = function (lastValues) {

};

/**
 * @ngdoc
 * @name snk.components.filterpanel.interfaces:IFilterPanelInterceptor#clearFilter
 * @methodOf snk.components.filterpanel.interfaces:IFilterPanelInterceptor
 * @description Função que deve ser implementada para limpar os filtros quando chamada.
 */
IFilterPanelInterceptor.prototype.clearFilter = function () {
};
angular
    .module('snk.components.fixedbar')
    .constant("FixedBarConstants", {
        "EVENT_FIXED_BAR_RESET": "fixedbar.event.reset"
    });
angular
    .module('snk.components.fixedbar')
    .directive('skFixedBar', ['$timeout', '$parse', '$window', '$document', 'FixedBarConstants', 'FixedBarService', 'PositionUtils', 'DomUtil', 'AngularUtil',
        function ($timeout, $parse, $window, $document, FixedBarConstants, FixedBarService, PositionUtils, DomUtil, AngularUtil) {
            var fixBarMap = {};
            var lastFixBarCompactedMap = {};

            var masterContentElem = $document;

            return {
                restrict: 'E',
                templateUrl: 'components/fixedbar/fixedbar.tpl.html',
                link: postLink,
                transclude: true
            };

            function postLink(scope, element, attr, controller, transclude) {
                var _fixedBarId = attr.skFixedBar;
                var _topOffset = parseInt(attr.skTopOffset) || 0;
                var _beforeOpen = attr.skBeforeOpen ? $parse(attr.skBeforeOpen) : undefined;
                var _lastScroll;

                var _currentContextInfo;
                var _barContextInfo;

              var _api = {
                getElement: getElement
              };

                scope.barContext;
                scope.contextPath = [];
                scope.gotoToContext = gotoToContext;

                if (!_fixedBarId) {
                    throw new Exception('O valor de sk-fixed-bar é obrigatório.');
                }

                transclude(function (clone) {
                    var barHeader = element[0].querySelector('.bar-header');
                    var barFooter = element[0].querySelector('.bar-footer');

                    angular.forEach(clone, function (item) {

                        switch (item.nodeName.toLowerCase()) {
                            case 'bar-header':
                                barHeader.appendChild(item);
                                break;

                            case 'bar-footer':
                                barFooter.appendChild(item);
                                break;

                            default:
                        }
                    });
                });

                init();

                function init() {
                    registerEvents();
                }

                function getElement() {
                    return element;
                }

                function gotoToContext(context) {
                    var newScroll = Math.max(0, getElementTop(context.element) - getElementHeight(element) + _topOffset);

                    DomUtil.scrollTo(masterContentElem, newScroll);
                }

                function getNextContext(scroll) {
                    var contexts = FixedBarService.getContexts(_fixedBarId);

                    var startIndex = _currentContextInfo ? contexts.indexOf(_currentContextInfo) + 1 : 0;

                    var newContext;

                    for (var i = startIndex; i < contexts.length; i++) {
                        var context = contexts[i];

                        if (!contextIsActive(context)){
                            continue;
                        }

                        if (!_currentContextInfo && contextIsForcingCurrent(context)) {
                            newContext = context;
                            break;
                        } else {
                            var barOffset = 0;

                            if (i > 0) {
                                var barPos = PositionUtils.position(element);
                                barOffset = barPos.height;
                            }

                            if (scroll + barOffset > getElementTop(context.element) + _topOffset) {
                                newContext = context;
                            } else if (scroll + barOffset < getElementTop(context.element) + _topOffset) {
                                break;
                            }
                        }
                    }

                    return newContext;
                }

                function getPreviousContext(scroll) {
                    if (getCurrentScroll() > 0) {
                        var contexts = FixedBarService.getContexts(_fixedBarId);

                        var endIndex = _currentContextInfo ? contexts.indexOf(_currentContextInfo) : contexts.length;

                        var newContext;

                        for (var i = 0; i < endIndex; i++) {
                            var context = contexts[i];

                            if (!contextIsActive(context)){
                                continue;
                            }

                            var barOffset = 0;

                            if (i > 0) {
                                var barPos = PositionUtils.position(element);
                                barOffset = barPos.height;
                            }

                            if (scroll + barOffset > getElementTop(context.element) + _topOffset) {
                                newContext = context;
                            } else if (scroll + barOffset < getElementTop(context.element) + _topOffset) {
                                break;
                            }
                        }

                        return newContext;
                    }

                    return undefined;
                }

                function canChangeToNextContext(scroll) {
                    var contexts = FixedBarService.getContexts(_fixedBarId);

                    if (!contexts) {
                        return false;
                    }

                    var nextIndex = _currentContextInfo ? contexts.indexOf(_currentContextInfo) + 1 : 0;
                    var isCtxtActive = true;

                    do {
                        isCtxtActive = contextIsActive(contexts[nextIndex]);
                    } while(!isCtxtActive && nextIndex++ && nextIndex < contexts.length);

                    if (contexts[nextIndex]) {
                        var nextContext = contexts[nextIndex];

                        var barOffset = 0;

                        if (nextIndex > 0) {
                            var barPos = PositionUtils.position(element);
                            barOffset = barPos.height;
                        }

                        if (scroll + barOffset > getElementTop(nextContext.element) + _topOffset) {
                            return true;
                        }
                    }

                    return false;
                }

                function canChangeToPreviousContext(scroll) {
                    var contexts = FixedBarService.getContexts(_fixedBarId);

                    if (!contexts) {
                        return false;
                    }

                    var currentIndex = _currentContextInfo ? contexts.indexOf(_currentContextInfo) : -1;
                    var isCtxtActive = true;

                    do {
                        isCtxtActive = contextIsActive(contexts[currentIndex]);
                    } while(!isCtxtActive && currentIndex-- && currentIndex > -1);

                    if (_currentContextInfo) {
                        var barOffset = 0;

                        if (currentIndex > 0) {
                            var barPos = PositionUtils.position(element);
                            barOffset = barPos.height;
                        }

                        return scroll + barOffset < getElementTop(_currentContextInfo.element) + _topOffset;
                    }

                    return false;
                }

                function getCurrentScroll() {
                    return masterContentElem.scrollTop();
                }

                function registerEvents() {
                    masterContentElem.bind('scroll', function() {
                        recalcFixedBars();
                    });

                    $window.addEventListener('resize', recalcPositions);

                    scope.$on('$destroy', function () {
                        $window.removeEventListener('resize', recalcPositions);
                    });

                    scope.$root.$on(FixedBarConstants.EVENT_FIXED_BAR_RESET, function (e, id) {
                        if (id == _fixedBarId) {
                            _lastScroll = 0;
                            _currentContextInfo = undefined;
                            recalcFixedBars();
                            recalcPositions();
                        }
                    });
                }

                function recalcFixedBars() {
                    var scroll = getCurrentScroll();

                    var newContext;
                    var contextChanged = false;

                    if (scroll == 0) {
                        newContext = undefined;
                        contextChanged = true;
                    } else if (scroll > _lastScroll && canChangeToNextContext(scroll)) {
                        newContext = getNextContext(scroll);
                        contextChanged = true;
                    } else if (scroll < _lastScroll && canChangeToPreviousContext(scroll)) {
                        newContext = getPreviousContext(scroll);
                        contextChanged = true;
                    }

                    if (contextChanged && newContext != _currentContextInfo) {
                        AngularUtil.apply(scope, function () {
                            setNewCurrentContext(newContext, scroll > _lastScroll);
                        });
                    }

                    _lastScroll = scroll;
                }

                function recalcPositions() {
                    if (_currentContextInfo) {
                        var refElem = angular.element(masterContentElem[0].querySelector('.' + _currentContextInfo.positionRefSelector));

                        if (refElem && refElem[0]) {
                            var position = PositionUtils.offset(refElem);

                            if (element.css('left') != position.left) {
                                element.css('left', position.left);
                            }

                            if (element.css('width') != position.width) {
                                element.css('width', position.width == 0 ? '100%' : position.width);
                            }
                        }
                    }
                }

                function contextIsForcingCurrent(context) {
                    if (context) {
                        var forceFixedBarContextFn = context.barScope.forceContext;

                        if (forceFixedBarContextFn) {
                            return forceFixedBarContextFn();
                        }
                    }

                    return false;
                }

                function contextIsActive(context) {
                    if (context) {
                        var isActiveFn = context.barScope.isActive;

                        if (isActiveFn) {
                            return isActiveFn();
                        }
                    }

                    return true;
                }

                function setNewCurrentContext(newContext, down) {
                    var forceStayInContext = contextIsForcingCurrent(_barContextInfo);

                    if (!forceStayInContext) {
                        _currentContextInfo = newContext;
                        _barContextInfo = newContext;
                        scope.barContext = _barContextInfo ? _barContextInfo.barScope.context : undefined;
                    } else {
                        var canChange = (down || !newContext);

                        if (!canChange) {
                            var contexts = FixedBarService.getContexts(_fixedBarId);

                            canChange = contexts.indexOf(_barContextInfo) <= contexts.indexOf(newContext);
                        }

                        if (canChange) {
                            _currentContextInfo = newContext;
                        } else if (getCurrentScroll() == 0) {
                            _currentContextInfo = undefined;
                        }
                    }

                    toggleVisibility(_currentContextInfo);

                    if (_currentContextInfo) {
                        var contexts = FixedBarService.getContexts(_fixedBarId);

                        scope.contextPath.length = 0;

                        for (var i = 0; i <= contexts.indexOf(_currentContextInfo); i++) {
                            if (contextIsActive(contexts[i])) {
                                scope.contextPath.push(contexts[i]);
                            }
                        }

                        recalcPositions();
                    }
                }

                function toggleVisibility(newContext) {
                    var newDisplay = newContext ? 'block' : 'none';

                    if (newContext && _beforeOpen) {
                      _beforeOpen(scope, {
                          $fixedBar: _api
                      });
                    }

                    if (element.css('display') !== newDisplay) {
                        element.css('display', newDisplay);
                    }
                }

                function getElementTop(element) {
                    return PositionUtils.offset(element).top;
                }

                function getElementHeight(element) {
                    return element[0].getBoundingClientRect().height || element.prop('offsetHeight');
                }

                function toPX(value) {
                    return value + 'px';
                }

                function adjustWidthLeftPosition() {
                    var rect = fixBar.contentElem[0].getBoundingClientRect();

                    fixBar.element.css('left', toPX(rect.left));
                } 
            }
        }]);
angular
    .module('snk.components.fixedbar')
    .directive('skFixedBarContext', ['$timeout', 'FixedBarService',
        function ($timeout, FixedBarService) {

            return {
                restrict: 'E',
                link: postLink,
                scope: {
                    context: '=skContext',
                    name: '@skName',
                    forceContext: '=?skForceContext',
                    isActive: '=?skIsActive'
                }
            };

            function postLink(scope, element, attr) {

                init();

                function init() {
                    var fixedBarId = attr.skFixedBar;
                    var positionRefElem = attr.skFixedBarPositionRef;

                    if (!fixedBarId) {
                        throw new Error('O valor de sk-fixed-bar é obrigatório.');
                    }

                    FixedBarService.registryContext(fixedBarId, {
                        element: element,
                        barScope: scope,
                        positionRefSelector: positionRefElem
                    });
                }
            }
        }]);
angular
    .module('snk.components.fixedbar')
    .service('FixedBarService', function(){
        var self = this;

        var _contexts = {};


        self.getContexts = function (fixedBarId){
            return _contexts[fixedBarId];
        };

        self.registryContext = function (fixedBarId, contextInfo){
            if (!_contexts.hasOwnProperty(fixedBarId)){
                _contexts[fixedBarId] = [];
            }

            _contexts[fixedBarId].push(contextInfo);
        };
    });
angular
  .module('snk.components.flattree')
  .component('skFlatTree', {
    controller: 'SkFlatTreeController',
    templateUrl: 'components/flattree/flattree.tpl.html',
    bindings: {
      dataprovider: '<skDataprovider',
      dataset: '<skDataset',
      parentProperty: '@skParentProperty',
      localProperty: '@skLocalProperty',
      descriptionProperty: '@skDescriptionProperty',
      configName: '@skConfigName',
      componentCreated: '&?skComponentCreated'
    }
  });
angular
  .module('snk.components.flattree')
  .controller('SkFlatTreeController', ['$scope', '$q', '$element', 'ObjectUtils', 'ArrayUtils', 'MessageUtils', 'AngularUtil', 'StringUtils', 'i18n', 'DomUtil', 'DatasetEvents', 'SkApplicationInstance', 'SkConstants', 'PositionUtils', 'HierarchyUtils',
    function ($scope, $q, $element, ObjectUtils, ArrayUtils, MessageUtils, AngularUtil, StringUtils, i18n, DomUtil, DatasetEvents, SkApplicationInstance, SkConstants, PositionUtils, HierarchyUtils) {
      var self = this;

      var PARENT_FIELD_SUFIX = 'PAI';
      var ROOT_KEY_VALUE = -9999;

      var LBL_PESQUISA = i18n('Geral.lblResultadosPesquisa');
      var LBL_SEM_RESULTADOS = i18n('FlatTree.lblSemResultados');

      ObjectUtils.implements(self, IDataSetObserver);

      var _publicAPI;

      var _scrollContainer = angular.element($element[0].querySelector('[sk-scroll-container]'));

      var _itemSelectionChangeListeners = [];
      var _itemClickListeners = [];

      var _removeLastObserver;

      var _ignoreLineChange = false;

      var _lastSearchQuery;
      var _innerProvider = [];
      var _timeoutID;
      var _clickTimerID;
      var _itemsById = {};
      var _searchItemsById = undefined;

      var _selectionPath = [];

      var _initialized = false;

      /**
       * Configuração da máscara que será aplicada na hierarquia do sk-tree
       - mask: string - Máscara que será aplicada (Exemplo: "##.###.####")
        - fromLeft: boolean - Flag que indica se o texto será da esquerda para direita se estiver 'true' | padrão
        - defaultChar: string - Caractere para preencher a máscara caso o valor não preencha toda a máscara (Exemplo: "0")
        */
      var _hierarchyConfig = {
        mask: '',
        fromLeft: true,
        defaultChar: ''
      };

      var _selectedItemBeforeSearch;

      var _selectAfterRefreshID;

      var _localPropertyName;
      var _parentPropertyName;
      var _pathPropertyName;

      /**
       * SearchOptions
       */
      var _filterBranchesOption = {
        label: i18n('FlatTree.lblConsiderarPastas'),
        value: false,
        change: function (value) {
          saveConfig();
          doSearch();
        }
      };

      self.handleKeysInput = handleKeysInput;

      self.tree = [];
      self.filteredTree;

      self.pathArray = [];

      self.pathHierarchy;

      self.getCurrentLevelList = getCurrentLevelList;
      self.getItemDescription = getItemDescription;
      self.isSelectedItem = isSelectedItem;
      self.selectedItemHasChildren = selectedItemHasChildren;
      self.addSelectionChangeListener = addSelectionChangeListener;
      self.addItemClickListener = addItemClickListener;
      self.getHierarchyPath = getHierarchyPath;
      self.setHierarchyConfig = setHierarchyConfig;
      self.getHierarchyConfig = getHierarchyConfig;

      self.selectPKAfterRefresh = selectPKAfterRefresh;

      self.goToLevel = goToLevel;
      self.goToRoot = goToRoot;
      self.itemClick = itemClick;
      self.userItemClick = userItemClick;
      self.itemDblClick = itemDblClick;
      self.nextLevelClick = nextLevelClick;

      self.getTitle = getTitle;
      self.getTitleTooltip = getTitleTooltip;
      self.getEntityDescription = getEntityDescription;
      self.getEntityOrSearchDescription = getEntityOrSearchDescription;

      self.doSearch = doSearch;
      self.cancelSearch = cancelSearch;
      self.backArrowClick = backArrowClick;

      /** Impl. do IDataSetObserver */
      self.refreshed = refreshed;
      self.currentLineChanged = currentLineChanged;
      self.insertionModeActivated = insertionModeActivated;
      self.recordRemoved = recordRemoved;
      self.dataSaved = dataSaved;

      self.openSelectItem = openSelectItem;
      self.openLevelByIdentifier = openLevelByIdentifier;

      init();

      function init() {
        _publicAPI  = ObjectUtils.buildPublicAPI(self, [
            'selectPKAfterRefresh', 'openSelectItem',
            'selectedItemHasChildren', 'addSelectionChangeListener',
            'getHierarchyPath', 'goToRoot',
            'openLevelByIdentifier', 'addItemClickListener',
            'setHierarchyConfig', 'getHierarchyConfig']);

        self.searchOptions = [_filterBranchesOption];

        self.$onChanges = function (changes) {
          if (ObjectUtils.getProperty(changes, 'dataProvider.currentValue')) {
            _initialized = true;
            self.filteredTree = undefined;
            self.tree = arrayToTree(self.dataprovider);
            openLevel(self.tree, undefined);
          } else if (ObjectUtils.getProperty(changes, 'dataset.currentValue')) {
            if (_removeLastObserver) {
              _removeLastObserver();
            }

            _removeLastObserver = self.dataset.addObserver(self);

            bindToDataset();
          }
        };

        self.$postLink = function () {
          $element.attr('layout', 'column');
          $element.attr('flex', '');
        };

        _scrollContainer.bind('keydown', handleKeysContainer);

        loadConfig();

        if (self.componentCreated) {
          self.componentCreated({$component: _publicAPI});
        }
      }

      function selectPKAfterRefresh(pks) {
        var currPKValue = ObjectUtils.getProperty(pks, '0.value');

        if (angular.isDefined(currPKValue)) {
          _selectAfterRefreshID = currPKValue;
        }
      }

      function handleKeysInput(event) {
        if (event.keyCode == SkConstants.KEY_CODE.ESCAPE) {
          self.search = '';
        } else if (event.keyCode == SkConstants.KEY_CODE.DOWN_ARROW) {
          var currentIndex = -1;
          var currentList = getCurrentLevelList();

          if (!currentList) {
            return;
          }

          if (currentList[0]) {
            selectByIndex(currentList[0].arrayIndex);
          }

          _scrollContainer.focus();
          event.preventDefault();
          event.stopPropagation();
        }
      }

      function handleKeysContainer(event) {
        var newArrayIndex = -1;
        var currentIndex = -1;

        var currentList = getCurrentLevelList();

        if (!currentList) {
          return;
        }

        if (self.selectedItem) {
          currentIndex = findIndexByUID(currentList, self.selectedItem.uid);
        }

        if (event.keyCode == SkConstants.KEY_CODE.ESCAPE) {
          self.search = '';
          AngularUtil.digest($scope); //Nesse ponto não estamos em um digest e devemos lançar um.
        } else if (event.keyCode == SkConstants.KEY_CODE.HOME) {
          newArrayIndex = currentList[0];//.arrayIndex;
        } else if (event.keyCode == SkConstants.KEY_CODE.END) {
          newArrayIndex = currentList[currentList.length - 1];//.arrayIndex;
        } else if (event.keyCode == SkConstants.KEY_CODE.UP_ARROW) {
          if (currentIndex > 0) {
            newArrayIndex = currentList[currentIndex - 1];//.arrayIndex;
          } else if (currentIndex == 0) {
            DomUtil.select($element, 'sk-search-input input').focus();
          }
        } else if (event.keyCode == SkConstants.KEY_CODE.DOWN_ARROW) {
          if (currentIndex > -1 && currentIndex < currentList.length - 1) {
            newArrayIndex = currentList[currentIndex + 1];//.arrayIndex;
          }
        } else if (event.keyCode == SkConstants.KEY_CODE.RIGHT_ARROW) {
          if (self.selectedItem && self.selectedItem.children) {
            nextLevelClick(self.selectedItem);
          }
        } else if (event.keyCode == SkConstants.KEY_CODE.LEFT_ARROW) {
          if (event.ctrlKey) {
            goToRoot();
          } else {
            backArrowClick();
          }
        }

        if (newArrayIndex != -1 ||(event.keyCode == SkConstants.KEY_CODE.DOWN_ARROW &&  currentIndex == currentList.length - 1)) { //if (newArrayIndex > -1) {
          if (newArrayIndex != -1) {
            itemClick(newArrayIndex, true);
          }

          event.preventDefault();
          event.stopPropagation();
        }
      }

      function loadConfig() {
        if (self.configName) {
          SkApplicationInstance
            .loadMgeConfig(self.configName)
            .then(function (result) {
              _filterBranchesOption.value = StringUtils.toBoolean(ObjectUtils.getProperty(result, 'config.filterBranches'));
            });
        }
      }

      function saveConfig() {
        if (self.configName) {
          SkApplicationInstance
            .saveMgeConfig(self.configName, {
              filterBranches: _filterBranchesOption.value
            });
        }
      }

      function bindToDataset() {
        _initialized = false;

        self.dataset.whenMetadataLoaded().then(function () {
          var foundPathHierarquia = false;

          ArrayUtils.forEach(self.dataset.getFieldsMetadata(), function (fieldMD) {
            if (_hierarchyConfig.mask === '') {
              var maskProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                  return prop.name == 'mask';
              });

              if (maskProp) {
                _hierarchyConfig.mask = StringUtils.expandHierarchyMask(maskProp.value);
                loadPropertyKey(fieldMD);
              }
            }

            if (!foundPathHierarquia) {
              var pathProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                return prop.name == 'pathHierarquia';
              });

              if (pathProp) {
                _pathPropertyName = fieldMD.name;
                self.pathHierarchy = self.dataset.getFieldIndexByName(_pathPropertyName);
                foundPathHierarquia = true;
              }
            }

            return _hierarchyConfig.mask === '' || !foundPathHierarquia;
          });

          if (angular.isUndefined(_localPropertyName) && _hierarchyConfig.mask === '') {
              ArrayUtils.forEach(self.dataset.getFieldsMetadata(), function (fieldMD) {
                  loadPropertyKey(fieldMD);
                  return isNaN(self.parentProperty);
              });
          }

          if (angular.isUndefined(_hierarchyConfig.mask)) {
            throw Error(i18n('SanDB.Dynaform.messageEntidadeNaoDefinida', [self.dataset.getEntityName()]));
          }

          if (isNaN(self.parentProperty)) {
            throw Error(i18n('SanDB.Dynaform.messageObjetoPaiNulo'));
          }

          self.descriptionProperty = self.dataset.getEntityPresentationFieldIndex();

          _initialized = true;
        });
      }

      function loadPropertyKey(fieldMD) {
        _localPropertyName = fieldMD.name;

        var parentKeyNameProp = ArrayUtils.find(fieldMD.properties, function (prop) {
          return prop.name == 'parentKeyName';
        });

        if (parentKeyNameProp && parentKeyNameProp.value) {
          _parentPropertyName = parentKeyNameProp.value;
        } else {
          _parentPropertyName = fieldMD.name + PARENT_FIELD_SUFIX;
        }

        self.localProperty = self.dataset.getFieldIndexByName(_localPropertyName);
        self.parentProperty = self.dataset.getFieldIndexByName(_parentPropertyName);
      }

      function insertionModeActivated() {
        if (self.selectedItem) {
          var parentKey = self.selectedItem[self.pathHierarchy || self.parentProperty];
          var isValid = angular.isNumber() ? parentKey > 0 : angular.isDefined(parentKey);
          
          if (angular.isDefined(parentKey) && isValid) {
            self.dataset.setFieldValue( (_pathPropertyName || _localPropertyName) , parentKey);
          }

          setSelectedItem(undefined);
        }
      }

      function dataSaved(isNew, records) {
        var newRecord = records[0];

        if (isNew) {
          _selectAfterRefreshID = newRecord[self.localProperty];
          refreshed();
        } else {
          var oldRecord = _itemsById[newRecord[self.localProperty]];

          if (oldRecord) {
            oldRecord[self.descriptionProperty] = newRecord[self.descriptionProperty];
          }

          if (_searchItemsById) {
            oldRecord = _searchItemsById[newRecord[self.localProperty]];
            if (oldRecord) {
              oldRecord[self.descriptionProperty] = newRecord[self.descriptionProperty];
            }
          }
        }
      }

      function findByUID(list, uid) {
        return ArrayUtils.find(list, function (item) {
          return item.uid == uid;
        });
      }

      function findIndexByUID(list, uid) {
        var index = -1;

        ArrayUtils.forEach(list, function (item, currIndex) {
          if (item.uid == uid) {
            index = currIndex;
            return false;
          }
        });

        return index;
      }

      function recordRemoved(removedItem) {
        var currentID = removedItem[self.localProperty];
        var currentItem = _itemsById[currentID];

        if (self.onSearch) {
          var filterItem = findByUID(self.filteredTree, currentItem.uid);

          if (filterItem) {
            ArrayUtils.removeReference(self.filteredTree, filterItem);
          }

          if (filterItem == self.selectedItem) {
            setSelectedItem(undefined);
          }
        }
        
        if(self.levelList === undefined){ 
        	refreshed(); 
        	return false; 
    	}

        if (self.levelList.length > 1) { //Tem mais um irmão, então posicionamos nele
          var deletedPosition = ArrayUtils.indexOf(self.levelList, currentItem);
          ArrayUtils.removeAtIndex(self.levelList, deletedPosition);

          deletedPosition = Math.min(deletedPosition, self.levelList.length - 1);

          var newSelectionItem = self.levelList[deletedPosition];
          _selectAfterRefreshID = newSelectionItem[self.localProperty];
        } else { //Era filho único, selecionamos o pai.
          var parentID = removedItem[self.parentProperty];
          var parentItem = _itemsById[parentID];

          if (parentItem) {
            _selectAfterRefreshID = parentItem[self.localProperty];
          }
        }

        refreshed();
      }

      function refreshed(reason) {
        _selectionPath.length = 0;
        _lastSearchQuery = undefined;
        self.filteredTree = undefined;
        setSelectedItem(undefined);
        self.tree = arrayToTree(self.dataset.getRecords());

        var currentIndex = -1;

        if (_selectAfterRefreshID) {
          itemToSelect = _itemsById[_selectAfterRefreshID];

          if (itemToSelect) {
            currentIndex = itemToSelect.arrayIndex;
          }

          _selectAfterRefreshID = undefined;
        }

        if (currentIndex == -1) {
          if (reason != DatasetEvents.REFRESH_REASON_RESET) {
            currentIndex = self.dataset.getCurrentIndex();
          } else {
            var currentItem = self.tree[0];

            if (currentItem) {
              currentIndex = currentItem.arrayIndex;
            }
          }
        }

        if (currentIndex > -1) {
          selectByIndex(currentIndex);
        }

        if (self.onSearch) {
          doSearch(true);
        }
      }

      function goToRoot() {
        goToLevel(undefined, true);
        // .then(function () {
        //   var currentList = getCurrentLevelList();

        //   if (currentList && currentList[0]) {
        //     itemClick(currentList[0]);
        //   }
        // });
      }

      function currentLineChanged(newIndex, reason, properties) {
        if (reason == DatasetEvents.LINE_CHANGE_BY_RECORD_REMOVED) {
          return; //Não fazemos nada pois vamos lançar um refresh interno.
        } else if (reason == DatasetEvents.REFRESH_REASON_RESET) {
          if (properties.locateByPk) {
           AngularUtil.timeout(function() {
             try {
               _ignoreLineChange = true;
              selectByIndex(newIndex);
             } finally {
               _ignoreLineChange = false;
             }
           });
          } else {
            if (newIndex  < 0) {
              var firstChild = self.tree[0];
              if (firstChild) {
                newIndex = firstChild.arrayIndex;
              }
            }

            if (newIndex > -1) {
              selectByIndex(newIndex);
            }
          }
        } else if (newIndex > -1) {
          if (!_ignoreLineChange) {
            selectByIndex(newIndex);
          }
        } else {
          setSelectedItem(undefined);
        }
      }

      function selectByIndex(indexToSearch) {
        var selectedTreeItem = findTreeItemByIndex(self.filteredTree || self.tree, indexToSearch);

        if (self.selectedItem && selectedTreeItem && (self.selectedItem.uid == selectedTreeItem.uid)) {
          return;
        }

        if (selectedTreeItem) {
          var changeLevel = true;
          var currentList = getCurrentLevelList();

          if (currentList) {
            changeLevel = findByUID(currentList, selectedTreeItem.uid) == undefined;
          }

          var callback = function () {
            buildSelectionPathFromItem(selectedTreeItem);
            itemClick(selectedTreeItem, true);
          };

          if (changeLevel === false) {
            callback();
          } else {
            goToLevel(selectedTreeItem.parent).then(callback);
          }
        }
      }

      function findTreeItemByIndex(array, indexToSearch) {
        for (var i = 0, len = array.length; i < len; i++) {
          var treeItem = array[i];

          if (treeItem.arrayIndex == indexToSearch) {
            return treeItem;
          } else if (treeItem.children) {
            var childTreeItem = findTreeItemByIndex(treeItem.children, indexToSearch);

            if (childTreeItem) {
              return childTreeItem;
            }
          }
        }
      }

      function backArrowClick() {
        var itemToSelect;
        var scrollPos = -1;
        var newTreeLevel = self.currentParent;

        var selectionPathItem = _selectionPath.pop();

        if (selectionPathItem) {
          itemToSelect = selectionPathItem.item;
          scrollPos = selectionPathItem.scrollPos;
        }

        if (newTreeLevel) {
          goToLevel(newTreeLevel.parent)
            .then(function () {
              itemClick(itemToSelect, true, scrollPos);
            });
        }
      }

      function buildSelectionPathFromItem(treeItem, origParent) {
        _selectionPath.length = 0;

        var item = treeItem;

        var alreadyFound = false;

        while (item = item.parent) {
          _selectionPath.push({
            item: item,
            scrollPos: -1,
            parent: item.parent
          });
        }

        _selectionPath = _selectionPath.reverse();

        if (origParent) {
          _selectionPath[0] = {
            item: origParent,
            scrollPos: -1,
            parent: undefined
          };
        }
      }

      function getEntityOrSearchDescription() {
        if (self.onSearch) {
          if (self.filteredTree && self.filteredTree.length == 0) {
            return LBL_SEM_RESULTADOS;
          } else {
            return LBL_PESQUISA;
          }
        } else {
          return getEntityDescription();
        }
      }

      function getEntityDescription() {
        return self.dataset && self.dataset.getEntityDescription();
      }

      function getTitle() {
        return getItemDescription(self.currentParent);
      }

      function getTitleTooltip() {
        return self.currentParentTooltip;
      }

      function doSearch(forceSearch) {
        var search = angular.isDefined(self.search) ? self.search.trim() : '';

        var searchIdentifier = search + ':' + _filterBranchesOption.value;

        if ((_lastSearchQuery == searchIdentifier) && !(forceSearch === true)) {
          return;
        }

        if (_timeoutID) {
          clearTimeout(_timeoutID);
        }

        self.onSearch = search != '';
        self.filteredTree = undefined;

        if (self.onSearch) {
          _searchItemsById = {};

          if (self.onSearch && !_selectedItemBeforeSearch) {
            _selectedItemBeforeSearch = self.selectedItem;
          }

          search = StringUtils.replaceAccentuatedChars(search).toLowerCase();

          self.pathArray.length = 0;
          self.filteredTree = [];

          _timeoutID = processChunk((_innerProvider || []), function (item) {
            var itemDescription = StringUtils.replaceAccentuatedChars(item[self.descriptionProperty].toLowerCase());
            var originalItemKey = item.maskedIdentifier;
            var itemKey = item.maskedIdentifier.replace(/\./g, '');

            var valid = (!item.children || _filterBranchesOption.value) && (itemDescription.indexOf(search) > -1 || (itemKey.indexOf(search) > -1 || originalItemKey.indexOf(search) > -1));

            if (valid) {
              var copy = angular.copy(item);
              copy.children = item.children;
              copy.path = buildTreeItemPath(item.parent);

              _searchItemsById[self.localProperty] = copy;

              self.filteredTree.push(copy);
            }
          }, function () {
            AngularUtil.digest($scope);
          });

          openLevel(self.filteredTree, undefined)
            .then(function () {
              _lastSearchQuery = searchIdentifier;
            }, function () {
              self.filteredTree = undefined;
            });
        } else {
          _searchItemsById = undefined;
        }
      }

      function cancelSearch() {
        self.onSearch = false;
        _lastSearchQuery = undefined;
        self.filteredTree = undefined;

        var newLevel;

        if (_selectedItemBeforeSearch) {
          newLevel = _selectedItemBeforeSearch.parent;
        }

        goToLevel(newLevel)
          .then(function () {
            if (_selectedItemBeforeSearch) {
              buildSelectionPathFromItem(_selectedItemBeforeSearch);

              itemClick(_selectedItemBeforeSearch, true)
                .finally(function () {
                  _selectedItemBeforeSearch = undefined;
                });
            }
          });
      }

      function isSelectedItem(item) {
        return ObjectUtils.getProperty(self, 'selectedItem.uid') === ObjectUtils.getProperty(item, 'uid');
      }

      function addSelectionChangeListener(listener) {
        _itemSelectionChangeListeners.push(listener);
      }

      function addItemClickListener(listener) {
        _itemClickListeners.push(listener);
      }

      function getHierarchyPath() {
        return self.currentParentItemPath;
      }

      function selectedItemHasChildren() {
          return (self.selectedItem && self.selectedItem.children && self.selectedItem.children.length > 0) == true;
      }

      function buildTreeItemPath(item) {
        if (!item) {
          return '';
        }

        var path = [];

        do {
          path.push(item[self.descriptionProperty]);
        } while (item = item.parent);

        return path.reverse().join(' > ');
      }

      function processChunk(arr, callback, chunkFinish, chunkStart) {
        var timeoutID;

        chunkStart = angular.isDefined(chunkStart) ? chunkStart : 0;
        var chunkSize = Math.min(arr.length, chunkStart + 300);
        var timeoutSize = 200;

        for (var i = chunkStart; i <= chunkSize; i++) {
          if (i < arr.length) {
            if (i == chunkSize) {
              timeoutID = setTimeout(function () {
                processChunk(arr, callback, chunkFinish, i);
              }, timeoutSize);
              break;
            }

            callback(arr[i]);
          } else {
            chunkFinish();
          }
        }

        return timeoutID;
      }

      function goToLevel(item, selectItemFromPath) {
        var openLevelPromise;

        if (item) {
          openLevelPromise = openLevel(item.children, item);
        } else {
          openLevelPromise = openLevel(self.onSearch ? self.filteredTree : self.tree, undefined);
        }

        return openLevelPromise.then(function () {
          if (selectItemFromPath && _selectionPath.length > 0) {
            var index = -1;

            ArrayUtils.forEach(_selectionPath, function (selectionItem, selectionIndex) {
              if (selectionItem.parent == item) {
                index = selectionIndex;
                return false;
              }
            });

            if (index > - 1) {
              _selectionPath.splice(index + 1);
              var itemToSelect = _selectionPath.pop();

              if (itemToSelect) {
                itemClick(itemToSelect.item, true, itemToSelect.scrollPos);
              }
            }
          }
        });
      }

      function setSelectedItem(item) {
        self.selectedItem = item;

        ArrayUtils.callEachFunctionWith(_itemSelectionChangeListeners, item);
      }

      function userItemClick(item) {
        if (_clickTimerID) {
          AngularUtil.cancelTimeout(_clickTimerID);
        }

        _clickTimerID = AngularUtil.timeout(function () {
          itemClick(item, false, -1, true);
        }, 150);
      }

      function itemDblClick(item) {
        if (_clickTimerID) {
          AngularUtil.cancelTimeout(_clickTimerID);
        }

        if (item.children) {
          nextLevelClick(item);
        } else {
          itemClick(item);
        }
      }

      function itemClick(item, recalculateScroll, scrollPos, userClick) {
        if (!_initialized || !item || self.selectedItem == item) {

          if (userClick && item) {
            ArrayUtils.callEachFunctionWith(_itemClickListeners, item);
          }

          return $q(function (resolve) {
            resolve();
          });
        }

        return gotoRowOnDataset(item.arrayIndex)
          .then(function () {
            if (userClick) {
              ArrayUtils.callEachFunctionWith(_itemClickListeners, item);
            }

            setSelectedItem(item);

            if (recalculateScroll) {
              AngularUtil.timeout(function () {
                if (scrollPos > -1) {
                  DomUtil.scrollTo(_scrollContainer, scrollPos, undefined, 0);
                } else {
                  var selectedChild = _scrollContainer[0].querySelector('.tree-item-container.active');
                  selectedChild && scrollToChild(selectedChild);
                }
              });
            }
          });
      }

      function scrollToChild(selectedChild) {
        DomUtil.scrollToChild(_scrollContainer, selectedChild);
      }

      function gotoRowOnDataset(index) {
        return $q(function (resolve, reject) {
          if (!_ignoreLineChange) {
            _ignoreLineChange = true;
            self.dataset.gotoRow(index).then(function () {
              _ignoreLineChange = false;
              resolve();
            }, reject);
          } else {
            resolve();
          }
        });
      }

      function openSelectItem() {
        if (self.selectedItem) {
            nextLevelClick(self.selectedItem);
        }
      }

      function nextLevelClick(item) {
        var rebuildSelectionPath = self.onSearch && getCurrentLevelList() == self.filteredTree;

        openLevel(item.children, item)
          .then(function () {
            if (rebuildSelectionPath || !self.selectedItem) {
              _selectionPath.length = 0;
            } else {
              _selectionPath.push({
                item: item,
                scrollPos: _scrollContainer.scrollTop(),
                parent: item.parent
              });
            }

            itemClick(self.levelList && self.levelList[0])
              .then(function () {
                if (rebuildSelectionPath) {
                  buildSelectionPathFromItem(self.selectedItem, item);
                }
              });
          });
      }

      function getItemDescription(item) {
        return item && item[self.descriptionProperty];
      }

      function openLevelByIdentifier(identifier, selectFromLevelCache){
        var treeItem = _itemsById[identifier];

        if (treeItem && treeItem != self.currentParent) {
            goToLevel(treeItem, selectFromLevelCache);
        }
      }

      function openLevel(levelList, parent) {
        return self.dataset.autoSave().then(function () {
          self.currentParent = parent;
          self.levelList = levelList;

          self.currentParentTooltip = parent ? buildTreeItemPath(parent) : undefined;

          if (parent && parent.children) {
            self.currentParentLinkPath = [];
            self.currentParentPath = [];
            self.currentParentItemPath = [];

            var maskArray = parent.maskedIdentifier.split('\.').reverse();

            var currentParent = parent;

            for (var i = 0, len = maskArray.length; i < len && currentParent; i++) {
              if (Number(maskArray[i]) > 0) {
                if (currentParent == parent) {
                  self.currentParentPath.push(maskArray[i]);
                } else {
                  self.currentParentLinkPath.push({
                      description: currentParent[self.descriptionProperty],
                      item: currentParent,
                      label: maskArray[i]
                  });
                }

                self.currentParentItemPath.push({
                    arrayIndex: currentParent.arrayIndex,
                    description: currentParent[self.descriptionProperty],
                    identifier: currentParent[self.localProperty],
                    maskedIdentifier: currentParent.maskedIdentifier
                });

                currentParent = currentParent.parent;
              } else {
                self.currentParentPath.push(maskArray[i]);
              }
            }

            self.currentParentItemPath = self.currentParentItemPath.reverse();
            self.currentParentLinkPath = self.currentParentLinkPath.reverse();
            self.currentParentPath = self.currentParentPath.reverse();
          } else {
            self.currentParentItemPath = undefined;
            self.currentParentLinkPath = undefined;
            self.currentParentPath = undefined;
          }
        });
      }

      function getCurrentLevelList() {
        if (self.levelList) {
          return self.levelList;
        } else if (self.onSearch) {
          return self.filteredTree;
        } else {
          return self.tree;
        }
      }

      function buildItemIdentifier(item) {
        return item[self.localProperty] + ':' + item[self.parentProperty];
      }

      function arrayToTree(dataProvider) {
        _innerProvider = [];

        if (!angular.isArray(dataProvider)) {
          return [];
        }

        _itemsById = {};
        var waitingForParent = {};
        var roots = [];

        for (var i = 0; i < dataProvider.length; i++) {
          var item = dataProvider[i];
          var itemIdentifier = item[self.localProperty];
          var parentIdentifier = item[self.parentProperty];

          var isRootRecord = angular.isUndefined(parentIdentifier) || parentIdentifier <= ROOT_KEY_VALUE || parentIdentifier == 0;

          if (isRootRecord && itemIdentifier == 0) {
            continue;
          }

          var treeItem = buildTreeItemFromRecord(item);
          treeItem.arrayIndex = i;

          _itemsById[itemIdentifier] = treeItem;
          _innerProvider.push(treeItem);

          if (waitingForParent[itemIdentifier]) {
            treeItem.children = [];

            waitingForParent[itemIdentifier].forEach(function (child) {
              child.parent = treeItem;
              treeItem.children.push(child);
            });

            delete waitingForParent[itemIdentifier];
          }

          if (isRootRecord) {
            roots.push(treeItem);
          } else {
            var parentNode = _itemsById[parentIdentifier];

            if (parentNode) {
              treeItem.parent = parentNode;

              if (!parentNode.children) {
                parentNode.children = [];
              }
              parentNode.children.push(treeItem);
            } else {
              var waiters = waitingForParent[parentIdentifier];

              if (!waiters) {
                waiters = [];
                waitingForParent[parentIdentifier] = waiters;
              }

              waiters.push(treeItem);
            }
          }
        }

        return sortTree(roots);
      }

      function sortTree(roots) {
        //Ordenamos todos os filhos dentro de todos os nós.
        _innerProvider.forEach(function (treeItem) {
          if (treeItem.children) {
            treeItem.children.sort(sortLevel);
          }
        });

        //Ordenamos o root
        return roots.sort(sortLevel);
      }

      function sortLevel(a, b) {
        var aNodeID = a[self.localProperty];
        var bNodeID = b[self.localProperty];
        return aNodeID - bNodeID;
      }

      function buildTreeItemFromRecord(record) {
        var itemIdentifier = record[ self.pathHierarchy || self.localProperty];
        var parentIdentifier = record[self.parentProperty];

        var maskedIdentifier;

        if ((angular.isUndefined(parentIdentifier) || parentIdentifier <= ROOT_KEY_VALUE || parentIdentifier == 0) && itemIdentifier == 0) {
            maskedIdentifier = StringUtils.replicate('0', _hierarchyConfig.mask?.indexOf('.'));
        } else {
            const { mask, fromLeft, defaultChar } = _hierarchyConfig;
            maskedIdentifier = StringUtils.applyHierarchyMask(mask, itemIdentifier, false, fromLeft, defaultChar);
        }

        var treeItem = {
          uid: buildItemIdentifier(record),
          maskedIdentifier: maskedIdentifier
        };

        treeItem[self.localProperty] = itemIdentifier;
        treeItem[self.parentProperty] = record[self.parentProperty];
        treeItem[self.descriptionProperty] = record[self.descriptionProperty];
        
        if(self.pathHierarchy){
          treeItem[self.pathHierarchy] = record[self.pathHierarchy];
        }

        return treeItem;
      }

      function setHierarchyConfig(config) {
        const newMask = angular.isDefined(config.mask) 
            ? config.mask !== '' && config.mask.indexOf('#') === -1 
            ? StringUtils.expandHierarchyMask(config.mask) 
            : config.mask.indexOf('#') !== -1
            ? config.mask 
            : ''
            : _hierarchyConfig.mask;
        _hierarchyConfig = {
            ..._hierarchyConfig,
            ...config,
            mask: newMask
        };
      }

      function getHierarchyConfig() {
          return _hierarchyConfig;
      }
    }]);

/**
 * @ngdoc directive
 * @name snk.components.icon.directive:font
 * @restrict E
 * @description
 * A diretiva 'font' permite você utilizar a tag font que foi descontinuada no HTML5
 * Tivemos que fazer isso para que os erros que eram lançados em flex usando essa tag não parem de
 * funcionar
 * 
 * @param {string=} size Tamanho da fonte.
 * @param {string=} color Cor da fonte
 * @param {string=} face Nome da fonte
 *
 * @example
     <example module="app">
         <file name="exemplo.html">
            <font size="2" face="arial" color="#8B1A1A">
                <b>Atenção:  </b>Teste.
                <br><br>
                <b>Motivo: </b> Erro!.
                <br><br>
                <b>Solução: </b> Texto qualquer!
            </font>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.font')
    .directive('font', [function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: false,
        template: '<span ng-transclude></span>',
        link: function (scope, element, attr) {
            if (attr.color) {
                element.css('color', attr.color);
            }

            if (attr.face) {
                element.css('font-family', attr.face);
            }

            if (attr.size) {
                element.css('font-size', attr.size);
            }
        }
    };
}]);
angular
    .module('snk.components.form')
    .constant("FormHighlithKind", {
        ERROR: 'error',
        SEARCH: 'search',
    })
    .constant("FormColumnConfig", {
        /*O valor das constantes abaixo deve estar em conformidade com o arquivo
         DynaformFormColConfigInitLoader.java*/
        FORM_COL_CONFIG_PREFIX  : 'formColCfg.',
        DEFAULT_KEY             : 'default',
        HIERARCHY_CONFIG_PREFIX : 'treeHierarchy.',

        /*O valor das constantes abaixo deve estar em conformidade com o parâmetro
         mge.core.config.form.html5*/
        PADRAO                  : 0, //Por Usuario
        POR_USUARIO             : 0,
        UNICA_NORMAL            : 1,
        UNICA_COMPACTA          : 2,
        MULTI_COLUNAS           : 3
    });
angular
    .module('snk.components.form')
    .controller('SkFormController', ['$scope', '$q', '$timeout', '$element', '$document', '$compile', 'FormHighlithKind', '$attrs', 'DomUtil', 'FormService', 'UserAgentUtils', 'ObjectUtils', '$tooltip', 'TooltipBuilder', 'ArrayUtils', 'StringUtils', 'MGEParameters', 'AngularUtil', 'PositionUtils', 'FormColumnConfig','SkApplicationInstance', 'WhenReady',
    function($scope, $q, $timeout, $element, $document, $compile, FormHighlithKind, $attrs, DomUtil, FormService, UserAgentUtils, ObjectUtils, $tooltip, TooltipBuilder, ArrayUtils, StringUtils, MGEParameters, AngularUtil, PositionUtils, FormColumnConfig, SkApplicationInstance, WhenReady){
        var self = this;
        const _fiedByName = [];

        let _whenFormReady = WhenReady();

        var PX = 'px';
        var CHAR_TO_PIXEL_RATIO = 7.5;

        var _createdFields = {};
        var _createdBlocks = {};
        var _fieldPromises = {};
        var _highlightedFieldNamesByKind = {};
        var _labelsWidth = 0;
        //var _loadedFields = {};
        //var _loadingPanelElem = $element.find('sk-loading-panel');
        var autofocus = false;

        var _tooltips = {};

        var _customFormItems = {};

        var _onlyCustomFormItems = $attrs.hasOwnProperty('skOnlyCustom');
        var _onlyCustomOrder = 0;

        var _hasInitialSkColumns = StringUtils.isNotEmpty($scope.skColumns) || StringUtils.isNotEmpty($scope.columns);

        var _currentColumnClass;

        var _personalizeHighlightByField = {};

        self.registryField = registryField;
        self.highlightFields = highlightFields;
        self.unHighlightFields = unHighlightFields;
        self.updateFieldLabelWidth = updateFieldLabelWidth;
        self.updateFieldsLabelWidth = updateFieldsLabelWidth;
        self.isFormInline = isFormInline;
        self.getModel = getModel;
        self.getFieldController = getFieldController;
        self.showFieldTooltip = showFieldTooltip;
        self.addCustomFormItem = addCustomFormItem;
        self.getCustomFormItem = getCustomFormItem;
        self.setFieldProperty = setFieldProperty;
        self.setFieldFocus = setFieldFocus;

        self.loaddedFromConfig = false;

        $scope.inline = $scope.inline == 'true' ? true : false;
        $scope.creationComplete = creationComplete;
        $scope.fieldsProperties = [];
        $scope.isFieldVisible = isFieldVisible;
        $scope.isGroupVisible = isGroupVisible;
        $scope.onBlockCreationComplete = onBlockCreationComplete;
        $scope.preProcessFormColConfig = preProcessFormColConfig;
        $scope.defaultStyle = {
            opacity: 0
        };
        $scope.isFieldAccount = isFieldAccount;

        init();

        function init() {
            if($scope.formInterceptor) {
                ObjectUtils.isImplementorOf($scope.formInterceptor, IFormInterceptor);
            }

            autofocus = !UserAgentUtils.isMobile() && $attrs.hasOwnProperty('skAutofocus');

            if ($attrs.skDataset && $attrs.onlyProps != 'true') {
                var unWatch = $scope.$watch('dataset', function(newDs) {
                   if (newDs) {
                       preProcessFormColConfig();

                       bindToDataset(newDs);

                       unWatch();
                   }
                });
            } else {
                $scope.$watchCollection('properties', function(newProperties){
                    _createdFields = {};
                    _createdBlocks = {};

                    /*if (isFormInline()) {
                        setLoaderVisible(true);
                    }*/

                    if (angular.isDefined($scope.fieldsOrder)) {                     
                        newProperties.sort(function (fieldA, fieldB) {
                            return $scope.fieldsOrder.indexOf(fieldA.fieldName) - $scope.fieldsOrder.indexOf(fieldB.fieldName);
                        });
                    }

                    preProcessFormColConfig();

                    $scope.formBlocks = buildFormBlocks(newProperties);
                });
            }
            
            if(angular.isFunction($scope.onFormLoaded)){
                $scope.onFormLoaded({
                    form: self
                })
            }
        }

        /*function setLoaderVisible(val) {
            //_loadingPanelElem[val ? 'removeClass' : 'addClass']('hide');
        }*/

        function preProcessFormColConfig() {
            if(!_hasInitialSkColumns && angular.isDefined($scope.formConfigColumnKey)) {
                var paramConfigForm = MGEParameters.asInteger("mge.core.config.form.html5");

                if(!processFormColConfig(paramConfigForm) && paramConfigForm == FormColumnConfig.POR_USUARIO) {
                    var config = SkApplicationInstance.getConfiguracaoTela($scope.formConfigColumnKey);

                    if(angular.isDefined(config)) {
                        let colsNumber = Number(config.config);
                        //Tratativa para a nova config de formulário
                        if(!config.newConfig && colsNumber > 0){
                            colsNumber--;
                        }
                        processFormColConfig(Number(colsNumber));
                    }else{ //Default de 1 coluna compacta
                        $scope.skColumns = 1;
                        $scope.inline = true;
                    }
                }
            }

            applyColumns();
        }

        function processFormColConfig(config) {
            //Sobrescre a configuracao padrao do formulario se existir
        	if(StringUtils.isNotEmpty($scope.formColumnNumberConfig)){
                config = Number($scope.formColumnNumberConfig);
            }

            if(angular.isUndefined(config)) {
                return false;
            }

            if(config == FormColumnConfig.UNICA_NORMAL || config == FormColumnConfig.UNICA_COMPACTA) {
                $scope.skColumns = 1;
                $scope.inline = (config == FormColumnConfig.UNICA_COMPACTA);
                return true;
            }
            
            if(config == FormColumnConfig.MULTI_COLUNAS) {//Multi colunas
                $scope.skColumns = undefined;
                $scope.inline = false;
                self.loaddedFromConfig = true;
                return true;
            }
            
            if(config == FormColumnConfig.PADRAO){
                $scope.skColumns = 1;
                $scope.inline = true;
            }

            return false;
        }

        function addCustomFormItem(customFormItem) {
            _customFormItems[customFormItem.fieldName] = customFormItem;

            if (_onlyCustomFormItems) {
                customFormItem.order = _onlyCustomOrder++;
            }
        }

        function getCustomFormItem(fieldName) {
            return _customFormItems[fieldName];
        }

        function bindToDataset(dataset) {
            dataset.whenMetadataLoaded().then(function () {

                var foreignKeysLocalName;
                if (dataset.getParentDataset() && angular.isArray(dataset.getForeignKeyFields())) {
                    foreignKeysLocalName = dataset.getForeignKeyFields().map(function(foreignKey){
                        return foreignKey.localField;
                    });
                }

                var properties = FormService.buildPropertiesFromMD(dataset.getFieldsMetadata(), function () {
                    return fieldProps = {
                        'sk-dataset': $scope.dataset
                    };
                }, function (fieldMD) {
                    if (_onlyCustomFormItems) {
                        return angular.isDefined(getCustomFormItem(fieldMD.name));
                    }

                    if (fieldMD.isDescriptionField) {
                        return false;
                    }

                    if (!$scope.formInterceptor && foreignKeysLocalName && foreignKeysLocalName.indexOf(fieldMD.name) > -1){
                        return false;
                    }

                    if($scope.formInterceptor && !$scope.formInterceptor.acceptField(fieldMD, dataset)) {
                        return false;
                    }

                    return true;
                }, undefined, function(fieldProperty) {
                    $scope.formInterceptor && $scope.formInterceptor.interceptField(fieldProperty, $scope.dataset);
                });

                if (_onlyCustomFormItems) {
                    properties.sort(function(fieldA, fieldB) {
                        return getCustomFormItem(fieldA.fieldName).order - getCustomFormItem(fieldB.fieldName).order; 
                    });
                } else if ($scope.fieldsOrder) {
                    properties.sort(function (fieldA, fieldB) {
                        return $scope.fieldsOrder.indexOf(fieldA.fieldName) - $scope.fieldsOrder.indexOf(fieldB.fieldName);
                    });
                }

                $scope.formBlocks = buildFormBlocks(properties);
            });
        }

        function getModel(){
            return $scope.model;
        }

        function applyColumns() {
            //Default coluna unica compacta.
            if(!_hasInitialSkColumns && (!$scope.skColumns && !$scope.columns && !self.loaddedFromConfig) ){
                $scope.inline = true;
                $element.addClass('compact-components');
            }

            var numColumns = isFormInline() ? 1 : ($scope.skColumns || $scope.columns);
            var formElem = angular.element($element[0].children[0]);

            if(_currentColumnClass) {
                formElem.removeClass(_currentColumnClass);
            }

            _currentColumnClass = 'columns-' + numColumns;

            formElem.addClass(_currentColumnClass);

            if (isFormInline()) {
                formElem.addClass('sk-form-flex');
            } else {
                formElem.removeClass('sk-form-flex');
            }

            $scope.responsiveClass = FormService.getResponsiveClass(numColumns);
        }
        
        function isFieldVisible(field) {
            var customFormItem = getCustomFormItem(field.fieldName);
            
            if (customFormItem) {
            	field.visible = customFormItem.visible;
                return customFormItem.visible;
            }

        	return !field.hasOwnProperty('visible') || field.visible == true;
        }

        function isFieldAccount(field) {
            return field.fieldName == 'ACCOUNTEMAIL';
        }
        
        function isGroupVisible(groupFields) {
        	if (!groupFields || groupFields.length == 0) {
        		return false;
        	} else {
        		var isVisible = false;
        		
        		ArrayUtils.forEach(groupFields, function(field){
        			if (isFieldVisible(field)) {
        				isVisible = true;
        				
        				return false;
        			};
        		});
        		
        		return isVisible;
        	}
        }

        function highlightFormItem(kind, formItem, options){
            var labelContainer = angular.element(formItem).find('label');
            labelContainer = angular.element(labelContainer[0]);
            let hasOptions = angular.isObject(options);
            let reqIco = labelContainer.find('.required');
            
            if(hasOptions && options.style && _personalizeHighlightByField.hasOwnProperty(options.fieldName)){
                _personalizeHighlightByField[options.fieldName].originStyle = formItem[0].style;
                _personalizeHighlightByField[options.fieldName].requiredIco = reqIco;
            }
            
            var color = '';

            if (kind == FormHighlithKind.ERROR) {
                color = '#FF8585';
            } else if (FormHighlithKind.SEARCH) {
                color = 'yellow';
            } else {
                throw new Error('Tipo de highlight não definido: ' + kind);
            }            

            var descriptionSpan = labelContainer.find('span:not(.required)');

            if(hasOptions && options.style){
                descriptionSpan.css(options.style);
            }

            if(!hasOptions || !options.style){
                descriptionSpan.css('background', color);
                descriptionSpan.css('border-radius', '4px');
                descriptionSpan.css('padding-inline', '2px');
            }

            if(hasOptions && options.icon){
                appendIconError(labelContainer, options);
            }

            var formItemBottom = formItem[0].getBoundingClientRect().bottom;
            var scrollTop = $document.scrollTop();
            var windowHeight = window.innerHeight;

            if (formItemBottom > windowHeight) {
                var diff = formItemBottom - windowHeight;
                DomUtil.scrollTo($document, scrollTop + diff + 5);
            }
        }

        function appendIconError(labelContainer, options){
            let fieldInfo = _createdFields[options.fieldName];
            let requeredIco = labelContainer.find('.required');

            if(requeredIco){
                options.requeredIco = requeredIco;
                requeredIco.remove();
            }

            let iconTpl = '<sk-icon font-icon="{icon}" class="icon-error" tooltip="{msgToolTip}" tooltip-placement="{tooltipPlacement}" ></sk-icon>';           
            iconTpl = StringUtils.substitute(iconTpl, {icon: options.icon, msgToolTip: options.message, tooltipPlacement: options.tooltipPlacement || 'right' });

            let icoElement = AngularUtil.compile(iconTpl, fieldInfo.controller.scope);

            labelContainer.append(icoElement);
        }

        function unHighlightFormItem(kind, formItem, fieldName){
            var labelContainer = getFormItemLabel(formItem);

            let personalizedOpt = _personalizeHighlightByField[fieldName];

            if(personalizedOpt){
                removePersonalizedError(formItem, personalizedOpt);
            }else{
                labelContainer.css('background', 'none');
                labelContainer.css('border-radius', '0px');
                labelContainer.css('padding-inline', '0px');
            }
            
            delete _personalizeHighlightByField[fieldName];
        }

        function removePersonalizedError(formItem, personalizedOpt){
            let personlizedIco = formItem.find('.icon-error');
            let labelContainer = getFormItemLabel(formItem);

            if(personlizedIco){
                personlizedIco.remove();
            }

            if(personalizedOpt.requiredIco){
                labelContainer.append(personalizedOpt.requiredIco);
            }

            if(labelContainer && personalizedOpt && personalizedOpt.options && personalizedOpt.options.style){
                resetStyle(personalizedOpt, labelContainer)
            }

            let span = labelContainer.find('span');
            if(span){
                resetStyle(personalizedOpt, span);
            }
        }

        function resetStyle(personalizedOpt, labelContainer){
            angular.forEach(personalizedOpt.options.style, function(value, prop){                    
                labelContainer.css(prop, personalizedOpt.originStyle[prop]);
            });
        }

        function doUnhighlithField(kind, fieldName){
            if (!fieldExists(fieldName)){
                throw new Error('Campo \'' + fieldName + '\' não registrado no formulário.');
            }

            var fieldInfo = _createdFields[fieldName];

            fieldInfo.controller.unHighlightField();

            unHighlightFormItem(kind, fieldInfo.formItem, fieldName);
        }

        function doHighlithField(kind, fieldName, tryNumber, options) {
            if (!fieldExists(fieldName)){
                throw new Error('Campo \'' + fieldName + '\' não registrado no formulário.');
            }

            var fieldInfo = _createdFields[fieldName];

            highlightFormItem(kind, fieldInfo.formItem, options);

            fieldInfo.controller.highlightField();

            if (kind == FormHighlithKind.SEARCH){
                $timeout(function(){
                    fieldInfo.controller.setFocus();
                }, 0, false);
            }
        }

        function highlightFields(kind, fieldNames, options){
            if (!angular.isArray(fieldNames)){
                fieldNames = [fieldNames];
            }

            if (kind == FormHighlithKind.ERROR) {
                var oldHighlighted = _highlightedFieldNamesByKind[FormHighlithKind.ERROR];

                if (oldHighlighted) {
                    oldHighlighted.forEach(function(fieldName){
                        doUnhighlithField(kind, fieldName, undefined);
                    });
                }

                fieldNames.forEach(function(fieldName){
                    let personalizedOpt = angular.isObject(options) ? options[fieldName] : undefined;                   
                    if(personalizedOpt){
                        personalizedOpt.fieldName = fieldName;
                        _personalizeHighlightByField[fieldName] = {options: personalizedOpt, originStyle: undefined };
                    }
                    doHighlithField(kind, fieldName, undefined, personalizedOpt);
                });               

                _highlightedFieldNamesByKind[FormHighlithKind.ERROR] = fieldNames;
            } else if (kind == FormHighlithKind.SEARCH) {
                var oldHighlighted = _highlightedFieldNamesByKind[FormHighlithKind.SEARCH];

                if (oldHighlighted){
                    doUnhighlithField(kind, oldHighlighted);
                }

                var fieldName = fieldNames[0];

                doHighlithField(kind, fieldName);

                _highlightedFieldNamesByKind[FormHighlithKind.SEARCH] = fieldName;
            } else {
                throw new Error('Tipo de highlight não definido: ' + kind);
            }

            _highlightedFieldName = fieldName;
        }

        function unHighlightFields(kind, fields) {
            var highlightedFields = fields || _highlightedFieldNamesByKind[kind];

            if (highlightedFields){

                if (!angular.isArray(highlightedFields)){
                    highlightedFields = [highlightedFields];
                }

                highlightedFields.forEach(function(fieldName){
                    doUnhighlithField(kind, fieldName);
                });

                delete _highlightedFieldNamesByKind[kind];
            }
        }

        function fieldExists(fieldName){
            return _createdFields[fieldName];
        }

        function getFieldController(fieldName, async){
            if (async){
                var deferred = $q.defer();

                if (_createdFields[fieldName]){
                    deferred.resolve(_createdFields[fieldName].controller);
                } else {
                    if (!_fieldPromises[fieldName]){
                        _fieldPromises[fieldName] = [];
                    }

                    _fieldPromises[fieldName].push({
                        promise: deferred,
                        property: 'controller'
                    });
                }

                return deferred.promise;
            } else {
                return _createdFields[fieldName] && _createdFields[fieldName].controller;
            }
        }

        function registryField(fieldName, formItem, inputElem, controller) {
            if (!fieldName || $scope.allowRepeatedFields == 'true'){
                return;
            }

            if (_createdFields[fieldName] && !$attrs.hasOwnProperty('skAllowDuplicateFields')){
                throw new Error('O campo '+ fieldName +' já está registrado nesse formulário.');
            }

            var labelElem = getFormItemLabel(formItem);

            _createdFields[fieldName] = {
                inputElem: inputElem,
                formItem: formItem,
                controller: controller,
                labelElem: labelElem
            };

            if (isFormInline()) {
                updateFieldLabelWidth(fieldName);
            }

            if (_fieldPromises[fieldName]){
                var fieldPromise;
                while(fieldPromise = _fieldPromises[fieldName].pop()){
                    var valueToSend = _createdFields[fieldName];

                    if (fieldPromise.property){
                        valueToSend = valueToSend[fieldPromise.property];
                    }

                    fieldPromise.promise.resolve(valueToSend);
                }
            }
        }

        function updateFieldLabelWidth(fieldName) {
            var labelElem = _createdFields[fieldName].labelElem;

            var labelText = labelElem.text().replace(/(\*|:)/g, '');

            var labelArr = labelText.split('');

            var labelWidth = getLabelWidth(labelText);//labelElem[0].clientWidth;

            /*if (labelWidth == 0) {
                _loadedFields[fieldName] = undefined;

                var destroyWatch = $scope.$watch(function() {
                    return labelElem[0].clientWidth;
                }, function(newV) {
                    if (newV > 0) {
                        destroyWatch();
                        updateFieldLabelWidth(fieldName);
                    }
                });

                return;
            }*/

            var origWidth = labelElem.data('origWidth');

            if (origWidth) {
                labelWidth = origWidth;
            }

            if (labelWidth > _labelsWidth) {
                _labelsWidth = labelWidth;

                updateFieldsLabelWidth(_labelsWidth);
            } else {
                labelElem.css('width', _labelsWidth + PX);

                if (!origWidth) {
                    labelElem.data('origWidth', labelWidth);
                }
            }

            //_loadedFields[fieldName] = undefined;
            //fieldLoaded();
        }

        function getLabelWidth(description) {
            if (description.length <= 15) {
                return Math.max(description.length * CHAR_TO_PIXEL_RATIO, 100);
            } else if (description.length <= 35) {
                return Math.max(description.length * (CHAR_TO_PIXEL_RATIO - 0.2), 100);
            } else {
                return Math.max(description.length * (CHAR_TO_PIXEL_RATIO - 0.8), 100);
            }
        }

        function updateFieldsLabelWidth(newWidth){
            var label;
            var fieldName;

            for (fieldName in _createdFields) {
                label = _createdFields[fieldName].labelElem;

                if (!label.data('origWidth') && angular.isDefined(label[0])){
                    label.data('origWidth', label[0].clientWidth);
                }

                label.css('width', newWidth + PX);
            }
        }

        function creationComplete() {
            $timeout(function () {
                $scope.defaultStyle = {};
            });
        }

        function onBlockCreationComplete(blockInfo, block) {
            if (blockInfo.creationComplete) {
                blockInfo.creationComplete(block);
            }

            //_loadedFields[blockInfo.blockId] = undefined;
            //fieldLoaded();
        }

        /*function fieldLoaded() {

            var createdFields = Object.keys(_createdFields).length;
            var createdBlocks = Object.keys(_createdBlocks).length;

            if ((createdFields + createdBlocks) == Object.keys(_loadedFields).length) {
                $timeout(function() {
                    setLoaderVisible(false);
                }, 150, false);
            }
        }*/

        function buildFormBlocks(argArray) {
            var groupedFieldsInfo = {};
            var lastUngroupedField;

            var currentBlock;
            var blocks = [];

            angular.forEach(argArray, function (field, index) {
                if (field.userType == 'customBlock') {
                    blocks.push(field);
                    _createdBlocks[field.blockId] = field;

                    if (currentBlock) {
                        currentBlock = undefined;
                    }
                } else {
                    if (!currentBlock) {
                        currentBlock = {};
                        blocks.push(currentBlock);
                    }

                    if (field.visible && autofocus) {
                        if(!field.fieldProp){
                            field.fieldProp = {};
                        }

                        autofocus = false;
                        field.fieldProp.autofocus = ''; //Colocamos o focus no primeiro field do form
                    }
                    
                    if (!currentBlock.groupFields) {
                        currentBlock.groupFields = [];
                    }

                    var customFormItem = getCustomFormItem(field.fieldName);
                    var groupName;

                    if (customFormItem) {
                        groupName = customFormItem.groupName;
                    }

                    if (StringUtils.isEmpty(groupName)) {
                        groupName = field.groupName;
                    }

                    if (angular.isDefined(groupName) && groupName !== '') {
                        var groupInfo;

                        if (groupedFieldsInfo.hasOwnProperty(groupName)) {
                            groupInfo = groupedFieldsInfo[groupName];
                            groupInfo.groupFields.push(field);
                        } else {
                            groupInfo = {
                                groupType: 'GROUPED',
                                groupLabel: groupName,
                                groupFields: [field]
                            };

                            currentBlock.groupFields.push(groupInfo);

                            groupedFieldsInfo[groupName] = groupInfo;
                        }
                    } else {
                        var i = angular.isDefined(lastUngroupedField) ? (currentBlock.groupFields.indexOf(lastUngroupedField) + 1) : 0;

                        currentBlock.groupFields.splice(i, 0, field);

                        lastUngroupedField = field;
                    }
                }

                if(field){
                    _fiedByName[field.fieldName] = field;
                }

                if($scope.onCreateField) $scope.onCreateField({field : angular.copy(field)});
            });

            _whenFormReady.ready();

            return blocks;
        }

        function showFieldTooltip(id, fieldName, message, duration) {
            var fieldInfo = _createdFields[fieldName];

            if (fieldInfo) {
                var tooltipBuilder = _tooltips[id] || TooltipBuilder();

                tooltipBuilder
                    .targetElement(fieldInfo.formItem)
                    .message(message)
                    .duration(duration)
                    .show();

                _tooltips[id] = tooltipBuilder;
            }
        }

        function getFormItemLabel(formItem) {
            var labelContainer = formItem.find('label');
            return angular.element(labelContainer[0]);
        }

        function isFormInline() {
            return ($scope.inline == "true" || $scope.inline == true);
        }

        function setFieldProperty(fieldName, propName, value){
            _whenFormReady.whenReady()
            .then(function () { 
                let fProp = _fiedByName[fieldName]
                if(fProp){
                    let hasScopeVar = FormService.SCOPE_MUTABLE_PROPERTIES.indexOf(propName) > -1;
    
                    if(FormService.MUTABLE_PROPERTIES.indexOf(propName) == -1 && !hasScopeVar){
                        throw new Error('[SkFormController] setFieldProperty, propriedade ' + propName + ' não pode ser alterada.');
                    }

                    if(hasScopeVar){
                        getFieldController(fieldName, true).then( (ctrl) => {
                            if(ctrl && ctrl.scope){
                                ctrl.scope[propName] = value;
                            }
                        });
                    }else {
                        fProp[propName] = value;
                    }

                    if(propName == 'required' && $scope.dataset){
                        $scope.dataset[value == true ? 'makeFieldRequired' : 'makeFieldNonRequired'](fieldName);
                    }
                }else{
                    console.warn('[SkFormController] setFieldProperty, Campo ' + fieldName + ' não encontrado.');
                }
            });
        }

        function setFieldFocus(fieldName, select){
            _whenFormReady.whenReady()
            .then(function () {
                getFieldController(fieldName, true).then( (ctrl) => {
                    if(ctrl && ctrl.setFocus){
                        ctrl.setFocus();
                        
                        if (select && ctrl.select) {
                        	ctrl.select();
                        }
                    }
                });
            })            
        }
    }]);

/**
 * @ngdoc directive
 * @name snk.form.directive:sk-form
 * @restrict E
 * @scope
 * @description
    Form é o componente responsável por realizar a renderização de campos (form item) de acordo com as propriedades recebidas através do objeto de propriedades.
    Esse componente é exclusivo para renderizar os form item e aplicar o conceito de responsivo no formulário.
    <br>
    <p style="font-weight: bold">
        O form agora possui o suporte a implementar campos personalizados no html semelhante ao que existe hoje no DBForm e outros form do Flex.
        <br>
        Nos exemplos apresentado no fim dessa página tem as possibilidades de uso e seus respectivos exemplos abrangendo todas as novas funcionalidades.
        <br>
        Em resumo foi disponibilizado a diretiva de elemento {@link snk.form.directive:sk-form-custom-item sk-form-custom-item} para ser 
        adicionada como filha do form para fazer as customizações dos campos conforme sua regra de negócio.
        <br>
        <span class="text-danger">Lembre-se, você deve usar essa nova forma apenas se for mais rápida e se for ficar mais organizado a sua implementação.</span>
    </p>
 *
 * @param {object} properties
    - Nesse objeto devemos passar um array denominado de fields (<b>fields: []</b>).
    - Nesse array de fields podemos passar todas as propriedades utilizados na renderização de 1 <b>sk-form-item</b>, 
    as propriedades permitidas no objeto que contempla o array de fields são: 
        - <b>label</b>: Campo texto utilizado para apresentar os label nos respectivos form item.
        - <b>fieldName</b>: Campo de texto utilizado nos componentes interno para informar o nome do campo do dicionário de dados ao DataSet.
        - <b>value</b>: Valor do campo que está sendo renderizado, este é o valor que é manipulado como fonte de dados pelo DataSet.
        - <b>type</b>: Campo de texto que define o tipo do sk-form-item a ser renderizado (texto, número, data e etc).
        - <b>required</b>: Booleano para definir se o campo deverá ser requerido ou não.
        - <b>saveLastValue</b>: Não documentado.
        - <b>groupName</b>: Campo do tipo texto que define o grupo de campos que este form item vai ser renderizado, caso essa chave seja vazia ou não informada, ele vai listar os campos sem nenhum grupo de campos.
        - <b>fieldProp</b>: Esse campo recebe um objeto que pode conter N atributos/diretivas de atributos do HTML para ser aplicado nos componentes internos renderizado pelo form item.
    Para mais detalhes sobe o array de propriedades, consulte o exemplo.
 *
 * @param {string=} [sk-columns=1] Número de colunas em que o formulário será renderizado. Atualmente temos
 * suporte apenas para 1, 2, 3 e 6 colunas, caso seja informado um número de colunas diferente disso o
 * skForm automaticamente coloca no máximo 4 colunas como o padrão quando a tela dá suporte a essa quantidade.
 *
 * @param {boolean=} [sk-inline=false] Informa se o skForm deve assumir apenas 1 coluna (padrão flex) ou se terá
 * colunas responsivas conforme o novo padrão do HTML5.
 * 
 * @param {attribute} [sk-only-custom] Quando esse atributo estiver presente no form, ele vai renderizar 
 * apenas os sk-form-custom-item filho do form que estão no html.
 *
 * @param {tag} [sk-form-custom-block] Quando essa tag estiver presente dentro form, o elemento que 
 * estiver dentro dela ele vai ser renderizada no final do formulário.
 * 
 * @example
     <example module="app">
         <file name="FormExample.html">
            <sk-application ng-controller="ExampleController as ctrl" layout-padding>
                <sk-dataset
                    sk-refresh-handler="ctrl.refreshHandler(request)" 
                    sk-dataset-created="ctrl.onDatasetCreated(dataset)" sk-standalone>
                        <sk-dsfield-md name="CAMPOSTR" description="Campo String"></sk-dsfield-md>
                        <sk-dsfield-md name="CAMPONUM" description="Campo Numerico" user-type="I"></sk-dsfield-md>
                        <sk-dsfield-md name="CAMPOSW" description="Campo Switch" presentation-type="S"></sk-dsfield-md>
                        <sk-dsfield-md name="CAMPOCOMBO" description="Campo Combo" group-name="Grupo">
                            <sk-options>
                                <sk-option data="A" label="Opcao A"></sk-option>
                                <sk-option data="B" label="Opcao B"></sk-option>
                                <sk-option data="C" label="Opcao C"></sk-option>
                            </sk-options>
                        </sk-dsfield-md>
                </sk-dataset>
                <sk-tab>
                    <sk-tab-item label="Form dataset override exclusive">
                        <sk-form sk-dataset="ctrl.myDS" columns="2" sk-only-custom>
                            <sk-form-custom-item sk-field-name="CAMPOSTR" sk-description="Aumenta ou diminui a temperatura do ar?">
                                <sk-switch sk-dataset="ctrl.myDS" sk-field-name="CAMPOSTR"></sk-switch>
                            </sk-form-custom-item>
                            <sk-form-custom-item sk-field-name="CAMPONUM" sk-description="{{ ctrl.getTemperaturaDoArDesc() }}" sk-visible="!ctrl.escondeuControle">
                                <sk-hbox align="start stretch" flex> 
                                    <sk-text-input sk-custom-item-input sk-dataset="ctrl.myDS" sk-field-name="CAMPONUM" sk-restrict="[^0-9]"></sk-text-input>
                                    <button default small ng-click="ctrl.aumentaDiminuiTemperatura()" style="padding-top:0;padding-bottom:0;padding-right:5px;padding-left:5px;margin-left:5px;font-size:10px;min-height:20px;height:20px;">
                                        <i class="icon-minus text-danger" aria-hidden="true" ng-style="ctrl.getGrayStateStyle('DOWN')"></i>
                                        <i class="icon-plus text-primary" aria-hidden="true" ng-style="ctrl.getGrayStateStyle('UP')"></i>
                                    </button>
                                </sk-hbox>
                            </sk-form-custom-item>
                        </sk-form>
                        <button default ng-click="ctrl.esconderControle()">{{ ctrl.escondeuControle ? 'Mostrar controle do ar' : 'Esconder controle do ar' }}</button>
                    </sk-tab-item>
                    <sk-tab-item label="Form dataset">
                        <sk-form sk-dataset="ctrl.myDS"></sk-form>
                    </sk-tab-item>
                    <sk-tab-item label="Form dataset override">
                        <sk-form sk-dataset="ctrl.myDS">
                            <sk-form-custom-item sk-field-name="CAMPOSTR">
                                <sk-combobox sk-dataset="ctrl.myDS" sk-field-name="CAMPOSTR" sk-options="ctrl.optionsCampoStr"></sk-combobox>
                            </sk-form-custom-item>
                            <sk-form-custom-item sk-field-name="CAMPONUM" sk-description="Número residencial"></sk-form-custom-item>
                        </sk-form>
                    </sk-tab-item>
                    <sk-tab-item label="Form properties">
                        <sk-form properties="ctrl.formProperties" columns="2" flex></sk-form>
                    </sk-tab-item>
                </sk-tab>
            </sk-application>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('ExampleController', ['$scope', function($scope){
                    var TEMPERATURA_DESC = 'Temperatura do AR ';
                    var self = this;

                    self.myDS;
                    self.escondeuControle = false;
                    self.getTemperaturaDoArDesc = getTemperaturaDoArDesc;
                    self.aumentaDiminuiTemperatura = aumentaDiminuiTemperatura;
                    self.getGrayStateStyle = getGrayStateStyle;
                    self.esconderControle = esconderControle;
                    self.onDatasetCreated = onDatasetCreated;
                    self.refreshHandler = refreshHandler;
                    self.optionsCampoStr = [
                        {data: 'Campo1', value: 'Campo 1'},
                        {data: 'Campo2', value: 'Campo 2'},
                        {data: 'Campo3', value: 'Campo 3'}
                    ];
                    self.formProperties = [
                        {
                            description: 'Razão Social',
                            fieldName: 'RAZAOSOCIAL',
                            value: 'Sankhya Tecnologia em Sistemas LTDA',
                            type: 'S',
                            required: true
                        },
                        {
                            description: 'Nome da Empresa',
                            fieldName: 'NOMEEMP',
                            value: 'Sankhya',
                            type: 'S'
                        },
                        {
                            description: 'Endereço',
                            fieldName: 'ENDERECO',
                            value: 'Av. Marcos de Freitas Costa',
                            type: 'S',
                            groupName: 'GrupoEndereco',
                            fieldProp: {}
                        }
                    ];

                    function getTemperaturaDoArDesc() {
                        var desc = TEMPERATURA_DESC;

                        if (self.myDS) {
                            desc += self.myDS.getFieldValueAsString('CAMPONUM') + '°';
                        }

                        return desc;
                    }

                    function aumentaDiminuiTemperatura() {
                        var tempAtual = self.myDS.getFieldValueAsNumber('CAMPONUM');

                        if (self.myDS.getFieldValueAsString('CAMPOSTR') == 'S') {
                            tempAtual++
                        } else {
                            tempAtual--;
                        }

                        self.myDS.setFieldValue('CAMPONUM', tempAtual);
                        console.log(tempAtual);
                    }

                    function refreshHandler(request) {
                        return [
                            ['Campo1', 1, 'S'],
                            ['Campo1', 2, 'N'],
                            ['Campo1', 3, 'S'],
                            ['Campo1', 4, 'N'],
                        ];
                    }

                    function onDatasetCreated(dataset) {
                        self.myDS = dataset;
                        self.myDS.addCriteriaProvider(new CriteriaProvider(Criteria('this.CODCID > 0')));
                        self.myDS.initializeDataSet().then(self.myDS.refresh);
                    }

                    function getGrayStateStyle(direction) {
                        if (direction == 'UP' && self.myDS && self.myDS.getFieldValueAsString('CAMPOSTR') != 'S') {
                            return {color: '#ddd'};
                        }

                        if (direction == 'DOWN' && self.myDS && self.myDS.getFieldValueAsString('CAMPOSTR') == 'S') {
                            return {color: '#ddd'};
                        }

                        return {};
                    }

                    function esconderControle() {
                        self.escondeuControle = !self.escondeuControle; 
                    }
                }]);
         </file>
     </example>
 */
angular
    .module('snk.components.form')
    .directive('skForm', [function(){
        return {
            restrict: 'E',
            transclude: {
                'formCustomBlock': '?skFormCustomBlock'
            },
            templateUrl: 'components/form/form.tpl.html',
            require: '^?skDynaform',
            scope: {
                properties: '=?',
                dataset: '=?skDataset',
                onFormLoaded: '&?skOnFormLoaded',
                fieldsOrder: '=?skFieldsOrder',
                requiredFields: '=?skRequiredFields',
                fieldInterceptor: '=skFieldInterceptor',
                model: '=',
                columns: '@',
                skColumns: '@skColumns',
                inline: '@skInline',
                allowRepeatedFields: '@skAllowRepeatedFields',
                formInterceptor: '=skFormInterceptor',
                onModelChange: '&?skModelChange',
                formConfigColumnKey: '@?skFormConfigColumnKey',
                onCreateField: '&?skOnCreateField',
                formColumnNumberConfig:'@?skFormColumnNumberConfig',
            },
            controller: 'SkFormController',
            controllerAs: 'ctrl',
            link: function(scope, element, attr, ctrl){
                if(ctrl && ctrl.getFormColConfig) {
                    scope.formConfigColumnKey = ctrl.getFormColConfig();
                }

                scope.preProcessFormColConfig();

                /*if (ctrl.isFormInline()) {
                    var formElem = angular.element(element[0].children[0]);
                    formElem.addClass('sk-form-flex');
                }*/
            }
        };
    }]);

/**
 * Created by bruno.brandao on 09/06/2015.
 */

angular
    .module('snk.components.form')
    .service('FormService', ['StringUtils', function (StringUtils) {

        var DEFAULT_DECIMAL_PRECISION = 2;

        this.MUTABLE_PROPERTIES = ['enabled', 'required', 'description', 'visible', 'nullable'];
        this.SCOPE_MUTABLE_PROPERTIES = ['precision', 'prettyPrecision'];;

        this.buildPropertyFromMD = buildPropertyFromMD;
        this.buildPropertiesFromMD = buildPropertiesFromMD;
        this.buildProperty = buildProperty;
        this.getInputInfo = getInputInfo;
        this.getUserType = getUserType;
        this.addDefaultFieldProps = addDefaultFieldProps;
        this.getResponsiveClass = getResponsiveClass; 

        function buildPropertiesFromMD(fieldsMD, fieldPropBuilder, acceptFieldFn, sortFields, interceptField) {
            var fields = [];

            for (var i = 0; i < fieldsMD.length; i++) {
                var fieldMD = fieldsMD[i];

                if (acceptFieldFn && !acceptFieldFn(fieldMD)) {
                    continue;
                }

                fields.push(buildPropertyFromMD(fieldMD, fieldPropBuilder, interceptField));
            }

            if (sortFields !== false) {
                fields.sort(function (fA, fB) {
                    return fA.order - fB.order;
                });
            }

            return fields;
        }

        function addDefaultFieldProps(fieldMD, fieldProp) {
            if (fieldMD.fk) {
                var resourceIDCadastro = fieldMD.fk.resourceIDCadastro;

                if (!resourceIDCadastro && fieldMD.properties) {
                    for (var i = 0; i < fieldMD.properties.length; i++) {
                        prop = fieldMD.properties[i];

                        if (prop.name == 'resourceIDCadastro') {
                            resourceIDCadastro = prop.value;
                        } else if(prop.name == 'filterSearchShowInactives'){
                            fieldMD.fk.showInactives = prop.value == 'S';
                        }
                    }
                }

                fieldProp['sk-target-field'] = fieldMD.fk.targetField;
                fieldProp['sk-resource-id-cadastro'] = resourceIDCadastro;
                fieldProp['sk-entity-name'] = fieldMD.fk.relationShipName;
                fieldProp['sk-form-criteria'] = fieldMD.fk.formCriteria;
                fieldProp['sk-dependent-fields'] = fieldMD.fk.dependentFields;
                fieldProp['sk-relation-ship-description'] = fieldMD.fk.relationShipDescription || fieldMD.fk.relationShipName;
                fieldProp['sk-somente-analitico'] = fieldMD.fk.hasOwnProperty('somenteAnalitico') ? fieldMD.fk.somenteAnalitico : false;
                fieldProp['sk-allow-show-hierarchical-mode'] = fieldMD.fk.isHierarchyEntity;

                var descriptionFieldName = fieldMD.fk.descriptionFieldName;

                if (descriptionFieldName) {
                    var dotIndex = descriptionFieldName.lastIndexOf('.');

                    if (dotIndex > -1) {
                        descriptionFieldName = descriptionFieldName.slice(dotIndex + 1, descriptionFieldName.length);
                    }
                }

                //fieldProp['sk-description-field-name'] = decodeURIComponent(escape(descriptionFieldName));
                fieldProp['sk-target-description-field-name'] = descriptionFieldName;
            }

            if (fieldMD.options && fieldMD.options.length > 0) {
                fieldProp['sk-options'] = angular.copy(fieldMD.options);
                fieldProp['sk-allow-null'] = fieldMD.isNullable;
            } else if (fieldMD.fk) {
                var options = {
                    entityName: fieldMD.fk.entity,
                    relationName: fieldMD.fk.relationShipName,
                    fieldName: fieldMD.fk.targetField,
                    showInactives: fieldMD.fk.showInactives == true
                };
                fieldProp['sk-options'] = options;
            }

            if (fieldMD.properties) {
                for (var i = 0; i < fieldMD.properties.length; i++) {
                    var prop = fieldMD.properties[i];

                    if (prop.name == 'mask') {
                        fieldProp['sk-mask'] = processMask(fieldMD.dataType, prop.value);
                        break;
                    }
                }
            }

            if (fieldMD.userType === 'B') {
                if (fieldMD.presentationType == 'A') {
                    fieldProp['sk-download-file'] = true;
                    fieldProp['sk-only-button'] = true;
                    fieldProp['sk-show-btn-cancel'] = true;
                }
            }

            if (fieldMD.userType === 'F') {

                var precision = fieldMD.precision;

                if(precision == null){
                    precision = DEFAULT_DECIMAL_PRECISION;
                }

                fieldProp['sk-precision'] = precision;

                if (fieldMD.hasOwnProperty('prettyPrecision')) {
                    fieldProp['sk-pretty-precision'] = fieldMD.prettyPrecision;
                }
            }

            fieldProp['sk-data-type'] = fieldMD.userType;
            fieldProp['sk-label'] = fieldMD.description;
        }

        function processMask(userType, maskBase) {
            var maskBaseArr = maskBase.split(".");
            maskBase = '';

            for (var i = 0; i < maskBaseArr.length; i++) {
                for (var x = 0; x < Number(maskBaseArr[i]); x++) {
                    maskBase += ((userType == 'F' || userType == 'I') ? '9' : 'A');
                }

                if (i < (maskBaseArr.length - 1)) {
                    maskBase += ".";
                }
            }

            return maskBase;
        }

        function buildPropertyFromMD(fieldMD, fieldPropBuilder, interceptField) {
            var groupName = '';

            if (fieldMD.properties) {
                for (var i = 0; i < fieldMD.properties.length; i++) {
                    var prop = fieldMD.properties[i];

                    if (prop.name == 'UIGroupName') {
                        groupName = prop.value;
                        break;
                    }
                }
            }

            var fieldProp = (fieldPropBuilder ? fieldPropBuilder(fieldMD) : {});

            addDefaultFieldProps(fieldMD, fieldProp);

            //checkSomenteAnalitco(fieldMD, fieldProp);

            fieldMD.fieldProp = fieldProp;
            fieldMD.userType = getUserType(fieldMD);

            var fieldProperty = buildProperty(fieldMD.name, fieldMD.description, fieldMD.userType, fieldMD.presentationType, fieldMD.required, !fieldMD.readOnly, groupName, fieldMD.checkbox, fieldMD.size, fieldMD.fieldProp, fieldMD.visible);

            fieldProperty.order = fieldMD.order;

            interceptField && interceptField(fieldProperty);

            return fieldProperty;
        }

        function getUserType(fieldMD) {

            if (fieldMD.fk && !(fieldMD.options && fieldMD.options.length > 0)) {
                return 'ENTITY';
            } else {
                var userType = fieldMD.userType;

                if (angular.isArray(fieldMD.properties)) {
                    for (var i = 0; i < fieldMD.properties.length; i++) {
                        var prop = fieldMD.properties[i];

                        if (prop.name == 'mask' && StringUtils.isNotEmpty(prop.value)) {
                            return 'MASKEDINPUT';
                        } else if (prop.name == 'UIType') {
                            return prop.value;
                        } else if (prop.name == 'useSelectDistinct' && StringUtils.toBoolean(prop.value)) {
                            return 'SELECTDISTINCT';
                        }
                    }
                }

                return userType;
            }
        }

        function buildProperty(fieldName, description, type, presentationType, required, enabled, groupName, isCheckbox, size, fieldProp, visible) {
            return {
                fieldName: fieldName,
                description: description,
                type: type,
                presentationType: presentationType,
                required: required,
                enabled: enabled,
                groupName: groupName,
                isCheckbox: isCheckbox,
                size: size,
                fieldProp: fieldProp,
                visible: angular.isDefined(visible) ? visible : true
            }
        }

        function getInputInfo(type, isCheckbox, presentationType, skOptions, size) {
            var inputName;
            var controllerName;

            var hasOptions = (skOptions && skOptions.length > 0);

            if (type != 'SELECTDISTINCT' && hasOptions) {
                if (isCheckbox) {
                    inputName = 'sk-switch';
                    controllerName = '$skSwitchController';
                } else if (type == 'CHECKLIST') {
                    inputName = 'sk-checkbox-list';
                    controllerName = '$skCheckboxListController';
                } else {
                    inputName = 'sk-combobox';
                    controllerName = '$skComboboxController';
                }

                return {
                    inputName: inputName,
                    controllerName: controllerName
                };
            }

            switch (type) {
                case 'I':
                case 'F':
                    inputName = 'sk-number-input';
                    controllerName = '$skNumberInputController';
                    break;
                case 'D':
                    inputName = 'sk-date-input';
                    controllerName = '$skDateInputController';
                    break;
                case 'T':
                    inputName = 'sk-time-input';
                    controllerName = '$skTimeInputController';
                    break;
                case 'H':
                    inputName = 'sk-date-time-input';
                    controllerName = '$skDateTimeInputController';
                    break;
                case 'C':
                    if (presentationType == 'H') {
                        inputName = 'sk-rich-text';
                        controllerName = '$skRichTextController';
                    } else {
                        inputName = 'sk-text-area';
                        controllerName = '$skTextAreaController';
                    }
                    break;
                case 'SELECTDISTINCT':
                    inputName = 'sk-select-distinct-input';
                    controllerName = '$skSelectDistinctInputController';
                    break;
                case 'MASKEDINPUT':
                    inputName = 'sk-masked-input';
                    controllerName = '$skMaskedInputController';
                    break;
                case 'ENTITY':
                    inputName = 'sk-pesquisa-input';
                    controllerName = '$skPesquisaInputController';
                    break;
                case 'ENTITYLIST':
                    inputName = 'sk-entity-list';
                    controllerName = '$skEntityListController';
                    break;
                case 'CGC_CPF':
                    inputName = 'sk-cgc-cpf-input';
                    controllerName = '$skCgcCpfInputController';
                    break;
                case 'CEP':
                    inputName = 'sk-cep-input';
                    controllerName = '$skCepInputController';
                    break;
                case 'Phone':
                    inputName = 'sk-phone-input';
                    controllerName = '$skPhoneInputController';
                    break;
                case 'DP':
                    inputName = 'sk-date-period-input';
                    controllerName = '$skDatePeriodInputController';
                    break;
                case 'ColorPicker':
                    inputName = 'sk-color-picker';
                    controllerName = '$skColorPickerController';
                    break;
                case 'B':
                    if (presentationType == 'I' || presentationType == 'P') {
                        inputName = 'sk-image-input';
                        controllerName = '$skImageInputController';
                    }else if (presentationType == 'A') {
                        inputName = 'sk-file-input';
                        controllerName = '$skFileInputController';
                    }else if (presentationType == 'M') {
                        inputName = 'sk-file-input-multi';
                        controllerName = '$skFileInputMultiController';
                    }
                    break;
                default:
                    if (isCheckbox || (type == 'S' && presentationType == 'S')) {
                        inputName = 'sk-switch';
                        controllerName = '$skSwitchController';
                    } else {
                        if (presentationType == 'O' || (skOptions && skOptions.length > 0)) {
                            inputName = 'sk-combobox';
                            controllerName = '$skComboboxController';
                        } else if (presentationType == 'F') {
                            inputName = 'sk-file-input';
                            controllerName = '$skFileInputController';
                        } else if (presentationType == 'H') {
                            inputName = 'sk-rich-text';
                            controllerName = '$skRichTextController';
                        } else if (size > 100) {
                            inputName = 'sk-text-area';
                            controllerName = '$skTextAreaController';
                        } else {
                            inputName = 'sk-text-input';
                            controllerName = '$skTextInputController';
                        }
                    }

                    break;
            }

            return {
                inputName: inputName,
                controllerName: controllerName
            };
        }

        function getResponsiveClass(columns) {
            var responsiveClass;

            if (angular.isDefined(columns)) {
                if (columns == 1) {
                    responsiveClass = 'col-xs-12 col-sm-12';
                } else if (columns == 2) {
                    responsiveClass = 'col-xs-12 col-sm-6';
                } else if (columns == 3) {
                    responsiveClass = 'col-xs-12 col-sm-6 col-md-4';
                } else if (columns == 6) {
                    responsiveClass = 'col-xs-12 col-sm-6 col-md-4 col-lg-2';
                }
            }

            if (angular.isUndefined(responsiveClass)) {
                responsiveClass = 'col-xs-12 col-sm-6 col-md-4 col-lg-3';
            }

            return responsiveClass;
        }
    }]); 

/**
 * Created by bruno.brandao on 29/02/2016.
 */
angular
    .module('snk.components.form')
    .controller('SkFormBlockController', ['$scope', function($scope){
        var self = this;

        $scope.getResourceId = getResourceId;

        self.getProperties = getProperties;
        self.creationComplete =  creationComplete;

        function creationComplete() {
            return $scope.creationComplete({block: self});
        }

        function getProperties() {
            return $scope.properties;
        }

        function getResourceId() {
            if ($scope.properties && $scope.properties.resourceId) {
                return $scope.properties.resourceId;
            } else {
                return $scope.properties.dynaform.getResourceId() + '.' + $scope.properties.entityName;
            }
        }
    }]);
/**
 * @ngdoc directive
 * @name snk.components.form.directive:sk-form-block
 * @restrict E
 * @scope
 * @description

 * @param {string} entityName Nome da entidade base que o dataset representará
 */
angular
    .module('snk.components.form')
    .directive('skFormBlock', ['AngularUtil', '$compile', '$controller', '$timeout', '$q', 'ObjectUtils', function (AngularUtil, $compile, $controller, $timeout, $q, ObjectUtils) {
        return {
            scope: {
                properties: '=skProperties',
                templateUrl: '@skTemplateUrl',
                template: '@skTemplate',
                controller: '@skController',
                controllerAs: '@skControllerAs',
                creationComplete: '&skCreationComplete',
                eventBus: '=skEventBus'
            },
            link: linker,
            controller: 'SkFormBlockController',
            restrict: 'E'
        };

        function linker(scope, element, attrs, controller) {
            initializeBlock();

            function getBlockTemplate() {
            	return $q(function(resolve) {
            		if (scope.templateUrl) {
            			resolve(AngularUtil.requestTemplate(scope.templateUrl));
            		} else if (scope.template) {
            			resolve(scope.template);
            		} else {
            			throw Error("FormBlock deve receber 'templateUrl' ou 'template'.");
            		}
            	});
            }

            function initializeBlock() {
            	getBlockTemplate()
                    .then(function(template){
                        if (angular.isUndefined(template)) {
                            throw Error('Template não definido para o bloco.');
                        } else if (angular.isString(template)) {
                            template = template.trim();
                        }

                        var blockCreatedDeferred;
                        var implController;

                        var contentScope = scope;

                        if (scope.controller) {
                            contentScope = scope.$new();

                            blockCreatedDeferred = $q.defer();

                            implController = $controller(scope.controller, {
                                $scope: contentScope,
                                $element: element,
                                BlockEventBus: scope.eventBus,
                                BlockProperties: scope.properties || {},
                                BlockCreationCompleted: blockCreatedDeferred.promise
                            });

                            if (scope.controllerAs) {
                                contentScope[scope.controllerAs] = implController;
                            }

                            AngularUtil.setContextControllerInfo(element, scope.controller, scope.controllerAs, implController);
                        }

                        var content = angular.element(template);
                        element.append(content);

                        $compile(content)(contentScope);

                        $timeout(function(){
                            var creationValue = controller.creationComplete();

                            $q.when(creationValue, function(value) {
                                blockCreatedDeferred && blockCreatedDeferred.resolve(value);

                                var onCreated = ObjectUtils.getProperty(scope, 'properties.onCreated');

                                if (angular.isFunction(onCreated)) {
                                    onCreated(implController);
                                }
                            });
                        }, 0, false);
                    });
            }
        }
    }]);
/**
 * @ngdoc directive
 * @name snk.form.directive:sk-form-custom-item
 * @restrict E
 * @scope
 * @description
    Esse componente deve ser utilizado apenas como filho do sk-form. 
    <br>
    A sua documentação de uso pode ser visualizada {@link snk.form.directive:sk-form clicando aqui}.
 * @param {String} [sk-field-name] Essa propriedade define o nome do campo que ele representa no dataset para 
 * buscar descrição ou até mesmo os metadados do campo a ser renderizado (dataset informado no form).
 * 
 * @param {String} [sk-description] Expressão envolvida em {{ }} para ser avaliada e retornar uma descrição 
 * para o campo, também poderá ser informado a string direta.
 * 
 * @param {boolean} [sk-visible] Define se será ou não exibido o container do form-item que contenha o label e 
 * o campo do mesmo.
 * 
 * @param {boolean} [sk-enabled] Define se o input será editável ou não.
 *
 * @param {String} [sk-group] Define se o groupName do campo.
 *
 * @param {attribute} [sk-custom-item-input] Quando se customiza essa diretiva com box, div, ou qualquer outro 
 * elemento envolvendo o campo que faz bind com o dataset, você deverá colocar esse atributo 
 * no campo que faz bind com o dataset, por exemplo sk-combobox. <b class="text-danger">Esse atributo é válido apenas em elementos filhos dessa diretiva.</b>
 */
angular
    .module('snk.components.form')
    .directive('skFormCustomItem', ['i18n', '$parse', 'DomUtil', function(i18n, $parse, DomUtil) {
        return {
            restrict: 'E',
            require: '^?skForm',
            compile: function(tElement, tAttr) {
                var tComponent = tElement.children()[0];
                
                if (tComponent) {
                	var tInputElem = DomUtil.select(tComponent, '[sk-custom-item-input]');

                    if (!tInputElem || tInputElem == tComponent) {
                        tComponent = angular.element(tComponent);
                        tComponent.detach();
                        tComponent.attr('sk-custom-item-input', '');

                        var gambiContainer = angular.element('<div flex></div>');
                        gambiContainer.append(tComponent);

                        tElement.append(gambiContainer);
                    }
                }

                return function(scope, element, attr, formController) {
                    var fieldName = attr.skFieldName;
                    var description = attr.skDescription;
                    var forceSimpleLabel = attr.hasOwnProperty('skSimpleLabel');

                    if (!fieldName) {
                        throw Error('sk-form-custom-item deve possuir fieldName');
                    }

                    var component = element.children()[0];

                    if (component) {
                        component = angular.element(component);
                        component.detach();
                    }

                    var formItemMD = {
                        fieldName: fieldName,
                        description: i18n(description),
                        inputElem: component,
                        visible: true,
                        forceSimpleLabel: forceSimpleLabel,
                        helperTooltip: false
                    };

                    if (attr.skVisible) {
                        scope.$watch(attr.skVisible, function(newValue) {
                            if (formItemMD.visible != newValue) {
                                formItemMD.visible = newValue;
                            }
                        });
                    }

                    if (attr.skEnabled) {
                        formItemMD.enabled = true;

                        scope.$watch(attr.skEnabled, function(newValue) {
                            if (formItemMD.enabled != newValue) {
                                formItemMD.enabled = newValue;
                            }
                        });
                    }

                    if(attr.required){
                        formItemMD.required = true;

                        scope.$watch(attr.required, function(newValue) {
                            if (formItemMD.required != newValue) {
                                formItemMD.required = newValue;
                            }
                        });
                    }

                    if (attr.skIsRichText) {
                        formItemMD.isRichText = false;

                        scope.$watch(attr.skIsRichText, function(newValue) {
                            if (formItemMD.isRichText != newValue) {
                                formItemMD.isRichText = newValue;
                            }
                        });
                    }

                    if (attr.popUpEditEnabled) {
                        formItemMD.popUpEditEnabled = true;

                        scope.$watch(attr.popUpEditEnabled, function(newValue) {
                            if (formItemMD.popUpEditEnabled != newValue) {
                                formItemMD.popUpEditEnabled = newValue;
                            }
                        });
                    }

                    if (attr.skHideButtons) {
                        formItemMD.hideButtons = false;

                        scope.$watch(attr.skHideButtons, function(newValue) {
                            if (formItemMD.hideButtons != newValue) {
                                formItemMD.hideButtons = newValue;
                            }
                        });
                    }

                    if (attr.skGroup) {
                        formItemMD.groupName = i18n(attr.skGroup);
                    }

                    if (attr.skHelperTooltip) {
                        formItemMD.helperTooltip = i18n(attr.skHelperTooltip);
                    }

                    formController = formController != null ? formController : element['data']("$controllerInstanceController");
                    
                    formController.addCustomFormItem(formItemMD);

                    attr.$observe('skDescription', function(newValue) {
                        if (description != newValue) {
                            description = newValue;
                            formController.getCustomFormItem(fieldName).description = i18n(description);
                        }
                    });

                    //element.detach();
                }
            }
        };
    }]);

angular
    .module('snk.components.form')
    .directive('skFormItem', SkFormItemDirective);

SkFormItemDirective.$inject = ['StringUtils', 'AngularUtil', '$timeout', 'FormService', 'ObjectUtils', 'DomUtil', '$compile', 'DateUtils', 'DateUtilsConstants', '$q', 'i18n'];

function SkFormItemDirective(StringUtils, AngularUtil, $timeout, FormService, ObjectUtils, DomUtil, $compile, DateUtils, DateUtilsConstants, $q, i18n) {
    var propertiesName = ["description", "fieldName", "value", "type", "required", "saveLastValue", "groupName", "fieldProp", "visible", "enabled"];

    var stringProps = {
        'sk-entity-name': undefined,
        'sk-disable-on-insertion': undefined,
        'sk-file-key': undefined,
        'sk-key': undefined,
        'sk-label': undefined,
        'sk-opt-key': undefined,
        'sk-opt-label': undefined,
        'sk-resource-id-cadastro': undefined,
        'sk-form-criteria': undefined,
        'sk-target-field': undefined,
        'sk-description-field-name': undefined,
        'sk-target-description-field-name': undefined,
        'sk-relation-ship-description': undefined,
        'sk-mask': undefined,
        'sk-align': undefined,
        'sk-restrict': undefined,
        'sk-local-entity-name': undefined
    };

    var contextFunctionProps = {
        'sk-enviroment-criteria': undefined
    };

    var oneLineComponents = {
        'sk-text-area': undefined,
        'sk-image-input': undefined,
        'sk-checkbox-list': undefined,
        'sk-entity-list': undefined,
        'sk-rich-text': undefined
    };

    var PX = 'px';

    return {
        restrict: 'E',
        require: '^skForm',
        replace: false,
        templateUrl: 'components/form/formitem/formitem.tpl.html',
        scope: {
            properties: '=',
            formInterceptor: '=skFormInterceptor',
            model: '='
        },
        link: { pre: postLink }
    };

    function isFieldCustom(scope) {
    	var _currentDs = undefined;
    	if(scope.properties.fieldProp){
	    	if(scope.properties.fieldProp['sk-dataset']){
	    		_currentDs = scope.properties.fieldProp['sk-dataset'];
	    	}
    	}
        if (_currentDs && _currentDs.isStandAlone()) {
            return false;
        }

        const _customPrefix = "AD_";
        if (StringUtils.undefinedAsEmpty(scope.properties.fieldName).startsWith(_customPrefix)) {
            return true;
        }

        if (_currentDs) {
            const _parentEntityName = StringUtils.undefinedAsEmpty(_currentDs.getParentEntityName());
            if (StringUtils.isEmpty(_parentEntityName) || _parentEntityName.startsWith(_customPrefix)) {
                return false;
            }

            return StringUtils.undefinedAsEmpty(_currentDs.getEntityName()).startsWith(_customPrefix);
        }

        return false;
    }

    function postLink(scope, element, attr, formController) {
        scope.labelWidth = 'auto';
        scope.inputValue = undefined;
        scope.uid = StringUtils.nextUid();
        scope.formItemChangeValueHandler = formItemChangeValueHandler;

        scope.propagateValueToModel = false;

        setClass(scope, element);

        var labelContainer = angular.element(element).find('label');

        var fieldName = scope.properties.fieldName;

        var customFormItem = formController.getCustomFormItem(fieldName);

        scope.helperTooltip = ObjectUtils.getProperty(customFormItem, 'helperTooltip');

        scope.$watch('properties.required', function (required) {
            scope.styleTooltip = required ? '3px' : '-12px';
        });

        var fieldProp = {
            'id': 'form-item-' + scope.uid,
            'sk-field-name': fieldName,
            'sk-required': 'properties.required',
            'sk-enabled': 'properties.enabled',
            'sk-change': 'formItemChangeValueHandler(codeValue, value)',
            'sk-size': 'properties.size'
        };

        if (scope.model) {
            let fieldList = [];
            let modelAux = 'model';

            if (!ObjectUtils.getProperty(scope.model, fieldName)) {
                ObjectUtils.setProperty(scope.model, fieldName, '');
            }

            fieldList = fieldName.split('.');
            fieldList.forEach(nameAux => modelAux += '["' + nameAux + '"]');
            fieldProp['sk-value'] = modelAux;
        } else if (scope.properties.hasOwnProperty('value')) {
            fieldProp['sk-value'] = 'properties.value';
        }

        if (scope.properties.hasOwnProperty('fieldProp')) {
            angular.forEach(scope.properties.fieldProp, function (value, key) {
                if (stringProps.hasOwnProperty(key)) {
                    fieldProp[key] = value;
                } else {
                    var normalizedName = attr.$normalize(key);

                    scope[normalizedName] = value;

                    if (contextFunctionProps.hasOwnProperty(key)) {
                        normalizedName += (contextFunctionProps[key] || '()');
                    }

                    fieldProp[key] = normalizedName;
                }
            });
        }

        var inputInfo = FormService.getInputInfo(scope.properties.type, scope.properties.isCheckbox, scope.properties.presentationType,
            scope.skOptions, scope.properties.size);

        var inputName = inputInfo.inputName;
        var controllerName = inputInfo.controllerName;

        if (angular.isDefined(scope.properties.visible)) {
            scope.$watch('properties.visible', function (visible) {
                var parentElem = element.parent();
                var elementToHide;
                let display = visible ? 'block' : 'none';

                if (parentElem.hasClass('ungroup-fields')) {
                    elementToHide = parentElem;
                } else if (parentElem.hasClass('ungroup-fields-account')) {
                    elementToHide = parentElem;
                    display = visible ? 'table' : 'none';
                } else {
                    elementToHide = element;
                }

                elementToHide.css('display', display);
            });
        }

        if (customFormItem && customFormItem.description) {
            scope.description = customFormItem.description;
            scope.$watch(function () {
                return customFormItem.description;
            }, function (newV) {
                updateDescription(newV);
            });
        } else {
            scope.$watch('properties.description', function (newV) {
                updateDescription(newV);
            });

            updateDescription(scope.properties.description);
        }

        if (customFormItem && customFormItem.hasOwnProperty('enabled')) {
            scope.$watch(function () {
                return customFormItem.enabled;
            }, function (newV) {
                scope.properties.enabled = newV;
            });
        }

        var labelElem;
        var inputContainer;
        var inputElem;

        var elmCreatedByUser = false;

        if (scope.formInterceptor || customFormItem) {
            var userInputElem;

            if (customFormItem) {
                userInputElem = customFormItem.inputElem;
            } else {
                userInputElem = scope.formInterceptor.interceptBuildField(scope.properties.fieldName, scope.properties.fieldProp['sk-dataset'], fieldProp, scope);
            }

            if (angular.isElement(userInputElem)) {
                if (!userInputElem.length > 0) {
                    throw new Error("Elemento inválido para o campo '" + fieldName + "'.");
                }

                if (customFormItem) {
                    var customItemInput = DomUtil.select(userInputElem, '[sk-custom-item-input]');

                    if (customItemInput) {
                        inputContainer = angular.element(userInputElem);
                        userInputElem = angular.element(customItemInput);
                    }
                }

                inputElem = userInputElem;
            }

            if (inputElem) {
                inputName = inputElem.prop('tagName').toLowerCase();
                elmCreatedByUser = true;
            }
        }

        var forceSimpleLabel = (customFormItem && customFormItem.forceSimpleLabel == true);

        if (inputName == 'sk-pesquisa-input' && !forceSimpleLabel) {
            try{
				let skEntityName = !fieldProp['sk-entity-name'] ? scope.properties.fieldProp['sk-dataset'].getEntityName() : fieldProp['sk-entity-name'];
				fieldProp['sk-entity-name'] = skEntityName;
			} catch (err){
				fieldProp['sk-entity-name'] = undefined;
			}
            if (!fieldProp['sk-entity-name']) {
				throw new Error('O campo ' + fieldName + ' foi definido como pesquisa, porém não possui um nome de entidade');           
            }

            var pkFieldName;

            if (fieldProp['sk-target-field']) {
                pkFieldName = fieldProp['sk-target-field'];
            } else {
                pkFieldName = scope.properties.fieldName;
            }

            labelElem = AngularUtil.createDirective('sk-entity-card-link', {
                'sk-entity-name': fieldProp['sk-entity-name'],
                'sk-pk-field-name': pkFieldName,
                'sk-label': 'description',
                'sk-value': 'inputValue',
                'sk-criteria-builder': 'entityLinkCriteriaBuilder',
                'sk-target-resource-id': (fieldProp["sk-resource-id-cadastro"]) ? fieldProp["sk-resource-id-cadastro"] : undefined
            }, scope);

            scope.propagateValueToModel = true;

            angular.element(labelContainer).append(labelElem);
        }else if (inputName == 'sk-text-area') {
            var isRichText = false;
            var enabled = scope.properties.enabled;

            if (customFormItem) {
                if (angular.isDefined(customFormItem.isRichText)) {
                    isRichText = customFormItem.isRichText;
                }
                if (angular.isDefined(customFormItem.enabled)) {
                    enabled = customFormItem.enabled;
                }
            }

            scope.currentDs = null;
            scope.currentFieldName = null;

            if(scope.properties.fieldProp['sk-dataset']) {
                scope.currentDs = scope.properties.fieldProp['sk-dataset'];
                scope.currentFieldName = scope.properties.fieldName;
            }

            labelElem = AngularUtil.createDirective('sk-text-area-link', {
                'sk-label': 'description',
                'sk-value': 'inputValue',
                'sk-dataset': 'currentDs',
                'sk-field-name': 'currentFieldName',
                'sk-enabled': enabled,
                'sk-is-rich-text': isRichText 
            }, scope);

            fieldProp['sk-value'] = 'inputValue';

            scope.propagateValueToModel = true;

            angular.element(labelContainer).append(labelElem);
        } else if (inputName == 'sk-rich-text') {
            var isRichText = true;
            var popUpEditEnabled = false;

            if (customFormItem) {
                if (angular.isDefined(customFormItem.isRichText)) {
                    isRichText = customFormItem.isRichText;
                }
                if (angular.isDefined(customFormItem.popUpEditEnabled)) {
                    popUpEditEnabled = customFormItem.popUpEditEnabled;
                }
                if (angular.isDefined(customFormItem.hideButtons)) {
                    fieldProp['sk-hide-buttons'] = customFormItem.hideButtons;
                }
            }
            if( angular.isUndefined(fieldProp['sk-link-enabled']) || fieldProp['sk-link-enabled'] == true){
                labelElem = AngularUtil.createDirective('sk-rich-text-link', {
                    'sk-label': 'description',
                    'sk-value': 'inputValue',
                    'sk-enabled': 'properties.enabled',
                    'sk-is-rich-text': isRichText,
                    'sk-pop-up-edit-enabled' : popUpEditEnabled,
                    
                }, scope);
            }else{                
        	    labelElem = AngularUtil.createDirective('span', {'ng-bind': 'description'},scope);
            }
            
            fieldProp['sk-value'] = 'inputValue';

            scope.propagateValueToModel = true;

            angular.element(labelContainer).append(labelElem);
        } else if (inputName == 'sk-checkbox-list' && (!scope.properties.hasOwnProperty('forceRequiredList') || scope.properties.forceRequiredList === false)) {
            labelContainer.remove();
        } else { 

            if(inputName == "sk-date-period-input") {
                delete fieldProp["sk-change"];
                fieldProp["sk-focus-out"] = 'formItemChangeValueHandler(codeValue, value)';
            }
            
        	labelElem = AngularUtil.createDirective('span', {'ng-bind': 'description'},scope);
        	
        	if (!scope.properties.hasOwnProperty('forceRequiredList') || scope.properties.forceRequiredList === false) {
            	angular.element(labelContainer).append(labelElem);
        	}
        }

        if (labelElem) {
            labelElem.attr('title', scope.description);
        }

        if(customFormItem && customFormItem.hasOwnProperty('required')){
            scope.properties.required = customFormItem.required;
        }

        var requiredIcon = AngularUtil.createDirective('span', { 'class': 'required', 'sk-visible': 'properties.required' }, scope);
        requiredIcon.html('*');
        angular.element(labelContainer).append(requiredIcon);

        if (!inputElem) {
            inputElem = AngularUtil.createDirective(inputName, fieldProp, scope);
        }

        inputElem.addClass('sk-form-item-input');

        // Add the custom item class to the element
        if(isFieldCustom(scope)){
            inputElem.addClass('sk-form-item-custom-input');
        }

        if (oneLineComponents.hasOwnProperty(inputName)) {
            element.css('width', '100%');
            element.parent().css('width', '100%');
        }

        if (!inputContainer) {
            inputContainer = scope.formInterceptor && scope.formInterceptor.buildFieldContainer(scope.properties.fieldName, scope.properties.fieldProp['sk-dataset'], inputElem, scope, labelElem);
        }
        
        if (isFieldCustom(scope)) {
            if(inputName == 'sk-text-area'){
                (inputContainer || inputElem).css('flexBasis', '80%');
            }

            if (inputName == 'sk-combobox') {
                (inputContainer || inputElem).css('flexBasis', '100%');
            }

            var hBoxElem = AngularUtil.createDirective('sk-hbox', {
                'layout-align': 'start center',
                'style': 'width: 100%;',
                'gap': '5',
                'flex': ''
            }, scope)[0];
        
            scope.getProperties = function () {
                var deferred = $q.defer();
        
                deferred.resolve({ data: i18n('Form.customField') });

                return deferred.promise;
            };
            
            var infoIcon = AngularUtil.createDirective('div', {
                'sk-popover': '',
                'popover-template-url': 'infopersonalizado.html',
                'popover-placement': 'right',
                'tooltip-append-to-body': 'true',
                'hide-on':'mouseleave',
                'show-triangle':'false',
                'properties': 'getProperties',
                'width': 'auto',
                'height': 'auto',
                'sk-width': '20px',
                'sk-height': '20px'
            }, scope)[0];
        
            infoIcon.append(AngularUtil.createDirective('sk-icon', {
                'font-icon': 'circle-info',
                'v': '2',
                'class': 'sk-form-item-custom-icon'
            }, scope)[0]);
        
            hBoxElem.append((inputContainer || inputElem)[0]);
            hBoxElem.append(infoIcon);
        
            angular.element(element.children()[0]).append(hBoxElem);
        } else {
            angular.element(element.children()[0]).append(inputContainer || inputElem);
        }

        $timeout(function () {
            var controller = elmCreatedByUser ? AngularUtil.getControllerFromElement(inputElem) : inputElem.data(controllerName);

            if (!controller) {
                if (elmCreatedByUser) {
                    console.error('Não foi possível obter o controlador de um componente de input do dataset. [' + fieldName + ']');
                    return;
                } else {
                    console.error('Não foi possível obter o controlador de um campo. [' + controllerName + ',' + inputName + ']');
                    return;
                }
            }

            scope.formInterceptor && scope.formInterceptor.interceptFieldElement(scope.properties.fieldName, inputElem, controller);

            formController.registryField(scope.properties.fieldName, element, inputElem, controller, scope);
        }, 0, false);

        function formItemChangeValueHandler(codeValue, value) {
            var isPesquisa = inputElem[0].tagName == 'SK-PESQUISA-INPUT';

            if (value) {
                value = adjustTimeOnFinalDate(value);
            }

            scope.inputValue = isPesquisa ? codeValue : value;

            if (scope.propagateValueToModel) {
                if (scope.model) {
                    var fieldName = 'model["'+scope.properties.fieldName+'"]';
                    ObjectUtils.setProperty(scope.model, fieldName, scope.inputValue);
                } else if (scope.properties.hasOwnProperty('value')) {
                    ObjectUtils.setProperty(scope.properties, 'value', scope.inputValue);
                }
            }

            AngularUtil.digest(scope);
        }

        function updateDescription(newDescription) {
            scope.description = newDescription;

            if (labelElem) {
                labelElem.attr('title', scope.description);
            }

            if (formController.isFormInline()) {
                scope.description += ':';
            }
        }
    }

    function setClass(scope, element) {
        element.addClass('sk-form-item');
    }

    function adjustTimeOnFinalDate(value) {
        if (!value.dtFin) {
            return value;
        }

        var dtFin = DateUtils.dateToString(value.dtFin, DateUtilsConstants.DEFAULT_DATE_US_FORMAT);
        value.dtFin = DateUtils.setTime(dtFin, "23:59").toDate();
        return value;
    }

}

/**
 * @ngdoc interface
 * @name snk.components.form.interfaces:IFormInterceptor
 * @description Interface utilizada para interceptar os componentes Form e FormItem
 * As funções são chamadas na ordem disposta aqui nesta documentação.
 */
function IFormInterceptor() {}

/**
 * @ngdoc
 * @name snk.components.form.interfaces:IFormInterceptor#acceptField
 * @methodOf snk.components.form.interfaces:IFormInterceptor
 * @description Função chamada para definir se o campo será ou não adicionado ao Form
 * @param {object} fieldMetadata Metadados do campo.
 * @param {object} dataset Instância do dataset.
 */
IFormInterceptor.prototype.acceptField = function (fieldMetadata, dataset) {
    return true;
};

/**
 * @ngdoc
 * @name snk.components.form.interfaces:IFormInterceptor#interceptField
 * @methodOf snk.components.form.interfaces:IFormInterceptor
 * @description Função chamada para interceptar os metadados do campo no formulário.
 * @param {object} fieldMetadata Metadados do campo.
 * @param {object} dataset Instância do dataset.
 */
IFormInterceptor.prototype.interceptField = function (fieldMetadata, dataset) {

};

/**
 * @ngdoc
 * @name snk.components.form.interfaces:IFormInterceptor#interceptBuildField
 * @methodOf snk.components.form.interfaces:IFormInterceptor
 * @description Função chamada para interceptar o componente visual ANTES da sua criação.
 * @param {string} fieldName Nome do Campo.
 * @param {object} dataset Instância do Dataset.
 * @param {object} fieldProp Propriedades originais do campo.
 * @param {object} scope Escopo que seria utilizado para a compilação do template.
 * @returns {element|object} retorna um elemento compilado ou um objeto no seguinte formato: {input: input, container: container}
 */
IFormInterceptor.prototype.interceptBuildField = function (fieldName, dataset, fieldProp, scope) {

};

/**
 * @ngdoc
 * @name snk.components.form.interfaces:IFormInterceptor#buildFieldContainer
 * @methodOf snk.components.form.interfaces:IFormInterceptor
 * @description Função chamada para interceptar o componente visual e permitir que seja alterado o container do mesmo
 *              Para por exemplo criar um hbox, e colocar o campo dentro, com alguma outra coisa junto.
 * @param {string} fieldName Nome do Campo.
 * @param {object} dataset Instância do Dataset.
 * @param {object} fieldElem Element do campo.
 * @param {object} scope Escopo para a compilação do template, caso necessário.
 * @param {object} labelElem Element do form
 * @returns {element} retorna o elemento compilado que será incluido no formulário
 */
IFormInterceptor.prototype.buildFieldContainer = function (fieldName, dataset, fieldElem, scope, labelElem) {

};

/**
 * @ngdoc
 * @name snk.components.form.interfaces:IFormInterceptor#interceptFieldElement
 * @methodOf snk.components.form.interfaces:IFormInterceptor
 * @description Função chamada para interceptar o componente visual já criado no formulário.
 * @param {string} fieldName Nome do campo
 * @param {object} element Element do campo.
 * @param {function} controller Controlador do campo.
 */
IFormInterceptor.prototype.interceptFieldElement = function (fieldName, element, controller) {

};
angular
    .module('snk.components.formconfig')
    .controller("SkFormconfigController", ['$scope', '$document', 'AngularUtil', '$timeout', 'DateUtils', 'SkApplicationInstance', 'ServiceProxy', '$q', 'i18n', 'SanPopup', 'MGEAuthorizationConstants',
        function ($scope, $document, AngularUtil, $timeout, DateUtils, SkApplicationInstance, ServiceProxy, $q, i18n, SanPopup, MGEAuthorizationConstants) {
            var self = this;

            const LOAD_CONFIG = "mge@FormConfig.getFormConfig";		    

            let _form;
            let _configuration;
            
            $scope.isConfAvailable = false;
            $scope.allowFormCfg = !SkApplicationInstance.authIsLoadded() || SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG_FORM);

            self.whenConfigLoaded = whenConfigLoaded;
            self.openPopUpConfig = openPopUpConfig;
            self.setConfig = setConfig;

            $timeout(init);

            function init(){

                if(!$scope.configName){
                    throw new Error("[SkFormconfigController] é necessário informar o atributo sk-config-name.");
                }

                _form = skUid($scope.targetFormId);
                
                $scope.configName = "FormCfg:" + $scope.configName;

                if(!_form){
                    let formEl = $document.find($scope.targetFormId);
                    
                    if(formEl){
                        _form = AngularUtil.getControllerFromElement(formEl);
                    }
                }

                if(_form){
                    _form.formConfig = self;
                    loadConfiguration();
                }else{
                    let message = "[SkFormconfigController] target-form não econtrado.";
                    
                    if(!$scope.targetFormId){
                        message += "<br><b>*Informe um sk-target-form-id.</b></br>";
                    }else{
                        message += "<br><b>*Verifique se existe um sk-configurable-form com o sk-uid='" + $scope.targetFormId + "' informado.</b></br>";
                    }
                    
                    throw new Error(message);
                }                

            }

            function loadConfiguration() {
               
               let formConfigObj = SkApplicationInstance.getConfiguracaoTela($scope.configName);
               
               if (formConfigObj) {
                   loadConfig(formConfigObj);
               } else {
                    formConfigObj = {
                        formConfig: {
                            configName: $scope.configName
                        }
                    }
                   
                   if($scope.configNameFallback) {
                        formConfigObj.formConfig.configNameFallback = "FormCfg:" + $scope.configNameFallback;
                   }
                   
                   if($scope.isVariacao != undefined) {
                	   formConfigObj.formConfig.isVariacao = $scope.isVariacao; 
                   }
                   
                   if($scope.validDateTime){
                	   formConfigObj.formConfig.validDateTime = DateUtils.formatDate($scope.configValidDateTime, "DD/MM/YYYY HH:MM:SS");
                   }
                   
                   ServiceProxy.callService(LOAD_CONFIG, formConfigObj).then(function(response) {
                        loadConfig(response.responseBody.formConfig);
                    }, function(){
                        loadConfig({});
                    });                  
               }
            }


            function loadConfig(config){
                $scope.isConfAvailable = true;
                _configuration = config;
                if (Object.keys(config).length > 0) {
                	_form.setConfig(config, $scope.forceRebuild === true);
                } else {
                    _form.setConfig(undefined);
                }
             }

             function setConfig(conf){
                 _configuration = conf;
             }
            
             function whenConfigLoaded() {
                return $q(function (resolve, reject) {
                    if ($scope.isConfAvailable) {
                        resolve();
                    } else {
                        let removewatch = $scope.$watch('isConfAvailable', function(newV){
                            if(newV == true){
                                removewatch();
                                resolve();
                            }
                        });
                    }
                });
            }

            function openPopUpConfig(){
                SanPopup.open({
                    title: i18n('FormConfig.lblCfgForm'),
                    templateUrl: 'components/formconfig/popupconfig/popupconfigform.tpl.html',
                    controller: 'PopUpConfigFormController',
                    controllerAs: 'ctrl',
                    enableBtnOk: true,
                    bodyPadding: true,
                    showBtnNo: true,
                    okBtnLabel: i18n('GridConfig.restaurarPadrao'),
                    noBtnLabel: i18n('Geral.lblSalvar'),
                    okBtnClass: 'btn-default',
                    noBtnClass: 'btn-primary',
                    cancelBtnClass: 'btn-default',
                    showBtnCancel: true,
                    size: 'lg',
                    resolve: {
                        data : function(){
                            return{
                                    configureFields: $scope.configureFields,
                                    targetForm: _form,
                                    configuration: _configuration,
                                    configName: $scope.configName,
                                    isVariation: $scope.isVariation,
                                    configNameFallback: $scope.configNameFallback,
                                    callBackConfigSaved: $scope.callBackConfigSaved,
                                    availableColumnsStandard: $scope.availableColumnsStandard,
                                    configureDefaultValue: $scope.configureDefaultValue
                                }
                        }
                    }
                });
            }
        }]);

angular
    .module('snk.components.configurableform')
    .directive('skFormConfig',[function() {
        var directive = {};

        directive.restrict = 'E';
        directive.templateUrl = 'components/formconfig/formconfig.tpl.html';
        directive.controller = 'SkFormconfigController';
        directive.controllerAs = 'ctrl';
        directive.scope = {
            targetFormId: '@skTargetFormId',
            configName: "@skConfigName",
            configNameFallback: "=?skConfigNameFallback",
            configValidDateTime: "=?skConfigValidDateTime",
            isVariation: "=?skIsVariation",
            configureFields: "=?skConfigureFields",
            forceRebuild: "=?skForceRebuild",
            callBackConfigSaved: "=?skCallbackConfigSaved",
            availableColumnsStandard: '=?skAvailableColumnsStandard',
            configureDefaultValue: '=?skConfigureDefaultValue'
        };

        return directive;
    }]);
angular
    .module('snk.components.formconfig')
    .controller("PopUpConfigFormController", ['$scope', '$popupInstance', 'data', 'StringUtils', 'ServiceProxy', 'ArrayUtils', 'i18n',
        function ($scope, $popupInstance, data, StringUtils, ServiceProxy, ArrayUtils, i18n) {
            var self = this;

            const SAVE_CONFIG = "mge@FormConfig.saveFormConfig";
            const RESTORE_CONFIG = "mge@FormConfig.restoreFormConfig";
            const  _camposBusca = ["userDescription", "description"];

            let _loaded = false;
            let _allFields;
            let _lastSelectedList = '';
            
            self.configureDefaultValue = data.configureDefaultValue ? data.configureDefaultValue : false;
            
            self.comboTipoValorPadrao = 'literal';
            self.dpTipoVlrPadrao = [
                { data: 'literal', value: i18n('Geral.optLiberal') },
                { data: 'variavel', value: i18n('Geral.optVariaveis') }
            ];
            
            self.dpComboOptions = [];
            self.dpComboVariaveis = [
                { data: 'data', value: i18n('Geral.dataAtual') },
                { data: 'datahora', value: i18n('Geral.dataHoraAtuais') },
                { data: 'usuario', value: i18n('Geral.codUsuLogado') },
                { data: 'usuario.logado.codparc', value: i18n('Geral.parceiroUsuLogado') },
                { data: 'usuario.empresa', value: i18n('Geral.empresaUsuLogado') },
                { data: 'usuario.vendedor', value: i18n('Geral.vendedorUsuLogado') },
                { data: 'usuario.centroresultado', value: i18n('Geral.centroResultadoUsuLoagdo') }
            ];

            self.textValorPadrao;
            self.comboOptions;
            self.comboVariaveis;
            self.textValorPadraoVisibled = true;
            self.comboOptionsVisibled = false;
            self.comboVariaveisVisibled = false;

            self.selecionaUIExpressao = selecionaUIExpressao;

            var _dpOpcoesCampo;
            var _isOptionValue = false;
            
            self.availableFields = new ArrayList();
            self.selectedFields = new ArrayList();
            self.filterFn = filterFn;
            self.onSelectionChanged = onSelectionChanged;
            self.selectedField;
            self.isEditItemEnable = isEditItemEnable;
            self.onEditItem = onEditItem;
            self.hasChangedByProgramer = hasChangedByProgramer;
            self.distinctGroups = [];
            
            $popupInstance.result.then(restore, function (reason) {
                if (reason == 'no') {//save
                    saveConfig();
                }
                else if (reason == 'cancel') {

                }
            });

            $popupInstance.rendered.then(buildFormConfig);
            

            function buildFormConfig(){
                self.configureFields = data.configureFields;

                if(!_loaded){
                    setupArrayFields();
                    _loaded = true;
                }

                const mapDiffGrpups = {};

                self.distinctGroups = [];

                for (var prop in _allFields){
                    let field = _allFields[prop];
                    if(field.groupName && !mapDiffGrpups.hasOwnProperty(field.groupName) && !isInvisible(field.fieldName)){
                        self.distinctGroups.push({
                            label: field.groupName
                        });

                        mapDiffGrpups[field.groupName] = true;
                    }
                }
            }
            
            function setupArrayFields(){
                let hasConfig = data.configuration != null && data.configuration.layout != null && Object.keys(data.configuration.layout).length > 0;
                _allFields = data.targetForm.getMdByName();                

                self.availableFields.clear();
                self.selectedFields.clear();

                if(hasConfig){
                    let configFieldsMap = {};

                    let cfgFields = (angular.isArray(data.configuration.layout.field) ? data.configuration.layout.field : [data.configuration.layout.field]);
                    
                    //Feito em for diferente pois a ordem dos campos é afetada caso tudo seja resolvido em um unico for dentro dos metadados.
                    cfgFields.forEach( fieldConf => {
                        if(!isInvisible(fieldConf.name)){
                        	var fm = _allFields[fieldConf.name];
                        	if (fm) {
                        		self.selectedFields.addItem(normalizeFieldInfoFromMd(fm));
                        		configFieldsMap[fieldConf.name] = true;
                        	}
                        }
                    });

                    for(let name in _allFields){
                        let metadata = _allFields[name];

                        if(isInvisible(name)){
                            continue;
                        }

                        if(configFieldsMap[metadata.fieldName]){
                            continue;
                        }
                        self.availableFields.addItem(normalizeFieldInfoFromMd(metadata));
                    }
                }else{
                	let availableColumns = data.availableColumnsStandard ? Array.isArray(data.availableColumnsStandard) ? data.availableColumnsStandard : [data.availableColumnsStandard] : [];
                	
                	if (availableColumns.length > 0) {
                		let selectedFields = {};
                		availableColumns.forEach(function(fmA) {
                			selectedFields[fmA.name] = true;
                			self.selectedFields.addItem(normalizeFieldInfoFromMd(_allFields[fmA.name]));
                		});
                		for(var fName in _allFields) {
                			if (selectedFields[fName] || isInvisible(fName)) {
                				continue;
                			}
                			self.availableFields.addItem(normalizeFieldInfoFromMd(_allFields[fName]));
                		}
                	} else {
	                    for(var fName in _allFields){
	                        if(isInvisible(fName)){
	                            continue;
	                        }
	                        self.selectedFields.addItem(normalizeFieldInfoFromMd(_allFields[fName]));
	                    }
                	}
                }

                self.availableFields.setSortFunction(sortFields);
                
                self.availableFields.refresh();
                self.selectedFields.refresh();
            }

            function isInvisible(fName){
                return _allFields[fName] && _allFields[fName].visible == false;
            }

            function sortFields(fieldA, fieldB){
                let fNameA = (fieldA["userDescription"] || fieldA["description"]).replace(/^%\s+/, "");
                let fNameB = (fieldB["userDescription"] || fieldB["description"]).replace(/^%\s+/, "");

                return fNameA === fNameB ? 0 : (fNameA < fNameB ? -1 : 1);
            }

            function filterFn(item, term) {
                
                if(term == undefined || term == "") {
                    return true;
                }

                var nomeCampo = term.toLowerCase();                
                
                nomeCampo = StringUtils.replaceCharacterSpecial(nomeCampo);

                for(var i = 0; i < _camposBusca.length; i++){
                    let campo = _camposBusca[i];
                    
                    if (angular.isDefined(item[campo])) {
                        var nomeCampoLista = StringUtils.replaceCharacterSpecial(item[campo]).toLowerCase();
                        
                        if (nomeCampoLista.indexOf(nomeCampo) >= 0) {
                            return true;	
                        }
                    }
                }
                
                return false;
            }

            function normalizeFieldInfoFromMd(metadata){

                let config = data.configuration ? data.configuration.metadata : undefined;

                let mdConf;
                 
                 if(config && Object.keys(config).length > 0){
                    mdConf = angular.isArray(config.field) ? config.field : [config.field]
                 }

                 let fConfig = ArrayUtils.find(mdConf, fProp => fProp.name == metadata.fieldName);
                
                let fieldInfo = {
                    field: metadata.fieldName,
                    description: metadata.description,
                    systemGroupName: metadata.groupName,
                    systemRequired: metadata.required ? 'S' : 'N',
                    systemReadOnly: metadata.enabled ? 'N' : 'S'
                };

                if(fConfig){                    
                    if (fConfig.hasOwnProperty('userDescription')) {
                        fieldInfo.userDescription = fConfig.userDescription;
                    }
                    
                    if (fConfig.hasOwnProperty('userGroupName')) {
                        fieldInfo.userGroupName = fConfig.userGroupName;
                    }
                    
                    if (fConfig.hasOwnProperty('userReadOnly')) {
                        fieldInfo.userReadOnly = fConfig.userReadOnly;
                    }
                    
                    if (fConfig.hasOwnProperty('userRequired')) {
                        fieldInfo.userRequired = fConfig.userRequired;
                    }

                    if(self.configureDefaultValue) {
                        if (fConfig.hasOwnProperty('textValorPadrao')) {
                            fieldInfo.textValorPadrao = fConfig.textValorPadrao;

                            addTipoValorPadrao(fConfig, fieldInfo, 'literal');
                        }
                        
                        if (fConfig.hasOwnProperty('comboOptions')) {
                            fieldInfo.comboOptions = fConfig.comboOptions;

                            addTipoValorPadrao(fConfig, fieldInfo, 'variavel');
                        }

                        if (fConfig.hasOwnProperty('comboVariaveis')) {
                            fieldInfo.comboVariaveis = fConfig.comboVariaveis;

                            addTipoValorPadrao(fConfig, fieldInfo, 'variavel');
                        }
                    }
                }

                return fieldInfo;
            }

            function addTipoValorPadrao(fConfig, fieldInfo, tipoValor) {
                if (fConfig.hasOwnProperty('comboTipoValorPadrao')) {
                    fieldInfo.comboTipoValorPadrao = fConfig.comboTipoValorPadrao;

                } else {
                    fieldInfo.comboTipoValorPadrao = tipoValor;
                }
            }

            function saveConfig(){
                const config = buildConfigToSave();

                if(data.saveConfig){
                    data.saveConfig(config);
                    return;
                }

                ServiceProxy.callService(
                    SAVE_CONFIG,
                    config                    
                ).then(function(response){                    
                    loadConfig(response.responseBody.formConfig);

                    if(angular.isFunction(data.callBackConfigSaved)) {
                        data.callBackConfigSaved(response.responseBody.formConfig);
                    }
                });
            }

            function buildConfigToSave() {
				
				var layout =   [];
                var metadata = [];
				
				var allFields = self.availableFields.getItems().concat(self.selectedFields.getItems());
				
				for (var i = 0; i < allFields.length; i++) {
					var field = allFields[i];
					
					var fieldName = field.field;
					
                    var fieldMD = {name : fieldName};
					
					if (field.hasOwnProperty('userDescription')) {
						fieldMD.userDescription = field.userDescription;
					}
					
					if (field.hasOwnProperty('userGroupName')) {
						fieldMD.userGroupName = field.userGroupName;
					}
					
					if (field.hasOwnProperty('userReadOnly')) {
						fieldMD.userReadOnly = field.userReadOnly;
					}
					
					if (field.hasOwnProperty('userRequired')) {
						fieldMD.userRequired = field.userRequired;
					}
					
                    if(self.configureDefaultValue) {
                        if (field.hasOwnProperty('comboTipoValorPadrao')) {
                            fieldMD.comboTipoValorPadrao = field.comboTipoValorPadrao;
                        }
                        
                        if (field.hasOwnProperty('textValorPadrao')) {
                            fieldMD.textValorPadrao = field.textValorPadrao;
                        }
                        
                        if (field.hasOwnProperty('comboOptions')) {
                            fieldMD.comboOptions = field.comboOptions;
                        }

                        if (field.hasOwnProperty('comboVariaveis')) {
                            fieldMD.comboVariaveis = field.comboVariaveis;
                        }
                    }
					
					if (Object.keys(fieldMD).length > 1) {
						metadata.push(fieldMD);
					}
					
					if (self.selectedFields.indexOf(field) > -1) {
						var fieldObj = {name: fieldName};
						layout.push(fieldObj);
					}
				}
				
                var cfg = {formConfig : {}};
                
                cfg.formConfig.configName = data.configName;
                cfg.formConfig.isVariation = data.isVariation;
				
				cfg.formConfig.layout = {field: layout};
				cfg.formConfig.metadata = {field: metadata};
				
				return cfg;
            }

            function restore(){
                var formConfig = {formConfig: {configName: data.configName, isVariacao: data.isVariation}};
                
                if(data.configNameFallback) {
                    formConfig.configNameFallback = data.configNameFallback;
                }
                
                ServiceProxy.callService(
                    RESTORE_CONFIG,
                    formConfig
                ).then(function(response){
                    loadConfig(response.responseBody.formConfig);

                    if(angular.isFunction(data.callBackConfigSaved)) {
                        data.callBackConfigSaved(response.responseBody.formConfig);
                    }
                });
             }

             function loadConfig(config){
                _configuration = config;
                data.targetForm.setConfig(_configuration, true);
             }

             function onSelectionChanged(selection, list){
                if(selection.length > 0){
                    self.selectedField = selection[selection.length - 1];

                    self.userDescription = self.selectedField.hasOwnProperty('userDescription') ? self.selectedField.userDescription : self.selectedField.description;
                    self.userGroupName = self.selectedField.hasOwnProperty('userGroupName') ? self.selectedField.userGroupName : self.selectedField.systemGroupName;
                    self.userRequired = self.selectedField.userRequired || self.selectedField.systemRequired;
                    self.userReadOnly = self.selectedField.userReadOnly || !self.selectedField.systemReadOnly;

                    self.requiredEnable = data.targetForm.canChangeRequiredState(self.selectedField);
                    self.readOnlyEnable = data.targetForm.canChangeEnabledState(self.selectedField);

                    _lastSelectedList = list;

                    if(self.configureDefaultValue) {
                        self.comboTipoValorPadrao = self.selectedField.comboTipoValorPadrao ? self.selectedField.comboTipoValorPadrao : 'literal';
                        self.textValorPadrao = self.selectedField.textValorPadrao;
                        self.comboOptions = self.selectedField.comboOptions;
                        self.comboVariaveis = self.selectedField.comboVariaveis;

                        selecionaUIExpressao();
                        getOpcoesByFieldName();
                    }
                }else if(_lastSelectedList == list){

                    self.selectedField = undefined;                    
                    self.userDescription = "";
                    self.userGroupName = "";
                    self.requiredEnable = false;
                    self.readOnlyEnable = false;
                    self.userRequired = false;
                    self.userReadOnly = false;

                    if(self.configureDefaultValue) {
                        self.comboTipoValorPadrao = 'literal';
                        self.textValorPadrao = "";
                        self.comboOptions = undefined;
                        self.comboVariaveis = undefined;

                        selecionaUIExpressao();
                    }
                }
             }

             function getOpcoesByFieldName() {
                var fieldMD = _allFields[self.selectedField.field];

                var entityName;

                if(fieldMD.fieldProp && fieldMD.fieldProp["sk-entity-name"]) {
                    entityName = fieldMD.fieldProp["sk-entity-name"];
                } else {
                    var ds = fieldMD.fieldProp["sk-dataset"];

                    if(ds && angular.isFunction(ds.getEntityName)) {
                        entityName = ds.getEntityName();
                    }
                }

                var param = {
                    fieldName: fieldMD.fieldName,
                    entityName: angular.isUndefined(entityName) ? "CabecalhoNota" : entityName
                };

                ServiceProxy.callService('mgecom@ConfiguradorLayoutNotaSP.getOpcoesByFieldName', { params: param })
                    .then(
                        function (response) {
                            _dpOpcoesCampo = response.responseBody.opcoes.opcao;

                            if(Array.isArray(_dpOpcoesCampo)) {
                                buildComboOptions();
                            } else {
								_isOptionValue = false; 
								selecionaUIExpressao();
							}

                        }
                    );
            }

            function buildComboOptions() {
                self.dpComboOptions = [];

                _dpOpcoesCampo.forEach(function (item) {
                    self.dpComboOptions.push(
                        { data: angular.isUndefined(item.valor) ? "" : item.valor, value: angular.isUndefined(item.label) ? "" : item.label }
                    );
                });

                _isOptionValue = true;

                for (var i = 0; i < self.dpComboOptions.length; i++) {
                    var item = self.dpComboOptions[i];

                    if (self.textValorPadrao == item.data) {
                        self.comboOptions = item.data;
                        
                        break;
                    }
                }
                selecionaUIExpressao();
             }

             function isEditItemEnable(){
                 return self.selectedField != undefined;
             }

             function hasChangedByProgramer(selectedField, prop){
                return selectedField && data.targetForm.getPropChangedProgramaticaly(selectedField.field, prop) !== undefined;
             }

             function onEditItem(prop){
                if(self.selectedField){                    
                    self.selectedField[prop] = self[prop];

                    if(!StringUtils.isEmpty(self.selectedField[prop])){
                        self.selectedField[prop] = self[prop];
                        hasChanged = true;
                    } else{
                        delete self.selectedField[prop];
                        hasChanged = true;
                    }
                }
            }

            function selecionaUIExpressao(prop) {
                if(prop) {
                    onEditItem(prop);
                }

                if (!self.comboTipoValorPadrao) {
                    return;
                }

                switch (String(self.comboTipoValorPadrao)) {
                    case "variavel":
                        self.comboOptionsVisibled = false;
                        self.textValorPadraoVisibled = false;
                        self.comboVariaveisVisibled = true;
                        break;

                    case "literal":
                        if (_isOptionValue) {
                            self.comboVariaveisVisibled = false;
                            self.textValorPadraoVisibled = false;
                            self.comboOptionsVisibled = true;
                        } else {
                            self.comboVariaveisVisibled = false;
                            self.comboOptionsVisibled = false;
                            self.textValorPadraoVisibled = true;
                        }

                        break;
                }
            }
            
        }]);

/**
 * @ngdoc directive
 * @name snk.components.gridconfig.directive:sk-grid-config
 * @restrict E
 * @scope
 * @description
    Componente responsável por renderizar um botão com a configuração da grade.
 * 
 * @param {string} sk-config-name Nome da configuração do grid. (Este mesmo nome deve ser passado ao sk-datagrid)
 * @param {string} sk-available-columns-standard São as colunas que serão mantidas como "Colunas disponíveis" quando restaurar o padrão.
 * @param {function} sk-selected-columns-grid É uma função utilizada para listar todas as colunas selecionadas, para que sejam implementadas validações (se necessário)
 */

angular
    .module('snk.components.gridconfig')
    .directive('skGridConfig', ['GridConfigInstance', 'SkApplication', 'MGEAuthorizationConstants', 'StringUtils', function (GridConfigInstance, SkApplication, MGEAuthorizationConstants, StringUtils) {
        return {
            restrict: 'E',
            templateUrl: 'components/gridconfig/gridconfig.tpl.html',
            scope: {
                configName: "@skConfigName",
                availableColumnsStandard: '@?skAvailableColumnsStandard',
                tooltipPlacement:'@?skTooltipPlacement',
                selectedColumnsGrid: '&?skSelectedColumnsGrid'
            },
            link: function($scope, $element, $attrs) {
                var _gridConfig;

                $attrs.$observe('skConfigName', function() {
                    if ($scope.configName) {
                        if (_gridConfig) {
                            _gridConfig.setId($scope.configName);
                        } else {
                            _gridConfig = GridConfigInstance($scope.configName, $attrs.hasOwnProperty('uigrid'))
                        }
                    }

                    if($scope.availableColumnsStandard && angular.isString($scope.availableColumnsStandard)){
                        $scope.availableColumnsStandard = $scope.availableColumnsStandard.replace(/ /g, "");
                        let availableColumns = $scope.availableColumnsStandard.split(',');
    
                        if (_gridConfig) {
                        	let idAvailableColumns = StringUtils.undefinedAsEmpty($scope.configName) + 'availableColumns';
                            _gridConfig.setConfig({id: idAvailableColumns, cfg: availableColumns});
                        }
                    }
                });

                $scope.$on('$destroy', function() {
                    if (_gridConfig) {
                        _gridConfig.unregistry();
                    }
                }); 
                
                $scope.openGridconfig = function() {
                    if (_gridConfig) {
                        _gridConfig.open({visibleColumns: $scope.selectedColumnsGrid});
                    }
                };

                $scope.allowGridEdit = SkApplication.instance().authIsLoadded() ? SkApplication.instance().hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG_GRID) : true;
            }
        };
    }]
);


/**
 * Created by bruno.brandao on 17/05/2017.
 */
angular
    .module('snk.components.gridconfig')
    .service('GridConfigJqx', ['SanPopup', 'i18n', '$q', '$timeout', 'ServiceProxy', 'ArrayUtils', 'SkApplication', 'DateUtils', 'DateUtilsConstants', 'AngularUtil',
        function (SanPopup, i18n, $q, $timeout, ServiceProxy, ArrayUtils, SkApplication, DateUtils, DateUtilsConstants, AngularUtil) {
            var self = this;

            var HTML5_PREFFIX = 'GrdCfgHtml5:';

            var LOAD_CONFIG = "mge@GridConfig.getGridConfigFromJson";
            var SAVE_CONFIG = "mge@GridConfig.saveGridConfigFromJSON";
            var RESTORE_CONFIG = "mge@GridConfig.restoreGridConfigFromJson";

            var _configsByName = {};

            self.load = load;
            self.save = save;
            self.restore = restore;

            function load(configName) {
                return $q(function (resolve, reject) {
                    if (_configsByName[configName]) {
                        resolve(_configsByName[configName]);
                    } else {
                        var gridConfigRequest = {
                            gridConfig: {
                                configName: HTML5_PREFFIX + configName
                            }
                        };

                        /*TODO
                         if (_gridConfigsList[gridconfigId].configValidDateTime) {
                         var dateStr = _gridConfigsList[gridconfigId].configValidDateTime.getTime();
                         gridConfigRequest.gridConfig.validDateTime = dateStr;
                         }*/

                        ServiceProxy.callService(LOAD_CONFIG, gridConfigRequest).then(function (result) {
                            if (result.responseBody == undefined || result.responseBody.gridConfig == undefined) {
                                _configsByName[configName] = {};
                                resolve({});
                            } else {
                                var resultConfig = processLoadResult(configName, result.responseBody.gridConfig);
                                resolve(resultConfig);
                            }
                        }, reject);
                    }
                });
            }

            function restore(configName) {
                return $q(function(resolve, reject) {
                    ServiceProxy.callService(RESTORE_CONFIG, {
                        gridConfig: {
                            configName: HTML5_PREFFIX + configName
                        }
                    }).then(function(result) {
                        var resultConfig = processLoadResult(configName, result.responseBody.gridConfig);
                        resolve(resultConfig);
                    }, reject);
                })
            }

            function processLoadResult(configName, resultConfig) {
                var fieldsResult = resultConfig.field;
                var parsedFields;

                if (angular.isDefined(fieldsResult) && !angular.isArray(fieldsResult)) {
                    parsedFields = [];

                    var length = Object.keys(fieldsResult).length;
                    for (var i = 0; i < length; i++) {
                        parsedFields.push(fieldsResult['field' + i]);
                    }
                } else {
                    parsedFields = fieldsResult;
                }

                resultConfig.field = parsedFields;
                _configsByName[configName] = resultConfig;

                return resultConfig;
            }

            function save(configName, gridController, restrictConfig) {
                var cfg = {
                    gridConfig: {
                        restrictBySup: restrictConfig,
                        configName: HTML5_PREFFIX + configName,
                        //TODO compactMode: grdConfig.compactMode,
                        field: []
                    }
                };

                var orderFields = getOrderFieldsMap(configName);

                gridController.getColumns().forEach(function(columnMD) {
                    if (columnMD.hidden || columnMD.transientColumn) {
                        return;
                    }

                    var fieldCfg = {
                        name: columnMD.name,
                        width: columnMD.width,
                        orderIndex: 0
                    };

                    var order = orderFields[columnMD.name];

                    if (order) {
                        fieldCfg.orderIndex = order.orderIndex;

                        if(order.hasOwnProperty("ascending")) {
                            fieldCfg.ascending = order.ascending;
                        }
                    }

                    cfg.gridConfig.field.push(fieldCfg);
                });

                return $q(function(resolve, reject) {
                    ServiceProxy.callService(SAVE_CONFIG, cfg)
                        .then(function (result) {
                            var configResult = processLoadResult(configName, result.responseBody.gridConfig);
                            resolve(configResult);
                        }, reject);
                });
            }

            function getOrderFieldsMap(configName) {
                var orderFieldsMap = {};

                var fields = _configsByName[configName].field;

                if (fields && fields.length > 0) {
                    fields.forEach(function(field) {
                        orderFieldsMap[field.name] = {orderIndex: Number(field.orderIndex), ascending: field.hasOwnProperty("ascending") ? field.ascending == "true" : true};
                    });
                }

                return orderFieldsMap;
            }
        }]);

angular
    .module('snk.components.gridconfig')
    .service('GridConfig', ['SanPopup', '$translate', '$q', '$timeout', 'ServiceProxy', 'ArrayUtils', 'SkApplication', 'DateUtils', 'DateUtilsConstants', 'AngularUtil', 'MGEAuthorizationConstants', 'MessageUtils', 'i18n', 'StringUtils',
        function (SanPopup, $translate, $q, $timeout, ServiceProxy, ArrayUtils, SkApplication, DateUtils, DateUtilsConstants, AngularUtil, MGEAuthorizationConstants, MessageUtils, i18n, StringUtils) {
            var self = this;

            self.openGridconfig = openGridconfig;
            self.registerGridConfig = registerGridConfig;
            self.registerTargetGridController = registerTargetGridController;
            self.closeGridConfig = closeGridConfig;
            self.forceCloseGridConfig = forceCloseGridConfig;

            self.getAvailableColumns = getAvailableColumns;
            self.getSelectedColumns = getSelectedColumns;
            self.getOrderedColumns = getOrderedColumns;

            self.addOrderedColumn = addOrderedColumn;

            self.sortAvailableColumns = sortAvailableColumns;

            self.setOriginalRegistersSelected = setOriginalRegistersSelected;

            self.updateColumnWidth = updateColumnWidth;
            self.updateColumnOrder = updateColumnOrder;

            self.setCompactMode = setCompactMode;
            self.getCompactMode = getCompactMode;

            self.togglePinColumn = togglePinColumn;
            self.getPinnedColumns = getPinnedColumns;

            self.loadConfigurations = loadConfigurations;
            self.save = save;
            self.restoreGridConfig = restoreGridConfig;

            self.unregistry = unregistry;

            self.openGroup = openGroup;

            self.isRegistred = isRegistred;
            self.changeColumLabel = changeColumLabel;

            self.setConfig = setConfig;

            var _gridConfigsList = {};
            var _waitingGrids = {};
            var _waitingGridsForLoad = [];
            var _charToPixelRatio = 14;
            var _restrictConfig = false;

            var _configs = [];

            var _gridConfigContentInstance;

            var LOAD_CONFIG = "mge@GridConfig.getGridConfigFromJson";
            var SAVE_CONFIG = "mge@GridConfig.saveGridConfigFromJSON";
            var RESTORE_CONFIG = "mge@GridConfig.restoreGridConfigFromJson";

            function openGridconfig(gridconfigId, options) {

                if(!SkApplication.instance().hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG_GRID) && SkApplication.instance().authIsLoadded()){
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Controls.GridConfig.msgAcessoNegadoConfGrid'));
                    return;
                } 

                $timeout(function () {
                    f();
                });

                var f = function () {
                    var btnTour = angular.element('<button default><sk-icon font-icon="train"></sk-icon><sk-i18n>EntityStartPage.sideMenu.lblIniciarTour</sk-i18n></button>');
                    AngularUtil.compile(btnTour);

                    _gridConfigContentInstance = SanPopup.open({
                        id: gridconfigId ? 'POP_GRIDCONFIG_' + gridconfigId : undefined,
                        title: $translate.instant('GridConfig.titulo'),
                        templateUrl: 'components/gridconfig/gridconfigcontent.tpl.html',
                        controller: 'SkGridconfigContentController',
                        controllerAs: 'gridConfigContentCtrl',
                        type: 'default',
                        okBtnLabel: $translate.instant('GridConfig.restaurarPadrao'),
                        noBtnLabel: $translate.instant('Geral.lblSalvar'),
                        okBtnClass: 'btn-default',
                        noBtnClass: 'btn-primary',
                        cancelBtnClass: 'btn-default',
                        showBtnCancel: true,
                        showBtnNo: true,
                        size: 'lg',
                        windowClass: 'gridconfig-modal-window',
                        backdrop: 'static',
                        animation: false,
                        leftBottomBar: [btnTour],
                        resolve: {
                            gridconfigId: function () {
                                return gridconfigId;
                            },
                            availableColumns: function () {
                                return _gridConfigsList[gridconfigId].availableColumns;
                            },
                            selectedColumns: function () {
                                return _gridConfigsList[gridconfigId].selectedColumns;
                            },
                            orderedColumns: function () {
                                return _gridConfigsList[gridconfigId].orderedColumns;
                            },
                            restrictConfig: function () {
                                return _restrictConfig;
                            },
                            isSup: function () {
                                return SkApplication.instance().isSup();
                            },
                            isTourMode: function () {
                                return options && options.isTourMode;
                            },
                            btnTour: function () {
                                return btnTour;
                            },
                            isAggrid : function(){
                                return true;
                            },
                            visibleColumns: function () {
                            	return options && options.visibleColumns;
                            }
                        }
                    });
                }
            }

            /*function removeDuplicateElements(array) {
                return array.reduce( function(unique, o) {
                    if(!unique.some( function(obj) { return obj.skName === o.skName } )) {
                      unique.push(o);
                    }
                    return unique;
                },[]);
            }*/

            function registerGridConfig(gridconfigId, configName, configValidDateTime, reuseGridConfig, ignoreConfig, autoShowNewFields) {
                if (!gridconfigId) {
                    new Error("Erro interno: é necessário informar o id do gridconfig.");
                }
                if (!configName) {
                    new Error("Erro interno: é necessário informar o configName do gridconfig.");
                }
                if (!reuseGridConfig && _gridConfigsList.hasOwnProperty(gridconfigId)) {
                    new Error("Erro interno: gridconfig com id " + gridconfigId + " já registrado.");
                }

                /*
                    Se so substutuimos na lista de configs de ela não eh reusable ou
                    ainda não foi criada.
                */
                if(!reuseGridConfig || !_gridConfigsList.hasOwnProperty(gridconfigId)){

                    _gridConfigsList[gridconfigId] = {
                        configName: configName,
                        configValidDateTime: configValidDateTime,
                        sorting: false,
                        compactMode: true,
                        availableColumns: [],
                        selectedColumns: [],
                        orderedColumns: [],
                        ignoreConfig: ignoreConfig == true,
                        autoShowNewFields: autoShowNewFields == true
                    };

                }

                if (_waitingGrids[gridconfigId]) {
                    _gridConfigsList[gridconfigId].gridController = _waitingGrids[gridconfigId];
                    delete _waitingGrids[gridconfigId];
                }

                var gridToLoadIndex = _waitingGridsForLoad.indexOf(gridconfigId);
                if (gridToLoadIndex > -1) {
                    loadConfigurations(gridconfigId);
                    _waitingGridsForLoad.splice(gridToLoadIndex, 1);
                }
            }

            function unregistry(gridconfigId) {
                delete _gridConfigsList[gridconfigId];
                delete _waitingGrids[gridconfigId];
            }

            function registerTargetGridController(gridconfigId, controller) {
                if (!gridconfigId) {
                    new Error("Erro interno: é necessário informar o id do gridconfig.");
                }
                if (!controller) {
                    new Error("Erro interno: é necessário informar o controlador do datagrid.");
                }

                if (!_gridConfigsList.hasOwnProperty(gridconfigId)) {
                    _waitingGrids[gridconfigId] = controller;
                } else {
                    _gridConfigsList[gridconfigId].gridController = controller;
                }
            }

            function loadConfigurations(gridconfigId) {
                if (!_gridConfigsList[gridconfigId]) {
                    _waitingGridsForLoad.push(gridconfigId);
                    return;
                }

                validateState(gridconfigId);

                var _configName = "GrdCfgHtml5:" + _gridConfigsList[gridconfigId].configName;

                if (_gridConfigsList[gridconfigId].ignoreConfig) {
                    setAllColumnsVisible(gridconfigId);
                    _gridConfigsList[gridconfigId].gridController.refreshView();
                }else{

                    var gridConfigRequest = {
                        gridConfig: {
                            configName: _configName
                        }
                    };
    
                    if (_gridConfigsList[gridconfigId].configValidDateTime) {
                        var dateStr = _gridConfigsList[gridconfigId].configValidDateTime.getTime();
                        gridConfigRequest.gridConfig.validDateTime = dateStr;
                    }
    
                    ServiceProxy.callService(LOAD_CONFIG, gridConfigRequest)
                        .then(function (result) {
                            if (!processLoadResult(result, gridconfigId)) {
                                setAllColumnsVisible(gridconfigId);
                            }
    
                            if(_gridConfigsList[gridconfigId]){
                            	_gridConfigsList[gridconfigId].gridController.refreshView();
                            }
                        });
                }
            }

            function validateState(gridconfigId) {
                if (!_gridConfigsList.hasOwnProperty(gridconfigId)) {
                    new Error("Erro interno: gridconfig com id '" + gridconfigId + "' não encontrado.");
                }
            }

            function processLoadResult(result, gridconfigId, setupGrid) {
                /*
                    Quando a grade é aberta em um popup por exemplo e o mesmo é fechando antes que as configs
                    sejam carregados a configuração da grade não ira existir mais nesse ponto.
                */
                if(!_gridConfigsList[gridconfigId]){
                    return true;
                }
                setupGrid = setupGrid == undefined ? true : setupGrid;
                //Faz uma cópia das configurações vindas do dataset
                if (!_gridConfigsList[gridconfigId].originalColumnDefs) {
                    _gridConfigsList[gridconfigId].originalColumnDefs = _gridConfigsList[gridconfigId].gridController.getColumnDefs().slice(0);
                }

                _gridConfigsList[gridconfigId].selectedColumns.length = 0;
                _gridConfigsList[gridconfigId].availableColumns.length = 0;
                _gridConfigsList[gridconfigId].orderedColumns.length = 0;

                //Obtem a lista de todas as colunas
                var columnDefsCopy = _gridConfigsList[gridconfigId].gridController.getColumnDefs().slice(0);
                var columnsSelected = [];
                var columnsUnselected = [];

                //Remove a coluna de checkbox e a coluna em branco
                if (columnDefsCopy[0] && columnDefsCopy[0].transient) {
                    ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[0]);
                }

                if (columnDefsCopy[columnDefsCopy.length - 1] && columnDefsCopy[columnDefsCopy.length - 1].transient) {
                    ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[columnDefsCopy.length - 1]);
                }

                if (result.responseBody == undefined || result.responseBody.gridConfig == undefined) {
                    return false;
                }

                _restrictConfig = result.responseBody.gridConfig.restrictBySup;

                _gridConfigsList[gridconfigId].pinnedColumns = result.responseBody.gridConfig.pinnedColumns;

                if (result.responseBody.gridConfig.hasOwnProperty('compactMode')) {
                    _gridConfigsList[gridconfigId].compactMode = result.responseBody.gridConfig.compactMode;
                }

                if (result.responseBody.gridConfig.restrict) {
                    processLoadResultWithRestictFields(gridconfigId, result, columnDefsCopy);
                    return true;
                }

                //Processa a resposta
                var fieldsResult = result.responseBody.gridConfig.field != undefined ? result.responseBody.gridConfig.field : undefined;

                if (fieldsResult == undefined) {
                    for (var i = 0; i < _gridConfigsList[gridconfigId].originalColumnDefs.length; i++) {
                        var col = _gridConfigsList[gridconfigId].originalColumnDefs[i];

                        if (col.presentationType == 'I' || col.skVisible == false || col.transient) {
                            continue;
                        }

                        var column = {
                            field: col.field,
                            displayName: col.skDescription,
                            selected: false,

                            name: col.skName,
                            orderIndex: 0,
                            checked: false,
                            direction: 'asc',
                            width: col.width
                        };
                        
                        let idAvailableColumns = StringUtils.undefinedAsEmpty(gridconfigId) + 'availableColumns';
                        if((_configs[idAvailableColumns] && _configs[idAvailableColumns].indexOf(col.field) > -1) || col.skVisivelPadrao == false){
                            _gridConfigsList[gridconfigId].availableColumns.push(column);
                        } else {
                            _gridConfigsList[gridconfigId].selectedColumns.push(column);
                        }
                    }

                    var k;

                    for (k = 0; k < _gridConfigsList[gridconfigId].selectedColumns.length; k++) {
                        _gridConfigsList[gridconfigId].orderedColumns.push(_gridConfigsList[gridconfigId].selectedColumns[k]);
                    }

                    for (k = 0; k < _gridConfigsList[gridconfigId].availableColumns.length; k++) {
                        _gridConfigsList[gridconfigId].orderedColumns.push(_gridConfigsList[gridconfigId].availableColumns[k]);
                    }

                    if (_gridConfigsList[gridconfigId].gridController && setupGrid) {
                        setupDatagrid(gridconfigId, true);
                    }
                    return true;
                }
                else {
                    //Define as colunas selecionadas (visíveis)
                    var length = 0;
                    var isObject = false;
                    if (angular.isArray(fieldsResult)) {
                        length = fieldsResult.length;
                    }
                    else if (angular.isObject(fieldsResult)) {
                        length = Object.keys(fieldsResult).length;
                        isObject = true;
                    }

                    for (var i = 0; i < length; i++) {
                        var fieldResult;
                        if (isObject) {
                            fieldResult = fieldsResult['field' + i] || fieldsResult;
                        }
                        else {
                            fieldResult = fieldsResult[i];
                        }

                        var name = fieldResult.name;
                        var orderIndex = fieldResult.orderIndex;
                        var width = fieldResult.width;
                        var ascending = fieldResult.ascending;

                        for (var j = 0; j < columnDefsCopy.length; j++) {
                            var col = columnDefsCopy[j];

                            if (col.presentationType == 'I' || col.skVisible == false || col.transient) {
                                continue;
                            }

                            var adjustedName;
                            if (col.skName.indexOf('.') > -1) {
                                adjustedName = col.skName.replace(/\./g, '_');
                            }
                            else {
                                adjustedName = col.skName;
                            }

                            var adjustedFieldName;
                            if(angular.isDefined(name)){
                                if (name.indexOf('.') > -1) {
                                    adjustedFieldName = name.replace(/\./g, '_');
                                }else {
                                    adjustedFieldName = name;
                                }
                            }

                            if (adjustedName == adjustedFieldName) {
                                var column = {
                                    field: col.field,
                                    displayName: col.skDescription,
                                    selected: false,

                                    name: adjustedName !== col.skName ? col.skName : name,
                                    orderIndex: orderIndex,
                                    checked: false,
                                    width: width
                                };

                                if (ascending != undefined) {
                                    column.checked = true;
                                    column.direction = (typeof ascending == "boolean" ? ascending : (typeof ascending == "string" ? ascending == 'true' : !!ascending)) ? 'asc' : 'dec';
                                    columnsSelected.push(column);
                                }
                                else {
                                    column.direction = 'asc';
                                    columnsUnselected.push(column);
                                }

                                _gridConfigsList[gridconfigId].selectedColumns.push(column);
                                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[j]);

                                break;
                            }
                        }
                    }

                    //Define as colunas disponíveis (não visíveis)
                    for (var i = 0; i < columnDefsCopy.length; i++) {
                        var col = columnDefsCopy[i];

                        if (col.presentationType == 'I' || col.skVisible == false || col.transient) {
                            continue;
                        }

                        var column = {
                            field: col.field,
                            displayName: col.skDescription,
                            selected: false,
                            checked: false,

                            name: col.skName,
                            orderIndex: 0,
                            width: col.width || Math.max((Math.min(col.skDescription.toString().length, 30) * _charToPixelRatio), 130)
                        };

                        // Se autoShowNewFields estiver ativo, campos novos (que não estavam na configuração salva) 
                        // são adicionados como visíveis por padrão. Caso contrário, ficam ocultos.
                        if (_gridConfigsList[gridconfigId].autoShowNewFields) {
                            if (col.skVisivelPadrao === false) {
                                _gridConfigsList[gridconfigId].availableColumns.push(column);
                            } else {
                                // Campos novos ficam visíveis quando autoShowNewFields está ativo
                                _gridConfigsList[gridconfigId].selectedColumns.push(column);
                            }
                        }else{
                            _gridConfigsList[gridconfigId].availableColumns.push(column);
                        }
                    }

                    sortColumns(columnsSelected, 'orderIndex');
                    sortColumns(columnsUnselected, 'displayName');

                    var concatenedList = columnsSelected.concat(columnsUnselected);
                    for (var k = 0; k < concatenedList.length; k++) {
                        _gridConfigsList[gridconfigId].orderedColumns.push(concatenedList[k]);
                    }

                    sortAvailableColumns(gridconfigId);

                    if (_gridConfigsList[gridconfigId].gridController && setupGrid) {
                        setupDatagrid(gridconfigId);
                    }
                    return true;
                }
            }

            function processLoadResultWithRestictFields(gridconfigId, result, columnDefsCopy) {
                var restrictFields = result.responseBody.gridConfig.restrict.field;
                var userFields = result.responseBody.gridConfig.field;

                var gridController = _gridConfigsList[gridconfigId].gridController;
                var gridApi = gridController.getGridApi();

                var columnsSelected = [];
                var columnsUnselected = [];

                var length = 0;
                var isObject = false;
                if (angular.isArray(restrictFields)) {
                    length = restrictFields.length;
                }
                else if (angular.isObject(restrictFields)) {
                    length = Object.keys(restrictFields).length;
                    isObject = true;
                }

                var restrictFieldNames = [];

                for (var i = 0; i < length; i++) {
                    var restrictField;
                    if (isObject) {
                        restrictField = restrictFields['field' + i];
                    }
                    else {
                        restrictField = restrictFields[i];
                    }

                    var restrictFieldName = restrictField.name;
                    var fieldFound = false;

                    restrictFieldNames.push(restrictFieldName);
                    
                    var userFieldsLength = 0;
                    var userFieldIsObject;
                    if (angular.isArray(userFields)) {
                        userFieldsLength = userFields.length;
                        userFieldIsObject = false;
                    }
                    else if (angular.isObject(userFields)) {
                        userFieldsLength = Object.keys(userFields).length;
                        userFieldIsObject = true;
                    }

                    for (var j = 0; j < userFieldsLength; j++) {
                        var userField;
                        if (userFieldIsObject) {
                            userField = userFields['field' + j];
                        }
                        else {
                            userField = userFields[j];
                        }
                        if (userField.name == restrictFieldName) {
                            fieldFound = true;
                            break;
                        }
                    }

                    for (var j = 0; j < columnDefsCopy.length; j++) {
                        var col = columnDefsCopy[j];

                        if (col.presentationType == 'I' || col.skVisible == false || col.transient) {
                            continue;
                        }

                        var adjustedName;
                        if (col.skName.indexOf('.') > -1) {
                            adjustedName = col.skName.replace(/\./g, '_');
                        }
                        else {
                            adjustedName = col.skName;
                        }

                        var adjustedFieldName;
                        if (restrictFieldName.indexOf('.') > -1) {
                            adjustedFieldName = restrictFieldName.replace(/\./g, '_');
                        }
                        else {
                            adjustedFieldName = restrictFieldName;
                        }

                        if (adjustedName == adjustedFieldName) {
                            var ascending = userField.ascending;

                            var column = {
                                field: col.field,
                                displayName: col.skDescription,
                                selected: false,

                                name: adjustedName !== col.skName ? col.skName : restrictFieldName,
                                orderIndex: fieldFound ? userField.orderIndex : "0",
                                checked: false,
                                width: fieldFound ? userField.width : Math.max((Math.min(col.skDescription.toString().length, 30) * _charToPixelRatio), 130)
                            };

                            if (ascending != undefined) {
                                column.checked = true;
                                column.direction = (typeof ascending == "boolean" ? ascending : (typeof ascending == "string" ? ascending == 'true' : !!ascending)) ? 'asc' : 'dec';
                                columnsSelected.push(column);
                            }
                            else {
                                column.direction = 'asc';
                                columnsUnselected.push(column);
                            }

                            if (fieldFound) {
                                _gridConfigsList[gridconfigId].selectedColumns.push(column);
                                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[j]);
                            }
                            else {
                                _gridConfigsList[gridconfigId].availableColumns.push(column);
                                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[j]);
                            }

                            break;
                        }
                    }
                }

                sortColumns(columnsSelected, 'orderIndex');
                sortColumns(columnsUnselected, 'displayName');

                var concatenedList = columnsSelected.concat(columnsUnselected);
                for (var k = 0; k < concatenedList.length; k++) {
                    _gridConfigsList[gridconfigId].orderedColumns.push(concatenedList[k]);
                    
                    gridApi.columnController.getAllGridColumns().forEach(function(col){
                        if(restrictFieldNames.indexOf(col.colDef.field) === -1){
                            col.lockVisible = true;
                            col.colDef.enableValue = false;
                            col.colDef.enableRowGroup = false;
                        }
                    });
                }

                if (_gridConfigsList[gridconfigId].gridController) {
                    setupDatagrid(gridconfigId);
                }
            }

            function sortAvailableColumns(gridconfigId) {
                if (!_gridConfigsList[gridconfigId].sorting) {
                    _gridConfigsList[gridconfigId].sorting = true;
                    sortColumns(_gridConfigsList[gridconfigId].availableColumns, 'displayName');
                    _gridConfigsList[gridconfigId].sorting = false;
                }
            }

            function sortColumns(collection, field) {
                collection.sort(function (a, b) {
                    if (!a && !b) {
                        return 0;
                    }
                    else if (a && !b) {
                        return 1;
                    }
                    else if (!a && b) {
                        return -1;
                    }
                    else {
                        var strA = a[field].toString().toLowerCase();
                        var strB = b[field].toString().toLowerCase();
                        return strA === strB ? 0 : (strA < strB ? -1 : 1);
                    }
                });
            }

            function setupDatagrid(gridconfigId) {
                function fn (){
                    var gridController = _gridConfigsList[gridconfigId].gridController;
                    var gridApi = gridController.getGridApi();
                    var columnDefs = gridController.getColumnDefs();

                    var checkBoxCol;
                    var blankCol;

                    var groupColumn = gridApi.columnController.columnApi.getColumn('ag-Grid-AutoColumn');
                    var hasCbxColumn = gridController.hasCbxColumn();

                    var columnsMap = columnDefs.reduce(function (map, colDef) {
                        if (colDef.field == '-100000') {
                            checkBoxCol = colDef;
                        } else if (colDef.field == '9999') {
                            blankCol = colDef;
                        } else {
                            map[colDef.skName] = colDef;
                        }

                        return map;
                    }, {});

                    columnDefs.length = 0;

                    let mapColsState = {
                        visible: [],
                        hide: []
                    };

                    _gridConfigsList[gridconfigId].selectedColumns.forEach(function (selectedColumn, i) {
                        var datagridColumn = columnsMap[selectedColumn.name];

                        if (datagridColumn) {
                            
                            datagridColumn.width = parseInt(selectedColumn.width);
                            datagridColumn.index = i;
                            
                            if (gridApi) {                                
                                mapColsState[datagridColumn.skVisible ? 'visible' : 'hide' ].push(datagridColumn.field);
                                gridApi.columnController.columnApi.setColumnWidth(datagridColumn.field, (datagridColumn.width));
                                gridApi.columnController.columnApi.moveColumn(datagridColumn.field, hasCbxColumn ? i + 1 : i);
                            }

                            columnDefs.push(datagridColumn);
                            delete columnsMap[selectedColumn.name];
                        }
                    });

                    //colunas que sobraram
                    angular.forEach(columnsMap, function (columnDef, name) {
                        var visible = columnDef.skVisible && columnDef.transient;
                        mapColsState[visible ? 'visible' : 'hide' ].push(columnDef.field);
                        columnDefs.push(columnDef);
                    });

                    let { availableColumns, selectedColumns } = _gridConfigsList[gridconfigId];
                    
                    for(let av of availableColumns.filter(column => !selectedColumns.some(selected => column.name == selected.name))){
                        for (var j = 0; j < columnDefs.length; j++) {
                            var datagridColumn = columnDefs[j];
                            if (datagridColumn.skName != av.name) { 
                                continue;
                            }
                            else {                                
                                mapColsState['hide'].push(datagridColumn.field);
                            }
                        }
                    }

                    var configColsOrdened = [];

                    for (var i = 0; i < _gridConfigsList[gridconfigId].orderedColumns.length; i++) {
                        var orderedColumn = _gridConfigsList[gridconfigId].orderedColumns[i];
                        var datagridColumn = gridController.getGridApi().columnController.columnApi.getColumn(orderedColumn.field);
                        if (orderedColumn.checked) {
                            datagridColumn.direction = orderedColumn.direction == 'asc' ? 'asc' : 'desc';
                            datagridColumn.priority = orderedColumn.orderIndex + 1;
                            configColsOrdened.push(datagridColumn);
                        }
                    }

                    gridController.setCompactMode(getCompactMode(gridconfigId));

                    sort = [];
                    
                    configColsOrdened.forEach(function (order) {
                        sort.push({ colId: order.colId, sort: order.direction });
                    });
                    
                    gridApi.setSortModel(sort);
                    
                    /**
                     * Para melhorar o desempenho no setup de colunas fazemos o set de 
                     * visiveis/invisiveis de uma so vez
                     */
                    gridApi.columnController.columnApi.setColumnsVisible(mapColsState.visible, true);
                    gridApi.columnController.columnApi.setColumnsVisible(mapColsState.hide, false);

                    if(_gridConfigsList[gridconfigId].pinnedColumns){
                        _gridConfigsList[gridconfigId].pinnedColumns.forEach(function(col){
                            gridApi.columnController.columnApi.setColumnPinned(col.fieldName, col.position ? col.position : 'left');
                        });
                    }
                    //Colocamos a columa de agrupamento sempre na primeira posição.
                    if(groupColumn){
                        gridApi.columnController.columnApi.moveColumn(groupColumn.colId, 0);
                    }
                }

                //Caso a api do grid já esteja disponível atualizamos a grid, caso contrário aidcionamos um listener para quando ela estiver pronta
                if(_gridConfigsList[gridconfigId].gridController.getGridApi()){
                    fn();
                }else{
                    _gridConfigsList[gridconfigId].gridController.addGridReadyListener(fn);
                }                
            }

            function swapItems(collection, firstIndex, secondIndex) {
                if (!collection[firstIndex] || !collection[secondIndex]) {
                    return;
                }
                var tmp = collection[firstIndex];
                collection[firstIndex] = collection[secondIndex];
                collection[secondIndex] = tmp;

                return collection;
            }

            function getAvailableColumns(gridconfigId) {
                validateState(gridconfigId);
                return _gridConfigsList[gridconfigId].availableColumns;
            }

            function getSelectedColumns(gridconfigId) {
                validateState(gridconfigId);
                return _gridConfigsList[gridconfigId].selectedColumns;
            }

            function getOrderedColumns(gridconfigId) {
                validateState(gridconfigId);
                return _gridConfigsList[gridconfigId].orderedColumns;
            }

            function save(gridconfigId, restrictConfig, setupGrid, visibleColumns) {
                validateState(gridconfigId);

                var grdConfig = _gridConfigsList[gridconfigId];
                if (grdConfig.ignoreConfig) {
                    return;
                }

                var cfg = {
                    gridConfig: {
                        restrictBySup: restrictConfig,
                        configName: "GrdCfgHtml5:" + grdConfig.configName,
                        compactMode: grdConfig.compactMode,
                        field: {}
                    }
                };

                if (grdConfig.selectedColumns.length > 0) {
                	if(visibleColumns) {
                		visibleColumns({visibleColumns: grdConfig.selectedColumns});
                	}
                    for (var i = 0; i < _gridConfigsList[gridconfigId].selectedColumns.length; i++) {
                        var column = _gridConfigsList[gridconfigId].selectedColumns[i];
                        var orderData = getColumnOrderData(gridconfigId, column);

                        var fieldCfg = {
                            name: column.name,
                            width: column.width,
                            orderIndex: orderData.orderIndex
                        };

                        if (orderData.ascending != undefined) {
                            fieldCfg.ascending = orderData.ascending;
                        }

                        cfg.gridConfig.field['field' + i] = fieldCfg;
                    }
                }
                else {
                    for (var i = 0; i < grdConfig.availableColumns.length; i++) {
                        var column = grdConfig.availableColumns[i];
                        var orderData = getColumnOrderData(gridconfigId, column);

                        var fieldCfg = {
                            name: column.name,
                            width: column.width,
                            orderIndex: 0
                        };

                        cfg.gridConfig.field['field' + i] = fieldCfg;
                    }
                }

                cfg.gridConfig.pinnedColumns = grdConfig.pinnedColumns;

                ServiceProxy.callService(SAVE_CONFIG, cfg)
                    .then(function (result) {
                        processLoadResult(result, gridconfigId, setupGrid);
                    });
            }

            function getColumnOrderData(gridconfigId, column) {
                var orderData = {
                    orderIndex: 0
                };
                for (var i = 0; i < _gridConfigsList[gridconfigId].orderedColumns.length; i++) {
                    var orderedColumn = _gridConfigsList[gridconfigId].orderedColumns[i];
                    if (orderedColumn.checked && column.displayName == orderedColumn.displayName) {
                        orderData.orderIndex = i;
                        orderData.ascending = orderedColumn.direction == 'asc';
                        break;
                    }
                }
                return orderData;
            }

            function restoreGridConfig(gridconfigId) {

                var columnDefs = _gridConfigsList[gridconfigId].gridController.getColumnDefs();
                columnDefs.length = 0;
                for (var i = 0; i < _gridConfigsList[gridconfigId].originalColumnDefs.length; i++) {
                    columnDefs[i] = _gridConfigsList[gridconfigId].originalColumnDefs[i];
                }

                var request = {
                    gridConfig: {
                        configName: "GrdCfgHtml5:" + _gridConfigsList[gridconfigId].configName
                    }
                };

                ServiceProxy.callService(RESTORE_CONFIG, request)
                    .then(function (result) {
                        if (!processLoadResult(result, gridconfigId)) {
                            setAllColumnsVisible(gridconfigId);
                        }
                        $timeout(function () {
                            closeGridConfig(gridconfigId);
                        });
                    });
            }

            function updateColumnWidth(gridconfigId, fieldName, deltaChange, newWidth) {
                for (var i = 0; i < _gridConfigsList[gridconfigId].selectedColumns.length; i++) {
                    var selectedColumn = _gridConfigsList[gridconfigId].selectedColumns[i];
                    if (selectedColumn.name == fieldName) {
                        if (newWidth != undefined && newWidth > 0) {
                            selectedColumn.width = newWidth;
                            save(gridconfigId, undefined, false);
                        }
                        else if (deltaChange != undefined && !isNaN(Number(selectedColumn.width))) {
                            selectedColumn.width = Number(selectedColumn.width) + deltaChange;
                            save(gridconfigId, false);
                        }
                        break;
                    }
                }
            }

            function togglePinColumn(gridconfigId, fieldName, pinning, position) {
                var config = _gridConfigsList[gridconfigId];
                var index = -1;
                var pinnedCol = {
                    fieldName: fieldName,
                    position: position
                };
                if (pinning) {
                    if (!config.pinnedColumns) {
                        config.pinnedColumns = [];
                    } else {
                        index = getIndexFieldPinned(gridconfigId, fieldName);
                    }

                    if (index == -1) {
                        config.pinnedColumns.push(pinnedCol);
                    }else if(index != -1 && _gridConfigsList[gridconfigId].pinnedColumns[index].position != position){                        
                        togglePinColumn(gridconfigId, fieldName, false, position);
                        if(!config.pinnedColumns){
                            config['pinnedColumns'] = [];
                        }
                        config.pinnedColumns.push(pinnedCol);
                    }
                } else if ((index = getIndexFieldPinned(gridconfigId, fieldName)) > -1) {
                    ArrayUtils.removeAtIndex(config.pinnedColumns, index);

                    if (config.pinnedColumns.length == 0) {
                        delete config.pinnedColumns;
                    }
                }

                save(gridconfigId);
            }

            function getIndexFieldPinned(configId, fieldName){
                var config = _gridConfigsList[configId];
                var result = -1;
                if(config){
                    config.pinnedColumns.forEach(function(pinned, index){
                        if(pinned.fieldName === fieldName){
                            result = index;
                        }
                    })
                }
                return result;
            };

            function setCompactMode(gridconfigId, value) {
                if (!gridconfigId) {
                    return;
                }

                var config = _gridConfigsList[gridconfigId];

                config.compactMode = value;

                save(gridconfigId);
            }

            function getCompactMode(gridConfigId) {
                if (!gridConfigId) {
                    return true;
                }

                var config = _gridConfigsList[gridConfigId];

                if (!config || !config.hasOwnProperty('compactMode')) {
                    return true;
                }

                return config.compactMode;
            }

            function getPinnedColumns(gridconfigId) {
                return _gridConfigsList[gridconfigId].pinnedColumns;
            }

            function updateColumnOrder(gridconfigId, newPosition, colId) {
                var originalPosition;

                _gridConfigsList[gridconfigId].selectedColumns.forEach(function (col, i) {
                    if (col.field == colId) {
                        originalPosition = i;
                    }
                });

                if (newPosition < originalPosition) {
                    for (var i = originalPosition; i > newPosition; i--) {
                        swapItems(_gridConfigsList[gridconfigId].selectedColumns, i, i - 1);
                        let updatedColumnDefs = swapItems(_gridConfigsList[gridconfigId].gridController.getColumnDefs(), i, i - 1);
                        _gridConfigsList[gridconfigId].gridController.setColumnDefs(updatedColumnDefs);
                    }
                    save(gridconfigId, undefined, false);
                }
                else if (newPosition > originalPosition) {
                    for (var i = originalPosition; i < newPosition; i++) {
                        swapItems(_gridConfigsList[gridconfigId].selectedColumns, i, i + 1);
                        let updatedColumnDefs = swapItems(_gridConfigsList[gridconfigId].gridController.getColumnDefs(), i, i + 1);
                        _gridConfigsList[gridconfigId].gridController.setColumnDefs(updatedColumnDefs);
                    }
                    save(gridconfigId, undefined, false);
                }
            }

            function setAllColumnsVisible(gridconfigId) {
                var columnDefsCopy = _gridConfigsList[gridconfigId].gridController.getColumnDefs().slice(0);

                _gridConfigsList[gridconfigId].selectedColumns.length = 0;
                _gridConfigsList[gridconfigId].availableColumns.length = 0;
                for (var i = 0; i < columnDefsCopy.length; i++) {
                    var col = columnDefsCopy[i];

                    if (col.skVisible) {
                        var column = {
                            field: col.field,
                            displayName: col.skDescription,
                            selected: false,

                            name: col.skName,
                            orderIndex: 0,
                            width: _gridConfigsList[gridconfigId].gridController.getColumnWidth(col.skDescription.toString())
                        };

                        _gridConfigsList[gridconfigId].selectedColumns.push(column);
                    }
                }
                _gridConfigsList[gridconfigId].gridController.resetColumnWidths();
                buildOrderedColumns(gridconfigId);
                setupDatagrid(gridconfigId, true);
            }

            function closeGridConfig(gridconfigId) {
                $timeout(function () {
                    setupDatagrid(gridconfigId);
                });
            }

            function forceCloseGridConfig() {
                if (_gridConfigContentInstance) {
                    _gridConfigContentInstance.dismiss();
                }
            }

            function buildOrderedColumns(gridconfigId) {
                var selectedColumns = _gridConfigsList[gridconfigId].selectedColumns.slice(0);

                _gridConfigsList[gridconfigId].orderedColumns.length = 0;
                for (var i = 0; i < selectedColumns.length; i++) {
                    var selectedColumn = selectedColumns[i];
                    selectedColumn.selected = false;
                    selectedColumn.direction = 'asc';
                    _gridConfigsList[gridconfigId].orderedColumns.push(selectedColumn);
                }

                if (_gridConfigsList[gridconfigId].orderedColumns.length > 0) {
                    sortColumns(_gridConfigsList[gridconfigId].orderedColumns, 'displayName');
                }
            }

            function addOrderedColumn(gridconfigId, column) {
                _gridConfigsList[gridconfigId].orderedColumns.push(column);
                sortColumns(_gridConfigsList[gridconfigId].orderedColumns, 'displayName');
            }

            function setOriginalRegistersSelected(gridconfigId, availableColumns, selectedColumns){
                _gridConfigsList[gridconfigId].availableColumns = availableColumns;
                _gridConfigsList[gridconfigId].selectedColumns = selectedColumns;
            }

            function openGroup(groupIndex) {
                if (_gridConfigContentInstance && _gridConfigContentInstance.$controller) {
                    _gridConfigContentInstance.$controller.openGroup(groupIndex);
                }
            }

            function isRegistred(configId) {
                return _gridConfigsList.hasOwnProperty(configId);
            }

            function changeColumLabel(gridconfigId, colName, newName){
                let col;               

                if(_gridConfigsList[gridconfigId] && _gridConfigsList[gridconfigId].availableColumns){
                    col = ArrayUtils.find(_gridConfigsList[gridconfigId].availableColumns, function(item){
                        return item.field == colName;
                    });
                }
                
                if(!col && _gridConfigsList[gridconfigId] && _gridConfigsList[gridconfigId].selectedColumns){
                    col = ArrayUtils.find(_gridConfigsList[gridconfigId].selectedColumns, function(item){
                        return item.field == colName;
                    });
                }

                if(col){
                    col.displayName = newName;
                }
            }

            function setConfig(config){
                if(config){
                    _configs[config.id] = config.cfg;
                }
            }

        }]);

angular
    .module('snk.components.gridconfig')
    .service('GridConfigUiGrid', ['SanPopup', '$translate', '$q', '$timeout', 'ServiceProxy', 'ArrayUtils', 'SkApplication', 'DateUtils', 'DateUtilsConstants', 'AngularUtil',
        function (SanPopup, $translate, $q, $timeout, ServiceProxy, ArrayUtils, SkApplication, DateUtils, DateUtilsConstants, AngularUtil) {
            var self = this;

            self.openGridconfig = openGridconfig;
            self.registerGridConfig = registerGridConfig;
            self.registerTargetGridController = registerTargetGridController;
            self.closeGridConfig = closeGridConfig;
            self.forceCloseGridConfig = forceCloseGridConfig;

            self.getAvailableColumns = getAvailableColumns;
            self.getSelectedColumns = getSelectedColumns;
            self.getOrderedColumns = getOrderedColumns;

            self.addOrderedColumn = addOrderedColumn;

            self.sortAvailableColumns = sortAvailableColumns;

            self.updateColumnWidth = updateColumnWidth;
            self.updateColumnOrder = updateColumnOrder;

            self.setCompactMode = setCompactMode;
            self.getCompactMode = getCompactMode;

            self.togglePinColumn = togglePinColumn;
            self.getPinnedColumns = getPinnedColumns;

            self.loadConfigurations = loadConfigurations;
            self.save = save;
            self.restoreGridConfig = restoreGridConfig;

            self.unregistry = unregistry;

            self.openGroup = openGroup;

            var _gridConfigsList = {};
            var _waitingGrids = {};
            var _waitingGridsForLoad = [];
            var _charToPixelRatio = 14;
            var _restrictConfig = false;

            var _gridConfigContentInstance;

            var LOAD_CONFIG = "mge@GridConfig.getGridConfigFromJson";
            var SAVE_CONFIG = "mge@GridConfig.saveGridConfigFromJSON";
            var RESTORE_CONFIG = "mge@GridConfig.restoreGridConfigFromJson";

            function openGridconfig(gridconfigId, options) {
                $timeout(function () {
                    f();
                });

                var f = function () {
                    var btnTour = angular.element('<button default><sk-icon font-icon="train"></sk-icon><sk-i18n>EntityStartPage.sideMenu.lblIniciarTour</sk-i18n></button>');
                    AngularUtil.compile(btnTour);

                    _gridConfigContentInstance = SanPopup.open({
                        id: gridconfigId ? 'POP_GRIDCONFIG_' + gridconfigId : undefined,
                        title: $translate.instant('GridConfig.titulo'),
                        templateUrl: 'components/gridconfig/gridconfigcontent.tpl.html',
                        controller: 'SkGridconfigContentController',
                        controllerAs: 'gridConfigContentCtrl',
                        type: 'default',
                        okBtnLabel: $translate.instant('GridConfig.restaurarPadrao'),
                        noBtnLabel: $translate.instant('Geral.lblSalvar'),
                        okBtnClass: 'btn-default',
                        noBtnClass: 'btn-primary',
                        cancelBtnClass: 'btn-default',
                        showBtnCancel: true,
                        showBtnNo: true,
                        size: 'lg',
                        windowClass: 'gridconfig-modal-window',
                        backdrop: 'static',
                        animation: false,
                        leftBottomBar: [btnTour],
                        resolve: {
                            gridconfigId: function () {
                                return gridconfigId;
                            },
                            availableColumns: function () {
                                return _gridConfigsList[gridconfigId].availableColumns;
                            },
                            selectedColumns: function () {
                                return _gridConfigsList[gridconfigId].selectedColumns;
                            },
                            orderedColumns: function () {
                                return _gridConfigsList[gridconfigId].orderedColumns;
                            },
                            restrictConfig: function () {
                                return _restrictConfig;
                            },
                            isSup: function () {
                                return SkApplication.instance().isSup();
                            },
                            isTourMode: function() {
                                return options && options.isTourMode;
                            },
                            btnTour: function() {
                                return btnTour;
                            },
                            isAggrid : function(){
                                return false;
                            }
                        }
                    });
                }
            }

            function registerGridConfig(gridconfigId, configName, configValidDateTime, reuseGridConfig) {
                if (!gridconfigId) {
                    new Error("Erro interno: é necessário informar o id do gridconfig.");
                }
                if (!configName) {
                    new Error("Erro interno: é necessário informar o configName do gridconfig.");
                }
                if (!reuseGridConfig && _gridConfigsList.hasOwnProperty(gridconfigId)) {
                    new Error("Erro interno: gridconfig com id " + gridconfigId + " já registrado.");
                }

                /*
                    Se so substutuimos na lista de configs de ela não eh reusable ou
                    ainda não foi criada.
                */
                if(!reuseGridConfig || !_gridConfigsList.hasOwnProperty(gridconfigId)){

                    _gridConfigsList[gridconfigId] = {
                        configName: configName,
                        configValidDateTime: configValidDateTime,
                        sorting: false,
                        compactMode: true,
                        availableColumns: [],
                        selectedColumns: [],
                        orderedColumns: []
                    };

                }

                if (_waitingGrids[gridconfigId]) {
                	_gridConfigsList[gridconfigId].gridController = _waitingGrids[gridconfigId];
                	delete _waitingGrids[gridconfigId];
                }
                
                var gridToLoadIndex = _waitingGridsForLoad.indexOf(gridconfigId);
                if(gridToLoadIndex > -1) {
                	loadConfigurations(gridconfigId);
                	_waitingGridsForLoad.splice(gridToLoadIndex,1);
                }
            }

            function unregistry(gridconfigId) {
                delete _gridConfigsList[gridconfigId];
                delete _waitingGrids[gridconfigId];
            }

            function registerTargetGridController(gridconfigId, controller) {
                if (!gridconfigId) {
                    new Error("Erro interno: é necessário informar o id do gridconfig.");
                }
                if (!controller) {
                    new Error("Erro interno: é necessário informar o controlador do datagrid.");
                }

                if (!_gridConfigsList.hasOwnProperty(gridconfigId)) {
                  _waitingGrids[gridconfigId] = controller;
                } else {
                    _gridConfigsList[gridconfigId].gridController = controller;
                }
            }

            function loadConfigurations(gridconfigId) {
            	if(!_gridConfigsList[gridconfigId]) {
            		_waitingGridsForLoad.push(gridconfigId);
            		return;
            	}
            	
                validateState(gridconfigId);
                
                var _configName = "GrdCfgHtml5:" + _gridConfigsList[gridconfigId].configName;

                var gridConfigRequest = {
                    gridConfig: {
                        configName: _configName
                    }
                };

                if (_gridConfigsList[gridconfigId].configValidDateTime) {
                    var dateStr = _gridConfigsList[gridconfigId].configValidDateTime.getTime();
                    gridConfigRequest.gridConfig.validDateTime = dateStr;
                }

                ServiceProxy.callService(LOAD_CONFIG, gridConfigRequest)
                    .then(function (result) {
                        if (!processLoadResult(result, gridconfigId)) {
                            setAllColumnsVisible(gridconfigId);
                        }

                        _gridConfigsList[gridconfigId].gridController.refreshView();
                    });
            }

            function validateState(gridconfigId) {
                if (!_gridConfigsList.hasOwnProperty(gridconfigId)) {
                    new Error("Erro interno: gridconfig com id '" + gridconfigId + "' não encontrado.");
                }
            }

            function processLoadResult(result, gridconfigId) {
                //Faz uma cópia das configurações vindas do dataset
                if (!_gridConfigsList[gridconfigId].originalColumnDefs) {
                    _gridConfigsList[gridconfigId].originalColumnDefs = _gridConfigsList[gridconfigId].gridController.getColumnDefs().slice(0);
                }

                _gridConfigsList[gridconfigId].selectedColumns.length = 0;
                _gridConfigsList[gridconfigId].availableColumns.length = 0;
                _gridConfigsList[gridconfigId].orderedColumns.length = 0;

                //Obtem a lista de todas as colunas
                var columnDefsCopy = _gridConfigsList[gridconfigId].gridController.getColumnDefs().slice(0);

                var columnsSelected = [];
                var columnsUnselected = [];

                //Remove a coluna de checkbox e a coluna em branco
                if (columnDefsCopy[0] && columnDefsCopy[0].transient) {
                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[0]);
                }

                if (columnDefsCopy[columnDefsCopy.length - 1] && columnDefsCopy[columnDefsCopy.length - 1].transient) {
                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[columnDefsCopy.length - 1]);
                }

                if (result.responseBody == undefined || result.responseBody.gridConfig == undefined) {
                    return false;
                }

                _restrictConfig = result.responseBody.gridConfig.restrictBySup;

                _gridConfigsList[gridconfigId].pinnedColumns = result.responseBody.gridConfig.pinnedColumns;

                if (result.responseBody.gridConfig.hasOwnProperty('compactMode')) {
                    _gridConfigsList[gridconfigId].compactMode = result.responseBody.gridConfig.compactMode;
                }

                if (result.responseBody.gridConfig.restrict) {
                    processLoadResultWithRestictFields(gridconfigId, result, columnDefsCopy);
                    return true;
                }

                //Processa a resposta
                var fieldsResult = result.responseBody.gridConfig.field != undefined ? result.responseBody.gridConfig.field : undefined;

                if(fieldsResult == undefined) {
                    for(var i = 0; i < _gridConfigsList[gridconfigId].originalColumnDefs.length; i++) {
                        var col = _gridConfigsList[gridconfigId].originalColumnDefs[i];

                        if(col.presentationType == 'I' || col.skVisible == false) {
                            continue;
                        }

                        var column = {
                            field: col.field,
                            displayName: col.displayName,
                            selected: false,

                            name: col.skName,
                            orderIndex: 0,
                            checked: false,
                            direction: 'asc',
                            width: col.width
                        };
                        _gridConfigsList[gridconfigId].selectedColumns.push(column);
                    }

                    for (var k = 0; k < _gridConfigsList[gridconfigId].selectedColumns.length; k++) {
                        _gridConfigsList[gridconfigId].orderedColumns.push(_gridConfigsList[gridconfigId].selectedColumns[k]);
                    }

                    if (_gridConfigsList[gridconfigId].gridController) {
                        setupDatagrid(gridconfigId, true);
                    }
                    return true;
                }
                else {
                    //Define as colunas selecionadas (visíveis)
                    var length = 0;
                    var isObject = false;
                    if (angular.isArray(fieldsResult)) {
                        length = fieldsResult.length;
                    }
                    else if (angular.isObject(fieldsResult)) {
                        length = Object.keys(fieldsResult).length;
                        isObject = true;
                    }

                    for (var i = 0; i < length; i++) {
                        var fieldResult;
                        if (isObject) {
                            fieldResult = fieldsResult['field' + i];
                        }
                        else {
                            fieldResult = fieldsResult[i];
                        }

                        var name = fieldResult.name;
                        var orderIndex = fieldResult.orderIndex;
                        var width = fieldResult.width;
                        var ascending = fieldResult.ascending;

                        for (var j = 0; j < columnDefsCopy.length; j++) {
                            var col = columnDefsCopy[j];

                            if(col.presentationType == 'I' || col.skVisible == false) {
                                continue;
                            }

                            var adjustedName;
                            if (col.skName.indexOf('.') > -1) {
                                adjustedName = col.skName.replace(/\./g, '_');
                            }
                            else {
                                adjustedName = col.skName;
                            }

                            var adjustedFieldName;
                            if (restrictFieldName.indexOf('.') > -1) {
                                adjustedFieldName = restrictFieldName.replace(/\./g, '_');
                            }
                            else {
                                adjustedFieldName = restrictFieldName;
                            }

                            if (adjustedName == adjustedFieldName) {
                                var column = {
                                    field: col.field,
                                    displayName: col.displayName,
                                    selected: false,

                                    name: adjustedName !== col.skName ? col.skName : name,
                                    orderIndex: orderIndex,
                                    checked: false,
                                    width: width
                                };

                                if (ascending != undefined) {
                                    column.checked = true;
                                    column.direction = ascending == true ? 'asc' : 'dec';
                                    columnsSelected.push(column);
                                }
                                else {
                                    column.direction = 'asc';
                                    columnsUnselected.push(column);
                                }

                                _gridConfigsList[gridconfigId].selectedColumns.push(column);
                                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[j]);

                                break;
                            }
                        }
                    }

                    //Define as colunas disponíveis (não visíveis)
                    for (var i = 0; i < columnDefsCopy.length; i++) {
                        var col = columnDefsCopy[i];

                        if(col.presentationType == 'I' || col.skVisible == false) {
                            continue;
                        }

                        var column = {
                            field: col.field,
                            displayName: col.displayName,
                            selected: false,
                            checked: false,

                            name: col.skName,
                            orderIndex: 0,
                            width: col.width || Math.max((Math.min(col.displayName.toString().length, 30) * _charToPixelRatio), 130)
                        };

                        _gridConfigsList[gridconfigId].availableColumns.push(column);
                    }

                    sortColumns(columnsSelected, 'orderIndex');
                    sortColumns(columnsUnselected, 'displayName');

                    var concatenedList = columnsSelected.concat(columnsUnselected);
                    for (var k = 0; k < concatenedList.length; k++) {
                        _gridConfigsList[gridconfigId].orderedColumns.push(concatenedList[k]);
                    }

                    sortAvailableColumns(gridconfigId);

                    if (_gridConfigsList[gridconfigId].gridController) {
                        setupDatagrid(gridconfigId);
                    }
                    return true;
                }
            }

            function processLoadResultWithRestictFields(gridconfigId, result, columnDefsCopy) {
                var restrictFields = result.responseBody.gridConfig.restrict.field;
                var userFields = result.responseBody.gridConfig.field;

                var columnsSelected = [];
                var columnsUnselected = [];

                var length = 0;
                var isObject = false;
                if (angular.isArray(restrictFields)) {
                    length = restrictFields.length;
                }
                else if (angular.isObject(restrictFields)) {
                    length = Object.keys(restrictFields).length;
                    isObject = true;
                }

                for (var i = 0; i < length; i++) {
                    var restrictField;
                    if (isObject) {
                        restrictField = restrictFields['field' + i];
                    }
                    else {
                        restrictField = restrictFields[i];
                    }

                    var restrictFieldName = restrictField.name;
                    var fieldFound = false;

                    var userFieldsLength = 0;
                    var userFieldIsObject;
                    if (angular.isArray(userFields)) {
                        userFieldsLength = userFields.length;
                        userFieldIsObject = false;
                    }
                    else if (angular.isObject(userFields)) {
                        userFieldsLength = Object.keys(userFields).length;
                        userFieldIsObject = true;
                    }

                    for (var j = 0; j < userFieldsLength; j++) {
                        var userField;
                        if (userFieldIsObject) {
                            userField = userFields['field' + j];
                        }
                        else {
                            userField = userFields[j];
                        }
                        if (userField.name == restrictFieldName) {
                            fieldFound = true;
                            break;
                        }
                    }

                    for (var j = 0; j < columnDefsCopy.length; j++) {
                        var col = columnDefsCopy[j];

                        if(col.presentationType == 'I' || col.skVisible == false) {
                            continue;
                        }

                        var adjustedName;
                        if (col.skName.indexOf('.') > -1) {
                            adjustedName = col.skName.replace(/\./g, '_');
                        }
                        else {
                            adjustedName = col.skName;
                        }

                        var adjustedFieldName;
                        if (restrictFieldName.indexOf('.') > -1) {
                            adjustedFieldName = restrictFieldName.replace(/\./g, '_');
                        }
                        else {
                            adjustedFieldName = restrictFieldName;
                        }

                        if (adjustedName == adjustedFieldName) {
                            var ascending = userField.ascending;

                            var column = {
                                field: col.field,
                                displayName: col.displayName,
                                selected: false,

                                name: adjustedName !== col.skName ? col.skName : restrictFieldName,
                                orderIndex: fieldFound ? userField.orderIndex : "0",
                                checked: false,
                                width: fieldFound ? userField.width : Math.max((Math.min(col.displayName.toString().length, 30) * _charToPixelRatio), 130)
                            };

                            if (ascending != undefined) {
                                column.checked = true;
                                column.direction = ascending == true ? 'asc' : 'dec';
                                columnsSelected.push(column);
                            }
                            else {
                                column.direction = 'asc';
                                columnsUnselected.push(column);
                            }

                            if (fieldFound) {
                                _gridConfigsList[gridconfigId].selectedColumns.push(column);
                                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[j]);
                            }
                            else {
                                _gridConfigsList[gridconfigId].availableColumns.push(column);
                                ArrayUtils.removeReference(columnDefsCopy, columnDefsCopy[j]);
                            }

                            break;
                        }
                    }
                }

                sortColumns(columnsSelected, 'orderIndex');
                sortColumns(columnsUnselected, 'displayName');

                var concatenedList = columnsSelected.concat(columnsUnselected);
                for (var k = 0; k < concatenedList.length; k++) {
                    _gridConfigsList[gridconfigId].orderedColumns.push(concatenedList[k]);
                }

                if (_gridConfigsList[gridconfigId].gridController) {
                    setupDatagrid(gridconfigId);
                }
            }

            function sortAvailableColumns(gridconfigId) {
                if (!_gridConfigsList[gridconfigId].sorting) {
                    _gridConfigsList[gridconfigId].sorting = true;
                    sortColumns(_gridConfigsList[gridconfigId].availableColumns, 'displayName');
                    _gridConfigsList[gridconfigId].sorting = false;
                }
            }

            function sortColumns(collection, field) {
                collection.sort(function (a, b) {
                    if (!a && !b) {
                        return 0;
                    }
                    else if (a && !b) {
                        return 1;
                    }
                    else if (!a && b) {
                        return -1;
                    }
                    else {
                        var strA = a[field].toString().toLowerCase();
                        var strB = b[field].toString().toLowerCase();
                        return strA === strB ? 0 : (strA < strB ? -1 : 1);
                    }
                });
            }

            function setupDatagrid(gridconfigId) {
                var gridController = _gridConfigsList[gridconfigId].gridController;
                var columnDefs = gridController.getColumnDefs();

                var checkBoxCol;
                var blankCol;

                var columnsMap = columnDefs.reduce(function(map, colDef){
                    if (colDef.field == '-100000') {
                        checkBoxCol = colDef;
                    } else if (colDef.field == '9999') {
                        blankCol = colDef;
                    } else {
                        map[colDef.skName] = colDef;
                        }
                    
                    return map;
                }, {});

                columnDefs.length = 0;

                _gridConfigsList[gridconfigId].selectedColumns.forEach(function(selectedColumn) {
                    var datagridColumn = columnsMap[selectedColumn.name];

                    if (datagridColumn) {
                            datagridColumn.visible = datagridColumn.skVisible;
                            datagridColumn.width = parseInt(selectedColumn.width);

                            var datagridColumnObj = gridController.getGridApi().grid.getColumn(datagridColumn.field);
                            if(datagridColumnObj) {
                                datagridColumnObj.width = datagridColumn.width;
                            }

                        columnDefs.push(datagridColumn);
                        delete columnsMap[selectedColumn.name];
                    }
                });

                //colunas que sobraram
                angular.forEach(columnsMap, function(columnDef, name) {
                    columnDef.visible = false;
                    columnDefs.push(columnDef);
                });

                if (checkBoxCol) {
                    columnDefs.unshift(checkBoxCol);
                    }

                if (blankCol) {
                    columnDefs.push(blankCol);
                }

                for (var i = 0; i < _gridConfigsList[gridconfigId].availableColumns.length; i++) {
                    var availableColumn = _gridConfigsList[gridconfigId].availableColumns[i];
                    for (var j = 0; j < columnDefs.length; j++) {
                        var datagridColumn = columnDefs[j];
                        if (datagridColumn.skName != availableColumn.name) {
                            continue;
                        }
                        else {
                            datagridColumn.visible = false;
                        }
                    }
                }

                for (var i = 0; i < _gridConfigsList[gridconfigId].orderedColumns.length; i++) {
                    var orderedColumn = _gridConfigsList[gridconfigId].orderedColumns[i];
                    var datagridColumn = gridController.getGridApi().grid.getColumn(orderedColumn.field);
                    if (datagridColumn.sort) {
                        if (orderedColumn.checked) {
                            datagridColumn.sort.direction = orderedColumn.direction == 'asc' ? 'asc' : 'desc';
                            datagridColumn.sort.priority = orderedColumn.orderIndex + 1;
                        }
                        else {
                            datagridColumn.sort.direction = undefined;
                        }
                    }
                }

                gridController.setCompactMode(getCompactMode(gridconfigId));

                var params = {
                    columns: gridController.getGridApi().grid.columns,
                    rows: gridController.getGridApi().grid.rows
                };

                gridController.skSortFunction(params);

                gridController.getGridApi().core.refreshRows();
                gridController.updateAllOptions();
                gridController.updatePinnedColumns();

                //Neste caso, é necessário que um apply aconteça após o digest
                $timeout(function() {
                    gridController.refreshView();
                });
            }

            function swapItems(collection, firstIndex, secondIndex) {
                if (!collection[firstIndex] || !collection[secondIndex]) {
                    return;
                }
                var tmp = collection[firstIndex];
                collection[firstIndex] = collection[secondIndex];
                collection[secondIndex] = tmp;
            }

            function getAvailableColumns(gridconfigId) {
                validateState(gridconfigId);
                return _gridConfigsList[gridconfigId].availableColumns;
            }

            function getSelectedColumns(gridconfigId) {
                validateState(gridconfigId);
                return _gridConfigsList[gridconfigId].selectedColumns;
            }

            function getOrderedColumns(gridconfigId) {
                validateState(gridconfigId);
                return _gridConfigsList[gridconfigId].orderedColumns;
            }

            function save(gridconfigId, restrictConfig) {
                validateState(gridconfigId);

                var grdConfig = _gridConfigsList[gridconfigId];

                var cfg = {
                    gridConfig: {
                        restrictBySup: restrictConfig,
                        configName: "GrdCfgHtml5:" + grdConfig.configName,
                        compactMode: grdConfig.compactMode,
                        field: {}
                    }
                };

                if (grdConfig.selectedColumns.length > 0) {
                    for (var i = 0; i < _gridConfigsList[gridconfigId].selectedColumns.length; i++) {
                        var column = _gridConfigsList[gridconfigId].selectedColumns[i];
                        var orderData = getColumnOrderData(gridconfigId, column);

                        var fieldCfg = {
                            name: column.name,
                            width: column.width < 50 ? 50 : column.width,
                            orderIndex: orderData.orderIndex
                        };

                        if (orderData.ascending != undefined) {
                            fieldCfg.ascending = orderData.ascending;
                        }

                        cfg.gridConfig.field['field' + i] = fieldCfg;
                    }
                }
                else {
                    for (var i = 0; i < grdConfig.availableColumns.length; i++) {
                        var column = grdConfig.availableColumns[i];
                        var orderData = getColumnOrderData(gridconfigId, column);

                        var fieldCfg = {
                            name: column.name,
                            width: column.width,
                            orderIndex: 0
                        };

                        cfg.gridConfig.field['field' + i] = fieldCfg;
                    }
                }

                cfg.gridConfig.pinnedColumns = grdConfig.pinnedColumns;

                ServiceProxy.callService(SAVE_CONFIG, cfg)
                    .then(function (result) {
                        processLoadResult(result, gridconfigId);
                        $timeout(function () {
                            _gridConfigsList[gridconfigId].gridController.updateGridColumn();
                        },0,false);
                    });
            }

            function getColumnOrderData(gridconfigId, column) {
                var orderData = {
                    orderIndex: 0
                };
                for (var i = 0; i < _gridConfigsList[gridconfigId].orderedColumns.length; i++) {
                    var orderedColumn = _gridConfigsList[gridconfigId].orderedColumns[i];
                    if (orderedColumn.checked && column.displayName == orderedColumn.displayName) {
                        orderData.orderIndex = i;
                        orderData.ascending = orderedColumn.direction == 'asc';
                        break;
                    }
                }
                return orderData;
            }

            function restoreGridConfig(gridconfigId) {

                var columnDefs = _gridConfigsList[gridconfigId].gridController.getColumnDefs();
                columnDefs.length = 0;
                for (var i = 0; i < _gridConfigsList[gridconfigId].originalColumnDefs.length; i++) {
                    columnDefs[i] = _gridConfigsList[gridconfigId].originalColumnDefs[i];
                }

                var request = {
                    gridConfig: {
                        configName: "GrdCfgHtml5:" + _gridConfigsList[gridconfigId].configName
                    }
                };

                ServiceProxy.callService(RESTORE_CONFIG, request)
                    .then(function (result) {
                        if (processLoadResult(result, gridconfigId)) {
                            _gridConfigsList[gridconfigId].gridController.updateAllOptions();
                        }
                        else {
                            setAllColumnsVisible(gridconfigId);
                        }
                        $timeout(function () {
                            closeGridConfig(gridconfigId);
                        });
                    });
            }

            function updateColumnWidth(gridconfigId, fieldName, deltaChange, newWidth) {
                for (var i = 0; i < _gridConfigsList[gridconfigId].selectedColumns.length; i++) {
                    var selectedColumn = _gridConfigsList[gridconfigId].selectedColumns[i];

                    if (selectedColumn.name == fieldName) {
                        /*
                        if ((!deltaChange || deltaChange == 0) && newWidth != 0) {
                            selectedColumn.width = newWidth;
                            save(gridconfigId);
                        }
                        else {
                            selectedColumn.width = selectedColumn.width + deltaChange;
                            save(gridconfigId);
                        }
                        */
                        if(newWidth != undefined && newWidth > 0) {
                            selectedColumn.width = newWidth;
                            save(gridconfigId);
                        }
                        else if(deltaChange != undefined && !isNaN(Number(selectedColumn.width))) {
                            selectedColumn.width = Number(selectedColumn.width) + deltaChange;
                            save(gridconfigId);
                        }
                        break;
                    }
                }
            }

            function togglePinColumn(gridconfigId, colDef, pinning){
                var config = _gridConfigsList[gridconfigId];

                var fieldName = colDef.skName;
                var index = -1;

                if (pinning){
                    if (!config.pinnedColumns){
                        config.pinnedColumns = [];
                    } else {
                        index = ArrayUtils.indexOf(config.pinnedColumns, fieldName);
                    }

                    if (index == -1){
                        config.pinnedColumns.push(fieldName);
                    }
                } else if ((index = ArrayUtils.indexOf(config.pinnedColumns, fieldName)) > -1) {
                    ArrayUtils.removeAtIndex(config.pinnedColumns, index);

                    if (config.pinnedColumns.length == 0){
                        delete config.pinnedColumns;
                    }
                }

                save(gridconfigId);
            }

            function setCompactMode(gridconfigId, value) {
                if (!gridconfigId) {
                    return;
                }

                var config = _gridConfigsList[gridconfigId];

                config.compactMode = value;

                save(gridconfigId);
            }

            function getCompactMode(gridConfigId) {
                if (!gridConfigId) {
                    return true;
                }

                var config = _gridConfigsList[gridConfigId];

                if (!config || !config.hasOwnProperty('compactMode')) {
                    return true;
                }

                return config.compactMode;
            }

            function getPinnedColumns(gridconfigId) {
                return _gridConfigsList[gridconfigId].pinnedColumns;
            }

            function updateColumnOrder(gridconfigId, originalPosition, newPosition) {
                if (newPosition < originalPosition) {
                    for (var i = originalPosition; i > newPosition; i--) {
                        swapItems(_gridConfigsList[gridconfigId].selectedColumns, i, i - 1);
                    }
                    save(gridconfigId);
                }
                else if (newPosition > originalPosition) {
                    for (var i = originalPosition; i < newPosition; i++) {
                        swapItems(_gridConfigsList[gridconfigId].selectedColumns, i, i + 1);
                    }
                    save(gridconfigId);
                }
            }

            function setAllColumnsVisible(gridconfigId) {
                var columnDefsCopy = _gridConfigsList[gridconfigId].gridController.getColumnDefs().slice(0);

                _gridConfigsList[gridconfigId].selectedColumns.length = 0;
                _gridConfigsList[gridconfigId].availableColumns.length = 0;
                for (var i = 0; i < columnDefsCopy.length; i++) {
                    var col = columnDefsCopy[i];

                    if (col.skVisible) {
                        var column = {
                            field: col.field,
                            displayName: col.displayName,
                            selected: false,

                            name: col.skName,
                            orderIndex: 0,
                            width: _gridConfigsList[gridconfigId].gridController.getColumnWidth(col.displayName.toString())
                        };

                        _gridConfigsList[gridconfigId].selectedColumns.push(column);
                    }
                }
                _gridConfigsList[gridconfigId].gridController.resetColumnWidths();
                buildOrderedColumns(gridconfigId);
                setupDatagrid(gridconfigId, true);
            }

            function closeGridConfig(gridconfigId) {
                $timeout(function () {
                    setupDatagrid(gridconfigId);
                });
            }

            function forceCloseGridConfig() {
                if(_gridConfigContentInstance) {
                    _gridConfigContentInstance.dismiss();
                }
            }

            function buildOrderedColumns(gridconfigId) {
                var selectedColumns = _gridConfigsList[gridconfigId].selectedColumns.slice(0);

                _gridConfigsList[gridconfigId].orderedColumns.length = 0;
                for (var i = 0; i < selectedColumns.length; i++) {
                    var selectedColumn = selectedColumns[i];
                    selectedColumn.selected = false;
                    selectedColumn.direction = 'asc';
                    _gridConfigsList[gridconfigId].orderedColumns.push(selectedColumn);
                }

                if (_gridConfigsList[gridconfigId].orderedColumns.length > 0) {
                    sortColumns(_gridConfigsList[gridconfigId].orderedColumns, 'displayName');
                }
            }

            function addOrderedColumn(gridconfigId, column) {
                _gridConfigsList[gridconfigId].orderedColumns.push(column);
                sortColumns(_gridConfigsList[gridconfigId].orderedColumns, 'displayName');
            }

            function openGroup(groupIndex) {
                if(_gridConfigContentInstance && _gridConfigContentInstance.$controller) {
                    _gridConfigContentInstance.$controller.openGroup(groupIndex);
                }
            }

        }]);
angular
    .module('snk.components.gridconfig')
    .controller('SkGridconfigContentController', ['$scope', '$translate', '$timeout', '$location', '$anchorScroll', 'DatagridTourContent', 'gridconfigId', 'isSup', 'isTourMode', 'restrictConfig', 'availableColumns', 'selectedColumns', 'orderedColumns', 'PositionUtils', 'UserAgentUtils', 'ArrayUtils', 'MessageUtils', 'ServiceProxy', '$popupInstance', 'AngularUtil', 'DomUtil', 'btnTour', '$injector', 'isAggrid', 'visibleColumns', 'StringUtils',
        function ($scope, $translate, $timeout, $location, $anchorScroll, DatagridTourContent, gridconfigId, isSup, isTourMode, restrictConfig, availableColumns, selectedColumns, orderedColumns, PositionUtils, UserAgentUtils, ArrayUtils, MessageUtils, ServiceProxy, $popupInstance, AngularUtil, DomUtil, btnTour, $injector, isAggrid, visibleColumns, StringUtils) {
            var self = this;
            var GridConfig;
            var serviceConfigName = isAggrid ? 'GridConfig' : 'GridConfigUiGrid';

            $injector.invoke([serviceConfigName, function(service){
                GridConfig = service;
            }]);
            
            self.orderedColumns = orderedColumns;

            self.colunasDisponiveisTerm = undefined;
            self.colunasSelecionadasTerm = undefined;
            self.colunasOrdenadasTerm = undefined;

            self.openGroup = openGroup;

            self.restrictConfig = restrictConfig;

            $scope.isMobile = UserAgentUtils.isMobile();

            $scope.isTourMode = isTourMode;

            $scope.sortableConfigForAvailableColumns = getSortableConfiguration('availableColumns');
            $scope.sortableConfigForSelectedColumns = getSortableConfiguration('selectedColumns');

            $scope.originalAvailableColumns = angular.copy(availableColumns);
            $scope.originalSelectedColumns = angular.copy(selectedColumns);

            $scope.availableColumns = availableColumns;
            $scope.selectedColumns = selectedColumns;

            $scope.orderedColumns = orderedColumns;
            
            $scope.visibleColumns = visibleColumns;
            $scope.availableColumnsSelected = [];
            $scope.selectedColumnsSelected = [];

            $scope.lblSelecaoDeColunas = $translate.instant('GridConfig.lblSelecaoDeColunas');
            $scope.lblOrdenacaoDosDados = $translate.instant('GridConfig.lblOrdenacaoDosDados');
            $scope.lblColunasSelecionadas = $translate.instant('GridConfig.colunasSelecionadas');
            $scope.lblColunasDisponiveis = $translate.instant('GridConfig.colunasDisponiveis');
            $scope.lblPesquisar = $translate.instant('GridConfig.lblPesquisar');
            $scope.colunasInputTooltip = $translate.instant('GridConfig.colunasInputTooltip');
            $scope.lblCamposTodosUsuarios = $translate.instant('GridConfig.lblCamposTodosUsuarios');
            $scope.camposTodosUsuariosTooltip = $translate.instant('GridConfig.camposTodosUsuariosTooltip');
            $scope.lblAscendente = $translate.instant('GridConfig.lblAscendente');
            $scope.lblDescendente = $translate.instant('GridConfig.lblDescendente');

            $scope.lblMoverTodosDireita = $translate.instant('GridConfig.lblMoverTodosDireita');
            $scope.lblMoverParaDireita = $translate.instant('GridConfig.lblMoverParaDireita');
            $scope.lblMoverTodosEsquerda = $translate.instant('GridConfig.lblMoverTodosEsquerda');
            $scope.lblMoverParaEsquerda = $translate.instant('GridConfig.lblMoverParaEsquerda');

            $scope.lblMoverParaPrimeiro = $translate.instant('GridConfig.lblMoverParaPrimeiro');
            $scope.lblMoverParaCima = $translate.instant('GridConfig.lblMoverParaCima');
            $scope.lblMoverParaBaixo = $translate.instant('GridConfig.lblMoverParaBaixo');
            $scope.lblMoverParaUltimo = $translate.instant('GridConfig.lblMoverParaUltimo');

            $scope.isSup = isSup;

            $scope.flexWidth = $scope.isMobile ? 85 : 90;

            $scope.itemClickHandler = itemClickHandler;
            $scope.keydownHandler = keydownHandler;

            $scope.onKeydownAtSearchHandlerForAvailableColumns = onKeydownAtSearchHandlerForAvailableColumns;
            $scope.onKeydownAtSearchHandlerForSelectedColumns = onKeydownAtSearchHandlerForSelectedColumns;
            $scope.onKeydownAtSearchHandlerForOrderColumns = onKeydownAtSearchHandlerForOrderColumns;
            $scope.isSomeAvailableColumnSelected = isSomeAvailableColumnSelected;
            $scope.isSomeSelectedColumnSelected = isSomeSelectedColumnSelected;
            $scope.changeSelectedColumnsSort = changeSelectedColumnsSort;
            $scope.changeOrderedColumnsSort = changeOrderedColumnsSort;
            $scope.changeOrderedColumnDirection = changeOrderedColumnDirection;
            $scope.toggleOrderedColumn = toggleOrderedColumn;
            $scope.swapSelectedColumns = swapSelectedColumns;
            $scope.removeSpecialChars = removeSpecialChars;
            $scope.moveColumns = moveColumns;
            $scope.adjustID = adjustID;

            var _lastSelectedColumnIndex = 0;
            var _lastAvailableColumnIndex = 0;
            var _lastOrderedColumnIndex = 0;

            const SCROLL_OFFSET = 20;

            var _searchInfo = {
                availableColumns : {
                    lastSearchTerm: '',
                    lastSearchMatches: [],
                    lastSearchIndex: -1
                },
                selectedColumns: {
                    lastSearchTerm: '',
                    lastSearchMatches: [],
                    lastSearchIndex: -1
                },
                orderedColumns: {
                    lastSearchTerm: '',
                    lastSearchMatches: [],
                    lastSearchIndex: -1
                }
            };

            var msgConfirmaRestaurarConfigPadrao = $translate.instant('GridConfig.msgConfirmaRestaurarConfigPadrao');

            var _availableColumnWatchDeReg;

            var LOAD_CONFIG = "mge@GridConfig.getGridConfig";
            var SAVE_CONFIG = "mge@GridConfig.saveGridConfig";
            var RESTORE_CONFIG = "mge@GridConfig.restoreGridConfig";

            $popupInstance.rendered.then(function(){
                if (isSup){
                    $popupInstance.element.addClass('is-sup');
                }

                if (UserAgentUtils.isMobile()){
                    $popupInstance.element.addClass('is-mobile');
                }
            });

            //O Gridconfig é sempre aberto no primeiro grupo do accordion
            openGroup(0);

            btnTour.on('click', function(){
                AngularUtil.apply($scope, startTour);
            });

            $popupInstance.opened.then(function(){
                AngularUtil.apply($scope);
            });

            $scope.$success = function() {
                confirmRestoreConfig();
            };

            $popupInstance.result.then(function () {

            }, function (reason) {
                if (reason == 'no') {
                    GridConfig.save(gridconfigId, self.restrictConfig, undefined, $scope.visibleColumns);
                } else if (reason == 'cancel' || reason == 'close') {
                    GridConfig.setOriginalRegistersSelected(gridconfigId, $scope.originalAvailableColumns, $scope.originalSelectedColumns);
                }
            });

            function confirmRestoreConfig() {
                MessageUtils
                    .simpleConfirm(MessageUtils.TITLE_CONFIRMATION, msgConfirmaRestaurarConfigPadrao, true)
                    .then(function () {
                        restoreRestoreConfig();
                        GridConfig.closeGridConfig(gridconfigId);
                        $popupInstance.dismiss();
                    }, function (reason) {
                        //Nada a fazer
                    });
            }

            function restoreRestoreConfig() {
                GridConfig.restoreGridConfig(gridconfigId);
            }

            function startTour() {
                if (!$scope.tour) {
                    $scope.tour = DatagridTourContent.getGridConfigTourContent();
                }

                $scope.tour.startTour = true;
            }

            function itemClickHandler(event, column, columnsList) {
                if (columnsList == 'availableColumns') {
                    if (!event.ctrlKey && !event.shiftKey) {
                        unselectAll(columnsList);
                        $scope.availableColumnsSelected.length = 0;
                    }
                    if (!event.shiftKey) {
                        column.selected = true;
                        $scope.availableColumnsSelected.push(column);
                        _lastAvailableColumnIndex = $scope.availableColumns.indexOf(column);
                    }
                    else {
                        var firstIndex = 0;
                        var lastIndex = 0;
                        if ($scope.availableColumns.indexOf(column) > _lastAvailableColumnIndex) {
                            firstIndex = _lastAvailableColumnIndex;
                            lastIndex = $scope.availableColumns.indexOf(column);
                        }
                        else if (_lastAvailableColumnIndex > $scope.availableColumns.indexOf(column)) {
                            firstIndex = $scope.availableColumns.indexOf(column);
                            lastIndex = _lastAvailableColumnIndex;
                        }

                        for (var i = firstIndex; i <= lastIndex; i++) {
                            var colToSelect = $scope.availableColumns[i];
                            colToSelect.selected = true;
                            if ($scope.availableColumnsSelected.indexOf(colToSelect) < 0) {
                                $scope.availableColumnsSelected.push(colToSelect);
                            }
                        }
                        _lastAvailableColumnIndex = i - 1;
                    }
                }
                else if (columnsList == 'selectedColumns') {
                    if (!event.ctrlKey && !event.shiftKey) {
                        unselectAll(columnsList);
                        $scope.selectedColumnsSelected.length = 0;
                    }
                    if (!event.shiftKey) {
                        column.selected = true;
                        $scope.selectedColumnsSelected.push(column);
                        _lastSelectedColumnIndex = $scope.selectedColumns.indexOf(column);
                    }
                    else {
                        var firstIndex = 0;
                        var lastIndex = 0;
                        if ($scope.selectedColumns.indexOf(column) > _lastSelectedColumnIndex) {
                            firstIndex = _lastSelectedColumnIndex;
                            lastIndex = $scope.selectedColumns.indexOf(column);
                        }
                        else if (_lastSelectedColumnIndex > $scope.selectedColumns.indexOf(column)) {
                            firstIndex = $scope.selectedColumns.indexOf(column);
                            lastIndex = _lastSelectedColumnIndex;
                        }

                        for (var i = firstIndex; i <= lastIndex; i++) {
                            var colToSelect = $scope.selectedColumns[i];
                            colToSelect.selected = true;
                            if ($scope.selectedColumnsSelected.indexOf(colToSelect) < 0) {
                                $scope.selectedColumnsSelected.push(colToSelect);
                            }
                        }
                        _lastSelectedColumnIndex = i - 1;
                    }
                }
            }

            function onKeydownAtSearchHandlerForAvailableColumns(event) {
                searchFieldsOnList(event, self.colunasDisponiveisTerm, 'availableColumns', '#grdcfg-colunas-disponiveis-container', '#availableColumn', '#colunasDisponiveisInput');
            }

            function onKeydownAtSearchHandlerForSelectedColumns(event) {
                searchFieldsOnList(event, self.colunasSelecionadasTerm, 'selectedColumns', '#grdcfg-colunas-selecionadas-container', '#selectedColumn', '#colunasSelecionadasInput');
            }

            function onKeydownAtSearchHandlerForOrderColumns(event) {
                searchFieldsOnList(event, self.colunasOrdenadasTerm, 'orderedColumns', '.gridconfig-colunas-order-container', '#orderedColumn', '#colunasOrdenadasInput');
            }

            function searchFieldsOnList(event, searchTerm, sourceListName, listContainerSelector, listItemSelector, searchInputSelector) {
                if (event.keyCode === 13) { //Enter
                    if (!searchTerm) {
                        return;
                    }

                    var termToMatch = StringUtils.replaceCharacterSpecial(StringUtils.replaceAccentuatedChars(searchTerm.toLowerCase()));

                    var matches = _searchInfo[sourceListName].lastSearchMatches;
                    var matchIndex = _searchInfo[sourceListName].lastSearchIndex;

                    if (termToMatch != _searchInfo[sourceListName].lastSearchTerm) {
                        matches.length = 0;
                        var regexpFlags = 'i';
                        var containsRE = new RegExp(termToMatch, regexpFlags);

                        for (var i = 0; i < $scope[sourceListName].length; i++) {
                            var col = $scope[sourceListName][i];
                            col.selected = false;

                            if (containsRE.test(StringUtils.replaceAccentuatedChars(col.displayName))) {
                                matches.push((col));
                            }
                        }

                        _searchInfo[sourceListName].lastSearchIndex = matchIndex = 0;
                        _searchInfo[sourceListName].lastSearchTerm = termToMatch;

                        if (matches.length <= 0) {
                            return;
                        }
                    }

                    unselectAll(sourceListName);

                    if (matchIndex == -1 || matches.length == 0) {
                        return;
                    }

                    var columnToFind;

                    if (matchIndex < matches.length) {
                        if (matchIndex != 0) {
                            matches[matchIndex - 1].selected = false;
                            matches[matchIndex].selected = true;
                            columnToFind = matches[matchIndex].displayName;
                            matchIndex++;
                        }
                        else if(matches[matchIndex]) {
                            matches[matchIndex].selected = true;
                            columnToFind = matches[matchIndex].displayName;
                            matchIndex++;
                        }
                    }
                    else if(matchIndex > 0) {
                        matches[matchIndex - 1].selected = false;
                        matchIndex = 0;
                        matches[matchIndex].selected = true;
                        columnToFind = matches[matchIndex].displayName;
                        matchIndex++;
                    } else if(matchIndex.length > 0) {
                        matchIndex = 0;
                        matches[matchIndex].selected = true;
                        columnToFind = matches[matchIndex].displayName;
                        matchIndex++;
                    }

                    if (_searchInfo[sourceListName].lastSearchIndex != matchIndex) {
                        _searchInfo[sourceListName].lastSearchIndex = matchIndex;
                    }

                    if (angular.isDefined(columnToFind)) {
                        $timeout(function() {
                            var listContainer = angular.element(document.querySelector(listContainerSelector));
                            var columnElement = angular.element(document.querySelector(listItemSelector + adjustID(columnToFind)));

                            scrollTo(listContainer,columnElement);
                            var element = angular.element(document.querySelectorAll(searchInputSelector));
                            if(element[0]) {
                                element[0].focus();
                            }
                        },0,false);
                    }
                }
            }

            function keydownHandler($event) {
                var e = $event;
                console.log(e.keyCode);
            }

            function isSomeSelectedColumnSelected() {
                for (var i = 0; i < $scope.selectedColumns.length; i++) {
                    var col = $scope.selectedColumns[i];
                    if (col.selected) {
                        return true;
                    }
                }
                return false;
            }

            function isSomeAvailableColumnSelected() {
                for (var i = 0; i < $scope.availableColumns.length; i++) {
                    var col = $scope.availableColumns[i];
                    if (col.selected) {
                        return true;
                    }
                }
                return false;
            }

            function changeSelectedColumnsSort(direction) {
                if (direction.toString().toLowerCase() == 'down') {
                    for (var i = $scope.selectedColumns.length - 2; i>=0; i--) {
                        var col = $scope.selectedColumns[i];
                        if (col.selected) {
                            swapSelectedColumns(i + 1, i);
                            _lastSelectedColumnIndex = i;
                        }
                    }
                } else {
                    for (var i = 0; i < $scope.selectedColumns.length; i++) {
                        var col = $scope.selectedColumns[i];
                        if (col.selected) {
                            if (direction.toString().toLowerCase() == 'up') {
                                swapSelectedColumns(i, i - 1);
                                _lastSelectedColumnIndex = i;
                            }
                            else if (direction.toString().toLowerCase() == 'up-all') {
                                for (var j = i; j > 0; j--) {
                                    swapSelectedColumns(j, j - 1);
                                }
                                _lastSelectedColumnIndex = 0;
                                break;
                            }
                            else if (direction.toString().toLowerCase() == 'down-all') {
                                for (var j = i; j < $scope.selectedColumns.length - 1; j++) {
                                    swapSelectedColumns(j, j + 1);
                                }
                                _lastSelectedColumnIndex = $scope.selectedColumns.length - 1;
                                break;
                            }
                        }
                    }
                }
                if(direction.indexOf('up') > -1 && _lastSelectedColumnIndex > 0) {
                    _lastSelectedColumnIndex--;
                } else if(direction.indexOf('down') > -1 && _lastSelectedColumnIndex < ($scope.selectedColumns.length-1)) {
                    _lastSelectedColumnIndex++;
                }

                if (_lastSelectedColumnIndex != undefined) {
                    $timeout(function() {
                        var listContainer = angular.element(document.querySelector(('#grdcfg-colunas-selecionadas-container')));
                        var columnToFindId = '#selectedColumn' + adjustID($scope.selectedColumns[_lastSelectedColumnIndex].displayName);
                        var columnElement = angular.element(document.querySelector(columnToFindId))

                        scrollTo(listContainer,columnElement);
                    },0,false);
                }
            }

            function changeOrderedColumnsSort(direction) {
                var lastSwapped = undefined;
                for (var i = 0; i < $scope.orderedColumns.length; i++) {
                    var col = $scope.orderedColumns[i];
                    if (col.selected) {
                        if (direction.toString().toLowerCase() == 'up') {
                            swapOrderedColumns(i, i - 1);
                            lastSwapped = i;
                        }
                        else if (direction.toString().toLowerCase() == 'down') {
                            swapOrderedColumns(i, i + 1);
                            lastSwapped = i;
                            i++;
                        }
                        else if (direction.toString().toLowerCase() == 'up-all') {
                            for (var j = i; j > 0; j--) {
                                swapOrderedColumns(j, j - 1);
                            }
                            lastSwapped = 0;
                            break;
                        }
                        else if (direction.toString().toLowerCase() == 'down-all') {
                            for (var j = i; j < $scope.orderedColumns.length - 1; j++) {
                                swapOrderedColumns(j, j + 1);
                            }
                            lastSwapped = $scope.orderedColumns.length - 1;
                            break;
                        }
                    }
                }

                if(direction.indexOf('up') > -1 && lastSwapped > 0) {
                    lastSwapped--;
                } else if(direction.indexOf('down') > -1 && lastSwapped < ($scope.orderedColumns.length-1)) {
                    lastSwapped++;
                }

                if (lastSwapped != undefined) {
                    $timeout(function() {
                        var listContainer = angular.element(document.querySelector(('.gridconfig-colunas-order-container')));
                        var columnToFindId = '#orderedColumn' + adjustID($scope.orderedColumns[lastSwapped].displayName);
                        var columnElement = angular.element(document.querySelector(columnToFindId))

                        scrollTo(listContainer,columnElement);
                    },0,false);
                }
            }

            function swapSelectedColumns(firstIndex, secondIndex) {
                var tmp = $scope.selectedColumns[firstIndex];
                $scope.selectedColumns[firstIndex] = $scope.selectedColumns[secondIndex];
                $scope.selectedColumns[secondIndex] = tmp;
            }

            function swapOrderedColumns(firstIndex, secondIndex) {
                var tmp = $scope.orderedColumns[firstIndex];
                $scope.orderedColumns[firstIndex] = $scope.orderedColumns[secondIndex];
                $scope.orderedColumns[secondIndex] = tmp;
            }

            function adjustID(id) {
                var temp = id;

                temp = removeAccents(id);
                temp = removeSpecialChars(temp);

                return temp;
            }

            function removeSpecialChars(str) {
                if (str) {
                    return str.toString().replace(/[^\w\s]/gi, '').replace(/ /g, '');
                }
                return null;
            }

            function removeAccents(str) {
                if(!str) {
                    return undefined;
                }
                var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
                var to   = "aaaaeeeeiiiioooouuuunc------";
                var newStr = str;
                for (var i=0, l=from.length ; i<l ; i++) {
                    newStr = newStr.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }
                return newStr;
            }

            function getSortableConfiguration(columnsType) {
                var sortableConfig = {
                    group: 'gridConfig',
                    disabled: isTourMode,
                    sort: true,
                    onAdd: function (evt) {
                        if (columnsType == 'selectedColumns') {
                            GridConfig.addOrderedColumn(gridconfigId, evt.model);
                        } else if ('availableColumns') {
                            ArrayUtils.removeReference($scope.orderedColumns, evt.model);
                            GridConfig.sortAvailableColumns(gridconfigId);
                        }
                    }
                };

                if ($scope.isMobile) {
                    sortableConfig.handle = '.handle';
                }

                return sortableConfig;
            }

            function moveColumns(sourceList, allColumns) {
                if (isTourMode) {
                    return;
                }

                if (sourceList === 'availableColumns') {
                    unselectAll('selectedColumns');
                    for (var i = 0; i < $scope.availableColumns.length; i++) {
                        var col = $scope.availableColumns[i];
                        if (!allColumns) {
                            if (col.selected) {
                                ArrayUtils.removeReference($scope.availableColumns, col);
                                i--;
                                $scope.selectedColumns.push(col);
                                GridConfig.addOrderedColumn(gridconfigId, col);
                            }
                        }
                        else {
                            $scope.selectedColumns.push(col);
                            GridConfig.addOrderedColumn(gridconfigId, col);
                        }
                    }
                    if (allColumns) {
                        $scope.availableColumns.length = 0;
                    }
                }
                else if (sourceList === 'selectedColumns') {
                    unselectAll('availableColumns');
                    for (var i = 0; i < $scope.selectedColumns.length; i++) {
                        var col = $scope.selectedColumns[i];
                        if (!allColumns) {
                            if (col.selected) {
                                ArrayUtils.removeReference($scope.selectedColumns, col);
                                i--;
                                ArrayUtils.removeReference($scope.orderedColumns, col);
                                $scope.availableColumns.push(col);
                            }
                        }
                        else {
                            $scope.availableColumns.push(col);
                        }
                    }
                    if (allColumns) {
                        $scope.selectedColumns.length = 0;
                        $scope.orderedColumns.length = 0;
                    }

                    GridConfig.sortAvailableColumns(gridconfigId);
                }
            }

            function unselectAll(listName) {
                var list = $scope[listName];

                if (list) {
                    for (var i = 0; i < list.length; i++) {
                        var col = list[i];
                        col.selected = false;
                    }
                }
            }

            function changeOrderedColumnDirection(column) {
                if (column.direction == 'asc') {
                    column.direction = 'dec';
                } else {
                    column.direction = 'asc';
                }
            }

            function toggleOrderedColumn(event, column) {
                if (!event.ctrlKey && !event.shiftKey) {
                    unselectAll('orderedColumns');
                }

                if (!event.shiftKey) {
                    column.checked = !column.checked;
                    column.selected = true;
                    if(column.direction == undefined) {
                        column.direction = 'asc';
                    }
                    _lastOrderedColumnIndex = $scope.orderedColumns.indexOf(column);
                } else {
                    var firstIndex = 0;
                    var lastIndex = 0;
                    if ($scope.orderedColumns.indexOf(column) > _lastOrderedColumnIndex) {
                        firstIndex = _lastOrderedColumnIndex;
                        lastIndex = $scope.orderedColumns.indexOf(column);
                    }
                    else if (_lastOrderedColumnIndex > $scope.orderedColumns.indexOf(column)) {
                        firstIndex = $scope.orderedColumns.indexOf(column);
                        lastIndex = _lastOrderedColumnIndex;
                    }

                    for (var i = firstIndex; i <= lastIndex; i++) {
                        var colToSelect = $scope.orderedColumns[i];
                        colToSelect.selected = true;
                        colToSelect.checked = true;
                    }
                    _lastOrderedColumnIndex = i - 1;
                }
            }

            function openGroup(groupIndex) {
                $timeout(function() {
                    var element = angular.element($popupInstance.element[0].querySelectorAll('#grid-config-group-' + groupIndex));
                    var elementController = AngularUtil.getControllerFromElement(element);
                    if(elementController) {
                        elementController.toggleOpen();
                    }
                },0,false);
            }

            function scrollTo(listContainer,columnElement) {
                if(!listContainer ||listContainer.length <= 0 || !columnElement || columnElement.length <= 0) {
                    return;
                }

                var columnElementPosition = PositionUtils.position(columnElement);
                var columnTop = columnElementPosition.top;

                var listContainerScroll = listContainer.scrollTop();

                var columnBottom = columnElementPosition.height + columnTop - listContainerScroll;

                var diff;

                if (columnBottom > listContainer[0].offsetHeight) {
                    diff = columnBottom - listContainer[0].offsetHeight;
                    DomUtil.scrollTo(listContainer, listContainerScroll + diff + SCROLL_OFFSET);
                } else if(columnTop - listContainerScroll < 0) {
                    diff = columnTop - listContainerScroll;
                    DomUtil.scrollTo(listContainer, listContainerScroll + diff - SCROLL_OFFSET);
                }
            }
        }
    ]);

/**
 * @ngdoc service
 * @name snk.components.gridconfig.service:GridConfigInstance
 *
 * @description
 * Função que deve ser chamada passando o configName do grid a ser manipulado.
 *
 */

angular
    .module("snk.components.gridconfig")
    .provider('GridConfigInstance', [function () {
        this.$get = ['$injector', 'i18n', function ($injector,i18n) {

            function GridConfigInstance(gridConfigId, isUiGrid) {
                var serviceConfigName = isUiGrid ?  'GridConfigUiGrid' : "GridConfig";
                $injector.invoke([serviceConfigName, function(service){
                    GridConfig = service;
                }]);
                this.setId(gridConfigId);                
            }


            /**
             * @ngdoc
             * @name snk.components.gridconfig.service:GridConfigInstance#setId
             * @methodOf snk.components.gridconfig.service:GridConfigInstance
             * @description
             *  Seta um novo id de configuração para o gridconfig.
             * @param {string} gridConfigId Novo id.
             * @example
             *      <pre>_gridConfig.setId('br.com.sankhya.novo.id')</pre>
             *
             */
            GridConfigInstance.prototype.setId = function(gridConfigId) {
                if (gridConfigId) {
                    this.gridConfigId = gridConfigId;
                    GridConfig.registerGridConfig(gridConfigId, gridConfigId, undefined, true);
                }
            };

            GridConfigInstance.prototype.setConfig = function(config) {
                if (this.gridConfigId) {
                    GridConfig.setConfig(config);
                }
            };

            /**
             * @ngdoc
             * @name snk.components.gridconfig.service:GridConfigInstance#open
             * @methodOf snk.components.gridconfig.service:GridConfigInstance
             * @description
             *  Abre o popup de configuração.
             * @param {object} [options=undefined] Opções adicionais para o popup.
             * @example
             *      <pre>_gridConfig.open()</pre>
             *
             */
            GridConfigInstance.prototype.open = function(options) {
                if (this.gridConfigId) {
                    GridConfig.openGridconfig(this.gridConfigId, options);
                }
            };

            /**
             * @ngdoc
             * @name snk.components.gridconfig.service:GridConfigInstance#unregistry
             * @methodOf snk.components.gridconfig.service:GridConfigInstance
             * @description
             *  Desregistra o popup de configuração.
             * @example
             *      <pre>_gridConfig.unregistry()</pre>
             *
             */
            GridConfigInstance.prototype.unregistry = function() {
                if (this.gridConfigId) {
                    GridConfig.unregistry(this.gridConfigId);
                }
            };

            /**
             * @ngdoc
             * @name snk.components.gridconfig.service:GridConfigInstance#buildOpenMenuOption
             * @methodOf snk.components.gridconfig.service:GridConfigInstance
             * @description
             *  Abre o popup de configuração.
             * @example
             *      <pre>_gridConfig.buildOpenMenuOption()</pre>
             *
             */
            GridConfigInstance.prototype.buildOpenMenuOption = function() {
                return {
                    label: i18n('Geral.lblConfigurarGrade'),
                    action: function(){
                        if (this.gridConfigId) {
                            this.open();
                        }
                    }.bind(this)
                };
            };

            return function (gridConfigId, isUiGrid) {
                return new GridConfigInstance(gridConfigId, isUiGrid);
            };
        }];
    }]); 

angular
    .module('snk.components.gridprinter')
    .controller('SkGridPrinterController', 
    		['$scope', '$translate', 'UserAgentUtils', '$timeout', 'ServiceProxy', '$window', 'Base64', 'DatasetUtils','SkApplication','$q','StringUtils','SkWorkspace', 'SkI18nService', 'MessageUtils', 'WebConnectionCaller', 'MGEParameters', 'WebConnectionConstants','i18n', 'ObjectUtils', 'DateUtils', 'DateUtilsConstants',
function ($scope, $translate, UserAgentUtils, $timeout, ServiceProxy, $window, Base64, DatasetUtils, SkApplication, $q, StringUtils, SkWorkspace, SkI18nService, MessageUtils, WebConnectionCaller, MGEParameters, WebConnectionConstants,i18n, ObjectUtils, DateUtils, DateUtilsConstants) {
    var self = this;

    var GERAR_PDF = "pdf";
    var GERAR_XLS = "xls";
    var GERAR_XLSX = "xlsx";
    var GERAR_CUBO = "cubo";
    var MAX_BAND_WIDTH = 900;   //tamanho maximo da banda como landscape
    var GERAR_RELATORIO_FORMATADO = 3;
    var EXPORTAR_REGISTROS = 4;
    var REPORT_LAUNCHER_RESOURCE_ID = "br.com.sankhya.controls.ReportLauncher";
    var	NUMBER_TYPES = "I-C-F-CUR";
    var CUBE_PAGE_SIZE = 500;
    var indexRow = 0;

    var _maxRegExport = MGEParameters.asInteger("mge.core.qtde.maxima.registros.para.exportacao");

    var resourceId = SkApplication.instance().getResourceID();

    var _executeCubeViewAttemps = 0;

    var _dataSet = angular.isDefined($scope.dataset) ? $scope.dataset : (angular.isDefined($scope.skGridController) ? $scope.skGridController.getDataset() : undefined);

    self.getMetadadosColumns = getMetadadosColumns;
    self.getNextRows = getNextRows;

    self.hasPkValue = true;

    $scope.onlyReport = angular.isDefined($scope.onlyReport) ? $scope.onlyReport : false;
    $scope.autoRepostionPlacement = angular.isDefined($scope.placement);
    $scope.placement = angular.isDefined($scope.placement) ? $scope.placement : 'bottom';

    self.getGridPrinterProperties = function () {
        return {
            textToColor: StringUtils.textToColor,
            menuOpt: getOptions(),
            dynamicOptions: dynaloadReportMenu(),
            choosedPrintType: choosedPrintType,
            actionHasImage: actionHasImage,
            buildNick: buildNick,
            itemClickReport: itemClickReport,
            getIcon: getIcon,
            hideDynamicOptions: $scope.hideDynamicOptions,
            onlyReport: $scope.onlyReport,
            titleRelatorioFormatado: SkI18nService.instant('GridPrinter.titleRelatorioFormatado')
        };
    };

    $scope.tooltipGridPrinter = $scope.onlyReport ? SkI18nService.instant('GridPrinter.lblExpotarRelatorioFormatado') : SkI18nService.instant('GridPrinter.titleGridPrinter');
    $scope.mobileClass = UserAgentUtils.isMobile() ? 'is-mobile' : '';
    $scope.getPopoverWidth = getPopoverWidth;
    $scope.choosedPrintType = choosedPrintType;

    $scope.$watch('dataset', (dataset) => {
        if (dataset) {
            _dataSet = dataset;
        }
    });

    $scope.$watch('skGridController', (gridController) => {
        if (gridController) {
            _dataSet = gridController.getDataset();
        }
    });

    /*
        TODO Preparado para a opção exportar registros, este ainda não está implementado
        self.menuOpt.push({description: 'Exportar Registros', type: EXPORTAR_REGISTROS});
     */

    function choosedPrintType (optType) {
        if($scope.skGridController === undefined){
           return;               
        }
        
        if(!$scope.skGridController) {
            if (angular.isDefined($scope.skCreateGridFn)) {
                $scope.skCreateGridFn().then(function() {
                    $timeout(function() {
                        processExport(optType);
                    },0,false);
                });
            }
        } else {
            processExport(optType);
        }
    }

    function processExport(optType, limited) {
        if (!$scope.skGridController) {
            return;
        }

        var records = _dataSet.getRecords();

        var numItems = records.length;

        if(numItems <= 0) {
            MessageUtils.showAlert(MessageUtils.TITLE_WARNING,SkI18nService.instant('GridPrinter.msgNaoExistemDadosParaExportar'));
            return;
        }

        if(angular.isUndefined(limited)) {
            if(_maxRegExport > 0 && numItems > _maxRegExport) {
                MessageUtils.simpleConfirmBuilder()
                    .title(MessageUtils.TITLE_WARNING)
                    .msg('GridPrinter.msgMaxRegInExport', {qtd: _maxRegExport})
                    .showAsWarning(true)
                    .show()
                    .then(function() {
                        processExport(optType, true);
                    });

                return;
            }
        } else if (limited == true) {
            records = records.slice(0, _maxRegExport);
        }

        var columns = [];

        var jsonBuildPdf = {
            grid : {
            	gridTitle : i18n($scope.title) || _dataSet.getEntityDescription(),
                //'use.base64': true,
                columns: {
                    column: []
                },
                rows: {
                    row: []
                },
                customOptions: {
                    xlsxExtension: optType === GERAR_XLSX
                }
            }
        };
        
        if ($scope.customEntity != true && !_dataSet.isStandAlone()) {
            jsonBuildPdf.grid.entityName = _dataSet.getEntityName();
        }

        var columnDefs = removeCbxSelection($scope.skGridController.getVisibleColumnDefs());
        var columnsById = {};
        var bandWidth = 0;
        var colIndex = 0;
        var extraColumns;

        if(optType === GERAR_CUBO){
        	ServiceProxy.callService("mge@UsuarioSP.usuarioLogadoPodeExportarPDF", {}).then(function (result) {
                var permiteExportarCubo = ObjectUtils.getProperty(result, 'responseBody.$');

                if(MGEParameters.asBoolean("global.usa.app.cubo")) {
                    excecuteExternalCube(permiteExportarCubo);
                } else {
                    executeCubeView();
                }
            });
            return;
        }

        if (angular.isDefined($scope.interceptor)) {
            ObjectUtils.isImplementorOf($scope.interceptor, IGridPrinterInterceptor);

            var extraParams = $scope.interceptor.getExtraParams();

            if (extraParams) {
                jsonBuildPdf.grid.extraParams = {
                    param: []    
                };

                angular.forEach(extraParams, function(value, key) {
                    jsonBuildPdf.grid.extraParams.param.push({
                        name: key,
                        value: value
                    });
                });
            }

            extraColumns = $scope.interceptor.getExtraColumns();
        }

        for(colIndex = 0; colIndex < columnDefs.length; colIndex++) {
            var column = columnDefs[colIndex];

            bandWidth += column.width;

            // para pdf tem limitacao de tamanho
            if(optType == GERAR_PDF && bandWidth > MAX_BAND_WIDTH) {
                break;
            }

            var columnObj = buildDataColumnObj(column, colIndex);

            let useAggregator = _dataSet.getFieldMetadata(column.skName)?.useAggregator;
            if(useAggregator != undefined && (useAggregator == false || useAggregator.trim().toLocaleLowerCase() == 'false')){
                useAggregator = undefined;
            }
            columnObj.aggregationFunction = useAggregator;

            jsonBuildPdf.grid.columns.column.push(columnObj);

            columnsById[columnObj.id] = columnObj;
        }

        if (extraColumns) {
            var extraColumnIndex = colIndex;

            extraColumns = extraColumns.filter(function(extraColumnName) {
                return !columnsById[extraColumnName];
            });
            
            extraColumns.forEach(function(columnName) {
                var extraColumnDef = $scope.skGridController.getColumnByName(columnName);

                var columnObj = buildDataColumnObj(extraColumnDef, extraColumnIndex);
                columnObj.extraColumn = 'true';
                columnObj.type = 'S';

                let useAggregator  = _dataSet.getFieldMetadata(columnName)?.useAggregator;
                if(useAggregator != undefined && (useAggregator == false || useAggregator.trim().toLocaleLowerCase() == 'false')){
                    useAggregator = undefined;
                }
                columnObj.aggregationFunction = useAggregator;

                jsonBuildPdf.grid.columns.column.push(columnObj);

                columnsById[columnObj.id] = columnObj;

                extraColumnIndex++;
            });
        }

        for(var i=0; i < records.length; i++) {
            var row = {};
            
            var j;
            for(j = 0; j < colIndex; j++) {
               if(angular.isDefined($scope.isFromDashboard) && $scope.isFromDashboard && (optType === GERAR_XLS || optType === GERAR_XLSX)){
                  row['c' + (j+1)] = {'$': getCellValueDashboard(columnDefs[j], records[i])};
               }else{
                  row['c' + (j+1)] = {'$': getCellValue(columnDefs[j], records[i])};
               }
            }

            if (extraColumns) {
                extraColumns.forEach(function(columnName) {
                     var extraColumnDef = $scope.skGridController.getColumnByName(columnName);
                     if(angular.isDefined($scope.isFromDashboard) && $scope.isFromDashboard && (optType === GERAR_XLS || optType === GERAR_XLSX)){
                        row['c' + (j+1)] = {'$': getCellValueDashboard(extraColumnDef, records[i])};
                     }else{
                        row['c' + (j+1)] = {'$': getCellValue(extraColumnDef, records[i])};
                     }
                    j++;
                });
            }

            jsonBuildPdf.grid.rows.row.push(row);
        }

        var isPDF  = (optType == GERAR_PDF);
        var nameService = isPDF ? "mge@GridPDFBuilderSP.buildPDFFromJson" : "mge@GridXLSBuilderSP.buildXLSFromJson";

        /** Inserção de opções customizadas no objeto principal enviado para o servidor quando exportar para XLS. */
        
        if (angular.isDefined($scope.skCustomOptions) && !isPDF){
            jsonBuildPdf.grid.customOptions = $scope.skCustomOptions;
        }

        //o dataset retorna ... quando a entidade não ten descrição, tratamos isso, pois, caso os .., vá para o servidor o arquivo fica com a extensão inválida ao ser baixado.
        if(jsonBuildPdf && jsonBuildPdf.grid && (jsonBuildPdf.grid.gridTitle == '...' || !jsonBuildPdf.grid.gridTitle)) jsonBuildPdf.grid.gridTitle = "expot_grid";

        ServiceProxy.callService(nameService, jsonBuildPdf, {preventTransform: true}).then(function(result){
            var chave;
            var extension;
            var permiteImprimir;
            var permiteExportar;
            let canSendByEmail;
            
            if(isPDF) {
                chave = result.responseBody.chavePDF.valor;
                permiteImprimir = result.responseBody.permiteImprimir.valor == "S";
                permiteExportar = result.responseBody.permiteExportar.valor == "S";
                canSendByEmail = (result.responseBody.canSendEmail && result.responseBody.canSendEmail.valor == "S");
                extension = ".pdf";
            } else {
                chave = result.responseBody.chaveXLS.valor;
                extension = (optType === GERAR_XLSX) ? ".xlsx" : ".xls";
            }
            if(isPDF && MGEParameters.asBoolean("global.usa.app.impressao") && !permiteExportar && !UserAgentUtils.isMobile()) {
            	executeExternalPdfViewer(chave, permiteImprimir, permiteExportar, true, canSendByEmail);
            } else if(UserAgentUtils.isElectron() && isPDF){
            	executeExternalPdfViewer(chave, permiteImprimir, permiteExportar, true, canSendByEmail);
            } else {
            	SkWorkspace.downloadFile(window.serverAddress, chave, extension);
            }
        });
    }

    function getCellValueDashboard(columnDef, record ) {
        var indexField = columnDef.skFieldMdIndex;
    
        columnDef.isExportingFromDashboard = true;
        content = angular.isFunction(columnDef.valueFormatter) ? columnDef.valueFormatter({ value: record[columnDef.skFieldMdIndex], data: "", colDef: columnDef, column: columnDef }) : record[columnDef.skFieldMdIndex.toString()];
    
        return DatasetUtils.dataToString(content, false) || '';
    }

    function getCellValue(columnDef, record) {
        let content;
        let indexField = columnDef.skFieldMdIndex;

        if(angular.isFunction(columnDef.cellFormatter)){
            content =  columnDef.cellFormatter(undefined, record[indexField], record);
        }else{
            let rowId = record[record.length - 1].rowID;
            let rowNode = getDataFromDataGrid(rowId);

            content = angular.isFunction(columnDef.valueFormatter) ? columnDef.valueFormatter({ value: record[columnDef.skFieldMdIndex], data: rowNode ? rowNode.data : "", colDef: columnDef, column: columnDef }) : record[columnDef.skFieldMdIndex.toString()];
        }

        return DatasetUtils.dataToString(content, false) || ''; 
    } 

    function getDataFromDataGrid(rowId) {
        let rowNode;

        if (angular.isDefined($scope.skGridController) && angular.isDefined(rowId) ){
            rowNode = $scope.skGridController.getGridApi().getRowNode(rowId);
        }

        return rowNode;
    }

    function buildDataColumnObj(column, index) {
        return {
            index: index + 1,
            label: column.displayName || column.skDescription,
            id: column.skName,
            width: column.width,
            align: column.cellTextAlignment || 'left',
            type: (column.skFieldType === 'ENTITY' || column.dataType) ? column.dataType : column.skFieldType,
            presentationType: column.presentationType,
            useFooter: column.useFooter,
            personalized: ObjectUtils.getProperty(column, 'skAggregateExpression.0.Personalized')
        };
    }
    
    function getOptions(){
        var menuOpt = [];

        if (!$scope.onlyReport) {
            menuOpt.push({description: SkI18nService.instant('GridPrinter.lblExportarPDF'), type: GERAR_PDF});
            menuOpt.push({description: SkI18nService.instant('GridPrinter.lblExportarPlanilha') + " (xls)", type: GERAR_XLS});
            menuOpt.push({description: SkI18nService.instant('GridPrinter.lblExportarPlanilha') + " (xlsx)", type: GERAR_XLSX});

            if(!UserAgentUtils.isMobile()) {
                menuOpt.push({description: SkI18nService.instant('GridPrinter.lblExportarCubo'), type: GERAR_CUBO});
            }
        }

        return menuOpt;
    }

    function dynaloadReportMenu(){
        var defer = $q.defer();

        var load = function(){
            doDynaloadReportMenu().then(function(menus){
                defer.resolve(menus)
            });
        };

        if(!$scope.skGridController) {
            if (angular.isDefined($scope.skCreateGridFn)) {
                $scope.skCreateGridFn().then(function() {
                    $timeout(function() {
                        load();
                    });
                });
            } else if (_dataSet) {
                load();
            }
        } else {
            load();
        }

        return defer.promise;
    }

    function doDynaloadReportMenu() {
        var defer = $q.defer();

        var isEmptyDataset = _dataSet.size() < 1 || _dataSet.isInsertionMode();

        if (isEmptyDataset) {
            defer.resolve([]);
        }

        var instanciaElem = {
            instancia:{
                nome: _dataSet.getEntityName(),
            	pk: []
            }
        };

        if (resourceId) {
            instanciaElem.instancia['resourceID'] = resourceId;
        }

        for (var i in _dataSet.getPrimaryKeys()) {
            var pkFieldName = _dataSet.getPrimaryKeys()[i];

            var pkValue = _dataSet.getFieldValueAsString(pkFieldName);

            if(StringUtils.emptyAsNull(pkValue) == null){
                self.hasPkValue = false;
                break;
            }

            instanciaElem.instancia.pk.push({
                name: pkFieldName,
                $: pkValue
            });
        }

        if(self.hasPkValue){
            ServiceProxy.callService('VisualizadorRelatorios.getRelatoriosDisponiveisPorInstancia',
                instanciaElem
            ).then(function (result) {
                    var dpOpcoes = [];
    
                    var relatorios = result.responseBody.relatorios.relatorio;
    
                    if (relatorios && relatorios.length > 0) {
                        //dpOpcoes.push({type: "separator"});
    
                        var dpSubOpcoes = [];
    
                        for (var i = 0; i < relatorios.length; i++) {
                            var rel = relatorios[i];
                            dpSubOpcoes.push({
                                description: rel.label,
                                type: GERAR_RELATORIO_FORMATADO,
                                nuRfe: rel.nuRfe
                            });
                        }
    
                        dpOpcoes.push({
                            description: SkI18nService.instant('GridPrinter.titleRelatorioFormatado'),
                            children: dpSubOpcoes
                        });
    
                    }
    
                    defer.resolve(dpOpcoes);
                }, function(error) {
                    console.warn('[SkGridPrinterController] Erro ao resolver relatórios por instancia.', error);
                    defer.resolve([]);
                });
            }else {
                self.hasPkValue = true;
                defer.resolve([]);
            }
            
        return defer.promise;
    }

    function itemClickReport(item){
        var isEmptyDataset = _dataSet.size() < 1 || _dataSet.isInsertionMode();

        if (isEmptyDataset) {
            return;
        }

        var pk = [];
        var id = item["nuRfe"];
        var pks = [];

        if(angular.isDefined($scope.isFromDashboard) && $scope.isFromDashboard){
            if(_dataSet.getCurrentIndex() == -1){
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, $translate.instant('GridPrinter.selecioneLinhaTabela'));
                return;
            }

            for (var i in _dataSet.getFieldNames()) {
                var pkFieldName = _dataSet.getFieldNames()[i];
                var pkValue = _dataSet.getFieldValueAsString(pkFieldName);
                var pkType = _dataSet.getFieldMetadata(pkFieldName).userType=="ENTITY"?
                                _dataSet.getFieldMetadata(pkFieldName).dataType:
                                _dataSet.getFieldMetadata(pkFieldName).userType;

                pk["PK_" + pkFieldName] = {type: pkType, value: pkValue};
            }
        }else{
            for (var i in _dataSet.getPrimaryKeys()) {
                var pkFieldName = _dataSet.getPrimaryKeys()[i];
                var pkValue = _dataSet.getFieldValueAsString(pkFieldName);
                var pkType = _dataSet.getFieldMetadata(pkFieldName).userType=="ENTITY"?
                                _dataSet.getFieldMetadata(pkFieldName).dataType:
                                _dataSet.getFieldMetadata(pkFieldName).userType;
                
                pk["PK_" + pkFieldName] = {type: pkType, value: pkValue};
            }
            
			for(let selectedIndex in _dataSet.getSelectedRecordsPks()){
				var objPk = {};
				var fieldsPk = [];
				for (var indexPk in _dataSet.getPrimaryKeys()) {
	                var pkFieldName = _dataSet.getPrimaryKeys()[indexPk];
					let itemSelected = _dataSet.getSelectedRecordsPks()[selectedIndex];
	                var pkValue = itemSelected[pkFieldName] instanceof Date ? DateUtils.dateToString(itemSelected[pkFieldName], DateUtilsConstants.DEFAULT_DATETIME_FORMAT) : itemSelected[pkFieldName];
	                var pkType = _dataSet.getFieldMetadata(pkFieldName).userType=="ENTITY"?
	                                _dataSet.getFieldMetadata(pkFieldName).dataType:
	                                _dataSet.getFieldMetadata(pkFieldName).userType;
	                                
	                var fieldPk = {nome: "PK_" + pkFieldName, tipo: pkType, valor: pkValue};
	                fieldsPk.push(fieldPk);
	            }
	            objPk['fields'] = fieldsPk;
	            pks.push(objPk);
			}
			pk['pks'] = pks;
        }

        SkApplication.instance().openApp(REPORT_LAUNCHER_RESOURCE_ID + "_" + id, pk);
    }


    function actionHasImage(action){
        return action.img && action.img != '';
    }

    function buildNick(action){
        var descr = action.description;

        if (descr && angular.isFunction(descr.trim)){
            descr = descr.trim();

            return descr.substr(0, Math.min(3, descr.length));
        } else {
            return  '';
        }
    }

    function getIcon(type) {
        if (type === GERAR_PDF) {
            return '/mge/assets/svg/pdf.svg';
        } else if (type === GERAR_XLS || type === GERAR_XLSX) {
            return '/mge/assets/svg/xls.svg';
        } else if (type === GERAR_CUBO) {
            return '/mge/assets/svg/cube.svg';
        }
    }

    function getPopoverWidth(){
        if(UserAgentUtils.isMobile()){
            return '320';
        } else {
            return '440';
        }
    }

    function invokeClientCallback(callbackJsFunction, callBackResponse){
        return callbackJsFunction(callBackResponse);
    }

    function isDashboardPersonalizedGOL () {
        if (angular.isDefined(MODULE_ID) && MODULE_ID == "DashboardGOL" && resourceId.includes('br.com.sankhya.menu.adicional.gol')) {
            return true
        }

        return false;
    }

    function getExecuteExternalOptions (externalProdutctLabel){
        let label = SkWorkspace.getAppLabel(resourceId);

        if (StringUtils.isEmpty(label) && isDashboardPersonalizedGOL()) {
            label = invokeClientCallback(window.dashboard.getPersonalizedDashboardGOLDescription);
        }

        if (label) {
			label = label.replace(/[^a-zA-Z0-9\s\.\-\_\(\)]/g, '');
		} 

        return {
            resourceID: resourceId,
            label: label + ' - ' + externalProdutctLabel,
            locale: SkI18nService.getLang()
        }
    }

    function excecuteExternalCube(permiteExportarCubo) {
        var caller = WebConnectionCaller(WebConnectionConstants.methods.CUBE_VIEWER_GRID, angular.extend(getExecuteExternalOptions("Cubo"), {permiteExportar: permiteExportarCubo}));
    	sendCubeData(caller);
    }
    
    function executeExternalPdfViewer(chavePdf, userCanPrint, userCanExport, fileJasper, canSendByEmail) {
        var caller = WebConnectionCaller(WebConnectionConstants.methods.PDF_VIEWER, getExecuteExternalOptions("Pdf Viewer"));  	
    	caller.sendPdfKey(chavePdf, userCanPrint, userCanExport, fileJasper, canSendByEmail);
    }
    
    function sendCubeData(caller) {
    	caller.sendCubeInit(getMetadadosColumns());
		indexRow = 0;		
		var nextRows;
		
		var run = function() {
			if ((nextRows = getNextRows()) !== '') {
				var error = !caller.sendCubeData(nextRows); 
	            if(!error){
	            	$timeout(run,0,false);
	            }
			}else{
				$timeout(caller.sendCubeFinish ,0,false);
			}
		};
		
        run();
    }

    function executeCubeView() {
        var label =  SkWorkspace.getAppLabel(resourceId) + ' - Cubo';
        var uid;

        if(uid === undefined){
            uid = StringUtils.nextUid();
            registerCubeMethods(uid, self);
        }
        var url = StringUtils.substitute("/mge/cubeViewer.jsp?&DESCRICAO={0}&RESOURCEID={1}&UID={2}&LOCALE={3}&HTML5=S", label, resourceId, uid, SkI18nService.getLang());

        var posx = 0;
        var posy = 0;
        var height = 700;
        var width = 1000;

        posx = (screen.width - width) / 2;
        width = width;

        posy = (screen.height - height) / 2;
        height = height;

        var windowArgs = [url, 'pop', 'width=' + width + ',height=' + height + ',top=' + posy + ', left=' + posx + ', scrollbars=no,resizable=no,toolbar=no,status=no,menubar=no'];

        if($scope.$root.$$phase) {
            if(_executeCubeViewAttemps >= 10) {
                MessageUtils.showInfo(MessageUtils.TITLE_WARNING, $translate.instant('GridPrinter.msgErroExportarCubo'));
                return;
            }
            $timeout(function() {
                _executeCubeViewAttemps++;
                executeCubeView();
            },0,false);
        } else {
            _executeCubeViewAttemps = 0;
            SkApplication.instance().openWindow.apply(SkApplication.instance(),windowArgs);
        }
    }

    function registerCubeMethods(uid, gridPrinter) {
         var funcNextRows = "getNextRows" + uid;
         var funcMetadadosColumns = "getMetadadosColumns" + uid;

         $window[funcNextRows] = function() {
             return gridPrinter.getNextRows();
         };

        $window[funcMetadadosColumns] = function() {
             return gridPrinter.getMetadadosColumns();
         };
     };

    function getMetadadosColumns() {
        var columnDefs = removeCbxSelection($scope.skGridController.getVisibleColumnDefs());

        var root = '<columns>';

        for(var colIndex = 0; colIndex < columnDefs.length; colIndex++) {
            var column = columnDefs[colIndex];

            if ("B" === column.skFieldType || column.width > 1000) {
                continue;// colunas do tipo BLOB ou tenha muitos caracteres não serão utilizadas no CUBO.
            }

            root += buildDataColumn(column, colIndex + 1);

        }

        root += '</columns>';

        return root.toString();
    }

    function buildDataColumn (col, colIndex) {

        var column = '<column';

        column += ' index="' + colIndex + '"';
        column += ' label="' + StringUtils.htmlScape((col.displayName || col.skDescription)) + '"';
        column += ' width="' + col.width + '"';
        column += ' id="' + col.skName + '"';

        var type = getColumnDataType(col);
        if (type == "I") {
        	if (angular.isDefined(_dataSet)) {
        		var md = _dataSet.getFieldMetadata(col.skName);
        		if (angular.isDefined(md) && angular.isDefined(md.options) && md.options.length > 0) {
        			if (isNaN(Number(md.options[0]))) {
        				type = "S";
        			}
        		}
        	}
        }
        column += ' type="' + type + '"';

        column += ' align="' + col.cellTextAlignment + '"';
  //    useFooter: 'N' //col.useFooter() ? "S" : "N"
        column += ' />';

        return column;
    }

    function getColumnDataType(col) {
        if (angular.isUndefined(col.dataType)){
            return 'S';
        } else {
            return isCurrencyType(col) ? 'F' : col.dataType;
        }
    }

    function getNextRows() {
        var rows = '<rows>';
        var records = _dataSet.getRecords();
        var columnDefs = removeCbxSelection($scope.skGridController.getVisibleColumnDefs());
        var end = Math.min(indexRow + CUBE_PAGE_SIZE, _maxRegExport > 0 ? _maxRegExport : Number.MAX_VALUE, records.length);
        var hasRow = false;

        for (var i = indexRow; i < end; i++) {
            linha = records[i];

            var row = '<row>';
            var countIndex = 1;

            for(var colIndex = 0; colIndex < columnDefs.length; colIndex++) {
                var column = columnDefs[colIndex];

                var currentIndex = $scope.skGridController.getCurrentColIndexByColumnDef(column);

                if ("B" === column.skFieldType || column.width > 1000) {
                    continue;// colunas do tipo BLOB ou tenha muitos caracteres não serão utilizadas no CUBO.
                }

                row += buildDataRow(column, currentIndex, linha, GERAR_CUBO, countIndex);

                countIndex++;
            }

            hasRow = true;

            row += '</row>';
            rows += row;
        }

        rows += '</rows>';

        if (hasRow) {
            indexRow = end;
            return rows.toString();
        }

        indexRow = 0;
        return "";
    }

    function buildDataRow(col, columnIndex, linha, tipoImpressao, countIndex) {
        var content;

		/* Dashboard = Usado especialmente para retirar a máscara dos dados que serão enviados para o Cubo */
        if(angular.isDefined($scope.isFromDashboard) && $scope.isFromDashboard){
            col.isExportingFromDashboard = true
        }

        if (angular.isFunction(col.cellFormatter)) {
            content = col.cellFormatter(undefined,linha[columnIndex]);
        } else if (angular.isFunction(col.valueFormatter) && !isCurrencyType(col)) {
            content = col.valueFormatter({ value: linha[col.skFieldMdIndex], data: "", colDef: col, column: col});
        } else {
            content = linha[col.skFieldMdIndex.toString()];
        }
        
        var value = DatasetUtils.dataToString(content, false) || '';

        var returnElem = '<c' + countIndex + '>';
        returnElem += '<![CDATA[' + StringUtils.htmlScape(value) + ']]>';

        returnElem += '</c' + countIndex + '>';

        return returnElem;
    }
    
    function isCurrencyType(col) {
    	return 'CUR' === col.dataType || 'C' === col.dataType; // Verifica se a coluna do dashboard é do tipo Moeda
    }

    function removeCbxSelection(columnDefs){

        var columns = angular.copy(columnDefs);

        for(var index in columns){
            if(columns[index].field === '-100000'){
                columns.splice(index, 1);
            }
        }
        return columns;
    }

}]);

/**
* @ngdoc directive
 * @name snk.components.gridprinter.directive:sk-grid-printer
 * @restrict E
 * @description
 * A diretiva 'skGridPrinter' exportar a grid em varios formatos como PDF,XLS e Cubo.
 *
 * @param {object} [sk-grid-controller=undefined] Nesse parametro deve ser informado o data grid a ser utilizado.
 *
 * @param {string} [sk-title=undefined]  Nesse parametro deve ser informado o título do documento.
 *
 * @param {function} [sk-create-grid-fn=undefined]  Nesse parametro deve ser informado uma função de construção de grid controller caso na criação ele esteja ainda undefined .
 * 
 * @param {boolean} [sk-custom-entity=false] Nesse parametro pode ser informado se deseja utilizar uma entidade personalizada.
 * 
 * @param {boolean} [sk-enabled=true] Utilizado para habilitar ou desabilitar.
 *
 * @param {IGridPrinterInterceptor} [sk-grid-printer-interceptor=undefined] Interceptor para o componente
 * 
 * @param {boolean} [sk-only-report=true] Utilizado para apresentar somente os relatórios personalizados ligados a entidade.
 * 
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente em vez do controle vinculado a grid (sk-grid-controller).
 *
 */
angular
    .module('snk.components.gridprinter')
    .directive('skGridPrinter', function () {
        return {
            templateUrl: 'components/gridprinter/gridprinter.tpl.html',
            restrict: 'E',
            controller: 'SkGridPrinterController',
            controllerAs: 'ctrl',
            scope: {
                skGridController: '=',
                title: '@skTitle',
                skCreateGridFn: '=',
                customEntity: '=skCustomEntity',
                enabled: '=skEnabled',
                interceptor: '=?skGridPrinterInterceptor',
                zIndex: '<',
                isFromDashboard: '<',
                hideDynamicOptions: '=?skHideDynamicOptions',
                skCustomOptions: '=',
                onlyReport: '=?skOnlyReport',
                placement: '@?skPlacement',
                dataset: '=?skDataset'
            }
        };
    });

/**
 * @ngdoc interface
 * @name snk.components.gridprinter.interfaces:IGridPrinterInterceptor
 * @description Interface utilizada para interceptar a utilização do GridPrinter
 */
function IGridPrinterInterceptor() {}

/**
 * @ngdoc
 * @name snk.components.gridprinter.interfaces:IGridPrinterInterceptor#getExtraParams
 * @methodOf snk.components.gridprinter.interfaces:IGridPrinterInterceptor
 * @description Função chamada para enviar parametros adicionais para o exportador
 */
IGridPrinterInterceptor.prototype.getExtraParams = function () {
    return undefined;
};

/**
 * @ngdoc
 * @name snk.components.gridprinter.interfaces:IGridPrinterInterceptor#getExtraColumns
 * @methodOf snk.components.gridprinter.interfaces:IGridPrinterInterceptor
 * @description Função chamada para enviar colunas adicionais para o exportador
 */
IGridPrinterInterceptor.prototype.getExtraColumns = function () {
    return undefined;
};
angular
    .module('snk.components.gridprinter')
    .controller('SkGridPrinterPopOverController', ['$scope', '$timeout', '$element', function ($scope, $timeout, $element) {
        var newMaxHeight;
        var originalMaxHeight;
        var actionsElem = angular.element($element[0].querySelector('div.actions-container'));
        var showMoreElem = angular.element($element[0].querySelector('div.show-more-container'));
        var contentActionsElem = actionsElem.children()[0];

        $scope.showMore = showMore;

        $scope.$onPopoverOpened = init;

        function init() {

            if (contentActionsElem.offsetHeight === actionsElem[0].offsetHeight) {
                showMoreElem.css('display', 'none');
            } else {
                if (!(actionsElem[0].scrollTop > 0)) {
                    showMoreElem.css('display', 'block');
                    if (actionsElem[0].offsetHeight > (window.innerHeight / 2)) {
                        actionsElem.css('max-height', (window.innerHeight / 2) + 'px');
                    }
                }
                actionsElem.bind('scroll', function () {
                    if (actionsElem[0].scrollTop > 0) {
                        newMaxHeight = actionsElem[0].offsetHeight + showMoreElem[0].offsetHeight;

                        if (!originalMaxHeight) {
                            originalMaxHeight = actionsElem.css('max-height');
                        }

                        showMoreElem.css('display', 'none');
                        actionsElem.css('max-height', newMaxHeight + 'px');
                    } else {
                        showMoreElem.css('display', 'block');

                        if (originalMaxHeight) {
                            actionsElem.css('max-height', originalMaxHeight);
                        }
                    }
                });

                $scope.$on('$destroy', function () {
                    actionsElem.unbind('scroll');
                });
            }
        }

        function showMore() {
            actionsElem[0].scrollTop = actionsElem[0].offsetHeight;
        }

    }]);

/**
* @ngdoc overview
* @name snk.components.gridstatistics.directive:gridstatistics
* @description 
* Módulo de exibição de estatísticas da Grade
*
* @param {skDatagrid} sk-datagrid ID do datagrid que será utilizado para o cálculo da estatística. 
* 
*/

angular
.module('snk.components.gridstatistics')
.service('GridStatistics', ['SanPopup', 'i18n', '$translate', 'MessageUtils',
function (SanPopup, i18n, $translate, MessageUtils) {
   var self = this;

   self.openGridStatistics = function (datagrid) {
      if (angular.isUndefined(datagrid) || datagrid.getDataset().isEmpty()) {
         MessageUtils.showAlert(i18n('DataGrid.gradeVazia'));
         return;
      }
      
      var dataset = datagrid.getDataset().getRecordsAsObject();
      var visibleColumns = datagrid.getVisibleColumnDefs();
      var dsGridStatistics = [];
      
      visibleColumns.forEach(function(column) {
         if (column.dataType == 'I' || column.dataType == 'F') {
            var sum = 0;
            var average = 0;
            var bigger = 0;
            var smaller = 0;
            var occurrences = 0;
            
            dataset.forEach(function(fieldObj) {
               var fieldValue = fieldObj[column.field];
               
               if (!isNaN(fieldValue)) {
                  sum += fieldValue;
                  
                  if (occurrences == 0) {
                     bigger = fieldValue;
                     smaller = fieldValue;
                  } else {
                     if (fieldValue > bigger) {
                        bigger = fieldValue;
                     }
                     
                     if (fieldValue < smaller) {
                        smaller = fieldValue;
                     }
                  }
               }
               
               occurrences++;
            });
            
            if (occurrences > 0) {
               average = sum / occurrences;
            }
            
            dsGridStatistics.push({
               COLUNA: column.skDescription,
               SOMA: sum,
               MEDIA: average,
               OCORRENCIAS: occurrences,
               MAIOR: bigger,
               MENOR: smaller
            });
         }
      });
      
      SanPopup.open({
         title: i18n('DataGrid.estatisticas'),
         templateUrl: 'components/gridstatistics/gridstatisticscontent.tpl.html',
         controller: 'GridStatisticsController',
         controllerAs: 'gridStatisticsCtrl',
         okBtnLabel: i18n('Geral.lblFechar'),
         showBtnCancel: false,
         size: 'lg',
         resolve: {
            dsComponent: function () {
               return dsGridStatistics;
            }
         }
      });
   }
}]); 
angular
    .module('snk.components.gridstatistics')
    .controller('GridStatisticsController', ['$scope', 'i18n', '$translate', 'dsComponent',
        function ($scope, i18n, $translate, dsComponent) {
            var self = this;

            self.onDsCreated = function (dataset) {
                self.dsGridStatistics = dataset;
                self.dsGridStatistics.init().then(function(){
                    self.dsGridStatistics.addRecordsAsObjects(dsComponent);
                });
            }
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.groupcontainer.directive:sk-group-container
 * @restrict E
 * @description
 * O componente 'sk-simple-group' é um container que contém um título.    
 *
 * @param {string} sk-title Título do grupo.
 * 
 *
 * @example
     <example module="appSimpleGroup">
         <file name="appSimpleGroup.html">
            <sk-application>
                <sk-group-container sk-title="Título">
                    <sk-text-input></sk-text-input>
                    <button primary></button>
                </sk-group-container>
            </sk-application>
         </file>
         <file name="appSimpleGroup.js">
            angular.module('appSimpleGroup', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.groupcontainer')
    .component('skGroupContainer',  {
        templateUrl: 'components/groupcontainer/groupcontainer.tpl.html',
        controller: 'SkGroupContainerController',
        transclude: true,
        bindings: {
            title: '@skTitle'
        }
    })
    .controller('SkGroupContainerController', ['$element', function($element) {
        $element.attr('layout', 'column');
    }]);
/**
 * @ngdoc directive
 * @name snk.components.sk-help-tip.directive:sk-help-tip
 * @restrict E

 * @description
 *   	Esse componente é responsável por mostrar um tooltip com informação de ajuda. 
 *
 * @param {string} [sk-text=undefined] Recebe um texto  informativo.
 * 
 * * @param {string} [sk-scrollable=undefined] Se verdadeiro cria um tooltip com a barra de scroll. PS: Funciona apenas com sk-placement='bottom'.
 *
 * @example
     <example module="app">
         <file name="HelpTipExample.html">
            	<sk-help-tip sk-text="Informação"></sk-help-tip>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.helptip')
    .directive('skHelpTip', [function (){
        return {
            restrict: 'E',
            template: '<sk-icon font-icon="circle-question-mark" ng-click="toggleTooltip()" ></sk-icon>',
            scope:{
                classHelp:'@?skClassHelp',
                placement: '@?skPlacement',
                scrollable: '=?skScrollable'
            },
            controller: ['$scope', '$element', '$attrs', 'i18n', 'TooltipBuilder', 'StringUtils',
            function($scope, $element, $attrs, i18n, TooltipBuilder, StringUtils){
                var _tooltipBuilder;
                var customClassHelp  = 'sk-help-tip-tooltip ' + $scope.classHelp;

                $scope.toggleTooltip = function() {
                    _tooltipBuilder = _tooltipBuilder || TooltipBuilder($element)
                                                                                .duration(-1)
                                                                                .customClass(customClassHelp)
                                                                                .setScrollable($scope.scrollable);

                    if(!angular.isUndefined($scope.placement)){
                        _tooltipBuilder.placement($scope.placement);
                    }

                    if (_tooltipBuilder.isOpen()) {
                        _tooltipBuilder.hide();
                    } else {
                        _tooltipBuilder
                            .message(i18n($attrs.skHelpTip || $attrs.skText))
                            .show();
                    }
                }
            }]
        }
    }]);
angular
    .module('snk.components.hover')
    .directive('skHoverClass', [function () {
        return {
            restrict: 'A',
            link: function($scope, $element, $attr) {
                var className = $attr.skHoverClass;

                $element.on('mouseenter', function() {
                    $element.addClass(className);
                });

                $element.on('mouseleave', function() {
                    $element.removeClass(className);
                });
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name snk.components.icon.directive:sk-icon
 * @restrict E
 * @description
 * A diretiva 'skIcon' permite você utilizar ícones no sistema de acordo com a nossa fonte vetorial Glyphicons e também
 * permite a utilização de SVG. 
 * 
 * Com a utilização do SVG já existe ícones pré-carregados na diretiva e também a possibilidade
 * de passar uma URL personalizada do seu ícone. Caso escolha a utilização de ícones pré-carregados, você precisa informar
 * apenas o ID do mesmo conforme a lista abaixo (para ver a representação de cada ícone, veja os exemplos):
 * 
 * <b>Ícone de arrow para tabs:</b> tabs-arrow.svg<br>
 * <b>Ícone de fechamento:</b> close.svg<br>
 * <b>Ícone de cancelamento:</b> cancel.svg<br>
 * <b>Ícone de arrow para toggle:</b> toggle-arrow.svg<br>
 *
 * @param {string=} fontIcon utilizado para informar qual o nome do ícone glyphicons que o componente precisa utilizar.
 *
 * @param {string=} svgSrc utilizado para informar a URL do ícone SVG que o componente deve usar. A utilização desse
 * item consiste em fazer o cache dos ícones carregados e com isso nas próximas vezes que o sistema precisar daquele ícone,
 * o mesmo vai estar no cache dos ícones e não será necessário fazer uma nova requisição.
 *
 * @param {string=} v versão do pacote de icones a ser utilizado, hoje temos a versão default (sem parâmetro) e a versão 2.
 * 
 * @scope
 *
 * @example
     <example module="app">
         <file name="exemplo.html">
            <div>
                <p>Ícone pré-carregado "tabs-arrow": <sk-icon svg-src="tabs-arrow.svg"></sk-icon></p>
                <p>Ícone pré-carregado "close": <sk-icon svg-src="close.svg"></sk-icon></p>
                <p>Ícone pré-carregado "cancel": <sk-icon svg-src="cancel.svg"></sk-icon></p>
                <p>Ícone pré-carregado "toggle-arrow": <sk-icon svg-src="toggle-arrow.svg"></sk-icon></p>
                <hr style="border-color:#ccc;margin: 2px 0px 10px 0px;">
                <p>Ícone carregado por URL: <sk-icon svg-src="img/html5-icon.svg"></sk-icon></p>
                <hr style="border-color:#ccc;margin: 2px 0px 10px 0px;">
                <p>Ícone carregado do Glyphicons (glyphicons-dog): <sk-icon font-icon="dog" style="font-size:18px;"></sk-icon></p>
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.icon')
    .directive('skIcon', ['StringUtils', 'skIconProvider',
function (StringUtils, skIconProvider) {
    return {
        scope: {
            fontIcon: '@fontIcon',
            svgSrc: '@svgSrc',
            onClick: '=?skClick',
            enabled: '=?skEnabled',
            visible: '=?skVisible',
            skClass: '@?skClass',
            colorDefault:'=?skColorDefault'//Pega a cor padrão do Jiva ou Sankhya -> "remover style="fill.....;" do svg"
        },
        restrict: 'E',
        template: getTemplate,
        link: postLink
    };

    function getTemplate(element, attr) {
        return attr.fontIcon ? '<span ng-disabled="!enabled" ng-show="visible !== false" ng-class="[prefixIcon, prefixIcon + \'-\' + fontIcon, skClass]"></span>' : '';
    }

    function postLink(scope, element, attr) {
        if (angular.isDefined(scope.enabled)){
            if (angular.isString(scope.enabled)) {
                var evaluated = scope.$eval(scope.enabled);

                scope.enabled = angular.isDefined(evaluated) ? evaluated : true;
            }
        } else {
            scope.enabled = true;
        }

        var parent = element.parent();
        var attrName = attr.$normalize(attr.$attr.svgSrc || '');

        if (angular.isFunction(scope.onClick)){
            angular.element(element).bind('click', function(e){
               if (scope.enabled){
                   scope.onClick(e);
               }
            });
        }

        let icoVersion = attr.v;

        // Support for ez-icones
        if (icoVersion === 'ez') {
            scope.prefixIcon = 'ez-icones';
        } else {
            icoVersion = icoVersion ? (' glyphicons-' + icoVersion) : '';
            scope.prefixIcon = 'glyphicons' + icoVersion;
        }

        if (angular.isDefined(parent) && angular.isDefined(parent[0])) {
            /*
            A condição parent.hasClass('btn') deve sempre vir primeiro nesse if,
            pois as demais verificações children.length por exemplo, faz com que 
            esse if fique parado até que os filhos do parent sejam totalmente 
            renderizados, causando grande problema de performance.
            */
            if (parent.hasClass('btn') && (StringUtils.isNotEmpty(parent[0].innerText) || (StringUtils.isNotEmpty(parent[0].textContent)) || parent[0].children.length > 1 )) {
                if (!attr.hasOwnProperty('noMargin')) {
                    element.addClass('margin-icon');
                }
            } else if (parent.hasClass('btn')) {
                element.addClass('no-text');
            }
        }
        
        if(scope.colorDefault){
            element.addClass('icon-color');
        }

        if (attrName) {
            attr.$observe(attrName, function (attrVal) {                

                if (attrVal) {
                    element.empty();
                    element.addClass("svg-icon");
                    skIconProvider(attrVal).then(function (svg) {
                        element.append(svg);
                    });
                }
            });
        }
    }
}]);

angular
    .module('snk.components.icon')
    .provider('skIconProvider', SkIconProvider);


var config = {
    defaultIconSize: 24
};

function SkIconProvider() {
    
}

SkIconProvider.prototype = {
    icon: function icon(id, url, iconSize) {
        if (id.indexOf(':') == -1) {
            id = '$default:' + id;
        }

        config[id] = new ConfigurationItem(url, iconSize);
        
        return this;
    },

    iconSet: function iconSet(id, url, iconSize) {
        config[id] = new ConfigurationItem(url, iconSize);
        return this;
    },

    defaultIconSet: function defaultIconSet(url, iconSize) {
        var setName = '$default';

        if (!config[setName]) {
            config[setName] = new ConfigurationItem(url, iconSize);
        }

        config[setName].iconSize = iconSize || config.defaultIconSize;

        return this;
    },

    defaultIconSize: function defaultIconSize(iconSize) {
        config.defaultIconSize = iconSize;
        return this;
    },

    preloadIcons: function ($templateCache) {
        var iconProvider = this;
        var svgRegistry = [
            {
                id: 'tabs-arrow',
                url: 'tabs-arrow.svg',
                svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><g><polygon points="15.4,7.4 14,6 8,12 14,18 15.4,16.6 10.8,12 "/></g></svg>'
            },
            {
                id: 'close',
                url: 'close.svg',
                svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><g><path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"/></g></svg>'
            },
            {
                id: 'cancel',
                url: 'cancel.svg',
                svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><g><path d="M12 2c-5.53 0-10 4.47-10 10s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10zm5 13.59l-1.41 1.41-3.59-3.59-3.59 3.59-1.41-1.41 3.59-3.59-3.59-3.59 1.41-1.41 3.59 3.59 3.59-3.59 1.41 1.41-3.59 3.59 3.59 3.59z"/></g></svg>'
            },
            {
                id: 'back',
                url: 'back.svg',
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="199.404" height="199.404" viewBox="0 0 199.404 199.404"><path d="M135.412 0L35.71 99.702l99.702 99.702 28.283-28.285L92.277 99.7l71.418-71.417"/></svg>'
            },
            {
                id: 'next',
                url: 'next.svg',
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="199.404" height="199.404" viewBox="0 0 199.404 199.404"><path d="M63.993 199.404l99.702-99.702L63.993 0 35.71 28.285l71.417 71.417L35.71 171.12"/></svg>'
            },
            {
                id: 'next',
                url: 'next.svg',
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="199.404" height="199.404" viewBox="0 0 199.404 199.404"><path d="M63.993 199.404l99.702-99.702L63.993 0 35.71 28.285l71.417 71.417L35.71 171.12"/></svg>'
            },
            {
                id: 'toggle-arrow',
                url: 'toggle-arrow.svg',
                svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 48 48"><path d="M24 16l-12 12 2.83 2.83 9.17-9.17 9.17 9.17 2.83-2.83z"/><path d="M0 0h48v48h-48z" fill="none"/></svg>'
            },
            {
                id: 'btn-remove-deselected',
                url: 'btn-remove-deselected.svg',
                svg: '<svg width="100%" height="100%" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" fit="" style="pointer-events: none; display: block;"><rect fill="#333" x="0.499984" y="0.437502" width="14" height="3" id="svg_2" stroke="#333"></rect><rect fill="#333" x="0.500031" y="11.5625" width="14" height="3" id="svg_3" stroke="#333"></rect><rect fill="#f3f3f3" stroke="#333" x="1.468738" y="5.437501" width="12" height="4" id="svg_4"></rect><ellipse stroke="#f3f3f3" fill="#f3f3f3" stroke-width="0" cx="11.437491" cy="11.368732" id="svg_7" rx="4.375019" ry="4.462517"></ellipse><rect stroke="null" id="svg_6" height="1.374957" width="3.499891" y="13.687307" x="11.531125" fill-opacity="null" stroke-opacity="null" stroke-width="0" fill="#f3f3f3"></rect><ellipse fill="#333" stroke-width="0" stroke-opacity="null" fill-opacity="null" cx="11.406239" cy="11.374982" id="svg_5" rx="3.5" ry="3.5" stroke="#f3f3f3"></ellipse><rect stroke="null" fill="#f3f3f3" x="9.250008" y="10.61249" width="4.3" height="1.5" id="svg_4"></rect></svg>'
            },
            {
                id: 'btn-remove-selected',
                url: 'btn-remove-selected.svg',
                svg: '<svg width="100%" height="100%" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" fit="" style="pointer-events: none; display: block;"><rect fill="none" x="1.499984" y="0.437502" width="12" height="3" id="svg_2" stroke="#333"></rect><rect fill="none" x="1.500031" y="11.5625" width="12" height="3" id="svg_3" stroke="#333"></rect><rect fill="#333333" stroke="#333" x="0.468738" y="5.437501" width="14" height="4" id="svg_4"></rect><ellipse stroke="#f3f3f3" fill="#f3f3f3" stroke-width="0" cx="11.437491" cy="11.368732" id="svg_7" rx="4.375019" ry="4.462517"></ellipse><rect stroke="#f3f3f3" id="svg_6" height="1.374957" width="3.499891" y="13.687307" x="11.531125" fill-opacity="null" stroke-opacity="null" stroke-width="0" fill="#f3f3f3"></rect><ellipse fill="#333333" stroke-width="0" stroke-opacity="null" fill-opacity="null" cx="11.406239" cy="11.374982" id="svg_5" rx="3.5" ry="3.5" stroke="#333333"></ellipse><rect stroke="null" fill="#f3f3f3" x="9.250008" y="10.61249" width="4.3" height="1.5" id="svg_4"></rect></svg>'
            },
            {
                id: 'maximize',
                url: 'maximize.svg',
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="402.996" height="402.996" viewBox="0 0 402.996 402.996"><path d="M392.996 1.985H258.33c-5.523 0-10 4.477-10 10V31.01c0 5.523 4.477 10 10 10h78.046l-111.42 111.42c-3.906 3.906-3.906 10.238 0 14.143l13.452 13.453c1.953 1.953 4.512 2.93 7.07 2.93 2.56 0 5.12-.978 7.07-2.93L363.973 68.604v78.047c0 5.524 4.478 10 10 10h19.024c5.523 0 10-4.476 10-10V11.986c0-5.523-4.476-10-10-10zM66.62 41.01h78.046c5.523 0 10-4.477 10-10V11.985c0-5.523-4.477-10-10-10H10c-5.523 0-10 4.477-10 10V146.65c0 5.524 4.477 10 10 10h19.024c5.523 0 10-4.476 10-10V68.605l111.422 111.42c1.952 1.954 4.512 2.93 7.07 2.93s5.12-.977 7.072-2.93l13.453-13.452c3.906-3.905 3.906-10.237 0-14.142L66.62 41.01zM392.996 246.344h-19.024c-5.522 0-10 4.478-10 10v78.047L252.55 222.97c-3.903-3.905-10.237-3.905-14.142 0l-13.453 13.453c-3.905 3.904-3.905 10.236 0 14.142l111.42 111.42H258.33c-5.523 0-10 4.478-10 10v19.024c0 5.522 4.477 10 10 10h134.666c5.523 0 10-4.478 10-10V256.343c0-5.523-4.476-10-10-10zM164.588 222.97c-3.905-3.905-10.238-3.905-14.142 0L39.024 334.392v-78.047c0-5.523-4.477-10-10-10H10c-5.523 0-10 4.477-10 10V391.01c0 5.524 4.477 10 10 10h134.666c5.523 0 10-4.476 10-10V371.99c0-5.523-4.477-10-10-10H66.62l111.42-111.422c3.906-3.904 3.906-10.236 0-14.143L164.59 222.97z"/></svg>'
            },
            {
                id: 'undo-arrow',
                url: 'undo-arrow.svg',
                svg: '<svg enable-background="new 0 0 90 90" version="1.1" viewBox="0 0 90 90" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="M90,79c0,0-10-48.667-53.875-48.667V11L0,43.276l36.125,33.455V54.94    C59.939,54.94,77.582,57.051,90,79z" fill="#030104"/></svg>'
            }
         ];

        svgRegistry.forEach(function (asset) {
            iconProvider.icon(asset.id, asset.url);
            $templateCache.put(asset.url, asset.svg);
        });

    },

    $get: ['$http', '$q', '$log', '$templateCache', function ($http, $q, $log, $templateCache) {
        this.preloadIcons($templateCache);
        return new IconService(config, $http, $q, $log, $templateCache);
   }]
};

/**
 *  Item de Configuração do armazenamento dos ícones registrados.
 *  Usado para localizar e carregar o mesmo caso este não esteja armazenado no cache.
 */
function ConfigurationItem(url, iconSize) {
    this.url = url;
    this.iconSize = iconSize || config.defaultIconSize;
}

function IconService(config, $http, $q, $log, $templateCache) {
    var iconCache = {};
    var urlRegex = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/i;

    Icon.prototype = {
        clone: cloneSVG,
        prepare: prepareAndStyle
    };

    return function getIcon(id) {
        id = id || '';

        // Se já está carregado e armazenado no cache, usa o clone do ícone em cache.
        // Senão ele carrega a partir da URL e faz o cache do mesmo.
        if (iconCache[id]) {
            return $q.when(iconCache[id].clone());
        }

        if (urlRegex.test(id)) {
            return loadByURL(id).then(cacheIcon(id));
        } else {
            throw new Error("The URL from SVG is invalid.");
        }
    };

    /**
     * Prepara e faz o cache do ícone carregado a partir do id especificado.
     */
    function cacheIcon(id) {
        return function updateCache(icon) {
            if (angular.isDefined(icon)) {
                iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
                return iconCache[id].clone();
            }

            return undefined;
        };
    }

    /**
     * Carrega o ícone a partir de uma URL (pode usar o $templateCache).
     * Extrair os dados para converter posteriormente em Ícone.
     */
    function loadByURL(url) {
        return $http
            .get(url, {
                cache: $templateCache
            })
            .then(function (response) {
                return angular.element('<div>').append(response.data).find('svg')[0];
            });
    }

    /**
     * Verifica a assinatura do target para ver se ele é uma instância do ícone.
     */
    function isIcon(target) {
        return angular.isDefined(target) && angular.isDefined(target.element) && angular.isDefined(target.config);
    }

    /**
     *  Define a classe do ícone.
     */
    function Icon(el, config) {
        if (el.tagName != 'svg') {
            el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el)[0];
        }

        // Injeta o namespace se não existir.
        if (!el.getAttribute('xmlns')) {
            el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
        }

        this.element = el;
        this.config = config;
        this.prepare();
    }

    /**
     *  Prepara o elemento DOM que será cacheado no iconCache.
     */
    function prepareAndStyle() {
        var iconSize = this.config ? this.config.iconSize : config.defaultIconSize;

        angular.forEach({
            'fit': '',
            'height': '100%',
            'width': '100%',
            'preserveAspectRatio': 'xMidYMid meet',
            'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + iconSize + ' ' + iconSize)
        }, function (val, attr) {
            this.element.setAttribute(attr, val);
        }, this);

        angular.forEach({
            'pointer-events': 'none',
            'display': 'block'
        }, function (val, style) {
            this.element.style[style] = val;
        }, this);
    }

    /**
     * Clona o elemento ícone do DOM.
     */
    function cloneSVG() {
        return this.element.cloneNode(true);
    }

}
/**
 * Created by bruno.brandao on 14/09/2017.
 */
angular
    .module('snk.components.imagepopup')
    .controller('ImagePopupController', ['$scope', '$popupInstance', '$q', 'DomUtil', 'options', function ($scope, $popupInstance, $q, DomUtil, options) {

      $scope.$success = openOriginal;

      $scope.$beforeShow = init;

      function init() {
        return $q(function(resolve, reject) {
          try {
            var modalDialog = angular.element(DomUtil.select($popupInstance.element, '.modal-dialog'));
            var modalBody = angular.element(DomUtil.select($popupInstance.element, '.modal-body'));
            modalBody.attr('layout-align', 'center center');

            var canvas = DomUtil.select($popupInstance.element, 'canvas');
            var ctx = canvas.getContext("2d");

            var maxWidth = modalBody.width();
            var maxHeight = modalBody.height();

            var img = new Image();
            img.onload = function () {
              try {
                var needResize = img.height > maxHeight || img.width > maxWidth;

                var newWidth, newHeight;

                if (needResize) {
                  var scale;

                  if (img.width >= img.height) {
                    scale = maxWidth / img.width;
                    newWidth = maxWidth;
                    newHeight = scale * img.height;
                    var needResizeHeight = newHeight > maxHeight;
                    if (needResizeHeight) {
	                    scale = maxHeight / newHeight;
	                    newHeight = scale * newHeight;
	                    newWidth = scale * newWidth;
                  	}
                  } else if (img.height > img.width) {
                    scale = maxHeight / img.height;
                    newHeight = maxHeight;
                    newWidth = scale * img.width;
                    var needResizeWidth = newWidth > maxWidth;
                    if (needResizeWidth) {
	                    scale = maxWidth / newWidth;
	                    newHeight = scale * newHeight;
	                    newWidth = scale * newWidth;
                  	}
                  } else {
                    newWidth = img.width;
                    newHeight = img.height;
                  }

                  canvas.width = newWidth;
                  canvas.height = newHeight;

                  angular.element(canvas).css({
                    width: newWidth + 'px',
                    height: newHeight + 'px'
                  });

                  /// step 1
                  var oc = document.createElement('canvas'),
                      octx = oc.getContext('2d');

                  oc.width = img.width;
                  oc.height = img.height;
                  octx.drawImage(img, 0, 0, oc.width, oc.height);

                  /// step 2
                  octx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5);

                  ctx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5,
                      0, 0, canvas.width, canvas.height);
                } else {
                  newWidth = img.width;
                  newHeight = img.height;

                  canvas.width = newWidth;
                  canvas.height = newHeight;

                  ctx.drawImage(img, 0, 0, newWidth, newHeight);
                }

                modalBody.css({
                  'min-width': 'auto',
                  width: '100%',
                  height: '100%'
                });

                modalDialog.css({
                  width: Math.max((newWidth + 10), 220) + 'px',
                  height: (newHeight + 10) + 'px'
                });

                $popupInstance.center();
                resolve();
              } catch (e) {
                reject();
              }
            };

            img.src = options.fileEncoded;
          } catch (e) {
            reject();
          }
        });
      }

      function openOriginal() {
        window.open(options.url, '_blank');
      }
    }]);
/**
 * Created by bruno.brandao on 14/09/2017.
 */
angular
    .module('snk.components.imagepopup')
    .service('ImagePopUpService', ['SanPopup', 'i18n', function (SanPopup, i18n) {
      var self = this;

      self.open = open;

      function open(options) {
        return SanPopup.open({
          title: options?.title || i18n('ImagePopup.title'),
          templateUrl: 'components/imagepopup/imagepopup.tpl.html',
          controller: 'ImagePopupController',
          windowClass: 'no-padding-modal-body',
          okBtnLabel: i18n('ImagePopup.lblAbrirOriginal'),
          cancelBtnLabel: i18n('Geral.lblFechar'),
          showBtnNo: false,
          showBtnCancel: true,
          size: 'lg',
          grayBG: true,
          resolve: {
            options: options
          }
        }).result;
      }
    }]);
angular
    .module('snk.components.input')
    .controller('SkCepInputController', ['$scope', '$timeout', '$element', 'ObjectUtils', 'PesquisaCEP','StringUtils', 'MGEParameters', 'SkConstants',
        function ($scope, $timeout, $element, ObjectUtils, PesquisaCEP, StringUtils, MGEParameters, SkConstants) {
            var self = this;

            var _ngModelCtrl;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            self.onFocusOut = onFocusOut;
            self.onFocusIn = onFocusIn;
            self.setNgModelCtrl = setNgModelCtrl;

            $scope.changeHandler = changeHandler;
            $scope.onKeyPress = onKeyPress;
            $scope.openPesquisaPopUp = openPesquisaPopUp;
            $scope.onClickCorreios = onClickCorreios;
            $scope.loadingCep = false;
            $scope.searchCEP = true;

            var canSearchCepOnProviders = ( ($scope.codsAdrressBind && ($scope.codsAdrressBind.CIDADE || $scope.codsAdrressBind.BAIRRO || $scope.codsAdrressBind.ENDERECO))
                || ($scope.descriptionsAdrressBind && ($scope.descriptionsAdrressBind.CIDADE || $scope.descriptionsAdrressBind.BAIRRO || $scope.descriptionsAdrressBind.ENDERECO)) ) && MGEParameters.asInteger('mge.core.tipo.consulta.automatica.cep') != 0;

            $scope.$watch('value', function(value){
                if(typeof value !== 'undefined'){
                    value = value.replace('-', '');
                    if(value.length == 8 && value === $scope.originalValue){
                        $scope.searchCEP = false;
                    } else {
                        $scope.searchCEP = true;
                    }
                }
            });    

            function setNgModelCtrl(ngModelCtrl) {
                _ngModelCtrl = ngModelCtrl;
            }

            function onKeyPress($event) {
                
                if($event.charCode == SkConstants.KEY_CODE.ENTER){
                    searchAddressByCep();
                }
                
                var acceptKey = $event.charCode >= 48 && $event.charCode <= 57 || $event.charCode === 0;

                if (!acceptKey) {
                    $event.preventDefault();
                }
            }

            function openPesquisaPopUp() {
                self.fbFocusIn();
                PesquisaCEP.openPesquisaCEP(getData())
                    .then(function (cepSelecionado) {
                        if (cepSelecionado) {

                            var addressInfo = {};

                            addressInfo['codCid'] = cepSelecionado.CODCID;
                            addressInfo['codBairro'] = cepSelecionado.CODBAI;
                            addressInfo['codEnd'] = cepSelecionado.CODEND;
                            
                            addressInfo['descCid'] = cepSelecionado['Cidade.NOMECID'];
                            addressInfo['descBairro'] = cepSelecionado['Bairro.NOMEBAI'];
                            addressInfo['descEnd'] = cepSelecionado['Endereco.NOMEEND'];

                            bindAddressFields(addressInfo);

                            if ($scope.onSelectCep) {
                                $scope.onSelectCep(cepSelecionado);
                            }


                            setData(cepSelecionado.CEP, true);
                            changeHandler();
                            self.fbFocusOut();
                        }
                    });
            }

            function changeHandler() {
                if (self.useDataset($scope)) {
                    $timeout(function () {
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    }, 0, false);
                }

                runOnChange();
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)($scope);
            }

            function setData(data, avoidRunOnChange) {
                $scope.originalValue = data;
                $scope.value = data;

                $timeout(function () {
                    updateViewValue(buildFieldMasked(data));
                }, 0, false);

                if (!avoidRunOnChange){
                    runOnChange();
                }
            }

            function getData() {
                return _ngModelCtrl.$viewValue && _ngModelCtrl.$viewValue.replace(/\.|-|\//g, '');
            }

            function buildFieldMasked(cleanValue) {
                if(isNaN(Number(removeSeparator(cleanValue)))){
                    return undefined;
                }
                
                if (cleanValue && cleanValue.length == 8) {
                    return cleanValue.replace(/(\d{5})(\d)/, '$1-$2');
                }

                return cleanValue;
            }

            function onFocusIn() {
                updateViewValue(getData());
            }

            function updateViewValue(value) {
                if (_ngModelCtrl) {
                    _ngModelCtrl.$viewValue = value;
                    _ngModelCtrl.$render();
                }
            }

            function onFocusOut() {
                updateViewValue(buildFieldMasked(_ngModelCtrl.$viewValue));

                if(canSearchCepOnProviders){
                    if(self.useDataset($scope)){
                        
                        var fieldNameResolved = $scope.fieldName;
                        
                        if(!fieldNameResolved && $scope.fieldIndex){
                            var fieldMD = $scope.dataset.getFieldMetadataByIndex($scope.fieldIndex);
                            if(fieldMD){
                                fieldNameResolved = fieldMD.name;
                            }
                        }

                        if(fieldNameResolved && $scope.dataset.isModifyingField(fieldNameResolved) && $scope.searchCEP){
                            searchAddressByCep();
                        }

                    }else{
                        searchAddressByCep();
                    }

                }

                if (angular.isFunction($scope.onFocusOut)) {
                    $scope.onFocusOut();
                }
            }

            function searchAddressByCep() {
                if(StringUtils.isEmpty(getData())){
                    clearAddressFields();
                    return;
                }
                
                if(getData().length != 8){                    
                    return;
                }

                $scope.loadingCep = true;
                
                PesquisaCEP.getDadosCep(getData()).then(function (enderecoData) {
                    $scope.loadingCep = false;
                    bindAddressFields(enderecoData);                    
                },function(){
                    $scope.loadingCep = false;
                });
            }

            function bindAddressFields(address) {
                if (self.useDataset($scope)) {

                    if ($scope.codsAdrressBind) {
                        if ($scope.codsAdrressBind.CIDADE && $scope.dataset.hasFieldBinder($scope.codsAdrressBind.CIDADE)) {
                        	//Comentei essas linhas de setFieldValue(CAMPO, 0) pois por algum motivo que n�o entendi (talvez assincronia), em alguns casos o campo ficava com o valor 0 inv�s do valor de address.codCid por exemplo.
                            //$scope.dataset.setFieldValue($scope.codsAdrressBind.CIDADE, 0); 
                            $scope.dataset.setFieldValue($scope.codsAdrressBind.CIDADE, address.codCid);
                        }

                        if ($scope.codsAdrressBind.BAIRRO && $scope.dataset.hasFieldBinder($scope.codsAdrressBind.BAIRRO)) {
                           //$scope.dataset.setFieldValue($scope.codsAdrressBind.BAIRRO, 0);
                            $scope.dataset.setFieldValue($scope.codsAdrressBind.BAIRRO, address.codBairro);
                        }

                        if ($scope.codsAdrressBind.ENDERECO && $scope.dataset.hasFieldBinder($scope.codsAdrressBind.ENDERECO)) {                            
                            //$scope.dataset.setFieldValue($scope.codsAdrressBind.ENDERECO, 0);
                            $scope.dataset.setFieldValue($scope.codsAdrressBind.ENDERECO, address.codEnd);
                        }

                        if ($scope.codsAdrressBind.UF && $scope.dataset.hasFieldBinder($scope.codsAdrressBind.UF)) {
                            //$scope.dataset.setFieldValue($scope.codsAdrressBind.UF, 0);
                            $scope.dataset.setFieldValue($scope.codsAdrressBind.UF, address.codUf);
                        }
                    }

                    if ($scope.descriptionsAdrressBind) {
                        if ($scope.descriptionsAdrressBind.CIDADE && $scope.dataset.hasFieldBinder($scope.descriptionsAdrressBind.CIDADE)) {
                            $scope.dataset.setFieldValue($scope.descriptionsAdrressBind.CIDADE, address.descCid);
                        }

                        if ($scope.descriptionsAdrressBind.BAIRRO && $scope.dataset.hasFieldBinder($scope.descriptionsAdrressBind.BAIRRO)) {
                            $scope.dataset.setFieldValue($scope.descriptionsAdrressBind.BAIRRO, address.descBairro);
                        }

                        if ($scope.descriptionsAdrressBind.ENDERECO && $scope.dataset.hasFieldBinder($scope.descriptionsAdrressBind.ENDERECO)) {
                            $scope.dataset.setFieldValue($scope.descriptionsAdrressBind.ENDERECO, address.descEnd);
                        }

                        if ($scope.descriptionsAdrressBind.UF && $scope.dataset.hasFieldBinder($scope.descriptionsAdrressBind.UF)) {
                            $scope.dataset.setFieldValue($scope.descriptionsAdrressBind.UF, address.descUf);
                        }
                    }
                }

                if ($scope.onAdrressLoadded) {
                    $scope.onAdrressLoadded(address);
                }
            }

            function clearAddressFields() {
                var addressInfo = {};

                addressInfo['codCid'] = '';
                addressInfo['codBairro'] = '';
                addressInfo['codEnd'] = '';
                addressInfo['codUf'] = '';
                
                addressInfo['descCid'] = '';
                addressInfo['descBairro'] = '';
                addressInfo['descEnd'] = '';
                addressInfo['descUf'] = '';

                bindAddressFields(addressInfo);
            }

            function onClickCorreios() {
                PesquisaCEP.openSiteCorreios(getData(), $scope.interceptAddressInfo);
            }

            function removeSeparator(text) {
                return text && text.replace(/-/g, '');
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-cep-input
 * @restrict E
 * @scope
 * @description
     Componente de CEP.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento do texto no componente.
 *
 * @param {string} [sk-cods-address-bind=undefined]
    É um objeto que pode conter os sguintes atributos: CIDADE, BAIRRO, ENDERECO, UF, o valor de cada um desses atributos se 
    refere ao campo de CÓDIGO do dataset a ser setado quando for encontrado um endereço no webservice dos correios.
 *
 * @param {string} [sk-desc-address-bind=undefined]
    É um objeto que pode conter os sguintes atributos: CIDADE, BAIRRO, ENDERECO, UF, o valor de cada um desses atributos se 
    refere ao campo de DESCRIÇÃO do dataset a ser setado quando for encontrado um endereço no webservice dos correios.
 *
 * @param {function} [sk-address-loadded-=undefined]
    Função a ser chamada quando o endereço do webservice dos correios é carregado, recebe como parâmetro um objeto com o endereço. 
 *
 * @example
     <example module="appCepInput">
         <file name="appCepInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-cep-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-cep-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appCepInput.js">
            angular
                .module('appCepInput', ['snk'])
                .controller('TesteController', TesteController);
                
                function TesteController($scope){
                    $scope.inputValue = '';
                    $scope.log = [];

                    $scope.$watch('inputValue',function(newv,oldv) {
                        console.log(newv);
                    });
                    $scope.onChange = function () {
                      $scope.log.push($scope.inputValue);
                    };
                }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skCepInput', ['$timeout', 'StringUtils',
function ($timeout, StringUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '=?skFocusOut',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            size: '=?skSize',
            interceptAddressInfo: '=?skInterceptAddressInfo',
            onSelectCep: '=?skOnSelectCep',
            codsAdrressBind: '<?skCodsAddressBind',
            descriptionsAdrressBind: '<?skDescAddressBind',
            onAdrressLoadded: '&?skAddressLoadded',
            onEndEdit: '&skEndEdit',
        },
        template: getTemplate,
        controller: 'SkCepInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';

        var template =
                '<input type="text" class="form-control" ng-model="value" ng-disabled="!enabled || loadingCep" ng-required="required" ng-change="changeHandler()" ng-keypress="onKeyPress($event)" "maxlength="8" {gridEditor} {autofocus}/>' +
                '<sk-icon font-icon=\'search\' ng-show="!loadingCep" ng-click="!enabled || openPesquisaPopUp()" sk-enabled="enabled"></sk-icon>' +
                '<sk-icon svg-src=\'/mge/assets/svg/btnSearchCorreios.svg\' ng-show="!loadingCep" class=\'btn-correios\' ng-click="!enabled || onClickCorreios()" sk-enabled="enabled" tooltip="{{\'SanDB.BuscaCEP.buttonPesquisaCorreios\' | translate}}" tooltip-append-to-body="true"></sk-icon>' +
                '<sk-loading-input-indicator sk-loading="loadingCep"></sk-loading-input-indicator>';

        var templateArgs = {
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'sk-datagrid-pesquisa-editor' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
            }, 0, false);
        }

        ctrl.setFocus = setFocus;
        ctrl.setNgModelCtrl(ngModelCtrl);

        angular.element(inputElement).bind('focus', function () {
            ctrl.onFocusIn();
            select();
        });

        angular.element(inputElement).bind('blur', function () {
            ctrl.onFocusOut();
        });

        ctrl.setElement(inputElement);

        if (attr.skDatagridEditor == 'true') {
            inputElement.focus();

            select();
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkCgcCpfInputController', ['$scope', '$timeout', '$element', 'ObjectUtils', 'StringUtils', 'NumberUtils',
        function ($scope, $timeout, $element, ObjectUtils, StringUtils, NumberUtils) {
            var self = this;

            var _ngModelCtrl;
            const alphanumericRegexPattern = /^[A-Za-z0-9]{12}\d{2}$/;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            self.onFocusOut = onFocusOut;
            self.onFocusIn = onFocusIn;
            self.setNgModelCtrl = setNgModelCtrl;
            self.removeSeparators = removeSeparators;
            self.cnpjIsAlphaNumeric = cnpjIsAlphaNumeric;

            $scope.changeHandler = changeHandler;
            $scope.onKeyPress = onKeyPress;

            function setNgModelCtrl(ngModelCtrl){
                _ngModelCtrl = ngModelCtrl;

              _ngModelCtrl.$parsers.push(function(value) {
                  value = removeSeparators(value); //Caso onde o valor é colado com os separadores.
                  value = sanitizeInput(value);
                  updateViewValue(value);
                  return value;
              });
            }

            function sanitizeInput(value) {
                if (!value) return value;

                value = value.toUpperCase();
                value = value.replace(/[^A-Z0-9]/g, '');

                if (value.length > 14) {
                    value = value.substring(0, 14);
                }

                if (value.length >= 13) {
                    let prefix = value.substring(0, 12);
                    let verifiers = value.substring(12);

                    let cleanVerifiers = verifiers.replace(/[^0-9]/g, '');

                    if (cleanVerifiers !== verifiers) {
                        value = prefix;
                    } else {
                        value = prefix + cleanVerifiers;
                    }
                }

                return value;
            }

            function isValidKey($event) {
              let isAlpha = ($event.charCode >= 65 && $event.charCode <= 90) || ($event.charCode >= 97 && $event.charCode <= 122);
              let isNumeric = $event.charCode >= 48 && $event.charCode <= 57;
              let isControlKey = $event.charCode === 0 || $event.isTrigger === true;
              let isAllowedSpecialKey = $event.charCode === 46 || $event.charCode === 8 || $event.charCode === 67 || $event.ctrlKey === true;

              if (isAlpha) {
                  let input = $event.target;
                  let cursorPos = input.selectionStart;
                  let currentValue = input.value;

                  let valueLength = (currentValue || '').length;

                  if (valueLength >= 12 && cursorPos >= 12) {
                      return false;
                  }
              }

              return isAlpha || isNumeric || isControlKey || isAllowedSpecialKey;
            }

            function changeToUpperCase($event) {
                if ($event.charCode >= 97 && $event.charCode <= 122) {
                    $event.preventDefault();

                    let upperChar = String.fromCharCode($event.charCode).toUpperCase();
                    let input = $event.target;
                    let start = input.selectionStart;
                    let end = input.selectionEnd;

                    input.value = input.value.substring(0, start) + upperChar + input.value.substring(end);
                    input.setSelectionRange(start + 1, start + 1);

                    _ngModelCtrl.$setViewValue(input.value);
                }
            }

            function onKeyPress($event){
                if(!isValidKey($event)){
                    $event.preventDefault();
                    return;
                }

                changeToUpperCase($event);
            }

            function changeHandler() {
                if (self.useDataset($scope)) {
                    $timeout(function () {
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    }, 0, false);
                }

                runOnChange();
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)($scope);
            }

            function setData(data) {
                $scope.value = data;

                $timeout(function(){
                    updateViewValue(buildFieldMasked(data));
                }, 0, false);

                runOnChange();
            }

            function getData(){
                return removeSeparators(_ngModelCtrl.$viewValue);
            }

            function removeSeparators(text) {
                return text && text.replace(/\.|-|\//g, '');
            }

            function buildFieldMasked(cleanValue) {
                if (!cleanValue || StringUtils.isEmpty(cleanValue)) {
                    return;
                }

                cleanValue = removeSeparators(cleanValue);

                if (!StringUtils.hasDigit(cleanValue)) {
                    return cleanValue;
                }

                let maskedText = '';

                if (cleanValue.length === 11 && NumberUtils.isNumeric(cleanValue)) {
                    for (let i = 0; i < cleanValue.length; i++) {
                        maskedText += cleanValue.charAt(i);

                        if (i === 2 || i === 5) {
                            maskedText += '.';
                        } else if (i === 8) {
                            maskedText += '-';
                        }
                    }
                } else if (cleanValue.length === 14 && cnpjIsAlphaNumeric(cleanValue)) {
                    for (let l = 0; l < cleanValue.length; l++) {
                        maskedText += cleanValue.charAt(l);
                        if (l === 1 || l === 4) {
                            maskedText += ".";
                        } else if (l === 7) {
                            maskedText += "/";
                        } else if (l === 11) {
                            maskedText += "-";
                        }
                    }
                } else {
                    maskedText = cleanValue;
                }

                return maskedText;
            }

            function onFocusIn() {
                updateViewValue(getData());
            }

            function updateViewValue(value){
                if (_ngModelCtrl){
                    _ngModelCtrl.$viewValue = value;
                    _ngModelCtrl.$render();
                }
            }

            function onFocusOut(){
                updateViewValue(buildFieldMasked(_ngModelCtrl.$viewValue));

                if (angular.isFunction($scope.onFocusOut)){
                    $scope.onFocusOut();
                }
            }

            function cnpjIsAlphaNumeric(input) {
                if (StringUtils.isEmpty(input)) {
                    return false;
                }

                return alphanumericRegexPattern.test(input);
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-cgc-cpf-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @example
     <example module="appCgcCpfInput">
         <file name="appCgcCpfInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-cgc-cpf-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-cgc-cpf-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appCgcCpfInput.js">
            angular
                .module('appCgcCpfInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.inputValue = '';
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skCgcCpfInput', ['$timeout', 'StringUtils',
function ($timeout, StringUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '=?skFocusOut',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            size: '=?skSize',
            onEndEdit: '&skEndEdit',
        },
        template: getTemplate,
        controller: 'SkCgcCpfInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';

        var template = '<input type="text" class="form-control" ng-model="value" ng-attr-placeholder="{{placeholder}}" ng-disabled="!enabled" ng-required="required" ng-change="changeHandler()" ng-keypress="onKeyPress($event)" {gridEditor} {autofocus}/>';

        var templateArgs = {
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];
        var $inputElement = angular.element(inputElement);
        var ngModelCtrl = $inputElement.data('$ngModelController');

        var fullSelected = false;


        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select() {
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.setFocus = setFocus;
        ctrl.setNgModelCtrl(ngModelCtrl);

        $inputElement.bind('focus', function () {
            ctrl.onFocusIn();
        });

        $inputElement.bind('click', function () {
           if (fullSelected) {
                var pos = (scope.value && scope.value.length) || 0;

                if (inputElement.setSelectionRange) {
                    inputElement.setSelectionRange(pos, pos);
                } else if (inputElement.createTextRange) {
                    // Curse you IE
                    var range = inputElement.createTextRange();
                    range.collapse(true);
                    range.moveStart('character', pos);
                    range.moveEnd('character', pos);
                    range.select();
                }

                fullSelected = false;
            } else if (isDatagrid()) {
                setFocus();
            } else {
                select();
            }
        });

        $inputElement.bind('mouseup', function(e){
            e.preventDefault();
        });

        $inputElement.bind('blur', function () {
            ctrl.onFocusOut();
            fullSelected = false;
        });

        $inputElement.bind('keypress', function(evt){
            if (scope.size && scope.value && scope.value.length >= scope.size){
              var selStart = evt.target.selectionStart;
              var selEnd = evt.target.selectionEnd;

              return (selStart != selEnd);
            }

            return true;
        });

        ctrl.setElement($inputElement);

        if (isDatagrid()) {
            inputElement.focus();

            $timeout(function () {
                select();
            }, 0, false);
        }
    }
}]);
/**
 * Created by Wender on 24/05/2016.
 */
angular
    .module('snk.components.input')
    .controller('SkCodeEditorController', ['$scope', '$timeout', 'ObjectUtils', 'StringUtils', 'AngularUtil',
        function ($scope, $timeout, ObjectUtils, StringUtils, AngularUtil) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            $scope.editorId = "code_" + StringUtils.nextUid();

            var _ignoreChange = false;
            var _editor;

            self.setFocus = setFocus;
            self.setMode = setMode;
            self.resize = resize;
            self.execCommand = execCommand;
            self.insert = insert;
            self.refresh = refresh;
            self.find = find;
            self.findPrevious = findPrevious;
            self.findNext = findNext;

            init();
            function init() {
                $timeout(function () {
                    ace.config.set('basePath', '/mge/scripts/vendors/ace');

                    if (document.getElementById($scope.editorId) == null){
                        return;
                    }

                    _editor = ace.edit($scope.editorId);

                    _editor.$blockScrolling = Infinity;

                    _editor.setTheme("ace/theme/eclipse");
                    _editor.getSession().setMode("ace/mode/" + $scope.mode);
                    _editor.setReadOnly($scope.enabled === false);

                    _editor.commands.addCommand({
                        name: "insertNewLine",
                        bindKey: { win: "Enter", mac: "Enter" },
                        exec: function(editor) {
                            var position = editor.getCursorPosition();
                            editor.session.insert(position, "\n");
                        }
                    });

                    _editor.getSession().on('change', function () {
                        if(!_ignoreChange){// Quando 
                            AngularUtil.apply($scope, function () {
                                $scope.value = _editor.getValue();
                            });
                        }
                    });

                    $scope.$watch('value', function (newValue, oldValue) {
                        // Verifica se o novo valor e diferente do atual no componente, isso ocorre quando a mudança e efetuada no js  
                        if (StringUtils.emptyAsUndefined(_editor.getValue()) != StringUtils.emptyAsUndefined(newValue)) {
                            _ignoreChange = true;
                            _editor.setValue(newValue || ''); //Atualizamos o componente
                            _editor.clearSelection();
                        }

                        if (StringUtils.emptyAsUndefined(newValue) != StringUtils.emptyAsUndefined(oldValue)) {
                            runOnChange();
                        }

                        $timeout(function () {
                            //voltamos avaliar o change
                            _ignoreChange = false;
                        }, 10, false);
                    });

                    $scope.$watch('enabled', function (newValue) {
                        _editor.setReadOnly(newValue === false);
                    });

                    if ($scope.creationComplete) {
                        $scope.creationComplete({editor: self});
                    }
                }, 100);
            }

            function resize(force) {
                _editor && _editor.resize(force);
            }

            function execCommand(cmd) {
                _editor && _editor.execCommand(cmd)
            }

            function setFocus() {
                _editor && _editor.focus();
            }

            function findNext() {
                _editor && _editor.findNext();
            }

            function findPrevious() {
                _editor && _editor.findPrevious();
            }
            
            function find(terms) {
                _editor && _editor.find(terms);
            }

            function insert(text) {
            	if(!_editor) {
            		return;
            	}
            	let cursorPosition = _editor.getCursorPosition();
            	_editor.session.insert(cursorPosition, text);
            }

            function setMode(mode) {
                _editor && _editor.getSession().setMode("ace/mode/" + mode);
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)($scope);

                if (self.useDataset($scope)) {
                    $scope.$evalAsync(function(){
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }
            }

            function refresh(){
                 AngularUtil.apply($scope, function() {
                     _editor.setValue(_editor.getValue());
                 });
            }

            function setData(data){
                $scope.value = StringUtils.undefinedAsEmpty(data);
            }

            function getData(){
                return $scope.value;
            }
        }
    ]);

/**
 * Created by Wender on 24/05/2016.
 */
/**
 * @ngdoc directive
 * @name snk.components.codeeditor.directive:sk-code-editor
 * @restrict E
 * @scope
 * @description
 Editor de código (Java, SQL, JavaScript, etc.) que exibe nro de linhas e highlight
 * @param {string} [sk-value=undefined]
 Texto (código) exibido no formatador, valor também digitado pelo usuário.
 *
 * @param {string} [sk-mode=""]
 Linguagem que será considerada para o highlight do código.<br/>
 Suporta: "java", "javascript", "sql", "sqlserver", "xml", "html", "as", "bash" e "sh"
 *
 * @param {boolean} [sk-enabled="true"]
 * Determina se o texto (conteúdo) será editável
 * @example
     <example module="app">
         <file name="exemplo.html">
            <div ng-controller="MyController as ctrl" flex layout="column" style="height:300px">
                <sk-code-editor flex layout
                    sk-mode="java"
                    sk-value="ctrl.value">
                </sk-code-editor>
                <span>Value:</span>
                <div ng-bind="ctrl.value"></div>
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope){
                    var self = this;
                });
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skCodeEditor',[function() {
        var directive = {};
        directive.restrict = 'E';
        directive.templateUrl = 'components/input/codeEditor/codeeditor.tpl.html';
        directive.controller = 'SkCodeEditorController';
        directive.scope = {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            value: "=?skValue",
            mode: "@skMode",
            enabled: "=?skEnabled",
            creationComplete: '&?skCreationComplete',
            onChange: '&?skChange',
        };

        return directive;
    }]);

angular
    .module('snk.components.input')
    .controller('SkComboboxController', ['ServiceProxy', '$scope', '$timeout', 'ObjectUtils', 'StringUtils', 'ArrayUtils', 
        function (ServiceProxy, $scope, $timeout, ObjectUtils, StringUtils, ArrayUtils) {
        var self = this;

        var isOptionsFromQuery = false;
        
        $scope.modelValue = {
            selected: undefined
        };

        ObjectUtils.implements(self, FieldBinder, {
            scope: $scope,
            setData: setData
        });

        $scope.key = $scope.key || 'data';
        $scope.label = $scope.label || 'value';
        $scope.changeHandler = changeHandler;
        $scope.onSelect = onSelect;
        $scope.processedOptions;

        self.updateCombobox = updateCombobox;
        self.updateComboOptions = updateComboOptions;

        init();

        function init() {
        	if (angular.isObject($scope.optionsFromQuery)) {
                loadOptionsFromQuery($scope.optionsFromQuery);
                isOptionsFromQuery = true;
            }
        	
            $scope.$watchGroup(['options', 'required'], updateComboOptions);

            self.addDatasetLoadedListener(function () {
                if (self.useDataset() && ($scope.options || []).length == 0) {
                    var fieldMD = $scope.dataset.getFieldMetadata(self.getFieldName());

                    $scope.options = fieldMD.options;
                    $scope.allowNull = fieldMD.isNullable;
                }
            });
        }

        function loadOptionsFromQuery(optionsFromQuery) {
            var query = optionsFromQuery.query;
            var descriptionField = optionsFromQuery.descriptionField;
            var keyField = optionsFromQuery.keyField;
            var callback = optionsFromQuery.callback;

            $scope.options = [];

            var params = {
                querydata: {
                    query: query
                }
            }

            ServiceProxy.callService('mge@ExecQuerySP.execQuery', params)
                .then(function (response) {

                    if ($scope.allowNull !== false) {
                        $scope.options.push({
                            data: '',
                            value: ''
                        });
                    }

                    var line = ObjectUtils.getProperty(response, 'responseBody.entity.line');

                    ArrayUtils.toArray(line)
                        .forEach(function (colunas) {
                            var key = undefined;
                            var description = undefined;

                            ArrayUtils.toArray(colunas.column)
                                .forEach(function (col) {
                                    if (col.name == keyField) {
                                        key = col.value;
                                    } else if (col.name == descriptionField) {
                                        description = col.value;
                                    }
                                });

                            if (StringUtils.emptyAsUndefined(description) == undefined) {
                                description = key;
                            }
                            
                            if (key != undefined) {
                                $scope.options.push({
                                    data: key,
                                    value: description
                                });
                            }
                        });

                    if (angular.isFunction(callback)) {
                        callback();
                    }
                });
        }

        function updateComboOptions() {
            if ($scope.required || (angular.isDefined($scope.allowNull) && !$scope.allowNull) || isOptionsFromQuery) {
                if($scope.options && $scope.options.length >= 0){
                    $scope.processedOptions = $scope.options;
                } else{
                    $scope.processedOptions = [$scope.options];
                }
            } else {
                var blankOption = ArrayUtils.find($scope.options, function (option) {
                    if (option[$scope.key] == "null") {
                        option[$scope.key] = "";
                    }
                    return StringUtils.isEmpty(option[$scope.key]);
                });
                
                if (!blankOption) {
                    blankOption = {};
                    
                    blankOption[$scope.key] = '';
                    blankOption[$scope.label] = ' ';
                    
                    $scope.processedOptions = [blankOption].concat($scope.options);
                } else {
                    $scope.processedOptions = $scope.options;
                }
            }

            if (angular.isDefined($scope.value)){
            	updateCombobox($scope.value);
            }
        }

        function onSelect() {
            var newValue = undefined;

            if ($scope.modelValue && $scope.modelValue.selected) {
                newValue = $scope.modelValue.selected[$scope.key];
            }

            self.finishedEdition(StringUtils.nullAsEmpty(newValue).toString(), StringUtils.nullAsEmpty($scope.value).toString());

            if (StringUtils.nullAsEmpty(newValue).toString() != StringUtils.nullAsEmpty($scope.value).toString()) {
                $scope.value = newValue;
                changeHandler($scope.value);
            }
        }

        function changeHandler() {
            self.notifyChangeToDataset();

            runOnChange();
        }

        function runOnChange() {
            $timeout(function () {
                ($scope.onChange || angular.noop)({
                	$selected: $scope.modelValue && $scope.modelValue.selected
                });
            }, 0);
        }

        function updateCombobox(data) {
            var selected = undefined;

            if ($scope.options) {
                for (var i = 0; i < $scope.options.length; i++) {
                    var opt = $scope.options[i];

                    if ((opt[$scope.key] == 'null' || StringUtils.isEmpty(opt[$scope.key])) && StringUtils.isEmpty(data)) {
                        opt[$scope.key] = undefined;
                        data = undefined;
                    }

                    if (opt[$scope.key] == data) {
                        selected = opt;
                        break;
                    }
                }

                $scope.modelValue.selected = selected;
            }
        }

        function setData(data) {
            updateCombobox(data);

            $scope.value = data;

            runOnChange();
        }
    }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-combobox
 * @restrict E
 * @scope
 * @description
    Componente de seleção equivalente ao select do html.
    Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
    - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
    - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
 *  Dataset que será utilizado no controle deste componente.
 *  Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 *  @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-allow-null=true]
    Habilitado ou não o componente ter valor nulo.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {array} [sk-options=undefined]
     Lista de opções a serem exibidas no combo.
 *
 * @param {string} [sk-opt-key=data]
    Nome da propriedade nas opções que determina a key da opção.
 *
 * @param {string} [sk-opt-label=value]
    Nome da propriedade nas opções que determina o label da opção.

 * @param {string} [sk-without-bind-html=false]
    Determina se o atributo será ng-bind ou ng-bind-html para o label, o padrão é ng-bind-html. 
    
 * @param {objeto} [sk-options-from-query=undefined]
    Recebe um objeto contento a descriptionField, keyField e query, que será utilizada para 
    construir as opções do combobox exemplo de envio
    <br/>
    <code class="prettyprint">
    var objeto = {
        descriptionField: 'REMETENTE',
        keyField: 'CODSMTP',
        query: 'SELECT CODSMTP, REMETENTE FROM TSISMTP',
        callback: function () {
               self.contaSMTP = 1;
        }
    }
    </code> 
 *

 *  @example
     <example module="appCombobox">
         <file name="appCombobox.html">
            <div ng-controller="DemoController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="value = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    <sk-combobox sk-enabled="enabled" sk-value="value" sk-options="options" sk-change="onChange()"></sk-combobox>
                    <p>Valor: {{value}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appCombobox.js">
            angular
                .module('appCombobox', ['snk'])
                .controller('DemoController', DemoController);

            function DemoController($scope){
                $scope.value = '2';
                $scope.enabled = false;
                $scope.options = [{ data: '1', value:'Opcao1'}, { data: '2', value:'Opcao2'}];
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.value);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skCombobox', ['$timeout', 'StringUtils', '$document', 'SkConstants', function ($timeout, StringUtils, $document, SkConstants) {
        return {
            scope: {
                dataset: '=?skDataset',
                fieldName: '@?skFieldName',
                fieldIndex: '@?skFieldIndex',
                value: '=?skValue',
                options: '=?skOptions',
                onFocusOut: '&?skFocusOut',
                onFocus: '&?skFocus',
                onChange: '&?skChange',
                key: '@?skOptKey',
                label: '@?skOptLabel',
                enabled: '=?skEnabled',
                required: '=?skRequired',
                allowNull: '=?skAllowNull',
                gridEditor: '@skDatagridEditor',
                optionsFromQuery:'=?skOptionsFromQuery',
                withoutBindHtml: '=?skWithoutBindHtml'
           },
            templateUrl: 'components/input/combobox/combobox.tpl.html',
            controller: 'SkComboboxController',
            link: linkFn
        };

        function linkFn(scope, element, attr, ctrl) {
           
            var uiSelectScope = angular.element(element.children()[0]).scope();
            var closeHandler = closeHandler;
            var unregistryHandler = scope.$watch(function () {
                return scope.value
            }, function (newValue) {
                ctrl.updateCombobox(newValue);
            });

            ctrl.setFocus = setFocus;

            if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
                throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
            }

            if (attr.skDatagridEditor == 'true') {
                $timeout(function(){
                    setFocus();
                }, 0, false);
            }

            if (attr.autofocus) {
                $timeout(function(){
                    setFocus();
                }, 0, false);
            }

            $document.on(SkConstants.EVENTS.SCROLL, closeHandler);
           
            scope.$on(SkConstants.EVENTS.DESTROY, function () {
                unregistryHandler();

                $document.off(SkConstants.EVENTS.SCROLL, closeHandler);
            });

            function closeHandler() {
                if (uiSelectScope && uiSelectScope.$select) {
                    uiSelectScope.$select.close();
                }
            }

            function setFocus() {
                scope.$broadcast('UiSelectFocusEvent');
            }
        };
    }]);
angular
    .module('snk.components.input')
    .constant('SkCompanySelectorContants',{
        COMPANY_SELECTED_EVENT:"insertionMode",
        CODEMPPLACTA_FIELD:"CODEMPPLACTA",
        CODEMP_FIELD:"CODEMP",
        COREMPRESA_FIELD:"COREMPRESA",
        DTFIMPERCTB_FIELD:"DTFIMPERCTB",
        DTINICPERCTB_FIELD:"DTINICPERCTB",
        MASCCTA_FIELD:"MASCCTA",
        NROLOTEMNUALFIM_FIELD:"NROLOTEMNUALFIM",
        NROLOTEMNUALINI_FIELD:"NROLOTEMNUALINI",
        NUMLOTESAUT_FIELD:"NUMLOTESAUT",
        RAZAOSOCIAL_FIELD:"RAZAOSOCIAL",
        REFERENCIA_FIELD:"REFERENCIA", 
        UTILCENCUS_FIELD:"UTILCENCUS",
        UTILPROJ_FIELD:"UTILPROJ",
        PERALTQDCOM_FIELD:"PERALTQDCOM",
        ULTPAGDIARIO_FIELD:"ULTPAGDIARIO",
        ACEITARHISTZERO_FIELD:"ACEITARHISTZERO",
        CODCTACTBENCRES_FIELD:"CODCTACTBENCRES",
        CODINSTRESP_FIELD:"CODINSTRESP",
        MASCCTAEXT_FIELD:"MASCCTAEXT"
    }).controller('SkCompanySelectorInputController', ['$scope','$timeout','CrudUtils','StringUtils','SkCompanySelectorContants',
        'SkPesquisaService','DateUtils','i18n','ColorUtils','NumberUtils','SkSessionStorage','SkApplicationInstance',
        function ($scope, $timeout, CrudUtils,StringUtils, SkCompanySelectorContants, SkPesquisaService, DateUtils, i18n, ColorUtils,
            NumberUtils,SkSessionStorage, SkApplicationInstance) {
            var self = this;

            $scope.openSelection = openSelection;
            $scope.mouseOver = mouseOver;
            $scope.mouseLeave = mouseLeave;

            self.asDate = asDate;
            self.asString = asString;
            self.asNumber = asNumber;
            self.asBoolean = asBoolean;
            self.getAllProperties = getAllProperties;
            self.load = load;
            self.hasSelected = hasSelected;

            $scope.styleSelector = {
            		
                "color" : "0xFFFFFF",
                "background-color": "white"
            }

            var _propertyNames = [
                SkCompanySelectorContants.CODEMPPLACTA_FIELD,
                SkCompanySelectorContants.CODEMP_FIELD,
                SkCompanySelectorContants.COREMPRESA_FIELD,
                SkCompanySelectorContants.DTFIMPERCTB_FIELD,
                SkCompanySelectorContants.DTINICPERCTB_FIELD,
                SkCompanySelectorContants.MASCCTA_FIELD,				
                SkCompanySelectorContants.NROLOTEMNUALFIM_FIELD,
                SkCompanySelectorContants.NROLOTEMNUALINI_FIELD,
                SkCompanySelectorContants.NUMLOTESAUT_FIELD,
                SkCompanySelectorContants.RAZAOSOCIAL_FIELD,
                SkCompanySelectorContants.REFERENCIA_FIELD,
                SkCompanySelectorContants.UTILCENCUS_FIELD,
                SkCompanySelectorContants.UTILPROJ_FIELD,
                SkCompanySelectorContants.PERALTQDCOM_FIELD,
                SkCompanySelectorContants.ULTPAGDIARIO_FIELD,
                SkCompanySelectorContants.ACEITARHISTZERO_FIELD,
                SkCompanySelectorContants.CODCTACTBENCRES_FIELD,
                SkCompanySelectorContants.CODINSTRESP_FIELD,
                SkCompanySelectorContants.MASCCTAEXT_FIELD
            ];

            // var _storage = SkSessionStorage(''SkApplicationInstance.getScreenResourceID());
            var _storage = SkSessionStorage('COMPANY_SELECTOR');
            var _properties;
            var _propertiesInMemory = undefined;
            var _backgroundColor = 0xFFFFFF;

            init();

            function init(){
                $timeout(function () {
                    if (angular.isFunction($scope.companySelectorCreated)) {
                        $scope.companySelectorCreated({
                            selector: self
                        });
                    }
                }, 0, false);

                load();
            }

            function load(selectedRow, forceCodEmp){
				if(selectedRow){
					_properties = {};
					
					_propertyNames.forEach(function(fieldName){
						var value = selectedRow.data[fieldName];

                        if (fieldName === SkCompanySelectorContants.CODEMP_FIELD) {
                            //adiciona chave e valor em cache para tela enquanto a aba estiver aberta, mantem o valor
                            //até mesmo ao sair e entrar no sistema novamente.
                            _storage.set(fieldName,value);
                        }

						_properties[fieldName] = value; 
					});

                    createLabel();

                    if (angular.isFunction($scope.companySelected)) {
                        $scope.companySelected({
                            selector :self
                        });
                    }
                } else if(hasSelected() || forceCodEmp != null){
					_properties = {};

					var codEmp = forceCodEmp ||  getPropertyInStorage(SkCompanySelectorContants.CODEMP_FIELD);

                    var fields = [];
					_propertyNames.forEach(function(fieldName){
						fields.push(fieldName);
					});

                    var criterio = {CODEMP : codEmp}
                    var entityName = "ViewEmpresaContabilidade";
                    var result = CrudUtils.find(entityName, fields, criterio, true)
                                .then(function(result) {
                                    if (result) {
                                        _propertyNames.forEach(function(fieldName){
                                            _properties[fieldName] = result[fieldName];
                                        });

                                        createLabel(forceCodEmp);
                                        if (angular.isFunction($scope.companySelected)) {
                                            $scope.companySelected({
                                                selector :self
                                            });
                                        }
                                    } else {
                                        forcerSelection();
                                    }
                                });
				} else {
					//Não tem informação no contexto. Forçar a seleção.
                    forcerSelection();
				}
            }

            function forcerSelection() {
                if (angular.isUndefined($scope.showSelector) || $scope.showSelector === true) {
                    openSelection();
                }

                createLabel();
            }

			function createLabel(forceCodEmp){
				$scope.buttonLabel = getLabel(forceCodEmp);

                if (hasSelected() || forceCodEmp != null) {
                    _backgroundColor = ColorUtils.toStringColor(asNumber(SkCompanySelectorContants.COREMPRESA_FIELD));
                } else {
                    _backgroundColor = 0xFFFFFF;
                }

                changeColors(_backgroundColor);
			}

			function getLabel(forceCodEmp){
				var label;
                if (angular.isFunction($scope.customizeLabel) && !StringUtils.isEmpty($scope.customizeLabel)) {
                    label = $scope.customizeLabel({selector : self});
                } else {
                    if (hasSelected() || forceCodEmp != null) {
                        label = asString(SkCompanySelectorContants.CODEMP_FIELD) + " - " + asString(SkCompanySelectorContants.RAZAOSOCIAL_FIELD);
                        var ref = asString(SkCompanySelectorContants.REFERENCIA_FIELD);
                        if (angular.isDefined(ref)) {
                            ref = ref.trim();
                            label += " (" + DateUtils.formatDate(DateUtils.strToDate(ref), "MM/YYYY") + ")";
                        }
                    }
                }

                if (angular.isUndefined(label)) {
                    label = i18n('Controls.CompanySelector.tituloSelecioneEmpresa');
                }

				return label; 
			}

			function openSelection(){
                var options = {
                    loadOnCreate: false,
                    enableRowsCounter: true,
                    allowShowHierarchicalMode: false,
                    descriptionFieldName: SkCompanySelectorContants.CODEMP_FIELD,
                    label: "Empresa"                   
                }

                var entityName = "ViewEmpresaContabilidade";
                var descriptionValue = undefined;

                SkPesquisaService.openPesquisaPopUp(entityName, descriptionValue, options)
                    .then(onSelectEntity);
            }

            function loadOnCreate(){
                //caso queira acessar algo do popup após sua criação.
            }

            function onSelectEntity(item){
                load(item);
            }

			function asString(field){
				if(angular.isDefined(_properties) && _properties.hasOwnProperty(field)) {
                    var fieldString = _properties[field];

					return StringUtils.emptyAsNull(fieldString);
				} else {
					return undefined;
				}
			}

			function asNumber(field){
				return NumberUtils.stringToNumber(asString(field));	
			}

			function asDate(field) {
				return DateUtils.strToDate(asString(field));
			}
			
			function asBoolean(field) {
				return 'S' == asString(field);
			}

			function hasSelected(){
				var codemp = getPropertyInStorage(SkCompanySelectorContants.CODEMP_FIELD);	
				return !StringUtils.isEmpty(codemp);
			}

            function getPropertyInStorage(prop){
                _propertiesInMemory =  _storage.get(prop, undefined);

                if (angular.isDefined(_propertiesInMemory)) {
                    return _propertiesInMemory;
                }

                return undefined;
            }

			function isOwnerOfChartOfAccounts(){
				var codEmp = asNumber(SkCompanySelectorContants.CODEMP_FIELD); 
				var codEmpPlanoDeContas = asNumber(SkCompanySelectorContants.CODEMPPLACTA_FIELD);

				return codEmp != 0 && codEmp == codEmpPlanoDeContas;
			}

			function changeColors(backgroundColor){	
                var labelColor = ColorUtils.getContrastColor(backgroundColor);

                $scope.styleSelector = {
                    "color" : ColorUtils.intToHex(labelColor),
                    "background-color" : ColorUtils.intToHex(backgroundColor)
                }
			}

            function getMaskValue() {
                var maskBase = asString(SkCompanySelectorContants.MASCCTA_FIELD);

                //Verificar se existe o 
                return StringUtils.isEmpty(maskBase) ? "1" : StringUtils.applyHierarchyMask(maskBase);
            }

            function getMaskValueECD() {
                var maskBase = asString(SkCompanySelectorContants.MASCCTAEXT_FIELD);

                return StringUtils.isEmpty(maskBase) ? "1" : StringUtils.applyHierarchyMask(maskBase);
            }

            function mouseOver(){
                var background = ColorUtils.getVariantColor(_backgroundColor, 30);
                changeColors(background);
            }
            
            function mouseLeave(){
                changeColors(_backgroundColor);
            }

            function getAllProperties(){
                return _properties;
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-company-selector
 * @restrict E
 * @scope
 * @description
    <p align="justify"> Seletor de Empresa é o componente responsável por selecionar a empresa da contabilidade 
        utilizando a instância ViewEmpresaContabilidade para buscar os dados da mesma, após selecionada ao 
        fechar o sistema e abrir novamente a última empresa será carregada, a limpeza da empresa selecionada é realizada
        abrindo o sistema em outra aba do navegador.
    </p>
 
 * @param {function} sk-company-selector-created
 *  - Função executada após a criação completa do componente.
  
 * @param {function} sk-company-selected
 *  - Função executada após a seleção da empresa, ou após o carregamento do componente quando a empresa já foi selecionada anteriormente.

 * @param {function} sk-customize-label
 *  - Função executada ao inicializar o componente, como também após a escolher da empresa, sendo possível customizar a apresentação
 *    do label.

 * @param {boolean} sk-show-selector
 *  - Apresenta o seletor para a escolha da empresa na inicialização, caso o parâmetro não seja passado, o padrão é que o seletor
 *    seja apresentado.
 
 * @example
 * <example module="app">
         <file name="exemplo1.html">
                <sk-application ng-controller="ExampleController as ctrl" layout-padding sk-bg-color="white" style="height: 400px;">
                    <sk-company-selector 
                        sk-company-selector-created="ctrl.companySelectorCreated(selector)"
                        sk-company-selected="ctrl.selectedCompany(selector)"
                         ">
                    </sk-company-selector>
                    <br>Primeira Empresa Selecionada:{{ctrl.codEmp}}
                    <br>
                    <sk-company-selector 
                        sk-company-selected="ctrl.selectedCompany1(selector)"
                        sk-customize-label="ctrl.setCustomizeLabel(selector)"
                        sk-show-selector="false">
                    </sk-company-selector>
                    Segunda Empresa Selecionada:{{ctrl.codEmp1}}
                </sk-application>
         </file>
         <file name="app.js">
             angular
                .module('app', ['snk'])
                .controller('ExampleController', ['SkCompanySelectorContants', function(SkCompanySelectorContants){
                    var self = this;             

                    self.selectedCompany = selectedCompany;
                    self.companySelectorCreated = companySelectorCreated;
                    self.setCustomizeLabel = setCustomizeLabel;

                    _selector = undefined;

                    function companySelectorCreated(selector){
                        _selector = selector;
                    }

                    function selectedCompany(selector){
                        if(selector){
                            self.codEmp = selector.asString(SkCompanySelectorContants.CODEMP_FIELD);
                        }
                    }
                   
                    function selectedCompany1(selector){
                        if(selector){
                            self.codEmp1 = selector.asString(SkCompanySelectorContants.CODEMP_FIELD);
                        }
                    }

                    function setCustomizeLabel(selector){
                        var codEmp = selector.asString(SkCompanySelectorContants.CODEMP_FIELD);
                        var label = "Selecione uma empresa por favor";
                        if (angular.isDefined(codEmp)) {
                            label = "Você selecionou a empresa: " + codEmp;
                        } 

                        return label;
                    }
                }]);
         </file>
     </example>
*/
angular
    .module('snk.components.input')
    .directive('skCompanySelector', ['$timeout', 'StringUtils', 'i18n',
function ($timeout, StringUtils, i18n) {
    return {
        restrict: 'E',
        scope: {
            companySelectorCreated : '&?skCompanySelectorCreated',
            companySelected : '&?skCompanySelected',
            customizeLabel : '&?skCustomizeLabel',
            showSelector : '=skShowSelector'
        },
        template: getTemplate,
        controller: 'SkCompanySelectorInputController'
    };

    function getTemplate(tElem, tAttrs) {
        var template = '<div>' +
                            '<button ng-click="openSelection()" class="btn btn-block" ng-style="styleSelector" ng-mouseover="mouseOver()" ng-mouseleave="mouseLeave()"><u>{{buttonLabel}}</u></button>'+
                        '</div>';

        return template;
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkControleEstoqueInput', ['$scope', '$timeout', '$element', 'ObjectUtils', 'AngularUtil', 'CrudUtils', 'ArrayUtils', 'StringUtils', 'i18n', 'DateUtils', 'DateUtilsConstants', 'GradeProdutoService', 'GradeProdutoConstant',
        function ($scope, $timeout, $element, ObjectUtils, AngularUtil, CrudUtils, ArrayUtils, StringUtils, i18n, DateUtils, DateUtilsConstants, GradeProdutoService, GradeProdutoConstant) {
            var self = this;

            ObjectUtils.implements(self, IDataSetObserver);

            $scope.valueObj = {
                innerValue: undefined
            };

            $scope.labelBtnGrade = 'Grade';

            $scope.onControleInputFocusOut = onControleInputFocusOut;

            var _productChangeListeners = [];
            var _clickBtnSerieListeners = [];
            var _changeControle = [];
            var _confirmarGradeChangeListeners = [];

            var _simpleFormCtrl;
            var _publicAPI;
            var _defaultLabel;
            var _dataSet;
            var _fieldName;
            var _labelManual;
            var _showWhenType;
            var _tipMov;

            self.setSimpleFormCtrl = setSimpleFormCtrl;
            self.loadByCodProd = loadByCodProd;
            self.onProductInfoChange = onProductInfoChange;
            self.changeControle = changeControle;
            self.setValue = setValue;
            self.setDefaultLabel = setDefaultLabel;
            self.onEditarSerie = onEditarSerie;
            self.serieBtnClick = serieBtnClick;
            self.changeHandler = changeHandler;
            self.rowMetadataChanged = rowMetadataChanged;
            self.setEnableSerie = setEnableSerie;
            self.populateCombo = populateCombo;
            self.selectUI = selectUI;
            self.openGrade = openGrade;
            self.confirmarGrade = confirmarGrade;
            self.useControle;
            self.setEnableBtnGrade = setEnableBtnGrade;
            self.enableBtnGrade = true;
            self.getTipMov = getTipMov;

            init();

            function init() {
                _dataSet = $scope.dataset;
                _fieldName = $scope.fieldName;
                _labelManual = $scope.labelManual;
                _showWhenType = $scope.showWhenType;

                _publicAPI = ObjectUtils.buildPublicAPI(self, ['loadByCodProd', 'onProductInfoChange', 'setValue', 'serieBtnClick', 'changeControle', 'setEnableSerie', 'confirmarGrade', 'setEnableBtnGrade', 'getTipMov']);

                $scope.$watch('valueObj.innerValue', function (v) {
                    if (v instanceof Date) {
                        v = DateUtils.dateToString(v, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                    }

                    $scope.value = v;
                });

                $scope.$watch('dataset', (newDs) => {
                    if(newDs){
                        _dataSet = newDs;
                        _dataSet.addObserver(self);

                        ObjectUtils.implements(self, FieldBinder, {
                            scope: $scope,
                            setData: setData,
                            getData: getData
                        });

                        updateMetadata();
                    }
                });

                if (angular.isFunction($scope.componentCreated) ) {
                    $scope.componentCreated({ $component: _publicAPI });
                }
            }

            function setData(data){
                $scope.value = data == " " ? undefined : data;
                $scope.valueObj.innerValue = $scope.value;
                
                if($scope.tipContEst == 'G' || !StringUtils.isEmpty($scope.value)){
                    $scope.labelBtnGrade = StringUtils.isEmpty($scope.value) ? $scope.labelBtnGrade : StringUtils.replaceAll(String($scope.value), ":","-");
                }
            }

            function getData(){
                return $scope.value;
            }

            function runOnChange() {
                if ($scope.value instanceof Date) {
                    $scope.value = DateUtils.dateToString($scope.value, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                }

                ArrayUtils.callEachFunctionWith(_changeControle, {
                    valueControl: $scope.value
                });
            }

            function changeHandler() {
            	if (angular.isDefined(self.useDataset) && self.useDataset($scope)) {
                    $timeout(function () {
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    }, 0, false);
                }

                runOnChange();
            }

            function setSimpleFormCtrl(simpleFormCtrl) {
                _simpleFormCtrl = simpleFormCtrl;
            }

            function onProductInfoChange(listener) {
                _productChangeListeners.push(listener);
            }

            function changeControle(listener) {
                _changeControle.push(listener);
            }

            function serieBtnClick(listener) {
                _clickBtnSerieListeners.push(listener);
            }

            function setDefaultLabel(defaultLabel) {
                _defaultLabel = defaultLabel;
            }

            function loadByCodProd(codProd) {
                if (StringUtils.isEmpty(codProd)) {
                    $scope.tipContEst = '';
                    if (_simpleFormCtrl) {
                        _simpleFormCtrl.setText(undefined);
                    }
                    ArrayUtils.callEachFunctionWith(_productChangeListeners, undefined);
                } else {
                    CrudUtils.find('Produto', 'TIPCONTEST,LISCONTEST,TITCONTEST', {
                        CODPROD: codProd
                    }, true, undefined, undefined, { includePresentations: false })
                        .then(function (result) {
                        	if(result != undefined) {
                        		if (_simpleFormCtrl && !_labelManual) {
                        			_simpleFormCtrl.setText(result.TITCONTEST);
                        		}
                        		
                        		var tipContEst = result.TIPCONTEST;
                        		if (tipContEst == "G" && $scope.preferGridOptions === true) {
                        			tipContEst = 'GO';
                        		}
                        		
                        		$scope.tipContEst = tipContEst;
                        		
                        		$scope.listOptions = [];
                        		
                        		if (result.LISCONTEST != undefined) {
                        			populateCombo(result.LISCONTEST);
                        		}
                        		
                        		$scope.labelControl = StringUtils.isEmpty(result.TITCONTEST) ? _defaultLabel : result.TITCONTEST;
                        		updateLabelControl();
                        		setUseControle();
                        		
                        		ArrayUtils.callEachFunctionWith(_productChangeListeners, {
                        			TIPCONTEST: $scope.tipContEst,
                        			LISCONTEST: $scope.listOptions,
                        			TITCONTEST: $scope.labelControl
                        		});
                        	}
                        });
                }

                AngularUtil.digest($scope);
            }

            function setValue(value) {
                if (!_dataSet) {
                    $scope.valueObj.innerValue = value;
                }
            }

            function setUseControle() {
                self.useControle = StringUtils.isNotEmpty($scope.tipContEst) && $scope.tipContEst != "N";

                if (!self.useControle) {
                    $scope.value = undefined;
                }
            }

            function updateLabelControl() {
                if (StringUtils.isNotEmpty($scope.labelText)) {
                    updateLabel($scope.labelText);
                    return;
                }

                switch ($scope.tipContEst) {
                    case "L":
                        updateLabel(i18n('ControleProduto.labelLote'));
                        break;

                    case "P":
                        updateLabel(i18n('ControleProduto.labelParceiro'));
                        break;

                    case "V":
                        updateLabel(i18n('ControleProduto.labelData'));
                        break;

                    case "E":
                        updateLabel(i18n('ControleProduto.labelSerie'));
                        break;

                    case "G":
                        updateLabel(i18n('ControleProduto.labelGrade'));
                        break;

                    case "S":
                    case "I":
                        updateLabel($scope.labelControl);
                        break;

                    default:
                        updateLabel(_defaultLabel);
                        break;
                }
            }

            function updateLabel(value) {
                if ($scope.$parent && $scope.$parent.properties && $scope.$parent.properties.description && StringUtils.isNotEmpty(value)) {
                    $scope.$parent.properties.description = value;
                }
            }

            function onEditarSerie() {
                ArrayUtils.callEachFunctionWith(_clickBtnSerieListeners, undefined);
            }

            function rowMetadataChanged(reason, providerChanged) {
                updateMetadata();
            }
            
            function setEnableSerie(enable){
            	$scope.enabledSerie = self.serieEnable = enable;
            }

            function getRowMetadataProperty(metadata) {
                if (metadata == undefined || !metadata.properties ) {
                    return undefined;
                }

                for (property of metadata.properties) {
                    if ("rm_controle" === property.name) {
                        return property.value;
                    }
                }
            }

            function updateMetadata() {
                if (!_dataSet || _dataSet.getFieldsMetadata() == undefined) {
                    return;
                }
                
                var tipContest = "N";
                var metadata = _dataSet.getFieldMetadata(_fieldName);

                if (StringUtils.isNotEmpty(metadata)) {
                    var metadataKey = getRowMetadataProperty(metadata);

                    var controle = _dataSet.getRowMetadata(undefined, metadataKey);

                    if (StringUtils.isNotEmpty(controle)) {
                        tipContest = controle.tipoContEst;
                        
                        if(StringUtils.isNotEmpty(_showWhenType) && _showWhenType.indexOf(tipContest) == -1){
							/*Algumas rotinas não utilizam todos os tipos de controle, como por exemplo o módulo ARMAZENS
							 por isso foi criada a prop. sk-show-when-type (semelhante ao que temos no FLEX)*/ 
							tipContest = 'N';
						}
                        
                		if (tipContest == "G" && $scope.preferGridOptions === true) {
                			tipContest = 'GO';
                		}
                        
                        $scope.tipContEst = tipContest;
                        $scope.labelControl = StringUtils.isEmpty(controle.labelContEst) ? _defaultLabel : controle.labelContEst;
                        updateLabelControl();
                        
                        if (StringUtils.isNotEmpty($scope.preferDefault) && $scope.preferDefault.indexOf(tipContest) != -1) {
                            $scope.tipContEst = 'D';
                        }

                        if (tipContest == "S") {
                            $scope.listOptions = [];

                            if(metadata.isNullable){
                                $scope.listOptions.push({
                                    data: '',
                                    value: ''
                                });
                            }

                            for (opt of controle.listaContEst) {
                                $scope.listOptions.push({ data: opt, value: opt });
                            }
                        } else if (tipContest == "GO" && $scope.preferGridOptions === true && _dataSet) {
                        	
                        	var options = GradeProdutoService.buildOptionsGrade(_dataSet);
                        	$scope.listOptionsGrade = [];
            				
                        	options.forEach(function(option) {
                        		$scope.listOptionsGrade.push({ data: option.data, value: option.label });
                        	});
                        }

                        ArrayUtils.callEachFunctionWith(_productChangeListeners, {
                            TIPCONTEST: $scope.tipContEst,
                            LISCONTEST: $scope.listOptions,
                            TITCONTEST: $scope.labelControl
                        });
                    } else {
                        $scope.tipContEst = '';
                        $scope.labelControl = _defaultLabel;
                        updateLabelControl();

                        ArrayUtils.callEachFunctionWith(_productChangeListeners, undefined);
                    }

                    setUseControle();
                }
            }

            function populateCombo(strOptions) {
                $scope.listOptions = [];

                if (_dataSet && _fieldName) {
                    var metadata = _dataSet.getFieldMetadata(_fieldName);
                    if (StringUtils.isNotEmpty(metadata) && metadata.isNullable) {
                        $scope.listOptions.push({
                            data: '',
                            value: ''
                        });
                    }
                }

                if (strOptions) {
                    if (angular.isArray(strOptions)) {
                        $scope.listOptions = strOptions;
                    } else {
                        strOptions = strOptions.toString();
                        strOptions = strOptions.replace(/\r/g, "");
                        strOptions = strOptions.replace(/\n/g, "${nl}");

                        if (strOptions.indexOf('${nl}')) {
                            strOptions.split('${nl}').forEach(function (item) {
                                if (item != '') {
                                    $scope.listOptions.push({ data: item, value: item });
                                }
                            });
                        }
                    }
                }
            }

            function selectUI(tipo) {
                $scope.tipContEst = tipo;

                updateLabelControl();
            }
            
            function confirmarGrade(listener) {
                _confirmarGradeChangeListeners.push(listener);
            }

            function onFinishGrade(itensGrade){
                ArrayUtils.callEachFunctionWith(_confirmarGradeChangeListeners, itensGrade);

                if (_confirmarGradeChangeListeners.length === 0 && _dataSet && ArrayUtils.isNotEmpty(itensGrade)) {
                    setData(itensGrade[0].CONTROLE)
                    changeHandler();
                }
            }

            function getTipMov (getTip) {
                if(angular.isDefined(getTip)){
                    _tipMov = getTip;
                }
            }

            function openGrade(){
                if (angular.isFunction($scope.onStartGrade)) {
                    $scope.onStartGrade();
                } else {
                    var popupInfo = {
                        dataset : _dataSet,
                        fieldName : 'CONTROLE',
                        mode : GradeProdutoConstant.CENTRAL_NOTAS,
                        onFinishGrade : onFinishGrade,
                        getTipMov : _tipMov
                    }
                    GradeProdutoService.show(popupInfo);
                }
            }

            function setEnableBtnGrade(enable){
            	self.enableBtnGrade = enable;
            }

            function onControleInputFocusOut() {
                if (angular.isFunction($scope.onFocusOut)){
                    $scope.onFocusOut();
                }
            }

        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-controle-estoque-input-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</.>.
 *
 * @param {string} [sk-component-created='onControleEstoqueCreated($component)']
    Função utilizada para guardar o ponteiro do onControleEstoqueCreated e realizar as configurações necessárias no mesmo.
    - Eventos de listeners disponíveis ['loadByCodProd', 'onProductInfoChange', 'setValue', 'serieBtnClick', 'changeControle']
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @example
     <example module="appControleEstoqueInput">
         <file name="appControleEstoqueInput.html">
            <div ng-controller="TesteController">
                <div>
                    <sk-pesquisa-input sk-entity-name="Produto"  
                                       sk-entity-change="onChangeCodProd(item)">
                    </sk-pesquisa-input>
                </div>
                <div>
                    <sk-controle-estoque-input sk-value="valueControl" 
                                               sk-component-created="onControleEstoqueCreated($component)">
                    </sk-controle-estoque-input>
                </div>
            </div>
         </file>
         <file name="appControleEstoqueInput.js">
            angular
                .module('appControleEstoqueInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                var _controleEstoqueInstance;

                $scope.onControleEstoqueCreated = function ($component) {
                   _controleEstoqueInstance = $component;

                   _controleEstoqueInstance.onProductInfoChange(function (produto) {
                    });

                   _controleEstoqueInstance.serieBtnClick(function () {
                    });

                    _controleEstoqueInstance.changeControle(function (control) {
                    });
                };

                $scope.onChangeCodProd = function (item) {
                  if (_controleEstoqueInstance) {
                    _controleEstoqueInstance.loadByCodProd(item.fields.CODPROD);
                  }
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skControleEstoqueInput', ['$timeout', 'StringUtils',
function ($timeout, StringUtils) {
    return {
        scope: {
            value: '=?skValue',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            isGrid: '=?skIsGrid',
            componentCreated: '&?skComponentCreated',
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            showWhenType: '@?skShowWhenType',
            labelText: '@?skLabelText',
            onStartGrade: '&?skOnStartGrade',
            labelManual: '&?skLabelManual',
            preferGridOptions: '=?skPreferGridOptions',
            onFocusOut: '&?skFocusOut',
            preferDefault: '@?skPreferDefault'
        },
        require: ['skControleEstoqueInput', '^?skSimpleItem'],
        template: getTemplate,
        controller: 'SkControleEstoqueInput',
        controllerAs: 'ctrl',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';

        var template = '<div ng-switch="tipContEst" flex>' +
				        	' <sk-text-input ng-switch-default sk-width="100%" sk-change="ctrl.changeHandler()" sk-value="valueObj.innerValue" sk-enabled="ctrl.useControle" sk-focus-out="onControleInputFocusOut()" sk-focus-out-controle="true"></sk-text-input>' +
                            ' <sk-combobox ng-switch-when="S" sk-change="ctrl.changeHandler()" sk-allow-null="false" sk-value="valueObj.innerValue" sk-options="listOptions"></sk-combobox>' +
                            ' <sk-pesquisa-input ng-switch-when="P" sk-entity-change="ctrl.changeHandler()" sk-width="250%" sk-entity-name="Parceiro" sk-description-field-name="Parceiro.NOMEPARC"  sk-enabled="ctrl.useControle" sk-value="valueObj.innerValue"></sk-pesquisa-input>' +
                            ' <sk-date-input ng-switch-when="V" sk-change="ctrl.changeHandler()" sk-enabled="ctrl.useControle" sk-value="valueObj.innerValue" ></sk-date-input>' +
                            ' <button default ng-switch-when="E" ng-click="ctrl.onEditarSerie()" ng-disabled="ctrl.serieEnable == false || ctrl.useControle == false" style sk-i18n><translate>ControleProduto.buttonNumerosSerie</translate></button>' +
                            ' <button ng-switch-when="G" class="btn btn-default" toolTip="Grade" ng-disabled="!ctrl.useControle || !ctrl.enableBtnGrade" ng-click="ctrl.openGrade()" style>{{ labelBtnGrade }}</button>' +
                            ' <sk-combobox ng-switch-when="GO" sk-change="ctrl.changeHandler()" sk-allow-null="false" sk-value="valueObj.innerValue" sk-options="listOptionsGrade"></sk-combobox>' +
				        '</div>';
        
        template = angular.isDefined(tAttrs.skIsGrid) && tAttrs.skIsGrid === "true"? template.replace(/style/gm, "style='min-height: 20px;padding: 0px;width:100%;border: 0px;margin-bottom: 2px;'"): template.replace(/style/gm, '');
        var templateArgs = {
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            autofocus: autofocus
        };
        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrls) {
        function setFocus(){
        }

        ctrls[0].setFocus = setFocus;
        ctrls[0].setSimpleFormCtrl(ctrls[1]);
        ctrls[0].setDefaultLabel(attr.skLabel);
    }
}]);

angular
    .module('snk.components.input')
    .controller('SkControleProduto', ['StringUtils', 'SkI18nService', '$scope', '$timeout', '$element', 'ObjectUtils', 'AngularUtil', 'CrudUtils','ArrayUtils',
        function (StringUtils, SkI18nService, $scope, $timeout, $element, ObjectUtils, AngularUtil, CrudUtils,ArrayUtils) {
            var self = this;

            ObjectUtils.implements(self, IDataSetObserver);

            $scope.valueObj = {
                innerValue: undefined,
                innerEnabled: undefined
            };
            
            var _changeControle = [];

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            $scope.tipContEst = undefined;
            $scope.listOptions = [];
            
            self.onTap = $scope.onTap;
            self.entityPath = 'Produto';
            self.codProd = undefined;
            self.setProduct = setProduct;
            //setValue eh utilizado no standalone e setData no dataset
            self.setValue = setValue;
            self.setFocus = setFocus;
            self.changeControle = changeControle;
            self.verifyOnTap = verifyOnTap;
            
            init();

            function init(){
                $scope.$watch('valueObj.innerValue', function(newValue){
                    if(angular.isFunction($scope.onChange)){
                        $scope.onChange({value: newValue});
                    }

                    if (self.useDataset($scope)) {
                        $timeout(function () {
                            $scope.dataset.notifyEditionStart(self);
                            $scope.dataset.setModified(self);
                        }, 0, false);
                    }
    
                    runOnChange();

                    $scope.value = newValue;
                });

                $scope.$watch('dataset', (newDs) => {
                    if(newDs){
                        $scope.dataset = newDs;
                        $scope.dataset.addObserver(self);
                    }
                });

                $scope.$watch('value', (newValue) => {
                    if(newValue){
                        $scope.valueObj.innerValue = newValue;
                    }
                });
                
                $scope.$watch('enabled', (newEnabled) => {
                    if(angular.isDefined(newEnabled)){
                        $scope.valueObj.innerEnabled = newEnabled;
                    }
                });
                
                if(angular.isFunction($scope.onCreate)){
                    $scope.onCreate({api: self});
                }

                if (self.useDataset($scope)) {
                    $scope.dataset.addLineChangeListener(function(){
                        loadConfigProd();

                        var gridCtrl = $scope.dynaformGrid.getGridController();

                        if(gridCtrl){
                            gridCtrl.getColumnByName($scope.fieldNameColumn).setDescription($scope.bindableLabel);
                        }    
                    });
                }
            }
            
            function loadConfigProd(){
                if($scope.dataset){
                    setValue('');
                } else{
                    setData('');
                }

                var product = { 
                    TIPCONTEST: $scope.productDataset ? $scope.productDataset.getFieldValueAsString('TIPCONTEST') : ($scope.standaloneProduct ? $scope.standaloneProduct.TIPCONTEST: ''),
                    LISCONTEST: $scope.productDataset ? $scope.productDataset.getFieldValueAsString('LISCONTEST') : ($scope.standaloneProduct ? $scope.standaloneProduct.LISCONTEST: ''),
                    TITCONTEST: $scope.productDataset ? $scope.productDataset.getFieldValueAsString('TITCONTEST') : ($scope.standaloneProduct ? $scope.standaloneProduct.TITCONTEST : '')
                };

                if(product != null){
                    $scope.tipContEst = product.TIPCONTEST;
                    $scope.titContEst = product.TITCONTEST

                    $scope.listOptions = [];

                    if(product.LISCONTEST != undefined){
                    	product.LISCONTEST = StringUtils.replaceAll(product.LISCONTEST, '\r', '');
                        var separator = product.LISCONTEST.indexOf('${nl}') > -1 ? '${nl}' : '\n';
                        product.LISCONTEST.split(separator).forEach(function(item){
                            if(item != ''){
                                $scope.listOptions.push({data: item, value:item});
                            }
                        });
                        
                    }

                    if($scope.dataset){
                        setValue($scope.dataset.getFieldValue($scope.fieldName));
                    }
                    
                    updateProduct();
                }  

                AngularUtil.digest($scope);
            }
           
            function updateProduct(){

                switch($scope.tipContEst){
                    case "I":
                        if(!StringUtils.emptyAsNull($scope.tipContEst) || $scope.tipContEst == ""){
                            updateLabel(SkI18nService.instant('ControleProduto.labelLivre'));
                        } else{
                            updateLabel($scope.titContEst);
                        }
                        break;
                        
                    case "L":
                        updateLabel(SkI18nService.instant('ControleProduto.labelLote'));
                        break;
                        
                    case "E":
                        updateLabel(SkI18nService.instant('ControleProduto.labelSerie'));
                        break;

                    case "N":
                        updateLabel(null);
                        break;

                    case "P":
                        updateLabel(SkI18nService.instant('ControleProduto.labelParceiro'));
                        break;

                    case "S":
                        if(!StringUtils.emptyAsNull($scope.tipContEst) || $scope.tipContEst == ""){
                            updateLabel(SkI18nService.instant('ControleProduto.labelLista'));
                        } else {
                            updateLabel($scope.titContEst);
                        }
                        break;

                    case "V":
                        updateLabel(SkI18nService.instant('ControleProduto.labelData'));
                        break;

                    default:
                        updateLabel(null);
                        break;
                }
              }

              function updateLabel(value){
                if(!StringUtils.emptyAsNull(value) || value === ""){
                    value = SkI18nService.instant('ControleProduto.labelControle');
                }

                $scope.bindableLabel = value;
              }

              function setData(data){
                $scope.value = data;
                $scope.valueObj.innerValue = $scope.value;
              }

              function getData(){
                  return $scope.value;
              }

              function setProduct(product){
                $scope.standaloneProduct = product;
                loadConfigProd();
              }

              function setValue(value){
                if (!$scope.dataset) {
                    $scope.valueObj.innerValue = value;
                }

                onInputChange()
              }

              function setFocus(){

                var element = null;

                if($element.find('sk-pesquisa-input').length > 0){
                    element =  $element.find('sk-text-input');
                    element.find('input').focus();
                } else if($element.find('sk-text-input').length > 0 || $element.find('sk-combobox').length > 0 || $element.find('sk-date-input').length > 0){
                    element = $element.find('input');
                    element.focus();
                } 
              }

            function onInputChange(){
                if(angular.isFunction($scope.onChange)){
                    $scope.onChange(self.value);
                }
              }

            function runOnChange() {
                ArrayUtils.callEachFunctionWith(_changeControle, {
                    valueControl: $scope.value
                });
            }

            function changeControle(listener) {
                _changeControle.push(listener);
            }
            
            function verifyOnTap(){
				return  angular.isFunction($scope.onTap);
			}
        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-controle-estoque-input-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @example
     <example module="appCgcCpfInput">
         <file name="appCgcCpfInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-cgc-cpf-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-cgc-cpf-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appCgcCpfInput.js">
            angular
                .module('appCgcCpfInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.inputValue = '';
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
     angular
     .module('snk.components.input')
     .directive('skControleProduto', ['$timeout', 'StringUtils',
 function ($timeout, StringUtils) {
     return {
         scope: {
             value: '=?skValue',
             enabled: '=?skEnabled',
             fieldName: '=?skFieldName',
             fieldNameColumn: '=?skFieldNameColumn',
             dataset: '=?skDataset',
             productDataset: '=?skProductDataset',
             bindableLabel:'=?skBindableLabel',
             onChange: '&?skChange',
             dynaformGrid: '=?skDynaformGrid',
             onCreate: '&?skOnCreate',
             onTap: '&?skOnTap'
         },
         require: ['skControleProduto', '^?skSimpleItem'],
         template: getTemplate,
         controller: 'SkControleProduto',        
         controllerAs: 'ctrl'
     };
 
     function getTemplate(tElem, tAttrs) {
         var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
 
         var template =  '<div ng-switch="tipContEst">' +
                            '<sk-text-input sk-enabled="enabled" sk-value="valueObj.innerValue" sk-change="onChange({value: valueObj.innerValue})" ng-switch-default></sk-text-input>' +
                            '<sk-pesquisa-input sk-entity-name="Parceiro" sk-enabled="enabled" sk-value="valueObj.innerValue" sk-change="onChange({value: valueObj.innerValue})" sk-notify-description-change-to-data-set="false" ng-switch-when="P"></sk-pesquisa-input>' +
                            ' <button default ng-switch-when="G" toolTip="Grade" ng-if="ctrl.verifyOnTap()" ng-disabled="!valueObj.innerEnabled" ng-click="ctrl.onTap()">{{valueObj.innerValue ? valueObj.innerValue : "Grade"}}</button>' +
                            '<sk-combobox sk-enabled="enabled" sk-value="valueObj.innerValue" ng-switch-when="S" sk-allow-null="false" sk-change="onChange({value: valueObj.innerValue})" sk-options="listOptions"></sk-combobox>' +
                            '<sk-date-input  sk-enabled="enabled" sk-value="valueObj.innerValue" sk-change="onChange({value: valueObj.innerValue})" ng-switch-when="V"></sk-date-input>' +
                         '</div>';
 
         var templateArgs = {
             gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
             autofocus: autofocus
         };
 
         tElem.removeAttr('autofocus');
 
         return StringUtils.substitute(template, templateArgs);
     }
 }]);
angular
    .module('snk.components.input')
    .controller('SkDateInputController', ['$scope', '$timeout', 'ObjectUtils', 'DateUtils', '$document', 'AngularUtil', '$rootScope', 'SkConstants', 'DateUtilsConstants', 'StringUtils', '$element', '$attrs',
function ($scope, $timeout, ObjectUtils, DateUtils, $document, AngularUtil, $rootScope, SkConstants, DateUtilsConstants, StringUtils, $element, $attrs) {
    var self = this;
    var _ngModelCtrl;
    var _changed = false;
    var OPEN_CLASS = 'sk-open';

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        getData: getData,
        getViewValue: getViewValue,
        setNgModelCtrl: setNgModelCtrl
    });

    /*
    override do focusout padrão do fieldbinder, no dateinput fazemos o 
    onEndEdit durante o selectDate (que é chamado sempre no focusout, e na selação de data no popover)
    */
    self.fbFocusOut = angular.noop;

    $scope.datePickerOpened = false;
    $scope.changeHandler = changeHandler;
    $scope.toggleDatePicker = toggleDatePicker;
    $scope.selectDate = selectDate;
    $scope.onSelectDate = $scope.onSelectDate || angular.noop;
    $scope.buttonMode = angular.isDefined($scope.buttonMode) ? StringUtils.toBoolean($scope.buttonMode) : false;
    $scope.datepickerOptions = datepickerOptions;

    self.onFocusOut = onFocusOut;
    self.runChangeEnd = runChangeEnd;
    self.setCurrentDate = setCurrentDate;
    self.pressTab = false;

    init();

    function init(){    
        if (!$attrs.hasOwnProperty('aggrid') && $attrs.skDatagridEditor != 'true'){     
            window.addEventListener('dataGridScrolled', function (e) {
                closeHandler();    
            });
        }

        $rootScope.$on(SkConstants.EVENTS.CONTAINER_DRAG_START, closeHandler);


        $scope.$watch('datePickerOpened', function(newValue, oldValue) {
            if (newValue != oldValue) {
                $element[newValue ? 'addClass' : 'removeClass'](OPEN_CLASS);
            }
        });
    }



    function selectDate() {
        if ($scope.oldValue != $scope.value) {
            $scope.oldValue = $scope.value;
            $timeout(function() {
                self.notifyChangeToDataset();
    
                $scope.onSelectDate($scope);
    
                runChangeEnd();
            });
        }
    }

    function runChangeEnd(){        
        if($scope.oldValue != $scope.value){
            $scope.onEndEdit({value: $scope.value});
        }
    }

    function onFocusOut(){
    	let transformedviewValue = _ngModelCtrl.$viewValue?.replace(/[^0-9]/ig, '') ?? "";

        if(transformedviewValue.length <= 3){
            _ngModelCtrl.$setViewValue('');
            _ngModelCtrl.$render();
        } else if (transformedviewValue.length == 6 && !self.monthMode) {
            var currentYear = transformedviewValue.substring(4, transformedviewValue.length);
            if(currentYear.length == 2 && currentYear != null) {
				currentYear = (currentYear < "70" ? "2000" : "1900");
			}
            const viewValue = StringUtils.insertAt(transformedviewValue, currentYear.toString().substring(0, 2), 4);
            _ngModelCtrl.$setViewValue(viewValue);
            _ngModelCtrl.$render();
        }

        if (_changed){
            $scope.$evalAsync(function(){
                var date = adjustInput(_ngModelCtrl.$viewValue, true);

                if(!date || (date && DateUtils.formatDate(date) != _ngModelCtrl.$viewValue)){
                    if (!date){
                        _ngModelCtrl.$setViewValue('');
                    } else {
                        _ngModelCtrl.$viewValue = DateUtils.formatDate(date);
                    }
    
                    broadCastDatePicker(date);
                    _ngModelCtrl.$render();
                    self.notifyChangeToDataset();
                    runOnChange();
                }

                _changed = false;
                ($scope.onFocusOut || angular.noop)({$value: $scope.value});
               
            });
        } else {
            ($scope.onFocusOut || angular.noop)({$value: $scope.value});
        }
    }

    function broadCastDatePicker(date){

        if(!self.pressTab){
            if (!date){
                $scope.$broadcast('datepicker.adjustViewValue');
            } else {
                $scope.$broadcast('datepicker.adjustViewValue', {value: date});
            }
    
            $scope.$broadcast('datepicker.adjustActiveDate');
        }
        self.pressTab = false;
    }

    function adjustInput(value, getAsDate){
        if (!value) return undefined;

        var transformedInput = value.replace(/[^0-9\/]/ig, '');

        if (transformedInput != value) {
            _ngModelCtrl.$setViewValue(transformedInput);
            _ngModelCtrl.$render();
        }

        if (getAsDate){
            return DateUtils.strToDate(transformedInput, false, self.monthMode);
        } else {
            return transformedInput;
        }
    }

    function setNgModelCtrl(ngModelCtrl){
        _ngModelCtrl = ngModelCtrl;
        _ngModelCtrl.$parsers.unshift(adjustInput);
        _ngModelCtrl.$parsers.push(function(value){
            return DateUtils.strToDate(value, false, self.monthMode);
        });
    }

    function toggleDatePicker($event){
        if ($event) {
            $event.preventDefault();
        }

        if ($scope.value == undefined) {
            setData(undefined);

            $scope.$broadcast('datepicker.adjustViewValue', { value: undefined });
            $scope.$broadcast('datepicker.adjustActiveDate');
        } else {
        	setData($scope.value);
        }
        
        $scope.datePickerOpened = !$scope.datePickerOpened;
    }

    function closeHandler() {
        if ($scope.datePickerOpened) {
            AngularUtil.apply($scope, function(){
                $scope.datePickerOpened = false;
            });
        }
    }

    function changeHandler($event) {
        if ($scope.value === null){
            $scope.value = undefined;
        }

        _changed = true;

		self.notifyChangeToDataset();
        runOnChange();
    }

    function runOnChange() {
        $timeout(function() {
            ($scope.onChange || angular.noop)($scope);
        });
    }

    function setData(data) {
        if (typeof data === 'object' && data instanceof Date){
            $scope.value = new Date(data.getTime());
        } else if (typeof data === 'string'){
            $scope.value = DateUtils.strToDate(data);
        } else if (angular.isDefined(data)){
            throw new Error('DateInput.setData aceita apenas string ou Date');
        } else {
            $scope.value = data;
        }

        runOnChange();
    }

    function getData(){
        return $scope.value;
    }
    
    function getViewValue(){
        return _ngModelCtrl.$viewValue;
    }

    function datepickerOptions() {
        return {
            "initDate": new Date()
        }
    }

    function setCurrentDate() {
        setData(DateUtils.getToday(true));
        changeHandler();
    }
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-date-input
 * @restrict E
 * @scope
 * @description
     Componente de seleção de data.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
    Dataset que será utilizado no controle deste componente.
    Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.

 * @param {boolean} [sk-month-mode=false]
    Determina se o input vai trabalhar apenas com mês/ano.

 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @param {string} [sk-button-mode=undefined]
    Utiliza componente no modo botão não exibindo input de texto.
 *
 * @example
     <example module="appDateInput">
         <file name="appDateInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="date = undefined" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo: <sk-date-input sk-value="date" sk-change="onChange()" sk-enabled="enabled"></sk-date-input>
                    <p>Data: {{date | date}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item | date" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appDateInput.js">
            angular
                .module('appDateInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.log = [];

                $scope.today = function() {
                    $scope.date = new Date();
                };

                $scope.today();


                $scope.onChange = function () {
                  $scope.log.push($scope.date);
                };

                $scope.clear = function () {
                    $scope.date = undefined;
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skDateInput', ['$timeout', 'StringUtils', 'DateUtilsConstants',
function ($timeout, StringUtils, DateUtilsConstants) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            align: '@?skAlign',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            onSelectDate: '&?skOnSelectDate',
            buttonMode: '@?skButtonMode',
            closeOnSelection: '=?skCloseOnSelection',
            onlyIcon: '=?skOnlyIcon',
            onEndEdit: '&skEndEdit',
        },
        template: getTemplate,
        controller: 'SkDateInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';

        tAttrs.onlyIcon = angular.isDefined(tAttrs.skOnlyIcon) ? true : false;

        var template = 
        	'<input style type=\'text\' class=\'form-control\' sk-bind-pop-over-id="{bindPopOverId}" show-weeks="false" sk-datepicker-popup=\'{format}\' {closeOnSelection} min-mode="{minMode}" ng-model=\'value\' is-open=\'datePickerOpened\' close-text=\'Fechar\' current-text=\'Hoje\' clear-text=\'Limpar\' ng-change="changeHandler()" ng-disabled="!enabled" datepicker-append-to-body="true" ng-required="required" on-select-date="selectDate()" ng-show="!buttonMode" datepicker-options="datepickerOptions()" {style} {gridEditor} {autofocus}/>' +
                '<sk-icon font-icon=\'calendar\' sk-enabled="enabled" ng-click="!enabled || toggleDatePicker($event)"></sk-icon>';
       
        template = !tAttrs.onlyIcon ? template.replace('style', '') : template.replace('style', 'style="display: none;"')

        var monthMode = angular.isDefined(tAttrs.skMonthMode) ? 'true' == tAttrs.skMonthMode : false;

        var templateArgs = {
            format: monthMode ? DateUtilsConstants.DEFAULT_DATE_MONTH_FORMAT : 'dd/MM/yyyy',
            minMode: "\'" + (monthMode ? 'month' : 'day') + "'",
            style: angular.isDefined(tAttrs.skAlign) ? 'ng-style="{\'text-align\': align}"' : '',
            style: angular.isDefined(tAttrs.skCloseOnSelection) ? 'close-on-date-selection="closeOnSelection"' : '',
            gridEditor : angular.isDefined(tAttrs.skDatagridEditor) ? 'sk-datagrid-pesquisa-editor ng-model-options="{ allowInvalid: \'true\'}"' : '',
            autofocus: autofocus,
            bindPopOverId: StringUtils.nextUid()
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;
        var inputElement = element.children()[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');
		var isInputDate = true;
		var isClickedDate = true;

        if (scope.buttonMode) {
            element.addClass('button-mode');
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select() {
            $timeout(function () {
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        if(ngModelCtrl){
            ctrl.setNgModelCtrl(ngModelCtrl);
        }

        ctrl.setFocus = setFocus;
        ctrl.select   = select;
        ctrl.monthMode = angular.isDefined(attr.skMonthMode) ? attr.skMonthMode == 'true' : false;
        ctrl.setElement(inputElement);

        angular.element(inputElement).bind('click', function () {
        	isClickedDate = true;
            if (isDatagrid()) {
            	if(!inputElement.form.innerHTML.includes("sk-date-time-input")){
                	setFocus();
                }
            } else if (!fullSelected) {
                select();
            }
        });

		angular.element(inputElement).bind('keydown', function (event) {
            if(event.keyCode == 9){
                ctrl.pressTab = true;
                ctrl.runChangeEnd();
            } else if(event.keyCode == 72) {
                ctrl.setCurrentDate()
            }
        });

        angular.element(inputElement).bind('blur', function () {
			ctrl.onFocusOut();
            fullSelected = false;
            if(isClickedDate){
            	isInputDate = false;
            	isClickedDate = false;
            }
            isInputDate = !isInputDate;
        });

        angular.element(inputElement).bind('focus', function () {
        	if(angular.isDefined(inputElement.form) && angular.isDefined(inputElement.form.innerHTML) && inputElement.form.innerHTML.includes("sk-date-time-input")){
	        	if(isInputDate){
	        		inputElement.parentElement.firstChild.focus();
	        	}else{
	        		inputElement.parentElement.nextSibling.firstChild.focus();
	        	}
        	}else{
        		(scope.onFocus || angular.noop)(scope);
        	}
        });

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        if (isDatagrid()) {
            inputElement.focus();
            select();
        }
    }
}]);

angular
    .module('snk.components.input')
    .controller('SkDatePeriodInputController', ['$scope', 'ObjectUtils', 'DateUtils',
        function ($scope, ObjectUtils, DateUtils) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData
            });

            $scope.value = $scope.value || {dtIni: null, dtFin: null};

            $scope.onChangeDate = onChangeDate;

            function setData(data, fieldName) {
                var date = undefined;

                if (data instanceof Date) {
                    date = data;
                } else if (typeof data === 'string') {
                    date = DateUtils.strToDate(data);
                } else if (angular.isDefined(data)) {
                    throw new Error('DatePeriodInput.setData aceita apenas string ou Date');
                } else {
                    date = data;
                }

                if (!$scope.value) {
                    $scope.value = {};
                }

                $scope.value[fieldName] = date;
            }

            function onChangeDate(newValue, fieldName, isFocusOut) {
                if (angular.isDefined(newValue) && angular.isDefined(fieldName)) {
                    if (angular.isDefined(newValue[fieldName])) {
                        setData(newValue[fieldName], fieldName);
                        changeHandler(isFocusOut);
                    } else if (newValue instanceof Date || typeof newValue === 'string') {
                        setData(newValue, fieldName);
                        changeHandler(isFocusOut);
                    }
                }
            }

            function changeHandler(isFocusOut) {
                self.notifyChangeToDataset();
                if (isFocusOut) {
                    runOnFocusOut()
                } else {
                    runOnChange();
                }
            }

            function runOnFocusOut() {
                ($scope.onFocusOut || angular.noop)($scope);
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)($scope);
            }
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-date-period-input
 * @restrict E
 * @scope
 * @description
     Componente de seleção de data e hora.
    Internamente é o componente de data e o de hora alinhados verticalmente.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @example
     <example module="appDatePeriodInput">
         <file name="appDatePeriodInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="clear()" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo: <sk-date-period-input sk-value="date" sk-change="onChange()" sk-enabled="enabled"></sk-date-period-input>
                    <p>Data: {{date | date:'MM/dd/yyyy @ h:mm'}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item | date:'MM/dd/yyyy @ h:mm'" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appDateInput.js">
            angular
                .module('appDatePeriodInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.date);
                };

                $scope.today = function() {
                    $scope.date = new Date();
                };

                $scope.today();

                $scope.clear = function () {
                    $scope.date = undefined;
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skDatePeriodInput', ['StringUtils', '$timeout', 'DateUtils', function (StringUtils, $timeout, DateUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            align: '@?skAlign',
            value: '=?skValue',
            onChange: '&?skChange',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            onFocusOut: '&?skFocusOut'
        },
        template: getTemplate,
        controller: 'SkDatePeriodInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template =
            '<sk-date-input sk-value="value.dtIni" sk-enabled="enabled" sk-required="required" sk-change="::onChangeDate(value, \'dtIni\')" sk-align="{{align}}" sk-focus-out="::onChangeDate(value, \'dtIni\', true)" {appendToBody} {required} {gridEditor} {autofocus}></sk-date-input>' +
            '<span class="label-a"> {{::"Geral.lblA" | translate}} </span>' +
            '<sk-date-input sk-value="value.dtFin" sk-enabled="enabled" sk-required="required" sk-change="::onChangeDate(value, \'dtFin\')" sk-align="{{align}}" sk-focus-out="::onChangeDate(value, \'dtFin\', true)" {appendToBody} {required} {gridEditor} {autofocus}></sk-date-input>'

        var templateArgs = {
            required: angular.isDefined(tAttrs.skRequired) ? 'sk-required="true"' : '',
            appendToBody: angular.isDefined(tAttrs.skAppendToBody) ? 'sk-append-to-body="true"' : '',
            gridEditor : angular.isDefined(tAttrs.skDatagridEditor) ? 'sk-datagrid-editor' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var dateInputIniElement = element.children()[0];
        var dateInputFiniElement = element.children()[2];

        var dateInputController = angular.element(dateInputIniElement).data('$skDateInputController');

        /** Existe um comportamento no flex que ao apertar a tecla <H> dentro do componente, é inserido a data atual. <Comportamento trazido do flex> */
        angular.element(dateInputIniElement).bind('keydown', function (event) {
            if (event.keyCode == 72) {
                ctrl.setData(DateUtils.getToday(), "dtIni")
            }
        });

        angular.element(dateInputFiniElement).bind('keydown', function (event) {
            if (event.keyCode == 72) {
                ctrl.setData(DateUtils.getToday(), "dtFin")
            }
        });

        function setFocus(){
            $timeout(function(){
                dateInputController.setFocus();
            }, 0, false);
        };
        
        ctrl.setFocus = setFocus;

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        if (attr.skDatagridEditor == 'true') {
            setFocus();

            $timeout(function () {
                dateInputController.select();
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkDateTimeInputController', ['$scope', '$timeout', 'ObjectUtils', 'DateUtils', 'DateUtilsConstants', 'AngularUtil', 'StringUtils',
function ($scope, $timeout, ObjectUtils, DateUtils, DateUtilsConstants, AngularUtil, StringUtils) {
    var self = this;

    $scope.dateValue = undefined;
    $scope.timeValue = undefined;

    var oldValue;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        setDateInputCtrl: setDateInputCtrl
    });

    $scope.setNow = setNow;
    $scope.changeHandler = changeHandler;
    $scope.onSelectDate = onSelectDate;
    $scope.onChangeDate = onChangeDate;
    $scope.onChangeTime = onChangeTime;
    $scope.onFocusOutDateInput = onFocusOutDateInput;
    $scope.onFocusOutTimeInput = onFocusOutTimeInput;
    $scope.timeInputEndEdit = timeInputEndEdit;
    
    self.clear = clear;

    let _hasChanged = false;
    let dateInputCtrl;

    init();

    $scope.$watch('value', function (newValue){
        /* Esse watch so funciona para casos em que a data e setada manualmente na variavel
           e a mesma esta como string e completa(tamanho == 16), para os demais casos o watch
           NAO PODE funcionar pois a data podera ser formatada antes que o usuario temine de 
           digitar completamente a mesma no input
        */
        if ($scope.value && angular.isString($scope.value) && $scope.value.length === 16) {
            setData($scope.value);
        }

        if (StringUtils.isEmpty($scope.value) && (angular.isDefined(dateInputCtrl) && StringUtils.isEmpty(dateInputCtrl.getViewValue()))) {
            clear();
            
            $scope.$broadcast('datepicker.adjustViewValue', { value: undefined });
            $scope.$broadcast('datepicker.adjustActiveDate');
        }
        changeHandler();
    }, true);

    function init() {
        $scope.showDate = angular.isUndefined($scope.showDate) ? true : $scope.showDate;
 
        if ($scope.value) {
            setData($scope.value);
        }
    }

    function onSelectDate(){
        timeInputEndEdit('date');
        updateTimeOnDate();
        self.notifyChangeToDataset();
    }

    function onFocusOutDateInput(value){
        if (angular.isUndefined(value)){
            $scope.value = undefined;
            $scope.timeValue = undefined;
        } else {
            $scope.dateValue = value;

            if (updateTimeOnDate()) {
            self.notifyChangeToDataset();
            oldValue = angular.copy($scope.value);
        }
    }
    }

    function onFocusOutTimeInput(){
        if (angular.isUndefined($scope.dateValue) && angular.isDefined($scope.timeValue)){
            AngularUtil.apply($scope, function(){
                $scope.dateValue = DateUtils.clearTime(new Date());
                updateTimeOnDate();
                self.notifyChangeToDataset();
                oldValue = angular.copy($scope.value);
            });
        } else if (angular.isDefined($scope.dateValue)){
            AngularUtil.apply($scope, function(){
                if (updateTimeOnDate()){
                    self.notifyChangeToDataset();
                    oldValue = angular.copy($scope.value);
                }
            });
        }
    }

    function buildTime(value){
        return Time.parse(value, false, false);
    }

    function updateTimeOnDate(){
        if (angular.isDate($scope.dateValue)){
            if (angular.isDefined($scope.timeValue)){
                var time = buildTime($scope.timeValue);

                if (time.isValid($scope.showSeconds)){
                    time.toDate($scope.dateValue);
                } else {
                    $scope.dateValue = undefined;
                }

                $scope.value = $scope.dateValue;
            } else {
                $scope.value = $scope.dateValue;

                $scope.value.setHours(0);
                $scope.value.setMinutes(0);
                $scope.value.setSeconds(0);
            }
        }else {
        	clear();
        }

        return !angular.equals(oldValue, $scope.value);
    }

    function handleValueUpdate() {
        updateTimeOnDate();
        self.notifyChangeToDataset();
        changeHandler();
        _hasChanged = true;
    }

    function onChangeDate(newValue){
        $scope.dateValue = newValue;
        handleValueUpdate();
    }

    function onChangeTime(newValue){
        $scope.timeValue = newValue;
        handleValueUpdate();
    }

    function setNow(){
        self.setData(new Date());
        self.notifyChangeToDataset();
        changeHandler();
        _hasChanged = true;
        timeInputEndEdit('time');
    }

    function changeHandler() {
        runOnChange();
    }

    function runOnChange() {
        $timeout(function(){
            ($scope.onChange || angular.noop)($scope);
        });
    }

    function setData(data) {
        var date = undefined;
        var time = undefined;

        if (typeof data === 'object' || data instanceof Date){
        	try {
                date = new Date(data.getTime());
            }catch(error){
                throw new Error('DateTimeInput.setData aceita apenas string ou Date');    
            } 
        } else if (typeof data === 'string'){
            date = DateUtils.strToDate(data);
        } else if (angular.isDefined(data)){
            throw new Error('DateTimeInput.setData aceita apenas string ou Date');
        } else {
            date = data;
        }

        if (angular.isDate(date)){
            if ($scope.showSeconds != true) {
                date = DateUtils.clearSeconds(date);
            }

            time = DateUtils.extractTimeFromDate(date, false, false);

            if (time.isValid($scope.showSeconds) && !time.minutesIsPriority){
                time = time.toNumber($scope.showSeconds);
            }
        }

        $scope.value = date;
        $scope.dateValue = date;
        $scope.timeValue = time;

        oldValue = angular.copy($scope.value);
    }

    function clear() {
        setData(undefined);       
    }
    
    function setDateInputCtrl(controller){
		dateInputCtrl = controller;
	}

    function timeInputEndEdit(inputName){
        $timeout(() => {
            if(_hasChanged){
                $scope.onEndEdit({value: $scope.value, inputName: inputName});
                _hasChanged = false;
            }
        });
    }

}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-date-time-input
 * @restrict E
 * @scope
 * @description
     Componente de seleção de data e hora.
    Internamente é o componente de data e o de hora alinhados verticalmente.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @param {boolean} [sk-show-date=true]
    Determina se será apresentado visualmente o componente de data.
 *
 * @param {boolean} [sk-show-seconds=false]
    Determina se será apresentado os segundos no componente de tempo.
 *
 * @example
     <example module="appDateTimeInput">
         <file name="appDateTimeInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="clear()" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo: <sk-date-time-input sk-value="date" sk-change="onChange()" sk-enabled="enabled"></sk-date-time-input>
                    <p>Data: {{date | date:'MM/dd/yyyy @ h:mm'}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item | date:'MM/dd/yyyy @ h:mm'" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appDateInput.js">
            angular
                .module('appDateTimeInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.date);
                };

                $scope.today = function() {
                    $scope.date = new Date();
                };

                $scope.today();

                $scope.clear = function () {
                    $scope.date = undefined;
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skDateTimeInput', ['StringUtils', '$timeout', function (StringUtils, $timeout) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            align: '@?skAlign',
            value: '=?skValue',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            onChange: '&?skChange',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            showDate: '=?skShowDate',
            showSeconds: '=?skShowSeconds',
            onEndEdit: '&skEndEdit',
        },
        template: getTemplate,
        controller: 'SkDateTimeInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template = '<div flex layout="row" ng-class="{nodate: !showDate}">' +
            '<sk-date-input sk-value="dateValue" sk-enabled="enabled" sk-required="required" sk-change="::onChangeDate(value)" sk-align="{{align}}"  sk-focus-out="::onFocusOutDateInput(value)"  sk-focus="::onFocus()" sk-on-select-date="::onSelectDate()" ng-show="showDate" {appendToBody} {required} {gridEditor} {autofocus} {aggrid}></sk-date-input>' +
            '<sk-time-input sk-value="timeValue" sk-enabled="enabled" sk-required="required" sk-change="::onChangeTime(value)" sk-align="{{align}}"  sk-focus-out="::onFocusOutTimeInput(value)"  sk-focus="::onFocus()" sk-set-now="::setNow" sk-minutes-is-priority="false" sk-show-seconds="showSeconds" sk-end-edit="timeInputEndEdit(\'time\')" {required} {gridEditor}></sk-time-input>'
            '</div>';

        var templateArgs = {
            required: angular.isDefined(tAttrs.skRequired) ? 'sk-required="true"' : '',
            appendToBody: angular.isDefined(tAttrs.skAppendToBody) ? 'sk-append-to-body="true"' : '',
            gridEditor : angular.isDefined(tAttrs.skDatagridEditor) ? 'sk-datagrid-editor' : '',
            aggrid: angular.isDefined(tAttrs.aggrid) ? 'aggrid' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var dateInputElement = element.children().children()[0];
        var dateInputController = angular.element(dateInputElement).data('$skDateInputController');
        
        if(dateInputController){
            ctrl.setDateInputCtrl(dateInputController);
        }

        function setFocus(){
            $timeout(function(){
                dateInputController.setFocus();
            }, 0, false);
        };

        ctrl.setFocus = setFocus;

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        if (attr.skDatagridEditor == 'true') {
            setFocus();

            $timeout(function () {
                dateInputController.select();
            }, 0, false);
        }

        angular.element(dateInputElement).bind('keydown', function (event) {
            if(event.keyCode == 9){
                scope.timeInputEndEdit('date');
            }
        });
    }
}]);
angular
    .module('snk.components.input')
    .constant('SkFileInputConstant', {
        UPLOAD_IN_PROGRESS: 'uploading',
        UPLOAD_SUCCESS: 'upload-success',
        UPLOAD_FAILED: 'upload-failure'
    })
    .controller('SkFileInputController', ['NumberUtils', 'DateUtils', 'DateUtilsConstants', 'SkApplicationInstance','AngularUtil', 'i18n', 'StringUtils', '$scope', '$element', '$attrs', '$timeout', '$q', 'SessionFileUpload', 'ObjectUtils', 'SkFileInputConstant', 'MessageUtils', 'UserAgentUtils',
        function (NumberUtils, DateUtils, DateUtilsConstants, SkApplicationInstance, AngularUtil, i18n, StringUtils, $scope, $element, $attrs, $timeout, $q, SessionFileUpload, ObjectUtils, SkFileInputConstant, MessageUtils, UserAgentUtils) {
            var self = this;

            var _http;
            var _progressBar;
            var _status;
            var _icoUploadElement;
            var _internalName;
            var _fileItem;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                getData: getData,
                setData: setData
            });

            $scope.changeHandler = changeHandler;
            $scope.onClickUpload = onClickUpload;
            $scope.cancelUpload = cancelUpload;
            $scope.addFocus = addFocus;
            $scope.removeFocus = removeFocus;
            $scope.onFocusInIcoUpload = onFocusInIcoUpload;
            $scope.onFocusOutIcoUpload = onFocusOutIcoUpload;
            $scope.getPropertiesInfo = getPropertiesInfo;

            $scope.api({
                api: self
            });

            self.setFileKey = setFileKey;
            self.clear = clear;
            
            $scope.idInput = 'idInput_' + StringUtils.nextUid();
            $scope.componentId = StringUtils.nextUid();
            $scope.editionAlertPopOverId = 'edition-alert-popover-' + $scope.componentId;

            $element[0]['click'] = onClickUpload;
            
            init();

            function init() {
                $scope.onlyButton = $attrs.hasOwnProperty('skOnlyButton');
                $scope.progressBarId = 'progressBar_' + StringUtils.nextUid();
                $scope.statusId = 'status_' + StringUtils.nextUid();
                $scope.typeImage = 'upload';
                _icoUploadElement = $element.find('sk-icon.img-src');
            }

            function getPropertiesInfo(){
                _fileItem = ObjectUtils.getSafelyJson(_fileItem);
                $scope.value = ObjectUtils.getSafelyJson($scope.value);

                _fileItem['name']                 = $scope.value.name || _fileItem['name'];
                _fileItem['size']                 = $scope.value.size || _fileItem['size'];
                _fileItem['type']                 = $scope.value.type || _fileItem['type'];
                _fileItem['lastModifiedDate']     = $scope.value.lastModifiedDate || _fileItem['lastModifiedDate'];

                var deferred = $q.defer();

                if(ObjectUtils.isEmpty(_fileItem) && ObjectUtils.isEmpty($scope.value)){
                    deferred.reject();
                }else{
                    var data = {
                        name: _fileItem.name,
                        lastModifiedDate: DateUtils.formatDate(_fileItem.lastModifiedDate, DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS),
                        size: NumberUtils.bytesToSize(_fileItem.size)
                    };

                    deferred.resolve(data);
                }

                return deferred.promise;
            }

            function getData() {
                if ($scope.value) {
                    if (self.useDataset()) {

                        if ($scope.standaloneMode) {
                            return angular.toJson({
                                label: $scope.value.name,
                                key: buildFileSessionKey()
                            });
                        }

                        if (!($scope.nameAsValue == true)) {
                            return buildFileSessionKey();
                        }
                    } 
                        return $scope.value.name;
                   
                }

                return undefined;
            }

            function buildFileSessionKey() {
                var buf = StringUtils.newBuffer();
                if ($scope.value) {
                    buf.append('$file.session.key{').append(getFileKey()).append('}');
                    if ($scope.saveOnRepository) {
                        buf.append('.saveOnRepository{').append(StringUtils.undefinedAsEmpty(_internalName)).append('}');
                    }
                }
                return StringUtils.emptyAsUndefined(buf.toString());
            }

            function getFileKey() {
                if ($scope.standaloneMode && self.useDataset($scope)) {
                    var _rowMetadata = $scope.dataset.getRowMetadata();
                    var _rowID = _rowMetadata ? _rowMetadata.rowID : $scope.dataset.getNextUniqueID();

                    return $scope.dataset.getEntityName() + '_' + $scope.fieldName + "_" + _rowID;
                }

                return $scope.fileKey || $scope.fieldName;
            }

            function setData(data) {
				
				if(angular.isUndefined(data)){
                    cancelUpload();
					return;
				}
				if(typeof data == 'string' && data.includes("file.session.key")){
					return;
				}
				
                if (_http) {
                    _http.abort();
                }

                var parsedData;
                    
                try{
                    parsedData = JSON.parse(data);
                }catch(e){ 
                    /*silent*/
                }

                if(parsedData){
                    if (angular.isDefined(parsedData.label) && ($scope.standaloneMode)) {
                        $scope.value = {
                            name: parsedData.label
                        };
                    }else{
                        $scope.value = angular.copy(parsedData);
    
                        _internalName = parsedData.internalName;
                    }
                }else{
                    $scope.value = {
                        name: data
                    };

                    _internalName = data;
                }

                $timeout(function () {
                    completeHandler();
                }, 0, false);
            }

            function clear() {
                if (angular.isDefined($scope.value) && angular.isDefined($scope.value.name)) {
                    $scope.value = undefined;
	
                    if (self.useDataset($scope)) {
                            $scope.dataset.setModified(self);
                    }
                }
            }

            function onClickUpload($event) {
                var fnBefore = angular.isFunction($scope.beforeOpenUpload) ? $scope.beforeOpenUpload : angular.noop;

                $q.when(fnBefore())
                .then(function () {
                    $timeout(function () {
                        angular.element($element.find('#' + $scope.idInput)[0]).trigger('click');
                    }, 0, false);
                });
			}
          
            function changeHandler() {
                if (self.useDataset($scope)) {
                    $timeout(function () {
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    }, 0, false);
                }

                uploadFile();
            }

            function setFileKey(fileKey) {
                $scope.fileKey = fileKey;
            }

            function uploadFile() {
                if (_http) {
                    _http.abort();
                }

				if ($scope.value?.size == 0) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Attach.msgArquivoSemDados'));
                    $scope.value = null;
                    return;
                }
                
                $scope.showIconCancel = angular.isDefined($scope.value)?true:false;
             

                notifyUploadState(SkFileInputConstant.UPLOAD_IN_PROGRESS);
                
                clearProgressBar();

                var uploader;
                var params;

                if ($scope.customFileUploader) {
                    uploader = $scope.customFileUploader()
                    params = [{
                        $fileKey: getFileKey(),
                        $file: $scope.value
                    }]
                } else {
                    uploader = SessionFileUpload.uploadSessionFile;
                    params = [getFileKey(), $scope.value, createHttp];
                }
                
                if($scope.value){
                	$q.when(uploader.apply(self, params))
                	.then(function () {
                		if ($scope.value){
                        notifyUploadState(SkFileInputConstant.UPLOAD_SUCCESS);
                        completeHandler();
                            if (angular.isDefined($scope.value)) {
                                _fileItem = {
                                    name: $scope.value.name,
                                    lastModifiedDate: $scope.value.lastModifiedDate,
                                    size: $scope.value.size,
                                    type: $scope.value.type
                                };

                                $scope.value.pathSession = 'sfi://' + getFileKey();
                            }
                		}
                    }, function () {
                		notifyUploadState(SkFileInputConstant.UPLOAD_FAILED); getFileKey()  
                		errorHandler();
                	});
                }
            }

            function createHttp(http) {
                _http = http;
                _http.upload.addEventListener("progress", progressHandler);
            }

            function notifyUploadState(state) {
                $scope.uploadState({ $state: state, $value: $scope.value, $component: self });

                if (self.useDataset()) {
                    $scope.dataset.notifyUploadState(state == 'uploading');
                }

                $scope.cancelToolTip = state == SkFileInputConstant.UPLOAD_IN_PROGRESS ? i18n('Geral.lblCancelar') : i18n('Attach.lblRemover');
            }

            function progressHandler(event) {
                var percent = (event.loaded / event.total) * 100;

                updateProgressBar(percent);

                _status = _status || document.getElementById($scope.statusId);
                if (_status) {
                    _status.innerHTML = i18n('Attach.enviando') + Math.round(percent) + '%';
                }
            }

            function updateProgressBar(percent) {
                _progressBar = _progressBar || document.getElementById($scope.progressBarId);
                if (_progressBar) {
                    _progressBar.style.display = "";
                    _progressBar.style.width = Math.round(percent) + '%';
                }
            }

            function completeHandler() {
                if ($scope.value && $scope.value.name) {
                     
                    $scope.showIconCancel =  $scope.showBtnCancel; //Mostra ou nao o bnt de remover

                    updateProgressBar(100);

                    _status = _status || document.getElementById($scope.statusId);
                    if (_status) {
                        _status.innerHTML = '';

                        
                        var _element;
                        if ($scope.downloadFile || angular.isFunction($scope.customDownloadFile)) {
                            _element = document.createElement('a');
                            _element.style.cursor = 'pointer';
                            _element.onclick = function () {
                                if (angular.isFunction($scope.customDownloadFile)) {
                                        $scope.customDownloadFile();                                    
                                } else {
                                    if (self.useDataset()) {
                                        if($scope.standaloneMode){
                                            SkApplicationInstance.openWindow('/mge/download.mge?fileName=sfi://' + getFileKey() + '&downloadFileName=' + $scope.value.name);
                                        }else{
                                            var _path = $scope.value.pathSession || $scope.value.path;
                                              if (_path) {
                                                   var _internalNameValue = StringUtils.isEmpty($scope.value.internalName) ? '' : ('/' + $scope.value.internalName);
                                                   SkApplicationInstance.openWindow('/mge/download.mge?fileName=' + _path +_internalNameValue + '&downloadFileName=' + $scope.value.name);
                                              } else {
                                                var url = StringUtils.newBuffer();
                                                url.append('/mge/download.mge?fileName=sab://');
                                                url.append($scope.fieldName);
                                                url.append('&downloadFileName=');
                                                url.append($scope.value.name);
                                                url.append('&pkValues=');
                                                url.append(JSON.stringify($scope.dataset.getPrimaryKeyObject()));
                                                
                                                var fieldMetadata = $scope.dataset.getFieldMetadata($scope.fieldName);
                                                if(fieldMetadata){
                                                    url.append('&tableName=');
                                                    url.append(fieldMetadata['tableName']);
                                                }else{
                                                    url.append('&entityName=');
                                                    url.append($scope.dataset.getEntityName());
                                                }
    
                                                // Interceptor para injetar atributos a mais ou modificar a URL 
                                                $scope.interceptUrlDownload && $scope.interceptUrlDownload(url);
    
                                                SkApplicationInstance.openWindow(url.toString());
                                            }
                                        }


                                    }
                                }
                            };
                        } else {
                            _element = document.createElement('span');
                        }

                        _element.setAttribute('ng-bind', 'value.name');

                        _status.appendChild(_element);

                        hideProgressBar();

                        const debouncedCompile = AngularUtil.debounce(() => {
                            AngularUtil.compile(_status, $scope);
                        }, 0);

                        debouncedCompile();
                    }
                }else{
                    cancelUpload();
                }
            }

            function addFocus() {
                if($scope.disabledFocus !== true){
                    document.getElementById('input-file').style.borderBottomColor = '#4D90FE';
                    $scope.colorFocus = true;
                    _icoUploadElement.addClass('focus');
                }
            }
            
            function removeFocus() {
                if($scope.disabledFocus !== true){
                    document.getElementById('input-file').style.borderBottomColor = '#ccc';
                    $scope.colorFocus = false;
                    onFocusOutIcoUpload();
                }
            }

            function errorHandler() {
                _status = _status || document.getElementById($scope.statusId);
                if (_status) {
                    _status.innerHTML = i18n('Attach.uploadFalhou');
                }
            }

            function cancelUpload() {
                if (_http) {
                    _http.abort();
                }

                clearProgressBar();

                $scope.showIconCancel = false;

                clear();
            }

            function clearProgressBar() {
                hideProgressBar();

                _status = _status || document.getElementById($scope.statusId);
                if (_status) {
                    _status.innerHTML = "";
                }
            }

            function hideProgressBar(){
                _progressBar = _progressBar || document.getElementById($scope.progressBarId);
                if (_progressBar) {
                    _progressBar.style.display = "none";
                }
            }

            function onFocusInIcoUpload(){
               if(_icoUploadElement && $scope.disabledFocus !== true && !$scope.colorFocus) _icoUploadElement.addClass('focus');
            }

            function onFocusOutIcoUpload(){
                if(_icoUploadElement && $scope.disabledFocus !== true && !$scope.colorFocus) _icoUploadElement.removeClass('focus');
            }
            
        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-file-input
 * @restrict E
 * @description
 * A diretiva 'skFileInput' permite selecionar um arquivo de um diretório.
 *
 * Esse componente ao selecionar o arquivo o mesmo já realiza o upload do arquivo para ser salvo no repositório.
 *
 * @param {string=} skFileKey Será a chave que o arquivo será reconhecido quando estiver na sessão,
 * para que o mesmo possa ser salva, excluido e realizar o download do arquivo. Está chave é composta
 * dos seguinte dados:
 *
 * KEY_SESSION = 'ANEXO_SISTEMA' +
 * entityName = Entidade que o anexo será vinculado +
 * pkRegistro = Chave do arquivo que o anexo estará vinculado.
 *
 * @param {string=} skDataset Nesse parametro deve ser informado o dataSet da entidade que será gravado os anexos.
 *
 *  @param {string} [sk-field-name=undefined]
 *  Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
 * Índice do campo que este componente irá se registrar no dataset.
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
        <sk-application ng-controller="ExampleController as ctrl">
            <div>
                <sk-file-input sk-file-key="" sk-dataSet="ctrl.dataSet"></sk-file-input>
            </div>
        </sk-application>
     </file>
     <file name="app.js">
             angular
                .module('app', ['snk'])
                .controller('ExampleController', ['$q', 'Criteria', function($q, Criteria){
                    var self = this;
                    
                    self.dataSet;

                    self.onDatasetCreated = onDatasetCreated;
                    
                    
                    function onDatasetCreated(dataset) {
                        self.dataSet; = dataset;
                    }
                }]);
         </file>
 </example>
 *
 *
 * Author: Deivid Rodrigues
 */
angular
    .module('snk.components.input')
    .directive('skFileInput', ['SkConstants', '$timeout', function(SkConstants, $timeout){
        return {
            restrict: 'E',
            templateUrl: 'components/input/fileinput/fileinput.tpl.html',
            controller: 'SkFileInputController',
            scope: {
                api: '&skApi',
                fileKey: '@skFileKey',
                dataset: '=skDataset',
                fieldName: '@?skFieldName',
                fieldIndex: '@?skFieldIndex',
                enabled: '=?skEnabled',
                uploadState: '&skUploadState',
                beforeUpload: '&?skBeforeUpload',
                standaloneMode: '=?skStandaloneMode',
                nameAsValue: '=?skNameAsValue',
                value: '=?skValue',
                customFileUploader: '&?skCustomFileUploader',
                btnLabel: '@skBtnLabel',
                userTooltip: '@skTooltip',
                btnIcon: '@skBtnIcon',
                beforeOpenUpload: '&?skBeforeOpenUpload',
                downloadFile:'=?skDownloadFile',
                customDownloadFile:'&?skCustomDownloadFile',
                showBtnCancel:'=?skShowBtnCancel',
                disabledFocus:'=?skDisabledFocus',
                saveOnRepository: '@?skSaveOnRepository',
                interceptUrlDownload:'=?skInterceptUrlDownload',
            }
        };
    }]);

angular
    .module('snk.components.input')
    .directive('fileModel', ['$parse', 'ObjectUtils', 'AngularUtil', function ($parse, ObjectUtils, AngularUtil) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var changeFn = $parse(attrs.change);
                var onFocusOut = $parse(attrs.onFocusOut);
                var onFocus = $parse(attrs.onFocus);

                var modelSetter = model.assign;

                scope.$watch(attrs.fileModel, function(value) {
                    if(angular.isUndefined(ObjectUtils.getProperty(value,'name'))) {
                        element.val('');
                    }
                });

                element.bind('change', function () {
                    AngularUtil.apply(scope, function() {
                        modelSetter(scope, element[0].files[0]);

                        changeFn(scope);
                    });
                });

                element.bind('focus', function () {
                    (onFocus || angular.noop)(scope);
                });

                element.bind('blur', function () {
                    (onFocusOut || angular.noop)(scope);
                });
            }
        };
    }]);

angular
    .module('snk.components.input')
    .controller('skFileInputMultiController', ['SanPopup', 'i18n', '$scope', '$timeout', 'ObjectUtils','ArrayUtils',
        function (SanPopup, i18n, $scope, $timeout, ObjectUtils, ArrayUtils) {
            var self = this;

            var _registeredItems = [];
            var _sessionModifield = [];

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                getData: getData,
                setData: setData
            });

            $scope.onClickOpenMultipleFiles = onClickOpenMultipleFiles;
            $scope.countItems = 0;
            $scope.countItemsDescription = i18n('Attach.lblContadorArquivos', {items: $scope.countItems});

            function getData() {
                if ($scope.standaloneMode || window.standaloneModeAnexo) {
					(window.standaloneModeAnexo) ? window.standaloneModeAnexo = false : window.standaloneModeAnexo = undefined;
                    return ArrayUtils.toArray(_registeredItems).length > 0 ? angular.toJson({ 'values': cloneFileObject(_registeredItems) }) : '';
                }

                return _sessionModifield ? angular.toJson(_sessionModifield.join('')) : '';
            }

            function cloneFileObject() {
                var newValue = [];
                ArrayUtils.forEach(_registeredItems, function(item) {
                    newValue.push({
                        "fileKey": item.fileKey,
                        "lastModified": item.lastModified,
                        "lastModifiedDate": item.lastModifiedDate,
                        "name": item.name,
                        "path": item.path,
                        "progressBarId": item.progressBarId,
                        "size": item.size,
                        "statusId": item.statusId,
                        "type": item.type,
                        "upload": item.upload,
                        "link": item.link,
                        "linkNew": item.linkNew,
                        "pathSession": item.pathSession,
                        "internalName": item.internalName
                    });
                });

                return newValue;
            }

            function setData(data) {
                var parsedData = [];

                try {
                    parsedData = JSON.parse(data);
                } catch (e) { /*silent*/ }


                if ($scope.standaloneMode) {
                    if (!angular.isArray(parsedData)) {
                        parsedData = parsedData.values;
                    }
                }

                _registeredItems = ArrayUtils.toArray(parsedData);

                $scope.countItems = _registeredItems.length;
                $scope.countItemsDescription = i18n('Attach.lblContadorArquivos', {items: $scope.countItems});
            }

            function onClickOpenMultipleFiles($event) {
                SanPopup.open({
                    title: i18n('Attach.lblArquivos'),
                    templateUrl: 'components/input/fileinputmulti/popup/filemultipopup.tpl.html',
                    controller: 'fileMultiPopupController',
                    controllerAs: 'ctrl',
                    showBtnCancel: false,
                    showIconClose: false,
                    size: 'md',
                    windowClass: 'modal-multiple-files',
                    resolve: {
                        data: {
                            enabled: $scope.enabled,
                            files: ObjectUtils.clone(_registeredItems),
                            getFileKey: function () {
                                return $scope.fileKey || $scope.fieldName;
                            }
                        }
                    }
                }).result.then((data) => {
                    //Se for diferente ou teve adicao ou remocao de elementos
                    if (!ObjectUtils.equals(data.allItems, _registeredItems)) {

                        $timeout(function () {
                            $scope.dataset.notifyEditionStart(self);
                            $scope.dataset.setModified(self);
                        },0, false);

                        _registeredItems = data.allItems;
                        _sessionModifield = data.modifieldItems;

                        $scope.countItems = _registeredItems.length;
                        $scope.countItemsDescription = i18n('Attach.lblContadorArquivos', {items: $scope.countItems});
                    }
                });
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-file-input-multi
 * @restrict E
 * @description
 * A diretiva 'skFileInputMulti' permite selecionar um arquivo de um diretório.
 *
 * Esse componente ao selecionar o arquivo o mesmo já realiza o upload do arquivo para ser salvo no repositório de aquivos.
 *
 * @param {string=} skDataset Nesse parametro deve ser informado o dataSet da entidade que será gravado os anexos.
 *
 *  @param {string} [sk-field-name=undefined]
 *  Nome do campo que este componente irá se registrar no dataset.
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
        <sk-application ng-controller="ExampleController as ctrl">
            <div>
                <sk-file-input-multi sk-dataSet="ctrl.dataSet" sk-field-name="namefield"></sk-file-input-multi>
            </div>
        </sk-application>
     </file>
     <file name="app.js">
             angular
                .module('app', ['snk'])
                .controller('ExampleController', ['$q', 'Criteria', function($q, Criteria){
                    var self = this;
                    
                    self.dataSet;

                    self.onDatasetCreated = onDatasetCreated;
                    
                    
                    function onDatasetCreated(dataset) {
                        self.dataSet; = dataset;
                    }
                }]);
         </file>
 </example>
 */
angular
    .module('snk.components.input')
    .directive('skFileInputMulti', ['SkConstants', '$timeout', function(SkConstants, $timeout){
        return {
            restrict: 'E',
            templateUrl: 'components/input/fileinputmulti/fileinputmulti.tpl.html',
            controller: 'skFileInputMultiController',
            scope: {
                fileKey: '@skFileKey',
                dataset: '=skDataset',
                fieldName: '@?skFieldName',
                enabled: '=?skEnabled',
                standaloneMode: '=?skStandaloneMode',
            }
        };
    }]);
angular
    .module('snk.components.input')
    .directive('fileMultiModel', ['$parse', 'ObjectUtils', 'AngularUtil',
    function ($parse, ObjectUtils, AngularUtil) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileMultiModel);
                var changeFn = $parse(attrs.change);
                var onFocusOut = $parse(attrs.onFocusOut);
                var onFocus = $parse(attrs.onFocus);

                var modelSetter = model.assign;

                scope.$watch(attrs.fileModel, function(value) {
                    if (angular.isUndefined(ObjectUtils.getProperty(value,'name'))) {
                        element.val('');
                    }
                });

                element.bind('change', function () {
                    AngularUtil.apply(scope, function() {
                        modelSetter(scope, (element[0].files || []));
                        changeFn(scope);
                    });
                });

                element.bind('focus', function () {
                    (onFocus || angular.noop)(scope);
                });

                element.bind('blur', function () {
                    (onFocusOut || angular.noop)(scope);
                });
            }
        };
    }]);

angular
    .module('snk.components.input')
    .filter('bytesToSize', ['NumberUtils',
        function (NumberUtils) {
            return function (size) {
                return NumberUtils.bytesToSize(size);
            };
    }]) 
    .filter('limitToName', ['StringUtils',
        function (StringUtils) {
            return function (name) {
                if (StringUtils.isEmpty(name)) {
                    return 'SEM NOME';
                }
                return name.length <= 75 ? name : `${name.substr(0, 75)}...`;
            };
    }]) 
    .controller('fileMultiPopupController', ['$popupInstance', 'SkApplicationInstance', '$q', 'StringUtils', '$scope', 'ArrayUtils', 'i18n', 'MessageUtils', 'data', 'SessionFileUpload', '$timeout', 'ObjectUtils', 'PopUpParameter', 'UrlUtils', 'Base64',
        function ($popupInstance, SkApplicationInstance, $q, StringUtils, $scope, ArrayUtils, i18n, MessageUtils, data, SessionFileUpload, $timeout, ObjectUtils, PopUpParameter, UrlUtils, Base64) {
            self = this;

            $scope.$success = confirm;

            $scope.idInput = 'idInput_' + StringUtils.nextUid();

            self.enabled = data.enabled;

            var _filesRemove = [];

            self.addFiles = addFiles;
            self.downloadAll = downloadAll;
            self.disableDownloadAll = disableDownloadAll;
            self.downloadAtIndex = downloadAtIndex;
            self.fileItems = data.files;
            self.removeAttach = removeAttach;
            self.removeAll = removeAll;
            self.onChangeHandler = onChangeHandler;
            self.allowSameFile = allowSameFile;
            self.addLink = addLink;

            const charsNotParseable = ['º', '°', 'ç', 'á','ã','â','í','ú','é','ê','õ','ó','ô','@','*','Ç', 'Á','Â','Ã','Í','Ú','É','Ê','Õ','Ó','Ô'];

            function addFiles() {
                $timeout(function () {
                    document.getElementById($scope.idInput).click()
                }, 0, false);
            }

            function onChangeHandler() {
                [].slice.call($scope.value).forEach(e => {
                    addSessionFile(e, data.getFileKey() + "_" + StringUtils.nextUid());
                });
            }

            function addSessionFile(file, fileKey) {
            	if (file.size == 0) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Attach.msgArquivoSemDados'));
                    return;
                }

                if(charsNotParseable.some(c => file.name.includes(c))){
                    file = normalizeFileName(file);
                }

                file.fileKey = fileKey;
                file.statusId = 'statusId' + fileKey;
                file.progressBarId = 'progressBarId_' + fileKey;

                var uploader = SessionFileUpload.uploadSessionFile;
                var params = [fileKey, file, SessionFileInstance(file).createHttp];

                file.upload = true;

                self.fileItems.push(file);

                $q.when(uploader.apply(self, params))
                    .then(function () {
                        ArrayUtils.forEach(self.fileItems, (e) => {
                            if (ObjectUtils.equals(e, file)) {
                                e.pathSession = 'sfi://' + fileKey;
                                e.upload = false;
                                return false;
                            }
                        });
                    }, function () {
                    
                    });
            }

            function SessionFileInstance(file) {
                this.createHttp = function (http) {
                    file._http = http;
                    file._http.upload.addEventListener("progress", progressHandler);
                }

                function progressHandler(event) {
                    var percent = (event.loaded / event.total) * 100;
                    var _status = document.getElementById(file.statusId);

                    updateProgressBar(percent);

                    if (_status) {
                        _status.innerHTML = i18n('Attach.enviando') + Math.round(percent) + '%';
                    }
                }

                function updateProgressBar(percent) {
                    var _progressBar = document.getElementById(file.progressBarId);

                    if (_progressBar) {
                        _progressBar.style.display = "";
                        _progressBar.style.width = Math.round(percent) + '%';
                    }
                }

                return this;
            }

            function removeAttach(file, isNew) {
                doRemove(i18n('Attach.textConfiRemover'), () => {
                    var pathSession = ObjectUtils.getProperty(file, "pathSession") || '';

                    if (isNew || pathSession.startsWith("sfi://") || file.linkNew) {
                        if (file._http && file._http.abort) {
                            file._http.abort();
                        }

                        // Esta indo para sessao
                        ArrayUtils.removeReference(self.fileItems, file);
                    } else {
                        _filesRemove.push(file);
                        ArrayUtils.removeReference(self.fileItems, file);
                    }
                });
            }

            function removeAll() {
                doRemove(i18n('Attach.textConfiRemoverAll'), () => {
                    self.fileItems.forEach((file) =>{
                        var pathSession = ObjectUtils.getProperty(file, "pathSession") || '';
    
                        if (!pathSession.startsWith("sfi://") || (file.link && !file.linkNew)) {
                            _filesRemove.push(file);
                        }
                    });

                    self.fileItems = [];
                });
            }

            function doRemove(title, fnAfterAgreed) {
                MessageUtils
                    .simpleConfirmBuilder()
                    .title('Geral.lblExcluir')
                    .msg(title)
                    .okTheme('danger')
                    .okLabel(i18n('Attach.simExcluir'))
                    .show()
                    .then(function () {
                        fnAfterAgreed();
                    });
            }

            function downloadAll() {
                self.fileItems.forEach(e => !e.link ? downloadAtIndex(e) : undefined);
            }

            function disableDownloadAll() {
               if (!self.fileItems.find(e => !e.link)) {
                   return true;
               }
               return false;
            }

            function downloadAtIndex(file) {
                if (file.link) {
                    SkApplicationInstance.openWindow(file.link);
                } else {
                    var _internalNameValue = StringUtils.isEmpty(file.internalName) ? '' : ('/' + file.internalName);
                    
                    if(file.path.includes("//AD")){
						file.path = file.path.replace("//AD","/AD");
					}
                    
                    var filePath = (file.pathSession || file.path) + _internalNameValue;
                    var path = Base64.encode(filePath);
	                var url = UrlUtils.getUrlBase() + "/mge/download.mge?fileName=" + path + "&fileNameIsEncoded=S";
	                
	                fetch(url).then(response => {
					    if (response.ok) {
					      window.open(url, '_blank');
					    } else {				
							var fileSemAcento = file.name;							
							charsNotParseable.forEach(function (c) {
								if (c ==='ç') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'c');
			        			} else if (c ==='Ç') {
									fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'C');	
			    				} else if (c === 'º' || c === '*'|| c === '@') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'x');
			    				}else if (c==='á' || c==='ã'|| c==='â') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'a');
			        			}else if (c==='Á' || c==='Ã'|| c==='Â') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'A');	
			    				}else if (c==='ó' || c==='õ'|| c==='ô') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'o');
			        			}else if (c==='Ó' || c==='Õ'|| c==='Ô') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'O');	
			        			}else if (c==='í') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'i');
			        			}else if (c==='Í') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'I');	
			        			}else if (c==='é'|| c==='ê') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'e');
			        			}else if (c==='É'|| c==='Ê') {
			        				fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'E');
			        			}else if (c==='ú') {
									fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'u');
			        			}else if (c==='Ú') {
									fileSemAcento = StringUtils.replaceAll(fileSemAcento, c, 'U');
								}
			                });							
							path = Base64.encode(file.path + '/' + fileSemAcento);			
			                url = UrlUtils.getUrlBase() + "/mge/download.mge?fileName=" + path + "&fileNameIsEncoded=S";
			                SkApplicationInstance.openWindow(url + '&downloadFileName=' + file.name);
			                //window.open(url, '_blank');
					    }
					}).catch();
                } 
            }

            function allowSameFile($event) {
                $event.target.value = null;
            }

            function confirm() {
                var _files = [];
                var hasFileUploading = false;

                for (var i = 0; i < self.fileItems.length; i++) {
                    var file = self.fileItems[i];

                    if (file.upload) {
                        hasFileUploading = true;
                        break;
                    }

                    if (file.link && file.linkNew) {
                        _files.push(`$file.save{link=§§${file.name}§§${file.link}}`);
                    } else {
                        //Salva somente os que estao na sessao
                        var pathSession = ObjectUtils.getProperty(file, "pathSession") || '';
                        if (pathSession.startsWith("sfi://")) {
                            _files.push('$file.save{sessionkey=' + file.fileKey + '}');
                        }
                    }
                }

                _filesRemove.forEach(e => {
                    if(e.link){
                        _files.push(`$file.remove{link=§§${e.link}}`);
                    }else{
                        _files.push('$file.remove{internalName=' + e.internalName + '}');
                    }
                });
               
                if (hasFileUploading) {
                    MessageUtils.showAlert(i18n('Attach.lblArquivos'), i18n('Attach.lblAguardeFinalizacao'));
                } else {
                    $popupInstance.success({ 'modifieldItems': _files, 'allItems': self.fileItems });
                }
            }
          
            function addLink() {
                PopUpParameter.builder()
                .title(i18n('Attach.cadastrarLink'))
                .size('md')
                .height(120)
                .columns(1)
                .buildStringParameter('name', i18n('Attach.descricaoLink '), true)
                .buildStringParameter('link', i18n('Attach.link '), true)
                .show().result
                .then(function (result) {
                    if (!self.fileItems.find(item => item.link === result.link)) {
                        result.linkNew = true;
                        self.fileItems.push(result);
                    }
                });
            }

            function normalizeFileName(file){
                let newFileName = file.name;
                charsNotParseable.forEach(c =>{
					if (c ==='ç'|| c ==='Ç') {
        				newFileName = StringUtils.replaceAll(newFileName, c, 'c');
    				} else if (c === 'º' || c === '*'|| c === '@') {
        				newFileName = StringUtils.replaceAll(newFileName, c, 'x');
    				}else if (c==='á' || c==='ã'|| c==='â'|| c==='Á' || c==='Ã'|| c==='Â') {
        				newFileName = StringUtils.replaceAll(newFileName, c, 'a');
    				}else if (c==='ó' || c==='õ'|| c==='ô'||c==='Ó' || c==='Õ'|| c==='Ô') {
        				newFileName = StringUtils.replaceAll(newFileName, c, 'o');
        			}else if (c==='í'||c==='Í') {
        				newFileName = StringUtils.replaceAll(newFileName, c, 'i');
        			}else if (c==='é'|| c==='ê'|| c==='É'|| c==='Ê') {
        				newFileName = StringUtils.replaceAll(newFileName, c, 'e');
        			}else if (c==='ú'||c==='Ú') {
						newFileName = StringUtils.replaceAll(newFileName, c, 'u');
        			}
                });

                return new File([file], newFileName, {
                    type: file.type,
                    lastModified: file.lastModified,
                });
            }

        }
    ]);
angular
    .module('snk.components.input')
    .controller('SkFilterDatasetController', ['$scope', 'StringUtils','ArrayUtils','ObjectUtils',
        function ($scope, StringUtils, ArrayUtils, ObjectUtils) {
            var self = this;

            $scope.eventFilter = eventFilter;
            $scope.runScript = runScript;

            var _fieldsNameToFind = [];

            self.setFieldNames = setFieldNames;
            self.clear = clear;

            init();
            function init() {
                
                ($scope.onFilterCreated || angular.noop)({
                    filter: ObjectUtils.buildPublicAPI(self, ['setFieldNames', 'clear'])
                });
            }

			function runScript(keyEvent) {
				if (keyEvent.which === 13){
                    eventFilter();
				}
            }

            function eventFilter() {
                findRecords($scope.valueFilter);

                document.getElementById("inputFilter").focus();
            }

            function findRecords(pattern) {
            	$scope.dataset.removeFilter();

                if (!StringUtils.isEmpty(pattern)) {
                	if (_fieldsNameToFind.length === 0) {
                		ArrayUtils.toArray($scope.fieldNames).forEach(function (fieldName) {
                			_fieldsNameToFind.push($scope.dataset.getFieldIndexByName(fieldName));
                		});
                	}
                	
                    $scope.dataset.addFilterFunction(function (value) {
                        var matchedItens = false;
                        for (var i = 0; i < _fieldsNameToFind.length; i++) {
                        	var record = String(StringUtils.undefinedAsEmpty(value[_fieldsNameToFind[i]]));
                            if (record.toUpperCase().indexOf(pattern.toUpperCase()) >= 0) {
                                matchedItens = true;
                                break;
                            }
                        }

                        return matchedItens;
                    });
                }

                $scope.dataset.refresh();
            }

            function clear() {
                if($scope.dataset){
                    $scope.dataset.removeFilter();
                }

                $scope.valueFilter = undefined;
            }

            function setFieldNames(fieldNames){
                $scope.fieldNames = fieldNames;
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-filter-dataset
 * @restrict E
 * @description
 *
 * Esse componente filtra os registros da grade do dataSet, conforme valor digitado no input.
 *
 * @param {string=} skDataset Nesse parametro deve ser informado o dataSet da entidade que sera filtrado os registros.
 *
 *  @param {string} [sk-field-names]
 *  Nome dos campos que serao filtrados.
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
         <div>
             <sk-filter-dataset sk-dataSet="dataSet" sk-field-names="CODPROD,REFERENCIA">
             </sk-filter-dataset>
         </div>
     </file>
 </example>
 *
 *
 */
angular
    .module('snk.components.input')
    .directive('skFilterDataset', function () {
        return {
            restrict: 'E',
            templateUrl: 'components/input/filterdataset/filterdataset.tpl.html',
            controller: 'SkFilterDatasetController',
            scope: {
                dataset: '=skDataset',
                fieldNames: '@?skFieldNames',
                onFilterCreated: '&?skFilterCreated'
            }
        };
    });
angular.module('snk.components.input')
    .controller('SkImageInputController', ['$scope', '$q', 'SessionFileUpload', 'ObjectUtils', 'MessageUtils', '$http', 'UrlUtils', '$element', 'UserAgentUtils', 'SkI18nService', '$timeout', 'AngularUtil', 'DomUtil', 'ImagePopUpService', 'StringUtils',
        function ($scope, $q, SessionFileUpload, ObjectUtils, MessageUtils, $http, UrlUtils, $element, UserAgentUtils, SkI18nService, $timeout, AngularUtil, DomUtil, ImagePopUpService, StringUtils) {
            var NO_IMAGE_URL = '/mge/img/noImage.jpg';

            var NO_IMAGE_CLASS = 'no-img';
            var MOBILE_CLASS = 'is-mobile';

            var validMimeTypes;
            var self = this;

            var _lastLoadedUrl;
            var _isFileSession;
            var _isFileDeleted;

            var _cancelerDownloadImage = $q.defer();

            $scope.loadingImage = false;
            $scope.changeHandler = self.changeHandler = changeHandler;
            $scope.deleteFile = deleteFile;
            $scope.uploadFile = uploadFile;

            self.useEntityName = useEntityName;

            init();

            function init() {
                if (UserAgentUtils.isMobile()) {
                    $element.addClass(MOBILE_CLASS);
                }

                //Para que o click do input não dispare o click do container
                $element.find('input').click(stopEventPropagation);

                angular.element(DomUtil.select($element, '.image-container')).on('click', AngularUtil.wrapApply($scope, openImage));

                if ($scope.acceptType) {
                    validMimeTypes = $scope.acceptType;
                } else {
                    validMimeTypes = ['image/png', 'image/jpeg', 'image/gif'];
                }

                ObjectUtils.implements(self, FieldBinder, {
                    scope: $scope,
                    getData: getData,
                    setData: setData
                });

                if (self.useDataset()) {
                    ObjectUtils.implements(self, IDataSetObserver, {
                        currentLineChanged: function () {
                            if (!$scope.dataset.isCopyingRecord()) {
                                downloadImage(true, true);
                            }
                        },
                        insertionModeActivated: function (indexBeforeInsert) {
                            if ($scope.dataset.isCopyingRecord() && !$scope.avoidCopyingRecord) {
                                var sourceRecord = $scope.dataset.getRecord(indexBeforeInsert);

                                var pkFields = {};

                                for (var i in $scope.dataset.getPrimaryKeys()) {
                                    var pkFieldName = $scope.dataset.getPrimaryKeys()[i];
                                    pkFields[pkFieldName] = sourceRecord[$scope.dataset.getFieldIndexByName(pkFieldName)];
                                }

                                if ($scope.standaloneMode) {
                                    var imagemSession = sourceRecord[$scope.dataset.getFieldIndexByName($scope.fieldName)];
                                }
                                copy(pkFields, imagemSession);
                            } else {
                                setFile(undefined);
                            }
                        },
                        reloadFields: () => {
                            if ($scope.standaloneMode) {
                                _isFileSession = false;
                                _isFileDeleted = false;
                                $scope.dataset.setFieldValue($scope.fieldName, undefined);
                            } 
                            downloadImage(true);
                        }
                    });

                    $scope.dataset.addObserver(self);
                    downloadImage(true);
                } else if (self.useEntityName()) {
                    downloadImage(true);
                } else {
                    setFile(null, validMimeTypes);
                }
            }

            function stopEventPropagation(event) {
                event.stopPropagation();
                event.stopImmediatePropagation();
            }

            function setData(data) {
                let isDataDefined = $scope.standaloneMode && angular.isDefined(data);
                _isFileSession = isDataDefined && data.startsWith('$file.session.key'); 
                _isFileDeleted = isDataDefined && data.startsWith('deletado');
            }

            function getData() {
                if ($scope.file) {
                    return '$file.session.key{' + buildFileKey() + '}';
                }
                return undefined;
            }

            function getUrlStandaloneMode() {
                if (self.useDataset()) {
                    return `/mge/UPLOADING_${buildFileKey()}.dbimage`;
                }
            }

            function downloadImage(preventUpload, changeLine = false) {
                var uploadUrl;
                if (_isFileDeleted) {
                    uploadUrl = undefined;   
                } else if ($scope.standaloneMode && _isFileSession) {
                    uploadUrl = getUrlStandaloneMode()
                } else {
                    uploadUrl = getBaseUrl(buildPkObj());
                }

                if (uploadUrl) {
                    _lastLoadedUrl = uploadUrl;

                    $scope.loadingImage = true;

                    if (changeLine) {
                        _cancelerDownloadImage.resolve();
                        _cancelerDownloadImage = $q.defer();
                    }

                    $http.get(uploadUrl, { responseType: 'blob', timeout: _cancelerDownloadImage.promise })
                        .success(function (image) {
                            setFile(image, false, preventUpload).finally(() => {
                                finallyDownloadImage();
                            });
                        })
                        .error(function () {
                            setFile(undefined, false, preventUpload).finally(() => {
                                finallyDownloadImage();
                            });
                        });
                } else {
                    setFile(undefined, false, preventUpload);
                }
            }

            function finallyDownloadImage() {
                $timeout(function () {
                    $scope.loadingImage = false;
                    AngularUtil.digest($scope);
                }, 0, false);
            }

            function changeHandler(file) {
                setFile(file);
                updateDatasetField();
            }

            function isTypeValid(type) {
                if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
                    return true;
                } else {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, SkI18nService.instant('ImageInput.msgTipoImage') + validMimeTypes);
                    return false;
                }
            }

            function setFile(file, validateType, preventUpload) {
                var defer = $q.defer();

                if (file && validateType !== true) {
                    if (isTypeValid(file.type)) {
                        $element.removeClass(NO_IMAGE_CLASS);

                        $scope.file = file;

                        encodeImage(file).then(function (fileEncoded) {
                            $scope.fileEncoded = fileEncoded;
                            $scope.$emit('onVerifyImage', $scope.fileEncoded);
                        }).finally(() => {
                            defer.resolve();
                        });

                        if (preventUpload !== true) {
                            if (angular.isDefined($scope.maxSize) && $scope.maxSize > 0) {
                                // O valor recuperado no sizeFileUpload é em bytes. Nesse caso é necessário multiplcar o <maxSize> por 1024 para ter o valor em KB.
                                let sizeFileUpload = ObjectUtils.getProperty(file, 'size');
                                let maxSize = $scope.maxSize * 1024;
                                if (sizeFileUpload >= maxSize) {
                                    MessageUtils.showError(MessageUtils.TITLE_ERROR, SkI18nService.instant('ImageInput.errorImageSize') + $scope.maxSize + "(KB)");
                                    return;
                                }
                            }
                            sessionFileUpload();
                        }
                    }
                } else {
                    $element.addClass(NO_IMAGE_CLASS);
                    $scope.file = undefined;
                    $scope.fileEncoded = $scope.iconDefault ? $scope.iconDefault : NO_IMAGE_URL;
                    $scope.$emit('onVerifyImage', $scope.fileEncoded);
                    defer.resolve();
                }
                
                return defer.promise;
            }

            function sessionFileUpload() {
                var fileKey = buildFileKey();
                SessionFileUpload.uploadSessionFile(fileKey, $scope.file).then(function () {
                    _lastLoadedUrl = '/mge/UPLOADING_' + fileKey + '.dbimage';
                }, function (error) {
                    console.log('Erro ao fazer upload de arquivo: ', error);
                });
            }

            function encodeImage(image) {
                var defer = $q.defer();
                var reader = new FileReader();
                reader.onload = function (evt) {
                    defer.resolve(evt.target.result);
                };
                reader.onerror = function (evt) {
                    defer.reject(evt);
                };
                reader.readAsDataURL(image);
                return defer.promise;
            }

            function buildFileKey() {
                if (self.useDataset()) {
                    var fileKey = $scope.dataset.getEntityName() + "_" + $scope.fieldName;
                    if ($scope.standaloneMode) {
                        var rowMetadata = $scope.dataset.getRowMetadata();
                        var rowID = rowMetadata ? rowMetadata.rowID : $scope.dataset.getNextUniqueID();
                        fileKey += '_' + rowID; 
                    }
                    return fileKey;
                } else {
                    return $scope.fieldName;
                }
            }

            function buildPkObj() {
                if ($scope.dataset) {
                    try {
                        return $scope.dataset.getPrimaryKeyObject(true);
                    } catch (Error) {
                        if (!$scope.dataset.isInsertionMode()) {
                            return undefined;
                        }
                    }
                }
                if ($scope.pk) {
                    return $scope.pk;
                }
                return undefined;
            }

            function getBaseUrl(pk) {
                if (!pk) {
                    return undefined;
                }
                let entityName = self.useDataset() ? $scope.dataset.getEntityName() : $scope.entityName;
                var url = UrlUtils.getUrlBase();
                url += '/mge/' + entityName;
                url += '@' + $scope.fieldName;
                for (pkField in pk) {
                    url += '@' + pkField + "=" + pk[pkField];
                }
                url += '.dbimage';
                if (StringUtils.isNotEmpty($scope.imageLoaderCustom)) {
                    url += ('?imageLoaderCustom=' + $scope.imageLoaderCustom);
                }
                return url;
            }

            function uploadFile($event) {
                stopEventPropagation($event);
                setTimeout(function () {
                    $element.find('input').click();
                })
            }

            function openImage() {
                if ($scope.file) {
                    ImagePopUpService.open({
                        file: $scope.file,
                        fileEncoded: $scope.fileEncoded,
                        url: _lastLoadedUrl
                    });
                }
            }

            function deleteFile($event) {
                stopEventPropagation($event);
                if (!$scope.enabled) {
                    return;
                }
                setFile(undefined);
                SessionFileUpload.clearSessionFile(buildFileKey())
                    .finally(function () {
                        updateDatasetField(true);
                    });
            }

            function updateDatasetField(deletado) {
                if (self.useDataset()) {
                    var f = function () {
                        if ($scope.dataset.getCurrentRow() || $scope.dataset.isAnyEditMode() || $scope.dataset.isInsertionMode()) {
                            if ($scope.standaloneMode) {
                                if (deletado) {
                                    $scope.dataset.setFieldValue($scope.fieldName, 'deletado');
                                } else {
                                    //Forçando sujuar o dataSet para entrar em modo de inserçao
                                    $scope.dataset.setFieldValue($scope.fieldName, '$file.session.key{}');
                                    $scope.dataset.setFieldValue($scope.fieldName, '$file.session.key{' + buildFileKey() +'}');
                                }
                                self.notifyChangeToDataset();
                            } else {
                                $scope.dataset.setFieldValue($scope.fieldName, '$file.session.key{' + buildFileKey() +'}');
                            }    
                        }     
                    }
                };

                if ($scope.dataset.size() == 0 && !$scope.dataset.isInsertionMode()) {
                    $scope.dataset.goToInsertionMode().then(function () {
                        f();
                    });
                } else {
                    f();
                }
            }

            function copy(pk, imagemSession) {
                if (imagemSession) {
                    sessionFileUpload();
                    return;
                }
                var urlCopy = getBaseUrlCopy(pk)
                if (urlCopy) {
                    $http.get(urlCopy, { responseType: 'blob' })
                        .success(function (image) {
                            setFile(image, false);
                        })
                        .error(function () {
                            setFile(undefined, false);
                        });
                } else {
                    setFile(undefined, false);
                }

                updateDatasetField();
            }

            function getBaseUrlCopy(pk) {
                if (!pk) {
                    return undefined;
                }

                var url = UrlUtils.getUrlBase();
                url += "/mge/COPY_" + $scope.dataset.getEntityName();
                url += "@" + $scope.fieldName;

                for (pkField in pk) {
                    url += '@' + pkField + "=" + pk[pkField];
                }

                url += '.dbimage';

                if (StringUtils.isNotEmpty($scope.imageLoaderCustom)) {
                    url += ('?imageLoaderCustom=' + $scope.imageLoaderCustom);
                }

                return url;

            }

            function useEntityName() {
                return angular.isDefined($scope.entityName) ? true : false;
            }
        }]);



/**
 * @ngdoc directive
 * @name snk.components.entityattach.directive:sk-image-input
 * @restrict E
 * @description
 * A diretiva 'skImageInput' permite ao usuário selecionar uma imagem. O Objetivo desse componente é possíbilitar o usuário
 * realizar do drop ou clicar para selecionar uma imagem e apresentar uma preview da mesma.
 *
 * @param {string} skFile Nesse parametro pode ser passado o arquivo em si, geralmente será utilizado em telas que não tem dataSet.
 *
 * @param {string} skAcceptType Nesse parametro pode ser informado os tipos de arquivos que o componente irá aceitar por padrão
 * é aceito os seguintes formatos: image/jpg, image/png, image/gif.
 *
 * @param {string} skFieldName Nesse parametro pode ser informado o nome do campo da entidade que será salvo a imagem
 * nas telas dynaform os campos do tipo do campo for 'B' tipo de apresentação for 'I' serão renderizados no formato do desse componente.
 *
 * @param {string} skDataset Nesse parametro pode ser informado o dataSet da entidade que será gravado a imagem.
 *
 * @param {string} skEnabled Nesse paramentro pode ser informado se o campo será habilitado ou não de acordo com uma regra por default este é habilitado.
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
         <div ng-controller="MyController as ctrl">
             <sk-image-input sk-field-name="TESTE"></sk-image-input>
         </div>
     </file>
     <file name="app.js">
         angular
         .module('app', ['snk'])
         .controller('MyController', function(){

          });
     </file>
 </example>
 * Author: Deivid Rodrigues
 */
angular.module('snk.components.input')
    .directive('skImageInput', function (SkConstants, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'components/input/imageinput/imageinput.tpl.html',
            controller: 'SkImageInputController',
            controllerAs: 'ctrl',
            scope: {
                file: '=?skFile',
                acceptType: '@?skAcceptType',
                fieldName: '@?skFieldName',
                dataset: '=?skDataset',
                enabled: '=?skEnabled',
                avoidCopyingRecord: '=?avoidCopyingRecord',
                entityName: '@?skEntityName',
                pk: '=?skPk',
                width: '@?skWidth',
                height: '@?skHeight',
                onlyImage: '=?skOnlyImage',
                iconDefault: '@?skIconDefault',
                maxSize: '=?skMaxSize',
                imageLoaderCustom:'@?skImageLoaderCustom',
                standaloneMode: '=?skStandaloneMode'
            },
            compile: function(element, attr) {
                attr.tabindex = attr.tabindex || 0;

                element.attr('tabindex', attr.tabindex);

                return linkFn;
            }

        };

        function linkFn(scope, element, attrs, controller) {

            var processDragOverOrEnter = function (event) {
                if (event != null) {
                    event.preventDefault();
                }

                event.originalEvent.dataTransfer.effectAllowed = 'copy';
                return false;
            };

            scope.onlyImage = scope.onlyImage ? scope.onlyImage : false;
            scope.width = scope.width ? scope.width : '';
            scope.height = scope.height ? scope.height : '';

            element.bind('dragover', true);
            element.bind('dragenter', true);

            element.bind('drop', function (event) {
                if (event != null) {
                    event.preventDefault();
                }

                if(!scope.enabled){
                    return;
                }

                var file = event.originalEvent.dataTransfer.files[0];

                controller.changeHandler(file);

                return false;
            });

            element.bind(SkConstants.EVENTS.FOCUS, function() {
                element.addClass('sk-focused');
            });

            element.bind(SkConstants.EVENTS.BLUR, function() {
                element.removeClass('sk-focused');
            });

            element.bind(SkConstants.EVENTS.KEY_DOWN, function(event) {
                if (event.which === SkConstants.KEY_CODE.SPACE) {
                    event.preventDefault();

                    $timeout(function() {
                        angular.element(element.find('input')[0]).trigger('click');
                    }, 0, false);

                }
            });

        }

    });

angular.module('snk.components.input')
    .controller('SkLoadingInputIndicatorController', ['$scope',
        function ($scope) {
           

        }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-rate-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento do texto no componente.
 *
 * @param {string} [sk-password=false]
 Determina se o componente será apresentado como um campo de senha
 *
 * @param {string} [sk-restrict]
    Informar a regex de aceitação de entradas de caracteres no campo. Por exemplo, caso deseje aceitar apenas números passe sk-restrict="[^0-9]".
 *
 * @example
     <example module="appRateInput">
         <file name="appRateInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = 0" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-rate-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-rate-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
            </div>
         </file>
         <file name="appRateInput.js">
            angular
                .module('appRateInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = 3;
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skLoadingInputIndicator', ['$timeout', 'StringUtils', 'UserAgentUtils',
function ($timeout, StringUtils, UserAgentUtils) {
    return {
        scope: {
            isLoading: '=skLoading'
        },
        template: '<span class="loading form-control-feedback" ng-show="isLoading"></span>',
        controller: 'SkLoadingInputIndicatorController',
        link: linkFn
    };

    function linkFn(scope, element, attr, ctrl) {
        
    }
}]);
/**
 * Created by leonardo.mendes on 18/11/2016.
 */
angular
    .module('snk.components.input')
    .controller('SkMaskedInputController', ['$scope', '$timeout', '$element', 'ObjectUtils', '$attrs',
function ($scope, $timeout, $element, ObjectUtils, $attrs) {
    var self = this;

    self.fieldValue = '';

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        fbFocusOut: focusOut,
        fbFocusIn: focusIn
    });

    $scope.changeHandler = changeHandler;
    $scope.getMask = getMask;
    $scope.valueOptions = $scope.valueOptions || {};
    
    function changeHandler() {
        if (self.useDataset($scope)) {
            $scope.$evalAsync(function(){
                $scope.dataset.notifyEditionStart(self);
                $scope.dataset.setModified(self);
            });
        }

        runOnChange();
    }

    function getMask() {
    	return $scope.mask;
        }

    function runOnChange() {
        checkFieldValue();

        if ($attrs.skChange) {
            $timeout(function(){
                $scope.onChange($scope);
            });
        }
    }

    function setData(data) {
    	if(!isNaN(data)){ // Só se for numero temos que verificar se o numero eh negativo
    		$scope.value = data > -1 ? data : ' ';
    	}else{
    		$scope.value = data;
    	}

        runOnChange();
    }

    function focusOut() {
        $timeout(function() {
            // Validacao necessaria para contornar erro da lib mask.min.js
            if ($element.children().length && self.fieldValue !== $element.children().val()) {
                $element.children().val(self.fieldValue);
            }
        });
    }

    function focusIn(){
        checkFieldValue();
    }

    function checkFieldValue(){
        // Controle necessario para contornar erro da lib mask.min.js
        if ($element.children().length) {
            self.fieldValue = $element.children().val();
        }    
    }
    
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-masked-input
 * @restrict E
 * @scope
 * @description
     Componente de texto com mascara.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento do texto no componente.
 *
 * @param {string} [sk-password=false]
 Determina se o componente será apresentado como um campo de senha
 *
 * @example
     <example module="appTextInput">
         <file name="appTextInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-masked-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled"
                        sk-mask="999.999.999-99">
                    </sk-masked-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appTextInput.js">
            angular
                .module('appTextInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = '';
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skMaskedInput', ['$timeout', 'StringUtils', 'UserAgentUtils',
function ($timeout, StringUtils, UserAgentUtils) {
    return {
        scope: {
            id: '@skId',
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            valueOptions: '=?skValueOptions',
            align: '@?skAlign',
            onChange: '&?skChange',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            placeholder: '@?skPlaceholder',
            onKeydown: '=?skKeydown',
            mask: '@skMask',
            size: '=?skSize',
            disableOnInsertion: '=skDisableOnInsertion',
            fillLeftFromRight: '=?skFillLeftFromRight',
            onEndEdit: '&skEndEdit',
            maskFunc: '=?skMaskFunc',
        },
        template: getTemplate,
        controller: 'SkMaskedInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template = '<input type="text" id="{{id}}" class="form-control" ng-model="value" ng-model-options="valueOptions" ng-attr-placeholder="{{placeholder}}" ng-disabled="!enabled" ng-required="required" ng-change="changeHandler()" ng-keydown="onKeydown($event)" {ngAttrUiMask} sk-default-char="{defaultChar}" allow-invalid-value {preventFillMask} {includeMask} {fillLeftFromRight} {style} {gridEditor} {autofocus} autautocomplete="off"/>';

        var templateArgs = {
            style: angular.isDefined(tAttrs.skAlign) ? 'ng-style="{\'text-align\': align}"' : '',
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
    		includeMask: angular.isDefined(tAttrs.skIncludeMask) ? 'sk-include-mask' : '',
            fillLeftFromRight: angular.isDefined(tAttrs.skFillLeftFromRight) ? 'sk-fill-left-from-right="fillLeftFromRight"' : '',
            autofocus: autofocus,
            preventFillMask: tAttrs.skPreventFillMask == 'true' ? 'sk-prevent-fill-mask="true"' : 'false',
            uiMask: angular.isDefined(tAttrs.skMaskFunc) ? 'ui-mask="{{maskFunc}}"' : 'ui-mask="{{mask}}"',
            ngAttrUiMask: angular.isDefined(tAttrs.skMaskFunc) ? 'ng-attr-ui-mask="{{maskFunc}}"' : 'ng-attr-ui-mask="{{mask}}"',
        };

        if(tAttrs.skDefaultChar){
            templateArgs['defaultChar'] = tAttrs.skDefaultChar;
        }

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;
        var inputElement = element.children()[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }
        
        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.setFocus = setFocus;
        ctrl.select = select;

        var $inputElement = angular.element(inputElement);

        attr.$observe('skRequired', function(newV) {
            var isRequired = scope.$eval(newV);
            element[isRequired ? 'addClass' : 'removeClass']('required');
        });

        $inputElement.bind('focus', function () {
            element.addClass('focused');
            (scope.onFocus || angular.noop)(scope);
        });

        $inputElement.bind('click', function () {
            if (isDatagrid()) {
                setFocus();
            } else if (!fullSelected) {
                select();
            }
        });

        $inputElement.bind('blur', function () {
            element.removeClass('focused');
            (scope.onFocusOut || angular.noop)(scope);
            fullSelected = false;
        });
        
        ctrl.setElement($inputElement);

        if (scope.size && UserAgentUtils.isSafari()){
            $inputElement.bind('keypress', function(evt){
                if (scope.value && scope.value.length >= scope.size){
                    var selStart = evt.target.selectionStart;
                    var selEnd = evt.target.selectionEnd;

                    return (selStart != selEnd);
                }

                return true;
            });
        }

        if (isDatagrid()) {
            setFocus();
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('skMultiComboController', ['$scope', 'ArrayUtils', 'ObjectUtils', '$element', '$document',
                function ($scope, ArrayUtils, ObjectUtils, $element, $document) {
        var self = this;        

        ObjectUtils.implements(self, FieldBinder, {
            scope: $scope,
            setData: setData,
            getData: getData
        });

        self.popoverListener = {
            onOpen : onPopoverOpen,
            onClose: onPopoverClose
        }

        self.onSelectionChanged = onSelectionChanged;
        self.fieldLbl;
        $scope.message = '';

        $scope.getListProps = getListProps;

        $scope.$watch('options',function(){
            onSelectionChanged();
        });

        $scope.$watch('value',function(){
            onValueChanged();
        });      

        init();

        function init(){
            if(!$scope.value){
                $scope.value = [];
            }

            if(!$scope.dataset && !$scope.options){
                throw new Error('[skMultiCombo] data set ou options precisa ser informado.');
            }

            if($scope.dataset && !$scope.fieldName){
                throw new Error('[skMultiCombo] quando dataset for informado, é necessário informar um skField.');
            }
    
            if($scope.dataset){
                var fMd = $scope.dataset.getFieldMetadata($scope.fieldName);
                $scope.options = fMd.options;
                self.fieldLbl = fMd.description;
            }
        }

        function getListProps(){
            return {
                     options: $scope.options,
                     fnSelectionChanged: self.onSelectionChanged
                   };
        }

        function onSelectionChanged(){
            $scope.value.length = 0;
            
            $scope.options.forEach(function(opt){                
                if(opt.selected){
                    $scope.value.push(opt.data);
                }
            });

            if (self.useDataset($scope)) {
                $scope.$evalAsync(function(){
                    $scope.dataset.notifyEditionStart(self);
                    $scope.dataset.setModified(self);
                });
            }

            var lblByFn;

            if($scope.labelFn){
                lblByFn = $scope.labelFn({items: $scope.value});
            }
            
            if(!lblByFn){
                $scope.message = ($scope.value.length + (self.fieldLbl ? (' - ' + self.fieldLbl) : '') + ' selecionados');
            }else{
                $scope.message = lblByFn;
            }
        }

        function onValueChanged(){
            unselectAllOptions();
            
            if($scope.value){
                $scope.value.forEach(function(val){
                    var opt = ArrayUtils.find($scope.options, function(item){
                        return item.data == val;
                    });
                    if(opt) {
                        opt.selected = true
                    };
                });
                
                if($scope.labelFn){
                    lblByFn = $scope.labelFn({items: $scope.value}); 
                }

                if(!lblByFn){
                    $scope.message = ($scope.value.length + (self.fieldLbl ? (' - ' + self.fieldLbl) : '') + ' selecionados'); 
                }else{
                    $scope.message = lblByFn; 
                }
            }
        }

        function unselectAllOptions(){
            if(!$scope.options){
                return;
            }
            $scope.options.forEach(function(opt){
                opt.selected = false;
            });
        }
        
        function getData(){
            if($scope.value){
                return $scope.value.join(',');
            }else{
                return undefined;
            }
            
        }

        function setData(data){
            if(data){
                $scope.value = data.split(',');
            }else{
                $scope.value = [];
            }
        }

        function onPopoverOpen(instance){
            adjustPopOver(instance.uid);
        }

        function adjustPopOver(uid){
            var popover = $document.find('#sk-popover-' + uid);
            var input = $element.find('.btn');
            if(popover && input){
                popover.css('width', input.css('width'));
            }
        }

        function onPopoverClose(){
            if($scope.onClose){
                $scope.onClose({items: $scope.value});
            }
        }
    }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-multi-combo
 * @restrict E
 * @scope
 * @description
    Este componente é um combobox capaz de fazer a seleção em mais de um item.
 * @param {object} sk-dataset Instância do dataset.
 * @param {boolean} sk-field-name Nome do campo no dataset que o componente irá armazenar a seleção e realizara a busca de opçoes nos metadados.
 * @param {object} [sk-value] variavel que armazenara os valores selecionados.
 * @param {object} sk-options um array de objetos contendo as opções a serem apresentadas no combo, exemplo: 
    [{
        data: 'A',
        value: 'Teste-1',
        selected: true
    },{
        data: 'B',
        value: 'Teste-2',
        selected: false
    }]
 * @param {boolean} [sk-enabled] define se o campo esta ativo.
 * @param {boolean} [sk-label-fn] função a ser chamada para definir o texto apresentado no input, exemplo:
 * function lblFn(items){
        if(items.length > 0){
            return items.length + ' status selecionados'
        }else{
            return 'Nenhum status selecionado';
        }        
    }
 * @param {boolean} [sk-on-close] função a ser chamada quando o popover de seleção do itens for fechado.
 * @example
     <example module="appMultiCombo">
         <file name="appMultiCombo.html">
            <div ng-controller="TesteController">
                <h3>Parâmetros</h3>
                <p>
                    <sk-multi-combo sk-value="vlr" sk-options="options" sk-label-fn="lblFn(items)" sk-on-close="closeFn(items)"></sk-multi-combo>
                    <div>Valores Selecionados: {{vlr}}</div>
                </p>
            </div>
         </file>
         <file name="appMultiCombo.js">
            angular
                .module('appMultiCombo', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){

                $scope.options = [{
                    data: 'A',
                    value: 'Opção 1',
                    selected: true
                },{
                    data: 'B',
                    value: 'Opção 2',
                    selected: false
                },{
                    data: 'C',
                    value: 'Opção 3'
                }];

                $scope.lblFn = function(items){
                    if(items.length > 0){
                        return items.length + ' status selecionados'
                    }else{
                        return 'Nenhum status selecionado';
                    } 
                }

                $scope.closeFn = function(items){
                    console.log('[multCombo] closed!', items);
                }
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skMultiCombo', ['$timeout', function ($timeout){
        return {
            scope: {
                dataset: '=?skDataset',
                fieldName: '@?skFieldName',
                value: '=?skValue',
                options: '=?skOptions',
                enabled: '=?skEnabled',
                labelFn: '&?skLabelFn',
                onClose: '&?skOnClose'
            },
            controller: 'skMultiComboController',
            controllerAs: 'ctrl',
            templateUrl: 'components/input/multicombo/multicombo.tpl.html',
            link: link
        };

        function link(scope, element, attrs) {
        }
}]);

angular
    .module('snk.components.input')
    .controller('skMultiComboListController', ['$scope',
                function ($scope) {
        var self = this;

        self.onChangeSelection = onChangeSelection;

        function onChangeSelection(){
            $scope.fnSelectionChanged();
        }

    }]);

angular
    .module('snk.components.input')
    .controller('SkNumberInputController', ['$scope', 'ObjectUtils', 'NumberUtils', 'AngularUtil', 'StringUtils', '$attrs',
        function ($scope, ObjectUtils, NumberUtils, AngularUtil, StringUtils, $attrs) {
            var self = this;
            var _ngModelCtrl;
            var _originalValue;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData,
                setNgModelCtrl: setNgModelCtrl,
                highlightField: highlightField,
                unHighlightField: unHighlightField
            });

            self.onBlur = onBlur;

            // Precisao ausente ou invalida (inclusive negativa) fica como "nao informada" em vez de virar zero, para o campo nao apagar a virgula digitada pelo usuario
            var parsedPrecision = parseInt($scope.precision);
            $scope.precision = (isNaN(parsedPrecision) || parsedPrecision < 0) ? undefined : parsedPrecision;
            $scope.prettyPrecision = parseInt($scope.prettyPrecision) ? parseInt($scope.prettyPrecision) : -1;

            $scope.$watchGroup(['precision', 'prettyPrecision'], function () {
                updateValues();
            });
            
            function onRmpChanged(reason, providerChange) {
                if(!$scope.ignoreRmPrecision){
                    const metaDatakey = $scope.dataset.getRowMetadataProperty($scope.fieldName, "rm_precision");
                    if (metaDatakey != undefined) {
                        let precision = $scope.dataset.getRowMetadata(undefined, metaDatakey);
                        if(typeof precision == 'number') {
                            $scope.precision = precision
                        }
                    }
                }
                if (angular.isDefined(_originalValue)) {
                    setData(_originalValue);
                }
            }
            
            $scope.$watch('dataset', function(newDataSet){
		        if (newDataSet) {
                    newDataSet.addRowMetaDataListener(onRmpChanged);
                    newDataSet.whenMetadataLoaded().then(() => {
                        onRmpChanged();
                    });
		        }
		    });

            $scope.changeHandler = changeHandler;

            function changeHandler() {
                if (self.useDataset($scope)) {
                    self.notifyChangeToDataset();
                }

                runOnChange();
            }

            function runOnChange() {
                AngularUtil.timeout(function() {
                    ($scope.onChange || angular.noop)($scope);
                });
            }

            function setData(data) {
                _originalValue = data;
                $scope.value = data;

                if (_ngModelCtrl) {
                    _ngModelCtrl.$viewValue = data;
                }

                updateValues(!$attrs.hasOwnProperty('skDatagridEditor'));

                runOnChange();
            }

            function getData() {
                return formatToModel();
            }

            function formatToView(value) {

                if (angular.isDefined(value) && ($scope.precision >= 0 && $scope.avoidFormatingConflicts) && !$scope.ignoredSelectFormat ) {
                    return NumberUtils.format(value, $scope.precision, $scope.prettyPrecision);
                }

                if (angular.isDefined(value) && ($scope.precision > 0) && !$scope.ignoredSelectFormat) {
                    return NumberUtils.format(value, $scope.precision, $scope.prettyPrecision);
                } else {
                    return value != null ? String(value) : value;
                }
            }

            function formatToModel() {
                if (!_ngModelCtrl || !angular.isDefined(_ngModelCtrl.$viewValue) || _ngModelCtrl.$viewValue == null) {
                    return undefined;
                }

                var modelValue = NumberUtils.stringToNumber(_ngModelCtrl.$viewValue);

                if (isNaN(modelValue)) {
                    return undefined;
                } else {
                    return modelValue;
                }
            }

            function onBlur() {
                updateValues(true);

                if ($scope.onFocusOut) {
                    $scope.onFocusOut($scope);
                }
            }

            function updateValues(formatViewValue = true) {
                if (!_ngModelCtrl) {
                    return;
                }

                var modelValue = formatToModel();

                var viewValue = undefined;

                if (angular.isDefined(modelValue)) {
                    if (!formatViewValue && NumberUtils.isFloat(modelValue)) {
                        formatViewValue = true;
                    }
                    viewValue = formatViewValue ? formatToView(modelValue) : String(modelValue);
                }

                $scope.value = modelValue;

                _ngModelCtrl.$setViewValue(viewValue);
                _ngModelCtrl.$viewValue = viewValue;

                _ngModelCtrl.$render();
            }

            function setNgModelCtrl(ngModelCtrl) {
                _ngModelCtrl = ngModelCtrl;

                if (angular.isDefined($scope.restrict) && StringUtils.isNotEmpty($scope.restrict)) {
                    AngularUtil.addRegexOnlyParser(_ngModelCtrl, $scope.restrict);
                }

                _ngModelCtrl.$formatters.push(function (value) {
                    return formatToView(value);
                });

                _ngModelCtrl.$parsers.push(function (value) {
                    if (angular.isString(value)) {
                        // So remove os separadores quando ha certeza de que o campo nao aceita casas decimais; na duvida, o que o usuario digitou e preservado
                        var transformed = NumberUtils.formatNumber(value, NumberUtils.getNumberOrDefault($scope.precision,  2) > 0);

                        if (transformed != value) {
                            value = transformed;
                            _ngModelCtrl.$setViewValue(transformed);
                            _ngModelCtrl.$render();
                        }
                    }

                    return value;
                });

                _ngModelCtrl.$parsers.push(function (value) {

                    if(angular.isUndefined(value) || value === '' || value === null) {
                        return undefined;
                    }

                    value = value.toString();
                    
                    var parts = value.split(/[.,]/);

                    if(parts.length > 2){
                        value = value.replace(/\./g, "");
                    }

                    var modelValue = NumberUtils.stringToNumber(value);

                    if (isNaN(modelValue)) {
                        return undefined;
                    } else {
                        return modelValue;
                    }
                });
            }

            function highlightField() {

            }

            function unHighlightField() {

            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-number-input
 * @restrict E
 * @scope
 * @description
     Componente de entrada numérico, com ou sem decimais.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @param {string} [sk-precision=undefined]
    Determina a quantidade de cadas decimais do componente.
 *
 * @param {string} [sk-pretty-precision=undefined]
    Determina a quantidade de cadas decimais significantes do componente.
 *
 * @param {string} [sk-password=false]
    Determina se o componente será apresentado como um campo de senha

 * @param {string} [sk-restrict]
    Informar a regex de aceitação de entradas de caracteres no campo. Por exemplo, caso deseje aceitar apenas números passe sk-restrict="[^0-9]".
 *
 * @example
     <example module="appNumberInput">
         <file name="appNumberInput.html">
            <div ng-controller="TesteController">
                <h3>Parâmetros</h3>
                <p>
                    precision:
                    <input type="number" ng-model="precision">
                    </input>
                </p>
                <p>
                    prettyPrecision:
                    <input type="number" ng-model="prettyPrecision">
                    </input>
                </p>

                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = undefined" class="btn btn-default">Limpar</button>
                </div>
                <h3>Resultado</h3>
                <div>
                    ViewValue:
                    <sk-number-input
                        sk-value="inputValue"
                        sk-precision="precision"
                        sk-pretty-precision="prettyPrecision"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-number-input>
                </div>
                <div>
                    ModelValue:
                    <span ng-bind="inputValue">
                    </span>
                </div>
            </div>
         </file>
         <file name="appNumberInput.js">
            angular
                .module('appNumberInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = '';
                $scope.precision = 3;
                $scope.prettyPrecision = 2;

                $scope.onChange = function () {
                  console.log($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skNumberInput', ['$timeout', 'StringUtils', 'NumberUtils',
function ($timeout, StringUtils, NumberUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            align: '@?skAlign',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            precision: '=?skPrecision',
            prettyPrecision: '=?skPrettyPrecision',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            disableOnInsertion: '=skDisableOnInsertion',
            size: '=skSize',
            style: '=?skStyle',
            restrict: '@?skRestrict',
            onEndEdit: '&skEndEdit',
            onKeyDown: '&?skKeydown',
            ignoreRmPrecision: '=?skIgnoreRmPrecision',
            avoidFormatingConflicts: '=?skAvoidFormatingConflicts',
        },
        template: getTemplate,
        controller: 'SkNumberInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var template = '<input type="{compType}" ng-style="style" class="form-control" ng-model="value" ng-keydown="onInputKeyDown($event)" ng-change="changeHandler()" ng-disabled="!enabled" style="text-align: right" maxlength="{{size}}" {gridEditor} {autofocus}/>';
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';

        tElem.removeAttr('autofocus');

        var templateArgs = {
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            autofocus: autofocus,
            compType: angular.isDefined(tAttrs.skPassword) ? 'password' : 'text'
        };

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;
        var inputElement = element.children()[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select() {
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        attr.$observe('skRequired', function(newV) {
            var isRequired = scope.$eval(newV);
            element[isRequired ? 'addClass' : 'removeClass']('required');
        });

        ctrl.setNgModelCtrl(ngModelCtrl);
        ctrl.setFocus = setFocus;
        ctrl.select   = select;

        angular.element(inputElement).bind('focus', function () {
            element.addClass('focused');
            (scope.onFocus || angular.noop)(scope);
        });

        angular.element(inputElement).bind('blur', function () {
            element.removeClass('focused');
            ctrl.onBlur();
            fullSelected = false;
        });

        angular.element(inputElement).bind('click', function () {
            if (isDatagrid()) {
                setFocus();
            } else if (!fullSelected) {
                select();
            }
        });

        ctrl.setElement(inputElement);
        
        if(angular.isDefined(attr.autofocus)){
        	setFocus();
        }

        if (isDatagrid()) {
            setFocus();
            
            var ignoredSelectFormat = attr.skIgnoredSelectFormat === 'true';
            if (ignoredSelectFormat) {
            	scope.ignoredSelectFormat = true;
            } else {
                scope.ignoredSelectFormat = false;
            }
        }

        scope.onInputKeyDown = function($event) {
            if (scope.onKeyDown) {
                scope.onKeyDown({$event: $event});
            }
        };
    }
}]);

angular
    .module('snk.components.input')
    .controller('SkNumericStepperController', ['$scope', '$attrs', 'ObjectUtils', 'NumberUtils', 'AngularUtil',
function ($scope, $attrs, ObjectUtils, NumberUtils, AngularUtil) {
    var self = this;
    var _ngModelCtrl;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        highlightField: highlightField,
        unHighlightField: unHighlightField
    });

    self.configElement = configElement;

    self.onBlur = onBlur;
    self.onFocusIn = onFocusIn;

    $scope.changeHandler = changeHandler;
    $scope.incValue = incValue;
    $scope.decValue = decValue;
    $scope.blurHandler = blurHandler;
    $scope.valueOptions = $scope.valueOptions || {};

    init();

    function init() {
        validMinMaxValues();
    }

    function incValue(){
        if ($scope.value != undefined){
            $scope.value = Number($scope.value) + 1;
        } else {
            $scope.value = 1;
        }

        validMaxValue();

        changeHandler();
    }

	function decValue(){
        if ($scope.value != undefined){
            $scope.value = Number($scope.value) - 1;
        } else {
            $scope.value = 0;
        }

        validMinValue();

        changeHandler();
    }

    function validMinMaxValues() {
        validMinValue();
        validMaxValue();
    }

    function validMinValue() {
        if (!$attrs.skMinValue) {
            return;
        }

        var minValue = NumberUtils.stringToNumber($attrs.skMinValue);
        var value = $scope.value;

        if (angular.isDefined(minValue) && value < minValue) {
            value = minValue;
        }

        if ($scope.value !== value) {
            $scope.value = value;
            changeHandler();
        }
    }

    function validMaxValue() {
        if (!$attrs.skMaxValue) {
            return;
        }

        var maxValue = NumberUtils.stringToNumber($attrs.skMaxValue);
        var value = $scope.value;

        if (angular.isDefined(maxValue) && value > maxValue) {
            value = maxValue;
        }

        if ($scope.value !== value) {
            $scope.value = value;
            changeHandler();
        }
    }

    function changeHandler() {
        if (self.useDataset($scope)) {
            $scope.dataset.notifyEditionStart(self);
            $scope.dataset.setModified(self);
        }

        runOnChange();
    }

    function blurHandler() {
        validMinMaxValues();
    }

    function runOnChange() {
        AngularUtil.timeout(function() {
            ($scope.onChange || angular.noop)($scope);
        }, 0, true);
    }

    function setData(data) {
        $scope.value = data;

        runOnChange();
    }

    function onFocusIn() {
        _ngModelCtrl.$render(true);
    }

    function onBlur() {
        if ($scope.onFocusOut){
            $scope.onFocusOut();
        }

        _ngModelCtrl.$render();
    }

    function configElement(ngModelCtrl, $element) {
        var maxLength = $scope.size || 5;

        if ($attrs.skPrefixChar){
            maxLength += ($attrs.skPrefixChar.length + 1);
        }

        if ($attrs.skSufixChar){
            maxLength += ($attrs.skSufixChar.length + 1);
        }

        $element.width(15 + (maxLength  * 6));

        _ngModelCtrl = ngModelCtrl;

        _ngModelCtrl.$render = function(avoidPutChar){
            var value = $scope.value || 0;

            if (!avoidPutChar) {
                if ($attrs.skPrefixChar) {
                    value = $attrs.skPrefixChar + ' ' + value;
                }

                if ($attrs.skSufixChar) {
                    value = value + ' ' + $attrs.skSufixChar;
                }
            }

            $element.val(value);
        };

        _ngModelCtrl.$parsers.push(function (value) {
            if (angular.isString(value)){
                var transformed = Number(NumberUtils.formatNumber(value));

                if (transformed != value){
                    value = transformed;
                    _ngModelCtrl.$setViewValue(transformed);
                    _ngModelCtrl.$render();
                } else {
                    return transformed;
                }
            }

            return value;
        });
    }

    function highlightField(){

    }

    function unHighlightField(){

    }
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-numeric-stepper
 * @restrict E
 * @scope
 * @description
     Componente de entrada numérico, com ou sem decimais.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @param {string} [sk-pretty-precision=undefined]
    Determina a quantidade de cadas decimais significantes do componente.
 *
 * @example
     <example module="appNumberInput">
         <file name="appNumberInput.html">
            <div ng-controller="TesteController">
                <h3>Parâmetros</h3>
                <p>
                    precision:
                    <input type="number" ng-model="precision">
                    </input>
                </p>
                <p>
                    prettyPrecision:
                    <input type="number" ng-model="prettyPrecision">
                    </input>
                </p>

                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = undefined" class="btn btn-default">Limpar</button>
                </div>
                <h3>Resultado</h3>
                <div>
                    ViewValue:
                    <sk-numberic-stepper
                        sk-value="inputValue"
                        sk-pretty-precision="prettyPrecision"
                        sk-change="onChange"
                        sk-enabled="enabled">
                    </sk-numberic-stepper>
                </div>
                <div>
                    ModelValue:
                    <span ng-bind="inputValue">
                    </span>
                </div>
            </div>
         </file>
         <file name="appNumberInput.js">
            angular
                .module('appNumberInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = '';
                $scope.precision = 3;
                $scope.prettyPrecision = 2;
                $scope.log = [];

                $scope.onChange = function (event, newValue) {
                  $scope.log.push(newValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skNumericStepper', ['$timeout', 'StringUtils', 'NumberUtils',
function ($timeout, StringUtils, NumberUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            align: '@?skAlign',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '=?skFocusOut',
            precision: '=?skPrecision',
            prettyPrecision: '=?skPrettyPrecision',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            disableOnInsertion: '=skDisableOnInsertion',
            size: '=skSize',
            valueOptions: '=?skValueOptions'
        },
        template: getTemplate,
        controller: 'SkNumericStepperController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var template =  '<div class="numberic-stepper-container" layout="{layout}" layout-align="{layoutAlign}">' +
                            '<button class="btn btn-default btn-minus" ng-disabled="!enabled" ng-click="decValue()" tabindex="-1"><sk-icon font-icon="minus"></sk-icon></button>' +
                            '<input type="text" class="form-control" ng-model-options="valueOptions" ng-model="value" ng-change="changeHandler()" ng-disabled="!enabled" ng-blur="blurHandler()" maxlength="{{size}}" {gridEditor} {autofocus}/>' +
                            '<button class="btn btn-default btn-plus" ng-disabled="!enabled" ng-click="incValue()" tabindex="-1"><sk-icon font-icon="plus"></sk-icon></button>' +
                        '</div>';

        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var layout = angular.isDefined(tAttrs.layout) ? tAttrs.layout : 'row';
        var layoutAlign = angular.isDefined(tAttrs.layoutAlign) ? tAttrs.layoutAlign : 'start end';

        tElem.removeAttr('autofocus');

        var templateArgs = {
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            autofocus: autofocus,
            layout: layout,
            layoutAlign: layoutAlign
        };

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;
        var inputElement = element.children()[0].children[1];
        var $element = angular.element(inputElement);
        var ngModelCtrl = $element.data('$ngModelController');

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.configElement(ngModelCtrl, $element);
        ctrl.setFocus = setFocus;
        ctrl.select   = select;

        angular.element(inputElement).bind('focus', function () {
            element.addClass('focus');
            ctrl.onFocusIn();
        });

        angular.element(inputElement).bind('click', function () {
            if (isDatagrid()) {
                setFocus();
            } else if (!fullSelected) {
                select();
            }
        });

        angular.element(inputElement).bind('blur', function () {
            element.removeClass('focus');
            ctrl.onBlur();
            fullSelected = false;
        });

        if (isDatagrid()) {
            setFocus();

            inputElement.select();
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select() {
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkPesquisaInputController', ['$scope', '$element', '$attrs', 'ServiceProxy', 'ObjectUtils', 'StringUtils', '$q', '$timeout', 'SkPesquisaService', 'SkI18nService', 'AngularUtil', 'DatasetUtils', '$translate', 'Criteria', 'SkConstants', 'ArrayUtils', 'MGEParameters',
    function ($scope, $element, $attrs, ServiceProxy, ObjectUtils, StringUtils, $q, $timeout, SkPesquisaService, SkI18nService, AngularUtil, DatasetUtils, $translate, Criteria, SkConstants, ArrayUtils, MGEParameters) {
    var self = this;
    
    var lastLoadedPk = undefined;
    var lastLoadedPkField = undefined;
    var _changeByUser = false;
    var _descriptionProxy;
    var _loadPromise;
    var _oldValue;
    var _loadDescriptionOnChange;
    var _optionsChanged;
    var _isKeyEnter = false;

    let _programaticalyEntityChange = false;
    
    $scope.pesquisaInputApi = self;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        getData: getData
    });

    self.observerActivated = false;
    self.descriptionLoaded = false;

    self.loadDescription = loadDescription;
    self.getTargetDescriptionFieldName = getTargetDescriptionFieldName;
    self.getDescriptionValue = getDescriptionValue;
    self.setCodeValue = setCodeValue;
    self.setDescriptionValue = setDescriptionValue;

    $scope.showDescriptionInput = angular.isUndefined($scope.showDescriptionInput) ? true : StringUtils.toBoolean($scope.showDescriptionInput);
    $scope.codeInputEnabled = angular.isUndefined($scope.codeInputEnabled) ? true : StringUtils.toBoolean($scope.codeInputEnabled);
    $scope.enabled = angular.isUndefined($scope.enabled) ? true : StringUtils.toBoolean($scope.enabled);

    $scope.searching = false;
    $scope.changeHandler = changeHandler;
    $scope.loadSuggestions = loadSuggestions;
    $scope.onSelectEntity = onSelectEntity;
    $scope.showMoreResults = showMoreResults;
    $scope.onBeforeChangeCode = onBeforeChangeCode;
    $scope.onChangeCode = onChangeCode;
    $scope.openPesquisaPopUp = openPesquisaPopUp;
    $scope.onCodeInputFocusOut = onCodeInputFocusOut;
    $scope.onFocusOutDescriptionInput = onFocusOutDescriptionInput;
    $scope.onCodeInputFocus = onCodeInputFocus;
    $scope.onCodeKeyDown = onCodeKeyDown;
    $scope.onlySearch = angular.isUndefined($scope.onlySearch) ? false : $scope.onlySearch;
    $scope.isCodeEnabled = isCodeEnabled;
    $scope.isNumberCode = isNumberCode;
    $scope.isDecimalCode = isDecimalCode;
    $scope.onKeyPress = onKeyPress;
    
    $scope.textInputTitle = SkI18nService.instant("PesquisaInput.titleCampoCodigo");
    $scope.typeaheadTitle = SkI18nService.instant("PesquisaInput.titleCampoDescricao");
    
    $scope.notifyDescriptionChangeToDataSet = $scope.notifyDescriptionChangeToDataSet == undefined ? true : $scope.notifyDescriptionChangeToDataSet;
    
    $scope.closeModal = closeModal;
    
    if($attrs.skDataset){
        $scope.$watch('dataset', init);
    }else{
        init();
    }
    
    function init() {
        $scope.api = self;

        if (self.useDataset()){
            $scope.dataset.whenMetadataLoaded().then(function(){
                var fieldMD = $scope.dataset.getFieldMetadata(self.getFieldName());
                
                var descriptionFieldName = $scope.descriptionFieldName || ObjectUtils.getProperty(fieldMD, 'fk.descriptionFieldName');
                
                if (descriptionFieldName) {
                    $scope.dataset.makeFieldNonRequired(descriptionFieldName);

                    function Proxy() {
                        var proxyScope = $scope.$new();
                        proxyScope.fieldName = descriptionFieldName;
                        proxyScope.dataset = $scope.dataset;

                        var proxyProperties = {
                            'scope': proxyScope,
                            'setData': function(newValue){
                                AngularUtil.apply($scope, function() {
                                    if($scope.notifyDescriptionChangeToDataSet){
                                    	$scope.descriptionValue = newValue;
                                    }
                                });
                            },
                            'getData': function() {
                                return $scope.descriptionValue;
                            }
                        };

                        ObjectUtils.implements(this, FieldBinder, proxyProperties);
                    }

                    _descriptionProxy = new Proxy();
                } else {
                   if(StringUtils.isNotEmpty($scope.targetDescriptionFieldName)){
					   $scope.notifyDescriptionChangeToDataSet = false;
					   setHasDescriptionInput(true);
				   }else{
				   	   setHasDescriptionInput(false);
				   }
                }
            });

          $scope.dataset.addLineChangeListener(function() {
             _loadPromise = undefined;
          });
        } else if (!$scope.showDescriptionInput) {
            setHasDescriptionInput(false);
        }

        var initialLoad = true;
        
        $scope.$watch('codeValue', function(newValue, oldValue){

			_oldValue = oldValue;
	
            if (angular.equals(newValue, oldValue)) {
                return;
            } else if (_changeByUser) {
                initialLoad = false;
                return;
            }

            if (StringUtils.isNotEmpty(newValue) && StringUtils.isNotEmpty(oldValue)) {
                self.descriptionLoaded = false;
            }

            if (!self.useDataset() && StringUtils.isNotEmpty(newValue) && initialLoad) {
            	loadDescription(angular.isUndefined($scope.codeValue));
            } else if (!self.useDataset() && StringUtils.isNotEmpty(newValue)){
                loadDescription(angular.isUndefined($scope.codeValue));
            } else if (self.useDataset() && !$scope.notifyDescriptionChangeToDataSet) {
                $timeout(function(){
                    lastLoadedPk = undefined;
                    loadDescription(angular.isUndefined($scope.codeValue));
                });                
            } else if (StringUtils.isEmpty(newValue)) {
            	clearValues(false, false);
                runOnChange(true);
                onEntityChange();
            }

            _changeByUser = false;
            initialLoad = false;
        });
        

        loadDescription(angular.isUndefined($scope.codeValue));

        if(angular.isFunction($scope.onCreated)){
            $scope.onCreated({ pesquisaApi: self });
        }
        
    }


    function isNumberCode(){
        return angular.isUndefined($scope.dataType) || $scope.dataType == 'I';
    }

    function isDecimalCode(){
        return angular.isUndefined($scope.dataType) || $scope.dataType == 'F';
    }

    function onCodeKeyDown($event) {
        if ($attrs.skDatagridEditor == 'true') {
            return;
        }

        // Ctrl + Alt + T
	    // Atalho criado para o cursor do mouse focar no campo Descrição
        if($event.ctrlKey && $event.altKey && $event.keyCode == 84){
            var inputTypeaHead = ($element[0].querySelector('sk-typeahead-input'));
            var inputDescription = angular.element(inputTypeaHead)[0].firstElementChild;
            inputDescription.focus();
        }

        if($scope.useTabLikeEnter && SkConstants.KEY_CODE.TAB == $event.keyCode){
            const elementIsInDatagrid = angular.element($element[0]).hasClass("sk-grid-editor");

            if(_changeByUser ||  (elementIsInDatagrid && (!angular.isUndefined($scope.codeValue)))) {
                 loadDescription();
             } 
        }

        switch ($event.keyCode) {
            case SkConstants.KEY_CODE.ENTER:
                const elementIsInDatagrid = angular.element($element[0]).hasClass("sk-grid-editor");
                let datasetIndex;

                if(_changeByUser ||  (elementIsInDatagrid && (!angular.isUndefined($scope.codeValue)))) {
                    _isKeyEnter = true;
                    
                    if (self.useDataset()) {
                        datasetIndex = $scope.dataset.getCurrentIndex();
                    }

                    loadDescription(null, null, null, null, datasetIndex);
                } else {
                    openPesquisaPopUp();
                }

                if (angular.isUndefined($scope.codeValue)) {
                    $event.stopPropagation();
                }

                $event.preventDefault();
            break;

            case SkConstants.KEY_CODE.DOWN_ARROW:
                if ($event.altKey || $event.ctrlKey) {
                    openPesquisaPopUp();
                    $event.preventDefault();
                }
                break;
        }
    }


    function onKeyPress($event){
        if (!isDecimalCode() && isNumberCode() && isNaN(Number($event.key)) && !($event.charCode == 0 || $event.ctrlKey === true)) {
            $event.preventDefault();
        }
    }

    function setHasDescriptionInput(val) {
        $scope.showDescriptionInput = val;
        $element[val ? 'removeClass' : 'addClass']('no-description');
    }

    function isCodeEnabled(){
        return $scope.codeInputEnabled && $scope.enabled;
    }

    function openPesquisaPopUp(descriptionValue, loadOnCreate){
        if (!$scope.enabled) {
            return;
        }

        if (angular.isFunction($scope.clickHandler)) {
        	$scope.clickHandler();
        }else {

            var label = ($scope.options && $scope.options.relationName)? $scope.options.relationName : $scope.relationShipDescription;
	        
			var options = getSearchOptions({
	            loadOnCreate: loadOnCreate,
	            label: label,
	            resourceIdCadastro: $scope.resourceIdCadastro,
	            criteria: buildCriteria(true),
	            enviromentCriteria: $scope.enviromentCriteria,
	            enableRowsCounter: true,
	            loadTopBar: $scope.loadTopBar,
	            allowShowHierarchicalMode: $scope.allowShowHierarchicalMode,
	            fieldName: $scope.targetField || $scope.fieldName,
	            useDescriptionOptions: $scope.useDescriptionOptions || false,
                onlyPresentation:$scope.onlyPresentation,
                showInactives: $scope.showInactives
	        });
	        
            if($attrs.skModalId){
                options.modalId = $attrs.skModalId;
            }
            
            if ($scope.somenteAnalitico) {
                options.somenteAnalitico = $scope.somenteAnalitico;
            }
	        
	        var entityName = $scope.entityName;
	        if (angular.isUndefined(entityName) && self.useDataset()){
	        	entityName = $scope.dataset.getEntityName();
	        }
	
            loadEntityDescription(options.localEntityName, $scope.entityName, function (){
                   
            	ajustaLabelPainelPesquisa(options, label, entityName);
  
		        SkPesquisaService.openPesquisaPopUp(entityName, descriptionValue, options)
		            .then(onSelectEntity);
            });
        } 
    }
    
    /**
     * Ajuste label painel de pesquisa -> Procurando por 'Descricao'
     * @param {*} options 
     * @param {*} label 
     * @param {*} entityName 
     */
    function ajustaLabelPainelPesquisa(options, label, entityName) {
        // Da preferencia para a atualizada utilizando o servico getInstanceDescription
        options.label = $scope.label;

        if (StringUtils.isEmpty(options.label)) {
            options.label = label; // Utiliza a informada 
        }

        if (StringUtils.isEmpty(options.label)) {
            options.label = entityName; // Utiliza o proprio nome da entidade 
        }
    }

    function getSearchOptions(options) {
        var defOptions = {
            pkFieldName: useLocalFieldName() ? getTargetField() : undefined,
            descriptionFieldName: $scope.targetDescriptionFieldName
        };

        if ($attrs.hasOwnProperty('skShowFinderError')) {
            defOptions.showFinderError = $scope.showFinderError;
        }
        
        if ($attrs.hasOwnProperty('skShowInactives')) {
            defOptions.showInactives = $scope.showInactives;
        }
        
        if($scope.options && $scope.options.originalEntityName){
            defOptions['localEntityName'] = $scope.options.originalEntityName;
        }else if (self.useDataset() && !$scope.dataset.isStandAlone()){
            defOptions['localEntityName'] = $scope.dataset.getEntityName();
        } else if ($scope.localEntityName) {
            defOptions['localEntityName'] = $scope.localEntityName;
        }

        if($scope.options) {
        	angular.extend(defOptions, $scope.options);
        	
            defOptions.entityName = $scope.options.entityName;
            defOptions.fieldName = $scope.options.fieldName;
            defOptions.relationName = $scope.options.relationName;
            defOptions.ignoreEntityCriteria = $scope.options.ignoreEntityCriteria;
            defOptions.listener = $scope.options.listener;
            defOptions.limit = $scope.options.limit;

            if($scope.options.hasOwnProperty('overwriteNextShowInactives')){
                defOptions.showInactives = $scope.options.overwriteNextShowInactives;

                delete $scope.options.overwriteNextShowInactives;
            }else if ($scope.options.showInactives){
                defOptions.showInactives = $scope.options.showInactives;
            }
        }

        return options ? angular.extend(defOptions, options) : defOptions;
    }

    function getTargetField() {
        return $scope.targetField || self.getFieldName();
    }

    function useLocalFieldName() {
        return $scope.useLocalFieldName || (self.useDataset() && $scope.dependentFields && $scope.dependentFields.length > 0);
    }

    function onSelectEntity(item){
        validateSelectedItens(item.data);

        $scope.codeValue = item.key;
        $scope.descriptionValue = item.label;
        lastLoadedPk = item.key;
        lastLoadedPkField = item.pkField;
        
        
        if (item.data && !item.fields) {
        	item.fields = item.data;
        }

        onEntityChange(item);

        changeHandler(true);
    }

    function validateSelectedItens(data) {
        if($scope.somenteAnalitico && !(data.ANALITICO == 'S' || data.ANALITICA == 'S')) {
            clearValues();
            throw new Error($translate.instant('DWF.Pesquisa.messageRegistroInvalido'));
        }
    }

    function showMoreResults(){
        openPesquisaPopUp($scope.descriptionValue, true);
    }

    function onCodeInputFocusOut(){
        self.finishedEdition($scope.codeValue, _oldValue);

        if (angular.isDefined($scope.codeValue) && angular.isDefined(_oldValue) && 
            angular.equals($scope.codeValue.toString(), _oldValue.toString())) {
            return;
        }

        self.descriptionLoaded = true;

        let datasetIndex;
        if (self.useDataset()) {
            datasetIndex = $scope.dataset.getCurrentIndex();
        }

        $scope.$evalAsync(function(){
            const elementIsInDatagrid = angular.element($element[0]).hasClass("sk-grid-editor");
            if(_isKeyEnter) {
                _isKeyEnter = false;
                
                if(elementIsInDatagrid) return;
            }
            
            loadDescription(false, false, null, true, datasetIndex);
        });

        if (angular.isFunction($scope.onFocusOut)){
            $scope.onFocusOut($scope);
        }

        if(self.useDataset() && !$scope.onlySearch){
            self.onFocusout();
        }

        _changeByUser = false;
    }

    function onFocusOutDescriptionInput(){
        self.finishedEdition($scope.codeValue, _oldValue);
		onCodeInputFocusOut();
		_oldValue=$scope.codeValue;
    }

    function onCodeInputFocus(){
        if(self.useDataset() && !$scope.dataset.isInsertionMode()){
            _oldValue = $scope.codeValue;
        }

        if (angular.isFunction($scope.onFocus)){
            $scope.onFocus();
        }
    }

    function onChangeCode(){
        if($scope.loadDescriptionOnChange) {
            if(_loadDescriptionOnChange) {
                $timeout.cancel(_loadDescriptionOnChange);
                _loadDescriptionOnChange = $timeout(function(){
                    loadDescription(false);
                }, 300);
            }
        }
        $timeout(function(){
            changeHandler();
        }, 0);
    }

    function onBeforeChangeCode(value) {
        _changeByUser = true;
    }

    function changeHandler() {
        if (self.useDataset() && !$scope.onlySearch){
            if($scope.options?.isEnd){
            	self.notifyChangeToDataset(true);
            } else {
				self.notifyChangeToDataset(false);
			}

            if (_descriptionProxy && $scope.notifyDescriptionChangeToDataSet) {
                _descriptionProxy.notifyChangeToDataset();
            }
        }

        if(self.useDataset() && $scope.onlySearch){
            searchLineOnChange();
        }

        runOnChange();
    }

    function onEntityChange(item) {
        $timeout(function(){
            var result = ($scope.onEntityChange || angular.noop)({item: item, programmatically: _programaticalyEntityChange});            
            _programaticalyEntityChange = false;
            if (angular.isFunction(result)) {
                result(item);
            }
        }, 0, false);
    }

    function runOnChange(programmatically = false) {
        $scope.hasProgrammatically = !!programmatically;
        $timeout(function(){
            ($scope.onChange || angular.noop)($scope);
        }, 0, false);
    }

    function setData(data, options) {
        $scope.codeValue = data;

        self.descriptionLoaded = false;
        _optionsChanged = options;
        controlDescription(options);

        lastLoadedPk = data;

        runOnChange(data);
    }

    function controlDescription(options, forceLoad) {
        const elementAux = $element && $element[0];

        // Valida se o carregamento é automático, se o campo está renderizado na tela e se já carregou a descrição
        if (options && options.programmatically && hasCodeValue() && !$attrs.hasOwnProperty('aggrid') && 
            elementAux && elementAux.clientHeight > 0 && !self.descriptionLoaded && !_changeByUser) {

            self.descriptionLoaded = true;
            loadDescription(false, true, undefined, forceLoad);

        // Valida se o campo possui valor, se o campo não está renderizado na tela e se já carregou a descrição
        } else if (hasCodeValue() && elementAux && !elementAux.clientHeight && !self.descriptionLoaded && !_changeByUser) {

            $timeout(controlFieldChanged, 2000, false);
        
        // Valida se o campo já possui o observer ativado em seu carregamento
        } else {
            setFieldObserver(elementAux);
        }
    }

    function controlFieldChanged() {
        const optionsAux = {
            programmatically: (self.useDataset() && $scope.dataset.isInsertionMode()) 
                || (!self.descriptionLoaded && angular.isUndefined($scope.descriptionValue) && $scope.showDescriptionInput)
                || !self.useDataset()
        };

        let forceLoad = true;

        if(self.useDataset() && $scope.dataset.isCopyingRecord()){
           forceLoad = false;
        }

        controlDescription(_optionsChanged || optionsAux, forceLoad);
    }

    function setFieldObserver(elementAux) {
        if (elementAux && angular.isFunction(MutationObserver) && !self.observerActivated) {
            self.observerActivated = true;
    
            const config = {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            };
    
            const callback = function (mutationsList) {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'attributes' && hasCodeValue() && !self.descriptionLoaded && !_changeByUser) {
                        controlFieldChanged();
                    }
                }
            };
    
            const observer = new MutationObserver(callback);
            observer.observe(elementAux, config);
        }
    }

    function hasCodeValue() {
        return angular.isDefined(StringUtils.emptyAsNull($scope.codeValue));
    }

    function getData(options){
        if(_loadPromise && ObjectUtils.getProperty(options,'acceptPromise')) {
            return _loadPromise.promise;
        }
        return $scope.codeValue;
    }

    function clearValues(initialLoad, updateDs){
        $scope.codeValue = undefined;
        $scope.descriptionValue = undefined;
        $scope.entity = undefined;
        lastLoadedPk = undefined;
        _changeByUser = false;

        if ((!updateDs === false) && !initialLoad && self.useDataset() && ($scope.dataset.getCurrentIndex() > -1 || $scope.dataset.isInsertionMode() || $scope.dataset.isEditMode()) && !$scope.onlySearch){
            $scope.dataset.setFieldValue(self.getFieldName(), undefined);
        }
    }

    function loadSuggestions(value){
        if (StringUtils.isEmpty(value)){
            clearValues();
            return [];
        }

        var deferred = $q.defer();

        try {
            var options = getSearchOptions();
            var criteria = buildCriteria();

            $scope.searching = true;

            SkPesquisaService.loadSuggestions($scope.entityName, value, true, 5, criteria, options)
                .then(function(entity){

                    $scope.entity = entity;

                    $scope.hasMoreResults = entity.hasMore;

                    var options = entity.data.map(function(item){
                        var option = {
                            key : item[useLocalFieldName() ? getTargetField() : entity.pkField],
                            label: item[entity.descriptionField],

                            entityName: $scope.entityName,
                            pkField: entity.pkField,
                            descriptionField: entity.descriptionField,
                            entityDescription: entity.entityDescription,
                            hasImage: item.__hasImage,
                            isFavorite: item.__isFavorite,
                            imageField: entity.imageField,
                            data: item,
                            fieldsMetadata: entity.fieldsMetadata,
                            resourceID: entity.resourceID
                        };

                        return option;
                    });

                    deferred.resolve(options);
                }, function(error){
                    deferred.reject(error);
                }).finally(function(){
                    $scope.searching = false;
                });
        } catch (e){
            $scope.searching = false;

            if (e instanceof CriteriaError || e instanceof TypeError){
                throw e;
            }

            deferred.reject(e.message);
        }

        return deferred.promise;
    }

    function buildCriteria(avoidEnviromentCriteria){
        var criteria;

        if ($scope.dependentFields && self.useDataset()){
            criteria = DatasetUtils.buildDependentFieldsCriteria($scope.dependentFields, $scope.dataset);
        }

        if($scope.formCriteria){
            if (!criteria){
                criteria = Criteria($scope.formCriteria);
            } else {
                criteria.and($scope.formCriteria);
            }

            var formParams = $scope.formCriteria.match(/form\.@?\w+/g);

            if (formParams && self.useDataset()){
                formParams.forEach(function(formParam){
                    var required  = formParam.indexOf('@') < 0;
                    var fieldName = formParam.replace(/form\.@?/, '');

                    criteria.addParameter(DatasetUtils.getCriteriaParameterFromDataset($scope.dataset, fieldName, required));
                    criteria.replaceOnExpression(formParam, '?');
                });
            }
        }

        if (!(avoidEnviromentCriteria === true) && $scope.enviromentCriteria){
            var envCriteria = $scope.enviromentCriteria();

            if (envCriteria && envCriteria.getExpression()) {
                ObjectUtils.isImplementorOf(envCriteria, Criteria);

                if (!criteria){
                    criteria = Criteria(envCriteria.getExpression(), envCriteria.getParameters());
                } else {
                    criteria.and(envCriteria.getExpression(), envCriteria.getParameters());
                }
            }
        }

        return criteria;
    }

    function loadDescription(initialLoad, programmatically, code, forceLoad, datasetIndex){
        const elementAux = $element && $element[0];
        if ((!elementAux || !elementAux.clientHeight) && !$attrs.hasOwnProperty('aggrid')) {
            if (!self.useDataset()) {
                setFieldObserver(elementAux);
            }
            if(angular.isUndefined($scope.loadDescriptionWithoutBeingVisible) || !$scope.loadDescriptionWithoutBeingVisible) {
	            return;
            }
        }

        var newValue = angular.isDefined(code) ? code : $scope.codeValue;
        if($scope.standaloneMode && !$scope.forceLoadDescription){
    		return;
    	}

        if (StringUtils.isEmpty(newValue)){
            clearValues(initialLoad);

            if (!initialLoad && (newValue !== lastLoadedPk)){
                onEntityChange();
            }
            return;
        } else if (lastLoadedPk == newValue && !forceLoad && !$scope.forceLoadDescription){
            return;
        }

        if ($scope.enableLookup == false) {
            lastLoadedPk = $scope.codeValue;
            onEntityChange({
                data: $scope.codeValue,
                programmatically: programmatically
            });

            return;
        }

        var options = getSearchOptions({fieldName: $scope.targetField || $scope.fieldName, showInactives: $scope.showInactives || $scope?.options?.showInactives});

        try {
            var criteria = buildCriteria();

            $scope.searching = true;
            _loadPromise = $q.defer();

            AngularUtil.timeoutPromise(_loadPromise, 15000);

            SkPesquisaService.loadSuggestionsByPk($scope.entityName, newValue, undefined, criteria, options)
                .then(function(entity){

                    /**
                     * Se o input de pesquisa estiver no datagrid e o dataset mudar o index,
                     * por este service ser assíncrono, ele é retornado após a alteração do index,
                     * logo, o código abaixo irá alterar o index selecionado no dataset incorretamente,
                     * desta forma, é necessário abortá-lo se a condição abaixo for positiva
                     */
                    if (self.useDataset() 
                    && datasetIndex !== $scope.dataset.getCurrentIndex() 
                    && $attrs.hasOwnProperty('aggrid')) {
                        return;
                    }

                    $scope.entity = entity;

                    var entityData = entity.data[0];
                    var allFields = entity.data[0];

                    if (entityData && !(programmatically === true)) {
                        validateSelectedItens(entity.data[0]);
                    }

                    if (entityData) {

                        if(entity.allPks && entity.allPks.length == 2){
                            initialLoad = true;
                        }
                        
                        lastLoadedPk = entity.data[0][entity.pkField];
                        
                        $scope.codeValue = lastLoadedPk;
                        var fieldNameDescription = entity.fieldsMetadata?.find(field => field.isDescriptionField)?.fieldName;
                        $scope.descriptionValue = entity.data[0][entity.descriptionField] || entity.data[0][fieldNameDescription];
                        
                    } else {
                        lastLoadedPk = $scope.codeValue;
                        $scope.descriptionValue = '';
                    }

                    if($scope.saveDescriptionFieldToDataSet && StringUtils.isNotEmpty(options.descriptionFieldName)){
                        // Quando utilizamos o dataset somente para criar dados e posteriormente salva-los em outro momento essa informação não fica armazenada no dataset,
                        // a descricao e sempre carregada do servidor no momento de salvar, e nesse cenario não vamos no servidor ao salvar e em modo grade o campo fica sem valor.
                        $scope.dataset.setFieldValue(options.relationName + '.' + options.descriptionFieldName, $scope.descriptionValue, false);
                    }

                    if (!initialLoad){
                        changeHandler(true);
                    }

                    var key;
                    
                    if (entityData) {
                        entityData = entityData[(options && options.pkFieldName) || entity.pkField];
                    } else {
                        key = $scope.codeValue;
                    }

                    _changeByUser = false;

                    onEntityChange({
                        pkField: (options && options.pkFieldName) || entity.pkField,
                        key: key,
                        label: $scope.descriptionValue,
                        data: entityData,
                        fields: allFields,
                        programmatically: programmatically
                    });

                    if (_loadPromise) {
                      _loadPromise.resolve($scope.codeValue);
                    }
                }, function(){
                    clearValues(false, true);
                    if(_loadPromise !== undefined){
                        _loadPromise.reject();
                    }
                    
                }).finally(function(){
                    $scope.searching = false;
                    _loadPromise = undefined;
                });

        } catch (e){
            $scope.searching = false;
            _loadPromise = undefined;

            clearValues();

            if (e instanceof CriteriaError || e instanceof TypeError){
                throw e;
            }
        }
    }

    function loadEntityDescription(localEntityName, entityName, callback){

        var param = {
            "entityName": entityName
        }

        if(localEntityName){
            param.baseEntityName = localEntityName;
        }

        ServiceProxy.callService('mge@SystemUtilsSP.getInstanceDescription', {param: param})
            .then(function(result){
                $scope.label = result.responseBody.entity.description;
                if(callback){
                    callback();
                }
            });    
    }

    function closeModal(){
        SkPesquisaService.closeModal();
    }
    
    function getTargetDescriptionFieldName(){
    	if($scope.descriptionValue) return $scope.descriptionValue;
    	return null;
    }

    function getDescriptionValue(){
        return angular.copy($scope.descriptionValue);
    }

    function setCodeValue(newV){
        _programaticalyEntityChange = true;
        $scope.codeValue = newV;
    }

    function setDescriptionValue(description){
        $scope.descriptionValue = description;
    }

    function searchLineOnChange(){
        var pkField = angular.isDefined(lastLoadedPkField) ? lastLoadedPkField : $scope.fieldName;
        if(angular.isDefined(pkField)){
            var oldIndex = $scope.dataset.getCurrentIndex();

            var newIndex = ArrayUtils.findIndex($scope.dataset.getRecordsAsObject(), function (obj) {
                var value = ObjectUtils.getProperty(obj, pkField);
                return $scope.codeValue == value;
            });
    
            if(newIndex > -1 && newIndex != oldIndex){
                $scope.dataset.gotoRow(newIndex);
            }
        }
    }

}]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-pesquisa-input
 * @restrict E
 * @scope
 * @description
     Componente de seleção de data e hora.
    Internamente é o componente de data e o de hora alinhados verticalmente.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-entity-name]
    Nome da entidade que será pesquisada.
 * 
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Ýndice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {function} [sk-entity-change=undefined]
 * 	Função que é chamada ao executar uma mudança de registro carregada na pesquisa.
 * 
 * @param {function} [sk-enviroment-criteria=undefined]
 * 	Função de adição de um criterio a pesquisa.

 * @param {function} [sk-show-finder-error=true]
 * 	Utilizado para mostrar ou não erros quando não encontrar o registro.
 *
 * @example
     <example module="appPesquisaInput">
         <file name="appPesquisaInput.html">
            <sk-application  ng-controller="TesteController" layout-padding>
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="clear()" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo: <sk-pesquisa-input sk-value="value" sk-change="onChange()" sk-enabled="enabled"></sk-pesquisa-input>
                    <p>Data: {{value}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="value" ng-repeat="item in log track by $index"/>
                </div>
            </sk-application>
         </file>
         <file name="appPesquisaInput.js">
            angular
                .module('appPesquisaInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.log = [];
                $scope.value = '';

                $scope.onChange = function () {
                  $scope.log.push($scope.value);
                };

                $scope.clear = function () {
                    $scope.value = undefined;
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skPesquisaInput', ['StringUtils', '$timeout', function (StringUtils, $timeout) {
    return {
        scope: {
        	pesquisaInputApi: '=?skApi',
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            entityName: '@?skEntityName',
            localEntityName: '@?skLocalEntityName',
            targetField: '@skTargetField',
            codeValue: '=?skValue',
            onChange: '&?skChange',
            onEntityChange: '&?skEntityChange',
            onFocus: '=?skFocus',
            onFocusOut: '=?skFocusOut',
            enabled: '=?skEnabled',
            codeInputEnabled: '=?skCodeInputEnabled',
            required: '=?skRequired',
            descriptionPlaceholder: '@?skDescriptionPlaceholder',
            descriptionFieldName: '@?skDescriptionFieldName',
            targetDescriptionFieldName: '@?skTargetDescriptionFieldName',
            dataType: '=?skDataType',
            resourceIdCadastro: '@?skResourceIdCadastro',
            formCriteria: '@?skFormCriteria',
            dependentFields: '=?skDependentFields',
            enviromentCriteria: '&?skEnviromentCriteria',
            showDescriptionInput: '=?skShowDescriptionInput',
            useLocalFieldName: '=?skUseLocalFieldName',
            useTabLikeEnter: '=?skUseTabLikeEnter',
            relationShipDescription: '@skRelationShipDescription',
            somenteAnalitico: '=?skSomenteAnalitico',
            loadTopBar: '=?skLoadTopBar',
            allowShowHierarchicalMode: '=?skAllowShowHierarchicalMode',
            showFinderError: '<?skShowFinderError',
            showInactives: '<?skShowInactives',
            options: '=?skOptions',
            clickHandler: '&?skClickHandler',
            loadDescription: '=?skLoadDescription',
            loadDescriptionOnChange: "=?skLoadDescriptionOnChange",
            loadDescriptionWithoutBeingVisible: "=?skLoadDescriptionWithoutBeingVisible",
            notifyDescriptionChangeToDataSet: '=?skNotifyDescriptionChangeToDataSet',
            api: "=?skApi",
            enableLookup: '=?skEnableLookup',
            onCreated: '&?skOnCreated',
            onEndEdit: '&skEndEdit',
            disableOnInsertion: '=skDisableOnInsertion',
            forceLoadDescription: '=?skForceLoadDescription',
            saveDescriptionFieldToDataSet:'=?skSaveDescriptionFieldToDataSet',
            onlySearch : '=?skOnlySearch',
            onlyPresentation : '=?skOnlyPresentation',
            standaloneMode : '=skStandaloneMode'
        },
        template: getTemplate,
        controller: 'SkPesquisaInputController',

        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';

        tElem.removeAttr('autofocus');

        var template =
                '<sk-text-input sk-focus="onCodeInputFocus()" sk-value="codeValue" title="{{descriptionValue.length > 0 ? descriptionValue : textInputTitle}}" sk-enabled="isCodeEnabled()" sk-required="required" sk-before-change="::onBeforeChangeCode($value)" sk-change="::onChangeCode()" sk-focus-out="onCodeInputFocusOut()" sk-keydown="onCodeKeyDown($event)" sk-only-numbers="isDecimalCode()" sk-show-thousand-separator="false" sk-end-edit="onEndEdit({value: value, inputName: \'code\'})" ng-keypress="onKeyPress($event)" {gridEditor} {autofocus}></sk-text-input>' +
                '<sk-typeahead-input sk-value="descriptionValue" title="{{descriptionValue.length > 0 ? descriptionValue : typeaheadTitle}}" ng-show="showDescriptionInput" sk-placeholder="{{descriptionPlaceholder}}" sk-enabled="enabled" sk-focus-out="::onFocusOutDescriptionInput" sk-get-options="loadSuggestions" sk-is-loading="searching" sk-key="label" sk-label="label" sk-on-select="onSelectEntity" sk-show-more="hasMoreResults" sk-show-more-fn="showMoreResults()" sk-template-url="components/input/pesquisa/typeahead.tpl.html" sk-tab-index="-1" sk-end-edit="onEndEdit({value: value, inputName: \'description\'})" {gridEditorStyle} sk-min-length="1" sk-append-to-body></sk-typeahead-input>' +
                '<sk-icon font-icon=\'search\'  ng-if="!searching" ng-click="openPesquisaPopUp()" sk-enabled="enabled"></sk-icon>' +
                '<sk-icon font-icon=\'refresh\' ng-if="searching"  ng-click="openPesquisaPopUp()" sk-enabled="enabled" sk-class="spin"></sk-icon>';

        var templateArgs = {
            gridEditor      : angular.isDefined(tAttrs.skDatagridEditor) ? 'sk-datagrid-pesquisa-editor' : '',
            gridEditorStyle : angular.isDefined(tAttrs.skDatagridEditor) ? 'style="display:none;"' : '',
            autofocus       : autofocus
        };

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];
        var inputController = angular.element(inputElement).data('$skTextInputController');
        var descriptionElement = element.find('sk-typeahead-input');
        var descriptionController;
        if(descriptionElement){
            descriptionController = angular.element(descriptionElement).data('$skTypeaheadInputController');
        }

        function setFocus(onDescription) {
            $timeout(function(){
                if(onDescription && descriptionController){
                    descriptionController.setFocus();
                }else{
                    inputController.setFocus();
                }
            }, 0, false);
        }

        ctrl.setFocus = setFocus;
        
        scope.useDescriptionOptions = angular.isDefined(attr.skUseDescriptionOptions) ? true : false;

        if (attr.skDatagridEditor == 'true') {
            inputController.setFocus();

          $timeout(function () {
            inputController.select();
          }, 0, false);
        }
    }
}]);

angular
    .module('snk.components.input')
    .component('skPesquisaConfig', {
        restrict: 'E',
        bindings: {
            entityName: '@skEntityName',
        },
        controller: 'SkPesquisaConfigController',
        templateUrl: 'components/input/pesquisa/config/pesquisaconfig.tpl.html'
    });
angular
    .module('snk.components.input')
    .controller('SkPesquisaConfigController', ['$element', function($element) {
        var self = this;

        self.getConfigSearchProperties = getConfigSearchProperties;

        function getConfigSearchProperties(){
            return {
                entityName: self.entityName,
            }
        }

    }]);
angular
    .module('snk.components.input')
    .controller('SkPesquisaConfigContentController', ['$scope', 'SkPesquisaService', 'SkApplication', function($scope, SkPesquisaService, SkApplication) {
        var self = this;

        $scope.props = $scope.properties();
        $scope.selectedTab = 0;
        $scope.descriptors = {};
        $scope.isSup = false;

        try{
            $scope.isSup = SkApplication.instance().isSup();
        }catch(e){
            $scope.isSup = false;
        }

        $scope.removeConfig = removeConfig;
        $scope.saveConfig = saveConfig;
        $scope.changeRestrict  = changeRestrict;
        $scope.selectedTabFn = selectedTabFn;
        $scope.checkAllDescriptors = checkAllDescriptors;
        $scope.itemClickHandler = itemClickHandler;
        $scope.allSelected = false;

        self.fieldOrdeBy = null;
        self.limitResult = null;        

        $scope.$onPopoverOpened = function () {
            init();
        }       

        function init(){
        	$scope.savedConfig = false;
        	
            SkPesquisaService.getSearchConfig($scope.props.entityName).then(result => {
                $scope.descriptors = result;

                if($scope.descriptors){
                    
                    $scope.descriptors.fieldDescriptors = $scope.descriptors.fieldDescriptors.filter(filterInactives);
                    $scope.orderByItens = [{description: 'Padrão', name: 'null'}].concat($scope.descriptors.fieldDescriptors);
                    $scope.descriptors.relationDescriptors = $scope.descriptors.relationDescriptors.filter(filterInactives);

                    if($scope.descriptors.fieldDescriptors.length == 0){
                        $scope.selectedTab = 1;
                    }
                    
                    self.fieldOrdeBy = $scope.descriptors.fieldOrdeBy;
                    self.limitResult = $scope.descriptors.limitResult;

                    if(!$scope.isSup){
                        $scope.descriptors.restrict = false;
                    }else if($scope.descriptors.restrict == null){
                        $scope.descriptors.restrict = false;
                    }
                    
                    validateAllDescriptors($scope.selectedTab);
                }
            });
        }

        function filterInactives(item){
            return item.hasActive == true;
        }
        
        function filterSearchable(item) {
            return item.searchable == true;
        }

        function removeConfig(){
            SkPesquisaService.removeSearchConfig($scope.props.entityName).then(() => {
                init();
                $scope.hide();
            });
        }

        function saveConfig(){
            if(self.fieldOrdeBy != null){
                $scope.descriptors.fieldOrdeBy = self.fieldOrdeBy;
            }

            if(self.limitResult != null){
                $scope.descriptors.limitResult = self.limitResult;
            }
            
            SkPesquisaService.saveSearchConfig($scope.props.entityName, $scope.descriptors)
                .then(
                    () => {
                        $scope.$emit('$pesquisaController.savedConfig', { 'savedConfig': $scope.savedConfig = true });
                        $scope.hide();
                    }
                );
        }

        function changeRestrict(){
            $scope.descriptors.restrict = !$scope.descriptors.restrict;
        }
        
        function selectedTabFn(tab) {
            // Evita de clicar na mesma aba e fazer a validação do checkbox
            if (tab == $scope.selectedTab) {
                return;
            }

            $scope.selectedTab = tab;

            validateAllDescriptors(tab);
        }

        function itemClickHandler(field) {
            field.searchable = !field.searchable

            validateAllDescriptors($scope.selectedTab);
        }

        function getTypeDescriptor(tab) {
            let arr = [];

            if (tab == 0) {
                arr = $scope.descriptors.fieldDescriptors;
            } else {
                arr = $scope.descriptors.relationDescriptors;
            }

            if (!angular.isArray(arr)) {
                arr = [arr];
            }

            return arr;
        }

        function checkAllDescriptors() {
            if (angular.isDefined($scope.descriptors)) {
                let descriptors = getTypeDescriptor($scope.selectedTab);

                descriptors.forEach(function (descriptor) {
                    if (descriptor) {
                        descriptor.searchable = !$scope.allSelected;
                    }
                });
            }
        }

        function validateAllDescriptors(tab) {
            let descriptors = getTypeDescriptor(tab);
            let allMarked = descriptors.every(filterSearchable);

            $scope.allSelected = allMarked;
        }

    }]);
angular
    .module('snk.components.input')
    .controller('SkPesquisaContentController', ['$scope', '$element', '$timeout', '$translate', '$q', 'SkPesquisaService', 'SkConstants', 'ObjectUtils', 'WhenReadyBuilder', 'DatasetUtils', 'GridConfig', 'StringUtils', 'ArrayUtils', 'SkApplication', 'Base64', 'DomUtil', 'PositionUtils', 'SkTourService', 'SanPopup', 'ServiceProxy', 'Criteria', 'UserAgentUtils', 'SkSessionStorage', 'SkApplicationInstance',
        function ($scope, $element, $timeout, $translate, $q, SkPesquisaService, SkConstants, ObjectUtils, WhenReadyBuilder, DatasetUtils, GridConfig, StringUtils, ArrayUtils, SkApplication, Base64, DomUtil, PositionUtils, SkTourService, SanPopup, ServiceProxy, Criteria, UserAgentUtils, SkSessionStorage, SkApplicationInstance) {
            var DEFAULT_PAGE_SIZE = 100;
            var LAST_USED_MODE = 'lastUsedMode';

            var self = this;

            var _txProperties = new TXProperties();
            var _criteriaProviders = [];
            var _metadataReady = WhenReadyBuilder.$new();
            var _dsMetadata;
            var _dsFields;
            var _metadataInitialized = false;
            var _allowShowHierarchicalMode = ObjectUtils.getProperty($scope, 'options.allowShowHierarchicalMode') == "true" || ObjectUtils.getProperty($scope, 'options.allowShowHierarchicalMode') == true;
            var _handleOnlyAnalytics = ObjectUtils.getProperty($scope, 'options.handleOnlyAnalytics');
            var _enableRowsCounter = ObjectUtils.getProperty($scope, 'options.enableRowsCounter');
            var _lastEnviromentCriteria;
            var _gridCtrl;
            var _structuredDataLoaded = false;

            ObjectUtils.implements(self, DataSource);

            var _storage = SkSessionStorage('PesquisaContent');

            $scope.multiSelectEnabled = ObjectUtils.getProperty($scope, 'options.multiSelect') === true;

            var _multiSelectedItems = {};

            $scope.viewMode = _allowShowHierarchicalMode ? 'table' : 'list';

            $scope.currentIndex = 0;
            $scope.viewStackSelectedIndex = _allowShowHierarchicalMode ? 2 : 1;
            $scope.canGoToGrid = _allowShowHierarchicalMode ? true : false;
            $scope.hierarchicalDP = [];

            $scope.ngModelOptions = {
    		    debounce: UserAgentUtils.isMobile() ? 850 : 450
		    };
            
            $scope.onKeydown = onKeydown;
            $scope.onClick = onClick;
            $scope.onDoubleClick = onDoubleClick;
            $scope.isActive = isActive;
            $scope.loadSuggestions = loadSuggestions;
            $scope.changeViewMode = changeViewMode;
            $scope.dsMetadataProvider = dsMetadataProvider;
            $scope.onGridDoubleClick = onGridDoubleClick;
            $scope.onGridSingleClick = onGridSingleClick;
            $scope.openHelpPopup = openHelpPopup;
            $scope.selectedOnTree = selectedOnTree;
            $scope.treeDblClickForSelect = !UserAgentUtils.isMobile();
            $scope.onDatasetLoaded = onDatasetLoaded;
            $scope.onDatagridLoaded = onDatagridLoaded;
            $scope.treeSearchInterceptor = treeIsEmptyControl;

            $scope.onInputCreationComplete = onInputCreationComplete;

            $scope.enableGridMode = angular.isUndefined($scope.enableGridMode) ? true : $scope.enableGridMode;

            $scope.onlyPresentation = $scope.options?.onlyPresentation;
            $scope.showSearchInput = $scope.onlyPresentation && !_allowShowHierarchicalMode ? false : true;
            
            var loadOnCreation = ($scope.options && $scope.options.loadOnCreate) || angular.isUndefined($scope.loadOnCreation) ? true : $scope.loadOnCreation;
            $scope.limit = _allowShowHierarchicalMode ? 1000 : ($scope.limit || DEFAULT_PAGE_SIZE);

            $scope.gridConfigId = 'grdcfg.dynaform.pesquisa.' + $scope.entityName;
            $scope.treeCtrl = $scope.treeCtrl || {};

            var configName = $scope.gridConfigId;

            GridConfig.registerGridConfig($scope.gridConfigId, configName, undefined, true, undefined, true);

            self.getEntityName = getEntityName;
            self.addCriteriaProvider = addCriteriaProvider;
            self.removeCriteriaProvider = removeCriteriaProvider;
            self.loadSuggestions = loadSuggestions;
            self.refresh = loadSuggestions;//Sobrescrevemos o método implementado do DataSource para utilização de outros componentes
            self.getEntityReference = getEntityReference;
            self.getSelectedIndex = getSelectedIndex;
            self.saveCriteria = saveCriteria;
            self.getCurrentQuery = getCurrentQuery;
            self.setFocus = setFocus;

            var entityDataByUniqueId = {};

            init();

            function init() {
                var initialMessage = '';

                if ($scope.query) {
                    initialMessage = $translate.instant('PesquisaContent.aguardeProcurandoRegistros');
                } else if ($scope.enableGridMode) {
                    initialMessage = $translate.instant('PesquisaContent.resultadosAparececaoAqui');
                }

                $scope.clickSeeAll = $translate.instant('PesquisaContent.clickSeeAll');
                $scope.searchLimited = $translate.instant('PesquisaContent.searchLimited');

                showMessageView(initialMessage);

                if ($scope.criteriaProvider) {
                    _criteriaProviders.push($scope.criteriaProvider);
                }

                if (loadOnCreation ||($scope.onlyPresentation && !_allowShowHierarchicalMode)) {
                    loadSuggestions();
                }

                $scope.helpTooltipAling = ObjectUtils.getProperty($scope, 'options.helpTooltipAling') || 'top';

                updateRowsCounterVisible();

                if (!_allowShowHierarchicalMode) {
                    _storage.getWithServerFallback($scope.entityName)
                        .then(function(config) {
                            if (config && config[LAST_USED_MODE]) {
                                updateViewMode(config[LAST_USED_MODE], true);
                            }
                        });
                }

                listenerSavedConfig();
                listenerConfirmMultiSelection();
            }

            function listenerSavedConfig () {
                $scope.$on('$pesquisaController.savedConfig', function (event, opt) {
                    if (ObjectUtils.getProperty(opt, 'savedConfig') == true && StringUtils.isNotEmpty($scope.query)){ 
                        loadSuggestions();
                    }
                });
            }

            function listenerConfirmMultiSelection() {
                $scope.$on('pesquisa.confirmMultiSelection', function() {
                    confirmMultiSelection();
                });
            }

            function onDatasetLoaded(dataset) {
                $scope.dataset = dataset;
                $scope.dataset.addLineChangeListener(function (newIndex) {
                    currentLineChange(newIndex);
                });
                
            }

            function currentLineChange(newIndex){
                if($scope.dataset.getCurrentRow() && $scope.selectDataSingleClick) selectedDataGrid(newIndex);
            }

            function updateRowsCounterVisible() {
                if (_enableRowsCounter) {
                    if (_allowShowHierarchicalMode) {
                        $scope.rowsCounterVisibleHieraircal = ($scope.viewMode == 'table');
                        $scope.rowsCounterVisible = false;
                    } else {
                        $scope.rowsCounterVisibleHieraircal = false;
                        $scope.rowsCounterVisible = true;
                    }
                } else {
                    $scope.rowsCounterVisible = false;
                    $scope.rowsCounterVisibleHieraircal = false;
                }
            }

            function onInputCreationComplete() {
                setFocus();
            }

            function setFocus() {
              $timeout(function () {
                DomUtil.setFocusOnElement($element[0].querySelector('.query-input'), true);
              }, 400, false);
            }

            function dsMetadataProvider(setMetadata) {
                _metadataReady.whenReady()
                    .then(function () {
                        DatasetUtils.prepareMetadata(_dsMetadata)
                            .then(function (dsMetadata) {
                                setMetadata(dsMetadata);
                            });
                    });
            }

            function getEntityReference() {
                return $scope.entity;
            }

            function getSelectedIndex() {
                return $scope.currentIndex;
            }

            function saveCriteria(id, criteria, criteriaParsed) {
                var encoded = Base64.encode(JSON.stringify(criteriaParsed));

                _txProperties.addProperty('ConfigToSaveAt:' + id, encoded);
            }

            function initializeMetadata(entity) {
                if (!_metadataReady.isReady()) {
                    _dsMetadata = {
                        entities: {}
                    };

                    _dsFields = [];
                    _dsMetadata.entities[$scope.entityName] = {
                        description: entity.entityDescription,
                        fields: _dsFields
                    };

                    entity.fieldsMetadata.forEach(function (field, index) {
                        var dsField = {
                            name: field.fieldName,
                            description: field.description,
                            userType: field.type,
                            order: index
                        };

                        if($scope.options.useDescriptionOptions){
                            if(field.options && entity.data.length > 0){
                                for(let i=0; i < entity.data.length; i++){
                                    let option = entity.data[i][field.fieldName];
                                    entity.data[i][field.fieldName] = field.options[option];
                                }
                            }
                        }

                        if (field.uiType) {
                            dsField.properties = [
                                {
                                    name: 'UIType',
                                    value: field.uiType
                                }
                            ]
                        }

                        if (field.options) {
                            dsField.options = [];

                            angular.forEach(field.options, function (value, key) {
                                dsField.options.push({
                                    data: key,
                                    value: value
                                })
                            });
                        }

                        _dsFields.push(dsField);
                    });

                    _metadataReady.ready();
                    $scope.dataset.initializeDataSet();
                    $scope.canGoToGrid = true;
                    _metadataInitialized = true;
                }
            }

            function addCriteriaProvider(criteriaProvider) {
                ObjectUtils.isImplementorOf(criteriaProvider, CriteriaProvider);

                _criteriaProviders.push(criteriaProvider);
            }

            function removeCriteriaProvider(criteriaProvider) {
                ObjectUtils.isImplementorOf(criteriaProvider, CriteriaProvider);

                var index = _criteriaProviders.indexOf(criteriaProvider);

                if (index > -1) {
                    _criteriaProviders.splice(index, 1);
                }
            }

            function getEntityName() {
                return $scope.entityName;
            }

            function changeViewMode() {
                updateViewMode($scope.viewMode == 'table' ? 'list' : 'table');
            }

            function updateViewMode(mode, skipSave) {
                $scope.viewMode = mode;
                if($scope.viewMode == 'table' && $scope.enableGridMode == false){
                    $scope.viewMode = 'list';
                }
                $scope.viewStackSelectedIndex = ($scope.viewMode == 'list' ? (_allowShowHierarchicalMode ? 0 : 1) : 2);
                updateRowsCounterVisible();

                if (_allowShowHierarchicalMode && (!$scope.emptyList || 
                    ($scope.viewMode == 'table' && $scope.emptyList && _structuredDataLoaded))) {
                    loadSuggestions();
                }

                if (!(skipSave == true)) {
                    var config = {};
                    config[LAST_USED_MODE] = mode;
                    _storage.setWithServerUpdate($scope.entityName, config);
                }
                
                // Apos o update do viewMode, força o foco no input de pesquisa
                setFocus();
            }

            function populateTree() {
                var f = function () {
                    var params = {
                        instancia: {
                            nome: ObjectUtils.getProperty($scope, 'options.entityName') || $scope.entityName,
                            relationName: ObjectUtils.getProperty($scope, 'options.relationName'),
                            nomeInstanciaLocal: ObjectUtils.getProperty($scope, 'options.localEntityName'),
                            listener: ObjectUtils.getProperty($scope, 'options.serverSideListener'),
                            ignoreFinderListener: ObjectUtils.getProperty($scope, 'options.ignoreFinderListener'),
                            showInactives: ObjectUtils.getProperty($scope, 'options.showInactives'),
                            codeFieldName: ObjectUtils.getProperty($scope, 'options.fieldName'),
                            resourceIdFilterDefault: ObjectUtils.getProperty($scope, 'options.resourceIdFilterDefault')
                        }
                    };

                    insertEnvironmentCriteria(params).then(function () {
                        _lastEnviromentCriteria = ObjectUtils.getProperty(params, 'instancia.criterioLiteral');

                        showMessageView($translate.instant('PesquisaContent.aguardeProcurandoRegistros'));

                        ServiceProxy.callService('Pesquisa.getStructuredData', params).then(function (result) {
                            _structuredDataLoaded = true;

                            if (ObjectUtils.getProperty(result, 'responseBody.arvore.no')) {
                                hideMessageView();
                                var buildNode = function (data) {
                                    var node = {
                                        description: data.descricao,
                                        label: data.caminho + ' - ' + data.descricao,
                                        data: processData(data),
                                        children: []
                                    };
                                    if (data.no && data.no.length > 0) {
                                        data.no.forEach(function (value) {
                                            node.children.push(buildNode(value));
                                        });
                                    }
                                    return node;
                                };

                                $scope.hierarchicalDP.length = 0;
                                result.responseBody.arvore.no.forEach(function (value) {
                                    $scope.hierarchicalDP.push(buildNode(value));
                                });
                            } else {
                                showMessageView($translate.instant('PesquisaContent.lblNenhumRegistro'));
                            }
                        });
                    });
                };

                $scope.limit = 10000; //tem que trazer todos, se deixar undefined seta para 1000	
                getEnviromentCriteria().then(function (requestCriteria) {
                    doLoadSuggestions(requestCriteria).then(function () {
						if (!$scope.entity) {
							f();
						} else if ($scope.hierarchicalDP.length <= 0) {
							f();
						} else {
							 insertEnvironmentCriteria().then(function (criteria) {
		                        if (!angular.equals(_lastEnviromentCriteria, criteria)) {
		                            f();
		                        }
		                        treeIsEmptyControl();
		                    });
						}
					});
                });
            }

            function processData(data) {
                if (!ObjectUtils.getProperty($scope, 'entity.data')) {
                    return undefined;
                }

                const fieldName = angular.isDefined($scope.options) 
                    ? $scope.options.fieldName 
                    || $scope.entity.pkField 
                    : $scope.entity.pkField;

                if (angular.isUndefined(fieldName)) {
                    return undefined;
                }

                for (var i = 0, length = $scope.entity.data.length; i < length; i++) {
                    var value = $scope.entity.data[i];
                    if (value[fieldName] == data.codigo) {
                        return value;
                    }
                }
            }

            function insertEnvironmentCriteria(params) {
                var promise = $q.defer();

                getEnviromentCriteria().then(function (requestCriteria) {
                    var expression = requestCriteria.getExpression();
                    var parameters = requestCriteria.getParameters();

                    if (angular.isUndefined(expression)) {
                        promise.resolve();
                        return;
                    }

                    var criterioObject = {
                        expressao: {
                            $: expression
                        },
                        parametro: []
                    };

                    parameters.forEach(function (param) {
                        criterioObject.parametro.push({
                            tipo: param.type,
                            $: param.value
                        });
                    });

                    ObjectUtils.setProperty(params, 'instancia.criterioLiteral', criterioObject);

                    promise.resolve(criterioObject);
                });

                return promise.promise;
            }

            function loadSuggestions() {
                hideMessageView();

                var f = function () {
                    getEnviromentCriteria().then(function (requestCriteria) {
                        doLoadSuggestions(requestCriteria);
                    });
                };

                if (_allowShowHierarchicalMode) {
                    if ($scope.viewMode == 'table') {
                        f();
                    } else {
                        populateTree();
                    }
                } else {
                    f();
                }

                // Apos carregar as informações, força o foco no input de pesquisa
                setFocus();
            }

            function getEnviromentCriteria() {
                var promise = $q.defer();

                if (_criteriaProviders.length > 0) {
                    var criteriaPromises = [];
                    var requestCriteria = Criteria();
                    var criteria;

                    var appendCriteria = function (criteria) {
                        if (angular.isDefined(criteria)) {
                            var thisCriteriaExpression = criteria.getExpression();

                            if (angular.isDefined(thisCriteriaExpression) && thisCriteriaExpression.length > 0) {
                                if (requestCriteria.getSize() > 0) {
                                    requestCriteria.and();
                                }

                                requestCriteria.append("(" + thisCriteriaExpression + ")");
                                requestCriteria.addAllParameters(criteria.getParameters());
                            }
                        }
                    };

                    for (var i = 0; i < _criteriaProviders.length; i++) {
                        if (angular.isDefined(_criteriaProviders[i])) {
                            criteria = _criteriaProviders[i].getCriteria();

                            if (angular.isDefined(criteria)) {
                                var criteriaPromise = $q.when(criteria);
                                criteriaPromises.push(criteriaPromise);
                            }
                        }
                    }

                    $q.all(criteriaPromises)
                        .then(function (resolvedCriterias) {
                            resolvedCriterias.forEach(function (resolvedCriteria) {
                                appendCriteria(resolvedCriteria);
                            });

                            promise.resolve(requestCriteria);
                        }, function () {
                            showMessageView($translate.instant('PesquisaContent.lblFiltroCancelado'));
                        });
                } else {
                    promise.resolve();
                }

                return promise.promise;
            }

            function showMessageView(msg) {
                $scope.emptyList = true;
                $scope.stateText = msg;
            }

            function getCurrentQuery() {
                return $scope.query;
            }

            function hideMessageView() {
                $scope.emptyList = false;
                $scope.stateText = $translate.instant('PesquisaContent.resultadosAparececaoAqui');
            }

            function doLoadSuggestions(requestCriteria) {
                var promise = $q.defer();

                if (!$scope.options) {
                    $scope.options = {};
                }

                if (!$scope.options.localEntityName) {
                    $scope.options.localEntityName = $scope.localEntityName;
                }

                if (angular.isDefined($scope.showInactives)) {
                  $scope.options.showInactives = $scope.showInactives;
                }

                _txProperties.setupProperties($scope.options);

                showMessageView($translate.instant('PesquisaContent.aguardeProcurandoRegistros'));

                SkPesquisaService.loadSuggestions($scope.entityName, $scope.query, true, $scope.limit, requestCriteria, $scope.options)
                    .then(function (entity) {
                    	if (!$scope.dataset) {
							return;
                    	}

                        $scope.currentIndex = 0;
                        _multiSelectedItems = {};

                        _txProperties.reset();

                        initializeMetadata(entity);

                        $scope.entity = entity;

                        if (angular.isFunction($scope.onEntityLoaded)) {
                            $scope.onEntityLoaded(entity);
                        }

                        $scope.dataset.resetRecords();

                        if (entity.data.length == 0) {
                            showMessageView($translate.instant('PesquisaContent.lblNenhumRegistro'));
                        } else {
                            hideMessageView();
                            var nextUniqueId = $scope.dataset.getNextUniqueID();
                            var rows = [];

                            if ($scope.options && angular.isFunction($scope.options.orderByFn)) {
                                entity.data = entity.data.sort($scope.options.orderByFn);
                            }

                            entity.data.forEach(function (data, count) {
                                var row = [];

                                _dsFields.forEach(function (field) {
                                    row.push(data[field.name]);
                                });

                                entityDataByUniqueId[nextUniqueId + count] = count;
                                rows.push(row);
                            });

                            $scope.dataset.whenMetadataLoaded().then(function () {
                            	$scope.dataset.resetRecords();
                            	$scope.dataset.addRecords(rows);
                                $scope.dataset.gotoRow(0);
                                promise.resolve();
                            });
                        }

                        if ($scope.resolvePkEntity) {
                            $scope.entity.resolvePkEntity = $scope.resolvePkEntity;
                        }
                        
                    }, _txProperties.reset);
                return promise.promise;
            }

            function onKeydown($event) {
                if (_allowShowHierarchicalMode && $scope.viewMode == 'list') {
                    return;
                }

                var listSize = ($scope.entity ? $scope.entity.data.length : 0);

                if (listSize > 0 && !SkTourService.isOnTour()) {
                    if ($event.keyCode == SkConstants.KEY_CODE.ENTER && $scope.currentIndex > -1) {
                        if ($scope.multiSelectEnabled) {
                            if ($scope.viewMode !== 'table' && Object.keys(_multiSelectedItems).length === 0) {
                                return;
                            }
                            confirmMultiSelection();
                        } else {
                            var item = $scope.entity.data[$scope.currentIndex];

                            if ($scope.removeOnSelect) {
                                ArrayUtils.removeReference($scope.entity.data, item);
                            }

                            $scope.onSelectData($scope.entity, item, $scope.query);
                        }
                    } else if($scope.viewMode == 'table' && $event.keyCode == SkConstants.KEY_CODE.DOWN_ARROW){
                        setFocusOnGrid();
                        $event.preventDefault();
                    }else if ($event.keyCode == SkConstants.KEY_CODE.DOWN_ARROW && $scope.currentIndex < listSize - 1) {
                        $scope.currentIndex++;
                        scrollViewTo($scope.currentIndex);
                    } else if ($event.keyCode == SkConstants.KEY_CODE.UP_ARROW && $scope.currentIndex > 0) {
                        $scope.currentIndex--;
                        scrollViewTo($scope.currentIndex);
                    }
                } else if ($event.keyCode == SkConstants.KEY_CODE.ENTER) {
                    loadSuggestions();
                }
            }

            function getCardsContainer() {
                return angular.element($element[0].querySelector('.sk-pesquisa-result-container'));
            }

            function scrollViewTo(currentIndex) {
                var container = getCardsContainer();

                var childPosition = PositionUtils.position(container.children()[currentIndex]);
                var childTop = childPosition.top;
                var childBottom = (childPosition.height + childTop);

                var containerScroll = container.scrollTop();

                if (childBottom > container[0].offsetHeight) {
                    var diff = childBottom - container[0].offsetHeight;
                    DomUtil.scrollTo(container, containerScroll + diff);
                } else if (childTop < 0) {
                    DomUtil.scrollTo(container, containerScroll + childTop);
                } else if (childTop == 0) {
                    DomUtil.scrollTo(container, 0);
                }
            }

            function onGridDoubleClick() {
                if ($scope.multiSelectEnabled) {
                    confirmMultiSelection();
                    return;
                }
                if (!UserAgentUtils.isMobile()) {
                    selectedDataGridDoubleClick();
                }
            }

            function toggleCardSelection(index, data) {
                if (_multiSelectedItems.hasOwnProperty(index)) {
                    delete _multiSelectedItems[index];
                } else {
                    _multiSelectedItems[index] = data;
                }
            }

            function onGridSingleClick() {
                if ($scope.multiSelectEnabled) {
                    return;
                }
                if (UserAgentUtils.isMobile() || handleSingleAndDoubleClick()) {
                    selectedDataGrid();
                }
            }

            function handleSingleAndDoubleClick(){
                return(angular.isFunction($scope.onSelectData) && angular.isFunction($scope.onSelectDataByDblclick));
            }

            function confirmMultiSelection() {
                var items = [];

                if ($scope.viewMode === 'table') {
                    var selectedRecords = $scope.dataset.getSelectedRecords(true);
                    if (!selectedRecords || selectedRecords.length === 0) {
                        return;
                    }

                    selectedRecords.forEach(function(record) {
                        var rowID = record[record.length - 1].rowID;
                        var index = entityDataByUniqueId[rowID];
                        if (angular.isDefined(index) && $scope.entity.data[index]) {
                            items.push($scope.entity.data[index]);
                        }
                    });
                } else {
                    angular.forEach(_multiSelectedItems, function(data) {
                        items.push(data);
                    });
                }

                if (items.length > 0) {
                    _multiSelectedItems = {};
                    $scope.onSelectData($scope.entity, items, $scope.query);
                }
            }

            function selectedDataGrid(newIndex) {
                var currentRow = $scope.dataset.getCurrentRow();
                var index = angular.isDefined(newIndex) ? newIndex : entityDataByUniqueId[currentRow[currentRow.length - 1].rowID];
                var item = $scope.entity.data[index];

                $scope.currentIndex = index;

                if ($scope.selectOnDblclick ) {
                    return;
                }

                if ($scope.removeOnSelect) {
                    ArrayUtils.removeReference($scope.entity.data, item);
                }

                $scope.onSelectData($scope.entity, item, $scope.query);
            }

            function selectedDataGridDoubleClick() {
                var currentRow = $scope.dataset.getCurrentRow();
                var index = entityDataByUniqueId[currentRow[currentRow.length - 1].rowID];
                var item = $scope.entity.data[index];
                if (angular.isFunction($scope.onSelectDataByDblclick)) {
                    $scope.onSelectDataByDblclick($scope.entity, item, $scope.query);
                } else {
                    $scope.onSelectData($scope.entity, item, $scope.query);
                }
            }

            function selectedOnTree(row) {
                if(ArrayUtils.toArray(row.children).length > 0 && _handleOnlyAnalytics){
                    return;
                }

                var item = ObjectUtils.getProperty(row, 'data');
                if(angular.isUndefined(item)){
					buscaRowData($scope.hierarchicalDP, row);
					item = window.fieldData;
				}
                $scope.onSelectData($scope.entity, item);
            }

			function buscaRowData(child, row){
				if(angular.isUndefined(child)){
					return;
				}
				child.forEach(function (field, index) {
					if(field.children?.length > 0){
						buscaRowData(field.children, row);
					} else {
						if(field.label?.includes(row.description)){
							window.fieldData = field.data;
						}
					}
				});
			}

            function isActive(index) {
                if ($scope.multiSelectEnabled && $scope.viewMode === 'list') {
                    return _multiSelectedItems.hasOwnProperty(index);
                }
                return $scope.currentIndex == index;
            }

            function onClick($event, $index, entity, data) {
                $scope.currentIndex = $index;

                if ($scope.multiSelectEnabled) {
                    toggleCardSelection($index, data);
                    setFocus();
                    return;
                }

                if ($scope.selectOnDblclick) {
                    $event && $event.preventDefault();

                    return;
                }

                if ($scope.removeOnSelect) {
                    ArrayUtils.removeReference(entity.data, data);
                }

                $scope.onSelectData(entity, data, $scope.query);
            }

            function onDoubleClick($event, $index, entity, data) {
                if ($scope.multiSelectEnabled) {
                    _multiSelectedItems[$index] = data;
                    confirmMultiSelection();
                    return;
                }

                if(!handleSingleAndDoubleClick()){
                        if (!$scope.selectOnDblclick ) {
                        $event && $event.preventDefault();
                        return;
                    }

                    if ($scope.removeOnSelect) {
                        ArrayUtils.removeReference(entity.data, data);
                    }
                    $scope.onSelectData(entity, data, $scope.query);
                }else{
                     $scope.onSelectDataByDblclick(entity, data, $scope.query);
                }                              
            }

            function openHelpPopup() {
                SanPopup.open({
                    templateUrl: 'components/input/pesquisa/content/pesquisacontenthelppopup.tpl.html',
                    size: 'lg',
                    title: $translate.instant('Geral.lblAjuda'),
                    windowClass: ObjectUtils.getProperty($scope, 'options.helpWindowClass'),
                    showBtnCancel: false,
                    showBtnOk: false,
                    showBtnNo: false,
                    controller: ['$scope', '$popupInstance', function ($scope, $popupInstance) {
                        $scope.onCancelWizard = onCancelWizard;
                        $scope.onFinishWizard = onFinishWizard;

                        function onCancelWizard() {
                            $popupInstance.dismiss();
                        }

                        function onFinishWizard($step) {
                            $popupInstance.dismiss();
                        }
                    }]
                });
            }

            function onDatagridLoaded(datagrid, dataset){
                _gridCtrl = datagrid; 
            }

            function setFocusOnGrid(){
                if($scope.viewMode == 'table'){
                    if(_gridCtrl){
                        _gridCtrl.setFocus();
                    }
                }
            }

            function treeIsEmptyControl(tree_rows) {
                if (_allowShowHierarchicalMode && _structuredDataLoaded && $scope.viewMode == 'list') {
                    let treeIsEmpty = !tree_rows || (tree_rows && !tree_rows.length);

                    if (angular.isDefined($scope.treeCtrl)) {
                        if (angular.isFunction($scope.treeCtrl.tree_is_empty)) {
                            treeIsEmpty = $scope.treeCtrl.tree_is_empty();
                        }
                    }
                
                    if (treeIsEmpty) {
                        showMessageView($translate.instant('PesquisaContent.lblNenhumRegistro'));
                    } else {
                        hideMessageView();
                    }
                }
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-pesquisa-content
 * @restrict E
 * @scope
 * @description
     Componente de seleção de data e hora.
     Internamente o componente de data e o de hora alinhados verticalmente.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 * @param {object} [sk-options=undefined]
     Objeto com as configurações e parâmetros necessários para realizar a busca no loadSuggestions do PesquisaService.
     - <b>descriptionFieldName</b>: <string> Texto correspondente ao atributo que será utilizado para ordenação dos dados da busca, exemplo: 'this.DTMOV'.
     - <b>limit</b>: <number> Corresponde a quantidade de registros que serão carregados na busca, se enviar o valor zero (0) carregará todos os dados.
     - <b>orderByDesc</b>: <boolean> Flag que ativa a busca por valor decrescente, este atributo só funcionará se houver o atributo descriptionFieldName definido.
     - <b>orderByFn</b>: <function> Função para ordenar os dados do lado do front-end, atributo que apenas será utilizado se a ordenação necessitar de regras bem específicas.
     - <b>localEntityName</b>: <string> Nome da entidade local.
     - <b>showInactives</b>: <boolean> Flag para mostrar registros inativos.
     - <b>loadOnCreation</b>: <boolean> Flag para ativar a busca automática ao abrir o popup de pesquisa.
     - <b>useDescriptionOptions</b>: <boolean> Flag que ativa o uso das opções do campo descrição.
     - <b>fieldName</b>: <string> Nome do campo relacionado a pesquisa.
     - <b>ignoreEntityCriteria</b>: <boolean> Flag para ignorar o criteria da entidade.
     - <b>txProperties</b>: <object> Informações em forma de chave/valor para a sessão Jape.
     - <b>resourceIdCadastro</b>: <string> Resource ID do cadastro da entidade.
     - <b>modalId</b>: <string> ID do popup de pesquisa.
 *
 */
angular
    .module('snk.components.input')
    .directive('skPesquisaContent', ['StringUtils', '$timeout', function (StringUtils, $timeout) {
        return {
            scope: {
                id: '=skId',
                entityName: '=skEntityName',
                localEntityName: '=skLocalEntityName',
                onSelectData: '=skOnSelect',
                onSelectDataByDblclick: '=skOnSelectByDblclick',
                onEntityLoaded: '=skOnEntityLoaded',
                limit: '@?skLimit',
                enableShowDetails: '=?skEnableShowDetails',
                enableGridMode: '=?skEnableGridMode',
                enableRowsCounter: '=?skEnableRowsCounter',
                loadOnCreation: '=?skLoadOnCreation',
                query: '@?skQuery',
                options: '=?skOptions',
                criteriaProvider: '=?skCriteriaProvider',
                queryPlaceholder: '=?skQueryPlaceholder',
                selectOnDblclick: '=?skSelectOnDblclick',
                removeOnSelect: '=?skRemoveOnSelect',
                showAllAction: '=?skShowAllAction',
                showInactives: '=?skShowInactives',
                selectDataSingleClick: "=?skSelectDataSingleClick",
                resolvePkEntity: '=?skResolvePkEntity'
            },
            templateUrl: 'components/input/pesquisa/content/pesquisacontent.tpl.html',
            controller: 'SkPesquisaContentController'
        };
    }]);

/**
 * Created by bruno.brandao on 28/05/2015.
 */
angular
    .module('snk.components.input')
    .service('SkPesquisaService', ['MetadataProvider', 'ServiceProxy', '$q', 'SanPopup', 'SkApplication', '$translate', 'SanPopupStack', 'ObjectUtils', function(MetadataProvider, ServiceProxy, $q, SanPopup, SkApplication, $translate, SanPopupStack, ObjectUtils) {
        var self = this;

        self.loadSuggestions = loadSuggestions;
        self.loadSuggestionsByPk = loadSuggestionsByPk;
        self.isFavorite = isFavorite;
        self.openPesquisaPopUp = openPesquisaPopUp;
        self.updateFavorite = updateFavorite;
        self.currentResourceId = SkApplication.instance().getResourceID();
        self.closeModal = closeModal;
        self.getSearchConfig = getSearchConfig;
        self.saveSearchConfig = saveSearchConfig;
        self.removeSearchConfig = removeSearchConfig;

        var modalInstanceById = {};
        var lastValue;

        function loadSuggestionsByPk(entityName, pk, parentPk, requestCriteria, options){
            var pkValue;
            var assumedPkName;

            if (angular.isObject(pk)){
                angular.forEach(pk, function(value, fieldName){
                    if (!pkValue){
                        assumedPkName = fieldName;
                        pkValue = value;
                    } else {
                        if (!parentPk) {
                            parentPk = {};
                        }

                        parentPk[fieldName] = value;
                    }
                });
            } else {
                pkValue = pk;
            }

            var request = {
                criteria: {
                    entityName: entityName,
                    compacted: false,//sempre será false pois agora pesquisamos por tudo, no html5,
                    ignoreEntityCriteria: options && options.hasOwnProperty("ignoreEntityCriteria") ?  options.ignoreEntityCriteria : false,
                    pk: {
                        $: pkValue
                    },
                    localEntityName: options && options.localEntityName,
                    options: options,
                    txProperties: options.txProperties
                }
            };

            if (parentPk || requestCriteria) {
                var externalCriteria = {
                    query: {
                        $: ''
                    },
                    otherPks: {
                        otherPks: []
                    }
                };

                if (requestCriteria) {
                    externalCriteria.query.$ = requestCriteria.getExpression();

                    externalCriteria.params = {
                        param: []
                    };

                    for (var index in requestCriteria.getParameters()){
                        var param = requestCriteria.getParameters()[index];

                        externalCriteria.params.param.push(param.buildParam(true));
                    }
                }

                if (parentPk){
                    angular.forEach(parentPk, function(pkValue, pkField){
                        if (pkField != assumedPkName){
                            externalCriteria.otherPks.otherPks.push({
                                name: pkField,
                                $: pkValue
                            });
                        }
                    });
                }

                request.criteria.externalCriteria = externalCriteria;
            }

            return MetadataProvider.getEntityMetadata(entityName).then(function(params){

                var pks = params[entityName].pk;
                
                if(pks.length == 2){
                   request.criteria.pks = {$: pks[0] + ',' + pks[1]};
                }

                return doLoadSuggestion(request);
            })
        }

        function loadSuggestions(entityName, value, compacted, limit, requestCriteria, options){
            // Buscamos os metadados da entidade
            return MetadataProvider.getEntityMetadata(entityName).then(function(params){
                var request = {
                    criteria: {
                        entityName: entityName,
                        compacted: false, //sempre será false pois agora pesquisamos por tudo, no html5
                        ignoreEntityCriteria: options && options.hasOwnProperty("ignoreEntityCriteria") ? options.ignoreEntityCriteria : false,
                        limit: options && angular.isDefined(options.limit) ? options.limit : limit,
                        query: {
                            $: value
                        },
                        txProperties: options && options.txProperties,
                        localEntityName: options && options.localEntityName,
                        orderByDesc: options && options.orderByDesc || false,
                        options: options
                    }
                };

                if (requestCriteria) {
                    var externalCriteria = {
                        query: {
                            $: requestCriteria.getExpression()
                        },
                        params: {
                            param: []
                        }
                    };
        
                    for (var index in requestCriteria.getParameters()) {
                        var param = requestCriteria.getParameters()[index];
                        externalCriteria.params.param.push(param.buildParam(true));
                    }
        
                    request.criteria.externalCriteria = externalCriteria;
                }

                // Tentamos recuperar as propriedades configuradas nos metadados
                let properties = ObjectUtils.getProperty(params, entityName + '.properties');
                
                // Caso existam, adicionamos no request
                if (!ObjectUtils.isEmpty(properties)) {
                    let keys = Object.keys(properties);
                    if (keys.length > 0) {
                        let orderBy = ObjectUtils.getProperty(properties, "orderBy");
                        let limit = ObjectUtils.getProperty(properties, "limit");
                        if (!options) {
                        	options = {};
                        }
                        if (orderBy) {
                        	options.descriptionFieldName = orderBy;
                        } else {
                        	delete options.descriptionFieldName;
                        }
                        if (limit) {
                        	request.criteria.limit = limit;
                        }
                    }
                }
                return doLoadSuggestion(request);
            });
        }

        function doLoadSuggestion(request){
            var deferred = $q.defer();
            deferred.promise.$$state.lastValue = request.criteria.query;
            lastValue = deferred.promise.$$state.lastValue;

            ServiceProxy.callService('mge@PesquisaSP.getSuggestion', request, {aditionalUrlParameters: {'allowConcurrentCalls': 'true'}})
                .then(function(result){
                    var entity = JSON.parse(result.responseBody.json.$);
                    if (lastValue === deferred.promise.$$state.lastValue){
                    	deferred.resolve(entity);
                    }
                }, function(error){
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function isFavorite(entityName, pkValues) {
            var deferred = $q.defer();

           ServiceProxy.callService('mge@PesquisaSP.isFavorito', {
                entityName: entityName,
                pkValues: pkValues
            })
            .then(function(result){
                var isFavorito = result.responseBody.isFavorito;

                deferred.resolve(isFavorito);
            }, function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function updateFavorite(entityName, pkValues, favorite) {
            return ServiceProxy.callService('mge@PesquisaSP.marcarComoFavorito', {
                entityName: entityName,
                pkValues: pkValues,
                isFavorito: favorite
            });
        }

        function openPesquisaPopUp(entityName, value, options){

            var rightBottomBar;

            if (options && options.resourceIdCadastro && options.resourceIdCadastro !== self.currentResourceId){
                var btnIrParaCadastro = angular.element('<button class="btn btn-default">' + $translate.instant('Geral.lblIrParaCadastro') + '</button>');

                btnIrParaCadastro.on('click', function(){
                    SkApplication.instance().openApp(options.resourceIdCadastro);
                });

                rightBottomBar = [btnIrParaCadastro];
            }

            var modalInstance = SanPopup.open({
                templateUrl: 'components/input/pesquisa/popup/pesquisa-pop-up.tpl.html',
                controller: 'SkPesquisaPopUpController',
                size: 'lg',
                title: $translate.instant('PesquisaContent.procurandoPor'),
                showBtnOk: false,
                showBtnCancel: false,
                resolveOnScope: true,
                onlyPresentation:options.onlyPresentation,
                windowClass: 'pesquisa-popup-modal',
                resolve: {
                    query: function () {
                        return value;
                    },
                    entityName: function () {
                        return entityName;
                    },
                    options: function(){
                        return options;
                    }
                },
                rightBottomBar: rightBottomBar
            });

            if(options && options.modalId){
                modalInstanceById[options.modalId] = modalInstance;
            }

            return modalInstance.result;
        }

        function closeModal(modalIds){
            
            if(angular.isString(modalIds) && modalIds.indexOf(',') > -1){
                modalIds = modalIds.split(',');
            }else if(angular.isString(modalIds)){
                modalIds = [modalIds];
            }
            
            modalIds.forEach(function(id){
                if(modalInstanceById[id]){
                    SanPopupStack.dismiss(modalInstanceById[id]);
                }
            })
        }

        function getSearchConfig(entityName){
           var deferred = $q.defer();

           ServiceProxy.callService('mge@PesquisaSP.getSearchConfig', {
                entityName: entityName,
            })
            .then(function(result){
                deferred.resolve(result.responseBody);
            }, function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function saveSearchConfig(entityName, descriptor){
            var deferred = $q.defer();

           ServiceProxy.callService('mge@PesquisaSP.saveSearchConfig', {
                entityName: entityName,
                descriptor: descriptor
            })
            .then(function(result){
                deferred.resolve();
            }, function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function removeSearchConfig(entityName){
            var deferred = $q.defer();

           ServiceProxy.callService('mge@PesquisaSP.removeSearchConfig', {
                entityName: entityName,
            })
            .then(function(result){
                deferred.resolve();
            }, function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }
    }]);

angular
    .module('snk.components.input')
    .controller('SkPesquisaPopUpController', ['$scope', 'SkI18nService', '$popupInstance', '$timeout', 'ObjectUtils', 'AngularUtil', 'StringUtils', 'entityName', 'query', 'options', 'Criteria', '$translate',
        function ($scope, SkI18nService, $popupInstance, $timeout, ObjectUtils, AngularUtil, StringUtils, entityName, query, options, Criteria, $translate) {

            $scope.query = query;
            $scope.entityName = entityName;
            $scope.options = options;

            $scope.modalCancel = modalCancel;
            $scope.selectData = selectData;
            $scope.onEntityLoaded = onEntityLoaded;
            $scope.multiSelect = options && options.multiSelect;
            $scope.confirmMultiSelection = confirmMultiSelection;

            $scope.pesquisaContentId = StringUtils.nextUid();

            $scope.criteriaProvider = {};
            ObjectUtils.implements($scope.criteriaProvider, CriteriaProvider);
            $scope.criteriaProvider.getCriteria = function () {
                var criteria = Criteria();

                if (options && options.criteria) {
                    criteria.and(options.criteria);
                }


                if (options && angular.isFunction(options.enviromentCriteria) && angular.isDefined(options.enviromentCriteria()) && angular.isDefined(options.enviromentCriteria().getExpression())) {
                    var environmentCriteria = options.enviromentCriteria();

                    if (environmentCriteria) {
                        if (!criteria) {
                            criteria = Criteria();
                        }

						if (environmentCriteria.getSize()) {
                        	criteria.and(environmentCriteria);
                        }
                    }
                }

                return criteria;
            };

            var _procurandoPor = SkI18nService.instant('PesquisaContent.procurandoPor');

            init();

            function init() {
                if (hasLabel()) {
                    $scope.$evalAsync(function () {
                        $popupInstance.setTitle(_procurandoPor + options.label);
                    });
                }


                if (hasTopBar()) {
                    var topBar = options.loadTopBar();

                    $timeout(function () {
                        var popupTopBar = angular.element($popupInstance.element[0].querySelector('.top-bar'));

                        if (angular.isElement(topBar)) {
                            popupTopBar.append(topBar);
                            popupTopBar.removeClass('hide');
                        }
                    }, 0, false);
                }


            }

            function hasTopBar() {
                return (options && options.loadTopBar);
            }

            function hasLabel() {
                return (options && options.label);
            }

            function onEntityLoaded(entity) {
                if (!hasLabel()) {
                    $popupInstance.setTitle(_procurandoPor + entity.entityDescription);
                }
            }

            function modalCancel() {
                $popupInstance.dismiss('cancel');
            }

            function confirmMultiSelection() {
                $scope.$broadcast('pesquisa.confirmMultiSelection');
            }

            function selectData(entity, data) {
                if (options && options.multiSelect && angular.isArray(data)) {
                    var results = data.map(function(item) {
                        return {
                            pkField: (options && options.pkFieldName) || entity.pkField,
                            key: item[(options && options.pkFieldName) || entity.pkField],
                            label: item[entity.descriptionField],
                            data: item,
                            otherEntityPks: entity && angular.isArray(entity.otherEntityPks) ? entity.otherEntityPks : []
                        };
                    });
                    $popupInstance.success(results);
                    return;
                }

                var keepOpen = $scope.options && $scope.options.keepOpenOnSelect;

                var result = {
                    pkField: (options && options.pkFieldName) || entity.pkField,
                    key: data[(options && options.pkFieldName) || entity.pkField],
                    label: data[entity.descriptionField],
                    data: data,
                    otherEntityPks: entity && angular.isArray(entity.otherEntityPks) ? entity.otherEntityPks : []
                };

                if (options.somenteAnalitico && !(data.ANALITICO == 'S' || data.ANALITICA == 'S')) {
                    throw new Error($translate.instant('DWF.Pesquisa.messageRegistroInvalido'));
                } else if (!keepOpen) {
                    $popupInstance.success(result);
                } else {
                    $popupInstance.notify(result);
                }
            }
        }
    ]);
angular
    .module('snk.components.input')
    .controller('SkPhoneInputController', ['$scope', '$timeout', '$element', 'ObjectUtils', 'StringUtils', 'AngularUtil', '$attrs',
function ($scope, $timeout, $element, ObjectUtils, StringUtils, AngularUtil, $attrs) {
    var self = this;

    self.focusIn = focusIn;
    self.focusOut = focusOut;

    var _codAreaElem = $element[0].children[0];
    var _prefixoElem = $element[0].children[1];
    var _sufixoElem = $element[0].children[2];
    let _oldValue;

    // Adição dos listeners para passar entre os campos aos pressionar 'Tab' no modo grade
    _codAreaElem.addEventListener('keydown', nextField);
    _prefixoElem.addEventListener('keydown', nextField);

    function nextField(event) {
        if(event.keyCode === 9 && $attrs.hasOwnProperty('skDatagridEditor')){
            event.stopPropagation();
        }
    }

    [_codAreaElem, _prefixoElem, _sufixoElem].forEach((input) => {
        angular.element(input).on('focus', focusIn);
        angular.element(input).on('blur', focusOut);
    })

    $scope.changeHandler = changeHandler;
    
    /** Paleativo para telas construidas pelo construtor de telas na qual é definido um default de 100, redefinimos o size dele nesse componente. */
    $scope.size = $scope.size > 15 ? 13 : $scope.size
    
    $scope.sufixoMaxLength = _sufixoElem.maxLength;
    $scope.prefixoMaxLength = ($scope.size > 12 ? 5 : 4);
    $scope.codAreaMaxLength = Math.max(
        ($scope.size - $scope.sufixoMaxLength - $scope.prefixoMaxLength),
        ($scope.size > 11 ? 3 : 2)
    );

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        getData: getPhone
    });

    self.setNgModelCtrl = setNgModelCtrl;

    function changeHandler() {
        if (self.useDataset($scope)) {
            $scope.$evalAsync(function(){
                $scope.dataset.notifyEditionStart(self);
                $scope.dataset.setModified(self);
            });
        }

        runOnChange();
    }

    function setNgModelCtrl(ngModelCtrlCodArea, ngModelCtrlPrefixo, ngModelCtrlSufixo) {
        AngularUtil.addNumberOnlyParser(ngModelCtrlCodArea);
        AngularUtil.addNumberOnlyParser(ngModelCtrlPrefixo);
        AngularUtil.addNumberOnlyParser(ngModelCtrlSufixo);

        ngModelCtrlCodArea.$parsers.push(function (inputValue) {
            if (angular.isDefined(inputValue)) {
                if ($scope.codAreaMaxLength == (inputValue.length)){
                    $timeout(function(){
                        _prefixoElem.focus();
                    }, 0, false);
                }
            }

            return inputValue;
        });

        ngModelCtrlPrefixo.$parsers.push(function (inputValue) {
            if (angular.isDefined(inputValue)) {
                if ($scope.prefixoMaxLength == (inputValue.length)){
                    $timeout(function(){
                        _sufixoElem.focus();
                    }, 0, false);
                }
            }

            return inputValue;
        });

        ngModelCtrlSufixo.$parsers.push(function (inputValue) {
            if (angular.isDefined(inputValue)) {
                  if ($scope.sufixoMaxLength == (inputValue.length)){
                     $timeout(function(){
                        _sufixoElem.focus();
                     }, 0, false);
                  }
            }

            return inputValue;
         });
    }

    function runOnChange() {
        ($scope.onChange || angular.noop)($scope);
    }

    function setData(data) {
    	$scope.codArea = '';
        $scope.prefixo = '';
        $scope.sufixo = '';

        if(!angular.isUndefined(data)){
            // Mantem os espaços em branco para ter comportamento semelhante ao flex
            let phone = data.toString();

            /* Preenchendo da direita pra esquerda */
            if(phone.length <= 4){
                $scope.sufixo = phone;
            }else{
                $scope.sufixo = phone.substr(phone.length - 4);

                let maxLengthPrefixo = ((phone.length <= 10) || (phone.length == 11 && phone.charAt(0) == "0") || (phone.length == 12 && (phone.charAt(0) != "0" || phone.charAt(1) == "0"))) ? 4 : 5;

                if(phone.length <= (maxLengthPrefixo + 4)){
                    $scope.prefixo = phone.substr(0, phone.length - 4);
                }else{
                    $scope.prefixo = phone.substr(phone.length - (maxLengthPrefixo + 4), maxLengthPrefixo);
                    $scope.codArea = phone.substr(0, phone.length - (maxLengthPrefixo + 4));
                }
            }
        }

        runOnChange();
    }

    function getPhone(){
        var phone = '';

        var prefixoLength = $scope.prefixo.length;
        var codAreaLength = $scope.codArea.length;
        var sufixoLength = $scope.sufixo.length;

        phone += $scope.codArea;
        if(codAreaLength != $scope.codAreaMaxLength) {
            for(var i = 0; i <  $scope.codAreaMaxLength - codAreaLength; i++) {
                phone += ' ';
            }
        }

        phone += $scope.prefixo;
        if(prefixoLength  != 4 || prefixoLength  != 5) {
            for(var j = 0; j < 4 - prefixoLength ; j++) {
                phone += " ";
            }
        }

        phone += $scope.sufixo;
        if(sufixoLength != 4) {
            for(var k = 0; k < 4 - sufixoLength; k++) {
                phone += " ";
            }
        }

        return StringUtils.emptyAsNull(phone);
    }

    function focusIn(){
        if($scope.prefixo && $scope.codArea && $scope.sufixo){
            _oldValue = getPhone();
        }else {
            _oldValue = undefined
        }
    }

    function focusOut(){        
        if($scope.prefixo && $scope.codArea && $scope.sufixo){
            let phoneActual = getPhone();
            if(_oldValue != phoneActual){
                $scope.onEndEdit({value: phoneActual});
            }
        }else if(_oldValue != undefined){
            $scope.onEndEdit({value: undefined});
        }
    }
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-phone-input
 * @restrict E
 * @scope
 * @description
     Componente de telefone.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @example
     <example module="appTextInput">
         <file name="appTextInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-phone-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-phone-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appTextInput.js">
            angular
                .module('appTextInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = 'Teste';
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skPhoneInput', ['$timeout', 'StringUtils',
function ($timeout, StringUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            align: '@?skAlign',
            onChange: '&?skChange',
            onFocusOut: '&skFocusOut',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            size: '=?skSize',
            onEndEdit: '&skEndEdit',
        },
        templateUrl: 'components/input/phoneinput/phoneinput.tpl.html',
        controller: 'SkPhoneInputController',
        compile: function(element){

            element.attr('flex', '');
            element.attr('layout', 'row');
            element.attr('tabindex', '-1');

            return linkFn;
        }
    };

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected;
        var inputElement = element.children();
        var firstInput = inputElement[0];

        var ngModelCtrlCodArea = angular.element(inputElement[0]).data('$ngModelController');
        var ngModelCtrlPrefixo = angular.element(inputElement[1]).data('$ngModelController');
        var ngModelCtrlSufixo = angular.element(inputElement[2]).data('$ngModelController');

        ctrl.setNgModelCtrl(ngModelCtrlCodArea, ngModelCtrlPrefixo, ngModelCtrlSufixo);

        function setFocus() {
            $timeout(function () {
                firstInput.focus();
            }, 0, false);
        }

        function select() {
            $timeout(function () {
                firstInput.select();
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.setFocus = setFocus;

        angular.element(inputElement).bind('click', function (e) {
            if (isDatagrid()) {
                e.target.focus();
            } else if (fullSelected != e.target) {
                e.target.select();

                fullSelected = e.target;
            }
        });

        angular.element(inputElement).bind('blur', function (e) {
            scope.onFocusOut(scope);
            fullSelected = undefined;
        });

        if (isDatagrid()) {
            firstInput.focus();

            select();
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkRadioInputController', ['$scope', '$timeout', '$element', 'ObjectUtils',
        function ($scope, $timeout, $element, ObjectUtils) {
            var self = this;

            $scope.$watch('enabled', function(newValue){
                if(newValue == false){
                    $element.children().addClass('disabled');
                }else{
                    $element.children().removeClass('disabled');
                }                
            });

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData
            });

            $scope.changeHandler = changeHandler;
            
            init();
            
            function init() {
            	var inputElem = $element.find('input');
            	
            	$scope.$watch('value', function(newValue) {
            		var checked = newValue == $scope.option;
            		inputElem[checked ? 'addClass' : 'removeClass']('checked');
            	});
            }

            function changeHandler() {
                $timeout(function () {
                    if (self.useDataset($scope)) {
                            $scope.dataset.notifyEditionStart(self);
                            $scope.dataset.setModified(self);
                    }

                    runOnChange();
                }, 0);
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)($scope);
            }

            function setData(data) {
                $scope.value = data;

                runOnChange();
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-radio-input
 * @restrict E
 * @scope
 * @description
     Componente de radio, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @example
     <example module="appRadioInput">
         <file name="appRadioInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    <sk-radio-input
                        sk-value="inputValue"
                        sk-option="'M'"
                        sk-change="onChange()"
                        sk-enabled="enabled"
                        sk-name="example">
                        Masculino
                    </sk-radio-input>
                    <sk-radio-input
                        sk-value="inputValue"
                        sk-option="'F'"
                        sk-change="onChange()"
                        sk-enabled="enabled"
                        sk-name="example">
                        Feminino
                    </sk-radio-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appRadioInput.js">
            angular
                .module('appRadioInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = '';
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skRadioInput', ['$timeout', 'StringUtils',
function ($timeout, StringUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            option: '@skOption',
            name: '@skName'
        },
        transclude: true,
        templateUrl: 'components/input/radio/radioInput.tpl.html',
        controller: 'SkRadioInputController',
        link: linkFn
    };

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
            }, 0, false);
        }

        ctrl.setFocus = setFocus;
        ctrl.select = select;

        angular.element(inputElement).bind('focus', function () {
            element.addClass('focused');
            select();
        });

        angular.element(inputElement).bind('blur', function () {
            element.removeClass('focused');
            scope.onFocusOut(scope);
        });
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkRateInputController', ['$scope', '$timeout', '$element', 'ObjectUtils', '$attrs', 'NumberUtils', 'AngularUtil',
        function ($scope, $timeout, $element, ObjectUtils, $attrs, NumberUtils, AngularUtil) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData
            });

            var _minValue = 1;//$attrs.hasOwnProperty('skMin') ? Number($attrs.skMin) : 0; Não implementado
            var _maxValue = 5;//$attrs.hasOwnProperty('skMax') ? Number($attrs.skMax) : 5; Não implementado

            $scope.items = new Array(5);

            $scope.changeHandler = changeHandler;
            $scope.paintStars = paintStars;
            $scope.unpaintStars = unpaintStars;
            $scope.onClickStar = onClickStar;

            function changeHandler() {
                if (self.useDataset($scope)) {
                    $scope.$evalAsync(function () {
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }

                runOnChange();
            }

            function runOnChange() {
                if ($attrs.skChange) {
                    $timeout(function () {
                        $scope.onChange($scope);
                    });
                }
            }

            function setData(data) {
                $scope.value = data;
                runOnChange();
            }

            function unpaintStars($index) {
                paintStars($scope.value - 1);
            }

            function paintStars($index) {
                var items = $element.find('div');

                for (var index = 0; index < items.length; index++) {
                    var $star = angular.element(items[index]);

                    if ($index >= index) {
                        $star.addClass('active');
                    } else {
                        $star.removeClass('active');
                    }
                }
            }

            function onClickStar(index, e) {
                 var newValue = index + 1;

                if (newValue === $scope.value && newValue === 1 && _minValue == 0) {
                    newValue = 0;
                }

                $scope.value = newValue;
                
                runOnChange();
            };
        }]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-rate-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento do texto no componente.
 *
 * @param {string} [sk-password=false]
 Determina se o componente será apresentado como um campo de senha
 *
 * @param {string} [sk-restrict]
    Informar a regex de aceitação de entradas de caracteres no campo. Por exemplo, caso deseje aceitar apenas números passe sk-restrict="[^0-9]".
 *
 * @example
     <example module="appRateInput">
         <file name="appRateInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = 0" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-rate-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-rate-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
            </div>
         </file>
         <file name="appRateInput.js">
            angular
                .module('appRateInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = 3;
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skRateInput', ['$timeout', 'StringUtils', 'UserAgentUtils',
function ($timeout, StringUtils, UserAgentUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange'
        },
        template: getTemplate,
        controller: 'SkRateInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template =
                '<div class="star" ng-touch="paintStars($index)" ng-mouseenter="paintStars($index)" ng-mouseleave="unpaintStars($index)" ng-repeat="item in items track by $index">' +
                    '<sk-icon font-icon="star" ng-click="onClickStar($index, $event)"></sk-icon>' +
                '</div>';

        var templateArgs = {
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
            }, 0, false);
        }

        ctrl.setFocus = setFocus;
        ctrl.select = select;

        var $inputElement = angular.element(inputElement);

        $inputElement.bind('focus', function () {
            element.addClass('focused');
            select();
            (scope.onFocus || angular.noop)(scope);
        });

        $inputElement.bind('blur', function () {
            element.removeClass('focused');
            (scope.onFocusOut || angular.noop)(scope);
        });

        if (attr.skDatagridEditor == 'true') {
            setFocus();

            $timeout(function () {
                inputElement.select();
            }, 0, false);
        }
    }
}]);
/**
 * Created by cleverson.puche on 06/04/2016.
 */

angular
    .module('snk.components.input')
    .controller('SkRichTextController',['$scope', '$timeout', '$element', '$translate', 'ObjectUtils', 'StringUtils', 'DomUtil', 'SkApplicationInstance', 'i18n', 'MessageUtils','ArrayUtils',
        function($scope, $timeout, $element, $translate, ObjectUtils, StringUtils, DomUtil, SkApplicationInstance, i18n, MessageUtils, ArrayUtils) {

            var self = this;

            var MAX_RETRIES = 5;
            var INITIAL_VERIFY_DELAY = 1500;
            var RETRY_VERIFY_DELAY = 800;
            var RECREATE_DELAY = 300;

            var _lang = $translate.use();
            var _editor;
            var _retryTimer = null;
            var _retryCount = 0;
            var _destroyed = false;

            $scope.editorId = StringUtils.nextUid();
            $scope.tinymceOptions = null;
            $scope.editorInitialized = false;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                setFocus: setFocus
            });

            $scope.$watch('value', function(newValue, oldValue) {
                if(newValue != oldValue){
                    changeHandler();
                }
            });

            $scope.$on('$destroy', function() {
                _destroyed = true;
                cancelRetryTimer();
                destroyEditor();
            });

            $timeout(function() {
                init();
            });

            function init() {
                var toolbar =  'undo redo ';

                if (false !== $scope.showTextFormatButtons) {
                    toolbar += ' | bold italic underline | bullist  ';
                }

                if (false !== $scope.showImageButton) {
                    toolbar += ' | image';
                }

                if (false !== $scope.showLinkButton) {
                    toolbar += '  link';
                }

                if (ArrayUtils.toArray($scope.variaveis).length > 0){
                    toolbar += ' | variables';
                }

                $scope.tinymceOptions = {
                    height: $scope.height || 300,
                    // Necessario manter essas tags por questao de compatibilidade no ERP
                    formats: {
                        bold : {inline : 'b' },
                        italic : {inline : 'i' },
                        underline : {inline : 'u'}
                    },
                    plugins: 'link autolink lists searchreplace' + ($scope.autoResize == true ? ' autoresize' : ''),
                    body_class: 'sk-rich-text-body',
                    statusbar: false,
                    menubar: false,
                    toolbar: toolbar,
                    valid_elements: '*[*]',
                    entity_encoding: 'raw',
                    forced_root_block: false,
                    force_p_newlines: false,
                    force_br_newlines: false,
                    link_title: false,
                    target_list: false,
                    default_link_target: "_blank",
                    link_assume_external_targets: false,
                    language: _lang == 'en_US' ? 'en_CA' : 'pt_BR',
                    readonly: ($scope.enabled === false) ? 1 : 0,
                    content_css: StringUtils.substitute('/mge/assets/css/richtextTinymce{0}.min.css', [SkApplicationInstance.isJivaW() ? '-jiva' : '']),
                    setup: setupEditor,
                    images_dataimg_filter: function (img) {
                        // use the base64 name reference instead of default url blob
                        return img.hasAttribute('internal-blob');
                    }
                };

                if(self.useDataset($scope)){
                    $scope.dataset.addLineChangeListener(resetEditor);
                }
                
                $scope.editorInitialized = true;

                // Em cenários de lazy load (abas, modais), o TinyMCE pode não
                // renderizar corretamente porque o textarea ainda não está
                // visível no DOM. Agenda verificação com retry.
                scheduleEditorVerification();
            }

            /**
             * Agenda verificação do editor com delay inicial.
             * Em lazy load (abas/modais), o textarea pode não estar visível
             * quando o TinyMCE tenta renderizar.
             */
            function scheduleEditorVerification() {
                _retryTimer = $timeout(verifyAndFixEditor, INITIAL_VERIFY_DELAY);
            }

            /** Cancela o timer de retry pendente, se houver. */
            function cancelRetryTimer() {
                if (_retryTimer) {
                    $timeout.cancel(_retryTimer);
                    _retryTimer = null;
                }
            }

            /** Remove o editor TinyMCE de forma segura. */
            function destroyEditor() {
                if (_editor) {
                    try {
                        _editor.remove();
                    } catch (e) {
                        console.warn('[RichText] Erro ao destruir editor.', e);
                    }
                    _editor = null;
                }
            }

            /**
             * Verifica se o editor foi renderizado e tenta corrigi-lo.
             * Caso o textarea não exista ou o editor não tenha inicializado,
             * força a recriação via ng-if toggle com retry progressivo.
             */
            function verifyAndFixEditor() {
                if (_destroyed || isEditorReady()) return;

                var textareaEl = document.getElementById($scope.editorId);

                if (!textareaEl) {
                    retryOrGiveUp('Textarea não encontrado no DOM.');
                    return;
                }

                var existingEditor = tinymce.get($scope.editorId);

                if (isExistingEditorValid(existingEditor)) {
                    _editor = existingEditor;
                    return;
                }

                if (_retryCount >= MAX_RETRIES) {
                    console.error('[RichText] Falha ao inicializar o editor após ' + MAX_RETRIES + ' tentativas.');
                    return;
                }

                _retryCount++;
                console.warn('[RichText] Editor não renderizado. Forçando recriação (tentativa ' + _retryCount + '/' + MAX_RETRIES + ')');

                safeRemoveEditor(existingEditor);
                recreateEditorViaToggle();
            }

            function isEditorReady() {
                return _editor && _editor.initialized;
            }

            function isExistingEditorValid(editor) {
                return editor && editor.initialized && editor.getContainer();
            }

            function retryOrGiveUp(message) {
                if (_retryCount < MAX_RETRIES) {
                    _retryCount++;
                    console.warn('[RichText] ' + message + ' Retry ' + _retryCount + '/' + MAX_RETRIES);
                    _retryTimer = $timeout(verifyAndFixEditor, RETRY_VERIFY_DELAY);
                } else {
                    console.error('[RichText] ' + message + ' Desistindo após ' + MAX_RETRIES + ' tentativas.');
                }
            }

            function safeRemoveEditor(editor) {
                if (editor) {
                    try {
                        editor.remove();
                    } catch (e) {
                        console.warn('[RichText] Erro ao remover instância parcial:', e);
                    }
                }
            }

            /**
             * Recria o editor fazendo toggle do ng-if (editorInitialized).
             * Desliga -> aguarda RECREATE_DELAY -> religa -> agenda nova verificação.
             */
            function recreateEditorViaToggle() {
                $scope.$applyAsync(function() {
                    $scope.editorInitialized = false;

                    $timeout(function() {
                        if (_destroyed) return;
                        $scope.editorInitialized = true;
                        _retryTimer = $timeout(verifyAndFixEditor, INITIAL_VERIFY_DELAY);
                    }, RECREATE_DELAY);
                });
            }

            function setupEditor(editor) {
                _editor = editor;

                var inp = $('<input id="tinymce-uploader" type="file" name="pic" accept="image/*" style="display:none">');
                $(_editor.getElement()).parent().append(inp);

                _editor.on('init', function() {
                    $scope.$applyAsync(function() {
                        _retryCount = MAX_RETRIES;
                        cancelRetryTimer();
                    });
                });

                inp.on("change",function(){
                    var input = inp.get(0);
                    var file = input.files[0];
                    var fr = new FileReader();
                    var richTextId = '#skRichText-' + $scope.editorId;
                    fr.onload = function() {
                        if (document.querySelector(richTextId+" #tinymce-uploader").files[0].size < 500000) { // 500kb
                    		var source = fr.result;
                    		_editor.focus();
                    		_editor.selection.setContent(editor.dom.createHTML('img', {src : source}));
                    		_editor.setDirty(true);
                    		if(input){
                    			input.value = null;
                    		}
                    		_editor.fire('NodeChange', {});
                    	} else {
                    		MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Geral.msgImgLessThan'));
                    	}
                    }
                    fr.readAsDataURL(file);
                });

                _editor.on('click', function() {
                    DomUtil.simulateClickEvent($element[0]);
                });

                _editor.on('change', function () {
                    changeHandler();
                });

                _editor.on('focus', function(){
                    ($scope.onFocus || angular.noop)($scope);
                    self.fbFocusIn();
                });

                _editor.on('blur', function(){
                    ($scope.onFocusOut || angular.noop)($scope);
                    self.fbFocusOut();
                });

                if(_editor.ui){
	                _editor.ui.registry.addButton('image', {
	                	icon: 'image',
	                	tooltip: i18n('Geral.tpInsertNewImage'),
	                    onAction: function(e) {
	               		 	inp.trigger('click');
	                	}
	                });
                }

                if (ArrayUtils.toArray($scope.variaveis).length > 0) {

                    var getVariables = function(callback){
                    var menu = [];

                    $scope.variaveis.forEach(function (e) {
                        menu.push({
                                type: 'menuitem',
                            text: e.label,
                                onAction: function () {
                                editor.insertContent(' ' + e.variavel + ' ');
                            }
                        });
                    });

                        callback(menu);
                    }

                    _editor.ui.registry.addMenuButton('variables', {
                        text: i18n('Geral.tpVariaveis'),
                        fetch: getVariables
                    });
                }
            }

            function changeHandler() {
                if (self.useDataset($scope)) {
                    $scope.$evalAsync(function(){
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }

                runOnChange();
            }

            function setFocus() {
                try {
                  _editor && _editor.focus();
                } catch (e) {
                }
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)($scope);
            }

            function setData(data) {
                $scope.value = data;

                runOnChange();
            }

            function resetEditor(){
                try{
                    if(_editor && _editor.initialized && !$scope.dataset.isEditMode() && !$scope.dataset.isInsertionMode() && _editor.mode.get() != 'readonly'){
                        _editor.resetContent($scope.value)
                    };
                }catch(e){
                    console.info("[RichText] Erro ao resetar content do editor.", e);
                }
            }
        }
    ]);
/**
 * Created by cleverson.puche on 06/04/2016.
 */

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-rich-text
 * @restrict E
 * @scope
 * @description
 Componente de para formatação de textos em HTML.
 Este componente pode ser utilizado tanto com um Dataset como em modo standalone.
 - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
 - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.

 * @param {SkDataset} [sk-dataset=undefined]
 Dataset que será utilizado no controle deste componente.
 Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
 Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
 Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
 Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
 Função de listener de alteração do valor do componente.
 *
 * @param {boolean} [sk-enabled=true]
 Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-hide-buttons=false] Se habilitado esconde os botões de formatação
 * @param {boolean} [sk-pop-up-edit-enabled=true] Se habilitado permite edição no conteúdo do popUp (independente do sk-enabled)
 * @param {boolean} [sk-link-enabled=false] Se habilitado permite que o componente tenha o link para um popUp com o conteúdo
 *
 * @param {Array} [sk-variaveis=undefined]
 Recebe um array de objeto contendo label e variavel para ser inserido no texto.
 <br/>
 <code class="prettyprint">
     self.variaveis = [
                { variavel: '{EMAIL_EMPRESA}', label: 'E-mail da empresa' },
                { variavel: '{NOME_EMPRESA}', label: 'Nome da Empresa' },
                { variavel: '{NOME_PARCEIRO}', label: 'Nome do parceiro' },
    ];
    </code>
 *
 * @param {int} [sk-height=191]
 Recebe um valor referente o tamanho default 191.
 */

angular
    .module('snk.components.input')
    .directive('skRichText', ['$timeout', 'StringUtils',
        function ($timeout, StringUtils) {
            return {
                restrict: 'E',
                controller: 'SkRichTextController',
                templateUrl: 'components/input/richtext/richtext.tpl.html',
                scope: {
                    id: '@skId',
                    dataset: '=?skDataset',
                    fieldName: '@?skFieldName',
                    fieldIndex: '@?skFieldIndex',
                    value: '=?skValue',
                    onChange: '&?skChange',
                    onFocusOut: '&?skFocusOut',
            		onFocus: '&?skFocus',
                    enabled: '=?skEnabled',
                    variaveis: '=?skVariaveis',
                    height: '@?skHeight',
                    showImageButton: '=?skShowImageButton',
                    showLinkButton: '=?skShowLinkButton',
                    showTextFormatButtons: '=?skShowTextFormatButtons',
                    hideButtons: '=?skHideButtons',
                    popUpEditEnabled: '=?skPopUpEditEnabled',
                    linkEnabled: '=?skLinkEnabled',
                    onEndEdit: '&skEndEdit',
                    autoResize: '=?skAutoResize',
                },
                link: linkFn
            };


            function linkFn(scope, element, attr, ctrl) {
                var inputElement = element.children()[0];
                var $inputElement = angular.element(inputElement);

                if (Number(attr.skHeight)) {
                    angular.element(inputElement).css({
                        height: StringUtils.toPX(attr.skHeight),
                        maxHeight: StringUtils.toPX(attr.skHeight),
                    });
                }

                if (Number(attr.skPlaceholder)) {
                    angular.element(inputElement).css({
                        height: StringUtils.toPX(attr.skHeight),
                        maxHeight: StringUtils.toPX(attr.skHeight),
                    });
                }

                if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
                    throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
                }

                function setFocus() {
                    $timeout(function () {
                        inputElement.focus();
                    }, 0, false);
                }

                function getSelectionRange() {
                    return {
                        start: inputElement.selectionStart,
                        end: inputElement.selectionEnd
                    };
                }

                ctrl.setFocus = setFocus;
                ctrl.getSelectionRange = getSelectionRange;

                scope.$watch('required', function (newValue) {
                    element[newValue ? 'addClass' : 'removeClass']('required');
                });

                angular.element(inputElement).bind('focus', function () {
                    element.addClass('focus');
                });
                angular.element(inputElement).bind('blur', function () {
                    element.removeClass('focus');

                    if (angular.isFunction(scope.onFocusOut)) {
                        scope.onFocusOut();
                    }
                });

                if (scope.size && UserAgentUtils.isSafari()) {
                    $inputElement.bind('keypress', function (evt) {
                        if (scope.value && scope.value.length >= scope.size) {
                            var selStart = evt.target.selectionStart;
                            var selEnd = evt.target.selectionEnd;

                            return (selStart != selEnd);
                        }

                        return true;
                    });
                }

                if (attr.skDatagridEditor == 'true') {
                    inputElement.focus();

                    $timeout(function () {
                        inputElement.select();
                    }, 0, false);
                }
            }
        }]);
/**
 * @ngdoc directive
 * @name snk.components.entitycard.directive:sk-rich-text-link
 * @restrict E
 * @description
 *  Diretiva que renderiza um link para o popup de um richtext.
 *
 * @element ANY
 *
 * @example
 <example module="app">
 <file name="index.html">
 <sk-entity-card>
 </sk-entity-card>
 </file>
 <file name="app.js">
 angular
 .module('app', ['snk']);
 </file>
 </example>
 */
angular
    .module('snk.components.input')
    .directive('skRichTextLink', ['RichTextPopupService',
        function (RichTextPopupService) {
            return {
                restrict: 'E',
                scope: {
                    label: '=skLabel',
                    value: '=skValue',
                    enabled: '=skEnabled',
                    isRichText: '=?skIsRichText',
                    popUpEditEnabled: '=?skPopUpEditEnabled',
                    linkEnabled: '=?skLinkEnabled'
                },
                template: getTemplate,
                link: linkFn
            };

            function getTemplate(tElem, tAttrs) {
                var template = '<a ng-bind="label" class="link" ng-click="openPopUp()"></a>';
                
                if (angular.isDefined(tAttrs.linkEnabled) && !tAttrs.linkEnabled) {
                    template = '<span ng-bind="label"></span>';
                }


                return template;
            }

            function linkFn($scope) {
                $scope.openPopUp = openPopUp;

                function openPopUp() {
                    RichTextPopupService
                        .open($scope.label, $scope.value, $scope.enabled, $scope.isRichText, $scope.popUpEditEnabled)
                        .then(function (result) {
                            $scope.value = result;
                        });
                }
            }

        }]);

angular
    .module('snk.components.input')
    .controller('SkRichTextPopUpController', ['$scope', '$popupInstance', 'SkConstants', 'value', 'enabled', 'isRichText', 'popUpEditEnabled', function ($scope, $popupInstance, SkConstants, value, enabled, isRichText, popUpEditEnabled) {
        $scope.value = value;
        $scope.enabled = enabled;
        $scope.isRichText = isRichText;
        $scope.popUpEditEnabled = popUpEditEnabled;
        
        if (angular.isUndefined(isRichText)) {
            $scope.isRichText = false;
        }
        if (angular.isUndefined(popUpEditEnabled)) {
            $scope.popUpEditEnabled = true;
        }

        $scope.onKeyDown = function($event) {
            var keyCode = $event.which || $event.keyCode;

            if ($event.ctrlKey && keyCode === SkConstants.KEY_CODE.ENTER) {
                $scope.$success();
            }
        };

        $scope.$success = function(){
            $popupInstance.success($scope.value);
        };
    }]);
/**
 * Created by bruno.brandao on 31/05/2017.
 */
angular
    .module('snk.components.input')
    .service('RichTextPopupService', ['SanPopup', 'i18n', function (SanPopup, i18n) {
        var self = this;

        self.open = open;

        function open(fieldDescr, value, enabled, isRichText, popUpEditEnabled) {
            var popupInstance = SanPopup.open({
                templateUrl: 'components/input/richtext/richtextlink/richtextpopup.tpl.html',
                title: i18n('RichTextLink.lblEditandoCampo', {campo: fieldDescr}),
                okBtnTooltip: i18n('Geral.lblAtalhoCtrlEnter'),
                size: 'md',
                controller: 'SkRichTextPopUpController',
                controllerAs: 'ctrl',
                windowClass: 'sk-rich-text-link-popup',
                resolve: {
                    value: function () {
                        return value
                    },
                    enabled: function () {
                        return enabled
                    },
                    isRichText: function () {
                        return isRichText
                    },
                    popUpEditEnabled: function () {
                        return popUpEditEnabled
                    }
                    
                }
            });

            return popupInstance.result;
        }

    }]);
angular
    .module('snk.components.input')
    .controller('SkSearchinputController', ['$scope',
        function ($scope) {
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-search-input
 * @restrict E
 * @scope
 * @description
  	Componente de Input standalone simples para buscas.
 *
 * @example
 <example module="appSearchInput">
	 <file name="appSearchInput.html">
		<div ng-controller="TesteController">
                <div>
                    Campo:
                    <sk-search-input 
                    	sk-value="value" 
                    	sk-placeholder="Digite para Filtrar..." 
                    	sk-change="onChange()" 
                    	sk-on-click="onClick">
                	</sk-search-input>
                    <p>Valor: {{value}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in logs track by $index"/>
                </div>
            </div>
       </div>
	 </file>
	 <file name="appSearchInput.js">
		angular
	        .module('appSearchInput', ['snk'])
	        .controller('TesteController', TesteController);
	
	    function TesteController($scope){
	        $scope.logs = [];
	
			$scope.onChange = function(){
			  	$scope.logs.push($scope.value);
			};
			
			$scope.onClick = function(){
			    window.alert($scope.value);
			};
	    }
     </file>
 </example>
 */

angular
    .module('snk.components.input')
    .directive('skSearchInput', ['AngularUtil', 'StringUtils', '$timeout', function (AngularUtil, StringUtils, $timeout) {
        var directive = {};

        directive.restrict = 'E';
        directive.templateUrl = 'components/input/search/searchinput.tpl.html';
        directive.controller = 'SkSearchinputController';

        directive.scope = {
            placeholder: "@?skPlaceholder",
            value: "=skValue",
            debounce: '@skDebounce',
            onClick: "=?skOnClick",
            onChange: "&?skChange",
            onKeyDown: '&?skKeydown',
            onFocusOut: '&?skFocusOut',
            searchOptions: '=?skSearchOptions',
            cancelSearch: '&?skCancelSearch',
            enabled: '=?skEnabled',
            searchTooltip: '@?skSearchTooltip',
            toolTipPlacement: '@?skToolTipPlacement',
            inputHelptip: "@?skInputHelptip"
        };

        directive.compile = function(element, attr) {
            if (angular.isDefined(attr.autofocus)) {
                element.removeAttr('autofocus');
                element.find('input').attr('autofocus', '');
            }

            return link;
        };

        function link(scope, element, attrs, ctrl) {
            var debounce = isNaN(scope.debounce) ? 100 : Number(scope.debounce);
            var debouncedChangeFn = AngularUtil.debounce(onChangeValue,  debounce, scope, true);

            if (attrs.skSearchOptions) {
                element.addClass('has-options');
            }

            if (attrs.skCancelSearch) {
                element.addClass('has-cancel-btn');
            }
           
            scope.$watch('value', debouncedChangeFn);

            scope.onCancelSearch = function() {
                scope.value = '';
            };

            scope.onInputKeyDown = function($event) {
                if (scope.onKeyDown) {
                    scope.onKeyDown({$event: $event});
                }
            };
            
            scope.onCodeInputFocusOut = function() {
            	if (scope.onFocusOut) {
            		scope.onFocusOut();
            	}
            }

            function verifyAutofocus(){
                $timeout(function () {
                    let hasAutofocus = element.find('input')[0];

                    if (angular.isDefined(hasAutofocus) && hasAutofocus.autofocus) {
                        ctrl.setFocus();
                    }
                }, debounce, false);
            }

            function onChangeValue(newV, oldV) {
                if (StringUtils.isEmpty(newV) && StringUtils.isNotEmpty(oldV) && scope.cancelSearch) {
                    scope.cancelSearch(scope);
                } else {
                    (scope.onChange || angular.noop)(scope);
                }
                
                // Função verifica se o componente tem o autofocus setado como true, e seta o foco no input do componente de acordo com o debounce
                verifyAutofocus();
            }

            ctrl.setFocus = function() {
                element.find('input').focus();
            };
            
            ctrl.select = function() {
            	element.find('input').select();
            };

            element.bind('focus', function() {
                ctrl.setFocus();
            });

            element[0].addEventListener('keyup', function(evt) {
                if (!scope.onKeyDown && evt.which === 13 && scope.onClick) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    scope.onClick(evt);
                }
            }, true);
        }

        return directive;
    }]);

/**
 * Created by cleverson.puche on 06/04/2016.
 */

angular
    .module('snk.components.input')
    .controller('SkPopUpSelectDistinctController',['$scope', '$timeout', '$popupInstance', 'ServiceProxy', 'entityName', 'fieldName', 'ObjectUtils', 'StringUtils', 'afterLoad', 'SkConstants', 'DomUtil', 'dataProvider', 'presentationField',
        function($scope, $timeout, $popupInstance, ServiceProxy, entityName, fieldName, ObjectUtils, StringUtils, afterLoad, SkConstants, DomUtil, dataProvider, presentationField) {
            var self = this;

            var _currentActiveIndex = -1;
            var _filteredItems = [];

            $scope.dataProvider = [];

            $scope.textToColor = StringUtils.textToColor;
            $scope.buildNick = StringUtils.buildNick;
            $scope.selectItem = selectItem;
            $scope.onKeydown = onKeydown;

            init();

            function init() {

                if(!dataProvider){
                    var request = {
                        selectDistinct: {
                            instancia: entityName,
                            coluna: fieldName
                        }
                    };

                    ServiceProxy.callService('mge@Pesquisa.getSelectDistinct', request).then(
                        function(result) {
                            var items = ObjectUtils.getProperty(result,'responseBody.ocorrencias.ocorrencia');
                            if(items) {
                                items.forEach(function(item) {
                                    $scope.dataProvider.push({
                                        label: item.$,
                                        active: false
                                    })
                                });
                            }

                            if(angular.isDefined(afterLoad)) {
                                var newDS = afterLoad($scope.dataProvider);
                                
                                if (angular.isArray(newDS)) {
                                    $scope.dataProvider = newDS;
                                }
                            }
                        }
                    );
                }else{

                    if(angular.isDefined(afterLoad)) {
                        var newDS = afterLoad($scope.dataProvider);
                                    
                        if (angular.isArray(newDS)) {
                            $scope.dataProvider = newDS;
                        }
                    }else{
                        $scope.dataProvider = dataProvider;
                    }
                }
            }

            function selectItem(itemLabel) {
                $popupInstance.success(itemLabel);
            }

            function onKeydown(event) {
                switch(event.keyCode) {
                    case SkConstants.KEY_CODE.UP_ARROW:
                        changeActiveItem(SkConstants.KEY_CODE.UP_ARROW);
                        break;
                    case SkConstants.KEY_CODE.DOWN_ARROW:
                        changeActiveItem(SkConstants.KEY_CODE.DOWN_ARROW);
                        break;
                    case SkConstants.KEY_CODE.HOME:
                        goToFirstOrLast('first');
                        break;
                    case SkConstants.KEY_CODE.END:
                        goToFirstOrLast('last');
                        break;
                    case SkConstants.KEY_CODE.ENTER:
                        if($scope.dataProvider[_currentActiveIndex] !== undefined){
                            selectItem($scope.dataProvider[_currentActiveIndex].label);
                        }
                        break;
                    default:
                        $timeout(function() {
                            rebuildFilteredLabels();
                        }, 0, false);
                        break;
                }
            }

            function rebuildFilteredLabels() {
                if(angular.isUndefined($scope.searchTerm)) {
                    return;
                }

                _filteredItems = [];
                for(var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                    if($scope.dataProvider[i].label != undefined && $scope.dataProvider[i].label.toLowerCase().indexOf($scope.searchTerm.toLowerCase()) > -1) {
                        _filteredItems.push($scope.dataProvider[i]);
                    }
                }
            }

            function changeActiveItem(direction) {
                if(direction == SkConstants.KEY_CODE.UP_ARROW) {
                    if (StringUtils.isEmpty($scope.searchTerm) && $scope.dataProvider[_currentActiveIndex - 1]) {
                        $scope.dataProvider[_currentActiveIndex].active = false;
                        $scope.dataProvider[_currentActiveIndex - 1].active = true;
                        scrollToIndex(_currentActiveIndex - 1);
                        _currentActiveIndex--;
                    } else if(StringUtils.isNotEmpty($scope.searchTerm)) {
                        var i = _currentActiveIndex > -1 ? _currentActiveIndex-1 : $scope.dataProvider.length-1;
                        do {
                            if($scope.dataProvider[i] && $scope.dataProvider[i].label.toLowerCase().indexOf($scope.searchTerm.toLowerCase()) > -1) {
                                if(_currentActiveIndex > -1) {
                                    $scope.dataProvider[_currentActiveIndex].active = false;
                                }
                                $scope.dataProvider[i].active = true;
                                scrollToIndex(_filteredItems.indexOf($scope.dataProvider[i]));
                                _currentActiveIndex = i;
                                return;
                            }

                            i--;
                        } while(i >= 0);
                    }
                } else if(direction == SkConstants.KEY_CODE.DOWN_ARROW) {
                    if (StringUtils.isEmpty($scope.searchTerm) && $scope.dataProvider[_currentActiveIndex + 1]) {
                        if(_currentActiveIndex > -1) {
                            $scope.dataProvider[_currentActiveIndex].active = false;
                        }
                        $scope.dataProvider[_currentActiveIndex + 1].active = true;
                        scrollToIndex(_currentActiveIndex + 1);
                        _currentActiveIndex++;
                    } else if(StringUtils.isNotEmpty($scope.searchTerm)) {
                        var i = _currentActiveIndex > -1 ? _currentActiveIndex+1 : 0;
                        var length = $scope.dataProvider.length;
                        do {
                            if($scope.dataProvider[i] && $scope.dataProvider[i].label.toLowerCase().indexOf($scope.searchTerm.toLowerCase()) > -1) {
                                if(_currentActiveIndex > -1) {
                                    $scope.dataProvider[_currentActiveIndex].active = false;
                                }
                                $scope.dataProvider[i].active = true;
                                scrollToIndex(_filteredItems.indexOf($scope.dataProvider[i]));
                                _currentActiveIndex = i;
                                return;
                            }

                            i++;
                        } while(i < length);
                    }
                }
            }

            function goToFirstOrLast(position) {
                var position = position.toLowerCase();

                if(position != 'first' && position != 'last') {
                    return;
                }

                if(_currentActiveIndex > -1) {
                    $scope.dataProvider[_currentActiveIndex].active = false;
                }

                if(position == 'first') {
                    if(_filteredItems.length > 0) {
                        _filteredItems[0].active = true;
                        _currentActiveIndex = $scope.dataProvider.indexOf(_filteredItems[0]);
                    } else {
                        $scope.dataProvider[0].active = true;
                        _currentActiveIndex = 0;
                    }

                    scrollToIndex(0);
                } else {
                    if(_filteredItems.length > 0) {
                        _filteredItems[_filteredItems.length-1].active = true;
                        _currentActiveIndex = $scope.dataProvider.indexOf(_filteredItems[_filteredItems.length-1]);
                        scrollToIndex(_filteredItems.length-1);
                    } else {
                        $scope.dataProvider[$scope.dataProvider.length-1].active = true;
                        _currentActiveIndex = $scope.dataProvider.length-1;
                        scrollToIndex(_currentActiveIndex);
                    }
                }
            }

            function scrollToIndex(index) {
                $timeout(function () {
                    DomUtil.scrollToChildIndex($popupInstance.element.find('.popup-select-distinct-items-container'), index);
                }, 0, false);
            }
        }
    ]);

/**
 * Created by cleverson.puche on 06/04/2016.
 */

angular
    .module('snk.components.input')
    .controller('SkSelectDistinctInputController', ['$scope','$attrs', '$element', '$timeout', 'SkI18nService', 'SanPopup', 'ObjectUtils', 'StringUtils',
        function ($scope,$attrs, $element, $timeout, SkI18nService, SanPopup, ObjectUtils, StringUtils) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            self.getValue = getValue;
            
            $scope.textInputChangeHandler = textInputChangeHandler;
            $scope.openPopUpSelectDistinctField = openPopUpSelectDistinctField;
            $scope.changeHandler = changeHandler;
            $scope.selectedDistinctInputApi = self;

            init();

            function init() {

                if(!$attrs.skDataProvider){

                    if (!$attrs.skFieldName && !$attrs.skFieldIndex) {
                            throw new Error(SkI18nService.instant("SanDB.Comum.messageInformarPropriedade", ["fieldName ou fieldIndex"]));
                    }
                    
                    /*if (!$attrs.skDataset) {
                        throw new Error(SkI18nService.instant("SanDB.Comum.messageInformarPropriedade", ["dataSet"]));
                    }*/
                }
            }

            function getColumnName() {
                return $scope.columnName || $scope.fieldName;
            }

            function openPopUpSelectDistinctField() {
                let validaFieldName = $scope?.dataset?.getFieldMetadata($scope.fieldName).description;

                if (!validaFieldName) {
                    validaFieldName = getColumnName();
                }
                SanPopup.open({
                    scope: $scope,
                    title: SkI18nService.instant('Controls.SelectDistinct.titlePesquisando', [validaFieldName]),
                    templateUrl: 'components/input/selectdistinct/popupselectdistinct/popupselectdistinct.tpl.html',
                    controller: 'SkPopUpSelectDistinctController',
                    type: 'default',
                    showBtnCancel: false,
                    okBtnLabel: SkI18nService.instant('Geral.lblFechar'),
                    okBtnClass: 'btn-default',
                    windowClass: 'datagrid-modal-window',
                    resolve: {
                        entityName: function () {
                            return angular.isDefined($scope.entityName) ? $scope.entityName : angular.isDefined($scope.dataset) ? $scope.dataset.getEntityName() : undefined;
                        },
                        fieldName: function () {
                            return getColumnName();
                        },
                        afterLoad: function () {
                            return $scope.afterLoad;
                        },
                        dataProvider: function(){
                            return $scope.dataProvider;
                        },
                        presentationField: function(){
                            return $scope.presentationField;
                        }
                    }
                }).result.then(function (item) {
                    if (angular.isUndefined(item)) {
                        return;
                    }

                    if ($scope.size > 0 && StringUtils.isNotEmpty(item) && item.length > $scope.size) {
                        item = (item.substr(0, $scope.size)).trim();
                    }

                    if($scope.keyDelimiter){
                        var pos = item.indexOf($scope.keyDelimiter);
                        if (pos > 0) {
                            item = item.substr(0, pos - 1);
                        }
                    }

                    setData(item);
                    changeHandler();
                });
            }

            function getValue(){
                return $scope.value;
            }

            function getData(){
                return $scope.value;
            }

            function textInputChangeHandler(value){
                setData(value, false);
                runOnChange();
            }

            function setData(data) {
                $scope.value = data;
            }

            function changeHandler() {
                if (self.useDataset($scope)) {
                    $scope.$evalAsync(function(){
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }
        
                runOnChange();
            }
        
            function runOnChange() {
                $timeout(function(){
                    ($scope.onChange || angular.noop)({$value: $scope.value});
                }, 0, true);
            }
        }
    ]);
/**
 * Created by cleverson.puche on 06/04/2016.
 */

/**
 * @ngdoc directive
 * @name snk.components.selectdistinctinput.directive:sk-select-distinct-input
 * @restrict E
 * @scope
 * @description
 	skSelectDistinctInput é o componente que permite digitação livre de strings, mas também permite pesquisar
 pelos valores já digitados.

 * @param {object} skDataset Referência para o dataset no qual o componente deve se basear.
 * @param {string} skFieldName Nome do campo o qual o componente diz respeito.
 * @param {function} skAfterLoad Função a ser executada após a carga dos valores já digitados.
 * @param {string} skEntityName Entidade que contém o campo informado no parâmetro <i>fieldName</i>.
 */
angular
    .module('snk.components.input')
    .directive('skSelectDistinctInput', ['AngularUtil', function (AngularUtil) {
        return {
            restrict: 'E',
            controller: 'SkSelectDistinctInputController',
            templateUrl: 'components/input/selectdistinct/selectdistinctinput.tpl.html',
            scope: {
            	selectedDistinctInputApi: '=?skSelectedDistinctInputApi',
                dataset: '=skDataset',
                dataProvider: '=?skDataProvider',
                value: "=?skValue",
                fieldName: '@skFieldName',
                enabled: '=?skEnabled',
                fieldIndex: '@?skFieldIndex',
                columnName: '@skColumnName',
                afterLoad: '=?skAfterLoad',
                entityName: '@?skEntityName',
                onChange: '&?skChange',
                size: '=?skSize',
                restrict: '@?skRestrict',
                keyDelimiter: '@?skKeyDelimiter'
            },
            link: function (scope, $element, $attr, ctrl) {
                var textInputElem = $element.find('sk-text-input');
                var textInputController = AngularUtil.getControllerFromElement(textInputElem);

                ctrl.setFocus = setFocus;
                ctrl.highlightField = highlightField;
                ctrl.unHighlightField = unHighlightField;

                function setFocus() {
                    AngularUtil.timeout(function () {
                        textInputController.setFocus();
                    });
                }

                function highlightField() {
                    textInputController.highlightField();
                }

                function unHighlightField() {
                    textInputController.unHighlightField();
                }
            }
        }
    }]);

angular
    .module('snk.components.input')
    .controller('SkSwitchController', ['$scope', '$timeout', 'ObjectUtils', 'StringUtils', '$element', '$attrs', 'SkConstants', 'i18n',
function ($scope, $timeout, ObjectUtils, StringUtils, $element, $attrs, SkConstants, i18n) {
    var _ngModelCtrl;
    var self = this;
    $scope.attrs = $attrs;
    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        getData: getData,
        setNgModelCtrl: setNgModelCtrl
    });

    $scope.changeHandler = changeHandler;
    $scope.id = StringUtils.nextUid();
    $scope.trueValue = $scope.trueValue || 'S';
    $scope.falseValue = $scope.falseValue || 'N';

    $scope.$watch('value', function(newValue){
        $scope.viewValue = isTrue(newValue);
    });

    $scope.$watch('switchLabel', function(){
        $scope.switchLabel = i18n($attrs['skSwitchLabel']);
    });

    $scope.$watch('enabled', function(isEnabled){
        if (isEnabled){
            $element.attr('tabindex', $attrs.tabindex);
        } else {
            $element.attr('tabindex', '-1');
        }
    });

    $scope.triggerClickCheckbox = triggerClickCheckbox;

    self.registerEvents = registerEvents;

    function isTrue(value){
        return String(value) == $scope.trueValue;
    }

    function getModelValue(value){
        if (value){
            return angular.isDefined($scope.$eval($scope.trueValue)) ? $scope.$eval($scope.trueValue) : $scope.trueValue;
        } else {
            return angular.isDefined($scope.$eval($scope.falseValue)) ? $scope.$eval($scope.falseValue) : $scope.falseValue;
        }
    }

    function setNgModelCtrl(ngModelCtrl) {
        _ngModelCtrl = ngModelCtrl;

        _ngModelCtrl.$formatters.push(function (value) {
            $scope.value = getModelValue(value);

            return value;
        });

        _ngModelCtrl.$parsers.push(function(value){
            $scope.value = getModelValue(value);

            return value;
        });
    }

    function changeHandler() {
        self.notifyChangeToDataset();

        runOnChange();
    }

    function runOnChange() {
        $timeout(function(){
            ($scope.onChange || angular.noop)($scope);
        }, 0, true);
    }

    function getData(){
        return $scope.value;
    }

    function setData(data) {
        $scope.value = data;
        $scope.viewValue = isTrue(data);

        runOnChange();
    }

    function registerEvents() {
        $element.bind(SkConstants.EVENTS.FOCUS, function() {
            $element.addClass('sk-focused');
        });

        $element.bind(SkConstants.EVENTS.BLUR, function() {
            $element.removeClass('sk-focused');
        });

        $element.bind(SkConstants.EVENTS.KEY_DOWN, function(event) {
            if (event.which === SkConstants.KEY_CODE.SPACE) {
                event.preventDefault();

                triggerClickCheckbox();
            }
        });
    }

    function triggerClickCheckbox(event) {
        if (!$scope.enabled || $scope.preventClick){
            event && event.preventDefault();
            return;
        }

        $scope.viewValue = !$scope.viewValue;
        $scope.value = getModelValue($scope.viewValue);

        changeHandler();
    }
}]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-switch
 * @restrict E
 * @scope
 * @description
     Componente de marcação, análogo ao checkbox. Pode-se definir qual é o valor que o torna verdadeiro e falso.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-true-value=S]
    Determina o valor verdadeiro do componente.

 * @param {string} [sk-false-value=N]
    Determina o valor falso do componente.
    
 * @param {string} [sk-switch-label=undefined]
    Determina o label do componente.
 *
 * @example
     <example module="appSwitch">
         <file name="appSwitch.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                </div>
                <div>
                    <sk-switch
                        sk-value="value"
                        sk-change="onChange()"
                        sk-true-value="S"
                        sk-false-value="N"
                        sk-enabled="enabled"></sk-switch>
                    <p>Valor: {{value}}</p>
                </div>
                <h4>Log de alterações:</h4>
                    <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appSwitch.js">
            angular
                .module('appSwitch', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.value = 'S';
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.value);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skSwitch', ['$timeout', 'SkConstants', 'UserAgentUtils',
function ($timeout, SkConstants, UserAgentUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            trueValue: '@?skTrueValue',
            falseValue: '@?skFalseValue',
            wide: '@?skWide',
            preventClick: '=?skPreventClick',
            switchLabel: '=?skSwitchLabel'
        },
        templateUrl: 'components/input/switch/switch.tpl.html',
        controller: 'SkSwitchController',
        link: linkFn
    };

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.find('input')[0];
        var labelElement = element.find('span.sk-container')[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');

        ctrl.setFocus = setFocus;
        ctrl.setNgModelCtrl(ngModelCtrl);
        ctrl.registerEvents();

        if (attr.skDatagridEditor == 'true') {
            inputElement.focus();
        }

        if (attr.autofocus) {
            angular.element(inputElement).attr('autofocus');
            setFocus();
        }

        var $inputElement = angular.element(inputElement);
        $inputElement.bind('focus', function () {
            element.addClass('focused');
            (scope.onFocus || angular.noop)(scope);
        });

        $inputElement.bind('blur', function () {
            element.removeClass('focused');
            (scope.onFocusOut || angular.noop)(scope);
        });

        //Se está sendo utilizado no aggrid temos que cancelar a navegação com as setas
        if(attr.hasOwnProperty('aggrid')){
            element.bind(SkConstants.EVENTS.KEY_DOWN, function(event) {
                if (   event.which === SkConstants.KEY_CODE.LEFT_ARROW 
                    || event.which === SkConstants.KEY_CODE.RIGHT_ARROW
                    || event.which === SkConstants.KEY_CODE.UP_ARROW
                    || event.which === SkConstants.KEY_CODE.DOWN_ARROW){
                    
                    event.preventDefault();
                }
            });
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkTextInputController', ['StringUtils', '$scope', '$timeout', '$element', 'ObjectUtils', '$attrs', 'NumberUtils', 'AngularUtil',
function (StringUtils, $scope, $timeout, $element, ObjectUtils, $attrs, NumberUtils, AngularUtil) {
    var self = this;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        setNgModelCtrl: setNgModelCtrl
    });

    $scope.changeHandler = changeHandler;
    $scope.valueOptions = $scope.valueOptions || {};
    $scope.onInputKeydown = onInputKeydown;

    $scope.$watch('enableDrop', function(newV){
            setupDrop(newV);
    });    

    function onInputKeydown($event) {
        if ($scope.onKeydown) {
            $scope.onKeydown({$event: $event});
        }
    }

    function changeHandler() {
        if (self.useDataset($scope)) {
            $scope.$evalAsync(function(){
                $scope.dataset.notifyEditionStart(self);
                $scope.dataset.setModified(self);
            });
        }

        runOnChange();
    }

    function runOnChange() {
        if ($attrs.skBeforeChange) {
            $scope.beforeChange({$value: $scope.value});
        }

        if ($attrs.skChange) {
            $timeout(function(){
                $scope.onChange($scope);
            });
        }

        if ($attrs.skFinishChange) {
            if(angular.isDefined($scope.value) && angular.isDefined($scope.size)){
                if($scope.value.length ==  $scope.size){
                    $scope.finishChange();
                }
            }
        }
    }

    function setData(data) {
        $scope.value = data;

        runOnChange();
    }

    function setNgModelCtrl(ngModelCtrl) {
        if (angular.isDefined($scope.restrict) && StringUtils.isNotEmpty($scope.restrict)) {
            AngularUtil.addRegexOnlyParser(ngModelCtrl, $scope.restrict);
        }

        ngModelCtrl.$formatters.push(function (value) {
            if($scope.decimalTime) {
                var modelValue = angular.isString(value) ?  cleanDecimalTime(value) : value;
                ngModelCtrl.$modelValue = modelValue;
                return formatDecimalTime(angular.isString(value) ? cleanDecimalTime(value) : value);
            } else if ($scope.onlyNumbers) {
                return formatToView(value);
            } else {
                return value;
            }
        });

        ngModelCtrl.$parsers.push(function (value) {
            if(angular.isString(value) && $scope.decimalTime) {
                var viewValue = formatDecimalTime(angular.isString(value) ?  cleanDecimalTime(value) : value);
                ngModelCtrl.$viewValue = viewValue;
                ngModelCtrl.$render();
         
                return value ?  cleanDecimalTime(value) : value;
            } else if (angular.isString(value) && $scope.onlyNumbers){
                let transformed = NumberUtils.formatNumber(value, false);

                if (transformed != value){
                    value = transformed;
                    ngModelCtrl.$setViewValue(transformed);
                    ngModelCtrl.$render();
                }
            }

            return value;
        });
    }

    function formatToView(value) {
        if (value){
            if($scope.showThousandSeparator || angular.isUndefined($scope.showThousandSeparator)){
            return NumberUtils.format(value, 0);
        } else {
                return NumberUtils.formatWithoutThousandSeparator(value, 0);
    }
        } else {
            return value;
        }
    }

    function formatDecimalTime(data) {
        if(data) {
            data = data.toString();
            let formatted;
            if(data.length == 1) {
                formatted = `00:0${data}`;
            } else if(data.length == 2) {
                formatted = `00:${data}`;
            } else if(data.length == 3){
                let end = data.substr(-2);
                let start = data.substr(0, data.length - 2);
                formatted = `0${start}:${end}`;
            } else if(data.length >= 3) {
                let end = data.substr(-2);
                let start = data.substr(0, data.length - 2);
                formatted = `${start}:${end}`;
            }
            return formatted;
        } else {
            return data;
        }
    }

    function cleanDecimalTime(data) {
        let clean = data.replace(":", "");
        return Number(clean).toString();
    }

    function setupDrop(enable){
        $element.off('dragenter', dragenter);
        $element.off('dragover', dragover);
        $element.off('drop', drop);

        if(enable){
            $element.on('dragenter', dragenter);
            $element.on('dragover', dragover);
            $element.on('drop', drop);
        }
    }

    function dragenter(event){
        if(angular.isFunction($scope.dragEnter)){
             $scope.dragEnter({event : event});
        }
    }
    
    function dragover(event){
        if(angular.isFunction($scope.dragOver)){ 
            $scope.dragOver({event : event});
        }
        event.preventDefault();
    }
    
     function drop(event){
        if(angular.isFunction($scope.dragDrop)){
            $scope.dragDrop({event : event});
        }
    }

}]);

/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-text-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao input convencional do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=false]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento do texto no componente.
 *
 * @param {string} [sk-password=false]
 Determina se o componente será apresentado como um campo de senha
 *
 * @param {string} [sk-restrict]
    Informar a regex de aceitação de entradas de caracteres no campo. Por exemplo, caso deseje aceitar apenas números passe sk-restrict="[^0-9]".
 *
 * @example
     <example module="appTextInput">
         <file name="appTextInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-text-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-text-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appTextInput.js">
            angular
                .module('appTextInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = '';
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skTextInput', ['$timeout', 'StringUtils', 'UserAgentUtils', 'SkI18nService',
function ($timeout, StringUtils, UserAgentUtils, SkI18nService) {
    return {
        scope: {
            id: '@skId',
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            valueOptions: '=?skValueOptions',
            align: '@?skAlign',
            onChange: '&?skChange',
            beforeChange: '&?skBeforeChange',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            placeholder: '@?skPlaceholder',
            onKeydown: '&?skKeydown',
            size: '=?skSize',
            disableOnInsertion: '=skDisableOnInsertion',
            onlyNumbers: '=skOnlyNumbers',
            showThousandSeparator: '=skShowThousandSeparator',
            decimalTime: '=skDecimalTime',
            restrict: '@?skRestrict',
            onEndEdit: '&?skEndEdit',
            finishChange: '&?skFinishChange',
            enableDrop: '=?skDropEnabled',
            dragEnter: '&?skDragEnter',
            dragOver: '&?skDragOver',
            dragDrop: '&?skDragDrop',
            focusOutControle:  '=?skFocusOutControle',
        },
        template: getTemplate,
        controller: 'SkTextInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template = '<input type="{compType}" id="{{id}}" class="form-control" ng-model="value" ng-model-options="valueOptions" ng-attr-placeholder="{{placeholder}}" ng-disabled="!enabled" ng-required="required" ng-change="changeHandler()" ng-keydown="$event.keyCode !== 13 && onInputKeydown($event)" ng-keyup="$event.keyCode === 13 && onInputKeydown($event)" maxlength="{{size}}" {style} {gridEditor} {autofocus} ng-blur="onControleInputFocusOut()"/>';
        var styles = [];
        var finalStyle;

        if(tAttrs.skAlign) {
            styles.push("\'text-align\': '" + tAttrs.skAlign + "'");
        }

        if(tAttrs.skDisplayAsUpperCase) {
            styles.push("\'text-transform\':  \'uppercase\'");
        }

        if(styles.length > 0) {
            finalStyle = 'ng-style="{' + styles.join(",") + '}"';
        }

        var templateArgs = {
            style: finalStyle,
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            compType: angular.isDefined(tAttrs.skPassword) ? 'password' : 'text',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;

        var inputElement = element.children()[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        if(scope.required){
            inputElement.title = SkI18nService.instant('TextInput.preenchaCampo');
        }

        scope.onControleInputFocusOut = function() {
            if (scope.onFocusOut && scope.focusOutControle) {
                scope.onFocusOut();
            }
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.setNgModelCtrl(ngModelCtrl);
        ctrl.setFocus = setFocus;
        ctrl.select = select;

        var $inputElement = angular.element(inputElement);

        attr.$observe('skRequired', function(newV) {
            var isRequired = scope.$eval(newV);
            element[isRequired ? 'addClass' : 'removeClass']('required');
        });

        $inputElement.bind('focus', function () {
            element.addClass('focused');
            (scope.onFocus || angular.noop)(scope);
        });

        $inputElement.bind('click', function () {
            if (isDatagrid()) {
                setFocus();
            } else if (!fullSelected) {
                select();
            }
        });

        $inputElement.bind('blur', function () {
            element.removeClass('focused');
            fullSelected = false;
            (scope.onFocusOut || angular.noop)(scope);
        });

        ctrl.setElement($inputElement);

        if (scope.size && UserAgentUtils.isSafari()){
            $inputElement.bind('keypress', function(evt){
                if (scope.value && scope.value.length >= scope.size){
                    var selStart = evt.target.selectionStart;
                    var selEnd = evt.target.selectionEnd;

                    return (selStart != selEnd);
                }

                return true;
            });
        }

        if (isDatagrid()) {
            setFocus();

            $timeout(function () {
                inputElement.select();
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .controller('SkTextAreaController', ['$scope', '$timeout', '$attrs', 'ObjectUtils', '$element', 'ClipboardUtils',
function ($scope, $timeout, $attrs, ObjectUtils, $element, ClipboardUtils) {
    
    const CURRENT_SELECTION = {
        start: 0,
        end: 0
    };
    
    var self = this;
    self.getSelectionRange = getSelectionRange;
    self.clearSelection = clearSelection;

    var inputElem = angular.element($element.children()[0]);
    var clipboardElem = angular.element($element.children()[1]);    

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData
    });

    $scope.changeHandler = changeHandler;

    inputElem.on('mouseup', (evt) => {
        registerCurrentSelect();
    });

    init();

    function init() {
        //quando o text-area-link confirma a edição, o changeHandler não é disparado
        //colocaremos este watch para notificar o dataset;
        if ($attrs.skValue){
            $scope.$watch('value', function(newV, oldV){
                if (newV == oldV) {
                    return;
                }
                
                changeHandler();
            });
        }

        $scope.$watch('enableDrop', function(newV){
            setupDrop(newV);
        });

        ClipboardUtils.bind(clipboardElem, function() {
            return $scope.value;
        });

        buildScroll();
        
        if ($scope.componentCreated) {
        	$scope.componentCreated({$component: self});
        }
    }

    function changeHandler() {
        self.notifyChangeToDataset();
        runOnChange();
    }

    function runOnChange() {
        buildScroll();

        ($scope.onChange || angular.noop)($scope);
    }

    function setData(data) {
        $scope.value = data;

        runOnChange();
    }

    function buildScroll() {
        $timeout(function() {
            if (!$scope.enabled && hasScroll()) {
                $element.addClass('has-scroll');
            } else {
                $element.removeClass('has-scroll');
            }
        }, 0, false);
    }

    function hasScroll() {
        if (inputElem[0].clientHeight < inputElem[0].scrollHeight) {
            return true;
        }

        return false;
    }

    function dragenter(event){
        if($scope.dragEnter) $scope.dragEnter({event : event});
    }
    
    function dragover(event){
        if($scope.dragOver) $scope.dragOver({event : event});
        event.preventDefault();
    }
    
     function drop(event){
        if($scope.dragDrop) $scope.dragDrop({event : event});
    }


    function setupDrop(enable){
        $element.off('dragenter', dragenter);
        $element.off('dragover', dragover);
        $element.off('drop', drop);

        if(enable){
            $element.on('dragenter', dragenter);
            $element.on('dragover', dragover);
            $element.on('drop', drop);
        }
    }

    function registerCurrentSelect(){
        CURRENT_SELECTION.start = inputElem[0].selectionStart;
        CURRENT_SELECTION.end = inputElem[0].selectionEnd;
    }

    function getSelectionRange() {
        return CURRENT_SELECTION;
    }

    function clearSelection(){
        CURRENT_SELECTION.start = CURRENT_SELECTION.end = 0;
        inputElem[0].setSelectionRange(0, 0)
    }

}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-text-area
 * @restrict E
 * @scope
 * @description
     Componente de texto, análogo ao textarea do html.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.

* @param {int} [sk-height=230]
    Determina a altura em pixel do text-area

 * @param {boolean} sk-drop-enabled ativa a função de soltar itens dobre o textarea(drag-and-drop)

 * @param {function} sk-drag-enter Acionado quando uma ekemento entra em um ponto de soltura do textarea

 * @param {function} sk-drag-over Acionado quando um item está sendo arrastado sobre o textarea

 * @param {function} sk-drop Acionado quando um item é solto em um ponto de soltura (drop target) do textarea.
 *
 * @example
     <example module="appTextArea">
         <file name="appTextArea.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-text-area
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-text-area>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appTextArea.js">
            angular
                .module('appTextArea', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = 'Teste';
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skTextArea', ['$timeout', 'StringUtils', 'UserAgentUtils',
function ($timeout, StringUtils, UserAgentUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocus: '&?skFocus',
            onFocusOut: '&?skFocusOut',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            placeholder: '@?skPlaceholder',
            componentCreated: '&?skComponentCreated',
            size: '=?skSize',
            enableDrop: '=?skDropEnabled',
            dragEnter: '&?skDragEnter',
            dragOver: '&?skDragOver',
            dragDrop: '&?skDrop',
            style: "=?skStyle",
            rows: '=?skRows',
            onEndEdit: '&skEndEdit',
        },
        template: getTemplate,
        controller: 'SkTextAreaController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template = '<textarea id="snk-textarea" ng-style="style" class="form-control {layoutClass}" rows="4" ng-model="value" ng-disabled="!enabled" ng-change="changeHandler()" ng-attr-placeholder="{{placeholder | i18n}}" maxlength="{{size}}" {style} {gridEditor} {autofocus} {layout}></textarea>';
        template += '<sk-icon font-icon="copy" class="copy-clipboard" ng-show="!enabled" tooltip="Geral.lblCopiar" tooltip-placement="left" sk-i18n></sk-icon>';

        var templateArgs = {
    		layout: angular.isDefined(tAttrs.flex) ? 'flex' : '',
    		layoutClass: angular.isDefined(tAttrs.flex) ? '' : 'text-area-height',
            style: angular.isDefined(tAttrs.skAlign) ? 'ng-style="{\'text-align\': align}"' : '',
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        if (angular.isDefined(tAttrs.flex)) {
            tElem.attr('layout', 'column');
        }

        return StringUtils.substitute(template, templateArgs);
    }

	function setRowSize($scope, $inputElement) {
        let rowSize = 4 // Tamanho default 

        /* Se a diretiva contem valor, este será usado. Caso contrário criará conforme o tamanho do campo */
        if (angular.isDefined($scope.rows) && Number($scope.rows)){
            rowSize = $scope.rows;
        }else {
            if ($scope.size > 100 && $scope.size <= 300) {
                rowSize = 2
            } else if ($scope.size > 300 && $scope.size <= 600) {
                rowSize = 4
            } else if ($scope.size > 600) {
                rowSize = 6
            } 
        }

        $inputElement.attr('rows', rowSize);
        $inputElement.attr('style', 'resize: vertical');
    }

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];
        var $inputElement = angular.element(inputElement);

        /* Nova regra para definir a quantidade de rows do text-area */
        setRowSize(scope, $inputElement);

        if (Number(attr.skHeight)) {
        	angular.element(inputElement).css({
        		height: StringUtils.toPX(attr.skHeight),
        		maxHeight: StringUtils.toPX(attr.skHeight),
        	});
        }
       
        if (Number(attr.skWidth)) {
        	angular.element(inputElement).css({
        		width: StringUtils.toPX(attr.skWidth),
        		maxWidth: StringUtils.toPX(attr.skWidth),
        	});
        }
        
        if (Number(attr.skPlaceholder)) {
        	angular.element(inputElement).css({
        		height: StringUtils.toPX(attr.skHeight),
        		maxHeight: StringUtils.toPX(attr.skHeight),
        	});
        }

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }
        
        function getSelectionRange() {
        	return {
        		start: inputElement.selectionStart,
        		end: inputElement.selectionEnd
        	};
        }

        ctrl.setFocus = setFocus;
        ctrl.getSelectionRange = getSelectionRange;

        scope.$watch('required', function(newValue){
            element[newValue ? 'addClass' : 'removeClass']('required');
        });

        angular.element(inputElement).bind('focus', function () {
            element.addClass('focus');
            (scope.onFocus || angular.noop)(scope);
        });
        angular.element(inputElement).bind('blur', function () {
            element.removeClass('focus');

            if (angular.isFunction(scope.onFocusOut)){
                scope.onFocusOut();
            }
        });

        ctrl.setElement(inputElement);

      if (scope.size && UserAgentUtils.isSafari()){
        $inputElement.bind('keypress', function(evt){
          if (scope.value && scope.value.length >= scope.size){
            var selStart = evt.target.selectionStart;
            var selEnd = evt.target.selectionEnd;

            return (selStart != selEnd);
          }

          return true;
        });
      }

        if (attr.skDatagridEditor == 'true') {
            inputElement.focus();

            $timeout(function () {
                inputElement.select();
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .service('TextInsert', function () {
        var textInsert = {
            insert: insert
        }
		
		/*
		  Modo de uso 
		  TextInsert.insert(angular.element('#input1')[0], 'Texto blablabla');
		*/

        function insert(input, text) {
            if (!input) {
                return;
            }

            var scrollPos = input.scrollTop
            var pos = 0

            if (input.selectionStart || input.selectionStart == '0') {
                browser = 'ff';
            } else if (document.selection) {
                browser = 'ie';
            } else {
                browser = false;
            }

            if (browser == 'ie') {
                input.focus()
                range = document.selection.createRange()
                range.moveStart('character', -input.value.length)
                pos = range.text.length

                input.focus()
                range = document.selection.createRange()
                range.moveStart('character', -input.value.length)
                range.moveStart('character', pos)
                range.moveEnd('character', 0)
                range.select()
            } else if (browser == 'ff') {
                pos = input.selectionStart
                front = (input.value).substring(0, pos)
                back = (input.value).substring(pos, input.value.length)
                input.value = front + text + back
                pos = pos + text.length

                input.selectionStart = pos
                input.selectionEnd = pos
                input.focus()
                input.scrollTop = scrollPos
                angular.element(input).trigger('input')
            }
        }

        return textInsert;
    });
/**
 * @ngdoc directive
 * @name snk.components.entitycard.directive:sk-text-area-link
 * @restrict E
 * @description
 *  Diretiva que renderiza um link para o popup de um textarea.
 *
 * @element ANY
 *
 * @example
 <example module="app">
 <file name="index.html">
 <sk-entity-card>
 </sk-entity-card>
 </file>
 <file name="app.js">
 angular
 .module('app', ['snk']);
 </file>
 </example>
 */
angular
    .module('snk.components.input')
    .directive('skTextAreaLink', ['TextAreaPopupService',
        function (TextAreaPopupService) {
            return {
                restrict: 'E',
                scope: {
                    label: '=skLabel',
                    value: '=skValue',
                    enabled: '=skEnabled',
                    dataset: '=?skDataset',
                    fieldName: '=?skFieldName',
                    isRichText: '=skIsRichText'
                },
                template: '<a ng-bind="label" class="link textAreaLinkModified" ng-click="openPopUp()"></a>',
                link: linkFn
            };

            function linkFn($scope) {
                $scope.openPopUp = openPopUp;

                function openPopUp() {
                    if ($scope.dataset) {
                        TextAreaPopupService
                            .open($scope.label, $scope.dataset.getFieldValue($scope.fieldName), $scope.enabled, $scope.isRichText)
                            .then(function (result) {
                                $scope.dataset.setFieldValue($scope.fieldName, result);
                            });
                    } else {
                        TextAreaPopupService
                            .open($scope.label, $scope.value, $scope.enabled, $scope.isRichText)
                            .then(function (result) {
                                $scope.value = result;
                            });
                    }
                    
                }
            }

        }]);

angular
    .module('snk.components.input')
    .controller('SkTextAreaPopUpController', ['$scope', '$popupInstance', 'SkConstants', 'value', 'enabled', 'isRichText', function ($scope, $popupInstance, SkConstants, value, enabled, isRichText) {
        $scope.value = value;
        $scope.enabled = enabled;
        $scope.isRichText = isRichText;
        
        if (angular.isUndefined(isRichText)) {
            $scope.isRichText = false;
        }

        $scope.onKeyDown = function($event) {
            var keyCode = $event.which || $event.keyCode;

            if ($event.ctrlKey && keyCode === SkConstants.KEY_CODE.ENTER) {
                $scope.$success();
            }
        };

        $scope.$success = function(){
            $popupInstance.success($scope.value);
        };
    }]);
/**
 * Created by bruno.brandao on 31/05/2017.
 */
angular
    .module('snk.components.input')
    .service('TextAreaPopupService', ['SanPopup', 'i18n', function (SanPopup, i18n) {
        var self = this;

        self.open = open;

        function open(fieldDescr, value, enabled, isRichText, options) {
            var popupInstance = SanPopup.open({
                templateUrl: 'components/input/textarea/textarealink/textareapopup.tpl.html',
                title: enabled ? i18n('TextAreaLink.lblEditandoCampo', {campo: fieldDescr}) : i18n(fieldDescr),
                okBtnTooltip: i18n('Geral.lblAtalhoCtrlEnter'),
                size: (options && options.size) || 'md',
                controller: 'SkTextAreaPopUpController',
                controllerAs: 'ctrl',
                resolve: {
                    value: function () {
                        return value
                    },
                    enabled: function () {
                        return enabled
                    },
                    isRichText: function () {
                        return isRichText
                    }
                }
            });

            return popupInstance.result;
        }

    }]);

angular
    .module('snk.components.input')
    .controller('SkTimeInputController', ['$scope', '$attrs', '$timeout', 'ObjectUtils', 'StringUtils', 'DateUtils', 'AngularUtil', '$element',
function SkTimeInputController($scope, $attrs, $timeout, ObjectUtils, StringUtils, DateUtils, AngularUtil, $element) {
    var self = this;
    var _ngModelCtrl;

    var _time;
    var _minutesIsPriority = $attrs.hasOwnProperty('skMinutesIsPriority') ? $attrs.skMinutesIsPriority == 'true' : true;
    var _unlimitedHour = $attrs.hasOwnProperty('skUnlimitedHour') ? $attrs.skUnlimitedHour == 'true' : false;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        getData: getData,
        setNgModelCtrl: setNgModelCtrl
    });

    $scope.setNow = $scope.setNow || setNow;
    $scope.changeHandler = changeHandler;

    self.onBlur = onBlur;
    self.fbFocusOut = fbFocusOut;

    $scope.viewValue = $scope.value;

    function setNow($event){
        adjustValue();
        changeHandler($event);
        self.fbFocusOut();
    }

    function setNgModelCtrl(ngModelCtrl){
        _ngModelCtrl = ngModelCtrl;

        //Para permitir apenas numeros e :
        _ngModelCtrl.$parsers.unshift(function (inputValue) {
            var transformedInput = inputValue.replace(/[^\d.:]/g, '');

            if (transformedInput != inputValue) {
                ngModelCtrl.$setViewValue(transformedInput);
                ngModelCtrl.$render();
            }

            return transformedInput;
        });

        _ngModelCtrl.$parsers.push(function (inputValue) {
            _ngModelCtrl.$modelValue = formatToModel(inputValue);
            return inputValue;
        });

        _ngModelCtrl.$formatters.push(function (value) {
            return formatToView(value);
        });

        _ngModelCtrl.$validators.time = function(){
            return _time && _time.isValid();
        };
    }

    function onBlur() {
        updateViewValue();

        if (angular.isFunction($scope.onFocusOut)){
            $scope.onFocusOut();
        }
    }

    function formatToModel(value) {
        buildTime(value);

        if (_time && _time.isValid($scope.showSeconds)){
            return _time.toNumber($scope.showSeconds);
        } else {
            invalidateModel();
            return undefined;
        }
    }

    function buildTime(value){
        _time = Time.parse(value, _unlimitedHour, _minutesIsPriority);
        _minutesIsPriority = (_time && _time.minutesIsPriority == true) ? _time.minutesIsPriority : _minutesIsPriority; 
    }

    function invalidateModel(){
        _ngModelCtrl.$setViewValue(undefined);
        _ngModelCtrl.$commitViewValue();
        _ngModelCtrl.$render();
    }

    function formatToView(value){
        buildTime(value);

        if (_time.isValid($scope.showSeconds)){
            return _time.toString($scope.showSeconds);
        } else {
            $scope.value = undefined;
            return '';
        }
    }

    function updateViewValue() {
        if (StringUtils.isNotEmpty(_ngModelCtrl.$modelValue)){
            if (!isNumber($scope.value)) {
            	// Realiza ajuste na hora quando esta for digitada com ':' dois pontos, ocasionando erro na renderiza��o
                adjustValue($scope.value);
            }
            _ngModelCtrl.$setViewValue(formatToView($scope.value));
            _ngModelCtrl.$render();
        }
    }

    function changeHandler() {
        self.notifyChangeToDataset();

        runOnChange();
    }

    function runOnChange($event) {
        $timeout(function(){
            ($scope.onChange || angular.noop)($scope);
        }, 0, false);
    }

    function setData(data) {
        $scope.value = data;

        runOnChange();
    }

    function getData(){
        if ($scope.value && angular.isString($scope.value)){
            return $scope.value.replace(/:/g,"");
        } else {
            return $scope.value;
        }
    }

    function adjustValue(value) {
        var format = 'HH:mm';
        var date;
        var tamanhoHora = 4;

        if ($scope.showSeconds) {
            format += ':ss';
            tamanhoHora = 6;
        }

        if (value) {
            date = DateUtils.getToday(true);
            date = DateUtils.dateToString(date, 'YYYY-MM-DD');
            date = DateUtils.setTime(date, value);
        } else {
            date = DateUtils.getToday(false)
        }

        $scope.value = formatToModel(DateUtils.formatDate(date, format)).toString().padStart(tamanhoHora, '0');
    }

    function isNumber(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
    /*
    override do focusout padrão do fieldbinder, pois no timeinput
    é necessário normalizar os valores para realizar a verificação de alteração
    */
    function fbFocusOut(){
        let actualValue = $scope.value;
        let oldValue = $scope.oldValue;

        if(angular.isString(actualValue)){
            actualValue = actualValue.replace(':', '');
        }

        if(angular.isString(oldValue)){
            oldValue = oldValue.replace(':', '');
        }

        if(actualValue != oldValue){
            $scope.onEndEdit({value: this.scope.value});
        }
    }
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-time-input
 * @restrict E
 * @scope
 * @description
     Componente de hora.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
 Dataset que será utilizado no controle deste componente.
 Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @param {boolean} [sk-show-seconds=false]
    Determina se será apresentado os segundos no componente de tempo.

 * @param {boolean} [sk-hide-icon=false]
    Determina se será apresentado os segundos no componente de tempo.
 *
 * @param {boolean} [sk-unlimited-hour=false]
    Determina se será apresentado as horas em forma de contagem. Ex: 201:30
 *
 * @example
     <example module="appTimeInput">
         <file name="appTimeInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = undefined" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Hora:
                    <sk-time-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-text-input>
                </div>
                <p>Valor: {{inputValue}}</p>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appTextInput.js">
            angular
                .module('appTimeInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.inputValue = 2130;
                $scope.log = [];

                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skTimeInput', ['$timeout', 'StringUtils', function ($timeout, StringUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            align: '@?skAlign',
            value: '=?skValue',
            showSeconds: '=?skShowSeconds',
            setNow: '=?skSetNow',
            onFocusOut: '&?skFocusOut',
            onFocus: '&?skFocus',
            onChange: '&?skChange',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            hideIcon: '=?skHideIcon',
            unlimitedHour: '=?skUnlimitedHour',
            onEndEdit: '&skEndEdit',
        },
        template: getTemplate,
        controller: 'SkTimeInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template =
                '<input type=\'text\' class=\'form-control\' ng-class="{\'padding-right\' : hideIcon !== true }" ng-model=\'value\' ng-model-options="{ updateOn: \'blur\'}" ng-change="changeHandler()" ng-disabled="!enabled" {style} ng-required="{{required}}" {gridEditor} {autofocus}/>' +
                '<sk-icon ng-if="hideIcon !== true" font-icon=\'clock\' ng-click="!enabled || setNow()" sk-enabled="enabled"></sk-icon>';

        var templateArgs = {
            style: angular.isDefined(tAttrs.skAlign) ? 'ng-style="{\'text-align\': align}"' : '',
            gridEditor : angular.isDefined(tAttrs.skDatagridEditor) ? 'sk-datagrid-pesquisa-editor' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;
        var inputElement = element.children()[0];
        var ngModelCtrl = angular.element(inputElement).data('$ngModelController');

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.setNgModelCtrl(ngModelCtrl);
        ctrl.setFocus = setFocus;
        ctrl.setElement(inputElement);

        angular.element(inputElement).bind('click', function () {
            if (isDatagrid()) {
                setFocus();
            } else if (!fullSelected) {
                select();
            }
        });

        angular.element(inputElement).bind('blur', function () {
            ctrl.onBlur();
            fullSelected = false;
        });

        angular.element(inputElement).bind('focus', function () {
            (scope.onFocus || angular.noop)(scope);
        });

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        if (isDatagrid()) {
            inputElement.focus();

            $timeout(function () {
                inputElement.select();
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .directive('skTypeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', 'SkTypeaheadParser', 'StringUtils', 'SkConstants', 'PositionUtils', 'AngularUtil', function ($compile, $parse, $q, $timeout, $document, $window, $rootScope, SkTypeaheadParser, StringUtils, SkConstants, PositionUtils, AngularUtil) {
        var HOT_KEYS = [9, 13, 27, 38, 40];
        var MIN_HEIGHT = 100;
        var eventDebounceTime = 200;

        return {
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(originalScope, element, attrs, modelCtrl) {
            var minLength = originalScope.$eval(attrs.skTypeaheadMinLength);
            var waitTime = originalScope.$eval(attrs.skTypeaheadWaitMs) || 0;
            var isEditable = originalScope.$eval(attrs.skTypeaheadEditable) !== false;
            var isLoadingSetter = $parse(attrs.skTypeaheadLoading).assign || angular.noop;
            var onSelectCallback = $parse(attrs.skTypeaheadOnSelect);
            var isSelectOnBlur = StringUtils.toBoolean(originalScope.$eval(attrs.skTypeaheadSelectOnBlur));
            var inputFormatter = attrs.skTypeaheadInputFormatter ? $parse(attrs.skTypeaheadInputFormatter) : undefined;
            var appendToBody = attrs.skTypeaheadAppendToBody ? originalScope.$eval(attrs.skTypeaheadAppendToBody) : false;
            var windowClass = attrs.skWindowClass;
            var focusFirst = originalScope.$eval(attrs.skTypeaheadFocusFirst) !== false;
            var isExternalAction = StringUtils.toBoolean(originalScope.$eval(attrs.skTypeaheadExternalAction));
            var $setModelValue = $parse(attrs.ngModel).assign;
            var parserResult = SkTypeaheadParser.parse(attrs.skTypeahead);
            var scope = originalScope.$new(); //Cria um scope filho para a diretiva não poluir o scope original com dados específicos do typeahead (matches, query e etc.)
            var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
            var loadOnFocus = attrs.skTypeaheadLoadOnFocus ? attrs.skTypeaheadLoadOnFocus : false;
            var popupElem = angular.element('<div sk-typeahead-popup></div>');
            var resetMatches = resetMatches;
            var getMatchId = getMatchId;
            var getMatchesAsync = getMatchesAsync;
            var scheduleSearchWithTimeout = scheduleSearchWithTimeout;
            var cancelPreviousTimeout = cancelPreviousTimeout;
            var dismissClickHandler = dismissClickHandler;
            var timeoutEventPromise;
            var timeoutPromise;
            var hasFocus;
            var $popup;
            var popupScrollElem;

            scope.moveInProgress = false;
            scope.query = undefined;
            scope.select = select;
            
			$document.on(SkConstants.EVENTS.SCROLL, closeHandler);

            $rootScope.$on(SkConstants.EVENTS.CONTAINER_DRAG_START, closeHandler);

            if (!minLength && minLength !== 0) {
                minLength = 1;
            }

            element.attr({
                'aria-autocomplete': 'list',
                'aria-expanded': false,
                'aria-owns': popupId
            });

            popupElem.attr({
                'id': popupId,
                'matches': 'matches',
                'active': 'activeIdx',
                'select': 'select(activeIdx)',
                'move-in-progress': 'moveInProgress',
                'query': 'query',
                'position': 'position'
            });

            if (angular.isDefined(attrs.skTypeaheadTemplateUrl)) {
                popupElem.attr('template-url', attrs.skTypeaheadTemplateUrl);
            }

            if (angular.isDefined(attrs.skWindowClass)) {
                popupElem.addClass(attrs.windowClass);
            }

            scope.$watch('activeIdx', function (index) {
                if (index < 0) {
                    element.removeAttr('aria-activedescendant');
                } else {
                    element.attr('aria-activedescendant', getMatchId(index));
                }
            });

            if (appendToBody) {
                angular.element($window).bind(SkConstants.EVENTS.RESIZE, fireRecalculating);

                $document.find('body').bind(SkConstants.EVENTS.SCROLL, fireRecalculating);
            }

            resetMatches();

            //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
            //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
            modelCtrl.$parsers.unshift(function (inputValue) {
                hasFocus = true;

                if (minLength === 0 || inputValue && inputValue.length >= minLength) {
                    if (waitTime > 0) {
                        cancelPreviousTimeout();
                        scheduleSearchWithTimeout(inputValue);
                    } else {
                        getMatchesAsync(inputValue);
                    }
                } else {
                    isLoadingSetter(originalScope, false);
                    cancelPreviousTimeout();
                    resetMatches();
                }

                if (isEditable) {
                    return inputValue;
                } else {
                    if (!inputValue) {
                        // Reset in case user had typed something previously.
                        modelCtrl.$setValidity('editable', true);
                        return inputValue;
                    } else {
                        modelCtrl.$setValidity('editable', false);
                        return undefined;
                    }
                }
            });

            modelCtrl.$formatters.push(function (modelValue) {
                var candidateViewValue, emptyViewValue;
                var locals = {};

                // The validity may be set to false via $parsers (see above) if
                // the model is restricted to selected values. If the model
                // is set manually it is considered to be valid.
                if (!isEditable) {
                    modelCtrl.$setValidity('editable', true);
                }

                if (inputFormatter) {
                    locals.$model = modelValue;

                    return inputFormatter(originalScope, locals);
                } else {
                    //it might happen that we don't have enough info to properly render input value
                    //we need to check for this situation and simply return model value if we can't apply custom formatting
                    locals[parserResult.itemName] = modelValue;
                    candidateViewValue = parserResult.viewMapper(originalScope, locals);
                    locals[parserResult.itemName] = undefined;
                    emptyViewValue = parserResult.viewMapper(originalScope, locals);

                    return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
                }
            });

            element.bind(SkConstants.EVENTS.FOCUS,function(evt) {
               if(loadOnFocus === "true") {
                   hasFocus = true;
                   scheduleSearchWithTimeout(undefined);
               }
            });

            element.bind(SkConstants.EVENTS.KEY_DOWN, function (evt) {
                var loadAllMatches = scope.matches.length === 0 && scope.minLength === 0 && evt.which === SkConstants.KEY_CODE.ENTER;

                //typeahead is open and an "interesting" key was pressed
                if (!loadAllMatches && (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) ) {
                    return;
                }

                //if there's nothing selected (i.e. focusFirst) and enter is hit, don't do anything
                if (!loadAllMatches && scope.activeIdx === -1 && evt.which === SkConstants.KEY_CODE.ENTER) {
                    return;
                }

                //if there's nothing selected (i.e. focusFirst) and tab is hit, clear the results
                if (scope.activeIdx === -1 && evt.which === SkConstants.KEY_CODE.TAB) {
                    resetMatches();

                    scope.$digest();

                    return;
                }

                evt.preventDefault();

                if (!popupScrollElem) {
                    popupScrollElem = getPopupScrollElem();
                }

                if (evt.which === SkConstants.KEY_CODE.DOWN_ARROW) {
                    if (scope.activeIdx + 1 >= scope.matches.length){
                        return;
                    }

                    scope.activeIdx = (scope.activeIdx + 1);
                    scope.$digest();

                    if ($popup && popupScrollElem) {
                        var item = angular.element($popup[0].querySelector('ul.dropdown-menu li.active'));
                        var itemPosition = PositionUtils.position(item);
                        var scrollTopItem = (itemPosition.height + itemPosition.top);
                        var diff = scrollTopItem - popupScrollElem.offsetHeight;
                        var scrollTop = popupScrollElem.scrollTop + diff;

                        if (scrollTopItem <= popupScrollElem.offsetHeight) {
                            scrollTop = 0;
                        }

                        popupScrollElem.scrollTop = scrollTop;
                    }
                } else if (evt.which === SkConstants.KEY_CODE.UP_ARROW) {
                    if (scope.activeIdx == 0){
                        return;
                    }

                    scope.activeIdx = scope.activeIdx - 1;
                    scope.$digest();

                    if ($popup && popupScrollElem) {
                        var item = $popup[0].querySelector('ul.dropdown-menu li.active');
                        var scrollTop = (item.offsetTop - 5);

                        /*if (scrollTop <= popupScrollElem.offsetHeight) {
                            scrollTop = 0;
                        }*/

                        popupScrollElem.scrollTop = scrollTop;
                    }
                } else if (evt.which === SkConstants.KEY_CODE.ENTER || evt.which === SkConstants.KEY_CODE.TAB) {
                    if(loadAllMatches) {
                        scheduleSearchWithTimeout('',true);
                        evt.stopPropagation();
                    } else {
                        AngularUtil.apply(scope, function () {
                            scope.select(scope.activeIdx);
                        });
                    }

                } else if (evt.which === SkConstants.KEY_CODE.ESCAPE) {
                    evt.stopPropagation();

                    resetMatches();

                    scope.$digest();
                }
            });

            element.bind('blur', function (evt) {
                if (isSelectOnBlur && scope.activeIdx >= 0) {
                    scope.$apply(function () {
                        scope.select(scope.activeIdx);
                    });
                }

                hasFocus = false;
            });

            $document.bind(SkConstants.MOUSE.CLICK, dismissClickHandler);

            originalScope.$on(SkConstants.EVENTS.DESTROY, function () {
                scope.$destroy();

                $document.unbind(SkConstants.MOUSE.CLICK, dismissClickHandler);

                if (appendToBody) {
                    $popup.remove();
                }

                //Prevent jQuery cache memory leak
                popupElem.remove();

                $document.off(SkConstants.EVENTS.SCROLL, closeHandler);
            });

            $popup = $compile(popupElem)(scope);

            if (appendToBody) {
                $document.find('body').append($popup);
            } else {
                element.after($popup);
            }

            function select(activeIdx) {
                var locals = {};
                var model;
                var item;

                locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                model = parserResult.modelMapper(originalScope, locals);

                $setModelValue(originalScope, isExternalAction ? '' : model);

                modelCtrl.$setValidity('editable', true);
                modelCtrl.$setValidity('parse', true);

                onSelectCallback(originalScope, {
                    $item: item,
                    $model: model,
                    $label: parserResult.viewMapper(originalScope, locals)
                });

                resetMatches();

                if (!isExternalAction) {
                    $timeout(function () {
                        element[0].focus();
                    }, 0, false);
                }
            }

            function dismissClickHandler(evt) {
                if (element[0] !== evt.target) {
                    closeHandler();
                }
            }

            function scheduleSearchWithTimeout(inputValue,loadAll) {
                timeoutPromise = $timeout(function () {
                    getMatchesAsync(inputValue,loadAll);
                }, waitTime, false);
            }

            function cancelPreviousTimeout() {
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }
            }

            function fireRecalculating() {
                if (!scope.moveInProgress) {
                    scope.moveInProgress = true;

                    scope.$digest();
                }

                // Cancel previous timeout
                if (timeoutEventPromise) {
                    $timeout.cancel(timeoutEventPromise);
                }

                // Debounced executing recalculate after events fired
                timeoutEventPromise = $timeout(function () {
                    // if popup is visible
                    if (scope.matches.length) {
                        recalculatePosition();
                    }

                    scope.moveInProgress = false;
                    scope.$digest();
                }, eventDebounceTime, false);
            }

            function resetMatches() {
                scope.matches = [];
                scope.activeIdx = -1;

                element.attr('aria-expanded', false);
            }

            function getMatchId(index) {
                return popupId + '-option-' + index;
            }

            function getMatchesAsync(inputValue,loadAll) {
                var locals = {$viewValue: inputValue};

                try {
                    isLoadingSetter(originalScope, true);

                    $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
                        var onCurrentRequest = (inputValue === modelCtrl.$viewValue);

                        if (loadAll || (onCurrentRequest && hasFocus) ) {
                            if (matches && matches.length > 0) {
                                scope.activeIdx = focusFirst ? 0 : -1;
                                scope.matches.length = 0;

                                //transforma labels
                                for (var i = 0; i < matches.length; i++) {
                                    locals[parserResult.itemName] = matches[i];
                                    
                                    scope.matches.push({
                                        id: getMatchId(i),
                                        label: parserResult.viewMapper(scope, locals),
                                        model: matches[i]
                                    });
                                }
                                scope.query = inputValue;

                                recalculatePosition();

                                element.attr('aria-expanded', true);
                            } else {
                                resetMatches();
                            }
                        }
                        if (onCurrentRequest) {
                            isLoadingSetter(originalScope, false);
                        }
                    }, function () {
                        resetMatches();

                        isLoadingSetter(originalScope, false);
                    });
                } catch (e){
                    isLoadingSetter(originalScope, false);

                    if (e instanceof CriteriaError){
                        throw e;
                    }
                }
            }

            function recalculatePosition() {
                var newPosition = appendToBody ? PositionUtils.offset(element) : PositionUtils.position(element);

                $popup.css('visibility', 'hidden');

                if ($popup) {
                    scope.position = {};

                    $timeout(function(){
                        var offset = PositionUtils.offset($popup);
                        var posX = offset.width + newPosition.left + 20;
                        var posY = offset.height + newPosition.top;

                        if (posX > $window.innerWidth) {
                            var diffPos = posX - $window.innerWidth;

                            newPosition.left -= diffPos;
                        }

                        if (posY > $document.scrollTop() + $document[0].documentElement.clientHeight) {
                            var elemHeight = element.prop('offsetHeight');

                            newPosition.top = newPosition.top + (offset.height * -1);
                        } else {
                            newPosition.top += element.prop('offsetHeight');
                        }

                        if(newPosition.top < 0){
                            newPosition.top = 0;
                            popUpScrollElem = getPopupScrollElem();
                            popUpScrollElem.style.height = popUpScrollElem.offsetHeight + newPosition.top + 'px';
                        }

                        scope.position = newPosition;

                        $popup.css('visibility', 'visible');
                    });
                } else {
                    scope.position = newPosition;
                    scope.position.top += element.prop('offsetHeight');

                    $popup.css('visibility', 'visible');
                }
            }

            function getPopupScrollElem() {
                return $popup[0].querySelector('.typeahead-content');
            }

            function closeHandler(){
                resetMatches();

                if (!$rootScope.$$phase) {
                    scope.$digest();
                }
            }

            modelCtrl.setFocus = function(){
                element[0].focus();
            }
        }
    }]);
angular
    .module('snk.components.input')
    .filter('skTypeaheadHighlight', [function() {
        return function(matchItem, query) {
            return query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem;
        };

        function escapeRegexp(queryToEscape) {
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }
    }]);
angular
    .module('snk.components.input')
    .service('SkTypeaheadParser', ['$parse', function($parse){
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
        var self = this;

        self.parse = parse;

        function parse(input) {
            var match = input.match(TYPEAHEAD_REGEXP);

            if (!match) {
                throw new Error(
                    'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
                    ' but got "' + input + '".');
            }

            return {
                itemName: match[3],
                source: $parse(match[4]),
                viewMapper: $parse(match[2] || match[1]),
                modelMapper: $parse(match[1])
            };
        }
    }]);

angular
    .module('snk.components.input')
    .controller('SkTypeaheadController', ['$scope', 'ObjectUtils',
function ($scope, ObjectUtils) {
    var self = this;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData
    });

    $scope.changeHandler = changeHandler;
    $scope.onSelectItem = onSelectItem;

    function onSelectItem($item, $model, $label){
        if (angular.isFunction($scope.onSelect)){
            $scope.onSelect($item, $model, $label);
        }

        if ($scope.clearAfterSelect == 'true'){
            $scope.value = undefined;
        }
    }

    function changeHandler($event) {
        if (self.useDataset($scope)) {
            $scope.dataset.notifyEditionStart(self);
            $scope.dataset.setModified(self);
        }

        runOnChange($event);
    }

    function runOnChange($event) {
        if (angular.isFunction($scope.onChange)) {
            $scope.onChange($event, $scope.value);
        }
    }

    function setData(data) {
        $scope.value = data;

        runOnChange();
    }
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-typeahead
 * @restrict E
 * @scope
 * @description
     Componente de texto que apresenta um dropdown de seleção com opções baseadas na escrita do usuário
     os a lista de opções pode ser estática ou carregada via serviços.
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento da o texto no componente.
 *
 * @param {string} [sk-append-to-body=false]
    Determina se o popup deve ser renderizado como filho do body.
 *
 * @param {function} [sk-get-options=undefined]
    Função executada pelo componente para buscar as opções.
 *
 * @param {string} [sk-min-length=2]
    Define a quantidade mínima de caracteres que o usuário deve digitar para ativar a pesquisa.
 *
 * @param {string} [sk-template-url=Lista simples]
    Define o template dos itens apresentados no popUp.
 *
 * @param {string} [sk-key=undefined]
    Nome da propriedade nas opções que determina a key da opção.
 *
 * @param {string} [sk-label=undefined]
    Nome da propriedade nas opções que determina o label da opção.
 *
 * @param {function} [sk-on-select=undefined]
    Função executada ao selecionar um item da lista. Os seguintes parâmetros são enviados, respectivamente:
    - $item: Item selecionado
    - $model: Valor do item.
    - $label: Label do label.
 *
 * @param {function} [sk-show-more=undefined]
        Função executada quando o usuário cliar em 'Mostrar mais' no popup de opções.

 * @param {string} [sk-placeholder=undefined]
    Placeholder para o input

 *
 * @example
     <example module="appTypeaheadInput">
         <file name="appTypeaheadInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-typeahead-input
                        sk-value="inputValue"
                        sk-on-select="onSelect"
                        sk-enabled="enabled"
                        sk-get-options="getOptions"
                        sk-key="label"
                        sk-label="label"
                    >
                    </sk-typeahead-input>
                    <p>Valor: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item | json" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appTypeaheadInput.js">
            angular
                .module('appTypeaheadInput', ['snk'])
                .controller('TesteController', TesteController);
                
            function TesteController($scope){
                $scope.log = [];
                var options = ['Minas Gerais', 'Goiás', 'Rio de Janeiro', 'São Paulo', 'Santa Catarina'];
                var jsonOptions = [
                    {label: 'Minas Gerais',     value: 'MG'},
                    {label: 'Goiás',            value: 'GO'},
                    {label: 'Rio de Janeiro',   value: 'RJ'},
                    {label: 'São Paulo',        value: 'SP'},
                    {label: 'Santa Catarina',   value: 'SC'}
                ];

                $scope.getOptions = function (viewValue){
                    return jsonOptions;
                }

                $scope.onSelect = function($item, $model, $label){
                    $scope.log.push($item.value);
                }
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skTypeaheadInput', ['$timeout', 'StringUtils',
function ($timeout, StringUtils) {
    return {
        scope: {
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            align: '@?skAlign',
            onChange: '&?skChange',
            onFocusOut: '=?skFocusOut',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            getOptions: '=skGetOptions',
            filterValue: '=?skFilterValue',
            limitTo: '=?skLimitTo',
            templateUrl: '@?skTemplateUrl',
            isLoading: '=?skIsLoading',
            minLength: '=?skMinLength',
            onSelect: '=?skOnSelect',
            key: '@?skKey',
            label: '@?skLabel',
            showMore: '=?skShowMore',
            showMoreFn: '&?skShowMoreFn',
            placeholder: '@?skPlaceholder',
            tabIndex: '@skTabIndex',
            clearAfterSelect: '@skClearAfterSelect',
            isExternalAction: '@skExternalAction',
            loadOnFocus: '=?skLoadOnFocus',
            onEndEdit: '&skEndEdit'
        },
        template: getTemplate,
        controller: 'SkTypeaheadController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var template = '<input type="text" class="form-control" ng-model="value" ng-disabled="!enabled" ng-change="changeHandler($event)" ng-attr-placeholder="{{placeholder}}" sk-typeahead="{query} for item in getOptions($viewValue) {filterValue} {limitTo}" sk-typeahead-min-length="{minLength}" sk-typeahead-loading="isLoading" sk-typeahead-on-select="onSelectItem($item, $model, $label)"  sk-typeahead-external-action="{{ isExternalAction }}" sk-typeahead-template-url="{{templateUrl}}" sk-typeahead-load-on-focus="{{loadOnFocus}}"  {style} {appendToBody} {tabIndex} {gridEditor} sk-typeahead-wait-ms="300"/>';

        var templateArgs = {
            query: (tAttrs.skKey || tAttrs.skLabel) ? 'item.' + tAttrs.skKey + ' as item.' + tAttrs.skLabel : 'item',
            //filterValue: tAttrs.skFilterValue != 'false' ? ' | filter:$viewValue' : '',
            //limitTo: angular.isDefined(tAttrs.skLimitTo) ? ' | limitTo:' + tAttrs.skLimitTo : '',
            appendToBody: angular.isDefined(tAttrs.skAppendToBody) ? 'sk-typeahead-append-to-body=\'true\'' : '',
            windowClass: angular.isDefined(tAttrs.skWindowClass) ? 'sk-window-class="'+ tAttrs.skWindowClass +'"' : '',
            minLength: angular.isDefined(tAttrs.skMinLength) ? tAttrs.skMinLength : '2',
            style: angular.isDefined(tAttrs.skAlign) ? 'ng-style="{\'text-align\': align}"' : '',
            tabIndex: angular.isDefined(tAttrs.skTabIndex) ? 'tabindex="' + tAttrs.skTabIndex + '"' : '',
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : ''
        };

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var inputElement = element.children()[0];

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        ctrl.setFocus = setFocus;

        angular.element(inputElement).bind('focus', function (e) {
            $timeout(function(){
                inputElement.select();
            }, 0, false);
        });

        if (angular.isFunction(scope.onFocusOut)){
            angular.element(inputElement).bind('blur', function () {
                scope.onFocusOut();
            });
        }

        ctrl.setElement(inputElement);

        if (attr.skDatagridEditor == 'true') {
            setFocus();

            $timeout(function () {
                inputElement.select();
            }, 0, false);
        }
    }
}]);
angular
    .module('snk.components.input')
    .directive('skTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
        return {
            restrict: 'EA',
            scope: {
                index: '=',
                match: '=',
                query: '='
            },
            link: function (scope, element, attrs) {
                var templateUrl = 'components/input/typeahead/templates/typeahead-match.tpl.html';
                templateUrl = $parse(attrs.templateUrl)(scope.$parent) || templateUrl;

                $templateRequest(templateUrl).then(function (templateContent) {
                    $compile(templateContent.trim())(scope, function (clonedElement) {
                        element.replaceWith(clonedElement);
                    });
                });
            }
        };
    }]);

angular
    .module('snk.components.input')
    .directive('skTypeaheadPopup', [function(){
        return {
            restrict:'EA',
            scope:{
                matches:'=',
                query:'=',
                active:'=',
                position:'=',
                moveInProgress:'=',
                select:'&'
            },
            replace:true,
            templateUrl: 'components/input/typeahead/templates/typeahead-popup.tpl.html',
            link:function (scope, element, attrs) {  
                scope.templateUrl = attrs.templateUrl;
                scope.isOpen = isOpen;
                scope.isActive = isActive;
                scope.selectActive = selectActive;
                scope.selectMatch = selectMatch;
                scope.mouseDown = mouseDown;
                scope.close = close;
                scope.onClickShowMore = onClickShowMore;

                function onClickShowMore(){
                    scope.$parent.$parent.showMoreFn();
                    close();
                }

                function isOpen() {
                    return scope.matches.length > 0;
                }

                function close() {
                    scope.matches = [];
                }

                function isActive(matchIdx) {
                    return scope.active == matchIdx;
                }

                function selectActive(matchIdx) {
                    scope.active = matchIdx;
                }

                function selectMatch(activeIdx) {
                    scope.select({activeIdx:activeIdx});
                }

                function mouseDown(event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        };
    }]);

angular
    .module('snk.components.input')
    .controller('SkTypeSelectController', ['$scope', '$timeout', '$element', 'ObjectUtils', 'StringUtils', 'AngularUtil',
        function($scope, $timeout, $element, ObjectUtils, StringUtils, AngularUtil) {
            var self = this;

            $scope.internalDivId = StringUtils.nextUid();
            $scope.internaldUlId = StringUtils.nextUid();

            $scope.adjustDropdownLeft = adjustDropdownLeft;
            $scope.processChange = processChange;
            $scope.getGeneralLabel = getGeneralLabel;

            init();

            function init() {
                ObjectUtils.implements(self, FieldBinder, {
                    scope: $scope,
                    setFocus: setFocus,
                    setEnabled: setEnabled,
                    highlightField: function() {},
                    unHighlightField: function() {}
                });
            }

            function setEnabled(value) {
                console.log('seting enabled on typeSelect: ', value);
            }

            function setFocus() {
                $element.find('button').focus();
            }

            function adjustDropdownLeft() {
                var ulElem = angular.element(document.getElementById($scope.internaldUlId));
                if (ulElem.length > 0) {
                    ulElem.css('visibility','hidden');
                    $timeout(function () {
                        var typeSelectElem = angular.element($element.find('#' + $scope.internalDivId));
                        if (typeSelectElem.length > 0) {
                            ulElem.css('left', (ulElem[0].offsetLeft - typeSelectElem[0].offsetLeft) + 'px');
                            $timeout(function() {
                                ulElem.css('visibility','visible');
                            }, 0, false);
                        }
                    }, 0, false);
                }
            }

            function processChange(id, value, changeFn) {
                AngularUtil.apply($scope,function() {
                    changeFn(id, value);
                });
            }

            function getGeneralLabel() {
                var label = '';
                for(var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                    if($scope.dataProvider[i].value === true) {
                        if(label != '') {
                            label += ', ' + $scope.dataProvider[i].label;
                        } else {
                            label += $scope.dataProvider[i].label;
                        }
                    }
                }
                return label;
            }
        }
    ])
/**
 * Created by cleverson.puche on 11/05/2016.
 */

angular
    .module('snk.components.input')
    .directive('skTypeSelect',[function() {
        return {
            restrict: 'E',
            templateUrl: 'components/input/typeselect/typeselect.tpl.html',
            controller: 'SkTypeSelectController',
            scope: {
                dataProvider: '=skDataProvider',
                enabled: '=skEnabled'
            }
        }
    }]);
angular
    .module('snk.components.input')
    .controller('SkUrlInputController', ['$scope', '$timeout', '$element', 'ObjectUtils', 'StringUtils',
function ($scope, $timeout, $element, ObjectUtils, StringUtils) {
    var self = this;

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData
    });

    $scope.changeHandler = changeHandler;
    $scope.openLink = openLink;

    function changeHandler() {
        if (self.useDataset($scope)) {
            $scope.$evalAsync(function(){
                $scope.dataset.notifyEditionStart(self);
                $scope.dataset.setModified(self);
            });
        }

        runOnChange();
    }

    function runOnChange() {
        ($scope.onChange || angular.noop)($scope);
    }

    function setData(data) {
        $scope.value = data;

        runOnChange();
    }

    function openLink() {
        if(!StringUtils.isEmpty($scope.value)) {
            var url = $scope.value.replace(' ','');

            if(!/\w+\:\/\/./.test(url)) {
                url = 'http://' + url;
            }
            open(url,'_blank');
        }
    }
}]);
/**
 * @ngdoc directive
 * @name snk.components.input.directive:sk-url-input
 * @restrict E
 * @scope
 * @description
     Componente de texto, com a opção para abrir um determinado link
     Este componente pode ser utilizado tanto com um Dataset ou em modo standalone.
     - Para utilização com Dataset, deve-se informar os parâmetros <b>sk-dataset</b> e <b>sk-field-name</b> ou <b>sk-field-index</b>.
     - Para utilização sem o Dataset, deve-se informar o parâmetro <b>sk-value</b>.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     Caso ele não seja fornecido o componente trabalhará em modo standalone com bind na variável <b>sk-value</b>.
 *
 * @param {string} [sk-field-name=undefined]
    Nome do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-field-index=undefined]
    Índice do campo que este componente irá se registrar no dataset.
 *
 * @param {string} [sk-value=undefined]
    Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset)
 *
 * @param {function} [sk-change=undefined]
    Função de listener de alteração do valor do componente.
 *
 * @param {function} [sk-focus-out=undefined]
    Função de listener de focus out do componente.
 *
 * @param {boolean} [sk-enabled=true]
    Habilitado ou não o componente para edição do usuário.
 *
 * @param {boolean} [sk-required=true]
    Determina se o valor é requerido ou não.
 *
 * @param {string} [sk-align=undefined]
    Determina o alinhamento do texto no componente.
 *
 * @example
     <example module="appTextInput">
         <file name="appUrlInput.html">
            <div ng-controller="TesteController">
                <div class="btn-group" style="margin: 10px;" >
                    <button btn-checkbox ng-model="enabled" class="btn btn-primary">Enabled</button>
                    <button ng-click="inputValue = ''" class="btn btn-default">Limpar</button>
                </div>
                <div>
                    Campo:
                    <sk-url-input
                        sk-value="inputValue"
                        sk-change="onChange()"
                        sk-enabled="enabled">
                    </sk-url-input>
                    <p>Endereço: {{inputValue}}</p>
                </div>
                <h4>Log de alterações:</h4>
                <div style="max-height: 200px; overflow-y: auto;">
                    <p ng-bind="item" ng-repeat="item in log track by $index"/>
                </div>
            </div>
         </file>
         <file name="appUrlInput.js">
            angular
                .module('appUrlInput', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                $scope.inputValue = '';
                $scope.log = [];

                $scope.$watch('inputValue',function(newv,oldv) {
                    console.log(newv);
                });
                $scope.onChange = function () {
                  $scope.log.push($scope.inputValue);
                };
            }
         </file>
     </example>
 */
angular
    .module('snk.components.input')
    .directive('skUrlInput', ['$timeout', 'StringUtils', 'UserAgentUtils',
function ($timeout, StringUtils, UserAgentUtils) {
    return {
        scope: {
            id: '@skId',
            dataset: '=?skDataset',
            fieldName: '@?skFieldName',
            fieldIndex: '@?skFieldIndex',
            value: '=?skValue',
            onChange: '&?skChange',
            onFocusOut: '&?skFocusOut',
            enabled: '=?skEnabled',
            required: '=?skRequired',
            placeholder: '@?skPlaceholder',
            onKeydown: '=?skKeydown',
            size: '=?skSize',
            disableOnInsertion: '=skDisableOnInsertion'
        },
        template: getTemplate,
        controller: 'SkUrlInputController',
        link: linkFn
    };

    function getTemplate(tElem, tAttrs) {
        var autofocus = angular.isDefined(tAttrs.autofocus) ? 'autofocus' : '';
        var template =  
                        '<input type="text" id="{{id}}" class="form-control" ng-model="value" ng-attr-placeholder="{{placeholder}}" ng-disabled="!enabled" ng-required="required" ng-change="changeHandler()" ng-keydown="onKeydown($event)" maxlength="{{size}}" {gridEditor} {autofocus}/>' +
                        '<sk-icon font-icon="arrow-right" ng-click="openLink()" tooltip="" sk-translate="Controls.UrlInput.buttonAbrirEndereco" sk-translate-attr="tooltip"></sk-icon>';
        var templateArgs = {
            gridEditor: angular.isDefined(tAttrs.skDatagridEditor) ? 'ui-grid-editor' : '',
            autofocus: autofocus
        };

        tElem.removeAttr('autofocus');

        return StringUtils.substitute(template, templateArgs);
    }

    function linkFn(scope, element, attr, ctrl) {
        var fullSelected = false;
        var inputElement = element.children()[0];

        if (ctrl.useDataset(scope) && angular.isDefined(attr.value)) {
            throw new Error('Input que utiliza o dataset não deve fazer bind de valor.');
        }

        function setFocus(){
            $timeout(function(){
                inputElement.focus();
            }, 0, false);
        }

        function select(){
            $timeout(function(){
                inputElement.select();
                fullSelected = true;
            }, 0, false);
        }

        function isDatagrid() {
            return attr.skDatagridEditor == 'true' || attr.hasOwnProperty('aggrid');
        }

        ctrl.setFocus = setFocus;
        ctrl.select = select;

        var $inputElement = angular.element(inputElement);

        attr.$observe('skRequired', function(newV) {
            var isRequired = scope.$eval(newV);
            element[isRequired ? 'addClass' : 'removeClass']('required');
        });

        $inputElement.bind('focus', function () {
            element.addClass('focused');
        });

        $inputElement.bind('click', function () {
            if (isDatagrid()) {
                setFocus();
            } else if (!fullSelected) {
                select();
            }
        });

        $inputElement.bind('blur', function () {
            element.removeClass('focused');
            fullSelected = false;

            if (scope.onFocusOut) {
                scope.onFocusOut(scope);
            }
        });

        if (scope.size && UserAgentUtils.isSafari()){
            $inputElement.bind('keypress', function(evt){
                if (scope.value && scope.value.length >= scope.size){
                    var selStart = evt.target.selectionStart;
                    var selEnd = evt.target.selectionEnd;

                    return (selStart != selEnd);
                }

                return true;
            });
        }

        if (isDatagrid()) {
            setFocus();

            $timeout(function () {
                inputElement.select();
            }, 0, false);
        }
    }
}]);
/**
 * Created by Leonardo.mendes on 12/01/2019.
 */
angular
    .module('snk.components.intervalselector')
    .controller('SkIntervalSelectorController', ['i18n','ObjectUtils', '$scope','StringUtils','NumberUtils',
        function (i18n, ObjectUtils, $scope, StringUtils,NumberUtils) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            var _selectedItem = '';

            $scope.setTipoIntervalo = setTipoIntervalo;
            $scope.parseExpression = parseExpression;
            $scope.setData = setData;
            $scope.setValorIntervalo = setValorIntervalo;

            $scope.itens = [
                { label: i18n('CronSyntaxSelector.secondsLabel'), data: 'sec', selected: false },
                { label: i18n('CronSyntaxSelector.minutesLabel'), data: 'min', selected: false },
                { label: i18n('CronSyntaxSelector.hoursLabel'), data: 'hour', selected: false }
            ];

            $scope.$watch('isVisible', function(newValue){
                setVisible();
            });

            init();
            function init() {
                setVisible();

                if (angular.isFunction($scope.onIntervalCreated)) {
                    $scope.onIntervalCreated({
                        interval: {
                            clearAll: clearAll,
                            parseExpression: parseExpression
                        }
                    });
                }

                if (StringUtils.isEmpty($scope.value)) {
                    if($scope.dataset){
                        $scope.value = $scope.dataset.getFieldValue($scope.fieldName);
                    }else{
                        parseExpression();
                    }
                }
            }

            function setVisible(){
                $scope.isVisible = angular.isDefined($scope.isVisible) ? $scope.isVisible : true;
            }
            
            function setData(data){
                $scope.value = StringUtils.undefinedAsEmpty(data);

                parseExpression();              
            }


            function setValorIntervalo(item) {
                if (_selectedItem && item) {
                    $scope.value = _selectedItem + ':' + item;
                } else if (_selectedItem) {
                    $scope.value = _selectedItem + ':';
                }else{
                    $scope.value = '';
                }

                changeIntervalselector();
            }

            function setTipoIntervalo(item) {
                $scope.itens.forEach(function (e) {
                    e.selected = e.data == item.data;
                });

                _selectedItem = item.data;

                setValorIntervalo($scope.intervalValue);
            }

            function getData(){
                return $scope.value;
            }

            function parseExpression() {
                if (StringUtils.isNotEmpty($scope.value)){

                    var values = $scope.value.split(":");

                    if (values.length == 2) {
                        var time = values[1];
                        _selectedItem = values[0];

                        $scope.intervalValue = time;

                        $scope.itens.forEach(function (e) {
                            e.selected = e.data == _selectedItem;
                        });
                    }
                }else{
                    clearAll();
                }
            }

            function clearAll(){
				$scope.itens.forEach(function (e) {
                    e.selected = false;
                });

                $scope.intervalValue = '';
                
                changeIntervalselector();
            }
            

            function changeIntervalselector(){
                ($scope.onChange || angular.noop)();

                if (self.useDataset($scope)) {
                    $scope.$evalAsync(function(){
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.intervalselector.directive:sk-interval-selector
 * @restrict E
 * @description
 *  O intervalSelector é um programa de agendamento de tarefas. Com ele você pode programar para ser 
 *  executado qualquer coisa numa certa periodicidade, segundo, minuto e hora
 * 
 * @param {object} sk-dataset dataset que o label irá fazer bind
 * @param {string} sk-field-name nome do campo ao qual o label irá se ligar no dataset.
 * @param {string} [sk-value=undefined] Variável em que ocorrerá o bind entre o model e o view.
 * @param {function} [sk-change=undefined] Função a ser chamada quando alterar a expressão
 * @param {function} [sk-interval-created=undefined] Construtor onde se obter acesso aos metodos da diretiva
 *  - clearAll
 *  - parseExpression  
 *
 *  @example
     <example module="app">
         <file name="exemplo.html">
            <sk-vbox gap="5">
                  <sk-hbox gap="8">
                     <span>Expressão: </span>
                     <span ng-bind="expression"></span>
                  </sk-hbox>
                  <sk-interval-selector sk-value="expression"
			                            sk-interval-created="onIntervalCreated(interval)"
                                        sk-change="change(value)">
                  </sk-interval-selector>
             </sk-vbox>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MyController', function($scope){

                    $scope.expression = "10";
                    $scope.onIntervalCreated = function (interval){
                        $scope.interval = interval;
                    }
                });
         </file>
     </example>
 */
angular
    .module('snk.components.intervalselector')
    .directive('skIntervalSelector', ['i18n', function (i18n) {
        return {
            restrict: 'E',
            templateUrl: 'components/intervalselector/intervalselector.tpl.html',
            controller: 'SkIntervalSelectorController',
            scope: {
                dataset: '=?skDataset',
                fieldName: '@?skFieldName',
                value: '=?skValue',
                onChange: '&?skChange',
                onIntervalCreated: '&?skIntervalCreated',
                isVisible : '=?skVisible'
            }
        };
}]);

angular
    .module('snk.components.ishikawa')
    .controller('skIshikawaController', ['$scope', '$element', 'StringUtils', '$timeout', 'ObjectUtils', '$q', 'ServiceProxy', 'DomUtil', 'TooltipBuilder',
        function ($scope, $element, StringUtils, $timeout, ObjectUtils, $q, ServiceProxy, DomUtil, TooltipBuilder) {
        
        const self = this;

        let _nodesMap = {};
        let _nodesHiddenMap = {};
        let _rootElement;
        let _toolTipByNode = {};
        let _mousDown = false;

        let _initialClickPos = {
            x: 0,
            y: 0,
        }

        let _userScale;

        $scope.uniqueId = StringUtils.nextUid();
        $scope.onAddNode = onAddNode;
        $scope.onEditNode = onEditNode;
        $scope.onRemoveNode = onRemoveNode;
        $scope.onActionPlain = onActionPlain;        

        self.svgElement;
        self.qtdNodes = 0;        
        self.svgId = 'ishikawa-svg-' + $scope.uniqueId;
        self.optionsPanelApi;

        self.setDataProvider = setDataProvider;
        self.clearScrollPosition = clearScrollPosition;
        self.drawIshikawa = drawIshikawa;
        self.setScale = setScale;
        self.refresh = refresh;
        self.scrollToHeadFish = scrollToHeadFish;
        self.getHeight = getHeight;
        self.getWidth = getWidth;
        self.expandAll = expandAll;
        self.collapseAll = collapseAll;

        //IDatasetObserver
        ObjectUtils.implements(self, IDataSetObserver);
        self.refreshed = onDatasetRefresh;
        
        const _causes = {
            head: {
                name: '',
                children: []
            }
        };

        $timeout(init);

        function init(){
            $scope.$watch('dataset' ,(ds) =>{
                if(ds){
                    ds.addObserver(self);

                    if($scope.dataset.isLoaded()){
                        setDataProvider($scope.dataset.getRecordsAsObject());
                    }
                }
            });

            _rootElement = $element.find("#ishikawa-root-" + $scope.uniqueId);

            _rootElement.on('mousedown', (evt) => {
                _mousDown = true;
                _initialClickPos.x = evt.pageX;
                _initialClickPos.y = evt.pageY;
            });

            _rootElement.on('mouseup', (evt) => {
                _mousDown = false;
            });

            _rootElement.on('mousemove', onMouseMove);

            $scope.api = self;
        }

        function onMouseMove(evt){
            if (_mousDown){
                positionScroll(evt);
            }
        }

        function positionScroll(evt){
            if(hasHScroll() || hasVScroll()){
                let offsetX = _initialClickPos.x  - evt.pageX;
                let offsetY = _initialClickPos.y  - evt.pageY;
                
                _rootElement.scrollLeft(_rootElement.scrollLeft() + offsetX);
                _rootElement.scrollTop(_rootElement.scrollTop() + offsetY);
            }
        }

        function onDatasetRefresh(){
            setDataProvider($scope.dataset.getRecordsAsObject());
        }
        
        function setDataProvider(dataRows){
            _causes.head.children.length = 0;            
            _nodesMap = {};

            for(var i = 0; i < dataRows.length; i++){
                let dataRow = angular.copy(dataRows[i]);
                let parentID = dataRow[$scope.parentProperty];
                let nodeID = dataRow[$scope.keyProperty];
                
                let cause = {
                    name: dataRow[$scope.descrProperty],
                    index: i,
                    parentID: parentID,
                    effectID: dataRow[$scope.effectKey],
                    nodeID: nodeID,
                    uid: nodeID,
                    observacao: dataRow[$scope.obsProperty],
                    havePlanAction: dataRow[$scope.actionProperty] != undefined,
                    children: [],                    
                };
                
                _nodesMap[nodeID] = cause;

                if(parentID == 0){
                    _causes.head.children.push(_nodesMap[nodeID]);
                }else if(_nodesMap.hasOwnProperty(parentID)){
                    _nodesMap[parentID].children.push(cause);
                }
            }

            mapNodes(_causes.head);
            
            drawIshikawa();
        }

         /**
         * @ngdoc
         * @name snk.components.ishikawa.directive:sk-ishikawa#drawIshikawa
         * @methodOf snk.components.ishikawa.directive:sk-ishikawa
         * @description
         * Médodo responsável redesenhar o diagrama.
         */
        function drawIshikawa(){
            _causes.head.name = $scope.parentDataset.getFieldValueAsString($scope.descrPropertyParent);

            _toolTipByNode = {};

            let offset = Number($scope.offsetH != undefined ? $scope.offsetH : 0) 
            
            _rootElement.css({
                maxWidth: ($scope.maxWidth || window.innerWidth) - offset,
                maxHeight: ($scope.maxHeight || window.innerHeight) - offset
            });

            self.svgElement = $element.find('#' + self.svgId);

            self.svgElement.innerWidth(window.innerWidth - 20);
            self.svgElement.innerHeight(window.innerHeight - 20);

            self.svgElement[0].removeEventListener('click', onSvgClick);
            self.svgElement[0].addEventListener('click', onSvgClick, true);
            
            self.plotter = new Fishbone.Plotter({
                canvas: Snap('#ishikawa-svg-' + $scope.uniqueId),
                xUnitSize: _userScale ?  _userScale : 150,
                yUnitSize: _userScale ?  _userScale : 150,
                id: self.svgId,
                onBtnNodeClick: onBtnNodeClick,
                onLblNodeClick: onLblNodeClick,
                onLblHover: onLblHover,
                onLblOut: onLblOut,
            });

            self.plotter.draw(_causes);

            if(self.plotter.redraw) {
                self.plotter.draw(_causes, true);
            }
        }

        /**
         * @ngdoc
         * @name snk.components.ishikawa.directive:sk-ishikawa#refresh
         * @methodOf snk.components.ishikawa.directive:sk-ishikawa
         * @description
         * Médodo responsável atualizar o diagrama, recria os dados e a apresentação baseado no dataset.
         */
        function refresh(){
            setDataProvider($scope.dataset.getRecordsAsObject());
        }

        function mapNodes(node){
          var counter = 0;
          
          var hide = node.hide;

          if(node.children.length == 0){
              if(!hide) counter++;
              node.showBtn = false;
          }else {
              if(!hide){
                  counter++;
                  
                  var children = node.children;
                  
                  for(var i = children.length; i--; ) {
                      counter += mapNodes(children[i]);
                  }
                  node.showBtnCollapse = true;
              }else{
                  node.showBtnExpand = true;
              }
          }

          return counter;  
        }

        function onBtnNodeClick(event, node){
            let nodeRef = _nodesMap[node.uid];

            if(_nodesHiddenMap[node.uid]){
                nodeRef.hide = false;
                nodeRef.children = _nodesHiddenMap[nodeRef.uid];
                delete _nodesHiddenMap[nodeRef.uid];
                node.showBtnCollapse = true;
                nodeRef.showBtnExpand = false;
            }else{
                nodeRef.hide = true;
                _nodesHiddenMap[nodeRef.uid] = nodeRef.children;
                nodeRef.children = [];
                nodeRef.showBtnExpand = true;
                node.showBtnCollapse = false;
            }

            drawIshikawa();
        }

        function onLblNodeClick(ev, node){            
            self.optionsPanelApi.setPosition(ev.clientX, ev.clientY);
            self.optionsPanelApi.show(node);
        }

        function onSvgClick(ev){
            self.optionsPanelApi.hide();
            self.tooltiptext = '';
            self.showToolTip = false;            
        }

        function onAddNode(node){
            let cause = {
                name: node.name,
                index: $scope.dataset.size(),
                parentID: node.parent.uid,
                uid: StringUtils.nextUid(),
                observacao: node.observacao,
                havePlanAction: false,
                children: [],                    
            };

            adicionarCausa(cause.name, cause.observacao, $scope.parentDataset.getFieldValueAsNumber($scope.effectKey), cause.parentID).then(function(){
                self.optionsPanelApi.hide();
                $scope.dataset.refresh();
            });
        }

        function onEditNode(node){
            editarCausa(node.name, node.observacao, $scope.parentDataset.getFieldValueAsNumber($scope.effectKey), node.nodeID).then(function(){
                self.optionsPanelApi.hide();
                $scope.dataset.refresh();
            });
        }

        function adicionarCausa(descricao, descrObs, nuEfeito, codCausaPai){
            var deffered = $q.defer();

            var param = { 
                params: {
                    nuEfeito: nuEfeito,
                    codCausaPai: codCausaPai,
                    descrObs: descrObs,
                    descricao: descricao
                }
            };

			ServiceProxy.callService(
				"mgegi@AnaliseCausaEfeitoSP.adicionarCausa",
				param).then(function(response){
                    deffered.resolve();
                });
                
                return deffered.promise;
        }
        
        function editarCausa(descricao, observacao, nuEfeito, codCausa){
            if(!codCausa){
                $scope.parentDataset.setFieldValue($scope.descrPropertyParent, descricao);
                return $scope.parentDataset.save();
            }else{
                var deffered = $q.defer();

                var param = {
                    params: {
                        nuEfeito: nuEfeito ,
                        codCausa: codCausa
                    }
                };

                if(StringUtils.emptyAsNull(descricao) != null){
                    param.params.descricao = descricao;
                }
                
                if(StringUtils.emptyAsNull(observacao) != null){
                    param.params.observacao = observacao;
                }

                ServiceProxy.callService(
                    "mgegi@AnaliseCausaEfeitoSP.editarCausa", param).then(function(response){
                    deffered.resolve();
                    });

                return deffered.promise;
            }
        }
        
        function onActionPlain(cause){
            if($scope.planoAcaoFunction){
                $scope.planoAcaoFunction({cause: angular.copy(_nodesMap[cause.uid]) });
            }
        }

        function forEachChieldrens(node, fn){
          if(node.children.length > 0){
              for(var i = children.length; i--; ) {
                  fn(children[i]);
                  forEachChieldrens(children[i]);
              }
          }
        }

        /**
         * @ngdoc
         * @name snk.components.ishikawa.directive:sk-ishikawa#clearScrollPosition
         * @methodOf snk.components.ishikawa.directive:sk-ishikawa
         * @description
         * Médodo responsável por centralizar o scroll do diagrama.
         */
        function clearScrollPosition(){            
            centralizeHScroll();
            centralizeVScroll();            
        }

        function centralizeHScroll(){
            if(hasHScroll()){
                let scrollSize = _rootElement[0].scrollWidth - _rootElement.innerWidth();
                if(scrollSize > 0){
                    _rootElement.scrollLeft(scrollSize / 2);
                }
            }
        }

        function centralizeVScroll(){
            if(hasVScroll()){
                let scrollSize = _rootElement[0].scrollHeight - _rootElement.innerHeight();
                if(scrollSize > 0){
                    _rootElement.scrollTop(scrollSize / 2);
                }
            }
        }

        function hasVScroll(){
            return DomUtil.hasScrolling(_rootElement, 'y');
        }

        function hasHScroll(){
            return DomUtil.hasScrolling(_rootElement, 'x');
        }

        function onLblHover(evt, node){
            
            if(StringUtils.isEmpty(node.observacao) && !node.hasClip) return;

            let toolTip = getToolTipOfNode(node);
            let txt = `<b>Causa: </b>${node.name}`;
            
            if(node.observacao){
                txt = txt + `</p><b>Observação: </b>${node.observacao}`
            }            

            if(toolTip) toolTip.message(txt).show();
        }

        function onLblOut(evt, node){
            let toolTip = getToolTipOfNode(node);
            
            if(toolTip) toolTip.hide();
        }

        function getToolTipOfNode(node){
            if(_toolTipByNode.hasOwnProperty(node.uid)) return _toolTipByNode[node.uid];

            let rowElement = $element.find('#tooltip-node-' + node.uid);

            _toolTipByNode[node.uid] = TooltipBuilder(rowElement).duration(-1);

            _toolTipByNode[node.uid].placement("bottom")
                                    .setScrollable(true);

            return _toolTipByNode[node.uid];
        }

        function onRemoveNode(node){
            let arrToRemove = [];
            
            if(node.hasRoot){
                arrToRemove = $scope.dataset.getRecordsAsObject();
            }else{
                pushRecordsInAC(node, arrToRemove);
            }

            removerCausa(arrToRemove);
        }


        function pushRecordsInAC(causePai, arr){
            let records = $scope.dataset.getRecordsAsObjects();
			var recordPai = records[causePai.index];
			
			if(arr.indexOf(recordPai) == -1){
				arr.push(recordPai);
			}
			
			if(causePai.children.length > 0){
                
                causePai.children.forEach((item) => {
                    arr.push(records[item.index]);

                    if(item.children.length > 0){
						pushRecordsInAC(item, arr);
                    }
                    
                });
			}
        }
        
        function removerCausa(lista){
           let hasArray = lista.length > 1;
           let request = { params: {causa: (hasArray ? [] : {}) }};

           lista.forEach((obj) => {

            if(obj){
                let causa = {
                    nuEfeito: obj[$scope.effectKey],
                    codCausa: obj[$scope.keyProperty]
                }

                if(hasArray){
                    request.params.causa.push(causa);
                }else{
                    request.params.causa = causa;
                }
            }

           });

           ServiceProxy.callService(
               "mgegi@AnaliseCausaEfeitoSP.removerCausa", 
               request).then(function(){
                   $scope.dataset.refresh();
                   self.optionsPanelApi.hide();
            });

        }

         /**
         * @ngdoc
         * @name snk.components.ishikawa.directive:sk-ishikawa#setScale
         * @methodOf snk.components.ishikawa.directive:sk-ishikawa
         * @description
         * Médodo responsável por setar a escala no diagrama (dar zoom)
         * @param {number} scale nova escala de zoom a ser definada no componente, o diagrama sempre é iniciado com 100.
         */
        function setScale(scale) {
            /*
             A multiplicação da escala por 1.50 se dá pois o calculo da esca utilizada aqui é diferente da
             utilizada no flex, então, 1.50 é referente a progração geometrica das proporções de zoom do flex
             para o zoom do html.
            */
            _userScale = (scale * 1.50);
            drawIshikawa();
        }

         /**
         * @ngdoc
         * @name snk.components.ishikawa.directive:sk-ishikawa#scrollToHeadFish
         * @methodOf snk.components.ishikawa.directive:sk-ishikawa
         * @description
         * Médodo responsável posicionar o desenho no inicio do efeito.
         */
        function scrollToHeadFish(){
            if(hasHScroll()){
                let scrollSize = _rootElement[0].scrollWidth - _rootElement.innerWidth();
                _rootElement.scrollLeft(scrollSize);
            }
        }

        function getHeight(){
            return self.svgElement[0].getBBox().height;
        }

        function getWidth(){
            return self.svgElement[0].getBBox().width;
        }

        function expandAll(){
            expandOrCollapseAll(true);
        }

        function collapseAll(){
            expandOrCollapseAll(false);
        }

        function expandOrCollapseAll(expand){

            //Nada a fazer
            if((Object.keys(_nodesHiddenMap).length == 0 && expand) || (Object.keys(_nodesHiddenMap).length == $scope.dataset.size() && !expand)) return;

            for(nodeId in _nodesMap){
                let nodeRef = _nodesMap[nodeId];

                if(expand){

                    if(!_nodesHiddenMap[nodeRef.uid]) continue;

                    nodeRef.hide = false;
                    nodeRef.children = _nodesHiddenMap[nodeRef.uid];
                    delete _nodesHiddenMap[nodeRef.uid];
                    nodeRef.showBtnExpand = false;
                }else{

                    if(_nodesHiddenMap[nodeRef.uid]) continue;

                    nodeRef.hide = true;
                    _nodesHiddenMap[nodeRef.uid] = nodeRef.children;
                    nodeRef.children = [];
                    nodeRef.showBtnExpand = true;
                }
            }

            mapNodes(_causes.head);

            drawIshikawa();
        }
           
    }]);

/**
 * Created by leonardo.jorge on 04/10/2019.
 */
/**
 * @ngdoc directive
 * @name snk.components.ishikawa.directive:sk-ishikawa
 * @restrict E
 * @scope
 * @description
   sk-ishikawa é o componente reponsavél por apresentar siagrama de Ishikawa, esse componente está preprado para traalhar apenas com dataset.
 * @param {object} sk-dataset dataset o componente irá buscar os dados de causas.
 * @param {string} sk-effect-key nome do campo chave do registro do efeito.
 * @param {string} sk-obs-property nome do campo do dataset que representa a observação das causas.
 * @param {string} sk-descr-property-parent nome da propriedade de descrição do efeito.
 * @param {string} sk-key-property nome do campo chave das causas
 * @param {string} sk-parent-property nome do campo que se refere a causa pai na hierarquia, esse é o campo que faz a ligaçao de uma causa a uma causa pai.
 * @param {string} sk-descr-property nome do campo que representa a descrição da causa.
 * @param {object} sk-parent-dataset dataset que comtem os efeitos.
 * @param {string} sk-action-property campo que contém codigo do plano de ação.
 * @param {string} sk-max-width Largura maxima do componente.
 * @param {string} sk-max-height Altura máxima do componente.
 * @param {object} sk-api variavél para pegar a api de componente.
 */
angular
    .module('snk.components.ishikawa')
    .directive('skIshikawa', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/ishikawa/ishikawa.tpl.html',
                controller: 'skIshikawaController',
                controllerAs: 'ctrl',
                scope: {
                    api: '=?skApi',
                    dataset: '=?skDataset',
                    parentDataset: '=?skParentDataset',
                    parentProperty: '@?skParentProperty',
                    keyProperty: '@?skKeyProperty',
                    descrProperty: '@?skDescrProperty',
                    effectKey: '@?skEffectKey',
                    obsProperty: '@?skObsProperty',
                    actionProperty: '@skActionProperty',
                    planoAcaoFunction: '&skPlanoAcaoFunction',
                    descrPropertyParent: '@skDescrPropertyParent',
                    maxWidth: '@?skMaxWidth',
                    maxHeight: '@?skMaxHeight',
                    offsetH: '@?skOffsetH'
                },
                compile: function($element, attr) {                    
                
                }
            }
        }
    ]);

angular
    .module('snk.components.ishikawa')
    .controller('skIshikawaOptionsController', ['$scope', 'AngularUtil', 'MessageUtils', 'i18n',
        function ($scope, AngularUtil, MessageUtils, i18n) {        
        
        const self = this;           
        
        $scope.isShow = false;
        $scope.style = {};
        $scope.getPopOverOptions = getPopOverOptions;
        $scope.hide = hide;
        $scope.planoAcao = planoAcao;
        $scope.remove = remove;

        self.show = show;
        self.hide = hide;
        self.setPosition = setPosition;

        $scope.api = self;

        function show(node){
            self.node = node;
            $scope.isShow = true;
            AngularUtil.apply($scope);
        }

        function hide(){
            $scope.isShow = false;
            AngularUtil.apply($scope);
        }

        function setPosition(x, y){
            $scope.style.left = x;
            $scope.style.top = y;
        }

        function getPopOverOptions(mode){
            return {
                onPopOverClose: onPopOverClose,
                onPopOverSave: onPopOverSave,
                node: self.node,
                mode: mode
            };
        }

        function onPopOverSave(node){
            //se chegar um node como parâmetro, estamos em uma inserção caso contrario eh uma edição
            if(node && $scope.onAdd){
                $scope.onAdd({node: node});
            }else if(!node && $scope.onEdit){
                $scope.onEdit({node: self.node});
            }
        }

        function planoAcao(){
            if($scope.onActionPlain){
                $scope.onActionPlain({node: self.node});
            }

            hide();
        }

        function onPopOverClose(){

        }

        function remove(){
            MessageUtils.simpleConfirm(MessageUtils.TITLE_WARNING, self.node.hasRoot ? i18n("Ishikawa.removerTodasCausas") : i18n("Ishikawa.removerCausa"), true)
            .then(function(){
                if($scope.onRemove) $scope.onRemove({node: self.node});
            });
        }

    }]);

/**
 * Created by leonardo.jorge on 04/10/2019.
 */
angular
    .module('snk.components.ishikawa')
    .directive('skIshikawaOptions', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/ishikawa/optionspanel/ishikawaoptions.tpl.html',
                controller: 'skIshikawaOptionsController',
                controllerAs: 'ctrl',
                scope: {
                    api: '=?skApi',
                    onAdd: '&?skOnAdd',
                    onRemove: '&?skOnRemove',
                    onEdit: '&?skOnEdit',
                    onActionPlain: '&?skOnActionPlain'
                },
                compile: function($element, attr) {                    
                
                }
            }
        }
    ]);
angular
    .module('snk.components.ishikawa')
    .controller('IshikawaPopoverEdit', ['$scope', 'StringUtils', 'MessageUtils', 'i18n',
        function ($scope, StringUtils, MessageUtils, i18n) {
            $scope.doSave = doSave;
            $scope.transientNode = {};

            if($scope.mode == 'i'){
                $scope.transientNode = {
                    parent: $scope.node,
                    name: '',
                    observacao: ''
                };
            }else{
                $scope.transientNode = $scope.node;
            }

            function doSave(){
                if(StringUtils.isEmpty($scope.transientNode.name)){
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Ishikawa.informarNomeCausa'));
                    return;
                }

                if($scope.mode == 'i'){
                    $scope.onPopOverSave($scope.transientNode);
                }else{
                    $scope.onPopOverSave();
                }

                $scope.hide();
            }

        }]);

angular
    .module('snk.components.label')
    .controller('skLabelController', ['$scope', 'ObjectUtils',
        function ($scope, ObjectUtils) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
            });

            function setData(data){
                if(data == undefined){
                    data = $scope.value = '';    
                }
                if(angular.isFunction($scope.lblFunction)){
                    data = $scope.lblFunction({value: data});
                }
                $scope.value = data;                
            }
        }]);
/**
 * Created by leonardo.jorge on 04/10/2019.
 */
/**
 * @ngdoc directive
 * @name snk.components.label.directive:sk-label
 * @restrict E
 * @scope
 * @description
   skLabel é um componente reposnsavel pro apresentar um texto ligado a um campo do dataset,
   ou a um value quando no modo standalone
 * @param {object} sk-dataset dataset que o label irá fazer bind
 * @param {string} sk-field-name nome do campo ao qual o label irá se ligar no dataset.
 * @param {string} sk-value valor a ser apresentado quando for standalone.
 * @param {function} sk-lbl-function Função para personalização do label, recebe como parâmetro o valor atual do label,
 * deve retornar o novo label.
 * @param {string} padding valor de padding do label, default '5px'.
 */
angular
    .module('snk.components.label')
    .directive('skLabel', [
        function () {
            return {
                restrict: 'E',
                template: '<label ng-bind="value"></label>',
                controller: 'skLabelController',
                scope: {
                    dataset: '=?skDataset',
                    fieldName: '@?skFieldName',
                    value: '=?skValue',
                    lblFunction: '&?skLblFunction'
                },
                compile: function($element, attr) {
                    var padding = attr.padding;
                    if(!padding){
                        padding = '5px';
                    }
                    $element.css('padding', padding);
                }
            }
        }
    ]);
angular
    .module('snk.components.linkedlist')
    .controller('SkLinkedListController', ['$scope',
        function ($scope) {
            var self = this;
            var _popOver;

            self.value = $scope.value;
            self.getPopoverProperties = getPopoverProperties;
            
            self.onItemClick = onItemClick;

            $scope.hide = self.hide = hide;

            $scope.popOverListeners = { onCreate: onCreatePopover };

            function  onCreatePopover(popover){ 
                _popOver = popover;
                if($scope.popoverListener && $scope.popoverListener.onCreate){
                    $scope.popoverListener.onCreate(popover);
                } 
            }

            function getPopoverProperties(opt){
                return {
                    value: opt.value,
                    options: opt.child,
                    popoverListener: $scope.popoverListener,
                    parameters: $scope.parameters
                }
            }

            function onItemClick($event, option){
                if(option.action){
                    option.action($event, $scope.parameters, option);
                }

                if(option.type == 'check'){
                    self.value = option.data;
                }

                if(!option.child || option.child.length == 0){
                    hide(true);
                }
            }

            function hide(hideParent){
                if(_popOver) _popOver.hide();
                
                if(hideParent && $scope.$parent){
                    $scope.$parent.hide(true);
                    if($scope.$parent.hidePrincipal) $scope.$parent.hidePrincipal();
                }
            }
        }]);
/**
 * Created by leonardo.jorge on 04/10/2019.
 */
/**
 * @ngdoc directive
 * @name snk.components.label.directive:sk-label
 * @restrict E
 * @scope
 * @description
   skLabel é um componente reposnsavel pro apresentar um texto ligado a um campo do dataset,
   ou a um value quando no modo standalone
 * @param {object} sk-dataset dataset que o label irá fazer bind
 * @param {string} sk-field-name nome do campo ao qual o label irá se ligar no dataset.
 * @param {string} sk-value valor a ser apresentado quando for standalone.
 * @param {function} sk-lbl-function Função para personalização do label, recebe como parâmetro o valor atual do label,
 * deve retornar o novo label.
 * @param {string} padding valor de padding do label, default '5px'.
 */
angular
    .module('snk.components.linkedlist')
    .directive('skLinkedlist', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/linkedlist/linkedlist.tpl.html',
                controller: 'SkLinkedListController',
                controllerAs: 'ctrl',
                scope: {
                    options: '=?skOptions',
                    value: "=?skValue",
                    popoverListener: "=?skPopoverListener"
                },
            }
        }
    ]);
/**
 * @ngdoc directive
 * @name snk.components.icon.directive:sk-list
 * @restrict E
 * @description
 * A diretiva 'skList' permite você utilizar criar lista selecionáveis.
 *
 * @param {SkApi} [sk-api=undefined]
     Variavel onde sera fito o bind da api do sklist.
 * @example
 *  <example module="appList">
         <file name="appList.html">
            <div ng-controller="ListController as ctrl">
                <sk-list sk-drag-enabled="true" 
                     sk-drop-enabled="true" 
                     sk-drag-start
                     sk-drag-over
                     sk-drag-enter
                     sk-drag-exit
                     sk-drop="ctrl.dropList(event)"
                     sk-scroll-container 
                     sk-api="listApi" flex>
                        <div ng-repeat="item in ctrl.list" layout-padding ng-bind="item"></div>
                </sk-list>
                <div ondrop="drop(event)" ondragover="allowDrop(event)" style="position: relative; border: 1px solid #ccc;">
                    <div ondragstart="dragStart(event)" draggable="true" id="target">teste 4</div>
                </div>
            </div>
         </file>
         <file name="appList.js">
            angular
                .module('appList', ['snk'])
                .controller('ListController', ListController);

                function ListController($scope){
                    self = this;
                    self.list = ['Example 1', 'Example 2', 'Example 3'];

                    window.allowDrop = function(event){
                        event.preventDefault();
                    }
                    
                    window.drop = function(event) {
                        console.log('drop');
                        event.preventDefault();
                        var data = event.dataTransfer.getData("id");
                        var element = document.getElementById(data);
                        event.target.appendChild(element.cloneNode(true));
                    }

                    window.dragStart = function(event){
                        event.dataTransfer.setData("id", event.target.id);
                    }

                    self.dropList = function (event){
                        console.log('drop');
                        event.preventDefault();
                        var data = event.originalEvent.dataTransfer.getData('id');
                        var element = document.getElementById(data);
                        event.target.appendChild(element.cloneNode(true));
                    }
                }
         </file>
     </example>

 */
angular
    .module('snk.components.list')
    .directive('skList', ['$parse', 'SkComponentRegistry', 'AngularUtil', 'ArrayUtils','StringUtils', 
        function ($parse, SkComponentRegistry, AngularUtil, ArrayUtils, StringUtils) {
        return {
            restrict: 'AE',
            scope: {
                dropEnabled: "=?skDropEnabled",
                dragEnabled: "=?skDragEnabled",
                dragStart: "&?skDragStart",
                dragEnter: "&?skDragEnter",
                dragOver: "&?skDragOver",
                dragEnd: "&?skDragEnd",
                drop: "&?skDrop",
                api: "=?skApi",
                onSelection: '&?skOnSelection',
                enableCssTable: '=?skEnableCssTable',// altera a cor para a padrao da grade
                selectChecked: '=?skSelectChecked',
                selectLevel: '@?skSelectLevel'
            },
            link: function ($scope, $element, $attr) {
                var ACTIVE_CLASS = 'active';

                var self = this;
                var _source;

                var _selection = {};
                var _lastSelectionIndex = -1;

                var _indexsSelected = [];

                self.removeSelections = removeSelections;
                self.setSelection = setSelection;
                self.setSelectionChecked = setSelectionChecked;

                $scope.registerAddEventListenerElements = [];
               
                init();

                function init() {
                    $element.addClass('disable-text-selection');

                    if(StringUtils.toBoolean($scope.enableCssTable)){
                        $element.addClass('enable-css-grade');
                    }

                    $scope.api = self;

                    _source = AngularUtil.getNgRepeatSourceFromElement($element);

                    if ($attr.hasOwnProperty('skSelectLastOnChange')) {
                        $scope.$watchCollection(function () {
                            return _source.items();
                        }, function (newV, oldV) {
                            if (angular.isArray(newV) && angular.isArray(oldV)) {
                                handleListChange(newV, oldV);
                            }
                        });
                    } else if ($attr.hasOwnProperty('skSelectFirstOnChange')) {
                        $scope.$watchCollection(function () {
                            return _source.items();
                        }, function (newV, oldV) {
                            if (angular.isArray(newV) && angular.isArray(oldV)) {
                                if ($attr.skSelectFirstOnChange) {
                                    handleListChange(newV, oldV, 0);
                                    if ($attr.hasOwnProperty('skIgnoreSelectFirst')) {
                                        $attr.skSelectFirstOnChange = false;
                                    }
                                }
                            }
                        });
                    }else if($attr.hasOwnProperty('skSelectLevel')){
                        $scope.$watchCollection(function () {
                            return _source.items();
                        }, function (newV, oldV) {
                            if (angular.isArray(newV) && angular.isArray(oldV)) {
                                _source.items().forEach(function(item){
                                    if(item.value === $scope.selectLevel){
                                        handleListChange(newV, oldV, item.index);
                                    }
                                });
                            }
                        });
                    }

                    $element.on('mousedown', function (event) {                        
                        addEventsListenerInElement(event);
                    });

                    $element.on('click', function(event){
                        handleClick(event);
                    });

                    if($scope.dropEnabled){
                        $element.attr('draggable', true);
                        if($scope.drop){
                            $element.on('drop', function (event) {
                                event.preventDefault();

                                if(angular.isFunction($scope.drop)){
                                    $scope.drop({event: event}); 
                                }
                            });
                        }

                        $element.on('dragover', function (event) {
                            event.preventDefault();
                        });

                    }

                    if ($attr.skId){
                        var id = $scope.$eval($attr.skId) || $attr.skId;
                        SkComponentRegistry.register(self, id, $scope);
                    }
                }

                function handleListChange(newList, oldList, index) {
                    clearSelection();

                    if (angular.isDefined(newList) && newList.length > 0) {
                        var selectedIndex;

                        if (angular.isDefined(index) && newList[index]) {
                            selectedIndex = index;
                        } else {
                            selectedIndex = newList.length - 1;
                        }

                        var element = angular.element($element[0].children[selectedIndex]);

                        if (selectedIndex > -1) {
                            _selection[selectedIndex] = element;
                            element.addClass(ACTIVE_CLASS);
                        }
                    }
                }

                function handleClick(event) {
                    if (event.isDefaultPrevented()) {
                        return;
                    }

                    var selectedElement = getEventElement(event);

                    if (selectedElement) {
                        event.preventDefault();
                    } else {
                        return;
                    }

                    var selectedItem = _source.item(selectedElement);
                    var selectedIndex = ArrayUtils.indexOf(_source.items(), selectedItem);

                    if (event.shiftKey && _lastSelectionIndex > -1) {

                        var start, end;

                        if (selectedIndex >= _lastSelectionIndex) {
                            start = _lastSelectionIndex;
                            end = selectedIndex;
                        } else {
                            start = selectedIndex;
                            end = _lastSelectionIndex;
                        }

                        for (var i = start; i <= end; i++) {
                            if (!_selection[i]) {
                                _selection[i] = angular.element($element[0].children[i]);
                                _selection[i].addClass(ACTIVE_CLASS);
                            }
                        }

                        _lastSelectionIndex = selectedIndex;
                    } else {
                        if (event.ctrlKey) {
                            if (_selection.hasOwnProperty(selectedIndex)) {
                                _selection[selectedIndex].removeClass(ACTIVE_CLASS);
                                delete _selection[selectedIndex];
                            } else {
                                _selection[selectedIndex] = selectedElement;
                                selectedElement.addClass(ACTIVE_CLASS);
                            }
                        } else {
                            clearSelection();

                            if($scope.selectChecked){
                                setSelectionChecked(selectedIndex);
                            } else if (selectedIndex > -1) {
                                _selection[selectedIndex] = selectedElement;
                                selectedElement.addClass(ACTIVE_CLASS);
                            }
                        }

                        _lastSelectionIndex = selectedIndex;
                    }

                    onSelectionChanged();
                }

                function clearSelection() {
                    angular.forEach(_selection, function (value) {
                        value.removeClass(ACTIVE_CLASS);
                    });

                    _selection = {};
                }

                function getEventElement(event) {
                    var element = event.srcElement || event.target;

                    if (element == $element[0]){
                        return undefined;
                    }

                    while (element && element.parentElement && element.parentElement != $element[0]) {
                        element = element.parentElement;
                    }

                    return angular.element(element);
                }

                function removeSelections() {
                    var selections = [];

                    var items = _source.items();

                    angular.forEach(_selection, function (value, key) {
                        var item = _source.item(value);

                        ArrayUtils.removeReference(items, item);

                        selections.push(item);

                        delete _selection[key];
                    });

                    onSelectionChanged();

                    return selections;
                }

                function addEventsListenerInElement(event){

                    var element = getEventElement(event);

                    if(!element){
                        return;
                    }

                    if(!($scope.registerAddEventListenerElements.indexOf(element.attr('id') || element[0].innerText) > -1)){
                        
                        if($scope.dragEnabled){
                            element.attr('draggable', true);
                            
                            element.on('dragstart', function (event) {
                                event.target.id = event.target.id || event.target.innerText;
                                event.originalEvent.dataTransfer.setData('id', event.target.id);
                                event.originalEvent.dataTransfer.setData('items', JSON.stringify({items: _indexsSelected}));

                                if(angular.isFunction($scope.dragStart)){
                                    $scope.dragStart(event); 
                                }
                            });
                        }
            
                        if($scope.dropEnabled){
                            if($scope.dragEnter){
                                element.on('dragenter', function (event) {
                                    if(angular.isFunction($scope.dragenter)){
                                        $scope.dragenter(event); 
                                    }
                                });
                            }

                            if($scope.dragEnd){
                                element.on('dragend', function (event) {
                                    if(angular.isFunction($scope.dragend)){
                                        $scope.dragend(event); 
                                    }
                                });
                            }

                            if($scope.dragOver){
                                element.on('dragover', function (event) {
                                    event.preventDefault();
                                });
                            }
                        }
                        $scope.registerAddEventListenerElements.push(element[0].innerHTML);
                    }
                }

                /**
                 * @ngdoc
                 * @name snk.components.icon.directive:sk-list#setSelection
                 * @methodOf snk.components.icon.directive:sk-list
                 * @description
                 * Método responsável por setar itens selecionados na lista.
                 * PS: Os itens passados como parâmetro devem se o mesmo item no array utilizado no ng-repeat 
                 * para exibição da lista, pois, sera utilizada a referência do item no array.
                 * @param {Array} items pode ser um array ou o item da lista a ser selecionado.
                 * @param {String} [reset=true] se false não desmarca os itens que já estão selecionados na lista.
                 * @example 
                 * <pre>
                 *  self.apiList.setSelection([self.list[0], self.list[2]], false);
                 *  self.apiList.setSelection('Example 1', true);                 *  
                 * </pre>
                 */
                function setSelection(items, reset) {
                    let itemsArray;

                    if(!angular.isArray(items)){
                        itemsArray = [items];
                    }else{
                        itemsArray = items;
                    }

                    if(reset != false){
                        clearSelection();
                    }

                    itemsArray.forEach(function(item){
                        if(!_selection.hasOwnProperty(item)){
                            let indexToSelect = ArrayUtils.indexOf(_source.items(), item);
                            _selection[item] = angular.element($element.children()[indexToSelect]);
                            _selection[item].addClass(ACTIVE_CLASS);
                        }
                    });

                    onSelectionChanged();
                }

                function setSelectionChecked(index) {
                    setTimeout(() => {
                        var selectedElement = angular.element(".selectedChecked");
                        _selection[index] = selectedElement;
                        clearSelection();
                        selectedElement[index].className += " " + ACTIVE_CLASS;
                    }, 100);
                }

                function onSelectionChanged(){
                    _indexsSelected = [];

                    angular.forEach(_selection, function (value, key) {
                        var item = _source.item(value);
                        _indexsSelected.push(ArrayUtils.indexOf(_source.items(), item));                       
                    });
                    if(angular.isFunction($scope.onSelection)){

                        $scope.onSelection({selectedItems: _indexsSelected});
                    }
                }
            }
        }
    }]);

/**
 * Created by Leonardo.mendes on 22/02/2018.
 */
angular
    .module('snk.components.listOrder')
    .controller('SkListOrderController', ['$scope', '$attrs', '$element', 'ArrayUtils', 'i18n', 'SkApplication', 'StringUtils', 'ObjectUtils', 'AngularUtil', 'PopUpParameter', 'MessageUtils',
        function ($scope, $attrs, $element, ArrayUtils, i18n, SkApplication, StringUtils, ObjectUtils, AngularUtil, PopUpParameter, MessageUtils) {
            var self = this;

            var _lastListSelected;

            $scope.listSelectedItems = [];
            $scope.itemSelect = 'item-selected';
            $scope.typeItem = 'item';

            $scope.labelCustomName = $scope.labelCustomName || 'label';

            $scope.selectItem = selectItem;
            $scope.hasSomeListItem = hasSomeListItem;
            $scope.hasSomeListItemSelected = hasSomeListItemSelected;
            $scope.changeOrder = changeOrder;
            $scope.isFirstItemSelected = isFirstItemSelected;
            $scope.isLastItemSelected = isLastItemSelected;
            $scope.isItemSelected = isItemSelected;
            $scope.hasMoreThanTwoItem = hasMoreThanTwoItem;
            $scope.onDestSearchTermChange = onDestSearchTermChange;

            init();
            function init() {
                if ($scope.isTypeBtn) {
                    $scope.typeItem = 'item item-btn';
                    $scope.itemSelect = 'item-btn-selected';
                }

                $element.attr('layout', 'column');

                if (angular.isDefined($attrs['skListTitle'])) {
                    $scope.listTitle = i18n($attrs['skListTitle']);
                }

                var controllerInfo = AngularUtil.getContextControllerInfo($element);
                var controllerAs = ObjectUtils.getProperty(controllerInfo, 'controllerAs');
                if (controllerAs) {
                    $scope[controllerAs] = controllerInfo.controllerInstance;
                }

                $scope.listData = $scope.listData || [];
                
                $scope.$watch('listData', function (newV, oldV) {
                    if (angular.isUndefined(_lastListSelected) || newV !== oldV) {
                        $scope.listSelectedItems.length = 0
                        
                        if (newV && newV.length > 0) {
                            selectItem(newV[0]);
                        }
                    }
                });
            }

            function selectItem(item, $event) {
                var currentIndex;
                
                if ($event && !$event.ctrlKey && !$event.shiftKey) {
                    $scope.listSelectedItems.length = 0
                    $scope.listSelectedItems.push(item);
                    _lastListSelected = item;
                } else if ($event && $event.shiftKey) {
                    var lastSelectedIndex;

                    lastSelectedIndex = $scope.listData.indexOf(_lastListSelected);
                    currentIndex = $scope.listData.indexOf(item);
                    _lastListSelected = item;

                    if (lastSelectedIndex < currentIndex) {
                        for (var i = lastSelectedIndex; i <= currentIndex; i++) {
                            $scope.listSelectedItems.push($scope.listData[i]);
                        }
                    } else {
                        for (var i = lastSelectedIndex; i >= currentIndex; i--) {
                            $scope.listSelectedItems.push($scope.listData[i]);
                        }
                    }
                } else {
                    if ($scope.listSelectedItems.indexOf(item) < 0) {
                        $scope.listSelectedItems.push(item);
                        _lastListSelected = item;
                    } else {
                        ArrayUtils.removeReference($scope.listSelectedItems, item);
                    }
                }

                onChange(item);
            }


            function externalOnSortItem(item) {
                if (angular.isFunction($scope.onSortItem)) {
                    $scope.onSortItem({ item: item, listName: $scope.listData});
                }
            }

            function isItemSelected(item, type) {
                var selectedList = $scope.listSelectedItems;

                var isItemSelected = angular.isDefined(ArrayUtils.find(selectedList, function (listItem) {
                    return ObjectUtils.equals(listItem, item);
                }));

                if((type == 'item' && $scope.isTypeBtn) || (type == 'btn' && !$scope.isTypeBtn)){
                    return false;
                }

                return isItemSelected;

            }

            function hasSomeListItem() {
                return $scope.listData.length > 0;
            }

            function hasSomeListItemSelected() {
                return $scope.listSelectedItems.length > 0;
            }

            function isFirstItemSelected() {
                var list = $scope.listData;
                var selectedList = $scope.listSelectedItems;

                if (selectedList.indexOf(list[0]) > -1 || ($scope.fixTop && selectedList.indexOf(list[1]) > -1)) {
                    return true;
                }
                
                return false;
            }

            function isLastItemSelected() {
                var list = $scope.listData;
                var selectedList = $scope.listSelectedItems;

                if (selectedList.indexOf(list[list.length - 1]) > -1 || ($scope.fixTop && selectedList.indexOf(list[0]) > -1)){
                    return true;
                }

                return false;
            }

            function changeOrder(direction, moveAll) {
                //Apenas a lista de destino suporta ordenação através de botões.
                if (direction == 'up') {
                    if (moveAll) {
                        while (!isFirstItemSelected()) {
                            moveUp();
                        }
                    } else if(!isFirstItemSelected()){
                        moveUp();
                    }
                } else if (direction == 'down') {
                    if (moveAll) {
                        while (!isLastItemSelected()) {
                            moveDown();
                        }
                    } else if(!isLastItemSelected()){
                        moveDown();
                    }
                }
            }

            function moveUp() {
                var list = $scope.listData;
                var selectedList = $scope.listSelectedItems;

                for (var i = 1; i < list.length; i++) {
                    var item = list[i];
                    var selectedItemIndex = list.indexOf(item);

                    if (isItemSelected(item)) {
                        changeItems(list[selectedItemIndex - 1], item);

                        externalOnSortItem(item);

                        onChange(item);
                    }
                }
            }

            function moveDown() {
                var list = $scope.listData;
                var selectedList = $scope.listSelectedItems;

                for (var i = list.length - 2; i >= 0; i--) {
                    var item = list[i];
                    var selectedItemIndex = list.indexOf(item);

                    if (isItemSelected(item)) {
                        changeItems(list[selectedItemIndex + 1], item);

                        externalOnSortItem(item);

                        onChange(item);
                    }
                }
            }

            function onChange(item) {
                if (angular.isFunction($scope.eventClickItem)) {

                    var params = {'item':item, 'index' : $scope.listData.indexOf(item)};

                    $scope.eventClickItem(params);
                }
            }
            
            function changeItems(item1, item2) {
                var list = $scope.listData;

                if (list) {
                    var item1Index = list.indexOf(item1);
                    var item2Index = list.indexOf(item2);

                    list[item1Index] = item2;
                    list[item2Index] = item1;
                }
            }

            function onDestSearchTermChange(searchTerm) {
                if (StringUtils.isEmpty(searchTerm)) {
                    return;
                }
                
                $scope.listSelectedItems.length = 0;

                for (var i = 0; i < $scope.listData.length; i++) {
                    var item = $scope.listData[i];

                    if (angular.isFunction($scope.filterFn)) {
                        if ($scope.filterFn({ item: item, searchTerm: searchTerm })) {
                            _lastListSelected = item;
                            $scope.listSelectedItems.push(item);
                            return;
                        }
                    } else {
                        var label = item;

                        if (angular.isObject(label)) {
                            label = label[$scope.labelCustomName];

                            var containsRE = new RegExp(StringUtils.replaceAccentuatedChars(searchTerm), 'i');

                            if (angular.isString(label)) {
                                label = StringUtils.replaceAccentuatedChars(label);
                                return containsRE.test(label);
                            } else {
                                for (var key in item) {
                                    label = item[key];
                                    label = StringUtils.replaceAccentuatedChars(label);

                                    if (containsRE.test(label)) {
                                        _lastListSelected = item;
                                        $scope.listSelectedItems.push(item);
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            function hasMoreThanTwoItem(listName) {
                return $scope.listData.length > 1;
            }
        }
    ]);
/**
 * Created by Leonardo.mendes on 22/02/2018.
 */
/**
 * @ngdoc directive
 * @name snk.components.listOrder.directive:sk-list-order
 * @restrict E
 * @scope
 * @description
   ListOrder e um compenente para ordenar uma lista de objetos.

 * @param {string} sk-list-title Título da lista.
 * @param {array} sk-src-data Array contendo os dados que serão apresentados na lista.
 * @param {function} sk-src-filter-fn Função a ser invocada quando ocorrer um filtro na lista.
 * @param {element} sk-dest-right-container Template que será inserido à direita do campo da pesquisa da lista.
 * @param {element} sk-dest-item-tpl Template para renderização de cada item da lista. Pode-se usar o objeto <i>item</i>.
 *
 */
angular
    .module('snk.components.listOrder')
    .directive('skListOrder', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/listOrder/listOrder.tpl.html',
                controller: 'SkListOrderController',
                transclude: {
                    destRightContainer: '?skDestRightContainer',
                    destItemTpl: '?skDestItemTpl'
                },
                scope: {
                    listData: '=?skListData',
                    filterFn: '&?skFilterFn',
                    eventClickItem: '&?skEventClickItem',
                    onSortItem: '&?skOnSortItem',
                    optionsField: '&?skOptionsField',
                    childrenCustomName: '@?skChildrenCustomName',
                    listTitle: '@?skListTitle',
                    labelCustomName: '@?skLabelCustomName',
                    movePosition: '=?skMovePosition',
                    showSearch: '=?skShowSearch',
                    isTypeBtn: '=?skIsTypeBtn',
                    fixTop: '=?skFixTop'
                }
            }
        }
    ]);
angular
    .module('snk.components.livetimeline')
    .controller('SkLiveTimeLineController', SkLiveTimeLineController);

SkLiveTimeLineController.$inject = ['$scope', '$element'];

function SkLiveTimeLineController($scope, $element) {
    let self = this;
    self.chart = null;
    self.series = [];
    self.categories = [];
    self.container = $element.context;
    self.segmented = null;
    self.zoomX = [null, null];
    self.zoomY = [null, null];
    self.maxHeight = 640;

    init();

    function init() {
        $scope.$watch('data', formatData);
        $scope.$watch('sorter', formatData);
        self.timeLineEl = document.getElementById('timeline-container');
    }

    function formatData() {
        let sortedData = sorterData($scope.data);
        self.categories = sortedData.map(thread => thread.id).filter((element, position, list) => list.indexOf(element) == position);
        self.series = sortedData.map(thread =>
            (
                {
                    x: thread.start,
                    x2: thread.end ? thread.end : (moment().toDate().getTime()),
                    y: self.categories.indexOf(thread.id),
                    status:thread.status,
                    color: thread.color
                }
            )
        );
        if(self.series.length > 0) {
            buildChart();
        } else {
            clearElemente();
        }
    }

    function clearElemente() {
        let el = document.getElementById('timeline-container')
        while(el.firstChild){
            el.removeChild(el.firstChild);
        }
    }

    function sorterData(data) {
        switch($scope.sorter) {
            case 'alphabetical':
                data.sort((a,b) => {
                    if (a.id < b.id)
                        return -1;
                    if (a.id > b.id)
                        return 1;
                    return 0;
                })
                break;
            case 'highest':
                data.sort((a,b) => {
                    if (a.id == b.id) {
                        return 0;
                    } else {
                        let aList = data.filter(thread => thread.id == a.id),
                            bList = data.filter(thread => thread.id == b.id),
                            aDiff = aList.map(t => (t.end??moment().toDate().getTime())).reduce((max,current) => Math.max(max, current)) - 
                                aList.map(bt => bt.start).reduce((min, current) => Math.min(min, current)),
                            bDiff = bList.map(t => (t.end??moment().toDate().getTime())).reduce((max, current) => Math.max(max, current)) - 
                                bList.map(bt => bt.start).reduce((min, current) => Math.min(min, current));
                        return bDiff - aDiff;
                    }
                })
                break;
       }
       return data;
        
    }

    function buildChart() {
        Highcharts.chart('timeline-container', {
            chart: {
                type: 'xrange',
                zoomType: 'x',
                scrollablePlotArea: {
                    minWidth: 700,
                    scrollPositionX: 1
                },
                height:`${Math.max(300, self.categories.length * 26)}px`,
            },
            time: {
                timezone: 'America/Sao_Paulo'
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {
                title: {
                    text: 'Threads'
                },
                categories: self.categories,
                reversed: true
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    events: {
                        click: onClick,
                    }
                }
            },
            tooltip: {
                outside: false,
                backgroundColor: '#FFFFFF',
                formatter: function() {
                    let tooltip = `<span><b>Thread</b>: ${this.point.yCategory}</span><br>`; 
                    tooltip += `<b>Duração</b>: ${moment(this.x).format('DD/MM/YYYY HH:mm:ss')} até ${moment(this.x2).format('DD/MM/YYYY HH:mm:ss')}`;
                    tooltip += `<br><b>Status</b>: <span style="color:${this.point.color}"><b>${this.point.status}</b></span>:`;
                    return tooltip;
                } 
            },
            series: [{
                name: '',
                turboThreshold: 999999999,
                data: self.series,
            }]
        });
    }
    
    function onClick($event) {
        $scope.callback($event.point.yCategory)
    }

}

angular
    .module('snk.components.livetimeline')
    .directive('skLiveTimeLine', [function SkLiveTimeLineDirective() {
    return {
        restrict: 'E',
        scope: {
            data: '=?skData',
            callback: '=?skLineClick',
            isOpacity: '=?skIsOpacity',
            sorter: '=?skSorter'
        },
        templateUrl: 'components/livetimeline/livetimeline.tpl.html',
        controller: 'SkLiveTimeLineController',
    };
}]);
/**
 * @ngdoc directive
 * @name snk.components.load.directive:sk-load
 * @restrict A
 * @description
 * A diretiva 'skLoad' permite você registrar uma função para ser executada no momento em que o elemento for carregado.
 *
 */
angular
    .module('snk.components.load')
    .directive('skLoad', ['$parse', 'AngularUtil', function ($parse, AngularUtil) {
        return {
            restrict: 'A',
            compile: function($element, attr) {
                var fn = $parse(attr['skLoad']);

                return function(scope, element, attr) {
                    element.on('load', function(event) {
                        AngularUtil.apply(scope, function() {
                            fn(scope, {$event: event});
                        });
                    });
                };
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name snk.components.loadingpanel.directive:sk-loading-panel
 * @restrict E
 * @description
 * A diretiva 'skLoadingPanel' é apenas um painel que mostra o label/icone de carregamento no centro.
 *
 */
angular
    .module('snk.components.loadingpanel')
    .directive('skLoadingPanel', [function () {
        return {
            restrict: 'E',
            template:
            '<sk-icon svg-src="/mge/assets/svg/loading.svg" class="spin"></sk-icon>' +
            '<span sk-i18n>Geral.lblCarregando</span>',
            compile: function($element) {
                $element.addClass('container-absolute');
                $element.attr('layout', 'row');
                $element.attr('layout-align', 'center start');
            }
        };
    }]);
/*
 * Author: Cleverson Puche
 */

angular
    .module('snk.components.mapbutton')
    .controller('SkMapButtonController',['$scope', 'SkI18nService', 'StringUtils', 'SkApplication',
        function($scope, SkI18nService, StringUtils, SkApplication) {
            var self = this;

            var _codEmp;
            var _codParc;

            self.setCodParc = setCodParc;
            self.setCodEmp = setCodEmp;

            const PROCURAR_END_PARCEIRO        = 1;
            const PROCURAR_END_ENTREGA         = 2;
            const PROCURAR_ROTA_END_PARCEIRO   = 3;
            const PROCURAR_ROTA_END_ENTREGA    = 4;

            $scope.getPopOverProperties = getPopOverProperties;

            function abrirMapa(type) {
                if(type == PROCURAR_END_ENTREGA || type == PROCURAR_END_PARCEIRO) {
                    _codEmp = "";
                }

                var tipoEndereco = "P_" + type;

                var idTituloTela;
                switch(type) {
                    case PROCURAR_END_ENTREGA:
                        idTituloTela = 1;
                        break;
                    case PROCURAR_END_PARCEIRO:
                        idTituloTela = 2;
                        break;
                    case PROCURAR_ROTA_END_ENTREGA:
                        idTituloTela = 3;
                        break;
                    case PROCURAR_ROTA_END_PARCEIRO:
                        idTituloTela = 4;
                        break;
                }

                var obj = {
                    TIPO: tipoEndereco,
                    IDTITULO: idTituloTela,
                    CODPARC: _codParc
                }
                if(StringUtils.emptyAsNull(_codEmp) != null) {
                    obj.CODEMP = _codEmp;
                }

                SkApplication.instance().openApp('br.com.sankhya.mge.cons.mapavisualizadorenderecos',obj);
            }

            function setCodParc(codParc) {
                _codParc = codParc;
            }

            function setCodEmp(codEmp) {
                _codEmp = codEmp;
            }

            function getPopOverProperties() {
                return {
                    mostraEnderecoDeEntrega: $scope.mostraEnderecoDeEntrega,
                    mostraEnderecoDoParceiro: $scope.mostraEnderecoDoParceiro,
                    mostraRotaEnderecoDeEntrega: $scope.mostraRotaEnderecoDeEntrega,
                    mostraRotaEnderecoDoParceiro: $scope.mostraRotaEnderecoDoParceiro,
                    PROCURAR_END_PARCEIRO: PROCURAR_END_PARCEIRO,
                    PROCURAR_END_ENTREGA: PROCURAR_END_ENTREGA,
                    PROCURAR_ROTA_END_PARCEIRO: PROCURAR_ROTA_END_PARCEIRO,
                    PROCURAR_ROTA_END_ENTREGA: PROCURAR_ROTA_END_ENTREGA,
                    abrirMapa: abrirMapa,
                };
            }
        }
    ]);
/*
 * Author: Cleverson Puche
 */

angular
    .module('snk.components.mapbutton')
    .directive('skMapButton',[function() {
        return {
            restrict: 'E',
            controller: 'SkMapButtonController',
            templateUrl: 'components/mapbutton/mapbutton.tpl.html',
            scope: {
                enabled: '=?skEnabled',
                mostraEnderecoDeEntrega: '=?skMostraEnderecoDeEntrega',
                mostraEnderecoDoParceiro: '=?skMostraEnderecoDoParceiro',
                mostraRotaEnderecoDeEntrega: '=?skMostraRotaEnderecoDeEntrega',
                mostraRotaEnderecoDoParceiro: '=?skMostraRotaEnderecoDoParceiro'
            },
            link: linkFn
        };

        function linkFn(scope, element, attrs, controller) {
            if (attrs.id) {
                scope.$parent[attrs.id] = controller;
            }
        }
    }])
angular
.module('snk.components.margemcontribchart')
.component('skMargemContribChart', {
    templateUrl: 'components/margemcontribchart/margemcontribchart.tpl.html',
    bindings: {
        fat: '<',
        cmv: '<',
        gv: '<',
        gf: '<',
        mc: '<',
        lucro: '<',
        parentCtrl: '<',
        showInfo: '<',
        getDataValue: "&"
    },
    controller: 'SkMargemContribChartController'
})
.controller('SkMargemContribChartController', ['NumberUtils','SkI18nService', 'SanPopup', 'MessageUtils', 'i18n', function (NumberUtils, SkI18nService, SanPopup, MessageUtils, i18n) {
    var self = this;

    var mcDiv;
    var gvDiv;
    var gfDiv;
    var cmvDiv;
    var prejDiv;
    var secondRow;
    var thirdRow;

    self.onDoubleClick = onDoubleClick;

    self.fatPorcento = 0.0;
    self.cmvPorcento = 0.0;
    self.gvPorcento = 0.0;
    self.mcPorcento = 0.0;
    self.gfPorcento = 0.0;
    self.lucroPorcento = 0.0;

    self.labelFaturamento = SkI18nService.instant('ChartRentabilidade.labelFaturamento');
    self.labelCustoMercVendido = SkI18nService.instant('ChartRentabilidade.labelCustoMercVendido');
    self.labelGastoVariavel = SkI18nService.instant('ChartRentabilidade.labelGastoVariavel');
    self.labelMargemContrib = SkI18nService.instant('ChartRentabilidade.labelMargemContrib');
    self.labelPartGastoFixo = SkI18nService.instant('ChartRentabilidade.labelPartGastoFixo');
    self.labelLucro = SkI18nService.instant('ChartRentabilidade.labelLucro');
    self.labelPrejuizo = SkI18nService.instant('ChartRentabilidade.labelPrejuizo');


    self.$onInit = function () {
        self.mc = NumberUtils.getNumberOrZero(self.gf) + NumberUtils.getNumberOrZero(self.lucro);

        mcDiv = $('#mcDiv').get(0);
        gvDiv = $('#gvDiv').get(0);
        gfDiv = $('#gfDiv').get(0);
        cmvDiv = $('#cmvDiv').get(0);
        prejDiv = $('#prejDiv').get(0);
        secondRow = $('#secondRow').get(0);
        thirdRow = $('#thirdRow').get(0);

        self.semInformacoes = true;

        self.calcLabelsChart = calcLabelsChart();

        self.$onChanges();
    }

    self.$onChanges = function (changes) {

        loadValues();

        if(!cmvDiv) {
            self.semInformacoes = true;
            return;
        }

        if(!self.fat || self.fat <= 0) {
            self.semInformacoes = true;
            return;
        }

        self.semInformacoes = false;
        cmvDiv.style.width = 0;

        let widthRate = self.lucro > 0 ? (100 / self.fat) : (100 / (self.fat - self.lucro));

        if(self.cmv + self.gv + self.mc > self.fat) {
            if(self.lucro > 0) {
                widthRate = 100 / (self.cmv + self.gv + self.mc);
            } else {
                widthRate = 100 / (self.cmv + self.gv + self.mc - self.lucro);
            }
        }
                    
        fatDiv.style.width = Math.abs(self.fat) * widthRate + "%";
        
        if (self.cmv > 0) {
            cmvDiv.style.height = "100%";
            cmvDiv.style.borderWidth = "1px";
            cmvDiv.style.width = Math.abs(self.cmv) * widthRate + "%";
        } else {
            cmvDiv.style.height = "0%";
            cmvDiv.style.borderWidth = "0px";
        }

        if (self.gv > 0) {
            gvDiv.style.height = "100%";
            gvDiv.style.borderWidth = "1px";
            gvDiv.style.width = Math.abs(self.gv) * widthRate + "%";
        } else {
            gvDiv.style.height = "0%";
            gvDiv.style.borderWidth = "0px";
        }

        if (self.mc > 0) {
            mcDiv.style.width = Math.abs(self.mc) * widthRate + "%";

            mcDiv.style.clear = "";
            mcDiv.style.float = 'left';
            mcDiv.style.borderRightWidth = '1px';

            if (self.gf > 0) {
                gfDiv.style.width = Math.abs(self.gf) * widthRate + "%";
                
                gvDiv.style.borderRightWidth = "0px";
            } else {
                cmvDiv.style.borderRightWidth = "0px";
            }
            
            gfDiv.style.clear = "";
            gfDiv.style.borderRightWidth = '1px';
            gfDiv.style.borderLeftWidth = '1px';

            $("#mcDiv").detach().appendTo("#secondRow");
        } else {
            gfDiv.style.width = Math.abs(self.gf) * widthRate + "%";
            gfDiv.style.borderRightWidth = '1px';
            gfDiv.style.borderLeftWidth = '0px';
            
            cmvDiv.style.borderRightWidth = '1px';
            gvDiv.style.borderRightWidth = '1px';

            mcDiv.style.width = Math.abs(self.mc) * widthRate + "%";
            mcDiv.style.float = 'right';
            mcDiv.style.borderLeftWidth = '1px';

            $("#mcDiv").detach().appendTo("#thirdRow");
        }
        
        if (self.lucro > 0) {
            lucroDiv.style.width = Math.abs(self.lucro) * widthRate + "%";
            self.height = 33;
            //lucroText.setText("L");
            //thirdRow.insert(lucroDiv,0);
            
            gfDiv.style.borderRightWidth = '0px';
        } else {
            prejDiv.style.width = Math.abs(self.lucro) * widthRate + '%';
            //lucroDiv.setHeight("100%");
            //lucroDiv.setStyleName("margemcontribchart-prejuDiv");
            //$('#textLucro').text("P");
            self.height = 25;
            //lucroText.setText("P");
            //fourthRow.add(lucroDiv);
            //add(fourthRow);
        }
    }

    function calcLabelsChart() {
        if(self.showInfo == true) {
            return "hidden";
        }
        if(self.showInfo == false) {
            return "visible";
        }
    }

    function loadValues() {

        self.fatToolTip   = NumberUtils.format(self.fat   || 0, 2);
        self.cmvToolTip   = NumberUtils.format(self.cmv   || 0, 2);
        self.gvToolTip    = NumberUtils.format(self.gv    || 0, 2);
        self.mcToolTip    = NumberUtils.format(self.mc    || 0, 2);
        self.lucroToolTip = NumberUtils.format(self.lucro || 0, 2);
        self.gfToolTip    = NumberUtils.format(self.gf    || 0, 2);

        if (self.showInfo) {
            const invoicing = self.fat || 1;
            self.fatPorcento    = NumberUtils.format(100, 3);
            self.cmvPorcento    = NumberUtils.format(((self.cmv   || 0) / invoicing) * 100, 3);
            self.gvPorcento     = NumberUtils.format(((self.gv    || 0) / invoicing) * 100, 3);
            self.mcPorcento     = NumberUtils.format(((self.mc    || 0) / invoicing) * 100, 3);
            self.gfPorcento     = NumberUtils.format(((self.gf    || 0) / invoicing) * 100, 3);
            self.lucroPorcento  = NumberUtils.format(((self.lucro || 0) / invoicing) * 100, 3);
        }
    }

    function onDoubleClick(label, type) {
        if(self.getDataValue == undefined) {
            return;
        }
        
        if (type == "mc") {
            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Core.Dashboard.msgEditBarMC'));
            return;
        }

        expDataValue = self.getDataValue()();
        expDataValue.type = type;
        expDataValue.showQueryOptions = true;

        SanPopup.open({
            title: 'Editar ' + label,
            templateUrl: "html5/GadgetBuilder/dashboard/GadgetControlExpContent.tpl.html",
            controller: 'GadgetControlExpController',
            controllerAs: 'ctrl',
            showBtnNo: false,
            size: 'lg',
            height: 'auto',
            windowClass: 'popUpGadgetParam',
            resolve: {
                dataValue: expDataValue
            }
        }).result.then(function (content) {
            if(self.parentCtrl){
                self.parentCtrl.eventBusEditor.dispatchEvent('gadgetChange');
            }
        });
    }
}]);

/**
 * @ngdoc directive
 * @name snk.components.sk-mask-builder.directive:sk-mask-builder
 * @restrict E

 * @description
 *   	Esse componente é responsável por construir máscaras. 
 *
 * @param {string} [sk-field-name=undefined] Nome do campo que contém a mascára no dataset.
 * @param {string} [sk-dataset=undefined] Nesse parâmetro deve ser informado o dataSet da entidade que será utilizada, 
 * se não informado o sk-value, este passa a ser obrigátorio .
 * @param {string} [sk-value=undefined] Variável em que ocorrerá o bind entre o model e o view, quando no modo standalone (sem Dataset),
 * se não informado o sk-dataset, este passa a ser obrigátorio.
 * @param {string} [sk-title=undefined] Nesse parâmetro deve ser informado o título que será utilizada.
 * @param {string} [sk-mask-sufix="0"] Nesse parâmetro deve ser informado o sufixo que será utilizada na mascára.
 * @param {string} [sk-maxlength=undefined] Nesse parâmetro deve ser informado o número limite de dígitos a ser utilizada na mascára.
 *
 * @example
     <example module="app">
         <file name="MaskBuilderExample.html">
            <div ng-controller="MyController as ctrl">
            	<sk-mask-builder sk-value="ctrl.value"
                                 sk-title="Máscara de exemplo">
                </sk-mask-builder>
                <span ng-bind="ctrl.value"></span>
            </div>
         </file>
         <file name="app.js">
                angular
                    .module('app', ['snk'])
                    .controller('MyController', function($scope){
                        var self = this;
                        self.value = '9.9.9.99.99999;0';
                });
         </file>
     </example>
 */
angular
    .module('snk.components.maskbuilder')
    .directive('skMaskBuilder', [function () {
        return {
            templateUrl: 'components/maskbuilder/maskbuilder.tpl.html',
            controller: 'SkMaskBuilderController',
            controllerAs: '$ctrl',
            transclude: true,
            scope: {
                value: '=?skValue',
                fieldName: '@skFieldName',
                dataset: '<?skDataset',
                title: '@skTitle',
                maskSufix: '@skMaskSufix',
                maxlength: '@?skMaxlength'
            }
        };
    }])
    .controller('SkMaskBuilderController', ['$scope', 'StringUtils', '$attrs', '$element', 'ObjectUtils', 'MessageUtils', 'i18n',
        function ($scope, StringUtils, $attrs, $element, ObjectUtils, MessageUtils, i18n) {
            var self = this;

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData
            });

            self.$onInit = $onInit;

            self.updateMascara = updateMascara;
            self.carregarMascara = carregarMascara;
            self.addLevel = addLevel;
            self.removeLevel = removeLevel;

            //Variaveis disponivel controller 
            self.niveis = [];
            self.mascara = [];
            self.title = i18n($scope.title);

            function $onInit() {
                $element.attr('layout', 'column');

                if ($attrs.hasOwnProperty('skDataset')) {
                    //Não faz nada pois o FieldBinder vai atualizar quando pronto.
                } else if ($attrs.hasOwnProperty('skValue')) {
                    $scope.$watch('value', carregarMascara);
                } else {
                    throw new Error('Deve ser informado o sk-value ou sk-dataset');
                }

                if (angular.isUndefined($scope.maskSufix)) {
                    $scope.maskSufix = '0';
                }

                self.skModelOptions = $scope.maxlength ? { debounce: 350 } : undefined;
            }

            function updateMascara(notifyToDataset, nivel) {

                if ($scope.maxlength && isMaxlength(0)) {
                    nivel.value = nivel.oldValue;
                    throw new Error(i18n('MaskBuilder.MaxLength', { limite: $scope.maxlength }));
                }

                if (self.niveis && self.niveis.length > 0) {

                    var maskValue = self.niveis.map(function (qtd) {
                        qtd.value > 0 ? qtd.oldValue = qtd.value : qtd.value = qtd.oldValue;

                        return StringUtils.replicate('9', qtd.value);
                    });

                    $scope.value = maskValue.join('\\.') + ';' + $scope.maskSufix;
                    self.mascara = maskValue.join('.');
                } else {
                    $scope.value = undefined;
                    self.mascara = '';
                }

                if (notifyToDataset) {
                    self.notifyChangeToDataset();
                }
            }

            function carregarMascara(mascara) {
                self.niveis = [];

                if (!mascara) {
                    self.mascara = '';
                    return;
                }

                self.mascara = [];

                var posDefaultChar = mascara.indexOf(';');

                if (posDefaultChar > -1) {
                    mascara = mascara.substr(0, posDefaultChar);
                }

                mascara = mascara.replace(/\\/g, "");

                if (StringUtils.emptyAsNull(mascara) != null) {

                    self.niveis = mascara.split('\.').map(function (nivel) {
                        return { value: nivel.length, oldValue: nivel.length }
                    });

                    self.mascara = self.niveis.map(function (qtd) {
                        return StringUtils.replicate('9', qtd.value);
                    }).join('.');
                }
            }

            function removeLevel() {
                if (self.niveis.length <= 1) {
                    MessageUtils.showAlert(i18n('MaskBuilder.titleRemoverNivelMin'),
                        i18n('MaskBuilder.msgRemoverNivelMin'));
                } else {
                    self.niveis.pop();
                    updateMascara(true);
                }
            }

            function addLevel() {
                if ($scope.maxlength && isMaxlength(1)) {
                    throw new Error(i18n('MaskBuilder.MaxLength', { limite: $scope.maxlength }));
                }

                self.niveis.push({
                    value: 1,
                    oldValue: 1
                });

                updateMascara(true);
            }

            function isMaxlength(num) {
                self.niveis.forEach(function (item) {
                    num += item.value;
                });

                return num > $scope.maxlength;
            }

            function setData(data) {
                carregarMascara(data);
            }
        }]);

/*
 - Clicar em outro lugar da tela e fechar, vai existir?
 - Implementar para o componente salvar e carregar estados de tela
 */

angular
    .module('snk.components.multilist')
    .controller('SkMultilistController', ['$scope', '$element', 'SkConstants', '$compile', '$document', 'PositionUtils', 'StringUtils', 'DomUtil', '$timeout', 'AngularUtil', '$filter', 'ServiceProxy', 'ArrayUtils', 'SkApplication', '$q', 'DropdownUtil', 'i18n', 'ObjectUtils', function ($scope, $element, SkConstants, $compile, $document, PositionUtils, StringUtils, DomUtil, $timeout, AngularUtil, $filter, ServiceProxy, ArrayUtils, SkApplication, $q, DropdownUtil, i18n, ObjectUtils) {
        var URL_POPUP_LIST = 'components/multilist/popup.tpl.html';
        var MAX_POPUP_WIDTH = 400;
        var EMPTY_TEXT = i18n('Geral.nenhumEncontrado');
        var LOADING_TEXT = i18n('Geral.buscando');
        var SELECIONE = i18n('Geral.lblSelecione');
        var ALL_SELECTEDS = i18n('Geral.lblTodosSelecionados');
        var VIEW_SELECTEDS = i18n('Geral.lblVerSelecionados');
        var LABEL_ALL = i18n('Geral.lblAll');
        var DISABLED_CLASS = 'sk-disabled';
        var SERVICE_NAME_TO_LOAD = 'mge@UIComponentSP.getProviderMultiList';
        var DISTINCT_CLASS = 'sk-multilist-distinct';

        var self = this;

        var meuUid = StringUtils.nextUid();

        var buttonElem = angular.element($element.children()[0]);
        var textElem = angular.element(buttonElem.children()[0]);
        var countElem = angular.element(buttonElem.children()[1]);
        var popupElem;
        var searchInputElem;
        var loadingElem;
        var tabCountElem;
        var dataChanged = false;
        var popupWidth;
        var columnWidthValue;
        var totalSelecteds = 0;
        var filterFn = $filter('filter');
        var orderFn = $filter('orderBy');
        var providerDeferred = $q.defer();
        var limited = false;
        var dirtySearch = false;
        var itemByValue = {};
        var listSearch = [];
        var totalSearchSelecteds = 0;//Contador para sabermos quantos itens da lista atual de pesquisa está selecionado
        var isLoading = false;//isLoading controlado no momento das pesquisas
        var value;//Reflexo do $scope.value em alguns casos que necessitamos passar para quem usa o componente o scope.value vazio
        var lastCriteria;//Ultimo criteria utilizado na abertura do popup
        var _configListTemp;//Array temporario das configurações do usuario, apartir do momento que todos os itens da configuração na paginação já foram carregados ele deixa de existir
        var _lastFilterText;
        var _searchPromise = undefined;

        //public
        self.loadState = loadState;
        self.saveState = saveState;
        self.initialized = $q.defer();

        //scope
        $scope.selectAll = false;
        $scope.clickSelectAll = clickSelectAll;
        $scope.filterText;
        $scope.isEmpty;
        $scope.innerDataProvider = [];
        $scope.columnWidthStyle;
        $scope.fakeProcessed = false;
        $scope.onSelect = onSelect;
        $scope.onChange = onChange;
        $scope.inFocus;
        $scope.markFocus = markFocus;
        $scope.onSearchFocus = onSearchFocus;
        $scope.onChangeSearch = onChangeSearch;
        $scope.getVirtualList = getVirtualList;
        $scope.getEmptyLoadingMsg = getEmptyLoadingMsg;
        $scope.labelPesquisar = i18n('Geral.buttonPesquisar');
        $scope.selectedTab = 0;
        $scope.infiniteItems = getInfiniteItems();
        $scope.getTotalText = getTotalText;
        $scope.onSelectedTab = onSelectedTab;

        preInitialize();

        function preInitialize() {
            var item;
            var len;
            var dpCopy;

            $scope.value = $scope.value || [];
            $scope.resourceId = $scope.resourceId || SkApplication.instance().getResourceID();
            $scope.isDistinct = $scope.isDistinct || false;

            if ($scope.isDistinct && angular.isUndefined($scope.distinctFieldName)) {
                throw new Error('Para utilizar o DISTINCT, é necessário informar o campo do DISTINCT.');
            }

            //Caso o dataprovider esteja resolvido já carregamos ele, senão deixamos para ele ser carregado na hora de abrir o popup
            if (angular.isUndefined($scope.entityName)) {
                if (!angular.isArray($scope.dataProvider)) {
                    throw new Error(i18n('Geral.lblProviderTipoArray'));
                }

                dpCopy = angular.copy($scope.dataProvider);

                len = dpCopy.length;

                for (var i = 0; i < len; i++) {
                    item = dpCopy[i];

                    if ($scope.value.indexOf(item.value) > -1) {
                        item.selected = true;
                    } else {
                        item.selected = false;
                    }

                    addItem(item);
                }

                $scope.innerDataProvider = dpCopy;

                providerDeferred.resolve();
            } else {
                var allSelecteds;
                var request = {
                    entityName: $scope.entityName, 
                    resourceId: getResourceId()
                };

                if ($scope.isDistinct) {
                    request.distinctFieldName = $scope.distinctFieldName;
                }

                //Carregamos apenas as opções da última configuração do usuário
                ServiceProxy.callService('mge@UIComponentSP.getConfigMultiList', request)
                    .then(function(result){
                        var response = result.responseBody;

                        $scope.innerDataProvider = response.itens;

                        _configListTemp = $scope.innerDataProvider;

                        if (response.hasOwnProperty('allSelecteds')) {
                            allSelecteds = response.allSelecteds;
                        }
                    }, function(){
                        $scope.innerDataProvider = [];
                    })
                    .finally(function(){
                        var item;

                        if($scope.value) {
                            $scope.value.length = 0
                        } else {
                            $scope.value = [];
                        }
                        value = undefined;
                        itemByValue = {};

                        for (var i = 0; i < $scope.innerDataProvider.length; i++) {
                            item = $scope.innerDataProvider[i];

                            if (item.selected) {
                                buildSelecteds(item, false);
                            }

                            addItem(item);
                        }

                        updateTextView(angular.isDefined(allSelecteds) ? allSelecteds : isAllSelecteds());
                        self.initialized.resolve();
                    });
            }

            addEventListeners();
        }

        function onSelectedTab(newIndex) {
            if (newIndex === 1 && angular.isDefined(tabCountElem) && tabCountElem.hasClass(DISABLED_CLASS)) {
                return;
            }

            if ($scope.selectedTab !== newIndex) {
                var newText = _lastFilterText;

                _lastFilterText = $scope.filterText;
 
                $scope.selectedTab = newIndex;

                $scope.filterText = newText;
            }
        }

        function getCriteria() {
        	if (angular.isDefined($scope.enviromentCriteria)) {
	            var envCriteria = $scope.enviromentCriteria();

	            if (envCriteria) {
	                ObjectUtils.isImplementorOf(envCriteria, Criteria);

	                return envCriteria.toJSON();
	            }
        	}

            return undefined;
        }

        function loadFullProvider() {
            lastCriteria = getCriteria();

            var config = {
                ignoreLoadingBar: true
            };

            var pagination = {
                page: $scope.infiniteItems.page,
                pageSize: $scope.infiniteItems.pageSize
            };

            var request = {
                entityName: $scope.entityName, 
                resourceId: getResourceId(), 
                criteria: lastCriteria, 
                pagination: pagination
            };

            if ($scope.isDistinct) {
                request.distinctFieldName = $scope.distinctFieldName;
            }

            if ($scope.descriptionFieldName) {
                request.descriptionFieldName = $scope.descriptionFieldName;
            }
            
            if ($scope.searchFieldName) {
            	request.searchFieldName = $scope.searchFieldName;
            }

            if ($scope.ignoreFieldsCalculated) {
            	request.ignoreFieldsCalculated = $scope.ignoreFieldsCalculated;
            }

            ServiceProxy.callService(SERVICE_NAME_TO_LOAD, request, config)
                .then(function(result){
                    var response = result.responseBody;
                    var hasNextPage = false;

                    $scope.innerDataProvider = response.itens;

                    if (response.nextPage) {
                        hasNextPage = response.nextPage;
                    }

                    limited = hasNextPage;

                    $scope.infiniteItems.nextPage = hasNextPage;
                }, function(error){
                    $scope.innerDataProvider = [];
                })
                .finally(function(){
                    var item;

                    $scope.value = [];
                    value = undefined;
                    itemByValue = {};

                    for (var i = 0; i < $scope.innerDataProvider.length; i++) {
                        item = $scope.innerDataProvider[i];

                        if (item.selected) {
                            buildSelecteds(item, false);
                        }

                        addItem(item);
                    }

                    if (_configListTemp !== undefined && _configListTemp.length > 0) {
                        var configList = angular.copy(_configListTemp);
                        var configItem;

                        for (var i = 0; i < configList.length; i++) {
                            configItem = configList[i];

                            if (itemByValue[configItem.value] === undefined) {
                                $scope.innerDataProvider.push(configItem);
                                buildSelecteds(configItem, false);
                                addItem(configItem);
                            }

                            ArrayUtils.removeReference(_configListTemp, configItem);
                        }
                    }

                    updateTextView();

                    providerDeferred.resolve();
                });
        }

        function getValue() {
            return angular.isDefined(value) ? value : $scope.value;
        }

        function showLoadingMsg() {
            isLoading = true;
            $scope.isEmpty = true;
        }

        function hideLoadingMsg() {
            isLoading = false;
            $scope.isEmpty = false;
        }

        function applySearch(searchText) {
            listSearch = [];

            showLoadingMsg();

            var config = {
                ignoreLoadingBar: true
            };

            var request = {
                entityName: $scope.entityName,
                resourceId: getResourceId(),
                search: searchText,
                criteria: getCriteria()
            };

            if (angular.isDefined(_searchPromise)) {
                _searchPromise.abort();
            }

            if (dataChanged) {
                request.allSelecteds = isAllSelecteds();
            }

            if ($scope.isDistinct) {
                request.distinctFieldName = $scope.distinctFieldName;
            }

            if ($scope.descriptionFieldName) {
                request.descriptionFieldName = $scope.descriptionFieldName;
            }
            
            if ($scope.searchFieldName) {
            	request.searchFieldName = $scope.searchFieldName;
            }

            if ($scope.ignoreFieldsCalculated) {
            	request.ignoreFieldsCalculated = $scope.ignoreFieldsCalculated;
            }

            _searchPromise = ServiceProxy.callService(SERVICE_NAME_TO_LOAD, request, config);
            _searchPromise.then(function(result){
                    var itens = result.responseBody.itens;
                    var len = itens.length;

                    totalSearchSelecteds = 0;

                    hideLoadingMsg();

                    for (var i = 0; i < len; i++) {
                        item = itens[i];

                        if (angular.isDefined(getItem(item.value))) {
                            itens[i] = getItem(item.value);
                        }

                        if (itens[i].selected) {
                            totalSearchSelecteds++;
                        }
                    }

                    listSearch = itens;

                    buildSelectAll();
                }, function() {
                    hideLoadingMsg();
                });
        }

        function getEmptyLoadingMsg() {
            return isLoading ? LOADING_TEXT : EMPTY_TEXT;
        }

        function buildSelectAll() {
            var total = $scope.innerDataProvider.length;
            var valueLen = getValue().length;

            if (dirtySearch && limited && $scope.selectedTab === 0) {
                total += listSearch.length - totalSearchSelecteds
            }

            if (total === valueLen && $scope.selectAll !== true) {
                $scope.selectAll = true;
            } else if (valueLen > 0 && valueLen < total && $scope.selectAll !== undefined) {
                $scope.selectAll = undefined;
            } else if (valueLen === 0 && $scope.selectAll !== false) {
                $scope.selectAll = false;
            }
        }

        function getTotalText() {
            var valueLen = getValue().length;

            if (valueLen === 0) {
                return '';
            }

            return '[' + valueLen  + ']';
        }

        function addItem(item) {
            //if (!itemByValue.hasOwnProperty(item.value)) {
                itemByValue[item.value] = item;
            //}
        }

        function getItem(value) {
            return itemByValue[value];
        }

        function updateTextView(allSelecteds) {
            var newText = SELECIONE;
            var totalText = '';

            if (getValue().length > 0 || allSelecteds === true) {
                var dpLen = $scope.innerDataProvider.length;

                if (limited && dirtySearch && $scope.selectedTab === 0) {//Quando o selectedTab é 1 o seu length é baseado no innerDataProvider
                    dpLen += listSearch.length - totalSearchSelecteds;
                }

                if ((angular.isDefined(allSelecteds) && allSelecteds && getValue().length === dpLen) || (angular.isUndefined(allSelecteds) && getValue().length === dpLen)) {
                    value = $scope.value;
                    if(!$scope.alwaysSendValue){
                        $scope.value = [];
                    }

                    newText = ALL_SELECTEDS;
                } else {
                    if (angular.isDefined(value)) {
                        $scope.value = value;
                        value = undefined;
                    }

                    newText = getValue().toString().split(",").join(", ");

                    totalText = getTotalText();
                }
            }

            if (angular.isDefined(tabCountElem)) {
                tabCountElem.removeClass(DISABLED_CLASS);

                if (newText === ALL_SELECTEDS) {
                    tabCountElem.addClass(DISABLED_CLASS);
                    tabCountElem.text(VIEW_SELECTEDS + ' [' + LABEL_ALL + ']');
                } else {
                    tabCountElem.text(VIEW_SELECTEDS + ' ' + totalText);
                }
            }

            textElem.text(newText);
            countElem.text(totalText);
        }

        function buildTabCountDescription() {
            var newText = VIEW_SELECTEDS;

            if (angular.isDefined(textElem) && angular.isDefined(countElem)) {
                if (textElem.text() === ALL_SELECTEDS) {
                    newText += ' [' + LABEL_ALL + ']';
                } else {
                    newText += ' ' + countElem.text();
                }
            }

            tabCountElem.text(newText);
        }

        function onSearchFocus() {
            if ($scope.inFocus) {
                $scope.inFocus = undefined;
                AngularUtil.digest($scope);
            }
        }

        function onChangeSearch() {
            var filter = $scope.filterText;

            if (StringUtils.isNotEmpty(filter)) {
                dirtySearch = true;

                if (limited && $scope.selectedTab === 0) {//Efetuamos essa ação apenas na aba que mostra todos
                    applySearch(filter);
                }
            } else {
                //Dessa forma sabemos que ocorreu pesquisa no servidor e processamos o estado atual do selectAll
                if (dirtySearch && limited) {
                    buildSelectAll();
                }

                dirtySearch = false;
            }
        }

        function onSelect(event, option) {
            if (event.isDefaultPrevented()) {
                return;
            }

            option.selected = angular.isUndefined(option.selected) ? true : !option.selected;

            if (limited && dirtySearch && $scope.selectedTab === 0) {//Quando o selectedTab é 1 não trabalhamos com pesquisa no servidor
                if (option.selected) {
                    totalSearchSelecteds++;
                } else {
                    totalSearchSelecteds--;
                }
            }

            copyOriginal(option);
            buildSelecteds(option);
            updateTextView();

            ($scope.skChange || angular.noop)();
        }

        function onChange(option) {
            if (limited && dirtySearch && $scope.selectedTab === 0) {//Quando o selectedTab é 1 não trabalhamos com pesquisa no servidor
                if (option.selected) {
                    totalSearchSelecteds++;
                } else {
                    totalSearchSelecteds--;
                }
            }

            copyOriginal(option);
            buildSelecteds(option);
            updateTextView();

            ($scope.skChange || angular.noop)();
        }

        function copyOriginal(option) {
            if (limited && dirtySearch && option.selected && angular.isUndefined(getItem(option.value))) {
                $scope.innerDataProvider.push(option);

                addItem(option);
            }
        }

        function getVirtualList() {
            var list;

            if (limited && dirtySearch && $scope.selectedTab === 0) {//Quando o selectedTab é 1 não trabalhamos com pesquisa no servidor
                list = listSearch;
            } else {
                if ($scope.selectedTab === 1) {
                    list = getSelectedsList();
                } else {
                    list = $scope.innerDataProvider;
                }

                if (StringUtils.isNotEmpty($scope.filterText)) {
                    list = filterFn(list, $scope.filterText);
                }
            }

            $scope.isEmpty = (list.length == 0);

            return list;
        }

        function getSelectedsList() {
            var list = [];
            var len = getValue().length;
            var item;

            if (isAllSelecteds()) {
                return $scope.innerDataProvider;
            } else if (angular.isArray(getValue())) {
                for (var i =0; i < len; i++) {
                    item = itemByValue[getValue()[i]];

                    if (item && item.selected) {
                        list.push(item);
                    }
                }
            }

            return list;
        }

        function calcFakeWidth() {
            var fakeElem;
            var fakeData = getFakeData();
            var template = getFakeTemplate();
            var listElem;

            template = template.replace('${VALUE}', fakeData.value);
            template = template.replace('${DESCRIPTION}', fakeData.description);

            if ($scope.isDistinct) {
                template = template.replace('${DISTINCT}', 'ng-hide');
            }

            popupElem.addClass('sk-opened');

            listElem = angular.element(popupElem[0].querySelector('.sk-list'));
            fakeElem = angular.element(template.trim());
            listElem.append(fakeElem)

            popupWidth = fakeElem[0].offsetWidth + DomUtil.getScrollBarWidth();
            columnWidthValue = fakeElem[0].querySelector('.table-cell-value').offsetWidth;

            fakeElem.remove();
            popupElem.removeClass('sk-opened');
        }

        function getFakeData() {
            var maxLengthValue = 0;
            var maxLengthLabel = 0;
            var lengthValue;
            var lengthLabel;
            var item;
            var  i;
            var providerLength = $scope.innerDataProvider;
            var itemValue;
            var description;

            for (i = 0; i < providerLength.length; i++) {
                item = $scope.innerDataProvider[i];

                if (item && item.value) {
                    lengthValue = item.value.toString().length;

                    if (lengthValue > maxLengthValue) {
                        maxLengthValue = lengthValue;
                        itemValue = item.value;
                    }
                }

                if (item && item.description) {
                    lengthLabel = item.description.toString().length;

                    if (lengthLabel > maxLengthLabel) {
                        maxLengthLabel = lengthLabel;
                        description = item.description;
                    }
                }
            }

            return {'value': itemValue, 'description': description};
        }

        function markFocus(option) {
            $scope.inFocus = option;
        }

        function clickSelectAll() {
            var len;
            var i = 0;
            var item;
            var selecteds;//itens que estão selecionados para atualizar o skValue

            if (limited && dirtySearch && $scope.selectedTab === 0) {
                selectAllDirtySearch();
            } else {
                $timeout(function () {
                    len = $scope.innerDataProvider.length;
                    selecteds = [];

                    for (; i < len; i++) {
                        item = $scope.innerDataProvider[i];

                        if ($scope.selectAll && !item.selected) {
                            item.selected = true;
                        } else if (!$scope.selectAll && item.selected) {
                            item.selected = false;
                        }

                        if ($scope.selectAll) {
                            selecteds.push(item.value);
                        }
                    }

                    totalSelecteds = $scope.selectAll ? len : 0;

                    $scope.value = selecteds;
                    
                    if($scope.alwaysSendValue === true){
                        value = selecteds.length == 0 ? undefined : selecteds;
                    }else{
                        value = undefined;
                    }

                    updateTextView($scope.alwaysSendValue === true ? $scope.selectAll : undefined);

                    dataChanged = true;

                    ($scope.skChange || angular.noop)();
                }, 0);
            }
        }

        function selectAllDirtySearch() {
            var len = listSearch.length;
            var i = 0;
            var item;
            var selecteds = [];

            $timeout(function () {
                for (; i < len; i++) {
                    item = listSearch[i];

                    if ($scope.selectAll && !item.selected) {
                        item.selected = true;

                        copyOriginal(item);

                        if (getValue().indexOf(item.value) === -1) {
                            selecteds.push(item.value);
                        }

                        totalSearchSelecteds++;
                    } else if (!$scope.selectAll && item.selected) {
                        item.selected = false;

                        ArrayUtils.removeReference(getValue(), item.value);

                        totalSearchSelecteds--;
                    }
                }

                $scope.value = selecteds.concat($scope.value)
                value = undefined;

                totalSelecteds = $scope.value.length;

                updateTextView();

                dataChanged = true;

                ($scope.skChange || angular.noop)();
            }, 0);
        }

        function buildSelecteds(currentOption, dpChanged) {
            var dpLen = $scope.innerDataProvider.length;

            if ($scope.inFocus) {
                $scope.inFocus = undefined;
            }

            if (currentOption.selected && getValue().indexOf(currentOption.value) === -1) {
                getValue().push(currentOption.value);
                totalSelecteds++;
            } else if (!currentOption.selected && getValue().indexOf(currentOption.value) > -1) {
                ArrayUtils.removeReference(getValue(), currentOption.value);
                totalSelecteds--;
            }

            totalSelecteds = (totalSelecteds < 0) ? 0 : totalSelecteds;
            totalSelecteds = (totalSelecteds > dpLen) ? dpLen : totalSelecteds;

            buildSelectAll();

            dataChanged = angular.isDefined(dpChanged) ? dpChanged : true;
        }

        function buildColumnWidth() {
            $scope.columnWidthStyle = {'min-width': StringUtils.toPX(columnWidthValue)};
        }

        function addEventListeners() {
            buttonElem.on(SkConstants.MOUSE.CLICK, clickHandler);
        }

        function showLoadingBtn() {
            buttonElem.addClass('is-loading');
        }

        function hideLoadingBtn() {
            buttonElem.removeClass('is-loading');
        }

        function clickHandler() {
            if (DropdownUtil.isOpen(popupElem)) {
                hidePopup();
            } else {
                if (!popupElem) {
                    if (angular.isDefined($scope.entityName)) {
                        showLoadingBtn();
                        loadFullProvider();
                    }

                    getProvider().then(function(){
                        createPopup();
                        hideLoadingBtn();
                    });
                } else if (angular.isDefined($scope.entityName) && !angular.equals(lastCriteria, getCriteria())) {
                    providerDeferred = $q.defer();

                    showLoadingBtn();

                    loadFullProvider();

                    getProvider().then(function(){
                        showPopup();
                        hideLoadingBtn();
                    });
                } else {
                    showPopup();
                }
            }
        }

        function createPopup() {
            DropdownUtil.create($scope, URL_POPUP_LIST)
                .then(function(popup){
                    popupElem = popup;

                    popupElem.addClass('sk-dropdown-multilist');

                    if ($scope.isDistinct) {
                        popupElem.addClass(DISTINCT_CLASS);
                    }

                    searchInputElem = popupElem[0].querySelector('.search-input input');
                    loadingElem = angular.element(popupElem[0].querySelector('span.loading-panel'));
                    tabCountElem =  angular.element(popupElem[0].querySelector('.tab > .tab-count'));

                    calcFakeWidth();
                    buildColumnWidth();
                    buildTabCountDescription();
                    showPopup();
                });
        }

        function showPopup() {
            var config = {
                width: popupWidth,
                maxWidth: MAX_POPUP_WIDTH
            };

            resetTabView();

            DropdownUtil.open(popupElem, $element, config);

            if (searchInputElem) {
                $timeout(function(){
                    searchInputElem.focus();
                }, 0, false);
            }
        }

        function resetTabView() {
            $timeout(function() {
                _lastFilterText = undefined;
                $scope.filterText = undefined;
                $scope.selectedTab = 0;
            }, 0);
        }

        function hidePopup() {
            DropdownUtil.close(popupElem);
        }

        function getProvider() {
            return providerDeferred.promise;
        }

        function loadState(callback) {
            getProvider().then(function() {
                var config = {
                    chave: getResourceId(),
                    tipo: 'T'
                };

                ServiceProxy.callService('mge@SystemUtilsSP.getConf',{config: config})
                    .then(function(result){
                        var config = result.responseBody.config;
                        var configItem;
                        var item;
                        var newScopeValues;
                        var i;
                        var z;

                        if (config && config.item && angular.isArray(config.item)) {
                            newScopeValues = [];

                            for (i = 0; i < config.item.length; i++) {
                                configItem = config.item[i];

                                for (z = 0; z < $scope.innerDataProvider.length; z++) {
                                    item = $scope.innerDataProvider[z];

                                    if (configItem.value == item.value) {
                                        item.selected = true;

                                        newScopeValues.push(item.value);

                                        buildSelecteds(item, false);
                                    }
                                }
                            }

                            $scope.value = newScopeValues;
                            value = undefined;

                            AngularUtil.apply($scope);

                            updateTextView();
                        }

                        (callback || angular.noop)();
                    });
            });
        }

        function saveState(callback) {
            if (dataChanged) {
                var itemValue;
                var config = {
                    chave: getResourceId(),
                    tipo: 'T',
                    item: [],
                    allSelecteds: isAllSelecteds()
                };

                if(!config.allSelecteds) {
                    for (var i = 0; i < getValue().length; i++) {
                        itemValue = getValue()[i];

                        //Consideramos que o $scope.value é um array de números ou string [0,1,2] ou ["","",""]
                        //Caso o $scope.value seja modificado para ser um array de objetos, basta dar o push do objeto direto
                        config.item.push({value: itemValue});
                    }
                }

                ServiceProxy.callService('mge@SystemUtilsSP.saveConf',{config: config}, {ignoreLoadingBar: true})
                    .then(function(result){
                        dataChanged = false;

                        (callback || angular.noop)();
                    });
            }
        }

        function getResourceId() {
            var resourceId = $scope.resourceId + '.multilist.';

            if ($scope.isDistinct) {
                resourceId += 'distinct.'
            }

            resourceId += $scope.entityName;

            return resourceId;
        }

        function getInfiniteItems() {
            return {
                page: 0,
                pageSize: 1000,
                nextPage: false,

                getItems: function() {
                    return $scope.getVirtualList();
                },

                getItemAtIndex: function (index) {
                    if (index > (this.items.length - 1) && this.nextPage) {
                        this.fetchMoreItems(index);
                        return null;
                    }

                    return this.items[index];
                },

                getLength: function () {
                    if (!dirtySearch && this.nextPage && $scope.selectedTab === 0) {//Só existe paginação na primeira aba
                        return this.items.length + 5;
                    }

                    return this.items.length;
                },

                fetchMoreItems: function (index) {
                    var loaded = (this.pageSize * (this.page + 1));//Acrescentamos 1 na página, pois no JAPE a páginação começa em 0

                    if (loaded < index) {
                        this.page += 1;

                        var pagination = {
                            page: this.page,
                            pageSize: this.pageSize
                        };

                        var request = {
                            entityName: $scope.entityName,
                            resourceId: getResourceId(),
                            criteria: getCriteria(),
                            pagination: pagination
                        };

                        if (dataChanged) {
                            request.allSelecteds = isAllSelecteds();
                        }

                        if ($scope.isDistinct) {
                            request.distinctFieldName = $scope.distinctFieldName;
                        }

                        if ($scope.descriptionFieldName) {
                            request.descriptionFieldName = $scope.descriptionFieldName;
                        }
                        
                        if ($scope.searchFieldName) {
                        	request.searchFieldName = $scope.searchFieldName;
                        }

                        if ($scope.ignoreFieldsCalculated) {
                            request.ignoreFieldsCalculated = $scope.ignoreFieldsCalculated;
                        }

                        $scope.inFocus = {};

                        showLoadingMoreRows();

                        ServiceProxy
                            .callService(SERVICE_NAME_TO_LOAD, request, config)
                            .then(function(result){
                                var response = result.responseBody;
                                var itens = response.itens;
                                var len = itens.length;
                                var item;
                                var hasNextPage = false;

                                if (response.nextPage) {
                                    hasNextPage = response.nextPage;
                                }

                                limited = hasNextPage;

                                $scope.infiniteItems.nextPage = hasNextPage;

                                for (var i = 0; i < len; i++) {
                                    item = itens[i];

                                    if (angular.isUndefined(itemByValue[item.value])) {
                                        addItem(item);
                                        $scope.innerDataProvider.push(item);
                                        buildSelecteds(item);
                                    }
                                }
                            })
                            .finally(function(){
                                hideLoadingMoreRows();
                            });
                    }
                }
            };
        }

        function isAllSelecteds() {
            if ($scope.innerDataProvider.length === 0) {
                return false;
            }

            return getValue().length === $scope.innerDataProvider.length;
        }

        function showLoadingMoreRows() {
            if (angular.isDefined(loadingElem)) {
                loadingElem.addClass('in-progress');
            }
        }

        function hideLoadingMoreRows() {
            if (angular.isDefined(loadingElem)) {
                loadingElem.removeClass('in-progress');
            }
        }

        function getFakeTemplate() {
            return '\
            <div class="fake-table">\
                <div class="table-row" layout="row" layout-align="start center" flex>\
                    <div class="table-cell"><fake-checkbox></fake-checkbox></div>\
                    <div class="table-cell cell-center table-cell-value ${DISTINCT}">${VALUE}</div>\
                    <div class="table-cell cell-text">${DESCRIPTION}</div>\
                </div>\
            </div>';
        }
    }]);
angular
    .module('snk.components.multilist')
    .directive('skMultilist', [function () {
        return {
            scope: {
                dataProvider: '=?skProvider',
                value: '=?skValue',
                entityName: '@?skEntityName',
                resourceId: '@?skResourceId',
                enviromentCriteria: '&?skEnviromentCriteria',
                skChange: '&?skChange',
                isDistinct: '=?skDistinct',
                distinctFieldName: '@?skDistinctFieldName',
                descriptionFieldName: '@?skDescriptionFieldName',
                searchFieldName: '@?skSearchFieldName',
                enabled: '=?skEnabled',
                alwaysSendValue: '=?skAlwaysSendValue',
                ignoreFieldsCalculated: '=?skIgnoreFieldsCalculated'
            },
            restrict: 'E',
            templateUrl: 'components/multilist/multilist.tpl.html',
            controller: 'SkMultilistController',
            controllerAs: 'ctrl'
        };
    }]);
angular
    .module('snk.components.navigator')
    .directive("skFocusOnShow",['$timeout', function ($timeout) {
        return {
            restrict : 'A',
            link : function($scope,$element,$attr) {
                $scope.$watch($attr.skFocusOnShow,function(_focusVal) {
                    $timeout(function() {
                        var inputToFocus = $element.find('input');

                        _focusVal ? inputToFocus.focus() : inputToFocus.blur();
                    });
                });
            }
        }
    }]);
angular
    .module('snk.components.navigator')
    .controller('SkNavigatorController', ['$scope', '$attrs', 'ObjectUtils', 'SkI18nService', 'MGEParameters', 'StringUtils', 'SkComponentRegistry', 'UserAgentUtils', 'AngularUtil', 'DatasetEvents', 'SkApplication', 'ServiceProxy', '$q', 'SanPopup', 'i18n', "KeyboardManager", "$timeout", function ($scope, $attrs, ObjectUtils, SkI18nService, MGEParameters, StringUtils, SkComponentRegistry, UserAgentUtils, AngularUtil, DatasetEvents, SkApplication, ServiceProxy, $q, SanPopup, i18n, KeyboardManager, $timeout) {
        var self = this;

        var _showEditionAlert = MGEParameters.asBoolean('global.notifica.alteracao.dataset');
        var _showedEditionAlertForThisRecord = false;
        var _dataGridMode = false;
        var _gridInstance;

        var _deepCopyMetadata = [];        
        var _keepDeepCopyAnswer = false;
        var _deepCopyMDLoaded = false;

        ObjectUtils.implements(self, IDataSetObserver);

        $scope.tooltipPrimeiro = SkI18nService.instant('Navigator.lblPrimeiro');
        $scope.tooltipAnterior = SkI18nService.instant('Navigator.lblAnterior');
        $scope.tooltipProximo = SkI18nService.instant('Navigator.lblProximo');
        $scope.tooltipUltimo = SkI18nService.instant('Navigator.lblUltimo');
        $scope.tooltipSalvar = SkI18nService.instant('Navigator.lblSalvar');
        $scope.tooltipDescartar = SkI18nService.instant('Navigator.lblDescartar');
        $scope.lblDescartar = SkI18nService.instant('Geral.lblDescartar');
        $scope.tooltipAtualizar = SkI18nService.instant('Navigator.lblAtualizar');
        $scope.tooltipDuplicar = SkI18nService.instant('Navigator.lblDuplicar');
        $scope.tooltipExcluir = SkI18nService.instant('Navigator.lblExcluir' + (UserAgentUtils.isMac() ? 'MAC' : ''));
        $scope.tooltipEditar = SkI18nService.instant('Navigator.lblEditar');

        $scope.componentId = StringUtils.nextUid();
        $scope.editionAlertPopOverId = 'edition-alert-popover-' + $scope.componentId;

        $scope.first = first;
        $scope.previous = previous;
        $scope.next = next;
        $scope.last = last;

        $scope.newRecord = newRecord;
        $scope.editRecord = editRecord;
        $scope.remove = remove;

        $scope.save = save;
        $scope.refresh = refresh;
        $scope.onClickCancel = onClickCancel;
        $scope.refresh = refresh;
        $scope.clone = clone;
        $scope.edit = edit;

        $scope.clean = true;

        $scope.showAlertIcon = false;

        $scope.btnFirstEnabled = false;
        $scope.btnPrevEnabled = false;
        $scope.btnNextEnabled = false;
        $scope.btnLastEnabled = false;
        $scope.btnAddEnabled = false;
        $scope.btnRemoveEnabled = false;
        $scope.btnEditarEnabled = false;
        $scope.btnSaveEnabled = false;
        $scope.btnCancelEnabled = false;
        $scope.btnRefreshEnabled = true;
        $scope.btnEditEnabled = false;
        $scope.btnCloneEnabled = false;
        $scope.fieldSearchOpen = false;

        $scope.isShowNavigator = isShowNavigator;
        $scope.isShowAddButton = isShowAddButton;
        $scope.isShowFirstButton = isShowFirstButton;
        $scope.isShowNextButton = isShowNextButton;
        $scope.isShowLastButton = isShowLastButton;
        $scope.isShowPreviousButton = isShowPreviousButton;
        $scope.isShowSaveButton = isShowSaveButton;
        $scope.isShowCancelButton = isShowCancelButton;
        $scope.openSearch = openSearch;
        $scope.pesqFieldSelect = pesqFieldSelect;

        $scope.isView = isView;

        $scope.getEntityDescription = getEntityDescription;

        self.getDataset = getDataset;
        self.setDataGridMode = setDataGridMode;

        $scope.showDeepCopyMenu = false;
        $scope.showDeepCopyPopUp = showDeepCopyPopUp;
        self.setSaveHandler = setSaveHandler;
        $scope.api = self;
        self.setAddHandler = setAddHandler;
        self.setEditHandler = setEditHandler;
        $scope.loadFieldSuggestions = loadFieldSuggestions;

        KeyboardManager.bind('Ctrl+F', openSearch);

        $scope.$watch('fieldSearchOpen',function(newVal, oldVal) {
            $timeout(function() {
                if(newVal === false){
                    var unselectField = document.querySelectorAll('.highlighted-field');

                    if(NodeList.prototype.isPrototypeOf(unselectField) && unselectField.length > 0){
                        unselectField[0].classList.remove('highlighted-field');
                    }
                }

            });
        });

        $scope.$watch('dataset', function (newDs) {
            if ($scope.dataset != newDs || !_deepCopyMDLoaded) {
                resetDataset(newDs);
                if ($scope.dataset && !$scope.dataset.isStandAlone()) {
                    loadDeepCopyMD();
                }

                if($scope.dataset){
                    $scope.dataset.setEnableDeleteFromNavigator(!($scope.showCrud === false || $scope.showRemoveButton === false));
                }
            } else {
                resetDataset(newDs);
            }
        });

        function resetDataset(newDs) {
            if ($scope.dataset) {
                $scope.dataset.removeObserver(self);
            }

            $scope.dataset = newDs;

            if ($scope.dataset) {
                $scope.dataset.addObserver(self);
                enableDisableNavControls();
            }
        }

        function getEntityDescription() {
            return $scope.dataset && $scope.dataset.getEntityDescription();
        }

        function isShowNavigator() {
            return $scope.showNavigation !== false;
        }

        function isShowAddButton() {
            if (isView() || $scope.editUniqueRecord){
                return false;
            } else if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return insertionMode || !dirty;
            } else {
                return (angular.isDefined($scope.showAddButton) ? $scope.showAddButton == true : true) && $scope.btnAddEnabled;
            }
        }

        function isShowSaveButton() {
            if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return !insertionMode && dirty;
            }

            return ($scope.btnSaveVisible || $scope.editUniqueRecord) && !($scope.showSaveButton === false);
        }
        
        function isShowCancelButton() {
            if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return !insertionMode && dirty;
            }
            
            return ((!isView() && $scope.btnCancelEnabled) || $scope.editUniqueRecord) && !($scope.showCancelButton === false);
        }

        function isShowFirstButton() {
            if (isShowNavigator()) {
                var show = angular.isDefined($scope.showFirstButton) ? $scope.$eval($scope.showFirstButton) : true;
                return show && $scope.clean && !$scope.editUniqueRecord;
            } else if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return !insertionMode && !dirty;
            } else {
                return false;
            }
        }

        function isShowNextButton() {
            if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return !insertionMode && !dirty;
            }

            return $scope.alwaysNavigation || (isShowNavigator() && $scope.clean && $scope.editUniqueRecord !== true);
        }

        function isShowPreviousButton() {
            if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return !insertionMode && !dirty;
            }

            return $scope.alwaysNavigation || (isShowNavigator() && $scope.clean && !$scope.editUniqueRecord);
        }

        function isShowLastButton() {
            if (isShowNavigator()) {
                var show = angular.isDefined($scope.showLastButton) ? $scope.$eval($scope.showLastButton) : true;
                return show && $scope.clean && !$scope.editUniqueRecord;
            } else if ($scope.externalInsertionMode) {
                var insertionMode = $scope.dataset.isInsertionMode();
                var dirty = $scope.dataset.isRecordDirty();
                return !insertionMode && !dirty;
            } else {
                return false;
            }
        }

        function isView() {
            if (!$scope.dataset) {
                return false;
            }

            return $scope.dataset.isView();
        }

        function first() {
            $scope.dataset.first();
        }

        function previous() {
            if(_dataGridMode){
                _gridInstance.previousRow();
            }else{ 
                if($scope.dataset.isRecordDirty() && $scope.alwaysNavigation){
                    $scope.dataset.save().then(function(){
                        $scope.dataset.previous();
                    });
                }else{
                    $scope.dataset.previous();
                } 
            }
        }

        function next() {
            if(_dataGridMode){
                _gridInstance.nextRow();
            }else{
                if($scope.dataset.isRecordDirty() && $scope.alwaysNavigation){
                    $scope.dataset.save().then(function(){
                        $scope.dataset.next();
                    });
                }else{
                    $scope.dataset.next();
                } 
            }
        }

        function last() {
            $scope.dataset.last();
        }

        function newRecord() {
            if(angular.isFunction($scope.api.addFunction)){
                $scope.addFunction = $scope.api.addFunction;
            }

            if(angular.isFunction($scope.addFunction)) {
                $scope.addFunction($scope);
            } else {
                $scope.dataset.goToInsertionMode();
            }
        }

        function editRecord() {
            if(angular.isFunction($scope.api.editFunction)){
                $scope.editFunction = $scope.api.editFunction;
            }

            if(angular.isFunction($scope.editFunction)) {
                $scope.editFunction($scope);
            } else {
                $scope.dataset.goToInsertionMode();
            }
        }

        function remove() {
            if(angular.isFunction($scope.removeHandler)) {
                $scope.removeHandler({dataset: $scope.dataset});
            } else {
                var hideQuestionRemove = angular.isDefined($attrs.skHideQuestionRemove) ? true : false;
                $scope.dataset.removeCurrentRow(hideQuestionRemove);
            }
        }

        function save() {
        	if(!($scope.saveHandler)){
                if($scope.api.saveHandler){
                    $scope.saveHandler = $scope.api.saveHandler;
                }
            }
        	
            if(angular.isFunction($scope.saveHandler)) {
                $scope.saveHandler({dataset: $scope.dataset});
            } else {
                $scope.dataset.save($scope.refreshAllRecords, undefined, {preventSort : true, preventFilter: true});
            }
        }

        function onClickCancel() {
            $scope.dataset.cancelEdition();
        }

        function refresh() {
        	$scope.dataset.refresh();
        }

        function clone() {
            var deepCopyPromisse = angular.noop;

            if(_deepCopyMetadata != null && _deepCopyMetadata.length > 0 && (!_keepDeepCopyAnswer || hasUnansweredDeepCopy())){
                deepCopyPromisse = showDeepCopyPopUp();
            }

            $q.when(deepCopyPromisse).then(function(justConfig){
                if(justConfig != true){
                    if(StringUtils.toBoolean($scope.ignoreConditionalSaveCopy)){
                        var isConditional = $scope.dataset.isConditionalAutoSave(); 
                        if(isConditional){
                                $scope.dataset.setConditionalAutoSave(false);
                                $scope.dataset.copyCurrentRow().then(function(){
                                     $scope.dataset.setConditionalAutoSave(true);
                                });
                        }else{
                            $scope.dataset.copyCurrentRow();
                        }                       
                    }else{
                        $scope.dataset.copyCurrentRow();
                    } 
                }
            });            
        }

        function edit() {
            $scope.dataset.beginEdition();
        }

        function enableDisableNavControls() {
            if (!$scope.dataset) {
                return;
            }

            var insertionMode = $scope.dataset.isInsertionMode();
            var dirty = $scope.dataset.isRecordDirty();
            var multiEdit = $scope.dataset.isMultiRecordEditMode();
            var recordSelections = $scope.dataset.getSelectedRecords();
            var currentIndex = $scope.dataset.getCurrentIndex();
            var size = $scope.dataset.size();

            var clean = !(dirty || insertionMode || multiEdit);

            $scope.clean = clean;

            if (_showEditionAlert && !_showedEditionAlertForThisRecord) {
                SkComponentRegistry.get($scope.editionAlertPopOverId)
                    .then(function (instance) {
                        if (!insertionMode && (dirty || multiEdit)) {
                            instance.show();
                            $scope.showAlertIcon = true;
                            _showedEditionAlertForThisRecord = true;
                        } else {
                            instance.hide();
                            $scope.showAlertIcon = false;
                        }
                    });
            }


            $scope.btnFirstEnabled = _dataGridMode ? _gridInstance.hasPrevious() : clean && $scope.dataset.hasPrevious();
            $scope.btnPrevEnabled = _dataGridMode ? _gridInstance.hasPrevious() : ($scope.alwaysNavigation || clean ) && $scope.dataset.hasPrevious();
            $scope.btnNextEnabled = _dataGridMode ? _gridInstance.hasNext() : ($scope.alwaysNavigation || clean ) && $scope.dataset.hasNext();
            $scope.btnLastEnabled = _dataGridMode ? _gridInstance.hasNext() : clean && $scope.dataset.hasNext();

            $scope.btnAddEnabled = clean;
            $scope.btnCloneEnabled = clean && size > 0 && (currentIndex > -1 || (angular.isDefined(recordSelections) && recordSelections.length > 0));
            $scope.btnRefreshEnabled = clean;

            $scope.btnEditEnabled = clean && angular.isDefined(recordSelections) && recordSelections.length > 1 && (angular.isDefined($scope.showEditButton) ? $scope.showEditButton : true);

            $scope.btnRemoveEnabled = clean && size > 0 && (currentIndex > -1 || (angular.isDefined(recordSelections) && recordSelections.length > 0));
            $scope.btnEditarEnabled = clean && size > 0 && (currentIndex > -1 || (angular.isDefined(recordSelections) && recordSelections.length > 0));
            $scope.btnSaveVisible = !clean;
            $scope.btnSaveEnabled = !clean;
            $scope.btnCancelEnabled = !clean;
            //Isso foi necessário devido a integração com aggrid, pois a grade não dispara cliclos digest, 
            //e o navigator ficava desatualizado, então precisamos disparar manualmente.
            AngularUtil.digest($scope);
        }

        self.dataSaved = function () {
            enableDisableNavControls();
        };

        self.insertionModeActivated = function () {
            if($scope.dataset && $scope.dataset.isCopyingRecord()){
                var entitiesToCopy = "";
                
                _deepCopyMetadata.forEach(function(md){
                    if(md.includeInCopy == "S"){
                        if(entitiesToCopy.length > 0){
                            entitiesToCopy = entitiesToCopy + ",";
                        }
                        entitiesToCopy = entitiesToCopy + md.name;
                    }
                });

                $scope.dataset.addTXProperty("include.in.deep.copy", entitiesToCopy);
            }
            
            enableDisableNavControls();
        };

        self.currentLineChanged = function () {
            _showedEditionAlertForThisRecord = false;
            enableDisableNavControls();
        };

        self.refreshed = function () {
            enableDisableNavControls();
        };

        self.closed = function () {
            $scope.btnFirstEnabled = false;
            $scope.btnPrevEnabled = false;
            $scope.btnNextEnabled = false;
            $scope.btnLastEnabled = false;
            $scope.btnRemoveEnabled = false;
            $scope.btnEditarEnabled = false;
            $scope.btnRefreshEnabled = false;

            $scope.btnSaveEnabled = $scope.dataset.isRecordDirty();
            $scope.btnCancelEnabled = $scope.dataset.isRecordDirty();
            $scope.btnAddEnabled = !$scope.dataset.isInsertionMode();
            $scope.btnEditEnabled = !($scope.dataset.isRecordDirty() || $scope.dataset.isInsertionMode());
        };

        self.dataModified = function () {
            enableDisableNavControls();
        };

        self.editionCanceled = function () {
            enableDisableNavControls();
        };

        self.selectionChanged = function () {
            enableDisableNavControls();
        };

        self.editionModeActivated = function () {
            enableDisableNavControls();
        };

        self.uploadingFile = function (uploading) {
            $scope.btnSaveEnabled = !uploading;
        }

        function getDataset(){
            return $scope.dataset;
        }

        function setDataGridMode(value, gridIstance){
            if(value && !gridIstance){
                throw('Para usar datagridmode é obrigatório a instancia do grid.');
            }                                 
            if(!value){
                _gridInstance = undefined;
            }else{
                _gridInstance = gridIstance; 
            }
            _dataGridMode = value;
        }

        function loadDeepCopyMD(){
            //Metadados de copia p/ entidades filhas (ONE_TO_MANY)
            var request = {param: {}};
            request.param.entityName = $scope.dataset.getEntityName();
            request.param.resourceID = getDeepCopyConfigResourceID();
            
            $scope.showDeepCopyMenu = false;

            ServiceProxy.callService(
                "mge@SystemUtilsSP.getDeepCopyMetadata",
                request,
            ).then(function(result){                    
                _deepCopyMetadata = [];
                var resp = result.responseBody;
                
                if(resp.metadata && resp.metadata.entity){

                    if(angular.isArray(resp.metadata.entity)){

                        resp.metadata.entity.forEach(function(entity){
                            var md = {
                                name: entity.name,
                                includeInCopy: entity.includeInCopy,
                                description: entity.description,
                                answered: entity.answered
                            }
                            _deepCopyMetadata.push(md);                  
                        })

                    }else{
                        var entity = resp.metadata.entity;
                        _deepCopyMetadata.push({
                            name: entity.name,
                            includeInCopy: entity.includeInCopy,
                            description: entity.description,
                            answered: entity.answered
                        });
                    }
                    $scope.showDeepCopyMenu = true;
                }
                _keepDeepCopyAnswer = ObjectUtils.getProperty(resp, 'metadata.keepChoice') == "S";
                _deepCopyMDLoaded = true;
            });
        }

        function getDeepCopyConfigResourceID(){
            return SkApplication.instance().getResourceID() + ".configDeepCopy." + $scope.dataset.getEntityName();
        }

        function hasUnansweredDeepCopy(){
            if(_deepCopyMetadata != null){
                _deepCopyMetadata.forEach(function(md){
                    if(md.answered == "N"){
                        return true;
                    }
                });
            }
            return false;
        }

        function showDeepCopyPopUp(justConfig){
            var defer = $q.defer();

            var options =  {metadata: _deepCopyMetadata, keepChoice: _keepDeepCopyAnswer};

            SanPopup.open({
            title: i18n('DeepCopy.lblCopiarTambem'),
            templateUrl: 'components/dataset/deepcopy/deepcopypopup.tpl.html',
            controller: 'DeepCopyPopUpController',
            controllerAs: 'ctrl',
            okBtnLabel: i18n('Geral.lblSalvar'),
            cancelBtnLabel: i18n('Geral.lblFechar'),
            showBtnNo: false,
            showBtnCancel: true,
            size: 'sm',
            grayBG: true,
            resolve: {
                options: options
            }
            }).result.then(function(data){
                _keepDeepCopyAnswer = data.keepChoice;
                _deepCopyMetadata = data.metadata;
                SkApplication.instance().saveMgeConfig(getDeepCopyConfigResourceID(), getConfigDeepCopy());
                defer.resolve(justConfig);
            });

            return defer.promise;;
        }

        function getConfigDeepCopy(){
            var request = { };
            request.keepChoice = _keepDeepCopyAnswer ? "S" : "N";

            var hasArray = _deepCopyMetadata.length > 1;

            if(hasArray){
                request.ref = [];
            }

            _deepCopyMetadata.forEach(function(md){
                var ref = {entityName: md.name, includeInCopy: md.includeInCopy};
                if(hasArray){
                    request.ref.push(ref);
                }else{
                    request.ref = ref;
                }
            });

            return request;
        }
        
        function setSaveHandler(fn){
            $scope.api.saveHandler = fn;
        }
        
        function setAddHandler(fn){
            $scope.api.addFunction = fn;
        }

        function setEditHandler(fn){
            $scope.api.editFunction = fn;
        }

        function openSearch(){
            if(!$scope.isInsideDynaform && $scope.enableSearchFields){
                $scope.fieldSearchOpen = !$scope.fieldSearchOpen;
                $scope.$parent.$apply();
            }
		}

        function loadFieldSuggestions(value) {

			if (StringUtils.isEmpty(value)) {
				return [];
			}

			var deferred = $q.defer();

			var matches = [];
            
            if($scope.searchFieldsUseDataset){
                matches = getDatasetFieldsMatching(value)
            } else {
                matches = getFormItemsMatching(value);
            }

			deferred.resolve(matches);

			return deferred.promise;
		}

        function pesqFieldSelect(item, highlightKind) {
            var unselectField = document.querySelectorAll('.highlighted-field');
            var selectedField = " ";

            if(NodeList.prototype.isPrototypeOf(unselectField) && unselectField.length > 0){
                unselectField[0].classList.remove('highlighted-field');
            }

            if(typeof item.fieldName === "string" && item.fieldName.includes(".")){

                var entityName = item.fieldName.split(".")[0];
                var fieldName = item.fieldName.split(".")[1];

                var selectedField = document.querySelectorAll('[sk-field-name=' + fieldName +'][sk-entity-name=' + entityName + ']');
            } else if (typeof item.fieldName === "string" && !item.fieldName.includes(".")){

                var fieldName = item.fieldName;

                var selectedField = document.querySelectorAll('[sk-field-name=' + fieldName +']');
            }


            if(NodeList.prototype.isPrototypeOf(selectedField) && selectedField.length > 0){
                
                var fieldTabIndex = selectedField[0].closest('sk-tab-item');

                if(angular.isDefined($scope.tabsSelectedIndex) && (fieldTabIndex !== null)){

                    fieldTabIndex = fieldTabIndex.getAttribute('sk-tabitem-id') !== null ? fieldTabIndex.getAttribute('sk-tabitem-id') : '0';
                    $scope.tabsSelectedIndex = parseInt(fieldTabIndex);
                    
                    $timeout(function() {
                        highlightField(selectedField[0]);
                    }, 50);

                } else {
                    highlightField(selectedField[0]);
                }

            }
        }

        function highlightField(element){
            element.closest('div.form-group').classList.add('highlighted-field');
            element.querySelector('input').focus();
            element.querySelector('input').scrollIntoView({behavior: "smooth"});
        }

        function getFormItemsMatching(value){
            var matches = [];

			var simpleItemsOnScreen = document.querySelectorAll("sk-simple-item");

			simpleItemsOnScreen.forEach(function (item, index) {
                var itemLabel = item.getAttribute("sk-label") != null ? i18n(item.getAttribute("sk-label")) : null;
                var itemInput = item.querySelector("[sk-field-name]");

                if(StringUtils.replaceAccentuatedChars(itemLabel).toLowerCase().indexOf(StringUtils.replaceAccentuatedChars(value).toLowerCase()) > -1){
                    var fieldName = itemInput.getAttribute("sk-field-name");

                    matches.push({
                        key: itemLabel,
						label: itemLabel,

                        fieldName: fieldName,
                        fieldIndex: index,
                        description: itemLabel
                    })
                }
			});

            return matches;
        }

        function getDatasetFieldsMatching(value){
            var matches = [];
            var fieldsMD = $scope.dataset.getFieldsMetadata();

			fieldsMD.forEach(function (field, index) {
				if (field.visible && field.userType != "customBlock" && StringUtils.replaceAccentuatedChars(field.description).toLowerCase().indexOf(StringUtils.replaceAccentuatedChars(value).toLowerCase()) > -1) {

					matches.push({
						key: field.name,
						label: field.description,

						fieldName: field.name,
						fieldIndex: index,
						description: field.description,
					});
				}
				
			});

            return matches;
        }

    }]);

/**
 * @ngdoc directive
 * @name snk.components.navigator.directive:sk-navigator
 * @restrict E
 * @scope
 * @description
    Este componente consiste na barra de botões para navegação no Dataset, incluindo os botões de anterior, próximo, etc.
 * @param {object} dataset Instância do dataset.
 * @param {boolean} [show-crud=true] Apresentar botões de CRUD, Create, Read, Update e Delete.
 * @param {function} sk-add-function Função a ser chamada no momento da inserção.
 * @param {boolean} sk-show-navigation Mostra ou não os botões de navegação.
 * @param {boolean} sk-show-add-button Mostra ou não o botão para criar um novo registro.
 * @param {boolean} sk-show-copy-button Mostra ou não o botão de copiar registro.
 * @param {boolean} sk-show-remove-button Mostra ou não o botão de remover registro.
 * @param {boolean} sk-show-refresh-button Mostra ou não o botão de 'Refresh'.
 * @param {boolean} sk-show-cancel-button Mostra ou não o botão de cancelar uma edição.
 * @param {boolean} sk-show-save-button Mostra ou não o botão de salvar uma edição.
 * @param {boolean} sk-edit-unique-record Define se o modo de edição única está ligado.
 * @param {function} sk-save-handler Função a ser chamada quando o botão de salvar for clicado. Recebe uma instância do dataset como parâmetro.
 * @param {boolean} sk-show-edit-button Define se o botão de edição múltipla está ativado.
 * @param {boolean} sk-always-navigation Define se o botão de navegação sempre esta visivel ao mudar de linha o dataset sera salvo.
 * @param {boolean} sk-api define NavigatorApi.
 * @param {boolean} sk-enable-search-fields Flag que habilita a funcionalidade de ctrl+F para destacar campos do dataset.
 * @param {boolean} sk-search-fields-use-dataset Usa o dataset para procurar os campos na tela caso "searchFields" estiver ativado.
 * @param {int} sk-tabs-selected-index Variável controladora do index das Tabs caso hajam na tela.
 */
angular
    .module('snk.components.navigator')
    .directive('skNavigator', ['$timeout', function ($timeout){
        return {
            scope: {
                dataset: '=',
                addFunction: '&?skAddFunction',
                editFunction: '&?skEditFunction',
                showNavigation: '=?skShowNavigation',
                showAddButton: '=?skShowAddButton',
                showCopyButton: '=?skShowCopyButton',
                showRemoveButton: '=?skShowRemoveButton',
                showEditarButton: '=?skShowEditarButton',
                showRefreshButton: '=?skShowRefreshButton',
                showCancelButton: '=?skShowCancelButton',
                showSaveButton: '=?skShowSaveButton',
                showLastButton: '=?skShowLastButton',
                showFirstButton: '=?skShowFirstButton',
                externalInsertionMode: '=?skExternalInsertionMode',
                editUniqueRecord: '=skEditUniqueRecord',
                saveHandler: '&?skSaveHandler',
                showEditButton: '=?skShowEditButton',
                showCrud:'=?showCrud',
                refreshAllRecords: '=?skRefreshAllRecords',
                alwaysNavigation:'=?skAlwaysNavigation',
                api: '=?skApi',
				removeHandler: '&?skRemoveHandler',
                ignoreConditionalSaveCopy: '=?skIgnoreConditionalSaveCopy',
                tabsSelectedIndex: "=?skTabsSelectedIndex",
                enableSearchFields: "=?skEnableSearchFields",
                searchFieldsUseDataset: "=?skSearchFieldsUseDataset"
            },
            controller: 'SkNavigatorController',
            templateUrl: 'components/navigator/navigator.tpl.html',
            link: link
        };

        function link(scope, element, attrs) {
        }
}]);

angular
    .module('snk.components.personalizedfilter')
    .controller('FieldSelectionPopUpController', ['$scope', '$popupInstance', 'resourceId', 'ServiceProxy', 'entityName', 'StringUtils', '$timeout', 'FieldFilterFunction', 'LinkFilterFunction', function ($scope, $popupInstance, resourceId, ServiceProxy, entityName, StringUtils, $timeout,FieldFilterFunction, LinkFilterFunction) {

        var LIST_VIEW = 'list';
        var SEARCH_VIEW = 'search';

        $scope.currentView = LIST_VIEW;
        $scope.currentEntity;
        $scope.searchValue = '';
        $scope.inputEntityFilter = '';
        $scope.inputFieldFilter = '';
        $scope.activeBtnSearch = false;
        $scope.showLoading = false;
        $scope.entityPath = [];
        $scope.changeSearch = changeSearch;
        $scope.applySearch = applySearch;
        $scope.keyDownSearch = keyDownSearch;
        $scope.getIconField = getIconField;
        $scope.showIconSvg = showIconSvg;
        $scope.existFieldsInFilter = existFieldsInFilter;

        loadEntityFields(entityName, $scope);

        $scope.loadEntityFields = function (entityName) {
            loadEntityFields(entityName, $scope);
        };

        $scope.changeEntityByPath = function (entityName, index) {
            if ($scope.currentView === SEARCH_VIEW) {
                $scope.currentView = LIST_VIEW;
            }

            loadEntityFields(entityName, $scope, index);
        };

        $scope.selectField = function (field) {
            $popupInstance.success({
                entityPath: $scope.entityPath,
                selectedItem: field
            });
        };

        function existFieldsInFilter(fields) {

        }

        function loadEntityFields(entityName, $scope, index) {
            ServiceProxy.callService('PersonalizedFilter.getEntityStructure', {
                entity: {
                    name: entityName
                }
            }).then(function (result) {
                var responseBody = result.responseBody;

                responseBody.entity.field = (responseBody.entity.field && !angular.isArray(responseBody.entity.field)) ? [responseBody.entity.field] : responseBody.entity.field;

                if (angular.isDefined(index)) {
                    $scope.entityPath = $scope.entityPath.slice(0, index);
                }

                $scope.entityDescrption = responseBody.entity.description;
                $scope.currentEntity = responseBody.entity;
                $scope.entityPath.push($scope.currentEntity);

                $scope.fields = filterResult(responseBody.entity.field, FieldFilterFunction);
                $scope.entities = filterResult(responseBody.links.entity, LinkFilterFunction);
            });
        }

        function filterResult(array, filterFunction) {
            if (filterFunction) {
                return array.filter(filterFunction);
            } else {
                return array;
            }
        }

        function changeSearch() {
            if (StringUtils.isEmpty($scope.searchValue)) {
                $scope.activeBtnSearch = false;
            } else {
                $scope.activeBtnSearch = true;
            }
        }

        function applySearch() {
        //    if (StringUtils.isEmpty($scope.searchValue)) {
        //        if ($scope.currentView === SEARCH_VIEW) {
        //            $scope.currentView = LIST_VIEW;
        //        }
        //
        //        return;
        //    }
        //
        //    $scope.searchResults = [];
        //    $scope.showLoading = true;
        //    $scope.currentView = SEARCH_VIEW;
        //
        //    //CallService
        //    $timeout(function () {
        //        $scope.showLoading = false;
        //
        //        $scope.searchResults = [
        //            {
        //                description: "% Desc. Especial",
        //                name: "PERCDESCESPECIAL",
        //                entity: "Parceiro",
        //                type: "F",
        //                options: {}
        //            },
        //            {description: "% Desc. Financeiro", name: "DESCFIN", entity: "Parceiro", type: "F", options: {}},
        //            {
        //                description: "% de Custo Variável",
        //                name: "PERCCUSVAR",
        //                entity: "Parceiro",
        //                type: "F",
        //                options: {}
        //            },
        //            {description: "% de juro (diário)", name: "PERCJURO", entity: "Parceiro", type: "F", options: {}},
        //            {description: "% de multa", name: "PERCMULTA", entity: "Parceiro", type: "F", options: {}},
        //            {description: "Agência bancária", name: "CODAGE", entity: "Parceiro", type: "S", options: {}},
        //            {description: "CEP", name: "CEP", entity: "Parceiro", type: "S", options: {}},
        //            {description: "CNPJ / CPF", name: "CGC_CPF", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Cad. Específico do INSS - CEI",
        //                name: "CEI",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Cad.Mun.Contribuintes", name: "INSCMUN", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Caixa Postal", name: "CAIXAPOSTAL", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Celular", name: "AD_CELULAR", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Celular/Fax", name: "FAX", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Como nos conheceu",
        //                name: "COMOCONHECEU",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Complemento", name: "COMPLEMENTO", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Conta bancária parceiro",
        //                name: "CODCTABCO",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Cód. Parceiro", name: "CODPARC", entity: "Parceiro", type: "I", options: {}},
        //            {description: "Cód. Unimed", name: "CODUNIMED", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Código no SGE", name: "CODANT", entity: "Parceiro", type: "I", options: {}},
        //            {description: "Data alteração", name: "DTALTER", entity: "Parceiro", type: "H", options: {}},
        //            {description: "Data cadastramento", name: "DTCAD", entity: "Parceiro", type: "D", options: {}},
        //            {
        //                description: "Data nascimento/Fundação",
        //                name: "DTNASC",
        //                entity: "Parceiro",
        //                type: "D",
        //                options: {}
        //            },
        //            {
        //                description: "Dt. Último contato",
        //                name: "DTULTCONTATO",
        //                entity: "Parceiro",
        //                type: "H",
        //                options: {}
        //            },
        //            {
        //                description: "% Desc. Especial",
        //                name: "PERCDESCESPECIAL",
        //                entity: "Parceiro",
        //                type: "F",
        //                options: {}
        //            },
        //            {description: "% Desc. Financeiro", name: "DESCFIN", entity: "Parceiro", type: "F", options: {}},
        //
        //            {
        //                description: "% de Custo Variável",
        //                name: "PERCCUSVAR",
        //                entity: "Parceiro",
        //                type: "F",
        //                options: {}
        //            },
        //            {description: "% de juro (diário)", name: "PERCJURO", entity: "Parceiro", type: "F", options: {}},
        //            {description: "% de multa", name: "PERCMULTA", entity: "Parceiro", type: "F", options: {}},
        //            {description: "Agência bancária", name: "CODAGE", entity: "Parceiro", type: "S", options: {}},
        //            {description: "CEP", name: "CEP", entity: "Parceiro", type: "S", options: {}},
        //            {description: "CNPJ / CPF", name: "CGC_CPF", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Cad. Específico do INSS - CEI",
        //                name: "CEI",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Cad.Mun.Contribuintes", name: "INSCMUN", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Caixa Postal", name: "CAIXAPOSTAL", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Celular", name: "AD_CELULAR", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Celular/Fax", name: "FAX", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Como nos conheceu",
        //                name: "COMOCONHECEU",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Complemento", name: "COMPLEMENTO", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Conta bancária parceiro",
        //                name: "CODCTABCO",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Cód. Parceiro", name: "CODPARC", entity: "Parceiro", type: "I", options: {}},
        //            {description: "Cód. Unimed", name: "CODUNIMED", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Código no SGE", name: "CODANT", entity: "Parceiro", type: "I", options: {}},
        //            {description: "Data alteração", name: "DTALTER", entity: "Parceiro", type: "H", options: {}},
        //            {description: "Data cadastramento", name: "DTCAD", entity: "Parceiro", type: "D", options: {}},
        //            {
        //                description: "Data nascimento/Fundação",
        //                name: "DTNASC",
        //                entity: "Parceiro",
        //                type: "D",
        //                options: {}
        //            },
        //            {
        //                description: "Dt. Último contato",
        //                name: "DTULTCONTATO",
        //                entity: "Parceiro",
        //                type: "H",
        //                options: {}
        //            },
        //            {
        //                description: "% Desc. Especial",
        //                name: "PERCDESCESPECIAL",
        //                entity: "Parceiro",
        //                type: "F",
        //                options: {}
        //            },
        //            {description: "% Desc. Financeiro", name: "DESCFIN", entity: "Parceiro", type: "F", options: {}},
        //            {
        //                description: "% de Custo Variável",
        //                name: "PERCCUSVAR",
        //                entity: "Parceiro",
        //                type: "F",
        //                options: {}
        //            },
        //            {description: "% de juro (diário)", name: "PERCJURO", entity: "Parceiro", type: "F", options: {}},
        //            {description: "% de multa", name: "PERCMULTA", entity: "Parceiro", type: "F", options: {}},
        //            {description: "Agência bancária", name: "CODAGE", entity: "Parceiro", type: "S", options: {}},
        //            {description: "CEP", name: "CEP", entity: "Parceiro", type: "S", options: {}},
        //            {description: "CNPJ / CPF", name: "CGC_CPF", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Cad. Específico do INSS - CEI",
        //                name: "CEI",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Cad.Mun.Contribuintes", name: "INSCMUN", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Caixa Postal", name: "CAIXAPOSTAL", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Celular", name: "AD_CELULAR", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Celular/Fax", name: "FAX", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Como nos conheceu",
        //                name: "COMOCONHECEU",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Complemento", name: "COMPLEMENTO", entity: "Parceiro", type: "S", options: {}},
        //            {
        //                description: "Conta bancária parceiro",
        //                name: "CODCTABCO",
        //                entity: "Parceiro",
        //                type: "S",
        //                options: {}
        //            },
        //            {description: "Cód. Parceiro", name: "CODPARC", entity: "Parceiro", type: "I", options: {}},
        //            {description: "Cód. Unimed", name: "CODUNIMED", entity: "Parceiro", type: "S", options: {}},
        //            {description: "Código no SGE", name: "CODANT", entity: "Parceiro", type: "I", options: {}},
        //            {description: "Data alteração", name: "DTALTER", entity: "Parceiro", type: "H", options: {}},
        //            {description: "Data cadastramento", name: "DTCAD", entity: "Parceiro", type: "D", options: {}},
        //            {
        //                description: "Data nascimento/Fundação",
        //                name: "DTNASC",
        //                entity: "Parceiro",
        //                type: "D",
        //                options: {}
        //            },
        //            {
        //                description: "Dt. Último contato",
        //                name: "DTULTCONTATO",
        //                entity: "Parceiro",
        //                type: "H",
        //                options: {}
        //            }
        //        ];
        //    }, 1000);
        }

        function keyDownSearch(event) {
            if (event.keyCode === 13) {
                applySearch();
            }
        }

        function getIconField(field) {
            var icon;

            switch (field.type) {
                case 'I':
                    if (field.hasOwnProperty('targetEntityName')) {
                        icon = 'search';
                    } else {
                        icon = '/mge/assets/svg/number.svg';
                    }
                    break;
                case 'F':
                    icon = '/mge/assets/svg/number.svg';
                    break;
                case 'D':
                    icon = 'calendar';
                    break;
                case 'T':
                    icon = 'clock';
                    break;
                case 'H':
                    icon = '/mge/assets/svg/calendar-time.svg';
                    break;
                default:
                    if (field.hasOwnProperty('targetEntityName')) {
                        icon = 'search';
                    } else {
                        icon = '/mge/assets/svg/character-t.svg';
                    }
                    break;
            }

            return icon;
        }

        function showIconSvg(field) {
            var showSvg;

            switch (field.type) {
                case 'I':
                    if (field.hasOwnProperty('targetEntityName')) {
                        showSvg = false;
                    } else {
                        showSvg = true;
                    }
                    break;
                case 'F':
                    showSvg = true;
                    break;
                case 'D':
                    showSvg = false;
                    break;
                case 'T':
                    showSvg = false;
                    break;
                case 'H':
                    showSvg = true;
                    break;
                default:
                    if (field.hasOwnProperty('targetEntityName')) {
                        showSvg = false;
                    } else {
                        showSvg = true;
                    }
                    break;
            }

            return showSvg;
        }
    }]);
angular
    .module('snk.components.personalizedfilter')
    .controller('SkFilterAssistentController', ['$scope', '$timeout', '$q' ,'$element', 'SanPopup', 'SkI18nService', 'SkConstants', 'SkFilter', 'StringUtils', '$document', 
    function ($scope, $timeout, $q, $element, SanPopup, SkI18nService, SkConstants, SkFilter, StringUtils, $document) {
        var self = this;

        self.conjunctionOptions = [{
            key: SkConstants.SQL.AND,
            label: SkI18nService.instant('FiltroPersonalizado.and')
        }, {
            key: SkConstants.SQL.OR,
            label: SkI18nService.instant('FiltroPersonalizado.or')
        }];

        self.required = true;
        self.enabled = false;
        self.isEmptyOperand = isEmptyOperand;
        self.isNumberField = isNumberField;
        self.isComboField = isComboField;
        self.isSearchField = isSearchField;
        self.isDefaultField = isDefaultField;
        self.isDateField = isDateField;
        self.isTimeField = isTimeField;
        self.openFieldSelectorFromAssistent = openFieldSelectorFromAssistent;
        self.openFieldSelectorNerdEdit = openFieldSelectorNerdEdit;
        self.addNewFilter = addNewFilter;
        self.removeFilter = removeFilter;
        self.onChangeValue = onChangeValue;
        self.operatorOptions = getOperators();
        self.goToAssistentMode = goToAssistentMode;
        self.toggleEditMode = toggleEditMode;
        self.previewAssistent = previewAssistent;
        self.changeExpression = changeExpression;
        self.cancelNerdEdition = cancelNerdEdition;
        self.openVariableParameterConfig = openVariableParameterConfig;
        self.isPreviewMode = false;
        self.buildArray = buildArray;
        self.onChangeParentheses = onChangeParentheses;
        self.getElement = getElement
        self.onChangeFieldValue = onChangeFieldValue;

        $scope.msgAlertError;
        $scope.msgNotAcceptAssistentMode = SkI18nService.instant('FiltroPersonalizado.msgNaoAceitaModoAssistente');
        $scope.tooltipCancelarEdicao = SkI18nService.instant('FiltroPersonalizado.tooltipCancelarEdicao');
        $scope.tooltipConfigVariableParam = SkI18nService.instant('FiltroPersonalizado.tooltipConfigVariableParam');
        $scope.tooltipBtnAddRemoveParentheses = SkI18nService.instant('FiltroPersonalizado.tooltipBtnAddRemoveParentheses');
        $scope.standaloneMode = $scope.standaloneMode ? StringUtils.toBoolean($scope.standaloneMode) : false;
        $scope.showError = false;

        init();

        function init() {
            if ($scope.standaloneMode) {
                if (angular.isUndefined($scope.transientFilter)) {
                    $scope.transientFilter = {
                        newItem: true,
                        filterModel: {}
                    };
                }

                $scope.filter = $scope.transientFilter;

                if (angular.isUndefined($scope.filter.mode)) {
                    if ($scope.filter.filterModel && !$scope.filter.filterModel.assistent && $scope.filter.filterModel.expression) {
                        $scope.filter.mode = SkFilter.MODE_EXPRESSION;
                    } else {
                        $scope.filter.mode = SkFilter.MODE_ASSISTENT;
                    }
                }
            }
        }

        function onChangeParentheses() {
            $scope.transientFilter.dirty = true;
        }

        function buildArray(n){
            return new Array(n | 0);
        }

        function openVariableParameterConfig(element){

            var popupInstance = SanPopup.open({
                templateUrl: 'components/personalizedfilter/templates/variable-parameter-config-popup.tpl.html',
                controller: 'VariableParamterConfigPopUpController',
                controllerAs: 'ctrl',
                title: SkI18nService.instant('FiltroPersonalizado.tituloVariableParameterConfig'),
                size: 'md',
                okBtnLabel: SkI18nService.instant('Geral.lblSalvar'),
                windowClass: 'variable-parameter-config-modal',
                parentElementPopup: $scope.parameterPopupOnBody ? $document.find('body').eq(0) : undefined,
                resolve: {
                    parameter: function () {
                        return angular.copy(element);
                    }
                }
            });

            popupInstance.result.then(function(config){
                element.config = config;
                $scope.transientFilter.dirty = true;
            })

        }

        function changeExpression(oldValue) {
            if ($scope.transientFilter && $scope.transientFilter.filterModel && $scope.transientFilter.filterModel.expression && StringUtils.isEmpty($scope.transientFilter.filterModel.expression['$'])) {
                $scope.transientFilter.expressionChanged = false;

                if ($scope.transientFilter.filterModel.assistent) {
                    $scope.transientFilter.filterModel.assistent = undefined;
                }
            } else {
                $scope.transientFilter.expressionChanged = true;

                if ($scope.transientFilter && $scope.transientFilter.filterModel && $scope.transientFilter.filterModel.assistent) {
                    $scope.transientFilter.assistentBackup = $scope.transientFilter.filterModel.assistent;
                    self.oldExpressionValue = oldValue;
                    delete $scope.transientFilter.filterModel['assistent'];
                }
            }
            ($scope.onChangeExpressionFilter || angular.noop)(SkFilter.buildExpression($scope.transientFilter))
        }

        function cancelNerdEdition(){
            $scope.transientFilter.filterModel.assistent = $scope.transientFilter.assistentBackup;
            $scope.transientFilter.expressionChanged = false;
            $scope.transientFilter.filterModel.expression = self.oldExpressionValue;
            delete $scope.transientFilter.assistentBackup;
        }

        function previewAssistent(filter){
            toggleEditMode(filter);
            self.isPreviewMode = true;
        }

        function toggleEditMode(filter) {
            if (filter.mode == SkFilter.MODE_ASSISTENT) {
                if ($scope.transientFilter) {
                    SkFilter.buildExpression($scope.transientFilter);
                }

                filter.mode = SkFilter.MODE_EXPRESSION;
            } else if (filter.mode == SkFilter.MODE_EXPRESSION) {
                filter.mode = SkFilter.MODE_ASSISTENT;
                self.isPreviewMode = false;
            } else {
                showErrorMessage(SkI18nService.instant('FiltroPersonalizado.modoEdicaoInvalido'));
            }
        }

        function showErrorMessage(msg) {
            $scope.msgAlertError = msg;
            $scope.showError = true;
        }

        function hideErrorMessage() {
            $scope.showError = false;
        }

        function goToAssistentMode() {
            var filter = $scope.transientFilter;

            if (!filter) {
                return false;
            }

            var expressionVoid = (filter && filter.filterModel && filter.filterModel.expression && StringUtils.isEmpty($scope.transientFilter.filterModel.expression['$']));

            return ((filter.filterModel.assistent || filter.newItem || expressionVoid) && (filter.expressionChanged == undefined || filter.expressionChanged == false));
        }

        function addNewFilter() {
            if ((!$scope.transientFilter.filterModel.assistent || ($scope.transientFilter.filterModel.assistent && !$scope.transientFilter.filterModel.assistent.hasOwnProperty('element')))) {
                $scope.transientFilter.filterModel.assistent = {};
            }

            if (!$scope.transientFilter.filterModel.assistent.element) {
                $scope.transientFilter.filterModel.assistent.element = [];
            } else if(!angular.isArray($scope.transientFilter.filterModel.assistent.element)) {
                $scope.transientFilter.filterModel.assistent.element = [$scope.transientFilter.filterModel.assistent.element];
            }

            if ($scope.transientFilter.filterModel.assistent.element.length > 0) {
                $scope.transientFilter.filterModel.assistent.element.push({
                    elementType: SkFilter.CONTAINER_OPERAND,
                    operand: SkConstants.SQL.AND
                });
            }

            $scope.transientFilter.filterModel.assistent.element.push({
                elementType: SkFilter.CONTAINER_FILTER,
                operand: SkConstants.SQL.EQUAL
            });
        }

        function removeFilter(element) {

            var array = $scope.transientFilter.filterModel.assistent.element;

            var i;

            for (i = array.length - 1; i >= 0; i--) {
                if (array[i] === element) {
                    array.splice(i, 1);
                    break;
                }
            }

            var removed = false;

            if (i < array.length && array[i].elementType == SkFilter.CONTAINER_OPERAND) {
                array.splice(i, 1);
                removed = true;
            } else if (i > 1 && array[i - 1].elementType == SkFilter.CONTAINER_OPERAND) {
                array.splice(i - 1, 1);
                removed = true;
            }

            if (removed) {
                $scope.transientFilter.dirty = true;
            }
            ($scope.onChangeExpressionFilter || angular.noop)(SkFilter.buildExpression($scope.transientFilter))
        }

        function isDefaultField(element) {
            var isDefault = true;

            switch (element.type) {
                case "D":
                case "T":
                case "H":
                case "F":
                case "I":
                case "C":
                    isDefault = false;
                    break;
                default:
                    if (element.hasOwnProperty('targetEntityName')) {
                        isDefault = false;
                    }
            }

            if (isDefault && isComboField(element)) {
                isDefault = false;
            }

            return isDefault;
        }

        function isNumberField(element) {
            return (element.type === 'I' || element.type === SkFilter.CONTAINER_FILTER) && !isComboField(element) && !isSearchField(element);
        }

        function isComboField(element) {
            return (element.options !== undefined && element.options.option !== undefined && element.options.option.length > 0);
        }

        function isSearchField(element) {
            var isSearch = false;

            if (element.type === 'I' && !isComboField(element) && element.hasOwnProperty('targetEntityName')) {
                isSearch = true;
            } else if (!isDefaultField(element) && element.hasOwnProperty('targetEntityName')) {
                isSearch = true;
            }

            return isSearch;
        }

        function isDateField(element) {
            return (element.type === 'D' || element.type === 'H') && !isComboField(element);
        }

        function isTimeField(element) {
            return element.type === 'T' && !isComboField(element);
        }

        function openFieldSelectorFromAssistent(element) {
            openFieldSelector()
                .then(function (result) {
                    element.entityName = result.entityName;
                    element.fieldName = result.searchResult.selectedItem.name;
                    element.description = result.description;
                    element.type = result.searchResult.selectedItem.type;
                    element.options = result.searchResult.selectedItem.options;
                    element.expression = result.expression;
                    element.value = undefined;

                    if (result.searchResult.selectedItem.targetEntityName) {
                        element.targetEntityName = result.searchResult.selectedItem.targetEntityName;
                    } else {
                        delete element.targetEntityName;
                    }
                });
        }

        function openFieldSelectorNerdEdit(filter) {
            openFieldSelector()
                .then(function (result) {
                    if (!filter.filterModel.expression){
                        filter.filterModel.expression = {
                        };
                    }

                    if (filter.filterModel.expression.$){
                        self.oldExpressionValue = angular.copy(filter.filterModel.expression);
                    }

                    if (filter.filterModel.expression.$){
                        if (!filter.filterModel.expression.$.endsWith(' ')){
                            filter.filterModel.expression.$ += ' ';
                        }

                        filter.filterModel.expression.$ += result.expression;
                    } else {
                        filter.filterModel.expression.$ = result.expression;
                    }

                    filter.filterModel.expression.$ += ' ';

                    changeExpression(self.oldExpressionValue);

                    $element.find('.filter-assistent-sql textarea').focus();
                });
        }

        function openFieldSelector() {
            var deferred = $q.defer();

            var popupInstance = SanPopup.open({
                templateUrl: 'components/personalizedfilter/templates/field-selection-popup.tpl.html',
                controller: 'FieldSelectionPopUpController',
                controllerAs: 'ctrl',
                title: SkI18nService.instant('FiltroPersonalizado.tituloSelecaoCampo'),
                size: 'lg',
                windowClass: 'personalized-filter-modal',
                parentElementPopup: $scope.parameterPopupOnBody ? $document.find('body').eq(0) : undefined,
                showBtnOk: false,
                resolve: {
                    resourceId: function () {
                        return $scope.resourceId;
                    },
                    entityName: function () {
                        return $scope.entityName;
                    },
                    FieldFilterFunction:  function() {
                        return $scope.fieldFilterFunction;
                    },
                    LinkFilterFunction: function () {
                        return $scope.linkFilterFunction;
                    }
                }
            });

            popupInstance.result.then(function (result) {
                var description = '';
                var expression = '';
                var entityName = '';

                result.entityPath.forEach(function (path, i) {
                    entityName = path.name;

                    if (result.entityPath.length > 1) {
                        if (i > 0) {
                            expression += entityName + '->';
                        }
                    } else {
                        expression += entityName + '.';
                    }

                    description += path.description;
                    description += " >> ";
                });

                expression += result.selectedItem.name;
                description += result.selectedItem.description;

                deferred.resolve({
                    expression: expression,
                    description: description,
                    entityName: entityName,
                    searchResult: result
                });
            });

            return deferred.promise;
        }

        function getOperators() {
            return [
                {
                    key: SkConstants.SQL.EQUAL,
                    label: SkI18nService.instant('FiltroPersonalizado.igual')
                },
                {
                    key: SkConstants.SQL.DIFFERENT,
                    label: SkI18nService.instant('FiltroPersonalizado.diferente')
                },
                {
                    key: SkConstants.SQL.LIKE,
                    label: SkI18nService.instant('FiltroPersonalizado.em')
                },
                {
                    key: SkConstants.SQL.IN,
                    label: SkI18nService.instant('FiltroPersonalizado.contendo')
                },
                {
                    key: SkConstants.SQL.START_WITH,
                    label: SkI18nService.instant('FiltroPersonalizado.lblIniciando')
                },
                {
                    key: SkConstants.SQL.FINISHED_WITH,
                    label: SkI18nService.instant('FiltroPersonalizado.lblTerminado')
                },
                {
                    key: SkConstants.SQL.NULL,
                    label: SkI18nService.instant('FiltroPersonalizado.lblVazio')
                },
                {
                    key: SkConstants.SQL.NOT_NULL,
                    label: SkI18nService.instant('FiltroPersonalizado.lblNaoVazio')
                },
                {
                    key: SkConstants.SQL.LARGER,
                    label: SkI18nService.instant('FiltroPersonalizado.lblMaior')
                },
                {
                    key: SkConstants.SQL.LARGER_EQUAL,
                    label: SkI18nService.instant('FiltroPersonalizado.lblMaiorIgual')
                },
                {
                    key: SkConstants.SQL.SMALLER,
                    label: SkI18nService.instant('FiltroPersonalizado.lblMenor')
                },
                {
                    key: SkConstants.SQL.SMALLER_EQUAL,
                    label: SkI18nService.instant('FiltroPersonalizado.lblMenorIgual')
                }
            ];
        }

        function isEmptyOperand(operand) {
            if (operand === SkConstants.SQL.NOT_NULL || operand === SkConstants.SQL.NULL) {
                return true;
            }

            return false;
        }

        function onChangeValue(element, obj) {
            element.value = undefined;
        }

        function getElement() {
            return $scope.transientFilter.filterModel.assistent.element[0];
        }

        function onChangeFieldValue(){
            if ($scope.transientFilter){
                $scope.transientFilter.filterModel?.assistent?.element?.forEach(function (element) {
                    if (element.elementType == 'F' && 
                        element.operand !== SkConstants.SQL.NULL && 
                        element.operand !== SkConstants.SQL.NOT_NULL && 
                        "D-H".indexOf(element.type) > -1 && 
                        element.value == undefined) {
                        element.clickToggleDatePicker = true;
                    }
                });
                ($scope.onChangeExpressionFilter || angular.noop)(SkFilter.buildExpression($scope.transientFilter))
            }
        }

    }])
/**
 * @ngdoc directive
 * @name snk.components.personalizedfilter.directive:filter-assistent
 * @restrict E
 * @scope
 * @description
 * Componente para utilização do assistente de filtros.
 * Ele é composto por um criador de expressões inteligente com um assistente de criação e também possui a possibilidade
 * de criar a expressão em SQL puro.
 *
 * @param {object} transient-filter Objeto que vai conter o filtro criado em memória pelo assistente.
 * @param {string} entity-name Nome da entidade para ser utilizado no listagem de campos a serem usados no assistente.
 * @param {string} resource-id Resource ID para ser utilizado no assistente no momento de seleção de campos.
 * @param {object=} filter Objeto que vai conter o filtro a ser utilizado no assistente e que não está transacional na
 * @param {boolean} parameter-popup-on-body Caso true, a popup de parametros sempre será renderizada no body (em frente de todos os paineis),
 *                  caso contrario, ele buscará o Parent e renderizará nele (ex: personalized-filter está dentro de uma popup).
 * 
 * memória. Quando esse objeto não é passado e o assistente está em modo stand alone, ele assume como valor o transientFilter.
 *
 * @param {boolean=} [standalone-mode=false] Liga o assistente em modo standalone e com isso não faz operações no assistente
 * que são validas apenas para trabalhar com o assistente em modo lista, por exemplo, utilizar o assistente
 * no @{link snk.components.personalizedfilter.directive:sk-personalized-filterFiltro Personalizdo}.
 *
 * @example
     <example>
         <file name="exemplo.html">
            <p>Esse componente não possui demo, pois ele é um componente comum de nossas telas e não existe a possibilidade de apresentação nesse contexto.</p>
         </file>
     </example>
 */
angular
    .module('snk.components.personalizedfilter')
    .directive('filterAssistent', [function () {
        return {
            restrict: 'E',
            templateUrl: 'components/personalizedfilter/templates/filter-assistent.tpl.html',
            controller: 'SkFilterAssistentController',
            controllerAs: 'ctrl',
            scope: {
                filter: '=?filter',
                transientFilter: '=transientFilter',
                entityName: '@entityName',
                resourceId: '@resourceId',
                standaloneMode: '@?standaloneMode',
                allowVariable: '=?allowVariable',
                fieldFilterFunction: '=fieldFilterFunction',
                linkFilterFunction: '=linkFilterFunction',
                ignoreNameFilter:'=?skIgnoreNameFilter',
                parameterPopupOnBody: '=?parameterPopupOnBody',
                onChangeExpressionFilter:'&?skOnChangeExpressionFilter'
            }
        };
    }]);
angular
    .module("snk.components.personalizedfilter")
    .service("SkFilter", ['SkConstants', 'StringUtils', 'NumberUtils', 'MetadataProvider', '$q', 'DateUtils', 'DateUtilsConstants', 'ServiceProxy', function (SkConstants, StringUtils, NumberUtils, MetadataProvider, $q, DateUtils, DateUtilsConstants, ServiceProxy) {
        //private
        var self = this;
        const pendingRequests = {};
        const responseCache = {};

        var _filterPanelFields = {};

        //public
        self.MODE_EXPRESSION = 'nerdEdit';
        self.MODE_ASSISTENT = 'edit';
        self.MODE_DEFAULT = '';
        self.CONTAINER_FILTER = 'F';
        self.CONTAINER_OPERAND = 'O';

        self.buildExpression = buildExpression;
        self.buildFilterExpression = buildFilterExpression;
        self.getExpression = getExpression;
        self.getParameterValue = getParameterValue;
        self.getFilterPanelFields = getFilterPanelFields;
        self.invalidateFilterCache = invalidateFilterCache;

        //inner functions
        function getParameterValue(element){
            if (StringUtils.toBoolean(element.variable)) {
                var value;

                if (!element.config) {
                    value = '?:{entidade=' + element.entityName + ';campo=' + element.fieldName + '}';
                } else if (element.config.configType == 'S') {
                    var config = element.config.systemConfig;
                    value = '?:{entidade=' + (config ? config.entityName : '') + ';campo=' + (config ? config.fieldName : '') + '}';
                } else if (element.config.configType == 'E') {
                    var config = element.config.userConfig;
                    value = '?:{desc=' + (config ? config.description : '') + ';tipo=' + (config ? config.type : '') + '}';
                } else {
                    throw Error('Filtro variável com configuação inválida: ' + buildExpression(element));
                }

                return value;
            } else if (element.operand !== SkConstants.SQL.NULL && element.operand !== SkConstants.SQL.NOT_NULL) {
                var value = element.value;
                if ("F-I".indexOf(element.type) > -1) {
                    value = NumberUtils.stringToNumber(value);

                    if (isNaN(value)) {
                        throw new Error('O valor informado não é um número válido.');
                    }
                } else if ("D-H".indexOf(element.type) > -1) {
                    value = DateUtils.formatDate(value, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                }

                return value;
            } else {
                return element.operand;
            }
        }

        function getExpression(filter) {
            if (filter.filterModel && filter.filterModel.expression && filter.filterModel.expression.hasOwnProperty('$')) {
                return filter.filterModel.expression['$'];
            } else {
                return null;
            }
        }

        function getFilterPanelFields(entityName) {
            var deferred = $q.defer();

            if (_filterPanelFields[entityName]) {
                deferred.resolve(_filterPanelFields[entityName]);
            } else {
                MetadataProvider.getEntityMetadata(entityName).then(function(md){
                    var entityMd = md[entityName];

                    _filterPanelFields[entityName] = entityMd.fields.filter(function(field){
                        return field.fieldFilterInfo;
                    }).sort(function(field1, field2){
                        var order1 = Number(field1.fieldFilterInfo.order);
                        var order2 = Number(field2.fieldFilterInfo.order);

                        return order1 - order2;
                    });

                    deferred.resolve(_filterPanelFields[entityName]);
                })
            }

            return deferred.promise;
        }

        function buildExpression(filter) {
            if (filter && filter.filterModel && filter.filterModel.assistent && filter.filterModel.assistent.element) {
                var sql = '';

                filter.filterModel.assistent.element.forEach(function (element) {
                    if (element.elementType == 'F') {
                        if (!element.expression){
                            throw new Error('Filtro com campo indefinido.');
                        }

                        var value = getParameterValue(element);
                        let clickToggleDatePicker = element.hasOwnProperty('clickToggleDatePicker');

                        if (angular.isUndefined(value) && !clickToggleDatePicker) {
                            throw new Error('Filtro com valor indefinido.');
                        }

                        if (clickToggleDatePicker) {
                            delete element.clickToggleDatePicker;
                        }

                        sql += buildFilterExpression(element, value);
                    } else {
                        sql += ' ' + element.operand + ' ';
                    }
                });

                if (!StringUtils.isDelimitersBalanced(sql, '(', ')')){
                    throw Error('Expressão com parenteses desbalanceados.');
                }

                filter.filterModel.expression = {
                    $: sql
                };
            }
        }

        function buildFilterExpression(element) {
            var value = getParameterValue(element);

            if (element.operand == SkConstants.SQL.IN) {
                return element.expression + ' ' + element.operand + ' (' + value + ')';
            }

            let expression = element.expression;

            switch (element.operand) {
                case SkConstants.SQL.NULL:
                case SkConstants.SQL.NOT_NULL:
                    expression += " IS " + value;
                    break;
                case SkConstants.SQL.LIKE:
                    expression += " LIKE '%" + value + "%'";
                    break;
                case SkConstants.SQL.START_WITH:
                    expression += " LIKE '" + value + "%'";
                    break;
                case SkConstants.SQL.FINISHED_WITH:
                    expression += " LIKE '%" + value + "'";
                    break;
                default:
                    var quotes;

                    if ((element.type === 'S' || element.type === 'D' || element.type === 'H') && !StringUtils.toBoolean(element.variable)) {
                        quotes = "'";
                    } else {
                        quotes = "";
                    }
                    expression += ' ' + element.operand + ' ' + quotes + value + quotes;
            }

            if (element.parentheses) {
                if (element.parentheses.open) {
                    expression = StringUtils.replicate('(', element.parentheses.open) + expression;
                }

                if (element.parentheses.close) {
                    expression = expression + StringUtils.replicate(')', element.parentheses.close);
                }
            }

            return expression;
        }
    
        this.callPersonalizedFilter = function(resourceId, useSupOnlyConfig) {
            const cacheKey = `${resourceId}-${useSupOnlyConfig ? 'S' : 'N'}`;
    
            if (responseCache[cacheKey]) {
                return $q.resolve(responseCache[cacheKey]);
            }
    
            if (pendingRequests[cacheKey]) {
                return pendingRequests[cacheKey];
            }
    
            const deferred = $q.defer();
            pendingRequests[cacheKey] = deferred.promise;
    
            ServiceProxy.callService('PersonalizedFilter.getFilters', {
                filters: {
                    id: resourceId,
                    useSupOnlyConfig: useSupOnlyConfig ? 'S' : 'N'
                }
            })
            .then(response => {
                responseCache[cacheKey] = response;
                deferred.resolve(response);
            })
            .catch(error => deferred.reject(error))
            .finally(() => {
                delete pendingRequests[cacheKey];
            });
    
            return deferred.promise;
        };

        function invalidateFilterCache(resourceId, useSupOnlyConfig) {
            const cacheKey = `${resourceId}-${useSupOnlyConfig ? 'S' : 'N'}`;
            if (responseCache[cacheKey]) {
                delete responseCache[cacheKey];
            }
        }
    }]);
angular
    .module('snk.components.personalizedfilter')
    .controller('PersonalizedFilterController', ['SkApplication', '$scope', '$attrs', '$q', 'SkI18nService', 'ServiceProxy', 'ObjectUtils', '$timeout', 'PopUpParameter', 'DatasetUtils', 'StringUtils', 'SkComponentRegistry', '$element', 'SkConstants', '$document', 'AngularUtil', '$compile', 'ArrayUtils', 'NumberUtils', 'MessageUtils', 'SkFilter', 'WhenReadyBuilder', 'DomUtil', 'PositionUtils', 'PersonalizedFilterTourContent', 'DateUtils', 'Criteria', 'MGEParameters', 'DatasetEvents', 'SanPopupStack', 'KeyboardManager', 'SanPopup',
        function (SkApplication, $scope, $attrs, $q, SkI18nService, ServiceProxy, ObjectUtils, $timeout, PopUpParameter, DatasetUtils, StringUtils, SkComponentRegistry, $element, SkConstants, $document, AngularUtil, $compile, ArrayUtils, NumberUtils, MessageUtils, SkFilter, WhenReadyBuilder, DomUtil, PositionUtils, PersonalizedFilterTourContent, DateUtils, Criteria, MGEParameters, DatasetEvents, SanPopupStack, KeyboardManager, SanPopup) {
            //private
            var self = this;
            var templateUrl = 'components/personalizedfilter/templates/personalized-filter-popover.tpl.html';
            var filterReady = WhenReadyBuilder.$new();
            var componentId = $scope.id;
            var filtersMap = {};
            var lastDOMProperties = {};
            var watchDatasource;
            var registerInstance;
            var containerElem;
            var bodyElem = angular.element($document[0].body);
            var msgErrorsInForm = SkI18nService.instant('FiltroPersonalizado.existeErrosFormulario');
            var msgFilterContainsExpression = SkI18nService.instant('FiltroPersonalizado.filtroTemExpressao');
            var _loadFilterPromise;
            var _lastResourceIdActiveFilters;
            var _validateFilter = false;
            var _isValidation = false;
            $scope.valSegFiltro = MGEParameters.asBoolean("br.com.sankhya.modelcore.validacaosegurancafiltros");
            
            $scope.forms = {};
            
            $scope.personalizedFilterApi = self;

            $scope.tooltipApply = $scope.tooltipApply ? $scope.tooltipApply : 'Geral.buttonAplicarTooltip';

            //inject
            ObjectUtils.implements(self, CriteriaProvider);
            ObjectUtils.implements(self, IDataSetObserver);

            //scope
            $scope.states = {
                isDropdownOpen: false
            };

            $scope.tooltipFiltroPersonalizado = SkI18nService.instant('FiltroPersonalizado.titulo');
            $scope.filterInfos = [];
            $scope.autoFillCriteria = $scope.autoFillCriteria ? StringUtils.toBoolean($scope.autoFillCriteria) : false;
            $scope.loadOnCreate = $scope.loadOnCreate ? StringUtils.toBoolean($scope.loadOnCreate) : true;
            $scope.allowVariable = angular.isUndefined($scope.allowVariable) ? true : StringUtils.toBoolean($scope.allowVariable);
            $scope.hideApply = angular.isUndefined($scope.hideApply) ? false : StringUtils.toBoolean($scope.hideApply);
            $scope.value = '2';
            $scope.enabled = false;
            $scope.options = [{ data: '1', value: 'Opcao1' }, { data: '2', value: 'Opcao2' }];
            $scope.date = new Date();
            $scope.transientFilter;
            $scope.msgAlertError;
            $scope.showError = false;
            $scope.required = true;
            $scope.filtersActive = true;
            $scope.useSupOnlyConfig = angular.isUndefined($scope.useSupOnlyConfig) ? false : StringUtils.toBoolean($scope.useSupOnlyConfig);
            $scope.hideFilter = angular.isUndefined($scope.hideFilter) ? false : StringUtils.toBoolean($scope.hideFilter);
            $scope.showList = false;            
            
            $scope.saveFilter = saveFilter;
            $scope.openFilter = openFilter;
            $scope.openFilterEdit = openFilterEdit;
            $scope.openFilterNew = openFilterNew;
            $scope.applyFilter = applyFilter;
            $scope.deselectAllFilters = self.deselectAllFilters = deselectAllFilters;
            $scope.getActiveFilters = self.getActiveFilters = getActiveFilters;
            $scope.hasActiveFilter = self.hasActiveFilter = hasActiveFilter;
            $scope.isColoredButton = isColoredButton;
            $scope.getButtonColor = getButtonColor;
            $scope.startTour = startTour;
            $scope.onToggleAllFilters = onToggleAllFilters;
            $scope.isSup = SkApplication.instance().isSup();
            $scope.getDefaultFilterToolTip = getDefaultFilterToolTip;
            $scope.openFilterDefault = openFilterDefault;
            $scope.toggleList = toggleList;
            $scope.countActiveFilters = countActiveFilters;
            
            //public
            self.isLoaded = false;
            self.getProperties = getProperties;
            self.applyFilter = applyFilter;
            self.onCriteriaReady = onCriteriaReady;
            self.getCriteria = getCriteria;
            self.getAppliedCriteria = getAppliedCriteria;
            self.getInstance = getInstance;
            self.loadFilters = loadFilters;
            self.cancel = cancel;
            self.confirmEdition = confirmEdition;
            self.newFilter = newFilter;
            self.beginEdition = beginEdition;
            self.cancelEdition = cancelEdition;
            self.setSelected = setSelected;
            self.deleteFilter = deleteFilter;
            self.confirmDelete = confirmDelete;
            self.isEditingFilter = isEditingFilter;
            self.textToColor = textToColor;
            self.buildFilterNick = buildFilterNick;
            self.openFilter = openFilter;
            self.startTour = startTour;
            self.setResourceId = setResourceId;
            self.clearFilters = clearFilters;
            self.currentLineChanged = currentLineChanged;
            self.getFilterName = getFilterName;

            var _publicAPI = ObjectUtils.buildPublicAPI(self, 'getCriteria,getInstance,loadFilters,setResourceId,clearFilters,hasActiveFilter,getActiveFilters,deselectAllFilters,onCriteriaReady,getAppliedCriteria');

            //initialize
            init();

            $scope.$watch('resourceId',function(){
                if($scope.resourceId)
                    loadFilters();
            });

            KeyboardManager.bind('ctrl+shift+f', function () {
                $timeout(function () {
                    toggleList();
                }, 200);
            });

            KeyboardManager.bind('ctrl+f8', function () {
                $timeout(function () {
                    openFilterNew();
                }, 200);
            });

            function currentLineChanged(newIndex) {
                if(newIndex > -1){
                    var filterInfos = [];

                    if (angular.isDefined($scope.datasetStandalone.getFieldValue($scope.fieldNameStandalone))) {
                        var dataField = $scope.datasetStandalone.getFieldValue($scope.fieldNameStandalone);
                        if (!StringUtils.isEmpty(dataField)) {
                            var filters = JSON.parse(dataField);
                            if (filters && filters.filter) {
                                filters.filter.forEach(function (filter) {
                                    var newFilter = {
                                        filterModel: filter
                                    };
    
                                filterInfos.push(newFilter);
    
                                    filtersMap[filter.id] = newFilter;
                                });
                            }

                        }
                    }

                    $scope.filterInfos = filterInfos;

                }else{
                    $scope.filterInfos = [];
                }

                refreshHasSomeActiveFilter();

                _loadFilterPromise.resolve();
                filterReady.ready();
            }
            
            function saveActivePersonalizedFilter(){
                if($scope.filtersActive === undefined){
                    return;
                }

                var filterRequest = {
                    resourceId: $scope.resourceId,
                    entityName: $scope.entityName,
                    useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N',
                    filtersActive: $scope.filtersActive === true ? 'S' : 'N'
                };

                ServiceProxy.callService('PersonalizedFilter.savePersonalizedFilterProperties', {
                    filterproperties: filterRequest
                }).then(function() {
                    SkFilter.invalidateFilterCache($scope.resourceId, $scope.useSupOnlyConfig);
                });
            }

            function loadActivePersonalizedFilter(){
            	if(!$scope.resourceId){
                    console.warn('[SanPopupStack] Filtros ativos não carregados pois o resource id não foi setado.');
                    return;
                }

                if(_lastResourceIdActiveFilters === $scope.resourceId){
                    return;
                }
                
                var filterRequest = {
                    resourceId: $scope.resourceId,
                    entityName: $scope.entityName,
                    useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N'
                };

                ServiceProxy.callService('PersonalizedFilter.loadPersonalizedFilterProperties', {
                    filterproperties: filterRequest
                }).then(function(filter) {
                	_lastResourceIdActiveFilters = $scope.resourceId;
                	$scope.filtersActive = ( 
                                                (filter &&
                                                filter.responseBody.filters &&
                                                filter.responseBody.filters.filtersActive &&
                                                filter.responseBody.filters.filtersActive === "S")
                                            ) || (
                                                !filter ||
                                                !filter.responseBody.filters ||
                                                !filter.responseBody.filters.filtersActive
                                            ) ? true : false;
                });
            }

            function init() {
                var doInit = function () {
                    self.isLoaded = true;

                    if (angular.isDefined($scope.dataSource)) {
                        $scope.dataSource.addCriteriaProvider(self);

                        let observer = new IDataSetObserver();

                        observer.refreshed = function() {
                            $timeout(() => {
                                $scope.dataSource.gotoRow(0);
                            }, 300)
                        }

                        $scope.dataSource.addObserver(observer);
                    }

                    if (angular.isDefined($scope.datasetStandalone) && $scope.fieldNameStandalone) {
                        $scope.datasetStandalone.addObserver(self);

                        $scope.datasetStandalone.addInsertionModeListener(function () {
                            $scope.filterInfos = [];

                            refreshHasSomeActiveFilter();

                            _loadFilterPromise.resolve();
                            filterReady.ready();
                        });
                    }

                    if (!StringUtils.isEmpty(componentId)) {
                        registerInstance = SkComponentRegistry.register(self, componentId);
                    }

                    if ($scope.loadOnCreate) {
                        loadFilters();
                    }

                    AngularUtil.timeout(function () {
                        if ($scope.onFilterCreated) {
                            $scope.onFilterCreated({ $filter: _publicAPI });
                        }
                    });
                };

                if ($scope.standaloneMode) {
                    doInit();
                } else if ($attrs.skDataSource) {
                    AngularUtil.addSingleWatch($scope, 'dataSource', function (newDs) {
                        ObjectUtils.isImplementorOf(newDs, DataSource);

                        if (!$scope.entityName && angular.isFunction(newDs.getEntityName)) {
                            $scope.entityName = newDs.getEntityName();
                        }

                        if (!$scope.entityName) {
                            throw Error('[sk-personalized-filter] É obrigatório informar um entityName ou ter um entityName no DataSource');
                        }

                        newDs.addCriteriaProvider(self);

                        doInit();
                    });
                } else {
                    throw Error('[sk-personalized-filter]  Deve-se informar um dataSource.');
                }

                $scope.finalBtnApplyLabel = SkI18nService.instant($scope.btnApplyLabel || 'Geral.lblAplicar');

                $scope.$on(SkConstants.EVENTS.DESTROY, onDestroy);
                
                loadActivePersonalizedFilter();
            }

            function textToColor(description) {
                if (description) {
                    return StringUtils.textToColor(description);
                } else {
                    return '#ccc';
                }
            }
            function buildFilterNick(description) {
                if (description) {
                    description = description.trim();

                    return description.substr(0, Math.min(3, description.length));
                } else {
                    return '';
                }
            }

            function isColoredButton() {
                return !($scope.coloredButton === false);
            }

            function getButtonColor() {
                if (hasActiveFilter() && isColoredButton()) {
                    return 'btn-danger';
                } else if ($scope.btnDefault === true && !hasActiveFilter()) {
                    return 'btn-default';
                } else {
                    return 'btn-primary';
                }
            }

            function isEditingFilter(filterInfo) {
                return filterInfo.mode == 'edit' || filterInfo.mode == 'nerdEdit';
            }

            function exitFilter() {
                var deferred = $q.defer();

                if ($scope.transientFilter && ($scope.transientFilter.newItem || !angular.equals($scope.currentEditFilter, $scope.transientFilter))) {
                    MessageUtils
                        .confirm(SkI18nService.instant('FiltroPersonalizado.titulo'), SkI18nService.instant('FiltroPersonalizado.msgFecharFiltro'), SkI18nService.instant('Geral.lblSalvar'), SkI18nService.instant('Geral.lblDescartar'), true)
                        .then(function () {
                            confirmEdition(self.filterAssistentForm, $scope.currentEditFilter)
                                .then(deferred.resolve,
                                    function () {
                                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, $scope.msgAlertError);
                                        $scope.showError = false;
                                        deferred.reject();
                                    });

                        }, function (reason) {
                            if (reason === 'no') {
                                cancelEdition($scope.currentEditFilter);
                                deferred.resolve();
                            } else {
                                deferred.reject();
                            }
                        });
                } else {
                    for (var i = 0; i < $scope.filterInfos.length; i++) {
                        $scope.filterInfos[i].mode = SkFilter.MODE_DEFAULT;
                    }
                    deferred.resolve();
                }

                return deferred.promise;
            }

            function cancel() {
                exitFilter().then(function () {
                    hideContainer();
                });
            }

            function onDestroy() {
                registerInstance && registerInstance();//Removemos a instancia desse componente do controlador de instancias

                if (angular.isDefined($scope.dataSource)) {
                    $scope.dataSource.removeCriteriaProvider(self);
                }

                if (containerElem) {
                    $document.off(SkConstants.EVENTS.KEY_DOWN, keydownHandler);

                    containerElem.remove();
                }
            }

            function openFilterEdit(filter) {
                openFilter()
                    .then(function () {
                        beginEdition(filter);

                        $timeout(function () {
                            var filterContainer = containerElem.find('.filter-container');

                            var filterIndex = $scope.filterInfos.indexOf(filter);
                            var filterElement = filterContainer[0].children[filterIndex];

                            var newScroll = PositionUtils.position(filterElement).top - 5;

                            DomUtil.scrollTo(containerElem.find('.personalized-filter'), newScroll);
                        }, 0, false);
                    });
            }

            function openFilterNew() {
                openFilter()
                    .then(function () {
                        newFilter();
                    });
            }

            function openFilter() {
                var defer = $q.defer();

                if (!containerElem) {
                    createFilterContainer(defer);
                } else {
                    showContainer(defer);
                }

                return defer.promise;
            }

            function createFilterContainer(defer) {
                containerElem = angular.element('<div id="sk-filter-container-' + componentId + '" class="sk-filter-container" layout="column"></div>');

                AngularUtil.requestTemplate(templateUrl)
                    .then(function (template) {
                        containerElem.html(template);

                        containerElem = $compile(containerElem)($scope);

                        bodyElem.append(containerElem);

                        $document.on(SkConstants.EVENTS.KEY_DOWN, keydownHandler);

                        showContainer(defer);
                    }, function (result) {
                        throw new Error(result);
                    });
            }

            function hideContainer() {
                if (containerElem) {
                    containerElem.css('display', 'none');

                    bodyElem.css('overflow-y', lastDOMProperties.overflowY);

                    $document[0].scrollTop = lastDOMProperties.scrollPosition;

                    lastDOMProperties.scrollPosition = undefined;
                    lastDOMProperties.overflowY = undefined;
                }
                //Se o filtro estiver sendo usado em um popup ele esconde o popup
                if($scope.ehPopup){
                    SanPopupStack.escondePopUp(false);
                }
                resetFilterState();
            }

            function showContainer(defer) {
                if (containerElem) {
                    lastDOMProperties.scrollPosition = $document.scrollTop();
                    lastDOMProperties.overflowY = bodyElem.css('overflow-y');

                    bodyElem.css('overflow-y', 'hidden');

                    containerElem.css('display', '');

                    containerElem[0].focus();

                    $scope.states.isDropdownOpen = false;

                    if (defer) {
                        defer.resolve();
                    }
                }
                //Se o filtro estiver sendo usado em um popup ele mostra o popup
                if($scope.ehPopup){
                    SanPopupStack.escondePopUp(true);
                }
            }

            function keydownHandler(event) {
                var keycode = event.which || event.keyCode;

                if (SkConstants.KEY_CODE.ESCAPE === keycode) {
                    if (!event.isDefaultPrevented()) {
                        cancel();
                    }
                }
            }

            function applyFilter() {
                exitFilter().then(function () {
                	if ($scope.dataSource && !$scope.applyFunction) {
                        $scope.dataSource.refresh();
                    } else if ($scope.applyFunction) {
                        $scope.applyFunction();
                    }

                    hideContainer();
                    $scope.states.isDropdownOpen = false;
                });
            }

            /**
             * @ngdoc
             * @name #setResourceId
             * @methodOf snk.components.personalizedfilter.directive:sk-personalized-filter
             * @description
             * Método para alterar o resourceId do componente.
             */
            function setResourceId(resourceId) {
                $scope.resourceId = resourceId;
                loadActivePersonalizedFilter();
            }

            /**
             * @ngdoc
             * @name #clearFilters
             * @methodOf snk.components.personalizedfilter.directive:sk-personalized-filter
             * @description
             * Método para limpar os filtros;
             */
            function clearFilters() {
                if (_loadFilterPromise) {
                    _loadFilterPromise.resolve();
                }

                filterReady.ready();

                $scope.filterInfos = [];

                refreshHasSomeActiveFilter();
            }

            /**
             * @ngdoc
             * @name #loadFilters
             * @methodOf snk.components.personalizedfilter.directive:sk-personalized-filter
             * @description
             * Método para efetuar o carregamento dos filtros personalizado;
             */
            function loadFilters() {
                if (!$scope.resourceId) {
                    throw new Error('ResourceID do filtro não foi definido.');
                }

                if (_loadFilterPromise) {
                    return _loadFilterPromise;
                }

                filterReady.notReady();
                _loadFilterPromise = $q.defer();

                if($scope.unplugged){
                    _loadFilterPromise.resolve();
                    filterReady.ready();
                    return;
                }


                if ($scope.datasetStandalone && $scope.fieldNameStandalone) {
                    $scope.filterInfos = [];

                    refreshHasSomeActiveFilter();

                    _loadFilterPromise.resolve();
                    filterReady.ready();
                } else {
                    //quando há dataSource e fieldName a carga será feita no currentLinechange
                    SkFilter.callPersonalizedFilter($scope.resourceId, $scope.useSupOnlyConfig === true)
                        .then(async function (result) {
                        var filterInfos = [];
                        var filters = result.responseBody.filters;
                        let defaultFilter = result.responseBody.defaultFilter;
                        var filtersValidation = result.responseBody?.filtersValidation?.filter;

                        if (filtersValidation != null && !_isValidation) {

                            for await(var filter of filtersValidation){
                                var filterValidate = {
                                    filterModel: filter
                                };
                                _isValidation = true;
                                await doSetSelected(filterValidate);
                            }
                            setTimeout(() => {
                                loadFilters();
                            }, 200);
                        }
                 
                        //Sempre deve vir primeiro que os filtros do usuario
                        if(defaultFilter && defaultFilter.filters && defaultFilter.filters.filter){
                            let filter = defaultFilter.filters.filter;
                            
                            filter.active = true;

                            if(filter.assistent && !angular.isArray(filter.assistent.element)){
                                filter.assistent.element = [filter.assistent.element];
                                filter.assistent.element.forEach( el => el.variable = StringUtils.toBoolean(el.variable) );
                            }                            
                            

                            let newFilter = {
                                filterModel: filter,
                                standard: true
                            };                            

                            filterInfos.push(newFilter);

                            filtersMap[filter.id] = newFilter;
                        }

                        if (filters && filters.filter) {
                            // Caso o layout antigo possua filtro ativo e o layout novo não, aplicamos o filtro usado pelo layout antigo no novo
                            if (filters.active != -1 && filters.filtersActive == "N" && !filters.filter.some(f => f.active)) {
                                filters.filter.forEach(function (filter) {
                                    if (filter.id == filters.active && filter.changedFrom != 'HTML') {
                                        filter.active = true;
                                        filters.filtersActive = "S";
                                        $scope.filtersActive = true;
                                    }
                                });
                            }

                            filters.filter.forEach(function (filter) {
                                var newFilter = {
                                    filterModel: filter
                                };

                                filterInfos.push(newFilter);

                                filtersMap[filter.id] = newFilter;
                            });
                        }

                        $scope.filterInfos = filterInfos;

                        refreshHasSomeActiveFilter();

                        _loadFilterPromise.resolve();
                        filterReady.ready();
                    }).finally(function () {
                        _loadFilterPromise = undefined;
                    });
                }

                return _loadFilterPromise.promise;
            }

            /**
             * @ngdoc
             * @name #getProperties
             * @methodOf snk.components.personalizedfilter.directive:sk-personalized-filter
             * @description
             * Método para retornar um objeto na função de resolve da Promise com as propriedades:
             * - resourceId: Resource ID sendo utilizado no filtro;
             * - entityName: Nome da entidade sendo utilizado no filtro;
             * - filterInfos: Array com todos os filtros que estão sendo listados no filtro;
             *
             * @return {Promise} Retorna uma promessa que na sua função de resolve retornara o objeto citado acima.
             */
            function getProperties() {
                var deferred = $q.defer();

                deferred.resolve({
                    //dataSource: $scope.dataSource,
                    resourceId: $scope.resourceId,
                    entityName: $scope.entityName,
                    filterInfos: $scope.filterInfos,
                    fieldFilterFunction: $scope.fieldFilterFunction,
                    linkFilterFunction: $scope.linkFilterFunction
                });

                return deferred.promise;
            }

            /**
             * @ngdoc
             * @name #onCriteriaReady
             * @methodOf snk.components.personalizedfilter.directive:sk-personalized-filter
             * @description
             * Método que expõe uma promessa que é resolvida no momento em que os filtros são carregados;
             *
             * @return {Promise} Retorna uma promessa que diz se os filtros já foram carregados.
             */
            function onCriteriaReady(requestId) {
                return filterReady.whenReady(requestId);
            }

            /**
             * @ngdoc
             * @name #getCriteria
             * @methodOf snk.components.personalizedfilter.directive:sk-personalized-filter
             * @description
             * Método que retorna o critéria de acordo com os filtros configurados;
             *
             * @return {Promise} Retorna uma promessa que contém os filtros configurados.
             */
            function getCriteria(requestId) {
                let contaisDefault = getStandardFilter() != undefined;

                if (!$scope.filtersActive) {
                    $scope.hasAppliedPersFilter = false;                    
                    if(!contaisDefault) return undefined;
                }

                return $q(function (resolve, reject) {
                    onCriteriaReady(requestId).then(function () {
                        watchDatasource && watchDatasource();
                        var criteriaPromise = doGetCriteria();

                        if (criteriaPromise) {
                            $q.when(criteriaPromise).then(function (criteria) {
                                $scope.hasAppliedPersFilter = criteria && criteria.getSize() > 0;
                                $scope.appliedCriteria = criteria;
                            });
                        }

                        resolve(criteriaPromise);
                    }, reject);
                });
            }

            function getAppliedCriteria() {
                if(getActiveFilters().length > 0) {
                    return $scope.appliedCriteria;
                } else {
                    return null;
                }
            }

            function getInstance() {
                return self;
            }

            function getTypedParameterValue(type, value) {
                if (angular.isDefined(value)) {
                    if (type == 'H' || type == 'D') {
                        return DateUtils.strToDate(value);
                    } else if (type == 'N' || type == 'I') {
                        return Number(value);
                    } else {
                        return value;
                    }
                }

                return value;
            }

            function doGetCriteria() {
                var activeFilters = getActiveFilters();

                if (angular.isArray(activeFilters)) {
                    var criteria = Criteria();

                    activeFilters.forEach(function (filter) {

                        if (angular.isDefined(filter.filterModel.expression.$) && filter.filterModel.expression.$.length > 0) {
                            if (angular.isDefined(criteria.getExpression()) && criteria.getExpression().length > 0) {
                                criteria.and();
                            }

                            criteria
                                .append('(')
                                .append(filter.filterModel.expression.$)
                                .append(')');

                            if (angular.isDefined(filter.filterModel.parameters) && angular.isDefined(filter.filterModel.parameters.parameter)) {
                                angular.forEach(filter.filterModel.parameters.parameter, function (parameter) {
                                    var properties = angular.copy(parameter);
                                    properties.filterID = filter.filterModel.id;

                                    //Removemos essas propriedades, pois elas já são enviadas para o Criteria
                                    delete properties["type"];
                                    delete properties["fieldName"];

                                    criteria.addParameter(new VariableCriteriaParameter(parameter.type, parameter.fieldName, parameter.$, filter.filterModel.name, getTypedParameterValue(parameter.type, parameter.lastValue), properties));
                                });
                            }

                        }
                    });

                    if (criteria.getSize() > 0) {
                        criteria.append(' /*HAS_PERSONALIZED_FILTER*/ ');
                    }

                    if (criteria.getParameters().length > 0) {
                        var resolvedParamsFn = function (resolvedVariableParams) {
                            self.popUpParameter = undefined;

                            var params = criteria.getParameters();
                            var paramsToSave = angular.copy(criteria.getParameters());

                            resolvedVariableParams.forEach(function (item) {
                                var index = Number(item.paramIndex);
                                var currentParameter = params[index];
                                var currentParameterToSave = paramsToSave[index];

                                if (item.defaultValue) {
                                    currentParameter.value = DatasetUtils.dataToString(item.defaultValue);
                                } else {
                                    currentParameter.value = DatasetUtils.dataToString(item.value);
                                    currentParameterToSave.value = currentParameter.value;
                                }

                                currentParameter.lastValue = currentParameterToSave.lastValue = DatasetUtils.dataToString(item.lastValue);
                            });

                            saveParameters(paramsToSave);

                            return criteria;
                        };

                        var hasParameters = criteria.getParameters().length > 0;
                        var hasNullParameters = false;

                        var parameters = [];

                        angular.forEach(criteria.getParameters(), function (param, index) {
                            var variableParameter;

                            if (angular.isDefined(param.lastValue)) {
                                param.value = param.lastValue;
                            }

                            if (StringUtils.isEmpty(param.value)) {
                                hasNullParameters = true;
                            }

                            variableParameter = param.buildParam();
                            variableParameter.paramIndex = index;

                            parameters.push(variableParameter);
                        });

                        if (!hasParameters || ($scope.autoFillCriteria && !hasNullParameters)) {
                            return resolvedParamsFn(parameters);
                        } else {
                            var deferred = $q.defer();

                            if (angular.isDefined(self.popUpParameter)) {
                                deferred.reject('Popup já aberto');

                                return deferred.promise;
                            }

                            buildParameters(parameters);

                            self.popUpParameter = PopUpParameter.openPopUp(parameters, {
                                showBtnDesconsiderar: true,
                                localEntityName: $scope.entityName
                            });

                            self.popUpParameter.result.then(
                                function () {
                                    var resolvedCriteria = resolvedParamsFn(parameters);

                                    deferred.resolve(resolvedCriteria);
                                },
                                function () {
                                    self.popUpParameter = undefined;
                                    deferred.reject();
                                });

                            return deferred.promise;
                        }
                    } else {
                        return criteria;
                    }
                } else {
                    return undefined;
                }
            }

            function buildParameters(parameters) {
                var parameter;
                var properties;
                
                for (var i = 0; i < parameters.length; i++) {
                    parameter = parameters[i];
                    parameter.fieldName = undefined;
                    parameter.description = parameter.label;
                    parameter.fieldType = parameter.type;
                    parameter.required = true;
                    parameter.fieldProp = {};
					parameter.value = ((parameter.type === 'I' || parameter.type === 'F') && parameter.value === 0) ? "" : parameter.value;
                    
                    properties = parameter.properties;

                    if (properties && properties.hasOwnProperty('uiType')) {
                        if (properties.uiType === 'CB') {
                            parameter.isCheckbox = true;
                        } else if (properties.uiType === 'COMBO') {
                            parameter.fieldProp['sk-options'] = properties.options.option;
                            parameter.fieldProp['sk-opt-key'] = 'value';
                            parameter.fieldProp['sk-opt-label'] = '$';
                        } else if (properties.uiType === 'SEARCH') {
                            parameter.type = 'ENTITY';
                            parameter.dataType = parameter.type;

                            /** Essa informação é setada durante o push do VariableCriteriaParameter. 
                            	Como é removido o fieldname da propriedade, recuperamos o valor através do criteria.
                            	Essa informação é importante no skFormItem ao construir o componente
                            */
                            parameter.fieldName = parameter.name;
                            parameter.fieldProp['sk-entity-name'] = properties.searchEntity;
                            parameter.fieldProp['sk-data-type'] = parameter.fieldType;
                            parameter.fieldProp['sk-description-field-name'] = properties.descriptionField;
                            parameter.fieldProp['sk-allow-show-hierarchical-mode'] = properties.isHierarchyEntity;
                        }
                    } else if (parameter.type === 'F') {
                        parameter.fieldProp['sk-precision'] = 2;
                    }
                }
            }

            function getActiveFilters(dontMakeCopy) {
                if (angular.isArray($scope.filterInfos)) {
                    var activeFilters = [];

                    $scope.filterInfos.forEach(function (filter) {
                        if ( ($scope.filtersActive && filter.filterModel.active === true) || filter.standard ) {
                            if (dontMakeCopy === true) {
                                activeFilters.push(filter);
                            } else {
                                activeFilters.push(angular.copy(filter));
                            }

                        }
                    });

                    return activeFilters;
                } else {
                    return [];
                }
            }

            function hasActiveFilter() {
                if (angular.isArray($scope.filterInfos)) {
                    for (var i in $scope.filterInfos) {
                        if ( ($scope.filtersActive && $scope.filterInfos[i].filterModel.active === true) || $scope.filterInfos[i].standard) {
                            if($scope.filterInfos[i].filterModel.name !== "default"){
                                return true;
                            }
                        }
                    }
                }
                return false;
            }

            function saveParameters(parameters) {
                var currentParameter;
                var newParameter;
                var newParameters;
                var parametersToSave = {};
                var groupedFilters = {};

                for (var i = 0; i < parameters.length; i++) {
                    var currentParameter = parameters[i];
                    var filterId = currentParameter.properties.filterID;

                    if (!groupedFilters[filterId]) {
                        groupedFilters[filterId] = [];
                    }

                    groupedFilters[filterId].push(currentParameter);
                }

                parametersToSave.parameters = [];

                for (var filterID in groupedFilters) {
                    var groupedParameters = groupedFilters[filterID];

                    newParameters = {};
                    newParameters.resourceID = $scope.resourceId;
                    newParameters.filterID = filterID;
                    newParameters.parameter = [];
                    newParameters.useSupOnlyConfig = $scope.useSupOnlyConfig === true ? 'S' : 'N';

                    for (var i = 0; i < groupedParameters.length; i++) {
                        currentParameter = groupedParameters[i];
                        var filterId = currentParameter.properties.filterID;

                        newParameters.parameter.push(
                            {
                                'type': currentParameter.type,
                                'fieldName': currentParameter.name,
                                'lastValue': currentParameter.lastValue,
                                'value': currentParameter.value,
                                'entityName': currentParameter.properties.entityName,
                                '$': currentParameter.properties['$']
                            }
                        );

                        //Nesse momento fazemos a atualização do último valor na nossa coleção de filtros original,
                        //caso isso não seja feito, os filtros em memória não vai conter o lastValue real na próxima aplicação de filtro.
                        var cachedParameter = ObjectUtils.getProperty(filtersMap, filterId + '.filterModel.parameters.parameter');

                        if (cachedParameter && cachedParameter[i]) {
                            cachedParameter[i].lastValue = currentParameter.lastValue;
                        }
                    }

                    parametersToSave.parameters.push(newParameters);
                }


                ServiceProxy.callService(
                    'PersonalizedFilter.saveParametersFromJson',
                    { data: parametersToSave },
                    { preventTransform: true },
                    { useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N' }
                ).then(function () {
                    SkFilter.invalidateFilterCache($scope.resourceId, $scope.useSupOnlyConfig);
                });
            }

            function refreshHasSomeActiveFilter() {
                $scope.hasSomeActiveFilter = $scope.filtersActive && hasActiveFilter();
            }

            function setSelected(filterInfo) {
                if(filterInfo && filterInfo.filterModel && $scope.onlyOneSelection){
                    filterInfo.filterModel.onlyOneSelection = $scope.onlyOneSelection;
                }
                
                if ($scope.beforeSaveAction) {
                    var result = $scope.beforeSaveAction({
                        $filter: self,
                        $filterModel: filterInfo
                    });

                    if (angular.isUndefined(result) || result == true) {
                        doSetSelected(filterInfo);
                    } else if (result === false) {
                        filterInfo.filterModel.active = !filterInfo.filterModel.active;
                        refreshHasSomeActiveFilter();
                    } else {
                        $q.when(result, function () {
                            notifyChange(filterInfo);
                            doSetSelected(filterInfo);
                        }, function () {
                            filterInfo.filterModel.active = !filterInfo.filterModel.active;
                            refreshHasSomeActiveFilter();
                        });
                    }
                } else {
                    notifyChange(filterInfo);
                    doSetSelected(filterInfo);
                }
            }

           async function doSetSelected(filterInfo) {
                var defer = $q.defer();
                if (angular.isDefined($scope.datasetStandalone) && $scope.fieldNameStandalone) {
                    var filters = [];
    
                    $scope.filterInfos.forEach(function (filter) {
                        filters.push(filter.filterModel);
                    });
    
                    var newFilter = {
                        id: $scope.resourceId,
                        active: 0,
                        filter: filters
                    };

                    $scope.datasetStandalone.setFieldValue($scope.fieldNameStandalone, JSON.stringify(newFilter));

                    refreshHasSomeActiveFilter();
                }else{

                    var filterRequest = {
                        resourceId: $scope.resourceId,
                        entityName: $scope.entityName,
                        useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N'
                    };
                    angular.extend(filterRequest, filterInfo.filterModel);
                    
                    refreshHasSomeActiveFilter();

                    if((filterRequest.active === true && filterRequest.authorizationStatus !== 'L') || filterRequest.validateSecurity){
                       await validateFilterSecurity(filterInfo, filterRequest, dosetSelectedFilter, null, null)
                        defer.resolve();
                    }else{
                        dosetSelectedFilter(filterRequest,null,null,filterInfo);
                    }
                }
                return defer.promise;
            }

            function dosetSelectedFilter(filterRequest, status, descricao, filter){
                
                if($scope.unplugged){
                    loadFilters();
                    return;
                }

                angular.extend(filterRequest, filter.filterModel);
                filterRequest['changedFrom'] = 'HTML';

                ServiceProxy.callService('PersonalizedFilter.setSelectedFilter', {
                    filter: filterRequest,
                    status: status,
                    descricao: descricao,
                    validateFilter: _validateFilter
                }).then(function (result) {
                   var filtersReturn = result.responseBody.filters.filter;
                  
                   if(filtersReturn?.length > 0){
                        var retorno = filtersReturn.filter( item => item.id == filter.filterModel.id);
                       filter.filterModel.authorizationStatus = retorno[0].authorizationStatus;
                       if(_isValidation){
                        loadFilters();
                       }
                   }else{
                       filter.filterModel.authorizationStatus = filtersReturn.authorizationStatus;
                   }
            }).catch(function (error) {
                loadFilters();
        })
        }

            function deselectAllFilters() {
                if (getActiveFilters(true).length > 0) {
                    if ($scope.beforeSaveAction) {
                        var result = $scope.beforeSaveAction({
                            $filter: self
                        });

                        if (angular.isUndefined(result) || result == true) {
                            doDeselectAllFilters();
                        } else if (result != false) {
                            $q.when(result, function () {
                                doDeselectAllFilters();
                            });
                        }
                    } else {
                        doDeselectAllFilters();
                    }
                }
            }

            function doDeselectAllFilters() {
                var activeIds = [];

                getActiveFilters(true).forEach(function (filter) {
                    filter.filterModel.active = false;
                    activeIds.push(filter.filterModel.id);
                });

                refreshHasSomeActiveFilter();

                if (activeIds.length == 0) {
                    return;
                }

                ServiceProxy.callService('PersonalizedFilter.deselectAllFilters', {
                    filter: {
                        resourceId: $scope.resourceId,
                        useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N'
                    }
                }).then(angular.noop,
                    function () {
                        if (activeIds.length > 0) {
                            var id;

                            while (id = activeIds.pop()) {
                                for (var i = 0, len = $scope.filterInfos.length; i < len; i++) {
                                    var filter = $scope.filterInfos[i];

                                    if (filter.filterModel.id == id) {
                                        filter.filterModel.active = true;
                                        break;
                                    }
                                }
                            }
                        }

                        refreshHasSomeActiveFilter();
                    });
            }

            function beginEdition(filter) {

                // O metodo BeginEdition é utilizando tanto para criação de um novo filtro quanto para edição de um existe.
                // Quando você clica para adicionar um novo filtro, e em seguida clica para editar, era adicionado um novo filtro na lista
                // com nenhuma informação quebrando o filtro. 
                // A condição abaixo tras a inserção do novo filtro nesse método, retirando do newFilter(). Se não for um novo filtro, é 
                // validado se a lista tem como primeiro item um novo filtro (adicionado anteriormente). 
                // Se a condição for verdadeira, ele cancela a edição do novo filtro apenas.

                var filterRequest = {
                    resourceId:  getResourceID(filter),
                };

                angular.extend(filterRequest, filter.filterModel);
                
                ServiceProxy.callService('PersonalizedFilter.checkFilterValidationStatus', {
                    filter: filterRequest
                }).then((response)=> {
                    if(response?.responseBody?.validado){
                        return dobeginEdition(filter);
                    }
                })
            }

            function dobeginEdition(filter) {
                if (filter.newItem) {
                    ArrayUtils.insertAtIndex($scope.filterInfos, 0, filter);
                } else {
                    if ($scope.filterInfos[0].newItem) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, SkI18nService.instant('FiltroPersonalizado.msgEditAfterAdd'));
                        return;
                    }
                }

                for (var i = 0; i < $scope.filterInfos.length; i++) {
                    $scope.filterInfos[i].mode = SkFilter.MODE_DEFAULT;
                }

                if (filter.filterModel.assistent || filter.newItem) {
                    filter.mode = SkFilter.MODE_ASSISTENT;
                } else {
                    filter.mode = SkFilter.MODE_EXPRESSION;
                }

                if (filter.filterModel.assistent && filter.filterModel.assistent.element) {
                    var element;

                    for (var i = 0; i < filter.filterModel.assistent.element.length; i++) {
                        element = filter.filterModel.assistent.element[i];

                        if ('F-I'.indexOf(element.type) > -1) {
                            var newValue = NumberUtils.stringToNumber(element.value);

                            if (!isNaN(newValue)) {
                                element.value = newValue;
                            }
                        }
                    }
                }

                $scope.transientFilter = cloneObject(filter);
                $scope.currentEditFilter = filter;
            }

            function deleteFilter(filterInfo) {
                removeFilter(filterInfo, function (filter) {
                    var index = $scope.filterInfos.indexOf(filter);
                    $scope.filterInfos.splice(index, 1);
                });
            }

            function confirmDelete(filterInfo) {
                MessageUtils
                    .simpleConfirm(SkI18nService.instant('FiltroPersonalizado.lblTitleConfirmExclusao'), SkI18nService.instant('FiltroPersonalizado.msgConfirmarExclusao')).then(function () {
                        deleteFilter(filterInfo);
                    });
            }

            function confirmEdition(form, filter) {
                var deferred = $q.defer();
                var resultDoConfirm;

                if ($scope.beforeSaveAction) {
                    var result = $scope.beforeSaveAction({
                        $filter: self,
                        $filterModel: filter
                    });

                    if (angular.isUndefined(result) || result == true) {
                        resultDoConfirm = doConfirmEdition(form, filter);
                        resultDoConfirm.then(deferred.resolve, deferred.reject);
                    } else if (result === false) {
                        cancelEdition();
                    } else {
                        $q.when(result, function () {
                            resultDoConfirm = doConfirmEdition(form, filter);
                            resultDoConfirm.then(deferred.resolve, deferred.reject);
                        }, function () {
                            cancelEdition();
                        });
                    }
                } else {
                    resultDoConfirm = doConfirmEdition(form, filter);
                }

                resultDoConfirm && resultDoConfirm.then(deferred.resolve, deferred.reject);

                return deferred.promise;
            }

            function doConfirmEdition(formId, filter) {
                var deferred = $q.defer();
                let form = $scope.forms[formId];

                if (form && (form.$dirty || $scope.transientFilter.dirty || $scope.transientFilter.newItem || !angular.equals(filter, $scope.transientFilter))) {
                    var expression = $scope.transientFilter.filterModel.expression;
                    var assistent = $scope.transientFilter.filterModel.assistent;

                    if (angular.isUndefined($scope.transientFilter.filterModel.name)) {
                        showErrorMessage(SkI18nService.instant('FiltroPersonalizado.msgNomeNaoInformado'));
                        deferred.reject();
                        return deferred.promise;
                    }

                    if (form.$valid && (expression || assistent)) {
                        filter.filterModel.name = $scope.transientFilter.filterModel.name;

                        if (angular.isDefined(assistent) && filter.mode == SkFilter.MODE_ASSISTENT) {
                            try {
                                SkFilter.buildExpression($scope.transientFilter);

                                var newExpression = $scope.transientFilter.filterModel.expression && $scope.transientFilter.filterModel.expression.$;

                                if (StringUtils.isEmpty(newExpression)) {
                                    showErrorMessage(SkI18nService.instant('FiltroPersonalizado.msgFiltroSemAssisExp'));
                                    deferred.reject();
                                    return deferred.promise;
                                } else if (!isValidAllowVariable(newExpression)) {
                                    deferred.resolve();
                                    return deferred.promise;
                                }

                                filter.filterModel.assistent = cloneObject($scope.transientFilter.filterModel.assistent);
                                filter.filterModel.expression = cloneObject($scope.transientFilter.filterModel.expression);
                            } catch (e) {
                                showErrorMessage(e.message);
                                deferred.reject();
                                return deferred.promise;
                            }
                        } else if (angular.isDefined(expression) && filter.mode == SkFilter.MODE_EXPRESSION) {
                            if (!isValidAllowVariable(expression['$'])) {
                                deferred.resolve();
                                return deferred.promise;
                            }

                            filter.filterModel.expression = expression;

                            if (!assistent && filter.filterModel.hasOwnProperty('assistent')) {
                                delete filter.filterModel.assistent;
                            } else if (assistent) {
                                filter.filterModel.assistent = cloneObject(assistent);
                            }
                        } else {
                            showErrorMessage(SkI18nService.instant('FiltroPersonalizado.msgFiltroSemAssisExp'));
                            deferred.reject();
                            return deferred.promise;
                        }

                        saveFilter(filter,
                            function (result) {
                                if (filter.newItem) {
                                    $scope.forms[filter.filterModel.id] = angular.copy($scope.forms[undefined]);
                                }
                                if($scope.afterSaveAction){
									$scope.afterSaveAction({
					                    $filter: self,
					                    $filterModel: filter
					                });
                                }
                                filter.mode = SkFilter.MODE_DEFAULT;
                                filter.newItem = false;
                                resetFilterState();
                            }).then(deferred.resolve, deferred.reject);
                    } else {
                        if (!form.$valid) {
                            showErrorMessage(msgErrorsInForm);
                        } else if (angular.isDefined($scope.transientFilter) && !($scope.transientFilter.filterModel.expression || $scope.transientFilter.filterModel.assistent)) {
                            showErrorMessage(msgFilterContainsExpression);
                        }

                        deferred.reject();
                        return deferred.promise;
                    }
                } else {
                    filter.mode = SkFilter.MODE_DEFAULT;
                    resetFilterState();
                    deferred.resolve();
                }

                return deferred.promise;
            }

            function onToggleAllFilters() {
            	saveActivePersonalizedFilter();
                refreshHasSomeActiveFilter();
            }

            function isValidAllowVariable(expressao) {
                expressao = expressao || '';

                if (!$scope.allowVariable && expressao.indexOf("?") > -1) {
                    showErrorMessage(SkI18nService.instant('Controls.Filter.messageNaoPermiteVariavel'));
                    return false;
                }

                return true;
            }

            function showErrorMessage(msg) {
                $scope.msgAlertError = msg;
                $scope.showError = true;
            }

            function hideErrorMessage() {
                $scope.showError = false;
            }

            function cancelEdition(filter) {
                filter = filter || $scope.currentEditFilter;

                $scope.transientFilter = undefined;
                $scope.currentEditFilter = undefined;

                var newItemToRemove = ArrayUtils.find($scope.filterInfos, function (item) { return item.newItem });

                if (newItemToRemove) {
                    ArrayUtils.removeReference($scope.filterInfos, newItemToRemove, true);
                } else {
                    if(filter.mode){
                        filter.mode = SkFilter.MODE_DEFAULT;
                    }
                }

                hideErrorMessage();
            }

            function newFilter(hasStandard) {
                var newfilter = {
                    newItem: true,
                    filterModel: {}
                };

                if(hasStandard) {
                    newfilter.standard = true;
                    newfilter.filterModel.name = 'default';
                }
                
                beginEdition(newfilter);
            }

            function resetFilterState() {
                $scope.transientFilter = undefined;
                $scope.itemEdit = false;
                $scope.currentEditFilter = undefined;

                hideErrorMessage();
            }

            function validateFilterSecurity( filter, filterRequest, popupCallback, saveCallback, deferred) {
                var defer = $q.defer();

               ServiceProxy.callService('PersonalizedFilter.validateFilterSecurity', {
                    filter: filterRequest
                }).then(function (result) {

                    _validateFilter = result.responseBody.validate;

                    if(_validateFilter){
                        SanPopup.open({
                            templateUrl: 'components/personalizedfilter/templates/validate-filter-popup.tpl.html',
                            controller: 'ValidateFilterPopUpController',
                            controllerAs: 'ctrl',
                            title: SkI18nService.instant('FiltroPersonalizado.tituloPopupValidateFilter'),
                            size: 'md',
                            windowClass: 'personalized-filter-modal',
                            type: 'warning',
                            okBtnClass: 'btn-primary',
                            height: filter.filterModel.validateSecurity || !filter.mode ? 250 : 160,
                            okBtnLabel: SkI18nService.instant('Geral.lblEnviar'),
                            cancelBtnLabel: SkI18nService.instant('Geral.lblCancelar'),
                            resolve: {
                                data:{
                                    validateSecurity: filter.filterModel.validateSecurity,
                                    nomeFiltro: filter.filterModel.name,
                                    expressao: filter.filterModel.expression.$,
                                    mode: filter.mode
                                }
                            }
                        }).result.then(function (descricao) {
                            popupCallback(filterRequest,"P", descricao, filter, saveCallback, deferred)
                            defer.resolve();
                        },
                        function (cancel) {
                            if(filter.filterModel.authorizationStatus != 'L'){
                                filter.filterModel.active = false;
                            }
                            cancelEdition(filter);
                            loadFilters();
                            defer.resolve();
                        });
                    }else{
                        var statusFilter = filter.filterModel.authorizationStatus == undefined ? "L" : filter.filterModel.authorizationStatus;
                        popupCallback(filterRequest,statusFilter , null,filter, saveCallback, deferred)
                    }
                }).catch(function (error) {
                    if(error){
                        loadFilters();
                    }
                })
                return defer.promise;
            }

            function saveFilter(filter, saveCallback) {
                var deferred = $q.defer();

                var filterRequest = {
                    resourceId:  getResourceID(filter),
                    entityName: $scope.entityName,
                    useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N'
                };
                angular.extend(filterRequest, filter.filterModel);
                validateFilterSecurity(filter, filterRequest, doSaveFilter, saveCallback, deferred);
                return deferred.promise;
            }

            function doSaveFilter(filterRequest, status, descricao, filter, saveCallback, deferred){
                
                if($scope.unplugged){
                    ServiceProxy.callService('PersonalizedFilter.standAloneSave', {
                        filter: filterRequest,
                        status: status,
                        descricao: descricao
                    }).then(function (result) {
                        if (angular.isDefined(saveCallback)) {
                            saveCallback(result.responseBody.filter);
                        }
                        SkFilter.invalidateFilterCache(getResourceID(filter), $scope.useSupOnlyConfig);
                        deferred.resolve();
                    });
                } else if ($scope.datasetStandalone && $scope.fieldNameStandalone) {
                    var filters = [];

                    $scope.filterInfos.forEach(function (filter) {
                        filters.push(filter.filterModel);
                    });
                    
                    var newFilter = {
                        id: $scope.resourceId,
                        active: 0,
                        filter: filters
                    };

                    $scope.datasetStandalone.setFieldValue($scope.fieldNameStandalone, JSON.stringify(newFilter));

                    if (angular.isDefined(saveCallback)) {
                        saveCallback(filter);
                    }

                    deferred.resolve();

                } else {

                    ServiceProxy.callService('PersonalizedFilter.saveFilter', {
                        filter: filterRequest,
                        status: status,
                        descricao: descricao
                    }).then(function (result) {
                        SkFilter.invalidateFilterCache(getResourceID(filter), $scope.useSupOnlyConfig);

                        var responseFilter = result.responseBody.filter;

                        filter.filterModel.parameters = responseFilter.parameters;
                        filter.filterModel.active = responseFilter.active;
                        filter.filterModel.id = responseFilter.id;
                        filter.filterModel.authorizationStatus = responseFilter.authorizationStatus;

                        filtersMap[responseFilter.id] = filter;

                        if (MGEParameters.asBoolean("global.ordenar.filtros.personalizados")) {
                            $scope.filterInfos.sort(function (a, b) {
                                var aName = String(ObjectUtils.getProperty(a, 'filterModel.name')).toLowerCase();
                                var bName = String(ObjectUtils.getProperty(b, 'filterModel.name')).toLowerCase();

                                if(a.standard){
                                    return -1;
                                }

                                if(b.standard){
                                    return 1;
                                }

                                return aName === bName ? 0 : (aName < bName ? -1 : 1);
                            });
                        }

                        /* Notifica o dynaform que um novo filtro padrão foi criado */                        
                        if(filter.standard){
                        	$scope.$root.$emit('$dynaform.changeDefaultFilterExpression', ObjectUtils.getProperty(filter, 'filterModel.expression.$'));

                            if(angular.isDefined($scope.dataSource)){
                                $scope.dataSource.refresh();
                            }
                        }

                        if (angular.isDefined(saveCallback)) {
                            saveCallback(filter);
                        }

                        deferred.resolve();

                    }, deferred.reject).catch(function (error) {
                        loadFilters();
                        cancelEdition(filter);
                })
                }
            }

            function removeFilter(filter, deleteCallback) {

                if ($scope.datasetStandalone && $scope.fieldNameStandalone) {

                    if (angular.isDefined(deleteCallback)) {
                        deleteCallback(filter);
                    }
                    var filters = [];
                    $scope.filterInfos.forEach(function (filter) {
                        filters.push(filter.filterModel);
                    });
                    var newFilter = {
                        id: $scope.resourceId,
                        active: 0,
                        filter: filters
                    };
                    $scope.datasetStandalone.setFieldValue($scope.fieldNameStandalone, JSON.stringify(newFilter));
                } else {
                    ServiceProxy.callService('PersonalizedFilter.removeFilter', {
                        filters: {
                            resourceId: getResourceID(filter),
                            useSupOnlyConfig: $scope.useSupOnlyConfig === true ? 'S' : 'N',
                            filter: [
                                {
                                    id: filter.filterModel.id,
                                    authorizationStatus: filter.filterModel.authorizationStatus
                                }
                            ]
                        }
                    }).then(function (result) {
                        SkFilter.invalidateFilterCache(getResourceID(filter), $scope.useSupOnlyConfig);
                    	/* Notifica o dynaform que o filtro padrão foi deletado */                        
                        if(filter.standard){
                        	$scope.$root.$emit('$dynaform.changeDefaultFilterExpression', undefined);

                        	if(angular.isDefined($scope.dataSource)){
                                $scope.dataSource.refresh();
                            }
                        }

                        angular.extend(filter.filterModel, result.responseBody.filter);

                        if (angular.isDefined(deleteCallback)) {
                            deleteCallback(filter);
                        }
                        //$scope.hasAppliedPersFilter = hasActiveFilter();
                    }).catch(function (error) {
                        loadFilters();
                })
                }
            }

            function cloneObject(obj) {
                if (obj == null || typeof (obj) != 'object' || (obj instanceof Date)) {
                    return obj;
                }

                var newObject = obj.constructor();

                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        newObject[key] = cloneObject(obj[key]);
                    }
                }

                return newObject;
            }

            function startTour() {
                if (!$scope.showTour) {
                    $scope.showTour = true;
                    initTour();
                }

                $scope.tour.startTour = true;
            }

            function initTour() {
                $scope.tour = PersonalizedFilterTourContent.getPersonalizedFilterTourContent(self, containerElem, $scope);
            }
            
            function getFilterName(filter){
                //TODO: Colocar o label com i18n
                if(filter.standard){
                    return 'Filtro Padrão';
                }
                return filter.filterModel.name;
            }

            function getResourceID(filter){
                if(filter.standard){
                    return $scope.resourceId +  '_default';
                }

                return $scope.resourceId;
            }

            function getDefaultFilterToolTip(){
                let hasStandardFilter = getStandardFilter() != undefined;
                //TODO: Internacionalizar
                if(hasStandardFilter){
                    return 'Editar filtro padrão';
                }else{
                    return 'Adicionar filtro padrão'
                }
            }

            function getStandardFilter(){
                for(var i = 0; i < $scope.filterInfos.length; i++){
                    if($scope.filterInfos[i].standard) return $scope.filterInfos[i];
                }

                return undefined;
            }

            function openFilterDefault(){
                let standardFilter = getStandardFilter();
                if(standardFilter){
                    openFilterEdit(standardFilter);
                }else{
                    newFilter(true);
                }
            }

            function toggleList(){
                $scope.showList = !$scope.showList;
            }

            function countActiveFilters(){
                if($scope.filtersActive && $scope.filterInfos){
                    return $scope.filterInfos.filter(function (filter) {
                        return filter.filterModel.active === true && !filter.standard;
                    }).length;

                }else{
                    return 0;
                }                
            }

            function notifyChange(filterInfo){
                if($scope.onSelectionChanged){
                    $scope.onSelectionChanged({selection: filterInfo, filterList: $scope.filterInfos});
                }
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.personalizedfilter.directive:sk-personalized-filter
 * @restrict E
 * @scope
 * @description
 * Componente para utilização de filtros personalizados nas telas em HTML5.
 * Ele é composto por um botão e quando aberto o mesmo sobrepõe um stack sobre toda a aplicação com os filtros personalizados daquela tela.
 *
 * @param {DataSource} sk-data-source Objeto para informar a fonte de dados do filtro, que pode ser um dataset ou qualquer classe que implemente o {@link util.common.interface:DataSource DataSource}.
 * @param {string} sk-resource-id Resource ID para ser utilizado no momento de salvar o filtro e também no momento de fazer a carga do mesmo.
 * @param {string=} [sk-entity-name=undefined] Nome da entidade para ser utilizado na carga e salvamento de informações. Quando esse parametro não
 * é informado, o filtro tenta acessar uma função denominada de getEntityName do DataSource repassado.
 *
 * @param {function=} [sk-apply-function=refresh()] Função utilizada pelo Filtro que é chamada no momento em que o usuário aplicar o filtro. Caso essa
 * função não seja informada, o filtro assume como padrão a função {@link util.common.interface:DataSource refresh()} da interface DataSource.
 *
 * @param {string=} [sk-auto-fill-criteria=false] Booleano utilizado para mostrar
 * o {@link snk.components.popupparameter.service:PopUpParameter PopUpParameter} com os filtros ativos e variáveis. Por
 * padrão esse booleano só é utilizado quando o próprio filtro não consegue prever a abertura do {@link snk.components.popupparameter.service:PopUpParameter PopUpParameter}.
 *
 * @param {string=} [id] ID utilizado para efetuar o registro de instância dos métodos publicos do controlador do filtro (Para ver todos os métodos, {@link snk.components.personalizedfilter.directive:sk-personalized-filter#methods clique aqui}).
 * Com isso, conseguimos pegar a instância do filtro apartir do ID em qualquer outro componente/controllador.
 *
 * @param {function} [sk-field-filter-function=undefined] Função que pode ser passada ao componente para filtrar os campos que serão apresentados no popup de seleção de campos.
 *
 * @param {function} [sk-link-filter-function=undefined] Função que pode ser passada ao componente para filtrar as ligações que serão apresentados no popup de seleção de campos.
 *
 * @param {boolean=} [sk-load-on-create=true] Força o carregamento dos filtros logo após a criação do componente.
 * 
 * @param {string} [sk-field-name-standalone = nome do campo] Nome do campo presente no sk-dataset-standalone para ser utilizado no momento de salvar o filtro e também no momento de fazer a carga do mesmo.
 * 
 * @param {string=} [sk-dataset-standalone=nome do dataset] Define o dataset standalone que o campo personalized-filter pertence. 
 *
 * @param {string} [sk-tooltip-apply=undefined] Nesse parametro deve ser informado o tooltip do botão aplicar.
 * 
 * @param {function} [sk-before-save-action] Esta função tem finalidade de executar alguma validação antes de salvar as informações do filtro personalizado.
 * 
 * @param {function} [sk-after-save-action] Esta função tem finalidade de executar alguma validação após salvar as informações do filtro personalizado.
 * 
 * @param {boolean} [parameter-popup-on-body] Caso true, a popup de parametros sempre será renderizada no body (em frente de todos os paineis), caso contrario, ele buscará o Parent e renderizará nele (ex: personalized-filter está dentro de uma popup).
 * 
 * 
 * @example
    <example>
        <file name="exemplo.html">
            <p>Esse componente não possui demo, pois ele é um componente comum de nossas telas e não existe a possibilidade de apresentação nesse contexto.</p>
        </file>
    </example>
 */
angular
    .module('snk.components.personalizedfilter')
    .directive('skPersonalizedFilter', ['$compile', 'AngularUtil', function ($compile, AngularUtil) {
        return {
            restrict: 'E',
            scope: {
            	personalizedFilterApi: '=?skPersonalizedFilterApi',
                dataSource: '=skDataSource',
                standaloneMode: '=skStandaloneMode',
                showDropdownFilter: '=skShowDropdownFilter',
                coloredButton: '=skColoredButton',
                resourceId: "@skResourceId",
                entityName: '@?skEntityName',
                applyFunction: '&?skApplyFunction',
                autoFillCriteria: '@?skAutoFillCriteria',
                id: '@?',
                loadOnCreate: '@?skLoadOnCreate',
                allowVariable: '=?skAllowVariable',
                hideApply: '=?skHideApply',
                btnDefault: '=?skBtnDefault',
                hasAppliedPersFilter: '=?skHasActivePersFilter',
                hasSomeActiveFilter: '=?skHasSomeActiveFilter',
                fieldFilterFunction: '=skFieldFilterFunction',
                linkFilterFunction: '=skLinkFilterFunction',
                onFilterCreated: '&?skOnFilterCreated',
                beforeSaveAction: '&?skBeforeSaveAction',
                afterSaveAction: '&?skAfterSaveAction',
                onSelectionChanged: '&?skOnSelectionChanged',
                ignoreServices: '@skIgnoreServices',
                expandedMode: '=skExpandedMode',
                btnApplyLabel: '@?skBtnApplyLabel',
                useSupOnlyConfig: '=?skUseSupOnlyConfig',
                hideFilter: '=?skHideFilter',
                fieldNameStandalone: '@?skFieldNameStandalone',
                datasetStandalone: '=skDatasetStandalone',
                ehPopup: '=?skEhPopup',
                inPopupMode: '=?skInPopupMode',
                compactMode: '=skCompactMode',
                tooltipApply: '@?skTooltipApply',
                onlyOneSelection: '=?skOnlyOneSelection',
                parameterPopupOnBody: '=?parameterPopupOnBody',
                unplugged: '=?skUnplugged'
            },
            controller: 'PersonalizedFilterController',
            controllerAs: 'ctrl',
            link: function(scope, element) {
                var templateUrl = 'components/personalizedfilter/templates/';

                if (scope.expandedMode || scope.compactMode) {
                    templateUrl += 'personalized-filter-expanded.tpl.html';
                } else if (scope.inPopupMode){
                    templateUrl += 'personalized-filter-inpopupmode.tpl.html'
                } else {
                    templateUrl += 'personalized-filter.tpl.html';
                }

                AngularUtil
                    .requestTemplate(templateUrl)
                    .then(function(template) {
                        var content = angular.element(template);
                        element.append(content);
                        $compile(content)(scope);
                    });
            }
        };
    }]);
angular
    .module('snk.components.personalizedfilter')
    .service('PersonalizedFilterTourContent',['AngularUtil','$translate',
        function(AngularUtil,$translate) {
            var self = this;

            self.getPersonalizedFilterTourContent = getPersonalizedFilterTourContent;

            function getPersonalizedFilterTourContent(personalizedFilterController, element, scope) {
                return {
                    startTour: true,
                    options: {
                        startNode: element,
                    },
                    onFinish: function(){
                        //Não faz nada, deixa os processo de inclusão iniciado para facilitar a inclusão de um novo filtro
                        //para o usuário
                    },
                    tourConfig: [
                        {
                            type: "title",
                            heading: $translate.instant('FiltroPersonalizado.titulo'),
                            templateUrl: 'components/personalizedfilter/tour/templates/intro.tpl.html',
                            placement: "center",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleAddFilter'),
                            selector: "#btn-novo-pers-filter",
                            templateUrl: 'components/personalizedfilter/tour/templates/btnNewFilter.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "function",
                            fn: function (next) {
                                if (next) {
                                    personalizedFilterController.newFilter();
                                } else {
                                    personalizedFilterController.cancelEdition();
                                }
                            }
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleFilterName'),
                            selector: "#pers-filter-nome-filtro",
                            templateUrl: 'components/personalizedfilter/tour/templates/inputFilterName.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleAdvancedMode'),
                            selector: "#pers-filter-btn-modo-avancado",
                            templateUrl: 'components/personalizedfilter/tour/templates/btnAdvancedMode.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titlePreviewExpression'),
                            selector: "#pers-filter-btn-preview",
                            templateUrl: 'components/personalizedfilter/tour/templates/btnPreviewExpression.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleAddCondition'),
                            selector: "#pers-filter-add-condition",
                            templateUrl: 'components/personalizedfilter/tour/templates/btnAddCondition.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "function",
                            fn: function (next) {
                                if (next) {
                                    var element = angular.element(document.querySelector('filter-assistent'));
                                    var controller = AngularUtil.getControllerFromElement(element);
                                    if(controller) {
                                        controller.addNewFilter();
                                    }
                                } else {
                                    var element = angular.element(document.querySelector('filter-assistent'));
                                    var controller = AngularUtil.getControllerFromElement(element);
                                    if(controller) {
                                        controller.removeFilter(controller.getElement());
                                    }
                                }
                            }
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleSelectField'),
                            selector: "#pers-filter-field-name",
                            templateUrl: 'components/personalizedfilter/tour/templates/lblSelectedField.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleSelectTheOperator'),
                            selector: "#pers-filter-operator",
                            templateUrl: 'components/personalizedfilter/tour/templates/inputSelectOperator.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleDefaultValue'),
                            selector: "#pers-filter-field-value",
                            templateUrl: 'components/personalizedfilter/tour/templates/inputDefaultValue.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleVariableValue'),
                            selector: "#pers-filter-cbx-variavel",
                            templateUrl: 'components/personalizedfilter/tour/templates/cbxVariableValue.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true,
                            isEnabled: function() {
                                return scope.allowVariable;
                            }
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleAddParantheses'),
                            selector: "#pers-filter-btn-add-paranthesis",
                            templateUrl: 'components/personalizedfilter/tour/templates/btnAddParentheses.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "element",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleRemoveCondition'),
                            selector: "#pers-filter-btn-remove-filter",
                            templateUrl: 'components/personalizedfilter/tour/templates/btnRemoveCondition.tpl.html',
                            placement: "bottom",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "title",
                            heading: $translate.instant('FiltroPersonalizado.tour.titleNewFilters'),
                            templateUrl: 'components/personalizedfilter/tour/templates/titleNewFilters.tpl.html',
                            placement: "center",
                            scroll: false,
                            attachToBody: true
                        },
                        {
                            type: "title",
                            heading: $translate.instant('FiltroPersonalizado.titulo'),
                            templateUrl: 'components/personalizedfilter/tour/templates/titleLastMessage.tpl.html',
                            placement: "center",
                            scroll: false,
                            attachToBody: true
                        }
                    ]
                }
            }
        }
    ]);
angular
    .module('snk.components.personalizedfilter')
    .controller('ValidateFilterPopUpController', ['$scope', '$popupInstance', 'StringUtils', 'MessageUtils','i18n', 'data',
        function ($scope, $popupInstance, StringUtils, MessageUtils, i18n, data) {
            var self = this;

            $scope.$success = success;
            $scope.$dismiss = dismiss;
            self.value;
            self.textPopup = i18n('FiltroPersonalizado.msgSolicitacaoLiberacaoFiltro', {nomeFiltro: data.nomeFiltro});
            self.expressao = data.expressao;
            self.enableExpressao = false;
            $scope.toggleExpressao = toggleExpressao;
            self.validateSecurity = data.validateSecurity;
            self.mode = data.mode;
            self.lblTooltip = i18n('FiltroPersonalizado.lblMostrarExpressao');

            init();
            function init(){
                self.visualizar = 'N';
            }

            function success() {
                if(StringUtils.isEmpty(self.value)){
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('FiltroPersonalizado.msgDescricaoObrigatoria'));
                    return;
                }

                $popupInstance.success(StringUtils.emptyAsUndefined(self.value));
            }
            
            function toggleExpressao(){
                if(!self.enableExpressao){
                    self.enableExpressao = true;
                    self.lblTooltip = i18n('FiltroPersonalizado.lblEsconderExpressao');
                }else{
                    self.enableExpressao = false;
                    self.lblTooltip = i18n('FiltroPersonalizado.lblMostrarExpressao');
                }
            }

            function dismiss() {
                $popupInstance.dismiss();
            }

        }]);
angular
    .module('snk.components.personalizedfilter')
    .controller('VariableParamterConfigPopUpController', ['$scope', '$timeout', '$popupInstance', 'SkI18nService', 'SkFilter', 'StringUtils', 'Criteria', 'parameter', function ($scope, $timeout, $popupInstance, SkI18nService, SkFilter, StringUtils, Criteria, parameter) {
        var self = this;

        $scope.$success = success;


        self.parameter = parameter;
        self.buildExpression = buildExpression;
        self.getFieldEnviromentCriteria = getFieldEnviromentCriteria;
        self.getEntityEnviromentCriteria = getEntityEnviromentCriteria;

        self.dataTypeOptions = [
            {data: 'S', value: SkI18nService.instant('Geral.lblfieldTypes.S')},
            {data: 'I', value: SkI18nService.instant('Geral.lblfieldTypes.I')},
            {data: 'F', value: SkI18nService.instant('Geral.lblfieldTypes.F')},
            {data: 'D', value: SkI18nService.instant('Geral.lblfieldTypes.D')}
        ];

        init();

        function init(){
            if (!self.parameter.config){
                self.parameter.config = {
                    configType: 'S'
                }
            }

            if (!self.parameter.config.systemConfig){
                self.parameter.config.systemConfig = {
                    entityName: self.parameter.entityName,
                        fieldName: self.parameter.fieldName
                };
            }

            if (!self.parameter.config.userConfig){
                self.parameter.config.userConfig = {
                    description: '',
                        type: ''
                };
            }
        }

        function getFieldEnviromentCriteria(){
            var entityName = self.parameter.config.systemConfig.entityName;
            return Criteria('this.NOMETAB = (SELECT NOMETAB FROM TDDINS WHERE NOMEINSTANCIA = ?)', Criteria.buildStringParameter(entityName));
        }

        function getEntityEnviromentCriteria(){
            return Criteria('this.NUINSTANCIAPAI IS NULL');
        }

        function success(){
            if (self.parameter.config.configType == 'E'){
                var userConfig = self.parameter.config.userConfig;

                if (StringUtils.isEmpty(userConfig.description)){
                    throw Error(SkI18nService.instant('FiltroPersonalizado.lblInformeDescricaoCampo'));
                } else if (StringUtils.isEmpty(userConfig.type)){
                    throw Error(SkI18nService.instant('FiltroPersonalizado.lblInformeTipoCampo'));
                }

                delete self.parameter.config.systemConfig;
            } else {
                delete self.parameter.config.userConfig;
            }

            $popupInstance.success(self.parameter.config);
        }

        function buildExpression() {
            var value = SkFilter.getParameterValue(self.parameter);
            return SkFilter.buildFilterExpression(self.parameter, value);
        }

    }]);
angular
    .module('snk.components.pesquisacep')
    .controller('SkPesquisaCEPController', ['$scope', '$q', 'SkI18nService', 'ObjectUtils', 'FormService', 'GridConfig', 'SkComponentRegistry', 'DoubleFacePanelConstants', '$popupInstance', 'MessageUtils', 'AngularUtil', 'DomUtil', 'Criteria', 'currentCep', 'StringUtils',
        function ($scope, $q, SkI18nService, ObjectUtils, FormService, GridConfig, SkComponentRegistry, DoubleFacePanelConstants, $popupInstance, MessageUtils, AngularUtil, DomUtil, Criteria, currentCep, StringUtils) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);

            self.interceptField = interceptField;

            $scope.filter = {
                CEP: currentCep
            };

            $scope.gridConfigId = 'br.com.sankhya.busca.cep';
            $scope.dblFacePanelId = 'pesquisaCEP.dblFacePanel';

            $scope.fieldsOrder = ['CEP', 'CODEND', 'CODBAI', 'CODCID', 'INTERVALO'];
            $scope.requiredFields = ['CEP', 'CODEND', 'CODBAI', 'CODCID'];

            $scope.changeActionButtons = [
                {
                    action: openGridConfig,
                    label: SkI18nService.instant('Geral.lblConfigurarGrade')
                }
            ];

            $scope.creationComplete = creationComplete;
            $scope.limparFiltro = limparFiltro;
            $scope.onGridDblClick = onGridDblClick;
            $scope.dblFacePanelFocusResolver = dblFacePanelFocusResolver;
            $scope.$success = onSelectCEP;
            $scope.$dismiss = dismiss;

            self.insertionModeActivated = insertionModeActivated;
            self.acceptColumnField = acceptColumnField;
            self.acceptField = acceptField;

            init();

            function init(){
                ObjectUtils.implements(self, IDataSetObserver);

                GridConfig.registerGridConfig($scope.gridConfigId,$scope.gridConfigId,undefined,true);

                $scope.formFilterFields = [
                    FormService.buildProperty('CEP', 'CEP', '', 'P', false, true, undefined, false, 8),
                    FormService.buildProperty('CODEND', 'Endereço', 'ENTITY', 'P', false, true, undefined, false, 0, {'sk-entity-name': 'Endereco', 'sk-description-field-name': 'NOMEEND'}),
                    FormService.buildProperty('CODBAI', 'Bairro', 'ENTITY', 'P', false, true, undefined, false, 0, {'sk-entity-name': 'Bairro', 'sk-description-field-name': 'NOMEBAI'}),
                    FormService.buildProperty('CODCID', 'Cidade', 'ENTITY', 'P', false, true, undefined, false, 0, {'sk-entity-name': 'Cidade', 'sk-description-field-name': 'NOMECID'})
                ];
            }

            function onSelectCEP(){
                $scope.dsCEP.autoSave().then(function(){
                    var selectedCEP = $scope.dsCEP.getCurrentRowAsObject();

                    if (selectedCEP){
                        $popupInstance.success(selectedCEP);
                        limparFiltro();
                    } else {
                        MessageUtils.showError(MessageUtils.TITLE_ERROR, 'Não há um CEP selecionado.');
                    }
                });
            }

            function onGridDblClick(){
                SkComponentRegistry.get($scope.dblFacePanelId)
                    .then(function (instance){
                        instance.setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
                });
            }

            function openGridConfig(){
                GridConfig.openGridconfig($scope.gridConfigId);
            }

            function dblFacePanelFocusResolver(faceSelector) {
                var selectedFace = DomUtil.querySelector($popupInstance.element, faceSelector);
                var autoFocusInput = selectedFace.querySelector('[autofocus]');
                AngularUtil.setFocusOnInput(autoFocusInput);
            }

            function limparFiltro(){
                angular.forEach($scope.filter, function(value, key){
                    $scope.filter[key] = '';
                })
            }

            function creationComplete() {
                $scope.dsCEP.addObserver(self);

                var criteriaProvider = new CriteriaProvider();

                criteriaProvider.getCriteria = function () {
                    var criterio = Criteria();

                    if ($scope.filter.CEP){
                        criterio.append('(this.CEP = ?)', Criteria.buildStringParameter($scope.filter.CEP));
                    }

                    if ($scope.filter.CODBAI){
                        criterio.and('(this.CODBAI = ?)', Criteria.buildNumberParameter($scope.filter.CODBAI));
                    }

                    if ($scope.filter.CODEND){
                        criterio.and('(this.CODEND = ?)', Criteria.buildNumberParameter($scope.filter.CODEND));
                    }

                    if ($scope.filter.CODCID){
                        criterio.and('(this.CODCID = ?)', Criteria.buildNumberParameter($scope.filter.CODCID));
                    }

                    if (criterio.getParameters().length == 0) {
                        throw new Error('Pelo menos um campo deve ser informado para o filtro.');
                    }

                    return criterio;
                };

                $scope.dsCEP.beforePostAction(function (dataset) {
                    var cep = dataset.getFieldValue('CEP');
                
                    if (!/^\d{8}$/.test(cep)) {
                        MessageUtils.showAlert(SkI18nService.instant('Commons.Parceiro.messageCepInvalido'));
                        return false;
                    }
                
                    return true;
                });

                $scope.dsCEP.addCriteriaProvider(criteriaProvider);

                $scope.dsCEP.initializeDataSet()
                    .then(function() {
                        if(StringUtils.isNotEmpty(currentCep)) {
                            $scope.dsCEP.refresh();
                        }
                    });

                $scope.requiredFields.forEach(function(fieldName){
                    $scope.dsCEP.makeFieldRequired(fieldName);
                });
            }

            function insertionModeActivated(){
                if ($scope.dsCEP.isCopyingRecord()){
                    var oldIndex = $scope.dsCEP.getIndexBeforeInsertionMode();
                    var origRecord = $scope.dsCEP.getRecordAsObject(oldIndex);

                    if (!origRecord){
                        return;
                    }

                    if(origRecord.CEP){
                        $scope.dsCEP.setFieldValue('CEP', origRecord.CEP);
                    }

                    if(origRecord.CODEND){
                        $scope.dsCEP.setFieldValue('CODEND', origRecord.CODEND);
                    }

                    if(origRecord.CODBAI){
                        $scope.dsCEP.setFieldValue('CODBAI', origRecord.CODBAI);
                    }

                    if(origRecord.CODCID){
                        $scope.dsCEP.setFieldValue('CODCID', origRecord.CODCID);
                    }
                }
            }

            function dismiss(reason){
                $scope.dsCEP.askAndCancelEdition().then(function(result){
                    $popupInstance.dismiss(reason);
                });
            }

            function acceptColumnField(field, dataset) {
                if ("NOMEEND" == field.id && field.visible == false) {
                    return false;
                }  else if ("TIPO" == field.id) {
                    field.description += " (" + field.entityDescription + ")";
                }

                return true;
            }

            function acceptField(field, dataset) {
                if ("TIPO" == field.id) {
                    return false;
                }  else if ($scope.requiredFields.indexOf(field.id) > -1) {
                    field.required = true;
                }
       
                return true;
            }
            
            function interceptField (fieldMetadata, dataset) {
                if (fieldMetadata.fieldName == "CODEND") {
                    fieldMetadata.description = "Endereço";
                }

                if (fieldMetadata.fieldName == "CODBAI") {
                    fieldMetadata.description = "Bairro";
                }

                if (fieldMetadata.fieldName == "CODCID") {
                    fieldMetadata.description = "Cidade";
                }
            }


        }]);
angular
    .module('snk.components.pesquisacep')
    .service('PesquisaCEP', ['$q', 'SanPopup', 'SkI18nService', 'StringUtils', 'ServiceProxy', 'UserAgentUtils', 'ElectronUtil', function ($q, SanPopup, SkI18nService, StringUtils, ServiceProxy, UserAgentUtils, ElectronUtil) {
        var self = this;

        var BASE_URL  = "https://buscacepinter.correios.com.br/";

        self.openPesquisaCEP = openPesquisaCEP;
        self.openSiteCorreios = openSiteCorreios;
        self.getDadosCep = getDadosCep;
        
        function openPesquisaCEP(currentCep){
            var promise = $q.defer();

            var popupInstance = SanPopup.open({
                templateUrl: 'components/pesquisacep/pesquisacep.tpl.html',
                title: SkI18nService.instant('PesquisaCEP.popupTitle'),
                size: 'lg',
                showBtnOk: true,
                okBtnLabel: 'Usar CEP selecionado',
                controller: 'SkPesquisaCEPController',
                controllerAs: 'ctrl',
                resolve: {
                    currentCep: function(){
                        return currentCep;
                    }
                },
                windowClass: 'sk-pesquisa-cep-popup'
            });

            popupInstance.result.then(function (result) {
                promise.resolve(result);
            }, function (reason) {
                promise.reject(reason);
            });

            return promise.promise;
        }

        function openSiteCorreios(strCep, addressInfoInterceptor) {
            var addrInfo = {};
            var postUrl;
            var requestVariables = {};

            var isAsync;

            if (StringUtils.isNotEmpty(strCep)) {
                postUrl = BASE_URL;
                requestVariables.relaxation = strCep;
            } else {
                if (addressInfoInterceptor != null) {
                    addressInfoInterceptor(addrInfo);
                }

                if (StringUtils.isEmpty(addrInfo.CODCID) || StringUtils.isEmpty(addrInfo.CODEND) || addrInfo.CODCID == "0" || addrInfo.CODEND == "0") {
                    postUrl = BASE_URL;
                } else {
                    postUrl = BASE_URL;
                    requestVariables.Numero = addrInfo.NUMEND;
                    isAsync = true;
                }
            }

            if (!isAsync) {
                navigateToUrl(postUrl, requestVariables);
            } else {
                ServiceProxy.callService('PesquisaCepSP.obterDadosLocalizacao', {
                    params: {
                        codcid: {
                            $: addrInfo.CODCID
                        },
                        codend: {
                            $: addrInfo.CODEND
                        }
                    }
                }).then(function(result) {
                    var localizacao = result.responseBody.localizacao;

                    requestVariables.UF = localizacao.UF.$;
                    requestVariables.Localidade = StringUtils.replaceAccentuatedChars(localizacao.NOMECID.$);
                    requestVariables.Tipo = StringUtils.replaceAccentuatedChars(localizacao.TIPO.$);
                    requestVariables.Logradouro = StringUtils.replaceAccentuatedChars(localizacao.NOMEEND.$);

                    navigateToUrl(postUrl, requestVariables);
                });
            }
        }

        function navigateToUrl(url, data) {
            var form = document.createElement('form');
            form.method = 'POST';
            form.target = '_blank';
            form.style.display = 'none';

            if(UserAgentUtils.isElectron()){
                var params = ElectronUtil.buildParametersNavigateUrl(data, "Content-Type: application/x-www-form-urlencoded");
                url +=  StringUtils.isEmpty(params) ? '' : ('?' + params);
            }else{
                angular.forEach(data, function(value, key){
                    var input = document.createElement('input');
                    input.type = 'text';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
            }
            form.action = url;

            var submit = document.createElement('input');
            submit.type = 'submit';
            form.appendChild(submit);

            document.body.appendChild(form);
            angular.element(form).submit();
            document.body.removeChild(form);
        }

        function getDadosCep(cep) {
            var deferred = $q.defer();

            cep = normalizeCep(cep);

            if (cep.length != 8) {
                deferred.reject("Tamano do cep inválido!");
            }
            
            var request =  { 'cep': { '$': cep } };

            ServiceProxy.callService('PesquisaCepSP.obterDadosDoCep', request).then(function (response) {
                var response = response.responseBody;

                if(response && response.ceps){                    
                    var qtdEnderecos = response.ceps.quantidade;
                    
                    if(qtdEnderecos == 1){

                        deferred.resolve(response.ceps.enderecos);

                    }else if(qtdEnderecos > 1){

                        var popupInstance = SanPopup.open({
                            templateUrl: 'components/pesquisacep/popupselectcep.tpl.html',
                            title: SkI18nService.instant('CepInput.selectCepPopUpTitle'),
                            size: 'md',
                            showBtnOk: true,
                            okBtnLabel: 'Usar CEP selecionado',
                            controller: 'SkSelectCepController',
                            controllerAs: 'ctrl',
                            resolve: {
                                enderecos: function () {
                                    return response.ceps.enderecos;
                                }
                            },
                            windowClass: 'sk-select-cep-popup'
                        });
            
                        popupInstance.result.then(function (endereco) {
                            deferred.resolve(endereco);
                        }, function(rej){
                            deferred.reject(rej);
                        });

                    }
                   
                }else{
                    deferred.reject("Não foi possível resolver o CEP." + cep);
                }
                
            }, function(err){
                deferred.reject("Não foi possível resolver o CEP." + cep);
            });

            return deferred.promise;
        }

        function normalizeCep(cep) {
            cep = StringUtils.replaceAll(cep, "\\.", "");
            cep = StringUtils.replaceAll(cep, "-", "");
            return cep;
        }

    }]);

angular
    .module('snk.components.pesquisacep')
    .controller('SkSelectCepController', ['$scope', 'GridConfig', 'SkComponentRegistry', '$popupInstance', 'MessageUtils', 'enderecos', '$q', '$timeout',
        function ($scope, GridConfig, SkComponentRegistry, $popupInstance, MessageUtils, enderecos, $q, $timeout) {
            var self = this;
            $scope.gridConfigId = 'br.com.sankhya.select.cep';

            self.onDatasetCreated = onDatasetCreated;
            self.onGridDblClick = onGridDblClick;
            self.refreshHandler = refreshHandler;
            self.onGridLoaded = onGridLoaded;

            $scope.$success = onSuccess;

            var _gridCtrl;
            
            init();

            function init(){
                GridConfig.registerGridConfig($scope.gridConfigId,$scope.gridConfigId,undefined,true);
            }
            
            function onDatasetCreated(dataset){
                self.dsCeps = dataset;
                self.dsCeps.initAndRefresh();
            }

            function onGridDblClick(){
                onSuccess();
            }

            function onSuccess(){
                $popupInstance.success(self.dsCeps.getCurrentRowAsObject());           
            }

            function refreshHandler(request){

                return $q(function(resolve) { 
                    var data = [];

                    enderecos.forEach(function(endereco){
                        data.push([endereco.cep, endereco.codEnd, endereco.descEnd, endereco.codBairro, endereco.descBairro, endereco.codCid, endereco.descCid, endereco.codUf, endereco.descUf]);
                    });

                    resolve(data);
                });

            }

            function onGridLoaded(datagrid){
                _gridCtrl = datagrid;

                if(_gridCtrl){
                    $timeout(_gridCtrl.setFocus, 300);
                }
            }

        }]);
/**
 * @ngdoc directive
 * @name snk.components.popover.directive:sk-popover
 * @restrict A
 * @description
 * Essa diretiva tem como responsabilidade exibir o seu conteúdo HTML em um "quadro" flutuante na sua tela a partir
 * de 1 ponto de referência, por exemplo 1 botão.
 * Ele aceita você dizer em qual direção o seu conteúdo será apresentado, com isso é possível você determinar qual o tamanho
 * da tela que vai proporcionar uma boa experiência de navegação para o usuário.
 *
 * @param {string} popoverTemplateUrl utilizado para informar a URL do template onde contém o conteúdo a ser renderizado.
 *
 * @param {string} [popoverContainer=body] utilizado para informar onde o seu popover vai ser adicionado como filho -
 * um elemento HTML.
 *
 * @param {string} [popoverPlacement=bottom] utilizado para informar em qual posição da tela o seu conteúdo vai ser
 * apresentado, opções disponíveis:

 top
 bottom

 *
 * @param {boolean} [popoverHideOnOutsideClick=true] quando ligado, ele vai esconder o popover ao efetuar o click
 * em qualquer local da tela que não seja o popover.
 *
 * @param {boolean} [popoverHideOnButtonClick=true] essa propriedade habilita a funcionalidade de ocultar o popover quando
 * o usuário efetuar o click no elemento (botão) que deu origem para a sua exibição.
 *
 * @param {boolean} [createOnLoad=true] essa propriedade habilita a criação e adição do popover ao DOM assim que
 * a sua tela for carregada. Caso ela esteja inativa, o popover só será adicionado ao DOM quando ocorrer a primeira
 * interação do usuário.
 *
 * @param {boolean} [showBtnApply=true] essa propriedade habilita exibição de 1 botão "Aplicar" próximo ao elemento
 * de click para exibição do popover.
 *
 * @param {boolean} [showBtnClose=true] essa propriedade habilita exibição do botão "Fechar" próximo ao elemento
 * de click para exibição do popover.
 *
 * @param {function} [applyHandler=NULL] quando a propriedade showBtnApply estiver ligado, ao efetuar 1 click no botão
 * apresentado por ela executamos essa função (callback).
 *
 * @param {function} [beforeCloseHandler=NULL] callback utilizado para fechar o popover. Ou seja, é possível executar
 * 1 serviço e só após o retorno da sua promessa fechamos o popover.
 *
 * @param {object} [properties=NULL] propriedades a serem repassados ao scope da diretiva.
 *
 * @scope
 *
 * @example
 <example module="app">
 <file name="exemplo.html">
 <div>
 <button type="button" class="btn btn-primary" sk-popover popover-template-url="doc-popover-example.html" popover-placement="top">Show Popover</button>
 </div>
 <script type="text/ng-template" id="doc-popover-example.html">
 <p>Conteúdo HTML do <b style="color:red;">Popover</b></p>
 </script>
 </file>
 <file name="app.js">
 angular
 .module('app', ['snk']);
 </file>
 </example>
 */
angular
    .module('snk.components.popover')
    .directive('skPopover', SkPopoverDirective);

SkPopoverDirective.$inject = ['$window', '$timeout', '$templateCache', '$q', '$http', '$compile', '$document', '$parse', '$controller', 'StringUtils', 'SkConstants', 'AngularUtil', 'UserAgentUtils', 'SkComponentRegistry', 'DomUtil', 'SkTourService', 'PositionUtils', 'ObjectUtils', 'SanPopupStack'];

function SkPopoverDirective($window, $timeout, $templateCache, $q, $http, $compile, $document, $parse, $controller, StringUtils, SkConstants, AngularUtil, UserAgentUtils, SkComponentRegistry, DomUtil, SkTourService, PositionUtils, ObjectUtils, SanPopupStack) {
    var defaults = {
        container: 'body',
        placement: 'bottom',
        autoRepostionPlacement: false,
        hideOnOutsideClick: true,
        hideOnButtonClick: true,
        createOnLoad: false,
        showBtnApply: false,
        showBtnClose: false,
        alwaysLoadProperties: false,
        bindToController: false,
        showOn: 'click',
        hideOn: 'click',
        openDelay: 0,
        backdrop: false,
        absolute: true,
        hideOnScroll: false,
        showTriangle: true,
        listeners: {onOpen: angular.noop, onClose: angular.noop, onCreate: angular.noop, onScroll: angular.noop},
        group: undefined,
        popoverClass: 'white-popover',
        showOnMousePosition:false,
        showOnMouseEnter:false
    };

    var popOverByGroups = {};

    return {
        restrict: 'A',
        scope: {
            popoverId: '@',
            applyHandler: '&',
            properties: '&',
            beforeCloseHandler: '&',
            dynamicContainerFn: '=',
            alwaysLoadProperties: '=',
            popoverListeners: '=',
            hideDelay: '@?',
            enable: '=?',
            lockOnPopUp: '=?'
        },
        link: linkFn
    };

    function linkFn(scope, elem, attrs) {
        var self = {};

        var OPEN_CLASS = 'sk-open';

        var $container;
        var popoverElem;
        var compiledPopoverElem;
        var contentElem;
        var backdropElem;
        var elemRect;
        var triangleIcon;
        var actionButtonsGroup;
        var btnApply;
        var btnClose;
        var placement;
        var align;
        var match;
        var uid = StringUtils.nextUid();
        var show = show;
        var hide = hide;
        var windowElem = angular.element($window);
        var propertiesLoaded = false;
        var openDelayPromise;
        var hideDelayPromise;
        var backdropClickHandler = backdropClickHandler;
        var hideBackdrop = hideBackdrop;
        var showScrollContainer = showScrollContainer;
        var hideScrollContainer = hideScrollContainer;
        var creatingPopover = false;
        var loadingClassTimeout;
        var popUp;
        var ctrlInstance;
        var showOnMousePosition;
        var _disableListenerHide = false;

        var options = {
            template: attrs.popoverTemplateUrl,
            container: attrs.popoverContainer || defaults.container,
            placement: attrs.popoverPlacement || defaults.placement,
            autoRepostionPlacement: attrs.popoverAutoRepostionPlacement ? StringUtils.toBoolean(attrs.popoverAutoRepostionPlacement) : defaults.autoRepostionPlacement,
            hideOnOutsideClick: attrs.popoverHideOnOutsideClick ? StringUtils.toBoolean(attrs.popoverHideOnOutsideClick) : defaults.hideOnOutsideClick,
            hideOnButtonClick: attrs.popoverHideOnButtonClick || defaults.hideOnButtonClick,
            showOn: attrs.showOn || defaults.showOn,
            hideOn: attrs.hideOn || defaults.hideOn,
            hideOnScroll: attrs.hideOnScroll ? StringUtils.toBoolean(attrs.hideOnScroll) : defaults.hideOnScroll,
            openDelay: parseInt(attrs.openDelay) || defaults.openDelay,
            width: attrs.width,
            popoverClass: attrs.popoverClass || defaults.popoverClass,
            height: attrs.height,
            backdrop: attrs.backdrop ? StringUtils.toBoolean(attrs.backdrop) : defaults.backdrop,
            showBtnApply: attrs.showBtnApply ? StringUtils.toBoolean(attrs.showBtnApply) : defaults.showBtnApply,
            showBtnClose: attrs.showBtnClose ? StringUtils.toBoolean(attrs.showBtnClose) : defaults.showBtnClose,
            createOnLoad: attrs.createOnLoad ? StringUtils.toBoolean(attrs.createOnLoad) : defaults.createOnLoad,
            alwaysLoadProperties: scope.alwaysLoadProperties || defaults.alwaysLoadProperties,
            applyHandler: scope.applyHandler,
            beforeCloseHandler: scope.beforeCloseHandler,
            controllerName: attrs.controllerName,
            controllerAs: attrs.controllerAs,
            bindToController: attrs.bindToController ? StringUtils.toBoolean(attrs.bindToController) : defaults.bindToController,
            popoverIndex: attrs.popoverIndex,
            dynamicContainerFn: scope.dynamicContainerFn,
            absolute: attrs.absolute ? StringUtils.toBoolean(attrs.absolute) : defaults.absolute,
            focusOnShow: attrs.popoverFocusOnShow,
            listeners: angular.extend({}, defaults.listeners, scope.popoverListeners || {}),
            group: attrs.popoverGroup || defaults.group,
            showTriangle: attrs.showTriangle ? StringUtils.toBoolean(attrs.showTriangle) : defaults.showTriangle,
            showOnMousePosition: attrs.showOnMousePosition ? StringUtils.toBoolean(attrs.showOnMousePosition) : defaults.showOnMousePosition,
            showOnMouseEnter: attrs.showOnMouseEnter ? StringUtils.toBoolean(attrs.showOnMouseEnter) : defaults.showOnMouseEnter,
            contentPadding: attrs.padding ? attrs.padding : '15',
            maxHeight: attrs.maxHeight
        };

        scope.hide = self.hide = hide;
        scope.show = self.show = openHandler;

        scope.uid = self.uid = uid;
        scope.apply = btnApplyClickHandler;
        scope.isPopover = true;

        scope.$onPopoverOpened = angular.noop;
        scope.$onPopoverClosed = angular.noop;
        scope.redrawPopover = redrawHandler;

        init();

        ObjectUtils.implements(self, IPopUpStackObserver);
        self.popUpClosed =  popUpClosed;
        self.popUpOpened = popUpOpened;
        self.popUpIsOpen = popUpIsOpen;

        scope.$watch('lockOnPopUp', (newV) => {
            if(newV == true){
                SanPopupStack.addObserver(self);
            }else{
                SanPopupStack.removeObserver(self);
            }
        });

        function init() {
            if (scope.popoverId) {
                SkComponentRegistry.register(self, scope.popoverId, scope, true);
            }

            if (angular.isUndefined(options.template)) {
                throw new Error('Attribute popover-template-url is not defined.');
            }

            if (options.group) {
                if (!popOverByGroups[options.group]) {
                    popOverByGroups[options.group] = [];
                }

                popOverByGroups[options.group].push(scope);
            }

            if (options.showOn != 'none') {
                $timeout(function(){
                    elem.on(options.showOn, openHandler);
                }, 0, false);
            }

            if (StringUtils.toBoolean(options.showOnMouseEnter)) {
                elem.on('mouseenter', onMouseEnter);
            }
            
            if (options.hideOn == 'mouseleave') {
                elem.on('mouseleave', onMouseLeave);
            }

            $container = $document.find(options.container);

            if ($container.length == 0) {
                $container = $document.find('body');
            }

            if (options.createOnLoad) {
                createPopover();
            }

            scope.$on('$destroy', function(){
                showScrollContainer();
                SanPopupStack.removeObserver(self);
            });

            if (options.listeners) {
                options.listeners.onCreate(self);
            }
        }

        function onMouseEnter() {
            self.show();
        }

        function onMouseOver() {
            cancelHide();
        }

        function onMouseLeave(e) {
            if (openDelayPromise) {
                $timeout.cancel(openDelayPromise);
                openDelayPromise = undefined;
            }

            if (popoverElem) {
                hideDelayPromise = $timeout(hide, 200, false);
            }
        }

        function propertiesNeedRefresh(propertiesLoadedOnCreate) {
            if (propertiesLoadedOnCreate) {
                return false;
            } else {
                return (options.alwaysLoadProperties || !propertiesLoaded);
            }
        }

        function loadProperties(afterLoad) {
            var propsFn = scope.properties();

            if (angular.isDefined(propsFn)) {
                if (propertiesNeedRefresh()) {
                    propertiesLoaded = false;

                    loadingClassTimeout = $timeout(function () {
                        elem.addClass('loading');
                    }, creatingPopover ? 0 : 50, false);

                    var promisses = [];
                    var keys = [];

                    $q.when(angular.isFunction(propsFn) ? propsFn() : propsFn)
                        .then(function (prop) {
                            angular.forEach(prop, function (promise, key) {
                                keys.push(key);
                                promisses.push(promise);
                            });

                            $q.all(promisses)
                                .then(function (values) {
                                    values.forEach(function (value, index) {
                                    	if (options.bindToController && ctrlInstance) {
                                    		ctrlInstance[keys[index]] = value;
                                    	} else {
                                    		scope[keys[index]] = value;
                                    	}
                                    })
                                }).finally(function () {
                                    propertiesLoaded = true;

                                    if (loadingClassTimeout) {
                                        $timeout.cancel(loadingClassTimeout);
                                    }

                                    elem.removeClass('loading');

                                    if (afterLoad) {
                                        afterLoad();
                                    }
                                });
                        });
                }
            } else {
                propertiesLoaded = true;

                if (afterLoad) {
                    afterLoad();
                }
            }
        }

        function show(e, propertiesLoadedOnCreate, isPropertiesLoaded) {
            if (!callerIsVisible()) {
                return;
            }

            if (!isPropertiesLoaded && propertiesNeedRefresh(propertiesLoadedOnCreate)) {
                loadProperties(function () {
                    show(e, propertiesLoadedOnCreate, true)
                });
                return;
            }

            if (options.group && popOverByGroups[options.group]) {
                popOverByGroups[options.group].forEach(function (otherPopOver) {
                    if (otherPopOver != scope && otherPopOver.isOpen) {
                        otherPopOver.hide();
                    }
                });
            }

            hideScrollContainer();

            if (options.dynamicContainerFn) {
                options.dynamicContainerFn(e, compiledPopoverElem);
            }

            scope.isOpen = true;
            popoverElem.css('visibility', 'hidden');
            popoverElem.css('display', 'block');
            popoverElem.css('top', '0px');

            elem.addClass(OPEN_CLASS);

            showBackdrop();

            elemRect = getBoundingClientRect(elem[0]);

            draw(popoverElem, placement, align, elemRect, triangleIcon, contentElem,e)
                .then(function(){
                  /** 
                  * Validamos dentro do dashboard se o sk-popup esta sendo aberto dentro de um gwtPanel.
                  * Essa Validação serve para setar o zIndex do popover maior que os demais botões.
                  */
                  if(window.location.pathname.includes("Dashboard")){
                     popUp = DomUtil.closest(elem, '.SimplePopup') || DomUtil.closest(elem, '.sk-popup'); 

                     if (popUp){ //Se estamos em um popup, nosso z-index deve ser maior que o dele
                        popUp = angular.element(popUp);

                        var zIndex = Number(popUp.css('z-index'));

                        if (!isNaN(zIndex)) {
                           popoverElem.css('z-index', (zIndex + 1));
                        }
                     }
                  }

                  popoverElem.css('visibility', 'visible');

					$timeout(function () {
                        var elementToFocus = options.focusOnShow || '[autofocus],[auto-focus]';
                        var tofocusElem = popoverElem[0].querySelector(elementToFocus);

                        if (tofocusElem && tofocusElem.focus) {
                            tofocusElem.focus();
                        }

                        if (options.listeners) {                    
                            let content = popoverElem.find('.sk-popover-content');
                            
                            if(content){
                                let scrollebleContent = content.find('[sk-scroll-container]');
                                (scrollebleContent || content).off('scroll', onScrool);
                                (scrollebleContent || content).on('scroll', onScrool);
                            }
                        }
                    }, 0, false);

                    options.listeners.onOpen(self);
                    scope.$onPopoverOpened(self);
                    if(scope.lockOnPopUp){
                        SanPopupStack.registerActiveListener(self);
                    }
                });

            if (options.hideOnOutsideClick) {
                $document.on('click touchstart', outsideClickHandler);
            }

            if (options.hideOnButtonClick) {
                elem.on('click', buttonClickHandler);
            }

            if (options.showBtnApply == true) {
                btnApply.on('click', btnApplyClickHandler);
            }

            if (options.showBtnClose == true) {
                btnClose.on('click', hide);
            }

            $document.on('keydown', escapeHandler);

            windowElem.on('resize', redrawHandler);

            if (options.hideOnScroll) {
                $document.on('scroll', function(){ 
                    if(!_disableListenerHide){ 
                        hide(); 
                    }
                });
            } else {
                $document.on('scroll', redrawHandler);
            }

            elem.off(options.showOn, openHandler);

            scope.$root.$emit('$dynaform.addOpenedPopover', {'popover': scope});
        }

        function onScrool ($event){
            options.listeners.onScroll($event, self);
        }

        function callerIsVisible() {
            var el = elem;

            do {
                if (el.css('display') == 'none') {
                    return false;
                }
            } while ((el = el.parent()) && angular.isDefined(el[0]) && el[0] != document);

            return true;
        }

        function hide() {
            var fn = options.beforeCloseHandler;

            if (angular.isFunction(fn)) {
                var promise = $q.when(fn(scope));

                promise.then(function (result) {
                    if (angular.isUndefined(result)) {
                        result = true;
                    }

                    if (result) {
                        doHide();
                    }
                });
            } else {
                doHide();
            }

        }

        function doHide() {
            if (angular.isUndefined(popoverElem)) {
                return;
            }

            var fn = function () {
                scope.isOpen = false;
                popoverElem.css('display', 'none');

                if (options.dynamicContainerFn) {
                    compiledPopoverElem.detach();
                }

                elem.removeClass(OPEN_CLASS);

                showScrollContainer();

                if (options.backdrop) {
                    hideBackdrop();
                }

                if (options.hideOnOutsideClick) {
                    $document.off('click touchstart', outsideClickHandler);
                }

                if (options.hideOnButtonClick) {
                    elem.off('click', buttonClickHandler);
                }

                if (options.showBtnApply == true) {
                    btnApply.off('click', btnApplyClickHandler);
                }

                if (options.showBtnClose == true) {
                    btnClose.off('click', hide);
                }

                if (options.showOn != 'none') {
                    elem.on(options.showOn, openHandler);
                }

                $document.off('keydown', escapeHandler);

                if (options.hideOnScroll) {
                    $document.off('scroll', hide);
                } else {
                    $document.off('scroll', redrawHandler);
                }

                windowElem.off('resize', redrawHandler);

                hideDelayPromise = undefined;
            };

            if (options.focusOnShow || scope.hideDelay) {
                if(options.focusOnShow) elem.focus();
                $timeout(fn, scope.hideDelay || 0 , false);
            } else {
                fn();
            }

            options.listeners.onClose(self);
            scope.$onPopoverClosed(self);
        }

        function draw(popover, placement, align, rect, triangle, content,e) {
            var deferred = $q.defer();

            $timeout(function(){
                var popoverRect = getBoundingClientRect(popover[0]);
                var triangleRect;

                if (triangle) {
                    triangleRect = getBoundingClientRect(triangle[0]);
                } else {
                    triangleRect = {
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    }
                }

                var top = 0;
                var left = 0;
                var width = 0;
                var height = 0;

                var positionX = function () {
                    if (options.absolute) {
                        return rect.left;
                    } else {
                        return rect.left - popoverRect.left;
                    }
                };

                var positionY = function () {
                    return rect.top;
                };

                //Isso é necessário pois na primeira vez que efetua o click no elemento por algum motivo
                //o scrollHeight nativo retorna 1 tamanho maior do que realmente é, na segunda vez tudo funciona normal
                var scrollHeight = $document[0].body.offsetHeight + $document[0].body.scrollTop;
                var bodyElem = angular.element($document.find('body'))[0];

                var topOffset = 0;

                var getTop = function (topOffset) {
                    var top = 0;

                    if (options.height) {
                        top = rect.top;

                        var scrollTop = PositionUtils.scrollTop($container, true);

                        if ((top + popoverRect.height - scrollTop) > $container[0].offsetHeight) {
                            top -= (top + popoverRect.height - scrollTop) - $container[0].offsetHeight;
                        }

                        if (triangleRect.height > rect.height) {
                            topOffset = triangleRect.height - rect.height;
                        }

                        top -= topOffset;
                    }

                    return top;
                };


                var calcExtraOffsetDiff = function (rect, popoverRect){
                    let offsetDiff = 0;
                    
                    if(rect.height > popoverRect.height){

                        offsetDiff = ((rect.height - popoverRect.height) / 2);

                    }

                    return offsetDiff;
                }

                if (options.absolute) {
                    if (placement === 'top') {
                            top = rect.top - popoverRect.height - triangleRect.height;

                            if (options.width) {
                                var calcWidth = (options.width == 'auto') ? popoverRect.width : parseInt(options.width);

                                width = options.width;
                                left = rect.left;

                                if ((calcWidth + left) > $container[0].offsetWidth) {
                                    left -= (calcWidth + left - $container[0].offsetWidth);
                                }
                            } else {
                                left = 0;
                                width = (bodyElem.offsetWidth - left);
                            }

                            height = options.height || (window.innerHeight - top + $container.scrollTop());
                    } else if (placement === 'right') {
                        top = getTop(topOffset) +  calcExtraOffsetDiff(rect, popoverRect);
                        left = rect.right + triangleRect.width / 2;
                        width = options.width || (bodyElem.offsetWidth - left);
                        height = options.height || window.innerHeight;
                    } else if (placement === 'bottom') {
                        top = rect.bottom + triangleRect.height;

                        if (options.width) {
                            var calcWidth = (options.width == 'auto') ? popoverRect.width : parseInt(options.width);

                            width = options.width;
                            left = rect.left;

                            if ((calcWidth + left) > $container[0].offsetWidth) {
                                left -= (calcWidth + left - $container[0].offsetWidth);
                            }
                        } else {
                            left = 0;
                            width = (bodyElem.offsetWidth - left);
                        }

                        height = options.height || (window.innerHeight - top + $container.scrollTop());
                    } else if (placement === 'left') {
                        top = getTop(topOffset) + calcExtraOffsetDiff(rect, popoverRect);
                        
                        if(options.showOnMousePosition){
                            left = e.clientX - (popoverRect.width + triangleRect.width);
                        }else{
                            left = rect.left - popoverRect.width - triangleRect.width;
                        }

                        if(left < 0){
                            left = 10;
                        }

                        width = options.width || (rect.left - triangleRect.width / 2);
                        height = options.height || window.innerHeight;
                    }

                    popover.css('width', width == 'auto' ? width : width.toString() + 'px');
                    popover.css('height', height == 'auto' ? height : height.toString() + 'px');
                    popover.css('top', top == 'auto' ? top : top.toString() + 'px');
                    popover.css('left', left == 'auto' ? left : left.toString() + 'px');
                    if(options.maxHeight) popover.css('max-height', options.maxHeight.indexOf('px') > -1 ? options.maxHeight : (options.maxHeight + "px"));
                }

                if (triangle) {
                    var triangleTop = 0;
                    popoverRect = popover[0].getBoundingClientRect();

                    if (placement === 'top' || placement === 'bottom') {

                        if (options.width) {
                            //Calculamos essa diferença, pois em algum momento foi reajustado o popover no
                            //viewport para não dar scroll horizontal e com isso precisamos considerar
                            //essa variação do ajuste no posicionamento do ícone.
                            var diff = positionX() - left;

                            var rectWidth = rect.width != 0 ? rect.width : (options.width / 2);

                            left = rectWidth / 2 + diff;
                        } else {
                            left = positionX() + rect.width / 2;
                        }

                        triangle.css('left', left.toString() + 'px');
                    } else {
                        if (options.height) {
                            triangleTop = positionY() - popoverRect.top - $container.scrollTop();
                            //triangleTop = positionY() - $container.scrollTop();
                            triangleTop += rect.height / 2;
                           // triangleTop = positionY() + (rect.height / 2) + 5;

                            if (topOffset > 0) {
                            	triangleTop += topOffset;
                            }
                        } else {
                            triangleTop = positionY() + rect.height / 2;
                        }

                        triangle.css('top', triangleTop.toString() + 'px');

                        if (placement === 'left') {
                            triangle.css('left', (popoverRect.width - 2) + 'px');
                        }
                    }
                }

                if (actionButtonsGroup) {
                    var leftBtn = positionX() + rect.width / 2;
                    leftBtn = leftBtn - (actionButtonsGroup[0].offsetWidth / 2);

                    actionButtonsGroup.css('left', leftBtn.toString() + 'px');

                    if (placement === 'top') {
                        actionButtonsGroup.css('bottom', '10px');
                    } else {
                        actionButtonsGroup.css('top', '10px');
                    }
                }

                
                if(options.autoRepostionPlacement){
                    const observer = new MutationObserver(() => {
                        const updatedPopoverRect = getBoundingClientRect(popover[0]);
                        const updatedTop = rect.top - updatedPopoverRect.height - triangleRect.height;
                        popover.css(placement, updatedTop + 'px');
                        observer.disconnect();
                    });
            
                    observer.observe(popover[0], { childList: true, subtree: true, attributes: true });
                }

                adjustPopOver();
                deferred.resolve();
            }, 0, false);

            return deferred.promise;
        }

        function adjustRect(rect, adjustX, adjustY, ev) {
            var localRect = {
                bottom: rect.bottom,
                height: rect.height,
                left: rect.left,
                right: rect.right,
                top: rect.top,
                width: rect.width
            };

            if (adjustX) {
                localRect.left = ev.pageX;
                localRect.right = ev.pageX;
                localRect.width = 0;
            }

            if (adjustY) {
                localRect.top = ev.pageY;
                localRect.bottom = ev.pageY;
                localRect.height = 0;
            }

            return localRect;
        }

        function getBoundingClientRect(element) {
            var rect = PositionUtils.offset(element);

            rect.right = rect.left + rect.width;
            rect.bottom = rect.top + rect.height;

            return rect;
        }

        function createPopover(e, showAfter, isPropertiesLoaded) {
            creatingPopover = true;

            if (!isPropertiesLoaded && propertiesNeedRefresh()) {
                loadProperties(function () {
                    createPopover(e, showAfter, true);
                });

                return;
            }

            popUp = DomUtil.closest(elem, '.sk-popup'); //Verificamos se estamos abrindo a partir de um popup

            /** 
            * Validamos dentro do dashboard se o sk-popup esta sendo aberto dentro de um gwtPanel.
            * Essa Validação serve para setar o zIndex do popover maior que os demais botões.
            */
            if(window.location.pathname.includes("Dashboard")){
               popUp = DomUtil.closest(elem, '.SimplePopup') || DomUtil.closest(elem, '.sk-popup');
            }

            popoverElem = angular.element('<div id="sk-popover-' + uid + '"></div>');
            scope.popoverId
            scope.popoverElem = popoverElem;

            popoverElem.attr('sk-popover-container', '');

            if (options.backdrop) {
                backdropElem = $compile('<div class="backdrop backdrop-popover">')(scope);
                backdropElem.on('click', backdropClickHandler);

                hideBackdrop();
            }

            if (options.popoverClass) {
                popoverElem.addClass(options.popoverClass);

                if (backdropElem) {
                    backdropElem.addClass(options.popoverClass);
                }
            }

            if (options.popoverIndex) {
                popoverElem.css('z-index', options.popoverIndex);
            }

            if (options.hideOn == 'mouseleave') {
                popoverElem.on('mouseover', onMouseOver);
                popoverElem.on('mouseleave', onMouseLeave);
            }

            placement = options.placement;

            AngularUtil.requestTemplate(options.template)
                .then(function (template) {
                    if (popUp){ //Se estamos em um popup, nosso z-index deve ser maior que o dele
                        popUp = angular.element(popUp);

                        var zIndex = Number(popUp.css('z-index'));

                        if (!isNaN(zIndex)) {
                            popoverElem.css('z-index', (zIndex + 1));
                        }
                    }

                    popoverElem.addClass('sk-popover');
                    popoverElem.addClass('sk-popover-' + placement + '-placement');
                    popoverElem.addClass('sk-popover-' + align + '-align');

                    if (UserAgentUtils.isMobile()) {
                        popoverElem.addClass('mobile');
                    }

                    scope.$on('$destroy', function () {
                        if (popoverElem && popoverElem.redraw) {
                            popoverElem.redraw();
                        }
                    });

                    scope.hidePopover = function () {
                        hide();
                    };

                    scope.showPopover = function (e) {
                        show(e);
                    };

                    popoverElem.css('position', 'absolute');
                    popoverElem.css('display', 'none');

                    if (options.showTriangle) {
                        triangleIcon = document.createElement('div');
                        triangleIcon = angular.element(triangleIcon);
                        triangleIcon.addClass('triangle');

                        popoverElem.append(triangleIcon);
                    }

                    if (options.showBtnApply == true || options.showBtnClose == true) {
                        actionButtonsGroup = angular.element(document.createElement('div'));
                        actionButtonsGroup.addClass('btn-group action-button');
                        popoverElem.append(actionButtonsGroup);

                        if (options.showBtnApply == true) {
                            btnApply = document.createElement('button');
                            btnApply = angular.element(btnApply);

                            btnApply.addClass('btn btn-primary btn-apply');

                            btnApply[0].textContent = "Aplicar";

                            actionButtonsGroup.append(btnApply);
                        }

                        if (options.showBtnClose == true) {
                            btnClose = angular.element(document.createElement('button'));
                            btnClose[0].textContent = "Fechar";
                            btnClose.addClass('btn btn-default');
                            actionButtonsGroup.append(btnClose);
                        }
                    }

                    contentElem = document.createElement('div');
                    contentElem = angular.element(contentElem);
                    contentElem.addClass('sk-popover-content');
                    contentElem.css('padding', options.contentPadding);
                    contentElem.html(template);

                    popoverElem.append(contentElem);

                    if (options.controllerName) {
                        ctrlInstance = $controller(options.controllerName, {
                            $scope: scope,
                            $element: popoverElem
                        });

                        if (options.controllerAs) {
                            scope[options.controllerAs] = ctrlInstance;
                        }
                    }

                    compiledPopoverElem = $compile(popoverElem)(scope);

                    if (options.dynamicContainerFn) {
                        //options.dynamicContainerFn(e, compiledPopoverElem);
                    } else {
                        $container.append(compiledPopoverElem);
                    }

                    $container.append(backdropElem);
                    creatingPopover = false;

                    if (showAfter) {
                        if (!options.createOnLoad) {
                            $timeout(function () {
                                show(e, true);
                            }, 0, false);
                        } else {
                            show(e, true);
                        }
                    }
                }, function (result) {
                    throw new Error(result);
                });
        }

        function outsideClickHandler(e) {
            if (options.backdrop) {
                return;
            }

            if (scope.isOpen && e.target !== elem[0] && !e.isDefaultPrevented()) {
                var id = popoverElem[0].id;

                if (!isInPopover(e, e.target, id)) {
                    hide();
                }
            }
        }

        function isInPopover(e, target, id) {
            if (target.id === id) {
                return true;
            }

            var parent = angular.element(target).parent()[0];

            if (angular.isUndefined(parent)) {
                return true;
            } else if (parent.hasAttribute('sk-popover-container') && parent != popoverElem[0]) {
                return true;
            } else if (parent.tagName == 'BODY' || parent.tagName == 'HTML') {
                return false;
            }

            if (parent.id === id) {
                return true;
            } else if (parent.hasAttribute && (parent.hasAttribute('sk-popup-window') || parent.hasAttribute('modal-backdrop'))) {
                //FIXME: Após fazer o merge do https://github.com/angular-ui/bootstrap/pull/3516 para a versão oficial
                //do Angular Bootstrap, devemos implementar essa funcionalidade e remover essa verificação de atributo
                //do modal-window
                return !angular.isDefined(popUp);
            } else if(parent.hasAttribute('sk-bind-pop-over-dad-id')){
                var eDad = elem.find('[sk-bind-pop-over-id="' + parent.getAttribute('sk-bind-pop-over-dad-id') + '"]');
                
                if(eDad){
                    return isInPopover(e, eDad, id);
                }else{
                    return isInPopover(e, parent, id); 
                }

            }else{
                return isInPopover(e, parent, id);
            }
        }

        function buttonClickHandler() {
            if (scope.isOpen) {
                hide();
            }
        }

        function escapeHandler(event) {
            if (event.keyCode == SkConstants.KEY_CODE.ESCAPE && !event.isDefaultPrevented()) {
                event.preventDefault();

                hide();
            }
        }

        function cancelHide() {
            if (hideDelayPromise) {
                $timeout.cancel(hideDelayPromise);
                hideDelayPromise = undefined;
            }
        }

        function openHandler(e) {
            if ((SkTourService.isOnTour() && angular.isDefined(e) && (e instanceof Event || e.originalEvent instanceof Event)) || scope.enable == false){
                return;
            }

            cancelHide();

            openDelayPromise = $timeout(function () {
                doOpenHandler(e);
            }, options.openDelay, false);
        }

        function doOpenHandler(e) {
            if (angular.isUndefined(openDelayPromise)) {
                return;
            }
            
            cancelHide();

            if (angular.isUndefined(popoverElem)) {
                createPopover(e, true);
            } else {
                show(e);
            }

            openDelayPromise = undefined;
        }

        function redrawHandler() {
            if (scope.isOpen) {
                elemRect = getBoundingClientRect(elem[0]);

                draw(popoverElem, placement, align, elemRect, triangleIcon, contentElem);
            }
        }

        function btnApplyClickHandler() {
            var fn = options.applyHandler;

            if (angular.isFunction(fn)) {
                var promise = $q.when(fn(scope));

                promise.then(function (result) {
                    if (angular.isUndefined(result)) {
                        result = true;
                    }

                    if (result) {
                        doHide();
                    }
                });
            } else {
                hide();
            }
        }

        function backdropClickHandler(event) {
            if (!event.isDefaultPrevented() && scope.isOpen) {
                hide();
                event.preventDefault();
            }
        }

        function hideBackdrop() {
            if (options.backdrop && backdropElem) {
                backdropElem.css('display', 'none');
            }
        }

        function showBackdrop() {
            if (options.backdrop && backdropElem) {
                backdropElem.css('display', 'block');
            }
        }

        function showScrollContainer() {
            if ($container && !(options.height || options.width)) {
                $container.css('position', 'static');
            }
        }

        function hideScrollContainer() {
            if ($container && !(options.height || options.width)) {
                $container.css('position', 'fixed');
            }
        }

        function popUpClosed(popupInstance){
            $timeout(function(){_disableListenerHide = false;})            
        }

        function popUpOpened(popupInstance){
            _disableListenerHide = true;
        }

        function adjustPopOver() {
            if(!popoverElem || options.autoRepostionPlacement) return;

            $timeout(function () {
                var taskbarWeight = 40; //tamanho padrão da Taskbar definido pelo WorkspaceView GWT
                var offsetPopover = PositionUtils.offset(popoverElem );

                if (placement == 'top' && (offsetPopover.top - taskbarWeight) < popoverElem.height()) {                
                    console.warn('[PopOver] Propriedade placement=top sendo sobrescrita, pois o popover não tem espaço suficiente para ser rendenrizado no topo.');
                    placement = defaults.placement;
                    popoverElem.removeClass('sk-popover-top-placement');
                    popoverElem.addClass('sk-popover-' + placement + '-placement');
                    redrawHandler();
                }
            });
        }
        
        function popUpIsOpen() {
            return scope.isOpen;
        }
    }
}

/**
 * @ngdoc service
 * @name snk.components.popup.service:SanPopup
 *
 * @description
 * Esse serviço permite lançar popup no nosso sistema, toda funcionalidade que lançar popup no sistema
 * deve utilizar esse serviço, pois esse é o nosso padrão de popup.
 *
 * Adicionalmente adicionamos no scope do popup 2 funções:
 * * <b>$success(result)</b>: Utilizado para sucesso da promise e em seguida fechar o popup (Utiliza-se
 * em botões de Ok, Continuar, Sim e etc);
 * * <b>$dismiss(reason)</b>: Utilizado para erros da promise e em seguida fechar o popup (Utiliza-se em
 * botões de Cancelar, Fechar, Não e etc), a reason repassada aqui será capturado na função de erro da
 * promessa;
 *
 * Esses métodos tornam mais fácil o fechamento de um popup, sem a necessidade de criar um controlador.
 *
 * Finalmente, um evento <b>popup.closing</b> é transmitido ao scope do popup antes do fechamento.
 * Se o ouvinte pede preventDefault sobre o evento, em seguida, o popup permanecerá aberto.
 * Os métodos $success e $dismiss retornam true se o evento foi permitido. O evento em si inclui um
 * parâmetro para o result/reason e um parâmetro booleano que indica se o popup está sendo success(true)
 * ou dismiss.
 *
 * <h3 style="color:#198BF1;">Observação Importante</h3>
 * Quando se usa um controlador no Popup, o próprio popup injeta no controlador a instância do popup e com isso fica mais fácil
 * utilizar métodos ou sobrescrever outros métodos do popup, para utilizar essa funcionalidade, deve-se importar o $popupInstance na declaração do controlador.
 *
 * No próprio $scope do controlador do popup pode ser feito a sobrescrita dos métodos/propriedades abaixo:
 * - $success = function newFunction(){};
 * - $dismiss = function newFunction(){};
 * - $popupTitle = 'Novo título do popup';
 * - $enableBtnOk = boolean para habilitar ou desabilitar o botão de OK do popup
 * - $enableBtnNo = boolean para habilitar ou desabilitar o botão de NO do popup
 */
angular
    .module('snk.components.popup', ['snk.tpls'])
    .service('SanPopup', ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', 'SanPopupStack', '$translate', 'ObjectUtils', function ($injector, $rootScope, $q, $templateRequest, $controller, SanPopupStack, $translate, ObjectUtils) {
        var self = this;
        var defaultOptions = {
            animation: false,
            backdrop: 'static',//true | false | 'static'
            keyboard: true,
            showBtnOk: true,
            showBtnCancel: true,
            showIconClose: true,
            showBtnNo: false,
            type: 'default',
            compileFooter: false,
            largeBottomButtons: false,
            enableBtnOk: true,
            controllerCache: false,
            grayBG: false,
            bodyPadding: true,
            focusOnButton: 'ok',
            scrollContainer: true,
            useCache: true,
            enableBtnNo: true,
            hideHeader: false,
            ignoreLoading: false
        };

        //public functions
        self.open = open;

        //Valida se exite alguma popup aberta e da a opção de fecha-la
        self.openedPopup = {
            opened: false, dismiss: null
        };

        /**
         * @ngdoc
         * @name SanPopup#open
         * @methodOf snk.components.popup.service:SanPopup
         *
         * @description
         * Método para abrir o popup de acordo com as opções repassadas.
         *
         * @param {object=} userPopupOptions Opções de abertura do popup, caso não seja repassado nenhuma
         * opção o componente vai assumir as opções padrão do popup. Esse objeto aceita:
         * * templateUrl <b>-</b> um template para representar o conteúdo do popup;
         * * template <b>-</b> um template inline para representar o conteúdo do popup;
         * * controller <b>-</b> um controlador para a instância do popup . Ele aceita o "controller-as"
         * sintaxe 'SomeCtrl como myctrl';
         * * controllerAs <b>-</b> uma alternativa para o controller-as sintaxe. Essa opção requer um
         * controller informado;
         * * resolve <b>-</b> membros que serão resolvidos e passados para o controlador local; é equivalente à
         * propriedade resolve das rotas do AngularJS;
         * * animation <b>-</b> setando para false, você vai desabilitar as animações na apresentação do popup;
         * * backdrop <b>-</b> controla a presença do backdrop. Permite os valores: true, false (sem backdrop)
         * e 'static' (coloca o backdrop, mas quando o mesmo recebe o click não fecha o popup é o padrão);
         * * keyboard <b>-</b> habilita o fechamento do popup com a tecla ESC; O padrão é true;
         * * backdropClass <b>-</b> classe adicional a ser adicionada no backdrop do popup;
         * * windowClass <b>-</b> classe adicional a ser adicionada na janela do popup;
         * * size <b>-</b> classe opcional para a janela do popup. O valor repassado é concatenado com 'modal-' class,
         * os seus tamanhos é baseado nas classes de modal do bootstrap e também tem um tamanho personalizado
         * que é o 'alert' para exibir o popup no tamanho d eum alerta.
         * * type <b>-</b> define o tipo do popup a ser apresentado. Essa opção aceita 'default', 'danger',
         * 'success', 'info', 'primary', 'warning', 'brand' e 'gray'. O padrão é 'default'.
         * * grayBG <b>-</b> Caso true o popup assumirá uma cor de fundo cinza, usamos quando nossos popups usam formulários
         * * title <b>-</b> Título a ser apresentado no popup (obrigatório);
         * * showBtnOk <b>-</b> habilita a apresentação do botão de 'Ok' no popup. O padrão é true.
         * * showBtnCancel <b>-</b> habilita a apresentação do botão de 'Cancelar' no popup. O padrão é true.
         * * showBtnNo <b>-</b> habilita a apresentação do botão de 'Não' no popup. O padrão é false.
         * * showIconClose <b>-</b> apresenta o ícone de fechamento da janela. O padrão é true.
         * * okBtnLabel <b>-</b> Label do botão Ok;
         * * okBtnTooltip <b>-</b> Tooltip do botão Ok;
         * * cancelBtnLabel <b>-</b> Label do botão Cancelar;
         * * noBtnLabel <b>-</b> Label do botão Não;
         * * leftBottomBar <b>-</b> Array de elementos (botões) a serem adicionados na esquerda do footer;
         * * rightBottomBar <b>-</b> Array de elementos (botões) a serem adicionados na direita do footer;
         * * ignoreLoading <b>-</b> Flag que desativa a validação que verifica se o sk-loading-bar está ativo (o padrão é false);
         *
         * @returns {object} retorna um objeto de instância do popup com as seguintes propriedades:
         * * success(result) - um método para ser usado para fechar com sucesso o popup.
         * * dismiss(reason) - um método para ser usado para dismiss no popup, ele passa uma reason com o motivo
         * do dismiss.
         * * result - uma promessa que é resolvida quando um popup está fechado(sucesso) e rejeitado
         * quando um popup é indeferido.
         * * opened - uma promessa que é resolvida quando um popup é aberto depois de baixar modelo de
         * conteúdo e resolver todas as variáveis.
         * * rendered - uma promessa que é resolvido quando um popup é renderizado.
         * * setTitle(newTitle) - método para setar um novo título enquanto ele está aberto.
         *
         * @example
         * ```js
         *      var popupInstance = SanPopup.open({
         *          title: 'Meu popup de exemplo',
         *          templateUrl: 'minha-url/template/popup.tpl.html',
         *          controller: 'ControladorPopup',
         *          controllerAs: 'ctrl',
         *          size: 'md', //Tamanho do popup
         *          okBtnLabel: 'Novo label do botão Ok',
         *          showBtnNo: true,
         *          noBtnLabel: 'Novo label do botão Não',
         *          windowClass: 'sk-popup-exemple',
         *          resolve: {
         *              parameters: function () {
         *                  return parameters;
         *              }
         *          }
         *      });
         *      
         *      popupInstance.result
         *      	.then(function(result) {
	     *				console.log(result);
		 *			}, function(cancel) {
		 *				console.log(cancel);
		 *			});
         * ```
         */
        function open(userPopupOptions) {
            var popupResultDeferred = $q.defer();
            var popupOpenedDeferred = $q.defer();
            var popupRenderDeferred = $q.defer();
            var popupInstance = {
                id: userPopupOptions.id,
                result: popupResultDeferred.promise,
                opened: popupOpenedDeferred.promise,
                rendered: popupRenderDeferred.promise,
                element: null,//Injetamos a instancia do elemento quando o popupstack é aberto
                success: function (result) {
                    /*ATENCAO: Foi necessário utilizar a variavel $$currentPopupInstance, pois com a funcionalidade de cache de controlador ligada
                    * não recriamos mais o controlador e com isso ao acessar $popupInstance no controlador, a referencia do popupInstance nele era a primeira
                    * e não a atual. Isso ocorreu pois a todo momento recriamos o popupInstance na abertura do popup e como no cache não recria mais
                    * o controlador, as referencias nas injeções do controlador continuava a antiga.
                    */
                    self.openedPopup.opened = false;
                    return SanPopupStack.close(popupInstance.$$currentPopupInstance || popupInstance, result);
                },
                dismiss: function (reason) {
                    /*ATENCAO: Foi necessário utilizar a variavel $$currentPopupInstance, pois com a funcionalidade de cache de controlador ligada
                    * não recriamos mais o controlador e com isso ao acessar $popupInstance no controlador, a referencia do popupInstance nele era a primeira
                    * e não a atual. Isso ocorreu pois a todo momento recriamos o popupInstance na abertura do popup e como no cache não recria mais
                    * o controlador, as referencias nas injeções do controlador continuava a antiga.
                    */
                    self.openedPopup.opened = false;
                    return SanPopupStack.dismiss(popupInstance.$$currentPopupInstance || popupInstance, reason);
                },
                setTitle: function (title) {
                    /*ATENCAO: Foi necessário utilizar a variavel $$currentPopupInstance, pois com a funcionalidade de cache de controlador ligada
                    * não recriamos mais o controlador e com isso ao acessar $popupInstance no controlador, a referencia do popupInstance nele era a primeira
                    * e não a atual. Isso ocorreu pois a todo momento recriamos o popupInstance na abertura do popup e como no cache não recria mais
                    * o controlador, as referencias nas injeções do controlador continuava a antiga.
                    */
                    SanPopupStack.setTitle(popupInstance.$$currentPopupInstance || popupInstance, title);
                },
                notify: function(result) {
                    popupResultDeferred.notify(result);
                },
                center: function () {
                  /*ATENCAO: Foi necessário utilizar a variavel $$currentPopupInstance, pois com a funcionalidade de cache de controlador ligada
                   * não recriamos mais o controlador e com isso ao acessar $popupInstance no controlador, a referencia do popupInstance nele era a primeira
                   * e não a atual. Isso ocorreu pois a todo momento recriamos o popupInstance na abertura do popup e como no cache não recria mais
                   * o controlador, as referencias nas injeções do controlador continuava a antiga.
                   */
                    SanPopupStack.center(popupInstance.$$currentPopupInstance || popupInstance);
                },
                $$currentPopupInstance: undefined
            };

            var popupOptions = angular.copy(defaultOptions);
            angular.extend(popupOptions, userPopupOptions);

            popupOptions.resolve = popupOptions.resolve || {};
            popupOptions.popupTitle = popupOptions.title;
            popupOptions.okBtnLabel = popupOptions.okBtnLabel || $translate.instant('Geral.lblOK');
            popupOptions.cancelBtnLabel = popupOptions.cancelBtnLabel || $translate.instant('Geral.lblCancelar');
            popupOptions.noBtnLabel = popupOptions.noBtnLabel || $translate.instant('Geral.lblNo');
            popupOptions.troubleshootingBtnLabel = popupOptions.troubleshootingBtnLabel || $translate.instant('Geral.lblTroubleshooting');
            popupOptions.leftBottomBar = popupOptions.leftBottomBar || [];
            popupOptions.rightBottomBar = popupOptions.rightBottomBar || [];

            if (!popupOptions.popupTitle) {
                throw new Error('É obrigatorio informar um título.');
            }

            if (!popupOptions.template && !popupOptions.templateUrl) {
                throw new Error('One of template or templateUrl options is required.');
            }

            var popUpCache;

            if (popupInstance.id){
                popUpCache = SanPopupStack.getPopUpFromCache(popupOptions.id);
            }

            popupInstance.popupOptions = popupOptions;

            var templateAndResolvePromise = $q.all([getTemplatePromise(popupOptions)].concat(getResolvePromises(popupOptions.resolve)));

            templateAndResolvePromise.then(function resolveSuccess(templateAndVariables) {
                var popupScope = (popUpCache && popUpCache.scope);

                if (!popupScope){
                    popupScope = $rootScope.$new();
                }

                popupScope.$leftBottomBar = popupOptions.leftBottomBar;
                popupScope.$rightBottomBar = popupOptions.rightBottomBar;
                popupScope.$compileFooter = popupOptions.compileFooter;
                popupScope.$popupTitle = popupOptions.popupTitle;
                popupScope.$enableBtnOk = popupOptions.enableBtnOk;
                popupScope.$enableBtnNo = popupOptions.enableBtnNo;
                popupScope.$beforeShow = angular.noop;
                popupScope.$hideHeader = popupOptions.hideHeader;


                //controllers
                var resolveIter = 1;
                if (popupOptions.controller) {
                    var ctrlInstance;
                   
                    if (popupOptions.controllerCache) {
                        ctrlInstance = popUpCache && popUpCache.controller;

                        if (ctrlInstance) {
                            ctrlInstance.$$popupInstance.$$currentPopupInstance = popupInstance;
                        }
                    }
                    
                    if (!ctrlInstance) {
                        var ctrlLocals = {
                            $scope: popupScope,
                            $popupInstance: popupInstance
                        };

                        angular.forEach(popupOptions.resolve, function (value, key) {
                            ctrlLocals[key] = templateAndVariables[resolveIter++];
                        });

                        popupScope.$success = popupInstance.success;
                        popupScope.$dismiss = popupInstance.dismiss;

                        ctrlInstance = $controller(popupOptions.controller, ctrlLocals);
                        ctrlInstance.$$popupInstance = popupInstance;
                    }

                    if (popupOptions.controllerAs) {
                        popupScope[popupOptions.controllerAs] = ctrlInstance;
                    }

                    popupInstance.$controller = ctrlInstance;
                    popupInstance.$controllerName = popupOptions.controller;
                    popupInstance.$controllerAs = popupOptions.controllerAs;
                } else {
                    popupScope.$success = popupInstance.success;
                    popupScope.$dismiss = popupInstance.dismiss;

                    angular.forEach(popupOptions.resolve, function (value, key) {
                        popupScope[key] = templateAndVariables[resolveIter++];
                    });
                }

                var windowClassArr = [];

                if (popupOptions.grayBG) {
                    windowClassArr.push('gray-background');
                }

                if (!popupOptions.bodyPadding) {
                    windowClassArr.push('no-padding-modal-body');
                }

                if (popupOptions.windowClass) {
                    windowClassArr.push(popupOptions.windowClass);
                }

                if (popupOptions.iconTitle) {
                    const parts = popupOptions.iconTitle.split('\.');
                    if (parts.length > 1) {
                        if (parts[1] == 'svg') {
                            popupOptions.popupSvgIcon = popupOptions.iconTitle;
                        } else {
                            popupOptions.popupImgIcon = popupOptions.iconTitle;
                        }
                    } else {
                        popupOptions.popupFontIcon = popupOptions.iconTitle;
                    }
                }
                
                SanPopupStack.open(popupInstance, {
                    id: popupOptions.id,
                    scope: popupScope,
                    deferred: popupResultDeferred,
                    renderDeferred: popupRenderDeferred,
                    openedDeferred: popupOpenedDeferred,
                    content: templateAndVariables[0],
                    animation: popupOptions.animation,
                    backdrop: popupOptions.backdrop,
                    keyboard: popupOptions.keyboard,
                    backdropClass: popupOptions.backdropClass,
                    windowClass: windowClassArr.join(' '),
                    type: popupOptions.type,
                    size: popupOptions.size,
                    okBtnLabel: popupOptions.okBtnLabel,
                    okBtnTooltip: popupOptions.okBtnTooltip,
                    showBtnOk: popupOptions.showBtnOk,
                    okBtnClass: popupOptions.okBtnClass,
                    troubleshootingBtnLabel: popupOptions.troubleshootingBtnLabel,
                    showBtnTroubleshooting: popupOptions.showBtnTroubleshooting,
                    troubleshootingBtnClass: popupOptions.troubleshootingBtnClass,
                    cancelBtnLabel: popupOptions.cancelBtnLabel,
                    showBtnCancel: popupOptions.showBtnCancel,
                    cancelBtnClass: popupOptions.cancelBtnClass,
                    noBtnLabel: popupOptions.noBtnLabel,
                    noBtnTooltip: popupOptions.noBtnTooltip,
                    showBtnNo: popupOptions.showBtnNo,
                    noBtnClass: popupOptions.noBtnClass,
                    showIconClose: popupOptions.showIconClose,
                    largeBottomButtons: popupOptions.largeBottomButtons,
                    popupHeight: popupOptions.height,
                    scrollContainer: popupOptions.scrollContainer,
                    useCache: popupOptions.useCache,
                    disableMovement: popupOptions.disableMovement,
                    hideHeader: popupOptions.hideHeader,
                    ignoreLoading: popupOptions.ignoreLoading,
                    popupSvgIcon: popupOptions.popupSvgIcon,
                    popupImgIcon: popupOptions.popupImgIcon,
                    popupFontIcon: popupOptions.popupFontIcon
                });

                self.openedPopup = {opened: true, dismiss: popupScope.$dismiss};

            }, function resolveError(reason) {
                popupResultDeferred.reject(reason);
            });

            return popupInstance;
        }

        function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
        }

        function getResolvePromises(resolves) {
            var promises = [];

            angular.forEach(resolves, function (value) {
                if (angular.isFunction(value) || angular.isArray(value)) {
                    promises.push($q.when($injector.invoke(value)));
                } else if (angular.isDefined(value)) {
                    promises.push($q.when(value));
                }
            });
            return promises;
        }
    }]);
angular
    .module('snk.components.popup')
    .directive('skPopupAnimationClass', [function () {
        return {
            compile: function (tElement, tAttrs) {
                if (tAttrs.skPopupAnimation) {
                    tElement.addClass(tAttrs.skPopupAnimationClass);
                }
            }
        };
    }]);
angular
    .module('snk.components.popup')
    .directive('skPopupBackdrop', ['$animate', 'SanPopupStack', function ($animate, SanPopupStack) {
        return {
            restrict: 'EA',
            replace: true,
            template: getTemplate,
            compile: function (tElement, tAttrs) {
                tElement.addClass(tAttrs.backdropClass);

                return linkFn;
            }
        };

        function linkFn(scope, element, attrs) {
            if (attrs.skPopupAnimation && attrs.skPopupInClass) {
                $animate.addClass(element, attrs.skPopupInClass);

                scope.$on(SanPopupStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                    var done = setIsAsync();

                    $animate.removeClass(element, attrs.skPopupInClass).then(done);
                });
            } else {
                element.addClass('in');
            }
        }

        function getTemplate() {
            return '\
                <div\
                    class="modal-backdrop"\
                    sk-popup-animation-class="fade"\
                    sk-popup-in-class="in"\
                    ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}">\
                </div>\
            ';
        }
    }]);
angular
    .module('snk.components.popup')
    .constant("PopUpConstants", {
        "POP_UP_STACK_CLOSED": "popup.stack.closed",
        "POP_UP_STACK_OPEN": "popup.stack.open"
    })
    .service('SanPopupStack', ['$animate', '$timeout', '$document', '$compile', '$rootScope', '$q', 'SkConstants', 'SkTourService', 'AngularUtil', 'ObjectUtils', 'PopUpConstants', 'ArrayUtils', function ($animate, $timeout, $document, $compile, $rootScope, $q, SkConstants, SkTourService, AngularUtil, ObjectUtils, PopUpConstants, ArrayUtils) {
        var self = this;

        const START_ZINDEX = 1050;

        let lastZIndex = START_ZINDEX;
        let activeObserverListener = undefined;

        var OPENED_POPUP_CLASS = 'sk-modal-open';
        var openedWindows = new StackedMap();
        var backdropElement;
        var backdropScope;
        var stackObservers = [];
        var _parentElementPopup;

        var _initialized = false;

        var _popUpCache = {};

        self.NOW_CLOSING_EVENT = 'popup.stack.now-closing';
        self.open = open;
        self.close = close;
        self.dismiss = dismiss;
        self.dismissAll = dismissAll;
        self.getTop = getTop;
        self.popupRendered = popupRendered;
        self.setTitle = setTitle;
        self.getPopUpFromCache = getPopUpFromCache;
        self.center = center;
        self.addObserver = addObserver;
        self.removeObserver = removeObserver;
        self.escondePopUp = escondePopUp;
        self.setFirstLayer = setFirstLayer;
        self.getLastZIndex = getLastZIndex;
        self.setLastZIndex = setLastZIndex;
        self.registerActiveListener = registerActiveListener;
        self.setParentElementPopup = setParentElementPopup;

        function init() {
            registerWatchers();
            registerEvents();
            _initialized = true;
        }

        function getPopUpFromCache(id){
            return _popUpCache[id];
        }

        function registerWatchers() {
            $rootScope.$watch(backdropIndex, backdropIndexChangeHandler);
        }

        function registerEvents() {
            $document.bind('keydown', keydownHandler);
        }

        function backdropIndex() {
            var topBackdropIndex = -1;
            var opened = openedWindows.keys();
            var i;

            for (i = 0; i < opened.length; i++) {
                if (openedWindows.get(opened[i]).value.backdrop) {
                    topBackdropIndex = i;
                }
            }

            return topBackdropIndex;
        }

        function backdropIndexChangeHandler(newBackdropIndex) {
            if (backdropScope) {
                backdropScope.index = newBackdropIndex;
            }
        }

        function keydownHandler(evt) {
            if (SkTourService.isOnTour()) {
                return;
            }

            var sanPopup;
            var keycode = evt.which || evt.keyCode;

            if (keycode === SkConstants.KEY_CODE.ESCAPE) {
                sanPopup = openedWindows.top();
                var numOpeneds = openedWindows.keys().length;

                if (sanPopup && sanPopup.value.keyboard && !evt.isDefaultPrevented()) {
                    $rootScope.$apply(function () {
                        var func = ObjectUtils.getProperty(sanPopup, 'value.popupScope.$dismiss');
                        var reason = 'escape key press';

                        if (angular.isFunction(func)) {
                            func(reason);
                        } else {
                            self.dismiss(sanPopup.key, reason);
                        }
                        
                        
                    });
                }

                $('body').css('overflow', 'auto');
                notifyObservers(PopUpConstants.POP_UP_STACK_CLOSED, {popUpInstance : sanPopup});

                if (numOpeneds > 0) {
                    evt.preventDefault();
                }
            }
        }

        function removePopupWindow(popupInstance, elementToReceiveFocus, popupWindow) {
            var body = getBodyElement(popupInstance);
            restoreOverFlow(popupInstance);
            var popupWindow = openedWindows.get(popupInstance).value;
            popupWindow.popupScope.popupOpened = false;

            //limpamos a nossa fila de instancias
            openedWindows.remove(popupInstance);

            removeAfterAnimate(popupInstance.id, popupWindow.popupElement, popupWindow.popupScope, function() {
                //body.toggleClass(OPENED_POPUP_CLASS, openedWindows.length() > 0);
                body.scrollTop(popupInstance.scrollPosition);
                checkRemoveBackdrop();
            });

            if (elementToReceiveFocus && elementToReceiveFocus.focus) {
                elementToReceiveFocus.focus();
            } else {
                body.focus();
            }

            if(popupWindow && popupWindow.backdrop == false){
                checkAllZIndex();
            }

            notifyObservers(PopUpConstants.POP_UP_STACK_CLOSED, {popupInstance: popupInstance});
        }

        function checkRemoveBackdrop() {
            //remove backdrop se não for mais necessário
            if (backdropElement && backdropIndex() == -1) {
                var backdropScopeRef = backdropScope;

                removeAfterAnimate(undefined, backdropElement, backdropScope, function () {
                    backdropScopeRef = null;
                });

                backdropElement = undefined;
                backdropScope = undefined;
            }
        }

        function broadcastClosing(popupWindow, resultOrReason, closing) {
            return !popupWindow.value.popupScope.$broadcast('popup.closing', resultOrReason, closing).defaultPrevented;
        }

        function open(popupInstance, popup) {
            let fromCache = false;

            removeOverFlow(popupInstance);

            if (!_initialized){
                init();
            }

            var popupOpener = $document[0].activeElement;
            var body = getBodyElement(popupInstance);
            var currrentBackdropIndex;

            openedWindows.add(popupInstance, {
                deferred: popup.deferred,
                renderDeferred: popup.renderDeferred,
                popupScope: popup.scope,
                backdrop: popup.backdrop,
                keyboard: popup.keyboard
            });

            currrentBackdropIndex = backdropIndex();

            if (currrentBackdropIndex >= 0 && !backdropElement) {
                backdropScope = $rootScope.$new(true);
                backdropScope.index = currrentBackdropIndex;

                var angularBackdropElement = angular.element('<div sk-popup-backdrop="modal-backdrop"></div>');
                angularBackdropElement.attr('backdrop-class', popup.backdropClass);

                if (popup.animation) {
                    angularBackdropElement.attr('sk-popup-animation', 'true');
                }

                backdropElement = $compile(angularBackdropElement)(backdropScope);
                body.append(backdropElement);
            }

            var popupCache = getPopUpFromCache(popup.id);

            var popupWindowElement;

            if (popupCache && popup.useCache){
                popupWindowElement = popupCache.element;
                fromCache = true;                
            } else {
                popupWindowElement = angular.element('<div sk-popup-window="modal-window"></div>');
                popupWindowElement.attr({
                    'opened': 'popupOpened',
                    'popup-id': popup.id,
                    'window-class': popup.windowClass,
                    'size': popup.size,
                    'ok-btn-label': popup.okBtnLabel,
                    'ok-btn-tooltip': popup.okBtnTooltip,
                    'show-btn-ok': popup.showBtnOk,
                    'ok-btn-class': popup.okBtnClass,
                    'troubleshooting-btn-label': popup.troubleshootingBtnLabel,
                    'show-btn-troubleshooting': popup.showBtnTroubleshooting,
                    'troubleshooting-btn-class': popup.troubleshootingBtnClass,
                    'cancel-btn-label': popup.cancelBtnLabel,
                    'show-btn-cancel': popup.showBtnCancel,
                    'cancel-btn-class': popup.cancelBtnClass,
                    'no-btn-label': popup.noBtnLabel,
                    'no-btn-tooltip': popup.noBtnTooltip,
                    'show-btn-no': popup.showBtnNo,
                    'no-btn-class': popup.noBtnClass,
                    'show-icon-close': popup.showIconClose,
                    'enable-btn-ok': '$enableBtnOk',
                    'enable-btn-no': '$enableBtnNo',
                    'index': openedWindows.length() - 1,
                    'animate': 'animate',
                    'on-success': '$success',
                    'on-dismiss': '$dismiss',
                    'footer-left': '$leftBottomBar',
                    'compile-footer': '$compileFooter',
                    'footer-right': '$rightBottomBar',
                    'popup-title': '$popupTitle',
                    'scroll-container': popup.scrollContainer,
                    'large-bottom-buttons': popup.largeBottomButtons,
                    'class': 'modal-type-' + popup.type,
                    'popup-height': popup.popupHeight,
                    'disable-movement': popup.disableMovement,
                    'enable-backdrop': (popup.backdrop != false),
                    'hide-header': popup.hideHeader,
                    'ignore-loading': popup.ignoreLoading,
                    'popup-font-icon': popup.popupFontIcon,
                    'popup-svg-icon': popup.popupSvgIcon,
                    'popup-img-icon': popup.popupImgIcon,
                    'popup-controller':popupInstance.$controllerName
                }).html(popup.content);

                if (popup.animation) {
                    popupWindowElement.attr('sk-popup-animation', 'true');
                }

                popupWindowElement = $compile(popupWindowElement)(popup.scope);
            }

            openedWindows.top().value.popupElement = popupWindowElement;
            openedWindows.top().value.popupOpener = popupOpener;
            
            /*
            Se o popup veio do cache, precisamos verificar o zIndex, pois pode estar 
            desatualizado no cache.
            */
            if(fromCache && popup.backdrop == false){
                $timeout( () => checkAllZIndex());
            }

            body.append(popupWindowElement);
            //body.addClass(OPENED_POPUP_CLASS);

            popupInstance.scrollPosition = body.scrollTop();
            popupInstance.element = popupWindowElement;

            AngularUtil.setContextControllerInfo(popupWindowElement, popupInstance.$controllerName, popupInstance.$controllerAs, popupInstance.$controller);

            popup.scope.popupOpened = true;

            $timeout(function(){
                body.scrollTop(popupInstance.scrollPosition);
                popup.openedDeferred.resolve(true);
            }, 0, false);

            if (popup.id && popup.useCache) {
                _popUpCache[popup.id] = {
                    scope: popup.scope,
                    element: popupWindowElement,
                    controller: popupInstance.$controller
                };
            }

            $timeout(function(){
                notifyObservers(PopUpConstants.POP_UP_STACK_OPEN, {popUpInstance : popup});
            }, 0, false);

        }
        
        function removeOverFlow(popupInstance) {
        	if (popupInstance) {
        		popupInstance.overFlowOriginal = $document.find('body').css('overflow');
        	}
        	
        	$('body').css('overflow', 'hidden');
        }
        
        function restoreOverFlow(popupInstance) {
        	var overflow = popupInstance && popupInstance.overFlowOriginal ? popupInstance.overFlowOriginal : 'auto';
    		$('body').css('overflow', overflow);
        }
        
        function getBodyElement(popupInstance) {
        	var body = ObjectUtils.getProperty(popupInstance, 'popupOptions.parentElementPopup');
        	
        	if (!body) {
        		body = getParentElementPopup();
        	}
        	
            if (!body) {
            	body = $document.find('body').eq(0);
            }
            
            return body;
        }
        
        function setParentElementPopup(elem) {
        	_parentElementPopup = elem;
        }
        
        function getParentElementPopup() {
        	return _parentElementPopup;
        }

        function close(popupInstance, result) {
            var popupWindow = openedWindows.get(popupInstance);

            if (popupWindow && broadcastClosing(popupWindow, result, true)) {
                popupWindow.value.deferred.resolve(result);

                removePopupWindow(popupInstance, popupWindow.value.popupOpener);

                notifyObservers(PopUpConstants.POP_UP_STACK_CLOSED, {popUpInstance : popupWindow});

                return true;
            }

            return !popupWindow;
        }

        function setTitle(popupInstance, title) {
            var popupWindow = openedWindows.get(popupInstance);

            if (popupWindow) {
                var popupScope = popupWindow.value.popupScope;
                popupScope.$popupTitle = title;
            }
        }

        function center(popupInstance) {
          var popupWindow = openedWindows.get(popupInstance);

          if (popupWindow) {
            var popupScope = popupWindow.value.popupScope;
            popupScope.$broadcast('popup.center');
          }
        }

        function dismiss(popupInstance, reason) {
            var popupWindow = openedWindows.get(popupInstance);

            if (popupWindow && broadcastClosing(popupWindow, reason, false)) {
                popupWindow.value.deferred.reject(reason);

                removePopupWindow(popupInstance, popupWindow.value.popupOpener);

                return true;
            }

            return !popupWindow;
        }

        function dismissAll(reason) {
            var topPopup = this.getTop();

            while (topPopup && this.dismiss(topPopup.key, reason)) {
                topPopup = this.getTop();
            }
        }

        function getTop() {
            return openedWindows.top();
        }

        function popupRendered(popupInstance) {
            var popupWindow = openedWindows.get(popupInstance);

            if (popupWindow) {
                popupWindow.value.renderDeferred.resolve();
            }
        }

        function removeAfterAnimate(id, domEl, scope, done) {
            var asyncDeferred;
            var asyncPromise = null;
            var setIsAsync = function () {
                if (!asyncDeferred) {
                    asyncDeferred = $q.defer();
                    asyncPromise = asyncDeferred.promise;
                }

                return function asyncDone() {
                    asyncDeferred.resolve();
                };
            };

            scope.$broadcast(self.NOW_CLOSING_EVENT, setIsAsync);

            // Note that it's intentional that asyncPromise might be null.
            // That's when setIsAsync has not been called during the
            // NOW_CLOSING_EVENT broadcast.
            return $q.when(asyncPromise).then(afterAnimating);

            function afterAnimating() {
                if (afterAnimating.done) {
                    return;
                }
                afterAnimating.done = true;

                if (id){
                    domEl.detach();
                } else {
                    domEl.remove();
                    scope.$destroy();
                }

                if (done) {
                    done();
                }
            }
        }

        function StackedMap() {
            var stack = [];
            var self = this;

            self.add = addStack;
            self.get = getStack;
            self.keys = keysStack;
            self.top = topStack;
            self.remove = removeStack;
            self.removeTop = removeTopStack;
            self.length = lengthStack;
            self.switchPositions = switchPositions;

            function addStack(key, value) {
                stack.push({
                    key: key,
                    value: value
                });
            }

            function getStack(key) {
                for (var i = 0; i < stack.length; i++) {
                    if (key == stack[i].key || ((angular.isDefined(key.id)) && key.id === stack[i].key.id)) {
                        return stack[i];
                    }
                }
            }

            function keysStack() {
                var keys = [];
                for (var i = 0; i < stack.length; i++) {
                    keys.push(stack[i].key);
                }
                return keys;
            }

            function topStack() {
                return stack[stack.length - 1];
            }

            function removeStack(key) {
                var idx = -1;
                for (var i = 0; i < stack.length; i++) {
                    if (key == stack[i].key) {
                        idx = i;
                        break;
                    }
                }
                return stack.splice(idx, 1)[0];
            }

            function removeTopStack() {
                return stack.splice(stack.length - 1, 1)[0];
            }

            function lengthStack() {
                return stack.length;
            }

            function switchPositions(aItem, bItem){                
                let indexToChange = stack.indexOf(aItem);
                toChange = removeStack(aItem.key);
                removeStack(bItem.key);

                ArrayUtils.insertAtIndex(stack, indexToChange, bItem);
                stack.push(aItem);
            }
        };
        
        function addObserver(observer){
            ObjectUtils.isImplementorOf(observer, IPopUpStackObserver);
            if(stackObservers.indexOf(observer) == -1){
                stackObservers.push(observer);
                if(stackObservers.length > 1000){
                    console.warn('[SanPopupStack.notifyObservers] existem muitos observers registrados no SanPopupStack, size: ' + stackObservers.length);
                }
            }
        };

        function notifyObservers(event, params){
            
            if(stackObservers.length > 1000){
                console.warn('[SanPopupStack.notifyObservers] existem muitos observers registrados no SanPopupStack, size: ' + stackObservers.length);
            }

            if(!activeObserverListener){
                return;
            }

            stackObservers.forEach(function(observer){
                /**
                 * Isso é necessário pois, sem ele, todos os listener registrados 
                 * estavam sendo notificados sem necessidade, afetando o desempenho da aplicação.
                 * Dessa forma fica mais trabalhoso fazer com que o listener funcione, pois,
                 * no componente que deseja ouvir o evento é necessário que ele se registre como ativo,
                 * porém, com isso, ganhamos muito em desempenho.
                 */
                if(activeObserverListener != observer){
                    return;
                }

                switch(event){
                    case PopUpConstants.POP_UP_STACK_CLOSED:
                        observer.popUpClosed(params.popUpInstance);
                    break;  
                    case PopUpConstants.POP_UP_STACK_OPEN:
                        observer.popUpOpened(params.popUpInstance);
                    break;  
                }
            });
        }

        function removeObserver(observer){
            return ArrayUtils.removeReference(stackObservers, observer);
        }

        //Mostar e esconder popup se tiver usando filtro personalizado.
        function escondePopUp(boolean){
            let modalBackdrop = document.getElementsByClassName("modal-backdrop");
            let modalTypeDefault = document.getElementsByClassName("modal-type-default");
            let display = boolean ? 'display: none' : 'display: block';

            if(modalBackdrop.length > 0){
                modalBackdrop[0].attributes.style.nodeValue = display;
            }

            if(modalTypeDefault.length > 0){
                modalTypeDefault[0].attributes.style.nodeValue = display;
            }
        }

        function setFirstLayer(popupInstanceOrId){
            let topPopUp = openedWindows.top();
            let backPopUp;

            if(angular.isString(popupInstanceOrId)){
                backPopUp = openedWindows.get({id: popupInstanceOrId});
            }else{
                backPopUp = openedWindows.get(popupInstanceOrId);
            }

            if(backPopUp && topPopUp && topPopUp.key.id != (popupInstanceOrId.id ? popupInstanceOrId.id : popupInstanceOrId)){
                let topZIndexElement = getZIndexElement(topPopUp.value.popupElement);
                let backZIndexElement = getZIndexElement(backPopUp.value.popupElement);
                
                let atualTopIndex = topZIndexElement.css('zIndex');
                let oldIndex = backZIndexElement.css('zIndex');

                topZIndexElement.css('zIndex', oldIndex);
                backZIndexElement.css('zIndex', atualTopIndex);

                openedWindows.switchPositions(backPopUp, topPopUp);
            }
        }        

        function getZIndexElement(popupElement){
            
            if(popupElement.css('zIndex') == 'auto'){
                let modalDialog = popupElement.find('div.modal-dialog');
                
                if(modalDialog.css('zIndex') != 'auto'){
                    return modalDialog;
                }
            }

            return popupElement;
        }

        function checkAllZIndex(){
            openedWindows.keys().forEach( (key, index) => {
                
                let popup = openedWindows.get(key);
                let el = getZIndexElement(popup.value.popupElement);
                lastZIndex = START_ZINDEX + (index * 10);

                el.css('zIndex', lastZIndex);
            });
        }

        function getLastZIndex(){
            return lastZIndex;
        }

        function setLastZIndex(newZIndex){
            lastZIndex = newZIndex;
        }

        function registerActiveListener(instanceListener){
            activeObserverListener = instanceListener;
        }
    }]);

angular
    .module('snk.components.popup')
    .directive('skPopupTransclude', [function () {
        return {
            restrict: 'EA',
            link: function(scope, element, attrs, controller, transcludeFn) {
                transcludeFn(scope.$parent, function(clone) {
                    element.empty();
                    element.append(clone);
                });
            }
        };
    }]);
angular
    .module('snk.components.popup')
    .directive('skPopupWindow', ['SanPopupStack', '$q', '$compile', '$animate', '$window', '$timeout', 'SkConstants', 'StringUtils', 'UserAgentUtils', 'SkTourService', function (SanPopupStack, $q, $compile, $animate, $window, $timeout, SkConstants, StringUtils, UserAgentUtils, SkTourService) {
        return {
            restrict: 'EA',
            scope: {
                opened: '=',
                popupId: '@',               
                index: '@',
                okBtnLabel: '@',
                okBtnTooltip: '@',
                noBtnLabel: '@',
                noBtnTooltip: '@',
                troubleshootingBtnLabel: '@',
                cancelBtnLabel: '@',
                onSuccess: '=',
                onDismiss: '=',
                footerLeft: '=',
                footerRight: '=',
                compileFooter: '=',
                popupTitle: '=',
                popupFontIcon:'@',
                popupSvgIcon:'@',
                popupImgIcon:'@',
                enableBtnOk: '=',
                scrollContainer: '=',
                disableMovement:'=',
                enableBtnNo: '=',
                enableBackdrop: '=',
                popupController: '@'
            },
            replace: true,
            transclude: true,
            templateUrl: 'components/popup/popup.tpl.html',
            compile: function(element, attrs) {
                var modalHeader = element.find('div.modal-header');
                if(StringUtils.toBoolean(attrs.disableMovement) !== true){
                    modalHeader.attr({"sk-draggable":"", "draggable-level":"2"});
                }

                if (attrs.windowClass) {
                    element.addClass(attrs.windowClass);
                }

                element.addClass('sk-popup');
                element.css('position', 'fixed');

                return linkFn;
            }
        };

        function linkFn(scope, element, attrs) {
            var PX = 'px';
            var DEFAULT_DISCOUNT = 20;
            var viewport = {};
            var modalDialog = angular.element(element[0].querySelector('.modal-dialog'));//Desenho do popup na tela
            var modalBody = angular.element(modalDialog[0].querySelector('.modal-content > .modal-body'));
            var modalFooter = angular.element(modalDialog[0].querySelector('.modal-content > .modal-footer'));
            var modalHeader = element.find('div.modal-header');
            var popupRenderDefer = $q.defer();//Defer que será resolvido quando o popup for renderizado..
            var initialValues;
            var lastPopupHeight;
            var largeBottomButtons = StringUtils.toBoolean(attrs.largeBottomButtons);

            scope.showBtnOk = StringUtils.toBoolean(attrs.showBtnOk);
            scope.showBtnTroubleshooting = StringUtils.toBoolean(attrs.showBtnTroubleshooting);
            scope.showBtnNo = StringUtils.toBoolean(attrs.showBtnNo);
            scope.showBtnCancel = StringUtils.toBoolean(attrs.showBtnCancel);
            scope.showIconClose = StringUtils.toBoolean(attrs.showIconClose);
            scope.hideHeader = StringUtils.toBoolean(attrs.hideHeader);
            scope.ignoreLoading = StringUtils.toBoolean(attrs.ignoreLoading);

            scope.okBtnClass = attrs.okBtnClass || 'btn-primary';
            scope.noBtnClass = attrs.noBtnClass || 'btn-default';
            scope.cancelBtnClass = attrs.cancelBtnClass || 'btn-default';
            scope.troubleshootingBtnClass = attrs.troubleshootingBtnClass || 'btn-default';

            scope.$isRendered = true;
            scope.size = attrs.size;
            scope.close = closeHandler;
            scope.$isDraggable = false;
            scope.showFooter = undefined;

            init();

            function init() {
                modalDialog.css('opacity', '0.0');

                if(scope?.popupController=='MaximizedTabController'){
                    modalDialog.css('width', 'fit-content');
                }

                $window.addEventListener(SkConstants.EVENTS.RESIZE, resizeHandler);

                initializeObservers();

                scope.$on(SkConstants.EVENTS.DESTROY, onDestroy);

                scope.$on('popup.center', function() {
                    applyPopupPosition(viewport);
                });

                if (scope.footerLeft) {
                    var modalFooterLeft = angular.element(modalDialog[0].querySelector('.modal-footer > .modal-footer-left'));

                    for (var i = 0; i < scope.footerLeft.length; i++) {
                        var item = scope.footerLeft[i];

                        if (item && scope.compileFooter){
                            item = $compile(item)(scope);
                        }

                        modalFooterLeft.append(item);
                    }
                }

                if (scope.footerRight) {
                    var modalFooterRight = angular.element(modalDialog[0].querySelector('.modal-footer > .modal-footer-right'));

                    if (largeBottomButtons) {
                        modalFooterRight.attr('layout', 'row');
                    }

                    for (var i = 0; i < scope.footerRight.length; i++) {
                        var item = scope.footerRight[i];

                        if (item && scope.compileFooter){
                            item = $compile(item)(scope);
                        }

                        modalFooterRight.append(item);
                    }
                }

                scope.showFooter = ((scope.footerLeft && scope.footerLeft.length > 0)  || (scope.footerRight && scope.footerRight.length > 0) || scope.showBtnOk || scope.showBtnNo || scope.showBtnCancel ||  scope.showBtnTroubleshooting);

                popupRenderDefer.promise.then(function () {
                    if (attrs.skPopupInClass) {
                        $animate.addClass(element, attrs.skPopupInClass);

                        scope.$on(SanPopupStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                            var done = setIsAsync();

                            $animate.removeClass(element, attrs.skPopupInClass).then(done);
                        });
                    }

                    // Notifica o SanPopupStack que o modal foi renderizado.
                    var sanPopup = SanPopupStack.getTop();

                    if (sanPopup) {
                        SanPopupStack.popupRendered(sanPopup.key);
                    }
                });

                scope.$watch('opened', function (newValue) {
                    if (newValue) {
                        modalDialog.css('opacity', '0.0');
                        if (scope.ignoreLoading) {
                            $timeout(renderPopup, 0, false);
                        } else {
                            $timeout(loadingPopup, 500, false);
                        }
                    }
                });

                if(scope.enableBackdrop == false){
                    element.css('position', 'unset');
                    
                    //Caso o backdrop esteja desabilitado devemos pegar o ultimo z-index da stack
                    modalDialog.css('z-index', (1050 + Number(scope.index) * 10));                    

                    function onModalClick(){
                        if(scope.popupId && scope.popupId != ''){
                            SanPopupStack.setFirstLayer(scope.popupId);    
                        }
                    }

                    modalHeader.on('click', () => {
                        onModalClick();
                    });

                    modalBody.on('click', () => {
                        onModalClick();
                    });
                }
            }

            function loadingPopup () {
                var loadingBar = document.querySelector('.sk-loading-bar');
                if (!loadingBar || (loadingBar && !loadingBar.clientHeight)) {
                    renderPopup();
                } else {
                    $timeout(loadingPopup, 500, false);
                }
            }

            function renderPopup() {
                applyPopupWidth();
                resolveFocus();

                var popupWindow = SanPopupStack.getTop();

                if (popupWindow) {
                    var popupScope = popupWindow.value.popupScope;

                    if (popupScope.$beforeShow) {
                        var returnVal = popupScope.$beforeShow();

                        $q.when(returnVal).then(function () {
                            modalDialog.css('opacity', '1.0');
                        });
                    } else {
                        modalDialog.css('opacity', '1.0');
                    }
                } else {
                    modalDialog.css('opacity', '1.0');
                }
            }

            function resolveFocus() {
                if (UserAgentUtils.isMobile() || SkTourService.isOnTour()) {
                    return;
                }

                var inputsWithAutofocus = element[0].querySelectorAll('[auto-focus]');

                if (inputsWithAutofocus.length == 0) {
                    inputsWithAutofocus = element[0].querySelectorAll('[autofocus]');
                }

                var elementToFocus;

                if (inputsWithAutofocus.length > 0 && inputsWithAutofocus[0].focus) {
                    elementToFocus = inputsWithAutofocus[0];
                } else {
                    var defaultFocus = SanPopupStack.getTop() ? SanPopupStack.getTop().key.popupOptions.focusOnButton : undefined;

                    if (defaultFocus) {
                        var button = modalFooter[0].querySelector('.btn-popup-' + defaultFocus);

                        if (button && button.focus) {
                            elementToFocus = button;
                        }
                    }
                }

                if (!elementToFocus && element[0].focus) {
                    elementToFocus = element[0];
                }

                if (elementToFocus) {
                    $timeout(function(){
                        elementToFocus.focus();
                    }, 200, false);
                }
            }

            function initializeObservers() {
                //Observe: será chamado no próximo ciclo digest que acontece após a compilação, garantindo que o DOM está pronto.
                //Para utilizar a forma de verificar se DOM está pronto, precisamos observar uma propriedade escopo usado no modelo do popup.
                attrs.$observe('skPopupRender', function (value) {
                    if (value == 'true') {
                        popupRenderDefer.resolve();
                    }
                });
            }

            function applyPopupWidth() {
                viewport.height = $window.innerHeight;
                viewport.width = $window.innerWidth;

                var modalHeight = modalDialog[0].clientHeight;
                var modalBodyHeight = modalBody[0].clientHeight;

                if (!initialValues) {
                    if (!isNaN(Number(attrs['popupHeight']))) {
                        modalBodyHeight = Number(attrs['popupHeight']); 
                    }

                    initialValues = {
                        modalHeight: modalHeight,
                        bodyHeight: modalBodyHeight
                    }
                }

                var newHeight;

                if (viewport.height > initialValues.modalHeight) {
                  newHeight = initialValues.bodyHeight;
                } else {
                  var diffHeight = modalHeight - modalBodyHeight;
                  newHeight = viewport.height - diffHeight - DEFAULT_DISCOUNT;
                }

                if (angular.isDefined(newHeight) && attrs.size != 'fullscreen'){
                    modalBody.css('height', newHeight + PX);
                }

                applyPopupPosition(viewport);
            }

            function applyPopupPosition(viewport) {
                var top = viewport.height/2 - modalDialog[0].clientHeight/2;
                var left = viewport.width/2 - modalDialog[0].clientWidth/2;

                if(attrs.size == "fullscreen"){
                    top = 0;
                    left = 0;
                }

                if (left <= 15) {
                  left = 0;
                }

                modalDialog.css({
                    'top': top + PX,
                    'left': left + PX
                });
            }

            function closeHandler(evt) {
                var sanPopup = SanPopupStack.getTop();

                if (sanPopup && sanPopup.value.backdrop && sanPopup.value.backdrop != 'static' && (evt.target === evt.currentTarget)) {
                    evt.preventDefault();
                    evt.stopPropagation();

                    SanPopupStack.dismiss(sanPopup.key, 'close');
                }
            }

            function resizeHandler() {
                applyPopupWidth();
            }

            function onDestroy() {
                $window.removeEventListener(SkConstants.EVENTS.RESIZE, resizeHandler);
            }
        }
    }]);
angular
    .module('snk.components.popupparameter')
    .controller('PopUpParameter', ['$scope', '$popupInstance', 'StringUtils', 'PopUpParameter', 'parameters', 'SanPopupStack', 'options','KeyboardManager', function($scope, $popupInstance, StringUtils, PopUpParameter, parameters, SanPopupStack, options, KeyboardManager){
        var defaultValuesByType = {
            I: -9999,
            F: -0.010101,
            D: "01/01/1800",
            T: -9999,
            H: "01/01/1800 00:00",
            S: ">:-:<"
        };

        var _defaultMDProperties = {
            value: undefined,
            visible: true,
            showInactives: false
        };

        $scope.fields = parameters;
        $scope.options = options;

        $scope.$success = success;
        $scope.$dismiss = dismiss;

        //initialize
        init();
        function init() {
            KeyboardManager.bind('enter',success);
            angular.forEach($scope.fields, function(field){
            	if (!field.presentationType) {
                    field.presentationType = 'P';
            	}

                if (!field.description && field.label){
                    field.description = field.label;
                }

                if(field.entityPK){
                    field.fieldName = field.entityPK;
                }                                

                angular.forEach(_defaultMDProperties, function(value, key) {
                    if (!field.hasOwnProperty(key)) {
                        field[key] = value;
                    }
                });

				//OS: 1382291 -> Tratativa para filtro de pesquisa realizado na mesma entidade.
                if (field.properties && field.properties.uiType == 'SEARCH' && options && StringUtils.isNotEmpty(options.localEntityName) && StringUtils.isNotEmpty(field.properties.entityName) && options.localEntityName == field.properties.entityName) {
                    if (!field.fieldProp) {
                        field.fieldProp = [];
                    }

                    if (!field.fieldProp['sk-options']) {
                        field.fieldProp['sk-options'] = {};
                    }

                    field.fieldProp['sk-options']['showInactives'] = true;
                }
                if(field.properties && field.properties.uiType == 'SEARCH' && field.properties.entityName == "GrupoProduto"){
                    field.fieldProp['sk-allow-show-hierarchical-mode'] = true;
                }
            });
        }

        function success() {
            processValidation();
            
            $popupInstance.success(PopUpParameter.buildResultObject($scope.fields));
        };

        function dismiss (reason) {
            if (reason === 'no') {//O popup dispara uma reason = 'no' quando clicamos no botão de desconsiderar os não informados
                processValidation(true);

                $popupInstance.success(PopUpParameter.buildResultObject($scope.fields));
            } else {
                $popupInstance.dismiss(reason);
            }
        };

        function processValidation(ignoreNotInformed = false){

            for (var i = 0; i < $scope.fields.length; i++){
                var field = $scope.fields[i];

                if (!ignoreNotInformed) {
                    if (StringUtils.toBoolean(field.required) && StringUtils.isEmpty(field.value)){
                        throw new Error('Existem parâmetros obrigatórios em branco.');
                    }
                }

                field.lastValue = field.value;

                if (!field.hasOwnProperty('value') || StringUtils.isEmpty(field.value)) {
                    if (!StringUtils.isEmpty(field.fieldType)) {
					    field.defaultValue = defaultValuesByType[field.fieldType];
					} else if (!StringUtils.isEmpty(field.type)) {
					    field.defaultValue = defaultValuesByType[field.type];
					} else  if (!StringUtils.isEmpty(field.dataType)) {
						field.defaultValue = defaultValuesByType[field.dataType];
					}					
                }
            }
        }
    }]);
/**
 * @ngdoc service
 * @name snk.components.popupparameter.service:PopUpParameter
 *
 * @description
 * Esse serviço permite lançar um popup com parametros(campos).
 */
angular
    .module('snk.components.popupparameter')
    .service('PopUpParameter', ['SanPopup', 'SkI18nService', function (SanPopup, SkI18nService) {
        var self = this;

        self.openPopUp = openPopUp;

        self.builder = builder;

        self.buildStringParameter = buildStringParameter;
        self.buildIntegerParameter = buildIntegerParameter;
        self.buildSearchInputParameter = buildSearchInputParameter;
        self.buildSwitchParameter = buildSwitchParameter;
        self.buildComboboxParameter = buildComboboxParameter;
        self.buildFileParameter = buildFileParameter;
        self.buildDateParameter = buildDateParameter;

        self.buildResultObject = buildResultObject;

        /* @ngdoc
        * @name PopUpParameter#builder
        * @methodOf snk.components.popupparameter.service:PopUpParameter
        * @description
        * Método responsável por criar um novo Builder de PopupParameter
        */
        function builder() {
            return new PopupParameterBuilder();
        }

        /**
         * @ngdoc
         * @name PopUpParameter#openPopUp
         * @methodOf snk.components.popupparameter.service:PopUpParameter
         * @description
         * Método para abrir o popup;
         *
         * @param {object} parameters Objeto com propriedades necessárias para renderização do nosso componente de {@link snk.form.directive:sk-form formulários}.
         *
         * @return {object} Retorna uma objeto de instância do componente {@link snk.componentes.popup.service:SanPopup SanPopup},
         * para ver mais detalhes do que existe nessa instância {@link snk.componentes.popup.service:SanPopup#methods_open_returns clique aqui}.
         *
         * @example
         * ```js
         *      var parameters = [
         *          {
         *              description: "Nome"
         *              enabled: true,
         *              fieldName: undefined,
         *              fieldProp: {
         *                  autofocus: ""//Essa propriedade provê ao Popup a possibilidade de focus
         *              },
         *              fieldType: "S",
         *              groupName: "Teste aplicar",
         *              label: "Nome",
         *              name: "NOME",
         *              paramIndex: 0,
         *              presentationType: "P",
         *              properties: {
         *                  $: "Nome",
         *                  entityName: "TGFREC",
         *                  filterID: 0
         *              },
         *              required: true,
         *              type: "S",
         *              value: ""
         *          }
         *      ];
         *
         *      var instance = PopUpParameter.openPopUp(parameters);
         * ```
         */
        function openPopUp(parameters, options) {
            var defaultOptions = {
                showBtnDesconsiderar: false,
                title: 'PopupParameters.tituloInformeParametro',
                size: 'md',
                columns: '1',
                backdrop: 'static',
                okLabel: 'Geral.lblAplicar',
                noLabel: 'PopupParameters.lblDesconsiderarNaoInf'
            };
            
            var options = angular.extend(defaultOptions, options);

            if (angular.isDefined(options)) {
                if (options.height) {
                    defaultOptions.height = options.height;
                }

                if (options.columns) {
                    defaultOptions.columns = options.columns;
                }
            }

            var popupInstance = SanPopup.open({
                title: SkI18nService.instant(options.title),
                templateUrl: 'components/popupparameter/popupparameter.tpl.html',
                controller: 'PopUpParameter',
                controllerAs: 'ctrl',
                size: options.size,
                height: options.height,
                showBtnNo: options.showBtnDesconsiderar,
                backdrop: options.backdrop,
                okBtnLabel: SkI18nService.instant(options.okLabel),
                noBtnLabel: SkI18nService.instant(options.noLabel),
                noBtnTooltip: 'Somente para Filtros formados com "OU". ',
                windowClass: 'sk-popup-parameter',
                resolve: {
                    parameters: function () {
                        return parameters;
                    },
                    options: function () {
                        return options;
                    }
                }
            });

            return popupInstance;
        }

        function buildResultObject(parameters) {
            var result = {};

            parameters.forEach(function (parameter) {

                //Em casos de parametros que tem hierarquia voltamos o fieldName para o original pois ele o campo pode ser utilizado como parâmetro nas ações. 
                if(parameter.entityPK){
                    parameter.fieldName = parameter.fieldNameOri;
                }

                result[parameter.name] = parameter.value;
            });

            return result;
        }

        function buildSearchInputParameter(name, description, required, entityName, descriptionFieldName, options, value) {
            var searchOptions = angular.extend({
                showDescription: angular.isDefined(descriptionFieldName) || !(angular.isDefined(options) && options.showDescription === false)
            }, options);


            var result = {
                name: name,
                fieldName: name,
                description: description,
                required: required,
                type: 'ENTITY',
                fieldProp: {
                    'sk-entity-name': entityName,
                    'sk-description-field-name': descriptionFieldName,
                    'sk-show-description-input': searchOptions.showDescription,
                    'sk-enviroment-criteria': searchOptions.enviromentCriteria
                }
            };

            if(value != undefined) {
                result.value = value;
            }
            return result;
        }

        function buildSwitchParameter(name, description, required, value) {
            return {
                name: name,
                fieldName: name,
                description: description,
                required: required,
                isCheckbox: true,
                value: value
            };
        }
        
        function buildFileParameter(name, description, fileKey, uploadState, required) {
            return {
                name: name,
                fieldName: name,
                description: description,
                required: required,
                type: 'S',
                presentationType: 'F',
                fieldProp: {
                	'sk-file-key': fileKey,
                	'sk-upload-state': uploadState
                }
            };
        }

        function buildComboboxParameter(name, description, required, options, defaultValue) {
            var cmbOptions = [];

            angular.forEach(options, function (value, key) {
                cmbOptions.push({value: value, data: key});
            });

            var result = {
                name: name,
                fieldName: name,
                description: description,
                required: required,
                fieldProp: {
                    'sk-options': cmbOptions
                }
            };
            
            if(defaultValue != undefined) {
                result.value = defaultValue;
            }

            return result;
        }

        function buildStringParameter(name, description, required, value, maxLength) {
            return {
                name: name,
                description: description,
                required: required,
                value: value,
                size: maxLength
            };
        }

        function buildIntegerParameter(name, description, required, value) {
            return {
                name: name,
                description: description,
                type: 'I',
                required: required,
                value: value
            };
        }
        
        function buildDateParameter(name, description, required, value) {
            return {
                name: name,
                description: description,
                type: 'D',
                required: required,
                value: value,
            };
        }

        function PopupParameterBuilder() {
            var _builder = this;

            var _buildParameterMethods = ['buildStringParameter', 'buildIntegerParameter', 'buildFileParameter', 'buildSearchInputParameter', 'buildSwitchParameter', 'buildComboboxParameter', 'buildDateParameter'];
            var _builderPopupOptions = ['title','height', 'backdrop', 'size', 'showBtnDesconsiderar', 'columns'];

            var _parameters = [];
            var _options = {};

            _builder.option = function (key, value) {
                _options[key] = value;

                return _builder;
            };

            _builder.options = function (opts) {
                _options = opts;

                return _builder;
            };

            _builderPopupOptions.forEach(function(optionName) {
                _builder[optionName] = function(value) {
                    return _builder.option(optionName, value);
                }
            });

            _buildParameterMethods.forEach(function(methodName) {
               _builder[methodName] = function() {
                   var parameter = self[methodName].apply(this, arguments);
                   _parameters.push(parameter);

                   return _builder;
               }
            });

            _builder.show = function(){
                return self.openPopUp(_parameters, _options);
            };
        }

    }]);

/*
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
angular
    .module('snk.components.queryexecutor')
    .component('skQueryExecutor', {
        templateUrl: 'components/queryexecutor/queryexecutor.tpl.html',
        controller: 'SkQueryExecutorController',
        controllerAs: 'ctrl',
        bindings: {
            dataSource: '=skDataSource',
            sql: '=skSql',
            onCreateComplete: '&',
        }
    })
    .controller('SkQueryExecutorController', ['$scope', 'i18n', 'AngularUtil', 'StringUtils', 'ArrayUtils', 'ObjectUtils', 'MessageUtils', 'DateUtils', 'ServiceProxy', 'SanPopup', 
        function ($scope, i18n, AngularUtil, StringUtils, ArrayUtils, ObjectUtils, MessageUtils, DateUtils, ServiceProxy, SanPopup) {
            var self = this;

            const RESULT_INDEX = 1;

            self.selectedStack = selectedStack;

            self.gridOptions = {
                columnDefs: [],
                rowData: [],
                defaultColDef: {
                    editable: false,
                    suppressMenu: true
                },
                toolPanelSuppressSideButtons: true
            };

            self.dataSourcesOpt = [i18n('mge.GadgetBuilder.msgCarregando')];

            var promiseReadDataSources = ServiceProxy.callService('mge@ExecQuerySP.listDataSources', {});

            promiseReadDataSources.then(function (data) {
                self.dataSourcesOpt =
                    (angular.isArray(data.responseBody.dataSources.ds) ? data.responseBody.dataSources.ds : [data.responseBody.dataSources.ds]).map(function (e) {
                        return e.$;
                    });
            });

            var _sqlOriginal = self.sql;

            //Functions
            self.$onInit = $onInit;
            self.executarQuery = executarQuery;

            var _publicAPI = {};
            _publicAPI.queryIsChange = queryIsChange;

            function $onInit() {
                self.onCreateComplete({
                    $instance: _publicAPI
                });
            };

            function executarQuery(isButton) {

                if(isButton) {
                    buttonClicked = true;
                }
                
                var sql = StringUtils.undefinedAsEmpty(self.sql).replace(/\/\*[\s\S]*?\*\/|--[\s\S]*?$/mg, ""); // Remove comentários da Query
                sql = sql.trim();

                if (!sql.toUpperCase().startsWith("SELECT")) {
                    MessageUtils.showAlert(i18n("Commons.QueryEditor.titleErro"), i18n("Commons.QueryEditor.erroInicioQuery"));
                    return;
                }

                if (sql.search(/\bupdate\b|\binsert\b/img) > -1) {
                    MessageUtils.showAlert(i18n("Commons.QueryEditor.titleErro"), i18n("Commons.QueryEditor.erroCommando"));
                    return;
                }

                var parameters = getParamsFromQuery();

                if(parameters && parameters.length > 0){

                    var _params = {};
                    parameters.forEach(param => {
                        _params[param.name] = param;
                    });

                    SanPopup.open({
                        title: i18n('mge.GadgetBuilder.titleParamDaConsulta'),
                        templateUrl: "components/queryexecutor/queryexecutorparams.tpl.html",
                        controller: 'SkQueryExecutorParamsController',
                        controllerAs: 'ctrl',
                        showBtnNo: false,
                        size: 'sm',
                        height: 'auto',
                        windowClass: 'popUpExecutorParams',
                        resolve: {
                            dataValue: {
                                parameters: Object.values(_params)
                            }
                        }
                    }).result.then(function (paramsList) {
                        var param = [];
                        parameters.forEach(pra => {
                            var pr = ArrayUtils.find(paramsList, (e) => {
                                return e.name == pra.name;
                            });

                            var value;

                            if(pr.typeValue == 'D' && pr.value){
                                value = DateUtils.formatDate(pr.value);
                            } else {
                                value = pr.value;
                            }
                            
                            param.push({
                                type: pr.typeValue,
                                value: angular.isDefined(value) ? value : ""
                            });
                        });

                        executarServicoQuery(sql, self.dataSource, param);
                    }); 
                } else {
                    executarServicoQuery(sql, self.dataSource, []);
                }
            }

            function executarServicoQuery(query, ds, param) {
                ServiceProxy.callService('ExecQuerySP.execQuery', {
                    querydata: {
                        query: query,
                        ds: ds,
                        param: param,
                        normalize: "S"
                    }
                }).then(
                    function (result) {
                        var erro = ObjectUtils.getProperty(result, 'responseBody.queryExecResult.ERRO');

                        if (angular.isDefined(erro)) {
                            MessageUtils.showError(i18n("Commons.QueryEditor.titleErro"), erro);
                            return;
                        }

                        var columnDefs = [];
                        var rowData = [];

                        var metadata = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.metadata.column'));

                        metadata.forEach(function (column) {
                            columnDefs.push({
                                headerName: column.name,
                                field: column.name
                            });
                        });

                        var line = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.entity.line'));

                        line.forEach(function (line) {
                            var row = {};

                            var column = ArrayUtils.toArray(line.column);

                            column.forEach(function (column) {
                                row[column.name] = column.value;
                            });

                            rowData.push(row);
                        });

                        self.gridOptions = {
                            columnDefs: columnDefs,
                            rowData: rowData,
                            defaultColDef: {
                                editable: false,
                                suppressMenu: true
                            },
                            toolPanelSuppressSideButtons: true
                        };

                        angular
                            .element(document.getElementById('ag-grid-result'))
                            .replaceWith(AngularUtil.compile('<sk-ag-grid id="ag-grid-result" sk-width="100%" sk-grid-options="ctrl.gridOptions" sk-height="330px"></sk-ag-grid>', $scope));

                        self.selectedIndex = 1;
                    });
            }

            function getParamsFromQuery(){
                var arrayParametros = [];
                var sql = StringUtils.undefinedAsEmpty(self.sql).replace(/\/\*[\s\S]*?\*\/|--[\s\S]*?$/mg, ""); // Remove comentários da Query
                sql = sql.trim().toUpperCase();
                var sqlParams = StringUtils.undefinedAsEmpty(sql).match(/'?%?((\$(N|T|D)\{.+\})|(\B:(@|#)?\b\w+(\.\w+)?\b))%?'?/gi);

                if(!StringUtils.isEmpty(sqlParams)){

                    ArrayUtils.forEach(sqlParams, function (sqlParam) {
                        var param = new Object();
                        param.name = sqlParam.replace(':', '');
                        param.value = null;
                        param.typeValue = 'I';

                        arrayParametros.push(param);
                    });
                }

                return arrayParametros;
            }

            function queryIsChange(){
                return _sqlOriginal != self.sql;
            }

            function selectedStack() {
                if(self.selectedIndex == RESULT_INDEX && !buttonClicked){
                    executarQuery(false);
                } else {
                    buttonClicked = false;
                }
            }
        }
    ]);
/**
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
angular
    .module('snk.components.queryexecutor')
    .controller('SkQueryExecutorParamsController', ['$scope', '$popupInstance', 'dataValue', 'i18n',
        function ($scope, $popupInstance, dataValue, i18n) {
            var self = this;

            self.typeParams = [
                {data: 'D', value: i18n('mge.GadgetBuilder.lblDataHora') },
                {data: 'T', value: i18n('mge.GadgetBuilder.lblTexto') },
                {data: 'I', value: i18n('mge.GadgetBuilder.lblNumerico') },
            ];

            self.parameters = dataValue.parameters;

            $scope.$success = function(){
                $popupInstance.success(self.parameters);
            };

            //Functions
            self.resetParamValue = resetParamValue;

            function resetParamValue(index){
                self.parameters[index].value = "";
            }
        }]);
angular
    .module('snk.components.recordsorganizerbar')
    .controller('RecordsOrganizerBarController', ['$translate', 'MessageUtils', 'i18n', 'ServiceProxy', 'DatasetEvents', 'ObjectUtils', '$scope', 'ArrayUtils', '$rootScope', function($translate, MessageUtils, i18n, ServiceProxy, DatasetEvents, ObjectUtils, $scope, ArrayUtils, $rootScope) {
        var self = this;

        //Interceptors
        ObjectUtils.implements(self, IDataSetObserver);

        self.save = save;
        self.savePosition = save.savePosition;
        self.setSaveHandler = setSaveHandler;
        self.btnSaveEnabled = false;
        self.startIndex = 1;
        self.getEntityToRestart = getEntityToRestart;
        self.setEntityToRestart = setEntityToRestart;

        // Implementações da interface IDataSetObserver
        self.refreshed = refreshed;

        init();

        $rootScope.$on('moveRecordDataset', (ev, args) => {
            if (args.move) {
                self.btnSaveEnabled = true;
            }
        });

        function init(){

            if(!$scope.orderField){
                MessageUtils.showError($translate.instant('Geral.messageInformarPropriedade', {propriedade: "orderField"}));
                return;
            }

            $scope.labelSave = !$scope.labelSave ? i18n('RecordsOrder.buttonSalvarOrdem') : $scope.labelSave;

            $scope.$watch('dataset', function(){
                if($scope.dataset){
                    $scope.dataset.addObserver(self); 
                }
            });

        }

        function save(){
            if($scope.saveHandler){
                $scope.saveHandler();
            } else {
                savePosition($scope.entityToRestart);
            }

            self.btnSaveEnabled = false;
        }
        
        function savePosition(entityToRestart){
            var param = {
                    entity: {
                        name: $scope.dataset.getEntityName(),
                        startIndex: self.startIndex,
                        column: $scope.orderField
                    }
            };

            if($scope.entityToRestart){
                param.entity.entityToRestart = $scope.entityToRestart;
            }

            var records = $scope.dataset.getRecords();
            var pkFields = $scope.dataset.getPrimaryKeys();
            
            if(pkFields){
                param.entity.pk = []
            }

            for(var index in records){
                var record = records[index];
                var pkElement = {};

                for(var field in pkFields){
                    var name = pkFields[field];
                    pkElement[name] = {$:  record[$scope.dataset.getFieldIndexByName(name)]};
                }

                if(!ObjectUtils.isEmpty(pkElement)){
                    param.entity.pk.push(pkElement);
                }
            }
            
            ServiceProxy.callService('mge@CRUDServiceProvider.setRecordsOrder', param, function(){
                self.btnSaveEnabled = false;
                $scope.dataset.refresh();
            });

        }

        function getEntityToRestart(){
            return $scope.entityToRestart;
        }

        function setEntityToRestart(value){
            $scope.entityToRestart = value;
        }

        function refreshed(){
            self.btnSaveEnabled = false;
        }

        function setSaveHandler(fn){
            $scope.saveHandler = fn;
        }
        
    }]);
/**
 * @ngdoc directive
 * @name snk.components.colorpicker.directive:sk-records-organizer-bar
 * @restrict E
 * @description
 * Este é o componente responsável por possibilitar mudar a ordem dos registros e salvar a ordem.
 * @param {SkDataset} [sk-dataset=undefined] ID do Dataset.
 * @param {SkLabel} [sk-label=String] Label do Botão.
 */
angular
    .module('snk.components.recordsorganizerbar')
    .directive('skRecordsOrganizerBar',function() {
        return {
            templateUrl: 'components/recordsorganizerbar/recordsorganizerbar.tpl.html',
            controller: 'RecordsOrganizerBarController',
            controllerAs: 'ctrl',
            scope: {
                dataset: '=skDataset',
                orderField: '@skOrderField',
                entityToRestart: '@?skEntityToRestart',
                labelSave: '@?skLabel',
                saveHandler: '&?skSaveHandler'
            }
        }
    });
angular
    .module('snk.components.resizable')
    .controller('SkResizableController', ['$scope', '$timeout', '$element', '$rootScope',
        function ($scope, $timeout, $element, $rootScope) {
            var toCall;
            var countElements = 0;

            $scope.getElementParentChildren = getElementParentChildren;

            init();

            function init(){
                buildResizable();

                //Observer criado para verificar alteracoes
                buildObserverElement();
            }

            function buildObserverElement() {
                if (angular.isElement($element) && angular.isFunction(MutationObserver)) {
                    var observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                            if (mutation.target.classList && mutation.target.classList.contains('rg-' + $scope.skDirection)) {
                                return;
                            }

                            var parentElement = getElementParentChildren();
                            if (mutation.type === 'childList' && parentElement != null && (countElements != parentElement?.length)) {
                                var divResizable = $element[0].querySelector('.rg-' + $scope.skDirection);

                                if(divResizable != null){
                                    divResizable.remove();
                                }

                                buildResizable();
                            }
                        });
                    });

                    var config = {childList: true, attributes: false, subtree: false};
                    observer.observe($element[0].parentElement || $element[0], config);
                }
            }

            function formatValue(value) {
                return $scope.skChangeLayout ? format(value) : formatPixel(value);
            }

            function buildResizable(){
                $scope.skWidth = format($scope.skWidth);
                $scope.skHeight = format($scope.skHeight);
                $scope.skMinWidth = format($scope.skMinWidth);
                $scope.skMinHeight = format($scope.skMinHeight);
                $scope.skRelativeSize = formatValue($scope.skRelativeSize);

                var parentElement = getElementParentChildren();
                countElements = parentElement != null ? parentElement.length : 0;

                $scope.$watch('skRelativeSize', function(value){
                    if ($scope.isRelativeResizable && value) {
                        $element[0].style['flexBasis'] = formatValue(value);
                    }
                });

                $scope.$watch('skShowSibling', function (newValue) {
                    if (angular.isDefined(newValue)) {
                        if (newValue === false) {
                            $element.css('flex-basis', '100%');
                            $element.addClass('resizable--hide-rg');
                        } else {
                            let flexSize = '300px';
                            if (['right', 'left'].includes($scope.skDirection) && angular.isDefined($scope.skWidth)) {
                                flexSize = $scope.skWidth;
                            } else if (['top', 'bottom'].includes($scope.skDirection) && angular.isDefined($scope.skHeight)) {
                                flexSize = $scope.skHeight;
                            }
                            $element.css('flex-basis', flexSize);
                            $element.removeClass('resizable--hide-rg');
                        }
                    }
                });

                if($scope.skRelativeSize){
                    $element[0].style['flexBasis'] = formatValue($scope.skRelativeSize);
                }

                if($scope.skDirection === 'right'){

                   $element.addClass('resizable-column');

                    var nextElem;

                    if($scope.skSibling){
                        nextElem = $scope.skSibling;
                    } else {
                        nextElem = $element[0].nextElementSibling;
                    }

                    if(!applyClass(nextElem, 'resizable-column')) {
                        return;
                    }
                }

                if($scope.skDirection === 'bottom'){
                    $element.addClass('resizable-row');

                    var nextElem;

                    if($scope.skSibling){
                        nextElem = $scope.skSibling;
                    } else {
                        nextElem = $element[0].nextElementSibling;
                    }

                    if(!applyClass(nextElem, 'resizable-row')){
                        return;
                    }
                }

                if($scope.skDirection === 'left'){
                    $element.addClass('resizable-column');

                    var previousElement;

                    if($scope.skSibling){
                        previousElement = $scope.skSibling;
                    } else {
                        previousElement = $element[0].previousElementSibling;
                    }

                    if(!applyClass(previousElement, 'resizable-column')){
                        return;
                    }

                }

                if($scope.skDirection === 'top'){
                    $element.addClass('resizable-row');

                    var previousElement;

                    if($scope.skSibling){
                        previousElement = $scope.skSibling;
                    } else {
                        previousElement = $element[0].previousElementSibling;
                    }

                    if(!applyClass(previousElement, 'resizable-row')){
                        return;
                    }

                }

                if($scope.skDirection === 'top' || $scope.skDirection === 'bottom'){
                    if($scope.skHeight){
                        $element[0].style['flexBasis'] = $scope.skHeight;
                    }

                    if($scope.skMinHeight){
                        $element[0].style['min-height'] =  $scope.skMinHeight;
                    }
                }

                if($scope.skDirection === 'right' || $scope.skDirection === 'left'){
                    if($scope.skWidth){
                        $element[0].style['flexBasis'] = $scope.skWidth;
                    }

                    if($scope.skMinWidth){
                        $element[0].style['min-width'] =  $scope.skMinWidth;
                    }
                }

                $scope.rFlex = true;

                var flexBasis = 'flexBasis' in document.documentElement.style ? 'flexBasis' :
                    'webkitFlexBasis' in document.documentElement.style ? 'webkitFlexBasis' :
                        'msFlexPreferredSize' in document.documentElement.style ? 'msFlexPreferredSize' : 'flexBasis';

                // register watchers on width and height attributes if they are set
                $scope.$watch('skWidth', function(value){
                    $element[0].style.width = format(value);
                });
                $scope.$watch('skHeight', function(value){
                    $element[0].style.height = format(value);
                });

                $element.addClass('resizable');

                var style = window.getComputedStyle($element[0], null),
                    w,
                    h,
                    dir = [$scope.skDirection],
                    vx = $scope.skCenteredX ? 2 : 1, // if centered double velocity
                    vy = $scope.skCenteredY ? 2 : 1, // if centered double velocity
                    inner = $scope.skGrabber ? $scope.skGrabber : '<span></span>',
                    start,
                    dragDir,
                    axis,
                    info = {};

                var updateInfo = function(e) {
                    info.width = false; info.height = false;
                    if(axis === 'x') {
                        info.width = parseInt($element[0].style[$scope.rFlex ? flexBasis : 'width']);
                    }else {
                        info.height = parseInt($element[0].style[$scope.rFlex ? flexBasis : 'height']);
                    }

                    info.id = $element[0].id;
                    info.evt = e;

                    if($scope.isRelativeResizable && $scope.skRelativeSize){
                        var currentElement = $element[0];
                        let isWorkBox = $element[0].childNodes[0].nodeName == 'SK-WORK-BOX';
                        if($scope.skResizeNextPreview){
                            setNewValuesResizeResizable(currentElement, isWorkBox ? currentElement.previousElementSibling : undefined);
                        }else{
                            setNewValuesResizeAllResizable(currentElement);
                        }
                    }
                };

                var dragging = function(e) {
                    var prop, offset = axis === 'x' ? start - e.clientX : start - e.clientY;
                    switch(dragDir) {
                        case 'top':
                            prop = $scope.rFlex ? flexBasis : 'height';
                            $element[0].style[prop] = h + (offset * vy) + 'px';
                            break;
                        case 'bottom':
                            prop = $scope.rFlex ? flexBasis : 'height';
                            $element[0].style[prop] = h - (offset * vy) + 'px';
                            break;
                        case 'right':
                            prop = $scope.rFlex ? flexBasis : 'width';
                            $element[0].style[prop] = w - (offset * vx) + 'px';
                            break;
                        case 'left':
                            prop = $scope.rFlex ? flexBasis : 'width';
                            $element[0].style[prop] = w + (offset * vx) + 'px';
                            break;
                    }
                    updateInfo(e);

                    if ($scope.onResize) {
                        $scope.onResize();
                    }
                    throttle(function() { $scope.$emit('angular-resizable.resizing', info);});
                };
                var dragEnd = function(e) {
                    updateInfo();

                    changeResizeSize();

                    $scope.$emit('angular-resizable.resizeEnd', info);
                    $scope.$apply();
                    document.removeEventListener('mouseup', dragEnd, false);
                    document.removeEventListener('mousemove', dragging, false);
                    $element.removeClass('no-transition');
                };
                var dragStart = function(e, direction) {
                    dragDir = direction;
                    axis = dragDir === 'left' || dragDir === 'right' ? 'x' : 'y';
                    start = axis === 'x' ? e.clientX : e.clientY;
                    w = parseInt(style.getPropertyValue('width'));
                    h = parseInt(style.getPropertyValue('height'));

                    //prevent transition while dragging
                    $element.addClass('no-transition');

                    document.addEventListener('mouseup', dragEnd, false);
                    document.addEventListener('mousemove', dragging, false);

                    // Disable highlighting while dragging
                    if(e.stopPropagation) e.stopPropagation();
                    if(e.preventDefault) e.preventDefault();
                    e.cancelBubble = true;
                    e.returnValue = false;

                    updateInfo(e);
                    // $scope.$emit('angular-resizable.resizeStart', info);
                    $scope.$apply();
                };

                dir.forEach(function (direction) {
                    var grabber = document.createElement('div');

                    // add class for styling purposes
                    grabber.setAttribute('class', 'rg-' + direction);
                    grabber.innerHTML = inner;
                    $element[0].appendChild(grabber);
                    grabber.ondragstart = function() { return false; };
                    grabber.addEventListener('mousedown', function(e) {
                        var disabled = ($scope.skDisabled === 'true');
                        if (!disabled && e.which === 1) {
                            // left mouse click
                            dragStart(e, direction);
                        }
                    }, false);

                });
            }

            function changeResizeSize(){
                if ($scope.handleWorkboxResize) {
                    return $rootScope.$broadcast("WorkBoxAlterado", $scope); 
                }

                if($scope.isRelativeResizable && $scope.skRelativeSize){
                    if(angular.isFunction($scope.onChangeRelativeSize)) {
                        $scope.onChangeRelativeSize({component : $scope});
                    }
                }
            }

            function throttle(fun) {
                if (toCall === undefined) {
                    toCall = fun;
                    setTimeout(function() {
                        toCall();
                        toCall = undefined;
                    }, 100);
                } else {
                    toCall = fun;
                }
            }

            function applyClass(element, applyClass){
                if(element){
                    element.classList.add(applyClass);
                    return true;
                } else {
                    return false;
                }
            }

            function getAvailableSpaceWithoutPadding(element, offsetSize, isVertical) {
                try {
                    var cs = window.getComputedStyle(element);
                    var padStart = parseFloat(isVertical ? cs.paddingTop    : cs.paddingLeft)  || 0;
                    var padEnd   = parseFloat(isVertical ? cs.paddingBottom : cs.paddingRight) || 0;
                    return Math.max(0, offsetSize - padStart - padEnd);
                } catch (e) {
                    return offsetSize;
                }
            }

            function resolveOffsetLegacy(parentEl) {
                return {
                    offSet: parentEl.offsetWidth - 60,
                    parentElement: parentEl.children
                };
            }

            function resolveOffsetAdjusted(parentEl) {
                var isVertical = parentEl.getAttribute('sk-direction-layout') === 'V';
                var offSet = isVertical ? parentEl.offsetHeight : parentEl.offsetWidth;
                return {
                    offSet: getAvailableSpaceWithoutPadding(parentEl, offSet, isVertical),
                    parentElement: parentEl.children
                };
            }

            function convertWidthToSize(valor) {
                var parentEl = $element[0].parentElement;
                if (!parentEl) return valor;

                var resolved = $scope.skOffsetAdjust === 'true'
                    ? resolveOffsetAdjusted(parentEl)
                    : resolveOffsetLegacy(parentEl);

                var tamanhoTotal = totalSizeElements(resolved.parentElement);
                if (resolved.offSet < tamanhoTotal) {
                    var percent = (valor / tamanhoTotal) * 100;
                    valor = (resolved.offSet * percent) / 100;
                }

                return valor;
            }

            function setNewValuesResizeAllResizable(currentElement) {
                var sizeCurrentElement = parseInt(currentElement.getAttribute('sk-relative-size'));
                var flexSize = parseInt($element[0].style['flexBasis']);

                if(sizeCurrentElement && flexSize && sizeCurrentElement != flexSize) {
                    var parentElement = $element[0].parentElement ? $element[0].parentElement.children : undefined;
                    var totalElements = angular.isDefined(parentElement) ? parentElement.length : 1;

                    var totalSize = totalSizeElements(parentElement);
                    var diferenca = totalSize - flexSize;

                    if (diferenca && parentElement) {
                        diferenca = diferenca / (totalElements - 1);

                        if (diferenca < 1) {
                            diferenca = 100;
                        }

                        for (var i = 0; i < totalElements; i++) {
                            var element = parentElement[i];
                            if (!angular.equals(currentElement, element)) {
                                element.style.flex = diferenca + 'px';
                                element.setAttribute('sk-relative-size', diferenca);
                            }
                        }

                        currentElement.setAttribute('sk-relative-size', flexSize);
                    }
                }
            }

            function setNewValuesResizeResizable(currentElement, nextElement) {
                if(currentElement){
                    var sizeCurrentElement = parseInt(currentElement.getAttribute('sk-relative-size'));
                    var flexSize = parseInt(currentElement.style['flexBasis']);

                    if (sizeCurrentElement && flexSize && sizeCurrentElement != flexSize) {
                        nextElement = angular.isDefined(nextElement)? nextElement : currentElement.nextElementSibling;

                        if(nextElement){
                            var nextElementSize = parseInt(nextElement.style['flexBasis'].trim() ? nextElement.style['flexBasis'] : 0);
                            var diferenca = 0;
                            var valorAtual = 0;

                            if(nextElementSize < 10 && (nextElement.nextElementSibling != null)){
                                setNewValuesResizeResizable($element[0], nextElement.nextElementSibling);
                            }

                            if(sizeCurrentElement < 10 && (currentElement.previousElementSibling != null && nextElement.nextElementSibling == null && currentElement.nextElementSibling != null)){
                                currentElement.nextElementSibling.style.flexBasis = (parseInt(currentElement.nextElementSibling.getAttribute('sk-relative-size')) + flexSize) + 'px';
                                let previousElement = getPreviousElement(currentElement);

                                if (sizeCurrentElement < 10) {
                                    let newValueCurrentSize = sizeCurrentElement - flexSize;
                                    currentElement.style.flexBasis = newValueCurrentSize;
                                    currentElement.setAttribute('sk-relative-size', newValueCurrentSize.toString());
                                }

                                setNewValuesResizeResizable(currentElement.nextElementSibling, previousElement);
                            }

                            if (sizeCurrentElement > flexSize) {
                                diferenca = sizeCurrentElement - flexSize;
                                if (nextElement != null) {
                                    valorAtual = nextElementSize + diferenca;
                                }
                            }else if (sizeCurrentElement < flexSize) {
                                diferenca = flexSize - sizeCurrentElement;

                                if (nextElement != null) {
                                    valorAtual = nextElementSize - diferenca;
                                }
                            }

                            valorAtual =  parseInt(convertWidthToSize(valorAtual));
                            nextElement.style.flexBasis = valorAtual + 'px';
                            nextElement.setAttribute('sk-relative-size', valorAtual.toString());

                            flexSize = parseInt(convertWidthToSize(flexSize));
                            currentElement.setAttribute('sk-relative-size', flexSize);
                            currentElement.style.flexBasis = flexSize + 'px';
                        }
                    } else if ($scope.skResizeToPixel && nextElement.style['flexBasis'].includes('%')) {
                        var offset = $element[0].parentElement.offsetWidth;
                        if ($element[0].parentElement.getAttribute('sk-direction-layout') == 'V') {
                            offset = $element[0].parentElement.offsetHeight;
                        }
                        
                        for (var i = 0; i < $element[0].parentElement.children.length; i++) {
                            var valorAtual = parseFloat((parseFloat($element[0].parentElement.children[i].style['flexBasis']) * parseFloat(offset)) / 100);
                            $element[0].parentElement.children[i].style.flexBasis = valorAtual + 'px';
                            $element[0].parentElement.children[i].setAttribute('sk-relative-size', valorAtual.toString());
                        }
                    }
                }
            }

            function getPreviousElement(elem){
                while (elem = elem.previousElementSibling) {
                    if(parseInt(elem.getAttribute('sk-relative-size')) >= 20) {
                        return elem;
                    }
                }
            }

            function totalSizeElements(elements) {
                var size = 0;
                angular.forEach(elements, function (element) {
                    var relativeSize = parseInt(element.getAttribute('sk-relative-size'));
                    size = size + relativeSize;
                });

                return size;
            }

            function format(format){
                if(format && (format.indexOf('%') == -1 && format.indexOf('px') == -1)){
                    format = format + '%';
                }
                return format;
            }

            function formatPixel(format){
                if(format && (format.indexOf('%') == -1 && format.indexOf('px') == -1)){
                    format = format + 'px';
                }
                return format;
            }

            function getElementParentChildren(){
                if($element[0].parentElement != null){
                    return $element[0].parentElement?.children;
                }
                return null;
            }
            
    }]);

/**
 * @ngdoc directive
 * @name snk.components.resizable.directive:sk-resizable
 * @restrict E
 * @scope
 * @description
     Componente com painel redimensionável.
 *
 * @param {SkResizable} [sk-resizable=undefined]
     Resizable é utilizado para definir o sentido que será redimensionamento dos painéis.
 
 *  @example
 *  <example module="appResizable">
         <file name="appResizable.html">
            <div ng-controller="ResizableController as ctrl">
               <sk-resizable-columns sk-height="100%">
                     <div sk-resizable style="background-color: black" sk-direction="'right'">
                         <p></p>
                     </div>
                     <div>
                         <sk-resizable-rows>
                             <div style="background-color: red" sk-resizable sk-direction="'bottom'">
                             </div>
                             <div style="background-color: yellow" >
                             </div>
                         </sk-resizable-rows>
                     </div>
                 </sk-resizable-columns>
            </div>
         </file>
         <file name="appResizable.js">
            angular
                .module('appResizable', ['snk'])
                .controller('ResizableController', ResizableController);

                function ResizableController($scope){

                }
         </file>
     </example>
*/
angular
    .module('snk.components.resizable')
    .directive('skResizable', function() {
        return {
            restrict: 'AE',
            scope: {
                skDirection: '=',
                skCenteredX: '=',
                skCenteredY: '=',
                skWidth: '@',
                skHeight: '@',
                skMinWidth: '@',
                skMinHeight: '@',
                skGrabber: '@',
                skDisabled: '@',
                skShowSibling: "=?",
                skSibling: "=?",
                onResize: "&skOnResize",
                skRelativeSize: '@skRelativeSize',
                skResizeNextPreview: '@skResizeNextPreview',
                isRelativeResizable: '=?skRelativeResizable',
                onChangeRelativeSize: "&skOnChangeRelativeSize",
                handleWorkboxResize: "=?skHandleWorkboxResize",
                skChangeLayout: '@skChangeLayout',
                skResizeToPixel: '@skResizeToPixel',
                skOffsetAdjust: '@skOffsetAdjust',
            },
            controller: 'SkResizableController',
        };

    });   

angular
    .module('snk.components.resizablecontainer')
    .component('skResizableContainer', {
        templateUrl: 'components/resizablecontainer/resizalbecontainer.tpl.html',
        controller: 'resizablContainerController',
        controllerAs: 'ctrl',
        transclude: true,
        bindings: {
        }
    })
    .controller('resizablContainerController', ['$scope', '$element', '$interval', 'AngularUtil',
        function ($scope, $element, $interval, AngularUtil) {

            const self = this;
            let panels = [];
            let expandedPanel;

            let observer = new MutationObserver(onAttrChange);

            self.$onInit = function(){
                //Aguarda conteudo ser renderizado.
                let interval = $interval(function () {
                    if ($element.find('sk-panel').length > 0) {
                        setupPanels();
                        setDefaultMetrics();
                        $interval.cancel(interval);
                    }
                }, 100, 0, false);

                AngularUtil.addWindowResizeHandler(onWindowResize);
            }

            function setupPanels(){
                panels = $element.find('sk-panel');
                
                for(var i = 0; i < panels.length; i++){
                    let panel = panels[i];
                    
                    observer.observe(panel, { attributes: true });                    
                    
                    let btnScope = $scope.$new();
                    
                    btnScope.expandCollapsePanel = function(){ 
                        expandCollapsePanel(panel) 
                    };
                    
                    btnScope.hoverIn = hoverIn;
                    btnScope.hoverOut = hoverOut;
                    
                    let btnFull = AngularUtil.createDirective('button', {  'font-icon' : 'fullscreen', 
                                                                            'ng-click': 'expandCollapsePanel()', 
                                                                            'class': 'DashWindow-btn icon-expand',
                                                                            'ng-mouseover': 'hoverIn($event)',
                                                                            'ng-mouseleave': 'hoverOut($event)'
                                                                         }, btnScope);
                    panel.append(btnFull[0]);
                }
            }

            function expandCollapsePanel(panel){
                if(expandedPanel){ //collapse
                    expandedPanel.element.style.position = expandedPanel.oldPosition;
                    expandedPanel.element.style.height = expandedPanel.oldH + 'px';
                    expandedPanel.element.style.width = expandedPanel.oldW + 'px';
                    expandedPanel.element.style.zIndex = expandedPanel.oldZIndex;
                    expandedPanel.element.style.zIndex = expandedPanel.oldBg; 
                    expandedPanel.element.style.top = expandedPanel.oldTop;
                    expandedPanel = undefined;
                }else{//expand
                    
                    expandedPanel = {
                        element: panel,
                        oldPosition: panel.style.position,
                        oldH: panel.offsetHeight,
                        oldW: panel.offsetWidth,
                        oldZIndex: panel.style.zIndex,
                        oldBg: panel.style.backgroundColor,
                        oldTop: panel.style.top
                    }

                    panel.style.position = 'absolute';
                    panel.style.height = $element[0].scrollHeight + 'px';
                    panel.style.width = '100%';
                    panel.style.zIndex = '100';
                    panel.style.top = $element[0].getBoundingClientRect().top + 'px';
                    
                    if(panel.style.backgroundColor == ''){
                        panel.style.backgroundColor = '#fff'
                    }
                }
            }            

            function hoverIn($event){                
                $event.currentTarget.style.opacity = "0.6"
            }

            function hoverOut($event){
                $event.currentTarget.style.opacity = "1";
            }

            function onAttrChange(mutations){
                mutations.forEach(mutation => {
                    //atualizando tamanho das rows
                    if(mutation.attributeName == 'style' && mutation.target && mutation.target.tagName == 'SK-PANEL' && mutation.target.style.position != 'absolute'){
                        let target = mutation.target;
                        let parent = target.parentElement;
                        if(parent && parent.tagName == 'SK-RESIZABLE-ROW'){
                            for(var i = 0; i < parent.children.length; i++){
                                let child = parent.children[i];
                                if(child.tagName == "SK-PANEL" && child != target){
                                    child.style.height = target.style.height;
                                }
                            }
                        }
                    }
                });
            }

            function setDefaultMetrics(){
                let rows = $element.find('sk-resizable-row');
                let totalH = $element.height();
                let totalW = $element.width();

                for(var i = 0; i < rows.length; i++){
                    let row = rows[i];
                    let panels = row.querySelectorAll('sk-panel');
                    for(var j = 0; j < panels.length; j++){
                        let panel = panels[j];
                        panel.style.height = (totalH / rows.length) + 'px';
                        panel.style.width = (totalW / panels.length) + 'px';
                    }
                }
            }

            function onWindowResize(){
                setDefaultMetrics();
            }
        }]);

angular
    .module('snk.components.rowscounter')
    .directive('skRowsCounter', ['$translate', '$compile', '$window', 'DatasetEvents', 'PositionUtils', 'SkConstants', '$interval', '$timeout',
function ($translate, $compile, $window, DatasetEvents, PositionUtils, SkConstants, $interval, $timeout) {
    return {
        scope: {
            dataset: '=?skDataset',
            onClick: '&?skOnClick',
            linesLimit: '<'
        },
        template: '<div class="rows-counter-div" ng-class="linesLimitAlertStyle" ng-click="onClick()" tooltip="{{text}}" tooltip-placement="left"><span ng-bind="count"></span><sk-icon ng-if="linesLimit > 0" font-icon="triangle-alert" v="2"></sk-icon></div>',
        restrict: 'E',
        link: postLink
    };

    function postLink(scope, element, attr) {
        var unWatch;
        var unRegLoadStart;
        var unRegLoadEnd;
        var paging = false;
        var carregandoPop = $compile(angular.element('<div class="sk-rows-counter-pop"> <sk-icon class="spin" svg-src="/mge/assets/svg/loading.svg"></sk-icon><a class="link-cancel" ng-click="cancelarPaginacao()">{{::\'RowsCounter.cancelarPaginacao\' | translate}}</a></div>'))(scope);
        var fadeIn;

        scope.count = 0;
        scope.cancelarPaginacao = cancelarPaginacao;

        init();

        function init(){
            element.addClass('sk-rows-counter');
            document.body.appendChild(carregandoPop[0]);

            updateFn();

            $window.addEventListener(SkConstants.EVENTS.RESIZE, function(){
                adjustPosition();
            });

            scope.$watch('dataset', function(){
                updateFn();
            });

            scope.$on('$destroy', function(){
                if (unWatch){
                    unWatch();
                }
            });
        }

        function updateFn(){
            unWatch && unWatch();
            unRegLoadStart && unRegLoadStart();
            unRegLoadEnd && unRegLoadEnd();

            if (scope.dataset) {
                unRegLoadStart = scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD_START, function(){
                    carregandoPop.addClass('paging');
                    carregandoPop.css('visibility', 'hidden');
                    paging = true;

                    adjustPosition();

                    carregandoPop.css('visibility', 'visible');
                });

                unRegLoadEnd = scope.dataset.addEventListener(DatasetEvents.BACKGROUND_LOAD_END, function(){
                    carregandoPop.removeClass('paging');
                    paging = false;

                    updateText();
                });

                unWatch = scope.$watchCollection('dataset.getRecords()', function(records){
                    scope.count = records.length;

                    updateText();
                });
            } else {
                scope.count = 0;
                updateText();
            }
        }

        function adjustPosition(){
            if (paging){
                var position = PositionUtils.offset(element);
                carregandoPop.css({
                    top: (position.top + position.height + 10) + 'px',
                    left: (position.left + position.width - carregandoPop[0].offsetWidth) + 'px'
                });
            }
        }

        function cancelarPaginacao(){
            if (paging && scope.dataset){
                scope.dataset.cancelPagination();
            }
        }

        function updateText(){
        	if(scope.linesLimit > 0) {
        		scope.linesLimitAlertStyle = 'RowsCounterAlert RowsCounterAlertShow';
        		var countFade = 0;
        		if(!fadeIn) {
        			fadeIn = $interval(function() {
        				countFade++;
        				scope.linesLimitAlertStyle = 'RowsCounterAlert RowsCounterAlertShow';
        				if (countFade <= 7) {
        					var fadeOut = $timeout(function() {
        						scope.linesLimitAlertStyle = 'RowsCounterAlert';
        					}, 750);
        				} else {
        					$interval.cancel(fadeIn);
        				}
        			}, 1500);
        		}
        	} else {
        		scope.linesLimitAlertStyle = '';
            }
            if(scope.count == 0){
                scope.text = $translate.instant('RowsCounter.lblCountZero');
            }
            if(scope.count == 1){
                scope.text = $translate.instant('RowsCounter.lblOneCount', {count: scope.count});
            }
            if(scope.count > 0 && scope.count != 1){
                scope.text = $translate.instant('RowsCounter.lblCount', {count: scope.count});
            }
        }
    }
}]);
angular
    .module('snk.components.sankhyaaccount')
    .directive('skSankhyaAcc', [function () {
        return {
            templateUrl: 'components/sankhyaaccount/sankhyaAccount.tpl.html',
            controller: 'skSankhyaAccController',
            controllerAs: 'ctrl',
            transclude: true,
            scope: {
                fieldName: '@skFieldName',
                dataset: '<?skDataset',
                onChange: '&?skChange',
            }
        };
    }])
    .controller('skSankhyaAccController', ['$scope', '$timeout', 'ObjectUtils', '$attrs', 'MessageUtils', 'ServiceProxy', 'i18n', 'StringUtils', 'SanPopup', '$rootScope',
function ($scope, $timeout, ObjectUtils, $attrs, MessageUtils, ServiceProxy, i18n, StringUtils, SanPopup, $rootScope) {
    var self = this;
    var status = false;
    self.toolTip = i18n('Core.CadastroUsuarios.msgToolTipLinkAccount');
    self.linkAccount = i18n('Core.CadastroUsuarios.buttonEnviarConvite');
    self.cancelAccount = i18n('Core.CadastroUsuarios.buttonCancelarConvite');
    self.unlinkAccount = i18n('Core.CadastroUsuarios.buttonDesvincularAccount');
    self.placeHolderInputAccount = i18n('Core.CadastroUsuarios.placeHolderInputAccount');

    ObjectUtils.implements(self, FieldBinder, {
        scope: $scope,
        setData: setData,
        getData: getData
    });

    $scope.changeHandler = changeHandler;
    $scope.valueOptions = $scope.valueOptions || {};
    $scope.onInputKeydown = onInputKeydown;
    
    $scope.dataset.addLineChangeListener(changeState);
    $scope.dataset.addInsertionModeListener(changeState);
    changeState();
    
    $scope.$on('broadcastUnlinkAccount', function(){
    	$scope.dataset.setFieldValue('ACCOUNTID', null);
    	$scope.dataset.setFieldValue('ACCOUNTTOKEN', null);
    	$scope.dataset.setFieldValue('ACCOUNTEMAIL', null);
    	$scope.dataset.save();
    	changeState();
    });

    $scope.dataset.addDataSavedListener(() => {
    	if(getData() && !status && !$scope.dataset.getFieldValue('ACCOUNTID') && !$scope.dataset.getFieldValue('ACCOUNTTOKEN')) {
    		$scope.linkAccount(self.value);
    	}
    });

    function onInputKeydown($event) {
        if ($scope.onKeydown) {
            $scope.onKeydown({$event: $event});
        }
    }

    function changeHandler() {
        if (self.useDataset($scope)) {
            $scope.$evalAsync(function(){
                $scope.dataset.notifyEditionStart(self);
                $scope.dataset.setModified(self);
            });
        }

        runOnChange();
    }

    function runOnChange() {
        if ($attrs.skBeforeChange) {
            $scope.beforeChange({$value: self.value});
        }

        if ($attrs.skChange) {
            $timeout(function(){
                $scope.onChange($scope);
            });
        }
    }

    function setData(data) {
    	self.value = data;
        runOnChange();
    }
    
    $scope.linkAccount = function(data) {
    	if(!validEmail(data)){
    		MessageUtils.showError(MessageUtils.TITLE_WARNING, i18n('Core.CadastroUsuarios.msgDesvincularAccountError', ['O e-mail informado não é válido.']));
    	} else if($scope.dataset.getFieldValue('CODUSU') === 0){
    		MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Core.CadastroUsuarios.msgAvisoVinculoSup'));
    		$scope.dataset.setFieldValue('ACCOUNTEMAIL', null);
    	} else {
    		ServiceProxy
            .callService('AccountSP.admUserInvite', {
                'email': data
            })
            .then(function(response){
                var error = response.responseBody.error;
                var message = response.responseBody.message;

                if (error) {
                	MessageUtils.showError(MessageUtils.TITLE_WARNING, i18n('Core.CadastroUsuarios.msgDesvincularAccountError', [message]));
                } else {
                	$scope.dataset.setFieldValue('ACCOUNTEMAIL', data);
                	changeState();
                	status = true;
                }
            });
    	}
    }
    
    $scope.cancelLinkAccount = function(){
    	ServiceProxy
        .callService('AccountSP.cancelLinkAccount', {
            'cod_usu': $scope.dataset.getFieldValue('CODUSU'),
            'nome_usu': $scope.dataset.getFieldValue('NOMEUSU'),
            'email': $scope.dataset.getFieldValue('ACCOUNTEMAIL')
        })
        .then(function(response){
            var error = response.responseBody.error;
            var message = response.responseBody.message;

            if (error) {
          	  MessageUtils.showError(MessageUtils.TITLE_WARNING, i18n('Core.CadastroUsuarios.msgDesvincularAccountError', [message]));
            } else {
          	  $scope.dataset.setFieldValue('ACCOUNTEMAIL', null);
          	  changeState();
            }
        });
    }
    
    $scope.unlinkAccount = function (){
		var codUsuario = $scope.dataset.getFieldValue('CODUSU');
		var nomeUsuario = $scope.dataset.getFieldValue('NOMEUSU');
		var accountId = $scope.dataset.getFieldValue('ACCOUNTID');

		if (StringUtils.isEmpty(codUsuario)) {
            MessageUtils.showAlert(i18n('Core.CadastroUsuarios.msgSelecionarUsuario'));
        } else {
        	if (accountId) {	            	
        		SanPopup.open({
					title: i18n('Core.CadastroUsuarios.itemDesvincularAccount'),
					templateUrl: 'html5/CadastroUsuarios/popup/desvincularAccount.tpl.html',
					controller: 'DesvincularAccountController', 
					controllerAs: 'ctrl',
					size: 'alert',
					okBtnLabel: i18n('Core.CadastroUsuarios.buttonDesvincularAccount'),
					showBtnNo: false,
					resolve: {
						data: {
                            codUsuario: codUsuario,
                            nomeUsuario: nomeUsuario,
                        }
					}
				});
        	} else {
        		MessageUtils.showAlert(i18n('Core.CadastroUsuarios.msgAccountInexistente'));
        	}
        }
	}
    
    function changeState() {
        const { isInsertionMode, getFieldValue } = $scope.dataset;
        const hasAccountId = !!getFieldValue('ACCOUNTID');
        const hasAccountToken = !!getFieldValue('ACCOUNTTOKEN');
        const hasAccountEmail = !!getFieldValue('ACCOUNTEMAIL');
    
        $scope.stateComponent = 0;
    
        if (isInsertionMode()) {
            $scope.stateComponent = 1;
        } else if (!hasAccountId && !hasAccountToken) {
            $scope.stateComponent = hasAccountEmail ? 2 : 1;
        } else if (hasAccountId && hasAccountToken && hasAccountEmail) {
            $scope.stateComponent = 3;
        } else if (hasAccountId && !hasAccountToken && hasAccountEmail) {
            $scope.stateComponent = 4;
        }
    }    
    
    $scope.userName = function() {
        const token = $scope.dataset.getFieldValue('ACCOUNTTOKEN');
        if (!token) return null;
    
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = JSON.parse(atob(base64));
            return `${jsonPayload.first_name} ${jsonPayload.last_name}`;
        } catch (e) {
            return null;
        }
    };    
    
    $scope.getPhoto = function(){
    	var photo = $scope.dataset.getFieldValue('ACCOUNTNOMEFOTO');
    	var photoDefault = '/mge/img/userAcc.png';
    	if(photo){
    		return photo;
    	}
    	return photoDefault;
    }
    
    function validEmail(email){
    	var emailPattern =  /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,8})$/;
        return emailPattern.test(email);
    }
    
    function getData(){
    	return self.value;
    }
}]);

angular
    .module('snk.components.select')
    .service('SkRepeatParser', ['$parse', function ($parse) {
        /**
         * Example:
         * expression = "address in addresses | filter: {street: $select.search} track by $index"
         * itemName = "address",
         * source = "addresses | filter: {street: $select.search}",
         * trackByExp = "$index",
         */
        var self = this;
        self.parse = parse;
        self.getGroupNgRepeatExpression = getGroupNgRepeatExpression;
        self.getNgRepeatExpression = getNgRepeatExpression;

        function parse(expression) {
            var match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?([\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            if (!match) {
                throw new Error("Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '" + expression + "'.");
            }

            return {
                itemName: match[2], // (lhs) Left-hand side,
                source: $parse(match[3]),
                trackByExp: match[4],
                modelMapper: $parse(match[1] || match[2])
            };

        }

        function getGroupNgRepeatExpression() {
            return '$group in $select.groups';
        }

        function getNgRepeatExpression(itemName, source, trackByExp, grouped) {
            var expression = itemName + ' in ' + (grouped ? '$group.items' : source);

            if (trackByExp) {
                expression += ' track by ' + trackByExp;
            }

            return expression;
        }
    }]);
var latestId = 0;

angular
    .module('snk.components.select')
    .constant('skSelectConfig', {
        theme: 'bootstrap',
        searchEnabled: true,
        sortable: false,
        placeholder: '', // Empty by default, like HTML tag <select>
        refreshDelay: 1000, // In milliseconds
        closeOnSelect: true,
        generateId: function () {
            return latestId++;
        },
        appendToBody: false
    });
angular
    .module('snk.components.select')
    .controller('skSelectCtrl', ['$scope', '$document', '$element', '$timeout', '$filter', 'SkRepeatParser', 'skSelectConfig', 'SkConstants', 'UserAgentUtils', function ($scope, $document, $element, $timeout, $filter, SkRepeatParser, skSelectConfig, SkConstants, UserAgentUtils) {
        var _refreshDelayPromise;
        var EMPTY_SEARCH = '';
        var ctrl = this;

        ctrl.isMobile = UserAgentUtils.isMobile();
        ctrl.placeholder = skSelectConfig.placeholder;
        ctrl.searchEnabled = skSelectConfig.searchEnabled;
        ctrl.sortable = skSelectConfig.sortable;
        ctrl.refreshDelay = skSelectConfig.refreshDelay;
        ctrl.removeSelected = false; //If selected item(s) should be removed from dropdown list
        ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
        ctrl.search = EMPTY_SEARCH;
        ctrl.activeIndex = 0; //Dropdown of choices
        ctrl.items = []; //All available choices
        ctrl.open = false;
        ctrl.focus = false;
        ctrl.disabled = false;
        ctrl.selected = undefined;
        ctrl.focusser = undefined; //Reference to input element used to handle focus events
        ctrl.resetSearchInput = true;
        ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
        ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
        ctrl.tagging = {isActivated: false, fct: undefined};
        ctrl.taggingTokens = {isActivated: false, tokens: undefined};
        ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
        ctrl.clickTriggeredSelect = false;
        ctrl.$filter = $filter;
        ctrl.searchInput = angular.element($element[0].querySelector('input.ui-select-search'));
        ctrl.isEmpty = isEmpty;   

        if (ctrl.searchInput.length !== 1) {
            throw new Error("Expected 1 input.ui-select-search but got '" + ctrl.searchInput.length + "'.");
        }

        // Most of the time the user does not want to empty the search input when in typeahead mode
        function _resetSearchInput() {
            if (ctrl.resetSearchInput || (ctrl.resetSearchInput === undefined && skSelectConfig.resetSearchInput)) {
                ctrl.search = EMPTY_SEARCH;
                //reset activeIndex
                if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
                    ctrl.activeIndex = ctrl.items.indexOf(ctrl.selected);
                }
            }
        }

        function _groupsFilter(groups, groupNames) {
            var i;
            var j;
            var result = [];

            for (i = 0; i < groupNames.length; i++) {
                for (j = 0; j < groups.length; j++) {
                    if (groups[j].name == [groupNames[i]]) {
                        result.push(groups[j]);
                    }
                }
            }

            return result;
        }

        // When the user clicks on ui-select, displays the dropdown list
        ctrl.activate = function (initSearchValue, avoidReset) {
            if (!ctrl.disabled && !ctrl.open) {
                if (!avoidReset) {
                    _resetSearchInput();
                }

                $scope.$broadcast('uis:activate');

                ctrl.open = true;
                ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;

                // ensure that the index is set to zero for tagging variants
                // that where first option is auto-selected
                if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
                    ctrl.activeIndex = 0;
                }

                // Give it time to appear before focus
                $timeout(function () {
                    ctrl.search = initSearchValue || ctrl.search;

                    ctrl.searchInput[0].focus();
                }, 0, false);
            }
        };

        ctrl.findGroupByName = function (name) {
            return ctrl.groups && ctrl.groups.filter(function (group) {
                    return group.name === name;
                })[0];
        };

        ctrl.parseRepeatAttr = function (repeatAttr, groupByExp, groupFilterExp) {
            function updateGroups(items) {
                var groupFn = $scope.$eval(groupByExp);

                ctrl.groups = [];

                angular.forEach(items, function (item) {
                    var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
                    var group = ctrl.findGroupByName(groupName);

                    if (group) {
                        group.items.push(item);
                    } else {
                        ctrl.groups.push({name: groupName, items: [item]});
                    }
                });

                if (groupFilterExp) {
                    var groupFilterFn = $scope.$eval(groupFilterExp);

                    if (angular.isFunction(groupFilterFn)) {
                        ctrl.groups = groupFilterFn(ctrl.groups);
                    } else if (angular.isArray(groupFilterFn)) {
                        ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
                    }
                }

                ctrl.items = [];
                ctrl.groups.forEach(function (group) {
                    ctrl.items = ctrl.items.concat(group.items);
                });
            }

            function setPlainItems(items) {
                ctrl.items = items;
            }

            ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
            ctrl.parserResult = SkRepeatParser.parse(repeatAttr);
            ctrl.isGrouped = !!groupByExp;
            ctrl.itemProperty = ctrl.parserResult.itemName;

            ctrl.refreshItems = function (data) {
                var selectedItems = ctrl.selected;

                data = data || ctrl.parserResult.source($scope);

                //TODO should implement for single mode removeSelected
                if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.removeSelected) {
                    ctrl.setItemsFn(data);
                } else {
                    if (data !== undefined) {
                        var filteredItems = data.filter(function (i) {
                            return selectedItems && selectedItems.indexOf(i) < 0;
                        });

                        ctrl.setItemsFn(filteredItems);
                    }
                }
            };

            // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
            $scope.$watchCollection(ctrl.parserResult.source, function (items) {
                if (items === undefined || items === null) {
                    // If the user specifies undefined or null => reset the collection
                    // Special case: items can be undefined if the user did not initialized the collection on the scope
                    // i.e $scope.addresses = [] is missing
                    ctrl.items = [];
                } else {
                    if (!angular.isArray(items)) {
                        throw new Error("Expected an array but got '" + items + "'.");
                    } else {
                        //Remove already selected items (ex: while searching)
                        //TODO Should add a test
                        ctrl.refreshItems(items);
                        ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
                    }
                }
            });

        };

        /**
         * Typeahead mode: lets the user refresh the collection using his own function.
         *
         * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
         */
        ctrl.refresh = function (refreshAttr) {
            if (refreshAttr !== undefined) {
                // Debounce
                // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
                // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
                if (_refreshDelayPromise) {
                    $timeout.cancel(_refreshDelayPromise);
                }
                _refreshDelayPromise = $timeout(function () {
                    $scope.$eval(refreshAttr);
                }, ctrl.refreshDelay, false);
            }
        };

        ctrl.setActiveItem = function (item) {
            ctrl.activeIndex = ctrl.items.indexOf(item);
        };

        ctrl.isActive = function (itemScope) {
            var itemIndex;
            var isActive;

            if (!ctrl.open) {
                return false;
            }

            itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
            isActive = itemIndex === ctrl.activeIndex;

            if (!isActive || ( itemIndex < 0 && ctrl.taggingLabel !== false ) || ( itemIndex < 0 && ctrl.taggingLabel === false)) {
                return false;
            }

            if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
                itemScope.$eval(ctrl.onHighlightCallback);
            }

            return isActive;
        };

        ctrl.isDisabled = function (itemScope) {
            var isDisabled;
            var item;
            var itemIndex;

            if (!ctrl.open) {
                return;
            }

            itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
            isDisabled = false;

            if (itemIndex >= 0 && !angular.isUndefined(ctrl.disableChoiceExpression)) {
                item = ctrl.items[itemIndex];

                isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression)); // force the boolean value
                item._skSelectChoiceDisabled = isDisabled; // store this for later reference
            }

            return isDisabled;
        };

        ctrl.getChoiceTitle = function (item, label) {
            if (item) {
                var title = item[label];

                if (item.tooltip) {
                    title += ('\n' + item.tooltip);
                }

                return title;
            } else {
                return '';
            }
        };

        // When the user selects an item with ENTER or clicks the dropdown
        ctrl.select = function (item, skipFocusser, $event) {
            if (item === undefined || !item._skSelectChoiceDisabled) {
                if (!ctrl.items && !ctrl.search) {
                    return;
                }

                if (!item || !item._skSelectChoiceDisabled) {
                    if (ctrl.tagging.isActivated) {
                        // if taggingLabel is disabled, we pull from ctrl.search val
                        if (ctrl.taggingLabel === false) {
                            if (ctrl.activeIndex < 0) {
                                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;

                                if (!item || angular.equals(ctrl.items[0], item)) {
                                    return;
                                }
                            } else {
                                // keyboard nav happened first, user selected from dropdown
                                item = ctrl.items[ctrl.activeIndex];
                            }
                        } else {
                            // tagging always operates at index zero, taggingLabel === false pushes
                            // the ctrl.search value without having it injected
                            if (ctrl.activeIndex === 0) {
                                // ctrl.tagging pushes items to ctrl.items, so we only have empty val
                                // for `item` if it is a detected duplicate
                                if (item === undefined) return;

                                // create new item on the fly if we don't already have one;
                                // use tagging function if we have one
                                if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
                                    item = ctrl.tagging.fct(ctrl.search);

                                    if (!item) {
                                        return;
                                    }
                                    // if item type is 'string', apply the tagging label
                                } else if (typeof item === 'string') {
                                    // trim the trailing space
                                    item = item.replace(ctrl.taggingLabel, '').trim();
                                }
                            }
                        }
                        // search ctrl.selected for dupes potentially caused by tagging and return early if found
                        if (ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter(function (selection) {
                                return angular.equals(selection, item);
                            }).length > 0) {

                            ctrl.close(skipFocusser);

                            return;
                        }
                    }

                    $scope.$broadcast('uis:select', item);

                    var locals = {};
                    locals[ctrl.parserResult.itemName] = item;

                    $timeout(function () {
                        ctrl.onSelectCallback($scope, {
                            $item: item,
                            $model: ctrl.parserResult.modelMapper($scope, locals)
                        });
                    }, 0);

                    if (ctrl.closeOnSelect) {
                        ctrl.close(skipFocusser);
                    }
                    if ($event && $event.type === 'click') {
                        ctrl.clickTriggeredSelect = true;
                    }
                }
            }
        };

        // Closes the dropdown
        ctrl.close = function (skipFocusser) {
            if (!ctrl.open) {
                return;
            }

            if (ctrl.ngModel && ctrl.ngModel.$setTouched) {
                ctrl.ngModel.$setTouched();
            }

            _resetSearchInput();

            ctrl.open = false;

            $scope.$broadcast('uis:close', skipFocusser);

        };

        ctrl.setFocus = function () {
           if (!ctrl.focus) {
                ctrl.focusInput[0].focus();
           }
        };

        ctrl.clear = function ($event) {
            ctrl.select(undefined);

            $event.stopPropagation();

            $timeout(function () {
                ctrl.focusser[0].focus();
            }, 0, false);
        };

        // Toggle dropdown
        ctrl.toggle = function (e) {
            if (ctrl.open) {
                ctrl.close();
                
                if(e){
                    e.preventDefault();
                    e.stopPropagation();
                }
                
            } else {
                ctrl.activate();
            }
        };

        ctrl.isLocked = function (itemScope, itemIndex) {
            var isLocked, item = ctrl.selected[itemIndex];

            if (item && !angular.isUndefined(ctrl.lockChoiceExpression)) {
                isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression)); // force the boolean value
                item._skSelectChoiceLocked = isLocked; // store this for later reference
            }

            return isLocked;
        };

        var sizeWatch = null;
        ctrl.sizeSearchInput = function () {
            var input = ctrl.searchInput[0];
            var container = ctrl.searchInput.parent().parent()[0];

            var calculateContainerWidth = function () {
                // Return the container width only if the search input is visible
                return container.clientWidth * !!input.offsetParent;
            };

            var updateIfVisible = function (containerWidth) {
                if (containerWidth === 0) {
                    return false;
                }
                var inputWidth = containerWidth - input.offsetLeft - 10;
                if (inputWidth < 50) inputWidth = containerWidth;
                ctrl.searchInput.css('width', inputWidth + 'px');
                return true;
            };

            ctrl.searchInput.css('width', '10px');

            $timeout(function () { //Give tags time to render correctly
                if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
                    sizeWatch = $scope.$watch(calculateContainerWidth, function (containerWidth) {
                        if (updateIfVisible(containerWidth)) {
                            sizeWatch();
                            sizeWatch = null;
                        }
                    });
                }
            }, 0, false);
        };

        function _handleDropDownSelection(key) {
            var processed = true;
            switch (key) {
                case SkConstants.KEY_CODE.DOWN_ARROW:
                    if (!ctrl.open && ctrl.multiple) {
                        ctrl.activate(false, true);//In case its the search input in 'multiple' mode
                    } else if (ctrl.activeIndex < ctrl.items.length - 1) {
                        ctrl.activeIndex++;
                    }

                    break;
                case SkConstants.KEY_CODE.UP_ARROW:
                    if (!ctrl.open && ctrl.multiple) {
                        ctrl.activate(false, true);//In case its the search input in 'multiple' mode
                    } else if (ctrl.activeIndex > 0 || (ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1)) {
                        ctrl.activeIndex--;
                    }

                    break;
                case SkConstants.KEY_CODE.TAB:
                    if (!ctrl.multiple || ctrl.open) {
                        ctrl.select(ctrl.items[ctrl.activeIndex], true);
                    }

                    break;
                case SkConstants.KEY_CODE.ENTER:
                    if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
                        ctrl.select(ctrl.items[ctrl.activeIndex]); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
                    } else {
                        ctrl.activate(false, true); //In case its the search input in 'multiple' mode
                    }

                    break;
                case SkConstants.KEY_CODE.ESCAPE:
                    ctrl.close();

                    break;
                default:
                    processed = false;
            }

            return processed;
        }

        // Bind to keyboard shortcuts
        ctrl.searchInput.on(SkConstants.EVENTS.KEY_DOWN, function (e) {
            var key = e.which;

            $scope.$apply(function () {
                var tagged = false;

                if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
                    _handleDropDownSelection(key);

                    if (ctrl.taggingTokens.isActivated) {
                        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
                            if (ctrl.taggingTokens.tokens[i] === SkConstants.KEY_MAP[e.keyCode]) {
                                // make sure there is a new value to push via tagging
                                if (ctrl.search.length > 0) {
                                    tagged = true;
                                }
                            }
                        }
                        if (tagged) {
                            $timeout(function () {
                                var newItem;

                                ctrl.searchInput.triggerHandler('tagged');

                                newItem = ctrl.search.replace(SkConstants.KEY_MAP[e.keyCode], '').trim();

                                if (ctrl.tagging.fct) {
                                    newItem = ctrl.tagging.fct(newItem);
                                }

                                if (newItem) {
                                    ctrl.select(newItem, true);
                                }
                            }, 0, false);
                        }
                    }
                } else if (key == SkConstants.KEY_CODE.TAB) {
                    ctrl.close();
                }

            });

            if ((key === SkConstants.KEY_CODE.DOWN_ARROW || key === SkConstants.KEY_CODE.UP_ARROW) && ctrl.items.length > 0) {
                _ensureHighlightVisible(e);
            }

            if (key === SkConstants.KEY_CODE.ENTER || key === SkConstants.KEY_CODE.ESCAPE) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        // If tagging try to split by tokens and add items
        ctrl.searchInput.on('paste', function (e) {
            var data = e.originalEvent.clipboardData.getData('text/plain');

            if (data && data.length > 0 && ctrl.taggingTokens.isActivated && ctrl.tagging.fct) {
                var items = data.split(ctrl.taggingTokens.tokens[0]); // split by first token only

                if (items && items.length > 0) {
                    angular.forEach(items, function (item) {
                        var newItem = ctrl.tagging.fct(item);

                        if (newItem) {
                            ctrl.select(newItem, true);
                        }
                    });

                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        });

        ctrl.searchInput.on('tagged', function () {
            $timeout(function () {
                _resetSearchInput();
            }, 0, false);
        });

     // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
        function _ensureHighlightVisible(event) {
        	var index = 0;
            var container = $document[0].querySelectorAll('.ui-select-choices-content');
            var choices = container[0].querySelectorAll('.ui-select-choices-row');

            if(choices.length === 0){
            	index = 1;
            	choices = container[1].querySelectorAll('.ui-select-choices-row');
            }
            
            if (choices.length < 1) {
                event.stopPropagation();
                throw new Error("Expected multiple .ui-select-choices-row but got '" + choices.length + "'.");
            }

            if (ctrl.activeIndex < 0) {
                return;
            }

            var highlighted = choices[ctrl.activeIndex];
            var posY = highlighted.offsetTop + highlighted.clientHeight - container[index].scrollTop;
            var height = container[index].offsetHeight;

            if (posY > height) {
            	container[index].scrollTop += posY - height;
            } else if (posY < highlighted.clientHeight) {
                if (ctrl.isGrouped && ctrl.activeIndex === 0) {
                	container[index].scrollTop = 0; //To make group header visible when going all the way up
                } else {
                	container[index].scrollTop -= highlighted.clientHeight - posY;
                }
            }
        }

        function isEmpty() {
            return angular.isUndefined(ctrl.selected) || ctrl.selected === null || ctrl.selected === '';
        }        
       
        $scope.$on('$destroy', function () {
            ctrl.searchInput.off('keyup keydown tagged blur paste');
        });
    }]);
angular
    .module('snk.components.select')
    .directive('skSelect', ['$document', 'skSelectConfig', '$compile', '$parse', '$timeout', '$window', 'PositionUtils', 'SkConstants', function ($document, skSelectConfig, $compile, $parse, $timeout, $window, PositionUtils, SkConstants) {
        return {
            restrict: 'EA',
            templateUrl: function (tElement, tAttrs) {
                var theme = tAttrs.theme || skSelectConfig.theme;

                return 'components/select/' + theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
            },
            replace: true,
            transclude: true,
            require: ['skSelect', '^ngModel'],
            scope: true,
            controller: 'skSelectCtrl',
            controllerAs: '$select',
            compile: function (tElement, tAttrs) {
                var directionUpClassName = 'direction-up';

                //Multiple or Single depending if multiple attribute presence
                if (angular.isDefined(tAttrs.multiple)) {
                    tElement.append("<sk-select-multiple/>").removeAttr('multiple');
                } else {
                    tElement.append("<sk-select-single/>");
                }

                return function (scope, element, attrs, ctrls, transcludeFn) {
                    var $select = ctrls[0];
                    var ngModel = ctrls[1];
                    var appendToBody = attrs.appendToBody ? scope.$eval(attrs.appendToBody) : skSelectConfig.appendToBody;

                    $select.generatedId = skSelectConfig.generateId();
                    $select.baseTitle = attrs.title || 'Select box';
                    $select.focusserTitle = $select.baseTitle + ' focus';
                    $select.focusserId = 'focusser-' + $select.generatedId;
                    $select.closeOnSelect = function () {
                        if (angular.isDefined(attrs.closeOnSelect)) {
                            return $parse(attrs.closeOnSelect)();
                        } else {
                            return skSelectConfig.closeOnSelect;
                        }
                    }();

                    var $inputElement = angular.element(element.children().children()[1]);
                    $inputElement.bind('blur', function (e) {
                        element.removeClass('focused');
                        (scope.onFocusOut || angular.noop)(scope);
                    });
        
                    $inputElement.bind('focus', function () {
                        element.addClass('focused');
                        (scope.onFocus || angular.noop)(scope);
                    });

                    $select.onSelectCallback = $parse(attrs.onSelect);
                    $select.onRemoveCallback = $parse(attrs.onRemove);

                    //Limit the number of selections allowed
                    $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;

                    //Set reference to ngModel from uiSelectCtrl
                    $select.ngModel = ngModel;

                    $select.choiceGrouped = function (group) {
                        return $select.isGrouped && group && group.name;
                    };

                    if (attrs.tabindex) {
                        attrs.$observe('tabindex', function (value) {
                            $select.focusInput.attr("tabindex", value);

                            element.removeAttr("tabindex");
                        });
                    }

                    scope.$watch('searchEnabled', function () {
                        var searchEnabled = scope.$eval(attrs.searchEnabled);

                        $select.searchEnabled = searchEnabled !== undefined ? searchEnabled : skSelectConfig.searchEnabled;
                    });

                    scope.$watch('sortable', function () {
                        var sortable = scope.$eval(attrs.sortable);

                        $select.sortable = sortable !== undefined ? sortable : skSelectConfig.sortable;
                    });

                    attrs.$observe('disabled', function () {
                        // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
                        $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
                    });

                    scope.$watch('$select.search', function(){
                        if ($select.open && dropdownElem.hasClass(directionUpClassName)) {
                            dropdownElem[0].style.visibility = 'hidden';

                            $timeout(function(){
                                var offset = PositionUtils.offset(element);
                                var offsetDropdown = PositionUtils.offset(dropdownElem);

                                var newTop;

                                if (appendToBody) {
                                    newTop = (offset.top - offsetDropdown.height - 2);
                                } else {
                                    newTop = (offsetDropdown.height * -2) - 2;
                                }

                                dropdownElem[0].style.top = newTop + 'px';

                                dropdownElem[0].style.visibility = 'visible';
                            },  0, false);
                        }
                    });

                    attrs.$observe('resetSearchInput', function () {
                        // $eval() is needed otherwise we get a string instead of a boolean
                        var resetSearchInput = scope.$eval(attrs.resetSearchInput);

                        $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
                    });

                    attrs.$observe('tagging', function () {
                        if (attrs.tagging !== undefined) {
                            // $eval() is needed otherwise we get a string instead of a boolean
                            var taggingEval = scope.$eval(attrs.tagging);

                            $select.tagging = {
                                isActivated: true,
                                fct: taggingEval !== true ? taggingEval : undefined
                            };
                        }
                        else {
                            $select.tagging = {isActivated: false, fct: undefined};
                        }
                    });

                    attrs.$observe('taggingLabel', function () {
                        if (attrs.tagging !== undefined) {
                            // check eval for FALSE, in this case, we disable the labels
                            // associated with tagging
                            if (attrs.taggingLabel === 'false') {
                                $select.taggingLabel = false;
                            }
                            else {
                                $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
                            }
                        }
                    });

                    attrs.$observe('taggingTokens', function () {
                        if (attrs.tagging !== undefined) {
                            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];

                            $select.taggingTokens = {isActivated: true, tokens: tokens};
                        }
                    });

                    //Automatically gets focus when loaded
                    if (angular.isDefined(attrs.autofocus)) {
                        $timeout(function () {
                            $select.setFocus();
                        }, 0, false);
                    }

                    //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
                    if (angular.isDefined(attrs.focusOn)) {
                        scope.$on(attrs.focusOn, function () {
                            $timeout(function () {
                                $select.setFocus();
                            }, 0, false);
                        });
                    }

                    function onDocumentClick(e) {
                        var contains;

                        if (!$select.open) {
                            $select.clickTriggeredSelect = false;
                            return;//Skip it if dropdown is close
                        }

                        contains = element[0].contains(e.target);

                        if (!contains && !$select.clickTriggeredSelect) {
                            //Will lose focus only with certain targets
                            var focusableControls = ['input', 'button', 'textarea'];
                            var targetController = angular.element(e.target).controller('SkSelect'); //To check if target is other ui-select
                            var skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select

                            if (!skipFocusser) {
                                skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase());//Check if target is input, button or textarea
                            }

                            $select.close(skipFocusser);

                            scope.$digest();
                        }

                        $select.clickTriggeredSelect = false;
                    }

                    // See Click everywhere but here event http://stackoverflow.com/questions/12931369
                    $document.on('click touchend', onDocumentClick);

                    scope.$on('$destroy', function () {
                        $timeout(function() {
                            $document.off('click touchend', onDocumentClick);
                        });
                    });

                    // Move transcluded elements to their correct position in main template
                    transcludeFn(scope, function (clone) {
                        // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html

                        // One day jqLite will be replaced by jQuery and we will be able to write:
                        // var transcludedElement = clone.filter('.my-class')
                        // instead of creating a hackish DOM element:
                        var transcluded = angular.element('<div>').append(clone);
                        var transcludedMatch = angular.element(transcluded[0].querySelector('.ui-select-match'));

                        transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
                        transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes

                        if (transcludedMatch.length !== 1) {
                            throw new Error("Expected 1 .ui-select-match but got '" + transcludedMatch.length + "'.");
                        }

                        angular.element(element[0].querySelector('.ui-select-match')).replaceWith(transcludedMatch);

                        var transcludedChoices = angular.element(transcluded[0].querySelector('.ui-select-choices'));
                        transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
                        transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes

                        if (transcludedChoices.length !== 1) {
                            throw new Error("Expected 1 .ui-select-choices but got '" + transcludedChoices.length + "'.");
                        }

                        angular.element(element[0].querySelector('.ui-select-choices')).replaceWith(transcludedChoices);
                    });

                    // Hold on to a reference to the .ui-select-container element for appendToBody support
                    var placeholder = null;
                    var originalWidth = '';
                    var dropdownElem;

                    function resizeHandler() {
                        if ($select.open) {
                            $select.close();
                        }
                    }

                    function positionDropdown() {
                        var offset = PositionUtils.offset(element);

                        if (!dropdownElem) {
                            dropdownElem = angular.element(element[0].querySelector('.ui-select-dropdown'));
                        }

                        // Remember the original value of the element width inline style, so it can be restored
                        // when the dropdown is closed
                        originalWidth = dropdownElem[0].style.width;

                        // Now move the actual dropdown element to the end of the body
                        $document.find('body').append(dropdownElem);

                        dropdownElem[0].style.position = 'absolute';
                        dropdownElem[0].style.left = offset.left + 'px';
                        dropdownElem[0].style.top = (offset.top + offset.height + 1) + 'px';
                        dropdownElem[0].style.width = offset.width + 'px';
                    }

                    function resetDropdown() {
                        if (!dropdownElem) {
                            return;
                        }

                        dropdownElem[0].style.position = '';
                        dropdownElem[0].style.left = '';
                        dropdownElem[0].style.top = '';
                        dropdownElem[0].style.width = originalWidth;
                    }

                    // Support changing the direction of the dropdown if there isn't enough space to render it.
                    scope.$watch('$select.open', function (isOpen) {
                        if (!dropdownElem) {
                            dropdownElem = angular.element(element[0].querySelector('.ui-select-dropdown'));
                        }

                        dropdownElem[0].style.visibility = 'hidden';

                        if (isOpen) {
                            if (!dropdownElem) {
                                return;
                            }

                            dropdownElem.addClass('open');

                            if (appendToBody) {
                                $window.addEventListener(SkConstants.EVENTS.RESIZE, resizeHandler);

                                positionDropdown();

                                scope.$on('$destroy', function () {
                                    $window.removeEventListener(SkConstants.EVENTS.RESIZE, resizeHandler);
                                });
                            }

                            // Delay positioning the dropdown until all choices have been added so its height is correct.
                            $timeout(function () {
                                var offset = PositionUtils.offset(element);
                                var offsetDropdown = PositionUtils.offset(dropdownElem);

                                // Determine if the direction of the dropdown needs to be changed.
                                if (offset.top + offset.height + offsetDropdown.height > $document.scrollTop() + $document[0].documentElement.clientHeight) {
                                    var newTop = 0;

                                    if (appendToBody) {
                                        newTop = (offsetDropdown.top + (offsetDropdown.height * -1) - offset.height - 2);
                                    } else {
                                        newTop = (offsetDropdown.height * -1) - 2;
                                    }

                                    dropdownElem[0].style.position = 'absolute';
                                    dropdownElem[0].style.top = newTop + 'px';

                                    element.addClass(directionUpClassName);
                                    dropdownElem.addClass(directionUpClassName);
                                }

                                // Display the dropdown once it has been positioned.
                                dropdownElem[0].style.visibility = 'visible';
                            }, 0, false);
                        } else {
                            if (!dropdownElem) {
                                return;
                            }

                            if (appendToBody) {
                                $window.removeEventListener(SkConstants.EVENTS.RESIZE, resizeHandler);
                            }

                            resetDropdown();

                            dropdownElem.removeClass('open');
                            dropdownElem.removeClass(directionUpClassName);

                            element.removeClass(directionUpClassName);
                        }
                    });
                };
            }
        };
    }]);
angular
    .module('snk.components.select')
    .directive('skSelectChoices', ['skSelectConfig', 'SkRepeatParser', '$compile', function (skSelectConfig, SkRepeatParser, $compile) {
        return {
            restrict: 'EA',
            require: '^skSelect',
            replace: true,
            transclude: true,
            templateUrl: function (tElement) {
                // Needed so the uiSelect can detect the transcluded content
                tElement.addClass('ui-select-choices');

                // Gets theme attribute from parent (ui-select)
                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
                return 'components/select/' + theme + '/choices.tpl.html';
            },
            compile: function (tElement, tAttrs) {
                if (!tAttrs.repeat) {
                    throw new Error("Expected 'repeat' expression.");
                }

                return linkFn;
            }
        };

        function linkFn(scope, element, attrs, $select, transcludeFn) {
            // var repeat = RepeatParser.parse(attrs.repeat);
            var groupByExp = attrs.groupBy;
            var groupFilterExp = attrs.groupFilter;

            $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
            $select.disableChoiceExpression = attrs.uiDisableChoice;
            $select.onHighlightCallback = attrs.onHighlight;

            if (groupByExp) {
                var groups = angular.element(element[0].querySelector('.ui-select-choices-group'));

                if (groups.length !== 1) {
                    throw new Error("Expected 1 .ui-select-choices-group but got '" + groups.length + "'.");
                }

                groups.attr('ng-repeat', SkRepeatParser.getGroupNgRepeatExpression());
            }

            var choices = angular.element(element[0].querySelector('.ui-select-choices-row'));

            if (choices.length !== 1) {
                throw new Error("Expected 1 .ui-select-choices-row but got '" + choices.length + "'.");
            }

            choices.attr('ng-repeat', SkRepeatParser.getNgRepeatExpression($select.parserResult.itemName, '$select.items', $select.parserResult.trackByExp, groupByExp))
                .attr('ng-if', '$select.open') //Prevent unnecessary watches when dropdown is closed
                .attr('ng-mouseenter', '$select.setActiveItem(' + $select.parserResult.itemName + ')')
                .attr('ng-click', '$select.select(' + $select.parserResult.itemName + ',false,$event)')
                .attr('title', '{{$select.getChoiceTitle(' + $select.parserResult.itemName + ', label)}}');

            var rowsInner = angular.element(element[0].querySelector('.ui-select-choices-row-inner'));

            if (rowsInner.length !== 1) {
                throw new Error("Expected 1 .ui-select-choices-row-inner but got '" + rowsInner.length + "'.");
            }

            rowsInner.attr('sk-transclude-append', ''); //Adding skTranscludeAppend directive to row element after choices element has ngRepeat

            $compile(element, transcludeFn)(scope); //Passing current transcludeFn to be able to append elements correctly from skTranscludeAppend

            scope.$watch('$select.search', function (newValue) {
                if (newValue && !$select.open && $select.multiple) {
                    $select.activate(false, true);
                }

                $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
                $select.refresh(attrs.refresh);
            });

            attrs.$observe('refreshDelay', function () {
                // $eval() is needed otherwise we get a string instead of a number
                var refreshDelay = scope.$eval(attrs.refreshDelay);

                $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : skSelectConfig.refreshDelay;
            });
        }
    }]);
angular
    .module('snk.components.select')
    .filter('highlight', function () {
        function escapeRegexp(queryToEscape) {
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }

        return function (matchItem, query) {
            return query && matchItem ? matchItem.replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
        };
    });
angular
    .module('snk.components.select')
    .directive('skSelectMatch', ['skSelectConfig', function (skSelectConfig) {
        return {
            restrict: 'EA',
            require: '^skSelect',
            replace: true,
            transclude: true,
            templateUrl: function (tElement) {
                // Needed so the uiSelect can detect the transcluded content
                tElement.addClass('ui-select-match');

                var parent = tElement.parent();

                // Gets theme attribute from parent (ui-select)
                var theme = parent.attr('theme') || skSelectConfig.theme;
                var multi = parent.attr('multiple');

                return 'components/select/' + theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
            },
            link: function (scope, element, attrs, $select) {
                $select.lockChoiceExpression = attrs.skLockChoice;

                attrs.$observe('placeholder', function (placeholder) {
                    $select.placeholder = placeholder !== undefined ? placeholder : skSelectConfig.placeholder;
                });

                function setAllowClear(allow) {
                    $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
                }

                attrs.$observe('allowClear', setAllowClear);
                
                setAllowClear(attrs.allowClear);

                if ($select.multiple) {
                    $select.sizeSearchInput();
                }

            }
        };
    }]);
angular
    .module('snk.components.select')
    .controller('SkSelectMultipleCtrl', ['$scope', '$timeout', function ($scope, $timeout) {
        var self = this;
        var $select = $scope.$select;
        var ngModel;

        //Wait for link fn to inject it
        $scope.$evalAsync(function () {
            ngModel = $scope.ngModel;
        });

        self.activeMatchIndex = -1;

        self.updateModel = function () {
            ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes

            self.refreshComponent();
        };

        self.refreshComponent = function () {
            //Remove already selected items
            //e.g. When user clicks on a selection, the selected array changes and
            //the dropdown should remove that item
            $select.refreshItems();
            $select.sizeSearchInput();
        };

        // Remove item from multiple select
        self.removeChoice = function (index) {
            var removedChoice = $select.selected[index];

            // if the choice is locked, can't remove it
            if (removedChoice._skSelectChoiceLocked) return;

            var locals = {};
            locals[$select.parserResult.itemName] = removedChoice;

            $select.selected.splice(index, 1);
            self.activeMatchIndex = -1;
            $select.sizeSearchInput();

            // Give some time for scope propagation.
            $timeout(function () {
                $select.onRemoveCallback($scope, {
                    $item: removedChoice,
                    $model: $select.parserResult.modelMapper($scope, locals)
                });
            }, 0, false);

            self.updateModel();

        };

        self.getPlaceholder = function () {
            //Refactor single?
            if ($select.selected && $select.selected.length) {
                return;
            }

            return $select.placeholder;
        };
    }]);
angular
    .module('snk.components.select')
    .directive('skSelectMultiple', ['$timeout', 'SkConstants', 'KeyboardManager', function ($timeout, SkConstants, KeyboardManager) {
        return {
            restrict: 'EA',
            require: ['^skSelect', '^ngModel'],
            controller: 'SkSelectMultipleCtrl',
            controllerAs: '$selectMultiple',
            link: function (scope, element, attrs, ctrls) {
                var $select = ctrls[0];
                var ngModel = scope.ngModel = ctrls[1];
                var $selectMultiple = scope.$selectMultiple;

                //$select.selected = raw selected objects (ignoring any property binding)

                $select.multiple = true;
                $select.removeSelected = true;

                //Input that will handle focus
                $select.focusInput = $select.searchInput;

                //From view --> model
                ngModel.$parsers.unshift(function () {
                    var locals = {};
                    var result;
                    var resultMultiple = [];

                    for (var j = $select.selected.length - 1; j >= 0; j--) {
                        locals = {};
                        locals[$select.parserResult.itemName] = $select.selected[j];
                        result = $select.parserResult.modelMapper(scope, locals);
                        resultMultiple.unshift(result);
                    }
                    return resultMultiple;
                });

                // From model --> view
                ngModel.$formatters.unshift(function (inputValue) {
                    var data = $select.parserResult.source(scope, {$select: {search: ''}}); //Overwrite $search
                    var locals = {};
                    var result;
                    var resultMultiple = [];

                    if (!data) {
                        return inputValue;
                    }

                    var checkFnMultiple = function (list, value) {
                        if (!list || !list.length) {
                            return;
                        }

                        for (var p = list.length - 1; p >= 0; p--) {
                            locals[$select.parserResult.itemName] = list[p];
                            result = $select.parserResult.modelMapper(scope, locals);

                            if ($select.parserResult.trackByExp) {
                                var matches = /\.(.+)/.exec($select.parserResult.trackByExp);

                                if (matches.length > 0 && result[matches[1]] == value[matches[1]]) {
                                    resultMultiple.unshift(list[p]);

                                    return true;
                                }
                            }

                            if (angular.equals(result, value)) {
                                resultMultiple.unshift(list[p]);

                                return true;
                            }
                        }
                        return false;
                    };

                    if (!inputValue) {
                        return resultMultiple;//If ngModel was undefined
                    }

                    for (var k = inputValue.length - 1; k >= 0; k--) {
                        //Check model array of currently selected items
                        if (!checkFnMultiple($select.selected, inputValue[k])) {
                            //Check model array of all items available
                            if (!checkFnMultiple(data, inputValue[k])) {
                                //If not found on previous lists, just add it directly to resultMultiple
                                resultMultiple.unshift(inputValue[k]);
                            }
                        }
                    }

                    return resultMultiple;
                });

                //Watch for external model changes
                scope.$watchCollection(function () {
                    return ngModel.$modelValue;
                }, function (newValue, oldValue) {
                    if (oldValue != newValue) {
                        ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters

                        $selectMultiple.refreshComponent();
                    }
                });

                ngModel.$render = function () {
                    // Make sure that model value is array
                    if (!angular.isArray(ngModel.$viewValue)) {
                        // Have tolerance for null or undefined values
                        if (angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue === null) {
                            $select.selected = [];
                        } else {
                            throw new Error("Expected model value to be array but got '" + ngModel.$viewValue + "'");
                        }
                    }

                    $select.selected = ngModel.$viewValue;

                    scope.$evalAsync(); //To force $digest
                };

                scope.$on('uis:select', function (event, item) {
                    if ($select.selected.length >= $select.limit) {
                        return;
                    }

                    $select.selected.push(item);
                    $selectMultiple.updateModel();
                });

                scope.$on('uis:activate', function () {
                    $selectMultiple.activeMatchIndex = -1;
                });

                scope.$watch('$select.disabled', function (newValue, oldValue) {
                    // As the search input field may now become visible, it may be necessary to recompute its size
                    if (oldValue && !newValue) {
                        $select.sizeSearchInput();
                    }
                });

                $select.searchInput.on('keydown', function (e) {
                    var key = e.which;

                    scope.$apply(function () {
                        var processed = false;
                        // var tagged = false; //Checkme
                        if (isHorizontalMovement(key)) {
                            processed = _handleMatchSelection(key);
                        }

                        if (processed && key != KEY.TAB) {
                            //TODO Check si el tab selecciona aun correctamente
                            //Crear test
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    });
                });

                function _getCaretPosition(el) {
                    if (angular.isNumber(el.selectionStart)) {
                        return el.selectionStart;
                    } else {
                        return el.value.length;// selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
                    }
                }

                // Handles selected options in "multiple" mode
                function _handleMatchSelection(key) {
                    var caretPosition = _getCaretPosition($select.searchInput[0]);
                    var length = $select.selected.length;
                    var first = 0;
                    var last = length - 1;
                    var curr = $selectMultiple.activeMatchIndex;
                    var next = $selectMultiple.activeMatchIndex + 1;
                    var prev = $selectMultiple.activeMatchIndex - 1;
                    var newIndex = curr;
                    //var none  = -1;

                    if (caretPosition > 0 || ($select.search.length && key == SkConstants.KEY_CODE.RIGHT_ARROW)) {
                        return false;
                    }

                    $select.close();

                    function getNewActiveMatchIndex() {
                        switch (key) {
                            case SkConstants.KEY_CODE.LEFT_ARROW:
                                // Select previous/first item
                                if (~$selectMultiple.activeMatchIndex) {
                                    return prev;
                                } else {
                                    return last;//Select last item
                                }

                                break;
                            case SkConstants.KEY_CODE.RIGHT_ARROW:
                                // Open drop-down
                                if (!~$selectMultiple.activeMatchIndex || curr === last) {
                                    $select.activate();

                                    return false;
                                } else {
                                    return next;//Select next/last item
                                }

                                break;
                            case SkConstants.KEY_CODE.BACKSPACE:
                                // Remove selected item and select previous/first
                                if (~$selectMultiple.activeMatchIndex) {
                                    $selectMultiple.removeChoice(curr);

                                    return prev;
                                } else {
                                    return last;//Select last item
                                }

                                break;
                            case SkConstants.KEY_CODE.DELETE:
                                // Remove selected item and select next item
                                if (~$selectMultiple.activeMatchIndex) {
                                    $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);

                                    return curr;
                                } else {
                                    return false;
                                }
                        }
                    }

                    newIndex = getNewActiveMatchIndex();

                    if (!$select.selected.length || newIndex === false) {
                        $selectMultiple.activeMatchIndex = -1;
                    } else {
                        $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
                    }

                    return true;
                }

                $select.searchInput.on('keyup', function (e) {
                    if (!KeyboardManager.isVerticalMovement(e.which)) {
                        scope.$evalAsync(function () {
                            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
                        });
                    }

                    // Push a "create new" item into array if there is a search string
                    if ($select.tagging.isActivated && $select.search.length > 0) {

                        // return early with these keys
                        if (e.which === SkConstants.KEY_CODE.TAB || KeyboardManager.isControl(e) || KeyboardManager.isFunctionKey(e) || e.which === SkConstants.KEY_CODE.ESCAPE || KeyboardManager.isVerticalMovement(e.which)) {
                            return;
                        }
                        // always reset the activeIndex to the first item when tagging
                        $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
                        // taggingLabel === false bypasses all of this
                        if ($select.taggingLabel === false) return;

                        var items = angular.copy($select.items);
                        var stashArr = angular.copy($select.items);
                        var newItem;
                        var item;
                        var hasTag = false;
                        var dupeIndex = -1;
                        var tagItems;
                        var tagItem;

                        // case for object tagging via transform `$select.tagging.fct` function
                        if ($select.tagging.fct !== undefined) {
                            tagItems = $select.$filter('filter')(items, {'isTag': true});

                            if (tagItems.length > 0) {
                                tagItem = tagItems[0];
                            }
                            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
                            if (items.length > 0 && tagItem) {
                                hasTag = true;
                                items = items.slice(1, items.length);
                                stashArr = stashArr.slice(1, stashArr.length);
                            }

                            newItem = $select.tagging.fct($select.search);
                            newItem.isTag = true;
                            // verify the the tag doesn't match the value of an existing item
                            if (stashArr.filter(function (origItem) {
                                    return angular.equals(origItem, $select.tagging.fct($select.search));
                                }).length > 0) {
                                return;
                            }
                            newItem.isTag = true;
                            // handle newItem string and stripping dupes in tagging string context
                        } else {
                            // find any tagging items already in the $select.items array and store them
                            tagItems = $select.$filter('filter')(items, function (item) {
                                return item.match($select.taggingLabel);
                            });

                            if (tagItems.length > 0) {
                                tagItem = tagItems[0];
                            }

                            item = items[0];
                            // remove existing tag item if found (should only ever be one tag item)
                            if (item !== undefined && items.length > 0 && tagItem) {
                                hasTag = true;
                                items = items.slice(1, items.length);
                                stashArr = stashArr.slice(1, stashArr.length);
                            }
                            newItem = $select.search + ' ' + $select.taggingLabel;
                            if (_findApproxDupe($select.selected, $select.search) > -1) {
                                return;
                            }
                            // verify the the tag doesn't match the value of an existing item from
                            // the searched data set or the items already selected
                            if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
                                // if there is a tag from prev iteration, strip it / queue the change
                                // and return early
                                if (hasTag) {
                                    items = stashArr;

                                    scope.$evalAsync(function () {
                                        $select.activeIndex = 0;
                                        $select.items = items;
                                    });
                                }

                                return;
                            }
                            if (_findCaseInsensitiveDupe(stashArr)) {
                                // if there is a tag from prev iteration, strip it
                                if (hasTag) {
                                    $select.items = stashArr.slice(1, stashArr.length);
                                }

                                return;
                            }
                        }
                        if (hasTag) {
                            dupeIndex = _findApproxDupe($select.selected, newItem);
                        }

                        // dupe found, shave the first item
                        if (dupeIndex > -1) {
                            items = items.slice(dupeIndex + 1, items.length - 1);
                        } else {
                            items = [];
                            items.push(newItem);
                            items = items.concat(stashArr);
                        }
                        scope.$evalAsync(function () {
                            $select.activeIndex = 0;
                            $select.items = items;
                        });
                    }
                });

                function _findCaseInsensitiveDupe(arr) {
                    if (arr === undefined || $select.search === undefined) {
                        return false;
                    }

                    var hasDupe = arr.filter(function (origItem) {
                            if ($select.search.toUpperCase() === undefined || origItem === undefined) {
                                return false;
                            }
                            return origItem.toUpperCase() === $select.search.toUpperCase();
                        }).length > 0;

                    return hasDupe;
                }

                function _findApproxDupe(haystack, needle) {
                    var dupeIndex = -1;

                    if (angular.isArray(haystack)) {
                        var tempArr = angular.copy(haystack);

                        for (var i = 0; i < tempArr.length; i++) {
                            // handle the simple string version of tagging
                            if ($select.tagging.fct === undefined) {
                                // search the array for the match
                                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
                                    dupeIndex = i;
                                }
                                // handle the object tagging implementation
                            } else {
                                var mockObj = tempArr[i];
                                mockObj.isTag = true;

                                if (angular.equals(mockObj, needle)) {
                                    dupeIndex = i;
                                }
                            }
                        }
                    }

                    return dupeIndex;
                }

                $select.searchInput.on('blur', function () {
                    $timeout(function () {
                        $selectMultiple.activeMatchIndex = -1;
                    }, 0, false);
                });

            }
        };
    }]);
angular
    .module('snk.components.select')
    .directive('skSelectSingle', ['$timeout', '$compile', 'KeyboardManager', 'SkConstants', 'UserAgentUtils', function ($timeout, $compile, KeyboardManager, SkConstants, UserAgentUtils) {
        return {
            restrict: 'EA',
            require: ['^skSelect', '^ngModel'],
            link: function (scope, element, attrs, ctrls) {
                var $select = ctrls[0];
                var ngModel = ctrls[1];

                //From view --> model
                ngModel.$parsers.unshift(function (inputValue) {
                    var locals = {};
                    var result;

                    locals[$select.parserResult.itemName] = inputValue;
                    result = $select.parserResult.modelMapper(scope, locals);

                    return result;
                });

                //From model --> view
                ngModel.$formatters.unshift(function (inputValue) {
                    var data = $select.parserResult.source(scope, {$select: {search: ''}}); //Overwrite $search
                    var locals = {};
                    var result;

                    if (data) {
                        var checkFnSingle = function (d) {
                            locals[$select.parserResult.itemName] = d;
                            result = $select.parserResult.modelMapper(scope, locals);
                            return result == inputValue;
                        };

                        //If possible pass same object stored in $select.selected
                        if ($select.selected && checkFnSingle($select.selected)) {
                            return $select.selected;
                        }

                        for (var i = data.length - 1; i >= 0; i--) {
                            if (checkFnSingle(data[i])) return data[i];
                        }
                    }

                    return inputValue;
                });

                //Update viewValue if model change
                scope.$watch('$select.selected', function (newValue) {
                    if (ngModel.$viewValue !== newValue) {
                        ngModel.$setViewValue(newValue);
                    }
                });

                ngModel.$render = function () {
                    $select.selected = ngModel.$viewValue;
                };

                scope.$on('uis:select', function (event, item) {
                    $select.selected = item;
                });

                scope.$on('uis:close', function (event, skipFocusser) {
                    $timeout(function () {
                        $select.focusser.prop('disabled', false);

                        if (!skipFocusser && !UserAgentUtils.isMobile()) {
                            $select.focusser[0].focus();
                        }
                    }, 0, false);
                });

                scope.$on('uis:activate', function () {
                    focusser.prop('disabled', true); //Will reactivate it on .close()
                });

                //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
                var focusser = angular.element("<input ng-disabled='$select.disabled || $select.isMobile' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");

                $compile(focusser)(scope);

                $select.focusser = focusser;

                //Input that will handle focus
                $select.focusInput = focusser;

                element.parent().append(focusser);

                focusser.bind("focus", function () {
                    scope.$evalAsync(function () {
                        $select.focus = true;
                    });
                });

                focusser.bind("blur", function () {
                    scope.$evalAsync(function () {
                        $select.focus = false;
                    });
                });

                focusser.bind("keydown", function (e) {
                    if (e.which === SkConstants.KEY_CODE.BACKSPACE) {
                        e.preventDefault();
                        e.stopPropagation();

                        $select.select(undefined);

                        scope.$apply();

                        return;
                    }

                    if (e.which == SkConstants.KEY_CODE.ENTER || e.which === SkConstants.KEY_CODE.TAB || KeyboardManager.isControl(e) || KeyboardManager.isFunctionKey(e) || e.which === SkConstants.KEY_CODE.ESCAPE) {
                        return;
                    }

                    if (e.which == SkConstants.KEY_CODE.DOWN_ARROW || e.which == SkConstants.KEY_CODE.UP_ARROW || e.which == SkConstants.KEY_CODE.SPACE) {
                        e.preventDefault();
                        e.stopPropagation();

                        $select.activate();
                    }

                    scope.$digest();
                });

                focusser.bind("keyup input", function (e) {
                    if (e.which === SkConstants.KEY_CODE.TAB || KeyboardManager.isControl(e) || KeyboardManager.isFunctionKey(e) || e.which === SkConstants.KEY_CODE.ESCAPE || e.which == SkConstants.KEY_CODE.ENTER || e.which === SkConstants.KEY_CODE.BACKSPACE) {
                        return;
                    }

                    $select.activate(focusser.val());//User pressed some regular key, so we pass it to the search input

                    focusser.val('');

                    scope.$digest();

                });
            }
        };
    }]);
angular
    .module('snk.components.select')
    .directive('skSelectSort', ['$timeout', 'skSelectConfig', function ($timeout, skSelectConfig) {
        return {
            require: '^skSelect',
            link: function (scope, element, attrs, $select) {
                if (scope[attrs.uiSelectSort] === null) {
                    throw new Error("Expected a list to sort");
                }

                var options = angular.extend({
                        axis: 'horizontal'
                    },
                    scope.$eval(attrs.uiSelectSortOptions));

                var axis = options.axis;
                var draggingClassName = 'dragging';
                var droppingClassName = 'dropping';
                var droppingBeforeClassName = 'dropping-before';
                var droppingAfterClassName = 'dropping-after';

                scope.$watch(function () {
                    return $select.sortable;
                }, function (n) {
                    if (n) {
                        element.attr('draggable', true);
                    } else {
                        element.removeAttr('draggable');
                    }
                });

                element.on('dragstart', function (e) {
                    element.addClass(draggingClassName);

                    (e.dataTransfer || e.originalEvent.dataTransfer).setData('text/plain', scope.$index);
                });

                element.on('dragend', function () {
                    element.removeClass(draggingClassName);
                });

                var move = function (from, to) {
                    this.splice(to, 0, this.splice(from, 1)[0]);
                };

                var dragOverHandler = function (e) {
                    e.preventDefault();

                    var offset = axis === 'vertical' ? e.offsetY || e.layerY || (e.originalEvent ? e.originalEvent.offsetY : 0) : e.offsetX || e.layerX || (e.originalEvent ? e.originalEvent.offsetX : 0);

                    if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
                        element.removeClass(droppingAfterClassName);
                        element.addClass(droppingBeforeClassName);

                    } else {
                        element.removeClass(droppingBeforeClassName);
                        element.addClass(droppingAfterClassName);
                    }
                };

                var dropTimeout;

                var dropHandler = function (e) {
                    var droppedItemIndex

                    e.preventDefault();

                    droppedItemIndex = parseInt((e.dataTransfer || e.originalEvent.dataTransfer).getData('text/plain'), 10);

                    // prevent event firing multiple times in firefox
                    $timeout.cancel(dropTimeout);

                    dropTimeout = $timeout(function () {
                        _dropHandler(droppedItemIndex);
                    }, 20, false);
                };

                var _dropHandler = function (droppedItemIndex) {
                    var theList = scope.$eval(attrs.uiSelectSort);
                    var itemToMove = theList[droppedItemIndex];
                    var newIndex = null;

                    if (element.hasClass(droppingBeforeClassName)) {
                        if (droppedItemIndex < scope.$index) {
                            newIndex = scope.$index - 1;
                        } else {
                            newIndex = scope.$index;
                        }
                    } else {
                        if (droppedItemIndex < scope.$index) {
                            newIndex = scope.$index;
                        } else {
                            newIndex = scope.$index + 1;
                        }
                    }

                    move.apply(theList, [droppedItemIndex, newIndex]);

                    scope.$apply(function () {
                        scope.$emit('skSelectSort:change', {
                            array: theList,
                            item: itemToMove,
                            from: droppedItemIndex,
                            to: newIndex
                        });
                    });

                    element.removeClass(droppingClassName);
                    element.removeClass(droppingBeforeClassName);
                    element.removeClass(droppingAfterClassName);

                    element.off('drop', dropHandler);
                };

                element.on('dragenter', function () {
                    if (element.hasClass(draggingClassName)) {
                        return;
                    }

                    element.addClass(droppingClassName);
                    element.on('dragover', dragOverHandler);
                    element.on('drop', dropHandler);
                });

                element.on('dragleave', function (e) {
                    if (e.target != element) {
                        return;
                    }

                    element.removeClass(droppingClassName);
                    element.removeClass(droppingBeforeClassName);
                    element.removeClass(droppingAfterClassName);

                    element.off('dragover', dragOverHandler);
                    element.off('drop', dropHandler);
                });
            }
        };
    }]);
angular
    .module('snk.components.select')
    .directive('skTranscludeAppend', [function () {
        return {
            link: function (scope, element, attrs, ctrl, transclude) {
                transclude(scope, function (clone) {
                    element.append(clone);
                });
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name snk.components.sglclick.directive:sglclick
 * @restrict A

 * @description
 *	 	Esse diretiva é responsável por permitir utilizar duplo click junto com o um click. 
 *
 * @param {function} [sk-sgl-click] Função chamada ao adicionar um click no elemento.
 *
 * @example
     <example module="app">
         <file name="sglclick.html">
            <div ng-controller="MyController">
             	<sk-hbox  layout-align="space-around center">
            	 <button sk-sgl-click="singleClick()" ng-dblClick="doubleClick()">sglclick and dblClick</button>
              </sk-hbox> 
            </div>
         </file>
         <file name="app.js">
                angular
                    .module('app', ['snk'])
                    .controller('AppCntrl', ['$scope', function ($scope) {
                          
                        $scope.singleClick = function() {
                              alert('Single Click');
                           }
                        
                          $scope.doubleClick = function() {
                              alert('Double Click');
                          }
                    }]);
         </file>
     </example>
 */
angular
    .module('snk.components.sglclick')
    .directive('skSglClick', ['$parse', function($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
              var fn = $parse(attr['skSglClick']);
              var delay = 300, clicks = 0, timer = null;
              element.on('click', function (event) {
                clicks++;  //count clicks
                if(clicks === 1) {
                  timer = setTimeout(function() {
                    scope.$apply(function () {
                        fn(scope, { $event: event });
                    }); 
                    clicks = 0;             //after action performed, reset counter
                  }, delay);
                  } else {
                    clearTimeout(timer);    //prevent single-click action
                    clicks = 0;             //after action performed, reset counter
                  }
              });
            }
        };
    }])
angular
    .module('snk.core.util')
    .constant('SidenavConstants', {
        DEFAULT_CLOSED_SIZE: '10px'
    })
angular
    .module('snk.components.sidenav')
    .controller('skSidenavController', SKSidenavController);

SKSidenavController.$inject = ['$scope', '$element', '$attrs', '$q'];

function SKSidenavController($scope, $element, $attrs, $q) {
    var self = this;
    var focusElement;

    self.redraw = angular.noop;

    self.isOpen = function () {
        return !!$scope.isOpen;
    };

    self.isLockedOpen = function () {
        return !!$scope.isLockedOpen;
    };

    self.open = function () {
        return self.$toggleOpen(true);
    };

    self.close = function () {
        return self.$toggleOpen(false);
    };

    self.toggle = function () {
        return self.$toggleOpen(!$scope.isOpen);
    };

    self.focusElement = function (el) {
        if (angular.isDefined(el)) {
            focusElement = el;
        }
        return focusElement;
    };

    self.$toggleOpen = function () {
        return $q.when($scope.isOpen);
    };
}
/**
 * @ngdoc directive
 * @name snk.components.sidenav.directive:sk-sidenav
 * @restrict E
 * @scope
 * @transclude
 * @description
 * O componente Sidenav permite que o mesmo seja aberto e fechado programaticamente.
 *
 * Por padrão, o mesmo quando aberto desliza dentro da sua tela.
 * Existe a possibilidade também de deixar o componente fixo na tela e aplicar o efeito de abrir e fechar de acordo com a resolução.
 *
 * Por padrão, o focus da tela é enviado ao container do sidenav. Caso seja necessário que o focus seja em um elemento
 * especifíco, veja a diretiva deste componente responsavél por aplicar o focus em 1 conteúdo interno.
 *
 * @param {expression=} is-open Informa ao componente se o mesmo deve ser aberto ao carregar.
 * @param {string=} component-id componentId é usado no servico skSidenav.
 * @param {expression=} is-locked-open Quando o resultado dessa expressão é verdadeiro,
 * o Sidenav bloqueia o mesmo como aberto, ou seja, ele faz parte do seu conteúdo (esse atributo sobrepõe is-open).
 *
 * Quando está no mobile (evento de touch), abrimos e fechamos o sidenav de acordo com o evento de 'Swipe/Touch move'.
 *
 * O serviço skMedia() é exposto para ser usado como valor do atributo is-locked-open, ele aceita
 * que seja repassado media queries do CSS e também as media queries pré configuradas no nosso framework 'sm', 
 * 'gt-sm', 'md', 'gt-md', 'lg' ou 'gt-lg'.
 *
 * @example
     <example module="app">
        <file name="exemplo.html">
            <div class="sidenav-docs" ng-controller="SideNavController" style="overflow:hidden;" layout="row" flex>
                <sk-sidenav class="sk-sidenav-left shadowpanel" sk-id="mySidenavLeft" is-open="false" is-locked-open="skMedia('gt-sm')">
                    <div layout-padding>
                        <h1>Sidenav Left</h1>
                        <p>
                            Isso é um Sidenav posicionado na esquerda e fixo de acordo com a media querie repassado para o componente.
                        </p>
                        <button ng-click="closeSidenav('mySidenavLeft')" class="btn btn-default visible-xs">Fechar</button>
                    </div>
                </sk-sidenav>
                <div layout-padding flex>
                    <div class="btn-group">
                        <button class="btn btn-danger" type="button" ng-click="openSidenav('mySidenavLeft')">Open Left</button>
                        <button class="btn btn-danger" type="button" ng-click="openSidenav('mySidenavRight')">Open Right</button>
                    </div>
                </div>
                <sk-sidenav sk-id="mySidenavRight" sk-sidenav-right is-locked-open="false" style="position: relative;">
                    <div layout-padding>
                        <h1>Sidenav Right</h1>
                        <form>
                            <div class="form-group">
                                <label for="testInput">Label</label>
                                <input id="testInput" type="text" class="form-control" sk-sidenav-focus>
                            </div>
                            <button ng-click="closeSidenav('mySidenavRight')" class="btn btn-default">Fechar</button>
                        </form>
                    </div>
                </sk-sidenav>
            </div>
        </file>
        <file name="app.js">
            angular.module('app', ['snk'])
            .controller('SideNavController', SideNavController);
            
            function SideNavController($scope, SkComponentRegistry, AngularUtil) {
                $scope.openSidenav = AngularUtil.debounce(function (navId) {
                        SkComponentRegistry.get(navId).then(function(instance){
                            instance
                                .toggle()
                                .then(function () {
                                    console.log("Sidenav " + navId + " está aberto.");
                                });
                        });

                    }, 300);

                $scope.closeSidenav = function(navId) {
                    SkComponentRegistry.get(navId).then(function(instance){
                        instance
                            .close()
                            .then(function () {
                                console.log("Sidenav " + navId + " fechado.");
                            });
                    });
                };
            }
        </file>
     </example>
 */
angular.module('snk.components.sidenav')
    .directive('skSidenav', SkSidenavDirective)
    .directive('skSidenavHorizontal', SkSidenavHorizontalDirective)
    .directive('skSidenavFocus', SkSidenavFocusDirective);

SkSidenavDirective.$inject = ['$timeout', '$window', '$animate', '$parse', '$log', 'SkConstants', '$compile', '$q', '$document', 'skMedia', 'SwipeUtil', 'UserAgentUtils', 'SidenavConstants'];
SkSidenavHorizontalDirective.$inject = ['$timeout', '$window', '$animate', '$parse', '$log', 'SkConstants', '$compile', '$q', '$document', 'skMedia', 'SwipeUtil', 'UserAgentUtils', 'SidenavConstants'];

function SkSidenavHorizontalDirective($timeout, $window, $animate, $parse, $log, SkConstants, $compile, $q, $document, skMedia, SwipeUtil, UserAgentUtils, SidenavConstants) {
   
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            isOpen: '=?isOpen',
            id: '@?skId',
            onToggle: '&skOnToggle',
            backdropClass: '@?backdropClass',
            onClose: '&?skOnClose',
            isFixedMode: '=?skIsFixedMode'
        },
        controller: 'skSidenavController',
        templateUrl: 'components/sidenav/sidenavHorizontal.tpl.html',
        compile: function (element, attr) {
            var sideNavBottom = angular.isDefined(attr.skSidenavBottom) ? true : false;
            var sideNavContent;

            if (sideNavBottom) {
                element.addClass('sk-sidenav-bottom');
            } else {
                element.addClass('sk-sidenav-top');
            }

            element.attr('tabIndex', '-1');
            element.parent().css('min-height', SidenavConstants.DEFAULT_CLOSED_SIZE);
            
            if (attr.childLayout || attr.layout) {
                sideNavContent = angular.element(element.children()[1]);
                sideNavContent.attr('layout', (attr.childLayout || attr.layout));
            }

            attr.sidenavHorizontal = true;

            return postLink;
        }
    };

    function postLink(scope, element, attr, sidenavCtrl) {
        createSidenav(scope, element, attr, sidenavCtrl, $timeout, $window, $animate, $parse, $log, SkConstants, $compile, $q, $document, skMedia, SwipeUtil, UserAgentUtils, SidenavConstants);
    }
}

function SkSidenavDirective($timeout, $window, $animate, $parse, $log, SkConstants, $compile, $q, $document, skMedia, SwipeUtil, UserAgentUtils, SidenavConstants) {
   
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            isOpen: '=?isOpen',
            id: '@?skId',
            onToggle: '&skOnToggle',
            backdropClass: '@?backdropClass',
            onClose: '&?skOnClose',
            isFixedMode: '=?skIsFixedMode'
        },
        controller: 'skSidenavController',
        templateUrl: 'components/sidenav/sidenav.tpl.html',
        compile: function (element, attr) {
            var sideNavRight = angular.isDefined(attr.skSidenavRight) ? true : false;
            var sideFilterPanelMode = angular.isDefined(attr.skFilterPanelMode) ? true : false;

            var sideNavContent;

            if (sideNavRight) {
                element.addClass('sk-sidenav-right');
            } else {
                element.addClass('sk-sidenav-left');
            }

            if(sideFilterPanelMode){
                element.addClass('sk-sidenav-filter-panel-mode');
                element.addClass('high-contrast-panel');
            }

            element.attr('tabIndex', '-1');
            element.parent().css('min-width', SidenavConstants.DEFAULT_CLOSED_SIZE);
            
            if (attr.childLayout || attr.layout) {
                sideNavContent = angular.element(element.children()[1]);
                sideNavContent.attr('layout', (attr.childLayout || attr.layout));
            }

            return postLink;
        }
    };

    function postLink(scope, element, attr, sidenavCtrl) {
        createSidenav(scope, element, attr, sidenavCtrl, $timeout, $window, $animate, $parse, $log, SkConstants, $compile, $q, $document, skMedia, SwipeUtil, UserAgentUtils, SidenavConstants);
    }
}

function createSidenav(scope, element, attr, sidenavCtrl, $timeout, $window, $animate, $parse, $log, SkConstants, $compile, $q, $document, skMedia, SwipeUtil, UserAgentUtils, SidenavConstants) {
    var lastParentOverFlow;
    var triggeringElement = null;
    var promise = $q.when(true);
    var isLockedOpenParsed = $parse(attr.isLockedOpen);
    var parent = element.parent();
    var backdrop = $compile('<div class="backdrop ng-enter">')(scope);

    var removeParentScroll = angular.isDefined(attr.skRemoveParentScroll) ? true : false;

    if (angular.isDefined(scope.backdropClass)) {
        backdrop.addClass(scope.backdropClass);
    }

    if(attr.sidenavHorizontal){
        if(attr.skHeight) {
            element.css({
                'height': attr.skHeight,
                'max-height': attr.skHeight,
                'min-height': attr.skHeight
            });
        }

        scope.isSidenavBottom = angular.isDefined(attr.skSidenavBottom) ? true : false;
    } else {
        if (attr.skWidth) {
            element.css({
                'width': attr.skWidth,
                'max-width': attr.skWidth,
                'min-width': attr.skWidth
            });
        }
        scope.isSidenavRight = angular.isDefined(attr.skSidenavRight) ? true : false;
    }

    scope.isOpen = angular.isDefined(scope.isOpen) ? scope.isOpen : isLocked();
    scope.openCloseSidenav = openCloseSidenav;
    scope.userLastState;

    element.on('$destroy', sidenavCtrl.destroy);

    scope.$watch(isLocked, updateIsLocked);

    scope.$watch('isOpen', updateIsOpen);

    $window.addEventListener('resize', resizeListener);

    scope.$on('$destroy', function(){
        $window.removeEventListener('resize', resizeListener);
    });

    sidenavCtrl.$toggleOpen = toggleOpen;
    //sidenavCtrl.focusElement(sidenavCtrl.focusElement() || element);

    SwipeUtil.left(scope, parent, function (data) {
        swipeToLeft(data.startCoords.x, data.endCoords.x);
    });

    SwipeUtil.right(scope, parent, function (data) {
        swipeToRight(data.startCoords.x, data.endCoords.x);
    });

    if (scope.isFixedMode){
        element.addClass('fixed-mode');
    }

    function resizeListener() {
        updateIsOpen(scope.isOpen, false);
    }

    /**
     * Alterna as classes no DOM para indicar que está 'fechado'
     */
    function updateIsLocked(isLocked, oldValue) {
        var state = isLocked;

        if (isLocked === oldValue) {
            element.toggleClass('sk-locked-open', !!state);
        } else {
            if (!isLocked) {
                state = false;
                scope.isOpen = false;
            } else {
                if (angular.isUndefined(scope.userLastState)) {
                    if (isLocked === false && oldValue === true) {
                        scope.isOpen = false;
                    } else if (isLocked === true && oldValue === false) {
                        scope.isOpen = true;
                    }
                } else {
                    state = scope.userLastState;
                    scope.isOpen = state;
                }
            }
        }

        addRemoveLockedOpen(state);
    }

    function addRemoveLockedOpen(bool) {
        $animate[bool ? 'addClass' : 'removeClass'](element, 'sk-locked-open');
        backdrop.toggleClass('sk-locked-open', !!bool);
    }

    /**
     * Alterna o Sidenav na view de acordo com os listeners
     */
    function updateIsOpen(isOpen, focusable) {
        parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
        backdrop[isOpen ? 'on' : 'off']('click', close);

        focusable = angular.isUndefined(focusable) ? true : focusable;

        if (isOpen) {
            triggeringElement = $document[0].activeElement;
        }

        var focusEl = sidenavCtrl.focusElement();

        if(!removeParentScroll){
            disableParentScroll(isOpen);
        }

        addRemoveLockedOpen(isOpen && isLocked());

        var promise = $q.all([
            isOpen && !isLocked() ? $animate.enter(backdrop, parent) : $animate.leave(backdrop),
            $animate[isOpen ? 'removeClass' : 'addClass'](element, 'sk-closed'),
            $animate[isOpen ? 'addClass' : 'removeClass'](element, 'sk-open')
        ]);

        promise.then(function () {
            recalcFixedMode();

            if (focusable && scope.isOpen && focusEl) {
                focusEl.focus();
            }
        });

        if (isOpen === false) {
            (scope.onClose || angular.noop)();
        }

        return promise;
    }

    function recalcFixedMode() {
        if (scope.isFixedMode){
            var newCss = {};

            var size;
            var minSize;

            if(attr.sidenavHorizontal){
                size = 'height';
                minSize = 'min-height';
            } else {
                size = 'width';
                minSize = 'min-width';
            }

            if (scope.isOpen && isLocked()) {
                newCss[size] = element.css(size);

                if (UserAgentUtils.isIE()){
                    newCss[minSize] = element.css(minSize);
                }
            } else {
                if (UserAgentUtils.isIE()){
                    newCss[minSize] = SidenavConstants.DEFAULT_CLOSED_SIZE;
                    newCss[size] = SidenavConstants.DEFAULT_CLOSED_SIZE;
                } else {
                    newCss[size] = scope.isFixedMode ? SidenavConstants.DEFAULT_CLOSED_SIZE : 'auto';
                }
            }

            element.parent().css(newCss);
            sidenavCtrl.redraw();
        }
    }

    function disableParentScroll(disabled) {
        if (disabled) {
            lastParentOverFlow = parent.css('overflow');
            parent.css('overflow', 'hidden');
        } else if (angular.isDefined(lastParentOverFlow)) {
            parent.css('overflow', lastParentOverFlow);
            lastParentOverFlow = undefined;
        }
    }

    /**
     * Alterna o Sidenav e retorna uma promessa que será resolvida quando a animação for concluída.
     */
    function toggleOpen(isOpen) {
        scope.userLastState = isOpen;

        if (scope.isOpen == isOpen) {
            if(angular.isFunction(scope.onToggle)) {
                scope.onToggle();
            }
            return $q.when(true);
        } else {
            var deferred = $q.defer();

            scope.isOpen = isOpen;

            $timeout(function () {
                promise.then(function (result) {

                    if (!scope.isOpen) {
                        triggeringElement && triggeringElement.focus();
                        triggeringElement = null;
                    }

                    deferred.resolve(result);

                    if(angular.isFunction(scope.onToggle)) {
                        scope.onToggle();
                    }
                });

            }, 0, false);

            return deferred.promise;
        }
    }

    function onKeyDown(ev) {
        var isEscape = (ev.keyCode === SkConstants.KEY_CODE.ESCAPE);
        return isEscape ? close(ev) : $q.when(true);
    }

    function close(ev) {
        if (isLocked()) {
            return;
        }

        return sidenavCtrl.close();
    }

    function swipeToRight(startX, endX) {
        var sidenavRect = element[0].getBoundingClientRect();
        
        if (!scope.isSidenavRight && startX <= 50 && !scope.isOpen) {
            //Quando está fechado e é um sidenav na esquerda
            toggleOpen(true);
        } else if (scope.isSidenavRight && scope.isOpen && startX >= (sidenavRect.left - 16) && startX <= (sidenavRect.left + 16)) {
            //Quando ele está aberto e é um sidenav na direita
            toggleOpen(false);
        }
    }

    function swipeToLeft(startX, endX) {
        var sidenavRect = element[0].getBoundingClientRect();
        
        if (!scope.isSidenavRight && startX >= 290 && startX <= 320 && scope.isOpen) {
            //Quando ele está aberto e é um sidenav na esquerda
            toggleOpen(false);
        } else if (scope.isSidenavRight && !scope.isOpen && startX >= (sidenavRect.left - 80)) {
            //Quando ele está fechado e é um sidenav na direita
            toggleOpen(true);
        }
    }

    function isLocked() {
        var isLocked;

        if (angular.isDefined(attr.isLockedOpen)) {
            isLocked = isLockedOpenParsed(scope.$parent, {
                skMedia: skMedia
            });
        } else {
            isLocked = skMedia('gt-lg');
            //isLocked = skMedia('lg');
        }

        return isLocked;
    }

    function openCloseSidenav() {
        if (sidenavCtrl.isOpen()) {
            toggleOpen(false);
        } else {
            toggleOpen(true);
        }
        scope.$broadcast('uiGridRecalculate');
    }

}

/**
 * @ngdoc directive
 * @name snk.components.sidenav.directive:sk-sidenav-focus
 *
 * @restrict A
 *
 * @description
 * skSidenavFocus dispõe da funcionalidade de aplicar o focus no elemento marcado com este atríbuto quando ocorrer
 * o focus do skSidenav.
 *
 * @example
     <example module="app">
        <file name="exemplo.html">
            <div class="sidenav-docs" ng-controller="SideNavController" style="overflow:hidden;" layout="row" flex>
                <sk-sidenav component-id="mySidenavId" class="sk-sidenav-right">
                    <div layout-padding>
                        <h1>Sidenav c/ focus</h1>
                        <form>
                            <div class="form-group">
                                <label for="testInput">Label</label>
                                <input id="testInput" type="text" class="form-control" sk-sidenav-focus>
                            </div>
                        </form>
                    </div>
                </sk-sidenav>
                <div layout-padding flex>
                    <button class="btn btn-danger" type="button" ng-click="openSidenav()">Open Sidenav</button>
                </div>
            </div>
        </file>
        <file name="app.js">
            angular.module('app', ['snk'])
            .controller('SideNavController', SideNavController);
            
            function SideNavController($scope, skSidenav, AngularUtil) {
                $scope.openSidenav = function(){
                    var navId = "mySidenavId";
                    
                    AngularUtil.delay(function () {
                        skSidenav(navId)
                            .toggle()
                            .then(function () {
                                console.log("toggle " + navId + " is done");
                            });
                    }, 300);
                };
            }
        </file>
     </example>
 */
function SkSidenavFocusDirective() {
    return {
        restrict: 'A',
        require: '^skSidenav',
        link: function (scope, element, attr, sidenavCtrl) {
            sidenavCtrl.focusElement(element);
        }
    };
}

/**
 * @ngdoc service
 * @name snk.components.sidenav.service:skSidenav
 *
 * @description
 * Esse serviço permite a interação com o sidenav criado em seu HTML. O seu acesso é feito através do ID do componente
 * definido na sua diretiva.
 */
angular
    .module('snk.components.sidenav')
    .factory('skSidenav', ['SkComponentRegistry', '$q', function(SkComponentRegistry, $q){
        return function (handle) {

            //Pesquisa a ocorrência do controlador para a instância especifica de SideNav
            var self;
            var errorMsg = "SideNav '" + handle + "' não está disponível!";
            var instance = SkComponentRegistry.get(handle);

            if (!instance) {
                SkComponentRegistry.notFoundError(handle);
            }

            return self = {
                /**
                 * @ngdoc
                 * @name snk.components.sidenav.service:skSidenav#isOpen
                 * @methodOf snk.components.sidenav.service:skSidenav
                 * @description Método para verificar se o SideNav está aberto.
                 * @example skSidenav(componentId).isOpen();
                 * @returns {boolean} retorna true se o SideNav estiver aberto.
                 */
                isOpen: function () {
                    return instance && instance.isOpen();
                },

                /**
                 * @ngdoc
                 * @name snk.components.sidenav.service:skSidenav#isLockedOpen
                 * @methodOf snk.components.sidenav.service:skSidenav
                 * @description Método para verificar se o SideNav está fazendo parte do conteúdo ao abrir.
                 * @example skSidenav(componentId).isLockedOpen();
                 * @returns {boolean} retorna true se o SideNav estiver como parte do conteúdo.
                 */
                isLockedOpen: function () {
                    return instance && instance.isLockedOpen();
                },

                /**
                 * @ngdoc
                 * @name snk.components.sidenav.service:skSidenav#toggle
                 * @methodOf snk.components.sidenav.service:skSidenav
                 * @description Método para abrir ou fechar o SideNav. Caso o mesmo esteja aberto e você chamar este método, ele vai fechar o mesmo.
                 * @example skSidenav(componentId).toggle();
                 * @returns {httpPromise} retorna uma promessa para ser utilizada após o toggle do SideNav.
                 */
                toggle: function () {
                    return instance ? instance.toggle() : $q.reject(errorMsg);
                },

                /**
                 * @ngdoc
                 * @name snk.components.sidenav.service:skSidenav#open
                 * @methodOf snk.components.sidenav.service:skSidenav
                 * @description Método para abrir o SideNav.
                 * @example
                 * skSidenav(componentId).open();
                 * skSidenav(componentId).open().then(function(){});
                 * @returns {httpPromise} retorna uma promessa que pode ser usada após abrir o SideNav.
                 */
                open: function () {
                    return instance ? instance.open() : $q.reject(errorMsg);
                },

                /**
                 * @ngdoc
                 * @name snk.components.sidenav.service:skSidenav#close
                 * @methodOf snk.components.sidenav.service:skSidenav
                 * @description Método para fechar o SideNav.
                 * @example
                 * skSidenav(componentId).close();
                 * skSidenav(componentId).close().then(function(){});
                 * @returns {httpPromise} retorna uma promessa que pode ser usada após fechar o SideNav.
                 */
                close: function () {
                    return instance ? instance.close() : $q.reject(errorMsg);
                },

                /**
                 * @ngdoc
                 * @name snk.components.sidenav.service:skSidenav#then
                 * @methodOf snk.components.sidenav.service:skSidenav
                 * @description Método para saber o momento em que o SideNav está pronto.
                 * @example
                 * skSidenav(componentId).then(function(){
             * //agora o SideNav está pronto
             * });
                 * @returns {httpPromise} callbackFn executa o callback quando o SideNav estiver pronto.
                 */
                then: function (callbackFn) {
                    var promise = instance ? $q.when(instance) : waitForInstance();
                    return promise.then(callbackFn || angular.noop);
                }
            };

            function waitForInstance() {
                return SkComponentRegistry
                    .when(handle)
                    .then(function (it) {
                        instance = it;
                        return it;
                    });
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name sk-simple-form.directive:sk-simple-form
 * @restrict E
 * @scope
 * @description
    Esse componente é responsável por prover a estrutura de formulários.
    <br>
    Ele foi desenvolvido para que seja desenvolvidos formulários sem metadados (standalone).
    <br>
    <b>Atualmente essa diretiva aceita {@link sk-simple-form.directive:sk-simple-item sk-simple-item} e 
    {@link sk-simple-form.directive:sk-simple-group sk-simple-group} como elementos válidos na layoutização do formulário.</b>
 *
 * @param {string=} [sk-columns=4] Número de colunas em que o formulário será renderizado. Atualmente temos
 * suporte apenas para 1, 2, 3 e 6 colunas, caso seja informado um número de colunas diferente disso o
 * formulário automaticamente coloca 4 colunas como padrão.
 * 
 * @param {string} [no-padding] Caso informado os sk-simple-item não terão os paddings padrões de formulários.
 *
 * @param {boolean} [sk-in-line=false] Informa se o label e o input do form item serão posicionados em uma mesma linha.
 * @example
     <example module="app">
         <file name="FormExample.html">
            <p>Formulário c/ padrão de colunas:</p>
            <!-- Formulário estático -->
            <sk-simple-form>
                <sk-simple-item sk-label="Campo 1">
                    <sk-text-input sk-value="campo1"></sk-text-input>
                </sk-simple-item>
                <sk-simple-item sk-label="Campo 2">
                    <sk-text-input sk-value="campo2"></sk-text-input>
                </sk-simple-item>
                <sk-simple-group sk-label="Grupo de campos">
                    <sk-simple-item sk-label="Campo 3" sk-required="true">
                        <sk-text-input sk-value="campo3"></sk-text-input>
                    </sk-simple-item>
                </sk-simple-group>
            </sk-simple-form>
            <br>
            <p>Formulário de 2 colunas:</p>
            <sk-simple-form sk-columns="2">
                <sk-simple-item sk-label="Campo 1">
                    <sk-number-input sk-value="campo1"></sk-number-input>
                </sk-simple-item>
                <sk-simple-item sk-label="Campo 2" sk-help-tip="Ajuda para o campo 2">
                    <sk-number-input sk-value="campo2"></sk-number-input>
                </sk-simple-item>
                <sk-simple-item sk-label="Campo 3" sk-required="true" sk-help-tip="Ajuda para o campo 3">
                    <sk-number-input sk-value="campo2"></sk-number-input>
                </sk-simple-item>
            </sk-simple-form>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.simpleform')
    .component('skSimpleForm', {
        restrict: 'E',
        transclude: true,
        bindings: {
            columns: '@skColumns',
            inLine: '=skInLine',
            minWidthLabel:'@?skMinWidthLabel'
        },
        controller: 'SkSimpleFormController',
        templateUrl: 'components/simpleform/simpleform.tpl.html'
    });
angular
    .module('snk.components.simpleform')
    .controller('SkSimpleFormController', ['NumberUtils', 'FormService', 'AngularUtil', 'StringUtils', '$timeout', 
        function(NumberUtils, FormService, AngularUtil, StringUtils, $timeout) {
        var self = this;
        
        var _responsiveClass;
        var _lblMaxWidth = NumberUtils.getNumberOrZero(self.minWidthLabel);//Precisamos conseguir informar um valor minimo
        var _fomrItemsControllers = [];
        var module = 'sk';

        self.$onInit = init;
        self.$doCheck = doCheck;
        self.addFormItem = addFormItem;
        self.getMajorLbl = getMajorLbl;
        
        function init() {
            _responsiveClass = FormService.getResponsiveClass(self.columns);
        }

        function addFormItem(itemElem, properties) {
            var columnClass = _responsiveClass;
            var itemController = AngularUtil.getControllerFromElement(itemElem, module);

            if (properties && properties.column) {
                columnClass = FormService.getResponsiveClass(properties.column);
            }

            itemElem.addClass(columnClass);

            let isInLine =  properties.inLine != undefined ? StringUtils.toBoolean(properties.inLine) : self.inLine;

            if(itemController){
                _fomrItemsControllers.push(itemController);
                itemController.setInLine(isInLine);

                if(isInLine){
                    $timeout(function(){
                        recalcMajorLabelWidth(itemController);
                    }, 100);                    
                }
            }
        }

        function recalcMajorLabelWidth(itemController){
            if(itemController && itemController.getLblWidth() > _lblMaxWidth){
                _lblMaxWidth = itemController.getLblWidth();
            }
        }

        function getMajorLbl(){
            return _lblMaxWidth;
        }

        function doCheck(){
            _fomrItemsControllers.forEach((ctrl) => {
                recalcMajorLabelWidth(ctrl);
            });
        }

        
    }]);
/**
 * @ngdoc directive
 * @name sk-simple-form.directive:sk-simple-group
 * @restrict E
 * @requires sk-simple-form
 * @scope
 * @description
    Esse componente é responsável por criar a estrutura de group label do formulário com sua respectiva classe adaptavel e suporte para sk-simple-item como filhos.
    <p>
        <b class="text-danger">ATENÇÃO:</b> Esse componente só pode ser utilizado em conjunto com o 
        {@link sk-simple-form.directive:sk-simple-form sk-simple-form}.
    <p>
    <b>Para ver como utiliza-lo {@link sk-simple-form.directive:sk-simple-form clique aqui}.</b>
 *
 * @param {string} [sk-label] Label para o groupo de campos.
 */
angular
    .module('snk.components.simpleform')
    .component('skSimpleGroup', {
        restrict: 'E',
        transclude: true,
        require: {
            formCtrl: '^skSimpleForm'
        },
        controller: 'SkSimpleGroupController',
        templateUrl: 'components/simpleform/simplegroup/simplegroup.tpl.html'
    });
angular
    .module('snk.components.simpleform')
    .controller('SkSimpleGroupController', ['$element', '$attrs', 'i18n', function($element, $attrs, i18n) {
        var self = this;

        self.$postLink = postLink;
        
        function postLink() {
            var labelElem = angular.element($element[0].querySelector('label.group-label'));

            if (angular.isDefined($attrs['skLabel'])) {
                labelElem.text(i18n($attrs['skLabel']));
            } else {
                throw Error('O atributo sk-label é obrigatório para o groupo de campos.');
            }
        }
    }]);
/**
 * @ngdoc directive
 * @name sk-simple-form.directive:sk-simple-item
 * @restrict E
 * @requires sk-simple-form
 * @scope
 * @description
    Esse componente � respons�vel por criar a estrutura de label e campo do formul�rio com sua respectiva classe adaptavel.
    <p>
        <b class="text-danger">ATEN��O:</b> Esse componente s� pode ser utilizado em conjunto com o 
        {@link sk-simple-form.directive:sk-simple-form sk-simple-form}.
    <p>
    <b>Para ver como utiliza-lo {@link sk-simple-form.directive:sk-simple-form clique aqui}.</b>
 *
 * @param {boolean=} [sk-required=false] Booleano para colocar a marca��o de campo obrigatorio no item. 
 * Essa propriedade tem efeitos apenas visuais e n�o validam os campos.
 * 
 * @param {number=} [sk-column=undefined] Propriedade que define o tamanho da sua coluna em rela��o ao form.
 * Quando essa properiedade � definida, no momento de processar esse item ele ignora a quantidade de colunas definidas pelo form.
 * Por exemplo, caso deseje que apenas um �nico simple-item tenha 1 coluna em rela��o ao form, voc� deve repassar 1 para o sk-column. 
 * 
 * @param {string=} [sk-label=undefined] Label para o campo.
 * 
 * @param {string=} [sk-help-tip=undefined] Ajuda para o campo.
 * 
 * @param {boolean=} [sk-empty-label=false] Booleano que seta se o label ser� vazio, mas com o elemento posicionado a direita.
 */
angular
    .module('snk.components.simpleform')
    .component('skSimpleItem', {
        restrict: 'E',
        transclude: true,
        require: {
            formCtrl: '^skSimpleForm'
        },
        bindings: {
            required: '=skRequired',
            helptip: '@?skHelpTip',
            classHelp:'@?skClassHelp',
            emptyLabel: '@?skEmptyLabel',
			positionHelpTip: '@?skPositionHelpTip'
        },
        controller: 'SkSimpleItemController',
        templateUrl: 'components/simpleform/simpleitem/simpleitem.tpl.html'
    });
angular
    .module('snk.components.simpleform')
    .filter('labelFilter', ['StringUtils',
        function (StringUtils) {
            return function (label) {
                return StringUtils.isNotEmpty(label) ? (label.lastIndexOf(':') > -1 ? label : (label + ':')) : '';
            };
        }
    ])
    .controller('SkSimpleItemController', ['$element', '$attrs', 'i18n',
        function($element, $attrs, i18n) {
    	
        var HIDE_CLASS = 'sk-hide';
        var self = this;
        var _labelElem;
        var _maxLblWidth = 0;
        
        var _ngShowVar;

        self.$onInit = init;
        self.$postLink = postLink;
        self.labelText;
        self.setText = setText;
        self.originalLabel;
        self.setInLine = setInLine;
        self.getItemStyle = getItemStyle;
        self.getStyleLblContainer = getStyleLblContainer;
        self.getLblWidth = getLblWidth;

        self.itemStyle = {'display': 'inline-grid', 'grid-template-columns': 'auto auto', 'grid-gap': '5px', 'align-items': 'center'};
        self.lblStyle = {'display': 'grid', 'grid-template-columns': 'auto'};

        function init() {
            _labelElem = angular.element($element[0].querySelector('label.simple-label'));

            if (!$attrs['skLabel']) {
                buildLabel();
            }

            $attrs.$observe('skLabel', buildLabel);
        }

        function postLink() {
        	if (angular.isDefined(self.formCtrl)) {
                self.formCtrl.addFormItem($element, {column: $attrs['skColumn'], inLine: $attrs['skInLine']});
            }

            var formGroup = angular.element($element.children()[0]);

            if (angular.isDefined($attrs['skMargin'])) {
                formGroup.css('margin', $attrs['skMargin']);
            }
        }

        function buildLabel() {
            var addClass = true;

            if (angular.isDefined($attrs['skLabel'])) {
                self.labelText = i18n($attrs['skLabel']);

                addClass = false;
            }
            
            if(self.originalLabel === undefined){
            	self.originalLabel = self.labelText;
        	}

            _labelElem[addClass ? 'addClass' : 'removeClass'](HIDE_CLASS);
        }
        
        function setText(newText) {
        	$attrs['skLabel'] = angular.isDefined(newText) ? newText : self.originalLabel;
        	buildLabel();
        }

        function setInLine(isInLine){
            self.inLine = isInLine;
        }

        function getItemStyle(){
            if(self.formCtrl){
                self.itemStyle['grid-template-columns'] = ((self.formCtrl.getMajorLbl()) + 'px auto');
            }

            return self.itemStyle;
        }

        function getStyleLblContainer(){
            let colsTpl = "auto";

            if(self.required){                
                colsTpl += " 15px";
            }

            if(self.helptip){                
                colsTpl += " 15px";
            }

            self.lblStyle['grid-template-columns'] = colsTpl;

            return self.lblStyle;
        }


        function getLblWidth(){
            let itemWidth = 0;

            if(self.required){                
                itemWidth += 15;
            }

            if(self.helptip){                
                itemWidth += 15;
            }

            let lblElem = $element.find('label');

            if(!lblElem){
                return itemWidth;
            }

            let textElem = lblElem.find('.lblText');

            if(textElem && textElem.width()){
                itemWidth += textElem.width();
            }

            return itemWidth;
        }

    }]);
/**
 * Created by jonathan.silva on 28/10/2020.
 */
angular
    .module('snk.components.snackbar')
    .controller('SkSnackbarController', ['$scope', '$timeout',
        function ($scope, $timeout) {
            var self = this;

            let _duration = 10;
            let _timeClose;

            self.id = 'sk-snackbar';
            self.show = false;
            self.open = open;
            self.close = close;

            // Directives variables
            $scope.snackbarTitle;
            $scope.snackbarMessage;
            $scope.snackbarDuration;
            $scope.positionHorizontal;
            $scope.positionVertical;
            $scope.customClass;
            $scope.iconName;

            $scope.$watch('snackbarMessage', init);

            function open() {
                self.show = true;
                _timeClose = $timeout(close, _duration);
            }

            function close() {
                self.show = false;
                $timeout(() => {
                    const $snackbar = document.querySelector(`#${self.id}`);
                    if ($snackbar) {
                        disableTimeout(_timeClose);
                        $snackbar.parentNode.remove();
                    }
                }, 500, false);
            }

            function init() {
                self.id = `sk-snackbar-${Math.floor(Date.now() / 1000)}`;
                _duration = ($scope.snackbarDuration || _duration) * 1000;
                $timeout(open, 100);
            }

            function disableTimeout(timeout) {
                if (timeout) {
                    $timeout.cancel(timeout);
                    timeout = undefined;
                }
            }
        }
    ]);

/**
 * Created by jonathan.silva on 28/10/2020.
 */
/**
 * @ngdoc directive
 * @name snk.components.snackbar.directive:sk-snackbar
 * @restrict E
 * @scope
 * @description
    skSnackbar é um componente responsável por apresentar uma notificação na tela 
    sem bloquear ou impedir o usuário de continuar navegando normalmente no sistema.
    Posições Disponíveis no Componente:
    • horizontal: left | right | center (default)
    • vertical: top | bottom (default)
 * @param {string}   'sk-snackbar-title'      - título que aparecerá no snackbar.
 * @param {string}   'sk-snackbar-message'    - mensagem de texto que aparecerá no snackbar.
 * @param {string}   'sk-snackbar-duration'   - valor da duração em segundos para fechar o snackbar.
 * @param {string}   'sk-position-horizontal' - posição horizontal que o snackbar irá aparecer.
 * @param {string}   'sk-position-vertical'   - posição vertical que o snackbar irá aparecer.
 * @param {string}   'sk-custom-class'        - classe CSS customizada.
 * @param {string}   'sk-icon-name'           - nome do ícone baseado nas opções disponíveis no glyphicon.
 * @example
     <example module="appSnackbar">
         <file name="appSnackbar.html">
         	<div ng-controller="SnackbarController">
                <sk-snackbar 
                    sk-snackbar-title="'Atenção!'"
                    sk-snackbar-message="'Solicitação Realizada com Sucesso!'"
                    sk-snackbar-duration="5"
                    sk-position-horizontal="'center'"
                    sk-position-vertical="'bottom'"
                    sk-custom-class="'bg-red'"
                    sk-icon-name="'alert'"
                ></sk-snackbar>
         	</div>
         </file>
         <file name="appSnackbar.css">
            sk-snackbar .bg-red {
                background-color: red;
            }
         </file>
     </example>
 */
angular
    .module('snk.components.snackbar')
    .directive('skSnackbar', [
        function () {
            return {
                restrict: 'E',
                controllerAs: 'ctrl',
                controller: 'SkSnackbarController',
                templateUrl: 'components/snackbar/snackbar.tpl.html',
                scope: {
                    snackbarTitle: '=?skSnackbarTitle',
                    snackbarMessage: '=skSnackbarMessage',
                    snackbarDuration: '=?skSnackbarDuration',
                    positionHorizontal: '=?skPositionHorizontal',
                    positionVertical: '=?skPositionVertical',
                    customClass: '=?skCustomClass',
                    iconName: '=?skIconName'
                },
            }
        }
    ]);
/**
 * Created by jonathan.silva on 28/10/2020.
 */
/**
 * @description
    Serviço responsável em criar e abrir o snackbar de notificação.
 * @example
    <example module="appSnackbar">
        <file name="appSnackbar.js">
            angular
                .module('appSnackbar', ['snk'])
                .controller('appSnackbarController', ['SnackbarService', function(SnackbarService) {   

                    SnackbarService.open({ 
                        title: 'Título', 
                        message: 'Mensagem',
                        duration: 5,
                        positionHorizontal: 'center',
                        positionVertical: 'bottom',
                        customClass: 'bg-red',
                        iconName: 'alert'
                    });

            }]);
        </file>
        <file name="appSnackbar.css">
            sk-snackbar .bg-red {
                background-color: red;
            }
        </file>
    </example>
 */
angular
    .module('snk.components.snackbar')
    .service('SnackbarService', ['AngularUtil', '$document', 
        function (AngularUtil, $document) {

        const self = this;

        self.open = open;

        function open(data) {
            const { title, message, duration, positionHorizontal, positionVertical, customClass, iconName } = data;
            const snackbar = document.createElement('sk-snackbar');
            if (angular.isDefined(title)) {
                snackbar.setAttribute('sk-snackbar-title', `'${title}'`);
            }
            if (angular.isDefined(message)) {
                snackbar.setAttribute('sk-snackbar-message', `'${message}'`);
            }
            if (angular.isDefined(duration)) {
                snackbar.setAttribute('sk-snackbar-duration', `${duration}`);
            }
            if (angular.isDefined(positionHorizontal)) {
                snackbar.setAttribute('sk-position-horizontal', `'${positionHorizontal}'`);
            }
            if (angular.isDefined(positionVertical)) {
                snackbar.setAttribute('sk-position-vertical', `'${positionVertical}'`);
            }
            if (angular.isDefined(customClass)) {
                snackbar.setAttribute('sk-custom-class', `'${customClass}'`);
            }
            if (angular.isDefined(iconName)) {
                snackbar.setAttribute('sk-icon-name', `'${iconName}'`);
            }
            const snackbarAux = AngularUtil.compile(snackbar);
            angular.element($document[0].body).prepend(snackbarAux);
        }
    }]);
angular
    .module('snk.components.sortable')
    .constant('skSortableConfig', {})
    .directive('skSortable', ['$parse', 'skSortableConfig', 'AngularUtil', function ($parse, skSortableConfig, AngularUtil) {
        var SOURCE_NAME = 'Sortable:sk-sortable';
        var SOURCE_NAME_FILTERED = 'Sortable:Filtered:sk-sortable';
        var removed;
        var nextSibling;

        // Export
        return {
            restrict: 'A',
            scope: {skSortable: "=?"},
            link: function (scope, $el, attrs) {
                var el = $el[0],
                    options = angular.extend(scope.skSortable || {}, skSortableConfig),
                    source = AngularUtil.getNgRepeatSourceFromElement(el),
                    watchers = [],
                    sortable
                    ;

                if (source) {
                    el[SOURCE_NAME] = source.items;

                    if (source.hasFilter()) {
                      el[SOURCE_NAME_FILTERED] = source.filteredItems;
                    }
                }

                function _emitEvent(/**Event*/evt, /*Mixed*/item) {
                    var name = 'on' + evt.type.charAt(0).toUpperCase() + evt.type.substr(1);

                    /* jshint expr:true */
                    options[name] && options[name]({
                        model: item || source && source.item(evt.item),
                        models: source && source.items(),
                        oldIndex: evt.oldIndex,
                        newIndex: evt.newIndex
                    });
                }


                function _sync(/**Event*/evt) {
                    if (!source) {
                        // Without ng-repeat
                        return;
                    }

                    var oldIndex = evt.oldIndex,
                        newIndex = evt.newIndex,
                        items = source.items();

                    if (el !== evt.from) {
                        var prevItems = evt.from[SOURCE_NAME]();

                        if (evt.from[SOURCE_NAME_FILTERED]) {
                            var filteredItems = evt.from[SOURCE_NAME_FILTERED]();

                            if (filteredItems && filteredItems[oldIndex]) {
                              var toSearch = filteredItems[oldIndex];

                              for (var i = 0; i < prevItems.length; i++) {
                                if (prevItems[i] == toSearch) {
                                  oldIndex = i;
                                  break;
                                }
                              }
                            }
                        }

                        removed = prevItems[oldIndex];

                        if (evt.clone) {
                            removed = angular.copy(removed);
                            prevItems.splice(Sortable.utils.index(evt.clone, sortable.options.draggable), 0, prevItems.splice(oldIndex, 1)[0]);
                            evt.from.removeChild(evt.clone);
                        } else {
                            prevItems.splice(oldIndex, 1);
                        }

                        items.splice(newIndex, 0, removed);

                        evt.from.insertBefore(evt.item, nextSibling); // revert element
                    } else {
                        var itemOldPos = items.splice(oldIndex, 1)[0];
                        items.splice(newIndex, 0, itemOldPos);

                        // move ng-repeat comment node to right position
                        if (nextSibling.nodeType === Node.COMMENT_NODE) {
                            evt.from.insertBefore(nextSibling, evt.item.nextSibling);
                        }
                    }

                    scope.$apply();
                }


                sortable = Sortable.create(el, Object.keys(options).reduce(function (opts, name) {
                    opts[name] = opts[name] || options[name];
                    return opts;
                }, {
                    onStart: function (/**Event*/evt) {
                        nextSibling = evt.from === evt.item.parentNode ? evt.item.nextSibling : evt.clone.nextSibling;
                        _emitEvent(evt);
                        scope.$apply();
                    },
                    onEnd: function (/**Event*/evt) {
                        _emitEvent(evt, removed);
                        scope.$apply();
                    },
                    onAdd: function (/**Event*/evt) {
                        _sync(evt);
                        _emitEvent(evt, removed);
                    },
                    onUpdate: function (/**Event*/evt) {
                        _sync(evt);
                        _emitEvent(evt);
                    },
                    onRemove: function (/**Event*/evt) {
                        _emitEvent(evt, removed);
                        scope.$apply();
                    },
                    onSort: function (/**Event*/evt) {
                        _emitEvent(evt);
                        scope.$apply();
                    }
                }));

                $el.on('$destroy', function () {
                    angular.forEach(watchers, function (/** Function */unwatch) {
                        unwatch();
                    });
                    sortable.destroy();
                    watchers = null;
                    sortable = null;
                    nextSibling = null;
                });

                angular.forEach([
                    'sort', 'disabled', 'draggable', 'handle', 'animation',
                    'onStart', 'onEnd', 'onAdd', 'onUpdate', 'onRemove', 'onSort'
                ], function (name) {
                    watchers.push(scope.$watch('skSortable.' + name, function (value) {

                        if (value !== void 0) {
                            options[name] = value;

                            if (!/^on[A-Z]/.test(name)) {
                                sortable.option(name, value);
                            }
                        }
                    }));
                });
            }
        };
    }]);
angular
    .module('snk.components.stickypanel')
    .component('skStickypanel', {
      controller: 'SkStickyPanelController',
      templateUrl: 'components/stickypanel/stickypanel.tpl.html',
      transclude: true,
      bindings: {
        scrollContainer: '@skScrollContainer',
        topOffset: '=skTopOffset'
      }
    })
    .controller('SkStickyPanelController', ['$scope', '$element', '$document', 'DomUtil', 'AngularUtil', 'PositionUtils', 
      function ($scope, $element, $document, DomUtil, AngularUtil, PositionUtils) {

        var self = this;

        var _scrollContainerElem;
        var _stickyContainerElem;


        self.$onInit = $onInit;
        self.$onChanges = $onChanges;


        function $onInit() {
          $element.attr('layout', '');

          _stickyContainerElem = angular.element($element[0].querySelector('.sticky-container'));

          AngularUtil.addWindowResizeHandler(recalculate, $scope);

          recalculate();
        }

        function $onChanges(changeObj) {
          if (changeObj.scrollContainer) {
            if (_scrollContainerElem) {
              _scrollContainerElem.off('scroll', scrollHandler);
            }

            _scrollContainerElem = angular.element(self.scrollContainer || $document);
            _scrollContainerElem.on('scroll', scrollHandler);
          }
        }

        function scrollHandler() {
          recalculate();
        }

        function recalculate() {
          if (_scrollContainerElem && _scrollContainerElem.length) {
            _stickyContainerElem.removeClass('sticky');
            const scrollingElement = _scrollContainerElem[0].scrollingElement;
            if (scrollingElement && scrollVisible(scrollingElement)) {
              var containerRect = _stickyContainerElem[0].getBoundingClientRect();

              if (containerRect.height > 0) {
                $element.css('height', containerRect.height);

                var top = $element[0].getBoundingClientRect().top;
  
                if (top <= 0) {
                  _stickyContainerElem.addClass('sticky');
                }
              }
            }
          }
        }

        function scrollVisible(element) {
          return element.scrollHeight > element.clientHeight;
        }
      }]);
angular
    .module('snk.components.structuredfield')
    .controller('SkStructuredFieldController', ['$scope', 'XmlJson', 'ServiceProxy', 'ArrayUtils', 'ObjectUtils', 'StringUtils', 'DateUtils',
        function ($scope, XmlJson, ServiceProxy, ArrayUtils, ObjectUtils, StringUtils, DateUtils) {
            var self = this;
            
            ObjectUtils.implements(self, IFormInterceptor);
            self.interceptBuildField = interceptBuildField;
            
            self.initializeStructureFields = initializeStructureFields;
            self.setFieldEnabled = setFieldEnabled;
            
            $scope.hasStructure = false;
            $scope.onFormLoaded = onFormLoaded;
            
            var _filtroFieldBinder;
            var _lastValue = {};
            var _originalFieldsProp = {};
            var _originalFieldsName = {};
            var _codProd;
            
            init();
            
            function init() {
            	if ($scope.onCreated) {
            		$scope.onCreated({
                        component: self
                    });
            	}
            	
            	$scope.$watch('dataset', function(newDataSet){
    		        if (newDataSet) {
    		        	
    		        	newDataSet.addInsertionModeListener(function() {
    		        		setFieldEnabled(undefined, true);
                            resetFields();
                        });
    		        	
    		        	newDataSet.addEditionCanceledListener(function(){
    		        		resetFields();
                        });
    		        	
    		        	newDataSet.addLineChangeListener(function() {
    		                if ($scope.dataset && !$scope.dataset.isInsertionMode()) {
    		                	setFieldEnabled(undefined, StringUtils.emptyAsNull($scope.tipMov) == null ? true : "C".indexOf($scope.tipMov) > -1);
    						}
    		            });
    		        	
                        _filtroFieldBinder = new FieldBinderProxy($scope.fieldName, newDataSet, getData, setData);
    		        }
    		    });
            }
            
            function initializeStructureFields(codProd) {
            	if (angular.isDefined(_codProd) && _codProd == codProd) {
            		return;
            	}
            	
            	_codProd = codProd;
            	$scope.hasStructure = false;
            	
            	var param = XmlJson.create('PRODUTO', {codProd: codProd});
            	
            	ServiceProxy.callService(
                    "mgecom@CACSP.montarEstruturaCampos",
                        param,
                        {normalizedJson:true}
                ).then(
                    function(result) {
                    	if (XmlJson.isNormalized(result)) {
                    		XmlJson.denormalize(result);
                        }
                    	
                    	var estrutura = result.responseBody.PRODUTOEST.ESTRUTURA;
                        
                    	if (estrutura) {
                    		var formProperties = [];
                    		var formValues = {};
                    		
                    		ArrayUtils.toArray(estrutura.CAMPO).forEach(function(campoElem){
                    			var field = buildFieldProperty(campoElem);
								
                    			_originalFieldsProp[field.fieldName] = field;
                    			formProperties.push(field);
								formValues[field.fieldName] = undefined;
                    		});
                    		
                    		$scope.hasStructure = true;
                    		$scope.formProperties = formProperties;
                        	$scope.formValues = formValues;
                        	
                        	if ($scope.dataset && $scope.fieldName) {
                        		setData($scope.dataset.getFieldValueAsString($scope.fieldName));
                        	}
						}
                    }
                );
            }
            
            function onFormLoaded(form) {
            	_formApi = form;
            }
            
            function setFieldEnabled(fieldName, enabled) {
            	if (!_formApi) {
            		return;
            	}
            	
            	if (angular.isUndefined(fieldName)) {
            		if ($scope.formProperties) {
            			$scope.formProperties.forEach(function(fieldProperty) {
            				_formApi.setFieldProperty(fieldProperty.fieldName, 'enabled', enabled);
            			});
            		}
            	} else {
            		_formApi.setFieldProperty(fieldName, 'enabled', enabled);
            	}
            }
            
            function buildFieldProperty(structure) {
            	var description = structure.DESCRICAO;
            	var fieldName = buildFieldName(structure.DESCRICAO);
            	
            	var fieldProperty = {
					description: description,
					fieldName: fieldName,
					type: getType(structure.TIPO),
					enabled: StringUtils.emptyAsNull($scope.tipMov) == null ? true : "C".indexOf($scope.tipMov) > -1,
					fieldProp: {}
				};
            	
            	if (structure.hasOwnProperty("OPCOES")) {
					var options = [];
					ArrayUtils.toArray(structure.OPCOES.OPCAO).forEach(function(opcElem){
						options.push({
							"value": opcElem.$,
							"data": opcElem.$
						});
					});
					
					fieldProperty.fieldProp['sk-options'] = options;
				}
            	
            	return fieldProperty;
            }
            
            /* O getType converte o tipo que vem do servidor 
               para o tipo que precisamos para criar o componente.
             
             	D - DATA
				I - INTEIRO
				N - NÚMERO
				T - TEXTO
				M - OPÇÕES
			*/
            function getType(type) {
				var newType = "";

				switch (type) {
					case "N":
						newType = "F";
						break;
					case "M":
					case "T":
						newType = "S";
						break;
					case "D":
					case "I":
					default :
						newType = type;
				}

				return newType;
			}
            
            function getOriginalFieldName(fieldName) {
            	var originalFieldName = _originalFieldsName[fieldName];
            	return originalFieldName ? originalFieldName : fieldName;
            }
            
            /* Função utilizada para gerar um nome adequado para os campos:
             * Sem espaços
             * Sem acentuação
             * E em caixa alta
             */
            function buildFieldName(prefix) {
            	var fieldName = _originalFieldsName[prefix];
            	
            	if (!fieldName) {
            		fieldName = prefix.replace(/\./g, "_");
            		fieldName = fieldName.replace(" ","");
            		fieldName = StringUtils.replaceAccentuatedChars(fieldName);
            		fieldName = fieldName.toUpperCase();
            		
            		_originalFieldsName[prefix] = fieldName;
            	}
                
                return fieldName;
            }
            
            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
            	fieldProp['sk-change'] = "modifyFieldBinder('"+fieldName+"')";
            	scope.modifyFieldBinder = modifyFieldBinder;
            }
            
            function modifyFieldBinder(fieldName) {
            	if (_filtroFieldBinder && (angular.isUndefined(_lastValue[fieldName]) || _lastValue[fieldName] != $scope.formValues[fieldName])) {
            		_filtroFieldBinder.modify();
            	}
            }
            
            function getData() {
            	var v;
            	
				if ($scope.formValues) {
					for (var fieldName in $scope.formValues) {
						var fValue = angular.isUndefined($scope.formValues[fieldName]) ? "" : getFieldValueFormated(fieldName, $scope.formValues[fieldName], true);
						v = (v == null ? "" : v + "\n") + fieldName + "=" + fValue;
					}
				}
				
				return v;
            }

            function setData(value) {
            	_lastValue = {};
            	
            	if (ObjectUtils.isEmpty(value)) {
            		resetFields();
            		
            	} else {
            		value.split(/\r?\n/).forEach(function(token) {
            			var parts = token.split("=");
            			var fieldName = getOriginalFieldName(parts[0]);
            			_lastValue[fieldName] = getFieldValueFormated(fieldName, parts[1], false);
            		});
    				
    				for (var fieldName in $scope.formValues) {
    					$scope.formValues[fieldName] = _lastValue[fieldName];
    				}
                }
            }
            
            function getFieldValueFormated(fieldName, value, isGetter) {
            	var fieldProperty = _originalFieldsProp[fieldName];
            	
            	if (fieldProperty && angular.isDefined(value)) {
            		switch (fieldProperty.type) {
            			case "D":
            				if (isGetter) {
            					if (value instanceof Date) {
            						value = DateUtils.formatDate(value);
            					}
            				} else {
            					if (value instanceof String) {
            						value = DateUtils.strToDate(value);
            					}
            				}
            				break
					}
            	}
            	
            	return value;
            }
            
            function resetFields() {
            	if ($scope.formValues) {
					for (var fieldName in $scope.formValues) {
						$scope.formValues[fieldName] = undefined;
					}
				}
            }
            
        }]);
angular
    .module('snk.components.structuredfield')
    .directive('skStructuredField', [function() {
        return {
            restrict: 'E',
            scope: {
            	onCreated: '&skOnCreated',
            	dataset: '=?skDataset',
                fieldName: '@?skFieldName',
                tipMov: '@?skTipMov'
            },
            templateUrl: 'components/structuredfield/structuredfield.tpl.html',
            controller: 'SkStructuredFieldController',
            controllerAs: 'ctrl'
        };
}]);
angular
    .module('snk.components.tabnavigator')
    .controller('TabController', ['$compile', '$scope', '$element', '$timeout', '$window', 'ObjectUtils', 'StringUtils', 'SkConstants', 'AngularUtil', 'ArrayUtils', 'TabNavigatorConstants', 'MGEParameters', 'DomUtil', 'PositionUtils', function ($compile, $scope, $element, $timeout, $window, ObjectUtils, StringUtils, SkConstants, AngularUtil, ArrayUtils, TabNavigatorConstants, MGEParameters, DomUtil, PositionUtils) {
        //private properties
        var ctrl = this;
     
        ctrl.addTab = addTab;

        function addTab(form, label){
            var tabNavigator = $element.find('div.tabnavigator-wrapper').first();
            var viewstack = $element.find('sk-viewstack').first();
           //var viewstack = angular.element(document.createElement('sk-viewstack'));

            if(tabNavigator?.length && viewstack?.length){

                var tabNavigatorItem  = angular.element(AngularUtil.createDirective('sk-tabnavigator-item', {'sk-label': label}, $scope.scopeComponent));
                
                var viewstackCtrl = AngularUtil.getContextControllerInfo(viewstack);
                viewstackCtrl.controllerInstance = angular.extend(viewstackCtrl.controllerInstance, AngularUtil.getControllerFromElement(viewstack));

                //var viewstackItem = angular.element(document.createElement('sk-viewstack-content'));
                var viewstackItem = angular.element(AngularUtil.createDirective('sk-viewstack-content', {}, $scope.scopeComponent, viewstackCtrl));
                viewstackItem.attr('flex','');
                viewstackItem.attr('layout','column');
                viewstackItem.attr('class','ng-scope');

                //$compile(viewstackItem)($scope.scopeComponent);

                var div = angular.element(document.createElement('div'));
                div.attr('flex','');
                div.attr('layout','column');
                div.attr('ng-if', 'isCreate()');
                div.attr('style', 'overflow: auto;');
                div.attr('class','ng-scope viewstack-internal-content');

                var tabItem = angular.element(document.createElement('sk-tab-item'));

                if(typeof form === 'string'){
                    tabItem.append($compile(form)($scope.scopeComponent)[0]);
                    AngularUtil.digest($scope.scopeComponent);
                } else {
                    tabItem.append(form);
                }


                div.append(tabItem);
                viewstackItem.append(div);
                viewstack.append(viewstackItem);

                tabNavigator.append(tabNavigatorItem);
                
           }
        }
   
    }]);

/**
 * @ngdoc directive
 * @name snk.components.tab.directive:sk-tab
 * @restrict E
 *
 * @description
 * Componente de tab com controle de navegação já embarcado. Esse componente é composto pelo
 * {@link snk.components.tabnavigator.directive:sk-tabnavigator skTabnavigator}
 * e o {@link snk.components.viewstack.directive:sk-viewstack skViewstack}.
 * 
 * Existem duas possíveis formas de se controlar o conteúdo de uma aba:
 *  - Reaproveitando o controle da aplicação.
 *  - Controlador por aba: basta usar a notação convencional do angular, passando um ng-controller para cada conteudo, vide aba 2 do exemplo.
 *  
 *  Adicionamente as duas opções acima podem ser usadas em conjunto, assim uma aba pode tanto usar o controlador do contexto, quanto o de aba, 
 *  vide aba 3 do exemplo.
 *
 * @param {number=} [sk-selected-index=0] index que representa qual o container a ser apresentado para o
 * usuário.
 *
 * @param {function=} sk-on-select callback executado toda vez que uma aba é selecionada.
 *
 * @param {string=} [sk-creation-policy=auto] política de criação dos containers presentes no componente.
 * Essa opção aceita:
 *
 * * <b>auto:</b> cria os containers no DOM de acordo com a necessidade e faz a renderização do seu conteúdo
 * apenas quando o container é criado no DOM.
 * * <b>all:</b> cria todos os containers no DOM e já faz a renderizaçao do seu conteúdo.
 *
 * @example
     <example module="app">
         <file name="exemplo1.html">
            <sk-application ng-controller="MeuController as ctrl">
                <sk-tab sk-selected-index="ctrl.selectedIndex" sk-on-select="ctrl.onChange">
                    <sk-tab-item label="Meu header 1">
                       <div>
                         	<p>Aba com contexto compartilhado com o parent</p>
                         	<button class="btn btn-default" ng-click="ctrl.onClickBtn1()">Btn1</button>
                       </div>
                    </sk-tab-item>
                    <sk-tab-item label="Meu header 2">
                       <p>Aba com controlador próprio</p>
                       <div ng-controller="MeuControllerAba2 as ctrlAba2">
                         	<button class="btn btn-default" ng-click="ctrlAba2.onClickBtn2()">Btn2</button>
                       </div>
                    </sk-tab-item>
                    <sk-tab-item label="Meu header 3">
                       <p>Aba usando controlador próprio e compartilhado.</p>
                       <div ng-controller="MeuControllerAba2 as ctrlAba2">
                         	<button class="btn btn-default" ng-click="ctrl.onClickBtn1()">Btn1</button>
                            <button class="btn btn-default" ng-click="ctrlAba2.onClickBtn2()">Btn2</button>
                        </div>
                    </sk-tab-item>
                </sk-tab>
                <br>
                <p ng-bind="ctrl.msg" layout-padding></p>
             </sk-application>
         </file>
         <file name="app.js">
             angular
                .module('app', ['snk'])
                .controller('MeuController', [function(){
                    var self = this;
                    
                    self.selectedIndex;
                    
                    self.onClickBtn1 = function() {
                    	console.log('clicou no botão 1');
                    }

                    self.onChange = function(id) {
                       self.msg = 'A aba de index ' + id + ' foi selecionado';
                    };
                }])
                .controller('MeuControllerAba2', [function(){
                    var self = this;
                    
                    self.onClickBtn2 = function() {
                    	console.log('clicou no botão 2');
                    }
                }]);
         </file>
     </example>
 */
angular
    .module('snk.components.tab')
    .directive('skTab', ['$timeout', '$compile', 'AngularUtil', 'ObjectUtils', 'i18n', 'SkApplication', function ($timeout, $compile, AngularUtil, ObjectUtils, i18n, SkApplication) {
        const TAB_ITEM = 'SK-TAB-ITEM';
        const TAB_HEADER = 'SK-TAB-HEADER';
        const TAB_CONTENT = 'SK-TAB-CONTENT';

        return {
            scope: {
                selectedIndex: '=?skSelectedIndex',
                onSelect: '=?skOnSelect',
                bgColor:'@bgColor'// cor que viewstack vai assumir exemplo bg-color="#F0F0F0"
                //skCreationPolice não é um parâmetro do escopo, e sim, tratado como atributo
                //skControllerName não é um parâmetro do escopo, e sim, tratado como atributo
            },
            restrict: 'E',
            transclude: false,
            controller: 'TabController as ctrl',
            compile: function(element, attr){
                var tabNavigator = angular.element(document.createElement('sk-tabnavigator'));
                var viewstack = angular.element(document.createElement('sk-viewstack'));
                tabNavigator.attr('sk-selected-index', 'selectedIndex');

                if (attr.skTabNavClass) {
                    tabNavigator.addClass(attr.skTabNavClass);
                }

                if (angular.isDefined(attr.skHideShowTabs)) {
                    tabNavigator.attr('sk-hide-show-tabs', true);
                }

                viewstack.attr('sk-selected-index', 'selectedIndex');
                viewstack.attr('sk-on-select', 'onSelect');
                viewstack.attr('flex', '');
                viewstack.attr('layout', '');
                viewstack.addClass('tab-container');
                
                if(attr.bgColor){
                    viewstack.attr('sk-bg-color', attr.bgColor);
                }

                element.attr('layout', 'column');

                if (angular.isDefined(attr.skCreationPolicy)) {
                    viewstack.attr('sk-creation-policy', attr.skCreationPolicy);
                }

                var children = element.children();
                for(var i = 0, len = children.length; i < len; i++) {
                    var clone = angular.element(children[i]).detach()[0];

                    if (clone.nodeName === TAB_ITEM) {
                        var hasHeader = false;
                        var tabNavigatorItem = angular.element(document.createElement('sk-tabnavigator-item'));

                        var elemLabel = ObjectUtils.getProperty(clone,'attributes.label.nodeValue');
                        if (angular.isDefined(elemLabel)) {
                            var i18nLabel = i18n(elemLabel);

                            tabNavigatorItem.html(i18nLabel);
                            tabNavigatorItem.attr('sk-label', i18nLabel);

                            var elemVisibleExp = ObjectUtils.getProperty(clone,'attributes.ng-show.nodeValue');

                            if (elemVisibleExp) {
                                tabNavigatorItem.attr('ng-show', elemVisibleExp);
                            }

                            var elemDisabledExp = ObjectUtils.getProperty(clone,'attributes.sk-disabled.nodeValue');

                            if (elemDisabledExp) {
                                tabNavigatorItem.attr('sk-disabled', elemDisabledExp);
                            }

                            hasHeader = true;
                        } else {
                            var tabHeaderElem = clone.querySelector(TAB_HEADER);
                            tabNavigatorItem.html(angular.element(tabHeaderElem).html());
                            hasHeader = true;
                        }

                        if (hasHeader) {
                            tabNavigator.append(tabNavigatorItem);
                        } else {
                            throw Error('Tab com header com formado inválido');
                        }

                        var viewstackItem = angular.element(document.createElement('sk-viewstack-content'));

                        var tabContentElem = clone.querySelector(TAB_CONTENT);

                        var hasLayoutPadding = true;
                        
                        if (tabContentElem) {
                            tabContentElem = angular.element(tabContentElem);
                        } else {
                            tabContentElem = angular.element(clone);
                            hasLayoutPadding = angular.isDefined(tabContentElem.attr('layout-padding'));
                        }

                        var srcElement = tabContentElem[0] || clone;

                        viewstackItem.attr('flex', ObjectUtils.getProperty(srcElement, 'attributes.flex.nodeValue') || '');
                        viewstackItem.attr('layout', ObjectUtils.getProperty(srcElement, 'attributes.layout.nodeValue') || 'column');

                        if (srcElement.attributes.hasOwnProperty('create-on-init')) {
                            viewstackItem.attr('create-on-init', '');
                        }

                        if (hasLayoutPadding) {
                        	viewstackItem.attr('layout-padding', '');
                        }
                        
                        viewstackItem.append(tabContentElem);
                        viewstack.append(viewstackItem);
                    }
                }

                return function postLink($scope, element, attr, ctrl) {
                    $scope.selectedIndex = $scope.selectedIndex || 0;
                    $scope.onSelect = $scope.onSelect || angular.noop;

                    var controllerInfo = AngularUtil.getContextControllerInfo(element);
                    var controllerAs = ObjectUtils.getProperty(controllerInfo,'controllerAs');
                    if(controllerAs) {
                        $scope[controllerAs] = controllerInfo.controllerInstance;
                    }

                    element.append(tabNavigator);
                    element.append(viewstack);

                    $scope.scopeComponent = $scope;

                    $compile(tabNavigator)($scope);
                    $compile(viewstack)($scope);

                    $timeout(function(){
                        element.css('visibility', 'visible');
                    }, 0, false);

                    $scope.$root.$on('$contextControllerChanged', function() {
                        var controllerInfo = AngularUtil.getContextControllerInfo(element);

                        if (controllerInfo) {
                            var controllerAs = controllerInfo.controllerAs;

                            if(controllerAs) {
                                $scope[controllerAs] = controllerInfo.controllerInstance;
                            }
                        }
                    });
                };
            }
        };


    }]);

angular
    .module('snk.components.tabnavigator')
    .constant("TabNavigatorConstants", {
        "EVENT_UPDATE_PAGINATION": "tabnavigator.event.update.pagination"
    });
angular
    .module('snk.components.tabnavigator')
    .controller('TabNavigatorController', ['$scope', '$element', '$timeout', '$window', 'ObjectUtils', 'StringUtils', 'SkConstants', 'AngularUtil', 'ArrayUtils', 'TabNavigatorConstants', 'MGEParameters', 'DomUtil', 'PositionUtils', function ($scope, $element, $timeout, $window, ObjectUtils, StringUtils, SkConstants, AngularUtil, ArrayUtils, TabNavigatorConstants, MGEParameters, DomUtil, PositionUtils) {
        //private properties
        var ctrl = this;
        var loaded = false;
        var elements = getElements();

        //public properties
        ctrl.tabs = [];
        ctrl.shouldPaginate = false;

        //public functions
        ctrl.addTab = addTab;
        ctrl.removeTab = removeTab;
        ctrl.prevPage = prevPage;
        ctrl.nextPage = nextPage;
        ctrl.canPageForward = canPageForward;
        ctrl.canPageBack = canPageBack;
        ctrl.select = select;
        ctrl.refreshIndex = refreshIndex;
        ctrl.removeFromDOM = removeFromDOM;
        ctrl.selectTabIndex = selectTabIndex;
        ctrl.selectTabId = selectTabId;
        ctrl.removeMargin = removeMargin;
        ctrl.getCurrentTabIndex = getCurrentTabIndex;

        ctrl.getAllTabsPopoverProperties = getAllTabsPopoverProperties;

        //sortable configs
        ctrl.sortableConfigForPrev = {
            disabled: true,
            onOverOtherGroupThrottle: 500,
            onOverOtherGroup: function (evt) {
                if (!draggingFromFieldsToTabs(evt)) {
                    prevPage();
                }
            }
        };

        ctrl.sortableConfigForNext = {
            disabled: true,
            onOverOtherGroupThrottle: 500,
            onOverOtherGroup: function (evt) {
                if (!draggingFromFieldsToTabs(evt)) {
                    nextPage();
                }
            }
        };

        ObjectUtils.defineProperty(ctrl, 'offsetLeft', handlerOffsetChange, 0);

        init();

        function removeFromDOM(index) {
            if ($scope.contentList && $scope.contentList[index]) {
                ArrayUtils.removeReference($scope.contentList, $scope.contentList[index]);
            }
        }

        function draggingFromFieldsToTabs(evt) {
            return (evt.sourceGroup == 'fields' && evt.destGroup == 'tabs');
        }

        function init() {
            if (angular.isFunction($scope.onTabnavigatorCreated)) {
                $scope.onTabnavigatorCreated({tabNavigator : ctrl});
            }

            registerWatchers();
            registerEvents();

            ctrl.offsetLeft = ctrl.offsetLeft || 0;
            $scope.selectedIndex = $scope.selectedIndex || 0;

            updatePagination();

            var deRegWatch = $scope.$watch('contentList', function (newValue) {
                if (newValue) {
                    $scope.$watchCollection('contentList', function (newValue) {
                        if (newValue) {
                            $timeout(function () {
                                var domChildsNodeList = $element[0].querySelectorAll('sk-tabnavigator-item');

                                if (!domChildsNodeList || domChildsNodeList.length == 0){
                                    return;
                                }

                                var domChilds = [];

                                for (var i = 0; i < domChildsNodeList.length; i++) {
                                    domChilds.push(domChildsNodeList[i]);
                                }

                                for (var i = 0; i < ctrl.tabs.length; i++) {
                                    var tab = ctrl.tabs[i];
                                    var tabElem = tab.element;

                                    tab.index = domChilds.indexOf(tabElem);
                                }

                                ctrl.tabs = ctrl.tabs.filter(function (tab) {
                                    return tab.index > -1;
                                }).sort(function (a, b) {
                                    return a.index - b.index;
                                });

                                handlerSelectedIndexChange($scope.selectedIndex);
                            }, 0, false);
                        }
                    });

                    deRegWatch();
                }
            });

            $timeout(function () {
                loaded = true;
            }, 0, false);
        }

        function getAllTabsPopoverProperties() {
            var props = {
                query: {
                    value: '',
                    currentIndex: 0
                },
                selectedIndex: $scope.selectedIndex,
                select: select,
                tabs: ctrl.tabs.filter(function(tab) {
                    return angular.isDefined(tab.label) && tab.isVisible() && (typeof tab.element?.checkVisibility==='function'?tab.element?.checkVisibility():true);
                }).map(function(tab) {
                    return {
                        label: tab.label,
                        index: tab.index,
                        visible: true
                    }
                }),
                filterTabs: function(tab) {
                    if (!props.query.value) {
                        return true;
                    }

                    props.selectionIndex = 0;

                    var text = StringUtils.replaceAccentuatedChars(tab.label.toLowerCase());
                    var search = StringUtils.replaceAccentuatedChars(props.query.value.toLowerCase());

                    return tab.visible = text.indexOf(search) > -1;
                },
                onKeydown: function(event, hideFn, uid) {
                    handleSearchTabKeyDown(event, props, hideFn, uid);
                }
            };

            if (MGEParameters.asBoolean('global.ordenar.abas.todasabas')) {
                props.tabs = ArrayUtils.sortByStringProperty(props.tabs, 'label');
            }

            return props;
        }

        function handleSearchTabKeyDown($event, props, hideFn, uid) {
            if (ArrayUtils.isIn([SkConstants.KEY_CODE.ENTER, SkConstants.KEY_CODE.DOWN_ARROW, SkConstants.KEY_CODE.UP_ARROW], $event.keyCode)) {
                var filteredList = props.tabs.filter(function(tab) {
                    return tab.visible;
                });

                if (filteredList.length == 0) {
                    return;
                }

                if ($event.keyCode == SkConstants.KEY_CODE.ENTER && props.query.currentIndex > -1) {
                    select(filteredList[props.query.currentIndex]);
                    hideFn();
                } else if ($event.keyCode == SkConstants.KEY_CODE.DOWN_ARROW && props.query.currentIndex < filteredList.length - 1) {
                    props.query.currentIndex++;
                    scrollViewTo(props.query.currentIndex, uid);
                } else if ($event.keyCode == SkConstants.KEY_CODE.UP_ARROW && props.query.currentIndex > 0) {
                    props.query.currentIndex--;
                    scrollViewTo(props.query.currentIndex, uid);
                }
            }
        }

        function scrollViewTo(currentIndex, popopverUid) {
            var scrollContainer = DomUtil.select($window.document, '#sk-popover-' + popopverUid + ' [sk-scroll-container]', true);
            DomUtil.scrollToChildIndex(scrollContainer, currentIndex);
        }

        function selectTabId(id) {
            ArrayUtils.forEach(ctrl.tabs, function (tab, index) {
                if (tab.tabId == id) {
                    $scope.selectedIndex = index;
                    return false;
                }
            });
        }

        function selectTabIndex(newIndex) {
            if (newIndex > -1) {
                $scope.tabSelectedIndex = newIndex;
                $scope.currentTab = $scope.tabsInfo[newIndex];

                $scope.currentTabVisible = !$scope.tabIsInvisible($scope.currentTab.tabName);
            }
        }

        function getCurrentTabIndex() {
            return $scope.selectedIndex;
        }

        function select(tabData) {
            $scope.selectedIndex = tabData.index;

            if (angular.isFunction($scope.selectedTabNavigator)) {
                $scope.selectedTabNavigator({tabNavigator : ctrl});
            }
        }

        function addTab(tabItem) {
            tabItem.index = ctrl.tabs.length;

            ctrl.tabs.push(tabItem);

            if ($scope.selectedIndex === tabItem.index) {
                updateSelection(tabItem.index);
            }

            $timeout(updatePagination, 0, false);

            return tabItem;
        }

        function removeTab(tabItem) {
            if (tabItem.index > -1){ //TODO: Quando reordenamos as abas do dynaform, as referencias de DOM estão se perdendo e o watch acima está colocando indices negativos
                ctrl.tabs.splice(tabItem.index, 1);

                for (var i = tabItem.index; i < ctrl.tabs.length; i++) {
                    var curTab = ctrl.tabs[i];

                    curTab.index = i;
                }

                refreshIndex();
            }
        }

        function refreshIndex() {
            if ($scope.selectedIndex >= ctrl.tabs.length && ctrl.tabs.length > 0) {
                $scope.selectedIndex = ctrl.tabs.length - 1;
            }
        }

        function nextPage() {
            var viewportWidth = elements.viewport.clientWidth;
            var totalWidth = viewportWidth + ctrl.offsetLeft;
            var i;
            var tab;

            for (i = 0; i < ctrl.tabs.length; i++) {
                tab = ctrl.tabs[i].element;

                if (tab.offsetLeft + tab.offsetWidth > totalWidth) {
                    break;
                }
            }

            ctrl.offsetLeft = fixOffset(tab.offsetLeft);
        }

        function prevPage() {
            var i;
            var tab;

            for (i = 0; i < ctrl.tabs.length; i++) {
                tab = ctrl.tabs[i].element;

                if (tab.offsetLeft + tab.offsetWidth >= ctrl.offsetLeft) {
                    break;
                }
            }

            ctrl.offsetLeft = fixOffset(tab.offsetLeft + tab.offsetWidth - elements.viewport.clientWidth);
        }

        function getElements() {
            var elements = {};
            elements.container = $element[0];
            elements.viewport = elements.container.querySelector('div.tabnavigator-viewport');
            elements.wrapperPaging = elements.viewport.querySelector('div.tabnavigator-wrapper');

            return elements;
        }

        function fixOffset(value) {
            if (!ctrl.tabs.length || !ctrl.shouldPaginate) {
                return 0;
            }

            var lastTab = ctrl.tabs[ctrl.tabs.length - 1].element;
            var totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;

            value = Math.max(0, value);
            value = Math.min(totalWidth - elements.viewport.clientWidth, value);

            return value;
        }

        function handlerOffsetChange(left) {
            var newValue = '-' + left + 'px';

            angular.element(elements.wrapperPaging).css('left', newValue);
        }

        function updatePagination() {
            ctrl.shouldPaginate = shouldPaginate();

            $timeout(function () {
                adjustOffset($scope.selectedIndex);
            }, 0, false);
        }

        function shouldPaginate() {
            if (!loaded) {
                return false;
            }

            var tabControls = $element[0].getElementsByClassName('tab-controls');
            
            var allTabsWidth = 0;

            // Consideramos o icone de todas as abas para o resize das abas em telas com resolu��es menores
            if(tabControls.length > 0){
                allTabsWidth = tabControls[0].clientWidth;
            }

            var canvasWidth = $element.prop('clientWidth') - allTabsWidth;

            angular.forEach(ctrl.tabs, function (tab) {
                canvasWidth -= tab.element.offsetWidth;
            });

            return canvasWidth < 0;
        }

        function adjustOffset(index) {
            if (!ctrl.tabs[index]) {
                return;
            }
            if (index == null) {
                index = ctrl.focusIndex;
            }

            var tab = ctrl.tabs[index].element;
            var left = tab.offsetLeft;
            var right = tab.offsetWidth + left;

            ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.viewport.clientWidth));
            ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
        }

        function canPageForward() {
            var lastTab = ctrl.tabs[ctrl.tabs.length - 1].element;

            return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.viewport.clientWidth + ctrl.offsetLeft;
        }

        function canPageBack() {
            return ctrl.offsetLeft > 0;
        }

        function registerWatchers() {
            $scope.$watch('selectedIndex', handlerSelectedIndexChange);
        }

        function registerEvents() {
            angular.element($window).on(SkConstants.EVENTS.RESIZE, handlerWindowResize);
            $scope.$on('$destroy', onDestroy);
            $scope.$root.$on(TabNavigatorConstants.EVENT_UPDATE_PAGINATION, function(){
        		AngularUtil.timeout(updatePagination);
        	});
        }

        function onDestroy() {
            angular.element($window).off(SkConstants.EVENTS.RESIZE, handlerWindowResize);
        }

        function handlerSelectedIndexChange(newIndex, oldIndex) {
            if (newIndex > -1 && ctrl.tabs[newIndex]) {
                updateSelection(newIndex, oldIndex);
                updatePagination();
            }
        }

        function handlerWindowResize() {
            AngularUtil.apply($scope,function () {
                ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
                $timeout(updatePagination, 0, false);
            });
        }

        function updateSelection(newIndex, oldIndex) {
            if (newIndex === oldIndex) {
                return;
            }

            var tabSelected = ctrl.tabs[newIndex];
            if (tabSelected) {
                tabSelected = angular.element(tabSelected.element);

                tabSelected.addClass('sk-selected');
            }

            var tabUnselected;

            if (oldIndex) {
                if (ctrl.tabs[oldIndex]) {
                    tabUnselected = angular.element(ctrl.tabs[oldIndex].element);
                }
            } else {
                for (var i = 0; i < ctrl.tabs.length; i++) {
                    if (i == newIndex) {
                        continue;
                    }

                    var tabElem = angular.element(ctrl.tabs[i].element);

                    if (tabElem.hasClass('sk-selected')) {
                        tabUnselected = tabElem;
                        break;
                    }
                }
            }

            if (tabUnselected) {
                tabUnselected.removeClass('sk-selected');
            }
        }

        function removeMargin(){
            if($scope.hideShowTabs){
                return {'margin-left': '0'}
            }
        }

    }]);

/**
 * @ngdoc directive
 * @name snk.components.tabnavigator.directive:sk-tabnavigator
 * @restrict E
 *
 * @description
 * Componente utilizado para fazer o controle de navegação de items colocando o mesmo em um estilo de menu.
 * O mesmo pode ser utilizado para fazer controles de viewstack, de links ou de qualquer outra coisa que
 * tenha aplicabilidade. Esse componente também vai embarcado no componente sk-tab.
 *
 * Quando esse componente é aberto a partir de um dispositivo que trabalha com touch (mobile), ao realizar
 * o movimento de 'swipe' no próprio componente, de acordo com a direção (direita ou esquerda) ele movimenta
 * a barra de navegação (Apenas quando tem items fora do container de visualização, caso contrário nada
 * acontece).
 *
 * @param {number=} [sk-selected-index=0] essa propriedade controla o index do item selecionado, quando
 * não informado, o componente assume que o primeiro item da navegação é o selecionado.
 *
 * @example
     <example module="app">
         <file name="exemplo1.html">
            <div ng-controller="MeuController">
                <sk-tabnavigator sk-selected-index="selectedIndex">
                    <sk-tabnavigator-item ng-repeat="tab in tabs"><span>{{ tab.name }}</span></sk-tabnavigator-item>
                </sk-tabnavigator>
                <br>
                <p layout-padding>Selected index: {{ selectedIndex }}</p>
                <br>
                <sk-tabnavigator sk-selected-index="selectedIndex2">
                    <sk-tabnavigator-item>Menu 1</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 2</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 3</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 4</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 5</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 6</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 7</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 8</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 9</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 10</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 11</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 12</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 13</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 14</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 15</sk-tabnavigator-item>
                    <sk-tabnavigator-item>Menu 16</sk-tabnavigator-item>
                </sk-tabnavigator>
                <br>
                <p layout-padding>Selected index 2: {{ selectedIndex2 }}</p>
            </div>
         </file>
         <file name="app.js">
            angular
                .module('app', ['snk'])
                .controller('MeuController', ['$scope', function($scope){
                    $scope.selectedIndex;
                    $scope.selectedIndex2;
                    $scope.tabs = [
                        {
                            name: 'Teste 1',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 2',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 3',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 1',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 2',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 3',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 1',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 2',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 3',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 1',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 2',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 3',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 1',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 2',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        },
                        {
                            name: 'Teste 3',
                            onCreate: function(){
                                console.log('Criou no repeat');
                            }
                        }
                    ];
                }]);
         </file>
     </example>
 */

angular
    .module('snk.components.tabnavigator')
    .directive('skTabnavigator', ['$timeout', 'SwipeUtil', function ($timeout, SwipeUtil) {
        return {
            scope: {
                selectedIndex: '=?skSelectedIndex',
                contentList: '=skContentList',
                selectedTabNavigator: '&skSelectedTabNavigator',
                onTabnavigatorCreated: '&?skTabnavigatorCreated',
            },
            restrict: 'E',
            templateUrl: 'components/tabnavigator/tabnavigator.tpl.html',
            transclude: true,
            controller: 'TabNavigatorController as ctrl',
            link: postLink
        };

        function postLink(scope, element, attr, ctrl, transcludeFn) {
        	
        	scope.hideShowTabs = angular.isDefined(attr.skHideShowTabs) ? true : false;
        	
            SwipeUtil.left(scope, element, function () {
                ctrl.nextPage();
            });

            SwipeUtil.right(scope, element, function () {
                ctrl.prevPage();
            });

            $timeout(function () {
                element.css('visibility', 'visible');
            }, 0, false);
        }
    }]);
/**
 * @ngdoc directive
 * @name snk.components.tabnavigator.directive:sk-tabnavigator-item
 * @restrict E
 *
 * @description
 * Este representa as abas do sk-tabnavigator. Ver o componente pai para mais detalhes.
 *
 * @param {boolean} cloaseableTabs Habilita a possibilidade de fechar a aba
 *
 * @param {string} fontIcon utilizado para informar qual o nome do ícone glyphicons que o componente precisa utilizar.
 * não informado, o componente assume que o primeiro item da navegação é o selecionado.
 *
 */
angular
    .module('snk.components.tabnavigator')
    .directive('skTabnavigatorItem', ['$compile', '$parse', '$timeout', '$q', 'i18n', 'DomUtil', 'ArrayUtils','StringUtils', 
        function ($compile, $parse, $timeout, $q, i18n, DomUtil, ArrayUtils, StringUtils) {
        return {
            restrict: 'E',
            require: '^skTabnavigator',
            scope: {
                label: '@skLabel',
                tabId: '@skTabId',
                canCloseFunction: '&skCanCloseFunction',
                fontIcon: '@skFontIcon'
            },
            transclude: true,
            templateUrl: 'components/tabnavigator/tabnavigatoritem.tpl.html',
            link: link
        };

        function link(scope, element, attr, ctrl) {
            if(attr.skCloseableTabs === 'true') {
                if (!hasContentList(scope)) {
                    throw new Error("Atributo 'sk-closeable-tabs' informado, mas o atributo 'sk-content-list' não foi informado na diretiva sk-tab-navigator!");
                }

                angular.element(element.children()[0]).addClass("no-padding-right");
            } else {
                angular.element(element[0].querySelector('.closeIcon')).remove();
            }

            if(angular.isUndefined(attr.skFontIcon)) {
                angular.element(element[0].querySelector('.labelIcon')).remove();
            }

            element.addClass('sk-tabnavigator-item');

            var tabLabel = resolveLabel();
            var tabId = resolveTabId();

            var visibleExp = undefined;
            if (attr.hasOwnProperty('ngShow')) {
                visibleExp = $parse(attr.ngShow);
            }

            var tabData = ctrl.addTab({
                'label': tabLabel,
                'tabId': tabId,
                'isVisible': function() {
                    return visibleExp ? visibleExp(scope.$parent) : true;
                },
                'element': element[0]
            });

            scope.select = function() {
                ctrl.select(tabData);
            };

            scope.close = function() {
                var canClose = scope.canCloseFunction();

                if (angular.isDefined(canClose)) {
                    if (canClose === true) {
                        doClose();
                    } else if (canClose === false) {
                    } else {
                        canClose.then(function() {
                           doClose();
                        });
                    }
                } else {
                    doClose();
                }
            };

            scope.enableClose = function() {
                return ctrl.enableClose();
            };

            scope.$on('$destroy', function () {
                ctrl.removeTab(tabData);
            });

            function doClose() {
                (ctrl.removeFromDOM || angular.noop)(tabData.index);
            }

            function resolveTabId(){
                var tabId = scope.tabId ? scope.tabId : StringUtils.nextUid();
                return tabId;
            }

            function resolveLabel() {
                var tabLabel = i18n(scope.label || element.textContent);

                var transcludeElem = DomUtil.select(element, '[ng-transclude]', true);

                if (tabLabel) {
                    //Se informou apenas no sk-label e não tem um conteudo, colocamos automaticamente.
                    if (transcludeElem.children().length == 0 && !element.textContent) {
                        transcludeElem.append(angular.element('<span>' + tabLabel + '</span>'))
                    }
                } else {
                    //Se não informou o sk-label, tentamos encontrar o nome da aba nos filhos
                    var possibleSelectors = ['[sk-i18n]', 'sk-i18n', '[ng-bind]'];

                    ArrayUtils.forEach(possibleSelectors, function(selector) {
                        var tabElem = DomUtil.select(transcludeElem, selector);

                        if (tabElem) {
                            tabLabel = tabElem.textContent;

                            return !angular.isDefined(tabLabel);
                        }
                    });
                }

                return tabLabel;
            }
        }

        function hasContentList(scope) {
            if(scope == null) {
                return false;
            }

            if(angular.isDefined(scope.contentList)) {
                return true;
            } else if(angular.isDefined(scope.$parent)) {
                return hasContentList(scope.$parent);
            }

            return false;
        }
    }]);
angular
    .module('snk.components.taskbar')
    .controller('SkTaskbarController', ['$scope', '$element', 'SkApplication', 'NumberConfig', 'StringUtils', 'SkPesquisaService', '$q', 'Criteria',
        function ($scope, $element, SkApplication, NumberConfig, StringUtils, SkPesquisaService, $q, Criteria) {
            var self = this;
            var _resourceId = SkApplication.instance().getResourceID();
            $scope.resourceId = _resourceId;

            var _defaultNavigatorOptions = {
                disableNavigator: false,
                showNavigation: true,
                showAddButton: true,
                showCopyButton: true,
                showRemoveButton: true,
                showRefreshButton: true,
                showCancelButton: true,
                showSaveButton: true,
                showEditButton: true,
                compactAddBtn: true
            };

            var optionsNavigator = ['disableNavigator', 'showNavigation', 'showAddButton', 'showCopyButton', 'showRemoveButton', 'showRefreshButton', 'showCancelButton', 'showSaveButton', 'showEditButton', 'compactAddBtn'];

            self.getMasterElement = getMasterElement;
            self.setIsUnderDbfPanel = setIsUnderDbfPanel;

            $scope.openNumberConfig = openNumberConfig;
            $scope.onClickUserConfiguration = onClickUserConfiguration;
            $scope.onChangeUserConfiguration = onChangeUserConfiguration;
            $scope.refreshDatasetByPk = refreshDatasetByPk;
            $scope.pesqEntitySelect = pesqEntitySelect;
            $scope.showMoreEntityPesqResults = showMoreEntityPesqResults;
            $scope.loadEntitySuggestions = loadEntitySuggestions;

            self.entitySearch = "";

            var dataset;

            init();

            function init() {
                dataset = $scope.dataset;
                if(angular.isDefined(dataset)) {
                    $scope.customEntityDescription = dataset.getEntityDescription(true);
                }

                if (!$scope.showEntityAttach) {
                    $scope.showEntityAttach = true;
                }

                if ((angular.isUndefined($scope.showGridPrinter) || $scope.showGridPrinter) && $scope.datagrid) {
                    $scope.showGridPrinter = true;
                }

                if ($scope.navigatorOptions) {
                    optionsNavigator.forEach(function (option) {
                        if (!$scope.navigatorOptions.hasOwnProperty(option)) {
                            $scope.navigatorOptions[option] = _defaultNavigatorOptions[option];
                        }
                    });
                } else {
                    $scope.navigatorOptions = _defaultNavigatorOptions;
                }
            }

            function getMasterElement() {
                return $element;
            }

            function setIsUnderDbfPanel(isUnderDbfPanel) {
                $scope.isOnDbfPanel = isUnderDbfPanel;
            }

            function openNumberConfig(event) {
                if ($scope.numberConfigDisabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

                NumberConfig.showInfo($scope.dataset.getEntityName(), _resourceId)
                    .then(function (value) {
                        $scope.autoNum = {
                            isAutoNum: value.isNumeracaoAutomatica
                        };

                        $scope.dataset.askAndCancelEdition();
                    });

            }

            function onClickUserConfiguration(conf) {
                if (!(conf.type == 'switch')) {
                    $scope.dropdownConfig.isOpen = false;
                }

                if (conf.onClick) {
                    conf.onClick(self, conf);
                }
            }

            function onChangeUserConfiguration(conf) {
                if (conf.onChange) {
                    conf.onChange(self, conf);
                }
            }

            function loadEntitySuggestions(value) {
                if (StringUtils.isEmpty(value)) {
                    return [];
                }
                self.entitySearch = value;
                var deferred = $q.defer();
                $scope.isSearchingEntity = true;
                let entityName = $scope.dataset.getEntityName();
                SkPesquisaService.loadSuggestions(entityName, value, true, 5, undefined, { localEntityName: entityName })
                    .then(function (entity) {
                        $scope.entity = entity;
                        $scope.hasMoreResults = entity.hasMore;
                        $scope.entityCardProps = {
                            entity: {
                                pkField: $scope.dataset.getPrimaryKeys()[0],
                                allPks: $scope.dataset.getPrimaryKeys(),
                                descriptionField: $scope.dataset.getEntityPresentationFieldName()
                            }
                        };
                        var options = entity.data.map(function (item) {
                            var option = {
                                key: item[entity.pkField],
                                label: item[entity.descriptionField],
                                entityName: entityName,
                                pkField: entity.pkField,
                                descriptionField: entity.descriptionField,
                                entityDescription: entity.entityDescription,
                                hasImage: item.__hasImage,
                                isFavorite: item.__isFavorite,
                                imageField: entity.imageField,
                                data: item,
                                fieldsMetadata: entity.fieldsMetadata,
                                //resourceID: entity.resourceID,
                                otherEntityPks: entity.otherEntityPks,
                                allPks: $scope.entityCardProps.entity.allPks
                            };
                            return option;
                        });
                        deferred.resolve(options);
                    }).finally(function () {
                        $scope.isSearchingEntity = false;
                    });
                return deferred.promise;
            }

            function showMoreEntityPesqResults() {
                let options = { loadOnCreate: true, showInactives: true };
                SkPesquisaService.openPesquisaPopUp($scope.dataset.getEntityName(), self.entitySearch, options).then(pesqEntitySelect);
                self.entitySearch = '';
            }

            function pesqEntitySelect(item) {
                var pk = [{
                    name: item.pkField,
                    value: item.key
                }];
                if (item.otherEntityPks) {
                    item.otherEntityPks.forEach(function (pkName) {
                        pk.push({
                            name: pkName,
                            value: item.data[pkName]
                        });
                    });
                }
                refreshDatasetByPk(pk);
                self.entitySearch = '';

            }

            function refreshDatasetByPk(pks, autoInsertPKs) {
                if (!angular.isArray(pks)) {
                    pks = [pks];
                }
                var criteria = Criteria();
                for (var index in pks) {
                    var pk = pks[index];
                    var pkMD = $scope.dataset.getFieldMetadata(pk.name);
                    if (pkMD) {
                        criteria.and(pk.name + ' = ?');
                        criteria.addParameter(Criteria.buildParameter(pkMD.dataType, pk.value));
                        if (autoInsertPKs) {
                            $scope.dataset.addAutoInsertValue(pk.name, pk.value);
                        }
                    } else {
                        throw new Error('Campo de PK desconhecido: ' + pk.name);
                    }
                }
                $scope.dataset.refresh(criteria);
            }
        }])

/**
 * @ngdoc directive
 * @name snk.components.taskbar.directive:sk-taskbar
 * @restrict E
 * @scope
 * @description
     Componente de barra de tarefas criado apartir do dataset, informado a partid do parametro <b>sk-dataset</b>.
     Para a criação do grid config e do gridprinter devem ser passados os parametros  <b>sk-config-name</b> e <b>sk-datagrid</b>
     A implementação do componente permite sua utilização dentro de um doubleface panel.
     - Para utilizar o componente dentro de um doubleface panel informe o parametro <b>target-id</b> igual ao id do sk-doubleface-panel.
 *
 * @param {SkDataset} [sk-dataset=undefined]
     Dataset que será utilizado no controle deste componente.
     O Dataset é crucial para a criação das funcionalidades da barra de tarefas.

 * @param {boolean} [sk-show-detail-description=false]
    Exibe a descrição da entidade do dataset.
 *
 * @param {Object} [sk-navigator-options=undefined]
    Opções de exibição do sk-navigator.
 *
 * @param {string} [sk-config-name=undefined]
    Config name do datagrid utilizado para montar o gridconfig, gridprinter e o componente de pesquisa(typeahead).
 *
 * @param {boolean} [sk-hide-personalized-filter-button=false]
    Esconde ou exibe o botão de filtro personalizado do componente.
 *
 * @param {function} [sk-filter-fields-personalized-filter=undefined]
    Permite alterar a função de campos do filtro personalizado.
 *
 * @param {boolean} [sk-show-filter-panel-btn=false]
    Exibe o botão de esconder ou mostrar o menu de filtro lateral.
 
* @param {boolean} [sk-show-grid-printer=false]
    Permite exibir ou esconder o gridprinter.

* @param {SkDatagrid} [sk-datagrid=undefined]
    Informa o datagrid que será utilizado no gridconfig e no gridprinter.
     
* @param {boolean} [sk-hide-entity-attach=false]
    Permite exibir ou esconder o botão de anexos.
         
* @param {boolean} [sk-hide-buttons-config=false]
    Permite exibir ou esconder o botão outras configurações no canto superior direito.
             
* @param {boolean} [sk-number-config-disabled=false]
    Permite exibir ou esconder o botão de configurações de numeração no menu outras configurações.
                 
* @param {Object} [sk-other-configurations=undefined]
    Objeto com nome e ação de click para criação de menus personalizados no menu de outras configurações.
                    
* @param {boolean} [sk-hide-entity-search-field]
    Esconde ou mostra o componente de pesquisa de entidade no menu.
                        
* @param {boolean} [sk-hide-entity-search-field]
    Esconde ou mostra o componente de pesquisa de entidade no menu.
                        
* @param {string} [target-id]
    id do elemento do double face panel a ser referenciado.
*
* @param {function} [sk-build-options]
    Método que monta as opções do menu outras opões.
*
    
 * @example
     <example>
         <file name="appTaskBar.html">
            <sk-application ng-controller="TesteController as ctrl" style="height: 210px;">
            
                <!--    uso como cabeçalho de um double face panel --->
                <sk-double-face-panel id="dbfExemplo">
                    <sk-taskbar sk-dataset="ctrl.dataset" target-id="dbfExemplo" sk-config-name="ctrl.configExemplo">
                    </sk-taskbar>
                </sk-double-face-panel>

                <!--    uso comum  --->
                <sk-taskbar sk-dataset="ctrl.dataset">
                </sk-taskbar>

                <!--    uso com navigator options   -->
                <sk-taskbar sk-dataset="ctrl.dataset" sk-navigator-options="ctrl.navigatorOptions">
                </sk-taskbar>
            </sk-application>
         </file>
         <file name="appTaskBar.js">
            angular
                .module('appTaskBar', ['snk'])
                .controller('TesteController', TesteController);

            function TesteController($scope){
                var self = this;

                self.navigatorOptions = {
                    disableNavigator: true,
                    showNavigation: false,
                    showAddButton: false,
                    showCopyButton: true,
                    showRemoveButton: true,
                    showRefreshButton: false,
                    showCancelButton: true,
                    showSaveButton: true,
                    showEditButton: true,
                    compactAddBtn: true
                };
            }
         </file>
     </example>
 */
angular.module('snk.components.taskbar')
    .directive('skTaskbar', ['AngularUtil', 'i18n', '$q', 'GridConfig',
        function (AngularUtil, i18n, $q, GridConfig) {
            return {
                scope: {
                    targetId: '@',
                    dataset: '=skDataset',
                    showDetailDescription: '=?skShowDetailDescription',
                    navigatorOptions: '=?skNavigatorOptions',
                    configName: '@?skConfigName',
                    hidePersonalizedFilterButton: '=?skHidePersonalizedFilterButton',
                    filterFieldsPersonalizedFilter: '&?skFilterFieldsPersonalizedFilter',
                    showFilterPanelBtn: '=?skShowFilterPanelBtn',
                    showGridPrinter: '=?skShowGridPrinter',
                    datagrid: '=?skDatagrid',
                    hideEntityAttach: '=?skHideEntityAttach',
                    hideButtonsConfig: '=?skHideButtonsConfig',
                    numberConfigDisabled: '=?skNumberConfigDisabled',
                    otherConfigurations: '=?skOtherConfigurations',
                    hideEntitySearchField: '=?skHideEntitySearchField',
                    buildOptions: '&skBuildOptions'
                },
                controller: 'SkTaskbarController',
                controllerAs: 'controller',
                templateUrl: 'components/taskbar/taskbar.tpl.html',
                restrict: 'E',
                link: linker,
                transclude: true
            };

            function linker(scope, element, attrs, controller) {
                addGridConfig(scope, controller);

                element.attr('style', 'flex-grow: 1;');

                if (!element[0].parentNode.getAttributeNames().find(function (name) { return name == "layout-padding" })) {
                    element[0].children[0].setAttribute('layout-padding', '');
                }

                resolveTransclude(element, controller);
            }

            function addGridConfig(scope, controller) {

                var dbfPanel = skUid(scope.targetId);

                if (!dbfPanel) {
                    let dbfPanelEl = document.getElementById(scope.targetId);

                    if (dbfPanelEl) {
                        dbfPanel = AngularUtil.getControllerFromElement(dbfPanelEl);
                    }
                }

                if (dbfPanel) {
                    controller.setIsUnderDbfPanel(true);

                    createGridConfig(scope);
                    dbfPanel.addInternalAction({
                        label: i18n('Controls.GridConfig.buttonGridConfig'), action: function () {
                            GridConfig.openGridconfig(scope.configName);
                        }
                    });
                } else {
                    console.log('skTaskbar - nao existe doubleface panel com o id \'' + scope.targetFormId + '\'informado')
                }
            }

            function createGridConfig(scope) {
                GridConfig.registerGridConfig(scope.configName, scope.configName, undefined, true);
            }

            function resolveTransclude(element, controller) {
                leftContainerTranscludeElement = controller.getMasterElement().find("sk-left-container");
                rightContainerTranscludeElement = controller.getMasterElement().find("sk-right-container");

                var userLeftContainer = angular.element(element[0].querySelector('.user-left-container'));
                var userRightContainer = angular.element(element[0].querySelector('.user-right-container'));

                if (leftContainerTranscludeElement) {
                    moveElement(leftContainerTranscludeElement, userLeftContainer);
                }

                if (rightContainerTranscludeElement) {
                    moveElement(rightContainerTranscludeElement, userRightContainer);
                }
            }

            function moveElement(origElem, destElem) {
                if (origElem && origElem.length > 0) {
                    origElem.detach();

                    destElem.append(origElem.children());
                } else {
                    destElem.detach();
                }
            }
        }])

/**
 * @ngdoc interface
 * @name snk.components.timelinediagram:IActionInterceptor
 * @description Interface utilizada para interceptar as tasks do timeline.
 */
function IActionInterceptor() {}

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#beforeAddTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma task ser adicionado no timeline
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha da task que está sendo sendo adicionada.
 * @param {TimeLineTask} task Task que está sendo adicionada.
 * @returns {TimeLineTask} task com as modificações.
 */
IActionInterceptor.prototype.beforeAddTask = function (diagram, lane, task) {
    return task;
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#afterAddTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma task ser adicionado no timeline
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha da task que está sendo sendo adicionada.
 * @param {TimeLineTask} task Task que está sendo adicionada.
 */
IActionInterceptor.prototype.afterAddTask = function (diagram, lane, task) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#beforeAddLane
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma linha ser adicionada no diagram.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que está sendo adicionada.
 * @returns {TimeLineLane} linha com as modificações.
 */
IActionInterceptor.prototype.beforeAddLane = function (diagram, lane) {
    return lane;
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#afterAddLane
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função apos uma linha ser adicionada no timeline.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que está sendo adicionada.
 */
IActionInterceptor.prototype.afterAddLane = function (diagram, lane) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#beforeRemoveLane
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma linha ser removida do diagram.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que está sendo removida.
 */
IActionInterceptor.prototype.beforeRemoveLane = function (diagram, lane) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#afterRemoveLane
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada apos uma linha ser removida do diagram.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que está sendo removida.
 */
IActionInterceptor.prototype.afterRemoveLane = function (diagram, lane) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#beforeRemoveTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma task ser removida do diagram.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que da task que está sendo removida.
 * @param {TimeLineTask} task task que está sendo removida.
 */
IActionInterceptor.prototype.beforeRemoveTask = function (diagram, lane, task) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#afterRemoveTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada apos uma task ser removida do diagram.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que da task que está sendo removida.
 * @param {TimeLineTask} task task que está sendo removida.
 */
IActionInterceptor.prototype.afterRemoveTask = function (diagram, lane, task) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#beforeModifyTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma task ser alterada.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que da task que está sendo editada.
 * @param {TimeLineTask} task task que está sendo editada.
 * @param {date} start data de inicio da task.
 * @param {date} end data final da task.
 * @returns {boolean} true se a alteração deve ser persistida
 */
IActionInterceptor.prototype.beforeModifyTask = function (diagram, lane, task, start, end) {
    return true;
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#afterModifyTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada apos uma task ser alterada.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que da task que está sendo editada.
 * @param {TimeLineTask} task task que está sendo editada.
 */
IActionInterceptor.prototype.afterModifyTask = function (diagram, lane, task) {
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#beforeCopyTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma task ser copiada.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que da task que está sendo copiada.
 * @param {TimeLineTask} task task que está sendo copiada.
 * @param {date} start data de inicio da task.
 * @param {date} end data final da task.
 * @returns {boolean} true se a cópia deve continuar.
 */
IActionInterceptor.prototype.beforeCopyTask = function (diagram, lane, task, start, end) {
    return true;
};

/**
 * @ngdoc
 * @name snk.components.timelinediagram:IActionInterceptor#afterCopyTask
 * @methodOf snk.components.timelinediagram:IActionInterceptor
 * @description Função chamada antes de uma task ser copiada.
 * @param {object} diagram Instancia do timeline.
 * @param {TimeLineLane} lane Linha que da task que está sendo copiada.
 * @param {TimeLineTask} task task que está sendo copiada.
 */
IActionInterceptor.prototype.afterCopyTask = function (diagram, lane, task) {
};

angular
   .module('snk.components.timelinediagram')
   .controller('SkLaneTitleController', ['$element', '$scope', function ($element, $scope) {
        
        var self = this;

        $scope.hasTimeConflict = $scope.hasConnectionProblem = $scope.hasFinancialLate = false;
        
        $scope.codUsu = $scope.lane.getDynamicProperty("CODUSU");
        self.updateHeaderData = updateHeaderData;
        self.updateDisplay = updateDisplay;
        self.financialLate = financialLate;
        self.shouldShowTitleIcon = shouldShowTitleIcon;

        init();

        function init(){
            $scope.tooltipAlert = "Esse usuário possui eventos com horários conflitantes.";
            $scope.tooltipLate = "Cliente com atraso financeiro.";
            $scope.tooltipNotSynchronized = "Esse usuário está com problemas na sincronização com o serviço de agenda. Certifique-se de que os dados da conta dele, e-mail e senha, estão corretos.";
            $scope.tooltipPhoto = "A foto do usuário pode ser alterada no cadastro de usuários.";
            
            updateHeaderData();
            updateDisplay();

            $scope.lane.setExpandedHeight(70);
        }

        function updateHeaderData(){
            let codUsu = $scope.lane.getDynamicProperty("CODUSU");
            let codCargo = $scope.lane.getDynamicProperty("CODCARGO");
            let descrCargo = $scope.lane.getDynamicProperty("DESCRCARGO");
            if(codCargo && descrCargo){
                $scope.tooltipLabel = codUsu + " - " + $scope.lane.getDescription() + "<br/>" + $scope.lane.getDynamicProperty("CODCARGO") + " - " + $scope.lane.getDynamicProperty("DESCRCARGO");
            }else{
                $scope.tooltipLabel = codUsu + " - " + $scope.lane.getDescription();
            }

            if($scope.codUsu != codUsu){
                $scope.codUsu = codUsu;
                $scope.photoIsLoaded = false;
            }
        }

        function updateDisplay(){
            $scope.hasTimeConflict = $scope.lane.hasTimeConflict();
            $scope.hasConnectionProblem = $scope.lane.hasConnectionProblem();
            $scope.hasFinancialLate = $scope.lane.hasFinancialLate();
        }

        function financialLate(){
            if(angular.isFunction($scope.lane.financialLate)){
                $scope.lane.financialLate();
            }
        }

        function shouldShowTitleIcon() {
            return ($scope.lane.hasTimeConflict() || $scope.hasFinancialLate || $scope.hasConnectionProblem) && !$scope.lane.isExpanded();
        }

   }]);
angular
    .module('snk.components.timelinediagram')
    .directive('skLaneTitleRenderer', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/timelinediagram/linerenderer/lanetitle/lanetitlerenderer.tpl.html',
                scope: {
                    lane: '=skLine',
                },
                link: postLink,
                controller: 'SkLaneTitleController',
                controllerAs: 'ctrl'
            }
            function postLink(scope, element, attr, ctrl){
                let parent = angular.element(element.parent()[0]);

                parent.off('dblclick');

                parent.on('dblclick', () => {
                    if(scope.lane.isExpanded()){
                        scope.lane.collapse();
                    } else {
                        scope.lane.expand();
                    }   
                });
            }
        }
    ]);
angular
    .module('snk.components.timelinediagram')
    .directive('skSimpleLineRenderer', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/timelinediagram/linerenderer/simpleline/simplelinerenderer.tpl.html',
                scope: {
                    lane: '=skLine',
                },
                link: postLink,
            }
            function postLink(scope, element, attr, ctrl){
                scope.lane.setExpandedHeight(35);
            }
        }
    ]);
angular
   .module('snk.components.timelinediagram')
   .controller('OptionsListController', ['$element', '$scope', function ($element, $scope) {
       $scope.optionsVisible = [];

       let self = this;

       function createOptionsList(){
            let element = angular.element($element[0].getElementsByClassName('option-list'))[0];
            
            if($scope.optionsList){
                for(let option of $scope.optionsList){

                    var div = angular.element('<div></div>');
                    var span = angular.element('<span ng-click="chooser($event, ' + option.action + ')"></span>');
                    var iconElem = angular.element('<sk-icon style="margin-right: 10px"></sk-icon>');
                    
                    if(angular.isObject(option)){
                        if(option.type === 'expand_all' || option.type === 'colapse_all'){
                            var icon = (option.type === 'expand_all') ? '/mge/assets/svg/expand_all.svg' : '/mge/assets/svg/collapse_all.svg'; 
                            var label = (option.type === 'expand_all') ? 'Expandir todos' : 'Contrair todos';

                            iconElem.css({width: '13px'});
                            iconElem.attr("svg-src", icon);

                            span.append(iconElem);
                            span.append(label);
                            div.append(span);

                        } else if(option.type === 'separator'){
                            var lastChild = angular.element(element.lastElementChild)
                            lastChild.css('border-bottom', '1px solid #dbdbdb');
                        } else if(option.type === 'radio'){

                            $scope.optionsVisible[option.action] = false;
                            iconElem.css({width: '7px'});
                            iconElem.attr("svg-src", '/mge/assets/svg/filled-circle.svg');
                            iconElem.attr("sk-visible", "optionsVisible[" + option.action + "]");

                            span.append(iconElem);
                            span.append(option.label);
                            div.append(span);
                        }
                    }
                    
                    element.append(div[0]);
                }

                $scope.optionsVisible[2] = true;

            }
       }

       $scope.chooser = function(event, action){
           setOptionsInvisible();
           $scope.optionsVisible[action] = true;
           if(angular.isFunction($scope.menuChoose)) $scope.menuChoose({action: action});
           $scope.hide();
       }

       $scope.verifyVisible = function(){
           return false;
       }

       function setOptionsInvisible(){
           for(var i in $scope.optionsVisible){
               if($scope.optionsVisible[i]){
                    $scope.optionsVisible[i] = false;
               }
           }
       }

       self.setSelected = function(action){
           $scope.chooser(undefined, action);
       }

       if($scope.onCreated) $scope.onCreated(self);

       createOptionsList();

   }]);

angular
    .module('snk.components.timelinediagram')
    .constant("TimeLineEvent", {
        "TASK_CLICK": "taskClick",
        "SELECTION_CELL": "selectionCell",
        "TASK_DOUBLE_CLICK": "taskDoubleClick"
    })

/**
 * Created by leonardo.jorge on 15/04/2020.
 */
angular
    .module('snk.components.timelinediagram')
    .controller('SkTimeLineDiagramController', ['$window', 'StringUtils', 'DateUtils', 'MessageUtils', '$scope', '$element', '$locale', 'AngularUtil', '$timeout', 'NumberUtils', '$injector', 'TimeLineEvent', 'ArrayUtils',
        function ($window, StringUtils, DateUtils, MessageUtils, $scope, $element, $locale, AngularUtil, $timeout, NumberUtils, $injector, TimeLineEvent, ArrayUtils) {
            //Constantes
            const DEFAULT_EXPANDED_HEIGHT = '24px';
            const DEFAULT_COLLAPSED_HEIGHT = '18px';
            const WEEK_DAYS = {1: "Seg", 2: "Ter", 3: "Qua", 4: "Qui", 5: "Sex"};
            const TITLE_MIN_WIDTH = 200;
            const BODY_MIN_WIDTH = 700;

            const _dragSource = {
                doDrag: undefined,
                currentColumn: undefined,
                currentLine: undefined,
                resize: false,
                direction: '',
                clear: function() {
                    this.doDrag = undefined;
                    this.currentColumn = undefined;
                    this.currentLine = undefined;
                    this.type = '';
                    this.resize = false;
                    this.direction = '';
                }
            };

            const _selectionSource = {
                startCol: undefined,
                endCol: undefined,
                currentLine: undefined,
                startElement: undefined,
                clear: function() {
                    this.startCol = undefined;
                    this.endCol = undefined;
                    this.currentLine = undefined;
                    this.startElement = undefined;
                }
            };

            const _resizer = {
                currentX: -200,
                clear: function(){
                    this.currentX = -200;
                }
            };

            const self = this;            
            //Variaveis
            $scope.visibleColumns = 10;
            $scope.rangeDays = 10;
            $scope.columnMetrics = [];
            $scope.columnGroups = [];
            $scope.visibleDates = [];
            $scope.timeLanesView = [];
            $scope.rows = [];
            $scope.defaultColumnWidth;
            $scope.api = self;
            //Métodos internos
            $scope.isLastDayOfMonth = isLastDayOfMonth;
            $scope.isFilteredOutOfRange = isFilteredOutOfRange;
            $scope.isWeekend = isWeekend;
            $scope.getHeaderMonthStyle = getHeaderMonthStyle;
            $scope.dragStart = dragStart;
            $scope.dragOver = dragOver;
            $scope.dragExit = dragExit;            
            $scope.drop = drop;
            $scope.dragEnd = dragEnd;
            $scope.dragLeave = dragLeave;
            $scope.dayMouseDown = dayMouseDown;
            $scope.dayMouseUp = dayMouseUp;
            $scope.dayMouseOver = dayMouseOver;
            $scope.getDayStyle = getDayStyle;
            $scope.getGridTemplate = getGridTemplate;
            $scope.resizeStart = resizeStart;
            $scope.getTitleResizeTemplate = getTitleResizeTemplate;
            $scope.resizeMove = resizeMove
            $scope.resizeTitleEnd = resizeTitleEnd;
            $scope.resizeDoubleClick = resizeDoubleClick;
            //Variaveis internas
            let _horizontalScale = [];		
            let _groupScale = [];
            let _firstDate;
            let _titleContainer;
            let _laneSortingProperties;
            let _filteredRange;            
            let _optionsInstance;
            let _iconDragTask;
            let _titleWidth = TITLE_MIN_WIDTH;
            //Métodos publicos
            self.setFirstDate = setFirstDate;
            self.previousColumn = previousColumn;
            self.previousViewPort = previousViewPort;
            self.previousOccurrence = previousOccurrence;
            self.nextColumn = nextColumn;
            self.nextViewPort = nextViewPort;
            self.nextOccurrence = nextOccurrence; 
            self.reset = reset;
            self.loadConfig = loadConfig;
            self.expandAllLanes = expandAllLanes;
            self.collapseAllLanes = collapseAllLanes;
            self.sortLanes = sortLanes;
            self.addTask = addTask;
            self.getColumnDate = getColumnDate;
            self.getVisibleColumnsLength = getVisibleColumnsLength;
            self.isVisibleTask = isVisibleTask;
            self.getColumnMetrics = getColumnMetrics;
            self.getColumnIndex = getColumnIndex;
            self.getVisibleDates = getVisibleDates;
            self.getTaskStyle = getTaskStyle;
            self.hasShowTimeConflict = hasShowTimeConflict;
            self.getTaskContentStyle = getTaskContentStyle;
            self.getFirstWorkingTime = getFirstWorkingTime;
            self.getLastWorkingTime = getLastWorkingTime;
            self.isShowTimeWear = isShowTimeWear;
            self.onTaskClick = onTaskClick;
            self.getAllLanes = getAllLanes;
            self.getAllTasks = getAllTasks;
            self.getLaneFromTask = getLaneFromTask;
            self.getLanesSort = getLanesSort;
            self.setFilteredRange = setFilteredRange;
            self.setSelectedOption = setSelectedOption;
            self.switchLane = switchLane;
            self.getFirstDate = getFirstDate;
            self.gotoDate = gotoDate;
            self.changeTask = changeTask;
            self.copyTask = copyTask;
            self.getProps = getProps;
            self.onChange = onChange;
            self.getLaneTitleController = getLaneTitleController;
            self.getIgnoreWeekend = getIgnoreWeekend;
            self.isWeekDay = isWeekDay;
            self.getVisibleColumns = getVisibleColumns;           
            self.addLane = addLane;
            self.getFormatToolTip=getFormatToolTip;
            
            init();

            function init(){
                setToday();
                //Redesenha colunas quando a quandidade de linhas eh alterada
                $scope.$watch('visibleColumns', buildCols);
                $element.on('mouseup', dayMouseUp);
                //Recalcula o tamanho dos containers de dias ao efetuar resize.
                angular.element($window).bind('resize', buildCols);
            }

            //Constroi colunas de dias e agrupamento de meses(TimeLineViewPort e TimeLineHeader)
            function buildCols(){
                //Se for menor que BODY_MIN_WIDTH trabalhamos o tamanho definido em BODY_MIN_WIDTH e deixamos dar scroll
                let elementW = 0;

                if($element.length > 0){
                    elementW = $element[0].getBoundingClientRect().width;
                }

                const labelWidth = Math.max(elementW - _titleWidth, BODY_MIN_WIDTH);

                _horizontalScale.length = 0;
                _groupScale.length = 0;                
			    $scope.columnMetrics.length = 0;
			    $scope.visibleDates.length = 0;
			    $scope.columnGroups.length = 0;
                
                _titleContainer = $element.find('.title-container');
                _lineBodyContainer = $element.find('.line-body-container');

                const lblContaier = $element.find('.header-lines');
                const lblDaysContainer = lblContaier.find('.days-container');
                
                const labelHeight = lblDaysContainer.innerHeight();
                
                const availableWidth = (labelWidth - 2); //-2 refere-se a resize que colocamos ao lado do titulo
			    $scope.defaultColumnWidth = (availableWidth / $scope.visibleColumns);
                
                let currentX = 0;
			    let currentDate;
                let currentGroup;

                do {
                    let w = Math.floor($scope.defaultColumnWidth);
                    //Cria retangulos para representar as dimensões das colunas.
                    $scope.columnMetrics.push(new Rectangle(currentX, 0, w, labelHeight));
    
                    //Mantém um array com a data de cada coluna.
                    currentDate = angular.copy(_firstDate);
                    currentDate.setDate(currentDate.getDate() + $scope.visibleDates.length);
                    $scope.visibleDates.push(currentDate);
    
                    //Agrupa as datas de acordo com uma função que retrona o título do grupo.
                    if (groupByMonth != null) {
                        var group = groupByMonth(currentDate);
                        
                        if ( !currentGroup || group != currentGroup.label) {
                            currentGroup = { label: group, rect: new Rectangle(currentX, 1, w, 1)};
                            $scope.columnGroups.push(currentGroup);
                            _groupScale[currentX] = group;
                        } else {
                            currentGroup.rect.addWidth( w );
                        }
                    }
    
                    _horizontalScale.push(currentX);
                    currentX += w;
    
                } while ($scope.visibleDates.length < $scope.visibleColumns);
                
                updateHorizontalMetrics();
            }
            
            function groupByMonth(date){
                return `${$locale.DATETIME_FORMATS.SHORTMONTH[date.getMonth()]} ${date.getFullYear()}`;
            }

            function setToday() {
                _firstDate = new Date();
                _firstDate.setHours(0, 0, 0, 0);
            }

            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#clearDataSet
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Método responsável por setar a data inicial que o componente irá utilizar como base.
             * @param {date} [data] data que será utilizada como data inicial.
             */
            function setFirstDate(d) {
                if (d == null) {
                    setToday();
                } else {
                    d.setHours(0, 0, 0, 0);
                    _firstDate = d;
                }
                buildCols();
            }

            function isLastDayOfMonth(date){
                return DateUtils.isLastDayOfMonth(date);
            }
            
            function previousColumn(){
                if(!_firstDate){
                    setToday();
                }

                _firstDate = DateUtils.subtract(_firstDate, 1);

                buildCols();
            }

            function previousViewPort(){
                if(!_firstDate){
                    setToday();
                }

                _firstDate = DateUtils.subtract(_firstDate, $scope.visibleColumns);

                buildCols();
            }

            function previousOccurrence(){
                let firstDate = _firstDate;
                let allDates = getAllStartDates(true);

                for(var i = 0; i < allDates.length;i++){
                    let date = allDates[i];
                    if(DateUtils.compareOnlyDate(firstDate, date) > 0){
                        setFirstDate(date);
                        return;
                    }
                }

			    MessageUtils.showAlert("Ocorrências anteriores", StringUtils.substitute("Não há ocorrências anteriores a \"{0}\"", DateUtils.dateToString(firstDate)));
            }

            function nextColumn(){
                if(!_firstDate){
                    setToday();
                }

                _firstDate = DateUtils.add(_firstDate, 1);

                buildCols();
            }

            function nextViewPort(){
                if(!_firstDate){
                    setToday();
                }

                _firstDate = DateUtils.add(_firstDate, $scope.visibleColumns);

                buildCols();
            }

            function nextOccurrence(){
                let lastDate = getLastDate();
                let allDates = getAllStartDates();

                for(var i = 0; i < allDates.length;i++){
                    let date = allDates[i];
                    if(DateUtils.compareOnlyDate(date, lastDate) > 0){
                        setFirstDate(date);
                        return;
                    }
                }

                MessageUtils.showAlert("Ocorrências futuras", StringUtils.substitute("Não há ocorrências posteriores a \"{0}\"", DateUtils.dateToString(lastDate)));
            }

            function getLastDate(){
                return DateUtils.add(_firstDate, $scope.visibleColumns-1);
            }

            function getAllStartDates(descOrder){
                var dates = [];

                $scope.timeLanesView.forEach(l => {
                    l.getAllTasks().forEach(t => dates.push(t.start));
                });

                dates.sort((d1, d2) => {
                    return descOrder ? DateUtils.compareOnlyDate(d2, d1) : DateUtils.compareOnlyDate(d1, d2);
                });

                return dates;
            }

            function onChange(){
                if(self.dtChooser){
                    _firstDate = self.dtChooser;
                    buildCols();    
                }
            }

            function getProps(){
                return {
                    optionsList: ($scope.optionsList || []),
                    menuChoose : ($scope.menuChoose || angular.noop),
                    onCreated: onOptionsCreated
                };
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#reset
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description posiciona o diagrama na data inicial configurada automaticamente pelo componente, ou na data passada como parâmetro.
             * @param {date} firstDate data a ser posicionada, se não for passada o default é a data inicial configurada automaticamente pelo componente
             */
            function reset(firstDate){
                if (!firstDate) {
                    firstDate = _firstDate;
                }
                setFirstDate(firstDate);
                $scope.timeLanesView.length = 0;
            }

            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#loadConfig
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Método responsável carregar as configurações do diagrama, será a partir daqui que o mesmo será renderizado.
             * @param {object} [config] objeto com as configurações do diagrama, exemplo:
             * {
                "sortBy":"NOMEUSU",
                "sortAsc":"true",
                "firstDate":"29/04/2020",
                "lane":{
                    "description":"SUP",
                    "task":[
                    {
                        "allDay":"false",
                        "start":"13/05/2020 08:00",
                        "end":"13/05/2020 18:00",
                        "color":{

                        },
                        "tooltiptext":{

                        },
                        "description":{
                            "$":"Teste"
                        },
                        "properties":{
                            "CODUSU":{
                                "$":"0"
                            },
                            "SINCRONIZAR":{
                                "$":"S"
                            },
                            "TIPO":{
                                "$":"ESTATICO"
                            },
                            "NUEVENTO":{
                                "$":"1"
                            },
                            "DHLCTO":{
                                "$":"13/05/2020 16:26"
                            },
                            "DESCRABREV":{
                                "$":"Teste"
                            },
                            "USULANCADOR":{
                                "$":"SUP       "
                            },
                            "NOMEUSU":{
                                "$":"SUP       "
                            },
                            "CONFIRMADO":{
                                "$":"N"
                            }
                        }
                    },               
                    ],
                    "properties":{
                    "CODUSU":{
                        "$":"0"
                    },
                    "CONNECTIONPROBLEM":{
                        "$":"N"
                    },
                    "CONFLICTCOLOR":{
                        "$":"0xFF0000"
                    },
                    "COLOR":{
                        "$":"0x0000FF"
                    },
                    "NOMEUSU":{
                        "$":"SUP"
                    }
                    }
                }
            }
             */
            function loadConfig(config){
                reset(DateUtils.stringToDate(config.firstDate));
                let lanes = angular.isArray(config.lane) ? config.lane : [config.lane];

                lanes.forEach((laneItem, index) => {                    
                    let lane = new TimeLineLane(this,  laneItem.description, $injector, $element);
                    
                    for (var prop in laneItem.properties){
                        lane.addDynamicProperty(prop, laneItem.properties[prop].$);
                    }
                    
                    addLane(lane);
                    
                    let tasks = [];
                    
                    if(laneItem.task) tasks = angular.isArray(laneItem.task) ? laneItem.task : [laneItem.task];
                    
                    tasks.forEach(taskItem => {
                        let task = TimeLineTask.create(taskItem, this, $injector);
                        addTask(lane, task);
                    });                    
                });

                updateHorizontalMetrics();
            }

            function updateHorizontalMetrics(){
                $timeout( () => {
                    $scope.timeLanesView.forEach( lane => {
                        lane.updateHorizontalMetrics();
                    });
                });
            }

            function addLane(lane){
                lane.setId($scope.timeLanesView.length);
               //Inicialmente o index da lane é a ultima posição do array.               
               lane.index = $scope.timeLanesView.length;               
               lane.compareTo = function(anotherLane){                   
                    if(_laneSortingProperties){                        
                        var ascending = _laneSortingProperties.sortAscending;
                        var strValue1 = this.getDynamicProperty(_laneSortingProperties.propertyName);
                        var strValue2 = anotherLane.getDynamicProperty(_laneSortingProperties.propertyName);
                        switch(_laneSortingProperties.dataType){
                            case "numeric":
                                return NumberUtils.compareNumber(strValue1, strValue2, ascending);
                            case "hour":
                                return DateUtils.compare(DateUtils.stringToDate(strValue1), DateUtils.stringToDate(strValue2));
                            case "date":
                                let value = DateUtils.compareOnlyDate(DateUtils.stringToDate(strValue1), DateUtils.stringToDate(strValue2));
                                return ascending ? value : (value * -1);
                            default:
                                return StringUtils.compareFunction(strValue1, strValue2, ascending);
                        }
                    }
                    return 0;
                }
               

                lane.hasFinancialLate = () => {
                    /** TODO
                     *  for each (var t:TimeLineTask in _tasks) {
                            if(t.getDynamicProperty("FINANCIALLATE") == "true"){
                                return true;
                            }
                        }
                     */

                    return false;
                };

                lane.financialLate = () => {
                    /**
                     * TODO
                     */
                }

                $scope.timeLanesView.push(lane);
                
                $timeout( () => buildTitle(lane) );
            }

            function buildTitle(line, fromSort = false){
                let renderer = ($scope.laneTitleRenderer || 'sk-simple-line-renderer');
                let scopeLane = $scope.$new();
                let titleItem = _titleContainer.find('.line-title-' + line.getId());
                let titleBody = _lineBodyContainer.find('.line-body-' + line.getId());
                
                scopeLane.line = line;
                
                removeTitle(titleItem);

                let titleEl = AngularUtil.createDirective(renderer, {'sk-line': 'line'}, scopeLane);                
                titleItem.append(titleEl);

                titleEl.addClass("ellipsisText ");
                titleEl.addClass("nowrapText ");
                
                if($scope.allowColapseExpand){
                    scopeLane.collapseExpand = function(expand){
                        
                        line.setExpanded(expand == undefined ? !line.isExpanded() : expand);
                        
                        let lineHeight = DEFAULT_COLLAPSED_HEIGHT;

                        if( (line.isExpanded() && expand != false) || expand){
                            //Necessario para aguardar a rendereizacao das tasks
                            $timeout(() => {
                                line.calcTasksPositions();
                                lineHeight = line.getExpandedHeight() ? Math.max(line.getExpandedHeight(), line.height) : Math.max(line.getExpandedHeight(), DEFAULT_EXPANDED_HEIGHT);
                                titleItem.css('height', lineHeight);
                                titleBody.css('height', lineHeight);                               
                                titleEl.css('height', lineHeight);  
                                titleEl.removeClass("nowrapText");
                            });                            
                        }else{
                            titleItem.css('height', lineHeight);
                            titleEl.addClass("nowrapText");
                            titleBody.css('height', lineHeight);                           
                            titleEl.css('height', lineHeight);
                        }

                        if(angular.isDefined(expand)){
                            AngularUtil.digest($scope);
                        }
                    }

                    line.collapse = () => scopeLane.collapseExpand(false);
                    line.expand = () => scopeLane.collapseExpand(true);

                    let icon = AngularUtil.createDirective('sk-icon', { 'ng-click' : 'collapseExpand()', 
                                                                        'font-icon' : '{{line.isExpanded() ? "circle-empty-minus" : "circle-empty-plus" }}', 
                                                                        'v': '2', 
                                                                        'class': 'btn-collapse-expand'}, scopeLane);
                    titleItem.append(icon);

                    $scope.rows.push(titleEl);
                }
                if(!fromSort){
                    titleItem.css('height', DEFAULT_COLLAPSED_HEIGHT);
                    titleBody.css('height', DEFAULT_COLLAPSED_HEIGHT)
                    titleEl.css('height', DEFAULT_COLLAPSED_HEIGHT);
                }else{
                    if(line.isExpanded()){
                        line.expand();
                    }else{
                        line.collapse();
                    }
                }
            }   

            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#collapseAllLanes
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função que contrai todas as linhas que estão expandidas
             */
            function collapseAllLanes(){
                $scope.timeLanesView.forEach(lane => lane.collapse());
            }

            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#expandAllLanes
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função que expande todas as linhas que estão contraidas
             */
            function expandAllLanes(){
                $scope.timeLanesView.forEach(lane => lane.expand());
            }

            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#sortLanes
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por ordenar as linhas
             * @param {string} [propertyName=undefined] propriedade da linha a ser utilizada para ordenação.
             * @param {string} [dataType=string] tipo de dados da ordenção, tipos permitidos: numeric, hour, date e string.
             * @param {string} [sortAscending=false] se true a ordenação será realizada de forma ascendente
             */
            function sortLanes(propertyName, dataType = 'string', sortAscending = false){
                _laneSortingProperties = {propertyName: propertyName, dataType: dataType, sortAscending: sortAscending};
                $scope.timeLanesView = $scope.timeLanesView.sort(compareLanes);
                $timeout( () => {                        
                        $scope.timeLanesView.forEach((lane, index) => {
                            //lane.removeTimeWearImages();
                            buildTitle(lane, true);
                            lane.index = index;
                        })
                    }
                )
            }

            function compareLanes(lane1, lane2){
                return lane1.compareTo(lane2);
            }

            function removeTitle(titleElem){
                while (titleElem[0].firstChild) {
                    titleElem[0].removeChild(titleElem[0].lastChild);
                }
            }

            function getLaneTitleController(index){
                if($scope.rows){
                    var row = $scope.rows[index];
                    return AngularUtil.getControllerFromElement(row);
                }
                return undefined;
            }

             /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#addTask
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél adicionar uma tarefa em uma determinada linha
             * @param {TimeLineLane} [lane=undefined] linha onde a task será adicionada.
             * @param {TimeLineTask} [task=undefined] tarefa a ser adicionada.
             */
            function addTask(lane, task){
                if($scope.actionInterceptor != undefined){
                    task = $scope.actionInterceptor.beforeAddTask(this, lane, task);
                }
    
                //TODO: _viewPort.registryTask(task);
                lane.addTask(task);
                lane.updateTaskMetrics(task);
                
                if($scope.actionInterceptor != undefined){
                    $scope.actionInterceptor.afterAddTask(this, lane, task);
                }
            }

            function getColumnDate(index){
                let date;

                if ($scope.visibleDates && index >= 0 && index < $scope.visibleDates.length) {
                    date = $scope.visibleDates[index];
                }

                return date;
            }

            function getVisibleColumnsLength(){
                return angular.copy($scope.visibleColumns);
            }

            function isVisibleTask(task){
                return (task.getCurrentTaskPosition() & TimeLineTask.VISIBLE_POSITION) > 0;
            }

            function getColumnMetrics(index) {
                let rect;
    
                if ($scope.columnMetrics && index >= 0 && index < $scope.columnMetrics.length) {
                    rect = $scope.columnMetrics[index];
                }
    
                return rect;
            }

            function getColumnIndex(date) {
                var index = -1;
                for (var i = 0; i < $scope.visibleDates.length; i++) {
                    if (DateUtils.compareOnlyDate(date, $scope.visibleDates[i]) == 0) {
                        index = i;
                        break;
                    }
                }

                return index;
            }

            function getVisibleDates(){
                return angular.copy($scope.visibleDates);
            }

            function getTaskStyle(lane, task, col){
                let style = {};
                style[ task.showBox() ? 'background-color' : 'color' ] = lane.hasTimeConflict(task) ? task.conflictColor : task.color;
                return style;
            }            

            function getTaskContentStyle(lane, task, col){
                let w = (col.width * task.countCols);

                let tplCols = '';

                if(task.done && StringUtils.isNotEmpty(task.iconDone)){
                    tplCols = '2px ' + (w - 20) + 'px' + ' 15px 2px' 
                }else{
                    tplCols = '2px ' + (w - 5) + 'px 2px';
                }

                return {'grid-template-columns': tplCols, 'margin-top' : task.marginTop + 'px'};
            }

            function hasShowTimeConflict(){
                return angular.copy($scope.showTimeConflict);
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getFirstWorkingTime
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description Realiza a busca da hora inicial de trabalho configurada no componente
             * @returns {string} hora inicial de trabalho.
             */
            function getFirstWorkingTime(){
                return "08:00";
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getLastWorkingTime
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description Realiza a busca da hora final de trabalho configurada no componente
             * @returns {string} hora final de trabalho.
             */
            function getLastWorkingTime(){
                return "18:00";
            }

            function isShowTimeWear(){
                return $scope.showTimeWear;
            }            

            function getTaskFromEventTarget(e){
                if(e.target.classList.contains('task-description')){
                    let target = angular.element(e.target);
                    return {task: target.scope().task, element: target};
                }else if(e.target.classList.contains('task-content') || e.target.classList.contains('task-resize')){
                    return {task: angular.element(e.target).scope().$parent.task, element: e.target};
                }
            }

            function onTaskClick($event){
                $event.type = TimeLineEvent.TASK_CLICK;
                
                $event.properties = {
                    task: angular.element($event.target).scope().$parent.task
                };

                ($scope.taskClick || angular.noop)({ $event: $event });
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getAllLanes
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por retornar todas as linhas registradas no componente
             * @returns {[TimeLineLane]} array de linhas registradas no compoente.
             */
            function getAllLanes(){
                return $scope.timeLanesView;
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getAllTasks
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por retornar todas as tasks registradas no componente
             * @returns {[TimeLineTask]} array de tasks registradas no compoente.
             */
            function getAllTasks(){
                var tasks = [];

                getAllLanes().forEach(l => {
                    l.getAllTasks().forEach(t => tasks.push(t))
                });

                return tasks;
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getLaneFromTask
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por retornar a linha da task que foi passada como parâmetro.
             * @param {TimeLineTask} [task=undefined] task que deverá ser buscada a linha.
             * @returns {TimeLineLane} linha da task passada como parâmetro.
             */
            function getLaneFromTask(task){

                let allL = getAllLanes();
                
                for (let i = 0; i < allL.length; i++) {
                    let l = allL[i];
                    
                    if(l.containsTask(task)){
                        return l;
                    }
                }

                return undefined;
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getLanesSort
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por retornar a configuração de ordenação das linhas.
             * @returns {Object} objeto de configuração de ordenação das linhas, no seguinte padrão.
             * { 
             *   propertyName: 'NOMECAMPOORDENADO', 
             *   dataType: 'TIPODEDADOSDOCAMPO', 
             *   sortAscending: 'TIPODAORDENACAO (se true a ordenação é ascendente.)'
             * };
             */
            function getLanesSort(){
                return _laneSortingProperties;
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#setFilteredRange
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por setar o periodo de datas que o diagram está filtrando.
             * @param {date} [start=undefined] data inicial.
             * @param {date} [end=undefined] data final.
             */
            function setFilteredRange(start, end) {
                const copyStart = angular.copy(start);
                const copyEnd = angular.copy(end);
                resetTimes(copyStart);
                resetTimes(copyEnd);
                _filteredRange = [copyStart, copyEnd];
            }

            function resetTimes(myDateTime) {
                if (angular.isDate(myDateTime)) {
                    myDateTime.setHours(0);
                    myDateTime.setMinutes(0);
                    myDateTime.setSeconds(0);
                    myDateTime.setMilliseconds(0);
                }
            }

            function isFilteredOutOfRange(d){
                if(_filteredRange == undefined){
                    return false;
                }
                return DateUtils.compare(d, _filteredRange[0]) < 0 || DateUtils.compare(d, _filteredRange[1]) > 0; 
            }

            function isWeekend(date) {
                return (date.getDay() == 0 || date.getDay() == 6);
            }

            function onOptionsCreated(ctrl) {
                _optionsInstance = ctrl;
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#setSelectedOption
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Função responsavél por setar a opção selecionada no nebu de opçoes.
             * @param {number} [action=undefined] código da ação a ser selecionada.
             */
            function setSelectedOption(action) {
                _optionsInstance.setSelected(action);
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#switchLane
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description
             * Substitui uma linha presente no timeline por uma nova linha passada como parâmetro.
             * @param {TimeLineLane} [oldLane=undefined] Linha a ser removida.
             * @param {TimeLineLane} [newLane=undefined] Linha a ser adicionada.
             */
            function switchLane(oldLane, newLane){
                let index = $scope.timeLanesView.indexOf(oldLane);
                if(index > -1){
                    ArrayUtils.removeAtIndex($scope.timeLanesView, index);
                    addLane(newLane);
                }
            }
            
            function getHeaderMonthStyle(){
                let colsStyle = '';
                let offsetW = 0;

                $scope.columnGroups.forEach( (colGrup, i) => {
                    let w = Math.floor(colGrup.rect.width);
                    offsetW =+ colGrup.rect.width - w;
                    
                    if(i == $scope.columnGroups.length){
                        w += offsetW;
                    }
                    
                    colsStyle += w + 'px ';
                });

                return {
                    'display': 'grid',
                    'grid-template-columns': colsStyle
                };
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#getFirstDate
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description Busca a data inicial configurada no componente.
             * @returns {date} cópia da data inicial configurada no componente.
             */
            function getFirstDate(){
                return angular.copy(_firstDate);
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#gotoDate
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description posiciona o diagrama na data passada como parâmetro, posicionado-o na view port refente a essa data.
             * @param {date} [oldLane=undefined] Linha a ser posicionada.
             */
            function gotoDate(date){
                setFirstDate(date);
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#changeTask
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description Modifica a task setando uma nova data de inicio, fim e altera a task de linha quando o parâmetro l for passado.
             * @param {TimeLineTask} [task=undefined] task a ser alterada.
             * @param {date} [start=undefined] Nova data inicial.
             * @param {date} [end=undefined] Nova data final.
             * @param {TimeLineLane} [l=undefined] Nova linha da task, quando informada troca a task para nova linha.
             */
            function changeTask(task, start, end, l = undefined){
                if(start.getTime() > end.getTime() || end.getTime() < start.getTime()){
                    return false;
                }

                let taskLane = getLaneFromTask(task);
                if(l == null){
                    l = taskLane;
                }
                if($scope.actionInterceptor){
                    var continueModify = $scope.actionInterceptor.beforeModifyTask(this, l, task, start, end);
                    if(!continueModify){
                        return;
                    }
                }
                
                if(l != null){
                    if(taskLane != l){
                        taskLane.removeTask(task);
                        taskLane.invalidateByChange();
                        l.addTask(task);
                    }
                    l.invalidateByChange();
                }
    
                task.start = start;
                task.end = end;
                task.setModified();
    
                if($scope.actionInterceptor){
                    $scope.actionInterceptor.afterModifyTask(this, l, task);
                }

                $timeout(() => {
                    l.updateHorizontalMetrics();
                    if(taskLane != l){
                        taskLane.updateHorizontalMetrics();
                    }
                });
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#copyTask
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description Realiza a cópia de uma task e adiciona a mesma na linha passada no parâmetro l.
             * @param {TimeLineTask} [task=undefined] task a ser copiada.
             * @param {date} [start=undefined] Nova data inicial.
             * @param {date} [end=undefined] Nova data final.
             * @param {TimeLineLane} [l=undefined] Linha que a task deverá ser adicionada.
             */
            function copyTask(task, start, end, l){
                if(l){
                    if($scope.actionInterceptor){
                        var continueCopy= $scope.actionInterceptor.beforeCopyTask(this, l, task, start, end);
                        if(!continueCopy){
                            return;
                        }
                    }
                    
                    task = task.clone();
                    l.addTask(task);
                    l.invalidateByChange();
    
                    task.start = start;
                    task.end = end;
                    task.setModified();
        
                    if($scope.actionInterceptor){
                        $scope.actionInterceptor.afterCopyTask(this, l, task);
                    }
                }
            }
            /**
             * @ngdoc
             * @name snk.components.timelinediagram:sk-time-line-diagram#isWeekDay
             * @methodOf snk.components.timelinediagram:sk-time-line-diagram
             * @description Verifica de a data é um dia útil.
             * @param {date} [date=undefined] Data a ser verificada.
             */
            function isWeekDay(date){
                return WEEK_DAYS.hasOwnProperty(date.getDay());
            }

            function getIgnoreWeekend(){
                return $scope.ignoreWeekend != undefined ? $scope.ignoreWeekend : true;
            }
            
            function dragStart(e){
                e.dataTransfer.setData("task-id", e.target.id);
                _dragSource.doDrag = getTaskFromEventTarget(e);
                _dragSource.doDrag.task.marginTop = 0;
                _dragSource.resize = e.target.classList.contains('task-resize');
                if(_dragSource.resize){
                     _dragSource.direction = e.target.classList.contains('left') ? 'L' : 'R';
                }else{
                    changeIconDrag(e);
                }
            }

            function changeIconDrag(e){
                if(!_iconDragTask){
                    var div = document.createElement('div');
                    div.style.display = 'inline-flex';
                    div.style.position = "absolute"; div.style.top = "0px"; div.style.left = "-100px";
                    div.setAttribute('id', 'aggrid-drag-and-drop-icon');

                    var icon = document.createElement('span');
                    //icon.style.marginTop = '-3px';
                    icon.classList.add('glyphicons-2');
                    icon.classList.add('glyphicons-2-block-move');

                    var text = document.createElement('label');
                    text.innerText = _dragSource.doDrag.task.description;
                    div.appendChild(icon);
                    div.appendChild(text);

                    document.body.appendChild(div);

                    _iconDragTask = div;
                }else{
                    _iconDragTask.getElementsByTagName('label')[0].innerText = _dragSource.doDrag.task.description;;
                }

                e.dataTransfer.setDragImage(_iconDragTask, 0, 0);  
            }

            function dragOver(e){
                if(_dragSource.doDrag && e.target.parentElement.parentElement != _dragSource.doDrag.element.parentElement){
                    _dragSource.currentColumn = getCurrentColumnFromEvent(e);
                    _dragSource.currentLine = getCurrentLineFromEvent(e);
                    
                    if(_dragSource.resize){
                        let lineEl = $element.find('.day-item[index="' + _dragSource.currentColumn + '"][line="' + _dragSource.currentLine.getId()  + '"]');
                        
                        if(lineEl.length == 0) return;
                        let dayEl = lineEl.find('.task-shadow');
                        if(dayEl.length > 0) return;

                        let boundRec = _dragSource.doDrag.element.getBoundingClientRect();
                        let col = $scope.columnMetrics[_dragSource.currentColumn];
                        e.target.append(createShadowTask(boundRec.x, boundRec.y, col.width, boundRec.height));
                    }else{
                        let el = getColumnElementFromEvent(e);
                        el.classList.add('drop-day');
                        
                        let nextElementSibling = el.nextElementSibling;

                        for(var i = 1; i < _dragSource.doDrag.task.countCols; i++){                            
                            if(nextElementSibling){
                                nextElementSibling.classList.add('drop-day');
                                nextElementSibling = nextElementSibling.nextElementSibling;
                            }else{
                                return;
                            }
                        }
                    }                    
                }
            }

            function createShadowTask(x, y, w, h){
                let elDiv = document.createElement('div');
                elDiv.classList.add('task-shadow');
                elDiv.style.top = y + "px";
                elDiv.style.width = w + "px";
                return elDiv;
            }

            function getCurrentColumnFromEvent(e){
                let el = getColumnElementFromEvent(e);
                
                if(el) {
                    return el.getAttribute('index');
                }

                return -1;
            }

            function getColumnElementFromEvent(e){
                let el = e.target;
                
                while (el != undefined){
                    if(el.classList.contains('day-item')){
                        return el;
                    }
                    el = el.parentElement;
                }
            }
            
            function dragExit(e){                
            }           

            function drop(e){
                let items = e.dataTransfer.getData('items');

				if(items){					
					dayMouseUp(e);
                }
            }
            
            function dragEnd(e){                                 
                if(_dragSource.resize){                    
                    removeShadowResize();
                }else{
                    removeDropDayClass();
                }
                finishDrag(e);
                _dragSource.clear(); 
            }

            function dragLeave(e){
                removeDropDayClass();
            }

            function removeDropDayClass(){
                let dropDayElem = _lineBodyContainer.find('.drop-day');
                
                for(var i = 0; i < dropDayElem.length; i++){
                    dropDayElem[i].classList.remove('drop-day');
                }
            }


            function getCurrentLineFromEvent(e){
                return angular.element(e.target.parentElement).scope().lane;
            }

            function removeShadowResize(){
                let dropDayElem = _lineBodyContainer.find('.task-shadow');
                
                for(var i = 0; i < dropDayElem.length; i++){
                    dropDayElem[i].remove();
                }
            }

            function finishDrag(event){
                if(!_dragSource.doDrag) return; //Não deixa conflitar com a seleção de celulas

                let t = _dragSource.doDrag.task;
                
                let toDate;

                if(_dragSource.resize){
                    //se estamos fazendo resize da task, devemos calcular a nova data pela posição do evento.
                    toDate = angular.copy(getColumnDate(getIndexDayFromEventPosition(event, _dragSource.currentLine)));
                    let colPosElement = $element.find('[index="' + _dragSource.currentColumn + '"]')[0];
                    let direction = getResizeDirection(_dragSource.doDrag.element, colPosElement);
                    let directionInverted = (direction != _dragSource.direction);
                    let isBack = false;

                    if(directionInverted){
                        isBack = direction == "R" ? getTaskStartCol(t) < Number(_dragSource.currentColumn) : getTaskStartCol(t) < Number(_dragSource.currentColumn);
                    }else{
                        isBack = direction == "R" ? getTaskStartCol(t) > Number(_dragSource.currentColumn) : getTaskStartCol(t) < Number(_dragSource.currentColumn);
                    }

                    let propDate = (direction == "R"  || DateUtils.compareOnlyDate(t.start, toDate) == 0 )? 'end' : 'start';

                    toDate.setHours(t[propDate].getHours());
                    toDate.setMinutes(t[propDate].getMinutes());
                    toDate.setSeconds(t[propDate].getSeconds());
                    
                    let dtStart;
                    let dtEnd;

                    if(direction == "R"){

                        if(directionInverted && !isBack) {
                            dtStart =  t.start;
                            dtEnd = toDate;
                        }else if(isBack){
                            dtStart =  toDate;
                            dtEnd = t.end;
                        }else{
                            dtStart =  t.start;
                            dtEnd = toDate;
                        }
                        
                        changeTask(t, dtStart, dtEnd);
                    }else{
                        
                        if(directionInverted && !isBack){
                            dtStart =  t.start;
                            dtEnd = toDate;
                        }else if(isBack){
                            dtStart = t.start;
                            dtEnd = toDate; 
                        }else {
                            dtStart =  toDate;
                            dtEnd = t.end;
                        }

                        changeTask(t, dtStart, dtEnd);
                    }
                }else{
                    toDate = angular.copy(getColumnDate(_dragSource.currentColumn));
                    toDate.setHours(t.start.getHours());
                    toDate.setMinutes(t.start.getMinutes());
                    toDate.setSeconds(t.start.getSeconds());

                    if(event.ctrlKey && $scope.allowCopy){
                        copyTask(t, toDate, t.calculateEndDate(toDate), _dragSource.currentLine);
                    }else{
                        changeTask(t, toDate, t.calculateEndDate(toDate), _dragSource.currentLine);
                    }
                }
            }

            function getResizeDirection(source, target){
                source = angular.element(source);
                target = angular.element(target);
                let srcX = source[0].getBoundingClientRect().x;
                let tgtX = target[0].getBoundingClientRect().x;
                return srcX > tgtX ? "L" : "R";
            }

            function getTaskStartCol(task){
                let selector = '.day-' + task.start.getDate() + '-' + task.start.getMonth() + '-' + task.start.getFullYear();
                let el = $element.find(selector);
                
                if(el.length > 0){
                    return Number(el.attr('index'));
                }else{
                    return -1;
                }
            }

            function getVisibleColumns(){
                return angular.copy($scope.visibleColumns);
            }

            function getDayStyle(col){
                return { width: col.width, height: col.height};
            }

            function getIndexDayFromEventPosition(event){
                let evtX = event.clientX;
                let lane = getLaneFromTask(_dragSource.doDrag.task)
                let tasks = getTasksElementsFromLane(lane);

                for(var i = 0; i < tasks.length; i++){
                    let taskEl = tasks[i];
                    let boundRec = taskEl.getBoundingClientRect();
                    
                    if(boundRec.left <= evtX && evtX <= (boundRec.left + boundRec.width)) return taskEl.getAttribute('index');
                }
            }

            function getTasksElementsFromLane(lane){
                return $element.find('.day-item[line="' + lane.getId() + '"]');
            }

            function dayMouseDown(event, lane){
                if(!event.target.classList.contains('day-item')) return;
                _selectionSource.startCol = getCurrentColumnFromEvent(event);
                _selectionSource.currentLine = lane;
                _selectionSource.startElement = event.target;                
            }

            function dayMouseUp(event){
                removeDropDayClass();
                
                if($scope.selectionCell) {                    
                    let props = {};                    
                    if (_selectionSource.startCol != undefined) {                    
                        props.colStart = _selectionSource.startCol;
                        props.start = getColumnDate(props.colStart);
                        props.colEnd = _selectionSource.endCol;
                        props.end = getColumnDate(props.colEnd);
                        props.lane = _selectionSource.currentLine;                        
                    }else if(event.type == 'drop'){
                        props.items = event.dataTransfer.getData('items');
                    }
                    if(Object.keys(props).length > 0){
                        event.skType = TimeLineEvent.SELECTION_CELL;
                        event.properties = props;
                        $scope.selectionCell({$event: event});
                    }
                }

                resizeTitleEnd();
                _selectionSource.clear(); //Não chamar o clear antes do $scope.selectionCell
            }

            function dayMouseOver(event, lane){
                if(!_selectionSource.startCol || lane.getId() != _selectionSource.currentLine.getId() || _selectionSource.startElement == event.target) return;

                _selectionSource.endCol = getCurrentColumnFromEvent(event);
                
                if(_selectionSource.startElement != event.target){
                    if(!_selectionSource.startElement.classList.contains('drop-day')) _selectionSource.startElement.classList.add('drop-day')
                    let el = getColumnElementFromEvent(event);
                    el.classList.add('drop-day');
                }
            }

            function getGridTemplate(){
                return {'grid-template-columns': _titleWidth + 'px 2px auto'};
            }

            function getTitleResizeTemplate(){
                let resizerH = 0;

                if($element.length){
                    resizerH = $element[0].getBoundingClientRect().height;
                }

                return { height: resizerH + 'px', left:  _resizer.currentX + 'px'};
            }

            function resizeStart($event){
                _resizer.currentX = $event.clientX;
            }

            function resizeMove($event){
                if(_resizer.currentX != -200) _resizer.currentX =  Math.max(TITLE_MIN_WIDTH, $event.clientX);
            }
            
            function resizeTitleEnd($event){
                if(_resizer.currentX != -200){
                    _titleWidth = Math.max(TITLE_MIN_WIDTH, _resizer.currentX);
                    buildCols();
                    _resizer.clear();
                    AngularUtil.digest($scope);
                }
            }

            function resizeDoubleClick(){
                if(_titleWidth != TITLE_MIN_WIDTH){
                    _titleWidth = TITLE_MIN_WIDTH;
                    _resizer.clear();
                    $timeout( () => buildCols() );
                }
            }

            function getFormatToolTip(task){
                var formatToolTip=DateUtils.formatDate(task._start, 'HH:mm')+'-'+
                DateUtils.formatDate(task._end, 'HH:mm')+'<br>'+ task._properties.DESCRABREV +"<br>";
               
                if(angular.isDefined(task._properties.DESCRLONGA)){
                    formatToolTip+=task._properties.DESCRLONGA.replace(/\n/g, "<br>");
                }
                return formatToolTip;
            }
        }]);


/**
 * @ngdoc directive
 * @name snk.components.timelinediagram:sk-time-line-diagram
 * @restrict E
 * @scope
 * @description
    <p align="justify">
    TimeLineDiagram é o componente resposavél por apresentar as agendas, e prazos em algumas rotinas do sistema, 
    como por exemplo, a AgendaDeRecursos, onde apresentamos a agenda diária de varios colboradores em uma mesma 
    visão, com intuido de ter uma visão ampla de horários para agendamento de tarefas de uma equipe, setor, ou até mesmo
    uma empresa.
    </p>
 
 * @param {object} sk-api Variavél que o componente fará bind de sua api de métodos e varávies, pode ser usado para modificar comportamentos do 
   componente e executar funções disponivéis.

   @param {string} sk-diagram-title Variavél urilizado para informar o titulo a ser apresentado no componente.

   @param {array} sk-options-list Lisa de opções disponivéis no menu de contexto do diagrama, recebe um array de objetos no seguinte padrão:
    {  
       label: 'Ordenar por nome (crescente)', String informando o label da opção
       action: 2, Identificador da ação
       type: 'radio' Tipo da ação, as opções disponivéis são:   radio: apresenta um radio button
                                                                separator: apresenta um separador entre as opções
                                                                expand_all: Opção de expandir todas as linhas do diagrama.
                                                                colapse_all: Opção de contrair todas as opções do diagrama.
    },
 * 
 * @param {Function} sk-menu-choose função de listener que será acionada no evento de click de uma das opções definidas no sk-options-list, recebe um parâmetro
 * action com identificador da ação que foi acionada, exemplo:
 * 
  
    function menuChoose(action){
        let ascending;
        let dataType;
        let propertyName;
        
        let laneApi = skUid('timeLineTeste');
        
        if(action == 0){
            laneApi.expandAllLanes();
        }else if(action == 1){
            laneApi.collapseAllLanes();
        }

        if(action == 4){
            ascending = true;
            dataType = "numeric";
            propertyName = "CODUSU";
        } else if(action == 5) {
            ascending = false;
            dataType = "numeric";
            propertyName = "CODUSU";
        } else if(action == 2) {
            ascending = true;
            dataType = "string";
            propertyName = "NOMEUSU";
        } else if(action == 3) {
            ascending = false;
            dataType = "string"
            propertyName = "NOMEUSU";
        }

        laneApi.sortLanes(propertyName, dataType, ascending);
    }

    @param {boolean} sk-allow-colapse-expand informa se o diagrama irá apresentar a opção de expandir e contrair as linhas.

    @param {string} sk-lane-title-renderer Informa o nome do componente/diretiva que será utilizada para renderizar a apresentação da
    linha, na barra lateral esquerda do diagrama, por default, temos 2 implementações nativas do framework, sendo elas sk-simple-line-renderer 
    e sk-lane-title-renderer, caso neessite de algo mais especifico, poderá ser cliada uma diretiva personalizada e passar seu nome como parâmetro
    neste atributo, ver exemplo dessa implementação no fontes /sankhya-js/src/components/timelinediagram/linerenderer/lanetitle/*.

    @param {IActionInterceptor} sk-action-interceptor interceptor que será chamado durante o ciclo de vida de uma task dentro do diagrama, geralmente esse 
    é utilizado para remover, adicionar e modificar informações de uma task em determinados momentos.

    @param {boolean} sk-show-time-conflict quando true irá destacar em vermelho as tarefas que têm conflito de horário.

    @param {boolean} sk-show-time-wear quando true, o diagrama irá apresentar um idicador em cada dia do mês indicando a utilização 
    de horas daquele determinado dia.

    @param {boolean} sk-can-change-done quando true, o diagrama irá permitir alterações em uma task que já esteja marcada como concluida.

    @param {Function} sk-task-click, listener chamado ao efetuar um click em uma task, recebe como parâmetro um evento, contendo um atributo
    type, com um dos tipos definidos em TimeLineEvent

    @param {boolean} sk-allow-copy, se true vai permitir a cópia de tarefas ao utilizar a tecla ctrl para arrastar uma task.

    @param {boolean} sk-ignore-weekend, se true, não permitirá arrastar e soltar nos finais de semana.

    @param {Function} sk-selection-cell, função a ser chamada ao finalizar a seleção de celulas.
 * 
 *  Exemplo de utilização:
        //html         
        //  <sk-time-line-diagram sk-uid="timeLineTeste" 
        //          sk-allow-colapse-expand="true" 
        //          sk-diagram-title="Agenda de Recursos" 
        //          sk-menu-choose="ctrl.menuChoose(action)" 
        //          sk-options-list="ctrl.optionsList" 
        //          sk-lane-title-renderer="sk-lane-title-renderer"
        //          sk-show-time-conflict="true"
        //          sk-show-time-wear="true"
        //          sk-task-click="ctrl.taskClick($event)"
        //          sk-action-interceptor="ctrl">
        //  </sk-time-line-diagram>        
         
         //JS
        angular
        .module('app', ['snk'])
        .controller('ExampleController', ['ServiceProxy', function(ServiceProxy){
            var self = this;

                init();

            function init(){
                ServiceProxy.callService(
                "mgeos@AgendaRecursosSP.carregarAgendas",
                {params: {
                        start: "29/04/2020",
                        end: "07/06/2020", 
                        mostraUsuarioLogado: true, 
                        resourceId: "br.com.sankhya.os.mov.agenda.recursos", 
                        resourceIdListaUsuarios: "br.com.sankhya.os.mov.agenda.recursos.list.Executante" 
                    }
                })
                .then(function(res){
                    
                    if(res.responseBody.hasOwnProperty("timeLine")){
                        var source = res.responseBody.timeLine;                            
                        skUid('timeLineTeste').loadConfig(source);
                    }
                    
                });
            }

            self.optionsList = [
                {
                    type: 'expand_all',
                    action: 0
                },
                {
                    type: 'colapse_all',
                    action: 1
                },
                {
                    type: "separator"
                },
                { 
                    label: 'Ordenar por nome (crescente)',
                    action: 2,
                    type: 'radio'
                },
                { 
                    label: 'Ordenar por nome (decrescente)',
                    action: 3,
                    type: 'radio'
                },
                { 
                    label: 'Ordenar por código (crescente)',
                    action: 4,
                    type: 'radio'
                },
                { 
                    label: 'Ordenar por código (decrescente)',
                    action:  5,
                    type: 'radio'
                }
            ];

            self.menuChoose = function(action){
                let ascending;
                                let dataType;
                let propertyName;
                let laneApi = skUid('timeLineTeste');
                    
                if(action == 0){
                    laneApi.expandAllLanes();
                }else if(action == 1){
                    laneApi.collapseAllLanes();
                }

                if(action == 4){
                    ascending = true;
                    dataType = "numeric";
                    propertyName = "CODUSU";
                } else if(action == 5) {
                    ascending = false;
                    dataType = "numeric";
                    propertyName = "CODUSU";
                } else if(action == 2) {
                    ascending = true;
                    dataType = "string";
                    propertyName = "NOMEUSU";
                } else if(action == 3) {
                    ascending = false;
                    dataType = "string"
                    propertyName = "NOMEUSU";
                }

                laneApi.sortLanes(propertyName, dataType, ascending);
            }

            self.taskClick = function(event){
                console.log('skTaskClick', event);
            }

            self.afterAddTask = function (diagram, lane, task) {
                task.toolTipText = "Teste <br>Teste tag html</br>";
            }
        }]);
 */
angular
    .module('snk.components.timelinediagram')
    .directive('skTimeLineDiagram', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/timelinediagram/timelinediagram.tpl.html',
                controller: 'SkTimeLineDiagramController',
                controllerAs: 'ctrl',
                scope: {
                    api: '=?skApi',
                    diagramTitle: '@skDiagramTitle',
                    optionsList: '=?skOptionsList',
                    menuChoose: '&?skMenuChoose',
                    allowColapseExpand: '=?skAllowColapseExpand',
                    laneTitleRenderer: '@?skLaneTitleRenderer',
                    actionInterceptor: '=?skActionInterceptor',
                    showTimeConflict: '=?skShowTimeConflict',
                    showTimeWear: '=?skShowTimeWear',
                    canChangeDone: '=?skCanChangeDone',
                    taskClick: '&?skTaskClick',
                    showTimeConflict: '=?skShowTimeConflict',
                    allowCopy: '=?skAllowCopy',
                    ignoreWeekend: '=?skIgnoreWeekend',
                    selectionCell: '&?skSelectionCell'
                },
            }
        }
    ]);

angular
    .module('snk.components.timelinediagram')
    .directive('skTimeWear', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/timelinediagram/timewear/timewear.tpl.html',
                controller: 'SkTimeWearController',
                controllerAs: 'ctrl',
                scope: {
                    timeLane: '=?skTimeLine',
                    startTime: '@?skStartTime',
                    endTime: '@?skEndTime'
                },
            }
        }
    ]).controller('SkTimeWearController', ['$scope', 'DateUtils', 'StringUtils', '$element',
    function ($scope, DateUtils, StringUtils, $element) {

        const self = this;
        
        let _usedTime = '';
        let _collisionTime;
        let _lastVisibleSlot;
		let _firstVisibleSlot;
		let _hasConflict = false;

        self.getStyle = getStyle;
        self.buildRectangles = buildRectangles;
        self.setFull = setFull;
		self.addUsedPeriod = addUsedPeriod;
		self.clear = clear;
		self.getRectangleClass = getRectangleClass;

		self.rects = [];


        init();

        function init(startTime = "08:00", endTime = "18:00"){
			maintainAspectRatio = false;
			_firstVisibleSlot = getSlotFromTime($scope.startTime || startTime);
			_lastVisibleSlot = getSlotFromTime($scope.endTime || endTime);
			self.rects.length = 0;
			buildRectangles();
		}

        function getSlotFromTime(strTime, roundType = "UP"){
			var value = DateUtils.getMinutes(strTime) / 30;
			return roundType == 'UP' ? Math.ceil(value) : Math.floor(value);
        }

        function buildStrPeriod(startTime, endTime){
			var startAt = getSlotFromTime(startTime, 'D');
			var endAt = getSlotFromTime(endTime);

			var str = StringUtils.stringZero(null, startAt);
			while(str.length < endAt){
				str = str + "1";
			}

			return str;
        }
        
        function addUsedPeriod(startTime, endTime){

			var period1 = buildStrPeriod(startTime, endTime);
			var period2 = _usedTime == null ? "" : _usedTime;
			_usedTime = "";

			var maxSize = Math.max(period1.length, period2.length);
			var collisionStr = "";

			for(var i = 0; i < maxSize; i++){
				var conflict = getSlot(i, _collisionTime);
				if(conflict == 0){
					var s1 = getSlot(i, period1);
					var s2 = getSlot(i, period2);
					conflict = s1 & s2;
					_usedTime = _usedTime + (s1|s2).toString();
				} else {
					_usedTime = _usedTime + "1";
				}
				collisionStr = collisionStr + conflict.toString();
			}

			_collisionTime = collisionStr;

			buildRectangles();
        }
        
        function periodHasConflict(startTime, endTime){
			if(StringUtils.emptyAsNull(_collisionTime) == null){
				return false;
			}
			
			var period = buildStrPeriod(startTime, endTime);
			
			for(var i = 0; i < period.length; i++){
				var slotConflict = getSlot(i, _collisionTime);
				var slotPeriod = getSlot(i, period);
				if((slotConflict & slotPeriod) == 1){
					return true;
				}
			}
			return false;
        }
        
        function getSlot(index, strTime){
			if(strTime != null && index >= 0 && index < strTime.length){
				return parseInt(strTime.charAt(index));
			}
			return 0;
		}
		
		function setFull(){
			addUsedPeriod("00:00", "23:59");
			buildRectangles();
		}

		function clear(){
			_usedTime = null;
			_collisionTime = null;
			self.rects.length = 0;
			buildRectangles();
		}
		
		function testFlag(strTime, index){
			return (strTime == null || strTime.length < index ? false : strTime.charAt(index) == "1");
        }
		
        function buildRectangles(){
			
			var qtdSlots = _lastVisibleSlot - _firstVisibleSlot;
			var slotWidth = ($element.parent().width() - 6) / qtdSlots;

			_hasConflict = false;

			self.rects.length = 0;

			var currentRect;

			for (var i = _firstVisibleSlot; i < _lastVisibleSlot; i++){
				
				var type = "free";
				
				if(testFlag(_collisionTime, i)){
					type = "collision";
					_hasConflict = true;
				} else if(testFlag(_usedTime, i)){
					type = "used";
				}
				
				if(currentRect == undefined || currentRect.type != type){
					currentRect = new Rectangle(0, 0, slotWidth, 0);
                    
                    currentRect.type = type;
                    
                    self.rects.push(currentRect);
				} else {
					currentRect.width += slotWidth;
				}
			}
		}

		/*function updateDisplayList(unscaledWidth:Number, unscaledHeight:Number):void{
			if(_invalidTime){

				var bmp:BitmapData = null;
				var freeTimeColor:uint = 0xA6A6A6;
				var usedTimeColor:uint = 0x424242;
				var colisionTimeColor:uint = 0xC02020;
				
				if(unscaledWidth > 0 && unscaledHeight > 0 && _usedTime != null){
					bmp = new BitmapData(unscaledWidth, unscaledHeight, false, freeTimeColor);
					for each(var rect:TimeRectangle in buildRectangles()){
						var type:String = rect.type;
						bmp.fillRect(rect, type == "collision" ? colisionTimeColor : usedTimeColor);
					}
				}
				data = new Bitmap(bmp);
				_invalidTime = false;
			}
			super.updateDisplayList(unscaledWidth, unscaledHeight);
		}*/

        function getStyle(){
            let style = { 'grid-template-columns' : '', 'height' : '10px', 'padding-left': '3px' };

            self.rects.forEach(rec => {
                style['grid-template-columns'] += rec.width + 'px ';
            });

            return style;
		}
		
		function getRectangleClass(rec){
			if(rec.type == 'collision'){
				return 'time-wear-collision';
			}else if(rec.type == 'used'){
				return 'time-wear-used';
			}else{ //free
				return 'time-wear-free';
			}
		}


    }]);

/**
 * @ngdoc directive
 * @name snk.components.icon.directive:sk-title
 * @restrict E
 * @description
 * A diretiva 'sk-title' possui o padrão de tamanho, cor e bold dos titulos do framework.
 * Outros componentes de layout podem ser usados em conjunto para personlizar a fonte, como sk-font-size,
 * sk-color e sk-bg-color
 *
 * @param {String} sk-text Texto a ser escrito no título, pode ser uma chave de i18n
 * 
 * @example
     <example module="app">
         <file name="exemplo.html">
            <sk-vbox>
                 <sk-title sk-text="Teste">
                 </sk-title>
                 <sk-title sk-text="Com a cor da marca" sk-color="brand">
                 </sk-title>
             </sk-vbox>

         </file>
         <file name="app.js">
            angular
                .module('app', ['snk']);
         </file>
     </example>
 */
angular
    .module('snk.components.font')
    .directive('skTitle', ['i18n', function (i18n) {
    return {
        restrict: 'E',
        scope: false,
        link: function (scope, element, attr) {
            attr.$observe('skText', function(newValue) {
                element.html(i18n(newValue));
            });
        }
    };
}]);
/**
 * Created by leonardo.jorge on 04/10/2019.
 */
/**
 * @ngdoc directive
 * @name snk.components.titllabel.directive:sk-title-label
 * @restrict E
 * @scope
 * @description
   skTitleLabel é um componente reposnsavel por apresentar um texto com um label.
 * @param {string} sk-text texto a ser apresentado no label.
 * @param {boolean} sk-required se true apresenta o icone (*) de requerido.
 * @param {object} sk-style estilo a ser aplicado no texto do label.
 * @param {string} sk-icon icone a ser apresentado no label.
 * @example
     <example module="appTitleLabel">
         <file name="appTitleLabel.html">
         	<div ng-controller="TesteCtrl">
	            <sk-title-label sk-text="'Title Label'" sk-icon="user-incognito" sk-icon-v="2"></sk-title-label>
         	</div>
         </file>
         <file name="appTitleLabel.js">
            angular
                .module('appTitleLabel', ['snk'])
                .controller('TesteCtrl', function($scope){                   
                });
         </file>
     </example>
 */
angular
    .module('snk.components.titlelabel')
    .directive('skTitleLabel', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/titlelabel/titlelabel.tpl.html',
                scope: {
                    text: '=skText',
                    required: '=?skRequired',
                    labelStyle: '=?skStyle',
                    icon: '@?skIcon',
                    iconV: '@?skIconV'
                },
            }
        }
    ]);
/**
 * @ngdoc controller
 * @name snk.components.modal.controller:skModalController
 *
 * @description
 *  Controller responsável pelo comportamento da modal customizada.
 */
angular
    .module('snk.components.toast')
    .controller('skToastController', ['$scope',
        function ($scope) {
            var self = this;

            self.fecharModal = function () {
                $scope.ctrl.skShowModal = false;
            };

            self.executarAcao = function () {
                if (angular.isFunction(self.skAction)) {
                    self.skAction();
                }
                self.fecharModal();
            };
        }]);

/**
 * @ngdoc directive
 * @name snk.components.toast.directive:toast
 * @restrict E
 *
 * @description
 *  Componente de modal customizada, que permite configurar título, mensagem e ação do botão.
 *
 * @param {string} sk-title      Título exibido na modal.
 * @param {string} sk-message    Mensagem exibida na modal.
 * @param {function} sk-action   Função executada ao clicar no botão de ação.
 *
 * @example
   <example module="app">
       <file name="modalExample.html">
           <toast sk-title="Título" sk-message="Texto da modal." sk-action="ctrl.minhaAcao()"></toast>
       </file>
       <file name="app.js">
           angular.module('app', ['snk']);
       </file>
   </example>
 */
   angular
    .module('snk.components.toast')
    .directive('skToast', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/toast/toast.tpl.html',
                controller: 'skToastController',
                controllerAs: 'ctrl',
                bindToController: true,
                scope: {
                    skTitle: '@skTitle',
                    skText: '@skText',
                    skActionLabel: '@skActionLabel',
                    skShowModal: '=skShowModal',
                    skAction: '&skAction'
                },
                compile: function ($element, attr) {
                    var zIndex = attr.zIndex;
                    if (!zIndex) {
                        zIndex = '1000';
                    }
                    $element.css('z-index', zIndex);
                }
            }
        }
    ]);
 
/**
 * @ngdoc directive
 * @name snk.components.tooltip.directive:tooltip
 * @restrict A

 * @description
 *   	Esse diretiva é responsável por apresentar tooltip com informações. 
 *
 * @param {string} [tooltip=undefined] Nesse parametro deve ser informado o texto que será utilizada.
 * @param {string} [tooltip-placement="top"] Posição que será apresentado o tooltip como por exemplo left,right,top e bottom.
 *
 * @example
     <example module="app">
         <file name="TooltipExample.html">
            <div ng-controller="MyController as ctrl">
             	<sk-hbox  layout-align="space-around center">
            	 <button default toolTip="Texto exemplo">top</button>
            	 <button default toolTip="Texto exemplo" tooltip-placement="right">right</button>
            	 <button default toolTip="Texto exemplo" tooltip-placement="bottom">bottom</button>
            	 <button default toolTip="Texto exemplo" tooltip-placement="left">left</button>
              </sk-hbox> 
            </div>
         </file>
         <file name="app.js">
                angular
                    .module('app', ['snk'])
                    .controller('MyController', function($scope){
                        var self = this;
                });
         </file>
     </example>
 */
angular
    .module('snk.components.tooltip')

    // This is mostly ngInclude code but with a custom scope
    .directive('tooltipTemplateTransclude', [
        '$animate', '$sce', '$compile', '$templateRequest',
        function ($animate, $sce, $compile, $templateRequest) {
            return {
                link: function (scope, elem, attrs) {
                    var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

                    var changeCounter = 0,
                        currentScope,
                        previousElement,
                        currentElement;

                    var cleanupLastIncludeContent = function () {
                        if (previousElement) {
                            previousElement.remove();
                            previousElement = null;
                        }
                        if (currentScope) {
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentElement) {
                            $animate.leave(currentElement).then(function () {
                                previousElement = null;
                            });
                            previousElement = currentElement;
                            currentElement = null;
                        }
                    };

                    scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function (src) {
                        var thisChangeId = ++changeCounter;

                        if (src) {
                            //set the 2nd param to true to ignore the template request error so that the inner
                            //contents and scope can be cleaned up.
                            $templateRequest(src, true).then(function (response) {
                                if (thisChangeId !== changeCounter) { return; }
                                var newScope = origScope.$new();
                                var template = response;

                                var clone = $compile(template)(newScope, function (clone) {
                                    cleanupLastIncludeContent();
                                    $animate.enter(clone, elem);
                                });

                                currentScope = newScope;
                                currentElement = clone;

                                currentScope.$emit('$includeContentLoaded', src);
                            }, function () {
                                if (thisChangeId === changeCounter) {
                                    cleanupLastIncludeContent();
                                    scope.$emit('$includeContentError', src);
                                }
                            });
                            scope.$emit('$includeContentRequested', src);
                        } else {
                            cleanupLastIncludeContent();
                        }
                    });

                    scope.$on('$destroy', cleanupLastIncludeContent);
                }
            };
        }])

    /**
     * Note that it's intentional that these classes are *not* applied through $animate.
     * They must not be animated as they're expected to be present on the tooltip on
     * initialization.
     */
    .directive('tooltipClasses', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (scope.placement) {
                    element.addClass(scope.placement);
                }
                if (scope.popupClass) {
                    element.addClass(scope.popupClass);
                }
                if (scope.animation()) {
                    element.addClass(attrs.tooltipAnimationClass);
                }
            }
        };
    })

    .directive('tooltipPopup', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-popup.html'
        };
    })

    .directive('tooltip', ['$tooltip', function ($tooltip) {
        return $tooltip('tooltip', 'tooltip', 'mouseenter');
    }])

    .directive('tooltipTemplatePopup', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
                originScope: '&'
            },
            templateUrl: 'template/tooltip/tooltip-template-popup.html'
        };
    })

    .directive('tooltipTemplate', ['$tooltip', function ($tooltip) {
        return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    .directive('tooltipHtmlPopup', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-html-popup.html'
        };
    })

    .directive('tooltipLightHtmlPopup', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-light-html-popup.html'
        };
    })

    .directive('tooltipHtml', ['$tooltip', function ($tooltip) {
        return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    .directive('tooltipLightHtml', ['$tooltip', function ($tooltip) {
        return $tooltip('tooltipLightHtml', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    /*
    Deprecated
    */
    .directive('tooltipHtmlUnsafePopup', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
        };
    })

angular
    .module('snk.components.tooltip')
    .provider('$tooltip', function () {

        var self = this;

        self.loadedTips = new Object();
        self.invalidateCache = invalidateCache;
        self.invalidateAllCache = invalidateAllCache;

        var defaultOptions = {
            placement: 'top',
            animation: true,
            popupDelay: 300,
            useContentExp: false,
            appendToBody: true
        };

        // Default hide triggers for each show trigger
        var triggerMap = {
            'mouseenter': 'mouseleave',
            'click': 'click',
            'focus': 'blur'
        };

        // The options specified to the provider globally.
        var globalOptions = {};

        /**
         * This is a helper function for translating camel-case to snake-case.
         */
        function snake_case(name) {
            var regexp = /[A-Z]/g;
            var separator = '-';
            return name.replace(regexp, function (letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }

        /*
         * Para a utilização dos métodos invalidateCache e invalidateAllCache, segue exemplo:
         * 
         * angular
         *   .module('ExemploApp', ['snk'])
         *   .config(['$tooltipProvider', function ($tooltipProvider) {
         *       window.stateProvider = $tooltipProvider;
         *   }])
         *   .controller('ExemploController', [ function () {
         *      window.stateProvider.invalidateCache("key");
         *      window.stateProvider.invalidateAll(Cache);
         *   }]);
         */

        function invalidateCache(key){
            delete self.loadedTips[key];
        }

        function invalidateAllCache(key){
            self.loadedTips = new Object();
        }

        self.$get = ['StringUtils', 'ServiceProxy', '$window', '$compile', '$timeout', '$document', '$interpolate', 'UserAgentUtils', 'PositionUtils', 'AngularUtil', function (StringUtils, ServiceProxy, $window, $compile, $timeout, $document, $interpolate, UserAgentUtils, PositionUtils, AngularUtil) {
            return function $tooltip(type, prefix, defaultTriggerShow, options,) {
                options = angular.extend({}, defaultOptions, globalOptions, options);

                /**
                 * Returns an object of show and hide triggers.
                 *
                 * If a trigger is supplied,
                 * it is used to show the tooltip; otherwise, it will use the `trigger`
                 * option passed to the `$tooltipProvider.options` method; else it will
                 * default to the trigger supplied to this directive factory.
                 *
                 * The hide trigger is based on the show trigger. If the `trigger` option
                 * was passed to the `$tooltipProvider.options` method, it will use the
                 * mapped trigger from `triggerMap` or the passed trigger if the map is
                 * undefined; otherwise, it uses the `triggerMap` value of the show
                 * trigger; else it will just use the show trigger.
                 */
                function getTriggers(trigger) {
                    var show = trigger || options.trigger || defaultTriggerShow;
                    var hide = triggerMap[show] || show;
                    return {
                        show: show,
                        hide: hide
                    };
                }

                function text(attrs, type){
                    var text = attrs[type];
                    if(text){
                        var result = new RegExp("^ServerSideToolTip\\((.+)\\)$").exec(text);
                        if(result){
                            text = getToolTip(result[1], attrs, type);
                        }
                    }
                    return text;
                }

                function replaceSizetoStyleSize(textHtml){
                    var regex = /\b(size)\s*=\s*"(.*?)"/g;
 
                    var parseSize = regex.exec(textHtml);

                    while(parseSize != null){
                        var sizeInPx = parseSize[2] + "px";

                        var newExpression = ' sytle="{font-size: ' + sizeInPx + '}"';
                        
                        textHtml = textHtml.replace(parseSize[0], newExpression);

                        parseSize = regex.exec(textHtml);
                    }

                    return textHtml;
                }

                function getToolTip(key, attrs, type){
                    if(self.loadedTips[key]){
                        return self.loadedTips[key];
                    }
                    
                    var source = {
                                source:{
                                    $: key
                                }
                            };
                    
                    ServiceProxy.callService("mge@SystemUtilsSP.loadDynamicToolTip", source)
                        .then(function(result){
                            var text = result.responseBody.toolTip.$ || '';
                            
                            var parseText = replaceSizetoStyleSize(text);
                            
                            parseText = '"' + StringUtils.barScape(parseText) + '"';
                            
                            self.loadedTips[key] = attrs[type] = parseText;

                        });
                    
                    return '"Aguarde, carregando informações..."'
                }

                var directiveName = snake_case(type);

                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template =
                    '<div ' + directiveName + '-popup ' +
                    'title="' + startSym + 'title' + endSym + '" ' +
                    (options.useContentExp ?
                        'content-exp="contentExp()" ' :
                        'content="' + startSym + 'content' + endSym + '" ') +
                    'placement="' + startSym + 'placement' + endSym + '" ' +
                    'popup-class="' + startSym + 'popupClass' + endSym + '" ' +
                    'animation="animation" ' +
                    'is-open="isOpen"' +
                    'origin-scope="origScope" ' +
                    '>' +
                    '</div>';

                return {
                    restrict: 'EA',
                    compile: function (tElem, tAttrs) {
                        if (UserAgentUtils.isMobile()) {
                            return angular.noop();
                        }

                        var tooltipLinker = $compile(template);

                        return function link(scope, element, attrs, tooltipCtrl) {
                            var tooltip;
                            var tooltipLinkedScope;
                            var transitionTimeout;
                            var popupTimeout;
                            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
                            var triggers = getTriggers(undefined);
                            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
                            var ttScope = scope.$new(true);

                            if(type === 'tooltipHtml' || type === 'tooltipLightHtml'){
                                attrs[type] = text(attrs, type);
                            }

                            var positionTooltip = function () {
                                if (!tooltip) {
                                    return;
                                }

                                var ttPosition = PositionUtils.positionElements(element, tooltip, ttScope.placement, appendToBody);
                                ttPosition.top += 'px';
                                ttPosition.left += 'px';

                                // Now set the calculated positioning.
                                tooltip.css(ttPosition);
                            };

                            // Set up the correct scope to allow transclusion later
                            ttScope.origScope = scope;

                            // By default, the tooltip is not open.
                            // TODO add ability to start tooltip opened
                            ttScope.isOpen = false;

                            ttScope.type = type;

                            function toggleTooltipBind() {
                                if (!ttScope.isOpen) {
                                    showTooltipBind();
                                } else {
                                    hideTooltipBind();
                                }
                            }

                            // Show the tooltip with delay if specified, otherwise show it immediately
                            function showTooltipBind() {
                                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                                    return;
                                }

                                if(type === 'tooltipHtml' || type === 'tooltipLightHtml'){
                                    attrs[type] = text(attrs, type);
                                }

                                prepareTooltip();

                                if (ttScope.popupDelay) {
                                    // Do nothing if the tooltip was already scheduled to pop-up.
                                    // This happens if show is triggered multiple times before any hide is triggered.
                                    if (!popupTimeout) {
                                        popupTimeout = $timeout(show, ttScope.popupDelay, false);
                                        popupTimeout.then(function (reposition) {
                                            reposition();
                                        });
                                    }
                                } else {
                                    show()();
                                }
                            }

                            function hideTooltipBind() {
                                /*
                                    Caso o tooltip esteja desabilitado nao precisamos e fechado
                                    nao precisamos disparar um apply novamente.
                                */
                                if(!ttScope.isOpen && hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])){
                                    return;
                                }
                                AngularUtil.apply(scope, hide);
                                /*scope.$apply(function () {
                                    hide();
                                });*/
                            }

                            // Show the tooltip popup element.
                            function show() {

                                popupTimeout = null;

                                // If there is a pending remove transition, we must cancel it, lest the
                                // tooltip be mysteriously removed.
                                if (transitionTimeout) {
                                    $timeout.cancel(transitionTimeout);
                                    transitionTimeout = null;
                                }

                                // Don't show empty tooltips.
                                if (!(options.useContentExp ? ttScope.contentExp() : ttScope.content)) {
                                    return angular.noop;
                                }

                                createTooltip();

                                if(ttScope.type && ttScope.type === 'tooltipLightHtml'){
                                    setColorLight(tooltip, ttScope.placement);
                                }

                                // Set the initial positioning.
                                tooltip.css({ top: 0, left: 0, display: 'block' });
                                ttScope.$digest();

                                positionTooltip();

                                // And show the tooltip.
                                if (ttScope != null) {
                                    ttScope.isOpen = true;
                                    ttScope.$apply(); // digest required as $apply is not called

                                    // Return positioning function as promise callback for correct
                                    // positioning after draw.
                                    return positionTooltip;
                                } else {
                                    return angular.noop;
                                }
                            }

                            // Hide the tooltip popup element.
                            function hide(scope, force) {
                                // First things first: we don't show it anymore.
                                ttScope.isOpen = false;

                                //if tooltip is going to be shown after delay, we must cancel this
                                $timeout.cancel(popupTimeout);
                                popupTimeout = null;

                                // And now we remove it from the DOM. However, if we have animation, we
                                // need to wait for it to expire beforehand.
                                // FIXME: this is a placeholder for a port of the transitions library.
                                if (ttScope.animation && !force) {
                                    if (!transitionTimeout) {
                                        transitionTimeout = $timeout(removeTooltip, 500);
                                    }
                                } else {
                                    removeTooltip();
                                }
                            }

                            function createTooltip() {
                                // There can only be one tooltip element per directive shown at once.
                                if (tooltip) {
                                    removeTooltip();
                                }
                                tooltipLinkedScope = ttScope.$new();
                                tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                                    if (appendToBody) {
                                        $document.find('body').append(tooltip);
                                    } else {
                                        element.after(tooltip);
                                    }
                                });

                                tooltipLinkedScope.$watch(function () {
                                    $timeout(positionTooltip, 0, false);
                                });

                                if (options.useContentExp) {
                                    tooltipLinkedScope.$watch('contentExp()', function (val) {
                                        if (!val && ttScope.isOpen) {
                                            hide();
                                        }
                                    });
                                }
                            }

                            function removeTooltip() {
                                transitionTimeout = null;
                                if (tooltip) {
                                    tooltip.remove();
                                    tooltip = null;
                                }
                                if (tooltipLinkedScope) {
                                    tooltipLinkedScope.$destroy();
                                    tooltipLinkedScope = null;
                                }
                            }

                            function prepareTooltip() {
                                prepPopupClass();
                                prepPlacement();
                                prepPopupDelay();
                            }

                            function setColorLight(tooltip, placement){
                                var firstElement = angular.element(tooltip.children()[0]);
                               
                                if(placement === 'top'){
                                    firstElement.css({'border-top-color': '#f3f3f3'});
                                } else if(placement === 'bottom'){
                                    firstElement.css({'border-bottom-color': '#f3f3f3'});
                                } else if(placement === 'right'){
                                    firstElement.css({'border-right-color': '#f3f3f3'});
                                } else if(placement === 'left'){
                                    firstElement.css({'border-left-color': '#f3f3f3'});
                                }
                            }

                            ttScope.contentExp = function () {
                                if(type === 'tooltipHtml' || type === 'tooltipLightHtml'){
                                    
                                    if(StringUtils.hasAccentuationOrWhiteSpace(attrs[type])){
                                        return attrs[type];
                                    }
                                    
                                    var evalResult = scope.$eval(attrs[type]);
                                    return evalResult != undefined ? evalResult : attrs[type];
                                }

                                return scope.$eval(attrs[type]);
                            };

                            /**
                             * Observe the relevant attributes.
                             */
                            if (!options.useContentExp) {
                                attrs.$observe(type, function (val) {
                                    ttScope.content = val;

                                    if (!val && ttScope.isOpen) {
                                        hide();
                                    }
                                });
                            }

                            attrs.$observe('disabled', function (val) {
                                if (val) {
                                    if (ttScope != null && ttScope.isOpen) {
                                        hide();
                                    } else if (popupTimeout) {
                                        $timeout.cancel(popupTimeout);
                                        popupTimeout = null;
                                    }
                                }

                            });

                            attrs.$observe(prefix + 'Title', function (val) {
                                ttScope.title = val;
                            });

                            function prepPopupClass() {
                                ttScope.popupClass = attrs[prefix + 'Class'];
                            }

                            function prepPlacement() {
                                var val = attrs[prefix + 'Placement'];
                                ttScope.placement = angular.isDefined(val) ? val : options.placement;
                            }

                            function prepPopupDelay() {
                                var val = attrs[prefix + 'PopupDelay'];
                                var delay = parseInt(val, 10);
                                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                            }

                            var unregisterTriggers = function () {
                                element.unbind(triggers.show, showTooltipBind);
                                element.unbind(triggers.hide, hideTooltipBind);

                                if (attrs.closeOnClick) {
                                  element.unbind('click', closeOnClick);
                                }
                            };


                            function closeOnClick() {
                                hide(undefined, true);
                            }

                            function prepTriggers() {
                                var val = attrs[prefix + 'Trigger'];
                                unregisterTriggers();

                                triggers = getTriggers(val);

                                if (triggers.show === triggers.hide) {
                                    element.bind(triggers.show, toggleTooltipBind);
                                } else {
                                    element.bind(triggers.show, showTooltipBind);
                                    element.bind(triggers.hide, hideTooltipBind);
                                }

                                if (attrs.closeOnClick) {
                                    element.bind('click', closeOnClick);
                                }
                            }

                            prepTriggers();

                            var animation = scope.$eval(attrs[prefix + 'Animation']);
                            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

                            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
                            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

                            // if a tooltip is attached to <body> we need to remove it on
                            // location change as its parent scope will probably not be destroyed
                            // by the change.
                            if (appendToBody) {
                                scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
                                    if (ttScope.isOpen) {
                                        hide();
                                    }
                                });
                            }

                            // Make sure tooltip is destroyed and removed.
                            scope.$on('$destroy', function onDestroyTooltip() {
                                $timeout.cancel(transitionTimeout);
                                $timeout.cancel(popupTimeout);
                                unregisterTriggers();
                                removeTooltip();
                                ttScope = null;
                            });
                        };
                    }
                };
            };
        }];
    });

angular
    .module('snk.components.tooltipbuilder')
    .provider('TooltipBuilder', function () {

        this.$get = ['$document', '$timeout', 'PositionUtils', 'AngularUtil', 'DomUtil', 'i18n', '$window', 'UserAgentUtils', function ($document, $timeout, PositionUtils, AngularUtil, DomUtil, i18n, $window, UserAgentUtils) {
            return function (element, options) {
                var _defParams = {
                    duration: 3000,
                    placement: 'top'
                };

                return new TooltipBuilder(element, angular.extend(_defParams, options), $document, $timeout, PositionUtils, AngularUtil, DomUtil, i18n, $window, UserAgentUtils);
            }
        }];

        function TooltipBuilder(element, options, $document, $timeout, PositionUtils, AngularUtil, DomUtil, i18n, $window, UserAgentUtils) {
            var _builder = this;

            var _targetElement = element;
            var _opener = undefined;
            
            var _options = options;

            var _tooltipElem;
            var _body = $document.find('body');

            var _removeTimeout;

            var _opended = false;

            var _builderPopupOptions = ['message', 'duration', 'customClass', 'placement'];

            angular.element($window).on('resize', onResize);

            createDynamicStyleScroll();

            _builder.option = function (key, value) {
                if (key === 'customClass' && _tooltipElem && _options.customClass){
                    _tooltipElem.removeClass(_options.customClass);
                }

                _options[key] = value;

                return _builder;
            };

            _builder.options = function (opts) {
                _options = opts;

                return _builder;
            };

            _builder.targetElement = function(targetElement) {
                _targetElement = targetElement;
                return _builder;
            };

            _builder.i18n = function(i18nKey, i18nValues) {
                _options.i18nKey = i18nKey;
                _options.i18nValues = i18nValues;
                return _builder;
            };

            _builderPopupOptions.forEach(function(optionName) {
                _builder[optionName] = function(value) {
                    return _builder.option(optionName, value);
                }
            });
            
            _builder.opener = function(opener) {
            	_opener = opener;
            	return _builder;
            };

            _builder.isOpen = function(){
                return _opended;
            };

            _builder.show = function() {
                
            	if (_tooltipElem) {
                    show();
                } else {
                    initAndShow();
                }

                return _builder;
            };

            _builder.hide = function() {
                remove();
                return _builder;
            };

            _builder.setScrollable = function(value) {
                _options.scrollable = value;
                return _builder;
            }

            function initAndShow(tooltipElemTemplate) {
                AngularUtil.requestTemplate('components/tooltipbuilder/tooltipbuilder.tpl.html')
                    .then(function(tooltipElemTemplate) {
                        _tooltipElem  = angular.element(tooltipElemTemplate);
                        show();
                    });
            }

            function show() {
            	$timeout.cancel(_removeTimeout);

                if (options.duration > 0) {
                    _removeTimeout = $timeout(function() {
                        remove();
                    }, options.duration);
                }
            	
            	if (_opended) {
            		return;
            	}
            	
                if (options.customClass) {
                    _tooltipElem.addClass(options.customClass);
                }

                _tooltipElem.css('visibility', 'hidden');

                var messageContainer = angular.element(_tooltipElem[0].querySelector('.message-container'));
                var message = _options.i18nKey ? i18n(_options.i18nKey, _options.i18nValues) : _options.message;
                messageContainer.html(message);

                _body.append(_tooltipElem);

                reposition();

                _tooltipElem.css('visibility', 'visible');

                _opended = true;

                $timeout(function(){
                    $document.bind('scroll', onBodyScroll);
                    $document.bind('click', onBodyClick);
                }, 0, false);
            }

            function reposition() {
                recalcSize();

                var targetElemPos = PositionUtils.offset(_targetElement);

                var tooltipPos = PositionUtils.positionElements(_targetElement, _tooltipElem, _options.placement, true);
                
                if(_options.placement == 'bottom' && _options.scrollable === true){
                    tooltipPos.top =  PositionUtils.offset(_targetElement).top + 10;
                }else{  
                    tooltipPos.top -= ((targetElemPos.height) / 2);
                }
                
                var triangleElem = angular.element(_tooltipElem[0].querySelector('.triangle'));                

                if(_options.placement == 'bottom'){
                    tooltipPos.top += 18;                    
                    triangleElem.css('bottom', (_tooltipElem[0].offsetHeight - 2) );
                    triangleElem.css('transform', 'rotate(180deg)');

                }else{
                    triangleElem.css('bottom', '-11px');                    
                }
                
                if(tooltipPos.left && tooltipPos.left < 0){
                    tooltipPos.left = 12;
                } else if(tooltipPos.left && (document.body.clientWidth - tooltipPos.left) < (0.2 * document.body.clientWidth)){
                    tooltipPos.left = tooltipPos.left -   (0.1 * document.body.clientWidth);
                }

                _tooltipElem.css(tooltipPos);

                var triangleLeft = targetElemPos.left - PositionUtils.offset(_tooltipElem).left;

                if (triangleLeft < 0) {
                    triangleLeft = 0;
                }

                triangleElem.css('left', triangleLeft - 4);
            }

            function onBodyClick(e) {
                if (!DomUtil.closest(e.target, '.sk-tooltip') && (angular.isUndefined(_opener) || _opener != e.target)){
                    remove();
                }
            }

            function onBodyScroll() {
                remove();
            }

            function remove() {
                if (_tooltipElem) {
                    _tooltipElem.remove();
                }

                _opended = false;

                $document.unbind('scroll', onBodyScroll);
                $document.unbind('click', onBodyClick);
            }

            function recalcSize(){
                if(_options.scrollable && _options.placement != 'bottom'){
                    throw new Error('[TooltipBuilder] Tooltip scrollable só pode ser usado com placement = "bottom"');
                }else if(_options.scrollable == true){
                     
                    let messageContent = _tooltipElem.find('.message-container');

                    if(messageContent){
                        messageContent.css('overflow-x', 'auto');
                        let targetElemPos = _targetElement[0].getBoundingClientRect();
                        messageContent.css('max-height', (window.innerHeight - targetElemPos.top) - 40);
                    }
                }
            }

            function onResize(){
                reposition();
            }

            function createDynamicStyleScroll(){                
                let css = (".custom-scroll::-webkit-scrollbar{" +
                    /* width */                    
                    "width: 5px;" +
                    "}" +
                
                    /* Track */
                    ".custom-scroll::-webkit-scrollbar-track {" +
                    "background: #f1f1f1;" +
                    "box-shadow: inset 0 0 5px grey;" +
                    "border-radius: 20px;" +
                    "}" +
                    
                    /* Handle */
                    ".custom-scroll::-webkit-scrollbar-thumb {" +
                    "background: #888;" +
                    "border-radius: 20px;" +
                    "height: 15px;" +
                    "}" +
                
                    /* Handle on hover */
                    ".custom-scroll::-webkit-scrollbar-thumb:hover {" +
                    "background: #555;" +
                    "}"
                );

                let head = document.head || document.getElementsByTagName('head')[0];
                
                if(head.querySelector('#personized-scroll-help-tip')){
                    return;
                }
                
                let style = document.createElement('style');
                
                style.setAttribute('id', 'personized-scroll-help-tip');

                head.appendChild(style);
                
                style.type = 'text/css';
                
                if (style.styleSheet){
                    // This is required for IE8 and below.                
                    style.styleSheet.cssText = css;
                } else {
                
                    style.appendChild(document.createTextNode(css));
                
                }
            }
        }
    });

/**
 * Created by cleverson.puche on 12/04/2016.
 */

angular
    .module('snk.components.tree')
    .controller('SkTreeController',['$element', 'ObjectUtils', '$scope', 'StringUtils', '$attrs','$timeout', 'DomUtil', 'SkConstants', 'PositionUtils', '$q', 'i18n', 'AngularUtil', 'PopUpParameter', 'ArrayUtils', 'MessageUtils', 'DatasetEvents', 'ServiceProxy',
        function($element, ObjectUtils, $scope, StringUtils, $attrs, $timeout, DomUtil, SkConstants, PositionUtils, $q, i18n, AngularUtil, PopUpParameter, ArrayUtils, MessageUtils, DatasetEvents, ServiceProxy ) {
            var self = this;

            /**
             * Início Lazy Load
             */
            var PARENT_FIELD_SUFIX = 'PAI';
            var ROOT_KEY_VALUE = -9999;

            ObjectUtils.implements(self, IDataSetObserver);

            var _ignoreLineChange = false;
            var _clickTimerID;
            var _nodesClicked = [];
            var _publicApi;
            var _innerProvider;
            var _treeSelect;
            /**
             * Fim Lazy Load
             */

            var _filteredRows = [];
            var _filteredRowsObjs = []
            var _lastSearchTermValue;
            var _initialized = false;
            var _dataLoaded = false;
            var _userClicked = false;
            var _programaticallyExpanding = false;
            var _branchByLabel = {};
            var _searchTermDebaunced = $scope.advSearch ?  AngularUtil.debounce(advancedSearchTermChange, 1500, $scope, true) : AngularUtil.debounce(searchTermChange, 150, $scope, true);
            var _parentPropertyName;
            var _localPropertyName;
            var _iconKeyName;
            var _pathPropertyName;
            var _itemSelectionChangeListeners = [];
            var _debounce;
            var _debounceScrollToSelectedBranch = AngularUtil.debounce(scrollToSelectedBranch, 200, $scope, true);

            /**
             * Configuração da máscara que será aplicada na hierarquia do sk-tree
             - mask: string - Máscara que será aplicada (Exemplo: "##.###.####")
             - fromLeft: boolean - Flag que indica se o texto será da esquerda para direita se estiver 'true' | padrão
             - defaultChar: string - Caractere para preencher a máscara caso o valor não preencha toda a máscara (Exemplo: "0")
             */
            var _hierarchyConfig = {
                mask: '',
                fromLeft: true,
                defaultChar: ''
            };

            $scope.rowsById = {};
            $scope.searchInputEnabled = angular.isDefined($scope.searchInputEnabled) ? $scope.searchInputEnabled : true;
            $scope.labelWithIdentifier = angular.isDefined($scope.labelWithIdentifier) ? $scope.labelWithIdentifier : true;
            $scope.childrenCustomName = $scope.childrenCustomName || 'children';
            $scope.labelCustomName = $scope.labelCustomName || 'label';
            $scope.sortField = $scope.sortField || 'data';

            $scope.$watch('searchTerm', _searchTermDebaunced);
            $scope.$watch('treeData', processDataChange, true);
            // $scope.$watch('treeData', refresh_interceptor, true);

            $scope.fontIcon = 'file';
            $scope.multiSelected = [];
            $scope.showTooltip = $scope.showTooltip == undefined ? true : $scope.showTooltip;
	    	$scope.indeterminateValue = "I";
            $scope.filteredRows;

            $scope.textToColor = StringUtils.textToColor;
            $scope.buildNick = StringUtils.buildNick;
            $scope.getItemLeft = getItemLeft;
            $scope.filterFunction = filterFunction;
            $scope.getItemStyle = getItemStyle;
            $scope.onItemKeydown = onItemKeydown;
            $scope.itemDblClick = itemDblClick;
            $scope.toggleExpanded = toggleExpanded;
            $scope.toggleExpandedLazyLoad = toggleExpandedLazyLoad;
            $scope.selected_branch;
            self.setSelectedItems =  $scope.setSelectedItems = setSelectedItems;
            self.getSelectedItems = $scope.getSelectedItems = getSelectedItems;
            self.cleanSelectedItems = $scope.cleanSelectedItems = cleanSelectedItems;
            self.getIconRow = $scope.getIconRow = getIconRow;
            self.iconIsSvg = $scope.iconIsSvg = iconIsSvg;
            self.valuesSearched = [];


            $scope.enableEdit = angular.isFunction($scope.endEdit);
            $scope.searchTermLoaded = false;

            self.selectPKAfterRefresh = selectPKAfterRefresh;
            self.openSelectItem = openSelectItem;
            self.selectedItemHasChildren = selectedItemHasChildren; 
            self.addSelectionChangeListener = addSelectionChangeListener;
            self.getHierarchyPath = getHierarchyPath;
            self.goToRoot = goToRoot;
            self.openLevelByIdentifier = openLevelByIdentifier;
            self.addItemClickListener = addItemClickListener;
            self.findElement = findElement;
            self.selectAndOpen = selectAndOpen;
            self.selectAndOpenByLabel = selectAndOpenByLabel;
            self.setHierarchyConfig = setHierarchyConfig;
            self.getHierarchyConfig = getHierarchyConfig;
            self.setSelectedIndex = setSelectedIndex;
            self.treeIsEmpty = treeIsEmpty;

            $scope.treeApi = self;

            // $scope.$watch('searchInput', function(newValue, oldValue){
            //     $scope.filteredRows = $scope.tree_rows | $scope.searchInput | filterFunction();
            // })


            init();

            /**
             * Início - Lazy Load
             *  
             */

            function init(){

                _publicAPI  = ObjectUtils.buildPublicAPI(self, [
                    'selectPKAfterRefresh', 'openSelectItem', 'selectAndOpen', 'selectAndOpenByLabel',
                    'selectedItemHasChildren', 'addSelectionChangeListener',
                    'getHierarchyPath', 'goToRoot', 'getIconRow', 'iconIsSvg',
                    'openLevelByIdentifier', 'addItemClickListener', 
                    'setHierarchyConfig', 'getHierarchyConfig', 
                    'setSelectedIndex', 'treeIsEmpty']);

                if ($scope.componentCreated) {
                    $scope.componentCreated({$component: _publicAPI});
                }    

                $scope.$watch('dataset', function(){
                    if($scope.dataset){

                        // Verificar se existe o locateByPk, caso não, instancia com objeto vazio. É necessário esse objeto para abrir o registro quando utilizado pk.
                        if (angular.isUndefined($scope.locateByPk)){
                            $scope.locateByPk = {};
                        }

                        $scope.dataset.addObserver(self);

                        $scope.dataset.addDataSavedListener(function(isNew, records){
                            if(angular.isUndefined($scope.treeData) || angular.isUndefined($scope.tree_rows)) {
                                refreshTreeMap();
                            }

                            let node = arrayToTree(records, true);
                            
                                let nodeParentUID = parseInt(node[0].uid.split(":")[1]);
                                let nodeParent = $scope.tree_rows.find(row => {
                                    return parseInt(row.branch?.uid?.split(":")[0]) === nodeParentUID;
                                });

                                let row = buildRow(nodeParent, node[0], true);

                                if (angular.isDefined(nodeParent)) {
                                    if(nodeParent.branch['children'] === undefined){
                                        nodeParent.branch['children'] = [];
                                	}
                                if(isNew){
                                    
                                    nodeParent.branch['children'].push(row);
                                    nodeParent.branch['hasChildren'] = "S";

                                  
                            	} else {
                                    nodeParent.branch['children'].forEach((element,index) => {
                                        if(element==$scope.selected_branch){
                                            
                                            row.hasChildren = element.hasChildren;
                                            row.expanded = element.expanded;

                                            if (element.children.length > 0) {
                                                if(row.children === undefined){
                                                    row.children = [];
                                                }
                                                element.children.forEach((reg,index) => {
                                                    row.children.push(reg);
                                                });
                                            }
                                            nodeParent.branch['children'][index]=row;
                                        }
                                    });                                                                     
                                    
                                }                                              
                                $scope.rowsById[row.branch.uid] = row;
                                $timeout(function () {
                                            setSelectedItems(row.branch);
                                }, 150, false);  
                            }else{
                                    $scope.rowsById[row.branch.uid] = row;

                                    $scope.dataset.refresh().then(function() {
                                        // Utilizado para selecionar a branch criada
                                        $timeout(function () {
                                            setSelectedItems(row.branch);
                                        }, 150, false);
                                    });                                
                            }
                        });

                        $scope.dataset.addRecordRemovedListener(function(record){
                            let encodedId = $scope.selected_branch.encodedId;
                            let branchUid = $scope.selected_branch.uid;
                            let parent = get_parent($scope.selected_branch);

                            if (encodedId || branchUid) {
                                $scope.removeChildren();
                            }
                            
                            if(!parent){
                                let previousRecord = $scope.dataset.getRecord(0);
                                let branch = arrayToTree([previousRecord], true);
                                
                                $timeout(function () {
                                    setSelectedItems(branch[0]);
                                }, 150, false);
                            } else {
                                var row = $scope.rowsById[parent.uid];
                                $timeout(function () {
                                    setSelectedItems(row.branch);
                                }, 150, false);
                            }
                        });

                        $scope.dataset.addRefreshedListener(function (reason) {
                            if (reason == DatasetEvents.REFRESH_REASON_RESET) {
                                refreshTreeMap();
                                $scope.forceExpanded = false;
                                $scope.collapse_all();

                                if ($scope.tree_rows.length > 0){
                                    $timeout(function () {
                                        
                                        // Seleciona a branch de acordo com a pk informada.
                                        if (ObjectUtils.getProperty($scope.locateByPk, 'locateByPk')) {
                                            let indexPk = ObjectUtils.getProperty($scope.locateByPk, 'index');
                                            let record = $scope.dataset.getRecord(indexPk);
                                            let branch = arrayToTree([record], true);


                                            // Reseta a variavel locateByPk
                                            $scope.locateByPk = {};

                                            setSelectedItems(branch);
                                            return;
                                        }
                                        if (angular.isDefined(_treeSelect)) {
                                            setSelectedItems(_treeSelect);
                                        } else {
                                            setSelectedItems($scope.tree_rows[0].branch);
                                        }
                                    });
                                }
                            }
                        });

						$scope.dataset.addLineChangeListener(function (newIndex, reason, properties) {

                            // Quando há pk informada é necessário recuperar as informações para selecionar a branch correta.
                            let locateByPk = ObjectUtils.getProperty(properties, 'locateByPk');

                            if (locateByPk) {
                                $scope.locateByPk = {
                                    locateByPk: true,
                                    index: newIndex
                                }

                                return;
                            }

                            // Não há necessidade aqui de fazer alguma alteração porque a tela ainda nao foi inicializada.
                            if (reason == DatasetEvents.REFRESH_REASON_RESET) {
                                return; 
                            }
                            
                            // filtros e ordenação não são aplicados no modo arvore. 
                            if (reason == DatasetEvents.REFRESH_REASON_SORT || reason == DatasetEvents.REFRESH_REASON_FILTER) {
                                return;
                            }

                            // Quando há uma exclusão de linha é feito o refresh da arvore com o novo getRecords() do dataset.
                            // O proprio listener tratará via $timeout a seleção da respectiva branch
                            if (reason == DatasetEvents.LINE_CHANGE_BY_RECORD_REMOVED) {
                                return;
                            }

                            if (reason == DatasetEvents.RECORD_CHANGED_REASON_INSERT) {
                                return;
                            }

                            if (newIndex > -1) { 
                                if (!_ignoreLineChange) {
                                    // Seleciona a nova branch apenas se houver registros no dataset
                                    if ($scope.dataset.getRecords().length > 0) {
                                        if (angular.isDefined(_treeSelect)) {
                                            setSelectedItems(_treeSelect);
                                            _treeSelect = undefined;
                                            return;
                                        }
                                        let record = $scope.dataset.getRecord(newIndex);
                                        let branch = arrayToTree([record], true);

                                        setSelectedItems(branch[0]);
                                    }
                                }
                            }
                        });

                        function refreshTreeMap() {
                            $scope.treeData = arrayToTree($scope.dataset.getRecords());
                            initialize();
                        }
                        
                        bindToDataset();
                    }
                });

            }
            
            function selectPKAfterRefresh(){
                return angular.noop;
            } 

            function openSelectItem (){
                return angular.noop;
            }

            function selectedItemHasChildren(){
                return ($scope.selected_branch && $scope.selected_branch.hasChildren === 'S') == true;
            }
            
            function addSelectionChangeListener(listener){
                _itemSelectionChangeListeners.push(listener);
            }
            
            function getHierarchyPath(){
                return angular.noop;
            }
            
            function goToRoot(){
                return angular.noop;
            }
            
            function openLevelByIdentifier(){
                return angular.noop;
            }
            
            function addItemClickListener(){
                return angular.noop;
            }

            function arrayToTree(dataProvider, byLevel, fromAdvSearch) {
                _innerProvider = [];

                if (!angular.isArray(dataProvider)) {
                    return [];
                }

                var roots = [];
                var _itemsById = {};
                var waitingForParent = {};

                var isLazyLoad = $scope.dataset.isInitDataSetLazyLoad();
                var isAlternativeParentProperty = $scope.dataset.isAlternativeParentKey();

                var isFlatMode = isLazyLoad || byLevel || isAlternativeParentProperty;

                for (var i = 0; i < dataProvider.length; i++) {
                    var item = dataProvider[i] || [];
                    var itemId = item[self.localProperty];
                    var parentId = item[self.parentProperty];
                    var treeItem = buildTreeItemFromRecord(item);

                    treeItem.arrayIndex = i;
                    _itemsById[itemId] = treeItem;
                    _innerProvider.push(treeItem);

                    if (isFlatMode) {
                        processFlatTreeItem(treeItem, parentId, _itemsById, roots);
                    } else {
                        processHierarchicalTreeItem(treeItem, itemId, parentId, _itemsById, waitingForParent, roots);
                    }
                }

                return fromAdvSearch ? roots[0] : sortTree(roots);
            }

            function isRootRecord(itemId, parentId) {
                return angular.isUndefined(parentId) || parentId <= ROOT_KEY_VALUE || parentId == 0;
            }

            function attachWaitingChildren(treeItem, itemId, waitingForParent) {
                var children = waitingForParent[itemId];
                if (children) {
                    treeItem.children = treeItem.children || [];
                    for (var j = 0; j < children.length; j++) {
                        treeItem.children.push(children[j]);
                    }
                    delete waitingForParent[itemId];
                }
            }

            function addChildToParent(treeItem, parentId, _itemsById, waitingForParent) {
                var parentNode = _itemsById[parentId];
                if (parentNode) {
                    parentNode.children = parentNode.children || [];
                    parentNode.children.push(treeItem);
                } else {
                    waitingForParent[parentId] = waitingForParent[parentId] || [];
                    waitingForParent[parentId].push(treeItem);
                }
            }

            function processFlatTreeItem(treeItem, parentId, _itemsById, roots) {
                var parentNode = _itemsById[parentId];
                if (!angular.isDefined(parentNode)) {
                    roots.push(treeItem);
                } else {
                    parentNode.children = parentNode.children || [];
                    parentNode.children.push(treeItem);
                }
            }

            function processHierarchicalTreeItem(treeItem, itemId, parentId, _itemsById, waitingForParent, roots) {
                if (isRootRecord(itemId, parentId) && itemId == 0) {
                    return;
                }

                attachWaitingChildren(treeItem, itemId, waitingForParent);

                if (isRootRecord(itemId, parentId)) {
                    roots.push(treeItem);
                } else {
                    addChildToParent(treeItem, parentId, _itemsById, waitingForParent);
                }
            }


            function sortTree(roots) {
                //Ordenamos todos os filhos dentro de todos os nós.
                _innerProvider.forEach(function (treeItem) {
                    if (treeItem.children) {
                        treeItem.children.sort(sortLevel);
                    }
                });

                //Ordenamos o root
                return roots.sort(sortLevel);
            }

            function sortLevel(a, b) {
                var aNodeID = a[$scope.sortField]; 
                var bNodeID = b[$scope.sortField];
                return aNodeID < bNodeID ? -1 : aNodeID > bNodeID ? 1 : 0;
            }

            function bindToDataset() {
                _initialized = false;

                $scope.dataset.whenMetadataLoaded().then(function () {
                    var foundPathHierarquia = false;

                    ArrayUtils.forEach($scope.dataset.getFieldsMetadata(), function (fieldMD) {
                        if (_hierarchyConfig.mask === '') {
                            var maskProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                                return prop.name == 'mask';
                            });

                            if (maskProp) {
                                _hierarchyConfig.mask = StringUtils.expandHierarchyMask(maskProp.value);
                                loadPropertyKey(fieldMD);
                            }
                        }

                        if (!foundPathHierarquia) {
                            var pathProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                                return prop.name == 'pathHierarquia';
                            });

                            if (pathProp) {
                                _pathPropertyName = fieldMD.name;
                                self.pathHierarchy = $scope.dataset.getFieldIndexByName(_pathPropertyName);
                                foundPathHierarquia = true;
                            }
                        }

                        return _hierarchyConfig.mask === '' || !foundPathHierarquia;
                    });

                    if (angular.isUndefined(_localPropertyName) && _hierarchyConfig.mask === '') {
                        ArrayUtils.forEach($scope.dataset.getFieldsMetadata(), function (fieldMD) {
                            loadPropertyKey(fieldMD);
                            return isNaN(self.parentProperty);
                        });
                    }

                    if (angular.isUndefined(_hierarchyConfig.mask)) {
                        throw Error(i18n('SanDB.Dynaform.messageEntidadeNaoDefinida', [$scope.dataset.getEntityName()]));
                    }

                    if (isNaN(self.parentProperty)) {
                        throw Error(i18n('SanDB.Dynaform.messageObjetoPaiNulo'));
                    }

                    self.descriptionProperty = $scope.dataset.getEntityPresentationFieldIndex();

                    _initialized = true;
                });
            }

            function loadPropertyKey(fieldMD) {
                _localPropertyName = fieldMD.name;

                var parentKeyNameProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                    return prop.name == 'parentKeyName';
                });
                
                var iconKeyNameProp = ArrayUtils.find(fieldMD.properties, function (prop) {
                    return prop.name == 'iconKeyName';
                });

                if (parentKeyNameProp && parentKeyNameProp.value) {
                    _parentPropertyName = parentKeyNameProp.value;
                } else {
                    _parentPropertyName = fieldMD.name + PARENT_FIELD_SUFIX;
                }
                
                if (iconKeyNameProp && iconKeyNameProp.value){
                    _iconKeyName = iconKeyNameProp.value;
                }

                self.localProperty = $scope.dataset.getFieldIndexByName(_localPropertyName);
                self.parentProperty = $scope.dataset.getFieldIndexByName(_parentPropertyName);
                self.iconProperty = $scope.dataset.getFieldIndexByName(_iconKeyName);
            }

            function buildTreeItemFromRecord(record) {
                var itemIdentifier = record[self.pathHierarchy || self.localProperty];
                var parentIdentifier = record[self.parentProperty];
        
                var maskedIdentifier;

                if ((angular.isUndefined(parentIdentifier) || parentIdentifier <= ROOT_KEY_VALUE || parentIdentifier == 0) && itemIdentifier == 0) {
                    maskedIdentifier = StringUtils.replicate('0', _hierarchyConfig.mask?.indexOf('.'));
                } else {
                    const { mask, fromLeft, defaultChar } = _hierarchyConfig;
                    maskedIdentifier = StringUtils.applyHierarchyMask(mask, itemIdentifier, false, fromLeft, defaultChar);
                }
        
                var treeItem = {
                    uid: buildItemIdentifier(record),
                    maskedIdentifier: maskedIdentifier
                };
        
                treeItem["data"] = Number(itemIdentifier);
                treeItem["label"] = record[self.descriptionProperty];
                treeItem["icon"] = record[self.iconProperty];

                var indexHasChildren = $scope.dataset.getFieldIndexByName('HASCHILDREN');
                treeItem['hasChildren'] = record[indexHasChildren];

                if(self.pathHierarchy){
                    treeItem[self.pathHierarchy] = record[self.pathHierarchy];
                }
                
                var rowId = record[record.length - 1];

                if (rowId) {
                    treeItem['rowUniqueId'] = rowId.rowID;
                }
                
                return treeItem;
            }

            function buildItemIdentifier(item) {
                return item[self.localProperty] + ':' + item[self.parentProperty];
            }

            function userItemClick(item) {
                if (_clickTimerID) {
                  AngularUtil.cancelTimeout(_clickTimerID);
                }
        
                _clickTimerID = AngularUtil.timeout(function () {
                  itemClick(item, false, -1, true);
                }, 150);
            }

            function itemClick(item, recalculateScroll, scrollPos, userClick) {
                if (!_initialized || !item){ 
                	return $q(function (resolve) {
                    resolve();
                  });
                }

                if(self.filtering){
                    let obj = Object;
                    let pkName = $scope.dataset.getPrimaryKeys()[0];
                    obj[pkName] = !isNaN(item.data) ? item.data : item.uid.split(':')[0];

                    return $q(function (resolve, reject) {                       
                          _ignoreLineChange = true;
                          $scope.dataset.locateByPk(obj).then(function (item) {
      
                             if(_itemSelectionChangeListeners.length > 0){
                                 ArrayUtils.callEachFunctionWith(_itemSelectionChangeListeners, item);
                             }  

                             let filteredBranch = arrayToTree([$scope.dataset.getRecord(item)],true)[0];
                             for ( rows of $scope.filteredRows) {
                                if(rows.maskedIdentifier == filteredBranch.maskedIdentifier){
                                    rows.branch.selected=true;
                                    rows.branch.expanded=true;
                                    $scope.selected_branch = rows.branch;
                                    break;
                                }
                             }                            
                            
                             _ignoreLineChange = false;
                            resolve();
                          }, reject);
                       
                      });                                      
                } else {
                    if (angular.isDefined(item.rowUniqueId)) {
                        return gotoRowOnDataset(item.rowUniqueId);
                    }
                    return gotoRowOnDataset(item.rowUniqueId || item.arrayIndex);
                }
            }

            function gotoRowOnDataset(rowUniqueId) {
                var index = $scope.dataset.getIndexByUniqueId(rowUniqueId);

                return $q(function (resolve, reject) {
                  if (!_ignoreLineChange) {
                    _ignoreLineChange = true;
                    $scope.dataset.gotoRow(index).then(function (item) {

                       if(_itemSelectionChangeListeners.length > 0){
                           ArrayUtils.callEachFunctionWith(_itemSelectionChangeListeners, item);
                       }  
                      
                       _ignoreLineChange = false;
                      resolve();
                    }, reject);
                  } else {
                    resolve();
                  }
                });
            }

            function buildRow(nodeParent, node, isNew){
                var tree_icon;
                                
                if (node.expanded == null) {
                    _programaticallyExpanding = true;
                    node.expanded = false;
                }
                if (!node[$scope.childrenCustomName] || node[$scope.childrenCustomName].length === 0) {
                    tree_icon = $attrs.iconLeaf;
                } else {
                    if (branch.expanded) {
                        tree_icon = $attrs.iconCollapse;
                    } else {
                        tree_icon = $attrs.iconExpand;
                    }
                }

                let level = (isNew && nodeParent != undefined) ? (nodeParent.level || 0) + 1 : 0;

                var row = {
                    level: level,
                    branch: node,
                    label: i18n(node.label),
                    tree_icon: tree_icon,
                    visible: true,
                    description: node.description,
                    data: node.data,
                    icon: node.icon,
                    iconV: node.iconV,
                    encodedId: btoa(node.uid).replace(/=/g ,''),
                    uid: node.uid
                };

                if($scope.lazyLoad){
                    row['maskedIdentifier'] = node.maskedIdentifier;
                    row['descriptionCustom'] = getDescriptionCustom(row);
                    row['rowUniqueId'] = node['rowUniqueId'];
                    row['hasChildren'] = node['hasChildren'];
                }

                row.toolTipPlacement = $scope.tooltipPlacement ? $scope.tooltipPlacement : 'bottom';

                return row;
            }

            /**
             * Fim - Lazy Load
             *  
             */
            
            function getIconRow(row) {
            	return row && row.icon && angular.isFunction(row.icon) ? row.icon(row) : row.icon;
            }

            function iconIsSvg(icon) {
            	return icon && icon.indexOf('.svg') > -1;
            }
            
            function toggleExpanded(row) {
                _programaticallyExpanding = true;
                row.branch.expanded = !row.branch.expanded;
                $scope.forceExpanded = {label: row.branch.label, expanded: row.branch.expanded, uid: row.branch.uid};
            }

            function toggleExpandedLazyLoad(row){

                var branch = row.branch;

                if($scope.lazyLoad){
                    if(self.filtering == true){
                        $scope.toggleExpanded(row);
                        userItemClick(branch);
                    } else {
                        if(_nodesClicked.indexOf(branch.uid) == -1 && $scope.dataset.isInitDataSetLazyLoad()){
                            let key;
                            let parallelLoaderValue = $scope.dataset.getParallelLoader();
    
                            try{
                                key = branch.uid.split(":")[0];
                            }catch(error){
                                console.error(error);
                                key = branch.data;
                            }
    
                            $scope.dataset.setParallelLoader(false);
    
                            $scope.dataset.loadRecordsByLevel(key).then(function(response){
                                var result = response.responseBody.result;
                                
                                var nodes = arrayToTree(result, true);
    
                                var nodeParent = $scope.rowsById[branch.uid];
    
                                var childrens = [];
                                
                                if(nodes.length > 0){
                                    for(var i=0; i < nodes.length; i++){
                                        var node = nodes[i];
                                        childrens.push(buildRow(nodeParent, node, false));
                                    }
                                    for(var i=0; i < $scope.tree_rows.length; i++){
                                        if($scope.tree_rows[i].branch.uid == nodeParent.branch.uid){
                                            $scope.tree_rows[i].branch['children'] = childrens;
                                        }
                                    }
    
                                    var row = $scope.rowsById[branch.uid];
                                    
                                    if(branch.expanded != true){
                                        $scope.toggleExpanded(row);
                                    }
                                }
                                _nodesClicked.push(branch.uid);
                                $scope.dataset.setParallelLoader(parallelLoaderValue);
                            });
                        } else {
                            $scope.toggleExpanded(row);
                        }
                        userItemClick(branch);
                    }
                }
            }

            function getItemLeft(level, branch, tree_icon) {
                if(level <= 1) {
                    if(branch[$scope.childrenCustomName].length == 0 && branch && (!$scope.lazyLoad || !tree_icon)) {
                        return '21px';
                    } else {
                        return 0;
                    }
                }

                if(branch[$scope.childrenCustomName].length > 0 || branch['hasChildren'] === 'S') {
                    return (level - 1) * 10 + 'px';
                } else {
                    return 21 + ((level - 1) * 10) + 'px';
                }
            }

            function filterFunction() {
                return function(row) {
                    return row.visible;
                };
            }

            function getItemStyle(level,branch) {
                if(branch['hasChildren'] === 'S') {
                    return 700;
                } 
                
                if(branch[$scope.childrenCustomName].length == 0) {
                    return 500;
                } 
            }

            function setParentsVisibility(row) {
                var parent_uid = row.branch.parent_uid;
                if(parent_uid) {
                    _programaticallyExpanding = true;
                    var parent = $scope.rowsById[parent_uid];
                    parent.visible = true;
                    parent.branch.expanded = true;
                    $scope.forceExpanded = {label: parent.branch.label, expanded: parent.branch.expanded, uid: parent.branch.uid};
                    _filteredRows.push(parent_uid);
                    setParentsVisibility(parent);
                }
            }

            function processDataChange(newData, oldData) {
            	if(angular.isDefined(newData) && !_initialized) {
            		initialize();
            		_initialized = true;
            	} else if ($scope.enableCbx && !_dataLoaded) {
                    // Adjust to solve the problem of loading data with checked parent item
                    if ($scope.tree_rows && $scope.tree_rows.length) {
                        _dataLoaded = true;
                        $scope.tree_rows.forEach(function(row) {
                            if (row.branch && row.branch.checked) {
                                $scope.control_selected_items(row.branch);
                                $scope.control_children_cbx(row.branch, row.branch.checked);
                            }
                        });
                    }
                }

                if(!_programaticallyExpanding || (StringUtils.isNotEmpty($scope.searchTerm) && !$scope.searchTermLoaded)) {
                    searchTermChange($scope.searchTerm);
                } else {
                    _programaticallyExpanding = false;
                }

                if (angular.isFunction($scope.treeDataCreated) && !_userClicked) {
                    $scope.treeDataCreated();
                }

                if (angular.isFunction(refresh_interceptor)) {
                	refresh_interceptor();
                }
            }

            function isArrayOfParents(array){
                let isArrayOfParents = true;

                array.forEach( array => {
                    if(!angular.isArray(array)){
                        isArrayOfParents = false;
                    }
                });

                return isArrayOfParents;
            }

            function advancedSearchTermChange(value, oldValue) {
                self.filtering = true;

                let recordHierarchy = undefined
                let treeDataHierarchy = []; 
                
                if(StringUtils.isEmpty(value)) {
                    if ($scope.dataset && !$scope.dataset.isLoadingByPk) {
                        if (angular.isUndefined($scope.refreshDatasetToTree) || $scope.refreshDatasetToTree) {
                            $scope.dataset.refresh();
                        }
                    } else if (angular.isDefined($scope.dataset?.isLoadingByPk)){
                        $scope.dataset.isLoadingByPk = false;
                    }
                    self.filtering = false;
                    return
                }
            
                if(angular.isUndefined($scope.tree_rows)) {
                    return;
                }

                $scope.dataset.getRecordAndHierarchy(value).then(result => {

                    recordHierarchy = result.responseBody.result;

                    if(isArrayOfParents(recordHierarchy)){
                        recordHierarchy.forEach(record => {
                            treeDataHierarchy.push(buildTreeData(record));
                        })
                    } else {
                        treeDataHierarchy = buildTreeData(recordHierarchy);
                    }

                    $scope.treeData = treeDataHierarchy;

                    on_treeData_change();

                    $scope.searchTermLoaded = true;

                    searchTermFinished();

                })

            }

            function buildTreeData(recordsHierarchy){

                let builtTreeData = []
                let buildRecordFrom = [];
                let hasChildren = undefined;
                let childrenRecord = undefined;

                recordsHierarchy.forEach(record => {
                    if(angular.isArray(record)){
                        hasChildren = true;
                        childrenRecord = record;
                    } else {
                        buildRecordFrom.push(record);
                        hasChildren = false
                    }
                });

                if(hasChildren){
                    if(isArrayOfParents(childrenRecord)){
                        let recordFrom = arrayToTree([buildRecordFrom], false, true);
                        if(angular.isDefined(recordFrom)) {
                            builtTreeData = recordFrom;
                            builtTreeData.expanded = true
                            builtTreeData.hasChildren = hasChildren ? 'S' : 'N';
                            builtTreeData.children = [];

                            childrenRecord.forEach(record => {
                                let childRecord;
                                let builtRecord = buildTreeData(record);

                                childRecord = builtRecord;
                                if(angular.isArray(childRecord)){
                                    builtTreeData.children.push(childRecord[0]);
                                } else {
                                    builtTreeData.children.push(childRecord)
                                }
                            });
                        }
                    }else {
                        let builtRecord = buildTreeData(childrenRecord);
                        let recordFrom = arrayToTree([buildRecordFrom], false, true, hasChildren);
                        if(angular.isDefined(recordFrom)) {
                            recordFrom.expanded = true;

                            builtTreeData = recordFrom;
                        }
                        builtTreeData.children = builtRecord;
                        builtTreeData.hasChildren = hasChildren ? 'S' : 'N';
                    }
                } else {
                    if(buildRecordFrom[self.parentProperty] <= ROOT_KEY_VALUE){
                        let parent = arrayToTree([buildRecordFrom], false, true, hasChildren);
                        if(angular.isDefined(parent)) {
                            parent.expanded = true;
                            parent.hasChildren = $scope.rowsById[parent.uid].hasChildren ? $scope.rowsById[parent.uid].hasChildren : 'N';                           
                            builtTreeData = parent;
                        }
                    } else {
                        let child = arrayToTree([buildRecordFrom], false, true, hasChildren);
                        if(angular.isDefined(child)) {
                            child.expanded = true;
                            child.hasChildren = hasChildren ? 'S' : 'N';
    
                            builtTreeData.push(child);
                        }
                    }
                }

                return builtTreeData;
            }

            function searchTermChange(value, oldValue) {
                if(angular.isUndefined($scope.tree_rows)) {
                    return;
                }
                var keysSearch = Object.keys(_branchByLabel);

                if(StringUtils.isEmpty(value)) {
                    _lastSearchTermValue = value;
                    _filteredRows = [];
                    _filteredRowsObjs = [];

                    for(var i = 0, length = keysSearch.length; i < length; i++) {
                        var row = _branchByLabel[keysSearch[i]];
                        _programaticallyExpanding = true;
                        row.visible = true;
                        row.branch.expanded = false;
                        $scope.forceExpanded = {
                            label: row.branch.label, 
                            expanded: row.branch.expanded, 
                            uid: row.branch.uid
                        };
                    }

                    on_treeData_change();

                    searchTermFinished();

                    return;
                }

                if(!$scope.tree_rows.length && !$scope.searchTermLoaded) {
                    return;
                }

                _lastSearchTermValue = value;
                _filteredRows = [];
                _filteredRowsObjs = [];

                var searchTerm = StringUtils.replaceAccentuatedChars($scope.searchTerm);
                searchTerm = StringUtils.replaceAll(searchTerm,'.','').toLowerCase();                

                for(var i = 0, length = keysSearch.length; i < length; i++) {
                    var row = _branchByLabel[keysSearch[i]];

                    if (row) {
                        var matchText = row.label || row.description;
                        var matchData = StringUtils.replaceAll(row.maskedIdentifier, '.', '');

                        if(matchText && matchData){
                            match = StringUtils.replaceAccentuatedChars(matchText).toLowerCase().indexOf(searchTerm) >= 0 || 
                            StringUtils.replaceAccentuatedChars(matchData).toLowerCase().indexOf(searchTerm) >= 0;
                        } else {
                            if(matchText){
                            match = StringUtils.replaceAccentuatedChars(matchText).toLowerCase().indexOf(searchTerm) >= 0
                            }
                        }
                    }

                    var hasChildren = row.branch[$scope.childrenCustomName].length > 0;

                    if(match && !hasChildren) {
                        _programaticallyExpanding = true;
                        row.visible = true;
                        _filteredRows.push(row.branch.uid);
                        _filteredRowsObjs.push(row);
                        setParentsVisibility(row);
                    } else {
                        row.visible = false;
                        _programaticallyExpanding = true;
                        row.branch.expanded = false;
                    }
                }

                if(_filteredRowsObjs[0]){
                    toggleExpandedLazyLoad(_filteredRowsObjs[0]);
                }

                on_treeData_change();

                $scope.searchTermLoaded = true;

                searchTermFinished();
            }

            function searchTermFinished() {
                if (angular.isFunction($scope.searchTermInterceptor)) {
                    $timeout(function () {
                        $scope.searchTermInterceptor($scope.tree_rows);
                    });
                }
            }

            function someChildrenMatches(row) {
                var match = false;

                if (row) {
                    var searchTerm = StringUtils.replaceAccentuatedChars($scope.searchTerm).toLowerCase();
                    match = StringUtils.replaceAccentuatedChars(row.label).toLowerCase().indexOf(searchTerm) >= 0;
                }

                var hasChildren = row.branch[$scope.childrenCustomName].length > 0;

                if(match && !hasChildren) {
                    return true;
                } else if(hasChildren) {
                    for(var i = 0, length = row.branch[$scope.childrenCustomName].length; i < length; i++) {
                        return someChildrenMatches(row.branch[$scope.childrenCustomName][i]);
                    }
                } else {
                    return false;
                }
            }

            function isAllParentsExpanded(branch) {
                var parent_uid = branch.parent_uid;
                if(parent_uid) {
                    var parent = $scope.rowsById[parent_uid];
                    if(!parent.branch.expanded) {
                        return false;
                    } else {
                        return isAllParentsExpanded(parent.branch);
                    }
                } else {
                    return branch.expanded;
                }
            }

            function onItemKeydown(row, $event) {
                $event.preventDefault();
                switch($event.keyCode) {
                    case SkConstants.KEY_CODE.UP_ARROW:
                        selectPreviousItem();
                        break;
                    case SkConstants.KEY_CODE.LEFT_ARROW:
                    case SkConstants.KEY_CODE.MINUS:
                        handleLeftArrow();
                        break;
                    case SkConstants.KEY_CODE.RIGHT_ARROW:
                    case SkConstants.KEY_CODE.PLUS:
                        handleRightArrow();
                        break;
                    case SkConstants.KEY_CODE.DOWN_ARROW:
                        selectNextItem();
                        break;
                    case SkConstants.KEY_CODE.ENTER:
                        if(angular.isFunction($scope.onSelect) && $scope.selected_branch) {
                            $scope.onSelect($scope.selected_branch, {programatically: false});
                        } else if ($scope.enableCbx) {
                            $scope.user_clicks_branch($scope.selected_branch, $event);
                        }
                        break;
                    case SkConstants.KEY_CODE.HOME:
                        selectFirstVisibleItem();
                        break;
                    case SkConstants.KEY_CODE.END:
                        selectLastVisibleItem();
                        break;
                }
            }

            function handleLeftArrow() {
                if (!$scope.selected_branch) {
                    return;
                }
                if(!$scope.selected_branch.expanded && $scope.selected_branch.parent_uid) {
                    for(var i = getSelectedIndex() - 1; i >= 0; i--) {
                        if($scope.tree_rows[i].branch.uid == $scope.selected_branch.parent_uid) {
                            $scope.user_clicks_branch($scope.tree_rows[i].branch);
                            return;
                        }
                    }
                } else {
                    expandOrCollapseRow(SkConstants.KEY_CODE.LEFT_ARROW);
                }
            }

            function handleRightArrow() {
                if (!$scope.selected_branch) {
                    return;
                }
                if($scope.lazyLoad){
                    var row = $scope.rowsById[$scope.selected_branch.uid];
                    toggleExpandedLazyLoad(row);
                } else if($scope.selected_branch.expanded && $scope.selected_branch[$scope.childrenCustomName].length > 0) {
                    for(var i = getSelectedIndex() + 1, length = $scope.tree_rows.length; i < length; i++) {
                        if($scope.tree_rows[i].visible) {
                            $scope.user_clicks_branch($scope.tree_rows[i].branch);
                            return;
                        }
                    }
                } else {
                    expandOrCollapseRow(SkConstants.KEY_CODE.RIGHT_ARROW);
                }
            }

            function selectNextItem() {
                for(var i = getSelectedIndex()+1, length = $scope.tree_rows.length; i < length; i++) {
                    var row = $scope.tree_rows[i];
                    if(row.visible) {
                        $scope.user_clicks_branch(row.branch);
                        $timeout(function () {
                            scrollToSelectedBranch();
                        }, 0, false);
                        break;
                    }
                }
            }

            function selectPreviousItem() {
                for(var i = getSelectedIndex()-1, length = $scope.tree_rows.length; i >= 0; i--) {
                    var row = $scope.tree_rows[i];
                    if(row.visible) {
                        $scope.user_clicks_branch(row.branch);
                        $timeout(function () {
                            scrollToSelectedBranch();
                        }, 0, false);
                        break;
                    }
                }
            }

            function selectFirstVisibleItem() {
                for(var i = 0, length = $scope.tree_rows.length; i < length; i++) {
                    var row = $scope.tree_rows[i];
                    if(row.visible) {
                        $scope.user_clicks_branch(row.branch);
                        $timeout(function () {
                            scrollToSelectedBranch();
                        }, 0, false);
                        break;
                    }
                }
            }

            function selectLastVisibleItem() {
                for(var i =  $scope.tree_rows.length - 1; i >= 0; i--) {
                    var row = $scope.tree_rows[i];
                    if(row.visible) {
                        $scope.user_clicks_branch(row.branch);
                        $timeout(function () {
                            scrollToSelectedBranch();
                        }, 0, false);
                        break;
                    }
                }
            }

            function expandOrCollapseRow(direction) {
                if (!$scope.selected_branch) {
                    return;
                }
                if((direction == SkConstants.KEY_CODE.RIGHT_ARROW && $scope.selected_branch.expanded) || (direction == SkConstants.KEY_CODE.LEFT_ARROW && !$scope.selected_branch.expanded)) {
                    return;
                }
                _programaticallyExpanding = true;
                $scope.selected_branch.expanded = !$scope.selected_branch.expanded;
            }

            function getSelectedIndex() {
                for(var i = 0, length = $scope.tree_rows.length; i < length; i++) {
                    if($scope.tree_rows[i].branch == $scope.selected_branch) {
                        return i;
                    }
                }
                return -1;
            }

            function setSelectedItems(items){

                let itemsArray;

                if(!angular.isArray(items)){
                    itemsArray = [items];
                }else{
                    itemsArray = items;
                }

                cleanSelectedItems();

                $scope.multiSelected = [];

                for(var idx in itemsArray){

                    var item = itemsArray[idx];
                    var id = '';

                    if(angular.isString(item)){
                        id = item;
                    } else if(angular.isObject(item)){
                        id = item.uid;
                    }

                    if(id.endsWith(':')){
                        id = id + 'undefined';
                    }
                    
                    var branch = $scope.rowsById[id] == undefined ? undefined : $scope.rowsById[id].branch;

                    if (angular.isFunction($scope.user_clicks_branch)) {
                        $scope.user_clicks_branch(branch, {ctrlKey: true});
                    }

                    $timeout(function() {
                        if (angular.isFunction(select_branch)) {
                            select_branch(branch, {programatically: true});
                        }
                    });
                }
            }

            function getSelectedItems(){
                
                var selectedItems = []

                for(var index in $scope.multiSelected){
                    var uid = $scope.multiSelected[index];
                    selectedItems.push($scope.rowsById[uid]);
                }
            
                return selectedItems;
            }

            function cleanSelectedItems(){
                removeActiveClass();
                $scope.multiSelected = [];
            }

            function removeActiveClass(){
                var actives = $element[0].querySelectorAll('li.active');

                if(actives){
                    actives.forEach(function(element){
                        if(element.classList.contains('active')){
                            element.classList.remove('active');
                        }
                    });
                }
            }

            
            function itemDblClick() {
                if(angular.isFunction($scope.dblClickFn)) {
                    $scope.dblClickFn($scope.selected_branch);
                }

                if(!$scope.dblClickForSelect) {
                    return
                };

                if(angular.isFunction($scope.onSelect) && $scope.selected_branch) {
                    $scope.onSelect($scope.selected_branch, { programatically: false });
                }
            }

            function scrollToSelectedBranch(options){
                if($scope.ignoreScrollTo == true) return;

                if(options?.programatically == false) return;
                var elementToScroll = $element.find('li.active');
                
                if(elementToScroll && elementToScroll.length > 0) {
                    elementToScroll[0].scrollIntoView({ behavior: 'smooth' });
                }
            }

            //Importado de um componente de terceiro//
            var error, expand_all_parents, expand_level, for_all_ancestors, for_each_branch, get_parent, n, on_treeData_change, select_branch, tree, refresh_interceptor, programatically_expanding;
            function initialize() {
            	_nodesClicked = [];
                error = function(s) {
                    console.log('ERROR:' + s);
                    return void 0;
                };
                if ($attrs.iconExpand == null) {
                    $attrs.iconExpand = 'glyphicon glyphicon-chevron-right';
                }
                if ($attrs.iconCollapse == null) {
                    $attrs.iconCollapse = 'glyphicon glyphicon-chevron-down';
                }
                if ($attrs.iconLeaf == null) {
                    //s$attrs.iconLeaf = 'icon-file  glyphicon glyphicon-file  fa fa-file';
                }
                if ($attrs.expandLevel == null) {
                    $attrs.expandLevel = '3';
                }
                expand_level = parseInt($attrs.expandLevel, 10);
                if (!$scope.treeData) {
                    //alert('no treeData defined for the tree!');
                    return;
                }
                if ($scope.treeData.length == null) {
                    if ($scope.treeData.label != null) {
                        $scope.treeData = [$scope.treeData];
                    } else {
                        //alert('treeData should be an array of root branches');
                        return;
                    }
                }
                for_each_branch = function(f) {
                    var do_f, root_branch, _i, _len, _ref, _results;
                    do_f = function(branch, level) {
                        var child, _i, _len, _ref, _results;
                        f(branch, level);
                        if (branch[$scope.childrenCustomName] != null) {
                            _ref = branch[$scope.childrenCustomName];
                            _results = [];

                            if (_ref && _ref.length > 0) {
                                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                    child = _ref[_i];
                                    _results.push(do_f(child, level + 1));
                                }
                            }

                            return _results;
                        }
                    };
                    _ref = $scope.treeData;
                    _results = [];

                    if (_ref && _ref.length > 0) {
                        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                            root_branch = _ref[_i];
                            _results.push(do_f(root_branch, 1));
                        }
                    }

                    return _results;
                };
                function tree_is_empty() {
                    return !$scope.tree_rows || ($scope.tree_rows && !$scope.tree_rows.length);
                };
                function expand_by_level(levelAux) {
                    return for_each_branch(function(b, level) {
                        if (levelAux === level) {
                            _programaticallyExpanding = true;
                            b.expanded = true;
                            $scope.forceExpanded = {label: b.label, expanded: b.expanded, uid: b.uid};
                        }
                        return b.expanded;
                    });
                };
                function expand_all() {
                    return for_each_branch(function(b, level) {
                        _programaticallyExpanding = true;
                        b.expanded = true;
                        $scope.forceExpanded = {label: b.label, expanded: b.expanded, uid: b.uid};
                        return b.expanded;
                    });
                };
                function collapse_all() {
                    return for_each_branch(function(b, level) {
                        _programaticallyExpanding = true;
                        b.expanded = false;
                        $scope.forceExpanded = {label: b.label, expanded: b.expanded, uid: b.uid};
                        return b.expanded;
                    });
                };
                $scope.selected_branch = null;
                select_branch = function(branch, options = {}) {
                    if (!branch) {
                        if ($scope.selected_branch != null) {
                            $scope.selected_branch.selected = false;
                        }
                        $scope.selected_branch = null;
                        return;
                    }
                    if (branch !== $scope.selected_branch) {
                        if ($scope.selected_branch != null) {
                            $scope.selected_branch.selected = false;
                        }
                        branch.selected = true;
                        $scope.selected_branch = branch;
                        expand_all_parents(branch);
                        _debounceScrollToSelectedBranch(options);

                        if (branch.onSelect != null && !$scope.dblClickForSelect) {
                            return $timeout(function() {
                                return branch.onSelect(branch, options);
                            });
                        } else {
                            if ($scope.onSelect != null && !$scope.dblClickForSelect) {
                                return $timeout(function() {
                                    return $scope.onSelect(branch, options);
                                });
                            }
                        }
                    }
                };

                // Method to control the checked data and update the children
                $scope.control_children_cbx = function(branch, checked) {
                    if (branch.children && branch.children.length) {
                        branch.children.forEach(function(child) {
                            child.checked = checked;
                            $scope.control_selected_items(child);
                            $scope.control_children_cbx(child, checked);
                        });
                    }
                }

                // Method to control the checked data and update the parent
                $scope.control_parent_cbx = function(branch) {
                    let checked = true;
                    let count = 0;
                    const parent = get_parent(branch);

                    // Control all parent branch when children branches checked
                    /* if (parent && parent.children) {
                        parent.children.forEach(function(child) {
                            if (!child.checked) {
                                checked = false;
                            } else {
                                count++;
                            }
                        });
                        parent.checked = (!checked && count > 0) ? $scope.indeterminateValue : checked;
                        $scope.control_selected_items(parent);
                        $scope.control_parent_cbx(parent);
                    } */

                    // Control only option "Check All" when children branches checked
                    if (parent && parent.children) {
                        if (!parent.parent_uid) {
                            for_each_branch(function(b) {
                                if (b.uid !== parent.uid) {
                                    if (!b.checked) {
                                        checked = false;
                                    } else {
                                        count++;
                                    }
                                }
                            });
                            parent.checked = (!checked && count > 0) ? $scope.indeterminateValue : checked;
                            $scope.control_selected_items(parent);
                        } else {
                            $scope.control_parent_cbx(parent);
                        }
                    }
                }

                // Method to control selected items list
                $scope.control_selected_items = function(branch) {
                    const checked = branch.checked === true ? true : false;
                    if (checked && $scope.multiSelected.indexOf(branch.uid) == -1) {
                        $scope.multiSelected.push(branch.uid);
                    } else if (!checked && $scope.multiSelected.indexOf(branch.uid) > -1) {
                        var index = $scope.multiSelected.indexOf(branch.uid);
                        $scope.multiSelected.splice(index, 1);
                    }
                }

                // Method to control directive attribute's to enable checkbox-list
                $scope.control_enable_cbx = function(branch, $event) {
                    if ($event && $event.target) {
                        if (angular.element($event.target).hasClass('tree-icon')) {
                            return;
                        }
                        branch.checked = !branch.checked;
                        $scope.control_selected_items(branch);
                        $scope.control_children_cbx(branch, branch.checked);
                        $scope.control_parent_cbx(branch);
                    }
                }
                
                $scope.user_mousedown = function(branch, $event){
                	if($scope.selectOnMouseDown){
                		$scope.user_clicks_branch(branch, $event)
                	}
                }
                
                $scope.user_clicks_branch = function(branch, $event) {

                    // Adjust to resolve the use of searchTerm in the component
                    _programaticallyExpanding = true;

                    // Adjust to control data created before the component has a user action
                    _userClicked = true;
                    
                    if($scope.lazyLoad){
                        userItemClick(branch);
                    }

                    if ($scope.enableCbx) {
                        $scope.control_enable_cbx(branch, $event);
                    }
                    
                    if ($scope.acceptMultiSelect && !$scope.enableCbx) {
                        if ($event && ($event.ctrlKey || $event.metaKey)) {
                            if ($scope.multiSelected.indexOf(branch.uid) == -1) {
                                branch.selected = true;
                                $scope.multiSelected.push(branch.uid);
                            } else if ($scope.multiSelected.indexOf(branch.uid) > -1) {
                                branch.selected = false;
                                var index = $scope.multiSelected.indexOf(branch.uid);
                                $scope.multiSelected.splice(index, 1);
                            }
                        } else {
                            if ($scope.multiSelected.length > 1) {
                                removeActiveClass();
                            }

                            $scope.multiSelected = [];
                            $scope.multiSelected.push(branch.uid);

                            if ($event && $event.target) {
                                if (angular.element($event.target).hasClass('tree-icon')) {
                                    return;
                                }
                            }

                            // Setamos a linha como false, para forçar a seleção
                            branch.selected = false;

                            return $timeout(function () {
                                return select_branch(branch, {programatically: false});
                            });
                        }
                    } else {
                        /*if ($event && $event.target) {
                            if (angular.element($event.target).hasClass('tree-icon')) {
                                return;
                            }
                        }*/
                        if (branch !== $scope.selected_branch) {
                            return select_branch(branch, {programatically: false});
                        } else if ($event.ctrlKey && $scope.selected_branch) {
                            $scope.selected_branch.selected = false;
                            $scope.selected_branch = undefined;
                            if ($scope.onSelect != null) {
                                $scope.onSelect({}, {programatically: false});
                            }
                        }
                    }
                };
                
                $scope.expand_all = expand_all;
                $scope.collapse_all = collapse_all;
                $scope.expand_by_level = expand_by_level;
                $scope.tree_is_empty = tree_is_empty;

                get_parent = function(child) {
                    var parent;
                    parent = void 0;
                    if (child.parent_uid) {
                        for_each_branch(function(b) {
                            if (b.uid === child.parent_uid) {
                                return parent = b;
                            }
                        });
                    }
                    return parent;
                };
                for_all_ancestors = function(child, fn) {
                    var parent;
                    parent = get_parent(child);
                    if (parent != null) {
                        fn(parent);
                        return for_all_ancestors(parent, fn);
                    }
                };
                expand_all_parents = function(child) {
                    return for_all_ancestors(child, function(b) {
                        _programaticallyExpanding = true;
                        b.expanded = true;
                        $scope.forceExpanded = {label: b.label, expanded: b.expanded, uid: b.uid};
                        return b.expanded;
                    });
                };
                programatically_expanding = function(value) {
                    _programaticallyExpanding = value;
                };
                $scope.tree_rows = [];

                refresh_interceptor = function () {
                    on_treeData_change();

                    if (angular.isFunction($scope.finishRefreshedInterceptor)) {
                        $scope.finishRefreshedInterceptor();
                    }
                }

                on_treeData_change = function() {
                    var add_branch_to_list, root_branch, _i, _len, _ref, _results;

                    if ($scope.treeData && ($scope.treeData.length || Object.keys($scope.treeData).length)) {
                        $scope.treeData = loadTreeData($scope.treeData);
                    }

                    for_each_branch(function(b, level) {
                        if (!b.uid) {
                            return b.uid = "" + Math.random();
                        }
                    });

                    for_each_branch(function(b) {
                        var child, _i, _len, _ref, _results;
                        if (angular.isArray(b[$scope.childrenCustomName])) {
                            _ref = b[$scope.childrenCustomName];
                            _results = [];

                            if (_ref && _ref.length > 0) {
                                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                    child = _ref[_i];
                                    _results.push(child.parent_uid = b.uid);
                                }
                            }

                            return _results;
                        }
                    });
                    $scope.tree_rows = [];
                    //_rowsById = {};
                    for_each_branch(function(branch) {
                        var child, f;
                        if (branch[$scope.childrenCustomName]) {
                            if (branch[$scope.childrenCustomName].length > 0) {
                                f = function(e) {
                                    if (typeof e === 'string') {
                                        return {
                                            label: e,
                                            children: []
                                        };
                                    } else {
                                        return e;
                                    }
                                };
                                return branch[$scope.childrenCustomName] = (function() {
                                    var _i, _len, _ref, _results;
                                    _ref = branch[$scope.childrenCustomName];
                                    _results = [];

                                    if (_ref && _ref.length > 0) {
                                        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                            child = _ref[_i];
                                            _results.push(f(child));
                                        }
                                    }

                                    return _results;
                                })();
                            }
                        } else {
                            return branch[$scope.childrenCustomName] = [];
                        }
                    });
                    add_branch_to_list = function(level, branch, visible) {
                        var child, child_visible, tree_icon, _i, _len, _ref, _results;
                        
                        if (branch.expanded == null) {
                            _programaticallyExpanding = true;
                            if(!$scope.lazyLoad &&  $scope.dataset && !$scope.dataset.isInitDataSetLazyLoad()){
                                branch.expanded = false;
                            }
                        }

                        if($scope.forceExpanded && branch.label === $scope.forceExpanded.label && branch.uid == $scope.forceExpanded.uid){
                            if(branch.expanded !== $scope.forceExpanded.expanded){
                                branch.expanded = $scope.forceExpanded.expanded;
                            }
                        }

                        if (!branch[$scope.childrenCustomName] || branch[$scope.childrenCustomName].length === 0) {
                            tree_icon = $attrs.iconLeaf;
                        } else {
                            if (branch.expanded) {
                                tree_icon = $attrs.iconCollapse;
                            } else {
                                tree_icon = $attrs.iconExpand;
                            }
                        }

                        if($scope.lazyLoad && branch['hasChildren']){
                            if(branch['hasChildren'] === 'S' && branch.expanded){
                                tree_icon = $attrs.iconCollapse;
                            } else if(branch['hasChildren'] === 'S' && !branch.expanded){
                                tree_icon = $attrs.iconExpand;
                            } else {
                                tree_icon = $attrs.iconLeaf;
                            }
                        }

                        // Customization to resolve the use of labelCustomName in the component
                        branch.label = branch.label || branch[$scope.labelCustomName];

                        var row = {
                            level: level,
                            branch: branch,
                            label: i18n(branch.label),
                            tree_icon: tree_icon,
                            visible: visible,
                            description: branch.description,
                            data: branch.data,
                            icon: branch.icon,
                            iconV: branch.iconV,
                            encodedId: btoa(branch.uid).replace(/=/g ,'') 
                        };

                        if(angular.isFunction($scope.dataTipFunction)){
                            
                            var data = branch.data;
                            
                            if(data && data.codigo){
                                row.tooltip = $scope.dataTipFunction({id: data.codigo});
                            }
                        }else if(branch.tooltip){
                            row.tooltip = branch.tooltip;
                        }

                        if($scope.lazyLoad){
                            row['maskedIdentifier'] = branch.maskedIdentifier;
                            row['descriptionCustom'] = getDescriptionCustom(row);
                            row['rowUniqueId'] = branch['rowUniqueId'];
                            row['hasChildren'] = branch['hasChildren'];
                        }

                        row.toolTipPlacement = $scope.tooltipPlacement ? $scope.tooltipPlacement : 'bottom';
                  
                        if (visible) {
                            $scope.tree_rows.push(row);
                        }
                        
                        $scope.rowsById[branch.uid] = row;

                        if(_branchByLabel[branch.label]){
                            var branchRepeat = branch.label + Math.random();
                            _branchByLabel[branchRepeat] = row;
                        } else {
                            _branchByLabel[branch.label || branch.description] = row;
                        }

                        if (branch[$scope.childrenCustomName] != null) {
                            _ref = branch[$scope.childrenCustomName];
                            _results = [];

                            if (_ref && _ref.length > 0) {
                                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                    child = _ref[_i];

                                    child_visible = (function(parentBranch, child,visible) {
                                        if (_filteredRows.length > 0) {
                                            var isFiltered = _filteredRows.indexOf(child.uid) > -1;
                                            return isFiltered && isAllParentsExpanded(child);
                                        } else {
                                            return visible && parentBranch.expanded;
                                        }
                                    })(branch, child,visible);

                                    _results.push(add_branch_to_list(level + 1, child, child_visible));
                                }
                            }
                            return _results;
                        }



                    };
                    _ref = $scope.treeData;
                    _results = [];

                    if (_ref && _ref.length > 0) {
                        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                            root_branch = _ref[_i];
                            var row = add_branch_to_list(1, root_branch, $scope.rowsById[root_branch.uid] ? $scope.rowsById[root_branch.uid].visible : true);
                            _results.push(row);
                        }
                    }

                    if($scope.searchTerm != _lastSearchTermValue) {
                        searchTermChange($scope.searchTerm, _lastSearchTermValue);
                    }

                    return _results;
                };

                on_treeData_change();

                if ($attrs.initialSelection != null) {
                    for_each_branch(function(b) {
                        if (b.label === $attrs.initialSelection) {
                            return $timeout(function() {
                                return select_branch(b, {programatically: true});
                            });
                        }
                    });
                }
                n = $scope.treeData.length;

                for_each_branch(function(b, level) {
                    b.level = level;
                    _programaticallyExpanding = true;
                    return b.expanded = false;//b.level < expand_level;
                });
                if ($scope.treeControl != null) {
                    if (angular.isObject($scope.treeControl)) {
                        tree = $scope.treeControl;
                        tree.expand_all = expand_all;
                        tree.collapse_all = collapse_all;
                        tree.expand_by_level = expand_by_level;
                        tree.refresh = on_treeData_change;
                        tree.tree_is_empty = tree_is_empty;
                        tree.expand_all_parents = expand_all_parents;
                        tree.programatically_expanding = programatically_expanding;

                        tree.get_first_branch = function() {
                            n = $scope.treeData.length;
                            if (n > 0) {
                                return $scope.treeData[0];
                            }
                        };
                        tree.select_first_branch = function() {
                            var b;
                            b = tree.get_first_branch();
                            return tree.select_branch(b, {programatically: true});
                        };
                        tree.get_selected_branch = function() {
                            return $scope.selected_branch;
                        };
                        tree.get_parent_branch = function(b) {
                            return get_parent(b);
                        };
                        tree.select_branch = function(b) {
                            select_branch(b, {programatically: true});
                            return b;
                        };
                        tree.get_children = function(b) {
                            return b[$scope.childrenCustomName];
                        };
                        tree.select_parent_branch = function(b) {
                            var p;
                            if (b == null) {
                                b = tree.get_selected_branch();
                            }
                            if (b != null) {
                                p = tree.get_parent_branch(b);
                                if (p != null) {
                                    tree.select_branch(p, {programatically: true});
                                    return p;
                                }
                            }
                        };
                        tree.add_branch = function(parent, new_branch) {
                            if (parent != null) {
                                parent[$scope.childrenCustomName].push(new_branch);
                                _programaticallyExpanding = true;
                                parent.expanded = false;
                            } else {
                                $scope.treeData.push(new_branch);
                            }
                            return new_branch;
                        };
                        tree.add_root_branch = function(new_branch) {
                            tree.add_branch(null, new_branch);
                            return new_branch;
                        };
                        tree.expand_branch = function(b) {
                            if (b == null) {
                                b = tree.get_selected_branch();
                            }
                            if (b != null) {
                                _programaticallyExpanding = true;
                                b.expanded = true;
                                return b;
                            }
                        };
                        tree.collapse_branch = function(b) {
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                _programaticallyExpanding = true;
                                b.expanded = false;
                                return b;
                            }
                        };
                        tree.get_siblings = function(b) {
                            var p, siblings;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                p = tree.get_parent_branch(b);
                                if (p) {
                                    siblings = p[$scope.childrenCustomName];
                                } else {
                                    siblings = $scope.treeData;
                                }
                                return siblings;
                            }
                        };
                        tree.get_next_sibling = function(b) {
                            var i, siblings;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                siblings = tree.get_siblings(b);
                                n = siblings.length;
                                i = siblings.indexOf(b);
                                if (i < n) {
                                    return siblings[i + 1];
                                }
                            }
                        };
                        tree.get_prev_sibling = function(b) {
                            var i, siblings;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            siblings = tree.get_siblings(b);
                            n = siblings.length;
                            i = siblings.indexOf(b);
                            if (i > 0) {
                                return siblings[i - 1];
                            }
                        };
                        tree.select_next_sibling = function(b) {
                            var next;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                next = tree.get_next_sibling(b);
                                if (next != null) {
                                    return tree.select_branch(next, {programatically: true});
                                }
                            }
                        };
                        tree.select_prev_sibling = function(b) {
                            var prev;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                prev = tree.get_prev_sibling(b);
                                if (prev != null) {
                                    return tree.select_branch(prev, {programatically: true});
                                }
                            }
                        };
                        tree.get_first_child = function(b) {
                            var _ref;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                if (((_ref = b[$scope.childrenCustomName]) != null ? _ref.length : void 0) > 0) {
                                    return b[$scope.childrenCustomName][0];
                                }
                            }
                        };
                        tree.get_closest_ancestor_next_sibling = function(b) {
                            var next, parent;
                            next = tree.get_next_sibling(b);
                            if (next != null) {
                                return next;
                            } else {
                                parent = tree.get_parent_branch(b);
                                return tree.get_closest_ancestor_next_sibling(parent);
                            }
                        };
                        tree.get_next_branch = function(b) {
                            var next;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                next = tree.get_first_child(b);
                                if (next != null) {
                                    return next;
                                } else {
                                    next = tree.get_closest_ancestor_next_sibling(b);
                                    return next;
                                }
                            }
                        };
                        tree.select_next_branch = function(b) {
                            var next;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                next = tree.get_next_branch(b);
                                if (next != null) {
                                    tree.select_branch(next, {programatically: true});
                                    return next;
                                }
                            }
                        };
                        tree.last_descendant = function(b) {
                            var last_child;
                            if (b == null) {
                            }
                            n = b[$scope.childrenCustomName].length;
                            if (n === 0) {
                                return b;
                            } else {
                                last_child = b[$scope.childrenCustomName][n - 1];
                                return tree.last_descendant(last_child);
                            }
                        };
                        tree.get_prev_branch = function(b) {
                            var parent, prev_sibling;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                prev_sibling = tree.get_prev_sibling(b);
                                if (prev_sibling != null) {
                                    return tree.last_descendant(prev_sibling);
                                } else {
                                    parent = tree.get_parent_branch(b);
                                    return parent;
                                }
                            }
                        };
                        
                        tree.select_father_children = function() {                      	
                        	var row;
                        	var hasChildren;

                        	tree.expand_all();
                        	
                        	var promise = $timeout(function() {
                        		var deferred = $q.defer();
	                        	for(var i = getSelectedIndex()+1, length = $scope.tree_rows.length; i < length; i++) {
	                        		row = $scope.tree_rows[i];
	                                hasChildren = row.branch[$scope.childrenCustomName].length > 1;
	
	                                if(hasChildren) {
	                                	$scope.user_clicks_branch(row.branch);
	                                    break;
	                                }
	                            }
	                        	
	                        	if (!hasChildren){
	                        		var branch = tree.select_first_branch();
	                        		if (branch){
		                                var last_child = tree.last_descendant(branch);
		                                $scope.user_clicks_branch(last_child);
	                        		}
	                        	}
	                        	
	                        	deferred.resolve();
	                        	return deferred.promise;
	                        	
                        	},0,false);
                        	
                        	promise.then(function(result) {
                        		scrollViewActiveChild();
                        		
                        		var selectedBranch = tree.get_selected_branch();
                        		if (selectedBranch){
                            		tree.collapse_father_children(selectedBranch);
                        		}
                    		});
                        };
                        function scrollViewActiveChild() {
                        	var container = $element.find('ul');
	                        var child = container[0].querySelector('li.active');
	                        
	                        if (child != null) {
	                            var childPosition = PositionUtils.position(child);
	                            var childTop = childPosition.top;
	
		                        if (childTop == 0) {
		                            DomUtil.scrollTo(container, 0);
		                        } else {
		                        	DomUtil.scrollTo(container, childTop);
		                        }
	                        }
                        }
                        tree.collapse_father_children = function(b) {                      	
                        	var children = tree.get_children(b);
                        	var child;
                        	
                        	for(var i = 0, length = children.length; i < length; i++) {
                        		child = children[i];
                        		tree.collapse_branch(child);
                            }
                        	return;
                        };
                        
                        
                        return tree.select_prev_branch = function(b) {
                            var prev;
                            if (b == null) {
                                b = $scope.selected_branch;
                            }
                            if (b != null) {
                                prev = tree.get_prev_branch(b);
                                if (prev != null) {
                                    tree.select_branch(prev, {programatically: true});
                                    return prev;
                                }
                            }
                        }; 
                    }
                }

                $scope.editAddRow = function editAddRow(edit) {

                    var parameters = [
                        {
                            description:  i18n("Geral.lblCreateInRoot"),
                            enabled: true,
                            fieldName: 'createInRoot',
                            fieldType: "S",
                            name: "root",
                            paramIndex: 0,
                            presentationType: "S",
                            required: false,
                            type: "S"
                        },
                        {
                            description: i18n("Geral.lblDescricao"),
                            enabled: true,
                            fieldName: 'description',
                            fieldProp: {
                                autofocus: ""//Essa propriedade provê ao Popup a possibilidade de focus
                            },
                            fieldType: "S",
                            label: "Geral.lblDescricao",
                            name: 'description',
                            paramIndex: 0,
                            presentationType: "P",
                            properties: {},
                            required: true,
                            type: "S",
                            value: ($scope.selected_branch && edit) ? $scope.selected_branch.description : ""
                        }
                    ];

                    var options = {
                        size: 'sm',
                        okLabel: 'Geral.lblSalvar',
                        title: ($scope.selected_branch && edit) ? 'Geral.lblEditar' : 'Geral.lblCadastrar'
                    }

                    var popUpEdit = PopUpParameter.openPopUp(parameters, options);

                    popUpEdit.result.then(function (result) {
                        var node;
                        if (!edit) {
                            node = undefined;
                        } else {
                            node = $scope.selected_branch;
                        }
                        if(result.root == 'S'){
                            $scope.selected_branch = null; 
                        }
                        $q.when($scope.endEdit(result.description, node, $scope.selected_branch, edit ? 'edit' : 'insert'), function (nodeResolved) {
                            if (!edit) {
                                if ($scope.selected_branch != null && angular.isDefined($scope.selected_branch[$scope.childrenCustomName])) {
                                    $scope.selected_branch[$scope.childrenCustomName].push(nodeResolved);
                                    $scope.selected_branch.selected = false;
                                    $scope.selected_branch = nodeResolved;
                                    expand_all_parents($scope.selected_branch);
                                } else {
                                    $scope.treeData.push(nodeResolved);
                                    if ($scope.selected_branch) {
                                        $scope.selected_branch.selected = true;
                                    }
                                    
                                    select_branch(nodeResolved, {programatically: true});
                                }
                            }
                            if($scope.selected_branch != null){
                                expand_all_parents($scope.selected_branch);
                            }
                        })
                    });
                }

                $scope.removeRow = function () {
                    if (!$scope.selected_branch) {
                        return;
                    }
                    MessageUtils.confirm(i18n('Dataset.messageTitleExluir'), i18n('Dataset.messageApagarRegistro')).then(function () {
                        $q.when($scope.endEdit($scope.selected_branch.description, $scope.selected_branch, undefined, 'delete'), function (canContinue) {
                            if (canContinue) {
                                if ($scope.treeData.indexOf($scope.selected_branch) > -1) {
                                    ArrayUtils.removeReference($scope.treeData, $scope.selected_branch, true);
                                } else {
                                    $scope.removeChildren();
                                }
                            }
                        });
                    })
                }

                $scope.removeChildren = function (){
                    let itemRemoved = false;
                    for_each_branch(function (b) {
                        if (b.children.indexOf($scope.selected_branch) > -1) {
                            itemRemoved = true;
                            ArrayUtils.removeReference(b.children, $scope.selected_branch, true);
                            if (b.children && b.children.length == 0) {
                                b.expanded = false;
                                b.hasChildren = 'N';
                            } else if (b.children && b.children.length > 0) {
                                b.expanded = true;
                                b.hasChildren = 'S';
                            }
                        }
                    });
                    if (!itemRemoved) {
                        if ($scope.treeData.indexOf($scope.selected_branch) > -1) {
                            itemRemoved = true;
                            ArrayUtils.removeReference($scope.treeData, $scope.selected_branch, true);
                        }
                    }
                    $scope.selected_branch = undefined;
                }

            }

            if(angular.isString($scope.itemToPosition)){
                var toPosiotionList = $scope.itemToPosition.split('->');
                
                var itemToPosition = $scope.treeData;

                toPosiotionList.forEach((element, index, array) => {
                  var branch;                  
                  if(itemToPosition) {
                    branch = ArrayUtils.find(itemToPosition, function(item){return item.descricao == element});
                  
                    if(branch){
                      itemToPosition = index == (array.length - 1) ? branch : branch.item;
                    }else{
                      itemToPosition = undefined;
                    }
                  }

                });
                
                if(itemToPosition){
                    $timeout(function(){                  
                        select_branch(itemToPosition, {programatically: true});
                    });
                }
              }

            function findElement(checkFn){
                return $scope.treeData.find(checkFn);
            }

            function selectAndOpen(fnOrRecord){
                let toSelect;

                if (angular.isFunction(fnOrRecord)) {
                    for_each_branch((branch, level) => {
                        if(fnOrRecord(branch)){
                            toSelect = branch;
                            return branch.expanded = true;
                        }
                    });
                } else {
                    var branch = arrayToTree([fnOrRecord], true);
                    if (branch) {
                        toSelect = branch[0];
                    }
                }

                if(toSelect){
                    _treeSelect = toSelect;
                    if($scope.selected_branch){
                        $scope.selected_branch.selected = false;
                        $scope.selected_branch = null;
                    }

                    $timeout(function () {
                        select_branch(toSelect);

                        $timeout(function () {
                            setSelectedItems(toSelect);
                        });
                    });
                }else {
                    console.warn('[SkTreeController.selectAndOpen] - Impossivél resolver a branch a ser selecionada.');
                }
            }

            function selectAndOpenByLabel(findLabel) {
                let branchMatched = undefined;
                let isFindAfterSelected = false;

                for_each_branch((branch, level) => {
                    if (!branchMatched) {
                        if ($scope.selected_branch) {
                            if (branch.uid === $scope.selected_branch.uid) {
                                isFindAfterSelected = true;
                            } else if (isFindAfterSelected) {
                                if (branch.label.toUpperCase().indexOf(findLabel.toUpperCase()) >= 0) {
                                    return branchMatched = branch;
                                }
                            }
                        } else if (branch.label.toUpperCase().indexOf(findLabel.toUpperCase()) >= 0) {
                            return branchMatched = branch;
                        }
                    }
                });

                if($scope.selected_branch){
                    $scope.selected_branch.selected = false;
                    $scope.selected_branch = null;
                }

                if(branchMatched){
                    $timeout(function () {
                        select_branch(branchMatched);
                    });
                } else {
                    selectAndOpenByLabel(findLabel);
                }
            }

            function loadTreeData(tree) {
                if (!tree) {
                    return [];
                }
                if (Array.isArray(tree)) {
                    const treeAux = tree.filter(item => angular.isDefined(item));
                    return treeAux.map(function (obj) {
                        return setItemTreeData(obj);
                    });
                }
                if (angular.isObject(tree)) {
                    return [setItemTreeData(tree)];
                }
                return [];
            }

            function setItemTreeData(obj) {
                if (angular.isDefined(obj) && obj[$scope.childrenCustomName]) {
                    obj[$scope.childrenCustomName] = loadTreeData(obj[$scope.childrenCustomName]);
                }
                return obj;
            }

            function setHierarchyConfig(config) {
                const newMask = angular.isDefined(config.mask) 
                    ? config.mask !== '' && config.mask.indexOf('#') === -1 
                    ? StringUtils.expandHierarchyMask(config.mask) 
                    : config.mask.indexOf('#') !== -1
                    ? config.mask 
                    : ''
                    : _hierarchyConfig.mask;
                _hierarchyConfig = {
                    ..._hierarchyConfig,
                    ...config,
                    mask: newMask
                };
            }

            function getHierarchyConfig() {
                return _hierarchyConfig;
            }

            function setSelectedIndex(index) {
                if (!isNaN(index)) {
                    for_each_branch(function(b) {
                        if (b.index === index) {
                            return $timeout(function() {
                                return select_branch(b, {programatically: true});
                            });
                        }
                    });
                }
            }

            function treeIsEmpty() {
                if (angular.isFunction($scope.tree_is_empty)) {
                    return $scope.tree_is_empty();
                }
                return true;
            }
            
            function getDescriptionCustom(row){
               if ($scope.labelWithIdentifier){
                    return row['maskedIdentifier'] + ' - ' + row['label'];
               }
               
               return row['label'];
            }
        }]);

/**
 * Created by cleverson.puche on 12/04/2016.
 */

 /**
 * @ngdoc directive
 * @name snk.components.tabnavigator.directive:sk-tree
 * @restrict E
 *
 * @description
 * Componente utilizado para apresentação de dados hierárquicos
 * 
 * @param {boolean} [sk-adv-search] Decide se o componente irá usar o serviço de busca hierarquica para retornar os resultados (em telas com muitos registros na arvore, pode demorar na pesquisa).
 * @param {function=} [sk-end-edit] função a ser chamada quando a edição de um item da apresentação for finalizada.
 * Essa recebe como parâmetros: 
 *    newValue: novo valor após a alteração.
 *    node: Uma referência para o nó que está sendo editado/adicionado.
 *    nodeDad: Uma referência para o nó pai do node que está sendo alterado/adicionado.
 *    operation: A operação que está sendo realizada, podendo ser 'edit', 'delete' ou 'insert'
 * É obrigatório sempre que essa função for utilizada essa deve atualizar os atributos node.label(concatenado com a chave), node.description,
 *
 *  @example
 *  <example module="appTree">
         <file name="appTree.html">
            <div ng-controller="TreeController as ctrl">
                <sk-tree id="arvoreCategoria" 
                        sk-tree-control="ctrl.treeCtrl" 
                        style="width: 140px; height: 140px; position: relative;"
                        class="container-absolute" 
                        sk-tree-data="ctrl.nodes" 
                        sk-on-select="ctrl.arvoreCategoriaChange" 
                        sk-on-toggle-or-expanded="ctrl.onToggleOrExpanded(row)" 
                        sk-hide-button-container="true" 
                        sk-drag-enabled="true" 
                        sk-drop-enabled="true" 
                        sk-drag-start
                        sk-drag-over
                        sk-drag-enter
                        sk-drag-exit
                        sk-drop="ctrl.dropList(event)"
                        ></sk-tree>
                <div ondrop="drop(event)" ondragover="allowDrop(event)" style="position: relative; border: 1px solid #ccc; margin-top: 15px";>
                    <div ondragstart="dragStart(event)" draggable="true" id="target">Arraste para cá !!</div>
                </div>
            </div>
         </file>
         <file name="appTree.js">
            angular
                .module('appTree', ['snk'])
                .controller('TreeController', TreeController);

                function TreeController($scope){

                    var self = this;

                    self.nodes = [
			                        {
			                        	"data":5,
			                            "label":"Example 1",
			                            "icon": toggleIcon,
			                            "children":[ 
			                                             {
			                                             	"data":6,
			                                               	"codGrupoPai":5,
			                                               	"label":"Example 5",
			                                               	"icon": toggleIcon
			                                             }
			                                       ]
			                         },
			                         {
			                         	"data":3,
			                          	"label":"Example 2",
			                          	"icon": toggleIcon
			                         },
			                         {
			                         	"data":4,
			                           	"label":"Example 3",
			                           	"icon": toggleIcon
			                         },
			                         {
			                         	"data":1,
			                           	"label":"Example 4",
			                           	"icon": toggleIcon
			                         }
			                     ];

			        function toggleIcon(item) {
				    	return item.branch.expanded ? 'folder-open' : 'folder-closed';
				    }

                    window.allowDrop = function(event){
                                        event.preventDefault();
                                    }
                                        
                    window.drop = function(event) {
	                                    event.preventDefault();
	                                    var data = event.dataTransfer.getData("items");
	                                    var parseData = JSON.parse(data);
	
	                                    var children = parseData.item[0].branch.children;
	
	                                    var element = document.getElementById(parseData.index);
	                                    event.target.appendChild(element.cloneNode(true));
	                                    
	                                    if(children.length > 0){
	                                    console.log('children > 0');
	                                    for(var i in children){
	                                        element = document.getElementById(children[i].uid);
	                                        event.target.appendChild(element.cloneNode(true));
	                                    }
                                    }
                                }
                }
         </file>
     </example>

 */
angular
    .module('snk.components.tree')
    .directive('skTree',['$timeout', function($timeout) {
        return {
            controller: 'SkTreeController',
            templateUrl: 'components/tree/tree.tpl.html',
            restrict: 'E',
            scope: {
                /** 
                 * Início - Lazy load
                */
                dataset: '<?skDataset',
                configName: '@?skConfigName',
                lazyLoad: '=?skLazyLoad',
                /** 
                 * Fim - Lazy load
                */
                treeApi: '=?skTreeApi',
                treeData: '=?skTreeData',
                dblClickForSelect: '=skDoubleClickForSelect',
                onSelect: '=skOnSelect',
                initialSelection: '@skInitialSelection',
                searchTerm: '=skSearchTerm',
                treeControl: '=?skTreeControl',
                dblClickFn: '=?skDblClickFn',
                childrenCustomName: '@?skChildrenCustomName',
                labelCustomName: '@?skLabelCustomName',
                endEdit: '=?skEndEdit',
                showCard: '=?skShowCard',
                hideButtonContainer: '=?skHideButtonContainer',
                showRemoveBtn: '=?skShowRemoveBtn',
                showEditBtn: '=?skShowEditBtn',
                heightTree:'@?skHeightTree',
                itemToPosition: '=?skItemToPosition',
                searchInput: '=skSearchInput',
                searchInputEnabled: '=?skSearchInputEnabled',
                acceptMultiSelect: '&?skAcceptMultiSelect',
                dropEnabled: "=?skDropEnabled",
                dragEnabled: "=?skDragEnabled",
                dragStart: "&?skDragStart",
                dragEnter: "&?skDragEnter",
                dragOver: "&?skDragOver",
                dragExit: "&?skDragExit",
                drop: "&?skDrop",
                dataTipFunction: "&?skDataTipFunction",
                tooltipPlacement: "@?skTooltipPlacement",
                componentCreated: '&?skComponentCreated',
                ignoreScrollTo: "=?skIgnoreScrollTo",
                finishRefreshedInterceptor: '=?skFinishRefreshedInterceptor',
                showTooltip: '=?skShowTooltip',
                treeReady: '&?skTreeReady',
				enableCbx: '=?skEnableCbx',
				selectOnMouseDown: '&?skSelectOnMouseDown',
                treeDataCreated: '=?skTreeDataCreated',
                searchTermInterceptor: '=?skSearchTermInterceptor',
                advSearch: '=?skAdvSearch',
                refreshDatasetToTree: '=?skRefreshDatasetToTree',
                labelWithIdentifier: '=?skLabelWithIdentifier',
                sortField: '@?skSortField'
            },
            link: function (scope, element, attrs) {

                scope.registerAddEventListenerElementSelecteds = [];
                
                if(scope.dropEnabled){
                    element.attr('draggable', true);
                    if(scope.drop){
                        element.on('drop', function (event) {
                            event.preventDefault();

                            if(angular.isFunction(scope.drop)){
                                scope.drop({event: event}); 
                            }
                        });
                    }

                    element.on('dragover', function (event) {
                        event.preventDefault();
                    });

                }
               
                scope.addEventsListenerInElement = function (event, rowId){

                	var elementSelected = element.find('.' + rowId);
                	 
                	if(elementSelected){
                		if(!(scope.registerAddEventListenerElementSelecteds.indexOf(elementSelected.attr('id')) > -1)){
                			if(scope.dragEnabled){

                                elementSelected.on('dragstart', function (event) {
                                	
                                	if(scope.acceptMultiSelect && scope.multiSelected.length > 1){
                                	
                                         var itens = scope.getSelectedItems();

                                         event.originalEvent.dataTransfer.setData('items', JSON.stringify({'items' : itens}));
                                	} else {
	                                    event.target.id = event.target.id || event.target.innerText;
	                                    
	                                    var items = [scope.rowsById[event.target.id]];
	                                    
                                        event.originalEvent.dataTransfer.setData('items', JSON.stringify({'items' : items}));
                                    }

                                    var treeId = element.attr('id');
                                    event.originalEvent.dataTransfer.setData('id', (treeId || ''));
                                    
                                    if(angular.isFunction(scope.dragStart)){
                                        scope.dragStart({event: event}); 
                                    }
                                });
                				
                				if(scope.dragEnter){
                					elementSelected.on('dragenter', function (event) {
                						if(angular.isFunction(scope.dragenter)){
                							scope.dragenter(event); 
                						}
                					});
                				}
                				
                				if(scope.dragEnd){
                					elementSelected.on('dragend', function (event) {
                						if(angular.isFunction(scope.dragend)){
                							scope.dragend(event); 
                						}
                					});
                				}
                				
                				if(scope.dragOver){
                					elementSelected.on('dragover', function (event) {
                						event.preventDefault();
                					});
                				}
                			}
                			
                			scope.registerAddEventListenerElementSelecteds.push(elementSelected.id);
                		}
                	} 
                }
            }
        };
    }]);

/**
 * Created by cleverson.puche on 25/10/2016.
 */
angular
    .module('snk.components.twolists')
    .controller('SkTwoListsController', ['$scope', '$attrs', '$element', 'ArrayUtils', 'i18n', 'SkApplication', 'StringUtils', 'ObjectUtils', 'AngularUtil', 'PopUpParameter', 'MessageUtils', '$timeout',
        function ($scope, $attrs, $element, ArrayUtils, i18n, SkApplication, StringUtils, ObjectUtils, AngularUtil, PopUpParameter, MessageUtils, $timeout) {
            var self = this;

            var _lastSrcSelected;
            var _lastDestSelected;

            $scope.SOURCE_LIST = 'srcList';
            $scope.DEST_LIST = 'destList';

            $scope.srcSelectedItems = [];
            $scope.destSelectedItems = [];
            
            $scope.srcData =  $scope.srcData || [];
            $scope.destData =  $scope.destData || [];
            
            $scope.treeCtrl = $scope.treeCtrl || {};

            $scope.childrenCustomName = $scope.childrenCustomName || 'children'
            $scope.labelCustomName = $scope.labelCustomName || 'label';

            $scope.selectItem = selectItem;
            $scope.moveInBatch = moveInBatch;
            $scope.moveItem = moveItem;
            $scope.hasSomeSrcItem = hasSomeSrcItem;
            $scope.hasSomeDestItem = hasSomeDestItem;
            $scope.hasSomeSrcItemSelected = hasSomeSrcItemSelected;
            $scope.hasSomeDestItemSelected = hasSomeDestItemSelected;
            $scope.changeOrder = changeOrder;
            $scope.isFirstItemSelected = isFirstItemSelected;
            $scope.isLastItemSelected = isLastItemSelected;
            $scope.filterFn = filterFn;
            $scope.onDestSearchKeyDown = onDestSearchKeyDown;
            $scope.onSelectTreeNode = onSelectTreeNode;
            $scope.isItemSelected = isItemSelected;
            $scope.dblClickInTreeHandler = dblClickInTreeHandler;
            $scope.showPopupMoveTo = showPopupMoveTo;
            $scope.hasMoreThanTwoItem = hasMoreThanTwoItem;

            init();
            function init() {
                $element.attr('layout', 'column');

                if (angular.isDefined($attrs['skSrcTitle'])) {
                    $scope.srcTitle = i18n($attrs['skSrcTitle']);
                }

                if (angular.isDefined($attrs['skDestTitle'])) {
                    $scope.destTitle = i18n($attrs['skDestTitle']);
                }

                var controllerInfo = AngularUtil.getContextControllerInfo($element);
                var controllerAs = ObjectUtils.getProperty(controllerInfo, 'controllerAs');
                if (controllerAs) {
                    $scope[controllerAs] = controllerInfo.controllerInstance;
                }

                $scope.$watch('destSearchTerm', function (newValue) {
                    onDestSearchTermChange(newValue);
                });

                $scope.srcData = $scope.srcData || [];
                $scope.destData = $scope.destData || [];

                if (angular.isDefined($scope.srcData) && !angular.isArray($scope.srcData)) {
                    $scope.srcData = [$scope.srcData];
                }

                if (angular.isDefined($scope.destData) && !angular.isArray($scope.destData)) {
                    $scope.destData = [$scope.destData];
                }

                if ($scope.treeMode) {
                    $scope.destData.forEach(function (item) {
                        item.skID = StringUtils.nextUid();
                    });
                }

                $scope.$watch('srcData', function(newV, oldV) {
                    if (newV !== oldV) {
                        unselectAllItems($scope.SOURCE_LIST);

                        if (newV && newV.length > 0) {
                            selectItem(newV[0], $scope.SOURCE_LIST);
                        }
                    }
                    if (angular.isUndefined($scope.srcData)) {
                        $scope.srcData = []
                    } else if (!angular.isArray($scope.srcData)) {
                        $scope.srcData = [$scope.srcData];
                    }
                });

                $scope.$watch('destData', function(newV, oldV) {
                    if (newV !== oldV) {
                        unselectAllItems($scope.DEST_LIST);

                        if (newV && newV.length > 0) {
                            selectItem(newV[0], $scope.DEST_LIST);
                        }
                    }
                    if (angular.isUndefined($scope.destData)) {
                        $scope.destData = []
                    } else if (!angular.isArray($scope.destData)) {
                        $scope.destData = [$scope.destData];
                    }
                });

                $scope.sortableConfigForSrcList = getSortableConfiguration($scope.SOURCE_LIST);
                $scope.sortableConfigForDestList = getSortableConfiguration($scope.DEST_LIST);
            }

            function selectItem(item, listName, $event) {
                if ($scope.treeMode && listName == $scope.SOURCE_LIST) {
                    unselectAllItems(listName);
                    var selectedItem = $scope.treeCtrl.get_selected_branch();
                    $scope.srcSelectedItems.push(selectedItem);
                    _lastSrcSelected = selectedItem;
                    notifyChange(listName);
                    return;
                }

                if ($event && !$event.ctrlKey && !$event.shiftKey) {
                    unselectAllItems(listName);

                    if (listName == $scope.SOURCE_LIST) {
                        $scope.srcSelectedItems.push(item);
                        _lastSrcSelected = item;
                    } else if (listName == $scope.DEST_LIST) {
                        $scope.destSelectedItems.push(item);
                        _lastDestSelected = item;
                    }
                } else if ($event && $event.shiftKey) {
                    var lastSelectedIndex;
                    var currentIndex;

                    if (listName == $scope.SOURCE_LIST) {
                        lastSelectedIndex = $scope.srcData.indexOf(_lastSrcSelected);
                        currentIndex = $scope.srcData.indexOf(item);
                        _lastSrcSelected = item;

                        if (lastSelectedIndex < currentIndex) {
                            for (var i = lastSelectedIndex; i <= currentIndex; i++) {
                                $scope.srcSelectedItems.push($scope.srcData[i]);
                            }
                        } else {
                            for (var i = lastSelectedIndex; i >= currentIndex; i--) {
                                $scope.srcSelectedItems.push($scope.srcData[i]);
                            }
                        }
                    } else if (listName == $scope.DEST_LIST) {
                        lastSelectedIndex = $scope.destData.indexOf(_lastDestSelected);
                        currentIndex = $scope.destData.indexOf(item);
                        _lastDestSelected = item;

                        if (lastSelectedIndex < currentIndex) {
                            for (var i = lastSelectedIndex; i <= currentIndex; i++) {
                                $scope.destSelectedItems.push($scope.destData[i]);
                            }
                        } else {
                            for (var i = lastSelectedIndex; i >= currentIndex; i--) {
                                $scope.destSelectedItems.push($scope.destData[i]);
                            }
                        }
                    }
                } else {
                    if (listName == $scope.SOURCE_LIST) {
                        if ($scope.srcSelectedItems.indexOf(item) < 0) {
                            $scope.srcSelectedItems.push(item);
                            _lastSrcSelected = item;
                        } else {
                            ArrayUtils.removeReference($scope.srcSelectedItems, item);
                        }
                    } else if (listName == $scope.DEST_LIST) {
                        if ($scope.destSelectedItems.indexOf(item) < 0) {
                            $scope.destSelectedItems.push(item);
                            _lastDestSelected = item;
                        } else {
                            ArrayUtils.removeReference($scope.destSelectedItems, item);
                        }
                    }
                }

                notifyChange(listName);
            }

            function externalOnMoveItem(item, listName) {
                if (angular.isFunction($scope.onMoveItem)) {
                    $scope.onMoveItem({ item: item, listName: listName });
                }
            }

            function externalOnSortItem(item, listName) {
                if (angular.isFunction($scope.onSortItem)) {
                    $scope.onSortItem({ item: item, listName: listName });
                }
            }

            function unselectAllItems(listName) {
                if (listName == $scope.SOURCE_LIST) {
                    $scope.srcSelectedItems.length = 0;
                } else if (listName == $scope.DEST_LIST) {
                    $scope.destSelectedItems.length = 0;
                }
            }

            function getSortableConfiguration(list) {
                var sortableConfig = {
                    group: 'twoLists',
                    handle: ".handlable",
                    sort: true,

                    onUpdate: function (event) {
                        externalOnSortItem(event.model, list);
                    },
                    onEnd: function(){
                        externalOnMoveItem(event.model, list);
                    }
                };

                return sortableConfig;
            }

            function moveInBatch(srcListName, destListName, moveAll) {
            	if (srcListName == $scope.SOURCE_LIST && _lastSrcSelected && $scope.handleOnlyAnalytics) {
            		moveIfNecessary(_lastSrcSelected, $scope.SOURCE_LIST, false, true);
            		return;
            	}
            	
                var list;
                var selectedList;

                if (srcListName == $scope.SOURCE_LIST) {
                    list = angular.copy($scope.srcData);
                    selectedList = $scope.srcSelectedItems;

                    if (list) {
                        list = list.filter(filterFn);
                    }
                } else if (srcListName == $scope.DEST_LIST) {
                    list = angular.copy($scope.destData);
                    selectedList = $scope.destSelectedItems;
                }

                if (angular.isArray(list)) {
                    list.forEach(function (item) {
                        moveIfNecessary(item, srcListName, moveAll);
                    });

                    selectNextItem(srcListName);
                }
            }

            function moveIfNecessary(item, srcListName, moveAll, moveOnlyAnalytics) {
                if (angular.isUndefined(item) || item == null) {
                    return;
                }

                if (angular.isArray(item[$scope.childrenCustomName])) {
                    item[$scope.childrenCustomName].forEach(function (child) {
                        moveIfNecessary(child, srcListName, moveAll, moveOnlyAnalytics);
                    });
                }

                if (moveAll || moveOnlyAnalytics || isItemSelected(srcListName, item)) {
                    moveItem(item, srcListName);
                }
            }

            function isItemSelected(listName, item) {
                var selectedList = getSelectedListByListName(listName);

                if (!$scope.treeMode) {
                    return angular.isDefined(ArrayUtils.find(selectedList, function (listItem) {
                        var itemFound = ObjectUtils.equals(listItem, item)
                        if(itemFound){
                            if(item.CP && document.querySelector(`#item_${item.CP}`)){
                                document.querySelector(`#item_${item.CP}`).scrollIntoView();
                            }
                            return ObjectUtils.equals(listItem, item);
                        }
                    }));
                }

                for (var i = 0; i < selectedList.length; i++) {
                    if ((angular.isDefined(item.uid) && selectedList[i] != null && selectedList[i].uid === item.uid)
                        || (angular.isUndefined(item.uid) && item.skID === selectedList[i].skID)) {
                        return true;
                    }
                }

                return false;
            }

            function moveItem(item, srcListName) {
            
                if($scope?.disableDblClick){
                    return;
                }
                
                if ($scope.treeMode && srcListName == $scope.SOURCE_LIST && $scope.handleOnlyAnalytics) {
                	var children = $scope.treeCtrl.get_children(item);
                	if (children && children.length > 0) {
                		return;
                	}
                }

                if (srcListName == $scope.SOURCE_LIST && $scope.moveToRight !== false) {
                    doMoveItem($scope.srcData, $scope.destData, item);
                } else if (srcListName == $scope.DEST_LIST && $scope.moveToLeft !== false) {
                    unselectAllItems($scope.SOURCE_LIST);
                    doMoveItem($scope.destData, $scope.srcData, item);
                }

                externalOnMoveItem(item, srcListName);
                
                return true;
            }

            function doMoveItem(srcList, destList, item) {
                if (!$scope.treeMode) {
                    ArrayUtils.removeReference(srcList, item, true);
                    if (destList.indexOf(item) < 0) {
                        destList.push(item);
                    }
                } else {
                    if (destList == $scope.destData) {
                        for (var i = 0; i < destList.length; i++) {
                            if ((angular.isDefined(item.uid) && destList[i].uid === item.uid)
                                || (angular.isUndefined(item.uid) && item.skID === destList[i].skID)) {
                                return;
                            }
                        }

                        destList.push(item);
                        selectNextItem(srcList == $scope.srcData ? $scope.SOURCE_LIST : $scope.DEST_LIST);
                    } else if (destList == $scope.srcData) {
                        for (var i = 0; i < srcList.length; i++) {
                            if ((angular.isDefined(item.uid) && srcList[i].uid === item.uid)
                                || (angular.isUndefined(item.uid) && item.skID === srcList[i].skID)) {
                                selectNextItem(srcList == $scope.srcData ? $scope.SOURCE_LIST : $scope.DEST_LIST);
                                srcList.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
            }

            function hasSomeSrcItem() {
                return $scope.srcData.length > 0 && ($scope.disableAllToRight !== undefined ? $scope.disableAllToRight : true);
            }

            function hasSomeDestItem() {
                return $scope.destData.length > 0 && ($scope.disableAllToLeft !== undefined ? $scope.disableAllToLeft : true);
                
            }

            function hasSomeSrcItemSelected() {
                return $scope.srcSelectedItems.length > 0 && ($scope.disableToRight !== undefined ? $scope.disableToRight : true);
                
            }

            function hasSomeDestItemSelected() {
                return $scope.destSelectedItems.length > 0 && ($scope.disableToLeft !== undefined ? $scope.disableToLeft : true);
                
            }

            function isFirstItemSelected(listName) {
                var list = getListByListName(listName);
                var selectedList = getSelectedListByListName(listName);

                if (!$scope.treeMode) {
                    if (selectedList.indexOf(list[0]) > -1) {
                        return true;
                    }
                } else {
                    if (!list[0]) {
                        return false;
                    }

                    for (var i = 0; i < selectedList.length; i++) {
                        if ((angular.isDefined(list[0].uid) && selectedList[i].uid == list[0].uid)
                            || (angular.isUndefined(list[0].uid) && selectedList[i].skID == list[0].skID)) {
                            return true;
                        }
                    }
                }

                return false;
            }

            function isLastItemSelected(listName) {
                var list = getListByListName(listName);
                var selectedList = getSelectedListByListName(listName);

               if (!$scope.treeMode) {
                    if (selectedList.indexOf(list[list.length - 1]) > -1) {
                        return true;
                    }
                } else {
                    if (!list[list.length - 1]) {
                        return false;
                    }

                    for (var i = 0; i < selectedList.length; i++) {
                        if ((angular.isDefined(list[list.length - 1].uid) && selectedList[i].uid == list[list.length - 1].uid)
                            || (angular.isUndefined(list[list.length - 1].uid) && selectedList[i].skID == list[list.length - 1].skID)) {
                            return true;
                        }
                    }
                }

                return false;
            }

            function changeOrder(direction, moveAll) {
                //Apenas a lista de destino suporta ordenação através de botões.
                if (direction == 'up') {
                    if (moveAll) {
                        while (!isFirstItemSelected($scope.DEST_LIST)) {
                            moveUp($scope.DEST_LIST);
                        }
                    } else {
                        moveUp($scope.DEST_LIST);
                    }
                } else if (direction == 'down') {
                    if (moveAll) {
                        while (!isLastItemSelected($scope.DEST_LIST)) {
                            moveDown($scope.DEST_LIST);
                        }
                    } else {
                        moveDown($scope.DEST_LIST);
                    }
                }
            }

            function moveUp(listName) {
                var list = getListByListName(listName);
                var selectedList = getSelectedListByListName(listName);

                for (var i = 1; i < list.length; i++) {
                    var item = list[i];
                    var selectedItemIndex = list.indexOf(item);

                    if (isItemSelected(listName, item)) {
                        changeItems(list[selectedItemIndex - 1], item, listName);

                        externalOnSortItem(item, listName);
                    }
                }
            }

            function moveDown(listName) {
                var list = getListByListName(listName);
                var selectedList = getSelectedListByListName(listName);

                for (var i = list.length - 2; i >= 0; i--) {
                    var item = list[i];
                    var selectedItemIndex = list.indexOf(item);

                    if (isItemSelected(listName, item)) {
                        changeItems(list[selectedItemIndex + 1], item, listName);

                        externalOnSortItem(item, listName);
                    }
                }
            }

            function changeItems(item1, item2, listName) {
                var list = getListByListName(listName);

                if (list) {
                    var item1Index = list.indexOf(item1);
                    var item2Index = list.indexOf(item2);

                    list[item1Index] = item2;
                    list[item2Index] = item1;
                }
            }

            function getListByListName(listName) {
                if (listName == $scope.SOURCE_LIST) {
                    return $scope.srcData;
                }

                if (listName == $scope.DEST_LIST) {
                    return $scope.destData;
                }

                return undefined;
            }

            function getSelectedListByListName(listName) {
                if (listName == $scope.SOURCE_LIST) {
                    return $scope.srcSelectedItems;
                }

                if (listName == $scope.DEST_LIST) {
                    return $scope.destSelectedItems;
                }

                return undefined;
            }

            function filterFn(item) {
                if (StringUtils.isEmpty($scope.srcSearchTerm)) {
                    return true;
                }

                if (angular.isFunction($scope.srcFilterFn)) {
                    return $scope.srcFilterFn({ item: item, searchTerm: $scope.srcSearchTerm });
                }

                var label = item;

                if (angular.isObject(label)) {
                    label = label[$scope.labelCustomName];

                    var containsRE = new RegExp(StringUtils.replaceAccentuatedChars($scope.srcSearchTerm), 'i');

                    if (angular.isString(label)) {
                        label = StringUtils.replaceAccentuatedChars(label);
                        return containsRE.test(label);
                    } else {
                        for (var key in item) {
                            label = item[key];
                            label = StringUtils.replaceAccentuatedChars(label);

                            if (containsRE.test(label)) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            }

            function onDestSearchTermChange(searchTerm) {
                unselectAllItems($scope.DEST_LIST);

                if (StringUtils.isEmpty(searchTerm)) {
                    return;
                }

                for (var i = 0; i < $scope.destData.length; i++) {
                    var item = $scope.destData[i];

                    if (angular.isFunction($scope.destFilterFn)) {
                        if ($scope.destFilterFn({ item: item, searchTerm: searchTerm })) {
                            _lastDestSelected = item;
                            $scope.destSelectedItems.push(item);
                            selectItem(item, $scope.DEST_LIST, event);                         
                            return;
                        }
                    } else {
                        var label = item;

                        if (angular.isObject(label)) {
                            label = label[$scope.labelCustomName];

                            var containsRE = new RegExp(StringUtils.replaceAccentuatedChars(searchTerm), 'i');

                            if (angular.isString(label)) {
                                label = StringUtils.replaceAccentuatedChars(label);
                                return containsRE.test(label);
                            } else {
                                for (var key in item) {
                                    label = item[key];
                                    label = StringUtils.replaceAccentuatedChars(label);

                                    if (containsRE.test(label)) {
                                        _lastDestSelected = item;
                                        $scope.destSelectedItems.push(item);
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            function onDestSearchKeyDown(event) {
                if (event.keyCode == 13) {
                    searchNextItem($scope.DEST_LIST, $scope.destSearchTerm);
                }
            }
            
            function findInTree(list, toFind) {
            	if (!list || !toFind) {
            		return undefined;
            	}
            	
            	var i;
            	var found;
            	
        		for (i = 0; i < list.length; i++) {
        			var listItem = list[i];
        			
        			if ((angular.isDefined(listItem.uid) && listItem.uid == toFind.uid) || (angular.isUndefined(listItem.uid) && listItem.skID == toFind.skID)) {
        				found = listItem;
        				break;
                    }
        			
        			if (angular.isArray(listItem[$scope.childrenCustomName])) {
        				found = findInTree(listItem[$scope.childrenCustomName], toFind);
        				
        				if (found) {
        					break;
        				}
        			}
        		}
        		
        		if (found) {
        			if (found.list) { //Para que o retorno não seja recursivo
            			return found;
            		} else {
            			return {
        					list: list,
        					item: found,
        					index: i
        				};
            		}
        		}
        		
        		return undefined;
        	}

            function selectNextItem(listName) {
                var list = getListByListName(listName);
                var selectedList = getSelectedListByListName(listName);
                var lastSelectedItem = listName == $scope.SOURCE_LIST ? _lastSrcSelected : _lastDestSelected;
                
                var treeSearchResult;
                var lastSelectedIndex = -1;

                if (!$scope.treeMode) {
                    lastSelectedIndex = list.indexOf(lastSelectedItem);
                } else if (lastSelectedItem) {
                	treeSearchResult = findInTree(list, lastSelectedItem); 
                }

                unselectAllItems(listName);

                AngularUtil.timeout(function () {
                	if ($scope.treeMode && treeSearchResult) {
                		list = treeSearchResult.list;
                		lastSelectedIndex = treeSearchResult.index;
                	}
                	
                    if (list[lastSelectedIndex]) {
                        selectedList.push(list[lastSelectedIndex]);
                        if (listName == $scope.SOURCE_LIST) {
                            _lastSrcSelected = list[lastSelectedIndex];
                        } else if (listName == $scope.DEST_LIST) {
                            _lastDestSelected = list[lastSelectedIndex];
                        }
                    } else if (list[lastSelectedIndex - 1]) {
                        selectedList.push(list[lastSelectedIndex - 1]);
                        if (listName == $scope.SOURCE_LIST) {
                            _lastSrcSelected = list[lastSelectedIndex - 1];
                        } else if (listName == $scope.DEST_LIST) {
                            _lastDestSelected = list[lastSelectedIndex - 1];
                        }
                    }
                }, 0, true);
            }

            function searchNextItem(listName, searchTerm) {
                var list = getListByListName(listName);
                var selectedList = getSelectedListByListName(listName);
                var containsRE = new RegExp(StringUtils.replaceAccentuatedChars(searchTerm), 'i');
                var lastSelectedIndex = -1;
                var i = 0;
                var j = 0;

                //Por enquanto, apenas a lista destino possui essa funcionalidade.
                if (listName == $scope.DEST_LIST && _lastDestSelected) {
                    if (!$scope.treeMode) {
                        lastSelectedIndex = list.indexOf(_lastDestSelected);
                    } else {
                        for (i = 0; i < list.length; i++) {
                            if ((angular.isDefined(list[i].uid) && list[i].uid === _lastDestSelected.uid)
                                || (angular.isUndefined(list[i].uid) && list[i].skID === _lastDestSelected.skID)) {
                                lastSelectedIndex = i;
                                break;
                            }
                        }
                    }
                }

                if (lastSelectedIndex + 1 >= list.length) {
                    j = 0;
                } else {
                    j = lastSelectedIndex + 1;
                }

                while (j < list.length) {
                    if (j == lastSelectedIndex) {
                        return;
                    }

                    if (angular.isFunction($scope.destFilterFn)) {
                        if ($scope.destFilterFn({ item: list[j], searchTerm: searchTerm })) {
                            unselectAllItems($scope.DEST_LIST);
                            _lastDestSelected = list[j];
                            $scope.destSelectedItems.push(list[j]);
                            
                            if(angular.isArray(selectedList)){
                                var elementSelected = document.getElementById("item_" + (selectedList[0].CP || selectedList[0].field));
                                if(angular.isDefined(elementSelected) && angular.isDefined($scope.DEST_LIST)){
                                    selectItem(selectedList[0], $scope.DEST_LIST, event);
                                    elementSelected.scrollIntoView();
                                }
                            }

                            return;
                        }
                    } else if (containsRE.test(StringUtils.replaceAccentuatedChars(list[j][$scope.labelCustomName]))) {
                        unselectAllItems($scope.DEST_LIST);
                        _lastDestSelected = list[j];
                        $scope.destSelectedItems.push(list[j]);
                        return;
                    }

                    if (j + 1 == list.length && lastSelectedIndex > -1) {
                        j = 0;
                    } else {
                        j++;
                    }
                }
            }

            function onSelectTreeNode(object) {
                if (object) {
                    selectItem(object, $scope.SOURCE_LIST);
                }
            }

            function dblClickInTreeHandler(branch) {
            	if ($scope.handleOnlyAnalytics) {
                	moveIfNecessary(branch, $scope.SOURCE_LIST, false, true);
            	} else {
            		moveInBatch($scope.SOURCE_LIST, $scope.DEST_LIST);
            	}
            }

            function showPopupMoveTo() {
                var selectedItem = getSelectedListByListName($scope.DEST_LIST)[0];
                var positionItem = 1 + getListByListName($scope.DEST_LIST).indexOf(selectedItem);

                PopUpParameter.builder()
                    .title('Core.SequenciaDeVisita.titMoverItem')
                    .size('alert')
                    .buildIntegerParameter('ROWPOSITION', i18n('Core.SequenciaDeVisita.informePosicaoItemselecionado'), true, positionItem)
                    .option('okLabel', 'Core.SequenciaDeVisita.btnReordenar')
                    .show().result
                    .then(function (result) {
                        moveTo(result.ROWPOSITION);
                    });
            }

            function moveTo(novaOrdem) {
                var selectedItem = getSelectedListByListName($scope.DEST_LIST)[0];
                var positionItem = getListByListName($scope.DEST_LIST).indexOf(selectedItem);

                if (novaOrdem < 1) {
                    MessageUtils.showAlert(i18n('Core.SequenciaDeVisita.escolhaPosicao', [$scope.destData.length]));
                } else {
                    novaOrdem--;
                    if (positionItem != novaOrdem) {
                        ArrayUtils.removeReference($scope.destData, selectedItem);
                        ArrayUtils.insertAtIndex($scope.destData, novaOrdem, selectedItem);
                        externalOnSortItem(selectedItem, $scope.DEST_LIST);
                    }
                }
            }
            
            function hasMoreThanTwoItem(listName) {
                return getListByListName(listName).length > 1;
            }

            function notifyChange(list){
                if($scope.onSelectionChanged){
                    const selected = list == 'destList' ? $scope.destSelectedItems : $scope.srcSelectedItems;
                    $scope.onSelectionChanged({selection: selected, list: list});
                }
            }
        }
    ]);
/**
 * Created by cleverson.puche on 25/10/2016.
 */

/**
 * @ngdoc directive
 * @name snk.components.twolists.directive:sk-two-lists
 * @restrict E
 * @scope
 * @description
 TwoLists é o componente utilizado quando se precisa manipular duas listas.<br/>
 Exemplo: itens classificados e itens a classificar, itens disponíveis e itens escolhidos, etc.

 * @param {string} sk-src-title Título da lista origem (à <b>esquerda</b>).
 * @param {string} sk-dest-title Título da lista destino (à <b>direita</b>).
 * @param {array} sk-src-data Array contendo os dados que serão apresentados na lista origem (à <b>esquerda</b>).
 * @param {array} sk-dest-data Array contendo os dados que serão apresentados na lista destino (à <b>direita</b>).
 * @param {boolean} sk-move-all-to-right Liga ou desliga a funcionalidade de mover todos os itens da <b>esquerda para a direita</b>.
 * @param {boolean} sk-move-to-right Liga ou desliga a funcionalidade de mover os itens selecionados <b>da esquerda para a direita</b>.
 * @param {boolean} sk-move-to-left Liga ou desliga a funcionalidade de mover os itens selecionados <b>da direita para a esquerda</b>.
 * @param {boolean} sk-move-all-to-left Liga ou desliga a funcionalidade de mover todos os itens <b>da direita para a esquerda</b>.
 * @param {boolean} sk-disable-all-to-right Habilita ou desabilita a funcionalidade de mover todos os itens da <b>esquerda para a direita</b>.
 * @param {boolean} sk-disable-to-right Habilita ou desabilita a funcionalidade de mover os itens selecionados <b>da esquerda para a direita</b>.
 * @param {boolean} sk-disable-to-left Habilita ou desabilita a funcionalidade de mover os itens selecionados <b>da direita para a esquerda</b>.
 * @param {boolean} sk-disable-all-to-left Habilita ou desabilita a funcionalidade de mover todos os itens <b>da direita para a esquerda</b>.
 * @param {boolean} sk-enable-sort Permite desabilitar os botões de ordenação à direita da lista destino.
 * @param {function} sk-src-filter-fn Função a ser invocada quando ocorrer um filtro na lista da <b>esquerda</b>. Recebe o item e o termo de pesquisa como parâmetros e deve retornar true ou false.
 * @param {function} sk-dest-filter-fn Função a ser invocada quando ocorrer um filtro na lista da <b>direita</b>. Recebe o item e o termo de pesquisa como parâmetros e deve retornar true ou false.
 * @param {boolean} sk-tree-mode Liga ou desliga o modo àrvore para a lista da <b>esquerda</b>.
 * @param {object} sk-tree-ctrl Objeto através do qual serão disponibilizadas várias funções para manipulação da àrvore.
 * @param {boolean} sk-handle-only-analytics Essa opção permite que apenas os itens analíticos sejam manipulados (transferidos) de uma lista para outra.
 * @param {function} sk-on-move-item Função invocada quando um item é movido de uma lista para outra. Recebe como argumento o item e o nome da lista, respectivamente.
 * @param {boolean} sk-move-position Essa opção permite escolher a posição que deseja mover o item por default false.
 * @param {boolean} sk-dest-show-search Essa opção permite ocultar a opção de pesquisa da lista default true mostar.
 * @param {element} sk-src-right-container Template que será inserido à direita do campo da pesquisa da lista da <b>esquerda</b>.
 * @param {element} sk-dest-right-container Template que será inserido à direita do campo da pesquisa da lista da <b>direita</b>.
 * @param {element} sk-src-item-tpl Template para renderização de cada item da lista da <b>esquerda</b>. Pode-se usar o objeto <i>item</i>.
 * @param {element} sk-dest-item-tpl Template para renderização de cada item da lista da <b>direita</b>. Pode-se usar o objeto <i>item</i>.
 *
 * @example
 <example module="app">
     <file name="exemplo.html">
        <sk-application ng-controller="MyController as ctrl" layout="column" flex style="height:900px;width:100%">
            <!-- normal-mode -->
            <sk-two-lists
                sk-src-title="A Classificar..."
                sk-dest-title="Classificados..."
                sk-src-data="ctrl.srcData"
                sk-dest-data="ctrl.destData"
                sk-src-filter-fn="ctrl.srcFilterFn(item, searchTerm)"
                sk-dest-filter-fn="ctrl.destFilterFn(item, searchTerm)"
                sk-on-move-item="ctrl.onMoveItem(item, listName)"
                flex >
                <sk-src-item-tpl>
                    <div>Nome     : {{item.nome}}</div>
                    <div>Sobrenome: {{item.sobrenome}}</div>
                </sk-src-item-tpl>
                <sk-dest-item-tpl>
                    {{ctrl.destItemFn(item)}}
                </sk-dest-item-tpl>
            </sk-two-lists>

            <div style="margin-top: 20px; border: 1px solid #CCC; width:100%"></div>

            <!-- tree-mode -->
            <sk-two-lists
                sk-src-title="Árvore"
                sk-dest-title="Lista"
                sk-src-data="ctrl.srcTreeData"
                sk-tree-mode="true"
                sk-tree-ctrl="ctrl.treeCtrl"
                sk-on-select-item="ctrl.onSelectItem"
                style="margin-top: 20px;"
                flex>
                 <sk-dest-item-tpl>
                    {{ctrl.treeDestItemFn(item)}}
                 </sk-dest-item-tpl>
            </sk-two-lists>
         </sk-application>
     </file>
     <file name="app.js">
         angular
         .module('app', ['snk'])
         .controller('MyController', function($scope, StringUtils){
                var self = this;

                //Data for normal-mode
                self.srcData = [
                    {
                        nome: 'Cleverson',
                        sobrenome: 'Puche'
                    },
                    {
                        nome: 'João',
                        sobrenome: 'Silva'
                    },
                    {
                        nome: 'Maria',
                        sobrenome: 'Júlia'
                    }
                ];

                self.destData = [];

                self.destItemFn = destItemFn;

                self.srcFilterFn = srcFilterFn;
                self.destFilterFn = destFilterFn;

                self.onMoveItem = onMoveItem;

                self.treeDestItemFn = treeDestItemFn;

                //Data for tree-mode
                self.treeCtrl = new Object();

                self.srcTreeData = [
                    {
                        label: 'Item 1',
                        data: 'I01'
                    },
                    {
                        label: 'Item 2',
                        data: 'I02',
                        children: [
                            {
                                label: 'Item 2.1',
                                description: 'NOV',
                                data: 'I021'
                            }

                        ]
                    }
                ];

                function onMoveItem(item, listName) {
                    console.log('Item: ', item, ' ListName: ', listName);
                }

                function destItemFn(item) {
                    return item.sobrenome + ', ' + item.nome;
                }

                function srcFilterFn(item, searchTerm) {
                    return basicSearch(item, searchTerm);
                }

                function destFilterFn(item, searchTerm) {
                    return basicSearch(item, searchTerm);
                }

                function basicSearch(item, searchTerm) {
                    if(StringUtils.isEmpty(searchTerm)) {
                        return true;
                    }

                    var containsRE = new RegExp(searchTerm,'i');

                    var match = containsRE.test(item.nome) || containsRE.test(item.sobrenome);
                    return match;
                }

                function treeDestItemFn(item) {
                    var itemDescr = item.label;
                    var parentBranch = self.treeCtrl.get_parent_branch(item);

                    if(parentBranch) {
                        itemDescr = parentBranch.label + ' -> ' + itemDescr;
                    }
                    return itemDescr;
                }
            });
         </file>
 </example>
**/
angular
    .module('snk.components.twolists')
    .directive('skTwoLists',[
       function() {
           return {
               restrict: 'E',
               templateUrl: 'components/twolists/twolists.tpl.html',
               controller: 'SkTwoListsController',
               transclude: {
                   srcRightContainer: '?skSrcRightContainer',
                   destRightContainer: '?skDestRightContainer',
                   srcItemTpl: '?skSrcItemTpl',
                   destItemTpl: '?skDestItemTpl'
               },
               scope: {
                   srcData: '=?skSrcData',
                   destData: '=?skDestData',
                   moveAllToRight: '=?skMoveAllToRight',
                   moveToRight: '=?skMoveToRight',
                   moveToLeft: '=?skMoveToLeft',
                   moveAllToLeft: '=?skMoveAllToLeft',
                   disableAllToRight: '=?skDisableAllToRight',
                   disableToRight: '=?skDisableToRight',
                   disableToLeft: '=?skDisableToLeft',
                   disableAllToLeft: '=?skDisableAllToLeft',
                   enableSort: '=?skEnableSort',
                   srcFilterFn: '&?skSrcFilterFn',
                   destFilterFn: '&?skDestFilterFn',
                   treeMode: '=?skTreeMode',
                   treeCtrl: '=?skTreeCtrl',
                   handleOnlyAnalytics: '=?skHandleOnlyAnalytics',
                   onMoveItem: '&?skOnMoveItem',
                   onSortItem: '&?skOnSortItem',
                   childrenCustomName: '@?skChildrenCustomName',
                   labelCustomName: '@?skLabelCustomName',
                   movePosition: '=?skMovePosition',
                   onSelectionChanged:'&?skOnSelectionChanged',
                   disableDblClick: '=?skDisableDblClick'
               }
           }
       }
    ]);
angular
    .module('snk.components.viewstack')
    .controller('SkViewstackController', ['$scope', '$element', '$timeout', 'SwipeUtil', 'AngularUtil', function ($scope, $element, $timeout, SwipeUtil, AngularUtil) {
        var CREATION_POLICY = {
            'ALL': 'all',
            'AUTO': 'auto'
        };

        var defaults = {
            selectedIndex: 0,
            creationPolicy: CREATION_POLICY.AUTO
        };

        var ctrl = this;

        ctrl.index = 0;
        ctrl.addPanel = addPanel; //retorna novo index do pai
        ctrl.removePanel = removePanel;
        ctrl.getSelectedIndex = getSelectedIndex;
        ctrl.registerSwipes = registerSwipes;
        ctrl.refreshIndex = refreshIndex;
        ctrl.updateViewstacksOpened = updateViewstacksOpened;
        ctrl.getScopeId = getScopeId;

        $scope.creationPolicy = $scope.creationPolicy || defaults.creationPolicy;
        $scope.selectedIndex = $scope.selectedIndex || defaults.selectedIndex;
        $scope.onSelect = $scope.onSelect || angular.noop;
        $scope.viewstacks = [];

        $scope.$watch('selectedIndex', function (newValue, oldValue) {
            updateSelectedIndex(newValue, oldValue);
        });

        function updateSelectedIndex(newValue, oldValue){
            if (newValue > -1 && $scope.viewstacks[newValue]){
                createContentIfNotCreated(newValue);
                updateViewstacksOpened(newValue);
                $scope.onSelect(newValue);
                $scope.$broadcast('uiGridRecalculate');
            }
        }

        function createContentIfNotCreated(index){
            if (index > -1 && $scope.viewstacks[index] && !$scope.viewstacks[index].create) {
                $scope.viewstacks[index].create = true;
            }
        }

        var deRegWatch = $scope.$watch('contentList', function(newValue){
            if (newValue){
                $scope.$watchCollection('contentList', function(newValue){
                    if (newValue){
                        $timeout(function(){
                            syncDomAndList();
                        });
                    }
                });

                deRegWatch();
            }

        });

        function syncDomAndList() {
            if ($element.children().length == 0) {
                return;
            }

            var domChilds = [];

            $element.children().each(function(index, value){
                domChilds.push(value);
            });

            var childs = $scope.viewstacks;

            for (var i = 0; i < childs.length; i++){
                var child = childs[i];
                var childElem = child.contentElement[0];

                child.index = domChilds.indexOf(childElem);
            }

            $scope.viewstacks = childs.filter(function(child) {
                return child.index > -1;
            }).sort(function(a, b){
                return a.index - b.index;
            });

            updateSelectedIndex($scope.selectedIndex);
        }

        function addPanel(contentElement, attrs) {
            var panel = {
                scopeId: $scope.$id,
                create: false,
                index: $scope.viewstacks.length,
                contentElement: contentElement
            };

            if (getSelectedIndex() === panel.index || $scope.creationPolicy === CREATION_POLICY.ALL || (attrs.hasOwnProperty('createOnInit') && attrs['createOnInit'] == 'true')) {
                panel.create = true;
            }

            $scope.viewstacks.push(panel);

            return panel;
        }

        function removePanel(panel) {
            $scope.viewstacks.splice(panel.index, 1);

            for (var i = panel.index; i < $scope.viewstacks.length; i++){
                var curPanel = $scope.viewstacks[i];

                curPanel.index = i;
            }

            $timeout(function(){
                syncDomAndList();
                refreshIndex();
            }, 0, false);
        }

        function refreshIndex() {
            if (getSelectedIndex() >= $scope.viewstacks.length && $scope.viewstacks.length > 0) {
                setSelectedIndex($scope.viewstacks.length - 1);
            }
        }

        function getSelectedIndex() {
            return $scope.selectedIndex;
        }

        function setSelectedIndex(newIndex) {
            $scope.selectedIndex = newIndex;
        }

        function registerSwipes(container) {
            swipeLeft(container);
            swipeRight(container);
        }

        function swipeLeft(container) {
            SwipeUtil.left($scope, container, function () {
                if ($scope.viewstacks.length > 1 && getSelectedIndex() < ($scope.viewstacks.length - 1)) {
                    var newIndex = getSelectedIndex() + 1;

                    setSelectedIndex(newIndex);
                }
            });
        }

        function swipeRight(container) {
            SwipeUtil.right($scope, container, function () {
                if ($scope.viewstacks.length > 1 && getSelectedIndex() > 0) {
                    var newIndex = getSelectedIndex() - 1;

                    setSelectedIndex(newIndex);
                }
            });
        }

        function updateViewstacksOpened(newValue) {
            newValue = angular.isDefined(newValue) ? newValue : getSelectedIndex();
            if (newValue > -1 && $scope.viewstacks[newValue]) {
                $scope.viewstacks[newValue].contentElement?.removeClass('sk-hidden');
                for (var i = 0; i < $scope.viewstacks.length; i++) {
                    if (i !== newValue) {
                        $scope.viewstacks[i].contentElement?.addClass('sk-hidden');
                    }
                }
            }
        }

        function getScopeId() {
            return $scope.$id;
        }
    }]);

/**
 * @ngdoc directive
 * @name snk.components.viewstack.directive:sk-viewstack
 * @restrict E
 *
 * @description
 * Componente de viewstack para utilização em seções que contém multiplos containers, onde deve ser exibido
 * apenas 1 container.
 *
 * Quando esse componente é aberto a partir de um dispositivo que trabalha com touch (mobile), ao realizar
 * o movimento de 'swipe' no próprio componente, de acordo com a direção (direita ou esquerda) ele chama
 * o próximo container ou o container anterior.
 *
 * @param {number=} [sk-selected-index=0] index que representa qual o container a ser apresentado para o
 * usuário.
 *
 * @param {function=} sk-on-select callback executado toda vez que uma aba é selecionada.
 *
 * @param {string=} [sk-creation-policy=auto] política de criação dos containers presentes no componente.
 * Essa opção aceita:
 *
 * * <b>auto:</b> cria os containers no DOM de acordo com a necessidade e faz a renderização do seu conteúdo
 * apenas quando o container é criado no DOM.
 * * <b>all:</b> cria todos os containers no DOM e já faz a renderizaçao do seu conteúdo.
 *
 * @example
     <example module="app">
         <file name="exemplo1.html">
             <div layout="column" flex ng-controller="MeuController">
                 <div class="btn-group">
                    <button class="btn btn-default" ng-click="prevViewstack()" ng-disabled="disablePrev">Anterior</button>
                    <button class="btn btn-default" ng-click="nextViewstack()" ng-disabled="disableNext">Próximo</button>
                 </div>
                 <br>
                 <sk-viewstack sk-selected-index="selectedIndex" flex>
                     <sk-viewstack-content layout-padding ng-style="tab.style" ng-repeat="tab in tabs">
                        Meu conteúdo da aba:{{ tab.name }}
                     </sk-viewstack-content>
                 </sk-viewstack>
                 <br>
                 <p>Selected index: {{ selectedIndex }}</p>
             </div>
         </file>
         <file name="app.js">
             angular
                 .module('app', ['snk'])
                 .controller('MeuController', ['$scope', function($scope){
                    $scope.selectedIndex;
                    $scope.disableNext = false;
                    $scope.disablePrev = false;

                    $scope.tabs = [
                        {
                            name: 'Teste 1',
                            style: {'background-color': '#2ECC71'}
                        },
                        {
                            name: 'Teste 2',
                            style: {'background-color': '#F9BF3B'}
                        },
                        {
                            name: 'Teste 3',
                            style: {'background-color': '#E74C3C'}
                        }
                    ];

                    $scope.prevViewstack = function() {
                        if ($scope.selectedIndex === 0) {
                            return;
                        }

                        $scope.selectedIndex = $scope.selectedIndex - 1;
                        $scope.disableNext = false;

                        if ($scope.selectedIndex === 0) {
                            $scope.disablePrev = true;
                        } else {
                            $scope.disablePrev = false;
                        }
                    }

                    $scope.nextViewstack = function() {
                        if ($scope.selectedIndex === $scope.tabs.length - 1) {
                            return;
                        }

                        $scope.selectedIndex = $scope.selectedIndex + 1;
                        $scope.disablePrev = false;

                        if ($scope.selectedIndex === $scope.tabs.length - 1) {
                            $scope.disableNext = true;
                        } else {
                            $scope.disableNext = false;
                        }
                    }
                }]);
        </file>
     </example>
 */
angular
    .module('snk.components.viewstack')
    .directive('skViewstack', ['UserAgentUtils', function (UserAgentUtils) {
        return {
            scope: {
                selectedIndex: '=?skSelectedIndex',
                creationPolicy: '@?skCreationPolicy',
                onSelect: '=?skOnSelect',
                enableDomRedraw: '@skEnableDomRedraw',
                contentList:'=skContentList'
            },
            restrict: 'E',
            transclude: true,
            controller: 'SkViewstackController',
            compile: function(element) {
                /**
                 * Por enquanto não teremos suporte a animação.
                 * Pois depois de animação ocorrer, devemos esconder os conteúdos com display:none,
                 * o que não conseguimos de maneira simples.
                 *
                 */
                //if (!UserAgentUtils.isMobile()) {
                    element.addClass('no-transition');
                //}

                return linkFn;
            }
        };

        function linkFn(scope, element, attr, ctrl, transcludeFn) {
            transcludeFn(function (clones) {
                element.append(clones);
            });

            //ctrl.registerSwipes(element);
        }
    }]);
angular
    .module('snk.components.viewstack')
    .directive('skViewstackContent', ['$timeout', 'StringUtils', function ($timeout, StringUtils) {
        return {
            restrict: 'E',
            require: '^?skViewstack',
            scope: true,
            transclude: true,
            template: '<div ng-if="isCreate()" ng-transclude></div>',
            compile: function (element, attrs) {
            	if (angular.isDefined(attrs.flex) || angular.isDefined(attrs.layout) || angular.isDefined(attrs.layoutWrap) || angular.isDefined(attrs.layoutAlign)) {
                    var div = angular.element(element.children()[0]);

                    div.attr('flex', attrs.flex || '');
                    div.attr('layout', attrs.layout || '');
                    div.attr('layout-wrap', attrs.layoutWrap);
                    div.attr('layout-align', attrs.layoutAlign);

                    var overflowAttrs = ['overflowY', 'overflowX'];

                    overflowAttrs.forEach(function(overflowAttr) {
                        if (attrs.hasOwnProperty(overflowAttr)) {
                            div.css(StringUtils.toDashCase(overflowAttr), attrs[overflowAttr]);
                        }
                    });
                }

                return postLink;
            }
        };

        function postLink(scope, element, attr, ctrl) {
        	
            ctrl = ctrl || element["data"]("$controllerInstanceController");
        	
            var panel = ctrl.addPanel(element, attr);

            scope.isCreate = function () {
                return panel.create;
            };

            scope.$watch(isLoaded, function (newValue) {
                element[newValue ? 'removeClass' : 'addClass']('sk-hidden');
                ctrl.updateViewstacksOpened();
            });

            scope.$on('$destroy', function () {
                ctrl.removePanel(panel);
            });

            function isLoaded() {
                return panel.index === ctrl.getSelectedIndex() && panel.scopeId === ctrl.getScopeId();
            }
        }
    }]);

/**
 * Created by leonardo.mendes on 05/12/2019.
 */
/**
 * @ngdoc service
 * @name snk.components.waitwindow.service:WaitWindow
 *
 * @description
 * Esse serviço permite lançar um popup com uma mensagem que pode ser alterada 
 * informando ao usuário o que esta ocorrendo, e que é necessário aguardar.
 * 
 * @example
 * Abrir o popup
 * <pre> 
 *   WaitWindow.show('Executando consulta...');
 * </pre>
 * 
 * Alterar a mensagem do popup
 * <pre> 
 *   WaitWindow.change('Executando troca de mensagem...');
 * </pre>
 * 
 * Fechando popup
 * <pre> 
 *    WaitWindow.close();
 * </pre>
 */
angular
    .module('snk.components.waitwindow')
    .service('WaitWindow', ['SanPopup', 
        function (SanPopup) {
            var self = this;

            var _instance;

            self.show = function (message) {
                if (_instance) {
                    _instance.change(message);
                } else {
                    SanPopup.open({
                        title: ' ',
                        templateUrl: 'components/waitwindow/waitwindow.tpl.html',
                        controller: 'WaitWindowController',
                        size: 'sm',
                        showBtnOk: false,
                        showBtnCancel: false,
                        showIconClose: false,
                        keyboard: false,
                        disableMovement: true,
                        ignoreLoading: true,
                        windowClass: 'WaitWindowClass',
                        resolve: {
                            data: {
                                message: message,
                                onCreated: function (instance) {
                                    _instance = instance;
                                }
                            }
                        }
                    }).result;
                }
            };

            self.change = function (message) {
                if (_instance) {
                    _instance.change(message);
                }
            };

            self.close = function () {
                if (_instance) {
                    _instance.close();
                    _instance = undefined;
                }
            };
        }])
    .controller('WaitWindowController', ['$scope', '$popupInstance', 'data',
        function ($scope, $popupInstance, data) {

            init();
            function init() {
                $scope.message = data.message;

                data.onCreated({
                    close: $popupInstance.dismiss,
                    change: function (message) {
                        $scope.message = message;
                    },
                });
            }
    }]);
angular
    .module('snk.components.wizard')
    .directive('skStep', ['$compile', '$controller', 'AngularUtil', 'i18n', function ($compile, $controller, AngularUtil, i18n) {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                title: '@skTitle',
                canNext: '=?skCanNext',
                canPrevious: '=?skCanPrevious',
                disabled: '=?skDisabled',
                finalize: '=?skFinalize',
                templateUrl: '@skTemplateUrl',
                controller: '@skController',
                controllerAs: '@skControllerAs',
                hidePrevious: '=?skHidePrevious',
                hideNext: '=?skHideNext',
                hideFinish: '=?skHideFinish',
                validateStep: '&?skValidateStep',
                completed:'=?skCompleted',
                eventBus: '=?skEventBus',
                creationPolicy: '@?skCreationPolicy'
            },
            require: '^skWizard',
            templateUrl: 'components/wizard/steps/steps.tpl.html',
            link: function ($scope, $element, $attrs, wizard, $transcludeFn) {
                if($scope.creationPolicy == 'lazy' || wizard.isLazy()){
                    $scope.created = false;
                }else{
                    $scope.created = true;
                }
                $scope.selected = false;
                $scope.cancelLabel = i18n($attrs.skCancelLabel || 'Geral.buttonCancelar');
                $scope.previousLabel = i18n($attrs.skPreviousLabel || 'Geral.lblAnterior');
                $scope.nextLabel = i18n($attrs.skNextLabel || 'Geral.lblProximo');
                $scope.finishLabel = i18n($attrs.skFinishLabel || 'Geral.lblConcluir');

                if (angular.isUndefined($attrs.skCanNext)) {
                    $scope.canNext = true;
                }

                if (angular.isUndefined($attrs.skCanPrevious)) {
                    $scope.canPrevious = true;
                }

                $scope.title = $scope.title || wizard.getNextStepNumber();

                $scope.$step = {
                    setCanNext: function (val) {
                        updateScopeVariable('canNext', val);
                        $scope.completed = val;
                    },
                    getCanNext: function() {
                    	return $scope.canNext;
                    },
                    setCanPrevious: function (val) {
                        updateScopeVariable('canPrevious', val);
                    },
                    getCanPrevious: function() {
                    	return $scope.canPrevious;
                    },
                    setCanFinish: function (val) {
                        updateScopeVariable('finalize', val);
                    },
                    getCanFinish: function() {
                    	return $scope.finalize;
                    },
                    setEnabled: function (val) {
                        updateScopeVariable('disabled', val ? false : true);
                    },
                    hidePrevious: function (val) {
                        updateScopeVariable('hidePrevious', val);
                    },
                    hideNext: function (val) {
                        updateScopeVariable('hideNext', val);
                    },
                    hideFinish: function (val) {
                        updateScopeVariable('hideFinish', val);
                    },
                    validateStep: function() {
                    	if ($scope.validateStep) {
                    		$scope.validateStep({$step: $scope.$step});
                    	}
                    },
                    isStepsCompleted: function() {
                       return wizard.isStepsCompleted();
                    },
                    onEnterStep: angular.noop,
                    onExitStep: angular.noop,
                    isVisible: angular.noop,
                    wizardContext: wizard.context
                };
                
                var templateScope = $scope;

                if ($scope.controller) {
                    var controllerScope = $scope.$new();
                    templateScope = controllerScope;

                    var evtBus;
                    if($scope.eventBus){
                        evtBus = $scope.eventBus;
                    }else{
                        evtBus = new EventBus();
                    }
                    var controller = $controller($scope.controller, {
                        $scope: controllerScope,
                        $wizard: wizard,
                        $step: $scope.$step,
                        $stepEventBus: evtBus
                    });

                    if ($scope.controllerAs) {
                        $scope[$scope.controllerAs] = controller;
                    }
                }

                function loadTpl(){
                    if ($scope.templateUrl) {
                        AngularUtil.requestTemplate($scope.templateUrl)
                            .then(function (template) {
                                var compiledTemplate = $compile(template)(templateScope);
                                $element.append(compiledTemplate);
                            });
                    } else {
                        $transcludeFn(function (clones) {
                            $element.append(clones);
                        });
                    }
                }

                if($scope.creationPolicy == 'lazy' || wizard.isLazy()){
                    let unWatchFn = $scope.$watch('created', (newV) => {
                        if(newV){ 
                            loadTpl();
                            unWatchFn();
                        }
                    });
                }else{
                    loadTpl();
                }
                
                wizard.addStep($scope);

                function updateScopeVariable(varName, value) {
                    if ($scope[varName] != value){
                        AngularUtil.apply($scope, function(){
                            $scope[varName] = value;
                        });
                    }
                }
            }
        };
    }]);
angular
    .module('snk.components.wizard')
    .controller('SkWizardController', ['StringUtils', '$scope', '$element', '$log', 'SkWizardHandler', '$q', 'ArrayUtils', '$document', 'SkConstants', 'AngularUtil', 'DomUtil',
        function (StringUtils, $scope, $element, $log, SkWizardHandler, $q, ArrayUtils, $document, SkConstants, AngularUtil, DomUtil) {
            var self = this;
            var firstRun = true;

            var _stepsElem = DomUtil.select($element, '.steps');
            
            let _wizardPreviou = false;

            $scope.steps = [];
            $scope.getStepNumber = getStepNumber;
            $scope.goTo = goTo;
            $scope.getEnabledSteps = getEnabledSteps;
            $scope.canPrevious = canPrevious;
            $scope.canNext = canNext;

            $scope.currentStepNumber = self.currentStepNumber = currentStepNumber;


            if (!$scope.context) {
            	$scope.context = {};
            } 
            
            self.context = $scope.context;
            
            self.addStep = addStep;
            self.getNextStepNumber = getNextStepNumber;
            self.isStepsCompleted = isStepsCompleted;
            self.goToByName = goToByName;
            self.getStepsContainerElement = getStepsContainerElement;
            self.isLazy = isLazy;
            self.getStepByName = getStepByName;

            self.next = next;
            self.finish = finish;
            self.previous = previous;
            self.cancel = cancel;
            self.previou = previou;

            init();

            function init() {
                SkWizardHandler.addWizard($scope.name, self);

                $document.bind('keydown', onKeyDown);

                $scope.$on('$destroy', function () {
                    SkWizardHandler.removeWizard($scope.name);

                    $document.unbind('keydown', onKeyDown);
                });

                $scope.$watch('currentStep', function (step) {
                    if (!step) return;

                    var stepTitle = $scope.selectedStep.title;

                    if ($scope.selectedStep && stepTitle !== $scope.currentStep) {
                        $scope.goTo(ArrayUtils.findWhere(getEnabledSteps(), {title: $scope.currentStep}));
                    }
                });

                $scope.$watch('[editMode, steps.length]', function () {
                    var editMode = $scope.editMode;
                    if (angular.isUndefined(editMode)) return;

                    if (editMode) {
                        angular.forEach(getEnabledSteps(), function (step) {
                            step.completed = true;
                        });
                    }
                }, true);

                if($scope.onCreate){
                    $scope.onCreate({wizard: self});
                }
            }
            
            function getStepsContainerElement(){
            	return _stepsElem; 
            }

            function onKeyDown(evt) {
                if($scope.disableKeyDown){
                    return;
                }

                var keycode = evt.which || evt.keyCode;

                if (keycode === SkConstants.KEY_CODE.LEFT_ARROW && canPrevious()) {
                    previous();
                    AngularUtil.digest($scope);
                } else if (keycode === SkConstants.KEY_CODE.RIGHT_ARROW && canNext()) {
                    next();
                    AngularUtil.digest($scope);
                }
            }

            function addStep(step) {
                //pushing the scope of directive onto step array
                $scope.steps.push(step);

                //if this is first step being pushed then goTo that first step
                if (getEnabledSteps().length === 1) {
                    //goTo first step
                    $scope.goTo(getEnabledSteps()[0], true);
                }
            }

            function getNextStepNumber() {
                return $scope.steps.length;
            }

            function isStepsCompleted() {
                for (var i = 0; i < $scope.steps.length; i++) {
                    if (!StringUtils.toBoolean($scope.steps[i].completed) && !StringUtils.toBoolean($scope.steps[i].finalize)) {
                        return false;
                    }
                }
                return true;
            }

            function getStepNumber(step) {
                return getEnabledSteps().indexOf(step) + 1;
            }

            function goTo(step, fromAddStep) {
                step.created = true;
                //createing variables to capture current state that goTo() was invoked from and allow booleans
                var thisStep = 0;

                var stepIndex = ArrayUtils.indexOf(getEnabledSteps(), step);
                
                if (firstRun) {
                    //deselect all steps so you can set fresh below
                    _wizardPreviou = stepIndex < thisStep;

                    unselectAll();
                    setSelectedStep(step, fromAddStep);
                    //making sure current step is not undefined
                    if (!angular.isUndefined($scope.currentStep)) {
                        $scope.currentStep = step.title || step.wzTitle;
                    }
                    //setting selected step to argument passed into goTo()
                    step.selected = true;

                    var stepIndex = ArrayUtils.indexOf(getEnabledSteps(), step);
                    //emit event upwards with data on goTo() invoktion
                    $scope.$emit('wizard:stepChanged', {
                        step: step,
                        index: stepIndex
                    });

                    //setting variable to false so all other step changes must pass validation
                    firstRun = false;
                } else {                   
                    //getting data for step you are transitioning out of
                    if (currentStepNumber() > 0) {
                        thisStep = currentStepNumber() - 1;
                    } else if (currentStepNumber() === 0) {
                        thisStep = 0;
                    }

                    _wizardPreviou = stepIndex < thisStep;

                    unselectAll();
                    setSelectedStep(step, fromAddStep);
                    
                    //making sure current step is not undefined
                    if (!angular.isUndefined($scope.currentStep)) {
                        $scope.currentStep = step.title || step.wzTitle;
                    }
                    //setting selected step to argument passed into goTo()
                    step.selected = true;
                    //emit event upwards with data on goTo() invoktion
                    $scope.$emit('wizard:stepChanged', {
                        step: step,
                        index: ArrayUtils.indexOf(getEnabledSteps(), step)
                    });
                    //$log.log('current step number: ', $scope.currentStepNumber());
                }

                $scope.onStepChange && $scope.onStepChange({$step: step, $index: stepIndex});

                DomUtil.scrollTo(_stepsElem, 0);
            }

            function canPrevious(){
            	if (!$scope.selectedStep) {
            		return false;
            	}
            	
                return $scope.selectedStep.canPrevious && currentStepNumber() > 1;
            }

            function canNext(){
            	if (!$scope.selectedStep) {
            		return false;
            	}
            	
                return $scope.selectedStep.canNext && currentStepNumber() < getEnabledSteps().length;
            }

            function setSelectedStep(step, fromAddStep){
                if(!$scope.interceptVisibleStep){
                    var oldStep = $scope.selectedStep;
            	
                    if (oldStep && !fromAddStep) {
                        oldStep.$step.onExitStep();
                    }
                }

                $scope.selectedStep = step;
                
                $scope.$step = step ? step.$step : undefined;
                
                if (step) {
                	step.$step.onEnterStep();
                }
            }

            function canEnterStep(step) {
                //If no validation function is provided, allow the user to enter the step
                if (step.canenter === undefined) {
                    return true;
                }
                //If canenter is a boolean value instead of a function, return the value
                if (typeof step.canenter === 'boolean') {
                    return step.canenter;
                }

                //Check to see if the canenter function is a promise which needs to be returned
                var canEnter = step.canenter($scope);

                if (angular.isFunction(canEnter.then)) {
                    var defer = $q.defer();

                    canEnter.then(function (response) {
                        defer.resolve(response);
                    });

                    return defer.promise;
                }

                return step.canenter($scope) === true;
            }

            function canExitStep(step, stepTo) {
                //Exiting the step should be allowed if no validation function was provided or if the user is moving backwards
                if (typeof(step.canexit) === 'undefined' || $scope.getStepNumber(stepTo) < $scope.currentStepNumber()) {
                    return true;
                }
                //If canexit is a boolean value instead of a function, return the value
                if (typeof step.canexit === 'boolean') {
                    return step.canexit;
                }
                //Check to see if the canexit function is a promise which needs to be returned
                var canExit = step.canexit($scope.context);
                if (angular.isFunction(canExit.then)) {
                    var defer = $q.defer();

                    canExit.then(function (response) {
                        defer.resolve(response);
                    });

                    return defer.promise;
                }

                return step.canexit($scope.context) === true;
            }

            function currentStepNumber() {
                return getEnabledSteps().indexOf($scope.selectedStep) + 1;
            }


            function getEnabledSteps() {
                return $scope.steps.filter(function (step) {
                    if($scope.interceptVisibleStep && angular.isDefined(step.$step.isVisible())){
                        step.disabled = !step.$step.isVisible();
                    }

                    return step.disabled != true;
                });
            }

            //unSelect All Steps
            function unselectAll() {
                //traverse steps array and set each "selected" property to false
                angular.forEach(getEnabledSteps(), function (step) {
                    step.selected = false;
                });
            }

            function goToByName(step, params = {}) {
                var enabledSteps = params.forceDisabled ? $scope.steps : getEnabledSteps();
                var stepTo;
                //checking that step is a Number
                if (angular.isNumber(step)) {
                    stepTo = enabledSteps[step];
                } else {
                    //finding the step associated with the title entered as goTo argument
                    var stepFilter = enabledSteps.filter(
                        function (el) {
                            return el.title == step;
                        });
                    stepTo = stepFilter[0];
                }

                goTo(stepTo);
                
                if(params.resetCompleted){
                    resetCompletedOfSteps();
                }
            }

            //method used for next button within step
            function next() {
            	if ($scope.selectedStep.$step.getCanNext()) {
            		$scope.selectedStep.$step.validateStep();

                    if($scope.interceptVisibleStep){
                        $scope.selectedStep.$step.onExitStep();
                    }    
            		
            		var enabledSteps = getEnabledSteps();
                    var index = enabledSteps.indexOf($scope.selectedStep);

                    //completed property set on scope which is used to add class/remove class from progress bar
                    $scope.selectedStep.completed = true;

                    //$scope.selectedStep.$step.exitStep();
                    
                    //invoking goTo() with step number next in line
                    var nextStep = enabledSteps[index + 1];
                    
                    if (nextStep) {
                    	$scope.goTo(enabledSteps[index + 1]);
                    } else {
                    	finish();
                    }
            	}
            }

            function previous() {
            	if ($scope.selectedStep.$step.getCanPrevious()) {
            		//getting index of current step
                    var index = ArrayUtils.indexOf(getEnabledSteps(), $scope.selectedStep);
                    //ensuring you aren't trying to go back from the first step
                    if (index > 0) {
                    	//$scope.selectedStep.$step.exitStep();
                    	
                        //go back one step from current step
                        $scope.goTo(getEnabledSteps()[index - 1]);
                    }
            	}
            }

            function finish() {
            	if ($scope.selectedStep.$step.getCanFinish()) {
            		$scope.selectedStep.$step.onExitStep();
                    $scope.onFinish($scope);
            	}
            }

            function cancel() {
                $scope.onCancel($scope);
            }

            function resetCompletedOfSteps(){
                $scope.steps.forEach(function(step){
                    step.completed = false;
                })
            }

            function isLazy(){
                return $scope.creationPolicy == "lazy"
            }

            function previou(){
                return _wizardPreviou;
            }

            function getStepByName(name){
                if(angular.isNumber(name)){
                    return $scope.steps[name].$step;
                }else{
                    let stepScope = $scope.steps.filter( (step) => step.title == name);
                    if(stepScope.length > 0){
                        return stepScope[0].$step;
                    }
                }                    
            }
        }]);

/**
 * @ngdoc directive
 * @name snk.components.wizard.directive:sk-wizard
 * @restrict E
 *
 * @description
 * Componente de wizard para utilização em seções que contém multiplos containers, onde deve ser exibido
 * um passo a passo ao usuário.
 *
 * @param {number=} [sk-selected-index=0] index que representa qual o container a ser apresentado para o
 * usuário.
 *
 * @param {function=} sk-on-select callback executado toda vez que uma aba é selecionada.
 *
 * @param {string=} [sk-creation-policy=all] política de criação dos containers presentes no componente.
 * Essa opção aceita:
 *
 * * <b>lazy:</b> cria os containers no DOM de acordo com a necessidade e faz a renderização do seu conteúdo
 * apenas quando o container é criado no DOM.
 * * <b>all:</b> cria todos os containers no DOM e já faz a renderizaçao do seu conteúdo.
 *
 * @example
     <example module="app">
         <file name="exemplo1.html">
             <div layout="column" flex ng-controller="MeuController">

             </div>
         </file>
         <file name="app.js">
             angular
                 .module('app', ['snk'])
                 .controller('MeuController', ['$scope', function($scope){

                }]);
        </file>
     </example>
 */
angular
    .module('snk.components.wizard')
    .directive('skWizard', [function() {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            currentStep: '=',
            onFinish: '&skOnFinish',
            onCancel: '&skOnCancel',
            onStepChange: '&?skOnStepChange',
            hideIndicators: '=skHideIndicators',
            hideBtnCancel: '=skHideBtnCancel',
            disableKeyDown:'=?skDisableKeyDown',
            editMode: '=',
            context: '=?skContext',
            name: '@',
            onCreate: '&?skOnCreate',
            creationPolicy: '@?skCreationPolicy',
            interceptVisibleStep : '=?skInterceptVisibleStep',
            usingMaxHeight : '=?skUsingMaxHeight'
        },
        templateUrl: 'components/wizard/wizard.tpl.html',
        controller: 'SkWizardController'
    };
}]);

function wizardButtonDirective(action) {
    angular.module('snk.components.wizard')
        .directive(action, ['$parse', function ($parse) {
            return {
                restrict: 'A',
                require: '^skWizard',
                link: function ($scope, $element, $attrs, wizard) {
                    $element.on('click', function (e) {
                        e.preventDefault();

                        $scope.$apply(function () {
                            wizard[action.replace('skStep', '').toLowerCase()]();
                        });
                    });
                }
            };
        }]);
}

wizardButtonDirective('skStepNext');
wizardButtonDirective('skStepPrevious');
wizardButtonDirective('skStepFinish');
wizardButtonDirective('skStepCancel');
angular
    .module('snk.components.wizard')
    .service('SkWizardHandler', function () {
        var self = this;

        var wizards = {};

        self.addWizard = function (name, wizard) {
            if (name){
                wizards[name] = wizard;
            }
        };

        self.removeWizard = function (name) {
            delete wizards[name];
        };

        self.wizard = function (name) {
            return wizards[name];
        };
    });
/*
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
angular
    .module('snk.components.workbox')
    .controller('SkWorkBoxController', ['$scope', '$attrs', '$element', '$document', '$q', 'ArrayUtils', 'i18n', 'StringUtils', 'AngularUtil', '$timeout', 'ObjectUtils', '$rootScope',
        function ($scope, $attrs, $element, $document, $q, ArrayUtils, i18n, StringUtils, AngularUtil, $timeout, ObjectUtils, $rootScope) {

            var ctrl = this;

            var _iWorkContainer = null;

            ctrl.index = 0;
            ctrl.addChild = addChild;
            ctrl.addChildAt = addChildAt;
            ctrl.getScopeApi = getScopeApi;
            ctrl.getChildIndex = getChildIndex;
            ctrl.addTagResizable = addTagResizable;
            ctrl.removeAllChildren = removeAllChildren;
            ctrl.removeChild = removeChild;
            ctrl.removeChildAt = removeChildAt;
            ctrl.hasWorkContainer = hasWorkContainer;
            ctrl.getWorkContainer = getWorkContainer;
            ctrl.addIWorkContainer = addIWorkContainer;
            ctrl.ajustTamanhoRelativo = ajustTamanhoRelativo;

            $scope.workContainers = new ArrayList();
            $scope.onSelect = $scope.onSelect || angular.noop;

            ctrl.onResizePanel = function (element){
                $rootScope.$broadcast("WorkBoxAlterado", element);    
            }

            AngularUtil.setContextControllerInfo($element, $scope, 'SkWorkBoxController', ctrl);

            init();

            function init() {

                $scope.api = self;
                $scope.element = $element;

                if (angular.isUndefined($scope.direction)) {
                    $scope.direction = 'V';
                }

                $timeout(function () {
                    $element.off('dragenter');
                    $element.off('dragover');
                    $element.off('drop');

                    $element.on('dragenter', ondragenter);
                    $element.on('dragover', ondragover);
                    $element.on('drop', ondrop);
                });
            }

            function addChild(newElement, scopeParent, elementParent, useEvent) {
                addIWorkContainer(newElement);

                var divElem;
                var layoutDirection = newElement[0].getAttribute('sk-direction-layout');
                var parentDirection = elementParent[0].getAttribute('sk-direction-layout');

                if (layoutDirection && parentDirection) {
                    var fieldProp = {
                        'sk-resizable': '',
                        'sk-direction': parentDirection == 'H' ? "'left'" : "'top'",
                        'sk-handle-workbox-resize': true,
                        'sk-relative-resizable' : true,
                        'sk-resize-next-preview' : true,
                        'sk-offset-adjust': true
                    };

                    var tamanhoRelativo = newElement[0].getAttribute('sk-tamanho-relativo');
                    if (tamanhoRelativo != null) {
                        if (layoutDirection == 'V') {
                            ObjectUtils.setProperty(fieldProp, 'sk-width', '100%');
                        } else if (layoutDirection == 'H') {
                            ObjectUtils.setProperty(fieldProp, 'sk-height', '100%');
                        }

                        tamanhoRelativo = useEvent === true ? ajustTamanhoRelativo(tamanhoRelativo) : tamanhoRelativo;

                        ObjectUtils.setProperty(fieldProp, 'sk-relative-size', tamanhoRelativo);
                    }
                    
                    var changeLayout = newElement[0].getAttribute('sk-change-layout');
                    if (changeLayout == "true") {
                        ObjectUtils.setProperty(fieldProp, 'sk-change-layout', true);
                    }

                    var resizeToPixel = newElement[0].getAttribute('sk-resize-to-pixel');
                    if (resizeToPixel == "true") {
                        ObjectUtils.setProperty(fieldProp, 'sk-resize-to-pixel', true);
                    }

                    var attrElements = layoutDirection == 'H' ? 'columns' : 'rows';
                    var resizableElement = $element.find(`sk-resizable-${attrElements}`);

                    if (resizableElement[0] && resizableElement[0].children.length > 0) {
                        scopeParent.elementSibling = resizableElement[0].children[0];
                        fieldProp['sk-sibling'] = 'elementSibling';
                    }

                    divElem = angular.element(AngularUtil.createDirective('div', fieldProp, scopeParent));
                    divElem.append(newElement);

                    if (resizableElement[0]) {
                        angular.element(resizableElement[0]).append(divElem);
                    }

                    return divElem;
                }
            }

            function addChildAt(newElement, index, scopeParent, position) {
                addIWorkContainer(newElement);

                var layoutDirection = newElement[0].getAttribute('sk-direction-layout');
                var divElem;
                var divPositionElem;

                if (layoutDirection) {

                    if (layoutDirection == "V") {

                        var percentHeight = newElement[0].getAttribute('sk-percent-height');
                        percentHeight = parseFloat(percentHeight) > 100 ? '100%' : percentHeight;

                        var fieldProp = {
                            'style': 'width: 100%',
                            'sk-resizable': '',
                            'sk-direction': position == 'before' ? "'bottom'" : "'top'"
                        };

                        // Aqui sempre vai chegar o sk-resizable
                        var resizableRows = angular.element($element[0].parentNode.parentNode);

                        if (resizableRows[0]) {
                            if (resizableRows[0] && resizableRows[0].children.length > 0) {
                                scopeParent.elementSibling = resizableRows[0].children[index];
                                fieldProp['sk-sibling'] = 'elementSibling';
                                divPositionElem = angular.element(resizableRows[0].children[index]);
                                if (divPositionElem[0]) {
                                    if (position == 'before' && containsClassChild(divPositionElem[0], 'rg-top')) {
                                        fieldProp['sk-direction'] = "'top'";
                                    } else if (position == 'after' && containsClassChild(divPositionElem[0], 'rg-bottom')) {
                                        fieldProp['sk-direction'] = "'bottom'";
                                    }
                                }
                            }
                        }

                        var divRow = angular.element(AngularUtil.createDirective('div', fieldProp, scopeParent));
                        divRow.css('flex', percentHeight);

                        divRow.append(newElement);

                        if (resizableRows[0]) {
                            if (!divPositionElem || !divPositionElem[0]) {
                                divPositionElem = angular.element(resizableRows[0].children[index]);
                            }

                            if (divPositionElem[0]) {
                                if (position == 'before') {
                                    divElem = divPositionElem[0].parentNode.insertBefore(divRow[0], divPositionElem[0]);
                                } else {
                                    divElem = divPositionElem[0].parentNode.insertBefore(divRow[0], divPositionElem[0].nextSibling);
                                }
                            } else {
                                scopeParent.elementSibling = divRow;
                                divRow.attr('sk-sibling', 'elementSibling')

                                divElem = divRow;

                                angular.element(resizableRows[0]).append(divRow);
                            }
                        }
                    } else {

                        var percentWidth = newElement[0].getAttribute('sk-percent-width');
                        percentWidth = parseFloat(percentWidth) > 100 ? '100%' : percentWidth;

                        var fieldProp = {
                            'style': 'height: 100%',
                            'sk-resizable': '',
                            'sk-direction': position == 'before' ? "'right'" : "'left'"
                        };
                        
                        // Aqui sempre vai chegar o sk-resizable
                        var resizableColumns = angular.element($element[0].parentNode.parentNode);

                        if (resizableColumns[0] && resizableColumns[0].children.length > 0) {
                            scopeParent.elementSibling = resizableColumns[0].children[index];
                            fieldProp['sk-sibling'] = 'elementSibling';
                            divPositionElem = angular.element(resizableColumns[0].children[index]);
                            if (divPositionElem[0]) {
                                if (position == 'before' && containsClassChild(divPositionElem[0], 'rg-left')) {
                                    fieldProp['sk-direction'] = "'left'";
                                } else if (position == 'after' && containsClassChild(divPositionElem[0], 'rg-right')) {
                                    fieldProp['sk-direction'] = "'right'";
                                }
                            }
                        }

                        var divRow = angular.element(AngularUtil.createDirective('div', fieldProp, scopeParent));
                        divRow.css('flex', percentWidth);

                        divRow.append(newElement);

                        if (resizableColumns[0]) {
                            if (!divPositionElem || !divPositionElem[0]) {
                                divPositionElem = angular.element(resizableColumns[0].children[index]);
                            }

                            if (divPositionElem[0]) {
                                if (position == 'before') {
                                    divElem = divPositionElem[0].parentNode.insertBefore(divRow[0], divPositionElem[0]);
                                } else {
                                    divElem = divPositionElem[0].parentNode.insertBefore(divRow[0], divPositionElem[0].nextSibling);
                                }
                            } else {
                                scopeParent.elementSibling = divRow;
                                divRow.attr('sk-sibling', 'elementSibling')

                                divElem = divRow;

                                angular.element(resizableColumns[0]).append(divRow);
                            }

                        }
                    }

                    return divElem;
                }
            }

            function addTagResizable(boxElem) {
                var resizableElem;

                if (boxElem.orientacao == 'V' || boxElem.orientacao == 'vertical') {
                    resizableElem = angular.element(AngularUtil.createDirective('sk-resizable-rows', {
                    }, $scope.scopeComponent));

                } else {
                    resizableElem = angular.element(AngularUtil.createDirective('sk-resizable-columns', {
                    }, $scope.scopeComponent));
                }

                $element.append(resizableElem);
            }

            function getScopeApi() {
                return $scope;
            }

            function getChildIndex(child) {
                return $scope.workContainers.getItemAtIndex(child);
            }

            function removeAllChildren() {

                var currentElement = $element[0];

                if (currentElement) {
                    while (currentElement.hasChildNodes()) {
                        currentElement.removeChild(currentElement.firstChild);
                    }
                }

                $scope.workContainers = new ArrayList();

                _iWorkContainer = null;
            }

            function removeChild(child) {

                $scope.workContainers.removeItem(child)
                _iWorkContainer = null;

                $timeout(function () {
                    syncDomAndList();
                }, 0, false);
            }

            function removeChildAt(index) {
                $scope.workContainers.removeItemAt(index);

                $timeout(function () {
                    syncDomAndList();
                }, 0, false);
            }

            function hasWorkContainer() {
                return angular.isDefined(_iWorkContainer);
            }

            function addIWorkContainer(iWorkContainer) {
                _iWorkContainer = iWorkContainer;
            }

            function getWorkContainer() {
                return _iWorkContainer;
            }

            function syncDomAndList() {
                if ($element.children().length == 0) {
                    return;
                }

                var domChilds = [];

                $element.children().each(function (index, value) {
                    domChilds.push(value);
                });

                var childs = $scope.workContainers.getItems();

                for (var i = 0; i < childs.length; i++) {
                    var child = childs[i];
                    var childElem = child.contentElement[0];

                    child.index = domChilds.indexOf(childElem);
                }
            }

            function ondragenter(event) {
                if ($scope.dragEnter) $scope.dragEnter({ event: event });
            }

            function ondragover(event) {
                if ($scope.dragOver) $scope.dragOver({ event: event }); event.preventDefault();
            }

            function ondrop(event) {

                if ($scope.drop) $scope.drop({ event: event });
            }

            function containsClassChild(parent, classChild) {
                let hasClassChild = false; 
                const childRen = parent.children;
                if (angular.isDefined(childRen) && childRen.length > 0) {
                    for (var i = 0; i < childRen.length; i++) {
                        var child = childRen[i];
                        if (child.className.indexOf(classChild) > -1) {
                            hasClassChild = true;
                        }
                    }
                }
                return hasClassChild;
            }

            function ajustTamanhoRelativo(tamanhoRelativo){
                if(tamanhoRelativo < 1000) return tamanhoRelativo;

                return parseInt(tamanhoRelativo / 100);
            }
        }
    ]);

/*
 * Created by Handz. 
 * Modified by jonathan.silva.
 */
angular
    .module('snk.components.workbox')
    .directive('skWorkBox', ['$timeout', 'ObjectUtils', 'AngularUtil', function ($timeout, ObjectUtils, AngularUtil) {
        return {
            restrict: 'E',
            transclude: true,
            controller: 'SkWorkBoxController as ctrl',
            scope: {
                creationComplete: '&?skCreationComplete',
                drop: '&?skDrop',
                dragOver: '&?skDragOver',
                onResizeWorkbox: '&?skOnResizeWorkbox'
            },
            compile: function (element, attrs) {

                if (attrs.skDirectionLayout) {

					/*O alinhamento segue e regra da API abaixo
					 *https://material.angularjs.org/latest/layout/alignment
					 */
                    if (attrs.skDirectionLayout == "V" || attrs.skDirectionLayout == "vertical") {
                        element.attr('layout', 'column');
                    } else if (attrs.skDirectionLayout == "H" || attrs.skDirectionLayout == "horizontal") {
                        element.attr('layout', 'row');
                    }
                }

                if (Number(attrs.skWidth)) {
                    angular.element(element).css({
                        width: attrs.skWidth + '%'
                    });
                }

                if (Number(attrs.skHeight)) {
                    angular.element(element).css({
                        height: attrs.skHeight + '%'
                    });
                }

                return postLink;
            }
        }

        function postLink($scope, element, attr, ctrl, transcludeFn) {

            var controllerInfo = AngularUtil.getContextControllerInfo(element);
            var controllerAs = ObjectUtils.getProperty(controllerInfo, 'controllerAs');
            if (controllerAs) {
                $scope[controllerAs] = controllerInfo.controllerInstance;
            }

            $scope.scopeComponent = $scope;

            $scope.$root.$on('$contextControllerChanged', function () {
                var controllerInfo = AngularUtil.getContextControllerInfo(element);

                if (controllerInfo) {
                    var controllerAs = controllerInfo.controllerAs;

                    if (controllerAs) {
                        $scope[controllerAs] = controllerInfo.controllerInstance;
                    }
                }
            });

            if ($scope.creationComplete) {
                $scope.creationComplete();
            }
        }
    }]);
 /**
 @ngdoc directive
@name snk.i18n.directive:sk-i18n

@restrict EA

@description
    Esta é a diretiva de internacionalização do sistema.
    Ela suporta vários formatos de internacionalização, como serão abordados nos exemplos abaixo.
    Os atributos 'tooltip', 'title' e 'placeholder' são traduzidos por padrão quando presentes, 
    para todos os outros, deve-se informar '@i18n:' antes da chave para que ela seja internacionalizada. 

@param {string} sk-i18n Chave de internacionalização.

@param {object}  sk-i18n-values Objeto com as propriedades que serão substituídas na tradução.

@example
  <example module="app">
      <file name="exemplo.html">
         <div ng-controller="Ctrl as ctrl">
            <p>i18n via Elemento         : <sk-i18n>MinhaTela.HELLO</sk-i18n></p>
            <p>i18n via Atributo         : <button default sk-i18n>MinhaTela.HELLO</button></p>
            <p>i18n no Tooltip           : <button default sk-i18n tooltip="MinhaTela.HELLO">X</button><p>
            <p>i18n no Tooltip e no Botão: <button default sk-i18n tooltip="MinhaTela.HELLO">MinhaTela.tooltip</button><p>
            <p>
                i18n variavel a partir do $scope:
                <sk-i18n sk-i18n-values="{ count: countScope }">MinhaTela.N_CLICK</sk-i18n>
             </p>
             <br>
             <button warning ng-click="i18nChange()">Alterar Idioma</button>
             <br><br>
         </div>
      </file>
      <file name="translationsLoader.js">
        //Essa não é a maneira correta, como é apenas 1 exemplo injetamos a internacionalização manualmente
         var traducoes = {
             'HELLO': 'Olá, seja bem-vindo!',
             'HELLO_NAME': 'Olá {{ name }}',
             'N_CLICK': '{{ count }} clique.',
             'tooltip': 'Com tooltip'
         };

         var translations = {
             'HELLO': 'Hello welcome!',
             'HELLO_NAME': 'Hello {{ name }}',
             'N_CLICK': '{{ count }} click.',
             'tooltip': 'With tooltip'
         };

         angular.module('app', ['snk'])
             .run(['SkI18nService', function(SkI18nService) {
                 SkI18nService.setLang('pt_BR');

                 SkI18nService.addPart('pt_BR', 'MinhaTela', traducoes);
                 SkI18nService.addPart('en_US', 'MinhaTela', translations);
             }]);
      </file>
      <file name="app.js">
         angular
             .module('app')
             .controller('Ctrl', ['$scope', 'SkI18nService', 'i18n', '$timeout', function ($scope, SkI18nService, i18n, $timeout) {
                 var lang;

                 $scope.countScope = 0;
                 $scope.traducaoIdKey = "MinhaTela.HELLO";

                 //Esse $timeout foi necessário apenas para nosso exemplo da documentação,
                 //nas nossas telas do sistema não precisa do $timeout
                 $timeout(function(){
                     $scope.translateInCtrl = i18n('MinhaTela.HELLO')
                 }, 0, false);

                 $scope.i18nChange = function() {
                     if (lang === 'en_US') {
                         lang = 'pt_BR';
                     } else {
                         lang = 'en_US';
                     }

                     $scope.countScope = $scope.countScope + 1;

                     SkI18nService.setLang(lang);
                 };
             }]);
      </file>
  </example>
 */
angular
    .module('snk.i18n')
    .directive('skTranslate', ['$translate', '$parse', '$timeout', '$compile', 'AngularUtil', 'StringUtils', function ($translate, $parse, $timeout, $compile, AngularUtil, StringUtils) {
        return {
            restrict: 'EA',
            link: function (scope, element, attr) {
                var translateKey;
                var translateValues;

                var useExpression = false;
                var attrTranslate = attr.skTranslateAttr;

                if (attr.skTranslateExp) {
                    useExpression = true;

                    translateKey = $parse(attr.skTranslateExp)(scope);

                    scope.$watch(function () {
                        return $parse(attr.skTranslateExp)(scope);
                    }, function (newTranslateKey) {
                        translateKey = newTranslateKey;
                        doTranslate();
                    });
                } else if (attr[attrTranslate]) {
                    translateKey = attr[attrTranslate];
                } else if (attr.skTranslate) {
                    translateKey = attr.skTranslate;
                } else {
                    translateKey = element.html();
                }

                if (!translateKey) {
                    throw new Error('Não foi definida uma chave de tradução');
                }

                if (attr.skTranslateValues) {
                    translateValues = {};

                    scope.$watch(function () {
                        return angular.extend(translateValues, $parse(attr.skTranslateValues)(scope));
                    }, function () {
                        doTranslate();
                    }, true);

                } else if (!useExpression) {
                    doTranslate();
                }

                var deReg = scope.$root.$on('$translateLoadingEnd', function () {
                    $timeout(doTranslate, 0, false);
                });

                scope.$on('$destroy', deReg);

                function doTranslate() {
                    $translate(translateKey, translateValues)
                        .then(function (translated) {
                            if (attr.hasOwnProperty('skRemoveEndColon')) {
                                if (translated.lastIndexOf(':') == (translated.length - 1)) {
                                    translated = translated.substring(0, (translated.length - 1));
                                }
                            }

                            if (attrTranslate) {
                                if (translateValues && translateValues.hasOwnProperty('$ready')){
                                    if (!translateValues.$ready){
                                        return;
                                    }
                                }

                                attr.$set(attr.$normalize(attrTranslate), translated);
                            } else {
                                element.html(translated);
                            }
                        });
                }
            }
        }
    }])
    .directive('skI18n', ['$translate', '$parse', '$timeout', '$compile', 'AngularUtil', 'StringUtils', 'SkI18nService', function ($translate, $parse, $timeout, $compile, AngularUtil, StringUtils, SkI18nService) {
        var TRANSLATABLE_ATTRS = ['tooltip', 'title', 'placeholder', 'skPlaceholder'];
        var I18N_PREFIX = '@i18n:';

        return {
            restrict: 'EA',
            link: function (scope, element, attr) {
                var translateInfos = [];
                
                if (attr.skI18n) {
                    translateInfos.push({
                        type: 'content',
                        key: attr.skI18n
                    });
                } else if (element.children().length == 0 && StringUtils.isNotEmpty(element.text())) {
                    translateInfos.push({
                        type: 'content',
                        key: element.text().trim()
                    });
                }

                angular.forEach(attr.$attr, function(dashCaseName, camelCaseName) {
                    var attrValue = attr[camelCaseName];

                    if (TRANSLATABLE_ATTRS.indexOf(camelCaseName) > -1) {
                        translateInfos.push({
                            type: 'attr',
                            name: camelCaseName,
                            key: attrValue || (translateInfos[0] != undefined ? translateInfos[0].key : undefined)
                        });
                    } else if (attrValue && StringUtils.startsWith(attrValue, I18N_PREFIX)) {
                        translateInfos.push({
                            type: 'attr',
                            name: camelCaseName,
                            key: attrValue.substring(I18N_PREFIX.length, attrValue.length)
                        });
                    }
                });


                var translateValues;
                if (attr.skI18nValues) {
                    translateValues = {};

                    scope.$watch(function () {
                        return angular.extend(translateValues, SkI18nService.adjustTranslateValues($parse(attr.skI18nValues)(scope)));
                    }, function () {
                        doTranslate();
                    }, true);

                } else {
                    doTranslate();
                }

                var deReg = scope.$root.$on('$translateLoadingEnd', function () {
                    $timeout(doTranslate, 0, false);
                });

                scope.$on('$destroy', deReg);

                function doTranslate() {
                    translateInfos.forEach(function (translateInfo) {
                    	var translated = $translate.instant(translateInfo.key, translateValues);
                        
                    	if (translateInfo.type == 'content') {
                            element.html(translated);
                        } else {
                            attr.$set(translateInfo.name, translated);
                        }
                    });
                    
                }
            }
        }
     }]);
/**
 * Created by bruno.brandao on 21/05/2015.
 */
angular
    .module('snk.i18n')
    .filter('i18n', function(i18n) {
        return i18n;
    });
angular
    .module('snk.i18n')
    .service('SkI18nService', ['$q', '$http', '$translate', 'StringUtils', function ($q, $http, $translate, StringUtils) {
        var self = this;
        var langFirstPromise = {};
        const DEFAULT_LANG = 'pt_BR';

        var _translationsByLang = {};
        //        var _translationsByLang;
        //
        //        if (top.i18nService_translationsByLang) {
        //            _translationsByLang = top.i18nService_translationsByLang;
        //        } else {
        //            _translationsByLang = top.i18nService_translationsByLang = {};
        //        }

        self.instant = function (translateId, translateValues) {
            return $translate.instant(translateId, adjustTranslateValues(translateValues));
        };

        self.translate = function (translateId, translateValues) {
            return $translate(translateId, adjustTranslateValues(translateValues));
        };

        self.setLang = function (lang) {
            $translate.use(lang);
        };

        self.getLang = function () {
        	return $translate.use() || DEFAULT_LANG;
        };

        self.loadAsyncBundle = function (locale, url) {
            $http.get(url)
                .then(function (result) {
                    if (result && result.data) {
                        angular.forEach(result.data, function (translations, bundleName) {
                            self.addBundle(locale, bundleName, translations);
                        });
                    } else {
                        var errMsg = 'Arquivo de i18n carregado é inválido.';
                        console.error(errMsg, result);
                        throw Error(errMsg);
                    }
                }, function (error) {
                    throw error;
                });
        };

        self.addBundle = function (lang, bundleName, translations) {
            if (!_translationsByLang[lang]) {
                _translationsByLang[lang] = {};
            }

            var bundle = _translationsByLang[lang][bundleName];

            adjustHtmlEntities(translations);

            if (bundle) {
                angular.extend(bundle, translations);
            } else {
                bundle = translations;
            }

            _translationsByLang[lang][bundleName] = bundle;

            if (langFirstPromise[lang]) {
                langFirstPromise[lang].resolve(_translationsByLang[lang]);
                delete langFirstPromise[lang];
            }

            $translate.refresh(lang);
        };

        self.addPart = self.addBundle;

        self.getTranslations = function (options) {
            var deferred = $q.defer();

            if (_translationsByLang[options.key]) {
                deferred.resolve(_translationsByLang[options.key]);
            } else {
                langFirstPromise[options.key] = deferred;
            }

            return deferred.promise;
        };

        function adjustHtmlEntities(translations) {
            angular.forEach(translations, function (value, key) {
                if (angular.isObject(value)) {
                    adjustHtmlEntities(value);
                } else {
                    translations[key] = StringUtils.toHtmlText(value);
                }
            });
        }

        self.adjustTranslateValues = adjustTranslateValues;

        function adjustTranslateValues(translateValues) {
            if (angular.isArray(translateValues)) {
                var map = {};

                translateValues.forEach(function (value, index) {
                    map[('p' + index)] = value;
                });

                translateValues = map;
            }

            return translateValues;
        }

    }])
    .provider('i18n', function () {
        this.$get = ['SkI18nService', function (SkI18nService) {
            return function (i18nKey, i18nValues) {
                return SkI18nService.instant(i18nKey, i18nValues);
            };
        }];
    })
    .factory('SkI18nServiceLoader', ['$q', '$timeout', 'SkI18nService', function ($q, $timeout, SkI18nService) {
        return function (options) {
            angular.forEach(i18nAll, function(translations, bundleName) {
	            SkI18nService.addBundle(locale, bundleName, translations);
	        });

	        angular.forEach(i18nFramework, function(translations, bundleName) {
	            SkI18nService.addBundle(locale, bundleName, translations);
	        });

            return SkI18nService.getTranslations(options);
        };
    }]);
angular
    .module("snk.commons").service("AbrirGavetaService", [function(){

        const self = this;

        self.abrirGaveta = abrirGaveta;

        function abrirGaveta(){

            let socket = new WebSocket("ws://localhost:9098/gaveta");

            socket.onopen = function(){socket.send(1)};


            if(socket.readyState === WebSocket.OPEN) {
                socket.close();
            }
    }

}]);
/**
 * @ngdoc directive
 * @name snk.commons.acaoprogramada.directive:sk-acao-programada
 * @restrict E
 * @scope
 * @description 
skAcaoProgramada é o componente responsável pela criação de ações programadas como rotina Java, Banco de dados e Script.

 * @param {string} [sk-contexto=undefined] Recebe a classe que implementa a interface "ContextoAcaoProgramada" 
 * @param {boolean} [is-java=true] Habilita criação de rotina java 
 * @param {boolean} [is-banco-dados=true] Habilita criação de rotina de Banco de dados
 * @param {boolean} [is-script=true] Habilita criação de rotina de Script
 * @param {object} [sk-value=undefined] Variável em que ocorrerá o bind entre o model e o view
 * @param {function} [sk-change=undefined] Função de listener de alteração do valor do componente.
 * @param {function} [sk-acao-programada-created=undefined] Função de criação de um instancia do componente, utilizado para chamar 
 * o método "validaDados" .
 * @example
 <example module="appAcaoProgramada">
      <file name="appAcaoProgramada.html">
          <sk-acao-programada sk-value="ctrl.acaoProgramada" 
                              sk-contexto="br.com.sankhya.modelcore.actionbutton.EventoProgramavelCtx" 
                              sk-acoes-programada-created="ctrl.acaoProgramada(acaoProgramada)"
                              sk-change="ctrl.validaStep()" 
                              flex>
           </sk-acao-programada>
      </file>

     <file name="appAcaoProgramada.js">
         angular
         .module('appAcaoProgramada',['snk'])
         .controller('TesteController', function(){
            var self = this;

            var _acaoProgramada;

            self.acaoProgramada = {};

             self.acaoProgramada = acaoProgramada;
      
             function acaoProgramada(acaoProgramada) {
                 _acaoProgramada = acaoProgramada;
             }

             function valida() {
                 var valido = _acaoProgramada && _acaoProgramada.validaDados();
                 console.log(valido);
             }
         });
     </file>
   </example>
  */
angular
    .module('snk.commons.acaoprogramada')
    .directive('skAcaoProgramada',
        function () {
            return {
                templateUrl: 'commons/acaoprogramada/acaoprogramada.tpl.html',
                controller: 'skAcoesController as ctrl',
                scope: {
                    dataset: '=?skDataset',
                    fieldName: '@?skFieldName',
                    interface: '@?skContexto',
                    isJava: '=?',
                    isBancoDados: '=?',
                    isScript: '=?',
                    value: '=?skValue',
                    onChange: '&?skChange',
                    acaoProgramadaCreated: '&?skAcaoProgramadaCreated',
                    height: '=?skHeight',
                    enableScriptLink: '=?skEnableScriptLink',
                    showControleTransacao:'=?skShowTransacao',
                    helpScript:'=?skHelpScript',
                    linguagensValue:'=?skLinguagensValue'
                },
                transclude: {
                    customElementOptionsType:'?skCustomElementOptionsType',
                    customElementScript:'?skCustomElementScript'
                }
            }
        })
    .controller('skAcoesController', ['AngularUtil', '$q', 'StringUtils', '$scope', 'MessageUtils', 'i18n', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils', 'SanPopup', '$timeout', 'AcaoProgramadaPopupService',
        function (AngularUtil, $q, StringUtils, $scope, MessageUtils, i18n, ServiceProxy, ObjectUtils, ArrayUtils, SanPopup, $timeout, AcaoProgramadaPopupService) {
            var self = this;

            const JAVA = 0;
            const BANCODADOS = 1;
            const SCRIPT = 2;

            if (angular.isUndefined($scope.height)) {
                $scope.height = '147px';
            }

            ObjectUtils.implements(self, FieldBinder, {
                scope: $scope,
                setData: setData,
                getData: getData
            });

            function setData(data) {
                if (data) {
                    $scope.value = angular.fromJson(data);
                }

                $scope.value = ObjectUtils.getEmptyAsUndefined($scope.value) || {};
            }

            function getData(){
                return angular.toJson($scope.value);
            }

            $scope.codeEditorID = 'code-editor' + StringUtils.nextUid();

            self.optionsType = [];

            self.changeType = changeType;
            self.runOnChange = runOnChange;
            self.openPopUp = openPopUp;

            if(angular.isUndefined($scope.enableScriptLink) || (angular.isDefined($scope.enableScriptLink) && $scope.enableScriptLink == true)){
                self.enableScriptLink = true;
            }

            //ROTINA BANCO DE DADOS 
            self.addProc = addProc;
            self.removeProc = removeProc;

            //ROTINA JAVA 
            self.openPopUpClasses = openPopUpClasses;
            self.onChangeModulo = onChangeModulo;

            self.creationCompleteEditor = creationCompleteEditor;
            self.changeLinguagem = changeLinguagem;
            self.enablenaNomeProc = false;

            var _linguagens = ['java', 'javascript', 'sql', 'sqlserver', 'xml', 'html', 'as', 'bash', 'sh'];
            var _editor;

            $scope.$watch("value['type']", function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    changeType(newValue);
                }
            });
            
            $scope.$watch("value['nameClass']", function (newValue, oldValue) {
                if (newValue !== self.nameClass) {
                    self.nameClass = newValue;
                }
            });

            init();
            function init() {
                if (angular.isUndefined($scope.interface) && StringUtils.isEmpty($scope.linguagensValue)){
                    throw Error("Erro interno: É necessário informar o nome da interface.");
                }

                if ($scope.acaoProgramadaCreated) {
                    $timeout(function () {
                        $scope.acaoProgramadaCreated({
                            acaoProgramada: {
                                validaDados: validaDados,
                                recria: recriaElements,
                            }
                        });
                    }, 0, false);
                }

                $scope.value = ObjectUtils.getEmptyAsUndefined($scope.value) || {};

                if ($scope.isJava !== false) {
                    self.optionsType.push({
                        data: JAVA,
                        value: i18n('Commons.Acaoprogramada.lblRotinajava')
                    });

                    self.nameClass = $scope.value['nameClass'];
                }

                if ($scope.isBancoDados !== false) {
                    self.optionsType.push({
                        data: BANCODADOS,
                        value: i18n('Commons.Acaoprogramada.lblBancosdados')
                    });

                    if ($scope.value['procName']) {
                        procedureExists();
                    }
                }

                if ($scope.isScript !== false) {
                    self.optionsType.push({
                        data: SCRIPT,
                        value: i18n('Commons.Acaoprogramada.lblScript')
                    });

                    if(StringUtils.isEmpty($scope.linguagensValue)){
                        buscaLinguagens();
                    }else{
                        self.linguagens = $scope.linguagensValue;
                    }
                }

                if (self.optionsType.length == 0) {
                    throw Error("Erro interno: É necessário utilizar ao menos uma ação.");
                }

                if (angular.isUndefined($scope.value['type'])) {
                    $scope.value['type'] = self.optionsType[0].data;
                }

                self.selectedIndex = $scope.value['type'];
            }

            function changeType(type) {
                self.selectedIndex = type;
                $scope.value['type'] = type;

                if (type == SCRIPT && angular.isUndefined($scope.value['linguagem'])) {
                    $scope.value['linguagem'] = self.linguagens[0].data;
                }

                runOnChange();
            }

            function validaDados(showMsg) {
                if ($scope.value['type'] == JAVA) {
                    if (angular.isUndefined($scope.value['moduloJava'])) {
                        if (showMsg) {
                            MessageUtils.showAlert(i18n('Commons.Acaoprogramada.informeModuloJava'));
                        }
                        return false;
                    }

                    if (StringUtils.isEmpty($scope.value['nameClass'])) {
                        if (showMsg) {
                            MessageUtils.showAlert(i18n('Commons.Acaoprogramada.selecaoClasses'));
                        }
                        return false;
                    }
                } else if ($scope.value['type'] == BANCODADOS) {
                    if (StringUtils.isEmpty($scope.value['procName'])) {
                        if (showMsg) {
                            MessageUtils.showAlert(i18n('Commons.Acaoprogramada.avisoprocName'));
                        }
                        return false;
                    }
                } else if ($scope.value['type'] == SCRIPT) {
                    if (StringUtils.isEmpty($scope.value['script'])) {
                        if (showMsg) {
                            MessageUtils.showAlert(i18n('Commons.Acaoprogramada.avisoscript'));
                        }
                        return false;
                    }

                    if (angular.isUndefined($scope.value['linguagem'])) {
                        if (showMsg) {
                            MessageUtils.showAlert(i18n('Commons.Acaoprogramada.avisosLinguagem'));
                        }
                        return false;
                    }
                }
                clear();
                return true;
            }

            function recriaElements() {
                $scope.value = {};

                angular.element(document.getElementById($scope.codeEditorID))
                    .replaceWith(AngularUtil.compile('<sk-code-editor id="{{::codeEditorID}}" '
                        + '                 ng-style="ctrl.linguagens.length > 1 && {\'height\': height} || {\'height\': \'185px\'}"  '
                        + ' 				sk-creation-complete="ctrl.creationCompleteEditor(editor)" '
                        + ' 				sk-mode="plain_text" '
                        + ' 				sk-value="value[\'script\']" '
                        + ' 				sk-change="ctrl.runOnChange()"> '
                        + ' </sk-code-editor> ', $scope));
            }

            function clear() {
                if ($scope.value['type'] != JAVA) {
                    delete $scope.value.moduloJava;
                    delete $scope.value.nameClass;
                }

                if ($scope.value['type'] != BANCODADOS) {
                    delete $scope.value.procName;
                }

                if ($scope.value['type'] != SCRIPT) {
                    delete $scope.value.script;
                    delete $scope.value.linguagem;
                }
            }

            function runOnChange() {
                ($scope.onChange || angular.noop)();

                if (self.useDataset($scope)) {
                    $scope.$evalAsync(function () {
                        $scope.dataset.notifyEditionStart(self);
                        $scope.dataset.setModified(self);
                    });
                }
            }

            //ROTINA SCRIPT INICIO

            self.clickHelpScript = function(){
                $scope.helpScript();
            };

            function buscaLinguagens() {
                ServiceProxy.callService('mge@AcaoProgramadaSP.getLinguagensToScript', {
                    script: {
                        interfaceName: $scope.interface
                    }
                }).then(function (response) {
                    self.linguagens = ArrayUtils.toArray(ObjectUtils.getProperty(response, 'responseBody.linguagens.linguagem'));
                });
            }

            function openPopUp() {
                var oldValue = angular.copy($scope.value);
                AcaoProgramadaPopupService.open($scope.label, $scope.value, $scope.enabled, $scope.interface, $scope.helpScript, $scope.linguagensValue)
                    .then(function (newValue) {
                        if (!ObjectUtils.equals(newValue, oldValue)) {
                            $scope.value = newValue;
                            runOnChange();
                        }
                    });
            }

            function creationCompleteEditor(editor) {
                _editor = editor;
                if (angular.isDefined($scope.value['linguagem'])) {
                    changeLinguagem($scope.value['linguagem'], true);
                }
            }

            function changeLinguagem(mode, ignoreChange) {
                if (_editor) {
                    var tema = 'plain_text';
                    for (var i = 0; i < _linguagens.length; i++) {
                        if (_linguagens[i] == (mode + "").toLowerCase()) {
                            tema = _linguagens[i];
                            break;
                        }
                    }
                    
                    _editor.setMode(tema);

                    //Nao e uma mudanca efetuado pelo usuario
                    if (ignoreChange) {
                        return;
                    }

                    runOnChange();
                }
            }
            //ROTINA SCRIPT FIM


            //ROTINA BANCO DE DADOS INICIO
            function addProc() {
                if (StringUtils.isEmpty($scope.value['procName'])) {
                    MessageUtils.showAlert(i18n('Commons.Acaoprogramada.avisoprocName'));
                } else {
                    procedureExists()
                        .then(function () {
                            ServiceProxy.callService('mge@AcaoProgramadaSP.createStoredProcedure', {
                                dbCall: {
                                    interfaceName: $scope.interface,
                                    procName: $scope.value['procName']
                                }
                            }).then(function (response) {
                                MessageUtils.showInfo(i18n('Commons.Acaoprogramada.criadoSucessoTitulo'), i18n('Commons.Acaoprogramada.criadoSucessoMsg'));
                                self.enablenaNomeProc = true;
                                runOnChange();
                            });
                        });
                }
            }

            function removeProc() {
                MessageUtils.simpleConfirm(i18n('Commons.Acaoprogramada.apagarProcTitulo'), i18n('Commons.Acaoprogramada.apagarProcMsg'))
                    .then(function (sim) {
                        ServiceProxy.callService('mge@AcaoProgramadaSP.dropStoredProcedure', {
                            action: {
                                procName: $scope.value['procName']
                            }
                        }).then(function (response) {
                            self.enablenaNomeProc = false;
                        });
                    });
            }

            function procedureExists() {
                return $q(function (resolve, reject) {
                    ServiceProxy.callService('mge@AcaoProgramadaSP.procedureExists', {
                        action: {
                            procName: $scope.value['procName']
                        }
                    }).then(function (response) {
                        self.enablenaNomeProc = StringUtils.toBoolean(ObjectUtils.getProperty(response, 'responseBody.action.procedureExists'));
                        self.enablenaNomeProc ? reject() : resolve();
                    });
                });
            }
            //ROTINA BANCO DE DADOS FIM



            //ROTINA JAVA INICIO
            function onChangeModulo() {
                if ($scope.value['nameClass'] != self.nameClass) {
                    $scope.value['nameClass'] = undefined;
                    self.nameClass = undefined;
                }
                runOnChange();
            }

            function openPopUpClasses(modulo) {
                if (angular.isUndefined(modulo)) {
                    MessageUtils.showAlert(i18n('Commons.Acaoprogramada.avisoSelecioneModulo'));
                } else {
                    var params = {
                        modulo: {
                            codModulo: modulo,
                            interfaceName: $scope.interface
                        }
                    };

                    ServiceProxy.callService('mge@AcaoProgramadaSP.getAcoesModulo', params)
                        .then(function (response) {
                            var actions = ArrayUtils.toArray(ObjectUtils.getProperty(response, 'responseBody.actions.action'));
                            var interfaceName = ObjectUtils.getProperty(response, 'responseBody.actions.interfaceName');

                            SanPopup.open({
                                title: i18n('Commons.Acaoprogramada.escolhaClassejava'),
                                templateUrl: 'commons/acaoprogramada/popUp/classeJavaPopUp.tpl.html',
                                controller: 'classeJavaPopUpController',
                                controllerAs: 'ctrl',
                                size: 'md',
                                height: 300,
                                resolve: {
                                    data: {
                                        actions: actions,
                                        interfaceName: interfaceName,
                                        nameClass: self.nameClass
                                    }
                                }
                            }).result.then(function (nameClass) {
                                $scope.value['nameClass'] = nameClass;
                                self.nameClass = nameClass;
                                runOnChange();
                            });
                        });

                }
            }
            //ROTINA JAVA FIM

        }
    ]);
angular
    .module('snk.components.input')
    .controller('SkAcaoProgramadaPopUpController', ['$scope', '$popupInstance', 'SkConstants', 'value', 'enabled', 'context','helpScript', 'linguagensValue', 
    	function ($scope, $popupInstance, SkConstants, value, enabled, context, helpScript, linguagensValue) {
        var self = this;
        $scope.value = value;
        $scope.enabled = enabled;
        $scope.context = context;

        self.valueScript = angular.copy(value);
        self.linguagensValue = angular.copy(linguagensValue);
        
        self.helpScript = helpScript;

        $scope.$success = function(){
            $popupInstance.success(self.valueScript);
        };

        $scope.onKeyDown = function($event) {
            var keyCode = $event.which || $event.keyCode;
            if ($event.ctrlKey && keyCode === SkConstants.KEY_CODE.ENTER) {
                $scope.$success();
            }
        };
    }]);
/**
 * Created by bruno.brandao on 31/05/2017.
 */
angular
    .module('snk.components.input')
    .service('AcaoProgramadaPopupService', ['SanPopup', 'i18n', function (SanPopup, i18n) {
        var self = this;

        self.open = open;

        function open(fieldDescr, value, enabled, context, helpScript, linguagensValue) {
            var popupInstance = SanPopup.open({
                templateUrl: 'commons/acaoprogramada/acaoprogramadascriptlink/acaoprogramadapopup.tpl.html',
                title: i18n('Commons.Acaoprogramada.lblScriptEdition', {campo: fieldDescr}),
                okBtnTooltip: i18n('Geral.lblAtalhoCtrlEnter'),
                size: 'lg',
                controller: 'SkAcaoProgramadaPopUpController',
                controllerAs: 'ctrl',
                resolve: {
                    value: function () {
                        return value;
                    },
                    enabled: function () {
                        return enabled;
                    },
                    context: function () {
                        return context;
                    },
                    helpScript:function() {
                    	return helpScript;
                    },
                    linguagensValue: function () {
                        return linguagensValue;
                    }
                }
            });

            return popupInstance.result;
        }

    }]);
angular
    .module('snk.commons.acaoprogramada')
    .controller('classeJavaPopUpController', ['i18n', 'data', 'ArrayUtils', '$scope', '$popupInstance', 'ObjectUtils',
        function (i18n, data, ArrayUtils, $scope, $popupInstance, ObjectUtils) {
            var self = this;

            var _nameClass;
            var _hasNotClass = false;

            $scope.$success = saveClass;

            self.adicionar = adicionar;
            self.saveClass = saveClass;

            self.msgAtencaoClasse = i18n('Commons.Acaoprogramada.msgAtencaoClasse', [data.interfaceName]);

            init();

            function init() {
                self.actions = data.actions;
                if (self.actions.length == 0) {
                    _hasNotClass = true;
                    self.actions.push({
                        className: {
                            $: i18n('Commons.Acaoprogramada.moduloNaoAcoes')
                        }
                    });
                } else {
                    if (angular.isDefined(data.nameClass)) {
                        adicionar(data.nameClass);
                    } else {
                        adicionar(ObjectUtils.getProperty(self.actions[0], 'className.$'));
                    }
                }
            }

            function adicionar(nameClass) {
                _nameClass = nameClass;
                self.actions.forEach(function (e) {
                    e['selected'] = nameClass == ObjectUtils.getProperty(e, 'className.$');
                });
            }

            function saveClass() {
                if (_hasNotClass) {
                    $popupInstance.dismiss();
                } else if (angular.isDefined(_nameClass)) {
                    $popupInstance.success(_nameClass);
                }
            }
        }
    ]);
/*
 *  Createad by Ítalo Araujo on 27/07/2018.
 */
angular
    .module('snk.commons.agendamentoBase')
    .controller('abaFrequenciaController', ['BlockProperties', 'i18n',
        function (BlockProperties, i18n) {
            var self = this;
            self.dynaformAgendadorEDIComercial = BlockProperties.dynaform;
            self.dsAgendamento = BlockProperties.dataset;
            self.tipoagendamento = BlockProperties.tipoagendamento;
        }
    ]);
/*
 *  Createad by Ýtalo Louis Araujo 25/07/2018.
 */
angular
    .module('snk.commons.agendamentoBase')
    .component('skAgendamentoBase', {
        templateUrl: 'commons/agendamentoBase/agendamento-base.tpl.html',
        controller: 'agendamentoBaseController',
        controllerAs: 'ctrl',
        bindings: {
            tipoFiltroAgendamento: '=skTipoFiltroAgendamento',
            dataset: '=skDataset',
            onLoadAgendamentoBase : '&?skOnLoadAgendamentoBase',
            customTabsAgendamento: '=?skCustomTabsAgendamento',
            validateConfig: '&skValidateConfig',
            helperClassName: '@?skHelperClassName',
            fnExecutarAgora: '&?skFnExecutarAgora',
            showBtnExecAgora: '=?skMostrarExecutarAgora'
        }
    })
    .controller('agendamentoBaseController', ['ObjectUtils', 'Criteria', 'MessageUtils', 'i18n', 'StringUtils', '$scope', 'AngularUtil', 'ArrayUtils',
        function (ObjectUtils, Criteria, MessageUtils, i18n, StringUtils, $scope, AngularUtil, ArrayUtils) {

            var self = this;
            var _tipoAgendamento = self.tipoFiltroAgendamento;
            var othersTabs = self.customTabsAgendamento;
            
            //Interceptors
            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, IDynaformInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);
            
            // Implementações da interface IDynaformInterceptor
            self.acceptField = acceptField;
            
            // Implementações da interface IDatagridInterceptor
            self.acceptColumnField = acceptColumnField;
            
            //Implementações da interface IFormInterceptor
            self.buildFieldContainer = buildFieldContainer;

            // Funções do controlador disponíveis no template
            self.onDynaformLoaded = onDynaformLoaded;
            self.customTabsLoader = customTabsLoader;
            self.getCriteria = getCriteria;
            self.validateFrequencia = validateFrequencia;
            self.executarAgora = executarAgora;
            self.showExecutarAgora = showExecutarAgora;

            init();

            function init() {
                if(!self.helperClassName){
                    self.helperClassName = 'br.com.sankhya.modelcore.dynaform.AgendadorValidacaoPedVendaPendDynaformHelper';
                }

                if (_tipoAgendamento == undefined || _tipoAgendamento == "") {
                    MessageUtils.showAlert(i18n('Commons.AgendamentoBase.messageFaltaTipoFiltroAgendamento'));
                    return;
                }
            }

            function onDynaformLoaded(dynaform, dataset) {

                if (dynaform.getEntityName() == 'AgendamentoTarefa') {

                    self.dynaformAgendadorEDIComercial = dynaform;
                    self.dsAgendamentos = dataset;

                    if(angular.isFunction(self.onLoadAgendamentoBase)){
                        self.onLoadAgendamentoBase({ agendamento: self.dsAgendamentos });
                    }
                    
                    self.dsAgendamentos.addCriteriaProvider(getCriteria);

                    self.dsAgendamentos.beforePostAction(function (dataset) {
                        self.dsAgendamentos.setFieldValue("TIPOAGE", _tipoAgendamento);
                        self.dsAgendamentos.setFieldValue("SEQUENCIA", 1);
                        
                        

                        try{
                            validateFrequencia(self.dsAgendamentos);

                            if(angular.isFunction(self.validateConfig)){
                                self.validateConfig({ dataset: self.dsAgendamentos });
                            }
                        } catch(e){
                            MessageUtils.showAlert(e.message);
                            return false;
                        }
                    });

                    self.dsAgendamentos.getFieldsMetadata().forEach(function (field) {
                        if ("STATUSULTEXEC" === field.name) {
                        	var uiTabName = i18n('Geral.lblGeral');
                        	
                        	field.properties.forEach(function(prop) {
                        		if (prop.name == 'UITabNameCustom') {
                        			uiTabName = prop.value; 
                        		}
                        	});
                        	
                            field.properties.push({ name: "UITabName", value: uiTabName });
                        }
                        
                    });
                
                    dynaform.setTabOrder([
                        'general',                        
                        'Horários',
                        'abaFrequencia',
                        'abaConfiguracoes'                        
                    ]);

                    dynaform.whenLoaded().then(() => {
                        var arrayTabInfo = [];
                        dynaform.getTabsInfo().forEach(function (propertie){
                            if (propertie.tabId === "mainTab") {
                                return;
                            }
                    
                            if (propertie.tabId === "general") {
                                propertie.tabName = i18n('Geral.lblGeral');
                            }
                    
                            arrayTabInfo.push(propertie);
                        });
                    
                        dynaform.setTabsInfo(arrayTabInfo);
                    });
                }
            }

            function customTabsLoader(entityName) {
                var customTabs = [];
                var firstTab = {
                    blockId: 'abaFrequencia',
                    description: i18n('Commons.AgendamentoBase.titleFrequenciaAgendamento'),
                    grayTabNav: true,
                    controller: 'abaFrequenciaController',
                    controllerAs: 'ctrl',
                    templateUrl: 'commons/agendamentoBase/abaFrequencia/aba-frequencia.tpl.html',
                    isLazyLoad: false,
                    properties: {
                        dataset: self.dsAgendamentos,
                        tipoagendamento: self.tipoFiltroAgendamento,
                        dynaform: self.dynaformAgendadorEDIComercial
                    }
                };

                customTabs.push(firstTab);
                
                if (othersTabs) {
                	var othersTabsArray = ArrayUtils.toArray(othersTabs);
                	
                	othersTabsArray.forEach(function(itemTab) {
                        if (!itemTab.properties) itemTab.properties = {}
                		itemTab.properties.dataset = self.dsAgendamentos;
                        itemTab.properties.dynaform = self.dynaformAgendadorEDIComercial;

                        if(itemTab.isLazyLoad === undefined){
                            itemTab.isLazyLoad = false;
                        }
                		
                		customTabs.push(itemTab);
                	});
                }

                return customTabs;
            }

            function getCriteria() {
                return Criteria('this.TIPOAGE = ?', _tipoAgendamento);
            }

            function validateFrequencia(dataset){
                if(StringUtils.isEmpty(dataset.getFieldValue("HORARIO"))){
                    throw Error(i18n('Commons.AgendamentoBase.messageNenhumHorario'));

                }else if(StringUtils.isEmpty(dataset.getFieldValue("MES"))){
                    throw Error(i18n('Commons.AgendamentoBase.messageEscolhaMes'));
    
                }
            }

            function executarAgora(){
                self.fnExecutarAgora();
            }

            function showExecutarAgora(){
                return self.showBtnExecAgora == undefined ?  angular.isFunction(self.fnExecutarAgora) : self.showBtnExecAgora;
            }
            function setTabOrder(tabOrder) {
                _tabOrder = [''];
            }
            
            function acceptColumnField(fieldMetadata, dataSet) {
				return acceptFieldImpl(dataSet.getEntityName(), fieldMetadata.name);
			}
			
			function acceptField(fieldMetadata, dataset){
				return acceptFieldImpl(dataset.getEntityName(), fieldMetadata.name);
			}
			
			function acceptFieldImpl(entityName, fieldName){
				if("AgendamentoTarefa" === entityName && "GERALOTEPARA" === fieldName){
					return _tipoAgendamento == 'FPA';
				}
				return true;
			}
            
            function buildFieldContainer(fieldName, dataset, fieldElem, scope) {
            	if(dataset.getEntityName() == "AgendamentoTarefa" && fieldName == 'GERALOTEPARA'){
            		if(_tipoAgendamento == 'FPA'){
	            		fieldElem.attr('flex', '');
	                    
	                    var helpTipElem = AngularUtil.createDirective('sk-help-tip', {
	                        'sk-help-tip': 'Determina qual o lote fiscal será emitido no agendamento. <br/>Agendamento para Serviços, use NFSe.<br/>Agendamento para Produtos, use NFe.<br/>',
	                        'style': 'margin-left: 5px'
	                    }, scope);
	
	                    var hBoxElem = AngularUtil.createDirective('sk-hbox', {
	                    	'layout-align': 'start center',
	                    	'flex': ''
	                    }, scope);
	                    hBoxElem.append(fieldElem);
	                    hBoxElem.append(helpTipElem);
	                    return hBoxElem;
            		}else{
            			fieldElem.attr('visivel', 'N');
            		}
            	}
            }

        }]);
angular.module('snk.commons.alertContratosPendentes')
    .component('skAlertContratosPendentes', {
        templateUrl: 'commons/alertContratosPendentes/alertContratosPendentes.tpl.html',
        controller: 'AlertContratosPendentesController',
        controllerAs: 'ctrl',
        bindings: {
            dataset: '=skDataset',
            compareSelected: '=?skCompareSelected',
            autoUpdate: '=?autoUpdate',
            onCreate: '&?onCreate',
            showPopupAlert: '=?showPopupAlert',
            showOnlySelected: '=?showOnlySelected'
        }
    })
    .controller('AlertContratosPendentesController', ['$scope', 'CrudUtils', 'MGEParameters', 'ContratosPendentes', 'i18n',
        function ($scope, CrudUtils, MGEParameters, ContratosPendentes, i18n) {
            var self = this;

            $scope.showBtnAlert = false;
            $scope.showContratosPendentes = showContratosPendentes;
            $scope.onDatasetCreated = onDatasetCreated;
            $scope.tooltip = self.showOnlySelected? i18n('Commons.AlertContratosPendentes.tooltipContratosPendentes') : i18n('Commons.AlertContratosPendentes.tooltipContratosPendentesGeral');

            self.update = update;

            var _dsContratoReajuste;
            var _contratosPendentes = [];
            var _notificarPendencias = false;

            init();

            function init() {
                if(self.onCreate) {
                    self.onCreate({alertContratosPendentes: self});
                }

                _notificarPendencias = MGEParameters.asBoolean('serv.notifica.pendencia.contrato');

                if(self.autoUpdate && self.dataset) {
                    self.dataset.addRefreshedListener(update);
                }
            }

            function onDatasetCreated(dataset) {
                _dsContratoReajuste = dataset;
                _dsContratoReajuste.addCriteriaProvider(CriteriaProvider.build(criteriaReajustesPendentes));
                _dsContratoReajuste.init();
            }

            function update() {
                if(_notificarPendencias) {
                    _dsContratoReajuste.refresh().finally(() => {
                        let contratos = _dsContratoReajuste.getRecordsAsObjects();
                        let records = self.compareSelected? self.dataset.getSelectedRecordsAsObjects() : self.dataset.getRecordsAsObjects();
    
                        _contratosPendentes = [];
                        records.forEach(record => {
                            if (contratos.find(contrato => contrato.NUMCONTRATO == record.NUMCONTRATO)) {
                                _contratosPendentes.push({
                                    NUMCONTRATO: record.NUMCONTRATO,
                                    CODPARC: record.CODPARC,
                                    NOMEPARC: record['Parceiro.NOMEPARC'],
                                    DTBASEREAJ: record.DTBASEREAJ,
                                    FREQREAJ: record.FREQREAJ,
                                    CODMOEDA: record['Moeda.CODMOEDA'],
                                    NOMEMOEDA: record['Moeda.NOMEMOEDA']});
                            }
                        });
                        $scope.showBtnAlert = _contratosPendentes.length > 0;
                        
                        if(self.showPopupAlert && _contratosPendentes.length > 0) {
                            ContratosPendentes.show(_contratosPendentes);
                        }
                    });
                }
            }

            function showContratosPendentes(){
                ContratosPendentes.showContratosPendentes(_contratosPendentes);
            }

            function criteriaReajustesPendentes() {
                let criteria = Criteria();

                let exp = "this.NUMCONTRATO <> 0";
                exp += " and Contrato->CODMOEDA <> 0";
                exp += " and Contrato->FREQREAJ <> 0";
                exp += " and Contrato->TIPOARM <> 'A'";

                if (MGEParameters.asBoolean('serv.reajustar.contrato.apartir.data.base.reajuste')) {
					exp += " and truncMonth(addMonths(Contrato->DTBASEREAJ, Contrato->FREQREAJ)) < ?";
				} else {
					exp += " and truncMonth(addMonths(Contrato->DTBASEREAJ, Contrato->FREQREAJ - :OFFSET)) <= ?";
				}

                exp += " and this.SITPROD = 'A'";
                exp += " and EXISTS(SELECT 1 FROM TCSPRE P1 WHERE P1.NUMCONTRATO = this.NUMCONTRATO AND P1.CODPROD = this.CODPROD AND P1.REFERENCIA = (SELECT MAX(REFERENCIA) FROM TCSPRE P2 WHERE P2.NUMCONTRATO = this.NUMCONTRATO AND P2.CODPROD = this.CODPROD AND P2.REFERENCIA <= ?) AND P1.VALOR <> 0)"
                criteria.and(exp);
                
                return criteria;
            }
        }
    ]);
angular
    .module('snk.commons.alertContratosPendentes')
    .controller('ContratosPendentesController', ['$scope', '$popupInstance', 'options', 'SkApplicationInstance', 'GridConfig', 'MessageUtils', 'i18n', 'MGEParameters',
        function ($scope, $popupInstance, options, SkApplicationInstance, GridConfig, MessageUtils, i18n, MGEParameters) {
            var self = this;

            self.resourceID = SkApplicationInstance.getResourceID();
            self.gridContratosPendentesConfig = self.resourceID + '.GridContratosPendentes';
            
            self.onDatasetCreated = onDatasetCreated;
            self.onDatagridLoaded = onDatagridLoaded;
            self.dblClickContrato = dblClickContrato;

            $scope.$success = onConfirm;

            self.navOptions = self.navigatorOptions = {
                showAddButton: false,
                showCopyButton: false,
                showRemoveButton: false,
                showRefreshButton: false,
                showCancelButton: false,
                showSaveButton: false,
                showEditButton: false
            };

            init();

            function init() {
                GridConfig.registerGridConfig(self.gridContratosPendentesConfig, self.gridContratosPendentesConfig, undefined, true);
            }

            function onDatasetCreated(name, dataset) {
                self[name] = dataset;
                
                dataset.whenMetadataLoaded().then(function () {
                    self[name].addRecordsAsObjects(options.contratosPendentes);
                });

                dataset.init()

            }

            function onDatagridLoaded(name, datagrid) {
                self[name] = datagrid;
            }

            function onConfirm() {
                let html5Desabilitado = MGEParameters.asBoolean('mge.core.desabilita.html5');
                if(html5Desabilitado) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.AlertContratosPendentes.msgHtmlDesabilitado'));
                    return;
                }

                let contratos = [];
                options.contratosPendentes.forEach(contrato => {
                    contratos.push(contrato.NUMCONTRATO);
                })
        
                SkApplicationInstance.openApp("br.com.sankhya.mgeos.reajuste.contrato", contratos);
                $popupInstance.success();
            }

            function dblClickContrato() {
                let numContrato = self['dsContratosPendentes'].getFieldValue("NUMCONTRATO");

                SkApplicationInstance.openApp("br.com.sankhya.os.cad.contratos", { NUMCONTRATO: numContrato });
                $popupInstance.success();
            }
        }])
angular
    .module('snk.commons.alertContratosPendentes')
    .service('ContratosPendentes', ['SanPopup', 'SkI18nService', 'MessageUtils',
        function (SanPopup, SkI18nService, MessageUtils) {
            var self = this;
            self.show = show;
            self.showContratosPendentes = showContratosPendentes;

            function show(contratosPendentes) {
                MessageUtils.simpleConfirmBuilder()
                    .title('Geral.msgtitleAviso')
                    .msg('Commons.AlertContratosPendentes.msgContratosPendentes')
                    .showAsWarning(true)
                    .noLabel('Commons.AlertContratosPendentes.btnSaibaMais')
                    .okLabel('Geral.buttonOK')
                    .okTheme('default')
                    .show()
                    .then(null, () => showContratosPendentes(contratosPendentes));

            }

            function showContratosPendentes(contratosPendentes) {
                var popup = SanPopup.open({
                    title: SkI18nService.instant('Commons.AlertContratosPendentes.titleContratosPendentes'),
                    templateUrl: 'commons/alertContratosPendentes/contratosPendentes.tpl.html',
                    controller: 'ContratosPendentesController',
                    controllerAs: 'ctrl',
                    type: 'default',
                    okBtnLabel: SkI18nService.instant('Commons.AlertContratosPendentes.btnIrReajuste'),
                    okBtnClass: 'btn-primary',
                    cancelBtnClass: 'btn-default',
                    cancelBtnLabel: SkI18nService.instant('Geral.lblFechar'),
                    showBtnNo: false,
                    showBtnCancel: true,
                    bodyPadding: false,
                    size: 'lg',
                    resolve: {
                        options: {
                            contratosPendentes: contratosPendentes
                        }
                    }
                });

                return popup.result;
            }
        }])
angular
    .module('snk.commons')
    .controller('PopUpParametrosFiltroAliquotaICMSController', ['$scope', '$popupInstance', 'MessageUtils', 'i18n', 'filtro', 'ServiceProxy', 'StringUtils', 'ObjectUtils',
        function ($scope, $popupInstance, MessageUtils, i18n, filtro, ServiceProxy, StringUtils, ObjectUtils) {
            var self = this;

            self.filtro = filtro;
            self.clearValue = clearValue;

            $scope.$success = validarFiltro;

            init();

            function init() {
                self.usaProduto = self.usaGrupoProduto = self.usaPerfilPrincipal = self.usaTop = self.usaCidOrigem = self.usaCidDestino = false;
                self.usaEmpresa = self.usaFinOperacao = self.usaGrupoIcmsParceiro = self.usaGrupoIcmsProduto = self.usaGrupoIcms2 = false; 
                self.usaGrupoIcmsGrupoProduto = self.usaTare = false;
                resolveCombos("E");
				resolveCombos("I");
				resolveCombos("K");
				resolveCombos("J");
            }

            function resolveCombos(value) {
                var request = {
                        param: {
                            tipo: value
                        }
                };

                ServiceProxy.callService('mgecom@AliquotaICMSSP.resolveCombosRestricao', request).then(
                    function(response) {
                        var rows = ObjectUtils.getProperty(response, 'responseBody.rowsCombo');

                        if (angular.isUndefined(rows)) {
                            return;
                        }

                        var dp = new Array();

                        if (!angular.isUndefined(rows.rowCombo)) {
                        	rows.rowCombo.forEach(function(row) {
                        		var obj = new Object();

                        		obj.data = row.grupoIcms;
                        		obj.value = row.$;

                        		dp.push(obj);
                        	});
                        }

                        if (value == "E") {
                            self.cbxGrupoIcmsParceiroOpts = dp;
                        } else if(value == "I") {
                            self.cbxGrupoIcmsProdutoOpts = dp;
                        } else if(value == "K") {
                            self.cbxGrupoIcms2Opts = dp;
                        } else if(value == "J") {
                            self.cbxGrupoIcmsGrupoProdutoOpts = dp;
                        }
                    });
            }

            function clearValue(switchValue, valueToClean) {
                if (!switchValue) {
                    self[valueToClean] = undefined;
                }
            }

            function validarFiltro() {
                if (temCamposMarcados()) {
                    validarFiltroAliquotaICMS();
                }
            }

            function temCamposMarcados() {
                var result = true;

                if (StringUtils.isEmpty(self.codUfOrigem) || StringUtils.isEmpty(self.codUfDestino)) {
                    MessageUtils.showAlert(i18n('Comercial.AliquotaICMS.camposObrigatorios'));
                    result = false;
                } else if (!isParametroPreenchido(self.usaProduto, self.codProduto) || !isParametroPreenchido(self.usaGrupoProduto, self.codGrupoProduto) || !isParametroPreenchido(self.usaPerfilPrincipal, self.codPerfil) ||
                           !isParametroPreenchido(self.usaTop, self.tipoOperacao) || !isParametroPreenchido(self.usaCidOrigem, self.codCidOrigem) || !isParametroPreenchido(self.usaCidDestino, self.codCidDestino) ||
                           !isParametroPreenchido(self.usaEmpresa, self.codEmpresa) || !isParametroPreenchido(self.usaFinOperacao, self.finOperacao) || !isParametroPreenchido(self.usaGrupoIcmsParceiro, self.cbxGrupoIcmsParceiro) ||
                           !isParametroPreenchido(self.usaGrupoIcmsProduto, self.cbxGrupoIcmsProduto) || !isParametroPreenchido(self.usaGrupoIcms2, self.cbxGrupoIcms2) || !isParametroPreenchido(self.usaGrupoIcmsGrupoProduto, self.cbxGrupoIcmsGrupoProduto)) {
                    MessageUtils.showAlert(i18n('Comercial.AliquotaICMS.checkMarcadoParametroNaoInformado'));
                    result = false;
                }

                return result;
            }

            function isParametroPreenchido(switchValue, parameterValue) {
                var result = true;

                if (switchValue && angular.isUndefined(parameterValue)) {
                    result = false;
                }

                return result;
            }

            function validarFiltroAliquotaICMS() {
                var request = {
                    params: {
                        FILTRO: {$: self.filtro },
                        UFORIGEM: {$: self.codUfOrigem},
                        UFDESTINO: {$: self.codUfDestino},

                        USACODPROD: {$: self.usaProduto},
                        CODPROD: {$: self.codProduto},

                        USACODGRUPOPROD: {$: self.usaGrupoProduto},
                        CODGRUPOPROD: {$: self.codGrupoProduto},

                        USACODTIPPARC: {$: self.usaPerfilPrincipal},
                        CODTIPPARC: {$:self.codPerfil},

                        USACODTIPOPER: {$: self.usaTop},
                        CODTIPOPER: {$: self.tipoOperacao},

                        USACIDORIGEM: {$: self.usaCidOrigem},
                        CIDORIGEM: {$: self.codCidOrigem},

                        USACIDDESTINO: {$: self.usaCidDestino},
                        CIDDESTINO: {$: self.codCidDestino},

                        USACODEMP: {$: self.usaEmpresa},
                        CODEMP: {$: self.codEmpresa},

                        USANUFOP: {$: self.usaFinOperacao},
                        NUFOP: {$: self.finOperacao},

                        USAGIPARC: {$: self.usaGrupoIcmsParceiro},
                        GIPARC: {$: self.cbxGrupoIcmsParceiro},

                        USAGIPROD: {$: self.usaGrupoIcmsProduto},
                        GIPROD: {$: self.cbxGrupoIcmsProduto},

                        USAGIPROD2: {$: self.usaGrupoIcms2},
                        GIPROD2: {$: self.cbxGrupoIcms2},

                        USAGIGRUPOPROD: {$: self.usaGrupoIcmsGrupoProduto},
                        GIGRUPOPROD: {$: self.cbxGrupoIcmsGrupoProduto},

                        TARENRO: {$: self.usaTare}
                    }
                };

                ServiceProxy.callService('mgecom@AliquotaICMSSP.validarFiltroAliquotaICMS', request).then(
                    function (response) {
                        var idAliquota = ObjectUtils.getProperty(response, 'responseBody.IDALIQ');

                        MessageUtils.showInfo(i18n('Comercial.AliquotaICMS.filtroExecutadoComSucesso', [idAliquota.$]));
                        $popupInstance.dismiss();
                    },
                    function (err) {
                        $popupInstance.dismiss();
                    }
                );
            }
        }
    ]);
/**
 * Created by cleverson.puche on 04/11/2016.
 */
angular
	.module('snk.commons')
	.service('AliquotasICMSPopupService', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;

			self.open = open;

			function open(filtro) {
				return SanPopup.open({
                    title: i18n('Comercial.AliquotaICMS.popUpParametrosFiltroAliquotaICMS'),
                    templateUrl: 'commons/aliquotaicms/popupparametrosfiltroaliquotaicms.tpl.html',
                    controller: 'PopUpParametrosFiltroAliquotaICMSController',
                    controllerAs: 'ctrl',
                    okBtnLabel: i18n('Comercial.AliquotaICMS.btnValidar'),
                    showBtnNo: false,
                    showBtnCancel: true,
                    size: 'lg',
                    grayBG: true,
                    resolve: {
                        filtro: filtro
                    }
                }).result;
			}
		}
    ]);
angular
    .module('snk.commons.analiseEnvioExpedicao')
    .controller('AnaliseEnvioExpedicaoController', ['$rootScope', 'ObjectUtils', '$scope', 'ServiceProxy', 'DateUtils', 'MessageUtils', 'i18n', 'SkApplicationInstance', '$q', 
        function ($rootScope,   ObjectUtils, $scope, ServiceProxy, DateUtils,  MessageUtils, i18n, SkApplicationInstance, $q) {
            var self = this;

            var TOTAL_PERCENT = "100";
            var _percentWidth = $scope.percentWidth ?  $scope.percentWidth : TOTAL_PERCENT;
            var _percentHeight = $scope.percentHeight ?  $scope.percentHeight : TOTAL_PERCENT;
            self.styleWizard = "position: absolute; "
                                + "width: " + _percentWidth +"%;"
                                + "height: " + _percentHeight +"%"

            self.loadingComplete = false;
            self.onLoadWizard = onLoadWizard;
            self.onCancel = onCancel;
            self.onFinish = onFinish;
            self.wizardContext = {};
            self.onClickBtnFormacaoCarga = onClickBtnFormacaoCarga;

            init();

            function init() {
            
                if(angular.isFunction($scope.onCreate)){
                    $scope.onCreate({analiseEnvioExpedicao: self});
                }

                self.loadingComplete = true;
            }


            function onFinish() {
              //  $popupInstance.success();
            }

            function onCancel() {
                close();
            }
    
            function close() {
               // $popupInstance.dismiss();
            }

            function onLoadWizard(wizard) {
                self.wizard = wizard;
            }

            function onClickBtnFormacaoCarga(){
                if(angular.isFunction($scope.onClickBtnFormacaoCarga)){
                    $scope.onClickBtnFormacaoCarga();
                }
            }
            

      
    }]);
angular
    .module('snk.commons.analiseEnvioExpedicao')
    .directive('skAnaliseEnvioExpedicao', [
        function () {
            return {
                scope: {
                    onCreate: '&?skOnCreateAnaliseEnvioExpedicao',
                    resourceID: '=?skResourceId',
                    percentWidth : '=?skPercentWidth',
                    percentHeight : '=?skPercentHeight',
                    cancelHandler: '&?skCancelHandler',
                    finishHandler: '&?skFinishHandler',
                    onClickBtnFormacaoCarga: '&?skOnClickBtnFormacaoCarga'
                },
                controller: 'AnaliseEnvioExpedicaoController',
                controllerAs: 'ctrl',
                restrict: 'E',
                templateUrl: 'commons/analiseEnvioExpedicao/analiseEnvioExpedicao.tpl.html'
            };
        }]);
angular
    .module('snk.commons.analiseEnvioExpedicao')
    .controller('AnaliseEnvioExpedicaoStepController', ['KeyboardManager', 'SkApplicationInstance', 'Criteria', 'MessageUtils', 'i18n', 'DateUtils', 'ObjectUtils', 'GridConfig','AngularUtil','ServiceProxy',
        function (KeyboardManager, SkApplicationInstance, Criteria, MessageUtils, i18n, DateUtils, ObjectUtils, GridConfig, AngularUtil, ServiceProxy) {
            var self = this;

            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);

            self.resourceID = SkApplicationInstance.getResourceID();
            self.onDatasetCreatedResultAnaliseEnvio = onDatasetCreatedResultAnaliseEnvio;
            self.onDatagridLoadedResultAnaliseEnvio = onDatagridLoadedResultAnaliseEnvio;
            self.onDatasetCreatedAnaliseEnvioDocs = onDatasetCreatedAnaliseEnvioDocs;
            self.onDatagridLoadedAnaliseEnvioDocs = onDatagridLoadedAnaliseEnvioDocs;
            self.dbClickResultAnaliseEnvio = dbClickResultAnaliseEnvio;
            self.dbClickAnaliseEnvioDocs = dbClickAnaliseEnvioDocs;
            self.gridConfigIdResultAnaliseEnvio = self.resourceID + '.ResultAnaliseEnvio';
            self.gridConfigIdAnaliseEnvioDocs = self.resourceID + '.AnaliseEnvioDocs';
            self.voltarFormacaoCarga = voltarFormacaoCarga;
            self.gerarAnalise = gerarAnalise;
            self.dsResultAnaliseEnvio;
            self.dgResultAnaliseEnvio;
            self.dsAnaliseEnvioDocs;
            self.dgAnaliseEnvioDocs;
            self.nuNota;
            self.ordemCarga;
            self.concluir = concluir;
            self.verificaNuNotaOrdemCarga = verificaNuNotaOrdemCarga;
            self.changeButtonActionsResultEnvio;
            self.changeButtonActionAnaliseEnvioDocs;
            self.wasProcessed = false;
            self.resourceID_preferencias = "br.com.sankhya.core.cfg.Preferencias";
            self.resourceID_produto = "br.com.sankhya.core.cad.produtos";
            self.resourceID_enderecoArmazenamento = "br.com.sankhya.wms.EnderecoArmazenamento";
            self.resourceID_divergenciaEstoque = "br.com.sankhya.wms.DivergenciasWMS";
            self.resourceID_areaSeparacao = "br.com.sankhya.wms.cad.areadeseparacao";

            init();

            function init() {
            
                GridConfig.registerGridConfig(self.gridConfigIdResultAnaliseEnvio, self.gridConfigIdResultAnaliseEnvio, undefined, true);
                GridConfig.registerGridConfig(self.gridConfigIdAnaliseEnvioDocs, self.gridConfigIdAnaliseEnvioDocs, undefined, false);

                self.changeButtonActionsResultEnvio = [{
                    label: i18n('Controls.GridConfig.buttonGridConfig'),
                    action: openGridConfig
                }];

                self.changeButtonActionAnaliseEnvioDocs = [{
                    label: i18n('Controls.GridConfig.buttonGridConfig'),
                    action: openGridConfigAnaliseEnvioDocs
                }];

            }

            function getCriteriaAnaliseEnvioDocs() {

                var criteria = new Criteria(" 1= 1");

                criteria.and("this.NUNOTA  = ? ", self.dsResultAnaliseEnvio.getFieldValue("NUNOTA"));

                return criteria;

            }

            function onDatasetCreatedResultAnaliseEnvio(dataset) {
                self.dsResultAnaliseEnvio = dataset;
                self.dsResultAnaliseEnvio.initAndRefresh();
            }

            function onDatasetCreatedAnaliseEnvioDocs(dataset) {
                self.dsAnaliseEnvioDocs = dataset;
                self.dsAnaliseEnvioDocs.addCriteriaProvider(new CriteriaProvider.build(getCriteriaAnaliseEnvioDocs));
                self.dsAnaliseEnvioDocs.initAndRefresh();
            }

            function onDatagridLoadedResultAnaliseEnvio(datagrid) {
                self.dgResultAnaliseEnvio = datagrid;
            }

            function onDatagridLoadedAnaliseEnvioDocs(datagrid) {
                self.dgAnaliseEnvioDocs = datagrid;
            }

            function gerarAnalise() {
                const param = {
                    params: {
                        ordemCarga: self.ordemCarga === undefined ? 0 : self.ordemCarga,
                        nuNota: self.nuNota === undefined ? 0 : self.nuNota
                    }
                };

                ServiceProxy.callService('mgecom@AnaliseEnvioExpedicaoSP.gerarAnaliseEnvExp', param).then(
                    function(response){
                        self.dsResultAnaliseEnvio.initAndRefresh();
                        self.dsAnaliseEnvioDocs.initAndRefresh();
                        self.wasProcessed = response.responseBody.result.wasProcessed == 'true' ? true : false;
                        if (self.wasProcessed) {
                            MessageUtils.showInfo(i18n('Análise executada com sucesso!'));
                        } else {
                            MessageUtils.showAlert(i18n('Não foi encontrada nenhuma análise para esta ordem de carga, pedido ou nota!'));
                        }
                    });
            }


            function concluir() {
                SkApplicationInstance.openApp('br.com.sankhya.mgecom.cad.formacaocarga');
                SkApplicationInstance.closeApp();
            }
            

            function dbClickResultAnaliseEnvio(resultAnaliseEnvio) {
                switch (self.dsResultAnaliseEnvio.getFieldValue("CHAVEROTINA")) {
                    case self.resourceID_produto:
                        SkApplicationInstance.openApp(self.resourceID_produto, {
                            CODPROD: self.dsResultAnaliseEnvio.getFieldValue("CODPROD")
                        });
                        break;
                    case self.resourceID_preferencias:
                        SkApplicationInstance.openApp(self.resourceID_preferencias, {
                            CHAVE: "LOTEENVIOWMS",
                            CODUSU: SkApplicationInstance.getUserID()
                        });
                        break;
                    case self.resourceID_enderecoArmazenamento:
                        SkApplicationInstance.openApp(self.resourceID_enderecoArmazenamento, {
                            CODPROD: self.dsResultAnaliseEnvio.getFieldValue("CODPROD")
                        });
                        break;
                    case self.resourceID_divergenciaEstoque:
                        SkApplicationInstance.openApp(self.resourceID_divergenciaEstoque, {
                            CODPROD: self.dsResultAnaliseEnvio.getFieldValue("CODPROD")
                        });
                        break;
                    case self.resourceID_areaSeparacao:
                        SkApplicationInstance.openApp(self.resourceID_areaSeparacao);
                        break;
                }
            }

            function dbClickAnaliseEnvioDocs(resultAnaliseEnvio) {
                resultAnaliseEnvio.changeFace();
            }

            function verificaNuNotaOrdemCarga() {
                return (self.ordemCarga == undefined  && self.nuNota == undefined);
            }

            function openGridConfig() {
                GridConfig.openGridconfig(self.gridConfigIdResultAnaliseEnvio);
            }

            function openGridConfigAnaliseEnvioDocs() {
                GridConfig.openGridconfig(self.gridConfigIdAnaliseEnvioDocs);
            }

            function voltarFormacaoCarga() {
                var analiseEnvioExpedicaoCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-analise-envio-expedicao"))
                if (angular.isDefined(analiseEnvioExpedicaoCtrl)) {
                    analiseEnvioExpedicaoCtrl.onClickBtnFormacaoCarga();
                }
            } 

        }]);
angular
    .module("snk.commons.armazem")
    .controller('SKSearchFieldCustomController', ['MessageUtils', '$scope', '$element', '$attrs', 'ServiceProxy', 'ObjectUtils', 'StringUtils', '$q', '$timeout', 'SkPesquisaService', 'SkI18nService', 'AngularUtil', 'DatasetUtils', '$translate', 'Criteria', 'SkConstants',
    function (MessageUtils, $scope, $element, $attrs, ServiceProxy, ObjectUtils, StringUtils, $q, $timeout, SkPesquisaService, SkI18nService, AngularUtil, DatasetUtils, $translate, Criteria, SkConstants) {
    
    	var self = this;
    	
    	ObjectUtils.implements(self, FieldBinder, {
            scope: $scope,
            setData: setData,
            getData: getData
        });
    	
    	var lastCodeValue = undefined;
    	var lastCodeValuePresentation = undefined;
    	
    	$scope.onCodeKeyDown = onCodeKeyDown;
    	$scope.onCodeInputFocusOut = onCodeInputFocusOut;
    	$scope.onCodeInputClick = onCodeInputClick;
    	$scope.onCodeInputChange = onCodeInputChange;
    	$scope.defaultPlaceholder = angular.isUndefined($scope.placeholder) ? "pesquisar.." : $scope.placeholder;
    	$scope.codeValuePresentation;
    	
    	if($attrs.skDataset){
            $scope.$watch('dataset', init);
        } else {
            init();
        }
    	
    	function init() {
    		setCodeValuePresentation();
    	}
    	
    	function setData(data, options) {
            $timeout(function() {
                $scope.codeValue = data;
                setCodeValuePresentation();
                
                if (options && options.programmatically){
                	if (!StringUtils.isEmpty($scope.codeValue) && $scope.codeValue != lastCodeValue) {
                		loadDescription($scope.codeValue, true);
            		}
                }
                
                lastCodeValue = data;
                if ($scope.dataset && $scope.fieldPresentation) {
                	lastCodeValuePresentation = $scope.dataset.getFieldValue($scope.fieldPresentation);
            	}
            }, 0);
        }

        function getData(options) {
            return $scope.codeValue;
        }
        
        function setCodeValuePresentation() {
        	if ($scope.dataset && $scope.fieldPresentation) {
        		$scope.codeValuePresentation = $scope.dataset.getFieldValue($scope.fieldPresentation);
        	} else {
        		$scope.codeValuePresentation = $scope.codeValue;
        	}
        }
    	
    	function onCodeKeyDown($event) {
            switch ($event.keyCode) {
                case SkConstants.KEY_CODE.ENTER:
                    if ($scope.codeValuePresentation) {
                        loadDescription($scope.codeValuePresentation);
                    } else {
                        openPesquisaPopUp();
                    }

                    $event.preventDefault();
                break;

                case SkConstants.KEY_CODE.DOWN_ARROW:
                    if ($event.altKey || $event.ctrlKey) {
                        openPesquisaPopUp();
                        $event.preventDefault();
                    }
                    break;
            }
        }
    	
    	function onCodeInputClick(){
    		openPesquisaPopUp();
    	}
    	
    	function onCodeInputChange(){
    	}
    	
    	function onCodeInputFocusOut(){
            $scope.$evalAsync(function(){
            	if (!StringUtils.isEmpty($scope.codeValuePresentation) && $scope.codeValuePresentation != lastCodeValuePresentation) {
            		loadDescription($scope.codeValuePresentation);
            	} else if (StringUtils.isEmpty($scope.codeValuePresentation) && $scope.codeValuePresentation != lastCodeValuePresentation) {
            		clearValues();
            		changeHandler();
            	}
            });
        }
    	
    	function loadDescription(value, byPk) {
    		var options;
    		var criteria;
    		
    		if (byPk) {
    			criteria = buildCriteriaPK();
    		} else {
    			criteria = buildCriteria();
    		}
    		value = angular.isDefined(criteria) ? undefined : value;
    		
    		SkPesquisaService.loadSuggestions(getEntityName(), value, undefined, undefined, criteria, options)
            .then(function(entity){
                if (entity) {
                	var rows = entity.data.map(function(item){
                        var row = {
                            key : item[entity.pkField],
                            label: item[entity.descriptionField],

                            entityName: $scope.entityName,
                            pkField: entity.pkField,
                            descriptionField: entity.descriptionField,
                            entityDescription: entity.entityDescription,
                            data: item,
                            fieldsMetadata: entity.fieldsMetadata,
                            resourceID: entity.resourceID
                        };

                        return row;
                    });
                	
                	if (rows.length <= 0) {
                		MessageUtils.showAlert('Nenhum registro encontrado.');
                		resetValues();
                		
                	} else if (rows.length == 1) {
                		onSelect(rows[0].data);
                		
                	} else {
                		openPesquisaPopUp(value);
                	}
                }
            }, function(){
            	clearValues(false, true);
            	
            }).finally(function(){
                
            });
    	}
    	
    	function openPesquisaPopUp(value) {
    		SkPesquisaService.openPesquisaPopUp(getEntityName(), value, {
                label: $scope.entityName,
                loadOnCreate: true,
                enviromentCriteria: buildCriteria
            }).then(function (result) {
                if (result && result.data) {
                	onSelect(result.data);
                }
            });
    	}
    	
    	function onSelect(data) {
    		if ($scope.dataset && $scope.fieldCriteria) {
    			$scope.codeValuePresentation = data[$scope.fieldCriteria];
    		} else {
    			$scope.codeValuePresentation = data[$scope.fieldName];
    		}
    		
    		if ($scope.dataset && $scope.targetField) {
    			$scope.codeValue = data[$scope.targetField];
    		} else {
    			$scope.codeValue = data[$scope.fieldName];
    		}
    		
    		lastCodeValue = $scope.codeValue;
    		lastCodeValuePresentation = $scope.codeValuePresentation;
    		
    		changeHandler();
    		
    		if (angular.isFunction($scope.onSelectData)) {
    			$scope.onSelectData(data);
    		}
    	}
    	
    	function buildCriteriaPK() {
    		var criteria;
    		
    		if ($scope.dataset && $scope.fieldName && $scope.codeValue) {
    			criteria = Criteria("this."+$scope.fieldName+" = ?", [$scope.codeValue]);
    		}
    		
    		criteria = buildEnviromentCriteria(criteria);
    		
    		return criteria;
    	}
    	
    	function buildCriteria() {
    		var criteria;
    		
    		if ($scope.dataset && $scope.fieldCriteria && $scope.codeValuePresentation) {
    			criteria = Criteria("this."+$scope.fieldCriteria+" = ?", [$scope.codeValuePresentation]);
    		}
    		
    		criteria = buildEnviromentCriteria(criteria);
    		
            return criteria;
    	}
    	
    	function buildEnviromentCriteria(criteria) {
    		if ($scope.enviromentCriteria) {
                var envCriteria = $scope.enviromentCriteria();

                if (envCriteria) {
                    ObjectUtils.isImplementorOf(envCriteria, Criteria);

                    if (!criteria){
                        criteria = Criteria(envCriteria.getExpression(), envCriteria.getParameters());
                    } else {
                        criteria.and(envCriteria.getExpression(), envCriteria.getParameters());
                    }
                }
            }
    		
    		return criteria;
    	}
    	
    	function getEntityName() {
    		return $scope.entityName ? $scope.entityName : $scope.dataset.getEntityName();
    	}
    	
    	function resetValues() {
    		$scope.codeValue = lastCodeValue;
    		$scope.codeValuePresentation = lastCodeValuePresentation;
    	}
    	
    	function clearValues() {
    		$scope.codeValue = undefined;
    		$scope.codeValuePresentation = undefined;
    	}
    	
    	function changeHandler() {
            if (self.useDataset()){
                self.notifyChangeToDataset();
            }
        }

}]);

angular
    .module("snk.commons.armazem")
    .directive("skSearchFieldCustom", [
        function () {
            return {
                templateUrl: 'commons/armazem/searchFieldCustom/search-field-custom.tpl.html',
                controller: 'SKSearchFieldCustomController',
                controllerAs: 'ctrl',
                scope: {
                	dataset: '=?skDataset',
                	entityName: '@?skEntityName',
                	fieldName: '@?skFieldName',
                	targetField: '@?skTargetField',
                	fieldCriteria: '@?skFieldCriteria',
                	fieldPresentation: '@?skFieldPresentation',
                	codeValue: "=?skValue",
                	placeholder: "@?skPlaceholder",
                    searchOptions: '=?skSearchOptions',
                    enabled: '=?skEnabled',
                    searchTooltip: '@?skSearchTooltip',
                    toolTipPlacement: '@?skToolTipPlacement',
                    onSelectData: '=skOnSelect',
                    enviromentCriteria: '&?skEnviromentCriteria'
                }
            };
        }
        
    ]);

angular
    .module('snk.commons')
    .controller('PopUpAnexoLinkController',[ 'ServiceProxy','dataValue', 'StringUtils',
        function( ServiceProxy,dataValue,StringUtils) {
           
            var self = this           
           
             var _tipoAnexo;
			 var _codAta;
			 var _sequencia;
			 var _targetAttatch;

             const SAVE   = "mge@Attach.save";
             const PREFIX_LINK = "http://";
             const PREFIX2_LINK = "https://";

             self._descricao = "";
             self.caminhoArquivo = PREFIX_LINK;            

             self.salvar = salvar;
             self.enableBtnSalvar = false;
             self.onChangeCampos = onChangeCampos;
             self.isAlteracao = false;

             init();

             function init() {
                setDataValue(dataValue);
             }

             function setDataValue(value){                
				_tipoAnexo = value.TIPO.toString();
				_codAta = value.CODATA.toString();
				_sequencia = value.SEQUENCIA.toString();
				_targetAttatch = value.TARGET_ATTATCH;
				if(value.DESCRICAO != null && value.ARQUIVO != null){
					self._descricao = value.DESCRICAO.toString();
                    self.descricaoArquivo = value.DESCRICAO.toString();
					self.caminhoArquivo = value.ARQUIVO.toString();
					self.isAlteracao = true;
				}else{
					self._descricao = "";
                    self.descricaoArquivo = "";
                    self.caminhoArquivo = PREFIX_LINK;
					self.isAlteracao = false;
				}
			}

            function salvar(){
				var _ehInclusao = self.isAlteracao ? "N" : "S";
                
                var request={"anexo": {
                    "codata":dataValue.CODATA,
                    "sequencia": dataValue.SEQUENCIA,
                    "tipo": dataValue.TIPO,
                    "descricao":  self.descricaoArquivo,
                    "link":  self.caminhoArquivo,
                    "ehInclusao": _ehInclusao,
                    "ehArquivoRepositorio": "N"
                 }}
               
                ServiceProxy.callService(SAVE,request).then(function(result) {                    
                    dataValue.TARGET_ATTATCH.loadAction();            
                    self.descricaoArquivo = "";
                    self._descricao = "";
                    self.caminhoArquivo = PREFIX_LINK;
                    _arquivo = PREFIX_LINK;                   
                    self.isAlteracao = false;
                    onChangeCampos();
                },true)
				
			}

            function onChangeCampos() {
                self.enableBtnSalvar = validateEnableBtnSalvar(PREFIX_LINK);
                if (!self.enableBtnSalvar) {
                    self.enableBtnSalvar = validateEnableBtnSalvar(PREFIX2_LINK);
                }
            }

            function validateEnableBtnSalvar(prefix) {
                return StringUtils.emptyAsNull(self.descricaoArquivo) != null && StringUtils.startsWith(self.caminhoArquivo, prefix) && self.caminhoArquivo.length > prefix.length;
            }
        }
    ])
angular
    .module('snk.commons')
    .controller('PopUpAnexosRepositorioController',[ 'ServiceProxy','dataValue','StringUtils',
        function( ServiceProxy,dataValue,StringUtils) {
           
            var self = this           
           
             var _tipoAnexo;
			 var _codAta;
			 var _sequencia;
			 var _targetAttatch;	

             const SAVE   = "mge@Attach.save";
             const PREFIX_REPO = "Repo://";

             self._descricao = "";
             self.caminhoArquivo = PREFIX_REPO;            

             self.salvar = salvar;
             self.enableBtnSalvar = false;
             self.onChangeCampos = onChangeCampos;
             self.isAlteracao = false;

             init();

             function init() {
                setDataValue(dataValue);
             }

             function setDataValue(value){                
				_tipoAnexo = value.TIPO.toString();
				_codAta = value.CODATA.toString();
				_sequencia = value.SEQUENCIA.toString();
				_targetAttatch = value.TARGET_ATTATCH;
				if(value.DESCRICAO != null && value.ARQUIVO != null){
					self._descricao = value.DESCRICAO.toString();
                    self.descricaoArquivo = value.DESCRICAO.toString();
					self.caminhoArquivo = value.ARQUIVO.toString();
					self.isAlteracao = true;
				}else{
					self._descricao = "";
                    self.descricaoArquivo = "";
                    self.caminhoArquivo = PREFIX_REPO;
					self.isAlteracao = false;
				}
			}


             function salvar(){
				var _ehInclusao = self.isAlteracao ? "N" : "S";
                
                var request={"anexo": {
                    "codata":dataValue.CODATA,
                    "sequencia": dataValue.SEQUENCIA,
                    "tipo": dataValue.TIPO,
                    "descricao":  self.descricaoArquivo,
                    "arquivo":  self.caminhoArquivo,
                    "ehInclusao": _ehInclusao,
                    "ehArquivoRepositorio": "S"
                 }}
               
                ServiceProxy.callService(SAVE,request).then(function(result) {                    
                    dataValue.TARGET_ATTATCH.loadAction();            
                    self.descricaoArquivo = "";
                    self._descricao = "";
                    self.caminhoArquivo = PREFIX_REPO;
                    _arquivo = "http://";                   
                    self.isAlteracao = false;
                    onChangeCampos();
                },true)
				
			}

            function onChangeCampos() {
                self.enableBtnSalvar = StringUtils.emptyAsNull(self.descricaoArquivo) != null && StringUtils.startsWith(self.caminhoArquivo, PREFIX_REPO) && self.caminhoArquivo.length > PREFIX_REPO.length;
            }

        }
    ])
angular
    .module('snk.commons')
    .controller('CustoGradeProdutoPopupController', ['$scope', '$popupInstance', 'popupInfo', 'ArrayUtils','ObjectUtils', 'i18n', 'ServiceProxy', 'GradeProdutoService', 'XmlJson', 'DateUtilsConstants', 'DateUtils', 'SkConstants', 'MessageUtils',	
        function ($scope, $popupInstance, popupInfo, ArrayUtils, ObjectUtils, i18n, ServiceProxy, GradeProdutoService, XmlJson, DateUtilsConstants, DateUtils, SkConstants, MessageUtils) {
            var self = this;
            
            ObjectUtils.implements(self, IDatagridInterceptor);
            self.interceptColumnMetadata = interceptColumnMetadata;
            
            ObjectUtils.implements(self, IFormInterceptor);
            self.acceptField = acceptField;
            self.interceptBuildField = interceptBuildField;
            
            self.onDatasetCreated = onDatasetCreated;
            self.refreshHandler = refreshHandler;
            self.onKeyDown = onKeyDown;
            self.findControle = findControle;
            
            $scope.$success = confirm;
            
            self.textCriteria;
            self.fields = ["CODPROD","CODEMP","DTATUAL","CODLOCAL","CUSMEDICM","CUSSEMICM","CUSREP","CUSVARIAVEL","CUSGER","CUSMED","VLRVENDAFIXO","ENTRADACOMICMS","ENTRADASEMICMS"];
            
            var _usaCustoPorEmpresa = popupInfo.usaCustoPorEmpresa;
            var _usaCustoPorLocal = popupInfo.usaCustoPorLocal;
            var _custoComFiltro = popupInfo.custoComFiltro;
            var _isFocusSearch = false;
            
            function onDatasetCreated(dataset) {
            	if (dataset.getEntityName() == 'Custo') {
            		self.dsCusto = dataset;
            		
            		dataset.addRowMetaDataListener(function(reason, providerChanged) {
            			updateControle();
            		});
            		
            		dataset.addDataModifiedListener(function (fieldName) {
            			if (fieldName == 'CODPROD' && self.dsCusto.getFieldValueAsNumberOrZero(fieldName) == 0) {
            				self.dsGrade.clearDataSet();
            				self.dsGrade.sortRecords();
            			}
            		});
            	} else {
            		self.dsGrade = dataset;
            		
            		dataset.addLineChangeListener(function (newIndex) {
            			setFocusSearch();
            		});
            	}
            	
            	dataset.init();
            }
            
            function refreshHandler(request) {
            	// Nada a fazer..
            }
            
            function interceptColumnMetadata(fieldMetadata, dataset) {
            	fieldMetadata.enableColumnMenu = false;
            }
            
            function acceptField(fieldMetadata, dataset) {
            	if (fieldMetadata.name == "CODEMP") {
					return _usaCustoPorEmpresa;
				} else if (fieldMetadata.name == "CODLOCAL") {
					return _usaCustoPorLocal;
				}
            	
            	return ArrayUtils.isIn(self.fields, fieldMetadata.name);
            }
            
            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
            	if (fieldName == 'CODPROD') {
            		fieldProp['sk-enviroment-criteria'] = 'getCriteriaCODPROD()';
            		fieldProp['sk-entity-change'] = 'entityChangeCODPROD(item)';
            		scope.getCriteriaCODPROD = function() {
            			return Criteria("this.TIPCONTEST = 'G'");
            		};
            		scope.entityChangeCODPROD = function(item) {
            			updateControle();
            		};
            	}
            }
            
            function updateControle() {
				var options = GradeProdutoService.buildOptionsGrade(self.dsCusto);
				
            	self.dsGrade.clearDataSet();
				
            	options.forEach(function(option) {
            		self.dsGrade.addRecordsAsObjects({CONTROLE: option.data,  DESCRCONTROLE: option.label});
            	});
				
				self.dsGrade.sortRecords();
			}
            
            function confirm() {
            	if (!self.dsCusto.validateRecord()) {
            		return;
            	}
            	
            	var records = self.dsGrade.getSelectedRecordsAsObjects();
            	
            	if (!ArrayUtils.isNotEmpty(records)) {
            		MessageUtils.showAlert('Nenhum controle foi definido. Informe um produto controlado por grade e selecione pelo menos um controle.');
            		return;
            	}
            	
            	if (_custoComFiltro) {
            		
            		var custos = [];
            		
            		records.forEach(function(record) {
            			var newRecord = {};
            			
            			self.fields.forEach(function(fieldName) {
            				var value;
            				
                			if (fieldName == 'CODEMP') {
                				value = self.dsCusto.getFieldValueAsNumberOrZero("CODEMP");
                				value = value == 0 ? 1 : value;
                				
                			} else if (fieldName == 'DTATUAL') {
                				value = DateUtils.formatDate(self.dsCusto.getFieldValue(fieldName), DateUtilsConstants.DEFAULT_DATE_FORMAT);
                				
                			} else {
                				value = self.dsCusto.getFieldValueAsNumberOrZero(fieldName);
                			}
                			
                			newRecord[fieldName] = value
                		});
            			
            			newRecord["CONTROLE"] = record["CONTROLE"];
            			addCamposProduto(newRecord);
            			custos.push(newRecord);
            		});
            		
            		$popupInstance.success(custos);
            		
            	} else {
            		
            		var controles = XmlJson.create("controles");
            		
            		records.forEach(function(record) {
            			XmlJson.append(controles, XmlJson.create("controle", undefined, record.CONTROLE));
            		});
            		
            		var custo = XmlJson.create("custo");
            		
            		self.fields.forEach(function(fieldName) {
            			var value;
            			
            			if (fieldName == 'CODEMP') {
            				value = self.dsCusto.getFieldValueAsNumberOrZero("CODEMP");
            				value = value == 0 ? 1 : value;
            				
            			} else if (fieldName == 'DTATUAL') {
            				value = DateUtils.formatDate(self.dsCusto.getFieldValue(fieldName), DateUtilsConstants.DEFAULT_DATE_FORMAT);
            				
            			} else {
            				value = self.dsCusto.getFieldValueAsNumberOrZero(fieldName);
            			}
            			
            			XmlJson.append(custo, XmlJson.create(fieldName, undefined, value));
            		});
            		
            		var params = XmlJson.create("params");
            		XmlJson.append(params, custo);
            		XmlJson.append(params, controles);
            		
            		ServiceProxy.callService(
                        "mgecom@AtualizaCustoSP.incluirCustoEmLote",
                        	params,
                            {normalizedJson:true}
                    ).then(
                        function(result) {
                        	$popupInstance.success({
                        		CODPROD: self.dsCusto.getFieldValue("CODPROD"), 
                        		DTATUAL: DateUtils.formatDate(self.dsCusto.getFieldValue("DTATUAL"))
                        	});
                        }
                    );
            	}
            }
            
            function addCamposProduto(record) {
				record["Produto.DESCRPROD"] = self.dsCusto.getFieldValueAsString("Produto.DESCRPROD");
				record["Produto.TIPCONTEST"] = "G";
				record["GRID_OPTIONS"] = GradeProdutoService.buildOptionsGrade(self.dsCusto);
			}
            
            function onKeyDown(evt) {
         	   switch (evt.keyCode) {
 			       case SkConstants.KEY_CODE.ENTER:
 			    	  setTimeout(()=> { 
 			        	   findControle();
 			           }, 200);
 			           break;
 			       default:
 			           break;
 			   }
            }
            
            function findControle() {
            	_isFocusSearch = true;
            	var matchedItens = [];
            	var pattern = self.textCriteria;
            	
            	var re = new RegExp(pattern, "i");
            	var records = self.dsGrade.getRecordsAsObjects();
            	
            	for (var index = 0; index < records.length; index++) {
            		var record = records[index];
            		var value = self.dsGrade.dataToString(record['DESCRCONTROLE']);
            		if (re.test(value)) {
            			matchedItens.push(index);
            		}
            	}
            	
            	if (matchedItens.length > 0) {
            		var i = matchedItens[0];
            		for (var j = 0; j < matchedItens.length; j++) {
            			if (matchedItens[j] > self.dsGrade.getCurrentIndex()) {
            				i = matchedItens[j];
            				break;
            			}
            		}
            		self.dsGrade.gotoRow(i);
            	}
           }
            
            function setFocusSearch() {
				if (!_isFocusSearch) {
					return;
				}
				
			    var searchInput = document.getElementById('textCriteria');
			    searchInput = searchInput ? searchInput.getElementsByTagName('input')[0] : undefined;
			   
		        if (searchInput) {
		           setTimeout(()=> { 
		        	   searchInput.focus();
		        	   searchInput.click();
		        	   _isFocusSearch = false;
		           }, 200);
		        }
		    }
    }]);

/**
 *
 * Exemplo:
 *
 *   var data = {
 *   	usaCustoPorEmpresa: true,
 *   	usaCustoPorLocal: false,
 *   	custoComFiltro: false
 *   };
 *
 *   CustoGradeProdutoPopup(data)
 *   	.result.then(function (response) {
 *   });
 */
angular
	.module('snk.commons')
	.service('CustoGradeProdutoPopup', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;

			self.show = show;

			function show(popupInfo) {
				var popupInstance = SanPopup.open({
						title: popupInfo.title,
						templateUrl: 'commons/atualizacaocusto/custo-grade-produto-popup.tpl.html',
						controller: 'CustoGradeProdutoPopupController',
						controllerAs: 'ctrl',
						size: 'lg',
						height: 550,
						showBtnNo: false,
						okBtnLabel: i18n('Geral.confirmar'),
						resolve: {
							popupInfo: popupInfo
						}
					});
				return popupInstance;
			}

		}
    ]);

angular.module('snk.commons.avaliacaoCapacidade')
    .component('skAvaliacaoCapacidade', {
        templateUrl: 'commons/avaliacaoCapacidade/avaliacaoCapacidade.tpl.html',
        controller: 'AvaliacaoCapacidadeController',
        controllerAs: 'ctrl',
        bindings: {
            hideTitle: '@?skHideTitle',
            onViewAvaliacaoCapacidadeCreated: '&?onViewAvaliacaoCapacidadeCreated',
            onClose: '&?onClose',
        }
    })
    .controller('AvaliacaoCapacidadeController', ['$scope', 'SkI18nService', 'SkApplicationInstance', 'i18n', 'AngularUtil', 'ServiceProxy', '$q', '$element', 'HighchartUtils' ,
        function ($scope, SkI18nService, SkApplicationInstance, i18n, AngularUtil, ServiceProxy, $q, $element, HighchartUtils) {

            var self = this;
            self.loadMps = loadMps;
            self.clear = clear;
            self.onLoadGrafico = onLoadGrafico;
            self.$onInit = $onInit;
            self.fechar = fechar;
            self.paineisCarregando = new Map();

            const VALUE_LANG = SkI18nService.getLang().replace("_", "-");
            self.chartMinicardHorasDisponiveis = "chartMinicardHorasDisponiveis";
            self.chartMinicardDemandasHoras = "chartMinicardDemandasHoras";
            self.chartMinicardCategoriaMaisUtilizada = "chartMinicardCategoriaMaisUtilizada";
            self.chartMinicardCategoriaMaisDisponivel = "chartMinicardCategoriaMaisDisponivel";

            const TIPOS_DEMANDA = {
                "G": i18n('Producao.PlanejamentoProducao.lblConfigContainerAbaDemandaProvTipoDemandaGiro'),
                "P": i18n('Producao.PlanejamentoProducao.lblConfigContainerAbaDemandaProvTipoDemandaPedidos'),
                "M": i18n('Producao.PlanejamentoProducao.lblConfigContainerAbaDemandaProvTipoDemandaMetas'),
                "S": i18n('Producao.PlanejamentoProducao.lblConfigContainerAbaDemandaProvTipoDemandaProc')
            };
            
            var paineis = new Map();
            paineis.set(self.chartMinicardHorasDisponiveis, {component: null, loaded: false, 'deferred': $q.defer(), callback: getDadosMinicardHorasDisponiveis});
            paineis.set(self.chartMinicardDemandasHoras, {component: null, loaded: false, 'deferred': $q.defer(), callback: getDadosMinicardDemandaHoras});
            paineis.set(self.chartMinicardCategoriaMaisUtilizada, {component: null, loaded: false, 'deferred': $q.defer()});
            paineis.set(self.chartMinicardCategoriaMaisDisponivel, {component: null, loaded: false, 'deferred': $q.defer()});
            
            self.resourceID = SkApplicationInstance.getResourceID();
            
            function $onInit(){
                AngularUtil.setContextControllerInfo($element, $scope, '$ctrl', self);
                if(angular.isDefined(self.onViewAvaliacaoCapacidadeCreated)) {
                    self.onViewAvaliacaoCapacidadeCreated({viewAvaliacaoCapacidade: self})
                }

                $('sk-avaliacao-capacidade').resize(() => {
                    AngularUtil.timeout(() => updateTela());
                })
            }

            function loadMps(nuMps) {
                self.nuMps = nuMps;
	            self.update();
            }

            function clear() {
                self.nuMps = undefined;
                $scope.graficoCarregado = false;
                clearContent();
                
            }

            function fechar() {
                if (self.onClose)
                    self.onClose();
            }

            function clearContent(msg) {
                self.listaTopOcupacao = null;
                self.listaTopDisponibilidade = null;
    
                if (self.chartAvaliacaoCapacidade) self.chartAvaliacaoCapacidade.destroy();
                if (self.chartPercentualCargaGeral) self.chartPercentualCargaGeral.destroy();
    
                let content = '<div ng-show="!graficoCarregado" class="avaliacao-loading" layout="row" layout-align="center center">';
                if (!msg) content += '<sk-icon svg-src="/mge/assets/svg/loading.svg" class="spin"></sk-icon>';
                content += '<span sk-translate>' + i18n(msg || 'Geral.lblCarregando') + '</span>';
                content += '</div>'
                $("#chartAvaliacaoCapacidade").html(content);
                self.paineisCarregando.clear();
            }

            function updateAvaliacaoCapacidade() {
                clearContent();
                self.paineisCarregando.set("avaliacao", "avaliacao");
                let params = {params: {nuMps: self.nuMps}};
                ServiceProxy.callService('mgeprod@IndicadoresAvaliacaoCapacidadeMpsSP.getAvaliacaoCapacidadePorMPS', params)
                    .then((response) => {
                        let result = response.responseBody;
                        if (result && result.chartData && result.chartData.length > 0){
                            carregarGraficoDisponibilidadeOcupacao(result);
                            carregarPercentualCargaGeral(result);
                            $scope.graficoCarregado = true;
                        } else
                            clearContent('Commons.AvaliacaoCapacidadeMps.msgSemDadosAvaliacaoCapacidade')

                        self.paineisCarregando.delete("avaliacao");
                    })
                    .catch(() => self.paineisCarregando.delete("avaliacao"));
            }

            self.update = function () {
                clearContent();

                if (self.nuMps) {
                    updateAvaliacaoCapacidade();
                    paineis.forEach((painel) => {
                        if (painel.loaded && painel.callback) {
                            updatPainelCallback(painel);
                        }
                    })
                    updateTela();
                }
            }

            function updateTela() {
                AngularUtil.timeout(() => {
                    if (self.chartAvaliacaoCapacidade) self.chartAvaliacaoCapacidade.reflow();
                    if (self.chartPercentualCargaGeral) self.chartPercentualCargaGeral.reflow();
                    resizePaineis(paineis);
                })
            }
            function resizePaineis(paineis) {
                if (paineis)
                    paineis.forEach((painel) => {
                        if (painel && painel.component && painel.component.chart)
                            (painel.component.reflow || painel.component.chart.reflow)();
                    })
            }

            function onLoadGrafico(component, g) {
                let painel = paineis.get(g);
                painel.name = g;
                painel.component = component;
                painel.loaded = true;
                painel.lastUpdate = null;
                painel.deferred.resolve();

                updatePainel(painel);
            }

            
        function updatePainel(painel) {
            if (painel.component && painel.component.chart)
                painel.component.chart.reflow();
            else if (painel.callback)
                updatPainelCallback(painel);
    
           
        }

        function updatPainelCallback(painel) {
            //graficoHelper.showLoadingBar(painel.name);
            self.paineisCarregando.set(painel.name, painel.name);
            painel.callback().then(function (response) {
                painel.data = angular.copy(response.responseBody);
                painel.component.update(painel.data);
                //graficoHelper.hideLoadingBar(painel.name);
                //painel.lastUpdate = self.filters.lastUpdate;
                self.paineisCarregando.delete(painel.name);
            }).catch(function (e) {
                self.paineisCarregando.delete(painel.name);
                //graficoHelper.hideLoadingBar(painel.name);
            })
        }

        function clearContent(msg) {
            self.listaTopOcupacao = null;
            self.listaTopDisponibilidade = null;

            if (self.chartAvaliacaoCapacidade) {
                self.chartAvaliacaoCapacidade.destroy();
                self.chartAvaliacaoCapacidade = null;
            };
            if (self.chartPercentualCargaGeral) {
                self.chartPercentualCargaGeral.destroy();
                self.chartPercentualCargaGeral = null;
            }

            let content = '<div ng-show="!graficoCarregado" class="avaliacao-loading" layout="row" layout-align="center center">';
            if (!msg) content += '<sk-icon svg-src="/mge/assets/svg/loading.svg" class="spin"></sk-icon>';
            content += '<span sk-translate>' + i18n(msg || 'Geral.lblCarregando') + '</span>';
            content += '</div>'
            $("#chartAvaliacaoCapacidade").html(content);

            paineis.forEach((painel) => {
                painel.filled = false
                if (painel.component && painel.component.clear) painel.component.clear();
            });
        }

        function getDadosMinicardHorasDisponiveis() {
            let params = {params: {nuMps: self.nuMps}};
            return ServiceProxy.callService('mgeprod@IndicadoresAvaliacaoCapacidadeMpsSP.getDadosMinicardHorasDisponiveis', params)
        }

        function getDadosMinicardDemandaHoras() {
            let params = {params: {nuMps: self.nuMps}};
            return ServiceProxy.callService('mgeprod@IndicadoresAvaliacaoCapacidadeMpsSP.getDadosMinicardDemandaHoras', params)
        }

        function carregarMinicardUtilizacaoCategoriaCT(painel, categoria, color) {
            painel.component.setTitle(categoria.nomeCategoriaCT);
            let params = {params: {nuMps: self.nuMps, codigoCategoriaCT: categoria.codigoCategoriaCT, color: color}};
            ServiceProxy.callService('mgeprod@IndicadoresAvaliacaoCapacidadeMpsSP.getDadosMinicardUtilizacaoCategoriaCT', params)
            .then((response) => {
                let result = response.responseBody;
                result.title = categoria.nomeCategoriaCT;
                painel.component.update(result);
            })
        }

        function updateAvaliacaoCapacidade() {
            let params = {params: {nuMps: self.nuMps}};
            ServiceProxy.callService('mgeprod@IndicadoresAvaliacaoCapacidadeMpsSP.getAvaliacaoCapacidadePorMPS', params)
                .then((response) => {
                    let result = response.responseBody;
                    if (result && result.chartData && result.chartData.length > 0){
                        carregarGraficoDisponibilidadeOcupacao(result);
                        carregarPercentualCargaGeral(result);
                        $scope.graficoCarregado = true;
                    } else
                        clearContent('Commons.AvaliacaoCapacidadeMps.msgSemDadosAvaliacaoCapacidade')
                })
        }

        function carregarGraficoDisponibilidadeOcupacao(result) {
            let chartOptions = {
                chart: {
                    events: {
                        load: function() {
                          const chart = this,
                            points = chart.series[0].data,
                            options = {
                              dataLabels: {
                                inside: false,
                                style: {
                                  color: 'black'
                                },
                                verticalAlign: 'bottom',
                                y: 0,
                              }
                            };
                  
                          points.forEach(function(point) {
                            if (point.shapeArgs.height < 170) {
                              point.update(options, false);
                            }
                          });
                  
                          chart.redraw();
                        }
                      }
                },
                title: {
                    text: i18n('Commons.AvaliacaoCapacidadeMps.tituloDisponibilidadeOcupacao')
                },
                subtitle: {
                    text: i18n('Commons.AvaliacaoCapacidadeMps.subtituloPorCategoriaCT')
                },
                accessibility: {
                    announceNewData: {
                        enabled: true
                    }
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        style: {
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis"
                        },
                    }
                },
                yAxis: {
                  tickInterval: 10,
                  tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                  title: '',
                  plotLines: [
                      {
                          color: "#000",
                          value: 100,
                          width: 3,
                          zIndex: 1
                      }
                  ]  
            
                },
                legend: {
                    align: 'right',
                    verticalAlign: 'top',
                    floating: true,
                    margin: 0,
                    padding: 0,
                    x: 0,
                    y: 0
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            inside: true,
                            align: 'center',
                            allowOverlap: false,
                            useHTML: true,
                            verticalAlign: 'bottom',
                            y: -150,
                            style: {
                                fontSize: '13px'
                            },
                            formatter: function () {
                                return this.point && this.point.y ? this.point.y.toLocaleString(VALUE_LANG, {maximumFractionDigits: 2}) + "%" : ""
                            }
                        }
                    }
                },
            
                tooltip: {
                    formatter: function () {
                        let point = this.points[0].point;
                        let data = point.options;
                        let content = '<div class="title-tooltip-ocup">' + point.series.name + ' ' + data.percentualOcupacaoStr + '%</div><br>';
                        content += '<table class="content-tooltip-ocup">' +
                        '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelCodMps') + '</span></td>' +
                        '<td class="value-tooltip-ocup"><span>' + self.nuMps +'</span></td></tr>' +
                        '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.tituloHorasDisponiveis') + ':</span></td>' +
                        '<td class="value-tooltip-ocup"><span>' + HighchartUtils.formatNumber(data.capacidade) +'</span></td></tr>' +
                        '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.tituloDemandaHoras') + ':</span></td>' +
                        '<td class="value-tooltip-ocup"><span>' + HighchartUtils.formatNumber(data.utilizacao) +'</span></td></tr>' +
                    '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelCodConfigMps') + '</span></td>' +
                                    '<td class="value-tooltip-ocup"><span>' + result.codigoConfiguracaoMps +'</span></td></tr>' +
                                    '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelTipoDemanda') + '</span></td>' +
                                    '<td class="value-tooltip-ocup"><span>' + TIPOS_DEMANDA[result.tipoDemanda] +'</span></td></tr>' +
                                    '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelInicioMps') + '</span></td>' +
                                    '<td class="value-tooltip-ocup"><span>' + result.inicioMps +'</span></td></tr>' +
                                    '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelFimMps') + '</span></td>' +
                                    '<td class="value-tooltip-ocup"><span>' + result.fimMps +'</span></td></tr>' +
                                    '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelPlanta') + '</span></td>' +
                                    '<td class="value-tooltip-ocup"><span>' + result.codigoPlanta +'</span></td></tr>' +
                                    '<tr><td class="label-tooltip-ocup"><span>' + i18n('Commons.AvaliacaoCapacidadeMps.labelAjusteDemanda') + '</span></td>' +
                                    '<td class="value-tooltip-ocup"><span>' + HighchartUtils.formatPercentage(result.percentualAjusteDemanda) +'</span></td></tr>' +
                                '</table>'
                        return content;
                    },
                    shared: true,
                    useHTML: true,
                    distance: 28,
                    zIndex: 30
                },
            
                series: [
                    {
                        type: 'column',
                        name: i18n('Commons.AvaliacaoCapacidadeMps.labelOcupacao'),
                        color: {
                          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, '#14AA9B'], // start
                            [1, '#0B5750'] // end
                        ]
                      },
                        data: []
                    },  {
                        type: 'line',
                        name: i18n('Commons.AvaliacaoCapacidadeMps.labelDisponibilidade'),
                        color: '#000',
                        data: [],
                        marker: {
                            symbol: 'circle',
                            fillColor: '#000',
                            radius: 0
                        },
                    }
                ]
               
            };

            let data = result.chartData.map((item) => {
                let itemData = angular.copy(item);
                itemData.y = item.percentualOcupacao;
                itemData.name = item.nomeCategoriaCT;
                itemData.percentualOcupacaoStr = HighchartUtils.formatPercentage(item.percentualOcupacao);
                return itemData;
            }).sort((a,b) => b.percentualOcupacao - a.percentualOcupacao);

            chartOptions.series[0].data = data;

            self.listaTopOcupacao = data.slice(0, 5);
            if (self.listaTopOcupacao.length > 0) {
                let topCT = self.listaTopOcupacao[0];
                if (topCT.percentualOcupacao > 100) {
                    let max = Math.round(topCT.percentualOcupacao * 1.1);
                    chartOptions.yAxis.tickPositions.push(max < 200 ? max : 200);
                }
                carregarMinicardUtilizacaoCategoriaCT(paineis.get(self.chartMinicardCategoriaMaisUtilizada), topCT, "#F14359");
            }

            self.listaTopDisponibilidade = angular.copy(data).sort((a, b) => a.percentualOcupacao - b.percentualOcupacao).slice(0, 5);
            if (self.listaTopDisponibilidade.length > 0)
            carregarMinicardUtilizacaoCategoriaCT(paineis.get(self.chartMinicardCategoriaMaisDisponivel), self.listaTopDisponibilidade[0], "#39A553");

            self.chartAvaliacaoCapacidade = Highcharts.chart('chartAvaliacaoCapacidade', chartOptions);
            
        }

        function carregarPercentualCargaGeral(result) {
            self.chartPercentualCargaGeral = new Highcharts.chart('chartPercentualCargaGeral', {
                chart: {
                    type: 'gauge',
                    plotBorderWidth: 0,
                    plotShadow: false,
                    plotShadow: false,
                    spacing:[0, 0, 0, 0],
                    margin: [5,5,-100,5],
        
                },
                credits: {
                    enabled: false
                },
                
                title: {
                    text: i18n('Commons.AvaliacaoCapacidadeMps.tituloPercentualCarga'),
                },
                
                pane: {
                    startAngle: -90,
                    endAngle:90,
                    background: [{
                        // default background
                        backgroundColor: '#fff',
                                 borderWidth: 0
                    }]
                },
                   
                // the value axis
                yAxis: {
                    min: 0,
                    max: 150,
                    
                    minorTickInterval: 'none',
                    minorTickWidth: 1,
                    minorTickLength: 10,
                    minorTickPosition: 'inside',
                    minorTickColor: '#666',
            
                    tickPixelInterval: 30,
                    tickWidth: 0,
                    tickPosition: 'inside',
                    tickLength: 10,
                    tickColor: '#666',
                    labels: {
                        enabled: false
                    },
                    
                    plotBands: [{
                        from: 0,
                        to: 91,
                        thickness: '40%',
                        color: '#55BF3B' // green
                    }, {
                        from: 91,
                        to: 101,
                        thickness: '40%',
                        color: '#DDDF0D' // yellow
                    }, {
                        from: 101,
                        to: 150,
                        thickness: '40%',
                        color: '#DF5353' // red
                    }],
                },
                
                plotOptions: {
                    gauge: {
                      dataLabels: {
                        borderColor: '#FFFFFF',
                        color: result.percentualCargaGeral > 101 ? '#DF5353' : '#000',
                        formatter: function() {
                            return HighchartUtils.formatPercentage(result.percentualCargaGeral )
                        },
                        dial: {
                            startAngle: -90,
                            endAngle:90,
                        },
                        //padding: 5,
                        backgroundColor: '#FFFFFF',
                        borderRadius: '45%',
                        style: {
                            fontSize: window.screen.width > 1280 ? '2.5rem' : '2rem',
                        },
                        y: window.screen.width > 1280 ? -35 : -25,
                        zIndex: 10,
                        tooltip: {
                            enabled: false
                        },
                    },
                    
                    pivot: {
                        radius: 0
                    }
                  }
                },
            
                series: [{
                    name: 'Percentual',
                    enableMouseTracking: false,
                    data: [result.percentualCargaGeral < 150 ? result.percentualCargaGeral : 150],
                    tooltip: {
                        enabled: false
                    }
                }]
            
            });
        }
    
    }]);
            

/**
 * Created by italo.araujo on 07/05/2020.
 */

angular
    .module("snk.commons").service("BaixaAgrupadaHelper", ["i18n", "MessageUtils", "$q",
    function(i18n, MessageUtils, $q) {
        var self = this;

        self.prepararBaixaAgrupada = prepararBaixaAgrupada;
        self.prepararParametrosBaixaAgrupada = prepararParametrosBaixaAgrupada;

        function prepararBaixaAgrupada(dsFin) {
            return $q(function(resolve, reject) {
                var baixaAgrupada = angular.isDefined(dsFin.getSelectedRecords()) && dsFin.getSelectedRecords().length > 1;
                if(baixaAgrupada){
                    var financeiros = dsFin.getSelectedRecordsAsObjects();
                    MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Commons.Baixa.msgConfirmBaixaAgrupada', [financeiros.length]))
                        .then(function (result) {
                            resolve(financeiros);
                        });
                }else{
                    reject();
                }
            });
        }
        
        function prepararParametrosBaixaAgrupada(params, paramsFin) {
            if (angular.isDefined(params) || angular.isDefined(paramsFin)) {
                var financeirosEmBaixaAgrupada = paramsFin["financeirosEmBaixaAgrupada"];

                if (angular.isDefined(financeirosEmBaixaAgrupada)) {
                    params["baixaAgrupada"] = {
                        financeiros: {
                            financeiro: []
                        }
                    };

                    financeirosEmBaixaAgrupada.forEach(function (finan) {
                        params.baixaAgrupada.financeiros.financeiro.push({ $: finan.NUFIN });
                    });
                }
            }

            return params;
        }
  }]);

/**
 * Created by italo.araujo on 07/05/2020.
 */

angular
    .module("snk.commons").service("BaixaHelper", [ "ObjectUtils", "ServiceProxy", "StringUtils", "MessageUtils", "$q",
    function( ObjectUtils, ServiceProxy, StringUtils, MessageUtils, $q) {
      var self = this;

      self.prepararBaixa = prepararBaixa;

      var deferred = $q.defer();

      function prepararBaixa(baixaPanel, paramsBaixa, finishHandler) {
          if(angular.isDefined(paramsBaixa)){
              var nuFin = ObjectUtils.getProperty(paramsBaixa, 'nuFin');
              var financeiros = ObjectUtils.getProperty(paramsBaixa, 'financeirosEmBaixaAgrupada');
              var codTipTit = ObjectUtils.getProperty(paramsBaixa, 'codTipTit');
              var codTipOperFinanceiro = ObjectUtils.getProperty(paramsBaixa, 'codTipOperFinanceiro');

              if (!angular.isDefined(financeiros)) {
                  baixaPanel.setBaixaAgrupada(false);

                  ServiceProxy.callService('mgefin@MovimentacaoFinanceiraSP.msgParaExibirNaBaixa', {param :{codTipTit : codTipTit}}).then(
                      function (response) {
                          var msg = response.responseBody.msgExibirBaixa;
                          if(!StringUtils.isEmpty(msg)){
                              MessageUtils.showInfo(msg);
                          }

                          ServiceProxy.callService('mgefin@MovimentacaoFinanceiraSP.ehDevolucaoCheque', {param :{nufin : nuFin}}).then(
                              function (response) {
                                  var ehDevolucaoCheque = response.responseBody.ehDevolucaoCheque == "S";
                                  ObjectUtils.setProperty(paramsBaixa, "ehDevolucaoCheque", ehDevolucaoCheque);
                                  baixaPanel.carregarBaixa(nuFin, paramsBaixa);
                              }
                          );
                      }
                  );
              } else{
                  baixaPanel.setBaixaAgrupada(true);
                  baixaPanel.carregarBaixa(nuFin, paramsBaixa);
              }

              baixaPanel.setCodTipOperFinanceiro(codTipOperFinanceiro);
          }

          if(angular.isDefined(finishHandler)){
              deferred.resolve(finishHandler);
          }
          return deferred.promise;
      }
  }]);

/* 
 *  Createad by italo.araujo on 08/05/2020.
 */
angular
    .module('snk.commons.baixa.cabecalho')
    .component('skCabecalhoBaixa', {
        templateUrl: 'commons/baixa/cabecalho/cabecalho-baixa.tpl.html',
        controller: 'CabecalhoBaixaController',
        controllerAs: 'ctrl',
        bindings: {
            onCreate: '&?skOnCreateCabecalhoBaixa',
            data: '=skData',
            enabledBackButton : '=?skEnableBackButton',
            enabledChangeDtBaixa : '=?skEnabledChangeDtBaixa',
            showBotaoVerFinanceiro : '=?skShowBotaoVerFinanceiro',
            parentInstance : '=?parentInstance',
            onClickVerFinanceiro : '&?skOnClickVerFinanceiro'
        }
    })
    .controller('CabecalhoBaixaController', [ 'StringUtils', 'i18n', '$scope', 'DateUtils', 'DateUtilsConstants','NumberUtils',
        function ( StringUtils, i18n, $scope, DateUtils, DateUtilsConstants,NumberUtils) {
            var self = this;

            self.labelNumUnico = i18n("Commons.Baixa.labelNumUnico") + ':';
            self.labelDesdob = i18n("Commons.Baixa.labelDesdob") + ':';
            self.labelVcto = i18n("Commons.Baixa.labelVcto")  + ':';
            self.labelDtBaixa = i18n("Commons.Baixa.labelDtBaixa") + ':';
            self.labelAtraso = i18n("Commons.Baixa.labelAtraso") + ':';
            self.visibleDiasAtraso = false;
            self.visibleDiferenca = false;
            self.verFinanceiro = verFinanceiro;
            self.getDataBaixa = getDataBaixa;
            self.changeDataBaixa = changeDataBaixa;
            self.isReady = isReady;

            $scope.$watch('data', function (newValue, oldValue) {
                isReady();
            });

            function isReady(){
                self.enabledBackButton = angular.isDefined(self.enabledBackButton) ? self.enabledBackButton : true;
                self.enabledChangeDtBaixa = angular.isDefined(self.enabledChangeDtBaixa) ? self.enabledChangeDtBaixa : true;

                if(angular.isDefined(self.data)){
                    self.nufin = self.data.nufin;
                    self.desdob = self.data.desdob;
                    self.dtVencimento = self.data.dtVencimento;
                    self.diasAtraso = self.data.diasAtraso;
                    self.diferenca = self.data.diferenca;
                    self.vlrMenor = self.data.vlrMenor;
                    self.vlrCalculado = self.data.vlrCalculado;
                    self.diferenca = self.data.diferenca;
                    self.dtBaixa = DateUtils.stringToDate(self.data.dtBaixa, DateUtilsConstants.DEFAULT_DATE_FORMAT);

                    if(!StringUtils.isEmpty(self.diasAtraso) || self.diasAtraso > 0){
                        self.visibleDiasAtraso = true;
                    }

                    if((!StringUtils.isEmpty(self.diferenca)) && (NumberUtils.getNumberOrZero(self.diferenca) != 0)){
                        self.labelDiferencaTitulo = i18n("Commons.Baixa.labelValorDiferenca", [self.diferenca]);
                        self.visibleDiferenca = true;
                    }else if(!StringUtils.isEmpty(self.vlrMenor)){
                        self.labelBaixaInferior = i18n('Commons.Baixa.labelBaixaInferiorCalculo', [NumberUtils.format(self.vlrMenor,2), NumberUtils.format(self.vlrCalculado,2)]);
                        self.visibleVlrMenor = true;
                    }
                }

                self.labelVerFinanceiro = i18n('Commons.Baixa.buttonConsultarTitulo', [self.nufin]);
                showBotaoVerFinanceiro(self.showBotaoVerFinanceiro);
                if(angular.isFunction(self.onCreate)){
                    self.onCreate({cabecalho: self});
                }
            }

            function verFinanceiro(){
                self.onClickVerFinanceiro();
            }

            function getDataBaixa(){
            	return DateUtils.formatDate(self.dtBaixa, DateUtilsConstants.DEFAULT_DATE_FORMAT);
            }

            function showBotaoVerFinanceiro(show){
                self.botaoVerFinanceiroVisible = show;
                self.botaoVerFinanceiroEnabled = show;
                self.labelNufinVisible = !show;
            }

            function changeDataBaixa(){
                if(DateUtils.dateToString(self.dtBaixa, DateUtilsConstants.DEFAULT_DATE_FORMAT) != undefined ){
                	var dtVenc = DateUtils.stringToDate(self.dtVencimento, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                    

                    if(DateUtils.compare(dtVenc, self.dtBaixa) < 0){
                        self.diasAtraso = DateUtils.diffDates(dtVenc, self.dtBaixa);
                    }else if(DateUtils.compare(dtVenc, self.dtBaixa) >= 0){
                        self.diasAtraso = 0;
                    }
                    
                    if (self.parentInstance) {
            			self.parentInstance.recalculaValores();
            		}
                }
            }
    }]);

angular
    .module('snk.commons.baixa.panel')
    .controller('BaixaPanelController', ['$rootScope', 'BaixaAgrupadaHelper', 'NumberUtils', 'ObjectUtils', '$scope', 'ServiceProxy', 'DateUtils', 'BaixaHelper', 'MessageUtils', 'i18n', 'SkApplicationInstance', '$q', 'DateUtilsConstants', 'SanPopup',
        function ($rootScope, BaixaAgrupadaHelper, NumberUtils, ObjectUtils, $scope, ServiceProxy, DateUtils, BaixaHelper, MessageUtils, i18n, SkApplicationInstance, $q, DateUtilsConstants, SanPopup) {
            var self = this;

            var TOTAL_PERCENT = "100";
            var CARREGANDO_DADOS_NOVOS = "br.com.sankhya.baixa.panel.carregando.dados.novos";
            var _percentWidth = $scope.percentWidth ?  $scope.percentWidth : TOTAL_PERCENT;
            var _percentHeight = $scope.percentHeight ?  $scope.percentHeight : TOTAL_PERCENT;
            var _resourceID = $scope.resourceID;
            var _resourceIDBloquearCampos = $scope.resourceIdBloquearCampos;
            var _paramsFin;
            var _codTipOperFinanceiro;
            var baixaAgrupada;
            var _nuFinBaixa = -1;

            $rootScope.baixaPanel = {recalculaValores: recalculaValores};

            self.styleWizard = "position: absolute; "
                                + "width: " + _percentWidth +"%;"
                                + "height: " + _percentHeight +"%"

            self.loadingComplete = false;
            self.baixaVlrMaiorDisabled = true;

            self.carregarBaixa = carregarBaixa;
            self.setCodTipOperFinanceiro = setCodTipOperFinanceiro;
            self.setBaixaAgrupada = setBaixaAgrupada;
            self.recalculaValores = recalculaValores;
            self.onLoadWizard = onLoadWizard;
            self.onClickBotaoVerFinanceiro = onClickBotaoVerFinanceiro;
            self.validateStep = validateStep;
            self.onCancel = onCancel;
            self.onFinish = onFinish;
            self.getOpcao = getOpcao;
            self.doClose = doClose;
            self.wizardContext = {};

            init();

            function init() {
                if(angular.isFunction($scope.onCreate)){
                    $scope.onCreate({baixa: self});
                }

                ServiceProxy.addClientEvent("br.com.sankhya.financeiro.alert.mudanca.titulo.baixa", function (clientEvent, serviceRecaller) {
                    SanPopup.open({
                        title: i18n('Financeiro.MovimentacaoFinanceira.lblaviso'),
                        templateUrl: 'html5/MovimentacaoFinanceira/popup/AvisoMudancaTituloFinanceiro/AvisoMudancaTituloFinanceiro.tpl.html',
                        controller: 'AvisoMudancaTituloFinanceiro',
                        controllerAs: 'ctrl',
                        size: 'alert',
                        type: 'warning',
                        showBtnCancel: true,
                        showBtnOk: true,
                        okBtnLabel: i18n('Financeiro.MovimentacaoFinanceira.lblavisoConfirmar'),
                        noBtnLabel: i18n('Financeiro.MovimentacaoFinanceira.lblCancelar'),
                        backdrop: 'static',
                        windowClass: 'modal-message',
                        largeBottomButtons: true,
                        resolve: {
                            dataValue: {
                                conta: clientEvent.CAMPOS.CONTA,
                                nossonumero: clientEvent.CAMPOS.NOSSONUMERO
                            }
                        }
                    }).result
                    .then(function(){
                        serviceRecaller.params.txProperties = {
                            'br.com.sankhya.financeiro.alert.mudanca.titulo.confirmacao': true
                        }
                        serviceRecaller.reCall();
                    }, function () {
                        self.wizard.previous();
                        return;
                    });
                });

            }

            function onLoadWizard(wizard) {
                self.wizard = wizard;
            }

            function validateStep(){
                if(self.wizardContext.valorNegativo){
                    throw new MessageError(MessageUtils.TITLE_ERROR, i18n('Commons.Baixa.messageBaixaNegativa'));
                }else{
                    return true;
                }
            }

            function setCodTipOperFinanceiro(codTipOper) {
                _codTipOperFinanceiro = codTipOper;
            }

            function setBaixaAgrupada(value) {
                baixaAgrupada = value;
            }

            function carregarBaixa(nuFin, paramsFin) {
            	//Garante que se mudar qualquer valor e salvar na tela principal,
            	//os valores atualizados serão carregados novamente na tela de baixa.
                SkApplicationInstance.putRuntimeProperty(CARREGANDO_DADOS_NOVOS, "S");

                resetBaixa(null, true);
                
                self.nuFin = nuFin;
                _paramsFin = paramsFin;

                createWizard(paramsFin);

                _nuFinBaixa = self.nuFin;

                var params = {
                    nuFin : self.nuFin,
                    resourceID : _resourceID,
                    reterImpostosRetroativos : true
                };

                params = BaixaAgrupadaHelper.prepararParametrosBaixaAgrupada(params, paramsFin);

                ServiceProxy.callService('mge@BaixaFinanceiroSP.montaDadosBaixa', {params})
                    .then(function (response) {
                        var dadosBaixa = response.responseBody.dadosBaixa;
                        if (angular.isDefined(dadosBaixa)) {
                            setaValoresDoRetorno(dadosBaixa);                            
                        }
                    }, function (err) {
                        if(angular.isDefined(err)){
                            _nuFinBaixa = -1;
                            if(angular.isFunction($scope.baixaPanelRollback)){
                                $scope.baixaPanelRollback();
                            }
                        }
                    });
            }

            function createWizard(params){
                ObjectUtils.setProperty(self.wizardContext, 'usaRecebimentoComCartao', $scope.usaRecebimentoComCartao);
				ObjectUtils.setProperty(self.wizardContext, 'ownerServiceCall',  $scope.ownerServiceCall);
                ObjectUtils.setProperty(self.wizardContext, 'recalcularJurosMultaApartirValorPendencia',  _paramsFin["recalcJurosMultaVlrPend"]);
                ObjectUtils.setProperty(self.wizardContext, 'centralNotas',  $scope.centralNotas);
                ObjectUtils.setProperty(self.wizardContext, 'showBotaoBaixaProximo', $scope.showBotaoBaixaProximo);

				ObjectUtils.setProperty(self.wizardContext, 'params', params);
                ObjectUtils.setProperty(self.wizardContext, 'baixaAgrupada', baixaAgrupada);
                ObjectUtils.setProperty(self.wizardContext, 'paramsFin', params);
			}
            
            function setaValoresDoRetorno(dadosBaixaObj) {
                var dadosBaixa = {
                    origem : dadosBaixaObj.origem,
                    alteraImpostos : "S" == dadosBaixaObj.alteraImpostos,
                    alteraMoedaBaixa : "S" == dadosBaixaObj.alteraMoedaBaixa,
                    vlrDesdobNegociacao : Number(dadosBaixaObj.vlrDesdobNegociacao),
                    concilia : "S" == dadosBaixaObj.concilia,
                    nufin : _nuFinBaixa,
                    regimeCaixa : "S" == dadosBaixaObj.regimeCaixa,
                    retencaoRetroativa : "S" == dadosBaixaObj.retencaoRetroativa,
                    reterImpostosRetroativos : "S" == dadosBaixaObj.reterImpostosRetroativos
                };

                BaixaAgrupadaHelper.prepararParametrosBaixaAgrupada(dadosBaixa, _paramsFin);

                var cabecalho = {
                    diasAtraso : dadosBaixaObj.diasAtraso,
                    dtBaixa : dadosBaixaObj.dataBaixa,
                    nufin : _nuFinBaixa,
                    desdob : dadosBaixaObj.desdobramento,
                    dtVencimento : dadosBaixaObj.dataVencimento,
                    codTipOperFinanceiro : _codTipOperFinanceiro
                };

                var dadosAdicionais = {
                    codEmpresa : dadosBaixaObj.dadosAdicionais.codEmpresa,
                    codTipoOperacao : dadosBaixaObj.dadosAdicionais.codTipoOperacao,
                    descrOperacao : dadosBaixaObj.dadosAdicionais.descrOperacao,
                    nomeFantasia : dadosBaixaObj.dadosAdicionais.nomeFantasia,
                    codBarras : dadosBaixaObj.dadosAdicionais.codBarras,
                    codParc : dadosBaixaObj.dadosAdicionais.codParc,
                    restricaoTipOper : dadosBaixaObj.dadosAdicionais.restricaoTipOper
                };

                var dadosBancarios = {
                    codConta : dadosBaixaObj.dadosBancarios.codConta,
                    codLancamento : dadosBaixaObj.dadosBancarios.codLancamento,
                    numDocumento : dadosBaixaObj.dadosBancarios.numDocumento,
                    descrConta : dadosBaixaObj.dadosBancarios.descrConta,
                    descrLancamento : dadosBaixaObj.dadosBancarios.descrLancamento,
                    historico : dadosBaixaObj.dadosBancarios.historico,
                    dataConciliacao : dadosBaixaObj.dadosBancarios.dataConciliacao,
                    codTipTit : dadosBaixaObj.dadosBancarios.codTipTit,
                    descrTipTit : dadosBaixaObj.dadosBancarios.descrTipTit,
                    subTipTit : dadosBaixaObj.dadosBancarios.subTipTit,
                    codBco : dadosBaixaObj.dadosBancarios.codBco,
                    descrBco : dadosBaixaObj.dadosBancarios.descrBco,
                    vlrMoedaBaixa : dadosBaixaObj.dadosBancarios.vlrMoedaBaixa,
                    sizeHistorico : dadosBaixaObj.dadosBancarios.sizeHistorico
                };

                var impostos = {
                    irrfRetido : "S" == dadosBaixaObj.impostos.irrfRetido,
                    issRetido : "S" == dadosBaixaObj.impostos.issRetido,
                    inssRetido : "S" == dadosBaixaObj.impostos.inssRetido,
                    calculoBaseDia : "S" == dadosBaixaObj.impostos.calculoBaseDia,
                    vlrIrrf : NumberUtils.stringToNumber(dadosBaixaObj.impostos.vlrIrrf),
                    vlrInss : NumberUtils.stringToNumber(dadosBaixaObj.impostos.vlrInss),
                    vlrIss : NumberUtils.stringToNumber(dadosBaixaObj.impostos.vlrIss),
                    baseDevidaOutrosImpostos : NumberUtils.stringToNumber(dadosBaixaObj.impostos.baseDevidaOutrosImpostosMensais),
                    outrosImpostos : NumberUtils.stringToNumber(dadosBaixaObj.impostos.outrosImpostos),
                    outrosImpostosMensais : NumberUtils.stringToNumber(dadosBaixaObj.impostos.outrosImpostosMensais),
                    vlrVendor : NumberUtils.stringToNumber(dadosBaixaObj.impostos.vlrVendor)
                };

                var valoresBaixa = {};
                if(self.dsVariosTitulos) {
                    valoresBaixa.taxaAdm = NumberUtils.stringToNumber(dadosBaixa.valoresBaixa["taxaAdm"]);
                } else {
                    if(angular.isDefined(dadosBaixaObj.valoresBaixa) && angular.isDefined(dadosBaixaObj.valoresBaixa.taxaAdm) && angular.isDefined(dadosBaixaObj.dadosPendencia) && angular.isDefined(dadosBaixaObj.dadosPendencia.vlrTaxaAdm)) {
                        valoresBaixa.taxaAdm = NumberUtils.round(dadosBaixaObj.valoresBaixa.taxaAdm + dadosBaixaObj.dadosPendencia.vlrTaxaAdm, 2);
                    } else {
                        valoresBaixa.taxaAdm = NumberUtils.stringToNumber(0);
                    }
                }

                var valoresBaixa = {
                    taxaAdm : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.taxaAdm),
                    tipoMulta : dadosBaixaObj.valoresBaixa.tipoMulta,
                    vlrMulta : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrMulta),
                    vlrMultaLib : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrMultaLib),
                    vlrMultaNeg : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrMultaNeg),
                    vlrDesconto : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrDesconto),
                    tipoJuros : dadosBaixaObj.valoresBaixa.tipoJuros,
                    vlrJuros : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrJuros),
                    vlrJurosLib : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrJurosLib),
                    vlrJurosNeg : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrJurosNeg),
                    vlrDesdob : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrDesdob),
                    vlrTotal : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrTotal),
                    vlrDespesasCartorio : dadosBaixaObj.valoresBaixa.vlrDespesasCartorio,
                    recDesp : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.recDesp),
                    multaEmb : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.multaEmb),
                    juroEmb : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.juroEmb),
                    vlrMoeda : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrMoeda),
                    vlrVarCambial : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.vlrVarCambial),
                    tipoMoeda : dadosBaixaObj.valoresBaixa.tipoMoeda,
                    codMoeda : NumberUtils.stringToNumber(dadosBaixaObj.valoresBaixa.codMoeda)
                };

                ObjectUtils.setProperty(dadosBaixa, 'cabecalho', cabecalho);
                ObjectUtils.setProperty(dadosBaixa, 'dadosAdicionais', dadosAdicionais);
                ObjectUtils.setProperty(dadosBaixa, 'dadosBancarios', dadosBancarios);
                ObjectUtils.setProperty(dadosBaixa, 'impostos', impostos);
                ObjectUtils.setProperty(dadosBaixa, 'valoresBaixa', valoresBaixa);

                self.loadingComplete = true;
                
                ObjectUtils.setProperty(self.wizardContext, 'dataWizard', dadosBaixa);
                ObjectUtils.setProperty(self.wizardContext, 'showBotaoVerFinanceiro', $scope.showBotaoVerFinanceiro);
                ObjectUtils.setProperty(self.wizardContext, 'showBotaoFecharReaplicar', $scope.showBotaoFecharReaplicar);

                if(angular.isDefined(_resourceID)){
                    ObjectUtils.setProperty(self.wizardContext, 'resourceID', _resourceID);
                }

                 if(angular.isDefined(_resourceIDBloquearCampos)){
                    ObjectUtils.setProperty(self.wizardContext, 'resourceIdBloquearCampos', _resourceIDBloquearCampos);
                 }

                ObjectUtils.setProperty(self.wizardContext, 'fnClickBtnVerFinanceiro', self.onClickBotaoVerFinanceiro);
                ObjectUtils.setProperty(self.wizardContext, 'hideBtnCancel', false);
            }

            function recalculaValores(dadosRecalculo) {
                return $q(function (resolve, reject) {
                    if (_nuFinBaixa == -1) {
                        return;
                    }else{
                        reterImpostosRetroativos = dadosRecalculo.reterImpostosRetroativos;
                        var params = {
                            nuFin : self.nuFin,
                            novaDataBaixa : DateUtils.dateToString(dadosRecalculo.dtBaixa, DateUtilsConstants.DEFAULT_DATE_FORMAT),
                            resourceID : _resourceID,
                            reterImpostosRetroativos : reterImpostosRetroativos
                        };

                        BaixaAgrupadaHelper.prepararParametrosBaixaAgrupada(params, _paramsFin);

                        ServiceProxy.callService('mge@BaixaFinanceiroSP.recalculaValores', {params})
                            .then(function (response) {
                                var dadosBaixa = response.responseBody.dadosBaixa;
                                if(angular.isDefined(dadosBaixa)){
                                    setaValoresDoRetorno(dadosBaixa);
                                    resolve(self.wizardContext);
                                }
                        });
                    }
                });
            }

            function onCancel($step) {
                if(angular.isFunction($scope.cancelHandler)){
                	var isClose = $scope.cancelHandler({close: doClose}) !== false;
                    if (isClose) {
                    	doClose();
                    }
                }
            }

            function doClose(){
                resetBaixa();
            }
            
            function onClickBotaoVerFinanceiro(){
                if(angular.isFunction($scope.onClickBotaoVerFinanceiro)){
                    $scope.onClickBotaoVerFinanceiro();
                }
            }

            function onFinish($step) {
                var opcaoEscolhida = self.wizardContext.opcao;
                BaixaHelper.prepararBaixa(undefined, undefined, opcaoEscolhida);

                resetBaixa();
            }

            function getOpcao(){
                return self.wizardContext.opcao;
            }

            function resetBaixa(doFinishHandler, ignoreFinishHandler){
                if(self.wizard) {
                    resetParams();

                    self.wizard.dataWizard = {};
                    self.wizardContext.pixSolicitado = false;
                    self.loadingComplete = false;

                    _nuFinBaixa = -1;

                    if (!ignoreFinishHandler) {
                        if(angular.isFunction($scope.finishHandler)) {
                            $scope.finishHandler();
                        }
                    }
                }
            }

            function resetParams() {
                _paramsFin = {};
                _nuFinBaixa = -1;
            }
    }]);
angular
    .module('snk.commons.baixa.panel')
    .directive('skBaixaPanel', [
        function () {
            return {
                scope: {
                    onCreate: '&?skOnCreateBaixaPanel',
                    resourceID: '=?skResourceId',
                    resourceIdBloquearCampos: '=?skResourceIdBloquearCampos',
                    baixaPanelIndex: '=?skBaixaPanelIndex',
                    percentWidth : '=?skPercentWidth',
                    percentHeight : '=?skPercentHeight',
                    usaRecebimentoComCartao : '=?skUsaRecebimentoComCartao',
                    showBotaoVerFinanceiro : '=?skShowBotaoVerFinanceiro',
                    showBotaoFecharReaplicar : '=?skShowBotaoFecharReaplicar',
                    showBotaoBaixaProximo : '=?skShowBotaoBaixaProximo',
                    centralNotas : '=?skCentralNotas',
                    ownerServiceCall : '=?ownerServiceCall',
                    cancelHandler: '&?skCancelHandler',
                    finishHandler: '&?skFinishHandler',
                    baixaPanelRollback: '&?skBaixaPanelRollback',
                    onClickBotaoVerFinanceiro : '&?skOnClickVerFinanceiro',
                },
                controller: 'BaixaPanelController',
                controllerAs: 'ctrl',
                restrict: 'E',
                templateUrl: 'commons/baixa/panel/baixapanel.tpl.html'
            };
        }]);
angular
    .module('snk.commons')
    .controller('OutrosImpostosMensaisController', [ 'data',
        function ( data) {
        
        var self = this;

        self.onDatasetCreated = onDatasetCreated;
        self.refreshHandler = refreshHandler;

        var _impostosMensais = data.impostos;

        function onDatasetCreated(dataset) {
            self.dsImpostosMensais = dataset;
            self.dsImpostosMensais.initAndRefresh();

            var vlrTotalImposto = 0;
            _impostosMensais.forEach(function (impostoMensal) {
                vlrTotalImposto = vlrTotalImposto + NumberUtils.stringToNumber(impostoMensal.valorRateado);
            });

            self.vlrTotalImpostos = NumberUtils.format(vlrTotalImposto, 2);
        }

        function refreshHandler() {
            return _impostosMensais;
        }
    }]);
angular
    .module('snk.commons')
    .controller('AlterarTipoTituloController', [ 'data', '$scope', '$popupInstance', 'MessageUtils', 'MGEParameters', 'i18n',
        function (data, $scope, $popupInstance, MessageUtils, MGEParameters, i18n) {
        
        var self = this;
        var textoTipoTitulo = data.textoTipoTitulo;
        var baixaAgrupada = data.baixaAgrupada;

        self.getCriteria = getCriteria;
        self.getString = getString;
        self.defineValorParametro = defineValorParametro;
        self.getMensagens = getMensagens;
        $scope.$success = confirmar;

        defineValorParametro();

        function defineValorParametro() {
            if (MGEParameters.asInteger("fin.valor.padrao.para.titulo.pix") > 0) {
                self.codTipTit = MGEParameters.asInteger("fin.valor.padrao.para.titulo.pix");
            }            
        }
        
        function getCriteria() {
            var criteria = new Criteria();

            criteria.append("this.SUBTIPOVENDA = 10");
            return criteria;
        }

        function getString(){
            if (baixaAgrupada) {
                return i18n('Commons.Baixa.msgAlteraTipoTituloAgrupado');
            } else {
                return i18n('Commons.Baixa.msgAlteraTipoTitulo', [textoTipoTitulo]);
            }            
        }

        function getMensagens(texto) {
            return i18n(texto);
        }

        function confirmar(){
            if (!self.codTipTit) {
                MessageUtils.showAlert(i18n('Commons.Baixa.msgTipoTituloObrigatorio'));
                return;
            }
            $popupInstance.success(self.codTipTit);
        };
        
    }]);
angular
    .module('snk.commons')
    .controller('ReceberComPixController', [ 'data', 'ServiceProxy', 'ObjectUtils', 'i18n', '$popupInstance', 'MessageUtils', 'DateUtils', 'StringUtils',
        function (data, ServiceProxy, ObjectUtils, i18n, $popupInstance, MessageUtils, DateUtils, StringUtils) {
        
        var self = this;
        
        self.abaQrcode = true;
        self.abaComprovante = false;

        self.txid;
        self.imagem;
        self.codigo;
        self.comprovante;
        self.nufin;
        self.data;
        self.hora;
        self.valor;
        self.nomePagador;
        self.idTransacao;
        self.conta;

        self.getString = getString;
        self.copiarCodigo = copiarCodigo;
        self.onCancel = onCancel;
        self.close = close;

        init();

        function init() {

            self.txid     = data.cobranca.txid;
            self.codigo   = data.cobranca.codigo;
            self.imagem   = data.cobranca.imagem;
            self.nufin    = data.cobranca.nufin;
            self.conta    = data.cobranca.codConta;
        }

        var mySetInterval = setInterval(function() {
            if(self.txid){
                consultaTransacao();
            }
        }, 5000);
        
        function consultaTransacao() {
            var param = { 
                txid: self.txid,
                nufin: self.nufin,
                codConta: self.conta
            };

            ServiceProxy.callService("mge@BaixaFinanceiroSP.consultaTransacaoPix", { param })
                .then(function (result) {

                    var pagamento =  ObjectUtils.getProperty(result, "responseBody.pagamento");

                    if (pagamento && pagamento.comprovante) {
                        clearInterval(mySetInterval);

                        self.comprovante = pagamento.comprovante;

                        self.abaQrcode = false;
                        self.abaComprovante = true;

                        self.data        = pagamento.data;
                        self.hora        = pagamento.hora;
                        self.valor       = pagamento.valor;
                        self.nomePagador = pagamento.nomePagador;
                        self.idTransacao = pagamento.idTransacao;
                       
                    }
                }
            );
        }

        function getString(txtTexto){
            return i18n(txtTexto);
        }

        function close(comprovante) {
            $popupInstance.success(comprovante);
        }

        function copiarCodigo() {
            var tempInput = document.createElement("input");
            tempInput.value =  self.codigo;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        }

        function onCancel() {
            clearInterval(mySetInterval);
            close(null);
        }

    }]);
angular
    .module('snk.commons.baixa.panel')
    .controller('BaixandoStepController', ['$wizard', '$step','ObjectUtils','StringUtils', 'ServiceProxy', 'DateUtils', '$timeout', 'AngularUtil', 'SkApplicationInstance', 'NumberUtils','Base64', 'DateUtilsConstants', 'XmlJson', 'i18n', 'MessageUtils', '$scope', 'SanPopup','PrintUtils','ServicoConfirmacao','UidGenerator',
        function ($wizard, $step, ObjectUtils, StringUtils, ServiceProxy, DateUtils, $timeout, AngularUtil, SkApplicationInstance, NumberUtils,Base64, DateUtilsConstants, XmlJson, i18n, MessageUtils, $scope, SanPopup,PrintUtils,ServicoConfirmacao,UidGenerator){
            var self = this;

            self.isBaixando = false;

            var _dsVariosTitulos;
            var usaRecebimentoComCartao;
            var _isLiberacao = false;
            var centralNotas = false;
            var ownerServiceCall;
            var _cabecalhoBaixa;

            const BANCO_BRASIL = "1";

            $step.onEnterStep = showStep;
            $step.onExitStep = exitStep;
            self.onClickVerFinanceiro = onClickVerFinanceiro;
            self.onCreatedCabecalho = onCreatedCabecalho;

            function onCreatedCabecalho(cabecalho){
                _cabecalhoBaixa = cabecalho;
            }

            function showStep(){
                self.wizard = $wizard.context;
                $wizard.context.hideBtnCancel = false;

                if($wizard.context.rollbackBaixa) {
                    $wizard.context.pixSolicitado = false;
                }
                $wizard.context.rollbackBaixa = false;

                var cabecalho = self.wizard.dataWizard.cabecalho;
                self.dadosCabecalho = {
                    nufin : cabecalho.nufin,
                    desdob : cabecalho.desdob,
                    dtVencimento : cabecalho.dtVencimento,
                    dtBaixa : cabecalho.dtBaixa,
                    diasAtraso : cabecalho.diasAtraso,
                    vlrTotal : cabecalho.vlrTotal,
                    vlrCalculado : cabecalho.vlrCalculado
                };

                _dsVariosTitulos = self.wizard.dsVariosTitulos;
                ownerServiceCall = self.wizard.ownerServiceCall;

                self.isLoad = true;

                paramsClientEvent = {
                    params:{
                        oldConta: $wizard.context.paramsFin.oldConta,
                        newConta: $wizard.context.dataWizard.dadosBancarios.codConta,
                        nufin: $wizard.context.paramsFin.nuFin
                    }
                }

                if($wizard.context.pixSolicitado && self.wizard.dataWizard.dadosBancarios.codBco === BANCO_BRASIL) {
                    baixaAtivaFintech(self.wizard.dataWizard.dadosBancarios.codConta).then(function(baixaFintechAtiva){
                        if(baixaFintechAtiva){
                            tituloBaixado();
                            return;
                        }
                        executarBaixa();
                    });
                } else {
                    executarBaixa();
                }
            }

            function executarBaixa() {
                ServiceProxy.callService("mge@BaixaFinanceiroSP.getParameterImpressao", paramsClientEvent)
                    .then(function(response){
                        var paramImprimeBoleto = response.responseBody.resultado.parametros.paramImprimeBoleto  == "true";
                        var paramImprimeBoletoDireto = response.responseBody.resultado.parametros.paramImprimeBoletoDireto == "true";
                        var confirm = response.responseBody.resultado.parametros.confirm ? true : false;
                        if (paramImprimeBoleto) {
                            if (paramImprimeBoletoDireto) {
                                realizaBaixa(true,confirm);
                            } else {
                                MessageUtils.confirm(i18n("Commons.Baixa.labelImprimirRecibo")).then(
                                        function () {
                                            realizaBaixa(true,confirm)
                                        },
                                        function () {
                                            realizaBaixa(false,confirm)
                                        }
                                );             
                            }
                        } else {
                            realizaBaixa(false,confirm);
                        }
                    });
            }

            async function baixaAtivaFintech(codConta){
                self.receberComPix = true;
                let params = {
                    entity: {
                        name: "ContaFintech",
                        criterio: [{
                        nome: "CODCTA",
                        valor: codConta
                        }],
                        fields: {
                        field: [
                            {name:"APIBAIXAAUTOMATICA"}
                        ]
                        }
                    }
                }

                return await ServiceProxy.callService("mge@crud.find", params).then(function(result){
                        let apiBaixaAutomatica = ObjectUtils.getProperty(result, 'responseBody.entidades.entidade.APIBAIXAAUTOMATICA');
                        return apiBaixaAutomatica && apiBaixaAutomatica.$ != "N" ? true : false;
                    }
                ).catch(function(error) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR,  i18n('Commons.Baixa.msgModuloDesatualizado'));
                });;
            }
            
            function possuiCaractereEspecial(texto){
				if (StringUtils.replaceAccentuatedChars(Base64.decode(Base64.encode(texto, true))) != 
					StringUtils.replaceAccentuatedChars(texto)) {				
					return true;
				} 
				
				return false;
			}

            function realizaBaixa(imprimeRecibo, confirm = false) {
                self.isBaixando = true;

                var params = XmlJson.create("dadosBaixa", {
                        dtbaixa: self.dadosCabecalho.dtBaixa,
                        nufin: self.dadosCabecalho.nufin,
                        decisao: NumberUtils.getNumberOrZero(self.wizard.dataWizard.decisao),
                        reterImpostosRetroativos: self.wizard.dataWizard.reterImpostosRetroativos,
                        isConfirm : confirm 
                });

                if (self.wizard.dataWizard.hasOwnProperty('baixaAgrupada')) {
                    var childrenFinanceiro = self.wizard.dataWizard.baixaAgrupada?.financeiros?.financeiro;
                    if (angular.isDefined(childrenFinanceiro)) {
                        var baixaAgrupada = XmlJson.create("baixaAgrupada");
                        var financeiros = XmlJson.create("financeiros");

                        if (!angular.isArray(childrenFinanceiro)) {
                            childrenFinanceiro = [childrenFinanceiro];
                        }
                        
                        childrenFinanceiro.forEach(function (fin) {
                            XmlJson.append(financeiros, XmlJson.create("financeiro", null, fin.$));
                        });
                                            
                        XmlJson.append(baixaAgrupada, financeiros);
                        XmlJson.append(params, baixaAgrupada);
                    }
                }

               var variosTitulos = angular.isDefined(_dsVariosTitulos) ? _dsVariosTitulos : undefined;

                var temRecebimentoCartao = false;
                var confirmouRecebimentoCartao = false;

                if(angular.isDefined(variosTitulos)) {
                    var titulos = variosTitulos.getRecordsAsObjects();
                    var variosTiposTitulos = XmlJson.create("variosTiposTitulos");

                    titulos.forEach(function (titulo, index) {
                        var titulosElem = XmlJson.create("titulo");

                        //Somente o primeiro título (original) tem o número único
                        if(index == 0) {
                            XmlJson.append(titulosElem, XmlJson.create("NUFIN", null, self.dadosCabecalho.nufin));
                        }

                        XmlJson.append(titulosElem, XmlJson.create("VLRBAIXA", null, titulo.VLRBAIXA));

                        if(angular.isDefined(titulo.NOSSONUM)) {
                            XmlJson.append(titulosElem, XmlJson.create("NOSSONUM", null, titulo.NOSSONUM));
                        }

                        if(angular.isDefined(titulo.CODBCO)) {
                            XmlJson.append(titulosElem, XmlJson.create("CODBCO", null, titulo.CODBCO));
                        }

                        if(angular.isDefined(titulo.HISTORICO)) {
                        	if (possuiCaractereEspecial(titulo.HISTORICO)){
            					XmlJson.append(titulosElem, XmlJson.create("HISTORICO", null, Base64.encode(titulo.HISTORICO, true)));
            				} else{
            					XmlJson.append(titulosElem, XmlJson.create("HISTORICO", null, Base64.encode(titulo.HISTORICO)));
            				}
                        }

                        if(angular.isDefined(titulo.DHBAIXA)) {
                            XmlJson.append(titulosElem, XmlJson.create("DHBAIXA", null, DateUtils.formatDate(titulo.DHBAIXA, DateUtilsConstants.DEFAULT_DATE_FORMAT)));
                        }

                        if(angular.isDefined(titulo.CODBARRA)) {
                            XmlJson.append(titulosElem, XmlJson.create("CODBARRA", null, titulo.CODBARRA));
                        }

                        if(angular.isDefined(titulo.CODTIPTIT)) {
                            XmlJson.append(titulosElem, XmlJson.create("CODTIPTIT", null, titulo.CODTIPTIT));
                        }

                        if(angular.isDefined(titulo.CODBCO_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("CODBCO_CMC7", null, titulo.CODBCO_CMC7));
                        }

                        if(angular.isDefined(titulo.AGENCIA_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("AGENCIA_CMC7", null, titulo.AGENCIA_CMC7));
                        }

                        if(angular.isDefined(titulo.CONTA_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("CONTA_CMC7", null, titulo.CONTA_CMC7));
                        }

                        if(angular.isDefined(titulo.CGC_CPF_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("CGC_CPF_CMC7", null, titulo.CGC_CPF_CMC7));
                        }

                        if(angular.isDefined(titulo.NOMEEMITENTE_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("NOMEEMITENTE_CMC7", null, titulo.NOMEEMITENTE_CMC7));
                        }

                        if(angular.isDefined(titulo.CHEQUERASTREADO_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("CHEQUERASTREADO_CMC7", null, titulo.CHEQUERASTREADO_CMC7));
                        }

                        if(angular.isDefined(titulo.DTCHEQUE_CMC7)) {
                            XmlJson.append(titulosElem, XmlJson.create("DTCHEQUE_CMC7", null, titulo.DTCHEQUE_CMC7));
                        }

                        if (self.wizard.usaRecebimentoComCartao && StringUtils.emptyAsNull(titulo.NSUCTF) != null) {
                            temRecebimentoCartao = true;
                            confirmouRecebimentoCartao = !StringUtils.isEmpty(titulo.RETORNOCONFIRMACAO);

                            XmlJson.append(titulosElem, XmlJson.create("NSUCTF", null, titulo.NSUCTF));
                            XmlJson.append(titulosElem, XmlJson.create("OPERACAO", null, titulo.OPERACAO));
                            XmlJson.append(titulosElem, XmlJson.create("NUMTRANS", null, titulo.NUMTRANS));
                            XmlJson.append(titulosElem, XmlJson.create("CODRESPAUTORIZADORA", null, titulo.CODRESPAUTORIZADORA));
                            XmlJson.append(titulosElem, XmlJson.create("CODAPROVACAO", null, titulo.CODAPROVACAO));
                            XmlJson.append(titulosElem, XmlJson.create("VLRTRANSACAO", null, titulo.VLRTRANSACAO));
                            XmlJson.append(titulosElem, XmlJson.create("NSUAUTORIZADORA", null, titulo.NSUAUTORIZADORA));
                            XmlJson.append(titulosElem, XmlJson.create("DTTRANSACAO", null, DateUtils.formatDate(titulo.DTTRANSACAO, DateUtilsConstants.DEFAULT_DATE_FORMAT)));
                            XmlJson.append(titulosElem, XmlJson.create("QTDPARCELAS", null, titulo.QTDPARCELAS));
                            XmlJson.append(titulosElem, XmlJson.create("BANDEIRA", null, titulo.BANDEIRA));
                            XmlJson.append(titulosElem, XmlJson.create("REDEADQUIRENTE", null, titulo.REDEADQUIRENTE));
                            XmlJson.append(titulosElem, XmlJson.create("CARTAO", null, titulo.CARTAO));
                            XmlJson.append(titulosElem, XmlJson.create("STATUS", null, titulo.STATUS));
                            XmlJson.append(titulosElem, XmlJson.create("REQUISICAO", null, titulo.REQUISICAO));
                            XmlJson.append(titulosElem, XmlJson.create("RETORNO", null, titulo.RETORNO));
                            XmlJson.append(titulosElem, XmlJson.create("REQUISICAOCONFIRMACAO", null, titulo.REQUISICAOCONFIRMACAO));
                            XmlJson.append(titulosElem, XmlJson.create("RETORNOCONFIRMACAO", null, titulo.RETORNOCONFIRMACAO));

                            if (StringUtils.isEmpty(titulo.DTPREDATADO)) {
                                XmlJson.append(titulosElem, XmlJson.create("DTPREDATADO", null, DateUtils.formatDate(titulo.DTPREDATADO, DateUtilsConstants.DEFAULT_DATE_FORMAT)));
                            }

                            XmlJson.append(titulosElem, XmlJson.create("IDENTIFICACAOTEF", null, titulo.IDENTIFICACAOTEF));
                        }

                        XmlJson.append(variosTiposTitulos, titulosElem);
                    });

                    XmlJson.append(params, variosTiposTitulos);
                }

                var dataWizard = self.wizard.dataWizard;

                var valoresBaixa = XmlJson.create("valoresBaixa" , {
                    tipoJuros: angular.isDefined(dataWizard.valoresBaixa.tipoJuros) ? dataWizard.valoresBaixa.tipoJuros : "",
                    tipoMulta: angular.isDefined(dataWizard.valoresBaixa.tipoMulta) ? dataWizard.valoresBaixa.tipoMulta : "",
                    taxaAdm: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.taxaAdm),
                    vlrDesconto: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrDesconto),
                    vlrCalculado: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrCalculado),
                    vlrDesdob: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrDesdob),
                    vlrDespesasCartorio: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrDespesasCartorio),
                    vlrJuros: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrJuros),
                    vlrMulta: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrMulta),
                    vlrTotal: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrTotal),
                    vlrMultaNeg: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrMultaNeg),
                    vlrJurosNeg: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrJurosNeg),
                    jurosLib: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrJurosLib),
                    multaLib: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrMultaLib),
                    vlrMoeda: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrMoeda),
                    vlrVarCambial: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrVarCambial),
                    vlrTotalOriginal: NumberUtils.getNumberOrZero(dataWizard.valoresBaixa.vlrTotalOriginal)
                });

                XmlJson.append(params, valoresBaixa);

                var _historico = "";
                if(dataWizard.dadosBancarios.historico){
                	if (possuiCaractereEspecial(dataWizard.dadosBancarios.historico)){
						_historico = Base64.encode(dataWizard.dadosBancarios.historico, true);
					} else{
						_historico = Base64.encode(dataWizard.dadosBancarios.historico);
					}
                }

                var dadosBancarios = XmlJson.create("dadosBancarios" , {
                    codConta: dataWizard.dadosBancarios.codConta,
                    codLancamento: dataWizard.dadosBancarios.codLancamento,
                    numDocumento: dataWizard.dadosBancarios.numDocumento,
                    dataConciliacao: dataWizard.dadosBancarios.dataConciliacao,
                    codTipTit: dataWizard.dadosBancarios.codTipTit,
                    vlrMoedaBaixa: dataWizard.dadosBancarios.vlrMoedaBaixa,
                    contaParaCaixaAberto: dataWizard.dadosBancarios.contaParaCaixaAberto,
                    historico: _historico
                });
                                
                XmlJson.append(params, dadosBancarios);

                var dadosAdicionais = XmlJson.create("dadosAdicionais" , {
                    codEmpresa : dataWizard.dadosAdicionais.codEmpresa,
                    codTipoOperacao : dataWizard.dadosAdicionais.codTipoOperacao
                });

                XmlJson.append(params, dadosAdicionais);

                if(dataWizard.hasOwnProperty("dadosPendencia")) {
                    var dadosPendencia = XmlJson.create("dadosPendencia" , {
                        dtVencimento : dataWizard.dadosPendencia.dtVencimento,
                        vlrDesconto : dataWizard.dadosPendencia.vlrDesconto,
                        vlrDespesaCartorio : dataWizard.dadosPendencia.vlrDespCartorio,
                        vlrInss : dataWizard.dadosPendencia.vlrInss,
                        vlrIrrf : dataWizard.dadosPendencia.vlrIrrf,
                        vlrIss : dataWizard.dadosPendencia.vlrIss,
                        vlrJuroIncluso : dataWizard.dadosPendencia.vlrJuro,
                        vlrMultaInclusa : dataWizard.dadosPendencia.vlrMulta,
                        vlrOutrosImpostos : dataWizard.dadosPendencia.vlrOutrosImp,
                        vlrOutrosImpostosMensais : dataWizard.dadosPendencia.outrosImpMen,
                        vlrTaxaAdm : dataWizard.dadosPendencia.vlrTaxaAdm,
                        vlrVendor : dataWizard.dadosPendencia.vlrVendor,
                        vlrTotal : dataWizard.dadosPendencia.vlrTotal,
                        vlrJurosNeg : dataWizard.dadosPendencia.vlrJurosNeg,
                        vlrMultaNeg : dataWizard.dadosPendencia.vlrMultaNeg
                    });

                    XmlJson.append(params, dadosPendencia);
                }

                var impostos = XmlJson.create("impostos" , {
                    inssRetido: dataWizard.impostos.inssRetido,
                    irrfRetido: dataWizard.impostos.irrfRetido,
                    issRetido: dataWizard.impostos.issRetido,
                    outrosImpostos: NumberUtils.getNumberOrZero(dataWizard.impostos.vlrOutrosImpostos),
                    outrosImpostosMensais: NumberUtils.getNumberOrZero(dataWizard.impostos.vlrOutrosImpMensais),
                    vlrInss: dataWizard.impostos.vlrInss,
                    vlrIrrf: dataWizard.impostos.vlrIrrf,
                    vlrIss: dataWizard.impostos.vlrIss,
                    vlrVendor: dataWizard.impostos.vlrVendor,
                    baseDevida: dataWizard.impostos.baseDevidaOutrosImpostos
                });

                XmlJson.append(params, impostos);

                var imprimeRecibo = XmlJson.create("imprimeRecibo" , {
                	paramImprimeBoleto : imprimeRecibo
                });

                XmlJson.append(params, imprimeRecibo);

                if(angular.isDefined(dataWizard.resourceID)){
                    XmlJson.setAttribute(params, 'resourceID', dataWizard.resourceID);
                }

                // Indica que a baixa está sendo realizada pela tela de Acerto de Ordem de Carga
                var movPelaTelaAcertoOC = SkApplicationInstance.getRuntimeProperty("ignorar.validacao.usuario.caixa");
                if(angular.isDefined(movPelaTelaAcertoOC)){
                    XmlJson.append(params, XmlJson.create("movPelaTelaAcertoOC" , null, movPelaTelaAcertoOC));
                }

                if (centralNotas) {
                    XmlJson.append(params, XmlJson.create("movPelaCentralDeNotas" , null, centralNotas));
                }

                if (ownerServiceCall) {
                    XmlJson.setAttribute(params, 'ownerServiceCall', ownerServiceCall);
                }

                var conversationId = getConversationId(temRecebimentoCartao && !confirmouRecebimentoCartao);

                let serviceConfig ={normalizedJson: true}

                if(conversationId!=null){
                    serviceConfig.aditionalUrlParameters= { 'conversation-id': conversationId  }
                }
                
                ServiceProxy.callService("mge@BaixaFinanceiroSP.baixarTitulo", params, serviceConfig )
                    .then(function(response){
                        if (XmlJson.isNormalized(response)) {
							XmlJson.denormalize(response);
						}

                        var processaLiberacoes = response.responseBody.resultado.liberacoes;
                        var mensagemComissao = response.responseBody.resultado.comissao;
                        var liberacoesList = [];
                        var mensagensList = [];
                        var comissaoList = [];
                        var _codigoUsuario;
                        var impressoes = {};
                        _isLiberacao = false;

                        if(angular.isDefined(processaLiberacoes) && !ObjectUtils.isEmpty(processaLiberacoes)) {
                            liberacoesList = response.responseBody.resultado.liberacoes.liberacao;
                            mensagensList = angular.isDefined(response.responseBody.resultado.mensagens) ? response.responseBody.resultado.mensagens.mensagem : [];
                            impressoes = response.responseBody.resultado;
                            _codigoUsuario = response.responseBody.resultado.usuarios.usuario.codUsuLogado;
                            _isLiberacao = true;
                        }
                        
                        if (ObjectUtils.getProperty(response.responseBody.resultado,'impressoes')) {
                            let codUsuLogado = SkApplicationInstance.getUserID();                         
                            let impressao =ObjectUtils.getProperty(response.responseBody.resultado.impressoes,'impressao');                          
                            let info='CODATA='+impressao?.codAta+',IMPRESSORA='+impressao?.impressora+',DESCRICAO='+impressao?.descricao+',TIPO='+impressao?.tipo;
                            PrintUtils.impressaoDireta(info, codUsuLogado)
                        }
                        
                        if(angular.isDefined(mensagemComissao) && !ObjectUtils.isEmpty(mensagemComissao)) {
                        	comissaoList = response.responseBody.resultado.comissao.mensagem;                        	
                        	ObjectUtils.setProperty(dataWizard, 'msgComissao', comissaoList);
                        }
                        //var dataWizard = {};

                        if(angular.isDefined(liberacoesList)) {
                            ObjectUtils.setProperty(dataWizard, 'baixou', false);
                        } else {
                            ObjectUtils.setProperty(dataWizard, 'baixou', true);
                        }

                        ObjectUtils.setProperty(dataWizard, 'liberacoes', liberacoesList);
                        ObjectUtils.setProperty(dataWizard, 'mensagens', mensagensList);
                        ObjectUtils.setProperty(dataWizard, 'impressoes', impressoes);
                        ObjectUtils.setProperty(dataWizard, 'usuarioLogado', _codigoUsuario);

                        var cabecalho = {
                            nufin : self.dadosCabecalho.nufin,
                            desdob : self.dadosCabecalho.desdob,
                            dtBaixa : self.dadosCabecalho.dtBaixa,
                            dtVencimento : self.dadosCabecalho.dtVencimento,
                            diasAtraso : self.dadosCabecalho.diasAtraso,
                            vlrTotal : self.dadosCabecalho.vlrTotal,
                            vlrCalculado : self.dadosCabecalho.vlrCalculado
                        };

                        ObjectUtils.setProperty(dataWizard, 'cabecalho', cabecalho);

                        $wizard.context.dataWizard = dataWizard;
                        $timeout(function () {
                            $wizard.next();
                            self.isBaixando = false;
                        }, 100, false);

                    }, function (err) {
                        if(angular.isDefined(err)){
                            $wizard.context.rollbackBaixa = true;
                            $wizard.previous();
                        }
                        self.isBaixando = false;
                    });

                aguardarPreparacaoBaixa(conversationId, imprimeRecibo);
            }
            
            function exitStep() {
                ObjectUtils.setProperty($wizard.context, 'isLiberacao', _isLiberacao);
            }

            function onClickVerFinanceiro() {
                var baixaPanelCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-baixa-panel"))
                if (angular.isDefined(baixaPanelCtrl)) {
                    baixaPanelCtrl.onClickBotaoVerFinanceiro();
                }
            }            
          

            function aguardarPreparacaoBaixa(conversationId,imprimeRecibo) {
				if (conversationId != null) {
					var waitParam = {
						wait: {
							signal: {
								"$": "baixa.executa.confirmacao.tef"
							}
						}
					}
                    ServiceProxy.callService("mge@XConversation.waitSignal", waitParam, { aditionalUrlParameters: {'conversation-id':conversationId} }).then(function (response) {
                  
                        const status = parseInt(ObjectUtils.getProperty(response, 'responseBody.signal-result.status.$'));
						if (status==0) {
								confirmarRecebimentoCartao(conversationId,imprimeRecibo);
							}
                    });
				}
			}
            function getConversationId(temRecebimentoCartao){
				if (temRecebimentoCartao) {
                    const resourceID = SkApplicationInstance.getResourceID();
					return UidGenerator.generateUID(`${resourceID}_BaixaComVariosTitulos_`);
				}
				
				return null;
			}

            function confirmarRecebimentoCartao(conversationId,imprimeRecibo){
				var servico = ServicoConfirmacao;
				servico.setDataSet(_dsVariosTitulos);

				servico.setSucessoFunction( () => {
					var retornoSucesso = { data: {} };

					var titulos = _dsVariosTitulos.getRecordsAsObjects();

					if (titulos != null && titulos.length > 0) {
						var tefsXML = { tefs: { type: "X" } };
						var tef = []
						angular.forEach(titulos, function (titulo, key) {
							if (StringUtils.emptyAsNull(titulo.NSUCTF) != null) {

								tef.push({
										NSUCTF: { $: titulo.NSUCTF },
										REQUISICAOCONFIRMACAO: { $: titulo.REQUISICAOCONFIRMACAO },
										RETORNOCONFIRMACAO: { $: titulo.RETORNOCONFIRMACAO }
								})


							}
						});

						tefsXML.tefs.tef = tef;
						retornoSucesso.data.tefsXML = tefsXML.tefs;
					}

					enviarSinalConfirmacaoCartao(conversationId, "baixa.confirmacao.tef.ok",imprimeRecibo, retornoSucesso.data);

				});

				servico.setErroFunction ( (erro) => {
					var retornoErro = { erro: { type: "S", $: erro.msgErro } };
					enviarSinalConfirmacaoCartao(conversationId, "baixa.confirmacao.tef.cancelar",imprimeRecibo, retornoErro);
				});

				servico.processarConfirmacao();
            }

            function enviarSinalConfirmacaoCartao(conversationId, signal,imprimeRecibo, data) {
				if (conversationId != null) {
					var sendParam = {
						send:
							{ signal: { $: signal } }
					};

					if (data != null) {
						sendParam.send.data = data;
					}
					ServiceProxy.callService("mge@XConversation.sendSignal",
						sendParam, { aditionalUrlParameters: { 'conversation-id': conversationId } }).then(function (response) {

							const status = parseInt(ObjectUtils.getProperty(response, 'responseBody.signal-result.status.$'));

							if (status == 1 && signal == "baixa.confirmacao.tef.ok") {
								realizaBaixa(imprimeRecibo);
							}
						});
				}
			}

            function tituloBaixado(){

                let dataWizard = self.wizard.dataWizard;
                
                ObjectUtils.setProperty(dataWizard, 'baixou', true);

                let cabecalho = {
                    nufin : self.dadosCabecalho.nufin,
                    desdob : self.dadosCabecalho.desdob,
                    dtBaixa : self.dadosCabecalho.dtBaixa,
                    dtVencimento : self.dadosCabecalho.dtVencimento,
                    diasAtraso : self.dadosCabecalho.diasAtraso,
                    vlrTotal : self.dadosCabecalho.vlrTotal,
                    vlrCalculado : self.dadosCabecalho.vlrCalculado
                };

                ObjectUtils.setProperty(dataWizard, 'cabecalho', cabecalho);

                $wizard.context.dataWizard = dataWizard;
                $timeout(function () {
                    $wizard.next();
                    self.isBaixando = false;
                }, 100, false);
            }

         
    }]);

angular
    .module('snk.commons.baixa.panel')
    .controller('BaixaStepController', ['$rootScope', '$wizard', '$step', 'ObjectUtils', 'ArrayUtils', 'SkApplicationInstance', 'MGEParameters', 'StringUtils', 'ServiceProxy', 'MessageUtils', 'DateUtils', 'i18n', 'Criteria', 'NumberUtils', 'AngularUtil', 'CMC7PanelService', 'SkApplication', 'CancelamentoTransacaoPendentePopup', 'RecebimentoCartaoPopup', 'CrudUtils', 'BaixaAgrupadaHelper', 'SkPesquisaService', 'SanPopup','TEF', 'SqlUtils', 'FintechUtilsService',
        function($rootScope, $wizard, $step, ObjectUtils, ArrayUtils, SkApplicationInstance, MGEParameters, StringUtils, ServiceProxy, MessageUtils, DateUtils, i18n, Criteria, NumberUtils, AngularUtil, CMC7PanelService, SkApplication, CancelamentoTransacaoPendentePopup, RecebimentoCartaoPopup, CrudUtils, BaixaAgrupadaHelper, SkPesquisaService, SanPopup, TEF, SqlUtils, FintechUtilsService) {
            var self = this;
            
            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);

            //Events
            var FOCUS_IN = "FOCUS_IN";
            var FOCUS_OUT = "FOCUS_OUT";
            var CHANGE = "CHANGE";
            var CARREGANDO_DADOS_NOVOS = "br.com.sankhya.baixa.panel.carregando.dados.novos";
            var ALTERAR_CONTA_BANCARIA = "br.com.sankhya.baixa.panel.alterar.conta.bancaria";
            var CONCLUIR_COM_OUTRA_CONTA = "br.com.sankhya.baixa.panel.concluir.com.outra.conta";

            var _nufin;
            var _codTipOperFinanceiro;
            var _codTipTitOrig;
            var desdob;
            var dtVencimento;
            var dtBaixa;
            var diasAtraso;
            var vlrTotal;
            var _regimeCaixa;
            var _usuarioEhCaixa;
            var baixaAgrupada;
            var usaRecebimentoComCartao;
            var _vlrDesdobNegociacao;
            var _juroBaixa = 0;
            var _multaBaixa = 0;
            var _descontoBaixa = 0;
            var _despCartorioBaixa = 0;
            var _taxaAdmBaixa = 0;
            var _IRRFBaixa = 0;
            var _INSSBaixa = 0;
            var _ISSBaixa = 0;
            var _vendorBaixa = 0;
            var _juroLibBaixa = 0;
            var _multaLibBaixa = 0;
            var _vlrMoeda = 0;
            var _vlrMoedaBaixa = 0;
            var _vlrDesdob = 0;
            var _valorCalculado = 0;
            var _baseDevidaOutrosImpMensais = 0;
            var _codParc;
            var _restricaoTipOper;
            var _codMoeda;
            var _valorTotal;
            var _alteraImpostos;
            var _vlrInssOrig = 0;
            var _vlrIrrfOrig = 0;
            var _vlrOutrosImpMensaisOrig = 0;
            var _vlrISSOrig = 0;
			var _vlrMultaOrig = 0;
			var _despCartorioOrig = 0;
			var _vlrVendorOrig = 0;
			var _vlrDescontoOrig = 0;
			var _multaLibOrig = 0;
			var _vlrJuroOrig = 0;
            var _taxaAdmAnterior;
            var _codBarras;
            var _codBco;
            var _recDesp = 0;
            var _utilizaSankhyaCivil=false;
            var _paramCalculaImpostosMensaisReceita;
            var _vlrVarCambial = 0;
            var _usuarioAlteraValorMoeda;
            var _valorTotalOutrosTitulos = 0;
            var _mostraValorMoeda = MGEParameters.asBoolean("fin.mostra.valor.moeda.financeiro");
            var _baixaAgruMoeda = MGEParameters.asBoolean("fin.sankhya.baixaagrumoeda");
            var _contaParaCaixaAberto;
            var _focusInValue;
            var params = {};
            var _btnReceberAtivo;
            var _cabecalhoBaixa;
            var _tipoTituloChanged = true;
            var _abriuCmc7PopUp = false;

            const BANCO_BRASIL = 1;
            let codBancoContaSelecionada;
            let pixBBAtivo = false;

            self.optTipoMulta = [
                { value: i18n('Commons.Baixa.itemIncluso'), data: 'I' },
                {value: i18n('Commons.Baixa.labelExtraNota'), data: 'E'}];

            self.optTipoJuro = [
                { value: i18n('Commons.Baixa.itemIncluso'), data: 'I' },
                {value: i18n('Commons.Baixa.labelExtraNota'), data: 'E'}];

            self.labelDadosBaixa = i18n('Commons.Baixa.labelDadosBaixa');
            self.labelRetido = i18n('Commons.Baixa.labelRetido');
            self.labelVlrMoeda = i18n('Commons.Baixa.labelVlrMoeda');
            self.labelDocumento = i18n('Commons.Baixa.labelDocumento');
            self.labelOutrosImpostos = i18n('Commons.Impostos.labelOutrosImpostos');
            self.lblFechamentoBaixaMoeda = i18n('Commons.Baixa.lblFechamentoBaixaMoeda');
            self.labelPgtoVariosTitulos = i18n('Commons.Baixa.labelPgtoVariosTitulos');
            self.labelBtnReceber = i18n('Commons.RecebimentoCartao.lblCartao');
            self.paramDecVlrMoeda = MGEParameters.asInteger("mgefin.decimais.calc.moeda");
            self.isJivaW = false;
            self.vlrDesdobTotalEnabled = false;
            self.empresaEnabled = true;
            self.topEnabled = true;
            self.usaRecebimentoComCartao = false;

            $step.onEnterStep = showStep;
            $step.onExitStep = exitStep;
            self.onDatasetCreated = onDatasetCreated;
            self.changeCodTipTitulo = changeCodTipTitulo;
            self.getTipoOperacaoCriteria = getTipoOperacaoCriteria;
            self.addEventListener = addEventListener;
            self.detalhesOutrosImpMensais = detalhesOutrosImpMensais;
            self.criteriaCotacaoMoeda = criteriaCotacaoMoeda;
            self.onClickVerFinanceiro = onClickVerFinanceiro;
            self.afterPopulateCodTipTitulo = afterPopulateCodTipTitulo;
            self.openInformarCMC7 = openInformarCMC7;
            self.receberCancelarCartao = receberCancelarCartao;
            self.enviromentCriteria = enviromentCriteria;
            self.metadataInterceptor = metadataInterceptor;
            self.environmentCriteriaTipoTitulo = environmentCriteriaTipoTitulo;
            self.environmentCriteriaContaBancaria = environmentCriteriaContaBancaria;
            self.calculaValorAliquota = calculaValorAliquota;
            self.calculaOutrosImpostos = calculaOutrosImpostos;
            self.onCreatedCabecalho = onCreatedCabecalho;
            self.calculaMulta = calculaMulta;
            self.calculaJuro = calculaJuro;
            self.recalculaValores = recalculaValores;
            self.buscarMoeda = buscarMoeda;
            self.buscarCotacao = buscarCotacao;
            self.changeValorMoeda = changeValorMoeda;
            self.setVariosTitulosInsertionMode = setVariosTitulosInsertionMode;
            self.baixaPanel = $rootScope.baixaPanel;
            self.gerarPix = gerarPix;
            self.onCancel = $wizard.cancel;
            self.onNext = $wizard.next;
            self.receberComPix = false;
            self.validaTipoTitulo = validaTipoTitulo;
            self.changeConta = changeConta;
            self.onChangeEmpresa = onChangeEmpresa;

            function onCreatedCabecalho(cabecalho) {
                _cabecalhoBaixa = cabecalho;
            }

            function showStep() {
                self.wizard = $wizard.context;
                $wizard.context.hideBtnCancel = true;
                $wizard.context.pixSolicitado = false;
                self.showBotaoVerFinanceiro = self.wizard.showBotaoVerFinanceiro;
                self.showBotaoFecharReaplicar = self.wizard.showBotaoFecharReaplicar;

                if (angular.isDefined(self.wizard.recalcular)) {
                    recalculaValores();
                } else if (angular.isUndefined(self.valoresBaixa)) {
                    populaCampos();
                }
                
                FintechUtilsService.injectErpCobrancaPix();
                exibeBaixaMoeda();
                initStep();
            }

            function initStep() {
                ServiceProxy.removeClientEvent(ALTERAR_CONTA_BANCARIA);
                if(!ServiceProxy.hasClientEvent(ALTERAR_CONTA_BANCARIA)){
                    ServiceProxy.addClientEvent(ALTERAR_CONTA_BANCARIA, function (eventContent, serviceRecaller) {
                        var options = {
                            okBtnLabel: "Nova cobrança",
                            noBtnLabel: "Cancelar",
                            cancelLabel: "Recuperar"
                        }
                        var infoConta = eventContent.alterarConta.codContaOld + " - " + eventContent.alterarConta.descrConta;
                        MessageUtils.confirm(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.msgAlterarContaBancaria', [infoConta]), options.okBtnLabel, options.noBtnLabel, true, undefined, options)
                            .then(function(){
                                var param = { 
                                    codConta: eventContent.alterarConta.codContaNova,
                                    valor: self.valorTotal,
                                    nufin: _nufin,
                                    seqpix: eventContent.alterarConta.seqpix
                                };
                                
                                ServiceProxy.callService("mge@BaixaFinanceiroSP.gerarCobrancaComOutraConta", { param })
                                    .then(function (result) {
                
                                        var cobranca =  ObjectUtils.getProperty(result, "responseBody.cobranca");
                                        carregarPopupPix(cobranca);
                                    });
    
                            }, function (reason) {
                                if (reason == 'cancel') {
                                    var param = { 
                                        valor: eventContent.alterarConta.valor,
                                        nufin: eventContent.alterarConta.nufin
                                    };
                                    
                                    ServiceProxy.callService("mge@BaixaFinanceiroSP.recuperarCobrancaComOutraConta", { param })
                                    .then(function (result) {
                                        if(result){
                                            self.conta = parseInt(eventContent.alterarConta.codContaOld);
                                            var cobranca =  ObjectUtils.getProperty(result, "responseBody.cobranca");
                                            carregarPopupPix(cobranca);
                                        }
                                    });
                                }
                            });
                    });  
                }

                ServiceProxy.removeClientEvent(CONCLUIR_COM_OUTRA_CONTA);
                if(!ServiceProxy.hasClientEvent(CONCLUIR_COM_OUTRA_CONTA)){
                    ServiceProxy.addClientEvent(CONCLUIR_COM_OUTRA_CONTA, function (eventContent, serviceRecaller) {
                        var infoConta = eventContent.alterarConta.codContaOld + " - " + eventContent.alterarConta.descrConta;
                        MessageUtils.showInfo(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.msgConcluirComOutraConta',  [infoConta]))
                            .then(function(){
                                self.conta = eventContent.alterarConta.codContaOld;
                                registrarCobranca();
                            }
                        );
                    });
                }

                if(_recDesp > 0) {
                    verificaTemContaPix();
                }

                usaRecebimentoComCartao = self.wizard.usaRecebimentoComCartao;
                if (usaRecebimentoComCartao && _recDesp == 1) {
                    self.usaRecebimentoComCartao = true;
                }

                if (SkApplicationInstance.isJivaW()) {
                    self.isJivaW = true;
                }

                ServiceProxy.addClientEvent("br.com.sankhya.mgecom.pesquisamov.mensagem",
                    function(clientEvent, recaller) {
                        var msg = ObjectUtils.getProperty(clientEvent, 'mensagem');
                        if (angular.isDefined(msg)) {
                            MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, msg);
                        }
                    });

                _utilizaSankhyaCivil = MGEParameters.asBoolean('fin.utiliza.sankhyacivil');
                _paramCalculaImpostosMensaisReceita = MGEParameters.asBoolean('fin.calc.impostos.mensais.para.receita.financeiro');

                self.mostraDataConciliacao = self.wizard.dataWizard.concilia;

                if (angular.isDefined(self.wizard.dataWizard.dadosBancarios.sizeHistorico)) {
                    self.maxCharsTxtHistorico = self.wizard.dataWizard.dadosBancarios.sizeHistorico;
                }

                if (angular.isDefined(self.wizard.dataWizard.descricaoDespCart)) {
                    self.formDespCart = self.wizard.dataWizard.descricaoDespCart + ":";
                }

                self.checkReterImpostosRetroativos = true;
                
                verificaTemContaPix();
            }

            function setVariosTitulosInsertionMode(){
                self.dsVariosTitulos.goToInsertionMode().then(function () {
                    afterPopulateCodTipTitulo();
                });
            }

            function onDatasetCreated(dataset) {
                if (dataset.getEntityName() == 'Financeiro') {
                    self.dsVariosTitulos = dataset;

                    var observerVariosTitulos = new IDataSetObserver();
                    observerVariosTitulos.insertionModeActivated = function() {
                        //verificando se o tipo de titulo mudou
                        if(self.dsVariosTitulos.getModifyingFields()){
                            if(self.dsVariosTitulos.getModifyingFields()[0] == "CODTIPTIT"){
                                _tipoTituloChanged = true;
                            }else{
                                _tipoTituloChanged = false; 
                            }
                        }

                        var nossoNum = self.wizard.dataWizard.dadosBancarios.numDocumento;

                        self.dsVariosTitulos.setFieldValue("CODTIPTIT", NumberUtils.stringToNumber(self.wizard.dataWizard.dadosBancarios.codTipTit));
                        self.dsVariosTitulos.setFieldValue("TipoTitulo.DESCRTIPTIT", self.wizard.dataWizard.dadosBancarios.descrTipTit);
                        self.dsVariosTitulos.setFieldValue("CODBCO", NumberUtils.stringToNumber(self.wizard.dataWizard.dadosBancarios.codBco));
                        self.dsVariosTitulos.setFieldValue("Banco.NOMEBCO", self.wizard.dataWizard.dadosBancarios.descrBco);
                        self.dsVariosTitulos.setFieldValue("NOSSONUM", angular.isUndefined(nossoNum) ? "" : nossoNum.toString());
                        self.dsVariosTitulos.setFieldValue("DHBAIXA", self.dataCabecalho.dtBaixa);
                        self.dsVariosTitulos.setFieldValue("HISTORICO", self.wizard.dataWizard.dadosBancarios.historico);
                        self.dsVariosTitulos.setFieldValue("SUBTIPOVENDA", self.wizard.dataWizard.dadosBancarios.subTipTit);

                        configurarBtnCartao();

                        setBtnsStatus();
                    };

                    observerVariosTitulos.dataSaved = function(isNew, records) {
                        calculaTotalVariosTitulos();
                    };

                    observerVariosTitulos.editionCanceled = function() {
                        setBtnsStatus();
                        calculaTotalVariosTitulos();
                    };

                    observerVariosTitulos.recordRemoved = function() {
                        if (self.dsVariosTitulos.isEmpty()) {
                            _taxaAdmBaixa = _taxaAdmAnterior;
                            self.taxaAdm = _taxaAdmAnterior;
                            _taxaAdmAnterior = undefined;
                            calculaOutrosImpostos();
                        } else {
                            calculaTotalVariosTitulos();
                        }
                    };

                    observerVariosTitulos.refreshed = function() {
                        verificaVariosTitulos(true);
                        setBtnsStatus();
                        calculaTotalVariosTitulos();
                    };

                    observerVariosTitulos.dataModified = function(fieldName) {
                        validarAlteracaoCartao(fieldName);
                        setBtnsStatus();
                    };

                    observerVariosTitulos.currentLineChanged = function(newIndex, reason, properties, dataset) {
                        configurarBtnCartao();
                        setBtnsStatus();
                        calculaTotalVariosTitulos();
                    };

                    observerVariosTitulos.editionModeActivated = function() {
                        setBtnsStatus();
                        calculaTotalVariosTitulos();
                    };

                    observerVariosTitulos.dataSaved = function(isNew, records) {
                        setBtnsStatus();
                        calculaTotalVariosTitulos();
                    };

                    observerVariosTitulos.editionCanceled = function() {
                        setBtnsStatus();
                        calculaTotalVariosTitulos();
                    };

                    self.dsVariosTitulos.addObserver(observerVariosTitulos);

                    self.dsVariosTitulos.beforePostAction(function(dataset) {
                        if (self.dsVariosTitulos.isEmpty()) {
                            _taxaAdmAnterior = _taxaAdmBaixa;
                            self.taxaAdm = 0;
                            _taxaAdmBaixa = 0;
                            calculaOutrosImpostos();
                        }

                        if (NumberUtils.round(self.vlrBaixaTitulo, 2) == 0) {
                            var sValorBaixa = i18n('Commons.Baixa.labelValorBaixa');
                            MessageUtils.showAlert(i18n('Commons.Baixa.messageCampoObrigatorio', [sValorBaixa]));
                            return false;
                        }
                        
                        var qtdPix = 0;
                        self.dsVariosTitulos.getRecordsAsObjects( {concatTransient: true}).forEach(function(record) {
                            if (record.SUBTIPOVENDA == 10) {
                                qtdPix++;
                            }
                        });
                        if (qtdPix > 1) {
                            MessageUtils.showAlert(i18n('Commons.Baixa.msgBaixaTipoTituloPix'));
                            return false;
                        }
                        return true;
                    });

                    self.dsVariosTitulos.beforeDeleteAction(function() {
                        if (usaRecebimentoComCartao && !StringUtils.isEmpty(self.dsVariosTitulos.getFieldValue("NSUCTF"))) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.RecebimentoCartao.msgNaoPossExcTitCartCred')+"." );
                            return false;
                        }
                        return true;
                    });
                    
                    TEF.createFieldsDataSet(self.dsVariosTitulos).then(function () {
                    self.dsVariosTitulos.init();                    
                    });                 
                } else if (dataset.getEntityName() == 'ImpostoFinanceiro') {
                    self.dsOutrosImpostos = dataset;
                    self.dsOutrosImpostos.addCriteriaProvider(getCriteria);
                    self.dsOutrosImpostos.setAllowPkModification(true);

                    var observerOutrosImpostos = new IDataSetObserver();
                    observerOutrosImpostos.insertionModeActivated = function() {
                        self.dsOutrosImpostos.setFieldValue("NUFIN", _nufin);
                        self.dsOutrosImpostos.setFieldValue("DIGITADO", "S");
                        self.dsOutrosImpostos.setFieldValue("TIPIMP", -1);
                    };

                    observerOutrosImpostos.dataSaved = function(isNew, records) {
                        calculaOutrosImpostos();
                    };

                    observerOutrosImpostos.refreshed = function() {
                        calculaOutrosImpostos();
                    };

                    observerOutrosImpostos.recordRemoved = function() {
                        calculaOutrosImpostos();
                    };

                    self.dsOutrosImpostos.addObserver(observerOutrosImpostos);

                    self.dsOutrosImpostos.beforePostAction(function(dataset) {
                        if (StringUtils.isEmpty(self.dsOutrosImpostos.getFieldValue("CODIMP"))) {
                            var sImposto = i18n('Commons.Impostos.labelImposto');
                            MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Baixa.messageCampoObrigatorio', [sImposto]));
                            return;
                        }

                        if (baixaAgrupada) {
                            MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Baixa.msgNaoPodeEditarOutrosImpostosBxAgrupada'));
                            return;
                        }
                        return true;
                    });

                    self.dsOutrosImpostos.beforeDeleteAction(function() {
                        if (baixaAgrupada) {
                            MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Baixa.msgNaoPodeEditarOutrosImpostosBxAgrupada'));
                            return;
                        }

                        return true;
                    });

                    self.dsOutrosImpostos.initAndRefresh();
                }
            }

            function metadataInterceptor(fields, dataset) {
                if (fields) {
                    ArrayUtils.forEach(fields, function(fm) {
                        if ('@CODIMP@VLRBAIXA@'.indexOf('@' + fm.name + '@') > -1) {
                            fm.required = true;
                            dataset.makeFieldRequired(fm.name);
                        }
                    });
                }
            }

            function getCriteria() {
                var criteriaOutrosImpostos = Criteria();

                let finBaixaAgrupada = self.wizard?.dataWizard?.baixaAgrupada?.financeiros?.financeiro;

                if (self.wizard.baixaAgrupada && angular.isDefined(finBaixaAgrupada) && finBaixaAgrupada.length > 1) {
                    let nuFinBaixaAgrupada = [];

                    finBaixaAgrupada.forEach(function (fin){
                        nuFinBaixaAgrupada.push(fin.$);
                    });

                    criteriaOutrosImpostos.append(SqlUtils.buildINClauseByValues("NUFIN", nuFinBaixaAgrupada));

                } else {
	                var nufin =  self.wizard.dataWizard ? self.wizard.dataWizard.nufin : 0;
	                criteriaOutrosImpostos.append('this.NUFIN = ?', Criteria.buildParameter('N', nufin));
                }

                criteriaOutrosImpostos.append(" AND this.CODIMP NOT IN ( SELECT IMC.CODIMP FROM TGFIMC IMC WHERE IMC.CALCBASEMENSAL = 'S')");

                return criteriaOutrosImpostos;
            }

            function enviromentCriteria() {
                var criterio = Criteria();
                criterio.append("this.CODIMP > 0 AND this.CALCBASEMENSAL = 'N'");
                return criterio;
            }

            function environmentCriteriaTipoTitulo() {
                var criterio = Criteria();
                if (_usuarioEhCaixa == "S") {
                    criterio.append("(NOT EXISTS (SELECT 1 FROM TGFRTT RTT WHERE RTT.CODTIPTITORI = " + _codTipTitOrig + " AND RTT.CODTIPTITDES = this.CODTIPTIT))");
                }
                return criterio;
            }

            function environmentCriteriaContaBancaria() {
                var criterio = Criteria();
                var codEmp = self.empresa ?  self.empresa : "NULL";

                criterio.append("(this.EXCLUSIVA = 'N' OR this.CODEMP = " + codEmp + ")");
               
                return criterio;
            }

            function getTipoOperacaoCriteria() {
                var tipMov;

                if (_recDesp > 0) {
                    tipMov = "R";
                } else if (_recDesp < 0) {
                    tipMov = "G";
                }

                var criteria = Criteria();
                criteria.append(' this.TIPMOV = ? ');
                criteria.addParameter(Criteria.buildParameter('S', tipMov));

                if (!StringUtils.isEmpty(_codTipOperFinanceiro) && _codTipOperFinanceiro > 0) {
                    criteria.append(
                        "	AND ( " +
                        "	  NOT EXISTS (SELECT 1 FROM TGFREP REP WHERE REP.CODTIPOPER = ? AND REP.TIPREST = 'I') " +
                        "	  OR  " +
                        "	  (  " +
                        "	    ( " +
                        "	   	 EXISTS (SELECT 1 FROM TGFREP REP WHERE REP.CODTIPOPER = ? AND REP.TIPREST = 'I' AND REP.RESTRICAO = 'S') " +
                        "		 AND (this.CODTIPOPER IN (SELECT REP.CODCOLREST FROM TGFREP REP WHERE REP.CODTIPOPER = ? AND REP.TIPREST = 'I' AND REP.RESTRICAO = 'S')) " +
                        "	    )  " +
                        "	    OR  " +
                        "	    ( " +
                        "		 EXISTS (SELECT 1 FROM TGFREP REP WHERE REP.CODTIPOPER = ? AND REP.TIPREST = 'I' AND REP.RESTRICAO = 'N') " +
                        "	     AND (this.CODTIPOPER NOT IN (SELECT REP.CODCOLREST FROM TGFREP REP WHERE REP.CODTIPOPER = ? AND REP.TIPREST = 'I' AND REP.RESTRICAO = 'N')) " +
                        "	    )  " +
                        "	  )  " +
                        "	)  ");

                    criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));

                    if (!StringUtils.isEmpty(_restricaoTipOper)) {
                        if (_restricaoTipOper == "S") {
                            criteria.append("AND (CODTIPOPER IN (SELECT REP.CODCOLREST FROM TGFREP REP WHERE REP.TIPREST = 'D' AND REP.CODTIPOPER = ?) ");
                        } else {
                            criteria.append("AND (CODTIPOPER NOT IN (SELECT REP.CODCOLREST FROM TGFREP REP WHERE REP.TIPREST = 'D' AND REP.CODTIPOPER = ?) ");
                        }
                        criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));

                       if (tipMov == "R") {
                            criteria.append("OR CODTIPOPER IN(SELECT nullValue(TOPBAIXARECEITA, -1) FROM TSIUSU WHERE codusu = ?)) ");
                            criteria.addParameter(Criteria.buildParameter('N', SkApplicationInstance.getUserID()));
                        } else if (tipMov == "G") {
                            criteria.append("OR CODTIPOPER IN(SELECT nullValue(TOPBAIXADESPESA, -1) FROM TSIUSU WHERE codusu = ?)) ");
                            criteria.addParameter(Criteria.buildParameter('N', SkApplicationInstance.getUserID()));
                        } else {
                            criteria.append(")");
                        }
                        
                    }

                    criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));
                    criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));
                    criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));
                    criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));
                    criteria.addParameter(Criteria.buildParameter('N', _codTipOperFinanceiro));
                
	                if (!StringUtils.isEmpty(_restricaoTipOper)) {
	                    if (tipMov == "R" || tipMov == "G") {
	                        criteria.addParameter(Criteria.buildParameter('N', SkApplicationInstance.getUserID()));
	                    }
	                }
	            }

                return criteria;
            }
            
            function calcularVlrDesdob(financeiros) {
				var vlrDesdobCalc;
				var vlrDesdobCalcTotal = 0;
				ArrayUtils.forEach(financeiros, function(financeiro) {
                    vlrDesdobCalc = financeiro.VLRDESDOB / financeiro.VLRMOEDA;
					vlrDesdobCalcTotal += NumberUtils.round(vlrDesdobCalc, 2);
                });
				return NumberUtils.round(vlrDesdobCalcTotal, 2);
			}

            function populaCampos(wizard) {
                if (wizard) {
                    self.wizard = wizard;
                }

                //Cabeçalho
                self.juroObrig = self.wizard.params["juroObrig"];
                self.multaEdit = self.wizard.params["multaEdit"];
                var cabecalho = self.wizard.dataWizard.cabecalho;

                _nufin = cabecalho.nufin;
                _codTipOperFinanceiro = cabecalho.codTipOperFinanceiro;
                desdob = cabecalho.desdob;
                dtVencimento = cabecalho.dtVencimento;
                dtBaixa = cabecalho.dtBaixa;
                diasAtraso = cabecalho.diasAtraso;
                vlrTotal = cabecalho.vlrTotal;
                vlrCalculado = angular.isDefined(cabecalho.vlrCalculado) ? cabecalho.vlrCalculado : vlrTotal;
                _regimeCaixa = self.wizard.dataWizard.regimeCaixa;
                self.retencaoRetroativa = self.wizard.dataWizard.retencaoRetroativa;

                _vlrDesdobNegociacao = self.wizard.dataWizard.vlrDesdobNegociacao;

                self.dataCabecalho = {
                    nufin: _nufin,
                    desdob: desdob,
                    dtVencimento: dtVencimento,
                    dtBaixa: dtBaixa,
                    diasAtraso: diasAtraso
                };

                var valoresBaixa = self.valoresBaixa = self.wizard.dataWizard.valoresBaixa;

                _vlrDesdob = valoresBaixa.vlrDesdob;
                _taxaAdmBaixa = valoresBaixa.taxaAdm;
                _descontoBaixa = valoresBaixa.vlrDesconto;


                _multaBaixa = valoresBaixa.vlrMulta;
                _juroBaixa = valoresBaixa.vlrJuros;

                _despCartorioBaixa = valoresBaixa.vlrDespesasCartorio;
                _multaLibBaixa = valoresBaixa.vlrMultaLib;
                _juroLibBaixa = valoresBaixa.vlrJurosLib;
                _valorTotal = valoresBaixa.vlrTotal;
                _recDesp = valoresBaixa.recDesp;
                _multaEmb = valoresBaixa.multaEmb;
                _juroEmb = valoresBaixa.juroEmb;
                _vlrMoeda = valoresBaixa.vlrMoeda;
                _vlrVarCambial = valoresBaixa.vlrVarCambial;
                _tipoMoeda = valoresBaixa.tipoMoeda;
                _codMoeda = valoresBaixa.codMoeda;

                self.valorTotal = _valorTotal;
                self.valor = _vlrDesdob;
                self.vlrVarCambial = _vlrVarCambial;
                self.taxaAdm = _taxaAdmBaixa;
                self.vlrDesconto = _descontoBaixa;
                self.vlrMulta = _multaBaixa;
                self.vlrJuro = _juroBaixa;
                self.despCartorio = _despCartorioBaixa;
                self.multaNeg = valoresBaixa.vlrMultaNeg;
                self.juroNeg = valoresBaixa.vlrJurosNeg;
                self.multaLib = _multaLibBaixa;
                self.juroLib = _juroLibBaixa;
                self.utilizaSankhyaCivil = _utilizaSankhyaCivil;

                //monta dados da baixa com Moeda
                self.vlrMoedaNeg = _vlrMoeda;
                if(_baixaAgruMoeda && self.wizard.paramsFin.financeirosEmBaixaAgrupada != undefined){
                	self.vlrDesdobMoedaNeg = calcularVlrDesdob(self.wizard.paramsFin.financeirosEmBaixaAgrupada);
				} else {
					self.vlrDesdobMoedaNeg = _vlrDesdobNegociacao / _vlrMoeda;
				}
                
                self.vlrDesdobNeg = _vlrDesdobNegociacao;
                self.vlrDesdobAtu = _valorTotal;
                self.vlrVaricaoDesdob = (self.vlrDesdobAtu - _vlrDesdobNegociacao);
                self.vlrDesdobTotal = _valorTotal;

                self.multaLibEnabled = _recDesp == 1;
                self.juroLibEnabled = _recDesp == 1;

                self.tipoMulta = valoresBaixa.tipoMulta;
                self.tipoJuro = self.wizard.dataWizard.valoresBaixa.tipoJuros;

                _usuarioAlteraValorMoeda = self.wizard.dataWizard.alteraMoedaBaixa;

                self.vlrDesdobTotalEnabled = _usuarioAlteraValorMoeda;
                self.vlrDesdobMoedaTotalEnabled = _usuarioAlteraValorMoeda;
                self.vlrMoedaAtuEnabled = _usuarioAlteraValorMoeda;

                //Impostos
                var impostos = self.wizard.dataWizard.impostos;

                _alteraImpostos = self.wizard.dataWizard.alteraImpostos;
                _INSSBaixa = impostos.vlrInss;
                _IRRFBaixa = impostos.vlrIrrf;
                _ISSBaixa = impostos.vlrIss;
                _baseDevidaOutrosImpMensais = impostos.baseDevidaOutrosImpostos;

                _vlrInssOrig = NumberUtils.getNumberOrZero(impostos.vlrInss);
                self.vlrINSS = _INSSBaixa;
                self.checkINSS = angular.isDefined(impostos.inssRetido)? impostos.inssRetido: true;

                _vlrIrrfOrig = NumberUtils.getNumberOrZero(impostos.vlrIrrf);
                self.vlrIRRF = _IRRFBaixa;
                self.checkIRRF = angular.isDefined(impostos.irrfRetido)? impostos.irrfRetido: true;

                self.vlrISS = _ISSBaixa;
                _vlrISSOrig = NumberUtils.getNumberOrZero(self.vlrISS);
                self.checkISS = angular.isDefined(impostos.issRetido)? impostos.issRetido: true;

                _vlrMultaOrig = NumberUtils.getNumberOrZero(self.vlrMulta);
                _despCartorioOrig=NumberUtils.getNumberOrZero(self.despCartorio);
                _vlrDescontoOrig=NumberUtils.getNumberOrZero(self.vlrDesconto);
                _multaLibOrig=NumberUtils.getNumberOrZero(self.multaLib);
                _vlrJuroOrig=NumberUtils.getNumberOrZero(self.vlrJuro);
               
                self.vlrVendor = impostos.vlrVendor;
                _vlrVendorOrig= NumberUtils.getNumberOrZero(self.vlrVendor);

                _vlrOutrosImpMensaisOrig  = NumberUtils.getNumberOrZero(impostos.outrosImpostosMensais);
                self.vlrOutrosImpMensais = _vlrOutrosImpMensaisOrig;

                self.btnDetalhesOutImpMenEnabled = self.vlrOutrosImpMensais != 0;

                self.vlrOutrosImp = impostos.outrosImpostos;

                //Dados adicionais da baixa
                var dadosAdicionais = self.wizard.dataWizard.dadosAdicionais;

                _codBarras = dadosAdicionais.codBarras;
                _codParc = dadosAdicionais.codParc;
                _restricaoTipOper = dadosAdicionais.restricaoTipOper;

                self.empresa = dadosAdicionais.codEmpresa;

                if(self.wizard.params){
                    params = self.wizard.params;
                }

                if (params.hasOwnProperty("codEmpReadOnly") && params.codEmpReadOnly == true) {
                    self.empresaEnabled = false;
                } else {
                    self.empresaEnabled = true;
                }

                self.top = dadosAdicionais.codTipoOperacao;

                if (params.hasOwnProperty("codTopReadOnly") && params.codTopReadOnly == true) {
                    self.topEnabled = false;
                } else {
                    self.topEnabled = true;
                }

                //Movimentação bancária
                var dadosBancarios = self.wizard.dataWizard.dadosBancarios;

                _codBco = dadosBancarios.codBco;
                _vlrMoedaBaixa = NumberUtils.stringToNumber(dadosBancarios.vlrMoedaBaixa);

                if (angular.isDefined(params.codContaBca)) {
                    self.conta = params.codContaBca;
                    self.contaEnabled = false;
                } else {
                    self.conta = dadosBancarios.codConta;
                    self.contaEnabled = true;
                }

                if (params.hasOwnProperty("contaParaCaixaAberto") && angular.isDefined(params.contaParaCaixaAberto)) {
                    _contaParaCaixaAberto = params.contaParaCaixaAberto;
                } else {
                    _contaParaCaixaAberto = 0;
                }
                self.valorMoeda = dadosBancarios.vlrMoedaBaixa;

                //monta dados da baixa com Moeda
                self.vlrMoedaAtu = dadosBancarios.vlrMoedaBaixa;
                self.vlrVarCamb = _vlrMoedaBaixa - _vlrMoeda;
                self.vlrDesdobMoedaAtu = self.vlrDesdobAtu / _vlrMoedaBaixa;
                self.vlrDesdobMoedaTotal = self.vlrDesdobMoedaAtu;

                if (dadosBancarios.vlrMoedaBaixa == "0.00") {
                    self.hbValorMoedaVisible = false;
                } else {
                    self.hbValorMoedaVisible = true;
                }

                self.documento = dadosBancarios.numDocumento;
                self.lancamento = dadosBancarios.codLancamento;
                self.historico = dadosBancarios.historico;

                makeValorCalculado();

                if (params["ehDevolucaoCheque"] && !params["devCheque"]) {
                    self.vsVariosTituloIndex = 1; 
                } else if (dtBaixa > dtVencimento && _codMoeda != 0 && _tipoMoeda == "I")  {
                    self.vsVariosTituloIndex = 2;
                } else {
                    self.vsVariosTituloIndex = 0;
                }

                if (params.hasOwnProperty("codTipTit") && angular.isDefined(params.codTipTit)) {
                    _codTipTitOrig = params["codTipTit"];
                }
                if (params.hasOwnProperty("usuarioEhCaixa") && angular.isDefined(params.usuarioEhCaixa)) {
                    _usuarioEhCaixa = params["usuarioEhCaixa"];
                }

            }

            function exibeBaixaMoeda() {
                if (NumberUtils.stringToNumber(self.wizard.dataWizard.valoresBaixa.codMoeda) == 0 || !_mostraValorMoeda) {
                    self.exibePainelBaixaMoeda = false;
                } else {
                    self.exibePainelBaixaMoeda = true;
                    buscarMoeda();
                }
            }

            function recalculaValores() {

				if (angular.isDefined(self.baixaPanel)) {
	                self.baixaPanel.recalculaValores({ 
	                	reterImpostosRetroativos: self.checkReterImpostosRetroativos,
	                	dtBaixa: _cabecalhoBaixa.dtBaixa
	                }).then(function(wizardResponse) {
                        populaCampos(wizardResponse);
                    });		
				}
            }

            function configurarBtnCartao() {
                if (usaRecebimentoComCartao) {
                    self.btnRecCancCartaoEnabled = false;

                    if (self.dsVariosTitulos.isInsertionMode() || self.dsVariosTitulos.isEmpty()) {
                        _btnReceberAtivo = true;
                        self.btnRecCancCartaoEnabled = true;
                        self.receberImg = "/mge/assets/img/btnReceberCartao.png";
                        self.labelBtnReceber = i18n('Commons.RecebimentoCartao.lblCartao');
                        self.tooltipBtnReceber = i18n('Commons.RecebimentoCartao.lblReceberComCartao');
                    } else if (angular.isDefined(self.dsVariosTitulos.getFieldValue("NSUCTF"))) {
                        _btnReceberAtivo = false;
                        self.btnRecCancCartaoEnabled = true;
                        self.labelBtnReceber = i18n('Commons.RecebimentoCartao.lblCancelarCartao');
                        self.tooltipBtnReceber = i18n('Commons.RecebimentoCartao.lblCancelarOperacaoCartao');
                    }
                }

            }

            function setBtnsStatus() {
                if (self.dsVariosTitulos.isRecordDirty()) {
                    $step.setCanNext(false);
                    $step.setCanFinish(false);
                } else {
                    $step.setCanNext(true);
                    $step.setCanFinish(true);
                }
            }

            function calculaTotalVariosTitulos() {
                if (self.dsVariosTitulos) {

                    var records = self.dsVariosTitulos.getRecordsAsObjects();
                    var vlrTotal = 0;
                    var vlrDif = 0;

                    _valorTotalOutrosTitulos = 0;

                    if (ArrayUtils.isNotEmpty(records)) {
                        ArrayUtils.forEach(records, function(record) {
                            var vlrDesdob = NumberUtils.stringToNumber(record.VLRBAIXA);
                            vlrTotal += vlrDesdob;
                        });

                        _valorTotalOutrosTitulos = NumberUtils.round(vlrTotal, 2);
                        makeValorCalculado();
                        vlrDif = NumberUtils.round(_valorTotalOutrosTitulos - _valorCalculado, 2);
                    }

                    eventoValorAlterou();

	                self.txtTituloOriginal = NumberUtils.format(_valorCalculado, 2);
                    self.txtTotal = NumberUtils.format(vlrTotal, 2);
                    self.txtDiferenca = NumberUtils.format(vlrDif, 2);
                }
            }

            function calculaValorAliquota() {
                var baseImp = isNaN(self.dsOutrosImpostos.getFieldValue("BASE")) ? 0 : self.dsOutrosImpostos.getFieldValue("BASE");
                var aliqImp = isNaN(self.dsOutrosImpostos.getFieldValue("ALIQUOTA")) ? 0 : self.dsOutrosImpostos.getFieldValue("ALIQUOTA");

                self.dsOutrosImpostos.setFieldValue("VALOR", NumberUtils.round(baseImp * aliqImp / 100, 2));
            }

            function verificaVariosTitulos() {
                calculaTotalVariosTitulos();
            }

            function validarAlteracaoCartao(modifiedField) {
                if (self.usaRecebimentoComCartao && angular.isDefined(self.dsVariosTitulos.getFieldValue("NSUCTF"))) {
                    if ("VLRBAIXA-CODTIPTIT".indexOf(modifiedField) > -1) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.RecebimentoCartao.msgNaoPermAltCamposCartao') + ".");
                        self.dsVariosTitulos.cancelEdition();
                    }
                }
            }

            function makeValorCalculado() {
                _valorCalculado = _vlrDesdob;
                _valorCalculado += NumberUtils.stringToNumber(self.multaNeg);
                _valorCalculado += NumberUtils.stringToNumber(self.juroNeg);
                _valorCalculado += NumberUtils.stringToNumber(self.despCartorio);
                _valorCalculado += NumberUtils.stringToNumber(self.vlrVendor);
                _valorCalculado += ((self.tipoMulta == "I" ? 1 : 0) * NumberUtils.stringToNumber(self.vlrMulta));
                _valorCalculado += ((self.tipoJuro == "I" ? 1 : 0) * NumberUtils.stringToNumber(self.vlrJuro));
                _valorCalculado += angular.isDefined(self.vlrOutrosImp)? NumberUtils.stringToNumber(self.vlrOutrosImp) : 0;
                _valorCalculado += angular.isDefined(self.vlrOutrosImpMensais) ? NumberUtils.stringToNumber(self.vlrOutrosImpMensais) : 0;
                _valorCalculado -= NumberUtils.stringToNumber(self.vlrDesconto);
                _valorCalculado -= NumberUtils.stringToNumber(self.taxaAdm);
                _valorCalculado -= ((self.checkIRRF ? 1 : 0) * NumberUtils.stringToNumber(self.vlrIRRF));
                _valorCalculado -= ((self.checkINSS ? 1 : 0) * NumberUtils.stringToNumber(self.vlrINSS));
                _valorCalculado -= ((self.checkISS ? 1 : 0) * NumberUtils.stringToNumber(self.vlrISS));
                _valorCalculado -= (NumberUtils.stringToNumber(self.multaLib));
                _valorCalculado -= (NumberUtils.stringToNumber(self.juroLib));
                _valorCalculado = NumberUtils.round(_valorCalculado, 2);
            }

            function exitStep() {
                if(validaCamposObrigatorios()){
                    makeValorCalculado();
    
                    //Cabeçalho
                    var cabecalho = {
                        dtVencimento: dtVencimento,
                        dtBaixa: _cabecalhoBaixa.getDataBaixa(),
                        diasAtraso: diasAtraso,
                        nufin: _nufin,
                        desdob: desdob,
                        vlrTotal: self.valorTotal,
                        vlrCalculado: _valorCalculado,
                        vlrDesdob: _vlrDesdob,
                        origem: self.wizard.dataWizard.origem
                    };
    
                    //Dados baixa
                    var dadosBaixa = {
                        dataBaixa: cabecalho.dtBaixa,
                        dataVencimento: cabecalho.dtVencimento,
                        diasAtraso: cabecalho.diasAtraso,
                        nufin: cabecalho.nufin,
                        decisao: 0, //O "0" significa ConsiderarErro.
                        reterImpostosRetroativos: self.checkReterImpostosRetroativos,
                        alteraMoedaBaixa: _usuarioAlteraValorMoeda,
                        vlrDesdobNegociacao: _vlrDesdobNegociacao
                    };
    
                    if (self.wizard.dataWizard.hasOwnProperty('baixaAgrupada')) {
                        dadosBaixa.baixaAgrupada = self.wizard.dataWizard.baixaAgrupada;
                    }
        
                    //Valores
                    var valoresBaixa = {
                        vlrTotal: self.valorTotal,
                        vlrCalculado: _valorCalculado,
                        vlrDesdob: NumberUtils.round(_vlrDesdob, 2),
                        taxaAdm: NumberUtils.round(self.taxaAdm, 2),
                        vlrDesconto: NumberUtils.round(self.vlrDesconto, 2),
                        vlrMulta: NumberUtils.round(self.vlrMulta, 2),
                        tipoMulta: self.tipoMulta,
                        vlrJuros: NumberUtils.round(self.vlrJuro, 2),
                        tipoJuros: self.tipoJuro,
                        vlrDespesasCartorio: NumberUtils.round(self.despCartorio, 2),
                        vlrMultaNeg: NumberUtils.round(self.multaNeg, 2),
                        vlrMultaLib: NumberUtils.round(self.multaLib, 2),
                        vlrJurosNeg: NumberUtils.round(self.juroNeg, 2),
                        vlrJurosLib: NumberUtils.round(self.juroLib, 2),
                        vlrMoeda: _vlrMoeda,
                        recDesp: _recDesp,
                        codMoeda: _codMoeda,
                        mostraValorMoeda: _mostraValorMoeda
                    };
    
                    if (_valorTotalOutrosTitulos != 0) {
                        ObjectUtils.setProperty(valoresBaixa, 'vlrTotal', _valorTotalOutrosTitulos);
                        self.valorTotal = _valorTotalOutrosTitulos;
                    }
    
                    if (_utilizaSankhyaCivil) {
                        ObjectUtils.setProperty(valoresBaixa, 'vlrVarCambial', _vlrVarCambial);
                    } else if (_codMoeda != 0 && self.vlrMoedaNeg != 0 && self.vlrMoedaAtu != 0) {
                    	var vlrDesdobMoedaNeg = self.vlrDesdobNeg / self.vlrMoedaNeg;
                    	var vlrDesdobMoedaAtual = NumberUtils.round(vlrDesdobMoedaNeg * NumberUtils.stringToNumber(self.vlrMoedaAtu), 2);
                    	
                    	ObjectUtils.setProperty(valoresBaixa, 'vlrVarCambial', NumberUtils.round(vlrDesdobMoedaAtual - self.vlrDesdobNeg, 2));
                    } else {
                        ObjectUtils.setProperty(valoresBaixa, 'vlrVarCambial', 0);
                    }
    
                    //Impostos
                    var impostos = {
                        vlrIrrf: self.vlrIRRF,
                        irrfRetido: self.checkIRRF,
                        vlrInss: self.vlrINSS,
                        inssRetido: self.checkINSS,
                        vlrIss: self.vlrISS,
                        issRetido: self.checkISS,
                        vlrVendor: self.vlrVendor,
                        vlrOutrosImpostos: self.vlrOutrosImp,
                        vlrOutrosImpMensais: self.vlrOutrosImpMensais,
                        outrosImpostosMensais: self.vlrOutrosImpMensais,
                        outrosImpostos: self.vlrOutrosImp,
                        baseDevidaOutrosImpostos: _baseDevidaOutrosImpMensais
                    };
    
                    //Movimentação bancária
                    var dadosBancarios = {
                        codConta: self.conta,
                        descrConta: self.conta,
                        numDocumento: self.documento,
                        codLancamento: self.lancamento,
                        descrLancamento: self.lancamento,
                        historico: angular.isDefined(self.historico) ? self.historico : self.wizard.dataWizard.dadosBancarios.historico,
                        dataConciliacao : DateUtils.formatDate(self.dataConciliacao, "DD/MM/YYYY"),
                        codTipTit: angular.isDefined(self.codTipTit) ? self.codTipTit : self.wizard.dataWizard.dadosBancarios.codTipTit,
                        codBco: _codBco,
                        vlrMoedaBaixa: self.valorMoeda,
                        contaParaCaixaAberto: _contaParaCaixaAberto
                    };
    
                    //Dados adicionais da baixa
                    var dadosAdicionais = {
                        codEmpresa: self.empresa,
                        nomeFantasia: self.empresa,
                        codTipoOperacao: self.top,
                        descrOperacao: self.top,
                        codBarras: _codBarras
                    };
    
                    //Monta objeto dataWizard
                    ObjectUtils.setProperty(dadosBaixa, 'alteraImpostos', _alteraImpostos);
    
                    var descricaoDespCart = self.wizard.dataWizard.descricaoDespCart;
                    var resourceID = getResourceID();
    
                    ObjectUtils.setProperty($wizard.context, 'showStepMaior', showStepVlrMaior());
                    ObjectUtils.setProperty($wizard.context, 'showStepMenor', showStepVlrMenor());
    
                    var dataWizard = dadosBaixa;
                    ObjectUtils.setProperty(dataWizard, 'cabecalho', cabecalho);
                    ObjectUtils.setProperty(dataWizard, 'impostos', impostos);
                    ObjectUtils.setProperty(dataWizard, 'valoresBaixa', valoresBaixa);
                    ObjectUtils.setProperty(dataWizard, 'dadosBancarios', dadosBancarios);
                    ObjectUtils.setProperty(dataWizard, 'dadosAdicionais', dadosAdicionais);
                    ObjectUtils.setProperty(dataWizard, 'descricaoDespCart', descricaoDespCart);
                    ObjectUtils.setProperty(dataWizard, 'resourceID', resourceID);
                    ObjectUtils.setProperty(dataWizard, 'showBotaoVerFinanceiro', self.showBotaoVerFinanceiro);
                    ObjectUtils.setProperty(dataWizard, 'showBotaoFecharReaplicar', self.showBotaoFecharReaplicar);
    
                    $wizard.context.dsVariosTitulos = self.dsVariosTitulos;
                    $wizard.context.dataWizard = dataWizard;
                }
            }

            function addEventListener(event, field) {
                switch (field) {
                    case "vlrJuro":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrJuro);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrJuro)) {
                            calculaJuro();
                        }
                        break;
                    case "tipoJuro":
                        if (event == CHANGE) {
                            calculaJuro();
                        }
                        break;
                    case "vlrMulta":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrMulta);
                        } else if (event == FOCUS_OUT) {
                            if (alteredValue(self.vlrMulta)) {
                                calculaMulta();
                            }
                        }
                        break;
                    case "tipoMulta":
                        if (event == CHANGE) {
                            calculaMulta();
                        }
                        break;
                    case "vlrDesconto":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrDesconto);
                    }else if(event == CHANGE){
                            if (alteredValue(self.vlrDesconto)) {
                                calculaDesconto();
                                eventoValorAlterou();
                            }
                        }
                        break;
                    case "valorTotal":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.valorTotal);
                        } else if (event == FOCUS_OUT && alteredValue(self.valorTotal)) {
                            calculaValorTotal();
                            eventoValorAlterou();
                        }
                        break;
                    case "despCartorio":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.despCartorio);
                    }else if(event == CHANGE && alteredValue(self.despCartorio)){
                            calculaDespCartorio();
                            eventoValorAlterou();
                        }
                        break;
                    case "taxaAdm":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.taxaAdm);
                    }else if(event == CHANGE && alteredValue(self.taxaAdm)){
                            calculataxaAdm();
                            eventoValorAlterou();
                        }
                        break;
                    case "vlrVendor":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrVendor);
                    }else if(event == CHANGE && alteredValue(self.vlrVendor)){
                            calculaVendor();
                            eventoValorAlterou();
                        }
                        break;
                    case "juroLib":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.juroLib);
                    }else if(event == CHANGE && alteredValue(self.juroLib)){
                            calculaJuroLib();
                            eventoValorAlterou();
                        }
                        break;
                    case "multaLib":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.multaLib);
                    }else if(event == CHANGE && alteredValue(self.multaLib)){
                            calculaMultaLib();
                            eventoValorAlterou();
                        }
                        break;
                    case "vlrINSS":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrINSS);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrINSS)) {
                            if (_regimeCaixa && vlrINSS.getValue() == 0 && _vlrInssOrig != 0) {
                                resetInssIrrf("INSS");
                            } else {
                                calculaINSS();
                            }

                            eventoValorAlterou();
                        }
                        break;
                    case "checkINSS":
                        if (event == CHANGE) {
                            calculaINSS();
                        }
                        break;
                    case "vlrIRRF":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrIRRF);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrIRRF)) {
                            if (_regimeCaixa && self.vlrIRRF == 0 && _vlrIrrfOrig != 0) {
                                resetInssIrrf("IRRF");
                            } else {
                                calculaIRRF();
                            }

                            eventoValorAlterou();
                        }
                        break;
                    case "checkIRRF":
                        if (event == CHANGE) {
                            calculaIRRF();
                        }
                        break;
                    case "vlrISS":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrISS);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrISS)) {
                            calculaISS();
                            eventoValorAlterou();
                        }
                        break;
                    case "checkISS":
                	if(event == CHANGE){
                            calculaISS();
                        }
                        break;
                    case "vlrDesdobMoedaTotal":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrDesdobMoedaTotal);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrDesdobMoedaTotal)) {
                            self.vlrDesdobTotal = NumberUtils.round(self.vlrDesdobMoedaTotal * NumberUtils.stringToNumber(self.vlrMoedaAtu), 2);
                            self.valorTotal = self.vlrDesdobTotal;
                            $rootScope.$apply();
                        }
                        break;
                     case "vlrMoedaAtu":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrMoedaAtu);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrMoedaAtu)) {
                            self.vlrDesdobTotal = NumberUtils.round(self.vlrDesdobMoedaTotal * NumberUtils.stringToNumber(self.vlrMoedaAtu), 2);
                            self.valorTotal = self.vlrDesdobTotal;
                            $rootScope.$apply();
                        }
						break;
                    case "vlrDesdobTotal":
                        if (event == FOCUS_IN) {
                            saveFocusInValue(self.vlrDesdobTotal);
                        } else if (event == FOCUS_OUT && alteredValue(self.vlrDesdobTotal)) {
                            self.vlrDesdobMoedaTotal = self.vlrDesdobTotal / NumberUtils.stringToNumber(self.vlrMoedaAtu);
                            self.valorTotal = self.vlrDesdobTotal;
                            $rootScope.$apply();
                        }
                        break;
                }

            }

            function eventoValorAlterou(calculaValor) {
                if (_paramCalculaImpostosMensaisReceita || _recDesp == -1) {
                   	if(!_baixaAgruMoeda){
                    	makeValorCalculado();
	                   	recalculaOutrosImpostos();
					}
                } else {
                    onVlrAlterado(calculaValor);
                }
            }

            function onVlrAlterado(forcarAtualizacao) {
                makeValorCalculado();
                
                if ((_mostraValorMoeda && _codMoeda > 0) || forcarAtualizacao){
                    self.valorTotal = _valorCalculado;
                  	atualizaCamposMoeda();
                }

                self.variosTitulosEnabled = NumberUtils.round(_valorCalculado, 2) == NumberUtils.round(self.valorTotal, 2);
				self.valorTotalEnabled = self.dsVariosTitulos.isEmpty();	
                canNext();
            }

            function saveFocusInValue(value) {
                value = isNaN(value) ? 0 : value;
                var valorAtual = value;
                _focusInValue = valorAtual.toString();
            }

            function alteredValue(value) {
                value = isNaN(value) ? 0 : value;
                var valorAtual = value;

                var alterou = false;
                if (_focusInValue != valorAtual.toString()) {
                    alterou = true;
                }

                _focusInValue = undefined;

                return alterou;
            }

            function calculaJuro() {

                self.vlrJuro = isNaN(self.vlrJuro) ? 0 : self.vlrJuro;
                var juroAtual = self.vlrJuro;

                juroAtual = juroAtual * (self.tipoJuro == "I" ? 1 : 0);

                _valorTotal = NumberUtils.round((_valorTotal - _juroBaixa) + juroAtual, 2);

                _juroBaixa = juroAtual;
                self.valorTotal = _valorTotal;

                eventoValorAlterou(true);
            }

            function calculaMulta() {
                self.vlrMulta = isNaN(self.vlrMulta) ? 0 : self.vlrMulta;
                var multaAtual = self.vlrMulta;

                multaAtual = multaAtual * (self.tipoMulta == "I" ? 1 : 0);

                var vlrTot = NumberUtils.round((_valorTotal - _multaBaixa) + multaAtual, 2);

                _multaBaixa = multaAtual;

                self.valorTotal = vlrTot;

                eventoValorAlterou(true);
            }

            function calculaDesconto() {

                self.vlrDesconto = isNaN(self.vlrDesconto) ? 0 : self.vlrDesconto;
                var descontoAtual = self.vlrDesconto;

                self.valorTotal = (NumberUtils.stringToNumber(self.valorTotal) + NumberUtils.stringToNumber(_descontoBaixa)) - descontoAtual, 2;
                _descontoBaixa = descontoAtual;
            }

            function calculaDespCartorio() {
                self.despCartorio = isNaN(self.despCartorio) ? 0 : self.despCartorio;
                var despCartorioAtual = self.despCartorio;
                self.valorTotal = NumberUtils.round((self.valorTotal - _despCartorioBaixa) + despCartorioAtual, 2);
                _despCartorioBaixa = despCartorioAtual;
            }

            function calculaValorTotal() {
                self.valorTotal = isNaN(self.valorTotal) ? 0 : self.valorTotal;
                var valorTotalAtual = self.valorTotal;
                _valorTotal = valorTotalAtual;
                self.vlrDesdobAtu = valorTotalAtual;
                onVlrAlterado();

                if (_mostraValorMoeda && _codMoeda > 0) {
                    MessageUtils.showAlert(i18n('Commons.Baixa.lblFechamentoBaixaMoeda'), i18n('Commons.Baixa.msgAvisoBaixaParcialMoeda'));
                }
            }

            function calculataxaAdm() {
                self.taxaAdm = isNaN(self.taxaAdm) ? 0 : self.taxaAdm;
                var taxaAdmAtual = self.taxaAdm;
                self.valorTotal = NumberUtils.round((self.valorTotal + _taxaAdmBaixa) - taxaAdmAtual, 2);
                _taxaAdmBaixa = taxaAdmAtual;
            }

            function calculaVendor() {
                self.vlrVendor = isNaN(self.vlrVendor) ? 0 : self.vlrVendor;
                var vendorAtual = self.vlrVendor;
                self.valorTotal = NumberUtils.round((self.valorTotal - _vendorBaixa) + vendorAtual, 2);
                _vendorBaixa = vendorAtual;
            }

            function calculaJuroLib() {
                self.juroLib = isNaN(self.juroLib) ? 0 : self.juroLib;
                var juroLibAtual = self.juroLib;
                self.valorTotal = NumberUtils.round((self.valorTotal + _juroLibBaixa) - juroLibAtual, 2);
                _juroLibBaixa = juroLibAtual;
            }

            function calculaMultaLib() {
                self.multaLib = isNaN(self.multaLib) ? 0 : self.multaLib;
                var multaLibAtual = self.multaLib;
                self.valorTotal = NumberUtils.round((self.valorTotal + _multaLibBaixa) - multaLibAtual, 2);
                _multaLibBaixa = multaLibAtual;
            }

            function resetInssIrrf(imposto) {
                MessageUtils.confirm(i18n('Commons.Baixa.msgTitleConfirmCalcInssIrrf'), i18n('Commons.Baixa.msgAvisoConfirmCalcInssIrrf')).then(
                    function() {
                        if ("IRRF" == imposto) {
                            self.vlrIRRF = _vlrIrrfOrig;
                            calculaIRRF();
                        } else {
                            self.vlrINSS = _vlrInssOrig;
                            calculaINSS();
                        }
                    });
            }

            function calculaIRRF() {
                var irfAtual = self.vlrIRRF;
        	    irfAtual = isNaN(irfAtual) ? irfAtual : Number.parseFloat(irfAtual);
                self.vlrIRRF = irfAtual.toString();
                var totLiq = self.checkIRRF ? (self.valorTotal -= irfAtual) : (self.valorTotal += irfAtual)
                self.valorTotal = NumberUtils.round(totLiq, 2);
                _IRRFBaixa = irfAtual;
            }

            function calculaINSS() {
                var inssAtual = self.vlrINSS;
                inssAtual = isNaN(inssAtual) ? inssAtual : Number.parseFloat(inssAtual);
                self.vlrINSS = inssAtual.toString();
                var totLiq = self.checkINSS ? (self.valorTotal -= inssAtual) : (self.valorTotal += inssAtual)
                self.valorTotal = NumberUtils.round(totLiq, 2);
                _INSSBaixa = inssAtual;
            }

            function calculaISS() {
                var issAtual = isNaN(self.vlrISS) ? 0 : self.vlrISS;
                issAtual = issAtual * (self.checkISS ? 1 : 0);
                self.valorTotal = NumberUtils.round((self.valorTotal + _ISSBaixa) - issAtual, 2);
                _ISSBaixa = issAtual;
            }

        
            function detalhesOutrosImpMensais() {
                var param = {
                nuFin: _nufin,
                    reterImpostosRetroativos: self.checkReterImpostosRetroativos
                };

                if (angular.isDefined(self.dataCabecalho.dtBaixa)) {
                param['dataBaixa'] = self.dataCabecalho.dtBaixa;
                }

                ServiceProxy.callService("mge@BaixaFinanceiroSP.getDetalhesOutrosImpostosMensais", { param })
                    .then(function(result) {
                        var impostoMensal = result.responseBody.dadosBaixa.impostosMensais.impostoMensal;
                        if (angular.isDefined(impostoMensal)) {
                            SanPopup.open({
                                title: i18n('Commons.Baixa.titlePopOutrosImpostosMensais'),
                                templateUrl: i18n('commons/baixa/panel/popup/OutrosImpostosMensaisPopUp.tpl.html'),
                                controller: 'OutrosImpostosMensaisController',
                                controllerAs: 'ctrl',
                                showBtnNo: false,
                                okBtnLabel: i18n('Geral.buttonOK'),
                                noBtnLabel: i18n('Geral.buttonCancelar'),
                                height: 330,
                                resolve: {
                                    data: {
                                        impostos: impostoMensal
                                    }
                                }
                            }).result.then(function(fieldPresentation) {

                            });

                        }
                    });
            }

            function canNext() {
                if (NumberUtils.stringToNumber(self.valorTotal) < 0) {
                    ObjectUtils.setProperty($wizard.context, 'valorNegativo', true);
                    return false;
                } else {
                    ObjectUtils.setProperty($wizard.context, 'valorNegativo', false);
                    return true;
                }
            }

            function atualizaValoresBaixa(vlrNaNegoc, vlrNaBaixa) {
                _vlrDesdob = NumberUtils.round(((self.vlrDesdobNeg / vlrNaNegoc) * vlrNaBaixa), 2);
                self.valor = _vlrDesdob;
                self.vlrMulta = NumberUtils.round((_vlrMultaOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.despCartorio = NumberUtils.round((_despCartorioOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.vlrVendor = NumberUtils.round((_vlrVendorOrig/ vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.vlrDesconto = NumberUtils.round((_vlrDescontoOrig/ vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.vlrIRRF = NumberUtils.round((_vlrIrrfOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.vlrISS = NumberUtils.round((_vlrISSOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.vlrINSS = NumberUtils.round((_vlrInssOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.multaLib = NumberUtils.round((_multaLibOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.vlrJuro = NumberUtils.round((_vlrJuroOrig / vlrNaNegoc) * vlrNaBaixa, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                self.valorMoeda = isNaN(vlrNaBaixa) ? "" : vlrNaBaixa.toString();
                self.vlrVarCamb = NumberUtils.round(vlrNaBaixa - vlrNaNegoc, angular.isDefined(self.paramDecVlrMoeda) ? self.paramDecVlrMoeda : 2);
                _vlrVarCambial=NumberUtils.round(self.vlrVaricaoDesdob, 2);
            }

            function criteriaCotacaoMoeda() {
                return Criteria("(this.CODMOEDA = " + _codMoeda.toString() + ")");
            }

            function showStepVlrMaior() {
                return self.valorTotal > _valorCalculado;
            }

            function showStepVlrMenor() {
                return self.valorTotal < _valorCalculado;
            }

            function calculaOutrosImpostos() {
                if (self.wizard.baixaAgrupada) {
                    return;
                }

                var total = 0;

                if (self.dsOutrosImpostos) {
                    self.dsOutrosImpostos.getRecordsAsObjects().forEach(function(record) {
                        total += (record.VALOR * record.TIPIMP);
                    });

                }

                self.vlrOutrosImp = NumberUtils.round(total, 2).toString();
	            recalcular();
            }

            function recalcular() {
                makeValorCalculado();

                self.valorTotal = _valorCalculado;

                verificaVariosTitulos();
                canNext();
            }

            function onClickVerFinanceiro() {
                var baixaPanelCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-baixa-panel"))
                if (angular.isDefined(baixaPanelCtrl)) {
                    baixaPanelCtrl.onClickBotaoVerFinanceiro();
                }
            }

            function recalculaOutrosImpostos() {
                if (_nufin == -1) {
                    return;
                }

                var param = {
                    nuFin: _nufin,
                    dataBaixa: self.dataCabecalho.dtBaixa,
                    vlrDesdob :  _vlrDesdob != null ? _vlrDesdob : "NaN", 
                    vlrDesconto : self.vlrDesconto != null ? self.vlrDesconto : "NaN", 
                    taxaAdm : self.taxaAdm != null ? self.taxaAdm : "NaN",
                    reterImpostosRetroativos: self.checkReterImpostosRetroativos
                };

                ServiceProxy.callService("mge@BaixaFinanceiroSP.recalculaOutrosImpostos", { param })
                    .then(function(result) {
                        var valores = result.responseBody.valores;

                        if (angular.isDefined(valores)) {
                            self.vlrOutrosImpMensais = valores.outrosImpMensais;
                            if(angular.isDefined(self.vlrOutrosImp) && angular.isDefined(valores.outrosImpDiarios)){
                                let somaVlrOutrosImp = parseFloat(self.vlrOutrosImp) + parseFloat(valores.outrosImpDiarios);
                                self.vlrOutrosImp = somaVlrOutrosImp.toString();
							}
                        }
						onVlrAlterado(true);
                    });

            }

            function receberCancelarCartao() {
                if (_btnReceberAtivo) {
                    receberComCartao();
                } else {
                    cancelarTransacoesCartao();
                }
            }

            function receberComCartao() {
                var records = [];
                var vltTotOutrosTits = _valorTotalOutrosTitulos;

                self.dsVariosTitulos.getRecordsAsObjects().forEach(function(record) {
                    if (record.NSUCTF) {
                        records.push(record);
                        vltTotOutrosTits -= NumberUtils.getNumberOrZero(record.VLRBAIXA);
                    }
                });

                var recebimento = {
                    resourceId: getResourceID(),
                    wizardBaixa: true,
                    vlrTotalTitulos: _valorCalculado - vltTotOutrosTits,
                    tefsEmProcessamento: records,
                    concluirRecebimentoFunction: concluirRecebimento
                };

                if (_nufin > 0) {
                    ObjectUtils.setProperty(recebimento, 'financeiros', { NUFIN: _nufin });
                }
                var carregandoDadosBaixa = SkApplicationInstance.getRuntimeProperty(CARREGANDO_DADOS_NOVOS);
                ObjectUtils.setProperty(recebimento, 'oferecerTransConfNaoConcluidas', carregandoDadosBaixa && carregandoDadosBaixa == "S");
                ObjectUtils.setProperty(recebimento, 'desfazerTransPendentes', carregandoDadosBaixa && carregandoDadosBaixa == "S");

                RecebimentoCartaoPopup.openPopUp(recebimento);
            }

            function cancelarTransacoesCartao() {
                var tefsPendentes = [];

                var variosTitulos = self.dsVariosTitulos.getRecordsAsObjects();
                variosTitulos.forEach(function(record) {
                    if ( StringUtils.emptyAsNull(record.NSUCTF)!=null) {
                        tefsPendentes.push(record);
                    }
                });
                var params = {
                    tefsPendentes: tefsPendentes,
                    resourceId: getResourceID(),
                    concluirCancelamentoFunction: concluirCancelamentoFunction
                };

                CancelamentoTransacaoPendentePopup.openPopUp(params);
            }

            function concluirCancelamentoFunction(transacoesCanceladas) {
                if (angular.isArray(transacoesCanceladas)) {
                    var records = self.dsVariosTitulos.getRecordsAsObjects();
                    self.dsVariosTitulos.clearDataSet();

                    transacoesCanceladas.forEach(function(cancelada) {
                        records.forEach(function(current) {
                            if (cancelada.NSUCTF != current.NSUCTF) {
                                self.dsVariosTitulos.addRecordsAsObjects(current);
                            }
                        });
                    });

                    self.dsVariosTitulos.first();
                }
            }

            function concluirRecebimento(result) {
                if (angular.isDefined(result) && angular.isDefined(result.recebimentos)) {
                    var recebimentos = result.recebimentos;
                    var record;

                    for (var i = 0; i < self.dsVariosTitulos.size(); i++) {
                        record = self.dsVariosTitulos.getRecordsAsObjects()[i];

                        for (var j = 0; j < recebimentos.length; j++) {
                            var recebimento = recebimentos[j];

                            if (record.NSUCTF && record.NSUCTF == recebimento.NSUCTF) {
                                record.STATUS = recebimento.STATUS;
                                record.REQUISICAOCONFIRMACAO = recebimento.REQUISICAOCONFIRMACAO;
                                record.RETORNOCONFIRMACAO = recebimento.RETORNOCONFIRMACAO;
                                recebimentos.removeItemAt(j);
                                break;
                            }
                        }
                    }

                    var dadosInfoUsu = undefined;

                    if (self.dsVariosTitulos.isInsertionMode()) {
                        dadosInfoUsu = {
                            "CODBCO": self.dsVariosTitulos.getFieldValue("CODBCO"),
                            "Banco.NOMEBCO": self.dsVariosTitulos.getFieldValue("Banco.NOMEBCO"),
                            "NOSSONUM": self.dsVariosTitulos.getFieldValue("NOSSONUM"),
                            "DHBAIXA": self.dsVariosTitulos.getFieldValue("DHBAIXA"),
                            "HISTORICO": self.dsVariosTitulos.getFieldValue("HISTORICO")
                        };
                    }

                    recebimentos.forEach(function(record) {
                        record.VLRBAIXA = record.VLRTRANSACAO;
                        record.TipoTitulo_DESCRTIPTIT = record.DESCRTIPTIT;

                        var nossoNum = angular.isDefined(dadosInfoUsu) ? dadosInfoUsu.NOSSONUM : self.wizard.dataWizard.dadosBancarios.numDocumento;

                        record.CODBCO = angular.isDefined(dadosInfoUsu) ? dadosInfoUsu.CODBCO : self.wizard.dataWizard.dadosBancarios.codBco;
                        record['Banco.NOMEBCO'] = angular.isDefined(dadosInfoUsu) ? dadosInfoUsu['Banco.NOMEBCO'] : self.wizard.dataWizard.dadosBancarios.descrBco;
                        record.NOSSONUM = angular.isUndefined(nossoNum) ? "" : nossoNum;
                        record.DHBAIXA = angular.isDefined(dadosInfoUsu) ? dadosInfoUsu.DHBAIXA : self.dataCabecalho.dtBaixa;
                        record.HISTORICO = angular.isDefined(dadosInfoUsu) ? dadosInfoUsu.HISTORICO : self.wizard.dataWizard.dadosBancarios.historico;

                        self.dsVariosTitulos.addRecordsAsObjects(record);

                    });

                    calculaTotalVariosTitulos();

                    self.dsVariosTitulos.cancelEdition();
                    self.dsVariosTitulos.last();
                }
            }

            function openInformarCMC7(){
                if (!self.dsVariosTitulos.isInsertionMode()) {
                    if (self.dsVariosTitulos.size() == 0) {
                        self.dsVariosTitulos.goToInsertionMode();
                        return false;
                    }

                    if (self.usaRecebimentoComCartao && angular.isDefined(self.dsVariosTitulos.getFieldValue("NSUCTF"))) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.RecebimentoCartao.msgNaoPermCMC7Cartao') + ".");
                        return false;
                    }
                }
                afterPopulateCodTipTitulo(undefined, true);
            }
            
            function changeCodTipTitulo() {
                if(angular.isDefined(self.dsVariosTitulos)){
                    var codTipTitulo = self.dsVariosTitulos.getFieldValueAsNumber("CODTIPTIT");

                    if (angular.isDefined(codTipTitulo) && _tipoTituloChanged) {
                        if (angular.isDefined(codTipTitulo)) {
                            afterPopulateCodTipTitulo();
                        }
                    }

                    if(!_tipoTituloChanged){
                        _tipoTituloChanged = true;
                    }
                }
            }            
            
            function afterPopulateCodTipTitulo(item, mostrarSemValidar) {
                var codTipTitulo = self.dsVariosTitulos.getFieldValue("CODTIPTIT");

                if (!StringUtils.isEmpty(codTipTitulo)) {
                    var param = { codTipTit: codTipTitulo};

                    ServiceProxy.callService("mge@BaixaFinanceiroSP.informarCMC7ParaTipoTitulo", { param })
                        .then(function (result) {
                            var response = result.responseBody;

                            if (angular.isDefined(response)) {
                                if (response.informaCmc7 == "S" || mostrarSemValidar) {
                                    var dataValue = {};
                                    dataValue.ehPopUpBaixa = true;
                                    dataValue.codParc = _codParc;
                                    dataValue.vlrCheque = self.dsVariosTitulos.getFieldValueAsNumber("VLRBAIXA");

                                    if (response.dataSugerida == 0) {
                                        dataValue.dataCheque = dtBaixa;
                                    } else {
                                        dataValue.dataCheque = dtVencimento;
                                    }

                                    if (response.usaRastreabilidadeCheque == "S") {
                                        dataValue.usaRastreabilidadeCheque = true;
                                    }


									if(!_abriuCmc7PopUp){
										_abriuCmc7PopUp = true;
	                                    CMC7PanelService.openPopUp({ dataValue })
	                                        .then(function (result) {
	                                            var value = result.value;
	                                            if (angular.isDefined(value)) {
	                                                self.dsVariosTitulos.setFieldValue("NOSSONUM", value.numCheque);
	                                                self.dsVariosTitulos.setFieldValue("VLRBAIXA", value.vlrCheque);
	                                                self.dsVariosTitulos.setFieldValue("DHBAIXA", value.dataCheque);
	                                                self.dsVariosTitulos.setFieldValue("CODBARRA", value.strCMC7);
	                                                self.dsVariosTitulos.setFieldValueAsString("CODBCO_CMC7", value.codBcoCMC7);
	                                                self.dsVariosTitulos.setFieldValue("AGENCIA_CMC7", value.agenciaCMC7);
	                                                self.dsVariosTitulos.setFieldValue("CONTA_CMC7", value.contaCMC7);
	                                                self.dsVariosTitulos.setFieldValue("CGC_CPF_CMC7", value.cgcCpfCMC7);
	                                                self.dsVariosTitulos.setFieldValue("NOMEEMITENTE_CMC7", value.nomeEmitenteCMC7);
	
	                                                if (value.usaRastreabilidadeCheque) {
	                                                    self.dsVariosTitulos.setFieldValue("CHEQUERASTREADO_CMC7", "S");
	                                                    self.dsVariosTitulos.setFieldValue("DTCHEQUE_CMC7", value.dataCheque);
	                                                }
	
	                                                self.dsVariosTitulos.save();
	                                                _abriuCmc7PopUp = false;
	                                                value.salvarContaCliente();
	                                            }
	                                        }, function (cancel) {
												_abriuCmc7PopUp = false;
                    						});
                                    }
                                }
                            }
                    });
                }
            }

            function buscarMoeda() {
                CrudUtils.find('CotacaoMoeda', 'COTACAO', { CODMOEDA: _codMoeda }, true, undefined, 'this.DTMOV DESC')
                    .then(function (moeda) {
                        if (angular.isDefined(self.vlrMoedaAtu) && angular.isDefined(moeda)) {
                            var valorFormatado = NumberUtils.round(moeda.COTACAO, 5);
                            self.vlrMoedaAtu = valorFormatado;
                            changeValorMoeda();
                        }
                    });
            }

            function orderByFn(obja, objb) {
                const dateA = (obja.DTMOV instanceof Date) ? obja.DTMOV : DateUtils.strToDate(obja.DTMOV);
                const dateB = (objb.DTMOV instanceof Date) ? objb.DTMOV : DateUtils.strToDate(objb.DTMOV);
                return dateB - dateA;
            }

            function buscarCotacao(){
                SkPesquisaService.openPesquisaPopUp('CotacaoMoeda', undefined, {
					label: "Cotação de Moeda",
					criteria: criteriaCotacaoMoeda(),
                    loadOnCreate: true,
                    descriptionFieldName: 'this.DTMOV',
                    orderByDesc: true,
                    limit: 0
				}).then(function (result) {
                    var response = result.data;
					if(angular.isDefined(response)){
                        self.vlrMoedaAtu = NumberUtils.round(response["COTACAO"] , self.paramDecVlrMoeda);
                        changeValorMoeda();
                    }
				});
            }

            function changeValorMoeda(){
                if (angular.isDefined(self.vlrMoedaAtu) && alteredValue(self.vlrMoedaAtu)) {
                    var valorFormatado = NumberUtils.round(self.vlrMoedaAtu, self.paramDecVlrMoeda);
                    atualizaValoresBaixa(self.vlrMoedaNeg, valorFormatado);
                    self.vlrMoedaAtu = valorFormatado;
                    eventoValorAlterou();
                }
            }

            function atualizaCamposMoeda(){
                self.vlrDesdobAtu = self.valorTotal;
				self.vlrDesdobMoedaAtu = NumberUtils.round((self.vlrDesdobAtu / NumberUtils.stringToNumber(self.vlrMoedaAtu)),2);
				self.vlrDesdobMoedaTotal = self.vlrDesdobMoedaAtu;
				self.vlrVaricaoDesdob = self.vlrDesdobAtu - _vlrDesdobNegociacao;
				self.vlrDesdobTotal = self.vlrDesdobAtu;
            }

            function gerarPix(){
                var baixaAgrupadaPix = false;
                if (self.wizard.dataWizard.baixaAgrupada) {
                    baixaAgrupadaPix = true;
                } 
                if(validaCamposObrigatorios()){
                   ObjectUtils.setProperty($wizard.context, 'pixSolicitado', true);
                   
                   if (!self.dsVariosTitulos.isEmpty() || self.wizard.dataWizard.dadosBancarios.subTipTit == 10) {
                       registrarCobranca();
                   } else {
                       SanPopup.open({
                           title: i18n('Aviso'),
                           templateUrl: 'commons/baixa/panel/popup/alteracaotipotitulo/AlterarTipoTituloPopUp.tpl.html',
                           controller:  'AlterarTipoTituloController',
                           controllerAs: 'ctrl',
                           size: 'alert',
                           height: 190,
                           keyboard: false,
                           okBtnLabel: i18n('Commons.Baixa.buttonGerarPix'),
                           resolve: {
                               data: {
                                   textoTipoTitulo: self.wizard.dataWizard.dadosBancarios.descrTipTit,
                                   baixaAgrupada: baixaAgrupadaPix
                               }
                           }
                       }).result.then(function (result) {                            
                           self.codTipTit = result;                                             
                           registrarCobranca();
                       });
                   }
                }          
                
            }
            
            function validaCamposObrigatorios() {
                if (StringUtils.isEmpty(self.empresa)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.msgEmpresaObrigatoria'));
                    return false;
                } else if (StringUtils.isEmpty(self.top)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.msgTopObrigatoria'));
                    return false;
                } else if (StringUtils.isEmpty(self.conta)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.msgContaObrigatoria'));
                    return false;
                } else if (StringUtils.isEmpty(self.lancamento)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.msgLancamentoObrigatorio'));
                    return false;
                }
                return true;
            }

            function registrarCobranca(){
                var param = { 
                    codConta: self.conta,
                    valor: self.valorTotal,
                    codParc: self.codParc,
                    nomeParc: self.nomeParc,
                    cgcCpfParc: self.cgcCpfParc, 
                    nufin: _nufin
                };

                var vlrPix = 0;
                if (!self.dsVariosTitulos.isEmpty()) {                    
                    self.dsVariosTitulos.getRecordsAsObjects(undefined, true).forEach(function(record) {
                        if (record.SUBTIPOVENDA == 10) {
                            vlrPix = record.VLRBAIXA;
                        }
                    });
                }
                if (vlrPix > 0) {
                    param.valor = vlrPix;
                }
                if (vlrPix == 0 && !self.dsVariosTitulos.isEmpty()) {
                    MessageUtils.showAlert(i18n('Commons.Baixa.msgSemTituloPix'));
                    resetPixSolicitado();
                    return;
                }

                if( angular.isUndefined(param.valor) || param.valor == 0 ) {

                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING,  i18n('Commons.Baixa.msgValorZerado'));
                    resetPixSolicitado();
                } else {

                    if(isBancoBrasil()){

                        var params = {
                            entity: {
                                name: "ContaFintech",
                                criterio: [{
                                nome: "CODCTA",
                                valor: self.conta
                                }],
                                fields: {
                                field: [
                                    {name:"PIXATIVO"}
                                ]
                                }
                            }
                        }

                        ServiceProxy.callService("mge@crud.find", params)
                            .then(function(result){
                                let pixFintechAtivo= ObjectUtils.getProperty(result, 'responseBody.entidades.entidade.PIXATIVO'); 
                                pixBBAtivo = pixFintechAtivo && pixFintechAtivo.$ === "S" ? true : false;
                                if(!pixBBAtivo){
                                    MessageUtils.showError(MessageUtils.TITLE_ERROR,  i18n('Commons.Baixa.msgPixFintechDesativado'));
                                    return;
                                }
                                const callBackSucess = async () => {
                                        $wizard.next();
                                }
        
                                FintechUtilsService.openErpCobrancaPix(_nufin, self.conta, callBackSucess, null, cancelarPixFintech);
                            }
                        ).catch(function(error) {
                            MessageUtils.showError(MessageUtils.TITLE_ERROR,  i18n('Commons.Baixa.msgModuloDesatualizado'));
                        }).finally(function() {
                            resetPixSolicitado();
                        });


                    } else{
                        ServiceProxy.callService("mge@BaixaFinanceiroSP.registrarCobrancaPix", { param })
                            .then(function (result) {
        
                                var cobranca =  ObjectUtils.getProperty(result, "responseBody.cobranca");
        
                                if(cobranca.status == "CONCLUIDA"){
                                    if (self.dsVariosTitulos.isEmpty()) {
                                        self.valorTotal = cobranca.valorPago;
                                    }
                                    $wizard.next();
                                } else {
                                    carregarPopupPix(cobranca);
                                }
                            }
                        ).finally(function() {
                            resetPixSolicitado();
                        });
                    }
                }
            }

            function resetPixSolicitado() {
                ObjectUtils.setProperty($wizard.context, 'pixSolicitado', false);
            }

            function cancelarPixFintech(){
				let requestObj = {
						params: {
							NUFIN: {$: _nufin},
							STATUS: {$: "X"}
						}
					};

					resetPixSolicitado();
					ServiceProxy.callService("mgecom@CheckoutProdutoSP.atualizarStatusPix", requestObj);
			}

            function carregarPopupPix(cobranca) {
                SanPopup.open({
                    title: i18n('Commons.Baixa.titlePopupPix'),
                    templateUrl: 'commons/baixa/panel/popup/pix/ReceberComPixPopUp.tpl.html',
                    controller: 'ReceberComPixController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    height: 500,
                    showIconClose: false, 
                    keyboard: false,
                    showBtnOk: false,
                    showBtnCancel: false,
                    resolve: {
                        data: {
                            cobranca: cobranca
                        }
                    }
                }).result.then(function (result) {
                    if(result){
                        $wizard.next();
                    }
                }).finally(function() {
                    resetPixSolicitado();
                });
            }

            function validaTipoTitulo() {
                var possuiPix = false;                
                if (self.dsVariosTitulos.isEmpty() && self.wizard.dataWizard.dadosBancarios.subTipTit == 10 && _recDesp == 1) {
                    possuiPix = true;                    
                } else {
                    self.dsVariosTitulos.getRecordsAsObjects(undefined, true).forEach(function(record) {
                        if (record.SUBTIPOVENDA == 10 && _recDesp == 1) {
                            possuiPix = true;
                        }
                    });                    
                } 
                if (possuiPix) {
                    var options = {
                        okBtnLabel: "Receber com Pix",
                        noBtnLabel: "Cancelar",
                        cancelLabel: "Apenas baixar"
                    }
                    MessageUtils.confirm(MessageUtils.TITLE_WARNING, (self.dsVariosTitulos.isEmpty() ? i18n('Commons.Baixa.msgTipoTitulo') : i18n('Commons.Baixa.msgAlgumaParcelaPix')) , options.okBtnLabel, options.noBtnLabel, true, undefined, options)
                        .then(function(){
                            if(validaCamposObrigatorios()){
                                registrarCobranca();
                            }
                        }, function (reason) {
                            if (reason == 'no') {
                                resetPixSolicitado();
                            } else if (reason == 'cancel') {
                                resetPixSolicitado();
                                $wizard.next();
                            }
                        }
                    );
                } else {
                    resetPixSolicitado();
                    $wizard.next();
                }
            }

            function verificaTemContaPix(conta) {
                if(conta && conta.fields) {
                    let newConta = conta.fields;
                    codBancoContaSelecionada = newConta.CODBCO;
                    if(newConta.CHAVEPIX && newConta.IDCLIPIX && newConta.SENCLIPIX && _recDesp == 1) {
                        self.receberComPix = true;
                    } else {
                        verificaContaPixBanco();
                    }
                } else {
                    verificaContaPixBanco();
                }
            }

            function verificaContaPixBanco() {
                
                if (!StringUtils.isEmpty(self.conta)) {
                    if(isBancoBrasil()){
                        self.receberComPix = true;
                    } else {
                        CrudUtils.find("ContaBancaria", "CHAVEPIX,IDCLIPIX,SENCLIPIX", { CODCTABCOINT: self.conta }, true).then((result) => {
                            if(result.CHAVEPIX && result.IDCLIPIX && result.SENCLIPIX && _recDesp == 1) {
                                self.receberComPix = true;
                            } else {
                                self.receberComPix = false;
                            }
                        });
                    }       
                }
                
            }

            function changeConta(conta) {
                verificaTemContaPix(conta);
            }

            function onChangeEmpresa(){

                //FIXME o trecho abaixo fazia com que a conta ficasse vazia ao carregar a tela, perdendo o valor inicialmente carregado ao abrir o popup de baixa.
                //self.conta="";
                self.environmentCriteriaContaBancaria();

            }

            function getResourceID(){
                return (self.wizard.dataWizard?.resourceID || self.wizard.resourceID || '').toString();
            }

            function isBancoBrasil() {
                return codBancoContaSelecionada == BANCO_BRASIL;
            }
    }]);

angular
    .module('snk.commons.baixa.panel')
    .controller('BaixaVlrMaiorStepController', ['$wizard', '$step','ObjectUtils', 'MGEParameters', 'NumberUtils', 'AngularUtil', 'StringUtils',
        function ($wizard, $step, ObjectUtils, MGEParameters, NumberUtils, AngularUtil, StringUtils){
            var self = this;

            $step.onEnterStep = showStep;
            $step.onExitStep = exitStep;
            $step.isVisible = isVisible;

            self.istituloCredito = false;
            self.isLoad = false;
            self.diferenca = 1;

            self.onClickVerFinanceiro = onClickVerFinanceiro;
            self.onCreatedCabecalho = onCreatedCabecalho;

            var nufin;
            var desdob;
            var dtVencimento;
            var dtBaixa;
            var diasAtraso;
            var vlrTotal;
            var vlrCalculado;
            var _cabecalhoBaixa;

            function onCreatedCabecalho(cabecalho){
                _cabecalhoBaixa = cabecalho;
            }

            function isVisible(){
                return $wizard.context.dataWizard.valoresBaixa.vlrTotal > $wizard.context.dataWizard.valoresBaixa.vlrCalculado;
            }

            function showStep() {
                self.wizard = $wizard.context;
                $wizard.context.hideBtnCancel = false;

                self.verFinanceiroVisible = self.wizard.showBotaoVerFinanceiro;

                var cabecalho = self.wizard.dataWizard.cabecalho;
                nufin = cabecalho.nufin;
                desdob = cabecalho.desdob;
                dtVencimento = cabecalho.dtVencimento;
                dtBaixa = cabecalho.dtBaixa;
                diasAtraso = cabecalho.diasAtraso;
                vlrTotal = self.wizard.dataWizard.valoresBaixa.vlrTotal;
                vlrCalculado = self.wizard.dataWizard.valoresBaixa.vlrCalculado;

                self.dadosCabecalho = {
                    nufin : nufin,
                    desdob : desdob,
                    dtVencimento : dtVencimento,
                    dtBaixa : dtBaixa,
                    diasAtraso : diasAtraso,
                    diferenca : NumberUtils.round(vlrTotal - vlrCalculado, 2)
                };

                self.isLoad = true;

                if(self.wizard.dataWizard.valoresBaixa.recDesp == 1 && MGEParameters.asInteger("com.tipo.titulo.comp.credito") != 0){
                    self.istituloCredito = true;
                }else if(self.wizard.dataWizard.valoresBaixa.recDesp != 1 && MGEParameters.asInteger("com.tipo.titulo.comp.credito") != 0){
                    self.istituloCredito = false;
                }
                if (_cabecalhoBaixa) {
                    _cabecalhoBaixa.data = self.dadosCabecalho;
                    _cabecalhoBaixa.isReady();
                }
            }
            
            function exitStep() {
            	if(!StringUtils.isEmpty(self.diferenca) && $wizard.context.showStepMaior){
                    ObjectUtils.setProperty($wizard.context.dataWizard, 'decisao', self.diferenca);

                    //Cabeçalho
                    var cabecalho = {
                        nufin : nufin,
                        desdob : desdob,
                        dtBaixa : _cabecalhoBaixa.getDataBaixa(),
                        dtVencimento : dtVencimento,
                        diasAtraso : diasAtraso,
                        vlrTotal : vlrTotal,
                        vlrCalculado : vlrCalculado
                    };
                    ObjectUtils.setProperty($wizard.context.dataWizard, 'cabecalho', cabecalho);
                }

            }

            function onClickVerFinanceiro() {
                var baixaPanelCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-baixa-panel"))
                if (angular.isDefined(baixaPanelCtrl)) {
                    baixaPanelCtrl.onClickBotaoVerFinanceiro();
                }
            }

    }]);
angular
    .module('snk.commons.baixa.panel')
    .controller('BaixaVlrMenorStepController', ['$wizard', '$step','ObjectUtils','StringUtils', 'NumberUtils', 'AngularUtil','i18n', 'DateUtils', 'ServiceProxy', 'MGEParameters', 'MessageUtils',
        function ($wizard, $step, ObjectUtils, StringUtils, NumberUtils, AngularUtil, i18n, DateUtils, ServiceProxy, MGEParameters, MessageUtils){
            var self = this;

            $step.onEnterStep = showStep;
            $step.onExitStep = exitStep;
            $step.isVisible = isVisible;

            self.onClickVerFinanceiro = onClickVerFinanceiro;
            self.onCreatedCabecalho = onCreatedCabecalho;
            self.handleFrequence = handleFrequence;
            self.ajustarCalculoPorDentro = ajustarCalculoPorDentro;
            self.corVlrListener = corVlrListener;
            self.corVlrIssEventListener = corVlrIssEventListener;
            self.corVlrIrrfEventListener = corVlrIrrfEventListener;
            self.corVlrInssEventListener = corVlrInssEventListener;
            self.corVlrVendorEventListener = corVlrVendorEventListener;
            self.corVlrMultaEventListener = corVlrMultaEventListener;
            self.corVlrDespCartorioEventListener = corVlrDespCartorioEventListener;
            self.corVlrJuroEventListener = corVlrJuroEventListener;
            self.corVlrTaxaAdmEventListener = corVlrTaxaAdmEventListener;
            self.corVlrDescontoEventListener = corVlrDescontoEventListener;
            self.diferenca = 4;
            self.lblInformacaoText;

            var _irrfRetido;
            var _inssRetido;
            var _issRetido;
            var _temOutrosImpostos;
            var _habilitaVariosCampos;
            var desdob;
            var dtVencimento;
            var dtBaixa;
            var diasAtraso;
            var vlrTotal;
            var vlrCalculado;
            var vlrJuroLib;
            var vlrMultaLib;
            var _nufin;
            var _cabecalhoBaixa;
            var _recalcularJurosMultaApartirValorPendencia;
            var _primeiroRecalculo;

            function onCreatedCabecalho(cabecalho){
                _cabecalhoBaixa = cabecalho;
            }

            function isVisible(){
                return $wizard.context.dataWizard.valoresBaixa.vlrTotal < $wizard.context.dataWizard.valoresBaixa.vlrCalculado;
            }

            function showStep() {
                _primeiroRecalculo = true;
                self.wizard = $wizard.context;
                $wizard.context.hideBtnCancel = false;
                self.dsVariosTitulos = $wizard.context.dsVariosTitulos;
                self.verFinanceiroVisible = self.wizard.showBotaoVerFinanceiro;
                
                _recalcularJurosMultaApartirValorPendencia = self.wizard.recalcularJurosMultaApartirValorPendencia;

                var cabecalho = self.wizard.dataWizard.cabecalho;
                _nufin = cabecalho.nufin;
                desdob = cabecalho.desdob;
                dtVencimento = cabecalho.dtVencimento;
                dtBaixa = cabecalho.dtBaixa;
                diasAtraso = cabecalho.diasAtraso;
                vlrTotal = (angular.isDefined(self.dsVariosTitulos) && !self.dsVariosTitulos.isEmpty()) ? self.wizard.dataWizard.valoresBaixa.vlrTotal : self.wizard.dataWizard.cabecalho.vlrTotal;
                vlrCalculado = cabecalho.vlrCalculado;

                self.dataCabecalho = {
                    nufin : _nufin,
                    desdob : desdob,
                    dtVencimento : dtVencimento,
                    dtBaixa : dtBaixa,
                    diasAtraso : diasAtraso,
                    vlrMenor : NumberUtils.round(vlrTotal, 2),
                    vlrCalculado : NumberUtils.round(vlrCalculado, 2)
                };

                self.isLoading = true;

                if(angular.isUndefined(self.wizard.dataWizard.dadosPendencia)){
                    populaCampos();
                }

                habilitaCampos();

                ajustarOutrosImpostos();
            }

            function populaCampos() {
                _irrfRetido = self.wizard.dataWizard.impostos.irrfRetido;
                _inssRetido =  self.wizard.dataWizard.impostos.inssRetido;
                _issRetido = self.wizard.dataWizard.impostos.issRetido;

                var tipoMulta = self.wizard.dataWizard.valoresBaixa.tipoMulta;
                var tipoJuros = self.wizard.dataWizard.valoresBaixa.tipoJuros;
                var vlrMulta = 0;
                var vlrJuros = 0;

                if(!StringUtils.isEmpty(tipoMulta) && tipoMulta == "I"){
                    vlrMulta = self.wizard.dataWizard.valoresBaixa.vlrMulta;
                }

                if(!StringUtils.isEmpty(tipoJuros) && tipoJuros == "I"){
                    vlrJuros = self.wizard.dataWizard.valoresBaixa.vlrJuros;
                }

                var outrosImpostos = NumberUtils.getNumberOrZero(self.wizard.dataWizard.impostos.vlrOutrosImpostos);
                var vlrDespCartorio = self.wizard.dataWizard.valoresBaixa.vlrDespesasCartorio;
                var vlrJurosNeg = self.wizard.dataWizard.valoresBaixa.vlrJurosNeg;
                var vlrMultaNeg = self.wizard.dataWizard.valoresBaixa.vlrMultaNeg;

                var valoresOrigem = ["E", "F"]
                if (outrosImpostos != 0 && valoresOrigem.includes(self.wizard.dataWizard.cabecalho.origem)) {
                    _temOutrosImpostos = true;
                }

                vlrJuroLib = self.wizard.dataWizard.valoresBaixa.vlrJurosLib;
                vlrMultaLib = self.wizard.dataWizard.valoresBaixa.vlrMultaLib;

                self.oriVencimento = self.wizard.dataWizard.dataVencimento;
                self.oriVlrIrrf = angular.isDefined(_irrfRetido) ? self.wizard.dataWizard.impostos.vlrIrrf : 0;
                self.oriVlrInss = angular.isDefined(_inssRetido) ? self.wizard.dataWizard.impostos.vlrInss : 0;
                self.oriVlrIss = angular.isDefined(_issRetido) ? self.wizard.dataWizard.impostos.vlrIss : 0;
                self.oriVlrVendor = self.wizard.dataWizard.impostos.vlrVendor;
                self.oriVlr = self.wizard.dataWizard.valoresBaixa.vlrDesdob;
                self.oriVlrMulta = vlrMulta;
                self.oriVlrMultaNeg = vlrMultaNeg;
                self.oriVlrDespCartorio = vlrDespCartorio;
                self.oriVlrJuro = vlrJuros;
                self.oriVlrJurosNeg = vlrJurosNeg;
                self.oriVlrDesconto = self.wizard.dataWizard.valoresBaixa.vlrDesconto;
                self.oriVlrTaxaAdm = self.wizard.dataWizard.valoresBaixa.taxaAdm;
                self.oriVlrOutrosImp = outrosImpostos;
                self.oriOutrosImpMen = NumberUtils.getNumberOrZero(self.wizard.dataWizard.impostos.vlrOutrosImpMensais);
                self.oriVlrTotal = self.wizard.dataWizard.valoresBaixa.vlrCalculado;

                var percentVlrBaixa = 1;
                var vlrJurosMultas = vlrMulta + vlrDespCartorio + vlrJuros + vlrJurosNeg + vlrMultaNeg;

                if(vlrTotal < outrosImpostos){
                    percentVlrBaixa = 0;
                    _habilitaVariosCampos = true;
                    self.boxInformacaoVisible = false;
                } else if(vlrTotal <= vlrJurosMultas){
                    percentVlrBaixa = vlrTotal / (vlrCalculado + Math.abs(outrosImpostos));
                    self.boxInformacaoVisible = true;
                    self.lblInformacaoText = i18n("Commons.Baixa.messageValorBaixaInsuficiente");
                    _habilitaVariosCampos = true;
                    /*Caso o valor total vlrTotal <= vlrJurosMultas deve-se proporcionalizar tambem o perdão de multa e juros informado
                     *para que seja efetuado apenas o abatimento da multa e juros referente a porcentagem da baixa parcial corrente*/
                    vlrJuroLib = self.wizard.dataWizard.valoresBaixa.vlrJurosLib = NumberUtils.round(vlrJuroLib * percentVlrBaixa, 2);
                	vlrMultaLib = self.wizard.dataWizard.valoresBaixa.vlrMultaLib = NumberUtils.round(vlrMultaLib * percentVlrBaixa, 2);
                } else{
                    percentVlrBaixa = 1;
                    _habilitaVariosCampos = false;
                    self.boxInformacaoVisible = false;
                }

                self.corVencimento = self.wizard.dataWizard.dataVencimento;
                self.corVlrIrrf = _irrfRetido ? NumberUtils.round(self.wizard.dataWizard.impostos.vlrIrrf * percentVlrBaixa, 2) : 0;
                self.corVlrInss = _inssRetido ? NumberUtils.round(self.wizard.dataWizard.impostos.vlrInss * percentVlrBaixa, 2) : 0;
                self.corVlrIss = _issRetido ? NumberUtils.round(self.wizard.dataWizard.impostos.vlrIss * percentVlrBaixa, 2) : 0;
                self.corVlrVendor = NumberUtils.round(self.wizard.dataWizard.impostos.vlrVendor * percentVlrBaixa, 2);
                self.corVlrMulta = NumberUtils.round(vlrMulta * percentVlrBaixa, 2);
                self.corVlrMultaNeg = NumberUtils.round(vlrMultaNeg * percentVlrBaixa, 2);
                self.corVlrDespCartorio = NumberUtils.round(vlrDespCartorio * percentVlrBaixa, 2);
                self.corVlrJuro = NumberUtils.round(vlrJuros * percentVlrBaixa, 2);
                self.corVlrJurosNeg = NumberUtils.round(vlrJurosNeg * percentVlrBaixa, 2);
                self.corVlrDesconto = NumberUtils.round(self.wizard.dataWizard.valoresBaixa.vlrDesconto * percentVlrBaixa, 2);
                self.corVlrTaxaAdm = NumberUtils.round(self.wizard.dataWizard.valoresBaixa.taxaAdm * percentVlrBaixa, 2);
                self.corVlrOutrosImp = NumberUtils.round(outrosImpostos * percentVlrBaixa, 2);
                self.corOutrosImpMen = NumberUtils.getNumberOrZero(self.wizard.dataWizard.impostos.vlrOutrosImpMensais) * percentVlrBaixa;
                self.corBaseDevidaOutrosImp = NumberUtils.getNumberOrZero(self.wizard.dataWizard.impostos.baseDevidaOutrosImpostos);
                self.corVlrTotal = NumberUtils.round(vlrTotal, 2);
                self.corTipoMulta = self.wizard.dataWizard.valoresBaixa.tipoMulta;

                if(angular.isDefined(self.wizard.dataWizard.valoresBaixa.diferenca) && self.wizard.dataWizard.valoresBaixa.diferenca != 0) {
                    self.corVlrTotal = NumberUtils.round(self.wizard.dataWizard.valoresBaixa.vlrTotal, 2) + NumberUtils.round(self.wizard.dataWizard.valoresBaixa.diferenca, 2);
                }

                self.penVencimento = DateUtils.stringToDate(self.wizard.dataWizard.dataVencimento);
                self.penVlrIrrf = NumberUtils.round(self.oriVlrIrrf - self.corVlrIrrf, 2);
                self.penVlrInss = NumberUtils.round(self.oriVlrInss - self.corVlrInss, 2);
                self.penVlrIss = NumberUtils.round(self.oriVlrIss - self.corVlrIss, 2);
                self.penVlrVendor = NumberUtils.round(self.oriVlrVendor - self.corVlrVendor, 2);
                self.penVlrMulta = NumberUtils.round(self.oriVlrMulta - self.corVlrMulta, 2);
                self.penVlrMultaNeg = NumberUtils.round(self.oriVlrMultaNeg - self.corVlrMultaNeg, 2);
                self.penVlrDespCartorio = NumberUtils.round(self.oriVlrDespCartorio - self.corVlrDespCartorio, 2);
                self.penVlrJuro = NumberUtils.round(self.oriVlrJuro - self.corVlrJuro, 2);
                self.penVlrJurosNeg = NumberUtils.round(self.oriVlrJurosNeg - self.corVlrJurosNeg, 2);
                self.penVlrDesconto = NumberUtils.round(self.oriVlrDesconto - self.corVlrDesconto, 2);
                self.penVlrTaxaAdm = NumberUtils.round(self.oriVlrTaxaAdm - self.corVlrTaxaAdm, 2);
                self.penVlrOutrosImp = NumberUtils.round(self.oriVlrOutrosImp - self.corVlrOutrosImp, 2);
                self.penOutrosImpMen = NumberUtils.round(self.oriOutrosImpMen - self.corOutrosImpMen, 2);

                calculaValorCorrente();
            }

            function calculaValorCorrente(){
                var valor = 0;
                var vlrDif = 0;

                valor = self.corVlrTotal - self.corVlrIrrf - self.corVlrInss - self.corVlrIss + self.corVlrVendor + self.corVlrMulta + self.corVlrMultaNeg + self.corVlrDespCartorio + self.corVlrJuro - self.corVlrDesconto - self.corVlrTaxaAdm + self.corVlrOutrosImp + self.corOutrosImpMen - vlrJuroLib - vlrMultaLib + self.corVlrJurosNeg;
                vlrDif = self.corVlrTotal - valor;

                self.corVlr = NumberUtils.round(NumberUtils.stringToNumber(self.corVlrTotal) + vlrDif , 2);

                calculaValorPendencia();
            }
            
            function exitStep() {
                if(!StringUtils.isEmpty(self.diferenca) && $wizard.context.showStepMenor){
					if(DateUtils.dateToString(self.penVencimento, DateUtils.DEFAULT_DATE_FORMAT) != undefined ){
                    	self.penVencimento = DateUtils.dateToString(self.penVencimento, DateUtils.DEFAULT_DATE_FORMAT);
                	}
                    var dadosPendencia = {
                    	dtVencimento : self.penVencimento,
                        vlrIrrf : self.penVlrIrrf,
                        vlrInss : self.penVlrInss,
                        vlrIss : self.penVlrIss,
                        vlrVendor : self.penVlrVendor,
                        vlrMulta : self.penVlrMulta,
                        vlrMultaNeg : self.penVlrMultaNeg,
                        vlrDespCartorio : self.penVlrDespCartorio,
                        vlrJuro : self.penVlrJuro,
                        vlrDesconto : self.penVlrDesconto,
                        vlrTaxaAdm : self.penVlrTaxaAdm,
                        vlrOutrosImp : self.penVlrOutrosImp,
                        outrosImpMen : self.penOutrosImpMen,
                        vlrTotal : self.penVlr,
                        vlrJurosNeg : self.penVlrJurosNeg,
                    };

                    ObjectUtils.setProperty($wizard.context.dataWizard, 'decisao', self.diferenca);
                    ObjectUtils.setProperty($wizard.context.dataWizard, 'dadosPendencia', dadosPendencia);

                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrDesdob', self.corVlr);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'taxaAdm', self.corVlrTaxaAdm);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrMulta', self.corVlrMulta);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrMultaNeg', self.corVlrMultaNeg);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrDesconto', self.corVlrDesconto);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrJuros', self.corVlrJuro);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrTotal', self.corVlrTotal);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrDespesasCartorio', self.corVlrDespCartorio);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrJurosNeg', self.corVlrJurosNeg);
                    ObjectUtils.setProperty($wizard.context.dataWizard.valoresBaixa, 'vlrTotalOriginal', self.oriVlr);

                    //Impostos
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'vlrIrrf', self.corVlrIrrf);
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'vlrInss', self.corVlrInss);
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'vlrIss',  self.corVlrIss);
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'vlrVendor',  self.corVlrVendor);
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'vlrOutrosImpostos',  self.corVlrOutrosImp);
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'vlrOutrosImpMensais',  self.corOutrosImpMen);
                    ObjectUtils.setProperty($wizard.context.dataWizard.impostos, 'baseDevidaOutrosImpostos',  self.corBaseDevidaOutrosImp);

                    //Cabeçalho
                    var cabecalho = {
                        nufin : self.dataCabecalho.nufin,
                        desdob : desdob,
                        dtBaixa : self.dataCabecalho.dtBaixa,
                        dtVencimento : dtVencimento,
                        diasAtraso : diasAtraso,
                        vlrTotal : vlrTotal,
                        vlrCalculado : vlrCalculado
                    };

                    ObjectUtils.setProperty($wizard.context.dataWizard, 'cabecalho', cabecalho);
                    //quando o usuario clicar em voltar no passo 'Baixa Valor Menor' PRECISA ser feito o recalculo dos valores, mas os _dirtyFields permanecem.
                    ObjectUtils.setProperty($wizard.context.dataWizard, 'recalcular', true);
                }
            }

            function onClickVerFinanceiro() {
                var baixaPanelCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-baixa-panel"))
                if (angular.isDefined(baixaPanelCtrl)) {
                    baixaPanelCtrl.onClickBotaoVerFinanceiro();
                }
            }

            function ajustarOutrosImpostos() {
                var valor = self.corVlr - self.corVlrIrrf - self.corVlrInss - self.corVlrIss + self.corVlrVendor + self.corVlrMulta + self.corVlrDespCartorio + self.corVlrJuro - self.corVlrDesconto - self.corVlrTaxaAdm + self.corVlrOutrosImp + self.corOutrosImpMen - vlrJuroLib - vlrMultaLib;
                recalcularOutrosImpostos(valor, true);
            }

            function recalcularOutrosImpostos(valor, primeiroRecalculo) {
                if(self.opcaoCalculo && !_primeiroRecalculo){
					return;
				}
                
                if(_temOutrosImpostos){
                    var params ={
                        nufin : _nufin,
                        vlrTotal : self.oriVlr,
                        vlrBaixa : valor,
                        vlrPendencia : self.oriVlr - valor,
                        vlrMulta : self.corVlrMulta,
                        vlrMultaNeg : self.corVlrMultaNeg,
                        vlrDespCartorio : self.corVlrDespCartorio,
                        vlrJuro : self.corVlrJuro,
                        vlrJurosNeg : self.corVlrJurosNeg,
                        vlrDesconto : self.corVlrDesconto,
                        vlrTaxaAdm : self.corVlrTaxaAdm,
                        primeiroRecalculo : primeiroRecalculo ? "S" : "N"
                    };

                    ServiceProxy.callService("mge@BaixaFinanceiroSP.recalcularOutrosImpostosVlrMinimo", {params})
                        .then(function (result) {
                            var outrosImpostos = result.responseBody.outrosImpostos;
                            var temImpostoDigitado = outrosImpostos.temImpostoDigitado == "true";

                            if(!temImpostoDigitado) {
                                var vlrOutrosImpostosBaixa = outrosImpostos["vlrOutrosImpostosBaixa"];
                                var vlrOutrosImpostosPendencia = outrosImpostos["vlrOutrosImpostosPendencia"];

                                if (_primeiroRecalculo) {
                                    var vlrBaixa = outrosImpostos["vlrBaixa"];

                                    _primeiroRecalculo = false;
                                    self.corVlr = vlrBaixa;

                                    var isValorMenorQueOutrosImpostos = vlrTotal < Math.abs(vlrOutrosImpostosBaixa);

                                    if (isValorMenorQueOutrosImpostos){
                                        MessageUtils.showAlert(i18n("Commons.Baixa.messageValorBaixaInsuficienteOutrosImpostos"));
                                    }

                                    $step.setCanNext(!isValorMenorQueOutrosImpostos);
                                }

                                self.corVlrOutrosImp = NumberUtils.stringToNumber(vlrOutrosImpostosBaixa);
                                self.penVlrOutrosImp = NumberUtils.stringToNumber(vlrOutrosImpostosPendencia);

                                calculaValorPendencia();
                            }

                        });
                }

            }
            
            function calculaValorPendencia() {
                self.penVlr = self.oriVlr - self.corVlr;
                calculaVlrTotalBaixa();
                calculaVlrTotalPendencia();
            }

            function calculaVlrTotalBaixa(){
                var valor = 0;
                valor = self.corVlr - self.corVlrIrrf - self.corVlrInss - self.corVlrIss + self.corVlrVendor + self.corVlrMulta + self.corVlrMultaNeg+  self.corVlrDespCartorio + self.corVlrJuro - self.corVlrDesconto - self.corVlrTaxaAdm + self.corVlrOutrosImp + self.corOutrosImpMen  - vlrJuroLib - vlrMultaLib + self.corVlrJurosNeg;

                self.corVlrTotal = valor;
            }

            function calculaVlrTotalPendencia(){
                var valor = 0;
                if(MGEParameters.asBoolean('usa.liberacao.perdao.juro.multa')){
					valor = self.penVlr - self.penVlrIrrf - self.penVlrInss - self.penVlrIss + self.penVlrVendor + self.penVlrMulta + self.penVlrMultaNeg + self.penVlrDespCartorio + self.penVlrJuro - self.penVlrDesconto - self.penVlrTaxaAdm + self.penVlrOutrosImp + self.penOutrosImpMen  - (vlrJuroLib - (self.corVlrJuro + self.penVlrJuro)) - (vlrMultaLib - (self.penVlrMulta + self.corVlrMulta)) + self.penVlrJurosNeg;
				} else {
                	valor = self.penVlr - self.penVlrIrrf - self.penVlrInss - self.penVlrIss + self.penVlrVendor + self.penVlrMulta + self.penVlrMultaNeg + self.penVlrDespCartorio + self.penVlrJuro - self.penVlrDesconto - self.penVlrTaxaAdm + self.penVlrOutrosImp + self.penOutrosImpMen  - vlrJuroLib - vlrMultaLib + self.penVlrJurosNeg;
				}
                self.penVlrTotal = valor;
            }

            function habilitaCampos() {
                self.campos = {};
            	self.campos.corVlrIrrf = false;
				self.campos.corVlrInss = false;
				self.campos.corVlrIss = false;
				self.campos.corVlrVendor = false;
                self.campos.penVencimento = false;
                self.campos.corVlr = false;
				self.campos.corVlrMulta = false;
				self.campos.corVlrDespCartorio = false;
				self.campos.corVlrJuro = false;
				self.campos.corVlrTaxaAdm = false;
				self.campos.corVlrDesconto = false;
				
                if(self.diferenca == 4) {
					self.campos.corVlrIrrf = self.oriVlrIrrf != 0;
					self.campos.corVlrInss = self.oriVlrInss != 0;
					self.campos.corVlrIss = self.oriVlrIss != 0;
					self.campos.corVlrVendor = self.oriVlrVendor != 0;

					if(_habilitaVariosCampos){
                        self.campos.corVlr = true;
						self.campos.corVlrMulta = self.oriVlrMulta != 0;
						self.campos.corVlrDespCartorio = self.oriVlrDespCartorio != 0;
						self.campos.corVlrJuro = self.oriVlrJuro != 0;
						self.campos.corVlrTaxaAdm = self.oriVlrTaxaAdm != 0;
						self.campos.corVlrDesconto = self.oriVlrDesconto != 0;
					} else{
                        let podeAlterarDataVencimento = true
        
                        try {
                            const resourceIDBloquearCampos = self.wizard.resourceIdBloquearCampos;
                            const listaResourceIdsPodeAlterarDataVencimento = [
                                'br.com.sankhya.com.mov.CentralNotas_VENDA',
                                'br.com.sankhya.com.mov.CentralNotas_COMPRA',
                                'br.com.sankhya.com.mov.CentralNotas',
                                'br.com.sankhya.fin.cad.movimentacaoFinanceira'
                            ]
    
                            if (resourceIDBloquearCampos != null && listaResourceIdsPodeAlterarDataVencimento.includes(resourceIDBloquearCampos)){
                                podeAlterarDataVencimento = !MGEParameters.asBoolean('fin.permite.alt.venc.baix.parc');
                            }
                        } catch {
                            podeAlterarDataVencimento = true
                        }
              
                        
						self.campos.penVencimento = podeAlterarDataVencimento
                        
                        self.campos.corVlr = self.campos.corVlrIrrf || self.campos.corVlrInss || self.campos.corVlrIss || self.campos.corVlrVendor;
					}
				}
            }

            function ajustarCalculoPorDentro(){
                var calculo = vlrTotal;
                if(self.opcaoCalculo){
                    calculo = calculo + (self.corVlrInss + self.corVlrIss + self.corVlrIrrf);
                }

				_primeiroRecalculo = true;
                recalcularOutrosImpostos(calculo, true);
			}

			function corVlrListener(){
				var valorAtual = self.corVlr;
				
				valorAtual = isNaN(valorAtual) ? 0 : valorAtual;
				
				if(NumberUtils.round(valorAtual, 2) >= NumberUtils.round(self.oriVlr, 2)) {
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Baixa.messageValorCorrenteMaiorIgualOrig'));
					return;
				}
				
				recalcularOutrosImpostos(valorAtual, false);
				
				//self.corVlr = valorAtual;
				
				if(_recalcularJurosMultaApartirValorPendencia) {
					recalcularJurosDoValorPendente();
					
				} else {
					calculaValorPendencia();
				}
            }

            function corVlrIssEventListener(){
                ajustarCalculoPorDentro();
				var vlrIssAtual = self.corVlrIss;

				vlrIssAtual = isNaN(vlrIssAtual) ? 0 : vlrIssAtual;
				self.corVlrIss = vlrIssAtual;
				self.penVlrIss = NumberUtils.round(self.oriVlrIss - vlrIssAtual, 2);
				calculaValorPendencia();
            }

            function corVlrIrrfEventListener(){
                ajustarCalculoPorDentro();
                var vlrIrrfAtual = self.corVlrIrrf;

                vlrIrrfAtual = isNaN(vlrIrrfAtual) ? 0 : vlrIrrfAtual;
                self.corVlrIrrf = vlrIrrfAtual;
                self.penVlrIrrf = NumberUtils.round(self.oriVlrIrrf - vlrIrrfAtual, 2);
                calculaValorPendencia()
            }

            function corVlrInssEventListener(){
                ajustarCalculoPorDentro();
                var vlrInssAtual = self.corVlrInss;

                vlrInssAtual = isNaN(vlrInssAtual) ? 0 : vlrInssAtual;
                self.corVlrInss = vlrInssAtual;
                self.penVlrInss = NumberUtils.round(self.oriVlrInss - vlrInssAtual, 2);
                calculaValorPendencia();
            }

            function corVlrVendorEventListener(){
                var vendorAtual = self.corVlrVendor

				vendorAtual = isNaN(vendorAtual) ? 0 : vendorAtual;
				self.corVlrVendor =NumberUtils.round(vendorAtual, 2);
				self.penVlrVendor = NumberUtils.round(self.oriVlrVendor - vendorAtual, 2);
				calculaValorPendencia();
            }

            function corVlrMultaEventListener(){
                var multaAtual = self.corVlrMulta;
                multaAtual = isNaN(multaAtual) ? 0 : multaAtual;
				self.corVlrMulta = NumberUtils.round(multaAtual, 2);
					
				if(_recalcularJurosMultaApartirValorPendencia) {
                    recalcularJurosDoValorPendente();
                } else {
                    self.penVlrMulta = NumberUtils.round(self.oriVlrMulta - multaAtual, 2);
                    calculaValorPendencia();
                }		
            }

            function corVlrDespCartorioEventListener(){
                var despCartAtual = self.corVlrDespCartorio;

                despCartAtual = isNaN(despCartAtual) ? 0 : despCartAtual;
                self.corVlrDespCartorio = NumberUtils.round(despCartAtual, 2);

                self.penVlrDespCartorio = NumberUtils.round(self.oriVlrDespCartorio - despCartAtual, 2);

                calculaValorPendencia();
            }

            function corVlrJuroEventListener(){
                var juroAtual = self.corVlrJuro;

                juroAtual = isNaN(juroAtual) ? 0 : juroAtual;
                self.corVlrJuro = NumberUtils.round(juroAtual, 2);
                
                if(_recalcularJurosMultaApartirValorPendencia) {
                    recalcularJurosDoValorPendente();
                    
                } else {
                    self.penVlrJuro = NumberUtils.round(self.oriVlrJuro - juroAtual, 2);
                    calculaValorPendencia();
                }
            }

            function corVlrTaxaAdmEventListener(){
                var taxaAdmAtual = self.corVlrTaxaAdm;

				taxaAdmAtual = isNaN(taxaAdmAtual) ? 0 : taxaAdmAtual;
				self.corVlrTaxaAdm = NumberUtils.round(taxaAdmAtual, 2);

				self.penVlrTaxaAdm = NumberUtils.round(self.oriVlrTaxaAdm - taxaAdmAtual, 2);

				calculaValorPendencia();
            }

            function corVlrDescontoEventListener(){
                var descontoAtual = self.corVlrDesconto;

                descontoAtual = isNaN(descontoAtual) ? 0 : descontoAtual;
                self.corVlrDesconto = NumberUtils.round(descontoAtual, 2);

                self.penVlrDesconto = NumberUtils.round(self.corVlrDesconto - descontoAtual, 2);

                calculaValorPendencia();
            }

            function recalcularJurosDoValorPendente() {
                var params = {
                    nufin: _nufin,
                    vlrPendencia: self.oriVlr - self.corVlr,
                    dtBaixa : dtBaixa
                }

                ServiceProxy.callService("mge@BaixaFinanceiroSP.recalcularJurosMultaDoValorPendente", { params })
                    .then(function (result) {
                        var valoresRecalculados = result.responseBody.valoresRecalculados;
                        var penVlrJuroRecalculado = NumberUtils.stringToNumber(valoresRecalculados.penVlrJuro);
                        var penVlrMultaRecalculado = NumberUtils.stringToNumber(valoresRecalculados.penVlrMulta);

                        self.penVlrJuro = NumberUtils.round(penVlrJuroRecalculado , 2);
                        self.penVlrMulta = NumberUtils.round(penVlrMultaRecalculado, 2);

                        calculaValorPendencia();

                    });


            }
            
            function handleFrequence(){
                habilitaCampos();
            }
    }]);
angular
    .module('snk.commons.baixa.panel')
    .controller('ConclusaoBaixaStepController', ['$wizard', '$step','AngularUtil', 'ObjectUtils', 'MessageUtils',
        function ($wizard, $step, AngularUtil, ObjectUtils, MessageUtils){
            var self = this;

            var _opcao;

            $step.onEnterStep = showStep;
            $step.onExitStep = exitStep;
            self.escolherAcao = escolherAcao;
            self.onClickVerFinanceiro = onClickVerFinanceiro;

            function showStep(){
                self.wizard = $wizard.context;
                self.wizard.hideBtnCancel = true;
                var cabecalho = self.wizard.dataWizard.cabecalho;

                self.dadosCabecalho = {
                    nufin : cabecalho.nufin,
                    desdob : cabecalho.desdob,
                    dtVencimento : cabecalho.dtVencimento,
                    dtBaixa : cabecalho.dtBaixa,
                    diasAtraso : cabecalho.diasAtraso,
                    vlrTotal : cabecalho.vlrTotal,
                    vlrCalculado : cabecalho.vlrCalculado
                };
                
                if(angular.isDefined(self.wizard.dataWizard.msgComissao)) {
	            	MessageUtils.showAlert(MessageUtils.TITLE_WARNING, self.wizard.dataWizard.msgComissao);
                }
                
                self.verFinanceiroVisible = self.wizard.showBotaoVerFinanceiro;
                self.fecharAplicarVisible = self.wizard.showBotaoFecharReaplicar;
                self.fecharBaixarProximoVisible = self.wizard.showBotaoBaixaProximo;
                self.isLoad = true;
            }

            function escolherAcao(opcao){
                _opcao = opcao;
                $step.setCanFinish(true);
                $wizard.finish();
            }

            function exitStep() {
                ObjectUtils.setProperty($wizard.context, 'opcao', _opcao);
            }

            function onClickVerFinanceiro() {
                var baixaPanelCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-baixa-panel"))
                if (angular.isDefined(baixaPanelCtrl)) {
                    baixaPanelCtrl.onClickBotaoVerFinanceiro();
                }
            }
    }]);
angular
    .module('snk.commons.baixa.panel')
    .controller('LiberacaoBaixaStepController', ['$wizard', '$step','ObjectUtils', 'MessageUtils', 'i18n', 'ArrayUtils', 'AngularUtil',
        function ($wizard, $step, ObjectUtils, MessageUtils, i18n, ArrayUtils, AngularUtil){
            var self = this;

            $step.onEnterStep = showStep;
            $step.onExitStep = exitStep;
            $step.isVisible = isVisible;

            self.onDatasetCreatedStandAlone = onDatasetCreatedStandAlone;
            self.refreshHandlerStadAlone = refreshHandlerStadAlone;
            self.onClickVerFinanceiro = onClickVerFinanceiro;
            self.onCreatedCabecalho = onCreatedCabecalho;

            var _mensagens = [];
            var _cabecalhoBaixa;

            function onCreatedCabecalho(cabecalho){
                _cabecalhoBaixa = cabecalho;
            }

            function isVisible(){
                return !ObjectUtils.isEmpty($wizard.context.dataWizard.liberacoes) && $wizard.context.dataWizard.baixou == false;
            }

            function showStep(){
                self.wizard = $wizard.context;
                self.wizard.hideBtnCancel = false;

                self.verFinanceiroVisible = self.wizard.showBotaoVerFinanceiro;

                var cabecalho = self.wizard.dataWizard.cabecalho;
                self.dadosCabecalho = {
                    nufin : cabecalho.nufin,
                    desdob : cabecalho.desdob,
                    dtVencimento : cabecalho.dtVencimento,
                    dtBaixa : cabecalho.dtBaixa,
                    diasAtraso : cabecalho.diasAtraso,
                    vlrTotal : cabecalho.vlrTotal,
                    vlrCalculado : cabecalho.vlrCalculado
                };

                var objliberacoes = self.wizard.dataWizard.liberacoes;
                if(angular.isDefined(objliberacoes) && !ObjectUtils.isEmpty(objliberacoes)){
                    self.liberacoes = {liberacao : ArrayUtils.toArray(objliberacoes)};

                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Baixa.messageErroTituloPedeLiberacao'));

                    self.isLoad = true;
                }

                if(angular.isDefined(self.wizard.dataWizard.mensagens)){
                    var mensagens = ArrayUtils.toArray(self.wizard.dataWizard.mensagens);
                    mensagens.forEach(function(row) {
                        _mensagens.push({MSG : row.$});
                    });

                    if(self.dsMensagens && _mensagens.length > 0){
                        self.dsMensagens.refresh();
                    }
                }
            }

            function onDatasetCreatedStandAlone(dataset) {
                self.dsMensagens = dataset;
                var observer = new IDataSetObserver();
                observer.currentLineChanged = function () {
                    self.mensagenSelecionada = self.dsMensagens.getFieldValue("MSG");
                };

                self.dsMensagens.addObserver(observer);
                self.dsMensagens.init();
            }
            
            function refreshHandlerStadAlone() {
                return _mensagens;
            }

            function exitStep(){
                $wizard.context.dataWizard.opcao = 0;
            }

            function onClickVerFinanceiro() {
                var baixaPanelCtrl = AngularUtil.getControllerFromElement(document.querySelector("sk-baixa-panel"))
                if (angular.isDefined(baixaPanelCtrl)) {
                    baixaPanelCtrl.onClickBotaoVerFinanceiro();
                }
            }

    }]);
angular
    .module("snk.commons").service("CadastroPdvMaquina", ["$q", function($q){

        const self = this;
        let url = 'ws://localhost:9098/cadastroPdv';
        let message = "{\"comando\":\"getPdvMaquina\"}";
        let messageCallbacks = [];
        
        function handleMessage(event) {
            let message = JSON.parse(event.data);
            messageCallbacks.forEach(function (callback) {
                callback(message);
            });
        }


        self.connect = function() {
            self.socket = new WebSocket(url);

            let deferred = $q.defer();
    
            self.socket.onopen = function() {
                deferred.resolve();
            };
    
            self.socket.onerror = function(error) {
                deferred.reject(error);
            };

            self.socket.onmessage = handleMessage;
                
            return deferred.promise;
        };

        self.onMessage = function (callback) {
            messageCallbacks.push(callback);
        }
    
        self.send = function() {
            if (!self.socket) {
                throw new Error("Erro ao conectar ao Web Connection.");
            }
            
            self.socket.send(message);
        };
    
        self.close = function() {
            if (self.socket) {
                self.socket.close();
                messageCallbacks = [];
            }
        };

}]);
angular
	.module('snk.commons')
    .component('skPainelEscolhaTipoPergunta', {
		templateUrl: 'commons/cadastroPergunta/PainelEscolhaTipoPergunta/PainelEscolhaTipoPergunta.tpl.html',
        controller: 'PainelEscolhaTipoPerguntaController',
		controllerAs: 'ctrl',
		bindings: {
			wizard: '=skWizard',
		}
    })
	.controller('PainelEscolhaTipoPerguntaController', ['ObjectUtils', 'Criteria', 'MessageUtils', 'i18n', 'StringUtils', '$scope',
		function (ObjectUtils, Criteria, MessageUtils, i18n, StringUtils, $scope) {
    		
			var self = this;

			self.wizard;

			self.setTipo = setTipo;
			self.doubleClickItem = doubleClickItem;
			
			function setTipo(tipo) {
				if(self.wizard) {
					self.wizard.context.tipo = tipo;
				}
			}

			function doubleClickItem() {
				if(self.wizard) {
					self.wizard.next();
				}
			}

        }]);
angular
    .module('snk.commons')
	.controller('WizardCriacaoPerguntaController', ['$popupInstance', '$scope', 'MessageUtils', 'data', 'i18n',
	 function($popupInstance, $scope, MessageUtils, data, i18n) {
		var self = this;

		var _ehPerguntaTabular;
		
		self._dataset = data.dataset;
		self.grupoTipoValue = data.grupoTipoValue;
		self.doubleClickItem = doubleClickItem;
		
		self.btnProximo = btnProximo;
		self.btnAnterior = btnAnterior;
		self.btnConcluir = btnConcluir;
		self.btnCancelar = btnCancelar;
		self.tipoDePerguntaSelecionada = tipoDePerguntaSelecionada;
		
		self.selectedIndex =0;
		self.selectedViewIndex = 0;
		self.selectedStep = 0;
		
		self.formularioTabular = 1;
		self.formularioComum = 0;
		
		self.permiteAnterior = false;
		self.permiteProximo = true;
		self.permiteConcluir = false;
		
		self.grupoValue;
		self.descricaoValue;
		self.maxLinhasValue;
		self.maxEscolhaValue;
		self.nroTentativasValue;
		self.aceitaObservacaoValue;
		self.pergObrigatoriaValue;
		self.textoCabecalho;
		self._tipo;
		self._tipoAnexo = true;
		
		init();

		function init(){
			inicializaVariaveis();
			self.permiteAnterior = false;
			self.permiteProximo = true;
			self.permiteConcluir = false;
		}

		function doubleClickItem(){
			self.btnProximo();
		}

		function btnConcluir(){
			//Verifica se todos os campos obrigatórios foram preenchidos antes de concluir
			if(!self.descricaoValue == "" && !self.grupoValue == ""){
				if(_ehPerguntaTabular){
					self.maxLinhasValue = 0;
					self.nroTentativasValue = 0;
				}
				else if(!self._tipoAnexo){
					self.maxLinhasValue = 0;
					self.maxEscolhaValue =  0;
					self.nroTentativasValue =  0;
					self.aceitaObservacaoValue = false;
				} 
				else if(self.nroTentativasValue == undefined && self.maxLinhasValue == undefined && self.maxEscolhaValue == undefined){
					self.maxLinhasValue = 0;
					self.maxEscolhaValue =  0;
					self.nroTentativasValue =  0;
					self.aceitaObservacaoValue = false;
				}
			}
			else{
				MessageUtils.showAlert(i18n("mgepesq.CadastroPergunta.ttlAviso"), i18n("mgepesq.CadastroPergunta.msgExistemCamposObg"));
				return false;
			}
			$popupInstance.success(self);
		}

		function btnProximo(){
			if(self._tipo && self.selectedStep == 0){
				self.selectedStep += 1;
				self.permiteAnterior = true;
				self.permiteProximo = false;
				self.permiteConcluir = true;
				self.selectedViewIndex = tipoDePerguntaSelecionada(self._tipo);
			} else if(self.selectedStep == 0){
				MessageUtils.showAlert(i18n("mgepesq.CadastroPergunta.ttlAviso"), i18n("mgepesq.CadastroPergunta.msgSelecioneTipoPerg"));
			}
		}

		function btnAnterior(){
			self.selectedStep -= 1;
			self.permiteAnterior = false;
			self.permiteProximo = true;
			self.permiteConcluir = false;
		}

		function inicializaVariaveis(){
			self.grupoValue = self._dataset.getFieldValue("CODGRUPOPERG");
			self.descricaoValue = self._dataset.getFieldValue("DESCRPERG");
			self.maxLinhasValue = self._dataset.getFieldValue("QTDMAXLINHAS");
			self._tipo = self._dataset.getFieldValue("TIPO");
			self.maxEscolhaValue = (self.grupoTipoValue == "7") ? "0" : self._dataset.getFieldValue("QTDMAXESCOLHAS");
			self.nroTentativasValue = self._dataset.getFieldValue("NROTENTATIVAS");
			self.aceitaObservacaoValue = self._dataset.getFieldValue("ACEITAOBSERVACAO") =='S';
			self.pergObrigatoriaValue = self._dataset.getFieldValue("OBRIGATORIA") =='S';
		}

		function btnCancelar(){
			$scope.$dismiss();
		}

		function tipoDePerguntaSelecionada(tipo) {
			if (tipo == 7 || tipo == 8) {
				self.textoCabecalho = i18n("mgepesq.CadastroPergunta.lblInformTabela");
				self._tipoAnexo = true;
				_ehPerguntaTabular = true;
				return self.formularioTabular;
			} else if (tipo == 9) {
				self.textoCabecalho = i18n("mgepesq.CadastroPergunta.lblInformPergunta");
				self._tipoAnexo = false;
				_ehPerguntaTabular = false;
				return self.formularioComum;
			} else {
				self.textoCabecalho = i18n("mgepesq.CadastroPergunta.lblInformPergunta");
				self._tipoAnexo = true;
				_ehPerguntaTabular = false;
				return self.formularioComum;
			}
		}
	}
]);






angular
    .module('snk.commons')
    .controller('CadastroPerguntaController', ['$scope', '$popupInstance', 'MessageUtils', 'i18n', 'filtro', 'ServiceProxy', 'StringUtils', 'ObjectUtils',
        function ($scope, $popupInstance, MessageUtils, i18n, filtro, ServiceProxy, StringUtils, ObjectUtils) {
            var self = this;

            self.teste = teste;

            function teste() {
                console.log("meu primeiro componente");
            }


        }
    ]);
/**
 * Created by cleverson.puche on 04/11/2016.
 */
angular
	.module('snk.commons')
	.service('CadastroPerguntaService', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;

			self.wizardCriacaoPergunta = wizardCriacaoPergunta;

			function wizardCriacaoPergunta(dataset, grupoTipoValue) {
				return SanPopup.open({
                    title: "Cadastro Pergunta",
					templateUrl: 'commons/cadastroPergunta/WizardCriacaoPergunta/WizardCriacaoPergunta.tpl.html',
                    controller: 'WizardCriacaoPerguntaController',
                    controllerAs: 'ctrl',
                    okBtnLabel: 'Ok',
                    showBtnNo: false,
                    showBtnCancel: false,
					showBtnOk: false,
                    size: 'lg',
                    grayBG: true,
                    resolve: { 	
						data: {
							dataset: dataset,
							grupoTipoValue: grupoTipoValue
						}
					}
                });
			}
		}
    ]);
angular
    .module('snk.commons')
    .controller('CadastroSimplificadoVeiculoController', ['AngularUtil', 'i18n', 'MessageUtils', '$popupInstance', '$scope', 'ObjectUtils', 'MGEParameters',
        function (AngularUtil, i18n, MessageUtils, $popupInstance, $scope, ObjectUtils, MGEParameters) {
            var self = this;

            let _scopePesEmpParc;

            ObjectUtils.implements(self, IDynaformInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);
            
            $scope.$success = selecionarVeiculo;
            
            self.onDynaformLoaded = onDynaformLoaded;
            self.selecionarVeiculo = selecionarVeiculo;
            self.interceptBuildField = interceptBuildField;
            $scope.selecionarVeiculo = selecionarVeiculo;
            self.codVei; 
            
            var _fieldNames = ["TGFVEI.CODVEICULO", "TGFVEI.MARCAPLACA", "TGFVEI.CODMOTORISTA", "TGFVEI.PROPRIO", "TGFVEI.TIPOVEICULO", "TGFVEI.PLACA", "TGFVEI.CODCID", "TGFVEI.CODPARC", "TGFVEI.PESOMAX"];
            
            if (MGEParameters.asBoolean('mge.usar.rateio.por.veiculo')) {
                _fieldNames.push("TGFVEI.AFERICAO", "TGFVEI.TIPOAFERICAO");
            }
            
            function onDynaformLoaded(dynaform, dataset){
            	if(dynaform.getEntityName() == "Veiculo"){
                    self.dsVeiculo = dataset;
                    indexOfdescemp = self.dsVeiculo.getFieldIndexByName('DESCR_EMP_PARC');
            		dynaform.setDynaformHelperData({
                        onlyVisibleFields: _fieldNames
                    });
                    var observer = {};
                    ObjectUtils.implements(observer, IDataSetObserver);

                    observer.currentLineChanged = function (newIndex) {
                        if(!_scopePesEmpParc){
                            return;
                        }
                        changePesquisaParEmp();
                    }
                    
                    dataset.beforePostAction(beforePostActionVeiculo);
                    
                    observer.dataModified = function(fieldName){
						if(fieldName == "AFERICAO"){
							if(self.dsVeiculo.getFieldValueAsString("AFERICAO") == "N"){
								self.dsVeiculo.setFieldValue("TIPOAFERICAO", "N");
							}
						}
                    }

                    dynaform.addFieldPropertyEvaluator('TIPOAFERICAO', 'enabled',function atualizarCampoTipoAfericao(dataset, dynaform) {
                        return self.dsVeiculo.getFieldValueAsString("AFERICAO") != "N";
                    }, 'AFERICAO');

                    self.dsVeiculo.addObserver(observer);
                }
            }
            
            function beforePostActionVeiculo() {
            	
                if (!self.dsVeiculo.getFieldValue('PROPRIO')) {
                	self.dsVeiculo.setFieldValue('PROPRIO', 'N')
                }

            }

            function selecionarVeiculo(){
                var record = self.dsVeiculo.getCurrentRowAsObject();
            	if(record != undefined){
                    $popupInstance.success(
                    		record
                    )
                } else {
                    MessageUtils.showAlert(i18n('Commons.CadastroSimplificadoVeiculo.msgSelectRegister'));
                }
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                if(dataset.getEntityName() == "Veiculo"){
                    if(fieldName == "CODPARC"){
                        fieldProp['sk-description-field-name'] =  'DESCR_EMP_PARC';
                        fieldProp['sk-notify-description-change-to-data-set'] = false;

                        _scopePesEmpParc = scope;

                        fieldProp['sk-entity-name'] = '{{pesEntityName}}';
                        fieldProp['sk-field-name'] = '{{pesFieldName}}';  
                        fieldProp['sk-target-field'] = '{{pesTargetField}}';
                        
                        changePesquisaParEmp();

                        return AngularUtil.createDirective('sk-pesquisa-input', fieldProp, scope);
                    }
                }
            }

            function changePesquisaParEmp() {
                if(!_scopePesEmpParc || !self.dsVeiculo){
                    return;
                }
                if(self.dsVeiculo.getFieldValueAsString("EMPPARC") == 'E'){
                    _scopePesEmpParc.pesEntityName = "Empresa";
                    _scopePesEmpParc.pesFieldName = "CODPARC";
                    _scopePesEmpParc.pesTargetField = "CODEMP";
                }else{
                    _scopePesEmpParc.pesEntityName = "Parceiro";
                    _scopePesEmpParc.pesFieldName = "CODPARC";
                    _scopePesEmpParc.pesTargetField = "CODPARC";
                }
            }

    }]);
angular
    .module('snk.commons')
    .service('CadastroSimplificadoVeiculoService', ['i18n', 'SanPopup',
        function (i18n, SanPopup) {
            var self = this;
            
            self.show = show;
            
            function show(popupInfo){
            	var popupInstance = SanPopup.open({
            		title: i18n('Commons.CadastroSimplificadoVeiculo.popUpCadastroSimplificado'),
            		templateUrl: "commons/cadastroSimplificadoVeiculo/cadastroSimplificadoVeiculo.tpl.html",
            		controller: "CadastroSimplificadoVeiculoController",
            		controllerAs: "ctrl",
            		size: "lg", 
            		okBtnLabel: i18n('Commons.CadastroSimplificadoVeiculo.btnSelecionar'),
            		showBtnOk: angular.isDefined(popupInfo) ? popupInfo.disableSelecionar : true,
            		resolve:{
            			data: popupInfo
            		}
            	});
            	return popupInstance;
            }
    }]);
angular
    .module('snk.commons')
    .controller('ParceiroSimplificadoController', ['$scope', 'dados', 'ServiceProxy', 'i18n', 'SkI18nService', '$popupInstance', 'SkApplicationInstance', 'MessageUtils', 'ObjectUtils', 'MGEParameters', 'Criteria', 'StringUtils', 'AngularUtil', 'ImportadorDadosUtil', 'DateUtils', 'DatasetEvents', 'MGEAuthorizationConstants', 'MGEAuthorizationService',
        function ($scope, dados, ServiceProxy, i18n, SkI18nService, $popupInstance, SkApplicationInstance, MessageUtils, ObjectUtils, MGEParameters, Criteria, StringUtils, AngularUtil, ImportadorDadosUtil, DateUtils, DatasetEvents, MGEAuthorizationConstants, MGEAuthorizationService) {
            var self = this;

            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, IDynaformInterceptor);

            var RESOURCE_ID_PARCEIRO = 'br.com.sankhya.core.cad.parceiros';
            var RESOURCE_ID_PARCEIRO_WEB = 'br.com.sankhya.cad.ParceiroWeb';
            var RESOURCE_ID_POPUP_IMPORTACAO_NFE_PARA_CTE = 'br.com.sankhya.mgecom.selecaodocumento.popupimportacaonfeparacte';
            var _codigoParceiro;
            var _resourceIDTelaPai;
            var _dadosPreCadastroParceiro;
            var _voltouDoServidor;
            var _aceitaCGCCPFBrancoF2;
            var _usaConsCont;
            var _usaIcmsIsentoF2;
            var _bloquearF2;
            var _paramCarregInitTela;
            var _paramIgnoraAcessoParceirof2;
            var _forceRefresh;

            self.resourceID;
            self.onDynaformLoaded = onDynaformLoaded;
            self.otherOptionsLoader = otherOptionsLoader;
            self.interceptBuildField = interceptBuildField;
            self.acceptField = acceptField;
            $scope.$success = usarParceiroClicked;

            init();
            function init() {
                _resourceIDTelaPai = dados.resourceIDTelaPai;
                _dadosPreCadastroParceiro = dados.dadosPreCadastroParceiro;
                _codigoParceiro = dados.codigoParceiro;
                _usaConsCont = MGEParameters.asBoolean("usa.consumidor.contribuinte.parceirof2");
                _usaIcmsIsentoF2 = MGEParameters.asBoolean("usa.classificacaoicms.isento.parceirof2");
                _bloquearF2 =  MGEParameters.asBoolean("inclui.com.credito.bloqueado.parceirof2");
                _aceitaCGCCPFBrancoF2 =  MGEParameters.asBoolean("com.aceita.cgccpf.parceiro.branco.f2");
                _paramCarregInitTela =  MGEParameters.asBoolean("global.carregar.registros.iniciar.tela");
                _paramIgnoraAcessoParceirof2 =  StringUtils.toBoolean(MGEParameters.getValueOrNull("com.ignora.acessos.parceirof2"));
                _voltouDoServidor = true;

                $scope.$enableBtnOk = usarParceiroEnabled();
                self.resourceID = _resourceIDTelaPai + ":br.com.sankhya.commons.parceiro.cadastro.simplificado";
                ServiceProxy.addClientEvent("br.com.sankhya.mgecore.ie.repetida.transportadora", solicitarIERepTransp);

                self.sup = SkApplicationInstance.isSup();
            }

            function onDynaformLoaded(dynaform, dataset) {
                if (dataset.getEntityName() == 'Parceiro'){
                    self.dsParceiro = dataset;

                    configureAuthorization(self.dsParceiro);

                    self.dsParceiro.beforePostAction(function () {
                        beforePost(self.dsParceiro);
                     });

                    //Adicionando observers
                    var obsCadastroParceiro = new IDataSetObserver();
                    obsCadastroParceiro.insertionModeActivated = function () {
                        if(angular.isDefined(self.dsParceiro)) {
                            self.dsParceiro.setFieldValue("DTCAD", DateUtils.getToday());
                            
                            if(dados.isCadSimplMotorista){
                                self.dsParceiro.setFieldValue("MOTORISTA", "S");
                            } else {
                                self.dsParceiro.setFieldValue("CLIENTE", "S");
                            }
                            

                            if (!ObjectUtils.isEmpty(_dadosPreCadastroParceiro)) {
                                if (!StringUtils.isEmpty(_dadosPreCadastroParceiro.InfoParceiro.NOME)) {
                                        self.dsParceiro.setFieldValueAsString("NOMEPARC", _dadosPreCadastroParceiro.InfoParceiro.NOME);
                                }

                                if (!StringUtils.isEmpty(_dadosPreCadastroParceiro.InfoParceiro.CNPJCPF)) {
                                        self.dsParceiro.setFieldValueAsString("CGC_CPF", _dadosPreCadastroParceiro.InfoParceiro.CNPJCPF);
                                }

                                if (!StringUtils.isEmpty(_dadosPreCadastroParceiro.InfoParceiro.TIPOPESSOA)) {
                                        self.dsParceiro.setFieldValueAsString("TIPPESSOA", _dadosPreCadastroParceiro.InfoParceiro.TIPOPESSOA);
                                }

                                if (!StringUtils.isEmpty(_dadosPreCadastroParceiro.InfoParceiro.IE)) {
                                        self.dsParceiro.setFieldValueAsString("IDENTINSCESTAD", _dadosPreCadastroParceiro.InfoParceiro.IE);
                                }

                                if (!StringUtils.isEmpty(_dadosPreCadastroParceiro.InfoParceiro.CIDADE)) {
                                        self.dsParceiro.setFieldValueAsString("CODCID", _dadosPreCadastroParceiro.InfoParceiro.CIDADE);
                                }

                                if (!StringUtils.isEmpty(_dadosPreCadastroParceiro.InfoParceiro.CEP)) {
                                        self.dsParceiro.setFieldValueAsString("CEP", _dadosPreCadastroParceiro.InfoParceiro.CEP);
                                }
                            }
                        }
                        $scope.$enableBtnOk = usarParceiroEnabled();
                    };

                    obsCadastroParceiro.dataModified = function () {
                        $scope.$enableBtnOk = usarParceiroEnabled();
                    };

                    obsCadastroParceiro.dataSaved = function () {
                        $scope.$enableBtnOk = usarParceiroEnabled();
                    };

                    self.dsParceiro.addCriteriaProvider(getCriteria);
                    self.dsParceiro.addObserver(obsCadastroParceiro);
                    self.dsParceiro.addEventListener(DatasetEvents.ON_METADATA_UPDATED, function(evt) {
                        if (angular.isDefined(_dadosPreCadastroParceiro) && _resourceIDTelaPai == RESOURCE_ID_POPUP_IMPORTACAO_NFE_PARA_CTE) {
                            processarXMLDadosPreCadastroParceiro();
                        } else if (_forceRefresh && !_paramCarregInitTela) {
                            self.dsParceiro.refresh();
                            _forceRefresh = false;
                        }
                    });

                    if(self.resourceID != RESOURCE_ID_POPUP_IMPORTACAO_NFE_PARA_CTE){
                        if(angular.isDefined(self.dsParceiro) && self.dsParceiro.isLoaded() && angular.isDefined(_codigoParceiro)){
                            self.dsParceiro.refresh();
                            _forceRefresh = false;
                        } else {
                            _forceRefresh = true;
                        }
                    }
                    processarXMLDadosPreCadastroParceiro();
                }else if(dataset.getEntityName() == "Contato"){
                    self.dsContato = dataset;
                    configureAuthorization(self.dsContato);

                    var cepContato = self.dsContato.getFieldValue("CEP");
                    if (!StringUtils.isEmpty(cepContato) && cepContato.length < 8 ) {
                        MessageUtils.showAlert(SkI18nService.instant('Commons.Parceiro.messageCepInvalido'));
                        return;
                    }
                    return true;
                }


            }

            function usarParceiroEnabled(){
                return (angular.isDefined(self.dsParceiro) && !self.dsParceiro.isInsertionMode());
            }
            
            function getCriteria() {
                var criteria = new Criteria();
                if(!StringUtils.isEmpty(_codigoParceiro)){
                    criteria.append("this.CODPARC = ?", Criteria.buildParameter('N', _codigoParceiro));
                }else{
                    criteria.append("1 = 0");
                }
                return criteria;
            }

            function beforePost(dataset) {
                if(_voltouDoServidor){
                    if(!_usaConsCont && (self.dsParceiro.getFieldValue("CLASSIFICMS") == 'T' || self.dsParceiro.getFieldValue("CLASSIFICMS") == "X")){
                        MessageUtils.showAlert(SkI18nService.instant('Commons.Parceiro.messageInclusaoBarradaTOPouContrib'));
                        return;
                    }
                    
                    if(!_usaIcmsIsentoF2 && self.dsParceiro.getFieldValue("CLASSIFICMS") == "I"){
                        throw Error(SkI18nService.instant('Commons.Parceiro.messageInclusaoBarradaIsento'));
                    }

                    if(self.dsParceiro.getFieldValueAsString("CEP").length < 8 && !StringUtils.isEmpty(self.dsParceiro.getFieldValueAsString("CEP"))) {
                        MessageUtils.showAlert(SkI18nService.instant('Commons.Parceiro.messageCepInvalido'));
                        return;
                    }
                    var cepEndEntrega = self.dsParceiro.getFieldValueAsString("ComplementoParc.CEPENTREGA");
                    if(!StringUtils.isEmpty(cepEndEntrega) && cepEndEntrega.length < 8 ){
                        MessageUtils.showAlert(SkI18nService.instant('Commons.Parceiro.messageCepInvalido'));
                        return;
                    }
                    if(_bloquearF2 && self.dsParceiro.isInsertionMode()){
                        self.dsParceiro.setFieldValueAsString("BLOQUEAR", "S");
                        self.dsParceiro.setFieldValueAsString("MOTBLOQ", SkI18nService.instant('Commons.Parceiro.textCadastroResumido'));
                    }

                    dataset.addTXProperty("br.com.sankhya.commons.parceiro.CadastroParceiroSimplificado", "true");
                    return true;
                }
            }

            function configureAuthorization( ds){
				ds.setCanEdit(false);
				ds.setCanInsert(false);
				if(self.resourceID.includes('CentralNotasPW')){
                    MGEAuthorizationService.loadAuthorization(RESOURCE_ID_PARCEIRO_WEB).then(function(authData) {
                        if(_paramIgnoraAcessoParceirof2){
                            ds.setCanEdit(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE));
                            ds.setCanInsert(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT));
                        }else{
                            ds.setCanEdit(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE) && authData.hasAnyAccess());
                            ds.setCanInsert(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT) && authData.hasAnyAccess());
                        }
                    });
				} else{
                    MGEAuthorizationService.loadAuthorization(RESOURCE_ID_PARCEIRO).then(function(authData) {
                        if(_paramIgnoraAcessoParceirof2){
                            ds.setCanEdit(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE));
                            ds.setCanInsert(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT));
                        } else {
                            ds.setCanEdit(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE) && authData.hasAnyAccess());
                            ds.setCanInsert(authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT) && authData.hasAnyAccess());
                        }
                    });
                }
            }
            
            function processarXMLDadosPreCadastroParceiro() {
                if(angular.isDefined(_dadosPreCadastroParceiro)){
                    if(angular.isDefined(_dadosPreCadastroParceiro.InfoParceiro)){
                        if(self.dsParceiro.isInsertionMode()){
                            self.dsParceiro.cancelEdition();
                        }
                        self.dsParceiro.goToInsertionMode();
                    }
                }
            }

            function otherOptionsLoader() {
                var itensMenu = [
                    {label: SkI18nService.instant('Commons.Parceiro.itemValidarCPF'), action: validaCpfCnpj},
                    {label: SkI18nService.instant('Commons.Parceiro.itemCopiarEndPrincipalEntrega'), action: copiaEnderecoPrincipalParaEnderecoEntrega},
                    {label: SkI18nService.instant('Commons.Parceiro.itemImportarDadosReceitaFederal'), action: itemImportarDadosReceitaFederal},
                    {label: SkI18nService.instant('Commons.Parceiro.itemAtualizarSituacaoCadastralSefaz'), action: atualizaSituacaoCadastroSefaz},
                    {label: SkI18nService.instant('Commons.Parceiro.itemAtualizarSituacaoCadastralRF'), action: atualizaSituacaoCadastroRF},
                    {label: SkI18nService.instant('Commons.Parceiro.itemSuspenderValidacaoSefaz'), action: suspenderValidacaoSefaz},
                    {label: SkI18nService.instant('Commons.Parceiro.itemImportarDadosCadastraisSefaz'), action: importaDadosCadastroSefaz},
                ];

                return itensMenu;
            }
            
            function validaCpfCnpj() {
                var tipoDePessoa;
                if(self.dsParceiro.getFieldValue("TIPPESSOA") == "J"){
                    tipoDePessoa = i18n('Commons.Parceiro.itemDocPessoaJuridica');
                } else{
                    tipoDePessoa = i18n('Commons.Parceiro.itemDocPessoaFisica');
                }

                var cgcCpf = self.dsParceiro.getFieldValue("CGC_CPF");
                var params = {
                    param: {
                        cgcCpf : cgcCpf
                    }
                };
                ServiceProxy.callService("mge@SystemUtilsSP.validadorCpfCnpj", params)
                    .then(function(response){
                        if(response.responseBody.valido.$ == "true"){
                            MessageUtils.showAlert(i18n('Commons.Parceiro.messageDocTipoPessoaValido', [tipoDePessoa]));
                        }else{
                            MessageUtils.showAlert(i18n('Commons.Parceiro.messageDocTipoPessoaInvalido', [tipoDePessoa]));
                        }
                    });
            }
            
            function copiaEnderecoPrincipalParaEnderecoEntrega() {
                self.dsParceiro
                    .setFieldValue("ComplementoParc.CODENDENTREGA", self.dsParceiro.getFieldValue("CODEND"))
                    .setFieldValue("ComplementoParc.NUMENTREGA", self.dsParceiro.getFieldValue("NUMEND"))
                    .setFieldValue("ComplementoParc.COMPLENTREGA", self.dsParceiro.getFieldValue("COMPLEMENTO"))
                    .setFieldValue("ComplementoParc.CODBAIENTREGA", self.dsParceiro.getFieldValue("CODBAI"))
                    .setFieldValue("ComplementoParc.CODCIDENTREGA", self.dsParceiro.getFieldValue("CODCID"))
                    .setFieldValue("ComplementoParc.CEPENTREGA", self.dsParceiro.getFieldValue("CEP"))
                    .save();
            }

            function itemImportarDadosReceitaFederal(){
                ImportadorDadosUtil.importarDadosReceitaFederal(self.dsParceiro);
            }
            
            function atualizaSituacaoCadastroSefaz() {
                ImportadorDadosUtil.atualizaSituacaoCadastroSefaz(self.dsParceiro);
            }
            
            function atualizaSituacaoCadastroRF() {
               ImportadorDadosUtil.atualizaSituacaoCadastroRF(self.dsParceiro);
            }
            
            function suspenderValidacaoSefaz() {
                ImportadorDadosUtil.suspenderValidacaoSefaz(self.dsParceiro);
            }
            
            function importaDadosCadastroSefaz() {
                ImportadorDadosUtil.importaDadosCadastroSefaz(self.dsParceiro);
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                var entityName = dataset.getEntityName();
                if (entityName == 'Parceiro') {
                    if (fieldName == 'CEP') {
                        return montaComponenteCep("", "", dataset, fieldProp, scope);
                    } else if (fieldName == 'ComplementoParc.CEPTRAB') {
                        return montaComponenteCep("ComplementoParc.", "TRAB", dataset, fieldProp, scope);
                    } else if (fieldName == 'ComplementoParc.CEPENTREGA') {
                        return montaComponenteCep("ComplementoParc.", "ENTREGA", dataset, fieldProp, scope);
                    } else if (fieldName == 'ComplementoParc.CEPRECEB') {
                        return montaComponenteCep("ComplementoParc.", "RECEB", dataset, fieldProp, scope);
                    }else if(fieldName == 'CGC_CPF') {
                        if(_voltouDoServidor && !_aceitaCGCCPFBrancoF2){
                            fieldProp['sk-required'] = true;
                        }
                    }
                }
                if (entityName == 'Contato') {
                    if (fieldName == 'CEP') {
                        return montaComponenteCep("", "", dataset, fieldProp, scope);
                    }
                }
            }
            
            function acceptField(fieldMetadata, dataset) {
                if( ('ComplementoParc.NROCNH' == fieldMetadata.name) 
                    || ('ComplementoParc.CATEGORIACNH' == fieldMetadata.name) 
                    || ('ComplementoParc.VENCIMENTOCNH' == fieldMetadata.name) 
                    || ('MOTORISTA' == fieldMetadata.name)) {
                    return dados.isCadSimplMotorista === true;
                }
                return true;
            };

            function montaComponenteCep(entity, complementoField, dataset, fieldProp, scope) {
                var fieldCep = entity + "CEP" + complementoField;
                var fieldCodCid = entity + "CODCID" + complementoField;
                var fieldCodEnd = entity + "CODEND" + complementoField;
                var fieldCodBai = entity + "CODBAI" + complementoField;

                var fieldNumEnd = entity + (complementoField == "" ? "NUMEND" : "NUM") + complementoField;

                fieldProp['sk-field-name'] = entity + "CEP" + complementoField;

                fieldProp['sk-intercept-address-info'] = 'interceptAddressInfo';
                scope.interceptAddressInfo = function (addressInfo) {
                    addressInfo.CODCID = dataset.getFieldValueAsString(fieldCodCid);
                    addressInfo.CODEND = dataset.getFieldValueAsString(fieldCodEnd);
                    addressInfo.NUMEND = dataset.getFieldValueAsString(fieldNumEnd);
                };

                scope.codsAddressBind = {CIDADE: fieldCodCid, BAIRRO: fieldCodBai, ENDERECO: fieldCodEnd};

                fieldProp['sk-cods-address-bind'] = 'codsAddressBind';

                return AngularUtil.createDirective('sk-cep-input', fieldProp, scope);
            }
            
            function usarParceiroClicked() {
                if(angular.isDefined(self.dsParceiro)){
                    var codParc = self.dsParceiro.getFieldValue("CODPARC");
                    var nomeParc = self.dsParceiro.getFieldValue("NOMEPARC");
                    var response = {
                        codParc : codParc,
                        nomeParc : nomeParc
                    };
                    $popupInstance.success(response);
                }
            }

            function solicitarIERepTransp(clientEvent, serviceRecaller) { 
            	var params = angular.copy(serviceRecaller.params);
            	MessageUtils.simpleConfirm(
                    MessageUtils.TITLE_CONFIRMATION,
                    i18n('Commons.Parceiro.msgPermiteRepetirIE', [clientEvent.event.message]))
                    .then(function () {
	                    var txProperties = {};
						txProperties['pode.repetir.ie.transp'] = true;
						params.txProperties = txProperties;
                        serviceRecaller.reCall(params);
                    });
            }

    }]);

/**
 * Created by Italo Araujo on 25/01/2020.
 *
 * Exemplo:
 * 	 var dadosPreCadastroParceiro = {
 * 	     InfoParceiro : {
 * 	         NOME: 'Teste',
 * 	         CNPJCPF: '000.000.000-00',
 * 	         TIPOPESSOA : 'J',
 * 	         IE : '000000',
 * 	         CIDADE : '1',
 * 	         CEP: '38400-00'
 * 	     }
 * 	 };
 *
 *   var data = {
 *   			resourceIDTelaPai : resourceID,
 *   			codigoParceiro : codParc,
 *   			dadosPreCadastroParceiro : dadosPreCadastroParceiro
 *   };
 *
 *   CadastroParceiroSimplificadoService.show(data)
 *   	.result.then(function (response) {
 *   });
 */
angular
	.module('snk.commons')
	.service('CadastroParceiroSimplificadoService', ['SanPopup', 'SkI18nService',
		function (SanPopup, SkI18nService) {
			var self = this;

			self.show = show;

			function show(popupInfo) {
				var popupInstance = SanPopup.open({
						title: SkI18nService.instant('Cadastro Simplificado de parceiros'),
						templateUrl: 'commons/cadastroparceirosimplificado/cadastro-parceiro-simplificado.tpl.html',
						controller: 'ParceiroSimplificadoController',
						controllerAs: 'ctrl',
						size: 'lg',
						height: 550,
						showBtnCancel: true,
						showBtnOk: angular.isDefined(popupInfo) && angular.isDefined(popupInfo.disableSelecionar) ? popupInfo.disableSelecionar : true,
						showBtnNo: false,
						okBtnLabel: 'Selecionar parceiro',
						resolve: {
							dados: popupInfo
						}
					});
				return popupInstance;
			}

		}
    ]);

/**
 * @ngdoc service
 * @name snk.commons:ImportadorDadosUtil
 *
 * @description
 * Esse serviço permite chamar funçoes utilizadas na importação de dados do parceiro
 */
angular
	.module("snk.commons")
	.service("ImportadorDadosUtil", ['StringUtils', 'i18n', 'ServiceProxy', 'MessageUtils', 'DateUtils', 'PopUpParameter', 'DateUtilsConstants', 'DataImporter', 'ObjectUtils',
		function(StringUtils, i18n, ServiceProxy, MessageUtils, DateUtils, PopUpParameter, DateUtilsConstants, DataImporter, ObjectUtils){
			var self = this;

			self.atualizaSituacaoCadastroSefaz = atualizaSituacaoCadastroSefaz;
			self.suspenderValidacaoSefaz = suspenderValidacaoSefaz;
			self.atualizaSituacaoCadastroRF = atualizaSituacaoCadastroRF;
			self.importaDadosCadastroSefaz = importaDadosCadastroSefaz;
			self.importarDadosReceitaFederal = importarDadosReceitaFederal;

			function atualizaSituacaoCadastroSefaz(ds) {
				if (validaParceiroSalvo(ds)) {
					ServiceProxy.callService('ParceiroSP.atualizaSituacaoCadastroSefaz', {
						param: {
							codParc: ds.getFieldValueAsString('CODPARC')
						}
					}).then(function (result) {
						var dadosCadastro = result.responseBody.dadosCadastro;
						var situacao = dadosCadastro.situacao;
						var sitSuframa = dadosCadastro.sitSuframa;
						var motivo = dadosCadastro.motivo;
						var status = dadosCadastro.status;
						var msg = undefined;

						msg = i18n('Commons.Parceiro.messageSitAtualizada');
						if (StringUtils.isNotEmpty(situacao)) {
							msg = msg + i18n('Commons.Parceiro.messageSitSefaz', [situacao == 0 ? i18n('Commons.Parceiro.parcNaoHabilitado') : i18n('Commons.Parceiro.parcHabilitado')]);
						} else {
							if (StringUtils.isNotEmpty(motivo)) {
								if (StringUtils.isEmpty(status)) {
									msg = msg + i18n('Commons.Parceiro.messageUfNaoPossuiServico', [motivo]);
								} else {
									msg = msg + i18n('Commons.Parceiro.messageSitNaoAtualizada', [status, motivo]);
								}
							}
						}

						msg = msg + '<br><br>' + i18n('Commons.Parceiro.messageSitSuframa'); //Resulado da consulta na no suframa

						if (sitSuframa == "1") {
							msg = msg + i18n('Commons.Parceiro.sitSuframaBloqueado'); //Bloqueado
						} else if (sitSuframa == "2") {
							msg = msg + i18n('Commons.Parceiro.parcHabilitado'); //Habilitado
						} else {
							msg = msg + i18n('Commons.Parceiro.sitSugramaNaoEncontrado'); //Não encontrado nos arquivos da Sefaz
						}

						MessageUtils.showInfo(msg);

						ds.refreshCurrentRow();
					});
				}
			}

			function suspenderValidacaoSefaz(ds) {
				if (ds.getCurrentIndex() == -1) {
					MessageUtils.showAlert(i18n('Commons.Parceiro.msgSelecioneParceiro'));
				} else {
					var parameters = [
						{
							description: i18n('Commons.Parceiro.lblDataSefaz'),
							name: "data",
							type: "D", //tipo data
							value: DateUtils.add(DateUtils.getToday(), 30),
							required: true
						}
					];

					var options = { size: 'sm', title: i18n('Commons.Parceiro.titleAlterarSefaz') };

					PopUpParameter.openPopUp(parameters, options).result.then(function (result) {
						var dataSefaz = result.data;
						var parceiro = ds.getFieldValueAsString('CODPARC');

						if (DateUtils.diffWithToday(dataSefaz) < 1) {
							MessageUtils.showAlert(i18n('Commons.Parceiro.msgDataMaiorAtual'));
						} else {
							ServiceProxy.callService('ParceiroSP.suspenderValidacaoSefaz', {
								param: {
									data: DateUtils.formatDate(dataSefaz, DateUtilsConstants.DEFAULT_DATE_FORMAT),
									codParc: parceiro
								}
							});
						}
					});
				}
			}

			function atualizaSituacaoCadastroRF(ds) {
				if (validaParceiroSalvo(ds)) {
					ServiceProxy.callService('ParceiroSP.atualizaSituacaoCadastroRF', {
						param: {
							codParc: ds.getFieldValueAsString('CODPARC')
						}
					}).then(function (result) {
						var dadosCadastro = result.responseBody.dadosCadastro;
						var situacao = dadosCadastro.situacao;
						var sitSuframa = dadosCadastro.sitSuframa;
						var motivo = dadosCadastro.motivo;
						var status = dadosCadastro.status;
						var msg = null;
						msg = i18n('Commons.Parceiro.messageSitRFAtualizada');
						if (situacao === '1') {
							msg = msg + i18n('Commons.Parceiro.messageSitRF', [i18n('Commons.Parceiro.parcHabilitado')]);
						} else {
							msg = msg + i18n('Commons.Parceiro.messageSitRF', [i18n('Commons.Parceiro.parcNaoHabilitado')]);
							if (!StringUtils.undefinedAsEmpty(motivo)) {
								if (StringUtils.undefinedAsEmpty(status)) {
									msg = msg + i18n('Commons.Parceiro.messageUfNaoPossuiServico', [motivo]);
								} else {
									msg = msg + i18n('Commons.Parceiro.messageSitNaoAtualizada', [status, motivo]);
								}
							}
						}
						MessageUtils.showInfo(msg);
					});
				}
			}
			
			function importaDadosCadastroSefaz(ds) {
				DataImporter.open(ds, {
					serviceName: 'mge@ParceiroSP.importarDadosParceiroToJson',
					loadFieldsParam: {fonteDados: 'SF'},
					fieldsFilter: ['CGC_CPF', 'UF', 'IDENTINSCESTAD'],
					customFieldsFilter: [{userType: 'S', name: 'UF', description: 'UF'}],
					fieldsFilterInterceptor: function(fields) {
						if (!ds.isInsertionMode()) {
							var codParc = ds.getFieldValueAsNumber('CODPARC');

							if (codParc) {
								fields.push({CODPARC: codParc});
							}
						}

						fields.unshift({FONTE_DADOS: 'SF'});
					},
					afterInitializeFilters: function(dsBase, dsFilter, dsImport) {
						var codCid = dsBase.getFieldValueAsNumber('CODCID');

						if (codCid) {
							ServiceProxy.callService('ParceiroSP.getUFCidade', {
								codigoCidade: {
									'$': dsBase.getFieldValueAsNumber('CODCID')
								}
							}).then(function (response) {
								dsFilter.setFieldValue('UF', ObjectUtils.getProperty(response, 'responseBody.UF.$'));
								dsImport.refresh();
							});
						}
					},
					interceptImportFormField: function(fieldMD) {
						fieldMD.required = false;

						if (fieldMD.fieldName == "DHCADSEFAZ") {
							fieldMD.visible = false;
						}
					},
					beforeConfirm: function(dsBase, dsImport) {
					    if (dsBase.getCurrentIndex() > -1) {
						    dsBase.setFieldValue('COMPLEMENTO', undefined);
						}
					},
					title: i18n('Commons.Parceiro.itemImportarDadosSefaz'),
					height: 410
				});
			}
			
			function importarDadosReceitaFederal(ds) {
				DataImporter.open(ds, {
					serviceName: 'mge@ParceiroSP.importarDadosParceiroToJson',
					loadFieldsParam: {fonteDados: 'RF'},
					fieldsFilter: ['CGC_CPF'],
					fieldsFilterInterceptor: function(fields) {
						if (!ds.isInsertionMode()) {
							var codParc = ds.getFieldValueAsNumber('CODPARC');

							if (codParc) {
								fields.push({CODPARC: codParc});
							}
						}

						fields.unshift({FONTE_DADOS: 'RF'});
					},
					interceptFilterFormField: function(fieldMD) {
						if (fieldMD.fieldName == "CGC_CPF") {
							fieldMD.description = i18n('Commons.Parceiro.itemDocPessoaJuridica');
						}
					},
					beforeConfirm: function(dsBase, dsImport) {
                        if (dsBase.getCurrentIndex() > -1) {
							console.log('importa dados RF')
                            dsBase.setFieldValue('COMPLEMENTO', undefined);
						}
					},
					title: i18n('Commons.Parceiro.itemImportarDadosReceitaFederal'),
					height: 410
				});
			}

			function validaParceiroSalvo(ds) {
				if (ds.isInsertionMode() || ds.isRecordDirty()) {
					MessageUtils.showError(i18n('Commons.Parceiro.salvarRegistroParaImportar'));
					return false;
				}
				return true;
			}

		}]);

angular.module("snk.commons").service("CentralNotaLauncher", [
  "SkApplicationInstance",
  "StringUtils",
  "TipoCentralNota",
  function (SkApplicationInstance, StringUtils, TipoCentralNota) {
    var self = this;

    self.RESOURCEID = "br.com.sankhya.com.mov.CentralNotas";
    self.RESOURCEID_PW = "br.com.sankhya.com.mov.CentralNotasPW";

    self.launch = launch;
    self.isGroupedCentral = isGroupedCentral;

    function launch(pk, agruparCentrais = true, resourceID = null) {
      var customResourceID = resourceID != null;

      if (!resourceID && (StringUtils.toBoolean(pk.ehPedidoW) || StringUtils.toBoolean(pk.EHPEDIDOW))) {
        resourceID = self.RESOURCEID_PW;
      }

      if (!resourceID) {
        resourceID = self.RESOURCEID;
      }

      var tipMov = pk.TIPMOV;

      if (!customResourceID) {
        if (agruparCentrais && !StringUtils.isEmpty(tipMov)) {
          resourceID += TipoCentralNota.getByTipMov(tipMov).suffix;
        } else if (pk != null && pk.NUNOTA) {
          resourceID += "_" + pk["NUNOTA"];
        }
      }

      pk.forceNewHash = new Date().getTime();

      SkApplicationInstance.openApp(resourceID, pk);
    }

    function isGroupedCentral(resourceID) {
      var options = [
        TipoCentralNota.TIPO_VENDA,
        TipoCentralNota.TIPO_COMPRA,
        TipoCentralNota.TIPO_MOV_INTERNA,
      ];

      for (var tipo of options) {
        if (StringUtils.endsWith(resourceID, String(tipo.suffix))) {
          return true;
        }
      }

      return false;
    }
  },
]);

angular
	.module("snk.commons")
	.service("TipMovUtil", ['i18n',
	  function (i18n) {
	    var self = this;
	    
	    self.TIPOS_MOVIMENTOS = {
    		/*-------------------------------------*/
            /*Lista completa de tipos de movimentos*/
            /*-------------------------------------*/
			P: i18n('Comercial.TipoMovUtil.itemPedidoVenda'),	     /* P->Pedido de venda                  */
			O: i18n('Comercial.TipoMovUtil.itemPedidoCompra'),       /* O->Pedido de compra                 */
			V: i18n('Comercial.TipoMovUtil.itemNotaVenda'),          /* V->Nota de venda                    */
			C: i18n('Comercial.TipoMovUtil.itemNotaCompra'),         /* C->Nota de compra                   */
			D: i18n('Comercial.TipoMovUtil.itemDevolucaoVenda'),     /* D->Devolução de venda               */
			E: i18n('Comercial.TipoMovUtil.itemDevolucaoCompra'),    /* E->Devolução de compra              */
			T: i18n('Comercial.TipoMovUtil.itemTransferencia'),      /* T->Transferência                    */
			J: i18n('Comercial.TipoMovUtil.itemPedidoRequisicao'),   /* J->Pedido de requisição             */
			Q: i18n('Comercial.TipoMovUtil.itemRequisicao'),         /* Q->Requisição                       */
			L: i18n('Comercial.TipoMovUtil.itemDevolucaoRequisicao'),/* L->Devolução de requisição          */
			F: i18n('Comercial.TipoMovUtil.itemProducao'),           /* F->Produção                         */
			I: i18n('Comercial.TipoMovUtil.itemFinanceiro'),         /* I->Financeiro                       */
			R: i18n('Comercial.TipoMovUtil.itemRecebimento'),        /* R->Recebimento                      */
			G: i18n('Comercial.TipoMovUtil.itemPagamento'),          /* G->Pagamento                        */
			B: i18n('Comercial.TipoMovUtil.itemMovimentoBancario'),  /* B->Movimento bancário               */
		    														 /* K->Pedido de transferência          */
		    														 /* M->Devolução de transf              */
			N: i18n('Comercial.TipoMovUtil.itemEntradas'),  		 /* N->Entradas						    */
			1: i18n('Comercial.TipoMovUtil.itemNFDeposito'),         /* 1->NF Depósito                      */
			2: i18n('Comercial.TipoMovUtil.itemPedidoDevolucao'),    /* 2->PD Devol. / Procuração / Warrant */
			3: i18n('Comercial.TipoMovUtil.itemSaidas'),  		     /* 3->Saídas                           */
			4: i18n('Comercial.TipoMovUtil.itemFaturamento'), 	     /* 4->Faturamento                      */
			8: i18n('Comercial.TipoMovUtil.itemPedidoArmazenagem'),  /* 8->RD8                              */
			A: i18n('Comercial.TipoMovUtil.itemCTe')				 /* A->CTE (Virtual)                    */
		};
	    
	    self.getDescription = getDescription;
	    self.getVirtualTipMov = getVirtualTipMov;
	    
	    function getDescription(dsCabecalhoNota) {
			return self.TIPOS_MOVIMENTOS[getVirtualTipMov(dsCabecalhoNota)];
		}

		function getVirtualTipMov(dsCabecalhoNota) {
			var tipMov = dsCabecalhoNota.getFieldValueAsString("TIPMOV");
	
			if (tipMov == "V") {
				var codModDoc = dsCabecalhoNota.getFieldValueAsNumber("TipoOperacao.CODMODDOC");
	
				if (codModDoc == 57 || codModDoc == 8){
					tipMov = "A";
				}
			}
	
			return tipMov;
		}
	  }
]);

angular.module("snk.commons").service("TipoCentralNota", [
  function () {
    var self = this;

    self.TIPO_VENDA = {
      suffix: "_VENDA",
    };

    self.TIPO_COMPRA = {
      suffix: "_COMPRA",
    };

    self.TIPO_MOV_INTERNA = {
      suffix: "_MOVINTERNA",
    };

    self.TIPO_PRODUCAO = {
      suffix: "_PRODUCAO",
    };

    self.TIPO_ARMAZEM = {
      suffix: "_ARMAZEM",
    };


    self.TIPOS_BY_TIPMOV = {
      P: self.TIPO_VENDA,
      V: self.TIPO_VENDA,
      D: self.TIPO_VENDA,
      A: self.TIPO_VENDA,
      O: self.TIPO_COMPRA,
      C: self.TIPO_COMPRA,
      E: self.TIPO_COMPRA,
      H: self.TIPO_COMPRA,
      F: self.TIPO_PRODUCAO,
      T: self.TIPO_MOV_INTERNA,
      J: self.TIPO_MOV_INTERNA,
      Q: self.TIPO_MOV_INTERNA,
      L: self.TIPO_MOV_INTERNA,
      I: self.TIPO_MOV_INTERNA,
      R: self.TIPO_MOV_INTERNA,
      G: self.TIPO_MOV_INTERNA,
      B: self.TIPO_MOV_INTERNA,
      8: self.TIPO_ARMAZEM,
      N: self.TIPO_ARMAZEM,
      1: self.TIPO_ARMAZEM,
      2: self.TIPO_ARMAZEM,
      3: self.TIPO_ARMAZEM,
      4: self.TIPO_ARMAZEM
    };

    self.getByTipMov = function (tipMov) {
      if (self.TIPOS_BY_TIPMOV[tipMov]) {
        return self.TIPOS_BY_TIPMOV[tipMov];
      } else {
        return self.TIPO_VENDA;
      }
    };
  },
]);

angular.module("snk.commons").controller("CMC7PanelController", [
  "i18n",
  "cmc7PanelInfo",
  "ServiceProxy",
  "MessageUtils",
  "StringUtils",
  "NumberUtils",
  "$scope",
  "Criteria",
  "ObjectUtils",
  "ArrayUtils",
  "$popupInstance",
  "DateUtils",
  "$timeout",
  "TabNavigatorHelper",
  function(
    i18n,
    cmc7PanelInfo,
    ServiceProxy,
    MessageUtils,
    StringUtils,
    NumberUtils,
    $scope,
    Criteria,
    ObjectUtils,
    ArrayUtils,
    $popupInstance,
    DateUtils,
    $timeout,
    TabNavigatorHelper
  ) {
    var self = this;
    ObjectUtils.implements(self, IDataSetObserver);
    $scope.$success = validateFields;

    //Variaveis ------------------------------------------------------------------------------------------------------

    self.txtComp = "000";
    self.txtBanco = "000";
    self.txtAgencia = "0000";
    self.txtDigAgencia = "0";
    self.txtC1 = "0";
    self.txtConta = "0000000000";
    self.txtC2 = "0";
    self.txtCheque = "000000";
    self.txtC3 = "0";

    self.onDatasetCreatedStandAlone = onDatasetCreatedStandAlone;
    self.onDatagridLoaded = onDatagridLoaded;
    self.changeCheckEmitenteEhParceiro = changeCheckEmitenteEhParceiro;
    self.gerarBanda = gerarBanda;
    self.validarBanda = validarBanda;
    self.changeCMC73 = changeCMC73;
    self.focusOutComp = focusOutComp;
    self.focusOutBanco = focusOutBanco;
    self.focusOutAgencia = focusOutAgencia;
    self.focusOutConta = focusOutConta;
    self.focusOutCheque = focusOutCheque;
    self.nextFocus = nextFocus;
    //----------------------------------------------------------------------------------------------------------------

    //Opcoes do combobox Tipos de Cheques ----------------------------------------------------------------------------
    self.opcoesComboTipo = [
      { data: "5", value: i18n("Commons.CMC7.labelNormal") },
      { data: "6", value: i18n("Commons.CMC7.labelBancario") },
      { data: "7", value: i18n("Commons.CMC7.labelSalario") },
      { data: "8", value: i18n("Commons.CMC7.labelAdmin") },
      { data: "9", value: i18n("Commons.CMC7.labelCPMF") }
    ];
    self.comboTipo = 5;

    self.opcoesComboPrefixo = [];

    self._ehPopUpDaBaixa = cmc7PanelInfo.dataValue.ehPopUpBaixa != undefined;
    self._ehPopUpMovimentacaoFinan =
      cmc7PanelInfo.dataValue.ehPopUpMovimentacaoFinan != undefined;
    self._dtCheque = cmc7PanelInfo.dataValue.dataCheque;
    self._codParc = cmc7PanelInfo.dataValue.codParc;
    self._vlrCheque = cmc7PanelInfo.dataValue.vlrCheque;
    self._usaRastreabilidadeCheque =
      cmc7PanelInfo.dataValue.usaRastreabilidadeCheque;
    self._vlrChequeEnabled = cmc7PanelInfo.isPdvWeb ? false : true;
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    init();

    function init() {
      self.vlrCheque = self._vlrCheque;
      self.dtCheque = self._dtCheque;

      $timeout( () => {
        $popupInstance.rendered.then(()=>{
          TabNavigatorHelper.getPopUpNavigationPath($popupInstance.element[0], "#campoComp");
        });

        let campo = document.getElementById('campoComp');
        if(campo){
          campo.children[0].focus();
          campo.children[0].select();
        }
      }, 1500);
    }
    //----------------------------------------------------------------------------------------------------------------

    //Criar dataset --------------------------------------------------------------------------------------------------
    function onDatasetCreatedStandAlone(dataset) {
      var observer = new IDataSetObserver();
      observer.refreshed = refreshedObserver;
      
      self.dsPrefixoCheque = dataset;
      self.dsPrefixoCheque.addObserver(observer);
      self.dsPrefixoCheque.init();
    }

    function refreshedObserver() {
      if (ArrayUtils.isNotEmpty(self.dsPrefixoCheque.getRecordsAsObjects())) {
        const dataProviderCombo = [];
        self.dsPrefixoCheque.getRecordsAsObjects().forEach(item => {
          var descricao = item.DESCRICAO;
          if (StringUtils.emptyAsNull(item.PREFIXO)) {
            descricao += " - " + item.PREFIXO;
          }

          dataProviderCombo.push({ banco: item.CODBCO, descricao: descricao, prefixo: item.PREFIXO })
        });
        const prefixoZero = dataProviderCombo.filter(item => item.prefixo === '00');
        self.comboPrefixo = prefixoZero.length > 0 ? prefixoZero[0].prefixo 
          : dataProviderCombo.length > 0 && angular.isDefined(dataProviderCombo[0].prefixo) 
          ? dataProviderCombo[0].prefixo : null;
        self.opcoesComboPrefixo = dataProviderCombo;
      }
    }
    //----------------------------------------------------------------------------------------------------------------

    //Carregar grid --------------------------------------------------------------------------------------------------
    function onDatagridLoaded(datagrid) {
      self.dataGrid = datagrid;
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function changeCheckEmitenteEhParceiro() {
      if (self.checkEmitenteEhParceiro == "S") {
        if (isNaN(self._codParc)) {
          MessageUtils.showError(
            MessageUtils.TITLE_ERROR,
            i18n("Commons.CMC7.messageFaltaParceiro")
          );
          self.checkEmitenteEhParceiro = "N";
        } else {
          getDadosParceiro();
        }
      } else {
        carregaDadosEmitente();
      }
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function getDadosParceiro() {
      if (isNaN(self._codParc)) {
        self.txtEmitente = "";
        self.txtCpf = "";
      } else {
        params = {
          entity: {
            name: "Parceiro",
            criterio: {
              nome: "CODPARC",
              valor: self._codParc
            },
            fields: {
              field: [
                {
                  name: "NOMEPARC"
                },
                {
                  name: "CGC_CPF"
                }
              ]
            }
          }
        };
        ServiceProxy.callService("mge@crud.find", params, true).then(function(
          result
        ) {
          var parceiro = result.responseBody.entidades.entidade;

          self.txtEmitente = parceiro.NOMEPARC.$;
          self.txtCpf = parceiro.CGC_CPF.$;
        });
      }
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function carregaDadosEmitente() {
      params = {
        param: {
          agencia: self.txtAgencia2,
          banco: self.txtBanco2,
          conta: self.txtConta2
        }
      };
      ServiceProxy.callService(
        "mge@Cmc7SP.getDadosEmitente",
        params,
        true
      ).then(function(result) {
        self.txtCpf = StringUtils.undefinedAsEmpty(result.responseBody.cpf);
        self.txtEmitente = StringUtils.undefinedAsEmpty(
          result.responseBody.nomeEmitente
        );

        self.txtCpfEnabled = self.txtCpf == "";
        self.txtEmitenteEnabled = self.txtEmitente == "";

        if (!self.txtEmitenteEnabled) {
          self.txtEmitenteEnabled =
            StringUtils.undefinedAsEmpty(
              result.responseBody.podeAlterarEmitente
            ) == "S";
        }

        if (!self.txtCpfEnabled) {
          self.txtCpfEnabled =
            StringUtils.undefinedAsEmpty(
              result.responseBody.podeAlterarEmitente
            ) == "S";
        }

        if (self.txtEmitenteEnabled) {
          if (self.checkEmitenteEhParceiro == "S") {
            getDadosParceiro();
          }
        } else {
          self.checkEmitenteEhParceiro == "N";
        }
      });
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function gerarBanda() {
      var prefixo = "";

      //Banco Brasil ou Santander ou Itaú
      if (
        self.txtBanco == "001" ||
        self.txtBanco == "409" ||
        self.txtBanco == "237" ||
        self.txtBanco == "033" ||
        self.txtBanco == "341"
      ) {
        prefixo = self.comboPrefixo;

        if (isNaN(prefixo)) {
          MessageUtils.showError(
            MessageUtils.TITLE_ERROR,
            i18n("Commons.CMC7.messageErroGerarBandaPrefixoCheque")
          );
          return;
        }

        if (prefixo.length == 1) {
          prefixo = "0" + prefixo;
        }
      }

      if (
        self.txtComp == "" ||
        self.txtBanco == "" ||
        self.txtAgencia == "" ||
        self.txtConta == "" ||
        self.txtCheque == ""
      ) {
        MessageUtils.showError(
          MessageUtils.TITLE_ERROR,
          i18n("Commons.CMC7.messageErroGerarBandaCampos")
        );
        return;
      }

      params = {
        param: {
          banco: self.txtBanco,
          agencia: self.txtAgencia,
          comp: self.txtComp,
          cheque: self.txtCheque,
          conta: self.txtConta,
          tipo: self.comboTipo,
          prefixo: prefixo
        }
      };

      ServiceProxy.callService("mge@Cmc7SP.getCmc7", params, true).then(
        function(result) {
          self.txtBanda = result.responseBody.cmc7;

          self.txtBandaConf1 = self.txtBanda.substr(21, 3);
          self.txtBandaConf2 = self.txtBanda.substr(24, 8);
          self.txtBandaConf3 = self.txtBanda.substr(32, 1);

          self.formItemConferir = true;
        }
      );
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function validarBanda() {
      if (StringUtils.nullAsEmpty(self.txtBanda) == '') {
        MessageUtils.showError(
          MessageUtils.TITLE_ERROR,
          i18n("Commons.CMC7.messageErroValidarBanda")
        );
        return;
      }

      params = {
        param: {
          banda: self.txtBanda,
          tipo: self.comboTipo
        }
      };

      ServiceProxy.callService(
        "mge@Cmc7SP.getValuesAndValidBanda",
        params,
        true
      ).then(function(result) {
        if(angular.isDefined(result.responseBody.banda)){
          self.txtComp2 = StringUtils.undefinedAsEmpty(
            result.responseBody.banda.comp
          );
          self.txtBanco2 = StringUtils.undefinedAsEmpty(
            result.responseBody.banda.banco
          );
          self.txtAgencia2 = StringUtils.undefinedAsEmpty(
            result.responseBody.banda.agencia
          );
          self.txtConta2 = StringUtils.undefinedAsEmpty(
            result.responseBody.banda.conta
          );
          self.txtCheque2 = StringUtils.undefinedAsEmpty(
            result.responseBody.banda.cheque
          );
          self.txtBanda2 = StringUtils.undefinedAsEmpty(
            result.responseBody.banda.banda
          );
        }

        if (self.txtBanda2 == "") {
          self.txtBanda2 = i18n("Commons.CMC7.labelBandaMagneticaInvalida");
          self.txtCpf = "";
          self.txtEmitente = "";

          self._strCmc7 = "";

          if (self.checkEmitenteEhParceiro == "S") {
            getDadosParceiro();
          }
        } else {
          carregaDadosEmitente();
          self._strCmc7 = self.txtBanda2;
        }
      });
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function validateFields() {
      if (self._ehPopUpDaBaixa) {
        if (self._ehPopUpMovimentacaoFinan && NumberUtils.getNumberOrZero(self.txtBanco) == 0 && NumberUtils.getNumberOrZero(self.txtBanco2) == 0) {
          MessageUtils.showError(
            MessageUtils.TITLE_ERROR,
            i18n("Commons.CMC7.messageBancoZero")
          );
          return false;
        }
      }

      if (angular.isUndefined(self._strCmc7) || self._strCmc7 == "") {
        MessageUtils.showError(
          MessageUtils.TITLE_ERROR,
          i18n("Commons.CMC7.messageBandaInvalida")
        );
        return false;
      }

      if (self._ehPopUpDaBaixa) {
        if (angular.isUndefined(self.vlrCheque) || self.vlrCheque <= 0) {
          MessageUtils.showError(
            MessageUtils.TITLE_ERROR,
            i18n("Commons.CMC7.messageChequeMenorIgualZero")
          );
          return false;
        }
      }

      dataValue = {
        value: {
          numCheque: self.txtCheque2,
          vlrCheque: self.vlrCheque,
          dataCheque: typeof self.dtCheque == 'string' ? self.dtCheque : DateUtils.dateToString(self.dtCheque),
          strCMC7: self._strCmc7,
          codBcoCMC7: self.txtBanco2,
          agenciaCMC7: self.txtAgencia2,
          contaCMC7: self.txtConta2,
          cgcCpfCMC7: self.txtCpf,
          nomeEmitenteCMC7: self.txtEmitente,
          salvarContaCliente: salvarContaCliente,
          usaRastreabilidadeCheque: self._usaRastreabilidadeCheque
        }
      };
//      cmc7PanelInfo.eventBus.dispatchEvent();
//      dispatchEvent(new Event("CMC7_CONCLUIDO", dataValue));
      $popupInstance.success(dataValue);
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function salvarContaCliente(callBack = undefined) {
      if (self.txtEmitente != "") {
        var params = {
          param: {
            agencia: self.txtAgencia2,
            conta: self.txtConta2,
            banco: self.txtBanco2,
            nomeEmitente: self.txtEmitente,
            cpfCgc: self.txtCpf
          }
        };
        ServiceProxy.callService(
          "mge@Cmc7SP.salvaContaClinte",
          params,
          true
        ).then(function(result) {
          if (callBack != undefined) {
            callBack();
            $popupInstance.dismiss();
          }
        });
      } else {
        if (callBack != undefined) {
          callBack();
          $popupInstance.dismiss();
        }
      }
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function divsLinha(ID, numerosCalculo) {
      var params = {
        param: {
          numerosCalculo: numerosCalculo
        }
      };
      ServiceProxy.callService("mge@Cmc7SP.getDigito", params, true).then(
        function(result) {
          if (ID == "txtC1") {
            self.txtC1 = result.responseBody.digito;
          } else if (ID == "txtC2") {
            self.txtC2 = result.responseBody.digito;
          } else if (ID == "txtC3") {
            self.txtC3 = result.responseBody.digito;
          }
        }
      );
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function changeCMC73() {
      if (angular.isDefined(self.txtCMC73) && self.txtCMC73.length == 12) {
        self.txtBanda =
          "<" + self.txtCMC71 + "<" + self.txtCMC72 + ">" + self.txtCMC73 + ":";
        validarBanda();
      }
    }

    function nextFocus(campo){
      var input = document.getElementById(campo);

        if (input) {
            setTimeout(function() { 
                input.firstChild.focus();
                input.firstChild.select();
           }, 10);
        }
    }

    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function focusOutComp() {
      self.txtComp = StringUtils.stringZero(self.txtComp, 3);
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function focusOutBanco() {
      self.txtBanco = StringUtils.stringZero(self.txtBanco, 3);
      if (self.txtBanco !== self.txtBanco2) {
        resetFields();
      }
      self.dsPrefixoCheque.refresh(Criteria(" this.CODBCO = ? ", Criteria.buildNumberParameter(self.txtBanco)));
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function focusOutAgencia() {
      self.txtAgencia = StringUtils.stringZero(self.txtAgencia, 4);

      if (self.txtBanco == "") {
        MessageUtils.showError(
          MessageUtils.TITLE_ERROR,
          i18n("Commons.CMC7.messageErroDigitoVerificador")
        );
        return;
      }

      var params = {
        param: {
          agencia: self.txtAgencia,
          banco: self.txtBanco
        }
      };

      ServiceProxy.callService(
        "mge@Cmc7SP.getDigitoModulo11",
        params,
        true
      ).then(function(result) {
        self.txtDigAgencia = result.responseBody.digito;
      });

      divsLinha("txtC1", self.txtComp + self.txtBanco + self.txtAgencia);
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function focusOutConta() {
      self.txtConta = StringUtils.stringZero(self.txtConta, 10);
      divsLinha("txtC2", self.txtConta);
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function focusOutCheque() {
      self.txtCheque = StringUtils.stringZero(self.txtCheque, 6);
      divsLinha("txtC3", self.txtCheque);
    }
    //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    function resetFields() {
      self.formItemConferir = false;
      self.txtBanda = "";
      self.txtBandaConf1 = "";
      self.txtBandaConf2 = "";
      self.txtBandaConf3 = "";
      self.txtComp2 = "";
      self.txtBanco2 = "";
      self.txtAgencia2 = "";
      self.txtConta2 = "";
      self.txtCheque2 = "";
      self.txtBanda2 = "";
      self.txtEmitente = "";
      self.txtCpf = "";
      self._strCmc7 = "";
      self.txtCpfEnabled = self.txtCpf == "";
      self.txtEmitenteEnabled = self.txtEmitente == "";
      self.comboPrefixo = null;
      self.opcoesComboPrefixo = [];
    }
    //----------------------------------------------------------------------------------------------------------------
  }
]);

/**
 * Created by vinicius.fernandes on 08/01/2020.
 */

angular.module("snk.commons").service("CMC7PanelService", [
  "SanPopup",
  "SkI18nService",
  function(SanPopup, SkI18nService) {
    var self = this;

    self.openPopUp = openPopUp;

    function openPopUp(popupInfo) {
      return SanPopup.open({
        title: SkI18nService.instant(popupInfo?.dataValue?.titlePopup ?? "Financeiro.MovimentacaoFinanceira.titleValidaBandaCMC7"),                                                            
        templateUrl: "commons/cmc7/cmc7panel.tpl.html",
        controller: "CMC7PanelController",
        controllerAs: "ctrl",
        size: "lg",
        showBtnNo: false,
        enableBtnOk: true,
        resolve: {
          cmc7PanelInfo: popupInfo
        }
      }).result;
    }
  }
]);

angular
    .module('snk.commons.coletorConferenciaLayout')
    .component('skColetorConferenciaLayout', {
    	templateUrl: 'commons/coletorConferenciaLayout/coletor-conferencia-layout.tpl.html',
        controller: 'ColetorConferenciaLayoutController',
        controllerAs: 'ctrl',
        bindings: {
        	fieldPresentation: '=skFieldPresentation',
        	srcData: '=skSrcData',
        	srcDataDest: '=skSrcDataDest',
        	presFieldVariables: '=skPresFieldVariables',
        	srcDataOrd: '=skSrcDataOrd',
        	srcDataOrdDest: '=skSrcDataOrdDest',
        	srcUseOrd: '=skUseOrd',
        	onChange: '&skChange'
        }
    })
    .controller('ColetorConferenciaLayoutController', ['DatasetEvents', 'StringUtils', '$scope', 'i18n', 'SkApplicationInstance', 'ObjectUtils', 'DatasetObserverEvents', '$q','SanPopup','MGEParameters','ArrayUtils',
        function (DatasetEvents, StringUtils, $scope, i18n, SkApplicationInstance, ObjectUtils, DatasetObserverEvents, $q,SanPopup, MGEParameters,ArrayUtils) {
    		
    		var self = this;
    		
    		self.fireEvent = fireEvent;
    		self.onMoveItem = onMoveItem;
	        self.srcFilterFn = srcFilterFn;
	        self.destFilterFn = destFilterFn;
	        self.openPresentationFieldBuilder = openPresentationFieldBuilder;
	        
	        function onMoveItem(item, listName) {
	        	fireEvent();
	        }
	        
	        function srcFilterFn(item, searchTerm) {
	            return basicSearch(item, searchTerm);
	        }
	        
	        function destFilterFn(item, searchTerm) {
	            return basicSearch(item, searchTerm);
	        }
	        
	        function basicSearch(item, searchTerm) {
	            if(StringUtils.isEmpty(searchTerm)) {
	                return true;
	            }
	            
	            var containsRE = new RegExp(searchTerm,'i');
	            
	            var match = containsRE.test(item.description);
	            return match;
	        }
	        
	        function fireEvent() {
	        	if ($scope.ctrl.onChange) {
	        		$scope.ctrl.onChange();
	        	}
	        }
	        
	        function openPresentationFieldBuilder() {
                SanPopup.open({
                  title: i18n('Comercial.ConfiguracaoColetorConferencia.lblCampoApresentacao'),
                  templateUrl: i18n('commons/construtornomearquivo/construtornomepopup.tpl.html'),
                  controller: 'ConstrutorNomeController',
                  controllerAs: 'ctrl',
                  showBtnNo: false,
                  okBtnLabel: i18n('Geral.buttonOK'),
                  noBtnLabel: i18n('Geral.buttonCancelar'),
                  height: 330,
                  resolve: {
                    data: {
                      nomeArquivo: self.fieldPresentation,
					  variaveis: self.presFieldVariables,
					  visibleResumo : false
                    }
                  }
                }).result.then(function (fieldPresentation) {
                	self.fieldPresentation = fieldPresentation;
                	fireEvent();
                });
            }
        }]);

angular
    .module('snk.commons.coletorConferenciaLayout')
    .controller('SkTypeSelectColetorController', ['$scope', '$timeout', '$element', 'ObjectUtils', 'StringUtils', 'AngularUtil',
        function($scope, $timeout, $element, ObjectUtils, StringUtils, AngularUtil) {
            var self = this;
            
            $scope.internalDivId = StringUtils.nextUid();
            $scope.internaldUlId = StringUtils.nextUid();

            $scope.adjustDropdownLeft = adjustDropdownLeft;
            $scope.processChange = processChange;
            $scope.getGeneralLabel = getGeneralLabel;

            init();

            function init() {
            	setButtonColor();
                ObjectUtils.implements(self, FieldBinder, {
                    scope: $scope,
                    setFocus: setFocus,
                    setEnabled: setEnabled,
                    highlightField: function() {},
                    unHighlightField: function() {}
                });
                
                $scope.$watch('dataProvider', function(newVal,oldVal) {
                	setButtonColor();
                });
            }

            function setEnabled(value) {
            }

            function setFocus() {
                $element.find('button').focus();
            }

            function adjustDropdownLeft() {
                var ulElem = angular.element(document.getElementById($scope.internaldUlId));
                if (ulElem.length > 0) {
                    ulElem.css('visibility','hidden');
                    $timeout(function () {
                        var typeSelectElem = angular.element($element.find('#' + $scope.internalDivId));
                        if (typeSelectElem.length > 0) {
                            ulElem.css('left', (ulElem[0].offsetLeft - typeSelectElem[0].offsetLeft) + 'px');
                            $timeout(function() {
                                ulElem.css('visibility','visible');
                            }, 0, false);
                        }
                    }, 0, false);
                }
            }

            function processChange(id, value, changeFn) {
            	setButtonColor();
                AngularUtil.apply($scope,function() {
                    changeFn(id, value);
                });
            }

            function getGeneralLabel() {
                var label = '';
                for(var i = 0, length = $scope.dataProvider.length; i < length; i++) {
                    if($scope.dataProvider[i].value === true) {
                        if(label != '') {
                            label += ', ' + $scope.dataProvider[i].label;
                        } else {
                            label += $scope.dataProvider[i].label;
                        }
                    }
                }
                return label;
            }
            
            function hasActiveFilter() {
            	var active = false;
            	$scope.dataProvider.forEach(function(item, index, array){
            		if (item.value === true) {
            			active = true;
            		}
            	});
            	
            	return active;
            }
            
            function setButtonColor() {
                if ($scope.dataProvider.length > 0 && hasActiveFilter()) {
                	$scope.buttonColor = 'btn-danger';
                } else if ($scope.btnDefault === true && !hasActiveFilter()) {
                	$scope.buttonColor = 'btn-default';
                } else {
                	$scope.buttonColor = 'btn-primary';
                }
            }
            
        }
    ])
/**
 * Created by cleverson.puche on 11/05/2016.
 */

angular
    .module('snk.commons.coletorConferenciaLayout')
    .directive('skTypeSelectColetor',[function() {
        return {
            restrict: 'E',
            templateUrl: 'commons/coletorConferenciaLayout/typeSelectColetor/type-select-coletor.tpl.html',
            controller: 'SkTypeSelectColetorController',
            scope: {
                dataProvider: '=skDataProvider',
                enabled: '=skEnabled'
            }
        }
    }]);
angular
    .module("snk.commons").service("ComunicaBalancaService", ["$q", function($q){

        const self = this;
        let url = 'ws://localhost:9098/balanca/pesagem';
        let message = "{\"comando\":\"getpesoV2\"}";
        let messageCallbacks = [];
        
        function handleMessage(event) {
            let message = JSON.parse(event.data);
            messageCallbacks.forEach(function (callback) {
                callback(message);
            });
        }


        self.connect = function() {
            self.socket = new WebSocket(url);

            let deferred = $q.defer();
    
            self.socket.onopen = function() {
                deferred.resolve();
            };
    
            self.socket.onerror = function(error) {
                deferred.reject(error);
            };

            self.socket.onmessage = handleMessage;
                
            return deferred.promise;
        };

        self.onMessage = function (callback) {
            messageCallbacks.push(callback);
        }
    
        self.send = function() {
            if (!self.socket) {
                throw new Error("Erro de conexão com a balança.");
            }
            
            self.socket.send(message);
        };
    
        self.close = function() {
            if (self.socket) {
                self.socket.close();
                messageCallbacks = [];
            }
        };

}]);
angular.module("snk.commons").provider("ComunicacaoEquipamentoFiscalService", function () {

    let url = 'ws://localhost:9098/sat';
    let message = "{\"params\":\"params\"}";
    let messageCallbacks = [];
    let params = null;
    // Defina a função de manipulação de mensagem
    function handleMessage(event) {
        let message = JSON.parse(event.data);
        messageCallbacks.forEach(function (callback) {
            callback(message);
        });
    }

    this.$get = ["$q", function ($q) {
        const self = this;

        self.connect = function () {
            self.socket = new WebSocket(url);

            let deferred = $q.defer();

            self.socket.onopen = function () {
                deferred.resolve();
            };

            self.socket.onerror = function (error) {
                deferred.reject(error);
            };

            self.socket.onmessage = handleMessage;

            return deferred.promise;
        };

        self.adicionarParams = function(novosParams) {
            params = novosParams;
        };

        self.onMessage = function (callback) {
            messageCallbacks.push(callback);
        };

        self.send = function () {
            if (!self.socket) {
                throw new Error("Erro ao conectar ao Web Connection.");
            }

            if (params) {
                message = `{"params": ${JSON.stringify(params)}}`;
    
                // Limpa os parâmetros após adicioná-los à mensagem, se desejado
                params = null;
            }

            self.socket.send(message);
        };

        self.close = function () {
            if (self.socket) {
                self.socket.close();
                messageCallbacks = [];
            }
        };

        return self;
    }];
});

angular
    .module('snk.commons.config')
    .controller('ConfigUsuarioController', ['$scope', '$popupInstance', 'data', 'ServiceProxy', 'FormService', 'StringUtils', 'NumberUtils', 'i18n', 'applicationInstance',
    function($scope, $popupInstance, data, ServiceProxy, FormService, StringUtils, NumberUtils, i18n, applicationInstance) {
        var self = this;
        var _parametros = {};
        const FIELDS_UPDATE_TO_EMPTY = "CODCTABCOINT";

        //verificar se tem integração com o E-Connect
        const INTEGRACAO_ECONECT_SOCIN = "30676";
        var _temIntegracaoEConectSocin = true;
         
        if(applicationInstance.temOpcional(INTEGRACAO_ECONECT_SOCIN)){
            _temIntegracaoEConectSocin = true;
        }else _temIntegracaoEConectSocin = false
        
        self.formProperties = [
            {fieldName: 'CODPARC', description: i18n('Core.CadastroUsuarios.lblParceiroParaF2'), type: 'ENTITY', fieldProp: {'sk-entity-name': 'Parceiro', 'autofocus': ''}},
            {fieldName: 'CODLOCAL', description: i18n('Core.CadastroUsuarios.lblLocalPadraoPedidosNotas'), type: 'ENTITY', fieldProp: {'sk-entity-name': 'LocalFinanceiro', 'sk-allow-show-hierarchical-mode': 'true'}},
            {fieldName: 'DIASLANCFUTUROS', description: i18n('Core.CadastroUsuarios.lblDiasLancamentosFuturos'), type: 'I'},
            {fieldName: 'DIASRETROBAIXA', description: i18n('Core.CadastroUsuarios.lblDiasRetroacaoBaixa'), type: 'I'},
            {fieldName: 'CODCTABCOINT', description: i18n('Core.CadastroUsuarios.lblNumeroContaPadraoBaixa'), type: 'ENTITY', fieldProp: {'sk-entity-name': 'ContaBancaria'}},
            {fieldName: 'LOGICO', description: i18n('Core.CadastroUsuarios.lblConfigUsuarioLogico'), type: 'O', isCheckbox: true},
            {fieldName: 'RESTRINGEDADOS', description: i18n('Core.CadastroUsuarios.lblRestrigeDadosParcModuloOs'), type: 'O', isCheckbox: true},
        ];

        if(_temIntegracaoEConectSocin){
            self.formProperties.push({fieldName: 'CTASANGSUPRI', description: i18n('Core.CadastroUsuarios.lblConfigUsuarioSangSupri'),type: 'ENTITY', fieldProp: {'sk-entity-name': 'ContaBancaria'}},);
        }
        self.formValues = {
            'CODPARC': '',
            'CODLOCAL': '',
            'DIASLANCFUTUROS': '',
            'DIASRETROBAIXA': '',
            'RESTRINGEDADOS': '',
            'CODCTABCOINT': '',
            'LOGICO': '',
            'CTASANGSUPRI': ''
        };

        $scope.$success = saveConfig;

        init();

        function init() {
            loadParameters();
        }

        function loadParameters() {
            var request = {
                params: {
                    codUsu: data.codUsuario,
                    param: [
                        {name: 'PARCF2'},
                        {name: 'DIASFUTURO'},
                        {name: 'DIASRETROACAO'},
                        {name: 'LOCALPADRAO'},
                        {name: 'CONTAPADRAO'},
                        {name: 'RESTINFOPARC'}
                    ]
                }
            };
            
            if(_temIntegracaoEConectSocin){
                request.params.param.push({name: "CTASANGSUPRI"});
            }


            ServiceProxy
                .callService('mge@ManutencaoPreferenciasSP.getParametros', request)
                .then(function(response) {
                    var params = response.responseBody.params.param;
                    var len = params.length;
                    var param;

                    for (var i = 0; i < len; i++) {
                        param = params[i];

                        _parametros[param.key] = param;
                    }

                    updateValueView('PARCF2', 'CODPARC');
                    updateValueView('DIASFUTURO', 'DIASLANCFUTUROS');
                    updateValueView('DIASRETROACAO', 'DIASRETROBAIXA');
                    updateValueView('LOCALPADRAO', 'CODLOCAL');
                    updateValueView('CONTAPADRAO', 'CODCTABCOINT');
                    updateLogicView('CONTAPADRAO', 'LOGICO');
                    updateLogicView('RESTINFOPARC', 'RESTRINGEDADOS');
                    updateValueView('CTASANGSUPRI', 'CTASANGSUPRI');
                });
        }

        function updateValueView(paramName, fieldName) {
            var value = _parametros[paramName].defaultValue;

            var valueEmpty = StringUtils.isEmpty(value);
            if((value == "0" || valueEmpty) && FIELDS_UPDATE_TO_EMPTY.indexOf(fieldName) > -1){
                value = "";
            } else if (StringUtils.isEmpty(value)) {
                value = "0";     
            } 

            if(fieldName=="CTASANGSUPRI" && value == "0"){
                value = "";
            }
            self.formValues[fieldName] = value;
        }

        function updateLogicView(paramName, fieldName) {
            var logic = _parametros[paramName].logico == 'S' ? 'S' : 'N';
            self.formValues[fieldName] = logic;
        }

        function saveConfig() {
            var entityElem;
            var entityElems = [];
            var request = {
                entity: entityElems
            };

            entityElem = buildJsonParm('PARCF2');
            entityElem.campo.push({nome: 'INTEIRO', '$': NumberUtils.getNumberOrZero(self.formValues['CODPARC'])});
            entityElems.push(entityElem);

            entityElem = buildJsonParm('DIASFUTURO');
            entityElem.campo.push({nome: 'INTEIRO', '$': NumberUtils.getNumberOrZero(self.formValues['DIASLANCFUTUROS'])});
            entityElems.push(entityElem);

            entityElem = buildJsonParm('DIASRETROACAO');
            entityElem.campo.push({nome: 'INTEIRO', '$': NumberUtils.getNumberOrZero(self.formValues['DIASRETROBAIXA'])});
            entityElems.push(entityElem);

            entityElem = buildJsonParm('LOCALPADRAO');
            entityElem.campo.push({nome: 'INTEIRO', '$': NumberUtils.getNumberOrZero(self.formValues['CODLOCAL'])});
            entityElems.push(entityElem);

            entityElem = buildJsonParm('CONTAPADRAO');
            entityElem.campo.push({nome: 'INTEIRO', '$': NumberUtils.getNumberOrZero(self.formValues['CODCTABCOINT'])});
            entityElem.campo.push({nome: 'LOGICO', '$': self.formValues['LOGICO']});
            entityElems.push(entityElem);

            entityElem = buildJsonParm('RESTINFOPARC');
            entityElem.campo.push({nome: 'LOGICO', '$': self.formValues['RESTRINGEDADOS']});
            entityElems.push(entityElem);

            if(_temIntegracaoEConectSocin){
                entityElem = buildJsonParm('CTASANGSUPRI');
                entityElem.campo.push({nome: 'INTEIRO', '$': NumberUtils.getNumberOrZero(self.formValues['CTASANGSUPRI'])});
                entityElems.push(entityElem);
            }

            ServiceProxy
                .callService('mge@crud.save',  request)
                .then(function(){
                    $popupInstance.success();
                });
        }

        function buildJsonParm(paramName) {
            var paramElem = _parametros[paramName];
            var param = {
                name: 'ParametroSistema',
                campo: [
                    {nome: 'CHAVE', '$': paramElem.key},
                    {nome: 'DESCRICAO', '$': paramElem.nodeName},
                    {nome: 'CODUSU', '$': data.codUsuario},
                    {nome: 'TIPO', '$': paramElem.type},
                    {nome: 'MODULO', '$': paramElem.module},
                    {nome: 'CLASSE', '$': paramElem.classe},
                    {nome: 'ABA', '$': paramElem.aba},
                ],
                key: {
                    'CHAVE': {
                        '$': paramElem.key
                    },
                    'CODUSU': {
                        '$': data.codUsuario
                    }
                }
            };

            return param;
        }
    }]);
angular
    .module('snk.commons.config')
    .controller('CopyConfigUserController', ['$popupInstance', 'data', 'MessageUtils', 'SkApplicationInstance', 'ServiceProxy', 'i18n', function($popupInstance, data, MessageUtils, SkApplicationInstance, ServiceProxy, i18n) {
        var self = this;

        self.wizardData = {
            codUsuarioBase: data.codUsuarioBase
        };

        self.desabilitaSelecaoTelas = desabilitaSelecaoTelas;
        self.onCancel = onCancel;
        self.onFinish = onFinish;

        function onCancel() {
            $popupInstance.dismiss('canceled');
        }

        function onFinish(step) {
            if (self.wizardData.MANTER_CONFIG == 'N') {
                MessageUtils
                    .confirm(i18n('Core.CadastroUsuarios.msgApagaConfigExistente'))
                    .then(function(){
                        copiarConfiguracoes();
                    });
            } else {
                copiarConfiguracoes();
            }
        }

        function copiarConfiguracoes() {
            var usuariosDestino = [];
            var resourceIDs = [];
            var param = {
                CODUSUORIGEM: self.wizardData.codUsuarioBase,
                RESOURCEID: SkApplicationInstance.getResourceID(),
                USARUSULOGADO: false,
                MANTERCONFIG: self.wizardData.MANTER_CONFIG,
                INCLUIABASEGURANCA: self.wizardData.INCLUI_ABA_SEGURANCA,
                SELECAOTELASINDIVIDUAIS: self.wizardData.SELECAO_TELAS_INDIVIDUAIS,
                INCLUICONFIGURACOESTOP: self.wizardData.INCLUI_CONFIGURACOES_TOP,
                COPIARRESTRICOESTOP: self.wizardData.COPIAR_RESTRICOES_TOP,
                COPIAREXCECOESTOP: self.wizardData.COPIAR_EXCECOES_TOP,
                usuariosDestino: {
                    CODUSU: usuariosDestino
                },
                resourceIDs: {
                    resourceID: resourceIDs
                }
            };

            var item;

            for (var i = 0; i < self.wizardData.USUARIOS_SELECIONADOS.length; i++) {
                item = self.wizardData.USUARIOS_SELECIONADOS[i];

                usuariosDestino.push({'$': item.CODUSU['$']});
            }

            var resourceIdSelecionados = self.wizardData.RESOURCEID_SELECIONADOS;
            if(angular.isDefined(resourceIdSelecionados)){
                for (var i = 0, len = resourceIdSelecionados.length; i < len; i++) {
                    item = self.wizardData.RESOURCEID_SELECIONADOS[i];

                    resourceIDs.push({'$': item.resourceID});
                }
            }

            if (self.wizardData.TIPO_CONFIG) {
                param.TIPOCOPIA = self.wizardData.TIPO_CONFIG;
            }

            ServiceProxy
                .callService('mge@UsuarioSP.copiarConfiguracoes', {'param': param})
                .then(function(){
                    MessageUtils
                        .showInfo(i18n('Core.CadastroUsuarios.msgConfigSalvoSucesso'))
                        .then(function() {
                            $popupInstance.success();
                        }, function() {
                            $popupInstance.success();
                        });
                });
        }

        function desabilitaSelecaoTelas() {
            if (angular.isUndefined(self.wizardData.SELECAO_TELAS_INDIVIDUAIS) || self.wizardData.SELECAO_TELAS_INDIVIDUAIS == 'N') {
                return true;
            }

            return false;
        }
    }]);

angular
.module('snk.commons.config')
.service('CopiarPersUsuPopUp', [
    'SanPopup', 'i18n',
    function(SanPopup, i18n) {
        var self = this;

        self.open = open;

        function open(resourceID, codUsuarioBase) {
            return SanPopup.open({
                title: i18n('Geral.copiarConfig'),
                templateUrl: 'commons/config/copiarConfigUsuario.tpl.html',
                controller: 'CopyConfigUserController',
                controllerAs: 'ctrl',
                size: 'lg',
                showBtnOk: false,
                showBtnCancel: false,
                showBtnNo: false,
                height: 560,
                resolve: {
                    data: {
                        codUsuarioBase: codUsuarioBase,
                        resourceID: resourceID
                    }
                }
            });
        }

    }
])


angular
    .module('snk.commons.config')
    .controller('StepSelecionaConfigController', ['$wizard', '$step', 'StringUtils', function($wizard, $step, StringUtils){
        var self = this;
        var _firstEnter = true;

        self.form = {};
        self.isSUP = false;
        self.enableCheckAbaSeguranca = false;
        self.enableCopiarRest = false;
        self.enableCopiarExc = false;
        self.enableCheckSelecionarTelas = false;
        self.validacoesRadioGroup = validacoesRadioGroup;
        self.validaCheckRestricaoExcecao = validaCheckRestricaoExcecao;
        self.validateBtnNext = validateBtnNext;
        self.validaCheckConfTop = validaCheckConfTop;
        self.chkSelecionaTelasChange = chkSelecionaTelasChange;

        $step.onEnterStep = onEnterStep;
        $step.onExitStep = onExitStep;

        function onEnterStep() {
        	//OS 3319805 - Não verificar usuário SUP (self.isSUP = false). Comportamento igual ao FLEX
            //self.isSUP = $wizard.context.codUsuarioBase == '0';

            if (self.isSUP) {
                self.form.tipoCopia = 'P';
                self.isSUP = true;
            }

            if (_firstEnter) {
                self.enableCheckSelecionarTelas = self.isSUP;
                _firstEnter = false;
            } else {
                validaCheckSelecionarTelas();
            }

            validateBtnNext();
        }

        function onExitStep() {
            $wizard.context.TIPO_CONFIG = self.form.tipoCopia;
            $wizard.context.MANTER_CONFIG = StringUtils.isEmpty(self.form.addInfoExistente) ? 'S' : self.form.addInfoExistente;
            $wizard.context.INCLUI_ABA_SEGURANCA = self.form.checkAbaSeguranca;
            $wizard.context.SELECAO_TELAS_INDIVIDUAIS = self.form.checkSelecionarTelas;
            $wizard.context.INCLUI_CONFIGURACOES_TOP = self.form.checkConfigTOP;
            $wizard.context.COPIAR_RESTRICOES_TOP = self.form.checkCopiarRest;
            $wizard.context.COPIAR_EXCECOES_TOP = self.form.checkCopiarExc;
        }

        function chkSelecionaTelasChange() {
            $wizard.context.SELECAO_TELAS_INDIVIDUAIS = self.form.checkSelecionarTelas;
        }

        function validacoesRadioGroup() {
            if (self.form.tipoCopia == 'P') {
                self.enableCheckAbaSeguranca = false;
                self.form.checkAbaSeguranca = 'N';
            } else {
                self.enableCheckAbaSeguranca = true;
            }

            validateBtnNext();
            validaCheckSelecionarTelas();
        }

        function validateBtnNext() {
            var enableNext = false;

            if((StringUtils.isNotEmpty(self.form.tipoCopia) && StringUtils.isNotEmpty(self.form.addInfoExistente) && self.form.checkConfigTOP == 'N') || 
                (self.form.checkConfigTOP == 'S' && self.form.checkCopiarRest == 'S' && StringUtils.isNotEmpty(self.form.addInfoExistente)) || 
                (self.form.checkConfigTOP == 'S' && self.form.checkCopiarExc == 'S' && StringUtils.isNotEmpty(self.form.addInfoExistente))){
                enableNext = true;
            }

            $step.setCanNext(enableNext);
        }

        function validaCheckRestricaoExcecao() {
            validateBtnNext();
        }

        function validaCheckSelecionarTelas() {
            if ('P' == self.form.tipoCopia || 'A' == self.form.tipoCopia || 'TODAS' == self.form.tipoCopia) {
                self.enableCheckSelecionarTelas = true;
            } else {
                self.enableCheckSelecionarTelas = false;
            }
        }

        function validaCheckConfTop() {
            validateBtnNext();

            if (self.form.checkConfigTOP == 'S') {
                self.enableCopiarRest = true;
                self.enableCopiarExc = true;		
            } else {
                self.form.checkCopiarRest = 'N';
                self.form.checkCopiarExc = 'N';

                self.enableCopiarRest = false;
                self.enableCopiarExc = false;
            }
        }
    }]);
angular
    .module('snk.commons.config')
    .controller('StepSelecionaTelasController', ['$wizard', '$step', 'ServiceProxy', function($wizard, $step, ServiceProxy){
        var self = this;

        self.telasProvider;
        self.selecionadosProvider = [];
        self.treeCtrl = {};
        self.getLabelDest = getLabelDest;
        self.onSelectItem = onSelectItem;

        $step.onExitStep = onExitStep;

        init();

        function init() {
            var request = {
                criteria: {
                    menuacesses: false,
                    showFavoritos: false,
                    itemMenuName: 'children'
                }
            };

            ServiceProxy
                .callService('mge@MenuSP.getXMLMenu', request)
                .then(function(result) {
                    self.telasProvider = result.responseBody.menu.children;
                });
        }

        function onExitStep() {
            $wizard.context.RESOURCEID_SELECIONADOS = self.selecionadosProvider;
        }

        function validateBtnNext() {
            $step.setCanNext(self.selecionadosProvider.length > 0);
        }

        function getLabelDest(item) {
            var itemDescr = item.label;
            var parentBranch = self.treeCtrl.get_parent_branch(item);
    
            if (parentBranch) {
                itemDescr = parentBranch.label + ' -> ' + itemDescr;
            }

            return itemDescr;
        }

        function searchFilterFn(item, search) {
            var containsRE = new RegExp(search,'i');
            return containsRE.test(item.label);
        }

        function onSelectItem() {
            validateBtnNext();
        }
    }]);
angular
    .module('snk.commons.config')
    .controller('StepSelecionaUsuarioController', ['$scope', '$wizard', 'ServiceProxy', '$step', function($scope, $wizard, ServiceProxy, $step) {
        var self = this;

        self.srcUserData;
        self.destUserData = [];
        self.searchFilterFn = searchFilterFn;
        self.onSelectItem = onSelectItem;

        $step.onExitStep = onExitStep;

        init();

        function init() {
            $step.setCanNext(false);

            var codUsuBase = angular.isDefined($wizard.context.codUsuarioBase) ? $wizard.context.codUsuarioBase : '';
            var request = {
                criterio: {
                   CODUSUBASE: codUsuBase
                }
            };

            ServiceProxy
                .callService('mge@UsuarioSP.getUsuarios', request)
                .then(function(result) {
                    self.srcUserData = result.responseBody.usuarios.usuario;
                });
        }

        function onExitStep() {
            $wizard.context.USUARIOS_SELECIONADOS = self.destUserData;
        }

        function searchFilterFn(item, search) {
            var containsRE = new RegExp(search,'i');
            var match = containsRE.test(item.CODUSU['$']) || containsRE.test(item.NOMEUSU['$']);

            return match;
        }

        function onSelectItem() {
            $step.setCanNext(self.destUserData.length > 0);
        }
    }]);
angular
    .module('snk.commons')
    .controller('ConstrutorNomeController', ['ObjectUtils', 'StringUtils', 'data', '$scope', '$popupInstance', 'SkI18nService', 'ServiceProxy', 'MessageUtils', 'DateUtils', 'i18n', 
        function (ObjectUtils, StringUtils, data, $scope, $popupInstance, SkI18nService, ServiceProxy, MessageUtils, DateUtils, i18n) {
        
        var self = this;

        $scope.$success = confirmar;
        $scope.$dismiss = cancelar;

        var _textAreaExpressao;

        self.variaveis = data.variaveis;
        self.nomeArquivo = data.nomeArquivo;
        self.resumoVariavel;
        self.visibleResumoVariavel = data.visibleResumo != undefined ? data.visibleResumo : true;
        self.titVariaveis = i18n('Commons.Expressoes.lblVariaveis');
        self.titExpressao = i18n('Commons.Expressoes.lblExpressao');

        self.textAreaCreated = textAreaCreated;
        self.adicionarVariavel = adicionarVariavel;
        self.visualizarResumoVariavel = visualizarResumoVariavel;
        self.compararVariavel = compararVariavel;

        function textAreaCreated(comp) {
            _textAreaExpressao = comp;
        }

        function confirmar() {
            $popupInstance.success(self.nomeArquivo);
        }

        function cancelar() {
            $popupInstance.dismiss('cancel');
        }

        function adicionarVariavel(variavel) {
            if (_textAreaExpressao) {
                var range = _textAreaExpressao.getSelectionRange();
				var selectionBegin = range.start;
				var selectionEnd = range.end;
                var texto = StringUtils.undefinedAsEmpty(self.nomeArquivo);

				var startToken = texto.substring(0, selectionBegin);
				var endToken = texto.substring(selectionEnd);
				
				self.nomeArquivo = startToken + variavel + endToken;
            }
        }

        function visualizarResumoVariavel(variavel) {
            self.resumoVariavel = variavel.descricao;
        }

        function compararVariavel(actual, expected) {
            if (StringUtils.isEmpty(expected)) {
                return true;
            } else if (ObjectUtils.isEmpty(actual) || StringUtils.isEmpty(actual.nome)) {
                return false;
            }

            var nomeVariavel = actual.nome.toUpperCase();
            var texto = expected.toUpperCase();

            var accents = ['[AÁÀÂÃ]', '[EÉÈÊ]', '[IÍÌÎ]', '[OÓÒÔÕ]', '[UÚÙÛ]', '[CÇ]'];

            accents.forEach(function (accent) {
                nomeVariavel = nomeVariavel.replace(new RegExp(accent, 'gi'), accent.charAt(1));
                texto = texto.replace(new RegExp(accent, 'gi'), accent.charAt(1));
            });

            return nomeVariavel.search(texto) > -1;
        }

    }]);
angular
    .module('snk.commons')
    .controller('containerLiberacaoLimitesController', ['SkConstants', 'PopUpGadgetsService', 'SkApplication', '$scope', 'ServiceProxy', 'AngularUtil', 'NumberUtils', 'ObjectUtils', 'DateUtils', 'SkApplicationInstance', 'Criteria', 'MessageUtils', 'StringUtils', 'i18n', 'SanPopup', '$filter', 'RentabilidadePopUpService', 'ResultadoGerLoteService', 'MGEParameters', 'ArrayUtils', 'PopupLiberacoes', '$timeout', 'vendaMaisService', 
        function (SkConstants, PopUpGadgetsService, SkApplication, $scope, ServiceProxy, AngularUtil, NumberUtils, ObjectUtils, DateUtils, SkApplicationInstance, Criteria, MessageUtils, StringUtils, i18n, SanPopup, $filter, RentabilidadePopUpService, ResultadoGerLoteService, MGEParameters, ArrayUtils, PopupLiberacoes, $timeout, vendaMaisService) {

            var self = this;

            self.dataLiberacoes = {};

            self.vlrLiberado;

            // Variáveis p/ o controller se comunicar com a view
            self.nomeUsu;
            self.senhaUsu;
            self.periodo=null;
            self.tipoSlide = 0;
            self.souLiberador = false;
            self.changeSouLiberador = changeSouLiberador;
            self.entityListSolicitantes;           
            self.contextoLibLimites;

            // Variáveis de configuração da tela
            self.resourceID = SkApplicationInstance.getResourceID();
            $scope.gridConfig = self.resourceID + 'gridLimite';
            $scope.gridConfigItemNota = self.resourceID + 'itemNota';

            // Funções do controller
            self.abrirFichaParceiro = abrirFichaParceiro;
            self.agendarRefreshDaTela = agendarRefreshDaTela;
            self.dsLibLimites=null;

            self.liberaNaoLiberaItems = liberaNaoLiberaItems;

            // Variáveis configuráveis no popup "Configurações", ficam disponíveis para diversas áreas da tela
            // puxar valores na inicialização
            self.intervaloAtualizacaoAuto;
            self.filtroPeriodos;
            self.checkItensNota;
            self.checkRecarregarLibNegacao;
            self.checkConfirmarAutomaticamente;
            self.checkCompensarAutomaticamente;
            self.checkPendentesPadrao;
            self.checkFiltrarAbertura;
            self.vendaMais = MGEParameters.asBoolean("fin.habilitar.servico.venda.mais");
            self.urlVendaMais = MGEParameters.asString("fin.url.ambiente.venda.mais");
            self.exVendaMais = "";          
            self.usaVendaMais = "";
            self.onCreatedListSolicitantes = onCreatedListSolicitantes;
            self.voltarParaCentral = voltarParaCentral;
            self.setNuNota = setNuNota;
            self.tableName;

            const FILTRO_APRESENTAR_PENDENTES = 1;
            const FILTRO_APRESENTAR_NEGADAS = 2;
            const FILTRO_APRESENTAR_LIBERADO_VLR_MENOR = 3;
            const FILTRO_APRESENTAR_NAO_LIB = 4;
            const CORTE_EM_CONFERENCIA = 64;
            const EVENTO_FECHAMENTO_CONTABIL_FISCAL = 79;
            const EVENTO_LIB_LIMITE_DESTINACAO_VERBA = 84;

            const DIFERENCA_NCM_CEST_ORGIEM = 75;
            const DIFERENCA_NCM = 85;
            const DIFERENCA_CEST = 86;
            const DIFERENCA_ORGIEM = 87;
            const DIFERENCA_FCI = 88;

            const DIFERENCA_IMPOSTOS = 76;

            self._strCodUsuLiberador;
            var _intervalId;
            var _refreshEmAndamento;
            var _filaRefresh = [];
            var _entityListSolicitantes;

            self.filtroPeriodos = "7DIAS";
            self.periodo = {
                dtIni: new Date(),
                dtFin: new Date()
            }


            //Validações currentLineObserver
            self.btnDetalhesNota = { enabled: false };
            self.btnFichaParc = { enabled: false };
            self.btnNegarLiberacao = { enabled: false };
            self.btnLiberar = { enabled: false };
            self.btnRentabilidade = { enabled: false };
            self.btnDetalhesConf = { enabled: false };

            self.popExibAprovacoesReprovacoes = { enabled: false };
            self.popDescFinanc = { enabled: false };
            self.popExibSaldoMetas = { enabled: false };

            self.popAbrirTela = { enabled: false };

            self.popConfirmarNota = { enabled: false };
            //refreshedObserver-----------------------------
            self.popElimPend = { enabled: false };
            //----------------------------------------------//

            self.pesqParc = undefined;
            self.edNroNota = undefined;
            self.nroUnico;

            ObjectUtils.implements(self, IFilterPanelInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDynaformInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);

            self.interceptMetadata = interceptMetadata;
            self.interceptColumnMetadata = interceptColumnMetadata;

            self.getCellColors = getCellColors;

            // Implementação para criar dataset standAlone
            self.onDatasetCreated = onDatasetCreated;

            // Implementação para criar Filtro e Datagrid
            self.onDatagridLoaded = onDatagridLoaded;
            self.onFilterCreated = onFilterCreated;
            self.apply = apply;

            // Botão de outras opções e funções de seus sub-itens
            self.buildButtonOptions = buildButtonOptions;
            self.buildAnaliseButtonOptions = buildAnaliseButtonOptions;

            self.criteriaProviderItens = new CriteriaProvider();
            self.refreshHandlerItens = refreshHandlerItens;
            // Funções para chamada de Pop-Ups
            self.lancaPopUpDetalhesNota = lancaPopUpDetalhesNota;
            self.mostraDetalhes = mostraDetalhes;
            self.verObservacaoCompPopUp = verObservacaoCompPopUp;
            self.mostrarRentabilidade = mostrarRentabilidade;
            self.interceptCellRenderer = interceptCellRenderer;

            self.btnAnalise = {
                enabled: false,
                dataProvider: undefined
            }
            self.dropdownAnalise;
            self.onDropdownLoaded = onDropdownLoaded;

            self.mostraDetalhesConf = mostraDetalhesConf;
            self.mostraPopUpLiberacaoNegacao = mostraPopUpLiberacaoNegacao;
            self.acaoDoubleClickLiberacao = acaoDoubleClickLiberacao;
            self.atualizaLiberacoes = atualizaLiberacoes;

            self.editObservacao = editObservacao;
            //Elementos do ComboBox 'Apresentar'
            self.tipoSlideOptions = [
                { data: 0, value: i18n('Commons.Liberacoes.labelApresentarTudo') },
                { data: 1, value: i18n('Commons.Liberacoes.labelApresentarPendentes') },
                { data: 2, value: i18n('Commons.Liberacoes.txtApresentarNegadas') },
                { data: 3, value: i18n('Commons.Liberacoes.txtApresentarLibValorMenor') },
                { data: 4, value: i18n('Commons.Liberacoes.labelApresentarNaoLiberados') }
            ];

            self.clearFilter = clearFilter;

            //Função responsavel por limpar EntityList Filtro Solicitante
            function clearFilter() {
                self.nroUnico = undefined;
                self.periodo.dtIni = undefined;
                self.periodo.dtFin = undefined;
                self.tipoSlide = FILTRO_APRESENTAR_PENDENTES;
                self.entityListSolicitantes = undefined;
            }
            
            function onCreatedListSolicitantes(entityList) {
            	_entityListSolicitantes = entityList;
            }
            
            self.ehCentral = $scope.embedded;
            var _callBackCentral = $scope.callBack;
            var _strNuNota;
            var _notaPossuiLibPendente;
            var _ajustaPercLibLim = MGEParameters.asBoolean("com.ajusta.percentual.liberacao");
            var _liberaCliqueDuplo = MGEParameters.asBoolean("mgecore.libera.duplo.clique");
            var isVendaAssitida = false;

            self.filterPanelID = self.ehCentral ? 'filPanLibLim' + Math.random().toString(36).substr(2, 9) : 'filPanLibLim';

            self.dsInicializado = false;

            init();

            function init(){
                carregaDdadosVendaMais();
            }

            function getCellColors(row, col, rowIndex, colIndex, gridApi, params) {

                if (params.dataset && params.dataset.getEntityName() == "ItemNota") {
                    var sequencia = self.dsItemNota.getFieldIndexByName('SEQUENCIA');                    

                    if (angular.isDefined(row.entity)) {
                        var color;
                        if (self._sequenciaLiberacao && row.entity[sequencia] == self._sequenciaLiberacao) {
                            color = "#FFFF66";
                        } 

                        return { bgColor: color };
                    }
                }

            }

            carregaTela();

            function carregaTela() {
            	if ($scope.componentCreated) {
            		$scope.componentCreated({component: self});
            	}
                carregarConfiguracoes();
                self.criteriaProviderItens.getCriteria = getCrteriaItensNota;
                self.lblLiberacoes = i18n('Commons.Liberacoes.labelLiberacaoNota', [_strNuNota]);
            }

            function onDatasetCreated(dataset) {

                if (dataset.getEntityName() === 'ViewLiberacaoLimite') {

                    self.dsLibLimites = dataset;
                    self.periodo.dtIni = new Date();
                    self.periodo.dtFin = new Date();
                    self.dsLibLimites.setCrudListener('br.com.sankhya.modelcore.crudlisteners.LiberacaoLimitesCrudListener');
                    self.dsLibLimites.removeCriteriaProviderIndex(0);
                    
                    var criteriaProvider = new CriteriaProvider();
                    criteriaProvider.getCriteria = getCriteria;
                    self.dsLibLimites.addCriteriaProvider(criteriaProvider);
                    
                    self.dsLibLimites.init();
                    self.contextoLibLimites = new DatasetActionButtonContext(self.dsLibLimites);
                    self.dsInicializado = false;
                    addObservers();
                }

                if (dataset.getEntityName() === 'ItemNota') {
                    self.dsItemNota = dataset;
                    self.dsItemNota.init();
                }
            }

            function onDatagridLoaded(datagrid) {
                self.datagrid = datagrid;
            }
            
             function interceptCellRenderer(cell, value) {

                if (cell.colId == "OBSCOMPL") {

                    let hBoxElem = AngularUtil.createDirective('sk-hbox', {
                        'layout-align': 'start right',
                        'flex': '',
                        'style': 'width: 100%;  line-height: 15px !important;'
                    }, $scope)[0];

                    let label = AngularUtil.createDirective('label', {
                        'style': 'max-width: 85% !important; min-width: 15em; text-align: left !important; margin-right: 10px !important; overflow: hidden; font-weight: 400;',
                        'sk-i18n': value
                    }, $scope)[0];

                    let iconElem = AngularUtil.createDirective('span', {
                        'class': 'glyphicons glyphicon-zoom-in',
                        'style': 'display: block !important; position: absolute !important; right: 10px !important;',
                        'ng-click': 'ctrl.verObservacaoCompPopUp()'
                    }, $scope)[0];
                    
                    hBoxElem.append(label);
                    hBoxElem.append(iconElem);
					cell.minWidth = 284;
                    return { element: hBoxElem, align: 'left' };
                }
             }

            //Menu  dropdown Outras Opcoes
            function buildButtonOptions() {
                var opcoes= [
                    { label: i18n('Commons.Liberacoes.itemEliminarConfirmadas'), action: eliminarPendenciasNotasConfirmadas },
                    { label: i18n('Commons.Liberacoes.itemConfirmarSelecionadas'), action: confirmarNotas },
                    { label: i18n('Commons.Liberacoes.itemConfirmarSemPendencia'), action: confirmarTodasSemPendencia },
                    { label: i18n('Commons.Liberacoes.itemDescontoPorParceiro'), action: mostrarDescontosFinanceiros },
                    { label: i18n('Commons.Liberacoes.itemEliminarPgtosJaPagos'), action: eliminarPendenciasJaPagas },
                    { label: i18n('Commons.Liberacoes.itemExibirSaldo'), action: exibirSaldos },
                    { label: i18n('Commons.Liberacoes.itemExibirAprovacoesFinanceiro'), action: exibirAprovacoesReprovacoes },
                    { label: i18n('Commons.Liberacoes.itemConfiguracoes'), action: mostraPopUpConfiguracoes },                  
                    { label: i18n('Commons.Liberacoes.configurarGadgetEvento'), action: configuracaoGadgetEvento },
                    { label: i18n('Commons.Liberacoes.lblReprocessarLib'), action: reprocessarConferencia },
                    { label: i18n('Commons.Liberacoes.itemEditarObservacao'), action: mostraPopUpEditarObservacao, group:"Configurações" },
                    
                ];

                opcoes.push({ label: i18n('Commons.Liberacoes.' + (self.dsLibLimites.getFieldValueAsString("TABELA") == "TGFFIN" ?  'messageAbrirMovFin': 'messageAbrirCentral')), action: abrirTela });       
      
                return opcoes;
            };

            function onDropdownLoaded(dropdown) {
                self.dropdownAnalise = dropdown;
            }

            function buildAnaliseButtonOptions() {
                return self.btnAnalise.dataProvider;
            }

            function addObservers() {
                var obs = {};
                ObjectUtils.implements(obs, IDataSetObserver);

                obs.currentLineChanged = dsCurrentLineChanged;
                obs.refreshed = dsRefreshed;
                obs.selectionChanged = dsSelectionChanged;

                self.dsLibLimites.addObserver(obs);
            }
            
            function dsSelectionChanged(){
				desabilitaRentabilidadeVendaAssistida();
			}

            function dsCurrentLineChanged(line) {
			    atualizaListaGadgets();
                validLine(line);
            }

            function dsRefreshed() {
                if (self.dsLibLimites.getRecords().length > 0) {
                    self.popElimPend.enabled = true;
                } else {
                    self.popElimPend.enabled = false;
                }
                self.refreshing = false;
            }
            
            function desabilitaRentabilidadeVendaAssistida(){
				var linhasSelecionadas;
				var temNuNota;
				var temParc;
				atualizaListaGadgets();
				if(self.dsLibLimites){
					linhasSelecionadas = self.dsLibLimites.getSelectedRecordsAsObjects();
				}

				linhasSelecionadas.forEach(function(row){
					if(row.CODPARC != 0){
						temParc = true;
					}
                    if(row.TABELA == "TGFCVR" || row.TABELA == "TGFIVR"){
						isVendaAssitida = true;
					} else if(row.NUNOTA != ""){
						temNuNota = true;
					}
                });
                
				if(temParc){
					self.btnFichaParc.enabled = true;
				}
				
                if(linhasSelecionadas.length > 1 && temNuNota){
					self.btnRentabilidade.enabled = true;
					self.btnDetalhesNota.enabled = true;
					isVendaAssitida = false;
				}
			}

            function atualizaListaGadgets() {

                var evento = self.dsLibLimites.getFieldValueAsString("EVENTO");
                var dp = [];
                self.buildAnaliseButtonOptions = function () {
                }
                self.btnAnalise.enabled = false;

                if (evento) {
                    var param = {
                        NUEVENTO: evento
                    };

                    ServiceProxy.callService(
                        "mge@LiberacaoLimitesSP.listaGadgetsPorEventoLiberacao", { param }).then(
                            function (result) {
                                if (result.responseBody.gadgets.gadget) {
                                    if (angular.isArray(result.responseBody.gadgets.gadget)) {
                                        result.responseBody.gadgets.gadget.forEach(function (gadgetElem) {
                                            let nugdg = gadgetElem.NUGDG.$.toString();
                                            let descgdg = gadgetElem.DESCRICAO.$.toString();
                                            dp.push({
                                                NUGDG: gadgetElem.NUGDG.$.toString(), 
                                                label: gadgetElem.DESCRICAO.$.toString(), 
                                                action: () => abreAnalise(nugdg, descgdg)
                                            });
                                        });
                                    } else {
                                        let nugdg = result.responseBody.gadgets.gadget.NUGDG.$.toString();
                                        let descgdg  = result.responseBody.gadgets.gadget.DESCRICAO.$.toString();
                                        dp.push({ 
                                            NUGDG: result.responseBody.gadgets.gadget.NUGDG.$.toString(), 
                                            label: result.responseBody.gadgets.gadget.DESCRICAO.$.toString(), 
                                            action: () => abreAnalise(nugdg, descgdg) });
                                     }

                                }
                                self.btnAnalise.enabled = dp.length > 0;
                                self.btnAnalise.dataProvider = dp;

                                if (self.dropdownAnalise) {
                                	self.dropdownAnalise.setOptionsLoaded(dp);
                                }
                            }
                        );
                } else {
                    self.btnAnalise.enabled = dp.length > 0;
                    self.btnAnalise.dataProvider = dp;
                   
                    if (self.dropdownAnalise) {
                    	self.dropdownAnalise.setOptionsLoaded(dp);
                    }
                }
            }

            function abreAnalise(nugdg, descgdg) {
                const montaDahLibLimite = MGEParameters.asBoolean("mge.excl.mntdash.liblimite");
                const parametros = removeTextoLongoDosParametros();
              
                if(montaDahLibLimite){
                    montaGadgetGetConf(nugdg, descgdg);
                }else{
                    PopUpGadgetsService.openPopUp(nugdg, descgdg, parametros);
                }
            }
            
            function atualizaLiberacoes(evt) {
            	switch (evt.keyCode) {
			       case SkConstants.KEY_CODE.ENTER:
			    	   apply();
			           break;
			       default:
			           break;
			   }
            }

            // Função para o botão 'Aplicar'
            function apply() {
             saveConfigFiltroTela();
             var parametros = {
                    params: {
                        "nomeUsu": self.nomeUsu,
                        "senhaUsu": self.senhaUsu
                    }
                }

                //Tratamento para não enviar data Undefined para o serviço. Caso a inicial fique Undefined, pega o tempo mais antigo e caso a final fique Undefined, pega data atual
                if(self.periodo.dtIni == undefined || self.periodo.dtFin == undefined){
                    if (self.periodo.dtIni == undefined){
                        self.periodo.dtIni = new Date(0);
                    }

                    if (self.periodo.dtFin == undefined){
                        self.periodo.dtFin = new Date;
                    }
                }

                if (self.souLiberador == "N") {
                    if (!angular.isDefined(parametros.params.nomeUsu) || !angular.isDefined(parametros.params.senhaUsu)
                        || parametros.params.nomeUsu == "" || parametros.params.senhaUsu == "" ) {
                        MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Liberacoes.messageFaltaUsuario'));
                        self.dsInicializado = false;
                        self.dsLibLimites.clearDataSet();
                        return;
                    
                }else {
                    ServiceProxy.callService(
                        "mge@LiberacaoLimitesSP.validarSenhaUsuario",
                        parametros).then(function (result) {
                            self._strCodUsuLiberador = parseFloat(result.responseBody.codUsu);

                           
                            self.dsInicializado = true;

                            if (self._strCodUsuLiberador == 0) {
                                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Liberacoes.messageSupNaoLibera'));
                                self.dsInicializado = false;                            
                                self.dsLibLimites.clearDataSet();
                                self.dsItemNota.clearDataSet();
                                return;
                            } else {
                                self.dsInicializado = true;
                                self.dsLibLimites.refresh();
                            }
                           
                        });
                     
        
                }
          
            }
            else if (self.souLiberador == "S" && SkApplicationInstance.getUserID() == 0) {
                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Liberacoes.messageSupNaoLibera'));
                self.dsInicializado = false;
                self.dsLibLimites.clearDataSet();
            } else if (self.souLiberador == "S") {
                self._strCodUsuLiberador = SkApplicationInstance.getUserID();
                self.dsLibLimites.refresh();
                self.dsItemNota.clearDataSet();
                self.dsInicializado = true;
            }
        }

            function onFilterCreated($filter) {
                self.filterPanel = $filter;
            }

            function getCriteria() {
            	 
            	if(StringUtils.emptyAsNull(self._strCodUsuLiberador) == null){
            		throw new Error(i18n('Commons.Liberacoes.messageFaltaCodUsuario'));
				}
            	
                var ctr = Criteria();

                self.dtIni = $filter('date')(self.periodo.dtIni, "dd/MM/yyyy");
                self.dtFin = $filter('date')(self.periodo.dtFin, "dd/MM/yyyy");
                var currentDate =DateUtils.dateToString(new Date(), 'DD/MM/YYYY'); 
                
                ctr.append('(this.CODUSULIB = 0 OR this.CODUSULIB = ?', Criteria.buildNumberParameter(self._strCodUsuLiberador));
                ctr.append(' OR this.CODUSULIB IN ( SELECT CODUSU FROM TSISUPL WHERE CODUSUSUPL = ?', Criteria.buildNumberParameter(self._strCodUsuLiberador));
                ctr.append(' AND DTINICIO <= ?', Criteria.buildDateParameter(currentDate));
                ctr.append(' AND ( DTFIM IS NULL OR DTFIM >= ?)))', Criteria.buildDateParameter(currentDate));
                if (self.ehCentral) {
                    ctr.append('AND this.NUNOTA=? ', Criteria.buildNumberParameter(_strNuNota));
                } else if (angular.isDefined(self.nroUnico)) {
                      ctr.append(" AND ((this.TABELA IN ('TGFCON2','TGFCOI2') AND this.NUNOTA = ?)", Criteria.buildNumberParameter(self.nroUnico));
                      ctr.append(' OR this.NUCHAVE = ?)', Criteria.buildNumberParameter(self.nroUnico));
                }

                switch (self.tipoSlide) {
                    case 0:
                        break;

                    case FILTRO_APRESENTAR_PENDENTES: //Não liberado nenhuma vez ou liberado e depois 'des-liberado' (a 'des-liberação' limpa o DHLIB)
						ctr.append(' AND (this.DHLIB IS NULL OR (ABS(this.VLRLIBERADO) > 0 AND ABS(this.VLRLIBERADO) < ABS(this.VLRATUAL)))');
                        break;

                    case FILTRO_APRESENTAR_NEGADAS:
                        ctr.append(" AND this.REPROVADO = ?", Criteria.buildStringParameter('S'));
                        break;

                    case FILTRO_APRESENTAR_LIBERADO_VLR_MENOR:  //Já liberado mas ainda não liberou o suficiente para poder confirmar a nota
                        ctr.append(' AND (ABS(this.VLRLIBERADO) > 0 AND ABS(this.VLRLIBERADO) < ABS(this.VLRATUAL))');
                        break;
                        
					case FILTRO_APRESENTAR_NAO_LIB: //Não liberado nenhuma vez ou liberado e depois 'des-liberado' (a 'des-liberação' limpa o DHLIB)
						ctr.append(' AND (this.DHLIB IS NULL) ');
						break;
                }
                if (self.entityListSolicitantes.length > 0 && !self.ehCentral) {
                    //implementar solicitantes
                    var solicitantes = self.entityListSolicitantes;

                    self.entityListSolicitantes.forEach(function (item) {
                        if (solicitantes.length > 0) {
                            solicitantes += ", "
                        }
                        solicitantes += item;

                        ctr.append(' AND this.CODUSUSOLICIT IN( ' + solicitantes + ' ) ');
                    });

                }

                if (!self.ehCentral) {                    
                    ctr.append(' AND this.DHSOLICIT >= ?', Criteria.buildDateParameter(angular.isDefined(self.dtIni)  ? self.dtIni : "01/01/1990"));
                    ctr.append(' AND onlydate(this.DHSOLICIT) <= ?', Criteria.buildDateParameter(angular.isDefined(self.dtFin)  ? self.dtFin : "31/12/2100"));
                }
				
				ctr.append(' AND this.EVENTO <> 24' );
                ctr.append(' AND this.EVENTO IN ( SELECT EVENTO FROM TSILIM LIM WHERE (( LIM.CODUSU = ?', Criteria.buildNumberParameter(self._strCodUsuLiberador));
                ctr.append(' OR LIM.CODUSU IN ( SELECT CODUSU FROM TSISUPL WHERE TSISUPL.CODUSUSUPL = ?', Criteria.buildNumberParameter(self._strCodUsuLiberador));
                ctr.append(' AND TSISUPL.DTINICIO <= ?', Criteria.buildDateParameter(currentDate));
                ctr.append(' AND (TSISUPL.DTFIM IS NULL OR TSISUPL.DTFIM >= ?', Criteria.buildDateParameter(currentDate));
                ctr.append(' ))) AND LIM.CODGRU = 0) OR (LIM.CODUSU = 0 AND (LIM.CODGRU = ?', Criteria.buildNumberParameter(self._strCodUsuLiberador));
                ctr.append(' OR LIM.CODGRU IN ( SELECT U.CODGRUPO FROM TSISUPL S, TSIUSU U');
                ctr.append(' WHERE  S.CODUSUSUPL = ?', Criteria.buildNumberParameter(self._strCodUsuLiberador));
                ctr.append(' AND S.DTINICIO <= ?', Criteria.buildDateParameter(currentDate));
                ctr.append(' AND (S.DTFIM IS NULL OR S.DTFIM >= ?)', Criteria.buildDateParameter(currentDate));
                ctr.append(' AND S.CODUSU = U.CODUSU))))');

                return ctr;
            }

            function saveConfigFiltroTela() {
                var config = {
                        chave: self.resourceID + '.dadosfiltro',
                        tipo: 'T',
                        filtro: { value: self.tipoSlide },
                        souLiberador: { $: self.souLiberador == "S" ? 'true' : 'false' },
                    }
				
                ServiceProxy.callService('mge@SystemUtilsSP.saveConf', { config: config });
                
                var configSolicitante = {
                        chave: self.resourceID + '.list.Solicitante',
                        tipo: 'T',
                        item: []
                    }
                
                for (var i in _entityListSolicitantes.getDataProvider()) {
					var item = _entityListSolicitantes.getDataProvider()[i];
					configSolicitante.item.push({data: item.data, selected: item.checked});
            	}
                
                ServiceProxy.callService('mge@SystemUtilsSP.saveConf', { config: configSolicitante });
            }
            
            function carregarConfiguracoes() {
                if(!self.ehCentral){
            	    SkApplicationInstance.loadMgeConfig(self.resourceID + ".configuracao").then(
                         function (config) {

                            if (config.config) {
                                self.intervaloAtualizacaoAuto = parseFloat(ObjectUtils.getProperty(config, 'config.tempoParaRefresh.$'));
                                self.filtroPeriodos =ObjectUtils.getProperty(config, 'config.tipoFiltroPeriodo.$');            
                                self.checkItensNota =  ObjectUtils.getProperty(config, 'config.mostrarItensNota.$') == "true" ? "S" : "N";
                                self.checkRecarregarLibNegacao =   ObjectUtils.getProperty(config, 'config.recarregarLiberacaoNegacao.$') == "true" ? "S" : "N";
                                self.checkConfirmarAutomaticamente =  ObjectUtils.getProperty(config, 'config.confirmarAutomaticamente.$')== "true" ? "S" : "N";
                                self.checkCompensarAutomaticamente = ObjectUtils.getProperty(config, 'config.compensarAutomaticamente.$') == "true" ? "S" : "N";
                                self.checkPendentesPadrao = ObjectUtils.getProperty(config, 'config.pendentesPadrao.$') == "true" ? "S" : "N";
                                self.checkFiltrarAbertura =  ObjectUtils.getProperty(config, 'config.filtrarAbertura.$') == "true" ? "S" : "N";                    
                                setDateInterval();
                                agendarRefreshDaTela();
                            }

                         });
                
                    SkApplicationInstance.loadMgeConfig(self.resourceID + ".list.Solicitante").then(
                        function (config) {
                            if (config.config) {
                                var listaSolicitantes = [];
            					
            					if (config.config.item) {
            						var lista = ArrayUtils.toArray(config.config.item);
            						lista.forEach(function(item){
            							listaSolicitantes.push({data: item.data, checked: item.selected == "true"});
            						});
            					}
            					
            					self.entityListSolicitantes = listaSolicitantes;
                            }
                            
                            SkApplicationInstance.loadMgeConfig(self.resourceID + ".dadosfiltro").then(
                                    function (config) {
                                        if (config.config) {
                                            self.tipoSlide = self.checkPendentesPadrao == "S" ? 1 : parseFloat(config.config.filtro.value);
                                            self.souLiberador = config.config.souLiberador.$ == "true" ? "S" : "N";
                                            
                        					if(self.checkFiltrarAbertura == "S") {
                        						self.souLiberador = "S";
                        						apply();
                        					}
                                        }
                                    });
                            
                        });
                }
            }

            async function carregaDdadosVendaMais() {
                await vendaMaisService.getAmbienteInfoVendaMais().then(function (ambienteInfo) {
                    self.sasId = ambienteInfo.sasId;
                    self.enviroment = ambienteInfo.enviroment;
                    self.codParc = ambienteInfo.codParc;
                });
                
                await vendaMaisService.getCnpjParceiro(self.codParc).then(function (dadosCnpj){
                    self.cnpj = dadosCnpj.cnpj;
                    self.razaoSocial = dadosCnpj.razaoSocial;
                    self.tipPessoa = dadosCnpj.tipPessoa;
                });

                document.querySelectorAll('sankhya-venda-mais').forEach(el => el.remove());
                self.infos = vendaMaisService.carregaInfo({
                    'sasId': self.sasId,
                    'partnerCode': self.dsLibLimites.getFieldValueAsString('CODPARC'),
                    'cnpjPartner': self.cnpj,
                    'pathTemplate': 'creditRequest',
                    'enviroment': self.environment,
                    'isFinance': false,
                    'personType': self.tipPessoa
                });

                vendaMaisService.constroiHtml(self.infos);
                vendaMaisService.sankhyaVendaMaisAddEventListener();
            }

            function mostraDetalhes() {

            	var evento = self.dsLibLimites.getFieldValueAsNumberOrZero("EVENTO");
            	
            	if(self.dsLibLimites.getSelectedRecordsAsObjects().length > 0){
            		evento = self.dsLibLimites.getSelectedRecordsAsObjects()[0].EVENTO;
            	}

                if (evento == EVENTO_FECHAMENTO_CONTABIL_FISCAL) {
                    lancaPopUpFechamentoCtb();
                } else if (evento == DIFERENCA_NCM_CEST_ORGIEM || evento == DIFERENCA_NCM || evento == DIFERENCA_CEST || evento == DIFERENCA_ORGIEM || evento == DIFERENCA_FCI) {
                    lancaPopUpProdutos();

                } else if (evento == DIFERENCA_IMPOSTOS) {
                    lancaPopUpImpostos();

                } else if(evento == EVENTO_LIB_LIMITE_DESTINACAO_VERBA){
                    abrirTela();
                }
                else {
                    lancaPopUpDetalhesNota();
                }
            }

            //--------------------------------------------------------------------------------------------------------------
            //------------------------- Funções relativas ao botão de "Outras Opções" (início) -----------------------------
            //--------------------------------------------------------------------------------------------------------------
            function eliminarPendenciasNotasConfirmadas() { // Precisa de registros pra testar
                let parametros = {
                    params: {
                        limite: []
                    }
                };

                let itens = self.dsLibLimites.getRecordsAsObjects();

                for (let item of itens) {
                    if (
                        item.DHLIB !== undefined &&
                        item.REPROVADO === "N" &&
                        item.TABELA === "TGFCAB" &&
                        (Number(item.PERCANTERIOR) !== 0 || Number(item.VLRANTERIOR) !== 0) &&
                        item.STATUSNOTA === "L"
                    ) {
                        parametros.params.limite.push({ nuChave: item.NUCHAVE, evento: item.EVENTO });
                    }
                }

                if (parametros.params.limite.length > 0) {
                    ServiceProxy.callService("mge@LiberacaoLimitesSP.eliminarPendeciasNotasConfirmadas", parametros)
                        .then(function () {
                            apply();
                        });
                }
            }

            function confirmarNotas(evento, notas = null) {
                let veioDeOutrasOpcoes = false;
                let parametrosParaServico = notas === null ? {} : notas;

                if (notas === null) {
                    veioDeOutrasOpcoes = true;

                    let parametros = {
                        notas: {
                            compensarNotaAutomaticamente:self.checkCompensarAutomaticamente == "S" ? "true" : "false",
                            nunota: []
                        }
                    };

                    let itens = self.dsLibLimites.getSelectedRecordsAsObjects(null,true);

                    for (let item of itens) {
                        if (item.NUNOTA !== undefined) {
                            parametros.notas.nunota.push({ $: item.NUNOTA });
                        }
                    }

                    parametrosParaServico = parametros;
                }

                ServiceProxy.callService('mgecom@ServicosNfeSP.confirmarNotas', parametrosParaServico)
                    .then(function (result) {
                    	let servicos = ObjectUtils.getProperty(result, 'responseBody.servicos');
                        let avisos = ObjectUtils.getProperty(result, 'responseBody.avisos');
                        let acompanhamentos = ObjectUtils.getProperty(result, 'responseBody.acompanhamentosNotas');

                        if (ObjectUtils.getProperty(servicos, 'servico') !== undefined || ObjectUtils.getProperty(avisos, 'aviso') !== undefined) {
                            ResultadoGerLoteService.openPopUp(true, result.responseBody, self.dsLibLimites);
                        } else if (acompanhamentos != undefined) {
                            var notas = result.responseBody.acompanhamentosNotas.nota;
                            var ocorrencias = result.responseBody.acompanhamentosNotas.acompanhamento;

                            if ((notas != undefined && notas != []) && (ocorrencias != undefined && ocorrencias != [])) {
                                lancapopUpOcorrenciasNotaServico(notas, ocorrencias);
                            }
                        } else {
                            if (Number(ObjectUtils.getProperty(result, "responseBody.qtdNotas")) > 0) {
                                MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Commons.Liberacoes.messageQtdeNotasConfirmadas', [result.responseBody.qtdNotas]));
                            } else if (veioDeOutrasOpcoes) {
                                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Liberacoes.messageNenhumaNotaConfirmada'));
                            }
                        }

                        if (ObjectUtils.getProperty(result, "responseBody.liberacoes") && MGEParameters.asBoolean('mge.libera.limites.nota.tela.lib.limites')) {
                            processaLiberacoes(ObjectUtils.getProperty(result, "responseBody.liberacoes.liberacao"));
                        }
                    });
            }

            function confirmarTodasSemPendencia() {
                let parametros = {
                    notas: {
                        compensarNotaAutomaticamente: self.checkCompensarAutomaticamente,
                        nunota: []
                    }
                };

                let itens = self.dsLibLimites.getRecordsAsObjects();

                for (let item of itens) {
                    if (item.NUNOTA !== undefined) {
                        parametros.notas.nunota.push({ $: item.NUNOTA });
                    }
                }

                confirmarNotas(null, parametros);
            }

            function mostrarDescontosFinanceiros() {
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Liberacoes.messageRecursoNaoImplementado'));
            }

            function abrirTela() {
                let tabela = self.dsLibLimites.getFieldValueAsString('TABELA');
                let numeroNota = self.dsLibLimites.getFieldValueAsString("NUNOTA");

                if (tabela === 'TGFFIN') {
                    SkApplicationInstance.openApp('br.com.sankhya.fin.cad.movimentacaoFinanceira', { NUFIN: self.dsLibLimites.getFieldValue("NUCHAVE") });
                } else if (tabela === 'TGFCVR') {
                    SkApplicationInstance.openApp('br.com.sankhya.mgecom.VendaAssistida', { NUCVR: self.dsLibLimites.getFieldValue("NUNOTA") });
                } else if (!StringUtils.isEmpty(numeroNota)) {
                    SkApplicationInstance.openApp('br.com.sankhya.com.mov.CentralNotas', { NUNOTA: self.dsLibLimites.getFieldValue("NUNOTA") });
                } else if(tabela === 'TGFDVM'){
                    SkApplicationInstance.openApp('br.com.sankhya.mgecom.DestinacaoVerbas', { NUDESTINACAO: self.dsLibLimites.getFieldValue("NUCHAVE") });
                }else {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Liberacoes.msgImpossivelAbrirNota'));
                }
            }

            function eliminarPendenciasJaPagas() { // Precisa de registros pra testar
                let parametros = {
                    params: {
                        limite: []
                    }
                };

                let itens = self.dsLibLimites.getRecordsAsObjects();

                for (let item of itens) {
                    if (
                        item.DHLIB !== undefined &&
                        Number(item.EVENTO) == 24 &&
                        item.REPROVADO === "N" &&
                        (Number(item.PERCANTERIOR) !== 0 || Number(item.VLRANTERIOR) !== 0)
                    ) {
                        parametros.params.limite.push({ nuChave: item.NUCHAVE, evento: item.EVENTO });
                    }
                }

                if (parametros.params.limite.length > 0) {
                    ServiceProxy.callService("mge@LiberacaoLimitesSP.eliminarPendeciasNotasConfirmadas", parametros)
                        .then(function () {
                            apply();
                        });
                }
            }

            function exibirSaldos() {
                lancaPopupResultadosDoOrcamento();
            }

            function exibirAprovacoesReprovacoes() {
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Liberacoes.messageRecursoNaoImplementado'));
            }

            function configuracaoGadgetEvento() {
                mostraPopUpconfiguracaoGadgetEvento();
            }

            function reprocessarConferencia() {
                let parametros = {
                    notas: []
                };

                let itens = self.dsLibLimites.getSelectedRecordsAsObjects();

                for (let item of itens) {
                    if (item.EVENTO === CORTE_EM_CONFERENCIA) {
                        parametros.notas.push({ $: item.NUCHAVE });
                    }
                }

                if (parametros.notas.length > 0) {
                    ServiceProxy.callService('mgecom@ConferenciaSP.reprocessarConferencia', parametros)
                        .then(function (result) {
                            let qtdNotasProcessadas = Number(result.responseBody.qtdNotasProcessadas);
                            let qtdTotalNotas = Number(result.responseBody.qtdTotalNotas);
                            let qtdNaoProcessadas = qtdTotalNotas - qtdNotasProcessadas;

                            if (qtdTotalNotas === 1) {
                                if (qtdNotasProcessadas === 1) {
                                    MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Comercial.SelecaoDocumento.msgConfReprocessada'));
                                } else {
                                    MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Comercial.SelecaoDocumento.msgConfReprocessadaDiv'));
                                }
                            } else {
                                MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Comercial.SelecaoDocumento.msgConfReprocessadasResul', [qtdTotalNotas, qtdNotasProcessadas, qtdNaoProcessadas]));
                            }
                        });
                } else {
                    // Label criado no Commons - confirmar após compilação
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, 'Commons.LiberacaoLimites.avisoSelecioneSomenteEvento64');
                }
            }


            function mostraPopUpConfiguracoes() { // Conferir quais itens usam 'S' e 'N' e quais usam 'true' ou 'false'.
                lancaPopupliberacaoLimitesConfiguracoes();
            }
            //--------------------------------------------------------------------------------------------------------------
            //------------------------- Funções relativas ao botão de "Outras Opções" (fim) --------------------------------
            //--------------------------------------------------------------------------------------------------------------


            //--------------------------------------------------------------------------------------------------------------
            //------------------------------------- Lançadores de Pop-Ups (início) -----------------------------------------
            //--------------------------------------------------------------------------------------------------------------
            function lancaPopUpImpostos() {
                var _nuNota = self.dsLibLimites.getFieldValueAsString("NUNOTA");
                
                if(self.dsLibLimites.getSelectedRecordsAsObjects().length > 0){
                	_nuNota = self.dsLibLimites.getSelectedRecordsAsObjects()[0].NUNOTA;
                }

                SanPopup.open({
                    title: i18n('Commons.Liberacoes.titleDetalhesImpostos'),
                    templateUrl: "commons/containerLiberacaoLimites/popup/detalhesImpostos/detalhesImpostos.tpl.html",
                    controller: 'detalhesImpostosController',
                    controllerAs: 'ctrl',
                    showBtnCancel: false,
                    size: 'lg',
                    resolve: {
                        dataValue: {
                            _nuNota: _nuNota,
                        }
                    }
                });
            }

            function lancaPopUpProdutos() {
                var _nuNota = self.dsLibLimites.getFieldValueAsString("NUNOTA");
                var _evento = self.dsLibLimites.getFieldValueAsString("EVENTO");

                if(self.dsLibLimites.getSelectedRecordsAsObjects().length > 0){
                	_nuNota = self.dsLibLimites.getSelectedRecordsAsObjects()[0].NUNOTA;
                  _evento = self.dsLibLimites.getSelectedRecordsAsObjects()[0].EVENTO;

                }

                SanPopup.open({
                    title: i18n('Commons.Liberacoes.titleDetalhesProdutos'),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/detalhesProdutos/detalhesProdutos.tpl.html',
                    controller: 'detalhesProdutosController',
                    controllerAs: 'ctrl',
                    showBtnCancel: false,
                    size: 'lg',
                    resolve: {
                        dataValue: {
                            _nuNota: _nuNota,
                            _evento: _evento
                        }
                    }
                });
            }

            function lancaPopUpFechamentoCtb() {
                var nuLiberacao = self.dsLibLimites.getFieldValueAsString("NUCHAVE");
                
                if(self.dsLibLimites.getSelectedRecordsAsObjects().length > 0){
                	nuLiberacao = self.dsLibLimites.getSelectedRecordsAsObjects()[0].NUCHAVE;
            	}

                SanPopup.open({
                    title: i18n("Commons.Liberacoes.titleFechaCtbFiscal"),
                    templateUrl: "commons/containerLiberacaoLimites/popup/detalhesFechamentoCtb/detalhesFechamentoCtb.tpl.html",
                    controller: 'detalhesFechamentoCtbController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    resolve: {
                        dataValue: {
                            nuLiberacao: nuLiberacao,
                        }
                    }
                });
            }

            function lancaPopUpDetalhesNota() {
                var _nuNota = self.dsLibLimites.getFieldValueAsString("NUNOTA");
                
                if(self.dsLibLimites.getSelectedRecordsAsObjects().length > 0){
                	_nuNota = self.dsLibLimites.getSelectedRecordsAsObjects()[0].NUNOTA;
                }

                SanPopup.open({
                    title: i18n("Commons.Liberacoes.titleDetalhesNota"),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/detalhes/detalhesNota.tpl.html',
                    controller: 'detalhesNotaController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    height: 450,
                    showBtnCancel: false,
                    showBtnOk: true,
                    okBtnLabel: i18n("Geral.buttonFechar"),
                    resolve: {
                        dsLibLimites: self.dsLibLimites,
                        dataValue: {
                            nuNota: _nuNota,
                            pesqEmp: self.pesqEmp,
                            numNotanumNota: self.numNotanumNota,
                            serie: self.serie,
                            dtNegociacao: self.dtNegociacao,
                            pesqParc: self.pesqParc,
                            pesqOperacao: self.pesqOperacao,
                            pesqOperacao: self.pesqOperacao,
                            pesqNatureza: self.pesqNatureza,
                            pesqCR: self.pesqCR,
                            pesqProj: self.pesqProj,
                            vlrNota: self.vlrNota,
                            primeiroVencimento: self.primeiroVencimento,
                            ultVenc: self.ultVenc,
                            prazoMedio: self.prazoMedio,
                            pesqVend: self.pesqVend,
                            observacao: self.observacao,
                            vlrDesconto: self.vlrDesconto,
                            vlrFrete: self.vlrFrete,
                            vlrDestaque: self.vlrDestaque,
                            vlrOutros: self.vlrOutros
                        }
                    }
                });
            }

            function lancaPopupliberacaoLimitesConfiguracoes() {
                SanPopup.open({
                    title: i18n("Commons.Liberacoes.titleConfiguracoes"),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/configuracoes/liberacaoLimitesConfiguracoes.tpl.html',
                    controller: 'liberacaoLimitesConfiguracoesController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnCancel: true,
                    showBtnOk: true,
                    okBtnLabel: i18n("Commons.Liberacoes.buttonConfirmar"),
                    resolve: {
                        dataValue: {
                            dsItemNota: self.dsItemNota,
                            intervaloAtualizacaoAuto: self.intervaloAtualizacaoAuto,
                            filtroPeriodos: self.filtroPeriodos,
                            checkItensNota: self.checkItensNota,
                            checkRecarregarLibNegacao: self.checkRecarregarLibNegacao,
                            checkConfirmarAutomaticamente: self.checkConfirmarAutomaticamente,
                            checkCompensarAutomaticamente: self.checkCompensarAutomaticamente,
                            checkPendentesPadrao: self.checkPendentesPadrao,
                            checkFiltrarAbertura: self.checkFiltrarAbertura,
                            agendarRefreshDaTela: agendarRefreshDaTela,
                            resourceID: self.resourceID
                        }
                    }
                }).result.then(function (properties) {
                	self.intervaloAtualizacaoAuto = properties.tempoParaRefresh;
                	self.filtroPeriodos = properties.tipoFiltroPeriodo;
                    self.checkItensNota = properties.checkItensNota;
                    self.checkRecarregarLibNegacao = properties.recarregarLiberacaoNegacao;
                    self.checkConfirmarAutomaticamente = properties.confirmarAutomaticamente;
                    self.checkCompensarAutomaticamente = properties.compensarAutomaticamente;
                    self.checkPendentesPadrao = properties.pendentesPadrao;
                    self.checkFiltrarAbertura = properties.filtrarAbertura;
                });
            }

            function lancaPopupResultadosDoOrcamento() {
                SanPopup.open({
                    title: i18n("Commons.Liberacoes.lblResultadosOrcamento"),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/resultadosOrcamento/resultadosOrcamento.tpl.html',
                    controller: 'resultadosOrcamentoController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnCancel: true,
                    showBtnOk: false,
                    cancelBtnLabel: i18n('Geral.buttonFechar'),
                    resolve: {
                        dataValue: {
                            NUNOTA: self.dsLibLimites.getFieldValueAsString("NUNOTA")
                        }
                    }
                });
            }
            
            function verObservacaoCompPopUp() {
	
			   $timeout(function () {
	        		var obsComp = self.dsLibLimites.getFieldValueAsString("OBSCOMPL");
	                if(!StringUtils.isEmpty(obsComp)){
	                    SanPopup.open({
	                        title: i18n('Commons.Liberacoes.lblObservacaoComplementar') ,
	                        templateUrl: 'commons/containerLiberacaoLimites/popup/observacaoCompl/observacaoComplPopUp.tpl.html',
	                        controller: 'observacaoComplPopUpController',
	                        controllerAs: 'ctrl',
	                        size:'md',
	                        height: 230,
	                        cancelBtnLabel: i18n('Commons.Liberacoes.lblOK'),
	                        showBtnNo: false,
	                        showBtnOk: false,
	                        resolve: {
	                            data: {
	                                obsComp: obsComp,
	                            }
	                        }
	                    });
	                }
	           }, 250);
            }
            
            function lancapopUpOcorrenciasNotaServico(nota, ocorrencia) {

                var btnVoltar = angular.element('<button class="btn btn-default" id="buttonVoltar" style="visibility: hidden;">' + i18n( 'mge.LiberacaoLimites.labelVoltar') + '</button>');
                var btnObservacao = angular.element('<button class="btn btn-default" id="buttonObservacao" disabled="true">' + i18n('Commons.Central.buttonVerObservacao') + '</button>');
                var btnOcorrencia = angular.element('<button class="btn btn-default" id="buttonOcorrencia" disabled="true">' + i18n('Commons.Central.buttonVerOcorrencia') + '</button>');
                var btnFechar = angular.element('<button class="btn btn-default" id="buttonFechar">' +   i18n( 'mge.LiberacaoLimites.labelFechar') + '</button>');

                SanPopup.open({
                    title: i18n('Commons.Liberacoes.titleOcorrenciasConfirmacaoNotas'),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/central/popUpOcorrenciasNotaServico.tpl.html',
                    controller: 'popUpOcorrenciasNotaServicoController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    showBtnCancel: false,
                    showBtnOk: false,
                    rightBottomBar: [btnObservacao, btnOcorrencia, btnVoltar, btnFechar],
                    resolve: {
                        dataValue: {
                            Notas: nota,
                            Ocorrencias: ocorrencia
                        },
                        btnVoltar: function () {
                            return btnVoltar;
                        },
                        btnObservacao: function () {
                            return btnObservacao;
                        },
                        btnOcorrencia: function () {
                            return btnOcorrencia;
                        },
                        btnFechar: function () {
                            return btnFechar;
                        }
                    }
                });
                agendarRefreshDaTela();
            }


            function mostraDetalhesConf() {

                SanPopup.open({
                    title: i18n("Commons.Liberacoes.titleDetalhesNota"),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/detalhes/DetalhesConferenciaPopUp.tpl.html',
                    controller: 'detalhesConferenciaPopupController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnCancel: false,
                    showBtnOk: true,
                    okBtnLabel: i18n("Geral.buttonFechar"),
                    resolve: {
                        dataValue: {
                            nuNota: self.dsLibLimites.getFieldValueAsString("NUNOTA")
                        }
                    }
                });

                agendarRefreshDaTela();
            }

            function mostraPopUpEditarObservacao() {
              
                var btnOk = angular.element('<button class="btn btn-default">' + i18n( 'mge.LiberacaoLimites.labelOK') + '</button>');
                var btnCancelar = angular.element('<button class="btn btn-default">' + i18n( 'mge.LiberacaoLimites.labelCancelar') + '</button>');

                SanPopup.open({
                    title: i18n('Commons.Liberacoes.itemEditarObservacao'),
                    templateUrl: 'commons/containerLiberacaoLimites/popup/editarObservacao/editarObservacao.tpl.html',
                    controller: 'editarObservacaoPopUpController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnCancel: false,
                    showBtnOk: false,
                    rightBottomBar: [btnCancelar, btnOk],
                    resolve: {
                        dataValue: {
                            obsLib: self.dsLibLimites.getFieldValueAsString("OBSLIB"),
                            obsSolic: self.dsLibLimites.getFieldValueAsString("OBSERVACAO"),
                            itensSelecionados: !ArrayUtils.isNotEmpty(self.dsLibLimites.getSelectedRecordsPks()) ? [self.dsLibLimites.getCurrentRowAsObject()] : self.dsLibLimites.getSelectedRecordsPks(),
                            editaObservacao: self.editObservacao
                        },
                        btnOk: function () {
                            return btnOk;
                        },
                        btnCancelar: function () {
                            return btnCancelar;
                        }
                    }
                });
            }

            function mostraPopUpconfiguracaoGadgetEvento() {
                var _title = i18n('Commons.Liberacoes.tituloPopUpGadgetEventoLiberacao');

                SanPopup.open({
                    title: _title,
                    templateUrl: 'commons/containerLiberacaoLimites/popup/configuracaoGadgetEvento/configuracaoGadgetEvento.tpl.html',
                    controller: 'configuracaoGadgetEventoPopUpController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnCancel: true,
                    showBtnOk: true,
                    resolve: {
                        dataValue: {
                        }
                    }
                });
            }

            function mostraPopUpLiberacaoNegacao(ehLiberacao) {
                var _title = ehLiberacao ? i18n('Commons.Liberacoes.titleLiberarLimites') : i18n('Commons.Liberacoes.titleNegarLiberacao');

                SanPopup.open({
                    title: _title,
                    templateUrl: 'commons/containerLiberacaoLimites/popup/liberarNegarLimite/liberacaoNegacaoLimitesPopUp.tpl.html',
                    controller: 'liberacaoNegacaoLimitesPopUpController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    height: self.dsLibLimites.getSelectedRecordsAsObjects().length > 1 ? 300 : 260,
                    resolve: {
                        dataValue: {
                            liberacao: ehLiberacao,
                            valorLiberado: self.dsLibLimites.getFieldValueAsNumberOrZero("VLRATUAL"),
                            liberaNaoLiberaItems: liberaNaoLiberaItems,
                            possuiVariosItensSelec: self.dsLibLimites.getSelectedRecordsAsObjects().length > 1
                        }
                    }
                });
            }
            //--------------------------------------------------------------------------------------------------------------
            //------------------------------------- Lançadores de Pop-Ups (fim ) --------------------------------------------
            //--------------------------------------------------------------------------------------------------------------

            async function liberaNaoLiberaItems(liberar, textObsLib, vlrLib, afterFunction) {
                await vendaMaisService.getAmbienteInfoVendaMais().then(function (ambienteInfo) {
                    self.sasId = ambienteInfo.sasId;
                    self.enviroment = ambienteInfo.enviroment;
                    self.codParc = ambienteInfo.codParc;
                });
                
                await vendaMaisService.getCnpjParceiro(self.dsLibLimites.getFieldValueAsString('CODPARC')).then(function (dadosCnpj){
                    self.cnpj = dadosCnpj.cnpj;
                    self.razaoSocial = dadosCnpj.razaoSocial;
                    self.tipPessoa = dadosCnpj.tipPessoa;
                });

                if (self.vendaMais) {
                    await carregarTiposNegociacaoOperacao();
                    await carregarLimiteVendaMaisSeNecessario();
                }
                
                var evento = self.dsLibLimites.getFieldValueAsString("EVENTO")

                if (self.dsLibLimites != null) {
                    if (self.vendaMais && self.exVendaMais === "S" && self.usaVendaMais === "S" && angular.isUndefined(vlrLib)) {
                        vlrLib = self.dsLibLimites.getFieldValueAsNumberOrZero("VLRATUAL");
                    }

                    if(self.vendaMais && self.exVendaMais === "S" && self.usaVendaMais === "S" && self.limiteVendaMais < vlrLib && liberar != 'N' && evento === "3"){
                        const msg = "O Valor de Crédito Venda Mais solicitado é maior que o Valor disponível (R$" + self.limiteVendaMais + "). Solicite uma nova análise de crédito através da opção 'Solicitar análise de crédito'. ";
                        MessageUtils.simpleConfirmBuilder().msg(msg).okLabel('Solicitar análise de crédito').noLabel('Voltar')
                            .showAsWarning(true).show()
                            .then(function () {
                                vendaMaisService.abrirPopUpSolicitacaoCredito($scope, {
                                        'sasId': self.sasId,
                                        'partnerCode': self.dsLibLimites.getFieldValueAsString('CODPARC'),
                                        'namePartner': self.razaoSocial,
                                        'pathTemplate': 'creditRequest',
                                        'isFinance': true,
                                        'personType': self.tipPessoa,
                                        'urlVendaMais': self.urlVendaMais,
                                        'dataSet': self.dsLibLimites,
                                        'razaoSocial': self.razaoSocial,
                                })
                            });
                    }else{
                        var itens = [];

                        self.dsLibLimites.getSelectedRecordsAsObjects(undefined, true).forEach(function (item) {
                            item = {
                                nuChave: item["NUCHAVE"],
                                evento: item["EVENTO"],
                                nucll: item["NUCLL"],
                                seqCascata: item["SEQCASCATA"],
                                sequencia: item["SEQUENCIA"],
                                tabela: item["TABELA"]
                            };
                            itens.push(item);
                        });

                        var exists = function (value) {
                            return typeof value !== 'undefined';
                        };

                        var parametro = {
                            params: {
                                itens,
                                usuario: self._strCodUsuLiberador,
                                liberar: liberar ? liberar : "",
                                obsLib: textObsLib ? textObsLib : "",
                                vlrLib: isNaN(vlrLib) ? 0.0 : vlrLib,
                                ...(exists(self.checkConfirmarAutomaticamente) && { confirmarNotaAutomaticamente: self.checkConfirmarAutomaticamente == "S" ? 'true' : 'false' }),
                                ...(exists(self.checkCompensarAutomaticamente) && { compensarNotaAutomaticamente: self.checkCompensarAutomaticamente == "S" ? 'true' : 'false' }),
                            }

                        };

                        if (self.ehCentral) {
                            parametro.params.nuNota = _strNuNota;
                        }

                        ServiceProxy.callService('mge@LiberacaoLimitesSP.liberarNegarLimites', parametro)
                            .then(function (result) {
                                var notas = ObjectUtils.getProperty(result, 'responseBody.notas');

                                if (notas != null && Object.keys(notas).length > 0) {
                                    confirmarNotas(null, { "notas": { "compensarNotaAutomaticamente": (self.checkCompensarAutomaticamente == "S" ? 'true' : 'false'), "nunota": notas.nunota } });
                                }

                                if (self.checkRecarregarLibNegacao == "S") {
                                    apply();
                                } else {
                                    self.dsLibLimites.refreshCurrentRow()
                                }

                                if (self.ehCentral) {
                                    _notaPossuiLibPendente = ObjectUtils.getProperty(result, 'responseBody.possuiLibPendente');
                                }

                                // função sem usabilidade até o momento
                                if (afterFunction != null) {
                                    afterFunction();
                                }
                            });
                    }
                }
            }

            async function carregarTiposNegociacaoOperacao() {
                let tabela = self.dsLibLimites.getFieldValueAsString("TABELA");
                let nuNota = self.dsLibLimites.getFieldValueAsString("NUNOTA");
                let isTabelaCabecalhoNota = tabela === 'TGFCAB' && StringUtils.isNotEmpty(nuNota);

                if (!isTabelaCabecalhoNota) {
                    return;
                }

                await vendaMaisService.getDadosTipoNegociacao(self.dsLibLimites.getFieldValueAsString("NUNOTA")).then(function (result){
                    self.exVendaMais = result;
                });

                await vendaMaisService.getDadosTipoOperacao(self.dsLibLimites.getFieldValueAsString("NUNOTA")).then(function (result){
                    self.usaVendaMais = result;
                });
            }

            async function carregarLimiteVendaMaisSeNecessario() {
                let habilitadoParaVendaMais = self.exVendaMais === "S" && self.usaVendaMais === "S";

                if (!habilitadoParaVendaMais) {
                    return;
                }

                await vendaMaisService.getSituacaoFinanceira(self.cnpj).then(function (limiteVendaMais) {
                    self.limiteVendaMais = limiteVendaMais;
                });
            }

            function processaLiberacoes(liberacoes) {
                var liberacoesPendentes = ArrayUtils.toArray(liberacoes);
                PopupLiberacoes
                    .builder()
                    .title(i18n('Commons.Liberacoes.titleLiberacoesSolicitadas'))
                    .ajustaPercLibLim(_ajustaPercLibLim)
                    .liberacoes(liberacoesPendentes)
                    .show();
            }
            
            function setNuNota(nuNota) {
            	_strNuNota = nuNota;
            	_notaPossuiLibPendente = null;
            	self.lblLiberacoes = i18n('Commons.Liberacoes.labelLiberacaoNota', [_strNuNota]);
            }
            
            function voltarParaCentral() {
            	self.dsLibLimites.clearDataSet();
            	self.nomeUsu = "";
            	self.senhaUsu = "";
				self._strCodUsuLiberador = undefined;
				
            	if (_callBackCentral) {
            		_callBackCentral({temLibPendente: _notaPossuiLibPendente});
            	}
            }

            function abrirFichaParceiro() {
                var codParc = self.dsLibLimites.getFieldValueAsString('CODPARC');

                SkApplicationInstance.openApp('br.com.sankhya.com.cons.fichaParceiro', {
                    CODPARC: codParc
                });

            }

            // Função chamada em vários locais da tela, configurável no popup de "Configurações"
            function agendarRefreshDaTela() {
                if (!isNaN(self.intervaloAtualizacaoAuto) && self.intervaloAtualizacaoAuto > 0) {
                    if (!isNaN(self._intervalId)) {
                        clearInterval(self._intervalId);
                    }

                    self._intervalId = setInterval(function () {
                    	if(!self.refreshing && StringUtils.emptyAsNull(self._strCodUsuLiberador) != null){
                    		self.refreshing = true;
                            self.oldSelectedItem = self.dsLibLimites.getSelectedRecords(true);
                            disableButtons();
                            self.dsLibLimites.refresh();
                    	}                       
                    }, self.intervaloAtualizacaoAuto * 1000);
                }
            }


            function setDateInterval() {

                var currentDate = new Date();

                self.periodo.dtIni = currentDate;
                self.periodo.dtFin = currentDate;

                switch (self.filtroPeriodos) {
                    case "VAZIO":
                    	self.periodo.dtIni = undefined;
                    	self.periodo.dtFin = undefined;
                        break;
                    case "7DIAS":
                        self.periodo.dtIni = DateUtils.subtract(self.periodo.dtFin, 7);
                        break;
                    case "30DIAS":
                        self.periodo.dtIni = DateUtils.subtract(self.periodo.dtFin, 30);
                        break;
                    case "60DIAS":
                        self.periodo.dtIni = DateUtils.subtract(self.periodo.dtFin, 60);
                        break;
                    default:

                        break;
                }
            }

            function validLine(line) {

                if (self.refreshing && self.oldSelectedItem) {
                    self.refreshing = false;
                }

                if (line > -1) {

                    self._sequenciaLiberacao = self.dsLibLimites.getFieldValueAsString("SEQUENCIA");

                    var possuiNuNota = self.dsLibLimites.getFieldValueAsString("NUNOTA") != "";
                    var eventoFechamento = self.dsLibLimites.getFieldValueAsNumber("EVENTO") == EVENTO_FECHAMENTO_CONTABIL_FISCAL;
                    var eventoDestVerba = self.dsLibLimites.getFieldValueAsNumber("EVENTO") == EVENTO_LIB_LIMITE_DESTINACAO_VERBA;
                    self.btnDetalhesNota.enabled = possuiNuNota || eventoFechamento || eventoDestVerba;
                    self.btnRentabilidade.enabled = possuiNuNota;
                    self.popExibSaldoMetas.enabled = possuiNuNota;
                    self.popConfirmarNota.enabled = possuiNuNota;

                    if("TGFCVR-TGFIVR".indexOf(self.dsLibLimites.getFieldValueAsString("TABELA")) > -1){
						self.btnRentabilidade.enabled = false;
						self.btnDetalhesNota.enabled = false;
					} else {
						isVendaAssitida = false;			
					}
					
                    self.btnFichaParc.enabled = self.dsLibLimites.getFieldValueAsNumberOrZero("CODPARC") != 0;
                    self.btnNegarLiberacao.enabled = !self.dsLibLimites.isEmpty() && (self.dsLibLimites.getFieldValue("DHLIB") == null || self.dsLibLimites.getFieldValueAsString("REPROVADO") == "N");
                   
                    let vlrAtual = NumberUtils.getNumberOrZero(self.dsLibLimites.getFieldValueAsNumberOrZero("VLRATUAL"), 4);
					let vlrLiberado = NumberUtils.getNumberOrZero(self.dsLibLimites.getFieldValueAsNumberOrZero("VLRLIBERADO"), 4);
                
                    self.btnLiberar.enabled = !self.dsLibLimites.isEmpty() && (self.dsLibLimites.getFieldValue("DHLIB") == null || self.dsLibLimites.getFieldValueAsString("REPROVADO") == "S" || (vlrAtual > vlrLiberado));

                    self.popExibAprovacoesReprovacoes.enabled = possuiNuNota || self.dsLibLimites.getFieldValueAsString("TABELA") == "TGFFIN";
                    self.popDescFinanc.enabled = self.dsLibLimites.getFieldValue("DHLIB") == null && self.dsLibLimites.getFieldValueAsString("TABELA") == "TGFFIN";

                    //self.popAbrirTela.label = resourceManager.getString('Commons:Liberacoes', self.dsLibLimites.getFieldValueAsString("TABELA") == "TGFFIN" ? "messageAbrirMovFin" : "messageAbrirCentral");
                    self.popAbrirTela.enabled = "TGFFIN-TGFCAB-TGFITE-TGFCON2-TGFCOI2".indexOf(self.dsLibLimites.getFieldValueAsString("TABELA")) > -1;

                    self.btnDetalhesConf.enabled = self.dsLibLimites.getFieldValueAsString("EVENTO") == CORTE_EM_CONFERENCIA;

                    if (possuiNuNota) {
                        carregaItensNota()
                    }else{
                       self.dsItemNota.clearDataSet();
                    }

                } else {

                    disableButtons();
                }
            }

            function disableButtons() {

                self.btnDetalhesNota.enabled = false;
                self.btnFichaParc.enabled = false;
                self.btnNegarLiberacao.enabled = false;
                self.btnLiberar.enabled = false;
                self.btnRentabilidade.enabled = false;
                self.btnDetalhesConf.enabled = false;

                self.popExibAprovacoesReprovacoes.enabled = false;
                self.popDescFinanc.enabled = false;
                self.popExibSaldoMetas.enabled = false

                self.popAbrirTela.enabled = false;

                self.popConfirmarNota.enabled = false;
            }


            function changeSouLiberador() {
                var CodUsuLiberador = SkApplicationInstance.getUserID();
                if (CodUsuLiberador == 0) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Liberacoes.messageSupNaoLibera'));
                    self.souLiberador = "N";
                    return false;
                }
            }


            function carregaItensNota() {

                if (self.dsItemNota.getCriteriaProvider().length > 0) {
                    self.dsItemNota.removeCriteriaProviderIndex(0);
                }

                self.tableName = self.dsLibLimites.getFieldValueAsString('TABELA');

                self.dsItemNota.addCriteriaProvider(self.criteriaProviderItens);
                self.dsItemNota.refresh();
            }

            function getCrteriaItensNota() {
                var field = self.tableName == 'TGFCVR' ? 'NUCVR' : self.tableName == 'TGFIVR' ? 'NUCVR' : 'NUNOTA';

                var nunota = self.dsLibLimites.getFieldValueAsNumberOrZero("NUNOTA");
                ctr = Criteria();
                ctr.append(" this." + field + " = ?", Criteria.buildNumberParameter(nunota));
                if(field != null && field !== 'NUCVR'){
                    ctr.append(" AND this.SEQUENCIA > 0");
                }

                return ctr;
            }

            function mostrarRentabilidade() {
				var nuNota = 0;
				linhasSelecionadas = self.dsLibLimites.getSelectedRecordsAsObjects();
				if(linhasSelecionadas.length == 0){
					nuNota = self.dsLibLimites.getFieldValueAsNumberOrZero("NUNOTA");
				} else {
					linhasSelecionadas.forEach(function(row){
						if((row.TABELA == "TGFCAB" || row.TABELA == "TGFITE") && nuNota == 0 ){
							nuNota = row.NUNOTA;
						} 
	                });
                }
                
                RentabilidadePopUpService.openPopUp(
                    nuNota,
                    SkApplicationInstance.getUserID()
                );
            };

            function editObservacao(item, txtObsLib) {
                if (self.dsLibLimites != null) {

                    var parametro = {
                        param: {
                            obslib: txtObsLib,
                            item
                        }
                    }
                  
                    if (self.dsLibLimites.getCurrentIndex() == -1) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING,i18n('mge.LiberacaoLimites.lblSelecNota'));
                        return;
                    }

                    ServiceProxy.callService(
                        "mge@LiberacaoLimitesSP.editarObservacao", parametro).then(function (response) {
                            self.dsLibLimites.refreshCurrentRow();
                        }, true);
                }
            };

            function interceptMetadata(fields) {
                fields.forEach(function(field){
                    if(field.name == 'Parceiro.ComplementoParc.Cidade.NOMECID'){
                        field.description = i18n('Commons.Liberacoes.lblNomeCidadeEntrega');
                    }
                }); 
            }
            
            function interceptColumnMetadata(fieldMetadata, dataset) {
				var fieldName = fieldMetadata.name;
				
				if (fieldName == "QTDNEG") {
                    fieldMetadata.customCellFormatter = function (value, column, data) {
        				return formatNumber(value, NumberUtils.getNumberOrZero(ObjectUtils.getProperty(data, 'Produto.DECQTD')));
    				};
                } else if (fieldName == "VLRUNIT") {
                    fieldMetadata.customCellFormatter = function (value, column, data) {
        				return formatNumber(value, NumberUtils.getNumberOrZero(ObjectUtils.getProperty(data, 'Produto.DECVLR')));
    				};
                }
			}
			
			function formatNumber(value, precision, prettyPrecision) {
            	return NumberUtils.formatWithoutThousandSeparator(StringUtils.isNotEmpty(value) ? value : 0, StringUtils.isNotEmpty(precision) ? precision : 2, prettyPrecision);
            }

            function acaoDoubleClickLiberacao(){
            	if(_liberaCliqueDuplo){
                    if(self.dsLibLimites.getFieldValueAsNumber("VLRLIBERADO") > 0){
                        mostraPopUpLiberacaoNegacao(false);
                    } else {
                        mostraPopUpLiberacaoNegacao(true);
                    }
            	} else {
            		liberaNaoLiberaItems();
            	}
            }

            function removeTextoLongoDosParametros(){
                const removeParamHab = MGEParameters.asBoolean("mge.excl.txtlglimite");
                if(!removeParamHab){
                    return self.dsLibLimites.getCurrentRowAsObject();
                }else{
                    const linha = self.dsLibLimites.getCurrentRowAsObject();
                    var linhaSemParamLongo = {};
                    Object.keys(linha).map(key => {
                        if(StringUtils.nullAsEmpty(linha[key]).toString().length < 50) {
                            linhaSemParamLongo[key] = linha[key];
                        } 
                    });

                    return linhaSemParamLongo;
                }
            }

            function buildParamsProdutos(){
                let entity = self.tableName == 'TGFCVR' ? 'ItemPedidoVR' : self.tableName == 'TGFIVR' ? 'ItemPedidoVR' : 'ItemNota';

                fieldsNames = self.dsItemNota.getFieldNames();

                if (entity == 'ItemPedidoVR'){
                    fieldsNames = fieldsNames.map((name) => {
                        if (name == 'SEQUENCIA'){
                            return 'SEQIVR'
                        } else if (name == 'NUNOTA'){
                            return 'NUCVR'
                        }

                        return name;
                    }).filter((name) => !['OBSERVACAO', 'VLRDESCBONIF', 'VLRREPRED'].includes(name))
                }

                var params = {
                    entityName: entity,
                    criteria: getCrteriaItensNota(),
                    fields: fieldsNames,
                    crudListener: "br.com.sankhya.modelcore.crudlisteners.LiberacaoLimitesItemNotaCrudListener"
                }

                return params;
            }

            function buildProduto(response){
                results = response.responseBody.result;
                produtos = [];

                results.forEach((result) => {
                    let prod = {};
                    fieldsNames.forEach((fieldName, index) => {
                        if (fieldName == 'SEQIVR'){
                            prod['SEQUENCIA'] = result[index];
                        } else if (fieldName == 'NUCVR'){
                            prod['NUNOTA'] = result[index];
                        } else {
                            prod[fieldName] = result[index];
                        }
                    });

                    produtos.push(prod);
                });


                return produtos;
            }

            function refreshHandlerItens(request){
                var params = buildParamsProdutos();

                ServiceProxy.callService('mge@DatasetSP.loadRecords', params)
                    .then(function(response){

                        var produtos = buildProduto(response);

                        self.dsItemNota.clearDataSet();
                        self.dsItemNota.addRecordsAsObjects(produtos, function(value) {
                            return value === undefined ? null : value;
                        });
                    })
            }

            function montaGadgetGetConf(nugdg, descgdg){

                    let params= { config: { chave: 'undefinedprompt-values', tipo: "T", usuario: SkApplicationInstance.getUserID() } }
                    let linhaParamGetConf={}
                     ServiceProxy.callService("mge@SystemUtilsSP.getConf", params).then(
                            function (result) {
                                var config= angular.isArray(result.responseBody.config.param)?result.responseBody.config.param:[result.responseBody.config.param]
                                    for (let index = 0; index < config.length; index++) {
                                        if(config[index] && config[index].hasOwnProperty("id")){
                                            linhaParamGetConf[config[index].id.toUpperCase()]=self.dsLibLimites.getFieldValue(config[index].id.toUpperCase());                                        
                                        }
                                    }
                                    PopUpGadgetsService.openPopUp(nugdg, descgdg, linhaParamGetConf);
                     })
            }
            
        }]);

angular
    .module('snk.commons')
    .directive('skContainerLiberacaoLimites',
        function () {
            return {
                templateUrl: 'commons/containerLiberacaoLimites/containerLiberacaoLimites.tpl.html',
                controller: 'containerLiberacaoLimitesController as ctrl',
                scope: {
                	componentCreated: '&skComponentCreated',
                    embedded: "=?embedded",
                    callBack:"&?callBack"
                }
            }
    });
angular
    .module('snk.commons')
    .controller('popUpOcorrenciasNotaServicoController', ['$scope', '$popupInstance', 'i18n', 'ServiceProxy', 'dataValue', 'btnVoltar', 'btnObservacao', 'btnOcorrencia','btnFechar',
        function ($scope, $popupInstance, i18n, ServiceProxy, dataValue, btnVoltar, btnObservacao, btnOcorrencia, btnFechar) {
            var self = this;

            self.onDatasetCreatedOne = onDatasetCreatedOne;
            self.onDatasetCreatedTwo = onDatasetCreatedTwo;
            self.onGridLoadedOne = onGridLoadedOne;
            self.onGridLoadedTwo = onGridLoadedTwo;
            self.refreshHandler = refreshHandler;
            self.mostraObservacao = mostraObservacao;
            self.mostraDetalheOcorrencia = mostraDetalheOcorrencia;
            self.verificaRowsGridNotas = verificaRowsGridNotas;
            self.verificaRowsGridOcorrencias = verificaRowsGridOcorrencias;

            self.telaOne;
            self.telaTwo;
            self.telaThree;

            self.gridNotas;
            self.gridOcorrencias;

            init();

            function init() {

                btnVoltar.on('click', voltar);
                btnObservacao.on('click', observacao);
                btnOcorrencia.on('click', ocorrencia);
                btnFechar.on('click', closePopUp);

                self.btnObsEnab = false;
                self.btnOcorEnab = true;

                self.telaOne = true;
                self.telaTwo = false;
                self.telaThree = false;
            }

            function onDatasetCreatedOne(dataset) {
                self.dsNotas = dataset;
                self.dsNotas.initAndRefresh();
            }

            function onDatasetCreatedTwo(dataset) {
                self.dsOcorrencia = dataset;
                self.dsOcorrencia.initAndRefresh();
            }

            function onGridLoadedOne(datagrid) {
                self.gridNotas = datagrid;
            }

            function onGridLoadedTwo(datagrid) {
                self.gridOcorrencias = datagrid;
            }

            function refreshHandler(request) {
                
                setTimeout(() => {
                    self.dsNotas.clearDataSet();

                    let Notas = !angular.isArray(dataValue.Notas) ? [dataValue.Notas] : dataValue.Notas

                        self.dsNotas.addRecordsAsObjects(Notas);
                        self.dsNotas.gotoRow(0);
                }
                ,200);

                setTimeout(() => {
                    self.dsOcorrencia.clearDataSet();

                    let Ocorrencias = !angular.isArray(dataValue.Ocorrencias) ? [dataValue.Ocorrencias] : dataValue.Ocorrencias

                    self.dsOcorrencia.addRecordsAsObjects(Ocorrencias);
                    self.dsOcorrencia.gotoRow(0);
                }
                ,200);
            }

            function mostraObservacao() {
                self.labelLoteNfe = i18n('Commons.Central.labelLoteNFe') + ": " + dataValue.Notas.numeroLoteNfe;
                self.textObservacaoNfe = dataValue.Notas.observacaoNfe;

                self.labelLoteNfse = i18n('Commons.Central.labelLoteNFSe') + ": " + dataValue.Notas.numeroLoteNfse;
                self.textObservacaoNfse = dataValue.Notas.observacaoNfse;

                self.telaOne = false;
                self.telaTwo = true;
                self.telaThree = false;
                
                angular.element(document.getElementById('buttonObservacao').style.visibility = "hidden");
                angular.element(document.getElementById('buttonOcorrencia').style.visibility = "hidden");
                angular.element(document.getElementById('buttonVoltar').style.visibility = "visible");

            }

            function mostraDetalheOcorrencia() {

                self.labelNumUnico = i18n('Commons.Central.labelLoteNFe') + ": " + dataValue.Ocorrencias.labelLoteNFe;
                self.labelNuNota = i18n('Commons.Central.labelLoteNFe') + ": " + dataValue.Ocorrencias.labelLoteNFe;
                self.labelDtOcorr = i18n('Commons.Central.labelLoteNFe') + ": " + dataValue.Ocorrencias.labelLoteNFe;
                self.labelUsuario = i18n('Geral.labelUsuario') + ": " + dataValue.Ocorrencias.labelUsuario;

                self.textDetalhe = dataValue.Notas.observacaoNfse;

                self.telaOne = false;
                self.telaTwo = false;
                self.telaThree = true;

                angular.element(document.getElementById('buttonOcorrencia').style.visibility = "hidden");
                angular.element(document.getElementById('buttonOcorrencia').style.visibility = "hidden");
                angular.element(document.getElementById('buttonVoltar').style.visibility = "visible");
                
            }
            
            function voltar() {

                self.telaOne = true;
                self.telaTwo = false;
                self.telaThree = false;

                angular.element(document.getElementById('buttonObservacao').style.visibility = "visible");
                angular.element(document.getElementById('buttonOcorrencia').style.visibility = "visible");
                angular.element(document.getElementById('buttonVoltar').style.visibility = "hidden");
            }

            function observacao() {
                self.telaOne = false;
                self.telaTwo = true;
                self.telaThree = false;    
                mostraObservacao();
            }

            function ocorrencia() {
                self.telaOne = false;
                self.telaTwo = false;
                self.telaThree = true;
                mostraDetalheOcorrencia();
            }

            function closePopUp(){
                $popupInstance.dismiss();
            }

            function verificaRowsGridNotas(){
                
                angular.element(document.getElementById('buttonObservacao').disabled = false);
            }
            function verificaRowsGridOcorrencias(){
                
                angular.element(document.getElementById('buttonOcorrencia').disabled  = false);
            }
        }]);
angular
	.module('snk.commons')
	.service('popUpOcorrenciasService', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;

			self.openPopup = openPopup;

			function openPopup(nota, ocorrencia) {

				var btnVoltar = angular.element('<button class="btn btn-default" id="buttonVoltar" style="visibility: hidden;">' + i18n( 'Commons.Liberacoes.labelVoltar') + '</button>');
                var btnObservacao = angular.element('<button class="btn btn-default" id="buttonObservacao" disabled="true">' + i18n('Commons.Central.buttonVerObservacao') + '</button>');
                var btnOcorrencia = angular.element('<button class="btn btn-default" id="buttonOcorrencia" disabled="true">' + i18n('Commons.Central.buttonVerOcorrencia') + '</button>');
                var btnFechar = angular.element('<button class="btn btn-default" id="buttonFechar">' +   i18n( 'Commons.Liberacoes.labelFechar') + '</button>');

                return SanPopup.open({
						title: i18n('Commons.Liberacoes.titleOcorrenciasConfirmacaoNotas'),
						templateUrl: 'commons/containerLiberacaoLimites/popup/central/popUpOcorrenciasNotaServico.tpl.html',
						controller: 'popUpOcorrenciasNotaServicoController',
						controllerAs: 'ctrl',
						size: 'lg',
						showBtnCancel: false,
						showBtnOk: false,
						rightBottomBar: [btnObservacao, btnOcorrencia, btnVoltar, btnFechar],
						resolve: {
							dataValue: {
								Notas: nota,
								Ocorrencias: ocorrencia
							},
							btnVoltar: function () {
								return btnVoltar;
							},
							btnObservacao: function () {
								return btnObservacao;
							},
							btnOcorrencia: function () {
								return btnOcorrencia;
							},
							btnFechar: function () {
								return btnFechar;
							}
						}
                });
			}
		}
    ]);
angular
    .module('snk.commons')
    .controller('configuracaoGadgetEventoPopUpController', ['$scope','ObjectUtils', '$popupInstance',
        function ($scope,ObjectUtils,$popupInstance) {
            var self = this;

            self.dsGadgetEventoLiberacao;
            self.onCreatePopOver = onCreatePopOver;
            self.getPopOverProperties = getPopOverProperties;
          
            ObjectUtils.implements(self, IDatagridInterceptor);

            // Implementação para criar dataset e Datagrid
            self.onDatagridLoaded = onDatagridLoaded;
            self.onDatasetCreated=onDatasetCreated;
            self.removeSelecionados=removeSelecionados;
            
            //Implementações do PopOver
            self.popoverMenuListeners = {onCreate: onCreatePopOver};
    		self._popover;
    		
			$scope.$dismiss = close;

            function onDatasetCreated(dataset) {
                if (dataset.getEntityName() == 'GadgetEventoLiberacao') {
                    self.dsGadgetEventoLiberacao = dataset;
                    self.dsGadgetEventoLiberacao.initAndRefresh();
                }
            }   
            
            function onCreatePopOver(popover) {
                self._popover = popover;
            }

            function close() {
                self._popover.hide();
                $popupInstance.dismiss();
            }


            function onDatagridLoaded(datagrid) {
                self.datagrid = datagrid;
            }

            function removeSelecionados(){
                    self.dsGadgetEventoLiberacao.getSelectedRecordsPks();
                    self.dsGadgetEventoLiberacao.removeCurrentRow(true);
            }
            
            function getPopOverProperties(){
            	return popOverProperties = {dsGadgetEventoLiberacao: self.dsGadgetEventoLiberacao};
            }
            
            $(document).on("click", ".click_me", function() {
            	self.dsGadgetEventoLiberacao.goToInsertionMode();
            });


}]);

angular
    .module('snk.commons')
    .controller('popoverComponentBIController', ['$scope', 'i18n','ServiceProxy','ObjectUtils',
        function ($scope, i18n, ServiceProxy,ObjectUtils) {
            var self = this;

            self.dsGadgetEventoLiberacao = $scope.properties().dsGadgetEventoLiberacao;	
            self.salvaEventoLiberacaoGadget = salvaEventoLiberacaoGadget;
            self.fechaPopOver = fechaPopOver;

            function fechaPopOver() {
                $scope.hide();                 
            }

            function salvaEventoLiberacaoGadget(){
                self.dsGadgetEventoLiberacao.save(false);      
                $scope.hide();                 
            }

}]);

angular
    .module('snk.commons')
    .controller('liberacaoLimitesConfiguracoesController', ['$scope', '$popupInstance', 'i18n', 'ServiceProxy', 'dataValue', 'MessageUtils', 'SkApplication',
        function ($scope, $popupInstance, i18n, ServiceProxy, dataValue, MessageUtils, SkApplication) {

            var self = this;

            // Variáveis p/ o controller se comunicar com a view
            self.intervaloAtualizacaoAuto;
            self.filtroPeriodos;
            self.checkItensNota;
            self.checkRecarregarLibNegacao;
            self.checkConfirmarAutomaticamente;
            self.checkCompensarAutomaticamente;
            self.checkPendentesPadrao;
            self.checkFiltrarAbertura;
            self.resourceID = dataValue.resourceID;

            // Funções do controller
            self.verificaSup = verificaSup;

            // Variáveis e funções da tela pai
            var _dsItemNota = dataValue.dsItemNota;
            var _agendarRefreshDaTela = dataValue.agendarRefreshDaTela;

            // Opções do Combobox "Filtro de Períodos"
            self.optionsfiltroPeriodos = [
                { value: i18n('Commons.Liberacoes.lblHoje'), data: 'HOJE' },
                { value: i18n('Commons.Liberacoes.lbl7dias'), data: '7DIAS' },
                { value: i18n('Commons.Liberacoes.lbl30dias'), data: '30DIAS' },
                { value: i18n('Commons.Liberacoes.lbl60dias'), data: '60DIAS' },
                { value: i18n('Commons.Liberacoes.lblSemFiltro'), data: 'VAZIO' }
            ];

            // Funções para botões de "Confirmar" e "Cancelar"
            $scope.$success = confirmaConfiguracoes;
            $scope.$dismiss = closeMe;


            init();

            function init() {
                carregaTela();
            }

            function carregaTela() {
                self.intervaloAtualizacaoAuto = dataValue.intervaloAtualizacaoAuto;
                self.filtroPeriodos = dataValue.filtroPeriodos;
                self.checkItensNota = dataValue.checkItensNota;
                self.checkRecarregarLibNegacao = dataValue.checkRecarregarLibNegacao;
                self.checkConfirmarAutomaticamente = dataValue.checkConfirmarAutomaticamente;
                self.checkCompensarAutomaticamente = dataValue.checkCompensarAutomaticamente;
                self.checkPendentesPadrao = dataValue.checkPendentesPadrao;
                self.checkFiltrarAbertura = dataValue.checkFiltrarAbertura;
            }

            function verificaSup() {
                if (self.checkFiltrarAbertura && SkApplication.instance().getUserID() === 0) {
                    self.checkFiltrarAbertura = 'N';
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Liberacoes.msgProibidoCarregarTelaSup'));
                }
            }

            function saveConfigPopUpTela() {
                var params = {
                    config: {
                        chave: self.resourceID + ".configuracao",
                        tipo: 'T',
                        mostrarItensNota: { $: self.checkItensNota == "S" ? 'true' : 'false'  },
                        recarregarLiberacaoNegacao: { $: self.checkRecarregarLibNegacao == "S" ? 'true' : 'false'  },
                        confirmarAutomaticamente: { $: self.checkConfirmarAutomaticamente == "S" ? 'true' : 'false'  },
                        compensarAutomaticamente: { $: self.checkCompensarAutomaticamente == "S" ? 'true' : 'false'  },
                        tempoParaRefresh: { $: self.intervaloAtualizacaoAuto },
                        tipoFiltroPeriodo: { $: self.filtroPeriodos },
                        pendentesPadrao: { $: self.checkPendentesPadrao == "S" ? 'true' : 'false'  },
                        filtrarAbertura: { $: self.checkFiltrarAbertura == "S" ? 'true' : 'false'  }
                    }
                };

                ServiceProxy.callService("mge@SystemUtilsSP.saveConf", params)
                    .then(function () {
                        closeMe();
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            }

            function confirmaConfiguracoes() {
                if (self.checkItensNota === 'S') {
                    // _dsItemNota.refresh();
                }
                properties = { checkItensNota: self.checkItensNota,
                			   recarregarLiberacaoNegacao: self.checkRecarregarLibNegacao,
                			   confirmarAutomaticamente: self.checkConfirmarAutomaticamente,
                			   compensarAutomaticamente: self.checkCompensarAutomaticamente,
                			   tempoParaRefresh: self.intervaloAtualizacaoAuto,
                			   tipoFiltroPeriodo: self.filtroPeriodos,
                			   pendentesPadrao: self.checkPendentesPadrao,
                			   filtrarAbertura: self.checkFiltrarAbertura
                }
                
                $popupInstance.success(properties)
                _agendarRefreshDaTela();
                saveConfigPopUpTela();
            }

            function closeMe() {
                $popupInstance.dismiss();
            }
        }]);
angular
	.module('snk.commons')
	.controller('detalhesConferenciaPopupController', ['$scope', '$popupInstance', 'i18n', 'StringUtils', 'NumberUtils', 'dataValue', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils',
		function ($scope, $popupInstance, i18n, StringUtils, NumberUtils, dataValue, ServiceProxy, ObjectUtils, ArrayUtils) {
			var self = this;

			const _white = '#ffffff';
			const _redColor = '#d84a38'; 

			//Implementors
            ObjectUtils.implements(self, IDatagridInterceptor);

			self.onDatasetCreated = onDatasetCreated;
			self.onGridLoaded = onGridLoaded;
			self.dsDetalhesConf;
			self.refreshHandler = refreshHandler;
			self.getCellColors = getCellColors;

			function onDatasetCreated(dataset) {
				self.dsDetalhesConf = dataset;
				self.dsDetalhesConf.initAndRefresh();
			}

			function onGridLoaded(datagrid) {
				self.gridDetalhesConf = datagrid;
			}

			function refreshHandler(request) {
				ServiceProxy.callService("mgecom@ConferenciaSP.getDetalhesConferencia", {
					params: {
						"nuNota": dataValue.nuNota
					}
				})
					.then(function (response) {

						if (angular.isUndefined(response.responseBody.produtos.produto)) {
							console.log("Entrou no undefined !!");
							return;
						}

						var produtos = response.responseBody.produtos.produto;

						if(!Array.isArray(produtos)){
							produtos = [produtos];
						}

						self.dsDetalhesConf.whenMetadataLoaded().then(function () {
							self.dsDetalhesConf.addRecordsAsObjects(recordsRow(produtos), function (value) {
								return value === undefined ? null : value;
							});
						});

					});

			}

			function recordsRow(produtos) {
				var prod = [];
				console.log(produtos)
				produtos.forEach(row => {
					row.QTDCONFERIDA = row.QTDCONFERIDA.$;
					row.QTDPEDIDO = row.QTDPEDIDO.$;
					row.CODPROD = row.CODPROD.$;
					row.DIFERENCA = row.DIFERENCA.$;
					row.CONTROLE = row.CONTROLE.$;
					row.DESCRPROD = row.DESCRPROD.$;

					prod.push(row);
				});

				return prod;
			}

			function getCellColors(row, col, rowIndex, colIndex) {
                var recdesp = self.dsDetalhesConf.getFieldIndexByName('DIFERENCA');
                if (angular.isDefined(row.entity)) {
                    if (row.entity[recdesp] != 0) {
                        return {
							textColor: _white,
					        bgColor: _redColor
						};
                    }
                }
            }
		}]);
angular
	.module('snk.commons')
	.controller('detalhesNotaController', ['$scope', '$popupInstance', 'i18n', 'StringUtils', 'NumberUtils', 'dataValue', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils',
		function ($scope, $popupInstance, i18n, StringUtils, NumberUtils, dataValue, ServiceProxy, ObjectUtils, ArrayUtils) {
			var self = this;

			var _nuNota = dataValue.nuNota;

			self.pesqEmp = dataValue.pesqEmp;
			self.numNotanumNota = dataValue.numNotanumNota;
			self.serie = dataValue.serie;
			self.dtNegociacao = dataValue.dtNegociacao;
			self.dtPrevent = dataValue.dtPrevent;
			self.pesqParc = dataValue.pesqParc;
			self.pesqOperacao = dataValue.pesqOperacao;
			self.pesqNegocia = dataValue.pesqNegocia;
			self.pesqNatureza = dataValue.pesqNatureza;
			self.pesqCR = dataValue.pesqCR;
			self.pesqProj = dataValue.pesqProj;
			self.vlrNota = dataValue.vlrNota;
			self.primeiroVencimento = dataValue.primeiroVencimento;
			self.ultVenc = dataValue.ultVenc;
			self.prazoMedio = dataValue.prazoMedio;
			self.pesqVend = dataValue.pesqVend;
			self.observacao = dataValue.observacao;
			self.observacaoValorOriginal = dataValue.observacao;
			self.vlrDesconto = dataValue.vlrDesconto;
			self.vlrFrete = dataValue.vlrFrete;
			self.vlrDestaque = dataValue.vlrDestaque;
			self.vlrOutros = dataValue.vlrOutros;
			
            self.onChangeObservacao = onChangeObservacao;

			init();

			function init() {
				populaDados(_nuNota);
			}
			function populaDados(value) {

				ServiceProxy.callService(
					"mge@LiberacaoLimitesSP.getInformacoesNota", {
					params: {
						nuNota: value
					}
				}).then(function (response) {

					var informacoes = ObjectUtils.getProperty(response, 'responseBody.informacoes');

					self.pesqEmp = StringUtils.emptyAsNull(informacoes.codEmp);
					self.numNota = informacoes.numNota;
					self.serie = informacoes.serieNota;
					self.dtNegociacao = informacoes.dtNeg;
					self.dtPrevent = informacoes.dtPrevent;
					self.pesqParc = StringUtils.emptyAsNull(informacoes.codParc);
					self.pesqOperacao = StringUtils.emptyAsNull(informacoes.codTipoPer);
					self.pesqNegocia = StringUtils.emptyAsNull(informacoes.codTipVenda);
					self.pesqNatureza = StringUtils.emptyAsNull(informacoes.codNat);
					self.pesqCR = StringUtils.emptyAsNull(informacoes.codCencus);
					self.pesqProj = StringUtils.emptyAsNull(informacoes.codProj);
					self.vlrNota = NumberUtils.format(informacoes.vlrNota, 2);
					self.primeiroVencimento = informacoes.primeiroVenc;
					self.ultVenc = informacoes.ultimoVenc;
					self.prazoMedio = informacoes.prazoMedio;
					self.pesqVend = StringUtils.emptyAsNull(informacoes.codVend);
					self.observacao = informacoes.observacao;
					self.observacaoValorOriginal = informacoes.observacao;
					self.vlrDesconto = NumberUtils.format(informacoes.vlrDescTot, 2);
					self.vlrFrete = NumberUtils.format(informacoes.vlrFrete, 2);
					self.vlrDestaque = NumberUtils.format(informacoes.vlrDestaque, 2);
					self.vlrOutros = NumberUtils.format(informacoes.vlrOutros, 2);

					self.placa = informacoes.placa;

					if (informacoes.tipMov == "C" || informacoes.tipMov == "O") {
						self.lblVendedor = i18n("Commons.Liberacoes.lblComprador") + ":";
					} else {
						self.lblVendedor = i18n("Commons.Liberacoes.lblVendedor") + ":"
					}
				},
					true
				);
			}
			
            function onChangeObservacao() {
                self.observacao = self.observacaoValorOriginal;
            }
            
		}]);
angular
	.module('snk.commons')
	.controller('detalhesFechamentoCtbController', ['$scope', 'i18n', 'Criteria', 'dataValue', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils',
		function ($scope, i18n, Criteria, dataValue, ServiceProxy, ObjectUtils, ArrayUtils) {
			var self = this;

			var nuLiberacao = dataValue.nuLiberacao;

			self.onDatasetCreated = onDatasetCreated;
			self.dsLiberacaoBloqCtb;
			self.dsItensLiberacaoBloqCtb;

			init();

			function init() {
			
			}

			function onDatasetCreated(dataset){
				if (dataset.getEntityName() === 'LiberacaoBloqueioContabil') {
					self.dsLiberacaoBloqCtb = dataset;
					self.dsLiberacaoBloqCtb.addCriteriaProvider(getCriteria);
					self.dsLiberacaoBloqCtb.initAndRefresh();
                }

                if (dataset.getEntityName() === 'ItensLiberacaoBloqueioContabil') {
					self.dsItensLiberacaoBloqCtb = dataset;
					self.dsItensLiberacaoBloqCtb.initAndRefresh();
                }
			}

			function getCriteria() {
				var ctr = Criteria();

				if (nuLiberacao){
					ctr.append("this.NULIBERACAO = "+nuLiberacao);					
				}
				return ctr;
			}

		}]);
angular
	.module('snk.commons')
	.controller('detalhesImpostosController', ['$scope', 'i18n', 'Criteria', 'dataValue', 'ServiceProxy', 'ObjectUtils', 'SkApplicationInstance',
		function ($scope, i18n, Criteria, dataValue, ServiceProxy, ObjectUtils, SkApplicationInstance) {
			var self = this;

			var _nuNota = dataValue._nuNota;
			
			self.onDatasetCreated = onDatasetCreated;
			self.onDataGridLoaded = onDataGridLoaded;

			self.datagrid=null;
			self.dsImpostos=null;

            self.resourceID = SkApplicationInstance.getResourceID();
            $scope.gridConfig = self.resourceID + 'gridProdutos';

			init();

			function init() {
			}

			function onDatasetCreated(dataset) {
		
					self.dsImpostos = dataset;
					self.dsImpostos.init().then(getData);
					
                
			}

			function onDataGridLoaded(datagrid) {
				self.datagrid = datagrid;
			}

			function getData() {
				var params = {params:{
					NUNOTA : _nuNota
				}}

				ServiceProxy.callService('mge@LiberacaoLimitesSP.getInformacoesImpostos', params).then((res)=>{
			
					var imposto = ObjectUtils.getProperty(res,"responseBody.resultado.imposto");
					if(imposto) {
						atualizaDS(imposto);
					}
				});
			}

			function atualizaDS(imposto) {
				self.dsImpostos.clearDataSet();

				if(!angular.isArray(imposto)){
					imposto=[imposto];
				}
				self.dsImpostos.addRecordsAsObjects(imposto);
		

			}

			
		}]);
angular
	.module('snk.commons')
	.controller('detalhesProdutosController', ['$scope', 'i18n', 'Criteria', 'dataValue', 'ServiceProxy', 'ObjectUtils', 'SkApplicationInstance',
		function ($scope, i18n, Criteria, dataValue, ServiceProxy, ObjectUtils, SkApplicationInstance) {
			var self = this;

			var _nuNota = dataValue._nuNota;
			var _evento = dataValue._evento;
			self.onDatasetCreated = onDatasetCreated;
			self.onDataGridLoaded = onDataGridLoaded;

			self.datagrid = null;
			self.dsProdutos = null;

            self.resourceID = SkApplicationInstance.getResourceID();
            $scope.gridConfig = self.resourceID + 'gridProdutos';

			init();

			function init() {
			}

			function onDatasetCreated(dataset) {
				if (dataset.getEntityName() == 'Produto') {
					self.dsProdutos = dataset;
		
					self.dsProdutos.init().then(getData);
                }
			}

			function onDataGridLoaded(datagrid) {
				self.datagrid = datagrid;
			}

			function getData() {
				var params = {
					params: {
						NUNOTA: _nuNota,
						EVENTO: _evento
					}
				};

				ServiceProxy.callService('mge@LiberacaoLimitesSP.getInformacoesProdutos', params)
				.then(result => {
					self.dsProdutos.clearDataSet();
					
					var produtos = ObjectUtils.getProperty(result,"responseBody.resultado.produto");
					if (produtos) {
						atualizaDS(produtos);
					}
				});
			}

			function atualizaDS(produtos) {
				self.dsProdutos.clearDataSet();

				if ( ! angular.isArray(produtos) ) {
					produtos = [produtos];
				}

				self.dsProdutos.addRecordsAsObjects(produtos);
			}			
		}]);
angular
	.module('snk.commons')
	.controller('editarObservacaoPopUpController', ['$scope', '$popupInstance', 'i18n', 'ServiceProxy', 'dataValue', 'btnOk', 'btnCancelar',
		function ($scope, $popupInstance, i18n, ServiceProxy, dataValue, btnOk, btnCancelar) {

			var self = this;

			self.obsUmouVarias = dataValue.obsSolic;
			self.obsLib = dataValue.obsLib;
			self.itsSelecionados = dataValue.itensSelecionados;
			var _editObservacao = dataValue.editaObservacao;

			init();

			function init() {
				btnOk.on('click', edit);
				btnCancelar.on('click', closePopup);
			}

			function edit() {
			
				if (self.itsSelecionados.length >= 1) {
					self.itsSelecionados.forEach(function (item) {
						item = {
							nuChave: item.NUCHAVE,
							evento: item.EVENTO,
							nucll: item.NUCLL,
							seqCascata: item.SEQCASCATA,
							sequencia: item.SEQUENCIA,
							tabela: item.TABELA
						};
						_editObservacao(item, self.obsLib);
					});
				}
				closePopup()

			}
			function closePopup() {
				$popupInstance.dismiss();
			}

		}]);
angular
    .module('snk.commons')
    .controller('liberacaoNegacaoLimitesPopUpController', ['$scope', '$popupInstance', 'i18n', 'ServiceProxy', 'dataValue', 'StringUtils',
        function ($scope, $popupInstance, i18n, ServiceProxy, dataValue, StringUtils) {
            var self = this;

            self.possuiVariosItensSelec = dataValue.possuiVariosItensSelec;
            self.ehLiberacao = dataValue.liberacao;
            self.vlrLiberado;
            self.txtObsLib;
            self.valorLiberadoPrecision = getDecimalPlacesOrDefault(dataValue.valorLiberado);
            var _liberaNaoLiberaItems = dataValue.liberaNaoLiberaItems;
            
            if (angular.isDefined(self.possuiVariosItensSelec) && self.possuiVariosItensSelec) {
				if (self.ehLiberacao) {
					self.lblInformacao = StringUtils.toHtmlText(i18n('Commons.Liberacoes.labelLiberacaoUtilizacaoCampo'));
				} else {
					self.lblInformacao = StringUtils.toHtmlText(i18n('Commons.Liberacoes.labeNegacaoUtilizacaoCampo'));
				}
			} else {
                self.vlrLiberado = dataValue.valorLiberado;
            }

            $scope.$success = liberar;
            
            function liberar() {
            	_liberaNaoLiberaItems(self.ehLiberacao ? "S" : "N", self.txtObsLib, self.vlrLiberado, closePopup);
            }

            function closePopup() {
                $popupInstance.dismiss();
            }

            function getDecimalPlacesOrDefault(value) {
                if (typeof value === 'number') {
                  if (!isFinite(value)) return 2;
                  value = value.toString();
                }
              
                if (typeof value === 'string') {
                  const [_, decimalPart] = value.split('.');
                  return decimalPart ? decimalPart.length : 2;
                }
              
                return 2;
            }
        }]);
angular
    .module('snk.commons')
    .controller('observacaoComplPopUpController', ['data',
        function (data) {
            var self = this;
			completed();

    		function completed() {
    			if(angular.isDefined(data)){
				self.obsComp = data.obsComp;
				}
			}
          
        }]);
angular
	.module('snk.commons')
	.controller('resultadosOrcamentoController', ['$scope', '$popupInstance', 'i18n', 'dataValue', 'ServiceProxy', 'MessageUtils', 'NumberUtils',
		function ($scope, $popupInstance, i18n, dataValue, ServiceProxy, MessageUtils, NumberUtils) {

			var self = this;

			// Variáveis p/ o controller se comunicar com a view
			self.periodoOrcado;
			self.periodoSuplementacao;
			self.periodoAntecipacao;
			self.periodoTransferencias;
			self.periodoTransferenciaDeSaldo;
			self.periodoRealizado;
			self.periodoCompromisso;
			self.periodoSaldo;
			self.periodoPendenteDeConfirmacao;

			self.anoOrcado;
			self.anoSuplementacao;
			self.anoAntecipacao;
			self.anoTransferencias;
			self.anoTransferenciaDeSaldo;
			self.anoRealizado;
			self.anoCompromisso;
			self.anoSaldo;
			self.anoPendenteDeConfirmacao;

			// Constantes
			const DEFAULT_FONT_COLOR = '#3A3A3A';
			const RED_FONT_COLOR = '#F00';

			// Função para botão de "Cancelar"
			$scope.$dismiss = closeMe;


			init();


			function init() {
				zeraValores();
				getResultadoOrcamento();
			}

			function getResultadoOrcamento() {
				let parametros = {
					params: {
						nuNota: dataValue.NUNOTA
					}
				};

				ServiceProxy.callService('mge@LiberacaoLimitesSP.getResultadoOrcamento', parametros)
					.then(function (result) {
						self.periodoOrcado = formatDecimal(result.responseBody.resultado.periodo.orcado);
						self.periodoSuplementacao = formatDecimal(result.responseBody.resultado.periodo.suplementacao);
						self.periodoAntecipacao = formatDecimal(result.responseBody.resultado.periodo.antecipacao);
						self.periodoTransferencias = formatDecimal(result.responseBody.resultado.periodo.transferencias);
						self.periodoTransferenciaDeSaldo = formatDecimal(result.responseBody.resultado.periodo.transferenciaDeSaldo);
						self.periodoRealizado = formatDecimal(result.responseBody.resultado.periodo.realizado);
						self.periodoCompromisso = formatDecimal(result.responseBody.resultado.periodo.compromisso);
						self.periodoSaldo = formatDecimal(result.responseBody.resultado.periodo.saldo);
						self.periodoPendenteDeConfirmacao = formatDecimal(result.responseBody.resultado.periodo.pendenteDeConfirmacao);

						self.anoOrcado = formatDecimal(result.responseBody.resultado.ano.orcado);
						self.anoSuplementacao = formatDecimal(result.responseBody.resultado.ano.suplementacao);
						self.anoAntecipacao = formatDecimal(result.responseBody.resultado.ano.antecipacao);
						self.anoTransferencias = formatDecimal(result.responseBody.resultado.ano.transferencias);
						self.anoTransferenciaDeSaldo = formatDecimal(result.responseBody.resultado.ano.transferenciaDeSaldo);
						self.anoRealizado = formatDecimal(result.responseBody.resultado.ano.realizado);
						self.anoCompromisso = formatDecimal(result.responseBody.resultado.ano.compromisso);
						self.anoSaldo = formatDecimal(result.responseBody.resultado.ano.saldo);
						self.anoPendenteDeConfirmacao = formatDecimal(result.responseBody.resultado.ano.pendenteDeConfirmacao);
					})
					.then(function () {
						formataLabelporValor('periodoOrcado', self.periodoOrcado);
						formataLabelporValor('periodoSuplementacao', self.periodoSuplementacao);
						formataLabelporValor('periodoAntecipacao', self.periodoAntecipacao);
						formataLabelporValor('periodoTransferencias', self.periodoTransferencias);
						formataLabelporValor('periodoTransferenciaDeSaldo', self.periodoTransferenciaDeSaldo);
						formataLabelporValor('periodoRealizado', self.periodoRealizado);
						formataLabelporValor('periodoCompromisso', self.periodoCompromisso);
						formataLabelporValor('periodoSaldo', self.periodoSaldo);
						formataLabelporValor('periodoPendenteDeConfirmacao', self.periodoPendenteDeConfirmacao);

						formataLabelporValor('anoOrcado', self.anoOrcado);
						formataLabelporValor('anoSuplementacao', self.anoSuplementacao);
						formataLabelporValor('anoAntecipacao', self.anoAntecipacao);
						formataLabelporValor('anoTransferencias', self.anoTransferencias);
						formataLabelporValor('anoTransferenciaDeSaldo', self.anoTransferenciaDeSaldo);
						formataLabelporValor('anoRealizado', self.anoRealizado);
						formataLabelporValor('anoCompromisso', self.anoCompromisso);
						formataLabelporValor('anoSaldo', self.anoSaldo);
						formataLabelporValor('anoPendenteDeConfirmacao', self.anoPendenteDeConfirmacao);
					})
					.catch(function () {
						MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Liberacoes.msgErroAoExibirResultadosOrcamento'));
					});
			}

			function zeraValores() {
				self.periodoOrcado = 0;
				self.periodoSuplementacao = 0;
				self.periodoAntecipacao = 0;
				self.periodoTransferencias = 0;
				self.periodoTransferenciaDeSaldo = 0;
				self.periodoRealizado = 0;
				self.periodoCompromisso = 0;
				self.periodoSaldo = 0;
				self.periodoPendenteDeConfirmacao = 0;

				self.anoOrcado = 0;
				self.anoSuplementacao = 0;
				self.anoAntecipacao = 0;
				self.anoTransferencias = 0;
				self.anoTransferenciaDeSaldo = 0;
				self.anoRealizado = 0;
				self.anoCompromisso = 0;
				self.anoSaldo = 0;
				self.anoPendenteDeConfirmacao = 0;
			}

			function formatDecimal(valor) {
				return NumberUtils.format(valor, 2);
			}

			function formataLabelporValor(idElemento, valor) {
				if (Number(valor) < 0) {
					selecionaElemento(idElemento).style.color = RED_FONT_COLOR;
				} else {
					selecionaElemento(idElemento).style.color = DEFAULT_FONT_COLOR;
				}
			}

			function selecionaElemento(idElemento) {
				return document.getElementById(idElemento);

			}

			function closeMe() {
				$popupInstance.dismiss();
			}
		}]);
/* eslint-disable angular/function-type */
/**
* Created by automatic batch Wesley.Souza on 2019-11-29 16:11:58
*/

angular
	.module('snk.commons.controleNumeracaoPainel', ['snk'])
	.component('skControleNumeracaoPainel', {
        templateUrl: 'commons/controleNumeracaoPainel/controleNumeracaoPainel.tpl.html',
		controller: 'ControleNumeracaoPainelController',
		controllerAs: 'ctrl',
        bindings: {
            codTipoPer: '@skCodTipOper',
            baseNumeracao: '@skBaseNumeracao',
            tipoNumeracao: '@skTipoNumeracaoDataset',
            hasSimpleContent: '@skHasSimpleContent',
            telaTipoOperacao: '@skTelaTipoOperacao'
        }
    })
    .controller('ControleNumeracaoPainelController', ['ArrayUtils', 'TooltipBuilder', 'DomUtil', 'StringUtils', 'ServiceProxy', 'ObjectUtils', 'MessageUtils', 'Criteria', 'i18n', 'SanPopup', 'MGEParameters', 'SkApplicationInstance', 'SASUtil', 'MGEAuthorizationConstants', 'DoubleFacePanelConstants',
        function (ArrayUtils, TooltipBuilder, DomUtil, StringUtils, ServiceProxy, ObjectUtils,  MessageUtils, Criteria, i18n, SanPopup, MGEParameters, SkApplicationInstance, SASUtil, MGEAuthorizationConstants, DoubleFacePanelConstants) {
            var self = this;

            //Interceptors
            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, IDatagridInterceptor);
			ObjectUtils.implements(self, IFormInterceptor);
			ObjectUtils.implements(self, IDynaformInterceptor);

            // Variáveis do controlador disponíveis no template
			self.showPainelCategorias = false;
			self.treeCtrl = {};
			self._codModDoc = true;
			self._serie = true;
			self._automatico = true;
			self._ultCod = true;
			self._ultNotaTalao = true;

            //Implementações da interface IFormInterceptor
            self.acceptField = acceptField;
			self.acceptColumnField = acceptColumnField;
			self.interceptFieldElement = interceptFieldElement;


			// Funções do controlador disponíveis no template
			self.onDynaformLoaded = onDynaformLoaded;
            self.onDatasetCreated = onDatasetCreated;
            self.arvoreCategoriaChange = arvoreCategoriaChange;
			self.onToggleOrExpanded = onToggleOrExpanded;

            var _codTipOper = "";
			var _baseNumeracao = "";
			var _tipoNumeracao = "";
			var _hasSimpleContent = false;
			var _telaTipoOperacao = false;
			var _strArquivo;
			var _controllers = {};
			init();
			
			function init() {
				var _codTipOper = StringUtils.undefinedAsEmpty(self.codTipoPer);
				var _baseNumeracao = StringUtils.undefinedAsEmpty(self.baseNumeracao);
				var _tipoNumeracao = StringUtils.undefinedAsEmpty(self.tipoNumeracao);
				var _hasSimpleContent = StringUtils.toBoolean(self.hasSimpleContent);
				var _telaTipoOperacao = StringUtils.toBoolean(self.telaTipoOperacao);
			}

			function acceptField(fieldMD, dynaform, dataset) {
				if(ArrayUtils.isIn(['ARQUIVO'], fieldMD.name)){
					return false;
				}
				return true;
            }
            
            function acceptColumnField(fieldMD, fieldName){
				if(ArrayUtils.isIn(['ARQUIVO'], fieldMD.name)){
					return false;
				}
				return true;
            }

            function chaveNumeracao() {
				var result = "";

				switch (StringUtils.undefinedAsEmpty(_baseNumeracao)){
					case "P":
						result = "PEDVEN";
						break;

					case "V":
						result = "VENDA";
						break;

					case "T":
						result = "TOP";
						break;

					case "Q":
						result = "REQUIS";
						break;

					case "D":
						result = "DEVVEN";
						break;

					case "L":
						result = "LOTEPRODUC";
						break;

					case "O":
						result = "PEDCOM";
						break;

					case "C":
						result = "COMPRA";
						break;

					case "E":
						result = "DEVCOM";
						break;

					case "S":
						result = "SEMNUM";
						break;

					case "I":
						result = "IMP-";
						break;

					case "A":
					 	result = "DAV";
					 	break;

					case "":
						break;

					default:
						throw new CriteriaError(CriteriaError.ILLEGAL_CRITERIA_VALUE, i18n('Comercial.TiposOperacao.baseNumeracao') + ' ' + _baseNumeracao + ' ' + i18n('Comercial.TiposOperacao.naoPrevistaAPlic') + "\n" +
                           i18n('Comercial.TiposOperacao.corrijaParamCadastroTOper'));
				}
				return result;
            }

            function configureLayout() {
                _topFields = {};
                self.showPainelCategorias = StringUtils.emptyAsNull(_codTipOper) == null &&  StringUtils.emptyAsNull(_tipoNumeracao) == null &&  StringUtils.emptyAsNull(_baseNumeracao) == null;
				
				arvoreTop.selectedIndex = 0;
				buscaTiposDeMovimento();
				addLabelArvore();
			}
			
            function buscaTiposDeMovimento() {
				ServiceProxy.callService('TipoOperacaoSP.montaArvore', {
					criterio : {
						retornaTops: true
					}
				}).then(function(resp){
					var camposDaArvore = resp.responseBody.todasCategorias;
					
					//Nivel 0
					self.nodes = {
						description: camposDaArvore.DESCRICAO,
						label: camposDaArvore.DESCRICAO,
						data: camposDaArvore,
						children: [], 
						icon: 'folder-plus'
					};
				   
                    //Nivel1 
                    self.nodes.children.push(getNode(camposDaArvore.tiposMov, 'folder-closed'));
                    self.nodes.children.push(getNode(camposDaArvore.grupos, 'folder-closed'));
                    self.nodes.children.push(getNode(camposDaArvore.tops, 'folder-closed'));
                    
                    //Nivel 2
                    self.nodes.children[0].children = buildNodes(camposDaArvore.tiposMov.tipMov);
                    self.nodes.children[1].children = buildNodes(camposDaArvore.grupos.Grupo);
					 self.nodes.children[2].children = buildNodes(camposDaArvore.tops.top);	
				});
            }
            
            function arvoreCategoriaChange (branch) {
                var categoria = branch.data;
                arvoreTop.selectedItem = categoria;

                _codTipOper = categoria.CODTIPOPER;
				_baseNumeracao = categoria.BASENUMERACAO;
				_tipoNumeracao = categoria.TIPONUMERACAO;
				
				//checking if is not Simple Content
				if(categoria == undefined || !categoria.hasOwnProperty("tipoItem") || categoria.tipoItem != "TOP"){
                    _hasSimpleContent = false;                    
				} else{
					_hasSimpleContent = true;
				}
				addLabelArvore();
				self.dsControleNumeracao.refresh();
			}

            function addLabelArvore() {
				if(_hasSimpleContent){
					self.lblTopArvoreText = arvoreTop.selectedItem.DESCRICAO;
				}else{
					self.lblTopArvoreText = i18n('Comercial.TiposOperacao.selectTipoOper');
				}
			}

            function onToggleOrExpanded(row) {
                if(row.branch.expanded){
                    row.icon = 'folder-open';
                    row.tree_icon = 'glyphicons glyphicons-folder-open';
                }else{
                    row.icon = 'folder-closed';
                    row.tree_icon = 'glyphicons glyphicons-folder-closed';
                }
            }

            function buildNodes(data) {
                var nodes = [];

                for (var i = 0; i < data.length; i++){					
                	if (data[i].top == null) {
                	    var childNode = getNode(data[i]);
                		nodes.push(childNode);
                	} else {
						var tops = [];
						tops = tops.concat(data[i].top);
						var parentNode = getNode(data[i], 'folder-closed');
                	    for(var j = 0; tops != null && j < tops.length; j++){
							var childNode = getNode(tops[j]);
                            parentNode.children.push(childNode);
                        }
                        nodes.push(parentNode);
                	}
				}
                return nodes;
            }

            function getNode(data, icon){
                return {
                    description: data.DESCRICAO,
                    label: data.DESCRICAO,
                    data: data,
                    children: [],
					icon: icon ||'file'
                };
			}
            
            function getCriteria(){
				var exp;
                var params = [];
				var codEmpIni;
                var codEmpFim;

                codEmpIni = "1";

                if(arvoreTop.selectedItem == null && !_hasSimpleContent && StringUtils.emptyAsNull(_codTipOper) == null){
					exp = "1 = 0";
				} else{
					if(_baseNumeracao == "T"){
						_strArquivo = "TOP-" + _codTipOper;
					} else if(_baseNumeracao == "I"){
						_strArquivo = "IMP-0001";
					} else{
						_strArquivo = chaveNumeracao();
					}
                }
                if(_tipoNumeracao == "U"){
                    codEmpFim = "1";
                } else{
                    codEmpFim = "9999";
                }

                exp = "this.ARQUIVO = ? AND this.CODEMP >= ? AND this.CODEMP <= ?";
                params.push(Criteria.buildStringParameter(StringUtils.undefinedAsEmpty(_strArquivo)));
                params.push(Criteria.buildNumberParameter(codEmpIni));
                params.push(Criteria.buildNumberParameter(codEmpFim));
                
				return Criteria(exp, params);
            }

			function onDynaformLoaded(dynaform, dataset){
				dynaform.goToGridView();
				onDatasetCreated(dataset);
			}

			function onDatasetCreated(dataset) {
                self.dsControleNumeracao = dataset;

                self.dsControleNumeracao.readAuthorizarionData(SkApplicationInstance.getAuthorizationData());

                self.dsControleNumeracao.addInsertionModeListener(function() {
                    if(!_hasSimpleContent && StringUtils.emptyAsNull(_codTipOper) == null || arvoreTop.selectedItem.hasOwnProperty("@TODAS")){
                        mostraMensagemLimpaDataSet();
                    } else{
                        self.dsControleNumeracao.setFieldValue("ARQUIVO", _strArquivo);
                        self.dsControleNumeracao.setFieldValue("SERIE", " ");
                        self.dsControleNumeracao.setFieldValue("AUTOMATICO", "N");
                        self.dsControleNumeracao.setFieldValue("ULTCOD", 0);
                        self.dsControleNumeracao.setFieldValue("ULTNOTATALAO", 32700);
                        self.dsControleNumeracao.setFieldValue("QTDAVISO", 0);
                        self.dsControleNumeracao.setFieldValue("CODMODDOC", 0);
                    }
                });

                self.dsControleNumeracao.addCriteriaProvider(getCriteria);

                self.dsControleNumeracao.addLineChangeListener(function(line){
					if (_baseNumeracao) {
						if(_controllers["CODMODDOC"]){
							_controllers["CODMODDOC"].setEnabled(_baseNumeracao === "V");
						}

						if(_controllers["SERIE"]){
							_controllers["SERIE"].setEnabled(_baseNumeracao != "A");
						}

						if(_controllers["AUTOMATICO"]){
							_controllers["AUTOMATICO"].setEnabled(_baseNumeracao != "S" && _baseNumeracao != "A");
						}
						if (_controllers["ULTCOD"]) {
							_controllers["ULTCOD"].setEnabled(_baseNumeracao != "S" && _baseNumeracao != "A");
						}

						if (_controllers["ULTNOTATALAO"]) {
							_controllers["ULTNOTATALAO"].setEnabled(_baseNumeracao != "S" && _baseNumeracao != "A");
						}
					}
				});

                self.dsControleNumeracao.beforePostAction(function(){
                    self.dsControleNumeracao.addTXProperty("br.com.sankhya.mgecom.cad.ControleNumeracao", "true");
					if(arvoreTop.selectedItem == null && StringUtils.emptyAsNull(_codTipOper) == null){
						mostraMensagemLimpaDataSet();
						return false;
					}
					return true;
                });

                self.dsControleNumeracao.setOrderByExpression("CODEMP");

				self.dsControleNumeracao.initAndRefresh();

                configureLayout();

                if(self.treeCtrl.refresh !== undefined){
					self.treeCtrl.refresh();
					self.treeCtrl.expand_all();
				}
            }

            function mostraMensagemLimpaDataSet() {
                MessageUtils.showInfo(MessageUtils.TITLE_WARNING, i18n('Comercial.TiposOperacao.tipoOperDevSerInfor'))
                    .then(function(){                            
                        self.dsControleNumeracao.clearDataSet();  
                    });
			}
			
			function interceptFieldElement(fieldName, element, controller) {
				if (["CODMODDOC","SERIE", "AUTOMATICO", "ULTCOD","ULTNOTATALAO"].includes(fieldName)) {
					_controllers[fieldName] = controller;
				}
			}
		}]);
angular
    .module("snk.commons")
    .service("ServiceCPFPinPad", ["i18n", "MessageUtils", "TEF", "MGEParameters",
    function(i18n, MessageUtils, TEF, MGEParameters){

        const self = this;

        self.obterCpfPinPad = obterCpfPinPad;
    
        function obterCpfPinPad(){
            return new Promise ( (resolve, reject) => {
                const gateWay = MGEParameters.asInteger("mgefin.tef.gateway");
                if (gateWay !=3) {
                    reject('Implementação funcional apenas para o SITEF.');
                    return;
                }
                const params = buildTEFParams();
                if(!params) {
                    reject('falha na construção dos parametros da requisição para o TEF.');
                    return;
                }
                TEF.execute(params, processaRetorno => {
                    try {
                        resolve(processaRetorno.responseTef);
                    } catch (error) {
                        reject(error);
                    }
                }
                );
            })
        }

        function buildTEFParams(){
            try{
                const params  = new Object();
                params.operacao = TEF.DIGITA_CPF;
                return params;
            }catch(err){
                return null;
            }
        };

        function processaRetorno(dadosRetorno) {
            if (TEF.temErro(dadosRetorno)) {
                return 'ERROR: ' + dadosRetorno.responseTef.codigoErro + ' Falha de comunicação com o ' + dadosRetorno.requestTef.gateway;
            }
            record = buildResponse(dadosRetorno);
            return record;
        }

        function buildResponse({ requestTef, responseTef }) {
            try {
              const record = new Object();
              record.operacao = requestTef.operacao;
              record.retorno = responseTef.retorno;
              record.retornoCpfPinPad = responseTef.retornoCpfPinPad;
              return record;
            } catch (err) {
              return null;
            }
        }        
}]);
angular
    .module('snk.commons')
    .controller('DescontoGradeProdutoPopupController', ['$scope', '$popupInstance', 'popupInfo', 'SkConstants', 'ObjectUtils',
        function ($scope, $popupInstance, popupInfo, SkConstants, ObjectUtils) {
            
			var self = this;

			self.dsControle;
			self.datagrid;

			ObjectUtils.implements(self, IDatagridInterceptor);
			self.interceptColumnMetadata = interceptColumnMetadata;
            
            self.onDatasetCreated = onDatasetCreated;
			self.onDatagridLoaded = onDatagridLoaded;

			self.confirmar = confirmar;
			self.cancelar = cancelar;
			self.onKeyDown = onKeyDown;
            self.findControle = findControle;
			self.textCriteria;

			var _controles;
			var _isFocusSearch = false;
            
            function onDatasetCreated(dataset) {
            	self.dsControle = dataset;
				dataset.init().then(function() {
					updateControle(popupInfo);
                });

				dataset.addLineChangeListener(function (newIndex) {
					setFocusSearch();
				});
            }

			function onDatagridLoaded(datagrid) {
                self.datagrid = datagrid;
            }
            
            function updateControle(popupInfo) {
				
				var lista = popupInfo.lista;
				
				var controlesSelecionados = popupInfo.controlesSelecionados;
				
            	self.dsControle.clearDataSet();

				var records = [];
            	lista.forEach(function(item) {
					var record = {CONTROLE: item.data.$,  DESCRCONTROLE: item.label.$};
					records.push(record);
				});
				
				self.dsControle.addRecordsAsObjects(records, null, true);
				self.dsControle.sortRecords();
				
				var index = [];
				records.forEach(function(record) {
					if (controlesSelecionados.indexOf(record.CONTROLE) > -1) {
						var item = records.indexOf(record);
						index.push(self.dsControle.getRecord(item));
					}
				});
				self.dsControle.setSelectedRecords(index);
			}

			function confirmar() {

				var records = self.dsControle.getSelectedRecordsAsObjects();

				_controles = [];
				records.forEach(function(record) {
					_controles.push(record.CONTROLE.toString());
				});
            		
				$popupInstance.success(_controles);
			}

			function cancelar (){
				$popupInstance.dismiss();
			}

			function onKeyDown(evt) {
         	   switch (evt.keyCode) {
 			       case SkConstants.KEY_CODE.ENTER:
 			    	  setTimeout(()=> { 
 			        	   findControle();
 			           }, 200);
 			           break;
 			       default:
 			           break;
 			   }
            }
            
            function findControle() {
            	_isFocusSearch = true;
            	var matchedItens = [];
            	var pattern = self.textCriteria;
            	
            	var re = new RegExp(pattern, "i");
            	var records = self.dsControle.getRecordsAsObjects();
            	
            	for (var index = 0; index < records.length; index++) {
            		var record = records[index];
            		var value = self.dsControle.dataToString(record['CONTROLE']);
            		if (re.test(value)) {
            			matchedItens.push(index);
            		}
            	}
            	
            	if (matchedItens.length > 0) {
            		var i = matchedItens[0];
            		for (var j = 0; j < matchedItens.length; j++) {
            			if (matchedItens[j] > self.dsControle.getCurrentIndex()) {
            				i = matchedItens[j];
            				break;
            			}
            		}
            		self.dsControle.gotoRow(i);
            	}
           }
            
            function setFocusSearch() {
				if (!_isFocusSearch) {
					return;
				}
				
			    var searchInput = document.getElementById('textCriteria');
			    searchInput = searchInput ? searchInput.getElementsByTagName('input')[0] : undefined;
			   
		        if (searchInput) {
		           setTimeout(()=> { 
		        	   searchInput.focus();
		        	   searchInput.click();
		        	   _isFocusSearch = false;
		           }, 200);
		        }
		    }

			function interceptColumnMetadata(fieldMetadata, dataset) {
                if (fieldMetadata.name == 'DESCRCONTROLE') {
					if(popupInfo.tipContEst == "G") {
						fieldMetadata.description =  "GRADE";
					} else if (popupInfo.tipContEst == "L") {
						fieldMetadata.description =  "LOTE";
					} else if (popupInfo.tipContEst == "S") {
						fieldMetadata.description =  "LISTA";
					}
                }
            }
            
    }]);

/**
 *
 * Exemplo:
 *
 *   var data = {
 *   	usaCustoPorEmpresa: true,
 *   	usaCustoPorLocal: false,
 *   	custoComFiltro: false
 *   };
 *
 *   DescontoGradeProdutoPopup(data)
 *   	.result.then(function (response) {
 *   });
 */
angular
	.module('snk.commons')
	.service('DescontoGradeProdutoPopup', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;

			self.show = show;

			function show(popupInfo) {
				var popupInstance = SanPopup.open({
						title: popupInfo.title,
						templateUrl: 'commons/descontopromocionais/desconto-grade-produto-popup.tpl.html',
						controller: 'DescontoGradeProdutoPopupController',
						controllerAs: 'ctrl',
						size: 'sm',
						height: 550,
						showBtnNo: false,
						showBtnOk: false,
						showBtnCancel: false,
						resolve: {
							popupInfo: popupInfo
						}
					});
				return popupInstance;
			}

		}
    ]);

/*
  Created by leonardo.mendes on 07/11/2020.
 */
angular
    .module('snk.commons.diagnosticoPreVenda')
    .directive('skDiagnosticoPreVenda',
        function () {
            return {
                templateUrl: 'commons/diagnosticoPreVenda/diagnosticoPreVenda.tpl.html',
                controller: 'DiagnosticoPreVendaController',
                controllerAs: 'ctrl',
                scope: {
                    onCreated: '&?skDiagnosticoCreated',
                    closeWizardHandler: '&?skCloseWizardHandler'
                }
            }
        })
    .controller('DiagnosticoPreVendaController', ['i18n', '$q', '$scope', 'ObjectUtils', 'ServiceProxy', 'ArrayUtils', 'NumberUtils', 'AngularUtil', 'MessageUtils', 'PerguntasService', 'StringUtils',
        function (i18n, $q, $scope, ObjectUtils, ServiceProxy, ArrayUtils, NumberUtils, AngularUtil, MessageUtils, PerguntasService, StringUtils) {
            var self = this;

            let _paginaPerguntas = {};
            let _curentIndexStep;

            var _timeCreated = null;
            var _numOs;
            var _codQuest;
            var _codFld;
            var _viewMode = false;
            var _podeAlterar = true;
            var _isDirty = false;
            let _steps = [];

            self.painelFiltroPerguntas = new ArrayList();
            self.textObservacao = '';
            self.paginaPergWizard = [];
            self.wizardContext = {};
            self.elementsFilter = [];
            self.mostrarFiltro = {};
            self.showFiltroPerguntas = false;

            self.unconditionalClose = unconditionalClose;
            self.podeAlterar = podeAlterar;
            self.labelHeader = labelHeader;
            self.buscarQuestionario = buscarQuestionario;
            self.salvarRespostas = salvarRespostas;
            self.clickObservacaoHandler = clickObservacaoHandler;
            self.closeWizard = closeWizard;
            self.finishWizard = finishWizard;
            self.onStepChange = onStepChange;
            self.paginaPerguntasCreated = paginaPerguntasCreated;
            self.aplicaFiltroPerguntas = aplicaFiltroPerguntas;

            function init() {
                if (angular.isFunction($scope.onCreated)) {
                    $scope.onCreated({
                        $component: {
                            unconditionalClose: unconditionalClose,
                            podeAlterar: podeAlterar,
                            labelHeader: labelHeader,
                            buscarQuestionario: buscarQuestionario
                        }
                    });
                }
            }

            function labelHeader(headerText) {
                self.headerText = headerText;
            }

            function podeAlterar(value) {
                if (arguments.length === 1) {
                    _podeAlterar = value;
                }

                return _podeAlterar;
            }

            function unconditionalClose() {
                if (angular.isFunction($scope.closeWizardHandler)) {
                    self.paginaPergWizard = [];
                    $scope.closeWizardHandler();
                    self.textObservacao = '';
                }
                _isDirty = false;
            }


            function buscarQuestionario(codQuest, numOs, codFld, onLoad) {
                clearVariaveis();

                _codQuest = codQuest;
                _numOs = numOs;
                _codFld = codFld;

                var _questionario = {
                    CODQUEST: _codQuest,
                    MODOVISUALIZACAO: _viewMode
                };

                if (_numOs > 0) {
                    _questionario['NUMOS'] = _numOs;
                }

                if (_codFld > 0) {
                    _questionario['CODFLD'] = _codFld;
                }

                ServiceProxy.callService('mgeos@DiagnosticoSP.carregarQuestionario', { 'QUESTIONARIO': _questionario })
                    .then(function (response) {
                        var _questinarios = ObjectUtils.getProperty(response, 'responseBody.QUESTIONARIO');
                        if (_questinarios) {
                            var _quest = _questinarios;
                            carregaQuestionario(_quest);

                            var _pesquisaRespondida = ObjectUtils.getProperty(_quest, 'PESQUISARESPONDIDA');
                            if (_pesquisaRespondida) {
                                carregaRespostas(_pesquisaRespondida);
                            }

                            (onLoad || angular.noop)();
                        }
                    });
            }

            function carregaRespostas(pesquisaRespondida) {
                self.textObservacao = ObjectUtils.getProperty(pesquisaRespondida, 'OBSERVACAO.$');

                ArrayUtils.toArray(pesquisaRespondida.PERGUNTA).forEach((pergElem) => {
                    self.wizardContext[pergElem.CODPERG] = pergElem;
                });
            }

            function carregaQuestionario(questionario) {
                _steps = [];
                var _count = 1;
                var _nuPesq = NumberUtils.getNumberOrZero(questionario.NUPESQ);

                if (questionario.hasOwnProperty("PERGUNTAABERTURA")) {
                    _steps.push({
                        respAbertura: questionario.RESPABERTURA,
                        perguntas: [{
                            pergunta: ObjectUtils.getProperty(questionario, 'PERGUNTAABERTURA.PERGUNTA'),
                            nuPesq: _nuPesq,
                            prefixoTitulo: String(_count),
                            validarAlteracao: validarAlteracao,
                            addEventChange: () => {
                                _isDirty = true;
                            }
                        }],
                    });

                    _count++;
                }

                var _nroPergporPag = NumberUtils.getNumberOrZero(questionario.NROPERGPORPAG);
                var _perguntas = [];
                ArrayUtils
                    .toArray(ObjectUtils.getProperty(questionario, 'PERGUNTAS.PERGUNTA'))
                    .forEach(perg => {

                        /*
                        (Não usado aqui) 6 - Grupo de pontuação
                        (Não usado aqui) 7 - Tabela de perguntas (Única escolha)
                        (Não usado aqui) 8 - Tabela de perguntas (Múltipla escolha)
                        */
                        if ('6-7-8'.indexOf(perg.TIPO) < 0) {
                            _perguntas.push({
                                pergunta: perg,
                                nuPesq: _nuPesq,
                                prefixoTitulo: String(_count),
                                validarAlteracao: validarAlteracao,
                                isFiltered: isFiltered,
                                addEventChange: () => {
                                    _isDirty = true;
                                }
                            });
                            _count++;
                        }
                    });

                var _pergPorPaginas = [];
                _perguntas.forEach(e => {
                    _pergPorPaginas.push(e);

                    if (_pergPorPaginas.length == _nroPergporPag) {

                        _steps.push({ 'perguntas': _pergPorPaginas });

                        _pergPorPaginas = [];
                    }
                });

                if (_pergPorPaginas.length > 0) {
                    _steps.push({ 'perguntas': _pergPorPaginas });
                }

                self.paginaPergWizard = [{ 'steps': _steps }];

                buildPerguntasFiltraveis();
            }

            function clickObservacaoHandler() {
                PerguntasService.clickObservacaoHandler(self.textObservacao).then(function (value) {
                    if (self.textObservacao != value) {
                        self.textObservacao = value;
                        _isDirty = true;
                    }
                });
            }

            $scope.getPropertiesInfo = function () {
                var deferred = $q.defer();

                deferred.resolve({ observacao: self.textObservacao });

                return deferred.promise;
            }

            function isFiltered(item) {
                var filtroLimpo = true;
                var filtrosAtivos = {};

                self.painelFiltroPerguntas.getItems().forEach(obj => {
                    if (obj.type == 'B' && StringUtils.toBoolean(obj.checked)) {
                        var gIndex = getGroupIndexFromPromptParamSource(obj);
                        var filtrosAtivosGrupo = {};
                        if (filtrosAtivos.hasOwnProperty(gIndex)) {
                            filtrosAtivosGrupo = filtrosAtivos[gIndex];
                        } else {
                            filtrosAtivosGrupo = {};
                            filtrosAtivos[gIndex] = filtrosAtivosGrupo;
                        }

                        filtrosAtivosGrupo[obj.paramName] = true;
                        filtroLimpo = false;
                    }
                });

                if (!filtroLimpo) {
                    ArrayUtils.forEach(ArrayUtils.toArray((item.getRespostasFilterSource || angular.noop)()), (r) => {
                        var respParamName = r.name;
                        var group = r.group;

                        var filtrosGrupo = filtrosAtivos[group];
                        if (filtrosGrupo != null && !filtrosGrupo.hasOwnProperty(respParamName)) {
                            filtroLimpo = true;
                            return false;
                        }
                    });

                    return filtroLimpo;
                }

                return false;
            }


            function getGroupIndexFromPromptParamSource(source) {
                var extraProperties = source.prop;
                if (extraProperties != null && extraProperties.hasOwnProperty('groupIndex')) {
                    return extraProperties.groupIndex;
                }
                return 0;
            }

            function onStepChange($step, $index) {
                _curentIndexStep = $index;
                montaFiltroPerguntasFiltraveis($index);
            }

            function buildPerguntasFiltraveis() {
                if (_steps.length == 0 || Object.keys(_paginaPerguntas).length != _steps.length) {
                    //Tempo de construcao do  componente, somente na primeira carga
                    _timeCreated = AngularUtil.timeout(() => {
                        buildPerguntasFiltraveis();
                    }, 100);
                } else {
                    if (_timeCreated) {
                        AngularUtil.cancelTimeout(_timeCreated);
                    }

                    Object.keys(_paginaPerguntas).forEach(pergKey => {

                        perg = _paginaPerguntas[pergKey];

                        var arrRespostaPorGrupo = [];

                        perg.getPerguntas().forEach((p) => {
                            arrRespostaPorGrupo = arrRespostaPorGrupo.concat(p.getFilterSource());
                        });

                        var arrRespostasFiltraveis = [];
                        if (arrRespostaPorGrupo.length > 0) {
                            arrRespostaPorGrupo = ArrayUtils.sortByStringProperty(arrRespostaPorGrupo, 'grupoLabel');

                            let _agrupamento = {};
                            arrRespostaPorGrupo.forEach((filterSource) => {
                                _agrupamento[filterSource.grupoLabel] = ArrayUtils.toArray(_agrupamento[filterSource.grupoLabel]);
                                _agrupamento[filterSource.grupoLabel].push(filterSource);
                            });

                            arrRespostaPorGrupo = [];
                            ObjectUtils.forEachInObject(_agrupamento, (grupoLabel, filtersSource) => {
                                ArrayUtils.pushAll(arrRespostaPorGrupo, ArrayUtils.sortByStringProperty(filtersSource, 'label'));
                            });

                            var lastGroup = null;
                            arrRespostaPorGrupo.forEach(resp => {
                                var groupName = resp.grupoLabel;
                                var properties = { groupIndex: resp.indGrupo };
                                if (groupName != lastGroup) {
                                    lastGroup = groupName;
                                    var grupoObj = { label: groupName, type: 'TITLE' };
                                    arrRespostasFiltraveis.push(grupoObj);
                                    arrRespostasFiltraveis.push({ label: i18n('Commons.diagnosticoPreVenda.lblNaoPreenchidoVazio'), paramName: '_void' + resp.indGrupo, type: 'B', prop: properties });
                                }
                                var paramName = resp.paramName;
                                var respFiltravel = { label: resp.label, paramName: paramName, type: 'B', prop: properties };

                                if (!existeRespostaCadastrada(arrRespostasFiltraveis, respFiltravel)) {
                                    arrRespostasFiltraveis.push(respFiltravel);
                                }
                            });
                        }

                        arrRespostasFiltraveis.forEach(respFiltravel => {
                            respFiltravel._typeFilter = pergKey + '_filter';
                            self.painelFiltroPerguntas.addItem(respFiltravel);
                        });
                    });

                    self.painelFiltroPerguntas.refresh();

                    montaFiltroPerguntasFiltraveis(0);
                }
            }

            function montaFiltroPerguntasFiltraveis($index) {
                self.painelFiltroPerguntas.setFilterFunction(function (value) {
                    return value._typeFilter == $index + '_filter';
                });

                self.painelFiltroPerguntas.refresh();

                self.showFiltroPerguntas = self.painelFiltroPerguntas.length() > 0;

                AngularUtil.digest($scope);
            }

            function existeRespostaCadastrada(arrRespostas, resposta) {
                return ArrayUtils.findIndex(arrRespostas, (resp) => resposta.hasOwnProperty('paramName') && resp.paramName == resposta.paramName) > -1;
            }

            function salvarRespostas(afterSave, forceExitCurrentStep) {
                if (validarAlteracao()) {

                    if (forceExitCurrentStep) {
                        Object.values(_paginaPerguntas).forEach((pagina) => {
                            pagina.exitStep();
                        });
                    }

                    var questElem = {
                        QUESTIONARIO: {
                            OBSERVACAO: { $: StringUtils.undefinedAsEmpty(self.textObservacao) },
                            CODQUEST: _codQuest,
                            NUMOS: _numOs,
                            CODFLD: _codFld,
                            PERGUNTA: Object.values(self.wizardContext)
                        }
                    };

                    ServiceProxy.callService('mgeos@DiagnosticoSP.responderQuestionario', questElem)
                        .then(function (response) {
                            _isDirty = false;

                            (afterSave || angular.noop)();
                        });
                }
            }

            function validarAlteracao() {
                if (!_podeAlterar) {
                    MessageUtils.showInfo(i18n('Commons.diagnosticoPreVenda.txtNegociacaoFechada'), i18n('Commons.diagnosticoPreVenda.avisoNegociacaoConcluida'));
                    return false;
                }

                return true;
            }

            function closeWizard() {
                if (_isDirty && !_viewMode) {
                    MessageUtils.confirm(i18n('Commons.diagnosticoPreVenda.questionarioModificado'), i18n('Commons.diagnosticoPreVenda.existemAlteracaoPendentes')).then(() => {
                        finishWizard();
                    }, (opcao) => {
                        if (opcao == 'no') {
                            unconditionalClose();
                        }
                    });
                } else {
                    unconditionalClose();
                }
            }

            function paginaPerguntasCreated(paginaPerguntas, index) {
                _paginaPerguntas[index] = paginaPerguntas;
            }

            function aplicaFiltroPerguntas() {
                _paginaPerguntas[_curentIndexStep].applyFilter();
            }

            function finishWizard() {
                if (_viewMode) {
                    unconditionalClose();
                } else {
                    salvarRespostas(() => {
                        closeWizard(null);
                    });
                }
            }

            function clearVariaveis() {
                _viewMode = false;
                _podeAlterar = true;
                _isDirty = false;
                _paginaPerguntas = {};
                self.textObservacao = '';
                self.paginaPergWizard = [];
                self.wizardContext = {};
                self.elementsFilter = [];
                self.painelFiltroPerguntas.clear();
                self.mostrarFiltro = {}
                self.showFiltroPerguntas = false;
            }

            init();
        }
    ]);
/**
 * Created by leonardo.mendes on 07/11/2020.
 */
angular
    .module('snk.commons.diagnosticoPreVenda')
    .directive('skGrupoRespostas', () => {
        return {
            restrict: 'E',
            templateUrl: 'commons/diagnosticoPreVenda/grupoRespostas/grupoRespostas.tpl.html',
            controller: 'GrupoRespostasController',
            controllerAs: 'ctrl',
            scope: {
                source: '=skSource',
                dataValue: '=skValue',
                pergunta: '=skPerguntaGrupo',
                usaComboBox: '=skUsaComboBox',
                multiSelecao: '=?skMultiSelecao',
                indGrupo: '@skIndGrupo',
                onUserChangeFunction: '=skUserChangeFunction',
                onSetValueFunction: '=skSetValueFunction',
                respPadrao: '@?skRespPadrao',
                grupoRespostasCreated: '&?skGrupoRespostasCreated',
                editable: '=?skEditable'
            }
        }
    }).controller('GrupoRespostasController', ['$scope', 'ArrayUtils', 'ObjectUtils', 'NumberUtils', 'AngularUtil',
        function ($scope, ArrayUtils, ObjectUtils, NumberUtils, AngularUtil) {
            var self = this;

            var _controle;
            var _respostasGrupo = [];
            var _respostasGrupoCreated = {};

            self.respostasGrupo = [];

            self.userChangeFunction = userChangeFunction;
            self.getRespostasSelecionadas = getRespostasSelecionadas
            self.getRespostas = getRespostas;
            self.limparRespostas = limparRespostas;

            function init() {
                self.value = $scope.respPadrao;
                if ($scope.usaComboBox) {
                    self.optionsResposta = ArrayUtils.toArray($scope.source.RESPOSTA).map((e) => {
                        return {
                            CODIGO: e.CODIGO,
                            value: e.DESCRICAO.$,
                            buildParamName: () => {
                                return $scope.indGrupo == 0 ? e.DESCRICAO.$ : $scope.indGrupo + "_" + e.DESCRICAO.$;
                            },
                            getTitulo: () => {
                                return e.DESCRICAO.$
                            },
                            getIndGrupo: () => {
                                return $scope.indGrupo;
                            }
                        };
                    });

                    _controle = true;

                    ArrayUtils.toArray(ObjectUtils.getProperty($scope, 'dataValue.RESPOSTA')).forEach((respElem) => {
                        var cod = respElem.CODRESP;

                        ArrayUtils.forEach(self.optionsResposta, (resp) => {
                            if (resp.CODIGO == cod) {
                                self.value = cod;
                                self.observacao = ObjectUtils.getProperty(respElem, 'OBSERVACAO.$');

                                return false;
                            }
                        });
                    });

                    doInit();
                } else {
                    self.radioSet = false;
                    if (!$scope.multiSelecao) {
                        self.radioSet = true;
                        _controle = true;
                    }

                    ArrayUtils.toArray($scope.source.RESPOSTA).forEach((r) => {
                        var resp = {
                            resposta: r,
                            CODIGO: r.CODIGO,
                            value: r.DESCRICAO.$,
                            respostaCreated: respostaCreated
                        }

                        _respostasGrupo.push(resp);

                    });

                    ArrayUtils.toArray(ObjectUtils.getProperty($scope, 'dataValue.RESPOSTA')).forEach((respElem) => {
                        var cod = respElem.CODRESP;

                        ArrayUtils.forEach(_respostasGrupo, (resp) => {
                            if (resp.resposta.CODIGO == cod) {
                                if (_controle) {
                                    self.value = cod;
                                    resp.resposta.observacao = ObjectUtils.getProperty(respElem, 'OBSERVACAO.$');
                                    return false;
                                } else {
                                    self.value = ObjectUtils.setProperty(self.value, cod, true);
                                    resp.resposta.observacao = ObjectUtils.getProperty(respElem, 'OBSERVACAO.$');
                                    return false;
                                }
                            }
                        });
                    });

                    self.respostasGrupo = _respostasGrupo;
                }

            }

            function doInit() {
                $scope.grupoRespostasCreated({
                    grupo: ObjectUtils.buildPublicAPI(self, 'getRespostasSelecionadas,getRespostas,limparRespostas')
                });
            }

            function limparRespostas() {
                if ($scope.usaComboBox) {
                    self.value = undefined;
                }

                self.respostasGrupo.forEach((resp) => {
                    resp.limparRespostas();
                });


                if (angular.isFunction($scope.onSetValueFunction)) {
                    $scope.onSetValueFunction();
                }
            }

            function respostaCreated(r) {
                _respostasGrupoCreated[r.getCodigo()] = r;

                //Somente neste momento acabou de criar as respostas
                if (self.respostasGrupo.length == Object.keys(_respostasGrupoCreated).length) {
                    self.respostasGrupo.forEach((resp) => {
                        angular.extend(resp, _respostasGrupoCreated[resp.CODIGO]);
                    });

                    doInit();
                }
            }

            function userChangeFunction() {
                $scope.dataValue = self.value;

                if (angular.isFunction($scope.onUserChangeFunction)) {
                    $scope.onUserChangeFunction(self);
                }
            }

            function getRespostasSelecionadas() {
                var selecao = [];

                if (_controle) {
                    var r = getResposta(NumberUtils.stringToNumber(self.value));
                    if (r != null) {
                        selecao.push(r);
                    }
                } else {
                    self.respostasGrupo.forEach((resp) => {
                        if (self.value && self.value[resp.CODIGO]) {
                            angular.extend(resp, resp.resposta);
                            selecao.push(resp);
                        }
                    });
                }

                return selecao;
            }

            function getResposta(codResp) {
                var _resposta = null;
                if ($scope.usaComboBox) {
                    _resposta = ArrayUtils.find(self.optionsResposta, resp => NumberUtils.stringToNumber(resp.CODIGO) == codResp)
                } else {
                    for (let i = 0; i < self.respostasGrupo.length; i++) {
                        if (NumberUtils.stringToNumber(self.respostasGrupo[i].CODIGO) == codResp) {
                            _resposta = self.respostasGrupo[i];
                            break;
                        }

                    }
                }

                return _resposta;
            }

            function getRespostas() {
                return $scope.usaComboBox ? self.optionsResposta : self.respostasGrupo;
            }

            init();
        }
    ]);
/**
 * Created by leonardo.mendes on 07/11/2020.
 */
angular
    .module('snk.commons.diagnosticoPreVenda')
    .directive('skPaginaPerguntas', () => {
        return {
            restrict: 'E',
            templateUrl: 'commons/diagnosticoPreVenda/paginaPerguntas/paginaPerguntas.tpl.html',
            controller: 'paginaPerguntasController',
            controllerAs: 'ctrl',
            scope: {
                dataPerguntas: '=skPerguntas',
                step: '=?skStepControl',
                paginaPerguntasCreated: '&?skPaginaPerguntasCreated'
            }
        }
    }).controller('paginaPerguntasController', ['$scope', 'ArrayUtils', 'ObjectUtils', '$q', '$timeout', 'AngularUtil',
        function ($scope, ArrayUtils, ObjectUtils, $q, $timeout, AngularUtil) {
            var self = this;

            let _perguntaCreated = {};

            $scope.step.onExitStep = exitStep;

            self.collapseAll = collapseAll;
            self.expandAll = expandAll;
            self.perguntaCreated = perguntaCreated;

            self.inicializada = false;
            self.perguntas = [];

            function init() {
                $scope.dataPerguntas.forEach((p) => {
                    var perg = angular.copy(p);

                    perg.value = $scope.step.wizardContext[perg.pergunta.CODIGO];

                    iteragePerguntas(perg.pergunta, (pergPend) => {
                        pergPend.value = $scope.step.wizardContext[pergPend.CODIGO];
                    });

                    perg.includeInLayout = true;

                    self.perguntas.push(perg);
                });
            }

            function perguntaCreated(pergunta, codigo) {
                _perguntaCreated[codigo] = pergunta;

                //Somente neste momento acabou de criar as perguntas
                if (self.perguntas.length == Object.keys(_perguntaCreated).length) {
                    self.perguntas.forEach((p) => {
                        angular.extend(p, _perguntaCreated[p.pergunta.CODIGO]);
                    });

                    $scope.paginaPerguntasCreated({
                        paginaPerguntas: {
                            getPerguntas: getPerguntas,
                            exitStep: exitStep,
                            applyFilter: applyFilter
                        }
                    });

                    $timeout(function () {
                        self.inicializada = true;
                    }, 100);
                }
            }

            function collapseAll() {
                Object.values(_perguntaCreated).forEach(perg => perg.collapse());
            }

            function expandAll() {
                Object.values(_perguntaCreated).forEach(perg => perg.expand());
            }

            function exitStep() {
                Object.values(_perguntaCreated).forEach((perg) => {
                    $scope.step.wizardContext = Object.assign($scope.step.wizardContext, perg.getDataValue());
                });
            }

            function exitStep() {
                self.perguntas.forEach((perg) => {
                    $scope.step.wizardContext = Object.assign($scope.step.wizardContext, perg.getDataValue());
                });
            }

            function getPerguntas() {
                return self.perguntas;
            }

            function iteragePerguntas(pergs, acao) {
                ArrayUtils.toArray(pergs).forEach((perg) => {

                    acao(perg);

                    var dependentes = ArrayUtils.toArray(ObjectUtils.getProperty(perg, 'PERGUNTASDEPENDENTES.PERGUNTA'));
                    if (dependentes.length > 0) {
                        iteragePerguntas(dependentes, acao);
                    }
                });
            }

            function applyFilter() {
                self.perguntas.forEach((perg) => {
                    perg.applyFilter(perg);
                });

                AngularUtil.digest($scope);
            }

            init();
        }
    ]);
/*
  Created by leonardo.mendes on 05/12/2020.
 */
angular
    .module('snk.commons.diagnosticoPreVenda')
    .directive('skPainelFiltroPerguntas', () =>  {
            return {
                templateUrl: 'commons/diagnosticoPreVenda/painelFiltroPerguntas/painelFiltroPerguntas.tpl.html',
                controller: 'painelFiltroPerguntasController',
                scope: {
                    perguntasFiltro: '=skPerguntasFiltro',
                    eventChange: '&?skChange',
                }
            }
    })
    .controller('painelFiltroPerguntasController', ['$scope', 'AngularUtil', 'StringUtils',
        function ($scope, AngularUtil, StringUtils) {

            $scope.notifyChange = () => {
                AngularUtil.timeout(function () {
                    ($scope.eventChange || angular.noop)();
                }, 0);
            }

            $scope.setSelectionValueAll = (value) => {
                $scope.perguntasFiltro.forEach((p) => {
                    if (p.type == 'B') {
                        p.checked = StringUtils.toBoolean(value);
                    }
                });

                $scope.notifyChange();
            }
        }
    ]);
/**
 * Created by leonardo.mendes on 08/11/2020.
 */
angular
    .module('snk.commons.diagnosticoPreVenda')
    .directive('skPergunta', () => {
        return {
            restrict: 'E',
            templateUrl: 'commons/diagnosticoPreVenda/pergunta/pergunta.tpl.html',
            controller: 'PerguntasController',
            controllerAs: 'ctrl',
            scope: {
                source: '=skSource',
                dataValue: '=?skValue',
                nuPesq: '@skNuPesq',
                perguntaPai: '=?skPerguntaPai',
                prefixoTitulo: '@skPrefixoTitulo',
                perguntaCreated: '&?skPerguntaCreated',
                eventChange: '=?skEventChange',
                isFiltered: '=?skIsFiltered',
                enableCollapse: '=?skEnableCollapse'
            }
        }
    }).controller('PerguntasController', ['MGEParameters', 'i18n', 'PerguntasService', '$scope', 'ObjectUtils', 'StringUtils', 'ArrayUtils', 'PerguntasConstant', 'UserAgentUtils', 'NumberUtils', 'AngularUtil',
        function (MGEParameters, i18n, PerguntasService, $scope, ObjectUtils, StringUtils, ArrayUtils, PerguntasConstant, UserAgentUtils, NumberUtils, AngularUtil) {
            var self = this;


            var _textControl = false;
            var _codigo;
            var _ignoreLimpezaGrupos
            var _timeCreated = null;
            var _mostrarDepTimer;

            const TIPO_TEXT_AREA = 'textArea';
            const TIPO_TEXT_INPUT = 'textInput';
            const TIPO_LISTA_ANEXOS = 'listaAnexos';

            var _gruposResposta;
            var _grupoRespostasCreated = [];
            var _perguntaPendCreated = {};

            self.perguntasDependentes = [];
            self.collapsed = false;
            self.subTipo = 'column';
            self.respostasMestre = [];


            self.onChange = onChange;
            self.collapse = collapse;
            self.expand = expand;
            self.limparRespostas = limparRespostas;
            self.anexoRespostaViewHandler = anexoRespostaViewHandler;
            self.clickObservacaoHandler = clickObservacaoHandler;
            self.mostraDependentes = mostraDependentes;
            self.perguntaPendCreated = perguntaPendCreated;
            self.dependenteAtivada = dependenteAtivada;

            function init() {
                var source = ObjectUtils.getProperty($scope, 'source') || {};
                self.respostas = [];

                _respostas = ArrayUtils.toArray(ObjectUtils.getProperty(source, 'GRUPOSRESPOSTA.GRUPO.RESPOSTA'));

                /* Tipos de perguntas:
                   0 - Caixa de texto (Única linha)
                   1 - Caixa de texto (Múltiplas linhas)
                   2 - Opções em linhas (Única escolha)
                   3 - Opções em colunas (Única escolha)
                   4 - Opções em linhas (Múltipla escolha)
                   5 - Opções em colunas (Múltipla escolha)
                  (Não usado aqui) 6 - Grupo de pontuação
                  (Não usado aqui) 7 - Tabela de perguntas (Única escolha)
                  (Não usado aqui) 8 - Tabela de perguntas (Múltipla escolha)
                  9 - Lista de Anexos
                 */

                var tipo = source.TIPO;
                self.subTipo = '1-2-4-9'.indexOf(tipo) > -1 ? 'column' : 'row';

                var multiSelecao = '4-5'.indexOf(tipo) > -1;
                switch (tipo) {
                    case PerguntasConstant.CAIXA_TEXTO_UNICA_LINHA:
                        self.tipoPergunta = TIPO_TEXT_INPUT;
                        _textControl = true;
                        break;
                    case PerguntasConstant.CAIXA_TEXTO_MULTIPLAS_LINHAS:
                        self.tipoPergunta = TIPO_TEXT_AREA;
                        _textControl = true;
                        break;
                    case PerguntasConstant.LISTA_ANEXO:
                        self.tipoPergunta = TIPO_LISTA_ANEXOS;
                        _usaPrefixo = false;
                        break;
                }

                var grupos = source.GRUPOSRESPOSTA.GRUPO;
                var usaComboBox = grupos.length > 1 || tipo == '3';
                _gruposResposta = [];

                var agrupamentosNaoEditaveis = MGEParameters.asString('mgeos.serv.prevenda.diagnostico.agrupamentos.nao.editaveis');

                var indGrupo = grupos.length > 1 ? 1 : 0;
                ArrayUtils.toArray(ObjectUtils.getProperty(source, 'GRUPOSRESPOSTA.GRUPO'))
                    .forEach((resp) => {
                        var _editable = true;
                        ArrayUtils.forEach(resp.RESPOSTA, (r) => {
                            _editable = StringUtils.isEmpty(agrupamentosNaoEditaveis) || StringUtils.undefinedAsEmpty(agrupamentosNaoEditaveis).indexOf(r.SEQAGRUPA) == -1;
                            return false;
                        });

                        var grupo = {
                            grupoElem: resp,
                            pergunta: self,
                            usaComboBox: usaComboBox,
                            multiSelecao: multiSelecao,
                            indGrupo: indGrupo,
                            editable: _editable,
                            onSetValueFunction: onSetValueFunction,
                            onUserChangeFunction: onUserChangeFunction,
                            grupoRespostasCreated: grupoRespostasCreated,
                            clickObservacaoHandler: clickObservacaoHandler
                        }

                        _gruposResposta.push(grupo);

                        indGrupo++;
                    });

                self.gruposResposta = _gruposResposta;

                self.obrigatoria = StringUtils.toBoolean(source.OBRIGATORIA);

                self.titulo = $scope.prefixoTitulo + ' - ' + ObjectUtils.getProperty(source, 'DESCRICAO.$');
                _codigo = source.CODIGO;

                self.permiteFiltrar = StringUtils.toBoolean(source.PERMITEFILTRAR) && '2-3-4-5'.indexOf(source.TIPO) > -1;

                if (source.hasOwnProperty('RESPOSTASMESTRE')) {
                    self.obrigatoria = false;
                }

                ArrayUtils.toArray(ObjectUtils.getProperty(source, 'PERGUNTASDEPENDENTES.PERGUNTA')).forEach(e => {
                    addPerguntaDep(e);
                });

                $scope.perguntaCreated({
                    pergunta: {
                        collapse: collapse,
                        expand: expand,
                        getDataValue: getDataValue,
                        limparRespostas: limparRespostas,
                        getFilterSource: getFilterSource,
                        getRespostasFilterSource: getRespostasFilterSource,
                        applyFilter: applyFilter
                    }
                });

                setDataValue();

                doInit();
            }

            function doInit() {
                if (self.gruposResposta.length > 0 && _grupoRespostasCreated.length != self.gruposResposta.length) {
                    //Tempo de construcao do  componente, somente na primeira carga
                    _timeCreated = AngularUtil.timeout(doInit, 200);
                } else {
                    mostraDependentes(getRespostasSelecionadas());
                    AngularUtil.cancelTimeout(_timeCreated);
                }
            }

            function grupoRespostasCreated(g) {
                _grupoRespostasCreated.push(g);
            }

            function onUserChangeFunction(g) {
                if (g) {
                    limpaGrupos(g);
                }
                onChange();
            }

            function onSetValueFunction(g) {
                if (g && !_ignoreLimpezaGrupos) {
                    limpaGrupos(g);
                }

                if (self.collapsed) {
                    expand();
                } else {
                    mostraDependentes(getRespostasSelecionadas());
                }
            }

            function onChange() {
                onSetValueFunction();

                $scope.eventChange();
            }

            function getDataValue() {
                let pergElem = {
                    CODPERG: _codigo
                }

                if (_textControl) {
                    pergElem.TEXTO = { '$': StringUtils.undefinedAsEmpty(self.value) };
                } else {
                    pergElem.RESPOSTA = [];
                    getRespostasSelecionadas().forEach(resp => {
                        let respElem = {
                            CODRESP: resp.CODIGO
                        };

                        if (StringUtils.isNotEmpty(ObjectUtils.getProperty(resp, 'resposta.observacao'))) {
                            respElem.OBSERVACAO = { '$': ObjectUtils.getProperty(resp, 'resposta.observacao') };
                        }

                        pergElem.RESPOSTA.push(respElem);
                    });
                }

                let _sourceDep = {};
                self.perguntasDependentes.forEach((e) => {
                    _sourceDep = Object.assign(_sourceDep, (e.getDataValue || angular.noop)());
                });

                let _source = {};
                _source[_codigo] = pergElem;

                return Object.assign(_source, _sourceDep);
            }

            function setDataValue() {
                if (angular.isDefined($scope.dataValue)) {
                    if (_textControl) {
                        self.value = ObjectUtils.getProperty($scope, 'dataValue.TEXTO.$');
                    } else {
                        self.value = $scope.dataValue;
                    }

                    //limpa grupos caso a resposta selecionada esteja configurada para isso...
                    _grupoRespostasCreated.forEach((grupo) => {
                        try {
                            _ignoreLimpezaGrupos = true;
                            limpaGrupos(grupo);
                        } finally {
                            _ignoreLimpezaGrupos = false;
                        }
                    });
                }
            }

            function onSetValueFunction(grupoRespostas) {
                if (grupoRespostas && !_ignoreLimpezaGrupos) {
                    limpaGrupos(grupoRespostas);
                }
                if (self.collapsed) {
                    expand();
                } else {
                    mostraDependentes(getRespostasSelecionadas());
                }
            }

            function getRespostasSelecionadas() {
                var selecao = [];

                _grupoRespostasCreated.forEach((grupo) => {
                    ArrayUtils.toArray((grupo.getRespostasSelecionadas || angular.noop)())
                        .forEach((resp) => {
                            selecao.push(resp);
                        });
                });

                return selecao;
            }

            function mostraDependentes(respSelecionadas) {
                if (self.perguntasDependentes.length > 0 && Object.keys(_perguntaPendCreated).length != self.perguntasDependentes.length) {
                    //Tempo de construcao do  componente, somente na primeira carga
                    _mostrarDepTimer = AngularUtil.timeout(function () {
                        mostraDependentes(getRespostasSelecionadas());
                    }, 100);
                } else {
                    if (_mostrarDepTimer != null) {
                        AngularUtil.cancelTimeout(_mostrarDepTimer);
                    }

                    self.perguntasDependentes.forEach((item) => {
                        var _mostrarPergunta = false;

                        if (!self.collapsed && (!angular.isFunction(item.isFiltered) || !item.isFiltered(item, item.getRespostasFilterSource()))) {
                            for (let i = 0; i < respSelecionadas.length; i++) {
                                if (item.pergunta.respostasMestre.indexOf(NumberUtils.stringToNumber(respSelecionadas[i].CODIGO)) > -1) {
                                    _mostrarPergunta = true;
                                    break;
                                }
                            }
                        }

                        item.includeInLayout = _mostrarPergunta;
                    });

                    AngularUtil.digest($scope);
                }
            }

            function dependenteAtivada(dep) {
                return ArrayUtils.findIndex(getRespostasSelecionadas(), resp => dep.pergunta.respostasMestre.indexOf(NumberUtils.stringToNumber(resp.CODIGO)) > -1) > -1;
            }

            function limpaGrupos(grupo) {
                if (grupo) {
                    var resp = (grupo.getRespostasSelecionadas || angular.noop)();
                    if(resp){
                        var limparGrupos = (resp.limpaGrupos || angular.noop)();
                        if (limparGrupos != null) {
                            limparGrupos.forEach(i => {
                                if (i > 0 && i <= _gruposResposta.length) {
                                    limparRespostas(i - 1);
                                }
                            });
                        }
                    }
                }
            }

            function applyFilter(value) {
                value.includeInLayout = true;

                if ($scope.perguntaPai != null && !$scope.perguntaPai.dependenteAtivada(value)) {
                    return;
                }

                value.includeInLayout = (!StringUtils.toBoolean(value.pergunta.PERMITEFILTRAR) || !value.isFiltered(value, getRespostasFilterSource()));

                return value.includeInLayout;
            }

            function addPerguntaDep(source) {
                self.perguntasDependentes = ArrayUtils.toArray(self.perguntasDependentes);

                //Normalizando para facilitar a verificacao
                source['respostasMestre'] = ArrayUtils.toArray(ObjectUtils.getProperty(source, 'RESPOSTASMESTRE.CODRESP'))
                    .map((codResp) => NumberUtils.stringToNumber(codResp.$));

                var perguntasDep = {
                    pergunta: source,
                    value: source.value,
                    nuPesq: $scope.nuPesq,
                    perguntaPai: self,
                    prefixoTitulo: $scope.prefixoTitulo + "." + (self.perguntasDependentes.length + 1),
                    validarAlteracao: $scope.validateAnexoHandler,
                    addEventChange: $scope.eventChange
                }

                self.perguntasDependentes.push(perguntasDep);
            }

            function perguntaPendCreated(pergunta, codigo) {
                _perguntaPendCreated[codigo] = pergunta;

                //Somente neste momento acabou de criar as perguntas
                if (self.perguntasDependentes.length == Object.keys(_perguntaPendCreated).length) {
                    self.perguntasDependentes.forEach((p) => {
                        angular.extend(p, _perguntaPendCreated[p.pergunta.CODIGO]);
                    });
                }
            }

            function collapse() {
                if ($scope.enableCollapse) {
                    self.collapsed = true;
                }
            }

            function expand() {
                if ($scope.enableCollapse) {
                    self.collapsed = false;
                }
            }

            function limparRespostas(codGrupo) {
                if (angular.isNumber(codGrupo)) {
                    for (let i = 0; i < self.gruposResposta.length; i++) {
                        const grupo = self.gruposResposta[i];
                        if (grupo.indGrupo == codGrupo) {
                            _grupoRespostasCreated[i].limparRespostas();
                            break;
                        }
                    }
                } else {
                    if (_textControl) {
                        self.value = "";
                    }

                    _grupoRespostasCreated.forEach(g => {
                        g.limparRespostas();
                    });

                    Object.values(_perguntaPendCreated).forEach(p => {
                        p.limparRespostas();
                    });
                }
            }

            function anexoRespostaViewHandler(resposta) {
                PerguntasService.visualizaAnexoResposta(_codigo, resposta.CODIGO);
            }

            function clickObservacaoHandler(resp) {
                PerguntasService.clickObservacaoHandler(resp.observacao).then(function (value) {
                    if (resp.observacao != value) {
                        resp.observacao = value;
                    }
                });
            }

            function getFilterSource() {
                var respostas = [];
                if (self.permiteFiltrar) {

                    var grupo = 1;
                    _grupoRespostasCreated.forEach(function (g) {
                        g.getRespostas().forEach(function (r) {
                            var grupoLabel;
                            if (r.getIndGrupo() == 0) {
                                grupoLabel = i18n('Commons.diagnosticoPreVenda.titleSemAgrupamento');
                            } else {
                                grupoLabel = i18n('Commons.diagnosticoPreVenda.titleAgrupamento', [grupo]);
                            }

                            respostas = respostas.concat({ grupoLabel: grupoLabel, label: r.getTitulo(), indGrupo: r.getIndGrupo(), paramName: r.buildParamName() });
                        });

                        grupo++;
                    });
                }

                Object.values(_perguntaPendCreated).forEach((pergDep) => {
                    respostas = respostas.concat(pergDep.getFilterSource());
                });

                return respostas;
            }


            function getRespostasFilterSource() {
                var selecao = [];

                _grupoRespostasCreated.forEach(grupo => {
                    var respostasGrupo = grupo.getRespostasSelecionadas();
                    if (respostasGrupo.length == 0) {
                        selecao.push({ name: '_void' + grupo.indGrupo, group: grupo.getIndGrupo });
                    } else {
                        respostasGrupo.forEach(resp => {
                            selecao.push({ name: resp.buildParamName(), group: resp.getIndGrupo() });
                        });
                    }
                });

                return selecao;
            }

            init();
        }]);
angular.module('snk.commons.diagnosticoPreVenda')
    .service('PerguntasService', ['ObjectUtils', 'ArrayUtils', 'Attach', 'SanPopup', 'i18n', 'StringUtils',
        function (ObjectUtils, ArrayUtils, Attach, SanPopup, i18n, StringUtils) {
            var self = this;

            self.visualizaAnexoResposta = visualizaAnexoResposta;
            self.visualizaAnexoLista = visualizaAnexoLista;
            self.clickObservacaoHandler = clickObservacaoHandler;
            self.getRespostaGrupo = getRespostaGrupo;

            function visualizaAnexoResposta(codPerg, codResp) {
                var pk = {
                    CODPERG: codPerg,
                    CODRESP: codResp
                }

                Attach.visualizaAnexo('RespostaPergunta', pk, 'ANEXO', 'NOMEARQUIVO');
            }

            function visualizaAnexoLista(nuPesq, codPerg, sequencia) {
                var pk = {
                    NUPESQ: nuPesq,
                    CODPERG: codPerg,
                    SEQUENCIA: sequencia
                }

                Attach.visualizaAnexo('AnexoPergunta', pk, 'CONTEUDO', 'NOMEARQUIVO');
            }


            function clickObservacaoHandler(observacao) {
                return SanPopup.open({
                    title: i18n('Commons.diagnosticoPreVenda.lblObservacao'),
                    template: '<sk-text-area sk-value="textObservacao" sk-height="282"></sk-text-area>',
                    controller: 'observacaoPopUpController',
                    size: 'md',
                    cancelBtnLabel: i18n('Geral.lblFechar'),
                    resolve: {
                        data: {
                            textObservacao: StringUtils.undefinedAsEmpty(observacao)
                        }
                    }
                }).result;
            }

            function getRespostaGrupo(item) {
                return ArrayUtils.toArray(ObjectUtils.getProperty(item, 'pergunta.GRUPOSRESPOSTA.GRUPO.RESPOSTA'));
            }
        }
    ])
    .controller('observacaoPopUpController', ['$scope', 'data', '$popupInstance',
        function ($scope, data, $popupInstance) {

            $scope.$success = success;

            init();
            function init() {
                $scope.textObservacao = data.textObservacao;
            }

            function success() {
                $popupInstance.success($scope.textObservacao);
            }
        }
    ]);
/**
 * Created by leonardo.mendes on 07/11/2020.
 */
angular
    .module('snk.commons.diagnosticoPreVenda')
    .directive('skResposta', () => {
        return {
            restrict: 'E',
            templateUrl: 'commons/diagnosticoPreVenda/resposta/resposta.tpl.html',
            controller: 'RespostaController',
            controllerAs: 'ctrl',
            scope: {
                source: '=skSource',
                dataValue: '=skValue',
                indGrupo: '@skIndGrupo',
                radioSet: '=?skRadioSet',
                editable: '=?skEditable',
                eventChange: '&?skChange',
                respostaCreated: '&?skRespostaCreated'
            }
        }
    }).controller('RespostaController', ['$scope', 'AngularUtil', 'ObjectUtils', 'PerguntasService', '$q', 'StringUtils', 'NumberUtils',
        function ($scope, AngularUtil, ObjectUtils, PerguntasService, $q, StringUtils, NumberUtils) {
            var self = this;


            var _limpaGrupos = null;

            self.onChange = onChange;
            self.anexoRespostaViewHandler = anexoRespostaViewHandler;
            self.clickObservacaoHandler = clickObservacaoHandler;
            self.isDisabled = isDisabled;

            $scope.$watch('dataValue', function (newValue, oldValue) {
                if (newValue != self.value) {
                    self.value = newValue;
                }
            });

            function init() {
                self.codigo = ObjectUtils.getProperty($scope, 'source.CODIGO');
                self.titulo = ObjectUtils.getProperty($scope, 'source.DESCRICAO.$');

                var strLimpaAgrupa = ObjectUtils.getProperty($scope, 'source.LIMPAAGRUPA');
                if (strLimpaAgrupa) {
                    var pieces = StringUtils.undefinedAsEmpty(strLimpaAgrupa).split(",");
                    pieces.forEach(agrupa => {
                        agrupa = StringUtils.emptyAsUndefined(agrupa);
                        if (!isNaN(Number(agrupa))) {
                            if (_limpaGrupos == null) {
                                _limpaGrupos = [];
                            }
                            _limpaGrupos.push(Number(agrupa));
                        }
                    });
                }

                $scope.respostaCreated({
                    resposta: {
                        buildParamName: buildParamName,
                        getTitulo: getTitulo,
                        getIndGrupo: getIndGrupo,
                        getCodigo: getCodigo,
                        limparRespostas: limparRespostas,
                        limpaGrupos: limpaGrupos
                    }
                });
            }

            function onChange() {
                $scope.dataValue = self.value;

                AngularUtil.timeout(function () {
                    ($scope.eventChange || angular.noop)();
                }, 0);
            }

            function buildParamName() {
                return $scope.indGrupo == 0 ? self.titulo : $scope.indGrupo + "_" + self.titulo;
            }

            function getTitulo() {
                return self.titulo;
            }

            function getIndGrupo() {
                return $scope.indGrupo;
            }

            function getCodigo() {
                return self.codigo;
            }

            function limparRespostas() {
                self.value = undefined;
                onChange();
            }

            function limpaGrupos() {
                return _limpaGrupos;
            }

            function anexoRespostaViewHandler(resposta) {
                PerguntasService.visualizaAnexoResposta(_codigo, resposta.CODIGO);
            }

            function clickObservacaoHandler(resp) {
                PerguntasService.clickObservacaoHandler(resp.observacao).then(function (value) {
                    if (resp.observacao != value) {
                        resp.observacao = value;
                    }
                });
            }

            $scope.getPropertiesInfo = function () {
                var deferred = $q.defer();

                deferred.resolve($scope.source);

                return deferred.promise;
            }

            function isDisabled() {
                if (!$scope.editable) {
                    return true;
                }

                if ($scope.radioSet) {
                    return NumberUtils.getNumberOrDefault(self.value, -1) != NumberUtils.stringToNumber(self.codigo);
                }

                return StringUtils.isEmpty(ObjectUtils.getProperty(self.value, self.codigo));
            }

            init();
        }
    ]);
angular
    .module('snk.commons.edicaoseriepopup')
    .service('EdicaoSeriePopUp', ['SanPopup', 'i18n',
        function (SanPopup, i18n) {
            var self = this;

            self.builder = builder;

            function builder() {
                return new EdicaoSeriePopUpBuilder();
            }

            function EdicaoSeriePopUpBuilder() {
                var defaultOptions = {
                    title: 'Comercial.CentralNotas.titleNumeroSerie',
                    cancelBtnLabel: 'Geral.buttonFechar',
                    backdrop: 'static',
                    height: 450,
                    size: 'md'
                };

                var _builder = this;

                var _options = {};
                _builder.option = function (key, value) {
                    _options[key] = value;
                    return _builder;
                };

                var _builderPopupOptions = ['title', 'height', 'backdrop', 'cancelBtnLabel', 'windowClass', 'size'];
                _builderPopupOptions.forEach(function (optionName) {
                    _builder[optionName] = function (value) {
                        return _builder.option(optionName, value);
                    }
                });

                var _data = {};
                _builder.data = function (key, value) {
                    _data[key] = value;
                    return _builder;
                };

                var _builderPopupData = ['setData'];
                _builderPopupData.forEach(function (optionName) {
                    _builder[optionName] = function (value) {
                        return _builder.data(optionName, value);
                    }
                });

                _builder.show = function () {
                    var options = angular.extend(defaultOptions, _options);

                    return SanPopup.open({
                        title: i18n(options.title),
                        templateUrl: 'commons/edicaoseriepopup/edicaoseriepopup.tpl.html',
                        controller: 'EdicaoSeriePopUpController',
                        controllerAs: 'ctrl',
                        size: options.size,
                        windowClass:options.windowClass,
                        showBtnCancel: true,
                        backdrop: options.backdrop,
                        cancelBtnLabel: i18n(options.cancelBtnLabel),
                        showBtnOk: false,
                        height: options.height,
                        leftBottomBar: ['<div id="lblTot"></div>'],
                        resolve: {
                            dataValue: _data.setData
                        }
                    })
                };
            }
        }]);


angular
	.module('snk.commons.edicaoseriepopup')
	.controller('EdicaoSeriePopUpController', ['SkPesquisaService', 'KeyboardManager', 'SkConstants', 'AngularUtil', '$scope', '$popupInstance', 'i18n', 'StringUtils','MessageUtils', 'NumberUtils', 'dataValue', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils','Criteria','SkApplication','MGEAuthorizationService','DynaformConstants','MGEParameters','XmlJson',
		function (SkPesquisaService, KeyboardManager, SkConstants, AngularUtil, $scope, $popupInstance, i18n, StringUtils, MessageUtils, NumberUtils, dataValue, ServiceProxy, ObjectUtils, ArrayUtils, Criteria, SkApplication, MGEAuthorizationService, DynaformConstants, MGEParameters, XmlJson) {
			var self = this;
			
			$scope.$dismiss = dismiss;
			
			ObjectUtils.implements(self, IDatagridInterceptor);
			self.acceptColumnField = acceptColumnField;
			self.interceptColumnMetadata = interceptColumnMetadata;
			
			var _nuNota = dataValue.nuNota;
			var _sequencia = dataValue.sequencia; 
			var _qtdNeg = dataValue.qtdNeg;
			var _modoCompra = dataValue.modoCompra;
			var _codigoProduto = dataValue.codigoProduto;
			var _codigoLocal = dataValue.codigoLocal;
			var _codigoEmpresa = dataValue.codigoEmpresa;
			var _produtoUsaSerieGlobal = dataValue.validaSerieGlobal == "S";
			var _produtoUsaSeriFab = dataValue.produtoUsaSeriFab == "S";
			var _produtoUtilSmartCard = dataValue.produtoUtilSmartCard == "S";
			var _ehVenda = dataValue.ehVenda;
			var _usaSerieGlobal = MGEParameters.asBoolean("mge.utiliza.numero.serie.global");
			var _utilSmartCard = MGEParameters.asBoolean("mge.core.usar.smartcard.com.serie");
			var _podeEditar = false;
			var _validaNotaFaturada;
			var _serieProdutoEntityDescription;
			var _qtdPreenchidos = 0;
			
			var _navigator = {
				setFocus: function() {
					setFocusComponent('navigator');
				}
			};
			
			self.serieInicial = {
				text: undefined,
				enabled: true,
				setFocus: function() {
					setFocusComponent('serieInicial');
				}
			};
			
			self.textSerie = {
				text: undefined,
				enabled: true,
				setFocus: function() {
					setFocusComponent('textSerie');
				}
			};
			
			self.textSmartCard = {
				text: undefined,
				enabled: false,
				setFocus: function() {
					setFocusComponent('textSmartCard');
				}
			};
			
			self.txtSerieGlobal = {
				text: undefined,
				enabled: false,
				visible: false,
				setFocus: function() {
					setFocusComponent('txtSerieGlobal');
				}
			};
			
			self.onDatasetCreated = onDatasetCreated;
			self.removeSeries = removeSeries;
			self.removeHandler = removeHandler;
			self.addHandler = addHandler;
			self.changeSerie = changeSerie;
			self.keyDownEventsSerie = keyDownEventsSerie;
			self.keyDownEventsSerieGlobal = keyDownEventsSerieGlobal;
			self.keyDownEventsSmartCard = keyDownEventsSmartCard;
			self.gerarSequencia = gerarSequencia;
			self.keyFocusChangeSerie = keyFocusChangeSerie;
			self.clickSearchButtonHandler = clickSearchButtonHandler;
			self.btnSearchShow = true;
			self.showCrud = true;
			self.visibleGeracaoAutomatica = true;
			self.textInputIncluirValue;
			self.panelTextSerie;
			self.panelTextSmartCard;
			self.ckcGeracaoAutomatica = true;
			self.modelGeracaoAutomatica = false;
			self.descrProduto = dataValue.descrProduto;
			
			$scope.labelRodape = "";
			
			init()

			function init() {
				
				var params = XmlJson.create('ITEM', {NUNOTA: _nuNota, SEQUENCIA: _sequencia});

				ServiceProxy.callService(
					"mge@EdicaoSerieSP.podeEditarSerie",
					params, { normalizedJson: true }
				).then(
					function(result){
						_podeEditar = XmlJson.getText(XmlJson.resolvePath(result, "responseBody.PODEEDITAR[0]")) == "S";
						_validaNotaFaturada = XmlJson.getText(XmlJson.resolvePath(result, "responseBody.ISFATURADO[0]")) == "S";
						var inibeSerie = XmlJson.resolvePath(result, "responseBody.CONFIGURACAO.@inibeSerie") == "S";
						
						if (inibeSerie) {
							self.btnSearchShow = false;	
						}
						
						if (!_podeEditar) {
							self.showCrud = false;
						}

						if (_usaSerieGlobal && _produtoUsaSerieGlobal) {
							self.ckcGeracaoAutomatica = false;
						}
						
						if (_modoCompra && _produtoUtilSmartCard && _utilSmartCard) {
							self.visibleGeracaoAutomatica = false;
						} else {
							self.visibleGeracaoAutomatica = _podeEditar;
						}

						
					}
				);
				
				ServiceProxy.callService(
					"mge@SystemUtilsSP.getInstanceDescription",
					{param : {entityName:"SerieProduto"}}).then(
					function(result){
						_serieProdutoEntityDescription = result.responseBody.entity.description;
					}
				);
			}

			function onDatasetCreated(dataset) {
				self.dsSerie = dataset;
				
				dataset.addCriteriaProvider(getCriteria);
				
				dataset.addEditionCanceledListener( () => {
					if(self.txtSerieGlobal.visible){
						self.txtSerieGlobal.text = "";
						self.txtSerieGlobal.setFocus();
						
					} else {
						if (self.dsSerie.size() == 0) {
							self.panelTextSerie = false;
						}
						self.textSerie.text = "";
						_navigator.setFocus();
						
						if(_produtoUtilSmartCard && _utilSmartCard){
							if (self.dsSerie.size() == 0){
								self.panelTextSmartCard = false;
							}
							self.textSmartCard.text = "";
						}
					}
				});

				dataset.addLineChangeListener( (line) => {
					if(line > -1){
						self.textSerie.text = "";
						
						if (self.textSerie.enabled) {
							if (self.dsSerie.size() == 0) {
								self.panelTextSerie = false;
							}
						} else {
							self.textSerie.enabled = true;
						}
						
						if(_produtoUtilSmartCard && _utilSmartCard){
							self.textSmartCard.text = "";
							
							if (self.textSmartCard.enabled) {
								if (self.dsSerie.size() == 0) {
									self.panelTextSmartCard = false;
								}
							} else {
								self.textSmartCard.enabled = true;
							}
						}
					}
				});

				dataset.addRefreshedListener( () => {
					if (self.txtSerieGlobal.visible) {
						self.txtSerieGlobal.setFocus();
					} else if (self.panelTextSerie) {
						self.textSerie.setFocus();
					} else {
						_navigator.setFocus();
					}

					atualizaQuantidades();
				});

				dataset.beforePostAction(() => {
					if (self.dsSerie.getFieldValue("NUNOTA") != null) {
						MessageUtils.showAlert("Alteração proibida", i18n('Comercial.CentralNotas.messageImpossivelAlterarSerie'));
						self.dsSerie.cancelEdition();
						
					} else {
						var serie = self.dsSerie.getFieldValueAsString("SERIE");
						
						if (StringUtils.isEmpty(serie) && !StringUtils.isEmpty(self.textSerie.text)) {
							serie = StringUtils.trim(self.textSerie.text);
						}
						
						if (!StringUtils.isEmpty(serie)) {

							var params = XmlJson.create("SERIE",{NUNOTA: _nuNota, SEQUENCIA: _sequencia}, serie);
							
							var smartCard;
							if (_produtoUtilSmartCard && _utilSmartCard){
								smartCard = self.dsSerie.getFieldValueAsString("SMARTCARD");
								if(StringUtils.isEmpty(smartCard) && !StringUtils.isEmpty(self.textSmartCard.text)){
									smartCard = self.textSmartCard.text;
								}
								params.SMARTCARD = smartCard;

								XmlJson.setAttribute(params, "SMARTCARD", smartCard)
							}
							
							ServiceProxy.callService(
								"mge@EdicaoSerieSP.incluirSerie",
								params, {normalizedJson:true}).then(
									function(result){
										if (_produtoUtilSmartCard && _utilSmartCard) {
											self.dsSerie.refresh(null, {SERIE: serie, SMARTCARD: smartCard, NUNOTA: _nuNota, SEQUENCIA: _sequencia});
										} else {
											self.dsSerie.refresh(null, {SERIE: serie, NUNOTA: _nuNota, SEQUENCIA: _sequencia});
										}
									},
									function(statusMessage, status){
										if (_produtoUtilSmartCard && _utilSmartCard) {
											if (!_ehVenda) {
												self.textSmartCard.enabled = true;
											}
										}
										self.textSerie.enabled = true;
										self.dsSerie.refresh();
									}
							);
						}
					}
					
					return true;
				});

				dataset.initAndRefresh().then(function() {
					var lblTot = angular.element('#lblTot');
					if (lblTot) {
						$scope.labelRodape = StringUtils.toHtmlText(i18n('Comercial.CentralNotas.msgQuantidadeItensComSerie', [_qtdNeg, _qtdPreenchidos, "#000000"]));
						var htmlContent = '<span ng-bind-html="labelRodape"></span>';
						lblTot.html(AngularUtil.compile(htmlContent, $scope));
					}
					
					atualizaQuantidades();
					
					var element = document.getElementById('contentPopupSerie');
					if (element) {
						KeyboardManager.bind('f8', addKeyHandler, {target: element});
						KeyboardManager.bind('esc', cancelKeyHandler, {target: element});
						KeyboardManager.bind('f9', deleteKeyHandler, {target: element});
						KeyboardManager.bind('f7', saveKeyHandler, {target: element});
					}
				});
			}
			
			function acceptColumnField(fieldMD, dataset) {
				if (fieldMD.name == "SERIE") {
					return true;
					
				} else if (fieldMD.name == "SERIEFAB") {
					return _produtoUsaSeriFab && MGEParameters.asBoolean('com.produto.usa.nro.serie.fabricante');
					
				} else if (fieldMD.name == "SMARTCARD") {
					return _produtoUtilSmartCard && _utilSmartCard;
				}
				
				return false;
			}
			
			function interceptColumnMetadata(fm, dataset) {
				if ("SERIE-SERIEFAB-SMARTCARD".indexOf(fm.name) > -1) {
					fm.width = 415;
				}
			}

			function addKeyHandler(evt) {
				if (_podeEditar) {
					addSerie()
				}
			}

			function cancelKeyHandler(evt) {
				if (_podeEditar && self.dsSerie.isInsertionMode() || self.dsSerie.isRecordDirty()) {
					self.dsSerie.cancelEdition();
				}
				
				textSerie.focus();
			}

			function deleteKeyHandler(evt) {
				if (_podeEditar) {
					removeSerie();
				}
				self.textSerie.setFocus();
			}
			
			function saveKeyHandler(evt) {
				if (_podeEditar) { 
					self.dsSerie.save();
				}
			}

			function closeMe(notificaDiferenca = false) {
				if ((notificaDiferenca || _validaNotaFaturada) && _podeEditar) {
					if(_qtdNeg > _qtdPreenchidos){
						MessageUtils.showAlertWithConfirm(
							i18n('Comercial.CentralNotas.titleTerminarEdicaoSeries'),
							i18n('Comercial.CentralNotas.messageQtdeSeriesInferiorNegociacao')).then(
							function(){
								_validaNotaFaturada = false;
								closeMe();
							}
						);
					} else {
						_validaNotaFaturada = false;
						closeMe();
					}
				} else {				
					$popupInstance.dismiss();
				}
			}
			
			function keyDownEventsSerieGlobal(evt) {
				switch (evt.keyCode) {
	                case SkConstants.KEY_CODE.ENTER:
	                	incluirSerieGlobal();
	                    break;
	                default:
	                    break;
	            }
			}
			
			function incluirSerieGlobal() {
				if(!self.dsSerie.isInsertionMode()) {
					self.dsSerie.goToInsertionMode().then(()=>{
						
						self.dsSerie.setFieldValue("SERIE", StringUtils.trim(self.txtSerieGlobal.text));
						self.dsSerie.save();		
						self.txtSerieGlobal.text = "";
					});
				}else{
					self.dsSerie.setFieldValue("SERIE", StringUtils.trim(self.txtSerieGlobal.text));
					self.dsSerie.save();
					self.txtSerieGlobal.text = "";
				}
			}
			
			function keyDownEventsSerie(evt) {
                switch (evt.keyCode) {
                    case SkConstants.KEY_CODE.ENTER:
                    	incluirSerie();
                        break;
                    default:
                        break;
                }
            }
			
			function incluirSerie() {
				self.textSerie.enabled = false;
				
				if (_produtoUtilSmartCard && _utilSmartCard) { 
					buscarSmartCard();
					
				} else {
					if(!self.dsSerie.isInsertionMode()) {
						self.dsSerie.goToInsertionMode();
					}
					
					self.dsSerie.setFieldValue("SERIE", StringUtils.trim(self.textSerie.text));
					self.dsSerie.save();
				}
			}
			
			function keyDownEventsSmartCard(evt) {
				switch (evt.keyCode) {
	                case SkConstants.KEY_CODE.ENTER:
	                	incluirSmartCard();
	                    break;
	                default:
	                    break;
	            }
			}
			
			function incluirSmartCard() {
				if (StringUtils.isEmpty(self.textSerie.text)) {
					MessageUtils.showAlert("Inclusão proibida", i18n('Comercial.CentralNotas.messageInformeNroSerie'));
					
				} else {
					self.textSmartCard.enabled = false;
					
					if(!self.dsSerie.isInsertionMode()){
						self.dsSerie.goToInsertionMode();
					}
					
					self.dsSerie.setFieldValue("SMARTCARD", self.textSmartCard.text);
					self.dsSerie.save();
				}
			}

			function gerarSequencia() {
				try{
					var semente = self.serieInicial.text;
					
					if (StringUtils.emptyAsNull(semente) == null ) {
						throw new Error(i18n('Comercial.CentralNotas.messageInformeSerieInicial'));
					}
					
					if(isNaN(Number(semente))){
						throw new Error(i18n('Comercial.CentralNotas.messageSerieInicialNaoNumerica'));
					}
					
					if(_qtdNeg <= _qtdPreenchidos){
						throw new Error(i18n('Comercial.CentralNotas.messageNumeroSeriesSuficiente'));
					}
					
					var params = XmlJson.create("SERIE",{
						"NUNOTA":_nuNota,
						"SEQUENCIA": _sequencia
					}, semente);

					ServiceProxy.callService(
						"mge@EdicaoSerieSP.gerarSequenciaSeries",
						params,{normalizedJson: true}).then(
						function(result){
							self.dsSerie.refresh();
						},
						function(statusMessage, status){
							self.dsSerie.refresh();
						}
					);
				} catch (e){
					self.serieInicial.setFocus();
					MessageUtils.showAlert(i18n('Comercial.CentralNotas.titleGeracaoSequencial'), e.message);
				}
			}
			
			function clickSearchButtonHandler() {
				if (!_serieProdutoEntityDescription) {
					_serieProdutoEntityDescription = "Série Produto";
				}
				
				SkPesquisaService.openPesquisaPopUp('SerieProduto', undefined, {
                    label: _serieProdutoEntityDescription,
                    enviromentCriteria: environmentCriteriaSearchField,
                    listener: 'br.com.sankhya.modelcore.pesquisa.listener.SerieProdutoListener'
                }).then(function (result) {
                    if (result && result.data) {
                    	if (!self.dsSerie.isInsertionMode()) {
                    		self.dsSerie.goToInsertionMode();
						}
						
						if (_produtoUtilSmartCard && _utilSmartCard) {
							self.textSerie.text =  result.data.SERIE;
							self.textSmartCard.text = result.data.SMARTCARD;
							self.dsSerie.setFieldValue("SMARTCARD", result.data.SMARTCARD);
							
						} else {
							self.dsSerie.setFieldValue("SERIE", result.data.SERIE);
							self.dsSerie.save();
						}
                    }
                });
			}
			
			function setFocusComponent(id) {
				setTimeout(function() { 
                	var component = document.getElementById(id);
                	if (component && component.firstChild) {
                		component.firstChild.focus();
                		component.firstChild.click();
                	}
               }, 250);
			}

			function atualizaQuantidades(){
				_qtdPreenchidos = 0;
				self.dsSerie.getRecordsAsObjects().forEach(obj =>{
					if(StringUtils.emptyAsNull(obj.SERIE) != null){
						_qtdPreenchidos++;
					}
				});
				
				var fontColor;
				if (_qtdPreenchidos < _qtdNeg) {
					fontColor = "#FF0000"; //red
					
				} else if(_qtdPreenchidos == _qtdNeg) {
					fontColor = "#006400"; //green
					
				} else {
					fontColor = "#000000"; //black
				}
				
				$scope.labelRodape = StringUtils.toHtmlText(i18n('Comercial.CentralNotas.msgQuantidadeItensComSerie', [_qtdNeg, _qtdPreenchidos, fontColor]));
			}

			function getCriteria(){
				var criteria = Criteria();
				criteria.append(" this.NUNOTA = ? ", Criteria.buildNumberParameter(_nuNota));
				criteria.append(" AND this.SEQUENCIA = ? ", Criteria.buildNumberParameter(_sequencia));
				return criteria;
			}
			
			function environmentCriteriaSearchField() {
				var criteria = Criteria();
				criteria.append(" this.ATUALESTOQUE > 0 ");
				
				if (!isNaN(_codigoProduto)) {
					criteria.append(" AND this.CODPROD = " + _codigoProduto);
				}
				
				if (!isNaN(_codigoLocal)) {
					criteria.append(" AND this.CODLOCAL = " + _codigoLocal);
				}
				
				if (!isNaN(_codigoEmpresa)) {
					criteria.append(" AND this.CODEMP = " + _codigoEmpresa);
				}
				
				return criteria;
			}

			function removeHandler(dataset) {
				removeSerie();
			}
			
			function removeSerie(confirmar = true){
				if (self.dsSerie.size() > 0) {
					if (confirmar) {
						MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.CentralNotas.messageConfirmarExclusaoSerie')).then( function(){removeSerie(false);});
						
					} else {
						var serie = self.dsSerie.getFieldValueAsString("SERIE");
						if (!serie || self.dsSerie.isRecordDirty()) {
							self.dsSerie.refresh();
							
						} else if (serie) {
							var params = XmlJson.create("SERIE",{NUNOTA: _nuNota, SEQUENCIA: _sequencia}, serie);

							var r = self.dsSerie.getCurrentRowAsObject();
							atualizaQuantidades();
							
							ServiceProxy.callService(
								"mge@EdicaoSerieSP.excluirSerie",
								params, {normalizedJson:true}).then(
									function(result){
										self.dsSerie.refresh();
									},
									function(statusMessage, status){
										self.dsSerie.refresh(null, r);
									}
							);
						}
					}
				}
			}
			
			function removeSeries(confirmar = true){
				if (self.dsSerie.size() > 0) {
					if(confirmar){
						MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.CentralNotas.messageConfirmarExclusaoSeries')).then(function(){removeSeries(false);});
					} else {

						var params = XmlJson.create('SERIE', {
							NUNOTA: _nuNota,
							SEQUENCIA: _sequencia
						});
						
						self.dsSerie.resetRecords();
						atualizaQuantidades();
						
						ServiceProxy.callService(
							"mge@EdicaoSerieSP.excluirSerie",
							params, {normalizedJson:true}).then(
								function(result){
									self.dsSerie.refresh();
								},
								function(statusMessage, status){
									self.dsSerie.refresh();
								}
						);
					}
				}
			}
			
			function addHandler(dataset) {
				addSerie();
			}
			
			function addSerie(){
				if (self.dsSerie.isRecordDirty()) {
					self.dsSerie.save();
					
				} else {
					if(self.dsSerie.size() < _qtdNeg){
						if(_usaSerieGlobal && _produtoUsaSerieGlobal){
							self.txtSerieGlobal.visible = true;
							self.txtSerieGlobal.setFocus();

						} else {
							self.panelTextSerie = true;
							self.textSerie.enabled = true;
							self.textSerie.setFocus();
							self.dsSerie.goToInsertionMode();
						}
						
						if(_produtoUtilSmartCard && _utilSmartCard){
							self.panelTextSmartCard = true;
							
							if (!_ehVenda) {
								self.textSmartCard.enabled = true;
							}
						}
					} else {
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.CentralNotas.messageNumeroSeriesSuficiente'));
					}
				}
			}
			
			function changeSerie() {
				if (!StringUtils.isEmpty(self.textSerie.text)) {
					var func = function() {
						self.dsSerie.setFieldValue('CODPROD', 0);
					};
					
					if (!self.dsSerie.isInsertionMode()) {
						self.dsSerie.goToInsertionMode().then(func);
					} else {
						func();
					}
				}
			}
			
			function onSelectSearched(searchEditor, value, description = null){
				if(!self.dsSerie.isInsertionMode()){
					self.dsSerie.gotoInsertionMode();
				}
				self.dsSerie.setFieldValue("SERIE", value);
			}
			
			function keyFocusChangeSerie() {
				buscarSmartCard();
			}
			
			function buscarSmartCard() {
				if (_produtoUtilSmartCard && _utilSmartCard) {
					var serie = StringUtils.trim(self.textSerie.text);
					var smartCard;
					
					self.textSmartCard.text = "";
					
					if (!StringUtils.isEmpty(serie)) {
						
						var params = XmlJson.create('SERIE', {NUNOTA: _nuNota, SEQUENCIA: _sequencia}, serie);
						
						ServiceProxy.callService(
	                        "mge@EdicaoSerieSP.buscarSmartCard",
	                        notas, { normalizedJson: true }).then(
	                        function(result) {
	                        	if (XmlJson.isNormalized(result)) {
	                        		XmlJson.denormalize(result);
	                        	}
	                        	
	                        	self.textSmartCard.text = ObjectUtils.getProperty(result, 'responseBody.entity.smartCard');
	                        	self.textSmartCard.setFocus();
								
								if (_ehVenda) { 
									self.textSmartCard.enabled = false;
									self.dsSerie.save();
								} else {
									self.textSmartCard.enabled = true;
								}
	                        }
	                    );
					}
				}
			}

			function dismiss(){
				closeMe(true);
			}
        }]);
angular
    .module('snk.commons')
    .controller('EditorFiltroController', ['$scope', 'dados', 'ServiceProxy', 'SkI18nService', '$popupInstance', 'SkApplicationInstance', 'MessageUtils', 'ObjectUtils', 'MGEParameters', 'Criteria', 'StringUtils', 'AngularUtil', 'ImportadorDadosUtil', 'DateUtils', 'DatasetEvents', 'MGEAuthorizationConstants', 'MGEAuthorizationService', 'DateUtilsConstants', 'FilterVariablesBuilder', 'SanPopup', 'i18n', "WebConnectionCaller", "WebConnectionConstants",
        function ($scope, dados, ServiceProxy, SkI18nService, $popupInstance, SkApplicationInstance, MessageUtils, ObjectUtils, MGEParameters, Criteria, StringUtils, AngularUtil, ImportadorDadosUtil, DateUtils, DatasetEvents, MGEAuthorizationConstants, MGEAuthorizationService, DateUtilsConstants, FilterVariablesBuilder, SanPopup, i18n, WebConnectionCaller, WebConnectionConstants) {
            var self = this;

            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, IDynaformInterceptor);

            var _tipoCampo;
            var _textAreaExpressao;
            var _campoSelecionado;
            var _isCleanFunction = false;

            self.comboExpressaoOpts = [
                {data: " > \{0\}", value: " > maior que"},
                {data: " < \{0\}", value: " < menor que"},
                {data: " = \{0\}", value: " = igual a"},
                {data: " >= \{0\}", value: " >= maior igual a"},
                {data: " <= \{0\}", value: " <= menor igual a"},
                {data: " <>; \{0\}", value: " <> diferente de"},
                {data: "Like '%\{0\}%'", value: "contendo", contemAspas:"true", aceitaTipo:"I-N-F-$-M-R-S"},
                {data: "Like '\{0\}%'", value: "começando com", contemAspas:"true", aceitaTipo:"I-N-F-$-M-R-S"},
                {data: "Like '%\{0\}'", value: "terminando com", contemAspas:"true", aceitaTipo:"I-N-F-$-M-R-S"},
                {data: "is null", value: "vazio"}
            ];

            self.descricao;
            self.codrel;
            self.resourceID = SkApplicationInstance.getResourceID().replace("-html5", "");

            self.comboExpressao = " > \{0\}";
            self.nomeCampo = "Escolha um campo";
            self.podeUsarCampoAtual = false;
            self.habilitaControleParametro = false;
            self.campoTextoVisible = true;
            self.isRequiredEnabled = false;
            self.isEditFilterEnabled = false;

            self.onFlatTreeCreated = onFlatTreeCreated;
            self.campoChanged = campoChanged;
            self.openEditForm = openEditForm;
            self.textAreaCreated = textAreaCreated;
            self.adicionaExpressao = adicionaExpressao;
            self.changeChkVariavel = changeChkVariavel;
            self.filterTree = filterTree;
            self.enviromentCriteriaEntidade = enviromentCriteriaEntidade;
            self.limpar = limpar;
            self.cleanFunction = cleanFunction;
            self.prepareEditFilterButton = prepareEditFilterButton;
            self.mudaOperador = mudaOperador;

            self.treeCtrl = {};
            $scope.$success = onSuccess;
            self.editFilterBox = true;

            init();

            function init(){
                self.camposDP = dados.camposDP;
                self.descricao = dados.descricao;
                self.codrel = dados.codrel;
                self.filterExpression = dados.expressao;
                prepareEditFilterButton();
            }

            function onFlatTreeCreated(component){
                self.flatTree = component;
            }

            function filterTree(){
                self.treeCtrl.expand_all();
            }

            function textAreaCreated(comp) {
                _textAreaExpressao = comp;
            }
            
            function adicionaExpressao() {
                if (angular.isDefined(_campoSelecionado)) {
                    var sinalSelecionado = self.comboExpressao;
                    var tipoCampo = _campoSelecionado.tipo;
                    if (sinalSelecionado.hasOwnProperty("aceitaTipo")) {
                        if ((sinalSelecionado.aceitaTipo).indexOf(tipoCampo) < 0) {
                            MessageUtils.showAlert("Expressão inválida", "Sinal inválido para campos deste tipo.");
                            return false;
                        }
                    }
                    var parametro = getValorParametro(tipoCampo, sinalSelecionado);
                    if (StringUtils.emptyAsNull(parametro) != null) {
                        var strExpression = "( :" + _campoSelecionado.descricao + ": " + StringUtils.substitute(sinalSelecionado, parametro) + " )";

                        if (self.checkVar) {
                            strExpression = buildAditionalFilterMetadata(parametro, strExpression);
                        }

                        concatenaExpressao(strExpression);
                    }
                }
                _tipoCampo = "";
            }
            
            function getValorParametro(tipo, sinalSelecionado) {
                var value = self.checkVar ? "?" : getStringValue(getParameterControl());
                if(!StringUtils.isEmpty(value)){
                    if("D-T".indexOf(tipo) > -1){
                        if(value != "?"){
                            value = "#" + value + "#";
                        }
                    } else {
                        var adicionarAspas = "M-R-S".indexOf(tipo) > -1 && !verificaContemAspas(sinalSelecionado);
                        if(adicionarAspas){
                            value = "'" + value + "'";
                        }
                    }
                }
                return value;

            }

            function getStringValue(value){
                if(angular.isUndefined(value)){
                    return "";
                }

                if(angular.isNumber(value)){
                    return "";
                }

                if(angular.isDate(value)){
                    return DateUtils.formatDate(value, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                }

                return value.toString();
            }

            function verificaContemAspas(valor) {
                self.comboExpressaoOpts.forEach(function (opts) {
                   if(opts.value == valor){
                       if(opts.contemAspas == "true"){
                           return true;
                       }else{
                           return false;
                       }
                   }
                });

            }

            function mudaOperador(campo){
                if(campo == "E" && self.checkAnd && self.checkOr){
                    self.checkOr = false;
                }else if(campo == "OU" && self.checkAnd && self.checkOr){
                    self.checkAnd = false;
                }
            }

            function getParameterControl(){
                if(self.campoOpcoesVisible){
                    return self.campoOpcoes;
                } if(self.campoDataVisible){
                    return self.campoData;
                } else if(self.campoNumeroVisible){
                    return self.campoNumero;
                } else {
                    return self.campoTexto;
                }
            }

            function buildAditionalFilterMetadata(parameter, expression) {
                var newExpression = undefined;
                var isRequired = (self.isRequiredEnabled && self.isRequired);

                var variablesBuilder= new FilterVariablesBuilder(isRequired, _tipoCampo, self.txiEntity);

                if(expression.indexOf(parameter) >= 0) {
                    var indexToReplace = expression.lastIndexOf(parameter);

                    var endOfExpression = expression.substring(indexToReplace + parameter.length, expression.length);

                    newExpression = expression.substring(0, indexToReplace) +
                        parameter + variablesBuilder.buildExpression();

                    if(endOfExpression != "") {
                        newExpression = newExpression + endOfExpression;
                    }

                } else {
                    newExpression = expression;
                }
                self.isRequired = true;
                self.txiEntity = "";
                return newExpression;
            }
            
            function concatenaExpressao(exp) {
                var newExpr;
                if(!StringUtils.isEmpty(self.filterExpression)){
                    newExpr = StringUtils.trim(self.filterExpression);
                    var regExp = new RegExp(".*\.(E|OU)\.\s*$");
                    if(!regExp.test(newExpr)){
                        newExpr += " .E.";
                    }
                    newExpr += "\n";
                } else {
                    newExpr = "";
                }
                newExpr += exp;
                if(self.checkAnd){
                    newExpr += " .E.";
                } else if(self.checkOr){
                    newExpr += " .OU.";
                }
                self.filterExpression = newExpr;
                notifyChange();
            }

            function campoChanged(item) {
                if(angular.isUndefined(item)){
                    self.podeUsarCampoAtual = false;
                    self.habilitaControleParametro = false;
                    selectParameterControl("S");
                }else{
                    var opcoes = getOptions(item);
                    _tipoCampo = item.tipo;

                    changeShowEntitySearch();

                    if(angular.isDefined(opcoes)){
                        if(opcoes.length > 0){
                            self.campoOpcoes = opcoes;
                        }
                    }
                    
                    self.nomeCampo = item.descricao;
                    self.podeUsarCampoAtual = item.soHierarquia != "S";
                    self.habilitaControleParametro = item.soHierarquia != "S";
                    selectParameterControl(angular.isDefined(opcoes) ? "OPT" : item.tipo);
                }

                _campoSelecionado = item;

            }
            
            function selectParameterControl(tipoCampo) {
                if("OPT" == tipoCampo){
                    self.campoOpcoesVisible = true;
                    self.campoTextoVisible = false;
                    self.campoDataVisible = false;
                    self.campoNumeroVisible = false;
                } else if("T-D".indexOf(tipoCampo) > -1){
                    self.campoTextoVisible = false;
                    self.campoDataVisible = true;
                    self.campoNumeroVisible = false;
                    self.campoOpcoesVisible = false;
                } else if("I-N-F-$".indexOf(tipoCampo) > -1){
                    self.campoTextoVisible = false;
                    self.campoDataVisible = false;
                    self.campoNumeroVisible = true;
                    self.campoOpcoesVisible = false;

                    if("F-$".indexOf(tipoCampo) > -1){
                        self.campoNumeroPrecision = "2";
                    } else {
                        self.campoNumeroPrecision = "0";
                    }
                } else {
                    self.campoTextoVisible = true;
                    self.campoDataVisible = false;
                    self.campoNumeroVisible = false;
                    self.campoOpcoesVisible = false;
                }

            }
            
            function changeShowEntitySearch(){
                if(!(_tipoCampo == "I" || _tipoCampo == "S")) {
                    self.showEntitySearch = false;
                } else {
                    self.showEntitySearch = true;
                }
            }
            
            function getOptions() {

            }

            function openEditForm() {
                if (_tipoCampo == "I" || _tipoCampo == "S") {
                    self.showEntitySearch = true;
                } else {
                    self.showEntitySearch = false;
                }
                prepareEditForm(getIndexToEdit());

                SanPopup.open({
                    title: i18n('Core.SelecaoCampos.editFilterVariablesTitle'),
                    templateUrl: 'commons/formatadorcuborelatorio/selecaocampos/popup/EditFilterPopUp.tpl.html',
                    controller: 'EditFilterPopUpController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    height: '70',
                    showBtnNo: false,
                    showBtnCancel: false,
                    showBtnOk: false,
                    windowClass: self.showEntitySearch ? 'popupEditFilterEntity' : 'popupEditFilter',
                    resolve: {
                        data: {
                            editFilterBoxVisibled: true,
                            showEntitySearch: self.showEntitySearch,
                            tipoCampo: _tipoCampo,
                            isRequiredEdit: self.isRequired,
                            txiEntityEdit: self.txiEntityEdit
                        }
                    }
                }).result
                    .then(function (result) {
                            self.txiEntityEdit = result.filter;
                            editFilterExpression();
                            closeFilterEdit();
                            self.txiEntityEdit = '';
                            _tipoCampo = '';
                        }
                        , function (cancel) {
                            closeFilterEdit();
                        });
            }

          function prepareEditFilterButton(){
                if(self.filterExpression == "" || self.filterExpression.indexOf("?") == -1) {
                    self.isEditFilterEnabled = false;
                } else {
                    self.isEditFilterEnabled = true;
                }
            }

            function prepareEditForm(indexToEdit) {
                var expression = self.filterExpression;
                var metadataStart = "/*{";
                var metadataEnd = "}*/";
                var filterMetadataObject = null;

                self.txiEntityEdit = '';

                if (expression.substring(indexToEdit + 1, indexToEdit + 4) == metadataStart) {
                    var metadataString = expression.substring(indexToEdit + 4, expression.indexOf(metadataEnd, indexToEdit));

                    filterMetadataObject = getFilterMetadata(metadataString);

                    if (filterMetadataObject != null) {
                        self.isRequiredEdit = filterMetadataObject["req"] == "s" ? true : false;
                        self.txiEntityEdit = filterMetadataObject["entity"];
                        _tipoCampo = filterMetadataObject["type"];

                        if (!(_tipoCampo == "I" || _tipoCampo == "S")) {
                            self.showEntitySearch = false;
                        } else {
                            self.showEntitySearch = true;
                        }
                    }
                }
            }
            
            function getFilterMetadata(metadataString) {
                var objectData = {};
                var metadataArray = metadataString.split(";");

                for(var i = 0; i < metadataArray.length; i++) {
                    var metadata = metadataArray[i].replace("{", "").replace("}", "").split("=");
                    objectData[metadata[0]] = metadata[1];
                }

                return objectData;
            }

            function editFilterExpression() {
                self.editFilterBox = true;
                self.filterExpression = editFilterMetadata(self.filterExpression, getIndexToEdit());
            }

            function getIndexToEdit() {
                var cursorIndex = 0;

                if (_textAreaExpressao) {
                    var range = _textAreaExpressao.getSelectionRange();
                    cursorIndex = range.start;
                }

                var charToFind = '?';
                var expression = self.filterExpression;
                var charToFindIndexes = [];
                var distanceArray = [];

                var matchIndex = 0;

                while (matchIndex != -1) {
                    matchIndex = expression.indexOf(charToFind, matchIndex);
                    if (matchIndex != -1) {
                        charToFindIndexes.push(matchIndex);
                        matchIndex++;
                    }
                }

                for (var i = 0; i < charToFindIndexes.length; i++) {
                    distanceArray.push(Math.abs(charToFindIndexes[i] - cursorIndex));
                }

                var indexToEdit = charToFindIndexes[getMinValueIndex(distanceArray)];

                return indexToEdit;
            }

            function getMinValueIndex(array) {
                var minValueIndex = 0;
                var minValue = array[0];

                for (var i = 0; i < array.length; i++) {
                    if (array[i] < minValue) {
                        minValueIndex = i;
                        minValue = array[i];
                    }
                }

                return minValueIndex;
            }
            
            function notifyChange() {
                prepareEditFilterButton();
            }
            
            function changeChkVariavel() {
                if(self.checkVar){
                    self.campoData = undefined;
                    self.campoTexto = undefined;
                    self.campoNumero = undefined;
                    self.habilitaControleParametro = false;
                    self.isRequiredEnabled = true;
                } else {
                    self.isRequiredEnabled = false;
                    self.habilitaControleParametro = true;
                }
            }
            
            function enviromentCriteriaEntidade() {
                return Criteria('this.NUINSTANCIAPAI IS NULL');
            }

            function closeFilterEdit(){
                self.isRequired = true;
                self.txiEntityEdit = "";
                self.isRequiredEnabled = false;
                self.isEditFilterEnabled = false;
            }

            function editFilterMetadata(expression, indexToEdit){
                const PARAMETER = "?";
                var newExpression = undefined;

                var metadataStart = "/*{";
                var metadataEnd = "}*/";

                var variablesBuilder = new FilterVariablesBuilder(self.isRequired, _tipoCampo, self.txiEntityEdit);

                if(expression.indexOf(PARAMETER) >= 0) {
                    if(expression.substring(indexToEdit+1, indexToEdit+4) == metadataStart) {
                        var metadataString = expression.substring(indexToEdit+4,expression.indexOf(metadataEnd, indexToEdit));

                        expression = expression.slice(0, indexToEdit+1) +
                            expression.slice(expression.indexOf(metadataEnd, indexToEdit)+3);
                    }

                    var endOfExpression = expression.substring(indexToEdit + PARAMETER.length, expression.length);

                    newExpression = expression.substring(0, indexToEdit) + PARAMETER + variablesBuilder.buildExpression();
                    if(endOfExpression != "") {
                        newExpression = newExpression + endOfExpression;
                    }
                } else {
                    newExpression = expression;
                }
                return newExpression;
            }


            function abrirVisualizarCubo() {
                var descricao = self.descricao;
                var codrel = self.codrel;
                var cubeResourceID = self.resourceID + ".relcubo_" + codrel;
                var url = StringUtils.substitute("/mge/cubeViewer.jsp?COD_REL={0}&DESCRICAO={1}&RESOURCEID={2}&LOCALE={3}", codrel, descricao, cubeResourceID, self.language);

                if (MGEParameters.asBoolean("global.usa.app.cubo")) {
                    var caller = WebConnectionCaller(WebConnectionConstants.methods.CUBE_VIEWER, {
                            resourceID: self.resourceID + ".relcubo_" + codrel,
                            label: descricao,
                            codRel: codrel,
                        }
                    );
                    caller.sendCubeData();
                }else{
                    window.open(url, '_blank');
                }
            }
            
            function onSuccess() {
                $popupInstance.success({
                    isCleanFunction : _isCleanFunction,
                    filterExpression : self.filterExpression
                });
            }
            
            function limpar() {
                self.filterExpression = undefined;
            }
            
            function cleanFunction() {
                _isCleanFunction = true;

                abrirVisualizarCubo();
            }

    }]);

angular
	.module('snk.commons')
	.service('EditorFiltroPopUp', ['SanPopup', 'SkI18nService',
		function (SanPopup, SkI18nService) {
			var self = this;

			self.show = show;

			function show(popupInfo) {
				var popupInstance = SanPopup.open({
					title: popupInfo.title,
					templateUrl: 'commons/editorfiltro/editor-filtro.tpl.html',
					controller: 'EditorFiltroController',
					controllerAs: 'ctrl',
					size: 'lg',
					height: 400,
					showBtnCancel: true,
					showBtnOk: true,
					showBtnNo: false,
					resolve: {
						dados : {
							camposDP: popupInfo.camposDP,
							expressao : popupInfo.expressao,
							descricao : popupInfo.descricao,
							codrel : popupInfo.codrel,
						}
					}
				});
				return popupInstance;
			}

		}
	]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('EditFilterPopUpController', ['data', '$scope', '$popupInstance', 'SkPesquisaService',
        function (data, $scope, $popupInstance, SkPesquisaService) {
            var self = this;

            self.showEntitySearch = false;

            self.showEntitySearch = data.showEntitySearch;
            self.tipoCampo = data.tipoCampo;
            self.ckcRequiredEdit = data.isRequiredEdit;
            self.textFilter = data.txiEntityEdit;

            //Functions
            self.searchEntity = searchEntity;
            self.getEnvironmentCriteria = getEnvironmentCriteria;
            self.confirmFilterEdit = confirmFilterEdit;
            self.closeFilterEdit = closeFilterEdit;

            function searchEntity(text) {
                var options = {
                    loadOnCreate: false,
                    enviromentCriteria: getEnvironmentCriteria,
                    enableRowsCounter: false,
                    allowShowHierarchicalMode: false,
                    label: ''
                }

                var entityName = "Instancia";
                var descriptionValue = undefined;

                SkPesquisaService.openPesquisaPopUp(entityName, descriptionValue, options)
                    .then(function (result) {
                        if (result && result.data) {
                            self.textFilter = result.data.NOMEINSTANCIA;
                        }
                    });
            }

            function getEnvironmentCriteria() {
                var criteria = new Criteria();
                criteria.append('this.NUINSTANCIAPAI IS NULL');
                return criteria;
            }

            function confirmFilterEdit() {
                data.filter = self.textFilter;

                $popupInstance.success(data);
            }

            function closeFilterEdit() {
                $popupInstance.dismiss();
            }
        }]);
angular
    .module('snk.commons.empresa')
    .controller('CopiarBlocosController', ['$scope', '$popupInstance', 'i18n', 'ServiceProxy', 'ObjectUtils', 'StringUtils', 'MessageUtils','popupInfo', 
        function ($scope, $popupInstance, i18n, ServiceProxy, ObjectUtils, StringUtils, MessageUtils,popupInfo){
            var self = this;
            self.codEmp;
            self.isSobreporConfig;

            init();

            function init(){
                self.telaParent = popupInfo.telaParent;
                self.criteria = getCriteria();

                $scope.$success = verificarEmpresa;
            }

            function verificarEmpresa() {
                if (StringUtils.isNotEmpty(popupInfo) && popupInfo.codEmp != self.codEmp) {
                    ServiceProxy
                        .callService(popupInfo.serviceName, popupInfo.getParamsService(self))
                        .then(function (response) {
                        	if (self.telaParent == 'REINF') {
                        		MessageUtils.showInfo(i18n('Commons.CopiarBlocos.msgInfo'), i18n('Commons.CopiarBlocos.msgSucessCopyEventos'));
                        	} else {
                        		MessageUtils.showInfo(i18n('Commons.CopiarBlocos.msgInfo'), i18n('Commons.CopiarBlocos.msgBcpySuces'));
                        	}
                            $popupInstance.success();
                        });
                } else {
                	if (self.telaParent == 'REINF') {
                		MessageUtils.showError(i18n('Commons.CopiarBlocos.msgAlert'), i18n('Commons.CopiarBlocos.msgCopyEventos'));
                	} else {
                		MessageUtils.showError(i18n('Commons.CopiarBlocos.msgAlert'), i18n('Commons.CopiarBlocos.msgCpyBlENms'));
                	}
                }

            }

            function getCriteria(){
                var criteria;
                if (StringUtils.isNotEmpty(popupInfo.enviromentCriteria) && angular.isFunction(popupInfo.enviromentCriteria)) {
                    criteria = popupInfo.enviromentCriteria;
                }

                return criteria;
            }
        }]);
/**
 * Created by Josiemerson
 */
angular
    .module('snk.commons.empresa')
    .service('SkCopiarBlocosService', ['SanPopup', 'StringUtils', 'i18n', function(SanPopup, StringUtils, i18n){
        var self = this;

        self.openPopUp = openPopUp;

        function openPopUp(popupInfo) {
            var title = StringUtils.isEmpty(popupInfo.title) ? i18n('Commons.CopiarBlocos.lblTitle') : popupInfo.title;
            var okBtnLabel = StringUtils.isEmpty(popupInfo.okBtnLabel) ? i18n('Commons.CopiarBlocos.lblBtnCopiar') : popupInfo.okBtnLabel;

            var popupInstance =  SanPopup.open({
            		title: title,
                    templateUrl: 'commons/empresa/copiarblocos/copiarblocos.tpl.html',
                    controller: 'CopiarBlocosController',
					controllerAs: 'ctrl',
					size: 'sm',
					okBtnLabel: okBtnLabel,
					showBtnNo: false,
					resolve: {
						popupInfo: function() {
                            return popupInfo;
                        }
					}
                });

            return popupInstance;
        }
    }]);
angular
    .module('snk.commons')
    .controller('StepAntecipacaoBaixaEstornoController', ['$wizard', '$wizard', '$step', 'MessageUtils', 'i18n',
		function ($scope, $wizard, $step, MessageUtils, i18n) {
			var self = this;
			var _nuorig = undefined;
			
			self.visibleSim = true;
			self.visibleNao = true;

			self.estornarTitulo = estornarTitulo;
			
			init();

			function init() {
				self.step = "AntecipacaoBaixaEstorno";
				self.wizardContext = $wizard.context;
				self.titleWarning = MessageUtils.TITLE_WARNING;

				if (self.wizardContext.statusEstorno.hasOwnProperty('nuorig')) {
                    _nuorig = self.wizardContext.statusEstorno.nuorig;
                }

				$step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;

				$step.setEnabled(self.wizardContext.statusEstorno.antecipacao);
				$step.hideNext(true);
				$step.hideFinish(true);

				self.lblMsg4Visible = true;
				if (self.wizardContext.dsFinanceiro.getFieldValue("RECDESP") == 1) {
					self.lblMsg = i18n('Financeiro.Estorno.labelReceitaMsg1');
					self.lblMsg2 = i18n('Financeiro.Estorno.labelDespesaMsg2', [_nuorig]);
					self.lblMsg3 = "";
					self.lblMsg4 = "";
					self.lblMsg5 = "";
					self.visibleNao = false;
					self.visibleSim = false;
				} else {
					self.lblMsg = i18n('Financeiro.Estorno.labelDespesaMsg1');
					self.lblMsg2 = i18n('Financeiro.Estorno.labelDespesaMsg2');
					self.lblMsg3 = i18n('Financeiro.Estorno.labelDespesaMsg3', [i18n('Geral.buttonSim')]);
					self.lblMsg4 = i18n('Financeiro.Estorno.labelDespesaMsg4', [i18n('Geral.buttonNao')]);
					self.lblMsg5 = i18n('Financeiro.Estorno.labelDespesaMsg5', [i18n('Geral.buttonCancelar')]);
					self.visibleNao = true;
					self.visibleSim = true;
					if (self.wizardContext.statusEstorno.baixaConj) {
						self.visibleNao = false;
						self.lblMsg4Visible = false;
					} else {
						self.visibleNao = true;
					}
				}
			}

		
			function estornarTitulo(todos) {
				self.wizardContext.estornarTodosAntecipacao = todos;				
				$step.setCanNext(true);
				$wizard.next();		
			}

			function exitStep() {
				self.wizardContext.statusEstorno.antecipacao = true;
			}

			function onEnterStep() {
				var canFinish = (!self.wizardContext.statusEstorno.conciliado && !self.wizardContext.statusEstorno.recomposicao);
				$step.setCanFinish(canFinish);
				$step.setCanNext(!canFinish);
			}
		}]);


angular
    .module('snk.commons')
    .controller('StepBaixadoOutrosTitulosEstornoController', ['$scope', '$wizard', '$step', 'MessageUtils',
		function ($scope, $wizard, $step, MessageUtils) {
			var self = this;

			init();

			function init() {
				self.wizardContext = $wizard.context;
				self.step = "BaixadoOutrosTitulosEstorno";
				self.titleWarning = MessageUtils.TITLE_WARNING;

				$step.setEnabled(!self.wizardContext.statusEstorno.antecipacao && self.wizardContext.statusEstorno.baixaConj);
				$step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;
			}

			function exitStep() {
				self.wizardContext.statusEstorno.baixaConj = true;
			}

			function onEnterStep() {
				var canFinish = !self.wizardContext.statusEstorno.recomposicao;

				$step.hideFinish(!canFinish);
				$step.hideNext(canFinish);
				$step.setCanFinish(canFinish);
			}
		}]);
angular
    .module('snk.commons')
    .controller('StepConfirmaEstornoController', ['$scope', '$wizard', '$step', 'MessageUtils',
		function ($scope, $wizard, $step, MessageUtils) {
			var self = this;

			init();

			function init() {
				self.wizardContext = $wizard.context;
				self.step = "ConfirmaEstorno";
				self.titleWarning = MessageUtils.TITLE_WARNING;

				$step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;
			}

			function exitStep() {
				self.wizardContext.statusEstorno.estorno = true;
			}

			function onEnterStep() {
				var canFinish = (!self.wizardContext.statusEstorno.antecipacao &&
					!self.wizardContext.statusEstorno.conciliado &&
					!(!self.wizardContext.statusEstorno.antecipacao && self.wizardContext.statusEstorno.baixaConj) &&
					!self.wizardContext.statusEstorno.recomposicao);
					
				$step.hideFinish(!canFinish);
				$step.hideNext(canFinish);
				$step.setCanFinish(canFinish);
			}
		}]);
angular
    .module('snk.commons')
    .controller('EstornoMultiploPopUpController', ['estornoPopUpInfo', '$scope', '$popupInstance', 'MessageUtils',
        function (estornoPopUpInfo, $scope, $popupInstance, MessageUtils) {
            var self = this;

            self.onFinish = onFinish;

            $scope.$dismiss = close;

            self.wizardContext;

            var _ignorarValidacaoUsuarioCaixa = false;
            var _contaParaCaixaAberto = 0;

            init();

            function init() {
                if (!estornoPopUpInfo.dsFinanceiro) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, 'Financeiro.Estorno.messageFaltaDBDataSet');
                }

                if (estornoPopUpInfo.hasOwnProperty('ignorarValidacaoUsuarioCaixa')) {
                    _ignorarValidacaoUsuarioCaixa = estornoPopUpInfo.ignorarValidacaoUsuarioCaixa;
                }
                
                if (estornoPopUpInfo.hasOwnProperty('contaParaCaixaAberto')) {
                    _contaParaCaixaAberto = estornoPopUpInfo.contaParaCaixaAberto;
                }
    
                self.wizardContext = {
                    dsFinanceiro                : estornoPopUpInfo.dsFinanceiro,
                    ignorarValidacaoUsuarioCaixa: _ignorarValidacaoUsuarioCaixa,
                    contaParaCaixaAberto        : _contaParaCaixaAberto,
                    status                      : estornoPopUpInfo.statusEstorno
                };
            }

            function onFinish(step) {
                $popupInstance.success();
            }

            function close() {
                $popupInstance.dismiss();
            }
        }
    ]);
angular
    .module('snk.commons')
    .controller('StepConfiguracaoEstornoMultiploController', ['$wizard', '$step', '$scope', 'i18n', 'SkApplicationInstance', 'MessageUtils', 'XmlJson', 'ArrayUtils', 'ObjectUtils',
        function ($wizard, $step, $scope, i18n, SkApplicationInstance, MessageUtils, XmlJson, ArrayUtils, ObjectUtils) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);
            self.acceptColumnField = acceptColumnField;
            self.sortMetadata      = sortMetadata;

            self.resourceID   = SkApplicationInstance.getResourceID();
            $scope.gridConfig = self.resourceID + '_EstornoMultiplo';

            self.onDatasetCreated       = onDatasetCreated;
            self.onDatagridLoaded       = onDatagridLoaded;
            self.removerSelecionados    = removerSelecionados;
            self.removerNaoSelecionados = removerNaoSelecionados;

            self.dsFinanceiros;
            self.dataGrid;
            self.wizardContext;

            self.antecipacaoBaixa    = false;
            self.estornarConciliados = false;
            self.recomporOriginais   = true;
            self.estornarBaixaConjunta = false;

            self.antecipacaoBaixaVisible    = false;
            self.estornarConciliadosVisible = false;
            self.recomporOriginaisVisible   = false;
            self.estornarBaixaConjuntaVisible = false;

            self.titleWarning = i18n("Financeiro.Estorno.msgConfirmaEstornoTitulos");

            var visibleFields = ["RECDESP", "NUFIN", "NUMNOTA", "VLRBAIXA", "DHBAIXA", "ORIGEM", "CONCILIADO", "DHCONCIL"];

            init();

			function init() {
                $step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;
			}

            function alterarMensagemWarning() {
                self.titleWarning = i18n("Financeiro.Estorno.msgAcoesExtrasDisponiveis");
            }

            function onDatasetCreated(dataset) {
                self.dsFinanceiros = dataset;

                self.dsFinanceiros.init().then(function() {
                    if(self.wizardContext && self.wizardContext.dsFinanceiro) {
                        self.dsFinanceiros.clearDataSet();
                        self.dsFinanceiros.addRecordsAsObjects(self.wizardContext.dsFinanceiro);
                    }
                });
            }

            function onDatagridLoaded(datagrid) {
                self.dataGrid = datagrid;
            }

            function acceptColumnField(fieldMD, fieldName){
				if(ArrayUtils.isIn(visibleFields, fieldMD.name)){
					return true;
				}

				return false;
            }

            function removerSelecionados() {
                self.dsFinanceiros.removeCurrentRow(true);
            }

            function removerNaoSelecionados() {
                var selecionados = self.dsFinanceiros.getSelectedRecordsAsObjects(undefined, true);

                self.dsFinanceiros.clearDataSet();

                if (angular.isDefined(selecionados) && selecionados.length > 0) {
                    self.dsFinanceiros.addRecordsAsObjects(selecionados);
                    self.dsFinanceiros.setSelectedRecords(selecionados);
                }
            }

            function onEnterStep() {
                self.wizardContext = $wizard.context;

                if(self.wizardContext && self.wizardContext.status) {
                    mostrarAcoesExtras();
                }
            }

            function mostrarAcoesExtras() {
                if(self.wizardContext.status.conciliado) {
                    alterarMensagemWarning();
                    
                    self.estornarConciliadosVisible = true;
                }
                
                if(self.wizardContext.status.recomposicao) {
                    alterarMensagemWarning();

                    self.recomporOriginaisVisible = true;
                }
                
                if(self.wizardContext.status.antecipacao) {
                    alterarMensagemWarning();
                    
                    self.antecipacaoBaixaVisible = true;
                }
                
                if(self.wizardContext.status.baixaConj) {
                	alterarMensagemWarning();
                	
                	self.estornarBaixaConjuntaVisible = true;
                }
            }

            function exitStep() {
                if(self.dsFinanceiros.length < 1) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n("Financeiro.MovimentacaoFinanceira.semRegistroSelecionado"));
                    return false;
                }

                var params = XmlJson.create("param", {
                    antecipacaoBaixa            : self.antecipacaoBaixaVisible && self.antecipacaoBaixa,
                    estornarConciliados         : self.estornarConciliadosVisible && self.estornarConciliados,
                    recomporOriginais           : self.recomporOriginaisVisible && self.recomporOriginais,
                    estornarBaixaConjunta       : self.estornarBaixaConjuntaVisible && self.estornarBaixaConjunta,
                    ignorarValidacaoUsuarioCaixa: self.wizardContext.ignorarValidacaoUsuarioCaixa,
                    contaParaCaixaAberto        : self.wizardContext.contaParaCaixaAberto,
                    resourceID                  : self.resourceID
                });

                self.dsFinanceiros.getRecordsAsObjects().forEach(function(record) {
                    XmlJson.append(params, XmlJson.create("titulo", undefined, record.NUFIN));
                });

                $wizard.context.parametrosEstorno = params;
			}

            function sortMetadata(fieldsMD) {
                fieldsMD.sort(function (a, b) {
                    return (
                        visibleFields.indexOf(a.name) -
                        visibleFields.indexOf(b.name)
                    );
                });
            }

        }
    ]);
angular
    .module('snk.commons')
    .controller('StepEstornandoMultiploController', ['$wizard', '$step', 'ServiceProxy', 'XmlJson', '$timeout', 'i18n',
        function ($wizard, $step, ServiceProxy, XmlJson, $timeout, i18n){
            var self = this;

            const STATUS_TITULO_ESTORNADO = "E";
            const STATUS_TITULO_N_ESTORNADO = "N";

            self.wizardContext;

            self.isEstornando = false;
            self.titleLoading = i18n("Financeiro.Estorno.msgRealizandoEstorno");

            var titulosEstornados = [];
            var titulosNaoEstornados = [];

            init();

			function init() {
                $step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;
			}

            function onEnterStep() {
                self.isEstornando = true;

                self.wizardContext = $wizard.context;

                ServiceProxy.callService("mge@BaixaFinanceiroSP.estornarMultiplosTitulos", self.wizardContext.parametrosEstorno, { normalizedJson:true } ).then(
                    function (response) {
                        if (XmlJson.isNormalized(response)) {
							XmlJson.denormalize(response);
						}

                        var retornoEstorno = response.responseBody.retornoEstorno;
		
                        if (retornoEstorno && retornoEstorno.titulo) {
                            var titulos = retornoEstorno.titulo;

                            if(Array.isArray(titulos)) {
                                titulos.forEach(function(titulo) {
                                    categorizarTitulo(titulo);
                                });
                            } else {
                                categorizarTitulo(titulos);
                            }
                        }
                        
                        $wizard.context.titulosEstornados = titulosEstornados;
                        $wizard.context.titulosNaoEstornados = titulosNaoEstornados;

                        $timeout(function () {
                            $wizard.next();
                            self.isEstornando = false;
                        }, 100, false);
				    },
                    function(error) {

                    }
                );
            }

            function categorizarTitulo(titulo) {
                if(STATUS_TITULO_ESTORNADO == titulo.status) {
                    titulosEstornados.push(titulo);

                } else if(STATUS_TITULO_N_ESTORNADO == titulo.status) {
                    titulosNaoEstornados.push(titulo);
                }
            }

            function exitStep() {}

        }
    ]);
angular
    .module('snk.commons')
    .controller('StepResultadosEstornoMultiploController', ['$step', 'SkApplicationInstance', '$scope', '$wizard', 'ArrayUtils', 'ObjectUtils', 'SqlUtils',
        function ($step, SkApplicationInstance, $scope, $wizard, ArrayUtils, ObjectUtils, SqlUtils) {
            var self = this;
            
            ObjectUtils.implements(self, IDatagridInterceptor);
            self.acceptColumnField = acceptColumnField;
            self.sortMetadata      = sortMetadata;

            self.resourceID   = SkApplicationInstance.getResourceID();
            $scope.gridConfigTitNaoEstornado = self.resourceID + '_NaoEstornado';
            $scope.gridConfigTitEstornado = self.resourceID + '_Estornado';

            self.onDatasetCreatedEstornados    = onDatasetCreatedEstornados;
            self.onDatasetCreatedNaoEstornados = onDatasetCreatedNaoEstornados;
            self.onDatagridNaoEstornadosLoaded = onDatagridNaoEstornadosLoaded;
            self.onDatagridEstornadosLoaded    = onDatagridEstornadosLoaded;

            self.dsTitulosEstornados;
            self.dsTitulosNaoEstornados;
            self.dataGridNaoEstornados;
            self.dataGridEstornados;

            self.selectedIndex = 1;
            self.possuiTitulosErro = false;
            self.possuiTitulosEstornados = false;
            self.nenhumTituloProcessado = false;

            self.msgErroTitulo;

            var visibleFieldsEstornados = ["RECDESP", "NUFIN", "NUMNOTA", "VLRBAIXA", "DHBAIXA", "ORIGEM"];
            var visibleFieldsNaoEstornados = ["RECDESP", "NUFIN", "NUMNOTA", "VLRBAIXA", "DHBAIXA", "ORIGEM", "CONCILIADO", "DHCONCIL", "MSGIMP"];

            init();

            function init() {
                $step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;
            }

            function onDatasetCreatedEstornados(dataset) {
                self.dsTitulosEstornados = dataset;
                
                dataset.addCriteriaProvider(getCriteriaEstornados);
                
                dataset.addRefreshedListener(function () {
                	if (!self.dsTitulosEstornados.isEmpty()) {
                        self.possuiTitulosEstornados = true;
                        self.selectedIndex = 1;
                    }
                });

                dataset.init();
            }

            function onDatasetCreatedNaoEstornados(dataset) {
                self.dsTitulosNaoEstornados = dataset;
                
                dataset.addLineChangeListener(function(line) {
                    self.msgErroTitulo = self.dsTitulosNaoEstornados.getFieldValue("MSGIMP");
                });

                dataset.init();
            }
            
            function atualizaStatusProcessamento(context) {
            	if(Array.isArray(context.titulosEstornados) && context.titulosEstornados.length > 0) {
            		self.nenhumTituloProcessado = false;
            		
            	} else if(Array.isArray(context.titulosNaoEstornados) && context.titulosNaoEstornados.length > 0) {
            		self.nenhumTituloProcessado = false;
            		
            	} else {
            		self.nenhumTituloProcessado = true;
            	}
            }

            function onDatagridNaoEstornadosLoaded(datagrid) {
                self.dataGridNaoEstornados = datagrid;
            }

            function onDatagridEstornadosLoaded(datagrid) {
                self.dataGridEstornados = datagrid;
            }
            
            function getCriteriaEstornados() {
            	var titulos = $wizard.context && $wizard.context.titulosEstornados ? $wizard.context.titulosEstornados : undefined;
            	return getCriteria(titulos);
            }
            
            function getCriteria(titulos) {
            	var criteria = undefined;
            	
            	if (ArrayUtils.isNotEmpty(titulos)) {
            		var financeiros = [];
            		titulos.forEach(function(titulo) {
            			financeiros.push(titulo.nuFin);
            		});
            		criteria = new Criteria(SqlUtils.buildINClauseByValues("NUFIN", financeiros));
            	} else {
            		criteria = new Criteria("1 = 0")
            	}
            	
            	return criteria;
            }

            function acceptColumnField(fieldMD, dataSet) {
                if(dataSet.getDatasetId() == "dsNaoEstornados") {
                    return isVisibleField(visibleFieldsNaoEstornados, fieldMD.name);

                } else {
                    return isVisibleField(visibleFieldsEstornados, fieldMD.name);
                }
            }

            function isVisibleField(fields, fieldName) {
                if(ArrayUtils.isIn(fields, fieldName)){
					return true;
				}

				return false;
            }

            function onEnterStep() {
            	$step.setCanFinish(true);
            	
            	self.dsTitulosEstornados.refresh();

                if($wizard.context) {
                	atualizaStatusProcessamento($wizard.context);
                	
                	if($wizard.context.titulosNaoEstornados) {
                		var financeirosSelecionados = $wizard.context.dsFinanceiro;
                    	
                        $wizard.context.titulosNaoEstornados.forEach(function(titulo) {
                            for(var i = 0; i < financeirosSelecionados.length; i++) {
                                if(Number(titulo.nuFin) == financeirosSelecionados[i].NUFIN) {
                                    financeirosSelecionados[i].MSGIMP = titulo.msg.$ ? titulo.msg.$ : titulo.msg;
                                    self.dsTitulosNaoEstornados.addRecordsAsObjects(financeirosSelecionados[i]);

                                    break;
                                }
                            }
                        });
                        
                        self.dsTitulosNaoEstornados.sortRecords();
                        
                        if (!self.dsTitulosNaoEstornados.isEmpty()) {
                            self.possuiTitulosErro = true;

                            self.selectedIndex = 0;
                        }
                	}
                }
			}

            function sortMetadata(fieldsMD, dataSet) {
                if(dataSet.getDatasetId() == "dsNaoEstornados") {
                    ordenarCampos(fieldsMD, visibleFieldsNaoEstornados);
                } else {
                    ordenarCampos(fieldsMD, visibleFieldsEstornados);
                }
            }

            function ordenarCampos(fieldsMD, fields) {
                fieldsMD.sort(function (a, b) {
                    return (
                        fields.indexOf(a.name) -
                        fields.indexOf(b.name)
                    );
                });
            }

            function exitStep() {}
        }
    ]);
/**
 * Created by cleverson.puche on 04/11/2016.
 */

angular
    .module('snk.commons')
    .controller('EstornoPopUpController', ['$scope', 'estornoPopUpInfo', 'ServiceProxy', 'i18n', '$popupInstance', 'SkApplicationInstance', 'MessageUtils',
        function ($scope, estornoPopUpInfo, ServiceProxy, i18n, $popupInstance, SkApplicationInstance, MessageUtils) {
            var self = this;

            self.onCancel = onCancel;
            self.onFinish = onFinish;

            var _solicitarReaplicarFiltro = true;
            var _ignorarValidacaoUsuarioCaixa = false;
            var _contaParaCaixaAberto = 0;
            var _estornarTodosAntecipacao = false;
            var _permiteEstornoSemRecomposicao = false;
            var _onFinishServiceName = undefined;

            init();

            function init() {
                if (!estornoPopUpInfo.dsFinanceiro) {
                    throw new MessageError('Financeiro.Estorno.messageFaltaDBDataSet');
                }
                if (!estornoPopUpInfo.statusEstorno) {
                    throw new MessageError('Financeiro.Estorno.messageFaltaStatus');
                }

                if (estornoPopUpInfo.hasOwnProperty('solicitarReaplicarFiltro')) {
                    _solicitarReaplicarFiltro = estornoPopUpInfo.solicitarReaplicarFiltro;
                }
                if (estornoPopUpInfo.hasOwnProperty('ignorarValidacaoUsuarioCaixa')) {
                    _ignorarValidacaoUsuarioCaixa = estornoPopUpInfo.ignorarValidacaoUsuarioCaixa;
                }
                if (estornoPopUpInfo.hasOwnProperty('contaParaCaixaAberto')) {
                    _contaParaCaixaAberto = estornoPopUpInfo.contaParaCaixaAberto;
                }
                if (estornoPopUpInfo.hasOwnProperty('estornarTodosAntecipacao')) {
                    _estornarTodosAntecipacao = estornoPopUpInfo.estornarTodosAntecipacao;
                }
                if (estornoPopUpInfo.hasOwnProperty('permiteEstornoSemRecomposicao')) {
                    _permiteEstornoSemRecomposicao = estornoPopUpInfo.permiteEstornoSemRecomposicao;
                }
                if (estornoPopUpInfo.hasOwnProperty('onFinishServiceName')) {
                    _onFinishServiceName = estornoPopUpInfo.onFinishServiceName;
                }
                self.wizardContext = {
                    dsFinanceiro: estornoPopUpInfo.dsFinanceiro,
                    statusEstorno: estornoPopUpInfo.statusEstorno,
                    dhbaixa: estornoPopUpInfo.dsFinanceiro.getFieldValue('DHBAIXA'),
                    vlrbaixa: estornoPopUpInfo.dsFinanceiro.getFieldValue('VLRBAIXA'),
                    codctabcoint: estornoPopUpInfo.dsFinanceiro.getFieldValue('CODCTABCOINT'),
                    historico: estornoPopUpInfo.dsFinanceiro.getFieldValueAsString('HISTORICO'),
                    permiteEstornoSemRecomposicao: _permiteEstornoSemRecomposicao 
                };
				self.titleWarning = MessageUtils.TITLE_WARNING;
            }

            function onCancel() {
                $popupInstance.dismiss('canceled');
            }

            function onFinish(step) {
                var request = {
                    param: {
                        nuFin: estornoPopUpInfo.dsFinanceiro.getFieldValue("NUFIN"),
                        recompoe: estornoPopUpInfo.statusEstorno.recomposicao,
                        estornarTodosAntecipacao: _estornarTodosAntecipacao, 
                        resourceID: SkApplicationInstance.getResourceID(),
                        ignorarValidacaoUsuarioCaixa: _ignorarValidacaoUsuarioCaixa, 
                        contaParaCaixaAberto: _contaParaCaixaAberto
                    }
                };

                ServiceProxy
                    .callService((_onFinishServiceName != undefined) ? _onFinishServiceName : 'mge@BaixaFinanceiroSP.estornarTitulo', request)
                    .then(function (response) {

                        if (_solicitarReaplicarFiltro) {
                            estornoPopUpInfo.dsFinanceiro.refresh();
                            if(angular.isDefined(estornoPopUpInfo.dsConciliacaoBancaria)){
                                estornoPopUpInfo.dsConciliacaoBancaria.refresh();
                            }
                        } else {
                            MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Financeiro.Estorno.messageEstornoSucesso'));
                        }

                        $popupInstance.success();
                    });
            }
        }
    ]);
/**
 * Created by cleverson.puche on 04/11/2016.
 */
angular
	.module('snk.commons')
	.service('EstornoPopUpService', ['SanPopup', 'SkI18nService',
		function (SanPopup, SkI18nService) {
			var self = this;

			self.openPopUp = openPopUp;

			function openPopUp(popupInfo) {
				if(popupInfo.estornoMultiplo) {
					return SanPopup.open({
						title: SkI18nService.instant('Financeiro.Estorno.titEstornoMultiplo'),
						templateUrl: 'commons/estornopopup/estornoMultiploPopUp/estornoMultiploPopUp.tpl.html',
						controller: 'EstornoMultiploPopUpController',
						controllerAs: 'ctrl',
						size: 'lg',
						height : '500',
						showBtnCancel: false,
						showBtnOk: false,
						showBtnNo: false,
						resolve: {
							estornoPopUpInfo: popupInfo
						}
					}).result;

				} else {
				return SanPopup.open({
					title: SkI18nService.instant('Financeiro.Estorno.titEstorno'),
					templateUrl: 'commons/estornopopup/estornopopup.tpl.html',
					controller: 'EstornoPopUpController',
					controllerAs: 'ctrl',
					size: 'md',
					height : '450',
					showBtnCancel: false,
					showBtnOk: false,
					showBtnNo: false,
					resolve: {
						estornoPopUpInfo: popupInfo
					}
				}).result;
				}
			}
		}
    ]);
angular
    .module('snk.commons')
    .controller('StepRecomposicaoEstornoController', ['$scope', '$wizard', '$step', 'MessageUtils',
		function ($scope, $wizard, $step, MessageUtils) {
			var self = this;

			init();

			function init() {
				self.wizardContext = $wizard.context;
				self.step = "RecomposicaoEstorno";
				self.titleWarning = MessageUtils.TITLE_WARNING;
				self.recompor = false;

				$step.setEnabled(self.wizardContext.statusEstorno.recomposicao);
				$step.onExitStep = exitStep;
				$step.onEnterStep = onEnterStep;
			}

			function exitStep() {
				self.wizardContext.statusEstorno.recomposicao = self.wizardContext.permiteEstornoSemRecomposicao ? self.recompor : true;
			}

			function onEnterStep() {				
				$step.hideFinish(false);
				$step.hideNext(true);
				$step.setCanFinish(true);
			}
		}]);

angular
    .module('snk.commons')
    .controller('StepTituloConciliadoEstornoController', ['$scope', '$wizard', '$step', 'MessageUtils',
		function ($scope, $wizard, $step, MessageUtils) {
			var self = this;

			init();

			function init() {
				self.wizardContext = $wizard.context;
				self.step = "TituloConciliadoEstorno";
				self.titleWarning = MessageUtils.TITLE_WARNING;

				$step.setEnabled(self.wizardContext.statusEstorno.conciliado);
				$step.onEnterStep = onEnterStep;
				$step.onExitStep = exitStep;
			}

			function exitStep() {
				self.wizardContext.statusEstorno.conciliado = true;
			}

			function onEnterStep() {
				var canFinish = !self.wizardContext.statusEstorno.baixaConj && !self.wizardContext.statusEstorno.recomposicao;

				$step.hideFinish(!canFinish);
				$step.hideNext(canFinish);
				$step.setCanFinish(canFinish);
			}
		}]);
/**
 * Created by luiz.figueiredo 27/01/2017
 */
angular
    .module('snk.commons')
    .controller('ConstrutorExpressoesController', ['$scope', '$popupInstance', 'i18n', 'ServiceProxy', 'ObjectUtils', 'StringUtils','popupInfo', function ($scope, $popupInstance, i18n, ServiceProxy, ObjectUtils, StringUtils, popupInfo) {
        var self = this;

        var _editor;

        self.operadores = [
            '+', '-', '*', '/', '=', '>', '<', '<>', '=<', '>=', 'NOT', 'AND', 'OR', '(', ')'
        ];

        self.addOperador = addOperador;
        self.limparExpressao = limparExpressao;
        self.editorCreated = editorCreated;
        self.treeSelectedItem = treeSelectedItem;
        self.addExpressao = addExpressao;
        self.init = init;
        self.filterTree = filterTree;
        self.treeCtrl = {};
        self.showCard = popupInfo.showCard != undefined ? popupInfo.showCard : false;

        $scope.$success = confirm;

        init();

        function addOperador(operador) {
            var variavel = " " + operador + " ";
            
            var texto = self.txtExpressao || '';
            
            var selectionBegin;
            var selectionEnd;
            var _branch = undefined;

            if (self.addFinalExpressao) {
                selectionBegin = texto.length;
                selectionEnd = texto.length;
            } else {
                var selection = _editor.getSelectionRange();

                if (selection.start == selection.end && selection.start == texto.length) {
                    selectionBegin = 0;
                    selectionEnd = 0;
                } else {
                    selectionBegin = selection.start;
                    selectionEnd =  selection.end;
                }
            }

            var startToken = texto.substring(0, selectionBegin);
            var endToken = texto.substring(selectionEnd);

            self.txtExpressao = startToken + variavel + endToken;
        }

        function limparExpressao() {
            self.txtExpressao = '';
        }

        function editorCreated(editor) {
            _editor = editor;
        }

        function treeSelectedItem(branch) {
            _branch = branch;
            if(_branch.folha){
                self.txtDescricao = _branch.descricao;
            }else{
                self.txtDescricao = '';
            }
        }

        function addExpressao(){
        	if (_branch == undefined) {
        		return;
        	}
            if(_branch.folha){ //folha
                addValorExpressao();
            }
         }

        function addValorExpressao(){
        	if (_branch == undefined) {
        		return;
        	}
            var variavel = StringUtils.undefinedAsEmpty(_branch.descricao);
            if (StringUtils.emptyAsNull(variavel) == null) {
                variavel = _branch.label;
            } else {
                variavel = getNameOfDescription(variavel)
            }

            if (variavel == "<VAZIO>"){
                return;
            }

            var areaExpressao = {};
            var txtExpressao = StringUtils.undefinedAsEmpty(self.txtExpressao);
            if (self.addFinalExpressao) {
                variavel = " " + variavel;
                areaExpressao.start = txtExpressao.length;
                areaExpressao.end = txtExpressao.length;
            } else {
                var selectionRange = _editor.getSelectionRange();

                areaExpressao.start = selectionRange.start;
                areaExpressao.end = selectionRange.end;
                variavel = variavel + " ";
            }

            var startToken = txtExpressao.substring(0, areaExpressao.start);
            var endToken = txtExpressao.substring(areaExpressao.end);

            self.txtExpressao = startToken + variavel + endToken;

            _editor.clearSelection();
        }

        function init(){
            self.addFinalExpressao = true;

            self.txtExpressao = popupInfo.dataValue;

            if (popupInfo.contexto != null) {
                ServiceProxy.callService("mge@ConstrutorExpressoesSP.getContexto",{
                    criterio: {
                        contexto: popupInfo.contexto,
                        query: StringUtils.emptyAsNull(popupInfo.query)
                    }
                })
                .then(function(response) {
                    var objCategories = getSortCategoriesByFlex(ObjectUtils.getProperty(response, 'responseBody.contexto'));

                    self.tree = [treeDataParsed(objCategories)];
                });   			
            }
        }

        function getSortCategoriesByFlex(obj) {
            var newObj = {};
            newObj.funcoes = obj["funcoes"];
            newObj.contexto = obj["contexto"];
            newObj.categoriasVariaveis = obj["categoriasVariaveis"];
            newObj.instancias = obj["instancias"];
            newObj.nome = obj["nome"];

            for (var property in obj) {
                if (!angular.isDefined(newObj[property])) {
                    newObj[property] = obj[property];
                }
            }

            return newObj;
        }

        function treeDataParsed(obj){
            var parsed = {};

            if (StringUtils.emptyAsNull(obj) != null && obj.nome) {
                parsed.label = obj.nome;
                 parsed.children = [];
                 parsed.folha = true;
                 parsed.tooltip = "'" + obj.nome + "'";
                angular.forEach(obj, function(value, key) {
                    if ('nome-descricao-contexto'.indexOf(key) == -1) {
                        if (angular.isArray(value)) {
                            value.forEach(function(item) {
                                parsed.children.push(treeDataParsed(item));
                                parsed.folha = false;
                            })
                        } else if (angular.isObject(value)) {
                            parsed.children.push(treeDataParsed(value));
                            parsed.folha = false;
                        }
                    } else if (key == 'descricao'){
                        parsed.descricao = value;
                    }
                })
            }

            return parsed
        }

        function confirm(){
            $popupInstance.success(self.txtExpressao);
        }

        function getNameOfDescription(description){
           var linhas = description.split(/[\r\n]/g);

           var nome = "";
           if (angular.isDefined(linhas) && linhas.length > 0) {
                nome = linhas[0];
           }

           return nome;
        }

        function filterTree(){
            self.treeCtrl.expand_all();
        }
}]);

/**
 * Created by luiz.figueiredo on 27/01/2017.
 */
angular
    .module('snk.commons')
    .service('ConstrutorExpressoesService', ['SanPopup', 'i18n', function(SanPopup, i18n){
        var self = this;

        self.openPopUp = openPopUp;

        function openPopUp(popupInfo) {
            return  SanPopup.open({
             title: i18n('Commons.Expressoes.construtorExpressoes'),
                    templateUrl: 'commons/expressoes/construtorExpressoes.tpl.html',
                    controller: 'ConstrutorExpressoesController',
                    controllerAs: 'ctrl',
                    okBtnLabel: i18n('Commons.Expressoes.btnSalvar'),
                    showBtnNo: false,
                    showBtnCancel: true,
                    size: 'lg',
                    windowClass: 'no-padding-modal-body',
                    grayBG: true,
                    resolve: {
                        popupInfo: popupInfo
                    }
                }).result;
        }
    }]);
/* eslint-disable angular/function-type */
/**
* Created by automatic batch Wesley.Souza on 2019-11-29 16:11:58
*/

angular
    .module('snk.commons.fichaPatrimonialPanel')
    .controller('fichaPatrimonialPanelController', ['$scope', 'StringUtils', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils', 'MessageUtils', 'i18n', 'SanPopup', 'SkApplicationInstance', 'Criteria', '$timeout', 'NumberUtils',
        function ($scope, StringUtils, ServiceProxy, ObjectUtils, ArrayUtils, MessageUtils, i18n, SanPopup, SkApplicationInstance, Criteria, $timeout, NumberUtils) {
            var self = this;

            const defaultGridConfigJson = { 
                gridConfig: { 
                    restrictBySup: false, configName: 'GrdCfgHtml5:' + SkApplicationInstance.getResourceID() + '.gradeImobilizado', compactMode: true, field: {
                         "field0": { name: "Produto.DESCRPROD", width: 220, orderIndex: 0 }, 
                         "field1": { name: "CODBEM", width: 190, orderIndex: 0 }, 
                         "field2": { name: "Produto.CODPROD", width: 120, orderIndex: 0 }, 
                         "field3": { name: "CODBEMORIG", width: 170, orderIndex: 0 }, 
                         "field4": { name: "CODBEMATUAL", width: 170, orderIndex: 0 }, 
                         "field5": { name: "DESCRBEM", width: 220, orderIndex: 0 }, 
                         "field6": { name: "DESCRABREV", width: 220, orderIndex: 0 }, 
                         "field7": { name: "CODLOCAL", width: 220, orderIndex: 0 }, 
                         "field8": { name: "LocalEstoque.DESCRLOCAL", width: 220, orderIndex: 0 }, 
                         "field9": { name: "Produto.REFERENCIA", width: 120, orderIndex: 0 }, 
                         "field10": { name: "Produto.CODVOL", width: 120, orderIndex: 0 }, 
                         "field11": { name: "Produto.MARCA", width: 120, orderIndex: 0 }, 
                         "field12": { name: "Produto.LOCALIZACAO", width: 170, orderIndex: 0 }, 
                         "field13": { name: "Produto.QTDEMB", width: 120, orderIndex: 0 }, 
                         "field14": { name: "NUMNOTA", width: 120, orderIndex: 0 }, 
                         "field15": { name: "DTCOMPRA", width: 120, orderIndex: 0 }, 
                         "field16": { name: "NFSAIDA", width: 120, orderIndex: 0 }, 
                         "field17": { name: "CabecalhoNotaSaida.DTENTSAI", width: 120, orderIndex: 0 }, 
                         "field18": { name: "Contrato.Parceiro.CGC_CPF", width: 220, orderIndex: 0 }, 
                         "field19": { name: "Contrato.NUMCONTRATO", width: 120, orderIndex: 0 }, 
                         "field20": { name: "VLRAQUISICAO", width: 200, orderIndex: 0 }, 
                         "field21": { name: "Contrato.CODPARC", width: 120, orderIndex: 0 }, 
                         "field22": { name: "Contrato.Parceiro.RAZAOSOCIAL", width: 220, orderIndex: 0 }, 
                         "field23": { name: "Contrato.EQUIPAMENTO", width: 120, orderIndex: 0 }, 
                         "field24": { name: "Contrato.AMBIENTE", width: 120, orderIndex: 0 }, 
                         "field25": { name: "Produto.COMPLDESC", width: 200, orderIndex: 0 }, 
                         "field26": { name: "NFRETORNO", width: 120, orderIndex: 0 }, 
                         "field27": { name: "NUMNOTABAIXA", width: 120, orderIndex: 0 }, 
                         "field28": { name: "DTBAIXA", width: 120, orderIndex: 0 }, 
                         "field29": { name: "DTRETORNO", width: 120, orderIndex: 0 }, 
                         "field30": { name: "NFDEVVENDA", width: 120, orderIndex: 0 }, 
                         "field31": { name: "Produto.COMPLDESC", width: 200, orderIndex: 0 }, 
                         "field32": { name: "SALDO", width: 120, orderIndex: 0 }, 
                         "field33": { name: "SaldoImobilizadoAtual.TOTALDEP", width: 120, orderIndex: 0 }, 
                         "field34": { name: "Local.CODEMP", width: 120, orderIndex: 0 }, 
                         "field35": { name: "Local.CODDEPTO", width: 120, orderIndex: 0 }, 
                         "field36": { name: "Local.Departamento.DESCRDEP", width: 160, orderIndex: 0 }, 
                         "field37": { name: "CODPOSSUIDOR", width: 120, orderIndex: 0 }, 
                         "field38": { name: "NOMEPOSSUIDOR", width: 220, orderIndex: 0 }, 
                         "field39": { name: "Produto.CODGRUPOPROD", width: 120, orderIndex: 0 }, 
                         "field40": { name: "Produto.GrupoProduto.DESCRGRUPOPROD", width: 220, orderIndex: 0 }, 
                         "field41": { name: "VLRDEP", width: 120, orderIndex: 0 } 
                        } 
                    } 
                };

            const RESOURCE_ID_CONFIG_OPTIONS = 'br.com.sankhya.mgecom.cons.FichaPatrimonial.configOptions';
            const ID_DATASET_PATRIMONIAL = 'DBDATASET_FICHA_PATRIMONIAL';
            
            const CONSULTAR_DEPRECIACAO = 'D';
            const CONSULTAR_AQUISICAO = 'A';
            const EXIBIR_DEPARTAMENTO 	= 'E';
            const EXIBIR_RESPONSAVEL	= 'P';

            ObjectUtils.implements(self, IDatagridInterceptor);

            // Functions available in the controller
            self.onDatasetCreated = onDatasetCreated;
            self.setFieldsVisible = setFieldsVisible;
            self.setPainelVisible = setPainelVisible;
            self.opcaoSelecionada = opcaoSelecionada;
            self.aplicarFiltro = aplicarFiltro;
            self.fillcolors = fillcolors;
            self.buildOutrasOpcoes = buildOutrasOpcoes;
            self.validarPanelFiltro = validarPanelFiltro;
            self.abrirPopUpEquipamento = abrirPopUpEquipamento;
            self.enviarSelecionados = enviarSelecionados;
            self.permanecerEnviarSelecionados = permanecerEnviarSelecionados;
            self.onLoadContainerFielsFocus = onLoadContainerFielsFocus;
            self.showContratoDescriptionInput = showContratoDescriptionInput;
            self.setChkDisponiveis = setChkDisponiveis;
            self.setChkEstoque = setChkEstoque;
            self.setChkLocado = setChkLocado;
            self.setChkBaixado = setChkBaixado;
            self.voltar = voltar;

            // Implementações da interface IDatagridInterceptor
            self.onDatagridLoaded = onDatagridLoaded;
            self.interceptColumnMetadata = interceptColumnMetadata;
            self.getCellColors = getCellColors;

            // Variables available in the controlle
            self.resourceID = SkApplicationInstance.getResourceID();
            self.gridConfig = self.resourceID + '.gradeImobilizado';
            self.actionBtnIDImobilizado = self.resourceID + 'ActionButtonImobilizado'
            self.dsFichaPatrimonial;
            self.gridFichaPatrimonial;
            self.imobilizadoCtx;
            self.showPanelInformacoes = false;
            self.gridFichaPatrimonialPercentWidth = 100;
            self.chkExibirDepartamento = 'N';
            self.chkExibirPainelResponsavelPossuidor = 'S';
            self.dbPesquisaLocal;
            self.dbPesquisaContrato;
            self.dbPesquisaPossuidor;
            self.dbPesquisaProduto;
            self.chkDisponiveis;
            self.chkEstoque;
            self.chkLocado;
            self.chkBaixado;
            self.qtdBens;
            self._possuiAcao = true;
            self.chkBaixadoEnabled = true;
            self.chkEstoqueEnabled = true;
            self.chkLocadoEnabled = true;
            self.showActionButton = false;
            self._isModoPopup = false;

            var _finishHandler;
            var _data;
            var _preFillData;
            var _codProd;
            var _atualBem;
            var _numContrato;
            var _nunota;
            var _lblStatusBemColor;
            var bemInput;
            var needToRefreshDatagrid = false;
            var _filtroAplicado = false;
            var firstLoad = true;

            init();

            function init() {
                self._isModoPopup = StringUtils.toBoolean($scope.isModoPopup);
                _finishHandler = $scope.finishHandler;
                _preFillData = self.preFillData;
                
                $scope.$watch('data', function(newData){
    		        if (newData) {
    		        	_data = newData;
    		        	_codProd = newData.codProd;
    	                _atualBem = newData.atualBem;
    	                _numContrato = newData.numContrato;
    	                _nunota = newData.nunota;
    	                
    	                if (self.dsFichaPatrimonial) {
    	                	self.dsFichaPatrimonial.refresh();
    	                }
    		        }
    		    });
            }
            
            function voltar() {
            	if (_finishHandler) {
            		_finishHandler({records: null, voltar: true});
            	}
            }
            
            function enviarSelecionados() {
            	if (_finishHandler) {
            		_finishHandler({records: self.dsFichaPatrimonial.getSelectedRecordsAsObjects(undefined, true), voltar: true});
            	}
			}

			function permanecerEnviarSelecionados() {
				if (_finishHandler) {
					_finishHandler({records: self.dsFichaPatrimonial.getSelectedRecordsAsObjects(undefined, true), voltar: false});
				}
            }

            function onDatasetCreated(dataset) {
                self.dsFichaPatrimonial = dataset;

                self.imobilizadoCtx = new DatasetActionButtonContext(self.dsFichaPatrimonial);

                checkIfNeedsDefaultGridConfig();

                
                if(!self._isModoPopup){
                    SkApplicationInstance.loadMgeConfig(self.resourceID).then((result) => {
                        if(result.config != null) {
                            var preferencias = result.config.preferencias;
    
                            self.dbPesquisaProduto = preferencias.codigoProduto;
                            self.dbPesquisaPossuidor = preferencias.codigoPossuidor;
                            self.dbPesquisaContrato = preferencias.codigoContrato;
                            self.txtPesqBens = preferencias.codigoBem;
                            self.chkDisponiveis = StringUtils.toBoolean(preferencias.apenasDisponiveis) ? 'S' : 'N';
                            self.chkEstoque = StringUtils.toBoolean(preferencias.emEstoque) ? 'S' : 'N';
                            self.chkLocado = StringUtils.toBoolean(preferencias.locado) ? 'S' : 'N';
                            self.chkBaixado = StringUtils.toBoolean(preferencias.baixado) ? 'S' : 'N';
                            self.dbPesquisaLocal = preferencias.codigoLocal;
                        }
                    });					
				
					loadConfig();
				}
                self.dbPesquisaProdutoEnabled = !angular.isDefined(_codProd);

                self.dsFichaPatrimonial.addRefreshedListener(function(){
                    self.qtdBens = self.dsFichaPatrimonial.size();

					if (!self._isModoPopup) {
                        var conf = salvarPreferenciasTela(self.resourceID);

                        SkApplicationInstance.saveMgeConfig(self.resourceID, conf).then(function () {
                            SkApplicationInstance.putConfiguracaoTela(self.resourceID, conf);
                        });
                        
                        validaCodBem();
                                         
                        if(_filtroAplicado){
	                    	resultadoFiltro();
                        } 
					} 
                });

                self.dsFichaPatrimonial.addLineChangeListener(function(line){
                    var statusBem = '';

					if(self.dsFichaPatrimonial.getFieldValueAsNumberOrZero('Contrato.NUMCONTRATO') == 0){
						statusBem = ' Em Estoque';
						_lblStatusBemColor = '#0000FF';
					}else{
						statusBem = ' Locado';
						_lblStatusBemColor = '#FF0000';
					}

					if(self.dsFichaPatrimonial.getFieldValueAsNumberOrZero('NUNOTABAIXA') != 0){
						statusBem = ' Baixado';
						_lblStatusBemColor = '#7F5217';
					}

                    self.lblStatusBem = statusBem;
                });

                self.dsFichaPatrimonial.addCriteriaProvider(getCriteria);

                self.dsFichaPatrimonial.init().then(function() {
                	if (self._isModoPopup || angular.isDefined(_nunota)) {
                		self.dsFichaPatrimonial.refresh();
                		
                	} else if (angular.isDefined(_preFillData)) {
                		preFillFields(_preFillData);
                		self.dsFichaPatrimonial.refresh();
                	}
                });

                self.dsFichaPatrimonial.setCanEdit(false);
                self.dsFichaPatrimonial.setCanInsert(false);
                self.dsFichaPatrimonial.setCanRemove(false);

                enableActionButton();
            }
            function aplicarFiltro() {
                self.dsFichaPatrimonial.refresh().then(()=>{
					_filtroAplicado = true;
                });
            }
            
            function resultadoFiltro() {
            	var txtPesqBens = StringUtils.undefinedAsEmpty(self.txtPesqBens);
            	
				if (txtPesqBens.indexOf(";") >= 0) {
					var pesquisa = txtPesqBens;
					var listaPesquisa = pesquisa.split(";");
					var msgBemNaoLocalizado = "";
					var bensEncontrados = self.dsFichaPatrimonial.getRecordsAsObjects();
					var listaBensEncontrados = [];

					listaPesquisa = listaPesquisa.sort();
                    bensEncontrados.forEach(row=>{
						var codBem = row["CODBEM"];
						listaBensEncontrados.push(codBem);
					});

					for(var j = 0; j < listaPesquisa.length; j++){
						var pesquisaBem = listaPesquisa[j];

						pesquisaBem = StringUtils.trim(pesquisaBem);
                        if (!(listaBensEncontrados.indexOf(pesquisaBem) > -1) && (angular.isDefined(pesquisaBem))) {
							var bemNaoLocalizado = "Bem não localizado. Cód: " + pesquisaBem + "</br>";
							msgBemNaoLocalizado += bemNaoLocalizado;
						}
					}

					if(msgBemNaoLocalizado != ""){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, msgBemNaoLocalizado);
					}

					_filtroAplicado = false;
				}
			}
            
            function preFillFields(preFillData){
                self.dbPesquisaProduto = preFillData.codProd;
                self.txtPesqBens = preFillData.codBem;
            }

            function salvarPreferenciasTela(resID) {
				var codigoProduto = StringUtils.undefinedAsEmpty(self.dbPesquisaProduto);
				var codigoPossuidor = StringUtils.undefinedAsEmpty(self.dbPesquisaPossuidor);
				var codigoContrato = StringUtils.undefinedAsEmpty(self.dbPesquisaContrato);
				var codigoBem = StringUtils.undefinedAsEmpty(self.txtPesqBens);
				var apenasDisponiveis = StringUtils.toBoolean(self.chkDisponiveis) ? 'S' : 'N';
				var emEstoque = StringUtils.toBoolean(self.chkEstoque) ? 'S' : 'N';
				var locado = StringUtils.toBoolean(self.chkLocado) ? 'S' : 'N';
				var baixado = StringUtils.toBoolean(self.chkBaixado) ? 'S' : 'N';
				var codigoLocal = StringUtils.undefinedAsEmpty(self.dbPesquisaLocal);

                var config = {
                    chave: resID,
                    tipo: 'T',
                    preferencias: {
                        codigoProduto:  codigoProduto,
                        codigoPossuidor: codigoPossuidor,
                        codigoContrato: codigoContrato,
                        codigoBem: codigoBem,
                        apenasDisponiveis: apenasDisponiveis,
                        emEstoque: emEstoque,
                        locado: locado,
                        baixado: baixado,
                        codigoLocal: codigoLocal
                    }
                }
				return config;
            }
            
            function validaCodBem() {
				var txtPesqBens = StringUtils.undefinedAsEmpty(self.txtPesqBens);
				var resultado = getCriteria();
				var expression = resultado.getExpression();
                
				var existeCodbem = false;
                const provider = self.dsFichaPatrimonial.getCriteriaProvider();
				for (var i = 0; i < provider.length; i++){
                    if(provider[i].getActiveFilters) {
                        let activeFilters = provider[i].getActiveFilters();
                        for(var ii = 0; ii < activeFilters.length; ii++) {
                            if(activeFilters[ii].filterModel.expression.$.includes("CODBEM")){
                                existeCodbem = true;
                            }
                        }    
                    }
				}
				
				if ((angular.isUndefined(txtPesqBens) || txtPesqBens == "") && existeCodbem && !firstLoad)  {
					var bemNaoEncontrado= "Bem não existe ou não pode ser usado aqui.";                            
		            
		            if (self.dsFichaPatrimonial.size() <= 0) {
		                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, bemNaoEncontrado);
		            }
				}
			}

            function getCriteria() {                
				var criteria = Criteria();
                criteria.append(" this.CODBEM <> '<TODOS>' ");
				if(StringUtils.toBoolean(self.chkDisponiveis)){
					if(StringUtils.emptyAsUndefined(_atualBem) != undefined){
						if(_atualBem == "B" || _atualBem == "1"){
                            criteria.and(' this.DTBAIXA IS NULL AND this.NUMCONTRATO = 0 AND  (this.NUNOTABAIXA IS NULL OR this.NUNOTABAIXA = 0) AND (this.NUNOTA IS NULL OR this.NUNOTA < ?) AND (this.NUNOTASAIDA IS NULL OR this.NUNOTASAIDA < ?) AND (this.NUNOTADEV IS NULL OR this.NUNOTADEV < ?) ',
                             [Criteria.buildNumberParameter(_nunota), Criteria.buildNumberParameter(_nunota), Criteria.buildNumberParameter(_nunota)]);
						}else if(_atualBem == "T"){
                            criteria.and(' (this.NUMCONTRATO = ? OR this.NUMCONTRATO = 0) AND this.DTBAIXA IS NULL AND (this.NUNOTABAIXA IS NULL OR this.NUNOTABAIXA = 0) AND (this.NUNOTA IS NULL OR this.NUNOTA < ?)  AND (this.NUNOTADEV IS NULL OR this.NUNOTADEV < ?) ',
                             [Criteria.buildNumberParameter(_numContrato), Criteria.buildNumberParameter(_nunota), Criteria.buildNumberParameter(_nunota)]);
						}else if(_atualBem == "D"){
                            criteria.and(' this.NUMCONTRATO = ? AND this.DTBAIXA IS NULL AND (this.NUNOTABAIXA IS NULL OR this.NUNOTABAIXA = 0) AND (this.NUNOTA IS NULL OR this.NUNOTA < ?) AND (this.NUNOTASAIDA IS NOT NULL AND this.NUNOTASAIDA < ?) ',
                             [Criteria.buildNumberParameter(_numContrato), Criteria.buildNumberParameter(_nunota), Criteria.buildNumberParameter(_nunota)]);
						}else if(_atualBem == "E"){
                            criteria.and(' this.DTBAIXA IS NOT NULL AND this.NUMCONTRATO = 0 AND (this.NUNOTA IS NULL OR this.NUNOTA < ?) AND (this.NUNOTABAIXA IS NOT NULL AND this.NUNOTABAIXA <> 0 AND this.NUNOTABAIXA < ?) ',
                             [Criteria.buildNumberParameter(_nunota), Criteria.buildNumberParameter(_nunota)]);
						}
					}
				}
				else {
					var filtrouEstoqueOuLocado = false;
                    var exp = '';
                    var filtraLocado = StringUtils.toBoolean(self.chkLocado);
                    var filtraEstoque = StringUtils.toBoolean(self.chkEstoque);
					if(filtraEstoque || filtraLocado){
						filtrouEstoqueOuLocado = true;
						if(filtraEstoque && filtraLocado){
                            exp += ' ( this.NUMCONTRATO = this.NUMCONTRATO ';
						}else if(filtraEstoque && !filtraLocado){
							exp += ' ( this.NUMCONTRATO = 0 ';
						}else if(!filtraEstoque && filtraLocado){
							exp += ' ( this.NUMCONTRATO <> 0 ';
						}
					}
					
					var strBemAtivo = ' ( this.DTBAIXA IS NULL AND (this.NUNOTABAIXA IS NULL OR this.NUNOTABAIXA = 0 ) ) '
					
					if(StringUtils.toBoolean(self.chkBaixado)){
						if(filtrouEstoqueOuLocado){
							exp += ' OR NOT ' + strBemAtivo + ' ) ';
						}else{
							exp += ' NOT ' + strBemAtivo;
						}
					}else{
						if(filtrouEstoqueOuLocado){
							exp += ' AND ' +strBemAtivo + ' ) ';
						}else{
							exp += strBemAtivo;
						}
                    }
                    criteria.and(exp);
				}
				
				if(angular.isDefined(_codProd)){
                    criteria.and(' this.CODPROD = ? ',
                             Criteria.buildNumberParameter(_codProd));
				}
				else if(angular.isDefined(self.dbPesquisaProduto)){
                    criteria.and(' this.CODPROD = ? ',
                             Criteria.buildNumberParameter(self.dbPesquisaProduto));
				}
				
				if(angular.isDefined(self.dbPesquisaPossuidor)){
					var exp = '';					
					exp += ' (';
					exp += 'CASE ';
					exp += 'WHEN NULLVALUE(TCIBEM.NUMCONTRATO, 0) <> 0 AND NULLVALUE(TCIBEM.NUNOTASAIDA, 0) <> 0 THEN (';
					exp += 'SELECT CAB.CODPARC FROM TGFCAB CAB WHERE CAB.NUNOTA = NULLVALUE(TCIBEM.NUNOTASAIDA, 0)';
					exp += ') ELSE (';
					exp += 'SELECT CON.CODPARC FROM TCSCON CON WHERE CON.NUMCONTRATO = NULLVALUE(TCIBEM.NUMCONTRATO, 0)';
					exp += ') END';
					exp += ') = ? ';
					criteria.and(exp, 
						Criteria.buildNumberParameter(self.dbPesquisaPossuidor));
				}
				
				if(angular.isDefined(self.dbPesquisaContrato)){
                    criteria.and(' this.NUMCONTRATO = ? ',
                             Criteria.buildNumberParameter(self.dbPesquisaContrato));
				}
				
                if (angular.isDefined(self.txtPesqBens)) {
					if (self.txtPesqBens.indexOf(";") < 0) {                        
						criteria.and(' this.CODBEM LIKE ? ', Criteria.buildStringParameter('%' + self.txtPesqBens + '%'));
						
					} else {
						var listaBens = self.txtPesqBens.split(";");
						
						if (listaBens && listaBens.length > 0) {
							criteria.append(" AND ( ");
							for (var i = 0; i < listaBens.length; i++) {
								var codBem = StringUtils.trim(listaBens[i]);
								
								criteria.append(' this.CODBEM =  ? ', Criteria.buildStringParameter(codBem));
								
								if (i < listaBens.length - 1) {
									criteria.append(" OR ");
								}
							}
							criteria.append(" ) ");
						}
					}
				}
				
				if (angular.isDefined(self.dbPesquisaGrupoProduto)) {
                    criteria.and(' Produto->CODGRUPOPROD = ? ',
                             Criteria.buildNumberParameter(self.dbPesquisaGrupoProduto));
				}
				
				if(angular.isDefined(self.dbPesquisaLocal)){
					criteria.and(" CASE WHEN NULLVALUE(this.NUNOTABAIXA,0) <> 0 AND NULLVALUE(this.NUNOTABAIXA,0) > NULLVALUE(this.NUNOTASAIDA,0) AND NULLVALUE(this.NUNOTABAIXA,0) > NULLVALUE(this.NUNOTADEVVENDA,0) AND NULLVALUE(this.NUNOTABAIXA,0) > NULLVALUE(this.NUNOTADEV,0) THEN 0 " +
						   "	 	  ELSE (SELECT MAX(I.CODLOCALORIG) " +
						   "	 	   	    FROM TGFITE I " +
						   "	               , TGFCAB C " +
						   "	               , TCIIBE IBE " +
						   "	            WHERE I.CODPROD = this.CODPROD " +
						   "	 		        AND I.NUNOTA = CASE WHEN NULLVALUE(this.NUNOTADEV,0) <> 0 AND NULLVALUE(this.NUNOTADEV,0) > NULLVALUE(this.NUNOTABAIXA,0) AND NULLVALUE(this.NUNOTADEV,0) > NULLVALUE(this.NUNOTASAIDA,0) AND NULLVALUE(this.NUNOTADEV,0) > NULLVALUE(this.NUNOTADEVVENDA,0) THEN NULLVALUE(this.NUNOTADEV,0) " +
						   "	 							        WHEN NULLVALUE(this.NUNOTADEVVENDA,0) <> 0 AND NULLVALUE(this.NUNOTADEVVENDA,0) > NULLVALUE(this.NUNOTABAIXA,0) AND NULLVALUE(this.NUNOTADEVVENDA,0) > NULLVALUE(this.NUNOTASAIDA,0) AND NULLVALUE(this.NUNOTADEVVENDA,0) > NULLVALUE(this.NUNOTADEV,0) THEN NULLVALUE(this.NUNOTADEVVENDA,0) " +
						   "	 							        WHEN NULLVALUE(this.NUNOTASAIDA,0) <> 0 AND NULLVALUE(this.NUNOTASAIDA,0) > NULLVALUE(this.NUNOTABAIXA,0) AND NULLVALUE(this.NUNOTASAIDA,0) > NULLVALUE(this.NUNOTADEVVENDA,0) AND NULLVALUE(this.NUNOTASAIDA,0) > NULLVALUE(this.NUNOTADEV,0) THEN NULLVALUE(this.NUNOTASAIDA,0)  " +
						   "	 							        WHEN NULLVALUE(this.NUNOTABAIXA,0) <> 0 AND NULLVALUE(this.NUNOTABAIXA,0) > NULLVALUE(this.NUNOTASAIDA,0) AND NULLVALUE(this.NUNOTABAIXA,0) > NULLVALUE(this.NUNOTADEVVENDA,0) AND NULLVALUE(this.NUNOTABAIXA,0) > NULLVALUE(this.NUNOTADEV,0) THEN 0 " +
						   "	 							        ELSE this.NUNOTA " +
						   "	 						       END " +
						   "	 				AND I.NUNOTA = C.NUNOTA " +
						   "	 				AND IBE.NUNOTA = I.NUNOTA " +
						   "	 				AND IBE.SEQUENCIA = ABS(I.SEQUENCIA) " +
						   "	 				AND IBE.CODPROD = this.CODPROD " +
						   "	 				AND IBE.CODBEM = this.CODBEM " +
						   "	 				AND I.NUNOTA = C.NUNOTA " +
						   "	 			    AND (C.TIPMOV <> 'T' OR I.SEQUENCIA < 0 OR this.NUNOTASAIDA = 0 OR this.NUNOTASAIDA IS NULL) " +
						   "	 			) " +
						   "	 END = ? ", Criteria.buildNumberParameter(self.dbPesquisaLocal));
				}
	
				return criteria;
            }

            function loadConfig() {
                SkApplicationInstance.loadMgeConfig(RESOURCE_ID_CONFIG_OPTIONS).then(function(result) {
                    if (result.config != null) {
                        self.chkExibirDepartamento = StringUtils.toBoolean(result.config.exibirDepartamento.$) ? 'S' : 'N';
                        self.chkExibirPainelResponsavelPossuidor = StringUtils.toBoolean(result.config.exibirPainelResponsavelPossuidor.$) ? 'S' : 'N';
                    }
                    setFieldsVisible();
                    setPainelVisible();
                });

				
            }

            function onDatagridLoaded(datagrid, dataset) {
                self.gridFichaPatrimonial = datagrid;
                if (needToRefreshDatagrid) {
                    self.gridFichaPatrimonial.refreshView();
                }
                
				setTimeout(function(){ 
				    firstLoad = false;
				}, 3000);					
            }

            function opcaoSelecionada(checked, option){
				switch(option){
					case CONSULTAR_DEPRECIACAO:
						abrirPopUpDepreciacao();
						break;

					case CONSULTAR_AQUISICAO:
						abrirPopUpAquisicao();
						break;

					case EXIBIR_DEPARTAMENTO:
                        self.chkExibirDepartamento = checked ? 'S' : 'N';
						setFieldsVisible();
						saveConfig();
						break;

					case EXIBIR_RESPONSAVEL:
                        self.chkExibirPainelResponsavelPossuidor = checked ? 'S' : 'N';
						setPainelVisible();
						saveConfig();
						break;
				}
			}	

            function abrirPopUpEquipamento() {
                var codProduto = self.dsFichaPatrimonial.getFieldValueAsNumber('CODPROD');
				var codBem = self.dsFichaPatrimonial.getFieldValueAsString('CODBEM');


                SanPopup.open({
					title: i18n('Comercial.FichaPatrimonial.titleEquipamentoBem', [self.dsFichaPatrimonial.getFieldValueAsString("Produto.DESCRPROD"), codBem]),
                    templateUrl: 'commons/fichaPatrimonialPanel/popup/EquipamentoPopUp/EquipamentoPopUp.tpl.html',
					controller: 'EquipamentoPopUpController',
                    controllerAs: 'ctrl',
                    windowClass: 'popup-equipamentos',
                    cancelBtnLabel: i18n('Comercial.FichaPatrimonial.buttonFechar'),
                    showBtnOk: false,
					resolve: {
						data: {
                            codProd: codProduto,
                            codigoBem: codBem
						}
					}
				});
            }

            function abrirPopUpDepreciacao() {
                var codProduto = self.dsFichaPatrimonial.getFieldValueAsString('CODPROD');
				var codBem = self.dsFichaPatrimonial.getFieldValueAsString('CODBEM');

                if(angular.isDefined(StringUtils.emptyAsUndefined(codBem)) && angular.isDefined(StringUtils.emptyAsUndefined(codProduto))){
                    SanPopup.open({
                        title: i18n('Comercial.FichaPatrimonial.titleConsultaDepreciacaoBem', [self.dsFichaPatrimonial.getFieldValueAsString("Produto.DESCRPROD"), codBem]),
                        templateUrl: 'commons/fichaPatrimonialPanel/popup/DepreciacaoPopUp/DepreciacaoPopUp.tpl.html',
                        controller: 'DepreciacaoPopUpController',
                        controllerAs: 'ctrl',
                        windowClass: 'popup-depreciacao',
                        okBtnLabel: i18n('Comercial.FichaPatrimonial.buttonExcluir'),
                        okBtnClass: 'btn-danger',
                        cancelBtnLabel: i18n('Comercial.FichaPatrimonial.buttonFechar'),
                        resolve: {
                            data: {
                                codProd: codProduto,
                                codigoBem: codBem
                            }
                        }
                    });
                } else {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaPatrimonial.messageSelecioneBemConsulta'));
                }
            }

            function abrirPopUpAquisicao() {
                SanPopup.open({
                    title: i18n('Comercial.FichaPatrimonial.titleConsultaAquisicao'),
                    templateUrl: 'commons/fichaPatrimonialPanel/popup/AquisicaoPopUp/AquisicaoPopUp.tpl.html',
                    controller: 'AquisicaoPopUpController',
                    size: 'lg',
                    controllerAs: 'ctrl',
                    showBtnCancel: false
                });
            }

            function saveConfig() {
                var config = {
                    exibirDepartamento: { $: StringUtils.toBoolean(self.chkExibirDepartamento)},
                    exibirPainelResponsavelPossuidor: { $: StringUtils.toBoolean(self.chkExibirPainelResponsavelPossuidor)}
                };

                SkApplicationInstance.saveMgeConfig(RESOURCE_ID_CONFIG_OPTIONS, config).then(function () {
                    SkApplicationInstance.putConfiguracaoTela(RESOURCE_ID_CONFIG_OPTIONS, config);
                });
            }

            function validarPanelFiltro() {
				self.chkBaixado = 'N';
				self.chkBaixadoEnabled = !StringUtils.toBoolean(self.chkDisponiveis);
				self.chkEstoque = 'N';
				self.chkEstoqueEnabled = !StringUtils.toBoolean(self.chkDisponiveis);
				self.chkLocado = 'N';
				self.chkLocadoEnabled = !StringUtils.toBoolean(self.chkDisponiveis);
            }

            function verificarBem() {
                var pesquisaBens = self.txtPesqBens ? self.txtPesqBens.split(";") : [];
                var bensNaoEncontrados = ObjectUtils.clone(pesquisaBens);
                var recordsElements = self.dsFichaPatrimonial.getRecordsAsObjects();

                recordsElements.some((record, i) => {
                    var codBem = record.CODBEM;
                    var matching = false;

                    ArrayUtils.forEach(pesquisaBens, function(bem) {
                        matching = codBem.toString().toUpperCase().indexOf(bem.toUpperCase()) > -1;

                        if (matching) {
                            if (i != self.dsFichaPatrimonial.getCurrentIndex()) {
                                self.dsFichaPatrimonial.gotoRow(i).then(() => bemInput.focus())
                            }

                            var indexBens = bensNaoEncontrados.indexOf(bem);

                            if (indexBens > -1) {
                                bensNaoEncontrados.splice(indexBens, 1);
                            }

                            matching = true;
                        }
                    });

                    return matching;
                });

                if (!ObjectUtils.isEmpty(bensNaoEncontrados)) {
                    var mensagemBemNaoEncontrado = "";

                    ArrayUtils.forEach(bensNaoEncontrados, function(bem) {
                        mensagemBemNaoEncontrado = mensagemBemNaoEncontrado.concat(i18n('Comercial.FichaPatrimonial.bemNaoEncontrado') + bem + "<br/>");
                    });

                    MessageUtils.showAlert(mensagemBemNaoEncontrado);
                }
            }

            function getCellColors(row, col, rowIndex, colIndex) {
                var numContratoIndex = self.dsFichaPatrimonial.getFieldIndexByName('Contrato.NUMCONTRATO');
                var color = '';
                if (angular.isDefined(row.entity)) {
                    if (NumberUtils.getNumberOrZero(row.entity[numContratoIndex]) == 0) {
                        color = '#0000FF';
                    } else {
                        color = '#FF0000';
                    }
                    var nunotaBaixaIndex = self.dsFichaPatrimonial.getFieldIndexByName('NUNOTABAIXA');
                    if(NumberUtils.getNumberOrZero(row.entity[nunotaBaixaIndex]) != 0){
                        color = '#7F5217';
                    }
                }
                return color;
            }

            function setFieldsVisible() {
                if(angular.isDefined(self.gridFichaPatrimonial)){
                    self.gridFichaPatrimonial.getColumnByName('Local.CODEMP').setVisible(StringUtils.toBoolean(self.chkExibirDepartamento));
                    self.gridFichaPatrimonial.getColumnByName('Local.CODDEPTO').setVisible(StringUtils.toBoolean(self.chkExibirDepartamento));
                    self.gridFichaPatrimonial.getColumnByName('Local.Departamento.DESCRDEP').setVisible(StringUtils.toBoolean(self.chkExibirDepartamento));	
                }
			}

			function setPainelVisible() {
                self.showPanelInformacoes = StringUtils.toBoolean(self.chkExibirPainelResponsavelPossuidor);
				if (self.showPanelInformacoes) {
					self.gridFichaPatrimonialPercentWidth = 80;
				} else {
					self.gridFichaPatrimonialPercentWidth = 100;
				}
            }

            function fillcolors(){
                return _lblStatusBemColor;
            }

            function buildOutrasOpcoes() {
            	var menuDataProvider = [];
            	
            	menuDataProvider.push({
                    label: i18n('Comercial.FichaPatrimonial.itemConsultarDepreciacao'),
                    action: function(event, param, checked) { opcaoSelecionada(checked, CONSULTAR_DEPRECIACAO) },
                    searchId: CONSULTAR_DEPRECIACAO
                });

                if (SkApplicationInstance.isMinRequiredVersion("4.35")) {
                    menuDataProvider.push({
                        label: i18n('Comercial.FichaPatrimonial.itemConsultarAquisicao'),
                        action: (event, param, checked) => opcaoSelecionada(checked, CONSULTAR_AQUISICAO),
                        searchId: CONSULTAR_AQUISICAO
                    });
                }

            	menuDataProvider.push({
            		label: i18n('Comercial.FichaPatrimonial.itemExibirDepartamento'),
            		action: function(event, param, checked) { opcaoSelecionada(checked, EXIBIR_DEPARTAMENTO) },
            		type: "check",
            		checked: StringUtils.toBoolean(self.chkExibirDepartamento),
            		searchId: EXIBIR_DEPARTAMENTO
            	});
            	
            	menuDataProvider.push({
            		label: i18n('Comercial.FichaPatrimonial.itemExibirPainelResponsavelPossuidor'),
            		action: function(event, param, checked) { opcaoSelecionada(checked, EXIBIR_RESPONSAVEL) },
            		type: "check",
            		checked: StringUtils.toBoolean(self.chkExibirPainelResponsavelPossuidor),
            		searchId: EXIBIR_RESPONSAVEL
            	});
            	
            	return menuDataProvider;
            }

            function enableActionButton() {
                self.showActionButton = false;
                ServiceProxy.callService('ActionButtonsSP.getActions', {
                    param: {
                        entityName: 'Imobilizado',
                        resourceID: self.resourceID,
                        randomNumber: Math.floor(Math.random() * 1000)
                    }
                }).then(function (result) {
                    if (result.responseBody.actions) {
                        self.showActionButton = result.responseBody.actions.action != undefined;
                    }
                });
            
            }

            function onLoadContainerFielsFocus(event){
                bemInput = event.target[0].querySelectorAll('#txtPesqBensFp input')[0];

                var fieldId;
                if (_codProd == null) {
                    fieldId = '#dbPesquisaProduto';
                } else {
                    fieldId = '#dbPesquisaPossuidor';
                }

                var elems = event.target[0].querySelectorAll(fieldId + ' sk-text-input input');
                if(elems.length > 0){
                    elems[0].focus();
                }
            }

            function checkIfNeedsDefaultGridConfig(){
                var chave = 'GrdCfgHtml5:' + self.gridConfig;
                var gridConfigRequest = {
                    gridConfig: {
                        configName: chave
                    }
                };
                ServiceProxy.callService('GridConfig.getGridConfigFromJson', gridConfigRequest).then(function (result) {
                            if(!result.responseBody.gridConfig.configName){
                                ServiceProxy.callService('GridConfig.saveGridConfigFromJSON', defaultGridConfigJson).then(function (result) {
                                    needToRefreshDatagrid = true;
                                });
                            }
                });
            };

            function showContratoDescriptionInput() {
                return !self._isModoPopup;
            }
            function setChkDisponiveis() {
                self.chkDisponiveis = self.chkDisponiveis == 'S' ? 'N' : 'S';
                validarPanelFiltro();
            }
            function setChkEstoque() {
                if(self.chkEstoqueEnabled){
                    self.chkEstoque = self.chkEstoque == 'S' ? 'N' : 'S';
                }
            }
            function setChkLocado() {
                if(self.chkLocadoEnabled){
                    self.chkLocado = self.chkLocado == 'S' ? 'N' : 'S';
                }
            }
            function setChkBaixado() {
                if(self.chkBaixadoEnabled){
                    self.chkBaixado = self.chkBaixado == 'S' ? 'N' : 'S';
                }
            }

            function interceptColumnMetadata(field) {
                if(field.name == 'CODBEM'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodBem');
                } else if(field.name == 'Produto.CODPROD'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodProd');
                    field.visible = false;
                } else if(field.name == 'CODBEMORIG'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodBemOrigem');
                    field.visible = true;
                } else if(field.name == 'CODBEMATUAL'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodBemAtual');
                } else if(field.name == 'CODLOCAL'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerLocal');
                } else if(field.name == 'LocalEstoque.DESCRLOCAL'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerDescricaoLocal');
                } else if(field.name == 'Produto.REFERENCIA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodBarra');
                } else if(field.name == 'Produto.MARCA'){
                    field.description = i18n('Comercial.FichaPatrimonial.labelMarca');
                } else if(field.name == 'Produto.LOCALIZACAO'){
                    field.description = i18n('Comercial.FichaPatrimonial.labelLocalizacao');
                } else if(field.name == 'Produto.QTDEMB'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerQtdEmb');
                } else if(field.name == 'NUMNOTA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNFEntrada');
                } else if(field.name == 'DTCOMPRA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerDtEntrada');
                } else if(field.name == 'NFSAIDA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNfSaida');
                    field.visible = true;
                } else if(field.name == 'CabecalhoNotaSaida.DTENTSAI'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerDtSaida');
                } else if(field.name == 'Contrato.NUMCONTRATO'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNroContrato');
                } else if(field.name == 'Contrato.CODPARC'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodParcContato');
                } else if(field.name == 'Contrato.Parceiro.RAZAOSOCIAL'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNomeParcContrato');
                } else if(field.name == 'NFRETORNO'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNfRetorno');
                    field.visible = true;
                } else if(field.name == 'NUMNOTABAIXA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNfBaixa');
                } else if(field.name == 'DTBAIXA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerDtBaixa');
                } else if(field.name == 'DTRETORNO'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerDtRetorno');
                    field.visible = true;
                } else if(field.name == 'SALDO'){
                    field.description = "Saldo";
                    field.visible = true;
                } else if(field.name == 'NFDEVVENDA'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNfDevolucaoVenda');
                    field.visible = true;
                } else if(field.name == 'Local.CODEMP'){
                    field.description = i18n('Comercial.FichaPatrimonial.labelCodEmp');
                } else if(field.name == 'Local.CODDEPTO'){
                    field.description = i18n('Comercial.FichaPatrimonial.labelCodDepto');
                } else if(field.name == 'Local.Departamento.DESCRDEP'){
                    field.description = i18n('Comercial.FichaPatrimonial.labelDescricaoDepartamento');
                } else if(field.name == 'CODPOSSUIDOR'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodParcPossuidor');
                    field.visible = true;
                } else if(field.name == 'NOMEPOSSUIDOR'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerNomeParcPossuidor');
                    field.visible = true;
                } else if(field.name == 'Produto.CODGRUPOPROD'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerCodGrupoProduto');
                } else if(field.name == 'Produto.GrupoProduto.DESCRGRUPOPROD'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerGrupoProduto');
                } else if(field.name == 'VLRDEP'){
                    field.description = i18n('Comercial.FichaPatrimonial.headerBaseDepreciacao');
                }else if(field.name == 'Empresa.NOMEFANTASIA'){                	
                    field.description =i18n('Comercial.FichaPatrimonial.labelNomeProprietario');                  
                }else if(field.name == 'Empresa.CODEMP'){                	
                    field.description=i18n('Comercial.FichaPatrimonial.labelCodProprietario');                   
                }
            }
        }]);

/* eslint-disable angular/function-type */
/**
* Created by automatic batch Wesley.Souza on 2019-11-29 16:11:58
*/
/**
 * @ngdoc directive
 * @name snk.commons.fichapatrimonialpanel.directive:sk-ficha-patrimonial-panel
 * @restrict E
 * @description
 * Este é o componente responsável por apresentar a ficha patrimonial
 * @param {SkIsModoPopup} [sk-is-modo-popup=false] Se o componente esta contido em um popup
 * @param {skFinishHandler} [sk-finish-handler=undefined] Função executada ao final da operação no componente 
 * @param {skData} [sk-data=undefined] Objeto com as propriedades para pre-carregamento das informações 
 * quando componente esta no modo popup 
 * @param {skPreFillData} [sk-pre-fill-data=undefined] Objeto com valores para serem enviados aos campos de filtro
 * @example
    <sk-application ng-controller="FichaPatrimonialController as ctrl" >
        <sk-ficha-patrimonial-panel sk-is-modo-popup="false" sk-pre-fill-data="{codProd: ctrl.codProd, codBem: ctrl.codBem}" sk-height="100%" sk-width="100%" sk-position="absolute" ></sk-ficha-patrimonial-panel>
    </sk-application>
 */
angular
    .module('snk.commons.fichaPatrimonialPanel')
    .directive('skFichaPatrimonialPanel',
        function () {
            return {
                templateUrl: 'commons/fichaPatrimonialPanel/fichapatrimonialpanel.tpl.html',
                controller: 'fichaPatrimonialPanelController as ctrl',
                scope: {
                    isModoPopup: '@skIsModoPopup',
                    finishHandler: '&skFinishHandler',
                    data: '=skData',
                    preFillData: '=skPreFillData'
                }
            }
        }
    );

angular
	.module('snk.commons.fichaPatrimonialPanel')
	.controller('AquisicaoPopUpController', ['$scope', '$popupInstance', 'ObjectUtils', 'Criteria', 'SkApplicationInstance',
        function ($scope, $popupInstance, ObjectUtils, Criteria, SkApplicationInstance) {
            const self = this;

            const _resourceID = SkApplicationInstance.getResourceID() + '.Aquisicao';

            self.onDatasetCreated = onDatasetCreated;
            self.onDatagridLoaded = onDatagridLoaded;
            self.dsMovimentacaoPisCofinsAquisicao;

            self.resourceIdFilter = _resourceID + '.filter';
            self.resourceIdGridConfig = _resourceID + '.gridConfig';

            function onDatasetCreated(dataset) {
                self.dsMovimentacaoPisCofinsAquisicao = dataset;
                self.dsMovimentacaoPisCofinsAquisicao.init();
            }

            function onDatagridLoaded(datagrid) {
                self.dgMovimentacaoPisCofinsAquisicao = datagrid;
            }
        }
	]);

/* eslint-disable angular/function-type */
/* eslint-disable angular/controller-as */
angular
	.module('snk.commons.fichaPatrimonialPanel')
	.controller('DepreciacaoPopUpController', ['$popupInstance', '$scope', 'i18n', 'DomUtil', 'TooltipBuilder', 'ServiceProxy', 'data', 'MessageUtils', 'StringUtils', 'DateUtils', 'Criteria', 'ObjectUtils', 'SkApplicationInstance',
		function ($popupInstance, $scope, i18n, DomUtil, TooltipBuilder, ServiceProxy, data, MessageUtils, StringUtils, DateUtils, Criteria, ObjectUtils, SkApplicationInstance) {
            var self = this;

            $scope.$success = popupSuccess;

            self.onDatasetEquipamentoCreated = onDatasetEquipamentoCreated;
            self.onDatagridLoaded = onDatagridLoaded;

            self.dsSaldoImobilizado;

            var _codProd = data.codProd;
            var _codBem = data.codigoBem;
            var _gridDepreciacao;

            function onDatagridLoaded(datagrid) {
                _gridDepreciacao = datagrid;
            }

            function onDatasetEquipamentoCreated(dataset){
                self.dsSaldoImobilizado = dataset;
                self.dsSaldoImobilizado.addCriteriaProvider(getCriteria);
                self.dsSaldoImobilizado.initAndRefresh();
            }

            function getCriteria() {
                var criteria = Criteria();
                criteria.append('1 = 1');
                if(angular.isDefined(StringUtils.emptyAsUndefined(_codBem))) {
                    criteria.and("this.CODBEM IN (SELECT CODBEM FROM TCIMOV WHERE TIPMOV IN ('A','C','D')) AND this.CODBEM = ? AND this.CODPROD = ?",
                                    [Criteria.buildStringParameter(_codBem),
                                        Criteria.buildNumberParameter(_codProd)]);
                }
                return criteria;
            }

            function popupSuccess() {
                excluirDepreciacao();   
            }

            function excluirDepreciacao() {
                var depreciacoesSelecionadas = _gridDepreciacao.getSelectedRecords();

                if (depreciacoesSelecionadas.length <= 0) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaPatrimonial.msgSemDepreciacao'));
                } else {
                    MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaPatrimonial.msgConfirmarExclusao'))
                        .then(() => {
                            var params = {
                                params: {
                                    CODPROD: { $: _codProd },
                                    CODBEM: { $: _codBem },
                                    REFERENCIA: { $: DateUtils.formatDate(_gridDepreciacao.getSelectedRecords()[0].REFERENCIA) }
                                }
                            };
                            ServiceProxy.callService("mgecom@FichaPatrimonialSP.excluirDepreciacao",params)
                                .then(() => MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Comercial.FichaPatrimonial.msgExclusaoSucesso'))
                                            .then(() => _gridDepreciacao.getDataset().refresh()));
                        }
                    );
                }
            }
		}
	]);

/* eslint-disable angular/function-type */
/* eslint-disable angular/controller-as */
angular
	.module('snk.commons.fichaPatrimonialPanel')
	.controller('EquipamentoPopUpController', ['$popupInstance', '$scope', 'i18n', 'DomUtil', 'TooltipBuilder', 'ServiceProxy', 'data', 'MessageUtils', 'StringUtils', 'DateUtils', 'Criteria', 'ObjectUtils', 'SkApplicationInstance',
		function ($popupInstance, $scope, i18n, DomUtil, TooltipBuilder, ServiceProxy, data, MessageUtils, StringUtils, DateUtils, Criteria, ObjectUtils, SkApplicationInstance) {
            var self = this;

            $scope.$success = popupSuccess;

            self.onDatasetEquipamentoCreated = onDatasetEquipamentoCreated;
            self.onDatagridLoaded = onDatagridLoaded;

            self.dsEquipamento;

            var _codProd = data.codProd;
            var _codBem = data.codigoBem;
            var _gridEquipamento;

            function onDatagridLoaded(datagrid) {
                _gridEquipamento = datagrid;
            }

            function onDatasetEquipamentoCreated(dataset){
                self.dsEquipamento = dataset;
                self.dsEquipamento.init();
                buscarEquipamentos();
            }

            function buscarEquipamentos(){
                var params = {
                    BEM: {
                        codProd: _codProd,
                        codBem: _codBem
                    }
                };
				ServiceProxy
					.callService('mge@ProdutoSP.montaEquipamentoBem', params)
					.then(function (result) {
                        updateDataset(self.dsEquipamento, result.responseBody.data.row);
					});

            }
            function updateDataset(dataSet, data) {
				dataSet.clearDataSet();
				if (!data) {
					return;
                }
                dataSet.whenMetadataLoaded().then(function () {
					dataSet.addRecordsAsObjects(data, function (value, fieldMD) {
                        return value === undefined ? null : value.$;
                    });
					dataSet.gotoRow(0);
                });
            }

            function popupSuccess() {
                $popupInstance.success();
            }
		}
	]);

angular
    .module('snk.commons')
    .component('skConfiguradorBuscaMagica', {
        templateUrl: 'commons/fichaparceiro/ConfiguradorBuscaMagica/ConfiguradorBuscaMagica.tpl.html',
        controller: 'ConfiguradorBuscaMagicaController',
        bindings: {
            CODPARC: '=?skCodparc',
            resourceID: '=?skResourceId',
            finishHandler: '=?skFinishHandler',
            onCreated: '&skOnCreated'
        }
    })
    .controller('ConfiguradorBuscaMagicaController', ['$scope', 'ServiceProxy', 'i18n',
        function ($scope, ServiceProxy, i18n) {
            var self = this;

            init();

            self.salvarConfig = salvarConfig;
            self.close = close;

            $scope.campos = {
                DESCRICAO: "N",
                CARACTERISTICAS: "N",
                COMPLEMENTO: "N",
                REFERENCIA: "N",
                GRUPO: "N",
                LOCALIZACAO: "N",
                MARCA: "N",
                CODPROD: "N",
                REFFORN: "N"
            }

            function init(){
                carregarConfig();
            }

            function carregarConfig() {
                var body = {
                    criterio: {
                        resourceID: self.resourceID
                    }
                }

                ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigBuscaMagica", body)
                    .then(function (response) {

                    if (response != null && response.responseBody != null && response.responseBody.configuracao != null) {
                        var configuracaoElem = response.responseBody.configuracao;

                        if (configuracaoElem != null && configuracaoElem.camposBuscaMagica != null) {

                            var keys = Object.keys(configuracaoElem.camposBuscaMagica);

                            for (var i = 0; i < keys.length; i++) {
                                var key = keys[i];

                                var objOp = configuracaoElem.camposBuscaMagica[key];

                                var PESQUISAR = objOp.PESQUISAR;

                                if (objOp.PESQUISAR == null) {
                                    if (objOp[key] != null) {
                                        PESQUISAR = objOp[key];
                                    }
                                }
                                $scope.campos[key] = PESQUISAR;
                            }
                        }
                    }
                });

            }


            function salvarConfig() {
                var xml = "<configuracao><camposBuscaMagica>";

                var keys = Object.keys($scope.campos);

                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    xml += "<" + key + " PESQUISAR=\"" + $scope.campos[key] + "\" />"
                }

                xml += "</camposBuscaMagica></configuracao>";

                var body = { configuracao: { $: xml, resourceID: self.resourceID } };


                ServiceProxy.callService(
                    "mgecom@FichaParceiroSP.salvarConfigBuscaMagica", body).then(function (response) {

                });
            }

            function close() {
                salvarConfig();
                if (self.finishHandler != null) {
                    self.finishHandler();
                }
            }
    }]);

angular
    .module('snk.commons')
    .component('skConfiguradorColunas', {
        templateUrl: 'commons/fichaparceiro/ConfiguradorColunas/ConfiguradorColunas.tpl.html',
        controller: 'ConfiguradorColunasController',
        controllerAs: 'ctrl',
        bindings: {
            onCreated: '&skOnCreated',
            indicador: '=?skIndicador',
            consultaSQL :  '=?skConsultaSql',
            changeHandler: '&skChangeHandler',
        }
    })
    .controller('ConfiguradorColunasController', ['$scope', 'ServiceProxy', 'i18n', 'ObjectUtils', 'MessageUtils', 'ArrayUtils', 'StringUtils',
        function ($scope, ServiceProxy, i18n, ObjectUtils, MessageUtils, ArrayUtils, StringUtils) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);

            self.onDatasetCreated = onDatasetCreated;
            self.carregarColunas = carregarColunas;
            self.refreshHandlerColunas = refreshHandlerColunas;
            self.moverParaCima = moverParaCima;
            self.moverParaBaixo = moverParaBaixo;
            self.buildLabelTipo = buildLabelTipo;
            self.resolverColunas = resolverColunas;
            self.saveHandler = saveHandler;
            self.removerColuna = removerColuna;

            var _colunasPlanilhaDataProvider = [];

            self.dpTipoApresentacao = [
                { value: i18n('Comercial.FichaParceiro.itemTexto'), data: "T" },
                { value: i18n('Comercial.FichaParceiro.itemInteiro'), data: "I" },
                { value: i18n('Comercial.FichaParceiro.itemDecimal'), data: "DE" },
                { value: i18n('Comercial.FichaParceiro.itemMoeda'), data: "M" },
                { value: i18n('Comercial.FichaParceiro.itemData'), data: "DT" },
            ];

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({ component: self });
                }
            }

            function onDatasetCreated(dataset) {
                self.dsColunasPlanilha = dataset;
                self.dsColunasPlanilha.setConditionalAutoSave(false);

                let obs = new IDataSetObserver();
                obs.insertionModeActivated = function () {
                    if(StringUtils.isEmpty(self.dsColunasPlanilha.getFieldValue("INDICE"))){
                        self.dsColunasPlanilha.setFieldValue("INDICE", self.dsColunasPlanilha.getRecords().length +1, true);
                    }
                };

                self.dsColunasPlanilha.addObserver(obs);
                self.dsColunasPlanilha.initAndRefresh();
            }

            function refreshHandlerColunas(request){
                if(angular.isDefined(self.indicador?.colunas)){
                    if(angular.isArray(self.indicador?.colunas) || angular.isArray(self.indicador?.colunas?.coluna) ){
                        var colunasIndicador = angular.isArray(self.indicador?.colunas) ? self.indicador?.colunas : self.indicador?.colunas?.coluna;
                        _colunasPlanilhaDataProvider=[];
                        colunasIndicador.forEach(element => {
                            _colunasPlanilhaDataProvider.push(element.coluna);
                        });
                        ArrayUtils.sortByStringProperty(_colunasPlanilhaDataProvider, 'INDICE.$');
                    }else{
                        //cenario onde coluna foi salva no flex
                        if(angular.isArray(self.indicador?.colunas?.coluna)){
                            _colunasPlanilhaDataProvider=[];
                                self.indicador?.colunas?.coluna.forEach(element => {
                                    _colunasPlanilhaDataProvider.push(element);
                                });
                        }else{
                            _colunasPlanilhaDataProvider=[self.indicador?.colunas.coluna];
                        }                        
                    }
                }              
                return _colunasPlanilhaDataProvider;
            }

            function carregarColunas(){
                var colunas = undefined;

                if(angular.isDefined(self.indicador?.colunas)){
                    if (ArrayUtils.isNotEmpty(self.indicador.colunas)) {
                        colunas = self.indicador.colunas[0].coluna;
                    } else {
                        colunas = self.indicador.colunas.coluna;
                    }
                }

                populateConfigColunas(colunas);
            }

            function populateConfigColunas(colunas){
                self.modoInsercao = false;

                _colunasPlanilhaDataProvider = ArrayUtils.toArray(colunas);

                if(ArrayUtils.isNotEmpty(_colunasPlanilhaDataProvider)){
                    populateFormulario(_colunasPlanilhaDataProvider[0]);
                    if (angular.isDefined(self.indicador?.colunas) && self.indicador?.colunas.length > 1) {
                        self.indicador.colunas.forEach(function(item){
                            if (_colunasPlanilhaDataProvider[0].INDICE.$ != item.coluna.INDICE.$) {
                                _colunasPlanilhaDataProvider.push({INDICE: {$: item.coluna.INDICE.$}, DESCRICAO: {$: item.coluna.DESCRICAO.$}, TIPO: {$: item.coluna.TIPO.$}});
                            }
                        });
                        ArrayUtils.sortByStringProperty(_colunasPlanilhaDataProvider, 'INDICE.$');
                    }
                }else{
                    populateFormulario(undefined);
                }

                if(angular.isDefined(self.dsColunasPlanilha)){
                    self.dsColunasPlanilha.refresh();
                }
            }

            function populateFormulario(coluna){
                self.statusSalvar = false;
                self.itemEmCache = coluna;

                if(coluna){
                    self.btnRemoveEnabled = true;
                    self.textIndice = coluna.INDICE.$;
                    self.textDescricao = coluna.DESCRICAO.$;
                    self.comboTipoApresentacao = coluna.TIPO.$;
                }else{
                    self.btnRemoveEnabled = false;
                    self.textIndice = undefined;
                    self.textDescricao = undefined;
                    self.comboTipoApresentacao = self.dpTipoApresentacao[0];
                }
            }

            function moverParaCima() {
                if (self.dsColunasPlanilha.getCurrentIndex()  > 0 && self.dsColunasPlanilha.getCurrentIndex()   < _colunasPlanilhaDataProvider.length) {
                    mover(-1);
                }
            }

            function moverParaBaixo() {
                if (self.dsColunasPlanilha.getCurrentIndex() > -1 && self.dsColunasPlanilha.getCurrentIndex() < (_colunasPlanilhaDataProvider.length - 1)) {
                    mover(1);
                }
            }

            function mover(soma) {
                var index = self.dsColunasPlanilha.getCurrentIndex();
                var proximo = index + soma;
                var atual = index;

                var item_proximo = _colunasPlanilhaDataProvider[proximo];
                var item_atual = _colunasPlanilhaDataProvider[atual];

                _colunasPlanilhaDataProvider[atual] = item_proximo;
                _colunasPlanilhaDataProvider[proximo] = item_atual;
                index += soma;

                self.dsColunasPlanilha.refresh().then(function() {
                    self.dsColunasPlanilha.gotoRow(index);
                });
            }

            function buildLabelTipo(column, value, record) {
                var labelTipo = self.dpTipoApresentacao.find(function(ele) { return ele.data == value });

                if (labelTipo) {
                    return labelTipo.value;
                }

                return i18n('Comercial.FichaParceiro.itemTipoDesconhecido');

            }


            function resolverColunas() {
                if (angular.isUndefined(self.indicador) || angular.isUndefined(self.consultaSQL)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageSelecioneIndicadorTipo'));
                    return;
                }

                var params = { consulta: { $: self.consultaSQL } }

                ServiceProxy.callService("mgecom@FichaParceiroSP.resolverConsulta", params)
                    .then(function (response) {
                        var colunasResponse = response.responseBody.colunas.coluna;

                        if(angular.isDefined(colunasResponse)){
                            _colunasPlanilhaDataProvider = colunasResponse;
                            self.dsColunasPlanilha.refresh();
                        }

                        populateConfigColunas(colunasResponse);

                        let arrayColunas = [];

                        let colunas =angular.isArray(colunasResponse)?colunasResponse:[colunasResponse];

                        colunas.forEach(function(coluna2){
                            var objColuna = {coluna : coluna2}
                            arrayColunas.push(objColuna);
                        });

                        if(angular.isDefined(self.changeHandler)){
                            self.changeHandler({colunas : arrayColunas});
                        }
                });
            }

            function saveHandler(request){
               salvarColuna();
            }

            function salvarColuna(pegarDadosDoForm = true){
                if(StringUtils.isEmpty(self.dsColunasPlanilha.getFieldValue("INDICE"))){
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial.FichaParceiro.headerIndice')]));
                    return;
                }

                if(StringUtils.isEmpty(self.dsColunasPlanilha.getFieldValue("DESCRICAO"))){
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial.FichaParceiro.headerDescricao')]));
                    return;
                }

                var dpColunas = self.dsColunasPlanilha.getRecordsAsObjects();
                var arrayColunas = [];

                if(pegarDadosDoForm){
                    var item = {
                        coluna : {}
                    };

                    ObjectUtils.setProperty(item.coluna, 'INDICE', {$ : self.dsColunasPlanilha.getFieldValue("INDICE")});
                    ObjectUtils.setProperty(item.coluna, 'DESCRICAO',  {$ : self.dsColunasPlanilha.getFieldValue("DESCRICAO")});
                    ObjectUtils.setProperty(item.coluna, 'TIPO',  {$ : self.dsColunasPlanilha.getFieldValue("TIPO")});

                    dpColunas = self.dsColunasPlanilha.getRecordsAsObjects();
                    ArrayUtils.sortByStringProperty(dpColunas, 'INDICE');

                    if(self.dsColunasPlanilha.isInsertionMode()){
                        dpColunas.forEach(function(coluna1){
                            if(item.coluna.INDICE.toString() == coluna1.INDICE.toString()){
                                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.messageIndiceColunaExiste', [item.INDICE]));
                                return;
                            }
                        });

                        arrayColunas.push(item);
                    }
                }

                dpColunas.forEach(function(coluna2){
                    var itemColuna = {
                        coluna : {}
                    };
                    ObjectUtils.setProperty(itemColuna.coluna, 'INDICE', {$ : coluna2.INDICE});
                    ObjectUtils.setProperty(itemColuna.coluna, 'DESCRICAO',  {$ : coluna2.DESCRICAO});
                    ObjectUtils.setProperty(itemColuna.coluna, 'TIPO',  {$ : coluna2.TIPO});

                    var objColuna = {coluna : itemColuna.coluna}
                    arrayColunas.push(objColuna);
                });

                self.indicador.colunas=arrayColunas;

                if(angular.isDefined(self.changeHandler)){
                    self.changeHandler({colunas : arrayColunas});
                }

                self.dsColunasPlanilha.save();
            }

            function removerColuna(request){
                MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messageConfirmaRemoverColuna'))
                    .then(function () {

                        var item = self.dsColunasPlanilha.getCurrentIndex() + 1;

                        var dpColunas = self.dsColunasPlanilha.getRecordsAsObjects();
                        ArrayUtils.sortByStringProperty(dpColunas, 'INDICE');
                        
                        self.dsColunasPlanilha.refresh();

                        let arrayColunas = [];

                        _colunasPlanilhaDataProvider = [];

                        dpColunas.forEach(function(coluna2){
                            if(item != coluna2.INDICE){
                                var itemColuna = {
                                    coluna : {}
                                };
                                ObjectUtils.setProperty(itemColuna.coluna, 'INDICE', {$ : coluna2.INDICE});
                                ObjectUtils.setProperty(itemColuna.coluna, 'DESCRICAO',  {$ : coluna2.DESCRICAO});
                                ObjectUtils.setProperty(itemColuna.coluna, 'TIPO',  {$ : coluna2.TIPO});
            
                                var objColuna = {coluna : itemColuna.coluna}
                                arrayColunas.push(objColuna);
                                _colunasPlanilhaDataProvider.push({INDICE: {$: coluna2.INDICE}, DESCRICAO: {$: coluna2.DESCRICAO}, TIPO: {$: coluna2.TIPO}});

                            }
                        });

                        if(angular.isDefined(self.changeHandler)){
                            self.changeHandler({colunas : arrayColunas});
                        }
                    });
                }
            }
            ]);

angular
.module('snk.commons')
.component('skConfiguradorConsultaDeProdutos', { 
    templateUrl: 'commons/fichaparceiro/ConfiguradorConsultaProdutos/ConfiguradorConsultaProdutos.tpl.html',
    controller: 'ConfiguradorConsultaProdutosFichaController',
    controllerAs : 'ctrl',
    bindings: {
        indentificador: '=?skIdentificador',
        mostrarIndicadoresSistema: '=?skMostrarIndicadoresSistema',
        resourceID: '=?skResourceId',
        onFinalize: '=?skFinalize',
    }
})
.controller('ConfiguradorConsultaProdutosFichaController', ['$scope', 'ServiceProxy', 'i18n', 'MessageUtils', 'SkPesquisaService', 'SanPopup', 'StringUtils', 'ObjectUtils', 'ArrayUtils', 'AngularUtil',
    function ($scope, ServiceProxy, i18n, MessageUtils, SkPesquisaService, SanPopup, StringUtils, ObjectUtils, ArrayUtils, AngularUtil) {
        var self = this;

        self.init = init;
        self.onDatasetCabecalhoCreated = onDatasetCabecalhoCreated;        
        self.removerLocalEstoque = removerLocalEstoque;
        self.removerEmpresaEstoque = removerEmpresaEstoque;
        self.salvarConfig = salvarConfig;
        self.finalizarConfiguracao = finalizarConfiguracao;
        self.confirmarRestauracao = confirmarRestauracao;
        self.validarFiltro = validarFiltro;
        self.abrirFacilitadorConsulta = abrirFacilitadorConsulta;
        self.empSelecionadaRemove = empSelecionadaRemove;
        self.localSelecionadoRemove = localSelecionadoRemove;
        self.addLocalEstoque = addLocalEstoque;
        self.addEmpresaEstoque = addEmpresaEstoque;

        self.labelEmpresa = i18n('Comercial.FichaParceiro.labelEmpresa');
        self.labelLocal = i18n('Comercial.FichaParceiro.labelLocal');

        $scope.transientFilter = undefined;
        self.entitySearch = "";

        self.listLocais = [];
        self.listEmpresas = [];
        self.gruposTops = [];
        
        init();

        function init() {
            setTimeout(()=> {
               carregarConfig(false);
            }, 200);
        }

        function onDatasetCabecalhoCreated(dataset) {
            self.dsCabecalho = dataset;
            self.dsCabecalho.init();
        }
              
        function carregarConfig(restaurar) {
            if(self.resourceID){
                if (angular.isUndefined(restaurar)) {
                    restaurar = false;
                }
    
                var params = {
                    criterio: {
                        resourceID: self.resourceID,
                        restaurarConfig: restaurar
                    }
                }
    
                ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigConsultaProdutos", params)
                    .then(function (response) {
                        var configuracao = response.responseBody.configuracao;
                        var dpGruposTops = response.responseBody.gruposTops.grupoTop;

                        limparConfig();
    
                        if (angular.isDefined(configuracao)) {
                            self.checkNotas = configuracao.notas.$;
                            self.checkPedidos = configuracao.pedidos.$;
                            self.checkDevolucoes = configuracao.devolucoes.$;
    
                            if(angular.isDefined(configuracao.considerar.ultimosMeses)){
                                if(configuracao.considerar.ultimosMeses.$ == "S"){
                                    self.grupoQtdMedia = "2";					
                                }else{
                                    self.grupoQtdMedia = "1";
                                }
                            }
    
                            self.ultimasNegs = angular.isDefined(configuracao.considerar.ultimasNegs) ? configuracao.considerar.ultimasNegs.$ : "N";
                            self.ultimosMeses = angular.isDefined(configuracao.considerar.ultimosMeses) ? configuracao.considerar.ultimosMeses.$ : "N";
                            
                            if(angular.isDefined(configuracao.gruposTops)){
                                var gruposTopsSelecionados = configuracao.gruposTops.grupoTop;
                                if(angular.isDefined(gruposTopsSelecionados)){
                                    gruposTopsSelecionados.forEach(function (grupoTopSelecionado) {
                                        dpGruposTops.forEach(function (grupoTop) {
                                            if(angular.isUndefined(grupoTop.$) && angular.isUndefined(grupoTopSelecionado.$)){
                                                ObjectUtils.setProperty(grupoTop, 'selecionado', "S");
                                            }
                                            if(angular.isDefined(grupoTop.$) && angular.isDefined(grupoTopSelecionado.$)){
                                                if(grupoTopSelecionado.$ == grupoTop.$){
                                                    ObjectUtils.setProperty(grupoTop, 'selecionado', "S");
                                                }
                                            }
                                        });
                                    });
                                }
                            }
    
                            if(configuracao.hasOwnProperty("estoque")){
                                var estoque = configuracao.estoque;
                                self.checkSubReserv = StringUtils.toBoolean(estoque.subtrairReservas);
                                if(angular.isDefined(estoque.locais)){
                                    self.listLocais = ArrayUtils.toArray(estoque.locais.local);
                                }
                                
                                if(angular.isDefined(estoque.empresas)){
                                    self.listEmpresas = ArrayUtils.toArray(estoque.empresas.empresa);
                                }
                                
                                if(StringUtils.isNotEmpty(estoque.filtro.$)){
                                    self.textAreaFiltro = estoque.filtro.$.toString().replace(/\${nl}/g, "\n");
                                }else{ 
                                    self.textAreaFiltro = "";
                                }
                            }else{
                                self.checkSubReserv = false;
                                self.listLocais = [];
                                self.listEmpresas = undefined;
                                self.textAreaFiltro = "";
                            }
    
                            self.listGruposTops = dpGruposTops;
                        }
                    }
                );
            }
        }

        function limparConfig(){
            self.checkNotas = false;
            self.checkPedidos = false;
            self.checkDevolucoes = false;
            self.ultimasNegs = 1;
            self.ultimosMeses = 1;				
        }

        function salvarConfig() {
            var xmlConfiguracao = getXMLConfig();
            var params = { configuracao: { resourceID: self.resourceID, $: xmlConfiguracao } };

            ServiceProxy.callService("mgecom@FichaParceiroSP.salvarConfigConsultaProdutos", params).then(function (response) {
                    finalizarConfiguracao(true);
                });
        }

        function getXMLConfig() {
            var configuracaoXML = StringUtils.newBuffer();
            configuracaoXML.append('<configuracao>');

            configuracaoXML.append(AngularUtil.jsonToXml({$ : self.checkNotas}, "notas"));
            configuracaoXML.append(AngularUtil.jsonToXml({$ : self.checkPedidos}, "pedidos"));
            configuracaoXML.append(AngularUtil.jsonToXml({$ : self.checkDevolucoes}, "devolucoes"));

            var considerarXML = "<considerar ultimosMeses=\"" + (self.grupoQtdMedia == "2" ? "S" : "N") + "\" > " +
                "<ultimasNegs>" + self.ultimasNegs + "</ultimasNegs>" +
                "<ultimosMeses>" + self.ultimosMeses + "</ultimosMeses>" + "</considerar>";

            configuracaoXML.append(considerarXML);

            var filtroTextArea = StringUtils.isNotEmpty(self.textAreaFiltro) ? self.textAreaFiltro.replace(/\n|\r/g, "${nl}") : "";
            var estoqueXML = "<estoque subtrairReservas=\"" + self.checkSubReserv + "\"> " +
                "<filtro><![CDATA[" + filtroTextArea + "]]></filtro>";
            
            configuracaoXML.append(estoqueXML);

            var locaisXML = StringUtils.newBuffer();
            locaisXML.append('<locais>');

            self.listLocais.forEach(function (local) {
                var objLocal = {};

                Object.keys(local).forEach(function (key) {
                    if (StringUtils.isNotEmpty(local[key])) {
                        ObjectUtils.setProperty(objLocal, key, local[key]);
                    }
                });
                var localXML = AngularUtil.jsonToXml(objLocal, "local");
                locaisXML.append(localXML);
            });

            locaisXML.append('</locais>');
            configuracaoXML.append(locaisXML.toString());

            var empresasXML = StringUtils.newBuffer();
            empresasXML.append('<empresas>');

            self.listEmpresas.forEach(function (empresa) {
                var objEmpresa = {};

                Object.keys(empresa).forEach(function (key) {
                    if (StringUtils.isNotEmpty(empresa[key])) {
                        ObjectUtils.setProperty(objEmpresa, key, empresa[key] );
                    }
                });

                var empresaXML = AngularUtil.jsonToXml(objEmpresa, "empresa");
                empresasXML.append(empresaXML);
            });

            empresasXML.append('</empresas>');
            configuracaoXML.append(empresasXML.toString());

            configuracaoXML.append(" </estoque>");

            var gruposTopsXML = StringUtils.newBuffer();
            gruposTopsXML.append('<gruposTops>');

            self.listGruposTops.forEach(function (top) {
                if(top.selecionado == 'S'){
                    var groupTopXML = AngularUtil.jsonToXml({$ : top.$}, "grupoTop");
                    gruposTopsXML.append(groupTopXML);
                }
            });

            gruposTopsXML.append('</gruposTops>');
            configuracaoXML.append(gruposTopsXML.toString());

            configuracaoXML.append("</configuracao>");
            return configuracaoXML.toString();
        }

        function addEmpresaEstoque() {
            let options = { loadOnCreate: true, showInactives: true };
            SkPesquisaService.openPesquisaPopUp("Empresa", self.entitySearch, options).then(function (result) {
                self.listEmpresas.push({ CODEMP: {$ :result.data.CODEMP}, DESCRICAO: {$:result.data.NOMEFANTASIA} });
            });
        }

        function addLocalEstoque() {
            let options = { loadOnCreate: true, showInactives: true };
            SkPesquisaService.openPesquisaPopUp("LocalFinanceiro", self.entitySearch, options).then(function (result) {
                self.listLocais.push({ CODLOCAL: {$: result.data.CODLOCAL}, DESCRICAO: {$: result.data.DESCRLOCAL}, DESCRLOCAL: {$:result.data.DESCRLOCAL }});
            });
        }

        function abrirFacilitadorConsulta() {
             SanPopup.open({
                title: i18n('Comercial.FichaParceiro.labelPopupFiltraEstoque'),
                templateUrl: 'commons/fichaparceiro/PopupFiltraEstoque/PopupFiltraEstoque.tpl.html',
                controller: 'PopupFiltraEstoqueController',
                controllerAs: '$ctrl',
                size: 'lg',
                okBtnLabel: i18n('Comercial.FichaParceiro.labelConfirmar'),
                showBtnNo: false,
                noBtnLabel: i18n('Geral.buttonFechar'),
                windowClass: 'sk-popup-exemple',
                resolve: {
                    resourceID: function () { return resourceID },
                    Trfilter: function () { return $scope.transientFilter }
                }
            }).result.then(function (result) {
                if (angular.isDefined(result.filter.filterModel)) {
                    self.textAreaFiltro = result.filter.filterModel.expression.$;
                }

                if (angular.isDefined(result.filter)) {
                    $scope.transientFilter = result.filter;
                }
            });
        }

        function validarFiltro() {
            if (StringUtils.isNotEmpty(self.textAreaFiltro)) {
                var params = { consulta: { expressao: { $: self.textAreaFiltro }}};

                ServiceProxy.callService("mgecom@FichaParceiroSP.resolverConsultaEstoque", params)
                .then(function (result) {
                    MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Comercial.FichaParceiro.messageConsultaValidada'));
                });
            }
        }

        function confirmarRestauracao() {
            MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messagePerderConfigAoRestaurar'))
                .then(function () {
                    carregarConfig(true);
                    finalizarConfiguracao();
                });
        }

        function empSelecionadaRemove(empresa, index){
            _indexEmpresaRemove = index;
        }

        function localSelecionadoRemove(local, index){
            _indexLocalRemove = index;
        }

        function removerLocalEstoque(item, index) {
            MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messageRemoverLocalFiltro'))
                .then(function (result) {
                    self.listLocais.splice(_indexLocalRemove, 1);
                });
        }

        function removerEmpresaEstoque(item, index) {
            MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messageRemoverEmpresaFiltro'))
                .then(function (result) {
                    self.listEmpresas.splice(_indexEmpresaRemove, 1);
                });
        }

        function finalizarConfiguracao(save) {
            if (self.onFinalize != null && self.onFinalize != undefined) {
                self.onFinalize(save);
            }
        }
    }
]);

angular
    .module('snk.commons')
    .component('skConfiguradorDadosParceiro', {
        templateUrl: 'commons/fichaparceiro/ConfiguradorDadosParceiro/ConfiguradorDadosParceiro.tpl.html',
        controller: 'ConfiguradorDadosParceiroController',
        controllerAs: "ctrl",
        bindings: {
            onCreated: '&skOnCreated',
            resourceID: '=?skResourceId',
            onFinalize: '=?skFinalize',
        }
    })
    .controller('ConfiguradorDadosParceiroController', ['ServiceProxy', 'ObjectUtils', 'StringUtils', 'FichaParceiroService',
        function (ServiceProxy, ObjectUtils, StringUtils, FichaParceiroService) {
            var self = this;

            self.carregarConfig = carregarConfig;
            self.selectionListChange = selectionListChange;
            self.detalhesCampoVisible = false;
            self.mudarTamFonte = mudarTamFonte;
            self.mudarFonteFamily = mudarFonteFamily;
            self.mudarCor = mudarCor;
            self.mudarApresentacao = mudarApresentacao;
            self.salvarConfig = salvarConfig;
            self.mudarFonteSublinhado = mudarFonteSublinhado;
            self.mudarFonteNegrito = mudarFonteNegrito;
            self.mudarFonteItalico = mudarFonteItalico;

            self.dpFontes = [
                { data: "Arial", label: "Arial", value: "Arial" },
                { data: "Courier New", label: "Courier New", value: "Courier New" },
                { data: "Times New Roman", label: "Times New Roman", value: "Times New Roman" },
                { data: "Verdana", label: "Verdana", value: "Verdana" }
            ];

            self.colorFonte = DEFAULT_COLOR;

            var _campoSelecionado = {};

            const DEFAULT_COLOR = "#000000";

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({component: self});
                }
            }

            function carregarConfig(restaurarConfig) {
                if (angular.isUndefined(restaurarConfig)) {
                    restaurarConfig = false;
                }

                var params = { criterio: { restaurarConfig: restaurarConfig, resourceID: self.resourceID } }

                ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigDadosParceiro", params)
                    .then(function (response) {
                    if (angular.isDefined(response.responseBody.camposParceiro.campo)) {
                        self.srcData = response.responseBody.camposParceiro.campo;
                        if (angular.isDefined(response.responseBody.configuracao.camposVisiveis )) {
                            self.destData = response.responseBody.configuracao.camposVisiveis.campo;
                        }
                    }
                });

                self.detalhesCampoVisible = false;
            }

            function selectionListChange(selection, list){
                if(list == "destList"){
                    _campoSelecionado = selection[0];
					
					var fontSize = ObjectUtils.getProperty(_campoSelecionado, 'FONTSIZE');
					var fontFamily = ObjectUtils.getProperty(_campoSelecionado, 'FONTFAMILY');
					
					if(fontSize == 0){
						fontSize = 10;
					}
					
					self.tamFonte = fontSize;

                    var cor = ObjectUtils.getProperty(_campoSelecionado, 'COR');
                    var corSelecionada = StringUtils.isNotEmpty(cor) ? cor : DEFAULT_COLOR;

					self.colorFonte = corSelecionada;

					if(angular.isDefined(fontFamily)){
						self.comboFontes = fontFamily;
					}else{
						self.comboFontes = "Arial";
					}

                    self.checkMostrarValor = ObjectUtils.getProperty(_campoSelecionado, 'SOMENTEVALOR') == "true";
                    
                    self.btnNegritoSelected = ObjectUtils.getProperty(_campoSelecionado, 'FONTWEIGHT') == "bold";
                    self.btnItalicoSelected = ObjectUtils.getProperty(_campoSelecionado, 'FONTSTYLE') == "italic";
                    self.btnSublinhadoSelected = ObjectUtils.getProperty(_campoSelecionado, 'TEXTDECORATION') == "underline";

                    self.textDemo = _campoSelecionado.DESCRICAO;
                    self.textDemoStyle = buildTextDemo(_campoSelecionado);

                    self.detalhesCampoVisible = true;
                }
            }

            function buildTextDemo(item) {
                return FichaParceiroService.buildObjectToStyle(item);
            }

            function mudarTamFonte(){
				if(_campoSelecionado){
                    ObjectUtils.setProperty(_campoSelecionado, 'FONTSIZE', self.tamFonte);
                    self.textDemoStyle = buildTextDemo(_campoSelecionado);
				}
			}

            function mudarFonteFamily(){
				if(_campoSelecionado){
                    ObjectUtils.setProperty(_campoSelecionado, 'FONTFAMILY', self.comboFontes);
					self.textDemoStyle = buildTextDemo(_campoSelecionado);
				}
			}

            function mudarCor(){
				if(_campoSelecionado){
                    ObjectUtils.setProperty(_campoSelecionado, 'COR', self.colorFonte);
					self.textDemoStyle = buildTextDemo(_campoSelecionado);
				}				
			}

           function mudarApresentacao(){
				if(_campoSelecionado){
                    ObjectUtils.setProperty(_campoSelecionado, 'SOMENTEVALOR', self.checkMostrarValor);
				}
			}
            
            function mudarFonteNegrito(){
                if(_campoSelecionado){
					if(self.btnNegritoSelected){
                        ObjectUtils.setProperty(_campoSelecionado, 'FONTWEIGHT', "normal");
						self.textDemoStyle = buildTextDemo(_campoSelecionado);
						self.btnNegritoSelected = false;
					}else{
                        ObjectUtils.setProperty(_campoSelecionado, 'FONTWEIGHT', "bold");
						self.textDemoStyle = buildTextDemo(_campoSelecionado);
						self.btnNegritoSelected = true;
					}
				}
			}

            function mudarFonteSublinhado(){
				if(_campoSelecionado){
					if(self.btnSublinhadoSelected){
                        ObjectUtils.setProperty(_campoSelecionado, 'TEXTDECORATION', undefined);
						self.textDemoStyle = buildTextDemo(_campoSelecionado);
						self.btnSublinhadoSelected = false;
					}else{
                        ObjectUtils.setProperty(_campoSelecionado, 'TEXTDECORATION', "underline");
						self.textDemoStyle = buildTextDemo(_campoSelecionado);
						self.btnSublinhadoSelected = true;
					}
				}
			}

            function mudarFonteItalico(){
                if(_campoSelecionado){
					if(self.btnItalicoSelected){
                        ObjectUtils.setProperty(_campoSelecionado, 'FONTSTYLE', "normal");
						self.textDemoStyle = buildTextDemo(_campoSelecionado);
						self.btnItalicoSelected = false;
					}else{
                        ObjectUtils.setProperty(_campoSelecionado, 'FONTSTYLE', "italic");
						self.textDemoStyle = buildTextDemo(_campoSelecionado);
						self.btnItalicoSelected = true;
					}
				}
			}

            function finalizarConfiguracao() {
                if(self.onFinalize){
                    self.onFinalize();
                }
            }

            function salvarConfig() {
                var body = { configuracao: { resourceID: self.resourceID, $: getXML() } }

                ServiceProxy.callService(
                    "mgecom@FichaParceiroSP.salvarConfigDadosParceiro", body).then(function (response) {
                    finalizarConfiguracao();
                });
            }

            function getXML() {
                var xml = "<configuracao><camposVisiveis>";

                if (angular.isDefined(self.destData)) {
                    for (var i = 0; i < self.destData.length; i++) {

                        var item = JSON.parse(JSON.stringify(self.destData[i]));
                        delete item.$$hashKey;

                        xml += "<campo " + FichaParceiroService.getPropsXMLFromObj(item, true) + "/> ";

                    }
                }

                xml += "</camposVisiveis></configuracao>";

                return xml;
            }
        }
    ]);
angular
    .module('snk.commons')
    .component('skConfiguradorIndicadores', {
        templateUrl: 'commons/fichaparceiro/ConfiguradorIndicadores/ConfiguradorIndicadores.tpl.html',
        controller: 'ConfiguradorIndicadoresController',
        controllerAs: 'ctrl',
        bindings: {
            identificador: '=?skIdentificadorPainel',
            tituloPainel: '=?skTituloPainel',
            mostrarIndicadoresSistema: '=?skMostrarIndicadoresSistema',
            CODPARC: '=?skCodparc',
            resourceID: '=?skResourceId',
            onSave: '=?skOnSave',
            finishHandler: '&?skFinishHandler',
        }
    })
    .controller('ConfiguradorIndicadoresController', ['$scope', 'ServiceProxy', 'i18n', 'MessageUtils', 'SkApplicationInstance', 'ArrayUtils', 'ObjectUtils', 'DoubleFacePanelConstants', 'StringUtils', 'AngularUtil', 'FichaParceiroService',
            function ($scope, ServiceProxy, i18n, MessageUtils, SkApplicationInstance, ArrayUtils, ObjectUtils, DoubleFacePanelConstants, StringUtils, AngularUtil, FichaParceiroService) {
                var self = this;
``
                ObjectUtils.implements(self, IDatagridInterceptor);
                ObjectUtils.implements(self, IDataSetObserver);

                self.dpTipoApresentacao = [];
                self.dpVariaceis = [];
                self.listIndicadores = [];
                self.variavelSel = "NDA";
                self.modoInsercao = false;
                self.statusSalvar = false;
                self.fieldSetConsultaVisible=true;
                self.comboTipoApresentacaoVisible=true;

                self.salvarConfig = salvarConfig;
                self.carregarConfiguracoes = carregarConfiguracoes;
                self.mudarModoInsercao = mudarModoInsercao;
                self.validarConsulta = validarConsulta;
                self.mudarModoFormulario = mudarModoFormulario;
                self.moverParaCima = moverParaCima;
                self.moverParaBaixo = moverParaBaixo;
                self.buildLabelTipo = buildLabelTipo;
                self.onCreatedConfiguradorColunas = onCreatedConfiguradorColunas;
                self.onDatasetCreated = onDatasetCreated;
                self.refreshHandlerIndicadores = refreshHandlerIndicadores;
                self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
                self.onCreatedUltimosMeses = onCreatedUltimosMeses;
                self.onCreatedUltimasNotas = onCreatedUltimasNotas;
                self.onCreatedUltimosTitulos = onCreatedUltimosTitulos;
                self.setConfiguracaoAlteradaHandler = setConfiguracaoAlteradaHandler;
                self.refresh = refresh;
                self.changeHandlerColunas = changeHandlerColunas;
                self.removerConfig = removerConfig;
                self.addVariavel = addVariavel;
                self.confirmarRestauracao = confirmarRestauracao;
                self.finalizarConfiguracao = finalizarConfiguracao;

                var _modoInsercao;
                var _itemEmCache;
                var _dataColunas;

                self.doubleFacePainelIndex = 1;

                init();

                function init() {
                    self.dpTipoApresentacao = [
                        { value: i18n('Comercial.FichaParceiro.itemTexto'), data: "T" },
                        { value: i18n('Comercial.FichaParceiro.itemInteiro'), data: "I" },
                        { value: i18n('Comercial.FichaParceiro.itemDecimal'), data: "DE" },
                        { value: i18n('Comercial.FichaParceiro.itemMoeda'), data: "M" },
                        { value: i18n('Comercial.FichaParceiro.itemData'), data: "DT" },
                        { value: i18n('Comercial.FichaParceiro.itemPlanilha'), data: "P" }
                    ];

                    self.dpVariaveis = [
                        { value: i18n('Comercial.FichaParceiro.itemVariaveis'), data: "NDA" },
                        { value: i18n('Comercial.FichaParceiro.labelParceiro'), data: "${CODPARC}" },
                        { value: i18n('Geral', 'labelUsuario'), data: "${CODUSULOGADO}" },
                        { value: i18n('Comercial.FichaParceiro.itemDtSistema'), data :"${DTSIS}"}
                    ];

                    carregarConfiguracoes();
                }

                function onCreatedConfiguradorColunas(component){
                    self.painelColunas = component;
                    comboApresentacaoAlterado(false);
                }

                function onDatasetCreated(dataset) {
                    self.dsIndicadores = dataset;
                    self.dsIndicadores.setConditionalAutoSave(false);

                    let dsObserver = new IDataSetObserver();

                    dsObserver.insertionModeActivated = function (){
                        self.btnRemoveEnabled = false;
                    }

                    dsObserver.dataModified = function(modifiedFieldId) {
                        if (modifiedFieldId == "TIPO") {
                            comboApresentacaoAlterado();
                        }else if ("EXIBIR-DESCRICAO-CONSULTA".indexOf(modifiedFieldId) > -1) {
                            campoAlterado();
                        }
                    };

                    dsObserver.currentLineChanged = function (line) {
                        if(line != -1 && self.dsIndicadores.getCurrentRowAsObject()?.TIPO == "SI") {
                            self.btnRemoveEnabled = false;
                        } else {
                            self.btnRemoveEnabled = true;
                        }
                    }

                    self.dsIndicadores.addObserver(dsObserver);
                    self.dsIndicadores.initAndRefresh();
                }

                function onCreatedUltimosMeses(component){
                    self.detalhesIndicador = component;
                }

                function onCreatedUltimasNotas(component){
                    self.detalhesIndicador = component;
                }

                function onCreatedUltimosTitulos(component){
                    self.detalhesIndicador = component;
                }

                function onDoubleFacePanelCreated(dblFacePanel){
                    self.dblFacePanel = dblFacePanel;
                }

                function refreshHandlerIndicadores(request){
                    return self.listIndicadores;
                }

                function refresh(){
                    self.dsIndicadores.refresh();
                }

                function carregarConfiguracoes(restaurarConfig = false) {
                    if (angular.isUndefined(restaurarConfig)) {
                        restaurarConfig = false;
                    }

                    var criterio = {
                        criterio: {
                            identificador: self.identificador + ":" + self.resourceID,
                            mostrarIndicadoresSistema: self.mostrarIndicadoresSistema,
                            restaurarConfig: restaurarConfig
                        }
                    }

                    ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigIndicadores", criterio)
                        .then(function (response) {
                            if(angular.isDefined(response.responseBody.configuracao)){
                                var configuracaoElem = ArrayUtils.toArray(response.responseBody.configuracao.indicador);

                                if (angular.isDefined(configuracaoElem)) {
                                    populateConfigIndicadores(configuracaoElem);

                                    self.dsIndicadores.refresh();
                                    if (configuracaoElem.length > 0) {
                                        populateFormulario(configuracaoElem[0]);
                                    } 
                                }
                            }


                            if(restaurarConfig){
                                if(angular.isFunction(self.finishHandler)) {
                                    self.finishHandler();
                                }
                            }
                        });

                    confirmarAlteracaoDados();
                }

                function populateConfigIndicadores(configuracao){
                    var index = self.dsIndicadores.getCurrentIndex();
                    self.modoInsercao = false;
                    if (configuracao == undefined) {
                        return;
                    }
                    configuracao.forEach(function (indicador, index) {
                        if (indicador["DETALHES"] && indicador["DETALHES"].CONSIDERAR?.ULTIMOSMESES?.ULTIMOSMESES != undefined) {
                            configuracao[index]["DETALHES"].CONSIDERAR["CHECKULTIMOSMESES"] = indicador["DETALHES"].CONSIDERAR.ULTIMOSMESES.ULTIMOSMESES;
                        }
                        self.listIndicadores[index] = indicador;
                    });

                    self.listIndicadores = configuracao;

                    if(ArrayUtils.isNotEmpty(self.listIndicadores)){
                        populateFormulario(self.listIndicadores[index]);
                    }
                }

                function populateFormulario(indicador){
                    self.statusSalvar = false;
                    _itemEmCache = indicador;

                    self.comboVariaveis = "NDA";

                    self.visibleConfiguradorUltimosMeses = false;
                    self.visibleConfiguradorUltimasNotas = false;
                    self.visibleConfiguradorUltimosTitulos = false;
                    self.visibleConfiguradorPontualidade = false;
                    self.visibleConfiguradorAtraso = false;

                    if(!ObjectUtils.isEmpty(indicador)){
                        self.modoInsercao = false;

                        var indicadorSistema = ObjectUtils.getProperty(indicador, 'TIPO.$') == "SI";

                        if(indicadorSistema) {
                            self.painelColunasEnabled = false;

                            if (ObjectUtils.getProperty(indicador, 'POSSUICONFIGDETALHADA.$') == 'S') {
                                habilitarDetalhesIndicador(true);

                                if (ObjectUtils.getProperty(indicador, 'IDENTIFICADOR.$') == "Identificador_PercentualRenegociacoes") {
                                    self.visibleConfiguradorUltimosMeses = true;
                                    self.dataUltimosMeses = indicador.DETALHES;
                                } else if (ObjectUtils.getProperty(indicador, 'IDENTIFICADOR.$') == "Identificador_TipoNegociacaoMaisUsada"){
                                    self.visibleConfiguradorUltimasNotas = true;
                                    self.dataUltimaNotas = indicador.DETALHES;
                                }else if (ObjectUtils.getProperty(indicador, 'IDENTIFICADOR.$') == "Identificador_PercentualPontualidade"){
                                    self.visibleConfiguradorPontualidade = true;
                                    self.dataPontualidade = indicador.DETALHES;
                                }else if (ObjectUtils.getProperty(indicador, 'IDENTIFICADOR.$') == "Identificador_AtrasoMedio"){
                                    self.visibleConfiguradorAtraso = true;
                                    self.dataAtraso = indicador.DETALHES;
                                } else if (ObjectUtils.getProperty(indicador, 'IDENTIFICADOR.$') == "Identificador_TipoTituloMaisUsado"){
                                    self.visibleConfiguradorUltimosTitulos = true;
                                    self.dataUltimosTitulos = indicador.DETALHES;
                                }
                            }else{
                                habilitarDetalhesIndicador(false);
                            }
                        }else{
                            habilitarDetalhesIndicador(false);
                        }

                        self.textAreaConsulta = ObjectUtils.getProperty(indicador, 'CONSULTA.$');
                        self.textAreaConsultaEnabled = ! indicadorSistema;
                        self.btnAddVariavelEnabled = ! indicadorSistema;
                        self.btnValidarConsultaEnabled = ! indicadorSistema;
                        self.btnRemoveEnabled = ! indicadorSistema;
                        self.fieldSetConsultaVisible = ! indicadorSistema;

                        mudarVisualizacaoTipoApresentacao(indicadorSistema);
                    }else {
                        self.btnRemoveEnabled = false;
                        self.textAreaConsulta = "";
                        self.textAreaConsultaEnabled = true;
                        self.btnAddVariavelEnabled = true;
                        self.btnValidarConsultaEnabled = true;
                        self.fieldSetConsultaVisible = true;

                        self.comboVariaveis = "T";
                        self.checkExibir = "S";

                        mudarVisualizacaoTipoApresentacao(false);
                        habilitarDetalhesIndicador(false);
                    }

                    comboApresentacaoAlterado(false);
                }

                function moverParaCima() {
                    if (self.dsIndicadores.getCurrentIndex()  > 0 && self.dsIndicadores.getCurrentIndex()  < self.listIndicadores.length) {
                        mover(-1);
                    }
                }

                function moverParaBaixo() {
                    if (self.dsIndicadores.getCurrentIndex() > -1 && self.dsIndicadores.getCurrentIndex() < (self.listIndicadores.length - 1)) {
                        mover(1);
                    }
                }

                function mover(soma) {
                    var index = self.dsIndicadores.getCurrentIndex();
                    var proximo = self.dsIndicadores.getCurrentIndex() + soma;
                    var atual = self.dsIndicadores.getCurrentIndex();

                    var item_proximo = self.listIndicadores[proximo];
                    var item_atual = self.listIndicadores[atual];

                    self.listIndicadores[atual] = item_proximo;
                    self.listIndicadores[proximo] = item_atual;

                    index += soma;

                    self.dsIndicadores.refresh().then(function() {
                        self.dsIndicadores.gotoRow(index);
                    });
                }

                function mudarModoFormulario() {
                    self.tabNavigatorIndex = 0;
                    linhaSelecionada()
                }

                function linhaSelecionada(){
                    var index = angular.isDefined(self.dsIndicadores) &&  self.dsIndicadores.getCurrentIndex() >= 0 ? self.dsIndicadores.getCurrentIndex() : 0;
                    var currentObject = angular.isDefined(self.listIndicadores) ? self.listIndicadores[index] : undefined;

                    if(angular.isDefined(currentObject)){
                        populateFormulario(formatObject(self.listIndicadores[index]));
                    }

                    confirmarAlteracaoDados();
                }

                function buildLabelTipo(column, value, record) {
                    var tipo = value;

                    if (self.mostrarIndicadoresSistema) {
                        if (tipo == "SI") {
                            return i18n('Comercial.FichaParceiro.itemSistema');
                        } else {
                            return i18n('Comercial.FichaParceiro.itemPersonalizado');
                        }
                    }

                    var labelTipo = self.dpTipoApresentacao.find(function(ele) { return ele.data == tipo });

                    if (labelTipo) {
                        return labelTipo.value;
                    }

                    return i18n('Comercial.FichaParceiro.itemTipoDesconhecido');

                }

                function comboApresentacaoAlterado(alteradoPeloUsuario = true){
                    let item = self.dsIndicadores.getFieldValueAsString("TIPO");

                    if(angular.isDefined(item) && item == "P"){
                        let index = angular.isDefined(self.dsIndicadores) ? self.dsIndicadores.getCurrentIndex() : 0;

                        self.painelColunasEnabled = true;
                        self.dpIndicador = self.listIndicadores[index];
                        self.consultaSQL = self.textAreaConsulta;

                        if(angular.isDefined(self.painelColunas)){
                            self.painelColunas.carregarColunas();
                        }
                    }else{
                        self.painelColunasEnabled = false;
                        self.dpIndicador = undefined;
                        self.consultaSQL = undefined;
                    }

                    if(alteradoPeloUsuario && self.dblFacePanel.getSelectedIndex() == DoubleFacePanelConstants.FORM_FACE){
                        campoAlterado();
                    }
                }

                function habilitarDetalhesIndicador(habilitar){
                    self.detalhesIndicadorEnabled = habilitar;
                }

                function mudarVisualizacaoTipoApresentacao(indicadorSistema){
                    self.comboTipoApresentacaoVisible = ! indicadorSistema;
                    self.textTipoApresentacaoVisible = indicadorSistema;
                }

                function mudarModoInsercao() {
                    self.dblFacePanel.setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
                    populateFormulario();

                    self.dsIndicadores.goToInsertionMode().then(function () {
                        confirmarAlteracaoDados();
                    });
                }

                function confirmarAlteracaoDados(){
                    if(self.statusSalvar){
                        MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messageSalvarIndicador'))
                            .then(function () {
                                salvarConfig();
                            }, function () {
                                self.statusSalvar = false;
                                populateFormulario(self.itemEmCache);
                            });
                    }
                }

                function validarConsulta() {
                    if (StringUtils.isNotEmpty(self.textAreaConsulta)){
                        var params = { consulta: { VALIDAR: true, $: self.textAreaConsulta } }
                        ServiceProxy.callService("mgecom@FichaParceiroSP.resolverConsulta", params)
                            .then(function (response) {
                                MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Comercial.FichaParceiro.messageConsultaValidada'));
                        });
                    }
                }

                function salvarConfig(pegarDadosDoForm = true, validarCampos = true){
                    if(validarCampos && StringUtils.isEmpty(self.dsIndicadores.getFieldValueAsString("DESCRICAO"))){
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial.FichaParceiro.labelDescricao')]));
                        return false;
                    }

                    if(validarCampos && self.textAreaConsultaEnabled && StringUtils.isEmpty(self.dsIndicadores.getFieldValueAsString("CONSULTA"))){
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial.FichaParceiro.labelConsultaSelect')]));
                        return false;
                    }

                    var indicadores = self.dsIndicadores.getRecordsAsObjects();

                    if(pegarDadosDoForm){
                        if(_itemEmCache != null){
                            item = _itemEmCache;
                        }else{
                            _modoInsercao = true;
                        }

                        if(self.dsIndicadores.isInsertionMode()){
                            var item = {};
                            ObjectUtils.setProperty(item, 'PERSONALIZADO', "S");
                            ObjectUtils.setProperty(item, 'EXIBIR', self.checkExibir || "N");
                            ObjectUtils.setProperty(item, 'DESCRICAO', self.dsIndicadores.getFieldValueAsString("DESCRICAO"));

                            if(item.TIPO != "SI"){
                                ObjectUtils.setProperty(item, 'TIPO', self.comboTipoApresentacao);
                            }

                            ObjectUtils.setProperty(item, 'CONSULTA', self.dsIndicadores.getFieldValueAsString("CONSULTA"));

                            if(self.dsIndicadores.isInsertionMode()){
                                indicadores.forEach(function(coluna1){
                                    if(item.DESCRICAO.toString() == coluna1.DESCRICAO.toString()){
                                        throw new AlertError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.messageIndiceColunaExiste', [item.DESCRICAO]));
                                    }
                                });
                            }

                            self.dsIndicadores.addRecordsAsObjects(item);
                        }
                    }
                    const oldListIndicators = self.listIndicadores;

                    indicadores = self.dsIndicadores.getRecordsAsObjects();
                    self.listIndicadores = indicadores;

                    var configuracaoXML = StringUtils.newBuffer();
                    configuracaoXML.append('<configuracao>');

                    var currentIndex = self.dsIndicadores.getCurrentIndex();

                    indicadores.forEach(function (indicador, index) {
                        var objIndicador = {};
                        var currentRow = self.dsIndicadores.getCurrentRowAsObject();

                        Object.keys(indicador).forEach(function (key) {
                            if (StringUtils.isNotEmpty(indicador[key])) {
                                ObjectUtils.setProperty(objIndicador, key, {$ : indicador[key]});
                            }
                        });

                        if (typeof indicador['CONSULTA'] === "string" && StringUtils.isNotEmpty(indicador['CONSULTA'])) {
                            ObjectUtils.setProperty(objIndicador, "CONSULTA", {$ : StringUtils.htmlScape(indicador['CONSULTA'])});
                        }

                        if(self.detalhesIndicadorEnabled){
                            if(currentRow.DESCRICAO == indicador.DESCRICAO){
                                if(angular.isDefined(self.detalhesIndicador)){
                                    var detalhes = self.detalhesIndicador.getDados();
                                    if(!ObjectUtils.isEmpty(detalhes)){
                                        ObjectUtils.setProperty(objIndicador, "DETALHES", detalhes);
                                        ObjectUtils.setProperty(self.listIndicadores[currentIndex], "DETALHES", detalhes);
                                    }
                                }
                            } else {
                                const oldElement = oldListIndicators.find(indicator => indicator.DESCRICAO.$ === indicador.DESCRICAO);
                                const detalhes = oldElement?.DETALHES;

                                if(!ObjectUtils.isEmpty(detalhes)){
                                    ObjectUtils.setProperty(objIndicador, "DETALHES", detalhes);
                                    ObjectUtils.setProperty(self.listIndicadores[index], "DETALHES", detalhes);
                                }
                            }
                        }

                        if(self.painelColunasEnabled){
                            if(currentRow.DESCRICAO == indicador.DESCRICAO && ArrayUtils.isNotEmpty(_dataColunas)){
                                ObjectUtils.setProperty(objIndicador, "colunas", _dataColunas);
                                ObjectUtils.setProperty(self.listIndicadores[currentIndex], "colunas", _dataColunas);
                                _dataColunas = undefined;
                            }
                        }

                        var indicadorXML = AngularUtil.jsonToXml(objIndicador, "indicador");
                        configuracaoXML.append(indicadorXML);
                    });

                    configuracaoXML.append('</configuracao>');

                    var configuracaoString = configuracaoXML.toString();
                    configuracaoString = configuracaoString.replaceAll("CHECKULTIMOSMESES", "ULTIMOSMESES");

                    var params = {
                        configuracao : {
                            identificador : self.identificador + ":" + self.resourceID,
                            $ : configuracaoString
                        }
                    };

                    ServiceProxy.callService("mgecom@FichaParceiroSP.salvarConfigIndicadores", params)
                        .then(function (response) {
                            if (self.listIndicadores.length > 0) {
                                var indicador = formatObject(self.listIndicadores[currentIndex]);

                                if(_modoInsercao){
                                    populateConfigIndicadores(indicador)
                                }else{
                                    populateFormulario(indicador);
                                }
                            }
                            self.statusSalvar = false;
                            carregarConfiguracoes();
                            self.finishHandler()
                        });
                }

                function formatObject(obj){
                    let retorno = {};
                    Object.keys(obj).forEach(key =>{
                        if(obj[key]?.hasOwnProperty("$")){
                            retorno[key] = obj[key];
                        }else{
                            retorno[key] = {"$": obj[key] || ""}
                        }
                    });
                    return retorno;
                }

                function setConfiguracaoAlteradaHandler(){
                    campoAlterado();
                }

                function campoAlterado(){
                    if(angular.isDefined(self.dblFacePanel)){
                        self.statusSalvar = true;
                    }
                }

                function changeHandlerColunas(colunas){
                    self.statusSalvar = true;
                    _dataColunas = colunas;
                }

                function removerConfig(){
                    MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messageRemoverIndicador'))
                        .then(function () {
                            var indicadorRemover = self.dsIndicadores.getCurrentRowAsObject();
                            var indicadores = self.dsIndicadores.getRecordsAsObjects();

                            if(!ObjectUtils.isEmpty(indicadorRemover) && indicadorRemover.TIPO != "SI"){

                                var filterData = indicadores.filter((aux) => aux.DESCRICAO != indicadorRemover.DESCRICAO);

                                if(!ObjectUtils.isEmpty(filterData)){
                                    self.dsIndicadores.removeCurrentRow(true).then(function () {
                                        salvarConfig(false);
                                    });
                                } else {
                                    self.dsIndicadores.removeCurrentRow(true).then(function (){
                                        salvarConfig(false, false);
                                    })
                                }
                            }
                        });
                }

                function addVariavel(){
                    var variavel = self.comboVariaveis;

                    if(variavel != "NDA"){
                        var consulta = self.dsIndicadores.getFieldValueAsString("CONSULTA");
                        self.textAreaConsulta = consulta.concat(variavel);
                    }
                }

                function confirmarRestauracao(){
                    MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messagePerderConfigAoRestaurar'))
                        .then(function () {
                            carregarConfiguracoes(true);
                        });
                }


                function finalizarConfiguracao(){
                    if(angular.isFunction(self.finishHandler)){
                        self.finishHandler();
                        confirmarAlteracaoDados();
                    }
                }
            }
        ]);

angular
    .module('snk.commons')
    .controller('ConfiguradorPaineisController', ['$scope', 'ServiceProxy', 'i18n', 'ObjectUtils', 'MessageUtils', 'AngularUtil', 'resourceID', '$popupInstance', 'ArrayUtils', 'StringUtils', 'FichaParceiroService', 'DoubleFacePanelConstants',
        function ($scope, ServiceProxy, i18n, ObjectUtils, MessageUtils, AngularUtil, resourceID, $popupInstance, ArrayUtils, StringUtils, FichaParceiroService, DoubleFacePanelConstants) {

            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);

            self.carregarConfig = carregarConfig;
            self.populateConfig = populateConfig;
            self.removerPainel = removerPainel;
            self.onDatagridLoaded = onDatagridLoaded;
            self.addPainel = addPainel;
            self.linhaSelecionada = linhaSelecionada;
            self.salvarPaineis = salvarPaineis;
            self.createDataSet = createDataSet;
            self.refreshHandler = refreshHandler;
            self.onCreatedFace = onCreatedFace;
            self.onChangeTipo = onChangeTipo;
            self.campoAlterado = campoAlterado;

            $scope.gridPaineis = null;
            self.dsPaineis = null;
            $scope.dblFace = null;
            $scope.modoInclusao = false;
            $scope.pesqGadgetVisible = false;
            $scope.$success = close;

            self.btnRemove = true;
            self.statusSalvar = true;

            $scope.list_selector = [
                { data: 'P', value: i18n('Comercial.FichaParceiro.itemPersonalizado') },
                { data: 'G', value: i18n('Comercial.FichaParceiro.itemCompBI') },
                { data: 'S', value: i18n('Comercial.FichaParceiro.itemSistema') },
            ];

            let _gridPaineisDataProvider;
            let _modoInclusao;
            let _configuracoesAlteradas = false;

            function onCreatedFace(doubleFacePanel) {
                self.dblFace = doubleFacePanel;
            }

            function onDatagridLoaded(id, datagrid) {
                $scope.gridPaineis = datagrid;
            }

            function createDataSet(dataset) {
                self.dsPaineis = dataset;
                self.dsPaineis.setConditionalAutoSave(false);

                self.dsPaineis.init().then(function () {
                    carregarConfig();
                });

                var observer = new IDataSetObserver();
                observer.currentLineChanged = function (line) {
                    linhaSelecionada();
                }

                observer.dataModified = function(modifiedFieldId) {
                    if (modifiedFieldId == "EXIBIR" && self.dblFace.getSelectedIndex() == DoubleFacePanelConstants.GRID_FACE) {
                        salvarPaineis();
                    }
                };
                
                self.dsPaineis.addObserver(observer);
            }

            function refreshHandler(request) {
                return _gridPaineisDataProvider;
            }

            function carregarConfig() {
                var body = { criterio: { resourceID: resourceID } };

                ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigPaineis", body).then(
                    function (response) {
                        if (angular.isDefined(response.responseBody.configuracao)) {
                            populateConfig(response.responseBody.configuracao);
                        }
                    }
                )
            }

            function populateConfig(configuracao) {
                _gridPaineisDataProvider = ObjectUtils.getProperty(configuracao, 'painel');
                if (!ArrayUtils.isNotEmpty(_gridPaineisDataProvider)) {
                    var tipo = ObjectUtils.getProperty(_gridPaineisDataProvider[0], 'TIPO.$')
                    populateFormulario(tipo);
                }
                self.dsPaineis.refresh();
            }

            function onChangeTipo() {
                $scope.pesqGadgetVisible = self.dsPaineis.getFieldValue("TIPO") == "G" ? true : false;
                campoAlterado();
            }

            function populateFormulario(tipo) {
                if (StringUtils.isNotEmpty(tipo)) {
                    self.statusSalvarDisabled = true;
                    self.comboTipoEnabled = false;

                    switch (tipo) {
                        case "S":
                            self.btnRemoveDisabled = true;
                            break;

                        case "P":
                            self.btnRemoveDisabled = false;
                            break;

                        case "G":
                            self.btnRemoveDisabled = false;
                            $scope.pesqGadget = self.dsPaineis.getFieldValue("GADGET");
                            break;
                    }
                } else {
                    self.btnRemoveDisabled = true;
                    self.comboTipoEnabled = true;

                    if(_modoInclusao){
                        self.dsPaineis.setFieldValue("EXIBIR", "S");
                        self.dsPaineis.setFieldValue("TIPO", "P");
                    }

                    $scope.pesqGadget = undefined;
                }
            }

            function linhaSelecionada() {
                var lineSelect = self.dsPaineis.getCurrentRowAsObject();
                if (angular.isDefined(lineSelect)) {
                    populateFormulario(lineSelect.TIPO);
                }
            }

            function campoAlterado() {
                if(angular.isDefined(self.dblFace) && self.dblFace.getSelectedIndex() == DoubleFacePanelConstants.FORM_FACE){
                    self.statusSalvarDisabled = false;
                }
            }

            function addPainel() {
                _modoInclusao = true;

                $scope.list_selector = [
                    { data: 'P', value: i18n('Comercial.FichaParceiro.itemPersonalizado') },
                    { data: 'G', value: i18n('Comercial.FichaParceiro.itemCompBI') }
                ];

                self.dsPaineis.goToInsertionMode().then(function () {
                    populateFormulario(undefined);
                });

                self.dblFace.setSelectedIndex(0);
                self.statusSalvarDisabled = false;
            }

            function close() {
                $popupInstance.success();
            }

            self.getLabel = function (nome) {
                return i18n("Comercial.FichaParceiro." + nome);
            }

            self.interceptCellRenderer = function (cell, value, eGridCell, data) {
                if (cell.colId == "TIPO") {

                    var element = document.createElement("span");
                    element.setAttribute("style", "layout-align: left;");
                    var text = i18n('Comercial.FichaParceiro.itemSistema');

                    if (value == "P")
                        text = i18n('Comercial.FichaParceiro.itemPersonalizado');

                    if (value == "G")
                        text = i18n('Comercial.FichaParceiro.itemCompBI');

                    element.innerHTML = text;

                    return {
                        element: element,
                        align: "left"
                    }
                }
            }

            function salvarPaineis(gridAlterou) {
                if (StringUtils.isEmpty(self.dsPaineis.getFieldValueAsString("TITULO"))) {
                    MessageUtils.showAlert(i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial.FichaParceiro.labelTitulo')]));
                    return false;
                }

                if ($scope.pesqGadgetVisible && StringUtils.isEmpty(self.dsPaineis.getFieldValueAsString("NUGDG")) && StringUtils.isEmpty(self.pesqGadget) && self.dsPaineis.isFieldVisible("NUGDG")) {
                    MessageUtils.showAlert("Atenção!", "É necessário informar o campo Cód. Gadget.");
                    return false;
                }

                if (StringUtils.isEmpty(self.dsPaineis.getFieldValue("LINHA"))) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial:FichaParceiro.labelLinha')]));
                    return false;
                }

                if (StringUtils.isEmpty(self.dsPaineis.getFieldValue("COLUNA"))) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageFaltaCampo', [i18n('Comercial.FichaParceiro.labelColuna')]));
                    return false;
                }

                var sourceConfiguracao = StringUtils.newBuffer();
                var paineis = self.dsPaineis.getRecordsAsObjects();

                sourceConfiguracao.append('<configuracao>\n');

                _gridPaineisDataProvider = [];

                let deferrer = new Promise((resolve, reject) => {

                    if (!gridAlterou && _modoInclusao) {
                        var item = _modoInclusao ? {} : self.dsPaineis.getCurrentRowAsObject();

                        item['EXIBIR'] = { $: self.dsPaineis.getFieldValue("EXIBIR") ? "S" : "N" };
                        item['TITULO'] = { $: self.dsPaineis.getFieldValue("TITULO") };
                        item['LINHA'] = { $: self.dsPaineis.getFieldValue("LINHA") };
                        item['COLUNA'] = { $: self.dsPaineis.getFieldValue("COLUNA") };

                        for (const element of paineis) {
                            if (ObjectUtils.getProperty(item, 'IDENTIFICADOR.$') != element.IDENTIFICADOR &&
                                ObjectUtils.getProperty(item, 'LINHA.$') == element.LINHA &&
                                ObjectUtils.getProperty(item, 'COLUNA.$') == element.COLUNA) {
                                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageTituloPainelJaExiste', [element.TITULO.toString(), element.LINHA.toString(), element.COLUNA.toString()]));
                                reject();
                                break;
                            }
                        }

                        if (_modoInclusao) {
                            var cmbTipo = self.dsPaineis.getFieldValue("TIPO");
                            item["TIPO"] = { $: cmbTipo };

                            if (cmbTipo == "G") {
                                item["GADGET"] = { $: $scope.pesqGadget||self.pesqGadget };
                            }

                            var identificador = "PanelPers_" + FichaParceiroService.createUuid().toString().replace(/-/g, "_");

                            if (identificador.length > 30) {
                                identificador = identificador.substring(0, 30);
                            }

                            item["IDENTIFICADOR"] = { $: identificador };

                            _gridPaineisDataProvider.push(item);

                            sourceConfiguracao.append(AngularUtil.jsonToXml(item, "painel"));
                        }
                    }
                    resolve();
                })

                deferrer.then( function(value) {

                    paineis = self.dsPaineis.getRecordsAsObjects();
                    paineis.forEach(function (painel) {
                        var obj = {};

                        Object.keys(painel).forEach(function (key) {
                            if (StringUtils.isNotEmpty(painel[key])) {
                                ObjectUtils.setProperty(obj, key, { $: painel[key] });
                            }
                        });

                        _gridPaineisDataProvider.push(obj);

                        var xml = AngularUtil.jsonToXml(obj, "painel");
                        sourceConfiguracao.append(xml);
                    });

                    sourceConfiguracao.append('</configuracao>');

                    var params = {
                        configuracao: {
                            resourceID: resourceID,
                            source: { $: sourceConfiguracao.toString() }
                        }
                    }

                    ServiceProxy.callService("mgecom@FichaParceiroSP.salvarConfigPaineis", params)
                        .then(function (response) {
                            _configuracoesAlteradas = true;
                            self.statusSalvarDisabled = true;

                            if (_modoInclusao) {
                                self.dsPaineis.refresh();
                                _modoInclusao = false;
                            }

                            self.dblFace.setSelectedIndex(1);
                        });
                }, function (erro) {
                    return false;
                })
            }
            

            function removerPainel() {
                MessageUtils.confirm(i18n('Comercial.FichaParceiro.tituloAlertaConfirmacao'), i18n('Comercial.FichaParceiro.confirmaExcluirPainel'))
                    .then(function () {
                        var painelRemover = self.dsPaineis.getCurrentRowAsObject();
                        var paineisGrid = self.dsPaineis.getRecordsAsObjects();

                        var sourceConfiguracao = StringUtils.newBuffer();
                        sourceConfiguracao.append('<configuracao>');

                        var params = { configuracao: undefined };

                        _gridPaineisDataProvider = [];

                        paineisGrid.forEach(function (painel) {
                            if (painelRemover.IDENTIFICADOR == painel.IDENTIFICADOR) {
                                ObjectUtils.setProperty(params.configuracao, 'removerConfigPainel', painelRemover.IDENTIFICADOR)
                            } else {
                                var objRemove = {};

                                Object.keys(painel).forEach(function (key) {
                                    if (StringUtils.isNotEmpty(painel[key])) {
                                        ObjectUtils.setProperty(objRemove, key, { $: painel[key] });
                                    }
                                });

                                _gridPaineisDataProvider.push(objRemove);

                                var xml = AngularUtil.jsonToXml(objRemove, "painel");
                                sourceConfiguracao.append(xml);
                            }
                        });

                        sourceConfiguracao.append('</configuracao>');

                        var params = {
                            configuracao: {
                                resourceID: resourceID,
                                source: { $: sourceConfiguracao.toString() }
                            }
                        }

                        ServiceProxy.callService("mgecom@FichaParceiroSP.salvarConfigPaineis", params)
                            .then(function (response) {
                                _configuracoesAlteradas = true;
                                self.statusSalvarDisabled = true;
                                self.dsPaineis.refresh();
                            });

                    });
            }
        }
    ]);

angular
    .module('snk.commons')
    .component('skConfiguradorPlanilha', {
        templateUrl: 'commons/fichaparceiro/ConfiguradorPlanilha/ConfiguradorPlanilha.tpl.html',
        controller: 'ConfiguradorPlanilhaController',
        bindings: {
            indicador: '=?skIndicador',
            CODPARC: '=?skCodparc',
        }
    })
    .controller('ConfiguradorPlanilhaController',
        ['$scope', 'AngularUtil', 'FPUtils',
            function ($scope, AngularUtil, FPUtils) {
                var self = this;

                self.buildIndicadorPlanilha = buildIndicadorPlanilha;
                self.init = init;

                $scope.dsColunas = null;

                function init() {
                    buildIndicadorPlanilha(self.indicador);
                }

                self.init();

                function buildIndicadorPlanilha(indicador) {


                    var lista = [];
                    if (indicador.dados != null && indicador.dados.linha != null) {
                        lista = indicador.dados.linha;
                    }

                    var colunas = [];

                    if (indicador.colunas != null && indicador.colunas.coluna != null) {


                        var col_ref = indicador.colunas.coluna;

                        if (col_ref != null && !Array.isArray(col_ref)) {
                            col_ref = [indicador.colunas.coluna];
                        }

                        for (var y = 0; y < col_ref.length; y++) {
                            var coluna = col_ref[y];
                            colunas.push({ name: coluna.INDICE.$, description: coluna.DESCRICAO.$ });
                        }


                        if (colunas.length > 0) {
                            $scope.dsColunas = FPUtils.converteListaToDataSet(AngularUtil, $scope, lista, colunas);

                        }
                    }

                }
            }

        ]);

angular
.module('snk.commons')
.component('skConfiguradorUltimasNotas', {
    templateUrl: 'commons/fichaparceiro/ConfiguradorUltimasNotas/ConfiguradorUltimasNotas.tpl.html',
    controller: 'ConfiguradorUltimasNotasController',
    controllerAs: 'ctrl',
    bindings: {
        onCreated: '&skOnCreated',
        data: '=skData',
        configuracaoAlteradaHandler: '&?skConfiguracaoAlteradaHandler',
    }
})
.controller('ConfiguradorUltimasNotasController', ['$scope', '$element', 'ServiceProxy', 'i18n', 'StringUtils', 'ArrayUtils', 'ObjectUtils', 'MessageUtils', 'AngularUtil',
        function ($scope, $element, ServiceProxy, i18n, StringUtils, ArrayUtils, ObjectUtils, MessageUtils, AngularUtil) {
            var self = this;

            var _initialized = false;
            self.radioUltimosMeses = undefined;

            self.getDados = getDados;
            self.campoAlterado = campoAlterado;

            iniConfigUltimasNotas();

            function iniConfigUltimasNotas(){
                _initialized = true;

                if (self.onCreated) {
                    self.onCreated({component: self});
                }

                populateForm();
            }

            function populateForm(){
                if(_initialized){
                    if(self.data){
                        if (self.data.$ == undefined) {
                            self.data.$ = self.data;
                        }

                        if(self.data.$.CONSIDERAR.ULTIMOSMESES.ULTIMOSMESES == "true"){
                            self.radioUltimosMeses = 1;
                        }else{
                            self.radioUltimosMeses = 0;
                        }

                        self.textUltimosMeses = self.data.$.CONSIDERAR.ULTIMOSMESES.$;
                        self.textUltimasNotas = self.data.$.CONSIDERAR.ULTIMASNOTAS.$;
                    }else{
                        self.radioUltimosMeses = true;
                        self.textUltimosMeses = 1;
                        self.textUltimasNotas = 1;
                    }
                }
            }

            function getDados(){
                var considerarUltimosMeses = self.radioUltimosMeses == "1";

                var objDetalhes = {
                    CONSIDERAR : {
                        CHECKULTIMOSMESES : considerarUltimosMeses,
                        ULTIMOSMESES : {$ : self.textUltimosMeses},
                        ULTIMASNOTAS : {$ : self.textUltimasNotas}
                    }
                }

                return objDetalhes;
            }

            function campoAlterado(){
                if (self.configuracaoAlteradaHandler) {
                    self.configuracaoAlteradaHandler();
                }
            }
        }
    ]);


angular
.module('snk.commons')
.component('skConfiguradorUltimosMeses', {
    templateUrl: 'commons/fichaparceiro/ConfiguradorUltimosMeses/ConfiguradorUltimosMeses.tpl.html',
    controller: 'ConfiguradorUltimosMesesController',
    controllerAs: 'ctrl',
    bindings: {
        onCreated: '&skOnCreated',
        data: '=skData',
        configuracaoAlteradaHandler: '&skConfiguracaoAlteradaHandler',
    }
})
.controller('ConfiguradorUltimosMesesController', ['$scope', 'ServiceProxy', 'i18n', 'StringUtils', 'ArrayUtils', 'ObjectUtils', 'MessageUtils', 'AngularUtil', 'MGEParameters', 'DateUtils', 'SkApplicationInstance', 'Criteria',
    function ($scope, ServiceProxy, i18n, StringUtils, ArrayUtils, ObjectUtils, MessageUtils, AngularUtil, MGEParameters, DateUtils, SkApplicationInstance, Criteria) {
        var self = this;

        var _initialized = false;

        self.campoAlterado = campoAlterado;
        self.getDados = getDados;

        iniConfigUltimosMeses();

        function iniConfigUltimosMeses(){
            _initialized = true;
            if (self.onCreated) {
                self.onCreated({component: self});
            }

            populateForm();
        }

        function populateForm(){
            if(_initialized){
                self.textUltimosMeses = 1;

                if(self.data){
                    if (self.data.$ == undefined) {
                        self.data.$ = self.data;
                    }
    
                    if(self.data.$.CONSIDERAR.ULTIMOSMESES.ULTIMOSMESES == "true"){
                        self.textUltimosMeses = self.data.$.CONSIDERAR.ULTIMOSMESES.$;
                    }
                }
            }
        }


        function campoAlterado(){
            if (self.configuracaoAlteradaHandler) {
                self.configuracaoAlteradaHandler();
            }
        }

        function getDados(){
            var considerarUltimosMeses = true;

            var objDetalhes = {
                CONSIDERAR : {
                    CHECKULTIMOSMESES : considerarUltimosMeses,
                    ULTIMOSMESES : {$ : self.textUltimosMeses},
                    ULTIMOSTITULOS : {}
                }
            }

            return objDetalhes;
        }

    }]);


angular
.module('snk.commons')
.component('skConfiguradorUltimosTitulos', {
    templateUrl: 'commons/fichaparceiro/ConfiguradorUltimosTitulos/ConfiguradorUltimosTitulos.tpl.html',
    controller: 'ConfiguradorUltimosTitulosController',
    controllerAs: 'ctrl',
    bindings: {
        onCreated: '&skOnCreated',
        data: '=skData',
        configuracaoAlteradaHandler: '&skConfiguracaoAlteradaHandler',
    }
})
.controller('ConfiguradorUltimosTitulosController', ['$scope', 'ServiceProxy', 'i18n', 'StringUtils', 'ArrayUtils', 'ObjectUtils', 'MessageUtils', 'AngularUtil', 'MGEParameters',
    function ($scope, ServiceProxy, i18n, StringUtils, ArrayUtils, ObjectUtils, MessageUtils, AngularUtil, MGEParameters) {
        var self = this;

        self.campoAlterado = campoAlterado;
        self.getDados = getDados;

        var _initialized = false;

        self.radioUltimosMeses = undefined;
        self.radioUltimosTitulos = undefined;

        iniConfigUltimosTitulos();

        function iniConfigUltimosTitulos(){
            _initialized = true;

            if (self.onCreated) {
                self.onCreated({component: self});
            }

            populateForm();
        }

        function populateForm(){
            if(_initialized){
                if(self.data){
                    if (self.data.$ == undefined) {
                        self.data.$ = self.data;
                    }
                    
                    if(self.data.$.CONSIDERAR.ULTIMOSMESES.ULTIMOSMESES == "true"){
                        self.radioUltimosMeses = 1;
                    }else{
                        self.radioUltimosMeses = 0;
                    }

                    self.textUltimosMeses = self.data.$.CONSIDERAR.ULTIMOSMESES.$;
                    self.textUltimosTitulos = self.data.$.CONSIDERAR.ULTIMOSTITULOS.$;
                }else{
                    self.radioUltimosMeses = true;
                    self.textUltimosMeses = 1;
                    self.textUltimosTitulos = 1;
                }
            }

        }

        function campoAlterado(){
            if (self.configuracaoAlteradaHandler) {
                self.configuracaoAlteradaHandler();
            }
        }

        function getDados(){
            var considerarUltimosMeses = self.radioUltimosMeses == "1";

            var objDetalhes = {
                CONSIDERAR : {
                    CHECKULTIMOSMESES : considerarUltimosMeses,
                    ULTIMOSMESES : {$ : self.textUltimosMeses},
                    ULTIMOSTITULOS : {$ : self.textUltimosTitulos}
                }
            }

            return objDetalhes;
        }

    }]);


angular
.module('snk.commons')
.component('skConsultaDeProdutos', {
    templateUrl: 'commons/fichaparceiro/ConsultaDeProdutos/ConsultaDeProdutos.tpl.html',
    controller: 'ConsultaDeProdutosController',
    controllerAs: 'ctrl',
    bindings: {
        codParc: '=?skCodparc',
        resourceID: '=?skResourceId',
        paramsCriterio: '=?skParamsCriterio',
        titulo: '=?skTitulo',
        onCreated: '&skOnCreated'
    }
})
.controller('ConsultaDeProdutosController', ['$scope', 'ServiceProxy', 'i18n', 'ObjectUtils', 'StringUtils', 'SkConstants', 'NumberUtils', 'ArrayUtils', 'MessageUtils', 'CentralNotaLauncher', 'DateUtils', 'SkApplicationInstance', 'FichaParceiroService',
        function ($scope, ServiceProxy, i18n, ObjectUtils, StringUtils, SkConstants, NumberUtils, ArrayUtils, MessageUtils, CentralNotaLauncher, DateUtils, SkApplicationInstance, FichaParceiroService) {
            var self = this;

            const CONT_CONSULTA_PRODUTOS  = 0;
            const CONT_CONF_BUSCA_MAGICA  = 1;
            const CONT_CONF_CONSULTA_PROD = 2;

            const ABA_NEGOCIADOS = 0;
            const ABA_TIPICOS = 1;

            const FILTRO_TODOS = "T";
            const FILTRO_RAD_COM_ESTOQUE = "C";
            const FILTRO_RAD_SEM_ESTOQUE = "S";

            const RESOURCE_CADASTRO_PROD_SERV = "CAD";
            const RESOURCE_CONSULTA_PRODUTOS = "COP";

            ObjectUtils.implements(self, IDatagridInterceptor);
            self.sortMetadata = sortMetadata;

            self.onDatasetCreatedNegociados = onDatasetCreatedNegociados;
            self.onDatasetCreatedTipicos = onDatasetCreatedTipicos;
            self.refreshHandlerNegociados = refreshHandlerNegociados;
            self.refreshHandlerProdutosTipico = refreshHandlerProdutosTipico;
            self.realizarConsulta = realizarConsulta;
            self.onFinalizeConfiguracao = onFinalizeConfiguracao;
            self.goToConfigurarBuscaMagica = goToConfigurarBuscaMagica;
            self.produtoSelecionado = produtoSelecionado;
            self.buildLabelValorDecimal = buildLabelValorDecimal;
            self.openConfig = openConfig;
            self.atualizar = atualizar;
            self.keyDownValorBusca = keyDownValorBusca;
            self.changeTab = changeTab;
            self.abrirTelaCentral = abrirTelaCentral;
            self.openApp = openApp;
            self.fecharJanelaDetalhes = fecharJanelaDetalhes;
            self.refresh = refresh;
            self.setParamsCriterio = setParamsCriterio;
            self.calculateResize = calculateResize;
            self.getCellColors = getCellColors;

            self.selectedIndex = ABA_NEGOCIADOS;

            self.seletorTela = { selectedChild: CONT_CONSULTA_PRODUTOS };

            self.ID_CONSULTA_PRODUTOS = "ConsultaProdutos";
            
            self.listaTipoNegociacao = [
                {data: "0", value: i18n('Comercial.FichaParceiro.ConsultaProdutos_itemVendas')},
                {data: "1", value: i18n('Comercial.FichaParceiro.ConsultaProdutos_itemCompras')},
                {data: "2", value: i18n('Comercial.FichaParceiro.ConsultaProdutos_itemAmbos')}
            ];

            self.filtro_estoque = self.cod_filtro_todos = FILTRO_TODOS;
            self.tipo_negociacao = "0";
            self.filtro = "";
            self.janelaDetalhesVisivel = false;
            self.menorValor = {};
            self.maiorValor = {};
            self.ultimoValor = {};
            self.ultimaNeg = {};
            self.precoAtual = {};
            self.estoque = {};
            self.itensDetalhes = [
                { label : i18n("Comercial.FichaParceiro.ConsultaProdutos_labelMenorValor"), click_function : "ctrl.abrirTelaCentral(ctrl.menorValor.data)", bind_object : self.menorValor }, 
                { label : i18n("Comercial.FichaParceiro.ConsultaProdutos_labelMaiorValor"), click_function : "ctrl.abrirTelaCentral(ctrl.maiorValor.data)", bind_object : self.maiorValor }, 
                { label : i18n("Comercial.FichaParceiro.ConsultaProdutos_labelUltimoValor"), click_function : "ctrl.abrirTelaCentral(ctrl.ultimoValor.data)", bind_object : self.ultimoValor }, 
                { label : i18n("Comercial.FichaParceiro.ConsultaProdutos_labelUltimaNegociacao"), click_function : "ctrl.abrirTelaCentral(ctrl.ultimaNeg.data)", bind_object : self.ultimaNeg },
                { label : i18n("Comercial.FichaParceiro.ConsultaProdutos_labelPrecoAtual"), click_function : "ctrl.openApp('COP', 'produtosNegociados')", bind_object : self.precoAtual }, 
                { label : i18n("Comercial.FichaParceiro.ConsultaProdutos_labelConsultaProduto"), click_function : "ctrl.openApp('COP', 'produtosNegociados')", bind_object : self.estoque }
            ];

            var _paramsCriterio = $scope.paramsCriterio;

            var _visibleGridColumns = ["CODPROD", "DESCRPROD", "DTULTNEGOCIACAO", "QTDMEDIANEG", "MARCA", "REFFORN"];

            let _gridProdutosDataProvider = [];
            let _gridProdutosTipicosDataProvider = [];
            
            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({component: self});
                }
            }

            function setParamsCriterio(paramsCriterio){
                _paramsCriterio = paramsCriterio;
            }

            function onDatasetCreatedNegociados(dataset) {
                self.dsProdutosNegociados = dataset;

                self.dsProdutosNegociados.addLineChangeListener(function (index) {
                    if (index > -1) {
                        produtoSelecionado();
                    }
                });

                self.dsProdutosNegociados.init();
            }

            function onDatasetCreatedTipicos(dataset) {
                self.dsProdutosTipicos = dataset;
                self.dsProdutosTipicos.init();
            }

            function refreshHandlerNegociados(request) {
                return _gridProdutosDataProvider;
            }

            function calculateResize(){
                return self.janelaDetalhesVisivel ? '50%' : '100%';
            }

            function refreshHandlerProdutosTipico(request){
                return _gridProdutosTipicosDataProvider;
            }

            function existsCodParc() {
                if(_paramsCriterio && _paramsCriterio["CODPARC"] && StringUtils.emptyAsNull(_paramsCriterio["CODPARC"].toString()) != null) {
                    return true;
                }
                return false;
            }

            function refresh() {
                if(existsCodParc()) {
                    var paramsCriterio = {
                        criterio : {CODPARC : _paramsCriterio["CODPARC"]}
                    };
    
                    ServiceProxy.callService("mgecom@FichaParceiroSP.getProdutosTipicos", paramsCriterio)
                        .then(function (response) {
                            var produtos = ArrayUtils.toArray(ObjectUtils.getProperty(response, "responseBody.produtos.produto"));
                            self.dsProdutosTipicos.clearDataSet();
    
                            if (ArrayUtils.isNotEmpty(produtos)) {
                                var arrayProdutos = FichaParceiroService.converteArrayXMLToObject(produtos);
                                _gridProdutosTipicosDataProvider = arrayProdutos;
                                self.dsProdutosTipicos.addRecordsAsObjects(arrayProdutos);
                            }
                        }
                    );
                } else {
                    _gridProdutosTipicosDataProvider = [];
                }
                
                self.janelaDetalhesVisivel = false;
            }

            function realizarConsulta() {
                if(existsCodParc()) {
                    var params = {
                        criterio : {
                            resourceID: self.resourceID,
                            CODPARC : _paramsCriterio["CODPARC"]
                        }
                    };

                    if (StringUtils.emptyAsNull(self.tipo_negociacao) != null) {
                        params.criterio["TIPO"] = self.tipo_negociacao;
                    }

                    params.criterio["valorBusca"] = { $ : self.valorBusca};
                    params.criterio["COMESTOQUE"] = "false";
                    params.criterio["SEMESTOQUE"] = "false";

                    if (self.filtro_estoque == FILTRO_RAD_COM_ESTOQUE) {
                        params.criterio["COMESTOQUE"] = "true";
                    }

                    if (self.filtro_estoque == FILTRO_RAD_SEM_ESTOQUE) {
                        params.criterio["SEMESTOQUE"] = "true";
                    }

                    var codParcMatriz = _paramsCriterio["CODPARCMATRIZ"];
                    if (codParcMatriz) {
                        params.criterio["CODPARCMATRIZ"] = codParcMatriz;
                    }

                    ServiceProxy.callService("mgecom@FichaParceiroSP.consultarProdutos", params).then(
                        function (response) {
                            var produtos = ArrayUtils.toArray(ObjectUtils.getProperty(response, "responseBody.produtos.produto"));
                            _gridProdutosDataProvider = [];

                            if (ArrayUtils.isNotEmpty(produtos)) {
                                produtos = FichaParceiroService.converteArrayXMLToObject(produtos);
                                _gridProdutosDataProvider = produtos;
                            }
                            self.dsProdutosNegociados.refresh();
                        }
                    );
                } else {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.msgInformeParceiro'));
                }
            }

            function openConfig() {
                if (self.seletorTela.selectedChild == CONT_CONF_CONSULTA_PROD) {
                    goToConsultaProdutos();
                } else {
                    goToConfigurarConsultaProdutos();
                }
            }

            function atualizar() {
                goToConsultaProdutos();
                refresh();
            }

            function goToConsultaProdutos() {
                self.seletorTela.selectedChild = CONT_CONSULTA_PRODUTOS;
            }

            function goToConfigurarConsultaProdutos() {
                self.seletorTela.selectedChild = CONT_CONF_CONSULTA_PROD;
            }

            function goToConfigurarBuscaMagica() {
                self.seletorTela.selectedChild = CONT_CONF_BUSCA_MAGICA;
            }

            function onFinalizeConfiguracao(salvei) {
                goToConsultaProdutos();

                if (salvei) {
                    refresh();
                }
            }

            function changeTab(indx) {
                self.selectedIndex = indx;
            }

            function keyDownValorBusca(evt) {
                switch (evt.keyCode) {                 
                    case SkConstants.KEY_CODE.ENTER:
                        realizarConsulta();
                        break;
                        
                    default:
                        break;
                }
            }

            function produtoSelecionado() {
                self.janelaDetalhesVisivel = true;
				
                var item = self.dsProdutosNegociados.getCurrentRowAsObject();
                
				if(item) {
                    self.menorValor["value"] = NumberUtils.format(item.MENORVALOR, 2);
                    self.menorValor["data"] = item.NUNOTAMENORVALOR.toString();

                    self.maiorValor["value"] = NumberUtils.format(item.MAIORVALOR, 2);
                    self.maiorValor["data"] = item.NUNOTAMAIORVALOR.toString();

                    self.ultimoValor["value"] = NumberUtils.format(item.ULTIMOVALOR, 2);
                    self.ultimoValor["data"] = item.ULTIMANOTA.toString();

                    self.ultimaNeg["value"] = item.ULTIMANOTA + " em " + DateUtils.dateToString(item.DTULTNEGOCIACAO, DateUtils.DEFAULT_DATE_FORMAT);
                    self.ultimaNeg["data"] = item.ULTIMANOTA.toString();

                    self.precoAtual["value"] = NumberUtils.format(item.VALORATUAL, 2);
                    self.estoque["value"] = NumberUtils.format(item.ESTOQUE, 2);
				}
            }

            function openApp(resourceType, tipoDataset) {
                let item = undefined;
                
                if(tipoDataset == 'produtosTipicos'){
                    item = self.dsProdutosTipicos.getCurrentRowAsObject();
                } else if(tipoDataset == 'produtosNegociados') {
                    item = self.dsProdutosNegociados.getCurrentRowAsObject();
                }

                if(item) {
                    var pkObject = {
                        CODPROD : item.CODPROD.toString()
                    }

                    if(resourceType == RESOURCE_CADASTRO_PROD_SERV) {
                        if("S" == item.USOPROD.toString()) {
                            SkApplicationInstance.openApp("br.com.sankhya.core.cad.servicos", pkObject);
                        } else {
                            SkApplicationInstance.openApp("br.com.sankhya.core.cad.produtos", pkObject);
                        }
                    } else if(resourceType == RESOURCE_CONSULTA_PRODUTOS) {
                        SkApplicationInstance.openApp("br.com.sankhya.com.cons.consultaProdutos", pkObject);
                    }
				} else {
					MessageUtils.showAlert("Atenção!", "Nenhum produto foi selecionado para ser mostrado.");
				}
            }

            function fecharJanelaDetalhes() {
                self.janelaDetalhesVisivel = false;
            }

            function buildLabelValorDecimal(col, value, record) {
				return NumberUtils.format(value, 2);
            }
            
            function sortMetadata(fieldsMD, dataset) {
                ArrayUtils.sortArrayFromArray(fieldsMD, _visibleGridColumns, function (fieldMD) {
                    return fieldMD.name;
                });
            }

            function abrirTelaCentral(nuNota) {
                if(StringUtils.emptyAsNull(nuNota)) {
                    CentralNotaLauncher.launch({NUNOTA: nuNota});
                } else {
                    MessageUtils.showAlert("Atenção!", "Nenhuma nota foi encontrada para ser mostrada.");
                }
            }

            function getCellColors(row) {
                if (row.entity[3] == 'N') {
                    return '#FF0000';
                }
            }
        }
    ]);

angular
    .module('snk.commons')
    .component('skConsultaEquifax', {
        templateUrl: 'commons/fichaparceiro/ConsultaEquifax/ConsultaEquifax.tpl.html',
        controller: 'ConsultaEquifaxController',
        bindings: {

            CODPARC: '=?skCodparc',
            resourceID: '=?skResourceId',
            paramsCriterio: '=?skParamsCriterio',
            myTitulo: '=?skMyTitulo'
        }
    })
    .controller('ConsultaEquifaxController',
        ['$scope', 'ServiceProxy', 'i18n',
            function ($scope, ServiceProxy, i18n) {
                var self = this;

                self.atualizar = atualizar;

                self.equifaxPanel = angular.element('#panel_ConsultaEquifax');
                self.equifaxIframe = angular.element('#equifaxIframe');

                const targetNode = document.getElementById('panel_ConsultaEquifax');
                const config = { attributes: true, childList: false, subtree: false };

                function atualizar() {
                    
                }

                const callback = function(mutationsList, observer) {
                    for(let mutation of mutationsList) {
                        if (mutation.type === 'attributes') {
                            if(self.equifaxIframe) {
                                document.getElementById('equifaxIframe').style.height = changeIframeHeight();
                            }
                        }
                    }
                };
                
                const observer = new MutationObserver(callback);
                observer.observe(targetNode, config);

                function changeIframeHeight() {
                    let altura = self.equifaxPanel.css('height');
                    altura = Number(altura.replace('px', ''));
                    altura = (altura - 42) + 'px';

                    return altura;
                }

                $scope.mensagem = "";
                $scope.mostraIframe = true;
                $scope.url = "";

                self.mostraInfo = mostraInfo;
                self.load = load;
                $scope.dados = { codParc: "", CGC_CPF: "" }


                self.resourceManager = new (function () {
                    var self = this;

                    self.getInstance = getInstance;
                    self.getString = getString;

                    function getInstance() {
                        return self;
                    }

                    function getString(bundle, key) {
                        var resourceKey = bundle.replace(":", ".") + "." + key;
                        return i18n(resourceKey);
                    }
                })();

                self.load();


                function mostraInfo(codParc, cgcCpf) {

                    $scope.mensagem = self.resourceManager.getString('Comercial:FichaParceiro', 'messageSelecioneParceiro');

                    if (cgcCpf == null) {
                        if (codParc == null) {
                            $scope.mensagem = self.resourceManager.getString('Comercial:FichaParceiro', 'messageSelecioneParceiro');
                        } else {
                            $scope.mensagem = self.resourceManager.getString('Comercial:FichaParceiro', 'messageCPFParcNaoEncontrado') + " " + codParc;
                        }
                        $scope.mostraIframe = false;
                    } else {
                        $scope.mostraIframe = true;
                        $scope.url = "/mge/integracaoequifax.consulta?CGC_CPF=" + cgcCpf + "&REQUESTTIME=" + new Date().getTime();
                    }
                }


                function load() {

                    if (self.CODPARC == null || self.CODPARC == undefined) {

                        if (self.paramsCriterio["CODPARC"] != null) {
                            self.CODPARC = self.paramsCriterio["CODPARC"];
                        } else {

                            return false;
                        }
                    }


                    var body = {
                        configuracao: {
                            $: " <entity name=\"Parceiro\"> " +
                                " <criterio nome=\"CODPARC\" valor=\"" + self.CODPARC + "\"/>" +
                                " <fields><field name=\"CGC_CPF\"/></fields></entity> "
                        }
                    };

                    body = {
                        entity: {
                            name: "Parceiro", criterio: { nome: "CODPARC", valor: self.CODPARC },
                            fields: [{ field: { name: "CGC_CPF" } }]

                        }
                    };


                    ServiceProxy.callService(
                        "mge@crud.find", body).then(function (result) {

                            if (result != null && result.responseBody != null && result.responseBody.entidades != null && result.responseBody.entidades.entidade != null) {


                                var cgc_cpf = result.responseBody.entidades.entidade.CGC_CPF.$;

                                $scope.dados = { codParc: self.CODPARC, CGC_CPF: cgc_cpf }

                                mostraInfo(self.CODPARC, cgc_cpf);
                            }
                        });

                }

            }

        ]);
angular
    .module('snk.commons')
    .component('skDadosParceiro', {
        templateUrl: 'commons/fichaparceiro/DadosParceiro/DadosParceiro.tpl.html',
        controller: 'DadosParceiroController',
        controllerAs: 'ctrl',
        bindings: {
            codParc: '=?skCodparc',
            resourceID: '=?skResourceId',
            paramsCriterio: '=?skParamsCriterio',
            onCreated: '&skOnCreated',
            ehConsultaProduto: '=?ehConsultaProduto'
        }
    })
    .controller('DadosParceiroController', ['ServiceProxy', 'i18n', 'Criteria', 'ObjectUtils', 'AngularUtil', '$timeout', 'SkApplicationInstance', 'FichaParceiroService',
        function (ServiceProxy, i18n, Criteria, ObjectUtils, AngularUtil, $timeout, SkApplicationInstance, FichaParceiroService) {
            var self = this;

            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, IDynaformInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);

            self.refresh = refresh;
            self.init = init;
            self.onDynaformLoaded = onDynaformLoaded;
            self.openConfig = openConfig;
            self.buildCamposCadastro = buildCamposCadastro;
            self.setParamsCriterio = setParamsCriterio;
            self.interceptBuildField = interceptBuildField;
            self.onCreatedConfiguradorDadosParceiro = onCreatedConfiguradorDadosParceiro;
            self.onFinalizeConfiguracao = onFinalizeConfiguracao;

            var _configDadosParceiro;
            var _paramsCriterio = {};

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({component: self});
                }
            }

            function onCreatedConfiguradorDadosParceiro(component){
                _configDadosParceiro = component;
                _configDadosParceiro.carregarConfig();
            }

            function setParamsCriterio(paramsCriterio){
                _paramsCriterio = paramsCriterio;
            }

            function isVisibleCnpj(){
                return self.dsContato.getFieldValueAsString("TIPPESSOA") === "J";
            }

            function onDynaformLoaded(dynaform, dataset) {
                if (dynaform.getEntityName() == 'Contato') {
                    self.dynaform = dynaform;
                    self.dsContato = dataset;
                    
                    dynaform.addFieldPropertyEvaluator("CNPJ", "visible", () => isVisibleCnpj(),"TIPPESSOA");
                    dynaform.addFieldPropertyEvaluator("CPF", "visible", () => !isVisibleCnpj(),"TIPPESSOA");

                    self.dsContato.addCriteriaProvider(getCriteria);

                    var observerContato = new IDataSetObserver();
                    observerContato.insertionModeActivated = function () {
                        var codParc = self.paramsCriterio["CODPARC"];
                        self.dsContato.setFieldValue("CODPARC", codParc);
                    };

                    self.dsContato.addObserver(observerContato);
                    setupContatoFieldValueEvaluators();

                    var canEditContato = self.ehConsultaProduto ? false : SkApplicationInstance.hasAuthorization('editTGFCTT');
                     self.dsContato.canEdit = self.dsContato.canInsert = self.dsContato.canRemove = self.dsContato.canCopy = canEditContato;
                    $timeout(function () {
                        self.dsContato.initAndRefresh();
                    }, 200, false);
                    dynaform.goToGridView()

                }

            }

            function getCriteria() {
                return Criteria('this.CODPARC = ?', _paramsCriterio["CODPARC"]);
            }

            function refresh() {
                var paramsCriterio = _paramsCriterio;
                var codParc = paramsCriterio.CODPARC;

                if (codParc) {
                    self.faceDadosParceiroIndex = 1;

                    var params = {
                        criterio : {
                            CODPARC : codParc,
                            resourceID : self.resourceID
                        }
                    }

                    ServiceProxy.callService("mgecom@FichaParceiroSP.getDadosParceiro", params).then(function (result) {
                        if (angular.isDefined(result.responseBody.parceiro)) {
                            var campo = result.responseBody.parceiro.campos.campo;
                            self.campos = campo;
                        }
                    });

                    if (self.dsContato) {
                        self.dsContato.refresh();
                    } else if (self.dynaform) {
                        self.dynaform.loadMetadata();
                    }
                } else {
                    self.faceDadosParceiroIndex = 0;
                }
            }

            function openConfig() {
                if (self.faceDadosParceiroIndex != 2) {
                    self.faceDadosParceiroIndex = 2;
                } else {
                    if(angular.isDefined(_paramsCriterio["CODPARC"])){
                        self.faceDadosParceiroIndex = 1;
                    }else{
                        self.faceDadosParceiroIndex = 0;
                    }
                }
            }

            function onFinalizeConfiguracao() {
                if (self.faceDadosParceiroIndex == 2) {
                    if(angular.isDefined(_paramsCriterio["CODPARC"])){
                        self.faceDadosParceiroIndex = 1;
                    }else{
                        self.faceDadosParceiroIndex = 0;
                    }
                }
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                var entityName = dataset.getEntityName();
                if (entityName == 'Contato') {
                    if (fieldName == 'CEP') {
                        return montaComponenteCep("", "", dataset, fieldProp, scope);
                    }
                }
            }

            function montaComponenteCep(entity, complementoField, dataset, fieldProp, scope) {
                var fieldCodCid = entity + 'CODCID' + complementoField;
                var fieldCodEnd = entity + 'CODEND' + complementoField;
                var fieldCodBai = entity + 'CODBAI' + complementoField;
                var fieldNumEnd = entity + (complementoField == '' ? 'NUMEND' : 'NUM') + complementoField;

                fieldProp['sk-field-name'] = entity + 'CEP' + complementoField;
                fieldProp['sk-intercept-address-info'] = 'interceptAddressInfo';

                scope.interceptAddressInfo = function (addressInfo) {
                    addressInfo.CODCID = dataset.getFieldValueAsString(fieldCodCid);
                    addressInfo.CODEND = dataset.getFieldValueAsString(fieldCodEnd);
                    addressInfo.NUMEND = dataset.getFieldValueAsString(fieldNumEnd);
                };

                scope.codsAddressBind = {CIDADE: fieldCodCid, BAIRRO: fieldCodBai, ENDERECO: fieldCodEnd};
                fieldProp['sk-cods-address-bind'] = 'codsAddressBind';

                return AngularUtil.createDirective('sk-cep-input', fieldProp, scope);
            }

            function setupContatoFieldValueEvaluators() {
                var validateCpfCnpj = function () {
                    $timeout(function () {
                        if (isJuridico(self.dsContato)) {
                            if (self.dsContato.isFieldEmpty('CNPJ')) {
                                self.dynaform.showFieldTooltip('informe.cnpj.cpf', 'CNPJ', i18n('Core.Parceiro.messagePreencherCNPJ'), 10000);
                            }
                        } else if (self.dsContato.isFieldEmpty('CPF')) {
                            self.dynaform.showFieldTooltip('informe.cnpj.cpf', 'CPF', i18n('Core.Parceiro.messagePreencherCPF'), 10000);
                        }
                    }, 100, false);
                };

                self.dsContato.addFieldValueEvaluator('CPF', function (dataset, currentRow) {
                    var newValue = isJuridico(dataset) ? undefined : currentRow.CPF;
                    validateCpfCnpj();
                    return newValue;
                }, 'TIPPESSOA');

                self.dsContato.addFieldValueEvaluator('CNPJ', function (dataset, currentRow) {
                    var newValue = !isJuridico(dataset) ? undefined : currentRow.CNPJ;
                    validateCpfCnpj();
                    return newValue;
                }, 'TIPPESSOA');
            }

            function isJuridico(ds) {
                return ds.getFieldValueAsString('TIPPESSOA') == 'J';
            }

            function buildCamposCadastro(item) {
                return FichaParceiroService.buildObjectToStyle(item);
            }
        }

    ]);

angular
  .module('snk.commons')
  .component('skDetalhesLimiteCredito', {
    templateUrl: 'commons/fichaparceiro/DetalhesLimiteCredito/DetalhesLimiteCredito.tpl.html',
    controller: 'DetalhesLimiteCreditoController',
    controllerAs: 'ctrl',
    bindings: {
      onCreated: '&skOnCreated',
      codParc: '=?skCodParc',
      indicador: '=?skIndicador',
      onClickBackHandler: '&?skOnClickBackHandler',
    }
  })
  .controller('DetalhesLimiteCreditoController', ['ServiceProxy', 'i18n', 'NumberUtils', 'ObjectUtils',
    function (ServiceProxy, i18n, NumberUtils, ObjectUtils) {
      var self = this;

      ObjectUtils.implements(self, IDatagridInterceptor);

      self.carregarDetalhes = carregarDetalhes;
      self.onDatasetLimCredito = onDatasetLimCredito;
      self.onDatasetLimCreditoMedia = onDatasetLimCreditoMedia;
      self.refreshHandlerLimCredito = refreshHandlerLimCredito;
      self.refreshHandlerLimCreditoMedia = refreshHandlerLimCreditoMedia;
      self.onClickVoltar = onClickVoltar;

      self.painelLimCredMediaVisible = false;

      var _dataProviderLimCredito;
      var _dataProviderLimCreditoMedia;

      init();

      function init() {
        if (self.onCreated) {
          self.onCreated({ component: self });
        }
      }

      function onDatasetLimCredito(dataset) {
        self.dsLimCredito = dataset;
        self.dsLimCredito.init();
      }

      function onDatasetLimCreditoMedia(dataset) {
        self.dslimCreditoMedia = dataset;
        self.dslimCreditoMedia.init();
      }

      function refreshHandlerLimCredito(request){
				return _dataProviderLimCredito;
			}

      function refreshHandlerLimCreditoMedia(request){
        return _dataProviderLimCreditoMedia;
      }

      function onClickVoltar() {
        if(self.onClickBackHandler){
            self.onClickBackHandler();
        }
      }

      function carregarDetalhes(codParc, nomeIndicador) {
        self.infoDetalhesLimCredito = i18n('Comercial.FichaParceiro.titleDetalhesSobreIndicador', [nomeIndicador]);
        
        var params = {
          criterio: {
            CODPARC: codParc
          }
        };

        ServiceProxy.callService("mgecom@FichaParceiroSP.getDetalhesLimiteCredito", params)
          .then(function (response) {
            if (angular.isDefined(response.responseBody.detalhesLimite)) {
              var detalhesLimite = response.responseBody.detalhesLimite;

              // debugger

              self.infoLimMensal = NumberUtils.round(NumberUtils.getNumberOrZero(detalhesLimite.LIMITEMENSAL.$), 2);
              self.infoLimTotal = NumberUtils.round(NumberUtils.getNumberOrZero(detalhesLimite.LIMITETOTAL.$), 2);
              self.infoDebitoTotal = NumberUtils.round(NumberUtils.getNumberOrZero(detalhesLimite.DEBITOTOTAL.$), 2);
              self.infoDisponivelTotal= NumberUtils.round(NumberUtils.getNumberOrZero(detalhesLimite.DISPONIVELTOTAL.$), 2);
              
              _dataProviderLimCredito = detalhesLimite.limitesMensais.limiteMensal;
              self.dsLimCredito.refresh();

              if(response.responseBody.hasOwnProperty("detalhesMediaNegociacoes")){
                self.painelLimCredMediaVisible = true;

                var detalhesMediaNegociacoes = response.responseBody.detalhesMediaNegociacoes;

                self.infoParamMesesMedia = NumberUtils.getNumberOrZero(detalhesMediaNegociacoes.QTDMESESMEDIA.$);
                self.infoMesesUtiliz = NumberUtils.getNumberOrZero(detalhesMediaNegociacoes.QTDMESESUTILIZ.$);
                self.infoTotalDesteMes = NumberUtils.round(NumberUtils.getNumberOrZero(detalhesMediaNegociacoes.TOTALDESTEMES.$), 2);
                self.infoParamAumMedia = NumberUtils.getNumberOrZero(detalhesMediaNegociacoes.PERCAUMMEDIO.$);
                self.infoTotalMesesAnt = NumberUtils.round(NumberUtils.getNumberOrZero(detalhesMediaNegociacoes.TOTALMESESANTERIORES)), 2;
                self.infoMediaMaisPerc = NumberUtils.round(NumberUtils.getNumberOrZero(detalhesMediaNegociacoes.MEDIAMAISPERC), 2);
                
                _dataProviderLimCreditoMedia = detalhesMediaNegociacoes.detalhesNegociacoes;
                self.dslimCreditoMedia.refresh();
              }else{
                self.infoParamMesesMedia = 0;
                self.infoMesesUtiliz = 0;
                self.infoTotalDesteMes = 0;
                self.infoParamAumMedia = 0;
                self.infoTotalMesesAnt = 0;
                self.infoMediaMaisPerc = 0;
                self.painelLimCredMediaVisible = true;
              }
            }
          });
      }
    }
  ]);

angular
    .module('snk.commons')
    .component('skDetalhesPontualidade', {
        templateUrl: 'commons/fichaparceiro/DetalhesPontualidade/DetalhesPontualidade.tpl.html',
        controller: 'DetalhesPontualidadeController',
        controllerAs: 'ctrl',
        bindings: {
            onCreated: '&skOnCreated',
            codParc: '=?skCodParc',
            indicador: '=?skIndicador',
            onClickBackHandler: '&?skOnClickBackHandler',
        }
    })
    .controller('DetalhesPontualidadeController',
    ['$scope', 'ServiceProxy', 'i18n', 'ObjectUtils', 'AngularUtil', 'SkApplicationInstance', 'ArrayUtils',
        function ($scope, ServiceProxy, i18n, ObjectUtils, AngularUtil, SkApplicationInstance, ArrayUtils) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);

            self.onDatasetFinPontuais = onDatasetFinPontuais;
            self.onDatasetFinAtrasados = onDatasetFinAtrasados;
            self.refreshHandlerFinPontuais = refreshHandlerFinPontuais;
            self.refreshHandlerFinAtrasados = refreshHandlerFinAtrasados;
            self.carregarDetalhes = carregarDetalhes;
            self.onClickVoltar = onClickVoltar;
            self.buildLabelTipoMovimentacao = buildLabelTipoMovimentacao;
            self.buildLabelEmpresa = buildLabelEmpresa;
            self.buildLabelTipoTitulo = buildLabelTipoTitulo;
            self.buildLabelNatureza = buildLabelNatureza;

            var _dataFinPontuais;
            var _dataFinAtrasados;

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({ component: self });
                }
            }

            function onDatasetFinPontuais(dataset) {
                self.dsFinPontuais = dataset;
                self.dsFinPontuais.init();
            }

            function onDatasetFinAtrasados(dataset) {
                self.dsFinAtrasados = dataset;
                self.dsFinAtrasados.init();
            }

            function refreshHandlerFinPontuais(request) {
                return _dataFinPontuais;
            }

            function refreshHandlerFinAtrasados(request) {
                return _dataFinAtrasados;
            }

            function carregarDetalhes(dados, nomeIndicador) {
                self.infoCabecalho = i18n('Comercial.FichaParceiro.titleDetalhesSobreIndicador', [nomeIndicador]);

                self.infoFinsAtrasados = i18n('Comercial.FichaParceiro.messageTitulosPagosAtraso', [dados.QTDTITULOSATRASADOS.$, dados.VLRTOTALTITULOSATRASADOS.$]);
                self.infoFinsPontuais = i18n('Comercial.FichaParceiro.messageTitulosPagosEmDia', [dados.QTDTITULOSPONTUAIS.$, dados.VLRTOTALTITULOSPONTUAIS.$]);

                carregarGridFinPontuais(dados.linha.financeirosPontuais.financeiro);
                carregarGridFinAtrasados(dados.linha.financeirosAtrasados.financeiro);
            }

            function carregarGridFinPontuais(financeiros) {
                financeiros = ArrayUtils.toArray(financeiros);

                if (ArrayUtils.isNotEmpty(financeiros)) {
                    var params = { criterio: { financeiro: [] } };
                    self.painelPontuaisVisible = true;

                    angular.forEach(financeiros, function (financeiro) {
                        params.criterio.financeiro.push(financeiro);
                    });

                    ServiceProxy.callService("mgecom@FichaParceiroSP.getFinanceiros", params)
                        .then(function (response) {
                            var responseFinanceiros = response.responseBody.financeiros;
                            if (angular.isDefined(responseFinanceiros)) {
                                _dataFinPontuais = [];
                                _dataFinPontuais = ArrayUtils.toArray(responseFinanceiros.financeiro);
                                self.dsFinPontuais.refresh();
                            }
                        });
                } else {
                    self.painelPontuaisVisible = false;
                }
            }

            function carregarGridFinAtrasados(financeiros) {
                financeiros = ArrayUtils.toArray(financeiros);

                if (ArrayUtils.isNotEmpty(financeiros)) {
                    self.painelAtrasadosVisible = true;

                    var params = { criterio: { financeiro: [] } };

                    angular.forEach(financeiros, function (financeiro) {
                        params.criterio.financeiro.push(financeiro);
                    });

                    ServiceProxy.callService("mgecom@FichaParceiroSP.getFinanceiros", params)
                        .then(function (response) {
                            if (angular.isDefined(response.responseBody.financeiros)) {
                                _dataFinAtrasados = [];
                                _dataFinAtrasados = ArrayUtils.toArray(response.responseBody.financeiros.financeiro);
                                self.dsFinAtrasados.refresh();
                            }
                        });
                } else {
                    self.painelAtrasadosVisible = false;
                }
            }

            function onClickVoltar() {
                if (self.onClickBackHandler) {
                    self.onClickBackHandler();
                }
            }

            function buildLabelTipoMovimentacao(col, value, row) {
                let indexCodTipOper = self.dsFinPontuais.getFieldIndexByName("CODTIPOOPER");
                let indexDescrOper = self.dsFinPontuais.getFieldIndexByName("DESCROPER");
                return row[indexCodTipOper] + " - " + row[indexDescrOper];
            }

            function buildLabelEmpresa(col, value, row) {
                let indexCodEmp = self.dsFinPontuais.getFieldIndexByName("CODEMP");
                let indexDescrEmp = self.dsFinPontuais.getFieldIndexByName("NOMEEMP");
                return row[indexCodEmp] + " - " + row[indexDescrEmp];
            }

            function buildLabelTipoTitulo(col, value, row) {
                let indexCodTit = self.dsFinPontuais.getFieldIndexByName("CODTIPTIT");
                let indexDescrTip = self.dsFinPontuais.getFieldIndexByName("DESCRTIPTIT");
                return row[indexCodTit] + " - " + row[indexDescrTip];
            }

            function buildLabelNatureza(col, value, row) {
                let indexCodNat = self.dsFinPontuais.getFieldIndexByName("CODNAT");
                let indexDescrNat = self.dsFinPontuais.getFieldIndexByName("DESCRNAT");
                return row[indexCodNat] + " - " + row[indexDescrNat];
            }
        }

    ]); 


angular
.module('snk.commons')
.component('skDetalhesRenegociacoes', {
    templateUrl: 'commons/fichaparceiro/DetalhesRenegociacoes/DetalhesRenegociacoes.tpl.html',
    controller: 'DetalhesRenegociacoesController',
    controllerAs: 'ctrl',
    bindings: {
        onCreated: '&skOnCreated',
        codParc: '=?skCodParc',
        indicador: '=?skIndicador',
        onClickBackHandler: '&?skOnClickBackHandler',
    }
})
.controller('DetalhesRenegociacoesController', ['$scope', 'ServiceProxy', 'i18n', 'NumberUtils', 'StringUtils', 'ObjectUtils', 'ArrayUtils',
        function ($scope, ServiceProxy, i18n, NumberUtils, StringUtils, ObjectUtils, ArrayUtils) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);

            self.onDatasetRenegociacoes = onDatasetRenegociacoes;
            self.onDatasetDetalhesRenegociacoes = onDatasetDetalhesRenegociacoes;
            self.refreshHandleRenegociacoes = refreshHandleRenegociacoes;
            self.refreshHandlerDetalhesRenegociacoes = refreshHandlerDetalhesRenegociacoes;
            self.onClickVoltar = onClickVoltar;
            self.carregarRenegociacoes = carregarRenegociacoes;

            var _dataRenegociacoes;
            var _dataDetalhesRenegociacoes;

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({ component: self });
                }
            }

            function onDatasetRenegociacoes(dataset) {
                self.dsRenegociacoes = dataset;

                var observer = new IDataSetObserver();
                observer.currentLineChanged = function () {
                    carregarDetalhes();
                }

                self.dsRenegociacoes.addObserver(observer);
                self.dsRenegociacoes.initAndRefresh();
            }

            function onDatasetDetalhesRenegociacoes(dataset) {
                self.dsDetalhesRenegociacoes = dataset;
                self.dsDetalhesRenegociacoes.initAndRefresh();
            }

            function refreshHandleRenegociacoes(request) {
                return _dataRenegociacoes;
            }

            function refreshHandlerDetalhesRenegociacoes(request) {
                return _dataDetalhesRenegociacoes;
            }

            function carregarRenegociacoes(codParc, indicador){
                self.infoDetalhesRenegociacoes = i18n('Comercial.FichaParceiro.titleDetalhesSobreIndicador', [indicador.DESCRICAO.$]);

                var dadosIndicador = indicador.dados;

                self.infoRenegociacoesPeriodo = i18n('Comercial.FichaParceiro.labelRenegociacoesPeriodo') + ": " + dadosIndicador.QTDRENEG.$;
                self.infoMaiorNegociacao = i18n('Comercial.FichaParceiro.labelMaiorNegociacao') + ": " + dadosIndicador.MAIORRENEG.$;
                self.infoUltimaNegociacao = i18n('Comercial.FichaParceiro.labelUltimaNegociacao') + ": " + dadosIndicador.ULTIMARENEG.$;
                self.infoTotal = i18n('Comercial.FichaParceiro.labelTotal') + ": " + dadosIndicador.TOTALRENEG.$;

                ServiceProxy.callService('mgecom@FichaParceiroSP.getRenegociacoes', {dados : dadosIndicador})
                    .then(function (response) {
                        var renegociacoes = response.responseBody.renegociacoes;

                        _dataRenegociacoes = ArrayUtils.toArray(renegociacoes.renegociacao);

                        if(angular.isDefined(self.dsRenegociacoes)){
                            self.dsRenegociacoes.refresh();
                        }
                        //carregarDetalhes();
                });
            }

            function carregarDetalhes(){
                var item = self.dsRenegociacoes.getCurrentRowAsObject();
                if(angular.isDefined(item)){
                    var nuReneg = item["NURENEG"];

                    if(StringUtils.isNotEmpty(nuReneg)){
                        var params = {
                            criterio : {
                                NURENEG : nuReneg
                            }
                        }
                        ServiceProxy.callService('mgecom@FichaParceiroSP.getDetalhesRenegociacao', params)
                            .then(function (response) {
                                var renegociacoes = response.responseBody.renegociacoes;

                                if(angular.isDefined(renegociacoes)){
                                    _dataDetalhesRenegociacoes = ArrayUtils.toArray(renegociacoes.renegociacao);
                                }

                                self.dsDetalhesRenegociacoes.refresh();
                            });

                    }
                }
            }

            function onClickVoltar() {
                if (self.onClickBackHandler) {
                    self.onClickBackHandler();
                }
            }
        }

    ]);


angular
    .module('snk.commons')
    .component('skDetalhesUltimoContato', {
        templateUrl: 'commons/fichaparceiro/DetalhesUltimoContato/DetalhesUltimoContato.tpl.html',
        controller: 'DetalhesUltimoContatoController',
        controllerAs: 'ctrl',
        bindings: {
            onClickBackHandler: '&?skOnClickBackHandler',
            onCreated: '&skOnCreated',
        }
    })
    .controller('DetalhesUltimoContatoController', ['$scope', 'i18n', 'SkApplicationInstance',
        function ($scope, i18n, SkApplicationInstance) {
            var self = this;

            self.carregarDetalhes = carregarDetalhes;
            self.onClickVoltar = onClickVoltar;
            self.mostrarOS = mostrarOS;
            self.mostrarTel = mostrarTel;
            self.mostrarNotaPedido = mostrarNotaPedido;

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({ component: self });
                }

                self.linkContatoOS = {
                    label : i18n('Comercial.FichaParceiro.labelSemContatoOS'),
                    data : undefined
                };
    
                self.linkContatoTel = {
                    label : i18n('Comercial.FichaParceiro.labelSemContatoTelemarketing'),
                    data : undefined
                };
    
    
                self.linkContatoNota = {
                    label : i18n('Comercial.FichaParceiro.labelSemContatoNota'),
                    data : undefined
                };
    
            }

            function carregarDetalhes(dados, nomeIndicador) {
                self.infoCabecalho = i18n('Comercial.FichaParceiro.titleDetalhesSobreIndicador', [nomeIndicador]);

                if(dados.detalhesContatos.hasOwnProperty("contatoOS")){
					var contatoOS = dados.detalhesContatos.contatoOS;
					 
					self.linkContatoOS.label = i18n('Comercial.FichaParceiro,labelUltimaOS', [contatoOS.DHCONTATO.$]);
					self.linkContatoOS.data = contatoOS.NUMOS.$;
                }else{
					self.linkContatoOS.label = i18n('Comercial.FichaParceiro.labelSemContatoOS');
					self.linkContatoOS.data = undefined;
				}

                if(dados.detalhesContatos.hasOwnProperty("contatoTel")){
					var contatoTel = dados.detalhesContatos.contatoTel;
					 
					self.linkContatoTel.label = i18n('Comercial.FichaParceiro.labelUltimoContatoTelemarketing', [contatoTel.DHCONTATO.$]);
					self.linkContatoTel.data = contatoTel.NUREL.$;
				}else{
					self.linkContatoTel.label = i18n('Comercial.FichaParceiro.labelSemContatoTelemarketing');
					self.linkContatoTel.data = undefined;
				}
				
				if(dados.detalhesContatos.hasOwnProperty("contatoNota")){
					var contatoNota = dados.detalhesContatos.contatoNota;
					 
					self.linkContatoNota.label = i18n('Comercial.FichaParceiro.labelUltimaNota', [contatoNota.DHCONTATO.$]);
					self.linkContatoNota.data = contatoNota.NUNOTA.$;
				}else{
					self.linkContatoNota.label = i18n('Comercial.FichaParceiro.labelSemContatoNota');
					self.linkContatoNota.data = undefined;
				}
            }

            function onClickVoltar() {
                if (self.onClickBackHandler) {
                    self.onClickBackHandler();
                }
            }

            function mostrarOS(){
                var obj = {}
                obj.numOs = self.linkContatoOS.data;
                obj.numItem = -1;

                SkApplicationInstance.openApp("br.com.sankhya.os.mov.OrdemServico", obj);
            }
            
            function mostrarTel(){
                var obj = {};
                obj.NUREL = self.linkContatoTel.data;

                SkApplicationInstance.openApp("br.com.sankhya.com.Telemarketing", obj);
            }

            function mostrarNotaPedido(){
                if(self.linkContatoNota.data){
                    var obj = {}

                    obj.NUNOTA = self.linkContatoNota.data;
                    SkApplicationInstance.openApp("br.com.sankhya.com.mov.CentralNotas_" + obj.NUNOTA, obj);
                }
              
            }
        }
    ]);

angular
.module('snk.commons')
.component('skExibirItemRender', {
    templateUrl: 'commons/fichaparceiro/ExibirItemRender/ExibirItemRender.tpl.html',
    controller: 'ExibirItemRenderController',
    bindings: {
    }
})
.controller('ExibirItemRenderController',
    ['$scope', '$element', 'ServiceProxy', 'i18n', 'StringUtils', 'ArrayUtils', 'ObjectUtils', 'MessageUtils', 'AngularUtil', 'MGEParameters',
        'DateUtils', 'SkApplicationInstance', 'Criteria',
        function ($scope, $element, ServiceProxy, i18n, StringUtils, ArrayUtils, ObjectUtils, MessageUtils, AngularUtil, MGEParameters,
            DateUtils, SkApplicationInstance, Criteria) {
            var self = this;

        }

    ]);
angular
    .module('snk.commons')
    .factory("FPUtils",
        function () {

            return {


                getHexCodeFromDecimal: function (numeric, NumberUtils) {
                    var hexaCode = numeric ? NumberUtils.decimalToHex(numeric).toUpperCase() : undefined;
                    if (hexaCode.toString().length < 6) {

                        while (hexaCode.length < 6) {
                            hexaCode = '0' + hexaCode;
                        }
                        return hexaCode;
                    }
                    return hexaCode;
                },
                pureColor: function (color) {

                    return color.toString().replace('0x', '').replace('#', '');;
                },


                createUuid: function () {
                    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });
                },

                getHtmlColor: function (solidcolor_entrada, opacity, NumberUtils) {

                    var r = 0; g = 0; b = 0;
                    var solidcolor = solidcolor_entrada;

                    if (NumberUtils != null && NumberUtils != undefined) {

                        if (angular.isNumber(solidcolor)) {

                            solidcolor = this.getHexCodeFromDecimal(solidcolor_entrada, NumberUtils);
                        }

                        return "#" + solidcolor;
                    }
                    var pedacos = parseFloat(solidcolor.length / 3);
                    var pedacos_int = parseInt(solidcolor.length / 3);

                    if (pedacos > pedacos_int)
                        pedacos_int++;
                    var inicio_proximo_pedaco = 0;

                    for (var i = 1; i <= pedacos_int; i++) {

                        var analise = 0;
                        analise = solidcolor.substring(inicio_proximo_pedaco, inicio_proximo_pedaco + 3);

                        if (parseInt(analise) > 255) {
                            analise = solidcolor.substring(inicio_proximo_pedaco, inicio_proximo_pedaco + 2);
                            inicio_proximo_pedaco = inicio_proximo_pedaco + 2;
                        } else {

                            inicio_proximo_pedaco = inicio_proximo_pedaco + 3;
                        }

                        if (i == 1) {
                            r = analise;
                        }
                        if (i == 2) {
                            g = analise;
                        }
                        if (i == 3) {
                            b = analise;
                        }


                    }

                    if (opacity == null || opacity == undefined) {

                        opacity = "0.5";
                    }
                    return "rgba(" + r + "," + g + "," + b + "," + opacity.toString() + ") ";

                },

                numberOrZero: function (val) {

                    if (typeof val === "number") {
                        return parseInt(val);
                    }

                    if (typeof val === "float") {
                        return parseInt(val);
                    }

                    return 0;

                },

                tohex: function (n) {
                    var retval = '';
                    if (n <= 0) {
                        retval = '00';
                        return retval;
                    }
                    var nt = n;
                    while (n > 0) {
                        var m = n;
                        n = m >> 4;
                        m = m % 16;
                        var string = '';
                        if (m < 10) string = '' + m; else {
                            switch (m) {
                                case 10:
                                default:
                                    string = 'A'
                                    break;

                                case 11:
                                    string = 'B'
                                    break;

                                case 12:
                                    string = 'C'
                                    break;

                                case 13:
                                    string = 'D'
                                    break;

                                case 14:
                                    string = 'E'
                                    break;

                                case 15:
                                    string = 'F'
                                    break;
                            }
                        }
                        retval = string + retval;
                    }
                    if (nt < 16) retval = '0' + retval;
                    return retval;
                },

                colorDecimalToHex: function (color, StringUtils, NumberUtils) {

                    return "#" + StringUtils.stringZero(NumberUtils.decimalToHex(color), 6, undefined, true);

                },
                dinheiroFormater: function (value, NumberUtils) {

                    if ( Highcharts == null || Highcharts == undefined ){

                        return NumberUtils.format(parseFloat(value), 2);
                    }else {
                        return Highcharts.numberFormat( parseFloat(value) , 2);

                    }
                },
                converteObjetoToSankhyaFormat: function (item) {
                    return this.converteObjetoToSanckyaFormat(item);

                },

                converteObjetoToSanckyaFormat: function (item) {

                    var saida = {};

                    var keys = Object.keys(item);

                    for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        saida[key] = { $: item[key] }
                    }

                    return saida;

                },
                isVazio(MessageUtils, dataset, field, msg) {

                    if (dataset.getFieldValue(field) == null || dataset.getFieldValue(field).toString() == "") {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, msg);
                        return true;

                    }

                    return false;

                },


                getList: function (listat) {

                    if (Array.isArray(listat)) {

                        return listat;

                    } else {
                        var lista = [];

                        if (listat != null && listat != undefined) {

                            lista.push(listat);
                        }

                        return lista;
                    }

                },

                converteListaSankhya: function (listat) {

                    var lista = [];

                    if (Array.isArray(listat)) {


                        for (var i = 0; i < listat.length; i++) {
                            var item = {}
                            item = this.converteObjetoFromSankhyaFormat(listat[i]);

                            lista.push(item);
                        }

                    } else {
                        if (listat != null && listat != undefined) {
                            var item = this.converteObjetoFromSankhyaFormat(listat);

                            lista.push(item);
                        }
                    }

                    return lista;

                },
                converteObjetoFromSankhyaFormat: function (item) {
                    return this.converteObjetoFromSanckyaFormat(item);
                },
                converteObjetoFromSanckyaFormat: function (item) {

                    var saida = {};

                    var keys = Object.keys(item);

                    for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        saida[key] = item[key].$;
                    }

                    return saida;



                },
                converteObjetoUnicoXML: function (item, soPreenchido) {
                    var xml = "";
                    var keys = Object.keys(item);
                    for (var zz = 0; zz < keys.length; zz++) {
                        var key = keys[zz];

                        if (item[key] != null && typeof item[key] === "object")
                            continue;

                        if (soPreenchido != null && soPreenchido == true) {
                            if (item[key] == null || item[key].toString() == "") {
                                continue;
                            }
                        }



                        xml += "<" + key + ">";

                        if (item[key] != null && item[key] != undefined) {
                            xml += "" + item[key].toString() + "";
                        }


                        xml += "</" + key + ">";

                    }
                    return xml;
                },
                getPropsXMLFromObj: function (item, soPreenchido) {
                    var xml = "";
                    var keys = Object.keys(item);
                    for (var zz = 0; zz < keys.length; zz++) {
                        var key = keys[zz];

                        if (soPreenchido != null && soPreenchido == true) {
                            if (item[key] == null || item[key].toString() == "") {
                                continue;
                            }
                        }

                        if (item[key] == null) {
                            xml += " " + key + "=\"\"";
                            continue;
                        }



                        if (typeof item[key] !== "object" && !Array.isArray(item[key])) {

                            if (item[key] != null && item[key] != undefined) {
                                xml += " " + key + "=\"" + item[key].toString() + "\"";
                            }

                        }

                    }
                    return xml;
                },
                getXmlChildrenFromlist: function (lst, tag) {
                    var xml = "";
                    for (var zz = 0; zz < lst.length; zz++) {
                        var item = lst[zz];
                        xml += "<" + tag + " " + this.getPropsXMLFromObj(item) + " />";
                    }

                    return xml;

                },
                getXmlObjectsFromlist: function (lst, tag) {
                    var xml = "";
                    for (var zz = 0; zz < lst.length; zz++) {
                        var item = lst[zz];
                        xml += "<" + tag + ">" + this.converteObjetoUnicoXML(item, true) + "</" + tag + ">";
                    }

                    return xml;

                },
                converteDataSetToList: function (dataset) {

                    var lista = dataset.getRecordsAsObject();
                    return lista;
                },
                converteListaToDataSet: function (AngularUtil, $scope, itens, colunas) {

                    var dsProperties = {
                        standalone: true
                    };

                    var diretiva = AngularUtil.createDirective('sk-dataset', dsProperties, $scope);


                    var datasetElem = angular.element(diretiva);
                    var ds = datasetElem.data('$skDatasetController');

                    for (var i = 0; i < colunas.length; i++) {
                        ds.addUserFieldMetadata(colunas[i]);
                    }
                    ds.setStandAlone(true);
                    ds.initializeDataSet();

                    if (!Array.isArray(itens)) {
                        var subit = [];
                        subit.push(itens);

                        itens = subit;

                    }

                    for (var i = 0; i < itens.length; i++) {
                        var item = itens[i];

                        var novo_item = {};

                        for (var z = 0; z < colunas.length; z++) {
                            var coluna = colunas[z].name;

                            novo_item[coluna] = null;

                            if (item["COLUNA" + coluna] != null) {
								colunanum = "COLUNA" + coluna;
								if (item[colunanum].$ != null) {
                                novo_item[coluna] = item[colunanum].$;
	                            } else {
	
	                                novo_item[coluna] = item[colunanum];
	                            }
                            } else if (item[coluna] != null) {
                                if (item[coluna].$ != null) {
                                    novo_item[coluna] = item[coluna].$;
                                } else {

                                    novo_item[coluna] = item[coluna];
                                }
                            }
                        }

                        ds.addRecordsAsObjects(novo_item, null, true);

                    }

                    return ds;
                },

                getStyleByParceiroItem(item) {

                    if (item.SOMENTEVALOR != null && item.SOMENTEVALOR.toString() == "true") {
                        return "";
                    }

                    var arr = [];
                    if (item.COR != null) {
                        arr.push("color: #" + item.COR);
                    }

                    if (item.FONTFAMILY != null) {
                        arr.push("font-family: " + item.FONTFAMILY);
                    }
                    if (item.FONTSIZE != null) {
                        arr.push("font-size: " + item.FONTSIZE + "px");
                    }
                    if (item.FONTWEIGHT != null) {

                        var traduzido = "normal";
                        if (item.FONTWEIGHT == "negrito") {
                            traduzido = "bold";
                        }
                        arr.push("font-weight: " + traduzido + "");
                    }
                    if (item.TEXTDECORATION != null) {
                        arr.push("text-decoration: " + item.TEXTDECORATION + "");
                    }
                    if (item.FONTSTYLE != null) {
                        arr.push("font-style: " + item.FONTSTYLE + "");
                    }

                    return arr.join(";");
                }
            }


        });
angular
.module('snk.commons')
    .component('skFichaParceiroContainer', {
        templateUrl: 'commons/fichaparceiro/FichaParceiroContainer/FichaParceiroContainer.tpl.html',
        controller: 'FichaParceiroContainerController as ctrl',
        bindings: {
            onCreated: '&skOnCreated',
            onClickBack: '&skOnClickBack',
            criterioParceiro: '&skCriterioParceiro',
            onSelectParceiro: '&?skOnSelectParceiro',
            embedded: '@embedded',
            ehPedidoWeb: '=?ehPedidoWeb',
            ehConsultaProduto: '=?ehConsultaProduto'
        }
    })
    .constant('FichaParceiroConstant', {
        "ID_PENDENCIAS_FIN": "PendenciasFinanceiras",
        "ID_GIRO_NEGOCIACOES": "GiroNegociacoes",
        "ID_INDICADORES_DE_SISTEMA": "IndicadoresSistema",
        "ID_CONSULTA_PRODUTOS": "ConsultaProdutos",
        "ID_DADOS_PARCEIRO": "DadosParceiro",
        "ID_INFORMACOES_SOBRE_CHAMADOS": "InformacoesSobreChamadosParceiro",
        "ID_PAINEL_PERSONALIZADO": "PainelPersonalizado",
        "ID_CONSULTA_EQUIFAX" : "ConsultaEquifax"
    })
    .controller('FichaParceiroContainerController', ['$scope', 'ServiceProxy', 'i18n', 'StringUtils', 'MessageUtils', 'SkApplicationInstance', 'SanPopup', 'ObjectUtils', 'MGEParameters', 'ArrayUtils', 'NumberUtils', 'AngularUtil', 'FichaParceiroConstant', 'MGEAuthorizationService', 'MGEAuthorizationConstants', 'FichaParceiroService',
        function ($scope, ServiceProxy, i18n, StringUtils, MessageUtils, SkApplicationInstance, SanPopup, ObjectUtils, MGEParameters, ArrayUtils, NumberUtils, AngularUtil, FichaParceiroConstant, MGEAuthorizationService, MGEAuthorizationConstants, FichaParceiroService) {
            var self = this;

            const TELEMARKETING_RESOURCE_ID = "br.com.sankhya.com.Telemarketing";
            const FICHAPARCEIROS_RESOURCE_ID = "br.com.sankhya.com.cons.fichaParceiro";
            const FICHAPARCEIROS_PEDIDOWEB_RESOURCE_ID = "br.com.sankhya.FichaDeParceirosW";

            self.abrirTelemarketing = abrirTelemarketing;
            self.abrirCadastroParceiro = abrirCadastroParceiro;
            self.getApplicationResourceID = getApplicationResourceID;
            self.exibeInfomacaoParceiro = exibeInfomacaoParceiro;
            self.aplicarFiltro = aplicarFiltro;
            self.otherOptionsLoader = otherOptionsLoader;
            self.consultaSerasa = consultaSerasa;
            self.configurarPaineis = configurarPaineis;
            self.loadFichaParceiro = loadFichaParceiro;
            self.setFocus = setFocus;
            self.setCodParc = setCodParc;
            self.filtraParceiro = filtraParceiro;
            self.onClickBtnVoltar = onClickBtnVoltar;
            self.usarEsteParceiro = usarEsteParceiro;
            self.loadByCodParc = loadByCodParc;
            self.getCriterioParceiro = getCriterioParceiro;
            self.isLoad = isLoad;
            self.getParamsCriterio = getParamsCriterio;
            self.getCodParc = getCodParc;
            self.openConfigPainel = openConfigPainel;
            self.onCreatedConsultaProdutos = onCreatedConsultaProdutos;
            self.onCreatedDadosParceiro = onCreatedDadosParceiro;
            self.onCreatedInformacoesChamado = onCreatedInformacoesChamado;
            self.onCreatedPainelPersonalizado = onCreatedPainelPersonalizado;
            self.onCreatedGiroNegociacao = onCreatedGiroNegociacao;
            self.onCreatedPendenciasFinanceiras = onCreatedPendenciasFinanceiras;
            self.onCreatedIndicadores = onCreatedIndicadores;
            self.onCreatedIndicadoresPersonalizado = onCreatedIndicadoresPersonalizado;
            self.getNameIndicadores = getNameIndicadores;
            self.isIndicadorPersonalizado = isIndicadorPersonalizado;
            self.refreshPainel = refreshPainel;
            self.getNuGadget = getNuGadget;
            self.onCreatedCompactPanel = onCreatedCompactPanel;
            self.resizeCompactPanel = resizeCompactPanel;
            self.carregaInfomacaoParceiro = carregaInfomacaoParceiro;
            self.getExibirParcInativos = getExibirParcInativos;
            self.enableCodParc = enableCodParc;

            self.isSankhyaW = SkApplicationInstance.isSankhyaW();
            self.isJivaW = SkApplicationInstance.isJivaW();
            
            self.optionsSearchParceiro = {};
            self.usarParceiroEnabled = false;
            self.ehConsultaProduto = false;
            self.B2BMode = false;
            self.usarParceiroVisible = false;
            self.exibirPorMatriz = "N";
            self.exibirParcInativos = false;
            self.hasConfigAccess = true;
            self.uid =StringUtils.nextUid();
            self.exibeMensagemParcInvalido=false;

            $scope.paramsCriterio = {};

            let _isCriteriaPesqParceiro = false;
            let controleCartoes;
            let consultaFaturas;
            let pesqCliente;
            let _isLoad = false;
            let _codParcMatriz;
            let _consProd;
            let _dadosParceiro;
            let _informacoesChamado;
            let _painelPersonalizado;
            let _giroNegociacao;
            let _pendenciasFinanceiras;
            let _indicadores;
            let _dashBoardPanels = new Map();
            let _idIndicadorGadgetPanel;

            init();

            function init() {
                if (self.onCreated) {
            		self.onCreated({component: self});
                }
                
                if(!self.embedded) {
                    loadAccessConfigFichaParceiro();
                    exibeInfomacaoParceiro();
                    loadFichaParceiro();
                }

                isLoad = true;
            }

            function onCreatedCompactPanel(component){
                self.compactPanelComponent = component;
            }

            function loadAccessConfigFichaParceiro(){
                var resourceID = getApplicationResourceID();
                MGEAuthorizationService.loadAuthorization(resourceID).then(function(authData) {
                    self.hasConfigAccess = authData.hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_CONFIG);
                });
            }

            function isLoad(){
                return _isLoad;
            }

            function onCreatedConsultaProdutos(component){
                _consProd = component;
                
                _dashBoardPanels.set(
                    FichaParceiroConstant.ID_CONSULTA_PRODUTOS, 
                    {
                        api : _consProd, 
                        id: FichaParceiroConstant.ID_CONSULTA_PRODUTOS
                    }
                );
            }

            function onCreatedDadosParceiro(component){
                _dadosParceiro = component;
                
                _dashBoardPanels.set(
                    FichaParceiroConstant.ID_DADOS_PARCEIRO, 
                    {
                        api : _dadosParceiro, 
                        id: FichaParceiroConstant.ID_DADOS_PARCEIRO
                    }
                );
            }

            function onCreatedInformacoesChamado(component){
                _informacoesChamado = component;
                
                _dashBoardPanels.set(
                    FichaParceiroConstant.ID_INFORMACOES_SOBRE_CHAMADOS, 
                    {
                        api : _informacoesChamado, 
                        id: FichaParceiroConstant.ID_INFORMACOES_SOBRE_CHAMADOS
                    }
                );
            }

            function onCreatedGiroNegociacao(component){
                _giroNegociacao = component;

                _dashBoardPanels.set(
                    FichaParceiroConstant.ID_GIRO_NEGOCIACOES, 
                    {
                        api : _giroNegociacao, 
                        id: FichaParceiroConstant.ID_GIRO_NEGOCIACOES
                    }
                );
            }

            function onCreatedPendenciasFinanceiras(component){
                _pendenciasFinanceiras = component;

                _dashBoardPanels.set(
                    FichaParceiroConstant.ID_PENDENCIAS_FIN, 
                    {
                        api : _pendenciasFinanceiras, 
                        id: FichaParceiroConstant.ID_PENDENCIAS_FIN
                    }
                );
            }

            function onCreatedIndicadores(component){
                _indicadores = component;

                _dashBoardPanels.set(
                    FichaParceiroConstant.ID_INDICADORES_DE_SISTEMA, 
                    {
                        api : _indicadores,
                        id: FichaParceiroConstant.ID_INDICADORES_DE_SISTEMA
                    }
                );
            }

            function onCreatedIndicadoresPersonalizado(component, id){
                _indicadores = component;

                _dashBoardPanels.set(id, {
                        api : _indicadores,
                        id: id
                    }
                );
            }

            function onCreatedPainelPersonalizado(component, id){
                _painelPersonalizado = component;
                
                _dashBoardPanels.set(id, {
                        api : _painelPersonalizado,
                        id: id
                    }
                );
            }

            function resizeCompactPanel() {
                if(angular.isDefined(_giroNegociacao)){
                    _giroNegociacao.changeResizePanel();
                }else if(angular.isDefined(_pendenciasFinanceiras)){
                    _pendenciasFinanceiras.changeResizePanel();
                }
            }

            function loadByCodParc(codParc, editable){
                editable = angular.isDefined(editable) ? editable : true;
                if (angular.isDefined(codParc) && codParc.hasOwnProperty("CODPARC") && StringUtils.isNotEmpty(codParc.CODPARC) && self.pesqParceiro != codParc.CODPARC){
                    self.pesqParceiro = codParc.CODPARC;
                    self.pesqParceiroEnabled = editable;
                }
            }

            function filtraParceiro(pesquisaApi) {
                if(pesquisaApi) {
                    self.pesquisaInputApi = pesquisaApi;

                    if(!self.embedded) {
                        self.optionsSearchParceiro = {
                            listener: "br.com.sankhya.modelcore.pesquisa.listener.RestricaoCarteiraFichaParceiroListenerHtml5"
                        };
                    }else{
                        _isCriteriaPesqParceiro = true;
                    }
                }
            }

            function getCriterioParceiro() {
                if(_isCriteriaPesqParceiro) {
                    return self.criterioParceiro();
                }
            }

            function refreshPainel(id){
                _dashBoardPanels.forEach((dashBoardView) => {
                    if(dashBoardView.id == id){
                        dashBoardView.api.refresh();
                    }
                });
            }

            function getApplicationResourceID() {
                if (self.embedded) {
                    if (!self.ehPedidoWeb) {
                        return FICHAPARCEIROS_RESOURCE_ID;
                    } else {
                        return FICHAPARCEIROS_PEDIDOWEB_RESOURCE_ID;
                    }
                } else {
                    return SkApplicationInstance.getResourceID();
                }
            }
            
            function getExibirParcInativos(){
				return self.exibirParcInativos;
			}

            function loadFichaParceiro() {
                ServiceProxy.callService("mge@SystemUtilsSP.getSessionInfo", {}).then(function (result) {
                    if (angular.isUndefined(result) || angular.isUndefined(result.responseBody) || angular.isUndefined(result.responseBody.sessionInfo)) {
                        return false;
                    }

                    var B2BMode = result.responseBody.sessionInfo.b2bMode;

                    if (B2BMode) {
                        self.paramsCriterio["b2bMode"] = B2BMode;
                    }

                    var codParc = result.responseBody.sessionInfo.parceiro;

                    if (!StringUtils.isEmpty(codParc)) {
                        self.pesqParceiro = codParc;
                    }

                    var params = { criterio: { resourceID: getApplicationResourceID() } }

                    ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigPaineis", params).then(function (response) {
                        if (response != null && response.responseBody != null) {
                            buildStructureDashBoard(response.responseBody.configuracao);
                            setFocus();
                        }
                    }).finally(() => {
                    	exibeInfomacaoParceiro();
                	});
                });

                if(angular.isFunction(self.onSelectParceiro)) {
                    self.usarParceiroVisible = true;
                }
            }

            function otherOptionsLoader() {
                var itensMenu = [];

                itensMenu.push(
                    {label: i18n('Comercial.FichaParceiro.lblConsultaSerasa'), action: consultaSerasa},
                    {label: i18n('Comercial.FichaParceiro.lblReiniciarLayout'), action: resetLayout}
                );

                pesqCliente = {label: i18n('Comercial.FichaParceiro.lblPesquisarCliente'), action: popUpPesquisaParc};
                controleCartoes = {label: i18n('Comercial.FichaParceiro.lblControleCartoes'), action: controlarCartoes , enabled: false};
                consultaFaturas = {label: i18n('Comercial.FichaParceiro.lblConsultaFaturas'), action: consultarFaturas, enabled: false};
              
                if (!StringUtils.isEmpty(self.pesqParceiro)){
                    atualizaOpcoesPainel();
                }

                if(MGEParameters.asBoolean("exibe.opcao.cartao")){
                    itensMenu.push(controleCartoes);
                    itensMenu.push(pesqCliente);
                    itensMenu.push(consultaFaturas);
                }

                return itensMenu;
            }

            function atualizaOpcoesPainel(){
                if (StringUtils.isEmpty(self.pesqParceiro)){
                    controleCartoes.enabled = false;
                    consultaFaturas.enabled = false;
                    self.usarParceiroEnabled = false;

                    if(self.embedded){
                        self.exibeMensagemParcInvalido = true;
                        MessageUtils.showAlert(i18n('Comercial.FichaParceiro.lblInformacao'), i18n('Comercial.FichaParceiro.msgParceiroNaoEncontrado'));
                    }

                } else {
                    controleCartoes.enabled = true;
                    consultaFaturas.enabled = true;
                    self.usarParceiroEnabled = true;
                }
            }

            function consultaSerasa(){
                SkApplicationInstance.openApp("br.com.sankhya.mge.consulta.serasa", { CODPARC: self.pesqParceiro });
            }

            function controlarCartoes(){
                abrirTela("br.com.sankhya.opcredito.geracao.controle.cartao",{ CODPARC: self.pesqParceiro });
            }

            function popUpPesquisaParc(){
                SanPopup.open({
                    title: i18n('Comercial.FichaParceiro.popUpPesquisaParceiroPorCartao'),
                    templateUrl: 'commons/fichaparceiro/PopUpPesquisaParceiro/PopUpPesquisaParceiro.tpl.html',
                    controller: 'PopUpPesquisaParceiroController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    showBtnCancel: true,
                    showBtnOk: true,
                    showBtnNo: false,
                    okBtnLabel: i18n('Comercial.FichaParceiro.lblSelecionar'),
                    cancelBtnLabel: i18n('Comercial.FichaParceiro.lblCancelar'),
                    resolve: {
                        data : {}
                    }
                }).result.then(function (result) {
                    okFunctionPesquisaParc(result.codParc);
                });
            }

            function okFunctionPesquisaParc(codParc){
                self.pesqParceiro = codParc;
            }

            function consultarFaturas(){
                abrirTela("br.com.sankhya.consulta.fatura.cartao",{ CODPARC: self.pesqParceiro });
            }

            function resetLayout(){
                self.compactPanelComponent.resetDashBoardLayout();
                aplicarFiltro();
            }

            function exibeInfomacaoParceiro(strDescr,codParc) {
				
				if(codParc != null){
					self.pesqParceiro = codParc;
				}
	
                if (StringUtils.emptyAsNull(self.pesqParceiro) == null) {
                    aplicarFiltro();
                } else {
                    var body = {
                        entity: {
                            name: "Parceiro", criterio: { nome: "CODPARC", valor: self.pesqParceiro },

                        }
                    };

                    ServiceProxy.callService("mge@crud.find", body).then(function (result) {
                        let resultado = ObjectUtils.getProperty(result, "responseBody.entidades.entidade");
                        if (resultado) {
                            ServiceProxy.callService("mgecom@FichaParceiroSP.exibeInformacaoParceiro", {criterio: {codParc: self.pesqParceiro}}).then(function (response) {

                                if (angular.isDefined(response.responseBody) && angular.isDefined(response.responseBody.tipoParceiro)) {
                                    var tipParc = response.responseBody.tipoParceiro;

                                    if (!StringUtils.isEmpty(tipParc.$)) {
                                        MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.messageExibeInfParceiro') + " " + tipParc.$);
                                    	self.exibeMensagemParcInvalido = true;
                                    } else {
                                        aplicarFiltro(strDescr);
                                        atualizaOpcoesPainel();
                                        self.exibeMensagemParcInvalido = false;
                                    }
                                }
                            });
                        }
                    });
                }
            }

            function abrirTela(resourceID, pk){
                if (StringUtils.isNotEmpty(pk["CODPARC"])){
                    SkApplicationInstance.openApp(resourceID, pk);
                } else {
                    SkApplicationInstance.openApp(resourceID);
                }
            }

            function abrirTelemarketing() {
                if (StringUtils.isNotEmpty(self.pesqParceiro)) {
                    SkApplicationInstance.openApp(TELEMARKETING_RESOURCE_ID, { CODPARC: self.pesqParceiro });
                } else {
                    MessageUtils.showAlert(i18n('Comercial.FichaParceiro.labelTelemarketing'), i18n('Comercial.FichaParceiro.messageInformeParceiro'));
                }
            }

            function abrirCadastroParceiro() {
				if(angular.isDefined(self.pesqParceiro) && StringUtils.isNotEmpty(self.pesqParceiro)){
					if (SkApplicationInstance.getResourceID() == FICHAPARCEIROS_PEDIDOWEB_RESOURCE_ID) {
		                SkApplicationInstance.openApp("br.com.sankhya.cad.ParceiroWeb", { CODPARC: self.pesqParceiro });
	                } else {
		                SkApplicationInstance.openApp("br.com.sankhya.core.cad.parceiros", { CODPARC: self.pesqParceiro });
					}
				} else {
					MessageUtils.showAlert(i18n('Comercial.FichaParceiro.lblInformacao'), i18n('Comercial.FichaParceiro.messageInformeParceiro'));
				}
            }

            function configurarPaineis() {
                SanPopup.open({
                    title: i18n('Comercial.FichaParceiro.titleConfigurandoPaineis'),
                    templateUrl: 'commons/fichaparceiro/ConfiguradorPaineis/ConfiguradorPaineis.tpl.html',
                    controller: 'ConfiguradorPaineisController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnCancel: false,
                    showBtnOk: true,
                    showBtnNo: false,
                    okBtnLabel: i18n('Geral.buttonFechar'),
                    resolve: {
                        resourceID: function () {
                            return getApplicationResourceID()
                        }
                    }
                }).result.then(function (result) {
                    loadFichaParceiro();
                });
            }

            function onClickBtnVoltar() {
                if(angular.isFunction(self.onClickBack)) {
                    self.onClickBack();
                }
            }

            self.atualizaOpcoesPainel = function () {
                if (self.embedded && (self.pesqParceiro == null || self.pesqParceiro == undefined || self.pesqParceiro.toString() == "")) {
                    MessageUtils.showAlert(i18n('Comercial.FichaParceiro.lblInformacao'), i18n('Comercial.FichaParceiro.msgParcNaoEncontrado'));
                }
            }

            $scope.validador = function(identificador) {
                if(['PendenciasFinanceiras','InformacoesSobreChamadosParceiro'].includes(identificador)){
                    return i18n("Comercial.FichaParceiro.msgloadingdashboard");
                } else {
                    return i18n("Comercial.FichaParceiro.msgloadingpanel");
                }
            }

            function buildStructureDashBoard(configuracao) {
                var paineisElem = configuracao.painel;
                var paineisporLinhas = [];
                var paineis = [];
                var max_linha = 0;

                SkApplicationInstance.loadMgeConfig(getApplicationResourceID() + ".painelConfigs")
                    .then(function(result) {
                        var configPainel = result.config?.painel;

                       configPainel = ArrayUtils.sortByStringProperty(configPainel, 'label');

                        paineisElem.sort((a, b)=> {
                            if (a.LINHA.$ === b.LINHA.$){
                                return parseInt(a.COLUNA.$) < parseInt(b.COLUNA.$) ? -1 : 1
                            } else {
                                return parseInt(a.LINHA.$) < parseInt(b.LINHA.$) ? -1 : 1
                            }
                        })

                        var indexConfig = 0;

                        paineisElem.forEach(function(painelElem) {
                            var item = FichaParceiroService.converteObjectXMLToObject(painelElem);
                            if(item.EXIBIR == 'S'){
                                var config =  configPainel[indexConfig];
                                if(config){
                                    ObjectUtils.setProperty(item.config, 'WIDTH', ObjectUtils.getProperty(config, 'WIDTH.$'));
                                    ObjectUtils.setProperty(item.config, 'name', ObjectUtils.getProperty(config, 'label'));
                                    indexConfig = indexConfig + 1;
                                }
                            }

                            if (item.LINHA != null && parseInt(item.LINHA) > max_linha) {
                                max_linha = parseInt(item.LINHA);
                            }
                            paineis.push(item);
                        });

                        paineis = buildInfoPaineisDashboard(paineis);

                        for (var i = 1; i <= max_linha; i++) {
                            var obj_linha = { index: i, colunas: [] }
                            var colunas = paineis.filter(function (value) {
                                return value.LINHA.toString() == i.toString() && (value.EXIBIR != undefined && value.EXIBIR.toString() == "S")
                            });

                            if (colunas.length > 0) {
                                obj_linha.colunas = colunas;
                                paineisporLinhas.push(obj_linha);
                            }
                        }

                        self.paineisInfo = paineisporLinhas;
                    });
            }

            function getParamsCriterio(){
                return $scope.paramsCriterio;
            }
            
            function getCodParc(){
                return self.pesqParceiro;
            }

            function openConfigPainel(id){
                _dashBoardPanels.forEach((dashBoardView) => {
                    if(dashBoardView.id == id && dashBoardView.api.openConfig){
                        dashBoardView.api.openConfig();
                    }
                });
            }

            function buildInfoPaineisDashboard(paineis){
                var dashboarBuilder = [];

                paineis.forEach(function(painel) {
                    var painelComponent = undefined;

                    switch(painel.IDENTIFICADOR.toString()) {
                        case FichaParceiroConstant.ID_PENDENCIAS_FIN:
                            $scope.codParc = self.pesqParceiro;
                            $scope.b2bmode = self.B2BMode;

                            painelComponent = AngularUtil.createDirective("sk-pendencias-financeiras" , {
                                "sk-on-created": "ctrl.onCreatedPendenciasFinanceiras(component)",
                                "sk-codparc":  $scope.codParc,
                                "sk-resource-id" : "ctrl.getApplicationResourceID()",
                                "sk-params-criterio": "ctrl.getParamsCriterio()",
                                "sk-b2bmode" : $scope.b2bmode,
                                "flex": "",
                                "sk-id-painel":self.uid
                            });

                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            ObjectUtils.setProperty(painel, "visibleBtnConfig", self.hasConfigAccess);
                            
                            break;
                        case FichaParceiroConstant.ID_GIRO_NEGOCIACOES:
                            $scope.codParc = self.pesqParceiro;
                            $scope.ehPedidoWeb = self.ehPedidoWeb;
                            $scope.b2bmode = self.B2BMode;

                            painelComponent = AngularUtil.createDirective("sk-giro-negociacoes", {
                                "sk-on-created": "ctrl.onCreatedGiroNegociacao(component)",
                                "sk-codparc":  $scope.codParc,
                                "sk-resource-id": "ctrl.getApplicationResourceID()",
                                "sk-params-criterio": "ctrl.getParamsCriterio()",
                                "eh-pedido-web" : $scope.ehPedidoWeb,
                                "sk-b2bmode" : $scope.b2bmode,
                                "sk-id-painel":self.uid,
                                "flex": ""
                            });
                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            ObjectUtils.setProperty(painel, "visibleBtnConfig", self.hasConfigAccess);
                            break;
                        case FichaParceiroConstant.ID_INDICADORES_DE_SISTEMA:

                            painelComponent = AngularUtil.createDirective("sk-indicadores", {
                                "sk-on-created": "ctrl.onCreatedIndicadores(component)",
                                "sk-codparc": "ctrl.pesqParceiro",
                                "sk-resource-id": getApplicationResourceID(),
                                "sk-params-criterio": "ctrl.getParamsCriterio()",
                                "sk-identificador-painel": painel.IDENTIFICADOR.toString(),
                                "sk-titulo-painel": painel.TITULO,
                                "sk-personalizado" : "false",
                                "flex": ""
                            });

                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            ObjectUtils.setProperty(painel, "visibleBtnConfig", self.hasConfigAccess);
                            break;
                        case FichaParceiroConstant.ID_CONSULTA_PRODUTOS:
                            painelComponent = AngularUtil.createDirective("sk-consulta-de-produtos", {
                                "sk-on-created": "ctrl.onCreatedConsultaProdutos(component)",
                                "sk-codparc": "ctrl.pesqParceiro",
                                "sk-resource-id": "ctrl.getApplicationResourceID()",
                                "sk-params-criterio": "ctrl.getParamsCriterio()",
                                "flex": ""
                            });

                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            ObjectUtils.setProperty(painel, "visibleBtnConfig", self.hasConfigAccess);
                            break;
                        case FichaParceiroConstant.ID_DADOS_PARCEIRO:
                            painelComponent = AngularUtil.createDirective("sk-dados-parceiro", {
                                "sk-on-created": "ctrl.onCreatedDadosParceiro(component)",
                                "sk-codparc": "ctrl.pesqParceiro",
                                "sk-resource-id": "ctrl.getApplicationResourceID()",
                                "sk-params-criterio": "ctrl.getParamsCriterio()",
                                "eh-consulta-produto": "false",
                                "flex": ""
                            });
                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            ObjectUtils.setProperty(painel, "visibleBtnConfig", self.hasConfigAccess);
                            break;
                        case FichaParceiroConstant.ID_INFORMACOES_SOBRE_CHAMADOS:
                            if (!painel.hasOwnProperty("NUGADGET") || painel.NUGADGET == ""){
                                painel.NUGADGET = "-40";
                            }

                            self.nuGadget = painel.NUGADGET;

                            painelComponent = AngularUtil.createDirective("sk-gadget-panel", {
                                "sk-on-created": "ctrl.onCreatedInformacoesChamado(component)",
                                "sk-nu-gdg": "ctrl.getNuGadget()",
                                "sk-prompt-params": "ctrl.getParamsCriterio()",
                                "flex": ""
                            });

                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            ObjectUtils.setProperty(painel, "visibleBtnConfig", false);
                            break;
                        case FichaParceiroConstant.ID_CONSULTA_EQUIFAX:
                                alertaDesativacaoEquifax();
                            break;
                        default : //Personalizados
                            if(painel.TIPO == "G"){
                                $scope.gadGet = painel.GADGET;
                                _idIndicadorGadgetPanel = painel.IDENTIFICADOR;

                                painelComponent = AngularUtil.createDirective("sk-gadget-panel", {
                                    "sk-on-created": "ctrl.onCreatedPainelPersonalizado(component, id)",
                                    "sk-nu-gdg": $scope.gadGet,
                                    "sk-control-load": true,
                                    "sk-identificador-painel": painel.IDENTIFICADOR.toString(),
                                    "sk-prompt-params": "ctrl.getParamsCriterio()",
                                    "flex": ""
                                });
                                ObjectUtils.setProperty(painel, "visibleBtnConfig", false);
                            }else{

                                painelComponent = AngularUtil.createDirective("sk-indicadores", {
                                    "sk-on-created": "ctrl.onCreatedIndicadoresPersonalizado(component, id)",
                                    "sk-codparc": "ctrl.pesqParceiro",
                                    "sk-resource-id": getApplicationResourceID(),
                                    "sk-params-criterio": "paramsCriterio",
                                    "sk-identificador-painel": painel.IDENTIFICADOR.toString(),
                                    "sk-titulo-painel": painel.TITULO,
                                    "sk-personalizado" : "ctrl.isIndicadorPersonalizado()",
                                    "flex": ""
                                });
                                ObjectUtils.setProperty(painel, "visibleBtnConfig", true);
                            }

                            ObjectUtils.setProperty(painel, "visibleBtnMaximize", true);
                            ObjectUtils.setProperty(painel, "visibleBtnRefresh", true);
                            break;
                    }

                    ObjectUtils.setProperty(painel, "identificador", painel.IDENTIFICADOR);
                    ObjectUtils.setProperty(painel, "title", painel.TITULO);
                    ObjectUtils.setProperty(painel, "content", painelComponent);
                    dashboarBuilder.push(painel);
                });

                return dashboarBuilder;
            }

            function aplicarFiltro(strDescr) {
                if (angular.isDefined(strDescr)) {
                    _codParcMatriz = strDescr.CODPARCMATRIZ;
                }

                var paramsCriterio = {};

                if (StringUtils.isNotEmpty(self.pesqParceiro)) {
                    paramsCriterio["CODPARC"] = self.pesqParceiro;
                }

                paramsCriterio["EXIBIRMATRIZ"] = "N";

                if (self.exibirPorMatriz == "S") {
                    paramsCriterio["EXIBIRMATRIZ"] = "S";

                    if (NumberUtils.getNumberOrZero(_codParcMatriz) == 0) {//caso o parceiro não tenha matriz, usa o próprio parceiro como matriz
                        paramsCriterio["CODPARCMATRIZ"] = self.pesqParceiro;
                    } else {
                        paramsCriterio["CODPARCMATRIZ"] = _codParcMatriz;
                    }
                } else if(paramsCriterio.hasOwnProperty("CODPARCMATRIZ")){
                    delete paramsCriterio["CODPARCMATRIZ"];
                }

                $scope.paramsCriterio = paramsCriterio;

                if(!self.embedded) {
                    let chave = getApplicationResourceID() + ".painelConfigs";
                    var arrayPaineis = [];

                    angular.forEach(self.paineisInfo, function(painelInfo, id) {
                        if (angular.isObject(painelInfo.colunas)) {
                            painelInfo.colunas = Object.keys(painelInfo.colunas).map(key => painelInfo.colunas[key])
                        }

                        angular.forEach(painelInfo.colunas, function (coluna, index) {
                            if(angular.isDefined(coluna.config)){
                                var width = ObjectUtils.getProperty(coluna, 'config.WIDTH');
                                var obj = {
                                    label : coluna.config.name,
                                    WIDTH : {$ : width}
                                }
                                arrayPaineis.push(obj);
                            }
                        });
                    });

                    let config = {
                        painel : arrayPaineis
                    };

                    SkApplicationInstance.saveMgeConfig(chave, config)
                        .then(function() {
                            SkApplicationInstance.putConfiguracaoTela(chave, config);
                        });
                }

                _dashBoardPanels.forEach((dashBoardView) => {
                    dashBoardView.api.setParamsCriterio(paramsCriterio);
                    dashBoardView.api.refresh();
                });
            }

            function alertaDesativacaoEquifax(){
                MessageUtils.showAlert(i18n('Comercial.FichaParceiro.messageDesativacaoEquifax'));
            }

            function usarEsteParceiro() {
                if(self.onSelectParceiro && StringUtils.isNotEmpty(self.pesqParceiro)) {
                    self.onSelectParceiro({codParc: self.pesqParceiro});
                }
            }

            function setCodParc(codParc) {
                self.pesqParceiro = codParc;
            }

            function isIndicadorPersonalizado(){
                return true;
            }

           function getNameIndicadores(){
                return FichaParceiroConstant.ID_INDICADORES_DE_SISTEMA;
            }

            function getNuGadget(){
                return self.nuGadget;
            }

            function setFocus() {
                if(self.pesquisaInputApi) {
                    self.pesquisaInputApi.setFocus();
                }
            }

            function carregaInfomacaoParceiro(item){             
                if(item){
                    exibeInfomacaoParceiro(ObjectUtils.getProperty(item,"fields"));
                }
            }

            function enableCodParc (value) {
                self.pesqParceiroEnabled = !value; 
            }
        }
    ]);

angular
	.module('snk.commons')
	.service('FichaParceiroService', ['StringUtils', 'ColorUtils',
		function (StringUtils, ColorUtils) {
			var self = this;

			self.buildObjectToStyle = buildObjectToStyle;
            self.getPropsXMLFromObj = getPropsXMLFromObj;
            self.converteObjectXMLToObject = converteObjectXMLToObject;
            self.converteObjectToObjectXML = converteObjectToObjectXML;
            self.converteArrayXMLToObject = converteArrayXMLToObject;
            self.createUuid = createUuid;

			function buildObjectToStyle(item) {
				let arr = [];

                if (angular.isDefined(item.COR)){
                    var cor = StringUtils.isNotEmpty(item.COR) ? ColorUtils.intToHex(item.COR) : "black";
                    arr.push("color: ".concat(cor));
                }

                if (angular.isDefined(item.FONTFAMILY)){
                    arr.push("font-family: " + item.FONTFAMILY);
                }

                if (angular.isDefined(item.FONTSIZE)){
                    arr.push("font-size: " + item.FONTSIZE + "px");
                }

                if (angular.isDefined(item.FONTWEIGHT)) {
                    arr.push("font-weight: " + item.FONTWEIGHT + "");
                }

                if (angular.isDefined(item.TEXTDECORATION)) {
                    arr.push("text-decoration: " + item.TEXTDECORATION + "");
                }

                if (angular.isDefined(item.FONTSTYLE)){
                    arr.push("font-style: " + item.FONTSTYLE + "");
                }

                arr.push("white-space: pre-line;");

                return arr.join(";");
			}

            function getPropsXMLFromObj(item, soPreenchido) {
                var xml = "";
                var keys = Object.keys(item);
                for (var zz = 0; zz < keys.length; zz++) {
                    var key = keys[zz];
    
                    if (soPreenchido != null && soPreenchido == true) {
                        if (item[key] == null || item[key].toString() == "") {
                            continue;
                        }
                    }
    
                    if (item[key] == null) {
                        xml += " " + key + "=\"\"";
                        continue;
                    }
    
                    if (typeof item[key] !== "object" && !Array.isArray(item[key])) {
    
                        if (item[key] != null && item[key] != undefined) {
                            xml += " " + key + "=\"" + item[key].toString() + "\"";
                        }
                    }
                }
                return xml;
            }

            function converteArrayXMLToObject(array) {
                var newArray = [];
                array.forEach(function(object) {
                    object = converteObjectXMLToObject(object);
                    newArray.push(object);
                });
                return newArray;
            }

            function converteObjectXMLToObject(item) {
                var saida = {};

                var keys = Object.keys(item);

                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    saida[key] = item[key].$;
                }

                return saida;
            }

            function converteObjectToObjectXML(item) {
                var saida = {};

                var keys = Object.keys(item);

                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    saida[key] = { $: item[key] }
                }
                return saida;
            }

            function createUuid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }
		}
    ]);

angular
    .module('snk.commons')
    .component('skGadgetPanel', {
        templateUrl: 'commons/fichaparceiro/GadgetPanel/GadgetPanel.tpl.html',
        controller: 'GadgetPanelController',
        controllerAs: 'ctrl',
        bindings: {
            onCreated: '&skOnCreated',
            nuGdg: '=?skNuGdg',
            promptParams: '=?skPromptParams',
            identificadorPainel: '@skIdentificadorPainel',
            controlLoad: '@skControlLoad',
        },  
    })
    .controller('GadgetPanelController', ['$scope', 'StringUtils', 'SkApplicationInstance','WhenReadyBuilder',
        function ($scope, StringUtils, SkApplicationInstance, WhenReadyBuilder) {
            var self = this;

            var _paramsCriterio;
            var _countReload = 0;
            var _refreshToken = 0;
            
            const maxReloadAttempts = 3;


            var whenRefreshReady = WhenReadyBuilder.$new();
            whenRefreshReady.notReady();

            self.refresh = refresh;
            self.onLoad = onLoad;
            self.setParamsCriterio = setParamsCriterio;

            init();

            $scope.$watch('nuGdg', function(newData){
                doRefresh();
            });

            function init() {
                if (self.onCreated) {
                    self.onCreated({component: self, id: self.identificadorPainel});
                }
                self.painelInformacoesVisible = true;
                self.refresh();
            }

            function onLoad() {
                whenRefreshReady.whenReady("refreshReady").then(() => {
                    searchPreloadGadget();
                });
            }

            function searchPreloadGadget() {
                try {
                    var painelElement = document?.getElementById(`gadgets-iframe-${self.nuGdg}`)?.contentDocument;
                    
                    setTimeout(() =>{
                        if (isGadgetLoaded(painelElement)) {
                            return;
                        } else if(_countReload >= maxReloadAttempts) {
                            return;
                        } else {
                            console.log("Reloading gadget " + self.nuGdg);
                            _countReload++;
                            painelElement?.location.reload(true);
                        }
                    }, 5000);
                } catch (error) {
                    console.error("Error on reloading: ", error);
                }
            }

            function setParamsCriterio(paramsCriterio){
                _paramsCriterio = paramsCriterio;
            }

            function refresh() {
                doRefresh();
            }

            function setPanelGadgetVisible(){
                if(StringUtils.isEmpty(_paramsCriterio?.CODPARC)){
					self.panelGadgetVisible = false;
				}
				
                self.panelGadgetVisible = true;
            }

            function setPanelInformacoesVisible(){
                if(StringUtils.isEmpty(_paramsCriterio?.CODPARC)){
					self.painelInformacoesVisible = true;
				}
				
                self.painelInformacoesVisible = false;
            }

            function doRefresh(){
                const resourceId = SkApplicationInstance.getResourceID() == "br.com.sankhya.FichaDeParceirosW" ? 
                    "br.com.sankhya.FichaDeParceirosW" : isVariacao(SkApplicationInstance.getResourceID());
                let src = "/mge/Dashboard.html5?resourceID=" + resourceId + "&nuGdg=" + self.nuGdg + "&appMode=true";

                if(self.controlLoad){
                    src += "&controlLoad=true";
                }

                if(_paramsCriterio){
                    let newParams = {
                        CODPARCMATRIZ : -1,
                        CODPARC : -1
                    };

                    for (let property in _paramsCriterio) {
                        if (_paramsCriterio.hasOwnProperty(property)) {
                            newParams[property] = _paramsCriterio[property];
                        }
                    }

                    if(Object.keys(newParams).length !== 0) {
                        src = src + "&parameters=" + encodeURIComponent(Base64.encodeToBinary(JSON.stringify(newParams)) );
                    }
                }

                src = src + "&refreshToken=" + (++_refreshToken);

                _countReload = 0;
                self.src = src;

                if(!_paramsCriterio?.CODPARC || StringUtils.isEmpty(self.src)) return;

                setPanelInformacoesVisible();
                setPanelGadgetVisible();
                whenRefreshReady.ready();
            }

            function isVariacao(resourceId){
                var regex = new RegExp(/(__+\d*.\d)$/);
                if(!regex.test(resourceId)){
                    return "br.com.sankhya.com.cons.fichaParceiro";
                }
                return resourceId;
            }

            
            function isGadgetLoaded(painelElement) {
                if (!painelElement) {
                    return false;
                }
                try {
                    var gadgetWindow = painelElement.defaultView;
                    var highchartsReady = !!(gadgetWindow && gadgetWindow.Highcharts);
                    return highchartsReady;
                } catch (error) {
                    return false;
                }
            }
        }
    ]);

angular
	.module('snk.commons')
	.component('skGiroNegociacoes', {
		templateUrl: 'commons/fichaparceiro/GiroNegociacoes/GiroNegociacoes.tpl.html',
		controller: 'GiroNegociacoesController as ctrl',
		bindings: {
			onCreated: '&skOnCreated',
			CODPARC: '=?skCodparc',
			resourceID: '=?skResourceId',
			ehPedidoWeb: '=?ehPedidoWeb',
			paramsCriterio: '=?skParamsCriterio',
			idPainel: '@skIdPainel'
		}
	})
	.controller('GiroNegociacoesController',
		['$scope', '$interval', 'ServiceProxy', 'i18n', 'MessageUtils', 'Criteria', 'NumberUtils', 'SanPopup', 'RentabilidadePopUpService','CentralNotaLauncher','SkApplicationInstance','StringUtils','ColorUtils',
			function ($scope,  $interval,  ServiceProxy, i18n, MessageUtils, Criteria, NumberUtils, SanPopup, RentabilidadePopUpService,CentralNotaLauncher,SkApplicationInstance, StringUtils, ColorUtils) {
				var self = this;

				// Variáveis
				var _paramsCriterio;
				var oldWidthGraph;
				var oldHeightGraph;
				self.showGraph = false;
				self.showConfig = false;
				self.showGrid = false;
				self.btnRentabilidade = false;
				self.btnOrdemCarga = true;
				self.enabledCheckNotas = true;
				self.enabledCheckDevolucoes = true;
				self.seletorNotasVisible = true;
				self.grupoPeriodo = "M";
				self.ID_GIRO_NEGOCIACOES = "GiroNegociacoes";
				// self.FIELD_QUANTIDADE = "quantidade";
				self.infoQtdNegociacoes;
				self.infoValorTotalNotas;
				self.infoQtdProdutos;
				self.infoQtdServicos;
				self.infoPeso;
				self.infoValorTotalItens;
				self.gridConfigDsNota = 'gridConfig.GiroNegociacoes.Notas:' + self.resourceID;
				self.gridConfigDsItemNota = 'gridConfig.GiroNegociacoes.ItensNota:' + self.resourceID;
				self.labelContMenor = "% " + i18n('Comercial.FichaParceiro.labelContMenor');
				self.ehGerenteEstoque;
				self.podeExibirRentabilidade;
				self.corPotencialCompra;
				self.infoPendenciasData;
				self.infoPendenciasCount;
				self.infoUltimaNegociacao;
				self.infoUltimaNegociacaoToolTip;
				self.infoMaiorNegociacaoData;
				self.infoMaiorNegociacaoToolTip;
				self.infoMaiorNegociacaoStr;
				self.infoTotalData;
				self.infoTotalCount;
				self.infoCabecalhoNegociacoes;

				self.graphStyle = {};
				
				self.uid =self.idPainel;				
				self.giroNegociacaoPanelId="GiroNegociacoesPanel"+ self.uid;
				self.graficoGiroNeg ="graficoGiroNeg"+self.uid;

				// Funções
				self.refresh = refresh;
				self.openConfig = config;
				self.setParamsCriterio = setParamsCriterio;
				self.getDataToGraph = getDataToGraph;
				self.createChartColumn = createChartColumn;
				self.linkInfoSelecionado = linkInfoSelecionado;
				self.voltarGrid = voltarGrid;
				self.barraSelecionada = barraSelecionada;
				self.marcarDesmarcarTodos = marcarDesmarcarTodos;
				self.carregarConfig = carregarConfig;
				self.confirmarRestauracao = confirmarRestauracao;
				self.config = config;
				self.salvarConfig = salvarConfig;
				self.abrirPopUpRentabilidade = abrirPopUpRentabilidade;
				self.abrirPopUpOrdemCarga = abrirPopUpOrdemCarga;
				self.onDatasetCreated = onDatasetCreated;
				self.populateNotas = populateNotas;
				self.changeSeletorNotas = changeSeletorNotas;
				self.validateBtnRentabilidade = validateBtnRentabilidade;
				self.changeResizePanel = changeResizePanel;
				self.abrirNotaPedito=abrirNotaPedito;
				self.abrirTelaProdutoServico=abrirTelaProdutoServico;
				self.changeTipoGrafico = changeTipoGrafico;
				self.beforeRefreshActionDsItemNota = beforeRefreshActionDsItemNota;
				self.restaurarConfiguracoes;

				// Combobox
				self.mostrarGraficoOpcoes = [
					{ value: i18n('Comercial.FichaParceiro.headerValor'), data: "V" },
					{ value: i18n('Comercial.FichaParceiro.labelQuantidade'), data: "Q" },
				];

				self.modoInicialOpcoes = [
					{ value: i18n('Comercial.FichaParceiro.modoInicialChart'), data: "CHART" },
					{ value: i18n('Comercial.FichaParceiro.modoInicialGrade'), data: "GRADE" },
				];

				self.seletorNotasOpcoes = [
					{ value: i18n('Comercial.FichaParceiro.lblTodas'), data: "T" },
					{ value: i18n('Comercial.FichaParceiro.labelPendentes'), data: "P" },
					{ value: i18n('Comercial.FichaParceiro.labelUltimaNegociacao'), data: "U" },
					{ value: i18n('Comercial.FichaParceiro.labelMaiorNegociacao'), data: "M" },
				];

				self.listaSelecionados = [];

				init();

				function init() {
					if (self.onCreated) {
						self.onCreated({component: self});
					}
				}

				function onDatasetCreated(dataset) {
					if(dataset.getEntityName() == "CabecalhoNota") {
						self.dsNota = dataset;

						let observerNota = new IDataSetObserver();

						observerNota.currentLineChanged = function () {
							let vlrTot = 0;
							
							for (let nota of self.dsNota.getRecordsAsObjects()){
								let vlrNota = nota.VLRNOTA;
								
								if(nota.TIPMOV == "D"){
									vlrNota *= -1;
								}
								
								vlrTot += vlrNota - NumberUtils.getNumberOrZero(Number(nota.VLRDESCTOT));
							}

							self.infoValorTotalNotas = NumberUtils.format(vlrTot, 2);
							self.infoQtdNegociacoes = self.dsNota.size();

							validateBtnRentabilidade();

							if (self.dsItemNota) {
								self.dsItemNota.refresh();
							}
						};

						self.dsNota.addObserver(observerNota);

					} else if(dataset.getEntityName() == "ItemNota") {
						self.dsItemNota = dataset;
						self.dsItemNota.addCriteriaProvider(getCriteria);

						let observerItemNota = new IDataSetObserver();

						observerItemNota.currentLineChanged = function () {
							let vlrTotal = 0;
							let pesoTotal = 0;
							let qtdServicos = 0;
							let qtdProdutos = 0;
							
							for (let item of self.dsItemNota.getRecordsAsObjects()){
								vlrTotal += Number(item.VLRTOT);
								
								let pesoBruto = item["Produto.PESOBRUTO"];
								
								if(NumberUtils.getNumberOrZero(pesoBruto) != 0){
									pesoTotal += pesoBruto * item["QTDNEG"]
								}
								
								if("S" == item["Produto.USOPROD"]) {
									qtdServicos += 1;
								} else {
									qtdProdutos += 1;
								}
							}

							self.infoPeso = NumberUtils.format(pesoTotal, 2);
							self.infoQtdServicos = qtdServicos;
							self.infoQtdProdutos = qtdProdutos;
							self.infoValorTotalItens = NumberUtils.format(vlrTotal, 2);
						};

						self.dsItemNota.addObserver(observerItemNota);
					}

					dataset.init();
				}

				function validateBtnRentabilidade() {
					if(self.dsNota.getCurrentRow() != null){
						self.btnRentabilidade = self.ehGerenteEstoque && "P-V".indexOf(self.dsNota.getFieldValueAsString("TIPMOV")) > -1;
					}else{
						self.btnRentabilidade = false;
					}
				}

				function abrirPopUpRentabilidade(){
					if(self.dsNota?.getCurrentRowAsObject()?.NUNOTA != null){
						let nuNota = self.dsNota.getCurrentRowAsObject().NUNOTA;
						RentabilidadePopUpService.openPopUp(nuNota, 0);
					} 
				}

				function abrirPopUpOrdemCarga() {
					let codEmp = Number(self.dsNota.getFieldValue("Empresa.EmpresaFinanceiro.CODEMPOC"));
					
					if (isNaN(codEmp) || codEmp == 0){
						codEmp = Number(self.dsNota.getFieldValue("CODEMP"));
					}

					SanPopup.open({
						title: i18n('Comercial.FichaParceiro.lblOrdemCarga'),
						templateUrl: 'commons/fichaparceiro/OrdemCargaPopUp/OrdemCargaPopUp.tpl.html',
						controller: 'OrdemCargaPopUpController',
						controllerAs: 'ctrl',
						size: 'lg',
						showBtnCancel: true,
						showBtnOk: false,
						showBtnNo: false,
						okBtnLabel: i18n('Comercial.FichaParceiro.lblSelecionar'),
						cancelBtnLabel: i18n('Comercial.FichaParceiro.lblCancelar'),
						resolve: {
							pkOdemCarga: {
								CODEMP: codEmp, 
								ORDEMCARGA: self.dsNota.getFieldValue("ORDEMCARGA")
							}
						}
					})
				}

				function marcarDesmarcarTodos(selecionado) {
					self.listaSelecionados.forEach((item) => {
						item.selecionado = selecionado;
					})
				}

				function setParamsCriterio(paramsCriterio){
					_paramsCriterio = paramsCriterio;
				}

				function confirmarRestauracao() {
					MessageUtils.simpleConfirm(
						MessageUtils.TITLE_CONFIRMATION,
						i18n('Comercial.FichaParceiro.messagePerderConfigAoRestaurar'))
					.then(() => { 
						self.restaurarConfiguracoes = true;
						carregarConfig("true");
					});
				}

				function config() {
					if (self.faceGiroIndicadoresIndex == 0) {
						self.faceGiroIndicadoresIndex = 1;
						carregarConfig();
					} else {
						self.faceGiroIndicadoresIndex = 0;
					}
				}

				function salvarConfig() {
					let xml = '<configuracao>';
					xml += `<potencialCompra exibe="${self.checkExibePotencial}" cor="${parseInt(self.corPotencial, 16)}"/>`;

					xml += `<notas>${self.checkNotas}</notas>`;
					xml += `<pedidos>${self.checkPedidos}</pedidos>`;
					xml += `<periodoFechado>${self.checkExibePeriodoFechado}</periodoFechado>`;
					xml += `<qtdPeriodo>${self.stepperUndPeriodo}</qtdPeriodo>`;
					xml += `<tipoPeriodo>${self.grupoPeriodo}</tipoPeriodo>`;
					xml += `<devolucoes>${self.checkDevolucoes}</devolucoes>`;
					xml += `<tipoGrafico>${self.comboTipoGraf}</tipoGrafico>`;
					xml += `<modoInicial>${self.comboModoInicial}</modoInicial>`;

					xml += '<rentabilidade>';

					if(self.percMenorIgual) {
						xml += `<menorIgual valor="${Number(self.percMenorIgual)}" cor="${parseInt(self.corMenorIgual, 16)}"/>`;
					}

					if(self.percMaior && self.percMenor) {
						xml += `<foraDosValores valor1="${Number(self.percMaior)}" valor2="${Number(self.percMenor)}" cor="${parseInt(self.corMaiorMenor, 16)}"/>`;
					}

					if(self.percMaiorIgual) {
						xml += `<maiorIgual valor="${Number(self.percMaiorIgual)}" cor="${parseInt(self.corMaiorIgual, 16)}"/>`;
					}

					xml += '</rentabilidade>';

					if (self.listaSelecionados != null) {
						xml += '<gruposTops>';

						for(let lista of self.listaSelecionados) {
							if(lista.selecionado == 'S'){
								xml += `<grupoTop>${lista.label}</grupoTop>`;
							}
						}

						xml += '</gruposTops>';
					}
					xml += '</configuracao>';

					let body = {};
					body.configuracao = { $: xml, resourceID: self.resourceID };
					body.resourceID = self.resourceID;

					ServiceProxy.callService(
						"mgecom@FichaParceiroSP.salvarConfigGiroNegociacoes",
						body)
					.then(() => {
						config();
						self.refresh();
					})
				}

				function carregarConfig(restaurarConfig = "false") {
					let criterio = {
						restaurarConfig: restaurarConfig,
						resourceID: self.resourceID
					};

					ServiceProxy.callService(
						"mgecom@FichaParceiroSP.getConfigGiroNegociacoes", { criterio })
						.then((response) => {
							let resp = response?.responseBody;
							let configuracao = resp?.configuracao;
							let dpGruposTops = resp?.gruposTops?.grupoTop;
							let dpSelectedGruposTops = angular.isArray(resp?.configuracao?.gruposTops.grupoTop) ? resp?.configuracao?.gruposTops?.grupoTop : [resp?.configuracao?.gruposTops?.grupoTop];
							let selecteds = [];

							if(angular.isDefined(dpSelectedGruposTops[0])){
								for(let selected of dpSelectedGruposTops) {
									selecteds.push(selected.$);
								}
							}

							dpGruposTops = Array.isArray(dpGruposTops) ? dpGruposTops : [dpGruposTops];

							self.listaSelecionados = [];

							dpGruposTops.forEach((item) => {
								self.listaSelecionados.push({
									label: item.label,
									selecionado: selecteds.includes(item.label) ? "S" : "N"
								})
							})

							if(!configuracao) return;

							limparConfig();

							self.grupoPeriodo = configuracao?.tipoPeriodo?.$;

							if($scope.ehPedidoWeb){
								self.checkNotas = "N";
								self.enabledCheckNotas = false;
								self.checkDevolucoes = "N";
								self.enabledCheckDevolucoes = false;
							} else {
								self.checkNotas = configuracao?.notas?.$;
								self.checkDevolucoes = configuracao?.devolucoes?.$;
							}

							self.checkPedidos = configuracao?.pedidos?.$;
							self.stepperUndPeriodo = Number(configuracao?.qtdPeriodo?.$);
							self.checkExibePeriodoFechado = configuracao?.periodoFechado?.$;

							if(angular.isUndefined(self.restaurarConfiguracoes)){	
								self.checkExibePotencial = configuracao?.potencialCompra?.exibe;
							} else {
								self.restaurarConfiguracoes = undefined;
							}

							self.corPotencial = configuracao?.potencialCompra?.cor;

							self.percMenorIgual = configuracao?.rentabilidade?.menorIgual?.valor;
							self.corMenorIgual = configuracao?.rentabilidade?.menorIgual?.cor;

							self.percMaior = configuracao?.rentabilidade?.foraDosValores?.valor1;
							self.percMenor = configuracao?.rentabilidade?.foraDosValores?.valor2;
							self.corMaiorMenor = configuracao?.rentabilidade?.foraDosValores?.cor;

							if(configuracao?.tipoGrafico?.$ == "V"){
								self.comboTipoGraf = "V";
							} else {
								self.comboTipoGraf = "Q";
							}

							changeTipoGrafico();
							
							if(configuracao?.modoInicial?.$ == "GRADE"){
								self.comboModoInicial = "GRADE";
							} else {
								self.comboModoInicial = "CHART";
							}
							
							self.percMaiorIgual = configuracao?.rentabilidade?.maiorIgual?.valor;
							self.corMaiorIgual = configuracao?.rentabilidade?.maiorIgual?.cor;

						})
				}

				function limparConfig() {
					self.grupoPeriodo = "M";
					self.checkNotas = "N";
					self.checkPedidos = "N";
					self.checkDevolucoes = "N";
					self.stepperUndPeriodo = 1;
					
					self.checkExibePotencial = "N";
					self.corPotencial = 0;
					
					self.percMenorIgual = "";
					self.corMenorIgual = 0;
					
					self.percMaior = "";
					self.percMenor = "";
					self.corMaiorMenor = 0;
					
					self.percMaiorIgual = "";
					self.corMaiorIgual = 0;
					
					self.comboTipoGraf = "V";

					changeTipoGrafico();
					
					self.comboModoInicial = "CHART";
				}

				function changeTipoGrafico() {
					self.checkExibePotencialCompraEnabled = (self.comboTipoGraf == "V");
					
					if(!self.checkExibePotencialCompraEnabled){
						self.checkExibePotencial = "N";
					}
				}

				function getDataToGraph(itens, coluna) {
					let data = [];

					if (coluna == null) {
						coluna = 'totalNegociado';
					}

					for (let i = 0; i < itens.length; i++) {
						let item = itens[i];
						let obj_value = item[coluna];
						let c = NumberUtils.stringToNumber(item.cor.$);

						let r = Math.floor(c / (256 * 256));
						let g = Math.floor(c / 256) % 256;
						let b = c % 256;

						let newY;

						if(self.comboTipoGraf == "Q") {
							newY = parseFloat(obj_value.$);
						} else {
							newY = parseFloat(item.totalNegociado.$);
						}

						item.totalNegociado.$ = NumberUtils.format(item.totalNegociado.$, 2);
						item.perRentab.$ = NumberUtils.format(item.perRentab.$, 2);

						data.push({
							name: item.descricao.$.toString(),
							y: newY,
							data: item,
							color: `rgba(${r},${g},${b},1)`
						});

					}

					return data;
				}

				function populateNotas(notas) {
					let aNotas = [];

					notas = Array.isArray(notas) ? notas : angular.isDefined(notas) ? [notas] : [];

					for(let nota of notas) {
						aNotas.push(nota?.nuNota);
					}

					if(aNotas != null && aNotas.length > 0) {
						let notas = "( "
						for(let aNota of aNotas) {
							notas += aNota + ","
						}
						notas = notas.slice(0, -1);
						notas += " ) ";

						if(self.ehPedidoWeb) {
							self.dsNota.refresh(Criteria("this.NUNOTA IN " + notas + " AND this.TIPMOV = 'P' "));
						} else {
							self.dsNota.refresh(Criteria("this.NUNOTA IN " + notas));
						}
					} else {
						self.dsNota.refresh(Criteria("1 = 0"));
						zerarRodaPe();
					}

				}

				function zerarRodaPe() {
					self.infoPeso = "0,00";
					self.infoQtdServicos = "0";
					self.infoQtdProdutos = "0";
					self.infoValorTotalItens = "0,00";
				}

				function changeSeletorNotas() {
					self.seletorNotasVisible = true;
					let selectedItem = self.seletorNotas;
					let labelCabecalhoNegociacoes = i18n('Comercial.FichaParceiro.labelNegociacoes') + " ( " ;
					
					switch(selectedItem) {
						case "T" :
							populateNotas(self.infoTotalData);
							labelCabecalhoNegociacoes += i18n('Comercial.FichaParceiro.labelTodas');
							break;
						case "P":
							populateNotas(self.infoPendenciasData);
							labelCabecalhoNegociacoes += i18n('Comercial.FichaParceiro.labelPendentes');
							break;
						case "U":
							populateNotas(self.infoUltimaNegociacaoData);
							labelCabecalhoNegociacoes += i18n('Comercial.FichaParceiro.labelUltimaNegociacao');
							break;
						case "M":
							populateNotas(self.infoMaiorNegociacaoData);
							labelCabecalhoNegociacoes += i18n('Comercial.FichaParceiro.labelMaiorNegociacao');
							break;
					}
					self.infoCabecalhoNegociacoes = labelCabecalhoNegociacoes + " ) ";
				}

				function linkInfoSelecionado(id) {
					let labelNegociacoes = " ( ";

					self.seletorNotasVisible = true;

					if (id == "infoPendencias") {
						self.seletorNotas = "P";
						labelNegociacoes += i18n('Comercial.FichaParceiro.labelPendentes');
						populateNotas(self.infoPendenciasData);
					} else if (id == "infoUltimaNegociacao") {
						self.seletorNotas = "U";
						labelNegociacoes += i18n('Comercial.FichaParceiro.labelUltimaNegociacao');
						populateNotas(self.infoUltimaNegociacaoData);
					} else if (id == "infoMaiorNegociacao") {
						self.seletorNotas = "M";
						labelNegociacoes += i18n('Comercial.FichaParceiro.labelMaiorNegociacao');
						populateNotas(self.infoMaiorNegociacaoData);
					} else if (id == "infoTotal") {
						self.seletorNotas = "T";
						populateNotas(self.infoTotalData);
						labelNegociacoes += i18n('Comercial.FichaParceiro.labelTodas');
					}

					labelNegociacoes += " ) ";

					self.infoCabecalhoNegociacoes = i18n('Comercial.FichaParceiro.labelNegociacoes') + labelNegociacoes;
					self.showGrid = true;
				}

				function barraSelecionada(event) {
					let data = event.point.data;
					
					if(angular.isUndefined(data)){
						return;
					}

					let notas = data.notas.nota;				

					self.seletorNotasVisible = false;
					self.seletorNotas = "T";
	
					if(Object.keys(notas).length > 0) {
						self.infoCabecalhoNegociacoes = i18n('Comercial.FichaParceiro.labelNegociacoes') 
						+ ` ( ${data.descricao.$} - ${data.dtInicial.$} ${i18n('Controls.DateTime.labelSeparadorPeriodo')} ${data.dtFinal.$} ) `;
						populateNotas(notas);
					} else {
						self.infoQtdNegociacoes = "0";
						self.infoValorTotalNotas = "0,00";
					}

					self.showGrid = true;
				}

				function voltarGrid() {
					self.showGrid = !self.showGrid;
				}

				function changeResizePanel() {
					let panelWidth = Number(angular.element("#"+self.giroNegociacaoPanelId).css('width').replace("px", "")) - 20;
					let panelHeight = Number(angular.element("#"+self.giroNegociacaoPanelId).css('height').replace("px", "")) - 120;

					if (self.chart != null && angular.isDefined(self.chart.animation)) {
						self.chart.setSize(panelWidth, panelHeight, true);
					}
				}

				function createChartColumn(id_element, colunaYTitle, category_name, data, fn_onclick, tipo) {
					Highcharts.setOptions({
						lang: {
							thousandsSep: '.',
							decimalPoint: ','
						}
					});
				
					let arrayValorPotencial = [];
					data.forEach(element => {
						var dataLabel = null;
						dataLabel = { enabled: false, text: '' };
						arrayValorPotencial.push({ y: NumberUtils.stringToNumber(element?.data?.potencial?.$), dataLabels: dataLabel });
					});

					let format = 
						"<b>" + i18n("Comercial.FichaParceiro.labelNegociado") + "</b>" + ": " + i18n("Comercial.FichaParceiro.labelCurrency")  
						+ "{point.data.totalNegociado.$}<br>"
						+ "<b>" + i18n("Comercial.FichaParceiro.labelQuantidade") + "</b>" + ": " + "{point.data.quantidade.$}<br>"
						+ "<b>{point.data.descricao.$}</b>" + ": " + "{point.data.dtInicial.$} a {point.data.dtFinal.$}<br>";
					
					if(self.podeExibirRentabilidade) {
						format += "<b>" + i18n("Comercial.FichaParceiro.labelRentabilidade") + "</b>" + ": " + "{point.data.perRentab.$}%";
					}

					// if (tipo != null && tipo == "V") {
					// 	format = i18n('Comercial.FichaParceiro.labelCurrency') + ' <b>{point.y}</b>';
					// }

					let objColumnChart ={						
						title: {
							text: null
						},
						accessibility: {
							announceNewData: {
								enabled: true
							}
						},
						xAxis: {
							type: 'category'
						},
						yAxis: {
							title: {
								text: colunaYTitle
							},
							labels: {
								formatter: function () {
									return Highcharts.numberFormat(this.value, 2);
								}
							}
						},
						legend: {
							enabled: false
						},
						plotOptions: {
							series: {
								borderWidth: 0,
								dataLabels: {
									enabled: true
								},
								events: {
									click: function (event) {
										if (fn_onclick != null) {
											fn_onclick(event, id_element);
										}
									}
								}
							}
						},
						series: [
							{
								type: 'column',
								name: category_name,
								data: data,
								tooltip: {
									headerFormat: "",
									pointFormat: format
								},
							}
						]
					}

					if(self.checkExibePotencial=='S' || self.corPotencialCompra){
						objColumnChart.series.push({
							type: 'line',
							marker: {
								enabled: false
							  },
					        lineWidth:5,								
							color:ColorUtils.decimalToHex(self.corPotencialCompra),	
							data: arrayValorPotencial								
						})						
					}
					self.chart = Highcharts.chart(id_element, objColumnChart );
				}

				function refresh() {
					if(!_paramsCriterio) {
						return;
					}
					
					let paramsCriterio = _paramsCriterio;

					let body = { criterio: { resourceID: self.resourceID } }

					let keys = Object.keys(paramsCriterio);

					keys.forEach(function (key, index) {
						body.criterio[key] = paramsCriterio[key];
					});

					oldWidthGraph = document.getElementById(self.giroNegociacaoPanelId)?.clientWidth;
					oldHeightGraph = document.getElementById(self.giroNegociacaoPanelId)?.clientHeight;

					ServiceProxy.callService("mgecom@FichaParceiroSP.getGiroNegociacoes", body)
					.then((response) => {
						if (!response?.responseBody?.periodos?.periodo?.length > 0) {
							return;
						}

						self.ehGerenteEstoque = response?.responseBody?.ehGerenteEstoque?.$.toString() == "true";
						self.podeExibirRentabilidade = response?.responseBody?.podeExibirRentabilidade?.$.toString() == "true";

						self.corPotencialCompra = response?.responseBody?.corPotencialCompra?.$.toString();

						let notasPendentes = response?.responseBody?.notasPendentes?.notaPendente;

						let qtdNotas;

						if (notasPendentes) {
							qtdNotas = 0;

							if (!Array.isArray(notasPendentes)) {
								notasPendentes = [notasPendentes];
							}

							qtdNotas = notasPendentes.length;

							self.infoPendenciasData = notasPendentes;
							self.infoPendenciasCount = notasPendentes.length;
						} else {
							self.infoPendenciasCount = 0;
						}

						let ultimaNotaNegociada = response?.responseBody?.ultimaNotaNegociada;
						let strVlrNota = "0,00";
						let strDtNeg = "";

						if (ultimaNotaNegociada) {
							self.infoUltimaNegociacaoData = ultimaNotaNegociada;
							strDtNeg = ultimaNotaNegociada.dtNeg;
							strVlrNota = NumberUtils.format(ultimaNotaNegociada.vlrNota, 2);
							self.infoUltimaNegociacao = strDtNeg;
							self.infoUltimaNegociacaoToolTip = i18n('Comercial.FichaParceiro.labelUltimaNegociacaoTooltip', ["R$ " + strVlrNota, strDtNeg]);
						}						

						let maiorNotaNegociada = response.responseBody.maiorNotaNegociada;

						strVlrNota = "0,00";
						strDtNeg = "";

						if (maiorNotaNegociada) {
							strVlrNota = NumberUtils.format(maiorNotaNegociada.vlrNota, 2);
							if (parseFloat(maiorNotaNegociada.vlrNota) == NaN) {
								strVlrNota = "0,00";
							}
							strDtNeg = maiorNotaNegociada.dtNeg;
							self.infoMaiorNegociacaoData = maiorNotaNegociada;
							self.infoMaiorNegociacaoToolTip = i18n('Comercial.FichaParceiro.labelMaiorNegociacaoTooltip', ["R$ " + strVlrNota, strDtNeg]);
						}

						if (!strVlrNota || strVlrNota?.toString() == "NaN") {
							strVlrNota = "0,00";
						}

						self.infoMaiorNegociacaoStr = "R$ " + strVlrNota;

						let infoTotalNotas = response?.responseBody?.totalNotas?.nota

						if (infoTotalNotas) {
							self.infoTotalCount = angular.isDefined(infoTotalNotas.length) ? infoTotalNotas.length : 0;
							self.infoTotalData = infoTotalNotas;
						} else {
							self.infoTotalCount = 0;
							self.infoTotalData = [];
						}

						if (response?.responseBody?.modoInicial?.$?.toString() == "GRADE") {
							self.showGrid = true;
							self.seletorNotas = "T";
							self.changeSeletorNotas();
						} else {
							self.showGrid = false;
						}

						if(_paramsCriterio.CODPARC) {
							self.showGraph = true;
						} else {
							self.showGraph = false;
						}

						// Gráfico

						let nomeColuna = "quantidade";
						let tipoGrafico = "Q";
						let tituloGrafico = i18n('Comercial.FichaParceiro.lblQtdNeg');

						if (response?.responseBody?.tipoGrafico?.$ == "V") {
							self.mostrarGrafico = "V";
							nomeColuna = "totalNegociado";
							tipoGrafico = response.responseBody.tipoGrafico.$.toString();
							tituloGrafico = i18n('Comercial.FichaParceiro.labelValoresNegociados') + " (" +
								i18n('Comercial.FichaParceiro.labelCurrency') + ")";
						}

						let dataGraph = self.getDataToGraph(response.responseBody.periodos.periodo, nomeColuna);
						self.graph_view = "grafColumnPendencias";
						if(document.getElementById(self.graficoGiroNeg)){
							self.createChartColumn(self.graficoGiroNeg, tituloGrafico,
								"category", dataGraph, self.barraSelecionada, tipoGrafico);
	
							changeResizePanel();
						}
						
					})	

				}

				function abrirNotaPedito(){
					if(self.dsNota.getCurrentRow() != null){				
						var objPK={};
						objPK.NUNOTA = self.dsNota.getFieldValueAsString("NUNOTA");
						objPK.ehPedidoW = $scope.ehPedidoWeb;
						CentralNotaLauncher.launch(objPK);
					}
	
				}

				function abrirTelaProdutoServico(){
					if(self.dsItemNota.getCurrentRow() != null){
						var pkObject = {};
						
						pkObject.CODPROD = self.dsItemNota.getFieldValueAsString("CODPROD");
						
						if("S" == self.dsItemNota.getFieldValueAsString("USOPROD")){
							SkApplicationInstance.openApp('br.com.sankhya.core.cad.servicos', pkObject);
						}else{
							SkApplicationInstance.openApp('br.com.sankhya.core.cad.produtos', pkObject);
						}
					}
				}

				function beforeRefreshActionDsItemNota() {
					let nuNota = self.dsNota.getFieldValueAsNumberOrZero('NUNOTA');
					return nuNota > 0;
				}

				function getCriteria() {
					let nunota = self.dsNota.getFieldValue("NUNOTA");
					let criteria = Criteria();
					if (nunota && nunota > 0) {
						criteria.append('this.NUNOTA = ?');
						criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, nunota));
					} else {
						criteria.append('1=0');
					}
					return criteria;
				}

			}

		]);

angular
    .module('snk.commons')
    .component('skIndicadores', {
        templateUrl: 'commons/fichaparceiro/Indicadores/Indicadores.tpl.html',
        controller: 'IndicadoresController',
        controllerAs: 'ctrl',
        bindings: {
            onCreated: '&skOnCreated',
            codParc: '=?skCodparc',
            resourceID: '@skResourceId',
            paramsCriterio: '=?skParamsCriterio',
            identificadorPainel: '@skIdentificadorPainel',
            tituloPainel: '@skTituloPainel',
            personalizado: '=?skPersonalizado',
        }
    })
    .controller('IndicadoresController', ['$scope', 'ServiceProxy', 'i18n', 'NumberUtils', 'ObjectUtils', 'AngularUtil', 'SkApplicationInstance', 'ArrayUtils', 'StringUtils', 'WhenReady', 'FichaParceiroService', 'MGEParameters', 'SkApplication', 'DateUtils',
        function ($scope, ServiceProxy, i18n, NumberUtils, ObjectUtils, AngularUtil, SkApplicationInstance, ArrayUtils, StringUtils, WhenReady, FichaParceiroService, MGEParameters, SkApplication, DateUtils) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);

            self.refresh = refresh;
            self.setParamsCriterio = setParamsCriterio;
            self.onClickIndicador = onClickIndicador;
            self.buildIndicador = buildIndicador;
            self.mostrarFinSelecionado = mostrarFinSelecionado;
            self.mostrarDetalhesFinanceiros = mostrarDetalhesFinanceiros;
            self.onDataGridLoaded = onDataGridLoaded;
            self.openConfig = openConfig;
            self.onCreatedDetalhesLimiteCredito = onCreatedDetalhesLimiteCredito;
            self.onClikMudarFaceIndicadores = onClikMudarFaceIndicadores;
            self.onCreatedDetalhesPontualidade = onCreatedDetalhesPontualidade;
            self.onCreatedDetalhesUltimoContato = onCreatedDetalhesUltimoContato;
            self.onCreatedDetalhesRenegociacao = onCreatedDetalhesRenegociacao;
            self.onDatasetDetalhesFinanceiros = onDatasetDetalhesFinanceiros;
            self.refreshHandlerDetalhesFinanceiros = refreshHandlerDetalhesFinanceiros;
            self.buildLabelTipoMovimentacao = buildLabelTipoMovimentacao;
            self.buildLabelEmpresa = buildLabelEmpresa;
            self.buildLabelTipoTitulo = buildLabelTipoTitulo;
            self.buildLabelNatureza = buildLabelNatureza;
            self.configuracaoFinalizada = configuracaoFinalizada;
            self.openRelatorioDoubleClick = openRelatorioDoubleClick;
            self.onDatagridLoadeIndicadores = onDatagridLoadeIndicadores;
            self.habilitaAbaVendaMais = MGEParameters.asBoolean('fin.habilitar.servico.venda.mais');

            self.faceIndicadoresIndex = 0;
            self.visibleFormIndicadores = false;
            self.indicadores = [];
            self.codParc = self.codParc;
            self.visibleFieldSetPlanilha = false;

            let _paramsCriterio = {};
            var _dsLimiteCreditoReady = WhenReady();
            var _dsPontualidadeReady = WhenReady();
            var _dsUltimoContatoReady = WhenReady();
            var _dsRenegociacaoReady = WhenReady();
            var _dataFinanceiros;
            self._eventBus = new EventBus();

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({ component: self , id : self.identificadorPainel});
                }

                setTimeout(() => {
                    refresh();
                }, 200);
            }

            function onCreatedDetalhesLimiteCredito(component){
                self.detalhesLimiteCredito = component;
                _dsLimiteCreditoReady.ready();   
            }

            function onCreatedDetalhesPontualidade(component){
                self.detalhesPontualidade = component;
                _dsPontualidadeReady.ready();   
            }

            function onCreatedDetalhesUltimoContato(component){
                self.detalhesUltimoContato = component;
                _dsUltimoContatoReady.ready();    
            }

            function onCreatedDetalhesRenegociacao(component){
                self.detalhesRenegociacao  = component;
                _dsRenegociacaoReady.ready();
            }

            function onDatagridLoadeIndicadores(datagrid){
                self.datagridIndicadoresPlanilha =  datagrid;
            }

            function setParamsCriterio(paramsCriterio) {
                _paramsCriterio = paramsCriterio;
            }

            function refresh() {
                var params = { criterio: {} };
                
                self._eventBus.dispatchEvent('eventoIndicadoresToVendaMais', self.codParc);

				
                if (!ObjectUtils.isEmpty(_paramsCriterio)) {
                    var paramsCriterio = _paramsCriterio;

                    var keys = Object.keys(paramsCriterio);

                    keys.forEach(function (key, index) {
                        params.criterio[key] = paramsCriterio[key];

                    });
                }

                if(StringUtils.isNotEmpty(self.identificadorPainel) && StringUtils.isNotEmpty(self.resourceID) && !ObjectUtils.isEmpty(_paramsCriterio)){
                    params.criterio["IDENTIFICADOR"] = self.identificadorPainel + ":" + self.resourceID;
                }

                if(StringUtils.isNotEmpty(self.personalizado)){
                    params.criterio["PERSONALIZADO"] = self.personalizado;
                }

                if (!ObjectUtils.isEmpty(params.criterio) && (angular.isDefined(params.criterio.EXIBIRMATRIZ) || angular.isDefined(params.criterio.EXIBIR)) && angular.isDefined(params.criterio.IDENTIFICADOR)) {
                    ServiceProxy.callService("mgecom@FichaParceiroSP.getIndicadores", params)
                        .then(function (response) {

                            if (angular.isDefined(response.responseBody.indicadores)) {
                                var indicadores = ArrayUtils.toArray(response.responseBody.indicadores.indicador);
                                var formIndicadores = [];

                                indicadores.forEach(function (indicador) {
                                    if(indicador.TIPO.$ == "P"){
                                        buildIndicadorPlanilha(indicador);
                                        ObjectUtils.setProperty(indicador, "DADOS", self.dataGridPlanilha);
                                        formIndicadores.push(indicador);
                                    }else{
                                        var properties = buildIndicador(indicador);
                                        ObjectUtils.setProperty(indicador, 'VALOR', properties.value);
                                        ObjectUtils.setProperty(indicador, 'TOOLTIP', properties.tooltip);
                                        formIndicadores.push(indicador);
                                    }
                                });

                                self.visibleFormIndicadores = true;
                                self.indicadores = formIndicadores;
                            }
                            self.faceIndicadoresIndex = 0;
                        });
                }
            }

            function onClikMudarFaceIndicadores(){
                self.faceIndicadoresIndex = 0;
            }
            
            function buildIndicador(indicador, isOnclickButton) {
                var coluna = null;
                var tipo = null;
                var indice = null;

                if (angular.isUndefined(indicador)) {
                    return undefined;
                }

                if (indicador.TIPO == null) {
                    return undefined;
                }

                if (indicador.TIPO.$ == null) {
                    return undefined;
                }

                if (indicador.colunas != null) {
                    coluna = indicador.colunas.coluna;
                    tipo = ObjectUtils.getProperty(coluna, "TIPO.$");
                    indice = ObjectUtils.getProperty(coluna, "INDICE.$");
                }

                var valor = undefined;

                if (angular.isDefined(indicador.dados) && angular.isDefined(indicador.dados.linha) && indicador.dados.linha["COLUNA" + indice] != null && indicador.dados.linha["COLUNA" + indice].$ != undefined) {

                    valor = indicador.dados.linha["COLUNA" + indice].$;

                    if (tipo == "M") {
                        valor = "R$ " + NumberUtils.format((valor ? parseFloat(valor) : 0), 2);
                    } else if (tipo == "DE") {
                        valor = NumberUtils.format((valor ? parseFloat(valor) : 0), 2);
                    }
                }

                var tipoIndicador = indicador.TIPO.$.toString();
                var idIndicador = "";

                if (indicador.IDENTIFICADOR != null && indicador.IDENTIFICADOR.$ != null) {
                    idIndicador = indicador.IDENTIFICADOR.$.toString();
                }

                var tooltip = "";

                if (tipoIndicador == "SI") {
                    if (idIndicador.indexOf("Identificador_PercentualRenegociacoes") > -1) {
                        if(angular.isDefined(indicador.dados)){
                            var qtdTitulosRenegociados = indicador.dados.QTDRENEG.$.toString();
                            tooltip = i18n('Comercial.FichaParceiro.buttonCliqueDetalhes');
                            valor = qtdTitulosRenegociados;
                            if(isOnclickButton){
                                if(_paramsCriterio.hasOwnProperty("CODPARC")){
                                    self.faceIndicadoresIndex = 3;
                                    _dsRenegociacaoReady.whenReady().then(function () {
                                        self.detalhesRenegociacao.carregarRenegociacoes(self.codParc, indicador);
                                    });
                                }
                            }
                        }else {
							tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
						}
                    }else if("Identificador_LimiteCreditoTotal|Identificador_LimiteCreditoMensal".indexOf(idIndicador) > -1){
						if(valor){
							tooltip = i18n('Comercial.FichaParceiro.buttonCliqueDetalhes');
                            if(isOnclickButton){
                                mostrarDetalhesLimiteCredito(indicador);
                            }
						}else{
							tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
						}
					}else if("Identificador_TotalAPagar".indexOf(idIndicador) > -1){
						if(angular.isDefined(ObjectUtils.getProperty(indicador, 'dados.linha'))){
                            var financeiros1 = ArrayUtils.toArray(indicador.dados.linha.financeiros.financeiro);
						
                            if(ArrayUtils.isNotEmpty(financeiros1)){
                                tooltip = i18n('Comercial.FichaParceiro.buttonCliqueDetalhes');
                                if(isOnclickButton){
                                    mostrarDetalhesFinanceiros(financeiros1);
                                };
                            }
                        }else{
                            tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
                        }
					}else if("Identificador_AtrasoMedio".indexOf(idIndicador) > -1){
                        if(angular.isDefined(ObjectUtils.getProperty(indicador, 'dados.linha'))){
                            var financeiros2 = ArrayUtils.toArray(indicador.dados.linha.financeiros.financeiro);

                            if(ArrayUtils.isNotEmpty(financeiros2)){
                                toolTip = i18n('Comercial.FichaParceiro.buttonCliqueDetalhes');
                                if(isOnclickButton){
                                    mostrarDetalhesFinanceiros(financeiros2, true);
                                };
                            }
                        }else{
                            tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
						}
					}else if("Identificador_PercentualPontualidade".indexOf(idIndicador) > -1 && angular.isDefined(ObjectUtils.getProperty(indicador, 'dados.linha'))){
                        var financeirosPontuais = ArrayUtils.toArray(indicador.dados.linha.financeirosPontuais.financeiro);
						var financeirosAtrasados = ArrayUtils.toArray(indicador.dados.linha.financeirosAtrasados.financeiro);
						
						if(ArrayUtils.isNotEmpty(financeirosPontuais) > 0 || 
                            ArrayUtils.isNotEmpty(financeirosAtrasados) > 0){
                            tooltip = i18n('Comercial.FichaParceiro.buttonCliqueDetalhes');
                            
							if(isOnclickButton){
								self.faceIndicadoresIndex = 5;
                                _dsPontualidadeReady.whenReady().then(function () {
                                    self.detalhesPontualidade.carregarDetalhes(indicador.dados, indicador.DESCRICAO.$);
                                });
							}
						}else{
                            tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
						}
					}else if("Identificador_UltimoContato".indexOf(idIndicador) > -1){
						if(valor){
                            tooltip = i18n('Comercial.FichaParceiro.buttonCliqueDetalhes');
							if(isOnclickButton){
								self.faceIndicadoresIndex = 6;
                                _dsUltimoContatoReady.whenReady().then(function () {
                                    self.detalhesUltimoContato.carregarDetalhes(indicador.dados, indicador.DESCRICAO.$);
                                });
							}
						}else{
                            tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
						}
					}
                }else{
                    tooltip = i18n('Comercial.FichaParceiro.buttonSemDetalhes');
                }
                return {value : valor, tooltip : tooltip};
            }

            function buildIndicadorPlanilha(indicador){
                self.fieldSetPlanilhaTitle = indicador.DESCRICAO.$;

                var columns = [];
                var colunas = ArrayUtils.toArray(indicador.colunas.coluna);

                if(ArrayUtils.isNotEmpty(colunas)){
                    colunas.forEach(function (coluna) {
                        var dataColumn = {
                            name : "COLUNA" + coluna.INDICE.$,
                            description : coluna.DESCRICAO.$,
                            userType : "S"
                        }

                        var tipo = coluna.TIPO.$;

                        if(tipo == "DT"){
                            dataColumn.userType = "D";
                        }else if(tipo == "DE"){
                            dataColumn.userType = "F";
                        }else if(tipo == "M"){
                            dataColumn.userType = "F";
                        }else if(tipo == "I"){
                            dataColumn.userType = "I";
                        }
                        columns.push(dataColumn);
                    });

                    var linhasPlanilha = [];
                    var linhas = ArrayUtils.toArray(indicador.dados.linha);

                    if(angular.isDefined(linhas)){
                        linhas.forEach(function (linha) {
                            var objLinha = FichaParceiroService.converteObjectXMLToObject(linha);
                            linhasPlanilha.push(objLinha);
                        });
                    }

                    self.dataGridPlanilha = [{
                        fields: columns,
                        records : linhasPlanilha
                    }];

                    if(angular.isDefined(self.datagridIndicadoresPlanilha)){
                        self.datagridIndicadoresPlanilha.getDataset().refresh();
                    }

                    self.visibleFieldSetPlanilha = true;
                }
            }

            function openRelatorioDoubleClick(){
                if(MGEParameters.asInteger("mgecom.fichaParceiro.modelo.relatorio.grid.click") != 0) {
                    var nuRfe = MGEParameters.asInteger("mgecom.fichaParceiro.modelo.relatorio.grid.click");

                    var campos = [
                        {
                            nome: "CODPARC",
                            classe: "java.math.BigDecimal",
                            valor : self.datagridIndicadoresPlanilha.getDataset().getFieldValue("COLUNA1"),
                            pesquisa: "false",
                            requerido: "false"
                        },
                        {
                            nome: "DTCONSULTA",
                            classe: "java.sql.Timestamp",
                            valor:  DateUtils.formatDate(self.datagridIndicadoresPlanilha.getDataset().getFieldValue("COLUNA2"), "DD/MM/YYYY"),
                            pesquisa: "false",
                            requerido: "false"
                        }
                    ];

                    var request = {
                        relatorio: {
                            nuRfe: nuRfe,
                            parametros: {parametro: campos}
                        },
                    }

                    ServiceProxy.callService('mge@VisualizadorRelatorios.visualizarRelatorio', request)
                        .then(function(result) {

                            var chave = result.responseBody.chave.valor;
                            SkApplication.instance().openWindow('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave, '_blank');
                        });
                }
            }

            function onClickIndicador(indicador) {
                buildIndicador(indicador, true);
            }

            function mostrarDetalhesLimiteCredito(indicador){
                if(_paramsCriterio.hasOwnProperty("CODPARC")){
					self.faceIndicadoresIndex = 4;

                    _dsLimiteCreditoReady.whenReady().then(function () {
                        self.faceIndicadoresIndex = 4;
                        self.detalhesLimiteCredito.carregarDetalhes(_paramsCriterio["CODPARC"], indicador.DESCRICAO.$);
                    });
				}
            }

            function mostrarFinSelecionado() {
                if (self.dsDetalhesFinanceiros.getCurrentRow()) {
                    var objPK = { NUFIN: 0 }
                    objPK.NUFIN = self.dsDetalhesFinanceiros.getFieldValueAsString("NUFIN");
                    abrirTelaMovFinanceira(objPK);
                }
            }

            function abrirTelaMovFinanceira(objPK) {
                if (angular.isDefined(objPK.NUFIN) && (angular.isDefined(self.paramsCriterio) || self.paramsCriterio["b2bMode"] == null)) {
                    SkApplicationInstance.openApp("br.com.sankhya.fin.cad.movimentacaoFinanceira", objPK);
                }
            }

            function openConfig() {
                if (self.faceIndicadoresIndex == 0) {
                    self.faceIndicadoresIndex = 1;
                } else {
                    self.faceIndicadoresIndex = 0;
                }
            }

            function onDataGridLoaded(datagrid) {
                self.dataGrid = datagrid;
            }

            function onDatasetDetalhesFinanceiros(dataset) {
                self.dsDetalhesFinanceiros = dataset;
                self.dsDetalhesFinanceiros.init();
            }

            function refreshHandlerDetalhesFinanceiros(request){
                return _dataFinanceiros;
            }

            function mostrarDetalhesFinanceiros(financeiros, mostrarDhBaixa = false) {
                self.faceIndicadoresIndex = 2;
                self.mostrarDhBaixa = mostrarDhBaixa;

                financeiros = ArrayUtils.toArray(financeiros);

                if (ArrayUtils.isNotEmpty(financeiros)) {
                    var params = { criterio: { financeiro: [] } };
                    self.painelPontuaisVisible = true;

                    angular.forEach(financeiros, function (financeiro) {
                        params.criterio.financeiro.push(financeiro);
                    });

                    ServiceProxy.callService("mgecom@FichaParceiroSP.getFinanceiros", params)
                        .then(function (response) {
                            var responseFinanceiros = response.responseBody.financeiros;
                            if (angular.isDefined(responseFinanceiros)) {
                                _dataFinanceiros = [];
                                _dataFinanceiros = ArrayUtils.toArray(responseFinanceiros.financeiro);
                                self.dsDetalhesFinanceiros.refresh();
                            }
                        });
                } 
            }

            function configuracaoFinalizada(){
                refresh();
            }

            function buildLabelTipoMovimentacao(col, value, row) {
                let indexCodTipOper = self.dsDetalhesFinanceiros.getFieldIndexByName("CODTIPOOPER");
                let indexDescrOper = self.dsDetalhesFinanceiros.getFieldIndexByName("DESCROPER");
                return row[indexCodTipOper] + " - " + row[indexDescrOper];
            }

            function buildLabelEmpresa(col, value, row) {
                let indexCodEmp = self.dsDetalhesFinanceiros.getFieldIndexByName("CODEMP");
                let indexDescrEmp = self.dsDetalhesFinanceiros.getFieldIndexByName("NOMEEMP");
                return row[indexCodEmp] + " - " + row[indexDescrEmp];
            }

            function buildLabelTipoTitulo(col, value, row) {
                let indexCodTit = self.dsDetalhesFinanceiros.getFieldIndexByName("CODTIPTIT");
                let indexDescrTip = self.dsDetalhesFinanceiros.getFieldIndexByName("DESCRTIPTIT");
                return row[indexCodTit] + " - " + row[indexDescrTip];
            }

            function buildLabelNatureza(col, value, row) {
                let indexCodNat = self.dsDetalhesFinanceiros.getFieldIndexByName("CODNAT");
                let indexDescrNat = self.dsDetalhesFinanceiros.getFieldIndexByName("DESCRNAT");
                return row[indexCodNat] + " - " + row[indexDescrNat];
            }
        }
    ]);


angular
.module('snk.commons')
.controller('OrdemCargaPopUpController', [ '$scope', 'Criteria', 'pkOdemCarga', 'i18n', 'ObjectUtils',
    function ($scope, Criteria, pkOdemCarga, i18n, ObjectUtils) {
      var self = this;

      ObjectUtils.implements(self, CriteriaProvider);

      self.onDatasetCreatedStandAlone = onDatasetCreatedStandAlone;
      self.getCriteria = getCriteria;
      self.dsOrdemCarga = null;

      function onDatasetCreatedStandAlone(dataset) {
        self.dsOrdemCarga = dataset;
        
        self.dsOrdemCarga.addCriteriaProvider(getCriteria);
        self.dsOrdemCarga.initAndRefresh();
      }

      function getCriteria(){
        let criteria = new Criteria();

        criteria.append('( CODEMP = ? ');
        criteria.addParameter(Criteria.buildNumberParameter(pkOdemCarga.CODEMP.toString()));

        if (pkOdemCarga.ORDEMCARGA == null || pkOdemCarga.ORDEMCARGA == '') {
          criteria.append(' AND ORDEMCARGA IS NULL ');
        } else{
          criteria.append(' AND ORDEMCARGA = ? ');
          criteria.addParameter(Criteria.buildNumberParameter(pkOdemCarga.ORDEMCARGA.toString()));
        }
        criteria.append(')');
        
        return criteria;
      }
    }
  ]);
angular
.module('snk.commons')
.component('skPendenciasFinanceiras', {
    templateUrl: 'commons/fichaparceiro/PendenciasFinanceiras/PendenciasFinaceiras.tpl.html',
    controller: 'PendenciasFinanceirasController as ctrl',
    bindings: {
        onCreated: '&skOnCreated',
        CODPARC: '=?skCodparc',
        resourceID: '=?skResourceId',
        paramsCriterio: '=?skParamsCriterio',
        b2bMode: '=?skB2bmode',
        idPainel: '@skIdPainel'
    }
})
.controller('PendenciasFinanceirasController',
    ['ServiceProxy', 'i18n', 'StringUtils', 'MessageUtils',
        'DateUtils', 'DateUtilsConstants', 'SkApplicationInstance', 'Criteria', 'NumberUtils', 'ArrayUtils',
        'ObjectUtils', '$interval', '$timeout', 'SanPopup',
        function (ServiceProxy, i18n, StringUtils, MessageUtils,
            DateUtils, DateUtilsConstants,  SkApplicationInstance, Criteria, NumberUtils, ArrayUtils, ObjectUtils, $interval, $timeout, SanPopup) {
            var self = this;
            
            // variaveis que serão deifinidas para obter um id unico para cada grid
            self.uid =self.idPainel;
            self.codGraficoPedencias="graficoPendencias"+ self.uid;
            self.codGraficoNatureza = "graficoNatureza"+ self.uid;
            self.codGraficoCR = "graficoCR"+ self.uid;
            self.codGraficoTOP = "graficoTOP"+ self.uid;
            self.codGraficoEmpresa = "graficoEmpresa"+ self.uid;
            self.codGraficoParceiro = "graficoParceiro"+ self.uid;
            self.pendFinanceiroPanel="PendenciasFinanceirasPanel"+ self.uid;

            // Constantes
            const NENHUM = "N";
			const HOJE = "H";
			const SEMANA_CORRENTE = "S";
			const MES_CORRENTE = "M";
			const TUDO = "T";
			const PERSONALIZADO = "P";
            const ID_FILTRO_FIN = "FiltroFinan:";
            const NIVEIS_ANALISE_GRAFICA = {
                "N": {name: self.codGraficoNatureza, label: i18n('Comercial.FichaParceiro.headerNatureza'), selected: "false", value: "N"},
                "C": {name: self.codGraficoCR, label: i18n('Comercial.FichaParceiro.headerCentroResultado'), selected: "false", value: "C"},
                "T": {name: self.codGraficoTOP, label: i18n('Comercial.FichaParceiro.headerTipoOperacao'), selected: "false", value: "T"},
                "E": {name: self.codGraficoEmpresa, label: i18n('Comercial.FichaParceiro.labelEmpresa'), selected: "false", value: "E"},
                "P": {name: self.codGraficoParceiro, label: i18n('Comercial.FichaParceiro.labelParceiro'), selected: "false", value: "P"}
            };

            const ORDENACAO_CAMPO = [ 
				"NUFIN",
				"NUMNOTA",
				"DTNEG",
				"DTVENC",
				"VLRDESDOB",
				"CODTIPOOPER",
				"TipoOperacao.DESCROPER",
				"CODEMP",
				"Empresa.NOMEFANTASIA",
				"CODNAT",
				"Natureza.DESCRNAT",
				"CODTIPTIT",
				"TipoTitulo.DESCRTIPTIT",
				"CODCENCUS",
				"CentroResultado.DESCRCENCUS",
				"HISTORICO"
			];

            // Implementors
            ObjectUtils.implements(self, IDatagridInterceptor);

            // Variáveis
            var _paramsCriterio;
            var _hasCenCus = true;
            var _inibeAcessoDespesas;
			var _inibeAcessoReceitas;
            var _lastCriteria;
            self.showGraph = false;
            self.showConfig = false;
            self.showGrid = false;
            self.grupoGrafico = "B";
            self.colorReceita = 255;
            self.colorDespesa = 16711680;
            self.intervaloVencimento = NENHUM;
            self.tituloComBaixaFutura = "false";
            self.ultimos = 0;
            self.proximos = 0;
            self.tipoGrafico = "column";
            self.currentGraph = self.codGraficoPedencias;

            self.gridConfigDsFinanceiro = "gridConfig:" + self.resourceID;

            self.graphsData = {
                [self.codGraficoPedencias]: [],
                [self.codGraficoNatureza]: [],
                [self.codGraficoCR]: [],
                [self.codGraficoTOP]: [],
                [self.codGraficoEmpresa]: [],
                [self.codGraficoParceiro]: [],
            }

            // Funções
            self.refresh = refresh;
            self.openConfig = config;
            self.getFatiasPendenciasFinanceiras = getFatiasPendenciasFinanceiras;
            self.setParamsCriterio = setParamsCriterio;
            self.createChartColumn = createChartColumn;
            self.getDataToGraph = getDataToGraph;
            self.buildLabelCategoriaVencimentos = buildLabelCategoriaVencimentos;
            self.config = config;
            self.confirmarRestauracao = confirmarRestauracao;
            self.openFiltro = openFiltro;
            self.proximoNivel = proximoNivel;
            self.nivelAnterior = nivelAnterior;
            self.salvarConfig = salvarConfig;
            self.carregarConfig = carregarConfig;
            self.salvarFiltro = salvarFiltro;
            self.carregarFiltro = carregarFiltro;
            self.irParaModoGrade = irParaModoGrade;
            self.irParaModoGrafico = irParaModoGrafico;
            self.getFinanceirosToGrade = getFinanceirosToGrade;
            self.onDatasetCreated = onDatasetCreated;
            self.getCellColors = getCellColors;
            self.atualizarTotalizadores = atualizarTotalizadores;
            self.initMenuOutrasOpcoes = initMenuOutrasOpcoes;
            self.jurosMultaIndividual = jurosMultaIndividual;
            self.jurosMultaColetivo = jurosMultaColetivo;
            self.irParaModoGraficoPendencias = irParaModoGraficoPendencias;
            self.abrirTelaMovFinanceira = abrirTelaMovFinanceira;
            self.sortMetadata = sortMetadata;
            self.interceptCellRenderer = interceptCellRenderer;
            self.changeResizePanel = changeResizePanel;

            function sortMetadata(fieldsMD) {
                ArrayUtils.sortArrayFromArray(fieldsMD, ORDENACAO_CAMPO, function (fieldMD) {
                    return fieldMD.name;
                });
            }

            // Combobox
            self.cbSeletorBaixadosOpcoes = [
                { value: i18n('Comercial.FichaParceiro.labelPendentes'), data: "P" },
                { value: i18n('Comercial.FichaParceiro.lblBaixados'), data: "B" },
            ];
            self.cbSeletorBaixados = "P";

            self.comboTipoPeriodoOpcoes = [
                { value: i18n('Comercial.FichaParceiro.labelMensal'), data: "M" },
                { value: i18n('Comercial.FichaParceiro.labelQuinzenal'), data: "Q" },
                { value: i18n('Comercial.FichaParceiro.labelSemanal'), data: "S" },
            ]
            self.comboTipoPeriodo = "M";

            self.lstNiveis = [];

            init();

            function init() {
                if (self.onCreated) {
                    self.onCreated({component: self});
                }
            }

            function initMenuOutrasOpcoes() {
                return [
                    {label: i18n('Comercial.FichaParceiro.lblCalcJurosMultaIndividual'), action: jurosMultaIndividual},
                    {label: i18n('Comercial.FichaParceiro.lblCalcJurosMultaColetivo'), action: jurosMultaColetivo}
                ];
            }

            function jurosMultaIndividual() {
                let pk = {};
                if(!validaJurosMultaIndividual()){
                    return;
                }	
                pk = {NUFIN: self.dsFinanceiro.getFieldValue("NUFIN")};
                SkApplicationInstance.openApp("br.com.sankhya.fin.rotina.calculoJurosMulta", pk);
            }

            function jurosMultaColetivo() {
                let pk = {};
                if(!validaJurosMultaColetivo()){
                    return;
                }
                pk = {expressaoListaNUFIN: _lastCriteria};
                SkApplicationInstance.openApp("br.com.sankhya.fin.rotina.calculoJurosMulta", pk);
            }

            function validaJurosMultaIndividual() {
                if(self.dsFinanceiro.isEmpty()){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validSemRegistrosNaGrade'));
					return false;
				}
				if(self.dsFinanceiro.getFieldValueAsString("PROVISAO") == "S"){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validFinanProvisao'));
					return false;
				}
				if(self.dsFinanceiro.getFieldValue("DHBAIXA") != null){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validFinanPendente'));
					return false;
				}
				if( self.dsFinanceiro.getFieldValueAsNumber("RECDESP") != 1){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validFinanReceita'));
					return false;
				}
				return true;
            }

            function validaJurosMultaColetivo() {
                if(self.dsFinanceiro.isEmpty()){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validSemRegistrosNaGrade'));
					return false;
				}
				if(self.cbSeletorBaixados != "P"){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validFinansPendentes'));
					return false;
				}
				if(self.groupRealProvAmbos == "S"){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Comercial.FichaParceiro.validFinansRecDesp'));
					return false;
				}	
				return true;
            }

            function onDatasetCreated(dataset) {
                self.dsFinanceiro = dataset;

                let observerFinanceiro = new IDataSetObserver();

                observerFinanceiro.refreshed = function () {
                    $timeout(() => {
                        self.atualizarTotalizadores();
                    });
                };
                
                self.dsFinanceiro.setCrudListener('br.com.sankhya.mgecomercial.listeners.PendenciasFinanceirasCrudListener');

                self.dsFinanceiro.addObserver(observerFinanceiro);
                self.dsFinanceiro.init();
            }

            function getCellColors(row, col, rowIndex, colIndex) {
                let colorRec;
                let colorDesp;

                if(isNaN(Number(self.colorReceita))) {
                    colorRec = parseInt(self.colorReceita, 16)
                } else {
                    colorRec = self.colorReceita;
                }

                if(isNaN(Number(self.colorDespesa))) {
                    colorDesp = parseInt(self.colorDespesa, 16)
                } else {
                    colorDesp = self.colorDespesa;
                }

                if(row.entity[self.dsFinanceiro.getFieldIndexByName('RECDESP')] == 1) {
                    return {
                        textColor: colorString(colorRec),
                    };
                } else {
                    return {
                        textColor: colorString(colorDesp),
                    };
                }
            }

            function interceptCellRenderer(cell, value, eGridCell, data) {
                if(cell.colDef.dataType == "S" && value?.toString()?.length > 0) {
                    var element = document.createElement("span");
                    var text = document.createTextNode(
                        value
                    );
                    element.appendChild(text);

                    return {
                        element: element,
                        align: "flex-start"
                    }
                }
            }

            function abrirTelaMovFinanceira() {
                let item = self.dsFinanceiro.getCurrentRowAsObject();
                
                if(item != null){
                    let objPK = item.NUFIN;
                    SkApplicationInstance.openApp("br.com.sankhya.fin.cad.movimentacaoFinanceira", 
                    {NUFIN: objPK});
                }
            }

            function atualizarTotalizadores() {
				let vlrTot = 0;
				let vlrTotReceita = 0;
				let vlrTotDespesa = 0;
				
				let ehBaiaxdos = "B" == self.cbSeletorBaixados;

				for(let fin of self.dsFinanceiro.getRecordsAsObjects()){
					vlrTot += ehBaiaxdos ? Number(fin.VLRBAIXA) : Number(fin.VLRDESDOB);
					if(Number(fin["RECDESP"]) == 1) {
						vlrTotReceita +=  Number(fin.VLRDESDOB);
					} else {
						vlrTotDespesa +=  Number(fin.VLRDESDOB);
					}
				}

                let colorRec;
                let colorDesp;

                if(isNaN(Number(self.colorReceita))) {
                    colorRec = parseInt(self.colorReceita, 16)
                } else {
                    colorRec = self.colorReceita;
                }

                if(isNaN(Number(self.colorDespesa))) {
                    colorDesp = parseInt(self.colorDespesa, 16)
                } else {
                    colorDesp = self.colorDespesa;
                }

				self.totReceita = NumberUtils.format(vlrTotReceita, 2);
                self.buttomGridReceita = {
                    color: colorString(colorRec)
                }
				
				self.totDespesa = NumberUtils.format(vlrTotDespesa, 2);
                self.buttomGridDespesa = {
                    color: colorString(colorDesp)
                }
				
				let rec_Desp = vlrTotReceita - vlrTotDespesa;
				self.totRecDesp = NumberUtils.format(rec_Desp, 2);

				if(rec_Desp >= 0){
					self.buttomGridRecDesp = {
                        color: colorString(colorRec)
                    }
				} else {
					self.buttomGridRecDesp = {
                        color: colorString(colorDesp)
                    }
					
				}
            }

            function irParaModoGrafico() {
                self.showGrid = !self.showGrid;
            }

            function irParaModoGrade() {
                getFinanceirosToGrade();
            }

            function irParaModoGraficoPendencias() {
                self.showGrid = !self.showGrid;
                self.currentGraph = self.codGraficoPedencias;
                mostrarGrade(self.graphsData[self.codGraficoPedencias], false);
            }

            function confirmarRestauracao() {
                MessageUtils.simpleConfirm(
                    MessageUtils.TITLE_CONFIRMATION, i18n('Comercial.FichaParceiro.messagePerderConfigAoRestaurar'))
                    .then(function(){ 
                        carregarConfig(true);
                        refresh();
                    });
            }

            function config() {
                if(self.showConfig) {
                    self.showConfig = false;
                } else {
                    self.showConfig = true;
                    carregarFiltro();
                    carregarConfig();
                }
            }

            function openFiltro() {
                SanPopup.open({
                    title: i18n('Comercial.FichaParceiro.labelFiltro'),
                    templateUrl: 'commons/fichaparceiro/PopupFiltroPendenciasFinanceiras/PopupFiltroPendenciasFinanceiras.tpl.html',
                    controller: 'PopupFiltroPendenciasFinanceirasController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    okBtnLabel: i18n('Comercial.FichaParceiro.labelAplicar'),
                    showBtnNo: false,
                    noBtnLabel: i18n('Geral.buttonFechar'),
                    resolve: {
                        filtro: {
                            vencInicio: self.vencInicio,
                            vencFinal: self.vencFinal,
                            groupRecDespAmbos: self.groupRecDespAmbos,
                            groupRealProvAmbos: self.groupRealProvAmbos,
                        }
                    }
                }).result.then(function (result) {
                    self.vencInicio = result.vencInicio == self.vencInicio ? result.vencInicio: DateUtils.formatDate(result.vencInicio, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                    self.vencFinal = result.vencFinal == self.vencFinal ? result.vencFinal : DateUtils.formatDate(result.vencFinal, DateUtilsConstants.DEFAULT_DATE_FORMAT);
                    self.groupRecDespAmbos = result.groupRecDespAmbos;
                    self.groupRealProvAmbos = result.groupRealProvAmbos;

                    salvarFiltro(false, () => {
                        getFatiasPendenciasFinanceiras(() => {
                            if(self.showGrid) {
                                mostrarGrade(self.graphsData[self.currentGraph], false);
                            }
                        });	
                    });
                    
                }).catch(function () {
                    if(self.currentGraph == self.codGraficoPedencias){
                        carregarFiltro(true);
                    } else {
                        carregarFiltro(false);
                    }
                });
            }

            function salvarPreferencias(ultimos, proximos) {
				self.ultimos = self.intervaloVencimento != PERSONALIZADO ? 0 : int(ultimos);
				self.proximos = self.intervaloVencimento != PERSONALIZADO ? 0 : int(proximos);
				preencheDataVencimento();
			}

            function preencheDataVencimento() {
				if(self.intervaloVencimento == NENHUM || self.intervaloVencimento == "") {

				} else if(self.intervaloVencimento == TUDO) {
					self.vencInicio = null;
					self.vencFinal = null;
				} else {
					let currentDate = new Date();
					switch(self.intervaloVencimento) {
						case HOJE:
							self.vencInicio = DateUtils.formatDate(currentDate, DateUtilsConstants.DEFAULT_DATE_FORMAT);
							self.vencFinal = DateUtils.formatDate(currentDate, DateUtilsConstants.DEFAULT_DATE_FORMAT);
						    break;

						case SEMANA_CORRENTE:
							let primeiroDiaSemana = new Date(currentDate);
							primeiroDiaSemana.setDate(currentDate.getDate() - currentDate.getDay());
							let ultimoDiaSemana = new Date(currentDate);
							ultimoDiaSemana.setDate(currentDate.getDate() - currentDate.getDay() + 6);

							self.vencInicio = DateUtils.formatDate(primeiroDiaSemana, DateUtilsConstants.DEFAULT_DATE_FORMAT);
							self.vencFinal = DateUtils.formatDate(ultimoDiaSemana, DateUtilsConstants.DEFAULT_DATE_FORMAT);
						    break;

						case MES_CORRENTE:
							let primeiroDiaMes = new Date(currentDate);
							primeiroDiaMes.setDate(1);
							let ultimoDiaMes = new Date(currentDate);
							ultimoDiaMes.setMonth(currentDate.getMonth() + 1, 1);
							ultimoDiaMes.setDate(ultimoDiaMes.getDate() - 1);

							self.vencInicio = DateUtils.formatDate(primeiroDiaMes, DateUtilsConstants.DEFAULT_DATE_FORMAT);
							self.vencFinal = DateUtils.formatDate(ultimoDiaMes, DateUtilsConstants.DEFAULT_DATE_FORMAT);
						    break;

						case PERSONALIZADO:
							let primeiroDia = new Date(currentDate);
							primeiroDia.setDate(currentDate.getDate() - self.ultimos);
							let ultimoDia = new Date(currentDate);
							ultimoDia.setDate(currentDate.getDate() + self.proximos);

							self.vencInicio = DateUtils.formatDate(primeiroDia, DateUtilsConstants.DEFAULT_DATE_FORMAT);
							self.vencFinal = DateUtils.formatDate(ultimoDia, DateUtilsConstants.DEFAULT_DATE_FORMAT);
						    break;

						default:
							throw new Error(i18n('Financeiro.MovimentacaoFinanceira.messageImpossivelPreencherVencimento'));
					}
				}
			}

            function salvarConfig() {
                salvarPreferencias(self.ultimos, self.proximos);
				salvarFiltro(false);

                let xml = '<configuracao>';

                xml += `<grafico tipo="${self.grupoGrafico}" />`;
                xml += `<fatiaHoje corFatia="${parseInt(self.corFatiaHoje, 16)}" />`;
				
                // fatiaVencidos

                xml += `<fatiaVencidos corFatia="${parseInt(self.corFatiaVencendo, 16)}">`;

				if(self.textVenc1){
					if(self.textVenc1.toString() == "0"){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageNaoPermitidoFatiasValorZero'));
						return;
					}
					xml += `<dias valor="${self.textVenc1}" />`;
				}
				
				if(self.textVenc2){
					if(self.textVenc2.toString() == "0"){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageNaoPermitidoFatiasValorZero'));
						return;
					}
					xml += `<dias valor="${self.textVenc2}" />`;
				}
				
				if(self.textVenc3){
					if(self.textVenc3.toString() == "0"){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageNaoPermitidoFatiasValorZero'));
						return;
					}
					xml += `<dias valor="${self.textVenc3}" />`;
				}

                xml += `</fatiaVencidos>`;

                // fatiaAVencer

                xml += `<fatiaAVencer corFatia="${parseInt(self.corFatiaAVencer, 16)}">`;

                if(self.textAVencer1){
					if(self.textAVencer1.toString() == "0"){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageNaoPermitidoFatiasValorZero'));
						return;
					}
					xml += `<dias valor="${self.textAVencer1}" />`;
				}
				
				if(self.textAVencer2){
					if(self.textAVencer2.toString() == "0"){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageNaoPermitidoFatiasValorZero'));
						return;
					}
					xml += `<dias valor="${self.textAVencer2}" />`;
				}
				
				if(self.textAVencer3){
					if(self.textAVencer3.toString() == "0"){
						MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.FichaParceiro.messageNaoPermitidoFatiasValorZero'));
						return;
					}
					xml += `<dias valor="${self.textAVencer3}" />`;
				}

                xml += `</fatiaAVencer>`;

                xml += `<baixados tipoPeriodo="${self.comboTipoPeriodo}" />`;
                xml += `<preferencias 
                    interVcto="${self.intervaloVencimento}" 
                    ulti="${self.ultimos}" 
                    prox="${self.proximos}" 
                    corRec="${parseInt(self.colorReceita, 16)}" 
                    corDesp="${parseInt(self.colorDespesa, 16)}"
                    titulosBaixaFut="${self.tituloComBaixaFutura}" />`;

                xml += '</configuracao>';

                let body = {}
                body.configuracao = { $: xml, resourceID: self.resourceID };
                body.resourceID = self.resourceID;

                ServiceProxy.callService(
                    "mgecom@FichaParceiroSP.salvarConfigPendenciasFinanceiras", body
                ).then(function (response) {
                    refresh();
                    config();
                }).catch(() => {
                    refresh();
                    config();
                });
            }

            function carregarConfig(restaurarConfig = false) {
                let body = { 
                    criterio: { 
                        resourceID: self.resourceID, 
                        restaurarConfig
                    }
                }

                ServiceProxy.callService("mgecom@FichaParceiroSP.getConfigPendenciasFinanceiras", body)
                .then((response) => {
                    let configuracao = response?.responseBody?.configuracao;

                    limparConfig();

                    if(configuracao){
                        if(configuracao?.grafico) {
                            self.grupoGrafico = configuracao.grafico.tipo;
                        } else {
                            self.grupoGrafico = "B";
                        }

                        self.corFatiaHoje = configuracao?.fatiaHoje?.corFatia;

                        let fatiaVencidos =  configuracao.fatiaVencidos;
                        if(fatiaVencidos) {
                            self.corFatiaVencendo = fatiaVencidos.corFatia;
								
                            let diasVencidos = fatiaVencidos.dias;
                            
                            if (angular.isDefined(diasVencidos)){
                                for(let i = 0; i < diasVencidos.length; i++){
                                    switch(i){
                                        case 0:
                                            self.textVenc1 = diasVencidos[i].valor;
                                            break;
                                        case 1:
                                            self.textVenc2 = diasVencidos[i].valor;
                                            break;
                                        case 2:
                                            self.textVenc3 = diasVencidos[i].valor;
                                            break;
                                    }
                                }
                            }
                        }

                        let fatiaAVencer = configuracao.fatiaAVencer;
                        if(fatiaAVencer){
                            self.corFatiaAVencer = fatiaAVencer.corFatia;
                            
                            let diasAVencer = fatiaAVencer.dias;
                            
                            if (angular.isDefined(diasAVencer)){
                                for(let j = 0; j < diasAVencer.length; j++){
                                    switch(j){
                                        case 0:
                                            self.textAVencer1 = diasAVencer[j].valor;
                                            break;
                                        case 1:
                                            self.textAVencer2 = diasAVencer[j].valor;
                                            break;
                                        case 2:
                                            self.textAVencer3 = diasAVencer[j].valor;
                                            break;
                                    }
                                }
                            }
                        }

                        let baixados = configuracao.baixados;

                        if(baixados){
                            self.comboTipoPeriodo = baixados.tipoPeriodo;
                        } else {
                            self.comboTipoPeriodo = "M";
                        }
                        
                        let preferencias =  configuracao.preferencias;
                        if(preferencias){
                            self.tituloComBaixaFutura = preferencias.titulosBaixaFut; 
                            self.intervaloVencimento = preferencias.interVcto;

                            self.ultimos = preferencias.ulti;
                            self.proximos = preferencias.prox;

                            self.colorDespesa = preferencias?.corDesp ? preferencias.corDesp : self.colorDespesa;
                            self.colorReceita = preferencias?.corRec ? preferencias.corRec : self.colorReceita; 
                        } else {
                            self.tituloComBaixaFutura = "false";
                            self.intervaloVencimento = NENHUM;
                            self.ultimos = 0;
                            self.proximos = 0;
                            self.colorDespesa = 16711680;
                            self.colorReceita = 255; 
                        }

                    }
                    if(restaurarConfig) {
                        refresh();
                        config();
                    }
                })

            }

            function limparConfig() {
                self.corFatiaHoje = 0;
							
				self.corFatiaVencendo = 0;
				self.textVenc1 = "";
				self.textVenc2 = "";
				self.textVenc3 = "";
				
				self.corFatiaAVencer = 0;
				self.textAVencer1 = "";
				self.textAVencer2 = "";
				self.textAVencer3 = "";
            }

            function salvarFiltro(fazerRefresh = true, callBack = null) {
                let body = { 
                    config: { 
                        chave: ID_FILTRO_FIN + self.resourceID, 
                        tipo: "T",
                        filtro: {
                            niveis: {
                                nivel: []
                            },
                            vencIni: self.vencInicio,
                            vencFin: self.vencFinal
                        }
                    },
                }

                let nivel = body.config.filtro.niveis.nivel;

                for(let lstItem of self.lstNiveis) {
                    nivel.push({
                        selected: lstItem.selected.toString(),
                        value: lstItem.value
                    })
                }

				if(self.groupRecDespAmbos != "A" ){
					body.config.filtro.recDesp = self.groupRecDespAmbos; 
				}
				
				if(self.groupRealProvAmbos != "A"){
					body.config.filtro.realProv = self.groupRealProvAmbos;
				}

                ServiceProxy.callService("mge@SystemUtilsSP.saveConf", body)
                .then(() => {

                    if(fazerRefresh){
                        refresh();
                    }
                    
                    if(callBack != null){
                        callBack();
                    }
                })
            }

            function carregarFiltro(cancelar = false) {
                let body = { 
                    config: { 
                        chave: ID_FILTRO_FIN + self.resourceID, 
                        tipo: "T"
                    }
                }

                ServiceProxy.callService("mge@SystemUtilsSP.getConf", body)
                .then((response) => {
                    let filtro = response?.responseBody?.config?.filtro;      
                    if(filtro) {
                        let niveis = filtro?.niveis?.nivel;
                        let dataProv = [];

                        if(filtro?.recDesp) {
                            self.groupRecDespAmbos = filtro.recDesp;
                        } else {
                            self.groupRecDespAmbos = "A";
                        }
                        
                        validateGroupRecDespAmbos();

                        if(filtro?.realProv) {
                            self.groupRealProvAmbos = filtro.realProv;    
                        } else {
                            self.groupRealProvAmbos = "A";
                        }
                        
                        if(filtro?.vencIni){
                            self.vencInicio = filtro.vencIni;
                        } else {
                            self.vencInicio = null;
                        }

                        if(filtro?.vencFin){
                            self.vencFinal = filtro.vencFin;
                        } else {
                            self.vencFinal = null;
                        }

                        if(niveis) {
                            for(let nivel of niveis) {
                                let item = NIVEIS_ANALISE_GRAFICA[nivel.value];
                                item.selected = nivel.selected;
                                if(item.value != "C" || (item.value == "C" && _hasCenCus)) {
                                    dataProv.push(item);
                                }
                            }
                        } else {
                            for(let valor of Object.keys(NIVEIS_ANALISE_GRAFICA)) {
                                if(NIVEIS_ANALISE_GRAFICA[valor].value != "C" || (NIVEIS_ANALISE_GRAFICA[valor].value == "C" && _hasCenCus)){
                                    dataProv.push(NIVEIS_ANALISE_GRAFICA[valor]);
                                }
                            }
                        }

                        self.lstNiveis = dataProv;
                    } else {
                        let dataProv = [];

                        for(let valor of Object.keys(NIVEIS_ANALISE_GRAFICA)) {
                            if(NIVEIS_ANALISE_GRAFICA[valor].value != "C" || (NIVEIS_ANALISE_GRAFICA[valor].value == "C" && _hasCenCus)){
                                dataProv.push(NIVEIS_ANALISE_GRAFICA[valor]);
                            }
                        }

                        self.lstNiveis = dataProv;
                    }

                    $timeout(() => {
                        self.listApi.setSelectedItems([self.lstNiveis[0]]);
                    }, 1000);

                    if(cancelar){
                        self.showGraph = true;
                    }
                    
                })
            }

            function validateGroupRecDespAmbos() {
                if(_inibeAcessoDespesas || _inibeAcessoReceitas){
                    if(!_inibeAcessoDespesas) {
                        self.groupRecDespAmbos = "-1";
                    }
                    if(!_inibeAcessoReceitas) {
                        self.groupRecDespAmbos = "1";
                    }
                    if(!_inibeAcessoDespesas && !_inibeAcessoReceitas) {
                        self.groupRecDespAmbos = "A";
                    }
				}
            }

            function setParamsCriterio(paramsCriterio){
                _paramsCriterio = paramsCriterio;
            }

            function refresh() {
                carregarFiltro();	
				getFatiasPendenciasFinanceiras();
            }

            function getFatiasPendenciasFinanceiras(callback = null) {
                if(!_paramsCriterio) {
                    return;
                }
                
                let paramsCriterio = _paramsCriterio;
                let body = { criterio: { resourceID: self.resourceID, pendenteBaixado: self.cbSeletorBaixados} }

                let keys = Object.keys(paramsCriterio);

                keys.forEach(function (key, index) {
                    body.criterio[key] = paramsCriterio[key];
                });

                ServiceProxy.callService("mgecom@FichaParceiroSP.getFatiasPendenciasFinanceiras", body)
                .then((response) => {								
                    let resp = response.responseBody;

                    let baixados = ArrayUtils.toArray(resp?.baixados?.financeiros);
					let tipoGrafico = resp?.tipoGrafico;
                    // perWedgeExplodeRadius - correspondencia em highcharts
                    let existeFatiaDeHoje = resp?.fatias?.existeFatiaDeHoje;
                    let fatias = ArrayUtils.toArray(resp?.fatias?.fatia);

                    let prazoPagRec = resp?.prazoPagRec;
					let prazoPagDesp = resp?.prazoPagDesp;

                    self.tipoGrafico = "column";
                    let graph_div = self.codGraficoPedencias;
                    self.showGraphColumn = true;

                    if (tipoGrafico == "P") {
                        self.tipoGrafico = "pie";
                        self.showGraphColumn = false;
                    }

                    if(fatias?.length > 0) {
                        let financeirosEmAberto = [];

                        // infoFinAVencer
                        let financeirosAVencer = resp?.infoFinanceiros.financeirosAVencer;

                        self.infoFinAVencerColor = {
                            color: colorString(financeirosAVencer.cor)
                        }
                        self.infoFinAVencerLabel = i18n('Comercial.FichaParceiro.labelAVencer') + " R$ " + NumberUtils.format(financeirosAVencer.valorTotal, 2);
                        self.infoFinAVencerToolTip = i18n('Comercial.FichaParceiro.labelAVencerTooltip', [financeirosAVencer.financeiro?.length]);
                        self.infoFinAVencerData = financeirosAVencer.financeiro;

                        financeirosAVencer.financeiro = Array.isArray(financeirosAVencer.financeiro) ? financeirosAVencer.financeiro : [financeirosAVencer.financeiro];

                        financeirosEmAberto = [...financeirosAVencer.financeiro];

                        // infoFinVencidos
                        let financeirosVencidos = resp?.infoFinanceiros.financeirosVencidos;

                        self.infoFinVencidosColor = {
                            color: colorString(financeirosVencidos.cor)
                        }
                        self.infoFinVencidosLabel = i18n('Comercial.FichaParceiro.labelEmAtraso') + " R$ " + NumberUtils.format(financeirosVencidos.valorTotal, 2);
                        self.infoFinVencidosTooltip = i18n('Comercial.FichaParceiro.labelEmAtrasoTooltip', [financeirosVencidos.financeiro?.length]);
                        self.infoFinVencidosData = financeirosVencidos.financeiro;

                        financeirosVencidos.financeiro = Array.isArray(financeirosVencidos.financeiro) ? financeirosVencidos.financeiro : [financeirosVencidos.financeiro];

                        financeirosEmAberto = [...financeirosEmAberto, ...financeirosVencidos.financeiro];

                        let qtdTotalFinanceiros = financeirosEmAberto.length;
                        let valorTotalFinanceiros = Number(financeirosAVencer.valorTotal) + Number(financeirosVencidos.valorTotal);

                        // infoFinAbertos
                        self.infoFinAbertosLabel = i18n('Comercial.FichaParceiro.labelEmAberto') + " R$ " + NumberUtils.format(valorTotalFinanceiros, 2);                        
                        self.infoFinAbertosToolTip = i18n('Comercial.FichaParceiro.labelEmAbertoTooltip', [qtdTotalFinanceiros]);
                        self.infoFinAbertosData = financeirosEmAberto;

                        let dataGraph = self.getDataToGraph(fatias, self.cbSeletorBaixados, graph_div);

                        self.graphsData[graph_div] = [...dataGraph];

                        if(document.getElementById(graph_div)){

                           self.createChartColumn(graph_div, 
                            i18n('Comercial.FichaParceiro.labelValoresPendentes') + "",
                            "category", dataGraph, self.proximoNivel, self.tipoGrafico);

                            changeResizePanel(); 
                        }

                        self.showGraph = true; 
                    } else if (baixados?.length > 0){
                        let financeirosAtrasados = resp?.financeirosAtrasados;
                        
                        self.infoAtrasadosLabel = i18n('Comercial.FichaParceiro.labelEmAtraso') + " R$ " + NumberUtils.format(financeirosAtrasados.valorAtraso, 2);
                        self.infoAtrasadosToolTip = financeirosAtrasados.financeiro?.length + i18n('Comercial.FichaParceiro.toolTipBaixadosEmAtraso');
                        self.infoAtrasadosData = financeirosAtrasados.financeiro;

                        let totalFinanceiros = resp?.totalFinanceiros;

                        self.infoTotalLabel = i18n('Comercial.FichaParceiro.labelTotal') + " R$ " + NumberUtils.format(totalFinanceiros.vlrTotal, 2);
                        self.infoTotalToolTip = totalFinanceiros.financeiro?.length + i18n('Comercial.FichaParceiro.toolTipBaixados');
                        self.infoTotalData = totalFinanceiros.financeiro;
                        
                        let dataGraph = self.getDataToGraph(baixados, self.cbSeletorBaixados, graph_div);

                        self.graphsData[graph_div] = [...dataGraph];

                        self.createChartColumn(graph_div, 
                            i18n('Comercial.FichaParceiro.labelValoresBaixados') + "",
                            "category", dataGraph, self.proximoNivel, self.tipoGrafico);

                        changeResizePanel();
                        self.showGraph = true;
                    } else {
                        self.showGraph = false;
                    }

                    if(prazoPagRec != null){
                        self.prazoAtrasoRec = true;
                        self.txtPrazoRec = prazoPagRec?.prazoMedio?.$ + " " + i18n('Comercial.FichaParceiro.lblDias');
                        self.txtAtrasoRec = prazoPagRec?.atrasoMedio?.$ + " " + i18n('Comercial.FichaParceiro.lblDias');
                    } else {
                        self.prazoAtrasoRec = false;
                    }

                    if(prazoPagDesp != null){
                        self.prazosAtrasoDesp = true;                        
                        self.txtPrazoDesp = prazoPagDesp?.prazoMedio?.$ + " " + i18n('Comercial.FichaParceiro.lblDias');
                        self.txtAtrasoDesp = prazoPagDesp?.atrasoMedio?.$ + " " + i18n('Comercial.FichaParceiro.lblDias');
                        
                    } else {
                        self.prazosAtrasoDesp = false;
                    }

                    if(callback != null){
                        callback();
                    }

                }).finally(()=>{
                    if(self.showGrid === true){
                        mostrarGrade(self.graphsData[self.currentGraph], false);
                    }
                })

            }

            function getFinanceirosToGrade() {
                self.showGrid = !self.showGrid;
                mostrarGrade(self.graphsData[self.currentGraph], false);
            }

            function mostrarGrade(dados, proximo) {
                let dadosGrade = [];
                dados = Array.isArray(dados) ? dados : [dados];
                if(proximo) {
                    for (let dado of dados){
						dadosGrade.push(dado);
					}
                } else {
                    for (let dado of dados) {
                        dado.financeiro = Array.isArray(dado.financeiro) ? dado.financeiro : [dado.financeiro];
                        for(let dad of dado.financeiro) {
                            dadosGrade.push(dad);
                        }
                    }
                }

                let criterio = "";
				let qtd = 0;

				for(let financeiro of dadosGrade){
                    if(financeiro?.nuFin) {
                        if(qtd == 999){
                            criterio += ") OR this.NUFIN IN (";
                            qtd = 0; // Precisa resetar a variável senão ela nunca mais será 999.
                        } else if(criterio.length > 0){
                            criterio += ",";
                        }
    
                        criterio += financeiro.nuFin;
                        
                        qtd++;
                    }
				}
			
				if(criterio.length == 0){
					criterio = " 1 = 0 "; // para que o dataset não retorne linhas
				} else {
					criterio = "this.NUFIN IN(" + criterio + ")";
				}

				_lastCriteria = criterio;
				self.dsFinanceiro.refresh(new Criteria(criterio));
            }

            function proximoNivel(panelOrigem, financeiros) { 
                let proxNivelGraph = null;
                let lstNiveisGraph = [
                    {
                        name: self.codGraficoPedencias, 
                        label: self.codGraficoPedencias, 
                        selected: "true", 
                        value: "GP"
                    }
                ]

                for(let nivel of self.lstNiveis) {
                    if(nivel.selected.toString() == "true") {
                        lstNiveisGraph.push(nivel);
                    }
                }

                for (let i = 0; i < lstNiveisGraph.length; i++) {
                    if(lstNiveisGraph[i].name == panelOrigem) {
                        if(lstNiveisGraph[i+1]) {
                            proxNivelGraph = lstNiveisGraph[i+1];
                        }
                    }                    
                }

                if(financeiros?.point?.financeiro) {
                    financeiros = financeiros.point.financeiro
                }

                if(proxNivelGraph == null){ // não conseguiu encontrar nenhum nivel marcado
                    self.showGrid = !self.showGrid;
					mostrarGrade(financeiros, true);
				} else {
					let body = {
                        params: {
                            nivel: proxNivelGraph.value,
                            pendenteBaixado: self.cbSeletorBaixados,
                            financeiro: []
                        },
                    }

                    let fins = body.params.financeiro;

                    financeiros = Array.isArray(financeiros) ? financeiros : [financeiros];
					
					for (let fin of financeiros){
						fins.push(fin);
					}

					ServiceProxy.callService(
						"mgecom@FichaParceiroSP.getFinanceirosNivel",
						body)
                        .then((response) => {
                            let itemNivel = response.responseBody.niveis.nivel;

                            itemNivel = Array.isArray(itemNivel) ? itemNivel : [itemNivel];

                            let dataGraph = self.getDataToGraph(itemNivel, self.cbSeletorBaixados, proxNivelGraph.name);

                            self.graphsData[proxNivelGraph.name] = [...dataGraph];

                            self.createChartColumn(
                                proxNivelGraph.name, 
                                proxNivelGraph.label,
                                "category", 
                                dataGraph, 
                                self.proximoNivel, 
                                self.tipoGrafico = "pie");
                            
                            self.currentGraph = proxNivelGraph.name;

                            changeResizePanel();

                        })
				}

            }

            function nivelAnterior() {
                let antNivelGraph = null;
                let lstNiveisGraph = [
                    {
                        name: self.codGraficoPedencias, 
                        label: self.codGraficoPedencias, 
                        selected: "true", 
                        value: "GP"
                    }
                ]

                for(let nivel of self.lstNiveis) {
                    if(nivel.selected.toString() == "true") {
                        lstNiveisGraph.push(nivel);
                    }
                }

                for(let i = lstNiveisGraph.length-1; i >= 0; i--) {
                    if(lstNiveisGraph[i].name == self.currentGraph) {
                        if(lstNiveisGraph[i-1]) {
                            antNivelGraph = lstNiveisGraph[i-1];
                        }
                    }
                }

                if(antNivelGraph == null){ // não conseguiu encontrar nenhum nivel marcado
                    self.showGrid = !self.showGrid;
					mostrarGrade(self.graphsData[self.currentGraph], false);
				} else {
                    let dataGraph = self.graphsData[antNivelGraph.name];

                    self.createChartColumn(
                        antNivelGraph.name, 
                        antNivelGraph.label,
                        "category", 
                        dataGraph, 
                        self.proximoNivel, 
                        self.tipoGrafico);
                    
                    self.currentGraph = antNivelGraph.name;
                    if (self.currentGraph == self.codGraficoPedencias) {
                        refresh();
                    }
                    changeResizePanel();
				}
               
            }

            function changeResizePanel() {
                let panelWidth = Number(angular.element("#"+self.pendFinanceiroPanel).css('width').replace("px", "")) - 20;
                let panelHeight = Number(angular.element("#"+self.pendFinanceiroPanel).css('height').replace("px", "")) - 120;

                if (self.chart != null && angular.isDefined(self.chart.animation)) {
                    self.chart.setSize(panelWidth, panelHeight, true);
                }
            }

            function createChartColumn(id_element, colunaYTitle, category_name, data, fn_onclick, type_graph) {
                if (type_graph == null || type_graph == undefined) {
                    type_graph = "column";
                }

                Highcharts.setOptions({
                    lang: {
                        thousandsSep: '.',
                        decimalPoint: ','
                    }
                });

                var nm_title = null;

                if (type_graph == "pie") {
                    nm_title = colunaYTitle;
                }

                self.chart = Highcharts.chart(id_element, {
                    chart: {
                        type: type_graph,
                        marginRight:15,
                    },
                    title: {
                        text: nm_title
                    },
                    accessibility: {
                        announceNewData: {
                            enabled: true
                        }
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: colunaYTitle
                        },
                        labels: {
                            formatter: function() {
                                return Highcharts.numberFormat(this.value, 2);
                            }
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                            },
                            events: {
                                click: function (event) {
                                    if (fn_onclick != null) {
                                        fn_onclick(id_element, event);
                                    }
                                }
                            }
                        },
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                            },
                            events: {
                                click: function (event) {
                                    if (fn_onclick != null) {
                                        fn_onclick(id_element, event);
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        valueDecimals: 2,
                        pointFormat: i18n('Comercial.FichaParceiro.labelCurrency') + ' <b>{point.y}</b>'
                    },
                    series: [
                        {
                            name: category_name,
                            colorByPoint: true,
                            data: data
                        }
                    ]
                });
            }

            function getDataToGraph(itens, tipo, graficoAtual) {
                let data = [];

                if (tipo == "P") {
                    for (let k = 0; k < itens.length; k++) {
                        let item = itens[k];

                        if(graficoAtual == self.codGraficoPedencias) {
                            let color = colorString(item?.cor?.$);

                            data.push({
                                name: self.buildLabelCategoriaVencimentos(item.dias.$, item),
                                y: parseFloat(item.valorTotal.$),
                                financeiro: item.financeiro,
                                color
                            });
                        } else {
                            let codigo = "";
                            let label = item.label;
                            
                            if(item?.codigo) {
                                codigo += item.codigo + " - ";
                            }

                            if(label.indexOf(">") > -1){
                                label = StringUtils.replaceAll(label, ">", "&gt;");
                            }
           
                            if(label.indexOf("<") > -1){
                                label = StringUtils.replaceAll(label, "<", "&lt;");
                            }

                            data.push({
                                name: codigo + label,
                                y: parseFloat(item.value),
                                financeiro: item.financeiro,
                            });
                        }

                    }
                }

                if (tipo == "B") {
                    let financeiros = itens;

                    for (let i = 0; i < financeiros.length; i++) {
                        let item = financeiros[i];

                        if(graficoAtual == self.codGraficoPedencias) {
                            data.push({
                                name: item.strData,
                                y: parseFloat(item.value),
                                financeiro: item.financeiro,
                                color: 'rgb(228, 135, 1)'
                            });
                        } else {
                            let codigo = "";
                            let label = item.label;
                            
                            if(item?.codigo) {
                                codigo += item.codigo + " - ";
                            }

                            if(label.indexOf(">") > -1){
                                label = StringUtils.replaceAll(label, ">", "&gt;");
                            }
           
                            if(label.indexOf("<") > -1){
                                label = StringUtils.replaceAll(label, "<", "&lt;");
                            }

                            data.push({
                                name: codigo + label,
                                y: parseFloat(item.value),
                                financeiro: item.financeiro,
                            });
                        }
                        
                    }
                }

                return data;
            }

            function buildLabelCategoriaVencimentos(labelValue, labelItem) {
                var dias = parseFloat(labelValue);

                if (!isNaN(dias)) {
                    if (labelItem?.superiorA?.$ != null) {
                        var superiorA = parseFloat(labelItem.superiorA.$);

                        if (labelItem.tipo.$.toString() == "V") {
                            return i18n('Comercial.FichaParceiro.labelAtrasadoMaisDe', [labelItem.superiorA.$.toString().replace(/-/g, "")])
                        }

                        return i18n('Comercial.FichaParceiro.labelVencendoMaisDe', [superiorA]);
                    } else if (dias == 0) {
                        return i18n('Comercial.FichaParceiro.itemHoje');
                    } else {
                        if(dias < 0) {
                            return i18n('Comercial.FichaParceiro.itemAtrasado') + " " + dias.toString().replace(/-/g, "") + " " + i18n('Comercial.FichaParceiro.labelNumDias');
                        } else {
                            return i18n('Comercial.FichaParceiro.itemVencendo') + " " + dias.toString().replace(/-/g, "") + " " + i18n('Comercial.FichaParceiro.labelNumDias');
                        }
                    }
                }

                return "";
            }

            function colorString(decimalColor) {
                let c = Number(decimalColor);

                let r = Math.floor(c / (256 * 256));
                let g = Math.floor(c / 256) % 256;
                let b = c % 256;

                return `rgb(${r},${g},${b})`;
            }

        }
    ]);


angular
.module('snk.commons')
.controller('PopUpPesquisaParceiroController', ['$scope', 'ServiceProxy', 'i18n', 'StringUtils', 'ArrayUtils', 'ObjectUtils', 'MessageUtils', 'AngularUtil', 'MGEParameters', '$popupInstance', 'SkApplicationInstance', 'Criteria',
        function ($scope, ServiceProxy, i18n, StringUtils, ArrayUtils, ObjectUtils, MessageUtils, AngularUtil, MGEParameters, $popupInstance, SkApplicationInstance, Criteria) {
            var self = this;

            // implementors
            ObjectUtils.implements(self, IFilterPanelInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);

            // Funções disponiveis no controller
            self.onDatasetCreated = onDatasetCreated;
            self.carregaFiltro = carregaFiltro;
            self.selecionaParceiro = selecionaParceiro;
            $scope.$success = callBack;

            function onDatasetCreated(dataset) {
                self.dsCartaoCredito = dataset;
                self.dsCartaoCredito.addCriteriaProvider(getCriteria);
                self.dsCartaoCredito.init();
            }

            function getCriteria() {
                var criteria = new Criteria();
                if(StringUtils.isNotEmpty(self.nomeText)){
                    criteria.append(" EXISTS( SELECT 1 FROM TGFPAR WHERE this.CODPARC = TGFPAR.CODPARC AND TGFPAR.NOMEPARC LIKE '%?%' ");

                    if(StringUtils.isNotEmpty(self.cpfText)){
                        criteria.append(" AND this.CGC_CPF = ? )");
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, self.nomeText));
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, self.cpfText.toString()));
                    }else{
                        criteria.append(" )");
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, self.nomeText));
                    }

                    if(StringUtils.isNotEmpty(self.cpfText) && StringUtils.isNotEmpty(criteria.getExpression())){
                        criteria.append(" EXISTS( SELECT TGFPAR.CODPARC FROM TGFPAR WHERE this.CODPARC = TGFPAR.CODPARC AND TGFPAR.CGC_CPF = ? )");
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, self.cpfText.toString()));
                    }

                    if(StringUtils.isNotEmpty(self.numCartaoText)){
                        if(StringUtils.isNotEmpty(criteria.getExpression())){
                            criteria.append(" AND ");
                        }
                        criteria.append(" this.NROCARTAO = ?");
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, self.numCartaoText.toString()));
                    }

                    return criteria;
                }
            }

            function carregaFiltro(){
                self.dsCartaoCredito.refresh();
            }

            function dataValue(){
                var params = {
                    codParc : self.dsCartaoCredito.getFieldValue("CODPARC")
                }
                return params;
            }

            function callBack(){
                $popupInstance.success(dataValue());
            }

            function selecionaParceiro(){
                callBack();
            }

        }
    ]);

angular
    .module('snk.commons')
    .controller('PopupFiltraEstoqueController', ['$popupInstance', '$scope', 'StringUtils', 'ObjectUtils', 'resourceID', 'SkFilter', 'Trfilter',
        function ($popupInstance, $scope, StringUtils, ObjectUtils, resourceID, SkFilter, Trfilter) {
            var self = this;

            $scope.dsEstoque = null;
            self.resourceID = resourceID;

            $scope.transientFilter = Trfilter || undefined;

            self.onDatasetCreated = function (dataset) {
                $scope.dsEstoque = dataset;
            }

            $scope.$success = function () {
                var filter = angular.copy($scope.transientFilter);

                var expression = ObjectUtils.getProperty(filter, 'filterModel.expression');
                var assistent = ObjectUtils.getProperty(filter, 'filterModel.assistent');

                if (expression || assistent) {
                    if (angular.isDefined(assistent) && filter.mode == SkFilter.MODE_ASSISTENT) {
                        SkFilter.buildExpression(filter);

                        var newExpression = filter.filterModel.expression && filter.filterModel.expression.$;

                        if (StringUtils.isEmpty(newExpression) || !isValidAllowVariable(newExpression)) {
                            $popupInstance.success(null);
                            return;
                        }

                        if (!isValidAllowVariable(newExpression)) {
                            $popupInstance.success(null);
                            return;
                        }
                    } else if (angular.isDefined(expression) && filter.mode == SkFilter.MODE_EXPRESSION) {
                        if (StringUtils.isEmpty(expression['$']) || !isValidAllowVariable(expression['$'])) {
                            $popupInstance.success(null);
                            return;
                        }

                        if (!assistent && filter.filterModel.hasOwnProperty('assistent')) {
                            delete filter.filterModel.assistent;
                        } else if (assistent) {
                            filter.filterModel.assistent = angular.copy(assistent);
                        }
                    }
                }
                $popupInstance.success({ filter: filter, expression: expression, assistent: assistent });

            }


            function isValidAllowVariable(expressao) {
                expressao = expressao || '';

                if (expressao.indexOf("?") > -1) {
                    return false;
                }

                return true;
            }

        }

    ]);

angular
.module('snk.commons')
.controller('PopupFiltroPendenciasFinanceirasController', ['$popupInstance', '$scope', 'ServiceProxy', 'filtro',
    function ($popupInstance, $scope, ServiceProxy, filtro) {
        var self = this;

        const SIGLA_CONTROLE_INIBE_RECEITAS = "R";
        const SIGLA_CONTROLE_INIBE_DESPESAS = "D";
        var _inibeAcessoDespesas;
        var _inibeAcessoReceitas;

        self.groupRecDespAmbos = filtro.groupRecDespAmbos;
        self.groupRealProvAmbos = filtro.groupRealProvAmbos;

        self.chkDespesaEnabled = true;
        self.chkReceitaEnabled = true;
        self.chkAmbosEnabled = true;

        self.periodo = {
            dtIni: filtro.vencInicio,
            dtFin: filtro.vencFinal
        }

        function validateGroupRecDespAmbos() {
            if(!_inibeAcessoDespesas && !_inibeAcessoReceitas) {
                self.groupRecDespAmbos = "A";
            }

            if(_inibeAcessoDespesas || _inibeAcessoReceitas){
                if(!_inibeAcessoDespesas) {
                    self.groupRecDespAmbos = "-1";
                }
                if(!_inibeAcessoReceitas) {
                    self.groupRecDespAmbos = "1";
                }
            }
        }

        function loadAcessoRecDesp() {
            let params = {
                usuario: {
                    usuariologado: "true"
                }
            }

            ServiceProxy.callService("mge@SystemUtilsSP.getAcessosCadastroUsuario", params)
                .then((result) => {
                    let acessos = result.responseBody.acessos.controle;

                    _inibeAcessoDespesas = (angular.isDefined(acessos) && acessos.indexOf(SIGLA_CONTROLE_INIBE_DESPESAS) >= 0);
                    _inibeAcessoReceitas = (angular.isDefined(acessos) && acessos.indexOf(SIGLA_CONTROLE_INIBE_RECEITAS) >= 0);

                    self.chkDespesaEnabled = !_inibeAcessoDespesas;
                    self.chkReceitaEnabled = !_inibeAcessoReceitas;
                    self.chkAmbosEnabled = !_inibeAcessoDespesas && !_inibeAcessoReceitas;

                    validateGroupRecDespAmbos();
                });
        }

        loadAcessoRecDesp();

        $scope.$success = function () {
            filtro.vencInicio = self.periodo.dtIni;
            filtro.vencFinal = self.periodo.dtFin;
            filtro.groupRecDespAmbos = self.groupRecDespAmbos;
            filtro.groupRealProvAmbos = self.groupRealProvAmbos;
            $popupInstance.success(filtro);
        }

    }

]);

angular
	.module('snk.commons')
	.component('skVendaMais', {
		templateUrl: 'commons/fichaparceiro/VendaMais/VendaMais.tpl.html',
		controller: 'VendaMaisController as ctrl',
		bindings: {
			CODPARC: '=?skCodparc',
			resourceID: '=?skResourceId',
			eventBus: '=?skEventbus',
		}
	})
	.controller('VendaMaisController',['MGEParameters', '$scope', 'ServiceProxy', 'i18n', 'SanPopup', '$timeout',
        function(MGEParameters, $scope, ServiceProxy, i18n, SanPopup, $timeout) {
			
			var self = this; 
			
			self.carregarScript = carregarScript;
			self.carregaInfo = carregaInfo;
			self.constroiHtml = constroiHtml;
			
			var infos;
			var sasId;
			var partnerCode;
			var personType;
			var environment;
			var flagInit = false;

			self.urlVendaMais = MGEParameters.asString("fin.url.ambiente.venda.mais");
			self.eventBus.addEventListener('eventoIndicadoresToVendaMais', function(codParc) {partnerCode = codParc, init()})
			
			init();
			
			function init (){
				
					
				ServiceProxy.callService('mgefin@VendaMaisProviderSP.getAmbienteInfo', {}).then(function (response) {
					document.querySelectorAll('sankhya-venda-mais').forEach(el => el.remove());    
					let result = response.responseBody; 
					sasId = result.idSAS;
					partnerCode = self.CODPARC; 
					environment = result.ambiente;
					
					if(angular.isDefined(partnerCode)){
						
						self.expressao = "CODPARC = "+ partnerCode;
						
						var params = {
		                        entity: {
		                            name: 'Parceiro',
		                            literalCriteria: {
		                                expression: {
		                                    $: self.expressao
		                                }
		                            },
		                            fields: {
		                                field: [{ name: 'CGC_CPF' }, { name: 'TIPPESSOA' }]
		                            }                            
		                        }
		                };
		                
		                ServiceProxy.callService("mge@crud.find", params)
		                .then(function (response) {
							
							cpnjPartner = response.responseBody.entidades.entidade?.CGC_CPF.$
							personType = response.responseBody.entidades.entidade?.TIPPESSOA.$
							carregaInfo(cpnjPartner, personType);
							if(!customElements.get('sankhya-venda-mais')){
								carregarScript();
		                	}
							constroiHtml();
		                	sankhyaVendaMaisAddEventListener();
		                	flagInit = true;
						});					
					}
                });
			}

			function carregarScript (){
					let node = document.createElement('script');
					node.src = self.urlVendaMais;
					node.type = 'text/javascript';
					node.async = true;
					document.getElementsByTagName('head')[0].appendChild(node);
			}
			
			function carregaInfo(cpnj, tippessoa){
				
				self.dados = {
                    'sasId': sasId,
                    'partnerCode': partnerCode,
                    'cnpjPartner': cpnj,
                    'pathTemplate': 'creditRequestOption',
                    'enviroment':environment,
                    'isFinance': true,
                    'personType': tippessoa
                }

                infos = btoa(JSON.stringify(self.dados));
			}
					
            function sankhyaVendaMaisAddEventListener (){
                let sankhyaVendaMais = document.querySelector('sankhya-venda-mais');
                sankhyaVendaMais.addEventListener('onCallbackEvent', handleSankhyaVendaMaisCallbackEvent);
            }

            function handleSankhyaVendaMaisCallbackEvent(event) {
                let eventDetail = event.detail;
                switch(eventDetail.name){
                   case 'POPUP_TRACK_CREDIT_REQUEST':
                        $timeout(function () {
							abrirPopUpAcompanhamento();
							self.popUpAcompanhamento.opened.then(function() {
                			});
                		}, 200);
                    break;								
                }
            }
                 
            function abrirPopUpAcompanhamento() {
				
				self.dadosPopUp = {
                    'sasId': sasId,
                    'partnerCode': partnerCode,
                    'pathTemplate': 'popUpTrackCreditApplication',
                    'enviroment':environment,
                    'isFinance': false
                }

                $scope.infosPopUpAcompanhamento = btoa(JSON.stringify(self.dadosPopUp));
				
                self.popUpAcompanhamento = SanPopup.open({
                    title: i18n('Comercial.FichaParceiro.popUpAcompanhamentoSolicitacaoVendaMais'),
                    template: '<sankhya-venda-mais params='+ $scope.infosPopUpAcompanhamento +'/>',
                    size: 'lg',
                    height: 410,
                    showBtnOk: false,
                    showBtnCancel: true,
                    showIconClose: true,
                    cancelBtnLabel: i18n("Comercial.FichaParceiro.lblVoltar"),
                    resolve: {
                    }
                });             
            }
            
            function constroiHtml(){
				document.getElementById("vendaMais")
                .innerHTML += "<sankhya-venda-mais params=" + infos +"></sankhya-venda-mais>";
			}
		}
	]);

angular
    .module('snk.commons')
    .controller('FileUploadController',['MessageUtils', 'i18n','infoPopUp', '$scope', '$popupInstance', 'SkFileInputConstant', 'ObjectUtils',
        function (MessageUtils, i18n, infoPopUp, $scope, $popupInstance, SkFileInputConstant, ObjectUtils) {
            var self = this;
            self.customFileUploader = infoPopUp.customFileUploader;
            self.fileKey = infoPopUp && infoPopUp.fileKey ?  infoPopUp.fileKey : '';
            self.uploadState = uploadState;

            $scope.$success = function uploadSuccess (){
                if(!self.fileUpload || !self.fileUpload.$state || !self.fileUpload.$value) {
                    MessageUtils.showAlert(i18n('Commons.FileUpload.alertArquivo'));
                } else if(self.fileUpload.$state == SkFileInputConstant.UPLOAD_SUCCESS){
                    $popupInstance.success(self.fileUpload);
                }
            }

            function uploadState($state, $value, $component){
                self.fileUpload = {
                    $state: $state, 
                    $value: $value,
                    $component : $component
                };
            }

        }]);
angular
    .module('snk.commons')
    .service('FileUploadService',['SanPopup', 'i18n',
        function ( SanPopup, i18n){
            var self = this;
            self.openPopUp = openPopUp;


        function openPopUp(infoPopUp){
            return SanPopup.open({
            title: infoPopUp.title  ? infoPopUp.title : i18n('SanUtil.SessionFileUpload.titleAnexo'),
                    templateUrl: 'commons/fileUpload/fileUpload.tpl.html',
                    controller: 'FileUploadController',
                    controllerAs: 'ctrl',
                    size: 'sm', //Tamanho do popup
                    okBtnLabel: 'Enviar',
                    showBtnNo: false,
                    noBtnLabel: 'Fechar',
                    windowClass: 'no-padding-modal-body',
                    resolve: {
                        infoPopUp : infoPopUp
                    }
            }).result;
        }

        }]);
/**
 * Created by jhonathan.cruz on 12/03/2026.
 */

angular.module("snk.commons").service("FintechUtilsService", [
  "SanPopup",
  "SkI18nService",
  function(SanPopup, SkI18nService) {
    var self = this;

    self.openErpCobrancaPix = openErpCobrancaPix;
    self.injectErpCobrancaPix = injectErpCobrancaPix;

    const WAITING_PAYMENT = "WAITING_PAYMENT";
    const CANCELED = "CANCELED";
    const ERROR = "ERROR";
    const PAID = "PAID";
    const CANCELLATION_PROCESSING = "CANCELLATION_PROCESSING";
    const CANCELAR_COBRANCA = "CANCELAR_COBRANCA";
    const ERROS = ["VERIFICAR_STATUS_SERVICO", "BUSCAR_COBRANCA", "CRIAR_COBRANCA", "VERIFICAR_STATUS_COBRANCA"];

    const erroGeracaoPix = (event) => {
        if(CANCELAR_COBRANCA === event?.detail){
            erroGeracaoPix?.cancelarPixFintech?.();
        } else if(ERROS.includes(event.detail)){
            erroGeracaoPix?.removerFinanceiro?.(true);
        }    
    };

    const closePopUp = (event) => {
        if(event?.detail?.status === WAITING_PAYMENT || event?.detail?.status === CANCELLATION_PROCESSING || event?.detail == undefined){
            erroGeracaoPix?.cancelarPixFintech?.();
        } else if(event?.detail?.status === CANCELED){
            erroGeracaoPix?.removerFinanceiro?.(true);
        } else if(event?.detail?.status === PAID){
            closePopUp?.callBackSucess?.();
        }
        
    };

    erroGeracaoPix.removerFinanceiro = null;
    erroGeracaoPix.cancelarPixFintech = null;
    closePopUp.callBackSucess = null;




    async function injectErpCobrancaPix(){
        if(document.getElementById("erp-cobranca-pix")) {
            return;
        }

        const script = document.createElement("script");
        script.id = "fintech-webcomponents-el";
        script.type = "module";
        script.src = `${window.location.origin}/fintech/webcomponents/fintech-webcomponents/fintech-webcomponents.esm.js`;
        script.onload = () => {
            console.log("WebComponent <erp-cobranca-pix /> carregado!");
            const el = document.createElement("erp-cobranca-pix");
            el.id = "erp-cobranca-pix";
            document.body.appendChild(el);            
        };

        document.head.appendChild(script);
    }

    async function openErpCobrancaPix(nuFin, codContaFintech, callBackSucess, callBackError, cancelarPixFintech) {

        try {
            const erpCobrancaPixElement = document.getElementById("erp-cobranca-pix");
            
            if(!erpCobrancaPixElement) {
                throw new Error('Componente ErpCobrancaPix não identificado!');
            }

             erroGeracaoPix.removerFinanceiro = callBackError;
             erroGeracaoPix.cancelarPixFintech = cancelarPixFintech;
             closePopUp.callBackSucess = callBackSucess;
            
            erpCobrancaPixElement.NUFIN = nuFin;
            erpCobrancaPixElement.CODCTABCOINT = codContaFintech;
            //Se já tiver um pix, esse campo deve ser preenchido com o pix já existente.
            //erpCobrancaPixElement.EMVPIX = "";
            erpCobrancaPixElement.removeEventListener('cobrancaPixAtualizada', closePopUp);
            erpCobrancaPixElement.addEventListener('cobrancaPixAtualizada', closePopUp);
            erpCobrancaPixElement.removeEventListener('cobrancaPixErro', erroGeracaoPix);
            erpCobrancaPixElement.addEventListener('cobrancaPixErro', erroGeracaoPix);
            
            await erpCobrancaPixElement.open();
            
        } catch (error) {
            console.log(error);
            MessageUtils.showError(MessageUtils.TITLE_ERROR, error.message);	
        }
      }


  }
]);

/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .component('formatadorCuboRelatorio', {
        templateUrl: 'commons/formatadorcuborelatorio/FormatadorCuboRelatorio.tpl.html',
        controller: 'FormatadorCuboRelatorioController',
        bindings: {
            onContentCreated: '&',
            tipoRel: '=',
            relatoriosDp: '=',
            getCodRelFunction: '&',
            changeRelFunction: '&?',
            locateFunction: '&',
            carregarRelatorios: '&',
            relatorioSelecionado: '=',
            callBack: '&?'
        }
    }).controller('FormatadorCuboRelatorioController', ['i18n', 'Criteria', 'MessageUtils', 'SanPopup', 'ServiceProxy', 'ParamsGenFieldProxy', 'ObjectUtils',
        function (i18n, Criteria, MessageUtils, SanPopup, ServiceProxy, ParamsGenFieldProxy, ObjectUtils) {
            var self = this;

            var _publicAPI = {};
            var _relatorioSelecionado = self.relatorioSelecionado;
            var _popUpRelatorio;
            var _listaImagens = [];
            var _selecaoCampos;

            self.optOrientation = [
                { data: i18n('Core.FormatadorCuboRelatorio.optPortrait'), value: 'Retrato' },
                { data: i18n('Core.FormatadorCuboRelatorio.optLandscape'), value: 'Paisagem' }
            ];

            self.orientation;
            self.paramsField;
            self.resumoField;
            self.ds;
            self.ckcImpDet = false;
            self.ckcImpTot = false;
            self.ckcContReg = false;
            self.ckcDistinct = false;
            self.ckcImprimeLogo = false;
            self.ckcAmpliarLogo = false;
            self.selectedIndex = 0;
            self.logomarca = '';
            self.alturaLogo = 40;
            self.larguraLogo = 40;
            self.distanciaLogo = 0;
            self.popUpRelatoriosVisibled = false;
            self.arvoreCampos;

            //Public Function
            _publicAPI.setCanInsert = setCanInsert;
            _publicAPI.setCanUpdate = setCanUpdate;
            _publicAPI.setCanRemove = setCanRemove;
            _publicAPI.reload = reload;
            _publicAPI.setRelatorioSelecionado = setRelatorioSelecionado;

            //Private Function
            self.$onInit = $onInit;
            self.openPopUpRelatorios = openPopUpRelatorios;
            self.changeFlagResumoField = changeFlagResumoField;
            self.changeParamsField = changeParamsField;
            self.listarImagens = listarImagens;
            self.onCreateCompleteSelecao = onCreateCompleteSelecao;
            self.carregarCamposTipoRelatorio = carregarCamposTipoRelatorio;
            self.getGrupoFromItem = getGrupoFromItem;

            function $onInit() {

                self.onContentCreated({
                    $instance: _publicAPI
                });
            };

            self.onDatasetCreated = function (dataset) {

                self.ds = dataset;

                var recordValidator = new RecordValidator();
                recordValidator.validate = function (record, nullFieldNames) {

                    var item = new Object();
                    item.ESCOLHIDOS = record[self.ds.getFieldIndexByName('ESCOLHIDOS')];

                    try {
                        if (self.paramsField) {
                            self.paramsField.validate();
                        }

                        if (self.resumoField) {
                            self.resumoField.validate();
                        }

                        if (!item.ESCOLHIDOS) {
                            throw new Error(i18n("Core.FormatadorCuboRelatorio.msgNoFieldsSelected"));
                        }
                    } catch (error) {
                        MessageUtils.showAlert(i18n("Core.FormatadorCuboRelatorio.titleSaveReport"), error);
                        return false;
                    }

                    return true;
                };

                self.ds.addRecordValidator(recordValidator);

                self.ds.beforePostAction(beforePost);

                self.ds.afterCopyAction(function (ds) {

                    var nome = self.ds.getFieldValueAsString("NOME");
                    if (nome.length > 32) {
                        nome = nome.substr(0, 32);
                    }
                    self.ds.setFieldValue("NOME", nome + " " + i18n("Core.FormatadorCuboRelatorio.lblCopia"));
                });

                self.ds.addInsertionModeListener(function () {

                    if (!self.ds.isCopyingRecord()) {
                        self.ds.setFieldValue("RESUMO", "    DTC    ");
                    }

                    self.changeRelFunction(null, false);
                });

                self.ds.addDataSavedListener(function (isNew, records) {

                    var relatorioSelecionado = self.ds.getFieldValueAsNumber("CODREL");

                    if (isNew) {
                        relatorioSelecionado = records[0][self.ds.getFieldIndexByName('CODREL')];
                    }
                    self.carregarRelatorios({
                        'callBack': function (relatoriosDpChanged) {

                            self.relatoriosDp = relatoriosDpChanged;

                            if (self.relatoriosDp) {

                                var itemNode = undefined;

                                if (!angular.isArray(self.relatoriosDp[0].node)) {
                                    self.relatoriosDp[0].node = [self.relatoriosDp[0].node];
                                }
                                self.relatoriosDp[0].node.forEach(function (item) {

                                    if (item.codRel == relatorioSelecionado) {
                                        itemNode = item;
                                        return false;
                                    }
                                });

                                if (itemNode) {
                                    self.changeRelFunction({ item: itemNode.label, ehFormatador: false, selecionaPai: true });
                                }
                            }
                        }
                    });
                });

                self.ds.addDataModifiedListener(function (modifiedField) {

                    if (self.ds.getFieldValue("PERSONALIZADO") == 'S' || self.ds.getFieldValue("TEMLAYOUTSW") == 'S') {
                        self.ds.setFieldValue("TEMLAYOUTSW", 'N');
                        self.ds.setFieldValue("PERSONALIZADO", 'N');

                        if (!self.ds.isCopyingRecord()) {
                            MessageUtils.simpleConfirm(
                                i18n("Core.FormatadorCuboRelatorio.titlePersonalizedLayout"),
                                i18n("Core.FormatadorCuboRelatorio.msgPersonalizedWarning"))
                                .then(function () { }
                                    , function () {
                                        self.ds.cancelEdition();
                                    });

                        }
                    }
                });

                self.ds.addRecordRemovedListener(function (record) {
                    self.carregarRelatorios({
                        'callBack': function (relatoriosDpChanged) {
                            self.changeRelFunction(null, false);
                        }
                    });
                });

                self.ds.whenMetadataLoaded().then(function () {
                    dsIsReady();
                });

                self.ds.init().then(function () {
                    creationCompleteHandler();
                });
            }

            function setCanInsert(value) {
                self.ds.setCanInsert(value);
            }

            function setCanUpdate(value) {
                self.ds.setCanEdit(value);
            }

            function setCanRemove(value) {
                self.ds.setCanRemove(value);
            }

            function creationCompleteHandler() {

                carregarCamposTipoRelatorio();

                self.ds.addCriteriaProvider(getCriteria);
            }

            function getCriteria() {

                var criteria = Criteria();

                var codRel = self.getCodRelFunction();

                if (!codRel || codRel == null) {
                    self.ds.clearDataSet();
                    criteria.append("1 = 0");
                } else {
                    criteria.append("this.CODREL = ? ", Criteria.buildNumberParameter(codRel));
                }

                return criteria;
            };

            function carregarCamposTipoRelatorio(callBack) {

                ServiceProxy.callService('mge@MGEReport.getArvoreCampos', { cubo: { tipo: self.tipoRel } })
                    .then(function (result) {

                        self.arvoreCampos = result.responseBody.campo;

                        if (!angular.isArray(self.arvoreCampos.campo)) {
                            self.arvoreCampos.campo = [self.arvoreCampos.campo];
                        }

                        if (self.callBack) {
                            self.callBack();
                        }

                    });
            }

            function reload() {
                self.ds.refresh();
            }

            function setRelatorioSelecionado(item) {
                _relatorioSelecionado = item;
                mostraItemSelecionado();
            }

            function mostraItemSelecionado() {

                if (!self.ds.isInsertionMode()) {
                    if (self.ds.isEmpty() || (self.getCodRelFunction() != self.ds.getFieldValueAsString("CODREL"))) {
                        self.ds.refresh();
                    }
                }
            }

            function dsIsReady() {

                self.resumoField = new ResumoFieldProxy(self.ds);
                window.addEventListener("changeResumoFieldProxy", function (e) {
                    self.ckcImpDet = self.resumoField.getFlagValue("D");
                    self.ckcImpTot = self.resumoField.getFlagValue("T");
                    self.ckcContReg = self.resumoField.getFlagValue("C");
                    self.ckcDistinct = self.resumoField.getFlagValue("I");
                });

                self.paramsField = new ParamsGenFieldProxy(self.ds);
                window.addEventListener("changeGenFieldProxy", function (e) {
                    self.ckcImprimeLogo = self.paramsField.getParamValue("ImprimirLogomarca") == "S";
                    self.logomarca = self.paramsField.getParamValue('PathLogomarca');
                    self.ckcAmpliarLogo = self.paramsField.getParamValue("AmpliadoLogomarca") == "S";
                    self.alturaLogo = Number(self.paramsField.getParamValue("AlturaLogomarca"));
                    self.larguraLogo = Number(self.paramsField.getParamValue("LarguraLogomarca"));
                    self.distanciaLogo = Number(self.paramsField.getParamValue("DistanciaLogomarca"));
                });

                self.ds.refresh();

                if (_selecaoCampos) {
                    _selecaoCampos.init();
                    _selecaoCampos.setResumoField(self.resumoField);
                    _selecaoCampos.setParamsGenField(self.paramsField);
                }
            }

            function beforePost(dataSet) {

                dataSet.setFieldValue("TIPO", self.tipoRel);
                dataSet.setFieldValue("CODEMP", 1);

                if (dataSet.isInsertionMode()) {
                    dataSet.setFieldValue("PERSONALIZADO", "N");
                    dataSet.setFieldValue("TIPOFONTE", "ARIAL");
                    dataSet.setFieldValue("TAMFONTE", 8);

                    if (self.paramsField) {
                        dataSet.setModified(self.paramsField);
                    }

                    if (self.resumoField) {
                        dataSet.setModified(self.resumoField);
                    }

                }
            }

            function openPopUpRelatorios() {

                _popUpRelatorio = SanPopup.open({
                    title: i18n('Core.FormatadorCuboRelatorio.lblPopUpRelatorios'),
                    templateUrl: 'commons/formatadorcuborelatorio/popup/PopUpRelatorio.tpl.html',
                    controller: 'PopUpRelatorioController',
                    controllerAs: 'ctrl',
                    size: 'sm',
                    height: '500',
                    showBtnNo: false,
                    showBtnCancel: false,
                    showBtnOk: false,
                    animation: false,
                    windowClass: 'popUpRelatorio',
                    resolve: {
                        data: {
                            relatoriosDP: self.relatoriosDp,
                            relatorioSelecionado: _relatorioSelecionado,
                            changeRelatorio: function (item) {
                                self.changeRelFunction({ item: item.label, ehFormatador: false, selecionaPai: true });
                            },
                            locateFunction: function (textFilter, nodesTree, treeControl) {
                                self.locateFunction({ textFilter: textFilter, ehFormatador: true, nodesTree: nodesTree, treeControl: treeControl });
                            }
                        }
                    }
                });
                _popUpRelatorio.result.then(function (result) {

                });
            }

            function changeFlagResumoField(key, value) {

                if (self.resumoField) {
                    self.resumoField.setFlag(key, value);
                }
            }

            function changeParamsField(key, value) {

                if (self.paramsField) {
                    self.paramsField.setParamValue(key, value);
                }
            }

            function listarImagens() {

                ServiceProxy.callService('mge@FormatadorCubosRelatoriosSP.carregarListaImagensModelo', {})
                    .then(function (result) {

                        _listaImagens = ObjectUtils.getProperty(result, 'responseBody.imagens.imagem');

                        openPopUpListarImagens();
                    });
            }

            function onCreateCompleteSelecao(instance) {
                _selecaoCampos = instance;
            }

            function openPopUpListarImagens() {

                SanPopup.open({
                    title: i18n('Core.FormatadorCuboRelatorio.titlePopUpImagens'),
                    templateUrl: 'commons/formatadorcuborelatorio/popup/PopUpImagens.tpl.html',
                    controller: 'PopUpImagensController',
                    controllerAs: 'ctrl',
                    size: 'sm',
                    height: '300',
                    showBtnNo: false,
                    showBtnCancel: false,
                    windowClass: 'popUpRelatorio',
                    keyboard: false,
                    useCache: false,
                    resolve: {
                        data: {
                            listaImagens: _listaImagens,
                            escolherImagemCallBack: escolherImagem
                        }
                    }
                }).result
                    .then(function (result) { });
            }

            function escolherImagem(imagem, popup) {
                self.logomarca = imagem;
                changeParamsField('PathLogomarcaSW', self.logomarca);
                popup.dismiss();
            }

            function getGrupoFromItem(item){
                while(angular.isDefined(item)){
                    if(item.isViewReport.toString() == "N"){
                        return item.codRel.toString();
                    }
                    item = item.parent();
                }
                return null;
            }
        }]);

/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .provider('ParamsGenFieldProxy', [function () {

        this.$get = ['SkI18nService', 'ArrayUtils', 'StringUtils', function (_SkI18nService, _ArrayUtils, _StringUtils) {
            SkI18nService = _SkI18nService;
            ArrayUtils = _ArrayUtils;
            StringUtils = _StringUtils;
            return ParamsGenFieldProxy;
        }];

        function ParamsGenFieldProxy(dataset) {

            if (!(this instanceof arguments.callee)) {
                return new ParamsGenFieldProxy(dataset);
            }

            this.scope = angular.element(document).scope().$root.$new();
            this.scope.dataset = dataset;
            this.scope.dataset.addFieldBinder(this);
            this.setData = (setData || angular.noop);
            this.getData = (getData || angular.noop);

            this.setParamValue = setParamValue;
            this.getParamValue = getParamValue;
            this.getFieldName = getFieldName;
            this.validate = validate;

            var _paramValues = new Object();

            var _paramKeys = [
                'MargemSuperior',
                'MargemInferior',
                'MargemEsquerda',
                'MargemDireita',
                'QtdLinhas',
                'SaltaPagina1',
                'SaltaPagina2',
                'SaltaPagina3',
                'SaltaPagina4',
                'ImprimirLogomarca',
                'AmpliadoLogomarca',
                'AlturaLogomarca',
                'LarguraLogomarca',
                'DistanciaLogomarca',
                'chkFrenteVerso',
                'PathLogomarca'
            ];

            var _defaultValues = {
                MargemSuperior: 10,
                MargemInferior: 15,
                MargemEsquerda: 10,
                MargemDireita: 15,
                QtdLinhas: 0,
                SaltaPagina1: 'N',
                SaltaPagina2: 'N',
                SaltaPagina3: 'N',
                SaltaPagina4: 'N',
                ImprimirLogomarca: 'N',
                AmpliadoLogomarca: 'N',
                AlturaLogomarca: 45,
                LarguraLogomarca: 45,
                DistanciaLogomarca: 2,
                chkFrenteVerso: 'N'
            };

            this.initializePrototype();

            function setFieldName(fieldName) {
            }

            function getFieldName() {
                return 'PARAMSGEN';
            }

            function getData() {
                var params = new Array();

                var values = angular.copy(_paramValues);

                _paramKeys.forEach(function (key) {
                    if (values.hasOwnProperty(key)) {
                        values.propertyIsEnumerable(key);
                        params.push(key + '=' + values[key]);
                    } else {
                        if (_defaultValues.hasOwnProperty(key)) {
                            params.push(key + '=' + _defaultValues[key]);
                        }
                    }
                });

                for (key in values) {

                    var existsKey = false;
                    params.forEach(function (param) {
                        var obj = param.split('=');
                        var objKey = obj[0];
                        var objeValue = obj[1];

                        if (key == objKey) {
                            existsKey = true;
                        }

                        if (existsKey && values[key] != objeValue) {
                            param = key + '=' + values[key];
                        }
                    });

                    if (!existsKey) {
                        params.push(key + '=' + values[key]);
                    }
                }

                return params.join('\n');
            }

            function setData(newDataValue) {

                var strValue = newDataValue;
                _paramValues = new Object();

                if (strValue) {
                    strValue.split(/[\r\n]+/).forEach(function (item) {
                        var pair = item.split("=");
                        if (pair.length == 2) {
                            _paramValues[pair[0]] = pair[1];
                        }
                    });
                }

                window.dispatchEvent(new Event("changeGenFieldProxy"));
            }

            function setParamValue(key, value) {

                if (StringUtils.isEmpty(value)) {
                    delete _paramValues[key]
                } else {
                    _paramValues[key] = value;
                }

                this.scope.dataset.notifyEditionStart(this);
                this.scope.dataset.setModified(this);
            }

            function getParamValue(key) {
                if (key == 'PathLogomarca' && _paramValues.hasOwnProperty('PathLogomarcaSW')) {
                    key = 'PathLogomarcaSW';
                }
                var value = _paramValues.hasOwnProperty(key) ? _paramValues[key] : null;

                if (value == null && _defaultValues.hasOwnProperty(key)) {
                    value = _defaultValues[key];
                }

                return value;
            }

            function validate() {
                if (getParamValue('ImprimirLogomarca') == 'S' && getParamValue('PathLogomarca') == null) {
                    throw new Error(SkI18nService.instant('Core.FormatadorCuboRelatorio.msgFaltaLogomarca'));
                }
            }
        }

        ParamsGenFieldProxy.prototype = new FieldBinder();
    }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
function ResumoFieldProxy(dataset) {

    var self = this;

    var _flags = ['1', '2', '3', '4', 'D', 'T', 'C', 'F', 'A', 'I', 'Q', 'P'];
    var _flagValues;

    if (!(self instanceof arguments.callee)) {
        return new ResumoFieldProxy(dataset);
    }

    self.scope = angular.element(document).scope().$root.$new();
    self.scope.dataset = dataset;
    self.scope.dataset.addFieldBinder(this);
    self.setData = setData;
    self.getData = getData;
    self.validate = validate;
    self.setFlag = setFlag;
    self.getFlagValue = getFlagValue;
    self.getFieldName = getFieldName;

    self.initializePrototype();

    function getData() {
        return _flagValues;
    }

    function setData(newDataValue) {

        _flagValues = newDataValue;

        if (angular.isUndefined(_flagValues) || _flagValues == null) {
            _flagValues = '';
        }

        window.dispatchEvent(new Event('changeResumoFieldProxy'));
    }

    function validate() {
    }

    function setFlag(flag, value) {

        var newValue = '';

        _flags.forEach(function (f) {

            if (f == flag) {
                newValue += value ? f : ' ';
            } else {
                newValue += getFlagValue(f) ? f : ' ';
            }
        });

        _flagValues = newValue;
        self.scope.dataset.notifyEditionStart(self);
        self.scope.dataset.setModified(self);
    }

    function getFlagValue(flag) {

        if (angular.isUndefined(_flagValues)) {
            return false;
        }

        return _flagValues.indexOf(flag) > -1;
    }

    function getFieldName() {
        return 'RESUMO';
    }

    function setFieldName(fieldName) { }
}

ResumoFieldProxy.prototype = new FieldBinder();
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .provider('FilterVariablesBuilder', [function () {

        var isRequiredValue = '';
        var type = '';
        var entity = '';
        var finalExpression = '';

        const META_START = "/*{";
        const META_END = "}*/";

        var requiredTpl = "req={0}";
        var entityTpl = "entity={0}";
        var typeTpl = "type={0}";

        this.$get = ['StringUtils', function (StringUtils) {

            return function (_isRequired, _type, _entity) {
                return new FilterVariablesBuilder(_isRequired, _type, _entity);
            }

            function FilterVariablesBuilder(_isRequired, _type, _entity) {

                var isRequired = angular.isUndefined(_isRequired) ? false : _isRequired;
                isRequiredValue = isRequired ? "s" : "n";
                type = angular.isUndefined(_type) ? null : _type;
                entity = angular.isUndefined(_entity) ? null : _entity;

                var self = this;
                self.buildExpression = buildExpression;

                buildExpression();
                function buildExpression() {
                    var requiredParam = StringUtils.substitute(requiredTpl, isRequiredValue);
                    var entityParam = '';
                    var typeParam = '';

                    if (StringUtils.emptyAsNull(entity) != null) {
                        entityParam = StringUtils.substitute(entityTpl, entity);
                    }

                    if (StringUtils.emptyAsNull(type) != null) {
                        typeParam = StringUtils.substitute(typeTpl, type);
                    }

                    var paramsArray = new Array(requiredParam, entityParam, typeParam).filter(function (v) { return v != '' });
                    finalExpression = META_START + paramsArray.join(";") + META_END;
                    return finalExpression;
                }
            }
        }];
    }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .component('parametrosRelatorio', {
        templateUrl: 'commons/formatadorcuborelatorio/popup/ParametrosRelatorio.tpl.html',
        controller: 'ParametrosRelatorioCompController',
        bindings: {
            onContentCreated: '&'
        }
    })
    .controller('ParametrosRelatorioCompController', [
        function () {

            var self = this;

            self.fieldsParams = [];

            // Funções publicas disponíveis no controlador PAI
            var _publicAPI = {};
            _publicAPI.getParametrosRelatorio = getParametrosRelatorio;
            _publicAPI.buildAllFields = buildAllFields;


            self.$onInit = $onInit;

            function $onInit() {
                self.onContentCreated({
                    $instance: _publicAPI
                });

            }

            function getParametrosRelatorio() {
                return self.fieldsParams;
            }

            function buildAllFields(paramsRelatorio) {
                if(!angular.isArray(paramsRelatorio)){
                    paramsRelatorio = [paramsRelatorio];
                }

                paramsRelatorio.forEach(function (param) {
                    var lastValue = undefined;

                    if (param.lastValue) {
                        lastValue = param.lastValue;
                    }

                    createField(param, lastValue, param.tipo, param.precision);

                });
            }

            function createField(label, lastValue, tipo, precision) {
                var formItem = { label: getObjectValue(label) };
                formItem.dateField = tipo;
                formItem.precision = precision;

                try {
                    if (lastValue) {
                        formItem.text = lastValue;
                    }
                } catch (ignored) {
                    formItem.text = "";
                }

                self.fieldsParams.push(formItem);
            }

            function getObjectValue(value) {
                try {
                    return value.$;
                }
                catch (e) {
                    return null;
                }

            }
        }
    ]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('ParametrosRelatorioController', ['data', '$scope', '$popupInstance', 'DateUtils','DateUtilsConstants',
        function (data, $scope, $popupInstance, DateUtils,DateUtilsConstants) {
            var self = this;

            self.fieldsParams = data.fieldsParams;
            self.finishHandler = data.finishHandler;
            self.paramsRelatorio = data.paramsRelatorio;
            self.finish = finish;
            self.finishSupressingParams = finishSupressingParams;
            self.close = close;
            self.onContentCreated = onContentCreated;

            var paramsRelatorioComponent;

            function onContentCreated(instance) {
                paramsRelatorioComponent = instance;
                paramsRelatorioComponent.buildAllFields(self.paramsRelatorio);
            }

            function finish() {
                if (self.finishHandler != null) {
                    var dadosParams = { params: { param: [] } };

                    self.fieldsParams = paramsRelatorioComponent.getParametrosRelatorio();

                    self.fieldsParams.forEach(function (field) {

                        if (field.dateField == 'D'  || field.dateField == 'H') {
                            field.text = DateUtils.formatDate(field.text, field.dateField == 'H' ? DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS : DateUtilsConstants.DEFAULT_DATE_FORMAT);
                        }

                        var paramObj = field.text ? { $: field.text } : { $: '#supressedParam#' };

                        dadosParams.params.param.push(paramObj);

                    });

                    self.finishHandler(dadosParams);
                }

                $scope.$success();
            }

            function finishSupressingParams() {

                if (self.finishHandler != null) {
                    var dadosParams = { params: [] };

                    self.fieldsParams = paramsRelatorioComponent.getParametrosRelatorio();

                    if (self.fieldsParams) {

                        self.fieldsParams.forEach(function (field) {
                            var paramObj = field.text ? { param: { $: field.text } } : { param: { $: '#supressedParam#' } };

                            dadosParams.params.push(paramObj);

                        });

                    }
                    self.finishHandler(dadosParams);
                }
                $scope.$success();
            }

            function close() {
                $popupInstance.dismiss();
            }

        }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('PopUpImagensController', ['$scope', 'data', '$popupInstance',
        function ($scope, data, $popupInstance) {
            var self = this;

            self.listaImagens = data.listaImagens;
            self.imagemSelecionada;

            //Functions
            self.escolherImagemCallBack = data.escolherImagemCallBack;
            self.escolherImagem = escolherImagem;
            self.setImageSelected = setImageSelected;
            self.getObjectValue = getObjectValue;
            $scope.$success = onSuccess;

            init();

            function init() {

                if (!self.listaImagens) {
                    self.listaImagens = [];
                }

                if (!angular.isArray(self.listaImagens)) {
                    self.listaImagens = [self.listaImagens];
                }
            }

            function getObjectValue(value) {
                try {
                    return value.$;
                }
                catch (e) {
                    return null;
                }

            }

            function onSuccess() {

                if (self.imageSelected) {
                    self.escolherImagemCallBack(self.imagemSelecionada, $popupInstance);
                } else {
                    self.escolherImagemCallBack('', $popupInstance);
                }

            }

            function escolherImagem(imagem) {
                self.imagemSelecionada = getObjectValue(imagem);
                self.escolherImagemCallBack(self.imagemSelecionada, $popupInstance);
            }

            function setImageSelected(imagem) {
                self.imagemSelecionada = getObjectValue(imagem);
                self.imageSelected = true;
            }
        }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('PopUpRelatorioController', ['data', '$timeout', 'SkConstants',
        function (data, $timeout, SkConstants) {
            var self = this;

            var _relatoriosDP = data.relatoriosDP;

            self.relatorioDPClone;

            self.relatorioSelecionado = data.relatorioSelecionado;
            self.textFilter = '';
            self.treeControle = {};

            self.onKeyPressLocate = onKeyPressLocate;
            self.onSelectTreeNode = onSelectTreeNode;
            self.locateFunction = data.locateFunction;
            self.locate = locate;

            self.createComplete = createComplete;
            self.changeRelatorio = data.changeRelatorio;

            function createComplete() {

                $timeout(function () {
                    if (self.relatorioSelecionado && self.relatorioSelecionado.data) {
                        positionItemNode(self.relatorioSelecionado.data.label);
                    }
                }, 400, false);
            }

            carregaArvoreRelatorio();

            function carregaArvoreRelatorio() {
                if(_relatoriosDP){
                    self.tree = buildNodes(_relatoriosDP);
                }
            }

            function buildNodes(data) {
                var nodes = [];


                if (!angular.isArray(data)) {
                    data = [data];
                }

                for (var i = 0; i < data.length; i++) {
                    nodes.push(getNode(data[i]));
                }

                return nodes;
            }

            function getNode(data) {
                return {
                    description: data.label,
                    label: data.label,
                    data: data,
                    children: data.node ? buildNodes(data.node) : [],
                    icon: data.iconField
                };
            }

            function onKeyPressLocate(event) {

                if (event.keyCode == SkConstants.KEY_CODE.ENTER) {
                    self.locate(self.textFilter);
                }
            }

            function onSelectTreeNode(item) {
                self.treeReport = item.data;

                arvoreRelatorios.selectedItem = item;

                self.changeRelatorio(item);
            }

            function locate(textFilter) {
                if(self.tree){
                    self.locateFunction(textFilter, self.tree, self.treeControle);
                }
            }

            function positionItemNode(nodeSelected) {
                self.locateFunction(nodeSelected, self.tree, self.treeControle);
            }
        }]);
angular
    .module('snk.commons')
    .controller('SegurancaContentController', ['data', 'i18n', 'ObjectUtils', 'Criteria', 'ServiceProxy',
        function (data, i18n, ObjectUtils, Criteria, ServiceProxy) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);

            self.navigatorIndex = 0;
            self.codRel = data.codRel;

            self.createDataSetAcessosGrupo = createDataSetAcessosGrupo;
            self.createDataSet = createDataSet;
            self.getCriteria = getCriteria;
            self.getCriteriaUsuarios = getCriteriaUsuarios;

            self.interceptColumnMetadata = interceptColumnMetadata;
            self.save = save;

            var linhaAtual = -1;

            function createDataSetAcessosGrupo(dataset) {
                self.dsAcessosGrupo = dataset;


                self.dsAcessosGrupo.addLineChangeListener(function (line) {
                    linhaAtual = line;

                    if (line > -1) {
                        self.vbxUsuariosLabel = i18n('Core.MgeReport.lblUserGrp') + self.dsAcessosGrupo.getFieldValueAsString("GrupoUsuario.NOMEGRUPO");
                    }
                });

                self.dsAcessosGrupo.init().then(function () {
                    loadRecordsAcessoGrupo();
                });
            }

            function interceptColumnMetadata(fieldMetadata, dataset) {
                if ("CODGRUPO" != fieldMetadata.name && "GrupoUsuario.NOMEGRUPO" != fieldMetadata.name && "NOMEUSU" != fieldMetadata.name) {
                    fieldMetadata.width = 90;
                    fieldMetadata.checkbox = true;
                    fieldMetadata.options = [{ data: 'S' }, { data: 'N' }];
                } else {
                    fieldMetadata.width = 110;
                }

            }

            function save(request) {
                var row = {
                    "entity": {
                        "name": "ControleAcessoRelatorio",
                        "campo": [{
                            "nome": "CODUSU",
                            "$": 0
                        }, {
                            "nome": "CODGRUPO",
                            "$": self.dsAcessosGrupo.getFieldValueAsString('CODGRUPO')
                        }, {
                            "nome": "CODREL",
                            "$": self.codRel
                        }, {
                            "nome": "CONS",
                            "$": self.dsAcessosGrupo.getFieldValueAsString('CONS')
                        }, {
                            "nome": "ALTERA",
                            "$": self.dsAcessosGrupo.getFieldValueAsString('ALTERA')
                        }, {
                            "nome": "FILTRO",
                            "$": self.dsAcessosGrupo.getFieldValueAsString('FILTRO')
                        }, {
                            "nome": "RESUMO",
                            "$": self.dsAcessosGrupo.getFieldValueAsString('RESUMO')
                        }, {
                            "nome": "SEGURANCA",
                            "$": self.dsAcessosGrupo.getFieldValueAsString('SEGURANCA')
                        }]
                    }
                };

                ServiceProxy.callService('mge@crud.save', row)
                    .then(function () {
                    });
            }

            function createDataSet(dataset) {
                self.dsAcessosUsuario = dataset;

                self.dsAcessosUsuario.addCriteriaProvider(getCriteria);

                self.dsAcessosUsuario.addInsertionModeListener(function () {
                    self.dsAcessosUsuario.setFieldValue("CODGRUPO", 0);
                    self.dsAcessosUsuario.setFieldValue("CODREL", self.codRel);
                    self.dsAcessosUsuario.setFieldValue("CONS", 'S');
                    self.dsAcessosUsuario.setFieldValue("ALTERA", 'S');
                    self.dsAcessosUsuario.setFieldValue("FILTRO", 'S');
                    self.dsAcessosUsuario.setFieldValue("RESUMO", 'S');
                    self.dsAcessosUsuario.setFieldValue("SEGURANCA", 'S');

                    self.navigatorIndex = 1;
                });

                self.dsAcessosUsuario.addDataSavedListener(function () {
                    self.navigatorIndex = 0;
                });

                self.dsAcessosUsuario.addEditionCanceledListener(function () {
                    self.navigatorIndex = 0;
                });

                self.dsAcessosUsuario.addRefreshedListener(function () {
                    self.navigatorIndex = 0;
                });

                self.dsAcessosUsuario.initAndRefresh();
            }

            function loadRecordsAcessoGrupo() {
                ServiceProxy.callService('mge@MGEReport.getControleAcessoGrupo', { seguranca: { codRel: self.codRel } })
                    .then(function (result) {

                        self.dsAcessosGrupo.setConditionalAutoSave(false);
                        self.dsAcessosUsuario.clearDataSet();

                        var rows = result.responseBody.controleAcesso.row;

                        if(rows){

                            if(! angular.isArray(rows)){
                                rows = [rows];
                            }

                            var records = [];

                            rows.forEach(function (row) {

                                var record = {};

                                record["CODGRUPO"] = Number(getObjectValue(row.CODGRUPO));
                                record["GrupoUsuario.NOMEGRUPO"] = String(getObjectValue(row.NOMEGRUPO));
                                record["CONS"] = String(getObjectValue(row.CONS));
                                record["ALTERA"] = String(getObjectValue(row.ALTERA));
                                record["FILTRO"] = String(getObjectValue(row.FILTRO));
                                record["RESUMO"] = String(getObjectValue(row.RESUMO));
                                record["SEGURANCA"] = String(getObjectValue(row.SEGURANCA));

                                records.push(record);

                            });

                            self.dsAcessosGrupo.clearDataSet();
                            self.dsAcessosGrupo.addRecordsAsObjects(records);
                        }

                        if (self.dsAcessosGrupo.size() > 0) {
                            self.dsAcessosGrupo.gotoRow(0);
                        } else {
                            self.vbxUsuariosLabel = i18n('Core.MgeReport.lblUsers');
                        }

                    }
                );
            }

            function getObjectValue(value) {
                try {

                    if (Object.entries(value).length === 0) {
                        return "N";
                    }

                    return value.$;
                }
                catch (e) {
                    return "";
                }

            }

            function getCriteria() {
                var criteria = Criteria();

                var codGrupo = self.dsAcessosGrupo.getFieldValueAsString("CODGRUPO");

                if (codGrupo) {
                    criteria.append("this.CODREL = ? ", Criteria.buildNumberParameter(self.codRel));
                    criteria.append(" AND this.CODUSU IN (SELECT USU.CODUSU FROM TSIUSU USU WHERE USU.CODGRUPO = ?) AND this.CODGRUPO = 0", Criteria.buildNumberParameter(codGrupo));
                } else {
                    criteria.append("1 = 0");
                }
                return criteria;
            }

            function getCriteriaUsuarios() {
                var criteria = Criteria();

                var codGrupo = self.dsAcessosGrupo.getFieldValueAsString("CODGRUPO");

                if (codGrupo) {
                    criteria.append("this.CODUSU > 0 AND this.CODGRUPO = ? ", Criteria.buildNumberParameter(self.dsAcessosGrupo.getFieldValueAsString("CODGRUPO")));
                    criteria.append("AND NOT EXISTS(SELECT 1 FROM TSIACI ACI WHERE ACI.CODGRUPO = 0 AND ACI.CODUSU = this.CODUSU AND ACI.CODREL = ?) ", Criteria.buildNumberParameter(self.codRel));
                } else {
                    criteria.append("1 = 0");
                }

                return criteria;
            }

        }]);
angular
	.module('snk.commons')
	.service('SegurancaContent', ['SanPopup',
		function (SanPopup) {
			var self = this;

			self.show = show;

			function show(popupInfo) {
				var popupInstance = SanPopup.open({
					title: popupInfo.title,
					templateUrl: 'commons/formatadorcuborelatorio/popup/SegurancaContent.tpl.html',
					controller: 'SegurancaContentController',
					controllerAs: 'ctrl',
					size: 'lg',
					height: 400,
					showBtnCancel: true,
					showBtnOk: false,
					showBtnNo: false,
					resolve: {
						data : {
							codRel : popupInfo.codRel
						}
					}
				});
				return popupInstance;
			}

		}
	]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .component('selecaoCampos', {
        templateUrl: 'commons/formatadorcuborelatorio/selecaocampos/SelecaoCampos.tpl.html',
        controller: 'SelecaoCamposController',
        bindings: {
            ds: '=?skDataset',
            tipoRelatorio: '=',
            camposDp: '=?',
            modoCubo: '=?',
            recarregaCampos: '&',
            onCreateComplete: '&',
        }
    }).controller('SelecaoCamposController', ['$scope', '$tooltip', 'i18n', 'Criteria', 'ServiceProxy', 'SanPopup', 'StringUtils', 'ObjectUtils', 'AngularUtil', 'ArrayUtils', 'FilterVariablesBuilder', 'MessageUtils', 'DateUtils', 'SkConstants',
    function ($scope, $tooltip, i18n, Criteria, ServiceProxy, SanPopup, StringUtils, ObjectUtils, AngularUtil, ArrayUtils, FilterVariablesBuilder, MessageUtils, DateUtils, SkConstants) {
        var self = this;

        ObjectUtils.implements(self, IDatagridInterceptor);


        var _ordem;
        var _codCampo;
        var _paramsField;
        var _resumoField;
        var _textAreaExpressao;

        var _exibindoAvisoDescartarRelatorio = false;
        var _showEntitySearch = false;
        var _isRequiredEdit = false;
        var _tipoCampo = '';
        var _txiEntityEdit = '';
        var _mapStateSwitch = [];
        var _escolhidos;

        var iconText = '/mge/assets/svg/ico-text.svg';
        var iconNum = '/mge/assets/svg/ico-number.svg';
        var iconDate = 'calendar';
        var iconList = 'list';
        var iconImage = 'picture';

        var _tiposCamposNaoEditaveis = {
            ESTRCTB2: "ESTRCTB2",
            BASRUSU: "BASRUSU",
            BASRBAI: "BASRBAI",
            BASRCID: "BASRCID",
            BASRENDE: "BASRENDE",
            BASRCOT: "BASRCOT",
            FINRTOP: "FINRTOP",
            FINRNATR: "FINRNATR",
            BASRCUS: "BASRCUS",
            FINRTTIT: "FINRTTIT"
        };

        var _icons = {
            I: iconNum,
            N: iconNum,
            F: iconNum,
            $: iconNum,
            T: iconDate,
            D: iconDate,
            M: iconText,
            R: iconText,
            S: iconText,
            L: iconList,
            B: iconImage
        };

        var _publicAPI = {};

        //Fields
        self.dsCampos;
        self.dsListaOrdenacao;
        self.filtroArvoreCampos;
        self.filterExpression;
        self.branchSelected;
        self.lastIndex;
        self.itemSelectedList;
        self.treeApi;
        self.vsDetailIndex = 0;
        self.treeControl = {};
        self.ckcReimprimir = false;
        self.ckcImpFiltro = false;
        self.expressaoEnabled = false;
        self.tabelasEnabled = false;
        self.ligacaoEnabled = false;
        self.isEditFilterEnabled = false;
        self.btnManutencaoVisibled = false;
        self.listaQuebra = [];
        self.listaSelecionados = [];
        self.toolTipBtnManutencaoCampos = i18n('Core.FormatadorCuboRelatorio.lblSelectedFields');
        self.toolTipBtnManutencaoDetalhes = i18n('Core.FormatadorCuboRelatorio.lblMaintenanceOfFields');

        //FormCampos
        self.codCampoPaiEnabled = false;
        self.descricaoEnabled = false;
        self.tipoEnabled = false;
        self.alinhamentoEnabled = false;
        self.totalizaEnabled = false;
        self.tamanhoEnabled = false;
        self.mascaraEnabled = false;

        //Functions
        self.onDatasetCreated = onDatasetCreated;
        self.onDsListaOrdenacaoCreated = onDsListaOrdenacaoCreated;
        self.onDgListaOrdenacaoLoaded = onDgListaOrdenacaoLoaded;
        self.onKeyDownFiltroArvore = onKeyDownFiltroArvore;
        self.changeVsDetailIndex = changeVsDetailIndex;
        self.textAreaCreated = textAreaCreated;
        self.toolTipCampos = toolTipCampos;

        //DataGridIntercept
        self.interceptCellRenderer = interceptCellRenderer;

        self.localizarItem = localizarItem;
        self.mudaOrdemQuebras = mudaOrdemQuebras;
        self.addSelecionadoFiltro = addSelecionadoFiltro;
        self.openEditForm = openEditForm;
        self.clearFilter = clearFilter;
        self.onSelectTreeNode = onSelectTreeNode;
        self.changeCampo = changeCampo;
        self.mudaOrdemSelecionados = mudaOrdemSelecionados;
        self.addBranchToSelecionados = addBranchToSelecionados;
        self.addToSelecionados = addToSelecionados;
        self.removeFromSelecionado = removeFromSelecionado;
        self.removeFromGroup = angular.noop;
        self.addGroupDetail = angular.noop;
        self.isOrderField = isOrderField;
        self.addToOrdenacao = addToOrdenacao;
        self.removeFromOrdenacao = removeFromOrdenacao;
        self.setOnFocusEditFilter = setOnFocusEditFilter;
        self.disableBtnUpOrdem = disableBtnUpOrdem;
        self.disableBtnDownOrdem = disableBtnDownOrdem;
        self.calculateScrollTree = calculateScrollTree;
        self.changeFlagResumoField = changeFlagResumoField;
        self.onChangeDraggableItemList = onChangeDraggableItemList;

        //Functions lblField
        self.isMasterGroupField = isMasterGroupField;
        self.isDetailGroupField = isDetailGroupField;
        self.changeSwitchAgrupamento = angular.noop;
        self.changeSwitchSaltar = angular.noop;

        //Drags
        self.doDragDrop = doDragDrop;

        self.$onInit = $onInit;

        _publicAPI.init = init;
        _publicAPI.setResumoField = setResumoField;
        _publicAPI.setParamsGenField = setParamsGenField;

        function $onInit() {

            self.onCreateComplete({
                $instance: _publicAPI
            });

            carregarCamposTipoRelatorio();
        };

        function init() {
            //Alteração teste wesley
            const scopedrag = self.listApi.getScopeApi();
            scopedrag.isOrderField = isOrderField;
            //Alteração teste wesley

            _escolhidos = new FieldBinderProxy('ESCOLHIDOS', self.ds, getEscolhidos, setEscolhidos);

            self.btnManutencaoVisibled = (self.tipoRelatorio == null || !_tiposCamposNaoEditaveis.hasOwnProperty(self.tipoRelatorio.toUpperCase()));
        }

        function onChangeDraggableItemList(item, positionToInsert) {
            notifyChange();
        }

        function changeFlagResumoField(key, value) {

            if (_resumoField) {
                _resumoField.setFlag(key, value);
            }
        }

        function setResumoField(resumoField) {
            _resumoField = resumoField;

            window.addEventListener("changeResumoFieldProxy", function (e) {
                self.ckcReimprimir = _resumoField.getFlagValue("Q");
                self.ckcImpFiltro = _resumoField.getFlagValue("F");
                var ac = self.dsListaOrdenacao.getRecordsAsObjects();

                if (ac) {
                    ac.forEach(function (item) {
                        if (item.groupIndex && item.groupIndex >= 0) {
                            item.agrupado = angular.isUndefined(item.groupIndex) ? false : _resumoField.getFlagValue(item.groupIndex);
                            item.saltar = item.agrupado && angular.isUndefined(item.saltar) ? false : item.saltar;
                        }
                    });
                }
            });
        }

        function setParamsGenField(paramsField) {
            _paramsField = paramsField;
            window.addEventListener("changeGenFieldProxy", function (e) {
                var ac = self.dsListaOrdenacao.getRecordsAsObjects();

                if (ac) {
                    ac.forEach(function (item) {
                        if (item.groupIndex && item.groupIndex >= 0) {
                            item.saltar = _paramsField.getParamValue("SaltaPagina" + item.groupIndex) == "S";
                        }
                    });
                }
            });
        }

        function carregarCamposTipoRelatorio() {

            ServiceProxy.callService('mge@MGEReport.getArvoreCampos', { cubo: { tipo: self.tipoRelatorio } })
                .then(function (result) {

                    var arvoreCampos = result.responseBody.campo;

                    if (!angular.isArray(arvoreCampos.campo)) {
                        arvoreCampos.campo = [arvoreCampos.campo];
                    }

                    if (arvoreCampos.campo.length > 0) {

                        self.treeDP = buildNodes(arvoreCampos.campo);

                        if (self.treeControl.refresh) {
                            self.treeControl.refresh();
                            self.treeControl.expand_all();
                        }
                    }

                });
        }

        function getCriteria() {
            var criteria = Criteria();

            if (!_codCampo) {
                self.dsCampos.clearDataSet();
                criteria.append("1 = 0");

                return;
            }

            criteria.append("this.CODUNI = ? ", Criteria.buildNumberParameter(_codCampo));

            return criteria;
        }

        function toolTipCampos(id){
            return StringUtils.substitute("ServerSideToolTip({0})", getToolTipKey(id));
        }

        function getToolTipKey(codigo) {
            return StringUtils.substitute("br.com.sankhya.modelcore.util.dynamictooltip.CampoRelatorioToolTip::{0}", codigo);
        }

        function onDatasetCreated(dataset) {
            self.dsCampos = dataset;

            self.dsCampos.afterCopyAction(function (ds) {
                self.dsCampos.setFieldValue('CODCAMPO', null);
                self.dsCampos.setFieldValue('SANKHYA', null);
            });

            self.dsCampos.addDataSavedListener(function () {

                var campoSelecionado = self.dsCampos.getFieldValueAsNumber("CODUNI");
                window.stateProvider.invalidateCache(getToolTipKey(campoSelecionado));
                self.treeDP = null;
                carregarCamposTipoRelatorio();
            });

            self.dsCampos.addRecordRemovedListener(function (record) {
                self.treeDP = null;
                carregarCamposTipoRelatorio();
            });

            self.dsCampos.addLineChangeListener(function (listener) {
                ajustaCamposEditaveis();
            });

            self.dsCampos.addInsertionModeListener(function () {

                var item = self.branchSelected;

                var codPai = null;

                if (item) {
                    if (item.soHierarquia == "S") {
                        codPai = item.codigo;
                    } else {
                        item = item.parent();
                        if (item) {
                            codPai = item.codigo;
                        }
                    }
                }
                if (!codPai) {
                    codPai = "-999999999";
                }
                self.dsCampos.setFieldValueAsString("CODCAMPOPAI", codPai);
                self.dsCampos.setFieldValueAsString("CODCAMPO", null);
                self.dsCampos.setFieldValueAsString("PROGRAMA", self.tipoRelatorio);
                self.branchSelected = undefined;
                ajustaCamposEditaveis();
            });

            self.dsCampos.addDataModifiedListener(function (modifiedField) {

                if (!_exibindoAvisoDescartarRelatorio && (self.ds.getFieldValue("PERSONALIZADO") == "S" || self.ds.getFieldValue("TEMLAYOUTSW") == "S")) {
                    _exibindoAvisoDescartarRelatorio = true;

                    MessageUtils.simpleConfirm(
                        i18n("Core.FormatadorCuboRelatorio.titlePersonalizedLayout"),
                        i18n("Core.FormatadorCuboRelatorio.msgPersonalizedWarning"))
                        .then(function () {
                                _exibindoAvisoDescartarRelatorio = false;
                                self.ds.setFieldValue("PERSONALIZADO", "N");
                                self.ds.setFieldValue("TEMLAYOUTSW", "N");
                                self.ds.save();
                            }
                            , function () {
                                _exibindoAvisoDescartarRelatorio = false;
                                self.dsCampos.cancelEdition();
                            });
                }
            });

            self.isEditFilterEnabled = false;
            if (self.modoCubo) {
                self.dsCampos.makeFieldNonRequired("ALINHAMENTO");
            }

            self.dsCampos.makeFieldNonRequired("CODUNI");
            self.dsCampos.makeFieldNonRequired("CODCAMPO");
            self.dsCampos.addCriteriaProvider(getCriteria);
            self.dsCampos.init();
        }

        function setOnFocusEditFilter() {
            prepareEditFilterButton()
        }

        function disableBtnUpOrdem() {

            if (!self.dsListaOrdenacao || self.dsListaOrdenacao.size() == 0 || self.dsListaOrdenacao.getCurrentIndex() <= 0) {
                return true;
            }

            return false;
        }

        function disableBtnDownOrdem() {

            if (!self.dsListaOrdenacao || self.dsListaOrdenacao.size() == 0 || (self.dsListaOrdenacao.getCurrentIndex() == -1 || self.dsListaOrdenacao.getCurrentIndex() == self.dsListaOrdenacao.size() - 1)) {
                return true;
            }

            return false;
        }

        function calculateScrollTree() {
            var rootContainerTree = document.getElementById('divContentTree');

            if (rootContainerTree) {
                var clientHeight = rootContainerTree.clientHeight;

                return clientHeight + 'px';
            }

            return null;
        }

        function prepareEditFilterButton() {
            if (self.filterExpression == '' || filterExpression.text.indexOf('?') == -1) {
                self.isEditFilterEnabled = false;
            } else {
                self.isEditFilterEnabled = true;
            }
        }

        async function onDsListaOrdenacaoCreated(dataset) {
            self.dsListaOrdenacao = dataset;
            await self.dsListaOrdenacao.init();
            _ordem = new FieldBinderProxy('ORDEM', self.ds, getOrdem, setOrdem);
        }

        function onDgListaOrdenacaoLoaded(datagrid) {
            self.listaOrdenacao = datagrid;
        }

        function onSelectTreeNode(branch) {
            self.branchSelected = branch;
            changeCampo()
        }

        function changeCampo() {
            if (self.branchSelected && self.branchSelected.data.codigo) {
                _codCampo = self.branchSelected.data.codigo;
            } else {
                _codCampo = null;
            }

            self.dsCampos.refresh();
        }

        function buildNodes(data) {
            var nodes = [];

            if (!angular.isArray(data)) {
                data = [data];
            }

            for (var i = 0; i < data.length; i++) {
                if(data[i]){
                    nodes.push(getNode(data[i]));
                }
            }

            return nodes;
        }

        function getNode(data) {
            return {
                description: data.descricao,
                label: data.descricao,
                data: data,
                children: (data.soHierarquia && data.soHierarquia == 'S') ? data.campo ? buildNodes(data.campo) : [] : [],
                icon: camposIconFunction(data)
            };
        }

        function camposIconFunction(item) {
            var ico = ''

            if (item.soHierarquia != 'S') {
                ico = _icons[item.tipo];
            }

            return ico;
        }

        function isMasterGroupField(data) {
            return (angular.isDefined(data.groupIndex) && data.hasOwnProperty("groupIndex"));
        }

        function isDetailGroupField(data) {
            return (angular.isDefined(data.masterGroupIndex) && data.hasOwnProperty("masterGroupIndex"));
        }

        function interceptCellRenderer(cell, value, eGridCell, data) {

            var gridItem = data.gridItem;
            var rowId = data.gridItem.rowID;

            var switchRowId = cell.colId + '-' + rowId;
            var enabled = String(cell.colId + 'Enabled' + rowId);

            var hBoxElem = AngularUtil.createDirective('sk-hbox', {
                'layout-align': 'start center',
                'style': 'width: 100%;'
            }, $scope)[0];

            if (cell.colId == 'label') {

                $scope[enabled] = angular.isUndefined($scope['agrupadoEnabled' + rowId]) ? false : $scope['agrupadoEnabled' + rowId];

                var isMasterGroup = isMasterGroupField(gridItem);
                var isDetailGroup = isDetailGroupField(gridItem);

                var spacerElem = AngularUtil.createDirective('label', {
                    'style': 'width: 25px;'
                }, $scope)[0];

                var iconAddElem = AngularUtil.createDirective('sk-icon', {
                    'id': rowId,
                    'font-icon': 'glyphicon glyphicon-circle-plus',
                    'class': 'icon',
                    'ng-if': isMasterGroup,
                    'sk-enabled': enabled,
                    'toolTip': i18n('Core.FormatadorCuboRelatorio.tooltipHeaderBandFields'),
                    'ng-click': 'addGroupDetail($event)',
                    'style': 'margin: 5px; color: green;'
                }, $scope)[0];

                var iconDelElem = AngularUtil.createDirective('sk-icon', {
                    'id': rowId,
                    'font-icon': 'glyphicon glyphicon-circle-minus',
                    'class': 'icon',
                    'ng-if': isDetailGroup,
                    'toolTip': i18n('Core.FormatadorCuboRelatorio.tooltipRemoveFromHeaderBand'),
                    'ng-click': 'removeFromGroup($event)',
                    'style': 'margin: 5px; color: red;'
                }, $scope)[0];

                var labelElem = AngularUtil.createDirective('span', {
                    'style': 'width: 100% !important;',
                    'sk-i18n': value
                }, $scope)[0];

                if (isDetailGroup) {
                    hBoxElem.append(spacerElem);
                }

                hBoxElem.append(iconAddElem);
                hBoxElem.append(iconDelElem);
                hBoxElem.append(labelElem);

                return { element: hBoxElem, align: 'left' };

            } else if (ArrayUtils.isIn(['agrupado', 'saltar'], cell.colId)) {

                var lineGrid = {
                    name: switchRowId,
                    status: enabled,
                    flag: value
                };

                _mapStateSwitch.push(lineGrid);

                if (cell.colId == 'agrupado') {
                    $scope[enabled] = value;
                    $scope['saltarEnabled' + rowId] = value;
                    $scope['labelEnabled' + rowId] = value;
                } else {
                    $scope[enabled] = value ? value : (angular.isUndefined($scope['agrupadoEnabled' + rowId]) ? false : $scope['agrupadoEnabled' + rowId]);
                }

                var skSwitchElem = AngularUtil.createDirective('sk-switch', {
                    'switch-row-id-elem': rowId,
                    'switch-row-value-elem': switchRowId,
                    'ng-if': isMasterGroupField(gridItem),
                    'sk-enabled': cell.colId == 'agrupado' ? true : enabled,
                    'sk-value': value,
                    'sk-true-value': "true",
                    'sk-false-value': "false",
                    'sk-change': cell.colId == 'agrupado' ? "changeSwitchAgrupamento(attrs, value)" : "changeSwitchSaltar(attrs, value)"
                }, $scope)[0];

                hBoxElem.append(skSwitchElem);
                return { element: hBoxElem, align: 'left' };
            }
        }

        function buildItemListaOrdByUniqueId(rowId) {

            var item = {};

            if (angular.isDefined(rowId)) {

                var record = self.dsListaOrdenacao.getRecordByUniqueId(rowId);

                var item = {};
                item.label = record[self.dsListaOrdenacao.getFieldIndexByName('label')];
                item.agrupado = record[self.dsListaOrdenacao.getFieldIndexByName('agrupado')];
                item.saltar = record[self.dsListaOrdenacao.getFieldIndexByName('saltar')];
                item.masterGroupIndex = record[self.dsListaOrdenacao.getFieldIndexByName('masterGroupIndex')];
                item.groupIndex = record[self.dsListaOrdenacao.getFieldIndexByName('groupIndex')];
            }

            return item;
        }

        $scope.changeSwitchAgrupamento = function (attrs, value) {
            attrs['skValue'] = value ? "true" : "false";
            var rowId = attrs['switchRowIdElem'];

            var agrupadoState = findWhere(_mapStateSwitch, attrs['switchRowValueElem'], value);

            if (!agrupadoState) {
                throw new Error('Não foi possível localizar este item da grade entre os elementos.');
            }

            $scope['saltarEnabled' + rowId] = value;
            $scope['labelEnabled' + rowId] = value

            var saltarState = findWhere(_mapStateSwitch, 'saltar-' + rowId, undefined);
            var saltarFlag = saltarState.flag;

            var item = buildItemListaOrdByUniqueId(rowId);
            item.agrupado = value;
            item.saltar = saltarFlag;

            AngularUtil.apply($scope);

            mudaAgrupamento(item, value, saltarFlag);

            return true;
        }

        $scope.changeSwitchSaltar = function (attrs, value) {

            attrs['skValue'] = value ? "true" : "false";
            var rowId = attrs['switchRowIdElem'];

            var mapState = findWhere(_mapStateSwitch, attrs['switchRowValueElem'], value);

            if (!mapState) {
                MessageUtils.showError(i18n('Core.MgeReport.msgNaoPossivelLocalizarItem'));
                return false;
            }

            var agrupadoState = findWhere(_mapStateSwitch, i18n('Core.MgeReport.titAgrupado') +'-' + rowId, undefined);
            var agrupadoFlag = agrupadoState.flag;

            var item = buildItemListaOrdByUniqueId(rowId);
            item.agrupado = agrupadoFlag;
            item.saltar = value;

            mudaAgrupamento(item, agrupadoFlag, value);

            return true;
        }

        function findWhere(array, whereObj, flag) {
            for (var key in array) {
                var value = array[key];
                if (value.name == whereObj) {

                    if (angular.isDefined(flag)) {
                        value.flag = flag
                    }

                    return value;
                }
            }
        }

        function addBranchToSelecionados() {
            if (self.branchSelected == undefined) {
                return;
            }

            if (self.branchSelected.data) {
                addToSelecionados(self.branchSelected);
            }
        }

        function addToSelecionados(item, index, convertXML) {

            if (!index) {
                index = -1;
            }

            if (angular.isUndefined(convertXML)) {
                convertXML = true;
            }

            if (item) {

                var itens = angular.isArray(item) ? item : [{ label: item.label }];

                var acSel = self.listaSelecionados;

                var itensByName = {};

                acSel.forEach(function (item) {
                    itensByName[item.label] = item;
                });

                if (index < 0) {
                    index = acSel.length;
                }

                var isNotifyChange = false;

                for (var i = itens.length - 1; i >= 0; i--) {
                    item = itens[i];

                    if (angular.isUndefined(item.label) || itensByName.hasOwnProperty(item.label)) {
                        continue;
                    }

                    var o = {
                        label: item.label,
                        selected: true
                    };

                    self.listaSelecionados.push(o);

                    isNotifyChange = true;
                }

                if (isNotifyChange) {
                    notifyChange();
                }

            }
        }

        function removeFromSelecionado(itens, useLocateByDescription, removeAll) {

            if (angular.isUndefined(useLocateByDescription)) {
                useLocateByDescription = false;
            }

            if (angular.isUndefined(removeAll)) {
                removeAll = false;
            }

            var ac = self.listaSelecionados;

            if (ac && ac.length > 0) {

                if (useLocateByDescription) {
                    itens = locateByDescription(ac, itens);
                }

                var itensByName = getAllItensByName(self.dsListaOrdenacao.getRecordsAsObjects(), "label");
                var toRemoveOrdenacao = [];

                if (removeAll) {

                    ac.forEach(function (itemToRemove) {
                        if (itensByName.hasOwnProperty(itemToRemove.label)) {
                            toRemoveOrdenacao.push(itensByName[itemToRemove.label]);
                        }
                    });

                    ac.splice(0, ac.length);

                } else {
                    itens.forEach(function (itemToRemove) {

                        if (itensByName.hasOwnProperty(itemToRemove.label)) {
                            toRemoveOrdenacao.push(itensByName[itemToRemove.label]);
                        }

                        ArrayUtils.removeReference(self.listaSelecionados, itemToRemove, true);
                    });
                }

                if (toRemoveOrdenacao.length > 0) {
                    removeFromOrdenacao(toRemoveOrdenacao);
                }

                notifyChange();
            }
        }

        window.allowDrop = function (event) {
            event.preventDefault();
        }

        window.dragStart = function (event) {
            event.dataTransfer.setData("id", event.target.id);
        }

        window.drop = function (event) {
            event.preventDefault();
        }

        function doDragDrop(event) {
            event.preventDefault();

            var initiator = event.originalEvent.dataTransfer.getData('id');
            var targetDrop = event.delegateTarget.id;

            if (initiator) {

                if (initiator == 'listaSelecionados') {

                    var data = event.originalEvent.dataTransfer.getData("items");
                    var parseData = JSON.parse(data);

                    var items = parseData.items;

                    if (targetDrop == 'arvoreCamposDisponiveis') {
                        removeFromSelecionado(items);

                    } else if (targetDrop == 'listaOrdenacao') {
                        addToOrdenacao(items);
                    }

                } else if (initiator == 'arvoreCamposDisponiveis' && targetDrop == 'listaSelecionados') {

                    var data = event.originalEvent.dataTransfer.getData('items');

                    var parseData = JSON.parse(data);

                    addToSelecionados(parseData.items);

                } else if (initiator == 'arvoreCamposDisponiveis' && targetDrop == 'filterExpressionn') {

                    var data = event.originalEvent.dataTransfer.getData('items');

                    var parseData = JSON.parse(data);

                    abrePopUpCriterio(parseData.items[0].branch);
                } else if (initiator == 'listaOrdenacao' && (targetDrop == 'listaSelecionados' || targetDrop == 'arvoreCamposDisponiveis')) {

                    var data = event.originalEvent.dataTransfer.getData('items');

                    var parseData = JSON.parse(data);
                    removeFromOrdenacao(parseData.items);
                }
            }
        }

        function addToOrdenacao(itens) {

            if (itens && itens.length > 0) {
                var acOrd = self.dsListaOrdenacao.getRecordsAsObjects();
                var maxGroupId = 0;
                var itensByName = {};

                acOrd.forEach(function (item) {
                    itensByName[item.label] = item;
                    if (item.hasOwnProperty("groupIndex") && angular.isDefined(item.groupIndex)) {
                        maxGroupId = Math.max(maxGroupId, item.groupIndex);
                    }
                });

                var isNotifyChange = false;

                itens.forEach(function (item) {
                    if (itensByName.hasOwnProperty(item.label)) {
                        return true;
                    }
                    var newItem = { label: item.label };

                    if (maxGroupId < 4) {
                        newItem.groupIndex = ++maxGroupId;
                    }

                    self.dsListaOrdenacao.addRecordsAsObjects(newItem)

                    isNotifyChange = true;
                });

                if (isNotifyChange) {
                    addToSelecionados(itens);
                    notifyChange();
                }
            }
        }

        function getAllItensByName(ac, labelAtribute) {

            var itensByName = {};

            ac.forEach(function (item) {
                itensByName[item[labelAtribute]] = item;
            });

            return itensByName;
        }

        function locateByDescription(ac, itens) {

            var arrayItens = [];
            itens.forEach(function (item) {

                ac.every(function (acItem) {

                    if (item.label == acItem.label) {
                        arrayItens.push(acItem);
                        return false;
                    }

                    return true;
                });
            });

            return arrayItens;
        }

        function removeFromOrdenacao(itens, useLocateByDescription) {

            if (angular.isUndefined(useLocateByDescription)) {
                useLocateByDescription = false;
            }

            if (itens && itens.length > 0) {

                var ac = self.dsListaOrdenacao.getRecordsAsObjects();

                if (useLocateByDescription) {
                    itens = locateByDescription(ac, itens);
                }

                var groupsToRemove = {};

                itens.forEach(function (item) {

                    mudaAgrupamento(item, false, false);

                    if (item.hasOwnProperty("groupIndex")) {
                        groupsToRemove[item.groupIndex] = null;
                    }

                    var index = findIndexByLabel(ac, item.label);

                    if (index > -1) {
                        ArrayUtils.removeAtIndex(ac, index);
                    }
                });

                var toRemoveAfter = [];

                var currentGroupIndex = 1;

                ac.forEach(function (item) {

                    if (item.masterGroupIndex) {
                        if (groupsToRemove.hasOwnProperty(item.masterGroupIndex)) {
                            toRemoveAfter.push(item);
                        } else {
                            item.masterGroupIndex = currentGroupIndex - 1;
                        }
                    } else if (currentGroupIndex <= 4) {
                        item.groupIndex = currentGroupIndex++;
                    }
                });

                toRemoveAfter.forEach(function (item) {
                    ArrayUtils.removeReference(ac, item, true);
                });

                _mapStateSwitch = [];
                self.dsListaOrdenacao.clearDataSet();

                if (ac && ac.length > 0) {
                    self.dsListaOrdenacao.addRecordsAsObjects(ac);
                }

                notifyChange();
            }
        }

        function isOrderField(item) {
            var orderAc = self.dsListaOrdenacao.getRecordsAsObjects();

            var isOrder = false;

            orderAc.forEach(function (orderItem) {
                if (item.label == orderItem.label) {
                    isOrder = true;
                    return false;
                }
            });

            return isOrder;
        }

        function mudaAgrupamento(item, agrupado, saltar) {

            item.agrupado = !agrupado ? false : agrupado;
            item.saltar = !saltar ? false : saltar;

            var renewRecords = [];
            self.dsListaOrdenacao.getRecordsAsObjects().forEach(function (lista) {

                if (lista.label == item.label) {
                    lista.agrupado = angular.isUndefined(agrupado) ? false : agrupado;
                    lista.saltar = angular.isUndefined(saltar) ? false : saltar;
                }

                renewRecords.push(lista);
            });

            buildNewOrdemAgrup(renewRecords);

            var ac = self.dsListaOrdenacao.getRecordsAsObjects();
            var toRemove = [];

            ac.forEach(function (i) {

                if (agrupado) {
                    if (i.groupIndex && i.groupIndex < item.groupIndex) {
                        i.agrupado = true;
                    }
                } else {
                    if (i.groupIndex) {

                        if (i.groupIndex > item.groupIndex) {
                            i.agrupado = false;
                        }
                        i.saltar = (!i.agrupado ? false : i.agrupado && (!i.saltar ? false : i.saltar));
                    }

                    if (i.masterGroupIndex >= item.groupIndex) {

                        var itemToRemove = ac[i];

                        toRemove.push(itemToRemove);
                    }
                }
            });

            if (toRemove && toRemove.length > 0) {

                toRemove.forEach(function (index) {
                    ArrayUtils.removeReference(ac, index, true);
                });
            }

            notifyChange();
        }

        function mudaOrdemSelecionados(itensSelecionados, shift) {

            var ac = self.listaSelecionados;

            if (ac && ac.length > 0) {
                var indices = new Array();

                var changePosition = true;

                itensSelecionados.forEach(function (item) {

                    var i = findIndexByLabel(ac, item.label);

                    if ((i + shift) < 0 || (i + shift) >= ac.length) {
                        changePosition = false;
                        return false;
                    }

                    if (indices.indexOf(i) == -1) {
                        indices.push(i);
                    }
                });

                if (changePosition) {
                    indices.sort(function (a, b) {
                        if (shift > 0) {
                            return b - a;
                        } else {
                            return a - b;
                        }
                    });

                    indices.forEach(function (i) {
                        ArrayUtils.insertAtIndex(ac, (i + shift), ArrayUtils.removeAtIndex(ac, i));
                    });

                    notifyChange()
                }
            }
        }

        function notifyChange() {
            _escolhidos.modify(true);
            _ordem.modify(true);

            var info = {};
            var ac = self.dsListaOrdenacao.getRecordsAsObjects();

            ac.forEach(function (item) {

                if (item.groupIndex) {
                    _resumoField.setFlag(item.groupIndex, Boolean(item.agrupado));
                    _paramsField.setParamValue("SaltaPagina" + item.groupIndex, !item.saltar ? 'N' : 'S');

                } else if (item.masterGroupIndex) {
                    var l = info["lista" + item.masterGroupIndex];

                    if (!l) {
                        l = [];
                        info["lista" + item.masterGroupIndex] = l;
                    }

                    if (!angular.isArray(l)) {
                        l = [l];
                    }

                    l.push(item.label);
                }
            });

            for (var index = 1; index <= 4; index++) {
                try {
                    if (info.hasOwnProperty("lista" + index)) {

                        var infoList = info["lista" + index];

                        if (!angular.isArray(infoList)) {
                            infoList = [infoList];
                        }

                        self.ds.setFieldValue("LISTA" + index, infoList.join("\n"));
                    } else {
                        self.ds.setFieldValue("LISTA" + index, '');
                    }
                } catch (ignored) {
                }

            }
        }

        function getEscolhidos() {

            var ac = self.listaSelecionados;
            var value = '';

            ac.forEach(function (item) {
                if (value.length > 0) {
                    value += "\n";
                }
                value += item.label;
            });

            return value;
        }

        function setEscolhidos(value) {
            self.listaSelecionados = [];

            if (value) {
                parseStrCampos(value).forEach(function (item) {
                    self.listaSelecionados.push({ label: item });
                });
            }
        }

        function getOrdem() {
            var ac = self.dsListaOrdenacao.getRecordsAsObjects();
            var value = '';

            ac.forEach(function (item) {
                if (!item.masterGroupIndex) {
                    if (value.length > 0) {
                        value += "\n";
                    }
                    value += item.label;
                }
            });

            return value;
        }

        function setOrdem(value) {

            _mapStateSwitch = [];
            self.dsListaOrdenacao.clearDataSet();

            if (value) {

                var dataProvider = [];
                var ordem = parseStrCampos(value);

                for (var i = 0; i < ordem.length; i++) {

                    if (i < 4) {
                        processaGrupo(ordem[i], i + 1, dataProvider);
                    } else {
                        dataProvider.push({ label: ordem[i] });
                    }
                }

                self.dsListaOrdenacao.addRecordsAsObjects(dataProvider);
            }
        }

        function processaGrupo(campoPrincipal, groupIndex, dataProvider) {

            var item = { label: campoPrincipal };

            item.groupIndex = groupIndex;
            item.agrupado = _resumoField.getFlagValue(groupIndex);

            var params = self.ds.getFieldValueAsString("PARAMSGEN");
            if (params) {
                var parts = new RegExp("SaltaPagina" + groupIndex + "\s*=\s*(S|N)").exec(params);
                if (parts) {
                    item.saltar = parts[1] == "S";
                }
            }

            dataProvider.push(item);

            var listaCamposExtra = parseStrCampos(self.ds.getFieldValueAsString("LISTA" + groupIndex));

            if (!angular.isArray(listaCamposExtra)) {
                listaCamposExtra = [listaCamposExtra];
            }

            listaCamposExtra.forEach(function (campo) {
                dataProvider.push({ label: campo, masterGroupIndex: groupIndex });
            });
        }

        function parseStrCampos(str) {
            var arr = [];

            if (str) {

                str = str.replace(/[\r\n]{1,2}/g, "\n");

                var listaCampos = str.split("\n");

                if (!angular.isArray(listaCampos)) {
                    listaCampos = [listaCampos];
                }

                listaCampos.forEach(function (campo) {
                    if (StringUtils.trim(campo)) {
                        arr.push(campo);
                    }
                });
            }
            return arr;
        }

        function ajustaCamposEditaveis() {

            var soHierarquia = self.dsCampos.getFieldValueAsString("SOHIERARQUIA") == "S";
            applyTofields({ enabled: self.dsCampos.isInsertionMode() }, ["DESCRICAO", "CODCAMPOPAI"]);
            applyTofields({ enabled: !soHierarquia }, ["TIPO", "ALINHAMENTO", "TOTALIZA", "TAMANHO", "MASCARA"]);
            self.expressaoEnabled = !soHierarquia;
            self.tabelasEnabled = !soHierarquia;
            self.ligacaoEnabled = !soHierarquia;
        }


        function applyTofields(attributes, fields) {

            fields.forEach(function (fieldName) {

                for (var propName in attributes) {
                    if (fieldName == "DESCRICAO") {
                        self.descricaoEnabled = attributes[propName];
                    } else if (fieldName == "CODCAMPOPAI") {
                        self.codCampoPaiEnabled = attributes[propName];
                    } else if (fieldName == "TIPO") {
                        self.tipoEnabled = attributes[propName];
                    } else if (fieldName == "ALINHAMENTO") {
                        self.alinhamentoEnabled = attributes[propName];
                    } else if (fieldName == "TOTALIZA") {
                        self.totalizaEnabled = attributes[propName];
                    } else if (fieldName == "TAMANHO") {
                        self.tamanhoEnabled = attributes[propName];
                    } else if (fieldName == "MASCARA") {
                        self.mascaraEnabled = attributes[propName];
                    }
                }

            });
        }

        function onKeyDownFiltroArvore(event) {
            if (event.keyCode == SkConstants.KEY_CODE.ENTER) {
                localizarItem();
            }
        }

        function changeVsDetailIndex() {
            if (self.vsDetailIndex == 0) {
                self.vsDetailIndex = 1;
            } else {
                self.vsDetailIndex = 0;
            }
        }

        function textAreaCreated(comp) {
            _textAreaExpressao = comp;
        }

        function localizarItem() {
            var textFilter = !self.filtroArvoreCampos ? null : self.filtroArvoreCampos;

            if (textFilter == null) {
                return;
            }

            var re = new RegExp(textFilter, "i");
            var matchedItens = [];

            var plain = self.treeDP;

            self.lastIndex = 1;

            plain.forEach(function (item) {
                navigateToNodes(matchedItens, item, re);
            });

            if (matchedItens.length > 0) {
                var selItem = self.branchSelected;

                if (!selItem) {
                    selItem = matchedItens[0];
                } else {

                    if (selItem == matchedItens[matchedItens.length - 1]) {
                        selItem = matchedItens[0];
                    } else {

                        if (matchedItens.length == 1) {
                            selItem = matchedItens[0];
                        } else {
                            matchedItens.every(function (item) {
                                if (Number(item.index) > Number(self.branchSelected.index)) {
                                    selItem = item;
                                    return false;
                                }
                                return true;
                            });
                        }
                    }
                }

                self.treeControl.expand_branch(selItem);
                self.treeControl.select_branch(selItem);
            }

            return textFilter;
        }

        function navigateToNodes(matchedItens, item, re) {

            if (item.children && item.children.length > 0) {

                addMatchedItens(item, matchedItens, re);

                item.children.forEach(function (node) {

                    addMatchedItens(node, matchedItens, re);

                    if (node.children.length > 0) {
                        navigateToNodes(matchedItens, node.children, re)
                    }
                });

            } else if (item) {

                if (angular.isArray(item)) {
                    item = item[0];
                }

                if (item) {
                    addMatchedItens(item, matchedItens, re);
                }
            }
        }

        function addMatchedItens(item, matchedItens, re) {
            item.index = ++self.lastIndex;

            if (re.test(item.label)) {
                matchedItens.push(item);
            }
        }

        function mudaOrdemQuebras(direction) {

            var shift = 1;

            if (direction == 'up') {
                shift = -1
            }

            var ac = self.dsListaOrdenacao.getRecordsAsObjects();
            var itemMovido = self.dsListaOrdenacao.getSelectedRecordsAsObjects(undefined, true);

            if (itemMovido.hasOwnProperty("masterGroupIndex")) {
                var index = findIndexByLabel(ac, itemMovido.label);

                var replaced = findItemAtByLabel(ac, (index + shift));

                if (replaced.masterGroupIndex == itemMovido.masterGroupIndex) {
                    ArrayUtils.insertAtIndex(ac, (index + shift), itemMovido);
                    ArrayUtils.insertAtIndex(ac, index, replaced);
                }
            } else {
                var itens = [];
                var grupos = new Object();

                //Prepara a coleção plana para ser ordenada (somente cabeças de grupo e campos de ordenação)
                //vinculando os detalhes de quebra aos cabeças de grupo...

                ac.forEach(function (item) {

                    if (item.hasOwnProperty("masterGroupIndex") && angular.isDefined(item.masterGroupIndex)) {
                        var grupo = grupos[item.masterGroupIndex];

                        if (!grupo.hasOwnProperty("children") || angular.isUndefined(grupo.children)) {
                            grupo.children = new Array();
                        }
                        grupo.children.push(item);
                    } else {
                        if (item.hasOwnProperty("groupIndex") && angular.isDefined(item.groupIndex)) {
                            grupos[item.groupIndex] = item;
                        }
                        itens.push(item);
                    }
                });

                //Faz a ordenação...
                var i = findIndexByLabel(itens, itemMovido[0].label);
                var positionTo = (i + shift);

                if (positionTo >= 0 && positionTo < itens.length) {
                    ArrayUtils.insertAtIndex(itens, positionTo, ArrayUtils.removeAtIndex(itens, i));
                }

                //Ajusta a sequencia de grupos expandindo os detalhes de quebra novamente.
                ac = [];

                var groupIndex = 1;

                for (var i = 0; i < itens.length; i++) {
                    var agrupado = true; //Sankhya precisa ajustar no flex igual aqui pois há um erro la.
                    var item = itens[i];

                    ac.push(item);

                    if (item.hasOwnProperty("groupIndex")) {
                        agrupado = agrupado && item.agrupado;
                        item.agrupado = agrupado;
                        item.saltar = agrupado && item.saltar;
                    }

                    if (groupIndex <= 4) {
                        item.groupIndex = groupIndex;
                        if (item.hasOwnProperty("children") && item.agrupado) {

                            item.children.forEach(function (c) {
                                c.masterGroupIndex = groupIndex;
                                ac.push(c);
                            });
                        }
                        groupIndex++;
                    } else {
                        delete item.agrupado;
                        delete item.saltar;
                        delete item.groupIndex;
                    }
                    delete item.children;
                }

                if (ac.length > 0) {
                    buildNewOrdemAgrup(ac);

                    var row = findIndexByLabel(self.dsListaOrdenacao.getRecordsAsObjects(), itemMovido[0].label);

                    self.dsListaOrdenacao.gotoRow(row);
                    notifyChange();
                }
            }
        }

        function addSelecionadoFiltro() {

            if (!self.branchSelected) {
                return;
            }

            var item = self.branchSelected;

            if (item) {
                abrePopUpCriterio(item);
            }
        }

        function abrePopUpCriterio(item) {

            if (item.data.soHierarquia == 'S') {
                MessageUtils.showAlert(i18n('Core.MgeReport.titleFieldNotFilter'), i18n('Core.MgeReport.msgFieldNotFilter'));
                return;
            }

            SanPopup.open({
                title: i18n('Core.FormatadorCuboRelatorio.lblNovoCriterio'),
                templateUrl: 'commons/formatadorcuborelatorio/selecaocampos/popup/CriterioPopUp.tpl.html',
                controller: 'CriterioPopUpController',
                controllerAs: 'ctrl',
                size: 'md',
                height: '180',
                showBtnNo: false,
                showBtnCancel: false,
                showBtnOk: false,
                windowClass: 'popupCriterioPopUp',
                resolve: {
                    data: {
                        item: item,
                        appendCriteria: function (comboOperador, ligacaoCriterio, labelField, ckcVariavelSelected, tipoCampo, value, isRequired, txiEntity, popup) {

                            var valor = StringUtils.substitute(StringUtils.toHtmlText(comboOperador.data), getValorCriterio(tipoCampo, ckcVariavelSelected, value, comboOperador));
                            var expressao
                            if(self.filterExpression) {
                                expressao = StringUtils.trim(self.filterExpression);
                            } else {
                                expressao = "";
                            }

                            if (expressao.length > 0) {
                                expressao = expressao + " " + ligacaoCriterio + "\n";
                            }

                            expressao = expressao + StringUtils.substitute(":{0}: {1}", labelField, valor);

                            if (ckcVariavelSelected) {
                                expressao = buildAditionalFilterMetadata(valor, expressao, tipoCampo, isRequired, txiEntity);
                            }

                            self.filterExpression = expressao;
                            popup.dismiss();
                            self.ds.setModified(AngularUtil.getControllerFromElement(document.getElementById('filterExpressionn')));
                            _tipoCampo = '';
                        }
                    }
                }
            }).result
                .then(function (result) {

                });
        }
        function getValorCriterio(tipoCampo, ckcVariavelSelected, value, comboOperador) {

            var tipo = tipoCampo;
            var value = ckcVariavelSelected ? '?' : getStringValue(tipo, value);

            if (!ckcVariavelSelected) {
                if ("D-T".indexOf(tipo) > -1) {
                    value = "#" + value + "#";
                } else {
                    var adicionarAspas = "M-R-S".indexOf(tipo) > -1 && !comboOperador.contemAspas;
                    if ("M-R-S".indexOf(tipo) > -1 && adicionarAspas) {
                        value = "'" + value + "'";
                    }
                }
            }

            return value;
        }

        function getStringValue(tipo, value) {

            if (value == null) {
                return '';
            } else if ("F-I".indexOf(tipo) > -1 && isNaN(Number(value))) {
                return '';
            } else if ("D-T".indexOf(tipo) > -1) {
                return DateUtils.formatDate(value);
            }

            return value.toString();
        }

        function buildAditionalFilterMetadata(parameter, expression, tipoCampo, isRequired, txiEntity) {

            if (angular.isUndefined(isRequired)) {
                isRequired = true;
            }

            var newExpression = null;

            var variablesBuilder = new FilterVariablesBuilder(isRequired, tipoCampo, txiEntity);

            if (expression.indexOf(parameter) >= 0) {
                var indexToReplace = expression.lastIndexOf(parameter);

                var endOfExpression = expression.substring(indexToReplace + parameter.length, expression.length);

                newExpression = expression.substring(0, indexToReplace) + parameter + variablesBuilder.buildExpression();

                if (endOfExpression != '') {
                    newExpression = newExpression + endOfExpression;
                }

            } else {
                newExpression = expression;
            }

            isRequired = true;
            txiEntity = '';

            return newExpression;
        }

        function openEditForm() {

            if (_tipoCampo == "I" || _tipoCampo == "S") {
                _showEntitySearch = true;
            } else {
                _showEntitySearch = false;
            }
            prepareEditForm(getIndexToEdit());

            SanPopup.open({
                title: i18n('Core.SelecaoCampos.editFilterVariablesTitle'),
                templateUrl: 'commons/formatadorcuborelatorio/selecaocampos/popup/EditFilterPopUp.tpl.html',
                controller: 'EditFilterPopUpController',
                controllerAs: 'ctrl',
                size: 'md',
                height: '70',
                showBtnNo: false,
                showBtnCancel: false,
                showBtnOk: false,
                windowClass: _showEntitySearch ? 'popupEditFilterEntity' : 'popupEditFilter',
                resolve: {
                    data: {
                        editFilterBoxVisibled: true,
                        showEntitySearch: _showEntitySearch,
                        tipoCampo: _tipoCampo,
                        isRequiredEdit: _isRequiredEdit,
                        txiEntityEdit: _txiEntityEdit
                    }
                }
            }).result
                .then(function (result) {
                        _txiEntityEdit = result.filter;
                        editFilterExpression();
                        closeFilterEdit();
                        self.ds.setModified(AngularUtil.getControllerFromElement(document.getElementById('filterExpressionn')));
                        _txiEntityEdit = '';
                        _tipoCampo = '';
                    }
                    , function (cancel) {
                        closeFilterEdit();
                    });
        }

        function clearFilter() {
            self.filterExpression = '';
            self.ds.setModified(AngularUtil.getControllerFromElement(document.getElementById('filterExpressionn')));
            _isEditFilterEnabled = false;
        }

        function editFilterExpression() {
            self.filterExpression = editFilterMetadata(self.filterExpression, getIndexToEdit());
        }

        function editFilterMetadata(expression, indexToEdit) {
            const PARAMETER = "?";
            var newExpression = null;

            var metadataStart = "/*{";
            var metadataEnd = "}*/";

            var variablesBuilder = new FilterVariablesBuilder(_isRequiredEdit, _tipoCampo, _txiEntityEdit);

            if (expression.indexOf(PARAMETER) >= 0) {
                if (expression.substring(indexToEdit + 1, indexToEdit + 4) == metadataStart) {
                    var metadataString = expression.substring(indexToEdit + 4, expression.indexOf(metadataEnd, indexToEdit));

                    expression = expression.slice(0, indexToEdit + 1) + expression.slice(expression.indexOf(metadataEnd, indexToEdit) + 3);
                }

                var endOfExpression = expression.substring(indexToEdit + PARAMETER.length, expression.length);

                newExpression = expression.substring(0, indexToEdit) + PARAMETER + variablesBuilder.buildExpression();

                if (endOfExpression != '') {
                    newExpression = newExpression + endOfExpression;
                }

            } else {
                newExpression = expression;
            }

            return newExpression;
        }

        function closeFilterEdit() {
            _isRequiredEdit = true;
            _tipoCampo = '';
        }

        function getIndexToEdit() {
            var cursorIndex = 0;

            if (_textAreaExpressao) {
                var range = _textAreaExpressao.getSelectionRange();
                cursorIndex = range.start;
            }

            var charToFind = '?';
            var expression = self.filterExpression;
            var charToFindIndexes = [];
            var distanceArray = [];

            var matchIndex = 0;

            while (matchIndex != -1) {
                matchIndex = expression.indexOf(charToFind, matchIndex);
                if (matchIndex != -1) {
                    charToFindIndexes.push(matchIndex);
                    matchIndex++;
                }
            }

            for (var i = 0; i < charToFindIndexes.length; i++) {
                distanceArray.push(Math.abs(charToFindIndexes[i] - cursorIndex));
            }

            var indexToEdit = charToFindIndexes[getMinValueIndex(distanceArray)];

            return indexToEdit;
        }

        function getMinValueIndex(array) {
            var minValueIndex = 0;
            var minValue = array[0];

            for (var i = 0; i < array.length; i++) {
                if (array[i] < minValue) {
                    minValueIndex = i;
                    minValue = array[i];
                }
            }

            return minValueIndex;
        }

        function prepareEditForm(indexToEdit) {
            var expression = self.filterExpression;
            var metadataStart = "/*{";
            var metadataEnd = "}*/";
            var filterMetadataObject = null;

            _txiEntityEdit = '';

            if (expression.substring(indexToEdit + 1, indexToEdit + 4) == metadataStart) {
                var metadataString = expression.substring(indexToEdit + 4, expression.indexOf(metadataEnd, indexToEdit));

                filterMetadataObject = getFilterMetadata(metadataString);

                if (filterMetadataObject != null) {
                    _isRequiredEdit = filterMetadataObject["req"] == "s" ? true : false;
                    _txiEntityEdit = filterMetadataObject["entity"];
                    _tipoCampo = filterMetadataObject["type"];

                    if (!(_tipoCampo == "I" || _tipoCampo == "S")) {
                        _showEntitySearch = false;
                    } else {
                        _showEntitySearch = true;
                    }
                }
            }
        }

        function getFilterMetadata(metadataString) {
            var objectData = {};
            var metadataArray = metadataString.split(";");

            for (var i = 0; i < metadataArray.length; i++) {
                var metadata = metadataArray[i].replace("{", "").replace("}", "").split("=");
                objectData[metadata[0]] = metadata[1];
            }

            return objectData;
        }

        $scope.removeFromGroup = function ($event) {

            var item = buildItemListaOrdByUniqueId($event.currentTarget.id);

            if (!item || angular.isArray(item).length < 1) {
                MessageUtils.showError('Core.SelecaoCampos.lblSelecioneLinhaRemoverGrupo');
                return false;
            }

            var deletou = false;

            var ac = self.dsListaOrdenacao.getRecordsAsObjects();

            var index = findIndexByLabel(ac, item.label);

            if (index > -1) {
                ArrayUtils.removeAtIndex(ac, index);
                deletou = true
            }

            if (deletou) {
                _mapStateSwitch = [];
                buildNewOrdemAgrup(ac);
                notifyChange();
            }
        }

        $scope.addGroupDetail = function ($event) {

            let item = buildItemListaOrdByUniqueId($event.currentTarget.id);

            if (!item) {
                throw new Error(i18n('Core.MgeReport.msgSelecioneLinha'))
            }

            if (!item.agrupado) {
                throw new Error(i18n('Core.MgeReport.msgQuebraNaoAgrupada'));
            }

            let grupo = item.groupIndex;
            var acDisponiveis = [];
            var acUsados = [];

            self.listaSelecionados.forEach(function (campo) {
                acDisponiveis.push(campo);
            });

            var toRemove = [];

            var acOrd = self.dsListaOrdenacao.getRecordsAsObjects();

            for (var j = 0; j < acOrd.length; j++) {
                var campo = acOrd[j];

                for (var i = 0; i < acDisponiveis.length; i++) {
                    var campo2 = acDisponiveis[i];

                    if (campo2.label == campo.label) {

                        var index = ArrayUtils.findIndex(acDisponiveis, function (indexField) {
                            return campo2 === indexField;
                        });

                        if (toRemove.indexOf(index) == -1) {
                            toRemove.push(campo2);
                            break;
                        }
                    }
                }

                if (campo.masterGroupIndex == grupo) {
                    acUsados.push({ label: campo.label });
                }
            }

            toRemove.forEach(function (item) {
                ArrayUtils.removeReference(acDisponiveis, item);
            });

            ArrayUtils.sortByStringProperty(acDisponiveis, 'label');

            SanPopup.open({
                title: i18n('Core.FormatadorCuboRelatorio.lblGroupDetail'),
                templateUrl: 'commons/formatadorcuborelatorio/selecaocampos/popup/SeletorDetalhesQuebraPopUp.tpl.html',
                controller: 'SeletorDetalhesQuebraController',
                controllerAs: 'ctrl',
                size: 'md',
                height: '300',
                showBtnNo: false,
                showBtnCancel: false,
                showBtnOk: false,
                resolve: {
                    data: {
                        listaDiponiveisQuebra: acDisponiveis,
                        listaSelecionadosQuebra: acUsados,
                        collectionChange: function (action, itemToMove, indexToMove) {

                            var acOrdemList = self.dsListaOrdenacao.getRecordsAsObjects();

                            if (action == 'remove') {

                                ArrayUtils.removeAtIndex(acOrdemList, findIndexByLabel(acOrdemList, itemToMove.label));

                                _mapStateSwitch = [];
                                buildNewOrdemAgrup(acOrdemList);
                            }

                            if (action == 'add') {

                                var targetIndex = findIndexByLabel(acOrdemList, item.label, false) + indexToMove + 1;

                                var newItem = { label: itemToMove.label, masterGroupIndex: grupo };

                                ArrayUtils.insertAtIndex(acOrdemList, targetIndex, newItem)
                                buildNewOrdemAgrup(acOrdemList);
                            }

                            notifyChange();
                        }
                    }
                }
            }).result
                .then(function (result) { });
        }

        function findIndexByLabel(list, lbl) {
            var index = -1;

            ArrayUtils.forEach(list, function (item, currIndex) {
                if (item.label == lbl) {
                    index = currIndex;
                    return false;
                }
            });

            return index;
        }

        function findItemAtByLabel(list, indextAt) {
            var itemToReturn = undefined;
            ArrayUtils.forEach(list, function (item, currIndex) {
                if (currIndex == indextAt) {
                    itemToReturn = item;
                    return false;
                }
            });

            return itemToReturn;
        }

        function buildNewOrdemAgrup(records) {
            self.dsListaOrdenacao.clearDataSet();
            self.dsListaOrdenacao.addRecordsAsObjects(records);
        }

    }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('CriterioPopUpController', ['data', '$popupInstance', 'SkPesquisaService', 'i18n',
        function (data, $popupInstance, SkPesquisaService, i18n) {
            var self = this;

            var item = data.item
            var _tipoCampo;

            self.appendCriteria = data.appendCriteria;

            self.comboOperador = [
                { value: i18n("Core.FormatadorCuboRelatorio.optMaiorque"), data: "&gt; \{0\}" },
                { value: i18n("Core.FormatadorCuboRelatorio.optMenorque"), data: "&lt; \{0\}" },
                { value: i18n("Core.FormatadorCuboRelatorio.optIgualA"), data: "= \{0\}" },
                { value: i18n("Core.FormatadorCuboRelatorio.optMaiorIgual"), data: "&gt;= \{0\}" },
                { value: i18n("Core.FormatadorCuboRelatorio.optMenorIgual"), data: "&lt;= \{0\}" },
                { value: i18n("Core.FormatadorCuboRelatorio.optDiferente"), data: "&lt;&gt; \{0\}" },
                { value: i18n("Core.FormatadorCuboRelatorio.optContendo"), data: "Like '%\{0\}%'", contemAspas: "true", aceitaTipo: "I-N-F-$-M-R-S" },
                { value: i18n("Core.FormatadorCuboRelatorio.optComecando"), data: "Like '\{0\}%'", contemAspas: "true", aceitaTipo: "I-N-F-$-M-R-S" },
                { value: i18n("Core.FormatadorCuboRelatorio.optTerminando"), data: "Like '%\{0\}'", contemAspas: "true", aceitaTipo: "I-N-F-$-M-R-S" },
                { value: i18n("Core.FormatadorCuboRelatorio.optVazio"), data: "is null" }
            ];

            self.operadorValue = '&gt; \{0\}';

            self.ligacaoValue;
            self.ligacaoCriterio;
            self.labelField = ''
            self.textFilter = null;
            self.showEntitySearch = false;
            self.ckcVariavel = false;
            self.ckcIsRequired = true;
            self.campoTextVisibled = false;
            self.campoNumeroVisibled = false;
            self.campoDataVisibled = false;
            self.campoOpcoesVisibled = false;

            self.campoTexto;
            self.campoNumero = 0;
            self.campoNumeroPrecision = 0;
            self.campoData;
            self.campoOpcoes = [];
            self.opcoesValue;

            //Functions
            self.searchEntity = searchEntity;
            self.prepareAppendCriteria = prepareAppendCriteria;

            init();
            function init() {

                self.ligacaoCriterio = ".E.";
                self.ligacaoValue = ".E.";

                self.labelField = item.data.descricao;

                var opts = [];

                if (item.data.options) {
                    var options = item.data.options.toString().split(";");

                    options.forEach(function (opt) {
                        if (opt) {
                            var o = [opt.split("=")];
                            opts.push({ data: o[0], value: o[1] });
                        }
                    });
                }

                var campo;

                var tipoCampo = item.data.tipo;
                _tipoCampo = tipoCampo;

                if (tipoCampo == "I" || tipoCampo == "S") {
                    self.showEntitySearch = true;
                } else {
                    self.showEntitySearch = false;
                }

                if (opts.length > 0) {
                    self.campoOpcoes = opts;
                    campo = 'campoOpcoes';

                } else if ("T-D".indexOf(tipoCampo) > -1) {
                    campo = 'campoData';

                } else if ("I-N-F-$".indexOf(tipoCampo) > -1) {

                    if ("F-$".indexOf(tipoCampo) > -1) {
                        self.campoNumeroPrecision = 2;
                    } else {
                        self.campoNumeroPrecision = 0;
                    }

                    campo = 'campoNumero';

                } else {
                    campo = 'campoTexto';
                }

                self.campoDataVisibled = campo == 'campoData';
                self.campoData = null;
                self.campoNumeroVisibled = campo == 'campoNumero';
                self.campoNumero = 0;
                self.campoOpcoesVisibled = campo == 'campoOpcoes';
                self.campoOpcoes = [];
                self.campoTextVisibled = campo == 'campoTexto';
                self.campoTexto = null;
            }

            function searchEntity(text) {
                var options = {
                    loadOnCreate: false,
                    enviromentCriteria: getEnvironmentCriteria,
                    enableRowsCounter: false,
                    allowShowHierarchicalMode: false,
                    label: ''
                }

                var entityName = "Instancia";
                var descriptionValue = undefined;

                SkPesquisaService.openPesquisaPopUp(entityName, descriptionValue, options)
                    .then(function (result) {
                        if (result && result.data) {
                            self.textFilter = result.data.NOMEINSTANCIA;
                        }
                    });
            }

            function getEnvironmentCriteria() {
                var criteria = new Criteria();
                criteria.append('this.NUINSTANCIAPAI IS NULL');
                return criteria;
            }

            function prepareAppendCriteria() {
                var value = null;

                if (self.campoOpcoesVisibled) {
                    value = self.opcoesValue;
                } else if (self.campoDataVisibled) {
                    value = self.campoData;
                } else if (self.campoNumeroVisibled) {
                    value = self.campoNumero;
                } else {
                    value = self.campoTexto;
                }

                var comboOperadorSelected = {};
                self.comboOperador.forEach(function (item) {

                    if (self.operadorValue == item.data) {
                        comboOperadorSelected = item;
                        return false;
                    }
                });

                self.appendCriteria(comboOperadorSelected, self.ligacaoValue, self.labelField, self.ckcVariavel, _tipoCampo, value, self.ckcIsRequired, self.textFilter, $popupInstance);
            }
        }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('EditFilterPopUpController', ['data', '$popupInstance', 'SkPesquisaService',
        function (data, $popupInstance, SkPesquisaService) {
            var self = this;

            self.showEntitySearch = false;

            self.showEntitySearch = data.showEntitySearch;
            self.tipoCampo = data.tipoCampo;
            self.ckcRequiredEdit = data.isRequiredEdit;
            self.textFilter = data.txiEntityEdit;

            //Functions
            self.searchEntity = searchEntity;
            self.getEnvironmentCriteria = getEnvironmentCriteria;
            self.confirmFilterEdit = confirmFilterEdit;
            self.closeFilterEdit = closeFilterEdit;

            function searchEntity(text) {
                var options = {
                    loadOnCreate: false,
                    enviromentCriteria: getEnvironmentCriteria,
                    enableRowsCounter: false,
                    allowShowHierarchicalMode: false,
                    label: ''
                }

                var entityName = "Instancia";
                var descriptionValue = undefined;

                SkPesquisaService.openPesquisaPopUp(entityName, descriptionValue, options)
                    .then(function (result) {
                        if (result && result.data) {
                            self.textFilter = result.data.NOMEINSTANCIA;
                        }
                    });
            }

            function getEnvironmentCriteria() {
                var criteria = new Criteria();
                criteria.append('this.NUINSTANCIAPAI IS NULL');
                return criteria;
            }

            function confirmFilterEdit() {
                data.filter = self.textFilter;

                $popupInstance.success(data);
            }

            function closeFilterEdit() {
                $popupInstance.dismiss();
            }
        }]);
/**
 * Created by Handz (Eduardo,Charles).
 */
angular
    .module('snk.commons')
    .controller('SeletorDetalhesQuebraController', ['data', 'ArrayUtils',
        function (data, ArrayUtils) {
            var self = this;

            self.listaDiponiveisQuebra = data.listaDiponiveisQuebra;
            self.listaSelecionadosQuebra = data.listaSelecionadosQuebra;

            self.collectionChange = data.collectionChange;

            self.onMoveItems = onMoveItems;

            function onMoveItems(item, listName) {

                var index = 0;

                if (listName == 'srcList') {

                    if (self.listaSelecionadosQuebra.length > 0) {
                        index = ArrayUtils.indexOf(self.listaSelecionadosQuebra, item, false);
                    }

                    self.collectionChange('add', item, index);
                } else if (listName == 'destList') {

                    if (self.listaDiponiveisQuebra.length > 0) {
                        index = ArrayUtils.indexOf(self.listaDiponiveisQuebra, item, false);
                    }

                    self.collectionChange('remove', item, index);
                }
            }
        }]);
/**
 * Created by cleverson.puche 10/04/2017
 */
angular
    .module('snk.commons')
    .controller('FormConfigColumnsController',['$scope', '$popupInstance', 'FormColumnConfig', 'options', 'SkI18nService', 'SkApplicationInstance', 'ObjectUtils', 'MessageUtils',
        function($scope, $popupInstance, FormColumnConfig, options, SkI18nService, SkApplicationInstance, ObjectUtils, MessageUtils) {
            var self = this;
            
            var _key                    = options.key;
            var _currentFormColConfig   = undefined;

            var _multiColunasImgPath    = '/mge/assets/img/layout-padrao.png';
            var _normalImgPath          = '/mge/assets/img/layout-normal.png';
            var _compactaImgPath        = '/mge/assets/img/layout-compacta.png';

            $scope.$success             = onFinish;
            $scope.$dismiss             = onDismiss;

            self.isHierarchyDynaform    = options.isHierarchyDynaform;

            init();

            function init() {
                _key = angular.isDefined(_key) ? _key : FormColumnConfig.FORM_COL_CONFIG_PREFIX + SkApplicationInstance.getResourceID();

                if(self.isHierarchyDynaform === true){
                    self.keyHierarchy = FormColumnConfig.HIERARCHY_CONFIG_PREFIX + SkApplicationInstance.getResourceID();
                    var configHierarchy = SkApplicationInstance.getConfiguracaoTela(self.keyHierarchy);    
                    
                    if(configHierarchy != undefined){
                        self.useTreeHierarchy = configHierarchy.config;
                    }
                }

                var config              = SkApplicationInstance.getConfiguracaoTela(_key);
                var configValue         = ObjectUtils.getProperty(config,'config');
                var configHasNew        = ObjectUtils.getProperty(config,'newConfig');
                var colValueNumber;
                
                //Tratativa para a nova config de formulário
                if(configValue){
                    colValueNumber = Number(configValue);                    
                    if(!configHasNew && colValueNumber > 0){
                    	colValueNumber--;
                        if(colValueNumber == 2) colValueNumber = 0;
                    }
                }
                
                _currentFormColConfig   = angular.isDefined(colValueNumber) ? Number(colValueNumber) : FormColumnConfig.PADRAO;
 
                switch(_currentFormColConfig) {
                    case FormColumnConfig.UNICA_COMPACTA:
						self.inputValue = FormColumnConfig.UNICA_COMPACTA;
                        self.currentConfigImg = _compactaImgPath;
                        self.currentTooltip = SkI18nService.instant('FormConfig.tooltipOptColCompacta');
                        break;
                    case FormColumnConfig.UNICA_NORMAL:
                        self.inputValue = FormColumnConfig.UNICA_NORMAL;
                        self.currentConfigImg = _normalImgPath;
                        self.currentTooltip = SkI18nService.instant('FormConfig.tooltipOptColNormal');
                        break;
                    case FormColumnConfig.MULTI_COLUNAS:
                        self.inputValue = FormColumnConfig.MULTI_COLUNAS;
                        self.currentConfigImg = _multiColunasImgPath;
                        self.currentTooltip = SkI18nService.instant('FormConfig.tooltipOptPadrao');
                        break;
                    default:
                        self.inputValue = FormColumnConfig.PADRAO;
                        self.currentConfigImg = _compactaImgPath;
                        self.currentTooltip = SkI18nService.instant('FormConfig.tooltipOptColCompacta');
                    break;
                }

                self.comboDP = [
                    {
                        option: FormColumnConfig.PADRAO,
                        tooltip: SkI18nService.instant('FormConfig.tooltipOptColCompacta'),
                        imgPath: _compactaImgPath
                    },
                    {
                        option: FormColumnConfig.UNICA_NORMAL,
                        tooltip: SkI18nService.instant('FormConfig.tooltipOptColNormal'),
                        imgPath: _normalImgPath
                    },
                    {
                        option: FormColumnConfig.MULTI_COLUNAS,
                        tooltip: SkI18nService.instant('FormConfig.tooltipOptPadrao'),
                        imgPath: _multiColunasImgPath
                    },
                    
                ]

                setupBtnRestore();
            }

            function setupBtnRestore() {
                var config              = SkApplicationInstance.getConfiguracaoTela(_key);
                var configFromDefault   = ObjectUtils.getProperty(config,'fromDefault') === "true";

                if(options.btnRestore) {
                    if(configFromDefault) {
                        options.btnRestore.css('display', 'none');
                    } else {
                        options.btnRestore.on('click', restoreConfig);
                    }
                }
            }

            function onFinish() {
                var newConfigValue = Number(self.inputValue);

                if(self.isHierarchyDynaform === true){
                    SkApplicationInstance.saveMgeConfig(self.keyHierarchy, {config: self.useTreeHierarchy});
                    SkApplicationInstance.putConfiguracaoTela(self.keyHierarchy, {config: self.useTreeHierarchy});
                }

                if(_currentFormColConfig != newConfigValue) {
                    SkApplicationInstance.saveMgeConfig(_key, {config: newConfigValue, newConfig: true});
                    SkApplicationInstance.putConfiguracaoTela(_key, {config: newConfigValue, newConfig: true});

                    if(self.applyForAllScreens == "S") {
                        SkApplicationInstance.saveMgeConfig(FormColumnConfig.FORM_COL_CONFIG_PREFIX + FormColumnConfig.DEFAULT_KEY,{config: newConfigValue, newConfig: true});
                        SkApplicationInstance.putConfiguracaoTela(FormColumnConfig.FORM_COL_CONFIG_PREFIX + FormColumnConfig.DEFAULT_KEY,{config: newConfigValue, newConfig: true});
                    }

                    $popupInstance.success({newConfig: newConfigValue, configChanged: true});
                } else if(self.applyForAllScreens == "S") {
                    MessageUtils
                        .simpleConfirmBuilder()
                        .msg('FormConfig.msgAplicarATodasTelas')
                        .showAsWarning(true)
                        .show()
                        .then(function() {
                            SkApplicationInstance.saveMgeConfig(FormColumnConfig.FORM_COL_CONFIG_PREFIX + FormColumnConfig.DEFAULT_KEY,{config: newConfigValue, newConfig: true});
                            SkApplicationInstance.putConfiguracaoTela(FormColumnConfig.FORM_COL_CONFIG_PREFIX + FormColumnConfig.DEFAULT_KEY,{config: newConfigValue, newConfig: true});
                            $popupInstance.success({newConfig: newConfigValue, configChanged: false, newConfig: true});
                        });
                } else {
                    $popupInstance.dismiss();
                }
            }

            function restoreConfig() {
                MessageUtils
                    .simpleConfirmBuilder()
                    .msg('FormConfig.msgRestaurarConfig')
                    .showAsWarning(true)
                    .show()
                    .then(function() {
                        SkApplicationInstance.removeMgeConfig(_key).then(function() {
                            SkApplicationInstance.loadMgeConfig(FormColumnConfig.FORM_COL_CONFIG_PREFIX + FormColumnConfig.DEFAULT_KEY)
                                .then(function(defaultConfig) {
                                    var config = defaultConfig ? ObjectUtils.getProperty(defaultConfig,'config.config') : FormColumnConfig.PADRAO;
                                    SkApplicationInstance.putConfiguracaoTela(_key, {config: config, fromDefault: "true"});
                                    $popupInstance.success({newConfig: config, configChanged: true});
                                });
                        });
                    });
            }

            function onDismiss(reason) {
                $popupInstance.dismiss(reason);
            }
        }
    ]);

angular
    .module('snk.commons')
    .service('FormConfigColumnsPopUp',['SanPopup', 'SkI18nService',
       function(SanPopup, SkI18nService) {
           var self = this;

           self.open = open;

           function open(key, isHierarchyDynaform) {
               var btnRestore = angular.element('<button class="btn btn-danger">' + SkI18nService.instant('GridConfig.restaurarPadrao') + '</button>');

               var popup = SanPopup.open({
                   title: SkI18nService.instant('Dynaform.configApresForm'),
                   templateUrl: 'commons/formconfig/columns/formconfigcolumns.tpl.html',
                   controller: 'FormConfigColumnsController',
                   controllerAs: 'ctrl',
                   type: 'default',
                   okBtnLabel: SkI18nService.instant('Geral.confirmar'),
                   okBtnClass: 'btn-primary',
                   cancelBtnClass: 'btn-default',
                   showBtnNo: false,
                   showBtnCancel: true,
                   bodyPadding: false,
                   size: 'lg',
                   leftBottomBar: [btnRestore],
                   height: 365,
                   windowClass: 'config-form-modal',
                   resolve: {
                       options: {
                           key: key,
                           isHierarchyDynaform, isHierarchyDynaform,
                           btnRestore: btnRestore
                       }
                   }
               });

               return popup.result;
           }
       }
    ]);

angular.module('snk.commons.formularioProducaoBuilder')
    .component('skFormularioProducaoBuilder', {
        templateUrl: 'commons/formularioProducaoBuilder/formularioProducaoBuilder.tpl.html',
        controller: 'FormularioProducaoBuilderController',
        controllerAs: 'ctrl',
        bindings: {
            selectedIndexTab: '=?selectedIndexTab',
            listDynaforms: '=?listDynaforms',
            onCreated: '&skOnCreated'
        }
    })
    .controller('FormularioProducaoBuilderController', ['Criteria', 'ObjectUtils', 'StringUtils', 'ServiceProxy', 'MessageUtils',
        function (Criteria, ObjectUtils, StringUtils, ServiceProxy, MessageUtils) {
            var self = this;
            const ESCOPO_POR_PROCESSO = "P";
            const TIPO_FORMULARIO_ATIVIDADE = "A";
            const TIPO_FORMULARIO_INICIALIZACAO = "I";
            const FORMULARIO_CONSULTA_PROCESSO = "CP";
            const FORMULARIO_CONSULTA_ATIVIDADE = "CA";
            const ACESSO_SOMENTE_LEITURA = "0";
            const CARDINALIDADE_1x1 = "1";
            var _mapInstanceConsulta = {};
            var _mapCardinalidade = {};
            var _mapEscopoProcesso = {};
            var _mapTipoInicializacao = {};
            var _camposInvisivel = { "IDIPROC": undefined, "IDEFX": undefined };
            self.listDynaforms = [];
            var _tabNav = 0;
            var _publicAPI;
            var _resourceId;
            var _dataset;
            var _tabNavigator;
            var _callBackSemFormularios;
            const FINALIZADA = "F";

            // Interceptors
            ObjectUtils.implements(self, IDynaformInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);

            self.onDynaformLoaded = onDynaformLoaded;
            self.interceptFieldMetadata = interceptFieldMetadata;
            self.acceptField = acceptField;
            self.acceptColumnField = acceptColumnField;
            self.interceptColumnMetadata = interceptColumnMetadata;
            
            init();

            function init() {
                _publicAPI = {
                    setResourceId: setResourceId,
                    setDataset: setDataset,
                    setTabNavigator: setTabNavigator,
                    callBackSemFormularios: callBackSemFormularios,
                    buildFormulario: buildFormulario
                };
                self.onCreated({$instance:  _publicAPI})
            }

            function setResourceId(value) {
                _resourceId = value;
            }

            function setDataset(value) {
                _dataset = value;
            }

            function setTabNavigator(value) {
                _tabNavigator = value;
            }

            function callBackSemFormularios(value) {
                _callBackSemFormularios = value;
            }

            function buildFormulario() {
                if (angular.isDefined(_dataset)) {
                    updateTabsForm();
                }
            }

            function removeTabsForm() {
                if (angular.isDefined(_tabNavigator)) {
                    var tabs = _tabNavigator.tabs;
                    tabs.forEach(tab => {
                        if (angular.isDefined(tab.tabId) && tab.tabId.indexOf("formularioProducao_") > -1) {
                            tabs.splice(tab.index);
                        }
                    });
                }
            }

            function updateTabsForm() {
                var strQuery = getQueryBuscaFormularios();
                var query = {
                    querydata: {
                        query: strQuery,
                        param: []
                    }
                };
                if (isAtividade()) {
                    query.querydata.param.push({ value: _dataset.getFieldValueAsNumber("CabecalhoInstanciaProcesso.ProcessoProdutivo.IDPROC") });
                    query.querydata.param.push({ value: _dataset.getFieldValueAsNumber("IDEFX") });
                    query.querydata.param.push({ value: _dataset.getFieldValueAsNumber("CODPRODPA") });
                } else {
                    query.querydata.param.push({ value: _dataset.getFieldValueAsNumber("IDPROC") });
                }
                ServiceProxy.callService("mge@ExecQuerySP.execQuery", query)
                    .then(function (result) {
                        removeTabsForm();
                        self.listDynaforms = [];
                        _tabNav = _tabNavigator.tabs.length;
                        setResultValuesFromQuery(result);
                    });
            }

            function setResultValuesFromQuery(result) {
                if (!ObjectUtils.isEmpty(result)) {
                    if (result.hasOwnProperty("responseBody")) {
                        var responseBody = result.responseBody;
                        if (responseBody.hasOwnProperty("entity")) {
                            var entity = responseBody.entity;
                            if (entity.hasOwnProperty("line")) {
                                var listLines = entity.line;
                                if (StringUtils.isNotEmpty(listLines)) {
                                    if (!angular.isArray(listLines)) {
                                        listLines = [listLines]
                                    }
                                    for (var i = 0; i < listLines.length; i++) {
                                        if (isAtividade()) {
                                            if (listLines[i].column[4].value == ESCOPO_POR_PROCESSO && listLines[i].column[5].value == TIPO_FORMULARIO_ATIVIDADE) {
                                                _mapEscopoProcesso[listLines[i].column[2].value] = listLines[i].column[2].value;
                                            }
                                            if (listLines[i].column[5].value == TIPO_FORMULARIO_INICIALIZACAO) {
                                                _mapTipoInicializacao[listLines[i].column[2].value] = listLines[i].column[2].value;
                                            }
                                        }
                                        if (listLines[i].column[3].value == FORMULARIO_CONSULTA_PROCESSO || listLines[i].column[3].value == FORMULARIO_CONSULTA_ATIVIDADE || listLines[i].column[3].value == ACESSO_SOMENTE_LEITURA) {
                                            _mapInstanceConsulta[listLines[i].column[2].value] = listLines[i].column[2].value;
                                        }
                                        if (listLines[i].column[0].value == CARDINALIDADE_1x1) {
                                            _mapCardinalidade[listLines[i].column[2].value] = CARDINALIDADE_1x1;
                                        }
                                        buildDynaformDynamic(listLines[i]);
                                    }
                                    if (listLines.length == 0 && angular.isFunction(_callBackSemFormularios)) {
                                        _callBackSemFormularios();
                                    }
                                }
                            }
                        }
                    }
                }
            }

            function isAtividade() {
                return _dataset.getEntityName() == "InstanciaAtividade";
            }

            function getQueryBuscaFormularios() {
                var strQuery = "";
                if (isAtividade()) {
                    strQuery = "SELECT FORMU.CARDINALIDADE, FORMU.DESCRICAO, FORMULARIO.NOMEINSTANCIA, FRME.TIPOACESSO, FORMU.ESCOPO, FORMU.TIPOFORM ";
                    strQuery += " FROM TPRFORM FORMU ";
                    strQuery += "		INNER JOIN ( ";
                    strQuery += "			SELECT NOMEINSTANCIA, TIPOFORM ";
                    strQuery += "				FROM TDDINS INS  ";
                    strQuery += "			WHERE TIPOFORM IS NOT NULL ";
                    strQuery += "		) FORMULARIO ON (FORMULARIO.NOMEINSTANCIA = FORMU.NOMEINSTANCIAREF)  ";
                    strQuery += "		INNER JOIN TPRFRME FRME ON (FORMU.IDFORM = FRME.IDFORM)  ";
                    strQuery += "		LEFT JOIN TPRFPA FPA ON (FORMU.IDFORM = FPA.IDFORM AND FORMU.IDPROC = FPA.IDPROC)   ";
                    strQuery += " WHERE FORMU.IDPROC = ? ";
                    strQuery += "		AND FRME.IDEFX = ? ";
                    strQuery += "		AND (FPA.CODPRODPA IS NULL OR FPA.CODPRODPA = ?) ";
                    strQuery += "		AND (nullValue(FPA.CONTROLEPA, ' ') = ' ' OR FPA.CONTROLEPA = '" + _dataset.getFieldValueAsString("CONTROLEPA") + "') ";
                    strQuery += " ORDER BY FRME.ORDEM ";
                } else {
                    strQuery = " SELECT FORMU.CARDINALIDADE, FORMU.DESCRICAO, FORMULARIO.NOMEINSTANCIA, FORMULARIO.TIPOFORM ";
                    strQuery += " FROM TPRFORM FORMU ";
                    strQuery += "		INNER JOIN ( ";
                    strQuery += "			SELECT NOMEINSTANCIA, TIPOFORM ";
                    strQuery += "				FROM TDDINS INS  ";
                    strQuery += "			WHERE TIPOFORM IS NOT NULL ";
                    strQuery += "		) FORMULARIO ON (FORMULARIO.NOMEINSTANCIA = FORMU.NOMEINSTANCIAREF)  ";
                    strQuery += " WHERE IDPROC = ? ";
                    strQuery += "		AND FORMU.TIPOFORM = 'I' ";
                    strQuery += " ORDER BY FORMU.ORDEMINICIA ";
                }
                return strQuery;
            }

            function buildDynaformDynamic(line) {
                var dynaform = {};
                dynaform.label = line.column[1].value;
                dynaform.entityName = line.column[2].value;
                dynaform.id = "formularioProducao_" + dynaform.entityName;
                dynaform.resourceId = _resourceId + ";" + dynaform.entityName;
                dynaform.editUniqueRecord = false;
                if (_mapCardinalidade.hasOwnProperty(dynaform.entityName)) {
                    dynaform.helperClassName = "br.com.sankhya.mgeprod.model.dynaform.FormularioProducaoDynaformHelper";
                    dynaform.editUniqueRecord = true;
                } else if (_mapTipoInicializacao.hasOwnProperty(dynaform.entityName)) {
                    dynaform.helperClassName = "br.com.sankhya.mgeprod.model.dynaform.FormularioProducaoInicializacaoAtvDynaformHelper";
                }
                dynaform.index = _tabNav++;
                self.listDynaforms.push(dynaform);
            }

            function onDynaformLoaded(dynaform, dataset) {
                var entityName = dataset.getEntityName();
                var criteriaProvider = new CriteriaProvider();
                if (isAtividade()) {
                    if (_mapEscopoProcesso.hasOwnProperty(entityName)) {
                        criteriaProvider.getCriteria = getCriteriaEscopoProcessoAtividade;
                    } else if (_mapTipoInicializacao.hasOwnProperty(entityName)) {
                        criteriaProvider.getCriteria = getCriteriaInicializacao;
                    } else {
                        criteriaProvider.getCriteria = getCriteriaAtividade;
                    }
                } else {
                    criteriaProvider.getCriteria = getCriteriaInicializacao;
                }
                dataset.addCriteriaProvider(criteriaProvider);
                dataset.beforePostAction(beforePost);
                dataset.beforeDeleteAction(beforeDelete);
                dataset.initAndRefresh();
            }

            function beforePost(dataset) {
                if (dataset.isInsertionMode()) {
                    dataset.setFieldValue("IDIPROC", _dataset.getFieldValueAsNumber("IDIPROC"));
                    if (isAtividade()) {
                        dataset.setFieldValue("IDEFX", _dataset.getFieldValueAsNumber("IDEFX"));
                    } else {
                        dataset.setFieldValue("IDEFX", 0);
                    }
                }
                if (FINALIZADA == _dataset.getFieldValueAsString("SITUACAO")) {
					MessageUtils.showError(MessageUtils.TITLE_ERROR,  "Atividade já foi finalizada.");
					dataset.cancelEdition();
					return false;
				}
                return true;
            }

            function beforeDelete(dataset) {
                if (_mapInstanceConsulta.hasOwnProperty(dataset.getEntityName())) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Producao.OperacaoProducao.msgValidacaoFormularioLeitura"));
                    return false;
                }
                if (FINALIZADA == _dataset.getFieldValueAsString("SITUACAO")) {
					MessageUtils.showError(MessageUtils.TITLE_ERROR,  "Atividade já foi finalizada.");
					return false;
				}
                return true;
            }

            function getCriteriaAtividade() {
                var criteria = new Criteria();
                criteria.append("this.IDIPROC = ? AND this.IDEFX = ?");
                criteria.addParameter(Criteria.buildNumberParameter(_dataset.getFieldValueAsString("IDIPROC")));
                criteria.addParameter(Criteria.buildNumberParameter(_dataset.getFieldValueAsString("IDEFX")));
                return criteria;
            }

            function getCriteriaEscopoProcessoAtividade() {
                var criteria = new Criteria();
                criteria.append("this.IDIPROC = ?");
                criteria.addParameter(Criteria.buildNumberParameter(_dataset.getFieldValueAsString("IDIPROC")));
                return criteria;
            }

            function getCriteriaInicializacao() {
                var criteria = new Criteria();
                criteria.append("this.IDIPROC = ? AND this.IDEFX = 0");
                criteria.addParameter(Criteria.buildNumberParameter(_dataset.getFieldValueAsString("IDIPROC")));
                return criteria;
            }

            function interceptFieldMetadata(fieldMetadata, dataset, dynaform) {
                if (_mapInstanceConsulta.hasOwnProperty(dataset.getEntityName())) {
                    fieldMetadata.enabled = false;
                }
            }

            function acceptField(fieldMD, dynaform, dataset) {
                if (_camposInvisivel.hasOwnProperty(fieldMD.name)) {
                    return false;
                }
                return true;
            }

            function acceptColumnField(fieldMD, dataset) {
                if (_camposInvisivel.hasOwnProperty(fieldMD.name)) {
                    return false;
                }
                return true;
            }

            function interceptColumnMetadata(fieldMetadata, dataset) {
                if (_mapInstanceConsulta.hasOwnProperty(dataset.getEntityName())
                    || _mapTipoInicializacao.hasOwnProperty(dataset.getEntityName())) {
                    fieldMetadata.readOnly = true;
                }
            }
        }
    ]
    );
/*
 *  Createad by Leonardo Mendes on 17/08/2018.
 */
angular
    .module('snk.commons.ftpinput')
    .directive('skFtpInput',
        function () {
            return {
                templateUrl: 'commons/ftpinput/ftpinput.tpl.html',
                controller: 'ftpInputController',
                scope: {
                    value: '=?skValue',
                    onChange: '&?skChange',
                    enabled: '=?skEnabled'
                }
            }
        })
    .controller('ftpInputController', ['$attrs', '$timeout', '$scope', 'PopUpParameter', 'StringUtils', 'i18n', 'ServiceProxy', 'MessageUtils',
        function ($attrs, $timeout, $scope, PopUpParameter, StringUtils, i18n, ServiceProxy, MessageUtils) {
            $scope.openConstrutorFTPPopup = openConstrutorFTPPopup;
            $scope.testeConexao = testeConexao;

            $scope.tooltipBtnAuxiliar = i18n('Commons.ftpinput.abreauxiliar');
            $scope.tooltipBtnTeste = i18n('Commons.ftpinput.testeftp');

            function openConstrutorFTPPopup() {
                var info = {};

                if (StringUtils.emptyAsUndefined($scope.value) != undefined) {
                    var parts = /^(?:ftp:\/\/)?(?:([^:]*)\:?([^@]*)@)?([^/:]+)(?:\:(\d+))?\/?(.*)$/gi.exec($scope.value);

                    if (parts) {
                        info.user = StringUtils.emptyAsUndefined(parts[1]);
                        info.pass = StringUtils.emptyAsUndefined(parts[2]);
                        info.addr = StringUtils.emptyAsUndefined(parts[3]);
                        info.port = parseInt(parts[4]);
                        info.path = StringUtils.emptyAsUndefined(parts[5]);
                    }
                }

                PopUpParameter.builder()
                    .title(i18n('Commons.ftpinput.informedadosendereco'))
                    .size('md')
                    .height(180)
                    .columns(2)
                    .buildStringParameter('username', 'Usuário', true, info.user)
                    .buildStringParameter('password', 'senha', true, info.pass)
                    .buildStringParameter('servidor', 'Endereço', true, info.addr)
                    .buildStringParameter('path', 'Caminho', false, info.path)
                    .buildIntegerParameter('porta', 'Porta', false, info.port)
                    .show().result
                    .then(function (result) {
                        //ftp://[<user>:<password>@]<host>[:<port>]/<url-path>
                    	var address = 'ftp://' + result.username + ':' + result.password + '@' + result.servidor;

                        if (result.porta != undefined) {
                            address += ':' + result.porta;
                        }

                        if (result.path != undefined) {
                        	if(address[address.length - 1] != "/"){
                        		address += "/";
                        	}
 
                        	address += result.path;
                        }

                        $scope.value = address;

                        if ($attrs.skChange) {
                            $timeout(function () {
                                $scope.onChange($scope);
                            });
                        }
                    });
            }

            function testeConexao() {

                if (StringUtils.emptyAsUndefined($scope.value) == undefined) {
                    MessageUtils.showError(i18n('Commons.ftpinput.enderecoftp'));

                } else {
                    ServiceProxy.callService('mge@SystemUtilsSP.testFTP', {
                        param: {
                            url: $scope.value
                        }
                    }).then(function (response) {
                        MessageUtils.showInfo(i18n('Commons.ftpinput.testesucesso'));
                    });
                }
            }
        }]);
angular
    .module('snk.commons.gradeproduto')
    .constant('GradeProdutoConstant', {"CARRINHO_COMPRAS":"0", 
    								  "CENTRAL_NOTAS":"1",
    								  "CONTAGEM_ESTOQUE":"2",
    								  "GRADE_PADRAO":"3",
    								  "MODELO_GRADE":"4",
									  "TABELA_PRECO":"5"})

angular
    .module('snk.commons.gradeproduto')
    .directive('skGradeProduto', ['GradeProdutoService',
        function(GradeProdutoService) {
            return {
                templateUrl: 'commons/gradeproduto/grade-produto.tpl.html',
                replace: true,
                restrict: 'AE',
                scope: {
                    dataset: '=?skDataset',	
                    fieldName: '@?skFieldName',
                    onStartGrade: '=?skOnStartGrade',
                    onFinishGrade: '=?skOnFinishGrade',
                    mode: '=?skMode',
                    usaPrecoPorLocal: '=?skUsaPrecoPorLocal',
                    gradeMetadata: "=?skGradeMetadata",
                    dataProvider : "=?skDataProvider"
                },
                transclude: true,
                link: function (scope, element, attrs, ctrl) {
                    scope.openGrade = function () {
                        GradeProdutoService.show(scope)
                    }
                }
            };
        }
    ]);
angular
	.module('snk.commons.gradeproduto')
	.service('GradeProdutoService', ['SanPopup', 'SkI18nService', 'ObjectUtils',
		function (SanPopup, SkI18nService, ObjectUtils) {
			var self = this;

			self.show = show;
			self.buildOptionsGrade = buildOptionsGrade;

			function show(popupInfo) {
				var popupInstance = SanPopup.open({
						title: SkI18nService.instant('Grade'),
						templateUrl: 'commons/gradeproduto/popup/grade-produto-popup.tpl.html',
						controller: 'GradeProdutoController',
						controllerAs: 'ctrl',
						bodyPadding: false,
						size: 'lg',
						showBtnCancel: false,
						showBtnOk: false,
						showBtnNo: false,
						resolve: {
							data: popupInfo
						}
					});
				return popupInstance;
			}
			
			function buildOptionsGrade(dataset, fieldName="CONTROLE", rmpName="rm_controle") {
				var options = [];
				
				if (dataset && fieldName && rmpName) {
					var fm = dataset.getFieldMetadata(fieldName);
					
					if (fm) {
						var metadataKey = null;
						for (var property of fm.properties) {
							if (property.name == 'rm_controle') {
								metadataKey = property.value;
								break;
							}
						}
						
						if (metadataKey) {
							var rowMetadata = dataset.getRowMetadata(dataset.getCurrentRow());
							
							if (rowMetadata) {
								var gradeMetadata = ObjectUtils.getProperty(rowMetadata, 'rmd.CODPROD.controle.gradeProduto');
								
								if (gradeMetadata) {
									var dm01 = gradeMetadata.dimensoes[0];
									var dm02 = gradeMetadata.dimensoes[1];
									
									dm01.variacoes.forEach(function(rec01) {
										dm02.variacoes.forEach(function(rec02) {
											var label = rec01.nome+"/"+rec02.nome;
											var usaMasc = gradeMetadata.usaMascara;
											var data = usaMasc == 'S' ? rec01.abreviacao+"/"+dm02.abreviacao : dm01.abreviacao+":"+rec01.abreviacao+"/"+dm02.abreviacao+":"+rec02.abreviacao;
																						
											options.push({label: label, data: data});
										});
									});
								}
							}
						}
					}
				}
				
				return options;
			}
		}
	]);
angular
    .module('snk.commons.gradeproduto')
    .controller('GradeProdutoController', ['StringUtils', 'GradeProdutoConstant', "i18n","data","ArrayUtils","NumberUtils", "ObjectUtils", "$scope", "$popupInstance","MessageUtils",
        function (StringUtils, GradeProdutoConstant, i18n, data, ArrayUtils, NumberUtils, ObjectUtils, $scope, $popupInstance, MessageUtils) {
            var self = this 
            
			self.confirmar = confirmar;
			self.desvincular = desvincular;
			self.cancelar = cancelar;
			self.limpar = limpar;

            
            ObjectUtils.implements(self, IDatagridInterceptor);
            self.interceptColumnMetadata = interceptColumnMetadata;
            
            self.onDatasetCreated = onDatasetCreated;
            self.onDatagridLoaded = onDatagridLoaded;
			self.isCentral = isCentral;
			self.isContagemEstoque = isContagemEstoque;
			self.isGradePadrao = isGradePadrao;
			self.isTabelaPreco = isTabelaPreco;
			self.isTransferencia = isTransferencia;
            self.grdPadraoCompr;
            self.grdPadraoFchdCompr;
            self.grdPadraoVnd;
            self.grdPadraoFchdVnd;
            self.gridEditable = true;
            self.exibirErro = false;
            self.pesqLocalInput;
            self.codLocalOrigem;
            self.codLocalDestino;
			self.isModeloGrade = isModeloGrade;
			self.habilitarConfGrade = habilitarConfGrade;
			self.disabledConfirmar = false;
			self.optionsTipo =  [	{ data: "P", value: i18n("Commons.GradeProdutos.lblPercentual") },
									{ data: "V", value: i18n("Commons.GradeProdutos.lblValor") } ];
			self.optionsValue = "P";
			self.replicarValor = replicarValor;
			self.vlrVenda;
			self.usaPrecoPorLocal =  data.usaPrecoPorLocal;
			self.valuesPrecision = 2;
            
            var _datagrid;
            var _gradeMetadata = data.grade;
            var _dataset = data.dataset;
			var _dsTabPreco = data.dsTabPreco;
			var _fieldName = data.fieldName;
			var onFinishGrade = data.onFinishGrade;
			var onStartGrade = data.onStartGrade;
            var _dataProvider = data.dataProvider;
            var _mode = angular.isUndefined(data.mode) ? GradeProdutoConstant.CENTRAL_NOTAS : data.mode; 
            var _usaMascara = angular.isUndefined(data.dataset) ? false : ("S" == data.dataset.getFieldValueAsString("Produto.ConfiguracaoGradeProduto.USAMASCARA"));
            
            function onDatasetCreated(dataset) {
            	self.dsGrade = dataset;
            	self.dsGrade.setIgnoreExportName(true);
            	
				if(!isTabelaPreco()) {
					self.dsGrade.addRefreshedListener(function(){
						if (!self.dsGrade.isEmpty()){
							self.dsGrade.getRecords().forEach(function(record){
								var total = 0
								self.dsGrade.getFieldsMetadata().forEach(function(fdm){
									if ("DIMENSAO-TOTAL-ABREVIACAO".indexOf(fdm.name) == -1) {
										total = NumberUtils.add(total, record[self.dsGrade.getFieldIndexByName(fdm.name)])
									}
								})
								record[self.dsGrade.getFieldIndexByName("TOTAL")] = total;
							});
						}
					}); 
					
					self.dsGrade.addDataModifiedListener(function(){
						var total = 0;
						self.dsGrade.getFieldsMetadata().forEach(function(fdm){
							if ("DIMENSAO-TOTAL-ABREVIACAO".indexOf(fdm.name) == -1) {
								if(!isNaN(NumberUtils.stringToNumber(self.dsGrade.getFieldValue(fdm.name)))){
									self.dsGrade.setFieldValue(fdm.name, NumberUtils.stringToNumber(self.dsGrade.getFieldValue(fdm.name)));
								}else{
									self.dsGrade.setFieldValue(fdm.name, null);
								}
								
								total = NumberUtils.add(total, self.dsGrade.getFieldValueAsNumber(fdm.name));
							}
						})
						self.dsGrade.setFieldValueAsString("TOTAL", total);
						_datagrid.setBottomData();
					})
				}
            	
				self.exibirErro = false;
            	createFieldsDataset();
            }

            function onDatagridLoaded(datagrid) {
            	_datagrid = datagrid;
            	var fixColumn = self.dsGrade.getFieldNames();
            	datagrid.pinColumn(fixColumn[0]);
				if(!isTabelaPreco()) {
					_datagrid.setBottomData();
				}
            }
            
            function interceptColumnMetadata(fieldMD) {
                if ("DIMENSAO-TOTAL-ABREVIACAO".indexOf(fieldMD.name) > -1) {
                	fieldMD.readOnly = true;
                }
            }
            
            function createFieldsDataset() {  
            	if (_dataset) {
					if (_fieldName && !_gradeMetadata) {
						var fieldMetadata = _dataset.getFieldMetadata(_fieldName);
						var metadataKey = null;
						for (var property of fieldMetadata.properties) {
							if (property.name == 'rm_controle') {
								metadataKey = property.value;
								break;
							}
						}
						if (metadataKey) {
							var rowMetadata = _dataset.getRowMetadata(_dataset.getCurrentRow());
							if (rowMetadata) {
								var controle = rowMetadata.rmd.CODPROD.controle;
								if (controle) {
									_gradeMetadata = controle.gradeProduto;
									_usaMascara = controle.usaMascara
								}
							}
						}
					}
					
					if (isGradePadrao()) {
						if (_dataset && _dataset.getFieldValueAsString("GRADEPADRAO")) {
							var dataGrade = JSON.parse(_dataset.getFieldValueAsString("GRADEPADRAO"));
							
							if (dataGrade) {
								_dataProvider = dataGrade.grade;
								atualizaPainelCompraVenda(dataGrade);
							}
						} else if(_gradeMetadata && _gradeMetadata.gradePadrao){
							var dataGrade = _gradeMetadata.gradePadrao;
							
							if (dataGrade) {
								_dataProvider = angular.isDefined(dataGrade.$) ? JSON.parse(dataGrade.$).grade : dataGrade.grade;
								atualizaPainelCompraVenda(dataGrade);
							}
						}
					} else if ((!_dataProvider || !_dataProvider.length) && _dataset.getCurrentRow() != null && isCentral() && (isCompra() || isVenda()) ) {
						if (_dataset.isInsertionMode()) {
							if (_gradeMetadata && _gradeMetadata.gradePadrao) {
								
								if (isUsaGrade()) {
									_dataProvider = _gradeMetadata.gradePadrao.grade;
								}
								configuraDataGrid();
							}
						} else {
							_dataProvider = [];
							_dataset.getRecordsAsObjects().forEach(function(item){
								if (_dataset.getFieldValue('CODPROD') == item['CODPROD']) {
									_dataProvider.push(item);
								}
							});
						 }
						configuraDataGrid();
					} else if(isTabelaPreco()) {
						self.valuesPrecision = getVlrVendaPrecision();
						
						_dataProvider =[];
						
						_dataset.getRecordsAsObjects().forEach(function(item){
							if (_dataset.getFieldValue('CODPROD') == item['CODPROD']) {
								_dataProvider.push(item);
							}
						});
					} else if(isTransferencia()){
						_dataProvider = [];

						_dataset.getRecordsAsObjects().forEach(function(item){
							if (_dataset.getFieldValue('CODPROD') == item['CODPROD']) {
								_dataProvider.push(item);
							}
						});
					}
            	}
            	
            	if (isCarrinho()) {
					configuraDataGrid();
				}

	        	if (_gradeMetadata) {
	        		if (_gradeMetadata.hasOwnProperty("gradeInvalida") && (_gradeMetadata.gradeInvalida == true || _gradeMetadata.gradeInvalida.$ == "true")) {
						self.exibirErro = true;
					} else {
						$popupInstance.setTitle("Grade - " + (angular.isDefined(_gradeMetadata.nome.$) ? _gradeMetadata.nome.$ : _gradeMetadata.nome));

						var count = 0;
						var width="910";

		        		self.dsGrade.addUserFieldMetadata({
			                name: 'DIMENSAO',
			                userType: 'S',
			                dataType: 'S',
			                visible: true,
							description: (angular.isDefined(_gradeMetadata.dimensoes[0].nome.$) ? _gradeMetadata.dimensoes[0].nome.$ : _gradeMetadata.dimensoes[0].nome)
										 + " - " + (angular.isDefined(_gradeMetadata.dimensoes[1].nome.$) ? _gradeMetadata.dimensoes[1].nome.$ : _gradeMetadata.dimensoes[1].nome),
							isPk: false,
							width : '120'
						});
						count++;
				    
		            	var variacoes = ArrayUtils.toArray(_gradeMetadata.dimensoes[1].variacoes);
		            	
		            	variacoes.forEach(function(variacao){
		            		self.dsGrade.addUserFieldMetadata({
								name: (angular.isDefined(_gradeMetadata.dimensoes[1].abreviacao.$) ? _gradeMetadata.dimensoes[1].abreviacao.$ : _gradeMetadata.dimensoes[1].abreviacao)
										+":"+ (angular.isDefined(variacao.abreviacao.$) ? variacao.abreviacao.$ : variacao.abreviacao),
				                userType: 'F',
				                dataType: 'F',
				                visible: true,
				                description: (angular.isDefined(variacao.nome.$) ? variacao.nome.$ : variacao.nome),
				                isPk: false,
				                properties: [{name:"gridFooterOper", value: "sum"}],
				                required: false,
								isNullable: true,
								width : '120'
							});
							count++;
		            	});
						
						if(!isTabelaPreco()) {
							self.dsGrade.addUserFieldMetadata({
								name: 'TOTAL',
								userType: 'F',
								dataType: 'F',
								visible: true,
								description: "TOTAL",
								isPk: false,
								properties: [{name:"gridFooterOper", value: "sum"}],
								width : '120'
							});
							count++;
						}
							            
					    self.dsGrade.addUserFieldMetadata({
			                name: 'ABREVIACAO',
			                userType: 'S',
			                dataType: 'S',
			                visible: false,
			                description: 'ABREVIACAO',
			                isPk: false
						});

						var widthTot = (120 * count); // Tamanho de todas as colunas
						if (widthTot < width) {
							widthTot = (width - 30) / count;

							self.dsGrade.getUserFieldsMetadata().forEach(function(field){
								field.width = widthTot;
							});
						}

						var loadValues = (!isCentral()) || (isCentral() && (isGradePadraoMinimaCompra() || isGradePadraoMinimaVenda() || isGradeFechadaCompra() || isGradeFechadaVenda()));
						if (isGradePadrao()) {
							var records = carregaGradePadrao(loadValues);
						} else {
							var records = carregaGrade(loadValues);
						}
						
						self.dsGrade.init().then(function(){
							self.dsGrade.addRecordsAsObjects(records, undefined, true);
							self.dsGrade.sortRecords();
						});
	        	     }
	        	}        	
            }

            function carregaGrade(carregar) {
			    var variacoes = ArrayUtils.toArray(_gradeMetadata.dimensoes[0].variacoes);
			    var records = [];
			    
			    variacoes.forEach(function(variacao){
			    	var record = {
						DIMENSAO: (angular.isDefined(variacao.nome.$) ? variacao.nome.$ : variacao.nome), 
						ABREVIACAO: (angular.isDefined(_gradeMetadata.dimensoes[0].abreviacao.$) ? _gradeMetadata.dimensoes[0].abreviacao.$ : _gradeMetadata.dimensoes[0].abreviacao)
							  +":"+ (angular.isDefined(variacao.abreviacao.$) ? variacao.abreviacao.$ : variacao.abreviacao)
					};

					if(_dataset && carregar){
						for(let dsRecord of _dataset.getRecordsAsObjects()) {
							let value = dsRecord?.CONTROLE?.split('/')[1];
							let abrev = dsRecord?.CONTROLE?.split('/')[0];
							if(record.ABREVIACAO == abrev) {
								if(record[value] && record[value] >= 1) {
									record[value] += 1 * dsRecord?.QTDNEG;
								} else {
									record[value] = 1 * dsRecord?.QTDNEG;
								}
							}
						}
					}

	            	if (_dataProvider && carregar) {
	            		_dataProvider.forEach(function(iteRecord) {
	            			var dimensao = String(iteRecord['CONTROLE']).split("/");
	            			if (record['ABREVIACAO'] == dimensao[0]) {
	            				record[dimensao[1]] = iteRecord['QTDNEG'];								
	            			}            		
	            		});
	            	}
			    	records.push(record);
            	});
			    
            	return records;
	        }
            
            function carregaGradePadrao(carregar) {
            	var variacoes = ArrayUtils.toArray(_gradeMetadata.dimensoes[0].variacoes);
            	var records = [];
            	
            	variacoes.forEach(function(variacao){
					var record = {
						DIMENSAO: (angular.isDefined(variacao.nome.$) ? variacao.nome.$ : variacao.nome), 
						ABREVIACAO: (angular.isDefined(_gradeMetadata.dimensoes[0].abreviacao.$) ? _gradeMetadata.dimensoes[0].abreviacao.$ : _gradeMetadata.dimensoes[0].abreviacao)
							  +":"+ (angular.isDefined(variacao.abreviacao.$) ? variacao.abreviacao.$ : variacao.abreviacao)
					};

					for(let dsRecord of _dataset.getRecordsAsObjects()) {
						let value = dsRecord?.CONTROLE?.split('/')[1];
						let abrev = dsRecord?.CONTROLE?.split('/')[0];
						if(record.ABREVIACAO == abrev) {
							if(record[value] && record[value] >= 1) {
								record[value] += 1 * dsRecord?.QTDNEG;
							} else {
								record[value] = 1 * dsRecord?.QTDNEG;
							}
						}
					}

            		if (_dataProvider && carregar) {
            			_dataProvider.forEach(function(iteRecord) {
            				var dimensao = String(iteRecord['CONTROLE']).split("/");
            				if (record['ABREVIACAO'] == dimensao[0]) {
            					record[dimensao[1]] = iteRecord['QTDNEG'];								
            				}            		
            			});
            		}
            		records.push(record);
            	});
            	
            	return records; 
            }
            
			function atualizaPainelCompraVenda(dataProvider) { 
				
				var data = (angular.isDefined(dataProvider.$) ? JSON.parse(dataProvider.$) : dataProvider);

				self.grdPadraoCompr = data.usaGradePadraoCompra ? "S" : "N";
				self.grdPadraoFchdCompr = data.usaGradeFechadaCompra ? "S" : "N";
				self.grdPadraoVnd = data.usaGradePadraoVenda ? "S" : "N";
				self.grdPadraoFchdVnd = data.usaGradeFechadaVenda ? "S" : "N";

				habilitarBtnConfirmar();
			}

			function habilitarConfGrade(check){
				if(check != null){
					if (check == "grdPadraoCompr" || check == "grdPadraoFchdCompr"){
						if(check == "grdPadraoCompr"){
							self.grdPadraoFchdCompr = "N";
						}else{
							self.grdPadraoCompr = "N";
						}
					}
					
					if (check == "grdPadraoVnd" || check == "grdPadraoFchdVnd"){
						if(check == "grdPadraoVnd"){
							self.grdPadraoFchdVnd = "N";
						}else{
							self.grdPadraoVnd = "N";
						}
					}
				}
				habilitarBtnConfirmar();
			}

			function habilitarBtnConfirmar(){
				if(isGradePadrao()){
					self.disabledConfirmar = !(self.grdPadraoFchdCompr == "S" || self.grdPadraoCompr == "S" || self.grdPadraoFchdVnd == "S" || self.grdPadraoVnd == "S");					
				}
			}
            
            function confirmar() {
            	var dimensoesGradePadrao = [];
            	var itensGrade = [];
            	var fields = self.dsGrade.getFieldsMetadata();
				var dimensoesGradeTabelaPreco = [];
            	
            	self.dsGrade.getRecords().forEach(function(row){
            		var record = self.dsGrade.getRowAsObject(row);
            		for (var field in fields) {        			        			
            			if ("DIMENSAO-ABREVIACAO-TOTAL".indexOf(fields[field].name) < 0) {
            				var isNumber = !(isNaN(record[fields[field].name] || record[fields[field].name] == undefined));
            				var qtdProd = !isNumber ? 0 : record[fields[field].name] 
            				var abreviacaoTipo = record["ABREVIACAO"].substring((record["ABREVIACAO"].indexOf(":")+1), record["ABREVIACAO"].length);
            				var abreviacaoNome = fields[field].name.substring((fields[field].name.indexOf(":")+1), fields[field].name.length);
            				
            				if (qtdProd < 0) {
            					MessageUtils.showError(i18n('Commons.GradeProdutos.titleErrorGrade'), i18n('Commons.GradeProdutos.msgErroGrade'));
            					return;
            					
            				} else if (isGradePadrao()) {
            					var itemDimensaoGradePadrao = {};
            					itemDimensaoGradePadrao.CONTROLE = _usaMascara ? abreviacaoTipo+"/"+abreviacaoNome : record["ABREVIACAO"] +"/"+ fields[field].name;
            					
            					if (isNaN(record[fields[field].name])) {
            						if (record[fields[field].name] === undefined) {
            							itemDimensaoGradePadrao.QTDNEG = null
            						} else {
            							itemDimensaoGradePadrao.QTDNEG = 0.0
            						}
            					} else {
            						itemDimensaoGradePadrao.QTDNEG = record[fields[field].name]
            					}
            					
            					
            					dimensoesGradePadrao.push(itemDimensaoGradePadrao);            					
            				} else if(isTabelaPreco()) {
								if(isNumber && qtdProd > 0) {
									var itemDimensaoGrade = {};
									
									itemDimensaoGrade.CONTROLE = _usaMascara ? abreviacaoTipo+"/"+abreviacaoNome : record["ABREVIACAO"] +"/"+ fields[field].name;
									itemDimensaoGrade.VLRVENDA = isNaN(record[fields[field].name]) ? 0.0 :  record[fields[field].name];
									
									dimensoesGradeTabelaPreco.push(itemDimensaoGrade);
								}
							} else {
            					var item = {};
								var usaMasc = data.grade?.usaMascara?.$;
								item.CONTROLE = (_usaMascara || usaMasc == 'S' ) ? abreviacaoTipo+"/"+abreviacaoNome : record["ABREVIACAO"] +"/"+ fields[field].name;
								item.CODLOCALORIG = self.codLocalOrigem ? self.codLocalOrigem : "";
								item.CODLOCALDEST = self.codLocalDestino ? self.codLocalDestino : "";
								item.DESCRLOCAL = angular.isDefined(self.pesqLocalInput) ? self.pesqLocalInput.getTargetDescriptionFieldName() : null;
								
								if (isContagemEstoque()) {
									item.QTDPROD = isNumber ? qtdProd : undefined;
									
								} else {
									item.QTDPROD = qtdProd ? qtdProd : 0;
								}
								
								if (item.QTDPROD == 0) {
									continue;
								}

								if (isTabelaPreco()){
									item.VLRVENDA =  qtdProd ? qtdProd : 0;
								}
								
								if (_dataset) {
									item.CODPROD = _dataset.getFieldValue("CODPROD");
									item.NUNOTA = _dataset.getFieldValue("NUNOTA");
									item.INCGRADEPROD = true;
								}
								
								itensGrade.push(item);
            				}
            			}
            		}
            	});
				
				if(!isTabelaPreco()) {
					close();
				}

            	if (isGradePadrao()) {
            		var itensGradePadrao = {};
            		
            		itensGradePadrao.grade = dimensoesGradePadrao;
					itensGradePadrao.usaGradePadraoCompra = self.grdPadraoCompr == "S" ? true : false;
					itensGradePadrao.usaGradeFechadaCompra = self.grdPadraoFchdCompr == "S" ? true : false;
					itensGradePadrao.usaGradePadraoVenda = self.grdPadraoVnd == "S" ? true : false;
					itensGradePadrao.usaGradeFechadaVenda = self.grdPadraoFchdVnd == "S" ? true : false;
            		
					if (onFinishGrade != null) {
						onFinishGrade(itensGradePadrao);
					}
            	} else if(isTabelaPreco()) {
					var itensGradeTabelaPreco = {};
					
					itensGradeTabelaPreco.grade = dimensoesGradeTabelaPreco;
					if(self.optionsValue != null){
						itensGradeTabelaPreco.tipo = self.optionsValue;
					}
					itensGradeTabelaPreco.codLocal = self.codLocalOrigem;
					
					if (onFinishGrade != null) {

						if(_dsTabPreco.getFieldValue("CODTAB") == _dsTabPreco.getFieldValue("CODTABORIG") && self.optionsValue != "V"){
							MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.TabelaPreco.tabelaOrginadaSoTemVlrs'));
						} else {
							onFinishGrade(itensGradeTabelaPreco, close);
						}

					}
				} else if (onFinishGrade != null) {
					onFinishGrade(itensGrade);
				}
			}
			
			function close() {
				$popupInstance.success();
			}

			function cancelar (){
				$popupInstance.dismiss();
			}
            
            function desvincular() {
				if (onFinishGrade != null) {
					onFinishGrade({});
				}
			
				close();
			}
			
			function limpar(){
				MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_WARNING, i18n('Commons.GradeProdutos.msgLimparGrade'))
				.then(function() {
					preencherGrade(null);
				});
			}
			
			function preencherGrade(value) {

				self.dsGrade.getRecords().forEach(function(record){
					self.dsGrade.getFieldsMetadata().forEach(function(field){
						if ("DIMENSAO-ABREVIACAO-TOTAL".indexOf(field.name) < 0) {
							record[self.dsGrade.getFieldIndexByName(field.name)] = value;
						}
					});
				});

				self.dsGrade.refreshDataGridCells();
			}

            function isGradePadrao() {
				return _mode == GradeProdutoConstant.GRADE_PADRAO;
			}    
            
            function isCentral() {
				return _mode == GradeProdutoConstant.CENTRAL_NOTAS;
			}
            
			function isCarrinho() {
				return _mode == GradeProdutoConstant.CARRINHO_COMPRAS;
			}
			
			function isContagemEstoque() {
				return _mode == GradeProdutoConstant.CONTAGEM_ESTOQUE;
			}
			
			function isModeloGrade() {
				return _mode == GradeProdutoConstant.MODELO_GRADE;
			}
			
			function isTabelaPreco() {
				return _mode == GradeProdutoConstant.TABELA_PRECO;
			}

			function isTransferencia() {
				if(_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.tipMov){
					return _gradeMetadata.gradePadrao.tipMov == "T";
			   	} else {
					if (angular.isDefined(data.getTipMov)) {
						var tipMov = data.getTipMov();
						return tipMov == "T";
					}
				}
			}
			
			function isVenda() {
				if(_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.tipMov){
					 return "P-V-D".indexOf(_gradeMetadata.gradePadrao.tipMov) > -1;
				}
				return false;
			}
			
			function isCompra() {
				if(_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.tipMov){
					return "C-O-E".indexOf(_gradeMetadata.gradePadrao.tipMov) > -1;
				}
				return false;
			}
			
			function isUsaGradeCompra() {
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradePadraoCompra) {
					return isCompra() && _gradeMetadata.gradePadrao.usaGradePadraoCompra;
				}
				return false;
			}
			
			function isGradeCompraFechada() {
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradePadraoCompra) {
					return isUsaGradeCompra() && _gradeMetadata.gradePadrao.usaGradeFechadaCompra;
				}
				return false;
			}
			
			function isUsaGradeVenda() {
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradePadraoVenda) {
					return isVenda() && _gradeMetadata.gradePadrao.usaGradePadraoVenda;
				}
				return false;
			}
			
			function isGradeVendaFechada() {
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradePadraoVenda) {
					return isUsaGradeVenda() && _gradeMetadata.gradePadrao.usaGradeFechadaVenda;
				}
				return false;
			}

			function isGradePadraoMinimaCompra(){
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradePadraoCompra) {
					return isCompra() && _gradeMetadata.gradePadrao.usaGradePadraoCompra;
				}
				return false;
			}

			function isGradePadraoMinimaVenda(){
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradePadraoVenda) {
					return isVenda() && _gradeMetadata.gradePadrao.usaGradePadraoVenda;
				}
				return false;
			}

			function isGradeFechadaCompra(){
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradeFechadaCompra) {
					return isCompra() && _gradeMetadata.gradePadrao.usaGradeFechadaCompra;
				}
				return false;
			}

			function isGradeFechadaVenda(){
				if (_gradeMetadata && _gradeMetadata.gradePadrao && _gradeMetadata.gradePadrao.usaGradeFechadaVenda) {
					return isVenda() && _gradeMetadata.gradePadrao.usaGradeFechadaVenda;
				}
				return false;
			}

			function isUsaGrade() {
				if (_gradeMetadata && _gradeMetadata.gradePadrao && (_gradeMetadata.gradePadrao.usaGradePadraoVenda 
					|| _gradeMetadata.gradePadrao.usaGradePadraoCompra || _gradeMetadata.gradePadrao.usaGradeFechadaVenda 
					|| _gradeMetadata.gradePadrao.usaGradeFechadaCompra)) {
					return true;
				}
				return false;
			}
			
			function configuraDataGrid() {	
				self.gridEditable = (!isGradeCompraFechada() && !isGradeVendaFechada());
			}

			function replicarValor() {
				preencherGrade(self.vlrVenda);
			}

			function getVlrVendaPrecision() {
				var casasDec = NaN;
				
				if(_dataset.getFieldValue("TIPO") == "V"){
					casasDec = _dataset.getFieldValueAsNumber("Produto_DECVLR");
				}
				
				if(isNaN(casasDec)){
					casasDec = 2;
				}
				
				return casasDec;
			}
	}])
	
/**
 * Created by Gabriel Lima on 27/05/2019.
 */
angular
    .module('snk.commons.grupotop')
    .directive('skGrupoTop',
        function() {
            return {
                restrict: 'E',
                controller: 'grupoTopController',
                templateUrl: 'commons/grupotop/grupotop.tpl.html',
                scope: {
                    valueKeys: '=?skValueKeys',
                    onCreateComplete: '&?skOnCreateComplete'
                }
            }
        })
    .controller('grupoTopController', ['$scope', 'ServiceProxy', 'i18n', 'SkApplicationInstance',
        function($scope, ServiceProxy, i18n, SkApplicationInstance) {

            self = this;
            self.$onInit = $onInit;
            $scope.tooltipBtnMarcar = i18n('Comercial.Gerencia.buttonMarcarTooltip');
            $scope.tolltipBtnDesmar = i18n('Comercial.Gerencia.buttonDesmarcarTooltip');
            $scope.btnMarcar        = i18n('Comercial.Gerencia.buttonMarcar');
            $scope.btnDesmar        = i18n('Comercial.Gerencia.buttonDesmarcar');

            $scope.desmarcar = desmarcar;
            $scope.marcar    = marcar;
            
            var _publicAPI = {};

            _publicAPI.valueKeysChange = function(newvalue) {
                    var keys = [];
                    if(angular.isDefined(newvalue)){
						$scope.valueKeys=newvalue;
						keys = $scope.valueKeys.split(',');
					} else if(angular.isDefined($scope.valueKeys)){
						keys = $scope.valueKeys.split(',');
					}
                    if($scope.grupos){
						desmarcar();
                        for(var y = 0; y < $scope.grupos.length; y++) {
                            for(var x = 0; x < keys.length; x++) {
								if(keys[x] === $scope.grupos[y].nome){
									$scope.grupos[y].ativo = true;
								}
							}
                        }
                    }
                };

            function $onInit() {
				if($scope.onCreateComplete){
					$scope.onCreateComplete({
						$instance: _publicAPI
						});
					}
            }

            var arrayKeyGrupo = [];
            var arrayGrupos = [];
            
             ServiceProxy
	                        .callService('mgecom@GerenciaProdutoSP.getGruposTOPs')
	            			.then(function (result) {
			                if(result.responseBody.grupos.grupo){
			                    var resultGrupos = result.responseBody.grupos.grupo;
			                    for(var x = 0; x < resultGrupos.length; x++){
			                        arrayGrupos.push(criaObj(resultGrupos[x].name.$, resultGrupos[x].value.$));
			                    }
			                    $scope.grupos = arrayGrupos;
	                		}
	            			},true);

            function criaObj(value, key){
                var atv = false;
                var keys=arrayKeyGrupo;
                if(angular.isDefined($scope.valueKeys)){
					keys = $scope.valueKeys.split(',');
				}
                for(var z = 0; z < keys.length; z++) {
                    if(key == keys[z]) {
                        atv = true;
                    }
                }
                var obj = {nome: value, ativo: atv, key: key};
                return obj;
            }

            function marcar() {
                for(var m = 0; m < $scope.grupos.length; m++) {
                    $scope.grupos[m].ativo = true;
                }
            }

            function desmarcar() {
                for(var n = 0; n < $scope.grupos.length; n++) {
                    $scope.grupos[n].ativo = false;
                }
            }

            $(document).ready(function() {
                // Escuta das alterações dos dados dos grupos, compartilhados no escopo. Esse valor será utilizado por quem está injetando o componente
                $scope.$watch('grupos', function(newValue) {
                    var keys = [];
                    if(newValue){
                        for(var y = 0; y < newValue.length; y++) {
                            if(newValue[y].ativo == true) {
                                keys.push(newValue[y].key);
                            }
                        }
                    }
                    $scope.valueKeys = keys.toString();
                },true);
                
                
                
                
               
            });
        }]);
/**
 * Created by Raisa Costa on 10/09/2019
 */
angular.module('snk.commons.lancadorMenu.adicionarLancador')
       .controller('AdicionarLancadorController', ['$scope','$popupInstance','data','$q', 'ArrayUtils','StringUtils','ServiceProxy', '$timeout',
          function ($scope, $popupInstance, data, $q, ArrayUtils, StringUtils, ServiceProxy, $timeout) { 
          var self = this;

          var _branch;
        
          $scope.$success = success;
          
          self.treeSelectedItem = treeSelectedItem;
          self.treeControl = {};
          self.toPosition = data.itemToPosition;
         
            init();
            function init() {
              self.descricao = data.descricao;
              self.arvoreMenuAtual = ArrayUtils.toArray(data.arvoreMenuAtual);
            }
            
            function treeSelectedItem(branch) {
              _branch = branch;
            }

            function success() {
              var source = {
                  item: {
                    nuControlePai: getControlePai(),
                    itemTipo: 'L',
                    descricao: self.descricao,
                    accessManager: 'br.com.sankhya.workflow.utils.ControleAcessoProcesso',
                    params: {
                      tipoLancador: data.tipoLancador,
                      atributo: data.atributo
                    }
                  }
              };
              
              ServiceProxy.callService('ConfiguracaoMenuSP.incluirAlterarItemMenu', source)
				                	.then(function (response) {
                   $popupInstance.success();
            });
          }

      function getControlePai() {
        if (_branch.itemTipo == 'P') {
          return _branch.nuControle;
        }

        var _elemento = undefined;

        for (var i = 0; i < self.arvoreMenuAtual.length; i++) {
          var _ele = self.arvoreMenuAtual[i];
          _elemento = localizaElemento(_ele, _ele);
          if (angular.isDefined(_elemento)) {
            break;
          }
        }

        if (angular.isUndefined(_elemento)) {
          throw Error('Selecione uma pasta');
        }

        return _elemento.nuControle;
          }

      function localizaElemento(ele, elePai) {
        if (_branch.nuControle == ele.nuControle) {
          return elePai;
          }

        var _elemento = undefined;
        var _item = ArrayUtils.toArray(ele.item);
        for (var i = 0; i < _item.length; i++) {
          
          _elemento = localizaElemento(_item[i], ele);
          if (angular.isDefined(_elemento)) {
            break;
          }
        }

        return _elemento
      }

}]);

/**
 * Created by Raisa Costa on 10/09/2019
 */
angular.module('snk.commons.lancadorMenu.adicionarLancador')
    .service('AdicionarLancador', ['SanPopup', 'ServiceProxy', 'i18n', 'ArrayUtils', 'ObjectUtils',
        function (SanPopup, ServiceProxy, i18n, ArrayUtils, ObjectUtils) {

            var adiconarLancador = {
                adicionarLancador: adicionarLancador
            };

            function adicionarLancador(menuName, tipoLancador, codPrn, itemToPosition) {
                ServiceProxy.callService('ConfiguracaoMenuSP.montarMenu', {}).then(function (result) {
                    var _menuAtivo = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.menus.menuAtivo.item'));

                    SanPopup.open({
                        title: i18n('Commons.LancadorMenu.adicionarLancador'),
                        templateUrl: 'commons/lancadorMenu/adicionarLancador/adicionarLancador.tpl.html',
                        controller: 'AdicionarLancadorController',
                        controllerAs: 'ctrl',
                        size: 'lg',
                        okBtnLabel: 'Criar Lançador',
                        resolve: {
                            data: {
                                descricao: menuName,
                                arvoreMenuAtual: _menuAtivo,
                                tipoLancador: tipoLancador,
                                atributo: codPrn,
                                itemToPosition: itemToPosition
                            }
                        }
                    });

                });
            }

            return adiconarLancador;
        }]);

angular.module('snk.commons.lancadorMenu.localizarLancador')
    .controller('LocalizarLancadorController', ['i18n', 'data', 'ServiceProxy', 'ObjectUtils', '$scope', '$popupInstance', 'MessageUtils', 'SkApplicationInstance', 'ArrayUtils', 'StringUtils',
        function (i18n, data, ServiceProxy, ObjectUtils, $scope, $popupInstance, MessageUtils, SkApplicationInstance, ArrayUtils, StringUtils) {

            var self = this;

            //Variaveis disponiveis no controller
            self.lancador = [];

            //função disponiveis no controller
            self.save = save;
            self.remove = remove;
            self.onDatasetCreated = onDatasetCreated;
            self.refreshHandler = refreshHandler;

            function onDatasetCreated(dataset) {
                self.dsRelations = dataset;

                self.dsRelations.init().then(function () {

                    _endidades = [];

                    data.lancador.forEach(function (entity) {
                        _endidades.push({
                            CAMINHO: entity['path'],
                            NOME: entity['descricao'],
                            NUCONTROLE: entity['nuControle'],
                            RESOURCEID: entity['resourceID']
                        });
                    });

                    self.dsRelations.refresh();
                });
            }
            function refreshHandler(request) {
                return _endidades;
            }

            function save(request) {
                var _descricao = self.dsRelations.getFieldValueAsString('NOME');
                var _nuControle = self.dsRelations.getFieldValueAsNumber('NUCONTROLE');

                if (StringUtils.emptyAsUndefined(_descricao) != undefined) {
                    var source = {
                        item: {
                            nuControle: _nuControle,
                            descricao: _descricao
                        }
                    };

                    ServiceProxy.callService('ConfiguracaoMenuSP.alterarDescricaoMenu', source)
                        .then(function (response) {
                            self.dsRelations.setFieldValueAsString('CAMINHO', ObjectUtils.getProperty(response, 'responseBody.controle.path'));
                            self.dsRelations.save();
                        });
                } else if (StringUtils.emptyAsUndefined(self.descricao) == undefined) {
                    MessageUtils.showError(i18n('Commons.LancadorMenu.erroInformeDescParaoItem'));
                }
            }

            function remove(request) {
                ServiceProxy.callService('ConfiguracaoMenuSP.removerItem', {
                    item: {
                        nuControle: self.dsRelations.getFieldValueAsNumber('NUCONTROLE')
                    }
                });
            }
        }]);
angular.module('snk.commons.lancadorMenu.localizarLancador')
       .service('LocalizarLancador', ['SanPopup', 'i18n', 'ServiceProxy','ArrayUtils','ObjectUtils',
        function (SanPopup, i18n, ServiceProxy, ArrayUtils, ObjectUtils) {
                     
            var localizarLancador = {
                localizarLancador: localizarLancador
            };

            function localizarLancador(menuName, tipoLancador, atributo) {
                ServiceProxy.callService('ConfiguracaoMenuSP.getLocalizacaoLancador', {
                    params: {
                        atributo: atributo,
                        tipoLancador: tipoLancador
                    }
                }).then(function (response) {
                    var _result = ArrayUtils.toArray(ObjectUtils.getProperty(response, 'responseBody.controle'));
                           
                    SanPopup.open({
                        title: i18n('Commons.LancadorMenu.localizarLancador'),
                        templateUrl: 'commons/lancadorMenu/localizarLancador/localizarLancador.tpl.html',
                        controller: 'LocalizarLancadorController',
                        controllerAs: 'ctrl',
                        size: 'lg',
                        showBtnCancel:"false",
                        resolve: {
                            data: {
                                descricao: menuName,
                                tipoLancador: tipoLancador,
                                atributo: atributo,
                                lancador:_result
                            }
                        }
                    })
                });
            }
            return localizarLancador;
        }]);
angular.module('snk.commons.lancamentoOrdemProducao')
    .component('skLancamentoOp', {
        templateUrl: 'commons/lancamentoOrdemProducao/lancamentoOrdemProducao.tpl.html',
        controller: 'LancamentoOrdemProducaoController',
        controllerAs: 'ctrl',
        bindings: {
            resourceId: '=?skResourceId',
            onFinished: '&?onFinished',
            onCanceled: '&?onCanceled',
            onViewLancamentoCreated: '&?onViewLancamentoCreated',
            nulop: '=nuLop',
            exibePopupInserir: '=?skExibePopupInserir',
            insertionMode: '=?skInsertionmode'
        }
    })
    .controller('LancamentoOrdemProducaoController', ['NumberUtils', 'CrudUtils', '$scope', 'MGEParameters', 'Criteria', 'SkApplicationInstance', 'i18n', 'ObjectUtils', 'AngularUtil', 'StringUtils', 'ServiceProxy', 'MessageUtils', 'SanPopup', '$q', 'GridConfig', 'DateUtils', 'MGEAuthorizationConstants',
        function (NumberUtils, CrudUtils, $scope, MGEParameters, Criteria, SkApplicationInstance, i18n, ObjectUtils, AngularUtil, StringUtils, ServiceProxy, MessageUtils, SanPopup, $q, GridConfig, DateUtils, MGEAuthorizationConstants) {
            var self = this;
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);
            self.resourceID = SkApplicationInstance.getResourceID();

            self.isJivaProducao = SkApplicationInstance.temOpcional("20448") || SkApplicationInstance.getAttributeFromHTMLWrapper("producaoFit");

            //CONST
            const SIM = "S";
            const NAO = "N";
            const MANUAL = "MN";
            const OP_PRODUCAO = "P";
            const OP_DESMONTE = "D";
            const OP_REPARO = "R";
            const COL_DECQTD_READONLY = ["TAMLOTE", "ProdutoLancamentoDeOP.CALCTAMLOTE", "TAMLOTEPAD", "NECESSIDADE", "QTDSUBS", "TAMLOTE", "CALCTAMLOTE", "ESTOQUE", "MINLOTE", "QTDPI", "QTDNECESSARIO", "QTDESTOQUE", "NECESSIDADETOTAL", "QTDUSAR"];
            const ESPECIFICO = "E";
            const OPCIONAL = "O";
            const ORDEM_CAMPOS_ITEM_LANCAMENTO = [
                "NULOP", "SEQOP", "CODPLP", "PlantaManufatura.NOME", "TIPOOP", "ProcessoProdutivo.CODPRC", "ProcessoProdutivo.DESCRABREV",
                "CODPROD", "DESCRPROD", "REFERENCIA", "TAMLOTE", "NUNOTA", "SEQNOTA", "ProcessoProdutivo.VERSAO",
                "DTPREVENT", "DECQTD"
            ];

            const ORDEM_CAMPOS_PRODUTO_LANCAMENTO = [
                "CODPRODPA", "Produto.DESCRPROD", "Produto.REFERENCIA", "CONTROLEPA", "Produto.COMPLDESC", "ESTOQUE", "NROLOTE", "TAMLOTE",
                "Produto_CODVOL", "MULTLOTE", "MINLOTE"
            ];

            const ORDEM_CAMPOS_DEPENDENCIA_LANCAMENTO = [
                "SEQOPPI", "CODPRODPI", "CONTROLEPI", "Produto_DESCRPROD", "NECESSIDADETOTAL", "QTDNECESSARIO", "QTDESTOQUE",
                "QTDPI", "CONSIDERAESTOQUE", "TIPOSUBOP", "Produto.REFERENCIA", "Produto.COMPLDESC", "Produto.CODVOL"
            ];

            const ORDEM_CAMPOS_SUB_PRODUTO_LANCAMENTO = [
                "IDEFX", "SEQLSP", "CODPRODSP", "Produto.DESCRPROD", "Produto.REFERENCIA", "CONTROLESP", "Produto.COMPLDESC", "NROLOTE",
                "Produto.CODVOL"
            ];

            //DATAGRID-CONFIG
            self.gridProcessosConfig = self.resourceID + '.GridProcessos';
            self.gridWCProcessosConfig = self.resourceID + '.WCProcessosConfig';
            self.gridWC = self.resourceID + '.WCConfig';
            self.gridMPAlternativaConfig = self.resourceID + '.MPAlternativaConfig';
            self.gridListaMPsConfig = self.resourceID + '.ListaMPsConfig';
            self.gridItemLancamentoConfig = self.resourceID + '.ItemLancamentoOP';
            self.gridParcProcessosConfig = self.resourceID + '.ParcProcessos';
            self.gridParc = self.resourceID + '.GridParc';
            self.gridInfoLoteConfig = self.resourceID + '.GridInfo';
            self.gridSerieProcessosConfig = self.resourceID + '.GridSerieConfig';
            self.gridSubProdutoProcessosConfig = self.resourceID + '.SubProdutoProcessos';
            self.gridSubProduto = self.resourceID + '.GridSubProduto';
            self.qtdNotasConfirmadas = MGEParameters.asInteger("mgeprod.dias.consulta.qdoitens.notas.confirmadas");

            //FUNCTION
            self.btnDependenciasEnabled = btnDependenciasEnabled;
            self.cancelEditionMpAlternativa = cancelEditionMpAlternativa;
            self.cellFormatterNroLote = cellFormatterNroLote;
            self.cellFormatterTamLote = cellFormatterTamLote;
            self.cellFormatterTamLoteProduto = cellFormatterTamLoteProduto;
            self.cellFormatterTamLoteAlternativo = cellFormatterTamLoteAlternativo;
            self.cellFormatterTamLoteAjustada = cellFormatterTamLoteAjustada;
            self.cellFormatterTamLoteAjustadaOP = cellFormatterTamLoteAjustadaOP;
            self.cellFormatterTamLoteWorkCenter = cellFormatterTamLoteWorkCenter;
            self.changeApresentarPIs = changeApresentarPIs;
            self.changeMPAPosition = changeMPAPosition;
            self.changeRecordPosition = changeRecordPosition;
            self.changeSeqEnabled = changeSeqEnabled;
            self.changeSeqMpaEnabled = changeSeqMpaEnabled;
            self.clickDependencia = clickDependencia;
            self.clickInfoLote = clickInfoLote;
            self.defaultEmptySaveHandler = defaultEmptySaveHandler;
            self.getCellColors = getCellColors;
            self.getPrecision = getPrecision;
            self.interceptCellRenderer = interceptCellRenderer;
            self.interceptColumnMetadata = interceptColumnMetadata;
            self.interceptItemEditor = interceptItemEditor;
            self.onCancel = onCancel;
            self.onCreateWizard = onCreateWizard;
            self.onCustomDatasetCreated = onCustomDatasetCreated;
            self.onDatagridLoaded = onDatagridLoaded;
            self.onDatasetCreated = onDatasetCreated;
            self.onExtratoDatasetCreated = onExtratoDatasetCreated;
            self.onFinish = onFinish;
            self.onStepChange = onStepChange;
            self.removerProcessosSelecionados = removerProcessosSelecionados;
            self.saveMpAlternativa = saveMpAlternativa;
            self.onPedidoChange = onPedidoChange;
            self.canFinalize = canFinalize;
            self.clicklSelectAll = clicklSelectAll;
            self.openInsertOP = openInsertOP;
            self.abrirConfiguracoesEstoque = abrirConfiguracoesEstoque;
            self.insersaoAutomatica = insersaoAutomatica;
            self.configSerie = configSerie;
            self.gerarSerie = gerarSerie;
            self.incluiSerie = incluiSerie;
            self.removeSerie = removeSerie;
            self.removeSeries = removeSeries;
            self.removeControle = removeControle;
            self.openEditarControle = openEditarControle;
            self.editQtdCoProducao = editQtdCoProducao;
            self.carregarPlanejamento = carregarPlanejamento;
            self.carregarLancamento = carregarLancamento;
            self.carregarLancamentoPedidoVenda = carregarLancamentoPedidoVenda;
            self.openGridConfig = openGridConfig;
            self.openGridConfigExtratoMPs = openGridConfigExtratoMPs;
            self.cellFormatterNroLoteSubProduto = cellFormatterNroLoteSubProduto;
            self.abrirPopUpDetalhamentoEntregasMP = abrirPopUpDetalhamentoEntregasMP;
            self.changeReutilizarLancamento = changeReutilizarLancamento;
            self.salvaLancamento = salvaLancamento;
            self.descartarLancamentoSalvo = descartarLancamentoSalvo;
            self.disableRemoveButton = disableRemoveButton;

            //CRITERIA
            self.criteriaProcesso = criteriaProcesso;
            self.criteriaPedido = criteriaPedido;
            self.criteriaProcessosWC = criteriaProcessosWC;
            self.criteriaSeq = criteriaSeq;
            self.criteriaProduto = criteriaProduto;
            self.criteriaSerie = criteriaSerie;

            //SCOPE-VARIABLE
            self.fieldNroLoteEnabled;
            self.showStepParceiro;
            self.showWC;
            self.selecionaMps = NAO;
            self.apresentarPis = NAO;
            self.btnSaveMpEnabled = false;
            self.wizard;
            self.erroTamLote;
            self.currentProcess;
            self.currentWorkCenter;
            self.showSequencia;
            self.seqPa;
            self.showDgProcessos;
            self.showStepNroSerie;
            self.showGerManual = true;
            self.showGerAuto = true;
            self.showGerSerie;
            self.showInclSerie;
            self.txtRodape;
            self.seqControleSerie = [];
            self.btAddSeqDisabled = false;
            showBtnEditCoProd = false;
            self.btnInsertEnabled = true;
            self.isEditableDataGrids = true;
            self.showStepSubproduto = false;
			self.codProdMPCompartilhada = [];
            self.serieInicial;
            self.nroSerie;
            self.enabledButtonDetalhamentoEntregas = false;
            self.disableRemove = false;

            //PRIVATE-VAR
            var _lancarOpVersaoAnterior = false;
            var _responsePopupInclusao;            
            var _isCallByMPS;
            var _isPrevisaoEntrega = false;
            var _isItensPorPedido = false;
            var _isPlanejamentProducao = false;
            var _listaMPAlternativa = [];
            var _decimaisProdutos = [];
            const _codprodSeries = [];

            //INPUTED DATA
            self.nulop;
            self.valueTipOP;
            self.codPlanta = 0;
            self.codProd;
            self.producaoParaTerc = NAO;
            self.usaTerc = NAO;
            self.codParc;
            self.nroPedido;
            self.codProcesso;
            self.idProcesso;
            self.tamLote;
            self.nroLote;
            self.oldTamLote;
            self.versaoProcesso;
            self.controlePA;
            self.multIdeal;

            //DATASET
            self.dsProcessos;
            self.dsLancamentos;
            self.dsProduto;
            self.dsWorkCenter;
            self.dsDependencias;
            self.dsTerceiros;
            self.dsListaMPs;
            self.dsListaMPAlternativa;
            self.dsItemLancamento;
            self.dsWcProcessos;
            self.dsTercProcessos;
            self.dsNumeroSerie;
            self.dsSerieProcessos;
			self.dsSubProduto;
            self.dsSubProdutoProcessos;

            //DATAGRID
            self.dgMPAlternativa;

            self.reutilizarLancamento = false;
            self.reutilizar = "N";
            self.descrLancamento = "";

            self.optionsTipOP = [{
                data: OP_PRODUCAO,
                value: i18n('Commons.LancamentoOrdem.labelTipoOrdemProducao')
            }, {
                data: OP_DESMONTE,
                value: i18n('Commons.LancamentoOrdem.labelTipoOrdemDesmonte')
            }, {
                data: OP_REPARO,
                value: i18n('Commons.LancamentoOrdem.labelTipoReparo')
            }]

            self.optionsNao = [{
                data: '',
                value: i18n('Commons.LancamentoOrdem.labelTodos')
            }, {
                data: SIM,
                value: i18n('Commons.LancamentoOrdem.opcSim')
            }, {
                data: NAO,
                value: i18n('Commons.LancamentoOrdem.opcNao')
            }];

            init();
            function init() {
                GridConfig.registerGridConfig(self.gridProcessosConfig, self.gridProcessosConfig, undefined, true);
                GridConfig.registerGridConfig(self.gridListaMPsConfig, self.gridListaMPsConfig, undefined, true);

                self.insertionMode = angular.isDefined(self.insertionMode)? self.insertionMode : 'manual';

                if(angular.isUndefined(self.exibePopupInserir) || self.exibePopupInserir) {
                    openInsertOP();
                } else {
                    if(self.insertionMode == 'auto') {
                        self.btnInsertEnabled = false;
                    }
                }

                self.showStepParceiro = false;
                self.erroTamLote = false;
                carregaConfiguracoes();
                if(angular.isDefined(self.onViewLancamentoCreated)){
                    self.onViewLancamentoCreated({viewLancamento: self})
                }
            }

            function onCreateWizard(wizard) {
                self.wizard = wizard;
            }

            function onFinish() {
                validaTamLote(self.dsProcessos, self.dgProcessos, validaLancamento, true);
                self.dsProcessos.save();
            }

            function onStepChange() {
                if (angular.isDefined(self.dsListaMPs)) {
                    self.dsListaMPs.unselectAll();
                }
                var stepNumber = self.wizard.currentStepNumber();
                if (stepNumber === 2 || stepNumber === 3) {
                    self.dsProcessos.save();
                    updateContent();
                }
            }

            function onCancel() {
                if (StringUtils.isEmpty(self.nulop)) {
                    self.onCanceled()();
                } else {
                    if(self.insertionMode == 'auto' || 'N' == self.reutilizar) {
                        deletarLancamento(self.nulop).finally(function () {
                            resetComponent();
                        });
                    } else {
                        resetComponent();
                    }
                }
            }
            
            function resetComponent() {
                self.nulop = undefined;
                self.showDg
                clearDatasets();
    
                restoreLayout();
                if (angular.isDefined(self.onCanceled)) {
                    self.onCanceled()();
                } else {
                    SkApplicationInstance.reloadApp(self.resourceID);
                }
            }

            function canFinalize() {
                if (angular.isDefined(self.dsProcessos)) {
                    return self.dsProcessos.getRecords().length > 0;
                } else {
                    return false;
                }
            }

            //DATASET-INITIALIZING
            function onDatasetCreated(dataset) {
                if (dataset.getEntityName() === "ItemDeLancamentoDeOP") {
                    self.dsProcessos = dataset;

                    self.dsProcessos.addRefreshedListener(function () {
                        var processoUsaTerc = self.dsProcessos.getRecordsAsObjects().filter(parc => parc["ProcessoProdutivo.USATERCEIRO"] === SIM || parc["ProcessoProdutivo.USATERCEIRO"] === OPCIONAL);
                        self.showStepParceiro = angular.isDefined(processoUsaTerc) && processoUsaTerc.length > 0;
                        self.showWC = false;
                        verificaUsaCentroTrabalho(self.dsProcessos.getRecordsAsObjects(),0);

                        if (angular.isDefined(_responsePopupInclusao) && _responsePopupInclusao.controleSerie) {
                            var maxSeq = 0;

                            self.dsProcessos.getRecordsAsObjects().forEach(record => {
                                if (record.SEQOP > maxSeq) {
                                    maxSeq = record.SEQOP;
                                }
                            });

                            if (self.seqControleSerie.indexOf(maxSeq) === -1 && maxSeq != 0) {
                                self.seqControleSerie.push(maxSeq);
                                _responsePopupInclusao = undefined;
                            }
                        }

                        if (self.dsProcessos.size() > 0) {
                            if (angular.isDefined(_responsePopupInclusao) && _responsePopupInclusao.codProdMPCompartilhada) {
                                var lastItem = self.dsProcessos.getRecordsAsObjects()[self.dsProcessos.size() - 1];
                                if (angular.isDefined(lastItem.SEQCOP)) {
                                    var existeSeqcop = self.codProdMPCompartilhada.findIndex(function (mp) { return mp.seqcop === lastItem.SEQCOP});
                                    if (existeSeqcop == -1) {
                                        self.codProdMPCompartilhada.push({seqcop: lastItem.SEQCOP, codProdMP: parseInt(_responsePopupInclusao.codProdMPCompartilhada)});
                                    }
                                }
                            }
                        }
                        
                        montaListaExtratoMateriais();
                        self.dsProcessos.getRecordsAsObjects().forEach(function (record) {
                            if(record) {
                                exibeStepNroSerie(null, record.CODPROD, record.IDPROC, true);
                            }
                        });
                    });

                    self.dsProcessos.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.ItemDeLancamentoDeOPHTML5CrudListener");

                    self.dsProcessos.addLineChangeListener(function (index) {
                        if (index != -1) {
                            self.currentProcess = self.dsProcessos.getCurrentRowAsObject();
                            self.showBtnEditCoProd = _isPlanejamentProducao ? false : (angular.isDefined(self.dsProcessos.getFieldValue("SEQCOP")) && self.dsProcessos.getFieldValue("SEQCOP")!="");
                            var usaConfiguracaoNroLoteSubProduto = "S" === self.dsProcessos.getFieldValueAsString("ProcessoProdutivo.USACONFNROLOTESP");
                            self.showStepSubproduto = usaConfiguracaoNroLoteSubProduto;
                        }
                    })

                    self.dsProcessos.setOrderByExpression("SEQOP ASC");

                    dataset.init().finally(function() {
                        if (angular.isUndefined(self.exibePopupInserir) || self.exibePopupInserir) {
                            openInsertOP();
                        }
                    });
                } else if (dataset.getEntityName() === "LancamentoDeOP") {
                    self.dsLancamentos = dataset;
                    self.dsLancamentos.addCriteriaProvider(criteriaLancamentos);
                    self.dsLancamentos.addRefreshedListener(() => {
                        self.reutilizar = self.dsLancamentos.getFieldValueAsString("REUTILIZAR");
                        if('S' == self.reutilizar) {
                            self.descrLancamento = self.dsLancamentos.getFieldValueAsString("DESCRICAO");
                        }
                    });
                    dataset.initAndRefresh();
                } else if (dataset.getEntityName() === "ProdutoLancamentoDeOP") {
                    self.dsProdutos = dataset;
                    self.dsProdutos.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.ProdutoLancamentoDeOPCrudListener");

                    self.dsProdutos.addRefreshedListener(function () {
                        if (self.dsProdutos.getRecords().length > 1) {
                            document.getElementById('dgProcessos').style.height = "calc(100vh - 460px)";
                            self.showDgProcessos = true;
                        } else {
                            document.getElementById('dgProcessos').style.height = "calc(100vh - 207px)";
                            self.showDgProcessos = false;
                        }
                    });

                    self.dsProdutos.init();
                } else if (dataset.getEntityName() === "DependenciaLancamentoOP") {
                    self.dsDependencias = dataset;
                    self.dsDependencias.addCriteriaProvider(criteriaDependenciaLancamentoOP);
                    self.dsDependencias.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.DependenciaLancamentoOPCrudListener");
                    self.dsDependencias.init();
                } else if (dataset.getEntityName() === "AlocacaoDeWorkCenterLctoOP") {
                    self.dsWorkCenter = dataset;
                    self.dsWorkCenter.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.AlocacaoDeWorkCenterLctoOPCrudListener");

                    self.dsWorkCenter.addLineChangeListener(function (index) {
                        if (index != -1) {
                            self.currentWorkCenter = self.dsWorkCenter.getCurrentRowAsObject();
                        }
                    });

                    self.dsWorkCenter.init();
                } else if (dataset.getEntityName() === "TerceiroLancamentoDeOP") {
                    self.dsTerceiros = dataset;
                    self.dsTerceiros.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.TerceiroLancamentoDeOPCrudListener");
                    self.dsTerceiros.init();
                } else if (dataset.getEntityName() === "SerieLancamentoOP") {
                    self.dsNumeroSerie = dataset;
                    self.dsNumeroSerie.addCriteriaProvider(criteriaSerie);
                    self.dsNumeroSerie.addRefreshedListener(function () {
                        atualizaQuantidades();
                    });
                    self.dsNumeroSerie.init();
                } else if (dataset.getEntityName() === "SubProdutoLancamentoOP") {
                    self.dsSubProduto = dataset;
                    self.dsSubProduto.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.SubProdutoLancamentoOPCrudListener");
                    self.dsSubProduto.init();
                }
            }

            function onExtratoDatasetCreated(dsName, dataset) {
                self[dsName] = dataset;
                if (dsName === 'dsListaMPs') {
                    self.dsListaMPs.addLineChangeListener(function (index) {
                        if (index != -1) {
                            self.dsItemLancamento.clearDataSet();
                            getItemsLancamento();
                        }
                    })
                    self.dsListaMPs.init();
                } else if (dsName === 'dsListaMPAlternativa') {
                    self.dsListaMPAlternativa.addDataModifiedListener(function (field) {
                        if (field === "CHK_SELECTION") {
                            var data = self.dsListaMPAlternativa.getCurrentRowAsObject();
                            var rowIndex = self.dsListaMPAlternativa.getRecordsAsObjects().findIndex(item => item.CODPRODMPALT === data.CODPRODMPALT);
                            handleCheck(data, rowIndex, field);
                        }
                    });

                    self.dsListaMPAlternativa.addLineChangeListener(function (index) {
                        if (index != -1) {
                            self.currentMpAlt = self.dsListaMPAlternativa.getCurrentRowAsObject();
                        }
                    });

                    self.dsListaMPAlternativa.init();
                } else if (dsName === 'dsItemLancamento') {
                    self.dsItemLancamento.init();
                    self.dsItemLancamento.addLineChangeListener(function (index) {
                        if (index != -1) {
                            self.dsListaMPAlternativa.clearDataSet();
                            getListaMaterialAlternativo();
                        }
                    })
                }
            }
            
            function exibeStepNroSerie(tipoGeraSerie, codProd, IdProc, ignoreBtAddSeqDisabled = false){
				if (!angular.isDefined(tipoGeraSerie)){
					CrudUtils.find("ProdutoAcabado", "TIPOGERASERIE", {
                                    CODPRODPA: codProd,
                                    IDPROC: IdProc
                                }, true).then(function (result) {
                                    
                                    if(!ignoreBtAddSeqDisabled) {
                                        self.btAddSeqDisabled = "L" != result?.TIPOGERASERIE;
                                    } else if("L" == result?.TIPOGERASERIE) {
                                        self.showStepNroSerie = true;
                                        _codprodSeries.push(codProd);
                                    }

									if (!self.btnInsertEnabled){
										self.showStepNroSerie = self.showStepNroSerie ? self.showStepNroSerie : "L" == result?.TIPOGERASERIE;
									}
                                })
				} else {
					self.btAddSeqDisabled = tipoGeraSerie!="L";
					if (!self.btnInsertEnabled){
						self.showStepNroSerie = self.showStepNroSerie ? self.showStepNroSerie : tipoGeraSerie=="L";
					}
				}
			}

            function onCustomDatasetCreated(dsName, dataset, criteria) {
                self[dsName] = dataset;
                dataset.addCriteriaProvider(criteria);
                dataset.setCrudListener("br.com.sankhya.mgeprod.crudlisteners.ItemDeLancamentoDeOPHTML5CrudListener");

                if (dsName === 'dsSerieProcessos') {                    
                    dataset.addLineChangeListener(function (index) {
                        if (index != -1) {
                            if (self.dsSerieProcessos.getRecords().length) {
                                CrudUtils.find("ProdutoAcabado", "TIPOGERASERIE", {
                                    CODPRODPA: self.dsSerieProcessos.getFieldValueAsNumberOrZero("CODPROD"),
                                    IDPROC: self.dsSerieProcessos.getFieldValueAsNumberOrZero("IDPROC")
                                }, true).then(function (result) {
                                    exibeStepNroSerie(result.TIPOGERASERIE, self.dsSerieProcessos.getFieldValueAsNumberOrZero("CODPROD"), self.dsSerieProcessos.getFieldValueAsNumberOrZero("IDPROC"));
                                })
                            }

                        }
                    })
                }

                if(!self.btnInsertEnabled) {
                    dataset.initAndRefresh();
                    return;
                }
                
                dataset.init();
            }

            function onDatagridLoaded(gridName, datagrid) {
                self[gridName] = datagrid;
                if (gridName === "dgProcessos") {
                    document.getElementById('dgProcessos').style.height = "calc(100vh - 207px)";
                    var dgProcessosApi = self.dgProcessos.getGridApi();
                    getGridAsyncListners(dgProcessosApi).set("cellClicked", [function (event) {
                        handleClickDsProcesso(event.colDef, event.data);
                    }]);

                    getGridAsyncListners(dgProcessosApi).set("cellEditingStopped", [function (event) {
                        handleProcessoEditionStoped(event.colDef, event.data);
                    }]);

                } else if (gridName === "dgMPAlternativa") {
                    var gridMpAltApi = self.dgMPAlternativa.getGridApi();
                    var colChk = self.dgMPAlternativa.getColumnDefs().find(col => col.skName === "CHK_SELECTION");

                    colChk.width = 20;
                    //colChk.resizable = false;
                    colChk.suppressMovable = true;
                    colChk.suppressMenu = true;
                    colChk.lockPosition = true
                    var columnDefs = self.dgMPAlternativa.getColumnDefs();

                    columnDefs[columnDefs.findIndex(col => col.skName === "CHK_SELECTION")] = colChk;

                    //columnDefs.forEach(item => item.sortable = false);

                    gridMpAltApi.setColumnDefs(columnDefs);

                    getGridAsyncListners(gridMpAltApi).set("cellEditingStopped", [function (event) {
                        handleEditionStopedMPAlt(event.colDef, event.data);
                    }]);
                } else if (gridName === "dgProdutos") {
                    var dgProdutosApi = self.dgProdutos.getGridApi();

                    getGridAsyncListners(dgProdutosApi).set("cellEditingStopped", [function (event) {
                        handleProdutoEditionStoped(event.colDef, event.data);
                    }]);

                } else if (gridName === "dgSubProduto") {
                    var dgSubProdutoApi = self.dgSubProduto.getGridApi();

                    getGridAsyncListners(dgSubProdutoApi).set("cellEditingStopped", [function (event) {
                        handleSubProdutoEditionStoped(event.colDef, event.data);
                    }]);

                } else if (gridName === "dgWorkCenter") {
                    var dgWorkCenterApi = self.dgWorkCenter.getGridApi();

                    getGridAsyncListners(dgWorkCenterApi).set("cellClicked", [function (event) {
                        handleClickDsWorkCenter(event.colDef, event.data);
                    }]);

                }
            }

            function handleCheck(data, rowIndex, field) {
                self.btnSaveMpEnabled = true;

                if (field === "CHK_SELECTION") {
                    var auxRecords = self.dsListaMPAlternativa.getRecords().slice();

                    if (data.CHK_SELECTION === "S") {
                        var conjunto = data.CONJUNTO;

                        if (angular.isDefined(conjunto) && conjunto != "") {

                            auxRecords.forEach(record => {
                                if (record[self.dsListaMPAlternativa.getFieldIndexByName("CONJUNTO")] === conjunto) {
                                    var qtdUsarIndex = self.dsListaMPAlternativa.getFieldIndexByName("QTDUSAR");

                                    if (record[qtdUsarIndex] === 0) {
                                        record[qtdUsarIndex] = record[self.dsListaMPAlternativa.getFieldIndexByName("NECESSIDADE")];
                                    }
                                    if (record[self.dsListaMPAlternativa.getFieldIndexByName("CODPRODMPALT")] != data.CODPRODMPALT) {
                                        record[self.dsListaMPAlternativa.getFieldIndexByName("CHK_SELECTION")] = "S";
                                    }
                                } else {
                                    record[self.dsListaMPAlternativa.getFieldIndexByName("CHK_SELECTION")] = "N";
                                }
                            });

                            self.dsListaMPAlternativa.clearDataSet();
                            self.dsListaMPAlternativa.addRecords(auxRecords);
                            self.dsListaMPAlternativa.save();

                            if (!self.dsListaMPAlternativa.getRecordsAsObjects().find(item => item.CHK_SELECTION === "N")) {
                                self.selecionaMps = SIM;
                            }
                        } else {
                            self.dsListaMPAlternativa.gotoRow(rowIndex).finally(
                                function () {
                                    if (self.dsListaMPAlternativa.getCurrentRowAsObject().QTDUSAR === 0) {
                                        self.dsListaMPAlternativa.setFieldValue("QTDUSAR", self.dsListaMPAlternativa.getCurrentRowAsObject().NECESSIDADE);
                                        self.dsListaMPAlternativa.setFieldValue("EDITADO", "S");
                                    }
                                    //self.dsListaMPAlternativa.setFieldValue("CHK_SELECTION", "S");

                                    self.dsListaMPAlternativa.save();

                                    if (!self.dsListaMPAlternativa.getRecordsAsObjects().find(item => item.CHK_SELECTION === "N")) {
                                        self.selecionaMps = SIM;
                                    }
                                }
                            );
                        }
                    } else {
                        var conjunto = data.CONJUNTO;
                        if (angular.isDefined(conjunto) && conjunto != "") {
                            var conjuntoIndex = self.dsListaMPAlternativa.getFieldIndexByName("CONJUNTO");

                            for (var i = 0; i < auxRecords.length; i++) {
                                if (auxRecords[i][conjuntoIndex] === conjunto) {
                                    if (auxRecords[i][self.dsListaMPAlternativa.getFieldIndexByName("CODPRODMPALT")] != data.CODPRODMPALT) {
                                        auxRecords[i][self.dsListaMPAlternativa.getFieldIndexByName("CHK_SELECTION")] = "N";
                                    }
                                }
                            }
                            self.dsListaMPAlternativa.clearDataSet();
                            self.dsListaMPAlternativa.addRecords(auxRecords);
                            self.dsListaMPAlternativa.save();

                        } else {
                            self.dsListaMPAlternativa.gotoRow(rowIndex).finally(
                                function () {
                                    // self.dsListaMPAlternativa.setFieldValue("CHK_SELECTION", "N");

                                    self.dsListaMPAlternativa.save();

                                }
                            );
                        }
                        self.selecionaMps = NAO;
                    }
                }
            }

            function handleProdutoEditionStoped(colDef, data) {
                var fieldName = colDef.skName;

                var processo = self.dsProcessos.getCurrentRowAsObject();

                var isEditMode = self.dsProdutos.isEditMode();
                if (fieldName === "TAMLOTE") {
                    if (isEditMode) {
                        self.dsProdutos.save(false, function () {
                            validaTamLote(self.dsProdutos, self.dgProdutos)
                        });
                    } else {
                        validaTamLote(self.dsProdutos, self.dgProdutos)
                        self.dsProdutos.save();
                    }
                } else if (fieldName === "NROLOTE") {
                    if (isEditMode) {
                        //var produto = self.dsProdutos.getCurrentRowAsObject();
                        self.dsProdutos.save(false, function () {
                            alterarAtributoProduto(processo.NULOP, processo.SEQOP, data.CODPRODPA, data.CONTROLEPA, "NUMLOTE", data.NROLOTE);
                        });
                    } else {
                        alterarAtributoProduto(processo.NULOP, processo.SEQOP, data.CODPRODPA, data.CONTROLEPA, "NUMLOTE", data.NROLOTE);
                        self.dsProdutos.save();
                    }
                }
            }

            function handleSubProdutoEditionStoped(colDef, data) {
                var fieldName = colDef.skName;

                var processo = self.dsProcessos.getCurrentRowAsObject();

                var isEditMode = self.dsSubProduto.isEditMode();
                if (fieldName === "NROLOTE") {
                    if (isEditMode) {
                        self.dsSubProduto.save(false, function () {
                            alterarAtributoSubProduto(processo.NULOP, processo.SEQOP, data.IDEFX, data.SEQLSP, "NUMLOTE", data.NROLOTE);
                        });
                    } else {
                        alterarAtributoSubProduto(processo.NULOP, processo.SEQOP, data.IDEFX, data.SEQLSP, "NUMLOTE", data.NROLOTE);
                        self.dsSubProduto.save();
                    }
                }
            }

            function handleProcessoEditionStoped(colDef, data) {
                var fieldName = colDef.skName;
                var rowIndex = self.dsProcessos.getRecordsAsObjects().findIndex(
                    record => record.SEQOP === data.SEQOP
                )
                self.dsProcessos.gotoRow(rowIndex).finally(
                    function () {
                        var isEditMode = self.dsProcessos.isEditMode();
                        if (fieldName === "TAMLOTE") {
                            if (self.currentProcess["TAMLOTE"] != data.TAMLOTE) {
                                if (isEditMode) {
                                    self.dsProcessos.save(false, function () {
                                        validaTamLote(self.dsProcessos, self.dgProcessos,function () { })
                                    });
                                } else {
                                    validaTamLote(self.dsProcessos, self.dgProcessos,function () { })
                                    self.dsProcessos.save();
                                }
                            }
                        } else if (fieldName === "NROLOTE") {
                            if (self.currentProcess["NROLOTE"] != data.NROLOTE) {
                                if (isEditMode) {
                                    var produto = self.dsProdutos.getCurrentRowAsObject();
                                    self.dsProcessos.save(false, function () {
                                        alterarAtributoProduto(data.NULOP, data.SEQOP, produto.CODPRODPA, produto.CONTROLEPA, "NUMLOTE", data.NROLOTE);
                                    });
                                } else {
                                    alterarAtributoProduto(data.NULOP, data.SEQOP, produto.CODPRODPA, produto.CONTROLEPA, "NUMLOTE", data.NROLOTE);
                                    self.dsProcessos.save();
                                }
                            }
                        } else if (fieldName === "NUNOTA") {
                            if (self.dsProcessos.getFieldValueAsNumberOrZero("NUNOTA") != 0 || self.dsProcessos.getFieldValue("NUNOTA") == undefined) {
                                if (self.currentProcess.NUNOTA != data.NUNOTA) {
                                    if (isEditMode) {
                                        self.dsProcessos.save(false, function () {
                                            alterarAtributoProcesso(data.SEQOP, "NUNOTA", data.NUNOTA);
                                        });
                                    } else {
                                        alterarAtributoProcesso(data.SEQOP, "NUNOTA", data.NUNOTA);
                                    }
                                }
                            }
                        } else if (fieldName === "SEQNOTA") {
                            if (self.dsProcessos.getFieldValueAsNumberOrZero("SEQNOTA") != 0) {
                                if (self.currentProcess.SEQNOTA != data.SEQNOTA) {
                                    if (isEditMode) {
                                        self.dsProcessos.save(false, function () {
                                            alterarAtributoProcesso(data.SEQOP, "SEQUENCIA", data.SEQNOTA);
                                        });
                                    } else {
                                        alterarAtributoProcesso(data.SEQOP, "SEQUENCIA", data.SEQNOTA);
                                    }
                                }
                            }
                        } else if (StringUtils.contains(fieldName, "AD_")) {                            
                            if (self.currentProcess[fieldName] != data[fieldName]) {
                                if (isEditMode) {
                                    self.dsProcessos.save(false, function () {
                                        alterarAtributoProcesso(data.SEQOP, fieldName, data[fieldName]);
                                    });
                                } else {
                                    alterarAtributoProcesso(data.SEQOP, fieldName, data[fieldName]);
                                }
                            }                            
                        }
                    })
            }

            function handleEditionStopedMPAlt(colDef, data) {
                var isEditMode = self.dsListaMPAlternativa.isEditMode();
                if (colDef.skName === "QTDUSAR") {
                    if (data.QTDUSAR != self.currentMpAlt.QTDUSAR) {
                        self.btnSaveMpEnabled = true;
                    }

                    if (isEditMode) {
                        var qtdUsarMpAlt = self.dsListaMPAlternativa.getFieldValueAsNumberOrZero("QTDUSAR") / self.dsListaMPAlternativa.getFieldValueAsNumberOrZero("QTDMISTURAMPALT");
                        var records = self.dsListaMPAlternativa.getRecordsAsObjects();
                        var conjunto = self.dsListaMPAlternativa.getFieldValueAsNumberOrZero("CONJUNTO");

                        if (conjunto) {
                            records.forEach(record => {
                                if (record.CONJUNTO === conjunto) {
                                    var qtdMistura = record.QTDMISTURAMPALT;
                                    changeMPAField(record.CODPRODMPALT, "QTDUSAR", qtdUsarMpAlt * qtdMistura);
                                    changeMPAField(record.CODPRODMPALT, "EDITADO", "S");
                                }
                            });
                        } else {
                            var record = self.dsListaMPAlternativa.getCurrentRowAsObject();

                            self.dsListaMPAlternativa.gotoRow(records.findIndex(rec => rec.CODPRODMPALT === record.CODPRODMPALT)).finally(() => {
                                if(record.CHK_SELECTION === NAO) {
                                    self.dsListaMPAlternativa.setFieldValue("CHK_SELECTION", SIM)
                                }
                            });
                        }
                    }
                }
            }

            function handleClickDsProcesso(colDef, data) {
                if (colDef.skName === "NUNOTA") {
                    if (data.ProcessoProdutivo.EXIGEPEDIDO === NAO) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgNPermitidoVincularPedidoCPrc'));
                        throw i18n('Commons.LancamentoOrdem.msgNPermitidoVincularPedidoCPrc');
                    }
                } else if (colDef.skName === "SEQNOTA") {
                    if (angular.isUndefined(data.NUNOTA) || data.NUNOTA === 0) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgInformeNroPedido'));
                        throw i18n('Commons.LancamentoOrdem.msgInformeNroPedido');
                    }
                }
            }

            function handleClickDsWorkCenter(colDef, data) {
                if (colDef.skName === "CODWCP") {
                    if (data.AlocacaoWorkCenterProcesso.TIPALOCACAO === ESPECIFICO) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.warnImpossivelAlterarWCEspecifico'));
                    } else if ("A-O-S".indexOf(data.AlocacaoWorkCenterProcesso.TIPALOCACAO) === -1) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.warnImpossivelAlterarWC'));
                    } else {
						colDef.editable = true;
					}
                }
            }

            function getGridAsyncListners(datagridApi) {
                return datagridApi.eventService.allAsyncListeners;
            }

            function criteriaLancamentos() {
                var criteria = Criteria();
                criteria.append('this.NULOP = ?');
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.nulop));
                return criteria;
            }
            
            function criteriaDependenciaLancamentoOP() {
                var criteria = Criteria();
                criteria.append('(this.CODPRODPA = ? AND this.NULOP = ?)');
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.dsProdutos.getFieldValueAsNumberOrZero("CODPRODPA")));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.nulop));
                return criteria;
            }

            function updateContent() {
                self.dsLancamentos.refresh();
                self.dsWcProcessos.refresh();
                self.dsTercProcessos.refresh();
                self.dsSerieProcessos.refresh();
                self.dsProcessos.refresh();
                self.dsSubProdutoProcessos.refresh();
            }

            function criteriaProduto() {
                var opDesmonte = self.valueTipOP == OP_DESMONTE ? SIM : NAO;
                var opReparo = self.valueTipOP == OP_REPARO ? SIM : NAO;

                var expressao = " this.USOPROD <> 'S'";

                expressao += " AND EXISTS (SELECT 1 ";
                expressao += " 				FROM TPRLPA LPA ";
                expressao += " 			   		 ,TPRPRC PRC ";
                expressao += " 			   WHERE LPA.IDPROC = PRC.IDPROC ";
                expressao += " 			   	AND LPA.CODPRODPA = this.CODPROD ";
                expressao += "              AND PRC.PROCDESMONTE = ? ";
                if ("S" == opReparo) {
                    expressao += "          AND PRC.PROCREPARO = '" + opReparo + "' ";
                }
                expressao += "             ) ";

                var criteria = Criteria();
                criteria.append(expressao);

                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, opDesmonte));

                return criteria;
            }

            function criteriaProcesso(codplp = undefined, prodParaTerc = undefined, codprod = undefined, tipoOp = undefined, controle = undefined) {
                codplp = angular.isDefined(codplp) ? codplp : self.codPlanta;
                prodParaTerc = angular.isDefined(prodParaTerc) ? prodParaTerc : angular.isDefined(self.producaoParaTerc) ? self.producaoParaTerc : NAO;
                codprod = angular.isDefined(codprod) ? codprod : self.codProd;
                tipoOp = angular.isDefined(tipoOp) ? tipoOp : self.valueTipOP;
                controle = angular.isDefined(controle) ? controle : angular.isDefined(self.dsProcessos)? self.dsProcessos.getFieldValueAsString("CONTROLE") : " ";
                var criteria = Criteria();

                if (StringUtils.isEmpty(controle)) {
                    controle = " ";
                }

                if (!_lancarOpVersaoAnterior) {
                    criteria.append("this.VERSAO = ( SELECT MAX(PRC2.VERSAO) AS VERSAO FROM TPRPRC PRC2 WHERE PRC2.CODPRC = this.CODPRC ) AND ");
                }
                criteria.append("(this.CODPLP IS NULL OR this.CODPLP = " + codplp + ")");
                criteria.append("AND this.IDPROC IN ( ");
                criteria.append("SELECT LPA.IDPROC FROM TPRLPA LPA WHERE 1=1");
                criteria.append("AND EXISTS(SELECT 1 FROM TPRLPA WHERE CODPRODPA = ? AND (CONTROLEPA = '" + controle + "') AND IDPROC = LPA.IDPROC))");
                criteria.append("AND this.PROCDESMONTE = '" + (OP_DESMONTE === tipoOp ? SIM : NAO) + "'");
                if (prodParaTerc != NAO) {
                    criteria.append(" AND this.PRODPARATERCEIRO <> 'N' ");
                }
                if (OP_REPARO === tipoOp) {
                    criteria.append(" AND this.PROCREPARO = 'S' ");
                } else {
                    criteria.append(" AND this.PROCREPARO IS NULL ");
                }

                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codprod));

                return criteria;
            }

            function criteriaProcessoDatagrid() {
                var codplp = 0;
                var codprod = self.dsProcessos.getFieldValueAsNumberOrZero("CODPROD");
                var tipoOp = self.dsProcessos.getFieldValueAsString("TIPOOP");
                var controle = self.dsProcessos.getFieldValueAsString("CONTROLE");
                var codparc = self.dsProcessos.getFieldValueAsNumberOrZero("CODPARCTERC");

                return criteriaProcesso(codplp, codparc != 0 ? SIM : NAO, codprod, tipoOp, controle);
            }

            function criteriaPedido() {
                var criteria = Criteria();
                criteria.append(" this.TIPMOV = 'P' AND this.PENDENTE = 'S' AND this.STATUSNOTA = 'L'");
                criteria.append(" AND EXISTS ( SELECT 1 ");
                criteria.append("			   	FROM TGFITE ITE ");
                criteria.append("			   WHERE ITE.CODPROD =  ?");
                criteria.append("			   	AND ITE.CONTROLE =  ' '");
                criteria.append("			   	AND ITE.PENDENTE = 'S' ");
                criteria.append("			   	AND ITE.NUNOTA = this.NUNOTA ");
                criteria.append("			  ) ");
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProd));
                return criteria;
            }

            function criteriaPedidoDatagrid() {
				var controle = self.dsProcessos.getFieldValueAsString("NROLOTE");
                var criteria = Criteria();

                if (NAO == self.dsProcessos.getFieldValueAsString("ProcessoProdutivo.EXIGEPEDIDO")) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgNPermitidoVincularPedidoCPrc'));
                    criteria.append("1 <> 1");
                } else {
                    criteria.append(" this.TIPMOV = 'P' AND this.PENDENTE = 'S' AND this.STATUSNOTA = 'L'");
                    criteria.append(" AND EXISTS ( SELECT 1 ");
                    criteria.append("			   	FROM TGFITE ITE ");
                    criteria.append("			   WHERE ITE.CODPROD =  ?");
                    if (controle && controle != '(Automático)' && controle != '') {
						criteria.append("			   	AND ITE.CONTROLE =  ?");
					}	
                    criteria.append("			   	AND ITE.PENDENTE = 'S' ");
                    criteria.append("			   	AND ITE.NUNOTA = this.NUNOTA ");
                    criteria.append("			  ) ");
                }

                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.dsProcessos.getFieldValueAsNumberOrZero("CODPROD")));
                
                if (controle && controle != '(Automático)' && controle != '') {
					criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, controle));
				}
				
                return criteria;
            }

            function criteriaSerie() {
                var criteria = Criteria();
                criteria.append("this.NULOP = ? AND this.SEQOP = ? AND this.CODPRODPA = ?");
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.nulop));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.dsSerieProcessos.getFieldValueAsNumberOrZero("SEQOP")));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.dsSerieProcessos.getFieldValueAsNumberOrZero("CODPROD")));

                return criteria;
            }


            function onPedidoChange(item) {
                if (angular.isDefined(item) && angular.isDefined(self.codProd)) {
                    self.showSequencia = true;
                    changeLayout();
                } else {
                    changeLayout();
                    self.showSequencia = false;
                    self.seqNota = undefined;
                }

            }

            function criteriaSeq() {
                var criteria = Criteria();

                var nuNota = self.nroPedido;
                if (nuNota === 0) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgInformeNroPedido'));
                    expression = "1 <> 1"
                } else {
                    var controle = self.controlePA;
                    if (StringUtils.isEmpty(controle)) {
                        controle = " ";
                    }

                    var expression = "this.NUNOTA = ? AND this.PENDENTE = 'S' AND this.CODPROD = ? AND this.CONTROLE = ?";

                    criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, nuNota));
                    criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProd));
                    criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, controle));
                }

                criteria.append(expression);

                return criteria;
            }

            function criteriaSeqPedidos() {
                var criteria = Criteria();

                var nuNota = self.dsProcessos.getFieldValueAsNumberOrZero("NUNOTA");
                if (nuNota === 0) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgInformeNroPedido'));
                    expression = "1 <> 1"
                } else {
                    var controle = self.dsProdutos.getFieldValueAsString("CONTROLE");
                    if (StringUtils.isEmpty(controle)) {
                        controle = " ";
                    }

                    var expression = "this.NUNOTA = ? AND this.PENDENTE = 'S' AND this.CODPROD = ? AND this.CONTROLE = ?";

                    criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, nuNota));
                    criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.dsProcessos.getCurrentRowAsObject()["CODPROD"]));
                    criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, controle));
                }



                criteria.append(expression);

                return criteria;
            }

            function changeRecordPosition(offset) {
                var currentProcess = self.dsProcessos.getCurrentRowAsObject();
                alterarAtributoProcesso(currentProcess.SEQOP, "ORDEM", currentProcess.ORDEM + offset);
            }

            function alterarAtributoProcesso(seqop, atributo, valor) {
                var request = {
                    params: {
                        nulop: self.nulop,
                        seqop: seqop,
                        atributo: atributo,
                        valor: valor
                    }
                }
                ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.alterarAtributoProcesso", request).then(function (result) {
                    verificaWarnings(result.responseBody);
                    updateContent();
                }).finally(function () {
                    self.dgProcessos.endEdit(true);
                });
            }

            function changeSeqEnabled(offset) {
                if (angular.isUndefined(self.dsProcessos)) {
                    return false;
                }

                if (angular.isDefined(self.dsProcessos.getCurrentRow()) && self.dsProcessos.getRecords().length > 1) {
                    if ((offset === -1 && self.dsProcessos.getCurrentRowAsObject().SEQOP === getMinSeq()) || (offset === 1 && self.dsProcessos.getCurrentRowAsObject().SEQOP === getMaxSeq())) {
                        return false;
                    }
                    return true;
                }
                return false;
            }

            function changeSeqMpaEnabled(offset) {
                if (angular.isUndefined(self.dsListaMPAlternativa)) {
                    return false;
                }

                if (self.dsListaMPAlternativa.getRecords().length > 1) {
                    if ((offset === -1 && self.dsListaMPAlternativa.getCurrentIndex() === 0) || (offset === 1 && self.dsListaMPAlternativa.getCurrentIndex() === (self.dsListaMPAlternativa.getRecords().length - 1))) {
                        return false;
                    }
                    return true;
                }
                return false;
            }

            function getMinSeq() {
                var minSeq = 1;
                for (var i = 0; i < self.dsProcessos.getRecords().length; i++) {
                    if (self.dsProcessos.getRecordsAsObject()[i].SEQOP < minSeq) {
                        minSeq = self.dsProcessos.getRecordsAsObject()[i].SEQOP;
                    }
                }
                return minSeq;
            }

            function getMaxSeq() {
                var maxSeq = 1;
                for (var i = 0; i < self.dsProcessos.getRecords().length; i++) {
                    if (self.dsProcessos.getRecordsAsObject()[i].SEQOP > maxSeq) {
                        maxSeq = self.dsProcessos.getRecordsAsObject()[i].SEQOP;
                    }
                }
                return maxSeq;
            }

            function removerProcessosSelecionados() {
                if(!SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE)) {
                    MessageUtils.showAlert(i18n('Dataset.msgtitleControleAcesso'), i18n('Dataset.messageNaoPermitidoRemover'));
                    return;
                }

                if (self.dsProcessos.getCurrentRowAsObject()) {
                    if (self.dsProcessos.getFieldValueAsNumberOrZero("SEQCOP") == 0) {
                        MessageUtils.confirm(MessageUtils.TITLE_CONFIRMATION, i18n('Commons.LancamentoOrdem.msgConfirmacaoRemoverOP')).then(function (result) {
                            removerProcesso(self.dsProcessos.getCurrentRowAsObject().SEQOP);
                        });
                    } else {
                        MessageUtils.confirmBuilder().msg(i18n('Commons.LancamentoOrdem.msgConfirmaRemoverCoProduto')).show().then(function () {
                            removerProcesso(0)
                        }, function (reason) {
                            if (reason == 'no') {
                                removerProcesso(self.dsProcessos.getCurrentRowAsObject().SEQOP);
                            }
                        });
                    }
                }
            }

            function removerProcesso(seqop) {
                var seqCop = self.dsProcessos.getFieldValueAsNumberOrZero("SEQCOP");
                if (seqop != 0) {
                    seqCop = 0;
                }
                var request = {
                    param: {
                        nulop: self.nulop,
                        seqop: seqop,
                        seqcop: seqCop
                    }
                }
                ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.removerProcesso", request).then(function (result) {
                    var index = self.seqControleSerie.indexOf(seqop);
                    if (index != -1) {
                        if (self.seqControleSerie.length === 1) {
                            self.seqControleSerie = [];
                        } else {
                            self.seqControleSerie.splice(index);
                        }
                        self.showStepNroSerie = self.seqControleSerie.length != 0
                    }

                    if (seqCop > 0) {
                        var index = self.codProdMPCompartilhada.findIndex(function(mp) { return mp.seqcop === seqCop});
                        if (index > -1) {
                            self.codProdMPCompartilhada.splice(index, 1);
                        }  
                    }                   

                    updateContent();
                    montaListaExtratoMateriais();
                })
            }

            function openPopupInfoLote() {
                if (self.dsProcessos.isEditMode()) {
                    self.dsProcessos.save().finally(function () {
                        validaTamLote(self.dsProcessos, self.dgProcessos, function () {

                        })
                    })
                }
                SanPopup.open({
                    title: i18n('Commons.LancamentoOrdem.btnInfLote'),
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/popupInfoLote/popupInfoLote.tpl.html',
                    controller: 'popupInfoLoteController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    showBtnOk: false,
                    resolve: {
                        data: {
                            dsProdutos: self.dsProdutos,
                            scope: $scope,
                            resourceID: self.resourceID,
                            precCols: COL_DECQTD_READONLY,
                            getPrecision: getPrecision
                        }
                    }
                });
            }

            function openPopupDependencia() {
                SanPopup.open({
                    title: i18n('Commons.LancamentoOrdem.labelDependencias'),
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/popup-dependencias/popupDependencias.tpl.html',
                    controller: 'popupDependenciasController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    showBtnOk: false,
                    resolve: {
                        data: {
                            dsDependencias: self.dsDependencias,
                            dsProcessos: self.dsProcessos,
                            nulop: self.nulop,
                            scope: $scope,
                            resourceID: self.resourceID,
                            precCols: COL_DECQTD_READONLY,
                            getPrecision: getPrecision
                        }
                    }
                });
            }

            function clickDependencia() {
                openPopupDependencia();
            }

            function clickInfoLote() {
                openPopupInfoLote();
            }

            function btnDependenciasEnabled() {
                return angular.isDefined(self.dsProcessos) && self.dsProcessos.getCurrentRowAsObject() != undefined && angular.isDefined(self.dsDependencias) && self.dsDependencias.getRecords().length > 0;
            }

            function getCellColors(row, col, rowIndex, colIndex) {
                if (row.entity.indexOf("DSMPA-2222") != -1) {
                    var saldoIndex = self.dsListaMPAlternativa.getFieldIndexByName("SALDOMPA");
                    if (row.entity[saldoIndex] > 0) {
                        return '#3300FF';
                    } else if (row.entity[saldoIndex] < 0) {
                        return '#FF0000';
                    } else {
                        return '#000000';
                    }
                } else if (row.entity.indexOf("DSMP-1111") != -1) {
                    var saldoIndex = self.dsListaMPs.getFieldIndexByName("SALDOMP");
                    if (row.entity[saldoIndex] < 0) {
                        return '#FF0000';
                    }
                }

            }

            function deletarLancamento(nulop) {
                var request = {
                    params: {
                        nulop: nulop
                    }
                }
                if (nulop > 0) {
                    return ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.deletarLancamentoOP", request).then(
                        function (response) {
                        });
                }
            }

            function carregaConfiguracoes() {
                var userId = SkApplicationInstance.getUserID();
                ServiceProxy.callService(
                    "mge@SystemUtilsSP.getConf",
                    { config: { chave: self.resourceID, tipo: "T", usuario: userId } }).then(
                        function (result) {
                            if (angular.isDefined(result.responseBody.config)) {
                                config = result.responseBody.config[0];
                                self.apresentarPis = config.apresentarpis === "false" ? NAO : SIM
                            }
                        }
                    );
            }

            function criteriaProcessosWC() {
                var criteria = Criteria();
                criteria.append('this.NULOP = ?');
                //criteria.append('AND (SELECT CODWCP FROM TPRWLOP WLOP WHERE WLOP.IDPROC = this.IDPROC AND WLOP.NULOP = this.NULOP AND WLOP.SEQOP = this.SEQOP) IS NOT NULL');
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.nulop));
                return criteria;
            }

            function criteriaProcessosWCGrid() {
                var criteria = Criteria();
                var codCwc = self.dsWorkCenter.getFieldValueAsNumberOrZero("CODCWC");
                var codPlanta = 0;
                var codProd = self.dsWcProcessos.getFieldValueAsNumberOrZero("CODPROD");

                criteria.append("CODCWC = ?");
                criteria.append(" AND this.CODPLP = ?");

                if (MGEParameters.asBoolean("prod.filtrar.workcenter.por.pa")) {
                    criteria.append(" AND EXISTS (");
                    criteria.append(" SELECT 1 ");
                    criteria.append(" FROM TPRWXP WXP ");
                    criteria.append(" WHERE WXP.CODWCP = this.CODWCP AND WXP.CODPRODPA = ?)");
                }
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codCwc));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codPlanta));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codProd));

                return criteria;
            }

            function cellFormatterTamLote(col, value, row) {
                if (angular.isDefined(value) && angular.isDefined(row)) {
                    var indexDecQtd = self.dsProcessos.getFieldIndexByName('DECQTD');
                    return NumberUtils.format(value, row[indexDecQtd] == undefined ? 2 : row[indexDecQtd] > 20 ? 20 : row[indexDecQtd]);
                }
            }

            function cellFormatterTamLoteProduto(col, value, row) {
                if (angular.isDefined(value) && angular.isDefined(row)) {
                    var decQtd = 2;
                    decQtd = angular.isDefined(self.dsProcessos.getFieldValueAsNumber('DECQTD'))? self.dsProcessos.getFieldValueAsNumber('DECQTD') : decQtd;

                    return NumberUtils.format(value, decQtd);
                }
            }

            function cellFormatterTamLoteAlternativo(col, value, row) {
                if (angular.isDefined(value) && angular.isDefined(row)) {
                    var decQtd = buscaDecimaisProdutos(row[$scope.ctrl.dsProdutos.getFieldIndexByName('CODPRODPA')]);
                    return NumberUtils.format(value, decQtd);
                }
            }

            function addDecimaisProdutos(codProd, decimais, tamlote) {
                let index = _decimaisProdutos.findIndex(prc => prc.CODPROD == codProd);
                if(index < 0) {
                    _decimaisProdutos.push({CODPROD: codProd, DECIMAIS: decimais, TAMLOTE: tamlote});
                }
            }

            function buscaDecimaisProdutos(codProd) {
                let index = _decimaisProdutos .findIndex(prc => prc.CODPROD== codProd);
                if(index != -1) {
                    return _decimaisProdutos[index].DECIMAIS;
                } else {
                    return 2;
                }
            }

            function cellFormatterTamLoteAjustada(col, value, row) {
                if (StringUtils.isNotEmpty(value) && angular.isDefined(row)) {
                    var decQtd = 2;
                    decQtd = angular.isDefined(self.dsProcessos.getFieldValueAsNumber('DECQTD'))? self.dsProcessos.getFieldValueAsNumber('DECQTD') : decQtd;

                    return NumberUtils.format(value, decQtd);
                } else if (StringUtils.isEmpty(value))
                    return "-";
            }

            function cellFormatterTamLoteAjustadaOP(col, value, row) {
                if (StringUtils.isNotEmpty(value) && angular.isDefined(row)) {
                    return NumberUtils.format(value, 2);
                } else if (StringUtils.isEmpty(value))
                    return "-";
            }

            function cellFormatterNroLote(col, value, row) {
                if (angular.isDefined(value) && angular.isDefined(row)) {
                    var tipNroLote = row[self.dsProcessos.getFieldIndexByName("TIPONROLOTE")];
                    var loteCuringa = row[self.dsProcessos.getFieldIndexByName("LOTECURINGA")];
                    if (isNroAutmatico(tipNroLote, loteCuringa)) {
                        return i18n('Commons.LancamentoOrdem.labelAutomatico');
                    } else {
                        return value;
                    }
                }
            }

            function cellFormatterNroLoteSubProduto(col, value, row) {
                if (angular.isDefined(value) && angular.isDefined(row)) {
                    if (tipoNroLoteSubProdutoIgualManual()) {
                        return value;
                    } else {
                        return i18n('Commons.LancamentoOrdem.labelAutomatico');
                    }
                }
            }

            function cellFormatterTamLoteWorkCenter(col, value, row) {
                if (angular.isDefined(value) && angular.isDefined(row)) {
                    var decQtd = 2;
                    var records = self.dsProcessos.getRecordsAsObjects();

                    records.forEach(function(item){
                        if(row[4] == item.CODPROD && row[1] == item.SEQOP) {
                            decQtd = item.DECQTD;
                        }
                    });

                    return NumberUtils.format(value, decQtd);
                }
            }

            function isNroAutmatico(tipNroLote, loteCuringa) {
                var processoProdutivoUsaLoteCuringa = tipNroLote === MANUAL && StringUtils.isNotEmpty(loteCuringa);
                return (tipNroLote != MANUAL && !processoProdutivoUsaLoteCuringa);
            }

            function interceptCellRenderer(cell, value, eGridCell, data) {
                if (COL_DECQTD_READONLY.indexOf(cell.colId) != -1 && !cell.colDef.editable) {
                    var element = document.createElement("span");
                    element.setAttribute("style", "layout-align: right;");
                    var text = document.createTextNode(NumberUtils
                        .format(value, getPrecision(angular.isDefined(data.gridItem.Produto) ? data.gridItem.Produto.DECQTD : data.gridItem.DECQTD)));
                    element.appendChild(text);

                    return {
                        element: element,
                        align: "flex-end"
                    }
                }
            }

            function interceptItemEditor(configObj, dataset) {
                if (dataset.getEntityName() === "ItemDeLancamentoDeOP") {

                    if (configObj.skName === "NUNOTA") {

                        if (dataset.getFieldValueAsString("ProcessoProdutivo.EXIGEPEDIDO") === NAO) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgNPermitidoVincularPedidoCPrc'));
                            self.dgProcessos.endEdit(true);
                        } else {
                            configObj.enviromentCriteria = criteriaPedidoDatagrid;
                        }
                        configObj.editable = self.isEditableDataGrids;
                    } else if (configObj.skName === "SEQNOTA") {
                        var nuNota = dataset.getFieldValueAsNumberOrZero("NUNOTA");
                        if (angular.isUndefined(nuNota) || nuNota === 0) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgInformeNroPedido'));
                            self.dgProcessos.endEdit(true);
                        } else {
                            configObj.enviromentCriteria = criteriaSeqPedidos;
                            configObj.fk.targetField = "SEQUENCIA";
                        }

                    } else if (configObj.skName === "ProcessoProdutivo.CODPRC") {
                        configObj.enviromentCriteria = criteriaProcessoDatagrid;
                        configObj.fk.targetField = "CODPRC";
                        configObj.editable = self.isEditableDataGrids;
                    } else if ("TAMLOTE" === configObj.skName) {
                        configObj.skPrettyPrecision = configObj.skPrecision = getPrecision(self.dsProcessos.getFieldValueAsNumberOrZero("DECQTD"));

                        if (self.showDgProcessos) {
                            self.dgProcessos.endEdit(true);
                        } else {
                            configObj.editable = self.isEditableDataGrids;
                        }
                    } else if (configObj.skName === "NROLOTE") {
                        if (isNroAutmatico(dataset.getFieldValueAsString("TIPONROLOTE"), dataset.getFieldValueAsString("LOTECURINGA"))) {
                            self.dgProcessos.endEdit(true);
                        } else {
                            configObj.editable = true;
                        }
                    } 

                } else if (dataset.getEntityName() === "AlocacaoDeWorkCenterLctoOP") {
                    if (configObj.skName === "CODWCP") {

                        if (self.dsWorkCenter.getFieldValueAsString("AlocacaoWorkCenterProcesso.TIPALOCACAO") === ESPECIFICO) {
                            self.dgWorkCenter.endEdit(true);
                        } else if ("A-O-S".indexOf(self.dsWorkCenter.getFieldValueAsString("AlocacaoWorkCenterProcesso.TIPALOCACAO")) === -1) {
                            self.dgWorkCenter.endEdit(true);
                        }
                        configObj.enviromentCriteria = criteriaProcessosWCGrid;
                    }

                } else if (dataset.getEntityName() === "ProdutoLancamentoDeOP") {
                    if ("TAMLOTE" === configObj.skName) {

                        configObj.skPrettyPrecision = configObj.skPrecision = getPrecision(self.dsProcessos.getFieldValueAsNumberOrZero("DECQTD"));

                    } else if (configObj.skName === "NROLOTE") {
                        if (isNroAutmatico(self.dsProcessos.getFieldValueAsString("TIPONROLOTE"), self.dsProcessos.getFieldValueAsString("LOTECURINGA"))) {
                            self.dgProdutos.endEdit(true);
                        } else {
                            configObj.editable = true;
                        }
                    }
                } else if (dataset.getEntityName() === "SubProdutoLancamentoOP") {
                    if (configObj.skName === "NROLOTE") {
                        if (tipoNroLoteSubProdutoIgualManual()) {
                            configObj.editable = true;
                        } else {
                            self.dgSubProduto.endEdit(true);
                        }
                    }
                } 
            }

            function tipoNroLoteSubProdutoIgualManual() {
                return self.dsProcessos.getFieldValueAsString("ProcessoProdutivo.TIPONROLOTESP") === MANUAL;
            }

            function interceptColumnMetadata(fieldMetadata, dataset) {
                if (dataset.getEntityName() === 'ItemDeLancamentoDeOP') {
                    if ("ProcessoProdutivo.CODPRC" === fieldMetadata.name) {
                        var fk = {
                            relationShipName: "ProcessoProdutivo",
                            entity: "ProcessoProdutivo",
                            targetField: "CODPRC",
                            isHierarchyEntity: false,
                            descriptionFieldName: "ProcessoProdutivo.DESCRABREV",
                        }

                        fieldMetadata.fk = fk;
                        fieldMetadata.readOnly = _isPrevisaoEntrega || _isItensPorPedido;
                    } else if ("NUNOTA" === fieldMetadata.name) {
                        var fk = {
                            relationShipName: "CabecalhoNota",
                            entity: "CabecalhoNota",
                            targetField: "NUNOTA",
                            isHierarchyEntity: false
                        }

                        fieldMetadata.fk = fk;
                        fieldMetadata.readOnly = _isPrevisaoEntrega || _isItensPorPedido;
                    } else if ("SEQNOTA" === fieldMetadata.name) {
                        var fk = {
                            relationShipName: "ItemNota",
                            entity: "ItemNota",
                            targetField: "SEQUENCIA",
                            isHierarchyEntity: false
                        }

                        fieldMetadata.fk = fk;
                        fieldMetadata.readOnly = _isPrevisaoEntrega || _isItensPorPedido;
                    } else if ("TAMLOTE" === fieldMetadata.name) {
                        fieldMetadata.precision = getPrecision(dataset.getFieldValueAsNumberOrZero("DECQTD"));
                        fieldMetadata.customCellFormatter = customCellFormatterOPAlternativo;
                        fieldMetadata.readOnly = _isPrevisaoEntrega || _isItensPorPedido || _isPlanejamentProducao;
                    } else if ("ProdutoLancamentoDeOP.CALCTAMLOTE" === fieldMetadata.name) {
                        fieldMetadata.precision = getPrecision(dataset.getFieldValueAsNumberOrZero("DECQTD"));
                        fieldMetadata.readOnly = true;
                    } else if ("NROLOTE" === fieldMetadata.name) {
                        fieldMetadata.readOnly = false;
                    } else if (StringUtils.contains(fieldMetadata.name, "AD_")) {
                        fieldMetadata.readOnly = false;
                    } else {
                        fieldMetadata.readOnly = true;
                    }

                    if ("CODPLP" === fieldMetadata.name && self.isJivaProducao) {
                        fieldMetadata.visible = false;
                    }

                    var order = ORDEM_CAMPOS_ITEM_LANCAMENTO.findIndex(item => item === fieldMetadata.name);
                    fieldMetadata.order = order != -1 ? order : fieldMetadata.order;
                } else if (dataset.getEntityName() === 'TerceiroLancamentoDeOP') {
                    if ("CODPARCTERC" == fieldMetadata.name) {
                        fieldMetadata.readOnly = false;
                    } else {
                        fieldMetadata.readOnly = true;
                    }
                } else if (dataset.getEntityName() === 'AlocacaoDeWorkCenterLctoOP') {
                    if ("CODWCP" === fieldMetadata.name) {
                        fieldMetadata.readOnly = _isPrevisaoEntrega || _isItensPorPedido;
                    } else {
                        fieldMetadata.readOnly = true;
                    }
                } else if (dataset.getEntityName() === 'ProdutoLancamentoDeOP') {
                    fieldMetadata.order = ORDEM_CAMPOS_PRODUTO_LANCAMENTO.findIndex(item => item === fieldMetadata.name);
                    if ("TAMLOTE" === fieldMetadata.name) {
                        fieldMetadata.precision = getPrecision(dataset.getFieldValueAsNumberOrZero("DECQTD"));
                        fieldMetadata.customCellFormatter = customCellFormatterOPAlternativo;
                        fieldMetadata.readOnly = _isPrevisaoEntrega || _isItensPorPedido || _isPlanejamentProducao;
                    } else if ("NROLOTE" === fieldMetadata.name) {
                        fieldMetadata.readOnly = false;
                    } else {
                        fieldMetadata.readOnly = true;
                    }
                } else if (dataset.getEntityName() === 'DependenciaLancamentoOP') {
                    fieldMetadata.order = ORDEM_CAMPOS_DEPENDENCIA_LANCAMENTO.findIndex(item => item === fieldMetadata.name);
                } else if (dataset.getEntityName() === 'SubProdutoLancamentoOP') {
                    fieldMetadata.order = ORDEM_CAMPOS_SUB_PRODUTO_LANCAMENTO.findIndex(item => item === fieldMetadata.name);
                    if ("NROLOTE" === fieldMetadata.name) {
                        fieldMetadata.readOnly = false;
                    } else {
                        fieldMetadata.readOnly = true;
                    }
                } else {
                    if (["QTDUSAR", "CHK_SELECTION"].indexOf(fieldMetadata.name) != -1) {
                        fieldMetadata.readOnly = false;
                    } else {
                        fieldMetadata.readOnly = true;

                    }
                    
                    if("QTDOPS" === fieldMetadata.name) {
						if(MGEParameters.asBoolean("prod.exibe.qtdops.extrato.mps")){
							fieldMetadata.visible = true;
						}else{
							fieldMetadata.visible = false;
						}						
					}

                    if("QTDPEDCOMPRA" === fieldMetadata.name) {
						if(self.qtdNotasConfirmadas < 0){
							fieldMetadata.visible = false;
						}else{
							fieldMetadata.visible = true;
						}
					}

                }
            }

            function customCellFormatterOPAlternativo(value, column, data) {
                if (value != undefined){
                   var decQtd = NumberUtils.getNumberOrZero(data.DECQTD) > 0 ? NumberUtils.getNumberOrZero(data.DECQTD) : 2;
                   return NumberUtils.format(value, decQtd);
                }else{
                   return value;
                }
             }

            function getPrecision(precision) {
                if (angular.isUndefined(precision)) {
                    return 2;
                }

                return isNaN(precision) ? 2 : precision;
            }

            function changeApresentarPIs() {
                montaListaExtratoMateriais();
            }

            function montaListaExtratoMateriais(gotoMP = undefined, gotoPA = undefined) {
                var request = {
                    params: {
                        nulop: self.nulop,
                        apresentarPIs: self.apresentarPis === SIM
                    }
                }

                var currentSeqItemLancamento = 0;
                if (self.dsListaMPs.getRecords().length > 0) {
                    currentSeqItemLancamento = self.dsItemLancamento.getFieldValueAsNumberOrZero("SEQOP");
                    self.dsListaMPs.clearDataSet();
                    self.dsItemLancamento.clearDataSet();
                    self.dsListaMPAlternativa.clearDataSet();
                }

                ServiceProxy.callService('mgeprod@LancamentoOrdemProducaoSP.getListaExtratoMateriais', request).then(
                    function (result) {
                        var listaMPs = [];
                        if (angular.isDefined(result.responseBody.materiais) && angular.isDefined(result.responseBody.materiais.materiaPrima)) {
                            materias = result.responseBody.materiais.materiaPrima;

                            self.dsListaMPs.clearDataSet();
                            if (angular.isDefined(materias)) {
                                if (Array.isArray(materias)) {
                                    materias.forEach(materia => {
                                        if (!mpAlreadyInList(materia)) {
                                        	if (self.codProdMPCompartilhada.filter(function(mp) { return mp.codProdMP === parseInt(materia.CODPRODMP);}).length < 1) {
                                        		listaMPs.push(resolveMP(materia));
                                        	}
                                        }
                                    })
                                } else {
                                    if (!mpAlreadyInList(materias)) {
                                    	if (self.codProdMPCompartilhada.filter(function(mp) { return mp.codProdMP === parseInt(materias.CODPRODMP);}).length < 1) {
                                    		listaMPs.push(resolveMP(materias));
                                    	}
                                    }
                                }

                                if (listaMPs.length > 0) {
                                    self.dsListaMPs.addRecordsAsObjects(listaMPs, function (value) {
                                        return value === undefined ? null : value;
                                    });

                                    if (angular.isDefined(gotoMP)) {
                                        if (angular.isDefined(gotoPA)) {
                                            self.seqPa = gotoPA;
                                        }
                                        self.dsListaMPs.gotoRow(self.dsListaMPs.getRecordsAsObjects().findIndex(record => record.CODPRODMP === gotoMP)).finally(
                                            function () {
                                                selectCurrentRecord(self.dsListaMPs);
                                            }
                                        );
                                    } else {
                                        self.dsListaMPs.gotoRow(0).finally(
                                            function () {
                                                selectCurrentRecord(self.dsListaMPs);
                                            }
                                        );
                                    }
                                    self.enabledButtonDetalhamentoEntregas = true;
                                } else {
                                    self.enabledButtonDetalhamentoEntregas = false;
                                }
                            }
                        }
                    }
                )
            }

            function mpAlreadyInList(materia) {
                return angular.isDefined(self.dsListaMPs.getRecordsAsObjects().find(mp => mp.CODPRODMP === parseInt(materia.CODPRODMP)));
            }

            function resolveMP(materia) {
                var mp = {
                    CODPRODMP: parseInt(materia.CODPRODMP),
                    DESCRMP: materia.DESCRPROD,
                    CONTROLEMP: materia.CONTROLEMP,
                    REFERENCIA: materia.REFERENCIA,
                    NECESSIDADE: parseFloat(materia.NECESSIDADE),
                    ESTOQUE: parseFloat(materia.ESTOQUE),
                    QTDSUBS: parseFloat(materia.QTDSUBS),
                    DECQTD: parseFloat(materia.DECQTD),
                    EXISTEMPSUB: materia.EXISTEMPSUB,
                    SALDOMP: parseFloat(materia.SALDO),
                    UNIDADE: materia.UNIDADE,
                    CODPARC: angular.isDefined(materia.CODPARC) ? parseInt(materia.CODPARC) : null,
                    RAZAOSOCIAL: angular.isDefined(materia.RAZAOSOCIAL) ? parseInt(materia.RAZAOSOCIAL) : null,
                    DSIDENTIFIER: "DSMP-1111",
                    QTDPEDCOMPRA: parseInt(materia.QTDPEDCOMPRA),
                    QTDOPS: angular.isDefined(materia.QTDOPS) ? parseFloat(materia.QTDOPS) : null
                }

                var qtdUsar = mp.NECESSIDADE - mp.QTDSUBS;
                mp.QTDUSAR = qtdUsar < 0 ? 0 : qtdUsar;
                return mp;
            }

            function getListaMaterialAlternativo() {
                var controlePA = StringUtils.isNotEmpty(self.dsItemLancamento.getFieldValueAsString("CONTROLEPA")) ? self.dsItemLancamento.getFieldValueAsString("CONTROLEPA") : " ";
                var controleMP = StringUtils.isNotEmpty(self.dsListaMPs.getFieldValueAsString("CONTROLEMP")) ? self.dsListaMPs.getFieldValueAsString("CONTROLEMP") : " ";

                var request = {
                    params: {
                        idproc: self.dsItemLancamento.getFieldValueAsNumberOrZero("IDPROC"),
                        codplp: self.dsItemLancamento.getFieldValueAsNumberOrZero("CODPLP"),
                        codProdPA: self.dsItemLancamento.getFieldValueAsNumberOrZero("CODPRODPA"),
                        controlePA: controlePA,
                        codProdMP: self.dsListaMPs.getFieldValueAsNumberOrZero("CODPRODMP"),
                        controleMP: controleMP,
                        tamLote: self.dsItemLancamento.getFieldValueAsNumberOrZero("TAMLOTE"),
                        calTamLote: self.dsItemLancamento.getFieldValueAsNumberOrZero("CALCTAMLOTE"),
                        nulop: self.dsItemLancamento.getFieldValueAsNumberOrZero("NULOP"),
                        seqop: self.dsItemLancamento.getFieldValueAsNumberOrZero("SEQOP")
                    }
                }

                ServiceProxy.callService(
                    "mgeprod@LancamentoOrdemProducaoSP.getListaMaterialAlternativo",
                    request).then(
                        function (result) {
                            materias = result.responseBody.materialAlternativo.materiaPrima;
                            var listaMPAlternativas = [];
							self.selecionaMps = NAO;
                            if (angular.isDefined(materias)) {
                                if (Array.isArray(materias)) {
                                    materias.forEach(materia => {
                                        listaMPAlternativas.push(resolveMPAlternativa(materia));
                                    })
                                } else {
                                    listaMPAlternativas.push(resolveMPAlternativa(materias));
                                }
								
								if (listaMPAlternativas.length > 0) {
									self.dsListaMPAlternativa.goToInsertionMode().then(function () {
										self.dsListaMPAlternativa.addRecordsAsObjects(listaMPAlternativas, function (value) {
	                                        return value === undefined ? null : value;
	                                    });
	                                    self.restorePointListaMPAlternativa = self.dsListaMPAlternativa.getRecordsAsObjects();
	                                    self.dsListaMPAlternativa.gotoRow(0);

										if (!listaMPAlternativas.find(item => item.CHK_SELECTION === "N")) {
		                                    self.selecionaMps = SIM;
		                                }
									});
										
                                }
                            }
                        }
                    ).finally(function () {
                        selectMPAlternativa();
                    });
            }

            function selectMPAlternativa(conjunto = undefined) {
                var records = self.dsListaMPAlternativa.getRecords();
                var recordsToSelect = [];

                records.forEach(record => {
                    var qtdUsar = record[self.dsListaMPAlternativa.getFieldIndexByName("QTDUSAR")];
                    if (angular.isDefined(qtdUsar) && qtdUsar != 0) {
                        if (angular.isUndefined(conjunto) || record[self.dsListaMPAlternativa.getFieldIndexByName("CONJUNTO")] === conjunto) {
                            recordsToSelect.push(record);
                        }
                    }
                });

                self.dsListaMPAlternativa.setSelectedRecords(recordsToSelect);
            }

            function selectMPAltByControleOrSelected(conjuntoSelecionado, selectedRecords, index) {
                self.dsListaMPAlternativa.gotoRow(index)
                    .then(function () {
                        self.dsListaMPAlternativa.gotoRow(index).finally(
                            function () {
                                var records = self.dsListaMPAlternativa.getRecords();
                                var recordsToSelect = [];

                                var indexQtd = self.dsListaMPAlternativa.getFieldIndexByName("QTDUSAR");
                                var indexConj = self.dsListaMPAlternativa.getFieldIndexByName("CONJUNTO");
                                var indexCod = self.dsListaMPAlternativa.getFieldIndexByName("CODPRODMPALT");

                                records.forEach(record => {
                                    var qtdUsar = record[indexQtd];
                                    if (angular.isDefined(qtdUsar) && qtdUsar != 0) {
                                        var recordIsSelected = selectedRecords.find(rec => rec[indexCod] === record[indexCod]);
                                        if ((angular.isUndefined(record[indexConj]) && recordIsSelected) || record[indexConj] === conjuntoSelecionado || recordIsSelected) {
                                            recordsToSelect.push(record);
                                        }
                                    }
                                });

                                self.dsListaMPAlternativa.setSelectedRecords(recordsToSelect);
                            })
                    });
            }

            function resolveMPAlternativa(materiaPrima) {
                var mp = {
                    CODPRODMPALT: materiaPrima.CODPRODMPALT,
                    DESCRPRODMPALT: materiaPrima.DESCRPRODMPALT,
                    CONTROLEMPALT: materiaPrima.CONTROLEMPALT,
                    REFERENCIA: materiaPrima.DESCRPRODMPALT,
                    ESTOQUE: materiaPrima.ESTOQUE,
                    ORDEM: materiaPrima.ORDEM,
                    EDITADO: NAO,
                    CONJUNTO: materiaPrima.CONJUNTO,
                    NECESSIDADE: materiaPrima.NECESSIDADE,
                    QTDUSAR: materiaPrima.QTDUSAR,
                    QTDMISTURAMPALT: materiaPrima.QTDMISTURAMPALT,
                    QTD_LANC: materiaPrima.QTD_LANC,
                    DECQTD: materiaPrima.DECQTD,
                    SALDOMPA: parseInt(materiaPrima.SALDO),
                    UNIDADE: materiaPrima.UNIDADE,
                    CHK_SELECTION: materiaPrima.QTDUSAR > 0 ? "S" : "N",
                    DSIDENTIFIER: "DSMPA-2222",
                    SEQMPA: materiaPrima.SEQMPA
                }
                return mp;
            }

            function getItemsLancamento() {
                var controleMP = StringUtils.isNotEmpty(self.dsListaMPs.getFieldValueAsString("CONTROLEMP")) ? self.dsListaMPs.getFieldValueAsString("CONTROLEMP") : " ";

                var request = {
                    params: {
                        nulop: self.nulop,
                        codProdMP: self.dsListaMPs.getFieldValueAsNumberOrZero("CODPRODMP"),
                        controleMP: controleMP
                    }
                }

                ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.getListaProdutoAcabadoLancamentoOP", request)
                    .then(function (result) {
                        var produtosAcabados = result.responseBody.produtosAcabado.produtoAcabado;
                        var listaPAs = [];
                        if (angular.isDefined(produtosAcabados)) {
                            if (Array.isArray(produtosAcabados)) {
                                produtosAcabados.forEach(produtoAcabado => {
                                    listaPAs.push(produtoAcabado);
                                    addDecimaisProdutos(produtoAcabado.CODPRODPA, produtoAcabado.DECQTD, produtoAcabado.TAMLOTE);
                                })
                            } else {
                                listaPAs.push(produtosAcabados);
                                addDecimaisProdutos(produtosAcabados.CODPRODPA, produtosAcabados.DECQTD, produtosAcabados.TAMLOTE);
                            }

                            if (listaPAs.length > 0) {
                                self.dsItemLancamento.addRecordsAsObjects(listaPAs, function (value) {
                                    return value === undefined ? null : value;
                                });
                                if (angular.isDefined(self.seqPa)) {
                                    self.dsItemLancamento.gotoRow(self.dsItemLancamento.getRecordsAsObjects().findIndex(record => parseInt(record.SEQOP) === self.seqPa)).finally(function () {
                                        selectCurrentRecord(self.dsItemLancamento);
                                        self.seqPa = self.dsItemLancamento.getSelectedRecordsAsObjects().SEQOP;
                                    });
                                } else {
                                    self.dsItemLancamento.gotoRow(0).finally(function () {
                                        selectCurrentRecord(self.dsItemLancamento);
                                        self.seqPa = self.dsItemLancamento.getSelectedRecordsAsObjects().SEQOP;
                                    });
                                }
                            }
                        }
                    });
            }

            function clearDatasets() {
                if (angular.isDefined(self.dsLancamentos)) {
                    self.dsLancamentos.clearDataSet();
                }
                if (angular.isDefined(self.dsItemLancamento)) {
                    self.dsItemLancamento.clearDataSet();
                }
                if (angular.isDefined(self.dsProcessos)) {
                    self.dsProcessos.clearDataSet();
                }
                if (angular.isDefined(self.dsProduto)) {
                    self.dsProduto.clearDataSet();
                }
                if (angular.isDefined(self.dsWorkCenter)) {
                    self.dsWorkCenter.clearDataSet();
                }
                if (angular.isDefined(self.dsDependencias)) {
                    self.dsDependencias.clearDataSet();
                }
                if (angular.isDefined(self.dsTerceiros)) {
                    self.dsTerceiros.clearDataSet();
                }
                if (angular.isDefined(self.dsListaMPs)) {
                    self.dsListaMPs.clearDataSet();
                }
                if (angular.isDefined(self.dsListaMPAlternativa)) {
                    self.dsListaMPAlternativa.clearDataSet();
                }
                if (angular.isDefined(self.dsWcProcessos)) {
                    self.dsWcProcessos.clearDataSet();
                }
                if (angular.isDefined(self.dsTercProcessos)) {
                    self.dsTercProcessos.clearDataSet();
                }
                if (angular.isDefined(self.dsSubProduto)) {
                    self.dsSubProduto.clearDataSet();
                }
                if (angular.isDefined(self.dsSubProdutoProcessos)) {
                    self.dsSubProdutoProcessos.clearDataSet();
                }
                if (angular.isDefined(self.dsSerieProcessos)) {
                    self.dsSerieProcessos.clearDataSet();
                }
            }                         
            
            function lancarOPs(ignorarWarnings = false) {
                
            	if (MGEParameters.asBoolean("mgepro.ignora.popup.alerta.lancamento.op")) {
            		ignorarWarnings = true;
                }
            	
            	var request = {
                    params: {
                        nulop: self.nulop,
                        ignorarWarnings: ignorarWarnings ? "S" : "N"
                    }
                }                
                 
                ServiceProxy.callService(
                    'mgeprod@LancamentoOrdemProducaoSP.lancarOrdensDeProducao', request
                ).then(function (result) {
                    var ordensIniciadas = result.responseBody.ordensIniciadas;
                    if (angular.isDefined(result.responseBody.mensagens)) {
                        exibirPopupErros(result.responseBody.mensagens);
                    } else {
                        if (ordensIniciadas.quantidade.$ > 0) {
                            var qtdOrdensIniciadas = ordensIniciadas.quantidade.$.toString();
                            clearDatasets();
                            restoreLayout();
                            if (qtdOrdensIniciadas > 1) {
                                if (angular.isDefined(self.onFinished)) {
                                    self.onFinished()(result.responseBody);
                                } else {
                                    SkApplicationInstance.reloadApp(self.resourceID);
                                }
                            } else {
                                if (angular.isDefined(self.onFinished)) {
                                    self.onFinished()(result.responseBody);
                                } else {
                                    SkApplicationInstance.reloadApp(self.resourceID);
                                }
                            }

                        } else {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.labelErroLancamentoOP'));
                        }
                    }
                });                
            }

            function exibirPopupErros(mensagens, isMostraBtnLancarOP = true) {
                var errosList = [];
                if (angular.isDefined(mensagens.erro)) {
                    var erros = mensagens.erro;
                    if (Array.isArray(erros)) {
                        erros.forEach(erro => errosList.push(erro));
                    } else {
                        errosList.push(erros);
                    }
                }

                var alertasList = [];
                if (angular.isDefined(mensagens.alerta)) {
                    var alertas = mensagens.alerta;
                    if (Array.isArray(alertas)) {
                        alertas.forEach(alerta => alertasList.push(alerta));
                    } else {
                        alertasList.push(alertas);
                    }
                }

                _popupErrosInstance = SanPopup.open({
                    title: i18n('Producao.ProcessoProdutivo.titleAlertas'),
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/popupErrosLancamentoOP/popupErrosLancamentoOP.tpl.html',
                    controller: 'popupErrosLancamentoOPController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    showBtnOk: isMostraBtnLancarOP,
                    showBtnCancel: true,
                    showBtnNo: false,
                    ignoreLoading: true,
                    okBtnLabel: i18n("Commons.LancamentoOrdem.labelLancarOrdens"),
                    cancelBtnLabel: isMostraBtnLancarOP ? i18n("Commons.LancamentoOrdem.labelCancelar") : "OK",
                    resolve: {
                        data: {
                            errors: errosList,
                            warnings: alertasList,
                            onConfirm: lancarOPs,
                            ignorarWarnings: true
                        }
                    }
                });
            }            
            
            function changeTamLote(produto, processo, tamLote) {
                if (angular.isDefined(self.erroTamLote) && !self.erroTamLote && !_isPlanejamentProducao) {
                    return alterarAtributoProduto(processo.NULOP, processo.SEQOP, produto.CODPRODPA, produto.CONTROLEPA, "TAMLOTE", tamLote);
                }
            }

            function alterarAtributoProduto(nulop, seqop, codprod, controle, atributo, valor) {
                var request = {
                    params: {
                        nulop: nulop,
                        seqop: seqop,
                        codprod: codprod,
                        controle: controle,
                        atributo: atributo,
                        valor: valor,
                        nuMps: self.dsLancamentos.getFieldValue("NUMPS"),
                        isPrevisaoEntrega: _isPrevisaoEntrega,
                        isItensPorPedido: _isItensPorPedido
                    }
                }
                    return ServiceProxy.callService(
                        "mgeprod@LancamentoOrdemProducaoSP.alterarAtributoProduto",
                        request).then(
                            function (result) {
                                verificaWarnings(result.responseBody);
                                updateContent();
                            }
                        );
            }

            function alterarAtributoSubProduto(nulop, seqop, idefx, seqLSP, atributo, valor) {
                var request = {
                    params: {
                        nulop: nulop,
                        seqop: seqop,
                        idefx: idefx,
                        seqLSP: seqLSP,
                        atributo: atributo,
                        valor: valor
                    }
                }
                return ServiceProxy.callService(
                    "mgeprod@LancamentoOrdemProducaoSP.alterarAtributoSubProduto",
                    request).then(
                        function (result) {
                            verificaWarnings(result.responseBody);
                            updateContent();
                        }
                    );
            }

            function validaLancamento() {

                if (self.dsProcessos.size() == 0) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.warnNenhumaOrdemInformada'));
                    return;
                }

                if(!self.showStepNroSerie) {
                    lancarOPs(false);
                    return;
                }

                validarSeriesPreenchidas().then((results) => {
                    let isValid = true;
                    if(Array.isArray(results)) {
                        results.forEach(valid => {
                            if(!valid.validated) {
                                isValid = false;
                            }
                        });
                    } else {
                        isValid = results.validated;
                    }

                    if(!isValid) {
                        MessageUtils.showError(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgDivergenciaQtdApontadaSerie'));
                        return;
                    }

                    lancarOPs(false);
                });
            }

            async function processPromises(array, fn) {
                let results = [];
                for (let i = 0; i < array.length; i++) {
                    let r = await fn(array[i]);
                    results.push(r);
                }
                return results;
            }

            function validarTamanhoLoteSerie(record) {
                const deferred = $q.defer();
                qtdSeries = 0;

                CrudUtils.find("SerieLancamentoOP", "SERIEPA", {
                    NULOP: self.nulop,
                    SEQOP: record.SEQOP,
                    CODPRODPA: record.CODPROD
                }, false).then(function (results) {

                    if(Array.isArray(results)) {
                        qtdSeries += results?.length || 0;
                    } else if( results?.SERIE ) {
                        qtdSeries += 1;
                    }

                    deferred.resolve({validated: record.TAMLOTE <= qtdSeries});
                }, deferred.reject);

                return deferred.promise;
            }

            function validarSeriesPreenchidas() {
                let deferred = $q.defer();

                const records = [];

                self.dsSerieProcessos.getRecordsAsObjects().forEach((record) => {
                    _codprodSeries.forEach(codProd => {
                        if(codProd === record.CODPROD) {
                            records.push(record);
                        }
                    });
                })

                processPromises(records, validarTamanhoLoteSerie).then((result) => {
                    deferred.resolve(result);
                }, deferred.reject)

                return deferred.promise;
            }

            function verificaWarnings(responseBody) {
                if (angular.isDefined(responseBody.warningMessage)) {
                    var messages = "";
                    if (Array.isArray(responseBody.warningMessage)) {
                        responseBody.warningMessage.forEach(message => {
                            if(angular.isDefined(message.$)){ 
                                messages += message.$ + "\n"; 
                            }
                        })
                    } else {
                        messages = responseBody.warningMessage.$;
                    }

                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, messages);
                }
            }

            function defaultEmptySaveHandler() {
                //método utilizado apenas para o dataset nao apresentar mensagem de edição que nao foi salva
            }

            function validaTamLote(dataset, datagrid, doFinally, isFinishigLancamento = false) {
                var currentRecord = dataset.getCurrentRowAsObject();
                var currentProd = self.dsProdutos.getRecordsAsObjects();

                var nomeCampoTamLote;
                var produto;
                if (dataset.getEntityName() === "ProdutoLancamentoDeOP") {
                    nomeCampoTamLote = "TAMLOTE";
                    produto = dataset.getCurrentRowAsObject();
                } else {
                    nomeCampoTamLote = "TAMLOTE";
                    produto = currentProd.find(prod => prod.CODPRODPA === currentRecord["CODPROD"]);
                }

                if (angular.isDefined(currentRecord) && angular.isDefined(produto)) {
                    var request = {
                        params: {
                            tamLote: currentRecord[nomeCampoTamLote],
                            multiploIdeal: produto.MULTLOTE,
                            minLote: produto.MINLOTE
                        }
                    }

                    var temErro = false;
                    return ServiceProxy.callService('mgeprod@LancamentoOrdemProducaoSP.validarTamanhoLote', request).then(
                        function (result) {
                            var validacao = result.responseBody.validacao;

                            if (validacao) {
                                if ("warnLoteTamanhoMinimo" === validacao) {
                                    self.wizard.previous();
                                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.warnLoteTamanhoMinimo').replace("{MIN}", produto.MINLOTE));
                                } else if ("warnLoteTamanhoMultiplo" === validacao) {
                                    self.wizard.previous();
                                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.warnLoteTamanhoMultiplo').replace("{MULT}", produto.MULTLOTE));
                                }
                                datagrid.endEdit();
                                temErro = true;
                            }
                        }
                    ).finally(function () {
                        self.erroTamLote = temErro;

                        if (temErro) {
                            var oldValue = self.currentProcess.TAMLOTE;

                            if (angular.isUndefined(oldValue)) {
                                oldValue = self.oldTamLote;
                            }

                            self.dsProcessos.setFieldValue("TAMLOTE", oldValue);
                            self.dsProcessos.save();
                        } else if (angular.isDefined(doFinally)) {
                        	if(!isFinishigLancamento && angular.isUndefined(self.dsLancamentos.getFieldValue("NUMPS"))) {
                                changeTamLote(produto, self.dsProcessos.getCurrentRowAsObject(), currentRecord[nomeCampoTamLote]).finally(function () {
                                    doFinally();
                                });
                            } else {
                                doFinally();
                            }
                        }else {
                        	if(!isFinishigLancamento) {
                                changeTamLote(produto, self.dsProcessos.getCurrentRowAsObject(), currentRecord[nomeCampoTamLote]);
                            }
                        }
                    });
                }
            }

            function changeMPAPosition(moveUp) {
                var recordIndex = self.dsListaMPAlternativa.getCurrentIndex();
                var record = self.dsListaMPAlternativa.getCurrentRowAsObject();
                var selectedRecords = self.dsListaMPAlternativa.getSelectedRecords();

                if (recordIndex != -1 && angular.isDefined(record)) {
                    chageIndexRecordsConjuntos(record, recordIndex, moveUp);

                    selectMPAltByControleOrSelected(record.CONJUNTO, selectedRecords, self.dsListaMPAlternativa.getRecordsAsObjects().findIndex(r => r.CODPRODMPALT === record.CODPRODMPALT));
                }
            }

            function chageIndexRecordsConjuntos(recordChange, indexChange, moveUp) {
                var listRecordsConjuntoFirst = [];
                var listRecordsConjuntoNext = [];

                var listaMPLength = self.dsListaMPAlternativa.getRecords().length;

                var nextRecord = {};
                var nextIndex = 0;

                var conjuntoIndex = self.dsListaMPAlternativa.getFieldIndexByName("CONJUNTO");
                if (listaMPLength == 1) {
                    return;
                } else if (moveUp === 1 && indexChange == 0) {
                    return;
                } else if (moveUp === -1 && indexChange == listaMPLength - 1) {
                    return;
                }

                if (moveUp === -1) {
                    nextIndex = indexChange + 1;
                    nextRecord = self.dsListaMPAlternativa.getRecords()[nextIndex];
                } else {
                    nextIndex = indexChange - 1;
                    nextRecord = self.dsListaMPAlternativa.getRecords()[nextIndex];
                }

                if (recordChange.CONJUNTO == nextRecord[conjuntoIndex]) {
                    self.dsListaMPAlternativa = changeMpAlternativaPosition(nextIndex, indexChange, self.dsListaMPAlternativa);
                } else {
                    if (recordChange.CONJUNTO != "") {
                        for (var i = 0; i <= listaMPLength - 1; i++) {
                            var record = self.dsListaMPAlternativa.getRecords()[i];

                            if (record[conjuntoIndex] == recordChange.CONJUNTO) {
                                listRecordsConjuntoFirst.push(record);
                            }
                        }
                    } else {
                        listRecordsConjuntoFirst.push(recordChange);
                    }

                    for (var j = 0; j <= listaMPLength - 1; j++) {
                        var recordConjunto = self.dsListaMPAlternativa.getRecords()[j];

                        if (recordConjunto[conjuntoIndex] == nextRecord[conjuntoIndex]) {
                            listRecordsConjuntoNext.push(recordConjunto);
                        }
                    }

                    var sizeConjuntoFirst = listRecordsConjuntoFirst.length;
                    var sizeConjuntoNext = listRecordsConjuntoNext.length;

                    var newListRecordsChange = [];
                    [].push.apply(newListRecordsChange, self.dsListaMPAlternativa.getRecords());

                    for (var i = 0; i <= listaMPLength - 1; i++) {
                        var newRecord = self.dsListaMPAlternativa.getRecords()[i];
                        var codMpaltIndex = self.dsListaMPAlternativa.getFieldIndexByName("CODPRODMPALT");
                        if (listRecordsConjuntoFirst.find(rec => rec[codMpaltIndex] === newRecord[codMpaltIndex])) {
                            var newIndex = moveUp === 1 ? i - sizeConjuntoNext : i + sizeConjuntoNext;

                            if (newIndex < 0) {
                                newIndex = 0;
                            } else if (newIndex > listaMPLength - 1) {
                                newIndex = listaMPLength - 1;
                            }

                            newListRecordsChange[newIndex] = newRecord;
                        } else if (angular.isDefined(listRecordsConjuntoNext.find(record => record === newRecord))) {
                            var newIndex = moveUp === 1 ? i + sizeConjuntoFirst : i - sizeConjuntoFirst;

                            if (newIndex < 0) {
                                newIndex = 0;
                            } else if (newIndex > listaMPLength - 1) {
                                newIndex = listaMPLength - 1;
                            }

                            newListRecordsChange[newIndex] = newRecord;
                        }
                    }

                    self.dsListaMPAlternativa.clearDataSet();
                    self.dsListaMPAlternativa.addRecords(newListRecordsChange);
                }

                self.btnSaveMpEnabled = true;
            }

            function changeMpAlternativaPosition(nextIndex, indexChange, dataset) {
                var records = dataset.getRecordsAsObjects();
                var aux = records[nextIndex];
                records[nextIndex] = records[indexChange];
                records[indexChange] = aux

                dataset.clearDataSet();
                dataset.addRecordsAsObjects(records);

                return dataset;
            }

            function saveMpAlternativa() {
                var recordsSelected = self.dsListaMPAlternativa.getSelectedRecordsAsObjects().slice();

                var ordem = 0;
				var mpAlternativaMarcada = false;
                _listaMPAlternativa = [];
                self.dsListaMPAlternativa.getRecordsAsObjects().forEach(itemMP => {

                    var mp = {
                        CODPRODMPALT: itemMP.CODPRODMPALT,
                        CONTROLEMPALT: itemMP.CONTROLEMPALT
                    }
                    var checked = itemMP.CHK_SELECTION === "S";
					
					if (checked){
						mpAlternativaMarcada = true;
					}

                    if ((angular.isUndefined(itemMP.QTDUSAR) || itemMP.QTDUSAR == 0) && checked) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Producao.ExtratoMateriais.msgQtdUsarMaiorZero'));
                        return;
                    }
                    mp.QTDUSAR = itemMP.QTDUSAR;
                    mp.SELECIONADO = checked;
                    mp.EDITADO = itemMP.EDITADO;
                    mp.DECQTD = itemMP.DECQTD;
                    mp.NECESSIDADE = itemMP.NECESSIDADE;
                    mp.SEQMPA = itemMP.SEQMPA;

                    ordem++;

                    mp.ORDEM = ordem;
                    _listaMPAlternativa.push(mp);
                });
				
				if (mpAlternativaMarcada > 0 && self.showBtnEditCoProd) {
					MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.labelMsgMatAltProdConjunta'));
				}

                var currentMP = self.dsListaMPs.getFieldValueAsNumberOrZero("CODPRODMP");
                var currentPA = self.dsItemLancamento.getFieldValueAsNumberOrZero("SEQOP");

                var request = {
                    params: {
                        NULOP: self.dsItemLancamento.getFieldValueAsNumberOrZero("NULOP"),
                        SEQOP: self.dsItemLancamento.getFieldValueAsNumberOrZero("SEQOP"),
                        CODPRODPA: self.dsItemLancamento.getFieldValueAsNumberOrZero("CODPRODPA"),
                        CONTROLEPA: self.dsItemLancamento.getFieldValueAsString("CONTROLEPA"),
                        CODPRODMP: self.dsListaMPs.getFieldValueAsNumberOrZero("CODPRODMP"),
                        CONTROLEMP: self.dsListaMPs.getFieldValueAsString("CONTROLEMP"),
                        mps: { mp: _listaMPAlternativa }
                    }
                }

                ServiceProxy.callService('mgeprod@LancamentoOrdemProducaoSP.salvarMaterialAlternativo', request).then(
                    function (result) {
                        montaListaExtratoMateriais(currentMP, currentPA);
                        self.btnSaveMpEnabled = false;
                        if(result.responseBody.recarregarLancamento == "true"){
                        	self.dsProcessos.refresh();
                        }
                    }
                );
            }

            function cancelEditionMpAlternativa() {
                self.dgMPAlternativa.unselectAllSelectedRows();
                self.btnSaveMpEnabled = false;

                if(self.dsListaMPAlternativa.getRecords().length > 0) {
                    self.dsListaMPAlternativa.clearDataSet();
                    self.dsListaMPAlternativa.addRecordsAsObjects(self.restorePointListaMPAlternativa);
                }
                
                if (self.dsListaMPAlternativa.getRecordsAsObjects().find(rec => rec.CHK_SELECTION === "N")) {
                    self.selecionaMps = NAO;
                } else {
					self.selecionaMps = SIM;
				}
                selectMPAlternativa();
            }

            function changeMPAField(id, fieldName, newValue) {
                var records = self.dsListaMPAlternativa.getRecordsAsObjects();
                for (var i = 0; i < records.length; i++) {
                    if (records[i].CODPRODMPALT === id) {
                        records[i][fieldName] = newValue;
                    }
                }

                self.dsListaMPAlternativa.clearDataSet();
                self.dsListaMPAlternativa.addRecordsAsObjects(records);
            }

            function restoreLayout() {
                self.wizard.goToByName(0, { resetCompleted: true });
                self.showWC = false;
                self.showStepParceiro = false;
                self.showDgProcessos = false;
                self.showStepNroSerie = false;
                self.showStepSubproduto = false;
                self.reutilizarLancamento = false;
                self.descrLancamento = "";
                self.reutilizar = false;
                document.getElementById('dgProcessos').style.height = "calc(100vh - 207px)";
            }

            function selectCurrentRecord(dataset) {
                var selectedRecords = [];
                if (angular.isDefined(dataset.getCurrentRow())) {
                    selectedRecords.push(dataset.getCurrentRow());
                    dataset.setSelectedRecords(selectedRecords);
                }
            }

            function clicklSelectAll() {
                if (self.dsListaMPAlternativa.getRecordsAsObjects().find(item => item.CHK_SELECTION === "N")) {
                    var auxRecords = self.dsListaMPAlternativa.getRecordsAsObjects();

                    auxRecords.forEach(rec => {
                        rec.CHK_SELECTION = "S";
                        if (rec.QTDUSAR === 0) {
                            rec.QTDUSAR = rec.NECESSIDADE;
                            rec.EDITADO = "S";
                        }
                    });

                    self.dsListaMPAlternativa.clearDataSet();
                    self.dsListaMPAlternativa.addRecordsAsObjects(auxRecords);

                    self.btnSaveMpEnabled = true;
                } else {
                    var auxRecords = self.dsListaMPAlternativa.getRecordsAsObjects();

                    auxRecords.forEach(rec => {
                        rec.CHK_SELECTION = "N";
                    });

                    self.dsListaMPAlternativa.clearDataSet();
                    self.dsListaMPAlternativa.addRecordsAsObjects(auxRecords);
                    self.btnSaveMpEnabled = true;
                }
            }

            function openInsertOP(nulop = self.nulop) {
                if (angular.isDefined(self.dsProcessos)) {
                    self.btnInsertEnabled = true;
                    var popupInstance = SanPopup.open({
                        title: i18n('Commons.LancamentoOrdem.buttonIncluirOP'),
                        templateUrl: 'commons/lancamentoOrdemProducao/popups/popupInclusaoOP/popupInclusaoOP.tpl.html',
                        controller: 'inclusaoOPController',
                        controllerAs: 'ctrl',
                        size: 'md',
                        cancelBtnLabel: i18n("Geral.lblFechar"),
                        okBtnLabel: i18n("Commons.LancamentoOrdem.buttonIncluirOP"),
                        resolve: {
                            data: {
                                nuLop: nulop,
                                dsProcessos: self.dsProcessos
                            }
                        }
                    })
    
                    popupInstance.result.then(function (response) {
                        self.showStepNroSerie = (self.showStepNroSerie || response.controleSerie);
                        _responsePopupInclusao = response;
                        updateContent();
                    });
                }
            }

            function abrirConfiguracoesEstoque(config) {
                SanPopup.open({
                    title: i18n('Commons.LancamentoOrdem.labelConfigEstoque'),
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/configuracaoEstoque/configuracaoEstoque.tpl.html',
                    controller: 'configuracaoEstoqueController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    showBtnOk: true,
                    okBtnLabel: i18n("Geral.lblSalvar"),
                    resolve: {
                        data: {
                            resourceID: self.resourceID,
                            tipConfig: config
                        }
                    }
                }).result.then(function (result) {
                    self.dsProcessos.refresh();
                });
            }

            function incluiSerie() {
                if (angular.isUndefined(self.nroSerie)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.CentralNotas.messageInformeSerieInicial'));
                    return;
                }

                var request = {
                    entity: []
                };

                var entity = {
                    name: 'SerieLancamentoOP',
                    campo: [
                        { nome: 'SERIEPA', '$': self.nroSerie },
                        { nome: 'SEQOP', '$': self.dsSerieProcessos.getFieldValue("SEQOP") },
                        { nome: 'NULOP', '$': self.nulop },
                        { nome: 'CODPRODPA', '$': self.dsSerieProcessos.getFieldValue("CODPROD") }
                    ]
                };

                request.entity.push(entity);

                ServiceProxy
                    .callService('mge@crud.save', request)
                    .then(function () {
                        self.dsNumeroSerie.refresh();
                        atualizaQuantidades();
                    });
            }

            function gerarSerie() {
                if (angular.isUndefined(self.serieInicial)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Comercial.CentralNotas.messageInformeSerieInicial'));
                    return;
                }

                var params = {
                    SERIE: {
                        $: self.serieInicial,
                        QTDPRODUZIR: self.dsSerieProcessos.getFieldValue("TAMLOTE"),
                        CODPRODPA: self.dsSerieProcessos.getFieldValue("CODPROD"),
                        SEQOP: self.dsSerieProcessos.getFieldValue("SEQOP"),
                        NULOP: self.nulop
                    }
                }

                ServiceProxy.callService(
                    "mgeprod@LancamentoOrdemProducaoSP.geraNroSerie",
                    params).then(
                        function (result) {
                            self.dsNumeroSerie.refresh();
                            atualizaQuantidades();
                        }
                    )
            }

            function configSerie() {
                self.showGerManual = true;
                self.showGerAuto = true;
                self.showGerSerie = false;
                self.showInclSerie = false;
                self.nroSerie = undefined;
                self.serieInicial = undefined;
            }

            function insersaoAutomatica(automatica) {
                if (automatica) {
                    self.showGerManual = false;
                    self.showGerAuto = false;
                    self.showGerSerie = true;
                    self.showInclSerie = false;
                } else {
                    self.showGerManual = false;
                    self.showGerAuto = false;
                    self.showGerSerie = false;
                    self.showInclSerie = true;
                }
            }

            function removeSerie() {
                if (self.dsNumeroSerie.getRecords().length > 0) {
                    if(!SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE)) {
                        MessageUtils.showAlert(i18n('Dataset.msgtitleControleAcesso'), i18n('Dataset.messageNaoPermitidoRemover'));
                        return;
                    }

                    var params = {
                        SERIE: {
                            seriePA: [],
                            CODPRODPA: self.dsSerieProcessos.getFieldValue("CODPROD"),
                            SEQOP: self.dsSerieProcessos.getFieldValue("SEQOP"),
                            NULOP: self.nulop
                        }
                    };

                    var selectedSeries = self.dsNumeroSerie.getSelectedRecordsAsObjects();
                    selectedSeries.forEach(serie => {
                        var seriePA = {
                            SERIEPA: serie.SERIEPA
                        };
                        params.SERIE.seriePA.push(seriePA);

                        if (serie.LIBERADO == 'S') {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Producao.OperacaoProducao.msgValidaRemoverSerieLiberado'));
                            return;
                        }
                    });

                    ServiceProxy.callService(
                        "mgeprod@LancamentoOrdemProducaoSP.excluirNroSerie",
                        params).then(
                            function (result) {
                                self.dsNumeroSerie.refresh();
                                atualizaQuantidades();
                            }
                        );
                }

            }

            function atualizaQuantidades() {
                var qtdProduzido = 0;
                var qtdProduzir = self.dsSerieProcessos.getFieldValueAsNumberOrZero("TAMLOTE");
                self.dsNumeroSerie.getRecordsAsObjects().forEach(obj => {
                    if (StringUtils.emptyAsNull(obj.SERIEPA) != null) {
                        qtdProduzido++;
                    }
                });

                var fontColor;
                if (qtdProduzido < qtdProduzir || qtdProduzido > qtdProduzir) {
                    fontColor = "#FF0000"; //red
                } else if (qtdProduzido == qtdProduzir) {
                    fontColor = "#006400"; //green
                } else {
                    fontColor = "#000000"; //black
                }
                document.getElementById("txtRodape").innerHTML = i18n('Commons.LancamentoOrdem.msgQuantidadeItensComSerie', [qtdProduzir, qtdProduzido, fontColor]);
            }

            function removeSeries(confirmar = true) {
                if(!SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE)) {
                    MessageUtils.showAlert(i18n('Dataset.msgtitleControleAcesso'), i18n('Dataset.messageNaoPermitidoRemover'));
                    return;
                }

                var params = {
                    SERIE: {
                        REMOVE_ALL: 'S',
                        CODPRODPA: self.dsSerieProcessos.getFieldValue("CODPROD"),
                        SEQOP: self.dsSerieProcessos.getFieldValue("SEQOP"),
                        NULOP: self.nulop
                    }
                }

                //self.dsNumeroSerie.removeAll();

                ServiceProxy.callService(
                    "mgeprod@LancamentoOrdemProducaoSP.excluirNroSerie",
                    params).then(
                        function (result) {
                            self.dsNumeroSerie.refresh();
                            atualizaQuantidades();
                        }
                    );
            }

            function removeControle() {
                if(!SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE)) {
                    MessageUtils.showAlert(i18n('Dataset.msgtitleControleAcesso'), i18n('Dataset.messageNaoPermitidoRemover'));
                    return;
                }
                
                var produto = self.dsProdutos.getCurrentRowAsObject();

                if (angular.isDefined(produto)) {
                    var processo = self.dsProcessos.getCurrentRowAsObject();
                    var produtosNoProcesso = self.dsProdutos.getRecordsAsObjects();

                    if (produtosNoProcesso.length > 1) {

                        ServiceProxy.callService(
                            "mgeprod@LancamentoOrdemProducaoSP.removerProduto",
                            { params: { nulop: processo.NULOP, seqop: produto.SEQOP, codprod: produto.CODPRODPA, controle: produto.CONTROLEPA } }).then(
                                function (response) {
                                    updateContent();
                                }
                            );
                    }
                }
            }

            function openEditarControle() {
                var popupInstance = SanPopup.open({
                    title: i18n('Commons.LancamentoOrdem.buttonIncluirOP'),
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/popupEdicaoControle/popupEdicaoControle.tpl.html',
                    controller: 'edicaoControleController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    resolve: {
                        data: {
                            codProd: self.dsProcessos.getCurrentRowAsObject()["CODPROD"],
                            produtos: self.dsProdutos.getRecordsAsObjects(),
                            seqop: self.dsProcessos.getCurrentRowAsObject().SEQOP,
                            nulop: self.nulop,
                            codPlp: self.dsProcessos.getFieldValue("CODPLP")
                        }
                    }
                })

                popupInstance.result.then(function (response) {
                    updateContent()
                });
            }

            function editQtdCoProducao() {
                var popupInstance = SanPopup.open({
                    title: i18n('Commons.LancamentoOrdem.buttonIncluirOP'),
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/popupEdicaoProdConjunta/popupEdicaoProdConjunta.tpl.html',
                    controller: 'edicaoConjuntaController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    resolve: {
                        data: {
                            nuLop: self.nulop,
                            seqCop: self.dsProcessos.getFieldValue("SEQCOP")
                        }
                    }
                })

                popupInstance.result.then(function (response) {
                    updateContent()
                });
            }
            
            function carregarPlanejamento(nulop){
            	_isPlanejamentProducao = true;
            	carregarLancamento(nulop, false, false, false);
            }


            function carregarLancamento(nulop, isUseConfigPI = true, isPrevisaoEntrega = false, isItensPorPedido = false, mensagens = undefined){
				if (!isUseConfigPI) {
					_isCallByMPS = true;
				}

				if (_isCallByMPS) {
					isUseConfigPI = false;
				}

                _isPrevisaoEntrega = isPrevisaoEntrega;
                _isItensPorPedido = isItensPorPedido;
                var isPrevisaoEntregaOuItensPorPedido = (_isPrevisaoEntrega || _isItensPorPedido);

                if (isPrevisaoEntregaOuItensPorPedido) {
                    self.isEditableDataGrids = !isPrevisaoEntregaOuItensPorPedido;
                }

				if (angular.isDefined(mensagens) && isPrevisaoEntregaOuItensPorPedido) {
                    
                    msgAlerta = "";

                    arrayMensagens = [];
                    
                    if (!angular.isArray(mensagens.alerta)) {
                    	arrayMensagens = [mensagens.alerta];
                    }

                    arrayMensagens.forEach(msg => {
                        msgAlerta += msg.$ + "\n";
                    });

                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, msgAlerta);
				}

				if(nulop <= 0){
					openInsertOP()
				} else {
					self.nulop = nulop;

					ServiceProxy.callService(
						"mgeprod@LancamentoOrdemProducaoSP.getLancamentoOP",
						{
                            params: {
                                nulop: nulop,
                                useconfigpi: isUseConfigPI
                            }
                        }).then(
                            function(response) {
                                var valueResult = response.responseBody;
                                if(valueResult != "erroRascunhoLancamento"){
                                    if(self.insertionMode == 'auto') {
                                        self.btnInsertEnabled = false;
                                    }
                                    self.dsLancamentos.refresh();
                                }else{
                                    onCancel();
                                }
                            }
                        );
				}
            }
            
            function verificaUsaCentroTrabalho(arryDados, sequencia) {
				if(arryDados[sequencia] != undefined){
					let seqop = arryDados[sequencia]["SEQOP"];
	                CrudUtils.find("AlocacaoDeWorkCenterLctoOP", "IDAWC", {NULOP: self.nulop, SEQOP: seqop}, false).then(
	                    function(result) {
	                        if(angular.isDefined(result) && result.length > 0) {
	                            self.showWC = true;
	                        } else {
								verificaUsaCentroTrabalho(arryDados, ++sequencia)
							}
	                    }
	                );
                }
            }

            function carregarLancamentoPedidoVenda(objeto) {
                let deferred = $q.defer();

                if (objeto) {
                    let mensagens = { erro: [], alerta: [] };

                    if (angular.isDefined(objeto.NULOP)) {
                        self.nulop = objeto.NULOP;
                    }

                    if (angular.isDefined(objeto.ATENDIDOS) && StringUtils.isNotEmpty(objeto.ATENDIDOS)) {                        
                        let atendidos = objeto.ATENDIDOS.atendido;

                        if (!angular.isArray(atendidos)) {
                            let array = [];
                            array.push(atendidos);
                            atendidos = array;
                        }

                        atendidos.forEach(atendido => mensagens.alerta.push({ $: i18n('Commons.LancamentoOrdem.msgPedidoAtendido', [atendido.$]) }));
                    }

                    if (angular.isDefined(objeto.SEMPROCPRODS) && StringUtils.isNotEmpty(objeto.SEMPROCPRODS)) {
                        let semProcessoProdutos = objeto.SEMPROCPRODS.mensagem;

                        if (!angular.isArray(semProcessoProdutos)) {
                            let array = [];
                            array.push(semProcessoProdutos);
                            semProcessoProdutos = array;
                        }

                        semProcessoProdutos.forEach(mensagem => mensagens.erro.push({ $: Base64.decode(mensagem.$) }));
                    }

                    if (mensagens.erro.length > 0 || mensagens.alerta.length > 0) {
                        exibirPopupErros(mensagens, false);
                    }

                    ServiceProxy.callService(
                        "mgeprod@LancamentoOrdemProducaoSP.getLancamentoOP",
                        {
                            params: {
                                nulop: self.nulop,
                                useconfigpi: true
                            }
                        }).then(function (response) {
                            let valueResult = response.responseBody;
                            if (valueResult != "erroRascunhoLancamento") {
                                if(self.insertionMode == 'auto') {
                                    self.btnInsertEnabled = false;
                                }
                                self.dsLancamentos.refresh();
                            } else {
                                onCancel();
                            }

                            deferred.resolve(response);
                        }, function () {
                            deferred.reject(undefined);
                        });
                } else {
                    deferred.reject(undefined);
                }

                return deferred.promise;
            }

            function openGridConfig() {
                GridConfig.openGridconfig(self.gridProcessosConfig);
            }

            function openGridConfigExtratoMPs() {
                GridConfig.openGridconfig(self.gridListaMPsConfig);
            }

            function abrirPopUpDetalhamentoEntregasMP() {
                SanPopup.open({
                    title: 'Detalhamento de Entregas MP',
                    templateUrl: 'commons/lancamentoOrdemProducao/popups/detalhamentoEntregasMP/popUpDetalhamentoEntregasMP.tpl.html',
                    controller: 'PopUpDetalhamentoEntregasMPController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    showBtnOk: false,
                    resolve: {
                        data: {
                            dsListaMPs : self.dsListaMPs,
                            codPlanta: self.dsItemLancamento.getFieldValueAsNumber("CODPLP")
                        }
                    }
                }).result.then(function (result) {

                });
            }

            function changeReutilizarLancamento() {
                if(self.reutilizar == 'S') {
                    if(self.dsLancamentos && self.dsLancamentos.getCurrentRow()) {
                        self.descrLancamento = self.dsLancamentos.getFieldValueAsString("DESCRICAO");
                    } else {
                        self.descrLancamento = "Novo lançamento - "  + DateUtils.formatDate(new Date(), "DD/MM/YYYY - HH:mm:SS");
                    }
                    novoLancamento()
                } else {
                    if(self.nulop) {
                        ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.editarLancamentoOP",{params: {nulop: self.nulop, descricao: self.descrLancamento, reutilizar: self.reutilizar}}).then(result => {
                            self.descrLancamento = "";
                        });
                    }
                }
            }

            function novoLancamento() {
				if(self.descrLancamento == null || self.descrLancamento == ""){
					MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Producao.OrdemProducao.errInformeUmaDescricao'));
					return;
				}
				
				if(self.nulop == null){
					ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.getNovoLancamentoOP",{params: {descricao: self.descrLancamento, reutilizar: self.reutilizar}});
				} else {
					ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.editarLancamentoOP",{params: {nulop: self.nulop, descricao: self.descrLancamento, reutilizar: self.reutilizar}});
				}
			}

            function salvaLancamento() {
                novoLancamento();
            }

            function descartarLancamentoSalvo() {
                if(!SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE)) {
                    MessageUtils.showAlert(i18n('Dataset.msgtitleControleAcesso'), i18n('Dataset.messageNaoPermitidoRemover'));
                    return;
                }
                
                var confirmMessage = MessageUtils
                        .simpleConfirmBuilder()
                        .title('Dataset.messageTitleExluir');
                confirmMessage.msg('Dataset.messageApagarRegistro');
                confirmMessage
                        .okTheme('danger')
                        .okLabel('Dataset.lblSimDeletar');
                        confirmMessage
                        .show().then(() => {
                            deletarLancamento(self.nulop).finally(() => {
                                resetComponent();
                            });
                        })
            }

            function disableRemoveButton(disable = false) {
                self.disableRemove = disable;
            }
        }
    ]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('configuracaoEstoqueController', ['SkDefaultFilter', 'i18n', '$scope', '$popupInstance', 'data', 'MessageUtils', 'ServiceProxy', 'StringUtils', 'SkApplicationInstance',
   function (SkDefaultFilter, i18n, $scope, $popupInstance, data, MessageUtils, ServiceProxy, StringUtils, SkApplicationInstance) {
      var self = this;
      self.msg = data.popUpContent;
      $scope.$success = onClickConfirm;

      const SIM = "S";
      const NAO = "N";
      const TODAS = "T";
      const DA_PLANTA = "P";
      const DO_GRUPO = "G";
      const LOCAIS_TODOS = "T";
      const LOCAIS_ESPECIFICOS = "E";
      const LOCAIS_LISTA = "L";

      self.isJivaProducao = SkApplicationInstance.temOpcional("20448") || SkApplicationInstance.getAttributeFromHTMLWrapper("producaoFit");

      self.empEstoque;
      self.locais;
      self.listaLocais;
      self.subtrairReserva;
      self.apenasAprovados;
      self.desconsiderarVencido;
      self.openFilterAssistent = openFilterAssistent;
      self.filtroPersonalizado;
      self.resourceID;
      self.locaisEnabled;

      self.showApenasAprovados;
      self.showDesconsiderarVencido;

      self.otherConfigs = {};

      self.onLocaisChange = onLocaisChange;

      self.optionsEmpEstoque = [{
         data: TODAS,
         value: i18n('Commons.LancamentoOrdem.labelTodasAsEmpresas')
      }, {
         data: DA_PLANTA,
         value: i18n('Commons.LancamentoOrdem.labelEmpresaDaPlanta')
      }, {
         data: DO_GRUPO,
         value: i18n('Commons.LancamentoOrdem.labelGrupoDaEmpresaDaPlanta')
      }];

      self.optionsLocais = [{
         data: LOCAIS_TODOS,
         value: i18n('Commons.LancamentoOrdem.labelTodosOsLocais')
      }, {
         data: LOCAIS_ESPECIFICOS,
         value: i18n('Commons.LancamentoOrdem.labelTodosExcetoControleEspecifico')
      }, {
         data: LOCAIS_LISTA,
         value: i18n('Commons.LancamentoOrdem.labelLista')
      }];

      self.optionsNao = [{
         data: '',
         value: i18n('Commons.LancamentoOrdem.labelTodos')
      }, {
         data: SIM,
         value: i18n('Commons.LancamentoOrdem.opcSim')
      }, {
         data: NAO,
         value: i18n('Commons.LancamentoOrdem.opcNao')
      }];

      self.tipConfig = "PA";
      init();

      function init() {
         self.resourceID = data.resourceID;
         self.tipConfig = data.tipConfig;

         self.empEstoque = self.isJivaProducao ? TODAS : DA_PLANTA;
         self.locais = LOCAIS_ESPECIFICOS;
         self.subtrairReserva = NAO;
         self.apenasAprovados = NAO;
         self.desconsiderarVencido = NAO;

         self.locaisEnabled = false;

         if(self.tipConfig === "MP") {
            self.showApenasAprovados = true;
         }

         if(self.tipConfig === "MP") {
            self.showDesconsiderarVencido = true;
         }

         getConfigs();
      }

      function getConfigs() {
         ServiceProxy.callService('mgeprod@LancamentoOrdemProducaoSP.getConfiguracoesEstoque', {})
            .then(function (result) {
               var config = result.responseBody.config;

               if (config) {
                  if (self.tipConfig === "PA") {
                     self.listaEmpresas = config.lista_empresas_pa;
                     self.empEstoque = self.isJivaProducao ? TODAS : config.emp_estoque_pa;
                     self.locais = config.locais_pa;
                     self.subtrairReserva = config.subtrair_reserva_pa;
                     if (config.locais_pa === LOCAIS_LISTA) {
                        self.listaLocais = config.lista_locais_pa;
                        self.locaisEnabled = true;
                     }
                     self.filtroPersonalizado = config.filtro_estoque_pa && angular.isDefined(config.filtro_estoque_pa.$) ? config.filtro_estoque_pa.$ : "";
   
                     self.otherConfigs.lista_empresas_mp = config.lista_empresas_mp;
                     self.otherConfigs.emp_estoque_mp = config.emp_estoque_mp;
                     self.otherConfigs.locais_mp = config.locais_mp;
                     self.otherConfigs.subtrair_reserva_mp = config.subtrair_reserva_mp;
                     self.otherConfigs.apenas_lotes_aprovados_mp = config.apenas_lotes_aprovados_mp;
                     self.otherConfigs.desconsiderar_vencidos_mp = config.desconsiderar_vencidos_mp;
                     self.otherConfigs.filtro_estoque_mp = config.filtro_estoque_mp;
                     if(config.lista_locais_mp) {
                        self.otherConfigs.lista_locais_mp = config.lista_locais_mp;
                     }
                  } else {
                     self.listaEmpresas = config.lista_empresas_mp;
                     self.empEstoque = self.isJivaProducao ? TODAS : config.emp_estoque_mp;
                     self.locais = config.locais_mp;
                     self.subtrairReserva = config.subtrair_reserva_mp;
                     self.apenasAprovados = config.apenas_lotes_aprovados_mp;
                     self.desconsiderarVencido = config.desconsiderar_vencidos_mp;
                     if (config.locais_mp === LOCAIS_LISTA) {
                        self.listaLocais = config.lista_locais_mp;
                        self.locaisEnabled = true;
                     }
                     self.filtroPersonalizado = config.filtro_estoque_mp && angular.isDefined(config.filtro_estoque_mp.$) ? config.filtro_estoque_mp.$ : "";
   
                     self.otherConfigs.lista_empresas_pa = config.lista_empresas_pa;
                     self.otherConfigs.emp_estoque_pa = config.emp_estoque_pa;
                     self.otherConfigs.locais_pa = config.locais_pa;
                     self.otherConfigs.subtrair_reserva_pa = config.subtrair_reserva_pa;
                     self.otherConfigs.filtro_estoque_pa = config.filtro_estoque_pa;
                     if(config.lista_locais_pa) {
                        self.otherConfigs.lista_locais_pa = config.lista_locais_pa;
                     }
                  }
               }
            });
      }

      function onClickConfirm() {
         salvarConfigs();

         $popupInstance.success({
            resposta: 'Sua resposta'
         });
      }

      function salvarConfigs() {
         if (angular.isDefined(self.filtroPersonalizado) && self.filtroPersonalizado.indexOf("?") != -1) {
            MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.LancamentoOrdem.filtroNaoPodeConterVariaveis'));
            return;
         }

         if (self.locais === LOCAIS_LISTA && self.listaLocais === "") {
            MessageUtils.showAlert(MessageUtils.TITLE_WARNING,
               i18n('Commons.LancamentoOrdem.informarValorLista'));
         }

         var request = getRequestBody();

         ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.salvarConfiguracoesEstoque", request).then(
            function (result) {
            }
         )
      }

      function getRequestBody() {
         var request = {};
         if (self.tipConfig == "PA") {
            request = {
               config: {
                  lista_empresas_pa: StringUtils.isEmpty(self.listaEmpresas) ? "" : self.listaEmpresas,
                  lista_empresas_mp: StringUtils.isEmpty(self.otherConfigs.lista_empresas_mp) ? "" : self.otherConfigs.lista_empresas_mp,
                  emp_estoque_pa: StringUtils.isEmpty(self.empEstoque) ? TODAS : self.empEstoque,
                  locais_pa: StringUtils.isEmpty(self.locais) ? TODAS : self.locais,
                  lista_locais_pa: StringUtils.isEmpty(self.listaLocais) ? "" : self.listaLocais,
                  subtrair_reserva_pa: StringUtils.isEmpty(self.subtrairReserva) ? SIM : self.subtrairReserva,
                  emp_estoque_mp: StringUtils.isEmpty(self.otherConfigs.emp_estoque_mp) ? TODAS : self.otherConfigs.emp_estoque_mp,
                  locais_mp: StringUtils.isEmpty(self.otherConfigs.locais_mp) ? TODAS : self.otherConfigs.locais_mp,
                  lista_locais_mp: StringUtils.isEmpty(self.otherConfigs.lista_locais_mp) ? "" : self.otherConfigs.lista_locais_mp,
                  subtrair_reserva_mp: StringUtils.isEmpty(self.otherConfigs.subtrair_reserva_mp) ? SIM : self.otherConfigs.subtrair_reserva_mp,
                  apenas_lotes_aprovados_mp: StringUtils.isEmpty(self.otherConfigs.apenas_lotes_aprovados_mp) ? SIM : self.otherConfigs.apenas_lotes_aprovados_mp,
                  desconsiderar_vencidos_mp: StringUtils.isEmpty(self.otherConfigs.desconsiderar_vencidos_mp) ? NAO : self.otherConfigs.desconsiderar_vencidos_mp,
                  filtro_estoque_mp:  angular.isUndefined(self.otherConfigs.filtro_estoque_mp) ? { $:  ""} : self.otherConfigs.filtro_estoque_mp,
                  filtro_estoque_pa: { $: angular.isUndefined(self.filtroPersonalizado) ? "" : self.filtroPersonalizado}
               },
            }
         } else {
            request = {
               config: {
                  lista_empresas_mp: StringUtils.isEmpty(self.listaEmpresas) ? "" : self.listaEmpresas,
                  lista_empresas_pa: StringUtils.isEmpty(self.otherConfigs.lista_empresas_pa) ? "" : self.otherConfigs.lista_empresas_pa,
                  emp_estoque_mp: StringUtils.isEmpty(self.empEstoque) ? TODAS : self.empEstoque,
                  locais_mp: StringUtils.isEmpty(self.locais) ? TODAS : self.locais,
                  lista_locais_mp: StringUtils.isEmpty(self.listaLocais) ? "" : self.listaLocais,
                  subtrair_reserva_mp: StringUtils.isEmpty(self.subtrairReserva) ? SIM : self.subtrairReserva,
                  apenas_lotes_aprovados_mp: StringUtils.isEmpty(self.apenasAprovados) ? SIM : self.apenasAprovados,
                  desconsiderar_vencidos_mp: StringUtils.isEmpty(self.desconsiderarVencido) ? NAO : self.desconsiderarVencido,
                  emp_estoque_pa: StringUtils.isEmpty(self.otherConfigs.emp_estoque_pa) ? TODAS : self.otherConfigs.emp_estoque_pa,
                  locais_pa: StringUtils.isEmpty(self.otherConfigs.locais_pa) ? TODAS : self.otherConfigs.locais_pa,
                  lista_locais_pa: StringUtils.isEmpty(self.otherConfigs.lista_locais_pa) ? "" : self.otherConfigs.lista_locais_pa,
                  subtrair_reserva_pa: StringUtils.isEmpty(self.otherConfigs.subtrair_reserva_pa) ? SIM : self.otherConfigs.subtrair_reserva_pa,
                  filtro_estoque_pa:  angular.isUndefined(self.otherConfigs.filtro_estoque_pa) ? { $:  ""} : self.otherConfigs.filtro_estoque_pa,
                  filtro_estoque_mp: { $: angular.isUndefined(self.filtroPersonalizado) ? "" : self.filtroPersonalizado}
               },
            }
         }


         return request;
      }

      function openFilterAssistent() {
         var defaultFilterAssistent = {
            dirty: true,
            mode: "edit",
            newItem: true,
            filterModel: {
               assistent: {},
               expression: { $: self.filtroPersonalizado }
            }
         }

         var defaultFilterPF;

         var entityName = "Estoque";

         var defaultFilter = SkDefaultFilter.open(entityName, self.resourceID, defaultFilterAssistent, defaultFilterPF);

         defaultFilter.then(function (result) {
            if (!result) {
               return;
            }

            if (result.expression) {
               self.filtroPersonalizado = result.expression;
            }

         }, function (result) { });
      }

      function onLocaisChange() {
         if (self.locais === LOCAIS_LISTA) {
            self.locaisEnabled = true;
         } else {
            self.locaisEnabled = false;
            self.listaLocais = "";
         }
      }
   }
]);
angular
    .module('snk.commons.lancamentoOrdemProducao')
    .controller('PopUpDetalhamentoEntregasMPController', ['$popupInstance', 'data', '$scope', 'ObjectUtils', 'SkApplicationInstance', 'StringUtils', 'ServiceProxy', function ($popupInstance, data, $scope, ObjectUtils, SkApplicationInstance, StringUtils, ServiceProxy) {
        var self = this;
        self.gridConfig = SkApplicationInstance.getResourceID() + "gridDetalhamentoEntrega";

        ObjectUtils.implements(self, IDatagridInterceptor);
        ObjectUtils.implements(self, IDataSetObserver);
        ObjectUtils.implements(self, IFormInterceptor);

        self.onDatasetCreated = onDatasetCreated;
        self.onDatagridLoaded = onDatagridLoaded;
        self.cancel = cancel;

        init();

        function init() {
            self.codPlanta = data.codPlanta;
            self.dsListaMPs = data.dsListaMPs;
            if (StringUtils.isNotEmpty(self.dsListaMPs) && self.dsListaMPs.size() > 0) {
                self.materiaPrima = self.dsListaMPs.getFieldValueAsString("CODPRODMP") + ' - ' + self.dsListaMPs.getFieldValueAsString("DESCRMP");
                self.dsListaMPs.addLineChangeListener(function (line) {
                    if (line > -1) {
                        getDetalhamentoEntregas();
                    } else {
                        self.dsDetalhamentoEntregas.clearDataSet();
                    }
                });

                self.dsListaMPs.addRefreshedListener(function () {
                    getDetalhamentoEntregas();
                });

            } else {
                cancel();
            }
        }

        function cancel() {
            $popupInstance.close();
        }

        function onDatasetCreated(dataset) {
            self.dsDetalhamentoEntregas = dataset;
            self.dsDetalhamentoEntregas.init().then(function () {
                getDetalhamentoEntregas();
            });
        }
    
        function onDatagridLoaded(datagrid) {
            self.dgDetalhamentoEntregas = datagrid;
        }

        function getDetalhamentoEntregas() {
            if (angular.isDefined(self.dsDetalhamentoEntregas)) {
                self.dsDetalhamentoEntregas.clearDataSet();
            }
            
            var request = {
                params: {
                    codPlanta: self.codPlanta,
                    codProdMP: self.dsListaMPs.getFieldValueAsString("CODPRODMP"),
                    controleMP: self.dsListaMPs.getFieldValueAsString("CONTROLEMP")
                }
            }

            ServiceProxy.callService('mgeprod@LancamentoOrdemProducaoSP.getDetalhamentoEntregasPedidosCompraMP', request)
                .then(function (result) {
                    var listaDetalhamentoEntregas = ObjectUtils.getProperty(result, "responseBody.detalhamentoEntregas.record");

                    if (StringUtils.isNotEmpty(listaDetalhamentoEntregas)) {
                        if (!angular.isArray(listaDetalhamentoEntregas)) {
                            listaDetalhamentoEntregas = [listaDetalhamentoEntregas];
                        }

                        var array = [];
                        listaDetalhamentoEntregas.forEach(function (record) {
                            array.push(getPrevisaoEntregaMP(record));
                        });

                        if (array.length > 0) {
                            self.dsDetalhamentoEntregas.addRecordsAsObjects(array);
                        }
                    }
                });
        }

        function getPrevisaoEntregaMP(record) {
            return {
                CODPRODMP: record.CODPRODMP,
                DESCRMP: record.DESCRMP,
                DTPREV: record.DTPREV,
                QTD: record.QTD,
                NUNOTA: record.NUNOTA
            }
        }

    }]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('popupDependenciasController', ['NumberUtils', 'ObjectUtils', '$scope', '$popupInstance', 'data', 'ServiceProxy',
   function (NumberUtils, ObjectUtils, $scope, $popupInstance, data, ServiceProxy) {
      var self = this;
      ObjectUtils.implements(self, IDatagridInterceptor);

      self.msg = data.popUpContent;
      $scope.$success = onClickConfirm;
      self.dsDependencias;
      self.dsProcessos;
      self.resourceID;
      self.gridDependenciasConfig;
      self.removerDependencia = removerDependencia;
      self.interceptCellRenderer = interceptCellRenderer;

      init();

      function init() {
         self.dsDependencias = data.dsDependencias;
         self.dsProcessos = data.dsProcessos;
         $scope = data.$scope;
         self.dsDependencias.initAndRefresh();
         self.resourceID = data.resourceID
         self.gridDependenciasConfig = self.resourceID + '.GridDependencias';
         self.precCols = data.precCols;
         self.getPrecision = data.getPrecision;
      }

      function onClickConfirm() {
         $popupInstance.success({
            resposta: 'Sua resposta'
         });
      }

      function removerDependencia() {
         var dependencia = self.dsDependencias.getCurrentRowAsObject();
         var processo = self.dsProcessos.getCurrentRowAsObject();

         var request = {
            params: {
               nulop: data.nulop,
               seqop: processo.SEQOP,
               codprodpa: dependencia.CODPRODPA,
               controlepa: dependencia.CONTROLEPA,
               seqoppi: dependencia.SEQOPPI,
               codprodpi: dependencia.CODPRODPI,
               controlepi: dependencia.CONTROLEPI
            }
         };

         ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.removerDependencia", request)
            .then(function (result) {
               self.dsProcessos.refresh();
               self.dsDependencias.refresh();
            });
      }

      function interceptCellRenderer(cell, value, eGridCell, data) {
         if (self.precCols.indexOf(cell.colId) != -1 && !cell.colDef.editable) {//NAO PODE SER APLICADA A CAMPOS EDITÁVEIS
            var element = document.createElement("span");
            var text = document.createTextNode((NumberUtils.format(value, self.getPrecision(data.gridItem.Produto.DECQTD))));
            element.appendChild(text);

            return {
               element: element,
               align: "flex-end"
            }
         }
      }
   }
]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('edicaoControleController', ['$scope', '$popupInstance', 'data', 'ObjectUtils', 'i18n', 'ServiceProxy', 'AngularUtil', 'StringUtils', 'SkWorkspace', 'CrudUtils', 'MessageUtils', 'MGEParameters', 'TooltipBuilder', 'Criteria',
    function ($scope, $popupInstance, data, ObjectUtils, i18n, ServiceProxy, AngularUtil, StringUtils, SkWorkspace, CrudUtils, MessageUtils, MGEParameters, TooltipBuilder, Criteria) {
        var self = this;
        $scope.$success = onClickConfirm;

        self.labelListControle;
        self.optionsControle = [];
        self.controlesSelecionados;

        init();

        function init() {
            self.codProd = data.codProd;
            self.produtos = data.produtos;
            self.seqop = data.seqop;
            self.nulop = data.nulop;
            self.codPlp = data.codPlp;
            selecionaControle();
        }

        function onClickConfirm() {
            inserirProdutoEmProcessoExistente().finally(function () {
                $popupInstance.success({
                    controleSerie: false
                });
            });
        }

        function selecionaControle() {
            CrudUtils.find("Produto", "TIPCONTEST,LISCONTEST,TITCONTEST", { CODPROD: self.codProd }, true).then(
                function (result) {
                    var produto = result;

                    if (produto) {
                        tipo = produto.TIPCONTEST;
                        opcoes = produto.LISCONTEST;

                        self.labelListControle = produto.TITCONTEST;

                        if (opcoes) {
                            opcoes = StringUtils.replaceAll(opcoes, "${nl}", "\n")
                            opcoes = opcoes.replace("/\r/g", "");
                            var arrayControles = [];

                            if (opcoes.indexOf("\n") != -1) {
                                opcoes.split("\n").forEach(opc => {
                                    if (!self.produtos.find(prod => prod.CONTROLEPA === opc)) {
                                        arrayControles.push({
                                            data: opc,
                                            value: opc,
                                            checked: false
                                        });
                                    }

                                })
                            } else {
                                if (!self.produtos.find(prod => prod.CONTROLEPA === opc)) {
                                    arrayControles.push({
                                        data: opcoes,
                                        value: opcoes,
                                        checked: false
                                    });
                                }
                            }
                            self.optionsControle = arrayControles;

                        }
                    }
                }
            )
        }

        function inserirProdutoEmProcessoExistente(){
            var controlesSelecionados = [];
            self.optionsControle.forEach(cont => {
                if(cont.checked) {
                    controlesSelecionados.push(cont.value);
                }
            } );
            
            if(controlesSelecionados == null){
                controlesSelecionados = [" "];
            }

            var controles = [];
            for(var i = 0; i < controlesSelecionados.length; i++){
                if(controlesSelecionados[i] != null){
                    controles.push({ controle: controlesSelecionados[i]})
                }
            }

            var params = {
                params: {
                    nulop: self.nulop,
                    seqop: self.seqop,
                    codprod: self.codProd,
                    opDesmonte:"N",
                    opReparo: "N",
                    codplp: angular.isDefined(self.codPlp)? self.codPlp : 0,
                    controle: controles
                }
            }
            
            
            
            return ServiceProxy.callService(
                "mgeprod@LancamentoOrdemProducaoSP.inserirProduto",
                params).then(
                    function(response){
                    }
                );
        }
        

    }
]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('edicaoConjuntaController', ['$scope', '$popupInstance', 'data', 'ObjectUtils', 'i18n', 'ServiceProxy', 'AngularUtil', 'StringUtils', 'SkWorkspace', 'CrudUtils', 'MessageUtils', 'MGEParameters', 'TooltipBuilder', 'Criteria',
    function ($scope, $popupInstance, data, ObjectUtils, i18n, ServiceProxy, AngularUtil, StringUtils, SkWorkspace, CrudUtils, MessageUtils, MGEParameters, TooltipBuilder, Criteria) {
        var self = this;
        $scope.$success = onClickConfirm;

        self.idCop;
        self.codProdMP;
        self.controleMpCompart;
        self.qtdProcess;
        self.codVol;
        self.qtdProcessPadrao;
        self.codVolPadrao;
        self.seqCop;
        self.nuLop;
        self.isProporcionaliza;

        self.showControleMpComp;

        self.setInfoCoProduto = setInfoCoProduto;

        self.criteriaUnidade = criteriaUnidade;

        init();

        function init() {
            self.seqCop = data.seqCop;
            self.nuLop = data.nuLop;
            self.isProporcionaliza = "S";
            setInfoCoProduto();
        }

        function onClickConfirm() {
            alterarCoProducao().finally(
                function () {
                    $popupInstance.success({
                    });
                }
            )

        }

        function criteriaUnidade() {
            var criteria = Criteria();

            expression = "this.CODVOL IN (SELECT VOA.CODVOL FROM TGFVOA VOA WHERE VOA.CODPROD = ?";
            expression += "				   UNION ";
            expression += "				  SELECT PRO.CODVOL FROM TGFVOL VOL INNER JOIN TGFPRO PRO ON (PRO.CODVOL = VOL.CODVOL) WHERE PRO.CODPROD = ?)";

            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProdMP));
            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProdMP));
            criteria.append(expression);

            return criteria;
        }

        function setInfoCoProduto(isFirstLoad = true) {
            var codVol = ' ';
            var descrVol = ' ';


            var params = {
                params: {
                    nuLop: self.nuLop,
                    idCop: 0,
                    unidade: codVol,
                    descrUnidade: descrVol,
                    qtdProcess: angular.isUndefined(self.qtdProcess) || self.qtdProcess === "" ? 0 : self.qtdProcess,
                    seqCop: self.seqCop,
                    isFirstLoad: isFirstLoad
                }
            }

            ServiceProxy.callService(
                "mgeprod@LancamentoOrdemProducaoSP.getInfoGrupoCoProduto",
                params).then(function (response) {

                    var coProduto = response.responseBody.coProduto.infoCoProduto;

                    if (angular.isDefined(coProduto)) {
                        self.qtdProcess = coProduto.QTDPROCESS;
                        self.codVol = coProduto.CODVOL;
                        self.descrVol = coProduto.DESCRVOL;
                        self.codVolPadrao = coProduto.CODVOL_PADRAO;
                        self.descrVolPadrao = coProduto.DESCRVOL_PADRAO;
                        self.decQtd = coProduto.DECQTD;
                        self.codProdMP = coProduto.CODPRODMP;

                        if (StringUtils.isNotEmpty(coProduto.CONTROLEMP)) {
                            self.showControleMpComp = true;
                            self.controleMpCompart = coProduto.CONTROLEMP;
                        }

                        self.idCop = coProduto.IDCOP;

                        self.qtdProcessPadrao = coProduto.QTDPROCESS_PADRAO;
                    }
                });
        }

        function alterarCoProducao() {
            var params = {
                params: {
                    nulop: self.nuLop,
                    seqCop: self.seqCop,
                    qtdConsumida: self.qtdProcess,
                    isProporcionaliza: self.isProporcionaliza === "S"
                }
            };

            return ServiceProxy.callService(
                "mgeprod@LancamentoOrdemProducaoSP.alterarCoProducao",
                params)
        }

    }
]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('popupErrosLancamentoOPController', ['$scope', '$popupInstance', 'data', 'ObjectUtils', 'i18n',
   function ($scope, $popupInstance, data, ObjectUtils, i18n) {
      var self = this;
      $scope.$success = onClickConfirm;
      $scope.$dismiss = onDismiss;

      ObjectUtils.implements(self, IDatagridInterceptor);
      ObjectUtils.implements(self, IDataSetObserver);
      ObjectUtils.implements(self, IFormInterceptor);

      $scope.onDatasetErros = onDatasetErros;
      $scope.dsErro;
      self.descricao;
      self.lineChange = lineChange;
      self.interceptColumnMetadata = interceptColumnMetadata;
      self.cellFormatterTipo = cellFormatterTipo;

      const ERRO = "E";
      const WARNING = "A";

      function onClickConfirm() {
         if (angular.isDefined(data.onConfirm)) {
            if (angular.isDefined(data.ignorarWarnings)) {
               data.onConfirm(data.ignorarWarnings);
            } else {
               data.onConfirm();
            }
         }
         $popupInstance.success({
            resposta: 'Sua resposta'
         });
      }
      
      function onDismiss() {
          if (angular.isDefined(data.onDismiss)) {
        	  data.onDismiss();
          }
          $popupInstance.dismiss({
             resposta: 'Sua resposta'
          });
       }

      function onDatasetErros(dataset) {
         $scope.dsErro = dataset;
         $scope.dsErro.init();
         updateDataset();
         $scope.dsErro.addLineChangeListener(lineChange);
      }

      function updateDataset() {
         var content = [];
         if (angular.isDefined(data.errors)) {
            data.errors.forEach(error => {
               content.push({
                  tipo: { $: ERRO },
                  descricao: error
               })
            })
         }

         if (angular.isDefined(data.warnings)) {
            data.warnings.forEach(warning => {
               content.push({
                  tipo: { $: WARNING },
                  descricao: warning
               })
            })
         }

         $scope.dsErro.whenMetadataLoaded().then(function () {
            $scope.dsErro.addRecordsAsObjects(content, function (value) {
               return value === undefined ? null : value.$;
            });
            $scope.dsErro.gotoRow(0);
         });
      }

      function lineChange() {
         if (angular.isDefined($scope.dsErro.getFieldValue('descricao'))) {
            self.descricao = $scope.dsErro.getFieldValue('descricao');
         } else {
            self.descricao = '';
         }
      }

      function interceptColumnMetadata(fieldMd) {
         fieldMd.enableSorting = true;
         if (angular.isDefined(fieldMd)) {
            if (fieldMd.name == 'descricao') {
               fieldMd.width = 645;
            }
         }
         return fieldMd;
      }

      function cellFormatterTipo(col, value, row) {
         if (angular.isDefined(value)) {
            if (col.colId == "tipo") {
               if (ERRO === value) {
                  return '<div class="datagrid-tipo-cell-erro"></div>' + i18n('Commons.LancamentoOrdem.tooltipErro');
               } else {
                  return '<div class="datagrid-tipo-cell-warning"></div>' + i18n('Commons.LancamentoOrdem.tooltipAlerta');
               }
            } else {
               return value;
            }
         }
      }

   }
]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('inclusaoOPController', ['$scope', '$popupInstance', 'data', 'ArrayUtils', 'ObjectUtils', 'i18n', 'ServiceProxy', 'AngularUtil', 'StringUtils', 'SkWorkspace', 'CrudUtils', 'MessageUtils', 'MGEParameters', 'TooltipBuilder', 'Criteria',
    function ($scope, $popupInstance, data, ArrayUtils, ObjectUtils, i18n, ServiceProxy, AngularUtil, StringUtils, SkWorkspace, CrudUtils, MessageUtils, MGEParameters, TooltipBuilder, Criteria) {
        var self = this;
        $scope.$success = onClickConfirm;

        //PRIVATE-VAR
        var _lancarOpVersaoAnterior = false;

        //CONST
        const LISTA = "S";
        const SERIE = "E";
        const SIM = "S";
        const NAO = "N";
        const MANUAL = "MN";
        const OP_PRODUCAO = "P";
        const OP_DESMONTE = "D";
        const OP_REPARO = "R";
        const OP_PRODUCAO_CONJUNTA = "PC";

        self.optionsTipOP = [{
            data: OP_PRODUCAO,
            value: i18n('Commons.LancamentoOrdem.labelTipoOrdemProducao')
        }, {
            data: OP_DESMONTE,
            value: i18n('Commons.LancamentoOrdem.labelTipoOrdemDesmonte')
        }, {
            data: OP_REPARO,
            value: i18n('Commons.LancamentoOrdem.labelTipoReparo')
        }]

        self.optionsNao = [{
            data: '',
            value: i18n('Commons.LancamentoOrdem.labelTodos')
        }, {
            data: SIM,
            value: i18n('Commons.LancamentoOrdem.opcSim')
        }, {
            data: NAO,
            value: i18n('Commons.LancamentoOrdem.opcNao')
        }];

        self.nulop;
        self.producaoParaTerc = NAO;
        self.valueTipOP;
        self.codPlanta = getAttributeFromHTMLWrapper("producaoFit") ? 0 : null;
        self.codProd;
        self.producaoParaTerc = NAO;
        self.usaTerc = NAO;
        self.codParc;
        self.nroPedido;
        self.codProcesso;
        self.idProcesso;
        self.tamLote;
        self.nroLote;
        self.oldTamLote;
        self.versaoProcesso;
        self.controlePA;
        self.multIdeal;
        self.lancarMesmaOp;
        self.idCop;
        self.qtdProcess;
        self.codVol;
        self.controleMpCompart;
        self.showControleMpComp;
        self.qtdProcessPadrao;

        self.showParceiro;
        self.showSelecionarControle;
        self.showControlesMesmaOP;
        self.showPesqPlanta;
        self.showPesqCop;
        self.showPesqProd;
        self.optionsControle = [];
        self.labelListControle;
        self.controleSerie = false;
        self.showRepropQtd = false;
        self.fieldTamLoteEnabled = true;
        self.fieldNroLoteEnabled = true;
        self.controlesSelecionados = [];
        self.codPrc;

        self.onTerceiroChange = onTerceiroChange;
        self.onParceiroChange = onParceiroChange;
        self.onProdutoChange = onProdutoChange;
        self.getPrecision = getPrecision;
        self.onProcessoChange = onProcessoChange;
        self.onTipoOpChange = onTipoOpChange;
        self.toggleTooltip = toggleHelptip;
        self.changeMesmaOP = changeMesmaOP;

        self.criteriaProcesso = criteriaProcesso;
        self.criteriaPedido = criteriaPedido;
        self.criteriaSeq = criteriaSeq;
        self.criteriaProduto = criteriaProduto;
        self.criteriaUnidade = criteriaUnidade;

        self.grupoCoProdutoChange = grupoCoProdutoChange;
        self.setInfoCoProduto = setInfoCoProduto;

        _nroLoteEnabledAux = true;

        self.dsProcessos;

        self.onControleChange = onControleChange;
		self.loadedLastVersion = false;
	
        init();

        function init() {
            self.dsProcessos = data.dsProcessos;
            self.nulop = data.nuLop;
            self.showParceiro = false;
            self.showSequencia = false;
            self.showPesqCop = false;
            self.showPesqProd = true;
            self.valueTipOP = OP_PRODUCAO;

            if ((isSankhyaW()  || temOpcional("20511")) && !getAttributeFromHTMLWrapper("producaoFit")) {
                self.showPesqPlanta = true;
                self.optionsTipOP.push({
                    data: OP_PRODUCAO_CONJUNTA,
                    value: i18n('Producao.GrupoCoProduto.labelProducaoConjunta')
                })
            }

            _lancarOpVersaoAnterior = MGEParameters.asBoolean("prod.lancar.op.versao.anterior");

        }

        function onClickConfirm() {
            if (self.valueTipOP === OP_PRODUCAO_CONJUNTA) {
                incluirCoProducao();
                $popupInstance.success({
                    codProdMPCompartilhada: self.codProdMP
                });
            } else {
                if (incluirOP()) {
                    if (self.controleSerie) {
                        var criteria = Criteria();
                        criteria.append("this.CODPRODPA = ? AND this.CONTROLEPA = ? AND this.IDPROC = ?");
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProd));
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, angular.isDefined(self.controaPA) ? self.controlePA : " "));
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.idProcesso));

                        CrudUtils.find("ProdutoAcabado", "TIPOGERASERIE", {
                            CODPRODPA: self.codProd,
                            IDPROC: self.idProcesso
                        }, true).then(function (result) {
                            var tipControleLista = result.TIPOGERASERIE === "L";
                            $popupInstance.success({
                                controleSerie: tipControleLista
                            });
                        })
                    } else {
                        $popupInstance.success({
                            controleSerie: false
                        });
                    }

                }
            }
        }

        function onTerceiroChange() {

            if (self.producaoParaTerc === SIM) {
                self.showParceiro = true;
            } else {
                disableParc();
            }

            var change = changeProduto(undefined);
            if (angular.isDefined(change)) {
                change.catch(function (error) {
                    disableParc();
                });
            }
        }

        function disableParc() {
            self.showParceiro = false;
            self.producaoParaTerc = NAO;
            self.codParc = undefined;
        }

        function onParceiroChange(item) {
            if (angular.isDefined(item)) {
                changeProduto(undefined);
            }
        }

        function onProdutoChange(item) {
            var change = changeProduto(item);
            self.nroPedido = undefined;

            if (angular.isDefined(change)) {
                change.catch(function (error) {
                    clearFormulary(true);
                });
            }
        }

        function changeProduto(item) {
            if (angular.isDefined(self.codProd)) {
                var controle = " ";
                self.optionsControle = [];

                if (angular.isDefined(item)) {
                    if ((isSankhyaW() && !getAttributeFromHTMLWrapper("producaoFit")) || temOpcional("20511")) {
                        if (item.fields.TIPCONTEST === LISTA) {
                            self.showSelecionarControle = true;
                            self.showControlesMesmaOP = true;
                            selecionaControle();
                        } else {
                            self.controleSerie = item.fields.TIPCONTEST === SERIE;
                            self.showSelecionarControle = false;
                            self.showControlesMesmaOP = false;
                        }
                    } else {
                        self.showSelecionarControle = false;
                        self.showControlesMesmaOP = false;
                        if ([LISTA, SERIE].indexOf(item.fields.TIPCONTEST) != -1) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.impossivelControleLista'));
                            clearFormulary();
                            return;
                        } else {
                            if (item.fields.TIPCONTEST === NAO) {
                                controle = " ";
                            } else {
                                controle = StringUtils.isNotEmpty(item.fields.LISCONTEST) ? item.fields.LISCONTEST : " ";
                            }
                        }
                    }
                }

                if (!self.showSelecionarControle) {
                    var request = {
                        params: {
                            codprod: self.codProd,
                            nulop: self.nulop,
                            tipop: self.valueTipOP,
                            producaoParaTerc: self.producaoParaTerc,
                            controle: controle,
                            codplp: angular.isDefined(self.codPlanta) && (!isJivaW() || temOpcional("20511")) ? self.codPlanta : 0
                        }
                    };
    
                    return getProcessoProdutivoParaProduto(request);
                }
            } else {
                clearFormulary(true);
            }
        }

        function onControleChange() {
            if (self.showSelecionarControle && self.controlesSelecionados.length > 0) {                
                var request = {
                    params: {
                        codprod: self.codProd,
                        nulop: self.nulop,
                        tipop: self.valueTipOP,
                        producaoParaTerc: self.producaoParaTerc,
                        controle: self.controlesSelecionados[0],
                        codplp: angular.isDefined(self.codPlanta) && ((!isJivaW() && !getAttributeFromHTMLWrapper("producaoFit")) || temOpcional("20511")) ? self.codPlanta : 0
                    }
                };
    
                return getProcessoProdutivoParaProduto(request);
            } else {
                self.codProcesso = undefined;
                self.tamLote = undefined;
                self.nroLote = undefined;
            }
        }

        function getProcessoProdutivoParaProduto(request) {
            ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.getProcessoProdutivoParaProduto", request).then(function (result) {
                self.codPrc = parseInt(result.responseBody.codProcesso);
                self.idProcesso = parseInt(result.responseBody.idProcesso);
                self.versaoProcesso = result.responseBody.versao;
                self.tamLote = result.responseBody.tamLote;
                self.oldTamLote = result.responseBody.tamLote;
                self.multIdeal = result.responseBody.multIdeal;
                self.decQtd = result.responseBody.decQtd;
                self.usaTerc = result.responseBody.usaTerceiro === "S";
                self.controlePA = result.responseBody.controlePA;
				self.loadedLastVersion = true;
                resolveNroLote(result.responseBody);
                changeProcesso(result.responseBody.idProcesso);
            });
        }

        function onProcessoChange(item) {
            if (angular.isDefined(item)) {

                var idProcesso = undefined;

                if (!self.loadedLastVersion && 
                	(item.fields.IDPROC != self.idProcesso || item.fields.CODPRC != self.codPrc)) {
                    if (angular.isDefined(item.data)) {
                        if (angular.isDefined(item.data.IDPROC)) {
                            idProcesso = item.data.IDPROC;
                            self.codPrc = item.data.CODPRC;
                        } else {
                            idProcesso = item.fields.IDPROC;
                            self.codPrc = item.fields.CODPRC;
                        }
                    }
                } else {
                    idProcesso = self.idProcesso;
					self.loadedLastVersion = false;
                }

                if (angular.isDefined(idProcesso)) {
                    self.idProcesso = idProcesso;
                    changeProcesso(self.idProcesso);
                }
            }
        }

        function changeProcesso(idProcesso) {
            var pesqProcessoCtrl = AngularUtil.getControllerFromElement(document.getElementById("pesquisaProcesso"));

            if (angular.isDefined(pesqProcessoCtrl)) {
                pesqProcessoCtrl.loadDescription(false, true, self.codPrc);
            }

            if (angular.isDefined(idProcesso) && angular.isDefined(self.codProd)) {
                var request = {
                    params: {
                        codprod: self.codProd,
                        idproc: idProcesso,
                        nulop: self.nulop,
                        tipop: self.valueTipOP,
                        codPlp: angular.isDefined(self.codPlanta) && ((!isJivaW() && !getAttributeFromHTMLWrapper("producaoFit")) || !temOpcional("20511"))? self.codPlanta : 0,
                        codParc: angular.isDefined(self.codParc) ? self.codParc : null,
                        controle: angular.isDefined(self.controlePA) ? self.controlePA : ' '
                    }
                }
                ServiceProxy.callService('mgeprod@LancamentoOrdemProducaoSP.getProdutoParaProcesso', request).then(function (result) {
                    self.multIdeal = result.responseBody.multIdeal;
                    self.decQtd = parseFloat(result.responseBody.decQtd);
                    self.controlePA = result.responseBody.controlePA;
                    self.tamLote = result.responseBody.tamLote;
                    self.oldTamLote = result.responseBody.tamLote;
                    self.codParc = result.responseBody.codParcTerc;
                    self.minLote = result.responseBody.minLote;
                    resolveNroLote(result.responseBody);
                }).finally(function () {
                    self.dgProcessos.refreshLayout();
                })
            }
        }

        function incluirOP() {

            if (!validaCampos()) {
                return false;
            }

            var request = {
                params: {}
            };

            var controles;
            if (angular.isDefined(self.optionsControle) && self.optionsControle.length > 0) {
                controles = [];
                self.optionsControle.forEach(cont => {
                    if (cont.checked) {
                        controles.push({ controle: cont.value })
                    }
                });
            } else {
                controles = { controle: self.controlePA };
            }

            request.params = {
                nulop: self.nulop,
                codplp: self.codPlanta,
                codprod: self.codProd,
                codParc: self.codParc,
                idproc: self.idProcesso,
                nropedido: self.nroPedido,
                tamlote: self.tamLote,
                oldTamLote: self.oldTamLote,
                agruparEmUnicaOP: self.showControlesMesmaOP && self.lancarMesmaOp,
                opDesmonte: self.valueTipOP === OP_DESMONTE ? SIM : NAO,
                opReparo: self.valueTipOP === OP_REPARO ? SIM : NAO,
                multIdeal: self.multIdeal,
                minLote: self.minLote,
                seqNota: self.seqNota,
                controle: controles
            }

            if (angular.isDefined(self.nroLote) && !self.nroAutomatico) {
                request.params.nrolote = self.nroLote;
            }

            ServiceProxy.callService("mgeprod@LancamentoOrdemProducaoSP.inserirProdutoHTML5", request).then(function (result) {
                var msg = "";
                if (angular.isDefined(result.responseBody.warnLoteTamanhoMinimo)) {
                    msg = result.responseBody.warnLoteTamanhoMinimo;
                } else if (angular.isDefined(result.responseBody.warnLoteTamanhoMultiplo)) {
                    msg = result.responseBody.warnLoteTamanhoMultiplo;
                }

                verificaWarnings(result.responseBody);

                if (StringUtils.isNotEmpty(msg)) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n(msg).replace("{MIN}", self.minLote).replace("{MULT}", self.multIdeal));
                } else {
                    clearFormulary();
                    updateDsProcessos();
                }
            });

            return true;
        }

        function validaCampos() {
            if (angular.isUndefined(self.codProd)) {
                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.LancamentoOrdem.labelSelecioneUmProduto'));
                return false;
            } else if (angular.isUndefined(self.codPrc)) {
                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.LancamentoOrdem.msgInformeOProcesso'));
                return false;
            } else if (angular.isUndefined(self.tamLote) && self.fieldTamLoteEnabled) {
                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.LancamentoOrdem.msgInformeOTamLote'));
                return false;
            } else if (angular.isUndefined(self.nroLote) && (angular.isUndefined(self.nroAutomatico) || !self.nroAutomatico)) {
                MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.LancamentoOrdem.msgInformeONroLote'));
                return false;
            } else if (self.producaoParaTerc === SIM && angular.isUndefined(self.codParc)) {
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.labelSelecioneUmParceiro'));
                return false;
            }

            return true;
        }

        function verificaWarnings(responseBody) {
            if (angular.isDefined(responseBody.warningMessage)) {
                var messages = "";
                if (Array.isArray(responseBody.warningMessage)) {
                    responseBody.warningMessage.forEach(message => {
                        messages.append(message + "\n")
                    })
                } else {
                    messages = responseBody.warningMessage.$;
                }

                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, messages);
            }
        }

        function clearFormulary(keepProdParaTerc = false) {
            self.codProd = undefined;
            self.idProcesso = undefined;
            self.codProcesso = undefined;
            self.codPrc = undefined;
            if (!keepProdParaTerc) self.codParc = undefined;
            self.tamLote = undefined;
            self.nroLote = undefined;
            self.nroAutomatico = undefined;
            self.minLote = undefined;
            self.multIdeal = undefined;
            self.decQtd = undefined;
            self.nroPedido = undefined;
            self.fieldNroLoteEnabled = true;
            self.valueTipOP = OP_PRODUCAO;
            if (!keepProdParaTerc) self.producaoParaTerc = NAO;
            self.apresentarPis = NAO;
            self.showWC = false;
            self.showStepParceiro = false;
            self.showSequencia = false;
            if (!keepProdParaTerc) self.showParceiro = false;
            self.seqNota = undefined;
            self.selecionaMps = NAO;
            self.btnSaveMpEnabled = false;
            self.showParceiro;
            self.showSelecionarControle = false;
            self.showControlesMesmaOP = false;
            self.optionsControle = [];
            self.labelListControle = "";
            self.fieldTamLoteEnabled = true;
        }

        function getPrecision(precision) {
            if (angular.isUndefined(precision)) {
                return 2;
            }

            return isNaN(precision) ? 2 : precision;
        }

        function isJivaW() {
            return SkWorkspace.isJivaW();
        }

        function isSankhyaW() {
            return SkWorkspace.isSankhyaW();
        }


        function temOpcional(opcional) {
            if (getAttributeFromHTMLWrapper("opc0009") == "1") {
                return true;
            }

            return angular.isDefined(ArrayUtils.find(ArrayUtils.toArray(opcional), function (opc) {
                return getAttributeFromHTMLWrapper("opc" + opc) == "1"
            }));
        }

        function getAttributeFromHTMLWrapper(attribName) {
            return window[attribName];
        }

        function toggleHelptip() {
            var texto = getTextoHelpTip();

            var _tooltipBuilder;
            var customClassHelp = 'sk-help-tip-tooltip';
            var element = document.getElementById('helpTipTamLote');
            _tooltipBuilder = _tooltipBuilder || TooltipBuilder(element).duration(-1).customClass(customClassHelp);

            _tooltipBuilder.placement("bottom");

            if (_tooltipBuilder.isOpen()) {
                _tooltipBuilder.hide();
            } else {
                _tooltipBuilder
                    .message(texto)
                    .show();
            }
        }

        function getTextoHelpTip() {
            var texto = "";
            if ((angular.isDefined(self.multIdeal) && parseFloat(self.multIdeal) > 0.0) && (angular.isDefined(self.minLote) && parseFloat(self.minLote) > 0.0)) {
                texto = i18n('Commons.LancamentoOrdem.helpTipTamLote');
            } else if ((angular.isDefined(self.multIdeal) && parseFloat(self.multIdeal) > 0.0) && (angular.isUndefined(self.minLote) || parseFloat(self.minLote) === 0.0)) {
                texto = i18n('Commons.LancamentoOrdem.helpTipTamLoteMultiplo');
            } else if ((angular.isUndefined(self.multIdeal) || parseFloat(self.multIdeal) === 0.0) && (angular.isDefined(self.minLote) && parseFloat(self.minLote) > 0.0)) {
                texto = i18n('Commons.LancamentoOrdem.helpTipTamLoteMinimo');
            } else {
                texto = i18n('Commons.LancamentoOrdem.helpTipTamLoteNenhum');
            }
            return texto.replace("{MIN}", self.minLote).replace("{MULT}", self.multIdeal);
        }

        function selecionaControle() {
            CrudUtils.find("Produto", "TIPCONTEST,LISCONTEST,TITCONTEST", { CODPROD: self.codProd }, true).then(
                function (result) {
                    var produto = result;

                    if (produto) {
                        tipo = produto.TIPCONTEST;
                        opcoes = produto.LISCONTEST;

                        self.labelListControle = produto.TITCONTEST;

                        if (opcoes) {
                            opcoes = StringUtils.replaceAll(opcoes, "${nl}", "\n")
                            opcoes = opcoes.replace("/\r/g", "");
                            var arrayControles = [];

                            if (opcoes.indexOf("\n") != -1) {
                                opcoes.split("\n").forEach(opc => {
                                    arrayControles.push({
                                        data: opc,
                                        value: opc,
                                        checked: false
                                    });
                                })
                            } else {
                                arrayControles.push({
                                    data: opcoes,
                                    value: opcoes,
                                    checked: false
                                });
                            }

                            self.optionsControle = arrayControles;

                        }
                    }
                }
            )
        }

        function onTipoOpChange() {
            if (self.valueTipOP === OP_PRODUCAO_CONJUNTA) {
                self.showPesqCop = true;
                self.showPesqProd = false;
            } else {
                self.showPesqCop = false;
                self.showPesqProd = true;
            }
        }

        function grupoCoProdutoChange(item) {
            if (angular.isDefined(self.idCop)) {
                if (!validaPercentualProcessamentoPAs()) {
                    self.idCop = undefined;
                }
            }
        }

        function validaPercentualProcessamentoPAs() {
            CrudUtils.find("ItensCoProdutos", "PERCQTDREND", { IDCOP: self.idCop }).then(function (result) {
                var itensCoProdutos = result;
                if (itensCoProdutos != null) {
                    var sumPercentual = 0;
                    if (ArrayUtils.isArray(itensCoProdutos)) {
                        itensCoProdutos.forEach(item => {
                            sumPercentual = NumberUtils.round(sumPercentual + item.PERCQTDREND, 2);
                        });
                    }

                    if (sumPercentual != 100) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Producao.GrupoCoProduto.msgValidaSumPercentualItensPA'));
                    }
                }
            });

        }

        function criteriaProcesso(codplp = undefined, prodParaTerc = undefined, codprod = undefined, tipoOp = undefined, controle = undefined) {
            codplp = angular.isDefined(codplp) ? codplp : self.codPlanta;
            prodParaTerc = angular.isDefined(prodParaTerc) ? prodParaTerc : angular.isDefined(self.producaoParaTerc) ? self.producaoParaTerc : NAO;
            codprod = angular.isDefined(codprod) ? codprod : self.codProd;
            tipoOp = angular.isDefined(tipoOp) ? tipoOp : self.valueTipOP;
            controle = angular.isDefined(controle) ? controle : angular.isDefined(self.controlePA) ? self.controlePA : " ";
            var criteria = Criteria();

            if (StringUtils.isEmpty(controle)) {
                controle = " ";
            }

            if (!_lancarOpVersaoAnterior) {
                criteria.append("this.VERSAO = ( SELECT MAX(PRC2.VERSAO) AS VERSAO FROM TPRPRC PRC2 WHERE PRC2.CODPRC = this.CODPRC ) AND ");
            }
            criteria.append("(this.CODPLP IS NULL OR this.CODPLP = " + codplp + ")");
            criteria.append("AND this.IDPROC IN ( ");
            criteria.append("SELECT LPA.IDPROC FROM TPRLPA LPA WHERE 1=1");
            criteria.append("AND EXISTS(SELECT 1 FROM TPRLPA WHERE CODPRODPA = ? AND (CONTROLEPA = '" + controle + "') AND IDPROC = LPA.IDPROC))");
            criteria.append("AND this.PROCDESMONTE = '" + (OP_DESMONTE === tipoOp ? SIM : NAO) + "'");
            if (prodParaTerc != NAO) {
                criteria.append(" AND this.PRODPARATERCEIRO <> 'N' ");
            }
            if (OP_REPARO === tipoOp) {
                criteria.append(" AND this.PROCREPARO = 'S' ");
            } else {
                criteria.append(" AND this.PROCREPARO IS NULL ");
            }

            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codprod));

            return criteria;
        }


        function criteriaPedido() {
			var controle = angular.isDefined(self.nroLote);
            var criteria = Criteria();
            criteria.append(" this.TIPMOV = 'P' AND this.PENDENTE = 'S' AND this.STATUSNOTA = 'L'");
            criteria.append(" AND EXISTS ( SELECT 1 ");
            criteria.append("			   	FROM TGFITE ITE ");
            criteria.append("			   WHERE ITE.CODPROD =  ?");
            
            if (controle && self.nroLote != '(Automático)' && self.nroLote != '') {
				criteria.append("			   	AND ITE.CONTROLE =  ?");
			}
            
            criteria.append("			   	AND ITE.PENDENTE = 'S' ");
            criteria.append("			   	AND ITE.NUNOTA = this.NUNOTA ");
            criteria.append("			  ) ");
            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProd));
            
            if (controle && self.nroLote != '(Automático)' && self.nroLote != '') {
				criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, self.nroLote));
			}
            
            return criteria;
        }

        function criteriaSeq() {
            var criteria = Criteria();

            var nuNota = self.nroPedido;
            if (nuNota === 0) {
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.LancamentoOrdem.msgInformeNroPedido'));
                expression = "1 <> 1"
            } else {
                var controle = self.controlePA;
                if (StringUtils.isEmpty(controle)) {
                    controle = " ";
                }

                var expression = "this.NUNOTA = ? AND this.PENDENTE = 'S' AND this.CODPROD = ? AND this.CONTROLE = ?";

                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, nuNota));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProd));
                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, controle));
            }

            criteria.append(expression);

            return criteria;
        }

        function criteriaProduto() {
            var opDesmonte = self.valueTipOP == OP_DESMONTE ? SIM : NAO;
            var opReparo = self.valueTipOP == OP_REPARO ? SIM : NAO;

            var expressao = " this.USOPROD <> 'S'";

            expressao += " AND EXISTS (SELECT 1 ";
            expressao += " 				FROM TPRLPA LPA ";
            expressao += " 			   		 ,TPRPRC PRC ";
            expressao += " 			   WHERE LPA.IDPROC = PRC.IDPROC ";
            expressao += " 			   	AND LPA.CODPRODPA = this.CODPROD ";
            expressao += "              AND PRC.PROCDESMONTE = ? ";
            if ("S" == opReparo) {
                expressao += "          AND PRC.PROCREPARO = '" + opReparo + "' ";
            }
            expressao += "             ) ";

            var criteria = Criteria();
            criteria.append(expressao);

            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, opDesmonte));

            return criteria;
        }

        function criteriaUnidade() {
            var criteria = Criteria();

            expression = "this.CODVOL IN (SELECT VOA.CODVOL FROM TGFVOA VOA WHERE VOA.CODPROD = ?";
            expression += "				   UNION ";
            expression += "				  SELECT PRO.CODVOL FROM TGFVOL VOL INNER JOIN TGFPRO PRO ON (PRO.CODVOL = VOL.CODVOL) WHERE PRO.CODPROD = ?)";

            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProdMP));
            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, self.codProdMP));
            criteria.append(expression);

            return criteria;
        }


        function setInfoCoProduto(obj) {
            var codVol = ' ';
            var descrVol = ' ';

            if (angular.isDefined(obj)) {
                codVol = obj.fields.CODVOL;
                descrVol = obj.fields["Volume.DESCRVOL"];
            } else if (StringUtils.isNotEmpty(self.codVol)) {
                codVol = self.codVol;
                descrVol = self.descrVol;
            }

            var params = {
                params: {
                    nuLop: self.nulop,
                    idCop: self.idCop,
                    unidade: codVol,
                    descrUnidade: descrVol,
                    qtdProcess: angular.isUndefined(self.qtdProcess) || self.qtdProcess === "" ? 0 : self.qtdProcess,
                    seqCop: 0,//self.seqCop,
                    isFirstLoad: true//self.isFirstLoad
                }
            }

            ServiceProxy.callService(
                "mgeprod@LancamentoOrdemProducaoSP.getInfoGrupoCoProduto",
                params).then(function (response) {

                    var coProduto = response.responseBody.coProduto.infoCoProduto;
					if (angular.isDefined(coProduto)) {
						self.qtdProcess = coProduto.QTDPROCESS;
						self.codVol = coProduto.CODVOL;
						self.descrVol = coProduto.DESCRVOL;
						self.codVolPadrao = coProduto.CODVOL_PADRAO;
						self.descrVolPadrao = coProduto.DESCRVOL_PADRAO;
						self.decQtd = coProduto.DECQTD;
						self.codProdMP = coProduto.CODPRODMP;

						if (StringUtils.isNotEmpty(coProduto.CONTROLEMP)) {
							self.showControleMpComp = true;
							self.controleMpCompart = coProduto.CONTROLEMP;
						}

						self.idCop = coProduto.IDCOP;

						self.qtdProcessPadrao = coProduto.QTDPROCESS_PADRAO;

						self.seqCop = 0;
					}
				});
        }

        function incluirCoProducao() {
            var params = {
                params: {
                    nulop: self.nulop,
                    idcop: self.idCop,
                    codplp: self.codPlanta,
                    qtdConsumida: self.qtdProcess
                }
            }

            ServiceProxy.callService(
                "mgeprod@LancamentoOrdemProducaoSP.inserirCoProducao",
                params).then(
                    function (response) {
                        clearFormulary();
                        updateDsProcessos();
                    });
        }

        function changeMesmaOP() {
            if (self.lancarMesmaOp === SIM) {
                self.fieldTamLoteEnabled = false;
                _nroLoteEnabledAux = self.fieldNroLoteEnabled;
                self.fieldNroLoteEnabled = false;
            } else {
                self.fieldTamLoteEnabled = true;
                self.fieldNroLoteEnabled = _nroLoteEnabledAux;
            }
        }

        function updateDsProcessos() {
            if(angular.isDefined(self.dsProcessos)) {
                self.dsProcessos.refresh();
            }
        }

        function resolveNroLote(item) {
            var processoProdutivoUsaLoteCuringa = item.tipNroLote === MANUAL && StringUtils.isNotEmpty(item.loteCuringa);
            self.fieldNroLoteEnabled = !(item.tipNroLote != MANUAL || processoProdutivoUsaLoteCuringa);
            if (!self.fieldNroLoteEnabled) {
                if (StringUtils.isNotEmpty(item.loteCuringa)){
                    self.nroAutomatico = false;
                    self.nroLote = item.loteCuringa;
                } else {
                    self.nroAutomatico = true;
                    self.nroLote = i18n('Commons.LancamentoOrdem.labelAutomatico');
                }
            } else if(self.nroAutomatico && item.tipNroLote === MANUAL){
                self.nroAutomatico = undefined;
                self.nroLote = undefined;
            }
        }
    }
]);
angular.module('snk.commons.lancamentoOrdemProducao').controller('popupInfoLoteController', ['NumberUtils', 'ObjectUtils', 'i18n', 'SanPopup', '$scope', '$popupInstance', 'data',
   function (NumberUtils, ObjectUtils, i18n, SanPopup, $scope, $popupInstance, data) {
      var self = this;
      ObjectUtils.implements(self, IDatagridInterceptor);

      self.msg = data.popUpContent;
      $scope.$success = onClickConfirm;
      self.dsProdutos;
      self.resourceID;
      self.gridInfoLoteConfig;
      self.precCols;
      self.abrirConfiguracoesEstoque = abrirConfiguracoesEstoque;
      self.interceptCellRenderer = interceptCellRenderer;

      init();

      function init() {
         self.dsProdutos = data.dsProdutos;
         self.dsProdutos.refresh();
         self.resourceID = data.resourceID
         self.gridInfoLoteConfig = self.resourceID + '.GridInfo';
         self.precCols = data.precCols;
         self.getPrecision = data.getPrecision;
      }

      function onClickConfirm() {
         $popupInstance.success({
            resposta: 'Sua resposta'
         });
      }

      function abrirConfiguracoesEstoque() {
         SanPopup.open({
            title: i18n('Commons.LancamentoOrdem.labelConfigEstoque'),
            templateUrl: 'commons/lancamentoOrdemProducao/popups/configuracaoEstoque/configuracaoEstoque.tpl.html',
            controller: 'configuracaoEstoqueController',
            controllerAs: 'ctrl',
            size: 'lg',
            cancelBtnLabel: i18n("Geral.lblFechar"),
            showBtnOk: true,
            okBtnLabel: i18n("Geral.lblSalvar"),
            resolve: {
               data: {
                  resourceID: self.resourceID,
                  tipConfig: "PA"
               }
            }
         });
      }

      function interceptCellRenderer(cell, value, eGridCell, data) {
         if (self.precCols.indexOf(cell.colId) != -1 && !cell.colDef.editable) {//NAO PODE SER APLICADA A CAMPOS EDITÁVEIS
            var element = document.createElement("span");
            var text = document.createTextNode((NumberUtils.format(value, self.getPrecision(data.gridItem.Produto.DECQTD))));
            element.appendChild(text);

            return {
               element: element,
               align: "flex-end"
            }
         }
      }
   }
]);
/*
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
angular
    .module('snk.commons.layout')
    .service('FieldInfoService', [function () {

        var self = this;

        var _descrWorkFieldsByID = new Object();
        var _visibleFieldsByID = new Object();
        var _systemRequiredByID = new Object();
        var _systemReadOnlyByID = new Object();
        var _defaultValuesByID = new Object();
        var _notAllowedDefaultValue = new Object();

        self.putDescription = putDescription;
        self.getDescription = getDescription;
        self.putVisibleField = putVisibleField;
        self.putSytemRequiredField = putSytemRequiredField;
        self.putSystemReadOnlyField = putSystemReadOnlyField;
        self.clearAllInfo = clearAllInfo;
        self.clearAllDefaultValues = clearAllDefaultValues;
        self.isVisibleField = isVisibleField;
        self.isSytemRequiredField = isSytemRequiredField;
        self.isSystemReadOnlyField = isSystemReadOnlyField;
        self.putDefaultValue = putDefaultValue;
        self.getDefaultValue = getDefaultValue;
        self.getAllDefaultValues = getAllDefaultValues;
        self.makeNotAllowedDefaultValue = makeNotAllowedDefaultValue;
        self.allowDefaultValue = allowDefaultValue;

        function putDescription(fieldID, description) {
            _descrWorkFieldsByID[fieldID] = description;
        }

        function getDescription(fieldID) {
            return _descrWorkFieldsByID[fieldID];
        }

        function putVisibleField(fieldName) {
            _visibleFieldsByID[fieldName] = null;
        }

        function putSytemRequiredField(fieldName, value) {
            if (angular.isUndefined(value)) {
                value = true;
            }
            _systemRequiredByID[fieldName] = value;
        }

        function putSystemReadOnlyField(fieldName, value) {

            if (angular.isUndefined(value)) {
                value = true;
            }

            _systemReadOnlyByID[fieldName] = value;
        }

        function clearAllInfo() {
            _descrWorkFieldsByID = new Object();
            _systemRequiredByID = new Object();
            _systemReadOnlyByID = new Object();
            _notAllowedDefaultValue = new Object();
        }

        function clearAllDefaultValues() {
            _defaultValuesByID = new Object();
        }

        function isVisibleField(fieldName) {
            return _visibleFieldsByID.hasOwnProperty(fieldName);
        }

        function isSytemRequiredField(fieldName) {
            return _systemRequiredByID.hasOwnProperty(fieldName) && _systemRequiredByID[fieldName];
        }

        function isSystemReadOnlyField(fieldName) {
            return _systemReadOnlyByID.hasOwnProperty(fieldName) && _systemReadOnlyByID[fieldName];
        }

        function putDefaultValue(fieldID, value) {
            if (value) {
                _defaultValuesByID[fieldID] = value;
            } else {
                delete _defaultValuesByID[fieldID];
            }
        }

        function getDefaultValue(fieldID) {
            return _defaultValuesByID[fieldID];
        }

        function getAllDefaultValues() {
            return angular.copy(_defaultValuesByID);
        }

        function makeNotAllowedDefaultValue(fieldID) {
            _notAllowedDefaultValue[fieldID] = null;
        }

        function allowDefaultValue(fieldID) {
            return !_notAllowedDefaultValue.hasOwnProperty(fieldID);
        }
    }]);
/*
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
class LayoutConfigManager {
    _configTool;
    _workBox;
    _workBoxSelected;
    _workBoxDetached;

    _cacheToUndoAction = new ArrayList();
    _transferArea;

    _dragEnterWorkBoxHandler;
    _dragDropWorkBoxHandler;
    _dragOverWorkBoxHandler;

    _eventName;
    _scope;
    _eventBusEditor

    workBoxStyleName = {
        'background-color': '#efefef',
        'border-color': '#999'
    };

    workBoxDetachStyleName = {
        'background-color': '#efefef',
        'border-color': '#ff9900',
    };

    workBoxSelectedStyleName = {
        'background-color': '#ffffe1',
        'border-color': '#666666'
    };

    workBoxDetachSelectedStyle = {
        'background-color': '#ffffe1',
        'border-color': '#ff9900',
    };

    MAX_ACTIONS_IN_CACHE = 5;
    WORK_BOX = 'sk-work-box';
    WORK_WINDOW = 'work-window';
    WORK_TAB = 'work-tab';
    GADGET_CONTROL = 'gadget-control';

    constructor($injector, configTool, baseWorkBox, eventName, scope, eventBusEditor) {
        this.angularUtil = $injector.get('AngularUtil');
        this.stringUtils = $injector.get('StringUtils');
        this.messageUtils = $injector.get('MessageUtils');
        this.NumberUtils = $injector.get('NumberUtils');
        this.$timeout = $injector.get('$timeout');
        this.i18n = $injector.get('i18n');
        this._scope = scope;
        this._configTool = configTool;
        this._eventName = eventName;
        this.eventBusEditor = eventBusEditor;

        if (baseWorkBox != null) {
            this._workBox = baseWorkBox;
            this._workBox.addEventListener('click', workBoxSelected);

            this.addWorkBoxListeners(this._workBox);
            this.selectWorkBox(this._workBox);
        }
    }

    workBoxSelected(e) {
        e.stopPropagation();
        this.selectWorkBox(e.currentTarget);
    }

    selectWorkBox(workBox) {

        var workBoxElem = angular.element(workBox);

        if (this._workBoxDetached != null) {
            this.setStyleFromElement(workBoxElem, workBoxElem[0].id == this._workBoxDetached[0].id ? this.workBoxDetachSelectedStyle : this.workBoxSelectedStyleName);
        } else {
            this.setStyleFromElement(workBoxElem, this.workBoxSelectedStyleName);
        }

        if (this._workBoxSelected != null && this._workBoxSelected[0].id != workBoxElem[0].id) {

            if (this._workBoxDetached != null) {
                this.setStyleFromElement(this._workBoxSelected, this._workBoxSelected[0].id == this._workBoxDetached[0].id ? this.workBoxDetachStyleName : this.workBoxStyleName);
            } else {
                this.setStyleFromElement(this._workBoxSelected, this.workBoxStyleName);
            }
        }

        this._workBoxSelected = workBoxElem;

        this.updateStatusTools();
    }

    unselectWorkBox() {
        if (this._workBoxSelected != null) {

            if (this._workBoxDetached != null) {
                this.setStyleFromElement(this._workBoxSelected, this._workBoxSelected[0].id == this._workBoxDetached[0].id ? this.workBoxDetachStyleName : this.workBoxStyleName);
            } else {
                this.setStyleFromElement(this._workBoxSelected, this.workBoxStyleName);
            }
        }

        this._workBoxSelected = null;
    }

    setStyleFromElement(element, style) {

        if (angular.isObject(style)) {
            Object.keys(style).forEach(function (key) {
                element.css(key, style[key]);
            });
        }
    }

    updateStatusTools() {

        if (this._configTool) {

            if (this._workBoxDetached == null || this._workBoxSelected != this._workBoxDetached) {
                this._configTool.statusBtnDestaque(false);
            } else {
                this._configTool.statusBtnDestaque(true);
            }

            if (this._cacheToUndoAction && this._cacheToUndoAction.length() == 0) {
                this._configTool.statusBtnDesfazer(false);
            } else {
                this._configTool.statusBtnDesfazer(true);
            }

            if (this._workBoxSelected == null || this._workBoxSelected[0].id == this._workBox[0].id) {
                this._configTool.statusBtnExcluir(false);
                this._configTool.statusBtnCopiar(false);
                this._configTool.statusBtnRecortar(false);
            } else {
                this._configTool.statusBtnExcluir(true);
                this._configTool.statusBtnCopiar(true);
                this._configTool.statusBtnRecortar(true);
            }

            this._configTool.statusBtnLimpar(this._workBoxSelected);

            if (this._workBoxSelected != null && this._workBoxSelected.parent) {
                var direction;
                var resizableElem = this._workBoxSelected[0].parentElement?.parentElement;
                if (resizableElem && (resizableElem.localName.indexOf('sk-resizable-') > -1 || resizableElem.localName == this.WORK_BOX)) {
                    if (resizableElem.localName == this.WORK_BOX) {
                        direction = resizableElem.getAttribute('sk-direction-layout') == 'V' ? "vertical" : "horizontal";
                    } else {
                        direction = resizableElem.localName == 'sk-resizable-columns' ? "horizontal" : "vertical";
                    }
                } else {
                    direction = this._workBoxSelected[0].getAttribute('sk-direction-layout') == 'H' ? 'horizontal' : 'vertical';
                }
                this._configTool.directionInsertWorkBox(direction);
            }

            if (this._workBoxSelected != null && this._workBoxSelected.children.length > 0) {

                var workBoxSelected = this.angularUtil.getControllerFromElement(this._workBoxSelected);

                if (workBoxSelected.hasWorkContainer()) {
                    this._configTool.statusBtnJoinWorkBoxs(false);
                } else {
                    // this._configTool.statusBtnJoinWorkBoxs(true);
                    // Manter desabilitado temporariamente até definir funcionalidade do botão
                    this._configTool.statusBtnJoinWorkBoxs(false);
                }
            } else {
                this._configTool.statusBtnJoinWorkBoxs(false);
            }

            if (this._transferArea != null && this._workBoxSelected != null) {
                this._configTool.statusBtnColar(true);
            } else {
                this._configTool.statusBtnColar(false);
            }

            this.angularUtil.apply(this._scope);
        }
    }

    executeUndoJoinWorkBoxsAction(action) {
        var data = action.DATA;

        var workBoxParent = data.PARENT;
        var workBoxChildren = new Array();

        var childrenInfo = data.CHILDREN_INFO;
        var parentDirection = data.DIRECTION;

        for (var i = 0; i < childrenInfo.length; i++) {
            var worBox = childrenInfo[i].workBox;
            var worBoxCtrl = this.angularUtil.getControllerFromElement(worBox);

            var children = childrenInfo[i].children;
            var childrenCache = children;

            this.doDivideWorkBox(worBoxCtrl.direction, worBoxCtrl, children);

            if (childrenCache.length < 2) {
                angular.element(worBox).append(childrenCache);
            }

            workBoxChildren.push(worBox);
        }

        this.doDivideWorkBox(parentDirection, workBoxParent, workBoxChildren);
    }

    duplicateChildNodes(parentId) {
        var parent = document.getElementById(parentId);
        NodeList.prototype.forEach = Array.prototype.forEach;
        var children = parent.childNodes;

        var clone = new Array();

        children.forEach(function (item) {
            var cln = item.cloneNode(true);
            clone.push(cln);
        });

        return clone;
    }



    undoLastAction() {
        if (this._cacheToUndoAction.length() > 0) {
            var action = this._cacheToUndoAction.removeItemAt(0);

            switch (action.NAME) {
                case "divideWorkBox":
                    this.executeDivideWorkBoxAction(action);
                    break;
                case "addChild":
                    this.executeAddChildAction(action);
                    break;
                case "removeChildren":
                    this.executeRemoveChildrenAction(action);
                    break;
                case "joinWorkBoxs":
                    this.executeUndoJoinWorkBoxsAction(action);
                    break;
                case "cutAndPastWorkBox":
                    this.executeUndoCutAndPastWorkBoxAction(action);
                    break;
            }

            if (this._workBoxSelected != null) {
                this.setStyleFromElement(this._workBoxSelected, this.workBoxStyleName);
            }

            if (this._workBoxDetached != null) {
                this.setStyleFromElement(this._workBoxDetached, this.workBoxStyleName);
            }

            this._workBoxSelected = !action.WORKBOX_SELECTED ? null : action.WORKBOX_SELECTED;
            this._workBoxDetached = !action.WORKBOX_DETACHED ? null : action.WORKBOX_DETACHED;

            if (this._workBoxSelected != null) {
                this.setStyleFromElement(this._workBoxSelected, this.workBoxSelectedStyleName);
            }

            if (this._workBoxDetached != null) {
                this.setStyleFromElement(this._workBoxDetached, this._workBoxSelected ? workBoxDetachSelectedStyle : workBoxDetachStyleName);
            }
            
            this.updateStatusTools();
        }
    }

    changeWorkBox(baseWorkBox) {
        this._workBox = baseWorkBox;
        this._workBox[0].addEventListener("click", e => this.workBoxSelected(e));
        this.addWorkBoxListeners(this._workBox);
        this.selectWorkBox(this._workBox);
        this._cacheToUndoAction = new ArrayList();
        this.updateStatusTools();
    }

    deleteWorkBox() {

        var workBox = this._workBoxSelected;

        if (workBox != null && workBox[0].id != this._workBox[0].id) {
            var parentWorkBox = angular.element(workBox[0].parentNode);           

            var index = parentWorkBox.index();

            if (index > -1) {
                //Pegamos o box que foi descartado e verificamos a existência de
                //Grids nele para volta-los para a lista de Grids. 
               
                const workboxParentElement = workBox[0].parentNode.parentNode;
                       
                const data = new Object();                

                data.PARENT = workboxParentElement;
                data.CHILD = parentWorkBox;
                data.INDEX = index;
                data.DIVIDER = null;

                const workBoxElement = parentWorkBox[0];
                const workBoxIndex = angular.element(workBoxElement).index();
                const wordBoxDirection = this.getDirectionClass(workBoxElement);
                const workBoxHasChild = this.getChildWithClass(workBoxElement, 'rg-' + wordBoxDirection);
                workboxParentElement.removeChild(workBoxElement);
                if (angular.isUndefined(workBoxHasChild)) {
                    const children = workboxParentElement.children[workBoxIndex];
                    if (angular.isDefined(children)) {
                        const classNameDirection = this.getDirectionClass(children);
                        const childRen = this.getChildWithClass(children, 'rg-' + classNameDirection);
                        if (angular.isDefined(childRen)) {
                            data.DIVIDER = childRen;
                            children.removeChild(childRen);
                        }
                    }
                }

                this.postActionInCache("addChild", data);
            }

            this._workBoxSelected = null;

            this.updateStatusTools();

            this.eventBusEditor.dispatchEvent('gadgetChange');
        }
    }

    executeUndoCutAndPastWorkBoxAction(action) {
        var data = action.DATA;

        var childToAdd = data.CHILD;
        var workBoxSelected = data.WORKBOX_SELECTED;

        workBoxSelected.removeChild(childToAdd);
    }


    executeRemoveChildrenAction(action) {
        var data = action.DATA;
        var parent = data.PARENT;
        var childrenToRemove = data.CHILDREN;
        var _this = this;

        if (childrenToRemove) {

            if (!angular.isArray(childrenToRemove)) {
                childrenToRemove = [childrenToRemove];
            }

            childrenToRemove.forEach(function (childToRemove) {

                if (childToRemove != null) {

                    if (childToRemove == _this._workBoxSelected) {
                        _this._workBoxSelected = null;
                    }

                    if (childToRemove.closest(parent).length) {
                        if (angular.isElement(childToRemove[0])) {
                            parent.removeChild(childToRemove[0]);
                        } else {
                            parent.removeChild(childToRemove);
                        }
                    }
                }
            });
        }

    }

    executeAddChildAction(action) {
        var data = action.DATA;
        var parent = data.PARENT;
        var child = data.CHILD;
        var index = Number(data.INDEX);
        var divider = data.DIVIDER;

        parent.insertBefore(child[0], parent.children[index]);

        if (divider) {
            parent.children[index+1].append(divider);
        }

        this.calculatePercentChildren(parent, parent.children);
    }

    calculatePercentChildren(boxParent, children) {
        var numberChildren = children.length;
        var percentSize = Number(this.NumberUtils.format(100 / numberChildren));

        for (var i = 0; i < numberChildren; i++) {
            //Calculando o último tamanho.
            if (i == (numberChildren - 1)) {
                percentSize = Number(this.NumberUtils.format(100 - (percentSize * i)));
            }

            angular.element(children[i]).css('flex', percentSize + '%');
        }
    }


    executeDivideWorkBoxAction(action) {
        var data = action.DATA;

        var workBoxParent = data.PARENT;
        var workBoxChildren = data.CHILDREN;
        var direction = data.DIRECTION;
        var numberCols = data.NUMBERCOLS;

        var workBoxParentCtrl = this.angularUtil.getControllerFromElement(workBoxParent);

        this.doDivideWorkBox(direction, workBoxParentCtrl ? workBoxParentCtrl : workBoxParent, workBoxChildren, numberCols);

    }

    divideWorkBox(direction, numberCols, postInCache = true) {

        if (this._workBoxSelected != null) {            

            var workBoxSelectedCtrl = this.angularUtil.getControllerFromElement(this._workBoxSelected);
            var workBoxChildren = this._workBoxSelected.children();

            var data = new Object();
            data.PARENT = workBoxSelectedCtrl;
            data.CHILDREN = workBoxChildren;
            data.NUMBERCOLS = workBoxChildren.length;
            data.DIRECTION = this._workBoxSelected[0].getAttribute('sk-direction-layout') == 'V' ? "vertical" : "horizontal";
    
            if (workBoxChildren.children 
                && workBoxChildren.children().length > 0 
                && (workBoxChildren[0].localName == this.WORK_WINDOW 
                    || workBoxChildren[0].localName == this.WORK_TAB 
                    || workBoxChildren[0].localName == this.GADGET_CONTROL)
                ) {
                if (postInCache) {
                    this.postActionInCache("divideWorkBox", data);
                }
                this.doDivideWorkBox(direction, workBoxSelectedCtrl, workBoxChildren, numberCols);
            } else {

                var childRen = null;

                if (workBoxChildren[0] && (workBoxChildren[0].localName.indexOf('sk-resizable') > -1
                || Object.values(workBoxChildren[0].attributes).filter(attr => attr.localName.indexOf('sk-resizable') > -1).length)) {
                    childRen = workBoxChildren.children();

                    if (childRen.length > 0) {
                        var i = childRen.length;
                        while (i--) {
                            var child = angular.element(childRen[i]);

                            if (child[0].localName.indexOf('div') > -1) {
                                childRen.splice(i, 1);
                            }
                        }
                    }
                }

                data.CHILDREN = childRen;
                if (postInCache) {
                    this.postActionInCache("divideWorkBox", data);
                }
                this.doDivideWorkBox(direction, workBoxSelectedCtrl, childRen, numberCols);
            }

            this.eventBusEditor.dispatchEvent('gadgetChange');            
        } else {
            this.messageUtils.showAlert(this.messageUtils.TITLE_WARNING, this.i18n('mge.GadgetBuilder.selecioneUmaColuna'));
        }
    }

    doDivideWorkBox(direction, workBoxParent, workBoxChildren, numberCols, includeResizable) {

        var noColumn = false;

        if (angular.isUndefined(numberCols) || isNaN(numberCols)) {
            numberCols = -1;
        }

        workBoxParent.direction = direction;

        workBoxParent.removeAllChildren();

        if (numberCols == -1 && workBoxChildren != null) {
            numberCols = workBoxChildren.length;
        }
        
        if (numberCols == 1 && !includeResizable) {
            noColumn = true;
        }

        var calcPercentual = Number(this.NumberUtils.format(100 / numberCols));

        var percentSizeChildren = (calcPercentual == Infinity || angular.isUndefined(calcPercentual)) ? 100 : calcPercentual;

        if (numberCols > 1 || (numberCols == 1 && includeResizable)) {

            var resizableTag = new Object();
            resizableTag.orientacao = direction;
            resizableTag.tamanhorelativo = percentSizeChildren;
        }

        var scopeToParent = workBoxParent.getScopeApi();

        if (!includeResizable) {
            if (direction == "horizontal") {
                scopeToParent.element.attr('sk-direction-layout', 'H');
                scopeToParent.element.attr('layout', 'row');
            } else {
                scopeToParent.element.attr('sk-direction-layout', 'V');
                scopeToParent.element.attr('layout', 'column');
            }
        }

        for (var i = 0; i < numberCols; i++) {

            //Calculando o último tamanho.
            if (i == (numberCols - 1)) {
                percentSizeChildren = Number(this.NumberUtils.format(100 - (percentSizeChildren * i)));
            }

            if (workBoxChildren && workBoxChildren.length > 0 && i < workBoxChildren.length) {
                var workBoxChild = angular.element(workBoxChildren[i]);

                if (workBoxChild.length > 0) {
                    if ((workBoxChild[0].localName == this.WORK_WINDOW || workBoxChild[0].localName == this.WORK_TAB || workBoxChild[0].localName == this.GADGET_CONTROL) && numberCols > 1) {
                        var newWorkBox = this.buildWorkBox(direction, percentSizeChildren);

                        newWorkBox = angular.element(newWorkBox).append(workBoxChild);

                        workBoxChild = newWorkBox;
                    }

                    if (workBoxChild[0].getAttribute('sk-direction-layout') == 'H') {
                        workBoxChild.attr('sk-percent-width', percentSizeChildren + '%');
                    } else {
                        workBoxChild.attr('sk-percent-height', percentSizeChildren + '%');
                    }

                    const multiplicador = direction == "horizontal" ? scopeToParent.element?.width() : scopeToParent.element?.height();
                    var size = percentSizeChildren / 100 * multiplicador;
                    workBoxChild.attr('sk-tamanho-relativo', size);
                    workBoxChild.attr('sk-relative-size', size);
                    workBoxChild.attr('sk-change-layout', false);

                    var divElem = noColumn ? null : workBoxParent.addChild(workBoxChild, scopeToParent, scopeToParent.element);

                    if (divElem) {
                        angular.element(scopeToParent.element).append(divElem);
                        this.angularUtil.compile(divElem, this._scope);
                    } else {
                        angular.element(scopeToParent.element).append(workBoxChild);
                        this.angularUtil.compile(workBoxChild, this._scope);
                    }
                }
            } else {
                const multiplicador = direction == "horizontal" ? scopeToParent.element?.width() : scopeToParent.element?.height();
                var size = percentSizeChildren / 100 * multiplicador;
                var divElem = workBoxParent.addChild(this.buildWorkBox(direction, parseInt(size)), scopeToParent, scopeToParent.element);
                angular.element(scopeToParent.element).append(divElem);
                this.angularUtil.compile(divElem, scopeToParent);
            }
        }
                
        return workBoxParent;
    }

    insertWorkBox(position, numberCols) {

        if (this._workBoxSelected != null) {

            if (this._workBoxSelected[0].id == this._workBox[0].id) {
                this.messageUtils.showAlert(this.i18n('mge.GadgetBuilder.titleAtencao'), this.i18n('mge.GadgetBuilder.msgNaoPodeInserirColAntesDepoisPrinc'));
                return;
            }

            var resizableElem = this._workBoxSelected[0].parentElement.parentElement;

            if (resizableElem && (resizableElem.localName.indexOf('sk-resizable-') > -1 || resizableElem.localName == this.WORK_BOX)) {

                var parentWorkBoxCtrl = this.angularUtil.getControllerFromElement(angular.element(this._workBoxSelected[0]));

                var divElem = angular.element(this._workBoxSelected[0].parentElement);

                var creationIndex = divElem.index();

                var newsChildren = new Array();

                var direction;

                if (resizableElem.localName == this.WORK_BOX) {
                    direction = resizableElem.getAttribute('sk-direction-layout') == 'V' ? "vertical" : "horizontal";
                } else {
                    direction = resizableElem.localName == 'sk-resizable-columns' ? "horizontal" : "vertical";
                }

                var numberChildren = resizableElem.children.length;

                var percentSize = Number(this.NumberUtils.format(100 / (numberCols + numberChildren)));

                for (var i = 0; i < numberCols; i++) {

                    var newChild = this.buildWorkBox(direction, percentSize);
                    var newDivElem;

                    if (creationIndex > -1) {

                        newDivElem = parentWorkBoxCtrl.addChildAt(newChild, creationIndex, parentWorkBoxCtrl.getScopeApi(), position);
                    } else {
                        newDivElem = parentWorkBoxCtrl.addChild(newChild, parentWorkBoxCtrl.getScopeApi(), resizableElem);
                    }

                    newsChildren.push(angular.element(newDivElem));
                }

                this.calculatePercentChildren(parentWorkBoxCtrl, resizableElem.children);

                var data = new Object();

                data.PARENT = resizableElem;
                data.CHILDREN = newsChildren;

                this.postActionInCache("removeChildren", data);

                this.eventBusEditor.dispatchEvent('gadgetChange');
            }
        } else {
            this.messageUtils.showAlert(this.i18n('mge.GadgetBuilder.titleAtencao'), this.i18n('mge.GadgetBuilder.selecioneUmaColuna'));
        }
    }

    cloneWorkBox(workBoxCtrl, direction, cloneAll) {
        var newWorkBoxElem = this.buildWorkBox(direction);


        this.setStyleFromElement(newWorkBoxElem, this.workBoxStyleName);
        this.addWorkBoxListeners(newWorkBoxElem);

        var newWorkBoxCtrl = this.angularUtil.getControllerFromElement(newWorkBoxElem);

        if (direction) {
            newWorkBoxCtrl.direction = (direction == 'H' || direction == 'horizontal') ? 'horizontal' : 'vertical';
        } else {
            newWorkBoxCtrl.direction = 'vertical';
        }

        var scopeToParent = newWorkBoxCtrl.getScopeApi();

        if (workBoxCtrl.hasWorkContainer()) {
            var workContainer = workBoxCtrl.getWorkContainer();
            var workContainerCtrl = this.angularUtil.getControllerFromElement(workContainer);

            var cloneWorkContainer;

            if (workContainerCtrl) {
                cloneWorkContainer = workContainerCtrl.clone(cloneAll);

                angular.element(newWorkBoxElem).append(cloneWorkContainer);

                newWorkBoxCtrl.addIWorkContainer(cloneWorkContainer);
            }
        } else {

            var workBoxElem = workBoxCtrl.getScopeApi().element;

            if (workBoxElem.children && workBoxElem.children().length > 0) {

                var childElement = angular.element(workBoxElem.children());

                if (childElement[0].localName == this.GADGET_CONTROL) {
                    var gadgetCtrl = this.angularUtil.getControllerFromElement(childElement);

                    var gadgetManager = gadgetCtrl.getControlManager();

                    var cloneGadgetControlElem = this._scope.$ctrl.buildGadgetControl(gadgetManager.metadata, gadgetManager);

                    angular.element(newWorkBoxElem).append(childElement);                    

                } else {

                    var divs = workBoxElem.children().children();

                    if (divs.length > 0 && newWorkBoxElem.length > 0) {

                        var resizableTag = new Object();
                        resizableTag.orientacao = childElement[0].localName == 'sk-resizable-rows' ? 'V' : 'H';                        
                    }

                    for (var i = 0; i < divs.length; i++) {

                        var workBoxChild = angular.element(divs[i].children);

                        if (workBoxChild.length > 0) {

                            //Necessário por causa das div left/top
                            if (workBoxChild[0].localName == 'div') {
                                workBoxChild = angular.element(workBoxChild[1]);
                            }

                            if (workBoxChild[0].localName == this.WORK_BOX) {

                                var workBoxChildCtrl = this.angularUtil.getControllerFromElement(workBoxChild);
                                var directionClone = workBoxChild[0].getAttribute('sk-direction-layout') == 'H' ? 'horizontal' : 'vertical';
                                var newCloneWorkBox = this.cloneWorkBox(workBoxChildCtrl, directionClone, cloneAll);

                                angular.element(newWorkBoxElem).append(newCloneWorkBox);

                                newWorkBoxCtrl.addChild(newCloneWorkBox, scopeToParent, divs.length > 1);
                            } else if (workBoxChild[0].localName == this.GADGET_CONTROL) {

                                var workBoxParent = angular.element(workBoxChild[0].parentNode);

                                var directionClone = workBoxParent[0].getAttribute('sk-direction-layout') == 'H' ? 'horizontal' : 'vertical';
                                var workBoxParentCtrl = this.angularUtil.getControllerFromElement(workBoxParent);
                                var newCloneWorkBox = this.cloneWorkBox(workBoxParentCtrl, directionClone, cloneAll);

                                var newWorkBoxCtrl = this.angularUtil.getControllerFromElement(newWorkBoxElem);

                                var divElem = newWorkBoxCtrl.addChild(newCloneWorkBox, scopeToParent, scopeToParent.element);

                                angular.element(newWorkBoxElem).append(divElem);                               

                            }
                        }
                    }
                }
            }
        }

        return newWorkBoxCtrl.getScopeApi().element;
    }

    postActionInCache(name, data) {

        if (!name) name = null;
        if (!data) data = null;

        var action = new Object();

        action.NAME = name;
        action.DATA = data;
        action.WORKBOX_SELECTED = this._workBoxSelected;//Automaticamente a o box selecionado é "cacheado".
        action.WORKBOX_DETACHED = this._workBoxDetached;//Automaticamente a o box destacado é "cacheado"

        this._cacheToUndoAction.addItemAt(action, 0);
        this._cacheToUndoAction.refresh(false, false, true);

        //O tamanho do cache é limitado.
        if (this._cacheToUndoAction.length() > this.MAX_ACTIONS_IN_CACHE) {
            this._cacheToUndoAction.removeItemAt(this._cacheToUndoAction.length - 1);
        }

        this.updateStatusTools();
    }

    buildWorkBox(directionParent, percentSize, hasChildren, changeLayout, resizeToPixel) {

        if (!directionParent) {
            directionParent = null;
        }

        if (!percentSize) {
            percentSize = 100;
        }

        var workBoxElem;

        if (directionParent == "H" || directionParent == "horizontal") {

            workBoxElem = this.angularUtil.createDirective(this.WORK_BOX, {
                'id': 'workbox' + this.stringUtils.nextUid(),
                'sk-percent-width': percentSize + '%',
                'sk-width': '100%',
                'sk-height': '100%',
                'style': 'margin:0px !important',
                'sk-direction-layout': 'H',
                'sk-has-children': hasChildren ? 'S' : 'N',
                'sk-tamanho-relativo' : percentSize,
                'sk-relative-size' : percentSize,
                'ng-transclude': '',
                'sk-change-layout': changeLayout ? true : false,
                'sk-resize-to-pixel': resizeToPixel ? true : undefined
            }, this._scope);
        } else {

            workBoxElem = this.angularUtil.createDirective(this.WORK_BOX, {
                'id': 'workbox' + this.stringUtils.nextUid(),
                'sk-percent-height': percentSize + '%',
                'sk-width': '100%',
                'sk-height': '100%',
                'style': 'margin:0px !important',
                'sk-direction-layout': 'V',
                'sk-has-children': hasChildren ? 'S' : 'N',
                'sk-tamanho-relativo' : percentSize,
                'sk-relative-size' : percentSize,
                'ng-transclude': '',
                'sk-change-layout': changeLayout ? true : false,
                'sk-resize-to-pixel': resizeToPixel ? true : undefined
            }, this._scope);
        }

        this.addWorkBoxListeners(workBoxElem);

        return workBoxElem;
    }

    getSelectedWorkBox() {
        return this._workBoxSelected;
    }

    set dragEnterWorkBoxHandler(f) {
        this._dragEnterWorkBoxHandler = f;
        this.addWorkBoxListeners(this._workBox);
    }

    set dragDropWorkBoxHandler(f) {
        this._dragDropWorkBoxHandler = f;
        this.addWorkBoxListeners(this._workBox);
    }

    set dragOverWorkBoxHandler(f) {
        this._dragOverWorkBoxHandler = f;
        this.addWorkBoxListeners(this._workBox);
    }

    set configTool(configTool) {
        this._configTool = configTool;
    }

    addWorkBoxListeners(workBox) {

        if (workBox) {

            workBox[0].addEventListener('click', e => this.workBoxSelected(e));

            if (this._dragDropWorkBoxHandler != null) {
                workBox[0].addEventListener('drop', this._dragDropWorkBoxHandler);
            }

            if (this._dragOverWorkBox != null) {
                workBox[0].addEventListener('dragover', this._dragOverWorkBox);
            }
        }
    }

    getChildWithClass(parent, classChild) {
        let childWithClass = null; 
        const childRen = parent.children;
        if (angular.isDefined(childRen) && childRen.length > 0) {
            for (var i = 0; i < childRen.length && !childWithClass; i++) {
                var child = childRen[i];
                if (child.className.indexOf(classChild) > -1) {
                    childWithClass = child;
                }
            }
        }
        return childWithClass;
    }

    getDirectionClass(element) {
        return element.getAttribute('sk-direction') 
            ? this.stringUtils.replaceAll(element.getAttribute('sk-direction'), "'", "") 
            : "";
    }
}
/*
 * Created by Handz (Eduardo,Charles).
 * Modified by jonathan.silva.
 */
angular
    .module('snk.commons.layout')
    .component('skLayoutConfigTool', {
        templateUrl: 'commons/layout/layout-config-tool.tpl.html',
        controller: 'LayoutConfigToolController',
        bindings: {
            onCreateComplete: '&',
            divideWorkBoxHandler: '&?',
            undoLastActionHandler: '&?',
            deleteWorkBoxHandler: '&?',
            detachWorkBoxHandler: '&?',
            insertWorkBoxHandler: '&?',
            joinWorkBoxsHandler: '&?',
            copyWorkBoxHandler: '&?',
            clearWorkBoxHandler: '&?',
            cutWorkBoxHandler: '&?',
            pastWorkBoxHandler: '&?',
            eventBusEditor: "=",
            viewLayout: "="
        }
    }).controller('LayoutConfigToolController', ['$scope', '$document', '$timeout', 'i18n', 'ServiceProxy', 'FieldInfoService', 'MGEParameters', 'AngularUtil', 'StringUtils', 'SkConstants', '$q',
        function ($scope, $document, $timeout, i18n, ServiceProxy, FieldInfoService, MGEParameters, AngularUtil, StringUtils, SkConstants, $q) {
            var self = this;

            var _publicAPI = {};
            var _imgAddBoxBefore;
            var _imgAddBoxAfter;

            var btnDetachSelected = false;


            self.tabSelectedIndex = 0;
            self.imgVerticalAlign = "/mge/assets/svg/btnVerticalAlign.svg";
            self.imgHorizontalAlign = "/mge/assets/svg/btnHorizontalAlign.svg";

            var _imgVAddBoxBeforeIcon = "/mge/assets/svg/btnVAddBoxBefore.svg";
            var _imgVAddBoxAfterIcon = "/mge/assets/svg/btnVAddBoxAfter.svg";

            var _imgHAddBoxBeforeIcon = "/mge/assets/svg/btnHAddBoxBefore.svg";
            var _imgHAddBoxAfterIcon = "/mge/assets/svg/btnHAddBoxAfter.svg";

            var LAYOUT_TOP_DOWN = "T";
            var LAYOUT_PERSONALIZADO = "P";

            //Buttons
            self.statusBtnDesfazerEnabled = false;
            self.statusBtnExcluirEnabled = false;
            self.statusBtnColarEnabled = false;
            self.statusBtnRecortarEnabled = false;
            self.statusBtnCopiarEnabled = false;
            self.statusBtnLimparEnabled = false;
            self.statusBtnMesclarEnabled = false;

            self.btnAreaDestaqueShow = true;
            self.btnDesfazerShow = true;
            self.btnExcluirShow = true;
            self.btnColarShow = true;
            self.btnRecortarShow = true;
            self.btnCopiarShow = true;
            self.btnLimparShow = true;
            self.btnMesclarShow = true;
            self.insertLayout = false;
            self.enableDivideHorizontal = true;

            self.textQtdColsDividir;
            self.textQtdColsInserir;

            //Functions
            self.$onInit = $onInit;

            self.undoLastAction = undoLastAction;
            self.deleteWorkBox = deleteWorkBox;
            self.pastWorkBox = pastWorkBox;
            self.cutWorkBox = cutWorkBox;
            self.copyWorkBox = copyWorkBox;
            self.clearWorkBox = clearWorkBox;
            self.detachWorkBox = detachWorkBox;
            self.joinWorkBoxs = joinWorkBoxs;
            self.divideWorkBox = divideWorkBox;
            self.insertWorkBox = insertWorkBox;
            self.layoutProperties = layoutProperties;

            self.optionsLayout = [{ label: i18n('Controls.Layout.labelLayoutTopDown'), data: LAYOUT_TOP_DOWN, type: "check", toggled: _statusBtnLayout },
            { label: i18n('Controls.Layout.labelLayoutPersonalizado'), data: LAYOUT_PERSONALIZADO, type: "check", toggled: _statusBtnLayoutPers }];

            //Functions Public
            _publicAPI.statusBtnExcluir = statusBtnExcluir;
            _publicAPI.statusBtnDesfazer = statusBtnDesfazer;
            _publicAPI.statusBtnDestaque = statusBtnDestaque;
            _publicAPI.statusBtnJoinWorkBoxs = statusBtnJoinWorkBoxs;
            _publicAPI.statusBtnColar = statusBtnColar;
            _publicAPI.statusBtnCopiar = statusBtnCopiar;
            _publicAPI.statusBtnLimpar = statusBtnLimpar;
            _publicAPI.statusBtnRecortar = statusBtnRecortar;
            _publicAPI.btnExcluir = btnExcluir;
            _publicAPI.btnDesfazer = btnDesfazer;
            _publicAPI.btnDestaque = btnDestaque;
            _publicAPI.btnJoinWorkBoxs = btnJoinWorkBoxs;
            _publicAPI.btnColar = btnColar;
            _publicAPI.btnCopiar = btnCopiar;
            _publicAPI.btnLimpar = btnLimpar;
            _publicAPI.btnRecortar = btnRecortar;
            _publicAPI.btnAreaDestaque = btnAreaDestaque;
            _publicAPI.insertionModeActivated = insertionModeActivated;
            _publicAPI.setLayout = setLayout;
            _publicAPI.posicionarLayout = posicionarLayout;
            _publicAPI.getLayout = getLayout;
            _publicAPI.menuLayoutChange = menuLayoutChange;

            var _statusBtnLayout = false;
            var _statusBtnLayoutPers = false;

            _publicAPI.directionInsertWorkBox = directionInsertWorkBox;

            function $onInit() {
                self.layout = LAYOUT_PERSONALIZADO;
                self.layoutImgSrc = "server-plus";

                self.onCreateComplete({
                    $instance: _publicAPI
                });

                self.imgHAddBoxBefore = _imgHAddBoxBeforeIcon;
                self.imgHAddBoxAfter = _imgHAddBoxAfterIcon;

                $scope.$watch('$ctrl.viewLayout', function (newV) {
                    self.layout = newV || LAYOUT_PERSONALIZADO;
                    self.layoutImgSrc = LAYOUT_TOP_DOWN ? "server-plus" : "server";

                    var apiViewLayout = getApiFromElement(angular.element(document.querySelector('#listViewLayout')));

                    if (apiViewLayout) {
                        // apiViewLayout.setSelection(newV == LAYOUT_TOP_DOWN ? self.optionsLayout[0] : self.optionsLayout[1], true);

                        var _optionsLayout;
                        if (self.layout == LAYOUT_TOP_DOWN) {
                            self.optionsLayout[1].toggled = false;
                            self.optionsLayout[0].toggled = true;

                            _optionsLayout = self.optionsLayout[0];
                            
                            self.layoutImgSrc = "server";
                            
                            apiViewLayout.setSelectionChecked(0);
                        } else {
                            self.optionsLayout[0].toggled = false;
                            self.optionsLayout[1].toggled = true;

                            _optionsLayout = self.optionsLayout[1];
                            
                            self.layoutImgSrc = "server-plus";
                            
                            self.enableDivideHorizontal = true;
                            
                            apiViewLayout.setSelectionChecked(1);
                        }

                        apiViewLayout.setSelection(_optionsLayout , true);
                    }

                    blockActionsWhenTopDownLayout();
                });

            }

            function getApiFromElement(element) {
                var data = angular.element(element).data();

                for (var key in data) {
                    if (data[key].api) {
                        return data[key].api
                    }
                }

                return undefined;
            }

            function layoutProperties() {
                //var deferred = $q.defer();

                var apiViewLayout = getApiFromElement(angular.element(document.querySelector('#listViewLayout')));
                if (apiViewLayout) {
                    self.optionsLayout.forEach(function(layout, indice){
                        if(layout.toggled == true){
                            apiViewLayout.setSelectionChecked(indice);
                        }
                    })
                }
                return {
                    layoutOptions: self.optionsLayout,
                    menuLayoutChange: menuLayoutChange
                };
                
            }

            function menuLayoutChange(layout) {
                var old = self.optionsLayout[0].toggled;

                if (layout.data == LAYOUT_TOP_DOWN) {                   

                    self.optionsLayout[0].toggled = true;

                    self.optionsLayout[1].toggled = false;

                    self.layout = LAYOUT_TOP_DOWN;

                    changeLayout();

                } else if (layout.data == LAYOUT_PERSONALIZADO) {

                    self.optionsLayout[0].toggled = false;
                    self.optionsLayout[1].toggled = true;
                    
                    self.layout = LAYOUT_PERSONALIZADO;

                    changeLayout();

                }
                
                self.layoutImgSrc = layout.data == LAYOUT_PERSONALIZADO ? "server-plus" : "server";
                
                if(old != self.optionsLayout[0].toggled){
                    self.eventBusEditor.dispatchEvent('gadgetLayoutChange');
                }

            }

            function undoLastAction() {
                if (self.undoLastActionHandler) {
                    self.undoLastActionHandler();
                }
            }

            function deleteWorkBox() {
                if (self.deleteWorkBoxHandler) {
                    self.deleteWorkBoxHandler();
                }
            }

            function pastWorkBox() {
                if (self.pastWorkBoxHandler) {
                    self.pastWorkBoxHandler();
                }
            }

            function cutWorkBox() {
                if (self.cutWorkBoxHandler) {
                    self.cutWorkBoxHandler();
                }
            }

            function copyWorkBox() {
                if (self.copyWorkBoxHandler) {
                    self.copyWorkBoxHandler();
                }
            }

            function clearWorkBox() {
                if (self.clearWorkBoxHandler) {
                    self.clearWorkBoxHandler();
                }
            }

            function detachWorkBox() {
                if (self.detachWorkBoxHandler) {
                    self.detachWorkBoxHandler({ toDetach: !btnDetachSelected });
                }
            }

            function joinWorkBoxs() {
                if (self.joinWorkBoxsHandler) {
                    self.joinWorkBoxsHandler();
                }
            }

            function divideWorkBox(direction) {
                if (self.divideWorkBoxHandler) {
                    self.divideWorkBoxHandler({ direction: direction, numberCols: Number(self.textQtdColsDividir) });
                }
            }

            function insertWorkBox(position) {
                if (self.insertWorkBoxHandler) {
                    self.insertWorkBoxHandler({ position: position, numberCols: Number(self.textQtdColsInserir) });
                }
            }

            function statusBtnExcluir(status) {
                self.statusBtnExcluirEnabled = status;
            }
            function statusBtnDesfazer(status) {
                self.statusBtnDesfazerEnabled = status;
            }
            function statusBtnDestaque(status) {
                btnDetachSelected = status;
            }
            function statusBtnJoinWorkBoxs(status) {
                self.statusBtnMesclarEnabled = status;
            }
            function statusBtnColar(status) {
                self.statusBtnColarEnabled = status;
            }
            function statusBtnCopiar(status) {
                self.statusBtnCopiarEnabled = status;
            }
            function statusBtnLimpar(status) {
                self.statusBtnLimparEnabled = status;
            }
            function statusBtnRecortar(status) {
                self.statusBtnRecortarEnabled = status;
            }

            function btnExcluir(visible) {
                self.btnExcluirShow = visible;
            }
            function btnDesfazer(visible) {
                self.btnDesfazerShow = visible;
            }
            function btnDestaque(visible) {
                self.btnAreaDestaqueShow = visible;
            }
            function btnJoinWorkBoxs(visible) {
                self.btnMesclarShow = visible;
            }
            function btnColar(visible) {
                self.btnColarShow = visible;
            }
            function btnCopiar(visible) {
                self.btnCopiarShow = visible;
            }
            function btnLimpar(visible) {
                self.btnLimparShow = visible;
            }
            function btnRecortar(visible) {
                self.btnRecortarShow = visible;
            }
            function btnAreaDestaque(visible) {
                self.btnRecortarShow = visible;
            }

            function insertionModeActivated() {
                _insertLayout = true;
            }

            function setLayout(layout) {
                self.layout = layout;
            }


            function getLayout() {
                return self.layout || LAYOUT_PERSONALIZADO;
            }

            function posicionarLayout() {
                
            }

            function blockActionsWhenTopDownLayout() {
                self.enableDivideHorizontal = self.layout != LAYOUT_TOP_DOWN;
            }

            function changeLayout() {
                blockActionsWhenTopDownLayout();
            }

            function directionInsertWorkBox(direction) {

                if (direction == "horizontal") {
                    _imgAddBoxBefore = _imgHAddBoxBeforeIcon;
                    _imgAddBoxAfter = _imgHAddBoxAfterIcon;
                } else {
                    _imgAddBoxBefore = _imgVAddBoxBeforeIcon;
                    _imgAddBoxAfter = _imgVAddBoxAfterIcon;
                }

                $timeout(() => {
                    updateIcons();
                });
            }

            function updateIcons() {

                self.imgHAddBoxBefore = _imgAddBoxBefore;
                self.imgHAddBoxAfter = _imgAddBoxAfter;

                AngularUtil.apply($scope);
            }
        }]);
/*
 * Created by jonathan.silva.
 */
angular
	.module('snk.commons.layout')
	.service('LayoutConfigService',
		function () {
			var self = this;

			self.create = create;

			function create($injector, configTool, baseWorkBox, eventName, scope, eventBusEditor) {
				return new LayoutConfigManager($injector, configTool, baseWorkBox, eventName, scope, eventBusEditor);
			}
		}
	);
angular
  .module('snk.commons.liberacoes')
  .controller('PopUpSolicLibOrcamentoController', ['$scope', 'dataValue', 'DoubleFacePanelConstants', '$popupInstance', 'ArrayUtils', 'ObjectUtils', 'GridConfig', 'SkApplicationInstance', 'i18n',
  function ($scope, dataValue, DoubleFacePanelConstants, $popupInstance, ArrayUtils, ObjectUtils, GridConfig, SkApplicationInstance, i18n) {
      var self = this;

      ObjectUtils.implements(self, IFormInterceptor);
      self.interceptBuildField = interceptBuildField;
      self.acceptField = acceptField;

      self.interceptMetadata = interceptMetadata;

      // Inicializações
      self.onDatasetCreated = onDatasetCreated;
      self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
      self.onDoubleFacePanelClick = onDoubleFacePanelClick;

      self.dsTransf;
      self.dblFacePanel;
      self.resourceID = SkApplicationInstance.getResourceID();
      self.gridConfigId = self.resourceID + '.dbgTransf';

      $scope.$success = confirm;
      $scope.$dismiss = closeMe;

      var _editableFields = ["TIPO", "OBSERVACAO"];
      var _searchFields = ["CODMETA", "CODUSU", "CODUSULIB", "CODCENCUS", "CODNAT", "CODPROJ", "CODPROD", "CODLOCAL"];

      self.allFields = ["TIPO","OBSERVACAO","CODMETA","DTREF","CODUSU","CODUSULIB","VLRDESDOB","VALOR","CODCENCUS","CODNAT","CODPROJ","CODPROD","CODLOCAL","CONTROLE","MARCA"];

      // Metodo init
      init();
      function init() {
          loadConfig();
          GridConfig.registerGridConfig(self.gridConfigId, self.gridConfigId, undefined, true);            

          // Para carregar as configurações da grade
          function loadConfig() {
             SkApplicationInstance.getConfiguracaoTela(self.gridConfigId);
          }
       
      }

      function onDatasetCreated(dataset) {
          self.dsTransf = dataset;
          self.dsTransf.init();

          self.dsTransf.whenMetadataLoaded().then(()=>{
              getDataValue();
          });
      }

      function getDataValue() {
          if(dataValue && dataValue.transferencias && dataValue.transferencias.entity) {
              var entities = ArrayUtils.toArray(dataValue.transferencias.entity);

              if(entities) {

                  entities.forEach(function (entity) {
                      let object={};
                      if(entity) {
                          ObjectUtils.forEachInObject(entity, function(key, value) {
                             var replace= key.replace("_",".");
                             object[replace]=value;
                          });
                          self.dsTransf.addRecordsAsObjects(montarRecord(object));
                         
                      }
                  });

                  self.dsTransf.sortRecords();
              }
          }
      }

      function montarRecord(oldRecord) {
          var newRecord = {}

          Object.keys(oldRecord).map(key => (newRecord[key] = oldRecord[key]["$"]));

          return newRecord;
      }

      function interceptBuildField(fieldName, dataset, fieldProp, scope) {
        if (ArrayUtils.isIn(_searchFields, fieldName)) {
          fieldProp['sk-notify-description-change-to-data-set'] = false;
        }

          if(fieldName=="CODMETA" || fieldName=="CODUSULIB" || fieldName=="CODCENCUS" || fieldName=="CODUSU" || fieldName=="CODNAT" || fieldName=="CODPROJ"|| fieldName=="CODPROD" || fieldName=="CODNAT"|| fieldName=="CODLOCAL"){
              fieldProp['sk-notify-description-change-to-data-set'] = true;
          }

      }

      function acceptField(fieldMetadata, dataset) {
        return ArrayUtils.isIn(self.allFields, fieldMetadata.name);
      }

      function interceptMetadata(fields) {
          for (var i = 0; i < fields.length; i++) {
              var field = fields[i];

              if (!ArrayUtils.isIn(_editableFields, field.name)) {
                  field.readOnly = true;
              }
          }
      }

      function onDoubleFacePanelCreated(dblFacePanel) {
          self.dblFacePanel = dblFacePanel;
      }

      function onDoubleFacePanelClick () {
          self.dblFacePanel.setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
      }

      function confirm() {
          var tipo = "";
          var obs = "";

          for (var i = 0; i < self.dsTransf.size(); i++) {
              tipo += (self.dsTransf.getRecordAsObject(i)["CODMETA"] + ";" + self.dsTransf.getRecordAsObject(i)["TIPO"] + "|");
              
              var obsCurrent = self.dsTransf.getRecordAsObject(i)["OBSERVACAO"];
              
              if (obsCurrent) {
				  obsCurrent = obsCurrent.replace(/[|;]/g, "");
                  obs += (self.dsTransf.getRecordAsObject(i)["CODMETA"] + ";" + obsCurrent + "|");
              }
          }
          
          dataValue["TIPO"] = tipo;
          dataValue["OBSERVACAO"] = obs;

          success(dataValue);
      }
      
      function success(data) {
          $popupInstance.success(data);
      }

      function closeMe() {
          $popupInstance.dismiss();
      }
  }
]);
angular
  .module('snk.commons.liberacoes')
  .service('PopUpSolicLibOrcamento', ['SanPopup', 'i18n',
    function (SanPopup, i18n) {
      var self = this;

      self.show = show;

      function show(title, data) {
        var popupInstance = SanPopup.open({
          title: title,
          templateUrl: "commons/liberacoes/liberacaoOrcamento/popupSolicLibOrcamento.tpl.html",
          controller: "PopUpSolicLibOrcamentoController",
          controllerAs: "ctrl",
          size: "lg",
          height: 540,
          cancelBtnLabel: i18n("Geral.lblFechar"),
          showBtnOk: true,
          okBtnLabel: i18n("Geral.buttonOK"),
          resolve: {
            dataValue: data
          }
        });

				return popupInstance;
      }
    }
  ]);
/*
 *  Createad by Leonardo Mendes on 17/12/2019.
 */
/**
 * @ngdoc component
 * @name snk.commons.liberacoes.component:sk-liberacoes
 * @description
 *  sk-liberacoes é um componente reponsavél manipular a liberação e composto por uma grade e um formulário
 * 
 * @param {object} sk-data O objeto contento as liberações.
 * @param {function} sk-close-function Função de fechamento de um Popup.
 * @param {boolean=false} sk-ajustaperc-lib-lim Condição para ajustar a precisão do valor.  
 * @param {number=2} sk-precision-to-mask Quantidade de casas decimais para precisão do valor  
 */
angular
    .module('snk.commons.liberacoes')
    .component('skLiberacoes', {
        templateUrl: 'commons/liberacoes/liberacoes/liberacoes.tpl.html',
        controller: 'skLiberacoesController',
        controllerAs: 'ctrl',
        bindings: {
            data: '=?skData',
            closeFunction: '&?skCloseFunction',
            ajustaPercLibLim: '=?skAjustaPercLibLim',
            precisionToMask: '=?skPrecisionToMask',
            showControlBar: '=?skShowControlBar'
        }
    });
angular
    .module('snk.commons.liberacoes')
    .controller('skLiberacoesController', ['AngularUtil', '$scope', 'GridConfig', 'StringUtils', 'ArrayUtils','ServiceProxy', 'SkApplicationInstance', 'MessageUtils', 'i18n', 'MGEParameters', 'Criteria', 'NumberUtils', 'ObjectUtils','DoubleFacePanelConstants',
        function (AngularUtil, $scope, GridConfig, StringUtils, ArrayUtils,ServiceProxy, SkApplicationInstance, MessageUtils, i18n, MGEParameters, Criteria, NumberUtils, ObjectUtils, DoubleFacePanelConstants) {
            var self = this;
			
			ObjectUtils.implements(self, IDatagridInterceptor);
			ObjectUtils.implements(self, IDataSetObserver);
			ObjectUtils.implements(self, IFilterPanelInterceptor);
			ObjectUtils.implements(self, IGridPrinterInterceptor);
			ObjectUtils.implements(self, IFormInterceptor);

			var _carregandoDataSet = true;
			var _salvou = false;
			var _chave;
			var _excluirLiberacoesFechar = MGEParameters.asBoolean("com.exclui.liberacoes.fechar.sem.salvar");
			
			self.precision = 9;
			self.prettyPrecision = 2;
			self.enviaNotif = true;
			self.gridConfigLiberacoes = SkApplicationInstance.getResourceID() + '.liberacoes';
			self.changeButtonActions = [
                {
                    label: i18n('Controls.GridConfig.buttonGridConfig'), action: function(){
						GridConfig.openGridconfig(self.gridConfigLiberacoes);
					}
                }
			];
			
			self.currentLineChanged = currentLineChanged;

			self.cellFormatterValor = cellFormatterValor;
			self.cellFormatterPerc = cellFormatterPerc;
			self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.onDblClickGrid = onDblClickGrid;
			self._resourceID = SkApplicationInstance.getResourceID() + ".painelliberacao";
			self.createDataSet = createDataSet;
			self.onDatagridLoaded = onDatagridLoaded;
			self.criterioLiberador = criterioLiberador;
			self.liberadorHandler = liberadorHandler;
			self.liberarEvento18 = liberarEvento18;
			self.saveHandler = saveHandler;
			self.mostrarBotaoLiberar = false;
			self.habilitarBotaoLiberar = false;
			self.close = close;
			self.showControlBar = true;
			self.focusBotaoLiberar=focusBotaoLiberar;
			self.onChangeFace = onChangeFace;
			self.dblFacePanel;
			
			init();
			function init(){
				self.precisionToMask = MGEParameters.asString("com.mascara.perc.desc");
				getPrecisionToMask();
				
				GridConfig.registerGridConfig(self.gridConfigLiberacoes, self.gridConfigLiberacoes, undefined, true);
				
				var buttonContainerID = document.getElementById('buttonContainerID');
				if (buttonContainerID) {
					var buttonContainer = '<sk-hbox ng-show="ctrl.showControlBar" layout-align="end center" gap="5">'+
					'	  <button default ng-click="ctrl.liberarEvento18()" id="btnLiberar" ng-show="ctrl.mostrarBotaoLiberar" ng-disabled="!ctrl.habilitarBotaoLiberar" sk-i18n>Commons.Liberacoes.buttonLiberar</button>'+
					'   <button default ng-click="ctrl.close()" id="btnFechar" sk-i18n>Geral.lblFechar</button>'+
					'   <button class="btn btn-primary" ng-click="ctrl.saveHandler()" tabindex="0" id="btnSalvar" sk-i18n>Geral.buttonSalvar</button>'+
					'</sk-hbox>';
					angular.element(buttonContainerID).replaceWith(AngularUtil.compile(buttonContainer, $scope));
									
					var btnSalvar = document.getElementById("btnSalvar");				
						btnSalvar.addEventListener('keydown', (e) =>{
							var evt = e || window.event;
							var keyCode = evt.which || evt.keyCode;
							if(keyCode === 9) { // TAB pressed
								if(evt.preventDefault) evt.preventDefault();
								document.getElementById("pesquisaLiberador").children[0].children[0].focus();								
							}
						})
				}
			}

			function onChangeFace(face){
				if(face === 1){
					self.pesqLibEnabled = true;
				} else {
					updateStatusFields();
				}
			}

			function onDatagridLoaded(datagrid) {
                self.gridLiberacoes = datagrid;
			}
			
			function onDoubleFacePanelCreated(dblFacePanel) {
                if (dblFacePanel) {
                    self.dblFacePanel = dblFacePanel;
                }
            }

            function onDblClickGrid() {
                self.dblFacePanel.setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
            }
			
			function cellFormatterValor(column, value, record){
				return NumberUtils.format(NumberUtils.getNumberOrZero(value), self.precision, self.prettyPrecision);
			}

			function cellFormatterPerc(column, value, record){
				return NumberUtils.format(NumberUtils.getNumberOrZero(value), self.decimaisPerc);
			}


			self.createDataSetTeste = function(dataset){
				self.dataSet = dataset;
				self.dataSet.initAndRefresh();
			}

			function createDataSet(dataset){
				self.dataSet = dataset;

				self.dataSet.addDataModifiedListener(function(fieldId){
					var vlrTotal = self.dataSet.getFieldValue("VLRTOTAL");
					var vlrAtual = self.dataSet.getFieldValue("VLRATUAL");
					
					if(vlrTotal){
						if(fieldId == "VLRATUAL"){
							self.dataSet.setFieldValue("PERCATUAL", self.ajustaPercLibLim ? getPercAtual(vlrTotal, self.dataSet.getFieldValue("VLRATUAL")) : NumberUtils.getNumberOrZero(self.dataSet.getFieldValue("VLRATUAL")) / vlrTotal * 100);
							if(!_carregandoDataSet) {
								self.dataSet.setFieldValue("ALTEROUVALOR", "S");
							}
						} else if(fieldId == "PERCATUAL"){
							var perc = NumberUtils.getNumberOrZero(self.dataSet.getFieldValue("PERCATUAL"));
							self.dataSet.setFieldValue("VLRATUAL", NumberUtils.round(perc * vlrTotal / 100, 2));
						}
					}

					_habilitarBotaoLiberar = self.dataSet.getFieldValueAsString("DHLIB") == null || self.dataSet.getFieldValueAsString("DHLIB") == "";
				});

				self.dataSet.addObserver(self);
				
				self.dataSet.init();

				setLiberacoes();	
				
				let btnSalvarLiberacoes = document.getElementById("btnSalvarLiberacoes");				
				btnSalvarLiberacoes.addEventListener('keydown', (e) =>{
							if(e.code.toLowerCase() === "tab") { 
								self.gridLiberacoes.setFocus()
								setTimeout(() => {
									self.gridLiberacoes.getGridApi().ensureIndexVisible(0);
									let firstCol = self.gridLiberacoes.getGridOptions().columnApi.getAllDisplayedColumns()[0];
									self.gridLiberacoes.getGridOptions().api.ensureColumnVisible(firstCol);
									self.gridLiberacoes.getGridOptions().api.setFocusedCell(0, firstCol);						
								}, 100);
							}
							
				})
            }
			

			function currentLineChanged(newIndex){
				self.mostrarBotaoLiberar = self.dataSet.getFieldValueAsString("EVENTO") == "18";
				self.habilitarBotaoLiberar = self.dataSet.getFieldValueAsString("DHLIB") == null || self.dataSet.getFieldValueAsString("DHLIB") == "";
				
				updateStatusFields();
			}

			function setLiberacoes(){
				var liberacoes = (angular.isArray(self.data) && self.data.length == 1 && angular.isArray(self.data[0].liberacao)) ? self.data[0].liberacao : (angular.isArray(self.data) ? self.data : ArrayUtils.toArray(ObjectUtils.getProperty(self,'data.liberacao')));
				
				self.dataSet.clearDataSet();
	
				//Coleciono o codigo dos usuarios pra buscar o nome.
				//Isso porque o DataSet e standAlone.
				var codUsu = [];
				liberacoes.forEach(function(e){
					var strLiberador =  angular.isDefined(e.liberador) ? e.liberador : e.liberacao.liberador;
					if(strLiberador){
						codUsu.push(strLiberador);
					}
					
					var strSolicitante = angular.isDefined(e.solicitante) ? e.solicitante : e.liberacao.solicitante;
					if(strSolicitante){
						codUsu.push(strSolicitante);
					}
				});	

				if(codUsu.length == 0){
					prepararLiberacoes(liberacoes);
				} else {
					
					var expression = "CODUSU in (" + codUsu.join(",") + ")";

					var params = {
						entity: {
							name: "Usuario",
							literalCriteria: {
								expression: {$: expression}
							},
							fields: {
								field: [
									{name:"CODUSU"},
									{name:"NOMEUSU"}
								]
							}
						}
					}

					ServiceProxy.callService("mge@crud.find", params)
						.then(function(result){
							prepararLiberacoes(liberacoes, result.responseBody.entidades.entidade);
						}
					);
				}	

				self.pesqMultiLibEnabled = false;
			}
			
			function close() {
				if (self.closeFunction) {
					if (!_salvou && _excluirLiberacoesFechar && _chave) {
						var liberacoes = {
							liberacao: {
								nuChave: _chave,
							}
						}
						ServiceProxy.callService(
							"mge@LiberacaoAlcadaSP.excluiLiberacoes",
							liberacoes,
							function(result){},
							true
						);
					};
					_salvou = false;
					self.closeFunction();
				}
			}

			function getPercAtual(vlrTotal, vlrAtual) {
				var percAtual = 0;
			
				if (self.dataSet != null) {
					if (vlrTotal != 0 && !isNaN(vlrTotal)) {
						var percAtualOrig = vlrAtual / vlrTotal * 100;
						var percAtualOrigArred = NumberUtils.round(percAtualOrig, (self.decimaisPerc + 1));

						/*
						* Esse if foi criado porque se for maior que dois tem que ser respeitado a quantidade de casas decimais do 
						* parametro senao da diferenca no valor apresentado na tela (esse valor serve apenas para visualizacao)
						* porem quando liberava o valor liberado era o correto
						*/
						if(self.decimaisPerc > 2){
							percAtual = percAtualOrigArred;
						} else {
							percAtual = NumberUtils.round(percAtualOrig / 0.05, 0) * 0.05;							
						}

						var indice = NumberUtils.round(percAtualOrigArred - percAtual, (self.decimaisPerc + 1));
						
						if (!(indice >= -0.01 && indice <= 0.01) || indice == 0) {
							percAtual = percAtualOrig;
						}
					}
				}
				return percAtual;
			}

			
			function prepararLiberacoes(liberacoes, nomesUsuario){

				var _nomeUsuarios = {};
				ArrayUtils.toArray(nomesUsuario).forEach(function(e){
					_nomeUsuarios[e.CODUSU.$] = e.NOMEUSU.$;
				});
	
				insereLiberacoes(liberacoes, _nomeUsuarios);
			}
	
			function insereLiberacoes(liberacoes, nomeUsuarios){
				_carregandoDataSet = true;
				
				self.dataSet.goToInsertionMode().then(function(){

					_chave = undefined;
					var Liberacoes = [];

					for(var i = 0; i < liberacoes.length; i++){
						let liberacaoTmp = liberacoes[i];
						
						if(liberacaoTmp.liberacao) {
							liberacaoTmp = liberacaoTmp.liberacao;
						}
					
						if(liberacaoTmp) {
							var liberacao = {};
							if (!_chave) {
								_chave = liberacaoTmp.chave;
							}
	
							liberacao["NUCHAVE"] = liberacaoTmp.chave;
							liberacao["EVENTO"] = liberacaoTmp.evento;
							liberacao["ViewEventoLiberacao.DESCRICAO"] = liberacaoTmp.descricaoEvento;
							liberacao["TABELA"] = liberacaoTmp.tabela;
							liberacao["SEQUENCIA"] = liberacaoTmp.sequencia;
							liberacao["SEQCASCATA"] = liberacaoTmp.seqCascata;
							liberacao["OBSERVACAO"] = liberacaoTmp.descricao;
							liberacao["OBSLIB"] = liberacaoTmp.obsLiberador;
							liberacao["VLRLIMITE"] = liberacaoTmp.limite;
							liberacao["PERCLIMITE"] = liberacaoTmp.porcentagem;
							liberacao["DHSOLICIT"] = liberacaoTmp.dhSolicitacao;
							liberacao["DHLIB"] = liberacaoTmp.dhLiberacao;
							liberacao["VLRANTERIOR"] = liberacaoTmp.vlrSolicitadoAnterior;
							liberacao["PERCANTERIOR"] = liberacaoTmp.porcentagemAnterior;
							liberacao["TIPEVENTO"] = liberacaoTmp.tipoEvento;
							liberacao["EDITALIBERADOR"] = liberacaoTmp.editaLiberador;
							liberacao["EDITAVLRATUAL"] = liberacaoTmp.editaVlrAtual;
							liberacao["VLRLIBERADO"] = liberacaoTmp.valorLiberado;
	
							var usuSolicitante = liberacaoTmp.solicitante;
							liberacao["CODUSUSOLICIT"] = usuSolicitante;
							liberacao["Usuario2.NOMEUSU"] = nomeUsuarios[usuSolicitante];
	
							var usuLiberador = liberacaoTmp.liberador;
							liberacao["CODUSULIB"] = usuLiberador;
							liberacao["Usuario.NOMEUSU"] = nomeUsuarios[usuLiberador];
	
							var vlrTotal = NumberUtils.getNumberOrZero(liberacaoTmp.valorTotal);
							var vlrAtual = NumberUtils.getNumberOrZero(liberacaoTmp.valorAtual);
	
							liberacao["VLRTOTAL"] = vlrTotal;
							liberacao["VLRATUAL"] = vlrAtual;
	
	
							liberacao["PERCATUAL"] = self.ajustaPercLibLim ? getPercAtual(vlrTotal, vlrAtual) : vlrTotal > 0 ? vlrAtual / vlrTotal * 100 : 0;
	
							liberacao["ENVIANOTIF"] = "true";
							liberacao["HASHLIBERACAO"] = liberacaoTmp.hashLiberacao;
							liberacao["ALTEROUVALOR"] = "N";
							liberacao["NUCLL"] =  StringUtils.isEmpty(liberacaoTmp.nucll) ? '' : NumberUtils.stringToNumber(liberacaoTmp.nucll);
	
							Liberacoes.push(liberacao);
						}
					}

					self.dataSet.addRecordsAsObjects(Liberacoes);
					
					_carregandoDataSet = false;
					
					self.dataSet.gotoRow(0);
				});
			}


			function updateStatusFields(){

				var ehPercentual = NumberUtils.getNumberOrZero(self.dataSet.getFieldValue("VLRTOTAL")) > 0;
				var editaLiberador = self.dataSet.getFieldValueAsString("EDITALIBERADOR") == "true" && (StringUtils.isEmpty(self.dataSet.getFieldValueAsString("CODUSULIB")) || self.dataSet.getFieldValueAsString("CODUSULIB") == "0");
				var editaVlrAtual = self.dataSet.getFieldValueAsString("EDITAVLRATUAL") == "true";
				var editaPercAtual = self.dataSet.getFieldValueAsString("EDITAVLRATUAL") == "true" && ehPercentual;
			
				self.iteFormVlrSolicRequired = editaVlrAtual;
				self.nroPercAtualEnabled = editaPercAtual;
				self.nroVlrAtualEnabled =  editaVlrAtual;
				self.pesqLibEnabled = editaLiberador || self.dblFacePanel.getSelectedIndex() === 1;
			}


            function criterioLiberadorEvento(evento){
				
				var criteria = Criteria();
				
				var valorLimite = NumberUtils.round(self.dataSet.getFieldValueAsNumberOrZero("VLRATUAL") - self.dataSet.getFieldValueAsNumberOrZero("VLRLIMITE"),9);
	
				var percLimite = 0;

				if(self.dataSet.getFieldValueAsNumberOrZero("VLRTOTAL") > 0){
					percLimite = NumberUtils.round((self.dataSet.getFieldValueAsNumberOrZero("VLRATUAL") - self.dataSet.getFieldValueAsNumberOrZero("VLRLIMITE")) / self.dataSet.getFieldValueAsNumber("VLRTOTAL") * 100,14);
				} else if(evento == "42"){
					 percLimite = (self.dataSet.getFieldValueAsNumberOrZero("VLRATUAL") - valorLimite) / valorLimite * 100;
				}

			
				criteria.append("(DTLIMACESSO IS NULL OR DTLIMACESSO >= ?) AND ", Criteria.buildDateParameter("${server.date}"))
				criteria.append(" EXISTS(SELECT 1 FROM TSILIM LIM WHERE (LIM.CODUSU = this.CODUSU OR LIM.CODUSU IN (SELECT S.CODUSU FROM TSISUPL S WHERE S.CODUSUSUPL = this.CODUSU AND S.DTINICIO <= ?", Criteria.buildDateParameter("${server.date}"))
				criteria.append(" AND (S.DTFIM IS NULL OR S.DTFIM >= ?)))", Criteria.buildDateParameter("${server.date}"))
				criteria.append(" AND LIM.EVENTO = ? AND (", Criteria.buildParameter('I', evento))


				if(evento == "13" || evento == "19" || evento == "48"){
					criteria.append(" (LIM.TIPOEVENTO = 'P' AND LIM.LIMITE <= ?) OR ",  Criteria.buildParameter('I', percLimite));

					valorLimite = self.dataSet.getFieldValueAsNumberOrZero("VLRLIMITE") - self.dataSet.getFieldValueAsNumberOrZero("VLRATUAL");
				} else {
					criteria.append(" (LIM.TIPOEVENTO = 'P' AND LIM.LIMITE >= 0 AND LIM.LIMITE >= ?) OR ",  Criteria.buildParameter('I', percLimite));
				}

				criteria.append("  (LIM.TIPOEVENTO = 'V' AND LIM.LIMITE >= 0 AND LIM.LIMITE >= ?) OR ",	Criteria.buildNumberParameter(valorLimite));
				criteria.append("  (LIM.TIPOEVENTO = 'V' AND LIM.LIMITE < 0 AND LIM.LIMITE < ?)	)	)",		Criteria.buildNumberParameter(valorLimite));
						
				return criteria;
			}
			

			function criterioLiberador(){
				return criterioLiberadorEvento(self.dataSet.getFieldValueAsString("EVENTO"));				
			}
		
			
			function liberarEvento18(){
			
				var liberarFunction = function() {
					
					var liberacao = {
						liberacao: {
							nuChave: self.dataSet.getFieldValueAsString("NUCHAVE"),
							tabela: self.dataSet.getFieldValueAsString("TABELA"),
							evento: "18",
							sequencia: self.dataSet.getFieldValueAsString("SEQUENCIA"),
							seqCascata: self.dataSet.getFieldValueAsString("SEQCASCATA"),
							vlrLiberado: "1"
						}				
					}
					ServiceProxy.callService(
						"mge@LiberacaoAlcadaSP.liberarEvento",
						liberacao,
						function(result){
							if (result.responseBody.liberacoes) {
								setLiberacoes(result.responseBody.liberacoes.liberacao);							
							}
							
							MessageUtils.showInfo(i18n('Commons.Liberacoes.messageEvento18Liberado'));
						},
						true
					);
				}

				saveHandler(liberarFunction);				
			}

			
			function saveHandler(liberarFunction){

				var record = self.dataSet.getRecordsAsObjects();
				var liberacao = []
				_salvou = false;

				for(var i = 0; i < record.length; i++){
					var row = {}

					row.chave = record[i].NUCHAVE;
					row.tabela = record[i].TABELA;
					row.evento = record[i].EVENTO;
					row.sequencia = record[i].SEQUENCIA;
					row.descricao = record[i].OBSERVACAO;
					row.solicitante = record[i].CODUSUSOLICIT;
					row.liberador = record[i].CODUSULIB;

					if(record[i].ALTEROUVALOR == "S") {
						row.valorAtual = record[i].VLRATUAL;
					}

					row.seqCascata = record[i].SEQCASCATA;
					row.enviaNotif = (record[i].ENVIANOTIF) == "true" ? "S" : "N";
					row.hashLiberacao = record[i].HASHLIBERACAO;
					row.nucll = record[i].NUCLL;

					liberacao.push(row); 
				};

				ServiceProxy.callService("mge@LiberacaoAlcadaSP.editarLiberacoes", {
					liberacoes: {
						liberacao: liberacao
					}
				}).then(function (ignored, result) {
					_salvou = true;
					(liberarFunction || angular.noop)();
					close();
				})
			}

			
			function liberadorHandler(){	
				if (self.pesqMultiLib == null || self.pesqMultiLib == "") {
					return;
				}

				if (self.pesqMultiLib == null || self.pesqMultiLib == "") {
					return;
				}

				var recordsPk = self.dataSet.getSelectedRecordsPks(true);
				var rowsIndex = [];

				recordsPk.forEach(function (recordPk) {
					var index = self.dataSet.findRecordIndexByPk(recordPk);
					rowsIndex.push(index);
				});
				
				var arrayRecords = self.dataSet.getRecordsAsObjects();
				self.dataSet.clearDataSet();

				arrayRecords.forEach(function (record, index) {
					var editaLiberador = record.EDITALIBERADOR == "true";
					if (rowsIndex.indexOf(index) >= 0  && editaLiberador) {
						record["CODUSULIB"] = self.pesqMultiLib;
						record["Usuario.NOMEUSU"] = self.pesqMultiLibApi.getDescriptionValue();
					}

				});

				self.dataSet.addRecordsAsObjects(arrayRecords);
				setTimeout(function () {
					self.dataSet.gotoRow(0);
				}, 500);
			}

			function getPrecisionToMask() {
				var param = self.precisionToMask;
				
				if (param == "" || param == null) {
					self.decimaisPerc = 2;
				} else {
					var decimaisPerc = param.substring(param.indexOf(".") + 1, param.length);
					self.decimaisPerc = decimaisPerc.length;					
				}
			}

			function focusBotaoLiberar(){
				setTimeout(() => {					
					if(self.mostrarBotaoLiberar){
						document.getElementById('btnLiberar').focus();
					}else{
						document.getElementById('btnFechar').focus();
					}
				}, 0);				
			}

        }
    ]);
/**
 * Created by Leonardo Mendes on 21/12/2019.
 */
/**
 * @ngdoc component
 * @name snk.commons.liberacoes.component:sk-painel-liberacoes
 * @description
 *  sk-painel-liberacoes é um componente reponsavél por criar um painel com tamanho fixo encapsulando o sk-liberacoes
 * 
 * @param {object} sk-liberacoes O objeto contento as liberações.
 * @param {function} sk-close-function Função de fechamento de um Popup.
 * @param {boolean=false} sk-ajustaperc-lib-lim Condição para ajustar a precisão do valor.  
 * @param {number=2} sk-precision-to-mask Quantidade de casas decimais para precisão do valor  
 */
angular
    .module('snk.commons.liberacoes')
    .component('skPainelLiberacoes', {
        templateUrl: 'commons/liberacoes/painelLiberacoes/painelLiberacoes.tpl.html',
        controller: 'PainelLiberacoesController',
        bindings: {
            liberacoes: '=?skLiberacoes',
            closeFunction: '&?skCloseFunction',
            ajustaPercLibLim: '=?skAjustaPercLibLim',
            precisionToMask: '=?skPrecisionToMask'
        }
    })
    .controller('PainelLiberacoesController', ['$scope',
        function ($scope) {
            
    }]);
/**
 * Created by Leonardo Mendes on 19/12/2019.
 */
/**
 * @ngdoc service
 * @name snk.commons.liberacoes.service:PopupLiberacoes
 * 
 * @description
 * Esse serviço permite lançar um popup de liberações.
 */
angular
    .module('snk.commons.liberacoes')
    .service('PopupLiberacoes', ['SanPopup', 'i18n',
        function (SanPopup, i18n) {
            var self = this;

            self.builder = builder;

            /**
             * @ngdoc
             * @name PopupLiberacoes#builder
             * @methodOf snk.commons.liberacoes.service:PopupLiberacoes
             *
             * @description
             * Método responsável por criar um novo Builder de PopupLiberacoes.
             * 
             * <p><b>builder()</b> Metodo de criação do Popup</p>
             * <p><b>ajustaPercLibLim(false)</b> Ajustar o percentual de limite</p>
             * <p><b>liberacoes(undefined)</b> O objeto com as liberações</p>
             * <p><b>closeFunction(undefined)</b> função de fechamento de um Popup</p>
             * <p><b>precisionToMask(2)</b> Precisão de mascara default 2</p>
             * <p><b>show()</b> Metodo para abrir o popup</p>
             *
             * @example
             * ```js
             *      PopupLiberacoes
             *            .builder()
             *            .liberacoes(liberacoesXMLList)
             *            .show();
            * ```
            */
            function builder() {
                return new PopupLiberacoesBuilder();
            }

            function PopupLiberacoesBuilder() {
                var defaultOptions = {
                    title: 'Commons.Liberacoes.buttonLiberacoes',
                    backdrop: 'static',
                    okLabel: 'Geral.lblFechar',
                    showControlBar: true,
                    height: 400
                };

                var _builder = this;

                var _options = {};
                _builder.option = function (key, value) {
                    _options[key] = value;
                    return _builder;
                };
                
                var _builderPopupOptions = ['title','height', 'backdrop', 'okBtnLabel', 'showControlBar'];
                _builderPopupOptions.forEach(function (optionName) {
                    _builder[optionName] = function (value) {
                        return _builder.option(optionName, value);
                    }
                });

                var _data = {};
                _builder.data = function (key, value) {
                    _data[key] = value;
                    return _builder;
                };
                
                var _builderPopupData = ['ajustaPercLibLim','liberacoes', 'closeFunction','precisionToMask'];
                _builderPopupData.forEach(function(optionName) {
                    _builder[optionName] = function(value) {
                        return _builder.data(optionName, value);
                    }
                });

                _builder.show = function () {
                    var options = angular.extend(defaultOptions, _options);
                    _data['showControlBar'] = options.showControlBar;

                    return SanPopup.open({
                        title: i18n(options.title),
                        templateUrl: 'commons/liberacoes/popupLiberacoes/popupLiberacoes.tpl.html',
                        controller: 'PopupLiberacoesController',
                        size: 'lg',
                        height: options.height,
                        backdrop: options.backdrop,
                        showBtnNo: false,
                        showBtnOk: false,
                        showBtnCancel: false,
                        rightBottomBar: ["<div id='buttonContainerID'></div>"],
                        windowClass: 'no-padding-modal-body',
                        resolve: {
                            data: _data
                        }
                    });
                };
            }
        }])
    .controller('PopupLiberacoesController', ['data','$popupInstance','$scope',
        function (data, $popupInstance, $scope) {

            init();
            function init() {
                $scope.liberacaoData = data.liberacoes;
                $scope.ajustaPercLibLim = data.ajustaPercLibLim;
                $scope.precisionToMask = data.precisionToMask;
                $scope.showControlBar = data.showControlBar;
                $scope.closeFunction = close;
            }

            function close() {
            	if (data.closeFunction) {
            		data.closeFunction();
            	}

                $popupInstance.success();
            }
        }
    ]);
angular
    .module('snk.commons')
    .component('skMinicard', {
        templateUrl: 'commons/minicard/minicard.tpl.html',
        bindings: {
            onLoad: '&',
            chartName: '@?skChartName',
            title: '@?skTitle',
            hidePercentage: '@?skHidePercentage',
            isPercentage: '@?skIsPercentage',
            isMoney: '@?skIsMoney',
            isTime: '@?skIsTime',
            resultCallback: '&?skResultCallback'
        },
        controller: 'skMiniCardController'
    })
    .controller('skMiniCardController', ['$element', '$scope', 'AngularUtil', 'i18n', 'HighchartUtils', function ($element, $scope, AngularUtil, i18n, HighchartUtils) {
        var self = this;

        self.$onInit = $onInit;
        self.update = update;
        self.reflow = reflow;
        self.clear = clear;
        self.setTitle = setTitle;

        function $onInit() {
            AngularUtil.setContextControllerInfo($element, $scope, '$ctrl', self);
            self.setTitle(self.title);

            self.onLoad({
                $component: self,
                $grafico: self.chartName,
            });
        }
        
        function update(data) {
            if (data)
                createChart(data);
            else if (self.resultCallback) {
                resultCallback().then(function (response) {
                    let data = angular.copy(response.responseBody);
                    createChart(data);
                }).catch(function (e){
                })
            }
        }

        function clear(msg) {
            if (self.chart) self.chart.destroy();
            self.chart = null;
            let content = '<div class="loading" layout="row" layout-align="center center">';
            if (!msg) content += '<sk-icon svg-src="/mge/assets/svg/loading.svg" class="spin"></sk-icon>';
            content += '<span sk-translate>' + i18n(msg || 'Geral.lblCarregando') + '</span>';
            content += '</div>'
            $("#" + self.chartName).html(content);
        }

        function setTitle(title) {
            self.titulo = i18n(title);
        }

        function getDefaultOptions(color) {
            if (!color) color = Highcharts.getOptions().colors[0];
            return {
                chart: {
                    backgroundColor: null,
                    borderWidth: 0,
                    type: 'area',
                    margin: [2, 0, 2, 0],
                    width: null,
                    height: null,
                    style: {
                        overflow: 'visible'
                    },
                    // small optimalization, saves 1-2 ms each sparkline
                    skipClone: true
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    lineWidth: 0,
                    tickWidth: 0,
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                yAxis: {
                    endOnTick: false,
                    startOnTick: false,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    lineWidth: 0,
                    tickWidth: 0,
                    tickPositions: [0]
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    shared: true,
                    useHTML: true,
                    formatter: function () {
                        let point = this.points[0].point;
                        let data = point.options;
                        let content = '<table class="minicard-tooltip"><tr><th><b>' + point.name + '</b></th></tr>';
                        content += '<tr><td>' + formatValue(point.y) + '</td></tr></table>'
                        return content;
                    },
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, color],
                                [1, Highcharts.color(color).setOpacity(0).get('rgba')]
                            ]
                        },
                        shadow: false,
                        marker: {
                            enabled: false
                        },
                        lineWidth: 2,
                        lineColor: color,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: '#910000',
                        borderColor: 'silver'
                    }
                }
            };
        }
            

        function formatValue(value) {
            if (self.isPercentage) {
                return HighchartUtils.formatPercentage(value) + "%";
            } else if (self.isMoney) {
                return HighchartUtils.formatMoney(value);
            } else if (self.isTime) {
                return HighchartUtils.formatTime(value, true);
            } else {
                return HighchartUtils.formatNumber(value, 2);
            }
        }

        function createChart(data) {
            let chartOptions = {chart: {}};

            if (!data.result) data.result = data;

            if (data.result.title) self.setTitle(data.result.title);

            self.percentage = data.result.percentageTotal ? HighchartUtils.formatPercentage(data.result.percentageTotal) : "";
            self.value = formatValue(data.result.value || 0);
            var infoTotal = HighchartUtils.formatPercentage(data.result.percentage) + "% " + i18n('Commons.Minicard.lblComparadoAnterior') 
            self.info = data.result.percentage && data.result.percentage > 0 ? "+" + infoTotal : infoTotal;

            chartOptions.series = [{
                name: i18n(self.title),
                data: data.result.chartData
            }];

          //  HighchartUtils.resizeChart(null, self.chartName);


            self.chartOptions = Highcharts.merge(getDefaultOptions(data.result.color), chartOptions);
            AngularUtil.timeout( () => self.chart = Highcharts.chart(self.chartName, self.chartOptions), 100);
        }

        function reflow() {
            if (self.chart) self.chart.reflow(); // HighchartUtils.resizeChart(self.chart, self.chartName);
        }

    }]);

angular.module('snk.commons')
    .controller('MultiplosMotivoPerdaPopUpController', ['MessageUtils', 'ServiceProxy', 'AngularUtil', '$scope', 'StringUtils', 'data', 'i18n', '$popupInstance', 'NumberUtils',
        function (MessageUtils, ServiceProxy, AngularUtil, $scope, StringUtils, data, i18n, $popupInstance, NumberUtils) {
            var self = this;
            self.idxFormInputs = 0;
            self.qtdePerda = [];
            self.motivoPerda = [];
            self.totalMotivoPerdaCarregado= 0;
            self.totalQtdePerdaCarregado = 0;
            self.totalMotivoPerdaCarregadoAntigo= 0;
            self.totalQtdePerdaCarregadoAntigo = 0;
            self.isLimparArray = false;

            self.getQtdePerdaDetalhada =  getQtdePerdaDetalhada;
            self.onFormChange = onFormChange;
            self.validaDetalhamento = validaDetalhamento;
            self.excluiDetalhamentos = excluiDetalhamentos;
            self.isApontamentoConfirmado = data.isApontamentoConfirmado;
            self.removerItens = removerItens;
            $scope.$success = saveDetalhamentos;
            $scope.$dismiss = cancelarEdicao;

            self.standAlone = data.standAlone || false;
            var casasDecimais = data.casasDecimais || 0;
            self.detalhamentoMP = data.detalhamentoMP || false;

            self.codProdMP = data.codProdMP;
            self.controleMP = data.controleMP;
            
            $popupInstance.rendered.then(function(){
            	angular.element("#lblTot").html(AngularUtil.compile("<div style='width:430px;'><span><h5 style='display:inline; margin-right: 20px;'><b>" + i18n("Commons.MultiplosMotivoPerdaPopUp.lblQtdePerdasDetalhadas") + "{{ctrl.getQtdePerdaDetalhada()}} / {{ctrl.qtdePerdaTotal}}" + "</b></h5></span>" +
                                                                    "<span><h5 style='display:inline-block;'><b>" + i18n("Commons.MultiplosMotivoPerdaPopUp.lblQtdeMotivosDetalhados") + "{{ctrl.qtdePerda.length}} / {{ctrl.qtdeMotivosPerda}}</b></h5></span></div>", $scope));

                if (!self.standAlone) {
                    carregaDetalhamentos();
                } else {
                    carregaDetalhamentosStandAlone(data.detalhesPerda);
                }
            });
            init();
            
            function init() {
                self.qtdePerdaTotal = NumberUtils.format(data.dataset.getFieldValueAsNumber("QTDPERDA"), casasDecimais, 0);
                self.qtdeMotivosPerda = NumberUtils.format(data.dataset.getFieldValueAsNumber("QTDMPE"), casasDecimais, 0);
            }

            function printNewSimpleForm() {
                angular.element('#popUpDetalhamentoMotivos').append(
                        AngularUtil.compile(`<sk-simple-form flex sk-columns="2">
                                <sk-simple-item sk-label=Commons.MultiplosMotivoPerdaPopUp.lblQtdPerda sk-width="25%">
                                    <sk-number-input sk-value="ctrl.qtdePerda[${self.idxFormInputs}]" sk-change=ctrl.onFormChange() sk-pretty-precision="${casasDecimais}"
                                        sk-precision="${casasDecimais}" sk-enabled=!ctrl.isApontamentoConfirmado></sk-number-input>
                                </sk-simple-item>
                                <sk-simple-item sk-label=Commons.MultiplosMotivoPerdaPopUp.lblMotivoPerda sk-width="75%">
                                    <sk-pesquisa-input id="motivoPerda_${self.idxFormInputs}" sk-entity-name="MotivosPerda" sk-field-name="CODMPE" sk-value="ctrl.motivoPerda[${self.idxFormInputs}]" sk-entity-change=ctrl.onFormChange() sk-enabled=!ctrl.isApontamentoConfirmado>
                                    </sk-pesquisa-input>
                                </sk-simple-item>
                            </sk-simple-form>`, $scope
                ));
            }

            function getQtdePerdaDetalhada() {

                var qtdePerdaDetalhada = 0;
                if (self.qtdePerda.length == 0)
                    return 0;
                
                self.qtdePerda.forEach(qtdePerdaPorMotivo => {
                    if (isNaN(qtdePerdaPorMotivo))
                        qtdePerdaPorMotivo = 0;
                    qtdePerdaDetalhada += qtdePerdaPorMotivo;                    
                });

                return NumberUtils.format(qtdePerdaDetalhada, casasDecimais, 0);
            }

            function onFormChange() {
                if ( self.qtdePerda.length  == self.idxFormInputs + 1 && self.motivoPerda.length == self.idxFormInputs + 1 ) {
                    self.idxFormInputs += 1;
                    printNewSimpleForm();
                }

            }

            function validaDetalhamento() {
                if ( getQtdePerdaDetalhada() != self.qtdePerdaTotal ) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.MultiplosMotivoPerdaPopUp.msgDivergenciaDetalhamento", [self.qtdePerdaTotal]));
                    return false;
                }

                if ( self.qtdePerda.length != self.qtdeMotivosPerda ) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.MultiplosMotivoPerdaPopUp.msgDivergenciaQtdMotivos", [self.qtdeMotivosPerda]));
                    return false;
                }

                if ( (self.qtdePerda.some(isUndefined) && !self.motivoPerda.some(isUndefined)) || (!self.qtdePerda.some(isUndefined) && self.motivoPerda.some(isUndefined))) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.MultiplosMotivoPerdaPopUp.msgReviseDetalhamento"));
                    return false;
                }

                if ( validaNaoRepetidos(self.motivoPerda) ) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.MultiplosMotivoPerdaPopUp.msgDetalhamentosMotivosRepetidos"));
                    return false;
                }

                if ( self.qtdePerda.length != self.motivoPerda.length ) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.MultiplosMotivoPerdaPopUp.msgDetalhamentoPreenchimento"));
                    return false;
                }

                if ( validaQtdeMaiorZero(self.qtdePerda) ) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.MultiplosMotivoPerdaPopUp.msgDetalhamentoQtdMaiorZero"));
                    return false;
                }

                return true;
            }

            function isUndefined(currentValue, index, arr) {
            	return angular.isUndefined(currentValue);
            }
            
            function tratarArray() {
                for (var i = 0; i < self.qtdePerda.length; i++) {
                    if (angular.isUndefined(self.qtdePerda[i]) && angular.isUndefined(self.motivoPerda[i])) {
                        self.qtdePerda.splice(i, 1);
                        self.motivoPerda.splice(i, 1);
                    }
                }
            }

            function validaNaoRepetidos(arr) {
                return arr.some( function(item) {
                    return arr.indexOf(item) !== arr.lastIndexOf(item);
                });
            }

            function validaQtdeMaiorZero(arr) {
                return arr.some( function(item) {
                    return item <= 0;
                });
            }
            
            function saveDetalhamentos() {
                tratarArray(); 
                AngularUtil.timeout(() => {

                    if( !validaDetalhamento() )
                        return;
                    
                    var numeroApontamaneto = data.dataset.getFieldValueAsNumberOrZero('NUAPO');
                    var sequenciaPA = data.dataset.getFieldValueAsNumberOrZero('SEQAPA');
    
                    var params = { params : [], detalhamentoMP: self.detalhamentoMP, CODPRODMP: self.codProdMP, CONTROLEMP: self.controleMP };
    
                    for (var i = 0; i < self.qtdePerda.length; i++) {
                        params.params[i] = {
                            NUAPO: numeroApontamaneto,
                            SEQAPA: sequenciaPA,
                            CODMPE: self.motivoPerda[i],
                            QTDPERDA: self.qtdePerda[i]
                        }
                    }
    
                    if (self.standAlone) {
                        $popupInstance.success({data: params.params});
                    } else {
                        ServiceProxy.callService(
                            "mgeprod@OperacaoProducaoSP.salvarDetalhamentoPerda",
                            params).then(function (result) {
                                $popupInstance.success();
                            });
                    }
                }, 500);
            }

            function cancelarEdicao() {

                $popupInstance.dismiss({
                    qtdeMotivos: self.totalMotivoPerdaCarregadoAntigo,
                    qtdeTotalPerda: self.totalQtdePerdaCarregadoAntigo
                });
            }
            
            function carregaDetalhamentos() {
            	var numeroApontamaneto = data.dataset.getFieldValueAsNumber('NUAPO');
                var sequenciaPA = data.dataset.getFieldValueAsNumber('SEQAPA');
                
                var params = {
    							NUAPO: numeroApontamaneto,
    							SEQAPA: sequenciaPA,
                                detalhamentoMP: self.detalhamentoMP,
                                CODPRODMP: self.codProdMP,
                                CONTROLEMP: self.controleMP
    			};
                ServiceProxy.callService(
                        "mgeprod@OperacaoProducaoSP.carregarDetalhamentosPerda",
                        params).then(function (result) {

                            if (StringUtils.isNotEmpty(result)) {
                                if (result.hasOwnProperty("responseBody")) {
                                    if (result.responseBody.hasOwnProperty("listaDetalhamentoPerda")) {
                                        result.responseBody.listaDetalhamentoPerda.forEach(element => {
                                            incluirLinha(element);
                                        })
                                        self.totalMotivoPerdaCarregadoAntigo = self.totalMotivoPerdaCarregado;
                                        self.totalQtdePerdaCarregadoAntigo = self.totalQtdePerdaCarregado;
                                        if (!self.isApontamentoConfirmado) {
                                            printNewSimpleForm();
                                        }
                                    }
                                }
                            }
                        });
                        
            }

            function carregaDetalhamentosStandAlone(detalhesPerda) {
                detalhesPerda.forEach(det => {
                    incluirLinha(det);
                });
                self.totalMotivoPerdaCarregadoAntigo = self.totalMotivoPerdaCarregado;
                self.totalQtdePerdaCarregadoAntigo = self.totalQtdePerdaCarregado;
                printNewSimpleForm();
            };

            function incluirLinha(det) {
                self.motivoPerda[self.idxFormInputs] = NumberUtils.getNumberOrZero(det.CODMPE);
                self.qtdePerda[self.idxFormInputs] = NumberUtils.getNumberOrZero(det.QTDPERDA);
                self.totalMotivoPerdaCarregado++;
                self.totalQtdePerdaCarregado += self.qtdePerda[self.idxFormInputs];
                printNewSimpleForm();
                self.idxFormInputs++;
            }
            
            function excluiDetalhamentos() {
                removerItens();
                /*if (self.standAlone) {
                } else {
                    var numeroApontamaneto = data.dataset.getFieldValueAsNumber('NUAPO');
                    var sequenciaPA = data.dataset.getFieldValueAsNumber('SEQAPA');
                    
                    var params = { params : [] };
                    params.params[0] = {
                        NUAPO: numeroApontamaneto,
                        SEQAPA: sequenciaPA
                    }
                    ServiceProxy.callService(
                            "mgeprod@OperacaoProducaoSP.excluirDetalhamentosPerda",
                            params).then(function (result) {
                                removerItens();
                            });
                } */
            }

            function removerItens() {
                self.idxFormInputs = 0;
                        self.totalMotivoPerdaCarregado = 0;
                        self.totalQtdePerdaCarregado = 0;
                        self.qtdePerda = [];
                        self.motivoPerda = [];
                        self.idxFormInputs = 0;
                        self.isLimparArray = true;
                        angular.element('#popUpDetalhamentoMotivos sk-simple-form').remove();
                        printNewSimpleForm();
            }
            
            
    	}
    ]);
angular
    .module('snk.commons')
    .service('MultiplosMotivoPerdaPopUp', ['SanPopup', 'i18n',
        function (SanPopup, i18n) {
            var self = this;
            self.open = open;
            self.openDetalhamentoMP = openDetalhamentoMP;
            function open(dataset, isApontamentoConfirmado, casasDecimais, detalhesPerda, standAlone) {
                var popup = SanPopup.open({
                    title: i18n('Commons.MultiplosMotivoPerdaPopUp.lblDetalhamentoPerdas'),
                    templateUrl: 'commons/multiplosMotivosPerda/multiplosMotivoPerdaPopUp.tpl.html',
                    controller: 'MultiplosMotivoPerdaPopUpController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnOk: !isApontamentoConfirmado,
                    showBtnCancel: true,
                    leftBottomBar: ['<div id="lblTot"></div>'],
                    okBtnLabel: i18n('Geral.lblSalvar'),
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    resolve: {
                        data: {
                            dataset: dataset,
                            isApontamentoConfirmado: isApontamentoConfirmado,
                            detalhesPerda: detalhesPerda || [],
                            casasDecimais: casasDecimais || 2,
                            standAlone: standAlone || false
                        }
                    }
                
                })
                return popup.result;
            }

            function openDetalhamentoMP(dataset, isApontamentoConfirmado, casasDecimais, detalhesPerda, codProdMP, controleMP, standAlone) {
                var popup = SanPopup.open({
                    title: i18n('Commons.MultiplosMotivoPerdaPopUp.lblDetalhamentoPerdas'),
                    templateUrl: 'commons/multiplosMotivosPerda/multiplosMotivoPerdaPopUp.tpl.html',
                    controller: 'MultiplosMotivoPerdaPopUpController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnOk: !isApontamentoConfirmado,
                    showBtnCancel: true,
                    leftBottomBar: ['<div id="lblTot"></div>'],
                    okBtnLabel: i18n('Geral.lblSalvar'),
                    cancelBtnLabel: i18n("Geral.lblFechar"),
                    resolve: {
                        data: {
                            dataset: dataset,
                            isApontamentoConfirmado: isApontamentoConfirmado,
                            detalhesPerda: detalhesPerda || [],
                            casasDecimais: casasDecimais || 2,
                            standAlone: standAlone || false,
                            codProdMP: codProdMP,
                            controleMP: controleMP,
                            detalhamentoMP: true
                        }
                    }
                
                })
                return popup.result;
            }
        }]);
angular
    .module('snk.commons')
    .controller('CampoAmpliadoController', ['data', '$scope', '$popupInstance', 'i18n', 
    	function (data, $scope, $popupInstance, i18n) {
        var self = this;
        
        self.value = data.value;
        
    }]);
angular
    .module('snk.commons.ordemservico')
    .controller('HistoricoController', ['SkApplicationInstance', 'StringUtils', 'DateUtils', 'ObjectUtils', 'Criteria', 'data', 'i18n', 
    	function (SkApplicationInstance, StringUtils, DateUtils, ObjectUtils, Criteria, data, i18n) {
        var self = this;
        
        ObjectUtils.implements(self, IDataSetObserver);
        self.refreshed = refreshed;
        
        self.onDatasetCreated = onDatasetCreated;
        self.getLabelDtExec = getLabelDtExec;
        self.getLabelHoraExec = getLabelHoraExec;
        self.getLabelTempoGasto = getLabelTempoGasto;
        self.getLabelNumItem = getLabelNumItem;
        self.abrirTelaDeOS = abrirTelaDeOS;
        self.getSolucaoHeight = getSolucaoHeight;
        self.getSolucao = getSolucao;
        self.itens = [];
        
        var _numOS = data.numOS;
        
        function onDatasetCreated(dataset) {
        	if (dataset.getEntityName() == 'ItemOrdemServico') {
        		self.dsItemOrdemServico = dataset;
        		dataset.addCriteriaProvider(getCriteria);
        		dataset.addObserver(self);
        	}
        	
        	dataset.initAndRefresh();
        }
        
        function getCriteria() {
        	var criteria = Criteria();
        	criteria.append(" this.NUMOS = ?", Criteria.buildNumberParameter(_numOS));
        	
        	return criteria;
        }
        
        function refreshed() {
        	self.itens = self.dsItemOrdemServico.getRecordsAsObjects();
        }
        
        function abrirTelaDeOS(item) {
			if(item && item.NUMOS && item.NUMITEM) {
				var pk = {};
				pk.numOS = item.NUMOS;
				pk.numItem = item.NUMITEM;
				
				if (item["OrdemServico.TIPO"] == "P") {
					SkApplicationInstance.openApp("br.com.sankhya.os.cad.negociacaoPreVenda", pk, true);
				} else {
					SkApplicationInstance.openApp("br.com.sankhya.os.mov.OrdemServico", pk);
				}
			}
		}
        
        function getLabelDtExec(item) {
        	return DateUtils.dateToString(item['INICEXEC'])
        }
        
        function getLabelHoraExec(item) {
        	var horaExec = "";
        	var hrInicial = item.HRINICIAL;
        	var hrFinal = item.HRFINAL;
        	
        	if (hrInicial && hrFinal) {
        		horaExec = DateUtils.getTimeFormatter(hrInicial) + ' - ' + DateUtils.getTimeFormatter(hrFinal);
        		
        	} else if (hrInicial) {
        		horaExec = DateUtils.getTimeFormatter(hrInicial);
        	}
        	
        	return horaExec;
        }
        
        function getLabelTempoGasto(item) {
        	var tempoGasto = item['TEMPGASTO'];
        	
        	if (tempoGasto) {
        		var hrs = Math.trunc(tempoGasto/60);
        		var min = tempoGasto%60;
        		
        		return 'Tempo gasto: ' + ((hrs != 0) ? (hrs+"h") : "") + ((min != 0) ? min+"min" : "");
        	}
        	
        	return undefined;
        }
        
        function getLabelNumItem(item) {
        	return "Item: "+ item.NUMITEM;
        }
        
        function getSolucaoHeight(item) {
        	var solucao = StringUtils.replaceAll(item.SOLUCAO, "\r\n", "\n")
        	solucao = item.SOLUCAO.split("\n")
        	var height = solucao.length;
        	
        	solucao.forEach(function(line){
        		var lines = Math.trunc(line.length/100);
        		if (lines > 0) {
        			height += lines;
        		}
        	});
        	
        	return height;
        }
        
        function getSolucao(item) {
        	return StringUtils.replaceAll(item.SOLUCAO, "\r\n", "\n")
        }
    }]);
angular
    .module('snk.commons.ordemservico')
    .service('SkOSService', ['$q', 'ServiceProxy', function($q, ServiceProxy){
        var self = this;

        self.loadRestricaoParceiro = loadRestricaoParceiro;

        function loadRestricaoParceiro(telaExecutadas) {
            var deferred = $q.defer();
     	   
     	   var params = {
 			   param: {
 				   name: 'os.restringe.dados.parceiro'
 			   }
     	   };
     	   
     	   ServiceProxy
            .callService('mge@SystemUtilsSP.getMGECoreParameterFromUserLog', params)
            .then(function (response) {
                var restringeInfoParceiro = response.responseBody.param.value == "true";
                var strFilteredColumns;
                
                if (telaExecutadas) {
             	   strFilteredColumns = 'COBRAR,RETRABALHO, TIPO, OrdemServico_TIPO, CORSLA';
                } else {
             	   strFilteredColumns = 'COBRAR,RETRABALHO';
                }
                
                if (restringeInfoParceiro) {
						strFilteredColumns+=","+
						                    "OrdemServico.Parceiro.CODEND,"+
						                    "OrdemServico.Parceiro.Endereco.NOMEEND,"+
						                    "OrdemServico.Parceiro.NUMEND,"+
						                    "OrdemServico.ENDERECO,"+
						                    "OrdemServico.TELCONTATO,"+
						                    "OrdemServico.Parceiro.CODBAI,"+
						                    "OrdemServico.Parceiro.Bairro.NOMEBAI,"+
						                    "OrdemServico.Parceiro.CEP,"+
								        "OrdemServico.Parceiro.EMAIL,"+
						                    "OrdemServico.Parceiro.TELEFONE,"+
						                    "OrdemServico.Parceiro.RAMAL,"+
						                    "OrdemServico.Parceiro.FAX,"+
						                    "OrdemServico.Contato.CODEND,"+
						                    "OrdemServico.Contato.Endereco.NOMEEND,"+
						                    "OrdemServico.Contato.NUMEND,"+
						                    "OrdemServico.Contato.CODBAI,"+
						                    "OrdemServico.Contato.Bairro.NOMEBAI,"+
						                    "OrdemServico.Contato.CEP,"+
								        "OrdemServico.Contato.EMAIL,"+
						                    "OrdemServico.Contato.TELEFONE,"+
						                    "OrdemServico.Contato.TELRESID,"+
						                    "OrdemServico.Contato.RAMAL,"+
						                    "OrdemServico.Contato.CELULAR,"+
						                    "OrdemServico.Contato.FAX";
					}
                
                 deferred.resolve(strFilteredColumns);
            });
     	   
     	   return deferred.promise;
        }
        
    }]);
/**
 * Created by bruno.brandao on 31/03/2016.
 */
angular
    .module('snk.commons.parceiro')
    .controller('SkImportarDadosEnderecosSefaz', ['$scope', '$popupInstance', 'SkI18nService', 'ServiceProxy', 'ObjectUtils', 'StringUtils', 'popupInfo', function ($scope, $popupInstance, SkI18nService, ServiceProxy, ObjectUtils, StringUtils, popupInfo) {
        var self = this;

        var i18n = SkI18nService.instant;

        self.sefazInfo = popupInfo.sefazInfo;
        self.parcInfo = popupInfo.parcInfo;

        self.getUF = getUF;
        self.getTipo = getTipo;

        init();

        function init() {
            $scope.$success = confirmar;

            loadTranslation('lblNumero', 'Commons.Parceiro.numero');
            loadTranslation('lblComplemento', 'Commons.Parceiro.complemento');
            
            if(!self.parcInfo.CODEND) {
            	self.parcInfo.CODEND = self.sefazInfo.parceiroSefaz.CODEND_FIND;
            }
            if(!self.parcInfo.CODBAI) {
            	self.parcInfo.CODBAI = self.sefazInfo.parceiroSefaz.CODBAIRRO_FIND;
            }
            if(!self.parcInfo.CODCID) {
            	self.parcInfo.CODCID = self.sefazInfo.parceiroSefaz.CODCID_FIND;
            }
            if(!self.parcInfo.NUMEND) {
            	self.parcInfo.NUMEND = self.sefazInfo.parceiroSefaz.NUMEND;
            }
            if(!self.parcInfo.COMPLEMENTO) {
            	self.parcInfo.COMPLEMENTO = self.sefazInfo.parceiroSefaz.COMPL;
            }
        }

        function loadTranslation(scopeKey, translateKey) {
            $scope[scopeKey] = SkI18nService.instant(translateKey).replace(':', '');
        }

        function getUF(item) {
            if (!item) {
                self.parcInfo.UF = undefined;
                return;
            }

            if (item.data.TIPO) {
                self.parcInfo.UF = item.data.UF;
            } else {
                ServiceProxy.callService('mge@ParceiroSP.getUFCidade',
                    {
                        codigoCidade: {
                            $: self.parcInfo.CODCID
                        }
                    }).then(function (result) {
                    self.parcInfo.UF = ObjectUtils.getProperty(result, 'responseBody.UF.$');
                });
            }
        }

        function getTipo(item) {
            if (!item) {
                self.parcInfo.TIPEND = undefined;
                return;
            }

            if (item.data.TIPO) {
                self.parcInfo.TIPEND = item.data.TIPO;
            } else {
                ServiceProxy.callService('mge@ParceiroSP.getTipoEndereco',
                    {
                        codigoEndereco: {
                            $: self.parcInfo.CODEND
                        }
                    }).then(function (result) {
                    self.parcInfo.TIPEND = ObjectUtils.getProperty(result, 'responseBody.tipoEndereco.$');
                });
            }
        }

        function confirmar() {
            var codEnd = self.parcInfo.CODEND;
            var codBai = self.parcInfo.CODBAI;
            var codCid = self.parcInfo.CODCID;

            if (StringUtils.isEmpty(codEnd)) {
                throw new AlertError(i18n('Commons.Parceiro.enderecoInvalido'), i18n('Commons.Parceiro.enderecoNulo'));
            } else if (codEnd == 0) {
                throw new AlertError(i18n('Commons.Parceiro.enderecoInvalido'), i18n('Commons.Parceiro.enderecoZero'));
            }

            if (StringUtils.isEmpty(codBai)) {
                throw new AlertError(i18n('Commons.Parceiro.bairroInvalido'), i18n('Commons.Parceiro.bairroNulo'));
            } else if (codBai == 0) {
                throw new AlertError(i18n('Commons.Parceiro.bairroInvalido'), i18n('Commons.Parceiro.bairroZero'));
            }

            if (StringUtils.isEmpty(codCid)) {
                throw new AlertError(i18n('Commons.Parceiro.cidadeInvalida'), i18n('Commons.Parceiro.cidadeNula'));
            } else if (codCid == 0) {
                throw new AlertError(i18n('Commons.Parceiro.cidadeInvalida'), i18n('Commons.Parceiro.cidadeZero'));
            }

            var parceiroSefaz = self.sefazInfo.parceiroSefaz;

            var params = {
                codParc: self.parcInfo.CODPARC,
                cidade: codCid,
                bairro: codBai,
                endereco: codEnd,
                compl: self.parcInfo.COMPLEMENTO,
                numero: self.parcInfo.NUMEND,

                razao: parceiroSefaz.RAZAOSOCIAL,
                nome: parceiroSefaz.NOMEPARC,
                ie: parceiroSefaz.IE,
                cep: parceiroSefaz.CEP,
                uf: parceiroSefaz.UF
            };

            if (self.parcInfo.hasOwnProperty('ehProspect')) {
                params['ehProspect'] = self.parcInfo.ehProspect;
            }

            ServiceProxy.callService('mge@ParceiroSP.importarDadosSefaz', {param: params})
                .then(function (result) {
                    $popupInstance.success(result);
                });
        }

    }]);
/**
 * Created by bruno.brandao on 31/03/2016.
 */
angular
    .module('snk.commons.parceiro')
    .service('ImportadorDadosEnderecosSefaz', ['SanPopup', 'SkI18nService', function(SanPopup, SkI18nService){
        var self = this;

        self.openPopUp = openPopUp;

        function openPopUp(popupInfo) {

            var popupInstance = SanPopup.open({
                title: SkI18nService.instant('PopupParameters.tituloInformeParametro'),
                templateUrl: 'commons/parceiro/importardadosenderecosefaz/importardadosenderecosefaz.tpl.html',
                controller: 'SkImportarDadosEnderecosSefaz',
                controllerAs: 'ctrl',
                size: 'lg',
                showBtnNo: false,
                okBtnLabel: SkI18nService.instant('Geral.lblAplicar'),
                noBtnLabel: SkI18nService.instant('PopupParameters.lblDesconsiderarNaoInf'),
                windowClass: 'importar-dados-enderecos-sefaz-popup',
                resolve: {
                    popupInfo: function() {
                        return popupInfo;
                    }
                }
            });

            return popupInstance;
        }
    }]);
/**
 * Created by vinicius.fernandes on 04/11/2019.
 */

angular
  .module('snk.commons')
  .controller('ParcelamentoController', ['i18n', 'MGEParameters', 'ServiceProxy', 'SkApplicationInstance', '$popupInstance', '$scope', 'MessageUtils', 'StringUtils', 'parcelamentoPopUpInfo', 'ObjectUtils', 'DateUtils',
    function (i18n, MGEParameters, ServiceProxy, SkApplicationInstance, $popupInstance, $scope, MessageUtils, StringUtils, parcelamentoPopUpInfo, ObjectUtils, DateUtils) {
      var self = this;
      $scope.$success = confirmar;
      $scope.$dismiss = salvarEstadoTela;

      // Title do accordion ------------------------------------------------------------------------------------------
      self.lblTipoParcelamento = i18n("Commons.Parcelamento.labelTipoParcelamento");
      self.lblJurosMulta = i18n("Commons.Parcelamento.labelJurosMultas");
      self.lblBaseVencimento = i18n("Commons.Parcelamento.labelBaseVencimento");
      self.lblDataNegociacao = i18n("Commons.Parcelamento.labelDataNegociacao");
      //--------------------------------------------------------------------------------------------------------------
      //Valores do radio button --------------------------------------------------------------------------------------
      self.DIARIA = 0;
      self.SEMANAL = 1;
      self.DEZENA = 2;
      self.QUINZENAL = 3;
      self.PARCELADO = 4;
      self.MENSAL = 5;
      self.BIMESTRAL = 6;
      self.TRIMESTRAL = 7;
      self.QUADRIMESTRAL = 8;
      self.SEMESTRAL = 9;
      self.ANUAL = 10;
      self.PERSONALIZADA = 11;

      self.JUROS_SIMPLES = 0;
      self.JURO_COMPOSTO = 1;
      self.JUROS_SIMPLES_FIXA = 2;
      self.SEM_JUROS = 3;

      self.SOMADO = 1;
      self.SEPARADO = 0;
      self.NEGOCIADO = 3;

      self.ORIGINAL = 0;
      self.NEGOCIACAO = 1;
      self.HOJE = 2;
      self.INFORMAR = 3;
      self.VENCIMENTO = 4;
      //--------------------------------------------------------------------------------------------------------------
      //Set dos valores do radio button ------------------------------------------------------------------------------
      self.tipo = self.JUROS_SIMPLES;
      self.juros = self.SOMADO;
      self.multa = self.SOMADO;
      self.dtVenc = self.ORIGINAL;
      self.dtNeg = self.ORIGINAL;
      //--------------------------------------------------------------------------------------------------------------
      //Opcoes do combobox frequencia --------------------------------------------------------------------------------
      self.optionsFrequencia = [
        { data: '0', value: i18n('Commons.Parcelamento.itemDiaria') },
        { data: '1', value: i18n('Commons.Parcelamento.itemSemanal') },
        { data: '2', value: i18n('Commons.Parcelamento.itemDezena') },
        { data: '3', value: i18n('Commons.Parcelamento.itemQuinzenal') },
        { data: '4', value: i18n('Commons.Parcelamento.itemParcelado') },
        { data: '5', value: i18n('Commons.Parcelamento.itemMensal') },
        { data: '6', value: i18n('Commons.Parcelamento.itemBimestral') },
        { data: '7', value: i18n('Commons.Parcelamento.itemTrimestral') },
        { data: '8', value: i18n('Commons.Parcelamento.itemQuadrimestral') },
        { data: '9', value: i18n('Commons.Parcelamento.itemSemestral') },
        { data: '10', value: i18n('Commons.Parcelamento.itemAnual') },
        { data: '11', value: i18n('Commons.Parcelamento.itemPersonalizada') }
      ];
      //--------------------------------------------------------------------------------------------------------------
      const PARCELAMENTO = 0;
      const RENEGOCIACAO = 1;

      self.codConta;
      self.codTipTit;
      self.calcDescMulJur = 0;
      self.desdobInicial = 1;
      self.dias = 0;
      self.save = false;
      self.origem = "F";
      self._showCopiarRateio = true;
      self._tipPopUp = RENEGOCIACAO;
      self._permiteRenegParceiroDif = false;
      self._permiteMultiplasEmpresasReneg = false;
      self._recalcularTaxaAdministradora = "N";
      self._utilizaSankhyaCivil = false;
      self.habilitaDias = habilitaDias;
      self.habilitaEntrada = habilitaEntrada;
      self.habilitaNovaData = habilitaNovaData;
      self.zerarJuroMultaChange = zerarJuroMultaChange;
      self.tipoParcChange = tipoParcChange;

      self.resourceID = SkApplicationInstance.getResourceID().replace("-html5", "") + "_parcelamento_estado";

      init();

      //Inicializacao da tela ----------------------------------------------------------------------------------------
      function init() {
        //Set dos valores vindo da tela que chama o popup
        if (parcelamentoPopUpInfo.hasOwnProperty('showCopiarRateio')) {
          self._showCopiarRateio = parcelamentoPopUpInfo.showCopiarRateio;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('showCalcJuroAteData')) {
          self._showCalcJuroAteData = parcelamentoPopUpInfo.showCalcJuroAteData;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('showConsiderarEntrada')) {
          self._showConsiderarEntradaCalcJuroMulta = parcelamentoPopUpInfo.showConsiderarEntrada;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('podeZerarJuroMulta')) {
          self._podeZerarJuroMulta = parcelamentoPopUpInfo.podeZerarJuroMulta;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('tipPopUp')) {
          if(parcelamentoPopUpInfo.tipPopUp == "PARCELAMENTO") {
            self._tipPopUp = PARCELAMENTO
          }
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('usaParamJUROSPCP')) {
          self._usaParamJUROSPCP = parcelamentoPopUpInfo.usaParamJUROSPCP;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('permiteRenegParceiroDif')) {
          self._permiteRenegParceiroDif = parcelamentoPopUpInfo.permiteRenegParceiroDif;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('permiteMultiplasEmpresasReneg')) {
          self._permiteMultiplasEmpresasReneg = parcelamentoPopUpInfo.permiteMultiplasEmpresasReneg;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('sugerirParceiro')) {
          self._sugestaoParceiro = parcelamentoPopUpInfo.sugerirParceiro;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('sugerirEmpresa')) {
          self._sugestaoEmpresa = parcelamentoPopUpInfo.sugerirEmpresa;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('recalcularTaxaAdministradora')) {
          self._recalcularTaxaAdministradora = parcelamentoPopUpInfo.recalcularTaxaAdministradora ? "S" : "N";
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('titulos')) {
          self.titulos = parcelamentoPopUpInfo.titulos;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('vlrLiquido')) {
          self.vlrLiquido = parcelamentoPopUpInfo.vlrLiquido;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('tipoTitulo')) {
          self.codTipTit = parcelamentoPopUpInfo.tipoTitulo;
        }
        if (parcelamentoPopUpInfo.hasOwnProperty('conta')) {
          self.codConta = parcelamentoPopUpInfo.conta;
        }
        
        if (parcelamentoPopUpInfo.hasOwnProperty('save')) {
        	self.save = parcelamentoPopUpInfo.save;
        }

        if (parcelamentoPopUpInfo.hasOwnProperty('calcDescMulJur')) {
          self.calcDescMulJur = parcelamentoPopUpInfo.calcDescMulJur;
        }

        if (parcelamentoPopUpInfo.hasOwnProperty('origem')) {
          self.origem = parcelamentoPopUpInfo.origem;
        }
        
        // Validacao para mudar o nome da label e do helptip
        if (self._tipPopUp == RENEGOCIACAO) {
          self.lblTaxaMulta = 'Commons.Parcelamento.labelTaxaMultaRenegociacao';
          self.helpTaxaMulta = 'Commons.Parcelamento.hintTaxaMultaRenegociacao';
        } else {
          self.lblTaxaMulta = 'Commons.Parcelamento.labelTaxaMultaParcelamento';
          self.helpTaxaMulta = 'Commons.Parcelamento.hintTaxaMultaParcelamento';
        }

        self.frmParceiro = self._permiteRenegParceiroDif;
        self.frmEmpresa = self._permiteMultiplasEmpresasReneg;

        carregarEstadoTela();

        self._utilizaSankhyaCivil = MGEParameters.asBoolean("fin.utiliza.sankhyacivil");
      }
      //--------------------------------------------------------------------------------------------------------------

      //Se a frequencia for igual a Personalizada, o campo intervalo dias aparece ------------------------------------
      function habilitaDias() {
        self.diasEnabled = self.frequencia == self.PERSONALIZADA;
      }
      //--------------------------------------------------------------------------------------------------------------

      //Se o switch estiver ligado, o input comEntrada fica habilitado -----------------------------------------------
      function habilitaEntrada() {
        self.entradaEnabled = self.comEntrada == "S" ? true : false;
      }
      //--------------------------------------------------------------------------------------------------------------

      //Se o radio for Informar data, o campo dateinput fica habilitado ----------------------------------------------
      function habilitaNovaData() {
        self.novaDtVencEnabled = self.dtVenc == self.INFORMAR;
        if(self.dtVenc != self.INFORMAR){
        	self.novaDtVenc = "";
        }
      }
      //--------------------------------------------------------------------------------------------------------------

      //--------------------------------------------------------------------------------------------------------------
      function confirmar() {
        var qtdParcelas = self.parcelas;

        if (qtdParcelas == 0) {
          MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Parcelamento.messageZeroParcelas'));
          return;
        }
        if (self.dtVenc == self.INFORMAR && StringUtils.isEmpty(self.novaDtVenc)) {
          MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Parcelamento.messageInformeVencimento'));
          return;
        }
        if (self.comEntrada == "S" && qtdParcelas < 2) {
          MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Parcelamento.messageDuasParcelasOuMais'));
			return;
        }
        
        if(self.frequencia == undefined || StringUtils.isEmpty(self.frequencia) ){
			MessageUtils.showAlert(MessageUtils.TITLE_WARNING,i18n('Commons.Parcelamento.messageFrequenciaNaoNula'));
			return;
		}

        var entradaNumber = StringUtils.isEmpty(self.entrada) != undefined ? self.entrada : 0;

        if (self.comEntrada == "S" && entradaNumber >= Math.abs(self.vlrLiquido)) {
          MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.Parcelamento.messageVlrEntrada'));
          return;
        }

        if (self.tipo == self.SEM_JUROS && self.origem != "F") {
          MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.Parcelamento.messageOrigemFinaceiro'));
          return;
        }

        var strCopiarRateio = "S";

        if (self._showCopiarRateio) {
          strCopiarRateio = self.copiarRateio == "S" ? "S" : "N";
        }

        var strJurosAteData = "N";

        if (self._showCalcJuroAteData) {
          strJurosAteData = self.jurosAteDataAtual == "S" ? "S" : "N";
        }

        var strConsiderarEntradaCalcJuroMulta = "N";

        if (self._showConsiderarEntradaCalcJuroMulta) {
          strConsiderarEntradaCalcJuroMulta = self.considerarEntradaCalcJuroMulta == "S" ? "S" : "N";
        }

        var params = {
          parcel: {
            save: self.save ? "S" : "N",
            nroparcel: qtdParcelas,
            cpyrat: strCopiarRateio,
            txjur: !isNaN(self.taxaJuros) ? self.taxaJuros : "",
            txmul: !isNaN(self.taxaMulta) ? self.taxaMulta : "",
            hist: self.nroParcela == "S" ? "S" : "N",
            calc: strJurosAteData,
            considerarEntradaCalcJuroMulta: strConsiderarEntradaCalcJuroMulta,
            tip: self.tipo,
            jur: self.juros,
            mul: self.multa,
            calcDesc: self.calcDescMulJur,
            usaParamJUROSPCP: self._usaParamJUROSPCP ? "S" : "N",
            desdobInicial: self.desdobInicial,
            varCambialJurMult: self.varCambialJurMult == "S" ? "S" : "N",
            zerarJuroMulta: self.zerarJuroMulta == "S" ? "S" : "N",
            chkComEntrada: self.comEntrada == "S" ? "S" : "N",
            recalcularTaxaAdministradora: self._recalcularTaxaAdministradora,
            priceJurMulDesc: self.priceJurMulDesc == "S" ? "S" : "N",
            codTipTit: self.codTipTit ? self.codTipTit : 0,
            codConta: self.codConta ? self.codConta : 0
          }
        };

        var ent = {
          value: self.entrada
        };

        var freq = {          
          value: self.frequencia,
          dias: self.dias          
        };

        var venc = {
          value: self.dtVenc,
	        nova: StringUtils.isEmpty(self.novaDtVenc) ? 
            "" : 
            DateUtils.formatDate(
              typeof self.novaDtVenc === 'string' ? 
                DateUtils.stringToDate(self.novaDtVenc) : 
                self.novaDtVenc,
              DateUtils.DEFAULT_DATE_FORMAT
            )
        };

        var tits = {
          nufins: self.titulos
        };

        var negoc = {
          value: self.dtNeg
        };

        if (self.comEntrada == "S") {
          params.parcel.ent = ent;
        }
        params.parcel.freq = freq;
        params.parcel.venc = venc;
        params.parcel.tits = tits;
        params.parcel.negoc = negoc;

        if (self._permiteMultiplasEmpresasReneg) {
          var perMulEmp = undefined;

          if (!StringUtils.isEmpty(self.empresa)) {
            perMulEmp = {
              value: self.empresa
            };
          } else if (StringUtils.isEmpty(self._sugestaoEmpresa)) {
            perMulEmp = {
              value: self._sugestaoEmpresa
            };
          }

          if (angular.isDefined(perMulEmp)) {
            params.parcel.empresaNovosTitulos= perMulEmp;
          }
        }

        if (self._permiteRenegParceiroDif) {
          var parRengDif = undefined;

          if (!StringUtils.isEmpty(self.parceiro)) {
            parRengDif = {
              value: self.parceiro
            };
          } else if (!StringUtils.isEmpty(self._sugestaoParceiro)) {
            parRengDif = {
              value: self._sugestaoParceiro
            };
          }

          if (angular.isDefined(parRengDif)) {
            params.parcel.parceiroNovosTitulos = parRengDif;
          }
        }

        ServiceProxy.callService("mgefin@ParcelamentoSP.parcelar", params, true).then(function (response) {          
            var respBody = response.responseBody;
            var titulosParcelados = respBody.parcelados

            parcelamentoPopUpInfo.eventBus.dispatchEvent('PARCELAMENTO_CONCLUIDO', titulosParcelados);


            /*dispatchEvent criado para contornar situação na 'Renegociação de Títulos', cujo evento deve passar tanto títulos
            parcelados, quanto títulos originais seguindo a mesma lógica do component no flex (Parcelamento.mxml - linha 304)*/
            parcelamentoPopUpInfo.eventBus.dispatchEvent('PARCELAMENTO_CONCLUIDO_RENEGOCIACAO', {
              titulosOriginais: ObjectUtils.getProperty(response, 'responseBody.originais'),
              titulosParcelados: ObjectUtils.getProperty(response, 'responseBody.parcelados')
            });

          });

        salvarEstadoTela();
      }
      //--------------------------------------------------------------------------------------------------------------

      //Carrega o estado/config da tela ------------------------------------------------------------------------------
      function carregarEstadoTela() {
        var params = {
          config: {
            chave: self.resourceID,
            tipo: "T"
          }
        }
        ServiceProxy.callService("mge@SystemUtilsSP.getConf", params, true).then(function (response) {
          if (response.responseBody.config != undefined) {
            estadoTela = response.responseBody.config.estadoTela;

            self.parcelas = estadoTela.nroParcelas;
            self.copiarRateio = estadoTela.cpyrat;
            self.taxaJuros = estadoTela.taxaJuros;
            self.taxaMulta = estadoTela.taxaMulta;
            self.frequencia = estadoTela.frequencia;
            self.comEntrada = estadoTela.comEntrada;
            if (self.comEntrada == "S") {
              self.entrada = estadoTela.entrada;
            } else {
              self.entrada = "";
            }
            self.nroParcela = estadoTela.nroParcela;
            self.jurosAteDataAtual = estadoTela.jurosAteDataAtual;
            self.considerarEntradaCalcJuroMulta = estadoTela.considerarEntradaCalcJuroMulta;
            self.tipo = estadoTela.tipo;
            self.juros = estadoTela.juros;
            self.multa = estadoTela.multa;
            self.dtVenc = estadoTela.dtVenc;
            self.dtNeg = estadoTela.dtNeg;
            self.priceJurMulDesc = estadoTela.priceJurMulDesc;
            if (self.dtVenc == self.INFORMAR) {
              self.novaDtVenc = DateUtils.stringToDate(estadoTela.novaDtVenc);
            } else {
              self.novaDtVenc = "";
            }

            if (self._sugestaoParceiro != undefined && self._permiteRenegParceiroDif) {
              self.parceiro = self._sugestaoParceiro;
            }
            if (self._sugestaoEmpresa != undefined && self._permiteMultiplasEmpresasReneg) {
              self.empresa = self._sugestaoEmpresa;
            }

            tipoParcChange();

            habilitaDias();
            habilitaEntrada();
            habilitaNovaData();
          }
        })
      }
      //--------------------------------------------------------------------------------------------------------------

      //Salva o estado/config da tela --------------------------------------------------------------------------------
      function salvarEstadoTela() {
        var params = {
          config: {
            chave: self.resourceID,
            tipo: "T",
            estadoTela: {
              nroParcelas: self.parcelas,
              cpyrat: self.copiarRateio == "S" ? "S" : "N",
              taxaJuros: self.taxaJuros,
              taxaMulta: self.taxaMulta,
              frequencia: self.frequencia,
              comEntrada: self.comEntrada == "S" ? "S" : "N",
              entrada: self.entrada,
              nroParcela: self.nroParcela == "S" ? "S" : "N",
              jurosAteDataAtual: self.jurosAteDataAtual == "S" ? "S" : "N",
              considerarEntradaCalcJuroMulta: self.considerarEntradaCalcJuroMulta == "S" ? "S" : "N",
              tipo: self.tipo,
              juros: self.juros,
              multa: self.multa,
              dtVenc: self.dtVenc,
              novaDtVenc: DateUtils.dateToString(self.novaDtVenc),
              dtNeg: self.dtNeg,
              priceJurMulDesc: self.priceJurMulDesc == "S" ? "S" : "N",
              codTipTit: self.codTipTit ? self.codTipTit : 0,
              codConta: self.codConta ? self.codConta : 0
            }
          }
        }
        ServiceProxy.callService("mge@SystemUtilsSP.saveConf", params, true);
        $popupInstance.dismiss();
      }
      //--------------------------------------------------------------------------------------------------------------

      //Habilita/desabilita campo ------------------------------------------------------------------------------------
      function zerarJuroMultaChange() {
        self.taxaJurosEnabled = self.zerarJuroMulta != 'S'
        self.taxaMultaEnabled = self.zerarJuroMulta != 'S'

        self.taxaMulta = "";
        self.taxaJuros = "";
      }
      //--------------------------------------------------------------------------------------------------------------

      //Habilita/desabilita campo ------------------------------------------------------------------------------------
      function tipoParcChange() {
        if (self.tipo != self.SEM_JUROS && self.zerarJuroMulta != 'S') {
          self.panelJuroMulta = !true;
          self.taxaMultaEnabled = true;
          self.taxaJurosEnabled = true;
        } else {
          self.panelJuroMulta = !false;
          self.taxaMultaEnabled = false;
          self.taxaJurosEnabled = false;
          self.taxaMulta = "";
          self.taxaJuros = "";
        }
        self.priceJurMulDescEnabled = self.tipo == self.JUROS_SIMPLES_FIXA;
      }
      //--------------------------------------------------------------------------------------------------------------      
    }]);

/**
 * Created by vinicius.fernandes on 11/12/2019.
 */
angular
  .module('snk.commons')
  .service('ParcelamentoPopUpService', ['SanPopup', 'SkI18nService',
    function (SanPopup, SkI18nService) {
      var self = this;

      self.openPopUp = openPopUp;

      function openPopUp(popupInfo) {
        return SanPopup.open({
          title: SkI18nService.instant('Commons.Parcelamento.titleParcelamento'),
          templateUrl: 'commons/parcelamento/parcelamentopopup.tpl.html',
          controller: 'ParcelamentoController',
          controllerAs: 'ctrl',
          size: 'lg',
          height: popupInfo.height,
          okBtnLabel: SkI18nService.instant('Commons.Parcelamento.buttonConfirmar'),
          resolve: {
            parcelamentoPopUpInfo: popupInfo
          }
        }).result;
      }
    }
  ]);
angular
    .module('snk.commons')
    .controller('PesquisadorNotaTransporteController', ['$scope', '$popupInstance', 'AngularUtil', 'ServiceProxy', 'SanPopup', 'SkI18nService', 'MessageUtils', '$timeout', 'options',
        function ($scope, $popupInstance, AngularUtil, ServiceProxy, SanPopup, SkI18nService, MessageUtils, $timeout, options) {
            var self = this;

            const OPT_CHAVE_NFE = 'C';
            const OPT_VEICULO = 'V';
            const OPT_NRO_NOTA = 'N';
            const OPT_NRO_UNICO = 'U'; 

            self.optionsCampoPesquisa = [
                { data: OPT_CHAVE_NFE, value: 'Chave NF-e' },
                { data: OPT_VEICULO, value: 'Veículo' },
                { data: OPT_NRO_NOTA, value: 'Nro Nota' },
                { data: OPT_NRO_UNICO, value: 'Nro Único' }];

            self.campoPesquisa;

            self.chaveNfeEnabled = false;
            self.veiculoEnabled = false;
            self.nroNotaEnabled = false;
            self.nroUnicoEnabled = false;
            self.contratoEnabled = false;

            self.changeCampoPesquisa = changeCampoPesquisa;

            self.campoNfeChave;
            self.campoVeiculo;
            self.campoNroNota;
            self.campoNroUnico;
            self.campoContrato;

            self.focusOutNfeChave = focusOutNfeChave;
            self.focusOutNroNota = focusOutNroNota;
            self.entityChangeVeiculo = entityChangeVeiculo;
            self.entityChangeNroUnico = entityChangeNroUnico;
            self.entityChangeContrato = entityChangeContrato;
            self.criteriaNroUnico = criteriaNroUnico;
            self.criteriaVeiculo = criteriaVeiculo;

            $scope.$success = onClickConfirm;

            var _result = {};

            init();
            
            function init() {
                self.campoPesquisa = OPT_CHAVE_NFE;
                changeCampoPesquisa();
                
                if(options.btnCancelar) {
                    options.btnCancelar.on('click', () => {$popupInstance.dismiss()})
                }
                
                $popupInstance.rendered.finally(() => {
                    $timeout(function() {
                        focusOn(document.getElementById('campoNfeChave'));
                        self.campoPesquisa = OPT_CHAVE_NFE;
                    }, 1000, false);
                })
            }

            function changeCampoPesquisa() {
                self.chaveNfeEnabled = OPT_CHAVE_NFE == self.campoPesquisa;
                self.veiculoEnabled = OPT_VEICULO == self.campoPesquisa;
                self.nroNotaEnabled = OPT_NRO_NOTA == self.campoPesquisa;
                self.nroUnicoEnabled = OPT_NRO_UNICO == self.campoPesquisa;
                clearFields();
                setFocus();
            }

            function setFocus() {
                if(OPT_CHAVE_NFE == self.campoPesquisa) {
                    focusOn(document.getElementById('campoNfeChave'));
                }
                
                if(OPT_VEICULO == self.campoPesquisa) {
                    focusOn(document.getElementById('campoVeiculo'));
                }
                
                if( OPT_NRO_NOTA == self.campoPesquisa) {
                    focusOn(document.getElementById('campoNroNota'));
                }
                
                if(OPT_NRO_UNICO == self.campoPesquisa) {
                    focusOn(document.getElementById('campoNroUnico'));
                }
            }

            function focusOn(element) {
                if(angular.isDefined(element)) {
                    AngularUtil.setFocusOnInput(element.firstChild);
                }
            }

            function focusOutNfeChave() {
                if(angular.isUndefined(self.campoNfeChave)) {
                    clearFields();
                } else if(self.campoNfeChave != _result.CHAVENFE) {
                    preecheCampos('CHAVENFE', "'" + self.campoNfeChave + "'");
                }
            }

            function entityChangeVeiculo() {
                if(angular.isUndefined(self.campoVeiculo)) {
                    clearFields();
                } else if(self.campoVeiculo != _result.CODVEICULO) {
                    preecheCampos('CODVEICULO', self.campoVeiculo);
                }
            }

            function focusOutNroNota() {
                if(angular.isUndefined(self.campoNroNota)) {
                    clearFields();
                } else if(self.campoNroNota != _result.NUMNOTA) {
                    preecheCampos('NUMNOTA', self.campoNroNota);
                }
            }

            function entityChangeNroUnico() {
                if(angular.isUndefined(self.campoNroUnico)) {
                    clearFields();
                } else if(self.campoNroUnico != _result.NUNOTA) {
                    preecheCampos('NUNOTA', self.campoNroUnico);
                }
            }

            function entityChangeContrato() {
                if(angular.isUndefined(self.campoContrato)) {
                    clearFields();
                } else if(self.campoContrato != _result.NUMCONTRATO) {
                    preecheCampos('NUMCONTRATO', self.campoContrato);
                }
            }

            function preecheCampos(campoAlterado, novoValor) {
                if(angular.isDefined(novoValor)) {
                    ServiceProxy.callService("armazem@PesagemSP.getNotaTransferencia", { param: { campo: campoAlterado, valor: novoValor } }).then(result => {
                        if(angular.isArray(result.responseBody.list)) {
                            let notasList = result.responseBody.list;
                            if(notasList.length == 1) {
                                let nota = result.responseBody.list[0];
                                atualizaValores(nota);
                            } else if(notasList.length > 1) {
                                selecionaNota(notasList).then(notaSelecionada => {
                                    atualizaValores(notaSelecionada.result);
                                });
                            } else {
                                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, "Lançamento não encontrado.").then(() => {
                                    clearFields();
                                });
                            }

                        }
                    });
                }
            }

            function clearFields() {
                self.campoNfeChave = undefined;
                self.campoVeiculo = undefined;
                self.campoNroNota = undefined;
                self.campoNroUnico = undefined;
                self.campoContrato = undefined;
                _result = {};
                enableBtnOk(false);
            }

            function atualizaValores(nota) {
                if(!validaValores(nota)) {
                    clearFields();
                    return;
                }
                self.campoNfeChave = nota.CHAVENFE;
                self.campoVeiculo =  nota.CODVEICULO;
                self.campoNroNota = nota.NUMNOTA;
                self.campoNroUnico = nota.NUNOTA;
                self.campoContrato = nota.NUMCONTRATO;
                _result = nota;
                enableBtnOk(true);
            }

            function enableBtnOk(val) {
                if(options.btnOk) {
                    if(val) {
                        options.btnOk[0].setAttribute('class', 'btn btn-primary');
                        options.btnOk.on('click', onClickConfirm);
                    } else {
                        options.btnOk[0].setAttribute('class', 'btn btn-primary disabled');
                        options.btnOk.on('click', ()=> {});
                    }
                }
            }

            function validaValores(nota) {
                if(angular.isUndefined(nota.CODMOTORISTA) || nota.CODMOTORISTA === 0) {
                    MessageUtils.showAlert(MessageUtils.TITLE_ERROR, "A Nota de Transporte informada não tem informação do Veículo e/ou Motorista. Por isso, esta pesagem deve ser aberta de forma manual.");
                    return false;
                }

                if(angular.isUndefined(nota.CODVEICULO) || nota.CODVEICULO === 0) {
                    MessageUtils.showAlert(MessageUtils.TITLE_ERROR, "A Nota de Transporte informada não tem informação do Veículo e/ou Motorista. Por isso, esta pesagem deve ser aberta de forma manual.");
                    return false;
                }

                return true;
            }

            function selecionaNota(notas) {
                return SanPopup.open({
                    title: 'Selecione a Nota de Transporte',
                    templateUrl: 'commons/pesquisadorNotaTransporte/selecionaNota.tpl.html',
                    controller: 'SelecionaNotaController',
                    controllerAs: 'ctrl',
                    okBtnLabel: SkI18nService.instant('Geral.confirmar'),
                    okBtnClass: 'btn-primary',
                    cancelBtnClass: 'btn-default',
                    showBtnNo: false,
                    showBtnCancel: true,
                    bodyPadding: false,
                    size: 'md',
                    resolve: {
                        data: {
                            notas: notas
                        }
                    }
                }).result;
            }

            function onClickConfirm() {
                $popupInstance.success({
                    result: _result
                });
            }

            function criteriaNroUnico() {
                return getDefaultCriteria("NUNOTA");
            }

            function criteriaVeiculo() {
                return getDefaultCriteria("CODVEICULO")
            }

            function getDefaultCriteria(field) {
                var criteria = Criteria();

                let expression;
                expression = "this." + field + " IN (SELECT CAB." + field;
                expression += " FROM";
                expression += "        TGFTOP TOPER";
                expression += "    INNER JOIN TGFCAB CAB ON";
                expression += "        (CAB.CODTIPOPER = TOPER.CODTIPOPER)";
                expression += "    INNER JOIN TGFITE ITE ON";
                expression += "        (CAB.NUNOTA = ITE.NUNOTA)";
                expression += "    WHERE";
                expression += "        CAB.STATUSNOTA = 'L'";
                expression += "        AND TOPER.TIPMOV = 'N'";
                expression += "        AND CAB.PENDENTE = 'S'";
                expression += "        AND TOPER.ARMTIPAPU = 2";
                expression += "        AND ITE.QTDENTREGUE = 0";
                expression += "       AND CAB.NUMCONTRATO > 0)";

                criteria.append(expression);

                return criteria;
            }
        }])
angular
    .module('snk.commons')
    .service('PesquisadorNotaTransporteService', ['SanPopup', 'i18n',
        function (SanPopup, i18n) {
            var self = this;
            self.open = open;
            self.isConcluirEnabled = false;

            function open() {
                var btnOk = angular.element('<button class="btn btn-primary disabled" ng-disabled="true">' + 'Lançar' + '</button>');
                var btnCancelar = angular.element('<button class="btn btn-default">' + 'Cancelar' + '</button>');

                var popup = SanPopup.open({
                    title: 'Nota de Transporte',
                    templateUrl: 'commons/pesquisadorNotaTransporte/pesquisadorNotaTransporte.tpl.html',
                    controller: 'PesquisadorNotaTransporteController',
                    controllerAs: 'ctrl',
                    type: 'default',
                    showBtnNo: false,
                    showBtnCancel: false,
                    showBtnOk: false,
                    bodyPadding: false,
                    size: 'md',
                    height: 130,
                    windowClass: 'config-form-modal',
                    rightBottomBar: [btnCancelar, btnOk],
                    enableBtnOk: false,
                    resolve: {
                        options: {
                            btnOk: btnOk,
                            btnCancelar: btnCancelar
                        }
                    }
                });

                return popup.result;
            }

            // function btnOkEnabled() {
            //     return self.isConcluirEnabled;
            // }

            // function enableConcluir(val) {
            //     self.isConcluirEnabled = val;
            // }
        }])
angular.module('snk.commons')
    .controller('SelecionaNotaController', ['$scope', 'data', '$popupInstance',
        function ($scope, data, $popupInstance) {
            var self = this;

            self.onDatasetCreated = onDatasetCreated;
            self.dsNotaTransporte;
            var _notas = [];
            $scope.$success = success;
            self.dblClickNota = dblClickNota;

            init();

            function init() {
                _notas = data.notas;
            }

            function onDatasetCreated(dataset) {
                self.dsNotaTransporte = dataset;
                self.dsNotaTransporte.init().finally(populateDataset);
            }

            function success() {
                $popupInstance.success({result: self.dsNotaTransporte.getCurrentRowAsObject()});
            }

            function dblClickNota() {
                var params = {
                    result: self.dsNotaTransporte.getCurrentRowAsObject()
                };
                $popupInstance.success(params);
            }

            function populateDataset() {
                self.dsNotaTransporte.addRecordsAsObjects(_notas);
            }
        }
    ]
    );

/* 
 *  Createad by Leonardo Mendes on 21/03/2018.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .component('skPlanejamentoMetaOrcamento', {
        templateUrl: 'commons/planejamentoMetaOrcamento/planejamento-meta-orcamento.tpl.html',
        controller: 'planejamentoMetaOrcamentoController',
        controllerAs: 'ctrl',
        bindings: {
            configPlanejamento: '=skConfigPlanejamento'
        }
    })
    .controller('planejamentoMetaOrcamentoController', ['$timeout', 'SkApplicationInstance', 'Criteria', '$q', 'ArrayUtils', 'NumberUtils', 'StringUtils', 'MessageUtils', 'PopUpParameter', 'DateUtils', 'i18n', 'SanPopup', 'ServiceProxy', 'ObjectUtils', '$document', 'AngularUtil', '$scope', 'MGEAuthorizationConstants',
        function ($timeout, SkApplicationInstance, Criteria, $q, ArrayUtils, NumberUtils, StringUtils, MessageUtils, PopUpParameter, DateUtils, i18n, SanPopup, ServiceProxy, ObjectUtils, $document, AngularUtil, $scope, MGEAuthorizationConstants) {
            var self = this;

            self.resourceId = self.configPlanejamento.resourceID;
            self.actionBtnID = self.configPlanejamento.resourceID + '.actionBtnID';
            self.entityBtnAction = self.configPlanejamento.entityBtnAction;
            self.ehSankhyaW = !SkApplicationInstance.isJivaW();

            //Variáveis privadas
            var _bloqueiaEntradaNumerosNegativos = StringUtils.toBoolean(self.configPlanejamento.bloqueiaEntradaNumerosNegativos);
            var _usaCenarios = StringUtils.toBoolean(self.configPlanejamento.usaCenarios);
            var _fieldCustom = self.configPlanejamento.fieldCustom;
            var _codUsuario = SkApplicationInstance.getUserID();
            var _codMeta;
            var _usaSaldoContasColRealizado;
            var _cenarios;
            var _messageSave;
            var _optionsReport;
            var _entityListCtrls = {};
            var _entityListLastValues = {};
            var _mapDados = {};
            var _mapDadosFilhos = {};
            var _mapTotalizador = {};
            var _dados;
            var _nomeMeta;
            var _rows = [];
            var _configTela = {};
            var _gridconfig = {};
            var _gridconfigTotal = {};
            var _chave = self.resourceId + '_planejamento';
            var _isPinned;
            var _qtdPeriodo;
            var _calculoDesvioInverso;
            var _periocidade;
            var _validaPrevisto = false;
            var _filter;
            var _contador;
            var _isUpdateConfig = false;
            var _filtroEntidade;
            var _anoAtual = DateUtils.getYear();
            var _ignorarAlertaDistribuicao = false;
            var _ignorarAlertaAlteracao = false;
            var _realizado;
            var _previsto;
            var _totalizador = [
                { path: i18n('Commons.PlanejamentoMetaOrcamento.saldoanterior'), pk: 'SALDOANTERIOR' },
                { path: i18n('Commons.PlanejamentoMetaOrcamento.totalperiodo'), pk: 'TOTALPERIODO' },
                { path: i18n('Commons.PlanejamentoMetaOrcamento.saldoatual'), pk: 'SALDOATUAL' }
            ];
            var _keymap = {
                TAB: 9, STRG: 17, CTRL: 17, CTRLRIGHT: 18, SHIFT: 16, ENTER: 13, BACKSPACE: 8, ALT: 18,
                ALTRIGHT: 17, SPACE: 32, WIN: 91, MAC: 91, PG_UP: 33, PG_DOWN: 34, UP: 38, DOWN: 40, LEFT: 37,
                RIGHT: 39, ESC: 27, DEL: 46, F1: 112, F2: 113, F3: 114, F4: 115, F5: 116, F6: 117, F7: 118,
                F8: 119, F9: 120, F10: 121, F11: 122, F12: 123, FN: null
            };
            var _diasMes;
            var _anoSelecionado;

            var _btnImportar = angular.element('<button class="btn btn-primary">' + "Importar" + '</button>');
            var _btnExportar = angular.element('<button class="btn btn-primary">' + "Exportar" + '</button>');

            //Constante
            const REALIZADO = 'REALIZADO';
            const DIFERENCA = 'DIFERENCA';
            const PREVISTO = 'PREVISTO';
            const PREVISTOOFICIAL = 'PREVISTOOFICIAL';
            const TOTALPERIODO = 'TOTALPERIODO';
            const SALDOATUAL = 'SALDOATUAL';
            const SALDOANTERIOR = 'SALDOANTERIOR';
            const PREVISTOTOTAL = 'PREVISTOTOTAL';
            const REALIZADOTOTAL = 'REALIZADOTOTAL';
            const PREVISTOOFICIALTOTAL = 'PREVISTOOFICIALTOTAL';
            const DIFERENCATOTAL = 'DIFERENCATOTAL';

            var _camposCalculado = [PREVISTOOFICIAL, REALIZADO, PREVISTO];

            //Funções disponíveis no controlador
            self.popUpSelecioneMeta = popUpSelecioneMeta;
            self.configurarGrade = configurarGrade;
            self.carregarPlanejamento = carregarPlanejamento;
            self.getEnviromentCriteria = getEnviromentCriteria;
            self.onFilterCreated = onFilterCreated;
            self.keydownHandler = keydownHandler;
            self.onFilterTextBoxChanged = onFilterTextBoxChanged;
            self.gerarMetas = gerarMetas;
            self.trocarTipoMeta = trocarTipoMeta;
            self.mostrarEsconder = mostrarEsconder;
            self.descartarAlteracoes = descartarAlteracoes;
            self.limparPlanejamento = limparPlanejamento;
            self.limparRowdata = limparRowdata;
            self.updateCampoDetalhe = updateCampoDetalhe;
            self.onEntityListCreated = onEntityListCreated;
            self.otherOptionsLoader = otherOptionsLoader;
            self.collapseAll = collapseAll;
            self.expandAll = expandAll;
            self.atualizarGridPorPeriodo = atualizarGridPorPeriodo;
            self.getCriteriaPeriodo = getCriteriaPeriodo;
            self.onChangePeriodo = onChangePeriodo;
            self.onChangeEmpresa = onChangeEmpresa;
            self.getCriteriaEmpresa = getCriteriaEmpresa;
            self.reportLoader = reportLoader;
            self.voltarPlanejamento = voltarPlanejamento;
            self.selecionaMes = selecionaMes;
            self.verificarPeriodo = verificarPeriodo;

            //Variáveis disponíveis no controlador
            self.podeExcluirPlanejamento = false;
            self.arvoreFiltro = [];
            self.rowsPsList = [];
            self.isDisableBtnAcao = true;
            self.showFilter = false;
            self.usaCadastroMarcas = self.configPlanejamento.usaCadastroMarcas == true;
            self.entityList = {};
            self.openEnityList = {};
            self.selectedItems = {};
            self.isDisableBtn = true;
            self.mostraMes = false;
            self.valuesCombobox = {};
            self.filterEntity = [];
            self.optionsAno = [];
            self.optionsEntidades = [];
            self.tipoMeta = 'R';// Padrão inicial previsto receita
            self.lblFiltro = i18n('Commons.PlanejamentoMetaOrcamento.filtro');
            self.porPeriodo = self.configPlanejamento.porPeriodo == true;
            self.bloquearEmpresaDetalhe = self.configPlanejamento.bloquearEmpresaDetalhe == true;
            self.ehTipoMetaContabil = self.configPlanejamento.ehTipoMetaContabil == true;
            self.codPeriodo;
            self.codEmp;
            self.atualizaRealizado = self.configPlanejamento.atualizaRealizado == true;
            self.lblTipoMeta = i18n(self.ehTipoMetaContabil ? 'Commons.PlanejamentoMetaOrcamento.tipoMetaContabil' : 'Commons.PlanejamentoMetaOrcamento.tipometa');
            self.lblTrocarmeta = i18n(self.ehTipoMetaContabil ? 'Commons.PlanejamentoMetaOrcamento.trocarmetaContabil' : 'Commons.PlanejamentoMetaOrcamento.trocarmeta');
            self.optionsTipo = [
                {
                    value: i18n(self.ehTipoMetaContabil ? 'Commons.PlanejamentoMetaOrcamento.credito' : 'Commons.PlanejamentoMetaOrcamento.receita'),
                    data: 'R'
                },
                {
                    value: i18n(self.ehTipoMetaContabil ? 'Commons.PlanejamentoMetaOrcamento.debito' : 'Commons.PlanejamentoMetaOrcamento.despesa'),
                    data: 'D'
                }
            ];
            self.gridOptionsTotal = {
                autoGroupColumnDef: {
                    headerName: i18n('Commons.PlanejamentoMetaOrcamento.totalizador'),
                    width: 150,
                    suppressResize: true,
                    headerComponent: CustomHeaderTotalizador
                },
                columnTypes: {},
                getContextMenuItems: function (params) {
                    return [];
                },
                onColumnResized: function (param) {
                    if (param.finished === true && param.source === 'uiColumnDragged') {
                        var col = param.columns[0];
                        var newWidth = col.actualWidth;
                        _gridconfigTotal[col.colId] = NumberUtils.getNumberOrDefault(newWidth, 100);

                        saveState();
                    }
                }
            };
            self.gridOptions = {
                onCellFocused: onCellFocused,
                onCellValueChanged: onCellValueChanged,
                autoGroupColumnDef: {
                    width: 300,
                    headerName: i18n('Commons.PlanejamentoMetaOrcamento.planejamento'),
                    cellRendererParams: {},
                    headerComponent: CustomHeaderGroup
                },
                getContextMenuItems: function (params) { return []; },
                icons: {
                    groupExpanded: '<span class="glyphicons glyphicons-chevron-down"></span>',
                    groupContracted: '<span class="glyphicons glyphicons-chevron-right"></span>',
                },
                onCellEditingStarted: onCellEditingStarted,
                onCellEditingStopped: function (data) {
                    //Salvamento na tabela temporária de 5 segundos
                    _contador = $timeout(saveConfigDataSource, 5000);
                },
                onColumnResized: function (param) {
                    if (param.finished === true && param.source === 'uiColumnDragged') {
                        var col = param.columns[0];
                        var newWidth = col.actualWidth;
                        _gridconfig[col.colId] = NumberUtils.getNumberOrDefault(newWidth, 100);

                        saveState();
                    }
                },
                isExternalFilterPresent: isExternalFilterPresent,
                doesExternalFilterPass: doesExternalFilterPass,
                onFilterChanged: function (params) {
                    params.api.expandAll();
                }
            };

            self.planejamentoCtx = {
                getMasterEntityName: function () {
                    return undefined;
                },
                selectedRowsGetter: function () {
                    return self.rowsPsList;
                },
                recordsReloader: function (refreshType) {
                    if (refreshType == 'NONE') {
                        return;
                    } else {
                        carregarPlanejamento();
                    }
                },
                parameterGetter: function (resourceID, entityName, fieldName) {
                    return '';
                },
                parameterLabelGetter: function (resourceID, entityName, fieldName) {
                    return '';
                }
            };

            self.meses = [{ value:  'Janeiro', data: "0" },
                { value:  'Fevereiro', data: "1" },
                { value:  'Março', data: "2" },
                { value:  'Abril', data: "3" },
                { value:  'Maio', data: "4" },
                { value:  'Junho', data: "5" },
                { value:  'Julho', data: "6" },
                { value:  'Agosto', data: "7" },
                { value:  'Setembro', data: "8" },
                { value:  'Outubro', data: "9" },
                { value:  'Novembro', data: "10" },
                { value:  'Dezembro', data: "11" }
            ];

            self.mes;
            self.changeMes = false;

            init();
            function init() {
                addPropertiesGridOptions(self.gridOptions);

                addPropertiesGridOptions(self.gridOptionsTotal);

                popUpSelecioneMeta(false);

                // Colocar chamada de metodo para verificar a cfg da meta e saber a periodicidade para o seletor de mes

                if (self.ehSankhyaW && self.entityBtnAction) {
                    getRelatoriosDisponiveis();
                }
                if (!ServiceProxy.hasClientEvent("br.com.sankhya.mge.event.resgatar.cenario")) {
                    ServiceProxy.addClientEvent("br.com.sankhya.mge.event.resgatar.cenario", function (clientEvent, recaller) {
                        MessageUtils.showAlertWithConfirm("Atenção !", "Ao resgatar cenário todas as modificações não salvas serão perdidas. Deseja continuar ?").then(function (sim) {
                            recaller.params.sobrescrever = true;
                            recaller.reCall();
                        
                        });

                    });
                }
                
                self.podeExcluirPlanejamento = SkApplicationInstance.getAuthorizationData().hasAccess(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE);
            }


            function reportLoader() {
                return _optionsReport;
            }


            function itemClickReport(nuRfe) {
                if (self.rowsPsList.length == 0) {
                    return;
                }

                var pk = {};
                var id = nuRfe;

                var row = self.rowsPsList[0];

                Object.keys(_fieldCustom).forEach(function (e) {
                    var pkFieldName = _fieldCustom[e].pkFieldName;
                    var pkType = _fieldCustom[e].pkType;
                    pk["PK_" + pkFieldName] = { type: pkType, value: row[pkFieldName] };
                });

                SkApplicationInstance.openApp("br.com.sankhya.controls.ReportLauncher_" + id, pk);
            }

            function getRelatoriosDisponiveis() {
                var instanciaElem = {
                    instancia: {
                        nome: self.entityBtnAction
                    },
                    pk: []
                };

                ServiceProxy.callService('VisualizadorRelatorios.getRelatoriosDisponiveisPorInstancia',
                    instanciaElem
                ).then(function (result) {
                    _optionsReport = [];

                    var relatorios = result.responseBody.relatorios.relatorio;

                    if (relatorios && relatorios.length > 0) {
                        for (var i = 0; i < relatorios.length; i++) {
                            var rel = relatorios[i];
                            _optionsReport.push({
                                label: rel.label,
                                action: function () {
                                    itemClickReport(rel.nuRfe);
                                }
                            });
                        }
                    }

                    if (_optionsReport.length > 0) {
                        angular.element(document.getElementById('report-loader'))
                            .replaceWith(AngularUtil.compile('<sk-dropdown-menu ng-show="!ctrl.modoCenario" sk-disabled="ctrl.rowsPsList.length == 0" sk-font-icon="file-export" sk-open-always="true" sk-build-options="ctrl.reportLoader()"></sk-dropdown-menu>', $scope));
                    }
                });
            }

            function containsAny(text, fragments) {
                var contains = false;
                for (var i = 0; i < fragments.length; i++) {
                    if (StringUtils.emptyAsUndefined(fragments[i]) != undefined &&
                        text.indexOf(fragments[i]) > -1) {
                        contains = true;
                        break;
                    }
                }

                return contains;
            }
            function isExternalFilterPresent() {
                return StringUtils.emptyAsUndefined(self.filterGrade) != undefined;
            }

            function doesExternalFilterPass(node) {
                var pass = true;
                if (angular.isDefined(node.data) && angular.isDefined(node.data.descricao)) {
                    var fragments = ArrayUtils.toArray(StringUtils.replaceAll(self.filterGrade, '%', ' ').toUpperCase().split(" "));
                    pass = containsAny(node.data.descricao.toUpperCase(), fragments);
                }
                return pass;
            }

            function onCellEditingStarted(params) {
                disableTimeout();

                if (_validaPrevisto) {
                    validaEdicao(params);
                }
            }

            function validaEdicao(params) {
                var dataAtual = DateUtils.getToday();

                if (self.intervalounico) {
                    var dias = DateUtils.diffWithToday(DateUtils.stringToDate(self.intervalounico));
                    if (dias <= 0) {
                        self.gridOptions.api.stopEditing(true);
                        MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.alertaEdicaoPrevisto'));
                    }
                } else {
                    var anoPlanejamento = NumberUtils.stringToNumber(self.anoPlanejamento);
                    var anoAtual = dataAtual.getFullYear();
                    if (anoPlanejamento <= anoAtual) {
                        var isErro = false;

                        if (anoPlanejamento < anoAtual) {
                            isErro = true;
                        } else {
                            var mesAtual = dataAtual.getMonth() + 1;
                            var column = params.column.colId;
                            var mesPrev = NumberUtils.stringToNumber(column.split(PREVISTO)[1]);
                            if (_periocidade != 1) {//Mensal
                                mesAtual = Math.round(Math.ceil(mesAtual / _periocidade));
                            }

                            if (mesPrev <= mesAtual) {
                                isErro = true;
                            }
                        }

                        if (isErro) {
                            self.gridOptions.api.stopEditing(true);
                            MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.alertaEdicaoPrevisto'));
                        }
                    }
                }
            }

            function disableTimeout() {
                if (_contador) {
                    $timeout.cancel(_contador);
                    _contador = undefined;
                }
            }

            function otherOptionsLoader() {
                self.otherOptions = [];

                if (self.ehSankhyaW) {

                    if (_usaCenarios) {
                        self.otherOptions = [
                            { id: 'SALVARCENARIO', label: i18n('Commons.PlanejamentoMetaOrcamento.lblSalvarCenario'), action: popUpSalvarCenario },
                            { label: i18n('Commons.PlanejamentoMetaOrcamento.lblCenarios'), action: popUpCenarios }
                        ];
                    }

                    self.otherOptions.push({ id: 'AJUSTEVALORES', label: i18n('Commons.PlanejamentoMetaOrcamento.lblajustevalores'), action: popUplblAjustevalores });
                }

                self.otherOptions.push({ id: 'IMPORMETATANO', label: i18n('Commons.PlanejamentoMetaOrcamento.importaanoanterior'), action: importPlanejamentoAnoAterior });

                self.otherOptions.push({ id: 'VISMOVORCMETA', label: i18n('Commons.PlanejamentoMetaOrcamento.visMovOrcMeta'), action: visuMovimentacaoPlanejamento });

                self.otherOptions.push({ id: 'IMPORTAPLANILHA', label: i18n('Commons.PlanejamentoMetaOrcamento.exportaImportaPlanilha'), action: importaExportaPlanilha });
                
                return self.otherOptions;
            }

            function changeOtherOptionEnabled(id, value) {
                var option = ArrayUtils.find(self.otherOptions, function (item) {
                    return item.id == id;
                });

                if (option) {
                    option.enabled = value;
                }
            }

            function importPlanejamentoAnoAterior() {
                if(self.mostraMes){
                    MessageUtils.showAlert("Alerta","Função ainda não disponivel para meta ou orçamentos com periodicidade diária e semanal.");
                    return;
                }

                if (angular.isUndefined(_anoAterior)) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.metaNaopossuiAnoAnterio', [self.descrMeta, self.anoPlanejamento]));
                    return;
                }

                var keyAnos = Object.keys(_anoAterior);
                if (keyAnos.indexOf(self.anoPlanejamento.toString()) > -1) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.possuiPlanejamento', [self.descrMeta, self.anoPlanejamento]));
                    return;
                }


                var anos = {}
                keyAnos.forEach(function (key) {
                    if (Number(key) < Number(self.anoPlanejamento)) {
                        anos[key] = key;
                    }
                });

                PopUpParameter.builder()
                    .title(i18n('Commons.PlanejamentoMetaOrcamento.selecionaeano'))
                    .size('sm')
                    .buildComboboxParameter('ANO', i18n('Commons.PlanejamentoMetaOrcamento.ano'), true, anos, true)
                    .show().result
                    .then(function (result) {
                        var params = {
                            param: {
                                codMeta: _codMeta,
                                ano: result.ANO,
                                anoPlanejamento: self.anoPlanejamento
                            }
                        };

                        ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.importarPlanejamentoAnterior', params)
                            .then(function (response) {
                                MessageUtils.showInfo('Copia foi efetuada com sucesso clique em carregar para visualizar')
                                    .then(function () {
                                    	if(!_anoAterior.hasOwnProperty(self.anoPlanejamento)){
											_anoAterior = { ..._anoAterior, [self.anoPlanejamento] : NumberUtils.stringToNumber(self.anoPlanejamento) }
										}
                                        limparRowdata();
                                    });
                            });
                    });


            }

            function onCellValueChanged(event) {
                var oldValue = event.oldValue;
                if (oldValue != event.newValue) {
                    var field = event.column.colId;
                    var pk = event.data.pk;

                    if (event.newValue > 0 && event.data.recDesp == 'S') {
                        MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.distribucaoNaoPermitida'))
                            .then(function () {
                                event.data[field] = oldValue;
                                self.gridOptions.api.refreshCells();
                            });
                    } else {

                        if (event.data.analitico == 'S' || _ignorarAlertaDistribuicao) {
                            updateItems(pk, field, oldValue);

                        } else {
                            var msg = 'distribuidohierarquia';

                            if (angular.isUndefined(event.newValue)) {
                                msg = 'limparhierarquia';
                            } else if (event.newValue == 0) {
                                msg = 'zerarHierarquia';
                            }

                            MessageUtils.showAlertWithConfirm(i18n('Commons.PlanejamentoMetaOrcamento.' + msg))
                                .then(function () {
                                    updateItems(pk, field, oldValue);
                                }, function () {
                                    event.data[field] = oldValue;
                                    self.gridOptions.api.refreshCells();
                                });
                        }
                    }
                }
            }

            self.navIndex = 1;

            function onFilterCreated($filter) {
                _filter = $filter;
            }

            function keydownHandler($event) {
                // ng-keydown="ctrl.keydownHandler($event)"
                var e = $event;

                if (e.keyCode === _keymap.F7) {
                    if (!self.isDisableBtn) {
                        gerarMetas();
                    }
                }
            };

            function onFilterTextBoxChanged() {
                if (self.gridOptions.api) {
                    self.gridOptions.api.onFilterChanged();
                }
            }

            function limparRowdata() {
                _rows = [];
                if (self.gridOptions.api) {
                    self.gridOptions.api.setRowData(undefined);
                    self.gridOptionsTotal.api.setRowData(undefined);
                }
            }
            function descartarAlteracoes() {
                limpaDescartaAlteracoes('descartarAlteracoes');
            }

            function limparPlanejamento() {
                limpaDescartaAlteracoes('limparPlanejamento');
            }

            function limpaDescartaAlteracoes(service) {
            	
            	saveConfigDataSource();
            	
                MessageUtils
                    .simpleConfirmBuilder()
                    .title('Geral.lblExcluir')
                    .msg(i18n('Commons.PlanejamentoMetaOrcamento.' + service))
                    .okTheme('danger')
                    .okLabel('Dataset.lblSimDeletar')
                    .show()
                    .then(function () {
                        if (self.porPeriodo) {
                            var params = {
                                param: {
                                    codMeta: _codMeta,
                                    periodo: self.codPeriodo,
                                    codEmp: self.codEmp
                                }
                            };
                        } else {
                            var params = {
                                param: {
                                    codMeta: _codMeta,
                                    ano: self.anoPlanejamento,
                                    mes : self.mesSelecionado == undefined ? null :self.mesSelecionado
                                }
                            };
                        }


                        ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.' + service, params)
                            .then(function (response) {
                                MessageUtils.showInfo(ObjectUtils.getProperty(response, 'responseBody.msg'))
                                    .then(function () {
                                    	if (!self.porPeriodo && StringUtils.isNotEmpty(_anoAterior) && _anoAterior.hasOwnProperty(self.anoPlanejamento)) {
                                    		delete _anoAterior[self.anoPlanejamento];
                                    	}
                                    	carregarPlanejamento();
                                    });
                            });
                    });
            }

            function saveState() {

                var newDataProvider = {};
                ArrayUtils.toArray(Object.keys(_entityListCtrls))
                    .forEach(function (key) {
                        newDataProvider[key] = _entityListCtrls[key].getDataProvider();

                        if (angular.isDefined(newDataProvider[key])) {
                            newDataProvider[key].forEach(function (e) {
                                e.checked = e.selected ? 'S' : 'N',
                                    e.selected = e.selected ? 'S' : 'N'
                            });
                        }
                    });


                var hasMeta = false;
                var configTela = ArrayUtils.toArray(_configTela.metas);
                for (var i = 0; i < configTela.length; i++) {
                    if (configTela[i].codMeta == _codMeta) {
                        configTela[i].detalhe = self.valueDetalhe;
                        configTela[i].optionsEntidades = self.optionsEntidades;
                        configTela[i].filtros.valuesCombobox = self.valuesCombobox;
                        configTela[i].filtros.tipoMeta = self.tipoMeta;

                        var oldDataProvider = configTela[i].filtros.dataProvider;
                        if (angular.isUndefined(oldDataProvider)) {
                            oldDataProvider = {};
                        }

                        ArrayUtils.toArray(Object.keys(newDataProvider))
                            .forEach(function (key) {
                                oldDataProvider[key] = newDataProvider[key];
                            });

                        configTela[i].filtros.dataProvider = oldDataProvider;

                        hasMeta = true
                        break;
                    }
                }

                if (!hasMeta) {
                    configTela.push({
                        codMeta: _codMeta,
                        detalhe: self.valueDetalhe,
                        optionsEntidades: self.optionsEntidades,
                        filtros: {
                            valuesCombobox: self.valuesCombobox,
                            tipoMeta: self.tipoMeta,
                            dataProvider: newDataProvider
                        }
                    });
                }


                var realizado = self.gridOptions.columnApi.getColumn(REALIZADO + '1');
                var diferenca = self.gridOptions.columnApi.getColumn(DIFERENCA + '1');
                var previstoOficial = self.gridOptions.columnApi.getColumn(PREVISTOOFICIAL + '1');

                //Configuração tela por usuario e por meta
                var config = {
                    gridconfig: _gridconfig,
                    gridconfigTotal: _gridconfigTotal,
                    realizado: realizado && realizado.visible ? 'S' : 'N',
                    diferenca: diferenca && diferenca.visible ? 'S' : 'N',
                    previstoOficial: previstoOficial && previstoOficial.visible ? 'S' : 'N',
                    ignorarAlertaDistribuicao: _ignorarAlertaDistribuicao ? 'S' : 'N',
                    ignorarAlertaAlteracao: _ignorarAlertaAlteracao ? 'S' : 'N',
                    totalPinned: _isPinned,
                    metas: configTela,
                    ignoreAlertaIncicial: _configTela.ignoreAlertaIncicial ? 'S' : 'N'
                };

                SkApplicationInstance.saveMgeConfig(_chave, config).then(
                    function () {
                        _configTela = config;
                        SkApplicationInstance.putConfiguracaoTela(_chave, config);
                    }
                );
            }

            function loadState() {
                var deferred = $q.defer();

                var cfgPlanejamento = SkApplicationInstance.getConfiguracaoTela(_chave);
                if (angular.isDefined(cfgPlanejamento)) {
                    //A configurações são aplicada por usuario
                    _configTela = JSON.parse(JSON.stringify(cfgPlanejamento));

                    if (_configTela) {
                        _ignorarAlertaDistribuicao = _configTela.ignorarAlertaDistribuicao == 'S';
                        _ignorarAlertaAlteracao = _configTela.ignorarAlertaAlteracao == 'S';
                    }
                }

                deferred.resolve();

                return deferred.promise;
            }

            function isEnableAlerta(name, enable) {
                if (name == 'distribuirhierarquia') {
                    _ignorarAlertaDistribuicao = enable;
                } else if (name == 'alertarAlteracao') {
                    _ignorarAlertaAlteracao = enable;
                }
            }

            function applyConfigMeta(configMeta) {

                if (angular.isUndefined(configMeta)) {
                    return;
                }
                self.arvoreFiltro = [];
                carregarArvoreFiltro(configMeta);

                var dataProvider = configMeta.filtros.dataProvider;
                if (angular.isObject(dataProvider)) {
                    ArrayUtils.toArray(Object.keys(dataProvider))
                        .forEach(function (key) {
                            ArrayUtils.toArray(dataProvider[key]).forEach(function (e) {
                                _entityListLastValues[key] = ArrayUtils.toArray(_entityListLastValues[key]);
                                
                                var isHaving = false;
                                _entityListLastValues[key].forEach(function (entity) {
                                    if (entity.data == NumberUtils.stringToNumber(e.data)) {
                                        entity['checked'] = true;
                                        entity['selected'] = true;
                                        isHaving = true;
                                    } else {
                                        entity['checked'] = false;
                                        entity['selected'] = false;
                                    }
                                });

                                if (!isHaving) {
                                    _entityListLastValues[key].push({
                                        data: NumberUtils.stringToNumber(e.data),
                                        value: e.value,
                                        checked: e.selected == 'S',
                                        selected: e.selected == 'S'
                                    });
                                }
                            });
                        });
                }

                self.valuesCombobox = {};
                opcoes = configMeta.filtros.valuesCombobox;
                if (angular.isDefined(opcoes)) {
                    var optionsCombobox = ArrayUtils.toArray(self.comboboxOptions);
                    optionsCombobox.forEach(function (e) {
                        if (angular.isDefined(opcoes[e.entity])) {
                            self.valuesCombobox[e.entity] = opcoes[e.entity];
                        }
                    });
                }

                // Esse tempo e necessario devido a carga dos filtros da tela
                $timeout(carregarPlanejamento, 650);
            }

            self.showMarcaField = function() {
                return (angular.isDefined(self.valuesCombobox.MarcaProduto) && self.valuesCombobox.MarcaProduto != '');
            }
            
            function applyConfigAfterLoading(configMeta) {
                if (_configTela) {
                    //Aplicando Configuração tela
                    setVisibleField(REALIZADO, _configTela.realizado == 'S');
                    setVisibleField(DIFERENCA, _configTela.diferenca == 'S');
                    setVisibleField(PREVISTOOFICIAL, _configTela.previstoOficial == 'S');
                    setColumnPinned(_configTela.totalPinned);


                    //Aplicando configuração grade planejamento
                    _gridconfig = _configTela.gridconfig;
                    if (angular.isUndefined(_gridconfig)) {
                        _gridconfig = {};
                    } else {
                        ArrayUtils.toArray(Object.keys(_gridconfig))
                            .forEach(function (e) {
                                self.gridOptions.columnApi.setColumnWidth(e, NumberUtils.getNumberOrDefault(_gridconfig[e], 100));
                            });
                    }

                    //Aplicando configuração grade totalizadora
                    _gridconfigTotal = _configTela.gridconfigTotal;
                    if (angular.isUndefined(_gridconfigTotal)) {
                        _gridconfigTotal = {};
                    } else {
                        ArrayUtils.toArray(Object.keys(_gridconfigTotal))
                            .forEach(function (e) {
                                self.gridOptionsTotal.columnApi.setColumnWidth(e, NumberUtils.getNumberOrDefault(_gridconfigTotal[e], 100));
                            });
                    }

                    applyConfigMeta(configMeta);
                }
            }

            function updateItems(pk, field, oldValue, rowData) {
                if (rowData == undefined) {
                    rowData = _mapDados[pk];
                }

                updateChildren(rowData, field);// Atualização dos filhos da hierarquia

                updateFather(rowData, field, oldValue); // Atualização dos pais da hierarquia

                updateTotalGrid(field);// Atualização da grid totalizadora

                self.gridOptions.api.refreshCells();


            }

            function updateTotalGrid(field) {
                var aux = extractToNumber(field);

                if (angular.isDefined(aux)) {
                    var numero = NumberUtils.getNumberOrZero(aux);

                    // Raiz da Hierarquia
                    var _base = _mapDados['-999999999'];

                    if (angular.isDefined(_base)) {
                        // Objeto TOTALPERIODO
                        var totalPeriodo = _mapTotalizador[TOTALPERIODO];

                        if (angular.isDefined(totalPeriodo)) {

                            _camposCalculado.forEach(function (name) {
                                totalPeriodo[name + numero] = _base[name + numero];
                            });

                            // Objeto Saldo Atual
                            var saldoAtual = _mapTotalizador[SALDOATUAL];

                            if (angular.isDefined(saldoAtual)) {
                                atualizaSaldoAtual(numero, saldoAtual, totalPeriodo).then(function () {

                                    // Objeto Saldo Anterior
                                    var saldoAnterior = _mapTotalizador[SALDOANTERIOR];
                                    if (angular.isDefined(saldoAnterior)) {

                                        atualizaSaldoAnterior(numero, saldoAnterior, saldoAtual).then(function () {
                                            // Apos atualizar objetos e necessários atualizar a grid.
                                            self.gridOptionsTotal.api.refreshCells();
                                        });
                                    }
                                });
                            }
                        }
                    }
                }
            }

            function atualizaSaldoAtual(posicao, saldoAtual, totalPeriodo) {
                return $q(function (resolve, reject) {
                    var valueAux;
                    var totalAtual;
                    var vlrSaldo;

                    for (var i = posicao; i <= _qtdPeriodo; i++) {

                        _camposCalculado.forEach(function (e) {

                            if (angular.isDefined(saldoAtual[e + (i - 1)])) {
                                vlrSaldo = NumberUtils.getNumberOrZero(saldoAtual[e + (i - 1)]);
                            }

                            if (angular.isDefined(totalPeriodo[e + i])) {
                                totalAtual = totalPeriodo[e + i] + NumberUtils.getNumberOrZero(vlrSaldo);
                            }

                            if (angular.isDefined(totalAtual)) {
                                valueAux = totalAtual;
                            }

                            saldoAtual[e + i] = valueAux;

                            valueAux = undefined;
                            totalAtual = undefined;
                            vlrSaldo = undefined;
                        });
                    }
                    resolve();
                });
            }

            function atualizaSaldoAnterior(posicao, saldoAnterior, saldoAtual) {
                return $q(function (resolve, reject) {
                    var valueAux;
                    var vlrSaldo;

                    for (var i = posicao; i <= _qtdPeriodo; i++) {

                        _camposCalculado.forEach(function (e) {
                            vlrSaldo = saldoAtual[e + (i - 1)];
                            if (angular.isDefined(vlrSaldo)) {
                                valueAux = vlrSaldo;
                            }
                            saldoAnterior[e + i] = valueAux;

                            vlrSaldo = undefined;
                            valueAux = undefined;
                        });
                    }
                    resolve();
                });
            }

            function podeModificarCampo(campo) {
                return ehDetalheComReceitaEDespesa() && angular.isDefined(campo.recDesp) && campo.analitico == 'S';
            }

            function ehDetalheComReceitaEDespesa() {
                return self.campoDetalhe == 'Natureza' || self.campoDetalhe == 'Conta Contábil';
            }

            function updateFather(rowData, field, oldValue) {
                var pai = _mapDados[rowData.pkPai];

                if (angular.isDefined(pai)) {

                    //Alterando o valor para negativo
                    if (podeModificarCampo(rowData) && angular.isDefined(rowData[field]) && rowData.recDesp == 'D' && rowData[field] > 0 && _calculoDesvioInverso == 'N') {
                        rowData[field] = rowData[field] * -1;
                    }

                    var newValue = NumberUtils.getNumberOrZero(rowData[field]) - NumberUtils.getNumberOrZero(oldValue);

                    oldValue = NumberUtils.getNumberOrZero(angular.copy(pai[field]));

                    var valuePai = NumberUtils.round((newValue + oldValue), 2);

                    pai[field] = angular.isUndefined(rowData[field]) && valuePai == 0 ? undefined : valuePai;

                    if (pai[field] != oldValue) {
                        updateFather(pai, field, oldValue);
                    }
                }
            }

            function updateChildren(rowData, field) {

                if (_isUpdateConfig && rowData.analitico == 'S') {
                    // Insere a linha modificada na tabela temporaria TGFPMO
                    updateConfigRow(rowData, field);
                }

                var children = ArrayUtils.toArray(_mapDadosFilhos[rowData.pk]);

                if (children.length > 0) {

                    var parcela = undefined;
                    var valorCampo = Number(rowData[field]);

                    if (!isNaN(valorCampo)) {
                        parcela = NumberUtils.round(valorCampo / children.length, 2);
                    }

                    for (var i = 0; i < children.length; i++) {
                        var value;
                        if (angular.isDefined(parcela)) {
                            value = parcela;

                            if (podeModificarCampo(children[i]) && children[i].recDesp == 'D' && _calculoDesvioInverso == 'N' && value > 0) {
                                value *= -1;
                            }

                            if (children[i + 1] == undefined) {// eh ultima parcela
                                value = NumberUtils.round(((value + (valorCampo - (parcela * children.length)))), 2);
                            }
                        }

                        if (children[i][field] != value) {
                            children[i][field] = value;
                            updateChildren(children[i], field);
                        }
                    }
                }
            }

            function updateConfigRow(rowData, field) {
                var row = angular.copy(rowData);

                var hasObject = false;

                for (var i = 0; i < _rows.length; i++) {

                    if (_rows[i].pk == row.pk) {

                        if (angular.isDefined(row[field])) {
                            _rows[i][field] = Math.abs(row[field]);
                        } else {
                            _rows[i]['remover'] = StringUtils.undefinedAsEmpty(_rows[i]['remover']) + "-" + field
                            _rows[i][field] = row[field];
                        }
                        hasObject = true;
                        break;
                    }
                }

                if (!hasObject) {
                    if (angular.isUndefined(row[field])) {
                        row['remover'] = field
                    } else {
                        row[field] = Math.abs(row[field]);
                    }
                    _rows.push(row);
                }
            }

            function extractToNumber(field) {
                var aux = '';
                if (field) {

                    var i = field.length - 1;

                    while (!isNaN(Number(field[i]))) {
                        aux = field[i] + aux;
                        i--;
                    }
                }
                return aux;
            }

            function saveConfigDataSource() {
                return $q(function (resolve, reject) {
                    if (_rows.length > 0) {

                        var filtros = getFiltros();

                        ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.saveRow', {
                            param: {
                                rows: _rows,
                                ano: self.anoPlanejamento,
                                codMeta: _codMeta,
                                detalhe: self.valueDetalhe,
                                filter: filtros,
                                periodo: self.codPeriodo,
                                codEmp: self.codEmp,
                                modoCenario: self.modoCenario,
                                mes:  self.mes != undefined ? self.mes : null
                            }
                        }).then(function (response) {
                            if (!_ignorarAlertaAlteracao) {
                                var nomes = ObjectUtils.getProperty(response, 'responseBody.usuarioalterandoplanejamento.nomes');
                                var qtd = ObjectUtils.getProperty(response, 'responseBody.usuarioalterandoplanejamento.qtd');

                                if (angular.isDefined(qtd)) {
                                    var chave = qtd > 1 ? 'usuariosalterandometa' : 'usuarioalterandometa';
                                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.' + chave, [nomes]));
                                }
                            }
                            
                            
                            _rows = [];
                            disableTimeout();
                            resolve();
                        });

                    } else {
                        _rows = [];
                        disableTimeout();
                        resolve();
                    }
                });
            }

            function setVisibleField(campo, enable) {
                var column = [campo + 'TOTAL'];
                for (var i = 1; i < 32; i++) {
                    column.push(campo + i);
                }
                self.gridOptions.columnApi.setColumnsVisible(column, enable);
                self.gridOptionsTotal.columnApi.setColumnsVisible(column, enable);
            }

            function setColumnPinned(position) {
                _isPinned = position;
                self.gridOptions.columnApi.setColumnsPinned([PREVISTOTOTAL, PREVISTOOFICIALTOTAL, REALIZADOTOTAL, DIFERENCATOTAL], position);
            }

            function reinicializarDados() {
                _entityListCtrls = {};
                _entityListLastValues = {};
                self.entityList = {};
                self.valuesCombobox = {};
                _rows = [];
                self.optionsEntidades = [];
                self.isDisableBtn = true;
                self.filterEntity = [];
            }

            function carregarPlanejamento(emiteMsg) {
                try {
                    carregarArvoreFiltro();
                    var optionsSearch = ArrayUtils.toArray(self.filterEntity);
                    for (var i = 0; i < optionsSearch.length; i++) {
                        if (ArrayUtils.toArray(self.entityList[optionsSearch[i].field]).length == 0) {
                            throw i18n('Commons.PlanejamentoMetaOrcamento.campoobrigatorio');
                        }
                    }

                    var optionsCombobox = ArrayUtils.toArray(self.comboboxOptions);
                    for (var i = 0; i < optionsCombobox.length; i++) {
                        if (angular.isUndefined(self.valuesCombobox[optionsCombobox[i].entity])) {
                            throw i18n('Commons.PlanejamentoMetaOrcamento.campoobrigatorio');
                        }
                    }

                    if (self.bloquearEmpresaDetalhe && self.codEmp == undefined) {
                        throw i18n('Commons.PlanejamentoMetaOrcamento.empresaObrigatoria');
                    }

                    if (self.porPeriodo && self.codPeriodo == undefined) {
                        throw i18n('Commons.PlanejamentoMetaOrcamento.periodoObrigatorio');
                    }

                    if (self.tipoMeta === 'R') {
                        self.exibeRecDesp = i18n('Commons.PlanejamentoMetaOrcamento.receita');
                    } else {
                        self.exibeRecDesp = i18n('Commons.PlanejamentoMetaOrcamento.despesa');
                    }

                } catch (error) {
                    if (emiteMsg) {
                        MessageUtils.showError(error);
                    }
                    return;
                }

                self.showFilter = false;

                // Limpa a grade
                self.gridOptions.api.setRowData();
                self.gridOptionsTotal.api.setRowData();

                _anoSelecionado = self.anoPlanejamento;
                if(self.mostraMes && !self.modoCenario){
                    atualizarColumnsDefs();
                }

                if (self.modoCenario) {
                    carregar();
                } else {
                    saveState();
                    saveConfigDataSource().then(carregar);
                }
            }


            function carregar() {
                var filtros = getFiltros();

                var params = {
                    param: {
                        filter: filtros,
                        codMeta: _codMeta,
                        ano: self.anoPlanejamento,
                        recDesp: self.tipoMeta,
                        detalhe: self.valueDetalhe,
                        periodo: self.codPeriodo,
                        codEmp: self.codEmp,
                        cenarios: _cenarios,
                        mes: self.mesSelecionado != undefined ? self.mesSelecionado : null
                    }
                };

                if (angular.isDefined(_filter)) {
                    _filter.getCriteria().then(function (criteria) {
                        var _expression = criteria.getExpression();
                        if (_expression) {
                            params.param.expression = _expression;
                        }
                    });
                }

                ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.carregarPlanejamento', params)
                    .then(function (response) {
                        _dados = ArrayUtils.toArray(ObjectUtils.getProperty(response, 'responseBody.dados'));
                        _referencia = ObjectUtils.getProperty(response, 'responseBody.referencia');
                        _diasMes = ObjectUtils.getProperty(response, 'responseBody.diasMes');

                        if(response && response.responseBody && response.responseBody.realizado && response.responseBody.realizado[0].isRealizado.trim() == 'false'){
                            MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.avisoRealizadoDesatualizado'));
                        } 

                        _mapDados = {};
                        _mapDadosFilhos = {};
                        _dados.forEach(function (e) {
                            if (angular.isUndefined(_mapDadosFilhos[e.pkPai])) {
                                _mapDadosFilhos[e.pkPai] = [];
                            }

                            if (podeModificarCampo(e) && e.recDesp == 'D' && _calculoDesvioInverso == 'N' && 'S' != _usaSaldoContasColRealizado) {
                                for (var i = 1; i <= _qtdPeriodo; i++) {
                                    _camposCalculado.forEach(function (name) {
                                        if (e[name + i] > 0) {
                                            e[name + i] *= -1;
                                        }
                                    });
                                }
                            }
                            _mapDadosFilhos[e.pkPai].push(e);
                            _mapDados[e.pk] = e;
                        });

                        _mapTotalizador = {};
                        _totalizador.forEach(function (e) {
                            _mapTotalizador[e.pk] = e;
                        });

                        _isUpdateConfig = false;

                        var i = _qtdPeriodo;
                        while (i) {
                            _camposCalculado.forEach(function (name) {
                                updateTotalGrid(name + i);
                            });
                            i--;
                        }

                        self.gridOptions.api.setRowData(_dados);
                        self.gridOptionsTotal.api.setRowData(_totalizador);

                        self.isDisableBtn = false;

                        _isUpdateConfig = true;
                    });
            }

            function getFiltros() {
                var filtros = {};

                if (self.valuesCombobox) {
                    ArrayUtils.toArray(Object.keys(self.valuesCombobox)).forEach(
                        function (e) {
                            filtros[e] = self.valuesCombobox[e];
                        });
                }

                if (self.entityList) {
                    Object.keys(self.entityList).forEach(function (e) {
                        var entidade = self.entityList[e][0];
                        if (angular.isDefined(entidade)) {
                            filtros[e] = entidade.data;
                        }
                    });
                }

                return filtros;
            }

            function mostrarEsconder() {
                self.showFilter = !self.showFilter;
            }

            function gerarMetas() {
            	self.gridOptions.api.stopEditing();

                $timeout(function () {
                
                	saveConfigDataSource()
                    	.then(function () {// Efetuando o salvamento antes de gerar a meta
                    		var filtros = getFiltros();

                    		var params = {
                    				param: {
                    					filter: filtros,
                    					codMeta: _codMeta,
                    					ano: self.anoPlanejamento,
                    					recDesp: self.tipoMeta,
                    					detalhe: self.valueDetalhe,
                    					periodo: self.codPeriodo,
                                        codEmp: self.codEmp,
                                        mes: self.mesSelecionado != undefined ? self.mesSelecionado : null
                    				}
                    		};

                    		ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.gerarMetas', params)
                            	.then(function (response) {
                            		var status = ObjectUtils.getProperty(response, 'responseBody.status');
                            		if (status == 'E') {
                            			var msgErro = ObjectUtils.getProperty(response, 'responseBody.msgErro');
                            			MessageUtils.showError(i18n('Commons.PlanejamentoMetaOrcamento.erroSalve', [msgErro]));
                            		} else {
                            			var msg;
                            			if (status == 'S') {
											if(StringUtils.isNotEmpty(_anoAterior) && !_anoAterior.hasOwnProperty(self.anoPlanejamento)){
												_anoAterior = { ..._anoAterior, [self.anoPlanejamento] : NumberUtils.stringToNumber(self.anoPlanejamento) }
											}
                            				msg = angular.copy(_messageSave);
                            				carregarPlanejamento();
                            			} else {
                            				msg = i18n('Commons.PlanejamentoMetaOrcamento.semAlteracoes');
                            			}
                            			MessageUtils.showInfo(msg);
                            		}
                            	});
                    	});
                }, 100);
            }

            function onCellFocused(column) {
                self.rowsPsList = [];
                if (self.entityBtnAction) {
                    var focusCell = column.api.getFocusedCell();
                    if (focusCell) {
                        var RowNode = column.api.getDisplayedRowAtIndex(focusCell.rowIndex);
                        if (RowNode) {
                            var data = angular.copy(RowNode.data);

                            if (data.pk == "-999999999") {
                                return;
                            }

                            var filtros = getFiltros();
                            if (_fieldCustom) {
                                Object.keys(_fieldCustom).forEach(function (key) {
                                    var pkFieldName = _fieldCustom[key].pkFieldName;
                                    var value = parserValue(filtros[key], _fieldCustom[key].pkType);
                                    data[pkFieldName] = value;
                                });

                                var campoDetalhe = _fieldCustom[self.valueDetalhe];
                                data[campoDetalhe.pkFieldName] = parserValue(data['pk'], campoDetalhe.pkType);
                            } else {
                                data[self.valueDetalhe] = data['pk'];

                                Object.keys(filtros).forEach(function (key) {
                                    data[key] = filtros[key];
                                });
                            }

                            data['CODMETA'] = _codMeta;

                            delete data.analitico;
                            delete data.path;
                            delete data.recDesp;
                            delete data.pkPai;
                            delete data.pk;
                            delete data.descricao;

                            self.rowsPsList.push(data);
                        }
                    }
                }
            }

            function parserValue(value, type) {
                switch (type) {
                    case 'I':
                    case 'N':
                        value = NumberUtils.getNumberOrZero(value);
                        break;
                    case 'D':
                    case 'H':
                        value = DateUtils.stringToDate(value);
                        break;
                    default:
                        value = StringUtils.undefinedAsEmpty(value);
                        break;
                }

                return value;
            }

            function updateCampoDetalhe() {
                limparRowdata();
                buscaConfiguracoes({
                    codMeta: _codMeta,
                    descrMeta: _nomeMeta,
                    usaSaldoContasColRealizado: _usaSaldoContasColRealizado
                });
            }

            function buscaConfiguracoes(meta, changeMeta) {
                var deferred = $q.defer();

                if (changeMeta) {
                    self.valueDetalhe = undefined;
                    self.optionsEntidades = undefined;
                    self.mesSelecionado = undefined;
                    self.mes = undefined;

                    // desabilitando o modo cenário
                    self.modoCenario = false; 
                    _cenarios = undefined;
                    _camposCalculado = [PREVISTOOFICIAL, REALIZADO, PREVISTO];
                }
                verificarPeriodo(meta.codMeta);


                loadState().then(function () {
                    _codMeta = meta.codMeta;
                    _nomeMeta = meta.descrMeta;
                    _usaSaldoContasColRealizado = meta.usaSaldoContasColRealizado;

                    self.descrMeta = _codMeta + " - " + _nomeMeta

                    var configMetas = ArrayUtils.toArray(_configTela.metas);
                    var configMeta = undefined;
                    for (var i = 0; i < configMetas.length; i++) {
                        if (configMetas[i].codMeta == _codMeta) {
                            configMeta = configMetas[i];

                            if (angular.isUndefined(self.valueDetalhe)) {
                                self.valueDetalhe = configMeta.detalhe;
                            }
                            if (angular.isUndefined(self.optionsEntidades)) {
                                self.optionsEntidades = ArrayUtils.toArray(configMeta.optionsEntidades);
                            }

                            if (!ehDetalheComReceitaEDespesa()) {
                                self.tipoMeta = 'R';
                                recDesp = self.tipoMeta;
                                if (configMeta.filtros.tipoMeta) {
                                    self.tipoMeta = configMeta.filtros.tipoMeta
                                }
                            }
                            break;
                        }
                    }

                    var params = {
                        param: {
                            codMeta: _codMeta,
                            detalhe: self.valueDetalhe,
                            listaCampos: self.optionsEntidades,
                            mes: self.mesSelecionado,
                            ano: changeMeta == undefined ? self.anoPlanejamento :_anoAtual
                        }
                    }

                    if (self.porPeriodo) {
                        params.param.codPeriodo = self.codPeriodo;
                    }

                    ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.carregarConfiguracoesTela', params)
                        .then(function (result) {
                            carregarConfiguracoesTela(result, configMeta, deferred);
                        });
                });

                return deferred.promise;
            }

            function carregarConfiguracoesTela(result, configMeta, deferred) {
                reinicializarDados();

                _qtdPeriodo = ObjectUtils.getProperty(result, 'responseBody.configuracoes.quantidadePeriodos');

                _periocidade = ObjectUtils.getProperty(result, 'responseBody.configuracoes.periocidade');

                _calculoDesvioInverso = ObjectUtils.getProperty(result, 'responseBody.configuracoes.calculoDesvioInverso');

                _validaPrevisto = StringUtils.toBoolean(ObjectUtils.getProperty(result, 'responseBody.configuracoes.otherOption.validaPrevisto'));
                self.intervalounico = ObjectUtils.getProperty(result, 'responseBody.configuracoes.otherOption.intervalounico');
                if (self.intervalounico) {
                    self.anoPlanejamento = DateUtils.stringToDate(self.intervalounico).getFullYear();
                }
                
                self.isDiaria = StringUtils.toBoolean(ObjectUtils.getProperty(result, 'responseBody.configuracoes.isDiaria'));
                
                
                self.exigeaprovacao = StringUtils.toBoolean(ObjectUtils.getProperty(result, 'responseBody.configuracoes.otherOption.exigeaprovacao'));
                if (self.exigeaprovacao) {
                    self.lblBtnConfirmar = i18n('Commons.PlanejamentoMetaOrcamento.solicitaraprovacao');
                    _messageSave = i18n('Commons.PlanejamentoMetaOrcamento.solicitacaoEnviada');
                } else {
                    self.lblBtnConfirmar = i18n('Commons.PlanejamentoMetaOrcamento.confirmarplanejamento');
                    _messageSave = i18n('Commons.PlanejamentoMetaOrcamento.sucessoSalve');
                }

                _anoAterior = ObjectUtils.getEmptyAsUndefined(ObjectUtils.getProperty(result, 'responseBody.anoAterior'));

                var arrayAnos = {};
                if (_anoAterior != undefined) {
                    arrayAnos = angular.copy(_anoAterior);
                }

                for (var i = 0; i <= 10; i++) {//10 Anos a frente do corrente
                    arrayAnos[_anoAtual + i] = _anoAtual + i;
                }

                self.optionsAno = [];
                Object.keys(arrayAnos)
                    .forEach(function (e) {
                        self.optionsAno.push({ data: e, value: e });
                    });

                self.anoPlanejamento = _anoAtual;

                if (angular.isUndefined(_qtdPeriodo)) {
                    throw Error('Erro interno: Periodicidade não foi informada');
                }

                _filtroEntidade = ObjectUtils.getProperty(result, 'responseBody.configuracoes.detalhe');

                self.campoDetalhe = _filtroEntidade.label;
                self.valueDetalhe = _filtroEntidade.field;
                self.entityDetalhe = _filtroEntidade.entity;

                self.resourceDetalhe = self.resourceId + '@' + self.campoDetalhe;

                self.optionsEntidades.push({ value: _filtroEntidade.label, data: _filtroEntidade.field });

                var filters = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.filtrosEntidades'));

                self.filterEntity = [];

                var temNatureza = false;
                self.helpNatureza = undefined;
                if (_filtroEntidade.field == 'NATUREZA') {
                    self.helpNatureza = i18n('Commons.PlanejamentoMetaOrcamento.helpNatureza');
                    temNatureza = true;
                }

                filters.forEach(function (e) {
                    if (!self.bloquearEmpresaDetalhe || e.entity != 'Empresa') {
                        self.filterEntity.push(e)

                        if (e.entity == 'Natureza') {
                            temNatureza = true;
                        }
                    }
                });


                updateOptionsEntidades(self.filterEntity);

                if (self.filterEntity[0]) {
                    self.openEnityList[self.filterEntity[0].entity] = true;
                }

                self.comboboxOptions = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.filtrosOpcoes'));
                updateOptionsEntidades(self.comboboxOptions);

                var totalFields = ObjectUtils.getProperty(result, 'responseBody.totalFields');
                if (totalFields) {
                    _camposCalculado = totalFields;
                }

                self.gridOptions.columnDefs = ajusteColumnDefs(ObjectUtils.getProperty(result, 'responseBody.columnDefs'));

                angular
                    .element(document.getElementById('ag-grid'))
                    .replaceWith(AngularUtil.compile('<sk-ag-grid  sk-theme-grid="ag-theme-fresh"   id="ag-grid" sk-grid-options="ctrl.gridOptions" flex></sk-ag-grid>', $scope));

                self.gridOptionsTotal.columnDefs = ObjectUtils.getProperty(result, 'responseBody.columnDefsTotalizador');

                angular
                    .element(document.getElementById('ag-grid-total'))
                    .replaceWith(AngularUtil.compile('<sk-ag-grid  sk-theme-grid="ag-theme-fresh"   sk-height="150px" id="ag-grid-total" sk-grid-options="ctrl.gridOptionsTotal"></sk-ag-grid>', $scope));

                var elementFiltro = angular.element(document.getElementById('filtro-detalhe'))

                var tplFilter = '';
                if (self.entityDetalhe != 'MarcaProduto' || self.usaCadastroMarcas) {
                    tplFilter = '<sk-personalized-filter sk-hide-apply="false"'
                        + '     sk-entity-name="{{::ctrl.entityDetalhe}}"'
                        + '     sk-resource-id="{{:: ctrl.resourceDetalhe}} "'
                        + '     sk-standalone-mode="true"'
                        + '     sk-on-filter-created="ctrl.onFilterCreated($filter)"'
                        + '     sk-allow-variable="false">'
                        + '  </sk-personalized-filter>';
                }

                elementFiltro.replaceWith(AngularUtil.compile(
                    '<sk-hbox id="filtro-detalhe" flex>'
                    + '    <sk-simple-item sk-label="Detalhar por" sk-help-tip="{{::ctrl.helpNatureza}}" sk-class-help="metas-help-natureza">'
                    + '        <sk-hbox layout-align="space-between center" gap="5" flex>'
                    + '               <sk-combobox flex sk-value="ctrl.valueDetalhe" sk-change="ctrl.updateCampoDetalhe()" sk-options="ctrl.optionsEntidades" sk-allow-null="false"></sk-combobox>'
                    + tplFilter
                    + '       </sk-hbox>'
                    + '    </sk-simple-item>'
                    + ' </sk-hbox>', $scope));

                self.showBox = true;
                self.showFilter = false;

                if (configMeta) {
                    applyConfigAfterLoading(configMeta);
                }

                if (temNatureza && _configTela['ignoreAlertaIncicial'] != 'S') {
                    MessageUtils.showAlertOptionNotDisplay(i18n('Commons.PlanejamentoMetaOrcamento.helpNatureza'))
                        .then(function (result) {
                            _configTela['ignoreAlertaIncicial'] = result;
                            if (result) {
                                saveState();
                            }
                        });
                }

                if (deferred) {
                    deferred.resolve();
                }
            }

            function onEntityListCreated(instance, name) {
                _entityListCtrls[name] = instance;
                if (_entityListLastValues && _entityListLastValues[name]) {
                    instance.setDataProvider(_entityListLastValues[name]);
                }
            }

            function popUpSelecioneMeta(enableCancel) {
                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.selecioneumameta'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/buscaMeta/busca-meta.tpl.html',
                    controller: 'PopupBuscaMetaController as ctrl',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    showIconClose: enableCancel,
                    showBtnCancel: enableCancel,
                    showBtnOk: false,
                    keyboard: enableCancel,
                    resolve: {
                        data: {
                            configPlanejamento: self.configPlanejamento,
                            buscaConfiguracoes: buscaConfiguracoes
                        }
                    }
                });
            }

            function popUpSalvarCenario() {
                if(self.isDiaria){
                    MessageUtils.showAlert("Alerta","Função ainda não disponivel para meta ou orçamentos com periodicidade diaria.");
                    return;
                }
                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.lblSalvarCenario'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/salvar-cenario/salvar-cenario.tpl.html',
                    controller: 'SalvarCenarioController as ctrl',
                    controllerAs: 'ctrl',
                    okBtnLabel: i18n('Geral.buttonSalvar'),
                    size: 'md',
                    resolve: {
                        data: {
                            codMeta: _codMeta,
                            codUsuario: _codUsuario,
                            resourceId: self.resourceId,
                            callback: function (data) {
                                var filtros = getFiltros();

                                return ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.salvarCenario', {
                                    params: {
                                        dados: data,
                                        filter: filtros,
                                        codMeta: _codMeta,
                                        ano: self.anoPlanejamento,
                                        detalhe: self.valueDetalhe,
                                        mes : self.mesSelecionado == undefined ? 0 :self.mesSelecionado ,
                                        isSemanalOrDiaria : self.mostraMes,
                                        rows: _dados,
                                        intervalounico: self.intervalounico,
                                        qtdPeriodo: _qtdPeriodo
                                    }
                                });
                            }
                        }
                    }
                });
            }

            function popUpCenarios() {
                if(self.isDiaria){
                    MessageUtils.showAlert("Alerta","Função ainda não disponivel para meta ou orçamentos com periodicidade diaria.");
                    return;
                }
                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.lblCenarios'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/cenarios/cenarios.tpl.html',
                    controller: 'CenariosController as ctrl',
                    controllerAs: 'ctrl',
                    showBtnOk: false,
                    height: 400,
                    size: 'lg',
                    resolve: {
                        data: {
                            codMeta: _codMeta,
                            codUsuario: _codUsuario,
                            resourceId: self.resourceId,
                            mes : self.mesSelecionado,
                            ano : _anoSelecionado,
                            usaMes : self.mostraMes,
                            aplicarCenario: function (params) {
                                _cenarios = params;//Utilizado para carregar os cenários
                                return $q(function (resolve, reject) {
                                    ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.aplicarCenario', _cenarios)
                                        .then(function (result) {
                                            carregarConfiguracoesTela(result);

                                            changeOtherOptionEnabled('IMPORMETATANO', false);
                                            changeOtherOptionEnabled('SALVARCENARIO', false);
                                            changeOtherOptionEnabled('AJUSTEVALORES', false);

                                            var configMeta = ObjectUtils.getProperty(result, 'responseBody.configMeta');

                                            applyConfigMeta(configMeta);

                                            self.modoCenario = true;// Habilitando o modo cenário

                                            resolve();
                                        });
                                });
                            },
                            resgatarCenario: function (params) {
                            	_cenarios = params;
                                return $q(function (resolve, reject) {
                                    ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.resgatarCenario', params)
                                        .then(function (result) {
                                        	buscaConfiguracoes({
							                    codMeta: _codMeta,
							                    descrMeta: _nomeMeta,
							                    usaSaldoContasColRealizado: _usaSaldoContasColRealizado
							                }, false);	
                                        	
                                            changeOtherOptionEnabled('IMPORMETATANO', false);
                                            changeOtherOptionEnabled('SALVARCENARIO', false);
                                            changeOtherOptionEnabled('AJUSTEVALORES', false);

                                            var configMeta = ObjectUtils.getProperty(result, 'responseBody.configMeta');

                                            applyConfigMeta(configMeta);

                                            self.modoCenario = true;// Habilitando o modo cenário

                                            resolve();
                                        });
                                });
                            }
                        }
                    }
                });
            }

            function voltarPlanejamento() {
                changeOtherOptionEnabled('IMPORMETATANO', true);
                changeOtherOptionEnabled('SALVARCENARIO', true);
                changeOtherOptionEnabled('AJUSTEVALORES', true);

                return buscaConfiguracoes({
                    codMeta: _codMeta,
                    descrMeta: _nomeMeta,
                    usaSaldoContasColRealizado: _usaSaldoContasColRealizado
                }, true);
            }


            function popUplblAjustevalores() {
                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.lblajustevalores'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/ajuste-valores/ajuste-valores.tpl.html',
                    controller: 'AjusteValoresController as ctrl',
                    controllerAs: 'ctrl',
                    okBtnLabel: i18n('Geral.buttonAplicar'),
                    size: 'md',
                    resolve: {
                        data: {
                            periocidade: _periocidade,
                            diasMes : _diasMes
                        }
                    }
                }).result.then(function (result) {
                    var previstoArray = Object.keys(result['previsto']);// Lista de campos que precisa ser atualizado

                    ArrayUtils.toArray(Object.values(_mapDadosFilhos)).forEach(function (children) {

                        ArrayUtils.toArray(children).forEach(function (rowData) {

                            ArrayUtils.toArray(previstoArray).forEach(function (fieldPrev) {
                                //Atualiza o campos à partir do valor do nó pai
                            	if (result.previsto[fieldPrev] == 'S' && angular.isDefined(rowData[fieldPrev]) && angular.isUndefined(rowData['pkPai'])) {
                                    var valor = (result.valor / 100) * rowData[fieldPrev];
									var oldValue = rowData[fieldPrev];

									if (result.acao == 'I') {
										rowData[fieldPrev] = rowData[fieldPrev] + valor;
									} else {
										rowData[fieldPrev] = rowData[fieldPrev] - valor;
									}
									updateItems(rowData['pk'], fieldPrev, oldValue, rowData);
                                }
                            });

                        });

                    });

                    saveConfigDataSource();
                    self.gridOptions.api.refreshCells();
                });
            }

            function visuMovimentacaoPlanejamento() {
                if(ArrayUtils.isNotEmpty(self.rowsPsList)){
                    return SanPopup.open({
                        title: i18n('Commons.PlanejamentoMetaOrcamento.visMovOrcMeta'),
                        templateUrl: 'commons/planejamentoMetaOrcamento/popup/visualizar-orcamento/visualizar-orcamento.tpl.html',
                        controller: 'VisualizarOrcamentoController as ctrl',
                        controllerAs: 'ctrl',
                        showBtnNo: false,
                        showBtnCancel: false,
                        showBtnOk: false,
                        size: 'lg',
                        height: 475,     
                        resolve: {
                            data: {
                                currentRow: self.rowsPsList,
                                resourceID: self.resourceId
                            }
                        }
                    }).result;
                }else{
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.selecionarLinha'));
                }
            }

            function updateOptionsEntidades(array) {
                array.forEach(function (e) {
                    self.optionsEntidades.push({
                        value: e.label,
                        data: e.field
                    });
                });
            }

            function getDiferenca(params) {
                if (!params.data) {
                    return;
                }
                var aux = extractToNumber(params.colDef.field);
                if (angular.isUndefined(aux)) {
                    aux = 'TOTAL';
                }

                var data = params.data;
                if (angular.isUndefined(data[PREVISTO + aux])) {
                    if (angular.isUndefined(data[REALIZADO + aux])) {
                        return undefined;
                    }
                    return data[REALIZADO + aux];
                }

                if('S' == _usaSaldoContasColRealizado && angular.isDefined(data["recDesp"])){
					if((('D' === data["recDesp"] || 'S' == data["recDesp"]) && NumberUtils.getNumberOrZero(data[REALIZADO + aux]) > 0)){
						return NumberUtils.getNumberOrZero(data[PREVISTO + aux]) - NumberUtils.getNumberOrZero(data[REALIZADO + aux]);
					}else if(('R' === data["recDesp"] || 'N' == data["recDesp"])  && NumberUtils.getNumberOrZero(data[REALIZADO + aux]) < 0){
						return NumberUtils.getNumberOrZero(data[REALIZADO + aux]) - NumberUtils.getNumberOrZero(data[PREVISTO + aux]);
					}
				}

                if (self.ehTipoMetaContabil && angular.isDefined(data["recDesp"]) && ('D' === data["recDesp"] && NumberUtils.getNumberOrZero(data[REALIZADO + aux]) > 0)){
                	return NumberUtils.getNumberOrZero(data[PREVISTO + aux]) - NumberUtils.getNumberOrZero(data[REALIZADO + aux]);
                } else if (self.ehTipoMetaContabil && ((angular.isDefined(data["recDesp"]) && 'R' === data["recDesp"]) || (angular.isDefined(self.tipoMeta) && 'R' === self.tipoMeta))) {
                    return Math.abs(NumberUtils.getNumberOrZero(data[REALIZADO + aux])) - Math.abs(NumberUtils.getNumberOrZero(data[PREVISTO + aux]));
                } else {
                    return Math.abs(NumberUtils.getNumberOrZero(data[PREVISTO + aux])) - Math.abs(NumberUtils.getNumberOrZero(data[REALIZADO + aux]));
                }
            }

            function getTotal(param, field, rowData) {
                if (!param.data) {
                    return;
                }
                var value;
                for (var i = 1; i <= _qtdPeriodo; i++) {
                    if (angular.isDefined(param.data[field + i])) {
                        if (angular.isUndefined(value)) {
                            value = 0;
                        }
                        value += NumberUtils.getNumberOrZero(param.data[field + i]);
                    }
                }
                return value;
            }

            function configurarGrade() {
                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.configgrade'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/configuracaoGrid/configuracao-grid.tpl.html',
                    controller: 'ConfiguracaoGridController as ctrl',
                    controllerAs: 'ctrl',
                    grayBG: true,
                    okBtnLabel: i18n('Geral.buttonFechar'),
                    showIconClose: false,
                    showBtnCancel: false,
                    keyboard: false,
                    size: 'md',
                    height: 200,
                    resolve: {
                        data: {
                            gridOptions: self.gridOptions,
                            visibleField: setVisibleField,
                            columnPinned: setColumnPinned,
                            totalPinned: _isPinned,
                            ignorarAlertaDistribuicao: _ignorarAlertaDistribuicao,
                            ignorarAlertaAlteracao: _ignorarAlertaAlteracao,
                            isEnableAlerta: isEnableAlerta
                        }
                    }
                }).result.then(saveState);
            }

            // Criteria das entidades para pesquisa
            function getEnviromentCriteria(entity) {
                var criteria = '';
                var arr = ArrayUtils.toArray(self.filterEntity);
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].entity == entity) {

                        if (entity == 'Natureza') {
                            criteria = StringUtils.replaceAll(arr[i].criteria, '#TIPNAT#', self.tipoMeta);
                        } else {
                            criteria = arr[i].criteria;
                        }
                        break;
                    }
                }
                return Criteria(criteria);
            }

            function trocarTipoMeta() {
                if (angular.isDefined(_entityListCtrls['Natureza'])) {
                    _entityListCtrls['Natureza'].clearDataProvider(i18n('Commons.PlanejamentoMetaOrcamento.removidasFiltronat'));
                }
            }

            function collapseAll() {
                self.gridOptions.api.collapseAll();
            }

            function expandAll() {
                self.gridOptions.api.expandAll();
            }

            //Adicinando configurações na grade
            function addPropertiesGridOptions(gridOptions) {
                gridOptions.columnTypes = {
                    'typeNumber': {
                        width: 135,
                        cellEditor: 'numericCellEditor',
                        valueFormatter: function (params) {
                        	var row = params.data;
                        	var decQtd = row?.decQtd;
                        	//var decVlr = row.decVlr;
                            var value = Number(params.value);
                            
                            if (isNaN(value)) {
                                return '';
                            }

                            if (value < 0) {
                                value = Math.abs(value);
                            }
                            
                            if(!isNaN(decQtd)) {
                            	return NumberUtils.format(value, decQtd);
                            	
                            //} else if(!isNaN(decVlr)) {
	                        //    return NumberUtils.format(value, decVlr);
	                            
                            } else {
	                            return NumberUtils.format(value, 2);
                            }
                        },
                        cellStyle: function (params) {
                            var style = { 'text-align': 'right' };
                            var field = ObjectUtils.getProperty(params, 'colDef.field');
                            var value = NumberUtils.getNumberOrZero(params.value);
                            var tipoMeta = ObjectUtils.getProperty(params, 'data.recDesp');

                            if (ehDetalheComReceitaEDespesa()) {
                                style.color = value < 0 ? '#FF0000' : value > 0 ? '#0000FF' : '#000000';
                            }

                            if (_calculoDesvioInverso == 'S') {
                            	if (field && field.indexOf('REALIZADO') > -1) {
                            		_realizado = value;
                            	} else if (field && field.indexOf('DIFERENCA') > -1) {
                            		var cor = '#000000';
                            		if ((tipoMeta == 'D' ||  ('S' == _usaSaldoContasColRealizado && tipoMeta == 'S')) && _realizado > 0) {
                            			cor = '#0000FF';
                            		} else {
                                        if (value < 0) {
                                            cor = '#0000FF';
                                        } else if (value > 0) {
                                            cor = '#FF0000';
                                        }
                            		}
                            		style.color = cor;
                            	}
                             } else if(field && field.indexOf('DIFERENCA') > -1 && tipoMeta == 'S'){
								style.color = '#000000';
							} else {
	                            if (field && field.indexOf('DIFERENCA') > -1) {
	                                var cor = '#000000';
	                                if (tipoMeta == 'R' || ('S' == _usaSaldoContasColRealizado && tipoMeta == 'N')) {
	                                    if (value < 0) {
	                                        cor = '#0000FF';
	                                    } else if (value > 0) {
	                                        cor = '#FF0000';
	                                    }
	                                } else {
	                                    if (value > 0) {
	                                        cor = '#0000FF';
	                                    } else if (value < 0) {
	                                        cor = '#FF0000';
	                                    }
	                                }
	                                style.color = cor;
	                            }
                            }

                            return style;
                        }
                    }
                };

                gridOptions.defaultColDef = {//Definição padrão das colunas
                    width: 100,
                    editable: false,
                    hide: true,
                    suppressMenu: true
                };

                gridOptions.getRowNodeId = function (data) {
                    return data.field;
                };

                gridOptions.rowData = [];

                gridOptions.groupDefaultExpanded = -1;// Expandir auto nivel 1

                gridOptions.enterMovesDownAfterEdit = true;

                gridOptions.enableColResize = true; // Habilitar ajuste largura colunas

                gridOptions.treeData = true;// Habilita modo hierarquia

                gridOptions.animateRows = true; //Habilita a animação das linhas filhas ao expandir ou recolher as mesmas

                gridOptions.getDataPath = function (data) {//Função de construção da Árvore
                    return data.path.split('&!&');
                };

                gridOptions.suppressMovableColumns = true;//Desabilita mover colunas

                gridOptions.enableRangeSelection = true; //Habilita a selecao de celulas
                
                gridOptions.enableFillHandle = true; //Habilita a copia dos valores nas celulas
                
                gridOptions.suppressClearOnFillReduction = true;

                gridOptions.enableCellChangeFlash = true; //Habilita efeito de flash nas telas que sao utilizadas

                // Definição do grupo da grid
                if (angular.isUndefined(gridOptions.autoGroupColumnDef.width)) {
                    gridOptions.autoGroupColumnDef.width = 200;
                }

                gridOptions.autoGroupColumnDef.pinned = 'left';
                gridOptions.autoGroupColumnDef.suppressMenu = true;
                gridOptions.autoGroupColumnDef.cellRendererParams = {
                    suppressMenu: true,
                    suppressCount: true
                };

                gridOptions.autoGroupColumnDef.cellStyle = function (params) {
                    var style = {};
                    if (podeModificarCampo(params.data)) {
                        style.color = params.data.recDesp == 'D' ? 'red' : 'blue';
                    }
                    return style;
                };

                gridOptions.components = {
                    numericCellEditor: NumericCellEditor
                };

                gridOptions.suppressPropertyNamesCheck = true;
                gridOptions.toolPanelSuppressSideButtons = true;

                gridOptions.getRowStyle = function (params) {
                    if (params.node.rowIndex % 2 != 0) {
                        return { background: '#F7F7F7' }
                    }
                };
            }

            var searchInput = document.getElementById("search-input");

            searchInput.addEventListener("keydown", function (event) {

                if (event.keyCode !== _keymap.TAB) return;

                event.preventDefault();

                self.gridOptions.api.ensureIndexVisible(0);

                var firstCol = self.gridOptions.columnApi.getAllDisplayedColumns()[0];

                self.gridOptions.api.ensureColumnVisible(firstCol);

                self.gridOptions.api.setFocusedCell(0, firstCol);

            }, true);



            // INICIO componente campo input númerico
            function NumericCellEditor() { }

            NumericCellEditor.prototype.init = function (params) {
                $scope.actualValue = params.charPress || params.value;
                $scope.data = params.node.data;

                var classe = '';
                if (ehDetalheComReceitaEDespesa()) {
                    if ($scope.data.recDesp == 'D') {
                        classe = 'has-negative';
                    } else if ($scope.data.recDesp == 'R') {
                        classe = 'has-positive';
                    }

                    if ($scope.actualValue < 0) {
                        $scope.actualValue *= -1;
                    }
                }
                
                var ignoreSelect = params.keyPress != _keymap.BACKSPACE;

                var tpl = '<form name="inputForm" class="datagrid-compact-mode">'
                    + '      <sk-number-input sk-precision="2"'
                    + '                       sk-datagrid-editor="true"'
                    + '                       sk-append-to-body="true"'
                    + '                       sk-ignored-select-format="'+ignoreSelect+'"'
                    + '                       sk-align="right"'
                    + '                       sk-value="actualValue"'
                    + '                       sk-size="21"'
                    + '                       class="' + classe + '">'
                    + '     </sk-number-input>'
                    + '</form>';

                this.editor = AngularUtil.compile(tpl, $scope);
            };

            NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
                return event.keyCode === 39 || event.keyCode === 37;
            };

            NumericCellEditor.prototype.getGui = function () {
                return this.editor[0];
            };

            NumericCellEditor.prototype.afterGuiAttached = function () {
                this.editor[0].focus();
            };

            NumericCellEditor.prototype.isCancelBeforeStart = function () {
                return this.cancelBeforeStart;
            };

            NumericCellEditor.prototype.getValue = function () {
            	if (_bloqueiaEntradaNumerosNegativos && $scope.actualValue && $scope.actualValue < 0) {
            		MessageUtils.showAlert("Alerta", "Não é permitido a inserção de valores negativos.");
            		this.editor.remove();
            		return;
            	}
                if (ehDetalheComReceitaEDespesa() && $scope.data.recDesp == 'D' && $scope.actualValue > 0 && _calculoDesvioInverso == 'N') {
                    $scope.actualValue *= -1;
                }
                return $scope.actualValue;
            };

            NumericCellEditor.prototype.destroy = function () {
                this.editor.remove();
            };

            // FIM componente campo input númerico


            // INICIO componente Heard custom
            function CustomHeaderGroup() {
            }

            CustomHeaderGroup.prototype.init = function (params) {
                this.params = params;
                this.eGui = AngularUtil.compile('' +
                    '<div class="ag-header-group-planejamento"><div layout="row" layout-align="space-between center">'
                    + '     <span style="padding-left: 13px; font-weight: bold;">' + this.params.displayName + '</span>'
                    + '     <div style="padding-right: 5px;">'
                    + '          <button ng-click="ctrl.expandAll()" default sk-i18n tooltip="DataGrid.expandAll"'
                    + '               tooltip-placement="bottom" small>'
                    + '              <sk-icon svg-src="/mge/assets/svg/expand_all.svg"></sk-icon>'
                    + '          </button>'
                    + '          <button ng-click="ctrl.collapseAll()" default sk-i18n tooltip="DataGrid.collapseAll"'
                    + '               tooltip-placement="bottom" small>'
                    + '              <sk-icon svg-src="/mge/assets/svg/collapse_all.svg"></sk-icon>'
                    + '          </button>'
                    + '     </div>'
                    + '</div></div>', $scope)[0];
            };

            CustomHeaderGroup.prototype.getGui = function () {
                return this.eGui;
            };

            // INICIO componente Heard custom
            function CustomHeaderTotalizador() {
            }

            CustomHeaderTotalizador.prototype.init = function (params) {
                this.params = params;
                this.eGui = document.createElement('div');
                this.eGui.className = 'ag-header-group-totalizador';
                this.eGui.innerHTML = '' +
                    '<div layout="row" layout-align="center center">'
                    + '   <span style="font-weight: bold;">' + this.params.displayName + '</span>'
                    + '</div>';
            };

            CustomHeaderTotalizador.prototype.getGui = function () {
                return this.eGui;
            };

            function atualizarGridPorPeriodo() {
                ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.carregarConfigColumns', {
                    param: {
                        codMeta: _codMeta,
                        codPeriodo: self.codPeriodo,
                        codEmp: self.codEmp,
                        detalhe: self.valueDetalhe
                    }
                }).then(function (result) {
                    self.gridOptions.columnDefs = ajusteColumnDefs(ObjectUtils.getProperty(result, 'responseBody.columnDefs'));

                    _qtdPeriodo = ObjectUtils.getProperty(result, 'responseBody.configuracoes.quantidadePeriodos');

                    angular
                        .element(document.getElementById('ag-grid'))
                        .replaceWith(AngularUtil.compile('<sk-ag-grid sk-theme-grid="ag-theme-fresh" id="ag-grid" sk-grid-options="ctrl.gridOptions" flex></sk-ag-grid>', $scope));

                    self.gridOptionsTotal.columnDefs = ObjectUtils.getProperty(result, 'responseBody.columnDefsTotalizador');

                    angular
                        .element(document.getElementById('ag-grid-total'))
                        .replaceWith(AngularUtil.compile('<sk-ag-grid sk-theme-grid="ag-theme-fresh" sk-height="150px" id="ag-grid-total" sk-grid-options="ctrl.gridOptionsTotal"></sk-ag-grid>', $scope));

                    setVisibleField(DIFERENCA, _configTela.diferenca === 'S');
                    setVisibleField(REALIZADO, _configTela.realizado === 'S');
                    setVisibleField(PREVISTOOFICIAL, _configTela.previstoOficial === 'S');

                });
            }

            function ajusteColumnDefs(colDefs) {
                var columnsDefs = angular.copy(ArrayUtils.toArray(colDefs));

                for (var i = 0; i < columnsDefs.length; i++) {
                    var diferenca = columnsDefs[i].children.filter(function (e) {
                        return e.field != undefined && e.field.indexOf(DIFERENCA) > -1;
                    })[0];

                    if (diferenca) {
                        diferenca.valueGetter = function (param) { return getDiferenca(param); };
                    }
                }

                var total = columnsDefs.filter(function (e) { return e.field == 'TOTAL'; })[0];
                if (total) {// Adicionando a função para calculo total grade
                    total = ArrayUtils.toArray(total.children);
                    var prev = total.filter(function (e) { return e.field == PREVISTOTOTAL; })[0];
                    if (prev) {
                        prev.valueGetter = function (param) { return getTotal(param, PREVISTO, prev); };
                    }

                    var atual = total.filter(function (e) { return e.field == PREVISTOOFICIALTOTAL; })[0];
                    if (atual) {
                        atual.valueGetter = function (param) { return getTotal(param, PREVISTOOFICIAL, atual); };
                    }

                    var real = total.filter(function (e) { return e.field == REALIZADOTOTAL; })[0];
                    if (real) {
                        real.valueGetter = function (param) { return getTotal(param, REALIZADO, real); };
                    }

                    var dif = total.filter(function (e) { return e.field == DIFERENCATOTAL; })[0];
                    if (dif) {
                        dif.valueGetter = function (param) {
                        	var totalPrevisto;
                        	var totalRealizado;
                        	
                        	if ('S' == _usaSaldoContasColRealizado && param.data.recDesp == "S") {
                                totalPrevisto = NumberUtils.getNumberOrZero(getTotal(param, PREVISTO, dif));
                                totalRealizado = NumberUtils.getNumberOrZero(getTotal(param, REALIZADO, dif));
                        	} else {
                                totalPrevisto = Math.abs(NumberUtils.getNumberOrZero(getTotal(param, PREVISTO, dif)));
                                totalRealizado = Math.abs(NumberUtils.getNumberOrZero(getTotal(param, REALIZADO, dif)));
                        	}
                        	
                            if (totalPrevisto == 0 && totalRealizado == 0) {
                                return undefined;
                            }
                            if('S' != _usaSaldoContasColRealizado){
                                return totalPrevisto - totalRealizado;
                            }else{
                                return param.data.recDesp == "D" || param.data.recDesp == "S" ? totalPrevisto - totalRealizado : totalRealizado - totalPrevisto;
                            }
                        };
                    }
                }

                return columnsDefs;
            }

            function getCriteriaPeriodo() {
                return Criteria('this.CODEMP = ' + self.codEmp);
            }

            function getCriteriaEmpresa() {
                var projetoParticipa = false;
                var crParticipa = false;
                var criteria = '';

                var arr = ArrayUtils.toArray(self.filterEntity);
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].entity === 'Projeto') {
                        projetoParticipa = true;
                    }
                    if (arr[i].entity === 'CentroResultado') {
                        crParticipa = true;
                    }
                }

                if (self.entityDetalhe === 'Projeto') {
                    projetoParticipa = true;
                }

                if (self.entityDetalhe === 'CentroResultado') {
                    crParticipa = true;
                }

                if (projetoParticipa && crParticipa) {
                    criteria = 'this.UTILPROJ = \'S\' AND this.UTILCENCUS = \'S\'';
                } else if (projetoParticipa) {
                    criteria = 'this.UTILPROJ = \'S\'';
                } else if (crParticipa) {
                    criteria = 'this.UTILCENCUS = \'S\'';
                }

                return Criteria(criteria);
            }

            function onChangePeriodo(value) {
                if (self.codPeriodo) {
                    atualizarGridPorPeriodo();
                }
            }

            function onChangeEmpresa(value) {
                self.codPeriodo = undefined;
            }

            function carregarArvoreFiltro(configMeta) {
                if (self.filterEntity) {
                    var temElementos = self.arvoreFiltro.length > 0;

                    self.filterEntity.forEach(function(item, index){
                        var filtros = _entityListCtrls[item.entity] ? _entityListCtrls[item.entity].getDataProvider() : configMeta.filtros.dataProvider[item.entity];
                        filtros = ArrayUtils.toArray(filtros);

                        if(!temElementos) {
                            var filtro = {
                                entity: item.entity,
                                label: item.label,
                                value: undefined
                            }
                            filtros.forEach(function(f){
                                if (f.checked === "S") {
                                    filtro.value = f.value;
                                }
                            });
                            self.arvoreFiltro.push(filtro);
                            
                        } else {
                            filtros.forEach(function(f, i){
                                if (f.selected === true) {
                                    self.arvoreFiltro.forEach(function(a, j){
                                        if (a.entity == item.entity) {
                                            a.value = f.value;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
            
            function importaExportaPlanilha() {
                if(podeImportarExportar()) {
                    var filtros = getListaFiltros();

                    var data = {
                        codMeta   : _codMeta,
                        codUsuario: _codUsuario,
                        ano       : self.anoPlanejamento,
                        filter    : filtros
                    }

                    if (angular.isDefined(_filter)) {
                        _filter.getCriteria().then(function (criteria) {
                            var _expression = criteria.getExpression();
                            if (_expression) {
                                data.expression = _expression;
                            }
                        });
                    }

                    SanPopup.open({
                        title: i18n('Commons.PlanejamentoMetaOrcamento.selecionarPlanilha'),
                        templateUrl: 'commons/planejamentoMetaOrcamento/popup/importaExportaPlanilha/importa-planilha.tpl.html',
                        controller: 'PopupImportaPlanilhaController as ctrl',
                        controllerAs: 'ctrl',
                        showIconClose: true,
                        showBtnOk: false,
                        ehSankhyaWCancel: true,
                        ehSankhyaWOk: false,
                        keyboard: true,
                        rightBottomBar: [_btnExportar, _btnImportar],
                        height: '150',
                        resolve: {
                            data: data,
                            btnImportar: function () {
                                return _btnImportar;
                            },
                            btnExportar: function () {
                                return _btnExportar;
                            },
                        }
                    }).result.then(
                        function(responseBody) {
                            if(responseBody && responseBody.dados) {
                                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, i18n("Commons.PlanejamentoMetaOrcamento.desejaSobrescreverComImportacao")).then(
                                    function (sim) {
                                        var param = {
                                            codMeta      : _codMeta,
                                            ano          : self.anoPlanejamento,
                                            codEstrImport: responseBody.codEstrImport,
                                            dados        : responseBody.dados
                                        }
        
                                        if (angular.isDefined(_filter)) {
                                            _filter.getCriteria().then(function (criteria) {
                                                var _expression = criteria.getExpression();
                                                if (_expression) {
                                                    param.expression = _expression;
                                                }
                                            });
                                        }
                            
                                        ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.incluirDadosImportacaoPlanilhaOrcamentaria', param)
                                        .then(
                                            function (response) {
                                                carregar();
                                            },
                                            function (error) {
                                                MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.erroInclusaoDadosImportacao"));
                                                return false;
                                            }
                                        );
                                    }
                                );
                            } else {
                                MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.erroInclusaoDadosImportacao"));
                                return false;
                            }
                        },
                        function(msg) {
                            carregar();
                        }
                    );
                }
            }
            
            function getListaFiltros() {
                var filtros = {};

                Object.keys(_entityListCtrls).forEach(function (e) {
                    filtros[e] = _entityListCtrls[e].getDataProvider();
                });

                return filtros;
            }

            function podeImportarExportar() {
                if(!angular.isDefined(_codMeta)) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.codMetaNaoEncontrado"));
                    return false;
                }

                if(!angular.isDefined(_codUsuario)) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.codUsuarioNaoEncontrado"));
                    return false;
                }

                return true;
            }

            function selecionaMes(){
                disableTimeout();
                carregarPlanejamento(true);
                self.mes = self.mesSelecionado;
            }

            function verificarPeriodo(_codMeta) {

                var params = {
                    param: {
                        meta: _codMeta
                    }
                };
                ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.isSemanalOrDiaria', params)
                    .then(function (response) {
                        self.mostraMes = "true" == response.responseBody.isSemanalOrDiaria;
                    });
            }

            function atualizarColumnsDefs() {

                var params = {
                    param: {
                        codMeta: _codMeta,
                        mes: self.mesSelecionado,
                        ano: self.anoPlanejamento
                    }
                };

                ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.atualizaColumnsDefs', params)
                    .then(function (result) {
                        self.gridOptions.columnDefs = ajusteColumnDefs(ObjectUtils.getProperty(result, 'responseBody.columnDefs'));

                        angular
                            .element(document.getElementById('ag-grid'))
                            .replaceWith(AngularUtil.compile('<sk-ag-grid  sk-theme-grid="ag-theme-fresh"   id="ag-grid" sk-grid-options="ctrl.gridOptions" flex></sk-ag-grid>', $scope));

                        self.gridOptionsTotal.columnDefs = ObjectUtils.getProperty(result, 'responseBody.columnDefsTotalizador');

                        angular
                            .element(document.getElementById('ag-grid-total'))
                            .replaceWith(AngularUtil.compile('<sk-ag-grid  sk-theme-grid="ag-theme-fresh"   sk-height="150px" id="ag-grid-total" sk-grid-options="ctrl.gridOptionsTotal"></sk-ag-grid>', $scope));

                            setVisibleField(DIFERENCA, _configTela.diferenca === 'S');
                            setVisibleField(REALIZADO, _configTela.realizado === 'S');
                            setVisibleField(PREVISTOOFICIAL, _configTela.previstoOficial === 'S');
                    });
            }

    }]);

/*
 *  Createad by Leonardo Mendes on 07/01/2019.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('AjusteValoresController', ['i18n', 'data', '$scope', '$popupInstance','NumberUtils', 'MessageUtils','ArrayUtils',
        function (i18n, data, $scope, $popupInstance, NumberUtils, MessageUtils, ArrayUtils) {
            var self = this;

            var periocidade = data.periocidade;
            var diasMes = data.diasMes;
            const SEMANA = "SEMANA";
            const DIA = "DIA";

            self.marcarDesmarca = marcarDesmarca;
            $scope.$success = success;

            self.columns = 2;
            self.previsto = {};
            
            init();
            function init() {
                self.valueTipo = 'S';
                marcarDesmarca('S');

                self.tipoOperacoes = [
                    { data: 'I', value: i18n('Commons.PlanejamentoMetaOrcamento.lblIncrementar') },
                    { data: 'D', value: i18n('Commons.PlanejamentoMetaOrcamento.lblDecrementar') }
                ];

                self.tipo = 'I';

                switch (periocidade) {
                    case 1://MENSAL
                        self.lblPrevisto1 = i18n('Commons.PlanejamentoMetaOrcamento.janeiro');
                        self.lblPrevisto2 = i18n('Commons.PlanejamentoMetaOrcamento.fevereiro');
                        self.lblPrevisto3 = i18n('Commons.PlanejamentoMetaOrcamento.marco');
                        self.lblPrevisto4 = i18n('Commons.PlanejamentoMetaOrcamento.abril');
                        self.lblPrevisto5 = i18n('Commons.PlanejamentoMetaOrcamento.maio');
                        self.lblPrevisto6 = i18n('Commons.PlanejamentoMetaOrcamento.junho');
                        self.lblPrevisto7 = i18n('Commons.PlanejamentoMetaOrcamento.julho');
                        self.lblPrevisto8 = i18n('Commons.PlanejamentoMetaOrcamento.agosto');
                        self.lblPrevisto9 = i18n('Commons.PlanejamentoMetaOrcamento.setembro');
                        self.lblPrevisto10 = i18n('Commons.PlanejamentoMetaOrcamento.outubro');
                        self.lblPrevisto11 = i18n('Commons.PlanejamentoMetaOrcamento.novembro');
                        self.lblPrevisto12 = i18n('Commons.PlanejamentoMetaOrcamento.dezembro');
                        self.columns = 3;
                        break;
                    case 2://BIMESTRAL
                        self.lblPrevisto1 = '1º ' + i18n('Commons.PlanejamentoMetaOrcamento.bimestre');
                        self.lblPrevisto2 = '2º ' + i18n('Commons.PlanejamentoMetaOrcamento.bimestre');
                        self.lblPrevisto3 = '3º ' + i18n('Commons.PlanejamentoMetaOrcamento.bimestre');
                        self.lblPrevisto4 = '4º ' + i18n('Commons.PlanejamentoMetaOrcamento.bimestre');
                        self.lblPrevisto5 = '5º ' + i18n('Commons.PlanejamentoMetaOrcamento.bimestre');
                        self.lblPrevisto6 = '6º ' + i18n('Commons.PlanejamentoMetaOrcamento.bimestre');
                        break;
                    case 3://TRIMESTRAL
                        self.lblPrevisto1 = '1º ' + i18n('Commons.PlanejamentoMetaOrcamento.trimestre');
                        self.lblPrevisto2 = '2º ' + i18n('Commons.PlanejamentoMetaOrcamento.trimestre');
                        self.lblPrevisto3 = '3º ' + i18n('Commons.PlanejamentoMetaOrcamento.trimestre');
                        self.lblPrevisto4 = '4º ' + i18n('Commons.PlanejamentoMetaOrcamento.trimestre');
                        break;
                    case 4://QUADRIMESTRAL
                        self.lblPrevisto1 = '1º ' + i18n('Commons.PlanejamentoMetaOrcamento.quadrimestre');
                        self.lblPrevisto2 = '2º ' + i18n('Commons.PlanejamentoMetaOrcamento.quadrimestre');
                        self.lblPrevisto3 = '3º ' + i18n('Commons.PlanejamentoMetaOrcamento.quadrimestre');
                        break;
                    case 5://SEMANAL
                        self.lblPrevisto1 = '1º ' + SEMANA;
                        self.lblPrevisto2 = '2º ' + SEMANA;
                        self.lblPrevisto3 = '3º ' + SEMANA;
                        self.lblPrevisto4 = '4º ' + SEMANA;

                        if(diasMes == 5){
                            self.lblPrevisto5 = '5º ' + SEMANA;
                        } 
                        if(diasMes == 6){
                            self.lblPrevisto5 = '5º ' + SEMANA;
                            self.lblPrevisto6 = '6º ' + SEMANA;
                        }
                        break;
                    case 6://SEMESTRAL
                        self.lblPrevisto1 = '1º ' + i18n('Commons.PlanejamentoMetaOrcamento.semestre');
                        self.lblPrevisto2 = '2º ' + i18n('Commons.PlanejamentoMetaOrcamento.semestre');
                        break;
                    case 12://ANUAL
                        self.lblPrevisto1 = i18n('Commons.PlanejamentoMetaOrcamento.ano');
                        break;
                    case 31://DIARIA
                        self.lblPrevisto1 = '1º ' + DIA;
                        self.lblPrevisto2 = '2º ' + DIA;
                        self.lblPrevisto3 = '3º ' + DIA;
                        self.lblPrevisto4 = '4º ' + DIA;
                        self.lblPrevisto5 = '5º ' + DIA;
                        self.lblPrevisto6 = '6º ' + DIA;
                        self.lblPrevisto7 = '7º ' + DIA;
                        self.lblPrevisto8 = '8º ' + DIA;
                        self.lblPrevisto9 = '9º ' + DIA;
                        self.lblPrevisto10 = '10º ' + DIA;
                        self.lblPrevisto11 = '11º ' + DIA;
                        self.lblPrevisto12 = '12º ' + DIA;
                        self.lblPrevisto13 = '13º ' + DIA;
                        self.lblPrevisto14 = '14º ' + DIA;
                        self.lblPrevisto15 = '15º ' + DIA;
                        self.lblPrevisto16 = '16º ' + DIA;
                        self.lblPrevisto17 = '17º ' + DIA;
                        self.lblPrevisto18 = '18º ' + DIA;
                        self.lblPrevisto19 = '19º ' + DIA;
                        self.lblPrevisto20 = '20º ' + DIA;
                        self.lblPrevisto21 = '21º ' + DIA;
                        self.lblPrevisto22 = '22º ' + DIA;
                        self.lblPrevisto23 = '23º ' + DIA;
                        self.lblPrevisto24 = '24º ' + DIA;
                        self.lblPrevisto25 = '25º ' + DIA;
                        self.lblPrevisto26 = '26º ' + DIA;
                        self.lblPrevisto27 = '27º ' + DIA;
                        self.lblPrevisto28 = '28º ' + DIA;

                        if(diasMes == 29){
                            self.lblPrevisto29 = '29º ' + DIA;
                        } else if(diasMes == 30){
                            self.lblPrevisto29 = '29º ' + DIA;
                            self.lblPrevisto30 = '30º ' + DIA;
                        } else {
                            self.lblPrevisto29 = '29º ' + DIA;
                            self.lblPrevisto30 = '30º ' + DIA;
                            self.lblPrevisto31 = '31º ' + DIA;
                        } 
                        break ;
                    default://INTERVALO_UNICO
                        self.lblPrevisto1 = i18n('Commons.PlanejamentoMetaOrcamento.intervalo');
                        break;
                }
            }

            function marcarDesmarca(tipo) {
                for (let i = 1; i <= 31; i++) {
                    self.previsto['PREVISTO' + i] = tipo;
                }  
            }

            function success() {
                if (NumberUtils.getNumberOrZero(self.valor) == 0) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.informevalorajuste'))
                    return;
                }

                var previstos = ArrayUtils.toArray(Object.values(self.previsto))
                    .find(function (element, index, array) {
                        return element == 'S';
                });

                if (angular.isUndefined(previstos)) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.selecionecolunas'))
                    return;
                }

                $popupInstance.success({
                    acao: self.tipo,
                    previsto: self.previsto,
                    valor: self.valor
                });
            }
        }]);
/*
 *  Createad by Leonardo Mendes on 21/03/2018.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('PopupBuscaMetaController', ['i18n', 'Criteria', 'ServiceProxy', '$popupInstance', 'data', 'MessageUtils', 'ArrayUtils',
        function (i18n, Criteria, ServiceProxy, $popupInstance, data, MessageUtils, ArrayUtils) {
            var self = this;

            self.onDatasetCreated = onDatasetCreated;
            self.iniciarPlanejamento = iniciarPlanejamento;
            self.onPesquisaMetaChanged = onPesquisaMetaChanged;
            
            self.labelButtonSearchPlanejamento = "Iniciar Planejamento"

            init();
            function init() {
                if (angular.isUndefined(data.configPlanejamento)) {
                    throw Error("sk-config-planejamento não foi informado");
                }
                self.gridConfigId = data.configPlanejamento.resourceID + '.GridMeta';
                self.entityName = data.configPlanejamento.entityName;
                self.fieldPatter = data.configPlanejamento.fieldPatter;
                self.fieldPKName = data.configPlanejamento.fieldPKName;
                self.fieldDescriptionName = data.configPlanejamento.fieldDescriptionName;
                
                if(data.labelButtonSearchPlanejamento != undefined) {
                	self.labelButtonSearchPlanejamento = data.labelButtonSearchPlanejamento
                }
            }

            function onDatasetCreated(dataset) {
                self.dsMetas = dataset;

                self.dsMetas.addCriteriaProvider(getCriteriaItens);

                self.dsMetas.init();
            }

            function onPesquisaMetaChanged(){
                if(angular.isDefined(self.dsMetas)){
                    if(angular.isDefined(self.valuePesqMeta)){
                        self.dsMetas.addCriteriaProvider(CriteriaProvider.build(getCriteriaDescricao));
                    }
                    self.dsMetas.refresh();
                }
            }

            function getCriteriaDescricao(){
                var criteria = Criteria();
                criteria.append('ignoreCase(this.CODMETA) like ignoreCase(?)', '%'.concat(self.valuePesqMeta).concat ('%'));
                criteria.or('ignoreCase(this.DESCRMETA) like ignoreCase(?)', '%'.concat(self.valuePesqMeta).concat ('%'));
                criteria.or('ignoreCase(this.TIPMETA) like ignoreCase(?)', '%'.concat(returnFinanceiroOrComercial(self.valuePesqMeta)).concat ('%'));
                return criteria;
            }

            function getCriteriaItens() {
                return Criteria(data.configPlanejamento.enviromentCriteria);
            }

            function returnFinanceiroOrComercial(value){
                var financeiro = 'Financeira';
                var comercial = 'Comercial';
                if(financeiro.indexOf(value) != -1){
                    return 'F';
                }else if(comercial.indexOf(value) != -1){
                    return 'C';
                }
            }

            function iniciarPlanejamento() {
                if (ArrayUtils.toArray(self.dsMetas.getCurrentRowAsObject()).length == 0) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.selecioneumameta'));
                } else {
                    if (angular.isFunction(data.buscaConfiguracoes)) {
                        var param = { 
                            codMeta: self.dsMetas.getFieldValueAsNumber(self.fieldPKName), 
                            descrMeta: self.dsMetas.getFieldValueAsString(self.fieldDescriptionName),
                            usaSaldoContasColRealizado: self.dsMetas.getFieldValueAsString('USASALCONREALI') 
                        };
                        
                        data.buscaConfiguracoes(param, true).then($popupInstance.success);
                    }
                }
            }
        }]);
/*
 *  Createad by Leonardo Mendes on 11/01/2019.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('CenariosController', ['GridConfig', 'StringUtils', 'i18n', 'data', '$scope', '$popupInstance', 'MessageUtils', 'Criteria', 'ObjectUtils', 'DoubleFacePanelConstants',
        function (GridConfig, StringUtils, i18n, data, $scope, $popupInstance, MessageUtils, Criteria, ObjectUtils, DoubleFacePanelConstants) {
            var self = this;

            var _options = [];
            var _camposSignificativos = [];
            var camposTGMFCT = ['CODCENCUS', 'CODCID', 'CODEMP', 'CODGER', 'CODGRUPONAT', 'CODGRUPOPROD', 'CODLOCAL', 'CODMETA', 'CODNAT', 'CODPAIS', 'CODPARC', 'CODPROD', 'CODPROJ', 'CODREG', 'CODTIPPARC', 'CODUF', 'CODUSU', 'CODVEND', 'CONTROLE', 'VENDEDOR', 'VENDITEM', 'MARCA', 'EXECUTANTE'];

            self.gridConfig = data.resourceId + '.gridConfigCenarios';

            self.onDatasetCreated = onDatasetCreated;
            self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.onDblClickGrid = onDblClickGrid;
            self.compararCenario = compararCenario;
            self.resgatarCenario = resgatarCenario;
            self.aplicarCenario = aplicarCenario;

            self.options = [];
            self.isComparar = false;
            self.lblCenarios =  i18n('Commons.PlanejamentoMetaOrcamento.lblCenarios'); 
            
            GridConfig.registerGridConfig(self.gridConfig, self.gridConfig, undefined, true);
            self.changeButtonActions = [
                {
                    label: i18n('Controls.GridConfig.buttonGridConfig'), action: function () {
                        GridConfig.openGridconfig(self.gridConfig);
                    }
                }
            ];

            function onDatasetCreated(dataset) {
                self.dsForecastMeta = dataset;

                self.dsForecastMeta.addLineChangeListener(function (line) {
                    _camposSignificativos = [];
                    camposTGMFCT.forEach(function (campo) {
                        if ((campo == 'MARCA' || campo == 'CONTROLE') && StringUtils.emptyAsUndefined(self.dsForecastMeta.getFieldValueAsString(campo)) != undefined) {
                            _camposSignificativos.push(campo);
                        } else if (self.dsForecastMeta.getFieldValueAsNumberOrZero(campo) > 0) {
                            _camposSignificativos.push(campo);
                        }
                    });

                    _options = self.dsForecastMeta.getRecordsAsObjects();
                });

                self.dsForecastMeta.addCriteriaProvider(getCriteria);
                self.dsForecastMeta.setCanInsert(false);
                self.dsForecastMeta.initAndRefresh();
            }

            function getCriteria() {
                var criteria = Criteria();
                criteria.and('this.CODUSU = ?');
                criteria.addParameter(Criteria.buildParameter('N', data.codUsuario));

                criteria.and('this.CODMETA = ?');
                criteria.addParameter(Criteria.buildParameter('N', data.codMeta));

                if (data.usaMes) {
                	var mes = data.mes == undefined ? 0 : data.mes;
                    criteria.and('this.MES = ?');
                    criteria.addParameter(Criteria.buildParameter('N', mes ));

                    criteria.and('this.ANO = ?');
                    criteria.addParameter(Criteria.buildParameter('N', data.ano));
                }

                return criteria;
            }

            function onDoubleFacePanelCreated(dblFacePanelForecastMeta) {
                self.dblFacePanelForecastMeta = dblFacePanelForecastMeta;
            }

            function aplicarCenario() {
                if (self.listCenarios.length == 0) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.selecioneCenario') + '.');
                    return;
                }
                
                var cenario = self.dsForecastMeta.getFieldValueAsNumberOrZero('CODCENARIO');
                self.listCenarios.push(cenario);
                
                data.aplicarCenario({
                    params: {
                        codCenarios: self.listCenarios,
                        codMeta: data.codMeta,
                        codUsuario: data.codUsuario,
                        mes: data.mes,
                        ano: data.ano
                    }
                }).then(function () {
                    $popupInstance.success();
                });
            }
            
            function onDblClickGrid() {
                self.dblFacePanelForecastMeta.setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
            }
            
            function resgatarCenario(){
                var _cenario = self.dsForecastMeta.getFieldValueAsNumberOrZero('CODCENARIO');
                if (_cenario == 0) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.selecioneCenario') + '.');
                    return;
                }

                data.resgatarCenario({             	
                    params: {
                        codCenarios: [_cenario],
                        codMeta: data.codMeta,
                        codUsuario: data.codUsuario,
                        mes: data.mes,
                        ano: data.ano
                    }
                }).then(function () {
                    $popupInstance.success();
                });
            }

            function compararCenario() {
                self.options = [];
                
                _options.forEach(function (row) {
                    var i = 0;
                    var isEquals = self.dsForecastMeta.getFieldValueAsString('CAMPODETALHE') == row['CAMPODETALHE'] 
                    && self.dsForecastMeta.getFieldValueAsNumberOrZero('CODCENARIO') != row['CODCENARIO'];
                    
                    do {
                        if (!isEquals) {
                            break;
                        }
                        
                        var campo = _camposSignificativos[i];
                        if (campo == 'MARCA' || campo == 'CONTROLE') {
                            isEquals = self.dsForecastMeta.getFieldValueAsString(campo) == row[_camposSignificativos[i]];
                        } else {
                            isEquals = self.dsForecastMeta.getFieldValueAsNumberOrZero(campo) == row[_camposSignificativos[i]];
                        }
                        
                        i++;
                    } while (i < _camposSignificativos.length);
                    
                    if (isEquals) {
                        self.options.push(
                            {
                                data: row['CODCENARIO'],
                                value: row['NOMECENARIO'],
                                checked: false
                            }
                            );

                        }
                    });
                    
                    if(self.options.length > 0){
                        self.isComparar = true;
                    }else{
                        MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.naoexistecenario') + '.');
                    }
                }

            }]);
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('ConfiguracaoGridController', ['data', '$scope', '$popupInstance', 'ArrayUtils', 'i18n',
        function (data, $scope, $popupInstance, ArrayUtils, i18n) {
            var self = this;

            var _gridOptions = data.gridOptions;
            var _visibleField = data.visibleField;
            var _columnPinned = data.columnPinned;
            var _isEnableAlerta = data.isEnableAlerta;

            //Constante
            const REALIZADO = 'REALIZADO';
            const DIFERENCA = 'DIFERENCA';
            const PREVISTOOFICIAL = 'PREVISTOOFICIAL';

            self.fixaresquerda = i18n('Commons.PlanejamentoMetaOrcamento.fixaresquerda');
            self.fixardireita = i18n('Commons.PlanejamentoMetaOrcamento.fixardireita');
            self.naofixar = i18n('Commons.PlanejamentoMetaOrcamento.naofixar');

            self.visibleField = visibleField;
            self.setColumnPinned = setColumnPinned;
            self.isEnableAlerta = isEnableAlerta;

            self.pinned = data.totalPinned;

            init();
            function init() {
                self.realizado = isEnable(REALIZADO);
                self.diferenca = isEnable(DIFERENCA);
                self.previstoOficial = isEnable(PREVISTOOFICIAL);
                
                self.distribuirhierarquia = data.ignorarAlertaDistribuicao;
                self.alertarAlteracao = data.ignorarAlertaAlteracao;
            }

            function isEnable(campo) {
                var field = _gridOptions.columnApi.getColumn(campo + '1');

                return field && field.visible;
            }

            function visibleField(campo, enable) {
                _visibleField(campo, enable);
            }

            function setColumnPinned(position) {
                self.pinned = position;
                _columnPinned(position);
            }

            function isEnableAlerta(name, enable) {
                _isEnableAlerta(name, enable);
            }
        }]);
/*
 *  Created by Gustavo Pomponi on 18/02/2019.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('CadastraConfiguracaoController', ['i18n', 'SkApplicationInstance', 'Criteria', 'ServiceProxy', 'data', 'ObjectUtils', 'DoubleFacePanelConstants', 'MessageUtils', 'StringUtils', '$scope', '$popupInstance', 'ArrayUtils', 'AngularUtil', '$timeout',
        function (i18n, SkApplicationInstance, Criteria, ServiceProxy, data, ObjectUtils, DoubleFacePanelConstants, MessageUtils, StringUtils, $scope, $popupInstance, ArrayUtils, AngularUtil, $timeout) {
            var self = this;

            const TIPO_ESTRUTURA_UNICA = "U";
            const TIPO_ESTRUTURA_DIMENSAO = "D";

            $scope.$success = confirm;

            ObjectUtils.implements(self, IFormInterceptor);
            self.interceptBuildField = interceptBuildField;
            self.buildFieldContainer = buildFieldContainer;

            self.gridConfigId = SkApplicationInstance.getResourceID() + ".configParameters";
            
            self.onDatasetCreated         = onDatasetCreated;
            self.addConfiguracao          = addConfiguracao;
            self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.onDblClickGrid           = onDblClickGrid;
            self.dimensaoChanged          = dimensaoChanged;

            self.recDespEnabled = true;
            
            self.dsConfiguracao;
            
            self.dimensoes                 = [];
            self.dimensoesOptions          = [];
            self.detalharPorOptions        = [];
            self.entidadesOptionsOriginais = [];
            
            var _estruturaBinder;
            var _detalheBinder;

            self.formDetalharPorProperties = [
                { 
                    fieldName       : 'DETPORSELECTED',
                    description     : i18n('Commons.PlanejamentoMetaOrcamento.labelEntidade'),
                    groupName       : i18n('Commons.PlanejamentoMetaOrcamento.labelGroupDetalharPor'),
                    type            : 'S',
                    presentationType: 'O',
                    required        : 'S',
                    fieldProp       : {
                        'sk-enabled'   : true,
                        'sk-required'  : true,
                        'sk-allow-null': false,
                        'sk-options'   : self.detalharPorOptions
                    }
                },
                {
                    fieldName       : 'DETPORCODIGO',
                    description     : i18n('Commons.PlanejamentoMetaOrcamento.labelCelCodigo'),
                    groupName       : i18n('Commons.PlanejamentoMetaOrcamento.labelGroupDetalharPor'),
                    type            : 'S',
                    presentationType: 'P',
                    required        : 'S',
                    fieldProp       : {
                        'sk-enabled' : true,
                        'sk-display-as-upper-case' : true
                    }
                }
            ];

            self.formDetalharPorValues = {
                'DETPORSELECTED': '',
                'DETPORCODIGO'  : ''
            };

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                if('DETPORSELECTED' == fieldName) {
                    fieldProp['sk-enabled'] = true;
                    fieldProp['sk-change'] = 'entidadeSelectedOnChange()';
                    scope.entidadeSelectedOnChange = detalharPorEntidadeChanged;

                } else if('DETPORCODIGO' == fieldName) {
                    fieldProp['sk-enabled'] = true;
                    fieldProp['sk-change'] = 'celulaCodigoOnChange()';
                    scope.celulaCodigoOnChange = detalharPorCelulaChanged;

                } else if('RECDESP' == fieldName) {
                    fieldProp['sk-allow-null'] = false;
                    fieldProp['sk-enabled'] = 'getRecDespEnabled()';
                    scope.getRecDespEnabled = function() {
                        return self.recDespEnabled;
                    }
                }
            }

            function buildFieldContainer(fieldName, dataset, fieldElem, scope) {
                if (dataset && dataset.getEntityName() == "ConfiguracaoEstruturaPlanilha") {
                    if('TIPOESTRUTURA' == fieldName || 'RECDESP' == fieldName) {
                        var hBoxElem = AngularUtil.createDirective('sk-hbox', {
                            'layout-align': 'start center',
                            'sk-width'    : '20%'
                        }, scope);

                        if('RECDESP' == fieldName) {
                            var helpTexto = i18n('Commons.PlanejamentoMetaOrcamento.helpTipoMeta');
    
                            var helpTipElem = AngularUtil.createDirective('sk-help-tip', {
                                'sk-help-tip' : helpTexto,
                                'sk-Placement': 'bottom',
                                'style'       : 'margin-left: 5px'
                            }, scope);
        
                            hBoxElem.append(fieldElem);
                            hBoxElem.append(helpTipElem);
        
                            return hBoxElem;
                        } else {
                            hBoxElem.append(fieldElem);
        
                            return hBoxElem;
                        }
                    }
                } else {
                    if('DETPORSELECTED' == fieldName) {
                        var hBoxElem = AngularUtil.createDirective('sk-hbox', {
                            'layout-align': 'start center',
                            'sk-width'    : '30%'
                        }, scope);
    
                        var helpTexto = i18n('Commons.PlanejamentoMetaOrcamento.helpLblDetPor');
    
                        var helpTipElem = AngularUtil.createDirective('sk-help-tip', {
                            'sk-help-tip' : helpTexto,
                            'sk-Placement': 'bottom',
                            'style'       : 'margin-left: 5px'
                        }, scope);
    
                        hBoxElem.append(fieldElem);
                        hBoxElem.append(helpTipElem);
    
                        return hBoxElem;
                        
                    } else if('DETPORCODIGO' == fieldName) {
                        var hBoxElem = AngularUtil.createDirective('sk-hbox', {
                            'layout-align': 'start center',
                            'sk-width'    : '10%'
                        }, scope);
    
                        var helpTexto = i18n('Commons.PlanejamentoMetaOrcamento.helpTipCelCodigo');
    
                        var helpTipElem = AngularUtil.createDirective('sk-help-tip', {
                            'sk-help-tip' : helpTexto,
                            'sk-Placement': 'bottom',
                            'style'       : 'margin-left: 5px'
                        }, scope);
    
                        hBoxElem.append(fieldElem);
                        hBoxElem.append(helpTipElem);
    
                        return hBoxElem;
                    }
                }
            }

            function onDatasetCreated(dataset) {
                self.dsConfiguracao = dataset;

                self.dsConfiguracao.addCriteriaProvider(getCriteria);

                self.dsConfiguracao.addAllObserverEventsListener(function (event) {
                    if (angular.equals(event, "dataset.observer.EVENT_EDITION_CANCELED") || angular.equals(event, "dataset.observer.EVENT_RECORD_REMOVED")) {
                        limparCampos();
                    }
                });

                self.dsConfiguracao.addLineChangeListener(function (newLine) {
                    if (newLine > -1) {
                        self.dimensoesOptions = reiniciarOptions();

                        enabledDisabledTipoMeta();
                    }
                });

                self.dsConfiguracao.addDataModifiedListener(function (fieldName) {
                    if ("DESCRCSP" == fieldName && !StringUtils.isEmpty(self.dsConfiguracao.getFieldValue("DESCRCSP"))) {
                        self.dsConfiguracao.setFieldValue("DESCRCSP", self.dsConfiguracao.getFieldValue("DESCRCSP"));
                    }
                });

                self.dsConfiguracao.addInsertionModeListener(function () {
                    limparCampos();

                    self.dsConfiguracao.setFieldValue("TIPOESTRUTURA", TIPO_ESTRUTURA_UNICA);
                })

                self.dsConfiguracao.beforePostAction(function () {
                    if (angular.isUndefined(self.dsConfiguracao.getFieldValue("DESCRCSP")) || angular.isUndefined(self.dsConfiguracao.getFieldValue("TIPOESTRUTURA")) || (self.recDespEnabled && angular.isUndefined(self.dsConfiguracao.getFieldValue("RECDESP")))) {
                        MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.formPrincipal"));
                        return false;
                    }

                    if(self.dsConfiguracao.getFieldValue("DESCRCSP").length < 3) {
                        MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.descricaoCurta"));
                        return false;
                    }

                    if(!isDetalheValidado()) {
                        return false;
                    }
                    
                    if(!isDimensoesValidadas()) {
                        return false;
                    }

                    self.dsConfiguracao.setFieldValue("CODMETA", data.codMeta);
                });

                self.dsConfiguracao.addRefreshedListener(function () {
                    enabledDisabledTipoMeta();
                });

                popularCombosBox();

                _detalheBinder = new FieldBinderProxy('DETALHE', self.dsConfiguracao, getDetalhe, setDetalhe);
                _estruturaBinder = new FieldBinderProxy('ESTRUTURA', self.dsConfiguracao, getEstrutura, setEstrutura);

                self.dsConfiguracao.initAndRefresh().then(
                    function() {
                        if(data.codConfig && data.codMeta) {
                            $timeout(function () {
                                selectConfig(data.codConfig, data.codMeta);
                            }, 0, false);
                        }
                    }
                );
            }

            function selectConfig(codConfig, codMeta) {
                var rowIndex = self.dsConfiguracao.getRecordsAsObjects().findIndex(
                    record => record.CODIGO === codConfig && record.CODMETA === codMeta
                );

                if(rowIndex > -1) {
                    self.dsConfiguracao.gotoRow(rowIndex);
                }
            }

            function limparCampos() {
                self.formDetalharPorValues = {
                    'DETPORSELECTED': '',
                    'DETPORCODIGO': ''
                };
                
                self.dimensoes = [];

                self.dimensoesOptions = reiniciarOptions();
                self.recDespEnabled = true;
            }

            function atualizarDimensoesDisponiveis() {
                self.dimensoes = [];

                self.dimensoesOptions.forEach(function(dimensao) {
                    self.dimensoes.push({
                        entidade: dimensao.data,
                        celCodigo: ''
                    });
                });
            }

            function popularCombosBox() {
                var params = {
                    param: {
                        codMeta: data.codMeta
                    }
                };

                ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.buscarCamposSignificativos', params)
                    .then(function (response) {
                        if(angular.isDefined(response.responseBody.campos)) {
                            response.responseBody.campos.forEach(function (fm) {
                                self.entidadesOptionsOriginais.push({ data: fm.nomeCfg, value: fm.label });
                                self.detalharPorOptions.push({ data: fm.nomeCfg, value: fm.label });
                                self.dimensoesOptions.push({ data: fm.nomeCfg, value: fm.label });
                            });
                        }
                    });
            }

            function atualizarCombosBox() {
                self.dimensoesOptions = reiniciarOptions();

                if(angular.isDefined(self.formDetalharPorValues.DETPORSELECTED)) {
                    for(var index = 0; index < self.dimensoesOptions.length; index++) {
                        if (angular.equals(self.formDetalharPorValues.DETPORSELECTED, self.dimensoesOptions[index].data)) {
                            self.dimensoesOptions.splice(index, 1);
    
                            break;
                        }
                    };
                }
            }

            function reiniciarOptions() {
                var options = [];

                if(self.entidadesOptionsOriginais && self.entidadesOptionsOriginais.length > 0) {
                    self.entidadesOptionsOriginais.forEach(function (entidade) {
                        options.push(entidade);
                    });
                }

                return options;
            }

            function dimensaoChanged() {
                _estruturaBinder.modify();

                enabledDisabledTipoMeta();
            }

            function detalharPorEntidadeChanged() {
                _detalheBinder.modify();

                atualizarCombosBox();
                atualizarDimensoesDisponiveis();

                enabledDisabledTipoMeta();
            }

            function enabledDisabledTipoMeta() {
                var temNatureza = false;

                if(angular.equals(self.formDetalharPorValues.DETPORSELECTED, "NATUREZA")) {
                    temNatureza = true;

                } else {
                    for(var index = 0; index < self.dimensoes.length; index++) {
                        if(angular.equals(self.dimensoes[index].entidade, "NATUREZA")) {
                            temNatureza = true;

                            break;
                        }
                    }
                }

                if(temNatureza) {
                    self.recDespEnabled = false;
                } else {
                    self.recDespEnabled = true;
                }
            }

            function detalharPorCelulaChanged() {
                _detalheBinder.modify();
            }

            function getCriteria() {
                var criterio = Criteria("this.CODMETA = ? ", data.codMeta);
                return criterio;
            }

            function getDetalheObj() {
                var detalhe = {
                    entidade: self.formDetalharPorValues.DETPORSELECTED,
                    celCodigo: self.formDetalharPorValues.DETPORCODIGO
                }

                return detalhe;
            }

            function getDetalhe() {
                return JSON.stringify(getDetalheObj());
            }

            function setDetalhe() {
                if (!StringUtils.isEmpty(self.dsConfiguracao.getFieldValue("DETALHE"))) {
                    var detalhe = JSON.parse(self.dsConfiguracao.getFieldValue("DETALHE"));

                    self.formDetalharPorValues.DETPORSELECTED = detalhe.entidade;
                    self.formDetalharPorValues.DETPORCODIGO = detalhe.celCodigo
                }
            }

            function getEstrutura() {
                return JSON.stringify(self.dimensoes);
            }

            function setEstrutura() {
                if (!StringUtils.isEmpty(self.dsConfiguracao.getFieldValue("ESTRUTURA"))) {
                    self.dimensoes = JSON.parse(self.dsConfiguracao.getFieldValue("ESTRUTURA"));
                }
            }

            function isDetalheValidado() {
                var detalhe = getDetalheObj();

                if(StringUtils.emptyAsNull(detalhe.entidade) == null || StringUtils.emptyAsNull(detalhe.celCodigo) == null) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.detalheObrigatorio"));
                    return false;
                }

                if(!isCampoCelulaValidada(detalhe.celCodigo, detalhe.entidade, self.detalharPorOptions)) {
                    return false;
                }

                return true;
            }

            function isCampoCelulaValidada(celula, campo, options) {
                if(!celula.match("\\$?([A-Za-z]+)\\$?([0-9]+)")) {
                    for(var index = 0; index < options.length; index++) {
                        if(campo == options[index].data) {
                            campo = options[index].value;

                            break;
                        }
                    }

                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.celulaFormatoInvalido", [campo]));
                    return false;
                }

                return true;
            }
            
            function isDimensoesValidadas() {
                if(!angular.isDefined(self.dimensoes) || (self.dimensoes.length == 0  && self.dsConfiguracao.getFieldValue("TIPOESTRUTURA") != TIPO_ESTRUTURA_UNICA)) {
	                if(self.dimensoesOptions.length == 0) {
	                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.itensEstruturaUmCampo"));
	                } else {
	                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.itensEstrutura"));
	                }
                    return false;
                }

                for(var index = 0; index < self.dimensoesOptions.length; index++) {
                    var dimensaoRepetida = 0;

                    for(var jndex = 0; jndex < self.dimensoes.length; jndex++) {
                        if(self.dimensoesOptions[index].data == self.dimensoes[jndex].entidade) {
                            dimensaoRepetida++;
                        }
                    }

                    if(dimensaoRepetida > 1) {
                        MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.dimensoesRepetidas"));
                        return false;
                    }
                }

                var detalhe = getDetalheObj();

                for(var index = 0; index < self.dimensoes.length; index++) {
                    if(StringUtils.isEmpty(self.dimensoes[index].entidade) || StringUtils.isEmpty(self.dimensoes[index].celCodigo)) {
                        MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.itensEstrutura"));
                        return false;
                    }

                    if(detalhe.entidade == self.dimensoes[index].entidade) {
                        MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.dimensaoIgualDetalhe"));
                        return false;
                    }

                    if(!isCampoCelulaValidada(self.dimensoes[index].celCodigo, self.dimensoes[index].entidade, self.dimensoesOptions)) {
                        return false;
                    }
                };

                return true;
            }

            function onDblClickGrid(dblFacePanel) {
                self[dblFacePanel.id].setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
            }

            function onDoubleFacePanelCreated(dblFacePanel) {
                if (dblFacePanel) {
                    self[dblFacePanel.id] = dblFacePanel;
                }
            }

            function addConfiguracao(dblFacePanel) {
                self[dblFacePanel.id].setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
                
                self.dsConfiguracao.goToInsertionMode();
            }

            function confirm() {
                if(self.dsConfiguracao.isInsertionMode()) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.alteracoesNaoSalvas"));
                    return false;
                }

                var selectedItens = self.dsConfiguracao.getCurrentRowAsObject();

                if(!selectedItens) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.nenhumaConfSelecionada"));
                    return false;
                }

                if(!angular.isDefined(selectedItens.CODIGO)) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.infoNaoEncontrada"), ['Código da configuração']);
                    return false;
                }

                if(!angular.isDefined(selectedItens.CODMETA)) {
                    MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.infoNaoEncontrada"), ['Código da meta']);
                    return false;
                }

                $popupInstance.success({
                    'codigo' : selectedItens.CODIGO.toString(),
                    'codmeta': selectedItens.CODMETA.toString()
                });
            }

        }]);
/*
 *  Created by Gustavo Pomponi on 15/02/2019.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('PopupImportaPlanilhaController', ['i18n', 'ServiceProxy', 'MessageUtils', 'ArrayUtils', 'ObjectUtils', 'SanPopup', 'data', 'btnImportar', 'btnExportar', 'UrlUtils', '$popupInstance', '$scope',
        function (i18n, ServiceProxy, MessageUtils, ArrayUtils, ObjectUtils, SanPopup, data, btnImportar, btnExportar, UrlUtils, $popupInstance, $scope) {
            var self = this;

            const CHAVE_ARQUIVO_EXPORT = "PlanilhaOrcamentaria_Export";
            const CHAVE_ARQUIVO_IMPORT = "PlanilhaOrcamentaria_Import";

            $scope.$dismiss = close;

            self.configSelected;

            self.configOptions = [];
            
            self.openCadastrarConfiguracao = openCadastrarConfiguracao;
            self.buscarConfiguracoes = buscarConfiguracoes;

            self.chaveImport = CHAVE_ARQUIVO_IMPORT;
            self.arquivoImport;

            var _codMeta;
            var _codUsuario;
            var _ano;
            var _filtros;
            var _expression;

            init();

            function init() {
                btnImportar.on('click', importarPlanilha);
                btnExportar.on('click', exportarPlanilha);

                if(angular.isDefined(data) ) {
                    _codMeta = data.codMeta;
                    _codUsuario = data.codUsuario;
                    _ano = data.ano;
                    _filtros = data.filter;
                    _expression = data.expression;

                    buscarConfiguracoes();
                }
            }

            function importarPlanilha() {
                if(configuracaoSelecionada()) {
                    MessageUtils.simpleConfirm(i18n('Commons.PlanejamentoMetaOrcamento.msgDesejaContinuarAcaoPlanilha', ['importar'])).then(
                        function() {
                            var params = {
                                chaveArquivo: CHAVE_ARQUIVO_IMPORT,
                                codConfig: self.configSelected,
                                codMeta: _codMeta,
                                ano: _ano
                            };
        
                            ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.importarPlanilhaOrcamentaria', params).then(
                                function(response) {
                                    limparDados();

                                    if(response.responseBody) {
                                        if(response.responseBody.msgRetorno) {
                                            MessageUtils.showAlert(response.responseBody.msgRetorno);
                                            return false;

                                        } else if(response.responseBody.notificacoes) {
                                            SanPopup.open({
                                                title: i18n('Commons.PlanejamentoMetaOrcamento.notificacoesImportacao'),
                                                templateUrl: 'commons/planejamentoMetaOrcamento/popup/importaExportaPlanilha/notificacoesImportacaoPopUp.tpl.html',
                                                controller: 'NotificacoesImportacaoPopUp',
                                                controllerAs: 'ctrl',
                                                size: 'lg',
                                                ehSankhyaWCancel: true,
                                                ehSankhyaWOk: true,
                                                okBtnLabel: 'Confirmar Importação',
                                                resolve: {
                                                    dataValue: response.responseBody
                                                }
                                            }).result.then(
                                                function () {
                                                    $popupInstance.success(response.responseBody);
                                                }
                                            );
                                        } else {
                                            $popupInstance.success(response.responseBody);
                                        }
                                    } else {
                                        MessageUtils.showAlert(i18n("Commons.PlanejamentoMetaOrcamento.dadosImportacaoNaoEncontrados"));
                                        return false;
                                    }
                                },
                                function(msg) {
                                    limparDados();

                                    return false;
                                });
                        }
                    );
                }
            }

            function exportarPlanilha() {
                if(configuracaoSelecionada()) {
                    MessageUtils.simpleConfirm(i18n('Commons.PlanejamentoMetaOrcamento.msgDesejaContinuarAcaoPlanilha', ['exportar'])).then(
                        function() {
                            var params = {
                                chaveArquivo: CHAVE_ARQUIVO_EXPORT,
                                codMeta     : _codMeta,
                                codUsuario  : _codUsuario,
                                codConfig   : self.configSelected,
                                filtros     : _filtros,
                                expression  : _expression
                            };
        
                            ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.exportarPlanilhaOrcamentaria', params).then(
                                function(response) {
                                    if (!angular.isDefined(response.responseBody.msgRetorno)) {
                                        MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.erroNaoFoiPossivelExportar'));

                                    } else {
                                        var url = UrlUtils.getUrlBase() + "/mge/visualizadorArquivos.mge?chaveArquivo=" + CHAVE_ARQUIVO_EXPORT;
                                        window.open(url, "_blank");
                                    }
                                },
                                function(error) {
                                    if(error && error.msg) {
                                        MessageUtils.showAlert(error.msg);
                                        return false;   
                                    }
                                });
                        }
                    );
                }
            }

            function configuracaoSelecionada() {
                if(!angular.isDefined(self.configSelected)) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.msgNenhumaConfPlanilhaSelecionada'));

                    return false;
                }

                return true;
            }

            function openCadastrarConfiguracao() {
                if(!isNaN(self.configSelected)) {
                    data.codConfig = Number(self.configSelected);
                }

                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.cadastraConfiguracao'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/importaExportaPlanilha/cadastra-configuracao.tpl.html',
                    controller: 'CadastraConfiguracaoController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    showIconClose: true,
                    ehSankhyaWCancel: true,
                    ehSankhyaWOk: false,
                    keyboard: true,
                    okBtnLabel: 'Selecionar',
                    resolve: {
                        data: data
                    }
                }).result.then(
                    function (result) {
                        buscarConfiguracoes(result);
                    },
                    function (cancel) {
                        buscarConfiguracoes();
                    }
                );
            }

            function buscarConfiguracoes(configSelectedByUser) {
                var param = {
                    codMeta: _codMeta
                };

                ServiceProxy.callService('mge@PlanejamentoOrcamentarioNewSP.buscarConfiguracoes', param).then(function (response) {
                    var dados = ObjectUtils.getProperty(response, 'responseBody');

                    if(angular.isDefined(dados)) {
                        var configuracoesArray = ArrayUtils.normalizeArray(dados);

                        if(angular.isDefined(configuracoesArray)) {
                            self.configOptions = [];

                            configuracoesArray.forEach(function(config) {
                                self.configOptions.push({data: config.CODIGO, value: config.DESCRCSP});
                            });

                            if(angular.isDefined(configSelectedByUser) && configSelecionadaEncontrada(configSelectedByUser)) {
                                self.configSelected = configSelectedByUser.codigo;
                            } else if(self.configOptions.length > 0) {
                                self.configSelected = self.configOptions[0].data;
                            }
                        }
                    }
                });
            }

            function configSelecionadaEncontrada(configSelected) {
                if(angular.isDefined(self.configOptions)) {
                    for(var index = 0; index < self.configOptions.length; index++) {
                        if(self.configOptions[index].data == configSelected.codigo) {
                            return true;
                        }
                    }
                }

                return false;
            }

            function close(retorno) {
                if(retorno && retorno.msgRetorno) {
                    $popupInstance.dismiss(retorno.msgRetorno)

                } else {
                    $popupInstance.dismiss()
                }
            }

            function limparDados() {
                self.arquivoImport = undefined;
            }

        }]
    );

angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('NotificacoesImportacaoPopUp', ['dataValue', 'MessageUtils', 'ObjectUtils', '$scope', '$popupInstance', 'i18n',
        function (dataValue, MessageUtils, ObjectUtils, $scope, $popupInstance, i18n) {
            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);
            self.interceptColumnMetadata = interceptColumnMetadata;

            self.onDatasetCreated = onDatasetCreated;
            self.refreshHandler   = refreshHandler;
            self.onDataGridLoaded = onDataGridLoaded;

            self.dsNotificacoes;
            self.datagrid;

            $scope.$success = function() {
                MessageUtils.showAlertWithConfirm(MessageUtils.TITLE_CONFIRMATION, i18n("Commons.PlanejamentoMetaOrcamento.desejaImportacaoIncompleta")).then(
                    function (sim) {
                        $popupInstance.success();
                    }
                );
            };

            $scope.$dismiss = function() {
                $popupInstance.dismiss();
            };

            init();

            function init() {
                var msg = "Nenhuma notificação foi encontrada."

                if(dataValue) {
                    msg = "O processo de importação encontrou alguns dados inesperados. Confira a lista de notificações geradas.";
                }

                MessageUtils.showAlert(msg);
            }

            function onDatasetCreated(dataset) {
                self.dsNotificacoes = dataset;
                self.dsNotificacoes.initAndRefresh();
            }

            function refreshHandler(request) {
                if(dataValue.notificacoes) {
                    self.dsNotificacoes.clearDataSet();

                    return dataValue.notificacoes;
                }
            }

            function onDataGridLoaded(datagrid) {
				self.datagrid = datagrid;
            }
            
            function interceptColumnMetadata(fieldMd) {
                if (fieldMd.name == 'descNotificacao') {
                    fieldMd.width = 600;
                }

                return fieldMd;
            }
        }
    ]);
/*
*  Createad by Leonardo Mendes on 11/01/2019.
*/
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('listaCenarios', ['i18n', 'Criteria', 'data','$scope','$popupInstance','MessageUtils',
        function (i18n, Criteria, data, $scope, $popupInstance, MessageUtils) {
            var self = this;

            $scope.$success = aplicar;
            
            self.gridConfigId = data.resourceId + '.GridListMeta';
            
            self.onDatasetCreated = onDatasetCreated;
            self.aplicar = aplicar;

            function onDatasetCreated(dataset) {
                self.dsForecastMeta = dataset;

                self.dsForecastMeta.addRefreshedListener(function(reason){
                    if(self.dsForecastMeta.size() == 0){
                        MessageUtils.showInfo(i18n('Commons.PlanejamentoMetaOrcamento.alertaNaoExisteCenario'));
                        $popupInstance.dismiss();
                    }
                });

                self.dsForecastMeta.addCriteriaProvider(getCriteria);
                self.dsForecastMeta.initAndRefresh();
            }

            function getCriteria() {
                var criteria = Criteria();
                criteria.and('this.CODUSU = ?');
                criteria.addParameter(Criteria.buildParameter('N', data.codUsuario));

                criteria.and('this.CODMETA = ?');
                criteria.addParameter(Criteria.buildParameter('N', data.codMeta));
                return criteria;
            }


            function aplicar() {
                $popupInstance.success({
                    codCenario: self.dsForecastMeta.getFieldValueAsNumberOrZero('CODCENARIO'),
                    nomeCenario: self.dsForecastMeta.getFieldValueAsString('NOMECENARIO'),
                    observacao: self.dsForecastMeta.getFieldValueAsString('OBSERVACAO')
                });
            }
        }]);
/*
 *  Createad by Leonardo Mendes on 11/01/2019.
 */

angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('SalvarCenarioController', ['i18n', 'data', '$scope', '$popupInstance', 'MessageUtils', 'StringUtils', 'SanPopup',
        function (i18n, data, $scope, $popupInstance, MessageUtils, StringUtils, SanPopup) {
            var self = this;

            self.popUpSelecione = popUpSelecione;

            $scope.$success = success;

            var _codCenario;

            function success() {
                if (StringUtils.isEmpty(self.nomeCenario)) {
                    MessageUtils.showAlert(i18n('Commons.PlanejamentoMetaOrcamento.alertaCenario'));
                    return;
                }

                data.callback({
                    NOMECENARIO: self.nomeCenario,
                    OBSERVACAO: self.observacao,
                    CODCENARIO: _codCenario
                }).then(function () {
                    $popupInstance.success();
                })
            }


            function popUpSelecione() {
                SanPopup.open({
                    title: i18n('Commons.PlanejamentoMetaOrcamento.lblCenarios'),
                    templateUrl: 'commons/planejamentoMetaOrcamento/popup/salvar-cenario/lista-cenarios.tpl.html',
                    controller: 'listaCenarios as ctrl',
                    controllerAs: 'ctrl',
                    size: 'md',
                    okBtnLabel: i18n('Commons.PlanejamentoMetaOrcamento.buttonSelecionarCenario'),
                    cancelBtnLabel:i18n('Geral.buttonVoltar'),
                    resolve: {
                        data: {
                            codMeta: data.codMeta,
                            codUsuario: data.codUsuario,
                            resourceId: data.resourceId
                        }
                    }
                }).result.then(function (data) {
                    self.nomeCenario = data.nomeCenario;
                    self.observacao = data.observacao;
                    _codCenario = data.codCenario;
                });
            }

        }]);
/*
 *  Createad by Italo Araujo 29/04/2019.
 */
angular
    .module('snk.commons.planejamentoMetaOrcamento')
    .controller('VisualizarOrcamentoController', ['GridConfig', 'i18n', 'data', '$scope', 'StringUtils', 'ObjectUtils',
        function (GridConfig, i18n, data, $scope, StringUtils, ObjectUtils) {
            var self = this;

            ObjectUtils.implements(self, IFormInterceptor);
            self.interceptBuildField = interceptBuildField;

            self.onDatasetCreated = onDatasetCreated;
            self.interceptMetadata = interceptMetadata;
            self.currentRow = data.currentRow[0];
            self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.gridConfigId = 'GridConfigVisualizarOrcamento:' + data.resourceID;

            self.changeButtonActions = [{
                label: i18n('Controls.GridConfig.buttonGridConfig'), action: openGridConfig
            }];

            init();
            
            function init() {
            	GridConfig.registerGridConfig(self.gridConfigId, self.gridConfigId, undefined, true);
            }

            function onDoubleFacePanelCreated(dblFacePanel) {
                self[dblFacePanel.id] = dblFacePanel;
            }

            function onDatasetCreated(dataset) {
                self.dsMetaAtual = dataset;
                self.dsMetaAtual.addCriteriaProvider(getCriteriaMeta);

                self.dsMetaAtual.initAndRefresh();

                if(self.formApi) self.formApi.setFieldProperty('CODMETA', 'required', true);
            }

            function interceptMetadata(fields) {
                fields.forEach(function(field){
                    if('@REDUCAODESP@CONTROLE@MARCA@CODTIPPARC@Perfil.DESCRTIPPARC@CODCID@CODPAIS@CODGRUPONAT@DIA@CODUF@CODREG@CODGRUPOPROD@ANALITICO@TIPOMSG@CODVOL@PERCAVISO@SEMANAMES@TOTALAUTINV@'.indexOf('@' + field.name + '@') > -1){
                        field.visible = false; 
                    }
                    field.required = false;
                }); 
            }

            function getCriteriaMeta(){
                var criteria = Criteria();
                criteria.append('this.CODMETA = ?', self.currentRow.CODMETA);

                if (!StringUtils.isEmpty(self.currentRow.CODCENCUS)) {
                	criteria.append(" AND this.CODCENCUS = ?", self.currentRow.CODCENCUS);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODCID)) {
                	criteria.append(" AND this.CODCID = ?", self.currentRow.CODCID);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODEMP)) {
                	criteria.append(" AND this.CODEMP = ?", self.currentRow.CODEMP);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODGER)) {
                	criteria.append(" AND this.CODGER = ?", self.currentRow.CODGER);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODGRUPONAT)) {
                	criteria.append(" AND this.CODGRUPONAT = ?", self.currentRow.CODGRUPONAT);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODGRUPOPROD)) {
                	criteria.append(" AND this.CODGRUPOPROD = ?", self.currentRow.CODGRUPOPROD);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODLOCAL)) {
                	criteria.append(" AND this.CODLOCAL = ?", self.currentRow.CODLOCAL);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODNAT)){
                	criteria.append(" AND this.CODNAT = ?", self.currentRow.CODNAT);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODPAIS)){
                	criteria.append(" AND this.CODPAIS = ?", self.currentRow.CODPAIS);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODPARC)){
                	criteria.append(" AND this.CODPARC = ?", self.currentRow.CODPARC);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODPROJ)){
                	criteria.append(" AND this.CODPROJ = ?", self.currentRow.CODPROJ);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODREG)){
                	criteria.append(" AND this.CODREG = ?", self.currentRow.CODREG);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODTIPPARC)){
                	criteria.append(" AND this.CODTIPPARC = ?", self.currentRow.CODTIPPARC);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODUF)){
                	criteria.append(" AND this.CODUF = ?", self.currentRow.CODUF);
                }
                if (!StringUtils.isEmpty(self.currentRow.CODVEND)){
                	criteria.append(" AND this.CODVEND = ?", self.currentRow.CODVEND);
                }

                return criteria;
            }
            
            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                if (dataset.getEntityName() == 'MetaAtual') {
                        fieldProp['sk-enabled'] = 'false';
                }
            }

            function openGridConfig() {
                GridConfig.openGridconfig(self.gridConfigId);
			}
            
        }]);
angular
    .module('snk.commons')
    .controller('PopUpGadgetsController', ['nugdg', 'descgdg', 'promptParams',
        function (nugdg, descgdg, promptParams) {
            var self = this;

            self.nugdg = nugdg;
            self.descgdg = descgdg;
            self.onLoad = onLoad;

            init();

            function init() {
                let src = "/mge/Dashboard.html5?nuGdg=" + self.nugdg;

                if(promptParams){
                    let newParams = {};

                    for (let property in promptParams) {
                        if (promptParams.hasOwnProperty(property)) {
                            newParams[property] = promptParams[property];
                        }
                    }

                    if(Object.keys(newParams).length !== 0) {
                        src = src + "&parameters=" + encodeURIComponent( Base64.encodeToBinary(JSON.stringify(newParams)) );
                    }
                }

                self.src = src;
            }

            function onLoad() {
                // const checkTimeInMs = 200;

                // const intervalId = window.setInterval(
                //     () => {
                //       let iframeElem = document.getElementById('popUpGadgets-iframe-' + self.nugdg);
                //       let dashboardView = iframeElem.contentWindow?.dashboard;

                //       if (dashboardView && dashboardView.dashboardLoaded === true) {
                //         window.clearInterval(intervalId);

                //         // Utilização do Dashboard aqui
                //       }
                //     },
                //     checkTimeInMs
                // );
            }
        }
    ]);
angular
	.module('snk.commons')
	.service('PopUpGadgetsService', ['SanPopup', 'SkI18nService',
		function (SanPopup) {
			var self = this;
			self.openPopUp = openPopUp;

			function openPopUp(nugdg, descgdg, promptParams) {
				return SanPopup.open({
					title: descgdg,
					templateUrl: 'commons/popUpGadgets/popUpGadgets.tpl.html',
					controller: 'PopUpGadgetsController',
					controllerAs: 'ctrl',
					size: 'lg',
					showBtnCancel: false,
					showBtnOk: false,
					showBtnNo: false,
					resolve: {
                        nugdg: nugdg,
                        descgdg: descgdg,
						promptParams: promptParams
                    }
				}).result;
			}
		}
    ]);
angular
    .module('snk.commons')
    .controller('PopUpParametrosEDIController', ['$scope', 'dataValue', '$popupInstance', 'DateUtils',
        function ($scope, dataValue, $popupInstance, DateUtils) {
            var self = this;
            
            self.dataValue = dataValue;
            self.init = init;

            init();	
            
            function init(){
            	if(self.dataValue && self.dataValue.param){
                    self.dataValue.param.forEach(grupo=>{
                		if(grupo.param && !Array.isArray(grupo.param)){
                			grupo.param = [grupo.param];
                		}
                	});
            	}
            }

            $scope.$success = success

            function getValueFromType(type, value) {
                var value;

                switch (type) {
                    case "I":
                    case "F":
                        value = value ? value.toString() : "";
                        break;
                    case "D":
                        value = DateUtils.dateToString(value);
                        break;
                }

                return value;
            }

            function success() {
                var value = {param: []};
                self.dataValue.param.forEach(function (layout) {
                    layout.param.forEach(params => {
                        value.param.push({codigo: layout.codigo, tipo: params.tipo, nome: params.nome, $: getValueFromType(params.tipo, params.value)});
                    });
                });

                $popupInstance.success(value)
            }

        }]);
angular
	.module('snk.commons')
	.service('PopUpParametrosEDIService', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;
			self.openPopUp = openPopUp;

			function openPopUp(params) {
				return SanPopup.open({
                    id: 'ID_POPUP_PARAMETROS_VARIAVEIS',
                    title: 'Parâmetros variáveis',
                    templateUrl: 'commons/popUpParametrosEDI/popUpParametrosEDI.tpl.html',
                    controller: 'PopUpParametrosEDIController',
                    controllerAs: 'ctrl',
                    showBtnOk: true,
                    grayBG: true,
                    bodyPadding: false,
                    cancelBtnLabel: i18n('Geral.lblFechar'),
                    resolve: {
                        dataValue: { param: params }
                    }
                }).result;
			}
		}
    ]);

angular
    .module('snk.commons.preenchimentoquestionario')
    .component('skCabecalhoQuestionario', {
        templateUrl: 'commons/preenchimentoquestionario/cabecalhoquestionario.tpl.html',
        controller: 'SkCabecalhoQuestionarioController',
        bindings: {
            textTitulo: '@?skTituloCabecalho',
            textTituloDivisoria: '=?skTituloDivisoria'
        }
    })
    .controller('SkCabecalhoQuestionarioController', ['$scope','StringUtils',
        function ($scope, StringUtils) {

        }]);



angular
    .module('snk.commons.preenchimentoquestionario')
    .component('skPerguntaQuestionario', {
        templateUrl: 'commons/preenchimentoquestionario/perguntaquestionario.tpl.html',
        controller: 'SkPerguntaQuestionarioController',
        bindings: {
            pergunta: '=skPergunta',
            value: '=skValue',
            onChange: '&skOnChange',
            step: '=?skStepControl'
        }
    })
    .controller('SkPerguntaQuestionarioController', ['$scope', '$element', 'MessageUtils', 'ObjectUtils', 'StringUtils', 'ArrayUtils', 'i18n', 'UserAgentUtils', 'QuestionarioConstant',
        function($scope, $element, MessageUtils, ObjectUtils, StringUtils, ArrayUtils, i18n, UserAgentUtils, QuestionarioConstant) {
            var self = this;

            self.$onInit = $onInit;
            self.$postLink = iniciarPergunta;

            self.tipo;
            self.subTipo;

            var _qtdCamposMarcadosInfo = undefined;

            self.verificaQtdCamposMarcados = verificaQtdCamposMarcados;
            self.verificaQtdMaxLinhas = verificaQtdMaxLinhas;
            self.verificaMaximoMinimo = verificaMaximoMinimo;
            self.isStarRating = isStarRating;

            function $onInit() {
                $element.attr('layout', 'column');
            }

            function iniciarPergunta() {
                if (!self.pergunta) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Questionario.messageDataProviderVazio'));
                }

                self.tipo = buildTipo();

                if (self.pergunta.hasOwnProperty('qtdMaxEscolhas')) {
                    _qtdCamposMarcadosInfo = self.pergunta.qtdMaxEscolhas;
                }
            }

            function buildTipo() {
                switch (self.pergunta.tipo) {
                    case QuestionarioConstant.CAIXA_TEXTO_UNICA_LINHA:
                        return 'text';

                    case QuestionarioConstant.CAIXA_TEXTO_MULTIPLAS_LINHAS:
                        return 'textarea';

                    case QuestionarioConstant.OPCOES_LINHA_UNICA_ESCOLHA:
                    case QuestionarioConstant.OPCOES_COLUNA_UNICA_ESCOLHA:
                        self.subTipo = UserAgentUtils.isMobile() || self.pergunta.tipo == QuestionarioConstant.OPCOES_LINHA_UNICA_ESCOLHA ? 'column' : 'row';
                        return 'radio';

                    case QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA:
                    case QuestionarioConstant.OPCOES_COLUNA_MULTIPLA_ESCOLHA:
                        self.subTipo = UserAgentUtils.isMobile() || self.pergunta.tipo == QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA ? 'column' : 'row';
                        return 'checkbox';

                    case QuestionarioConstant.GRUPO_PONTUACAO:
                        return 'grupo';

                    case QuestionarioConstant.TABELA_UNICA_ESCOLHA:
                        return 'tabUnica';

                    case QuestionarioConstant.TABELA_MULTIPLA_ESCOLHA:
                        return 'tabMultipla';

                }
            }

            function isStarRating(resposta) {
                return resposta.valorMin == 1 && resposta.valorMax == 5;
            }


            function quantidadeCamposMarcados(codPerg, codResp) {
                var quantidade = 0;

                if (angular.isDefined(self.value)) {
                    if (self.pergunta.tipo == QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA || self.pergunta.tipo == QuestionarioConstant.OPCOES_COLUNA_MULTIPLA_ESCOLHA) {

                        ObjectUtils.forEachInObject(self.value, function(key, value) {
                            if (value == true) {
                                quantidade++;
                            }

                            if (quantidade > _qtdCamposMarcadosInfo) {
                                return false;
                            }
                        });

                    } else if (self.pergunta.tipo == QuestionarioConstant.TABELA_MULTIPLA_ESCOLHA) {
                        var repostas = self.value[codPerg];

                        if (repostas) {
                            ObjectUtils.forEachInObject(repostas, function(key, value) {
                                if (value == true) {
                                    quantidade++;
                                }

                                if (quantidade > _qtdCamposMarcadosInfo) {
                                    return false;
                                }
                            });
                        }
                    }
                }

                return quantidade;
            }


            function verificaQtdCamposMarcados(codResp, codPerg) {
                if (angular.isDefined(_qtdCamposMarcadosInfo) && _qtdCamposMarcadosInfo > 0) {
                    if (quantidadeCamposMarcados(codPerg, codResp) > _qtdCamposMarcadosInfo) {

                        if (self.pergunta.tipo == QuestionarioConstant.TABELA_MULTIPLA_ESCOLHA) {
                            self.value[codPerg][codResp] = false;
                        } else {
                            self.value[codResp] = false;
                        }

                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Questionario.messageQtdMaxEscolhasMarcada', [_qtdCamposMarcadosInfo]));
                    } else {
                        self.onChange();
                    }
                }
            }

            function verificaMaximoMinimo(codResp, index) {
                if (self.value[codResp] > parseFloat(self.pergunta.resposta[index].valorMax)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Questionario.messageCampoExcedeuMaximo', [self.pergunta.resposta[index].valorMax]));
                    delete self.value[codResp];
                } else if (self.value[codResp] < parseFloat(self.pergunta.resposta[index].valorMin)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Questionario.messageCampoExcedeuMinimo', [self.pergunta.resposta[index].valorMin]));
                    delete self.value[codResp];
                }
            }


            function verificaQtdMaxLinhas($event, codResp) {
                if ($event.keyCode == 13) {
                    var valueIsEmpty = angular.isUndefined(self.value) || StringUtils.isEmpty(self.value[codResp]);

                    var invalid = false;

                    if (parseInt(self.pergunta.qtdMaxLinhas) == 1 && valueIsEmpty) {
                        invalid = true;
                    } else if (!valueIsEmpty && self.value[codResp].split('\n').length >= parseInt(self.pergunta.qtdMaxLinhas)) {
                        invalid = true;
                    }

                    if (invalid) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Questionario.messageNaoExcederQtdMaxLinhas', [self.pergunta.qtdMaxLinhas]));
                    }
                }
            }


        }]);


angular
    .module('snk.commons.preenchimentoquestionario')
    .component('skQuestionario', {
        templateUrl: 'commons/preenchimentoquestionario/questionario.tpl.html',
        controller: 'SkQuestionarioController',
        bindings: {
            dataProvider: '=skDataProvider',
            finishHandler: '&skFinishHandler',
            editHandler: '&skEditHandler',
            closeHandler: '&skCloseHandler',
            index: '=skIndex',
            multiplosQuestionarios:'=?skMultiplosQuestionarios'
        }
    })
    .controller('SkQuestionarioController', ['$scope', '$element', 'MessageUtils', 'i18n', 'ArrayUtils', 'SanPopup', 'SkWizardHandler', 'ObjectUtils', 'StringUtils', 'QuestionarioConstant', 'DomUtil', 'AngularUtil', 'SkLocalStorage', 'SkApplicationInstance',
        function ($scope, $element, MessageUtils, i18n, ArrayUtils, SanPopup, SkWizardHandler, ObjectUtils, StringUtils, QuestionarioConstant, DomUtil, AngularUtil, SkLocalStorage, SkApplicationInstance) {
            var self = this;

            var RESPOSTAS_NAO_SALVAS_KEY = 'respsNaoSalvas';

            self.respostas = {};
            self.observacoesPorPergunta = {};
            self.pergObrigatoriaInfo = {};
            self.observacao = undefined;
            self.tituloDivisoria = i18n('Commons.Questionario.lblQuestoes');
            
            self.ehPreVisualizacao = undefined;
            self.selectedIndexViewStack = 0;

            self.$onInit = $onInit;
            self.$postLink = iniciarQuestionario;

            self.onCancel = onCancel;
            self.onFinish = onFinish;
            self.onStepChange = onStepChange;

            self.isVisible = isVisible;
            self.editarRespotas = editarRespotas;
            self.validateStep = validateStep;
            self.incluirObservacao = incluirObservacao;
            self.getSubtituloCabecalho = getSubtituloCabecalho;
            self.getPerguntaMarginLeft = getPerguntaMarginLeft;
            self.pertuntaPossuiComentario = pertuntaPossuiComentario;
            self.onChangeResposta = onChangeResposta;

            var saveRespostasOnStorageDebounced = AngularUtil.debounce(saveRespostasOnStorage, 300, self, false);

            var _pergDependentesInfo = {};
            var _perguntaTipoInfo = {};

            var _localStorage;

            var _initialized = false;

            function $onInit() {
                $element.attr('layout', 'column');
                $element.attr('flex', '');
                //$element.addClass('container-absolute');
            }

            function iniciarQuestionario() {
                if (!self.dataProvider) {
                    MessageUtils.showError(i18n('Commons.Questionario.messageDataProviderVazio'));
                }
                self.ehPreVisualizacao = self.dataProvider.preVisualizacao == "true";

                if (angular.isDefined(self.dataProvider.instancia)) {
                    var atributos = ['name', 'nuInstancia', 'tipo', 'codigo', 'codigo2', 'codEmp', 'sequencia'];

                    atributos.forEach(function (atributo) {
                        atualizarInstanciaRetorno(atributo);
                    });

                    if (angular.isDefined(self.dataProvider.instancia.$)) {
                        self.dataProvider.instancia2.$ = self.dataProvider.instancia.$;
                    }
                }

                mapearPerguntas();

                self.selectedIndexViewStack = 2;

                self.wizardID = 'wzdQuestionario' + self.dataProvider.codQuest;

                var localStoragePrefix = SkApplicationInstance.getResourceID('br.com.sankhya.questionario.externo');
                localStoragePrefix += (':q:' + self.dataProvider.codQuest);

                if (self.dataProvider.nuPla) {
                    localStoragePrefix += (':p:' + self.dataProvider.nuPla);
                }

                _localStorage = SkLocalStorage(localStoragePrefix);

                if (!self.ehPreVisualizacao) {
                    loadRespostasFromStorage();
                }

                AngularUtil.timeout(function () {
                    _initialized = true;
                });
            }

            function loadRespostasFromStorage() {
                var respostas = _localStorage.get(RESPOSTAS_NAO_SALVAS_KEY);

                if (angular.isObject(respostas)) {
                    self.respostas = respostas;
                }
            }

            function onChangeResposta() {
                saveRespostasOnStorageDebounced();
            }

            function saveRespostasOnStorage() {
                if (_localStorage && _initialized && !self.ehPreVisualizacao) {
                    _localStorage.set(RESPOSTAS_NAO_SALVAS_KEY, self.respostas);
                }
            }

            function atualizarInstanciaRetorno(atributo) {
                if (angular.isDefined(self.dataProvider.instancia[atributo])) {
                    self.dataProvider.instancia2[atributo] = self.dataProvider.instancia[atributo];
                }
            }

            function onCancel() {
                self.closeHandler();
            }

            function onStepChange($step) {
                self.currentStep = $step && $step.$parent.passo;

                if(SkWizardHandler.wizard(self.wizardID).currentStepNumber() > self.dataProvider.passo.length){
                    self.tituloDivisoria = i18n('Commons.Questionario.lblConcluindoQuestionario');
                }else{
                    self.tituloDivisoria = i18n('Commons.Questionario.lblQuestoes');
                }
            }

            function onFinish() {
                if (self.dataProvider.passo.length >= SkWizardHandler.wizard(self.wizardID).currentStepNumber()) {
                    throw new AlertError('Geral.lblAtencao', 'Commons.Questionario.messageEtapasNaoPercorrida');
                } else {
                    validateFinish();

                    if(StringUtils.toBoolean($scope.multiplosQuestionarios)){
                        self.selectedIndexViewStack = 1;
                    }

                    self.finishHandler({
                        $respostasQuestionario: getRespostasQuestionario()
                    });
                }
            }

            function editarRespotas() {
                self.selectedIndexViewStack = 2;

                self.editHandler();

                SkWizardHandler.wizard(self.wizardID).goToByName(0);
            }

            //Mapear perguntas
            function mapearPerguntas() {
                self.dataProvider.passo.forEach(function (passo) {
                    if (!angular.isArray(passo.pergunta)) {
                        return;
                    }

                    passo.pergunta = ArrayUtils.toArray(passo.pergunta);
                    passo.pergunta.forEach(function (pergunta) {
                        if (ArrayUtils.isIn([QuestionarioConstant.CAIXA_TEXTO_UNICA_LINHA,
                        QuestionarioConstant.CAIXA_TEXTO_MULTIPLAS_LINHAS,
                        QuestionarioConstant.OPCOES_LINHA_UNICA_ESCOLHA,
                        QuestionarioConstant.OPCOES_COLUNA_UNICA_ESCOLHA,
                        QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA,
                        QuestionarioConstant.OPCOES_COLUNA_MULTIPLA_ESCOLHA,
                        QuestionarioConstant.GRUPO_PONTUACAO], pergunta.tipo)) {
                            
                            pergunta.resposta = ArrayUtils.toArray(pergunta.resposta);
                            pergunta.resposta.forEach(function (resposta) {
                                if (angular.isDefined(resposta.pergsDep)) {
                                    ArrayUtils.toArray(resposta.pergsDep.pergDep).forEach(function (pergDep) {
                                        var pergDependenteInfo = _pergDependentesInfo[pergDep.$];

                                        if (!pergDependenteInfo) {
                                            pergDependenteInfo = {
                                                pergMaster: pergunta.codPerg,
                                                respostas: []
                                            };

                                            _pergDependentesInfo[pergDep.$] = pergDependenteInfo;
                                        }

                                        pergDependenteInfo.respostas.push(resposta.codResp);
                                    });
                                }
                            });
                        }

                        self.pergObrigatoriaInfo[pergunta.codPerg] = StringUtils.toBoolean(pergunta.obrigatoria);

                        _perguntaTipoInfo[pergunta.codPerg] = pergunta.tipo;
                    });
                });
            }

            function isVisible(pergunta) {
                var pergDependenteInfo = _pergDependentesInfo[pergunta.codPerg];
                var visivel = false;

                if (pergDependenteInfo) { //É dependente, temos que chegar se a master está informada com a resposta necessária
                    var respostaMaster = self.respostas[pergDependenteInfo.pergMaster];

                    if (angular.isDefined(respostaMaster)) {
                        visivel = ArrayUtils.isIn(pergDependenteInfo.respostas, respostaMaster);
                    } else {
                        visivel = false; //Master não está respondida
                    }
                } else {
                    visivel = true;
                }

                if (!visivel) {
                    limparCamposPergunta(pergunta);
                }

                pergunta.visible = visivel;

                return visivel;

            }


            function isRequired(codPerg) {
                return StringUtils.toBoolean(self.pergObrigatoriaInfo[codPerg]);
            }

            function isAnswered(pergunta) {
                var respodido = self.respostas[pergunta.codPerg];
                var enable = false;
                if (angular.isDefined(respodido)) {
                    if (pergunta.tipo == QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA || pergunta.tipo == QuestionarioConstant.OPCOES_COLUNA_MULTIPLA_ESCOLHA) {
                        ArrayUtils.forEach(pergunta.resposta, function (resposta) {
                            if (respodido[resposta.codResp] == true) {
                                enable = true;
                                return false;
                            }
                        });
                    } else if (pergunta.tipo == QuestionarioConstant.GRUPO_PONTUACAO) {
                        enable = true;
                        ArrayUtils.forEach(pergunta.resposta, function (resposta) {
                            if (angular.isUndefined(respodido[resposta.codResp])) {
                                enable = false;
                                return false;
                            }
                        });
                    } else if (pergunta.tipo == QuestionarioConstant.TABELA_UNICA_ESCOLHA) {
                        enable = true;
                        ArrayUtils.forEach(pergunta.topicos.topico, function (topico) {
                            var codPerg = topico.codPerg;
                            if (angular.isUndefined(respodido[codPerg])) {
                                enable = false;
                                return false;
                            }
                        });
                    } else if (pergunta.tipo == QuestionarioConstant.TABELA_MULTIPLA_ESCOLHA) {
                        ArrayUtils.forEach(pergunta.topicos.topico, function (topico) {
                            enable = false;
                            var codPerg = topico.codPerg;
                            ArrayUtils.forEach(topico.resposta, function (resposta) {
                                if (respodido[codPerg][resposta.codResp] == true) {
                                    enable = true;
                                    return false;
                                }
                            });
                            if (enable == false) {
                                return false;
                            }
                        });
                    } else {
                        enable = true;
                    }
                }
                return enable;
            }

            function validateFinish(validateFinish) {
                self.dataProvider.passo.forEach(function (passo, passoIndex) {
                    validateStep(passo, passoIndex);
                });
            }

            function validateStep(passo, passoIndex) {
                if (angular.isUndefined(passo.pergunta)) {
                    return;
                }

                ArrayUtils.forEach(passo.pergunta, function (pergunta) {
                    if (isVisible(pergunta) && isRequired(pergunta.codPerg) && !isAnswered(pergunta)) {

                        if (angular.isNumber(passoIndex)) {
                            SkWizardHandler.wizard(self.wizardID).goToByName(passoIndex);

                            AngularUtil.timeout(function () {
                                scrollToPergunta(pergunta);
                            });
                        } else {
                            scrollToPergunta(pergunta);
                        }

                        throw new AlertError('Geral.lblAtencao', 'Commons.Questionario.messagePerguntaObrigatoria');
                    }
                });
            }

            function scrollToPergunta(pergunta) {
                var stepsContainerElem = SkWizardHandler.wizard(self.wizardID).getStepsContainerElement();
                var pergElement = DomUtil.select(stepsContainerElem, '.questionario-pergunta.pergunta-' + pergunta.codPerg);
                DomUtil.scrollTo(stepsContainerElem, pergElement.offsetTop - 10);
            }

            function incluirObservacao(codPerg) {
                var obsModel = {
                    value: self.observacoesPorPergunta[codPerg]
                };

                SanPopup.open({
                    title: i18n('Commons.Questionario.btnComentario'),
                    template: '<sk-text-area autofocus sk-value="obsModel.value" sk-placeholder="Commons.Questionario.messageAcrescenteComentario" flex></sk-text-area>',
                    size: 'md',
                    showBtnCancel: true,
                    okBtnLabel: i18n('Geral.buttonSalvar'),
                    resolve: {
                        obsModel: obsModel
                    }
                }).result.then(function () {
                    self.observacoesPorPergunta[codPerg] = obsModel.value;

                    if (self.observacoesPorPergunta[codPerg] == '') {
                        delete self.observacoesPorPergunta[codPerg];
                    }
                });
            }


            function limparCamposPergunta(pergunta) {
                if (angular.isDefined(self.respostas[pergunta.codPerg])) {
                    if (ArrayUtils.isIn([QuestionarioConstant.CAIXA_TEXTO_UNICA_LINHA,
                    QuestionarioConstant.CAIXA_TEXTO_MULTIPLAS_LINHAS,
                    QuestionarioConstant.OPCOES_LINHA_UNICA_ESCOLHA,
                    QuestionarioConstant.OPCOES_COLUNA_UNICA_ESCOLHA,
                    QuestionarioConstant.GRUPO_PONTUACAO], pergunta.tipo)) {
                        delete self.respostas[pergunta.codPerg];
                    } else if (ArrayUtils.isIn([QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA, QuestionarioConstant.OPCOES_COLUNA_MULTIPLA_ESCOLHA], pergunta.tipo)) {
                        ObjectUtils.forEachInObject(self.respostas[pergunta.codPerg], function (key, value) {
                            if (value == true) {
                                self.respostas[pergunta.codPerg][key] = false;
                            }
                        });
                    }
                }
                if (angular.isDefined(self.observacoesPorPergunta[pergunta.codPerg])) {
                    delete self.observacoesPorPergunta[pergunta.codPerg];
                }
            }

            function getRespostasQuestionario() {
                var respostas = {
                    nuPla: self.dataProvider.nuPla,
                    instancia: self.dataProvider.instancia2,
                    concluido: true,
                    perguntas: {
                        pergunta: getPerguntas()
                    }
                };

                if (StringUtils.isNotEmpty(self.observacao)) {
                    respostas.observacao = {
                        $: self.observacao
                    }
                }

                return respostas;
            }


            function getPerguntas() {
                var pergunta = [];

                ObjectUtils.forEachInObject(self.respostas, function (key, value) {
                    if (ArrayUtils.isIn([QuestionarioConstant.CAIXA_TEXTO_UNICA_LINHA, QuestionarioConstant.CAIXA_TEXTO_MULTIPLAS_LINHAS], _perguntaTipoInfo[key])) {
                        var respostas = getRespostasTexto(value);

                        if (respostas.length > 0) {
                            addPergunta(pergunta, key, respostas);
                        }
                    } else if (ArrayUtils.isIn([QuestionarioConstant.OPCOES_LINHA_UNICA_ESCOLHA, QuestionarioConstant.OPCOES_COLUNA_UNICA_ESCOLHA], _perguntaTipoInfo[key])) {
                        addPergunta(pergunta, key, { codResp: value });
                    } else if (ArrayUtils.isIn([QuestionarioConstant.OPCOES_LINHA_MULTIPLA_ESCOLHA, QuestionarioConstant.OPCOES_COLUNA_MULTIPLA_ESCOLHA], _perguntaTipoInfo[key])) {
                        var respostas = getRespostasCheckBox(value);

                        if (respostas.length > 0) {
                            addPergunta(pergunta, key, respostas);
                        }
                    } else if (ArrayUtils.isIn([QuestionarioConstant.GRUPO_PONTUACAO], _perguntaTipoInfo[key])) {
                        var respostas = getRespostasGrupoPontuacao(value);

                        if (respostas.length > 0) {
                            addPergunta(pergunta, key, respostas);
                        }
                    } else if (ArrayUtils.isIn([QuestionarioConstant.TABELA_UNICA_ESCOLHA], _perguntaTipoInfo[key])) {
                        ObjectUtils.forEachInObject(value, function (key, value) {
                            addPergunta(pergunta, key, { codResp: value });
                        });
                    } else if (ArrayUtils.isIn([QuestionarioConstant.TABELA_MULTIPLA_ESCOLHA], _perguntaTipoInfo[key])) {
                        ObjectUtils.forEachInObject(value, function (key, value) {
                            var respostas = getRespostasCheckBox(value);

                            if (respostas.length > 0) {
                                addPergunta(pergunta, key, respostas);
                            }
                        });
                    }

                });

                return pergunta;
            }

            function addPergunta(perguntaArr, key, respostas) {
                var pergunta = {
                    codPerg: key,
                    resposta: respostas
                };

                if (angular.isDefined(self.observacoesPorPergunta[key])) {
                    pergunta.observacao = {
                        $: self.observacoesPorPergunta[key]
                    }
                }

                perguntaArr.push(pergunta);
            }

            function getRespostasTexto(respostas) {
                var resposta = [];

                ObjectUtils.forEachInObject(respostas, function (key, value) {
                    resposta.push({
                        codResp: key,
                        texto: {
                            $: value
                        }
                    });
                });

                return resposta;
            }

            function getRespostasCheckBox(respostas) {
                var resposta = [];

                ObjectUtils.forEachInObject(respostas, function (key, value) {
                    if (value == true) {
                        resposta.push({
                            codResp: key
                        });
                    }
                });

                return resposta;
            }

            function getRespostasGrupoPontuacao(respostas) {
                var resposta = [];

                ObjectUtils.forEachInObject(respostas, function (key, value) {
                    resposta.push({
                        codResp: key,
                        valor: parseFloat(value)
                    });
                });

                return resposta;
            }

            function getSubtituloCabecalho() {
                if (!self.ehPreVisualizacao) {
                    var nomeInstancia = self.dataProvider.instancia2['name'];

                    if (self.dataProvider.instancia2['name'] == 'Usuario') {
                        nomeInstancia = 'Usuário';
                    } else if (self.dataProvider.instancia2['name'] == 'Funcionario') {
                        nomeInstancia = 'Funcionário';
                    }

                    return (nomeInstancia + ": " + self.dataProvider.instancia2.$);
                }
                return "";
            }

            function getPerguntaMarginLeft(codPerg) {
                var margin = 5;

                var pergDepInfo;

                while (pergDepInfo = _pergDependentesInfo[codPerg]) {
                    margin += 10;
                    codPerg = pergDepInfo.pergMaster;
                }

                return StringUtils.toPX(margin);
            }

            function pertuntaPossuiComentario(codPerg) {
                return angular.isDefined(self.observacoesPorPergunta[codPerg]);
            }

        }]);


/**
 * Created by Leonardo.Mendes on 12/12/2020.
 */
angular
    .module('snk.commons.preenchimentoquestionario')
    .constant('QuestionarioConstant', {
        CAIXA_TEXTO_UNICA_LINHA: '0',
        CAIXA_TEXTO_MULTIPLAS_LINHAS: '1',
        OPCOES_LINHA_UNICA_ESCOLHA: '2',
        OPCOES_COLUNA_UNICA_ESCOLHA: '3',
        OPCOES_LINHA_MULTIPLA_ESCOLHA: '4',
        OPCOES_COLUNA_MULTIPLA_ESCOLHA: '5',
        GRUPO_PONTUACAO: '6',
        TABELA_UNICA_ESCOLHA: '7',
        TABELA_MULTIPLA_ESCOLHA: '8'
    });
angular
    .module('snk.commons.queryEditor')
    .component('skQueryEditor', {
        templateUrl: 'commons/queryEditor/query-editor.tpl.html',
        controller: 'queryEditorController',
        controllerAs: 'ctrl',
        bindings: {
            dataSources: '=skDataSources',
            dataSource: '=skDataSource',
            dataParameters: '=skDataParams',
            sql: '=skSql',
            savedParamsId: '=skSavedParamsId',
            onCreateComplete: '&',
        }
    })
    .controller('queryEditorController', ['QueryParams', 'StringUtils', 'MessageUtils', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils', 'AngularUtil', 'SanPopup', 'Criteria', 'SkPesquisaService', 'i18n', '$scope', 'SkApplicationInstance','$q', '$timeout', '$rootScope',
        function (QueryParams, StringUtils, MessageUtils, ServiceProxy, ObjectUtils, ArrayUtils, AngularUtil, SanPopup, Criteria, SkPesquisaService, i18n, $scope, SkApplicationInstance, $q, $timeout, $rootScope) {
            const QUERY_INDEX = 0;
            const RESULT_INDEX = 2;

            var self = this;
            var _unidadeDados;
            var _buttonClicked = false;
            var _sqlOriginal = self.sql;
            var _publicAPI = {};

            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFormInterceptor);

            self.$onInit = $onInit;
            self.onDatasetCreated = onDatasetCreated;
            self.gridConfigId = SkApplicationInstance.getResourceID() + ".configParameters";
            self.selectedIndex = QUERY_INDEX;
            self.executarQuery = executarQuery;
            //self.onChange = onChange;
            self.refreshHandler = refreshHandler;
            self.dataChanged = dataChanged;
            self.metadataInterceptor = metadataInterceptor;
            self.insereValor = insereValor;
            self.tipoDadosOpt = [{ data:"0",label:"Texto" },{ data:"1",label:"SQL" },{ data:"2",label:"Entidade/Campo" }]
            self.unidadeDadosOpt = [{}];
            self.visibleForm = false;
            self.onChangeEntidade = onChangeEntidade;
            self.selectedStack = selectedStack;
            self.populaCombo = populaCombo;
            self.getParamsFromQuery = getParamsFromQuery;
            self.getEntidadeCriteria = getEntidadeCriteria;
            self.getCampoCriteria = getCampoCriteria;
            $scope.$success = onSavePopup;
            self.changeValue = changeValue;

            _publicAPI.queryIsChange = queryIsChange;

            function $onInit() {
                self.onCreateComplete({
                    $instance: _publicAPI
                });
            }

            function queryIsChange(){
                return _sqlOriginal != self.sql;
            }

            function onDatasetCreated(dataset) {
                self.dsParameters = dataset;
                self.dsParameters.setEntityDescription('ParametrosSQL');

                self.dsParameters.addDataModifiedListener(function(fieldName){
                    var tipo = self.dsParameters.getFieldValue("TIPO");
                    var tipoEntidadeTexto = self.dsParameters.getFieldValue("TIPODADO");
                    
                    if (fieldName == 'TIPO') {
                        self.visibleForm = true;
                        self.dsParameters.setFieldValue("PARAMETRO", self.dsParameters.getFieldValue("PARAMETRO").toUpperCase());
                        self.dsParameters.save();
                        verificaTipoDados(tipo, tipoEntidadeTexto);
                    } else if(fieldName == 'TIPODADO'){
                        verificaTipoDados(tipo, tipoEntidadeTexto);
                    } else if(fieldName == 'DESCRICAO') {
                        self.populaCombo();   
                    }
                    
                    if(tipo == "D" || tipo == "DP"){
                        if(self.dsParameters.getFieldValue("CURRENTDATE") == 'S' && fieldName == "CURRENTDATE"){
                            self.dsParameters.setFieldValue("SALVAULTVALOR", "N");
                        }else if(self.dsParameters.getFieldValue("SALVAULTVALOR") == 'S' && fieldName == "SALVAULTVALOR"){
                            self.dsParameters.setFieldValue("CURRENTDATE", "N");
                        }
                    }else if(tipo == "S"){
                        if(self.dsParameters.getFieldValue("SALVAULTVALOR") == 'S' && fieldName == "SALVAULTVALOR"){
                            self.dsParameters.setFieldValue("TRUEFALSE", "N");
                        }else if(self.dsParameters.getFieldValue("TRUEFALSE") == 'S' && fieldName == "TRUEFALSE"){
                            self.dsParameters.setFieldValue("SALVAULTVALOR", "N");
                        }
                    }
                    
                    
                });

                self.dsParameters.addDataSavedListener(function (action) {
                    self.dataParameters = self.dsParameters.getRecordsAsObjects();
                    if(!ObjectUtils.isEmpty(self.dataParameters)){
                        self.populaCombo();
                    }
                });
                
                self.dsParameters.beforePostAction(function(){
                    var valor = self.dsParameters.getFieldValue('PARAMETRO');
                    var desc = self.dsParameters.getFieldValue('DESCRICAO');
                    var parameterList = self.dsParameters.getRecordsAsObjects();
                    var resultado = true;


                    ArrayUtils.forEach(parameterList, function (sqlParametro) {
                        if(self.dsParameters.isInsertionMode()) { 
                            if(sqlParametro.PARAMETRO === valor || sqlParametro.DESCRICAO === desc) {
                                
                                MessageUtils.showError(
                                    MessageUtils.TITLE_ERROR,
                                    i18n('Commons.QueryEditor.impossivelAdicionar'));

                                resultado = false;
                                return;

                            } 
                        }

                    })
                    return resultado;
                });

                self.dsParameters.beforeDeleteAction(function(){
                    var retorno;
                    var objCurrentLine = self.dsParameters.getCurrentRowAsObject();
                    var sqlParams = self.getParamsFromQuery();
                    
                    if(!ObjectUtils.isEmpty(sqlParams)){
                        ArrayUtils.forEach(sqlParams, function (sqlParametro) {
                        	if(sqlParametro.replace(':', '') == objCurrentLine.PARAMETRO){
                        		MessageUtils.showError(
                                    MessageUtils.TITLE_ERROR,
                                    i18n('Commons.QueryEditor.impossivelExcluir'));
                        	
                        		retorno = false;
                        		return;
                        	}
                        });
                    }
                    self.dataParameters = self.dsParameters.getRecordsAsObjects();
                    return retorno;
                    
                  });
                
                self.dsParameters.addLineChangeListener(function () {
                    var objCurrentLine = self.dsParameters.getCurrentRowAsObject();
                    if(!ObjectUtils.isEmpty(objCurrentLine)){
                        self.visibleForm = true;
                        verificaTipoDados(objCurrentLine.TIPO, objCurrentLine.TIPODADO);
                    }
                });
     
                self.dsParameters.addRecordRemovedListener(function(registro) {
                    self.dataParameters = self.dsParameters.getRecordsAsObjects();
                    self.populaCombo();
                    if(ObjectUtils.isEmpty(self.dataParameters)){
                        self.variavel = undefined;
                        ocultarFormulario();
                    }
                });

                _unidadeDados = new FieldBinderProxy('UNIDADEDADOS', self.dsParameters, getUnidadeDados, setUnidadeDados);
                _campoDados = new FieldBinderProxy('CAMPO', self.dsParameters, getCampoDados, setCampoDados);
                self.dsParameters.initAndRefresh();
            }
            
            function onChangeEntidade(field){
                if(angular.equals("NUINSTANCIA", field)){
                    _unidadeDados.modify();
                }else if(angular.equals("NUCAMPO", field)){
                    _campoDados.modify();
                }
            }

            function onSavePopup() {
                dataChanged();
            }

            function getUnidadeDados(){
                return self.entityValue;
            }

            function setUnidadeDados(){
                self.entityValue = self.dsParameters.getFieldValue("UNIDADEDADOS");
                $timeout(function(){
                    var pesquisaUnidadeCtrl = AngularUtil.getControllerFromElement(document.getElementById('input-pes-unidade'));
                    if(pesquisaUnidadeCtrl){
                        pesquisaUnidadeCtrl.loadDescription();
                    }
                })
                
            }

            function getCampoDados(){
                return self.campoValue;
            }

            function setCampoDados(){
                self.campoValue = self.dsParameters.getFieldValue("CAMPO");
            }

            function insereValor(){
                if(angular.isDefined(self.variavel)) {
                    
                    var rec = self.dsParameters.getRecordByUniqueId(self.dsParameters.findRecordIndexByPk({PARAMETRO: self.variavel}));

                    if(angular.isArray(rec)){
                        if(rec[2] == "DP"){
                            self.variavel = rec[0]+'.INI AND :'+rec[0]+'.FIN';
                        }
                    }

                    if(angular.isDefined(self.sql)){
                        self.sql = self.sql + ":" + self.variavel;
                    } else {
                        self.sql = ":" + self.variavel;
                    }
                   
                    self.variavel = rec[0];
                }
            }
            
           function metadataInterceptor(fields) {
                if (fields) {
                    ArrayUtils.forEach(fields, function (fm) {
                        if ('@UNIDADEDADOS@CURRENTDATE@CHARLIMIT@DEFAULTVALUE@STARTVALUE@ENDVALUE@TRUEFALSE@TIPODADO@TIPODADOTEXT@DECIMALS@CAMPO@SALVAULTVALOR@'.indexOf('@' + fm.name + '@') > -1){
                            fm.visible = false;
                        }
                        
                        if('@PARAMETRO@DESCRICAO@TIPO@TIPODADO@'.indexOf('@' + fm.name + '@') > -1) {
                            fm.required = true;
                        }
                        
                        if(fm.name == 'UNIDADEDADOS'){
                            fm.entityPath = "Instancia";
                        }
                        
                        if(fm.name == 'TIPO' || fm.name == 'DESCRICAO'){
                            fm.isNullable = false;
                        }
                    });
                }
            } 
            
          
            function refreshHandler(request) {
                if(angular.isDefined(self.dataParameters) && ArrayUtils.isNotEmpty(self.dataParameters) ){
                    var objSqlParams = JSON.parse(Base64.decode(Base64.decode(self.dataParameters)));
                    if(!ObjectUtils.isEmpty(objSqlParams)){
                        ArrayUtils.forEach(objSqlParams, function (objConteudo) {
                            var record = { data: objConteudo.PARAMETRO, value: objConteudo.DESCRICAO };
                            self.unidadeDadosOpt.push(record);
                        });
                        if(!ObjectUtils.isEmpty(self.unidadeDadosOpt)){
                            self.variavel = '';
                        }
                        self.dataParameters = objSqlParams;
                        return objSqlParams;
                    }
                } else { 
                    var params = self.getParamsFromQuery();
                    var paramList = [];
                    var paramName;
                    var record;

                    self.variavel = undefined;

                    if(!ObjectUtils.isEmpty(params)){
                        ArrayUtils.forEach(params, function (objConteudo) {
                            paramName = objConteudo.replace(':', '');
                            record = { DESCRICAO: paramName, PARAMETRO: paramName, TIPO: "W" };
                            paramList.push(record);   
                        })
                        self.populaCombo();
                    }
                  
                    self.dataParameters = paramList;
                    return paramList;
                }
            }

            function getParamsFromQuery(){
                var arrayParametros = [];
                var sql = StringUtils.undefinedAsEmpty(self.sql).replace(/\/\*[\s\S]*?\*\/|--[\s\S]*?$/mg, ""); // Remove comentários da Query
                sql = sql.trim().toUpperCase();
                var sqlParams = StringUtils.undefinedAsEmpty(sql).match(/'?%?((\$(N|T|D)\{.+\})|(\B:(@|#)?\b\w+(\.\w+)?\b))%?'?/gi);

                if(!StringUtils.isEmpty(sqlParams)){
                    var sqlParamIni;
                    var sqlParamFim;
                    ArrayUtils.forEach(sqlParams, function (sqlParam) {
                        if(!ObjectUtils.isEmpty(sqlParam.match(".INI"))){
                            sqlParamIni = sqlParam.replace('.INI', '');
                        }else if(!ObjectUtils.isEmpty(sqlParam.match(".FIN"))){
                            sqlParamFim = sqlParam.replace('.FIN', '');
                        }else{
                            arrayParametros.push(sqlParam);
                        }
                    });

                    if(angular.isDefined(sqlParamIni) && angular.isDefined(sqlParamFim) && (sqlParamIni == sqlParamFim)){
                        arrayParametros.push(sqlParamIni);
                    }
                }
                return arrayParametros;
            }
            
            function populaCombo(){
                // Esvazia o combobox
                self.unidadeDadosOpt = [{}];
                // Cria um objeto com os parâmetros da query
                var sqlPrm = self.getParamsFromQuery(); 
                // Cria um objeto com os parâmetros do Dataset (Grid)
                var conteudo = self.dsParameters.getRecordsAsObjects(); 

                // Verifica se a query não possui parâmetros, mas a grid sim.
                if(ObjectUtils.isEmpty(sqlPrm) && !ObjectUtils.isEmpty(conteudo)){
                    ArrayUtils.forEach(conteudo, function (objConteudo) {
                        var record = { data: objConteudo.PARAMETRO, value: objConteudo.DESCRICAO };
                        self.unidadeDadosOpt.push(record);
                    });  
                }
                else if(!ObjectUtils.isEmpty(sqlPrm) && ObjectUtils.isEmpty(conteudo)){
                    ArrayUtils.forEach(sqlPrm, function (objPrm) {
                        var paramName = objPrm.replace(':', '');
                        var record = { data: paramName, value: paramName };
                        self.unidadeDadosOpt.push(record);
                    });  
            
                }else{
                    ArrayUtils.forEach(conteudo, function (objConteudo) {
                        var record = { data: objConteudo.PARAMETRO, value: objConteudo.DESCRICAO };
                        self.unidadeDadosOpt.push(record);
                    });  
                    //self.unidadeDadosOpt = undefined;
                }
                self.variavel = '';
            }

            function dataChanged() {
                if (angular.isDefined(self.dsParameters)) {
                    var nomParam;
                    var sqlParams = self.getParamsFromQuery();

                    if (!ObjectUtils.isEmpty(sqlParams)) {
                        ArrayUtils.forEach(sqlParams, function (sqlParametro) {
                            nomParam = sqlParametro.replace(':', '');


                            var index = self.dsParameters.findRecordIndexByPk({ PARAMETRO: nomParam.toUpperCase() });
                            if (index < 0) {
                                self.dsParameters.addRecordsAsObjects({ PARAMETRO: nomParam.toUpperCase(), TIPO: "W", DESCRICAO: nomParam.toUpperCase() });
                                self.dataParameters = self.dsParameters.getRecordsAsObjects();

                                self.populaCombo();

                            }
                        });

                    }
                }
            }

            function ocultarFormulario(){
                self.visibleUnidadeDados = false;
                self.visibleSalvaUltValor = false;
                self.visibleCurrentDate = false;
                self.visibleCharLimit = false;
                self.visibleDefaultVal = false;
                self.visibleStartVal = false;
                self.visibleEndVal = false;
                self.visibleDecimals = false;
                self.visibleTrueFalse = false;
                self.visibleTipoDado = false;
                self.visibleTipoDadoText = false;
                self.visibleCampoEntidade = false;
                self.visibleFormEntidade = false;
                self.visibleUnidadeDados = false;
                self.visibleCampoEntidade = false;
            }

            function verificaTipoDados(tipo, tipoEntidadeOuTexto){
                ocultarFormulario();

                switch (tipo) {
                    case 'ENTITY':
                        self.visibleFormEntidade = true;
                        self.visibleUnidadeDados = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'DP':
                        self.visibleCurrentDate = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'D':
                        self.visibleCurrentDate = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'W':
                        self.visibleCharLimit = true;
                        self.visibleDefaultVal = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'I':
                        self.visibleStartVal = true;
                        self.visibleDefaultVal = true;
                        self.visibleEndVal = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'F':
                        self.visibleStartVal = true;
                        self.visibleDefaultVal = true;
                        self.visibleEndVal = true;
                        self.visibleDecimals = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'S':
                        self.visibleTrueFalse = true;
                        self.visibleSalvaUltValor = true;
                        break;
                    case 'O':
                        self.visibleTipoDado = true;
                        self.visibleSalvaUltValor = true;
                        verificaEntidadeOuCampo(tipoEntidadeOuTexto);
                        break;
                    //Esse caso será realizado posteriormente pois o campo CHECKLIST não possui diretiva para entidade
                    /*case 'CHECKLIST':
                        self.visibleTipoDado = true;
                        self.visibleSalvaUltValor = true;
                        verificaEntidadeOuCampo(tipoEntidadeOuTexto);
                        break;*/
                }
            }

            function verificaEntidadeOuCampo(tipoEntidadeOuTexto){
                if(angular.equals("C", tipoEntidadeOuTexto)){
                    self.visibleUnidadeDados = true;
                    self.visibleTipoDadoText = true;
                } else if(angular.equals("ENTITY", tipoEntidadeOuTexto)){
                    self.visibleFormEntidade = true;
                    self.visibleUnidadeDados = true;
                    self.visibleCampoEntidade = true;
                }
            }

            function getEntidadeCriteria(){
                return Criteria('this.NUINSTANCIAPAI IS NULL');
			}
			
			function getCampoCriteria(){
                var entityName = self.entityValue;
                return Criteria('this.NOMETAB = (SELECT NOMETAB FROM TDDINS WHERE NUINSTANCIA = ?)', Criteria.buildStringParameter(entityName));
			}

            function selectedStack() {
                dataChanged(); 
                if(self.selectedIndex == RESULT_INDEX && !_buttonClicked){
                    executarQuery(false);
                } else {
                    _buttonClicked = false;
                }
            }
            
            function executarQuery(isButton) {
                dataChanged();

                if(isButton) {
                    _buttonClicked = true;
                }
                
                var sql = StringUtils.undefinedAsEmpty(self.sql).replace(/\/\*[\s\S]*?\*\/|--[\s\S]*?$/mg, ""); // Remove comentários da Query
                sql = sql.trim();

                if (!sql.toUpperCase().startsWith("SELECT")) {
                    MessageUtils.showAlert(i18n("Commons.QueryEditor.titleErro"), i18n("Commons.QueryEditor.erroInicioQuery"));
                    return;
                }

                if (sql.search(/\bupdate\b|\binsert\b/img) > -1) {
                    MessageUtils.showAlert(i18n("Commons.QueryEditor.titleErro"), i18n("Commons.QueryEditor.erroCommando"));
                    return;
                }

                QueryParams.buildParams(sql, self.dsParameters.getRecordsAsObjects(), undefined, self.savedParamsId)
                    .then(function (param) {
                        executarServicoQuery(sql, self.dataSource, param);
                    });
            }

            function onChange(id) {
                if (id == RESULT_INDEX) {
                    executarQuery();
                }
            }

            function executarServicoQuery(query, ds, param) {
                ServiceProxy.callService('ExecQuerySP.execQuery', {
                    querydata: {
                        query: query,
                        ds: ds,
                        param: param,
                        normalize: "S"
                    }
                }).then(
                    function (result) {
                        var erro = ObjectUtils.getProperty(result, 'responseBody.queryExecResult.ERRO');

                        if (angular.isDefined(erro)) {
                            MessageUtils.showError(i18n("Commons.QueryEditor.titleErro"), erro);
                            return;
                        }

                        var columnDefs = [];
                        var rowData = [];

                        var metadata = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.metadata.column'));

                        metadata.forEach(function (column) {
                            columnDefs.push({
                                headerName: column.name,
                                field: column.name
                            });
                        });

                        var line = ArrayUtils.toArray(ObjectUtils.getProperty(result, 'responseBody.entity.line'));

                        line.forEach(function (line) {
                            var row = {};

                            var column = ArrayUtils.toArray(line.column);

                            column.forEach(function (column) {
                                row[column.name] = column.value;
                            });

                            rowData.push(row);
                        });

                        self.gridOptions = {
                            columnDefs: columnDefs,
                            rowData: rowData,
                            defaultColDef: {
                                editable: false,
                                suppressMenu: true
                            },
                            toolPanelSuppressSideButtons: true
                        };

                        angular
                            .element(document.getElementById('ag-grid-result'))
                            .replaceWith(AngularUtil.compile('<sk-ag-grid id="ag-grid-result" sk-grid-options="ctrl.gridOptions" sk-height="310px"></sk-ag-grid>', $scope));

                        if(self.selectedIndex != RESULT_INDEX){
                            self.selectedIndex = RESULT_INDEX;
                        }
                    });
            }

           function changeValue(value) {
                $rootScope.$emit('codeFieldChanged', value);
            }
        }]);

angular
     .module('snk.commons.queryEditor')
     .service('QueryParams', function (SanPopup, i18n, $q, StringUtils, MessageUtils) {
        return {
            buildParams: function (sql, objParams, isName, savedParamsId) {
                return $q(function (resolve, reject) {
                    var sqlParams = StringUtils.undefinedAsEmpty(sql.toUpperCase()).match(/'?%?((\$(N|T|D)\{.+\})|(\B:(@|#)?\b\w+(\.\w+)?\b))%?'?/gi);

                    if (sqlParams) {
                        var setParm = {};
                        var params = [];

                        for (let i = 0; i < sqlParams.length; i++) {
                            var name = sqlParams[i].replace(':', '');
                            if (angular.isUndefined(setParm[name])) {
                                params.push({ name: name });
                                setParm[name] = '=';
                            }
                        }

                        SanPopup.open({
                            title: i18n('Commons.QueryEditor.titleParams'),
                            templateUrl: 'commons/queryEditor/query-params-popup.tpl.html',
                            controller: 'queryParamsController',
                            controllerAs: 'ctrl',
                            showBtnNo: false,
                            noBtnLabel: i18n('Commons.QueryEditor.buttonCancelar'),
                            height: 200,
                            resolve: {
                                data: {
                                    params: params,
                                    objParams: objParams,
                                    savedParamsId: savedParamsId
                                }
                            }
                        }).result.then(function (result) {
                            var params = result.params;
                            if(isName){
                                resolve(params);
                            }else{
                                var values = [];
                                for (var i = 0; i < sqlParams.length; i++) {
                                    for (var j = 0; j < params.length; j++) {
                                        var name = sqlParams[i].replace(':', '');
                                        if (params[j].name == name) {
                                        	var value = params[j].value;
                                        	var type = params[j].type;
                                        	var objstr = params[j].value;
                                        	
                                        	if (angular.isArray(value) && value.length > 0) {
                                        		type = 'IN';
                                        		objstr = '';
                                        		value.forEach(function(obj,idx, array){
                                        			objstr += "'"+(obj)+"'";
                                        			if (idx != array.length - 1){
                                        				objstr += ",";
                                        			}
                                        		});
                                        	}
                                        	
                                            values.push({ value: objstr, type: type, name: name });
                                            break;
                                        }
                                    }
                                }
                                resolve(values);
                            }
                        });
                    } else {
                        resolve();
                    }
                });
            }
        };
    })
     .controller('queryParamsController', ['i18n', 'data', 'MessageUtils', '$popupInstance', '$scope', 'DateUtils', 'NumberUtils', 'ArrayUtils', 'StringUtils', 'SkPesquisaService', 'SkApplicationInstance', 'ObjectUtils', '$q',
          function(i18n, data, MessageUtils, $popupInstance, $scope, DateUtils, NumberUtils, ArrayUtils, StringUtils, SkPesquisaService, SkApplicationInstance, ObjectUtils, $q) { 
            var self = this; 
            
            self.params = data.params;
            self.objParams = data.objParams;
            self.formParams = [];
            $scope.$success = onSavePopup;

            var _nameEntity;
            var _pkEntity;
            var _chave = data.savedParamsId;
            var _arrayParams = [];
            
            init();
            function init(){
                var configPopup = SkApplicationInstance.getConfiguracaoTela(_chave);

                if(angular.isDefined(configPopup)){
                    createForm();
                } else {
                    SkApplicationInstance.loadMgeConfig(_chave).then(function (data) {
                        SkApplicationInstance.putConfiguracaoTela(_chave, data.config);
                        createForm();
                    });
                }
            }

            function createForm() {
                self.formParams = [];

                self.params.forEach(function (par){
            		self.objParams.forEach(function(obj){
                        var paramNamePeriodo;
                        if(par.name.endsWith(".INI")){
                            paramNamePeriodo = par.name.replace('.INI', '');
                        }

            			if(par.name == obj.PARAMETRO || obj.PARAMETRO == paramNamePeriodo){
                            var valor = obj.DEFAULTVALUE ? obj.DEFAULTVALUE : obj.TRUEFALSE;
                            var options = [];

                            if(obj.SALVAULTVALOR == 'S'){
                               valor =  carregaDadosUltimoValor(obj.PARAMETRO);
                            }

                            if(obj.CURRENTDATE == 'S'){
                                valor = DateUtils.getToday();
                                if(obj.TIPO == 'DP'){
                                    valor = {dtIni: valor, dtFin: valor};
                                }
                            }

                            var properties = {
                                description : obj.DESCRICAO,
                                fieldName : obj.PARAMETRO,
                                type : obj.TIPO,
                                value : valor,
                                presentationType: obj.TIPO,
                                fieldProp: {
                                    'sk-entity-name': _nameEntity,
                                    'sk-field-name': _pkEntity,
                                    'sk-precision': obj.DECIMALS,
                                    'sk-size': obj.CHARLIMIT,
                                    'sk-options': options,
                                    'sk-label': obj.DESCRICAO},
                                required: 'S',
                                saveLastValue: obj.SALVAULTVALOR
                            };  

                            populaform(obj, properties); 

                            _arrayParams.push(obj);
            			}
            		})
                });
            }

            function populaform(obj, properties, deferred){
                if(obj.TIPODADO == 'C' && obj.TIPODADOTEXT){
                    options = toArrayOption(obj.TIPODADOTEXT, "\n", "=");
                    properties.fieldProp["sk-options"] = options;
                    self.formParams.push(properties);
                }else if(obj.TIPO == 'ENTITY'){
                    SkPesquisaService.loadSuggestionsByPk("Instancia", obj.UNIDADEDADOS, undefined, undefined, undefined)
                    .then(function (entity) {
                        _nameEntity = entity.data[0].NOMEINSTANCIA;
                        _pkEntity = entity.pkField;
                        
                        properties.fieldProp["sk-entity-name"] = _nameEntity;
                        properties.fieldProp["sk-field-name"] = _pkEntity;
                        
                        self.formParams.push(properties);
                    });
                }else if(obj.TIPO == "O" && obj.TIPODADO == 'ENTITY'){
                    SkPesquisaService.loadSuggestionsByPk("Campo", obj.CAMPO, undefined, undefined, undefined)
                        .then(function (entity) {
                            var _tableName = entity.data[0].NOMETAB;
                            var _nameCampo = entity.data[0].NOMECAMPO;

                            var objeto = {
                                descriptionField: _nameCampo,
                                keyField: _nameCampo,
                                query: 'SELECT ' +_nameCampo+ ' FROM ' + _tableName 
                            }

                            properties.fieldProp["sk-options-from-query"] = objeto;
                            self.formParams.push(properties);
                    });
                }else {
                    self.formParams.push(properties);
                }
            }

            function returnEntity(obj){
               /* SkPesquisaService.loadSuggestionsByPk("Instancia", obj.UNIDADEDADOS, undefined, undefined, undefined)
                    .then(function (entity) {
                        _nameEntity = entity.data[0].NOMEINSTANCIA;
                        _pkEntity = entity.pkField;
                        
                        properties.fieldProp["sk-entity-name"] = _nameEntity;
                        properties.fieldProp["sk-field-name"] = _pkEntity;
                        
                        _arrayAux.push(properties);*/
                        
                var deferred = $q.defer();
                SkPesquisaService.loadSuggestionsByPk("Instancia", obj.UNIDADEDADOS, undefined, undefined, undefined)
                    .then(function(entity){
                        _nameEntity = entity.data[0].NOMEINSTANCIA;
                        _pkEntity = entity.pkField;
                        deferred.resolve(buildProperties());
                    });
    
                return deferred.promise;
            };

            function buildProperties(){
                return {
                    entityName: _nameEntity,
                    pkEntity: _pkEntity
                };
            }

            $scope.$success = onSavePopup;

            function onSavePopup() {
                var validRequiredParam = false;
                var rangeValidado = true;

                var config = {
                    params: {}
                };
                
                for (let i = 0; i < self.params.length; i++) {
                    var param = self.params[i];
                    var paramName = param.name;

                    var sqlParamIni;
                    var sqlParamFin;
                    if(paramName.endsWith(".INI")){
                        sqlParamIni = paramName.replace('.INI', '');
                    }else if(paramName.endsWith(".FIN")){
                        sqlParamFin = paramName.replace('.FIN', '');
                    }

                    self.formParams.forEach(function(obj){
                        if(obj.fieldName == paramName || sqlParamIni == obj.fieldName || sqlParamFin == obj.fieldName){
                            var value = obj.value;
                            var type = obj.type;

                            if(obj.type == 'DP'){
                                var paramPeriod = sqlParamIni != undefined ? sqlParamIni : sqlParamFin;
                                config.params[paramPeriod] = {'type': obj.type, 'dtIni': value.dtIni, 'dtFin': value.dtFin};
                                if(paramName.endsWith(".INI")){
                                    value = value.dtIni;
                                }else if(paramName.endsWith(".FIN")){
                                    value = value.dtFin;
                                }
                            }

                            if (obj.required === 'S' && StringUtils.isEmpty(value)) {
                                    validRequiredParam = true;
                            }else{
                                //Verifica se o valor inserido está dentro do valor inicial e final para casos que tenha
                                _arrayParams.forEach(function (obj){
                                    if(paramName == obj.PARAMETRO && (angular.isDefined(obj.STARTVALUE) || angular.isDefined(obj.ENDVALUE))){
                                        if((value < obj.STARTVALUE) || (value > obj.ENDVALUE)){
                                            rangeValidado = false;
                                        }
                                    }
                                });

                                if(rangeValidado){
                                    if('@D@T@DP@'.indexOf('@' + type + '@') > -1){
                                        value = DateUtils.dateToString(value);
                                        type = 'D';
                                    }else if('@F@DC@'.indexOf('@' + type + '@') > -1) {
                                        type = 'N';
                                    }else{
                                        type = 'T';
                                        value = value.toString();
                                    }
                                    
                                    param.value = value;
                                    param.type = type;
                                    
                                    if(obj.saveLastValue == 'S' && obj.type != 'DP'){
                                        config.params[paramName] = {'type': obj.type, 'value': value};
                                    }
                                }
                            }
                        }
                    });
                }

                salvaUltimoValor(config);

                if (validRequiredParam) {
                	MessageUtils.showAlert(i18n('Commons.QueryEditor.preenchaCampoObrigatorio'));
                }else if(!rangeValidado){
                    MessageUtils.showAlert(i18n('Commons.QueryEditor.valorForaDeFaixa'));
                }else {
                	$popupInstance.success({params: self.params});
                }
            }

            function salvaUltimoValor(config){
                if(angular.isDefined(config)){
                    SkApplicationInstance.saveMgeConfig(_chave, config).then(
                        function () {
                            SkApplicationInstance.putConfiguracaoTela(_chave, config);
                        }
                    );
                }
            }

            function carregaDadosUltimoValor(paramName){
                var valor;
                var config = SkApplicationInstance.getConfiguracaoTela(_chave);

                if (angular.isDefined(config)) {
                    var param = config.params[paramName];
                    if (angular.isDefined(param)) {
                        if (param.type = 'DP') {
                            valor = {dtIni: DateUtils.formatDate(param.dtIni), dtFin: DateUtils.formatDate(param.dtFin)};
                        } else {
                            valor = param.value;
                        }
                    }
                }
                return valor;
            }
            
            function toArrayOption(str, regex1, regex2) {
            	var options = [];
            	if (StringUtils.isNotEmpty(str)) {
                    str.split(regex1).forEach(function(item){
                    	var option = item.split(regex2);
                        options.push({data: option[0], value: option.length > 1 ? option[1] : option[0]});
                    });
            	}
            	return options;
            }
     }]);
angular
    .module('snk.commons.rateio')
    .controller('InformacoesRateioPopUpController', [ 'dataValue', 'ServiceProxy',
        function ( dataValue, ServiceProxy) {
            var self = this;

            var _nuFin = dataValue.nuFin;
            var _valorDesdob = dataValue.vlrDesdob;
            var _strCodParc = dataValue.strCodParc;
            var _origem = "F";

            self.onLoadRateioPanel = onLoadRateioPanel;

            function onLoadRateioPanel(rateioPanel) {
                self.rateioPanel = rateioPanel;
                completePopUp();
            }

            function completePopUp() {
                var expressao = "((NUFIN = " + _nuFin +" AND ORIGEM = 'F')";
                expressao += " OR (NUFIN = (SELECT NUNOTA FROM TGFFIN WHERE NUFIN=" + _nuFin + ") AND ORIGEM='E'))";

                var params = {
                    entity: {
                        name: "RateioRecDesp",
                        literalCriteria: {
                            expression: {$: expressao}
                        },
                        fields: {
                            field: [
                                {name:"NUFIN"},
                                {name:"ORIGEM"}
                            ]
                        }
                    }
                };

                ServiceProxy.callService("mge@crud.find", params).then(function (result) {
                    var rateio = result.responseBody.entidades.entidade;
                    if (angular.isDefined(rateio)) {
                        if (Array.isArray(rateio)) {
                            _nuFin = rateio[0].NUFIN.$;
                            _origem = rateio[0].ORIGEM.$;
                        } else {
                            _nuFin = rateio.NUFIN.$;
                            _origem = rateio.ORIGEM.$;
                        }
                    }

                    self.paramentrosRateioPanel = {
                        NUFIN : _nuFin,
                        ORIGEM : _origem,
                        VLRDESDOB : _valorDesdob
                    };

                    self.rateioPanel.putParamParaRateio(self.paramentrosRateioPanel);
                    self.rateioPanel.atualizarRateio();

                    self.numeroUnico = _nuFin;
                    self.pesqParceiro = _strCodParc;
                    self.numValor = _valorDesdob;
                });

            }
        }]);
angular
	.module('snk.commons.rateio')
	.service('InformacoesRateioPopUp', ['SanPopup',
		function (SanPopup) {
			var self = this;

			self.openPopUp = openPopUp;

			function openPopUp(title, popupInfo) {
				return SanPopup.open({
					title: title,
					templateUrl: 'commons/rateio/popup/informacoesrateiopopup.tpl.html',
					controller: 'InformacoesRateioPopUpController',
					controllerAs: 'ctrl',
					showBtnOk: false,
					showBtnNo: false,
					showBtnCancel: true,
					size: 'lg',
					height: 580,
					resolve: {
						dataValue : popupInfo
					}
				});
			}
		}
    ]);
angular
    .module('snk.commons.rateio')
    .controller('RateioPopUpController', [ 'dataValue', '$scope', 'ServiceProxy', 'SkApplicationInstance', '$popupInstance',
        function ( dataValue, $scope, ServiceProxy, SkApplicationInstance, $popupInstance) {
            var self = this;

            self._notaRateada = dataValue.notaRateada;
            self.pesqCriterioRateio = dataValue.codCriterio;
            self.habilitaConfirma = habilitaConfirma;
            self.onLoadRateioPanel = onLoadRateioPanel;
            self.atualizarCriterioRateio = atualizarCriterioRateio;
            self.finishRateio = finishRateio;

            $scope.$enableBtnOk = false;
            $scope.$success = confirmarRateio;

            self.rateioPanel;
            self._temCentroResultado;
            self.paramentrosRateioPanel;
            self.codSite;
            self.DESCRNAT;
            self.DESCRCENCUS;
            self.DESCRPROJ;
            self.ehInformativo = angular.isDefined(dataValue.ehAlteravel) ? !dataValue.ehAlteravel : false;

            function init() {
                if (SkApplicationInstance.isJivaW() && !SkApplicationInstance.temOpcional("20444")) {
                    self._temCentroResultado = false;
                }
                
                getCodNat();
                getCodCenCus();
                getCodProj();
                createParameters();

                if (dataValue.nuFin != undefined && dataValue.origem == "F" || dataValue.nuNota != undefined && dataValue.origem == "E") {
                    var expressao="";
                    if (dataValue.origem == "F") {
                        expressao += "ORIGEM <> 'F' AND NUFIN = " + dataValue.nuFin;
                        validaRateio(expressao);
                    } else {
                        var serviceExpression = "NUNOTA = " + dataValue.nuNota;
                        var parametros = {
                            'entity': { 
                            	'name': "Financeiro",
                            	'literalCriteria': { 
                            		'expression': { $: serviceExpression }
                            	},
                            	'fields': { 
                            		'field': { 'name':  "NUFIN" } 
                            	} 
                            } 
                        };

                        ServiceProxy.callService(
                            "mge@crud.find", parametros).then(function (result) {
                                expressao = "ORIGEM = 'F' AND NUFIN IN (";
                                var contador = 0;
                                var entidades = result.responseBody.entidades;
                                if(angular.isDefined(entidades)){
                                    entidades.entidade.forEach(function (element) {
                                        if (contador > 0) {
                                            expressao += ","
                                        }
                                        expressao += element.NUFIN.$;
                                        contador = contador + 1;
                                    });
                                    expressao += ")";
                                    if (contador > 0) {
                                        validaRateio(expressao);
                                    } else {
                                        createParameters();
                                        self.rateioPanel.putParamParaRateio(self.paramentrosRateioPanel);
                                        self.rateioPanel.atualizarRateio();
                                    }
                                }
                            })
                    }
                } else {
                    createParameters();
                    self.rateioPanel.putParamParaRateio(self.paramentrosRateioPanel);
                    self.rateioPanel.atualizarRateio();
                }

            }
            // Função responsável por habilitar/dasabilitar o botão confirmar
            function habilitaConfirma(btnEnable){
                if(btnEnable != undefined){
                    $scope.$enableBtnOk = btnEnable;
                }
            }
            
            function onLoadRateioPanel(rateioPanel) {
                self.rateioPanel = rateioPanel;
                init();
            }

            function validaRateio(expressao) {
            	var parametros = {
                        'entity': {
                            'name': "RateioRecDesp",
                            'literalCriteria': {
                                'expression': { $: expressao }
                            },
                            'fields': {
                                'field': { 'name': 'NUFIN' }
                            }
                        }
                    };
                ServiceProxy.callService("mge@crud.find", parametros).then(function (result) {
                	let entidade = result.responseBody.entidades?.entidade?result.responseBody.entidades?.entidade.length > 0:result.responseBody.entidades;
                		if (entidade) {
                            if (dataValue.origem == "F") {
                                createParameters();
                                self.rateioPanel.putParamParaRateio(self.paramentrosRateioPanel);
                                self.rateioPanel.atualizarRateio();
                            }
                        } else {
                            createParameters();
                            self.rateioPanel.putParamParaRateio(self.paramentrosRateioPanel);
                            self.rateioPanel.atualizarRateio();
                        }
                	
                })
            }

            // Função responsável em buscar a descrição do CODNAT
            function getCodNat() {
                var expressao = "CODNAT = " + dataValue.codNat;
                var parametros = {
                    'entity': { 
                    	'name': "Natureza",
                    	'literalCriteria': { 
                    		'expression': { $: expressao }
                    	},
                    	'fields': { 
                    		'field': { 'name': "DESCRNAT" } 
                    	} 
                    }
                };

                ServiceProxy.callService(
                    "mge@crud.find", parametros).then(function (result) {
                        if(result.responseBody.entidades.entidade.DESCRNAT){
                            self.DESCRNAT = result.responseBody.entidades.entidade.DESCRNAT.$
                        }
                    })
            }

            // Função responsável em buscar a descrição do CODCENCUS
            function getCodCenCus() {
                var expressao = "CODCENCUS = " + dataValue.codCenCus;
                var parametros = {
                    'entity': { 
                    	'name': "CentroResultado",
                    	'literalCriteria': { 
                    		'expression': { $: expressao }
                    	},
                    	'fields': { 
                    		'field': { 'name': "DESCRCENCUS" } 
                    	}
                    } 
                };

                ServiceProxy.callService(
                    "mge@crud.find", parametros).then(function (result) {
                        if(result.responseBody.entidades.entidade.DESCRCENCUS){
                            self.DESCRCENCUS = result.responseBody.entidades.entidade.DESCRCENCUS.$
                        }
                    })

            }

            // Função responsável em buscar a descrição do CODPROJ
            function getCodProj() {
                if (dataValue.codProj == undefined) {
                    return
                }
                var expressao = "CODPROJ = " + dataValue.codProj;
                var parametros = {
                    'entity': { 
                    	'name': "Projeto",
                    	'literalCriteria': { 
                    		'expression': { $: expressao }
                    	},
                    	'fields': { 
                    		'field': { 'name': "IDENTIFICACAO" } 
                    	} 
                    }
                };

                ServiceProxy.callService(
                    "mge@crud.find", parametros).then(function (result) {
                        if(result.responseBody.entidades.entidade.IDENTIFICACAO){
                            self.DESCRPROJ = result.responseBody.entidades.entidade.IDENTIFICACAO.$
                        }
                    })
            }

            // Função responsável pela preparação dos parâmetros utilizados no RateioPanel
            function createParameters() {
            	self.rateioPanel.putParamParaRateio("CODCRITERIO", self.pesqCriterioRateio);
				self.rateioPanel.putParamParaRateio("NUFIN", self._notaRateada ? dataValue.nuNota : dataValue.nuFin);
				self.rateioPanel.putParamParaRateio("ORIGEM", self._notaRateada ? "E" : dataValue.origem);
				self.rateioPanel.putParamParaRateio("VLRDESDOB", dataValue.valorTotalDesdob);
				self.rateioPanel.putParamParaRateio("CODNAT", dataValue.codNat);
				self.rateioPanel.putParamParaRateio("CODCENCUS", dataValue.codCenCus);
				self.rateioPanel.putParamParaRateio("CODPROJ", dataValue.codProj);
				self.rateioPanel.putParamParaRateio("CODSITE", self.codSite);
				self.rateioPanel.putParamParaRateio("DESCRNAT", self.DESCRNAT);
				self.rateioPanel.putParamParaRateio("DESCRCENCUS", self.DESCRCENCUS);
				self.rateioPanel.putParamParaRateio("DESCRPROJ", self.DESCRPROJ);
				self.rateioPanel.putParamParaRateio("ISTIPDESPESA", dataValue.isTipDespesa);
				self.rateioPanel.putParamParaRateio("TIPDESPESA", dataValue.tipDespesa);
            }

            function confirmarRateio() {
                self.rateioPanel.confirmarRateio();
            }
            
            function finishRateio() {
            	if (dataValue.finishHandler) {
            		dataValue.finishHandler();
            	}
                $popupInstance.success();
            }

            function atualizarCriterioRateio(item){
                createParameters();
                self.rateioPanel.notGraphics(self.pesqCriterioRateio);
                self.rateioPanel.atualizarRateio();
                self.rateioPanel.atualizarGrafico();
			}

        }]);
angular
	.module('snk.commons.rateio')
	.service('RateioPopUpService', ['SanPopup', 'i18n',
		function (SanPopup, i18n) {
			var self = this;

			self.openPopUp = openPopUp;

			function openPopUp(title, popupInfo) {
				if (angular.isDefined(popupInfo) && angular.isDefined(popupInfo.title)) {
					title = popupInfo.title;
				} else {
					title = title + ' ' + popupInfo.nuFin
				}
				
				return SanPopup.open({
					title: title,
					templateUrl: 'commons/rateio/popup/rateiopopup.tpl.html',
					controller: 'RateioPopUpController',
					controllerAs: 'ctrl',
					okBtnLabel: i18n('Commons.Rateio.buttonConfirmar'),
					showBtnOk: true,
					showBtnNo: false,
					showBtnCancel: true,
					size: 'lg',
					height: 480,
					resolve: {
						dataValue : popupInfo
					}
				});
			}
		}
    ]);
/**
 * Created by vinicius.fernandes and igor.peres and italo.araujo on 13/12/2019.
 */
angular
    .module("snk.commons.rateio")
    .controller("SkRateioPanelController", ["ObjectUtils", "$scope", "$timeout", "ArrayUtils", "StringUtils", "NumberUtils", "DateUtils", "SkApplicationInstance", "MGEParameters", "ServiceProxy", "MessageUtils", "$document", "i18n", "TooltipBuilder", 'DoubleFacePanelConstants', 'Criteria', 'GridConfigInstance','AngularUtil','SkPesquisaService',
        function (ObjectUtils, $scope, $timeout, ArrayUtils, StringUtils, NumberUtils, DateUtils, SkApplicationInstance, MGEParameters, ServiceProxy, MessageUtils, $document, i18n, TooltipBuilder, DoubleFacePanelConstants, Criteria, GridConfigInstance, AngularUtil, SkPesquisaService) {
            var self = this;

            // Declaração dos interceptors
            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);

            // Variáveis
            var CRITERIO_RATEIO_MODE = "criterioRateio";
            var RATEIO_FINANCEIRO_MODE = "rateioFinanceiro";
            var PRECISAO_VALOR_PORCENTAGEM = 6;
            var PRECISAO_VALOR_DECIMAL = 2;

            var _rateioMode = $scope.rateioMode;
            var _somenteInformativo = $scope.ehInformativo
            var _paramsParaRateio = {};
            var _rateioContrato = true;
            var _rateioParceiro = true;
            var _temCentroResultado = true;
            var _initializingGrid = false;

            var _ehCadastro = $scope.ehCadastro
            var _mostrarToolTip = false;
            var _rateioPorVeiculo = false;
            var _parentDataSet = undefined;
            var _afericaoAtual;
            var _codCentroCusStr;
            var _tipoAfericao;
            var _codVeiculoAtual;

            var RESOURCE_ID = SkApplicationInstance.getResourceID();
            var IS_JIVA = SkApplicationInstance.isJivaW();
            var TELA_OPCIONAL_20444 = SkApplicationInstance.temOpcional("20444");

            var PROPRIEDADE_TEM_RAT_SEM_RAV = SkApplicationInstance.getRuntimeProperty('temRatSemRav');
            var RESOURCE_ID_CRITERIO = "br.com.sankhya.fin.cad.criteriosRateio";
            var _notGraphic = false;
            var _curRowIndexAfterConfirm = 0;

            self.isRateioVeiculo = false;
            self.visibleBtnConfirm = false;
            self.showBtnExcluir = $scope.showBtnExcluir 
            self.btnExcluirDisabled = false;
            self.loadingParameters = false;
            self.enableCentroResultado = true;
            self.gridConfig = self.resourceID + '.gridRateio';
            self.showBtnCopiar = $scope.showBtnCopiar; 
            self.mostrarInfoVlrRateio = true;

            // Ordenação do form
            self.fieldsFormOrder = ['VLRRATEIO', 'PERCRATEIO', 'CODVEICULO', 'Veiculo.MARCAPLACA', 'CODCENCUS', 'CentroResultado.DESCRCENCUS', 'CODNAT', 'Natureza.DESCRNAT', 'CODPROJ', 'Projeto.IDENTIFICACAO', 'CODCTACTB', 'PlanoContaEmpresa.DESCRCTA', 'NUMCONTRATO', 'DIGITADO',
                'CODPARC', 'Parceiro.RAZAOSOCIAL', 'Parceiro.NOMEPARC', 'AFERICAO', 'TIPOAFERICAO', 'CODSITE', 'Site.NOMESITE'];

            // Dataset e Datagrid
            self.onDatasetCreated = onDatasetCreated;
            self.interceptField = interceptField;
            self.atualizarRateio = atualizarRateio;
            self.putParamParaRateio = putParamParaRateio;
            self.saveHandlerRecDesp = saveHandlerRecDesp;
            self.removeHandlerRecDesp = removeHandlerRecDesp;

            //Funções do observer
            self.refreshed = refreshed;
            self.insertionModeActivated = insertionModeActivated;
            self.dataSaved = dataSaved;
            self.recordRemoved = recordRemoved;
            self.dataModified = dataModified;
            self.currentLineChanged = currentLineChanged;

            //Implementações da interface IFormInterceptor
            self.interceptBuildField = interceptBuildField;

            //Implementações da interface IDatagridInterceptor
            self.interceptColumnMetadata = interceptColumnMetadata;

            // Dataset e Datagrid
            self.onDatagridLoaded = onDatagridLoaded;

            // DoubleFacePanel
            self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.onDblClickGrid = onDblClickGrid;

            self.confirmarRateio = confirmarRateio;
            self.atualizarGrafico = atualizarGrafico;
            self.excluirRateio = excluirRateio;
            self.editionCanceled = editionCanceled;
            self.limparRateio = limparRateio;
            self.sortMetadata = sortMetadata;
            self.notGraphics = notGraphics
            self.abrirPesquisaCriterioRateio=abrirPesquisaCriterioRateio;

            // Bind Key Esc
            $document.bind('keypress', msgCancelEdition);

            self.btnConfirmar = _btnConfirmar;     
            self.rbgResultado = 'N' 

            initRateio();

            function initRateio() {
                self.changeButtonActions = [
                    GridConfigInstance(self.gridConfig).buildOpenMenuOption()
                ];

                _rateioPorVeiculo = MGEParameters.asBoolean("mge.usar.rateio.por.veiculo");

                if (IS_JIVA && !TELA_OPCIONAL_20444) {
                    _temCentroResultado = false;
                }

                var paramentros = {
                    params: [
                        {
                            param : [
                                {name: "fin.permitir.rateio.por.parceiro"},
                                {name: "fin.permitir.rateio.por.contrato"}

                        ]}
                    ]
                };

                ServiceProxy.callService("mge@SystemUtilsSP.getMGECoreParameters", paramentros)
                    .then(function (result) {
                    _rateioParceiro = "true" == result.responseBody.params.param[0].value;
                    _rateioContrato = "true" == result.responseBody.params.param[1].value;
                    self.loadingParameters = true;
                });

                if (_rateioPorVeiculo && PROPRIEDADE_TEM_RAT_SEM_RAV != "S") {
                    self.EntityName = "RateioVeiculo";
                    self.isRateioVeiculo = true;
                } else {
                    self.EntityName = "RateioRecDesp";
                    self.isRateioVeiculo = false;
                }

                self.ehInformativo = _somenteInformativo;
                if(self.ehInformativo){
                    self.enableCentroResultado = false;
                }
            }

            function sortMetadata(fieldsMD, dataset) {
                if(dataset.getEntityName() == "RateioRecDesp"){
                    fieldsMD.sort(function (a, b) {
                        return self.fieldsFormOrder.indexOf(a.name) - self.fieldsFormOrder.indexOf(b.name);
                    });
                }
            }

            // Iniciando o dsRateio
            function onDatasetCreated(dataset) {
                self.dsRateio = dataset;
                
                $scope.loadRateioPanel({rateioPanel: self});

				if(!_rateioPorVeiculo || PROPRIEDADE_TEM_RAT_SEM_RAV == "S"){
                    self.dsRateio.setCrudListener("br.com.sankhya.modelcore.crudlisteners.RateioPanelCrudListener");
                }

                self.dsRateio.addCriteriaProvider(getCriteria);
                self.dsRateio.setAllowPkModification(true);
                self.dsRateio.addObserver(self);

                self.dsRateio.beforePostAction(function (dataset) {
                    if (_rateioPorVeiculo && PROPRIEDADE_TEM_RAT_SEM_RAV != "S" && self.resourceID != RESOURCE_ID_CRITERIO) {

                        var cod = self.dsRateio.getFieldValue("CODVEICULO");

                        if (StringUtils.isEmpty(cod)) {
                            self.dsRateio.setFieldValue("TIPOAFERICAO", "N");
                        }

                        var afericaoValue = self.dsRateio.getFieldValueAsNumberOrZero("AFERICAO");
                        var tipoAfericao = self.dsRateio.getFieldValueAsString("TIPOAFERICAO");

                        if(!StringUtils.isEmpty(cod) && ("K" == tipoAfericao || "H" == tipoAfericao ) && afericaoValue==0){
                            if(angular.isUndefined(_afericaoAtual)){
                                var param = {codVeiculo: cod};
                                ServiceProxy.callService("mge@CriteriosDeRateioSP.obterInfosVeiculo", {param})
                                    .then(function (result) {
                                        _afericaoAtual = result.responseBody.result.afericao.$;
                                        _codVeiculoAtual = cod;
                                        self.dsRateio.save();
                                    });
                            }else{
                                if("O" == _afericaoAtual){
                                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Rateio.msgCampoAfericaoObrigatorio', [_codVeiculoAtual]));
                                    return false;
                                } else {
                                    return true;
                                }
                            }
                        }
                    }
                });

                self.dsRateio.makeFieldNonRequired("NUMCONTRATO");
                self.dsRateio.makeFieldNonRequired("CODPROJ");
                self.dsRateio.makeFieldNonRequired("CODPARC");
                self.dsRateio.makeFieldNonRequired("CODCENCUS");
                self.dsRateio.makeFieldNonRequired("CODNAT");
                self.dsRateio.makeFieldNonRequired("CODUSU");
                self.dsRateio.makeFieldRequired("PERCRATEIO");

                self.dsRateio.canInsert = !_somenteInformativo;
                self.dsRateio.canEdit = !_somenteInformativo;
                
                self.dsRateio.init();           

                if(angular.isUndefined($scope.habilitarConfirmar)){
                    self.visibleBtnConfirm = true;
                }
            }

            // Criteria para iniciar o dataSet
            function getCriteria() {
                var criteria = new Criteria();
                var origem = ObjectUtils.getProperty(_paramsParaRateio, 'ORIGEM');
                criteria.append("this.NUFIN = ? AND this.ORIGEM = ?");
                
                if(self.putParamParaRateioVar == true || (_paramsParaRateio && Object.keys(_paramsParaRateio).length > 0)){
                	
                	if(_rateioMode == CRITERIO_RATEIO_MODE){
                        var codCriterio = ObjectUtils.getProperty(_paramsParaRateio, 'CODCRITERIO');

                        if(!StringUtils.isEmpty(codCriterio)){
                            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codCriterio));
                        }
                    }else if(_rateioMode == RATEIO_FINANCEIRO_MODE){
                        var codCriterio = ObjectUtils.getProperty(_paramsParaRateio, 'CODCRITERIO');

                        if(!StringUtils.isEmpty(codCriterio)){
                            criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codCriterio));
                            origem = "C";

                            self.dsRateio.addTXProperty("rateio.panel.crudlistener.cfg.nufin", ObjectUtils.getProperty(_paramsParaRateio, 'NUFIN'));
                            self.dsRateio.addTXProperty("rateio.panel.crudlistener.cfg.origem", ObjectUtils.getProperty(_paramsParaRateio, 'ORIGEM'));
                        }else{
                            var nuFin = _paramsParaRateio.NUFIN;
                            if(!StringUtils.isEmpty(nuFin)){
                                criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, nuFin));
                            }
                        }
                    }else{
                        MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Rateio.messageModoRateioDesconhecido', _rateioMode));
                    }
                    
                    if(!StringUtils.isEmpty(origem)){
                        criteria.addParameter(Criteria.buildParameter(CriteriaParameter.TYPE_STRING, origem));
                    }    
                           
                        
                    return criteria;
                }
                
            }

            // Observer Refresh #refreshedImp
            function refreshed() {
                _initializingGrid = true;
                self.btnConfirmarEnable = _somenteInformativo ? false : self.dsRateio.size() > 0;

                if (angular.isDefined(self.btnExcluirDisabled)) {
                    self.btnExcluirDisabled = !_somenteInformativo && self.dsRateio.size() > 0;
                }

                //Nao deve ser alterado, ao fazer refresh é necessário recarregar o dataset com o vlrrateio
                //caso altere aqui vai dar problema na movimentação financeira que usa o vlrrateio
                var records = [];
                if(!self.dsRateio.isEmpty()){
                    var records = self.dsRateio.getRecordsAsObject();
                    ArrayUtils.toArray(records).forEach(function (object) {
                        ObjectUtils.setProperty(object, "VLRRATEIO", getVlrRateioObject(object));
                        if (isIniciarDigitado()) {
                            ObjectUtils.setProperty(object, "DIGITADO", "N");
                        }
                    });
                }
                
                var currentIndex = self.dsRateio.getCurrentIndex();

                self.dsRateio.clearDataSet().whenMetadataLoaded().then(function () {
                    self.dsRateio.addRecordsAsObjects(records);                  

                    var newCurrentIndex = currentIndex;

                    if(_curRowIndexAfterConfirm != currentIndex){
                        newCurrentIndex = _curRowIndexAfterConfirm;
                        _curRowIndexAfterConfirm = currentIndex;
                    }

                    self.dsRateio.gotoRow(newCurrentIndex);
                    _initializingGrid = false;

                    atualizarInfoRateio();
                });
                
                

                if (_rateioPorVeiculo && !self.dsRateio.isEmpty()) {
                    var tipAfericao = self.dsRateio.getFieldValueAsString("TIPOAFERICAO");
                    if (tipAfericao == "N") {
                        habilitaCampoAfericao(false);
                    } else {
                        habilitaCampoAfericao(true);
                    }

                    var codVei = self.dsRateio.getFieldValueAsString("CODVEICULO");
                    if (!StringUtils.isEmpty(codVei)) {
                        var param = {
                            codVeiculo : codVei
                        };
                        ServiceProxy.callService("mge@CriteriosDeRateioSP.obterInfosVeiculo", {param}).then(function (result) {
                            var codCenCus = NumberUtils.stringToNumber(result.responseBody.result.codCenCus);
                            if(codCenCus == self.dsRateio.getFieldValueAsNumber("CODCENCUS")) {
                                self.enableCentroResultado = false;
                            } else {
                                if(!_somenteInformativo){
                                    self.enableCentroResultado = true;
                                }
                            }
                        });
                    }
                }

                if (_paramsParaRateio.COPIACRITERIO) {
                    _paramsParaRateio.CODCRITERIO = undefined;
                    _paramsParaRateio.COPIACRITERIO = false;
                    mostrarToolTipConfirmacao();
                }
            }

            // Observer Current Line Changed #currentLineChangedImp
            function currentLineChanged() {

                if(self.dsRateio.size()){
                    _btnConfirmar(true);
                }

                if (_rateioPorVeiculo && !self.dsRateio.isEmpty()) {
                    var tipAfericao = self.dsRateio.getFieldValueAsString("TIPOAFERICAO");
                    if (tipAfericao == "N") {
                        habilitaCampoAfericao(false);
                    } else {
                        habilitaCampoAfericao(true);
                    }

                    var codVeiculo = self.dsRateio.getFieldValueAsString("CODVEICULO");
                    if (!StringUtils.isEmpty(codVeiculo)) {
                        var param = {codVeiculo : codVeiculo};
                        ServiceProxy.callService("mge@CriteriosDeRateioSP.obterInfosVeiculo", {param})
                       .then(function(result) {
                           var codCenCus = Number(result.responseBody?.result?.codCenCus?.$);
                           var codCenCusDataSet = self.dsRateio.getFieldValueAsNumber("CODCENCUS");

                           _afericaoAtual = String(result.responseBody?.result?.afericao?.$);
                           _codVeiculoAtual = codVeiculo;

                           if (codCenCus == codCenCusDataSet && codCenCusDataSet != 0) {
                               self.enableCentroResultado = false;
                           } else {
                               self.enableCentroResultado = true;
                           }
                       });
                   }
                }
            }

            // Observer Remove Record #recordRemovedImp
            function recordRemoved(record) {
                _mostrarToolTip = true;
                atualizarInfoRateio();

                self.btnConformarDisabled = true;
                _btnConfirmar(self.btnConformarDisabled);

                if (self.btnExcluirDisabled != undefined) {
                    self.btnExcluirDisabled = !_somenteInformativo && self.dsRateio.size() > 0;
                }
            }

            // Observer Data Modified #dataModifiedImp
            function dataModified(fieldName) {
                if(!_initializingGrid){
                    if (fieldName == "VLRRATEIO") {
                        recalcularPerRateio();
                    }else if (fieldName == "PERCRATEIO") {
                        calculaValorRateio();
                    }else if (fieldName == "CODVEICULO") {
                        if(_rateioPorVeiculo){
                            var cod= self.dsRateio.getFieldValue("CODVEICULO");
                            if (!StringUtils.isEmpty(cod)) {
                                var param = {codVeiculo:  cod};
                                ServiceProxy.callService("mge@CriteriosDeRateioSP.obterInfosVeiculo", {param})
                                    .then(function (result) {
                                    	if(result.responseBody.result){
                                        _afericaoAtual = result.responseBody.result.afericao.$;
                                        _codCentroCusStr = result.responseBody.result.codCenCus.$;
                                        _tipoAfericao = result.responseBody.result.tipoAericao.$;
                                        _codVeiculoAtual = cod;

                                        if(_tipoAfericao != "N"){
                                            habilitaCampoAfericao(true);
                                            self.dsRateio.setFieldValueAsString("TIPOAFERICAO", _tipoAfericao);
                                        }else{
                                            habilitaCampoAfericao(false);
                                            self.dsRateio.setFieldValueAsString("TIPOAFERICAO", "N");
                                        }

                                        if(!StringUtils.isEmpty(_codCentroCusStr)){
                                            self.dsRateio.setFieldValueAsString("CODCENCUS", _codCentroCusStr);
                                            self.enableCentroResultado = false;
                                        }else{
                                            limparCentroResultado(_codCentroCusStr);
                                        }
                                    	} else {
                                    		self.dsRateio.setFieldValueAsString("TIPOAFERICAO", "");
                                    		self.dsRateio.setFieldValueAsString("CODCENCUS", "");
                                    	}
                                    });
                            }

                        }

                    }

                    $timeout(() => {
	                    self.dsRateio.setFieldValueAsString("DIGITADO", "S");
	                }, 0, false);

                }
            }
            
            function limparCentroResultado(codCR) {
                if(!_somenteInformativo){
                    self.enableCentroResultado = true;
                }

                if(angular.isDefined(codCR)){
                    self.codCentroCusPesq = undefined;
                }
            }

            function habilitaCentroResultado(){
                var codVeiculo = self.dsRateio.getFieldValueAsString("CODVEICULO");
                if(!StringUtils.isEmpty(codVeiculo)){
                    self.enableCentroResultado = false;
                }else{
                    if(!_somenteInformativo){
                        self.enableCentroResultado = true;
                    }
                }
            }

            // Observer Edition Canceled #editionCanceledImp
            function editionCanceled() {
                if (_rateioPorVeiculo) {
                    limparCentroResultado(undefined);
                    habilitaCentroResultado();
                }
            }

            function dataSaved() {
                atualizarInfoRateio();
                self.btnConformarDisabled = true;

                if (self.dsRateio.size() > 0) {
                    _btnConfirmar(true);
                    self.btnConformarDisabled = true;

                    if (self.btnExcluirDisabled != undefined) {
                        self.btnExcluirDisabled = !_somenteInformativo;
                    }
                }
            }

            // Observer Insertion Mode #insertionModeActivatedImp
            function insertionModeActivated() {
                var rateado = 0;

                self.dsRateio.getRecordsAsObjects().forEach(function (rateio) {
                    if (angular.isDefined(rateio.PERCRATEIO)) {
                        rateado += NumberUtils.stringToNumber(rateio.PERCRATEIO);
                    }
                });

                var aRatear = 100 - rateado;

                var valorTotal = ObjectUtils.getProperty(_paramsParaRateio, 'VLRDESDOB');


                if(angular.isDefined(valorTotal)){
                    var valorRateio = NumberUtils.round(((aRatear * valorTotal) / 100), PRECISAO_VALOR_DECIMAL);
                    self.dsRateio.setFieldValue("VLRRATEIO", valorRateio);
                }

                var percRateio = NumberUtils.round(aRatear, PRECISAO_VALOR_PORCENTAGEM);
                self.dsRateio.setFieldValue("PERCRATEIO", percRateio);

                if (_rateioPorVeiculo) {
                    limparCentroResultado(undefined);
                }
            }

            function onDoubleFacePanelCreated(dblFacePanel) {
                if (dblFacePanel) {
                    self[dblFacePanel.id] = dblFacePanel;
                }
            }

            function onDblClickGrid(dblFacePanel) {
                self[dblFacePanel.id].setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
            }

            function onDatagridLoaded(datagrid) {
                self.dgRateio = datagrid;
            }

            // Calcular Valor do Rateio
            function calculaValorRateio() {
                self.dsRateio.setFieldValue("VLRRATEIO", getVlrRateio(self.dsRateio.getCurrentRowAsObject()), true);
            }

            function getVlrRateio(record) {
                if (record != null && record["PERCRATEIO"] != null) {
					return NumberUtils.round(Number(record["PERCRATEIO"]) * getIndiceRateio(), PRECISAO_VALOR_DECIMAL)
				}
                return 0;
            }

            function getVlrRateioObject(record) {
                if (angular.isDefined(record) && angular.isDefined(record.PERCRATEIO)) {
                    return NumberUtils.round(NumberUtils.stringToNumber(record.PERCRATEIO) * getIndiceRateio(), PRECISAO_VALOR_DECIMAL);
                }
                return 0;
            }

            // Save Handler
            function saveHandlerRecDesp() {
                if (_parentDataSet != undefined && _parentDataSet.isInsertionMode()) {
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Commons.Rateio.messageSalvarFormPrincipal'));
                } else {
                    _mostrarToolTip = true;
                    self.dsRateio.save();
                }
            }

            // Remove Handler
            function removeHandlerRecDesp() {
                self.dsRateio.unconditionalRemoveCurrentRecord();
                atualizarInfoRateio();
            }

            // Diretiva para habilitar o botão confirmar
            function _btnConfirmar(btnEnable) {
                if(angular.isDefined($scope.habilitarConfirmar)){
                    $scope.habilitarConfirmar({btnEnable: btnEnable});
                }
            }

            // Funções das diretivas
            function _confirmacaoRealizadaHandler() {
                $scope.confirmarcaoRealizadaHandler();
            }

            // Interceptando o campo
            function interceptField(field, dataset) {
                canCreatedField(field);
                //Campos não requiridos
                if ('@NUMCONTRATO@CODPROJ@CODPARC@CODCENCUS@CODNAT@'.indexOf('@' + field.fieldName + '@') > -1) {
                    field.required = false;
                } else if (field.fieldName == "PERCRATEIO") {
                    field.required = true;
                }

                if(_somenteInformativo){
                    field.enabled = false;
                }
            }

            // Atualizando o dataSet do rateio(StandAlone)
            function atualizarRateio() {
                self.dsRateio.refresh();                 
            }
            
            self.putParamParaRateioVar = false;

            function putParamParaRateio(chave, valor){
            	self.putParamParaRateioVar = false;
                if(arguments.length == 1 && angular.isObject(chave)){
                    _paramsParaRateio = chave;
                    self.putParamParaRateioVar = true;
                }else if(arguments.length == 2){
                    _paramsParaRateio[chave] = valor;
                    self.putParamParaRateioVar = true;
                }else {
                    console.warn('[SkRateioPanelController] - Parâmetros inválidos.');
                    self.putParamParaRateioVar = false;
                }
            }

            function canCreatedField(field) {
                switch (field.fieldName) {
                    case "VLRRATEIO":
                        field.visible = isVisible();
                        break;
                    case "CODPARC":
                        field.visible = _rateioParceiro;
                        break;
                    case "NOMEPARC":
                        field.visible = _rateioParceiro;
                        break;
                    case "NUMCONTRATO":
                        field.visible = _rateioContrato;
                        break;
                }

            }

            // Tornar alguns elementos visiveis ou não
            function isVisible() {
                if(self.mostrarInfoVlrRateio && _ehCadastro) {
                    return false;
                } else {
                    return true;
                }
            }

            function atualizarInfoRateio() {
                var rateado = 0;
                var parcelas = self.dsRateio.getRecordsAsObjects();

                parcelas.forEach(function (parcelaRateio) {
                    if(angular.isDefined(parcelaRateio.PERCRATEIO)){
                        rateado += NumberUtils.stringToNumber(parcelaRateio.PERCRATEIO);
                    }
                });

                var aRatear = 100 - rateado;

                if (aRatear == 0) {
                    self.colorARatear = "green";
                    if (_mostrarToolTip) {
                        mostrarToolTipConfirmacao();
                        _mostrarToolTip = false;
                    }
                } else {
                    self.colorARatear = "red";
                }

                self.percRateado = NumberUtils.format(rateado, PRECISAO_VALOR_PORCENTAGEM);
                self.percARatear = NumberUtils.format(aRatear, PRECISAO_VALOR_PORCENTAGEM);

                var valorTotal = ObjectUtils.getProperty(_paramsParaRateio, 'VLRDESDOB');
                if(angular.isDefined(valorTotal)){
                    self.mostrarInfoVlrRateio = true;
                    self.vlrTotal = valorTotal;
                    self.vlrRateado = ((rateado * valorTotal) / 100);
                    self.vlrARatear = ((aRatear * valorTotal) / 100);
                }else{
                    self.mostrarInfoVlrRateio = false;
                }
                
                atualizarGrafico();
            }

            // Exibir a mensagem de confirmação
            function mostrarToolTipConfirmacao() {
                    var _confirmTooltip = TooltipBuilder()
                        .targetElement(document.querySelector('.btn-popup-ok') || document.querySelector('#btnConfirmarRateio'))
                        .message(i18n('Commons.Rateio.messageLembrarConfirmarRateio'))
                        .duration(3000);

                AngularUtil.timeout(_confirmTooltip.show);
            }

            function isIniciarDigitado() {
                if(angular.isDefined(_paramsParaRateio) && !StringUtils.isEmpty(_paramsParaRateio.CODCRITERIO)) {
                    return true;
                } else {
                    return false;
                }
            }

            function habilitaCampoAfericao(flag) {
                if(!StringUtils.isEmpty(self.dsRateio.getFieldValue("AFERICAO"))){
                    self.enabledAfericao = flag;
                }
            }

            function getIndiceRateio() {
                var vlrRateio = 0;
                if (angular.isDefined(_paramsParaRateio) && angular.isDefined(_paramsParaRateio.VLRDESDOB)) {
                    vlrRateio = _paramsParaRateio.VLRDESDOB / 100;
                }
                return vlrRateio;
            }

            //Construção do gráfico da aba resultados
            function atualizarGrafico() {
                var records = self.dsRateio.getRecordsAsObjects();

                if(!ObjectUtils.isEmpty(records)){
                    var naturezaTotal = [];
                    var centroResultTotal = [];
                    var projetoTotal = [];
                    var objSeries = [];

                    records.forEach(function (chave) {
                        naturezaTotal.push({CODNAT : chave.CODNAT});
                        centroResultTotal.push({CODCENCUS : chave.CODCENCUS});
                        projetoTotal.push({CODPROJ : chave.CODPROJ});
                    });

                    if(self.rbgResultado == 'N'){
                        var naturezaResult = [];
                        var naturezaAux = [];
                        var chaveNat = self.dsRateio.getRecordsAsObjects();

                        //Remover duplicados
                        naturezaTotal.forEach(function (chave) {
                            var chaveNat = chave.CODNAT;

                            if(!ArrayUtils.isIn(naturezaAux, chaveNat)){
                                naturezaAux.push(chaveNat);
                            }
                        });

                        //Obter tamanho em porcentagem
                        naturezaAux.forEach(function (chave) {
                            var natureza = chave;
                            var tamanhoNat = 0;
                            var descricaoNat = undefined;

                            chaveNat.forEach(function (obj) {
                                if(natureza == obj.CODNAT){
                                	descricaoNat = htmlScape(obj["Natureza.DESCRNAT"]);
                                    tamanhoNat = obj.PERCRATEIO + tamanhoNat;
                                }
                            });

                            naturezaResult.push({name : descricaoNat, y: tamanhoNat});
                        });

                        objSeries.push({data: naturezaResult});
                    }else if(self.rbgResultado == 'CR'){
                        var centroResult = [];
                        var centroResultAux = [];
                        var chaveCR = self.dsRateio.getRecordsAsObjects();

                        //Remover duplicados
                        centroResultTotal.forEach(function (chave) {
                            var chaveCentroRes = chave.CODCENCUS;

                            if(!ArrayUtils.isIn(centroResultAux, chaveCentroRes)){
                                centroResultAux.push(chaveCentroRes);
                            }
                        });

                        centroResultAux.forEach(function (chave) {
                            var centroResultado = chave;
                            var tamanhoCR = 0;
                            var descricaoCR = undefined;

                            chaveCR.forEach(function (obj, index) {
                                if(centroResultado == obj.CODCENCUS){
                                    descricaoCR = htmlScape(obj["CentroResultado.DESCRCENCUS"]);
                                    tamanhoCR = obj.PERCRATEIO + tamanhoCR;
                                }
                            });
                            centroResult.push({name : descricaoCR, y: tamanhoCR});
                        });

                        objSeries.push({data: centroResult});
                    }else if(self.rbgResultado == 'P'){
                        var projetoResult = [];
                        var projetoAux = [];
                        var chaveProjeto = self.dsRateio.getRecordsAsObjects();

                        //Remover duplicados
                        projetoTotal.forEach(function (chave) {
                            var chaveProjeto = chave.CODPROJ;

                            if(!ArrayUtils.isIn(projetoAux, chaveProjeto)){
                                projetoAux.push(chaveProjeto);
                            }
                        });

                        projetoAux.forEach(function (chave) {
                            var projetoResultado = chave;
                            var tamanhoProjeto = 0;
                            var descricaoProjeto = undefined;

                            chaveProjeto.forEach(function (obj) {
                                if(projetoResultado == obj.CODPROJ){
                                    descricaoProjeto = htmlScape(obj["Projeto.IDENTIFICACAO"]);
                                    tamanhoProjeto = obj.PERCRATEIO + tamanhoProjeto;
                                }
                            });
                            projetoResult.push({name : descricaoProjeto, y: tamanhoProjeto});
                        });

                        objSeries.push({data: projetoResult});
                    }

                    if(_notGraphic){
                        var arr = [{}];
                        buildChartRateio(arr);
                    } else {
                        buildChartRateio(objSeries);
                    }
                }
            }

            // Recalcular o percentual do rateio
            function recalcularPerRateio() {
                var valorTotal = ObjectUtils.getProperty(_paramsParaRateio, 'VLRDESDOB');
                var percRateio = 0;

                if (angular.isDefined(valorTotal) && valorTotal > 0) {
                    percRateio = NumberUtils.format(((self.dsRateio.getFieldValue("VLRRATEIO")) / valorTotal * 100), PRECISAO_VALOR_PORCENTAGEM)
                }
                self.dsRateio.setFieldValue("PERCRATEIO", NumberUtils.stringToNumber(percRateio), true);
            }

            // Função do botão excluir rateio
            function excluirRateio() {
                MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, i18n('Commons.Rateio.messageConfirmaExclusao')).then(function () {
                    self.dsRateio.clearDataSet();
                    confirmarRateio();
                })
            }

            // Confirmar Rateio
            function confirmarRateio() {
                ajustarPercentual();

                var paramRateios = {rateios: {}};

                if (_rateioMode == CRITERIO_RATEIO_MODE) {
                    var codCriterio = ObjectUtils.getProperty(_paramsParaRateio, 'CODCRITERIO');
                    var numContrato = ObjectUtils.getProperty(_paramsParaRateio, 'NUMCONTRATO');

                    if (StringUtils.isEmpty(codCriterio) && StringUtils.isEmpty(numContrato)) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Rateio.messageFaltaCriterio'));
                        return;
                    }

                    if (!StringUtils.isEmpty(codCriterio)) {
                        paramRateios.rateios.nuFin = codCriterio;
                    }

                    if (!StringUtils.isEmpty(numContrato)) {
                        paramRateios.rateios.numContrato = numContrato;
                    }
                } else if (_rateioMode == RATEIO_FINANCEIRO_MODE) {
                    var nuFin = ObjectUtils.getProperty(_paramsParaRateio, 'NUFIN');

                    if (StringUtils.isEmpty(nuFin)) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Rateio.messageFaltaTitulo'));
                        return;
                    }

                    paramRateios.rateios.nuFin = nuFin;
                    _paramsParaRateio.CODCRITERIO = undefined;
                } else {
                    MessageUtils.showAlert(i18n('Commons.Rateio.messageModoRateioDesconhecido', [_rateioMode]));
                }

                var origem = _paramsParaRateio.ORIGEM;

                if (StringUtils.isEmpty(origem)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Rateio.messageFaltaTipoOrigem'));
                    return;
                }

                paramRateios.rateios.origem = origem;

                var fields = self.dsRateio.getFieldsMetadata();

                if (RESOURCE_ID == RESOURCE_ID_CRITERIO) {
                    paramRateios.rateios.isCriteria = "true";
                }

                var rateioArray = [];
                self.dsRateio.getRecordsAsObjects().forEach(function (rateio) {
                    var rateioObj = {};
                    fields.forEach(function (field) {
                        var fieldName = field.name;
                        if (rateio.hasOwnProperty(fieldName)) {
							if(field.isUserField && field.dataType == 'D'){
								value = DateUtils.formatDate(rateio[fieldName], DateUtils.DEFAULT_DATE_FORMAT);
							}else{
                            	var value = rateio[fieldName];
                            }
                            rateioObj = ObjectUtils.setProperty(rateioObj, fieldName, {isAdicional : field.isUserField, $ : value});
                        }
                    });
                    rateioArray.push(rateioObj);
                });

                ObjectUtils.setProperty(paramRateios.rateios, 'rateio', rateioArray);

                var rateado = 0;
                var chaveNatureza;

                chaveNatureza = self.dsRateio.getRecordsAsObjects();

                for (var i = 0; i < chaveNatureza.length; i++) {
                    if (chaveNatureza[i].PERCRATEIO != undefined) {
                        rateado += chaveNatureza[i].PERCRATEIO;
                    }
                }

                //Qdo DS é vazio, pode chamar serviço. Assim é feita a exclusão
                var isExclusao = self.dsRateio.size() == 0;

                // O total rateado é validado com 2 casas para desprezar erros de arredondamento que possam ter ocorrido
                if (isExclusao || NumberUtils.round(rateado, 2) == 100) {
                    _curRowIndexAfterConfirm = self.dsRateio.getCurrentIndex();
                    ServiceProxy.callService("mge@CriteriosDeRateioSP.confirmarRateio", paramRateios).then(function (result) {
                        if(result.responseBody && result.responseBody.hasOwnProperty("msg")){
							let msg = result.responseBody.msg.replace("[","").replace("]","");
							if (StringUtils.isNotEmpty(msg)){
								MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, msg);
							}
						}
                        if (isExclusao) {
                            MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Commons.Rateio.messageRateioApagado'));
                        }
                        if (angular.isFunction($scope.confirmarcaoRealizadaHandler)) {
                            _confirmacaoRealizadaHandler();
                        }
                        if(self.visibleBtnConfirm){
                            self.btnConformarDisabled = false;
                        }
                    })
                } else {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Rateio.messageTituloDeveSerRateado'));

                    rateado = NumberUtils.round(rateado, PRECISAO_VALOR_PORCENTAGEM);

                    var valorTotal = _paramsParaRateio.VLRDESDOB;

                    var aRatear = 100 - rateado;

                    self.percRateado = NumberUtils.format(rateado, PRECISAO_VALOR_PORCENTAGEM)
                    self.vlrRateado = NumberUtils.format(((rateado * valorTotal) / 100), PRECISAO_VALOR_DECIMAL)
                    self.percARatear = NumberUtils.format(aRatear, PRECISAO_VALOR_PORCENTAGEM)
                    self.vlrARatear = NumberUtils.format(((aRatear * valorTotal) / 100), PRECISAO_VALOR_DECIMAL)
                }
            }

            function buildChartRateio(series) {
                Highcharts.chart('graficoRateioID', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie'
                    },
                    title: {
                        text: null
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                                style: {
                                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                },
                                connectorColor: 'silver'
                            }
                        }
                    },
                    series: series,
                    credits: {enabled: false}
                });
            }

            function limparRateio(){
                self.dsRateio.clearDataSet();
                atualizarInfoRateio();
                self.btnConfirmarEnable = false;
                _btnConfirmar(false);
            }

            // Mensagem quando apertar o ESC
            function msgCancelEdition(evt) {
                if (evt.which === 27) {
                    if (self.dsRateio.isInsertionMode()) {
                        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.Rateio.msgConfirmeOuCanceleRateio'));
                        return false;
                    }
                }
            }

            // Ajustar o percentual do rateio
            function ajustarPercentual(vlrMaximo = 0) {
                if (self.dsRateio != undefined && self.dsRateio.getRecordsAsObjects() != undefined) {
                    var maxDif = 0.01;
                    var diferenca = 100 - getPercRateioTotal();

                    if (diferenca == 0 || Math.abs(diferenca) >= maxDif) {
                        return;
                    } else {
                        var indexMaior = -1;
                        
                        let recordMaior = {}
                        let index = 0;
                        
                        let recordsTemp = self.dsRateio.getRecordsAsObjects();

                        self.dsRateio.getRecordsAsObjects().forEach(function (rateioElement) {
                            var percRateio = rateioElement.PERCRATEIO != undefined ? rateioElement.PERCRATEIO : 0;
                            var percRateioMaior = recordMaior.PERCRATEIO != undefined ? recordMaior.PERCRATEIO : 0;
                            if ((percRateio > percRateioMaior) && (vlrMaximo == 0 || percRateio < vlrMaximo)) {
                                indexMaior = index; 
                                recordMaior = rateioElement;
                            }
                            index++;
                        });

                        if (indexMaior > -1) {	
							recordsTemp[indexMaior].PERCRATEIO = NumberUtils.round(NumberUtils.stringToNumber(recordMaior.PERCRATEIO) + diferenca, PRECISAO_VALOR_PORCENTAGEM);
							recordsTemp[indexMaior].VLRRATEIO = getVlrRateio(recordMaior);
							
							self.dsRateio.clearDataSet();
							self.dsRateio.addRecordsAsObjects(recordsTemp);
							vlrMaximo = recordsTemp[indexMaior].VLRRATEIO;
	                        diferenca = Math.round(100 - getPercRateioTotal(), PRECISAO_VALOR_PORCENTAGEM);
		
	                        if (vlrMaximo > 0 && diferenca != 0 && Math.abs(diferenca) < maxDif) {
	                               ajustarPercentual(vlrMaximo);
	                        }
                      	}
                    }
                }
            }

            // Pegar o percentual do rateio
            function getPercRateioTotal() {
                var totalRateado = 0;

                if (self.dsRateio != undefined) {
                    self.dsRateio.getRecordsAsObjects().forEach(function (rateioElement) {
                        if (rateioElement.PERCRATEIO != undefined) {
                            totalRateado += rateioElement.PERCRATEIO;
                        }
                    })
                }
                return totalRateado;
            }

            function notGraphics(valor){    
                if(valor == undefined || valor == "" || valor == null){
                    _notGraphic = true;
                    atualizarGrafico();
                } else {
                    _notGraphic = false;
                    atualizarGrafico();
                }
            }
            
            function htmlScape(value) {
            	if (StringUtils.isNotEmpty(value)) {
            		value = StringUtils.htmlScape(value);
            	}
            	return value;
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                if (fieldName == 'PERCRATEIO') {
                    fieldProp['sk-precision'] = PRECISAO_VALOR_PORCENTAGEM;
                }
                if (fieldName == 'CODNAT') {
                	scope.getCriteriaNatureza = getCriteriaNatureza;
              		fieldProp['sk-enviroment-criteria'] = "getCriteriaNatureza()";
                }                
            }
            
            function interceptColumnMetadata(fieldMetadata, dataset) {
                if (fieldMetadata.name == 'PERCRATEIO') {
                    fieldMetadata.precision = PRECISAO_VALOR_PORCENTAGEM;
                    
                } else if (fieldMetadata.name == 'VLRRATEIO') {
                    fieldMetadata.customCellFormatter = function (value, column, data) {
        				return formatNumber(value, 9, 2);
    				};
                }
            }

            function formatNumber(value, precision, prettyPrecision) {
            	if (value && precision) {
            		return NumberUtils.format(value, precision, prettyPrecision);
            	}
            	return value;
            }

            function abrirPesquisaCriterioRateio() {
                SkPesquisaService.openPesquisaPopUp('CriterioRateio', undefined, {
                    label: i18n('mgeos.Contratos.lbPesquisarCriterio')
                }).then(function (result) {
                    if (result && result.data) {
                        _paramsParaRateio['CODCRITERIO'] = result.data.CODCRITERIO;
						_paramsParaRateio['_COPIACRITERIO'] = true;
						 atualizar();
                    }
                });
			}

            function atualizar(){
				if(self.dsRateio){
                 	self.dsRateio.addCriteriaProvider(getCriteria);
					self.dsRateio.refresh();
				}
			}

			function getCriteriaNatureza(fieldName, dataset, fieldProp, scope) {	
				var ctr = Criteria();	
				var isTipDespesa = ObjectUtils.getProperty(_paramsParaRateio, 'ISTIPDESPESA');
				var tipDespesa = ObjectUtils.getProperty(_paramsParaRateio, 'TIPDESPESA');
				if(isTipDespesa){
					if(tipDespesa.length > 0){
						var tipo = tipDespesa=="1"?"R":"D";
						ctr.append("TIPNAT = '"+tipo+"'");
					}else{
						ctr.append("TIPNAT = 'zzz'");
					}
				} 
				return ctr;
			}	

        }]);

angular
  .module("snk.commons.rateio")
  .directive("skRateioPanel", [function () {
      var directive = {};
      directive.restrict = "E";
      directive.templateUrl = "commons/rateio/rateiopanel/rateiopanel.tpl.html";
      directive.controller = "SkRateioPanelController";
      directive.controllerAs = 'ctrl',
        directive.scope = {
              loadRateioPanel : '&?skOnLoadRateioPanel',
              rateioMode: '@?skRateioMode',
              ehCadastro: '=?skEhCadastro',
              ehInformativo: '=?skInformativo',
              confirmarcaoRealizadaHandler: '&?skConfirmarcaoRealizadaHandler',
              habilitarConfirmar: '&?skHabilitarConfirmar',
              showBtnExcluir : '&?skShowBtnExcluir',
              parentDataSet : '=?skParentDataset',
              showBtnCopiar : '&?skShowBtnCopiar'              
        };

      return directive;
    }
  ]);

angular
	.module("snk.commons")
	.controller("CancelamentoCartaoPopupController", ["$scope", "ObjectUtils", "dataValue", "$popupInstance", "i18n", "TEF", "StringUtils", "AngularUtil", "ServicoCancelamento", "ServiceProxy", "MessageUtils", "NumberUtils", "XmlJson",
		function ($scope, ObjectUtils, dataValue, $popupInstance, i18n, TEF, StringUtils, AngularUtil, ServicoCancelamento, ServiceProxy, MessageUtils, NumberUtils, XmlJson) {
			var self = this;

			let dsFinanceiro = dataValue.dsFinanceiro;
			let loadOnCloseFunction = dataValue.loadOnCloseFunction;
			let fecharRecebimentoFunction = dataValue.fecharRecebimentoFunction;
			let isPdvWeb = dataValue.isPdvWeb;
			var concluirCancelamentoFunction = dataValue.concluirCancelamentoFunction;
			var cancelamentos = dataValue.cancelamentos;
			var _currentIndex;
			var _transacoesCanceladas = [];

			self.close = close;
			self.progressBarVisible = false;
			self.resourceId = dataValue.resourceId;
			self.solicitarCancelamento = solicitarCancelamento;
			self.buildCelFLoat = buildCelFLoat;
			self.solicitarCancelamentoAdminstrativo = solicitarCancelamentoAdminstrativo;
			self.cancelamentoAdministrativo = dataValue.cancelamentoAdministrativo;
			self.progressBarClass = "progress-bar progress-bar-striped active";
			self.txtProgressBar = "";
			self.onDataGridLoaded = onDataGridLoaded;

			init();
			function init() {
				if(angular.isDefined(cancelamentos) && angular.isDefined(cancelamentos.cancelamento)){
					if (angular.isDefined(cancelamentos.cancelamento.length)) {
						cancelamentos = cancelamentos.cancelamento
					} else {
						cancelamentos = [cancelamentos.cancelamento]
					}
				}

				var datasetElem = angular.element(AngularUtil.createDirective("sk-dataset", {
					"sk-standalone": "",
					"sk-refresh-handler": "ctrl.carregarDados()",
				}, $scope));

				self.dsTransacao = datasetElem.data("$skDatasetController");

				var observer = new IDataSetObserver();

				observer.dataSaved = function (isNew) {
					habilitarDesabilitarBotoes();
				}

				observer.currentLineChanged = function (newIndex) {
					habilitarDesabilitarBotoes();
					printCupom(self.dsTransacao.getCurrentRowAsObject());
				}

				observer.recordRemoved = function (record) {
					habilitarDesabilitarBotoes();
				}

				self.dsTransacao.addObserver(observer);

				TEF.createFieldsDataSet(self.dsTransacao).then(function () {
					self.dsTransacao.initAndRefresh().then(function () {
						carregarDados()
					})
				});

				habilitarDesabilitarBotoes();
			}

			function carregarDados() {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						if (cancelamentos.length)
							angular.forEach(cancelamentos, function (item, key) {
								var record = {};
								record.STATUS = TEF.TRANSACAO_CONFIRMADA;

								angular.forEach(item, function (column, key) {
									var fm = self.dsTransacao.getFieldMetadata(key);
									var value = self.dsTransacao.strToTypedData(column.$, fm ? fm.dataType : "S");
									record[key] = value;
								})
								self.dsTransacao.addRecordsAsObjects(record);
								self.dsTransacao.gotoRow(0);
							})

							resolve(i18n('Commons.RecebimentoCartao.promiseResolvida'));
					}, 0);
				})
			}

			function removerTransacoesCanceladas() {
				var records = [];
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					if (current.STATUS == TEF.TRANSACAO_CANCELADA || current.STATUS == TEF.TRANSACAO_CANCELADA_ADMINISTRATIVAMENTE) {
						_transacoesCanceladas.push(current);
					} else {
						records.push(current);
					}
				})
				self.dsTransacao.clearDataSet();
				self.dsTransacao.addRecordsAsObjects(records);
			}

			function solicitarCancelamentoAdminstrativo() {
				_currentIndex = self.dsTransacao.getCurrentIndex();
				gerarCancelamentoCartao();
			}

			function solicitarCancelamento() {
				ligarDesligarProcessamento(TEF.SERVICO_SOLICITAR_CANCELAMENTO, true);

				var servico = ServicoCancelamento;
				servico.setDataSet(self.dsTransacao);
				servico.setConfirmarAuto(false);

				servico.setSucessoFunction(() => {
					ligarDesligarProcessamento();
					gerarCancelamentoCartao();
				});

				servico.setErroFunction((erro) => {
					ligarDesligarProcessamento();
					processarErros(erro);
				});

				servico.solicitarCancelamento();
			}

			function atualizarCancelamentoAdministrativo() {
				self.dsTransacao.gotoRow(_currentIndex).then(() => {
					self.dsTransacao.setFieldValue("STATUS", TEF.TRANSACAO_CANCELADA_ADMINISTRATIVAMENTE);
					self.dsTransacao.save(false, function () {
						self.dsTransacao.refresh().then(() => {
							self.dsTransacao.gotoRow(_currentIndex).then(() => {
								concluirCallCancelamento();
							})
						})
					});
				})
			}

			function gerarCancelamentoCartao() {
				var params = { params: { resourceId: self.resourceId, cancelarAdmin: self.cancelamentoAdministrativo ? true : false } }

				var cancelamentoXML = null;
				var cancel = []

				var cancelamento = null;
				var confirmouCancelamentoCartao = true;

				if (self.cancelamentoAdministrativo == true) {
					cancelamento = self.dsTransacao.getRecordsAsObjects();

					cancelamentoXML = {};

					cancelamentoXML.NSUCTF = { $: cancelamento[0].NSUCTF };

					if (!StringUtils.isEmpty(cancelamento[0].NUFINPARCELAS)) {
						cancelamentoXML.NUFINPARCELAS = { $: cancelamento[0].NUFINPARCELAS }
					}

					if (!StringUtils.isEmpty(cancelamento[0].NURENEG)) {
						cancelamentoXML.NURENEG = { $: cancelamento[0].NURENEG }
					}

					if (!StringUtils.isEmpty(cancelamento[0].NUACERTO)) {
						cancelamentoXML.NUACERTO = { $: cancelamento[0].NUACERTO }
					}

					cancel.push(cancelamentoXML);


				} else {
					var cancelamentos = self.dsTransacao.getRecordsAsObjects();

					angular.forEach(cancelamentos, function (cancelamento, key) {

						if (confirmouCancelamentoCartao) {
							confirmouCancelamentoCartao = cancelamento.STATUS == TEF.TRANSACAO_CANCELADA;
						}

						if (cancelamento.NSUCTFCAN != null) {
							if (cancelamento.NSUCTF == self.datagrid.getSelectedRecords()[0].NSUCTF) {
								cancelamentoXML = {};

								cancelamentoXML.NSUCTF = { $: cancelamento.NSUCTF }
								cancelamentoXML.REQUISICAO = { $: stringEmpty(cancelamento.REQUISICAO) }
								cancelamentoXML.RETORNO = { $: stringEmpty(cancelamento.RETORNO) }
								cancelamentoXML.REQUISICAOCONFIRMACAO = { $: stringEmpty(cancelamento.REQUISICAOCONFIRMACAO) }
								cancelamentoXML.RETORNOCONFIRMACAO = { $: stringEmpty(cancelamento.RETORNOCONFIRMACAO) }

								if (!StringUtils.isEmpty(cancelamento.NUFINPARCELAS)) {
									cancelamentoXML.NUFINPARCELAS = { $: cancelamento.NUFINPARCELAS }
								}

								if (!StringUtils.isEmpty(cancelamento.NURENEG)) {
									cancelamentoXML.NURENEG = { $: cancelamento.NURENEG }
								}

								if (!StringUtils.isEmpty(cancelamento.NUACERTO)) {
									cancelamentoXML.NUACERTO = { $: cancelamento.NUACERTO }
								}

								cancel.push(cancelamentoXML);
							}
						}
					})

				}
				var cancelamentoJson = { cancelamento: cancel }

				params.params.cancelamentos = cancelamentoJson;

				if (self.cancelamentoAdministrativo == true) {
					ligarDesligarProcessamento(TEF.SERVICO_CANCELAMENTO_ADMINISTRATIVO, true);
				} else {
					ligarDesligarProcessamento(TEF.SERVICO_CONCLUINDO_CANCELAMENTO_IMPRESSAO, true);
				}

				var conversationId = (self.cancelamentoAdministrativo == false) && !confirmouCancelamentoCartao ? UIDGenerator.generateUID(self.resourceId + "_cancelamento_cartao_") : null;				

				ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarCancelamento",
					params, self.cancelamentoAdministrativo == true ? null : { aditionalUrlParameters: { "conversation-id": conversationId } }).then(function (response) {

						if (self.cancelamentoAdministrativo == true) {
							atualizarCancelamentoAdministrativo();
						}
						else {
							let requestParam = XmlJson.create("params");
							let rootElem = XmlJson.create("records");
							for(let record of dsFinanceiro.getRecordsAsObjects()) {
								if(parseInt(record["TEF.NUMNSU"]) == self.datagrid.getSelectedRecords()[0].NSUCTF){
									let elem = XmlJson.create("record");
			
									dsFinanceiro.getFieldsMetadata().forEach(function (fm) {
											XmlJson.append(elem, XmlJson.create(fm.name, undefined, record[fm.name]));
									});
									XmlJson.append(rootElem, elem);
								}
							}	

							XmlJson.append(requestParam, rootElem);

							if(isPdvWeb){
								removerItemRecebimento(requestParam);
							}else{
								removerTransacoesCanceladas();
							}
							concluirCallCancelamento();
						}

					}).catch(function (statusMessage, status) {
						if (self.cancelamentoAdministrativo == false) {
							removerTransacoesCanceladas();
						}

						ligarDesligarProcessamento();

						habilitarDesabilitarBotoes();

						var msgErro = null;

						if (self.cancelamentoAdministrativo == true) {
							msgErro = i18n("Commons.RecebimentoCartao.msgErroCancelAdmin") + "\n\n" + statusMessage.statusMessage;
						} else {
							msgErro = i18n("Commons.RecebimentoCartao.msgSugerirCancelAdmin") + "\n\n" + statusMessage.statusMessage;
						}

						MessageUtils.showAlert(
							MessageUtils.TITLE_WARNING,
							msgErro
						);

						return true;
					})

				aguardarPreparacaoCancelamento(conversationId);
			}

			
			function removerItemRecebimento(params) {												
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.removerItemRecebimento", params, {normalizedJson : true})
				.then(
					
					function(msg) {
						if(msg && msg.statusMessage) {
							showAlert(msg.statusMessage);
						}
						return true;
					}
				);
			}

			function concluirCallCancelamento() {

				removerTransacoesCanceladas();

				ligarDesligarProcessamento();

				var podeFechar = self.dsTransacao.isEmpty();

				var funcCancelSucesso = function (canClose, concluirFunc) {
					MessageUtils.showInfo(
						MessageUtils.TITLE_INFORMATION
						, i18n("Commons.RecebimentoCartao.msgCancelSucesso") + "."
					).then(() => {
						if (canClose) {
							doClose();
							if (concluirFunc != null) {
								concluirFunc();
							}
						}
					}
					);
				}

				if (concluirCancelamentoFunction != null && podeFechar) {
					funcCancelSucesso(podeFechar, concluirCancelamentoFunction);
				} else {
					funcCancelSucesso(podeFechar);
				}
			}

			function aguardarPreparacaoCancelamento(conversationId) {
				if (conversationId != null) {

					var waitParam = {
						wait: {
							signal: {
								"$": "recebimento.cartao.executa.cancelamento.tef"
							}
						}
					}
					ServiceProxy.callService("mge@XConversation.waitSignal",
						waitParam, { aditionalUrlParameters: { 'conversation-id': conversationId } }).then(function (response) {
							var sigResult = ObjectUtils.getProperty(response, 'responseBody.signal-result');
							var status = parseInt(sigResult.status.$);

							if (status == 0) {
								processarCancelamento(conversationId);
							}
						});
				}
			}

			function enviarSinalCancelamentoCartao(conversationId, signal, data) {

				if (conversationId != null) {
					var sendParam = {
						send:
							{ signal: { $: signal } }
					};

					if (data != null) {
						sendParam.send.data = data.data;
					}

					ServiceProxy.callService("mge@XConversation.sendSignal",
						sendParam, { aditionalUrlParameters: { "conversation-id": conversationId } }).then(function (response) {

							var sigResult = ObjectUtils.getProperty(response, 'responseBody.signal-result');
							var status = parseInt(sigResult.status.$);

							if (status == 1 && signal == "recebimento.cartao.cancelamento.tef.ok") {
								gerarCancelamentoCartao();
							}
						})
				}
			}

			function processarCancelamento(conversationId) {
				ligarDesligarProcessamento(TEF.SERVICO_CONFIRMAR_TRANSACAO, true);

				var servico = ServicoCancelamento;
				servico.setDataSet(self.dsTransacao);
				servico.setConfirmarAuto(false);

				servico.setSucessoFunction(() => {
					var retornoSucesso = { data: {} };
					var recebimentos = self.dsTransacao.getRecordsAsObjects();

					if (recebimentos != null && recebimentos.length > 0) {
						var tefsXML = { tefs: { type: "X" } };
						var tef = []
						angular.forEach(recebimentos, function (titulo, key) {

							if (StringUtils.emptyAsNull(titulo.NSUCTF) != null) {

								tef.push({
									NSUCTF: { $: stringEmpty(titulo.NSUCTF) },
									REQUISICAOCONFIRMACAO: { $: stringEmpty(titulo.REQUISICAOCONFIRMACAO) },
									RETORNOCONFIRMACAO: { $: stringEmpty(titulo.RETORNOCONFIRMACAO) }
								})
							}
						});

						tefsXML.tefs.tef = tef;
						retornoSucesso.data.tefsXML = tefsXML.tefs;

					}

					enviarSinalCancelamentoCartao(conversationId, "recebimento.cartao.cancelamento.tef.ok", retornoSucesso);
					ligarDesligarProcessamento();
				});

				servico.setErroFunction((erro) => {
					var retornoErro = { data: { erro: { type: "S", $: erro.msgErro } } }

					enviarSinalCancelamentoCartao(conversationId, "recebimento.cartao.cancelamento.tef.cancelar", retornoErro);
					ligarDesligarProcessamento();
				});

				servico.solicitarConfirmacao();
			}

			function processarErros(erro) {
				var codRetorno = parseInt(erro.codRetorno);
				var serviceName = String(erro.servico);
				var msgErro = String(erro.msgErro);
				var callbackReprocessar = null;

				if (serviceName == TEF.SERVICO_SOLICITAR_CANCELAMENTO) {
					callbackReprocessar = solicitarCancelamento;
				}

				switch (codRetorno) {
					case TEF.DADO_INVALIDO:
						doProcessarErro(msgErro, serviceName, null);

					case TEF.TIME_OUT:
						doProcessarErro(msgErro, serviceName, callbackReprocessar);

					case TEF.TRANSACAO_NAO_AUTORIZADA_PELA_AUTORIZADORA:
						doProcessarErro(msgErro, serviceName, null);

					case TEF.TRANSACAO_NAO_AUTORIZADA_PELO_CTF:
						doProcessarErro(msgErro, serviceName, null);

					case TEF.ERRO_NA_CAMADA_INTERNET:
					case TEF.ERRO_NA_CAMADA_INTERTEF:
						doProcessarErro(msgErro, serviceName, callbackReprocessar);

					case TEF.ERRO_NA_CAMADA_PROCESSAMENTO:
					case TEF.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO:
						doProcessarErro(msgErro, serviceName, null);

					default:
						doProcessarErro(msgErro, serviceName, null);
				}
			}

			function doProcessarErro(msg, serviceName, callbackReprocessar) {
				if (callbackReprocessar != null) {
					msg += "\n\n" + i18n("Commons.RecebimentoCartao.msgDesejaReprocessTrans");

					MessageUtils.simpleConfirm(
						MessageUtils.TITLE_CONFIRMATION,
						msg,
						function () {
							if (callbackReprocessar != null) {
								callbackReprocessar();
							}
						},
						function () {
							habilitarDesabilitarBotoes();
						}
					);
				} else {
					habilitarDesabilitarBotoes();

					MessageUtils.showError(
						MessageUtils.TITLE_ERROR
						, msg
					);
				}
			}

			function printCupom(record) {
				var cupomData = getCupom(record);

				self.cupom = "";

				if (StringUtils.emptyAsNull(cupomData) == null) {
					return;
				}

				self.cupom += "\n" + cupomData;
			}

			function getCupom(record) {
				var cupomData = null;

				if (record != null) {
					if (record.STATUS == TEF.TRANSACAO_CONFIRMADA) {
						cupomData = record.COMPROVANTE;
					} else if (record.STATUS == TEF.TRANSACAO_EM_CANCELAMENTO || record.STATUS == TEF.TRANSACAO_CANCELADA) {
						if (record.CUPOMESTABELECIMENTOCAN != null) {
							cupomData = record.CUPOMESTABELECIMENTOCAN;
						} else if (record.CUPOMCLIENTECAN != null) {
							cupomData = record.CUPOMCLIENTECAN;
						} else {
							cupomData = record.CUPOMREDUZIDOCAN;
						}
					}
				}

				return cupomData;
			}

			function habilitarDesabilitarBotoes() {
				var btnCancelarEnabled = self.dsTransacao.getCurrentRow() != null && self.dsTransacao.getFieldValueAsString("STATUS") == TEF.TRANSACAO_CONFIRMADA;
				var btnCancelarAdminEnabled = self.dsTransacao.getCurrentRow() != null && self.dsTransacao.getFieldValueAsString("STATUS") != TEF.TRANSACAO_EM_CANCELAMENTO;

				self.btnCancelarEnabled = btnCancelarEnabled;
				self.btnCancelarAdminEnabled = btnCancelarAdminEnabled;
			}

			function ligarDesligarProcessamento(serviceName, ligar) {
				self.btnCancelarEnabled = ligar ? false : true;
				self.btnCancelarAdminEnabled = ligar ? false : true;
				$scope.$enableBtnOk = ligar ? false : true;

				self.txtProgressBar = i18n("Commons.RecebimentoCartao.msgExecOperacao");

				if (serviceName == TEF.SERVICO_SOLICITAR_CANCELAMENTO) {
					self.txtProgressBar = i18n("Commons.RecebimentoCartao.msgSolicitInfoCancel");
				} else if (serviceName == TEF.SERVICO_CONFIRMAR_CANCELAMENTO) {
					self.txtProgressBar = i18n("Commons.RecebimentoCartao.msgSolicitConfirmCancel");
				} else if (serviceName == TEF.SERVICO_CONCLUINDO_CANCELAMENTO) {
					self.txtProgressBar = i18n("Commons.RecebimentoCartao.msgProcessCancelImpComprovante");
				} else if (serviceName == TEF.SERVICO_CANCELAMENTO_ADMINISTRATIVO) {
					self.txtProgressBar = i18n("Commons.RecebimentoCartao.msgProcessCancelAdmin");
				}

				self.progressBarVisible = progressBar.includeInLayout = ligar ? true : false;
			}

			function close() {
				var temCancelamentoAprovado = false;
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					if (StringUtils.emptyAsNull(current.STATUS) == TEF.TRANSACAO_EM_CANCELAMENTO) {
						temCancelamentoAprovado = true;
					}
				});

				var msg = null;

				if (temCancelamentoAprovado) {
					msg = i18n("Commons.RecebimentoCartao.msgExisteCancelPendConfirmSeraRejeitado");
				}

				if (msg != null) {
					MessageUtils.simpleConfirm(
						MessageUtils.TITLE_CONFIRMATION,
						msg,
						function () {
							doClose();
						}
					);
				} else {
					doClose();
				}
			}

			function doClose() {
				if (fecharRecebimentoFunction != null) {
					fecharRecebimentoFunction();
				}

				if(loadOnCloseFunction != null){
					loadOnCloseFunction();
				}	
				$popupInstance.success("sucess");
			}

			var UIDGenerator = new (function () {
				var self = this;

				self.generateUID = generateUID;
				self.generateTinyUID = generateTinyUID;

				var CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";
				var _lastUID;

				function generateUID(prefix) {
					if (prefix == null) {
						prefix = "uid_";
					}

					if (_lastUID) {
						_lastUID++;
					} else {
						var now = new Date();
						_lastUID = now.getTime();
					}

					return prefix + generateTinyUID(_lastUID);
				}

				function generateTinyUID(i) {
					return i < CHARS.length
						? CHARS.charAt(i)
						: arguments.callee(i / CHARS.length - 1) +
						CHARS.charAt(i % CHARS.length);
				}
			});

			function stringEmpty(string) {
				if (angular.isUndefined(string) || string == null) {
					return " "
				}
				else {
					return string
				}
			}

			function buildCelFLoat(col, value, record) {
				if (value == undefined) {
					return NumberUtils.format(0, 2);
				} else if (value && typeof value === 'number') {
					return NumberUtils.format(value, 2);
				} else {
					var valueNumber = NumberUtils.stringToNumber(value);
					return NumberUtils.format(valueNumber, 2);
				}
			}

			function onDataGridLoaded(datagrid) {
				self.datagrid = datagrid;
			}
		}
	]);

angular
	.module("snk.commons")
	.service("CancelamentoCartaoPopup", ["SanPopup","i18n", "ServiceProxy",
		function (SanPopup,i18n, ServiceProxy) {
			var self = this;

			self.openPopUp = openPopUp;


			 function openPopUp(cancelamento) {

				var params = { params: { nuFin : cancelamento.nuFin} };

				ServiceProxy.callService("mge@RecebimentoComCartaoSP.prepararCancelamento",
					params).then(function (response) {

						var info = response.responseBody.info;

						var openPopup = {
							title: "",
							templateUrl: "commons/recebimentocartao/CancelamentoCartaoPopup/CancelamentoCartaoPopup.tpl.html",
							controller: "CancelamentoCartaoPopupController",
							controllerAs: "ctrl",
							size: "lg",
							height: 425,
							showBtnCancel: false,
							okBtnLabel: i18n('Commons.RecebimentoCartao.lblFechar'),
							keyboard : false,
							showBtnOk: false,
							showBtnNo: false,
							showIconClose : false,
							resolve: {
								dataValue: {
									cancelamentoAdministrativo: cancelamento.cancelamentoAdministrativo,
									concluirCancelamentoFunction: cancelamento.concluirCancelamentoFunction,
									dsFinanceiro: cancelamento.dsFinanceiro,
									isPdvWeb: cancelamento.isPdvWeb,
									loadOnCloseFunction: cancelamento.loadOnCloseFunction,
									fecharRecebimentoFunction: cancelamento.fecharRecebimentoFunction,
									resourceId: cancelamento.resourceId,
									cancelamentos: info.cancelamentos
								}
							}
						};

						if (cancelamento.cancelamentoAdministrativo == true) {
							openPopup.title = i18n('Commons.RecebimentoCartao.titleCancelamentoCartaoAdmin');
						} else {
							openPopup.title = i18n('Commons.RecebimentoCartao.titleCancelamentoCartao');
						}
						SanPopup.open(openPopup);
					},
					true,
					function(statusMessage, status) {
						if(cancelamento.fecharRecebimentoFunction != null) {
							cancelamento.fecharRecebimentoFunction();
						}
					}
				);
			}

		}

	]);
angular
	.module("snk.commons")
	.service("CancelamentoParam", [CancelamentoParam
	]); function CancelamentoParam() {

		var self = this; 
		self.resourceId;
		self.wizardBaixa;
		self.cancelamentoAdministrativo;
		self.nuFin;
		self.concluirCancelamentoFunction;
		self.fecharRecebimentoFunction;
		self.tefsPendentes;
	}

angular
	.module('snk.commons')
	.controller('CancelamentoTransacaoPendentePopupController', ['$scope', 'dataValue', '$popupInstance', 'i18n', 'TEF', 'StringUtils', 'AngularUtil', 'ServicoCancelamento', 'ServiceProxy', 'MessageUtils', 'ServicoDesfazimento',
		function ($scope, dataValue, $popupInstance, i18n, TEF, StringUtils, AngularUtil, ServicoCancelamento, ServiceProxy, MessageUtils, ServicoDesfazimento) {

			var self = this;
			$scope.$success = close;


			var concluirCancelamentoFunction = dataValue.concluirCancelamentoFunction;
			var transacoesConfirmadas = dataValue.transacoesConfirmadas;
			var transacoesPendentes = dataValue.transacoesPendentes;
			var _transacoesCanceladas = [];

			self.resourceId= dataValue.resourceID;
			self.close = close;
			self.cancelar = cancelar;


			init();
			function init() {

				var datasetElem = angular.element(AngularUtil.createDirective("sk-dataset", {
					"sk-standalone": "",
					"sk-refresh-handler": "ctrl.carregarDados()",
				}, $scope));

				self.dsTransacao = datasetElem.data("$skDatasetController");

				var observer = new IDataSetObserver();

				observer.dataSaved = function (isNew) {
					habilitarDesabilitarBotoes();
				}

				observer.currentLineChanged = function (newIndex) {
					habilitarDesabilitarBotoes();
					printCupom(self.dsTransacao.getCurrentRowAsObject());
				}

				observer.recordRemoved = function (record) {
					habilitarDesabilitarBotoes();
				}

				self.dsTransacao.addObserver(observer);

				TEF.createFieldsDataSet(self.dsTransacao).then(function () {
					self.dsTransacao.initAndRefresh().then(function () {
						carregarDados()
					})
				});

				habilitarDesabilitarBotoes();
			}

			function carregarDados() {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						if (angular.isDefined(transacoesConfirmadas) && transacoesConfirmadas.length > 0){
							angular.forEach(transacoesConfirmadas.transacao, function (item, key) {
								var record = {};
								record.STATUS = TEF.TRANSACAO_CONFIRMADA;

								angular.forEach(item, function (column, key) {
									var fm = self.dsTransacao.getFieldMetadata(key);
									var value = self.dsTransacao.strToTypedData(column.$, fm ? fm.dataType : "S");
									record[key] = value;
								})
								self.dsTransacao.addRecordsAsObjects(record);
								self.dsTransacao.gotoRow(0);
							})							
						}
						if (angular.isDefined(transacoesPendentes) && transacoesPendentes.length > 0) {
							angular.forEach(transacoesPendentes, function (item, key) {
								var record = {};
								record.STATUS = TEF.TRANSACAO_PENDENTE;
								self.dsTransacao.addRecordsAsObjects(item);
								self.dsTransacao.first();
							})							
						}

						resolve(i18n('Commons.RecebimentoCartao.promiseResolvida'));
					}, 0);
				})
			}


			function removerTransacoesCanceladas() {
				var records = [];
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					if (current.STATUS == TEF.TRANSACAO_CANCELADA || current.STATUS == TEF.TRANSACAO_DESFEITA) {
						_transacoesCanceladas.push(current);
					} else {
						records.push(current);
					}
				})
				self.dsTransacao.clearDataSet();
				self.dsTransacao.addRecordsAsObjects(records);
			}


			function cancelar() {
				var record = self.dsTransacao.getCurrentRowAsObject();

				if (record.STATUS == TEF.TRANSACAO_PENDENTE) {
					solicitarDesfazimento();
				} else {
					solicitarCancelamento();
				}
			}


			function solicitarDesfazimento() {
				ligarDesligarProcessamento(TEF.SERVICO_DESFAZER_TRANSACAO, true);

				var servico = ServicoDesfazimento;
				servico.setDataSet(self.dsTransacao);

				servico.setSucessoFunction(() => {
					ligarDesligarProcessamento();
					excluirTransacaoPendente();
				});

				servico.setErroFunction((erro) => {
					ligarDesligarProcessamento();
					processarErros(erro);
				});

				servico.solicitarDesfazimento();
			}
			function solicitarCancelamento() {
				ligarDesligarProcessamento(TEF.SERVICO_SOLICITAR_CANCELAMENTO, true);

				var servico = ServicoCancelamento;
				servico.setDataSet(self.dsTransacao);
				servico.setConfirmarAuto(false);

				servico.setSucessoFunction(() => {
					ligarDesligarProcessamento();
					excluirTransacaoPendente();
				});

				servico.setErroFunction((erro) => {
					ligarDesligarProcessamento();
					processarErros(erro);
				});

				servico.solicitarCancelamento();
			}

			
			function excluirTransacaoPendente(cancelamento) {
				var params = { params: { resourceID: self.resourceId} }

				var cancel = [];
				var cancelamentos = self.dsTransacao.getRecordsAsObjects();
				var confirmouCancelamentoCartao=true;
				
				angular.forEach(cancelamento, function (cancelamentos, key) {

					if (confirmouCancelamentoCartao) {
						confirmouCancelamentoCartao = (cancelamento.STATUS == TEF.TRANSACAO_CANCELADA || cancelamento.STATUS == TEF.TRANSACAO_DESFEITA);
					}

					if (cancelamento.NSUCTFCAN != null) {
						cancelamentoXML = {};

						cancelamentoXML.NSUCTF = { $: cancelamento.NSUCTF };
						cancelamentoXML.DTTRANSACAO = { $: cancelamento.DTTRANSACAO }
						cancelamentoXML.CODAPROVACAO = { $: cancelamento.CODAPROVACAO }
						cancel.push(cancelamentoXML);
					}
				});

				params.params.cancelamentos = { cancelamento: cancel }

				ligarDesligarProcessamento(TEF.SERVICO_CONCLUINDO_CANCELAMENTO_IMPRESSAO, true);

				var conversationId = !confirmouCancelamentoCartao ? UIDGenerator.generateUID(self.resourceId+ "_cancelamento_cartao_") : null;

				let serviceConfig ={}

				if(conversationId!=null){
                    serviceConfig.aditionalUrlParameters= { 'conversation-id': conversationId  }
				}
                
				
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.cancelarTransacaoPendente",
					params, serviceConfig).then(function (response) {

						removerTransacoesCanceladas();
						ligarDesligarProcessamento();

						var podeFechar = self.dsTransacao.isEmpty();



						var funcCancelSucesso = function (canClose, concluirFunc) {
							MessageUtils.showInfo(
								MessageUtils.TITLE_INFORMATION
								, i18n('Commons.RecebimentoCartao.msgCancelSucesso') + ".").then(function(){                            
									if (canClose) {
										doClose();

										if (concluirFunc != null) {
											concluirFunc(_transacoesCanceladas);
										}
									} 
								});

								
						}

						funcCancelSucesso(podeFechar, concluirCancelamentoFunction);
					});
				aguardarPreparacaoCancelamento(conversationId);
			}
			function aguardarPreparacaoCancelamento(conversationId) {
				if (conversationId != null) {
					var waitParam = { wait: { signal: { $: 'recebimento.cartao.executa.cancelamento.tef' } } }

					ServiceProxy.callService("mge@XConversation.waitSignal",
						waitParam, { aditionalUrlParameters: { 'conversation-id': conversationId } }).then(function (response) {
							var sigResult = response.responseBody.signal - result;
							var status = int(sigResult.status.$);

							if (status == 0) {
								processarCancelamento(conversationId);
							}
						});
				}
			}

			function enviarSinalCancelamentoCartao(conversationId, signal, data) {
				if (conversationId != null) {
					var sendParam = { send: { signal: { $: signal } } };

					if (data != null) {

						sendParam.send.data = data;
					}
					ServiceProxy.callService("mge@XConversation.sendSignal",
						sendParam, { aditionalUrlParameters: { 'conversation-id': conversationId } }).then(function (response) {

							var sigResult = response.responseBody.signal - result;
							var status = int(sigResult.status.$);

							if (status == 1 && signal == "recebimento.cartao.cancelamento.tef.ok") {
								gerarCancelamentoCartao();
							}
						})


				}
			}

			function processarCancelamento(conversationId) {
				ligarDesligarProcessamento(TEF.SERVICO_CONFIRMAR_TRANSACAO, true);

				var servico = ServicoCancelamento;
				servico.dataSet = self.dsTransacao;
				servico.confirmarAuto = false;

				servico.sucessoFunction = function () {
					var retornoSucesso = {};
					var recebimentos = self.dsTransacao.getRecordsAsObjects();

					if (recebimentos != null && recebimentos.length > 0) {
						var tefsXML = { tefs: type = "X" };
						var tefxml = []
						angular.forEach(recebimentos, function (titulo, key) {

							if (StringUtils.emptyAsNull(titulo.NSUCTF) != null) {
								var tefXML = {};

								tefXML.NSUCTF = { $: stringEmpty(titulo.NSUCTF) }

								tefXML.REQUISICAOCONFIRMACAO = { $: stringEmpty(titulo.REQUISICAOCONFIRMACAO) }

								tefXML.RETORNOCONFIRMACAO = { $: stringEmpty(titulo.RETORNOCONFIRMACAO) }

								tefxml.push(tefXML);
							}
						});

						tefsXML.tefs.tef = tefxml;
						retornoSucesso.data = tefsXML;

					}

					enviarSinalCancelamentoCartao(conversationId, "recebimento.cartao.cancelamento.tef.ok", retornoSucesso);
					ligarDesligarProcessamento();
				};

				servico.erroFunction = function (erro) {
					var retornoErro = { data: { erro: { type: "S", $: erro.msgErro } } }

					enviarSinalCancelamentoCartao(conversationId, "recebimento.cartao.cancelamento.tef.cancelar", retornoErro);
					ligarDesligarProcessamento();
				};

				servico.solicitarConfirmacao();
			}

			function processarErros(erro) {
				var codRetorno = int(erro.codRetorno);
				var serviceName = String(erro.servico);
				var msgErro = String(erro.msgErro);
				var callbackReprocessar = null;

				if (serviceName == TEF.SERVICO_SOLICITAR_CANCELAMENTO) {
					callbackReprocessar = solicitarCancelamento;
				}

				switch (codRetorno) {
					case TEF.DADO_INVALIDO:
						doProcessarErro(msgErro, serviceName, null);

					case TEF.TIME_OUT:
						doProcessarErro(msgErro, serviceName, callbackReprocessar);

					case TEF.TRANSACAO_NAO_AUTORIZADA_PELA_AUTORIZADORA:
						doProcessarErro(msgErro, serviceName, null);

					case TEF.TRANSACAO_NAO_AUTORIZADA_PELO_CTF:
						doProcessarErro(msgErro, serviceName, null);

					case TEF.ERRO_NA_CAMADA_INTERNET:
					case TEF.ERRO_NA_CAMADA_INTERTEF:
						doProcessarErro(msgErro, serviceName, callbackReprocessar);

					case TEF.ERRO_NA_CAMADA_PROCESSAMENTO:
					case TEF.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO:
						doProcessarErro(msgErro, serviceName, null);

					default:
						doProcessarErro(msgErro, serviceName, null);
				}
			}

			function doProcessarErro(msg, serviceName, callbackReprocessar) {
				if (callbackReprocessar != null) {
					msg += "\n\n" + i18n('Commons.RecebimentoCartao.msgDesejaReprocessTrans');

					MessageUtils.confirm(
						MessageUtils.TITLE_CONFIRMATION,
						msg,
						function () {
							if (callbackReprocessar != null) {
								callbackReprocessar();
							}
						},
						function () {
							habilitarDesabilitarBotoes();
						}
					);
				} else {
					habilitarDesabilitarBotoes();

					MessageUtils.showError(
						MessageUtils.TITLE_ERROR
						, msg
					);
				}
			}
			function printCupom(record) {
				var cupomData = getCupom(record);

				self.cupom = "";

				if (StringUtils.emptyAsNull(cupomData) == null) {
					return;
				}

				self.cupom += "\n" + cupomData;
			}

			function getCupom(record) {
				var cupomData = null;

				if (record != null) {
					if (record.STATUS == TEF.TRANSACAO_PENDENTE || record.STATUS == TEF.TRANSACAO_CONFIRMADA) {
						if (record.COMPROVANTE) {
							cupomData = record.COMPROVANTE;
						} else if (record.CUPOMESTABELECIMENTO) {
							cupomData = record.CUPOMESTABELECIMENTO;
						} else if (record.CUPOMCLIENTE) {
							cupomData = record.CUPOMCLIENTE;
						} else {
							cupomData = record.CUPOMREDUZIDO;
						}
					} else if (record.STATUS == TEF.TRANSACAO_EM_CANCELAMENTO || record.STATUS == TEF.TRANSACAO_CANCELADA) {
						if (record.CUPOMESTABELECIMENTOCAN) {
							cupomData = record.CUPOMESTABELECIMENTOCAN;
						} else if (record.CUPOMCLIENTECAN) {
							cupomData = record.CUPOMCLIENTECAN;
						} else {
							cupomData = record.CUPOMREDUZIDOCAN;
						}
					}
				}

				return cupomData;
			}

			function habilitarDesabilitarBotoes() {

				var btnCancelarEnabled = self.dsTransacao.getCurrentRow() != null && (self.dsTransacao.getFieldValueAsString("STATUS") == TEF.TRANSACAO_CONFIRMADA || self.dsTransacao.getFieldValueAsString("STATUS") == TEF.TRANSACAO_PENDENTE);
				self.btnCancelarEnabled = btnCancelarEnabled;
			}

			function ligarDesligarProcessamento(serviceName, ligar) {
				self.btnCancelarEnabled = ligar ? false : true;
				$scope.$enableBtnOk = ligar ? false : true;

				self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgExecOperacao');

				if (serviceName == TEF.SERVICO_SOLICITAR_CANCELAMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitInfoCancel');
				} else if (serviceName == TEF.SERVICO_CONFIRMAR_CANCELAMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitConfirmCancel');
				} else if (serviceName == TEF.SERVICO_CONCLUINDO_CANCELAMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgProcessCancelImpComprovante');
				} else if (serviceName == TEF.SERVICO_CANCELAMENTO_ADMINISTRATIVO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgProcessCancelAdmin');
				}

				self.progressBarVisible = progressBar.includeInLayout = ligar ? true : false;
			}

			function close() {
				var current = null;
				var temCancelamentoAprovado = false;
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					if (StringUtils.emptyAsNull(current.STATUS) == TEF.TRANSACAO_EM_CANCELAMENTO) {
						temCancelamentoAprovado = true;
					}
				});

				var msg = null;

				if (temCancelamentoAprovado) {
					msg = i18n('Commons.RecebimentoCartao.msgExisteCancelPendConfirmSeraRejeitado');
				}

				if (msg != null) {
					MessageUtils.confirm(
						MessageUtils.TITLE_CONFIRMATION,
						msg,
						function () {
							doClose();
						}
					);
				} else {
					doClose();
				}
			}

			function doClose() {
				$popupInstance.success('sucess');
			}

			var UIDGenerator = new (function () {
				var self = this;

				self.generateUID = generateUID;
				self.generateTinyUID = generateTinyUID;

				var CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";
				var _lastUID;

				function generateUID(prefix) {
					if (prefix == null) {
						prefix = "uid_";
					}

					if (_lastUID) {
						_lastUID++;
					} else {
						var now = new Date();
						_lastUID = now.getTime();
					}

					return prefix + generateTinyUID(_lastUID);
				}

				function generateTinyUID(i) {
					return i < CHARS.length
						? CHARS.charAt(i)
						: arguments.callee(i / CHARS.length - 1) +
						CHARS.charAt(i % CHARS.length);
				}
			});

			function stringEmpty(string) {

				if (angular.isUndefined(string) || string == null) {
					return " "
				}
				else {
					return string
				}
			}

		}
	]);

angular
	.module("snk.commons")
	.service("CancelamentoTransacaoPendentePopup", ["SanPopup", "i18n", "ServiceProxy", "ServicosGateway", "StringUtils", "ServicoDesfazimento",
		function (SanPopup, i18n, ServiceProxy, ServicosGateway, StringUtils, ServicoDesfazimento) {
			var self = this;

			self.openPopUp = openPopUp;

			function openPopUp(cancelamento) {
				var servico = ServicosGateway;
				servico.sucessoFunction = function (dados) {
					var hostName = dados ? stringEmpty(dados.hostName) : null;
					prepararCancelamento(cancelamento, hostName);
				};
				servico.erroFunction = function (dados) {
					MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, i18n('Commons.RecebimentoCartao.gatewayNaoAtivo'));
				};
				servico.isAtivo();
			}


			function prepararCancelamento(cancelamento, hostName) {
				var dataValue = {};

				if (cancelamento.tefsPendentes && cancelamento.tefsPendentes.length > 0) {

					dataValue.transacoesPendentes = cancelamento.tefsPendentes;
					dataValue.resourceID = cancelamento.resourceId;
					dataValue.concluirCancelamentoFunction = cancelamento.concluirCancelamentoFunction;
					openPopup.resolve.dataValue = dataValue;
					SanPopup.open(openPopup);

				} else {
					var params = { params: { resourceID: cancelamento.resourceId, wizardBaixa: cancelamento.wizardBaixa ? "S" : "N" } };

					if (StringUtils.emptyAsNull(hostName) != null) {
						params.params.hostName = hostName;
					}

					ServiceProxy.callService("mge@RecebimentoComCartaoSP.getTransacoesPendentes",
						params).then(function (response) {

							var info = response.responseBody.info;

							var ultTransacaoPendente = null;
							if (info.hasOwnProperty("ultTransacaoPendente")) {
								ultTransacaoPendente = {};
								ultTransacaoPendente.STATUS = TEF.TRANSACAO_PENDENTE;
								angular.forEach(info.ultTransacaoPendente[0].children(), function (column, key) {

									ultTransacaoPendente[column.name()] = !StringUtils.isEmpty(column.toString()) ? column.toString() : null;
								})
							}

							openPopUp.title = i18n('Commons.RecebimentoCartao.titleCancelamentoCartao');
							openPopUp.resolve.dataValue.transacoesConfirmadas = info.transacoesConfirmadas;
							openPopUp.resolve.dataValue.resourceId = cancelamento.resourceId;

							if (ultTransacaoPendente == null) {
								SanPopup.open(openPopup);
							} else {
								ServicoDesfazimento.desfazerSilencioso(ultTransacaoPendente, function () {
									SanPopup.open(openPopup);
								})
							}

						},
							true
						);
				}
			}

			function stringEmpty(string) {

				if (angular.isUndefined(string) || string == null) {
					return " "
				}
				else {
					return string
				}
			}

			var openPopup = {
				title: " ",
				templateUrl: "commons/recebimentocartao/CancelamentoTransacaoPendentePopup/CancelamentoTransacaoPendentePopup.tpl.html",
				controller: "CancelamentoTransacaoPendentePopupController",
				controllerAs: "ctrl",
				size: "lg",
				height: "400",
				showBtnCancel: false,
				okBtnLabel: i18n('Commons.RecebimentoCartao.lblFechar'),
				showBtnOk: true,
				showBtnNo: false,
				showIconClose: false,
				resolve: {
					"dataValue": {}
				}
			};

		}

	]);

angular
	.module("snk.commons")
	.service("CertificacaoParam", [CertificacaoParam
	]); function CertificacaoParam() {

		var self = this;
		self.resourceId;
		self.oncluirFunction;
}
angular
    .module('snk.commons')
    .controller('CertificacaoTEFPopupController', ['$scope', 'dataValue', 'SkApplicationInstance', 'StringUtils', '$popupInstance', 'MessageUtils', 'CancelamentoCartaoPopup', 'RecebimentoCartaoPopup', 'ServicosGateway', 'i18n',
        function ($scope, dataValue, SkApplicationInstance, StringUtils, $popupInstance, MessageUtils, CancelamentoCartaoPopup, RecebimentoCartaoPopup, ServicosGateway, i18n) {
            var self = this;
            var iniciaCertificacao = dataValue.iniciaCertificacao;
            var nroTesteCertificacao = 0;

            $scope.$success = fechar;

            self.executarCertificacao = executarCertificacao;


            init();
            function init() {
                let textProcCert = i18n('Commons.RecebimentoCartao.textProcCert');
                let textDarInicioCert = i18n('Commons.RecebimentoCartao.textDarInicioCert');

                SkApplicationInstance.putRuntimeProperty("mgefin.tef.popup.modo.certificacao", true);
                var text = StringUtils.substitute("<br/><b><font color=\"#000000\">{0}</font></b>",textProcCert );
                text += StringUtils.substitute("<br/><br/><font color=\"#000000\">{0}</font>", textDarInicioCert);
                self.detalhe = text;
            }

            function fechar() {
                SkApplicationInstance.putRuntimeProperty("mgefin.tef.popup.modo.certificacao", false);
                $popupInstance.success('close');
            }

            function executarCertificacao() {
                var servico = ServicosGateway;
                servico.sucessoFunction = function (dados) {
                    var params = {};

                    if (dados && dados.nroTesteCertificacao) {
                        params.operacao = { $: dados.operacao };
                        params.valorTransacao = { $: dados.valorTransacao ? Number(dados.valorTransacao) / 100 : 0 };
                        params.numeroParcelas = { $: dados.numeroParcelas ? Number(dados.numeroParcelas) : 1 };
                        params.hostName = { $: hostName };
                        ServiceProxy.callService("mge@RecebimentoComCartaoSP.prepararCertificacao",
                            params).then(function (response) {
                                var info = response.responseBody.info[0];

                                if (info.cancelamento == "S") {
                                    var cancelamento = new CancelamentoParam();
                                    cancelamento.nuFin = Number(info.nuFin);
                                    cancelamento.resourceId = resourceId;
                                    cancelamento.concluirCancelamentoFunction = function () {
                                        iniciaCertificacao = false;
                                        if (dados.retornoCertificacao == TEF.ABORTAR_CERTIFICACAO || dados.retornoCertificacao == TEF.FINALIZAR_CERTIFICACAO) {
                                            finalizarAbortarCertificacao(dados.retornoCertificacao);
                                        } else {
                                            proximoPassoCertificacao();
                                        }
                                    };

                                    CancelamentoCartaoPopup.open(cancelamento);
                                } else {
                                    var recebimento = {};
                                    recebimento.desfazerTransPendentes = true;
                                    recebimento.financeiros = [{ NUFIN: Number(info.nuFin) }];
                                    recebimento.resourceId = resourceId;
                                    recebimento.codTipTit = info.codTipTit;
                                    recebimento.qtdParcelas = int(info.numeroParcelas);
                                    recebimento.concluirRecebimentoFunction = function (recData) {
                                        iniciaCertificacao = false;
                                        if (dados.retornoCertificacao == TEF.ABORTAR_CERTIFICACAO || dados.retornoCertificacao == TEF.FINALIZAR_CERTIFICACAO) {
                                            finalizarAbortarCertificacao(dados.retornoCertificacao);
                                        } else {
                                            proximoPassoCertificacao();
                                        }
                                    };

                                    recebimento.concluirCancelamentoFunction = function (cancelData = null) {
                                        if (cancelData) {
                                            iniciaCertificacao = false;
                                            if (cancelData.retornoCertificacao == TEF.ABORTAR_CERTIFICACAO || cancelData.retornoCertificacao == TEF.FINALIZAR_CERTIFICACAO) {
                                                finalizarAbortarCertificacao(cancelData.retornoCertificacao);
                                            } else if (cancelData.retornoCertificacao == TEF.CONTINUAR_CERTIFICACAO) {
                                                proximoPassoCertificacao();
                                            }
                                        }
                                    };

                                    RecebimentoCartaoPopup.open(recebimento);
                                }
                            });
                    }
                }
                servico.erroFunction = function(dados) {
					MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, i18n('Commons.RecebimentoCartao.naoPossivel'));
				};
				servico.executarCertificacao(iniciaCertificacao ? -1 : nroTesteCertificacao);
            }
            function finalizarAbortarCertificacao(status) {
                var onClose = function () {
                    limparNroTesteCertificacao();
                    fechar();
                };

                if (status == TEF.FINALIZAR_CERTIFICACAO) {
                    MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Commons.RecebimentoCartao.certificaoFinalizada'), onClose);
                } else if (status == TEF.ABORTAR_CERTIFICACAO) {
                    MessageUtils.showInfo(MessageUtils.TITLE_INFORMATION, i18n('Commons.RecebimentoCartao.certificaoAbortada'), onClose);
                }
            }

            function proximoPassoCertificacao() {
                nroTesteCertificacao++;
                salvarNroTesteCertificacao();
            }

            function salvarNroTesteCertificacao() {
                var chave = "br.com.sankhay.tef.certificacao.configuracao." + hostName;
                var config = { chave: { $: chave }, tipo: { $: "T" } };
                config.nroTesteCertificacao = nroTesteCertificacao;
                ServiceProxy.callService("mge@SystemUtilsSP.saveConf",
                    config).then(function (response) {
                    });
            }

            function limparNroTesteCertificacao() {
                var chave = "br.com.sankhay.tef.certificacao.configuracao." + hostName;
                var config = { chave: { $: chave }, tipo: { $: "T" } };
                config.nroTesteCertificacao = nroTesteCertificacao;
                ServiceProxy.callService("mge@SystemUtilsSP.removeConf",
                    config).then(function (response) {
                    });

            }

            function buildRetorno(dados) {
                if (dados && dados.responseTef) {
                    var record = new Object();
                    for (var name in dados.responseTef) {
                        record[name] = dados.responseTef[name];
                    }
                    return record;
                }
                return null;
            }
        }]);
angular
    .module("snk.commons")
    .service("CertificacaoTEFPopup", ["SanPopup", "MessageUtils", "i18n", "ServicosGateway", "StringUtils", "ServiceProxy",
        function (SanPopup, MessageUtils, i18n, ServicosGateway, StringUtils, ServiceProxy) {
            var self = this;

            self.openPopUp = openPopUp;

            function openPopUp(certificacao) {

                var servico = ServicosGateway;

                servico.sucessoFunction = function (dados) {
                    var hostName = dados ? StringUtils.emptyAsNull(dados.hostName) : null;
                    prepararCertificacao(certificacao, hostName);
                };
                servico.erroFunction = function (dados) {
                    MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION,i18n('Commons.RecebimentoCartao.msgGatewayNotActive'));
                };

                servico.isAtivo();
            }

            function prepararCertificacao(certificacao, hostName) {
                var params = { params:  { buscaNroTesteCert: "true" } };
                certificacao
                if (StringUtils.emptyAsNull(hostName)) {
                    params.params.hostName = hostName;
                }

                ServiceProxy.callService("mge@RecebimentoComCartaoSP.prepararCertificacao",
                    params).then(function (response) {
                        var info = response.responseBody.info;

                        openPopup.title = i18n('Commons.RecebimentoCartao.certificaotef');
                        openPopup.resolve.dataValue.hostName = hostName;
                        openPopup.resolve.dataValue.resourceId = certificacao.resourceId;

                        if (info.hasOwnProperty("nroTesteCertificacao")) {
                            openPopup.resolve.dataValue.nroTesteCertificacao = int(info.nroTesteCertificacao.$.toString());
                        } else {
                            openPopup.resolve.dataValue.iniciaCertificacao = true;
                        }

                        SanPopup.open(openPopup);
                    });
            }

            var openPopup = {
				title: "",
				templateUrl: "commons/recebimentocartao/CertificacaoTEFPopup/CertificacaoTEFPopup.tpl.html",
				controller: "CertificacaoTEFPopupController",
				controllerAs: "ctrl",
				size: "lg",
				height: "400",
				showBtnCancel: false,
				okBtnLabel: i18n('Commons.RecebimentoCartao.lblFechar'),
				showBtnOk: true,
				showBtnNo: false,
				showIconClose: false,
				resolve: {
					dataValue: {

					}
				}
			};

        }
    ])
angular
    .module('snk.commons')
    .controller('PopUpVendaPOSController', ['$scope', 'MessageUtils', 'ObjectUtils', 'dataValue', '$popupInstance', 'i18n', 'DatasetEvents', 'AngularUtil', 'DateUtils',
        function ($scope, MessageUtils, ObjectUtils, dataValue, $popupInstance, i18n, DatasetEvents, AngularUtil, DateUtils) {
            var self = this;

            $scope.$success = closeButton;
            $scope.$dismiss = closeButton;

            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDynaformInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);
            ObjectUtils.implements(self, IDatagridInterceptor);

            var _mostrarTodasColunasTEF = dataValue.mostrarTodasColunasTEF;
            var _dsFinanceiro = dataValue.dsFinanceiro
            var _vendaPOSCheckout = dataValue.vendaPOSCheckout;
            var _callBackFunction = dataValue.callBackFunction;
            var _fecharPopUpFunction = dataValue.fecharPopUpFunction;
            var parentDS = dataValue.dataSetFinanceiro;

    
			var	datasetTef;


            self.acceptField = acceptField;
            self.acceptColumnField = acceptColumnField;
            self.interceptBuildField = interceptBuildField;
            self.onDynaformLoaded = onDynaformLoaded;
            self._dynaformFinanceiro = dataValue.dynaformFinanceiro;
            self.labelButton = _vendaPOSCheckout ? i18n('Commons.RecebimentoCartao.lblCancelarCartao') : i18n('Commons.RecebimentoCartao.lblFechar');
            self.closeButton = closeButton;
            function onDynaformLoaded(dynaform, dataset) {

                datasetTef = dataset;
                init();
            }

            function acceptField(fieldMD, dynaform, dataset) {

                if (_vendaPOSCheckout) {

                    if (!_mostrarTodasColunasTEF && "VLRTRANSACAO" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "TIPODOC" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "NUMDOC" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "NUMNSU" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "DESDOBRAMENTO" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "DTTRANSACAO" == fieldMD.name) {
                        return true;
                    }
                }

                return _mostrarTodasColunasTEF;
            }

            function acceptColumnField(fieldMD, dataset) {
                if (_vendaPOSCheckout) {
                    if (!_mostrarTodasColunasTEF && "VLRTRANSACAO" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "TIPODOC" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "NUMDOC" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "NUMNSU" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "DESDOBRAMENTO" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "AUTORIZACAO" == fieldMD.name) {
                        return true;
                    }

                    if (!_mostrarTodasColunasTEF && "DTTRANSACAO" == fieldMD.name) {
                        return true;
                    }
                }

                return _mostrarTodasColunasTEF;
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                if (fieldName == 'VLRTRANSACAO' || fieldName == 'TIPODOC') {
                    fieldProp['ng-disabled'] = dataset.getEntityName() == "TEF" && _vendaPOSCheckout;
                    return AngularUtil.createDirective('sk-number-input', fieldProp, scope);
                }
                else if (fieldName == 'DTTRANSACAO') {
                    fieldProp['ng-disabled'] = "true";
                    return AngularUtil.createDirective('sk-date-time-input', fieldProp, scope);
                }
            }

            function init() {
                _isShowing = true;

                var tefObserver = new IDataSetObserver();
                tefObserver.currentLineChanged = () => {
                    copyTefInformation();
                }
                tefObserver.dataSaved = () => {
                    if (_vendaPOSCheckout && _dsFinanceiro != null && _codTipTit > 0) {
                        let record = null;
                        angular.foreach(_dsFinanceiro.getRecordsAsObjects(), function (financeiro, key) {
                            if (financeiro.hasOwnProperty("CODTIPTIT") && _codTipTit == financeiro["CODTIPTIT"]) {
                                record = financeiro;
                            }
                        });
                    } else {

                        if (DateUtils.compareOnlyDate(DateUtils.stringToDate(datasetTef.getFieldValueAsString("DTTRANSACAO")), DateUtils.stringToDate(parentDS.getFieldValueAsString("DTNEG"))) < 0) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorValoresPosDiferentes", ["DTTRANSACAO"]));
                        }

                        if (datasetTef.getFieldValueAsString("DESDOBRAMENTO") != parentDS.getFieldValueAsNumber("DESDOBRAMENTO").toString()) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorValoresPosDiferentes", ["DESDOBRAMENTO"]));
                        }

                        if (datasetTef.getFieldValue("VLRTRANSACAO") && datasetTef.getFieldValue("VLRTRANSACAO").toString() != parentDS.getFieldValue("VLRDESDOB")) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorValoresPosDiferentes", ["VLRTRANSACAO"]));
                        }

                        if (datasetTef.getFieldValue("VLRTAXA") != parentDS.getFieldValue("CARTAODESC")) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorValoresPosDiferentes", ["VLRTAXA"]));
                        }
                    }
                }

                datasetTef.addObserver(tefObserver);
                datasetTef.setIgnoreAutoSave(true);

                if (datasetTef.isLoaded()) {
                    copyTefInformation();
                } else {
                    datasetTef.addEventListener(DatasetEvents.ON_METADATA_UPDATED, function (e) {
                        copyTefInformation();
                    });
                }

                datasetTef.addEventListener(DatasetEvents.EVENT_DATA_SAVED, function (e) {
                    close();
                });
            }

            function copyTefInformation() {
                var value = 0;

                if (_vendaPOSCheckout && _dsFinanceiro != null) {
                    var record = null;

                    angular.foreach(_dsFinanceiro.records.getRecordsAsObjects(), function (financeiro, key) {
                        if (financeiro.hasOwnProperty("CODTIPTIT") && _codTipTit == financeiro["CODTIPTIT"]) {
                            record = financeiro;
                        }
                    });

                    if (datasetTef != null && datasetTef.getCurrentRow() == null && record != null) {
                        datasetTef.goToInsertionMode().then(() => {
                            value = record["DESDOBRAMENTO"];
                            datasetTef.setFieldValue("DESDOBRAMENTO", isNaN(value) ? 1 : value);
                            datasetTef.setFieldValue("DTTRANSACAO", record["DTNEG"]);
                            datasetTef.setFieldValue("VLRTRANSACAO", record["VLRDESDOB"]);
                            datasetTef.setFieldValue("VLRTAXA", record["CARTAODESC"]);
                            datasetTef.setFieldValue("TIPODOC", record["CODTIPTIT"]);
                            datasetTef.setFieldValue("NUFIN", record["NUFIN"]);
                        })
                    }

                } else {
                    if (datasetTef != null && datasetTef.getCurrentRow() == null && _isShowing) {
                        datasetTef.goToInsertionMode().then(() => {

                            value = parentDS.getFieldValueAsNumber("DESDOBRAMENTO");
                            datasetTef.setFieldValue("DESDOBRAMENTO", isNaN(value) ? 1 : value);
                            datasetTef.setFieldValue("DTTRANSACAO", parentDS.getFieldValue("DTNEG"));
                            datasetTef.setFieldValue("VLRTRANSACAO", parentDS.getFieldValue("VLRDESDOB"));
                            datasetTef.setFieldValue("VLRTAXA", parentDS.getFieldValue("CARTAODESC"));
                            datasetTef.setFieldValue("TIPODOC", parentDS.getFieldValue("CODTIPTIT"));
                        })
                    }
                }
            }

            function closeButton() {
                close(true);
            }

            function close(rollBackFinanceiro = false) {
                $popupInstance.success('close');
                _isShowing = false;

                if (rollBackFinanceiro) {
                    if (datasetTef != null) {
                        datasetTef.cancelEdition();
                    }

                    if (_fecharPopUpFunction != null) {
                        _fecharPopUpFunction();
                    }
                }

                if (_callBackFunction != null) {
                    _callBackFunction();
                }
            }

        }]);

angular
    .module("snk.commons")
    .service("PopUpVendaPOS", ["SanPopup", "MessageUtils", "ObjectUtils", "i18n", "ServiceProxy",
        function (SanPopup, MessageUtils, ObjectUtils, i18n, ServiceProxy) {
            var self = this;
            var _isShowing = false;
            var _vendaPOSCheckout = false
            var _dynaformFinanceiro = null;
            var _dataSetFinanceiro = null;
            var _dsFinanceiro = null;
            var _callBackFunction = null;
            var _mostrarTodasColunasTEF = true;
            var _fecharPopUpFunction = null;


            self.show = show;
            self.setDynaformFinanceiro = setDynaformFinanceiro;
            self.setVendaPOSCheckout = setVendaPOSCheckout;
            self.setDsFinanceiro = setDsFinanceiro;
            self.setMostrarTodasColunasTEF = setMostrarTodasColunasTEF;
            self.setCallBackFunction = setCallBackFunction;
            self.setFecharPopUpFunction = setFecharPopUpFunction;
            self.setDataSetFinanceiro  = setDataSetFinanceiro ;

            function show() {
                if (!_isShowing) {
                    verificaUtilizaPos();
                }
            }

            function verificaUtilizaPos() {
                var parentDS = _dynaformFinanceiro.getDataset();
                if (!self._vendaPOSCheckout && parentDS) {
                    _codTipTit = parentDS.getFieldValueAsNumberOrZero("CODTIPTIT");
                }
                if (isNaN(_codTipTit)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorUtilizaPos"));
                    return;
                }
                if (_codTipTit > 0) {
                    var params = {
                        entity: {
                            name: "TipoTitulo",
                            literalCriteria: {
                                expression: { $: "CODTIPTIT = " + _codTipTit }
                            }
                        }
                    }

                    ServiceProxy.callService("mge@crud.find",
                        params).then(function (response) {
                            var utilizaPos = ObjectUtils.getProperty(response, 'responseBody.entidades.entidade.UTILIZAPOS.$');
                            if (utilizaPos == "S") {
                                openPopUp();
                            } else {
                                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorUtilizaPos"));
                            }
                        },
                            true
                        );

                } else {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Financeiro.MovimentacaoFinanceira.msgErrorUtilizaPos"));
                }
            }

            function openPopUp() {
                var Popup = {
                    title: i18n("Financeiro.MovimentacaoFinanceira.itemVendaPOS"),
                    templateUrl: "commons/recebimentocartao/PopUpVendaPOS/PopupVendaPos.tpl.html",
                    controller: "PopUpVendaPOSController",
                    controllerAs: "ctrl",
                    size: "500",
                    height: _vendaPOSCheckout ? "300" : "500",
                    showBtnCancel: false,
                    okBtnLabel: i18n('Commons.RecebimentoCartao.lblFechar'),
                    showBtnOk: false,
                    showBtnNo: false,
                    showIconClose: false,
                    resolve: {
                        dataValue: {
                            dynaformFinanceiro: _dynaformFinanceiro,
                            dataSetFinanceiro: _dataSetFinanceiro,
                            vendaPOSCheckout: _vendaPOSCheckout,
                            mostrarTodasColunasTEF: _mostrarTodasColunasTEF,
                            dsFinanceiro: _dsFinanceiro,
                            callBackFunction: _callBackFunction,
                            fecharPopUpFunction: _fecharPopUpFunction
                        }
                    }
                };

                SanPopup.open(Popup);
            }

            function setDynaformFinanceiro(dynaform) {
                _dynaformFinanceiro = dynaform;
            }

            function setDataSetFinanceiro(dataSet) {
                _dataSetFinanceiro = dataSet;
            }

            function setVendaPOSCheckout(vendaPOSCheckout) {
                _vendaPOSCheckout = vendaPOSCheckout;
            }

            function setMostrarTodasColunasTEF(mostrarTodasColunasTEF) {
                _mostrarTodasColunasTEF = mostrarTodasColunasTEF;
            }

            function setDsFinanceiro(dsFinanceiro) {
                _dsFinanceiro = dsFinanceiro;
            }

            function setCallBackFunction(callBack) {
                _callBackFunction = callBack;
            }

            function setFecharPopUpFunction(fecharPopUpFunction) {
                _fecharPopUpFunction = fecharPopUpFunction;
            }
        }
    ])
angular
	.module('snk.commons')
	.controller('PreferenciasRecebimentoCartaoPopupController', ['$scope', 'dataValue', '$popupInstance', 'i18n', 'SkApplicationInstance', 'StringUtils','MessageUtils', 'Criteria',
		function ($scope, dataValue, $popupInstance, i18n, SkApplicationInstance, StringUtils, MessageUtils, Criteria) {
			var self = this;
			$scope.$success = onFinish;

			self.VENCIMENTO_MAIS_PROXIMO = self.vencTitRemanescente = 0;
			self.VENCIMENTO_MAIS_DISTANTE = 1;
			self.HOJE = 2;
			self.centraldeNotas = dataValue.centraldeNotas;
			self.changeRenegociacao = changeRenegociacao;

			self.getEnvironmentCriteriaTipoOperacaoBaixa = getEnvironmentCriteriaTipoOperacaoBaixa;
			self.getEnvironmentCriteriaContaBancaria = getEnvironmentCriteriaContaBancaria;
			self.getEnvironmentCriteriaTipoOperacao = getEnvironmentCriteriaTipoOperacao;

			var resourceID = dataValue.resourceID;
			var configTela = angular.isDefined(dataValue.configTela) ?  StringUtils.emptyAsNull(dataValue.configTela) : null;

			init();
			function init() {
				carregarConfiguracao();
			}

			function carregarConfiguracao() {
				if (configTela != null) {
					self.calcularJuroAteDataAtual = configTela.calcularJuroAteDataAtual;
					self.zerarJuroMulta = configTela.zerarJuroMulta;
					self.usarRenegociacao = configTela.usarRenegociacao;
					self.vencTitRemanescente = configTela.vencTitRemanescente;

					if (angular.isDefined(configTela.codTipOperReneg) && StringUtils.emptyAsNull(configTela.codTipOperReneg) != null) {
						self.tipOperReneg = configTela.codTipOperReneg;
					}

					if (angular.isDefined(configTela.codEmpBaixa) && StringUtils.emptyAsNull(configTela.codEmpBaixa) != null) {
						self.empresa = configTela.codEmpBaixa;
					}

					if (angular.isDefined(configTela.codCtaBcoIntBaixa) && StringUtils.emptyAsNull(configTela.codCtaBcoIntBaixa) != null) {
						self.contaBancaria = configTela.codCtaBcoIntBaixa;
					}

					if (angular.isDefined(configTela.codTipOperBaixa) && StringUtils.emptyAsNull(configTela.codTipOperBaixa) != null) {
						self.tipOperBaixa = configTela.codTipOperBaixa;
					}

					if (angular.isDefined(configTela.codLancamento) && StringUtils.emptyAsNull(configTela.codLancamento) != null) {
						self.lancamento = configTela.codLancamento;
					}
				}
			}


			function salvarConfiguracao() {
				if (self.usarRenegociacao == "S" && (angular.isUndefined(self.tipOperReneg) || StringUtils.emptyAsNull(self.tipOperReneg) == null)) {
					MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n("Commons.RecebimentoCartao.msgInfoTipoOperacao"));
					return;
				}

				var configTela = {
					chave: resourceID,
					tipo: "T"
				};
				configTela.calcularJuroAteDataAtual =  self.calcularJuroAteDataAtual;
				configTela.zerarJuroMulta = self.zerarJuroMulta;
				configTela.usarRenegociacao = self.usarRenegociacao;
				configTela.vencTitRemanescente = self.vencTitRemanescente;

				if (angular.isDefined(self.tipOperReneg) && StringUtils.emptyAsNull(self.tipOperReneg) != null) {
					configTela.codTipOperReneg = self.tipOperReneg;
				}

				if (angular.isDefined(self.empresa) && StringUtils.emptyAsNull(self.empresa) != null) {
					configTela.codEmpBaixa = self.empresa;
				}

				if (angular.isDefined(self.contaBancaria) && StringUtils.emptyAsNull(self.contaBancaria) != null) {
					configTela.codCtaBcoIntBaixa = self.contaBancaria;
				}

				if (angular.isDefined(self.tipOperBaixa) && StringUtils.emptyAsNull(self.tipOperBaixa) != null) {
					configTela.codTipOperBaixa = self.tipOperBaixa;
				}

				if (angular.isDefined(self.lancamento) && StringUtils.emptyAsNull(self.lancamento) != null) {
					configTela.codLancamento = self.lancamento;
				}


				SkApplicationInstance.saveMgeConfig(resourceID, {"configTela" : configTela}).then(function() {
					SkApplicationInstance.putConfiguracaoTela(resourceID, configTela);
					$popupInstance.success(configTela);
				});
			}

			function getEnvironmentCriteriaTipoOperacao() {
				var expression = "this.TIPMOV = 'I'";
				var criteria = new Criteria();
				criteria.and(expression);
				return criteria;
			}

			function getEnvironmentCriteriaTipoOperacaoBaixa() {
				var expression = "this.TIPMOV = 'R'";
				var criteria = new Criteria();
				criteria.and(expression);
				return criteria;
			}

			function getEnvironmentCriteriaContaBancaria() {
				var codEmp = angular.isDefined(self.empresa) && StringUtils.emptyAsNull(self.empresa) ? self.empresa : "NULL"
				var expression = "(this.EXCLUSIVA = 'N' OR this.CODEMP = " + codEmp + ")";
				var criteria = new Criteria();
				criteria.and(expression);
				return criteria;
			}

			function changeRenegociacao() {
				if (self.usarRenegociacao != "S") {
					self.tipOperReneg = "";
				}
			}

			function onFinish() {
				salvarConfiguracao();
			}
		}
	]);

angular
	.module("snk.commons")
	.service("PreferenciasRecebimentoCartaoPopup", ["SanPopup", "i18n",
		function (SanPopup, i18n) {
			var self = this;
			self.openPopUp = openPopUp;
			self.PREFS_PGTO_CARTAO = "prefs_recebimento_cartao";

			function openPopUp(preferencia) {
				if (preferencia.centraldeNotas) {
					self.height = 250;
				} else {
					self.height = 550;
				}

				SanPopup.open({
					title: i18n('Commons.RecebimentoCartao.titielPrefRecebimentoCartao'),
					templateUrl: "commons/recebimentocartao/PreferenciasRecebimentoPopup/PreferenciasRecebimentoCartaoPopup.tpl.html",
					controller: "PreferenciasRecebimentoCartaoPopupController",
					controllerAs: "ctrl",
					showBtnCancel: true,
					size: 400,
					height: self.height,
					showBtnOk: true,
					showBtnNo: false,
					showIconClose: false,
					resolve: {
						dataValue: {
							resourceID: preferencia.resourceID,
							configTela: preferencia.configTela,
							centraldeNotas: preferencia.centraldeNotas
						}
					}
				}).result.then(function (result) {
					if (angular.isDefined(preferencia.concluir)) {
						preferencia.concluir(result);
					}
				});
			}
		}
	]);
angular
	.module("snk.commons")
	.controller("RecebimentoCartaoAdminPopupController", ["$scope", "$popupInstance", "ObjectUtils", "Criteria", "StringUtils", "MessageUtils", "ServiceProxy", "dataValue", "TEF", "PreferenciasRecebimentoCartaoPopup", "DatasetEvents", "AngularUtil", "i18n", "NumberUtils", "XmlJson", "MGEParameters", "DateUtils",
		function ($scope, $popupInstance, ObjectUtils, Criteria, StringUtils, MessageUtils, ServiceProxy, dataValue, TEF, PreferenciasRecebimentoCartaoPopup, DatasetEvents, AngularUtil, i18n, NumberUtils, XmlJson, MGEParameters, DateUtils) {

			var self = this;

			const PREFS_PGTO_CARTAO = "prefs_recebimento_cartao";
						
			var codTipTit = dataValue.codTipTit;			
			var financeiros = dataValue.financeiros;
			var resourceId = dataValue.resourceId;
			var vlrTotalTitulos = dataValue.vlrTotalTitulos;
			var filtraTipMovQtdIguais = MGEParameters.asBoolean("mge.filtra.titulo.qtd.parc");
			var concluirRecebimentoFunction = dataValue.concluirRecebimentoFunction;
			var qtdParcelas = dataValue.qtdParcelas;
			var subtipoVenda = dataValue.subtipoVenda;
			var operacaoCtf = dataValue.operacaoCtf;
			var cnpjCpfEmpresa = dataValue.cnpjCpfEmpresa;
			
			var _tipoTitulo = {};
			var _records = [];

			self.fechar = fechar;
			self.registrar = registrar;
			self.excluir = excluir;
			self.gerarRecebimentoCartao = gerarRecebimentoCartao;
			self.enableQtdParcelasInput = true;
			self.environmentCriteriaTipTit = environmentCriteriaTipTit;
			self.afterPopulateHandler = afterPopulateHandler;
			self.buildCelFLoat = buildCelFLoat;
			self.buildLabelTipoTitulo = buildLabelTipoTitulo;
			self.visibleBtnConcluir = false;

			init();
			
			function init() {

				var datasetElem = angular.element(AngularUtil.createDirective("sk-dataset", {
					"sk-standalone": "",
					"sk-refresh-handler": "ctrl.carregarDados()",					
				}, $scope));

				self.dsTransacao = datasetElem.data("$skDatasetController");

				TEF.createFieldsDataSet(self.dsTransacao).then(function () {
					self.dsTransacao.initAndRefresh();
				});

				var obsTransacao = new IDataSetObserver();

				obsTransacao.refreshed = function (i) {
					calcularTotalizadores();					
				}

				self.dsTransacao.addObserver(obsTransacao);
				
				_saldo = NumberUtils.getNumberOrZero(vlrTotalTitulos);

				resetForm();

				if (NumberUtils.getNumberOrZero(codTipTit) != 0) {
					self.pesqTipoTitulo = codTipTit;
				}

				if (NumberUtils.getNumberOrZero(qtdParcelas) > 0) {
					self.qtdParcelasInput = qtdParcelas;
				}

			}

			function calcularTotalizadores() {
				var valorTotalTrans = getVlrTransacaoTotal();
				_saldo = vlrTotalTitulos - valorTotalTrans;

				_valorTotalTits = parseFloat(vlrTotalTitulos).toFixed(2);
				_valorAprovado = parseFloat(valorTotalTrans).toFixed(2);
				_valorRestante = parseFloat(_saldo).toFixed(2);

				self.linhaTotais = ("<b>" + i18n('Commons.RecebimentoCartao.lblTotalTitulos') + " <font color=#0000FF>" + NumberUtils.format(_valorTotalTits, 2) + "</font></b> (-) <b> " + i18n('Commons.RecebimentoCartao.lblTotalRecebido') + " <font color=#0000FF>" + NumberUtils.format(_valorAprovado, 2) + "</font></b> (=) <b> " + i18n('Commons.RecebimentoCartao.lblSaldo') + " <font color=#0000FF>" + NumberUtils.format(_valorRestante, 2) + "</font></b> ");

				if(Number(_saldo) == 0){
					self.visibleBtnConcluir = true;
				} else {
					self.visibleBtnConcluir = false;
				}
			}

			function getVlrTransacaoTotal() {
				var valor = 0;
				if (self.dsTransacao != null && self.dsTransacao.getRecords().length > 0) {
					angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (row, key) {
						valor += row.VLRTRANSACAO;						
					});
				}
				return valor;
			}

			function resetForm() {				
				calcularTotalizadores();
				self.qtdParcelasInput = 1;
				self.vlrTransacaoInput = _saldo;
				self.nsuInput = null;
				self.numComprovanteVendaInput = null;
				self.autorizacaoInput = null;
				self.bandeiraInput = null;
				self.dtTransacaoInput = "";
				self.redeInput = null;
				changeTipoTitulo();
			}

			function changeTipoTitulo() {
				var operacao = _tipoTitulo != null ? _tipoTitulo.OPERACAOCTF : null;
				var qtdParcelas = _tipoTitulo != null && _tipoTitulo.QTDPARCELCTF != null ? _tipoTitulo.QTDPARCELCTF : 0;
				self.enableQtdParcelasInput = false;

				if (operacao == TEF.CREDITO_A_VISTA.toString() || operacao == TEF.DEBITO_PRE_DATADO.toString() || operacao == TEF.DEBITO.toString()) {
					self.qtdParcelasInput = 1;
				} else if (operacao == TEF.CREDITO_PARCELADO_COM_JUROS.toString() || operacao == TEF.CREDITO_PARCELADO_SEM_JUROS.toString()) {
					if (qtdParcelas > 0) {
						self.qtdParcelasInput = qtdParcelas;
					} else {
						self.enableQtdParcelasInput = true;
					}
				}
			}

			function afterPopulateHandler(obj) {
				if (angular.isUndefined(self.pesqTipoTitulo)) {
					return;
				}
				obj = self.pesqTipoTitulo;
				if (obj != null && !StringUtils.isEmpty(obj)) {
					var prefsCartao = { 
						chave: resourceId + "." + PREFS_PGTO_CARTAO
					};

					var params = {
						params:
						{
							codTipTit: obj,							
							prefsPgtoCartao: prefsCartao
						}
					}

					codTipTit = Number(obj);
					
					ServiceProxy.callService(
						"mge@RecebimentoComCartaoSP.carregarTipoTitulo", 
						params,
						{
							ignorePopUpErrorMsgs: true
						}
					).then(
						function (result) {
							var tipoTitulo = result.responseBody.tipoTitulo;

							_tipoTitulo = new Object();
							_tipoTitulo.CODTIPTIT = Number(tipoTitulo.CODTIPTIT.$.toString());
							_tipoTitulo.DESCRTIPTIT = tipoTitulo.DESCRTIPTIT.$.toString();
							_tipoTitulo.SUBTIPOVENDA = tipoTitulo.SUBTIPOVENDA.$.toString();
							_tipoTitulo.OPERACAOCTF = Object.keys(tipoTitulo.OPERACAOCTF) != "" ? tipoTitulo.OPERACAOCTF.$.toString() : " ";
							_tipoTitulo.QTDPARCELCTF = Number(tipoTitulo.QTDPARCELCTF.$.toString());

							changeTipoTitulo();
						},
						function (errorObj) {
							self.pesqTipoTitulo = "";

							MessageUtils.simpleConfirm(
								MessageUtils.TITLE_CONFIRMATION, i18n('Commons.RecebimentoCartao.msgNecessConfigBaixaPrefCartao'))
								.then(function () {
									abrirPreferenciasRecebimentoCartao();
								});							
						});
				}
			}

			function environmentCriteriaTipTit() {
				var expression;
				var qtdParcelas = self.qtdParcelasInput;
				var operacao = operacaoCtf;
				var subtipo = subtipoVenda;			

				var criteria = Criteria();

				if(NumberUtils.getNumberOrZero(qtdParcelas) > 0 && filtraTipMovQtdIguais){
					if (TEF.isEmCertificacao()) {
						expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114','-99') AND nullValue(this.UTILIZAPOS,'N') = 'N' AND this.QTDPARCELCTF = ? AND (this.OPERACAOCTF = ? OR this.SUBTIPOVENDA = ?)";
					} else {
						expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114') AND nullValue(this.UTILIZAPOS,'N') = 'N' AND this.QTDPARCELCTF = ?  AND (this.OPERACAOCTF = ? OR this.SUBTIPOVENDA = ?)";
					}
					criteria.and(expression, [Criteria.buildNumberParameter(qtdParcelas), Criteria.buildStringParameter(operacao), Criteria.buildStringParameter(subtipoVenda)]);
				} else {
				if (TEF.isEmCertificacao()) {
					expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114','-99') AND nullValue(this.UTILIZAPOS,'N') = 'N'";
				} else {
					expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114') AND nullValue(this.UTILIZAPOS,'N') = 'N'";
				}
				criteria.and(expression);
				}
				return criteria;
			}

			function carregarDados() {				
				resetForm();
			}

			function fechar(){
				$popupInstance.success('sucess');
			}

			function getNumTrans() {
				return self.dsTransacao.size() + 1;
			}

			function buildCelFLoat(col, value, record) {
				if (value == undefined) {
					return NumberUtils.format(0, 2);
				} else if (value && typeof value === 'number') {
					return NumberUtils.format(value, 2);
				} else {
					var valueNumber = NumberUtils.stringToNumber(value);
					return NumberUtils.format(valueNumber, 2);
				}
			}

			function buildLabelTipoTitulo(col, value, record) {

				var label = value.toString() + "-" + record[8].toString()

				return label;
			}

			function stringEmpty(string) {

				if (angular.isUndefined(string) || string == null) {
					return " "
				}
				else {
					return string
				}
			}

			function atualizarRecebimento(nuReneg, nuAcerto) {
				var index = -1;
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					index++;

					self.dsTransacao.gotoRow(index).then(() => {

						if (nuReneg != 0) {
							self.dsTransacao.setFieldValue("NURENEG", nuReneg);
						}

						if (nuAcerto != 0) {
							self.dsTransacao.setFieldValue("NUACERTO", nuAcerto);
						}

						self.dsTransacao.save();
					});
				});
			}

			function excluir(){
				if(angular.isDefined(self.dsTransacao.getSelectedRecords())) {
					if(self.dsTransacao.getSelectedRecords().length < 1){
						return;
					}
				}else{
					return;
				}

				self.dsTransacao.removeCurrentRow(true).then(function () {
					resetForm();
				});
				
			}

			function registrar(){													

				var qtdParcelas = isNaN(self.qtdParcelasInput) ? 0 : self.qtdParcelasInput;
				var vlrTransacao = isNaN(self.vlrTransacaoInput) ? 0 : Number(self.vlrTransacaoInput);
				var operacao = _tipoTitulo != null ? _tipoTitulo.OPERACAOCTF : null;
				var vlrTransacaoTotal = getVlrTransacaoTotal() + vlrTransacao;

				qtdParcelas = qtdParcelas <= 0 ? 1 : qtdParcelas;

				if (angular.isUndefined(self.pesqTipoTitulo) || StringUtils.emptyAsNull(self.pesqTipoTitulo) == null || (StringUtils.emptyAsNull(self.pesqTipoTitulo) != StringUtils.emptyAsNull(_tipoTitulo.CODTIPTIT))) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoTipoTitulo') + ".");
					return;
				}

				if (operacao == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoTipoTitulo') + ".");
					return;
				}

				if (vlrTransacao <= 0) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoVlrTransacao') + ".");
					return;
				}

				if (qtdParcelas == 1 && (operacao == "113" || operacao == "114")) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgOpCredNecessQtdParcMaiorQUm') + ".");
					return;
				}

				if (angular.isUndefined(self.nsuInput) || StringUtils.emptyAsNull(self.nsuInput) == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoNsu') + ".");
					return;
				}

				if (angular.isUndefined(self.numComprovanteVendaInput) || StringUtils.emptyAsNull(self.numComprovanteVendaInput) == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoNumComprovanteVenda') + ".");
					return;
				}

				if (angular.isUndefined(self.autorizacaoInput) || StringUtils.emptyAsNull(self.autorizacaoInput) == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoAutorizacao') + ".");
					return;
				}

				if (angular.isUndefined(self.bandeiraInput) || StringUtils.emptyAsNull(self.bandeiraInput) == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoBandeira') + ".");
					return;
				}

				if (angular.isUndefined(self.dtTransacaoInput) || StringUtils.emptyAsNull(self.dtTransacaoInput) == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoDtTransacao') + ".");
					return;
				}

				if (angular.isUndefined(self.redeInput) || StringUtils.emptyAsNull(self.redeInput) == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoRedeInput') + ".");
					return;
				}			

				if (vlrTransacaoTotal > vlrTotalTitulos) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoTotalTransMaiorTotalTit') + ".");
					return;
				}

				var record = new Object();
				
				record.OPERACAO = _tipoTitulo.OPERACAOCTF;
				record.CODAPROVACAO = self.autorizacaoInput;
				record.BANDEIRA = self.bandeiraInput;
				record.DTTRANSACAO = self.dtTransacaoInput;
				record.NSUCTF = self.nsuInput;
				record.NSUAUTORIZADORA = self.numComprovanteVendaInput;
				record.REDEADQUIRENTE = self.redeInput;
				record.VLRTRANSACAO = Number(self.vlrTransacaoInput);
				record.QTDPARCELAS = self.qtdParcelasInput;
				record.CODTIPTIT = _tipoTitulo.CODTIPTIT;
				record.DESCRTIPTIT = _tipoTitulo.DESCRTIPTIT;
				record.HOSTNAME = "localhost";
				record.NUMTRANS = getNumTrans();			
				record.CNPJCPFEMPRESA = cnpjCpfEmpresa;
				record.STATUS = "C";
				record.CODRESPAUTORIZADORA = "";
				record.REQUISICAO = "";
				record.RETORNO = '{"cupomCliente":[{"linha":"   PAGAMENTO REGISTRADO POR MEIO DE"},{"linha":"    RECEBIMENTO ADMINISTRATIVO"},{"linha":"        IMPRIMIR O CUPOM"},{"linha":" DIRETAMENTE NO SITE DA OPERADORA"}]}';
				record.REQUISICAOCONFIRMACAO = "";
				record.RETORNOCONFIRMACAO = "";
				record.IDENTIFICACAOTEF = "";

				
				self.dsTransacao.addRecordsAsObjects(record);				
				self.dsTransacao.gotoRow(0);

				resetForm();
				
			}

			function gerarRecebimentoCartao(){
				var recebimentos = self.dsTransacao.getRecordsAsObjects();

				var params = { centralDeNotas: "N" };

				var prefsPgtoCartao = {
					chave: resourceId + "." + PreferenciasRecebimentoCartaoPopup.PREFS_PGTO_CARTAO
				}

				params.prefsPgtoCartao = prefsPgtoCartao;

				var Financeiro = [];

				angular.forEach(financeiros, function (financeiro, key) {
					Financeiro.push({ $: financeiro.$ });
				});
				var financeiro = { financeiro: Financeiro }
				params.financeiros = financeiro;

				var recebimentosXML = [];

				angular.forEach(recebimentos, function (recebimento, key) {

					var recebimentoXML = {
						NSUCTF: { $: stringEmpty(recebimento.NSUCTF) },
						CODTIPTIT: { $: stringEmpty(recebimento.CODTIPTIT) },
						OPERACAO: { $: stringEmpty(recebimento.OPERACAO) },
						NUMTRANS: { $: stringEmpty(recebimento.NUMTRANS) },
						CODRESPAUTORIZADORA: { $: stringEmpty(recebimento.CODRESPAUTORIZADORA) },
						CODAPROVACAO: { $: stringEmpty(recebimento.CODAPROVACAO) },
						VLRTRANSACAO: { $: stringEmpty(recebimento.VLRTRANSACAO) },
						NSUAUTORIZADORA: { $: stringEmpty(recebimento.NSUAUTORIZADORA) },
						DTTRANSACAO: { $: DateUtils.formatDate(stringEmpty(recebimento.DTTRANSACAO), DateUtils.DEFAULT_DATETIME_FORMAT) },
						QTDPARCELAS: { $: stringEmpty(recebimento.QTDPARCELAS) },
						BANDEIRA: { $: stringEmpty(recebimento.BANDEIRA) },
						REDEADQUIRENTE: { $: stringEmpty(recebimento.REDEADQUIRENTE) },
						CODREDEADQUIRENTE: { $: stringEmpty(recebimento.CODREDEADQUIRENTE) },
						CARTAO: { $: stringEmpty(recebimento.CARTAO) },
						STATUS: { $: stringEmpty(recebimento.STATUS) },
						REQUISICAO: { $: stringEmpty(recebimento.REQUISICAO) },
						RETORNO: { $: stringEmpty(recebimento.RETORNO) },
						REQUISICAOCONFIRMACAO: { $: stringEmpty(recebimento.REQUISICAOCONFIRMACAO) },
						RETORNOCONFIRMACAO: { $: stringEmpty(recebimento.RETORNOCONFIRMACAO) },
						IDENTIFICACAOTEF: { $: stringEmpty(recebimento.IDENTIFICACAOTEF) }
					}

					if (StringUtils.emptyAsNull(recebimento.DTPREDATADO)) {
						recebimento.DTPREDATADO = { $: (recebimento.DTPREDATADO, "DD/MM/YYYY") }
					}

					recebimentosXML.push(recebimentoXML);
				});
				var recebimento = { recebimento: recebimentosXML }
				params.recebimentos = recebimento;

				params = { params: params };

				ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarRecebimento",
						params).then(function (response) {
							var info = response.responseBody.info;
							if (angular.isDefined(info.NURENEG))
								var nuReneg = StringUtils.emptyAsNull(info.NURENEG.$);
							if (angular.isDefined(info.NUACERTO))
								var nuAcerto = StringUtils.emptyAsNull(info.NUACERTO.$);

							atualizarRecebimento(nuReneg != null ? Number(nuReneg) : 0, nuAcerto != null ? Number(nuAcerto) : 0);

							if (concluirRecebimentoFunction != null) {
								$popupInstance.success('sucess');
								concluirRecebimentoFunction({ nuReneg: nuReneg, nuAcerto: nuAcerto });								
							} else {
								MessageUtils.showInfo(
									MessageUtils.TITLE_INFORMATION
									, i18n('Commons.RecebimentoCartao.msgRecebSucesso') + "."
									, function () {
										$popupInstance.success('sucess');
									}
								);
							}

						}).catch(function (statusMessage) {
							MessageUtils.showError(
								MessageUtils.TITLE_ERROR
								, statusMessage.statusMessage
							);							
						});

			}

			



		}
	]);

angular
	.module("snk.commons")
	.service("RecebimentoCartaoAdminPopup", ["SanPopup", "MessageUtils", "SkI18nService", "i18n", "ServicosGateway", "ServicoDesfazimento", "StringUtils", "ServiceProxy", "ObjectUtils", "DateUtils", "TEF",
		function (SanPopup, MessageUtils, SkI18nService, i18n, ServicosGateway, ServicoDesfazimento, StringUtils, ServiceProxy, ObjectUtils, DateUtils, TEF) {
			var self = this;
			const PREFS_PGTO_CARTAO = "prefs_recebimento_cartao";
			self.openPopUp = openPopUp;

			function openPopUp(recebimento) {

				prepararRecebimento(recebimento, "localhost");
				
			}

			function prepararRecebimento(recebimento, hostName) {
				var params = {
					resourceID: recebimento.resourceId,
					hostName: hostName
				}

				var prefsPgtoCartao = {
					chave: recebimento.resourceId + "." + PREFS_PGTO_CARTAO
				}

				params.prefsPgtoCartao = prefsPgtoCartao;

				var financeiros = [];
				if (recebimento.financeiros) {
					angular.forEach(recebimento.financeiros, function (financeiro, key) {
						financeiros.push({ $: financeiro["NUFIN"] });
					});

					params.financeiros = { financeiro: financeiros };
				}
				params = { params: params };

				ServiceProxy.callService("mge@RecebimentoComCartaoSP.prepararRecebimento",
					params).then(function (response) {

						var vlrRecebimento = recebimento.vlrTotalTitulos;
						var dtTransacao = recebimento.dtTransacao;
						var codTipTit = null;
						var qtdParcelas = null;
						var subtipoVenda = null;
						var operacaoCtf = null;
						var cnpjCpfEmpresa = null;

						var info = ObjectUtils.getProperty(response, 'responseBody.info');

						if (info.hasOwnProperty("VLRRECEBIMENTO")) {
							vlrRecebimento = Number(info.VLRRECEBIMENTO.$.toString());
						}
						if (info.hasOwnProperty("DTTRANSACAO")) {
							dtTransacao = DateUtils.strToDate(info.DTTRANSACAO.$);
						}
						if (info.hasOwnProperty("CNPJCPFEMPRESA")) {
							cnpjCpfEmpresa = info.CNPJCPFEMPRESA.$.toString();
						}
						if (info.hasOwnProperty("CODTIPTIT")) {
							codTipTit = Number(info.CODTIPTIT.$.toString());
						}
						if (info.hasOwnProperty("QTDPARCELAS")) {
							qtdParcelas = Number(info.QTDPARCELAS.$.toString());
						}
						if (info.hasOwnProperty("SUBTIPOVENDA")) {
							subtipoVenda = info.SUBTIPOVENDA.$.toString();
						}
						if (info.hasOwnProperty("OPERACAOCTF")) {
							operacaoCtf = info.OPERACAOCTF.$.toString();
						}

						var openPopup = {
							title: SkI18nService.instant("Commons.RecebimentoCartao.titleRecebimentoCartaoAdmin"),
							templateUrl: "commons/recebimentocartao/RecebimentoCartaoAdminPopup/RecebimentoCartaoAdminPopup.tpl.html",
							controller: "RecebimentoCartaoAdminPopupController",
							controllerAs: "ctrl",
							size: "lg",
							height: 525,
							showBtnCancel: false,
							okBtnLabel: i18n('Geral.lblConcluir'),
							noBtnLabel: i18n('Commons.RecebimentoCartao.lblFechar'),
							showBtnOk: false,
							showBtnNo: false,
							showIconClose: true,
							resolve: {
								dataValue: {
									concluirRecebimentoFunction: recebimento.concluirRecebimentoFunction,
									concluirCancelamentoFunction: recebimento.concluirCancelamentoFunction,
									fecharRecebimentoFunction: recebimento.fecharRecebimentoFunction,
									centralDeNotas: recebimento.centralDeNotas,
									wizardBaixa: recebimento.wizardBaixa,
									codTipTit: codTipTit,
									utilizaCheckout: recebimento.utilizaCheckout,
									ownerServiceCall: recebimento.ownerServiceCall,
									financeiros: financeiros,
									resourceId: recebimento.resourceId,
									vlrTotalTitulos: vlrRecebimento,
									dtTransacao: dtTransacao,									
									hostName: hostName,
									tefsEmProcessamento: recebimento.tefsEmProcessamento,
									qtdParcelas: qtdParcelas,
									subtipoVenda: subtipoVenda,
									operacaoCtf: operacaoCtf,
									cnpjCpfEmpresa: cnpjCpfEmpresa
								}
							}
						};

						SanPopup.open(openPopup);
					},
						true
					);
			}
		}
	]);

angular
	.module("snk.commons")
	.controller("RecebimentoCartaoPopupController", ["$scope", "$popupInstance", "ObjectUtils", "Criteria", "StringUtils", "MessageUtils", "ServiceProxy", "dataValue", "TEF", "PreferenciasRecebimentoCartaoPopup", "ServicoSolicitacao", "ServicoDesfazimento", "ServicoCancelamento", "ServicoConfirmacao", "DatasetEvents", "AngularUtil", "i18n", "NumberUtils", "XmlJson", "MGEParameters", "KeyboardManager",
		function ($scope, $popupInstance, ObjectUtils, Criteria, StringUtils, MessageUtils, ServiceProxy, dataValue, TEF, PreferenciasRecebimentoCartaoPopup, ServicoSolicitacao, ServicoDesfazimento, ServicoCancelamento, ServicoConfirmacao, DatasetEvents, AngularUtil, i18n, NumberUtils, XmlJson, MGEParameters, KeyboardManager) {

			var self = this;
			$scope.$enableBtnOk = self.visibleBtnConcluir;
			$scope.$enableBtnNo = !self.wizardBaixa;
			self.gerarRecebimentoCartao = gerarRecebimentoCartao;
			self.fechar = fechar;

			

			const BUSCANDO_INFORMACOES_TIPO_TITULO = "BUSCANDO_INFORMACOES_TIPO_TITULO";
			const TEMPORIZADOR_RECEBIMENTO = "TEMPORIZADOR_RECEBIMENTO";
			const PREFS_PGTO_CARTAO = "prefs_recebimento_cartao";

			var _valorTotalTits;
			var _valorRestante;
			var _valorAprovado;

			var concluirRecebimentoFunction = dataValue.concluirRecebimentoFunction;
			var concluirCancelamentoFunction = dataValue.concluirCancelamentoFunction;
			var atualizarFinanceiroFunction = dataValue.atualizarFinanceiroFunction;
			var fecharRecebimentoFunction = dataValue.fecharRecebimentoFunction;
			var centralDeNotas = dataValue.centralDeNotas;
			var wizardBaixa = dataValue.wizardBaixa;
			var codTipTit = dataValue.codTipTit;
			var utilizaCheckout = dataValue.utilizaCheckout;
			var ownerServiceCall = dataValue.ownerServiceCall;
			var financeiros = dataValue.financeiros;
			var resourceId = dataValue.resourceId;
			var vlrTotalTitulos = dataValue.vlrTotalTitulos;
			let utilizaPdvWeb = dataValue.utilizaPdvWeb;
			let nroParcelasMax = dataValue.nroParcelasMax;
			let vlrParcMinCart = dataValue.vlrParcMinCart;
			var filtraTipMovQtdIguais = MGEParameters.asBoolean("mge.filtra.titulo.qtd.parc");
			var timeOutRecebimento = MGEParameters.asInteger("mgefin.tef.timeout.receb");
			var permiteNovaTentativaConfirmacao = MGEParameters.asBoolean("mgefin.tef.permite.nova.tentativa.confirmacao.erro");
			var dtTransacao = dataValue.dtTransacao;
			var transacoesConfirmadas = dataValue.transacoesConfirmadas;
			var tefsEmProcessamento = dataValue.tefsEmProcessamento;
			var qtdParcelas = dataValue.qtdParcelas;
			var subtipoVenda = dataValue.subtipoVenda;
			var operacaoCtf = dataValue.operacaoCtf;
			var cnpjCpfEmpresa = dataValue.cnpjCpfEmpresa;
			var hostName = dataValue.hostName;
			let isPopupProtected = false;

			var _btnReceberAtivo = true;
			var _tipoTitulo = {};
			var _transacaoComErroDeRecebimento;
			var _transacaoComErroDeConfirmacao;
			var _transacaoComErroDeCancelamento;
			var _transacoesCanceladas = [];
			var _saldo;
			var _disabletnReceberCancelarOnKeyDown = dataValue.disabletnReceberCancelarOnKeyDown === true;

			//Self Enable e Visible
			self.visibleBtnConcluir = true;
			self.visibleBtnFechar = true;
			self.enabledPesqTipoTitulo = true;
			self.enabledVlrTransacaoInput = true;
			self.enableQtdParcelasInput = true;
			self.enableBtnReceberCancelar = true;
			self.visibleProgressBar = false;

			//Self de Labels
			self.lblReceberCancelar = i18n('Commons.RecebimentoCartao.lblReceber');
			self.txtProgressBar = "";
			self.progressBarClass = 'progress-bar progress-bar-striped active';
			self.buildLabelCartao = buildLabelCartao;
			self.buildLabelTipoTitulo = buildLabelTipoTitulo;
			// Self de Funções
			self.receberCancelar = receberCancelar;
			self.environmentCriteriaTipTit = environmentCriteriaTipTit;
			self.afterPopulateHandler = afterPopulateHandler;
			self.disableBtnReceberCancelar = disableBtnReceberCancelar;

			self.buildCelFLoat = buildCelFLoat;

			init();
			function init() {

				var datasetElem = angular.element(AngularUtil.createDirective("sk-dataset", {
					"sk-standalone": "",
					"sk-refresh-handler": "ctrl.carregarDados()",
				}, $scope));

				self.dsTransacao = datasetElem.data("$skDatasetController");

				TEF.createFieldsDataSet(self.dsTransacao).then(function () {
					self.dsTransacao.initAndRefresh()
				});

				self.visibleBtnConcluir = !TEF.isConfirmacaoAutomatica();

				var obsTransacao = new IDataSetObserver();

				obsTransacao.refreshed = function (i) {
					calcularTotalizadores();
					habilitarDesabilitarBotoes();
				}

				obsTransacao.currentLineChanged = function (newIndex) {
					habilitarDesabilitarBotoes();
					mostraCupom(self.dsTransacao.getCurrentRowAsObject());
				}

				self.dsTransacao.addObserver(obsTransacao);
				
				_saldo = NumberUtils.getNumberOrZero(vlrTotalTitulos);

				resetForm();

				if (NumberUtils.getNumberOrZero(codTipTit) != 0) {
					self.pesqTipoTitulo = codTipTit;
				}

				if (NumberUtils.getNumberOrZero(qtdParcelas) > 0) {
					self.qtdParcelasInput = qtdParcelas;
				}

				if (utilizaCheckout == true) {
					self.enabledPesqTipoTitulo = !utilizaCheckout;
					self.enabledVlrTransacaoInput = !utilizaCheckout;
				}

				if (angular.isDefined(self.dsTransacao.isLoaded())) {
					carregarDados();
				} else {
					self.dsTransacao.addEventListener(DatasetEvents.ON_METADATA_UPDATED, function (e) {
						carregarDados();
					});
				}
				
				window.onbeforeunload = function (event) {

					if (!tefsEmProcessamento || tefsEmProcessamento.length === 0) {
						return undefined;
					} else {
						event.preventDefault();
						return '';
					}
				};
				
			}

			function mostraCupom(record) {
				var cupomData = getCupom(record);

				self.cupom = "";

				if (StringUtils.emptyAsNull(cupomData) == null) {
					return;
				}

				self.cupom += "\n";
				self.cupom += cupomData;
			}

			function getCupom(record) {
				var cupomData = null;

				if (record != null) {
					if (record.STATUS == TEF.TRANSACAO_PENDENTE || record.STATUS == TEF.TRANSACAO_CONFIRMADA) {
						if (record.CUPOMESTABELECIMENTO != null) {
							cupomData = record.CUPOMESTABELECIMENTO;
						} else if (record.CUPOMCLIENTE != null) {
							cupomData = record.CUPOMCLIENTE;
						} else {
							cupomData = record.CUPOMREDUZIDO;
						}
					} else if (record.STATUS == TEF.TRANSACAO_EM_CANCELAMENTO || record.STATUS == TEF.TRANSACAO_CANCELADA) {
						if (record.CUPOMESTABELECIMENTOCAN != null) {
							cupomData = record.CUPOMESTABELECIMENTOCAN;
						} else if (record.CUPOMCLIENTECAN != null) {
							cupomData = record.CUPOMCLIENTECAN;
						} else {
							cupomData = record.CUPOMREDUZIDOCAN;
						}
					}
				}
				return cupomData;
			}

			function resetForm() {
				habilitarDesabilitarBotoes();
				calcularTotalizadores();
				self.vlrTransacaoInput = _saldo;
				changeTipoTitulo();
			}
			function carregarDados() {
				if (transacoesConfirmadas && transacoesConfirmadas.length() > 0) {
					var msg = null;
					if (transacoesConfirmadas.length() > 1) {
						msg = i18n('Commons.RecebimentoCartao.msgTransacoesPendentes');
					} else {
						msg = i18n('Commons.RecebimentoCartao.msgTransacaoPendente');
					}

					MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION,
						msg,
						function () {
							angular.forEach(transacoesConfirmadas.transacao, function (item, key) {

								var record = {};
								record.STATUS = TEF.TRANSACAO_CONFIRMADA;

								angular.forEach(item.children(), function (column, key) {
									var fm = self.dsTransacao.getFieldMetadata(column.name());
									var value = DBDataSet.strToTypedData(column.toString(), fm ? fm.type : "S");
									record[column.name()] = value;
								});

								self.dsTransacao.addRecordsAsObjects(record);
							});
							self.dsTransacao.first();
							resetForm();
						}
					);
				}

				if (tefsEmProcessamento && tefsEmProcessamento.length > 0) {
					angular.forEach(tefsEmProcessamento, function (tef, key) {
						self.dsTransacao.addRecordsAsObjects(tef);
					});

					self.dsTransacao.first();
					resetForm();
				}
			}

			function calcularTotalizadores() {
				var valorTotalTrans = getVlrTransacaoTotal();
				_saldo = vlrTotalTitulos - valorTotalTrans;

				_valorTotalTits = parseFloat(vlrTotalTitulos).toFixed(2);
				_valorAprovado = parseFloat(valorTotalTrans).toFixed(2);
				_valorRestante = parseFloat(_saldo).toFixed(2);

				if (wizardBaixa) {
					self.linhaTotais = StringUtils.substitute("<b> <font color=\"#0000FF\"> </font></b>" + i18n('Commons.RecebimentoCartao.lblTotalRecebido') + NumberUtils.format(_valorAprovado, 2));
				} else {
					self.linhaTotais = ("<b>" + i18n('Commons.RecebimentoCartao.lblTotalTitulos') + " <font color=#0000FF>" + NumberUtils.format(_valorTotalTits, 2) + "</font></b> (-) <b> " + i18n('Commons.RecebimentoCartao.lblTotalRecebido') + " <font color=#0000FF>" + NumberUtils.format(_valorAprovado, 2) + "</font></b> (=) <b> " + i18n('Commons.RecebimentoCartao.lblSaldo') + " <font color=#0000FF>" + NumberUtils.format(_valorRestante, 2) + "</font></b> ")
				}
			}

			function getVlrTransacaoTotal() {
				var valor = 0;
				if (self.dsTransacao != null && self.dsTransacao.getRecords().length > 0) {
					angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (row, key) {
						if (row.STATUS == TEF.TRANSACAO_PENDENTE || row.STATUS == TEF.TRANSACAO_CONFIRMADA) {
							valor += row.VLRTRANSACAO;
						}
					});
				}
				return valor;
			}


			function habilitarDesabilitarBotoes() {
				var btnConcluirEnabled = self.dsTransacao.size() > 0 && !_transacaoComErroDeConfirmacao && !self.visibleProgressBar;
				_btnReceberAtivo = !_transacaoComErroDeConfirmacao && !_transacaoComErroDeRecebimento;

				if (!_transacaoComErroDeConfirmacao) {
					angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
						if (current.STATUS != TEF.TRANSACAO_PENDENTE && current.STATUS != TEF.TRANSACAO_CONFIRMADA) {
							btnConcluirEnabled = false;
						}
					});
				}

				if (_btnReceberAtivo) {

					self.lblReceberCancelar = i18n('Commons.RecebimentoCartao.lblReceber');
				} else {
					self.lblReceberCancelar = i18n('Commons.RecebimentoCartao.lblCancelar');
				}

				$scope.$enableBtnOk = self.visibleBtnConcluir = btnConcluirEnabled;
			}
			
			function changeTipoTitulo() {
				var isCertificacao = TEF.isEmCertificacao();

				if (isCertificacao) {
					self.enabledPesqTipoTitulo = false;
					self.enableQtdParcelasInput = false;
					self.enabledVlrTransacaoInput = false;
				} else {
					var operacao = _tipoTitulo != null ? _tipoTitulo.OPERACAOCTF : null;
					var qtdParcelas = _tipoTitulo != null && _tipoTitulo.QTDPARCELCTF != null ? _tipoTitulo.QTDPARCELCTF : 0;
					self.enableQtdParcelasInput = false;

					if (operacao == TEF.CREDITO_A_VISTA.toString() || operacao == TEF.DEBITO_PRE_DATADO.toString() || operacao == TEF.DEBITO.toString()) {
						self.qtdParcelasInput = 1;
					} else if (operacao == TEF.CREDITO_PARCELADO_COM_JUROS.toString() || operacao == TEF.CREDITO_PARCELADO_SEM_JUROS.toString()) {
						if (qtdParcelas > 0) {
							self.qtdParcelasInput = qtdParcelas;
						} else {
							self.enableQtdParcelasInput = true;
						}
					}

					if (!utilizaCheckout) {
						if (centralDeNotas) {
							self.enabledVlrTransacaoInput = false;
							if (NumberUtils.getNumberOrZero(codTipTit) != 0) {
								self.enabledPesqTipoTitulo = false;
							}
						}
					}
				}
							
			}

			function environmentCriteriaTipTit() {
				var expression;
				var qtdParcelas = self.qtdParcelasInput;
				var operacao = operacaoCtf;
				var subtipo = subtipoVenda;			

				var criteria = Criteria();

				if(NumberUtils.getNumberOrZero(qtdParcelas) > 0 && filtraTipMovQtdIguais){
					if (TEF.isEmCertificacao()) {
						expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114','-99') AND nullValue(this.UTILIZAPOS,'N') = 'N' AND this.QTDPARCELCTF = ? AND (this.OPERACAOCTF = ? OR this.SUBTIPOVENDA = ?)";
					} else {
						expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114') AND nullValue(this.UTILIZAPOS,'N') = 'N' AND this.QTDPARCELCTF = ?  AND (this.OPERACAOCTF = ? OR this.SUBTIPOVENDA = ?)";
					}
					criteria.and(expression, [Criteria.buildNumberParameter(qtdParcelas), Criteria.buildStringParameter(operacao), Criteria.buildStringParameter(subtipoVenda)]);
				} else {
				if (TEF.isEmCertificacao()) {
					expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114','-99') AND nullValue(this.UTILIZAPOS,'N') = 'N'";
				} else {
					expression = "this.SUBTIPOVENDA IN('7','8','9') AND this.OPERACAOCTF IN('101','103','104','105','106','112','113','114') AND nullValue(this.UTILIZAPOS,'N') = 'N'";
				}
				criteria.and(expression);
				}
				return criteria;
			}

			function receberCancelar() {
				if (_btnReceberAtivo) {
					receber();
				} else {
					cancelar();
				}
			}

			function receber() {
				var qtdParcelas = isNaN(self.qtdParcelasInput) ? 0 : self.qtdParcelasInput;
				var vlrTransacao = isNaN(self.vlrTransacaoInput) ? 0 : Number(self.vlrTransacaoInput);
				var operacao = _tipoTitulo != null ? _tipoTitulo.OPERACAOCTF : null;
				var vlrTransacaoTotal = getVlrTransacaoTotal() + vlrTransacao;
				var contadorReceb;

				qtdParcelas = qtdParcelas <= 0 ? 1 : qtdParcelas;

				if(qtdParcelas == null || qtdParcelas == undefined){
					MessageUtils.showAlert('Preencha o campo Qtd Parcelas!');
					return;
				}

				if(utilizaPdvWeb == 'S'){
					if(NumberUtils.getNumberOrZero(nroParcelasMax) > 0 && qtdParcelas > nroParcelasMax){
						MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Qtd de parcela não permitida. Verifique a Qtd de parcelas maximas configurada em Tipo de Titulos>>Preferencias de Cartões>>Qtd Maxima de Parcelas'));
						return;
					}
					if(qtdParcelas > 1 && (NumberUtils.getNumberOrZero(vlrTransacao) / qtdParcelas) <  vlrParcMinCart){
						MessageUtils.showAlert(i18n('Valor da parcela mínima de parcelamento inferior ao valor permitido.'));
						return;
					}
					if(qtdParcelas == 1){
						operacao = _tipoTitulo.SUBTIPOVENDA  == 8 ? 101 : 112;
					} 
				}

				if (vlrTransacao <= 0) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoVlrTransacao') + ".");
					return;
				}

				if (operacao == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoTipoTitulo') + ".");
					return;
				}

				if (dtTransacao == null) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoDtTransacao') + ".");
					return;
				}

				if (angular.isUndefined(self.pesqTipoTitulo) || StringUtils.emptyAsNull(self.pesqTipoTitulo) == null || (StringUtils.emptyAsNull(self.pesqTipoTitulo) != StringUtils.emptyAsNull(_tipoTitulo.CODTIPTIT))) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoTipoTitulo') + ".");
					return;
				}

				if (!wizardBaixa && vlrTransacaoTotal > vlrTotalTitulos) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgInfoTotalTransMaiorTotalTit') + ".");
					return;
				}

				if (qtdParcelas == 1 && (operacao == "113" || operacao == "114")) {
					MessageUtils.showAlert(MessageUtils.TITLE_ERROR, i18n('Commons.RecebimentoCartao.msgOpCredNecessQtdParcMaiorQUm') + ".");
					return;
				} 
				disableCloseActions();
				var solicitacao = {};

				solicitacao.OPERACAO = operacao;
				solicitacao.VLRTRANSACAO = NumberUtils.format(vlrTransacao, 2);
				solicitacao.QTDPARCELAS = qtdParcelas;
				solicitacao.DTTRANSACAO = dtTransacao;
				solicitacao.NUMTRANS = getNumTrans();
				solicitacao.CODTIPTIT = _tipoTitulo.CODTIPTIT;
				solicitacao.DESCRTIPTIT = _tipoTitulo.DESCRTIPTIT;
				solicitacao.CNPJCPFEMPRESA = cnpjCpfEmpresa;
				solicitacao.REQUESTTIMEOUT = timeOutRecebimento;
				solicitacao.NROPARCELASMAX = nroParcelasMax;
				solicitacao.ULTILIZAPDVWEB = utilizaPdvWeb;
				solicitacao.VLRPARCMINCART = vlrParcMinCart;

				var servico = ServicoSolicitacao;
				servico.setDataSet(self.dsTransacao);
				servico.setFinanceiros(financeiros);

				servico.setSucessoFunction(function () {
					clearInterval(contadorReceb);
					ligarDesligarProcessamento();
					resetForm();

					if (TEF.isConfirmacaoAutomatica() && _saldo == 0) {
						gerarRecebimentoCartao();
					}
					enableCloseActions();
				});

				servico.setErroFunction(function (erro) {
					if (TEF.isEmCertificacao() && concluirCancelamentoFunction != null) {
						concluirCancelamentoFunction(erro);
						doClose();
					} else {
						clearInterval(contadorReceb);
						ligarDesligarProcessamento();
						changeTipoTitulo();
						processarErros(erro);
					}
					enableCloseActions();
				});

				var solicitar = function () {
					if(timeOutRecebimento > 0) {
						let duracao = timeOutRecebimento;						
						contadorRecebimento(duracao);						
						servico.solicitarTransacao(solicitacao);
					} else {
					ligarDesligarProcessamento(TEF.SERVICO_SOLICITAR_TRANSACAO, true);
					servico.solicitarTransacao(solicitacao);
					}
					
				};

				if (exigeConfirmacaoMultCartoes()) {
					confirmar(solicitar);
				} else {
					solicitar();
				}
				
				function contadorRecebimento(duration) {
					function paddedFormat(num) {
						return num < 10 ? "0" + num : num; 
			}
			

					let secondsRemaining = duration;
					let min = 0;
					let sec = 0;
				
					contadorReceb = setInterval(function () {
				
						min = parseInt(secondsRemaining / 60);
						sec = parseInt(secondsRemaining % 60);
										
						var time = `${paddedFormat(min)}:${paddedFormat(sec)}`;
												
						ligarDesligarProcessamento(TEMPORIZADOR_RECEBIMENTO, true, time);
						self.dsTransacao.refresh();
						
						secondsRemaining = secondsRemaining - 1;
						if (secondsRemaining < 0) {
							ligarDesligarProcessamento();
							clearInterval(contadorReceb) ;
						};
				
					}, 1000);
				}
			}
			

			function cancelar(){

				var record = self.dsTransacao.getCurrentRowAsObject();

				if (record != null) {
					
					if (record.STATUS == TEF.TRANSACAO_PENDENTE) {
						solicitarDesfazimento();
					} else if (record.STATUS == TEF.TRANSACAO_CONFIRMADA) {
						solicitarCancelamento();
					}
				}

			}

			function confirmar(callback) {
				ligarDesligarProcessamento(TEF.SERVICO_CONFIRMAR_TRANSACAO, true);

				var servico = ServicoConfirmacao;
				servico.setDataSet(self.dsTransacao)
				servico.setFinanceiros(financeiros);

				servico.setSucessoFunction(function () {
					ligarDesligarProcessamento();
					if (exigeConfirmacaoMultCartoes()) {
						confirmar(callback);
					} else {
						callback();
					}
				})

				servico.setErroFunction(function (erro) {
					_transacaoComErroDeConfirmacao = true;
					ligarDesligarProcessamento();
				});

				servico.processarConfirmacao();
			}

			function gerarRecebimentoCartao() {
				var recebimentos = self.dsTransacao.getRecordsAsObjects();

				if (wizardBaixa) {
					if (concluirRecebimentoFunction != null) {
						var result = {};

						result.recebimentos = recebimentos;

						doClose();
						concluirRecebimentoFunction(result);
					}
				} else {
					var params = { centralDeNotas: centralDeNotas ? "S" : "N" };

					var prefsPgtoCartao = {
						chave: resourceId + "." + PreferenciasRecebimentoCartaoPopup.PREFS_PGTO_CARTAO
					}

					params.prefsPgtoCartao = prefsPgtoCartao;

					var Financeiro = [];

					angular.forEach(financeiros, function (financeiro, key) {
						Financeiro.push({ $: financeiro.$ });
					});
					var financeiro = { financeiro: Financeiro }
					params.financeiros = financeiro;

					var optionDateFormat = {
						year: 'numeric', month: 'numeric', day: 'numeric',
						hour: 'numeric', minute: 'numeric', second: 'numeric',
						hour12: false
					}
					var confirmouRecebimentoCartao = true;
					var recebimentosXML = [];

					angular.forEach(recebimentos, function (recebimento, key) {

						if (confirmouRecebimentoCartao) {
							confirmouRecebimentoCartao = recebimento.STATUS == TEF.TRANSACAO_CONFIRMADA;
						}

						var recebimentoXML = {
							NSUCTF: { $: stringEmpty(recebimento.NSUCTF) },
							CODTIPTIT: { $: stringEmpty(recebimento.CODTIPTIT) },
							OPERACAO: { $: stringEmpty(recebimento.OPERACAO) },
							NUMTRANS: { $: stringEmpty(recebimento.NUMTRANS) },
							CODRESPAUTORIZADORA: { $: stringEmpty(recebimento.CODRESPAUTORIZADORA) },
							CODAPROVACAO: { $: stringEmpty(recebimento.CODAPROVACAO) },
							VLRTRANSACAO: { $: stringEmpty(recebimento.VLRTRANSACAO) },
							NSUAUTORIZADORA: { $: stringEmpty(recebimento.NSUAUTORIZADORA) },
							DTTRANSACAO: { $: Intl.DateTimeFormat('pt-BR', optionDateFormat).format(stringEmpty(recebimento.DTTRANSACAO)).replace(/,/g, "") },
							QTDPARCELAS: { $: stringEmpty(recebimento.QTDPARCELAS) },
							BANDEIRA: { $: stringEmpty(recebimento.BANDEIRA) },
							REDEADQUIRENTE: { $: stringEmpty(recebimento.REDEADQUIRENTE) },
							CODREDEADQUIRENTE: { $: stringEmpty(recebimento.CODREDEADQUIRENTE) },
							CARTAO: { $: stringEmpty(recebimento.CARTAO) },
							STATUS: { $: stringEmpty(recebimento.STATUS) },
							REQUISICAO: { $: stringEmpty(recebimento.REQUISICAO) },
							RETORNO: { $: stringEmpty(recebimento.RETORNO) },
							REQUISICAOCONFIRMACAO: { $: stringEmpty(recebimento.REQUISICAOCONFIRMACAO) },
							RETORNOCONFIRMACAO: { $: confirmouRecebimentoCartao ? 'S': 'N' },
							IDENTIFICACAOTEF: { $: stringEmpty(recebimento.IDENTIFICACAOTEF) }
						}

						if (StringUtils.emptyAsNull(recebimento.DTPREDATADO)) {
							recebimento.DTPREDATADO = { $: (recebimento.DTPREDATADO, "DD/MM/YYYY") }
						}

						recebimentosXML.push(recebimentoXML);
					});
					var recebimento = { recebimento: recebimentosXML }
					params.recebimentos = recebimento;

					if (ownerServiceCall) {
						params.ownerServiceCall = ownerServiceCall;
					}

					ligarDesligarProcessamento(TEF.SERVICO_GERANDO_RECEBIMENTO, true);

					var conversationId = !confirmouRecebimentoCartao ? UIDGenerator.generateUID(resourceId + "_") : null;

					params.hostName = hostName;

					params = { params: params }
					ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarRecebimento",
						params, { aditionalUrlParameters: { 'conversation-id': conversationId }, ignorePopUpErrorMsgs: true }).then(function (response) {
							var info = response.responseBody.info;
							if (angular.isDefined(info.NURENEG))
								var nuReneg = StringUtils.emptyAsNull(info.NURENEG.$);
							if (angular.isDefined(info.NUACERTO))
								var nuAcerto = StringUtils.emptyAsNull(info.NUACERTO.$);

							atualizarRecebimento(nuReneg != null ? Number(nuReneg) : 0, nuAcerto != null ? Number(nuAcerto) : 0);

							if (concluirRecebimentoFunction != null) {
								doClose();

								if (utilizaCheckout) {
									concluirRecebimentoFunction();
								} else {
									concluirRecebimentoFunction({ nuReneg: nuReneg, nuAcerto: nuAcerto });
								}
							} else {
								MessageUtils.showInfo(
									MessageUtils.TITLE_INFORMATION
									, i18n('Commons.RecebimentoCartao.msgRecebSucesso') + "."
									, function () {
										doClose();
									}
								);
							}

							ligarDesligarProcessamento();

						}).catch(function (statusMessage) {
							if(permiteNovaTentativaConfirmacao){
								MessageUtils.simpleConfirm(
									MessageUtils.TITLE_INFORMATION
									, statusMessage.statusMessage + "\n\nDeseja tentar novamente?"
									, true
								).then(() => { 
									//NADA A FAZER
								}, () => {
									//MARCAR O FINANCEIRO COMO ELEGIVEL PARA RECEBIMENTO ADMINISTRATIVO
									marcarFinanceiroRecebAdmin();
									ligarDesligarProcessamento();
									_transacaoComErroDeRecebimento = true;
									processarCancelamento();
								});
							} else {
							MessageUtils.showError(
								MessageUtils.TITLE_INFORMATION
								, statusMessage.statusMessage
							).then(
									() => {
									//MARCAR O FINANCEIRO COMO ELEGIVEL PARA RECEBIMENTO ADMINISTRATIVO
									marcarFinanceiroRecebAdmin();																		
									ligarDesligarProcessamento();
									_transacaoComErroDeRecebimento = true;
									processarCancelamento();
								});														
							}
						});

					aguardarPreparacaoRecebimento(conversationId);
				}
			}

			function processarCancelamento(){
				var qtdParaCancelar = 0;

				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (record, key) {
					if (record.STATUS == TEF.TRANSACAO_CONFIRMADA || record.STATUS == TEF.TRANSACAO_PENDENTE) {
						qtdParaCancelar++;
					}
				});

				if (qtdParaCancelar > 0) {
					habilitarDesabilitarBotoes();

					MessageUtils.showAlert(
						MessageUtils.TITLE_WARNING
						, i18n('Commons.RecebimentoCartao.msgSugerirCancel')
					);

				}

			}

			function aguardarPreparacaoRecebimento(conversationId) {
				if (conversationId != null) {
					var waitParam = {
						wait: {
							signal: {
								"$": "recebimento.cartao.executa.confirmacao.tef"
							}
						}
					}
					ServiceProxy.callService("mge@XConversation.waitSignal",
						waitParam, { aditionalUrlParameters: { 'conversation-id': conversationId } }).then(function (response) {

							var sigResult = ObjectUtils.getProperty(response, 'responseBody.signal-result');

							var status = parseInt(sigResult.status.$.toString());
							if (status == 0) {
								processarConfirmacao(conversationId);
							}
						});
				}
			}

			function enviarSinalConfirmacaoCartao(conversationId, signal, data) {
				if (conversationId != null) {
					var sendParam = {
						send:
							{ signal: { $: signal } }
					};

					if (data != null) {
						sendParam.send.data = data;
					}

					ServiceProxy.callService("mge@XConversation.sendSignal",
						sendParam, { aditionalUrlParameters: { 'conversation-id': conversationId } }).then(function (response) {
							var sigResult = ObjectUtils.getProperty(response, 'responseBody.signal-result');

							var status = parseInt(sigResult.status.$.toString());

							if (status == 1 && signal == "recebimento.cartao.confirmacao.tef.ok") {
								gerarRecebimentoCartao();
							}
						});
				}
			}

			function afterPopulateHandler(obj) {
				if (angular.isUndefined(self.pesqTipoTitulo)) {
					return;
				}
				obj = self.pesqTipoTitulo;
				if (obj != null && !StringUtils.isEmpty(obj)) {
					var prefsCartao = { 
						chave: resourceId + "." + PREFS_PGTO_CARTAO
					};

					var params = {
						params:
						{
							codTipTit: obj,
							wizardBaixa: wizardBaixa ? "S" : "N",
							prefsPgtoCartao: prefsCartao
						}
					}

					codTipTit = Number(obj);

					ligarDesligarProcessamento(BUSCANDO_INFORMACOES_TIPO_TITULO, true);
					ServiceProxy.callService(
						"mge@RecebimentoComCartaoSP.carregarTipoTitulo", 
						params,
						{
							ignorePopUpErrorMsgs: true
						}
					).then(
						function (result) {
							ligarDesligarProcessamento();
							habilitarDesabilitarBotoes();

							var tipoTitulo = result.responseBody.tipoTitulo;

							_tipoTitulo = new Object();
							_tipoTitulo.CODTIPTIT = Number(tipoTitulo.CODTIPTIT.$.toString());
							_tipoTitulo.DESCRTIPTIT = tipoTitulo.DESCRTIPTIT.$.toString();
							_tipoTitulo.SUBTIPOVENDA = tipoTitulo.SUBTIPOVENDA.$.toString();
							_tipoTitulo.OPERACAOCTF = Object.keys(tipoTitulo.OPERACAOCTF) != "" ? tipoTitulo.OPERACAOCTF.$.toString() : " ";
							_tipoTitulo.QTDPARCELCTF = Number(tipoTitulo.QTDPARCELCTF.$.toString());
							_tipoTitulo.ULTILIZAPDVWEB = tipoTitulo.ULTILIZAPDVWEB.$.toString();
							_tipoTitulo.VLRPARCMINCART = Number(tipoTitulo.VLRPARCMINCART.$.toString());
							_tipoTitulo.NROPARCELASMAX = Number(tipoTitulo.NROPARCELASMAX.$.toString());

							changeTipoTitulo();
						},
						function (errorObj) {
							ligarDesligarProcessamento();
							habilitarDesabilitarBotoes();
							self.pesqTipoTitulo = "";

							if (!wizardBaixa) {
								MessageUtils.simpleConfirm(
									MessageUtils.TITLE_CONFIRMATION, i18n('Commons.RecebimentoCartao.msgNecessConfigBaixaPrefCartao'))
									.then(function () {
										abrirPreferenciasRecebimentoCartao();
									});
							}
						});
				}
			}

			function abrirPreferenciasRecebimentoCartao() {
				var idTela = resourceId + "." + PreferenciasRecebimentoCartaoPopup.PREFS_PGTO_CARTAO;
				var config = XmlJson.create('config', {chave: idTela, tipo: "T" });

				ServiceProxy.callService("mge@SystemUtilsSP.getConf", config, { normalizedJson: true })
					.then(function (response) {
						var preferencia = {
							"resourceID": idTela,
							"centraldeNotas": centralDeNotas,
							"concluir": () => {
								if (codTipTit > 0) {
									self.pesqTipoTitulo = codTipTit;
								}
							}
						}

						if (XmlJson.isNormalized(response)) {
							XmlJson.denormalize(response);
						}

						var configTela = ObjectUtils.getProperty(response, 'responseBody.config');

						if (configTela) {
							preferencia.configTela = configTela
						}

						PreferenciasRecebimentoCartaoPopup.openPopUp(preferencia)
					})
			}

			function ligarDesligarProcessamento(serviceName = null, ligar = false, tempo = 0) {
				self.enableBtnReceberCancelar = ligar ? false : true;
				self.visibleBtnFechar = ligar ? false : true;
				self.visibleBtnConcluir = ligar ? false : true;
				$scope.$enableBtnOk = ligar ? false : true;
				$scope.$enableBtnNo = ligar ? false : true;
				self.enableQtdParcelasInput = ligar ? false : true;

				if (!utilizaCheckout) {
					self.enabledVlrTransacaoInput = ligar ? false : true;
					self.enabledPesqTipoTitulo = ligar ? false : true;
				}

				self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgExecOperacao');

				if (serviceName == TEF.SERVICO_SOLICITAR_TRANSACAO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitInfoReceb');
				} else if (serviceName == TEF.SERVICO_CONFIRMAR_TRANSACAO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitConfirmTrans');
				} else if (serviceName == TEF.SERVICO_DESFAZER_TRANSACAO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitDesfTrans');
				} else if (serviceName == TEF.SERVICO_CONCLUINDO_RECEBIMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitImpComprovante');
				} else if (serviceName == TEF.SERVICO_GERANDO_RECEBIMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgRegistrandoTrans');
				} else if (serviceName == TEF.SERVICO_SOLICITAR_CANCELAMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitInfoCancel');
				} else if (serviceName == TEF.SERVICO_CONFIRMAR_CANCELAMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitConfirmCancel');
				} else if (serviceName == TEF.SERVICO_CONCLUINDO_CANCELAMENTO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgProcessCancelSemImpComprovante');
				} else if (serviceName == TEF.SERVICO_CONCLUINDO_CANCELAMENTO_IMPRESSAO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgProcessCancelImpComprovante');
				} else if (serviceName == BUSCANDO_INFORMACOES_TIPO_TITULO) {
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgProcInfoTipTit');
				} else if (serviceName == TEMPORIZADOR_RECEBIMENTO){
					self.txtProgressBar = i18n('Commons.RecebimentoCartao.msgSolicitInfoReceb') + " - Tempo restante: " + tempo;
				}

				self.visibleProgressBar = ligar ? true : false;
			}

			function exigeConfirmacaoMultCartoes() {
				var exigeConfirmacaoMultCartoes = false;
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (record, key) {
					if (record.EXIGECONFIRMULTCARTOES == "S" && record.STATUS != TEF.TRANSACAO_CONFIRMADA) {
						exigeConfirmacaoMultCartoes = true;
					}
				});
				return exigeConfirmacaoMultCartoes;
			}

			function getNumTrans() {
				return self.dsTransacao.size() + 1;
			}


			function processarErros(erro) {
				var codRetorno = erro.codRetorno;
				var serviceName = erro.servico;
				var msgErro = erro.msgErro;
				var callbackReprocessar = null;

				if (serviceName == TEF.SERVICO_SOLICITAR_TRANSACAO) {
					callbackReprocessar = receber;
				} else if (serviceName == TEF.SERVICO_CONFIRMAR_TRANSACAO) {
					callbackReprocessar = processarConfirmacao;
				} else if (serviceName == TEF.SERVICO_DESFAZER_TRANSACAO) {
					callbackReprocessar = solicitarDesfazimento;
				} else if (serviceName == TEF.SERVICO_SOLICITAR_CANCELAMENTO) {
					callbackReprocessar = solicitarCancelamento;
				}

				switch (codRetorno) {
					case TEF.DADO_INVALIDO:
						doProcessarErro(msgErro, serviceName, null);
						break;

					case TEF.TIME_OUT:
						doProcessarErro(msgErro, serviceName, callbackReprocessar);
						break;

					case TEF.TRANSACAO_NAO_AUTORIZADA_PELA_AUTORIZADORA:
						doProcessarErro(msgErro, serviceName, null);
						break;

					case TEF.TRANSACAO_NAO_AUTORIZADA_PELO_CTF:
						doProcessarErro(msgErro, serviceName, null);
						break;

					case TEF.ERRO_NA_CAMADA_INTERNET:
					case TEF.ERRO_NA_CAMADA_INTERTEF:
						doProcessarErro(msgErro, serviceName, callbackReprocessar);
						break;

					case TEF.ERRO_NA_CAMADA_PROCESSAMENTO:
					case TEF.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO:
						doProcessarErro(msgErro, serviceName, null);
						break;
					case TEF.ERRO_GENERICO:
						msgErro = "Ocorreu um erro na operação. Entre em contato com suporte da sua INTEGRADORA TEF."
						doProcessarErro(msgErro, serviceName, null);
						break;

					default:
						doProcessarErro(msgErro, serviceName, null);
						break;
				}
			}

			function doClose(isCancelamento = false) {
				if ((fecharRecebimentoFunction != null && self.dsTransacao.size() == 0) || isCancelamento) {
					fecharRecebimentoFunction();
				}
				$popupInstance.success('sucess');
			}

			function fechar() {
				if (wizardBaixa) {
					if (concluirRecebimentoFunction != null) {
						var result = {};
						result.recebimentos = self.dsTransacao.getRecordsAsObjects();

						doClose();
						concluirRecebimentoFunction(result);
					} else {
						doClose();
					}
				} else {
					var temTransacaoAprovada = false;
					var temTransacaoConfirmada = false;
					var temCancelamentoAprovado = false;
					var ultTransPendente = null;
					angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
						if (current.STATUS == TEF.TRANSACAO_PENDENTE) {
							temTransacaoAprovada = true;
							ultTransPendente = current;
						} else if (current.STATUS == TEF.TRANSACAO_CONFIRMADA) {
							temTransacaoConfirmada = true;
						} else if (current.STATUS == TEF.TRANSACAO_EM_CANCELAMENTO) {
							temCancelamentoAprovado = true;
						}
					});

					var msg = null;

					if (temTransacaoAprovada && !temTransacaoConfirmada && !temCancelamentoAprovado) {
						msg = i18n('Commons.RecebimentoCartao.msgTransPendConfirm');
					} else if (temTransacaoConfirmada && _transacaoComErroDeConfirmacao) {
						msg = i18n('Commons.RecebimentoCartao.msgTransConfirCancel');
					} else if (temCancelamentoAprovado && _transacaoComErroDeCancelamento) {
						msg = i18n('Commons.RecebimentoCartao.msgErroCancelNaoConfirm');
					}

					if (msg != null) {
						MessageUtils.simpleConfirm(
							MessageUtils.TITLE_CONFIRMATION,
							msg).then(function () {
								if (ultTransPendente) {
									ServicoDesfazimento.desfazerSilencioso(ultTransPendente, function () {
										doClose(true);
									});
								} else {
									doClose();
								}
							})
					} else if (ultTransPendente) {
						MessageUtils.simpleConfirm(
							MessageUtils.TITLE_CONFIRMATION, i18n('Commons.RecebimentoCartao.msgTransPendConfirm')).then(function () {
								ServicoDesfazimento.desfazerSilencioso(ultTransPendente, function () {
									doClose(true);
							})
						});
					} else {
						doClose();
					}
				}

			}

			function concluirCancelamento() {
				if (self.dsTransacao.size() == 0) {
					MessageUtils.showInfo(
						MessageUtils.TITLE_INFORMATION
						, i18n('Commons.RecebimentoCartao.msgCancelSucesso') + "."
						, function () {
							doClose();

							if (concluirCancelamentoFunction != null) {
								concluirCancelamentoFunction();
							}
						}
					);
				}
			}

			function doProcessarErro(msg, serviceName, callbackReprocessar = null) {
				if (callbackReprocessar != null) {
					msg += "\n\n" + i18n('Commons.RecebimentoCartao.msgDesejaReprocessTrans');

					MessageUtils.simpleConfirm(
						MessageUtils.TITLE_CONFIRMATION,
						msg,
						function () {
							if (callbackReprocessar != null) {
								callbackReprocessar();
							}
						},
						function () {
							habilitarDesabilitarBotoes();
							changeTipoTitulo();
						}
					);
				} else {
					habilitarDesabilitarBotoes();
					changeTipoTitulo();
					//MARCAR O FINANCEIRO COMO ELEGIVEL PARA RECEBIMENTO ADMINISTRATIVO
					marcarFinanceiroRecebAdmin();

					MessageUtils.showError(
						MessageUtils.TITLE_ERROR
						, i18n('Commons.RecebimentoCartao.msgErroProcTrans') + ". \n\n Erro: " + msg
					);
				}
			}

			function marcarFinanceiroRecebAdmin(){

				var params = {};
	
				if (financeiros && financeiros.length > 0) {
					var Financeiro = [];
					angular.forEach(financeiros, function (fin, key) {
						Financeiro.push({ $: fin.$ });
					});
					params.financeiros = { financeiro: Financeiro };
				}
				params = { params: params }
								
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.marcarFinRecebimentoAdministrativo",
				params).then(function (response) {
					if (atualizarFinanceiroFunction != null) {
						atualizarFinanceiroFunction();
					}
				});				

			}
			
			function processarConfirmacao(conversationId) {
				ligarDesligarProcessamento(TEF.SERVICO_CONFIRMAR_TRANSACAO, true);

				var servico = ServicoConfirmacao;
				servico.setDataSet(self.dsTransacao);

				servico.setSucessoFunction( () => {
					var retornoSucesso = { data: {} };

					var recebimentos = self.dsTransacao.getRecordsAsObjects();

					if (recebimentos != null && recebimentos.length > 0) {
						var tefsXML = { tefs: { type: "X" } };
						var tef = []
						angular.forEach(recebimentos, function (titulo, key) {
							if (StringUtils.emptyAsNull(titulo.NSUCTF) != null) {

								tef.push({
										NSUCTF: { $: stringEmpty(titulo.NSUCTF) },
										REQUISICAOCONFIRMACAO: { $: stringEmpty(titulo.REQUISICAOCONFIRMACAO) },
										RETORNOCONFIRMACAO: { $: stringEmpty(titulo.RETORNOCONFIRMACAO) }
								})


							}
						});

						tefsXML.tefs.tef = tef;
						retornoSucesso.data.tefsXML = tefsXML.tefs;
					}

					enviarSinalConfirmacaoCartao(conversationId, "recebimento.cartao.confirmacao.tef.ok", retornoSucesso.data);

					_transacaoComErroDeConfirmacao = false;
					ligarDesligarProcessamento();
				});

				servico.setErroFunction ( (erro) => {
					var retornoErro = { erro: { type: "S", $: erro.msgErro } };
					enviarSinalConfirmacaoCartao(conversationId, "recebimento.cartao.confirmacao.tef.cancelar", retornoErro);

					_transacaoComErroDeConfirmacao = true;
					ligarDesligarProcessamento();
				});

				servico.processarConfirmacao();
			}

			function solicitarDesfazimento() {
				ligarDesligarProcessamento(TEF.SERVICO_DESFAZER_TRANSACAO, true);

				var servico = ServicoDesfazimento;
				servico.setDataSet(self.dsTransacao);				

				servico.setSucessoFunction( () => {
					ligarDesligarProcessamento();
					concluirCancelamentoCartao();
				});

				servico.setErroFunction( () => {
					ligarDesligarProcessamento();
					processarErros(erro);
				});

				servico.solicitarDesfazimento();

			}

			function solicitarCancelamento() {
				ligarDesligarProcessamento(TEF.SERVICO_SOLICITAR_CANCELAMENTO, true);

				var servico = ServicoCancelamento;
				servico.setDataSet(self.dsTransacao);

				servico.setSucessoFunction( () => {
					_transacaoComErroDeCancelamento = false;
					ligarDesligarProcessamento();
					concluirCancelamentoCartao();
				});
				
				servico.setErroFunction( () => {
					_transacaoComErroDeCancelamento = true;
					ligarDesligarProcessamento();
					processarErros(erro);
				});

				servico.solicitarCancelamento();
			}

			function stringEmpty(string) {

				if (angular.isUndefined(string) || string == null) {
					return " "
				}
				else {
					return string
				}
			}

			var UIDGenerator = new (function () {
				var self = this;

				self.generateUID = generateUID;
				self.generateTinyUID = generateTinyUID;

				var CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";
				var _lastUID;

				function generateUID(prefix) {
					if (prefix == null) {
						prefix = "uid_";
					}

					if (_lastUID) {
						_lastUID++;
					} else {
						var now = new Date();
						_lastUID = now.getTime();
					}

					return prefix + generateTinyUID(_lastUID);
				}

				function generateTinyUID(i) {
					return i < CHARS.length
						? CHARS.charAt(i)
						: arguments.callee(i / CHARS.length - 1) +
						CHARS.charAt(i % CHARS.length);
				}
			});

			function atualizarRecebimento(nuReneg, nuAcerto) {
				var index = -1;
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					index++;

					self.dsTransacao.gotoRow(index).then(() => {

						if (nuReneg != 0) {
							self.dsTransacao.setFieldValue("NURENEG", nuReneg);
						}

						if (nuAcerto != 0) {
							self.dsTransacao.setFieldValue("NUACERTO", nuAcerto);
						}

						self.dsTransacao.save();
					});
				});
			}

			function concluirCancelamentoCartao() {
				var params = { params: { centralDeNotas: centralDeNotas ? "S" : "N" } };

				var temCancelamentosParaConcluir = false;

				var listCancelamento = [];

				var temImpressao = false;

				var cancelamentos = self.dsTransacao.getRecordsAsObjects();

				angular.forEach(cancelamentos, function (cancelamento, key) {
					if (cancelamento.STATUS == TEF.TRANSACAO_CANCELADA || cancelamento.STATUS == TEF.TRANSACAO_DESFEITA) {
						var cancel = {};

						cancel.NSUCTF = { $: cancelamento.NSUCTF };
						cancel.REQUISICAO = { $: stringEmpty(cancelamento.REQUISICAO) };
						cancel.RETORNO = { $: stringEmpty(cancelamento.RETORNO) };

						if (cancelamento.STATUS == TEF.TRANSACAO_CANCELADA) {
							temImpressao = true;
							cancel.REQUISICAOCONFIRMACAO = { $: stringEmpty(cancelamento.REQUISICAOCONFIRMACAO) };
							cancel.RETORNOCONFIRMACAO = { $: stringEmpty(cancelamento.RETORNOCONFIRMACAO) };
						} else {
							cancel.DESFAZIMENTO = { $: "S" };
						}

						if (!StringUtils.isEmpty(cancelamento.NURENEG)) {
							cancel.NURENEG = { $: cancelamento.NURENEG };
						}

						if (!StringUtils.isEmpty(cancelamento.NUACERTO)) {
							cancel.NUACERTO = { $: cancelamento.NUACERTO };
						}

						listCancelamento.push(cancel)

						temCancelamentosParaConcluir = true;
					}
				});


				if (!temCancelamentosParaConcluir) {
					MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.RecebimentoCartao.msgNaoExistCancConf'));
					return;
				}

				params.params.cancelamentos = { cancelamento: listCancelamento };

				if (temImpressao) {
					ligarDesligarProcessamento(TEF.SERVICO_CONCLUINDO_CANCELAMENTO_IMPRESSAO, true);
				} else {
					ligarDesligarProcessamento(TEF.SERVICO_CONCLUINDO_CANCELAMENTO, true);
				}
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarCancelamento",
					params).then(function (response) {
						removerTransacoesCanceladas();
						ligarDesligarProcessamento();
						concluirCancelamento();

						if (self.dsTransacao.isEmpty()) {
							doClose();

							if (concluirCancelamentoFunction != null) {
								concluirCancelamentoFunction();
							}
						}

					}).catch(() => {
						ligarDesligarProcessamento();
						habilitarDesabilitarBotoes();

						MessageUtils.showAlert(
							MessageUtils.TITLE_WARNING,
							i18n('Commons.RecebimentoCartao.msgSugerirCancelAdmin')
						);

						return true;
					}
					);
			}


			function removerTransacoesCanceladas() {
				var records = [];
				angular.forEach(self.dsTransacao.getRecordsAsObjects(), function (current, key) {
					if (current.STATUS == TEF.TRANSACAO_CANCELADA || current.STATUS == TEF.TRANSACAO_DESFEITA) {
						_transacoesCanceladas.push(current);
					} else {
						records.push(current);
					}
				})
				self.dsTransacao.clearDataSet();
				self.dsTransacao.addRecordsAsObjects(records);
			}

			function buildLabelCartao(col, value, record) {
				var label =value;

				if (StringUtils.emptyAsNull(label) != null && label.length > 4) {
					label = label.substring(label.length - 4, label.length);
				}

				return label;
			}

			function buildLabelTipoTitulo(col, value, record) {

				var label = value.toString() + "-" + record[8].toString()

				return label;
			}

			function buildCelFLoat(col, value, record) {
				if (value == undefined) {
					return NumberUtils.format(0, 2);
				} else if (value && typeof value === 'number') {
					return NumberUtils.format(value, 2);
				} else {
					var valueNumber = NumberUtils.stringToNumber(value);
					return NumberUtils.format(valueNumber, 2);
				}
			}

			function disableBtnReceberCancelar(){
				if(!_disabletnReceberCancelarOnKeyDown) return;
				self.enableBtnReceberCancelar = false;
			}
			
			function disableCloseActions() {
			    isPopupProtected = true;
			    document.addEventListener('keydown', preventClose, true);
			    document.addEventListener('click', preventClose, true);
			    document.addEventListener('mousedown', preventClose, true);
			    window.addEventListener('beforeunload', preventBeforeUnload, true);
			}
			
			function enableCloseActions() {
			    isPopupProtected = false;
			
			    document.removeEventListener('keydown', preventClose, true);
			    document.removeEventListener('click', preventClose, true);
			    document.removeEventListener('mousedown', preventClose, true);
			    window.removeEventListener('beforeunload', preventBeforeUnload, true);
			}
			
			function preventClose(event) {
			    if (isPopupProtected) {
			        event.preventDefault();
			        event.stopPropagation();
			    }
			}
			
			function preventBeforeUnload(event) {
			    if (isPopupProtected) {
			        event.preventDefault();
			        event.returnValue = '';
			    }
			}


		}
	]);

angular
	.module("snk.commons")
	.service("RecebimentoCartaoPopup", ["SanPopup", "MessageUtils", "SkI18nService", "i18n", "ServicosGateway", "ServicoDesfazimento", "StringUtils", "ServiceProxy", "ObjectUtils", "DateUtils", "TEF", "NumberUtils",
		function (SanPopup, MessageUtils, SkI18nService, i18n, ServicosGateway, ServicoDesfazimento, StringUtils, ServiceProxy, ObjectUtils, DateUtils, TEF, NumberUtils) {
			var self = this;
			const PREFS_PGTO_CARTAO = "prefs_recebimento_cartao";
			self.openPopUp = openPopUp;

			function openPopUp(recebimento) {

				var servico = ServicosGateway;

				servico.sucessoFunction = function (dados) {
					var hostName = dados ? StringUtils.emptyAsNull(dados.hostName) : null;
					prepararRecebimento(recebimento, hostName);

				}

				servico.erroFunction = function (dados) {
					MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION,  i18n('Commons.RecebimentoCartao.gatewayNaoAtivo'));
					
					if (recebimento.onErrorFunction) {recebimento.onErrorFunction()}
				};

				servico.isAtivo();
			}


			function prepararRecebimento(recebimento, hostName) {
				var params = {
					resourceID: recebimento.resourceId,
					wizardBaixa: recebimento.wizardBaixa ? "S" : "N"
				}

				if (StringUtils.emptyAsNull(hostName) != null) {
					params.hostName = hostName;
					params.oferecerTransConfNaoConcluidas = recebimento.oferecerTransConfNaoConcluidas ? "S" : "N";
					params.desfazerTransPendentes = recebimento.desfazerTransPendentes ? "S" : "N";
				}

				var prefsPgtoCartao = {
					chave: recebimento.resourceId + "." + PREFS_PGTO_CARTAO
				}

				params.prefsPgtoCartao = prefsPgtoCartao;

				var financeiros = [];
				if (recebimento.financeiros) {
					if(angular.isArray(recebimento.financeiros)){
						angular.forEach(recebimento.financeiros, function (financeiro, key) {
							financeiros.push({ $: financeiro["NUFIN"] });
						});
					}else{
						financeiros.push({ $: recebimento.financeiros["NUFIN"] });
					}							

					params.financeiros = { financeiro: financeiros };
				}
				params = { params: params };

				ServiceProxy.callService("mge@RecebimentoComCartaoSP.prepararRecebimento",
					params).then(function (response) {

						var vlrRecebimento = recebimento.vlrTotalTitulos;
						var dtTransacao = recebimento.dtTransacao;
						var codTipTit = null;
						var qtdParcelas = null;
						var subtipoVenda = null;
						var operacaoCtf = null;
						var cnpjCpfEmpresa = null;
						var nroParcelasMax = null;
						var utilizaPdvWeb = null;
						var vlrParcMinCart = null;

						var info = ObjectUtils.getProperty(response, 'responseBody.info');

						if (info.hasOwnProperty("VLRRECEBIMENTO")) {
							vlrRecebimento = Number(info.VLRRECEBIMENTO.$.toString());
						}
						if (info.hasOwnProperty("DTTRANSACAO")) {
							dtTransacao = DateUtils.strToDate(info.DTTRANSACAO.$);
						}
						if (info.hasOwnProperty("CNPJCPFEMPRESA")) {
							cnpjCpfEmpresa = info.CNPJCPFEMPRESA.$.toString();
						}
						if (info.hasOwnProperty("CODTIPTIT")) {
							codTipTit = Number(info.CODTIPTIT.$.toString());
						}
						if (info.hasOwnProperty("QTDPARCELAS")) {
							qtdParcelas = Number(info.QTDPARCELAS.$.toString());
						}
						if (info.hasOwnProperty("SUBTIPOVENDA")) {
							subtipoVenda = info.SUBTIPOVENDA.$.toString();
						}
						if (info.hasOwnProperty("OPERACAOCTF")) {
							operacaoCtf = info.OPERACAOCTF.$.toString();
						}
						if (info.hasOwnProperty("ULTILIZAPDVWEB")) {
							utilizaPdvWeb = info.ULTILIZAPDVWEB.$.toString();
						}
						if (info.hasOwnProperty("VLRPARCMINCART")) {
							vlrParcMinCart = Number(info.VLRPARCMINCART.$.toString());
						}
						if (info.hasOwnProperty("NROPARCELASMAX")) {
							nroParcelasMax = Number(info.NROPARCELASMAX.$.toString());
						}

						var transacoesConfirmadas = null;
						if (info.hasOwnProperty("transacoesConfirmadas")) {
							transacoesConfirmadas = info.transacoesConfirmadas;
						}

						var ultTransacaoPendente = null;
						if (info.hasOwnProperty("ultTransacaoPendente")) {
							ultTransacaoPendente = new Object();
							ultTransacaoPendente.STATUS = TEF.TRANSACAO_PENDENTE;

							for (var name in info.ultTransacaoPendente) {
								ultTransacaoPendente[name] = !StringUtils.isEmpty(info.ultTransacaoPendente[name].$) ? info.ultTransacaoPendente[name].$ : null;
							}
						}

						var openPopup = {
							title: SkI18nService.instant("Commons.RecebimentoCartao.titleRecebimentoCartao"),
							templateUrl: "commons/recebimentocartao/RecebimentoCartaoPopup/RecebimentoCartaoPopup.tpl.html",
							controller: "RecebimentoCartaoPopupController",
							controllerAs: "ctrl",
							size: "lg",
							height: 425,
							showBtnCancel: false,
							okBtnLabel: i18n('Geral.lblConcluir'),
							noBtnLabel: i18n('Commons.RecebimentoCartao.lblFechar'),
							showBtnOk: false,
							showBtnNo: false,
							showIconClose: false,
							keyboard: false,
							resolve: {
								dataValue: {
									concluirRecebimentoFunction: recebimento.concluirRecebimentoFunction,
									concluirCancelamentoFunction: recebimento.concluirCancelamentoFunction,
									atualizarFinanceiroFunction: recebimento.atualizarFinanceiroFunction,
									fecharRecebimentoFunction: recebimento.fecharRecebimentoFunction,
									centralDeNotas: recebimento.centralDeNotas,
									wizardBaixa: recebimento.wizardBaixa,
									codTipTit: codTipTit,
									utilizaCheckout: recebimento.utilizaCheckout,
									ownerServiceCall: recebimento.ownerServiceCall,
									financeiros: financeiros,
									resourceId: recebimento.resourceId,
									vlrTotalTitulos: vlrRecebimento,
									dtTransacao: dtTransacao,
									transacoesConfirmadas: transacoesConfirmadas,
									hostName: hostName,
									tefsEmProcessamento: recebimento.tefsEmProcessamento,
									qtdParcelas: qtdParcelas,
									subtipoVenda: subtipoVenda,
									operacaoCtf: operacaoCtf,
									cnpjCpfEmpresa: cnpjCpfEmpresa,
									nroParcelasMax: nroParcelasMax,
									utilizaPdvWeb: utilizaPdvWeb,
									vlrParcMinCart: vlrParcMinCart,
									disabletnReceberCancelarOnKeyDown: recebimento.disabletnReceberCancelarOnKeyDown
								}
							}
						};
						if (ultTransacaoPendente == null) {
							SanPopup.open(openPopup).result.then(
								function() {
									buildaAtalhosPdv(recebimento);
								}, function() {
									buildaAtalhosPdv(recebimento);
								}
							);
							} else {
								let vlrRaw   = ultTransacaoPendente.VLRTRANSACAO;
								let vlr      = vlrRaw != null ? NumberUtils.format(NumberUtils.stringToNumber(vlrRaw), 2) : '-';
								let bandeira = ultTransacaoPendente.BANDEIRA    || '-';
								let dh       = ultTransacaoPendente.DTTRANSACAO || '-';
								let nsuctf   = ultTransacaoPendente.NSUCTF      || '-';

								let msgPend = i18n('Commons.RecebimentoCartao.msgTrasnPendEstacao')
									+ '\n\n' + i18n('Commons.RecebimentoCartao.lblVlrTransacao') + ': R$ ' + vlr
									+ '\n'   + i18n('Commons.RecebimentoCartao.lblBandeira')     + ': '    + bandeira
									+ '\n'   + i18n('Commons.RecebimentoCartao.lblDtTransacao')  + ': '    + dh
									+ '\n'   + i18n('Commons.RecebimentoCartao.lblNsu')           + ': '    + nsuctf;

								MessageUtils.simpleConfirm(
									MessageUtils.TITLE_CONFIRMATION, msgPend
								).then(
									function() {
										ServicoDesfazimento.desfazerSilencioso(ultTransacaoPendente, function () {
											SanPopup.open(openPopup).result.then(
												function() {
													buildaAtalhosPdv(recebimento);
												}, function() {
													buildaAtalhosPdv(recebimento);
												}
											);
										});
									},

									function() {
										SanPopup.open(openPopup).result.then(
											function() {
												buildaAtalhosPdv(recebimento);
											}, function() {
												buildaAtalhosPdv(recebimento);
											}
										);
									}
								);
							}
					},
						true
					);
			}

			function buildaAtalhosPdv(recebimento){
				if(recebimento.createBinders){
					recebimento.createBinders();
				}
			}
		}
	]);

angular
	.module("snk.commons")
	.service("RecebimentoParam", [RecebimentoParam
	]); function RecebimentoParam() {
		var self = this; 
		self.concluirRecebimentoFunction;
		self.concluirCancelamentoFunction;
		self.fecharRecebimentoFunction;
		self.centralDeNotas;
		self.wizardBaixa;
		self.codTipTit;
		self.ownerServiceCall;
		self.vlrTotalTitulos;
		self.financeiros;
		self.dtTransacao;
		self.resourceId;
		self.tefsEmProcessamento; // Utilizado no wizard de baixa no pagamento com vários tipos de títulos.
		self.oferecerTransConfNaoConcluidas; // Transações que foram confirmadas na operadora, mas NÃO foram concluídas no sistema.
		self.desfazerTransPendentes; // Transações que NÃO foram confirmadas na operadora.
		self.qtdParcelas;
		self.utilizaCheckout;
		self.utilizaPdvWeb;
		self.nroParcelasMax;
		self.vlrParcMinCart;
	}
angular
	.module("snk.commons")
	.controller("RecebimentoPixTEFController", ["$popupInstance", "MessageUtils", "i18n", "Criteria", "ServiceProxy", "dataValue", "ServicoPixTEF", "TEF", "$scope",
    function($popupInstance, MessageUtils, i18n, Criteria, ServiceProxy, dataValue, ServicoPixTEF, TEF, $scope){
        var self = this;

        const financeiro = dataValue.financeiro;

        self.cancelar = cancelar;
        self.receber = receber;
        self.concluir = concluir;
        self.environmentCriteriaTipTit = environmentCriteriaTipTit;

        const ERR_MSG_SOLICITAR = i18n('Commons.RecebimentoPixTEF.erroSolicitarTransacao');
        const ERR_MSG_CANCELAR  = i18n('Commons.RecebimentoPixTEF.msgCancelarSemReceber');
        const MSG_PADRAO_CUPOM = i18n('Commons.RecebimentoPixTEF.msgPadraoCupom');
        const MSG_PADRAO_PROCESSAMENTO = i18n('Commons.RecebimentoPixTEF.msgPadraoProcessamento');
        
        self.formConfig = {
            vlrTransacaoInput: {
                value: 0,
                enabled: false
            },
            qtdParcelasInput: {
                value: 0,
                enabled: false
            },
            pesqTipoTitulo: {
                value: 0,
                enabled: false
            }
        };

        self.recebimentoEfetuado = false;
        self.progressBarClass = 'progress-bar progress-bar-striped active';
        self.txtProgressBar = '';
        self.visibleProgressBar = false;
        self.cupom = '';
        self.btnCancelarEnabled = true;
        self.btnReceberEnabled = true;
        self.btnConcluirEnabled = true;

        init();

        function init(){
            self.cupom = MSG_PADRAO_CUPOM;
            self.txtProgressBar = MSG_PADRAO_PROCESSAMENTO;
            self.formConfig.vlrTransacaoInput.value = financeiro.VLRDESDOB;
            self.formConfig.qtdParcelasInput.value = 1;
            self.formConfig.pesqTipoTitulo.value = financeiro.CODTIPTIT;
        };

        function environmentCriteriaTipTit() {
            const criteria = Criteria();
            criteria.and("this.TPAGNFCE = 17 AND this.SUBTIPOVENDA = 10 AND nullValue(this.UTILIZAPOS,'N') = 'N'");
            return criteria;
        };

        function receber(){
            showProgressBar();

            const solicitacao = {
                vlrTransacao: self.formConfig.vlrTransacaoInput.value,
                qtdParcelas: self.formConfig.qtdParcelasInput.value,
                codEmp: financeiro.CODEMP
            };
            
            ServicoPixTEF.setOnSuccessCallback(async (recordTEF) => {
                self.recebimentoEfetuado = true;
                showProgressBar(false);
                
                await registrarRecebimento(recordTEF);
                showProgressBar(false);
                $scope.$apply();
            });

			ServicoPixTEF.setOnErrorCallback((err) => {
                const msgErro = err.msgErro || ERR_MSG_SOLICITAR;
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, msgErro);
                showProgressBar(false);
			});

            ServicoPixTEF.setProgressCallback((progress) => {
                showProgressBar(true, progress);
               
            });

            console.log('RecebimentoPixTEFController.receber', {solicitacao});
            ServicoPixTEF.solicitarTransacao(solicitacao);
        };

        async function registrarRecebimento(tefResponse){
            showProgressBar(true, 'Registrando recebimento...');

            const {responseBody} = await ServiceProxy.callService("mge@RecebimentoPixTEFSP.registrarRecebimento", {
                nuFin: financeiro.NUFIN,
                tef: tefResponse
            });

            console.log('mge@RecebimentoPixTEFSP.registrarRecebimento', {responseBody});
            
            if(!responseBody.success) {
                MessageUtils.showAlert(MessageUtils.TITLE_WARNING, responseBody.error);
                return;
            }else{
                confirmarPIX(tefResponse)
            }


            const {CUPOM} = responseBody.payload;
            updateCupom(CUPOM);

        };

        function updateCupom(cupomData){
            self.cupom =  cupomData;
        };

        function concluir(){
            dataValue.onSuccess();
            $popupInstance.success('sucess');
        };

        function cancelar(){

            if(self.recebimentoEfetuado){
                doClose();
                return;
            }

            MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, ERR_MSG_CANCELAR).then(doClose);
        };

        function showProgressBar(visible = true, message){
            self.visibleProgressBar = visible;
            self.txtProgressBar = visible ? message || MSG_PADRAO_PROCESSAMENTO : '';
            self.btnCancelarEnabled = !visible;
            self.btnReceberEnabled = !visible;
            self.btnConcluirEnabled = !visible;
            };

        function doClose(){
            dataValue.onClose();
            $popupInstance.success('sucess');
        };

        function confirmarPIX(tefResponse) {
			var params = {};
				params.operacao = TEF.CONFIRMACAO;

				params.identificacao = tefResponse.identificacao.toString();
				params.hostName = tefResponse.hostName.toString();
				params.nsuCTF = tefResponse.nsu.toString();
				params.codControle = tefResponse.controle.toString();

				TEF.execute(params, doConfirmarPIX);
		}

		function doConfirmarPIX(dadosConfirmacao) {
			if (TEF.temErro(dadosConfirmacao)) {
				TEF.processarErro(dadosConfirmacao, TEF.SERVICO_CONFIRMAR_TRANSACAO, erroFunction);
			}
		}
  }]);
angular
	.module("snk.commons")
	.service("RecebimentoPixTEF", ["SanPopup", "i18n", "MessageUtils", "ServicosGateway", 
    function(SanPopup, i18n, MessageUtils, ServicosGateway){
        var self = this;

        self.receber = receber;
        self.estornar = estornar;

        let recebimentoParams = {};

        function receber(params){

            const isValid = parseParams(params);

            if(!isValid) return;

            const onSuccess = () => {
                openPopupRecebimento();
            };

            const onError = () => {
                recebimentoParams.onError(i18n('Commons.RecebimentoPixTEF.gatewayNaoAtivo'));
            };

            validaStatusGateway(onSuccess, onError);
        }

        function estornar(params){

            const isValid = parseParams(params, true);

            if(!isValid) return;

            const onError = () => {
                recebimentoParams.onError(i18n('Commons.RecebimentoPixTEF.gatewayNaoAtivo'));
            };

            validaStatusGateway(openPopupEstorno, onError);
        };

        function validaStatusGateway(onSuccess, onError){
            
            ServicosGateway.sucessoFunction = onSuccess;

            ServicosGateway.erroFunction = onError;
            
            ServicosGateway.isAtivo();
        }

        function parseParams(params, ehEstorno = false){
            let isValid = true;

            recebimentoParams.financeiro = params.financeiro;

            if(ehEstorno){
                recebimentoParams.financeiro = undefined;
                recebimentoParams.financeiros = params.financeiros;
            }

            recebimentoParams.onError = (message) => {

                const errorMessage = message || i18n('Commons.RecebimentoPixTEF.msgErro');

                if(params.onError) {
                    params.onError(errorMessage);
                    return;
                }
                
                MessageUtils.showAlert(MessageUtils.TITLE_ERROR,  errorMessage);
            };

            recebimentoParams.onClose = () => {
                 if(params.onClose) params.onClose();
            };

            recebimentoParams.onSuccess = () => {
                if(params.onSuccess) params.onSuccess();
            };

            if(!ehEstorno && (!params.financeiro || !Object.keys(params.financeiro).length)) {
                recebimentoParams.onError(i18n('Commons.RecebimentoPixTEF.paramFinanceiro'));
                isValid = false;
            };

            return isValid;
        }

        function openPopupRecebimento(){

            const popupConfig = {
                title: i18n("Commons.RecebimentoPixTEF.tituloPopUp"),
                templateUrl: "commons/recebimentocartao/RecebimentoPixTEF/RecebimentoPixTEFPopup.tpl.html",
                controller: "RecebimentoPixTEFController",
                controllerAs: "ctrl",
                size: "md",
                height: 300,
                keyboard: false,
                showBtnCancel: false,
                okBtnLabel: i18n('Geral.lblConcluir'),
                noBtnLabel: i18n('Commons.RecebimentoPixTEF.lblFechar'),
                showBtnOk: false,
                showBtnNo: false,
                showIconClose: false,
                resolve: {
                    dataValue: {
                        financeiro: recebimentoParams.financeiro,
                        onClose: recebimentoParams.onClose,
                        onSuccess: recebimentoParams.onSuccess
                    }
                }
            };

            SanPopup.open(popupConfig);
        }

        function openPopupEstorno(){

            const popupConfig = {
                title: i18n("Commons.RecebimentoPixTEF.tituloPopUpEstorno"),
                templateUrl: "commons/recebimentocartao/RecebimentoPixTEF/estorno/EstornoPixTEFPopup.tpl.html",
                controller: "EstornoPixTEFController",
                controllerAs: "ctrl",
                size: "lg",
                height: 450,
                showBtnCancel: false,
                okBtnLabel: i18n('Geral.lblConcluir'),
                noBtnLabel: i18n('Commons.RecebimentoPixTEF.lblFechar'),
                showBtnOk: false,
                showBtnNo: false,
                showIconClose: false,
                resolve: {
                    dataValue: {
                        financeiros: recebimentoParams.financeiros,
                        onClose: recebimentoParams.onClose,
                        onSuccess: recebimentoParams.onSuccess
                    }
                }
            };

            SanPopup.open(popupConfig);
        }
    }]);
angular.module("snk.commons").controller("EstornoPixTEFController", [
  "$popupInstance",
  "$timeout",
  "dataValue",
  "MessageUtils",
  "ObjectUtils",
  "ServiceProxy",
  "ServicoEstornoPixTEF",
  "TEF",
  function ($popupInstance, $timeout, dataValue, MessageUtils, ObjectUtils, ServiceProxy, ServicoEstornoPixTEF, TEF) {
    const financeiros = dataValue.financeiros;

    var self = this;
    self.onDatasetCreated = onDatasetCreated;
    self.onDatagridLoaded = onDatagridLoaded;
    self.buildLabelStatus = buildLabelStatus;
    self.buildLabelNSU = buildLabelNSU;
    self.estornar = estornar;
    self.close = doClose;
    self.concluir = concluir;
    self.estornosFinalizados = false;
    self.btnFecharEnabled = true;
    self.btnEstornarEnabled = false;
    self.progressBarVisible = false;
    self.txtProgressBar = "";
    self.dsTransacao;
    self.gridTransacao;
    self.cupom = "";

    let _totalEstornos = 0;

    const STATUS_PIX_ESTORNADO = 'X';

    $timeout(init, 0);

    function onDatasetCreated(dataset) {
      self.dsTransacao = dataset;
      self.dsTransacao.initAndRefresh().then(addObservers);
    }

    function addObservers() {
      var obs = {};
      ObjectUtils.implements(obs, IDataSetObserver);

      obs.currentLineChanged = function () {
        validaBtnEstorno();
        updateCupom();
      };

      self.dsTransacao.addObserver(obs);
    }

    function onDatagridLoaded(datagrid) {
      self.gridTransacao = datagrid;
      self.gridTransacao.getGridApi().sizeColumnsToFit();
    }

    async function init() {
      try {
        updateProgressBar(true, "Preparando estorno...");

        const { financeiros } = await prepararEstorno();

        fillDataSet(financeiros);

        enableButtons(true);
      } catch (err) {
        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, err.message || "Ops, ocorreu um erro!");
      } finally {
        updateProgressBar(false);
      }
    }

    async function prepararEstorno() {
      const params = {
        financeiros: financeiros.map((fin) => fin.NUFIN),
      };

      const { responseBody } = await ServiceProxy.callService("mge@RecebimentoPixTEFSP.prepararEstorno", params);

      if (!responseBody.success) {
        throw new Error(responseBody.error);
      }

      return responseBody.payload;
    }

    async function registrarEstorno(params, callback) {
      updateProgressBar(true, "Registrando estorno...");

      const afterCallService = (response) => (callback ? callback(response) : undefined);

      await ServiceProxy.callService("mge@RecebimentoPixTEFSP.registrarEstorno", params).then(afterCallService);

      confirmarEstornoPIX(params.tef);

    }

    function confirmarEstornoPIX(tefResponse) {
			var params = {};
				params.operacao = TEF.CONFIRMACAO;

				params.identificacao = tefResponse.identificacao.toString();
				params.hostName = tefResponse.hostName.toString();
				params.nsuCTF = tefResponse.nsu.toString();
				params.codControle = tefResponse.controle.toString();

				TEF.execute(params, doConfirmarPIX);
		}

		function doConfirmarPIX(dadosConfirmacao) {
			if (TEF.temErro(dadosConfirmacao)) {
				TEF.processarErro(dadosConfirmacao, TEF.SERVICO_CONFIRMAR_TRANSACAO, erroFunction);
			}
		}

    function fillDataSet(records) {
      self.dsTransacao.clearDataSet();
      self.dsTransacao.addRecordsAsObjects(records);
      self.dsTransacao.gotoRow(0);
    }

    function updateCupom() {
      const record = getTransacaoSelecionada();
      self.cupom = record ? record.CUPOM : "";
    }

    function getTransacaoSelecionada() {
      const [record] = self.dsTransacao.getSelectedRecordsAsObjects(null, true);
      return record;
    }

    function temEstornoPendente() {
      const record = getTransacaoSelecionada();

      return record ? record.STATUS === "C" : false;
    }

    function validaBtnEstorno() {
      self.btnEstornarEnabled = temEstornoPendente();
    }

    function validaFinalizacao(){
        ++_totalEstornos;
        self.estornosFinalizados = self.dsTransacao.size() === _totalEstornos;
        self.btnFecharEnabled = !self.estornosFinalizados;
    }

    function updateProgressBar(visible, message) {
      enableButtons(!visible);
      self.progressBarVisible = visible;
      self.txtProgressBar = message || "";
    }

    function enableButtons(enable) {
      self.btnFecharEnabled = enable;
      self.btnEstornarEnabled = enable ? temEstornoPendente() : false;
    }

    async function estornar() {
      updateProgressBar(true, "Iniciando estorno...");
      const record = getTransacaoSelecionada();

      if (!angular.isDefined(record)) {
        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, "Selecione um registro para ser estornado.");
        return;
      }

      const solicitacao = {
        identificacao: record.IDENTIFICACAO,
        vlrTransacao: record.VLRTRANSACAO,
        useNSUPopup: true,
      };

      const onSuccess = (retornoTEF) => {
        const params = {
          nuFin: record.NUFIN,
          tef: retornoTEF,
        };

        registrarEstorno(params, ({ responseBody }) => {
          if (!responseBody.success) {
            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, responseBody.error);
            updateProgressBar(false);
            return;
          }

          self.dsTransacao.setFieldValue("STATUS",  STATUS_PIX_ESTORNADO);
          
          updateProgressBar(false);

          validaFinalizacao();

          const message = responseBody.payload.message;
          if (message) {
            MessageUtils.showInfo(message);
          }
        });
      };

      const onError = (msgErro) => {
        let mensagem = msgErro?.msgErro ? msgErro.msgErro : msgErro;
        MessageUtils.showAlert(MessageUtils.TITLE_WARNING, mensagem);
        updateProgressBar(false);
      };

      ServicoEstornoPixTEF.setOnSuccessCallback(onSuccess);

      ServicoEstornoPixTEF.setOnErrorCallback(onError);

      ServicoEstornoPixTEF.solicitarTransacao(solicitacao);
    }

    function buildLabelStatus(col, value, row) {
      const indexSatus = self.dsTransacao.getFieldIndexByName("STATUS");

      switch (row[indexSatus]) {
        case "C":
          return "Concluído";
        case "X":
          return "Estornado";
        default:
          return row[indexSatus];
      }
    }

    function buildLabelNSU(col, value, row) {
      const indexNSU = self.dsTransacao.getFieldIndexByName("NSU");

      try {
        return Number(row[indexNSU]);
      } catch (ignored) {
        return row[indexNSU];
      }
    }

    function doClose() {
      const records = self.dsTransacao.getRecordsAsObjects();
      const existePendentes = records.some((record) => record.STATUS === "C");

      if (existePendentes) {
        MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, "Existem recebimentos não estornados, deseja sair mesmo assim?")
        .then(closePopup);

        return;
      }

      closePopup();
    }

    function concluir(){
      dataValue.onSuccess();
      $popupInstance.success("sucess");
    }

    function closePopup() {
      dataValue.onClose();
      $popupInstance.success("sucess");
    }
  },
]);

angular
	.module("snk.commons")
	.service("ServicoCancelamento", ["ObjectUtils", "i18n", "StringUtils", 'ServiceProxy', 'TEF', 'NumberUtils','MGEParameters',  ServicoCancelamento
	]); function ServicoCancelamento(ObjectUtils, i18n, StringUtils, ServiceProxy, TEF, NumberUtils, MGEParameters) {

		var self = this;
		var dataSet;
		var erroFunction;
		var sucessoFunction;
		var confirmarAuto = true;
		var _currentIndex;

		var TEF_GATEWAY_MODES = {
			NENHUM: 0,
			AUTTAR: 1,
			PAYGO: 2,
			SITEF: 3
		};

		self.solicitarCancelamento = solicitarCancelamento;
		self.solicitarConfirmacao = solicitarConfirmacao;
		self.doSolicitarCancelamento = doSolicitarCancelamento;
		self.atualizarSolicitacaoCancelamento = atualizarSolicitacaoCancelamento;
		self.confirmarCancelamento = confirmarCancelamento;
		self.doConfirmarCancelamento = doConfirmarCancelamento;
		self.atualizarConfirmacaoCancelamento = atualizarConfirmacaoCancelamento;
		self.setDataSet = setDataSet;
		self.setConfirmarAuto = setConfirmarAuto;
		self.setSucessoFunction = setSucessoFunction;
		self.setErroFunction = setErroFunction;

		function solicitarCancelamento() {
			if (dataSet == null) {
				throw new Error(i18n('Commons.RecebimentoCartao.msgInformDataSet'));
			}

			_currentIndex = dataSet.getCurrentIndex();

			var vlrTransacao = NumberUtils.format(dataSet.getFieldValueAsNumber("VLRTRANSACAO"), 2);
			var dtTransacao = dataSet.getFieldValueAsString("DTTRANSACAO");

			var vlrTrans = vlrTransacao.toString().replace(",", "").replace(".", "");

			var dtTrans = null;
			if (TEF.usaGatewayTEF()) {
				dtTrans = dtTransacao;
			} else {
				dtTrans = getFormatBrasilianDate(dtTransacao, "DDMMYY");
			}

			var params = {};

			params.operacao = TEF.CANCELAMENTO;
			params.nsuCTF = dataSet.getFieldValue("NSUCTF");
			params.valorTransacao = vlrTrans;
			params.dataTransacao = dtTrans;
			params.redeAdquirente = dataSet.getFieldValue("REDEADQUIRENTE");
			params.codigoAprovacao = dataSet.getFieldValue("CODAPROVACAO");

			if (TEF.usaGatewayTEF()) {
				if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("OPERACAOORIG"))) {
					params.operacaoOrigem = dataSet.getFieldValueAsString("OPERACAOORIG");
				}
				if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("CNPJCPFEMPRESA"))) {
					params.cnpjcpfEstabelecimento = dataSet.getFieldValueAsString("CNPJCPFEMPRESA");
				}
			}

			if (!TEF.exigeIdentificacao()) {
				TEF.execute(params, doSolicitarCancelamento);
			} else {
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarNumeroIdentificacao",
					{ params: {} }).then(function (response) {
						var info = response.responseBody.info;
						if (info.hasOwnProperty("IDENTIFICACAOTEF")) {
							params.identificacao = Number(info.IDENTIFICACAOTEF.$.toString());
						}
						TEF.execute(params, doSolicitarCancelamento);
					});
			}
		}

		function solicitarConfirmacao() {
			_currentIndex = dataSet.getCurrentIndex();
			confirmarCancelamento();
		}

		function doSolicitarCancelamento(dadosCancelamento) {
			if (TEF.temErro(dadosCancelamento)) {
				TEF.processarErro(dadosCancelamento, TEF.SERVICO_SOLICITAR_CANCELAMENTO, erroFunction);
			} else {
				atualizarSolicitacaoCancelamento(dadosCancelamento);

				if (confirmarAuto) {
					confirmarCancelamento();
				} else if (sucessoFunction != null) {
					sucessoFunction();
				}
			}
		}

		function atualizarSolicitacaoCancelamento(dadosCancelamento) {
			var record = TEF.buildRecordSolicitacao(dadosCancelamento);

			dataSet.gotoRow(_currentIndex);
			dataSet.setFieldValue("NSUCTFCAN", record.NSUCTF);
			dataSet.setFieldValue("STATUS", StringUtils.emptyAsNull(record.STATUS) ? record.STATUS : TEF.TRANSACAO_EM_CANCELAMENTO);
			dataSet.setFieldValue("CUPOMESTABELECIMENTOCAN", record.CUPOMESTABELECIMENTO);
			dataSet.setFieldValue("CUPOMCLIENTECAN", record.CUPOMCLIENTE);
			dataSet.setFieldValue("CUPOMREDUZIDOCAN", record.CUPOMREDUZIDO);
			dataSet.setFieldValue("REQUISICAO", record.REQUISICAO);
			dataSet.setFieldValue("RETORNO", record.RETORNO);
			dataSet.setFieldValue("CODCONTROLECAN", record.CODCONTROLE);
			dataSet.setFieldValue("REQUISICAOCONFIRMACAO", record.REQUISICAOCONFIRMACAO);
			dataSet.setFieldValue("RETORNOCONFIRMACAO", record.RETORNOCONFIRMACAO);
			dataSet.setFieldValue("IDENTIFICACAOTEF", record.IDENTIFICACAOTEF);

			dataSet.save(false, function () {
				dataSet.gotoRow(_currentIndex);
			});
		}

		function confirmarCancelamento() {
			dataSet.gotoRow(_currentIndex).then(() => {
				var usaGatewayTEF = MGEParameters.asInteger("mgefin.tef.gateway") === TEF_GATEWAY_MODES.AUTTAR;

				if (dataSet.getFieldValueAsString("STATUS") == TEF.TRANSACAO_CANCELADA) {
					if (sucessoFunction != null) {
						sucessoFunction();
					}
				} else {
					var params = new Object();
					params.operacao = TEF.CONFIRMACAO;

					if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("NSUCTFCAN")) != null) {
						params.nsuCTF = dataSet.getFieldValueAsString("NSUCTFCAN");
					}

					params.numeroTransacao = !StringUtils.isEmpty(dataSet.getFieldValue("NUMTRANS")) && !usaGatewayTEF
						? dataSet.getFieldValue("NUMTRANS")
						: 1;

					if (!StringUtils.isEmpty(dataSet.getFieldValue("REDEADQUIRENTE"))) {
						params.redeAdquirente = dataSet.getFieldValue("REDEADQUIRENTE");
					}

					if (!StringUtils.isEmpty(dataSet.getFieldValue("CODCONTROLECAN"))) {
						params.codControle = dataSet.getFieldValue("CODCONTROLECAN");
					}

					if (TEF.exigeIdentificacao() && !StringUtils.isEmpty(dataSet.getFieldValue("IDENTIFICACAOTEF"))) {
						params.identificacao = dataSet.getFieldValue("IDENTIFICACAOTEF");
					}

					if (TEF.usaGatewayTEF()) {
						if (usaGatewayTEF) {
							params.operacaoOrigem = StringUtils.emptyAsNull(dataSet.getFieldValueAsString("OPERACAOORIG"))
								? dataSet.getFieldValueAsString("OPERACAOORIG")
								: StringUtils.emptyAsNull(dataSet.getFieldValueAsString("OPERACAO"))
									? dataSet.getFieldValueAsString("OPERACAO")
									: undefined;
						}
						if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("CNPJCPFEMPRESA"))) {
							params.cnpjcpfEstabelecimento = dataSet.getFieldValueAsString("CNPJCPFEMPRESA");
						}
					}

					TEF.execute(params, doConfirmarCancelamento);
				}
			})
		}

		function doConfirmarCancelamento(dadosConfirmacao) {
			if (TEF.temErro(dadosConfirmacao)) {
				TEF.processarErro(dadosConfirmacao, TEF.SERVICO_CONFIRMAR_CANCELAMENTO, erroFunction);
			} else {
				atualizarConfirmacaoCancelamento(dadosConfirmacao);

				if (sucessoFunction != null) {
					sucessoFunction();
				}
			}
		}

		function atualizarConfirmacaoCancelamento(dadosConfirmacao) {
			var record = TEF.buildRecordConfirmacao(dadosConfirmacao);

			dataSet.gotoRow(_currentIndex);
			let status = ObjectUtils.getProperty(record, 'STATUS');


			dataSet.setFieldValue("STATUS", status ? record.STATUS : TEF.TRANSACAO_CANCELADA);
			dataSet.setFieldValue("REQUISICAOCONFIRMACAO", record.REQUISICAO);
			dataSet.setFieldValue("RETORNOCONFIRMACAO", record.RETORNO);

			dataSet.save(false, function () {
			});
		}
		function setDataSet(ds) {
			dataSet = ds;
		}
		function setSucessoFunction(sucesso) {
			sucessoFunction = sucesso;
		}
		function setErroFunction(erro) {
			erroFunction = erro;
		}

		function setConfirmarAuto(confirmar) {
			confirmarAuto = confirmar;
		}

		function getFormatBrasilianDate(brasilianDate, format) {
			var dia = brasilianDate.split("/")[0];
			var mes = brasilianDate.split("/")[1];
			var ano = brasilianDate.split("/")[1].split(" ")[0];

			if (format == "DDMMYY") {
				return dia + mes + ano
			}
		}

	}

angular
	.module("snk.commons")
	.service("ServicoConfirmacao", ["i18n", "StringUtils", "DateUtils", "TEF", ServicoConfirmacao
	]); function ServicoConfirmacao(i18n, StringUtils, DateUtils, TEF) {

		var self = this;
		var dataSet;
		var erroFunction;
		var sucessoFunction;
		var financeiros;
		var _currentIndex;

		self.processarConfirmacao = processarConfirmacao;
		self.confirmar = confirmar;
		self.doConfirmar = doConfirmar;
		self.salvarTransacao = salvarTransacao;

		self.setDataSet = setDataSet;
		self.setErroFunction = setErroFunction;
		self.setSucessoFunction = setSucessoFunction;
		self.setFinanceiros = setFinanceiros;

		function processarConfirmacao() {
			if (dataSet == null) {
				throw new Error(i18n('Commons.RecebimentoCartao.msgInformDataSet'));
			}

			_currentIndex = -1;
			var index = -1;
			for (var i = 0; i < dataSet.getRecordsAsObjects().length; i++) {
				index++;
				if (StringUtils.emptyAsNull(dataSet.getRecordsAsObjects()[i].STATUS) == TEF.TRANSACAO_PENDENTE) {
					_currentIndex = index;
					break;
				}
			}

			if (_currentIndex >= 0) {
				confirmar();
			} else if (sucessoFunction != null) {
				var confirmou = true;
				for (var i = 0; i < dataSet.getRecordsAsObjects().length; i++) {
					if (dataSet.getFieldValue("STATUS") != TEF.TRANSACAO_CONFIRMADA) {
						confirmou = false;
						break;
					}
				}

				if (confirmou) {
					sucessoFunction();
				} else if (erroFunction != null) {
					var retornoErro = {};
					retornoErro.codRetorno = TEF.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO;
					retornoErro.codErro = 0;
					retornoErro.msgErro = i18n('Commons.RecebimentoCartao.msgFalhaProcConfirm');
					retornoErro.servico = TEF.SERVICO_CONFIRMAR_TRANSACAO;
					erroFunction(retornoErro);
				}
			}
		}

		function confirmar() {
			dataSet.gotoRow(_currentIndex).then(() => {
				var params = {};
				params.operacao = TEF.CONFIRMACAO;

				if (!StringUtils.isEmpty(dataSet.getFieldValue("NUMTRANS"))) {
					params.numeroTransacao = dataSet.getFieldValue("NUMTRANS")
				}

				if (!StringUtils.isEmpty(dataSet.getFieldValue("NSUCTF"))) {
					params.nsuCTF = dataSet.getFieldValue("NSUCTF")
				}

				if (!StringUtils.isEmpty(dataSet.getFieldValue("REDEADQUIRENTE"))) {
					params.redeAdquirente = dataSet.getFieldValue("REDEADQUIRENTE")
				}

				if (!StringUtils.isEmpty(dataSet.getFieldValue("CODCONTROLE"))) {
					params.codControle = dataSet.getFieldValue("CODCONTROLE")
				}

				if (TEF.exigeIdentificacao() && !StringUtils.isEmpty(dataSet.getFieldValue("IDENTIFICACAOTEF"))) {
					params.identificacao = dataSet.getFieldValue("IDENTIFICACAOTEF")
				}

				if (TEF.usaGatewayTEF()) {
					if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("OPERACAO"))) {
						params.operacaoOrigem = dataSet.getFieldValueAsString("OPERACAO")
					}
					if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("CNPJCPFEMPRESA"))) {
						params.cnpjcpfEstabelecimento = dataSet.getFieldValueAsString("CNPJCPFEMPRESA");
					}
				}

				TEF.execute(params, doConfirmar);
			});
		}

		function doConfirmar(dadosConfirmacao) {
			if (TEF.temErro(dadosConfirmacao)) {
				TEF.processarErro(dadosConfirmacao, TEF.SERVICO_CONFIRMAR_TRANSACAO, erroFunction);
			} else {
				var record = TEF.buildRecordConfirmacao(dadosConfirmacao);

				dataSet.gotoRow(_currentIndex).then(() => {

					dataSet.setFieldValue("STATUS", StringUtils.emptyAsNull(record.STATUS) ? record.STATUS : TEF.TRANSACAO_CONFIRMADA);
					dataSet.setFieldValue("REQUISICAOCONFIRMACAO", record.REQUISICAO);
					dataSet.setFieldValue("RETORNOCONFIRMACAO", record.RETORNO);

					if (TEF.usaGatewayTEF()) {
						dataSet.save(false, function () {
							processarConfirmacao();
						});
					} else {
						dataSet.save();
						processarConfirmacao();
					}
				}
				)
			}
		}

		function salvarTransacao(callback) {
			var record = dataSet.getCurrentRow();

			var params = { confirmando: { $: "S" } };
			params.NSUCTF = { $: StringUtils.nullAsEmpty(record.NSUCTF) };
			params.DTTRANSACAO = { $: DateUtils.format(record.DTTRANSACAO, "DD/MM/YYYY JJ:NN:SS") };
			params.RETORNO = { $: StringUtils.nullAsEmpty(record.RETORNO) };
			params.REQUISICAO = { $: StringUtils.nullAsEmpty(record.REQUISICAO) };
			params.REQUISICAOCONFIRMACAO = { $: StringUtils.nullAsEmpty(record.REQUISICAOCONFIRMACAO) };
			params.RETORNOCONFIRMACAO = { $: StringUtils.nullAsEmpty(record.RETORNOCONFIRMACAO) };
			params.HOSTNAME = { $: StringUtils.nullAsEmpty(record.HOSTNAME) };

			if (financeiros && financeiros.length > 0) {
				financeiro = []
				angular.forEach(recebimento.financeiros, function (fin, key) {
					financeiro.push({ $: fin.NUFIN });
				});
				params.financeiros = { "financeiro" : { "$" : financeiro } } ;
			}

			ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarNumeroIdentificacao",
				params).then(function (response) {
					if (callback != null) {
						callback();
					}
				});
		}

		function setDataSet(dataSet_) {
			dataSet = dataSet_;
		}

		function setSucessoFunction(sucessoFunction_) {
			sucessoFunction = sucessoFunction_;
		}

		function setFinanceiros(financeiros_) {
			financeiros = financeiros_;
		}

		function setErroFunction(erroFunction_) {
			erroFunction = erroFunction_;
		}
	}

angular
	.module("snk.commons")
	.service("ServicoDesfazimento", ['TEF', "i18n", "StringUtils", "ServiceProxy", ServicoDesfazimento
	]); function ServicoDesfazimento(TEF, i18n, StringUtils, ServiceProxy) {

		var self = this;
		var dataSet;
		var erroFunction;
		var sucessoFunction;
		var _currentIndex;

		self.desfazerSilencioso = desfazerSilencioso;
		self.solicitarDesfazimento = solicitarDesfazimento;

		self.setDataSet = setDataSet;
		self.setErroFunction = setErroFunction;
		self.setSucessoFunction = setSucessoFunction;

		const INICIO = "INICIO";
		const CONCLUSAO = "CONCLUSAO"; 

		function solicitarDesfazimento() {
			if (dataSet == null) {
				throw new Error(i18n('Commons.RecebimentoCartao.msgInformDataSet'));
			}

			_currentIndex = dataSet.getCurrentIndex();

			var params = {};
			params.operacao = TEF.DESFAZIMENTO_TOTAL;

			if (!StringUtils.isEmpty(dataSet.getFieldValue("REDEADQUIRENTE"))) {
				params.redeAdquirente = dataSet.getFieldValue("REDEADQUIRENTE");
			}

			if (!StringUtils.isEmpty(dataSet.getFieldValue("CODCONTROLE"))) {
				params.codControle = dataSet.getFieldValue("CODCONTROLE");
			}

			if (TEF.exigeIdentificacao() && !StringUtils.isEmpty(dataSet.getFieldValue("IDENTIFICACAOTEF"))) {
				params.identificacao = dataSet.getFieldValue("IDENTIFICACAOTEF");
			}

			if (TEF.usaGatewayTEF()) {
				if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("OPERACAO"))) {
					params.operacaoOrigem = dataSet.getFieldValueAsString("OPERACAO");
				}
				if (StringUtils.emptyAsNull(dataSet.getFieldValueAsString("CNPJCPFEMPRESA"))) {
					params.cnpjcpfEstabelecimento = dataSet.getFieldValueAsString("CNPJCPFEMPRESA");
				}
			}

			TEF.execute(params, doSolicitarDesfazimento);
		}

		function registrarMonitoria(dados) {
			ServiceProxy.callService("mge@RecebimentoComCartaoSP.registrarDesfazimentoSilencioso", {
				params: {
					numnsu:         dados.numnsu         || '',
					redeAdquirente: dados.redeAdquirente || '',
					codControle:    dados.codControle    || '',
					fase:           dados.fase,
					request:        dados.request        || '',
					response:       dados.response       || ''
				}
			}).catch(function (e) {
				console.log('[ServicoDesfazimento] Falha ao registrar monitoria TGFMTEF (' + dados.fase + '):', e);
			});
		}

		function desfazerSilencioso(solicitacao, callback) {
			var params = {};
			params.operacao = TEF.DESFAZIMENTO_TOTAL;

			if (!StringUtils.isEmpty(solicitacao.REDEADQUIRENTE)) {
				params.redeAdquirente = solicitacao.REDEADQUIRENTE;
			}

			if (!StringUtils.isEmpty(solicitacao.CODCONTROLE)) {
				params.codControle = solicitacao.CODCONTROLE;
			}

			if (TEF.exigeIdentificacao() && !StringUtils.isEmpty(solicitacao.IDENTIFICACAOTEF)) {
				params.identificacao = solicitacao.IDENTIFICACAOTEF;
			}

			registrarMonitoria({
				numnsu:         params.identificacao    || '',
				redeAdquirente: params.redeAdquirente   || '',
				codControle:    params.codControle      || '',
				fase:           INICIO,
				request:        JSON.stringify(params),
				response:       ''
			});

			TEF.execute(params, function (dadosDesfazimento) {
				var record = TEF.buildRecordDesfazimento(dadosDesfazimento);

				registrarMonitoria({
					numnsu:         (dadosDesfazimento.responseTef && dadosDesfazimento.responseTef.nsuCTF) || params.identificacao || '',
					redeAdquirente: params.redeAdquirente || '',
					codControle:    (dadosDesfazimento.responseTef && dadosDesfazimento.responseTef.codControle) || params.codControle || '',
					fase:           CONCLUSAO,
					request:        record.REQUISICAO || '',
					response:       record.RETORNO    || ''
				});

				excluirTransacao(record.HOSTNAME, callback);
			});
		}

		function doSolicitarDesfazimento(dadosDesfazimento) {
			if (TEF.temErro(dadosDesfazimento)) {
				TEF.processarErro(dadosDesfazimento, TEF.SERVICO_DESFAZER_TRANSACAO, erroFunction);
			} else {
				atualizarDesfazimento(dadosDesfazimento);

				if (sucessoFunction != null) {
					sucessoFunction();
				}
			}
		}

		function atualizarDesfazimento(dadosDesfazimento) {
			var record = TEF.buildRecordDesfazimento(dadosDesfazimento);

			dataSet.gotoRow(_currentIndex);
						dataSet.setFieldValue("STATUS", StringUtils.emptyAsNull(record.STATUS) ? record.STATUS : TEF.TRANSACAO_DESFEITA);
						dataSet.setFieldValue("REQUISICAO", record.REQUISICAO);
						dataSet.setFieldValue("RETORNO", record.RETORNO);

			dataSet.save(false, function () {
				dataSet.gotoRow(_currentIndex);
			});

			excluirTransacao(record.HOSTNAME);
		}

		function excluirTransacao(hostName, callback = null) {
			if (TEF.usaGatewayTEF() && StringUtils.emptyAsNull(hostName)) {
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.excluirTransacoesPendentes",
					{ params: { hostName: hostName } }).then(function (response) {
						if (callback != null) {
							callback();
						}
					});
			} else {
				if (callback != null) {
					callback();
				}
			}
		}

		function setDataSet(dataSet_) {
			dataSet = dataSet_;
		}

		function setSucessoFunction(sucessoFunction_) {
			sucessoFunction = sucessoFunction_;
		}

		function setErroFunction(erroFunction_) {
			erroFunction = erroFunction_;
		}
	}
angular.module("snk.commons").service("ServicoEstornoPixTEF", [
  "TEF",
  "i18n",
  "NumberUtils",
  function (TEF, i18n, NumberUtils) {
    var self = this;

    const MSG_ERR_BUILD_PARAMS = i18n(
      "Commons.RecebimentoPixTEF.erroPayloadTransacao"
    );

    self.solicitarTransacao = solicitarTransacao;
    self.parseCupom = parseCupom;
    self.setOnSuccessCallback = setOnSuccessCallback;
    self.setOnErrorCallback = setOnErrorCallback;
    

    let onSuccessCallback = () => {};
    let onErrorCallback = () => {};

    async function solicitarTransacao(payload) {
      try {
        const params = buildTEFParams(payload);

        TEF.execute(params, processaRetornoTEF);
        
      } catch (err) {
        onErrorCallback(err.message);
      }
    }

    function buildTEFParams(dadosEstorno) {
      try {
        const params = new Object();
        params.operacao = TEF.CANCELAMENTO;
        params.operacaoOrigem = TEF.PAGAMENTO_PIX;
        const vlrTrans = dadosEstorno.vlrTransacao * 100;
        params.identificacao = dadosEstorno.identificacao;
        params.valorTransacao = vlrTrans;

        return params;
      } catch (err) {
        throw new Error(MSG_ERR_BUILD_PARAMS);
      }
    }

    function processaRetornoTEF(dadosRetorno) {
      if (TEF.temErro(dadosRetorno)) {
        TEF.processarErro(dadosRetorno, TEF.SERVICO_PIX, onErrorCallback);
        return;
      }

      const record = buildResponse(dadosRetorno);
      onSuccessCallback(record);
    }

    function buildResponse({ requestTef, responseTef }) {
      try {
        const record = new Object();

        record.identificacao = requestTef.identificacao;
        record.operacao = requestTef.operacao;
        record.gateway = requestTef.gateway;
        record.retorno = responseTef.retorno;
        record.controle = responseTef.codControle;
        record.nsu = responseTef.nsuCTF;
        record.valorTransacao =
          NumberUtils.stringToNumber(responseTef.valorTransacao) / 100;
        record.dtTransacao = responseTef.dataTransacao;
        record.hostName = responseTef.hostName;
        record.status = responseTef.statusTransacao;
        record.estabelecimento = responseTef.estabelecimento;
        record.cupomEstabelecimento = parseCupom(
          responseTef.cupomEstabelecimento
        );
        record.cupomCliente = parseCupom(responseTef.cupomCliente);
        record.redeAdquirente = responseTef.redeAdquirente;

        return record;
      } catch (err) {
        console.log('buildResponse', err);
        onErrorCallback('Ocorreu um erro ao gerar resposta TEF.');
      }
    }

    function parseCupom(cupomData) {
      return TEF.buildCupom(cupomData);
    }

    function setOnSuccessCallback(callback) {
      onSuccessCallback = callback;
    }

    function setOnErrorCallback(callback) {
      onErrorCallback = callback;
    }

  },
]);

angular
	.module("snk.commons")
	.service("ServicoPixTEF", ["ServiceProxy", "TEF", "i18n", "NumberUtils", "CrudUtils",
    function (ServiceProxy, TEF, i18n, NumberUtils, CrudUtils) {

        var self = this;

        const MSG_ERR_BUILD_PARAMS = i18n('Commons.RecebimentoPixTEF.erroPayloadTransacao');
        const MSG_ERR_GET_TEF_ID = i18n('Commons.RecebimentoPixTEF.erroIdentificacaoTEF');

        self.solicitarTransacao = solicitarTransacao;
        self.parseCupom = parseCupom;
        self.setOnSuccessCallback = setOnSuccessCallback;
        self.setOnErrorCallback = setOnErrorCallback;
        self.setProgressCallback = setProgressCallback;
        
        let onSuccessCallback = () => {};
        let onErrorCallback = () => {};
        let onProgressCallback = () => {};
        
        async function solicitarTransacao(payload){
            const params = await buildTEFParams(payload);

            if(!params) {
                onErrorCallback(MSG_ERR_BUILD_PARAMS);
                return;
            }
            
            TEF.execute(params, processaRetornoTEF);

        };

        async function buildTEFParams(payload){
            try{
                const params  = new Object();
                const vlrTrans = Number((payload.vlrTransacao * 100).toFixed(2));
                params.operacao = TEF.PAGAMENTO_PIX;
                params.identificacao = await getIdentificacaoTEF();
                params.cnpjcpfEstabelecimento = await getCnpjcpfEstabelecimento(payload.codEmp);
                params.valorTransacao = vlrTrans;
                
                return params;
            }catch(err){
                console.error('ServiceProxy.buildTEFParams', {payload}, err);
                return null;
            }
        };

        async function getIdentificacaoTEF(){

            onProgressCallback('Gerando identificação da transação...');

            const {responseBody} = await ServiceProxy.callService("mge@RecebimentoPixTEFSP.gerarNumeroIdentificacao", {});

            if(!responseBody.success){
                console.error('ServiceProxy.getIdentificacaoTEF', {responseBody});
                throw new Error(responseBody.error || MSG_ERR_GET_TEF_ID);
            }

            const {payload} = responseBody;

            return payload.identificacaoTEF;
        };

        async function getCnpjcpfEstabelecimento(codEmp){

           return CrudUtils.find('Empresa', 'CGC', { CODEMP: codEmp }, true)
                .then(function (result) {
                    if (result){
                        return result.CGC;
                    }
                });
            
        };

        function processaRetornoTEF(dadosRetorno) {
            console.log('ServicoPixTEF.processaRetornoTEF', dadosRetorno);

			if (TEF.temErro(dadosRetorno)) {
				TEF.processarErro(dadosRetorno, TEF.SERVICO_PIX, onErrorCallback);
                return;
			}

            const record = buildRecord(dadosRetorno);
            onSuccessCallback(record);
		};

        function buildRecord({requestTef, responseTef}){
            const record = new Object();

            record.identificacao = requestTef.identificacao;
            record.operacao = requestTef.operacao;
            record.gateway = requestTef.gateway;
            record.retorno = responseTef.retorno;
            record.controle = responseTef.codControle;
            record.nsu = responseTef.nsuCTF;
            record.valorTransacao =  Number((responseTef.valorTransacao / 100).toFixed(2));
            record.dtTransacao =  responseTef.dataTransacao;
            record.hostName = responseTef.hostName;
            record.status = responseTef.statusTransacao;
            record.estabelecimento = responseTef.estabelecimento;
            record.cupomEstabelecimento = parseCupom(responseTef.cupomEstabelecimento);
            record.cupomCliente = parseCupom(responseTef.cupomCliente);
            record.redeAdquirente = responseTef.redeAdquirente;
            record.nsuAutorizadora = responseTef.nsuAutorizadora;

            return record;
        };

        function parseCupom(cupomData){
            return TEF.buildCupom(cupomData);
        };

        function setOnSuccessCallback(callback) {
			onSuccessCallback = callback;
		};

        function setOnErrorCallback(callback) {
			onErrorCallback = callback;
		};

        function setProgressCallback(callback){
            onProgressCallback = callback;
        };

    }]);
angular
	.module("snk.commons")
	.service("ServicoSolicitacao", ["ServiceProxy", "TEF", "i18n", "StringUtils", "DateUtils", "NumberUtils",
	function (ServiceProxy, TEF, i18n, StringUtils, DateUtils, NumberUtils) {

		var self = this;

		var dataSet;
		var erroFunction;
		var sucessoFunction;
		var financeiros;
		var _newRecord;

		self.solicitarTransacao = solicitarTransacao;
		self.doSolicitarTransacao = doSolicitarTransacao;
		self.incluirSolicitacaoTransacao = incluirSolicitacaoTransacao;
		self.salvarTransacao = salvarTransacao;

		self.setDataSet = setDataSet;
		self.setErroFunction = setErroFunction;
		self.setSucessoFunction = setSucessoFunction;
		self.setFinanceiros = setFinanceiros;
		self.setNewRecord = setNewRecord;

		function solicitarTransacao(solicitacao) {
			if (dataSet == null) {
				throw new Error(i18n('Commons.RecebimentoCartao.msgInformDataSet'));
			}
			_newRecord = solicitacao;

			var operacao = _newRecord["OPERACAO"];
			var vlrTransacao = _newRecord["VLRTRANSACAO"];
			var qtdParcelas = _newRecord["QTDPARCELAS"];
			var dtTransacao = _newRecord["DTTRANSACAO"];
			var numeroTransacao = _newRecord["NUMTRANS"];
			var cnpjCpfEmpresa = _newRecord["CNPJCPFEMPRESA"];
			var requestTimeOut = _newRecord["REQUESTTIMEOUT"];

			var vlrTrans = vlrTransacao.toString().replace(",", "").replace(".", "");

			var params = {};
			params.operacao = operacao;
			params.valorTransacao = vlrTrans;
			params.numeroTransacao = numeroTransacao.toString();
			params.requestTimeOut = requestTimeOut;

			if (TEF.usaGatewayTEF()) {
				params.dataTransacao = DateUtils.formatDate(dtTransacao, "DD/MM/YYYY HH:MM:SS");
				params.numeroParcelas = qtdParcelas.toString();
				params.cnpjcpfEstabelecimento = cnpjCpfEmpresa;
			} else {
				if (!TEF.isDebitoParcelado(int(operacao)) && !TEF.isDebitoPreDatado(int(operacao))) {
					params.dataTransacao = DateUtils.formatDate(dtTransacao, "DDMMYY");
				}
				if (!TEF.isDebitoParcelado(int(operacao))) {
					params.numeroParcelas = qtdParcelas.toString();
				}
			}

			if (!TEF.exigeIdentificacao()) {
				TEF.execute(params, doSolicitarTransacao);
			} else {
				ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarNumeroIdentificacao",
					{ params: {} }).then(function (response) {
						var info = response.responseBody.info;

						if (info.hasOwnProperty("IDENTIFICACAOTEF")) {
							params.identificacao = Number(info.IDENTIFICACAOTEF.$.toString());
						}

						TEF.execute(params, doSolicitarTransacao);
					});
			}

		}

		function doSolicitarTransacao(dadosSolicitacao) {
			if (TEF.temErro(dadosSolicitacao)) {
				TEF.processarErro(dadosSolicitacao, TEF.SERVICO_SOLICITAR_TRANSACAO, erroFunction);
			} else {
				incluirSolicitacaoTransacao(dadosSolicitacao);
				if (sucessoFunction != null) {
					sucessoFunction();
				}
			}
		}

		function incluirSolicitacaoTransacao(dadosSolicitacao) {
			var record = TEF.buildRecordSolicitacao(dadosSolicitacao);

			record.OPERACAO = _newRecord.OPERACAO;
			record.VLRTRANSACAO = NumberUtils.stringToNumber(_newRecord.VLRTRANSACAO);
			record.NUMTRANS = _newRecord.NUMTRANS;
			record.DESCRTIPTIT = _newRecord.DESCRTIPTIT;
			record.CODTIPTIT = _newRecord.CODTIPTIT;
			record.CNPJCPFEMPRESA = _newRecord.CNPJCPFEMPRESA;
			record.STATUS = StringUtils.emptyAsNull(record.STATUS) ? record.STATUS : TEF.TRANSACAO_PENDENTE;

			if (record.DTTRANSACAO == null) {
				record.DTTRANSACAO = _newRecord.DTTRANSACAO;
			}
			if (record.QTDPARCELAS == null || record.QTDPARCELAS == 0) {
				record.QTDPARCELAS = _newRecord.QTDPARCELAS;
			}


			dataSet.addRecordsAsObjects(record);
			dataSet.gotoRow(0);

			if (TEF.usaGatewayTEF()) {
				salvarTransacao(record);
			}
		}

		function salvarTransacao(record) {
			var params = {};
			params.NSUCTF = { $: stringEmpty(record.NSUCTF) };
			params.CODTIPTIT = { $: stringEmpty(record.CODTIPTIT) };
			params.OPERACAO = { $: stringEmpty(record.OPERACAO) };
			params.NUMTRANS = { $: stringEmpty(record.NUMTRANS) };
			params.CODAPROVACAO = { $: stringEmpty(record.CODAPROVACAO) };
			params.VLRTRANSACAO = { $: stringEmpty(record.VLRTRANSACAO) };
			params.DTTRANSACAO = { $: DateUtils.formatDate(record.DTTRANSACAO, "DD/MM/YYYY HH:MM:SS") };
			params.QTDPARCELAS = { $: stringEmpty(record.QTDPARCELAS) };
			params.BANDEIRA = { $: stringEmpty(record.BANDEIRA) };
			params.CARTAO = { $: stringEmpty(record.CARTAO) };
			params.REDEADQUIRENTE = { $: stringEmpty(record.REDEADQUIRENTE) };
			params.CODREDEADQUIRENTE = { $: stringEmpty(record.CODREDEADQUIRENTE) };
			params.RETORNO = { $: stringEmpty(record.RETORNO) };
			params.REQUISICAO = { $: stringEmpty(record.REQUISICAO) };
			params.REQUISICAOCONFIRMACAO = { $: stringEmpty(record.REQUISICAOCONFIRMACAO) };
			params.RETORNOCONFIRMACAO = { $: stringEmpty(record.RETORNOCONFIRMACAO) };
			params.CODCONTROLE = { $: stringEmpty(record.CODCONTROLE) };
			params.HOSTNAME = { $: stringEmpty(record.HOSTNAME) };


			if (financeiros && financeiros.length > 0) {
				var Financeiro = [];
				angular.forEach(financeiros, function (fin, key) {
					Financeiro.push({ $: fin.$ });
				});
				params.financeiros = { financeiro: Financeiro };
			}
			params = { params: params }
			ServiceProxy.callService("mge@RecebimentoComCartaoSP.gerarAtualizarTransacaoPendente",
				params).then(function (response) {

				});
		}

		function stringEmpty(string) {

			if (angular.isUndefined(string) || string == null) {
				return " "
			}
			else {
				return string
			}
		}

		function setDataSet(dataSet_) {
			dataSet = dataSet_;
		}

		function setSucessoFunction(sucessoFunction_) {
			sucessoFunction = sucessoFunction_;
		}

		function setFinanceiros(financeiros_) {
			financeiros = financeiros_;
		}

		function setNewRecord(newRecord) {
			_newRecord = newRecord;
		}

		function setErroFunction(erroFunction_) {
			erroFunction = erroFunction_;
		}
	}
])
angular
	.module("snk.commons")
	.service("ServicoTEFAdmin", ["ServiceProxy", "TEF", "i18n", "NumberUtils","MGEParameters", 
    function (ServiceProxy, TEF, i18n, NumberUtils, MGEParameters) {

        const self = this;

        self.admTEF = admTEF;
        self.setOnSuccessCallback = setOnSuccessCallback;
        self.setOnErrorCallback = setOnErrorCallback;
        
        
        let onSuccessCallback = () => {};
        let onErrorCallback = () => {};
        
        async function admTEF(){ 
            if(MGEParameters.asInteger("mgefin.tef.gateway") == 2 ||  MGEParameters.asInteger("mgefin.tef.gateway") == 3){
                const params  = new Object();
                params.operacao = TEF.OPERACAO_ADMINSTRATIVA;
                params.identificacao = await getIdentificacaoTEF();
                try {
                    TEF.execute(params, processaRetornoTEF);
                } catch (err) {
                    onErrorCallback(err.message);
                }
            } else {
                onErrorCallback("Funcionalidade suportada apenas por PayGo e SiTef, confira o parametro 'TEFGATEWAY'.");
            }

        };

        async function getIdentificacaoTEF(){

            const {responseBody} = await ServiceProxy.callService("mge@RecebimentoPixTEFSP.gerarNumeroIdentificacao", {});

            if(!responseBody.success){
                throw new Error(responseBody.error || "Erro ao obter identificação TEF.");
            }

            const {payload} = responseBody;

            return payload.identificacaoTEF;
        };

        function processaRetornoTEF(dadosRetorno) {
            
            if (TEF.temErro(dadosRetorno)) {
				TEF.processarErro(dadosRetorno, TEF.OPERACAO_ADMINSTRATIVA, onErrorCallback);
                return;
			}

            onSuccessCallback(dadosRetorno);
		};

        
        function setOnSuccessCallback(callback) {
			onSuccessCallback = callback;
		};

        function setOnErrorCallback(callback) {
			onErrorCallback = callback;
		};
    }]);
angular
	.module("snk.commons")
	.service("ServicosGateway", ["TEF", ServicosGateway
	]); function ServicosGateway(TEF) {
		var self = this;
		self.erroFunction;
		self.sucessoFunction;
		self.executarCertificacao = executarCertificacao;
		self.isAtivo = isAtivo;
		function isAtivo() {
			if (TEF.usaGatewayTEF() == false) {
				if (self.sucessoFunction != null) {
					self.sucessoFunction(null);
				}
			} else {
				var params = {};
				params.operacao = TEF.GATEWAY_ATIVO;
				TEF.execute(params, function (dados) {
					if (TEF.temErro(dados)) {
						try {
							TEF.processarErro(dados, TEF.SERVICO_GATEWAY_ATIVO, self.erroFunction);
						} catch{

						}
					} else {
						if (self.sucessoFunction != null) {
							self.sucessoFunction(buildRetorno(dados));
						}
					}
				});
			}
		}


		function executarCertificacao(nroTesteCertificacao) {
			if (!TEF.usaGatewayTEF()) {
				if (self.sucessoFunction != null) {
					self.sucessoFunction(null);
				}
			} else {
				var params = {};
				params.operacao = TEF.CERTIFICACAO;

				if (nroTesteCertificacao >= 0) {
					params.nroTesteCertificacao = nroTesteCertificacao;
				}

				TEF.execute(params, function (dados) {
					if (TEF.temErro(dados)) {
						TEF.processarErro(dados, TEF.SERVICO_CERTIFICACAO, self.erroFunction);
					} else {
						if (self.sucessoFunction != null) {
							self.sucessoFunction(buildRetorno(dados));
						}
					}
				});
			}
		}

		function buildRetorno(dados) {
			if (dados && dados.responseTef) {
				var records = [];

				for (var name in dados.responseTef) {
					records[name] = dados.responseTef[name];
				}

				return records;
			}

			return null;
		}
	}
angular
  .module("snk.commons")
  .service("TEF", ["MGEParameters", "SkApplication", "i18n", "StringUtils", "DateUtils", "SkApplicationInstance", TEF2]);

function TEF2(MGEParameters, skApplication, i18n, StringUtils, DateUtils, SkApplicationInstance) {
  var self = this;

  var ExternalInterface = new (function () {
    var self = this;

    self.addCallback = addCallback;
    self.call = call;

    function addCallback(callbackName, callback) {
      window[callbackName] = callback;
    }

    function call(callbackName) {
      if (callbackName == null || callbackName.length == 0) {
        throw new Error(i18n('Commons.RecebimentoCartao.msgParamNaoInformado'));
      }

      var fn = window[callbackName];

      if (fn == null) {
        throw new Error(
          i18n('Commons.RecebimentoCartao.msgCallBackInexistente')
        );
      }

      var args = [];

      if (arguments != null && arguments.length > 1) {
        args = arguments.slice(1, arguments.length);
      }

      return fn.call(this, args);
    }
  });

  var UIDGenerator = new (function () {
    var self = this;

    self.generateUID = generateUID;
    self.generateTinyUID = generateTinyUID;

    var CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";
    var _lastUID;

    function generateUID(prefix) {
      if (prefix == null) {
        prefix = "uid_";
      }

      if (_lastUID) {
        _lastUID++;
      } else {
        var now = new Date();
        _lastUID = now.getTime();
      }

      return prefix + generateTinyUID(_lastUID);
    }

    function generateTinyUID(i) {
      return i < CHARS.length
        ? CHARS.charAt(i)
        : arguments.callee(i / CHARS.length - 1) +
        CHARS.charAt(i % CHARS.length);
    }
  })();

  var StandAloneField = function (name, description, type, visible, order) {
    var self = this;

    self.name = name;
    self.description = description;
    self.isPk = false;
    self.userType = type;
    self.dataType = type;
    self.precision = 0;
    self.prettyPrecision = 0;
    self.readOnly = false;
    self.required = false;
    self.size = -1;
    self.visible = visible == "S";
    self.fk = null;
    self.options = null;
    self.properties = null;
    self.presentationType = null;
    self.standAlone = true;
    self.isDescriptionField = false;
    self.buildOptionsFn = null; //Esta propriedade só funciona no datagrid, caso necessário terá que ser implementada nos outros locais
    self.width = 100;
  };

  var ResourceManager = new (function () {
    var self = this;

    self.getInstance = getInstance;
    self.getString = getString;

    function getInstance() {
      return self;
    }

    function getString(bundle, key) {
      var resourceKey = bundle.replace(":", ".") + "." + key;
      return i18n(resourceKey);
    }
  })();

  self.onResponse = onResponse;
  self.execute = execute;
  self.usaRecebimentoComCartao = usaRecebimentoComCartao;
  self.usaGatewayTEF = usaGatewayTEF;
  self.isModoCertificacao = isModoCertificacao;
  self.isEmCertificacao = isEmCertificacao;
  self.exigeIdentificacao = exigeIdentificacao;
  self.isConfirmacaoAutomatica = isConfirmacaoAutomatica;
  self.processarErro = processarErro;
  self.temErro = temErro;
  self.getCodigoRetorno = getCodigoRetorno;
  self.getCodigoErro = getCodigoErro;
  self.getMsgError = getMsgError;
  self.getOperacao = getOperacao;
  self.buildCupom = buildCupom;
  self.isDebitoParcelado = isDebitoParcelado;
  self.isDebitoPreDatado = isDebitoPreDatado;
  self.buildRecordSolicitacao = buildRecordSolicitacao;
  self.buildRecordConfirmacao = buildRecordConfirmacao;
  self.buildRecordDesfazimento = buildRecordDesfazimento;
  self.createFieldsDataSet = createFieldsDataSet;

  // Gateway
  var AUTTAR = "AUTTAR";
  var PAYGO = "PAYGO";
  var SITEF = "SITEF";

  // Transações (Operações TEF)
  self.CREDITO_A_VISTA = 112;
  self.CREDITO_PARCELADO_SEM_JUROS = 113; // Logista
  self.CREDITO_PARCELADO_COM_JUROS = 114; // Administradora
  self.DEBITO = 101;
  self.DEBITO_PRE_DATADO = 103;
  self.DEBITO_PARCELADO = 104;
  self.DEBITO_PARCELADO_PARCELA_A_VISTA = 105;
  self.VOUCHER = 106;
  self.PAGAMENTO_PIX = 422;
  self.CANCELAMENTO = 128;
  self.CONFIRMACAO = 6;
  self.DESFAZIMENTO_TOTAL = 191;
  self.DIGITA_CPF = 300; //Digita CPF no PinPad

  // Serviços do Gateway
  self.GATEWAY_ATIVO = -127001;
  self.CERTIFICACAO = -127002;
  self.OPERACAO_ADMINSTRATIVA = -99;

  // Certificação
  self.ABORTAR_CERTIFICACAO = -1;
  self.CONTINUAR_CERTIFICACAO = 0;
  self.FINALIZAR_CERTIFICACAO = 1;

  // Códigos de retorno
  self.EXECUCAO_BEM_SUCEDIDA = 0;
  self.TIME_OUT = 1;
  self.TRANSACAO_NAO_AUTORIZADA_PELA_AUTORIZADORA = 5;
  self.ERRO_NA_CAMADA_INTERNET = 10;
  self.TRANSACAO_NAO_AUTORIZADA_PELO_CTF = 11;
  self.ERRO_NA_CAMADA_INTERTEF = 12;
  self.EXECUCAO_BEM_SUCEDIDA_CONF_DESF = 13;
  self.DADO_INVALIDO = 20;
  self.ERRO_NA_CAMADA_PROCESSAMENTO = 30;
  self.ERRO_GENERICO = 255;

  // Códigos de erro para o retorno 20
  self.OPERACAO_CANCELADA = 5317;

  // Erro de comunicação
  self.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO = -888888888;
  var ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO = self.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO;

  // Erro lançado pelo SnkTEF
  self.ERRO_INTERNO = -999999999;

  // Funções JavaScript (Tef.js)
  var EXECUTE = "tef.execute";

  self.TRANSACAO_PENDENTE = "P";
  self.TRANSACAO_CONFIRMADA = "C";
  self.TRANSACAO_DESFEITA = "D";
  self.TRANSACAO_EM_CANCELAMENTO = "Z";
  self.TRANSACAO_CANCELADA = "X";
  self.TRANSACAO_CANCELADA_ADMINISTRATIVAMENTE = "Y";

  self.SERVICO_SOLICITAR_TRANSACAO = "SOLICITAR_TRANSACAO";
  self.SERVICO_CONFIRMAR_TRANSACAO = "CONFIRMAR_TRANSACAO";
  self.SERVICO_DESFAZER_TRANSACAO = "DESFAZER_TRANSACAO";
  self.SERVICO_SOLICITAR_CANCELAMENTO = "SOLICITAR_CANCELAMENTO";
  self.SERVICO_CONFIRMAR_CANCELAMENTO = "CONFIRMAR_CANCELAMENTO";
  self.SERVICO_GERANDO_RECEBIMENTO = "GERANDO_RECEBIMENTO";
  self.SERVICO_CONCLUINDO_RECEBIMENTO = "CONCLUINDO_RECEBIMENTO";
  self.SERVICO_CANCELAMENTO_ADMINISTRATIVO = "CANCELAMENTO_ADMINISTRATIVO";
  self.SERVICO_CONCLUINDO_CANCELAMENTO = "CONCLUINDO_CANCELAMENTO";
  self.SERVICO_CONCLUINDO_CANCELAMENTO_IMPRESSAO =
    "SERVICO_CONCLUINDO_CANCELAMENTO_IMPRESSAO";
  self.SERVICO_GATEWAY_ATIVO = "GATEWAY_ATIVO";
  self.SERVICO_CERTIFICACAO = "SERVICO_CERTIFICACAO";
  self.SERVICO_PIX = "SERVICO_PIX";

  var callbacks = {};

  initialize();

  function initialize() {
    // Registra a function de respota para as Operações TEF
    ExternalInterface.addCallback("tefResponse", self.onResponse);
  }

  function onResponse(responseBody) {
    var requestID = responseBody.requestID;

    var callback = callbacks[requestID];

    if (callback != null) {
      delete callbacks[requestID];

      callback(responseBody);
    }
  }

  function execute(params, callback) {
    params.requestID = UIDGenerator.generateUID(EXECUTE + "_");
    params.urlCtfClient = MGEParameters.asString(
      "mgefin.url.para.integracao.com.ctfclient"
    );

    var gateway = MGEParameters.asInteger("mgefin.tef.gateway");
    if (gateway > 0) {
      params.urlCtfClient = MGEParameters.asString("mgefin.tef.gateway.url");

      if (gateway == 1) {
        params.gateway = AUTTAR;
      } else if (gateway == 2) {
        params.gateway = PAYGO;
      } else if (gateway == 3) {
        params.gateway = SITEF;
      }

      if (isEmCertificacao()) {
        params.redeAdquirente = "CERTIF";
      }
    }

    window[params.requestID] = callback
    try {
      tefhtml.execute(params);
    }
    catch (err) {
     
    }
  }

  function usaRecebimentoComCartao() {
    return (
      MGEParameters.asBoolean("mgefin.usa.recebimento.cartao.ctfclient") ||
      usaGatewayTEF()
    );
  }

  function usaGatewayTEF() {
    return MGEParameters.asInteger("mgefin.tef.gateway") > 0;
  }

  function isModoCertificacao() {
    return (
      usaGatewayTEF() &&
      SkApplicationInstance.getAttributeFromHTMLWrapper("modoCertifTef") == "true"
    );
  }

  function isEmCertificacao() {
    return (
      isModoCertificacao() &&
      skApplication.getRuntimeProperty("mgefin.tef.popup.modo.certificacao") ===
      true
    );
  }

  function exigeIdentificacao() {
    return MGEParameters.asInteger("mgefin.tef.gateway") > 1;
  }

  function isConfirmacaoAutomatica() {
    return (
      (isModoCertificacao() && MGEParameters.asInteger("mgefin.tef.gateway") == 3) || MGEParameters.asBoolean("mgefin.tef.confirmacao.automatica")
    );
  }

  function processarErro(data, serviceName, erroFunction) {
    var codRetorno = getCodigoRetorno(data);
    var codErro = getCodigoErro(data);
    var errorMsg = getMsgError(data);

    if (errorMsg == null) {
      switch (codRetorno) {
        case self.DADO_INVALIDO:
          var erros = data.responseTef.display;

          erros.forEach(function (erro) {
            errorMsg += erro.mensagem;
          });

          break;

        case self.TIME_OUT:
          errorMsg =
            i18n("Commons.RecebimentoCartao.msgErroTimeoutTrans") + ".";
          break;

        case self.TRANSACAO_NAO_AUTORIZADA_PELA_AUTORIZADORA:
          errorMsg =
            i18n("Commons.RecebimentoCartao.msgErroTransNaoAutorizadaRede") +
            ".";
          break;

        case self.TRANSACAO_NAO_AUTORIZADA_PELO_CTF:
          errorMsg =
            i18n("Commons.RecebimentoCartao.msgErroTransNaoAutorizadaCTF") +
            ".";
          break;

        case self.ERRO_NA_CAMADA_INTERNET:
        case self.ERRO_NA_CAMADA_INTERTEF:
          errorMsg = i18n("Commons.RecebimentoCartao.msgErroComunicacao") + ".";
          break;

        case self.ERRO_NA_CAMADA_PROCESSAMENTO:
        case self.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO:
          errorMsg =
            i18n("Commons.RecebimentoCartao.msgErroProcessamento") + ".";
          break;

        default:
          errorMsg =
            i18n("Commons.RecebimentoCartao.msgErroNaoIdentificado") + ".";
          break;
      }
    }

    if (erroFunction != null) {
      var retorno = new Object();

      retorno.codRetorno = codRetorno;
      retorno.codErro = codErro;
      retorno.msgErro = errorMsg;
      retorno.servico = serviceName;

      if (
        self.isEmCertificacao() &&
        data &&
        data.hasOwnProperty("responseTef") &&
        data.responseTef.retornoCertificacao
      ) {
        retorno.retornoCertificacao = parseInt(
          data.responseTef.retornoCertificacao
        );
      }

      erroFunction(retorno);
    } else {
      throw new Error(errorMsg);
    }
  }

  function temErro(data) {
    var retorno = getCodigoRetorno(data);
    var operacao = getOperacao(data);

    var isTemErro = false;

    switch (retorno) {
      case self.EXECUCAO_BEM_SUCEDIDA:
        isTemErro = false;
        break;

      case self.EXECUCAO_BEM_SUCEDIDA_CONF_DESF:
        isTemErro =
          !(operacao != self.CONFIRMACAO) && !(operacao != self.DESFAZIMENTO_TOTAL);
        break;

      case self.DADO_INVALIDO:
      case self.TIME_OUT:
      case self.TRANSACAO_NAO_AUTORIZADA_PELA_AUTORIZADORA:
      case self.ERRO_NA_CAMADA_INTERNET:
      case self.TRANSACAO_NAO_AUTORIZADA_PELO_CTF:
      case self.ERRO_NA_CAMADA_INTERTEF:
      case self.ERRO_NA_CAMADA_PROCESSAMENTO:
      case self.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO:
      case self.ERRO_INTERNO:
        isTemErro = true;
        break;

      default:
        isTemErro = true;
        break;
    }

    return isTemErro;
  }

  function getCodigoRetorno(data) {
    var retorno = self.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO;

    if (data) {
      if (data.hasOwnProperty("errorTef")) {
        retorno = self.ERRO_COMUNICACAO_OU_NAO_IDENTIFICADO;
      } else if (data.hasOwnProperty("responseTef")) {
        var responseTef = data.responseTef;
        if (responseTef && responseTef.hasOwnProperty("retorno")) {
          retorno = parseInt(data.responseTef.retorno);
        }
      }
    }

    return retorno;
  }

  function getCodigoErro(data) {
    var erro = 0;

    if (
      data.responseTef != null &&
      StringUtils.emptyAsNull(data.responseTef.codigoErro) != null
    ) {
      erro = parseInt(data.responseTef.codigoErro);
    }

    return erro;
  }

  function getMsgError(data) {
    var msg = "";

    if (
      data.responseTef != null &&
      data.responseTef.display != null &&
      data.responseTef.display instanceof Array
    ) {
      var msgList = data.responseTef.display;
      msgList.forEach(function (item) {
        msg += item.mensagem;
      });
    } else if(data.errorMessage != null){
      msg = data.errorMessage;
    }

    return StringUtils.emptyAsNull(msg);
  }

  function getOperacao(data) {
    var operacao = 0;

    if (data.errorTef != null) {
      operacao = parseInt(data.requestTef.operacao);
    } else {
      operacao = parseInt(data.operacao);
    }

    return operacao;
  }

  function buildCupom(cupomData) {
    if (cupomData == null) {
      return null;
    }

    var cupomStr = "";

    for (var i = 0; i < cupomData.length; i++) {
      if (i > 0) {
        cupomStr += "\n";
      }

      cupomStr += cupomData[i].linha;
    }

    return cupomStr;
  }

  function isDebitoParcelado(operacao) {
    switch (operacao) {
      case self.DEBITO_PARCELADO:
      case self.DEBITO_PARCELADO_PARCELA_A_VISTA:
        return true;

      default:
        return false;
    }
  }

  function isDebitoPreDatado(operacao) {
    return operacao == self.DEBITO_PRE_DATADO;
  }

  function buildRecordSolicitacao(data) {
    var record = new Object();

    record.NSUCTF = StringUtils.emptyAsNull(data.responseTef.nsuCTF);
    record.OPERACAO = StringUtils.emptyAsNull(data.responseTef.operacao);
    record.CODRESPAUTORIZADORA = StringUtils.emptyAsNull(
      data.responseTef.codigoRespAutorizadora
    );
    record.CODAPROVACAO = StringUtils.emptyAsNull(
      data.responseTef.codigoAprovacao
    );
    record.VLRTRANSACAO = Number(data.responseTef.valorTransacao);
    record.NSUAUTORIZADORA = StringUtils.emptyAsNull(
      data.responseTef.nsuAutorizadora
    );
    record.BANDEIRA = StringUtils.emptyAsNull(data.responseTef.bandeira);
    record.REDEADQUIRENTE = StringUtils.emptyAsNull(
      data.responseTef.redeAdquirente
    );
    record.CODREDEADQUIRENTE = StringUtils.emptyAsNull(data.responseTef.codRedeAdquirente);
    record.CARTAO = StringUtils.emptyAsNull(data.responseTef.cartao);
    record.CUPOMESTABELECIMENTO = self.buildCupom(
      data.responseTef.cupomEstabelecimento
    );
    record.CUPOMCLIENTE = self.buildCupom(data.responseTef.cupomCliente);
    record.CUPOMREDUZIDO = self.buildCupom(data.responseTef.cupomReduzido);
    record.REQUISICAO = JSON.stringify(data.requestTef);
    record.RETORNO = JSON.stringify(data.responseTef);

    if (usaGatewayTEF()) {
      record.CODCONTROLE = StringUtils.emptyAsNull(
        data.responseTef.codControle
      );
      record.STATUS = StringUtils.emptyAsNull(data.responseTef.statusTransacao);
      record.EXIGECONFIRMULTCARTOES = StringUtils.emptyAsNull(
        data.responseTef.exigeConfirmacaoMultCartoes
      );
      record.HOSTNAME = StringUtils.emptyAsNull(data.responseTef.hostName);

      if (StringUtils.emptyAsNull(data.responseTef.dataTransacao)) {
        record.DTTRANSACAO = DateUtils.strToDate(data.responseTef.dataTransacao);
      }
      if (StringUtils.emptyAsNull(data.responseTef.dataPreDatado)) {
        record.DTPREDATADO = DateUtils.strToDate(data.responseTef.dataPreDatado);
      }
      if (StringUtils.emptyAsNull(data.responseTef.identificacao)) {
        record.IDENTIFICACAOTEF = Number(
          StringUtils.emptyAsNull(data.responseTef.identificacao)
        );
      }
      if (StringUtils.emptyAsNull(data.responseTef.numeroParcelas)) {
        record.QTDPARCELAS = Number(
          StringUtils.emptyAsNull(data.responseTef.numeroParcelas)
        );
      }
    }

    return record;
  }

  function buildRecordConfirmacao(data) {
    var record = new Object();

    record.REQUISICAO = JSON.stringify(data.requestTef);
    record.RETORNO = JSON.stringify(data.responseTef);
    record.STATUS = StringUtils.emptyAsNull(data.responseTef.statusTransacao);
    record.HOSTNAME = StringUtils.emptyAsNull(data.responseTef.hostName);

    return record;
  }

  function buildRecordDesfazimento(data) {
    var record = new Object();

    record.REQUISICAO = JSON.stringify(data.requestTef);
    record.RETORNO = JSON.stringify(data.responseTef);
    record.STATUS = StringUtils.emptyAsNull(data.responseTef.statusTransacao);
    record.HOSTNAME = StringUtils.emptyAsNull(data.responseTef.hostName);

    return record;
  }

  function createFieldsDataSet(ds) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        var field;

        if (ds.getUserFieldMetadata("OPERACAO") == null) {
          field = new StandAloneField(
            "OPERACAO",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblOperacao"
            ),
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("STATUS") == null) {
          field = new StandAloneField(
            "STATUS",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblSituacao"
            ),
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("VLRTRANSACAO") == null) {
          field = new StandAloneField(
            "VLRTRANSACAO",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblVlrTransacao"
            ),
            "F",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("DTTRANSACAO") == null) {
          field = new StandAloneField(
            "DTTRANSACAO",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblDtTransacao"
            ),
            "D",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("QTDPARCELAS") == null) {
          field = new StandAloneField(
            "QTDPARCELAS",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblQtdParcelas"
            ),
            "I",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("BANDEIRA") == null) {
          field = new StandAloneField(
            "BANDEIRA",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblBandeira"
            ),
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CARTAO") == null) {
          field = new StandAloneField(
            "CARTAO",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblFinalCartao"
            ),
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CODTIPTIT") == null) {
          field = new StandAloneField(
            "CODTIPTIT",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblTipoTitulo"
            ),
            "I",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("DESCRTIPTIT") == null) {
          field = new StandAloneField("DESCRTIPTIT", "DESCRTIPTIT", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("VLRTAXA") == null) {
          field = new StandAloneField(
            "VLRTAXA",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblVlrTaxa"
            ),
            "F",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NSUCTF") == null) {
          field = new StandAloneField(
            "NSUCTF",
            ResourceManager.getInstance().getString(
              "Commons:RecebimentoCartao",
              "lblCodTransacao"
            ),
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NSUCTFCAN") == null) {
          field = new StandAloneField("NSUCTFCAN", "NSUCTFCAN", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NUMTRANS") == null) {
          field = new StandAloneField("NUMTRANS", "NUMTRANS", "I", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CODRESPAUTORIZADORA") == null) {
          field = new StandAloneField(
            "CODRESPAUTORIZADORA",
            "CODRESPAUTORIZADORA",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CODAPROVACAO") == null) {
          field = new StandAloneField("CODAPROVACAO", "CODAPROVACAO", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NSUAUTORIZADORA") == null) {
          field = new StandAloneField(
            "NSUAUTORIZADORA",
            "NSUAUTORIZADORA",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("REDEADQUIRENTE") == null) {
          field = new StandAloneField("REDEADQUIRENTE", "REDEADQUIRENTE", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("COMPROVANTE") == null) {
          field = new StandAloneField("COMPROVANTE", "COMPROVANTE", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CUPOMESTABELECIMENTO") == null) {
          field = new StandAloneField(
            "CUPOMESTABELECIMENTO",
            "CUPOMESTABELECIMENTO",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CUPOMCLIENTE") == null) {
          field = new StandAloneField("CUPOMCLIENTE", "CUPOMCLIENTE", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CUPOMREDUZIDO") == null) {
          field = new StandAloneField("CUPOMREDUZIDO", "CUPOMREDUZIDO", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CUPOMESTABELECIMENTOCAN") == null) {
          field = new StandAloneField(
            "CUPOMESTABELECIMENTOCAN",
            "CUPOMESTABELECIMENTOCAN",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CUPOMCLIENTECAN") == null) {
          field = new StandAloneField(
            "CUPOMCLIENTECAN",
            "CUPOMCLIENTECAN",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CUPOMREDUZIDOCAN") == null) {
          field = new StandAloneField(
            "CUPOMREDUZIDOCAN",
            "CUPOMREDUZIDOCAN",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("REQUISICAO") == null) {
          field = new StandAloneField("REQUISICAO", "REQUISICAO", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("RETORNO") == null) {
          field = new StandAloneField("RETORNO", "RETORNO", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("REQUISICAOCONFIRMACAO") == null) {
          field = new StandAloneField(
            "REQUISICAOCONFIRMACAO",
            "REQUISICAOCONFIRMACAO",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("RETORNOCONFIRMACAO") == null) {
          field = new StandAloneField(
            "RETORNOCONFIRMACAO",
            "RETORNOCONFIRMACAO",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NURENEG") == null) {
          field = new StandAloneField("NURENEG", "NURENEG", "I", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NUACERTO") == null) {
          field = new StandAloneField("NUACERTO", "NUACERTO", "I", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CODCONTROLE") == null) {
          field = new StandAloneField("CODCONTROLE", "CODCONTROLE", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CODCONTROLECAN") == null) {
          field = new StandAloneField("CODCONTROLECAN", "CODCONTROLECAN", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }
        if (ds.getUserFieldMetadata("CODREDEADQUIRENTE") == null) {
          field = new StandAloneField("CODREDEADQUIRENTE", "CODREDEADQUIRENTE", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("EXIGECONFIRMULTCARTOES") == null) {
          field = new StandAloneField(
            "EXIGECONFIRMULTCARTOES",
            "EXIGECONFIRMULTCARTOES",
            "S",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("HOSTNAME") == null) {
          field = new StandAloneField("HOSTNAME", "HOSTNAME", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("DESDOBRAMENTO") == null) {
          field = new StandAloneField("DESDOBRAMENTO", "DESDOBRAMENTO", "I", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CONFIRMADO") == null) {
          field = new StandAloneField("CONFIRMADO", "CONFIRMADO", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("DTPREDATADO") == null) {
          field = new StandAloneField("DTPREDATADO", "DTPREDATADO", "D", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("IDENTIFICACAOTEF") == null) {
          field = new StandAloneField(
            "IDENTIFICACAOTEF",
            "IDENTIFICACAOTEF",
            "I",
            "S"
          );
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("OPERACAOORIG") == null) {
          field = new StandAloneField("OPERACAOORIG", "OPERACAOORIG", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("CNPJCPFEMPRESA") == null) {
          field = new StandAloneField("CNPJCPFEMPRESA", "CNPJCPFEMPRESA", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }

        if (ds.getUserFieldMetadata("NUFINPARCELAS") == null) {
          field = new StandAloneField("NUFINPARCELAS", "NUFINPARCELAS", "S", "S");
          field.required = false;
          ds.addUserFieldMetadata(field);
        }
        resolve(i18n('Commons.RecebimentoCartao.promiseResolvida'));
      }, 0);
    })
  }

}

function TEFHTML() {
}

TEFHTML.prototype.execute = function(params) {
	var ws = new WebSocket(params.urlCtfClient);
	var sucesso = false;

	ws.onclose = function(evt) {
		// nada a fazer
	}

	ws.onerror = function(evt) {
		var responseBody = {
				errorTef: evt,
				requestID: params.requestID,
				requestTef: {
					operacao: params.operacao,
					valorTransacao: params.valorTransacao,
					dataTransacao: params.dataTransacao,
					numeroTransacao: params.numeroTransacao,
					nsuCTF: params.nsuCTF
				}
			};
			window["tefResponse"] = responseBody;
			window[params.requestID](responseBody);

		ws.close();
	}

	ws.onopen = function(evt) {
		var transacao = {};
		var requestTimeOut = 0;

		if (params.requestTimeOut != undefined) {
			requestTimeOut = params.requestTimeOut * 1000;
		}

		if (params.operacao != undefined) {
			transacao.operacao = params.operacao;
		}

		if (params.valorTransacao != undefined) {
			transacao.valorTransacao = params.valorTransacao;
		}

		if (params.numeroTransacao != undefined) {
			transacao.numeroTransacao = params.numeroTransacao;
		}

		if (params.numeroParcelas != undefined) {
			transacao.numeroParcelas = params.numeroParcelas;
		}

		if (params.dataTransacao != undefined) {
			transacao.dataTransacao = params.dataTransacao;
		}

		if (params.nsuCTF != undefined) {
			transacao.nsuCTF = params.nsuCTF;
		}

		if (params.redeAdquirente != undefined) {
			transacao.redeAdquirente = params.redeAdquirente;
		}

		if (params.codControle != undefined) {
			transacao.codControle = params.codControle;
		}

		if (params.codigoAprovacao != undefined) {
			transacao.codigoAprovacao = params.codigoAprovacao;
		}

		if (params.gateway != undefined) {
			transacao.gateway = params.gateway;
		}

		if (params.nroTesteCertificacao != undefined) {
			transacao.nroTesteCertificacao = params.nroTesteCertificacao;
		}

		if (params.identificacao != undefined) {
			transacao.identificacao = params.identificacao;
		}

		if (params.operacaoOrigem != undefined) {
			transacao.operacaoOrigem = params.operacaoOrigem;
		}

		if (params.cnpjcpfEstabelecimento != undefined) {
			transacao.cnpjcpfEstabelecimento = params.cnpjcpfEstabelecimento;
		}

		var req = JSON.stringify(transacao);

		params.req = transacao;

		ws.send(req);

		if(requestTimeOut > 0){
			setTimeout(function(){
				if(!sucesso){
					var responseBody = {
						errorTef: -888888888,
						requestID: params.requestID,
						errorMessage : "Opera\u00E7\u00E3o cancelada! Tempo limite de processamento excedido.",
						requestTef: {
							operacao: params.operacao,
							valorTransacao: params.valorTransacao,
							dataTransacao: params.dataTransacao,
							numeroTransacao: params.numeroTransacao,
							nsuCTF: params.nsuCTF
						}
					};
					window["tefResponse"] = responseBody;
					window[params.requestID](responseBody);
					
					ws.close();
				}
			}, requestTimeOut);
		}

	}

	ws.onmessage = function(evt) {
		sucesso = true;
		try {
		var data = evt.data;
        var response = JSON.parse(data);
        var responseBody;

        if (response.erro) {
          responseBody = {
            errorTef: -999999999,
            errorMessage: response.erro,
            requestID: params.requestID,
            requestTef: params.req
          };
        } else {
          responseBody = {
            responseTef: response,
            requestID: params.requestID,
            requestTef: params.req
          };
        }

        window[params.requestID](responseBody);
        window["tefResponse"] = responseBody;

		} catch (error) {
			var responseBody = {
				errorTef: -888888888,
				requestID: params.requestID,
				errorMessage : error.message,
				requestTef: {
					operacao: params.operacao,
					valorTransacao: params.valorTransacao,
					dataTransacao: params.dataTransacao,
					numeroTransacao: params.numeroTransacao,
					nsuCTF: params.nsuCTF
				}
			};
			window["tefResponse"] = responseBody;
			window[params.requestID](responseBody);
		} finally {
			ws.close();
		}
		
	}

};

var tefhtml = new TEFHTML();
/**
 * Created by gustavo.barbosa on 14/11/2019.
 */
angular
    .module('snk.commons')
    .controller('RentabilidadePopUpController', ['$scope', 'codUsu', 'nuNota', 'ServiceProxy', 'i18n', 'SkApplicationInstance', 'ObjectUtils', 'SkI18nService', 'AngularUtil',
        function ($scope, codUsu, nuNota, ServiceProxy, i18n, SkApplicationInstance, ObjectUtils, SkI18nService,AngularUtil) {

            var self = this;

            ObjectUtils.implements(self, IDatagridInterceptor);

        //Dados Geral
            self.carregaInfos = carregaInfos;
            self.getCellColors = getCellColors;
            self.interceptCellRenderer = interceptCellRenderer;

        //*********************************************************************//

        //Dados Com Custo
            self.onDatasetCreatedComCusto = onDatasetCreatedComCusto;
            self.onDatagridLoadedComCusto = onDatagridLoadedComCusto;
            self.datasetComCusto;
            self.datagridComCusto;
            self.dadosDatasetComCusto = [];
            self.gridConfigNameComCusto;
            self.datasetListenerComCusto = datasetListenerComCusto;
        //*********************************************************************//

        //Dados Sem Custo
            self.onDatasetCreatedSemCusto = onDatasetCreatedSemCusto;
            self.onDatagridLoadedSemCusto = onDatagridLoadedSemCusto;
            self.datasetSemCusto;
            self.datagridSemCusto;
            self.dadosDatasetSemCusto = [];
            self.gridConfigNameSemCusto
            self.datasetListenerSemCusto = datasetListenerSemCusto;
        //*********************************************************************//

        //Dados Nota
            self.carregaChartNota = carregaChartNota;
            self.dadosNota;
        //*********************************************************************//

            self.mostraBtnRentabilidadeNota = false;
            self.podeExibirGrafico = true;

            self.chartTitle = SkI18nService.instant('Commons.Rentabilidade.labelRentabilidadeNota');

            self.showMessageMargemNota;
            self.messageMargemNota;

            self.preferLabel;
            self.preferInfo;

        //Inicio -------


            function init() {
                setGridConfigNames();
            }

            function setGridConfigNames() {
                self.gridConfigNameComCusto = SkApplicationInstance.getResourceID() + ".gridProdutosComCusto";
                self.gridConfigNameSemCusto = SkApplicationInstance.getResourceID() + ".gridProdutosSemCusto";
            }

            function carregaInfos() {
                init();
                var params = {
                    nuNota: nuNota,
                }

                if(self.codUsu) {
                    params.codUsu = self.codUsu;
                }

                ServiceProxy.callService("mge@LiberacaoLimitesSP.getDadosRentabilidade", { params })
                    .then(function (response) {
                            self.fat = Number(response.responseBody.somaFaturamento);
                            self.cmv = Number(response.responseBody.somaCustoMercadoriaVendida);
                            self.gv = Number(response.responseBody.somaGastoVariavel);
                            self.gf = Number(response.responseBody.somaGastoFixo);
                            self.lucro = Number(response.responseBody.somaLucro);
                            self.mc = Number(response.responseBody.margemContrib);
                            self.temPreferencia = response.responseBody.possuiPreferencias == "true";
                            self.podeExibirGrafico = response.responseBody.podeExibirGrafico == "S";

                        self.dadosNota = response.responseBody;
                        self.dadosDatasetComCusto = formatData(response.responseBody.produtosComCusto.entities.entity);
                        self.dadosDatasetSemCusto = formatData(response.responseBody.produtosSemCusto.entities.entity);

                        if (self.temPreferencia) {
							self.preferLabel = response.responseBody.labelTipoPreferencia;
							self.preferInfo = response.responseBody.legendaPreferencia;
                            self.preferLabelColor = decimalColorToHTMLcolor(response.responseBody.corFonte);
                            self.preferBackColor = decimalColorToHTMLcolor(response.responseBody.corFundo);
                            setLabelColor(self.preferLabelColor, self.preferBackColor);
                        }

                        if (self.dadosDatasetSemCusto) {
                            self.datasetSemCusto.clearDataSet();
                            self.datasetSemCusto.addRecordsAsObjects(self.dadosDatasetSemCusto);

                            let legendaVisivel = self.temPreferencia;
                            if (legendaVisivel && self.datagridSemCusto && self.datagridSemCusto.getGridApi()) {
                                for (const column of self.datagridSemCusto.getColumnApi().getAllColumns()) {
                                    if (column && column.colId === 'LEGENDA') {
                                        legendaVisivel = column.visible;
                                        break;
                                    }
                                }
                            }
                            self.datagridSemCusto?.getColumnByName('LEGENDA')?.setVisible(legendaVisivel);

                            if(self.dadosDatasetSemCusto.length > 0){
                                self.showMessageMargemNota = true;

                                if(self.dadosDatasetSemCusto.length > 1){
                                    self.messageMargemNota = i18n('Commons.Rentabilidade.messageMargemDaNotaProdutos',[self.dadosDatasetSemCusto.length]);
                                } else {
                                    self.messageMargemNota = i18n('Commons.Rentabilidade.messageMargemDaNotaProduto');
                                }
                            }
                        }

                        if (self.dadosDatasetComCusto) {
                            self.datasetComCusto.clearDataSet();
                            self.datasetComCusto.addRecordsAsObjects(self.dadosDatasetComCusto);

                            let legendaVisivel = self.temPreferencia;
                            if (legendaVisivel && self.datagridComCusto && self.datagridComCusto.getGridApi()) {
                                for (const column of self.datagridComCusto.getColumnApi().getAllColumns()) {
                                    if (column && column.colId === 'LEGENDA') {
                                        legendaVisivel = column.visible;
                                        break;
                                    }
                                }
                            }
                            self.datagridComCusto?.getColumnByName('LEGENDA')?.setVisible(legendaVisivel);
                        }
                    }
                )
            }

            function decimalColorToHTMLcolor(number) {
                //converts to a integer
                var intNumber = number - 0;
             
                // isolate the colors - really not necessary
                var red, green, blue;
             
                // needed since toString does not zero fill on left
                var template = "000000";
             
                /* in the MS Windows world RGB colors
                // are 0xBBGGRR because of the way Intel chips store bytes
                red = (intNumber&0x0000ff) << 16;
                green = intNumber&0x00ff00;
                blue = (intNumber&0xff0000) >>> 16;
             
                // mask out each color and reverse the order
                intNumber = red|green|blue;*/
             
                // toString converts a number to a hexstring
                var HTMLcolor = intNumber.toString(16).padStart(6, '0');
             
                //template adds # for standard HTML #RRGGBB
               // HTMLcolor = template.substring(0,7 - HTMLcolor.length) + HTMLcolor;
                HTMLcolor = '#' + HTMLcolor + template.substring(HTMLcolor.length, 6)
             
                return HTMLcolor;
            } 

        //Dataset e Datagrid Com Custo
            function onDatasetCreatedComCusto(dataset) {
                self.datasetComCusto = dataset;
                self.datasetComCusto.addLineChangeListener((index) => {
                    if(index != -1) {
                        datasetListenerComCusto();
                    }
                })
                self.datasetComCusto.initAndRefresh();
            }

            function onDatagridLoadedComCusto(datagrid) {
                self.datagridComCusto = datagrid;
                self.datagridComCusto.unselectAllSelectedRows();
            }
        //*********************************************************************//

        //Dataset e DataGrid Sem Custo
            function onDatasetCreatedSemCusto(dataset) {
                self.datasetSemCusto = dataset;
                self.datasetSemCusto.addLineChangeListener((index) => {
                    if(index != -1) {
                        datasetListenerSemCusto();
                    }
                })
                self.datasetSemCusto.initAndRefresh();
            }

            function onDatagridLoadedSemCusto(datagrid) {
                self.datagridSemCusto = datagrid;
                self.datagridSemCusto.unselectAllSelectedRows();
            }
        //*********************************************************************//

        //Carrega grafico com dados Com Custo
            function datasetListenerComCusto() {
                var item = self.datasetComCusto.getCurrentRowAsObject();
                setChartData(item)
            }
        //*********************************************************************//

        //Carrega grafico com dados Sem Custo
            function datasetListenerSemCusto() {
                var item = self.datasetSemCusto.getCurrentRowAsObject();
                setChartData(item)

            }
            //*********************************************************************//

            function setChartData(item){
                if (item) {
                    self.fat = Number(item.FATURAMENTO);
                    self.cmv = Number(item.CUSTOMERCVEND);
                    self.gv = Number(item.GASTOVAR);
                    self.gf = Number(item.GASTOFIXO);
                    self.mc = Number(item.MARGEMCONTRIB);
                    self.lucro = Number(item.LUCRO);

                    self.chartTitle = SkI18nService.instant('Commons.Rentabilidade.labelRentabilidadeProduto', [item.CODPROD, item.DESCRPROD]);
                    self.mostraBtnRentabilidadeNota = true;
                    AngularUtil.apply($scope);
                }
            }
        //*********************************************************************//

        //Carrega grafico com os dados da nota
            function carregaChartNota() {
                self.datasetComCusto.gotoRow(-1);
                self.datasetSemCusto.gotoRow(-1);

                if(self.datagridComCusto){
                    self.datagridComCusto.unselectAllSelectedRows();
                }

                if(self.datagridSemCusto){
                    self.datagridSemCusto.unselectAllSelectedRows();
                }

                self.fat = Number(self.dadosNota.somaFaturamento);
                self.cmv = Number(self.dadosNota.somaCustoMercadoriaVendida);
                self.gv = Number(self.dadosNota.somaGastoVariavel);
                self.gf = Number(self.dadosNota.somaGastoFixo);
                self.lucro = Number(self.dadosNota.somaLucro);
                self.mc = Number(self.dadosNota.margemContrib);

                self.chartTitle = SkI18nService.instant('Commons.Rentabilidade.labelRentabilidadeNota');
                self.mostraBtnRentabilidadeNota = false;

                //self.datasetComCusto.refreshCurrentRow();
            }
        //*********************************************************************//

            function setLabelColor(color, color2) {
                document.getElementById("infoPreferencia").style.backgroundColor = color2;
                document.getElementById("infoPreferencia").style.color = color;
            }
        
            function formatData(data) {

                var ret = [];
                var count = 0;

                if(data) {
                    if(angular.isArray(data)) {
                        data.forEach(element => {
                            montarItem(element,ret,count)
                            count++;
                        });
                    } else {
                        montarItem(data,ret,count)
                    }
                } else {
                    ret = undefined;
                }

                return ret;
            }

            function montarItem(data,ret,count) {
                ret[count] = {};
                for(var key in data){
                    if(key=="LEGENDA"){
                        ret[count][key] = data[key][1].$
                    }else{
                        ret[count][key] = ObjectUtils.getProperty(data,key+'.$');
                    }
                }
            }

            function getCellColors(row, col, rowIndex, colIndex) {
                var corFundo = self.datasetComCusto.getFieldIndexByName('CORFUNDO');

                if (col.field === "LEGENDA") {
                    return {
                        bgColor: decimalColorToHTMLcolor(row.entity[corFundo])
                    };
                }
                return;
            }

            function interceptCellRenderer(cell, value, eGridCell, data) {
            	var element = document.createElement("span");
            	if (cell.colId === "LEGENDA") {
            		var corFonte = self.datasetComCusto.getFieldIndexByName('CORFONTE');
            		element.style.color = decimalColorToHTMLcolor(data.datasetItem[corFonte])
            	} else {
            		element.style.color = (data.gridItem['LUCRO'] && parseFloat(data.gridItem['LUCRO']) > 0.0) ? '#009900' : '#FF0000';
            	}
                if (value == undefined || value == null) {
                    value = '';
                }
                var text = document.createTextNode(value);
                element.appendChild(text);
    
                return {
                   element: element,
                   align: "flex-start"
                }
                
            }
        }


    ]);

/**
 * Created by gustavo.barbosa on 14/11/2019.
 */
angular
	.module('snk.commons')
	.service('RentabilidadePopUpService', ['SanPopup', 'SkI18nService',
		function (SanPopup, SkI18nService) {
			var self = this;
			self.openPopUp = openPopUp;

			function openPopUp(nuNota, codUsu) {
				return SanPopup.open({
					title: SkI18nService.instant('Commons.Rentabilidade.titleAnaliseRentabilidade'),
					templateUrl: 'commons/rentabilidadepopup/rentabilidadepopup.tpl.html',
					controller: 'RentabilidadePopUpController',
					controllerAs: 'ctrl',
					size:'lg',
					showBtnCancel: false,
					showBtnOk: false,
					showBtnNo: false,
					resolve: {
						nuNota: nuNota,
						codUsu: codUsu
					}
				}).result;
			}
		}
    ]);
angular
    .module('snk.commons')
    .controller('ResultadoGerLoteController', ['SkI18nService', 'btnFechar', '$popupInstance', 'dataValue', 'ObjectUtils',
        function (SkI18nService, btnFechar, $popupInstance, dataValue, ObjectUtils) {

            var self = this;

            // Inicializa dataset e dados da grid "Status dos Serviços Ativos"
            self.onDatasetStatusServicosCreated = onDatasetStatusServicosCreated;
            self.onDatagridStatusServicosLoaded = onDatagridStatusServicosLoaded;

            // Inicializa dataset e dadis da grid "Avisos"
            self.onDatasetAvisosCreated = onDatasetAvisosCreated;
            self.onDatagridAvisosLoaded = onDatagridAvisosLoaded;
            
            ObjectUtils.implements(self, IDatagridInterceptor);
            self.interceptColumnMetadata = interceptColumnMetadata;
            self.orderColumns = orderColumns
            const ORDEM_CAMPOS = 
            	['NRONOTA','DESCRICAO'];
            
            // Datasets standalone
            self.dsStatusServicos;
            self.dsAvisos;

            // Dataset pai
            self.dsLibLimites = dataValue.parentDataset;

            // Identificadores das grids
            self.datagridStatusServicos;
            self.datagridAvisos;

            // Mostra ou esconde a textarea de detalhes do aviso
            self.mostraDetalhes = false;

            // Mostra ou esconde painéis do accordion de acordo com o retorno do serviço
            self.mostraStatusServicos = false;
            self.mostraAvisos = false;
            self.mostraLiberacoes = false;

            // Função para abrir painel de detalhes na grid de Avisos e popular o textarea
            self.onClick = onClick;

            // Função para fechar o painel de detalhes em "Avisos"
            self.fecharDetalhes = fecharDetalhes;
            
            // Labels dos accordion groups
            self.labelStatusServicosAtivos = SkI18nService.instant('Commons.Liberacoes.labelStatusServicosAtivos');
            self.labelAvisos = SkI18nService.instant('Commons.Liberacoes.labelAvisos');
            self.labelLiberacoes = SkI18nService.instant('Commons.Liberacoes.labelLiberacoes');

            // Variáveis da tela pai
            var _resultadoGerLote = dataValue.resultadoGerLote;
            var _isLiberacaoLimites = dataValue.isLiberacaoLimites;

            // Label da coluna da grid "Avisos"
            self.description = _isLiberacaoLimites ? SkI18nService.instant('Commons.Liberacoes.headerDescricao') : SkI18nService.instant('Commons.Liberacoes.headerProblema');

            // Label da textarea "Detalhes do Problema"
            self.detalhesProblema = SkI18nService.instant('Commons.Liberacoes.labelDetalhesProblema');

            // Texto apresentado no textarea
            self.textoDetalhesProblema = '';

            init();

            function init() {
                btnFechar.on('click', closePopup);
                resultadoGerLoteChanged();
            }

            function onDatasetStatusServicosCreated(dataset) {
                self.dsStatusServicos = dataset;
                addTransientFieldsOnDatasetStatusServicos(_resultadoGerLote.servicos);
            }

            function onDatasetAvisosCreated(dataset) {
                self.dsAvisos = dataset;
                addTransientFieldsOnDatasetAvisos(_resultadoGerLote.avisos);
            }

            function onDatagridStatusServicosLoaded(datagrid) {
                self.datagridStatusServicos = datagrid;
            }

            function onDatagridAvisosLoaded(datagrid) {
                self.datagridAvisos = datagrid;
            }

            function onClick() {
                self.mostraDetalhes = true;
                let currentRow = self.dsAvisos.getCurrentRowAsObject();
                self.textoDetalhesProblema = currentRow ? currentRow.DESCRICAO : '';
            }

            function resultadoGerLoteChanged() {
                let servicos = _resultadoGerLote.servicos;
                let avisos = _resultadoGerLote.avisos;
                let liberacoes = _resultadoGerLote.liberacoes;

                if (angular.isDefined(servicos?.servico)) {
                    self.mostraStatusServicos = true;
                }

                if (angular.isDefined(avisos?.aviso)) {
                    self.mostraAvisos = true;
                }

                if (angular.isDefined(liberacoes?.liberacao)) {
                    self.mostraLiberacoes = true;
                    self.dataLiberacoes = _resultadoGerLote.liberacoes;
                }
            }

            function addTransientFieldsOnDatasetStatusServicos(servicos) {
                self.dsStatusServicos.addTransientField({ name: 'TITULO' });
                self.dsStatusServicos.addTransientField({ name: 'VALOR' });
                self.dsStatusServicos.init();
                adicionaValoresEmStatusServicos(servicos);                
            }

            function addTransientFieldsOnDatasetAvisos(avisos) {
                self.dsAvisos.addTransientField({ name: 'NRONOTA', isPk: true });
                self.dsAvisos.addTransientField({ name: 'DESCRICAO' });
                self.dsAvisos.init();
                self.dsAvisos.gotoRow(-1);
                adicionaValoresEmAvisos(avisos);
            }
            
            function interceptColumnMetadata(fieldMetadata, dataset) {
	            if (fieldMetadata.name == "NRONOTA") {
	                fieldMetadata.description = SkI18nService.instant('Commons.Liberacoes.headerNroNota');
	            } else if (fieldMetadata.name == "DESCRICAO") {
	                fieldMetadata.description = _isLiberacaoLimites ? SkI18nService.instant('Commons.Liberacoes.headerDescricao') : SkI18nService.instant('Commons.Liberacoes.headerProblema');
	            }
	        }
	        
	        function orderColumns(colA, colB) {
            	return ORDEM_CAMPOS.indexOf(colA.field) - ORDEM_CAMPOS.indexOf(colB.field);
            }

            function fecharDetalhes() {
                self.mostraDetalhes = false;
            }

            function closePopup() {
                $popupInstance.dismiss();
            }

            function adicionaValoresEmStatusServicos(servicos) {
                if(!angular.isDefined(servicos)){
                	return;
                }
                if (!angular.isArray(servicos)) {
                    self.dsStatusServicos.addRecordsAsObjects({ TITULO: servicos.servico.titulo, VALOR: servicos.servico.valor }, undefined, true);
                } else {
                    self.dsStatusServicos.addRecords(servicos);
                }
            }

            function adicionaValoresEmAvisos(avisos) {
                if(!angular.isDefined(avisos)){
                	return;
                }
                if (!angular.isArray(avisos)) {
                    self.dsAvisos.addRecordsAsObjects({ NRONOTA: avisos.aviso.nunota, DESCRICAO: avisos.aviso.$ }, undefined, true);
                } else {
                    self.dsAvisos.addRecords(avisos);
                }
            }
        }
    ]);
/**
 * Created by jean.costa on 17/01/2020.
 */
angular
	.module('snk.commons')
	.service('ResultadoGerLoteService', ['SanPopup', 'SkI18nService',
		function (SanPopup, SkI18nService) {
			var self = this;

			self.openPopUp = openPopUp;

			function openPopUp(isLiberacaoLimites, resultadoGerLote, parentDataset) {
				let btnFechar = angular.element('<button class="btn btn-default">' + SkI18nService.instant('Geral.buttonFechar') + '</button>');

				return SanPopup.open({
					title: isLiberacaoLimites ? SkI18nService.instant('Commons.Liberacoes.titleResultadoConfirmacao') : SkI18nService.instant('Commons.Central.titleResultadosGeracaoLote'),
					templateUrl: 'commons/resultadoGerLotePopUp/resultadoGerLotePopUp.tpl.html',
					controller: 'ResultadoGerLoteController',
					controllerAs: 'ctrl',
					size: 'lg',
					showBtnCancel: false,
					rightBottomBar: [btnFechar],
					showBtnOk: false,
					showBtnNo: false,
					resolve: {
						dataValue: {
							resultadoGerLote: resultadoGerLote,
							isLiberacaoLimites: isLiberacaoLimites,
							parentDataset: parentDataset
						},
						btnFechar: function () {
							return btnFechar;
						}
					}
				});
			}
		}
	]);
angular
    .module('snk.commons')
    .controller('ConfirmacaoPopupController', ['$scope', 'data', '$popupInstance', '$window', 'i18n', 'ServiceProxy', 'MessageUtils', 'SkApplicationInstance', function ($scope, data, $popupInstance, $window, i18n, ServiceProxy, MessageUtils, SkApplicationInstance) {

        var self = this;
        
        self.confirmacaoCompra  = data;
        self.lblTipoPacote = self.confirmacaoCompra.tipoPacote == 'EXTENSAO' ? 'Add-on' : 'Pacote';
        self.tipoPacote = self.confirmacaoCompra.tipoPacote;

        $scope.$success = closePopup;

        self.checkConfirmacao;
        self.checkTermoUso;

        function closePopup() {            
            if(self.checkConfirmacao && self.checkTermoUso) {
                $popupInstance.success({accepted: true});
            }
            return
        }

}]);
angular
    .module('snk.commons')
    .controller('DetalhesPacoteController', ['$scope','$window', 'i18n', 'ServiceProxy', '$wizard', '$step', 'MessageUtils', 'SkApplicationInstance', 'SanPopup', function ($scope, $window, i18n, ServiceProxy, $wizard, $step, MessageUtils, SkApplicationInstance, SanPopup) {

        var self = this;
        self.detalhes = {};
        self.instalado = false;
        self.instalando = false;
        self.instalado = false;
        self.erroInstalacao = false;
        
        var noimg = '/mge/assets/img/noimage.png';

        $step.onEnterStep = onEnterStep;
        self.confirmInstalacao = confirmInstalacao;
        self.instalar = instalar;
        self.voltar = voltar;
        self.infoCompra = {};


        function onEnterStep() {
            self.detalhes = $wizard.context.detalhes;
            self.instalado = $wizard.context.instalado;
            if(self.instalado){
                self.textoInstall="INSTALADO";
            }
            
            if(self.detalhes) {
            	self.id = self.detalhes.id;
            	if(self.detalhes.imagens[0]) {
            		self.imagens = self.detalhes.imagens[0].url;            		
            	}else {
            		self.imagens = noimg;
            	}
                self.nome = self.detalhes.nome;
                self.descricao = self.detalhes.descricao;
                self.numDownloads = self.detalhes.numDownloads;
                self.autor = self.detalhes.autor;
                self.banco = self.detalhes.banco;
                self.tipo = self.detalhes.tipo;
                self.dhPublicacao = self.detalhes.dhPublicacao;
                self.categoria = self.detalhes.categoria;
                self.nota = self.detalhes.nota;
                self.valor = self.detalhes.valor;
                self.isGratis = self.detalhes.isGratis;
                self.modeloSuporte = getModeloSuporte(self.detalhes.modeloSuporte);
                self.valorMensal = self.detalhes.valorMensal;
                self.valorTransacao = self.detalhes.valorTransacao;

                if(self.detalhes.company) {
                    self.companyAutor = self.detalhes.company.nome;
                    self.companyEmail = self.detalhes.company.email;
                    self.companyTelefone = self.detalhes.company.telefone; 
                    self.companyId = self.detalhes.company.companyId;
                }
            } else {
                self.detalhes = null;
            }
        }

        function voltar() {
            clearValues();
            clearCompanyValues();
            $wizard.previous();
        }

        function clearValues() {
            self.detalhes = null;
            self.id = null;
            self.imagens = null;
            self.nome = null;
            self.descricao = null;
            self.numDownloads = null;
            self.autor = null;
            self.banco = null;
            self.tipo = null;
            self.dhPublicacao = null;
            self.categoria = null;
            self.nota = null;
            self.instalado = false;
            self.instalando = false;
            self.instalado = false;
            self.erroInstalacao = false;
            self.isGratis = null;
            self.infoCompra = {};
            self.modeloSuporte = null;
            self.valorMensal = null;
            self.valorTransacao = null;
        }
        function clearCompanyValues() {
            self.companyAutor = null;
            self.companyEmail = null;
            self.companyTelefone = null;
            self.companyId = null;
        }

        function confirmInstalacao() {
            if (self.detalhes && self.detalhes.hasCuidadosInstalacao) {
                MessageUtils.simpleConfirm('Atenção', `Esta instalação irá inserir vários registros em seu banco
                 de dados que devem ser configurados adequadamente ou podem causar duplicidade em algumas informações.
                  Deseja continuar ?`).then(() => { self.isGratis == true ? openPopupAceiteTermosUso() : verificaAccountId() });
            } else {
                self.isGratis == true ? openPopupAceiteTermosUso() : verificaAccountId();
            }
        }

        function verificaAccountId() {
            ServiceProxy.callService('mge@AccountSP.accountTokenExists', {})
            .then((res) => {
                buscarInformacoesCompra();
            }).catch((err) => {});
        }

        function buscarInformacoesCompra() {
            ServiceProxy.callService('mge@SankhyaStoreSP.getPaymentOrderInformation', {})
            .then((res) => {
                if(res.responseBody){
                    self.infoCompra = {...res.responseBody, 'nomePacote':self.nome, 'valor':self.valor, 'valorMensal': self.valorMensal, 'valorTransacao': self.valorTransacao}
                    openPopupConfirmacaoCompra();
                }
            }).catch((err) => {});
        }

        function openPopupConfirmacaoCompra() {
            return SanPopup.open({
                title: "Sankhya",
                templateUrl: 'commons/solucoespopup/confirmacaoPopup/confirmacaoPopup.tpl.html',
                controller: 'ConfirmacaoPopupController',
                controllerAs: 'ctrl',
                size: 'md',
                showBtnCancel: false,
                noBtnLabel: "Cancelar",
                height: 350,
                okBtnLabel: "Sim, confirmar",
                showBtnOk: true,
                showBtnNo: true,
                resolve: {
                    data: self.infoCompra
                }
            }).result.then(function({accepted}){
                if(accepted){
                    instalar();
                }
            })
        }

        function openPopupAceiteTermosUso() {
            return SanPopup.open({
                title: "Sankhya",
                templateUrl: 'commons/solucoespopup/termoUsoPopup/termoUsoPopup.tpl.html',
                controller: 'TermoUsoPopupController',
                controllerAs: 'ctrl',
                size: 'md',
                showBtnCancel: false,
                noBtnLabel: "Cancelar",
                height: 130,
                okBtnLabel: "Sim, confirmar",
                showBtnOk: true,
                showBtnNo: true,
                resolve: {}
            }).result.then(function(data){
                instalar();
            })
        }

        function instalar() {
            self.textoInstall = i18n('Commons.SolucoesPopup.txtTextoInstalacao')
            self.instalando = true;

            ServiceProxy.callService('mge@SankhyaStoreSP.internoInstalarPacote', {
                    pkgKey: self.detalhes.chave, 
                    tipo: self.detalhes.tipo,
                    isPacoteInternalizacaoPago: self.isGratis,
                    sankhyaId: self.infoCompra.accountId
                })
                .then((res) => {
                    self.textoInstall = i18n('Commons.SolucoesPopup.txtTextoInstado')
                    self.instalando = false;
                    self.instalado = true;
                    $wizard.context.novoPacoteInstalado = self.detalhes.chave;
                    MessageUtils.showInfo(  i18n('Commons.SolucoesPopup.lblSucesso'), 
                                            i18n('Commons.SolucoesPopup.txtInstaladoComSucesso'));
                    let resourceID = res.responseBody.resourceID;
                    if (resourceID) SkApplicationInstance.openApp(resourceID);


                }).catch((err) => {
                    self.instalando = false;
                    self.textoInstall = i18n('Commons.SolucoesPopup.txtErroInstalacao')
                    self.erroInstalacao = true;
                });

        }

        function getModeloSuporte(codigo) {
            const MODELO = {
                "Suporte incluso": 1,
                "Suporte negociado": 2,
                "Sem suporte": 3,
            };
    
            for (const [key, val] of Object.entries(MODELO)) {
                if (val === codigo) {
                    return key;
                }
            }
            return null;
        }

    }]);
angular
    .module("snk.commons")
    .filter("ellipsis", function () {

        return function (input, size) {

            if (input.toString().length <= size) { return input; }
            return input.toString().substring(0, (size || 5)) + "...";
        }

    })
angular
    .module('snk.commons')
    .filter("drawstars", function () {

        return function (input) {

            if(!input){
                return;
            }

            if (input < 0 || input === null || input.toString() === "NaN") {
                input = 0;
            }


            let estrelas = "";
            let estrelasCheias;
            let estrelasVazias;
            let estrelasMetade;

            if (input % 1 === 0) {
                // Integer
                input -= input % 1;
                estrelasCheias = input;
                estrelasVazias = 5 - input;
            } else {
                // Float
                input -= input % 1;
                estrelasCheias = input;
                estrelasVazias = 5 - input - 1;
                estrelasMetade = 1;
            }

            for (let i = 0; i < estrelasCheias; i++) {
                estrelas += "<i class='fa fa-star text-primary'></i>";
            }

            for (let i = 0; i < estrelasMetade; i++) {
                estrelas += "<i class='fa fa-star-half-alt text-primary'></i>";
            }

            for (let i = 0; i < estrelasVazias; i++) {
                estrelas += "<i class='far fa-star text-primary'></i>";
            }

            return estrelas
        }

    });

angular
    .module('snk.commons')
    .controller('PacotesController', ['StringUtils','$scope', '$window', 'i18n', 'ServiceProxy', '$wizard', 'SkApplicationInstance', '$step', 
    function (StringUtils, $scope, $window, i18n, ServiceProxy, $wizard, SkApplicationInstance, $step) {

        const self = this;
        self.solucoes;
        self.solucoesExibidas;
        self.termoBuscado;
        self.solucaoSelecionada;

        $wizard.context.novoPacote
        const categorias = [
            { value: "GERAL", label: i18n('Geral.lblGeral'), icon: "folder-open" },
            { value: "COMERCIAL", label: i18n('Commons.SolucoesPopup.lblCategoriaComercial'), icon: "briefcase" },
            { value: "CONTABILIDADE", label: i18n('Commons.SolucoesPopup.lblCatContabilidade'), icon: "calculator" },
            { value: "FINANCEIRO", label: i18n('Commons.SolucoesPopup.lblCatFinan'), icon: "dollar" },
            { value: "RECURSOS_HUMANOS", label: i18n('Commons.SolucoesPopup.lblCatRH'), icon: "user" },
            { value: "LIVROFISCAL", label: i18n('Commons.SolucoesPopup.lblCatLivroFisc'), icon: "book" },
            { value: "WMS", id: "W", label: 'WMS', icon: "home" },
            { value: "PATRIMONIAL", label: i18n('Commons.SolucoesPopup.lblCatPatrimonial'), icon: "lock" },
            { value: "PRODUCAO", label: i18n('Commons.SolucoesPopup.lblCatProd'), icon: "cogwheels" },
            { value: "SERVICOS", label: i18n('Commons.SolucoesPopup.lblCatServ'), icon: "cogwheel" }
        ];

        const tipos = [
            { value: "PACOTES_RECOMENDADOS", label: i18n('Commons.SolucoesPopup.lblTipPacRecomendado'), icon: "lightbulb", color: "dark-green" },
            { value: "PACOTE_DO_MES", label: i18n('Commons.SolucoesPopup.lblTipPacMes'), icon: "three-dimensional", color: "dark-green" },
            { value: "MODULO_ADICIONAL", label: i18n('Commons.SolucoesPopup.lblTipModuloAdicional'), icon: "file", color: "middle-green" },
            { value: "CADASTRO_MODELO", label: i18n('Commons.SolucoesPopup.lblTipCadModelo'), icon: "list", color: "dark-red" },
            { value: "DASHBOARD", label: "Dashboard", icon: "stats", color: "light-blue" },
            { value: "DASHBOARD_TRIAL", label: "Dashboard Trial", icon: "stats-bars", color: "dark-blue" },
            { value: "EDIS", label: "EDIs", icon: "clipboard", color: "middle-blue" },
            { value: "NOTAS_ELETRONICAS", label: i18n('Commons.SolucoesPopup.lblTipNotaEle'), icon: "map-marker", color: "light-green" },
            { value: "RELATORIO_IREPORT", label: i18n('Commons.SolucoesPopup.lblTipRelaIReport'), icon: "clipboard", color: "dark-gray" },
            { value: "MGE_MITRA", label: "MGE/Mitra", icon: "laptop", color: "dark-orange" },
            { value: "SCRIPTS_BANCO", label: i18n('Commons.SolucoesPopup.lblTipScriptDB'), icon: "database", color: "dark-yellow" },
            { value: "TELAS_ADICIONAIS", label:i18n('Commons.SolucoesPopup.lblTipTelasAdicionais'), icon: "table", color: "light-orange" },
            { value: "TV", label: "Sankhya TV", icon: "computer-all-in-one", color: "dark-purple" }

        ];
  
  
        self.onDestSearchTermChange = onDestSearchTermChange;
        self.detalhesPacote = detalhesPacote;
        $step.onEnterStep = onEnterStep;

        function onDestSearchTermChange(solucao) {
            if (StringUtils.nullAsEmpty(self.termoBuscado).length < 3) {
                return true;
            }

            var text = StringUtils.replaceAccentuatedChars(self.termoBuscado.toLowerCase());
            var search = StringUtils.replaceAccentuatedChars(solucao.nome.toLowerCase());

            return search.indexOf(text) > -1;
        }


        onInit();
 

        function onInit() {
            let resourceID = SkApplicationInstance.getResourceID();
            
            const tipo = _buscarTipo(resourceID);

            ServiceProxy.callService("mge@SankhyaStoreSP.listarSolucoes", { tipo })
                .then(resp => {

                    self.pacotesJaInstalados = resp.responseBody.pacotesJaInstalados
                        .replace("[", "")
                        .replace("]", "")
                        .split(", ");


                        self.solucoes = normalizeSolutions(resp.responseBody.pacotes);
                        for (let solucao of self.solucoes) {
                            let tipoPertencente = tipos.find(tipo => tipo.value === solucao.tipo);
                            solucao.background = 'background-' + tipoPertencente.color;
                            solucao.iconTipo = tipoPertencente.icon;
                            solucao.instalado = self.pacotesJaInstalados.includes(solucao.chave) ? true : false;
                        }
    
                        self.solucoes.sort(ordenaPorPacotesInstalados);
                        self.solucoesExibidas = self.solucoes;
                    });
        }
    
        function normalizeSolutions(solutions){
            const DefaultCategory = { icon: "folder-open", label: i18n('Geral.lblGeral') };

            return solutions.map(solution =>{
                const category = categorias.find(categoria => categoria.value === normalizeValue(solution.categoria));

                const solutionCategory = category || DefaultCategory;
                solution.iconCategoria = solutionCategory.icon;
                solution.categoria = solutionCategory.label;


                return solution;
            });
        }
    
        function normalizeValue(value){
            const valueLower = StringUtils.nullAsEmpty(value).toUpperCase()
            return StringUtils.replaceAccentuatedChars(valueLower);
        }    

        function onEnterStep() {
         
            let pacoteNovoInstalado = $wizard.context.novoPacoteInstalado;
            if (pacoteNovoInstalado) {
                delete $wizard.context.novoPacoteInstalado;
                self.solucoesExibidas = self.solucoesExibidas.map(solucao => {
                    if (solucao.chave === pacoteNovoInstalado) {
                        solucao.instalado = true;
                        return solucao;
                    }
                    return solucao;
                });
            }
        }

        function ordenaPorPacotesInstalados(a , b) {
            return a.instalado - b.instalado;
        }

        function detalhesPacote(pacote) {

            ServiceProxy.callService("mge@SankhyaStoreSP.detalhesPacote", { id: pacote.id })
                .then((detalhes) => {
                    $wizard.context.detalhes = detalhes.responseBody.result;
                    $wizard.context.instalado = pacote.instalado;
                    $wizard.next();
                });

        }
        
        function _buscarTipo(resourceID) {
            var tipo;
            
            if(resourceID.includes('.RelFormatados')){
            	tipo = 'RELATORIO_IREPORT'
            }else if(resourceID.includes('.core.cfg.DashboardBuilder')){
            	tipo = 'DASHBOARD'
            }else if(resourceID.includes('.arquivo.remessa') || resourceID.includes('.arquivo.de.remessa')){
                tipo = 'EDIS'
            }else if(resourceID.includes('.core.cfg.TelasPersonalizadas')) {
            	tipo = 'TELAS_ADICIONAIS';
            }
            return tipo || "DASHBOARD"; 
        }
   
     

    }]);
/*
 *  Createad by Eduardo Pilla on 01/06/2022.
 */
angular
    .module('snk.commons.solucoespopup.packageItem')
    .directive('skPackageItem',
        function () {
            return {
                templateUrl: 'commons/solucoespopup/packageItem/packageitem.tpl.html',
                scope: {
                    solucao: '=skValue',
                }
            }
        })


angular
    .module('snk.commons')
    .controller('SolucoesController', ['$scope', '$rootScope','btnNovo', '$popupInstance', function ($scope, $rootScope, btnNovo, $popupInstance) {
        var self = this;

        btnNovo.on('click', () => {
        	$rootScope.$broadcast('openWizzard', 'message');
            $popupInstance.dismiss();
        });
    }]);
/**
 * Created by luiz.figueiredo on 27/01/2017.
 */
angular
    .module('snk.commons')
    .service('SolucoesStoreService', ['SanPopup', 'i18n', function (SanPopup, i18n) {
        var self = this;

        self.openPopUp = openPopUp;
        function openPopUp(origem) {
            //Porque esta sendo tratado no mvp so a tela de relatorio
            //enquantos as outras nao foram convertidas
            let titleBtn = '';
            if (origem === 'RELATORIO_IREPORT') {
                titleBtn = i18n('Commons.SolucoesPopup.btnCadastroRelatorio');
            } else if (origem === 'DASHBOARD') {
                titleBtn = i18n('Commons.SolucoesPopup.btnCadastroDashboard');
            } else if (origem === 'EDIS'){
                titleBtn = i18n('Commons.SolucoesPopup.btnCadastroEDI');
            } else if (origem === 'TELAS_ADICIONAIS'){
                titleBtn = i18n('Commons.SolucoesPopup.btnCadastroTelaAdicional');
            }

            let btnNovo = angular.element("<button class='btn btn-md btn-brand btn-copy-novo-registro'><span>" + titleBtn + "</span></button>");
            return SanPopup.open({
                title: i18n('Buscar soluções no Sankhya Place'),
                templateUrl: 'commons/solucoespopup/solucoes.tpl.html',
                controller: 'SolucoesController',
                controllerAs: 'ctrl',
                showBtnNo: false,
                showBtnCancel: false,
                showBtnOk: false,
                rightBottomBar: [btnNovo],
                size: 'lg',
                windowClass: 'no-padding-modal-body',
                grayBG: false,
                resolve: {
                    btnNovo: function () {
                        return btnNovo;
                    }

                }
            }).result;
        }
    }]);
angular
    .module('snk.commons')
    .controller('TermoUsoPopupController', ['$scope', '$popupInstance', '$window', 'i18n', 'ServiceProxy', 'MessageUtils', 'SkApplicationInstance', function ($scope, $popupInstance, $window, i18n, ServiceProxy, MessageUtils, SkApplicationInstance) {

        var self = this;
        $scope.$success = closePopup;
        self.isChecked = isChecked;
        
        self.btnCheck;

        function isChecked() {
            self.btnCheck = !self.btnCheck;
        }

        function closePopup() {            
            if(self.btnCheck) {
                $popupInstance.success({accepted: true});
            }
            return
        }

}]);
angular
	.module('snk.commons')
	.controller('StatusProcessoController', ['$scope', 'AngularUtil', 'statusProcessoPopUpInfo', 'ServiceProxy', 'ObjectUtils', '$popupInstance', 'MessageUtils', 'StringUtils', 'UrlUtils', 'i18n', 'StatusProcessoConstant', 'DateUtils',
        function ($scope, AngularUtil, statusProcessoPopUpInfo, ServiceProxy, ObjectUtils, $popupInstance, MessageUtils, StringUtils, UrlUtils, i18n, StatusProcessoConstant, DateUtils) {

		var self = this;

		self.optionsUF = [
			{data: 'TODAS', value: i18n('Commons.StatusProcesso.itemTODAS')},
			{data: 'AC', value: i18n('Commons.StatusProcesso.itemAC')},
			{data: 'AL', value: i18n('Commons.StatusProcesso.itemAL')},
			{data: 'AM', value: i18n('Commons.StatusProcesso.itemAM')},
			{data: 'AP', value: i18n('Commons.StatusProcesso.itemAP')},
			{data: 'BA', value: i18n('Commons.StatusProcesso.itemBA')},
			{data: 'CE', value: i18n('Commons.StatusProcesso.itemCE')},
			{data: 'DF', value: i18n('Commons.StatusProcesso.itemDF')},
			{data: 'ES', value: i18n('Commons.StatusProcesso.itemES')},
			{data: 'GO', value: i18n('Commons.StatusProcesso.itemGO')},
			{data: 'MA', value: i18n('Commons.StatusProcesso.itemMA')},
			{data: 'MG', value: i18n('Commons.StatusProcesso.itemMG')},
			{data: 'MS', value: i18n('Commons.StatusProcesso.itemMS')},
			{data: 'MT', value: i18n('Commons.StatusProcesso.itemMT')},
			{data: 'PA', value: i18n('Commons.StatusProcesso.itemPA')},
			{data: 'PB', value: i18n('Commons.StatusProcesso.itemPB')},
			{data: 'PE', value: i18n('Commons.StatusProcesso.itemPE')},
			{data: 'PI', value: i18n('Commons.StatusProcesso.itemPI')},
			{data: 'PR', value: i18n('Commons.StatusProcesso.itemPR')},
			{data: 'RJ', value: i18n('Commons.StatusProcesso.itemRJ')},
			{data: 'RN', value: i18n('Commons.StatusProcesso.itemRN')},
			{data: 'RO', value: i18n('Commons.StatusProcesso.itemRO')},
			{data: 'RR', value: i18n('Commons.StatusProcesso.itemRR')},
			{data: 'RS', value: i18n('Commons.StatusProcesso.itemRS')},
			{data: 'SC', value: i18n('Commons.StatusProcesso.itemSC')},
			{data: 'SE', value: i18n('Commons.StatusProcesso.itemSE')},
			{data: 'SP', value: i18n('Commons.StatusProcesso.itemSP')},
			{data: 'TO', value: i18n('Commons.StatusProcesso.itemTO')}
		];

		//Funcões disponíveis no controlador
		self.onDatasetCreated = onDatasetCreated;
		self.baixarArquivo = baixarArquivo;
		self.pararGeracao = pararGeracao;
		self.verHistorico = verHistorico;
		self.verAndamento = verAndamento;
		self.fechar = fechar;
		self.excluirProcessos = excluirProcessos;
		self.getHistoryOfProcess = getHistoryOfProcess;
		self.validarAcoes = validarAcoes;
		self.criaCampos = criaCampos;
		self.openParamsEntrada = true;
		self.mostrarCamposContabECD = false;

		//Inicializando variáveis
		self.uf = 'TODAS';
		self.btnVisualizarAtivo = true;
		self.btnPararAtivo = true;
		self.lblParametrosEntrada = i18n("Commons.StatusProcesso.lblParametrosEntrada");
		self.lblAndamento = i18n("Commons.StatusProcesso.lblAndamento");
		self.progressBarClass = 'progress-bar progress-bar-striped active';
		self.execucao = i18n("Commons.StatusProcesso.lblEmExecucao");

		var _path = "/";
		var _nomeArquivo;

		//Constantes
		var EM_EXECUCAO = "X";
		var ORIGEM_TELA_HISTORICO = "historico";
		var ORIGEM_TELA_DETALHES = "detalhes";

		self.statusProcessPerType = undefined;

		init();

		function init() {
			self.statusProcessPerType = resolveStatusProcess();
			_path = self.statusProcessPerType.pathRoot;

			if (statusProcessoPopUpInfo.origem == ORIGEM_TELA_DETALHES) {
				self.empresa = statusProcessoPopUpInfo.codEmpresa;

				if (!statusProcessoPopUpInfo.ocultarPeriodo){
					self.periodo = {
						dtIni: statusProcessoPopUpInfo.dtInicial,
						dtFin: statusProcessoPopUpInfo.dtFinal
					}
				}
				
				getStatusProcess();
			} else {
				getHistoryOfProcess();
			}
			if(statusProcessoPopUpInfo.usuarioLogado && statusProcessoPopUpInfo.usuarioLogado.length > 0) {
				self.usuarioLogado = statusProcessoPopUpInfo.usuarioLogado;
			}
			self.mostrarHistorico = statusProcessoPopUpInfo.origem == ORIGEM_TELA_HISTORICO;
			self.mostrarDownloadArquivo = angular.isDefined(statusProcessoPopUpInfo.mostrarDownloadArquivo) ? statusProcessoPopUpInfo.mostrarDownloadArquivo : false;			
			self.ocultarUF = angular.isDefined(statusProcessoPopUpInfo.ocultarUF) ? statusProcessoPopUpInfo.ocultarUF : false;
			if (angular.isDefined(statusProcessoPopUpInfo.uf)) {
				self.uf = statusProcessoPopUpInfo.uf;
			}
			self.ocultarPeriodo = angular.isDefined(statusProcessoPopUpInfo.ocultarPeriodo) ? statusProcessoPopUpInfo.ocultarPeriodo : false;
			self.ocultarParamsEntrada = angular.isDefined(statusProcessoPopUpInfo.ocultarParamsEntrada) ? statusProcessoPopUpInfo.ocultarParamsEntrada : false;
			self.mostrarCamposContabECD = statusProcessoPopUpInfo.type == StatusProcessoConstant.CONTABILIDADE.IMPORTACAO_LOTE_ECD;
			self.ocultarUsuario = angular.isDefined(statusProcessoPopUpInfo.ocultarUsuario) ? statusProcessoPopUpInfo.ocultarUsuario : true;
			self.ocultarEmpresa = angular.isDefined(statusProcessoPopUpInfo.ocultarEmpresa) ? statusProcessoPopUpInfo.ocultarEmpresa : false;
			self.ocultarCodDescEmp = angular.isDefined(statusProcessoPopUpInfo.ocultarCodDescEmp) ? statusProcessoPopUpInfo.ocultarCodDescEmp : true;
			_path += statusProcessoPopUpInfo.path;

			validarAcoes();
			
			if(angular.isDefined(statusProcessoPopUpInfo.parametros)) {
				self.parametros = statusProcessoPopUpInfo.parametros;
			}
			
			criaCampos();
		}
		
		function criaCampos() {
			if (angular.isDefined(self.parametros)) {
				let elemento;
				self.ocultarEmpresa = self.parametros.length > 0;
				self.parametros.forEach(function(item) {				
					switch(item.tipo) {
						case 'Pesquisa':
							elemento = AngularUtil.createDirective('sk-pesquisa-input', {
								'sk-entity-name': item.entidade,
								'sk-value': 'ctrl.valorPesquisa' + item.id,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorPesquisa' + item.id] = item.valor;
							break;
						case 'String':					
							elemento = AngularUtil.createDirective('sk-text-input', {
								'sk-value': 'ctrl.valorString' + item.id,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorString' + item.id] = item.valor;
							break;
						case 'Date':
							elemento = AngularUtil.createDirective('sk-date-input', {
								'sk-value': 'ctrl.valorDate' + item.id,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorDate' + item.id] = DateUtils.formatDate(item.valor);
							break;
						case 'Float':
							elemento = AngularUtil.createDirective('sk-number-input', {
								'sk-value': 'ctrl.valorFloat' + item.id,
								'sk-precision': item.casasDecimais,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorFloat' + item.id] = item.valor;
							break;
						case 'Integer':
							elemento = AngularUtil.createDirective('sk-number-input', {
								'sk-value': 'ctrl.valorInteger' + item.id,
								'sk-precision': 0,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorInteger' + item.id] = item.valor;
							break;
						case 'DateTime':
							elemento = AngularUtil.createDirective('sk-date-time-input', {
								'sk-value': 'ctrl.valorDateTime' + item.id,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorDateTime' + item.id] = new Date();
							break;
						case 'DatePeriod':
							elemento = AngularUtil.createDirective('sk-date-period-input', {
								'sk-value': 'ctrl.valorDatePeriod' + item.id,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorDatePeriod' + item.id] = {
								dtIni: item.valor.dtIni,
								dtFin: item.valor.dtFin
							}
							break;
						case 'Boolean':
							elemento = AngularUtil.createDirective('sk-switch', {
								'sk-value': 'ctrl.valorBoolean' + item.id,
								'sk-enabled': false,
								'sk-width': '50%',
								'sk-padding-left': '15px'
							}, $scope);
							self['valorBoolean' + item.id] = item.valor == true || item.valor == 'S' ? 'S' : 'N';
							break;
					}
					angular.element(document.getElementById('rastreamentoEstoque')).append("<label style='padding-left: 15px; padding-top: 5px; font-size: 12px; color: #5A5A5A'>" + item.label + "</label>");
					angular.element(document.getElementById('rastreamentoEstoque')).append(elemento);
				});
			}
		}

		function resolveStatusProcess(){
			if (statusProcessoPopUpInfo.module == StatusProcessoConstant.CONTABILIDADE.$){
				self.isContabilidade = true;
				return StatusProcessoConstant.CONTABILIDADE;
			} else if (statusProcessoPopUpInfo.module == StatusProcessoConstant.CALCULO_MEDIA_BC_ICMS_ST.$){
				self.isContabilidade = false;
				return StatusProcessoConstant.CALCULO_MEDIA_BC_ICMS_ST;
			}
			self.isContabilidade = false;
			return StatusProcessoConstant.LIVRO_FISCAL;		
		}

		function resolveServices() {
			let services;

			if (statusProcessoPopUpInfo.services){
				services = statusProcessoPopUpInfo.services;
			} else {
				services = self.statusProcessPerType.serviceProcess;
			}

			return services;
		}

		function getHistoryOfProcess(processo) {
			if (!processo) {
				var serviceHistory =  resolveServices().getHistory;

				if (serviceHistory) {
					var params = {
						criterio: {
							TIPO: statusProcessoPopUpInfo.type,
						    codEmpresa: statusProcessoPopUpInfo.codEmpresa
						}
					};
	
					if (self.isContabilidade) { 
						params.criterio.IDPROC = statusProcessoPopUpInfo.idProc;
					}
	
					ServiceProxy.callService(serviceHistory, params)
					.then(function (response) {
						let process;
						if (self.isContabilidade) {
							if (statusProcessoPopUpInfo.isGenerationScreen){
								process = response.responseBody.processos.processo;
							} else {
								process = response.responseBody.statusProcess.processos.processo;
							}
						} else {
							process = response.responseBody.processos.processo;
						}

						addRecordsProcessosInDataset(process);
					});
				}
			} else {
				addRecordsProcessosInDataset(processo);
			}
		}

		async function addRecordsProcessosInDataset(processo){
			if (self.dsProcessos != null) {
				self.dsProcessos.whenMetadataLoaded().then(function () {
					self.dsProcessos.clearDataSet();
					var proc = processo;

					if (proc != null) {
						if (!angular.isArray(proc)) {
							proc = [proc];
						}

						let processos =[];

						proc.forEach((registro) => {
							processos.push(
								{
									status: registro.status.$,
									codDescEmp: registro.codDescEmp && registro.codDescEmp.$ ? registro.codDescEmp.$ : '',
									uf: registro.uf && registro.uf.$ ? registro.uf.$ : '',
									dataInicio: registro.dataInicio && registro.dataInicio.$ ? registro.dataInicio.$ : '',
									dataFim: registro.dataFim && registro.dataFim.$ ? registro.dataFim.$ : '',
									dhExecIni: registro.dhExecIni && registro.dhExecIni.$ ? registro.dhExecIni.$ : '',
									dhExecFim: registro.dhExecFim && registro.dhExecFim.$ ? registro.dhExecFim.$ : '',
									tempoExec: registro.tempoExec && registro.tempoExec.$ ? registro.tempoExec.$ : '',
									usuario: registro.usuario && registro.usuario.$ ? registro.usuario.$ : '',
									empresa: registro.empresa && registro.empresa.$ ? registro.empresa.$ : '',
									nomeArquivo: registro.nomeArquivo && registro.nomeArquivo.$ ? registro.nomeArquivo.$ : '',
									statusLabel: registro.statusLabel && registro.statusLabel.$ ? registro.statusLabel.$ : '',
									resultado: registro.resultado && registro.resultado.$ ? registro.resultado.$ : '',
									dataProcessamento: registro.dataProcessamento && registro.dataProcessamento.$ ? registro.dataProcessamento.$ : '',
									dataImportacao: registro.dataImportacao && registro.dataImportacao.$ ? registro.dataImportacao.$ : '',
									versaoLayout: registro.versaoLayout && registro.versaoLayout.$ ? registro.versaoLayout.$ : '',
									inicioPeriodo: registro.inicioPeriodo && registro.inicioPeriodo.$ ? registro.inicioPeriodo.$ : '',
									fimPeriodo: registro.fimPeriodo && registro.fimPeriodo.$ ? registro.fimPeriodo.$ : '',
									codigo: registro.codigo && registro.codigo.$ ? registro.codigo.$ : ''
								});
							})
							
							self.dsProcessos.addRecordsAsObjects(processos);

							self.dsProcessos.gotoRow(0);
						};
					});

				self.dsProcessos.addLineChangeListener(function() {
					validarAcoes();
				});

				self.dsProcessos.gotoRow(0);
			}
		}

		function getStatusProcess() {
			var serviceGetStatus = resolveServices().getStatus;

			ServiceProxy.callService(serviceGetStatus, {
				criterio: {
					TIPO: statusProcessoPopUpInfo.type, 
					IDPROC: statusProcessoPopUpInfo.idProc
				}
			}).then(function (response) {
				
				var atualizaStatus = ((self.dsProcessos && self.dsProcessos.getFieldValue('codigo')==response.responseBody.statusProcess.codigo.$)|| response == undefined);
				
				if ((!StringUtils.isEmpty(response.responseBody.statusProcess.resultado) && atualizaStatus) || (self.dsProcessos && self.dsProcessos.getFieldValue('codigo') == undefined)){
						
					self.andamento = response.responseBody.statusProcess.resultado.$;
				}

				if (!StringUtils.isEmpty(response.responseBody.statusProcess.nomeArquivo)) {
					_nomeArquivo = response.responseBody.statusProcess.nomeArquivo.$;
				}

				if (!StringUtils.isEmpty(response.responseBody.statusProcess.statusLabel)) {
					enableBtnVisualizar(response.responseBody.statusProcess.statusLabel);
					enableBtnParar(response.responseBody.statusProcess.statusLabel);
				}

				if (!StringUtils.isEmpty(response.responseBody.statusProcess.statusLabel) && response.responseBody.statusProcess.statusLabel.$ != EM_EXECUCAO) {					
					self.progressBarClass = 'progress-bar progress-bar-striped';
					self.execucao = i18n("Commons.StatusProcesso.lblFinalizado");
					if (self.isContabilidade && angular.isUndefined(statusProcessoPopUpInfo.isGenerationScreen)){
						getHistoryOfProcess(response.responseBody.statusProcess.processos.processo);
					} else {
						getHistoryOfProcess();
					}
				} else {
					setTimeout(getStatusProcess, 5000);
				}
			});
		}

		function baixarArquivo() {
			if (!angular.isUndefined(self.dsProcessos)) {
				if (self.isContabilidade) {

					var _idProc = self.dsProcessos.getFieldValueAsString('codigo');
					var _codEmpresa = self.dsProcessos.getFieldValueAsString('empresa');
					var _dataProcessamento = self.dsProcessos.getFieldValueAsString('dataProcessamento');

					let extensionFile = resolveExtensionFile(statusProcessoPopUpInfo.type);
					_nomeArquivo = statusProcessoPopUpInfo.type + "_" + _codEmpresa + "_" + _dataProcessamento + "_" + _idProc + extensionFile;
				} else {
					_nomeArquivo = self.dsProcessos.getFieldValue('nomeArquivo');
				}
			}

			ServiceProxy.callService(
				"mge@RepositorioArquivoSP.abreArquivo", {
				config: {
					path: getFilePath()
				}
			}).then(function (response) {
				var chave = ObjectUtils.getProperty(response, 'responseBody.chave.valor');
				var url = UrlUtils.getUrlBase() + "/mge/visualizadorArquivos.mge?chaveArquivo=" + chave;
				window.open(url, '_blank');
			});			
		}

		function resolveExtensionFile(type) {
			let extension;

			switch(type){
				case StatusProcessoConstant.CONTABILIDADE.ECF.$:
					extension = StatusProcessoConstant.CONTABILIDADE.ECF.extensionFile;
					break;

				case StatusProcessoConstant.CONTABILIDADE.ECD.$:
					extension = StatusProcessoConstant.CONTABILIDADE.ECD.extensionFile;
					break;

				case StatusProcessoConstant.LIVRO_FISCAL.EFDFISCAL_HTML.$:
                    extension = StatusProcessoConstant.LIVRO_FISCAL.EFDFISCAL_HTML.extensionFile;
                    break;
                    
                case StatusProcessoConstant.LIVRO_FISCAL.DRCST.$:
                    extension = StatusProcessoConstant.LIVRO_FISCAL.DRCST.extensionFile;
                    break;

                case StatusProcessoConstant.LIVRO_FISCAL.EFDPISCOF_HTML.$:
                	extension = StatusProcessoConstant.LIVRO_FISCAL.EFDPISCOF_HTML.extensionFile;
                	break;

                case StatusProcessoConstant.LIVRO_FISCAL.CAT42.$:
                	extension = StatusProcessoConstant.LIVRO_FISCAL.CAT42.extensionFile;
                	break;

                case StatusProcessoConstant.LIVRO_FISCAL.DESBH.$:
                    extension = StatusProcessoConstant.LIVRO_FISCAL.DESBH.extensionFile;
                    break;

                case StatusProcessoConstant.LIVRO_FISCAL.NFSTMODELO21E22.$:
                     extension = StatusProcessoConstant.LIVRO_FISCAL.NFSTMODELO21E22.extensionFile;
                     break;

                case StatusProcessoConstant.LIVRO_FISCAL.SSINTEGRA.$:
                     extension = StatusProcessoConstant.LIVRO_FISCAL.SSINTEGRA.extensionFile;
                     break;

                case StatusProcessoConstant.LIVRO_FISCAL.SINTEGRA.$:
                     extension = StatusProcessoConstant.LIVRO_FISCAL.SINTEGRA.extensionFile;
                     break;

				case StatusProcessoConstant.LIVRO_FISCAL.GIAST.$:
					 extension = StatusProcessoConstant.LIVRO_FISCAL.GIAST.extensionFile;
                     break;

                case StatusProcessoConstant.LIVRO_FISCAL.DCTF.$:
                     extension = StatusProcessoConstant.LIVRO_FISCAL.DCTF.extensionFile;
                     break;

                case StatusProcessoConstant.LIVRO_FISCAL.ADRCST.$:
                     extension = StatusProcessoConstant.LIVRO_FISCAL.ADRCST.extensionFile;
                     break;

				default:
					extension = '.error';
			}

			return extension;
		}

		function getFilePath() {
			var filePath = _path;

			if (!StringUtils.isEmpty(_nomeArquivo)) {
				filePath += _nomeArquivo;
			}

			return filePath;
		}

		function pararGeracao() {
			if (statusProcessoPopUpInfo.idProc != null) {
				var serviceFinalizarProcesso = resolveServices().finalizar;
				ServiceProxy.callService(serviceFinalizarProcesso, {
					criterio: {
						IDPROC: statusProcessoPopUpInfo.idProc
					}
				}).then(function (response) {
					MessageUtils.showAlert(i18n("Commons.StatusProcesso.lblOperCancelada", [statusProcessoPopUpInfo.idProc]));
					$popupInstance.dismiss();	
				});
			}
		}

		function enableBtnVisualizar(status) {
			if (status != null && status != "") {
				if (self.isContabilidade && !statusProcessoPopUpInfo.isGenerationScreen){
					enableBtnPreviewAccounting(status);
				} else {
					enableBtnPreviewWhenIsGeneration(status);
				}
			} else if(!angular.isUndefined(self.dsProcessos) && !angular.isUndefined(self.dsProcessos.getSelectedRecords(true))) {
				var status = self.dsProcessos.getFieldValue('statusLabel');

				if (self.isContabilidade && !statusProcessoPopUpInfo.isGenerationScreen){
					enableBtnPreviewAccounting(status);
				} else {
					enableBtnPreviewWhenIsGeneration(status);
				}
			} else {
				self.btnVisualizarAtivo = false;
				applyChange();
			}
		}

		function enableBtnPreviewWhenIsGeneration(status) {
			if(["F"].indexOf(resolveValue(status)) >= 0 && temArquivoParaDownload()) {
				self.btnVisualizarAtivo = true;
			} else {
				self.btnVisualizarAtivo = false;
			}
		}

		function resolveValue(object){
			return object.$ ? object.$ : object;
		}

		function enableBtnPreviewAccounting(status) {
			if (statusProcessoPopUpInfo.type == StatusProcessoConstant.CONTABILIDADE.IMPORTACAO_LOTE){
				if(status.$ == "F" || status == "F") {
					self.btnVisualizarAtivo = true;
				} else {
					self.btnVisualizarAtivo = false;
				}
			} else {
				if(status.$ == "E" || status == "E") {
					self.btnVisualizarAtivo = true;
				} else {
					self.btnVisualizarAtivo = false;
				}
			}
			applyChange();
		}

		function enableBtnParar(status) {
			if (status != null && status != "") {
				if(status.$ == EM_EXECUCAO) {
					self.btnPararAtivo = true;
				} else {
					self.btnPararAtivo = false;
				}
			} else if(!angular.isUndefined(self.dsProcessos) && !angular.isUndefined(self.dsProcessos.getSelectedRecords())) {
				var status = self.dsProcessos.getFieldValue('statusLabel');

				if (status == EM_EXECUCAO) {
					self.btnPararAtivo = true;
				} else {
					self.btnPararAtivo = false;
				}
			} else {
				self.btnPararAtivo = false;
			}
			applyChange();
		}

		function validarAcoes() {
			enableBtnParar(null);
			enableBtnVisualizar(null);
		}

		function verHistorico() {
			self.mostrarHistorico = !self.mostrarHistorico;
		}

		function verAndamento() {
			self.mostrarHistorico = !self.mostrarHistorico;

			if (self.dsProcessos) {
				if("0" !== self.dsProcessos.getFieldValue('empresa')) {
					self.empresa = self.dsProcessos.getFieldValue('empresa');
				}
				self.uf = self.dsProcessos.getFieldValue('uf');

				self.periodo = {
					dtIni: self.dsProcessos.getFieldValue('dataInicio'),
					dtFin: self.dsProcessos.getFieldValue('dataFim')
				}

				self.andamento = self.dsProcessos.getFieldValue('resultado');

				if (self.dsProcessos.getFieldValue('status') == 'Finalizado') {
					self.progressBarClass = 'progress-bar progress-bar-striped';
					self.execucao = i18n("Commons.StatusProcesso.lblFinalizado");
				}
				else if (self.dsProcessos.getFieldValue('status') == 'Cancelado') {
					self.progressBarClass = 'progress-bar progress-bar-striped';
					self.execucao = i18n("Commons.StatusProcesso.lblCancelado");
				}
				else if (self.dsProcessos.getFieldValue('status') == 'Em Execução') {
					self.progressBarClass = 'progress-bar progress-bar-striped active';
					self.execucao = i18n("Commons.StatusProcesso.lblEmExecucao");
				}
				else if (self.dsProcessos.getFieldValue('status') == 'Erro') {
					self.progressBarClass = 'progress-bar progress-bar-striped';
					self.execucao = i18n("Commons.StatusProcesso.lblErro");
				}
				else if (self.dsProcessos.getFieldValue('status') == undefined) {
					self.progressBarClass = 'progress-bar progress-bar-striped';
					self.execucao = "";
				}
				else{
					self.progressBarClass = 'progress-bar progress-bar-striped';
					self.execucao = "";
				}

			}
		}

		function fechar() {
			$popupInstance.dismiss();
		}

		function onDatasetCreated(dataset) {
			dataset.init();
			self.dsProcessos = dataset;
		}

		function temArquivoParaDownload() {
			return self.isContabilidade ? true : (StringUtils.isNotEmpty(self.dsProcessos.getFieldValue("nomeArquivo")) && self.dsProcessos.getFieldValue("nomeArquivo") !== 'null');
		}

		function excluirProcessos() {
			var serviceExcluirProcesso = resolveServices().excluir;
            MessageUtils.simpleConfirm(MessageUtils.TITLE_CONFIRMATION, "Ao excluir o histórico de geração, o arquivo será removido do repositório de arquivos. Essa ação não é reversível. Deseja prosseguir com essa exclusão?").then(
                function(choice) {
                ServiceProxy.callService(serviceExcluirProcesso, {
                     criterio: {
                          TIPO: statusProcessoPopUpInfo.type,
                          extensionFile: resolveExtensionFile(statusProcessoPopUpInfo.type),
                          path: _path,
                          codEmpresa: statusProcessoPopUpInfo.codEmpresa
                     }
                }).then(function (response) {
                    var quantidade = response.responseBody.processos.quantidade.$;
                    if (quantidade > 0) {
                        MessageUtils.showInfo(i18n("Commons.StatusProcesso.lblProcessosExcluidos", [quantidade]));
                        getHistoryOfProcess();
                    } else {
                        MessageUtils.showAlert(angular.isDefined(statusProcessoPopUpInfo.msgExclusaoHistoricoFailed) ? statusProcessoPopUpInfo.msgExclusaoHistoricoFailed
                            : self.isContabilidade ? i18n("Commons.StatusProcesso.lblSempProcessosParaExcluirContab")
                            : i18n("Commons.StatusProcesso.lblSempProcessosParaExcluir"));
                    }
                });
            });

		}

		function applyChange() {
			AngularUtil.apply($scope);
		}
	}]);
angular
	.module('snk.commons')
	.constant('StatusProcessoConstant', {
		CONTABILIDADE: {
			$: "CONTABILIDADE",
			IMPORTACAO_LOTE : 'ImportacaoLote', 
			IMPORTACAO_LOTE_ECD : "ImportacaoLoteECD",
			IMPORTACAO_PLANO_CONTA_ECD : "ImportacaoPlanoContaECD",
			ECF : {$: "ECF", extensionFile: ".txt"},
			ECD : {$: "ECD", extensionFile: ".zip"},
			pathRoot: "Contabilidade/",
			serviceProcess: {
				//Contabilidade n�o tem History por isso chamamos o mesmo do getStatus
				getHistory	: "mgecontab@BackgroundProcessImportacaoDeLoteSP.getStatusProcess", 
				getStatus 	: "mgecontab@BackgroundProcessImportacaoDeLoteSP.getStatusProcess",
				finalizar	: "mgecontab@BackgroundProcessImportacaoDeLoteSP.finalizarProcesso",
				excluir 	: "mgecontab@BackgroundProcessImportacaoDeLoteSP.excluirProcessos"
			}
		},
		LIVRO_FISCAL: {
			$: "LIVROFISCAL",
			TYPE_EFD_CONTRIBUICOES : 'EFDPISCOF_HTML',
			EFDFISCAL_HTML : {$: "EFDFISCAL_HTML", extensionFile: ".zip"},
            EFDPISCOF_HTML : {$: "EFDPISCOF_HTML", extensionFile: ".zip"},
            CAT42 : {$: "CAT42", extensionFile: ".zip"},
            TYPE_CAT42: 'CAT42',
            DESBH : {$: "DESBH", extensionFile: ".zip"},
            TYPE_DESBH: 'DESBH',
            NFSTMODELO21E22 : {$: "NFSTMODELO21E22", extensionFile: ".zip"},
            TYPE_NFSTMODELO21E22: 'NFSTMODELO21E22',
            DRCST : {$: "DRCST", extensionFile: ".zip"},
            TYPE_DRCST: 'DRCST',
            SSINTEGRA : {$: "SSINTEGRA", extensionFile: ".zip"},
            TYPE_SSINTEGRA: 'SSINTEGRA',
            SINTEGRA : {$: "SINTEGRA", extensionFile: ".zip"},
            TYPE_SINTEGRA: 'SINTEGRA',
			GIAST: {$: "GIAST", extensionFile: ".zip"},
			TYPE_GIAST: 'GIAST',
            DCTF : {$: "DCTF", extensionFile: ".zip"},
            TYPE_DCTF: 'DCTF',
            ADRCST : {$: "ADRCST", extensionFile: ".zip"},
            TYPE_ADRCST: 'ADRCST',
			pathRoot: "Livros Fiscais/",
			serviceProcess: { 	
				getHistory	: "mge@BackgroundProcessSP.getHistoryOfProcess", 
				getStatus 	: "mge@BackgroundProcessSP.getStatusProcess",
				finalizar	: "mge@BackgroundProcessSP.finalizarProcesso",
				excluir 	: "mge@BackgroundProcessSP.excluirProcessos"
			}
		},
		CALCULO_MEDIA_BC_ICMS_ST: {
			$: "CALCULOMEDIABCICMSST",
			TYPE_CALCULO_MEDIA_BC_ICMS_ST : 'CALCULO_MEDIA_BC_ICMS_ST_HTML',
			pathRoot: "Comercial/",
			serviceProcess: { 	
				getHistory	: "mge@BackgroundProcessSP.getHistoryOfProcess", 
				getStatus 	: "mge@BackgroundProcessSP.getStatusProcess",
				finalizar	: "mge@BackgroundProcessSP.finalizarProcesso",
				excluir 	: "mge@BackgroundProcessSP.excluirProcessos"
			}
		},
		ORIGEM : {
			HISTORIC : 'historico',
			DETAILS : 'detalhes'
		}
	})
	.service('StatusProcessoPopUpService', ['SanPopup', 'SkI18nService', 'StatusProcessoConstant', 'StringUtils',
		function (SanPopup, SkI18nService, StatusProcessoConstant, StringUtils) {
			var self = this;

			self.openPopUp = openPopUp;

			function openPopUp(popupInfo) {
				return SanPopup.open({
					title: resolveTitulo(popupInfo),
					templateUrl: 'commons/statusProcessoPopUp/statusProcessoPopUp.tpl.html',
					controller: 'StatusProcessoController',
					controllerAs: 'ctrl',
					size: 'lg',
	                showBtnOk: false,
	                showBtnCancel: false,
					resolve: {
						statusProcessoPopUpInfo: popupInfo
					}
				}).result;
			}

			function resolveTitulo(popupInfo) {
				var titulo = popupInfo.title;

				if (StringUtils.isEmpty(popupInfo.title)) {
					if (popupInfo.module == StatusProcessoConstant.CONTABILIDADE.$) {
						titulo = SkI18nService.instant('Commons.StatusProcesso.titleHistorico');
					} else {
						titulo = SkI18nService.instant('Commons.StatusProcesso.titleProcessos');
					}
				}
				return titulo;
			}
		}
    ]);
angular
	.module('snk.commons')
	.controller('popupVendaMaisController',['data','$popupInstance','MessageUtils','i18n',
        function(data,$popupInstance,MessageUtils, i18n) {
			
			var self = this;

            $popupInstance;
			
			self.carregarScript = carregarScript;
			self.carregaInfo = carregaInfo;
			
			self.dsParceiro = data.dataset;
			
			self.urlVendaMais = data.urlVendaMais;

			self.razaoSocial = data.razaoSocial;
			
			init();
			
			async function init (){
                await carregarScript();
                await carregaInfo();
			}

			async function carregarScript (){
				let node = document.createElement('script');
				node.src = data.urlVendaMais;
				node.type = 'text/javascript';
				node.async = true;
				document.getElementsByTagName('head')[0].appendChild(node);
			}
			
			async function carregaInfo(){
                self.dadosPopUp = {
                    'sasId': data.sasId,
                    'partnerCode': self.dsParceiro.getFieldValue("CODPARC"),
                    'namePartner': self.razaoSocial,
                    'pathTemplate': 'creditRequest',
                    'isFinance': true
                }

                infosPopUpSolicitacao = btoa(JSON.stringify(self.dadosPopUp));

                document.getElementById("vendaMaisPopup")
                .innerHTML += "<sankhya-venda-mais params=" + infosPopUpSolicitacao +"></sankhya-venda-mais>";
			}
		}
	]);
angular
    .module('snk.commons')
    .service('vendaMaisService', ['SanPopup', 'i18n', '$timeout', 'MessageUtils', 'ServiceProxy', 'ObjectUtils', function (SanPopup, i18n, $timeout, MessageUtils, ServiceProxy, ObjectUtils) {
        
        var self = this;

        this.getAmbienteInfoVendaMais = function () {
            return new Promise(function (resolve, reject) {
                ServiceProxy.callService('mgefin@VendaMaisProviderSP.getAmbienteInfo', {})
                    .then(function (response) {
                        let result = response.responseBody;
                        let ambienteInfo = {
                            'sasId': result.idSAS,
                            'environment': result.ambiente,
                            'codParc': result.codParc
                        };
                        resolve(ambienteInfo);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        };
        
        this.getCnpjParceiro = function (codParc) {
            return new Promise(function (resolve, reject) {
                var expressao = "CODPARC = " + codParc;
        
                var params = {
                    entity: {
                        name: 'Parceiro',
                        literalCriteria: {
                            expression: {
                                $: expressao
                            }
                        },
                        fields: {
                            field: [
                                { name: 'CGC_CPF' },
                                { name: 'RAZAOSOCIAL' },
                                { name: 'TIPPESSOA' }
                            ]
                        }
                    }
                };
        
                ServiceProxy.callService("mge@crud.find", params)
                    .then(function (response) {
                        let cnpjDados = response.responseBody.entidades.entidade;
                        var cnpj = ObjectUtils.getProperty(cnpjDados, 'CGC_CPF.$');
                        var razaoSocial = ObjectUtils.getProperty(cnpjDados, 'RAZAOSOCIAL.$');
                        var tipPessoa = ObjectUtils.getProperty(cnpjDados, 'TIPPESSOA.$');
                        resolve({ cnpj: cnpj, razaoSocial: razaoSocial, tipPessoa: tipPessoa });
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        };
        
        this.getDadosTipoNegociacao = function(nuNota) {
            return new Promise(function (resolve, reject) {
                var expressao = "CODTIPVENDA = (SELECT CODTIPVENDA FROM TGFCAB WHERE NUNOTA = " + nuNota + ")";
        
                var params = {
                    entity: {
                        name: 'TipoNegociacao',
                        literalCriteria: {
                            expression: {
                                $: expressao
                            }
                        },
                        fields: {
                            field: [
                                { name: 'EXVENDAMAIS' }
                            ]
                        }
                    }
                };
        
                ServiceProxy.callService("mge@crud.find", params)
                    .then(function (response) {
                        let tipoNegociacao = response.responseBody.entidades.entidade;
                        var exVendaMais = ObjectUtils.getProperty(tipoNegociacao, 'EXVENDAMAIS.$');
                        resolve(exVendaMais);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        };

        this.getDadosTipoOperacao = function(nuNota) {
            return new Promise(function (resolve, reject) {
                let expressao = "CODTIPOPER = (SELECT CODTIPOPER FROM TGFCAB WHERE NUNOTA = " + nuNota + ") ";
                expressao += "AND DHALTER = (SELECT DHTIPOPER FROM TGFCAB WHERE NUNOTA =" + nuNota + ")";

                const params = {
                    entity: {
                        name: 'TipoOperacao',
                        literalCriteria: {
                            expression: {
                                $: expressao
                            }
                        },
                        fields: {
                            field: [
                                { name: 'USAVENDAMAIS' }
                            ]
                        }
                    }
                };

                ServiceProxy.callService("mge@crud.find", params)
                    .then(function (response) {
                        const tipoOperacao = response.responseBody.entidades.entidade;
                        const usaVendaMais = ObjectUtils.getProperty(tipoOperacao, 'USAVENDAMAIS.$');

                        resolve(usaVendaMais);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        };

        this.getSituacaoFinanceira = function (cnpj) {
            return new Promise(function (resolve, reject) {
                let request = {
                    cnpj: cnpj
                };
        
                ServiceProxy.callService('mgefin@VendaMaisProviderSP.getFinancialSituation', request)
                    .then(function (response) {
                        let limiteVendaMais = response.responseBody.financialSituation;
                        resolve(limiteVendaMais);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        };

        this.sankhyaVendaMaisAddEventListener = function () {
            let sankhyaVendaMais = document.querySelector('sankhya-venda-mais');
            sankhyaVendaMais.removeEventListener("DOMContentLoaded", self.handleSankhyaVendaMaisDOMContentLoadedEvent);
            sankhyaVendaMais.addEventListener('onCallbackEvent', function(event) {
                self.handleSankhyaVendaMaisCallbackEvent(event);
            });
            document.addEventListener('DOMContentLoaded', self.handleSankhyaVendaMaisDOMContentLoadedEvent);
        };

        this.constroiHtml = function (infos) {
            document.getElementById("vendaMais")
                .innerHTML += "<sankhya-venda-mais params=" + infos + "></sankhya-venda-mais>";
        };

        this.carregaInfo = function (dataController) {
            self.dados = {
                'sasId': dataController.sasId,
                'partnerCode': dataController.partnerCode,
                'cnpjPartner': dataController.cnpj,
                'pathTemplate': dataController.pathTemplate,
                'enviroment': dataController.environment,
                'isFinance': dataController.isFinance,
                'personType': dataController.tipPessoa
            };

            return btoa(JSON.stringify(self.dados));
        };

        this.handleSankhyaVendaMaisCallbackEvent = function (event) {
            let eventDetail = event.detail;
            switch(eventDetail.name) {
                case 'POPUP_CREDIT_REQUEST':
                    self.abrirPopUpSolicitacaoCredito();
                    $timeout(function () {
                        self.popUpSolicitacaoCredito.opened.then(function() {
                            self.dsParceiro.refreshCurrentRow();
                        });
                    }, 200);
                    break;
            }
        };

        this.handleSankhyaVendaMaisDOMContentLoadedEvent = function (event) {
            let eventDetail = event.detail;
            switch(eventDetail.name) {
                case 'CLOSE_POPUP_CREDIT_REQUEST':
                    self.popUpSolicitacaoCredito.dismiss();
                    MessageUtils.showInfo(i18n('Commons.Liberacoes.lblPopupVendaMais'), i18n('Commons.Liberacoes.textoPopupVendaMais'));
                    break;
                case 'VALIDATE_FIELDS_CREDIT_REQUEST':
                    self.popUpSolicitacaoCredito.dismiss();
                    MessageUtils.showAlert('Alerta', (i18n('Commons.Liberacoes.mensagemPrefixValidacaoCamposVendaMais')).concat(((eventDetail.data.errorsValidate).replaceAll('?', '\''))));
                    break;
            }
        };

        this.abrirPopUpSolicitacaoCredito = function ($scope, dataController) {
            self.dadosPopUp = {
                'sasId': dataController.sasId,
                'partnerCode': dataController.partnerCode,
                'namePartner': dataController.razaoSocial,
                'pathTemplate': dataController.pathTemplate,
                'isFinance': dataController.isFinance,
                'personType': dataController.tipPessoa
            };

            $scope.infosPopUpSolicitacao = btoa(JSON.stringify(self.dadosPopUp));

            self.popUpSolicitacaoCredito = SanPopup.open({
                title: i18n('Commons.Liberacoes.popUpSolicitacaoCreditoVendaMais'),
                templateUrl: 'commons/vendaMais/popupVendaMais.tpl.html',
                size: 'lg',
                height: 360,
                showBtnOk: false,
                showBtnCancel: false,
                showIconClose: true,
                controller: 'popupVendaMaisController',
                controllerAs: 'ctrl',
                resolve: {
                    data: {
                        urlVendaMais : dataController.urlVendaMais,
                        dataset : dataController.dataSet,
                        popup: self.popUpSolicitacaoCredito,
                        sasId: dataController.sasId,
                        razaoSocial: dataController.razaoSocial
                    }
                }
            });

            self.popUpSolicitacaoCredito.result
                .then(function(result) {
                    console.log(result);
                }, function(cancel) {
                    console.log(cancel);
                    document.querySelectorAll('sankhya-venda-mais').forEach(el => el.remove());
                    self.infos = self.carregaInfo(dataController);
                    self.constroiHtml(self.infos);
                    self.sankhyaVendaMaisAddEventListener();
                });
        };
    }]);

angular
    .module('snk.commons.verticaltimeline')
    .controller('skTimelineController', ['i18n', '$scope', 'ServiceProxy', 'ObjectUtils', 'ArrayUtils','StringUtils','data',
        function (i18n, $scope, ServiceProxy, ObjectUtils, ArrayUtils, StringUtils, data) {

            init();
            function init() {
                var params = {
                    param: {
                        nufin: data.nufin
                    }
                }
 
                var sUrl = 'mgefin@MovimentacaoFinanceiraSP.getEventosTitulo';
                if(data.sUrl != null){
                	sUrl = data.sUrl;
            	}	
                ServiceProxy.callService(sUrl, params)
                    .then(function (response) {
                        $scope.etapas = ArrayUtils.toArray(ObjectUtils.getProperty(response, 'responseBody.result.etapas'));
             
                        $scope.etapas.forEach(function (e) {
                            if(StringUtils.toBoolean(e.farol)){
                                e.descricao = i18n('Commons.VerticalTimeline.executado');
                                e.farol = '#35aa47';//Executado
                            }else{
                                e.descricao = i18n('Commons.VerticalTimeline.execucaopendente')
                                e.farol = '#bdc3c7';//Não executado
                            }
                            e.eventos = ArrayUtils.toArray(e.evento);
                        });
                    });
            }
        }]);
angular.module('snk.commons.verticaltimeline')
    .service('skVerticalTimeline', ['SanPopup', 'StringUtils', 'i18n',
        function (SanPopup, StringUtils, i18n) {
           
			var verticalTimeline = {
                openTimeline: openTimeline
            };

            function openTimeline(nufin, sUrl) {
                SanPopup.open({
                    title: i18n('Commons.VerticalTimeline.eventostitulo'),
                    templateUrl: 'commons/verticaltimeline/verticaltimeline.tpl.html',
                    controller: 'skTimelineController',
                    size: 'md',
                    height: 500,
                    showBtnCancel: false,
                    windowClass: 'sk-conference-timeline',
                    resolve: {
                        data: {
                            nufin: nufin,
                            sUrl : sUrl
                        }
                    }
                });
            }

            return verticalTimeline;
        }]);

angular
    .module('snk.commons')
    .service('VisualizadorCustoProducaoPopUp', ['SanPopup', 'SkI18nService',
        function (SanPopup, SkI18nService) {
            var self = this;
            self.open = open;
            function open(idProc, codProdPA, controlePA, isProducaoFit,ideFx,decVlrProduto) {
                var popup = SanPopup.open({
                    title: 'Visualizar Custo de Produção',
                    templateUrl: 'commons/visualizadorCustoProducao/visualizadorCustoProducao.tpl.html',
                    controller: 'VisualizadorCustoProducaoController',
                    controllerAs: 'ctrl',
                    type: 'default',
                    okBtnLabel: SkI18nService.instant('Geral.confirmar'),
                    okBtnClass: 'btn-primary',
                    cancelBtnClass: 'btn-default',
                    showBtnNo: false,
                    showBtnCancel: true,
                    bodyPadding: false,
                    size: 'lg',
                    height: 365,
                    windowClass: 'config-form-modal',
                    resolve: {
                        options: {
                            idProc: idProc,
                            codProdPA: codProdPA,
                            controlePA: controlePA,
                            isProducaoFit: isProducaoFit,
                            ideFx: ideFx,
                            decVlrProduto:decVlrProduto
                        }
                    }
                });

                return popup.result;
            }
        }])
angular
    .module('snk.commons')
    .controller('VisualizadorCustoProducaoController', ['$scope', '$popupInstance', 'FormColumnConfig', 'options', 'SkI18nService', 'SkApplicationInstance', 'ObjectUtils', 'MessageUtils', 'ServiceProxy', 'i18n','NumberUtils',
        function ($scope, $popupInstance, FormColumnConfig, options, SkI18nService, SkApplicationInstance, ObjectUtils, MessageUtils, ServiceProxy, i18n,NumberUtils) {
            var self = this;

            $scope.options = options;

            self.resourceID = SkApplicationInstance.getResourceID();
            self.gridCustoMpConfig = self.resourceID + '.CustoMpConfig';
            self.gridCustoCTConfig = self.resourceID + '.CustoCTConfig';
            self.gridCustoTarifaConfig = self.resourceID + '.CustoTarifaConfig';
            self.gridCustoTotalConfig = self.resourceID + '.CustoTotalConfig';

            const CUSTO_GERENCIAL = "G";
            const CUSTO_MEDIO_ICMS = "MI";
            const CUSTO_SEM_ICMS = "SI";
            const CUSTO_REPOSICAO = "R";
            const CUSTO_VARIAVEL = "V";
            const CUSTO_MEDIO = "M";

            var _serverData;
            var _detalheAtual = "M";
            var _listaTotal = [];
            var _custoMPs = [];
            var _custoTarivas = [];
            var _custoRecursosWC = [];
            var _total = {};

            self.onTipoCustoChange = onTipoCustoChange;
            self.onDatasetCreated = onDatasetCreated;
            self.showCusto = showCusto;
            self.customCellFormatter = customCellFormatter;

            self.dsCustoMp;
            self.dsCustoCT;
            self.dsCustoTarifa;
            self.dsCustoTotal;

            self.idProc;

            self.isProducaoFit;

            self.optionsTipCusto = [{
                data: CUSTO_MEDIO_ICMS,
                value: i18n('Commons.VisualizadorCustoProducao.optionCusMedIcms')
            }, {
                data: CUSTO_SEM_ICMS,
                value: i18n('Commons.VisualizadorCustoProducao.optionCusMedSemIcms')
            }, {
                data: CUSTO_REPOSICAO,
                value: i18n('Commons.VisualizadorCustoProducao.optionCusReposicao')
            }, {
                data: CUSTO_VARIAVEL,
                value: i18n('Commons.VisualizadorCustoProducao.optionCusVariavel')
            }, {
                data: CUSTO_GERENCIAL,
                value: i18n('Commons.VisualizadorCustoProducao.optionCusGerencial')
            }, {
                data: CUSTO_MEDIO,
                value: i18n('Commons.VisualizadorCustoProducao.optionCusMedio')
            }
            ];

            self.tipCusto = CUSTO_MEDIO_ICMS;

            self.txtCustPrevQtd = "";
            self.txtCustPrevpadrao = "";
            self.txtCustPrevQtdTotal = "";
            self.txtCustPrevPadraoTotal = "";

            self.codProdPA;
            self.controlePA;

            init();

            function init() {
                self.idProc = options.idProc;
                self.codProdPA = options.codProdPA;
                self.controlePA = options.controlePA;
                self.isProducaoFit = options.isProducaoFit;
                self.ideFx = options.ideFx;
                self.decVlrProduto = options.decVlrProduto;
                loadDataAndPopulateDataset();
            }

            function onDatasetCreated(dsName, dataset) {
                self[dsName] = dataset;

                if (dsName === 'dsCustoTotal') {
                    dataset.addLineChangeListener(updateTextosTotal);
                    dataset.addRefreshedListener(updateTextosTotal);
                }

                dataset.init();
            }

            function customCellFormatter(column, value, data) {
                var columnName = column.colId;
                if ("CUSPREVQTD,CUSPREVLOTE,CUSATUAL".indexOf(columnName) > -1) {
                    var decQtd = self.decVlrProduto;
                    decQtd = NumberUtils.getNumberOrZero(decQtd) > 0 ? decQtd : 2;
                    return NumberUtils.format(value, decQtd);
                }else if ("QTDPREV".indexOf(columnName) > -1) {
                    return NumberUtils.getNumberOrZero(value).toString().replace(".", ",");                    
                }
            }

            function updateTextosTotal(index) {
                if (index != -1) {
                    var listaTotal = _listaTotal;

                    var currentCustoSelected = self.dsCustoTotal.getFieldValue("TIPCUS");

                    var custoTotalSelecionado = listaTotal.find(custo => custo.TIPCUS === currentCustoSelected);

                    if (angular.isDefined(custoTotalSelecionado)) {
                        var parsedValueQtd = parseFloat(custoTotalSelecionado.CUSPREVQTD).toFixed(self.decVlrProduto).replace(".", ",");
                        var parsedValueLotePadrao = parseFloat(custoTotalSelecionado.CUSPREVLOTE).toFixed(self.decVlrProduto).replace(".", ",");

                        self.txtCustPrevQtd = i18n('Commons.VisualizadorCustoProducao.txtCusPrevQtd') + parsedValueQtd;
                        self.txtCustPrevpadrao = i18n('Commons.VisualizadorCustoProducao.txtCusPrevLotePadrao') + parsedValueLotePadrao;
                    }
                }
            }

            function showCusto(tipoCusto) {
                if (angular.isDefined(self.dsCustoTotal) && angular.isDefined(self.dsCustoTotal.getFieldValue('TIPCUS'))) {
                    _detalheAtual = self.dsCustoTotal.getFieldValue('TIPCUS');
                }
                if (angular.isDefined(self.dsCustoTotal)) {
                    return _detalheAtual === tipoCusto;
                } else {
                    return false;
                }
            }

            function loadData() {
                return ServiceProxy.callService("mgeprod@ProcessoProdutivoSP.getCustoProducao", { params: { idProc: self.idProc, calcCusto: self.tipCusto, codProdPA: self.codProdPA, controlePA: self.controlePA, isProducaoFit: self.isProducaoFit, ideFx: self.ideFx } }).then((result) => {
                    _serverData = result;
                    if (angular.isDefined(result)) {
                        _listaTotal = JSON.parse(result.responseBody.listaTotal)
                        _custoMPs = JSON.parse(result.responseBody.custoMPs)
                        _custoTarivas = JSON.parse(result.responseBody.custoTarivas)
                        if(!self.isProducaoFit) {
                            _custoRecursosWC = JSON.parse(result.responseBody.custoRecursosWC)
                        }
                        _total = JSON.parse(result.responseBody.total)
                    }
                });
            }

            function loadDataAndPopulateDataset(reload) {
                if (angular.isUndefined(_serverData) || reload) {
                    loadData().finally(() => populateDataset());
                } else {
                    populateDataset();
                }
            }

            function populateDataset() {
                if (angular.isDefined(self.dsCustoTotal)) {
                    var listaTotal = _listaTotal;
                    self.dsCustoTotal.addRecordsAsObjects(treatFieldsTotal(listaTotal));

                    var totalizador = _total;
                    self.txtCustPrevQtdTotal = calcCustoPrevQtdTotal(totalizador.CUSPREVQTD);
                    self.txtCustPrevPadraoTotal = calcCustoPrevPadraoTotal(totalizador.CUSPREVLOTE);

                    goToActualRow().finally(() => updateTextosTotal(0));
                }
                if (angular.isDefined(self.dsCustoMp)) {
                    self.dsCustoMp.addRecordsAsObjects(treatFieldsMPs(_custoMPs));
                }

                if (angular.isDefined(self.dsCustoCT)) {
                    self.dsCustoCT.addRecordsAsObjects(treatFieldsRecursos(_custoRecursosWC));
                }

                if (angular.isDefined(self.dsCustoTarifa)) {
                    if (_custoTarivas.data.length > 0 && angular.isUndefined(_custoTarivas.length)){
						_custoTarivas = _custoTarivas.data;
					}
                    self.dsCustoTarifa.addRecordsAsObjects(treatFieldsTarifasCIP(_custoTarivas));
                }
            }

            function goToActualRow() {
                var index = self.dsCustoTotal.getRecordsAsObjects().findIndex(item => item.TIPCUS === _detalheAtual);
                return self.dsCustoTotal.gotoRow(index);
            }

            function calcCustoPrevQtdTotal(cusPrevQtd) {
                var custoQtd = parseFloat(cusPrevQtd);

                return `${i18n('Commons.VisualizadorCustoProducao.txtCusPrevQtd')}: ${custoQtd.toFixed(self.decVlrProduto).replace(".", ",")}`;
            }

            function calcCustoPrevPadraoTotal(cusPrevLote) {
                var custoPadrao = parseFloat(cusPrevLote);

                return `${i18n('Commons.VisualizadorCustoProducao.txtCusPrevLotePadrao')}: ${custoPadrao.toFixed(self.decVlrProduto).replace(".", ",")}`;
            }

            function treatFieldsMPs(listCustoMps) {
                return treatFields(listCustoMps, "QTDMISTURA");
            }

            function treatFieldsTarifasCIP(listCustoTarifasCIP) {
                return treatFields(listCustoTarifasCIP, "QTD");
            }

            function treatFieldsRecursos(listCustoRecursos) {
                return treatFields(listCustoRecursos, "QTDUTILIZACAO");
            }

            function treatFields(listCusto) {
                var treatedListCusto = [];

                listCusto.forEach((custo) => {
                    var treatedCusto = {};
                    treatedCusto.DESCRPROD = custo.DESCRPROD;
                    treatedCusto.QTDPREV = custo.QTDUSO;
                    treatedCusto.CODPROD = custo.CODPROD;
                    treatedCusto.CUSATUAL = parseFloat(custo.CUSATUAL).toFixed(self.decVlrProduto);
                    treatedCusto.CUSPREVQTD = parseFloat(custo.CUSPREVQTD).toFixed(self.decVlrProduto);
                    treatedCusto.CUSPREVLOTE = parseFloat(custo.CUSPREVLOTE).toFixed(self.decVlrProduto);
                    treatedListCusto.push(treatedCusto);

                });
                return treatedListCusto;
            }

            function treatFieldsTotal(listaTotal) {
                var treatedListCusto = [];

                listaTotal.forEach((custo) => {
                    var treatedCusto = {};
                    treatedCusto.DESCRITEM = custo.DESCRITEM;
                    treatedCusto.CUSPREVQTD = parseFloat(custo.CUSPREVQTD).toFixed(self.decVlrProduto);
                    treatedCusto.CUSPREVLOTE = parseFloat(custo.CUSPREVLOTE).toFixed(self.decVlrProduto);
                    treatedCusto.TIPCUS = custo.TIPCUS;
                    treatedListCusto.push(treatedCusto);

                });
                return treatedListCusto;
            }

            function onTipoCustoChange() {
                self.dblFacePanel
                clearDatasets();
                loadDataAndPopulateDataset(true);
            }

            function clearDatasets() {
                self.dsCustoMp.clearDataSet();
                self.dsCustoCT.clearDataSet();
                self.dsCustoTarifa.clearDataSet();
                self.dsCustoTotal.clearDataSet();
            }
        }])
angular
	.module('snk.commons.visualizadorRelatoriosBase')
    .directive('skAbaAdicional', ['$controller', '$compile', 'AngularUtil', function ($controller, $compile, AngularUtil) {
        return {
            restrict: 'E',
            scope: {
                data: '=?skData',
                properties: '=?skProperties'
            },
            templateUrl: 'commons/visualizadorRelatoriosBase/abaAdicional/abaadicional.tpl.html',
            link: function ($scope, $element) {
            	if ($scope.data.controller) {
            		$scope.controller = $scope.data.controller;
            		if ($scope.data.controllerAs) {
            			$scope.controllerAs = $scope.data.controllerAs;
            		}
                }
            	
            	if ($scope.data.templateUrl) {
            		$scope.templateUrl = $scope.data.templateUrl;
            	}
            	
            	var controllerScope = $scope.$new();
            	controllerScope.properties = $scope.properties;
            	
				if(angular.isDefined($scope.controller) && angular.isDefined($scope.templateUrl)){
					var controller = $controller($scope.controller, {
						$scope: controllerScope
					});
					
					if ($scope.controllerAs) {
						$scope[$scope.controllerAs] = controller;
					}
					
					AngularUtil.requestTemplate($scope.templateUrl)
					.then(function (template) {
						var compiledTemplate = $compile(template)(controllerScope);
						$element.append(compiledTemplate);
					});
				}
            }
        };
    }]);
angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('AgendadorRelatoriosPopUpController', ['i18n', 'data', 'ObjectUtils', 'ServiceProxy', '$q', 'MessageUtils', 'ArrayUtils', 'DoubleFacePanelConstants', 'StringUtils', '$rootScope', '$popupInstance',
        function (i18n, data, ObjectUtils, ServiceProxy, $q, MessageUtils, ArrayUtils, DoubleFacePanelConstants, StringUtils, $rootScope, $popupInstance) {
            var self = this;
			var stepEvtBus = new EventBus();

			var _wizard;

            //Implementors
			ObjectUtils.implements(self, IDatagridInterceptor);
			
			self.manutencaoAgendamento = manutencaoAgendamento;
            self.finishTask = finishTask;
            self.salvarAgendamento = salvarAgendamento;
            self.removerAgendamento = removerAgendamento;
			self.clonarAgendamento = clonarAgendamento;
			self.carregarAgendamentos = carregarAgendamentos;
            self.executarAgendamentoManual = executarAgendamentoManual;
            self.execucaoUnicaLabelFunction = execucaoUnicaLabelFunction;
            self.onSelectItem = onSelectItem;
            self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.onDatasetCreated = onDatasetCreated;
			self.refreshHandler = refreshHandler;
			self.onCancel = onCancel;
			self.liberarFinalizacao = false;
			self.responseAgendamento = [];
			self.parametroBody = [];
			self.onWizardCreated = onWizardCreated;
			self.temRegistros = false;
			
            //IDatagridInterceptor
			self.interceptColumnMetadata = interceptColumnMetadata;
			
			//EventBus
			self.stepEvtBus = stepEvtBus;    

			$rootScope.$on('finalizeStep', function(event, title) {
				self.liberarFinalizacao = title;
			});

			function carregarAgendamentos() {
				self.dsAgendadorRelatorio.refresh();
            }

            function interceptColumnMetadata(fieldMetadata, dataset) {
                if (ArrayUtils.isIn(['SEQUENCIA', 'NURFE'], fieldMetadata.name)) {
                    fieldMetadata.visible = false;
                }
            }
            
			function onCancel() {
				self.dsAgendadorRelatorio.refresh();
				self.dsAgendadorRelatorio.first();
				self["dblFacePanelAgendadorRelatorio"].setSelectedIndex(DoubleFacePanelConstants.GRID_FACE);
				_wizard.goToByName(0, {resetCompleted: true});
			}
			
			function createParametersPanel(nurfe){
				var request = {
					relatorio: {
						nuRfe: nurfe
					}
				};
		
				ServiceProxy.callService('mge@VisualizadorRelatorios.requisitarParametros', request)
				.then(function(result) {
					self.parametroBody = result.responseBody.parametros;
				})
				.catch(function errorCallback(response) {
                    setTimeout(function() {
						$popupInstance.dismiss('canceled');
					});
                    
                    //using setTimeout moves the actual throwingout of the
                    // promise chain. It's kind of a hack!
                    return $q.reject(response) //reReject the error, so the rest
                    // of the chain knows there is something wrong
                });;

			}

            function manutencaoAgendamento(dblFacePanel) {
				
				if( dblFacePanel != null){
					self[dblFacePanel.id].setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
				
					var rowGrid = self.dsAgendadorRelatorio.getCurrentRowAsObject();
					var selectedItem = {};
					for (var i = 0; i < self.responseAgendamento.length; i++) { 
						if(self.responseAgendamento[i].SEQUENCIA.$ == rowGrid.SEQUENCIA){
							selectedItem = self.responseAgendamento[i];
						}
					}

					if(selectedItem.agendamento.parametros === undefined){
						selectedItem.agendamento.parametros = {}
						selectedItem.agendamento.parametros.parametro = [];
						var isArray = Array.isArray(self.parametroBody.parametro);
						if(!isArray){
							selectedItem.agendamento.parametros.parametro = [self.parametroBody.parametro];
						}else{
							selectedItem.agendamento.parametros.parametro = self.parametroBody.parametro;
						}
					}else{
						var isArray = Array.isArray(selectedItem.agendamento.parametros.parametro);
						if(!isArray){
							selectedItem.agendamento.parametros.parametro = [selectedItem.agendamento.parametros.parametro]
						}else{
							selectedItem.agendamento.parametros.parametro = selectedItem.agendamento.parametros.parametro;
						}
					}
					

					var data = {};
					data.PARAMETROS = {}
					data.PARAMETROS.parametro = [];
					data.AGENDAMENTO = selectedItem.agendamento;
					data.NURFE = self.initNurfe;
					data.SEQUENCIA = selectedItem.SEQUENCIA.$;
					data.DHINI = selectedItem.DHINI.$;
					data.DHFIM = selectedItem.DHFIM.$;
					data.EXECUNICA = selectedItem.EXECUNICA.$;
					data.DESCRICAO = selectedItem.DESCRICAO.$;
					data.PARAMETROS.parametro = selectedItem.agendamento.parametros.parametro;
					data.ARQMODEMAIL = selectedItem.ARQMODEMAIL.$;
					data.CODUSU = selectedItem.CODUSU;
					if(selectedItem.agendamento.sql !== undefined){
						data.SQL = selectedItem.agendamento.sql.$;
					}
					data.CODSMTP = selectedItem.CODSMTP.$;
					data.novoAgendamento = false;
					if(selectedItem.EMAILASSUNTO !== undefined){
						data.EMAILASSUNTO = selectedItem.EMAILASSUNTO.$;
					}
					if(selectedItem.EMAILMSG !== undefined){
						data.EMAILMSG = selectedItem.EMAILMSG.$;
					}

					stepEvtBus.dispatchEvent('dataWizardChanged', data);

				}else{
					var data = {};
					data.PARAMETROS = {}
					data.PARAMETROS.parametro = [];
					var parametroValorNull = self.parametroBody.parametro;
					data.novoAgendamento = true;
					if(parametroValorNull !== undefined){
						for(var i = 0; i < parametroValorNull.length; i++){
							parametroValorNull[i].valor = null;
						}
						data.PARAMETROS.parametro = parametroValorNull;
					}
					data.NURFE = self.initNurfe;
					stepEvtBus.dispatchEvent('dataWizardChanged', data);
				}

				self.dsAgendadorRelatorio.goToInsertionMode();
			}
			
            

            function finishTask($step){
				
				var destinatarios = {
					destinatario: $step.wizardContext.DESTINATARIOS
				}

				var agendamento = $step.wizardContext.AGENDAMENTO;
                
				if($step.wizardContext.DESTINATARIOS != $step.wizardContext.DESTINATARIO_DINAMICO){
					if($step.wizardContext.hasOwnProperty("PARAMETROS")){
						agendamento.parametros = $step.wizardContext.PARAMETROS;
					}
				}else{
					agendamento.sql = {
						$: $step.wizardContext.SQL
					};
					if($step.wizardContext.hasOwnProperty("CAMPOS_OBRIGATORIOS")){
						agendamento.camposObrigatorios = $step.wizardContext.CAMPOS_OBRIGATORIOS
					}
				}
				
				var dados = {
					agendamento: agendamento,
					destinatarios: destinatarios,
					NURFE: {$: $step.wizardContext.NURFE},
					SEQUENCIA: {$: $step.wizardContext.SEQUENCIA},
					DHINI: {$: $step.wizardContext.DHINI},
					DHFIM: {$: $step.wizardContext.DHFIM},
					EXECUNICA: {$: $step.wizardContext.EXECUNICA},
					DESCRICAO: {$: $step.wizardContext.DESCRICAO},
					CODUSU: {$: $step.wizardContext.CODUSU},
					CODSMTP: {$: $step.wizardContext.CODSMTP}
				}
				

				if(StringUtils.emptyAsNull($step.wizardContext.EMAILMSG)) {
					dados.EMAILASSUNTO = {$: $step.wizardContext.EMAILASSUNTO};
					dados.EMAILMSG = {$: $step.wizardContext.EMAILMSG};
				}else if (StringUtils.emptyAsNull($step.wizardContext.ARQMODEMAIL)) {
					dados.ARQMODEMAIL = {$: $step.wizardContext.ARQMODEMAIL};
				}
				
				if($step.wizardContext.DESTINATARIOS != $step.wizardContext.DESTINATARIO_DINAMICO){
					salvarAgendamento(dados);
				}else{
					
					if($step.wizardContext != null && $step.wizardContext.CAMPOS_OBRIGATORIOS != null){
						var campos;
						for(var i = 0; i < $step.wizardContext.CAMPOS_OBRIGATORIOS.parametro.length; i++){
							if(campos == null) {
								campos = $step.wizardContext.CAMPOS_OBRIGATORIOS.parametro[i].nome;
							} else {
								campos += "," + $step.wizardContext.CAMPOS_OBRIGATORIOS.parametro[i].nome;
							}
						}
						var consulta = {
							query: $step.wizardContext.SQL,
							reportReqFields: campos
						};
		
						var param = {consulta: consulta}
					}

					ServiceProxy.callService('mge@VisualizadorRelatorios.resolverConsulta', param)
					.then(function() {
						salvarAgendamento(dados);
					});
				}
			}
			
			function salvarAgendamento(dados){
				var request = {dados: dados}
				ServiceProxy
					.callService('mge@VisualizadorRelatorios.salvarAgendamento', request).then(function () {
						_wizard.goToByName(0, {resetCompleted: true});
						carregarAgendamentos();
						self["dblFacePanelAgendadorRelatorio"].setSelectedIndex(DoubleFacePanelConstants.GRID_FACE);
					});
            }
            
            
            function removerAgendamento() {
				self.dsAgendadorRelatorio.gotoRow(0);
                var _agedamento = self.dsAgendadorRelatorio.getCurrentRowAsObject("NURFE,SEQUENCIA");
                if (!ObjectUtils.isEmpty(_agedamento)) {

                    MessageUtils.simpleConfirm(i18n('Core.VisualizadorRelatorios.messageExcluirAgendamentoSelecioado'))
                        .then(function () {
                            ServiceProxy
                                .callService('mge@VisualizadorRelatorios.removerAgendamento', {
                                    agendamento:_agedamento
                                }).then(function () {
									carregarAgendamentos();
									self.dsAgendadorRelatorio.removeCurrentRow(true);
									_wizard.goToByName(0, {resetCompleted: true});
                                });
                        });
                }
            }

            function clonarAgendamento() {
                var _agendamento = self.dsAgendadorRelatorio.getSelectedRecordsAsObjects('NURFE,SEQUENCIA', true);
                if (_agendamento.length > 0) {
                    ServiceProxy
                        .callService('mge@VisualizadorRelatorios.clonarAgendamento', {
                            agendamento: _agendamento[0]
                        }).then(function () {
							carregarAgendamentos();
							_wizard.goToByName(0, {resetCompleted: true});
                        });
                }
            }

            
            function executarAgendamentoManual(){
				var _agendamento = self.dsAgendadorRelatorio.getSelectedRecordsAsObjects('NURFE,SEQUENCIA', true);

				var request = {
					agendamento: {
						NURFE: _agendamento[0].NURFE,
						SEQUENCIA: _agendamento[0].SEQUENCIA
					}
				};

				if(_agendamento.length >= 0){ 
					ServiceProxy
						.callService("mge@VisualizadorRelatorios.executarAgendamentoManual", request,{
							
                        }).then(function () {
							MessageUtils.showAlert(MessageUtils.TITLE_INFORMATION, "Agendamento executado com sucesso.");
                            carregarAgendamentos();
                        });
				}
            }
            

			function execucaoUnicaLabelFunction(data, column){
				return resourceManager.getString('Geral',String(data[column.dataField]) == "S" ? "buttonSim" : "buttonNao");
			}

            function onSelectItem() {
                $step.setCanNext(self.destUserData.length > 0);
            }


            function interceptColumnMetadata(fieldMetadata, dataset) {
                if (ArrayUtils.isIn(['SEQUENCIA', 'NURFE'], fieldMetadata.name)) {
                    fieldMetadata.visible = false;
                }
            }

            
            function onDoubleFacePanelCreated(dblFacePanel) {
                if (dblFacePanel) {
                    self[dblFacePanel.id] = dblFacePanel;
                }
            }


            function onDatasetCreated(dataset) {
                self.dsAgendadorRelatorio = dataset;

                self.dsAgendadorRelatorio.initializeDataSet()
                    .then(function () {
                        self.dsAgendadorRelatorio.refresh();
                    });

            }

            function refreshHandler(request) {
				self.initNurfe = data.numeroRelatorio;
				createParametersPanel(data.numeroRelatorio);
                return $q(function (resolve, reject) {
                    ServiceProxy
                        .callService('mge@VisualizadorRelatorios.getAgendamentos', {
                            criterio: {
                                NURFE: data.numeroRelatorio
                            }
                        }).then(function (response) {
							resolve(ObjectUtils.getProperty(response, 'responseBody.agendamentos.agendamento'));
							self.responseAgendamento = response.responseBody.agendamentos.agendamento;	
							if(self.responseAgendamento){
								self.temRegistros = true;
							}else{								
								self.temRegistros = false;
							}
						}, reject);
				});
			};

			function onWizardCreated(wizard){
				_wizard = wizard;
			}

        }]);

angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('StepSetTimesController', ['$wizard', '$step', 'StringUtils', '$filter', 'MessageUtils','i18n', '$scope','ObjectUtils','ArrayUtils', function($wizard, $step, StringUtils, $filter, MessageUtils, i18n, $scope, ObjectUtils, ArrayUtils) {
        var self = this;
        
        $step.onExitStep = onExitStep;
        $step.onEnterStep = onEnterStep;
        $step.setCanNext(false);
        
        self.validateBtnNext = validateBtnNext;
        self.carregarConfiguracoes = carregarConfiguracoes;
        self.limparCampos = limparCampos;
        self.setConfiguration = setConfiguration;
        self.getConfiguration = getConfiguration;
        self.todosMeses = todosMeses;
        self.todosDias = todosDias;
        self.validaChkMeses = validaChkMeses;
        self.changeRadioSemana = changeRadioSemana;
        self.changeRadioMes = changeRadioMes;
        self.enabledInput = true;
        self.chkTodos = false;
        self.inputValue = 'rdTodoDia';
        self.dtInicio;
        self.dtFinal;
        self.changeDiasMes = changeDiasMes;
        
        function validateBtnNext() {
            var enableNext = false;
            if(StringUtils.isNotEmpty(self.horasEnvio) && StringUtils.isNotEmpty(self.dtInicio) && StringUtils.isNotEmpty(self.dtFinal)){
                enableNext = true;
            }
            $step.setCanNext(enableNext);
        }

        function onEnterStep() {
            self.dtInicio = $wizard.context.DHINI;
            self.dtFinal = $wizard.context.DHFIM;
            self.chkExecUnica = "S" == $wizard.context.EXECUNICA;
            carregarConfiguracoes();
            validateBtnNext();
        }

        function changeDiasMes() {
            if(self.txtDias != undefined && self.txtDias != ""){
                $scope.regex = /^(3[0-1]|[1-2][0-9]|[0]?[1-9])(,3[0-1]|,[1-2][0-9]|,[0]?[1-9])*$/;
                if($scope.regex.test(self.txtDias) == false){
                    MessageUtils.showError(MessageUtils.TITLE_ERROR, i18n('Core.VisualizadorRelatorios.messageValorDiaMesInvalido',[self.txtDias]));
                }
            }
        }

        function onExitStep() {

            var dtInicio = $filter('date')(self.dtInicio, "dd/MM/yyyy HH:mm");
            var dtFinal = $filter('date')(self.dtFinal, "dd/MM/yyyy HH:mm");

            $wizard.context.DHINI = dtInicio;
            $wizard.context.DHFIM = dtFinal;
            $wizard.context.EXECUNICA = self.chkExecUnica ? "S" : "N";
            $wizard.context.AGENDAMENTO = getConfiguration();
        }

        
        
        function carregarConfiguracoes(){
            if($wizard.context.AGENDAMENTO != null) {
                setConfiguration($wizard.context.AGENDAMENTO);
            }else{
                limparCampos();
                self.dtInicio = " ";
                self.dtFinal = " ";
                self.horasEnvio = "";
                self.inputValue = 'rdTodoDia';
            }
        }
    
        function limparCampos(){
            todosDias(false);
            todosMeses(true);
            self.rdTodoDia = true;
            changeRadioSemana();
        }

        
        function setConfiguration(agendamento) {
            
            self.horasEnvio = {};
            var agendamentoHora = agendamento.hora;
            if(agendamentoHora !== undefined){
                self.horasEnvio = agendamentoHora.horas + ":" + agendamentoHora.min;
            }
            
            var agendamentoDias = agendamento.dias;

            if(agendamentoDias.todoDia !== undefined){
                var todoDia = agendamentoDias.todoDia.toString() ? true : false;
            }
            if(agendamentoDias.semanal !== undefined){
                var semanal = agendamentoDias.semanal.toString() ? true : false;
            }
            

            if (todoDia) {
                self.txtDias = "";
                self.rdTodoDia = true;
                self.inputValue = 'rdTodoDia';
                changeRadioSemana();
            } else if (semanal) {
                self.rdSemanal = true;
                self.rdTodoDia = false;
                self.rdMensal = false;
                self.inputValue = 'daysOfTheWeek';
                

                todosDias(false);
                if(!angular.isArray(agendamentoDias.dia) && agendamentoDias.dia !== undefined){
                    agendamentoDias.dia = [agendamentoDias.dia];
                }

                if(agendamentoDias.dia !== undefined || ArrayUtils.isNotEmpty(agendamentoDias.dia)){
                    for (var i = 0; i < agendamentoDias.dia.length; i++) {
                        var diaSemana = agendamentoDias.dia[i].$;

                        switch(diaSemana.toString()){
                            case "1":
                                self.chkDom = true; 
                                break;
                            case "2":
                                self.chkSeg = true; 
                                break;
                            case "3":
                                self.chkTer = true; 
                                break;
                            case "4":
                                self.chkQua = true; 
                                break;
                            case "5":
                                self.chkQui = true; 
                                break;
                            case "6":
                                self.chkSex = true; 
                                break;
                            case "7":
                                self.chkSab = true; 
                                break;
                        }
                    }
                }
            } else {
                self.rdMensal = true;
                self.inputValue = 'daysOfTheMonth';
                todosDias(false);
                changeRadioSemana();

                if(agendamentoDias.dia === undefined){
                    agendamentoDias.dia = "";
                }
                
                var diasMes = agendamentoDias.dia;

                self.txtDias = "";

                if(angular.isUndefined(diasMes)){
                    diasMes = [];
                }

                if(!angular.isArray(diasMes)){
                    diasMes = [diasMes];
                }

                for (var j = 0; j < diasMes.length; j++) {
                    var diaMes = diasMes[j].$;

                    self.txtDias += diaMes?.toString() || '';

                    if (j < diasMes.length - 1 && self.txtDias) {
                        self.txtDias += ",";
                    }
                }
            }

            var agendamentoMeses = agendamento.meses;
            var todoMes = undefined;

            if(agendamentoMeses.todosMeses !== undefined || !ObjectUtils.isEmpty(agendamentoMeses.todosMeses)){
                todoMes = agendamentoMeses.todosMeses.toString() ? true : false;
            }
            
            if(todoMes){
                todosMeses(true);
            }else{
                todosMeses(false);
                if(!ObjectUtils.isEmpty(agendamentoMeses.mes)){
                    for (var i = 0; i < agendamentoMeses.mes.length; i++) {
                        var mes = agendamentoMeses.mes[i].$;
                
                        switch(mes.toString()){
                            case "1":
                                self.chkJan = true;
                                break;
                            case "2":
                                self.chkFev = true;
                                break;
                            case "3":
                                self.chkMar = true;
                                break;
                            case "4":
                                self.chkAbr = true;
                                break;
                            case "5":
                                self.chkMai = true;
                                break;
                            case "6":
                                self.chkJun = true;
                                break;
                            case "7":
                                self.chkJul = true;
                                break;
                            case "8":
                                self.chkAgo = true;
                                break;
                            case "9":
                                self.chkSet = true;
                                break;
                            case "10":
                                self.chkOut = true;
                                break;
                            case "11":
                                self.chkNov = true;
                                break;
                            case "12":
                                self.chkDez = true;
                                break;
                        };
                    };
                }
                
            };
        };


        function getConfiguration(){

            var agendamento = {};
            agendamento.nuRfe = $wizard.context.NURFE;
            agendamento.sequencia = $wizard.context.SEQUENCIA;

            if(self.horasEnvio !== undefined){
                var hours = self.horasEnvio.toString();
                var horaString = hours.slice(0, 2);
                var minString = hours.slice(2);
                if (hours.indexOf(":") > -1) {
                    minString = hours.slice(hours.indexOf(":") + 1);
                }
                var horas = parseInt(horaString);
                var min = parseInt(minString);
                agendamento.hora = {
                    horas: horas,
                    min: min
                }
            }

            agendamento.dias = {};

            if (self.inputValue === 'rdTodoDia') {
                agendamento.dias.todoDia = true;
            } else if (self.inputValue === 'daysOfTheMonth') {
                self.enabledInput = true;
                var dias = self.txtDias.split(",");

                agendamento.dias.dia = [];
                for (var i = 0; i < dias.length; i++) {
                    agendamento.dias.dia.push({$:dias[i]});
                }
            } 
            else {
                agendamento.dias.semanal = true;
                agendamento.dias.dia = [];
                if (self.chkDom) {
                    agendamento.dias.dia.push({$:"1"});
                }

                if (self.chkSeg) {
                    agendamento.dias.dia.push({$:"2"});
                }

                if (self.chkTer) {
                    agendamento.dias.dia.push({$:"3"});
                }

                if (self.chkQua) {
                    agendamento.dias.dia.push({$:"4"});
                }

                if (self.chkQui) {
                    agendamento.dias.dia.push({$:"5"});
                }

                if (self.chkSex) {
                    agendamento.dias.dia.push({$:"6"});
                }

                if (self.chkSab) {
                    agendamento.dias.dia.push({$:"7"});
                }
            }

            agendamento.meses = {};

            if(self.chkTodos){
                agendamento.meses.todosMeses = true;
            }
            else{
                agendamento.meses.mes = [];
                if (self.chkJan) {
                    agendamento.meses.mes.push({$:"1"});
                }

                if (self.chkFev) {
                    agendamento.meses.mes.push({$:"2"});
                }

                if (self.chkMar) {
                    agendamento.meses.mes.push({$:"3"});
                }

                if (self.chkAbr) {
                    agendamento.meses.mes.push({$:"4"});
                }

                if (self.chkMai) {
                    agendamento.meses.mes.push({$:"5"});
                }

                if (self.chkJun) {
                    agendamento.meses.mes.push({$:"6"});
                }

                if (self.chkJul) {
                    agendamento.meses.mes.push({$:"7"});
                }

                if (self.chkAgo) {
                    agendamento.meses.mes.push({$:"8"});
                }

                if (self.chkSet) {
                    agendamento.meses.mes.push({$:"9"});
                }

                if (self.chkOut) {
                    agendamento.meses.mes.push({$:"10"});
                }

                if (self.chkNov) {
                    agendamento.meses.mes.push({$:"11"});
                }

                if (self.chkDez) {
                    agendamento.meses.mes.push({$:"12"});
                }
            }

            return agendamento;
        }

        
        function todosDias(valor){
            self.chkDom = valor;
            self.chkSeg = valor;
            self.chkTer = valor;
            self.chkQua = valor;
            self.chkQui = valor;
            self.chkSex = valor;
            self.chkSab = valor;
        }
        

        function todosMeses(valor) {
            self.chkTodos = valor; 
            self.chkJan = valor;
            self.chkFev = valor;
            self.chkMar = valor;
            self.chkAbr = valor;
            self.chkMai = valor;
            self.chkJun = valor;
            self.chkJul = valor;
            self.chkAgo = valor;
            self.chkSet = valor;
            self.chkOut = valor;
            self.chkNov = valor;
            self.chkDez = valor;
        }


        function validaChkMeses(){
            if (self.chkJan && 
                self.chkFev && 
                self.chkMar && 
                self.chkAbr && 
                self.chkMai && 
                self.chkJun && 
                self.chkJul && 
                self.chkAgo && 
                self.chkSet && 
                self.chkOut && 
                self.chkNov && 
                self.chkDez) {
                self.chkTodos = true;
            } else {
                self.chkTodos = false;
            }
        }
        

        function changeRadioSemana(){
            if(self.inputValue === "rdTodoDia"){
                self.chkDom = true;
                self.chkSeg = true;
                self.chkTer = true;
                self.chkQua = true;
                self.chkQui = true;
                self.chkSex = true;
                self.chkSab = true;
                self.todosDias(true);
                self.txtDias = "";
                self.enabledInput = false;
            }if(self.inputValue === "daysOfTheWeek"){
                self.todosDias(false);
                self.chkDom = false;
                self.chkSeg = false;
                self.chkTer = false;
                self.chkQua = false;
                self.chkQui = false;
                self.chkSex = false;
                self.chkSab = false;
                self.txtDias = "";
                self.enabledInput = false;
            }if(self.inputValue === "daysOfTheMonth"){
                self.todosDias(false);
                self.chkDom = false;
                self.chkSeg = false;
                self.chkTer = false;
                self.chkQua = false;
                self.chkQui = false;
                self.chkSex = false;
                self.chkSab = false;
                self.enabledInput = true;
            }
        }

        

        function changeRadioMes(){
            changeRadioSemana();
            self.enabledInput = true;
        }


    }]);

angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('StepDescriptionController', ['$scope', '$wizard', 'ObjectUtils', '$step', 'StringUtils','$rootScope', '$stepEventBus', 'SkI18nService', 'ServiceProxy',  function($scope, $wizard, ObjectUtils, $step, StringUtils, $rootScope, $stepEventBus, SkI18nService, ServiceProxy) {
        var self = this;
        var params = { param: {name: 'os.diretorio.modelos'}};

        $step.onExitStep = onExitStep;
        $step.setCanNext(false);
        self.buildToolTipMessage = buildToolTipMessage;
        buildToolTipMessage();

        $scope.validateBtnNext = function() {
            var enableNext = false;

            if(StringUtils.isNotEmpty(self.textDescricao)){
                enableNext = true;
            }

            $step.setCanNext(enableNext);
        }
        
        function buildToolTipMessage(){
            ServiceProxy.callService(
                'SystemUtilsSP.getMGECoreParameter', params, true).then(function(result){
                var helpMsg = SkI18nService.instant('Core.VisualizadorRelatorios.textPersonalizarModeloHelp');
                $scope.toolTipMessage = helpMsg + " " + SkI18nService.instant('Core.VisualizadorRelatorios.labelValorAtual') + ": " + result.responseBody.param.value;
                });
        }

        $stepEventBus.addEventListener('dataWizardChanged', function(newData){
            
            if(newData.novoAgendamento === false){
                $wizard.context = newData;
                self.textDescricao = newData.DESCRICAO;
                self.pesquisaUsuario = newData.CODUSU;
                self.pesquisaSmtp = newData.CODSMTP;
                if(newData.EMAILASSUNTO !== undefined || newData.EMAILMSG !== undefined){
                    self.textAssunto = newData.EMAILASSUNTO;
                    self.txaEmailMsg = newData.EMAILMSG;
                    self.emailManual = true;
                }else{
                    self.textModelo = newData.ARQMODEMAIL;
                    self.emailManual = false;
                }
                $step.setCanNext(true);
            }else{ 
                $wizard.context = {};
                self.textDescricao = "";
                self.pesquisaUsuario = "";
                self.pesquisaSmtp = "";
                self.textAssunto = "";
                self.txaEmailMsg = "";
                self.emailManual = false;
                $wizard.context = newData;
                $wizard.context.NURFE = newData.NURFE;
                $wizard.context.PARAMETROS = newData.PARAMETROS;
                $step.setCanNext(false);
            }            
            
        });

        function onExitStep() {
            $wizard.context.DESCRICAO = self.textDescricao;
            $wizard.context.CODUSU = self.pesquisaUsuario;
            $wizard.context.CODSMTP = self.pesquisaSmtp;
            if(self.emailManual) {
                $wizard.context.EMAILASSUNTO = self.textAssunto;
                $wizard.context.EMAILMSG = self.txaEmailMsg;
                $wizard.context.ARQMODEMAIL = null;
            }  else {
                $wizard.context.ARQMODEMAIL = self.textModelo;
                $wizard.context.EMAILASSUNTO = null;
                $wizard.context.EMAILMSG = null;
            }
        }

       
    }]);

angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('StepSelectedUserController', ['$wizard', 'ServiceProxy', '$step','StringUtils', 'ArrayUtils', 'ObjectUtils',
    function($wizard, ServiceProxy, $step, StringUtils, ArrayUtils, ObjectUtils) {
        var self = this;

        self.searchFilterFn = searchFilterFn;
        self.onSelectItem = onSelectItem;
        self.disabledTwoList = disabledTwoList;
        self.srcUserData = [];
        self.destUserData = [];
        $step.onExitStep = onExitStep;
        $step.init = init;
        $step.onEnterStep = onEnterStep;

        init();

        function init() {
            $step.setCanNext(false);

            var codUsuBase = angular.isDefined($wizard.context.codUsuarioBase) ? $wizard.context.codUsuarioBase : '';
            var request = {
                criterio: {
                   CODUSUBASE: codUsuBase
                }
            };

            ServiceProxy.callService('VisualizadorRelatorios.getDestinatarios', request)
            .then(function(result) {
                self.srcUserData = result.responseBody.destinatarios.destinatario;
                var isArray = Array.isArray(result.responseBody.destinatarios.destinatario);
                if(!isArray){
                    self.srcUserData = [result.responseBody.destinatarios.destinatario]
                }
            });
        }

        function onEnterStep(){
            if($wizard.context.getDest !== true){
                self.chkDestinatariosDinamicos = StringUtils.emptyAsNull($wizard.context.SQL) != null;
                if(self.chkDestinatariosDinamicos === false && $wizard.context.NURFE && $wizard.context.SEQUENCIA){
                    
                    var criterio = { NURFE: $wizard.context.NURFE, SEQUENCIA: $wizard.context.SEQUENCIA }
                    var request = {
                        criterio: criterio
                    }
                   
                    ServiceProxy.callService('VisualizadorRelatorios.getDestinatariosDefinidos', request)
                        .then(function(result) {

                        self.destUserData = result.responseBody.destinatarios.destinatario;
                        var isArray = Array.isArray(result.responseBody.destinatarios.destinatario);
                        if(!isArray){
                            self.destUserData = [result.responseBody.destinatarios.destinatario]
                        }

                        self.destUserData.forEach(function(dest){
                            for (var j = 0; j < self.srcUserData.length; j++) {
                                if(ObjectUtils.getProperty(dest, 'CODDEST.$') === ObjectUtils.getProperty(self.srcUserData, j + '.CODDEST.$')){
                                    ArrayUtils.removeAtIndex(self.srcUserData, j);
                                }
                            }
                        });
                        $step.setCanNext(true);
                        $wizard.context.getDest = true;
                    });
                }
                $step.setCanNext(true);
            }
            disabledTwoList();    
        }

        
        function onExitStep() {
            if(self.chkDestinatariosDinamicos){
                $wizard.context.DESTINATARIOS = self.chkDestinatariosDinamicos;
                $wizard.context.DESTINATARIO_DINAMICO = self.chkDestinatariosDinamicos;
            }else{
                $wizard.context.DESTINATARIOS = self.destUserData; 
                $wizard.context.DESTINATARIO_DINAMICO = self.chkDestinatariosDinamicos;				
            }
        }

        function searchFilterFn(item, search) {
            var containsRE = new RegExp(search,'i');
            var match = containsRE.test(ObjectUtils.getProperty(item, 'CODDEST.$')) || containsRE.test(ObjectUtils.getProperty(item, 'NOMEDEST.$'));
            return match;
        }


        function disabledTwoList(){
            if(self.chkDestinatariosDinamicos){
                for (var j = 0; j < self.destUserData.length; j++) {
                    self.srcUserData.push(self.destUserData[j]);
                }
                angular.element(document.getElementById('twoListVisualizadorRelatorios')).css('pointerEvents', 'none');
                angular.element(document.getElementById('twoListVisualizadorRelatorios')).css('opacity', '0.5');
                $step.setCanNext(true);
                self.destUserData = [];
            }else{
                angular.element(document.getElementById('twoListVisualizadorRelatorios')).css('pointerEvents', 'all');
                angular.element(document.getElementById('twoListVisualizadorRelatorios')).css('opacity', '1');
                $step.setCanNext(self.destUserData.length > 0);
            }          
        }

        function onSelectItem() {
            $step.setCanNext(self.destUserData.length > 0);
        }

    }]);
angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('StepValuesParametersController', ['MessageUtils', '$step', '$wizard','ServiceProxy', '$q', 'i18n','StringUtils','$rootScope', '$scope', '$timeout','ObjectUtils',
    function(MessageUtils, $step, $wizard, ServiceProxy, $q, i18n, StringUtils, $rootScope, $scope, $timeout, ObjectUtils) {
        var self = this;
    
        self.parametros = [];
        $step.onExitStep = onExitStep;
        $step.onEnterStep = onEnterStep;
        self.validarExpressao = validarExpressao;
        self.textAreaStyle= {
            'height' : '100%',
            'font-size' : '11px'
        }
        
        function onEnterStep() {
            $rootScope.$emit('finalizeStep', true);
            self.chkDinamicos = $wizard.context.DESTINATARIO_DINAMICO;
            self.sql = $wizard.context.SQL;

            self.parametros = $wizard.context.PARAMETROS.parametro;
            var isArray = Array.isArray(self.parametros);
            if(!isArray){
                self.parametros = [self.parametros]
            } 

            if(self.parametros.length > 0 && self.parametros[0] == undefined){
                self.parametros = [];
            }

            if(self.chkDinamicos){
                $step.setCanFinish(true);
            }else{
                for(var i = 0; i < self.parametros.length; i++){
                    if(ObjectUtils.getProperty(self.parametros, i + '.classe') === "java.sql.Timestamp"){
                        var dt = new Date(self.parametros[i].valor);
                        if(dt.toLocaleString().match("1969")){
                            self.parametros[i].valor = undefined;
                        }else{
                            self.parametros[i].valor = dt.toLocaleString();
                        }
                    }

                }
                if(self.parametros.length === 0){
                    $step.setCanFinish(true);
                }else{
                    $timeout(()=> $scope.validateBtnFinish());
                }
            }
        }

        $scope.validateBtnFinish = function(){
            
            var validadeIsNotEmpty = validadeIsRequerido = 0;
            
            for(var i = 0; i < self.parametros.length; i++){
                if(self.parametros[i] && self.parametros[i].requerido === "true"){
                    validadeIsRequerido++;
                    if(StringUtils.isNotEmpty(self.parametros[i].valor)){
                        validadeIsNotEmpty++; 
                    }
                }  
            }
            $step.setCanFinish(validadeIsNotEmpty === validadeIsRequerido);
        }

        function validarExpressao(){	
            if(self != null){
                var reportReqFields;
                for (var i = 0; i < self.parametros.length; i++) { 
                    if(reportReqFields == null) {
                        reportReqFields = self.parametros[i].nome;
                    } else {
                        reportReqFields += "," + self.parametros[i].nome;
                    }
                }
        
                var consulta = {
                    query: self.sql,
                    reportReqFields: reportReqFields
                };

                var param = {consulta: consulta}
 
            }

            ServiceProxy.callService(
                "VisualizadorRelatorios.resolverConsulta", param)
                    .then(function (response) {
                    MessageUtils.showInfo(i18n('Core.VisualizadorRelatorios.messageConsultaValidadaSucesso'));
                });
        }
        
        function onExitStep() {
            if(!self.chkDinamicos){
                $wizard.context.PARAMETROS.parametro = self.parametros;
                $step.wizardContext = $wizard.context
            }else{
                $wizard.context.SQL = self.sql;
                if(self.parametros !== null){
				    var camposObrigatorios = {
                            parametro: self.parametros
                        };
					$wizard.context.CAMPOS_OBRIGATORIOS = camposObrigatorios;;
                }
                $step.wizardContext = $wizard.context;
            }     
        }


        self.onDsDetalhesCreated = function (dataset) {
            self.dsDetalhes = dataset;
            dataset.initAndRefresh();
		}

        self.refreshHandlerDsDetalhes = function(request){
            return $q(function(resolve, reject) {                
                var rows = [];
                rows.push([ i18n('Core.VisualizadorRelatorios.labelDestinatarios') , "CODCON ou EMAIL" ]);
                var isArray = Array.isArray(self.parametros);
                if(!isArray){
                    self.parametros = [self.parametros]
                }
                if(self.parametros.length > 0 && self.parametros[0] !== undefined){
                    self.parametros.forEach(function(row){
                        let descricao = row.parametro?.descricao || row.descricao;
                        let nome = row.parametro?.nome || row.nome;
                        rows.push([ descricao  , nome ]);
                    });
                };

                resolve(rows);
            })   
        }

        
    }]);
angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('PopUpAdicionarLancadorController', ['i18n', 'data', 'ServiceProxy', 'ObjectUtils', '$scope', '$popupInstance', 'MessageUtils',
        function (i18n, data, ServiceProxy, ObjectUtils, $scope, $popupInstance, MessageUtils) {
            var self = this;

            $scope.$success = save;

            self.treeSelectedItem = treeSelectedItem;

            var _branch = undefined;

            var _showAccessInfo = false;

            init()

            function init() {

                if (angular.isDefined(data.showAccessInfo)) {
                    _showAccessInfo = data.showAccessInfo;
                }
                mostrarPopUpMenu();
            }

            function mostrarPopUpMenu() {
                ServiceProxy
                    .callService('ConfiguracaoMenuSP.montarMenu', {
                        param: {
                            somentePastas: 'true',
                            somenteAtivos: 'true'
                        }
                    })
                    .then(function (response) {
                        self.tree = ObjectUtils.getProperty(response, 'responseBody.menus.menuAtivo.item');
                    });
            }


            function save() {
                if (angular.isUndefined(_branch) || angular.isUndefined(self.descLancador)) {
                    MessageUtils.showError(i18n('Geral.msgtitleErro'), i18n('Commons.VisualizadorRelatoriosBase.messageInformarDescDir'));
                } else {
                    var source = {
                        item: {
                            nuControlePai: _branch.nuControle,
                            descricao: self.descLancador,
                            itemTipo: 'L',
                            params: {
                                tipoLancador: data.propertyGetter('tipoLancador'),
                                atributo: data.propertyGetter('chave'),
                                getTipoRel: data.propertyGetter('getTipoRel')
                            }
                        }
                    }
                    ServiceProxy.callService(
                        'ConfiguracaoMenuSP.incluirAlterarItemMenu',
                        source)
                        .then(function (response) {

                            if (_showAccessInfo) {
                                MessageUtils.showInfo(i18n('Commons.VisualizadorRelatoriosBase.infoSuccessRelatorio', [ObjectUtils.getProperty(response, 'responseBody.caminhoLancador')]));
                            }
                            self.descLancador = undefined;
                            
                            $popupInstance.success();
                        });
                }
            }

            function treeSelectedItem(branch) {
                _branch = branch;
            }

        }]);
angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('PopUpLocalizarLancadorController', ['i18n', 'data', 'ServiceProxy', 'ObjectUtils', '$scope', '$popupInstance', 'MessageUtils', 'SkApplicationInstance', 'ArrayUtils','StringUtils',
        function (i18n, data, ServiceProxy, ObjectUtils, $scope, $popupInstance, MessageUtils, SkApplicationInstance, ArrayUtils,StringUtils) {
            var self = this;

            $scope.$success = save;


            //Variaveis disponiveis no controller
            self.tooltipExcluir = i18n('Navigator.lblExcluir')
            self.tooltipSalvar = i18n('Navigator.lblSalvar')
            self.tooltipDescartar = i18n('Navigator.lblDescartar')
            self.lblDescartar = i18n('Geral.lblDescartar')
            self.lbldescricao = i18n('Geral.lblDescricao');
            self.lancador = [];
            self.btnCancelEnabled = true;
            self.btnSaveEnabled = true;
            self.selectedIndex = 1;

            //função disponiveis no controller
            self.remove = remove;
            self.save = save;
            self.openApp = openApp;
            self.habiliarEdicao = habiliarEdicao;
            self.selectPath = selectPath;


            var _descricao;
            var _index;
            var _lancador;

            init();

            function init() {
                carregaList();
            }

            function save() {
                if(StringUtils.emptyAsUndefined(self.descricao) != undefined){
					//var nuControle:String = ds.getFieldValueAsString("NUCONTROLE");
					var source = {
                        item :{
                        nuControle : self.lancador[0].nuControle,
                        descricao : self.descricao				
                        }
                    };    
				
					ServiceProxy.callService('ConfiguracaoMenuSP.alterarDescricaoMenu',source)
                    .then(function(response){
                         var _path = ObjectUtils.getProperty(response, 'responseBody.controle.path');


                    });
				}else if(StringUtils.emptyAsUndefined(self.descricao) == undefined){
				 	MessageUtils.showError(i18n('Commons.VisualizadorRelatoriosBase.erroInformeDescParaoItem'));	
				 	//descLancador.setFocus();	
				 }//else if(angular.isDefined(self.descLancador) && ds.getCurrentRow() == null){
				// 	MessageUtils.showError(i18n('Commons.VisualizadorRelatoriosBase.erroSelecioneUmLancador'));	
				// }


                $popupInstance.success();
            }

            function selectPath(lancador) {
                _lancador = lancador;
                _descricao = lancador.descricao;
                self.descricao = _descricao;
            }

            function habiliarEdicao(condicao) {
                self.btnCancelEnabled = condicao;
                self.btnSaveEnabled = condicao;

                if (condicao) {
                    self.descricao = _descricao;
                }
            }

            function carregaList() {

                ServiceProxy.callService('ConfiguracaoMenuSP.getLocalizacaoLancador', {
                    params: {
                        atributo: data.propertyGetter('chave'),
                        tipoLancador: data.propertyGetter('tipoLancador'),
                        getTipoRel: data.propertyGetter('getTipoRel')
                    }

                }).then(function (response) {
                    var result = ObjectUtils.getProperty(response, 'responseBody.controle');
                    if (angular.isDefined(result)) {
                        self.lancador = result;
                        self.descricao = self.lancador[0].descricao;
                        self.selectedIndex = self.lancador.length > 0 ? 0 : 1;
                    }
                });

            }

            function remove() {
                MessageUtils
                    .simpleConfirm(i18n('Commons.VisualizadorRelatoriosBase.titleExcluirLancador'), i18n('Commons.VisualizadorRelatoriosBase.alertaExcluirLancador'))
                    .then(function () {
                        //var _nuControle:String = ds.getFieldValueAsString("NUCONTROLE");
                        ServiceProxy.callService('ConfiguracaoMenuSP.removerItem', {
                            item: {
                                nuControle: self.lancador[0].nuControle
                            }
                        })
                         .then(function (result) {
                                $popupInstance.dismiss();
                                ArrayUtils.removeReference(self.lancador, _lancador);
                                if (self.lancador.length == 0) {
                                    self.selectedIndex = 1
                                }

                            });
                    });
               
            }

            function openApp(resourceID) {
                SkApplicationInstance.openApp(resourceID);
            }

        }]);

angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .controller('PopUpVisualizarRelatorioController', ['data', 'ServiceProxy','UserAgentUtils', 'MGEParameters','SkWorkspace', 'SkApplication', '$popupInstance', '$q', 'ObjectUtils','DateUtils','DateUtilsConstants', 'MessageUtils', 'i18n',
        function (data, ServiceProxy, UserAgentUtils, MGEParameters, SkWorkspace, SkApplication, $popupInstance, $q, ObjectUtils,DateUtils,DateUtilsConstants, MessageUtils, i18n) {
            
            var self = this;
            self.parametros = [];
            self.cancel = cancel;
            self.visualizarRelatorio = visualizarRelatorio;
            self.environmentCriteria=environmentCriteria;
            
            createParametersPanel()

            function createParametersPanel(){
                var numeroRel = data.numeroRelatorio;
                var request = {
                        relatorio: {
                            nuRfe : numeroRel
                    }
                };

                ServiceProxy.callService('mge@VisualizadorRelatorios.requisitarParametros', request) 
                .then(function(result) {
                    let hasParameters;

                    var isArray = Array.isArray(result.responseBody.parametros.parametro);
					if(!isArray){
                        if(result.responseBody.parametros.parametro === undefined){
                            self.parametros.length === 0;
                            visualizarRelatorio(result.responseBody.parametros);
                            cancel();
                        }else{
                            self.parametros = [result.responseBody.parametros.parametro];
                            hasParameters = true;
                        }
					}else{
                        self.parametros = result.responseBody.parametros.parametro;
                        hasParameters = true
                    }

                    if (hasParameters) {
                        for(var i = 0; i < self.parametros.length; i++){
                            if(ObjectUtils.getProperty(self.parametros, i + '.classe') === "java.sql.Timestamp"){
                                var dt = new Date(self.parametros[i].valor);
                                if(dt.toLocaleString().match("1969")){
                                    self.parametros[i].valor = undefined;
                                }else{
                                    self.parametros[i].valor = dt.toLocaleString();
                                }
                            }
        
                        }
                    }

                }).catch(function errorCallback(response) {
                    setTimeout(function() {
                        $popupInstance.dismiss('canceled');
                    });
                    
                    //using setTimeout moves the actual throwingout of the
                    // promise chain. It's kind of a hack!
                    return $q.reject(response) //reReject the error, so the rest
                    // of the chain knows there is something wrong
                });
            }

            function environmentCriteria(expressao){
                criteria = new Criteria(expressao);
                return criteria;
            }

            function cancel(){
                $popupInstance.dismiss('canceled');
            }

            function visualizarRelatorio(parametro){
                let campos = copyParametros(parametro);

                if (existeCamposObrigatoriosNaoPreenchidos(campos)) {
                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.VisualizadorRelatoriosBase.messagePreenchaParametrosObrigatorios') + i18n('Controls.ReportManager.messageParametroNaoPreenchido'));
                    return;
                }

                if(campos && angular.isArray(campos)){
                    for(var i=0; i < campos.length; i++){
                        var param = campos[i];

                        if(param.classe === 'java.sql.Timestamp'){
                            if(param.valor){
                                param.valor = DateUtils.formatDate(param.valor, DateUtilsConstants.DEFAULT_DATE_FORMAT)
                            }
                        }
                    }                  
                }

                var request ={
                    relatorio: {
                        nuRfe: data.numeroRelatorio,
                        parametros: {parametro: campos}
                    },
                }

                ServiceProxy.callService('mge@VisualizadorRelatorios.visualizarRelatorio', request)
                .then(function(result) {
                    
                    var chave = result.responseBody.chave.valor;
                    var permiteExportar = result.responseBody.chave.permiteExportar;

                    var filePDF = false;
                    var fileJasper = false;

                    if(result.responseBody.chave.contentType != null){
                    	filePDF = "application/pdf" == result.responseBody.chave.contentType;
                    	fileJasper 	= "application/octet-stream" == result.responseBody.chave.contentType && "P" == result.responseBody.chave.format;
                    }

                    if (UserAgentUtils.isElectron() && MGEParameters.asBoolean("global.usa.app.impressao") && (filePDF || fileJasper)) {
                        SkApplication.instance().openWindow('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave, '_blank');
                    } else if(permiteExportar || !MGEParameters.asBoolean("global.usa.app.impressao")) {
                    	SkApplication.instance().openWindow('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave, '_blank');
                    } else {
                    	SkWorkspace.downloadFile(window.serverAddress, chave, extension);
                    }
                });
            };

            function existeCamposObrigatoriosNaoPreenchidos(campos) {
                let retorno = true;

                if(campos) {
                    if (!angular.isArray(campos)) {
                        campos = [campos];
                    }

                    const camposObrigatoriosNaoPreenchidos = campos.filter(function(campo) {
                        return campo.requerido === 'true' && angular.isUndefined(campo.valor);
                    });

                    retorno = camposObrigatoriosNaoPreenchidos.length > 0;
                }

                return retorno;
            }

            function copyParametros(parametros) {
                var isArray = Array.isArray(parametros);
                if (isArray){
                    
                    let copiedParams = parametros.map(function(parametro) {
                        const row = Object.assign({}, parametro);
                        return row;
                    });

                    return copiedParams;
                }else{
                    return parametros;
                }
            }

        }
    ]);
angular
    .module('snk.commons.visualizadorRelatoriosBase')
    .component('skVisualizadorRelatoriosBase', {
        templateUrl: 'commons/visualizadorRelatoriosBase/visualizadorRelatoriosBase.tpl.html',
        controller: 'SkVisualizadorRelatoriosBaseController',
        bindings: {
            onCreated: '&?skOnCreated',
            tipoRelatorio: '@skTipoRelatorio',
            abasAdicionais: '=?skAbasAdicionais',
            showTelaPersonalizada: '=?skShowTelaPersonalizada',
            showFormatoImpressao: '=?skShowFormatoImpressao',
            showOutrasOpcoes: '=?skShowOutrasOpcoes',
            appName: '@?skAppName',
            otherOptionsLayout: '=?otherOptionsLayout',
            otherOptionsLabel: '@otherOptionsLabel',
            nomeImpressora: '=?nomeImpressora'
        }
    })
    .controller('SkVisualizadorRelatoriosBaseController', ['$element', '$attrs', 'DateBuilder', 'DateUtils', 'DateUtilsConstants', 'SanPopup', 'MessageUtils', 'MGEAuthorizationConstants', 'SkApplicationInstance', 'ObjectUtils', 'Criteria', 'ServiceProxy', 'i18n', 'GridConfig', 'DoubleFacePanelConstants', 'StringUtils', '$timeout', 'SkApplication', 'SkI18nService', 'SkDefaultFilter', '$scope', 'MGEParameters', 'UserAgentUtils', 'SolucoesStoreService',
        function($element, $attrs, DateBuilder, DateUtils, DateUtilsConstants, SanPopup, MessageUtils, MGEAuthorizationConstants, SkApplicationInstance, ObjectUtils, Criteria, ServiceProxy, i18n, GridConfig, DoubleFacePanelConstants, StringUtils, $timeout, SkApplication, SkI18nService, SkDefaultFilter, $scope, MGEParameters, UserAgentUtils, SolucoesStoreService) {
            var self = this;

            //Implementors
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IFilterPanelInterceptor);
            ObjectUtils.implements(self, IDataSetObserver);

            //Variaveis contastes;
            var RELATORIO_USUARIO = 'RU';
            var CARTA_COBRANCA = 'CC';
            var CHEQUE = 'CH';
            var BOLETO = 'BL';
            var NOTAS_PEDIDOS = 'NP';
            var COPIA_ESTOQUE = 'CE';
            var MODELO_ETIQUETA = 'ME';
            var SEM_CATEGORIA_LABEL = '<Sem Categoria>';

            //Variaveis privadas
            var _tipoRelatorio;
            var _canInsert;
            var _externalCallbackName;
            var _lblDtHora;

            var _defaultFilterAssistent;
            var btnDefaultFilterElem;
            var _defaultFilterPF;
            //Dataset
            self.dsRelatorio;
            self.dsArquivoRelatorio;

            //DataGrid
            self.dataGridRelatorio;
            self.dataArquivoRelatorio;

            //Variaveis disponiveis no controller
            self.codigoRelatorio;
            self.options = getDefaultOptionOfCheckList();
            self.inputDescricao;
            self.textCategoria;
            self.dateDhAlter;
            self.pesqInstancia;
            self.showTelaPersonalizada = true;
            self.descricaoRelatorio;
            self.buttonAdicionarArquivo = true;
            self.buttonAgendarRelatorio = true;
            self.btnFiltroInstancia = true;
            self.changeHelpTipVisibility = false;

            self.txtOptionsLayout;  
            self.txtOutrasOpcoes = "Outras Opções...";

            self.modeloPadrao;          

            self.openAjudanteExpressao = openAjudanteExpressao;
            $scope.isFilterDefaultActive = isFilterDefaultActive;
            self.getDefaultFilterAsCriteria = getDefaultFilterAsCriteria;
            self.getNomeInstancia = getNomeInstancia;
            self.marginHelper = "0px";
            self.showBtnLayout = $attrs.hasOwnProperty('otherOptionsLayout');


            //Implementações da interface IFilterPanelInterceptor
            self.clearFilter = clearFilter;

            self.changeButtonActionsRelatorios = [
                {
                    label: i18n('Controls.GridConfig.buttonGridConfig'), action: openGridConfigRelatorio
                }
            ];
            self.changeButtonActionsArquivoRelatorio = [
                {
                    label: i18n('Controls.GridConfig.buttonGridConfig'), action: openGridConfigArquivoRelatorio
                }
            ];

            //Funções disponiveis no controller
            self.$onInit = $onInit;
            self.onDatasetCreated = onDatasetCreated;
            self.apply = apply;
            self.getCriteriaPesquisa = getCriteriaPesquisa;
            self.onKeydown = onKeydown;
            self.visualizarRelatorio = visualizarRelatorio;
            self.agendarRelatorios = agendarRelatorios;
            self.otherOptionsLoader = otherOptionsLoader;
            self.abrirPlace = abrirPlace;
            self.getEnvironmentCriteria = getEnvironmentCriteria;
            self.openFormatoHelp = openFormatoHelp;
            self.onDoubleFacePanelCreated = onDoubleFacePanelCreated;
            self.fileUpload = fileUpload;
            self.download = download;
            self.saveHandler = saveHandler;
            self.changeLayout = changeLayout;
            self.visivel = visivel;
            self.getDatasetRelatorio = getDatasetRelatorio;

            // Implementações da interface IDatagridInterceptor
            self.onDatagridLoaded = onDatagridLoaded;
            self.onDblClickGrid = onDblClickGrid;
            self.interceptColumnMetadata = interceptColumnMetadata;

            // Implementações da interface IDataSetObserver
            self.currentLineChanged = currentLineChangedImpl;

            function $onInit() {

                $element.attr('layout', 'column');
                $element.attr('flex', '');

                _showTelaPersonalizada = self.showTelaPersonalizada;
                _showFormatoImpressao = self.showFormatoImpressao;
                _tipoRelatorio = self.tipoRelatorio;
                self.btnBoleto = _tipoRelatorio == BOLETO;
                self.resourceID = SkApplicationInstance.getResourceID();
                self.abasAdicionais = self.abasAdicionais;

                self.gridConfigRelatorio = self.resourceID + '.relatorio';
                self.gridConfigArquivoRelatorio = self.resourceID + '.arquivoRelatorio';
                self.language = SkI18nService.getLang();

                GridConfig.registerGridConfig(self.gridConfigRelatorio, self.gridConfigRelatorio, undefined, true);
                GridConfig.registerGridConfig(self.gridConfigArquivoRelatorio, self.gridConfigArquivoRelatorio, undefined, true);


                _externalCallbackName = "loadArquivo_" + StringUtils.nextUid().replace(/\./g, "_");

                SkApplicationInstance.registerExternalCall(_externalCallbackName, function() {
                    self.dsArquivoRelatorio.refresh();
                });
                
                if(_tipoRelatorio == NOTAS_PEDIDOS){
                	self.txtOptionsLayout = "Baixar Modelos Padrões";
                }else if(_tipoRelatorio == BOLETO){
                	self.txtOptionsLayout = "Baixar Modelo Padrão";
                    self.modeloPadraoAction = self.otherOptionsLayout()[0].action;
                }else{
                	self.txtOptionsLayout = "Layout";
                }              
                
                carregarCategorias();
            }

            $scope.buildOptions = () => {
                return [
                    {
                        label: i18n("Commons.VisualizadorRelatoriosBase.lblSolucaoPlace"),
                        action: () => {
                            SolucoesStoreService.openPopUp('RELATORIO_IREPORT');
                        },
                        default: true
                    },
                    {
                        label: i18n("Commons.VisualizadorRelatoriosBase.lblNovaSolucao"),
                        action: () => {
                            self.dsRelatorio.goToInsertionMode();
                        },
                    }
                ];
            };

            $scope.ehTelaCadastroRelatorio = () => {
                return _tipoRelatorio === 'RU';
            }

            function visivel() {
                if (MGEParameters.asInteger('mge.core.habilita.tela.html5') === 1) {
                    return true;
                } else {
                    return false;
                }
            }

            function clearFilter() {
                self.codigoRelatorio = undefined;
                self.descricaoRelatorio = undefined;
                self.nomeArquivoRelatorio = undefined;
            }

            function onDatasetCreated(dataset) {

                if (dataset.getEntityName() == 'Relatorio') {
                    self.dsRelatorio = dataset;

                    self.dsRelatorio.makeFieldNonRequired('Usuario.NOMEUSU');
                    self.dsRelatorio.makeFieldNonRequired('CODUSU');
                    self.dsRelatorio.makeFieldNonRequired('DHALTER');
                    changeHelpTipVisibility();

                    

                    var criteriaProvider = new CriteriaProvider();

                    criteriaProvider.getCriteria = getCriteria;
                    dataset.addCriteriaProvider(criteriaProvider);

                    self.dsRelatorio.addLineChangeListener(function() {
                        self.buttonAdicionarArquivo = !self.dsRelatorio.size() > 0;
                        updateStatusInstanciaFilter();
                        currentLineChangedImpl();
                        changeHelpTipVisibility();
                    });

                    self.dsRelatorio.addDataModifiedListener(function() {
                        if (self.dsRelatorio.getFieldValue('NUINSTANCIA') == undefined) {
                            self.dsRelatorio.setFieldValue('EXPFILTROINSTANCIA', undefined);
                        }
                        changeHelpTipVisibility();
                        updateStatusInstanciaFilter();
                    });

                    self.dsRelatorio.addInsertionModeListener(function() {
                        if(!$scope.ehTelaCadastroRelatorio()){
                            SolucoesStoreService.openPopUp('RELATORIO_IREPORT');
                        }
                        updateStatusInstanciaFilter();
                        self.buttonAdicionarArquivo = true;
                    });

                    self.dsRelatorio.beforeCopyAction(function () {

                        if (self.dsArquivoRelatorio.size() === 0)
                                return true;

                        var params = {}
                            params.arquivo = {
                                nuRfe: self.dsRelatorio.getFieldValue("NURFE")
                        };

                        ServiceProxy.callService("VisualizadorRelatorios.checkIfSomeReportIsProtected", params)
                            .then(function(result) {

                                var protegido = StringUtils.toBoolean(result.responseBody.protegido.valor);

                                if (protegido) {
                                    MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.VisualizadorRelatoriosBase.msgSolucaoProtegida'));
                                }
                                else {

                                    var currentRow = self.dsRelatorio.getCurrentRowAsObject();

                                    if (angular.isDefined(currentRow)) {
                                        self.dsRelatorio.goToInsertionMode().then(() => {

                                            for (var fieldFromCol of self.dsRelatorio.getFieldsMetadata()) {

                                                var id = fieldFromCol.id;

                                                if (!angular.isDefined(currentRow[id])) {
                                                    continue;
                                                }

                                                var fieldIsPk = self.dsRelatorio.getPrimaryKeys().find((primaryKey) => {
                                                    return primaryKey === id;
                                                });
                                                var value = fieldIsPk ? null : currentRow[id];
                                                self.dsRelatorio.setFieldValue(id, value);
                                            }
                                        });
                                    }
                                }
                        });
                    return false;
					});

                    let observer = new IDataSetObserver();

                    observer.recordRemoved = function(record) {
                        localizarERemoverLancadorExistente(record);
                    }

                    self.dsRelatorio.addObserver(observer);
                    
                    self.dsRelatorio.readAuthorizarionData(SkApplicationInstance.getAuthorizationData());
                                       

                } else if (dataset.getEntityName() == 'ArquivoRelatorio') {
                    self.dsArquivoRelatorio = dataset;

                    self.dsArquivoRelatorio.readAuthorizarionData(SkApplicationInstance.getAuthorizationData());

                    self.dsArquivoRelatorio.canEdit = SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_UPDATE);

                    _canInsert = SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_INSERT);

                    self.dsArquivoRelatorio.canRemove = SkApplicationInstance.hasAuthorization(MGEAuthorizationConstants.ACCESS_CONTROL_REMOVE);

                    self.dsArquivoRelatorio.addLineChangeListener(function() {
                        self.buttonAgendarRelatorio = !self.dsArquivoRelatorio.size() > 0;
                        self.buttonRelatorio = self.dsArquivoRelatorio.getFieldValue('SEQUENCIA') == undefined;
                    });

                    self.dsArquivoRelatorio.addInsertionModeListener(function() {
                        self.buttonRelatorio = true;
                    });

                    self.dsArquivoRelatorio.addDataSavedListener(function() {
                        self.buttonRelatorio = self.dsArquivoRelatorio.getFieldValue('SEQUENCIA') == undefined;
                    });

                }

                dataset.initializeDataSet();
                if(MGEParameters.asBoolean('global.carregar.registros.iniciar.tela') === true) {
					dataset.refresh();
				}
                
                if(angular.isFunction(self.onCreated)) {
                    self.onCreated({relatorio : self});
                }
            }

            function onDatagridLoaded(datagrid) {
                if (datagrid.getDataset().getEntityName() == 'Relatorio') {
                    self.dataGridRelatorio = datagrid;

                } else if (datagrid.getDataset().getEntityName() == 'ArquivoRelatorio') {
                    self.dataArquivoRelatorio = datagrid;
                }

            }

            function changeHelpTipVisibility() {
                if (self.dsRelatorio.getFieldValue('FORMATO')) {
                    if (self.dsRelatorio.getFieldValueAsString('FORMATO') == "W") {
                        self.helpTipVisibility = true;
                        self.marginHelper = "8px"
                    } else {
                        self.helpTipVisibility = false;
                        self.marginHelper = "0px"
                    }
                }
            }

            function saveHandler() {
                if (self.dsRelatorio.isInsertionMode()) {
                    self.dsRelatorio.setFieldValue('TIPO', _tipoRelatorio);
                }

                self.dsRelatorio.save().then(carregarCategorias);
            }

            function apply() {
                self.dsRelatorio.refresh();
            }

            function getCriteriaPesquisa() {
                return Criteria("this.TIPO = '" + _tipoRelatorio + "'");
            }

            function onKeydown($event) {
                if ($event.keyCode == 13) {
                    apply();
                }
            }

            function carregarCategorias() {

                ServiceProxy
                    .callService('DynaRelatorioBuilderSP.getRelatorioCategories', {
                        param: {
                            tipoRel: _tipoRelatorio
                        }
                    })
                    .then(function(response) {
                        var categorias = ObjectUtils.getProperty(response, 'responseBody.categorias.categoria');
                        self.options = getDefaultOptionOfCheckList();
                        if (categorias) {
                            categorias = angular.isArray(categorias) ? categorias : [categorias]
                            categorias.forEach(function (item) {
                                self.options.push(
                                    {
                                        data: item.$,
                                        value: item.$,
                                        checked: true
                                    }
                                );
                            }, this);
                        }
                    });
            }

            function openGridConfigRelatorio() {
                GridConfig.openGridconfig(self.gridConfigRelatorio);
            }

            function openGridConfigArquivoRelatorio() {
                GridConfig.openGridconfig(self.gridConfigArquivoRelatorio);
            }

            function visualizarRelatorio() {
                var _numeroRelatorio = self.dsRelatorio.getFieldValueAsNumber("NURFE");

                SanPopup.open({
                    title: i18n('Commons.VisualizadorRelatoriosBase.titleParametrosRelatorio', [self.dsRelatorio.getFieldValue('DESCRICAO')]),
                    templateUrl: 'commons/visualizadorRelatoriosBase/popup/PopUpVisualizarRelatorio/PopUpVisualizarRelatorio.tpl.html',
                    controller: 'PopUpVisualizarRelatorioController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    showBtnOk: false,
                    showBtnCancel: false,
                    resolve: {
                        data: {
                            numeroRelatorio: _numeroRelatorio
                        }
                    }
                });
            }

            function agendarRelatorios() {

                var _numeroRelatorio = self.dsRelatorio.getFieldValueAsNumber('NURFE');

                ServiceProxy
                    .callService('VisualizadorRelatorios.getDthoraServidor', {
                        param: {
                            dtHoraServer: undefined
                        }
                    })
                    .then(function(response) {
                        var dtHoraServer = ObjectUtils.getProperty(response, 'responseBody.dtHoraServer.$');
                        if (dtHoraServer) {
                            _lblDtHora = '<label style="padding-right: 11px;margin-top: 9px;">'
                                + i18n('Commons.VisualizadorRelatoriosBase.labelHoraLocal') + ': '
                                + DateUtils.formatDate(DateBuilder().toDate(), DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS)
                                + '</label>'
                                + '<label>'
                                + i18n('Commons.VisualizadorRelatoriosBase.labelHoraServidor') + ': ' + dtHoraServer
                                + '</label>';
                        }
                        SanPopup.open({
                            title: i18n('Commons.VisualizadorRelatoriosBase.titleAgendamentoRelatorios', [self.dsRelatorio.getFieldValue('DESCRICAO')]),
                            templateUrl: 'commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/AgendadorRelatoriosPopUp.tpl.html',
                            controller: 'AgendadorRelatoriosPopUpController',
                            controllerAs: 'ctrl',
                            size: 'lg',
                            cancelBtnLabel: i18n('Geral.buttonFechar'),
                            showBtnOk: false,
                            leftBottomBar: [_lblDtHora],
                            resolve: {
                                data: {
                                    numeroRelatorio: _numeroRelatorio
                                }
                            }
                        });
                    });

            }

            function getDatasetRelatorio(){
                return self.dsRelatorio;
            }

            function otherOptionsLoader() {
                var options = [
                    { label: i18n('Commons.VisualizadorRelatoriosBase.labelAdicionarLancador'), action: adicionarLancador, 'group': i18n('Commons.VisualizadorRelatoriosBase.lblLancador') },
                    { label: i18n('Commons.VisualizadorRelatoriosBase.labelLocalizarLancador'), action: localizarLancador, 'group': i18n('Commons.VisualizadorRelatoriosBase.lblLancador') },
                    { label: i18n('Commons.VisualizadorRelatoriosBase.lblExportarMetadados'),   action: exportarMetadados, 'group': i18n('Commons.VisualizadorRelatoriosBase.lblMetadados') }
                ];
                return options;
            }


            function pg(propertyName) {
                if (propertyName == 'descricao') {
                    return self.dsRelatorio.getFieldValueAsString('DESCRICAO');
                } else if (propertyName == 'chave') {
                    return self.dsRelatorio.getFieldValueAsString('NURFE');
                } else if (propertyName == 'tipoLancador') {
                    return 'RP';
                }
                return "";
            };

            function adicionarLancador() {
                SanPopup.open({

                    title: i18n('Commons.VisualizadorRelatoriosBase.titleCriarLancadorPara', [self.dsRelatorio.getFieldValueAsString('DESCRICAO')]),
                    templateUrl: 'commons/visualizadorRelatoriosBase/popup/PopUpAdicionarLancador/PopUpAdicionarLancador.tpl.html',
                    controller: 'PopUpAdicionarLancadorController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    okBtnLabel: i18n('Geral.lblConcluir'),
                    grayBG: true,
                    resolve: {
                        data: {
                            propertyGetter: pg
                        }
                    }
                });
            }

            function localizarLancador() {
                SanPopup.open({

                    title: i18n('Commons.VisualizadorRelatoriosBase.labelLocalizarLancador'),
                    templateUrl: 'commons/visualizadorRelatoriosBase/popup/PopUpLocalizarLancador/PopUpLocalizarLancador.tpl.html',
                    controller: 'PopUpLocalizarLancadorController',
                    controllerAs: 'ctrl',
                    size: 'md',
                    showBtnOk: false,
                    cancelBtnLabel: i18n('Geral.buttonFechar'),
                    resolve: {
                        data: {
                            propertyGetter: pg
                        }
                    }
                });

            }

            function exportarMetadados() {

                if ((!angular.isDefined(self.dsRelatorio)) || (!angular.isDefined(self.dsRelatorio.getFieldValue('NURFE')))){
            		MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.VisualizadorRelatoriosBase.msgNenhumRegistroSelecionado'));
            		return;
            	}

                var params = {}
                params.arquivo = {
                    nuRfe: self.dsRelatorio.getFieldValue("NURFE")
                };

                ServiceProxy.callService("VisualizadorRelatorios.checkIfSomeReportIsProtected", params)
                    .then(function(result) {

                        var protegido = StringUtils.toBoolean(result.responseBody.protegido.valor);

                        if (protegido) {
                           MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.VisualizadorRelatoriosBase.msgSolucaoProtegida'));
                        }
                        else {
                            ServiceProxy.callService("VisualizadorRelatorios.exportarMetadados", params)
                            .then(function(result) {
                                var chave = result.responseBody.chave.valor;
                                SkApplication.instance().openWindow('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave);
                            });
                        }
                });
            }

            function abrirPlace() {

                if (_tipoRelatorio == RELATORIO_USUARIO) {
                    return '#s:tipireports?filtro=I';
                }

                if (_tipoRelatorio == CHEQUE) {
                    return '#s:tipireports?filtro=H';
                }

                if (_tipoRelatorio == BOLETO) {
                    return '#s:tipireports?filtro=G';
                }

                if (_tipoRelatorio == COPIA_ESTOQUE) {
                    return '#s:tipireports?filtro=J';
                }

                if (_tipoRelatorio == CARTA_COBRANCA) {
                    return '#s:tipireports?filtro=X';
                }

                if (_tipoRelatorio == MODELO_ETIQUETA) {
                    return '#s:tipireports?filtro=W';
                }

                if (_tipoRelatorio == NOTAS_PEDIDOS) {
                    return '#s:tipnotaseletronicas';
                }
            }

            function getEnvironmentCriteria() {
                var criteria = Criteria();

                criteria.append('not (this.NOMETAB like ?', Criteria.buildStringParameter('TDD%'));
                criteria.or('this.NOMETAB like ?)', Criteria.buildStringParameter('TRD%'));

                return criteria;
            }

            function openFormatoHelp() {
                var url = '/mge/skwajuda.launcher?locale=' + self.language + '&resourceID=' + self.resourceID;
                AppletCaller.infoPopUp(url, 1000, 700);
            }

            function onDoubleFacePanelCreated(dblFacePanel) {
                if (dblFacePanel) {
                    self[dblFacePanel.id] = dblFacePanel;
                }
            }


            function interceptColumnMetadata(fieldMetadata, dataset) {
                if (dataset.getEntityName() == 'Relatorio') {
                    if ('NURFE' == fieldMetadata.name) {
                        fieldMetadata.description = i18n('Commons.VisualizadorRelatoriosBase.headerRelatorio');
                    } else if ('DESCRICAO' == fieldMetadata.name) {
                        fieldMetadata.description = i18n('Commons.VisualizadorRelatoriosBase.headerNomeRelatorio');
                    } else if ('CATEGORIA' == fieldMetadata.name) {
                        fieldMetadata.description = i18n('Commons.VisualizadorRelatoriosBase.categoria');
                    } else {
                        fieldMetadata.visible = false;
                    }
                    if (_tipoRelatorio == "CE") {
                        if (fieldMetadata.name == "Usuario.NOMEUSU") {
                            fieldMetadata.skVisible = false;
                        }
                        if (fieldMetadata.name == "Instancia.DESCRINSTANCIA") {
                            fieldMetadata.skVisible = false;
                        }
                        if (fieldMetadata.name == "RelatorioDependente.DESCRICAO") {
                            fieldMetadata.skVisible = false;
                        }
                    }

                } else if (dataset.getEntityName() == 'ArquivoRelatorio') {
                    if ('SEQUENCIA' == fieldMetadata.name) {
                        fieldMetadata.description = i18n('Commons.VisualizadorRelatoriosBase.headerSequencia');
                        fieldMetadata.readOnly = true;

                    } else if ('NOME' == fieldMetadata.name) {
                        fieldMetadata.description = i18n('Commons.VisualizadorRelatoriosBase.labelNome');
                        fieldMetadata.readOnly = true;
                    } else {
                        fieldMetadata.visible = false;
                    }
                }
            }

            function getCriteria() {
                var criteria = Criteria();

                criteria.append('( this.TIPO = ? ', Criteria.buildStringParameter(_tipoRelatorio));

                if (_tipoRelatorio == RELATORIO_USUARIO) {
                    criteria.or('this.TIPO IS NULL ');
                }


                criteria.append(')');

                if (angular.isDefined(self.codigoRelatorio)) {
                    criteria.and('this.NURFE = ?', Criteria.buildStringParameter(self.codigoRelatorio));

                } else {

                    if (angular.isDefined(self.descricaoRelatorio)) {
                        criteria.and('ignoreCase(this.DESCRICAO) LIKE ignoreCase(?)',
                            Criteria.buildStringParameter('%' + self.descricaoRelatorio + '%'));
                    }

                    if (angular.isDefined(self.nomeArquivoRelatorio)) {
                        criteria.and('EXISTS(SELECT 1 FROM TSIRFA RFA WHERE RFA.NURFE = this.NURFE AND ignoreCase(RFA.NOME) LIKE ignoreCase(?))',
                            Criteria.buildStringParameter('%' + self.nomeArquivoRelatorio + '%'));
                    }

                    if (self.value.length == 0) {
                        criteria.and('1 = 0');
                    } else {

                        var isNotCategory = self.value.indexOf(SEM_CATEGORIA_LABEL) > -1;

                        if (self.value.length == 1 && isNotCategory) {
                            criteria.and('this.CATEGORIA IS NULL');

                        } else {
                            var Parameters = [];
                            self.value.forEach(function(param) {
                                if (param != SEM_CATEGORIA_LABEL) {
                                    Parameters.push(Criteria.buildStringParameter(param));
                                }
                            }, this);

                            var exp = '? ,'.repeat(self.value.length);

                            exp = exp.substring(0, exp.length - (isNotCategory ? 4 : 2));
                            criteria.and(' (this.CATEGORIA IN (' + exp + ')', Parameters);

                            if (isNotCategory) {
                                criteria.or('this.CATEGORIA IS NULL');
                            }
                            criteria.append(')');
                        }
                    }
                }
                self.dblFacePanelRelatorios.setSelectedIndex(DoubleFacePanelConstants.GRID_FACE);

                return criteria;
            }

            function fileUpload() {

                var params = {}
                params.arquivo = {
                    nuRfe: self.dsRelatorio.getFieldValue("NURFE")
                };

                ServiceProxy.callService("VisualizadorRelatorios.checkIfSomeReportIsProtected", params)
                    .then(function(result) {

                        var protegido = StringUtils.toBoolean(result.responseBody.protegido.valor);

                        if (protegido) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.VisualizadorRelatoriosBase.msgSolucaoProtegida'));
                        }
                        else {

                            if (!_canInsert) {
                                MessageUtils.showAlert(i18n('Commons.VisualizadorRelatoriosBase.msgtitleControleAcesso'), i18n('Commons.VisualizadorRelatoriosBase.messageControleAcesso'));
                            } else {
            
                                let closeScript;
            
                                if (UserAgentUtils.isElectron()) {
                                    let resourceID = SkApplicationInstance.getResourceID();
                                    closeScript = "try {var ipc = require('electron').ipcRenderer; ipc.send('uploadFile', {'resourceID':'" + resourceID + "', 'callbackName': '" + _externalCallbackName + "'});}catch(error){alert(error.message);}";
                                } else {
                                    let selector = '[id=VisualizadorRelatoriosApp]';
            
                                    if (ngAppName) {
                                        selector = '[id=' + ngAppName + ']'
                                    }
            
                                    if (StringUtils.isNotEmpty(self.appName) != '') {
                                        selector = '[id=' + self.appName + ']'
                                    }
            
                                    closeScript = "var appElement = opener.document.querySelector('" + selector + "').querySelector('sk-application');";
                                    closeScript += "appElement." + _externalCallbackName + "();";
                                }
            
                                var url = '/mge/uploadArquivoServlet.mge?acao=carregar&closeScript=' + closeScript;
                                url += '&nurfe=' + self.dsRelatorio.getFieldValueAsString('NURFE');
            
                                var popUpWidth = 400;
                                var popUpHeight = 150;
                                var top = (screen.height - popUpHeight) / 2;
                                var left = (screen.width - popUpWidth) / 2;
            
                                $timeout(function() {
                                    window.open(url, '_blank', 'width=' + popUpWidth + ',height=' + popUpHeight + ',resizable=no,toolbar=no,top=' + top + ',left=' + left);
                                }, 0, false);
            
                            }
                        }
                });
            }


            function download() {

                var params = {}
                params.arquivo = {
                    nuRfe: self.dsRelatorio.getFieldValue("NURFE"),
                    sequencia: self.dsArquivoRelatorio.getFieldValue("SEQUENCIA")
                };

                ServiceProxy.callService("VisualizadorRelatorios.checkIfSomeReportIsProtected", params)
                    .then(function(result) {

                        var protegido = StringUtils.toBoolean(result.responseBody.protegido.valor);

                        if (protegido) {
                            MessageUtils.showAlert(MessageUtils.TITLE_WARNING, i18n('Commons.VisualizadorRelatoriosBase.msgSolucaoProtegida'));
                        }
                        else {
                            ServiceProxy.callService("VisualizadorRelatorios.visualizarArquivo", params)
                            .then(function(result) {

                                var chave = result.responseBody.chave.valor;
                                SkApplication.instance().openWindow('/mge/visualizadorArquivos.mge?chaveArquivo=' + chave);
                            });
                        }
                    });

            }

            function updateStatusInstanciaFilter() {
                self.btnFiltroInstancia = self.dsRelatorio.getFieldValue('NUINSTANCIA') != undefined;
            }


            function getDefaultOptionOfCheckList() {
                return [{
                    data: SEM_CATEGORIA_LABEL,
                    value: SEM_CATEGORIA_LABEL,
                    checked: true
                }];
            }

            function changeLayout(dsRelatorio) {
                SkApplication.instance().useClassicLayoutVersion(dsRelatorio);
            }



            function onDblClickGrid(dblFacePanel) {
                self[dblFacePanel.id].setSelectedIndex(DoubleFacePanelConstants.FORM_FACE);
                self.btnFiltroInstancia = self.dsRelatorio.getFieldValue('NUINSTANCIA') != undefined;

                currentLineChangedImpl();
            }

            function currentLineChangedImpl() {
                _defaultFilterAssistent = {}
                var expression = self.dsRelatorio.getFieldValue('EXPFILTROINSTANCIA');
                _defaultFilter = expression;

                if (_defaultFilter === "") {
                    _defaultFilterAssistent = {
                        dirty: true,
                        mode: "edit",
                        newItem: true,
                        filterModel: {
                            assistent: {},
                            expression: { $: expression }
                        }
                    }
                } else {
                    _defaultFilterAssistent = {
                        filterModel: {
                            expression: { $: expression }
                        }
                    }
                }
                applyClassBtnFilter();
            }

            function getDefaultFilterAsCriteria() {
                if (_defaultFilter || _defaultFilterPF) {
                    var defaultCriteria = new Criteria();

                    if (_defaultFilter) {
                        defaultCriteria.append('(').append(_defaultFilter).append(')');

                    }

                    if (_defaultFilterPF) {
                        defaultCriteria.and('(').append(_defaultFilterPF).append(')');
                    }

                    return defaultCriteria;
                } else {
                    return undefined;
                }
            }

            function isFilterDefaultActive() {
                return angular.isDefined(getDefaultFilterAsCriteria());
            }


            function applyClassBtnFilter() {
                if (!btnDefaultFilterElem) {
                    var elems = $element[0].querySelector('.btn-filter');

                    if (elems) {
                        btnDefaultFilterElem = angular.element(elems);
                    }
                }

                if (btnDefaultFilterElem) {
                    btnDefaultFilterElem[isFilterDefaultActive() ? 'addClass' : 'removeClass']('btn-danger');
                }
            }


            function openAjudanteExpressao() {

                self.nomeInstancia = self.dsRelatorio.getFieldValueAsString('Instancia.NOMEINSTANCIA');

                var defaultFilter = SkDefaultFilter.open(self.nomeInstancia, self.resourceID, _defaultFilterAssistent, _defaultFilterPF);

                defaultFilter.then(function(result) {
                    if (!result) {
                        return;
                    }

                    if (result.filterPFDeleted) {
                        filterPFDeleted();
                    }

                    if (_defaultFilter != result.expression) {
                        _defaultFilterChanged = true;
                    }

                    if (result.expression) {
                        _defaultFilter = result.expression;
                        self.dsRelatorio.setFieldValue("EXPFILTROINSTANCIA", _defaultFilter);

                    } else {
                        _defaultFilter = undefined;
                    }

                    if (result.filter) {
                        _defaultFilterAssistent = result.filter;
                    } else {
                        _defaultFilterAssistent = undefined;
                    }

                    if (result.expression || result.filter) {
                        _changed = true;
                    }

                    applyClassBtnFilter();
                }, function(result) {
                    if (result && result.filterPFDeleted) {
                        filterPFDeleted();
                        applyClassBtnFilter();
                    }
                });

            }

            function filterPFDeleted() {
                _defaultFilterPF = undefined;

                var config = SkApplication.instance().getConfiguracaoTela(self.resourceID);

                if (config) {
                    delete config.defaultFilterPF;
                    SkApplication.instance().putConfiguracaoTela(self.resourceID, config);
                }

                _defaultFilterChanged = true;
            }

            function getNomeInstancia(item) {
                if (item !== undefined) {
                    self.dsRelatorio.setFieldValue("Instancia.NOMEINSTANCIA", item.fields.NOMEINSTANCIA);
                }
            }

            function localizarERemoverLancadorExistente(lastReport) {
                let params = {
                    tipoRel: "",
                    tipoLancador: "RP", // Relatorio Personalizado
                    atributo: lastReport[15] // Código do relatorio
                }

                ServiceProxy.callService("ConfiguracaoMenuSP.getLocalizacaoLancador", { params })
                    .then(function(response) {

                        let controles = ObjectUtils.getProperty(response, 'responseBody.controle');

                        if (angular.isDefined(controles)) {
                            controles = angular.isArray(controles) ? controles : [controles];

                            // Deletar cada item de menu encontrado referente aquele relatorio
                            controles.forEach(function(controle) {
                                let item = {
                                    nuControle: controle.nuControle
                                }

                                ServiceProxy.callService("ConfiguracaoMenuSP.removerItem", { item }).then(function() {
                                    // Não faz nada pois a exclusão do item encontrado é silenciosa
                                });
                            });
                        }
                    });

            }
        }]);

angular
    .module('snk.commons.wizardquestion')
    .controller('SkStepQuestionController', ['$scope', 'ObjectUtils', 'FormService', 'StringUtils',
        function ($scope, ObjectUtils, FormService, StringUtils) {
            var self = this;
            
            ObjectUtils.implements(self, IFormInterceptor);
            self.interceptBuildField = interceptBuildField;
        	
        	var _wizardContext = $scope.context;
        	var _dsTipoOperacao = _wizardContext.dsTipoOperacao;
        	var _functionsByField = {};
        	var _responseQuestionByField = {};
        	var _enable = true;
        	var _id = -1;
        	
        	self.getId = getId;
        	self.onEnterStep = onEnterStep;
            self.onExitStep = onExitStep;
            self.validateStep = validateStep;
            self.titleGroup = $scope.question.title;
        	
        	init();
        	
            function init() {
            	if ($scope.question) {
            		var formProperties = [];
            		var formValues = {};
            		var fieldProperty = {};
            		_id = $scope.question.id;

            		if ($scope.question.type == "custom") {
            			var fields = $scope.question.fields;
            			
            			fields.forEach(function(field){
            				var fm = _dsTipoOperacao.getFieldMetadata(field.fieldName);
            				var required = getBooleanOrDefault(field.required, fm.required);
            				var description = getValueOrDefault(field.description, fm.description);
            				var type = angular.isDefined(field.type) ? field.type : "default";
							var value = _wizardContext.defaultValue[field.defaultValue];
            				
            				formValues[field.fieldName] = value;
            				
            				if (type == "default") {
            					fieldProperty = FormService.buildPropertyFromMD(fm);
            					fieldProperty.description = description;
								fieldProperty.required = required;
								fieldProperty.groupName = undefined;
								
            				} else {
            					fieldProperty = {
        							description: description,
        							fieldName: field.fieldName,
        							required: required,
									fieldProp: {}
								};
            				}
            				
            				_functionsByField[field.fieldName] = function(name) {
        						refreshWizard();
        					};
            				
            				if (type == "default") {
            					formProperties.push(fieldProperty);
            					
            				} else if (type == "options") {
            					fieldProperty.type = 'S';
            					fieldProperty.isCheckbox = field.checkbox;
            					fieldProperty.fieldProp['sk-options'] = field.options;
            					
            					formProperties.push(fieldProperty);
            					
            				} else if (type == "search") {
            					fieldProperty.type = 'ENTITY';
            					fieldProperty.fieldProp['sk-field-name'] = field.fieldName;
            					fieldProperty.fieldProp['sk-entity-name'] = field.entityName;
            					fieldProperty.fieldProp['sk-target-field'] = field.targetName;
            			
            					fieldProperty.fieldProp['sk-enviroment-criteria'] = function(){
            						return Criteria(field.enviromentCriteria);
            					}
            					
            					formProperties.push(fieldProperty);
            					
            				} else {
            					fieldProperty.type = 'S';
            					formProperties.push(fieldProperty);
            				}
            			});
            			
            		} else if ($scope.question.type == "options") {
            			var responseQuestion = $scope.question.response;
            			var fieldName = 'question'+$scope.question.id;
            			_responseQuestionByField[fieldName] = responseQuestion;
            			
            			_functionsByField[fieldName] = function(name) {
            				refreshWizard();
            			};
            			
    					fieldProperty = {
        					description: $scope.question.optionDescription,
        					fieldName: fieldName,
        					type: 'S',
        					isCheckbox: $scope.question.optionType === 'checkbox',
                        	fieldProp: {}
        				};
    					fieldProperty.fieldProp['sk-options'] = $scope.question.options;
    					
    					formProperties.push(fieldProperty);
    					formValues[fieldName] = undefined;
            		}
            		
            		$scope.formProperties = formProperties;
            		$scope.formValues = formValues;
            	}
            	
            	//$scope.wizard.addStep(self);
            }
            
            function getId() {
            	return _id;
            }

            function onEnterStep() {
            	
            }
            
            function onExitStep() {
            	for (var name in $scope.formValues) {
            		var value = $scope.formValues[name];
            		_wizardContext.fieldValues[name] = value;
            		
            		if (name.indexOf('question') > -1) {
            			var responseQuestion = _responseQuestionByField[name];
            			
            			if (responseQuestion && angular.isDefined(value) && angular.isDefined(StringUtils.emptyAsUndefined(value.toString()))) {
            				var fieldValues = responseQuestion[value];
            				if (fieldValues) {
            					for (var fName in fieldValues) {
            	        			 _wizardContext.fieldValues[fName] = fieldValues[fName]; 
            	        		 }
            				}
            			}
            		}
           		}
            }
            
            function validateStep() {
            	var isValid = true;
            	if ($scope.formProperties) {
            		$scope.formProperties.forEach(function(fieldProperty){
            			if (isValid && fieldProperty.required === true) {
            				var value = $scope.formValues[fieldProperty.fieldName];
            				isValid = angular.isDefined(value) && angular.isDefined(StringUtils.emptyAsUndefined(value.toString()));
            			}
            		});
            	}
            	
            	resetValuesDependecy();
            	
            	return isValid;
            }
            
            function resetValuesDependecy() {
            	if ($scope.question && $scope.question.dependency) {
					var dependency = $scope.question.dependency;
					var reset = _wizardContext.fieldValues['question'+dependency.question] != dependency.value;
					
					if (reset) {
						for (var name in $scope.formValues) {
							_wizardContext.fieldValues[name] = undefined;
						}
					}
            	}
            }
            
            function refreshWizard() {
            	onExitStep();
            	
            	if ($scope.wizard) {
            		$scope.wizard.refresh();
            	}
            }
            
            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
            	if (_functionsByField[fieldName]) {
            		fieldProp['sk-change'] = "modifyFieldBinder('"+fieldName+"')";
            		scope.modifyFieldBinder = _functionsByField[fieldName];
            	}
            }
            
            function getValueOrDefault(value, defaultValue) {
            	return angular.isDefined(value) ? value : defaultValue;
            }
            
            function getBooleanOrDefault(value, defaultValue) {
            	var value = getValueOrDefault(value, defaultValue);
            	return (value === true || value === "true");
            }
        }]);
angular
	.module('snk.commons.wizardquestion')
    .directive('skStepQuestion', ['$controller', '$compile', 'AngularUtil', function ($controller, $compile, AngularUtil) {
        return {
            restrict: 'E',
            scope: {
                title: '@skTitle',
                context: '=?skContext',
                question: '=?skQuestion',
                wizard: '=?wizard'
            },
            require: '^skWizardQuestion',
            templateUrl: 'commons/wizardquestion/step/steps.tpl.html',
            link: function ($scope, $element, $attrs, $transcludeFn) {
            	
            	$scope.controller = 'SkStepQuestionController';
            	$scope.controllerAs = 'ctrl';
            	$scope.templateUrl = 'commons/wizardquestion/step/stepquestion.tpl.html';
            	
            	if ($scope.question.controller) {
            		$scope.controller = $scope.question.controller;
            		if ($scope.question.controllerAs) {
            			$scope.controllerAs = $scope.question.controllerAs;
            		}
                }
            	
            	if ($scope.question.templateUrl) {
            		$scope.templateUrl = $scope.question.templateUrl;
            	}
            	
            	var controllerScope = $scope.$new();
            	controllerScope.context = $scope.context;
            	controllerScope.question = $scope.question;
            	controllerScope.wizard = $scope.wizard;
            	
            	var controller = $controller($scope.controller, {
            		$scope: controllerScope
            	});
            	
            	if ($scope.controllerAs) {
            		$scope[$scope.controllerAs] = controller;
            	}
            	
            	AngularUtil.requestTemplate($scope.templateUrl)
                .then(function (template) {
                    var compiledTemplate = $compile(template)(controllerScope);
                    $element.append(compiledTemplate);
                });
            	
            	$scope.wizard.addStep(controller);
            }
        };
    }]);
angular
    .module('snk.commons.wizardquestion')
    .controller('SkWizardQuestionController', ['$scope',
        function ($scope) {
            var self = this;
            
            const ON_ENTER 	= '0';
            const ON_EXIT 	= '1';
            
            var _forceCurrentStep = -1;
            var _stepsController = [];
            
            $scope.currentStep = 0;
            $scope.steps = [];
            $scope.canPrevious = false;
            $scope.canNext = false;
            $scope.canFinish = false;
            $scope.canCancel = true;
            
            self.init = init;
            self.addStep = addStep;
            self.finish = finish;
            self.cancel = cancel;
            self.refresh = refresh;
            self.previous = previous;
            self.next = next;
            self.setCanPrevious = setCanPrevious;
            self.setCanNext = setCanNext;
            self.setCanFinish = setCanFinish;
            self.setCanCancel = setCanCancel;
            
            doInit();
            
            function doInit() {
            	if($scope.onCreate){
            		$scope.onCreate({wizard: self});
            	}
            }
            
            function init(wizardData) {
            	_forceCurrentStep = -1;
                _stepsController = [];
                
            	$scope.wizardData = wizardData;
            	$scope.currentStep = 0;
                $scope.steps = [];
                $scope.canPrevious = false;
                $scope.canNext = false;
                $scope.canFinish = false;
                $scope.canCancel = true;
                
                var steps = [];
                var id = 0;
               
            	$scope.wizardData.questions.forEach(function(question){
            		question.id = id++;
            		steps.push({title: question.title, question: question});
            	});
               
                
                $scope.steps = steps;
            }
            
            function addStep(step) {
            	var replace = _stepsController.some(function(record){
            		var equals = record.getId() == step.getId();
            		if (equals) {
            			_stepsController[step.getId()] = step;
            		}
            		return equals;
            	});
            	
            	if (!replace) {
            		_stepsController.push(step);
            	}
            	
            	_stepsController.sort(function(stp1, stp2){
            		return stp1.getId() - stp2.getId();
            	});
            	
            	refresh();
            	step.onEnterStep();
            }
            
            function finish() {
            	notifyCurrentStep(ON_EXIT);
            	
            	if ($scope.onFinish) {
            		$scope.onFinish();
            	}
            }
            
            function cancel() {
            	$scope.steps = [];
            	
            	if ($scope.onCancel) {
            		$scope.onCancel();
            	}
            }
            
            function setCanNext(value) {
            	$scope.canNext = (value === true && hasNext());
            }
            
            function setCanPrevious(value) {
            	$scope.canPrevious = (value === true && hasPrevious());
            }
            
            function setCanFinish(value) {
            	$scope.canFinish = (value === true && !hasNext(true) && validateSteps());
            }
            
            function setCanCancel(value) {
            	$scope.canCancel = (value === true);
            }
            
            function refresh() {
            	$scope.canPrevious = hasPrevious(true);
            	var canNext = validateCurrentStep() && hasNext(true);
            	$scope.canNext = canNext;
            	$scope.canFinish = !canNext && validateSteps();
            }
            
            function previous() {
            	notifyCurrentStep(ON_EXIT);
            	setCanPrevious(true);
            	
            	if (_forceCurrentStep > -1) {
            		$scope.currentStep = _forceCurrentStep - 1;
            		refresh();
            		notifyCurrentStep(ON_ENTER);
            		_forceCurrentStep = -1;
            		
            	} else if (($scope.currentStep - 1) > -1) {
            		$scope.currentStep = $scope.currentStep - 1;
            		refresh();
            		notifyCurrentStep(ON_ENTER);
            	}
            }
            
            function next() {
            	notifyCurrentStep(ON_EXIT);
            	setCanNext(true);
            	
            	if (_forceCurrentStep > -1) {
            		$scope.currentStep = _forceCurrentStep + 1;
            		refresh();
            		notifyCurrentStep(ON_ENTER);
            		_forceCurrentStep = -1;
            		
            	} else if ($scope.steps.length > ($scope.currentStep + 1)) {
            		$scope.currentStep = $scope.currentStep + 1;
            		refresh();
            		notifyCurrentStep(ON_ENTER);
            	}
            }
            
            function hasPrevious(skipStepRecalculation) {
            	var currentStep = $scope.currentStep;
            	var canPrevious = (currentStep - 1) > -1;
        		
        		if (canPrevious) {
        			do {
        				canPrevious = true;
    					var step = $scope.steps[currentStep - 1];
    					if (step.question.dependency) {
    						var dependency = step.question.dependency;
    						canPrevious = $scope.wizardData.fieldValues['question'+dependency.question] == dependency.value;
    						currentStep--;
    						if (!canPrevious && !skipStepRecalculation) {
    							_forceCurrentStep = currentStep;
    						}
    					}
        			} while(!canPrevious && (currentStep - 1) > -1);
        		}
        		
        		return canPrevious;
            }
            
            function hasNext(skipStepRecalculation) {
            	var currentStep = $scope.currentStep;
            	var canNext = $scope.steps.length > (currentStep + 1);
    			
    			if (canNext) {
        			do {
        				canNext = true;
    					var step = $scope.steps[currentStep + 1];
    					if (step.question.dependency) {
    						var dependency = step.question.dependency;
    						canNext = $scope.wizardData.fieldValues['question'+dependency.question] == dependency.value;
    						currentStep++;
    						if (!canNext && !skipStepRecalculation) {
    							_forceCurrentStep = currentStep;
    							if (_stepsController[_forceCurrentStep] === undefined) { // Isso é um truque usado no addStep para que o validateCurrentStep funcione corretamente.
    								_stepsController.push(buildFakeStep(_forceCurrentStep));
    							}
    						}
    					}
        			} while(!canNext && currentStep < ($scope.steps.length - 1));
    			}
    			
    			return canNext;
            }
            
            function validateCurrentStep() {
            	if ($scope.currentStep < _stepsController.length) {
            		return _stepsController[$scope.currentStep].validateStep();
            	}
            	
            	return true;
            }
            
            function validateSteps() {
            	var isInvalid = _stepsController.some(function(step){
            		return step.validateStep() === false;
            	});
            	
            	return !isInvalid;
            }
            
            function buildFakeStep(id) {
            	return {
            		getId: function(){
            			return id;
            		},
                	onEnterStep: function(){
                	},
                    onExitStep: function(){
                    },
                    validateStep: function(){
                    	return true;
                    },
                    titleGroup: ''
            	};
            }
            
            function notifyCurrentStep(event) {
            	var step;
            	
            	switch (event) {
            		case ON_ENTER:
            			step = _stepsController[$scope.currentStep];
            			if (step) {
            				step.onEnterStep();
            			}
            			break;
            			
            		case ON_EXIT:
            			step = _stepsController[$scope.currentStep];
            			if (step) {
            				step.onExitStep();
            			}
            			break;
            	}
            }
            
        }]);
angular
    .module('snk.commons.wizardquestion')
    .directive('skWizardQuestion', [function() {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
        	onFinish: '&skOnFinish',
            onCancel: '&skOnCancel',
            onCreate: '&?skOnCreate'
        },
        templateUrl: 'commons/wizardquestion/wizardquestion.tpl.html',
        controller: 'SkWizardQuestionController',
        controllerAs: 'ctrl'
    };
}]);
/**
 *	Createad by Walison.ferreira 28/01/2020.
 */
angular.module('snk.commons.workFlow.fieldEventService')
    .constant(
        "FIELD_EVENT_KEYS", [
        { type: "sk-focus", name: "eventoEntrada", method: "onFocus" },
        { type: "sk-focus-out", name: "eventoSaida", method: "onFocusOut" },
        { type: "sk-change", name: "eventoAlteracao" },
        { type: "sk-condicao-apresentacao", name: "condicaoApresentacao" }
    ]
    ).service('SkFieldEventService', ['i18n','ObjectUtils', '$filter', 'MessageUtils', 'FIELD_EVENT_KEYS', 'FormService','ArrayUtils','StringUtils','AngularUtil',
        function (i18n, ObjectUtils, $filter, MessageUtils, FIELD_EVENT_KEYS, FormService, ArrayUtils, StringUtils, AngularUtil) {
            var self = this;

            const FOCUS_OUT_TO_REFERENCE = [
                'sk-pesquisa-input'
            ];

            self.builder = builder;

            function builder(embeddedDatasetInstance, getInstanciasFormularios) {
                return new EventServiceBuilder(embeddedDatasetInstance, getInstanciasFormularios);
            }

            /**
             * Serviço de registro de eventos de campos
             * (Caso necessite compartilhar a instância do formulário embarcado com os outros formulários, passar a instância no parâmetro)
             * @param {*} embeddedDatasetInstance
             * @param {*} getInstanciasFormularios
             */
            function EventServiceBuilder(embeddedDatasetInstance, getInstanciasFormularios) {
                var instance = this;
                var _fieldsElements = {};
                var eventExecutionTasks = {};
                var invalidFields = {};
                var _dataset;
            	var validHasMultipleErrors = [];

                instance.registerEvents = registerEvents;
                instance.registerElement = registerElement;
                instance.isValidEvent = isValidEvent;
                instance.executeCode = executeCode;
                instance.getEventName = getEventName;
                instance.invalidFields = invalidFields;

                /**
                 * Método interno para registro de um evento de foco(focus) ou perda de foco(focus-out).
                 * @param {*} scope
                 * @param {*} eventSchema
                 * @param {*} fieldProp
                 * @param {*} eventCode
                 */
                function registerFocusEvent(scope, eventSchema, fieldProp, eventCode, inputName) {
                    var fieldName = fieldProp['sk-field-name'];

                    var disparar = '';
                    if (FOCUS_OUT_TO_REFERENCE.indexOf(inputName) < 0) {
                        disparar = '()';
                    }

                    fieldProp[eventSchema.type] = eventSchema.method + disparar;

                    scope[eventSchema.method] = function () {

                        if (eventSchema.type === 'sk-focus-out') {
                            callExecuteForDatasetChangedField(fieldName + '_sk-change');
                        }

                        executeCode(eventCode, eventSchema.method, fieldName);
                    }
                }

                /**
                 * Método interno para registro de um evento de alteração.
                 * @param {*} scope
                 * @param {*} dataset
                 * @param {*} fieldName
                 * @param {*} eventCode
                 */
                function registerChangeEvent(scope, dataset, fieldName, eventCode) {
                    var key = fieldName + '_sk-change';

                    dataset.addFieldModifiedListener(fieldName, function (fieldName, newValue, oldValue) {
                        eventExecutionTasks[key] = { 'fieldName': fieldName, 'newValue': newValue, 'oldValue': oldValue, 'code': eventCode };
                    });
                }

                /**
                 * Método para registro dos eventos.
                 * @param {*} scope
                 * @param {*} dataset
                 * @param {*} fieldProp
                 * @param {*} events
                 */
                function registerEvents(scope, dataset, fieldProp, events) {
                    //Filtrando somentes eventos existentes
                    events = ArrayUtils.toArray(events).filter(e => StringUtils.isNotEmpty(e.value));
                    if (events.length > 0) {
                        fieldProp['sk-show-finder-error'] = true;

                        setDataset(dataset);

                        var fieldName = fieldProp['sk-field-name'];

                        let field = scope.properties;

                        var _inputInfo = FormService.getInputInfo(field.type, field.checkbox, field.presentationType, ArrayUtils.toArray(field.options), field.size);

                        registerGenericEvents(scope, dataset, fieldProp, fieldName, _inputInfo.inputName);

                        events.forEach(function (event) {
                            if (event.value) {
                                eventSchema = $filter('filter')(FIELD_EVENT_KEYS, { 'name': event.name })[0];

                                if (eventSchema === undefined) {
                                    return;
                                }

                                if (eventSchema.type === 'sk-change') {
                                    registerChangeEvent(scope, dataset, fieldName, event.value);
                                    return;
                                }

                                registerFocusEvent(scope, eventSchema, fieldProp, event.value, _inputInfo.inputName);
                            }
                        });
                    }
                }

                /**
                 * Define o dataset em uso e adiciona a função padrão de beforeAction
                 * @param {*} dataset 
                 */
                function setDataset(dataset) {
                	if (_dataset !== undefined) {
                		return;
                	}
                	_dataset = dataset;
                	dataset.beforePostAction(dsBeforePostAction);
                }

                /**
                 * Função padrão beforePostAction do dataset
                 * @param {*} dataset 
                 */
                function dsBeforePostAction (dataset) {
                    if (ObjectUtils.isEmpty(invalidFields)) {
                        return true;
                    }

                    var msg = i18n('Commons.FieldEventService.msgFormSaveErrorInvalidFields');
                    Object.entries(invalidFields).forEach(function ([key, value]) {
                        var fieldDescription = !angular.isUndefined(_fieldsElements[key].description) ? _fieldsElements[key].description : key;
                        msg += "<br> - " + fieldDescription;
                    });

                    MessageUtils.showError(msg);
                    return false;
                }

                /**
                 * Registra os eventos genéricos (Que precisam ser executados independente de qual tipo de evento tenha sido solicitado o registro.)
                 * @param {*} scope
                 * @param {*} dataset
                 * @param {*} fieldProp
                 * @param {*} fieldName
                 */
                function registerGenericEvents(scope, dataset, fieldProp, fieldName, inputName) {
                    var key = fieldName + '_sk-change';

                    var disparar = '';
                    if (FOCUS_OUT_TO_REFERENCE.indexOf(inputName) < 0) {
                        disparar = '()';
                    }

                    fieldProp['sk-focus-out'] = 'onFocusOut' + disparar;
                    scope.onFocusOut = function () {
                        callExecuteForDatasetChangedField(key);
                    }

                    registerChangeEvent(scope, dataset, fieldName, '');

                    dataset.addFieldModifiedListener(fieldName, function (fieldName, newValue, oldValue) {
                        removeInvalidField(fieldName);
                    });
                }

                /**
                 * Adiciona um campo na coleção de campos inválidos.
                 * @param {*} fieldName
                 */
                function addInvalidField(fieldName) {
                    invalidFields[fieldName] = {description: _fieldsElements[fieldName].description, messages: []};
                }

                /**
                 * Remove um campo da coleção de campos inválidos.
                 * @param {*} fieldName
                 */
                function removeInvalidField(fieldName) {
                    if (invalidFields[fieldName] !== undefined) {
                        _removeErroCampo(fieldName);
                    }
                }

                /**
                 * Registra os elementos html dos campos para que sejam usados posteriormente pelos métodos erroCampo e removeErroCampo.
                 * @param {*} fieldName
                 * @param {*} dynaform
                 */
                function registerElement(fieldName, dynaform) {
                    var _metadata = dynaform.getDataset().getFieldMetadata(fieldName);
                    var _description = StringUtils.emptyAsUndefined(ObjectUtils.getProperty(_metadata, 'description')) || fieldName;
                    _fieldsElements[fieldName] = { name: fieldName, dynaform: dynaform, description: _description };
                }

                /**
                 * Lança uma mensagem de erro na tela.
                 * @param {*} msg
                 */
                function _mensagemErroCampo(fieldName, msg) {
                    if (invalidFields[fieldName] && invalidFields[fieldName].messages.includes(msg)) {
                        return;
                    }

                    if(invalidFields[fieldName] == undefined){
                        addInvalidField(fieldName)
                    }

                    invalidFields[fieldName].messages.push(msg);

                    MessageUtils.showError(msg);
                }

                /**
                 * Sinaliza visualmente a existência de erro no campo informado no parâmetro.
                 * @param {*} fieldName
                 * @param {*} mensagem
                 */
                function _erroCampo(fieldName, mensagem) {
                    if (invalidFields[fieldName] !== undefined) {
                        return;
                    }

                    var elementData = _fieldsElements[fieldName];

                    if (angular.isUndefined(elementData)) {
                        return;
                    }

                    var obj = [];

                    obj[fieldName] = { icon: 'circle-exclamation-mark', message: mensagem, tooltipPlacement: 'right', style: { color: '#C20000' } }

                    dynaform = elementData.dynaform;
                    dynaform.highlightFields(undefined, 'error', [fieldName], obj);
                    addInvalidField(fieldName);
                }

                /**
                 * Remove a sinalização de erro do campo informado no parâmetro e solicita a remoção do campo da lista de campos inválidos.
                 * @param {*} fieldName
                 */
                function _removeErroCampo(fieldName) {
                    var elementData = _fieldsElements[fieldName];
                    dynaform = elementData.dynaform;
                    dynaform.unHighlightFields(undefined, fieldName);
                    delete invalidFields[fieldName];
                }

                /**
                 * Testa se um evento que está sendo registrado é válido neste contexto.
                 * @param {*} eventName
                 */
                function isValidEvent(eventName) {
                    if (eventName == undefined) {
                        return false;
                    }

                    return $filter('filter')(FIELD_EVENT_KEYS, { 'name': eventName }).length > 0;
                }

                /**
                 * Retorna o nome do evento pelo tipo informado
                 * @param {*} eventType
                 */
                function getEventName(eventType) {
                    event = $filter('filter')(FIELD_EVENT_KEYS, { 'type': eventType })[0];
                    if (event !== undefined) {
                        return event.name;
                    }

                    return 'invalid-event-type';
                }

                /**
                 * Executa o código do evento feito pelo usuário.
                 * @param {*} code
                 * @param {*} fieldName
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                function executeCode(code, eventMethod, fieldName, newValue, oldValue) {
                    try {
                        var addErrorFn = "function erroCampo(mensagem){_erroCampo('" + fieldName + "', mensagem);}";
                        var removeErrorFn = "function removeErroCampo(){_removeErroCampo('" + fieldName + "');} ";
                        var addMessageErrorFn = "function mensagemErroCampo(mensagem){_mensagemErroCampo('" + fieldName + "', mensagem);}";
                        eval(addMessageErrorFn + addErrorFn + removeErrorFn + code);
                    } catch (e) {
                    	if (validHasMultipleErrors.findIndex((err) => err == fieldName) < 0) {
                            _mensagemErroCampo(fieldName, i18n('Commons.FieldEventService.msgCodeExecutionError', [fieldName, eventMethod, e.message]));
                    		validHasMultipleErrors.push(fieldName);

                            if (e.stack) {
                                console.error(e.stack);
                            } else {
                                console.error(e);
                            }
                    	}
                    }
                }

                /**
                 * Chama a execução de código de um evento de alteração de campo efetuada no dataset.
                 * (Eventos de alteração não são executados no momento da alteração, e sim após o campo perder o foco)
                 * @param {*} key
                 */
                function callExecuteForDatasetChangedField(key) {
                    var task = eventExecutionTasks[key];
                    if (task == undefined) {
                        return;
                    }

                    executeCode(task.code, 'onChange', task.fieldName, task.newValue, task.oldValue);
                    delete eventExecutionTasks[key];
                }

                /**
                 * Função disponível para o usuário recuperar o valor de um determinado campo do formulário.
                 * @param {*} fieldName
                 */
                function getCampo(fieldName) {
                    var data = getTargetData(fieldName);
                    if (data === undefined) {
                        return;
                    }
                    return data.dataset.getFieldValue(data.field);
                }

                /**
                 * Função disponível para o usuário efetuar alteração do valor de um determinado campo do formulário.
                 * @param {*} fieldName
                 * @param {*} value
                 */
                function setCampo(fieldName, value) {
                    var data = getTargetData(fieldName);
                    if (data === undefined) {
                        return;
                    }

                   if (angular.isUndefined(data.dataset.getCurrentRow())) {
                        data.dataset
                            .goToInsertionMode()
                            .then(function() {
                                data.dataset.setFieldValue(data.field, value);
                            });
                    } else {
                        data.dataset.setFieldValue(data.field, value);
                    }
                    
                }

                /**
                 * Recupera o dataset correto para as operações de setCampo e getCampo.
                 * (Quando informado o nome do campo precedido do termo embarcado, é selecionado o dataset do formulário embarcado. ex: embarcado.nome_do_campo)
                 * @param {*} fieldName
                 */
                function getTargetData(fieldName) {
                    var targetDataset = _dataset;
                    var tempField = fieldName.split(".", 2);

                    if (tempField && tempField.length == 2 && tempField[0] === 'embarcado') {
                        targetDataset = (embeddedDatasetInstance || angular.noop)();

                        if (!targetDataset) {
                            targetDataset = getFormFromEntity(tempField[0]);
                        }

                        fieldName = tempField[1];
                    }

                    return targetDataset !== undefined ? { dataset: targetDataset, field: fieldName } : targetDataset;
                }

                function getFormFromEntity(entityName) {
                    var formInfo = (getInstanciasFormularios || angular.noop)();
                    return ObjectUtils.getProperty(formInfo, entityName + ".dataset") || [];
                }
            }
        }
    ]);
/**
 *	Createad by Francisco Navarro 26/11/2018.
 */
angular
    .module('snk.commons.workFlow.modelerBpmn')
    .controller('skModelerBpmnController', ['$scope', '$http', '$timeout', 'i18n',
        function ($scope, $http, $timeout, i18n) {
            var self = this;

            $scope.zoomInCanvas = zoomInCanvas;
            $scope.zoomOutCanvas = zoomOutCanvas;
            $scope.zoomResetCanvas = zoomResetCanvas;

            // Variável de tradução do componente
            var _translations = {
                'Activate the global connect tool': i18n("Commons.ModelerBpmn.bpmnJSActivateGlobalConnectTool"),
                'Activate the hand tool': i18n("Commons.ModelerBpmn.bpmnJSActivateHandTool"),
                'Activate the lasso tool': i18n("Commons.ModelerBpmn.bpmnJSActivateLassoTool"),
                'Activate the create/remove space tool': i18n("Commons.ModelerBpmn.bpmnJSActivateCreateRemoveSpaceTool"),
                'Add Lane above': i18n("Commons.ModelerBpmn.bpmnJSAddLaneAbove"),
                'Add Lane below': i18n("Commons.ModelerBpmn.bpmnJSAddLaneBelow"),
                'Append {type}': i18n("Commons.ModelerBpmn.bpmnJsAppend"),
                'Append EndEvent': i18n("Commons.ModelerBpmn.bpmnJsAppendEndEvent"),
                'Append Gateway': i18n("Commons.ModelerBpmn.bpmnJsAppendGateway"),
                'Append Intermediate/Boundary Event': i18n("Commons.ModelerBpmn.bpmnJSAppendIntermediateBoundaryEvent"),
                'Change type': i18n("Commons.ModelerBpmn.bpmnJSChangeType"),
                'Conditional Flow': i18n("Commons.ModelerBpmn.bpmnJSConditionalFlow"),
                'Connect using Sequence/MessageFlow or Association': i18n("Commons.ModelerBpmn.bpmnJSConnectSequenceMessageFlowAssociation"),
                'Create {type}': i18n("Commons.ModelerBpmn.bpmnJSCreate"),
                'Create StartEvent': i18n("Commons.ModelerBpmn.bpmnJSCreateStartEvent"),
                'Create EndEvent': i18n("Commons.ModelerBpmn.bpmnJSCreateEndEvent"),
                'Create Gateway': i18n("Commons.ModelerBpmn.bpmnJSCreateGateway"),
                'Create UserTask': i18n("Commons.ModelerBpmn.bpmnJSCreateUserTask"),
                'Create Intermediate/Boundary Event': i18n("Commons.ModelerBpmn.bpmnJSCreateIntermediateBoundaryEvent"),
                'Divide into two Lanes': i18n("Commons.ModelerBpmn.bpmnJSDivideTwoLanes"),
                'Divide into three Lanes': i18n("Commons.ModelerBpmn.bpmnJSDivideThreeLanes"),
                'Default Flow': i18n("Commons.ModelerBpmn.bpmnJSDefaultFlow"),
                'E-mail Task': i18n("Commons.ModelerBpmn.bpmnJSEmailTask"),
                'End Event': i18n("Commons.ModelerBpmn.bpmnJSEndEvent"),
                'Exclusive Gateway': i18n("Commons.ModelerBpmn.bpmnJSExclusiveGateway"),
                'Inclusive Gateway': i18n("Commons.ModelerBpmn.bpmnJSInclusiveGateway"),
                'Intermediate Throw Event': i18n("Commons.ModelerBpmn.bpmnJSIntermediateThrowEvent"),
                'Manual Task': i18n("Commons.ModelerBpmn.bpmnJSManualTask"),
                'Parallel Gateway': i18n("Commons.ModelerBpmn.bpmnJSParallelGateway"),
                'Parallel Multi Instance': i18n("Commons.ModelerBpmn.bpmnJSParallelMultiInstance"),
                'Remove': i18n("Commons.ModelerBpmn.bpmnJsRemove"),
                'Script Task': i18n("Commons.ModelerBpmn.bpmnJSScriptTask"),
                'Sequence Flow': i18n("Commons.ModelerBpmn.bpmnJSSequenceFlow"),
                'Sequential Multi Instance': i18n("Commons.ModelerBpmn.bpmnJSSequentialMultiInstance"),
                'Service Task': i18n("Commons.ModelerBpmn.bpmnJSServiceTask"),
                'Call Activity': i18n("Workflow.ProcessoNegocio.bpmnJSCallActivity"),
                'Start Event': i18n("Commons.ModelerBpmn.bpmnJSStartEvent"),
                'Task': i18n("Commons.ModelerBpmn.bpmnJSTask"),
                'Timer Boundary Event': i18n("Commons.ModelerBpmn.bpmnJSTimerBoundaryEvent"),
                'Timer Boundary Event (non-interrupting)': i18n("Commons.ModelerBpmn.bpmnJSTimerBoundaryEventNonInterrupting"),
                'Timer Intermediate Catch Event': i18n("Commons.ModelerBpmn.bpmnJSTimerIntermediateCatchEvent"),
                'Signal Intermediate Catch Event': i18n("Commons.ModelerBpmn.bpmnJSSignalIntermediateCatchEvent"),
                'Timer Start Event': i18n("Commons.ModelerBpmn.bpmnJSTimerStartEvent"),
                'User Task': i18n("Commons.ModelerBpmn.bpmnJSUserTask")
            };

            // Variável que carrega os protótipos das extensões do BPMN-JS
            var jsonBpmnSnkModeler = {
                method: 'GET',
                url: '../mge/scripts/vendors/bpmn/bpmnSnkModeler.json',
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            // Variáveis privadas
            var _bpmnModeler;
            var _canvas;
            var _overlays;
            var _valueZoom = 0.0;

            // Variáveis do Módulo adicionado do BPMN-JS
            var _customTranslateModule = {
                translate: ['value', customTranslate]
            };
       
            var _replaceMenuProvider = {
                replaceMenuProvider: ['value', '']
            };

            self.updateCanvas = updateCanvas;
            self.getHandTool = getHandTool;
            self.getEventBus = getEventBus;

            // Carrega o arquivo JSON das extensões do Modeler
            $http(jsonBpmnSnkModeler)
                .success(function (data) {
                    _bpmnCustomModeler = data;
                    init();
                });

            function init() {
                if ($scope.onModelerBpmnCreated) {
                    $timeout(function () {
                        $scope.onModelerBpmnCreated({ modelerBpmn: self });
                    }, 0, false);
                }

                if (angular.isUndefined($scope.showZoom)) {
                    $scope.showZoom = true;
                }

                $scope.$watch('value', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        updateCanvas();
                    }
                });

                if ($scope.bpmnXml) {
                    _bpmnModeler = new CustomModeler({
                        container: '#diagram-canvas',
                        keyboard: {
                            bindTo: window
                        },
                        additionalModules: [
                            _customTranslateModule,
                        
                            _replaceMenuProvider
                        ],
                        moddleExtensions: {
                            bpmnsnk: _bpmnCustomModeler
                        }
                    });

                    _canvas = _bpmnModeler.get('canvas');
                    _overlays = _bpmnModeler.get('overlays');

                    updateCanvas();
                }
            }

            function getHandTool() {
                return _bpmnModeler && _bpmnModeler.get('handTool');
            }

            function getEventBus(){
                return _bpmnModeler && _bpmnModeler.get('eventBus');
           }

            function updateCanvas() {
                if (angular.isUndefined(_bpmnModeler)) {
                    return;
                }
                
                _bpmnModeler.clear();

                if ($scope.isVisible()) {
                    _bpmnModeler.importXML($scope.bpmnXml, function (err) {
                        if (err) {
                            _bpmnModeler.clear();
                        } else {
                            // Renderiza o XML e realiza zoom do diagrama
                            _canvas.zoom('fit-viewport');
                            _valueZoom = _canvas.zoom();

                            setHighlightTask();
                        }
                    });
                }
            }

            function customTranslate(template, replacements) {
                replacements = replacements || {};

                // Translate
                template = _translations[template] || template;

                return template.replace(/{([^}]+)}/g, function (_, key) {
                    return replacements[key] || '{' + key + '}';
                });
            }

            // Seta a seleção da tarefa
            function setHighlightTask() {
                _overlays.add($scope.taskIdSelected, {
                    position: {
                        top: -10,
                        left: -10
                    },
                    html: $('<div style="background-color:lightskyblue; opacity:0.3; width:120px; height:100px;"></div>')
                });
            }

            function zoomInCanvas() {
                _valueZoom += 0.1;
                _canvas.zoom(_valueZoom);
            }

            function zoomOutCanvas() {
                _valueZoom -= 0.1;
                _canvas.zoom(_valueZoom);
            }

            function zoomResetCanvas() {
                _canvas.zoom('fit-viewport');
                _valueZoom = _canvas.zoom();
            }

        }
    ]);
/**
 * @ngdoc directive
 * @name snk.commons.workFlow.modelerBpmn.directive:sk-modeler-bpmn
 * @restrict E
 * @scope
 * @description 
skModelerBpmn é o componente responsável pela renderização e visualização do diagrama BPMN

 * @param {function} [sk-is-visible=undefined] Função que informa se o componente está visível na tela ou não
 * @param {string} [sk-bpmn-xml=true] Xml do BPMN que será renderizado pelo Modeler
 * @param {object} [sk-value=undefined] Id da instância da Tarefa
 * @param {string} [sk-task-id-selected=undefined] Id da Tarefa selecionada
 * @param {object} [sk-route-task=undefined] Array com os IDs dos elementos que foram percorridos até a Tarefa selecionada
 * @param {boolean} [sk-show-zoom=true] Habilita os botões de Zoom (Zoom-in, Zoom-out e Zoom-reset)
 * @example
 <example module="appModelerBpmn">
     <file name="appModelerBpmn.html">
        <div ng-controller="ModelerBpmnController as ctrl">
            <sk-modeler-bpmn sk-is-visible="ctrl.modelerIsVisible" 
                sk-bpmn-xml="ctrl.processXml" 
                sk-task-id-selected="ctrl.taskSelected" 
                sk-show-zoom="false"
                flex></sk-modeler-bpmn>
        </div>
     </file>

    <file name="appModelerBpmn.js">
        angular
        .module('appModelerBpmn',['snk'])
        .controller('ModelerBpmnController', function () {
            var self = this;

            self.processXml;
            self.taskSelected = 'UserTask_1';

            self.modelerIsVisible = modelerIsVisible;

            function modelerIsVisible() {
                return true;
            }
    
            function setDefaultDiagram() {
                self.processXml = '<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:bpmnsnk="http://sankhya.com.br/schema/bpmn/bpmnSnkModeler" id="definitions_1" targetNamespace="br.com.sankhya.workflow" typeLanguage="http://www.w3.org/1999/XPath">\n');
                self.processXml += '  <bpmn:collaboration id="collaboration_1">\n');
                self.processXml += '    <bpmn:participant id="participant_1" name="Diagrama" processRef="processo_1" />\n');
                self.processXml += '  </bpmn:collaboration>\n');
                self.processXml += '  <bpmn:process id="processo_1" name="Processo 1" isExecutable="false">\n');
                self.processXml += '    <bpmn:startEvent id="startEvent_1">\n');
                self.processXml += '      <bpmn:outgoing>SequenceFlow_13h9ui1</bpmn:outgoing>\n');
                self.processXml += '    </bpmn:startEvent>\n');
                self.processXml += '    <bpmn:userTask id="UserTask_1">\n');
                self.processXml += '      <bpmn:incoming>SequenceFlow_13h9ui1</bpmn:incoming>\n');
                self.processXml += '      <bpmn:outgoing>SequenceFlow_076lm6d</bpmn:outgoing>\n');
                self.processXml += '    </bpmn:userTask>\n');
                self.processXml += '    <bpmn:sequenceFlow id="SequenceFlow_13h9ui1" sourceRef="startEvent_1" targetRef="UserTask_1" />\n');
                self.processXml += '    <bpmn:endEvent id="EndEvent_1chfpi0">\n');
                self.processXml += '      <bpmn:incoming>SequenceFlow_076lm6d</bpmn:incoming>\n');
                self.processXml += '    </bpmn:endEvent>\n');
                self.processXml += '    <bpmn:sequenceFlow id="SequenceFlow_076lm6d" sourceRef="UserTask_1" targetRef="EndEvent_1chfpi0" />\n');
                self.processXml += '  </bpmn:process>\n');
                self.processXml += '  <bpmndi:BPMNDiagram id="BPMNDiagram_1">\n');
                self.processXml += '    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="collaboration_1">\n');
                self.processXml += '      <bpmndi:BPMNShape id="participant_1_di" bpmnElement="participant_1">\n');
                self.processXml += '        <dc:Bounds x="150" y="100" width="398" height="238" />\n');
                self.processXml += '      </bpmndi:BPMNShape>\n');
                self.processXml += '      <bpmndi:BPMNShape id="startEvent_1_di" bpmnElement="startEvent_1">\n');
                self.processXml += '        <dc:Bounds x="200" y="200" width="36" height="36" />\n');
                self.processXml += '      </bpmndi:BPMNShape>\n');
                self.processXml += '      <bpmndi:BPMNShape id="UserTask_1_di" bpmnElement="UserTask_1">\n');
                self.processXml += '        <dc:Bounds x="286" y="178" width="100" height="80" />\n');
                self.processXml += '      </bpmndi:BPMNShape>\n');
                self.processXml += '      <bpmndi:BPMNEdge id="SequenceFlow_13h9ui1_di" bpmnElement="SequenceFlow_13h9ui1">\n');
                self.processXml += '        <di:waypoint x="236" y="218" />\n');
                self.processXml += '        <di:waypoint x="286" y="218" />\n');
                self.processXml += '      </bpmndi:BPMNEdge>\n');
                self.processXml += '      <bpmndi:BPMNShape id="EndEvent_1chfpi0_di" bpmnElement="EndEvent_1chfpi0">\n');
                self.processXml += '        <dc:Bounds x="436" y="200" width="36" height="36" />\n');
                self.processXml += '      </bpmndi:BPMNShape>\n');
                self.processXml += '      <bpmndi:BPMNEdge id="SequenceFlow_076lm6d_di" bpmnElement="SequenceFlow_076lm6d">\n');
                self.processXml += '        <di:waypoint x="386" y="218" />\n');
                self.processXml += '        <di:waypoint x="436" y="218" />\n');
                self.processXml += '      </bpmndi:BPMNEdge>\n');
                self.processXml += '    </bpmndi:BPMNPlane>\n');
                self.processXml += '  </bpmndi:BPMNDiagram>\n');
                self.processXml += '</bpmn:definitions>');
            }

            init()
            function init() {
                setDefaultDiagram();
            }
        });
    </file>
</example>
 */
angular
    .module('snk.commons.workFlow.modelerBpmn')
    .directive('skModelerBpmn',
        function () {
            return {
                templateUrl: 'commons/workFlow/modelerBpmn/modelerBpmn.tpl.html',
                controller: 'skModelerBpmnController',
                controllerAs: 'ctrl',
                scope: {
                    isVisible: '=skIsVisible',
                    bpmnXml: '=skBpmnXml',
                    value: '=skValue',
                    taskIdSelected: '=?skTaskIdSelected',
                    routeTask: '=?skRouteTask',
                    showZoom: '=?skShowZoom',
                    onModelerBpmnCreated:'&?skOnModelerBpmnCreated'
                }
            }
        });
/**
 *	Createad by Leonardo Mendes 16/10/2019.
 */
angular
    .module('snk.commons.workFlow.startingProcess')
    .directive('skFormularioInicio', function () {
        return {
            templateUrl: 'commons/workFlow/startingProcess/fomulario/formularioInicio.tpl.html',
            controller: 'formularioInicioController',
            controllerAs: 'ctrl',
            scope: {
                entity: '=skEntity',
                createFormularioInicio: '=?skCreateFormularioInicio',
                initialization: '=?skInitialization',
                instanciaEmbarcado: '=?skInstanciaEmbarcado',
                getTaskInfo: '=?skTaskInfo',
                formGetter: '=?skFormGetter'
            }
        };
    })
    .controller('formularioInicioController', ['ContentType', 'SkPesquisaService', 'DatasetUtils', 'SkApplicationInstance', 'AngularUtil', 'DateUtils', '$scope', 'ObjectUtils', 'ArrayUtils', 'NumberUtils', 'StringUtils', '$q', 'i18n', 'MessageUtils', 'DateUtilsConstants', 'SkFieldEventService', 'SkVisibilityEventService',
        function (ContentType, SkPesquisaService, DatasetUtils, SkApplicationInstance, AngularUtil, DateUtils, $scope, ObjectUtils, ArrayUtils, NumberUtils, StringUtils, $q, i18n, MessageUtils, DateUtilsConstants, SkFieldEventService, SkVisibilityEventService) {
            var self = this;

            // Interceptors
            ObjectUtils.implements(self, IFormInterceptor);
            ObjectUtils.implements(self, IDatagridInterceptor);
            ObjectUtils.implements(self, IDynaformInterceptor);

            self.resourceIdDynaform = StringUtils.nextUid();

            // Variáveis privadas
            var _datasetByName = {};
            var _controleFilhos = {};
            var _fieldPesquisa = {};
            var _fieldsRequired = {};
            var _columnInvisibleEntity = {};
            var _columnInvisible = [
                'IDINSTPRN',
                'IDINSTTAR',
                'IDTAREFA',
                'CODREGISTRO',
                'SEQREGISTRO'
            ];

            self.entityName = ObjectUtils.getProperty($scope.entity, 'entityName');

            var _ehFormularioNativo = ObjectUtils.getProperty($scope.entity, 'tipo') == ContentType.FORMULARIO_NATIVO;
            var _ehFormularioEmbarcado = !_ehFormularioNativo && ObjectUtils.getProperty($scope.entity, 'tipo') == ContentType.FORMULARIO_EMBARCADO;

            var _configEntity = {};

            var _invisibleReferences = ['none'];
            var _entidadesDetalhe = [];
            var _fileMulti = {};
            var mapCamposAnexo = {};
            var _EventServiceInstances = {};
            var _VisibilityServiceInstance = SkVisibilityEventService.builder($scope.formGetter, $scope.getTaskInfo);
            var _eventsFields = {};
            var _dynaform;
            var _fieldPesqPkReadOnly = {};
            var _registroDetalhes = {};

            // Variáveis públicas
            self.uniqueRecord = ObjectUtils.getProperty($scope.entity, 'cardinality') == '1';

            // Funções públicas
            self.buildFieldContainer = buildFieldContainer;
            self.onDynaformLoaded = onDynaformLoaded;
            self.acceptColumnField = acceptColumnField;
            self.acceptField = acceptField;
            self.interceptDataset = interceptDataset;
            self.interceptFieldMetadata = interceptFieldMetadata;
            self.interceptBuildField = interceptBuildField;

            init();
            function init() {
                _configEntity[self.entityName] = {
                    ordemAbas: ArrayUtils.toArray($scope.entity.ordemAbas),
                    configFields: ArrayUtils.toArray(ObjectUtils.getProperty($scope.entity, 'configuracaoCampos.members.properties'))
                };

                var _instanceForm = ArrayUtils.toArray(ObjectUtils.getProperty($scope.entity, 'instanceFormDetalhe'));

                if (_instanceForm.length > 0) {
                    _invisibleReferences = [];

                    buildConfig(_instanceForm);
                }
            }

            function buildConfig(instanceFormDetalhe) {
                ArrayUtils.toArray(instanceFormDetalhe).forEach(function (e) {

                    //Colecinando entidades detalhe
                    _entidadesDetalhe.push(e.entityName);

                    // adiciona a lista de referencia que nao deven ser apresentadas
                    if (StringUtils.toBoolean(e.utilizaTarefa)) {
                        _invisibleReferences.push(e.entityName);
                    }

					if(angular.isUndefined(_configEntity[e.entityName])){
	                    _configEntity[e.entityName] = {
	                        configFields: ArrayUtils.toArray(ObjectUtils.getProperty(e, 'configuracaoCampos.members.properties')),
	                        ordemAbas: ArrayUtils.toArray(e.ordemAbas),
	                        utilizaTarefa: e.utilizaTarefa
	                    };
                    }

                    if (ArrayUtils.toArray(e.instanceFormDetalhe).length > 0) {
                        buildConfig(e.instanceFormDetalhe);
                    }
                });
            }

            function buildCriteria(dataset) {
                var _dependentFields = [];
                var _fieldPesquisaPks = Object.keys(_fieldPesquisa);

                if (_fieldPesquisaPks.length > 1) {
                    var dependent = [];

                    Object.keys(_fieldPesquisa).forEach(function (key) {
                        if (!_fieldPesquisa[key]) {
                            dependent.push(key + '=>' + key);
                        }
                    });

                    _dependentFields.push(dependent.join(',')); // "['CODEMP=>CODEMP']" 
                }

                if (_dependentFields.length > 0) {
                    return DatasetUtils.buildDependentFieldsCriteria(_dependentFields, dataset);
                }

                return Criteria();
            }


            function ehDynaformPrincipal(entityName) {
                return entityName == self.entityName;
            }

            function onDynaformLoaded(dynaform, dataset) {
                _dynaform = dynaform;

                dynaform.getNavigatorAPI().showRefreshButton(false);

                _datasetByName[dataset.getEntityName()] = dataset;
                _controleFilhos[dataset.getEntityName()] = {};

                // Cria uma instância do FieldEventService para cada dataset
                _EventServiceInstances[dataset.getEntityName()] = SkFieldEventService.builder($scope.instanciaEmbarcado, $scope.formGetter);

                if (ehDynaformPrincipal(dataset.getEntityName())) {
                    dataset.setEntityDescription(ObjectUtils.getProperty($scope.entity, 'description'));

                    var _publicAPI = {
                        saveHandler: saveHandler,
                        entityName: self.entityName,
                        dynaform: dynaform,
                        dataset: dataset,
                        normalizedFields: buildFieldsValues(dataset)
                    };

                    if (_ehFormularioEmbarcado) {
                        _publicAPI['getFieldValue'] = function (fieldName) {
                            return dataset.getFieldValue(fieldName);
                        };

                        _publicAPI['setFieldValue'] = function (fieldName, value) {
                            dataset.setFieldValue(fieldName, value);
                        };

                    }
                    // Liberando acesso externo a metodos privados
                    $scope.createFormularioInicio(_publicAPI, ObjectUtils.getProperty($scope.entity, 'tipo'));

                    _dsFormularioFormatado = dataset;
                }

                dynaform.hideBtnIsFavorite(true);
                dynaform.setVisibleReferences(_invisibleReferences);
                dynaform.enableSortFields(true);

                dataset.setRequiredMembroPK(false);
                dataset.setAllowPkModification(true);

                _fieldPesquisa = {};

                var _ordemAbas = ArrayUtils.toArray(ObjectUtils.getProperty(_configEntity, dataset.getEntityName() + '.ordemAbas'));
                if (_ordemAbas.length > 0) {
                    _ordemAbas = _ordemAbas.map(e => {
                        return e == 'Geral' ? 'general' : e;
                    });

                    dynaform.setTabOrder(_ordemAbas); // Reordenando abas 
                }

                _columnInvisibleEntity[dataset.getEntityName()] = [];

                var _configFields = ArrayUtils.toArray(ObjectUtils.getProperty(_configEntity, dataset.getEntityName() + '.configFields'));

                //Normalizando configuracao campos existem configuracao vazia
                _configFields = normalizaConfigFields(_configFields);

                dataset.getFieldsMetadata().forEach(function (field) {
                    if (_configFields.length > 0 && !field.isDescriptionField) {
                        // inicializa sempre como invisivel e nao obrigatorio
                        field.visible = false;
                        field.required = false;
                    }

                    if (_ehFormularioNativo && isCreatePesquisaField(dataset, field)) {
                        _fieldPesquisa[field.name] = angular.isUndefined(field.fk) || (dataset.getPrimaryKeys().length == 1 && dataset.getPrimaryKeys().indexOf(field.name) > -1);
                        _fieldPesqPkReadOnly[field.name] = false;
                    }

                    if (ArrayUtils.isIn(_columnInvisible, field.name)) {
                        field.visible = false;
                    } else {

                        // Prepara estrutura com campos do formulário embarcado que possuem eventos para serem registrados
                        if (_ehFormularioEmbarcado) {
                            if (field.properties.length && isEmbeddedFormInitializationField(field.properties)) {
                                entityName = $scope.entity.entityName;
                                var events = field.properties.filter(function (p) {
                                    return _EventServiceInstances[entityName].isValidEvent(p.name);
                                });

                                if (events.length) {
                                    _eventsFields[field.name] = events;
                                }
                            }
                            return;
                        }

                        if (_configFields.length > 0) {

                            var metadata = ArrayUtils.find(_configFields, function (e) {
                                return e.nome == field.name;
                            });

                            if (metadata) {
                                field.visible = StringUtils.toBoolean(metadata.visivel);
                                field.readOnly = StringUtils.toBoolean(metadata.somenteLeitura);
                                field.required = StringUtils.toBoolean(metadata.obrigatorio);
                                field.order = metadata.ordem;

                                if(!StringUtils.isEmpty(metadata.descricao)){
                                    field.description = metadata.descricao;
                                }

                                var _newProperties = [];
                                if (StringUtils.isNotEmpty(metadata.grupo)) {
                                    _newProperties.push({ name: 'UIGroupName', value: metadata.grupo });
                                }

                                // Prepara estrutura com campos dos formulários que não são embarcados e que possuam eventos para serem registrados                           
                                entityName = dataset.getEntityName();
                                _eventsFields[field.name] = [
                                    { name: _EventServiceInstances[entityName].getEventName('sk-focus'), value: metadata.eventoEntrada },
                                    { name: _EventServiceInstances[entityName].getEventName('sk-focus-out'), value: metadata.eventoSaida },
                                    { name: _EventServiceInstances[entityName].getEventName('sk-change'), value: metadata.eventoAlteracao },
                                    { name: _EventServiceInstances[entityName].getEventName('sk-condicao-apresentacao'), value: metadata.condicaoApresentacao }
                                ];

                                if (angular.isDefined(metadata.valorPadrao)) {
                                    field.allowDefault = true;
                                    field.defaultValue = metadata.valorPadrao;
                                }

                                if (StringUtils.isNotEmpty(metadata.nomeAba)) {
                                    _newProperties.push({ name: 'UITabName', value: metadata.nomeAba });
                                }

                                if (_newProperties.length > 0) {
                                    var _oldProperties = angular.copy(field.properties);
                                    for (var i = 0; i < _oldProperties.length; i++) {
                                        var _name = _oldProperties[i].name;

                                        //Tenta encontrar a propriedade
                                        var temPropriedade = angular.isDefined(ArrayUtils.find(_newProperties, function (e) {
                                            return e.name == _name;
                                        }));

                                        // se nao encontrar ela adiciona na nova properties do campo
                                        if (!temPropriedade) {
                                            _newProperties.push({ name: _name, value: _oldProperties[i].value });
                                        }
                                    }

                                    field.properties = _newProperties;
                                }

                                if (_fieldPesqPkReadOnly.hasOwnProperty(field.name)) {
                                    _fieldPesqPkReadOnly[field.name] = field.readOnly;
                                }
                            }
                        }
                    }

                    if (!field.visible) {
                        _columnInvisibleEntity[dataset.getEntityName()].push(field.name);
                    }
                });

                dataset.beforePostAction(function () {
                    var _parentDataset = dataset.getParentDataset();
                    if (_parentDataset) {
                        validaParentDataset(_parentDataset);
                    }

                    return true;
                });

                dataset.addDataSavedListener(function (isNew, records) {
                    var _parentDataset = dataset.getParentDataset();
                    if (_parentDataset) {
                        //Precisamos guardar as linhas detalhes
                        guardaLinhasDetalhes(_parentDataset, dataset.getEntityName(), dataset.getRecords());
                        
                        _controleFilhos[_parentDataset.getEntityName()][dataset.getEntityName()] = 0;
                    }
                });
                
                dataset.addRecordRemovedListener(function (registro) {
                    var _parentDataset = dataset.getParentDataset();
                    if (_parentDataset) {
                        //Precisamos remover a linha detalhe referente ao registro
                        removeLinhasDetalhes(_parentDataset, dataset.getEntityName(), registro);
                    }
                });

                dataset.addInsertionModeListener(function (indexBeforeInsert, dataset) {
                    dataset.getFieldsMetadata().forEach((field) => {
                        if (dataset.getPrimaryKeys().indexOf(field.name) > -1 && field.defaultValue === 0){
                            return;
                        }

                        if (field.allowDefault && angular.isDefined(field.defaultValue) && !dataset.isModifyingField(field.name)) {
                            dataset.setFieldValue(field.name, field.defaultValue);
                        }
                    });
                });

                dataset.init().then(() => {
                    if (podeAplicaRegra(dataset.getEntityName())) {
                        if (self.uniqueRecord) {
                            dataset.goToInsertionMode();
                        }
                    }
                });

                _VisibilityServiceInstance.registerConditionalEvent();

            }

            function guardaLinhasDetalhes(_parentDataset, entityName, records) {
                //Armazena registro da entidade detalhe
                if (!_registroDetalhes.hasOwnProperty(entityName)) {
                    _registroDetalhes[entityName] = {};
                }

                //Guarda a referencia da linha
                _registroDetalhes[entityName][buildIdRow(_parentDataset)] = angular.copy(ArrayUtils.toArray(records));
            }
            
            function removeLinhasDetalhes(_parentDataset, entityName, registro) {
                //Remove registro da entidade detalhe
                if (_registroDetalhes.hasOwnProperty(entityName)) {
                    _registroDetalhes[entityName][buildIdRow(_parentDataset)].pop(registro);
                }
            }

            function isCreatePesquisaField(dataset, field) {
                if (ehEntidadeDetalhe(dataset.getEntityName())) {
                    return false;
                }

                return 'D-T-H'.indexOf(field.dataType) < 0 && dataset.getPrimaryKeys().indexOf(field.name) > -1;
            }

            /**
             * Cria a rowId no padrao esperado
             * @param {*} currentRow 
             * @returns 
             */
            function buildIdRow(dataset) {
                var _currentIndex = 'rowID_' + dataset.getCurrentIndex();

                var _parent = dataset.getParentDataset();
                if (_parent) {
                    _currentIndex = buildIdRow(_parent) + _currentIndex;
                }

                return _currentIndex;
            }

            function validaParentDataset(dataset) {
                if (dataset.isInsertionMode()) {
                    throw new Error(i18n('Dataset.messageSalvarAntesDeIncluir'));
                }

                if (dataset.isEmpty()) {
                    throw new Error(i18n('Dataset.messageSelecioneRegistro'));
                }
            }

            function buildFieldsValues(dataset) {
                var fieldValuesProperties = ObjectUtils.getProperty($scope.entity, 'configuracaoCampos.members.properties');

                if (!fieldValuesProperties) {
                    var fieldNames = dataset.getFieldNames();
                    fieldValuesProperties = [];

                    ArrayUtils.forEach(fieldNames, function (name) {
                        var dados = dataset.getFieldMetadata(name);
                        var eventConditional = dados.properties.find(function (el) { return el.name == "condicaoApresentacao"; });

                        var objectPropertiesValues = { "nome": name, "obrigatorio": dados.required, "visivel": dados.visible };

                        if (eventConditional) {
                            angular.merge(objectPropertiesValues, { "condicaoApresentacao": eventConditional.value });
                        }

                        fieldValuesProperties.push(objectPropertiesValues);
                    });
                }

                return normalizaConfigFields(ArrayUtils.toArray(fieldValuesProperties));
            }

            function normalizaConfigFields(configFields) {
                var visiveis = 0;
                var fields = [];

                configFields.forEach((field) => {
                    //Pegando somente campos com a configuracao valida
                    if (!ObjectUtils.isEmpty(field)) {
                        fields.push(field);
                        // E necessario exisitir ao menos um visivel para considerar um formulario valido
                        if (StringUtils.toBoolean(field.visivel)) {
                            visiveis++;
                        }
                    }
                });

                return visiveis > 0 ? fields : [];
            }

            function ehEntidadeDetalhe(name) {
                return _entidadesDetalhe.indexOf(name) > -1;
            }

            // Registra os elementos html dos campos para que sejam usados posteriormente pelo erroCampo e removeErroCampo nos eventos
            function buildFieldContainer(fieldName, dataset, fieldElem, scope) {
                entityName = $scope.entity.entityName;
                _EventServiceInstances[entityName].registerElement(fieldName, _dynaform);
            }

            function interceptBuildField(fieldName, dataset, fieldProp, scope) {
                // Registra os eventos dos campos que possuem eventos cadastrados
                var events = ArrayUtils.toArray(_eventsFields[fieldName]);
                var entityName = dataset.getEntityName();
                _EventServiceInstances[entityName].registerEvents(scope, dataset, fieldProp, events);

                if (ehAnexo(scope.properties, 'type')) {
                    var fieldProp = angular.copy(fieldProp);
                    fieldProp['sk-only-button'] = true;
                    fieldProp['sk-show-btn-cancel'] = true;
                    fieldProp['sk-standalone-mode'] = true;
                    fieldProp['sk-download-file'] = true;

                    return AngularUtil.createDirective('sk-file-input', fieldProp, scope);
                }

                if (ehMultiAnexo(scope.properties, 'type')) {
                    _fileMulti = ObjectUtils.setProperty(_fileMulti, entityName + '.' + fieldName, []);

                    var fieldProp = angular.copy(fieldProp);

                    fieldProp['sk-standalone-mode'] = true;

                    return AngularUtil.createDirective('sk-file-input-multi', fieldProp, scope);
                }

                if (_ehFormularioNativo) {
                    if (_fieldPesquisa.hasOwnProperty(fieldName) && _fieldPesquisa[fieldName]) {
                        var helpTipElem = AngularUtil.createDirective('button', {
                            'font-icon': 'search',
                            'default': '',
                            'small': '',
                            'ng-click': 'openPesquisaEntidade()',
                            'toolTip': i18n('Geral.lblPesquisar'),
                            'tooltip-placement': 'bottom',
                            'sk-disabled': _fieldPesqPkReadOnly[fieldName]
                        }, scope);

                        var hBoxElem = AngularUtil.createDirective('sk-hbox', {
                            'layout-align': 'start start',
                            'flex': ''
                        }, scope);

                        scope.openPesquisaEntidade = function () {
                            SkPesquisaService.openPesquisaPopUp(dataset.getEntityName(), undefined, {
                                label: dataset.getEntityDescription(),
                                enableRowsCounter: true,
                                allowShowHierarchicalMode: false,
                                criteria: buildCriteria(dataset),
                            }).then(function (result) {
                                if (angular.isUndefined(dataset.getCurrentRow())) {
                                    dataset.goToInsertionMode().then(inputDataset);
                                } else {
                                    inputDataset();
                                }

                                function inputDataset() {
                                    dataset.setFieldValue(fieldName, result.key);

                                    ObjectUtils.forEachInObject(result.data, (fieldName, value) => {
                                        if (dataset.containsField(fieldName)) {
                                            dataset.setFieldValue(fieldName, value);
                                        }
                                    });
                                    dataset.notifyReloadFields();
                                }
                            });
                        };

                        fieldProp['sk-enabled'] = false;
                        fieldProp['class'] = 'input-size-plus';

                        hBoxElem.append(AngularUtil.createDirective('sk-number-input', fieldProp, scope));

                        hBoxElem.append(helpTipElem);
                        return hBoxElem;
                    }
                }

                if (ehImagem(scope.properties)) {
                    fieldProp['sk-standalone-mode'] = true;
                }

                _VisibilityServiceInstance.evalFields();
            }

            function ehAnexo(properties, type) {
                return properties[type] == 'S' && properties.presentationType == 'F' || properties[type] == 'B' && properties.presentationType == 'A';
            }

            function ehMultiAnexo(properties, type) {
                return properties[type] == 'S' && properties.presentationType == 'F' || properties[type] == 'B' && properties.presentationType == 'M';
            }

            function ehImagem(properties) {
                return properties.type == 'B' && properties.presentationType == 'I';
            }

            function isFieldMDPassword(dataset, fieldName) {
                var metadata = dataset.getFieldMetadata(fieldName);
                if (metadata.hasOwnProperty('properties')) {
                    return metadata.properties.find(function (field) {
                        return field.name === 'password' ? true : false;
                    });
                }

                return false;
            }

            function interceptDataset(self, datasetController) {
                datasetController.setSaveHandler(function () { });
                datasetController.setRemoveHandler(function () { });

                datasetController.setRefreshHandler(function () {
                    var _registros = datasetController.getRecords();
                    //Verifica se existe registro detalhe
                    if (_registroDetalhes.hasOwnProperty(datasetController.getEntityName())) {
                        //Carrega registros detalhes
                        _registros = _registroDetalhes[datasetController.getEntityName()][buildIdRow(datasetController.getParentDataset())];
                    }
                    // Retorna seus proprios campos
                    return ArrayUtils.toArray(_registros);
                });
            }

            function interceptFieldMetadata(fieldMetadata, dataset, dynaform) {
                var fieldName = fieldMetadata.fieldName;
                var _entityName = dataset.getEntityName();

                if (fieldMetadata.required && podeAplicaRegra(_entityName)) {
                    if (!_fieldsRequired.hasOwnProperty(_entityName)) {
                        _fieldsRequired[_entityName] = {};
                    }

                    _fieldsRequired[_entityName][fieldName] = fieldMetadata.description;
                }

                dataset.makeFieldNonRequired(fieldName);

                if (isFieldMDPassword(dataset, fieldName)) {
                    fieldMetadata.fieldProp['sk-password'] = true;
                }

                if (fieldMetadata.presentationType == 'P' && fieldMetadata.type == 'ENTITY') {
                    fieldMetadata.fieldProp['sk-notify-description-change-to-data-set'] = false;
                    fieldMetadata.fieldProp['sk-save-description-field-to-data-set'] = true;
                }
            }

            function acceptField(fieldMetadata, dataset) {
                return isVisibleField(fieldMetadata, dataset);
            }

            function acceptColumnField(fieldMD, dataset) {
                return isVisibleField(fieldMD, dataset);
            }

            function isEmbeddedFormInitializationField(fieldProperties) {
                if (fieldProperties === undefined) {
                    return false;
                }

                return fieldProperties.filter(function (p) { return p.name === 'initialization' && p.value === 'S'; }).length == 1;
            }

            function isVisibleField(fieldMD, dataset) {
                if (_ehFormularioEmbarcado) {
                    var ehInicializao = angular.isDefined(ArrayUtils.find(ArrayUtils.toArray(fieldMD.properties), function (e) {
                        return e.name == 'initialization' && StringUtils.toBoolean(e.value);
                    }));

                    return ehInicializao;
                } else {
                    if (ArrayUtils.isIn(_columnInvisible, fieldMD.name)) {
                        return false;
                    }

                    if (ArrayUtils.isIn(_columnInvisibleEntity[dataset.getEntityName()], fieldMD.name)) {
                        return false;
                    }
                }

                return true;
            }

            function podeAplicaRegra(entityName) {
                return !ehEntidadeDetalhe(entityName);
            }

            function saveHandler() {
                var deffered = $q.defer();

                salvarDatasets().then(function () {
                    var _entities = buildEntity(_datasetByName[self.entityName]);
                    
                    deffered.resolve({
                        tipo: $scope.entity.tipo,
                        entidades: _entities
                    });
                }, function () {
                    deffered.reject();
                });

                return deffered.promise;
            }

            function buildEntity(dataset, rowID = '') {
                return {
                    entityName: dataset.getEntityName(),
                    records: buildRecords(dataset, rowID),
                    configFields: ArrayUtils.toArray(ObjectUtils.getProperty(_configEntity, dataset.getEntityName() + '.configFields'))
                };
            }

            function buildRecords(dataset, rowID) {
                var records = [];
                ArrayUtils.forEach(dataset.getOriginalRecordsAsObject([], true), function (fields, id) {
                    var record = [];
                    Object.keys(fields).forEach(function (nome) {
                        if (angular.isDefined(fields[nome])) {
                            var _value = fields[nome];
                            var _metadata = dataset.getFieldMetadata(nome);

                            if (_metadata.dataType == 'D') {
                                _value = DateUtils.formatDate(_value);
                            } else if (_metadata.dataType == 'H') {
                                _value = DateUtils.formatDate(_value, DateUtilsConstants.DEFAULT_DATETIME_FORMAT_IGNORE_SECONDS);
                            } else if (ehAnexo(_metadata, 'userType')) {
                                try {
									_value = angular.fromJson(_value).key;
								} catch (e) {
									_value = _value;
								}
                            } else if (ehMultiAnexo(_metadata, 'userType')) {
                                try {
                                    _value = angular.toJson(ArrayUtils.toArray(ObjectUtils.getProperty(JSON.parse(_value), 'values')).map((e) => {
                                        if (e.link) {
                                            return `$file.save{link=${e.name}§§${e.link}}`;
                                        }
                                        return '$file.save{sessionkey=' + e.fileKey + '}';
                                    }).join(''));
                                } catch (e) { /*silent*/ }
                            }

                            record.push(
                                {
                                    name: nome,
                                    value: _value
                                }
                            );
                        } else if(_ehFormularioEmbarcado && _dynaform.isFieldVisible(nome)){
						    record.push(
                                {
                                    name: nome,
                                    value: undefined
                                }
                            );
						}
                    });

                    //Criando padrao encontrar linhas
                    var _rowIdDetalhe = rowID + 'rowID_' + id;
                    
                    var _detalhes = [];
                    Object.keys(_controleFilhos[dataset.getEntityName()]).forEach((entityName) => {
                        var _dsDetallhe = angular.copy(_datasetByName[entityName]);

                        var _linhas = _registroDetalhes[entityName][_rowIdDetalhe];
                        if (_linhas) {
                            _dsDetallhe.clearDataSet().addRecords(_linhas);
                            _detalhes.push(buildEntity(_dsDetallhe, _rowIdDetalhe));
                        }
                    });

                    records.push({
                        'record': record,
                        'detalhes': _detalhes
                    });
                });

                return records;
            }

            function salvarDatasets() {
                var deffered = $q.defer();

                var promises = [];
                Object.values(_datasetByName).forEach(function (dataset) {
                    if (dataset.isRecordDirty()) {
                        promises.push(dataset.save());
                    }
                });

                if (promises.length) {
                    $q.all(promises).then(function () {
                        deffered.resolve();
                    });
                } else {
                    deffered.resolve();
                }

                return deffered.promise;
            }
        }
    ]);
/*
 *  Createad by Raisa Costa 04/09/2019.
 */
angular
    .module('snk.commons.workFlow.startingProcess')
    .directive('skStartingProcess',
        function () {
            return {
                templateUrl: 'commons/workFlow/startingProcess/startingProcess.tpl.html',
                controller: 'StartingProcessController',
                controllerAs: 'ctrl',
                scope: {
                    entityName: '@skEntityName',
                    createCtrlStarting: '&skCreateCtrlStarting',
                    initForm: '=?skInitForm',
                    dataForms: '=?skDataForms',
                    dataTelas: '=?skDataTelas',
                    changeViewForm: '=?skChangeViewForm'
                }
            }
        })
    .controller('StartingProcessController', ['$scope', 'ArrayUtils', 'ObjectUtils', 'StringUtils', 'ServiceProxy', '$q', 'i18n', 'SkVisibilityEventService', 'MessageUtils', 'ContentType',
        function ($scope, ArrayUtils, ObjectUtils, StringUtils, ServiceProxy, $q, i18n, SkVisibilityEventService, MessageUtils, ContentType) {
            var self = this;

            var _clientEventVariavelInicializacao = "br.com.sankhya.workflow.listatarefa.necessita.variavel.inicializacao";
            var _instaciaFormulario = {};
            var _telasNativaFlow = [];
            var _codPrn = undefined;

            self.startProcess = startProcess;
            self.createFormFormatados = createFormFormatados;
            self.instanciaEmbarcado = instanciaEmbarcado;
            self.formGetter = formGetter;
            self.getTaskInfo = getTaskInfo;

            var _VisibilityServiceInstance = SkVisibilityEventService.builder(formGetter, getTaskInfo);

            init();
            function init() {
                // E chamada por StartingProcessLaucher.js Lancador "Ele nao tenta iniciar para o usuario clicar"
                if ($scope.dataForms || $scope.initForm || $scope.dataTelas) {
                    buildConteudoTarefa(Object.values($scope.dataForms || {}), $scope.initForm.embarcado, $scope.dataTelas);
                }

                $scope.createCtrlStarting({
                    instancia: {
                        startProcess: startProcess,
                        saveStartProcess: saveStartProcess,
                        clear: clear
                    }
                });

                // E chamada por StartProcess.controller.js Lista tarefa incializacao "Ele tenta iniciar, se houver erro inseri o fomulario"
                if (!ServiceProxy.hasClientEvent(_clientEventVariavelInicializacao)) {
                    ServiceProxy.addClientEvent(_clientEventVariavelInicializacao, function (clientEvent, reCaller) {
                        var _temVariavelInicializacao = StringUtils.toBoolean(ObjectUtils.getProperty(clientEvent, 'start.temVariavelInicializacao'));
                        var _forms = Object.values(ObjectUtils.getProperty(clientEvent, 'start.forms') || {});

						_forms.sort(comparaForms);

                        buildConteudoTarefa(_forms, _temVariavelInicializacao, ArrayUtils.toArray(ObjectUtils.getProperty(clientEvent, 'start.telasNativaFlow.telas')));
                    });
                }

            }

			function comparaForms(form1, form2) {
			    if (form1.codRegistro < form2.codRegistro){
			      return -1;
			    }
			    if(form1.codRegistro > form2.codRegistro){
			      return 1;
			    }
			    return 0;
			}

            function buildConteudoTarefa(forms, temVariavelInicializacao, telas) {
                _telasNativaFlow = telas;
                //Limpamos as variaveis para inicializar o conteudo
                clear();

                self.conteudoTarefa = ArrayUtils.toArray(forms);

                if (temVariavelInicializacao) {
                    ArrayUtils.insertAtIndex(ArrayUtils.toArray(self.conteudoTarefa), 0, {
                        cardinality: "1",
                        configuracaoCampos: undefined,
                        description: i18n('Commons.startingProcess.lblPanelAbaVar'),
                        entityName: $scope.entityName,
                        initialization: 'S',
                        tipo: ContentType.FORMULARIO_EMBARCADO
                    });
                }

                ArrayUtils.toArray(telas).forEach(e => {
                    self.conteudoTarefa.push({
                        description: e.description,
                        url: e.url,
                        tipo: ContentType.TELA_NATIVA,
                        configLigacao: {
                            hashcode: e.hashcode,
                            idInstprn: e.idInstprn,
                            entityName: e.entityName,
                            escopo: e.escopo,
                            politicaReentrancia: e.politicaReentrancia,
                            idInstTarefa: e.idInstTarefa,
                            idTarefa: e.idTarefa,
                        },
                        resourceid: e.resourceid,
                        cardinalidade: e.cardinalidade
                    });
                });

                ($scope.changeViewForm || angular.noop)();

            }

            function createFormFormatados(form, type) {
                _instaciaFormulario[form.entityName] = form;

                if (type == 'E') {
                    _formPrincipalController = form;
                }

                _VisibilityServiceInstance.registerConditionalEvent();
            }

            function instanciaEmbarcado() {
                return _formPrincipalController;
            }

            function formGetter(entityName) {
                if (StringUtils.safelyEqualsIgnoreCase(entityName, "EMBARCADO")) {
                    return _formPrincipalController;
                }

                var instancesForms = { 'embarcado': [] };
                var askedForm = undefined;

                ArrayUtils.forEach(Object.values(_instaciaFormulario), function (form) {
                    ArrayUtils.toArray(form).forEach(function (e) {
                        var key = e.entityName;

                        if (StringUtils.safelyEqualsIgnoreCase(entityName, key)) {
                            askedForm = e;
                            return false;
                        }

                        if (StringUtils.safelyStartsWith(key,"PROCESS_")) {
                            key = 'embarcado';
                        }

                        instancesForms[key] = e;
                    });
                });

                return askedForm || instancesForms;
            }

            function getTaskInfo() {
                return { processId: _codPrn };
            }

            function clear() {
                _instaciaFormulario = {};
                self.conteudoTarefa = [];
                _instaciaFormulario = {};
                self.selectedIndexForms = 0;
            }

            function startProcess(codPrn) {

                self.conteudoTarefa = [];
                _codPrn = codPrn;

                var defer = $q.defer();

                doStartProcess(defer, {
                    param: {
                        codPrn: codPrn
                    }
                });

                return defer.promise;
            }

            function doStartProcess(defer, params) {
                ServiceProxy.callService('workflow@ListaTarefaSP.startProcess', params).then(function (response) {
                    defer.resolve(response);
                });

                return defer;
            }

            function saveStartProcess(codPrn) {
                var defer = $q.defer();

                if (self.conteudoTarefa.length == 0) {
                    // Nao possui nenhum conteudo tentamos inicializar o processo
                    doStartProcess(defer, { param: { codPrn: codPrn } });
                } else {
                    //Definimos se vamos exigir que seja clicado para carregar a abas
                    verificaConteudosObrigatorios(defer, codPrn);
                }

                return defer.promise;
            }

            /**
             * Prepara a inicializacao do processo
             */
            function doSaveStartProcess(defer, codPrn) {
                var promises = [];
                Object.values(_instaciaFormulario).forEach(function (e) {
                    promises.push(e.saveHandler());
                });

                $q.all(promises).then(function (data) {
                    if (_telasNativaFlow.length > 0) {
                        MessageUtils.simpleConfirm(i18n('Commons.startingProcess.validaConcluirInicializacao'))
                            .then(function (sim) {
                                execute(data);
                            });
                    } else {
                        execute(data);
                    }

                    function execute(data) {
                        var formulario = {};

                        //Agrupando formulario
                        ArrayUtils.toArray(data).forEach(function (e) {
                            switch (e.tipo) {
                                case 'N':
                                    formulario['nativo'] = ArrayUtils.toArray(formulario['nativo']).concat(e.entidades);
                                    break;
                                case 'F':
                                    formulario['formatado'] = ArrayUtils.toArray(formulario['formatado']).concat(e.entidades);

                                    ArrayUtils.forEach(formulario['formatado'], (forms, index) => {
                                        var fieldsModifieds = _VisibilityServiceInstance.getModifiedFieldsVisibility(forms.entityName);
    
                                        ObjectUtils.forEachInObject(fieldsModifieds, (fieldName, visible) => {
                                            var configFields = formulario['formatado'][index]["configFields"];
                                           
                                            if(ArrayUtils.isNotEmpty(configFields)){
                                                var fieldIndex = configFields.findIndex(e => e.nome == fieldName);
    
                                                if(fieldIndex > -1){
                                                    configFields[fieldIndex]["visivel"] = visible ?  "S" : "N"; 
                                                }
                                            }
                                        });
                                    })
                                    break;
                                case 'E':
                                    formulario['embarcado'] = ArrayUtils.toArray(formulario['embarcado']).concat(e.entidades);
                                    break;
                            }
                        });

                        doStartProcess(defer, {
                            param: {
                                codPrn: codPrn,
                                formulario: formulario,
                                telas: _telasNativaFlow.length ==  0 ? null : _telasNativaFlow.map((e) => {
                                    return {
                                        'entityName': e.entityName,
                                        'hashcode': e.hashcode
                                    }
                                })
                            }
                        });
                    }
                });
            }

            /**
             * Avalia se a necessidade de ser carregada a aba na inicializado do processo
             * @param {*} defer 
             */
            function verificaConteudosObrigatorios(defer, codPrn) {
                var isContinue = true;

                ArrayUtils.forEach(self.conteudoTarefa, (e) => {
                    //Nao e tela e nao foi iniciado
                    if (e.tipo != ContentType.TELA_NATIVA && !_instaciaFormulario.hasOwnProperty(e.entityName)) {
                        var _configFields = ArrayUtils.toArray(ObjectUtils.getProperty(e, 'configuracaoCampos.members.properties'));

                        //Verificamos se possui algum campo obrigatorio
                        var _camposObrigatorios = _configFields.filter((form) => {
                            return StringUtils.toBoolean(form.obrigatorio) && StringUtils.toBoolean(form.visivel);
                        });

                        if (_camposObrigatorios.length > 0) {
                            var msgBuff = StringUtils.newBuffer();

                            msgBuff.append(i18n('Commons.startingProcess.msgAbaRequiredVariablesNotdefined', [e.description]));
                            msgBuff.append('<br/><ul>');

                            _camposObrigatorios.forEach(function (campo) {
                                //Ignoramos campos com condicao de apresentacao
                                if (StringUtils.isEmpty(campo.condicaoApresentacao)) {
                                    msgBuff.append('<li>').append(campo.descricao).append('</li>');
                                }
                            });

                            msgBuff.append('</ul>');

                            MessageUtils.showAlert(msgBuff.toString());

                            defer.reject();
                            isContinue = false;
                            //Paramos a execucao para nao apresentar varias mensagem
                            return false;
                        } else {
                            //Criamos saveHandler fake para manter a compatibilidade
                            _instaciaFormulario[e.entityName] = {
                                saveHandler: () => {
                                    var deffered = $q.defer();

                                    deffered.resolve({
                                        tipo: e.tipo,
                                        entidades: {
                                            entityName: e.entityName
                                        }
                                    });

                                    return deffered.promise;
                                }
                            }
                        }
                    }
                });

                if (isContinue) {
                    doSaveStartProcess(defer, codPrn);
                }
            }
        }]);


angular
    .module('snk.commons.workFlow.telaNativaFlow')
    .directive('skTelaNativaFlow',
        function () {
            return {
                templateUrl: 'commons/workFlow/telaNativaFlow/telaNativaFlow.tpl.html',
                controller: 'skTelaNativaFlowController',
                scope: {
                    src: '@skSrc',
                    clickHandler: '&skClickHandler',
                    situacao: '@?skSituacao',
                    pksExtra: '@?skPksExtra',
                    resourceid: '@?skResourceid',
                    configLigacao: '@skConfigLigacao',
                    cardinalidade: '@skCardinalidade'
                }
            }
        }).controller('skTelaNativaFlowController', ['$scope', '$timeout', 'StringUtils', 'Base64', 'CentralNotaLauncher', 'ArrayUtils', 'WaitWindow', 'i18n', 'ObjectUtils', 'ServiceProxy', 'MessageUtils',
            function ($scope, $timeout, StringUtils, Base64, CentralNotaLauncher, ArrayUtils, WaitWindow, i18n, ObjectUtils, ServiceProxy, MessageUtils) {

                if ($scope.src) {
                    //Criando unico id elemento
                    $scope.idtela = StringUtils.replaceAll($scope.resourceid, '.', '_') + StringUtils.nextUid();
                }

                $timeout(function () {
                    $(document).ready(function () {
                        //Executa evento de clique no iframe
                        $("#" + $scope.idtela).load(function () {
                            $(this).contents().on("click", function () {
                                ($scope.clickHandler || angular.noop)();
                            });
                        });
                    });

                }, 0, false);

                //So precisamos fazer relancamento para central de notas
                if ($scope.resourceid == 'br.com.sankhya.com.mov.CentralNotas') {
                    var _doOpenAppActivity = angular.noop;

                    workspace = new Proxy(workspace, {
                        get(target, property) {
                            if ('openAppActivity' == property) {
                                _doOpenAppActivity = angular.copy(target[property]);
                                return openAppActivity;
                            }

                            return target[property];
                        }
                    });

                    if (StringUtils.isNotEmpty($scope.pksExtra)) {
                        $timeout(function () {
                            //Guardamos referencia para controlar se estamos na tela correta
                            let idTelaControl = angular.copy($scope.idtela);

                            var _pksExtra = ArrayUtils.toArray(JSON.parse($scope.pksExtra));
                            if (_pksExtra.length > 0) {
                                launch(_pksExtra, 0, idTelaControl, true);
                            }
                        }, 2000, false);

                        function launch(_pksExtra, posicao, idTelaControl, isFirst) {
                            if (!document.getElementById(idTelaControl)) {
                                WaitWindow.close();
                            } else {
                                if (isFirst) {
                                    WaitWindow.show(i18n('Commons.startingProcess.aguardeLoadDoc'));
                                }

                                if (_pksExtra.length > posicao) {
                                    CentralNotaLauncher.launch(_pksExtra[posicao]);
                                    $timeout(function () {        
                                        launch(_pksExtra, posicao + 1, idTelaControl);
                                    }, 5000, false);
                                } else {
                                    WaitWindow.close();
                                }
                            }
                        }
                    }

                    function openAppActivity(resourceId, pkObject) {
                        // Se for central de notas e tem número de nota informado verifica o vinculo com flow
                                 
                        if (resourceId.indexOf('CentralNotas') > -1 && ObjectUtils.getProperty(pkObject, "NUNOTA")) {
                            ServiceProxy.callService('workflow@ListaTarefaSP.verificaVinculoFlow', {
                                param: {
                                    configLigacao: JSON.parse($scope.configLigacao),
                                    pkObject: pkObject
                                }
                            }).then(function (response) {
                                let existeVinculoFlow = StringUtils.toBoolean(ObjectUtils.getProperty(response, 'responseBody.existevinculo'));
                                if (!existeVinculoFlow) {
                                    MessageUtils.showAlert(i18n('Commons.startingProcess.abrirDocumentoNaoVinculados'));
                                } else {
                                    abrirTela(resourceId, pkObject);
                                }
                            });
                        } else {
                            abrirTela(resourceId, pkObject);
                        }
                    }

                    function abrirTela(resourceId, pkObject) {
                        if (resourceId.indexOf("CentralNotas") > -1) {
                            if ($scope.cardinalidade == "1" && !ObjectUtils.getProperty(pkObject, "NUNOTA")) {
                                MessageUtils.showAlert(i18n('Commons.startingProcess.bloquearInsercaoDeRegistroTela'));
                                return;
                            }
                            reabrirCentralNotas(resourceId, pkObject);
                        } else {
                            _doOpenAppActivity(resourceId, pkObject);
                        }
                    }

                    function reabrirCentralNotas(resourceId, pkObject) {
                        var elementId = document.getElementById($scope.idtela);
                        if (elementId) {
                            var _src = elementId.src;

                            var pksBuff = StringUtils.newBuffer();

                            pksBuff.append("#").append(Base64.encode(resourceId));
                            if (pkObject != null) {
                                pksBuff.append("/").append(Base64.encode(JSON.stringify(pkObject)));
                                pksBuff.append("&pk-refresh=").append(new Date().getMilliseconds());
                            }

                            elementId.src = _src.split('#')[0] + pksBuff.toString();
                        }
                    }

                }
            }
        ]);

/**
 *	Createad by Helikson.Rufino 29/10/2020.
 */
 angular.module('snk.commons.workFlow.visibilityEventService')
 .constant(
     "DATASET_EVENT_KEYS", [
     { type: "sk-condicao-apresentacao", name: "condicaoApresentacao" }
 ])
 .service('SkVisibilityEventService', ['i18n','ObjectUtils', '$filter', 'DATASET_EVENT_KEYS', 'ArrayUtils', 'SkApplicationInstance', 'MessageUtils',
     function (i18n, ObjectUtils, $filter, DATASET_EVENT_KEYS, ArrayUtils, SkApplicationInstance, MessageUtils) {
         var self = this;

         self.builder = builder;

         function builder(getInstanciasFormularios, getTaskInfo) {
             return new VisibilityServiceBuilder(getInstanciasFormularios, getTaskInfo);
         }

         /**
          * Serviço de registro de eventos de campos
          * (Caso necessite compartilhar a instância do formulário embarcado com os outros formulários, passar a instância no parâmetro)
          * @param {*} getInstanciasFormularios
          */
         function VisibilityServiceBuilder(getInstanciasFormularios, getTaskInfo) {
             var codUsuLogado = SkApplicationInstance.getUserID();
             var loadedForms = [];
             var instance = this;
             var _fieldsElements = {};
             var flaggedFields = [];
             var validHasMultipleErrors = [];
             var modifiedFieldsVisibility = {};

             instance.registerConditionalEvent = registerConditionalEvent;
             instance.getModifiedFieldsVisibility = getModifiedFieldsVisibility;
             instance.evalFields = evalFields;

             function getModifiedFieldsVisibility(entityName) {
                 return modifiedFieldsVisibility[entityName];
             }

             function registerConditionalEvent() {
                 var formularios = (getInstanciasFormularios || angular.noop)();

                 if (!formularios) {
                     return;
                 }

                 ArrayUtils.forEach(Object.values(formularios), function (form) {
                     var dataset = ObjectUtils.getProperty(form, 'dataset');

                     if (!dataset) {
                         return;
                     }

                     registryDatasetObservers(dataset);
                     
                     var entityName = dataset.getEntityName();
                     var fields = dataset.getFieldsMetadata();
                     
                     if (loadedForms.indexOf(entityName) > -1) {
                         return;
                     } else {
                         loadedForms.push(entityName);   
                     }

                     if (!fields) {
                         return;
                     }

                     ArrayUtils.forEach(Object.values(fields), function(field) {
                         var fieldName = field.name;
                         var metadata = ArrayUtils.find(form.normalizedFields, function (e) { return e.nome == fieldName; });

                         registerElement(fieldName, entityName);

                         var events = [
                             { name: getEventName('sk-condicao-apresentacao'), value: ObjectUtils.getProperty(metadata, 'condicaoApresentacao') }
                         ].filter(function (e) { return (!e.value || e.value == "") ? false : true; });

                         events.forEach(function (event) {
                             var eventSchema = $filter('filter')(DATASET_EVENT_KEYS, { 'name': event.name })[0];

                             if (eventSchema === undefined) {
                                 return;
                             }

                             registryFlaggedField(eventSchema.type, event.value, fieldName, entityName);
                         });
                     });
                 });
             }

             function registryDatasetObservers(dataset) {
                 var observerChange = new IDataSetObserver();
                 observerChange.currentLineChanged = evalFields;
                 observerChange.dataModified = evalFields;

                 dataset.addObserver(observerChange);
             }

             function registryFlaggedField(eventType, code, fieldname, entityName){
                 flaggedFields.push({
                     'typeEvent': eventType,
                     'code': code,
                     'fieldName': fieldname,
                     'entityName': entityName
                 });
             }

             function evalFields() {
                 ArrayUtils.forEach(flaggedFields, function(task) {
                     executeCode(task.code, 'onChange', task.fieldName, task.entityName, task.typeEvent);
                 });
             }

             /**
              * Registra os elementos html dos campos para que sejam usados posteriormente pelos métodos erroCampo e removeErroCampo.
              * @param {*} fieldName
              * @param {*} entityName
              */
             function registerElement(fieldName, entityName) {
                 var entity = getFormFromEntity(entityName);
                 var dataset = ObjectUtils.getProperty(entity, 'dataset');
                 var dynaform = ObjectUtils.getProperty(entity, 'dynaform');

                 if (dataset) {
                     var metadata = dataset.getFieldMetadata(fieldName);
                     var description = !angular.isUndefined(metadata.description) ? metadata.description : fieldName;

                     _fieldsElements[fieldName] = {
                         name: fieldName,
                         dynaform: dynaform,
                         description: description,
                         entityName: entityName
                     };
                 }
             }

             /**
              * Retorna o nome do evento pelo tipo informado
              * @param {*} eventType
              */
             function getEventName(eventType) {
                 var event = $filter('filter')(DATASET_EVENT_KEYS, { 'type': eventType })[0];

                 if (event !== undefined) {
                     return event.name;
                 }

                 return 'invalid-event-type';
             }

             /**
              * Executa o código do evento feito pelo usuário.
              * @param {*} code
              * @param {*} eventMethod
              * @param {*} fieldName
              */
             function executeCode(code, eventMethod, fieldName, entityName, typeEvent) {
                 try {
                     var scripts = groupScripts(code, entityName);

                     var valueResult = eval(scripts) || false;

                     if (typeEvent == 'sk-condicao-apresentacao') {
                         toggleField(entityName, fieldName, valueResult);
                     }
                 } catch (e) {
                     if (validHasMultipleErrors.findIndex((err) => err == fieldName) < 0) {
                         MessageUtils.showError(i18n('Commons.FieldEventService.msgCodeExecutionError', [fieldName, eventMethod, e.message]));
                         validHasMultipleErrors.push(fieldName);

                         if (e.stack) {
                             console.error(e.stack);
                         } else {
                             console.error(e);
                         }
                     }
                 }
             }

             /**
              * Agrupa os scripts para execução do código.
              * @param {*} code
              * @param {*} entityName
              */
             function groupScripts(code, entityName) {
                 var scripts = [];

                 scripts.push("function getCampo(fieldName) { return _getCampo(fieldName, '" + entityName + "'); }");
                 scripts.push("function getCodProcesso() { return _getCodProcesso(); }");
                 scripts.push("function getDhInclusao() { return _getDhInclusao(); }");
                 scripts.push("function getIdInstanceProcesso() { return _getIdInstanceProcesso(); }");
                 scripts.push("function getIdInstanceTarefa() { return _getIdInstanceTarefa(); }");
                 scripts.push("function getUsuarioInclusao() { return _getUsuarioInclusao(); }");
                 scripts.push("function getVersao() { return _getVersao(); }");
                 scripts.push("function getUsuarioLogado() { return _getUsuarioLogado(); }");
                 scripts.push("function getLinhasFormulario(entityName) { return _getLinhasFormulario(entityName); }");

                 scripts.push("function executeCodeScript() {" + code + "}");
                 scripts.push("executeCodeScript();");

                 return scripts.join(' ');
             }

             /**
              * Função disponível para o usuário recuperar o valor de um determinado campo do formulário.
              * @param {*} fieldName
              */
             function _getCampo(fieldName, entityName) {
                 var data = getTargetData(fieldName, entityName);

                 if (ObjectUtils.getProperty(data, 'dataset.getFieldValue')) {
                     return data.dataset.getFieldValue(data.field);
                 }
             }

             function _getCodProcesso() {
                 return getTargetTaskInfo('processId');
             }

             function _getDhInclusao() {
                 return getTargetTaskInfo('taskDhCreateTime');
             }

             function _getIdInstanceProcesso() {
                 return getTargetTaskInfo('processInstanceId');
             }

             function _getIdInstanceTarefa() {
                 return getTargetTaskInfo('taskInstanceId');
             }

             function _getUsuarioInclusao() {
                 return getTargetTaskInfo('processUserCreateCod');
             }

             function _getVersao() {
                 return getTargetTaskInfo('processVersion');
             }

             function _getUsuarioLogado() {
                 return codUsuLogado;
             }

             function _getLinhasFormulario(entityName) {
                 var data = getFormFromEntity(entityName);
                 var entityObjects = null;

                 if (ObjectUtils.getProperty(data, 'dataset.getFieldsMetadata')) {
                     var metadataElements = data.dataset.getFieldsMetadata();

                     entityObjects = {};

                     ArrayUtils.forEach(Object.values(metadataElements), function (element) {
                         var propDataset = ObjectUtils.getProperty(element, "fieldProp.sk-dataset");
                         entityObjects[element.id] = undefined;

                         if (propDataset) {
                             entityObjects[element.id] = propDataset.getFieldValue(element.id);
                         }
                     });
                 }

                 var result = [];

                 if (entityObjects) {
                     result.push(entityObjects);
                 }

                 return result;
             }

             /**
              * ***OBS: Não utilizado pois no toggleField ele já executa tal ação.
              * Função disponível para o usuário mostrar o campo.
              * @param {*} fieldName
              */
             function _mostrarCampo(entityName, fieldName) {
                 var data = getTargetData(fieldName, entityName);

                 if (ObjectUtils.getProperty(data, 'dynaform.setFieldProperty')) {
                     data.dynaform.setFieldProperty(data.field, 'visible', true);
                     angular.merge(modifiedFieldsVisibility[entityName], { [fieldName]: true });
                 }
             }

             /**
              * ***OBS: Não utilizado pois no toggleField ele já executa tal ação.
              * Função disponível para o usuário esconder o campo.
              * @param {*} fieldName
              */
             function _esconderCampo(entityName, fieldName) {
                 var data = getTargetData(fieldName, entityName);

                 if (ObjectUtils.getProperty(data, 'dynaform.setFieldProperty')) {
                     data.dynaform.setFieldProperty(data.field, 'visible', false);
                     angular.merge(modifiedFieldsVisibility[entityName], { [fieldName]: false });
                 }
             }

             /**
              * Realiza o toggle da visibilidade dos campos após a execução do script.
              * Caso retorne TRUE o campo é exibido em tela.
              * Caso retorne FALSE o campo é ocultado.
              */
             function toggleField(entityName, fieldName, visibility) {
                 var data = getTargetData(fieldName, entityName);

                 if (ObjectUtils.getProperty(data, 'dynaform.setFieldProperty')) {
                     if (!ObjectUtils.getProperty(modifiedFieldsVisibility, entityName)) {
                         modifiedFieldsVisibility[entityName] = {};
                     }

                     angular.merge(modifiedFieldsVisibility[entityName], { [data.field]: visibility });
                     
                     normalizedField = data.normalizedFields.find((field)=>{ return field.nome === data.field; });
                     
                     if (visibility && normalizedField && normalizedField.obrigatorio === 'S') {
                     	data.dataset.makeFieldRequired(data.field);
                     } else {
                     	data.dataset.makeFieldNonRequired(data.field);
                     }

                     try {
                         data.dynaform.addCustomFormItemVisible(data.field, visibility);
                         if(visibility && !data?.dataset?.getEntityName().startsWith("AD_") && data?.dataset?.getFieldMetadata(data.field)?.fieldProp['sk-data-type'] == 'B'){
							 window.standaloneModeAnexo = true;
						 }
                     } catch (error) {
                         //Na criação da tarefa o dynaform nao consegue utilizar addCustomFormItemVisible
                         data.dynaform.setFieldProperty(data.field, 'visible', visibility);
                     }
                 }
             }

             /**
              * Recupera o dataset correto para as operações de getCampo.
              * (Quando informado o nome do campo precedido do termo embarcado, é selecionado o dataset do formulário embarcado. ex: embarcado.nome_do_campo)
              * @param {*} fieldName
              * @param {*} entityName
              */
             function getTargetData(fieldName, entityName) {
                 if (fieldName) {
                     var parts = fieldName.split("\.");
                     
                     if (entityName && entityName.startsWith("PROCESS_")) {
                         entityName = 'embarcado';
                     }

                     var _formulario  = getFormFromEntity(entityName);
 
                     return {
                         field: parts.length > 1 ? parts[1] : fieldName,
                         dynaform: _formulario.dynaform,
                         dataset: _formulario.dataset,
                         normalizedFields: _formulario.normalizedFields
                     };
                 }
             }

             function getFormFromEntity(entityName) {
                 var formInfo = (getInstanciasFormularios || angular.noop)();
                 return ObjectUtils.getProperty(formInfo, entityName) || [];
             }

             /**
              * Retorna as informações da tarefa.
              * @param {*} nameProperty 
              */
             function getTargetTaskInfo(nameProperty) {
                 var taskInfo = (getTaskInfo || angular.noop)() || {};
                 return ObjectUtils.getProperty(taskInfo, nameProperty);
             }
         }
     }
 ]);
angular.module('snk.tpls', []).run(['$templateCache', function ($templateCache) {
  "use strict";
  $templateCache.put("core/tour/tour.popover.tpl.html",
    "<div class=\"popover ng-joyride sharp-borders\"><div class=arrow></div><h3 class=\"popover-title sharp-borders\"></h3><div class=\"popover-content container-fluid\"></div></div>");
  $templateCache.put("core/tour/tour.title.tpl.html",
    "<div id=ng-joyride-title-tplv1><div class=\"ng-joyride sharp-borders intro-banner\"><div class=popover-inner><h3 class=\"popover-title sharp-borders\">{{heading}}</h3><div class=\"popover-content container-fluid\"><div class=popover-content-html></div><hr><div class=row><div class=col-md-4><button class=\"skipBtn btn btn-default pull-left\" type=button sk-i18n>Geral.lblFechar</button></div><div class=col-md-8><div class=\"pull-right btn-group\"><button class=\"btn-tour prevBtn btn btn-default\" type=button><i class=\"glyphicon glyphicon-chevron-left\"></i>&nbsp;<sk-i18n>Geral.lblAnterior</sk-i18n></button> <button id=nextTitleBtn class=\"btn-tour nextBtn btn btn-brand\" type=button><sk-i18n>Geral.lblProximo</sk-i18n>&nbsp;<i class=\"glyphicon glyphicon-chevron-right\"></i></button></div></div></div></div></div></div></div>");
  $templateCache.put("core/util/avisos/avisos.tpl.html",
    "<sk-vbox class=painel-avisos><sk-hbox class=painel-avisos-header sk-draggable draggable-level=1><span sk-i18n>Geral.lblAvisos</span> <span flex></span><sk-icon svg-src=/mge/assets/svg/cancel.svg ng-click=onClose($event) sk-draggable-off></sk-icon></sk-hbox><sk-hbox class=painel-avisos-content flex><sk-resizable-columns flex><div class=painel-avisos-list sk-direction=\"'right'\" sk-width=60% sk-overflow-y=auto sk-overflow-x=hidden sk-resizable flex><ul><li class=text-ellipsis ng-repeat=\"aviso in avisos track by $index\" ng-click=\"onSelectItem($index, aviso)\" ng-class=\"{'selected': $index === selectedIndex }\"><div style=\"white-space: normal\"><p>{{ aviso }}</p></div></li></ul></div><sk-text-area sk-value=selectedText flex sk-margin-left=10px sk-border=none sk-enabled=false></sk-text-area></sk-resizable-columns></sk-hbox></sk-vbox>");
  $templateCache.put("core/util/print/print.tpl.html",
    "<div ng-init=init()><sk-vbox ng-if=!ctrl.impressaoDuplicada flex><sk-hbox flex><sk-vbox layout-padding flex><div class=text-bold><span sk-i18n>Geral.lblInfoPrinterName</span><span sk-padding-left=0.3em>{{originalPrinterName}}</span></div><div class=text-bold><span sk-i18n>Geral.lblInfoDocName</span><span sk-padding-left=0.3em>{{docTypeDescription}}</span></div><div><span sk-i18n>Geral.lblInfoAmountWork</span><span sk-padding-left=0.3em>{{printJobCount}}</span></div></sk-vbox></sk-hbox><sk-tabnavigator sk-selected-index=selectedIndex><sk-tabnavigator-item ng-show={{isPrintService}}><sk-i18n>Geral.lblTabServerPrinter</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Geral.lblTabLocalPrinter</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=selectedIndex sk-on-select=onTabSelected layout-padding flex><sk-viewstack-content layout=column class=tab-container sk-height=320px style=\"border: 1px solid #ccc\"><div style=overflow-y:auto><sk-vbox ng-repeat=\"server in serverPrinterList\" flex><div sk-color=gray-base sk-bg-color=#e4e4e4 sk-padding=5px class=text-bold><span sk-i18n>Geral.lblServer</span><span sk-padding-left=0.3em>{{server.printServerUri}}</span></div><sk-list style=overflow:hidden;border:none flex><div class=printerClass ng-repeat=\"item in server.printerList\" layout-padding style=float:left;border:none ng-click=setPrinterSelected(item) flex><div align=center flex><sk-icon svg-src=/mge/assets/svg/{{item.source}} tooltip={{item.toolTip}}></sk-icon><div sk-width=95px sk-height=60px sk-padding=5px flex>{{item.printerName}}</div></div></div></sk-list></sk-vbox></div></sk-viewstack-content><sk-viewstack-content layout=column class=tab-container sk-height=330px style=\"border: 1px solid #ccc\"><div style=overflow-y:auto><sk-list style=overflow:hidden;border:none flex><div class=printerClass ng-repeat=\"item in localPrinterList\" layout-padding style=float:left;border:none ng-click=setPrinterSelected(item) flex><div align=center flex><sk-icon svg-src=/mge/assets/svg/{{item.source}} tooltip={{item.toolTip}}></sk-icon><div sk-width=95px sk-height=60px sk-padding=5px flex>{{item.printerName}}</div></div></div></sk-list></div></sk-viewstack-content></sk-viewstack></sk-vbox><sk-vbox ng-if=!ctrl.impressaoDuplicada flex><div layout-padding style=\"padding: 0px 8px; flex-direction: column; display: flex\"><sk-checkbox ng-model=ctrl.active><sk-i18n>Geral.lblCheckboxPrinterPopUp</sk-i18n></sk-checkbox><span style=\"margin-left: 26px; margin-top: 6px\">{{ ctrl.printerSelected.printerName }}</span></div></sk-vbox><sk-hbox ng-if=ctrl.impressaoDuplicada><sk-vbox flex><p>Impressora n&atilde;o encontrada</p><sk-list sk-scroll-container flex class=list-container sk-overflow=auto sk-select-first-on-change=true flex><sk-hbox ng-repeat=\"variavel in ctrl.printersSelected\" ng-click=\"ctrl.itemClickHandler(variavel, $event)\" flex><sk-vbox layout-padding flex><div class=text-bold><span sk-i18n>Geral.lblInfoPrinterName</span><span sk-padding-left=0.3em>{{variavel.originalPrinterName.$}}</span></div><div class=text-bold><span sk-i18n>Geral.lblInfoDocName</span><span sk-padding-left=0.3em>{{variavel.docType.$}}</span></div><div><span sk-i18n>Geral.lblInfoAmountWork</span><span sk-padding-left=0.3em>{{variavel.printJobCount.$}}</span></div><div><span layout-align=end>{{ variavel.printerName || \"impressora n&atilde;o selecionada\" }}</span></div></sk-vbox></sk-hbox><div layout-align=\"space-between center\" layout=row><label ng-click=ctrl.adicionarVariavel(variavel.expressao)></label></div></sk-list></sk-vbox><sk-vbox flex><sk-vbox><sk-tabnavigator sk-selected-index=selectedIndex><sk-tabnavigator-item ng-show={{isPrintService}}><sk-i18n>Geral.lblTabServerPrinter</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Geral.lblTabLocalPrinter</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=selectedIndex sk-on-select=onTabSelected layout-padding flex><sk-viewstack-content layout=column class=tab-container sk-height=320px style=\"border: 1px solid #ccc\"><div style=overflow-y:auto><sk-vbox ng-repeat=\"server in serverPrinterList\" flex><div sk-color=gray-base sk-bg-color=#e4e4e4 sk-padding=5px class=text-bold><span sk-i18n>Geral.lblServer</span><span sk-padding-left=0.3em>{{server.printServerUri}}</span></div><sk-list style=overflow:hidden;border:none flex><div class=printerClass ng-repeat=\"item in server.printerList\" layout-padding style=float:left;border:none ng-click=setPrinterSelected(item) flex><div align=center flex><sk-icon svg-src=/mge/assets/svg/{{item.source}} tooltip={{item.toolTip}}></sk-icon><div sk-width=95px sk-height=60px sk-padding=5px flex>{{item.printerName}}</div></div></div></sk-list></sk-vbox></div></sk-viewstack-content><sk-viewstack-content layout=column class=tab-container sk-height=330px style=\"border: 1px solid #ccc\"><div style=overflow-y:auto><sk-list style=overflow:hidden;border:none flex><div class=printerClass ng-repeat=\"item in localPrinterList\" layout-padding style=float:left;border:none ng-click=setPrinterSelected(item) flex><div align=center flex><sk-icon svg-src=/mge/assets/svg/{{item.source}} tooltip={{item.toolTip}}></sk-icon><div sk-width=95px sk-height=60px sk-padding=5px flex>{{item.printerName}}</div></div></div></sk-list></div></sk-viewstack-content></sk-viewstack></sk-vbox><sk-vbox flex><div layout-padding style=\"padding: 8px 8px; flex-direction: column; display: flex\"><sk-checkbox ng-model=ctrl.active><sk-i18n>Geral.lblCheckboxPrinterPopUp</sk-i18n></sk-checkbox><span style=\"margin-left: 26px; margin-top: 6px\">{{ ctrl.printerSelected.printerName }}</span></div></sk-vbox></sk-vbox></sk-hbox></div>");
  $templateCache.put("components/accordion/accordion-group.tpl.html",
    "<div class=\"panel panel-default\" ng-class=\"{'open': isOpen}\"><div class=panel-heading><h4 class=panel-title><a href=# tabindex=0 class=\"accordion-toggle container-relative\" ng-click=\"$event.preventDefault(); toggleOpen()\" sk-accordion-transclude=heading><div sk-height=24px layout-align=\"space-between center\" layout=row><div layout-align=\"start center\" layout=row flex><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span> <span sk-margin-left=5px class=required ng-if=isRequired>*</span></div><div layout-align=\"end center\" layout=row ng-if=\"icon || iconSvgSrc\" sk-margin-right=10px><sk-icon font-icon={{icon}} svg-src={{iconSvgSrc}} sk-color={{iconColor}} ng-click=iconClick() tooltip=\"{{iconTooltip | translate}}\" tooltip-placement=left tooltip-append-to-body=true></sk-icon></div></div><sk-icon font-icon=circle-exclamation-mark class=required-invalid tooltip=\"{{'Dynaform.camposObrigNaoPreenchidos' | translate}}\" tooltip-placement=left tooltip-append-to-body=true ng-if=invalid></sk-icon></a></h4></div><div class=panel-collapse ng-class=\"{'collapse': !isOpen}\" layout=column flex><div class=panel-body ng-transclude layout=column flex></div></div></div>");
  $templateCache.put("components/accordion/accordion.tpl.html",
    "<div class=panel-group ng-class=\"{'panel-group-opened':!isOpen,'panel-group-closed':isOpen}\" layout=column flex ng-transclude></div>");
  $templateCache.put("components/actionbutton/actionbutton.tpl.html",
    "<button id=action-button_button class=\"btn btn-default btn-sk-sm\" sk-popover popover-template-url=actionbutton.html popover-index={{zIndex}} create-on-load={{useBindKey}} properties=getActionButtonConfigProperties show-btn-apply=false show-btn-close=false width=300 height=auto popover-class=white-popover tooltip={{::lblActions}} tooltip-placement=\"{{ tooltipPlacement ? tooltipPlacement : 'bottom' }}\" padding=\"{{ squareMode ? 15 : 0 }}\" tooltip-append-to-body=true tooltip-popup-delay=250 tooltip-z-index={{zIndex}} ng-disabled=isDisabled popover-listeners=ctrl.popoverListener popover-focus-on-show=true always-load-properties=alwaysLoadPropertiesActionButton><sk-icon font-icon=acao v=ez></sk-icon></button><script type=text/ng-template id=actionbutton.html><div ng-if=\"!actions\" class=\"no-action-container\" layout=\"column\" layout-align=\"center center\">\n" +
    "        <span translate>BotaoAcao.nenhumaAcao</span>\n" +
    "    </div>\n" +
    "     <div ng-if=\"::actions && squareMode\" class=\"actions-container\" layout-wrap layout=\"row\">\n" +
    "        <div class=\"action-item btn-action-focus\" tabindex=\"0\" ng-class=\"{'btn-action-item': action.selected}\" ng-repeat=\"action in actions\" ng-click=\"executeAction(action); hide()\" layout=\"column\" layout-align=\"start center\" tooltip=\"{{::action.description}}\" tooltip-placement=\"bottom\" tooltip-popup-delay=\"250\">\n" +
    "            <div class=\"img-container\">\n" +
    "                <img ng-if=\"::actionHasImage(action)\" ng-src=\"{{::getActionImage(action)}}\">\n" +
    "                <div ng-if=\"::!actionHasImage(action)\" class=\"nick-contaner\" ng-style=\"{'background-color': textToColor(action.description)}\">\n" +
    "                    <span ng-bind=\"::buildNick(action)\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <span class=\"action-label\" ng-bind=\"::action.description\">\n" +
    "            </span>\n" +
    "        </div>\n" +
    "         <div class=\"clearfix\"></div>\n" +
    "     </div>\n" +
    "     \n" +
    "     <div ng-if=\"::actions && !squareMode\" class=\"simple-actions-container\" sk-scroll-container>\n" +
    "        <ul class=\"dropdown-menu-simple\" role=\"menu\" aria-labelledby=\"split-button\">\n" +
    "            <li role=\"menuitem\" ng-class=\"{'selected-line': action.selected}\"\n" +
    "                ng-repeat=\"action in actions\"\n" +
    "                ng-click=\"executeAction(action); hide()\" tooltip=\"{{::action.description}}\" tooltip-placement=\"bottom\" tooltip-popup-delay=\"250\">\n" +
    "                <div>\n" +
    "                    <span class=\"action-label\" ng-bind=\"::action.description\"></span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div></script>");
  $templateCache.put("components/agendamentos/config-frequencia-panel.tpl.html",
    "<sk-hbox flex layout-padding class=config-frequencia-panel><sk-vbox ng-style=ctrl.getStyleContainerHr() layout-padding><sk-hbox gap=5><label sk-padding-top=4px ng-bind=ctrl.getLblHorarios()></label><span style=\"margin-left: 1%\"></span> <button default small sk-i18n ng-click=ctrl.addTime(ctrl.times) tooltip=Commons.AgendamentoBase.tooltipAddHorario tooltip-placement=right><sk-icon font-icon=plus></sk-icon></button> <button default small sk-i18n ng-click=ctrl.clearTime(ctrl.times) tooltip=Commons.AgendamentoBase.tooltipCleanHorario tooltip-placement=right><sk-icon font-icon=cleaning></sk-icon></button></sk-hbox><sk-simple-form sk-columns=1 sk-padding-top=5px><sk-simple-item ng-repeat=\"option in ctrl.times track by $index\" sk-label=\"{{ option.label }}\" sk-required=\"$index == 0\" class=time-form-item><sk-hbox gap=5><sk-time-input sk-value=option.data sk-change=ctrl.hourChanged() sk-width=172px></sk-time-input><button default small sk-i18n ng-click=ctrl.removeTime($index) tooltip=\"Remover Horário\" tooltip-placement=right ng-if=\"$index != 0\"><sk-icon font-icon=bin></sk-icon></button></sk-hbox></sk-simple-item></sk-simple-form></sk-vbox><sk-vbox flex layout-padding><sk-vbox sk-width=550px class=panel-frequencia layout-padding><label sk-font-size=13px layout=row layout-align=\"center center\" sk-i18n>Commons.AgendamentoBase.labelMeses</label><sk-hbox gap=4 layout-padding><div ng-repeat=\"mes in ctrl.meses\" layout=column layout-align=\"center center\"><span ng-bind=mes.label></span><sk-switch sk-value=mes.data sk-false-value=false sk-true-value=true sk-change=ctrl.mouthChanged(mes.isAllBtn)></div></sk-hbox></sk-vbox><sk-vbox sk-width=550px sk-height=300px class=panel-frequencia sk-margin-top=20px layout-padding><sk-hbox class=btn-group layout=row layout-align=\"center center\"><button class=\"btn btn-default\" ng-click=ctrl.selecionaFrequenciaDiaria(0) ng-class=\"{'btn-selecionado': ctrl.selectedIndex == 0}\" sk-i18n>Commons.AgendamentoBase.btnDiario</button> <button class=\"btn btn-default\" ng-click=ctrl.selecionaFrequenciaDiaria(1) ng-class=\"{'btn-selecionado': ctrl.selectedIndex == 1}\" sk-i18n>Commons.AgendamentoBase.btnSemanal</button> <button class=\"btn btn-default\" ng-click=ctrl.selecionaFrequenciaDiaria(2) ng-class=\"{'btn-selecionado': ctrl.selectedIndex == 2}\" sk-i18n>Commons.AgendamentoBase.btnMensal</button></sk-hbox><div flex layout class=\"viewstack-container has-tabs\"><sk-viewstack sk-selected-index=ctrl.selectedIndex flex layout><sk-viewstack-content layout-padding><span sk-i18n>Commons.AgendamentoBase.spanExecDias</span></sk-viewstack-content><sk-viewstack-content layout-padding><div class=\"row col-md-12 content-panel-frequencia\"><sk-hbox ng-repeat=\"diaSemana in ctrl.diasSemana\" class=col-md-3 layout-align=\"start center\" gap=5><sk-switch sk-value=diaSemana.data sk-true-value=true sk-false-value=false sk-change=ctrl.dayWeekChanged(diaSemana.isAllBtn)></sk-switch><span ng-bind=diaSemana.label></span></sk-hbox></div></sk-viewstack-content><sk-viewstack-content layout-padding><div class=\"row col-md-12 content-panel-frequencia\"><sk-hbox ng-repeat=\"diaMes in ctrl.diasMes\" class=col-md-3 layout-align=\"start center\"><sk-switch sk-value=diaMes.data sk-true-value=true sk-false-value=false sk-change=ctrl.dayMonthChanged(diaMes)></sk-switch><span ng-style=ctrl.getDayMonthStyle(diaMes) sk-padding-left=1px ng-bind=diaMes.label></span></sk-hbox></div></sk-viewstack-content></sk-viewstack></div></sk-vbox></sk-vbox></sk-hbox>");
  $templateCache.put("components/attach/attach.tpl.html",
    "<sk-dataset id=dsAttach sk-dataset-created=onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=CODATA description=Attach.lblCodigo user-type=I visible></sk-dsfield-md><sk-dsfield-md name=DESCRICAO description=Attach.lblDescricao></sk-dsfield-md><sk-dsfield-md name=ARQUIVO description=Attach.lblArquivo></sk-dsfield-md><sk-dsfield-md name=DTEXPIRA description=Attach.lblDataExpiracao user-type=D visible></sk-dsfield-md><sk-dsfield-md name=DTALTER description=Attach.lblDataAlteracao user-type=D></sk-dsfield-md><sk-dsfield-md name=USUARIO description=Attach.lblUsuario></sk-dsfield-md><sk-dsfield-md name=CODUSU user-type=I visible></sk-dsfield-md><sk-dsfield-md name=EDITA visible></sk-dsfield-md><sk-dsfield-md name=EHARQUIVOREPOSITORIO visible></sk-dsfield-md><sk-dsfield-md name=PUBLICO visible></sk-dsfield-md><sk-dsfield-md name=TEMCONTEUDO user-type=I visible></sk-dsfield-md><sk-dsfield-md name=SEQUENCIA visible></sk-dsfield-md><sk-dsfield-md name=TIPO visible></sk-dsfield-md><sk-dsfield-md name=TIPOCONTEUDO visible></sk-dsfield-md><sk-dsfield-md name=USUARIO_LOGADO user-type=I visible></sk-dsfield-md><sk-dsfield-md name=LINK user-type=S visible></sk-dsfield-md></sk-dataset><div flex layout=column><div layout=row class=\"top-bar-container high-contrast-panel\"><div ng-if=\"visualizaMultiplos() === false\"><sk-btn-novo sk-enabled=\"btnNewEnabled && !readOnly\" sk-compact=!showCodAta sk-entity-description=\"{{'Attach.lblAnexo' | translate}}\" sk-on-click=openPopUpInclusaoAlteracao() ng-if=\"!mostrarAnexoDropdown && showBtnAdd\"></sk-btn-novo><sk-dropdown-menu sk-build-options=otherOptionsLoader() sk-tooltip-placement=\"{{ tooltipPlacement ? tooltipPlacement : 'bottom' }}\" sk-on-click-btn=btnClick($event) ng-if=\"mostrarAnexoDropdown && showBtnAdd\" sk-font-icon=plus></sk-dropdown-menu><button class=\"btn btn-default btn-sk-sm btn-remove\" ng-if=showBtnRemove ng-click=removeAction() ng-disabled=\"!enableButtons() || readOnly\" tooltip=\"{{'Attach.btnExcluir' | translate}}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=bin></sk-icon></button> <button class=\"btn btn-default btn-sk-sm\" ng-click=alterarItem() ng-if=showBtnEdit ng-disabled=\"!enableButtons() || readOnly\" tooltip=\"{{'Attach.btnAlterar' | translate}}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=pencil></sk-icon></button> <button class=\"btn btn-default btn-sk-sm\" ng-click=viewAction() ng-disabled=!enableButtons() tooltip=\"{{'Attach.btnVisualizar' | translate}}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=eye-open></sk-icon></button></div><div ng-transclude=leftContainer></div><div ng-if=\"visualizaMultiplos() === true\"><button ng-click=selectLines(true) class=\"btn btn-default btn-sk-sm\" tooltip=\"{{'Attach.selecionarTodos' | translate}}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=menu-hamburger class=green-color></sk-icon><span sk-translate>Attach.selecionarTodos</span></button> <button ng-click=selectLines(false) class=\"btn btn-default btn-sk-sm\" tooltip=\"{{'Attach.deselecionarTodos' | translate}}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=menu-hamburger></sk-icon><span sk-translate>Attach.deselecionarTodos</span></button> <button ng-click=viewAction(true) class=\"btn btn-default btn-sk-sm\" tooltip=\"{{'Attach.visualizarSelecionados' | translate}}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=eye-open></sk-icon><span sk-translate>Attach.visualizarSelecionados</span></button></div><div flex layout layout-align=end><sk-rows-counter sk-dataset=dsAttach></sk-rows-counter></div></div><sk-datagrid sk-dataset=dsAttach sk-allow-multiple-selection=\"visualizaMultiplos() === true\" sk-on-dbl-click=viewAction() sk-editable=false sk-on-datagrid-loaded=onDatagridLoaded(datagrid)><sk-datagrid-custom-column sk-field-name=DTALTER sk-cell-formatter=formatDate></sk-datagrid></div>");
  $templateCache.put("components/banner/banner.tpl.html",
    "<div class=sk-banner-atualizar ng-if=\"ctrl.skType === 'alert'\"><sk-vbox flex><sk-hbox sk-width=100% sk-padding=17 flex><sk-hbox gap=8><sk-icon sk-color=#604701 font-icon=lightbulb v=2></sk-icon><span sk-color=#604701 sk-translate=\"{{ ctrl.skText }}\"></span> <button class=atualizacoes-alert-button ng-click=ctrl.executarAcao() default><span sk-translate=\"{{ ctrl.skActionLabel }}\"></span></button></sk-hbox></sk-hbox></sk-vbox></div><div class=sk-banner-adquirir ng-if=\"ctrl.skType === 'success'\"><sk-vbox flex><sk-hbox sk-width=100% sk-padding=17 flex><sk-hbox gap=8><sk-icon sk-color=#147a00 font-icon=lightbulb v=2></sk-icon><span sk-color=#147a00 sk-translate=\"{{ ctrl.skText }}\"></span> <button class=atualizacoes-alert-button ng-click=ctrl.executarAcao() brand><span sk-translate=\"{{ ctrl.skActionLabel }}\"></span></button></sk-hbox></sk-hbox></sk-vbox></div>");
  $templateCache.put("components/breadcrumbs/breadcrumbs.tpl.html",
    "<ul class=breadcrumbs flex></ul>");
  $templateCache.put("components/btnnovo/btnnovo.tpl.html",
    "<button class=\"btn btn-brand btn-novo-registro\" ng-class=\"{'sk-compact': compact}\" ng-disabled=\"enabled === false\" ng-click=\"addFn(undefined, $event)\" tooltip={{getToolTipText()}} tooltip-append-to-body=true tooltip-placement=\"{{tooltipPlacement ? tooltipPlacement : 'right'}}\"><div class=icon-container><sk-icon font-icon=plus></sk-icon></div><span class=entity-description ng-bind=getEntityDescription()></span></button>");
  $templateCache.put("components/btnoldlayout/btnoldlayout.tpl.html",
    "<button type=button sk-visible=visivel() ng-click=changeLayout() class=\"btn btn-default btn-sk-sm btn-formatter\" sk-i18n tooltip=Geral.lblLayoutAnterior tooltip-append-to-body=true tooltip-placement=bottom><sk-icon font-icon=message-forward style=\"padding-right: 5px\"></sk-icon>{{::lblBtnOldLayout}}</button>");
  $templateCache.put("components/btnotheroptions/btnotheroptions.tpl.html",
    "<sk-dropdown-menu ng-if=\"$ctrl.visible !== false\" sk-open-always=\"$ctrl.openAlways !== false\" sk-build-options=\"$ctrl.otherOptions({$dropdownMenu: $dropdownMenu})\" sk-build-on-every-click=$ctrl.buildOnEveryClick></sk-dropdown-menu>");
  $templateCache.put("components/btnplace/btnplace.tpl.html",
    "<button default ng-click=$ctrl.openPlace()><sk-icon font-icon=shopping-bag></sk-icon><span ng-if=!$ctrl.hideLabel ng-bind=::$ctrl.btnPlaceText></span></button>");
  $templateCache.put("components/calendar/calendar.tpl.html",
    "<div id=calendar-container flex layout=row></div>");
  $templateCache.put("components/calendar/event.tpl.html",
    "<sk-vbox flex class=event-template><sk-hbox gap=5 class=event-template-title><sk-icon font-icon=calendar></sk-icon><span>{{title}}</span></sk-hbox><sk-divider sk-width=100%></sk-divider><sk-vbox><sk-hbox><sk-icon font-icon=bell></sk-icon><span>{{start | date: 'dd/MM/yyyy HH:mm'}} - {{end | date: 'HH:mm'}}</span></sk-hbox></sk-vbox><sk-hbox class=event-template-text ng-if=description><sk-icon font-icon=notes></sk-icon><span>{{description}}</span></sk-hbox></sk-vbox>");
  $templateCache.put("components/carregando/carregando.tpl.html",
    "<sk-hbox align=\"center center\" flex><div class=loading--label layout=row layout-align=\"center center\"><sk-icon class=\"spin loading--size--icon\" svg-src=/mge/assets/svg/loading.svg></sk-icon><span class=loading--font sk-translate>Geral.lblCarregando</span></div></sk-hbox>");
  $templateCache.put("components/changeorderbar/changeorderbar.tpl.html",
    "<sk-hbox><button class=\"btn btn-default\" ng-disabled=!ctrl.btnTopEnabled ng-click=ctrl.moveTop() tooltip={{::tooltipMoverCima}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon svg-src=/mge/assets/svg/up.svg></sk-icon></button> <button class=\"btn btn-default\" ng-disabled=!ctrl.btnDownEnabled ng-click=ctrl.moveDown() tooltip={{::tooltipMoverBaixo}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon svg-src=/mge/assets/svg/down.svg></sk-icon></button></sk-hbox>");
  $templateCache.put("components/chart/chart.tpl.html",
    "<sk-vbox id={{chartId}} class=sk-chart></sk-vbox>");
  $templateCache.put("components/checkboxlist/checkboxlist.tpl.html",
    "<div flex class=checkbox-list-container><div layout=row layout-align=\"start center\" class=checkbox-list-header-container><sk-checkbox accept-indeterminate=true indeterminate-value=I ng-show=!singleSelection ng-model=checkBoxAll ng-change=atualizaCheckBoxLista() class=checkbox-list-cbx-header tooltip=\"{{'Geral.lblMarcarDesmarcar' | translate}}\" tooltip-placement=right tooltip-append-to-body=true></sk-checkbox><div class=checkbox-list-header>{{::label | i18n}}</div></div><div class=checkbox-list-body-container><div ng-repeat=\"item in dataProvider\" class=checkbox-list-body-item><sk-checkbox ng-model=item.checked ng-click=notifyChange(item) class=checkbox-list-cbx-item></sk-checkbox><span tooltip-placement=right tooltip=\"{{item.data == '__NON_VOID__' ? 'Exibe todos os registros que  tem o valor informado. ':'' || item.data == '__VOID__'? 'Exibe todos os registros que não tem o valor informado.' :'' }}\" ng-style=\"item.data == '__NON_VOID__' ? {'font-style':'italic'} : '' || item.data == '__VOID__'? {'font-style':'italic'} :''\" class=checkbox-list-span-item>{{::item.value}}</span></div></div></div>");
  $templateCache.put("components/colorpicker/colorpicker.tpl.html",
    "<sk-hbox><div class=button-select ng-class=\"{'button-select-undefined': (value === undefined && defaultColor === undefined), 'is-disabled': !enabled}\" ng-click=$ctrl.togglePallet() ng-style=\"{'background-color': '#' + $ctrl.selectedColor, 'border-radius': squareMode ? 'var(--border-radius-xsmall, 0px)' : '50%'}\" sk-i18n tooltip={{$ctrl.toolTip}}></div><sk-text-input ng-if=showColorTextInput sk-value=$ctrl.selectedColor sk-enabled=false sk-width=150px sk-margin-left=10px></sk-text-input></sk-hbox>");
  $templateCache.put("components/colorpicker/colorpickerpopup.tpl.html",
    "<sk-vbox><sk-hbox><div class=color-picker-indicator ng-class=\"{'button-select-undefined': value === undefined && $ctrl.preSelectedColor === ''}\" ng-style=\"{'background-color': '#' + $ctrl.preSelectedColor}\"></div><sk-text-input class=color-picker-margin-top sk-value=$ctrl.preSelectedColor sk-keydown=$ctrl.keyDownHandler($event) sk-display-as-upper-case=true></sk-text-input><div ng-if=\"disableUnselectColor !== true\" class=\"color-picker-item-size button-select-undefined color-picker-margin-top color-picker-unselect\" ng-style=\"{'margin-left': $ctrl.isMobile ? '175px' : '9px'}\" ng-click=$ctrl.selectColor(undefined) sk-i18n tooltip=Geral.tooltipSemCor></div></sk-hbox><div class=color-picker-container ng-style=\"{'padding-top': dataProvider === undefined ? '8px' : '5px'}\"><div ng-repeat=\"colorLine in $ctrl.collorsPallet\"><sk-hbox><div class=color-picker-item ng-repeat=\"color in colorLine track by color.id\" ng-class=\"{'color-picker-item-size': !$ctrl.isMobile, 'color-picker-item-size-mobile': $ctrl.isMobile}\" ng-style=\"{'background-color': color.value.replace('0x','#')}\" ng-mouseover=$ctrl.changeColorOnHover(color.value) ng-click=$ctrl.selectColor(color.value)></div></sk-hbox></div></div></sk-vbox>");
  $templateCache.put("components/compactpanel/compact-panel.tpl.html",
    "<sk-vbox id={{ctrl.compactPanelId}} ng-if=ctrl.isLoad class=compact-panel-main sk-width=100% sk-height=100% flex><sk-resizable-rows class=compact-panel-resizable-rows flex><div sk-resizable sk-direction=\"'bottom'\" ng-repeat=\"painelLinhas in dataPanel track by $index\" ng-init=\"firstIndex = $index\" sk-relative-size=\"{{ctrl.resizeRows(ctrl.dataPanel, painelLinhas)}}\" sk-relative-resizable=true><sk-resizable-columns class=compact-panel-resizable-column sk-height=100% style=\"max-width: 100%\"><sk-vbox sk-resizable sk-direction=\"'right'\" ng-init=\"secondIndex = $index\" ng-repeat=\"painelColunas in painelLinhas.colunas track by $index\" sk-relative-size=\"{{ctrl.resizeColumns(painelLinhas, painelColunas)}}\" sk-relative-resizable=true sk-resize-next-preview=true sk-on-change-relative-size=ctrl.onResizePanel(component) ng-class=\"{'sk-maximize__container--maximized': ctrl.maximizedId === painelColunas.identificador}\"><sk-vbox class=\"DashWindow-border-top compact-panel-box\" layout=column sk-width=100% sk-height=100% flex><sk-hbox class=\"DashWindow-TopBar DashWindow-nopadding\" layout-align=start sk-width=100%><sk-hbox flex><sk-title sk-text={{painelColunas.title}} style=\"font-size: 10pt\"></sk-title><button ng-if=\"ctrl.showBtnMaximize || painelColunas.visibleBtnMaximize\" type=button class=sk-maximize__button ng-click=ctrl.maximizeControl(painelColunas.identificador) tooltip={{ctrl.getDataTooltip(painelColunas.identificador)}} tooltip-placement=left><span class=ez-icones ng-class=\"{'ez-icones-compress-arrows': ctrl.containerIsMaximized($index), 'ez-icones-expand-arrows-alt': !ctrl.containerIsMaximized($index)}\"></span></button> <button ng-if=\"ctrl.showBtnClose || painelColunas.visibleBtnClose\" type=button class=sk-remove__button ng-click=\"ctrl.removeControl(painelColunas.identificador, painelColunas.title)\" tooltip=Geral.lblFechar tooltip-placement=left sk-i18n><sk-icon font-icon=remove></sk-icon></button> <button ng-if=\"ctrl.showBtnRefresh || painelColunas.visibleBtnRefresh\" type=button class=sk-remove__button ng-click=ctrl.onClickBtnRefresh(painelColunas.identificador) tooltip=Controls.Dashboard.buttonAtualizar tooltip-placement=left sk-i18n><sk-icon font-icon=refresh></sk-icon></button> <button ng-if=\"ctrl.showBtnConfig || painelColunas.visibleBtnConfig\" type=button class=sk-remove__button ng-click=ctrl.onClickBtnConfig(painelColunas.identificador) tooltip=Controls.Dashboard.buttonConfiguracoes tooltip-placement=left sk-i18n><sk-icon font-icon=cogwheel></sk-icon></button></sk-hbox></sk-hbox><sk-vbox id=\"{{'COMPACT-PANEL-CONTAINER-'+ ctrl.uid + firstIndex + secondIndex }}\" sk-overflow=auto flex></sk-vbox></sk-vbox></sk-vbox></sk-resizable-columns></div></sk-resizable-rows></sk-vbox>");
  $templateCache.put("components/configurableform/configurableform.tpl.html",
    "<div flex class=entity-list-container><sk-form id=form properties=ctrl.formProps sk-dataset=dataset only-props=true sk-on-create-field=ctrl.onCreateField(field) sk-form-interceptor=formInterceptor sk-on-form-loaded=ctrl.onFormLoaded(form) sk-columns={{skColumns}} sk-inline={{inLine}}></sk-form></div>");
  $templateCache.put("components/cronsyntaxselector/cronsyntaxselector.tpl.html",
    "<sk-vbox ng-show=isVisible gap=5 flex><sk-hbox><div class=cronsyntaxselector-wrapper ng-transclude></div><button ng-if=\"showClearButton !==false\" default ng-click=clearAll() sk-i18n>CronSyntaxSelector.clearListsLabel</button></sk-hbox><sk-vbox class=cronsyntax-box layout-padding flex><sk-tabnavigator sk-selected-index=selectedIndex><sk-tabnavigator-item><sk-i18n>CronSyntaxSelector.secondsLabel</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>CronSyntaxSelector.minutesLabel</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>CronSyntaxSelector.hoursLabel</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>CronSyntaxSelector.daysLabel</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>CronSyntaxSelector.monthsLabel</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>CronSyntaxSelector.weekDaysLabel</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=selectedIndex sk-creation-policy=all layout flex><sk-viewstack-content sk-overflow=auto layout-padding><div class=\"row col-xs-12\"><div class=col-xs-4 sk-padding=5px><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=all.second.data sk-change=\"secondChanged(all.second.data, all.second.isAllBtn)\"></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=all.second.label></span></sk-hbox></sk-hbox></div></div><div class=\"row col-xs-12\"><div class=col-xs-2 sk-padding=5px ng-repeat=\"second in seconds\"><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=second.data sk-change=secondChanged(second.data)></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=second.label></span></sk-hbox></sk-hbox></div></div></sk-viewstack-content><sk-viewstack-content sk-overflow=auto layout-padding><div class=\"row col-xs-12\"><div class=col-xs-4 sk-padding=5px><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=all.minute.data sk-change=\"minuteChanged(all.minute.data, all.minute.isAllBtn)\"></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=all.minute.label></span></sk-hbox></sk-hbox></div></div><div class=\"row col-xs-12\"><div class=col-xs-2 sk-padding=5px ng-repeat=\"minute in minutes\"><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=minute.data sk-change=minuteChanged(minute.data)></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=minute.label></span></sk-hbox></sk-hbox></div></div></sk-viewstack-content><sk-viewstack-content sk-overflow=auto layout-padding><div class=\"row col-xs-12\"><div class=col-xs-4 sk-padding=5px><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=all.hour.data sk-change=\"hourChanged(all.hour.data, all.hour.isAllBtn)\"></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=all.hour.label></span></sk-hbox></sk-hbox></div></div><div class=\"row col-xs-12\"><div class=col-xs-2 sk-padding=5px ng-repeat=\"hour in hours\"><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=hour.data sk-change=hourChanged(hour.data)></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=hour.label></span></sk-hbox></sk-hbox></div></div></sk-viewstack-content><sk-viewstack-content sk-overflow=auto layout-padding><div class=\"row col-xs-12\"><div class=col-xs-4 sk-padding=5px><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=all.day.data sk-change=\"dayChanged(all.day.data, all.day.isAllBtn)\"></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=all.day.label></span></sk-hbox></sk-hbox></div></div><div class=\"row col-xs-12\"><div class=col-xs-2 sk-padding=5px ng-repeat=\"day in days\"><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=day.data sk-change=dayChanged(day.data)></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=day.label></span></sk-hbox></sk-hbox></div></div></sk-viewstack-content><sk-viewstack-content sk-overflow=auto layout-padding><div class=\"row col-xs-12\"><div class=col-xs-4 sk-padding=5px><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=all.month.data sk-change=\"monthChanged(all.month.data, all.month.isAllBtn)\"></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=all.month.label></span></sk-hbox></sk-hbox></div></div><div class=\"row col-xs-12\"><div class=col-xs-3 sk-padding=5px ng-repeat=\"month in months\"><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=month.data sk-change=monthChanged(month.data)></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=month.label></span></sk-hbox></sk-hbox></div></div></sk-viewstack-content><sk-viewstack-content sk-overflow=auto layout-padding><div class=\"row col-xs-12\"><div class=col-xs-4 sk-padding=5px><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=all.week.data sk-change=\"daysWeekChanged(all.week.data, all.week.isAllBtn)\"></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=all.week.label></span></sk-hbox></sk-hbox></div></div><div class=\"row col-xs-12\"><div class=col-xs-3 sk-padding=5px ng-repeat=\"week in daysWeek\"><sk-hbox gap=5 flex><sk-hbox align=\"end start\"><sk-switch sk-true-value=true sk-false-value=false sk-value=week.data sk-change=daysWeekChanged(week.data)></sk-switch></sk-hbox><sk-hbox align=\"start center\" sk-margin-top=3px flex><span ng-bind=week.label></span></sk-hbox></sk-hbox></div></div></sk-viewstack-content></sk-viewstack></sk-vbox></sk-vbox>");
  $templateCache.put("components/cubebase/cubebase.tpl.html",
    "<div ng-if=!ctrl.isExternalCube style=\"height: 100%\"><iframe class=cubeBase ng-src={{ctrl.CUBE_SOURCE}} frameborder=0></iframe></div>");
  $templateCache.put("components/dashrenderer/dashboardrenderer.tpl.html",
    "<iframe ng-src=\"{{ src }}\" frameborder=0 scrolling=no sk-load=ctrl.onLoad() ng-style=\"{width: width, height: height}\"></iframe>");
  $templateCache.put("components/datagrid/filtermodal/filtermodal.tpl.html",
    "<div class=datagrid-modal-header-container layout layout-align=\"center center\" ng-show=!utilizaFiltroPeriodo><section class=grid-filter-modal><div class=tab layout=row flex><div class=tab-item ng-class=\"{'selected': selectedList === listNameAll}\" ng-click=selectList(listNameAll) sk-translate>Geral.lblAll</div><div class=\"tab-item tab-count\" ng-class=\"{'selected': selectedList === listNameFiltered}\" ng-click=selectList(listNameFiltered) flex ng-bind=verFiltradosLbl></div></div><div style=\"display: flex; padding: 5px; background-color: #eee\"><sk-checkbox ng-model=allSelected ng-click=onCheckAllClick()></sk-checkbox><sk-text-input sk-value=searchInput sk-placeholder=\"{{ ::labelPesquisar }}\" flex></sk-text-input><sk-icon class=icon-search font-icon=search></sk-icon></div></section></div><div class=datagrid-filter-modal-body flex layout ng-show=!utilizaFiltroPeriodo><span class=filter-not-found-lbl sk-i18n=\"Nenhum registro sendo filtrado...\" ng-if=\"keys[selectedList].length == 0\"></span><md-virtual-repeat-container id=vertical-container flex><div md-virtual-repeat=\"key in keys[selectedList] | filter: searchInput\" class=repeated-item flex><div ng-click=itemClickHandler(key) class=filter-modal-item><sk-checkbox ng-model=column.distinctData[key] ng-click=itemClickHandler(key)>{{ key.substring(0,44) }}</sk-checkbox></div></div></md-virtual-repeat-container></div><sk-vbox align=\"center center\" ng-if=utilizaFiltroPeriodo layout-top-padding flex><sk-simple-form sk-columns=1 flex><sk-simple-item sk-label=\"{{ ::labelFiltraDataVazia }}\"><sk-switch sk-value=column.includeDtEmpty sk-true-value=true sk-false-value=false></sk-switch></sk-simple-item><sk-simple-item sk-label=\"{{ ::labelDefinaPeriodo }}\"><sk-date-period sk-value=periodo></sk-date-period></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("components/datagrid/templates/checkboxheadercell.tpl.html",
    "<div class=datagrid-cbx-header><div ng-init=\"scope=$parent.$parent.$parent.$parent.$parent.$parent.$parent\" ng-class=\"{'datagrid-checkbox-header-com-campo-apresentacao': scope.existeCampoDeApresentacao,\n" +
    "     'datagrid-checkbox-header-sem-campo-apresentacao': !scope.existeCampoDeApresentacao,\n" +
    "     'datagrid-checkbox-header-mobile': scope.isMobile}\"><sk-checkbox ng-disabled=!scope.allowMultipleSelection tooltip={{grid.appScope.checkUncheckAllText}} tooltip-placement=right tooltip-append-to-body=true ng-model=scope.allSelected accept-indeterminate=true indeterminate-value=I ng-change=scope.checkAllRows()></sk-checkbox><div ng-if=grid.appScope.showingFilters tooltip={{grid.appScope.clearAllSearchText}} tooltip-placement=right tooltip-append-to-body=true class=clear-search ng-click=scope.clearSearch();scope.changeColumnSearchVisibility(true,false) ng-class=\"{'datagrid-checkbox-filter-icon': grid.appScope.isMobile}\"><sk-icon font-icon=filter style=color:black ng-if=grid.appScope.showingFilters></sk-icon><sk-icon font-icon=remove-2 ng-class=\"{'filter-x-com-apresentacao': grid.appScope.existeCampoDeApresentacao, 'filter-x-sem-apresentacao': !grid.appScope.existeCampoDeApresentacao}\" ng-if=grid.appScope.showingFilters></sk-icon></div></div></div>");
  $templateCache.put("components/datagrid/templates/datagrid.aggrid.tpl.html",
    "<div class=hide ng-if=tour ng-joy-ride=tour.startTour config=tour.tourConfig on-finish=tour.onFinish() on-skip=tour.onFinish()></div><div class=sk-aggrid id={{uniqueid}}-root><div class=grid-menu></div><div id={{uniqueid}} class=sk-aggrid-container ng-click=onGridContainerClick($event)></div><div class=\"ui-grid-grid-footer ui-grid-footer-info data-grid-footer-info datagrid-footer-rows-counter ng-scope\" ng-if=\"dataset.getSelectedRecords() && dataset.getSelectedRecords().length > 1\"><div class=sk-rows-counter><div class=rows-counter-div tooltip-placement=left sk-i18n ng-bind=\"dataset.getSelectedRecords().length + ' {{selectRecords}}'\"></div></div></div><div id={{uniqueid}} class=sk-tour-infinitt-scroll-ref style=\"position: absolute; top: 50%; right: 0px; width: 15px\"></div></div><div ng-transclude style=\"display: none\"></div>");
  $templateCache.put("components/datagrid/templates/datagrid.jqx.tpl.html",
    "<div class=jqx-grid-container></div><div ng-transclude style=\"display: none\"></div>");
  $templateCache.put("components/datagrid/templates/datagrid.tpl.html",
    "<div class=hide ng-if=tour ng-joy-ride=tour.startTour config=tour.tourConfig on-finish=tour.onFinish() on-skip=tour.onFinish()></div><div class=sk-datagrid-container><div ui-i18n={{lang}} class=datagrid ng-keydown=keydownHandler($event) ng-keyup=keyupHandler($event) tabindex=0 creation-complete=creationComplete()><div ng-bind=::stateText class=state-text ng-show=\"viewMode == 'loading'\"></div><div class=\"sk-loading-bar progress progress-striped\" ng-if=datagridOperationInProgress><div class=progress-bar role=progressbar></div></div><div ng-show=\"viewMode == 'loaded'\" ui-grid=datagrid class=datagrid ui-grid-edit ui-grid-resize-columns ui-grid-pagination ui-grid-pinning ui-grid-grouping ui-grid-selection ui-grid-move-columns ui-grid-cellnav></div></div></div><div ng-transclude style=\"display: none\"></div>");
  $templateCache.put("components/datagrid/templates/editcell.tpl.html",
    "<div ng-switch=col.colDef.userType><sk-time-input ng-switch-when=T sk-datagrid-editor=true ng-class=\"'colt' + col.uid\" sk-dataset=::grid.appScope.dataset sk-field-index={{::col.colDef.field}}></sk-time-input><sk-date-input ng-switch-when=D sk-align={{::col.colDef.cellTextAlignment}} sk-datagrid-editor=true ng-class=\"'colt' + col.uid\" sk-dataset=::grid.appScope.dataset sk-field-index={{::col.colDef.field}} sk-append-to-body=true></sk-date-input><sk-date-time-input ng-switch-when=H sk-align={{::col.colDef.cellTextAlignment}} sk-datagrid-editor=true ng-class=\"'colt' + col.uid\" sk-dataset=::grid.appScope.dataset sk-field-index={{::col.colDef.field}} sk-append-to-body=true></sk-date-time-input><div ng-switch-default><sk-combobox ng-if=\"::col.colDef.presentationType == 'O'\" sk-align={{::col.colDef.cellTextAlignment}} sk-datagrid-editor=true ng-class=\"'colt' + col.uid\" sk-dataset=::grid.appScope.dataset sk-field-index={{::col.colDef.field}} sk-options=col.colDef.options sk-append-to-body=::true></sk-combobox><sk-text-input ng-if=\"::col.colDef.presentationType == 'P'\" sk-align={{::col.colDef.cellTextAlignment}} sk-datagrid-editor=true ng-class=\"'colt' + col.uid\" sk-dataset=::grid.appScope.dataset sk-field-index={{::col.colDef.field}}></sk-text-input></div></div>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/clearsearch.tpl.html",
    "<div class=datagrid-menu-item layout layout-align=\"left center\" ng-if=shown() ng-click=action($event)><sk-icon font-icon=delete></sk-icon>&nbsp&nbsp{{::$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.clearAllSearchText}}</div>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/comfortablemode.tpl.html",
    "<div class=\"datagrid-menu-item datagrid-comfortable-item\" layout layout-align=\"left center\" ng-if=shown() ng-click=action($event)><sk-icon font-icon=list-alt></sk-icon>&nbsp&nbsp{{::$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.comfortableModeText}}</div>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/compactmode.tpl.html",
    "<div class=datagrid-menu-item layout layout-align=\"left center\" ng-if=shown() ng-click=action($event)><sk-icon font-icon=compressed></sk-icon>&nbsp&nbsp{{::$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.compactModeText}}</div>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/datagridtypeahead.tpl.html",
    "<a tabindex=-1 bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/findcolumn.tpl.html",
    "<div class=\"datagrid-menu-item datagrid-menu-item-search\" layout layout-align=\"left center\"><sk-typeahead-input ng-click=\"action($event, title)\" sk-get-options=context.loadSuggestions sk-is-loading=searching sk-key=key sk-label=label sk-on-select=context.onSelectEntity sk-show-more=false sk-append-to-body=true sk-placeholder={{::$parent.$parent.$parent.$parent.$parent.$parent.$parent.findColumnText}}... sk-min-length=0 sk-load-on-focus=false class=datagrid-menu-typeahead style=padding-left:4px></sk-typeahead-input><sk-icon font-icon=binoculars></sk-icon></div>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/inittour.tpl.html",
    "<div class=datagrid-menu-item layout layout-align=\"left center\" ng-if=shown() ng-click=action($event)><sk-icon font-icon=train></sk-icon>&nbsp&nbsp<span sk-i18n>EntityStartPage.sideMenu.lblIniciarTour</span></div>");
  $templateCache.put("components/datagrid/templates/gridmenuitems/search.tpl.html",
    "<div class=\"datagrid-menu-item datagrid-search-menu-item\" layout layout-align=\"left center\" ng-if=shown() ng-click=action($event)><sk-icon font-icon=search></sk-icon>&nbsp&nbsp{{::$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.searchText}}</div>");
  $templateCache.put("components/datagrid/templates/uigridcell.check.tpl.html",
    "<div class=ui-grid-cell-contents layout=column layout-align=center style=min-width:50px><sk-switch ng-class=\"'colt' + col.uid\" sk-datagrid-editor=true sk-value=row.entity[col.colDef.field] sk-change=\"grid.appScope.liveCheckChanged(row, col)\"></sk-switch></div>");
  $templateCache.put("components/datagrid/templates/uigridcell.textarea.tpl.html",
    "<div class=\"ui-grid-cell-contents ui-grid-cell-content-text-area\" layout=column layout-align=center style=min-width:50px><div ng-bind=currCellValue class=\"text-ellipsis ui-grid-cell-textarea-value\" title={{currCellValue}}></div><sk-icon class=grid-cell-textarea-icon ng-click=\"grid.appScope.openTextAreaEditor(row, col, currCellValue, updateCell)\" tooltip={{::grid.appScope.lblExpandCell}} svg-src=maximize.svg></sk-icon></div>");
  $templateCache.put("components/datagrid/templates/uigridcell.tpl.html",
    "<div ng-bind-html=currCellValue class=ui-grid-cell-contents layout=column layout-align=center style=min-width:50px></div>");
  $templateCache.put("components/datagrid/templates/uigridfilter.tpl.html",
    "<div class=ui-grid-filter-container ng-repeat=\"colFilter in col.filters\" ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\"><div ng-if=\"colFilter.type !== 'select'\"><input class=ui-grid-filter-input ng-model=colFilter.term ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\"></div><div ng-if=\"colFilter.type === 'select'\"><select class=ui-grid-filter-select ng-model=colFilter.term ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div class=ui-grid-filter-button-select ng-click=\"colFilter.term = null\" ng-if=!colFilter.disableCancelFilterButton><i class=ui-grid-icon-cancel ng-show=\"colFilter.term !== undefined && colFilter.term != null\">&nbsp;</i></div></div></div>");
  $templateCache.put("components/datagrid/templates/uigridfooter.tpl.html",
    "<div class=\"ui-grid-footer-panel ui-grid-footer-aggregates-row\" layout layout-align=\"center center\"><div class=\"ui-grid-footer ui-grid-footer-viewport\"><div class=ui-grid-footer-canvas><div class=ui-grid-footer-cell-wrapper ng-style=colContainer.headerCellWrapperStyle()><div class=ui-grid-footer-cell-row><div ng-repeat=\"col in colContainer.renderedColumns track by col.colDef.name\" ui-grid-footer-cell col=col render-index=$index class=\"ui-grid-footer-cell ui-grid-clearfix\" ng-class=\"{'datagrid-cbx-column-footer-height': col.colDef.field == -100000 && !grid.appScope.showingFilters, 'datagrid-cbx-column-footer-height-with-filter': col.colDef.field == -100000 && grid.appScope.showingFilters}\"></div></div></div></div></div></div>");
  $templateCache.put("components/datagrid/templates/uigridfootercell.tpl.html",
    "<div class=ui-grid-cell-contents style=\"text-align:right;padding: 0 5px\" col-index=renderIndex><div style=font-size:15px>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>");
  $templateCache.put("components/datagrid/templates/uigridgridfooter.tpl.html",
    "<div class=\"ui-grid-grid-footer ui-grid-footer-info\" layout layout-align=\"right center\"><span>{{'search.totalItems' | t}} {{grid.rows.length}}</span> &nbsp</div>");
  $templateCache.put("components/datagrid/templates/uigridheader.tpl.html",
    "<div class=ui-grid-top-panel><div class=ui-grid-header-viewport><div class=ui-grid-header-canvas><div class=ui-grid-header-cell-wrapper ng-style=colContainer.headerCellWrapperStyle()><div class=ui-grid-header-cell-row><div class=\"ui-grid-header-cell ui-grid-clearfix\" ng-class=col.headerClass ng-repeat=\"col in colContainer.renderedColumns track by col.colDef.name\" ui-grid-header-cell col=col render-index=$index></div></div></div></div></div></div>");
  $templateCache.put("components/datagrid/templates/uigridheadercell.tpl.html",
    "<div ng-class=\"{ 'sortable': sortable, 'datagrid-atificial-padding': col.sort.direction != 'desc' && col.sort.direction != 'asc','datagrid-border-color-red':col.sort.direction == 'desc','datagrid-border-color-green':col.sort.direction == 'asc' }\"><div class=ui-grid-cell-contents ng-class=\"{'datagrid-header-padding-desktop':!grid.appScope.isMobile,'datagrid-header-padding-mobile':grid.appScope.isMobile,\n" +
    "    'datagrid-header-height-mobile':grid.appScope.isMobile}\" col-index=renderIndex><span class=datagrid-column-label ng-class=\"{'datagrid-column-found':col.highlight}\">{{ col.displayName CUSTOM_FILTERS }}</span></div><div ng-if=grid.appScope.isFiltering(col) class=datagrid-header-filter tooltip={{grid.appScope.columnFilterActiveText}} tooltip-append-to-body=true tooltip-placement=top ng-class=\"{'datagrid-header-padding-desktop':!grid.appScope.isMobile,'datagrid-header-padding-mobile':grid.appScope.isMobile,\n" +
    "         'datagrid-header-height-mobile':grid.appScope.isMobile}\" ng-click=grid.appScope.clearDistinctFilter(col)><sk-icon font-icon=filter style=color:red></sk-icon></div><div class=ui-grid-column-menu-button ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader &&\n" +
    "         col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event);col.colDef.showMenu = !col.colDef.showMenu;\" ng-class=\"{'datagrid-visible': col.colDef.showMenu || grid.appScope.isMobile}\" tooltip={{grid.appScope.columnOptionsText}} tooltip-append-to-body=true><sk-icon font-icon=option-vertical class=datagrid-column-menu ng-class=\"{'datagrid-column-menu-pressed':col.colDef.showMenu}\"></sk-icon></div><div ui-grid-filter></div></div>");
  $templateCache.put("components/datagrid/templates/uigridmenu.tpl.html",
    "<div class=ui-grid-menu ng-if=shown><div class=ui-grid-menu-mid ng-show=shownMid><div class=ui-grid-menu-inner><ul class=ui-grid-menu-items><li ng-repeat=\"item in menuItems\" ui-grid-menu-item action=item.action name=item.title active=item.active icon=item.icon shown=item.shown context=item.context template-url=item.templateUrl leave-open=item.leaveOpen></li></ul></div></div></div>");
  $templateCache.put("components/datagrid/templates/uigridmenubutton.tpl.html",
    "<div class=ui-grid-menu-button ng-click=toggleMenu();grid.appScope.endEdit() ng-class=\"{'datagrid-header-menu':grid.appScope.isMobile}\"><div class=ui-grid-icon-container><sk-icon font-icon=menu-hamburger tooltip={{grid.appScope.datagridOptionsText}} tooltip-placement=left tooltip-append-to-body=true></sk-icon></div><div ui-grid-menu menu-items=menuItems></div></div>");
  $templateCache.put("components/datagrid/templates/uigridpagination.tpl.html",
    "<div class=ui-grid-pager-panel ui-grid-pager ng-show=grid.options.enablePaginationControls layout layout-align=\"center center\" ng-class=\"{'datagrid-padding-bottom-10': paginationApi.getTotalPages() <= 1}\"><div class=ui-grid-grid-footer><div class=ui-grid-pager-control><button type=button class=\"btn btn-default btn-sk-sm datagrid-pagination-btns datagrid-btn-first-page\" ng-show=\"paginationApi.getTotalPages() > 1\" ng-click=paginationApi.seek(1) ng-disabled=cantPageBackward()><sk-icon svg-src=/mge/assets/svg/rewind.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm datagrid-pagination-btns datagrid-btn-previous-page\" ng-show=\"paginationApi.getTotalPages() > 1\" ng-click=paginationApi.previousPage() ng-disabled=cantPageBackward()><sk-icon svg-src=/mge/assets/svg/back.svg></sk-icon></button> <span class=datagrid-pagination-indicator ng-if=\"grid.appScope.records.length > 0\"><b>&nbsp&nbsp{{grid.appScope.lblPagina}} {{grid.options.paginationCurrentPage}} {{grid.appScope.lblDe}} {{paginationApi.getTotalPages()}}&nbsp&nbsp</b></span> <span class=datagrid-pagination-indicator ng-if=\"grid.appScope.records.length <= 0\"><b>&nbsp{{grid.appScope.lblNenhumaPagina}}&nbsp</b></span> <button type=button class=\"btn btn-default btn-sk-sm datagrid-pagination-btns datagrid-btn-next-page\" ng-show=\"paginationApi.getTotalPages() > 1\" ng-click=paginationApi.nextPage() ng-disabled=cantPageForward()><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm datagrid-pagination-btns datagrid-btn-last-page\" ng-show=\"paginationApi.getTotalPages() > 1\" ng-click=paginationApi.seek(paginationApi.getTotalPages()) ng-disabled=cantPageToLast()><sk-icon svg-src=/mge/assets/svg/forward.svg></sk-icon></button></div></div></div><div class=\"ui-grid-grid-footer ui-grid-footer-info data-grid-footer-info datagrid-footer-rows-counter\" ng-if=\"grid.api.selection.getSelectedRows().length > 1\"><div class=sk-rows-counter><div class=rows-counter-div tooltip-placement=left>{{grid.api.selection.getSelectedRows().length}} {{'search.lblSelectedRecords' | t}}</div></div></div>");
  $templateCache.put("components/datagrid/templates/uigridrow.tpl.html",
    "<div ng-click=grid.appScope.rowClickHandler($event,col,row) ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" class=ui-grid-cell ui-grid-cell ng-class=\"{'{{col.headerClass}}':true}\"></div>");
  $templateCache.put("components/datagrid/templates/uigridselectionrowheader.tpl.html",
    "<div class=ui-grid-disable-selection><div class=ui-grid-cell-contents><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div></div>");
  $templateCache.put("components/datagrid/templates/uigridselectionrowheaderbuttons.tpl.html",
    "<div ng-click=grid.appScope.checkboxRowClickHandler(row,row.isSelected)><div ng-if=!row.isSelected ng-click=grid.appScope.checkboxRowClickHandler(row,row.isSelected)><div ng-if=grid.appScope.existeCampoDeApresentacao ng-style=\"{'background': grid.appScope.textToColor(row.entity[grid.appScope.presentationField]), 'color': 'white', 'margin': '1px', 'text-align': 'center', 'line-height': (grid.appScope.checkboxHeight - 2) + 'px', 'opacity': '0.78'}\">{{grid.appScope.buildNick(row)}}</div></div><div ng-if=row.isSelected ng-click=grid.appScope.checkboxRowClickHandler(row,row.isSelected)><div ng-if=grid.appScope.existeCampoDeApresentacao ng-style=\"{'background': 'transparent', '\\-webkit-border-radius': '5px', 'border-radius': '5px', 'text-align': 'center', 'line-height': grid.appScope.checkboxHeight + 'px', 'height': grid.appScope.checkboxHeight + 'px' ,'margin': '0 1px 0 1px', 'opacity': '0.78'}\"><sk-icon font-icon=ok-2 style=\"line-height: {{grid.appScope.checkboxHeight}}px\"></sk-icon></div></div><div ng-if=!grid.appScope.existeCampoDeApresentacao ng-class=\"{'datagrid-checkbox-sem-campo-apresentacao': grid.appScope.compactMode, 'datagrid-checkbox-mobile': !grid.appScope.compactMode}\" style=border:none><sk-checkbox ng-model=row.isSelected></sk-checkbox></div></div>");
  $templateCache.put("components/dataset/dataimporter/dataimporter.tpl.html",
    "<sk-dataset entity-name=DataSetImport sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone></sk-dataset><sk-dataset entity-name=DataSetFilter sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><div ng-repeat=\"field in ctrl.customFieldsFilter\"><sk-dsfield-md usertype={{field.userType}} name={{field.name}} description={{field.description}}></sk-dsfield-md></div></sk-dataset><sk-vbox sk-padding=4px flex><sk-vbox ng-if=!ctrl.insertionMode><label class=group-title sk-i18n>Geral.filtros</label><sk-hbox><sk-form sk-dataset=ctrl.dsFilter sk-form-interceptor=ctrl.formFilterInterceptor layout-padding flex><sk-form-custom-block><button brand ng-click=ctrl.importData() sk-i18n>Geral.lblImportar</button></sk-form-custom-block></sk-form></sk-hbox><sk-hbox class=\"alert alert-warning\" ng-if=ctrl.msgVariosRegistros role=alert align=\"start center\"><sk-hbox><sk-navigator dataset=ctrl.dsImport show-crud=false></sk-navigator><sk-vbox layout-left-padding layout-rigth-padding><span sk-margin-top=5px ng-bind-html=ctrl.msgVariosRegistros></span></sk-vbox></sk-hbox></sk-hbox></sk-vbox><sk-tab sk-selected-index=ctrl.selectedTabIndex sk-creation-policy=all flex><sk-tab-item label=Geral.lblImportacao sk-i18n flex><sk-form sk-dataset=ctrl.dsImport sk-form-interceptor=ctrl.formImportInterceptor style=\"overflow: auto; height: 100%; width: 100%\" layout-top-padding flex></sk-form></sk-tab-item><sk-tab-item label=Geral.lblDivergencias ng-show=ctrl.msgOfDivergences sk-i18n flex><sk-text-area sk-value=ctrl.msgOfDivergences sk-enabled=true style=\"color:red; overflow: auto\" sk-height=100% flex></sk-text-area></sk-tab-item></sk-tab><sk-vbox layout-left-padding layout-rigth-padding layout-top-padding><span>{{ctrl.msgInfomacaoWS}}</span></sk-vbox></sk-vbox>");
  $templateCache.put("components/dataset/deepcopy/deepcopypopup.tpl.html",
    "<sk-checkbox-list sk-label=Geral.lblAll sk-options=ctrl.metadata sk-value=ctrl.selectedMD></sk-checkbox-list><sk-checkbox style=\"margin-top: 5px\" ng-model=ctrl.keepChoice><sk-i18n>DeepCopy.manterEscolha</sk-i18n></sk-checkbox>");
  $templateCache.put("components/dateperiod/dateperiod.tpl.html",
    "<div ng-show=!buttonMode class=input-group layout=row flex><div><input class=form-control ng-model=ctrl.dtIni ng-change=ctrl.onChange(true) ng-blur=ctrl.notifyChange(true) ng-focus=ctrl.openOnFocus(true) ng-required=isRequired ng-disabled=!enabled></div><div class=pipe></div><div><input class=form-control ng-model=ctrl.dtFim ng-change=ctrl.onChange(false) ng-blur=ctrl.notifyChange(false) ng-focus=ctrl.openOnFocus() ng-required=isRequired ng-disabled=!enabled></div><div class=btn-open ng-click=ctrl.openCalendar() ng-disabled=!enabled><sk-icon font-icon=calendar sk-enabled=enabled></sk-icon></div></div><div ng-if=buttonMode class=\"button-mode btn-open\" ng-click=ctrl.openCalendar() ng-disabled=!enabled><sk-icon font-icon=calendar sk-enabled=enabled></sk-icon></div>");
  $templateCache.put("components/dateperiod/popup.tpl.html",
    "<div class=dates-container layout-padding layout=row flex><div class=datepicker layout-padding><span class=label-title sk-translate>Geral.lblPeriodoIni</span><sk-datepicker ng-model=value.dtIni on-select-date=selectDate(true) show-weeks=false on-create=onCreateDtPickerInit(datepicker)></sk-datepicker></div><div class=datepicker layout-padding><span class=label-title sk-translate>Geral.lblPeriodoFin</span><sk-datepicker ng-model=value.dtFim on-select-date=selectDate(false) min-date=value.dtIni show-weeks=false on-create=onCreateDtPickerFim(datepicker)></sk-datepicker></div><div class=actions><ul class=\"nav nav-tabs nav-pills nav-stacked wells\"><li><a href=\"\" ng-click=selectDt() sk-translate>Geral.lblHoje</a></li><li><a href=\"\" ng-click=\"selectDt('yesterday')\" sk-translate>Geral.lblOntem</a></li><li><a href=\"\" ng-click=\"selectDt('last7days')\" sk-translate>Geral.lblUltimos7dias</a></li><li><a href=\"\" ng-click=\"selectDt('last30days')\" sk-translate>Geral.lblUltimos30dias</a></li><li><a href=\"\" ng-click=\"selectDt('currentMonth')\" sk-translate>Geral.lblMesAtual</a></li><li><a href=\"\" ng-click=\"selectDt('lastMonth')\" sk-translate>Geral.lblMesAnterior</a></li></ul><sk-hbox class=button-mode-box ng-show=buttonMode><button primary small ng-click=selectDate(false) flex sk-i18n>Geral.lblAplicar</button></sk-hbox></div></div>");
  $templateCache.put("components/datepicker/template/datepicker.tpl.html",
    "<div ng-switch=datepickerMode role=application ng-keydown=keydown($event)><sk-daypicker ng-switch-when=day tabindex=0></sk-daypicker><sk-monthpicker ng-switch-when=month tabindex=0></sk-monthpicker><sk-yearpicker ng-switch-when=year tabindex=0></sk-yearpicker></div>");
  $templateCache.put("components/datepicker/template/day.tpl.html",
    "<table role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left\" ng-click=move(-1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th><th colspan=\"{{::5 + showWeeks}}\"><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm\" ng-click=\"toggleMode(1, $event)\" ng-disabled=\"datepickerMode === maxMode\" tabindex=-1 style=width:100%><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right\" ng-click=move(1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th></tr><tr><th ng-if=showWeeks class=text-center></th><th ng-repeat=\"label in ::labels track by $index\" class=text-center><small aria-label={{::label.full}}>{{::label.abbr}}</small></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-if=showWeeks class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center item-container\" role=gridcell id={{::dt.uid}} ng-class=::dt.customClass><button type=button ng-if=\"onlyCurrentMonth ? !dt.secondary : true\" style=min-width:100% class=\"btn btn-default btn-sm\" ng-class=\"{'btn-primary': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date, $event)\" ng-disabled=dt.disabled tabindex=-1><span ng-class=\"::{'text-muted': dt.secondary, 'current-day': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
  $templateCache.put("components/datepicker/template/month.tpl.html",
    "<table role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left\" ng-click=move(-1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th><th><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm\" ng-click=\"toggleMode(1, $event)\" ng-disabled=\"datepickerMode === maxMode\" tabindex=-1 style=width:100%><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right\" ng-click=move(1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center item-container\" role=gridcell id={{::dt.uid}} ng-class=::dt.customClass><button type=button style=min-width:100% class=\"btn btn-default\" ng-class=\"{'btn-primary': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date, $event)\" ng-disabled=dt.disabled tabindex=-1><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
  $templateCache.put("components/datepicker/template/popup.tpl.html",
    "<ul class=dropdown-menu ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=keydown($event)><li style=\"padding: 5px\" ng-transclude></li><li style=\"padding:10px 9px 2px\"><span class=pull-right><button type=button class=\"btn btn-sm btn-primary border\" ng-click=\"select('today', $event)\" sk-i18n>Geral.lblHoje</button> <button type=button class=\"btn btn-sm btn-default border\" ng-click=\"select(undefined, $event)\" sk-i18n>Commons.Expressoes.buttonLimpar</button></span></li></ul>");
  $templateCache.put("components/datepicker/template/year.tpl.html",
    "<table role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left\" ng-click=move(-1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th><th colspan=3><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm\" ng-click=\"toggleMode(1, $event)\" ng-disabled=\"datepickerMode === maxMode\" tabindex=-1 style=width:100%><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right\" ng-click=move(1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center item-container\" role=gridcell id={{::dt.uid}}><button type=button style=min-width:100% class=\"btn btn-default\" ng-class=\"{'btn-primary': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date, $event)\" ng-disabled=dt.disabled tabindex=-1><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
  $templateCache.put("components/defaultfilter/defaultfilter.tpl.html",
    "<sk-hbox sk-margin=\"5px 0 15px 0\" ng-if=filterPF><sk-icon font-icon=alert sk-margin=\"0 5px 0 0\"></sk-icon><a href=\"\" ng-click=visualizarFiltroLegado() flex sk-translate>DynaformConfig.lblFiltroLegado</a></sk-hbox><form name=filterAssistentForm novalidate><filter-assistent form=filterAssistentForm standalone-mode=true transient-filter=transientFilter entity-name=\"{{ ::ctrl.entityName }}\" resource-id=\"{{ ::ctrl.resourceId }}\"></filter-assistent></form>");
  $templateCache.put("components/diagram/diagram.tpl.html",
    "<div class=sk-diagram><svg id={{$ctrl.svgID}} class=sk-diagram-container></svg></div>");
  $templateCache.put("components/doublefacepanel/doublefacepanel.tpl.html",
    "<div class=top-bar ng-hide=hideButtonGridForm><div class=\"btn-group btn-change-face-group dropdown\" dropdown><button ng-hide=hideButtonDoubleFace class=\"btn btn-default btn-sk-sm btn-change-face\" ng-click=changeFace() ng-disabled=ctrl.getDoubleViewActived() tooltip=\"{{customFormTooltip && ['list','table'].indexOf(iconChangeFace) == -1? customFormTooltip : iconChangeFace == 'list' ? 'DoubleFacePanel.tooltipModoForm' : 'DoubleFacePanel.tooltipModoGrade' | translate}}\" tooltip-placement={{toolTipPlacement}}><sk-icon font-icon={{iconChangeFace}}></sk-icon></button> <button type=button ng-if=\"getInternalActions().length > 0\" class=\"btn btn-default dropdown-toggle\" dropdown-toggle><span class=caret></span></button><ul class=dropdown-menu role=menu aria-labelledby=split-button><li ng-repeat=\"action in getInternalActions()\" role=menuitem ng-click=action.action(scope) ng-class=\"{ 'dropdown-menu-item--checked': action.showCheck && ctrl.getDoubleViewActived() }\"><a ng-bind=::action.label></a></li></ul></div></div><div class=content ng-class=\"{ 'content--double-view': ctrl.getDoubleViewActived() }\" ng-transclude></div>");
  $templateCache.put("components/draggablelist/draggablelist.tpl.html",
    "<div class=\"fill-size items-container\" layout=column flex><div sk-scroll-container layout=column flex><div style=\"overflow: auto; z-index: 1\" layout=column flex><div class=\"item {{'item-' + $index}} draggable-item\" ng-class=\"{'item-bg-gray': $odd ,'item-selected': selectedItems.indexOf(item) > -1, 'handlable': moveToRight !== false}\" ng-repeat=\"item in srcData track by $index\" ng-click=\"selectItem(item, $event)\" ng-mousedown=\"onMouseDown(item, $event)\" index={{$index}} draggable=true><div sk-component-transclude=itemTpl><div ng-bind=item></div></div></div></div></div></div>");
  $templateCache.put("components/dropdown/dropdown.tpl.html",
    "<div class=btn-group dropdown><button type=button class=\"btn btn-default dropdown-toggle\" dropdown-toggle layout=row layout-aling=\"space-around center\"><span class=dropdown-text ng-if=text ng-bind=text></span><sk-icon ng-if=fontIcon font-icon={{fontIcon}}></sk-icon><sk-icon ng-if=svgUrl svg-src={{svgUrl}}></sk-icon><span class=caret></span></button><ul class=dropdown-menu role=menu></ul></div>");
  $templateCache.put("components/dropdownmenu/dropdownmenu.tpl.html",
    "<div class=btn-group><button class=\"btn btn-{{colorBtn ? colorBtn : 'default'}} btn-sk-sm\" ng-click=onClick($event) tooltip={{::tooltipBtn}} tooltip-placement=\"{{ tooltipPlacement ? tooltipPlacement : 'bottom' }}\" tooltip-append-to-body=true id=btn-action ng-disabled=disabled><sk-icon ng-if=::fontIcon font-icon={{fontIcon}} v={{iconVersion}}></sk-icon><sk-icon ng-if=::svgIcon svg-src={{svgIcon}}></sk-icon><span class=button-label ng-if=::label ng-bind=\"label | i18n\"></span></button> <button type=button class=\"btn btn-{{colorBtn ? colorBtn : 'default'}} dropdown-toggle\" ng-click=onClick($event) sk-popover popover-template-url=dropdownmenucomp.html always-load-properties=buildOnEveryClick create-on-load=false show-btn-apply=false show-btn-close=false width=auto height=\"{{popOverMaxHeight != undefined ? '' : 'auto'}}\" padding=\"{{ squareMode ? 15 : 0 }}\" popover-class=\"white-popover sk-dropdownmenu-popover\" max-height={{popOverMaxHeight}} properties=ctrl.getPopoverProperties popover-listeners=ctrl.popoverListener hide-on-scroll=true hide-delay=100 before-close-handler=beforeClose() ng-disabled=disabled><span class=caret></span></button></div><script type=text/ng-template id=dropdownmenucomp.html><div ng-if=\"squareMode\" class=\"actions-container actions-container-cursor\" sk-scroll-container>\n" +
    "        <div layout-wrap layout=\"row\">\n" +
    "            <div class=\"separator-container\" ng-repeat=\"group in groupedOptions | filter:{visible:true} track by $index\" layout-wrap layout=\"row\">\n" +
    "                <div class=\"separator-title\" ng-if=\"groupedOptions.length > 1\" ng-bind=\"group.groupName\"></div>\n" +
    "                <div class=\"action-item\" ng-repeat=\"option in group.options | filter:{visible:true} track by option.uid\"\n" +
    "                     sk-disabled=\"option.enabled === false\" ng-click=\"itemClickAction(option, $event);\" layout=\"column\" layout-align=\"start center\"\n" +
    "                     sk-popover \n" +
    "                     popover-template-url=\"listoptions.html\"\n" +
    "                     popover-placement =\"left\"\n" +
    "                     always-load-properties=\"false\" \n" +
    "                     create-on-load=\"false\" \n" +
    "                     show-btn-apply=\"false\" \n" +
    "                     show-btn-close=\"false\"\n" +
    "                     show-triangle=\"true\"\n" +
    "                     enable=\"option.child != undefined\"\n" +
    "                     width=\"auto\"\n" +
    "                     height=\"auto\"\n" +
    "                     popover-class=\"white-popover sk-dropdownmenu-popover\"\n" +
    "                     properties=\"getPopoverOptionsProperties(option)\" \n" +
    "                     always-load-properties=\"true\" \n" +
    "                     hide-on-scroll=\"true\" \n" +
    "                     hide-delay=\"100\"\n" +
    "                     padding=\"5\"\n" +
    "                     popover-listeners=\"listenerPopOverLinkedList\">\n" +
    "                    <div class=\"img-container\">\n" +
    "                        <div ng-if=\"::option.icon == undefined && option.type != 'check'\" class=\"nick-contaner\" ng-style=\"{'background-color': textToColor(option.label)}\"\n" +
    "                             tooltip=\"{{::option.tooltip ? option.tooltip : option.label}}\" tooltip-placement=\"bottom\">\n" +
    "                            <span ng-bind=\"::buildNick(option.label)\"></span>\n" +
    "                        </div>\n" +
    "                        <sk-icon class=\"nick-contaner\" ng-if=\"::option.icon && option.type != 'check'\" svg-src=\"{{::option.icon}}\" \n" +
    "                                 tooltip=\"{{::option.tooltip ? option.tooltip : option.label}}\" \n" +
    "                                 tooltip-placement=\"bottom\">\n" +
    "                        </sk-icon>\n" +
    "                        <sk-icon v=\"2\" sk-margin=\"0px 7px 0px 0px\" ng-if=\"::option.fontIcon\" font-icon=\"{{::option.fontIcon}}\"\n" +
    "                                 tooltip=\"{{::option.tooltip ? option.tooltip : option.label}}\" \n" +
    "                                 tooltip-placement=\"bottom\"\n" +
    "                                 sk-font-size=\"16px\">\n" +
    "                        </sk-icon>\n" +
    "                        <div ng-if=\"option.type == 'check'\" class=\"check-contaner\"\n" +
    "                             tooltip=\"{{::option.tooltip ? option.tooltip : option.label}}\" tooltip-placement=\"bottom\">\n" +
    "                                <sk-switch\n" +
    "                                        sk-value=\"option.checked\"\n" +
    "                                        sk-true-value=\"true\"\n" +
    "                                        sk-false-value=\"false\"\n" +
    "                                        sk-prevent-click=\"true\">\n" +
    "                                </sk-switch>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <span class=\"action-label\" ng-bind=\"::option.label\"></span>\n" +
    "                </div>\n" +
    "                <div class=\"clearfix\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"clearfix\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!squareMode\" class=\"simple-actions-container\" sk-scroll-container>\n" +
    "        <ul class=\"dropdown-menu-simple\" ng-repeat=\"group in groupedOptions | filter:{visible:true} track by $index\" role=\"menu\" aria-labelledby=\"split-button\">\n" +
    "            <div class=\"separator-title\" ng-if=\"groupedOptions.length > 1\" ng-bind=\"group.groupName\"></div>\n" +
    "\n" +
    "            <li  sk-popover \n" +
    "                popover-template-url=\"listoptions.html\"\n" +
    "                popover-placement =\"left\"\n" +
    "                always-load-properties=\"false\" \n" +
    "                create-on-load=\"false\" \n" +
    "                show-btn-apply=\"false\" \n" +
    "                show-btn-close=\"false\"\n" +
    "                show-triangle=\"false\"\n" +
    "                enable=\"option.child != undefined\"\n" +
    "                width=\"auto\"\n" +
    "                height=\"auto\"\n" +
    "                popover-class=\"white-popover sk-dropdownmenu-popover\"\n" +
    "                properties=\"getPopoverOptionsProperties(option)\" \n" +
    "                always-load-properties=\"true\" \n" +
    "                hide-on-scroll=\"true\" \n" +
    "                hide-delay=\"100\"\n" +
    "                padding=\"5\"\n" +
    "                popover-listeners=\"listenerPopOverLinkedList\"\n" +
    "                role=\"menuitem\"\n" +
    "                ng-disabled=\"option.enabled === false\"\n" +
    "                ng-repeat=\"option in group.options | filter:{visible:true} track by option.uid\"\n" +
    "                ng-click=\"itemClickAction(option, $event)\">\n" +
    "                <div style=\"display: inline-flex; align-items: center;\">\n" +
    "                    <sk-icon ng-if=\"option.child != undefined\" font-icon=\"chevron-left\"></sk-icon>\n" +
    "                    <sk-icon ng-if=\"option.child == undefined\" font-icon=\"\"></sk-icon>\n" +
    "                    <sk-icon sk-margin=\"0px 7px 0px 0px\" ng-if=\"::option.icon && option.type != 'check'\" svg-src=\"{{::option.icon}}\"></sk-icon>\n" +
    "                    <sk-icon v=\"2\" sk-font-size=\"16px\" sk-margin=\"0px 7px 0px 0px\" ng-if=\"::option.fontIcon\" font-icon=\"{{::option.fontIcon}}\"></sk-icon>\n" +
    "                    <div ng-if=\"option.type == 'check'\" style=\"display:inline-block;\" tooltip=\"{{::option.tooltip ? option.tooltip : option.label}}\" tooltip-placement=\"bottom\">\n" +
    "                        <sk-switch class=\"other-config-item\"\n" +
    "                                sk-value=\"option.checked\"\n" +
    "                                sk-true-value=\"true\"\n" +
    "                                sk-false-value=\"false\"\n" +
    "                                sk-prevent-click=\"true\">\n" +
    "                        </sk-switch>\n" +
    "                    </div>\n" +
    "                    <span class=\"action-label\" ng-bind=\"::option.label\"></span>\n" +
    "                </div>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div></script><script type=text/ng-template id=listoptions.html><sk-linkedlist sk-options=\"options\" sk-value=\"value\" sk-popover-listener=\"listenerPopOverLinkedList\"></sk-linkedlist></script>");
  $templateCache.put("components/dynaform/defaultblocks/customrelation/customrelationblock.tpl.html",
    "<sk-dataset id=blockDataset entity-name={{::BlockProperties.entityName}} parent-dataset=::BlockProperties.dataset sk-dataset-created=onDatasetCreated(dataset)></sk-dataset><sk-double-face-panel layout flex sk-dataset=blockDataset sk-default-face-index=GRID_FACE sk-selected sk-change-button-actions=changeButtonActions creation-complete=onDoubleFacePanelCreated(controller)><sk-top-bar layout=row layout-align=\"center center\" flex><div layout=row layout-align=\"space-between center\" flex><sk-navigator dataset=blockDataset sk-show-navigation=BlockProperties.showNavigation sk-show-add-button=BlockProperties.showAddButton sk-show-copy-button=BlockProperties.showCopyButton sk-show-remove-button=BlockProperties.showRemoveButton sk-show-refresh-button=BlockProperties.showRefreshButton sk-show-cancel-button=BlockProperties.showCancelButton sk-show-save-button=BlockProperties.showSaveButton sk-compact-btn-add=true></sk-navigator><div class=right-container><sk-hbox gap=5><sk-grid-printer sk-grid-controller=datagrid class=btn-export sk-title={{blockDataset.getEntityDescription()}}></sk-grid-printer><sk-entity-attach sk-dataset=blockDataset sk-entity-name={{::BlockProperties.entityName}} sk-resource-id={{::BlockProperties.attachResourceId}} ng-if=\"::BlockProperties.attachResourceId || BlockProperties.showAttach\"></sk-entity-attach><sk-rows-counter sk-dataset=blockDataset></sk-rows-counter></sk-hbox></div></div></sk-top-bar><sk-face-one layout flex><sk-form sk-dataset=blockDataset sk-form-interceptor=::BlockProperties.formInterceptor layout flex></sk-form></sk-face-one><sk-face-two layout flex><sk-datagrid sk-dataset=blockDataset sk-on-datagrid-loaded=onDatagridLoaded(datagrid) sk-grid-config={{gridConfigId}} sk-datagrid-interceptor=::BlockProperties.datagridInterceptor sk-on-dbl-click=onGridDoubleClick()></sk-datagrid></sk-face-two></sk-double-face-panel>");
  $templateCache.put("components/dynaform/defaultblocks/maximizedTab/MaximizedTab.tpl.html",
    "<sk-hbox id=hboxDynaform ng-init=ctrl.init() sk-height=100% sk-width=100%><sk-form sk-autofocus=true sk-form-column-number-config={{::ctrl.formColumnNumberConfig}} properties=ctrl.tabInfo.formFields sk-form-config-column-key={{::ctrl.formConfigColumnKey}} creation-complete=ctrl.formCreationComplete() sk-form-interceptor=ctrl.formInterceptor columns=\"{{ ::ctrl.formColumns }}\" style=\"height: 92vh\" layout flex class=compact-components ng-if=\"ctrl.tabInfo.type == 'form'\"></sk-form></sk-hbox>");
  $templateCache.put("components/dynaform/defaultblocks/relation/dynaformRelationBlock.tpl.html",
    "<sk-dynaform sk-entity-name={{::properties.entityName}} sk-parent-dynaform=properties.dynaform sk-resource-id={{::ctrl.getResourceId()}} sk-form-columns={{properties.formColumns}} sk-on-dynaform-loaded=ctrl.onDynaformLoaded(dynaform,dataset) sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded(datagrid, dataset)\" sk-custom-tabs-loader=ctrl.customTabsLoader(entityName) sk-other-options-loader=\"ctrl.otherOptionsLoader(dynaform, $dropdownMenu)\" sk-hide-tour=true sk-dynaform-interceptor=::properties.dynaform.getDynaformInterceptor() sk-datagrid-interceptor=::properties.dynaform.getDatagridInterceptor() sk-form-interceptor=::properties.dynaform.getFormInterceptor() sk-helper-class-name={{::properties.dynaform.getHelperClassName()}} sk-recursive-helper=::properties.dynaform.isRecursiveHelper()></sk-dynaform>");
  $templateCache.put("components/dynaform/dynaform.tpl.html",
    "<div class=hide ng-if=\"isMasterDynaform() && showTour\" ng-joy-ride=tour.startTour config=tour.tourConfig on-finish=tour.onFinish() on-skip=tour.onSkip()></div><sk-entity-start-page id=\"{{ ::entityStartPageId }}\" ng-if=showEntityStartPage() ng-show=\"view == 'start'\" sk-entity-name={{::entityName}} sk-resource-id={{::dynaformCtrl.getResourceId()}} sk-show-new-entity-link=showBtnAddRecord() sk-on-select-entity=onSelectEntityOnStartPage sk-on-select-new-entity=onSelectNewEntityOnStartPage sk-on-select-show-grid=onSelectShowGridOnStartPage sk-on-show-all-action=onShowAllActionOnStartPage sk-on-select-hierarchy=onSelectHierarchyOnStartPage sk-on-apply-filter=onApplyFilterOnStartPage sk-start-tour-fn=startTour sk-hierarchy=isHierarchyDynaformActivated() sk-criteria-provider=criteriaProvaiderStartPage sk-resolve-pk-entity=resolvePkEntity flex></sk-entity-start-page><sk-dynaform-config id=dynConfig sk-limit-copy-config=limitCopyConfig sk-before-post-config=\"beforePostConfig({formConfig: formConfig})\" ng-show=\"view == 'config'\" sk-dynaform-instance=controller sk-entity-name={{::entityName}} sk-resource-id={{::resourceId}} layout=column sk-image-validation=imageValidation flex></sk-dynaform-config><div ng-show=\"view == 'loading'\" class=dynaform-loading layout=row layout-align=\"center center\"><sk-icon svg-src=/mge/assets/svg/loading.svg class=spin></sk-icon><span sk-translate>Geral.lblCarregando</span></div><div ng-show=\"view == 'dynaform'\" class=container layout=column ng-class=\"{ 'container--limited': isHierarchyDynaformActivated() }\" flex><sk-stickypanel ng-if=\"showMasterHierarchyDynaform() && !getHierarchyConfig()\"><div class=hierarchy-breadcrumbs layout flex><div ng-show=\"!currentHierarchyPath || currentHierarchyPath.length == 0\" ng-bind=entityDescription class=text-bold sk-font-size=15px layout layout-align=\"start center\" flex></div><div ng-show=\"currentHierarchyPath.length > 0\" flex><sk-breadcrumbs sk-dataprovider=currentHierarchyPath sk-item-click=onHierarchyPathItemClick($item)></sk-breadcrumbs></div></div></sk-stickypanel><div ng-show=\"view == 'dynaform'\" class=\"container mainContainer\" layout=row flex><div ng-if=isHierarchyDynaformActivated() ng-show=\"viewMode == 'form'\" class=side-nav><sk-sidenav class=sk-sidenav-left sk-on-toggle=onToggleSidenav($isOpen) is-open=states.isSideNavOpen sk-id={{::getSidenavId()}} is-open=true is-locked-open=isSidenavLocked() child-layout=column flex><div class=hierarchy-tree-container><sk-text-input ng-show=\"getHierarchyConfig() && isTreeSearchActived()\" sk-value=treeSearchText sk-placeholder=\"{{'Geral.lblPesquisar' | translate}}\"></sk-text-input><sk-tree ng-if=getHierarchyConfig() sk-show-card=false sk-lazy-load=true sk-dataset=dataset sk-config-name={{getFlatTreeConfigName()}} sk-component-created=onTreeCreated($component) sk-search-input=treeSearchText sk-search-input-enabled=enableSearchInputHierarchy sk-search-term=treeSearchText sk-adv-search=treeAdvSearch sk-refresh-dataset-to-tree=refreshDatasetToTree></sk-tree><sk-flat-tree ng-if=!getHierarchyConfig() sk-dataset=dataset sk-config-name={{getFlatTreeConfigName()}} sk-component-created=onFlatTreeCreated($component)></sk-flat-tree></div></sk-sidenav></div><div class=\"dynaform-body dynaform-body-{{::getDynaformId()}}\" ng-class=\"{'form-view': viewMode == 'form'}\" layout=column flex><sk-fixed-bar ng-if=isMasterDynaform() sk-fixed-bar=dynaform-top-bar-{{::getMasterDynaformId()}} sk-top-offset=30 sk-before-open=beforeOpenFixedBar($fixedBar)><bar-header><sk-navigator ng-if=\"isActiveOnToolBarManager('useNavigator')\" dataset=barContext.getDataset() sk-disabled=navigatorOptions.disableNavigator sk-show-navigation=\"navigatorOptions.showNavigation && isActiveOnToolBarManager('useNavNavigationButtons')\" sk-show-copy-button=navigatorOptions.showCopyButton sk-show-add-button=navigatorOptions.showAddButton sk-edit-unique-record=editUniqueRecord sk-show-edit-button=navigatorOptions.showEditButton sk-compact-btn-add=true sk-api=dynaformCtrl.navigatorApi></sk-navigator></bar-header><bar-footer><sk-entity-card ng-if=\"!dataset.isInsertionMode() && entityCardProps.data\" sk-entity-name=entityName sk-all-pks=entityCardProps.entity.allPks sk-pk-field=entityCardProps.entity.pkField sk-other-entity-pks=entityCardProps.entity.otherEntityPks sk-description-field=entityCardProps.entity.descriptionField sk-has-image=entityCardProps.hasImage sk-is-favorite=entityCardProps.isFavorite sk-image-field=entityCardProps.entity.imageField sk-resource-id=resourceId sk-data=entityCardProps.data sk-fields-metadata=entityCardProps.entity.fieldsMetadata sk-compact=true></sk-entity-card><sk-entity-card ng-if=\"!barContext.getDataset().isInsertionMode() && barContext.getEntityCardProps().data\" sk-entity-name=barContext.getEntityName() sk-all-pks=barContext.getEntityCardProps().entity.allPks sk-pk-field=barContext.getEntityCardProps().entity.pkField sk-other-entity-pks=barContext.getEntityCardProps().entity.otherEntityPks sk-description-field=barContext.getEntityCardProps().entity.descriptionField sk-has-image=barContext.getEntityCardProps().hasImage sk-is-favorite=barContext.getEntityCardProps().isFavorite sk-image-field=barContext.getEntityCardProps().entity.imageField sk-resource-id=barContext.getResourceId() sk-data=barContext.getEntityCardProps().data sk-fields-metadata=barContext.getEntityCardProps().entity.fieldsMetadata sk-compact=true ng-show=\"barContext && barContext != controller\"></sk-entity-card></bar-footer></sk-fixed-bar><div class=\"top-bar high-contrast-panel dynaform-top-bar-{{::getMasterDynaformId()}} {{::customClassTopBar}}\" ng-class=\"{ 'top-bar--border-left': isHierarchyDynaformActivated() }\"><sk-fixed-bar-context sk-fixed-bar=dynaform-top-bar-{{::getMasterDynaformId()}} sk-name={{::entityDescription}} sk-context=controller sk-force-context=forceFixedBarContext sk-is-active=contextIsActive sk-fixed-bar-position-ref=dynaform-content-{{::getDynaformId()}}.content></sk-fixed-bar-context><span ng-show=\"parentDynaformIsMaster() && !parentDynaformIsHierarchy()  && showDetailDescription\" class=detail-entity-description>{{ ::customEntityDescription }}</span><div class=buttons-container><div class=left-container layout layout-wrap><button class=\"btn btn-default btn-sk-sm btn-start-page margin-right\" ng-click=goToStartPage() ng-show=\"isMasterDynaform() && !skipStartPage\" sk-translate=Dynaform.tooltipEntityStartPage sk-translate-attr=tooltip tooltip tooltip-placement=right><sk-icon font-icon=home></sk-icon></button><sk-personalized-filter id=\"{{ ::personalizedFilterId }}\" sk-data-source=dataset sk-load-on-create=\"{{ ::dynaformCtrl.loadFiltersOnCreate() }}\" sk-entity-name={{::entityName}} sk-has-some-active-filter=hasSomeActiveFilter.value sk-resource-id=\"{{ ::dynaformCtrl.getResourceId(entityName) }}\" ng-if=\"(showPersonalizedFilterButton() && !hasDynamicFilter && !navigatorOptions.disableSearch) || forceEnablePersonalizedFilter\" sk-eh-popup=popupMode class=margin-right sk-field-filter-function=dynaformCtrl.filterFieldsPersonalizedFilter></sk-personalized-filter><sk-filter-panel-btn sk-instancia-name={{filterInstanceName}} ng-if=\"hasDynamicFilter && !forceEnablePersonalizedFilter\"></sk-filter-panel-btn><div class=\"btn-group btn-change-face-group dropdown\" dropdown dropdown-append-to-body ng-show=!hideButtonGrid><button class=\"btn btn-default btn-sk-sm btn-change-face\" ng-click=changeViewMode() tooltip=\"{{viewMode != 'form' ? 'DoubleFacePanel.tooltipModoForm' : 'DoubleFacePanel.tooltipModoGrade' | translate}}\" tooltip-placement=\"{{isMasterDynaform() ?  'bottom' : 'right'}}\" tooltip-append-to-body=true><sk-icon font-icon={{iconChangeFace}}></sk-icon></button> <button type=button class=\"btn btn-default dropdown-toggle\" ng-if=\"isActiveOnToolBarManager('useGridConfigger') && !hideButtonsConfig\" ng-disabled=!allowGridConfiguration dropdown-toggle><span class=caret></span></button><ul class=dropdown-menu role=menu aria-labelledby=split-button style=\"z-index: 9999\"><li role=menuitem ng-click=openGridConfig()><a sk-translate>Geral.lblConfigurarGrade</a></li><li role=menuitem ng-click=controlActiveHierarchy() ng-if=::isHierarchyDynaform() ng-class=\"{ 'dropdown-menu-item--checked': isHierarchyActivated }\"><a sk-translate>EntityStartPage.sideMenu.mostrarHierarquia</a></li></ul></div><sk-navigator ng-if=\"isActiveOnToolBarManager('useNavigator')\" dataset=dataset sk-disabled=navigatorOptions.disableNavigator sk-show-navigation=\"navigatorOptions.showNavigation && isActiveOnToolBarManager('useNavNavigationButtons')\" sk-show-copy-button=\"(navigatorOptions.showCopyButton && isActiveOnToolBarManager('useNavCopyButton')) || (tour.startTour == true)\" sk-show-remove-button=\"navigatorOptions.showRemoveButton && isActiveOnToolBarManager('useNavRemoveButton')\" sk-show-refresh-button=\"navigatorOptions.showRefreshButton && isActiveOnToolBarManager('useNavRefreshButton')\" sk-show-cancel-button=\"navigatorOptions.showCancelButton && isActiveOnToolBarManager('useNavCancelButton')\" sk-show-save-button=\"navigatorOptions.showSaveButton && isActiveOnToolBarManager('useNavSaveButton')\" sk-show-add-button=navigatorOptions.showAddButton sk-edit-unique-record=editUniqueRecord sk-show-edit-button=navigatorOptions.showEditButton sk-compact-btn-add=true class=btn-nav sk-api=dynaformCtrl.navigatorApi></sk-navigator><div class=user-left-container layout=row></div></div><div class=right-container layout layout-wrap><div class=\"entity-search-container margin-right\" ng-if=\"isMasterDynaform() && !hideEntitySearchField\"><sk-typeahead-input id=entitySearchField sk-value=dynaformCtrl.entitySearch sk-clear-after-select=true sk-placeholder=\"{{'Dynaform.search.entity' | translate}}\" sk-get-options=loadEntitySuggestions sk-is-loading=isSearchingEntity sk-key=label sk-label=label sk-on-select=pesqEntitySelect sk-show-more=true sk-show-more-fn=showMoreEntityPesqResults() sk-template-url=entitySearch.html sk-external-action=true sk-append-to-body=true sk-min-length=1 sk-disabled=navigatorOptions.disableSearch></sk-typeahead-input><sk-icon font-icon=search class=btn-search ng-class=\"{active: dynaformCtrl.entitySearch}\"></sk-icon></div><sk-hbox gap=4 layout-align=\"start center\"><button default small class=btn-favorite ng-if=\"isMasterDynaform() && !hideButtonFavorite\" sk-popover popover-template-url=favoritesRecentsEntities.html create-on-load=false properties=getEntitdadesFavoritasProperties show-btn-apply=false show-btn-close=false width=300 height=auto popover-placement=bottom always-load-properties=true popover-class=\"white-popover no-padding\" hide-on-scroll=true absolute=true tooltip=Dynaform.tooltipFavoritos tooltip-placement=bottom sk-disabled=navigatorOptions.disableSearch sk-i18n><sk-icon font-icon=star></sk-icon></button> <button default small class=btn-recents ng-if=\"isMasterDynaform() && !hideButtonRecents\" sk-popover popover-template-url=favoritesRecentsEntities.html create-on-load=false properties=getEntitdadesRecentesProperties show-btn-apply=false show-btn-close=false width=300 height=auto popover-placement=bottom always-load-properties=true popover-class=\"white-popover no-padding\" hide-on-scroll=true absolute=true tooltip=Dynaform.tooltipRecentes tooltip-placement=bottom sk-disabled=navigatorOptions.disableSearch sk-i18n><sk-icon font-icon=stopwatch></sk-icon></button></sk-hbox><div class=user-right-container layout=row></div><div class=field-search ng-if=\"showSearchField && hideButtonsConfig\"><sk-typeahead-input class=\"fieldSearchField-{{uid}} display-inline-block\" sk-clear-after-select=true sk-placeholder=\"{{'Dynaform.search.fields' | translate}}\" sk-get-options=loadFieldSuggestions sk-key=label sk-label=label sk-on-select=pesqFieldSelect sk-show-more=false sk-append-to-body=true sk-template-url=fieldsSearch.html sk-external-action=true></sk-typeahead-input></div><sk-grid-printer sk-grid-controller=gridController sk-grid-printer-interceptor=gridPrinterInterceptor ng-if=\"!editUniqueRecord && isActiveOnToolBarManager('useGridPrinter') && !hideButtonsConfig\" class=btn-export sk-title={{::entityDescription}} sk-create-grid-fn=createGrid sk-custom-options=customConfigGridPrinter></sk-grid-printer><sk-entity-attach id=dynAttach sk-dataset=dataset sk-entity-name={{::entityName}} sk-resource-id={{::dynaformCtrl.getResourceId()}} ng-if=\"(!isView && !editUniqueRecord && isActiveOnToolBarManager('useNavAttachmentButton')) && hideButtonEntityAttach != true \"></sk-entity-attach><sk-action-button ng-if=\"(showActionButton || tour.startTour) && !editUniqueRecord\" sk-entity-name={{::entityName}} sk-resource-id={{::getActionButtonResourceId()}} sk-access-resource-id={{::getActionButtonAccessResourceId()}} sk-context=datasetActionButtonContext sk-is-disabled=actionBtnDisabled.status></sk-action-button><sk-dropdown-menu sk-api=dynaformCtrl.dropdownApi ng-if=otherOptions sk-open-always=true sk-build-options=buildOtherOptions($dropdownMenu) sk-parameters=entityName></sk-dropdown-menu><button class=\"btn btn-default btn-sk-sm\" ng-click=startTour() ng-if=!hideTour ng-show=btnTourExplicito tooltip=\"\" sk-translate=Geral.lblStartTour sk-translate-attr=tooltip tooltip-placement=left tooltip-append-to-body=true><sk-icon font-icon=train></sk-icon></button><div class=\"btn-group dropdown btn-group-config\" dropdown dropdown-append-to-body auto-close=outsideClick is-open=dropdownConfig.isOpen ng-if=\"!editUniqueRecord && !hideButtonsConfig\"><button type=button class=\"btn btn-default btn-sk-sm\" ng-disabled=!isBtnConfigEnabled() ng-click=launchConfiguration() tooltip={{::toolTipConfigTela}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=cogwheel></sk-icon></button> <button type=button class=\"btn btn-default dropdown-toggle\" dropdown-toggle ng-click=closeAllPopovers()><span class=caret></span></button><ul class=\"sk-dynaform dropdown-menu\" role=menu aria-labelledby=split-button><li role=menuitem><div class=field-search><sk-typeahead-input class=\"fieldSearchField-{{uid}} display-inline-block\" sk-clear-after-select=true sk-placeholder=\"{{'Dynaform.search.fields' | translate}}\" sk-get-options=loadFieldSuggestions sk-key=label sk-label=label sk-on-select=pesqFieldSelect sk-show-more=false sk-append-to-body=true sk-template-url=fieldsSearch.html sk-external-action=true></sk-typeahead-input><sk-icon font-icon=search></sk-icon></div></li><li role=menuitem ng-click=openNumberConfig($event) ng-if=\"isMasterDynaform() && isActiveOnToolBarManager('useFormConfigger') && isShowNumberConfig()\" ng-class=\"{'disabled': !dynaformCtrl.enableNumberConfig}\"><div><span class=one-icon>1</span> <span sk-translate>NumberConfig.numeracao</span></div></li><li role=menuitem class=\"{{'dynaform-tour-' + uid}} form-cfg-columns\" ng-click=formConfigColumns() ng-if=\"userConfigFormColumns && isMasterDynaform() && isShowFormLayoutConfig()\"><div><sk-icon font-icon=list-alt></sk-icon><span sk-i18n class=vertical-align-middle>Dynaform.configApresForm</span></div></li><li role=menuitem ng-click=startTour() ng-if=!hideTour ng-show=!btnTourExplicito><div><sk-icon font-icon=train></sk-icon><span sk-i18n class=vertical-align-middle>EntityStartPage.sideMenu.lblIniciarTour</span></div></li><li role=menuitem ng-click=useClassicLayoutVersion() ng-if=showClassicLayoutVersionLink()><div><sk-icon font-icon=message-forward></sk-icon><span sk-i18n class=vertical-align-middle>Dynaform.lblUtilizarLayoutAnterior</span></div></li><li ng-if=otherConfigurations ng-repeat=\"conf in otherConfigurations.items\" ng-click=onClickUserConfiguration(conf) class=other-config-item><div ng-switch=conf.type><div ng-switch-when=switch><sk-switch sk-true-value=true sk-false-value=false sk-change=onChangeUserConfiguration(conf) sk-value=otherConfigurations.byId[conf.id].value></sk-switch><span sk-i18n={{conf.label}} class=vertical-align-middle></span></div><div ng-switch-default><sk-icon font-icon={{conf.icon}}></sk-icon><span sk-i18n={{conf.label}} class=vertical-align-middle></span></div></div></li></ul></div><sk-rows-counter class=btn-rows-counter ng-if=\"dataset && !editUniqueRecord\" sk-dataset=dataset></sk-rows-counter></div><div class=clearfix></div></div><div id=user-header-container class=user-header-container></div><div class=compact-navbar><button class=\"btn btn-default\" ng-if=showSaveCancelOnCompactTopBar ng-click=dataset.save()><sk-icon font-icon=ok-2></sk-icon></button> <button class=\"btn btn-default\" ng-if=showSaveCancelOnCompactTopBar ng-click=dataset.cancelEdition()>Descartar</button></div></div><div layout=row flex><div class=\"custom-filters ng-hide\"></div><sk-vbox flex><div id=user-container-form-grid layout=row></div><div ng-show=\"viewMode == 'form'\" id=dynaform-content-{{::getDynaformId()}} class=\"dynaform-content-{{::getDynaformId()}} content\" layout=column flex><div class=entity-card-container ng-show=!skHideEntityCard></div><sk-form sk-autofocus=true properties=mainTabInfo.formFields sk-fields-order=fieldsOrder ng-if=mainTabInfo sk-form-config-column-key={{::formConfigColumnKey}} creation-complete=formCreationComplete() sk-form-interceptor=formInterceptor columns=\"{{ ::formColumns }}\" layout class=compact-components ng-class=\"tabsInfo.length > 0 ? 'top-column-max-height' : null\" sk-form-column-number-config={{::formColumnNumberConfig}}></sk-form><div layout=column flex sk-padding=5px class=stack-container ng-show=\"tabsInfo.length > 0\" ng-style=\"{ 'min-height': tabsInfo.length > 0 ? '350px' : '0px' }\"><sk-tabnavigator sk-selected-index=tabSelectedIndex sk-content-list=tabsInfo><sk-tabnavigator-item ng-click=\"selectTab(tabInfo); closeSidenav()\" ng-repeat=\"tabInfo in tabsInfo track by tabInfo.tabId\" sk-disabled=!tabInfo.enabled sk-label={{tabInfo.tabName}} ng-class=\"{'gray-tab-item': isTabNavBorderBottom($index)}\"><sk-hbox gap=5 flex><sk-icon svg-src=/mge/assets/svg/puzzle.svg ng-if=showTabCustomIcon(tabInfo) tooltip=\"{{'Dynaform.tooltipAbaPersonalizada' | translate}}\" sk-height=15px sk-width=15px tooltip-placement=right tooltip-append-to-body=true></sk-icon><span>{{tabInfo.tabName}}</span><sk-icon font-icon=circle-exclamation-mark ng-if=showTabRequiredIcon(tabInfo) class=span-required tooltip=\"{{'Dynaform.camposObrigNaoPreenchidos' | translate}}\" tooltip-placement=right tooltip-append-to-body=true></sk-icon><sk-icon font-icon=expand-arrows-alt v=ez tooltip-placement=right tooltip-append-to-body=true style=\"margin-left: 5px\" tooltip=Maximizar ng-if=\"tabSelected == tabInfo\" ng-click=maximizeTab(tabInfo)></sk-icon></sk-hbox></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=tabSelectedIndex sk-content-list=tabsInfo sk-on-select=onSelectTab flex layout=column class=has-borders sk-creation-policy={{::creationPolicy}}><sk-viewstack-content create-on-init=\"{{!(tabInfo.isLazyLoad != undefined ? tabInfo.isLazyLoad : true)}}\" ng-repeat=\"tabInfo in tabsInfo track by tabInfo.tabId\" sk-disabled=!tabInfo.enabled layout=column flex><sk-form sk-autofocus=true sk-form-column-number-config={{::formColumnNumberConfig}} properties=tabInfo.formFields sk-form-config-column-key={{::formConfigColumnKey}} ng-if=\"tabInfo.type == 'form'\" creation-complete=formCreationComplete() sk-form-interceptor=formInterceptor columns=\"{{ ::formColumns }}\" layout flex class=compact-components></sk-form></sk-viewstack-content></sk-viewstack></div></div><sk-vbox ng-show=\"viewMode == 'grid'\" flex><div id=dynaform-grid-content-{{::uid}} class=sk-grid-content layout flex></div><div id=user-bottom-grid-panel layout=row></div></sk-vbox></sk-vbox></div><div id=user-footer-container></div><div id=user-footer></div></div></div></div><div ng-transclude style=\"display: none\"></div><script type=text/ng-template id=entitySearch.html><div>\n" +
    "        <sk-entity-card\n" +
    "                sk-corner-favorite\n" +
    "                sk-highlight-on=\"query\"\n" +
    "                sk-entity-name=\"match.model.entityName\"\n" +
    "                sk-pk-field=\"match.model.pkField\"\n" +
    "                sk-all-pks=\"match.model.allPks\"\n" +
    "                sk-other-entity-pks=\"match.model.otherEntityPks\"\n" +
    "                sk-description-field=\"match.model.descriptionField\"\n" +
    "                sk-has-image=\"match.model.hasImage\"\n" +
    "                sk-image-field=\"match.model.imageField\"\n" +
    "                sk-is-favorite=\"match.model.isFavorite\"\n" +
    "                sk-resource-id=\"match.model.resourceID\"\n" +
    "                sk-data=\"match.model.data\"\n" +
    "                sk-fields-metadata=\"match.model.fieldsMetadata\"\n" +
    "                sk-resolve-pk-entity = \"match.model.resolvePkEntity\"\n" +
    "                >\n" +
    "        </sk-entity-card>\n" +
    "    </div></script><script type=text/ng-template id=fieldsSearch.html><div class=\"field-search-match\">\n" +
    "        <span class=\"field-search-match-name\" ng-bind=\"match.model.description\"/>\n" +
    "        <span class=\"field-search-match-path\" ng-bind=\"match.model.tabName\"/>\n" +
    "    </div></script><script type=text/ng-template id=favoritesRecentsEntities.html><div class=\"recent-favorites-popover\">\n" +
    "        <div class=\"recent-favorite-items-container\" sk-scroll-container>\n" +
    "            <div ng-if=\"entitiesData.data.length == 0\" class=\"no-entities-container\" layout=\"column\" layout-align=\"center center\">\n" +
    "                <span sk-translate>Geral.semRegistros</span>\n" +
    "            </div>\n" +
    "            <div ng-if=\"entitiesData.data.length > 0\" ng-repeat=\"data in entitiesData.data\" class=\"card-item\">\n" +
    "                <sk-entity-card\n" +
    "                        sk-corner-favorite\n" +
    "                        sk-entity-name=\"entityName\"\n" +
    "                        sk-pk-field=\"entitiesData.pkField\"\n" +
    "                        sk-all-pks=\"entitiesData.allPks\"\n" +
    "                        sk-other-entity-pks=\"entitiesData.otherEntityPks\"\n" +
    "                        sk-description-field=\"entitiesData.descriptionField\"\n" +
    "                        sk-has-image=\"data.__hasImage\"\n" +
    "                        sk-is-favorite=\"data.__isFavorite\"\n" +
    "                        sk-image-field=\"entitiesData.imageField\"\n" +
    "                        sk-resource-id=\"entitiesData.resourceID\"\n" +
    "                        sk-data=\"data\"\n" +
    "                        sk-fields-metadata=\"entitiesData.fieldsMetadata\"\n" +
    "                        sk-enable-show-details=\"false\"\n" +
    "                        ng-click=\"onSelectEntity(entitiesData, data); hide()\"\n" +
    "                        >\n" +
    "                </sk-entity-card>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"type == 'F' && entitiesData.data.length > 0 && entitiesData.hasMore\" ng-click=\"showFavoritesSearch(); hide()\" class=\"show-more-container\">\n" +
    "            <a sk-translate>Geral.lblPesquisar</a>\n" +
    "        </div>\n" +
    "    </div></script>");
  $templateCache.put("components/dynaform/dynaformconfig/copyconfig/configcopy.tpl.html",
    "<div class=wizard-copy-config-container layout flex><sk-wizard sk-hide-indicators=true sk-on-cancel=onCancelWizard() sk-on-finish=onFinishWizard($step) layout flex><sk-step sk-title=Origem sk-template-url=components/dynaform/dynaformconfig/copyconfig/steps/stepUsuOrigem.tpl.html sk-controller=StepUsuOrigemController layout=column flex></sk-step><sk-step sk-title=Destino sk-template-url=components/dynaform/dynaformconfig/copyconfig/steps/stepUsuDestino.tpl.html sk-controller=StepUsuDestinoController layout=column flex></sk-step><sk-step sk-title=\"Opções da cópia\" sk-can-next=false><div layout=column class=step-container flex><h4 sk-translate>DynaformConfig.CopyConfig.lblQuaisConfigsCopiar</h4><div layout=row><sk-combobox sk-value=$parent.$step.wizardContext.tipCopia sk-options=copyCfgOptions sk-change=\"updateCanNext($parent.$step, value)\" sk-required=true flex=50></sk-combobox></div><h4 sk-translate>DynaformConfig.CopyConfig.lblDesejaManterConfiguracoesAntigas</h4><div layout=row><sk-combobox sk-value=$parent.$step.wizardContext.forceRemove sk-options=copyCfgRemoverOptions sk-change=\"updateCanNext($parent.$step, value)\" sk-required=true flex=50></sk-combobox></div></div></sk-step><sk-step sk-title=Finalização sk-finalize=true class=aviso><h4 sk-translate>DynaformConfig.CopyConfig.lblTitleAviso</h4><span sk-translate>DynaformConfig.CopyConfig.msgAviso</span></sk-step></sk-wizard></div>");
  $templateCache.put("components/dynaform/dynaformconfig/copyconfig/steps/stepUsuDestino.tpl.html",
    "<div layout=column class=step-container flex><h4 sk-translate>DynaformConfig.CopyConfig.lblUsuariosDestinoTitle</h4><div layout=column flex><div layout=row><div class=form-item><span>Grupo de usuários:</span><sk-pesquisa-input sk-entity-name=GrupoUsuario sk-field-name=CODGRUPO sk-description-field-name=NOMEGRUPO sk-value=codGrupoUsuario sk-entity-change=onCodUsuChange()></sk-pesquisa-input></div></div><div layout=row flex><div class=\"form-item pesq-user-dest-container disable-text-selection\" layout=column flex=45><span sk-translate>DynaformConfig.CopyConfig.lblUsuariosDisponiveis</span><sk-pesquisa-content sk-id=copyCfgPesqUserDestId sk-load-on-creation=false sk-entity-name=\"'Usuario'\" sk-on-select=selectData sk-enable-grid-mode=false sk-criteria-provider=criteriaProvider sk-query-placeholder=\"::'DynaformConfig.CopyConfig.lblPesquisarUsuario'\" sk-select-on-dblclick=true sk-remove-on-select=true flex></sk-pesquisa-content></div><div class=buttons-container layout-align=\"center center\" layout=column flex=10><button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"getAvailableListSize() == 0\" ng-click=selectAllUsers()><sk-icon svg-src=/mge/assets/svg/forward.svg></sk-icon></button> <button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"getAvailableListSize() == 0\" ng-click=selectUser()><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button> <button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"selectedDestUsersEntity.length == 0\" ng-click=unselectUser()><sk-icon svg-src=/mge/assets/svg/back.svg></sk-icon></button> <button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"selectedDestUsersEntity.length == 0\" ng-click=unselectAllUsers()><sk-icon svg-src=/mge/assets/svg/rewind.svg></sk-icon></button></div><div class=\"form-item selected-users\" layout=column flex=45><span sk-translate>DynaformConfig.CopyConfig.lblUsuariosSelecionados</span><div class=selected-users-list sk-list sk-select-last-on-change=true sk-id=selectedUserListId sk-closest=.list-row><div class=list-row ng-dblclick=unselectUser() ng-repeat=\"user in selectedDestUsersEntity track by user.CODUSU\"><sk-entity-card sk-entity-name=\"'Usuario'\" sk-pk-field=entitiesData.pkField sk-other-entity-pks=entitiesData.otherEntityPks sk-description-field=entitiesData.descriptionField sk-has-image=user.__hasImage sk-is-favorite=user.__isFavorite sk-image-field=entitiesData.imageField sk-resource-id=entitiesData.resourceID sk-data=user sk-fields-metadata=entitiesData.fieldsMetadata sk-enable-show-details=false sk-corner-favorite></sk-entity-card></div></div></div></div></div></div>");
  $templateCache.put("components/dynaform/dynaformconfig/copyconfig/steps/stepUsuOrigem.tpl.html",
    "<div layout=column class=step-container flex><h4 sk-translate>DynaformConfig.CopyConfig.lblUsuarioOrigemTitle</h4><sk-checkbox ng-model=wizardContext.useCurrentUser ng-change=updateCanNext()><span sk-translate>DynaformConfig.CopyConfig.lblUsarUsuarioAtual</span></sk-checkbox><div ng-if=!wizardContext.useCurrentUser class=pesq-user-origem layout=column flex><sk-pesquisa-content sk-entity-name=\"'Usuario'\" sk-on-select=selectData sk-enable-grid-mode=false sk-criteria-provider=criteriaProvider sk-query-placeholder=\"::'DynaformConfig.CopyConfig.lblPesquisarUsuario'\" sk-load-on-creation=false flex></sk-pesquisa-content></div></div>");
  $templateCache.put("components/dynaform/dynaformconfig/dynaformconfig.tpl.html",
    "<div class=hide ng-if=showTour ng-joy-ride=tour.startTour options=tour.options config=tour.tourConfig on-finish=tour.onFinish() on-skip=tour.onFinish()></div><div layout=column flex class=dynaform-config><div layout=row layout-align=\"space-between center\" class=header style=\"flex-wrap: wrap\"><div layout=column style=\"flex-wrap: wrap\"><div layout=row layout-align=\"start center\"><sk-icon ng-click=cancelConfig() svg-src=tabs-arrow.svg class=return-icon></sk-icon><h3 flex sk-translate>DynaformConfig.titleConfigTela</h3></div><ul class=breadcrumb><li ng-repeat=\"entityDescr in entityPath\"><a href=# ng-bind=entityDescr></a></li></ul></div><div layout=column layout-align=\"center end\" class=grid-buttons><div><button id=btn-start-tour-dfrm-cfg class=\"btn btn-default\" ng-click=startTour() sk-translate tooltip=\"{{'EntityStartPage.sideMenu.lblIniciarTour' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom>EntityStartPage.sideMenu.lblIniciarTour</button> <button id=btn-copy-cfg class=\"btn btn-default\" ng-click=openCopyCfg() sk-translate tooltip=\"{{'DynaformConfig.tooltipCopiarPersonalizacao' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom>DynaformConfig.CopyConfig.lblCopiarPersonalizacao</button> <button id=btn-default-filter class=\"btn btn-default btn-sk-sm btn-filter-default\" ng-click=openFilterDefault() ng-if=isSup tooltip=\"{{ 'FiltroPersonalizado.lblFiltroPadrao' | translate }}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=filter></sk-icon></button> <button id=btn-cancel-dyfm-cfg class=\"btn btn-default\" ng-click=cancelConfig() sk-translate tooltip=\"{{'DynaformConfig.tooltipCancelar' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom>Geral.lblCancelar</button> <button id=btn-restore-dyfm-cfg class=\"btn btn-default\" ng-click=restoreConfig() sk-translate tooltip=\"{{'DynaformConfig.tooltipRestoreConfig' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom>DynaformConfig.lblRestaurar</button> <button id=btn-save-dyfm-cfg class=\"btn btn-primary\" ng-click=applyConfig() sk-translate tooltip=\"{{'DynaformConfig.tooltipSalvar' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom>Geral.lblSalvar</button></div><div class=checkbox-filtro tooltip=\"\" tooltip-append-to-body=true tooltip-placement=bottom><sk-checkbox ng-model=ctrl.allowPersonalizedFilter ng-change=notifyChange() false-value=N true-value=S ng-if=ctrl.showAllowPersonalizedFilter() tooltip=\"{{'DynaformConfig.tooltipUserAllowPersonalizedFilter' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom><span sk-translate>DynaformConfig.labelMostraFiltro</span></sk-checkbox></div></div></div><div layout=row class=content flex><div class=left-container layout=column flex=20><span class=available-fields sk-translate>DynaformConfig.lblCamposDisponiveis</span><div class=search-group><input class=\"query-input form-control\" placeholder=\"{{'DynaformConfig.lblProcurarCampo' | translate}}\" ng-model=fieldQuery ng-model-options=\"{ debounce: 300 }\"><sk-icon font-icon=search class=btn-search ng-class=\"{active: fieldQuery}\"></sk-icon></div><div sk-sortable=invisibleFieldsSortableConfig class=invisible-fields-container flex><div ng-repeat=\"field in configInfo.invisibleFields | filter:filterFields track by field.name\" class=field-item-container><div class=\"tab-field-item field available\" ng-dblclick=sendFieldToSelectedTab(field) ng-class=\"{'required': field.userRequired == 'S', 'block-field': field.userType == 'customBlock'}\"><sk-icon font-icon=show-lines class=handle style=\"vertical-align: middle\"></sk-icon><span class=tab-field-item-description ng-bind=\"field.userDescription || field.systemDescription\" tooltip=\"{{field.userDescription || field.systemDescription}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span class=tab-field-item-tab-name ng-bind=field.tabName tooltip={{field.tabName}} tooltip-popup-delay=500 tooltip-append-to-body=true></span><div class=right-actions-container><sk-icon class=send-to-same-tab-icon font-icon=share ng-click=sendAllFieldsWithSameTab(field) tooltip=\"{{'DynaformConfig.tooltipCopiarCamposParaAba' | translate:{'tabName':field.tabName} }}\"></sk-icon><span class=config-icon sk-popover popover-placement=right popover-template-url=fieldEditPopoverTemplate.html create-on-load=false properties=getFieldConfigProperties(field) controller-name=SkDynaformConfigFieldConfigController show-btn-apply=false show-btn-close=false backdrop=false popover-class=white-popover popover-listeners=popoverListener popover-group=fieldConfig always-load-properties=true width=auto height=auto><sk-icon class=open-icon font-icon=cogwheel tooltip=\"{{'DynaformConfig.tooltipAbrirConfigsCampo' | translate}}\" tooltip-append-to-body=true tooltip-placement=top-left></sk-icon><sk-icon class=close-icon font-icon=chevron-left tooltip=\"{{'DynaformConfig.tooltipFecharConfigsCampo' | translate}}\" tooltip-append-to-body=true tooltip-placement=top-left></sk-icon></span><sk-help-tip class=block-help-icon sk-translate=DynaformConfig.helpTipBloco sk-translate-attr=sk-help-tip></sk-help-tip></div></div></div></div></div><div layout=column layout-align=\"center center\" class=center-buttons-container><button class=\"btn btn-default\" ng-disabled=!canSendAllFieldsToCurrentTab() ng-click=sendAllFieldsToSelectedTab() tooltip=\"{{'DynaformConfig.tooltipAdicionarTodosCampos' | translate}}\"><sk-icon svg-src=/mge/assets/svg/forward.svg></sk-icon></button> <button class=\"btn btn-default\" ng-disabled=!canRemoveAllFieldsFromCurrentTab() ng-click=sendAllFieldsToInvisibleFields() tooltip=\"{{'DynaformConfig.tooltipRemoverTodosCampos' | translate}}\"><sk-icon svg-src=/mge/assets/svg/rewind.svg></sk-icon></button></div><div layout=column flex=75><div layout=row sk-border-bottom=\"1px solid #ccc\"><sk-tabnavigator id=tab-navigator-info sk-tabnavigator-created=onTabnavigatorCreated(tabNavigator) sk-selected-index=tabSelectedIndex sk-selected-tab-navigator=onTabChange() sk-content-list=configInfo.tabsInfo layout=column flex><div sk-sortable=tabsSortableConfig flex><sk-tabnavigator-item ng-repeat=\"tabInfo in configInfo.tabsInfo\" ng-class=\"{'tab-item-invisible': !tabInfo.visible}\" sk-label=\"{{tabInfo.title || tabInfo.tabName}}\"><sk-icon font-icon=show-lines class=handle style=\"vertical-align: middle\"></sk-icon>{{tabInfo.title || tabInfo.tabName}} <span class=config-icon><sk-icon ng-hide=tabInfo.visible font-icon=eye-close tooltip=\"{{'DynaformConfig.tooltipAbaInvisivel' | translate}}\"></sk-icon></span></sk-tabnavigator-item></div></sk-tabnavigator><div class=btn-group sk-margin-right=10px><button id=btn-toggle-tab-visibility class=\"btn btn-default no-text\" ng-click=toggleTabVisibility(currentTab) sk-height=28px><sk-icon font-icon=eye-open ng-show=!currentTab.visible sk-translate=DynaformConfig.labelMarcarComoVisivel sk-translate-attr=tooltip tooltip=\"\"></sk-icon><sk-icon font-icon=eye-close ng-show=currentTab.visible sk-translate=DynaformConfig.labelMarcarComoInvisivel sk-translate-attr=tooltip tooltip=\"\"></sk-icon></button> <button id=btn-delete-tab class=\"btn btn-default\" ng-click=deleteTab(currentTab) ng-disabled=\"currentTab.type == 'dynaform'\" tooltip=\"{{'DynaformConfig.tooltipExcluirAba' | translate}}\" tooltip-placement=bottom><sk-icon font-icon=bin></sk-icon></button> <button class=\"btn btn-default btn-brand btn-nova-aba\" sk-popover popover-template-url=novaAbaPopoverTemplate.html popover-placement=left show-btn-apply=false show-btn-close=false popover-class=white-popover height=auto width=auto create-on-load=false popover-focus-on-show=.nome-nova-aba-input apply-handler=newTab(nomeNovaAba) tooltip=\"{{'DynaformConfig.tooltipCriarNovaAba' | translate}}\" tooltip-placement=left><sk-icon font-icon=plus></sk-icon></button></div></div><sk-viewstack sk-selected-index=tabSelectedIndex sk-content-list=configInfo.tabsInfo flex layout=column><sk-viewstack-content ng-repeat=\"tabInfo in configInfo.tabsInfo\" flex layout=column><div ng-switch=tabInfo.type layout=column class=overflow-hidden flex><div class=dynaform-tab ng-switch-when=dynaform layout=column layout-align=\"center center\" flex><span class=message>Para realizar a configuração de uma tela de detalhes é necessário acessar a sua aba.</span></div><div ng-switch-default layout=column class=overflow-hidden flex><div class=fields-container ng-class=\"{'dynaform-tab': tabInfo.type == 'dynaform'}\" sk-sortable=fieldSortableConfig flex><div field-block-reference ng-repeat=\"field in tabInfo.fields\" class=\"field-item-container col-xs-12 col-sm-6 col-md-4 col-lg-3\"><div class=\"tab-field-item field\" ng-dblclick=sendFieldToInvisibleFields(field) ng-class=\"{'required': field.userRequired == 'S', 'block-field': field.userType == 'customBlock'}\"><sk-icon font-icon=show-lines class=handle style=\"vertical-align: middle\"></sk-icon><div class=tab-field-item-description ng-bind=\"field.userDescription || field.systemDescription\" tooltip=\"{{field.userDescription || field.systemDescription}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></div><div class=right-actions-container><sk-icon ng-click=sendFieldToInvisibleFields(field) class=remove-icon font-icon=remove-2 tooltip=\"{{'DynaformConfig.tooltipRemoverCampoTela' | translate}}\" tooltip-append-to-body=true tooltip-placement=top-left></sk-icon><span class=config-icon sk-popover popover-template-url=fieldEditPopoverTemplate.html create-on-load=false dynamic-container-fn=fieldEditPopoverContainer properties=getFieldConfigProperties(field) controller-name=SkDynaformConfigFieldConfigController show-btn-apply=false show-btn-close=false backdrop=false popover-class=white-popover absolute=false popover-hide-on-outside-click=false popover-listeners=popoverListener popover-group=fieldConfig always-load-properties=true><sk-icon class=open-icon font-icon=cogwheel tooltip=\"{{'DynaformConfig.tooltipAbrirConfigsCampo' | translate}}\" tooltip-append-to-body=true tooltip-placement=top-left></sk-icon><sk-icon class=close-icon font-icon=chevron-up tooltip=\"{{'DynaformConfig.tooltipFecharConfigsCampo' | translate}}\" tooltip-append-to-body=true tooltip-placement=top-left></sk-icon></span><sk-help-tip class=block-help-icon sk-translate=DynaformConfig.helpTipBloco sk-translate-attr=sk-help-tip></sk-help-tip></div></div></div></div></div></div></sk-viewstack-content></sk-viewstack></div></div></div><script type=text/ng-template id=fieldEditPopoverTemplate.html><sk-form white properties=\"formFields\" columns=\"3\" sk-field-interceptor=\"fieldInterceptor\" model=\"field\" sk-allow-repeated-fields=\"true\"></sk-form></script><script type=text/ng-template id=novaAbaPopoverTemplate.html><form name=\"form\" novalidate class=\"form-inline nova-aba-form\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <input type=\"text\" name=\"nomeNovaAba\" ng-model=\"nomeNovaAba\" placeholder=\"Nome da aba\" class=\"form-control nome-nova-aba-input\" required>\n" +
    "        </div>\n" +
    "        <div class=\"btn-group\">\n" +
    "            <button class=\"btn btn-sm btn-default\" ng-click=\"apply(); nomeNovaAba = ''\">\n" +
    "                <sk-icon font-icon=\"ok-2\"></sk-icon>\n" +
    "            </button>\n" +
    "            <button class=\"btn btn-sm btn-default\" ng-click=\"hide()\">\n" +
    "                <sk-icon font-icon=\"remove-2\"></sk-icon>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </form></script>");
  $templateCache.put("components/dynaform/numeracaoconfig/numeracaoconfig.tpl.html",
    "<form class=sk-form><div class=form-group><label class=form-input-label sk-translate>NumberConfig.numAutomatica</label><sk-switch sk-value=checkNumAutomatica sk-true-value=true sk-false-value=false sk-change=validValue()></sk-switch></div><div class=form-group><label class=form-input-label sk-translate>NumberConfig.numeroInicial</label><sk-number-input sk-value=numeroInicial sk-enabled=checkNumAutomatica sk-change=validValue()></sk-number-input></div></form>");
  $templateCache.put("components/dynamicfilterpanel/dynamic-filter-panel.tpl.html",
    "<sk-accordion close-others=true><sk-accordion-group is-open=defaultTab.isOpen ng-if=\"defaultTab.list.length > 0 || defaultTab.hasCustomDefault\"><sk-accordion-heading sk-remove-header=defaultTab.removeHeader><div layout=row layout-align=\"start center\" class=default-tab-container flex><span class=title ng-bind=defaultTab.name></span> <span tooltip-placement=left ng-click=clearFilter($event); class=clear-filter-text tooltip=DynamicFilterPanel.lblLimparFiltros sk-i18n>DynamicFilterPanel.lblLimpar</span></div></sk-accordion-heading><sk-form ng-keydown=onKeyDown($event) properties=defaultTab.list model=filterModel columns=1 ng-if=\"defaultTab.list.length > 0\" no-padding white></sk-form><div class=custom-filter-container></div></sk-accordion-group><sk-accordion-group ng-repeat=\"groupInfo in groupsInfo\" heading={{groupInfo.name}} is-open=groupInfo.isOpen><div layout flex><sk-entity-list sk-component-created=\"onEntityListCreated($component, groupInfo.id)\" sk-field-name={{groupInfo.id}} sk-entity-name={{groupInfo.entityName}} sk-value=filterModel[groupInfo.md.fieldName] sk-required=groupInfo.md.required flex></sk-entity-list></div></sk-accordion-group><sk-accordion-group ng-repeat=\"customGroup in customGroupsInfo\" heading={{customGroup.label}} is-required=customGroup.isRequired is-open=customGroup.isOpen class=custom-group-element></sk-accordion-group></sk-accordion>");
  $templateCache.put("components/entityattach/entityattach.tpl.html",
    "<button type=button ng-disabled=configDisabled class=\"btn btn-default btn-sk-sm\" ng-click=showInfo() tooltip=\"{{::'Attach.lblAnexo' | translate}}\" tooltip-append-to-body=true tooltip-placement=bottom><sk-icon font-icon=paperclip></sk-icon></button><script type=text/ng-template id=attach.html><div layout=\"column\" class=\"attach-container\" flex>\n" +
    "        <sk-dataset id=\"dsAnexo\" entity-name=\"AnexoSistema\" crud-listener=\"br.com.sankhya.modelcore.crudlisteners.AnexoSistemaCrudListener\" sk-save-handler=\"saveAttach()\"></sk-dataset>\n" +
    "        <div class=\"attach-buttons\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "            <div>\n" +
    "                <sk-btn-novo sk-entity-description=\"{{::'Attach.lblAnexo' | translate}}\" sk-on-click=\"newAttach()\" ng-show=\"selectedIndex == 0\" >\n" +
    "                </sk-btn-novo>\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-sk-sm\" ng-click=\"setSelectedIndex(1)\" ng-show=\"ctrl.isMobile()\" ng-disabled=\"hasRegister\" tooltip=\"{{'Attach.editar' | translate}}\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\">\n" +
    "                    <sk-icon font-icon=\"glyphicons glyphicons-pencil\"></sk-icon>\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-sk-sm\" ng-click=\"deleteAttach()\" sk-disabled=\"!ctrl.isDeletable()\" ng-show=\"selectedIndex == 0\" ng-disabled=\"hasRegister\" tooltip=\"{{'Attach.excluir' | translate}}\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\">\n" +
    "                    <sk-icon font-icon=\"bin\"></sk-icon>\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-sk-sm\" ng-click=\"downloadAttach()\" ng-show=\"selectedIndex == 0\" ng-disabled=\"hasRegister\" tooltip=\"{{(dsAnexo.getFieldValueAsString('LINK') != '' ? 'Attach.visualizar' : 'Attach.download') | translate}}\"  tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\">\n" +
    "                    <sk-icon font-icon=\"{{dsAnexo.getFieldValueAsString('LINK') != '' ? 'link' :'download-alt'}}\"></sk-icon>\n" +
    "                </button>\n" +
    "                <div class=\"btn-group\">\n" +
    "                    <button class=\"btn btn-default btn-sk-sm\" ng-click=\"validateAndSave()\" ng-show=\"selectedIndex == 1\" ng-disabled=\"uploaded\" tooltip=\"{{'Navigator.lblSalvar' | translate}}\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\">\n" +
    "                        <sk-icon font-icon=\"ok-2\"></sk-icon>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"cancelAttach()\" ng-show=\"selectedIndex == 1\" tooltip=\"{{'Navigator.lblDescartar' | translate}}\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\" translate>\n" +
    "                        Attach.descartar\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <sk-rows-counter sk-dataset=\"dsAnexo\"></sk-rows-counter>\n" +
    "        </div>\n" +
    "        <sk-viewstack sk-selected-index=\"selectedIndex\" flex layout=\"column\">\n" +
    "            <sk-viewstack-content flex layout=\"column\">\n" +
    "                <sk-datagrid  id=\"attachDatagrid\" sk-dataset=\"dsAnexo\" sk-datagrid-interceptor=\"datagridInterceptor\" sk-editable=\"false\" sk-allow-multiple-selection=\"false\" sk-on-dbl-click=\"setSelectedIndex(1)\" sk-grid-config=\"{{gridConfigId}}\"></sk-datagrid>\n" +
    "            </sk-viewstack-content>\n" +
    "            <sk-viewstack-content flex layout=\"column\">\n" +
    "                <sk-form properties=\"formFields\" sk-inline=\"true\" sk-form-interceptor=\"formInterceptor\" sk-autofocus></sk-form>\n" +
    "            </sk-viewstack-content>\n" +
    "        </sk-viewstack>\n" +
    "    </div></script>");
  $templateCache.put("components/entitycard/entitycard.tpl.html",
    "<div><sk-translate ng-hide=data>EntityCard.semInformacoes</sk-translate><div ng-if=data class=card-container layout=row flex><div class=image-container><div ng-show=loadingImage><sk-icon class=\"loading-icon spin\" svg-src=/mge/assets/svg/loading.svg></sk-icon></div><img ng-show=\"!loadingImage && hasImage\" ng-src={{fileEncoded}}><div ng-show=\"!loadingImage && !hasImage\" class=nick-contaner ng-style=\"{'background-color': textToColor(data[descriptionField])}\"><span ng-bind=nick></span></div></div><div class=card-content flex><div class=entity-description><sk-icon ng-if=\"disableFavoriteOpt !== true\" ng-click=updateFavorite($event) svg-src=/mge/assets/svg/favorite.svg class=favorite-icon ng-class=\"{'favorite': isFavorite}\" tooltip={{getFavoriteIconTooltip()}} tooltip-trigger=mouseenter tooltip-placement=right tooltip-append-to-body=true></sk-icon><a ng-if=\"enableShowDetails && resourceId\" ng-click=showDetails($event)><span ng-bind-html=title></span> </a><span ng-if=\"!(enableShowDetails && resourceId)\"><span ng-bind-html=title></span></span><div class=clearfix></div></div><div class=\"entity-field-container col-xs-12\" ng-class=\"::{'col-sm-6': !singleColumn, 'pull-none': singleColumn}\" ng-repeat=\"field in fields\" ng-switch=field.type><div ng-switch-when=E class=entity-field><span class=entity-field ng-bind=\"field.label + ': '\"></span> <a ng-href=mailto:{{field.value}} target=_blank><span ng-bind-html=field.value></span></a></div><div ng-switch-when=L class=entity-field><span class=entity-field ng-bind=\"field.label + ': '\"></span> <a ng-href={{field.value}} target=_blank><span ng-bind-html=field.value></span></a></div><p ng-switch-default class=entity-field>{{field.label}}: <span ng-bind-html=field.value></span></p></div><div class=clearfix></div></div><div ng-if=\"enableShowDetails && resourceId\" class=card-actions layout=column layout-align=\"start center\"><sk-icon class=edit-link font-icon=edit ng-if=\"enableShowDetails && resourceId\" ng-click=showDetails($event)></sk-icon></div></div></div>");
  $templateCache.put("components/entitycard/labellink/entitycardpopup.tpl.html",
    "<div class=entity-card-popup><sk-entity-card sk-corner-favorite sk-entity-name=entityName sk-pk-field=entity.pkField sk-description-field=entity.descriptionField sk-has-image=hasImage sk-is-favorite=isFavorite sk-image-field=entity.imageField sk-resource-id=entity.resourceID sk-data=data sk-fields-metadata=entity.fieldsMetadata sk-enable-show-details=showDetails sk-all-pks=entity.allPks></sk-entity-card></div>");
  $templateCache.put("components/entitylist/entitylist.tpl.html",
    "<div flex class=entity-list-container><div layout=row layout-align=\"start center\" class=checkbox-list-header-container><sk-checkbox ng-show=\"!onlyOneSelection && showCheckBox\" accept-indeterminate=true indeterminate-value=I ng-model=checkBoxAll ng-change=atualizaCheckBoxLista() class=checkbox-list-cbx-header tooltip=\"{{'Geral.lblMarcarDesmarcar' | translate}}\" tooltip-placement=right tooltip-append-to-body=true ng-disabled=disableActions></sk-checkbox><span ng-show=showLabel>{{::label}}</span><div class=checkbox-list-header flex layout=row layout-align=\"start center\"><button type=button ng-class=\"{'entity-list-margin-left-5' : onlyOneSelection || !showCheckBox}\" class=\"btn btn-default btn-teste-cond\" ng-click=addItem() class=entity-list-margin-left-5 ng-disabled=disableActions><sk-icon font-icon=plus></sk-icon>{{::'Geral.lblAdicionar' | translate}}</button> <button type=button class=\"btn btn-default\" ng-click=removeSelectedItems() ng-disabled=\"getSelectedItems().length <= 0\"><sk-icon font-icon=remove-2></sk-icon>{{::'Geral.lblRemover' | translate}}</button> <button type=button class=\"btn btn-default\" class=entity-list-margin-right-5 ng-click=clearAll() ng-disabled=!hasData()><sk-icon font-icon=delete></sk-icon>{{::'Geral.lblLimpar' | translate}}</button></div></div><div class=checkbox-list-body-container ng-if=!onlyOneSelection><div ng-repeat=\"item in dataProvider\" class=checkbox-list-body-item ng-click=\"!disableActions && selectItem(item,$event)\" ng-class=\"{'checkbox-list-body-item-lbl-selected':item.selected === true && !disableActions}\"><sk-checkbox ng-model=item.checked ng-click=\"!disableActions && onCheckboxClick(item); !disableActions && saveStateOnCheck();\" class=checkbox-list-cbx-item ng-show=showCheckBox ng-disabled=disableActions></sk-checkbox><span class=\"checkbox-list-span-item noselect\">{{::item.value}}</span></div></div><div class=checkbox-list-body-container ng-if=onlyOneSelection><div ng-repeat=\"item in dataProvider\" ng-repeat=\"item in dataProvider track by $index\" class=checkbox-list-body-item ng-click=\"!disableActions && selectItem(item,$event)\" ng-class=\"{'checkbox-list-body-item-lbl-selected':item.selected === true && !disableActions}\"><sk-radio-input flex=10 style=\"padding-left: 2px; margin-top: 2px\" sk-value=$parent.valueSelected sk-option={{::item.data}} ng-disabled=disableActions></sk-radio-input><span flex class=\"checkbox-list-span-item noselect\">{{::item.value}}</span></div></div></div>");
  $templateCache.put("components/entitystartpage/entitystartpage.tpl.html",
    "<div layout=row layout-align=\"start center\"><sk-icon class=home-icon font-icon=home></sk-icon><h3 class=title translate>EntityStartPage.title</h3></div><div style=\"display: none\"><sk-personalized-filter id=\"{{ ::personalizedFilterId }}\" sk-load-on-create=false sk-standalone-mode=true sk-show-dropdown-filter=false sk-colored-button=false class=pull-right sk-resource-id={{::resourceId}} sk-entity-name=\"{{ ::entityName }}\" sk-apply-function=personalizedFilterApply() sk-save-dynamic-filter-criteria=\"saveDynamicFilterCriteria(resourceId, criteriaToSave)\"></sk-personalized-filter></div><div class=row flex layout><div class=\"col-xs-3 no-padding\"><ul class=actions><li ng-click=onSelectNewEntity() class=new-entity ng-if=showNewEntityLink() layout=row layout-xs=column layout-align=\"start center\"><sk-icon font-icon=plus></sk-icon><span sk-translate>Geral.lblNovoRegistro</span></li><li ng-click=onSelectHierarchy(getCurrentQuery()) ng-if=isHierarchy class=show-hierarchy layout=row layout-xs=column layout-align=\"start center\"><sk-icon font-icon=tree-structure></sk-icon><span sk-translate>EntityStartPage.sideMenu.mostrarHierarquia</span></li><li ng-if=!isHierarchy ng-click=onSelectShowGrid(getCurrentQuery()) class=show-grid layout=row layout-xs=column layout-align=\"start center\"><sk-icon font-icon=table></sk-icon><span sk-translate>EntityStartPage.sideMenu.mostrarGrade</span></li><li ng-click=onSelectShowFilter() class=show-filter layout=row layout-xs=column layout-align=\"start center\"><sk-icon font-icon=filter></sk-icon><span sk-translate>EntityStartPage.sideMenu.filtrar</span></li><li ng-click=onOpenHelp() class=open-help layout=row layout-xs=column layout-align=\"start center\"><sk-icon font-icon=circle-question-mark></sk-icon><span sk-translate>EntityStartPage.sideMenu.ajuda</span></li><li ng-click=startTour() ng-if=hasStartTour class=start-tour layout=row layout-xs=column layout-align=\"start center\"><sk-icon font-icon=train></sk-icon><span sk-translate>EntityStartPage.sideMenu.lblIniciarTour</span></li></ul></div><div class=\"pesquisa-container col-xs-9\" layout=row flex><div class=pesquisa-content layout=row flex><sk-pesquisa-content scope-id=pesquisaContent sk-entity-name=entityName sk-entity=entity sk-on-select=onSelectData sk-limit=5 sk-enable-show-details=false sk-enable-grid-mode=false sk-load-on-creation=_paramCarregInitTela sk-show-all-action=showAllAction sk-show-inactives=true sk-criteria-provider=criteriaProvider sk-resolve-pk-entity=resolvePkEntity flex></sk-pesquisa-content></div><div class=clearfix></div></div></div>");
  $templateCache.put("components/filterpanel/filterpanel.tpl.html",
    "<div flex layout=column class=filter-panel ng-show=\"$ctrl.isOpen !== false\" sk-is-fixed-mode=$ctrl.isFixedMode><sk-vbox flex><div class=btns-container layout=row layout-align=\"end end\"><div layout flex><sk-personalized-filter sk-on-filter-created=$ctrl.onPersonalizedFilterCreated($filter) ng-if=!$ctrl.disablePersonalizedFilter sk-hide-apply=$ctrl.hideApply sk-entity-name={{$ctrl.entityName}} sk-data-source=$ctrl.dataSource sk-resource-id={{$ctrl.resourceId}} sk-has-some-active-filter=$ctrl.hasSomeActiveFilter sk-has-active-pers-filter=$ctrl.hasActivePersFilter sk-apply-function=$ctrl.apply() sk-field-filter-function=$ctrl.fieldFilterFunction sk-link-filter-function=$ctrl.linkFilterFunction sk-expanded-mode=$ctrl.personalizedFilterExpanded sk-btn-apply-label={{::$ctrl.finalBtnApplyLabel}} sk-standalone-mode=$ctrl.pfStandalone sk-hide-filter=$ctrl.hideFilter sk-tooltip-apply={{::$ctrl.tooltipApply}} flex></sk-personalized-filter></div><div flex layout layout-align=\"end end\" ng-if=\"!$ctrl.hideBtnApply && !$ctrl.personalizedFilterExpanded\"><button class=\"btn btn-primary btn-apply\" ng-click=$ctrl.apply()>{{::$ctrl.finalBtnApplyLabel}}</button></div></div><div class=\"filter-header-panel hide\"></div><div ng-if=\"$ctrl.disablePersonalizedFilter && $ctrl.showBtnApplyDynamicFilter\" align=\"center center\" layout-padding><button class=\"btn btn-primary btn-apply\" sk-margin-left=0px ng-click=$ctrl.apply()>{{::$ctrl.finalBtnApplyLabel}}</button></div><sk-dynamic-filter-panel sk-component-created=$ctrl.$onDynamicFilterCreated($component) sk-entity-name={{$ctrl.entityName}} sk-data-source=$ctrl.dataSource sk-save-criteria-fn=$ctrl.saveCriteriaProxy(resourceId,criteria,criteriaToSave) sk-resource-id={{$ctrl.resourceId}} sk-filter-panel-interceptor=$ctrl.filterPanelInterceptor sk-has-filter-infos=$ctrl.hasDynamicFilterInfos sk-has-filter=$ctrl.hasActiveDynFilter ng-show=\"$ctrl.hasDynamicFilterInfos !== false || $ctrl.hasCustomFilter\" sk-custom-criteria-loader=$ctrl.$customCriteriaLoader() sk-has-some-dynamic-filter-data=$ctrl.hasSomeDynamicFilterData() sk-group-others=$ctrl.groupOthers sk-show-label-others-filters=$ctrl.showLabelOthersFilters layout flex></sk-dynamic-filter-panel><div ng-transclude class=filter-panel-transclude style=\"display: none\"></div></sk-vbox></div>");
  $templateCache.put("components/filterpanel/filterpanelbtn/filterpanelbtn.tpl.html",
    "<button primary small ng-click=$ctrl.clickHandler() ng-class=\"{'btn-danger': $ctrl.hasFilter}\" tooltip=Dynaform.mostraEscondePainelFiltros tooltip-placement=right sk-i18n><sk-icon font-icon=filter></sk-icon></button>");
  $templateCache.put("components/fixedbar/fixedbar.tpl.html",
    "<div class=fixed-bar-container><ul class=breadcrumbs><li ng-repeat=\"contextInfo in contextPath\" ng-click=gotoToContext(contextInfo) href=#><a href=# ng-bind=contextInfo.barScope.name ng-class=\"{'active': barContext == contextInfo.barScope.context}\"></a></li></ul><div class=bar-header></div><div class=bar-footer></div></div>");
  $templateCache.put("components/flattree/flattree.tpl.html",
    "<div class=tree-search-container><sk-search-input sk-value=$ctrl.search sk-debounce=300 sk-change=$ctrl.doSearch() sk-click=$ctrl.doSearch() sk-search-options=$ctrl.searchOptions sk-cancel-search=$ctrl.cancelSearch() sk-placeholder=Dynaform.search.entity sk-keydown=$ctrl.handleKeysInput($event) sk-i18n></sk-search-input></div><div class=tree-path-container ng-keydown=$ctrl.handleKeys() ng-class=\"{'on-search': $ctrl.onSearch, 'has-parent': !!$ctrl.currentParent}\"><sk-hbox class=tree-item-parent-container flex><sk-hbox ng-show=!$ctrl.currentParent align=\"start center\" flex><sk-hbox class=icon-container ng-class=\"{'next': !($ctrl.currentParent)}\"><sk-icon svg-src=/mge/assets/svg/next.svg class=\"tree-item-arrow next\"></sk-icon></sk-hbox><div class=\"tree-item-parent-label description-panel\"><span ng-show=\"!$ctrl.currentParent || $ctrl.onSearch\" ng-bind=$ctrl.getEntityOrSearchDescription() tooltip={{$ctrl.getEntityOrSearchDescription()}} class=text-ellipsis></span></div></sk-hbox><sk-vbox ng-show=$ctrl.currentParent flex><sk-hbox><sk-vbox><sk-icon svg-src=/mge/assets/svg/rewind.svg ng-click=$ctrl.goToRoot() close-on-click=true class=\"tree-item-arrow-container tree-item-arrow border-right border-bottom rewind\" tooltip=FlatTree.lblVoltarRaiz tooltip-placement=right sk-i18n></sk-icon><sk-icon svg-src=/mge/assets/svg/back.svg ng-click=$ctrl.backArrowClick() close-on-click=true class=\"tree-item-arrow-container tree-item-arrow border-right back\" tooltip=FlatTree.lblVoltarAnterior tooltip-placement=right sk-i18n></sk-icon></sk-vbox><span layout layout-align=\"start center\" layout-left-padding class=relative flex><span ng-repeat=\"item in $ctrl.currentParentLinkPath\" class=\"tree-item-parent-label code text-ellipsis\"><a href=\"\" tooltip={{item.description}} tooltip-placement=right ng-click=\"$ctrl.goToLevel(item.item, true)\"><span ng-bind=item.label></span> </a><span class=separator>.</span> </span><span ng-repeat=\"item in $ctrl.currentParentPath track by $index\" class=\"tree-item-parent-label code text-ellipsis\"><span ng-bind=item></span> <span class=separator>.</span></span></span></sk-hbox></sk-vbox></sk-hbox></div><sk-vbox sk-scroll-container tabindex=0 class=overflow-y-auto ng-class=\"{'on-search': $ctrl.onSearch}\" ng-show=\"$ctrl.getCurrentLevelList().length > 0\" flex><div layout=row flex ng-repeat=\"item in $ctrl.getCurrentLevelList() track by $index\" ng-click=$ctrl.userItemClick(item) ng-dblclick=$ctrl.itemDblClick(item) class=tree-item-container ng-class=\"{'active': $ctrl.isSelectedItem(item)}\"><sk-vbox flex class=tree-item><sk-hbox align=\"center center\" flex><sk-icon ng-show=item.children font-icon=folder-closed class=\"tree-item-icon folder\"></sk-icon><sk-icon ng-show=!item.children font-icon=file class=tree-item-icon></sk-icon><sk-vbox flex><sk-hbox flex><sk-vbox flex><span ng-bind=item.maskedIdentifier class=\"tree-item-label text-ellipsis\" flex></span> <span ng-bind=$ctrl.getItemDescription(item) tooltip={{$ctrl.getItemDescription(item)}} class=\"tree-item-label text-ellipsis\" flex></span></sk-vbox></sk-hbox><sk-vbox><span ng-bind=item.path class=\"tree-item-search-path text-ellipsis\"></span></sk-vbox></sk-vbox></sk-hbox></sk-vbox><sk-hbox ng-if=item.children ng-click=$ctrl.nextLevelClick(item) class=tree-item-arrow-container><sk-icon svg-src=/mge/assets/svg/next.svg class=tree-item-arrow tooltip=FlatTree.lblAcessarFilhos sk-i18n></sk-icon></sk-hbox></div></sk-vbox><sk-vbox align=\"center center\" ng-show=\"$ctrl.getCurrentLevelList().length == 0\" flex><div sk-font-size=20px sk-color=gray-light><sk-i18n>Geral.semRegistros</sk-i18n>..</div></sk-vbox>");
  $templateCache.put("components/form/form.tpl.html",
    "<div class=form-container creation-complete=creationComplete() layout=column flex><ng-form class=sk-form ng-style=defaultStyle ng-repeat=\"blockInfo in formBlocks\" layout flex ng-class=\"{'flex-initial': ($index == 0 && formBlocks.length > 1)}\"><div ng-switch=blockInfo.userType layout flex><div ng-switch-when=customBlock layout=column flex><label class=\"group-label col-sm-12\" ng-if=\"formBlocks.length > 1\" ng-bind=blockInfo.description></label><sk-form-block sk-properties=blockInfo.properties sk-template={{::blockInfo.template}} sk-template-url={{::blockInfo.templateUrl}} sk-controller={{::blockInfo.controller}} sk-controller-as={{::blockInfo.controllerAs}} sk-event-bus=blockInfo.eventBus sk-creation-complete=onBlockCreationComplete(blockInfo,block) ng-show=blockInfo.visible layout=column flex></sk-form-block></div><div ng-switch-default class=form-fields-container><div ng-class=responsiveClass class=\"{{ isFieldAccount(fieldProperties) ? 'ungroup-fields-account' : 'ungroup-fields' }}\" ng-repeat=\"fieldProperties in blockInfo.groupFields | filter:{groupType:'!GROUPED'}\" ng-show=isFieldVisible(fieldProperties)><sk-form-item dataset=dataset properties=fieldProperties sk-form-interceptor=formInterceptor model=ctrl.getModel()></sk-form-item></div><div class=group-fields ng-repeat=\"groupInfo in blockInfo.groupFields | filter:{groupType:'GROUPED'}\" ng-show=isGroupVisible(groupInfo.groupFields)><label class=\"group-label col-sm-12\" ng-bind=groupInfo.groupLabel></label><sk-form-item ng-class=responsiveClass dataset=dataset properties=field sk-form-interceptor=formInterceptor model=ctrl.getModel() ng-repeat=\"field in groupInfo.groupFields\" ng-show=isFieldVisible(field)></sk-form-item></div><div ng-transclude=formCustomBlock></div><div class=clearfix></div></div></div></ng-form></div><div ng-transclude style=\"display: none\"></div>");
  $templateCache.put("components/form/formitem/formitem.tpl.html",
    "<div class=form-group><label class=form-input-label for=form-item-{{::uid}}></label><sk-icon ng-if=!!helperTooltip font-icon=question-sign tooltip={{::helperTooltip}} ng-style=\"{ 'margin-left': styleTooltip } \" sk-custom-item-input></sk-icon><div class=clearfix></div></div><script type=text/ng-template id=infopersonalizado.html><div ng-bind-html=\"data\" class=\"sk-form-item-custom-content\"></div></script>");
  $templateCache.put("components/formconfig/formconfig.tpl.html",
    "<div><button default small ng-click=ctrl.openPopUpConfig() sk-i18n tooltip=FormConfig.lblCfgForm ng-disabled=!allowFormCfg tooltip-placement=bottom><sk-icon font-icon=cogwheel></sk-icon></button></div>");
  $templateCache.put("components/formconfig/popupconfig/popupconfigform.tpl.html",
    "<sk-two-lists sk-src-title=DynaformConfig.lblCamposDisponiveis sk-dest-title=FormConfig.lblCamposSelecionados sk-src-data=ctrl.availableFields.getItems() sk-dest-data=ctrl.selectedFields.getItems() sk-src-filter-fn=\"ctrl.filterFn(item, searchTerm)\" sk-dest-filter-fn=\"ctrl.filterFn(item, searchTerm)\" sk-on-move-item=\"ctrl.onMoveItem(item, listName)\" sk-on-selection-changed=\"ctrl.onSelectionChanged(selection, list)\" flex layout-padding><sk-src-item-tpl><div>{{item.description + ((item.systemRequired == 'S' || ctrl.userRequired == true )? ' (*)' : '' ) }}</div></sk-src-item-tpl><sk-dest-item-tpl><div>{{item.description + ((item.systemRequired == 'S' || ctrl.userRequired == true )? ' (*)' : '' ) }}</div></sk-dest-item-tpl></sk-two-lists><sk-hbox><sk-vbox sk-width=60%><sk-simple-form sk-columns=1 class=\"form-config-content config-item\" ng-if=\"ctrl.configureFields != false\" sk-in-line=true flex=50><sk-simple-item sk-label=Nome><sk-text-input sk-value=ctrl.userDescription sk-change=\"ctrl.onEditItem('userDescription')\" sk-enabled=\"ctrl.isEditItemEnable() && !ctrl.hasChangedByProgramer(ctrl.selectedField, 'description')\" style=\"width: 337px\"></sk-text-input></sk-simple-item><sk-simple-item sk-label=Grupo><sk-select-distinct-input sk-data-provider=ctrl.distinctGroups sk-change=\"ctrl.onEditItem('userGroupName')\" sk-value=ctrl.userGroupName style=\"width: 337px\"></sk-select-distinct-input></sk-simple-item><sk-simple-item sk-label=Geral.lblTipoValorPadrao ng-if=ctrl.configureDefaultValue sk-i18n><sk-combobox sk-width=250px sk-value=ctrl.comboTipoValorPadrao sk-options=ctrl.dpTipoVlrPadrao sk-change=\"ctrl.selecionaUIExpressao('comboTipoValorPadrao')\" sk-allow-null=false></sk-combobox></sk-simple-item><sk-simple-item sk-label=Geral.lblValorPadrao ng-if=ctrl.configureDefaultValue sk-i18n><sk-text-area sk-value=ctrl.textValorPadrao class=variavel-text-area ng-if=ctrl.textValorPadraoVisibled sk-change=\"ctrl.onEditItem('textValorPadrao')\" flex></sk-text-area><sk-combobox sk-value=ctrl.comboOptions sk-options=ctrl.dpComboOptions sk-allow-null=false ng-if=ctrl.comboOptionsVisibled sk-change=\"ctrl.onEditItem('comboOptions')\"></sk-combobox><sk-combobox sk-value=ctrl.comboVariaveis sk-options=ctrl.dpComboVariaveis sk-allow-null=false ng-if=ctrl.comboVariaveisVisibled sk-change=\"ctrl.onEditItem('comboVariaveis')\"></sk-combobox></sk-simple-item></sk-simple-form></sk-vbox><sk-vbox sk-width=40%><sk-simple-form sk-columns=1 class=\"form-config-content config-item\" ng-if=\"ctrl.configureFields != false\" sk-in-line=true flex=50><sk-simple-item sk-label=\"Campo obrigatório\"><sk-switch sk-enabled=\"ctrl.isEditItemEnable() && ctrl.requiredEnable && !ctrl.hasChangedByProgramer(ctrl.selectedField, 'required')\" sk-value=ctrl.userRequired sk-change=\"ctrl.onEditItem('userRequired')\"></sk-switch></sk-simple-item><sk-simple-item sk-label=\"Campo protegido\"><sk-switch sk-enabled=\"ctrl.isEditItemEnable() && ctrl.readOnlyEnable && !ctrl.hasChangedByProgramer(ctrl.selectedField, 'enabled')\" sk-value=ctrl.userReadOnly sk-change=\"ctrl.onEditItem('userReadOnly')\"></sk-switch></sk-simple-item></sk-simple-form></sk-vbox></sk-hbox>");
  $templateCache.put("components/gridconfig/gridconfig.tpl.html",
    "<div><button default small ng-click=openGridconfig() sk-i18n tooltip=Geral.lblConfigurarGrade ng-disabled=!allowGridEdit tooltip-placement=\"{{tooltipPlacement || 'bottom'}}\"><sk-icon font-icon=cogwheel></sk-icon></button></div>");
  $templateCache.put("components/gridconfig/gridconfigcontent.tpl.html",
    "<div class=hide ng-if=tour ng-joy-ride=tour.startTour config=tour.tourConfig on-finish=tour.onFinish() on-skip=tour.onFinish()></div><div class=gridconfig-content flex layout=column layout-align=center><sk-accordion close-others=true><sk-accordion-group id=grid-config-group-0 heading={{::lblSelecaoDeColunas}} is-open=true is-disabled=false><div layout=column style=\"flex: 1 1 0%\" layout-padding><div ng-if=isSup layout=row style=\"max-width: 90%\"><sk-checkbox tooltip={{::camposTodosUsuariosTooltip}} ng-model=gridConfigContentCtrl.restrictConfig>{{::lblCamposTodosUsuarios}}</sk-checkbox></div><div flex layout=row class=gridconfig-internal-body><div flex=40 class=gridconfig-colunas-disponiveis layout=column layout-align=center><div layout=column><div class=gridconfig-colunas-disponiveis-titulo><p>{{::lblColunasDisponiveis}}</p></div><div layout=row layout-align=\"center center\" class=gridconfig-colunas-disponiveis-search><sk-text-input id=colunasDisponiveisInput sk-value=gridConfigContentCtrl.colunasDisponiveisTerm sk-keydown=onKeydownAtSearchHandlerForAvailableColumns($event) sk-placeholder={{::lblPesquisar}} style=width:98%></sk-text-input><sk-icon font-icon=search></sk-icon></div></div><div sk-sortable=sortableConfigForAvailableColumns class=gridconfig-colunas-container sk-scroll-container id=grdcfg-colunas-disponiveis-container><div ng-repeat=\"column in availableColumns track by $index\"><div class=gridconfig-colunas-disponiveis-item ng-class=\"{'gridconfig-item-selecionado':column.selected}\" ng-click=\"itemClickHandler($event,column,'availableColumns')\" ng-keydown=keydownHandler($event) ng-dblclick=\"moveColumns('availableColumns',false)\" flex layout=row><a id=availableColumn{{adjustID(column.displayName)}}></a><sk-icon font-icon=show-lines class=handle style=\"vertical-align: middle\"></sk-icon><div class=gridconfig-item-padding>{{column.displayName || column.headerName}}</div></div></div></div></div><div flex=10 layout=column layout-align=\"center center\" class=gridconfig-buttons-container gridconfig-center-buttons><button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"isTourMode || availableColumns.length <= 0\" id=grdcfg-btn-move-all-to-right ng-click=\"moveColumns('availableColumns',true)\"><sk-icon svg-src=/mge/assets/svg/forward.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"isTourMode || !isSomeAvailableColumnSelected()\" id=grdcfg-btn-move-selected-to-right ng-click=\"moveColumns('availableColumns',false)\"><sk-icon svg-src=/mge/assets/svg/next.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"isTourMode || !isSomeSelectedColumnSelected()\" id=grdcfg-btn-move-selected-to-left ng-click=\"moveColumns('selectedColumns',false)\"><sk-icon svg-src=/mge/assets/svg/back.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons btn btn-default\" ng-disabled=\"isTourMode || selectedColumns.length <= 0\" id=grdcfg-btn-move-all-to-left ng-click=\"moveColumns('selectedColumns',true)\"><sk-icon svg-src=/mge/assets/svg/rewind.svg style=min-width:20px></sk-icon></button></div><div flex=40 layout=column layout-align=center class=gridconfig-colunas-selecionadas><div layout=column><div class=gridconfig-colunas-disponiveis-titulo><p>{{::lblColunasSelecionadas}}</p></div><div flex layout=row layout-align=\"center center\" class=gridconfig-colunas-selecionadas-search><sk-text-input id=colunasSelecionadasInput sk-value=gridConfigContentCtrl.colunasSelecionadasTerm sk-keydown=onKeydownAtSearchHandlerForSelectedColumns($event) sk-placeholder={{::lblPesquisar}} style=width:98%></sk-text-input><sk-icon font-icon=search></sk-icon></div></div><div sk-sortable=sortableConfigForSelectedColumns class=gridconfig-colunas-container sk-scroll-container id=grdcfg-colunas-selecionadas-container><div ng-repeat=\"column in selectedColumns track by $index\"><div class=gridconfig-colunas-selecionadas-item ng-class=\"{'gridconfig-item-selecionado':column.selected}\" ng-click=\"itemClickHandler($event,column,'selectedColumns')\" ng-keydown=keydownHandler($event) ng-dblclick=\"moveColumns('selectedColumns',false)\" flex layout=row><a id=selectedColumn{{adjustID(column.displayName)}}></a><sk-icon font-icon=show-lines class=handle style=\"vertical-align: middle\"></sk-icon><div flex class=gridconfig-item-padding>{{column.displayName}}</div></div></div></div></div><div flex=10 layout=column layout-align=\"center center\" class=\"gridconfig-buttons-container gridconfig-buttons-last\"><button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (selectedColumns[0] && selectedColumns[0].selected) || !isSomeSelectedColumnSelected() || selectedColumnsSelected.length > 1\" ng-click=\"changeSelectedColumnsSort('up-all')\" id=grdcfg-btn-up-all><sk-icon svg-src=/mge/assets/svg/up-all.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (selectedColumns[0] && selectedColumns[0].selected) || !isSomeSelectedColumnSelected()\" ng-click=\"changeSelectedColumnsSort('up')\" id=grdcfg-btn-up><sk-icon svg-src=/mge/assets/svg/up.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (selectedColumns[selectedColumns.length - 1] && selectedColumns[selectedColumns.length - 1].selected) || !isSomeSelectedColumnSelected()\" ng-click=\"changeSelectedColumnsSort('down')\" id=grdcfg-btn-down><sk-icon svg-src=/mge/assets/svg/down.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (selectedColumns[selectedColumns.length - 1] && selectedColumns[selectedColumns.length - 1].selected) || !isSomeSelectedColumnSelected() || selectedColumnsSelected.length > 1\" ng-click=\"changeSelectedColumnsSort('down-all')\" id=grdcfg-btn-down-all><sk-icon svg-src=/mge/assets/svg/down-all.svg style=min-width:20px></sk-icon></button></div></div></div></sk-accordion-group><sk-accordion-group id=grid-config-group-1 heading={{::lblOrdenacaoDosDados}} is-open=false is-disabled=false><div layout=column flex layout-padding><div layout=row layout-align=\"center center\" class=gridconfig-colunas-ordenadas-search><sk-text-input id=colunasOrdenadasInput sk-value=gridConfigContentCtrl.colunasOrdenadasTerm sk-keydown=onKeydownAtSearchHandlerForOrderColumns($event) sk-placeholder={{::lblPesquisar}} flex></sk-text-input><sk-icon font-icon=search></sk-icon></div><div flex layout=row><div flex=90 sk-sortable=sortableConfigForSelectedColumns class=gridconfig-colunas-order-container sk-scroll-container><div ng-repeat=\"column in orderedColumns track by $index\" flex=100 layout=row class=gridconfig-colunas-disponiveis-item ng-class=\"{'gridconfig-item-selecionado':column.selected}\" ng-keydown=keydownHandler($event) style=width:100%><div flex=95 layout=row layout-align=left><div flex layout=row layout-align=\"left center\"><a id=orderedColumn{{adjustID(column.displayName)}}></a><sk-icon font-icon=show-lines class=handle style=\"vertical-align: middle\"></sk-icon><sk-checkbox ng-model=column.checked></sk-checkbox><div flex style=padding-left:10px;padding-top:5px style=margin-top:2px;cursor:default ng-click=toggleOrderedColumn($event,column)>{{column.displayName}}</div></div></div><div flex=5 ng-show=\"column.checked == true\"><sk-icon svg-src=/mge/assets/svg/sort-a-z.svg ng-if=\"column.direction == 'asc'\" ng-click=\"column.direction = 'dec'\" class=gridconfig-sort-priority tooltip={{::lblAscendente}}></sk-icon><sk-icon svg-src=/mge/assets/svg/sort-z-a.svg ng-if=\"column.direction == 'dec'\" ng-click=\"column.direction = 'asc'\" class=gridconfig-sort-priority tooltip={{::lblDescendente}}></sk-icon></div></div></div><div flex=10 layout=column layout-align=\"center center\" class=gridconfig-buttons-container><button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (orderedColumns[0] && orderedColumns[0].selected) || !isSomeSelectedColumnSelected() || selectedColumnsSelected.length > 1\" ng-click=\"changeOrderedColumnsSort('up-all')\"><sk-icon svg-src=/mge/assets/svg/up-all.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (orderedColumns[0] && orderedColumns[0].selected) || !isSomeSelectedColumnSelected()\" ng-click=\"changeOrderedColumnsSort('up')\"><sk-icon svg-src=/mge/assets/svg/up.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (orderedColumns[selectedColumns.length - 1] && orderedColumns[selectedColumns.length - 1].selected) || !isSomeSelectedColumnSelected()\" ng-click=\"changeOrderedColumnsSort('down')\"><sk-icon svg-src=/mge/assets/svg/down.svg style=min-width:20px></sk-icon></button> <button class=\"gridconfig-buttons gridconfig-buttons-right btn btn-default\" ng-disabled=\"isTourMode || (orderedColumns[selectedColumns.length - 1] && orderedColumns[selectedColumns.length - 1].selected) || !isSomeSelectedColumnSelected() || selectedColumnsSelected.length > 1\" ng-click=\"changeOrderedColumnsSort('down-all')\"><sk-icon svg-src=/mge/assets/svg/down-all.svg style=min-width:20px></sk-icon></button></div></div></div></sk-accordion-group></sk-accordion></div>");
  $templateCache.put("components/gridprinter/gridprinter.tpl.html",
    "<div class=btn-group style=\"display: flex !important\"><button class=\"btn btn-default btn-sk-sm\" ng-click=\"choosedPrintType('pdf')\" ng-disabled=\"enabled === false\" tooltip={{::tooltipGridPrinter}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=file-export></sk-icon></button> <button type=button class=\"btn btn-default dropdown-toggle\" sk-popover popover-template-url=gridPrinter.html popover-placement={{placement}} popover-auto-repostion-placement={{autoRepostionPlacement}} popover-index={{zIndex}} always-load-properties=true create-on-load=false show-btn-apply=false show-btn-close=false width={{getPopoverWidth()}} height=auto popover-class=\"white-popover sk-gridprinter-popover {{mobileClass}}\" properties=ctrl.getGridPrinterProperties controller-name=SkGridPrinterPopOverController popover-listeners=enableDisableMoreOptions ng-disabled=\"enabled === false\" style=\"justify-content: center;align-items: center;display: flex\"><span class=caret style=\"margin: 0px\"></span></button></div><script type=text/ng-template id=gridPrinter.html><div class=\"actions-container actions-container-cursor\">\n" +
    "        <div layout-wrap layout=\"row\">\n" +
    "            <div class=\"action-item {{ action.type }}\" ng-repeat=\"action in menuOpt\"\n" +
    "                 ng-click=\"choosedPrintType(action.type); hide()\" layout=\"column\" layout-align=\"start center\"\n" +
    "                 tooltip=\"{{::action.description}}\" tooltip-placement=\"bottom\">\n" +
    "                <div class=\"img-container\">\n" +
    "                    <sk-icon svg-src=\"{{::getIcon(action.type) }}\"></sk-icon>\n" +
    "                </div>\n" +
    "                <span class=\"action-label\" ng-bind=\"::action.description\">\n" +
    "                </span>\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"onlyReport && dynamicOptions.length == 0\" class=\"separator-title\">{{titleRelatorioFormatado}}</div>\n" +
    "\n" +
    "            <div ng-if=\"!hideDynamicOptions\" class=\"separator-container\" ng-repeat=\"tree in dynamicOptions track by $index\" layout-wrap layout=\"row\">\n" +
    "                <div class=\"separator-title\" ng-bind=\"tree.description\"></div>\n" +
    "                <div class=\"action-item\" ng-repeat=\"child in tree.children track by $index\"\n" +
    "                     ng-click=\"itemClickReport(child); hide()\" layout=\"column\" layout-align=\"start center\">\n" +
    "                    <div class=\"img-container\">\n" +
    "                        <div ng-if=\"::!actionHasImage(child)\" class=\"nick-contaner\"\n" +
    "                             ng-style=\"{'background-color': textToColor(child.description)}\"\n" +
    "                             tooltip=\"child.description\" tooltip-placement=\"bottom\">\n" +
    "                            <span ng-bind=\"::buildNick(child)\"></span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                <span class=\"action-label\" ng-bind=\"child.description\">\n" +
    "                </span>\n" +
    "                </div>\n" +
    "                <div class=\"clearfix\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"clearfix\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"show-more-container\">\n" +
    "        <a class=\"show-more-link\" ng-click=\"showMore()\">Mostrar mais</a>\n" +
    "    </div></script>");
  $templateCache.put("components/gridstatistics/gridstatisticscontent.tpl.html",
    "<sk-dataset sk-dataset-created=gridStatisticsCtrl.onDsCreated(dataset) sk-standalone><sk-dsfield-md name=COLUNA description=DataGrid.coluna user-type=S></sk-dsfield-md><sk-dsfield-md name=SOMA description=DataGrid.soma user-type=F></sk-dsfield-md><sk-dsfield-md name=MEDIA description=DataGrid.media user-type=F></sk-dsfield-md><sk-dsfield-md name=OCORRENCIAS description=DataGrid.ocorrencias user-type=I></sk-dsfield-md><sk-dsfield-md name=MAIOR description=DataGrid.maior user-type=F></sk-dsfield-md><sk-dsfield-md name=MENOR description=DataGrid.menor user-type=F></sk-dsfield-md></sk-dataset><sk-datagrid sk-dataset=gridStatisticsCtrl.dsGridStatistics sk-hide-cbx-column=true sk-editable=false flex layout></sk-datagrid>");
  $templateCache.put("components/groupcontainer/groupcontainer.tpl.html",
    "<div layout=column class=group-container flex><div class=header ng-bind=$ctrl.title></div><div class=group-user-container ng-transclude layout=column flex></div></div>");
  $templateCache.put("components/imagepopup/imagepopup.tpl.html",
    "<canvas></canvas>");
  $templateCache.put("components/input/codeEditor/codeeditor.tpl.html",
    "<div class=editor-container flex layout><div id={{::editorId}} class=sk-code-editor flex layout></div></div>");
  $templateCache.put("components/input/combobox/combobox.match.tpl.html",
    "<div class=\"ui-select-container selectize-control single\"><div class=selectize-input ng-class=\"{'focus': $select.open, 'disabled': $select.disabled, 'selectize-focus' : $select.focus}\" ng-click=$select.activate()><div class=ui-select-match></div><input autocomplete=off tabindex=-1 class=\"ui-select-search ui-select-toggle\" ng-click=$select.toggle($event) placeholder={{$select.placeholder}} ng-model=$select.search ng-hide=\"!$select.searchEnabled || ($select.selected && !$select.open)\" ng-disabled=$select.disabled aria-label=\"{{ $select.baseTitle }}\" ui-grid-editor=gridEditor></div><div class=ui-select-choices></div></div>");
  $templateCache.put("components/input/combobox/combobox.tpl.html",
    "<sk-select sk-focus-out=onFocusOut sk-focus=onFocus outfocus-on=UiSelectFocusEvent ng-model=modelValue.selected theme=selectize ng-disabled=!enabled on-select=onSelect() append-to-body=true><sk-select-match allow-clear=true placeholder={{$select.selected[label]}}>{{$select.selected[label]}}</sk-select-match><sk-select-choices repeat=\"opt in processedOptions | filter: $select.search\" title={{opt.tooltip}}><span ng-if=\"withoutBindHtml != true\" ng-bind-html=\"opt[label] | highlight: $select.search\"></span> <span ng-if=\"withoutBindHtml == true\" ng-bind=\"opt[label] | highlight: $select.search\"></span></sk-select-choices></sk-select>");
  $templateCache.put("components/input/date/templates/dateinputdaypicker.tpl.html",
    "<table class=date-picker-popup role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left\" ng-click=move(-1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th><th colspan=\"{{::5 + showWeeks}}\"><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm\" ng-click=\"toggleMode(1, $event)\" ng-disabled=\"datepickerMode === maxMode\" tabindex=-1 style=width:100%><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right\" ng-click=move(1) tabindex=-1><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th></tr><tr><th ng-if=showWeeks class=text-center></th><th ng-repeat=\"label in ::labels track by $index\" class=text-center><small aria-label={{::label.full}}>{{::label.abbr}}</small></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-if=showWeeks class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td><td ng-repeat=\"dt in row track by dt.date\" class=text-center role=gridcell id={{::dt.uid}} ng-class=::dt.customClass><button type=button style=width:100% class=\"btn btn-default btn-sm\" ng-class=\"{'btn-primary': dt.selected}\" ng-click=select(dt.date) ng-disabled=dt.disabled tabindex=-1><span ng-class=\"::{'text-muted': dt.secondary, 'current-day': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
  $templateCache.put("components/input/date/templates/dateinputpopup.tpl.html",
    "<ul class=dropdown-menu ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=keydown($event)><li style=\"padding: 5px\" ng-transclude></li><li style=\"padding:10px 9px 2px\"><span class=pull-right><button type=button class=\"btn btn-sm btn-primary\" ng-click=\"select('today')\">{{ getText('current') }}</button> <button type=button class=\"btn btn-sm btn-default\" ng-click=select()>{{ getText('clear') }}</button></span></li></ul>");
  $templateCache.put("components/input/fileinput/fileinput.tpl.html",
    "<div ng-style=\"{ 'width': '100%' }\"><div class=file-upload-wrapper layout=row layout-align=\"start end\" flex><button class=\"transparente ng-isolate-scope\" ng-click=onClickUpload($event)></button><div sk-disabled=!enabled class=file-upload-icon layout=row><sk-icon class=img-src svg-src=/mge/assets/svg/upload-arrow.svg tooltip=\"{{(userTooltip || 'Attach.upload') | translate}}\"></sk-icon><input ng-mouseleave=onFocusOutIcoUpload() ng-mouseover=onFocusInIcoUpload() ng-style=\"onlyButton && {'width': '0px'}\" type=file id={{idInput}} name=file file-model=value ng-disabled=!enabled change=changeHandler() ng-focus=addFocus() ng-blur=removeFocus()></div><div id=input-file layout=column layout-align=\"end end\" flex><div layout=row layout-align=\"space-between start\" style=\"height: 20px;width: 100%;padding: 2px\"><div id={{statusId}} sk-popover popover-template-url=popoverFileInputAlert.html popover-id={{::editionAlertPopOverId}} properties=getPropertiesInfo always-load-properties=true hide-on=mouseleave show-on-mouse-position=true show-on-mouse-enter=true width=435 height=auto class=texto-status></div><div sk-disabled=!enabled ng-show=showIconCancel ng-click=cancelUpload() layout=column layout-align=\"center center\" class=icon-close-cancel tooltip={{cancelToolTip}} tooltip-placement=right><sk-icon svg-src=/mge/assets/svg/cancel.svg class=icon-close></sk-icon></div></div><div layout=column layout-align=\"end start\" sk-width=100%><div id={{progressBarId}} class=\"progress-bar progress-bar-color\" role=progressbar aria-valuenow=40 aria-valuemin=0 aria-valuemax=100></div></div></div></div><script type=text/ng-template id=popoverFileInputAlert.html><table class=\"table\">\n" +
    "            <thead>\n" +
    "                <tr>\n" +
    "                    <th scope=\"col\" sk-i18n>Attach.lblAnexo</th>\n" +
    "                    <th scope=\"col\" sk-i18n>Attach.modificado</th>\n" +
    "                    <th scope=\"col\" sk-i18n>Attach.tamanho</th>\n" +
    "                </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "                <tr>\n" +
    "                    <td>{{name}}</span></td>\n" +
    "                    <td sk-width=\"120px\">{{lastModifiedDate}}</td>\n" +
    "                    <td style=\"min-width: 100px;\">{{size}}</td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table></script></div>");
  $templateCache.put("components/input/fileinputmulti/fileinputmulti.tpl.html",
    "<div ng-click=onClickOpenMultipleFiles() class=file-upload-wrapper style=\"cursor: pointer\" layout=row layout-align=\"start end\" flex><img sk-disabled=!enabled width=16px height=16px src=/mge/assets/img/multiplos-arquivos.png><div id=input-file layout=column layout-align=\"end end\" style=\"margin-left: 5px\" flex><span id={{statusId}} ng-if=\"countItems > 0\" layout=row layout-align=\"space-between start\" style=\"height: 20px; width: 100%; padding: 2px; margin-left: 5px; color: #15c\">{{countItemsDescription}}</span></div></div>");
  $templateCache.put("components/input/fileinputmulti/popup/filemultipopup.tpl.html",
    "<sk-vbox class=multiattach gap=5 flex><sk-hbox sk-border=\"1px solid #ccc\" sk-bg-color=gray-lighter gap=5 layout-padding><button sk-disabled=!ctrl.enabled default font-icon=link ng-click=ctrl.addLink() sk-i18n>Attach.incluirLink</button> <button sk-disabled=!ctrl.enabled default class=img-src svg-src=/mge/assets/svg/upload-arrow.svg ng-click=ctrl.addFiles() sk-i18n>Attach.enviarArquivo</button> <button sk-disabled=ctrl.disableDownloadAll() default font-icon=download-alt ng-click=ctrl.downloadAll() sk-i18n>Attach.baixarArquivos</button> <button sk-disabled=\"ctrl.fileItems.length == 0 || !ctrl.enabled\" default font-icon=bin ng-click=ctrl.removeAll() sk-i18n>Attach.deletarTodos</button></sk-hbox><sk-list sk-scroll-container flex><sk-hbox class=icon-list ng-repeat=\"item in ctrl.fileItems\" sk-padding=\"20px 8px 20px 8px\"><sk-hbox ng-show=!item.upload flex><sk-vbox gap=1 layout-align=\"center start\" flex=95><b sk-color=\"{{!item.link ? 'royalblue' : 'black'}}\" title={{item.name}}>{{item.name | limitToName}}</b> <b ng-if=!item.link sk-color=gray-light sk-margin-left=2.5px>{{item.size|bytesToSize}}</b> <a ng-if=item.link sk-color=gray-light ng-click=ctrl.downloadAtIndex(item) sk-margin-left=2.5px title={{item.link}}>{{item.link | limitToName}}</a></sk-vbox><sk-hbox gap=15 layout-align=\"end center\" flex=5><sk-hbox><sk-icon font-icon=\"{{!item.link ? 'download-alt' : 'link'}}\" ng-click=ctrl.downloadAtIndex(item)></sk-icon></sk-hbox><sk-hbox><sk-icon sk-disabled=!ctrl.enabled class=svgicon svg-src=/mge/assets/svg/cancel.svg ng-click=\"ctrl.removeAttach(item, false)\"></sk-icon></sk-hbox></sk-hbox></sk-hbox><sk-hbox ng-show=item.upload layout-align=\"start end\" sk-width=100% style=\"justify-content: space-between\" gap=5><sk-hbox id={{item.progressBarId}} style=\"max-width: 100%\" class=\"progress-bar progress-bar-color\" role=progressbar aria-valuenow=40 aria-valuemin=0 aria-valuemax=100><sk-hbox layout-align=\"start end\"><div class=texto-status id={{item.statusId}}></div></sk-hbox></sk-hbox><sk-hbox layout-align=\"center center\" style=\"margin-bottom: 2.5px\"><sk-icon class=svgicon svg-src=/mge/assets/svg/cancel.svg ng-click=\"ctrl.removeAttach(item, true)\"></sk-icon></sk-hbox></sk-hbox></sk-hbox></sk-list></sk-vbox><input id={{idInput}} ng-style=\"{'width': '0px', 'height': '0px'}\" type=file name=file file-multi-model=value change=ctrl.onChangeHandler() ng-click=ctrl.allowSameFile($event) multiple>");
  $templateCache.put("components/input/filterdataset/filterdataset.tpl.html",
    "<sk-hbox layout-align=\"start start\" flex><sk-text-input id=inputFilter sk-i18n sk-placeholder=DataGrid.pesquisar sk-value=valueFilter ng-keypress=runScript($event)></sk-text-input><button default small sk-i18n class=btn-pesquisa ng-click=eventFilter() tooltip=DataGrid.pesquisar tooltip-placement=bottom><sk-icon font-icon=search></sk-icon></button></sk-hbox>");
  $templateCache.put("components/input/imageinput/imageinput.tpl.html",
    "<div class=file-container ng-style=\"{ width: width, height: height }\"><sk-icon ng-show=loadingImage class=\"loading-icon spin\" svg-src=/mge/assets/svg/loading.svg></sk-icon><div class=image-container ng-show=!loadingImage><img ng-src={{fileEncoded}}> <input ng-show=!onlyImage type=file name=file file-model=file change=changeHandler(file) ng-disabled=!enabled tabindex=-1><div ng-show=!onlyImage class=btn-container layout flex layout-align=\"space-between center\"><button default ng-click=uploadFile($event) class=btn-upload tooltip=\"{{ 'ImageInput.tooltipEnviar' | translate }}\"><sk-icon font-icon=arrow-up></sk-icon></button> <button danger ng-click=deleteFile($event) class=btn-delete tooltip=\"{{ 'ImageInput.tooltipExcluir' | translate }}\"><sk-icon font-icon=bin></sk-icon></button></div></div></div>");
  $templateCache.put("components/input/multicombo/multicombo.tpl.html",
    "<div class=sk-multi-combo><input class=form-control ng-model=message ng-disabled=!enabled><button class=btn sk-popover popover-template-url=components/input/multicombo/multicombolist/multicombolist.tpl.html controller-name=skMultiComboListController controller-as=ctrl create-on-load=false show-triangle=false properties=getListProps padding=3 width=100% height=110 tooltip={{message}} tooltip-append-to-body=true tooltip-placement=bottom popover-listeners=ctrl.popoverListener ng-disabled=!enabled></button> <span class=arrow></span></div>");
  $templateCache.put("components/input/multicombo/multicombolist/multicombolist.tpl.html",
    "<div class=\"sk-multi-combo root-list\" ng-repeat=\"opt in options\"><sk-switch sk-value=opt.selected sk-true-value=true sk-false-value=false sk-change=ctrl.onChangeSelection()></sk-switch><label class=\"form-input-label label-list\" ng-bind=opt.value></label></div>");
  $templateCache.put("components/input/pesquisa/config/pesquisaconfig.tpl.html",
    "<span sk-popover popover-template-url=components/input/pesquisa/config/pesquisaconfigcontent.tpl.html controller-name=SkPesquisaConfigContentController controller-as=ctrl bind-to-controller=true properties=$ctrl.getConfigSearchProperties() show-btn-apply=false show-btn-close=false height=auto width=auto popover-class=white-popover show-on-mouse-position=true popover-placement=left show-triangle=false padding=0><sk-icon font-icon=filter-cogwheel v=2></sk-icon></span>");
  $templateCache.put("components/input/pesquisa/config/pesquisaconfigcontent.tpl.html",
    "<div class=pesquisa-config-content><div class=pesquisa-config-header-container layout layout-align=\"center center\"><section class=pesquisa-config-filter-modal><div class=tab><div class=\"tab-item tab-count\" ng-class=\"{'selected': selectedTab === 0}\" ng-click=selectedTabFn(0) sk-translate ng-show=\"descriptors.fieldDescriptors.length > 0\">Campos</div><div class=\"tab-item tab-count\" ng-class=\"{'selected': selectedTab === 1}\" ng-click=selectedTabFn(1) ng-show=\"descriptors.canRelations === true && descriptors.relationDescriptors.length > 0\" flex>Relacionamentos</div></div><div class=pesquisa-config-search ng-show=\"selectedTab < 2\"><sk-checkbox ng-model=allSelected ng-click=checkAllDescriptors()></sk-checkbox><sk-text-input sk-value=searchInput sk-placeholder=Pesquisar flex></sk-text-input></div></section></div><div class=pesquisa-config-body flex layout><div ng-if=\"selectedTab === 0\" ng-repeat=\"descriptor in descriptors.fieldDescriptors | filter: searchInput\" class=repeated-item flex><div ng-click=itemClickHandler(descriptor) class=descriptor-item><sk-checkbox ng-model=descriptor.searchable ng-click=itemClickHandler(descriptor)>{{ descriptor.description.substring(0,44) }}</sk-checkbox></div></div><div ng-if=\"selectedTab === 1\" ng-repeat=\"descriptor in descriptors.relationDescriptors | filter: searchInput\" class=repeated-item flex><div ng-click=itemClickHandler(descriptor) class=descriptor-item><sk-checkbox ng-model=descriptor.searchable ng-click=itemClickHandler(descriptor)>{{ descriptor.description.substring(0,44) }}</sk-checkbox></div></div><div ng-if=\"descriptors.fieldDescriptors.length === 0 && (descriptors.canRelations === false || descriptors.relationDescriptors.length == 0) \" ng-repeat=\"relation in descriptors.relationDescriptors | filter: searchInput\" class=repeated-item flex><span>Não existem campos disponiveis para configurar.</span>></div></div><div class=pesquisa-config-footer flex layout><button class=\"btn btn-danger\" ng-click=removeConfig();>Restaurar</button> <button class=\"btn btn-primary\" ng-click=saveConfig();>Salvar</button></div></div>");
  $templateCache.put("components/input/pesquisa/content/pesquisacontent.tpl.html",
    "<div class=sk-pesquisa-search-container layout=row><sk-dataset entity-name={{entityName}} metadata-provider=dsMetadataProvider sk-dataset-created=onDatasetLoaded(dataset)></sk-dataset><div class=search-group ng-show=showSearchInput flex><input auto-focus scope-id=searchInput creation-complete=onInputCreationComplete() class=\"query-input form-control\" placeholder=\"{{(queryPlaceholder || 'PesquisaContent.searchPlaceholder') | translate}}\" ng-model=query ng-model-options=ngModelOptions ng-change=loadSuggestions() ng-keydown=onKeydown($event)><sk-icon font-icon=search ng-click=loadSuggestions() class=btn-search></sk-icon><sk-pesquisa-config class=btn-config-search sk-entity-name=\"{{ ::entityName }}\"></sk-pesquisa-config><sk-icon font-icon=circle-question-mark ng-click=openHelpPopup() class=btn-help tooltip-placement={{::helpTooltipAling}} tooltip=\"{{'Dynaform.search.tooltipPesquisa' | translate}}\" tooltip-append-to-body=true></sk-icon></div><div ng-show=\"enableGridMode && rowsCounterVisibleHieraircal && showSearchInput\" class=buttons-container><sk-rows-counter sk-dataset=dataset></sk-rows-counter></div><div ng-show=enableGridMode class=buttons-container><button type=button class=\"btn btn-default\" ng-disabled=!canGoToGrid ng-click=changeViewMode()><sk-icon font-icon=\"{{viewMode == 'list' ? 'table' : 'list'}}\"></sk-icon></button></div><div ng-show=\"rowsCounterVisible && showSearchInput\" class=buttons-container><sk-rows-counter sk-dataset=dataset></sk-rows-counter></div></div><div class=sk-pesquisa-content-container layout=column flex><sk-viewstack sk-selected-index=viewStackSelectedIndex flex layout=column><sk-viewstack-content flex layout=column style=\"position: relative\"><div class=state-text ng-show=\"emptyList || !hierarchicalDP || !hierarchicalDP.length\" flex>{{stateText}}</div><sk-tree ng-show=\"!emptyList && hierarchicalDP && hierarchicalDP.length\" flex layout sk-tree-data=hierarchicalDP sk-search-term=query sk-on-select=selectedOnTree sk-double-click-for-select=treeDblClickForSelect sk-search-term-interceptor=treeSearchInterceptor sk-tree-control=treeCtrl></sk-tree></sk-viewstack-content><sk-viewstack-content flex layout=column><div class=state-text ng-show=emptyList flex>{{stateText}}</div><div class=sk-pesquisa-result-container sk-scroll-container><div ng-show=!emptyList class=sk-pesquisa-content-result-row ng-class=\"{'multi-selected': multiSelectEnabled && isActive($index), 'active': !multiSelectEnabled && isActive($index)}\" ng-repeat=\"data in entity.data\" ng-click=\"onClick($event, $index, entity, data)\" ng-dblclick=\"onDoubleClick($event, $index, entity, data)\"><sk-entity-card sk-highlight-on=query sk-corner-favorite sk-entity-name=entityName sk-pk-field=entity.pkField sk-all-pks=entity.allPks sk-other-entity-pks=entity.otherEntityPks sk-description-field=entity.descriptionField sk-has-image=data.__hasImage sk-is-favorite=data.__isFavorite sk-image-field=entity.imageField sk-resource-id=entity.resourceID sk-data=data sk-fields-metadata=entity.fieldsMetadata sk-enable-show-details=enableShowDetails sk-single-column=false sk-resolve-pk-entity=entity.resolvePkEntity></sk-entity-card></div></div><div class=has-more ng-if=entity.hasMore>{{searchLimited}} <a href=# ng-if=showAllAction ng-click=showAllAction(query)>{{clickSeeAll}}</a></div></sk-viewstack-content><sk-viewstack-content flex layout=column><div class=state-text ng-show=emptyList flex>{{stateText}}</div><sk-datagrid ng-show=!emptyList id=datagrid sk-dataset=dataset sk-editable=false sk-allow-multiple-selection=multiSelectEnabled sk-on-click=onGridSingleClick() sk-on-dbl-click=onGridDoubleClick() sk-grid-config={{gridConfigId}} sk-focus-to-after-refresh=searchInput sk-on-datagrid-loaded=onDatagridLoaded(datagrid)></sk-datagrid><div class=has-more ng-if=\"entity.hasMore || (entity.data && limit === entity.data.length)\">{{searchLimited}} <a href=# ng-if=showAllAction ng-click=showAllAction(query)>{{clickSeeAll}}</a></div></sk-viewstack-content></sk-viewstack></div>");
  $templateCache.put("components/input/pesquisa/content/pesquisacontenthelppopup.tpl.html",
    "<div class=sk-popup-pesquisa-help layout flex><sk-wizard sk-hide-indicators=false sk-on-finish=onFinishWizard($step) sk-hide-btn-cancel=true layout flex><sk-step sk-title=PesquisaContent.titlePesquisaSimples sk-can-next=true><div layout=column layout-align=\"start center\" class=step-container flex><p sk-i18n>PesquisaContent.help.step1</p><img src=/mge/assets/img/pesquisacontenthelp/step1.PNG width=430px height=300px></div></sk-step><sk-step sk-title=PesquisaContent.titleUnicaInformacao sk-can-next=true><div layout=column layout-align=\"start center\" class=step-container flex><p sk-i18n>PesquisaContent.help.step2</p><img src=/mge/assets/img/pesquisacontenthelp/step2.PNG></div></sk-step><sk-step sk-title=PesquisaContent.titleMultiplasInformacoes sk-finalize=true><div layout=column layout-align=\"start center\" class=step-container flex><p sk-i18n>PesquisaContent.help.step3</p><img src=/mge/assets/img/pesquisacontenthelp/step3.PNG></div></sk-step></sk-wizard></div>");
  $templateCache.put("components/input/pesquisa/popup/pesquisa-pop-up.tpl.html",
    "<div layout=column class=pesquisa-popup-modal-body><div class=\"top-bar hide\"></div><sk-pesquisa-content sk-id=pesquisaContentId sk-entity-name=entityName sk-entity=entity sk-on-select=selectData sk-enable-rows-counter=enableRowsCounter sk-on-entity-loaded=onEntityLoaded sk-query={{query}} sk-criteria-provider=criteriaProvider sk-options=options sk-load-on-creation=false flex></sk-pesquisa-content><div ng-if=multiSelect layout=row layout-align=\"end center\" style=\"padding: 8px 16px\"><button class=\"btn btn-primary\" ng-click=confirmMultiSelection() sk-translate>PesquisaContent.confirmarSelecao</button></div></div>");
  $templateCache.put("components/input/pesquisa/typeahead.tpl.html",
    "<div><sk-entity-card sk-corner-favorite sk-highlight-on=query sk-entity-name=match.model.entityName sk-pk-field=match.model.pkField sk-other-entity-pks=match.model.otherEntityPks sk-description-field=match.model.descriptionField sk-has-image=match.model.hasImage sk-is-favorite=match.model.isFavorite sk-image-field=match.model.imageField sk-resource-id=match.model.resourceID sk-data=match.model.data sk-fields-metadata=match.model.fieldsMetadata></sk-entity-card></div>");
  $templateCache.put("components/input/phoneinput/phoneinput.tpl.html",
    "<input sk-datagrid-pesquisa-editor class=form-control ng-model=codArea ng-disabled=!enabled ng-required=required ng-change=changeHandler() maxlength={{codAreaMaxLength}} size={{codAreaMaxLength}} flex> <input sk-datagrid-pesquisa-editor class=form-control ng-model=prefixo ng-disabled=!enabled ng-required=required ng-change=changeHandler() maxlength={{prefixoMaxLength}} size={{prefixoMaxLength}} flex> <input sk-datagrid-pesquisa-editor class=form-control ng-model=sufixo ng-disabled=!enabled ng-required=required ng-change=changeHandler() maxlength=4 size=4 flex>");
  $templateCache.put("components/input/radio/radioInput.tpl.html",
    "<label class=radio><input type=radio ng-model=value value={{option}} ng-disabled=!enabled ng-change=changeHandler() name={{name}}> <span class=outer><span class=inner></span> </span><span class=radio-label ng-transclude></span></label>");
  $templateCache.put("components/input/richtext/richtext.tpl.html",
    "<div ng-class=\"{'is-disabled': !enabled, 'richtext-hide-buttons' : hideButtons}\" id=\"{{'skRichText-' + editorId}}\"><div ng-if=editorInitialized ng-class=\"{'sk-richtext-editor-wrapper': !height}\" ng-style=\"height ? {'height': height} : {}\"><textarea id={{editorId}} ng-disabled=!enabled ui-tinymce=tinymceOptions ng-model=$parent.value></textarea></div></div>");
  $templateCache.put("components/input/richtext/richtextlink/richtextpopup.tpl.html",
    "<sk-rich-text autofocus ng-keydown=onKeyDown($event) class=sk-rich-text-popup sk-enabled=\"popUpEditEnabled || enabled\" sk-value=value ng-show=isRichText></sk-rich-text>");
  $templateCache.put("components/input/search/searchinput.tpl.html",
    "<div flex layout=row layout-align=\"center center\" class=\"dropdown relative\" dropdown dropdown-append-to-body h-placement=right top-offset=-3 auto-close=outsideClick><input class=form-control ng-keydown=onInputKeyDown($event) ng-blur=onCodeInputFocusOut() placeholder=\"{{placeholder | i18n}}\" title=\"{{inputHelptip | i18n}}\" ng-model=value ng-disabled=\"enabled === false\" flex><div class=search-icon-container><sk-icon ng-show=value ng-click=onCancelSearch() font-icon=remove class=remove sk-i18n tooltip=FlatTree.lblCancelarFiltro></sk-icon><sk-icon font-icon=search class=search ng-click=onClick() tooltip=\"{{searchTooltip | i18n}}\" tooltip-placement={{toolTipPlacement}}></sk-icon><a href=\"\" class=dropdown-toggle tabindex=-1 dropdown-toggle><span class=caret></span></a></div><ul class=\"dropdown-menu search-input-filter-popup\" role=menu layout-padding><sk-hbox ng-repeat=\"option in searchOptions\" gap=5 align=\"center center\" flex><sk-switch sk-value=option.value sk-true-value=true sk-false-value=false sk-change=option.change(option.value)></sk-switch><span ng-bind=option.label flex></span></sk-hbox></ul></div>");
  $templateCache.put("components/input/selectdistinct/popupselectdistinct/popupselectdistinct.tpl.html",
    "<div flex layout=column style=\"height: 100%\"><div layout><sk-text-input autofocus flex sk-value=searchTerm sk-placeholder=\"{{'Geral.buttonPesquisar' | translate}}\" sk-keydown=onKeydown($event)></sk-text-input><sk-icon font-icon=search></sk-icon></div><div flex layout=column class=popup-select-distinct-items-container sk-scroll-container><div ng-repeat=\"item in dataProvider | filter:{label: searchTerm} track by $index\" class=popup-select-distinct-item ng-click=selectItem(item.label)><div class=popup-select-distinct-item-card layout ng-class=\"{'active': item.active === true}\"><div class=filter-nick ng-style=\"{'background-color':textToColor(item.label)}\"><span ng-bind=buildNick(item.label)></span></div><span ng-bind=item.label class=item-label></span></div></div></div></div>");
  $templateCache.put("components/input/selectdistinct/selectdistinctinput.tpl.html",
    "<div sk-disabled=\"enabled === false\" flex layout><sk-text-input sk-enabled=enabled flex sk-dataset=dataset sk-value=value sk-field-name={{fieldName}} sk-size=size sk-change=textInputChangeHandler(value) sk-restrict={{restrict}}></sk-text-input><sk-icon font-icon=search ng-click=openPopUpSelectDistinctField()></sk-icon></div>");
  $templateCache.put("components/input/switch/switch.tpl.html",
    "<div ng-class=\"{'active-label': switchLabel}\"><span class=sk-container ng-click=triggerClickCheckbox($event)><input id=input-checkbox-{{id}} type=checkbox ng-model=viewValue ng-disabled=!enabled ng-change=changeHandler()><label><span class=checked></span> <span class=toggle></span></label></span><span ng-if=switchLabel class=label-text>{{switchLabel}}</span></div>");
  $templateCache.put("components/input/textarea/textarealink/textareapopup.tpl.html",
    "<sk-text-area autofocus ng-keydown=onKeyDown($event) class=sk-text-area-popup sk-enabled=enabled sk-value=value ng-show=!isRichText></sk-text-area><sk-rich-text autofocus ng-keydown=onKeyDown($event) class=sk-text-area-popup sk-enabled=enabled sk-value=value ng-show=isRichText></sk-rich-text>");
  $templateCache.put("components/input/typeahead/templates/typeahead-match.tpl.html",
    "<a tabindex=-1 ng-bind-html=\"match.label | skTypeaheadHighlight:query\"></a>");
  $templateCache.put("components/input/typeahead/templates/typeahead-popup.tpl.html",
    "<ul class=\"dropdown-menu sk-typeahead-input\" ng-show=isOpen() ng-style=\"{top: position.top+'px', left: position.left+'px'}\" style=\"display: block; z-index:10001\" role=listbox aria-hidden={{!isOpen()}}><div class=typeahead-content sk-scroll-container><li ng-repeat=\"match in matches\" ng-class=\"{active: isActive($index) }\" ng-mousedown=mouseDown($event) ng-mouseenter=selectActive($index) ng-click=selectMatch($index) role=option id={{match.id}}><div sk-typeahead-match index=$index match=match query=query template-url=templateUrl></div></li></div><div ng-if=$parent.$parent.showMore ng-mousedown=mouseDown($event) ng-click=onClickShowMore() class=show-more-container><a class=show-more-link>Mostrar mais</a></div></ul>");
  $templateCache.put("components/input/typeselect/typeselect.tpl.html",
    "<div id={{internalDivId}} flex class=\"dropdown dropup\" dropdown auto-close=outsideClick ng-click=adjustDropdownLeft() tooltip={{getGeneralLabel()}} tooltip-append-to-body=true><button type=button ng-disabled=!enabled class=\"form-control dropdown-toggle\" dropdown-toggle><div layout=row><div ng-repeat=\"data in dataProvider | filter:{'value':true}\"><sk-icon font-icon={{data.iconPath}} class=left ng-if=\"::data.iconType == 'glyphicon'\"></sk-icon><sk-icon svg-src={{data.iconPath}} class=left ng-if=\"::data.iconType == 'svg'\"></sk-icon><img src={{data.iconPath}} width={{data.width}} height={{data.height}} class=left ng-if=\"::data.iconType == 'img'\"></div></div></button><ul id={{internaldUlId}} class=\"sk-type-select dropdown-menu\" style=\"width: 100% !important; overflow: hidden !important\" role=menu aria-labelledby=split-button><li ng-repeat=\"data in dataProvider\" role=menuitem layout=row><div ng-click=\"data.value = !data.value; data.changeFn(data.id, data.value);\"><sk-icon font-icon={{data.iconPath}} class=left ng-if=\"::data.iconType == 'glyphicon'\"></sk-icon><sk-icon svg-src={{data.iconPath}} class=left ng-if=\"::data.iconType == 'svg'\"></sk-icon><img src={{data.iconPath}} width={{data.width}} height={{data.height}} class=left ng-if=\"::data.iconType == 'img'\"> <span class=text ng-bind=data.label></span></div><sk-switch style=\"margin-left: auto !important\" sk-value=data.value sk-true-value=true sk-false-value=false sk-change=\"processChange(data.id, data.value, data.changeFn);\"></sk-switch></li></ul></div>");
  $templateCache.put("components/intervalselector/intervalselector.tpl.html",
    "<sk-hbox ng-show=isVisible gap=5 align=\"start start\" flex><sk-vbox gap=5 flex><span><sk-i18n>CronSyntaxSelector.lblTipoIntervalo</sk-i18n>:</span><div class=items-container flex><div ng-repeat=\"item in itens\" ng-class=\"{'selected':item.selected}\" ng-click=setTipoIntervalo(item) ng-bind=item.label layout-padding></div></div></sk-vbox><sk-vbox gap=5 flex><span><sk-i18n>CronSyntaxSelector.lblValor</sk-i18n>:</span><sk-number-input sk-value=intervalValue sk-change=setValorIntervalo(intervalValue)></sk-number-input></sk-vbox></sk-hbox>");
  $templateCache.put("components/ishikawa/ishikawa.tpl.html",
    "<div id=ishikawa-root-{{uniqueId}} class=ishikawa-root><div class=tooltip ng-if=ctrl.showToolTip><span class=tooltiptext ng-bind=ctrl.tooltiptext></span></div><sk-ishikawa-options sk-api=ctrl.optionsPanelApi sk-on-add=onAddNode(node) sk-on-remove=onRemoveNode(node) sk-on-edit=onEditNode(node) sk-on-action-plain=onActionPlain(node)></sk-ishikawa-options><svg id=ishikawa-svg-{{uniqueId}}></svg></div>");
  $templateCache.put("components/ishikawa/optionspanel/ishikawaoptions.tpl.html",
    "<div class=root-container ng-if=isShow ng-style=style><button small default sk-popover popover-template-url=causeEdit.html popover-placement=left show-btn-apply=false show-btn-close=false popover-class=\"popover-ishikawa-edit-cause popover-class\" height=auto padding=5px hide-on-scroll=true controller-name=IshikawaPopoverEdit properties=\"getPopOverOptions('i')\" sk-i18n tooltip=Geral.lblAdicionar ng-if=ctrl.node.hasRoot><sk-icon font-icon=circle-empty-plus v=2></sk-icon></button> <button small default sk-popover popover-template-url=causeEdit.html popover-placement=left show-btn-apply=false show-btn-close=false popover-class=\"popover-ishikawa-edit-cause popover-class\" height=auto hide-on-scroll=false controller-name=IshikawaPopoverEdit properties=\"getPopOverOptions('e')\" sk-i18n tooltip=Geral.lblEditar ng-if=ctrl.node.hasRoot><sk-icon font-icon=pencil v=2></sk-icon></button> <button small default sk-popover popover-template-url=causeEdit.html popover-placement=right show-btn-apply=false show-btn-close=false popover-class=\"popover-ishikawa-edit-cause popover-class\" height=auto padding=5px hide-on-scroll=true controller-name=IshikawaPopoverEdit properties=\"getPopOverOptions('i')\" sk-i18n tooltip=Geral.lblAdicionar ng-if=!ctrl.node.hasRoot><sk-icon font-icon=circle-empty-plus v=2></sk-icon></button> <button small default sk-popover popover-template-url=causeEdit.html popover-placement=right show-btn-apply=false show-btn-close=false popover-class=\"popover-ishikawa-edit-cause popover-class\" height=auto hide-on-scroll=false controller-name=IshikawaPopoverEdit properties=\"getPopOverOptions('e')\" sk-i18n tooltip=Geral.lblEditar ng-if=!ctrl.node.hasRoot><sk-icon font-icon=pencil v=2></sk-icon></button> <button small default ng-click=remove() sk-i18n tooltip=Remover><sk-icon font-icon=circle-empty-minus v=2></sk-icon></button> <button small default ng-click=planoAcao() sk-i18n tooltip=Ishikawa.adicionarPlanoAcao ng-if=!ctrl.node.hasRoot><sk-icon font-icon=notes v=2></sk-icon></button></div><script type=text/ng-template id=causeEdit.html><div class=\"popover-ishikawa-edit-cause\">\n" +
    "        <div class=\"edit-cause-header\" ng-if=\"transientNode.parent\">\n" +
    "            <span sk-i18n>Ishikawa.adicionandoCausa</span>\n" +
    "            <div class=\"dad-cause-container\">\n" +
    "                <span sk-i18n>Ishikawa.causaPai</span>\n" +
    "                <span ng-bind=\"transientNode.parent.name\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <sk-simple-form sk-columns=\"1\" style=\"width: 280px;\">\n" +
    "            <sk-simple-item sk-label=\"Ishikawa.nomeCausa\" sk-required=\"true\">\n" +
    "                <sk-text-input sk-value=\"transientNode.name\" autofocus></sk-text-input>\n" +
    "            </sk-simple-item>\n" +
    "            <sk-simple-item sk-label=\"Ishikawa.observacao\">\n" +
    "                <sk-text-area sk-value=\"transientNode.observacao\"></sk-text-area>\n" +
    "            </sk-simple-item>\n" +
    "        </sk-simple-form>\n" +
    "        <div class=\"btns-container\">\n" +
    "            <button small default ng-click=\"doSave();\" sk-i18n tooltip=\"Producao.ProgramacaoPlanoMestre.hintEnviarParaFrente\" layout-padding>\n" +
    "                <span sk-i18n>Geral.lblSalvar</span>\n" +
    "            </button>\n" +
    "            <button small default ng-click=\"onPopOverClose(); hide();\" layout-padding>\n" +
    "                <span sk-i18n>Geral.lblCancelar</span>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div></script>");
  $templateCache.put("components/linkedlist/linkedlist.tpl.html",
    "<div class=linkedlist><div flex layout=column ng-repeat=\"opt in options\" class=item ng-click=ctrl.onItemClick($event,opt)><div ng-if=\"(!opt.type || opt.type == 'label') && (!opt.child || opt.child.length == 0)\" class=opt style=\"cursor: pointer\"><span ng-bind=opt.label></span></div><div ng-if=\"(opt.child && opt.child.length > 0)\" class=\"item-icon opt\" sk-popover popover-template-url=components/linkedlist/linkedlist.tpl.html popover-placement=left always-load-properties=false create-on-load=false show-btn-apply=false show-btn-close=false show-triangle=true width=auto height=auto popover-class=\"white-popover sk-dropdownmenu-popover\" properties=ctrl.getPopoverProperties(opt) always-load-properties=true hide-on-scroll=true hide-delay=100 padding=5 controller-name=SkLinkedListController controller-as=ctrl popover-listeners=popOverListeners style=\"cursor: pointer\"><sk-icon font-icon=chevron-left></sk-icon><span ng-bind=opt.label></span></div><div ng-if=\"opt.type == 'check' && (!opt.child || opt.child.length == 0)\" class=\"item-radio opt\" style=\"cursor: pointer\"><sk-radio-input sk-value=$parent.ctrl.value sk-option={{opt.data}}></sk-radio-input><span ng-bind=opt.label></span></div></div></div>");
  $templateCache.put("components/listOrder/listOrder.tpl.html",
    "<div flex layout=column class=fill-size><div flex layout=row class=fill-size><div class=fill-size layout=column flex><div class=listOrder-top-bar layout=row layout-align=\"center center\"><sk-search-input ng-if=\"showSearch != false\" flex sk-i18n sk-placeholder=PesquisaContent.searchPlaceholder sk-value=destSearchTerm sk-change=onDestSearchTermChange(destSearchTerm) sk-keydown=onDestSearchKeyDown($event)></sk-search-input><div ng-transclude=destRightContainer></div></div><div class=title-container layout-align=center layout=column ng-if=listTitle ng-bind=listTitle></div><div flex layout=column class=\"fill-size items-container\"><div sk-scroll-container style=\"overflow: auto\"><div class={{typeItem}} ng-class=\"{'item-bg-gray': $odd, 'item-btn-selected': isItemSelected(item, 'btn'), 'item-selected': isItemSelected(item, 'item'), 'handlable': moveToLeft !== false}\" ng-repeat=\"item in listData track by $index\" ng-click=\"selectItem(item, $event)\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"><div layout=row layout-align=\"space-between center\"><div sk-component-transclude=destItemTpl><div ng-bind=item></div></div></div></div></div></div></div><div class=btns-container layout=column layout-align=\"center center\"><button class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('up',true)\" ng-disabled=\"!(hasMoreThanTwoItem() && !isFirstItemSelected() && hasSomeListItemSelected())\"><sk-icon svg-src=/mge/assets/svg/up-all.svg></sk-icon></button> <button class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('up')\" ng-disabled=\"!(hasMoreThanTwoItem() && !isFirstItemSelected() && hasSomeListItemSelected())\"><sk-icon svg-src=/mge/assets/svg/up.svg></sk-icon></button> <button class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('down')\" ng-disabled=\"!(hasMoreThanTwoItem() && !isLastItemSelected() && hasSomeListItemSelected())\"><sk-icon svg-src=/mge/assets/svg/down.svg></sk-icon></button> <button class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('down', true)\" ng-disabled=\"!(hasMoreThanTwoItem() && !isLastItemSelected() && hasSomeListItemSelected())\"><sk-icon svg-src=/mge/assets/svg/down-all.svg></sk-icon></button></div></div></div>");
  $templateCache.put("components/livetimeline/livetimeline.tpl.html",
    "<div class=sk-timeline-container><div id=timeline-container ng-class=\"{'chart-opacity': isOpacity}\"></div></div>");
  $templateCache.put("components/mapbutton/mapbutton.tpl.html",
    "<button class=\"btn btn-default btn-sk-sm\" sk-popover popover-template-url=components/mapbutton/mapbuttoncontent.tpl.html create-on-load=true show-btn-apply=false show-btn-close=false width=auto height=auto popover-class=white-popover tooltip-popup-delay=250 properties=getPopOverProperties() ng-disabled=!enabled><sk-icon font-icon=map></sk-icon><span sk-translate>Geral.buttonMapas</span></button>");
  $templateCache.put("components/mapbutton/mapbuttoncontent.tpl.html",
    "<div class=actions-container layout-wrap layout=row layout-align=\"start start\"><div class=action-item flex layout=column ng-click=abrirMapa(PROCURAR_END_ENTREGA); ng-show=mostraEnderecoDeEntrega><sk-icon svg-src=/mge/assets/svg/location.svg style=\"color: red\"></sk-icon><span class=action-label sk-translate>Controls.PopupButtons.itemEnderecoEntrega</span></div><div class=action-item flex layout=column ng-click=abrirMapa(PROCURAR_END_PARCEIRO); ng-show=mostraEnderecoDoParceiro><sk-icon svg-src=/mge/assets/svg/location.svg style=\"color: blue\"></sk-icon><span class=action-label sk-translate>Controls.PopupButtons.itemEnderecoParceiro</span></div><div class=action-item flex layout=column ng-click=abrirMapa(PROCURAR_ROTA_END_ENTREGA); ng-show=mostraRotaEnderecoDeEntrega><sk-icon svg-src=/mge/assets/svg/transport.svg style=\"color: red\"></sk-icon><span class=action-label sk-translate>Controls.PopupButtons.itemRotaEntrega</span></div><div class=action-item flex layout=column ng-click=abrirMapa(PROCURAR_ROTA_END_PARCEIRO); ng-show=mostraRotaEnderecoDoParceiro><sk-icon svg-src=/mge/assets/svg/transport.svg style=\"color: blue\"></sk-icon><span class=action-label sk-translate>Controls.PopupButtons.itemRotaParceiro</span></div></div>");
  $templateCache.put("components/margemcontribchart/margemcontribchart.tpl.html",
    "<sk-hbox style=\"height: 100%; width: 100%\"><div class=informacoesGrafico ng-if=$ctrl.showInfo style=\"height: 100%; width: 50%\"><div style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelFaturamento</label><span class=boxValor id=infoFat>{{$ctrl.fatToolTip}}</span><label id=precentInfo>{{$ctrl.fatPorcento}}%</label></div><div style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelCustoMercVendido</label><span class=boxValor id=infoCmv>{{$ctrl.cmvToolTip}}</span><label id=precentInfo>{{$ctrl.cmvPorcento}}%</label></div><div style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelGastoVariavel</label><span class=boxValor id=infoGv>{{$ctrl.gvToolTip}}</span><label id=precentInfo>{{$ctrl.gvPorcento}}%</label></div><div style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelMargemContrib</label><span class=boxValor id=infoMc>{{$ctrl.mcToolTip}}</span><label id=precentInfo>{{$ctrl.mcPorcento}}%</label></div><div style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelPartGastoFixo</label><span class=boxValor id=infoGf>{{$ctrl.gfToolTip}}</span><label id=precentInfo>{{$ctrl.gfPorcento}}%</label></div><div ng-if=\"$ctrl.lucro > 0\" style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelLucro</label><span class=boxValor id=infoLucro>{{$ctrl.lucroToolTip}}</span><label id=precentInfo>{{$ctrl.lucroPorcento}}%</label></div><div ng-if=\"$ctrl.lucro <= 0\" style=\"width: 100%\"><label id=labelInfo sk-i18n>ChartRentabilidade.labelPrejuizo</label><span class=boxValor id=infoPrejuizo>{{$ctrl.lucroToolTip}}</span><label id=precentInfo>{{$ctrl.lucroPorcento}}%</label></div></div><div ng-if=$ctrl.showInfo class=verticalLine></div><div class=margemcontribchart style=\"height: 100%; min-width: 46%\"><div ng-if=$ctrl.semInformacoes style=\"width: 100%;height: 100%\"><label id=labelSemInformacoes sk-i18n>ChartRentabilidade.labelSemInformacoes</label></div><div ng-show=!$ctrl.semInformacoes style=\"width: 100%; height: 100%\"><div style=\"width: 100%\" ng-style=\"{'height': $ctrl.height + '%'}\"><div class=margemcontribchart-fatDiv id=fatDiv style=\"height: 100%\" ng-dblclick=\"$ctrl.onDoubleClick($ctrl.labelFaturamento, 'fat')\" sk-i18n tooltip=\"{{$ctrl.labelFaturamento}} {{$ctrl.fatToolTip}}\"><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descFaturamento</div></div></div><div style=\"width: 100%\" id=secondRow ng-style=\"{'height': $ctrl.height + '%'}\"><div ng-show=\"$ctrl.cmv > 0\" id=cmvDiv class=margemcontribchart-cmvDiv style=\"height: 100%\" ng-dblclick=\"$ctrl.onDoubleClick($ctrl.labelCustoMercVendido, 'cmv')\" tooltip=\"{{$ctrl.labelCustoMercVendido}} {{$ctrl.cmvToolTip}}\"><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descCustoMercVendido</div></div><div class=margemcontribchart-gvDiv id=gvDiv style=\"height: 100%;border-right-width:0px\" ng-dblclick=\"$ctrl.onDoubleClick($ctrl.labelGastoVariavel, 'gv')\" tooltip=\"{{$ctrl.labelGastoVariavel}} {{$ctrl.gvToolTip}}\"><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descGastoVariavel</div></div><div class=margemcontribchart-mcDiv id=mcDiv style=\"float: left;height: 100%;border-right-width: 1px\" ng-dblclick=\"$ctrl.onDoubleClick($ctrl.labelMargemContrib, 'mc')\" tooltip=\"{{$ctrl.labelMargemContrib}} {{$ctrl.mcToolTip}}\"><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descMargemContrib</div></div></div><div style=\"width: 100%; margin-top: -1px\" id=thirdRow ng-style=\"{'height': $ctrl.height + '%'}\"><div ng-show=\"$ctrl.lucro > 0\" id=lucroDiv class=margemcontribchart-lucroDiv ng-dblclick=\"$ctrl.onDoubleClick($ctrl.labelLucro, 'resultado')\" style=\"height: 100%\" tooltip=\"{{$ctrl.labelLucro}} {{$ctrl.lucroToolTip}}\"><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descLucro</div></div><div class=margemcontribchart-gfDiv id=gfDiv ng-show=\"$ctrl.gf > 0\" style=\"height: 100%; border-right-width: 0px; border-left-width: 1px\" ng-dblclick=\"$ctrl.onDoubleClick($ctrl.labelPartGastoFixo, 'gf')\" tooltip=\"{{$ctrl.labelPartGastoFixo}} {{$ctrl.gfToolTip}}\" tooltip-placement=left><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descPartGastoFixo</div></div></div><div ng-show=\"$ctrl.lucro < 0\" style=\"width: 100%; margin-top: -1px; height: 25%\"><div class=margemcontribchart-prejuDiv id=prejDiv style=\"width: 11.5339%; height: 100%\" ng-dblclick=$ctrl.onDoubleClick($ctrl.labelPrejuizo) tooltip=\"{{$ctrl.labelPrejuizo}} {{$ctrl.lucroToolTip}}\"><div class=gwt-HTML ng-style=\"{'visibility': $ctrl.calcLabelsChart}\" sk-i18n>ChartRentabilidade.descPrejuizo</div></div></div></div></div></sk-hbox>");
  $templateCache.put("components/maskbuilder/maskbuilder.tpl.html",
    "<div layout=column flex><div layout=column sk-bg-color=gray-lighter layout-padding><h4 ng-if=title ng-bind=$ctrl.title></h4><sk-hbox gap=5><button default ng-click=$ctrl.removeLevel() sk-i18n>MaskBuilder.btnRemoverNivel</button> <button default ng-click=$ctrl.addLevel() sk-i18n>MaskBuilder.bntAdicionarNivel</button><div layout=row ng-transclude flex></div></sk-hbox></div><div layout=row><h4 sk-i18n>MaskBuilder.labelMascara</h4><h4 class=mascara ng-bind=$ctrl.mascara></h4></div><div layout=row flex sk-overflow-y=auto><div layout=column><div ng-repeat=\"nivel in $ctrl.niveis track by $index\" class=repeat-nivel><div layout=row><div class=margin-top sk-i18n>MaskBuilder.labelNivel</div><div class=\"margin-top margin-number\">{{$index + 1}}:</div><sk-icon font-icon=asterisk class=required-nivel></sk-icon></div></div></div><div layout=column><div ng-repeat=\"nivel in $ctrl.niveis track by $index\" class=repeat-nivel><div layout=row><sk-numeric-stepper sk-value=nivel.value sk-change=\"$ctrl.updateMascara(true, nivel)\" sk-min-value=1 sk-required=true sk-value-options=$ctrl.skModelOptions></sk-numeric-stepper></div></div></div></div></div>");
  $templateCache.put("components/multilist/multilist.tpl.html",
    "<div class=\"btn btn-default dropdown-toggle\" sk-disabled=\"enabled == false\" layout=row layout-align=\"space-between center\"><div class=dropdown-text flex sk-translate>Geral.lblSelecione</div><div class=dropdown-count></div><div class=caret></div><div class=loading><span sk-translate>Geral.lblCarregando</span><sk-icon svg-src=/mge/assets/svg/loading.svg class=spin></sk-icon></div></div>");
  $templateCache.put("components/multilist/popup.tpl.html",
    "<div class=tab layout=row flex><div class=tab-item ng-class=\"{'selected': selectedTab === 0}\" ng-click=onSelectedTab(0) sk-translate>Geral.lblAll</div><div class=\"tab-item tab-count\" ng-class=\"{'selected': selectedTab === 1}\" ng-click=onSelectedTab(1) flex></div></div><div class=tab-container><div class=\"sk-header gray-container\" layout=row flex><sk-checkbox ng-model=selectAll ng-click=clickSelectAll() accept-indeterminate=true ng-disabled=isEmpty></sk-checkbox><sk-search-input class=search-input sk-value=filterText sk-debounce=300 sk-placeholder=\"{{ ::labelPesquisar }}\" sk-focus=onSearchFocus() sk-change=onChangeSearch() flex></sk-search-input></div><div class=sk-list><div class=empty ng-if=isEmpty>{{ getEmptyLoadingMsg() }}</div><md-virtual-repeat-container ng-show=!isEmpty><div class=\"table-row disable-text-selection\" md-virtual-repeat=\"option in infiniteItems\" md-on-demand=true ng-click=\"onSelect($event, option)\" ng-class=\"{'active': option.selected, 'focus': (inFocus == option)}\" layout=row layout-align=\"start center\" flex><div class=table-cell><sk-checkbox ng-model=option.selected ng-focus=markFocus(option) ng-change=onChange(option)></sk-checkbox></div><div class=\"table-cell cell-right table-cell-value\" ng-style=::columnWidthStyle ng-show=!isDistinct>{{ option.value }}</div><div class=\"table-cell cell-text\" flex>{{ option.description }}</div></div></md-virtual-repeat-container></div><span class=loading-panel sk-translate>Geral.lblLoadingMore</span></div>");
  $templateCache.put("components/navigator/navigator.tpl.html",
    "<div class=record-navigator><div id=fieldSearchDiv class=field-search-div auto-close=outsideClick ng-show=fieldSearchOpen sk-focus-on-show=fieldSearchOpen><div class=field-search-div-bg flex><sk-typeahead-input id=fieldSearchInput class=\"fieldSearchField-{{uid}} display-inline-block\" sk-clear-after-select=true sk-placeholder=\"{{'Dynaform.search.fields' | translate}}\" sk-get-options=loadFieldSuggestions sk-key=label sk-label=label sk-on-select=pesqFieldSelect sk-show-more=false sk-append-to-body=true sk-template-url=fieldsSearch.html sk-external-action=true></sk-typeahead-input><button ng-click=\"fieldSearchOpen = false\" class=field-search-div-close-btn>x</button></div></div><div class=\"btn-group no-margin-left\" ng-if=\"isShowAddButton() && !(showCrud === false)\"><sk-btn-novo sk-entity-description={{getEntityDescription()}} sk-on-click=newRecord()></sk-btn-novo></div><div class=btn-group ng-if=\"(isShowSaveButton() || isShowCancelButton()) && !(showCrud === false)\"><button class=\"btn btn-default\" ng-if=isShowSaveButton() ng-disabled=\"isView() || !btnSaveEnabled\" ng-click=save() tooltip={{::tooltipSalvar}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=ok-2 sk-enabled=\"!(isView() || !btnSaveEnabled)\"></sk-icon></button> <button class=\"btn btn-default\" ng-if=isShowCancelButton() ng-click=onClickCancel() ng-disabled=\"isView() || !btnCancelEnabled\" tooltip={{::tooltipDescartar}} tooltip-placement=bottom tooltip-append-to-body=true sk-popover popover-id={{::editionAlertPopOverId}} popover-template-url=popoverEditionAlert.html popover-placement=right show-btn-apply=false show-btn-close=false popover-class=\"white-popover navigator-edit-alert-popover\" height=auto width=auto show-on=none hide-on-scroll=true><sk-icon ng-show=showAlertIcon class=icon-alert font-icon=alert></sk-icon>{{::lblDescartar}}</button></div><div class=\"btn-group nav-group btn-control\" ng-if=\"isShowPreviousButton() || isShowNextButton()\"><button class=\"btn btn-default\" ng-if=isShowFirstButton() ng-disabled=!btnFirstEnabled ng-click=first() tooltip={{::tooltipPrimeiro}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=dual-chevron-left v=ez></sk-icon></button> <button class=\"btn btn-default\" ng-if=isShowPreviousButton() ng-disabled=!btnPrevEnabled ng-click=previous() tooltip={{::tooltipAnterior}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=chevron-left v=ez></sk-icon></button> <button class=\"btn btn-default\" ng-if=isShowNextButton() ng-disabled=!btnNextEnabled ng-click=next() tooltip={{::tooltipProximo}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=chevron-right v=ez></sk-icon></button> <button class=\"btn btn-default\" ng-if=isShowLastButton() ng-disabled=!btnLastEnabled ng-click=last() tooltip={{::tooltipUltimo}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=dual-chevron-right v=ez></sk-icon></button></div><sk-hbox gap=4 layout-align=\"start center\" ng-if=\"!isView() && !btnSaveVisible && !editUniqueRecord && !(showCrud === false) && (!(showRemoveButton === false) || !(showCopyButton === false) || !(showCopyButton === false) || showDeepCopyMenu || btnEditEnabled)\"><button class=\"btn btn-sk-sm btn-default btn-remove\" ng-if=\"!(showRemoveButton === false)\" ng-disabled=!btnRemoveEnabled ng-click=remove() tooltip={{::tooltipExcluir}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=bin></sk-icon></button><div class=\"btn-group btn-change-face-group dropdown\" dropdown dropdown-append-to-body ng-if=\"!(showCopyButton === false)\"><button class=\"btn btn-default btn-sk-sm btn-change-face\" ng-click=clone() tooltip={{::tooltipDuplicar}} tooltip-placement=bottom tooltip-append-to-body=true ng-disabled=!btnCloneEnabled><sk-icon font-icon=duplicate></sk-icon></button> <button type=button class=\"btn btn-default dropdown-toggle\" ng-if=showDeepCopyMenu dropdown-toggle ng-disabled=!btnCloneEnabled><span class=caret></span></button><ul class=dropdown-menu role=menu aria-labelledby=split-button><li role=menuitem ng-click=showDeepCopyPopUp()><a sk-translate>DeepCopy.lblConfigurarCopia</a></li></ul></div><button class=\"btn btn-sk-sm btn-default\" ng-if=btnEditEnabled ng-click=edit() tooltip={{::tooltipEditar}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=edit></sk-icon></button> <button class=\"btn btn-sk-sm btn-default\" ng-if=\"(showEditarButton === true)\" ng-disabled=!btnEditarEnabled ng-click=editRecord() tooltip=Editar tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=edit></sk-icon></button></sk-hbox><div class=btn-group ng-if=\"btnRefreshEnabled && !editUniqueRecord && !(showRefreshButton === false) && !(showCrud === false)\" sk-margin-left=4px><button class=\"btn btn-sk-sm btn-default btn-refresh\" ng-click=refresh() tooltip={{::tooltipAtualizar}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=refresh></sk-icon></button></div></div><script type=text/ng-template id=popoverEditionAlert.html><div>\n" +
    "        <span class=\"text\" sk-translate>Navigator.lblEditandoRegistro</span>\n" +
    "        <button class=\"close\" ng-click=\"hide()\">\n" +
    "            <sk-icon svg-src=\"cancel.svg\"></sk-icon>\n" +
    "        </button>\n" +
    "    </div></script><script type=text/ng-template id=fieldsSearch.html><div class=\"field-search-match\">\n" +
    "        <span class=\"field-search-match-name\" ng-bind=\"match.model.description\"/>\n" +
    "        <span class=\"field-search-match-path\" ng-bind=\"match.model.tabName\"/>\n" +
    "    </div></script>");
  $templateCache.put("components/personalizedfilter/templates/field-selection-popup.tpl.html",
    "<div layout=column flex><div class=\"row sub-header\"><ul class=breadcrumbs><li ng-repeat=\"entity in entityPath | limitTo: entityPath.length - 1\"><a ng-href=# ng-click=\"changeEntityByPath(entity.name, $index)\" ng-bind=entity.description></a></li><li><a href=javascript:void(0) class=active ng-bind=currentEntity.description ng-click=\"currentView = 'list'\"></a></li></ul></div><div class=search-group><input placeholder=\"{{ 'FiltroPersonalizado.lblInformeBusca' | translate }}\" ng-model=searchValue><sk-icon font-icon=search class=btn-search ng-class=\"{active: activeBtnSearch}\" ng-click=applySearch()></sk-icon></div><div class=field-selection ng-show=\"currentView == 'list'\" layout=column flex><div><div class=title-field ng-bind=\"'Campos de ' + entityDescrption\"></div></div><div class=row flex><div class=col-xs-4 ng-repeat=\"field in fieldsList  = (fields | filter:{description: searchValue})\" style=\"margin-bottom: 5px\"><div class=select-field ng-click=selectField(field) tooltip=\"{{field.description + ' [' + field.tableName + '.' + field.name + ']'}}\" tooltip-append-to-body=true><sk-icon font-icon=\"{{ getIconField(field) }}\" ng-if=!showIconSvg(field)></sk-icon><sk-icon svg-src=\"{{ getIconField(field) }}\" ng-if=showIconSvg(field)></sk-icon><span>{{field.description}}</span></div></div><div class=\"col-xs-12 no-record\" ng-show=!fieldsList.length sk-translate>FiltroPersonalizado.msgNenhumCampo</div></div><div><div class=title-entity ng-bind=\"'Ligações em ' + entityDescrption\"></div></div><div class=row flex><div class=col-xs-4 ng-repeat=\"entity in entities\" style=\"margin-bottom: 5px\"><div ng-click=loadEntityFields(entity.name) class=select-entity tooltip={{entity.description}} tooltip-append-to-body=true><sk-icon font-icon=table></sk-icon><span>{{entity.description}}</span></div></div><div class=\"col-xs-12 no-record\" ng-show=!entities.length sk-translate>FiltroPersonalizado.msgNenhumaLigacao</div></div></div><div class=field-search ng-show=\"currentView == 'search'\" layout=column flex><div><div class=title-field sk-translate>FiltroPersonalizado.lblResultadoPesquisa</div></div><div class=search-results flex><div class=col-xs-4 ng-repeat=\"fieldResult in searchResults\"><div class=select-field ng-click=selectField(fieldResult) tooltip=\"{{fieldResult.description + ' (' + fieldResult.name + ')'}}\" tooltip-append-to-body=true><sk-icon font-icon=\"{{ getIconField(fieldResult) }}\" ng-if=!showIconSvg(fieldResult)></sk-icon><sk-icon svg-src=\"{{ getIconField(fieldResult) }}\" ng-if=showIconSvg(fieldResult)></sk-icon><span>{{fieldResult.description}}</span></div></div><div class=search-loading ng-show=showLoading><sk-icon font-icon=refresh sk-class=spin></sk-icon><span sk-translate>Geral.lblCarregando</span></div></div></div></div>");
  $templateCache.put("components/personalizedfilter/templates/filter-assistent.tpl.html",
    "<div class=row ng-show=showError><div class=\"col-xs-12 no-padding\"><alert type=danger ng-bind=msgAlertError></alert></div></div><div class=row layout=row layout-align=\"start end\"><div class=\"col-xs-6 col-sm-3 no-padding\" ng-if=\"filter.standard != true\"><sk-text-input id=pers-filter-nome-filtro sk-value=transientFilter.filterModel.name sk-required=::ctrl.required sk-placeholder=\"{{ ::'FiltroPersonalizado.nomeFiltro' | translate }}\" ng-if=\"!standaloneMode && ignoreNameFilter != true\"></sk-text-input><sk-text-input sk-value=standaloneName sk-placeholder=\"{{ ::'FiltroPersonalizado.lblFiltroPadrao' | translate }}\" sk-enabled=!standaloneMode ng-if=\"(standaloneMode || ignoreNameFilter)\"></sk-text-input></div><div class=toggle-edit-mode layout=row layout-align=\"center center\"><sk-icon font-icon=circle-question-mark sk-visible=!ctrl.goToAssistentMode() tooltip-placement=right tooltip=\"{{ msgNotAcceptAssistentMode }}\" tooltip-append-to-body=true></sk-icon><button id=pers-filter-btn-modo-avancado ng-click=ctrl.toggleEditMode(filter) ng-if=\"ctrl.goToAssistentMode() && filter.mode == 'edit'\" class=\"btn btn-default\"><sk-icon font-icon=settings></sk-icon><span sk-translate>FiltroPersonalizado.alterarModoAvancado</span></button> <button id=pers-filter-btn-preview ng-click=ctrl.previewAssistent(filter) ng-if=\"!ctrl.isPreviewMode && filter.mode == 'edit'\" class=\"btn btn-default\"><sk-icon font-icon=eye-open></sk-icon><span sk-translate>FiltroPersonalizado.previewExpresssao</span></button> <button ng-click=ctrl.toggleEditMode(filter) ng-if=\"ctrl.goToAssistentMode() && filter.mode == 'nerdEdit'\" class=\"btn btn-default btn-fixed-size\"><sk-icon font-icon=magic></sk-icon><span sk-translate>FiltroPersonalizado.alterarModoAssistente</span></button> <button ng-click=ctrl.cancelNerdEdition(filter) ng-if=\"filter.mode == 'nerdEdit' && transientFilter.assistentBackup\" class=\"btn btn-default btn-fixed-size\" tooltip-placement=top tooltip=\"{{ ::tooltipCancelarEdicao }}\" tooltip-append-to-body=true><sk-icon font-icon=remove-2></sk-icon><span sk-translate>FiltroPersonalizado.cancelarEdicao</span></button><sk-btn-novo sk-on-click=ctrl.openFieldSelectorNerdEdit(transientFilter) ng-if=\"!ctrl.isPreviewMode && filter.mode == 'nerdEdit'\" sk-entity-description=\"{{::'Geral.lblCampo' | translate}}\"></sk-btn-novo></div><div class=clearfix></div></div><div class=row><div class=\"col-xs-12 no-padding\"><div ng-if=\"filter.mode == 'edit'\" ng-repeat=\"element in transientFilter.filterModel.assistent.element\" ng-switch=element.elementType><div ng-switch-when=F class=\"filter-assistent-container expression\" layout=row layout-align=\"start center\" flex><div class=\"block-item block-parentheses\"><span ng-repeat=\"i in ctrl.buildArray(element.parentheses.open) track by $index\">(</span></div><div class=\"block-item block-path\"><sk-text-input id=pers-filter-field-name sk-value=element.description tooltip={{element.description}} tooltip-append-to-body=true sk-required=ctrl.required sk-enabled=ctrl.enabled ng-click=ctrl.openFieldSelectorFromAssistent(element) sk-placeholder=\"Selecione o campo\"></sk-text-input></div><div class=\"block-item block-operator\"><sk-combobox id=pers-filter-operator sk-value=element.operand sk-options=ctrl.operatorOptions sk-opt-label=label sk-opt-key=key sk-required=ctrl.required></sk-combobox></div><div id=pers-filter-field-value class=\"block-item block-field\" flex tooltip={{element.value}} tooltip-append-to-body=true><sk-number-input sk-change=ctrl.onChangeFieldValue() sk-value=element.value sk-required=ctrl.isRequired(element) ng-if=ctrl.isNumberField(element) sk-enabled=\"!element.variable && !ctrl.isEmptyOperand(element.operand)\" class=filter-assistent-max-width-200></sk-number-input><sk-combobox sk-change=ctrl.onChangeFieldValue() sk-value=element.value sk-options=element.options.option sk-opt-label=description sk-opt-key=value sk-required=ctrl.isRequired(element) ng-if=ctrl.isComboField(element) sk-enabled=\"!element.variable && !ctrl.isEmptyOperand(element.operand)\" class=filter-assistent-max-width-200></sk-combobox><sk-date-input sk-change=ctrl.onChangeFieldValue() sk-value=element.value sk-required=ctrl.isRequired(element) ng-if=ctrl.isDateField(element) sk-enabled=\"!element.variable && !ctrl.isEmptyOperand(element.operand)\" class=filter-assistent-max-width-200></sk-date-input><sk-time-input sk-change=ctrl.onChangeFieldValue() sk-value=element.value sk-required=ctrl.isRequired(element) ng-if=ctrl.isTimeField(element) sk-enabled=\"!element.variable && !ctrl.isEmptyOperand(element.operand)\" class=filter-assistent-max-width-200></sk-time-input><sk-pesquisa-input sk-change=ctrl.onChangeFieldValue() sk-value=element.value sk-entity-name=\"{{ element.targetEntityName }}\" sk-required=ctrl.isRequired(element) ng-if=ctrl.isSearchField(element) sk-data-type=element.type sk-enabled=\"!element.variable && !ctrl.isEmptyOperand(element.operand)\" class=filter-assistent-max-width-200></sk-pesquisa-input><sk-text-input sk-change=ctrl.onChangeFieldValue() sk-value=element.value sk-required=ctrl.isRequired(element) ng-if=ctrl.isDefaultField(element) sk-enabled=\"!element.variable && !ctrl.isEmptyOperand(element.operand)\" class=filter-assistent-max-width-200></sk-text-input></div><div class=\"block-item block-parentheses\"><span ng-repeat=\"i in ctrl.buildArray(element.parentheses.close) track by $index\">)</span></div><div class=block-item ng-if=\"!standaloneMode && !ctrl.isEmptyOperand(element.operand) && allowVariable\"><sk-checkbox ng-disabled=transientFilter.standard id=pers-filter-cbx-variavel ng-model=element.variable ng-change=ctrl.onChangeValue(element) tooltip=\"{{ transientFilter.standard ? 'Filtro padrão não pode ser variavél.' : '' }}\"><span sk-translate=FiltroPersonalizado.variavel></span></sk-checkbox></div><div class=\"block-item block-var-config\" ng-click=ctrl.openVariableParameterConfig(element) sk-visible=\"element.variable && !standaloneMode && !ctrl.isEmptyOperand(element.operand)\" tooltip-placement=top tooltip=\"{{ ::tooltipConfigVariableParam }}\" tooltip-append-to-body=true><sk-icon font-icon=cogwheel></sk-icon></div><button id=pers-filter-btn-remove-filter type=button class=\"close close-filter-assistent\" aria-label=Close ng-click=ctrl.removeFilter(element) ng-show=\"transientFilter.filterModel.assistent.element.length > 0\"><span aria-hidden=true>&times;</span></button> <button id=pers-filter-btn-add-paranthesis class=\"btn btn-default btn-sm\" sk-popover popover-template-url=addRemoveParentesesPopover.html show-triangle=false properties=\"{parameter: element, onChangeParentheses: ctrl.onChangeParentheses}\" create-on-load=false show-btn-apply=false show-btn-close=false width=auto height=auto popover-class=white-popover tooltip=\"{{ ::tooltipBtnAddRemoveParentheses }}\"><sk-icon svg-src=/mge/assets/svg/parentheses-add-remove.svg class=parentheses-add-remove-icon></sk-icon></button><div class=clearfix></div></div><div ng-switch-when=O class=filter-assistent-operand><div class=filter-assistent-operand-container><sk-combobox sk-value=element.operand sk-options=ctrl.conjunctionOptions sk-opt-label=label sk-opt-key=key sk-required=ctrl.required></sk-combobox></div></div></div><div ng-show=\"filter.mode == 'edit'\" class=filter-new-condition><div class=operand-container ng-show=\"transientFilter.filterModel.assistent != undefined && transientFilter.filterModel.assistent.element != undefined && (transientFilter.filterModel.assistent.element.length > 0)\"></div><div class=filter-assistent-container><sk-btn-novo id=pers-filter-add-condition sk-on-click=ctrl.addNewFilter() sk-entity-description=\"{{::'FiltroPersonalizado.condicao' | translate}}\"></sk-btn-novo></div></div><div class=\"filter-assistent-container filter-assistent-sql\" ng-if=\"filter.mode == 'nerdEdit'\"><textarea ng-model=transientFilter.filterModel.expression.$ ng-change=ctrl.changeExpression({{transientFilter.filterModel.expression}}) required class=\"form-control expression-text-area\" placeholder=\"{{ ::'FiltroPersonalizado.expressaoSql' | translate }}\" ng-disabled=ctrl.isPreviewMode rows=6>\n" +
    "            </textarea></div></div></div><script type=text/ng-template id=addRemoveParentesesPopover.html><div class=\"add-remove-parentheses-container\">\n" +
    "        <sk-numeric-stepper sk-value=\"parameter.parentheses.open\" sk-change=\"onChangeParentheses()\"  sk-sufix-char=\" x (\" sk-min-value=\"0\" sk-size=\"3\">\n" +
    "        </sk-numeric-stepper>\n" +
    "        <sk-numeric-stepper sk-value=\"parameter.parentheses.close\" sk-change=\"onChangeParentheses()\" sk-prefix-char=\") x\" sk-min-value=\"0\" sk-size=\"3\">\n" +
    "        </sk-numeric-stepper>\n" +
    "    </div></script>");
  $templateCache.put("components/personalizedfilter/templates/personalized-filter-expanded.tpl.html",
    "<div layout=column flex class=personalized-filter-expanded><div layout=row layout-align=\"space-between center\"><sk-btn-novo sk-entity-description=\"{{::'FiltroPersonalizado.filtro' | translate}}\" sk-on-click=openFilterNew() ng-hide=hideFilter></sk-btn-novo><button ng-click=applyFilter(); primary block ng-if=hideFilter sk-margin-left=0px tooltip=\"{{::tooltipApply | translate}}\" tooltip-placement=right>{{::finalBtnApplyLabel}}</button> <button ng-click=applyFilter(); primary block ng-if=!hideFilter sk-margin-left=5px tooltip=\"{{::tooltipApply | translate}}\" tooltip-placement=right>{{::finalBtnApplyLabel}}</button></div><div class=filters ng-hide=\"hideFilter || compactMode\"><ul class=\"personalized-filter-fast-list expanded\"><div layout=row layout-align=\"start center\" class=header><sk-switch sk-value=filtersActive sk-true-value=true sk-false-value=false sk-change=onToggleAllFilters()></sk-switch><span class=title ng-click=openFilter() sk-i18n>FiltroPersonalizado.lblPersonalizedFilter</span><div layout=row layout-align=\"end center\" flex><span class=count-filters ng-bind=countActiveFilters() ng-click=toggleList()></span><sk-icon class=icon-expand font-icon=\"{{showList ? 'chevron-up' : 'chevron-down' }}\" v=2 ng-click=toggleList() tooltip=\"{{ showList ? 'Esconder Filtros' : 'Apresentar Filtros' }}\" tooltip-placement=right></sk-icon></div></div><div class=personalized-filter-fast-list-container sk-scroll-container sk-disabled=!filtersActive ng-if=showList><div class=filter-popup-item ng-repeat=\"filter in filterInfos\" ng-if=\"!filter.standard && ((valSegFiltro && filter.filterModel.authorizationStatus === 'L') || !valSegFiltro)\"><sk-switch sk-value=filter.filterModel.active sk-true-value=true sk-false-value=false sk-change=ctrl.setSelected(filter) sk-wide=true></sk-switch><sk-icon font-icon=pencil ng-click=openFilterEdit(filter); tooltip=\"{{::'Geral.lblEditar' | translate }}\" tooltip-append-to-body=true></sk-icon><span class=title ng-bind=filter.filterModel.name tooltip={{filter.filterModel.expression.$}} tooltip-append-to-body=true></span></div></div><div ng-if=\"(!filterInfos || filterInfos.length <= 0) && showList\" class=no-filters-container layout=column layout-align=\"space-around center\"><span class=no-filter-text sk-translate>FiltroPersonalizado.nenhumFiltro</span></div></ul></div></div>");
  $templateCache.put("components/personalizedfilter/templates/personalized-filter-inpopupmode.tpl.html",
    "<div class=\"btn-group dropdown btn-filter-start-page\" dropdown dropdown-append-to-body auto-close=outsideClick is-open=states.isDropdownOpen><button type=button ng-disabled=configDisabled ng-click=openFilter() class=\"btn btn-filter btn-sk-sm\" tooltip={{::tooltipFiltroPersonalizado}} tooltip-placement=bottom tooltip-append-to-body=true ng-class=getButtonColor()><sk-icon font-icon=filter></sk-icon></button> <button type=button ng-if=\"!(showDropdownFilter === false)\" class=\"btn dropdown-toggle\" ng-class=getButtonColor() dropdown-toggle><span class=caret></span></button><ul class=\"dropdown-menu personalized-filter-fast-list\" role=menu aria-labelledby=split-button style=\"z-index: 10000\"><div class=personalized-filter-fast-list-container sk-scroll-container><div class=filter-popup-item ng-repeat=\"filter in filterInfos\" ng-if=!filter.standard><sk-switch sk-value=filter.filterModel.active sk-true-value=true sk-false-value=false sk-change=ctrl.setSelected(filter) sk-wide=true></sk-switch><sk-icon font-icon=pencil ng-click=openFilterEdit(filter); tooltip=\"{{::'Geral.lblEditar' | translate }}\" tooltip-append-to-body=true></sk-icon><span class=title ng-bind=filter.filterModel.name tooltip={{filter.filterModel.expression.$}} tooltip-append-to-body=true></span></div></div><div ng-if=\"filterInfos.length > 0\" class=\"bottom-buttons btn-group\" layout=row layout-align=\"space-around center\"><button class=\"btn btn-default\" ng-click=deselectAllFilters() sk-translate flex>Geral.lblDesativarTodos</button> <button ng-click=applyFilter(); primary block sk-margin-left=5px tooltip=\"{{::tooltipApply | translate}}\" tooltip-placement=right>{{::finalBtnApplyLabel}}</button></div><div ng-if=\"filterInfos.length <= 0\" class=no-filters-container layout=column layout-align=\"space-around center\"><span class=no-filter-text sk-translate>FiltroPersonalizado.nenhumFiltro</span><sk-btn-novo sk-entity-description=\"{{::'FiltroPersonalizado.filtro' | translate}}\" sk-on-click=openFilterNew()></sk-btn-novo></div></ul></div>");
  $templateCache.put("components/personalizedfilter/templates/personalized-filter-popover.tpl.html",
    "<div class=hide ng-if=showTour ng-joy-ride=tour.startTour options=tour.options config=tour.tourConfig on-finish=tour.onFinish() on-skip=tour.onFinish()></div><div class=header layout=row layout-align=\"space-between center\" layout-padding><div layout=row layout-align=\"start center\"><sk-icon ng-click=ctrl.cancel() svg-src=tabs-arrow.svg class=return></sk-icon><h3 sk-translate>FiltroPersonalizado.titulo</h3></div><div class=buttons-group layout=row layout-align=\"end center\"><button type=button class=\"btn btn-default\" ng-disabled=currentEditFilter ng-click=ctrl.startTour()><sk-icon font-icon=train></sk-icon><span sk-i18n>EntityStartPage.sideMenu.lblIniciarTour</span></button> <button type=button class=\"btn btn-default\" ng-click=ctrl.cancel() sk-translate>Geral.lblCancelar</button> <button type=button class=\"btn btn-primary\" ng-click=ctrl.applyFilter() sk-translate ng-if=!hideApply>Geral.lblAplicar</button></div></div><div class=personalized-filter-scroll-panel><div class=personalized-filter layout-padding flex><div class=default-menu ng-hide=transientFilter><sk-btn-novo id=btn-novo-pers-filter sk-on-click=ctrl.newFilter() sk-entity-description=\"{{::'FiltroPersonalizado.filtro' | translate}}\"></sk-btn-novo><button id=btn-default-filter class=\"btn btn-default btn-sk-sm btn-default-filter\" ng-click=openFilterDefault() ng-if=isSup font-icon=filter sk-i18n tooltip=\"{{ getDefaultFilterToolTip() }}\" tooltip-placement=right>FiltroPersonalizado.lblFiltroPadrao</button></div><div class=filter-container><div class=filter-panel-container ng-repeat=\"filterInfo in filterInfos\" ng-show=\" !filterInfo.standard || isSup\" ng-class=\"{'col-lg-4 col-sm-6 col-xs-12': !ctrl.isEditingFilter(filterInfo) , 'col-xs-12': ctrl.isEditingFilter(filterInfo)}\"><div class=filter-panel ng-show=ctrl.isEditingFilter(filterInfo)><div class=filter-heading><div ng-show=!transientFilter.newItem layout=row class=filter-card-top layout-align=\"start center\"><span class=\"filter-card filter-nick\" ng-bind=ctrl.buildFilterNick(ctrl.getFilterName(filterInfo)) ng-style=\"{'background-color': ctrl.textToColor(ctrl.getFilterName(filterInfo))}\"></span><h4 class=title ng-bind=ctrl.getFilterName(filterInfo) tooltip={{filterInfo.filterModel.expression.$}} tooltip-append-to-body=true></div><div class=btn-group role=group><button type=button class=\"btn btn-default btn-save\" ng-click=\"ctrl.confirmEdition(filterInfo.filterModel.id, filterInfo)\"><sk-icon font-icon=ok-2></sk-icon></button> <button type=button class=\"btn btn-default\" ng-click=ctrl.cancelEdition(filterInfo) sk-translate>Geral.lblDescartar</button></div></div><div class=filter-body><form name=forms[filterInfo.filterModel.id] novalidate><div class=row><div class=\"col-xs-12 no-padding\"><alert type=danger ng-bind=msgAlertError ng-show=showError></alert><filter-assistent id=pers-filter-filter-assistent form=forms[filterInfo.filterModel.id] filter=filterInfo transient-filter=transientFilter entity-name={{entityName}} resource-id={{resourceId}} allow-variable=allowVariable link-filter-function=linkFilterFunction field-filter-function=fieldFilterFunction parameter-popup-on-body=parameterPopupOnBody></filter-assistent></div></div></form></div></div><div class=filter-item ng-show=!ctrl.isEditingFilter(filterInfo) ng-dblclick=ctrl.beginEdition(filterInfo) ng-class=\"{ 'filter-default' : filterInfo.standard, fiters: !filterInfo.standard}\" layout=column flex><div layout=row layout-align=\"start center\"><span class=filter-card ng-bind=ctrl.buildFilterNick(ctrl.getFilterName(filterInfo)) ng-style=\"{'background-color': ctrl.textToColor(ctrl.getFilterName(filterInfo))}\"></span><h4 class=title ng-bind=ctrl.getFilterName(filterInfo) tooltip={{filterInfo.filterModel.expression.$}} tooltip-append-to-body=true></div><div class=filter-actions layout=row layout-align=\"space-between center\" flex><div class=left ng-if=\"filterInfo.filterModel.authorizationStatus !== 'P' && filterInfo.filterModel.authorizationStatus !== 'N'\"><sk-switch ng-if=!filterInfo.standard sk-value=filterInfo.filterModel.active sk-true-value=true sk-false-value=false sk-change=ctrl.setSelected(filterInfo) sk-wide=true></sk-switch><sk-switch ng-if=filterInfo.standard sk-value=true sk-true-value=true sk-false-value=false sk-wide=true sk-enabled=false tooltip=\"O filtro padrão não pode ser desativado. Utilize a função excluir.\" tooltip-placement=right></sk-switch></div><div class=left ng-if=\"filterInfo.filterModel.authorizationStatus === 'P'\"><span ng-style=\"{ 'font-size': '14px', 'color': '#626D7C', 'font-style': 'italic'}\" sk-translate>FiltroPersonalizado.lblPendente</span></div><div class=left ng-if=\"filterInfo.filterModel.authorizationStatus === 'N'\"><span ng-style=\"{ 'font-size': '16px', 'color': '#FF6565', 'font-style': 'italic', 'font-weight': 'bold'}\" sk-translate>FiltroPersonalizado.lblReprovado</span></div><div class=right ng-if=\"filterInfo.filterModel.authorizationStatus !== 'P'\"><button class=\"btn btn-default btn-sk-sm\" ng-click=ctrl.beginEdition(filterInfo) tooltip=\"{{ 'Geral.lblEditar' | translate }}\" tooltip-append-to-body=true><sk-icon font-icon=pencil></sk-icon></button> <button class=\"btn btn-default btn-sk-sm\" ng-click=ctrl.confirmDelete(filterInfo) tooltip=\"{{ 'Geral.lblExcluir' | translate }}\" tooltip-append-to-body=true><sk-icon font-icon=bin></sk-icon></button></div></div></div></div><div class=clearfix></div></div><p ng-if=\"filterInfos.length === 0\" sk-translate>FiltroPersonalizado.msgSemFiltros</p></div></div>");
  $templateCache.put("components/personalizedfilter/templates/personalized-filter.tpl.html",
    "<div class=\"btn-group dropdown btn-filter-start-page\" dropdown dropdown-append-to-body auto-close=outsideClick is-open=states.isDropdownOpen><button type=button ng-disabled=configDisabled ng-click=openFilter() class=\"btn btn-filter btn-sk-sm\" tooltip={{::tooltipFiltroPersonalizado}} tooltip-placement=bottom tooltip-append-to-body=true ng-class=getButtonColor()><sk-icon font-icon=filter></sk-icon></button> <button type=button ng-if=\"!(showDropdownFilter === false)\" class=\"btn dropdown-toggle\" ng-class=getButtonColor() dropdown-toggle><span class=caret></span></button><ul class=\"dropdown-menu personalized-filter-fast-list\" role=menu aria-labelledby=split-button style=\"z-index: 10000\"><div class=personalized-filter-fast-list-container sk-scroll-container><div class=filter-popup-item ng-repeat=\"filter in filterInfos\" ng-if=!filter.standard><sk-switch sk-value=filter.filterModel.active sk-true-value=true sk-false-value=false sk-change=ctrl.setSelected(filter) sk-wide=true></sk-switch><sk-icon font-icon=pencil ng-click=openFilterEdit(filter); tooltip=\"{{::'Geral.lblEditar' | translate }}\" tooltip-append-to-body=true></sk-icon><span class=title ng-bind=filter.filterModel.name tooltip={{filter.filterModel.expression.$}} tooltip-append-to-body=true></span></div></div><div ng-if=\"filterInfos.length > 0\" class=bottom-buttons layout=row layout-align=\"space-around center\"><button class=\"btn btn-default\" ng-click=deselectAllFilters() sk-translate flex>Geral.lblDesativarTodos</button> <button class=\"btn btn-primary\" ng-click=applyFilter(); sk-translate ng-if=!hideApply tooltip=\"{{::tooltipApply | translate}}\" tooltip-placement=right>Geral.lblAplicar</button></div><div ng-if=\"filterInfos.length <= 0\" class=no-filters-container layout=column layout-align=\"space-around center\"><span class=no-filter-text sk-translate>FiltroPersonalizado.nenhumFiltro</span><sk-btn-novo sk-entity-description=\"{{::'FiltroPersonalizado.filtro' | translate}}\" sk-on-click=openFilterNew()></sk-btn-novo></div></ul></div>");
  $templateCache.put("components/personalizedfilter/templates/validate-filter-popup.tpl.html",
    "<sk-vbox><span sk-font-size=14px>{{ctrl.textPopup}}<span style=\"color: red; font-size: 14px\">*</span></span><sk-vbox ng-if=\"ctrl.validateSecurity || !ctrl.mode\"><sk-hbox><a sk-padding-left=0px sk-padding=6px ng-click=toggleExpressao() sk-translate>{{ctrl.lblTooltip}}</a><sk-icon class=icon-expand font-icon=\"{{ctrl.enableExpressao ? 'chevron-up' : 'chevron-down' }}\" v=2 ng-click=toggleExpressao() tooltip=\"{{ ctrl.lblTooltip }}\" tooltip-placement=right sk-padding-top=6px></sk-icon></sk-hbox><sk-text-area ng-if=ctrl.enableExpressao sk-size=4000 sk-value=ctrl.expressao sk-width=100% sk-enabled=false sk-padding-bottom=6px></sk-text-area></sk-vbox><sk-text-area sk-placeholder=FiltroPersonalizado.lblPlaceholderAprovacaoFilter sk-size=100 sk-value=ctrl.value sk-height=100 sk-width=100% sk-required=true></sk-text-area></sk-vbox>");
  $templateCache.put("components/personalizedfilter/templates/variable-parameter-config-popup.tpl.html",
    "<div class=variable-parameter-config-container layout=column flex><div layout=row layout-align=\"space-around center\"><div layout=column class=left-container layout-align=\"start start\" flex=45><sk-radio-input sk-value=ctrl.parameter.config.configType sk-option=S sk-change=onChange() sk-name=example layout-bottom-margin>{{::'FiltroPersonalizado.lblUsarDefinicoesSistema' | translate }}</sk-radio-input><div class=form-group><label sk-translate>FiltroPersonalizado.lblUnidadeDados</label><sk-pesquisa-input sk-value=ctrl.parameter.config.systemConfig.entityName sk-enabled=\"ctrl.parameter.config.configType == 'S'\" sk-code-input-enabled=false sk-entity-name=Instancia sk-field-name=NOMEINSTANCIA sk-show-description-input=false sk-use-local-field-name=true></sk-pesquisa-input></div><div class=form-group><label sk-translate>Geral.lblCampo</label><sk-pesquisa-input sk-value=ctrl.parameter.config.systemConfig.fieldName sk-enabled=\"ctrl.parameter.config.configType == 'S'\" sk-code-input-enabled=false sk-entity-name=Campo sk-field-name=NOMECAMPO sk-description-field-name=DESCRCAMPO sk-show-description-input=false sk-enviroment-criteria=ctrl.getFieldEnviromentCriteria() sk-use-local-field-name=true></sk-pesquisa-input></div></div><div layout=column class=vertical-rule></div><div layout=column class=right-container layout-align=\"start start\" flex=45><sk-radio-input sk-value=ctrl.parameter.config.configType sk-option=E sk-change=onChange() sk-name=example layout-bottom-margin>{{::'FiltroPersonalizado.lblUsarDefinicoesEspecificas' | translate }}</sk-radio-input><div class=form-group><label class=form-input-label><span sk-translate>Geral.lblDescricao</span><sk-icon font-icon=asterisk class=required></sk-icon></label><sk-text-input sk-enabled=\"ctrl.parameter.config.configType == 'E'\" sk-value=ctrl.parameter.config.userConfig.description></sk-text-input></div><div class=form-group><label class=form-input-label><span sk-translate>Geral.lblTipo</span><sk-icon font-icon=asterisk class=required></sk-icon></label><sk-combobox sk-enabled=\"ctrl.parameter.config.configType == 'E'\" sk-value=ctrl.parameter.config.userConfig.type sk-options=ctrl.dataTypeOptions sk-required=true></sk-combobox></div></div></div><sk-text-area sk-enabled=false sk-value=ctrl.buildExpression() flex layout-padding></sk-text-area></div>");
  $templateCache.put("components/personalizedfilter/tour/templates/btnAddCondition.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgBtnAddCondition</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/btnAddParentheses.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgBtnAddParentheses</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/btnAdvancedMode.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgBtnAdvancedMode</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/btnNewFilter.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgBtnNewFilter</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/btnPreviewExpression.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgBtnPreviewExpression</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/btnRemoveCondition.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgBtnRemoveCondition</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/cbxVariableValue.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgCbxVariableValue</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/inputDefaultValue.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgInputDefaultValue</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/inputFilterName.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgInputFilterName</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/inputSelectOperator.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgInputSelectOperator</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/intro.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgIntro</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/lblSelectedField.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgLblSelectedField</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/titleLastMessage.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgTitleLastMessage</sk-translate>");
  $templateCache.put("components/personalizedfilter/tour/templates/titleNewFilters.tpl.html",
    "<sk-translate>FiltroPersonalizado.tour.msgTitleNewFilters</sk-translate><img style=margin-left:5px src=/mge/assets/img/filtro-personalizado.PNG>");
  $templateCache.put("components/pesquisacep/pesquisacep.tpl.html",
    "<div class=pesquisa-cep-container layout=column creation-complete=creationComplete()><sk-dataset id=dsCEP entity-name=CEP><sk-field pattern=*></sk-field><sk-field pattern=TIPO path=Endereco></sk-field></sk-dataset><sk-double-face-panel sk-id=dblFacePanelId sk-dataset=dsCEP sk-default-face-index=GRID_FACE sk-change-button-actions=changeActionButtons sk-focus-resolver=dblFacePanelFocusResolver(faceSelector) layout flex><sk-top-bar layout=row><div class=nav-bar layout=row layout-align=\"space-between center\" flex><sk-navigator dataset=dsCEP sk-show-first-button=false sk-show-last-button=false></sk-navigator><sk-rows-counter sk-dataset=dsCEP></sk-rows-counter></div></sk-top-bar><sk-face-one layout=column flex><sk-form columns=3 sk-autofocus=true sk-dataset=dsCEP sk-fields-order=fieldsOrder sk-form-interceptor=ctrl sk-required-fields=requiredFields></sk-form></sk-face-one><sk-face-two layout=column flex><div class=filter-panel layout=column><sk-form sk-autofocus=true properties=formFilterFields columns=2 model=filter sk-allow-repeated-fields=true></sk-form><div layout=row><button class=\"btn btn-primary\" ng-click=dsCEP.refresh()><sk-icon font-icon=filter></sk-icon>Aplicar</button> <button class=\"btn btn-default\" ng-click=limparFiltro()>Limpar filtro</button></div></div><sk-datagrid sk-dataset=dsCEP sk-datagrid-interceptor=ctrl sk-editable=false sk-allow-multiple-selection=false sk-on-dbl-click=onGridDblClick() sk-grid-config={{gridConfigId}}></sk-datagrid></sk-face-two></sk-double-face-panel></div>");
  $templateCache.put("components/pesquisacep/popupselectcep.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-dsfield-md name=cep description=Cep visible></sk-dsfield-md><sk-dsfield-md name=codEnd description=CepInput.lblCodEnd></sk-dsfield-md><sk-dsfield-md name=descEnd description=CepInput.lblDesEnd></sk-dsfield-md><sk-dsfield-md name=codBairro description=CepInput.lblCodBai></sk-dsfield-md><sk-dsfield-md name=descBairro description=CepInput.lblDesBai></sk-dsfield-md><sk-dsfield-md name=codCid description=CepInput.lblCodCid></sk-dsfield-md><sk-dsfield-md name=descCid description=CepInput.lblDesCid></sk-dsfield-md><sk-dsfield-md name=codUf description=CepInput.lblCodEst></sk-dsfield-md><sk-dsfield-md name=descUf description=CepInput.lblDesEst></sk-dsfield-md></sk-dataset><div class=select-cep-container layout=column><sk-top-bar layout=row><div class=nav-bar layout=row layout-align=\"space-between center\" flex><sk-navigator sk-show-remove-button=false sk-show-copy-button=false sk-show-add-button=false sk-show-refresh-button=false dataset=ctrl.dsCeps sk-show-first-button=false sk-show-last-button=false></sk-navigator><sk-rows-counter sk-dataset=ctrl.dsCeps></sk-rows-counter></div></sk-top-bar><div layout=column flex><sk-datagrid sk-dataset=ctrl.dsCeps sk-editable=false sk-allow-multiple-selection=false sk-on-dbl-click=ctrl.onGridDblClick() sk-grid-config={{gridConfigId}} sk-on-datagrid-loaded=ctrl.onGridLoaded(datagrid)></sk-datagrid></div></div>");
  $templateCache.put("components/popup/popup.tpl.html",
    "<div tabindex=-1 role=dialog class=modal sk-popup-render={{$isRendered}} sk-popup-animation-class=fade sk-popup-in-class=in ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=close($event)><div class=modal-dialog ng-class=\"size ? 'modal-' + size : ''\"><div class=modal-content><div class=modal-header ng-if=!hideHeader><button type=button class=close data-dismiss=modal ng-click=\"onDismiss('close')\" ng-if=::showIconClose sk-draggable-off><sk-icon svg-src=/mge/assets/svg/cancel.svg sk-draggable-off></sk-icon></button><sk-hbox flex><sk-icon class=modal-icon-font ng-if=popupFontIcon font-icon={{::popupFontIcon}} v=2></sk-icon><sk-icon class=modal-icon-svg ng-if=popupSvgIcon svg-src={{::popupSvgIcon}}></sk-icon><img class=modal-icon-img ng-if=popupImgIcon ng-src={{::popupImgIcon}}><h5 class=modal-title ng-bind=popupTitle></h5></sk-hbox></div><div class=modal-body flex layout=column sk-scroll-container=scrollContainer sk-popup-transclude></div><div class=modal-footer layout=row ng-show=::showFooter><div class=modal-footer-left ng-show=\"footerLeft.length > 0\"></div><div class=modal-footer-right flex><button class=\"btn btn-popup-troubleshooting {{ ::troubleshootingBtnClass }}\" ng-click=\"onDismiss('troubleshooting')\" ng-bind=::troubleshootingBtnLabel ng-if=::showBtnTroubleshooting flex></button> <button class=\"btn btn-popup-no {{ ::noBtnClass }}\" ng-click=\"onDismiss('no')\" ng-bind=::noBtnLabel tooltip={{::noBtnTooltip}} ng-if=::showBtnNo flex ng-disabled=!enableBtnNo></button> <button class=\"btn btn-popup-cancel {{ ::cancelBtnClass }}\" ng-click=\"onDismiss('cancel')\" ng-bind=::cancelBtnLabel ng-if=::showBtnCancel flex></button> <button class=\"btn btn-popup-ok {{ ::okBtnClass }}\" ng-click=onSuccess() ng-bind=::okBtnLabel tooltip={{::okBtnTooltip}} tooltip-placement=top ng-if=::showBtnOk ng-disabled=!enableBtnOk flex></button></div></div></div></div></div>");
  $templateCache.put("components/popupparameter/popupparameter.tpl.html",
    "<sk-form columns={{::options.columns}} properties=fields sk-autofocus sk-allow-duplicate-fields></sk-form>");
  $templateCache.put("components/queryexecutor/queryexecutor.tpl.html",
    "<sk-vbox sk-height=100% gap=5 flex><sk-hbox gap=5><sk-tabnavigator sk-selected-index=ctrl.selectedIndex flex><sk-tabnavigator-item><sk-i18n>Commons.QueryEditor.lblConsulta</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Commons.QueryEditor.lblResultado</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-hbox gap=5><div class=\"btn-group dropdown\" dropdown dropdown-append-to-body is-open=states.isDropdownOpen><button class=\"btn btn-default btn-sk-sm view\" type=button svg-src=html5/GadgetBuilder/assets/datasources.svg class=\"btn dropdown-toggle\" dropdown-toggle href=# tooltip=Controls.QueryBuilder.buttonFonteDados sk-translate=Controls.QueryBuilder.buttonFonteDados sk-translate-attr=tooltip tooltip-placement=right tooltip-append-to-body=true sk-i18n></button><ul ul class=dropdown-menu role=menu sk-padding=10px style=\"z-index: 10000\"><li ng-repeat=\"value in ctrl.dataSourcesOpt\" role=menuitem><sk-radio-input sk-value=ctrl.dataSource sk-option={{value}}>{{value}}</sk-radio-input></li></ul></div><button class=\"btn btn-default btn-sk-sm view\" ng-click=ctrl.executarQuery(true) tooltip=\"\" sk-translate=mge.GadgetBuilder.btnExecutarAgora sk-translate-attr=tooltip tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=play class=play></sk-icon></button></sk-hbox></sk-hbox><sk-viewstack sk-selected-index=ctrl.selectedIndex sk-on-select=ctrl.selectedStack sk-creation-policy=all flex><sk-viewstack-content flex sk-height=330px><sk-code-editor sk-mode=sql sk-value=ctrl.sql layout flex sk-height=330px></sk-code-editor></sk-viewstack-content><sk-viewstack-content flex><sk-ag-grid id=ag-grid-result sk-width=100% sk-grid-options=ctrl.gridOptions sk-height=330px></sk-ag-grid></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("components/queryexecutor/queryexecutorparams.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-columns=1 sk-in-line=true flex><sk-simple-item sk-label={{param.name}} ng-repeat=\"param in ctrl.parameters track by $index\"><sk-hbox sk-width=100% gap=5 ng-switch=param.typeValue><sk-date-time-input sk-width=153px sk-value=param.value ng-model=param.value ng-switch-when=D></sk-date-time-input><sk-text-input sk-width=153px sk-value=param.value ng-switch-when=I sk-restrict=[^0-9]></sk-text-input><sk-text-input sk-width=153px sk-value=param.value ng-switch-when=T></sk-text-input><sk-combobox sk-value=param.typeValue sk-options=ctrl.typeParams sk-allow-null=false sk-change=ctrl.resetParamValue($index) sk-width=110px></sk-combobox></sk-hbox></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("components/recordsorganizerbar/recordsorganizerbar.tpl.html",
    "<div style=\"display: flex\"><sk-change-order-bar sk-dataset=dataset></sk-change-order-bar><button default ng-click=ctrl.save() ng-disabled=!ctrl.btnSaveEnabled>{{labelSave}}</button></div>");
  $templateCache.put("components/resizablecontainer/resizalbecontainer.tpl.html",
    "<ng-transclude></ng-transclude>");
  $templateCache.put("components/sankhyaaccount/sankhyaAccount.tpl.html",
    "<div ng-if=\"stateComponent == 1\" class=inline-item><sk-hbox><input class=form-input placeholder={{ctrl.placeHolderInputAccount}} ng-model=ctrl.value ng-disabled=!enabled ng-required=required ng-change=changeHandler() ng-keydown=onInputKeydown($event)><sk-icon class=form-icon font-icon=circle-question-mark sk-i18n tooltip={{ctrl.toolTip}} sk-width=20px></sk-icon><button type=button class=\"btn btn-primary form-button\" ng-click=linkAccount(ctrl.value) ng-if=!dataset.isInsertionMode()>{{ctrl.linkAccount}}</button></sk-hbox></div><div ng-if=\"stateComponent == 2\" class=inline-item><sk-hbox class=form-div-confirm><div class=form-div-img-default><img src=/mge/img/userAcc.png class=form-img-default></div><div><div class=form-div-flex><div><div class=form-flag-status></div></div><span class=form-span-status sk-i18n>Core.CadastroUsuarios.lblStatusAguardandoVerificacao</span></div><div><span class=form-span-email>{{dataset.getFieldValue('ACCOUNTEMAIL')}}</span></div></div><div><img src=/mge/img/cancelAcc.png class=form-button-img><button type=button class=\"btn btn-default form-button-cancel\" ng-click=cancelLinkAccount()>{{ctrl.cancelAccount}}</button></div></sk-hbox></div><div ng-if=\"stateComponent == 3\" class=inline-item><sk-hbox class=form-div-link><div ng-if=\"getPhoto() != '/mge/img/userAcc.png'\" class=form-div-img><img src={{getPhoto()}} class=form-img></div><div ng-if=\"getPhoto() == '/mge/img/userAcc.png'\" class=form-div-img-default><img src=/mge/img/userAcc.png class=form-img-default></div><div><div><span class=form-span-email>{{userName()}}</span></div><div><span class=form-span-status>{{dataset.getFieldValue('ACCOUNTEMAIL')}}</span></div></div><div><button type=button class=\"btn btn-danger form-button-unlink\" ng-click=unlinkAccount()>{{ctrl.unlinkAccount}}</button></div></sk-hbox></div><div ng-if=\"stateComponent == 4\" class=inline-item><sk-hbox class=form-div-link><div ng-if=\"getPhoto() != '/mge/img/userAcc.png'\" class=form-div-img><img src={{getPhoto()}} class=form-img></div><div ng-if=\"getPhoto() == '/mge/img/userAcc.png'\" class=form-div-img-default><img src=/mge/img/userAcc.png class=form-img-default></div><div class=form-div-account-data><div><span class=form-span-status>{{dataset.getFieldValue('ACCOUNTEMAIL')}}</span></div></div><div><button type=button class=\"btn btn-danger form-button-unlink\" ng-click=unlinkAccount()>{{ctrl.unlinkAccount}}</button></div></sk-hbox></div>");
  $templateCache.put("components/select/selectize/choices.tpl.html",
    "<div ng-show=$select.open class=\"ui-select-choices ui-select-dropdown selectize-dropdown single\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\" role=listbox><div ng-show=$select.isGrouped class=\"ui-select-choices-group-label optgroup-header\" ng-bind=$group.name></div><div role=option class=ui-select-choices-row ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner text-ellipsis\" data-selectable></div></div></div></div></div>");
  $templateCache.put("components/select/selectize/match.tpl.html",
    "<div ng-hide=\"($select.open || $select.isEmpty())\" class=ui-select-match ng-transclude title=\"{{ $select.selected.label || $select.selected.value }}\"></div>");
  $templateCache.put("components/select/selectize/select.tpl.html",
    "<div class=\"ui-select-container selectize-control single\"><div class=selectize-input ng-class=\"{'focus': $select.open, 'disabled': $select.disabled, 'selectize-focus' : $select.focus}\" ng-click=$select.activate()><div class=ui-select-match></div><input autocomplete=off tabindex=-1 class=\"ui-select-search ui-select-toggle\" ng-click=$select.toggle($event) placeholder={{$select.placeholder}} ng-model=$select.search ng-hide=\"!$select.searchEnabled || ($select.selected && !$select.open)\" ng-disabled=\"$select.disabled || $select.isMobile\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=ui-select-choices></div></div>");
  $templateCache.put("components/sidenav/sidenav.tpl.html",
    "<div class=sk-sidenav-controls layout-align=\"center center\" layout=row ng-if=isSidenavRight><span class=sk-sidenav-arrow ng-click=openCloseSidenav()><sk-icon font-icon=play ng-class=\"{'flip': !isOpen}\"></sk-icon></span></div><div class=sk-sidenav-content flex=\"\" ng-transclude></div><div class=sk-sidenav-controls layout-align=\"center center\" layout=row ng-if=!isSidenavRight><span class=sk-sidenav-arrow ng-click=openCloseSidenav()><sk-icon font-icon=play ng-class=\"{'flip': isOpen}\"></sk-icon></span></div>");
  $templateCache.put("components/sidenav/sidenavHorizontal.tpl.html",
    "<div class=sk-sidenav-controls layout-align=\"center center\" layout=column ng-if=isSidenavBottom><span class=sk-sidenav-arrow ng-click=openCloseSidenav()><sk-icon font-icon=play ng-class=\"{'flip': !isOpen}\" ng-style=\"{'transform' : isOpen ? 'rotate(90deg)' : 'rotate(270deg)'}\"></sk-icon></span></div><div class=sk-sidenav-content flex=\"\" ng-transclude></div><div class=sk-sidenav-controls layout-align=\"center center\" layout=column ng-if=!isSidenavBottom><span class=sk-sidenav-arrow ng-click=openCloseSidenav()><sk-icon font-icon=play ng-class=\"{'flip': isOpen}\" ng-style=\"{'transform' : isOpen ? 'rotate(270deg)' : 'rotate(90deg)'}\"></sk-icon></span></div>");
  $templateCache.put("components/simpleform/simpleform.tpl.html",
    "<div class=sk-form flex><div class=\"form-fields-container clearfix\" ng-transclude></div></div>");
  $templateCache.put("components/simpleform/simplegroup/simplegroup.tpl.html",
    "<label class=\"group-label col-sm-12\"></label><div ng-transclude></div>");
  $templateCache.put("components/simpleform/simpleitem/simpleitem.tpl.html",
    "<div class=form-group><div ng-if=!$ctrl.inLine sk-width=100%><label ng-if=\"$ctrl.labelText || $ctrl.emptyLabel\" class=\"form-input-label simple-label\" ng-class=\"{'required': $ctrl.required, 'has-help-tip': $ctrl.helptip}\"><div layout=row><span ng-bind=$ctrl.labelText ng-if=!$ctrl.emptyLabel></span> <span class=required>*</span><sk-help-tip ng-if=$ctrl.helptip sk-class-help={{$ctrl.classHelp}} sk-text={{$ctrl.helptip}} sk-placement={{$ctrl.positionHelpTip}}></div></label><div class=clearfix></div><div ng-transclude id=simple-item-content></div></div><div ng-if=$ctrl.inLine ng-style=$ctrl.getItemStyle() class=inline-item sk-width=100%><label ng-if=\"$ctrl.labelText || $ctrl.emptyLabel\" class=\"form-input-label simple-label\" ng-class=\"{'required': $ctrl.required, 'has-help-tip': $ctrl.helptip}\"><div ng-style=$ctrl.getStyleLblContainer()><span class=lblText ng-bind=\"$ctrl.labelText | labelFilter\" ng-if=!$ctrl.emptyLabel></span> <span class=required>*</span><sk-help-tip ng-if=$ctrl.helptip sk-class-help={{$ctrl.classHelp}} sk-text={{$ctrl.helptip}} sk-placement={{$ctrl.positionHelpTip}}></div></label><div ng-transclude id=simple-item-content-inline></div></div></div>");
  $templateCache.put("components/snackbar/snackbar.tpl.html",
    "<div id={{ctrl.id}} class=\"sk-snackbar {{customClass}}\" ng-class=\"\n" +
    "        { \n" +
    "            'sk-snackbar--show'  : ctrl.show,\n" +
    "            'sk-snackbar--left'  : positionHorizontal === 'left',\n" +
    "            'sk-snackbar--right' : positionHorizontal === 'right',\n" +
    "            'sk-snackbar--top'   : positionVertical   === 'top'\n" +
    "        }\n" +
    "    \"><div class=sk-snackbar__content><span class=sk-snackbar__icon ng-if=iconName><i class=\"glyphicon glyphicon-{{iconName}}\"></i></span><div class=sk-snackbar__column><p class=sk-snackbar__title ng-if=snackbarTitle ng-bind-html=snackbarTitle></p><p class=sk-snackbar__message ng-if=snackbarMessage ng-bind-html=snackbarMessage></p></div></div><button type=button class=sk-snackbar__button tooltip=Fechar ng-click=ctrl.close()><i class=\"glyphicon glyphicon-remove-2\"></i></button></div>");
  $templateCache.put("components/stickypanel/stickypanel.tpl.html",
    "<div class=sticky-container ng-transclude></div>");
  $templateCache.put("components/structuredfield/structuredfield.tpl.html",
    "<sk-vbox style=\"border:1px solid #e5e5e5\"><span ng-show=!hasStructure sk-i18n></span><sk-form properties=formProperties model=formValues sk-form-interceptor=ctrl sk-on-form-loaded=onFormLoaded(form) sk-inline=true ng-show=hasStructure layout-padding></sk-form></sk-vbox>");
  $templateCache.put("components/tabnavigator/alltabspopover.tpl.html",
    "<div layout=column flex ng-keydown=\"onKeydown($event, hide, uid)\"><sk-search-input autofocus layout-padding sk-value=query.value sk-placeholder=Geral.lblPesquisar></sk-search-input><div class=navigator-all-tabs-container layout-padding sk-scroll-container><div class=\"tab-item text-ellipsis\" ng-repeat=\"tab in tabs | filter:filterTabs:query\" ng-bind=tab.label title={{tab.label}} ng-click=\"select(tab); hide();\" ng-class=\"{'active': selectedIndex == tab.index, 'selected': query.currentIndex == $index}\"></div></div></div>");
  $templateCache.put("components/tabnavigator/tabnavigator.tpl.html",
    "<div ng-if=!hideShowTabs class=\"tab-controls tab-show-all-button\" sk-sortable=ctrl.sortableConfigForPrev><span class=popover-container sk-popover popover-template-url=components/tabnavigator/alltabspopover.tpl.html create-on-load=false properties=ctrl.getAllTabsPopoverProperties show-btn-apply=false show-btn-close=false width=300 height=auto popover-placement=right always-load-properties=true popover-class=\"white-popover no-padding\" hide-on-scroll=true absolute=true><sk-icon font-icon=more-windows sk-i18n tooltip=Geral.mostrarTodasAbas tooltip-placement=right></sk-icon></span></div><div class=\"tab-controls tab-prev-button\" sk-sortable=ctrl.sortableConfigForPrev ng-if=ctrl.shouldPaginate ng-click=ctrl.prevPage() ng-class=\"{'sk-disabled': !ctrl.canPageBack()}\"><sk-icon svg-src=tabs-arrow.svg></sk-icon></div><div class=\"tab-controls tab-next-button flip\" sk-sortable=ctrl.sortableConfigForNext ng-if=ctrl.shouldPaginate ng-click=ctrl.nextPage() ng-class=\"{'sk-disabled': !ctrl.canPageForward()}\"><sk-icon svg-src=tabs-arrow.svg></sk-icon></div><div ng-style=ctrl.removeMargin() class=tabnavigator-viewport ng-class=\"{'sk-paginated': ctrl.shouldPaginate}\"><div class=tabnavigator-wrapper ng-transclude></div></div>");
  $templateCache.put("components/tabnavigator/tabnavigatoritem.tpl.html",
    "<div flex layout=row ng-class=\"{'no-padding-left': fontIcon}\" ng-click=select()><sk-icon font-icon={{fontIcon}} ng-if=fontIcon class=labelIcon></sk-icon><div ng-transclude></div><sk-icon svg-src=close.svg ng-click=close() class=closeIcon></sk-icon></div>");
  $templateCache.put("components/taskbar/taskbar.tpl.html",
    "<div class=\"task-bar high-contrast-panel\"><div ng-transclude style=\"display: none\"></div><div><sk-hbox><div layout layout-wrap flex><sk-grid-config ng-if=\"!isOnDbfPanel  && configName != undefined\" sk-config-name={{::configName}}></sk-grid-config><sk-personalized-filter id=personalizedFilter sk-data-source=dataset sk-load-on-create=\"{{ true }}\" sk-entity-name={{::dataset.getEntityName()}} sk-resource-id=\"{{ ::resourceId }}\" ng-if=!hidePersonalizedFilterButton sk-eh-popup=popupMode class=margin-right sk-field-filter-function=filterFieldsPersonalizedFilter></sk-personalized-filter><sk-filter-panel-btn ng-if=showFilterPanelBtn></sk-filter-panel-btn><sk-navigator dataset=dataset sk-margin-left=5px sk-disabled=navigatorOptions.disableNavigator sk-show-navigation=navigatorOptions.showNavigation sk-show-copy-button=navigatorOptions.showCopyButton sk-show-remove-button=navigatorOptions.showRemoveButton sk-show-refresh-button=navigatorOptions.showRefreshButton sk-show-cancel-button=navigatorOptions.showCancelButton sk-show-save-button=navigatorOptions.showSaveButton sk-show-add-button=navigatorOptions.showAddButton sk-show-edit-button=navigatorOptions.showEditButton sk-compact-btn-add=navigatorOptions.compactAddBtn class=btn-nav sk-api=dynaformCtrl.navigatorApi></sk-navigator><div class=user-left-container layout=row></div></div><div layout layout-wrap><span flex></span><div class=\"entity-search-container margin-right\" ng-if=!hideEntitySearchField sk-margin-top=2px layout><sk-typeahead-input id=entitySearchField sk-value=controller.entitySearch sk-clear-after-select=true sk-placeholder=\"{{'Dynaform.search.entity' | translate}}\" sk-get-options=loadEntitySuggestions sk-is-loading=isSearchingEntity sk-key=label sk-label=label sk-on-select=pesqEntitySelect sk-show-more=true sk-show-more-fn=showMoreEntityPesqResults() sk-template-url=entitySearch.html sk-external-action=true sk-append-to-body=true sk-min-length=1></sk-typeahead-input></div><div class=user-right-container sk-margin-left=5px layout=row></div><sk-grid-printer ng-if=showGridPrinter sk-margin-left=5px sk-grid-controller=datagrid></sk-grid-printer><sk-entity-attach id=dynAttach ng-if=!hideEntityAttach sk-resource-id=\"{{ ::resourceId }}\" sk-margin-left=5px sk-dataset=dataset sk-entity-name={{::dataset.getEntityName()}}></sk-entity-attach><sk-dropdown-menu ng-if=buildOptions($dropdownMenu) sk-margin-left=5px sk-open-always=true sk-build-options=buildOptions($dropdownMenu) sk-parameters=dataset.getEntityName()></sk-dropdown-menu><div class=\"btn-group dropdown btn-group-config\" sk-margin-left=5px dropdown dropdown-append-to-body auto-close=outsideClick is-open=dropdownConfig.isOpen ng-if=!hideButtonsConfig><button type=button class=\"btn btn-default btn-sk-sm\"><sk-icon font-icon=cogwheel></sk-icon></button> <button type=button class=\"btn btn-default dropdown-toggle\" dropdown-toggle><span class=caret></span></button><ul class=\"sk-dynaform dropdown-menu\" role=menu aria-labelledby=split-button><li role=menuitem ng-click=openNumberConfig($event) ng-if=!numberConfigDisabled><div><span class=one-icon>1</span> <span sk-translate>NumberConfig.numeracao</span></div></li><li ng-if=otherConfigurations ng-repeat=\"conf in otherConfigurations.items\" ng-click=onClickUserConfiguration(conf) class=other-config-item><div ng-switch=conf.type><div ng-switch-when=switch><sk-switch sk-true-value=true sk-false-value=false sk-change=onChangeUserConfiguration(conf) sk-value=otherConfigurations.byId[conf.id].value></sk-switch><span sk-i18n={{conf.label}} class=vertical-align-middle></span></div><div ng-switch-default><sk-icon font-icon={{conf.icon}}></sk-icon><span sk-i18n={{conf.label}} class=vertical-align-middle></span></div></div></li></ul></div><sk-rows-counter sk-margin-left=5px class=btn-rows-counter ng-if=\"dataset && !editUniqueRecord\" sk-dataset=dataset></sk-rows-counter></div></sk-hbox><div class=clearfix></div></div></div><script type=text/ng-template id=entitySearch.html><div>\n" +
    "        <sk-entity-card\n" +
    "                sk-corner-favorite\n" +
    "                sk-highlight-on=\"query\"\n" +
    "                sk-entity-name=\"match.model.entityName\"\n" +
    "                sk-pk-field=\"match.model.pkField\"\n" +
    "                sk-all-pks=\"match.model.allPks\"\n" +
    "                sk-other-entity-pks=\"match.model.otherEntityPks\"\n" +
    "                sk-description-field=\"match.model.descriptionField\"\n" +
    "                sk-has-image=\"match.model.hasImage\"\n" +
    "                sk-image-field=\"match.model.imageField\"\n" +
    "                sk-is-favorite=\"match.model.isFavorite\"\n" +
    "                sk-resource-id=\"match.model.resourceID\"\n" +
    "                sk-data=\"match.model.data\"\n" +
    "                sk-fields-metadata=\"match.model.fieldsMetadata\"\n" +
    "                >\n" +
    "        </sk-entity-card>\n" +
    "    </div></script>");
  $templateCache.put("components/timelinediagram/linerenderer/lanetitle/lanetitlerenderer.tpl.html",
    "<div class=lane-title><sk-image-input class=lane-title-photo ng-show=lane.isExpanded() sk-width=60px sk-height=60px sk-entity-name=Usuario sk-field-name=FOTO sk-pk=\"{ CODUSU: codUsu }\" sk-only-image=true tooltip=\"{{ tooltipPhoto }}\" tooltip-placement=right sk-icon-default=/mge/assets/img/men_silhouette.png></sk-image-input><sk-icon ng-show=lane.hasTimeConflict() class=icon font-icon=\"glyphicons glyphicons glyphicons-alert\" tooltip=\"{{ tooltipAlert }}\" tooltip-placement=right></sk-icon><sk-icon ng-show=hasFinancialLate class=icon ng-click=ctrl.financialLate() font-icon=\"glyphicons glyphicons-2-payment\" v=2 tooltip=\"{{ tooltipLate }}\" tooltip-placement=right></sk-icon><sk-icon ng-show=hasConnectionProblem class=icon font-icon=\"glyphicons glyphicons-2-sync-alert\" v=2 tooltip=\"{{ tooltipNotSynchronized }}\" tooltip-placement=right></sk-icon><div class=container-title><label ng-class=\"{'content-title-icon': ctrl.shouldShowTitleIcon()}\" ng-bind=lane.getDescription() tooltip={{tooltipLabel}} tooltip-placement=right></label></div></div>");
  $templateCache.put("components/timelinediagram/linerenderer/simpleline/simplelinerenderer.tpl.html",
    "<label ng-bind=lane.getDescription()><label></label></label>");
  $templateCache.put("components/timelinediagram/optionsList/optionsList.tpl.html",
    "<sk-vbox flex><section class=option-list></section></sk-vbox>");
  $templateCache.put("components/timelinediagram/timelinediagram.tpl.html",
    "<div class=time-line-root ng-mousemove=resizeMove($event)><div class=resize-shadow ng-style=getTitleResizeTemplate()></div><div class=time-line-header ng-style=getGridTemplate()><div class=\"header-item control-panel border-right border-bottom\"><div class=period-navigator><span class=span-period-navigator>Período</span> <span sk-popover popover-template-url=components/timelinediagram/optionsList/optionsList.tpl.html controller-name=OptionsListController controller-as=ctrl create-on-load=true width=245 height=auto hide-on-scroll=false popover-hide-on-outside-click=true a lways-load-properties=true properties=ctrl.getProps()><sk-icon class=triangle-down sk-color-default=true svg-src=/mge/assets/svg/triangle-down.svg sk-i18n tooltip=\"Clique e veja a lista de opções\" tooltip-placement=bottom></sk-icon></span></div><div class=time-line-navigator><div class=icon-navigator-left><sk-icon ng-click=ctrl.previousColumn() class=previous-day font-icon=\"glyphicons glyphicons-play\" sk-i18n tooltip=\"Dia Anterior\" tooltip-placement=bottom></sk-icon></div><div class=icon-navigator-left><sk-icon ng-click=ctrl.previousViewPort() font-icon=\"glyphicons glyphicons-2-skip-to-start\" sk-i18n tooltip=\"Período Anterior\" tooltip-placement=bottom></sk-icon></div><div class=icon-navigator-left><sk-icon ng-click=ctrl.previousOccurrence() font-icon=\"glyphicons glyphicons-2-skip-to-previous\" sk-i18n tooltip=\"Ocorrência Anterior\" tooltip-placement=bottom></sk-icon></div><div class=date-input-navigator><sk-date-input class=date-input sk-value=ctrl.dtChooser sk-change=ctrl.onChange() sk-only-icon></sk-date-input></div><div class=icon-navigator-right><sk-icon ng-click=ctrl.nextOccurrence() font-icon=\"glyphicons glyphicons-2-skip-to-next\" sk-i18n tooltip=\"Próxima ocorrência\" tooltip-placement=bottom></sk-icon></div><div class=icon-navigator-right><sk-icon ng-click=ctrl.nextViewPort() font-icon=\"glyphicons glyphicons-2-skip-to-end\" sk-i18n tooltip=\"Próximo período\" tooltip-placement=bottom></sk-icon></div><div class=icon-navigator-right><sk-icon ng-click=ctrl.nextColumn() font-icon=\"glyphicons glyphicons-play\" sk-i18n tooltip=\"Próximo dia\" tooltip-placement=bottom></sk-icon></div></div><div class=range><div class=wrap role=group aria-label=\"multi thumb slider with ruler\"><input class=range-navigator id=b type=range min=10 max=40 step=5 ng-model=visibleColumns list=options><datalist id=options><option value=10>10 dias</option><option value=15></option><option value=20></option><option value=25></option><option value=30></option><option value=35></option><option value=40>40 dias</option></datalist></div></div></div><div class=\"title-resize header\" ng-dblclick=resizeDoubleClick() ng-mousedown=resizeStart($event)></div><div class=\"header-item header-lines\"><div class=\"header-title title-name border-bottom\" ng-bind=diagramTitle></div><div class=\"header-title border-bottom\" ng-style=getHeaderMonthStyle()><div ng-repeat=\"group in columnGroups track by $index\" class=\"moth-group border-right\" ng-class=\"{'last-day-item' : $index != (columnGroups.length - 1)}\"><span class=center ng-bind=group.label></span></div></div><div class=\"border-bottom in-line-items\"><div class=day-item ng-repeat=\"col in columnMetrics track by $index\" ng-style=\"{ width: col.width, height: col.height }\" ng-class=\"{'border-right last-day-item' : isLastDayOfMonth(visibleDates[$index])}\"><span ng-if=!isFilteredOutOfRange(visibleDates[$index]) class=center ng-bind=visibleDates[$index].getDate()></span><sk-icon ng-if=isFilteredOutOfRange(visibleDates[$index]) class=\"center icon-out-of-range\" font-icon=circle-remove v=2></sk-icon></div></div></div></div><div class=time-line-body ng-style=getGridTemplate()><div class=\"title-container border-right\"><div style=\"display: flex\" ng-repeat=\"lane in timeLanesView track by $index\" class=\"{{'title-item line-title-' + lane.getId()}}\" ng-class=\"{'border-bottom' : (timeLanesView.length - 1) != $index}\"></div></div><div class=\"title-resize body\" ng-mousedown=resizeStart($event) ng-dblclick=resizeDoubleClick()></div><div class=line-body-container><div ng-repeat=\"lane in timeLanesView track by lane.getId()\" class=\"{{'in-line-items line-body-' + lane.getId()}}\" ng-class=\"{'border-bottom' : (timeLanesView.length - 1) != lane.index}\" ng-mousedown=\"dayMouseDown($event, lane)\"><div class=\"day-item day-{{ visibleDates[$index].getDate() + '-' + visibleDates[$index].getMonth() + '-' + visibleDates[$index].getFullYear() }}\" ng-repeat=\"col in columnMetrics track by $index\" ng-style=getDayStyle(col) ng-class=\"{'border-right last-day-item' : isLastDayOfMonth(visibleDates[$index]), \n" +
    "                                'day-out-of-range' : isFilteredOutOfRange(visibleDates[$index]),\n" +
    "                                'weekend' : isWeekend(visibleDates[$index]) && !isFilteredOutOfRange(visibleDates[$index]),\n" +
    "                                'weekend-opacity' : isWeekend(visibleDates[$index]) && isFilteredOutOfRange(visibleDates[$index])\n" +
    "                                }\" index=\"{{ $index }}\" droppable drag-over=dragOver($event) drag-exit=dragExit($event) drag-end=dragEnd($event) drag-leave=dragLeave($event) drop=drop($event) line=\"{{ lane.getId() }}\" ng-mouseover=\"dayMouseOver($event, lane)\"><div class=\"timewear-content col-{{ $index }}\"></div><div ng-repeat=\"task in lane.getTasksByDay(visibleDates[$index]) track by $index\" id=\"{{'uid-' + task.uid}}\" class=task-content ng-if=lane.isExpanded() ng-style=\"ctrl.getTaskContentStyle(lane, task, col)\" ng-click=ctrl.onTaskClick($event) tooltip-html=ctrl.getFormatToolTip(task) tooltip-placement=bottom simple-draggable drag-start=dragStart($event) flex uid={{task.uid}}><div class=\"task-resize left\" simple-draggable></div><div class=\"task task-description\" ng-class=\"{ 'task-box' : task.showBox()}\" ng-style=\"ctrl.getTaskStyle(lane, task, col)\" ng-bind=task.description flex=95></div><sk-icon class=icon-done ng-if=task.done font-icon={{task.iconDone}} v=2 flex=5></sk-icon><div class=\"task-resize rigth\" simple-draggable></div></div></div></div></div></div></div>");
  $templateCache.put("components/timelinediagram/timewear/timewear.tpl.html",
    "<div class=root-time-wear ng-style=ctrl.getStyle() sk-height=8px ng-if=\"ctrl.rects.length > 1 || ctrl.rects[0].type != 'free'\"><div ng-repeat=\"rec in ctrl.rects\" class={{ctrl.getRectangleClass(rec)}}></div></div>");
  $templateCache.put("components/titlelabel/titlelabel.tpl.html",
    "<div layout=row class=title-lable-container><sk-icon class=title-icon ng-if=\"icon && icon.indexOf('.svg') > -1\" svg-src={{icon}} v={{iconV}}></sk-icon><sk-icon class=title-icon ng-if=\"icon && icon.indexOf('.svg') == -1\" font-icon={{icon}} v={{iconV}}></sk-icon><label ng-bind=text ng-style=labelStyle></label><span class=required ng-if=required>*</span></div>");
  $templateCache.put("components/toast/toast.tpl.html",
    "<div class=sk-modal ng-if=ctrl.skShowModal><button class=sk-modal-close-button aria-label=\"Fechar modal\" ng-click=ctrl.fecharModal()><sk-icon sk-color=white font-icon=menu-close v=2></sk-icon></button><div class=sk-modal-content><div class=sk-modal-icon-area><sk-icon sk-color=white font-icon=lightbulb v=2></sk-icon></div><div class=sk-modal-text-area><h2 sk-translate=\"{{ ctrl.skTitle }}\"></h2><br><p sk-translate=\"{{ ctrl.skText }}\"></p></div></div><div class=sk-modal-action-area><button class=sk-modal-action-button ng-click=ctrl.executarAcao() default><span sk-translate=\"{{ ctrl.skActionLabel }}\"></span></button></div></div>");
  $templateCache.put("components/tooltipbuilder/tooltipbuilder.tpl.html",
    "<div class=\"sk-tooltip custom-scroll\" layout=column flex><div class=\"sk-tooltip-container custom-scroll\" flex><p class=\"message-container custom-scroll\"></p></div><div class=triangle></div></div>");
  $templateCache.put("components/tree/tree.tpl.html",
    "<sk-vbox sk-height=100% flex><sk-hbox gap=5 sk-padding=5 ng-if=enableEdit><button default small ng-click=editAddRow()><sk-icon font-icon=plus></sk-icon></button> <button default small ng-if=\"showEditBtn !== false\" ng-click=editAddRow(true) ng-disabled=\"selected_branch == undefined\"><sk-icon font-icon=edit></sk-icon></button> <button default small ng-if=\"showRemoveBtn !== false\" ng-disabled=\"selected_branch == undefined\" ng-click=removeRow()><sk-icon font-icon=minus></sk-icon></button></sk-hbox><sk-vbox sk-height=25 ng-if=enableEdit></sk-vbox><div ng-if=!lazyLoad class=buttons-container layout ng-hide=hideButtonContainer><button default small ng-click=expand_all()><sk-icon svg-src=/mge/assets/svg/expand_all.svg></sk-icon></button> <button default small ng-click=collapse_all()><sk-icon svg-src=/mge/assets/svg/collapse_all.svg></sk-icon></button></div><sk-vbox ng-show=\"filteredRows && filteredRows.length > 0\" ng-style=\"{'min-height':heightTree}\" flex><ul id=nav-abn-tree class=\"nav abn-tree\" ng-keydown=onItemKeydown(row,$event) tabindex=3 sk-scroll-container><li ng-repeat=\"row in filteredRows = (tree_rows | filter: searchInputEnabled ? searchInput : '' | filter: filterFunction()) track by $index\" ng-class=\"(row.branch.selected ? ' active':'') + ' ' + row.classes.join(' ') + 'level-' + row.level\" ng-style=\"{'padding-left': getItemLeft(row.level, row.branch, row.tree_icon), 'position':relative}\" class=\"abn-tree-row {{row.encodedId}}\" id={{row.branch.uid}} draggable=true ng-mousedown=\"addEventsListenerInElement($event, row.encodedId)\" tooltip-light-html={{row.tooltip}} tooltip-placement={{row.toolTipPlacement}} tooltip-enable={{showTooltip}}><a class=\"indented no-text-selection abn-tree-flex-center\" ng-click=\"user_clicks_branch(row.branch, $event);\" ng-mousedown=\"user_mousedown(row.branch, $event)\" ng-dblclick=itemDblClick()><i ng-class=\"row.tree_icon  + (row.children && row.children.length ? null : ' collapse')\" class=tree-icon ng-click=\"lazyLoad ? toggleExpandedLazyLoad(row) : toggleExpanded(row)\"></i> <span ng-class=\"{'abn-tree-cbx-area' : enableCbx == true, 'not-card': showCard != true}\" class=\"node-container abn-tree-flex-stretch\"><sk-icon ng-if=\"row.icon && !iconIsSvg(getIconRow(row))\" font-icon={{getIconRow(row)}} v={{row.iconV}} style=\"font-size:18px;margin-right: 7px;color:#666\"></sk-icon><sk-icon ng-if=\"row.icon && iconIsSvg(getIconRow(row))\" svg-src={{getIconRow(row)}} style=\"width: 18px; height: 18px; min-width: 18px; min-height: 18px; margin-right: 7px;color:#666\"></sk-icon><span ng-if=\"lazyLoad == undefined && row.icon == undefined && showCard == true && !enableCbx\" class=filter-nick ng-style=\"{'background-color':textToColor(row.description || row.label || row.branch[labelCustomName])}\"><span ng-bind=\"::buildNick(row.description || row[labelCustomName] || row.branch[labelCustomName])\"></span></span><sk-checkbox ng-if=enableCbx ng-model=row.branch.checked accept-indeterminate=true indeterminate-value={{indeterminateValue}}></sk-checkbox><span ng-if=\"lazyLoad == undefined\" ng-bind-html=\"row[labelCustomName] || row.branch[labelCustomName]\" class=\"item-label abn-tree-flex-center\" ng-style=\"{'font-weight': getItemStyle(row.level,row.branch)}\"></span> <span ng-if=\"lazyLoad == true\" ng-bind-html=\"row['descriptionCustom']\" class=item-label ng-style=\"{'font-weight': getItemStyle(row.level,row.branch)}\"></span></span></a></li></ul></sk-vbox><sk-vbox align=\"center center\" ng-show=\"!filteredRows || !filteredRows.length\" flex><div sk-font-size=20px sk-color=gray-light><sk-i18n>Geral.semRegistros</sk-i18n>..</div></sk-vbox></sk-vbox>");
  $templateCache.put("components/twolists/twolists.tpl.html",
    "<div flex layout=column class=fill-size><div flex layout=row class=fill-size><div class=fill-size layout=column flex><div class=twolists-top-bar layout=row layout-align=\"center center\"><sk-search-input flex sk-i18n sk-placeholder=PesquisaContent.searchPlaceholder sk-value=srcSearchTerm></sk-search-input><div ng-transclude=srcRightContainer></div></div><div class=title-container layout-align=center layout=column ng-if=srcTitle ng-bind=srcTitle></div><div flex layout=column class=\"fill-size items-container\"><div sk-scroll-container layout=column flex><div sk-sortable=sortableConfigForSrcList style=\"overflow: auto\" layout=column flex><sk-tree ng-if=\"treeMode === true\" sk-tree-data=srcData sk-on-select=onSelectTreeNode sk-tree-control=treeCtrl sk-dbl-click-fn=dblClickInTreeHandler sk-search-term=srcSearchTerm sk-children-custom-name={{childrenCustomName}} sk-label-custom-name={{labelCustomName}}></sk-tree><div class=item ng-if=\"treeMode !== true\" ng-class=\"{'item-bg-gray': $odd ,'item-selected': srcSelectedItems.indexOf(item) > -1, 'handlable': moveToRight !== false}\" ng-repeat=\"item in srcData | filter:filterFn track by $index\" ng-click=\"selectItem(item, SOURCE_LIST, $event)\" ng-dblclick=\"moveItem(item, SOURCE_LIST)\"><div sk-component-transclude=srcItemTpl><div ng-bind=item></div></div></div></div></div></div></div><div class=btns-container layout=column layout-align=\"center center\"><button sk-i18n tooltip=TwoList.moveAllToRight class=\"btn btn-default btn-sk-sm\" ng-if=\"moveAllToRight !== false && moveToRight !== false\" ng-disabled=!hasSomeSrcItem() ng-click=moveInBatch(SOURCE_LIST,DEST_LIST,true)><sk-icon svg-src=/mge/assets/svg/forward.svg></sk-icon></button> <button sk-i18n tooltip=TwoList.moveToRight class=\"btn btn-default btn-sk-sm\" ng-if=\"moveToRight !== false\" ng-disabled=!hasSomeSrcItemSelected() ng-click=moveInBatch(SOURCE_LIST,DEST_LIST)><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button> <button sk-i18n tooltip=TwoList.moveToLeft class=\"btn btn-default btn-sk-sm\" ng-if=\"moveToLeft !== false\" ng-disabled=!hasSomeDestItemSelected() ng-click=moveInBatch(DEST_LIST,SOURCE_LIST)><sk-icon svg-src=/mge/assets/svg/back.svg></sk-icon></button> <button sk-i18n tooltip=TwoList.moveAllToLeft class=\"btn btn-default btn-sk-sm\" ng-if=\"moveAllToLeft !== false && moveToLeft !== false\" ng-disabled=!hasSomeDestItem() ng-click=moveInBatch(DEST_LIST,SOURCE_LIST,true)><sk-icon svg-src=/mge/assets/svg/rewind.svg></sk-icon></button></div><div class=fill-size layout=column flex><div class=twolists-top-bar layout=row layout-align=\"center center\"><sk-search-input flex sk-i18n sk-placeholder=PesquisaContent.searchPlaceholder sk-value=destSearchTerm sk-keydown=onDestSearchKeyDown($event)></sk-search-input><div ng-transclude=destRightContainer></div></div><div class=title-container layout-align=center layout=column ng-if=destTitle ng-bind=destTitle></div><div flex layout=column class=\"fill-size items-container\"><div sk-scroll-container style=\"overflow: auto\"><div sk-sortable=sortableConfigForDestList><div class=item ng-class=\"{'item-bg-gray': $odd,'item-selected': isItemSelected(DEST_LIST, item), 'handlable': moveToLeft !== false && !treeMode}\" ng-repeat=\"item in destData track by $index\" ng-click=\"selectItem(item, DEST_LIST, $event)\" ng-dblclick=\"moveItem(item, DEST_LIST)\" id=\"{{ 'item_' + (item.CP || item.field) }}\"><div sk-component-transclude=destItemTpl><div ng-bind=item ng-if=!treeMode></div><div ng-bind=item.label ng-if=treeMode></div></div></div></div></div></div></div><div class=btns-container ng-if=\"enableSort !== false\" layout=column layout-align=\"center center\"><button sk-i18n tooltip=TwoList.MovePosition default ng-click=showPopupMoveTo() small ng-if=movePosition ng-disabled=\"!(hasMoreThanTwoItem(DEST_LIST) && hasSomeDestItemSelected())\"><sk-icon font-icon=sorting></sk-icon></button> <button sk-i18n tooltip=TwoList.MovePrimeiro class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('up',true)\" ng-disabled=\"!(hasMoreThanTwoItem(DEST_LIST) && !isFirstItemSelected(DEST_LIST) && hasSomeDestItemSelected())\"><sk-icon svg-src=/mge/assets/svg/up-all.svg></sk-icon></button> <button sk-i18n tooltip=TwoList.MoveAcima class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('up')\" ng-disabled=\"!(hasMoreThanTwoItem(DEST_LIST) && !isFirstItemSelected(DEST_LIST) && hasSomeDestItemSelected())\"><sk-icon svg-src=/mge/assets/svg/up.svg></sk-icon></button> <button sk-i18n tooltip=TwoList.MoveAbaixo class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('down')\" ng-disabled=\"!(hasMoreThanTwoItem(DEST_LIST) && !isLastItemSelected(DEST_LIST) && hasSomeDestItemSelected())\"><sk-icon svg-src=/mge/assets/svg/down.svg></sk-icon></button> <button sk-i18n tooltip=TwoList.MoveUltimo class=\"btn btn-default btn-sk-sm\" ng-click=\"changeOrder('down', true)\" ng-disabled=\"!(hasMoreThanTwoItem(DEST_LIST) && !isLastItemSelected(DEST_LIST) && hasSomeDestItemSelected())\"><sk-icon svg-src=/mge/assets/svg/down-all.svg></sk-icon></button></div></div></div>");
  $templateCache.put("components/waitwindow/waitwindow.tpl.html",
    "<sk-vbox align=\"space-between start\" flex><span ng-bind-html=message width=100% height=100%></span><div class=\"progress-bar progress-bar-striped active\" role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100 id=progressBar><sk-vbox align=\"center center\" sk-height=100% flex><span class=labelCarregando sk-i18n>Controls.WaitWindow.labelAguarde</span></sk-vbox></div></sk-vbox>");
  $templateCache.put("components/wizard/steps/steps.tpl.html",
    "<section ng-show=selected ng-class=\"{current: selected, done: completed}\" class=step layout=column flex></section>");
  $templateCache.put("components/wizard/wizard.tpl.html",
    "<div layout=column style=padding:3px ng-class=\"{'container-max-height': usingMaxHeight === true}\" flex><ul class=\"steps-indicator steps-{{getEnabledSteps().length}}\" ng-if=!hideIndicators><li ng-class=\"{\n" +
    "            current: step.selected,\n" +
    "            editing: step.selected,\n" +
    "            default: !step.selected && $index > currentStepNumber()-1,\n" +
    "            done:    !step.selected && $index < currentStepNumber()-1 && step.completed\n" +
    "        }\" ng-repeat=\"step in getEnabledSteps()\"><a sk-i18n={{step.title}} ng-click=goTo(step)></a></li></ul><div class=steps sk-scroll-container layout flex ng-transclude></div><div class=buttons-container layout layout-align=\"end center\"><button sk-step-cancel ng-if=!hideBtnCancel class=\"btn btn-default\">{{ selectedStep.cancelLabel }}</button> <button sk-step-previous ng-if=!selectedStep.hidePrevious ng-disabled=!canPrevious() class=\"btn btn-default\">{{ selectedStep.previousLabel }}</button> <button sk-step-next ng-if=!selectedStep.hideNext ng-disabled=!canNext() class=\"btn btn-default\">{{ selectedStep.nextLabel }}</button> <button sk-step-finish ng-if=!selectedStep.hideFinish ng-disabled=!selectedStep.finalize class=btn ng-class=\"{'btn-primary' : selectedStep.finalize, 'btn-default' : !selectedStep.finalize}\">{{ selectedStep.finishLabel }}</button></div></div>");
  $templateCache.put("commons/acaoprogramada/acaoprogramada.tpl.html",
    "<sk-vbox class=acao-programada flex><sk-simple-form no-padding ng-if=\"ctrl.optionsType.length > 1\" sk-columns=4><sk-simple-item id=combo-tiporotina sk-label=Commons.Acaoprogramada.tiporotina sk-required=true><sk-hbox gap=5 flex><sk-combobox sk-value=\"value['type']\" sk-options=ctrl.optionsType sk-allow-null=false sk-change=\"ctrl.changeType(value['type'])\" sk-width=272px></sk-combobox><div ng-transclude=customElementOptionsType></div></sk-hbox></sk-simple-item><sk-simple-item id=switch-transacao-manual sk-padding-left=10px sk-label=Commons.Acaoprogramada.transacaoManual ng-if=\"showControleTransacao !== false\"><sk-switch sk-value=\"value['transacaoManual']\"></sk-switch></sk-simple-item></sk-simple-form><sk-viewstack sk-selected-index=ctrl.selectedIndex flex><sk-viewstack-content><sk-simple-form no-padding sk-columns=1 flex><sk-simple-item sk-label=Commons.Acaoprogramada.modulo sk-required=true><sk-pesquisa-input sk-entity-name=ModuloAdicional sk-value=\"value['moduloJava']\" sk-field-name=CODMODULO sk-entity-change=ctrl.onChangeModulo()></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Acaoprogramada.classeJava sk-required=true><sk-hbox gap=5 flex><sk-text-input sk-value=ctrl.nameClass sk-enabled=false flex></sk-text-input><button default small svg-src=/mge/assets/svg/binary-code.svg ng-click=\"ctrl.openPopUpClasses(value['moduloJava'])\" tooltip=Commons.Acaoprogramada.selecaoClasses sk-i18n class=btn-binary-code></button> <a href=/mge/bibliotecas/SankhyaW-extensions.jar style=\"margin-top: 5px\" sk-i18n>Commons.Acaoprogramada.baixarExtencoes</a></sk-hbox></sk-simple-item></sk-simple-form></sk-viewstack-content><sk-viewstack-content><sk-simple-form no-padding sk-columns=1 flex><sk-simple-item sk-label=Commons.Acaoprogramada.nomerotina sk-required=true><sk-hbox gap=10><sk-text-input sk-value=\"value['procName']\" sk-disabled=ctrl.enablenaNomeProc sk-change=ctrl.runOnChange() sk-display-as-upper-case=true flex></sk-text-input><sk-hbox gap=10><sk-icon sk-i18n tooltip=Commons.Acaoprogramada.criarTpl tooltip-placement=right svg-src=/mge/assets/svg/addproc.svg sk-height=25 sk-width=25 style=\"cursor: pointer\" sk-disabled=ctrl.enablenaNomeProc ng-click=ctrl.addProc()></sk-icon><sk-icon sk-i18n tooltip=Commons.Acaoprogramada.removertpl tooltip-placement=right svg-src=/mge/assets/svg/dropproc.svg sk-height=25 sk-width=25 style=\"cursor: pointer\" sk-disabled=!ctrl.enablenaNomeProc ng-click=ctrl.removeProc()></sk-icon></sk-hbox></sk-hbox></sk-simple-item></sk-simple-form></sk-viewstack-content><sk-viewstack-content sk-bg-color=#EEEEEE><sk-hbox ng-if=\"ctrl.linguagens.length > 1\" align=\"start center\" class=bloco-code gap=5><a class=link ng-click=ctrl.openPopUp() ng-if=ctrl.enableScriptLink><span sk-i18n>Commons.Acaoprogramada.lblLinguagem</span> </a><span ng-if=!ctrl.enableScriptLink sk-i18n>Commons.Acaoprogramada.lblLinguagem</span> :<sk-combobox sk-value=\"value['linguagem']\" sk-options=ctrl.linguagens sk-allow-null=false sk-change=\"ctrl.changeLinguagem(value['linguagem'])\" sk-width=200px sk-padding-left=5px></sk-combobox><sk-icon ng-if=helpScript font-icon=question-sign ng-click=ctrl.clickHelpScript() tooltip=Commons.Acaoprogramada.tooltipHelp sk-i18n></sk-icon><div ng-transclude=customElementScript></div></sk-hbox><sk-code-editor id={{::codeEditorID}} ng-style=\"ctrl.linguagens.length > 1 && {'height': height} || {'height': '185px'}\" sk-creation-complete=ctrl.creationCompleteEditor(editor) sk-mode=plain_text sk-value=\"value['script']\" sk-change=ctrl.runOnChange()></sk-code-editor></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/acaoprogramada/acaoprogramadascriptlink/acaoprogramadapopup.tpl.html",
    "<sk-acao-programada sk-contexto={{context}} sk-linguagens-value=ctrl.linguagensValue sk-value=ctrl.valueScript sk-change=ctrl.expressionChange() is-banco-dados=false is-java=false is-script=true sk-enable-script-link=false sk-height=440 sk-help-script=ctrl.helpScript></sk-acao-programada>");
  $templateCache.put("commons/acaoprogramada/popUp/classeJavaPopUp.tpl.html",
    "<sk-vbox flex class=acao-programada gap=5><span ng-bind-html=ctrl.msgAtencaoClasse></span><div class=list-class flex><div class=border-bottom ng-repeat=\"action in ctrl.actions\" ng-click=ctrl.adicionar(action.className.$) ng-dblclick=ctrl.saveClass() ng-class=\"{'active': action.selected}\" style=\"cursor: pointer\"><span ng-bind=action.className.$></span></div></div></sk-vbox>");
  $templateCache.put("commons/agendamentoBase/abaFrequencia/aba-frequencia.tpl.html",
    "<sk-vbox flex><sk-config-frequencia-panel sk-dataset=ctrl.dsAgendamento sk-tipo-agendamento=ctrl.tipoagendamento></sk-config-frequencia-panel></sk-vbox>");
  $templateCache.put("commons/agendamentoBase/agendamento-base.tpl.html",
    "<sk-vbox><sk-dynaform sk-entity-name=AgendamentoTarefa sk-on-dynaform-loaded=ctrl.onDynaformLoaded(dynaform,dataset) sk-helper-class-name={{ctrl.helperClassName}} sk-custom-tabs-loader=ctrl.customTabsLoader(entityName) sk-use-ds-criteria-in-entity-search=true sk-custom-criteria-loader=ctrl.getCriteria() sk-dynaform-interceptor=ctrl sk-form-interceptor=ctrl sk-datagrid-interceptor=ctrl sk-height=100% sk-width=100% sk-position=absolute><dynaform-agendamento-tarefa><sk-left-top-bar><button class=\"btn btn-default\" tooltip=\"Executar Agora\" tooltip-placement=bottom tooltip-append-to-body=true ng-click=ctrl.executarAgora() ng-show=ctrl.showExecutarAgora()><sk-icon font-icon=play></sk-icon>Executar Agora</button></sk-left-top-bar></dynaform-agendamento-tarefa></sk-dynaform></sk-vbox>");
  $templateCache.put("commons/alertContratosPendentes/alertContratosPendentes.tpl.html",
    "<sk-dataset id=dsContratoReajuste entity-name=ProdutoServicoContrato sk-dataset-created=onDatasetCreated(dataset) crud-listener=br.com.sankhya.mgeserv.model.helpper.ProdutoServicoContratoCRUDListener><sk-field pattern=NUMCONTRATO></sk-field></sk-dataset><div><button class=\"btn btn-default\" ng-show=showBtnAlert ng-click=showContratosPendentes() tooltip={{tooltip}} tooltip-placement=bottom tooltip-append-to-body=true sk-i18n><sk-icon class=pulse svg-src=/mge/assets/svg/yellow-warning.svg></button></div>");
  $templateCache.put("commons/alertContratosPendentes/contratosPendentes.tpl.html",
    "<sk-dataset sk-dataset-created=\"ctrl.onDatasetCreated('dsContratosPendentes', dataset)\" sk-standalone><sk-dsfield-md name=NUMCONTRATO description=Commons.AlertContratosPendentes.lblNumContrato user-type=I order=1></sk-dsfield-md><sk-dsfield-md name=CODPARC description=Commons.AlertContratosPendentes.lblParceiro user-type=I order=3></sk-dsfield-md><sk-dsfield-md name=NOMEPARC description=Commons.AlertContratosPendentes.lblNomeParceiro user-type=S order=4></sk-dsfield-md><sk-dsfield-md name=DTBASEREAJ description=Commons.AlertContratosPendentes.lblDtBaseReajuste user-type=D order=5></sk-dsfield-md><sk-dsfield-md name=FREQREAJ description=Commons.AlertContratosPendentes.lblFreqReajuste user-type=I order=6></sk-dsfield-md><sk-dsfield-md name=CODMOEDA description=Commons.AlertContratosPendentes.lblMoeda user-type=I order=7></sk-dsfield-md><sk-dsfield-md name=NOMEMOEDA description=Commons.AlertContratosPendentes.lblNomeMoeda user-type=S order=8></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-hbox gap=8><sk-taskbar sk-config-name={{::ctrl.gridContratosPendentesConfig}} sk-navigator-options=ctrl.navOptions sk-datagrid=ctrl.dgContratosPendentes sk-dataset=ctrl.dsContratosPendentes sk-hide-entity-attach=true sk-hide-buttons-config=true sk-hide-entity-search-field=true sk-hide-personalized-filter-button=true><sk-right-container><sk-grid-printer sk-margin-left=5px sk-grid-controller=ctrl.dgContratosPendentes sk-custom-entity=true></sk-grid-printer></sk-right-container></sk-taskbar></sk-hbox><sk-datagrid sk-grid-config={{::ctrl.gridContratosPendentesConfig}} sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgContratosPendentes',datagrid)\" sk-dataset=ctrl.dsContratosPendentes sk-editable=false sk-on-dbl-click=ctrl.dblClickContrato()></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/aliquotaicms/popupparametrosfiltroaliquotaicms.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1><sk-simple-group sk-label=Comercial.AliquotaICMS.lblOrigemDestino><sk-simple-item sk-label=Comercial.AliquotaICMS.ufOrigem sk-required=true><sk-pesquisa-input sk-entity-name=UnidadeFederativaOrigem sk-value=ctrl.codUfOrigem sk-field-name=UFORIG></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Comercial.AliquotaICMS.ufDestino sk-required=true><sk-pesquisa-input sk-entity-name=UnidadeFederativaDestino sk-value=ctrl.codUfDestino sk-field-name=UFDEST></sk-pesquisa-input></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox><sk-vbox sk-scroll-container flex class=popup-parametros-aliquota-icms-container><span class=parametros-text sk-i18n>Comercial.AliquotaICMS.lblParametros</span><sk-vbox gap=5><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaProduto sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaProduto, 'codProduto')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaProduto = !ctrl.usaProduto\">Comercial.AliquotaICMS.porProduto</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=Produto sk-value=ctrl.codProduto sk-field-name=CODPROD sk-enabled=ctrl.usaProduto></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaGrupoProduto sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaGrupoProduto, 'codGrupoProduto')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaGrupoProduto = !ctrl.usaGrupoProduto\">Comercial.AliquotaICMS.porGrupoICMS</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=GrupoProduto sk-value=ctrl.codGrupoProduto sk-field-name=CODGRUPOPROD sk-enabled=ctrl.usaGrupoProduto></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaPerfilPrincipal sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaPerfilPrincipal, 'codPerfil')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaPerfilPrincipal = !ctrl.usaPerfilPrincipal\">Comercial.AliquotaICMS.porPerfilPrincipal</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=Perfil sk-value=ctrl.codPerfil sk-field-name=CODTIPPARC sk-enabled=ctrl.usaPerfilPrincipal></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaTop sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaTop, 'tipoOperacao')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaTop = !ctrl.usaTop\">Comercial.AliquotaICMS.porTop</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=TipoOperacao sk-value=ctrl.tipoOperacao sk-field-name=CODTIPOPER sk-enabled=ctrl.usaTop></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaCidOrigem sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaCidOrigem, 'codCidOrigem')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaCidOrigem = !ctrl.usaCidOrigem\">Comercial.AliquotaICMS.porCidadeOrigem</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=Cidade sk-value=ctrl.codCidOrigem sk-field-name=CODCID sk-enabled=ctrl.usaCidOrigem></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaCidDestino sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaCidDestino, 'codCidDestino')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaCidDestino = !ctrl.usaCidDestino\">Comercial.AliquotaICMS.porCidadeDestino</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=Cidade sk-value=ctrl.codCidDestino sk-field-name=CODCID sk-enabled=ctrl.usaCidDestino></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaEmpresa sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaEmpresa, 'codEmpresa')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaEmpresa = !ctrl.usaEmpresa\">Comercial.AliquotaICMS.porCodigoEmpresa</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=Empresa sk-value=ctrl.codEmpresa sk-field-name=CODEMP sk-enabled=ctrl.usaEmpresa></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaFinOperacao sk-true-value=true sk-false-value=false sk-change=\"ctrl.clearValue(ctrl.usaFinOperacao, 'finOperacao')\"></sk-switch><sk-i18n ng-click=\"ctrl.usaFinOperacao = !ctrl.usaFinOperacao\">Comercial.AliquotaICMS.porFinalidadeOperacao</sk-i18n></sk-hbox><sk-pesquisa-input flex sk-entity-name=FinalidadeOperacao sk-value=ctrl.finOperacao sk-field-name=NUFOP sk-enabled=ctrl.usaFinOperacao></sk-pesquisa-input></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaGrupoIcmsParceiro sk-true-value=true sk-false-value=false></sk-switch><sk-i18n ng-click=\"ctrl.usaGrupoIcmsParceiro = !ctrl.usaGrupoIcmsParceiro\">Comercial.AliquotaICMS.porGrupoICMSParceiro</sk-i18n></sk-hbox><sk-combobox flex sk-value=ctrl.cbxGrupoIcmsParceiro sk-options=ctrl.cbxGrupoIcmsParceiroOpts sk-enabled=ctrl.usaGrupoIcmsParceiro></sk-combobox></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5 sk-true-value=true sk-false-value=false><sk-switch sk-value=ctrl.usaGrupoIcmsProduto sk-true-value=true sk-false-value=false></sk-switch><sk-i18n ng-click=\"ctrl.usaGrupoIcmsProduto = !ctrl.usaGrupoIcmsProduto\">Comercial.AliquotaICMS.porGrupoICMSProduto</sk-i18n></sk-hbox><sk-combobox flex sk-value=ctrl.cbxGrupoIcmsProduto sk-options=ctrl.cbxGrupoIcmsProdutoOpts sk-enabled=ctrl.usaGrupoIcmsProduto></sk-combobox></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaGrupoIcms2 sk-true-value=true sk-false-value=false></sk-switch><sk-i18n ng-click=\"ctrl.usaGrupoIcms2 = !ctrl.usaGrupoIcms2\">Comercial.AliquotaICMS.porGrupoICMS2</sk-i18n></sk-hbox><sk-combobox flex sk-value=ctrl.cbxGrupoIcms2 sk-options=ctrl.cbxGrupoIcms2Opts sk-enabled=ctrl.usaGrupoIcms2></sk-combobox></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaGrupoIcmsGrupoProduto sk-true-value=true sk-false-value=false></sk-switch><sk-i18n ng-click=\"ctrl.usaGrupoIcmsGrupoProduto = !ctrl.usaGrupoIcmsGrupoProduto\">Comercial.AliquotaICMS.porGrupoICMSGrupoProduto</sk-i18n></sk-hbox><sk-combobox flex sk-value=ctrl.cbxGrupoIcmsGrupoProduto sk-options=ctrl.cbxGrupoIcmsGrupoProdutoOpts sk-enabled=ctrl.usaGrupoIcmsGrupoProduto></sk-combobox></sk-hbox><sk-hbox flex><sk-hbox flex layout-align=\"start center\" gap=5><sk-switch sk-value=ctrl.usaTare sk-true-value=true sk-false-value=false></sk-switch><sk-i18n ng-click=\"ctrl.usaTare = !ctrl.usaTare\">Comercial.AliquotaICMS.porTare</sk-i18n></sk-hbox></sk-hbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/analiseEnvioExpedicao/analiseEnvioExpedicao.tpl.html",
    "<sk-wizard id=analiseEnvioPanelWizard sk-hide-indicators=true ng-if=ctrl.loadingComplete sk-context=ctrl.wizardContext sk-on-create=ctrl.onLoadWizard(wizard) sk-on-cancel=ctrl.onCancel() sk-on-finish=ctrl.onFinish($step) sk-hide-btn-cancel=true sk-creation-policy=lazy sk-intercept-visible-step=true style={{ctrl.styleWizard}} layout=column><sk-step sk-hide-previous=true sk-hide-next=true sk-hide-finish=true layout=column sk-template-url=commons/analiseEnvioExpedicao/step/analiseEnvioExpedicaostep.tpl.html sk-validate-step=ctrl.validateStep() sk-controller=AnaliseEnvioExpedicaoStepController sk-controller-as=ctrl flex></sk-step></sk-wizard>");
  $templateCache.put("commons/analiseEnvioExpedicao/step/analiseEnvioExpedicaostep.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreatedResultAnaliseEnvio(dataset) entity-name=ResultadoAnaliseEnvioExpedicao id=dsResultAnaliseEnvio><sk-field pattern=CODPROD,DESCRPROD,REFERENCIA,CONTROLE,UNIDADE,SITUACAO,SOLUCAO,ROTINA,QTDNEG,CHAVEROTINA></sk-field></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetCreatedAnaliseEnvioDocs(dataset) entity-name=AnaliseEnvioExpedicaoDocs parent-dataset=ctrl.dsResultAnaliseEnvio><sk-field pattern=NUNOTA,NUMNOTA,CODEMP,NOMEFANTASIA,ORDEMCARGA,CODVEICULO,CODREG,CODPARCTRANSP,CODPARC,NOMEPARC read-only=true></sk-field></sk-dataset><sk-hbox flex><sk-vbox flex><sk-vbox flex><sk-hbox layout-padding button-container><label sk-font-size=12px layout layout-align=left sk-i18n=\"Análise de Envio de Expedição\"></label><div class=clearfix flex></div></sk-hbox><sk-space sk-height=5px></sk-space><sk-hbox layout-padding button-container><sk-simple-form sk-in-line=true sk-columns=6 sk-width=100%><sk-simple-item style=\"width: 10% !important\"><button class=\"btn btn-default\" ng-click=ctrl.voltarFormacaoCarga() default sk-i18n><sk-icon sk-padding-left=3px font-icon=arrow-left></sk-icon><sk-i18n>Formação Carga</sk-i18n></button></sk-simple-item><sk-simple-item verticalalign=center sk-i18n sk-label=\"Ordem de Carga\" style=\"width: 13% !important\"><sk-pesquisa-input sk-value=ctrl.ordemCarga sk-entity-name=OrdemCarga sk-field-name=ORDEMCARGA sk-show-description-input=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-i18n sk-label=Pedido/Nota style=\"width: 13% !important\"><sk-number-input sk-value=ctrl.nuNota sk-field-name=NUNOTA></sk-number-input></sk-simple-item><sk-simple-item sk-padding-left=10px style=\"width: 10% !important\"><button class=\"btn btn-success\" id=btnGerar ng-click=ctrl.gerarAnalise() ng-disabled=ctrl.verificaNuNotaOrdemCarga() default sk-i18n><sk-icon style=\"color: #ffffff\" sk-padding-left=3px font-icon=play></sk-icon><sk-i18n>Gerar Análise</sk-i18n></button></sk-simple-item><sk-hbox class=right-container layout=row layout-align=\"end none\"><sk-span ng-if=ctrl.wasProcessed sk-padding-top=5px style=\"text-align: left; display: inline-block\"><sk-icon font-icon=circle-question-mark></sk-icon><b sk-padding-left=2px>Dê um duplo clique em dos registros abaixo, para ser redirecionado para a rotina e concluir a correção.</b></sk-span></sk-hbox></sk-simple-form></sk-hbox><sk-space sk-height=8px></sk-space><sk-hbox layout-padding button-container><label sk-font-size=12px layout layout-align=left sk-margin=0px flex sk-i18n=\"Resultado da Análise\"></label></sk-hbox><sk-double-face-panel id=resultAnaliseEnvio sk-dataset=ctrl.dsResultAnaliseEnvio sk-change-button-actions=ctrl.changeButtonActionsResultEnvio sk-default-face-index=GRID_FACE flex><sk-top-bar layout-padding><sk-hbox class=left-container layout-align=\"start center\" gap=3 layout-wrap flex><sk-navigator button-container dataset=ctrl.dsResultAnaliseEnvio sk-show-navigation=true sk-show-refresh-button=true sk-show-copy-button=false sk-show-add-button=false sk-show-remove-button=false sk-show-save-button=false sk-show-cancel-button=false sk-show-edit-button=false></sk-navigator><div class=clearfix flex></div><sk-rows-counter sk-dataset=ctrl.dsResultAnaliseEnvio></sk-rows-counter></sk-hbox></sk-top-bar><sk-face-one><sk-form layout-padding flex style=\"overflow: auto\" sk-form-interceptor=ctrl sk-only-custom sk-dataset=ctrl.dsResultAnaliseEnvio><sk-form-custom-item required sk-field-name=CODPROD><sk-number-input sk-field-name=CODPROD sk-required=false style=\"max-width: 12% !important\" sk-dataset=ctrl.dsResultAnaliseEnvio sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=DESCRPROD><sk-text-input sk-field-name=DESCRPROD sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 12% !important\" sk-enabled=false></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=REFERENCIA><sk-text-input sk-field-name=REFERENCIA sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 12% !important\" sk-enabled=false></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CONTROLE><sk-text-input sk-field-name=CONTROLE sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 12% !important\" sk-enabled=false></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=UNIDADE><sk-text-input sk-field-name=UNIDADE sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 12% !important\" sk-enabled=false></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=QTDNEG><sk-number-input sk-field-name=QTDNEG sk-required=false style=\"max-width: 12% !important\" sk-dataset=ctrl.dsResultAnaliseEnvio sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=SITUACAO sk-enabled=false><sk-text-area sk-field-name=SITUACAO sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 25% !important\" sk-enabled=false></sk-text-area></sk-form-custom-item><sk-form-custom-item sk-field-name=SOLUCAO sk-enabled=false><sk-text-area sk-field-name=SOLUCAO sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 25% !important\" sk-enabled=false></sk-text-area></sk-form-custom-item><sk-form-custom-item sk-field-name=ROTINA sk-enabled=false><sk-text-area sk-field-name=ROTINA sk-dataset=ctrl.dsResultAnaliseEnvio style=\"max-width: 25% !important\" sk-enabled=false></sk-text-area></sk-form-custom-item></sk-form></sk-face-one><sk-face-two><sk-datagrid sk-editable=false id=dgResultAnaliseEnvio sk-dataset=ctrl.dsResultAnaliseEnvio sk-on-datagrid-loaded=ctrl.onDatagridLoadedResultAnaliseEnvio(datagrid) sk-on-dbl-click=ctrl.dbClickResultAnaliseEnvio(resultAnaliseEnvio) sk-grid-config=\"{{ ::ctrl.gridConfigIdResultAnaliseEnvio }}\" flex><sk-datagrid-custom-column sk-field-name=CODPROD></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DESCRPROD></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=REFERENCIA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CONTROLE></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=UNIDADE></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=SITUACAO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=SOLUCAO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ROTINA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=QTDNEG></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=SEQUENCIA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NUNOTA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CHAVEROTINA sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-face-two></sk-double-face-panel></sk-vbox><sk-vbox flex><sk-hbox layout-padding button-container><label sk-font-size=12px layout layout-align=left sk-margin=0px flex sk-i18n=Notas/Pedidos></label></sk-hbox><sk-space sk-height=8px></sk-space><sk-double-face-panel id=analiseEnvioDocs sk-dataset=ctrl.dsAnaliseEnvioDocs sk-change-button-actions=ctrl.changeButtonActionAnaliseEnvioDocs sk-default-face-index=GRID_FACE flex><sk-top-bar layout-padding><sk-hbox class=left-container layout-align=\"start center\" gap=3 layout-wrap flex><sk-navigator dataset=ctrl.dsAnaliseEnvioDocs sk-show-navigation=true sk-show-refresh-button=true sk-show-copy-button=false sk-show-add-button=false sk-show-remove-button=false sk-show-save-button=true sk-show-cancel-button=true sk-show-edit-button=false></sk-navigator><div class=clearfix flex></div><sk-rows-counter sk-dataset=ctrl.dsAnaliseEnvioDocs></sk-rows-counter></sk-hbox></sk-top-bar><sk-face-one><sk-form layout-padding style=\"overflow: auto\" sk-only-custom sk-dataset=ctrl.dsAnaliseEnvioDocs><sk-form-custom-item required sk-field-name=NUNOTA><sk-number-input sk-field-name=NUNOTA style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=NUMNOTA><sk-number-input sk-field-name=NUMNOTA style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODEMP><sk-number-input sk-field-name=CODEMP style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=NOMEFANTASIA><sk-text-input sk-field-name=NOMEFANTASIA style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=ORDEMCARGA><sk-number-input sk-field-name=ORDEMCARGA style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODPARCTRANSP><sk-number-input sk-field-name=CODPARCTRANSP style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODVEICULO><sk-number-input sk-field-name=CODVEICULO style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODREG><sk-number-input sk-field-name=CODREG style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODPARC><sk-number-input sk-field-name=CODPARC style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=NOMEPARC><sk-text-input sk-field-name=NOMEPARC style=\"max-width: 12% !important\" sk-dataset=ctrl.dsAnaliseEnvioDocs sk-enabled=false></sk-text-input></sk-form-custom-item></sk-form></sk-face-one><sk-face-two><sk-datagrid id=dgAnaliseEnvioDocs sk-editable=false sk-dataset=ctrl.dsAnaliseEnvioDocs sk-on-datagrid-loaded=ctrl.onDatagridLoadedAnaliseEnvioDocs(datagrid) sk-on-dbl-click=ctrl.dbClickAnaliseEnvioDocs(analiseEnvioDocs) sk-grid-config=\"{{ ::ctrl.gridConfigIdAnaliseEnvioDocs }}\" flex><sk-datagrid-custom-column sk-field-name=NUNOTA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NUMNOTA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODEMP></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ResultadoAnaliseEnvioExpedicao.DESCRPROD sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ORDEMCARGA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NOMEFANTASIA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODVEICULO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODREG></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPARCTRANSP></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPARC></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NOMEPARC></sk-datagrid-custom-column></sk-datagrid></sk-face-two></sk-double-face-panel></sk-vbox></sk-vbox></sk-hbox>");
  $templateCache.put("commons/armazem/searchFieldCustom/search-field-custom.tpl.html",
    "<sk-search-input sk-value=codeValuePresentation sk-on-click=onCodeInputClick sk-keydown=onCodeKeyDown($event) sk-change=onCodeInputChange() sk-enabled=enabled sk-search-tooltip={{tooltip}} sk-placeholder={{defaultPlaceholder}} sk-focus-out=onCodeInputFocusOut() flex></sk-search-input>");
  $templateCache.put("commons/attach/PopUpAnexoLink.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1 style=width:100% sk-in-line=true><sk-simple-item sk-label=Descrição: sk-required=true><sk-text-input sk-value=ctrl.descricaoArquivo sk-change=ctrl.onChangeCampos() sk-enabled=!ctrl.isAlteracao></sk-text-input></sk-simple-item><sk-simple-item sk-label=Link: sk-required=true><sk-text-input sk-value=ctrl.caminhoArquivo sk-change=ctrl.onChangeCampos()></sk-text-input></sk-simple-item><label style=\"padding-left: 15px\">Ex.: http://exemplo/Arquivo_Teste.pdf</label><sk-simple-item><button sk-i18n default ng-click=ctrl.salvar() tooltip=Salvar sk-margin-bottom=0px ng-disabled=!ctrl.enableBtnSalvar><span sk-i18n=Salvar></span></button></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/attach/PopUpAnexosRepositorio.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1 style=width:100% sk-in-line=true><sk-simple-item sk-label=Descrição: sk-required=true><sk-text-input sk-value=ctrl.descricaoArquivo sk-change=ctrl.onChangeCampos() sk-enabled=!ctrl.isAlteracao></sk-text-input></sk-simple-item><sk-simple-item sk-label=\"Caminho do Arquivo:\" sk-required=true><sk-text-input sk-value=ctrl.caminhoArquivo sk-change=ctrl.onChangeCampos()></sk-text-input></sk-simple-item><label style=\"padding-left: 15px\">Ex.: Repo://exemplo/Arquivo Teste.pdf</label><sk-simple-item><button sk-i18n default ng-click=ctrl.salvar() tooltip=Salvar ng-disabled=!ctrl.enableBtnSalvar><span sk-i18n=Salvar></span></button></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/atualizacaocusto/custo-grade-produto-popup.tpl.html",
    "<sk-dataset entity-name=Custo sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-field pattern=*></sk-field><sk-field pattern=LISCONTEST path=Produto></sk-field><sk-field pattern=TIPCONTEST path=Produto></sk-field><sk-field pattern=TITCONTEST path=Produto></sk-field><sk-field pattern=DESCRPROD path=Produto></sk-field><sk-field pattern=NOMEFANTASIA path=Empresa></sk-field><sk-field pattern=DESCRLOCAL path=LocalFinanceiro></sk-field></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-dsfield-md name=CONTROLE description=CONTROLE user-type=S visible></sk-dsfield-md><sk-dsfield-md name=DESCRCONTROLE description=Grade user-type=S width=250></sk-dsfield-md></sk-dataset><sk-hbox flex><sk-form sk-dataset=ctrl.dsCusto sk-form-interceptor=ctrl sk-fields-order=ctrl.fields flex=60></sk-form><sk-datagrid sk-dataset=ctrl.dsGrade sk-config-name=\"{{ ::ctrl.gridConfigId }}\" sk-editable=false sk-datagrid-interceptor=ctrl sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-allow-multiple-selection=true sk-hide-cbx-column=false sk-disable-pagination=true sk-disable-search=true flex=40></sk-datagrid></sk-hbox>");
  $templateCache.put("commons/avaliacaoCapacidade/avaliacaoCapacidade.tpl.html",
    "<sk-vbox flex layout=column style=z-index:1 sk-height=100% sk-width=100%><sk-hbox ng-show=!ctrl.hideTitle sk-bg-color=#F0F0F0 gap=8 sk-padding=6px sk-border-bottom=\"1px solid #ccc\"><sk-hbox flex><sk-hbox flex=10 gap=5><button default small class=\"btn btn\" ng-click=ctrl.fechar() tooltip=Commons.AvaliacaoCapacidadeMps.lblVoltar tooltip-placement=bottom sk-i18n><sk-icon font-icon=arrow-left></sk-icon></button></sk-hbox><sk-hbox flex layout-align=\"center center\"><h4 sk-i18n tooltip-placement=bottom>Commons.AvaliacaoCapacidadeMps.titleCargaMaquina</h4></sk-hbox><sk-hbox flex=10 gap=5 class=box-refresh><button default small class=btn ng-click=ctrl.update() ng-disabled=\"ctrl.paineisCarregando.size > 0\" tooltip=Commons.AvaliacaoCapacidadeMps.lblAtualizar tooltip-placement=left sk-margin-left=5px sk-i18n><sk-icon font-icon=refresh></sk-icon></button></sk-hbox></sk-hbox></sk-hbox><sk-hbox flex layout=row style=\"z-index:1;padding-right: 0px\" sk-height=100% sk-width=100% layout-padding><sk-vbox flex class=sessao-principal><sk-hbox flex=85 class=\"card-charts chart-wrapper\"><div class=chart id=chartAvaliacaoCapacidade></div></sk-hbox><div flex=15 layout=\"row reverse\" layout-align=\"space-between center\" class=container-cards><sk-minicard sk-width=23% sk-hide-percentage=true sk-chart-name={{ctrl.chartMinicardHorasDisponiveis}} sk-title=Commons.AvaliacaoCapacidadeMps.tituloHorasDisponiveis on-load=\"ctrl.onLoadGrafico($component, $grafico)\"></sk-minicard><sk-minicard sk-width=23% sk-hide-percentage=true sk-chart-name={{ctrl.chartMinicardDemandasHoras}} sk-title=Commons.AvaliacaoCapacidadeMps.tituloDemandaHoras on-load=\"ctrl.onLoadGrafico($component, $grafico)\"></sk-minicard><sk-minicard sk-width=23% sk-hide-percentage=true sk-chart-name={{ctrl.chartMinicardCategoriaMaisUtilizada}} sk-is-percentage=true on-load=\"ctrl.onLoadGrafico($component, $grafico)\"></sk-minicard><sk-minicard sk-width=23% sk-hide-percentage=true sk-chart-name={{ctrl.chartMinicardCategoriaMaisDisponivel}} sk-is-percentage=true on-load=\"ctrl.onLoadGrafico($component, $grafico)\"></sk-minicard></div></sk-vbox><sk-vbox layout flex layout-padding class=lateral-esquerda><sk-vbox flex><sk-hbox flex=25 class=chart-wrapper layout-bottom-margin><div class=chart id=chartPercentualCargaGeral sk-width=90%></div></sk-hbox><sk-vbox flex=38 class=\"card-top5 ocupado\" layout-bottom-margin><p sk-i18n>Commons.AvaliacaoCapacidadeMps.tituloTop5Ocupados</p><div flex ng-repeat=\"disponibilidade in ctrl.listaTopOcupacao track by $index\"><sk-hbox flex><span flex class=descricao-item tooltip={{disponibilidade.nomeCategoriaCT}}>{{disponibilidade.nomeCategoriaCT}}</span> <span flex class=valor-item>{{disponibilidade.percentualOcupacaoStr}}%</span></sk-hbox></div></sk-vbox><sk-vbox flex=35 class=\"card-top5 disponivel\"><p sk-i18n class=header>Commons.AvaliacaoCapacidadeMps.tituloTop5Disponiveis</p><div flex ng-repeat=\"ocupacao in ctrl.listaTopDisponibilidade track by $index\"><sk-hbox flex><span flex class=descricao-item tooltip={{ocupacao.nomeCategoriaCT}}>{{ocupacao.nomeCategoriaCT}}</span> <span flex class=valor-item>{{ocupacao.percentualOcupacaoStr}}%</span></sk-hbox></div></sk-vbox></sk-vbox></sk-vbox></sk-hbox></sk-vbox>");
  $templateCache.put("commons/baixa/cabecalho/cabecalho-baixa.tpl.html",
    "<sk-top-bar layout=row layout-padding><sk-hbox gap=15 align=\"start center\" layout-align=\"center center\" flex><sk-hbox ng-if=ctrl.botaoVerFinanceiroVisible><button class=\"btn btn-default\" ng-click=ctrl.verFinanceiro() ng-disabled=!ctrl.botaoVerFinanceiroEnabled><sk-icon font-icon=arrow-left></sk-icon>{{ctrl.labelVerFinanceiro}}</button></sk-hbox><sk-hbox gap=5 ng-if=ctrl.labelNufinVisible><span ng-bind=ctrl.labelNumUnico></span> <span class=text-bold ng-bind=ctrl.nufin></span></sk-hbox><sk-hbox gap=5><span ng-bind=ctrl.labelDesdob></span> <span class=text-bold ng-bind=ctrl.desdob></span></sk-hbox><sk-hbox layout-top-padding gap=8><span ng-bind=ctrl.labelVcto></span><span class=required>*</span> <span class=text-bold ng-bind=ctrl.dtVencimento></span></sk-hbox><sk-hbox layout-top-padding gap=8><span ng-bind=ctrl.labelDtBaixa></span><span class=required>*</span></sk-hbox><sk-date-input sk-value=ctrl.dtBaixa sk-focus-out=ctrl.changeDataBaixa() sk-enabled=ctrl.enabledChangeDtBaixa></sk-date-input><sk-hbox gap=5 ng-if=ctrl.visibleDiasAtraso><span sk-color=red ng-bind=ctrl.labelAtraso></span> <span class=text-bold sk-color=red ng-bind=ctrl.diasAtraso></span></sk-hbox></sk-hbox><div layout=row layout-align=\"end center\"><span class=text-bold sk-i18n>Commons.Baixa.titleBaixaTitulos</span></div></sk-top-bar><sk-top-bar ng-if=ctrl.visibleDiferenca><div layout-padding layout=row><sk-hbox gap=10><span class=text-bold sk-i18n>Commons.Baixa.labelBaixaSuperiorTitulo</span> <span class=text-bold sk-color=red ng-bind=ctrl.labelDiferencaTitulo></span></sk-hbox></div></sk-top-bar><sk-top-bar ng-if=ctrl.visibleVlrMenor><div layout-padding layout=row><sk-hbox gap=10><span class=text-bold ng-bind=ctrl.labelBaixaInferior></span></sk-hbox></div></sk-top-bar>");
  $templateCache.put("commons/baixa/panel/baixapanel.tpl.html",
    "<sk-wizard id=baixaPanelWizard sk-hide-indicators=true ng-if=ctrl.loadingComplete sk-context=ctrl.wizardContext sk-on-create=ctrl.onLoadWizard(wizard) sk-on-cancel=ctrl.onCancel() sk-on-finish=ctrl.onFinish($step) sk-hide-btn-cancel=ctrl.wizardContext.hideBtnCancel sk-creation-policy=lazy sk-intercept-visible-step=true sk-disable-key-down=true style={{ctrl.styleWizard}} layout=column><sk-step sk-hide-previous=true sk-hide-next=true sk-hide-finish=true layout=column sk-template-url=commons/baixa/panel/step/baixastep.tpl.html sk-validate-step=ctrl.validateStep() sk-controller=BaixaStepController sk-controller-as=ctrl flex></sk-step><sk-step sk-next-label=Geral.buttonBaixar sk-hide-previous=false sk-hide-next=false sk-hide-finish=true layout=column sk-template-url=commons/baixa/panel/step/baixavlrmaiorstep.tpl.html sk-controller=BaixaVlrMaiorStepController sk-can-previous=true sk-controller-as=ctrl flex></sk-step><sk-step sk-next-label=Geral.buttonBaixar sk-hide-previous=false sk-hide-next=false sk-hide-finish=true sk-hide layout=column sk-template-url=commons/baixa/panel/step/baixavlrmenorstep.tpl.html sk-controller=BaixaVlrMenorStepController sk-can-previous=true sk-controller-as=ctrl flex></sk-step><sk-step sk-hide-previous=true sk-hide-next=true sk-hide-finish=true layout=column sk-template-url=commons/baixa/panel/step/baixandostep.tpl.html sk-controller=BaixandoStepController sk-controller-as=ctrl flex></sk-step><sk-step sk-previous-label=Geral.buttonBaixar sk-cancel-label=Geral.lblFechar sk-hide-previous=false sk-hide-next=true sk-hide-finish=true layout=column sk-template-url=commons/baixa/panel/step/liberacaostep.tpl.html sk-controller=LiberacaoBaixaStepController sk-controller-as=ctrl flex></sk-step><sk-step sk-hide-previous=true sk-hide-next=true sk-hide-finish=true layout=column sk-template-url=commons/baixa/panel/step/conclusaostep.tpl.html sk-controller=ConclusaoBaixaStepController sk-controller-as=ctrl flex></sk-step></sk-wizard>");
  $templateCache.put("commons/baixa/panel/popup/OutrosImpostosMensaisPopUp.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-dsfield-md name=codImposto description=Commons.Baixa.headerImposto user-type=I></sk-dsfield-md><sk-dsfield-md name=tipImp description=Commons.Baixa.headerTipoImposto user-type=S></sk-dsfield-md><sk-dsfield-md name=base description=Commons.Baixa.headerBase user-type=F></sk-dsfield-md><sk-dsfield-md name=aliquota description=Commons.Baixa.headerAliquota user-type=F></sk-dsfield-md><sk-dsfield-md name=valorRateado description=Commons.Baixa.headerValor user-type=F></sk-dsfield-md><sk-dsfield-md name=digitado description=Commons.Baixa.headerDigitado user-type=S></sk-dsfield-md></sk-dataset><sk-datagrid sk-dataset=ctrl.dsImpostosMensais sk-allow-multiple-selection=false sk-datagrid-interceptor=ctrl sk-disable-tour=true sk-editable=false></sk-datagrid><sk-footer-bar layout-top-padding><sk-hbox layout-padding layout-align=\"end center\" gap=10 flex><span class=text-bold sk-i18n>Commons.Baixa.headerTotOutImpMensais</span><span class=text-bold>:</span> <span class=text-bold ng-bind=ctrl.vlrTotalImpostos></span></sk-hbox></sk-footer-bar>");
  $templateCache.put("commons/baixa/panel/popup/alteracaotipotitulo/AlterarTipoTituloPopUp.tpl.html",
    "<sk-vbox gap=10 flex layout-padding><sk-label style=font-size:15px sk-value=ctrl.getString()></sk-label><sk-hbox gap=5 align=\"start center\"><sk-simple-form sk-columns=1><sk-simple-item ski18n sk-label=Commons.Baixa.labelTipoTitulo ski18n sk-help-tip=Commons.Baixa.labelHelpTipoTitulo sk-required=true><sk-pesquisa-input sk-entity-name=TipoTitulo sk-field-name=CODTIPTIT sk-value=ctrl.codTipTit sk-width=330px sk-enviroment-criteria=ctrl.getCriteria()></sk-pesquisa-input></sk-simple-item></sk-simple-form></sk-hbox></sk-vbox>");
  $templateCache.put("commons/baixa/panel/popup/pix/ReceberComPixPopUp.tpl.html",
    "<sk-vbox flex layout-padding><sk-viewstack layout flex><sk-viewstack-content layout flex ng-if=ctrl.abaQrcode><sk-vbox flex layout-align=center><sk-label style=\"text-align:center; font-size:15px\" sk-value='ctrl.getString(\"Commons.Baixa.qrCodeCriado\")'></sk-label><img src=data:image/png;base64,{{::ctrl.imagem}} height=280px width=280px class=center><div class=copiaCola><a class=\"lbl-link center\" ng-click=ctrl.copiarCodigo()><span sk-i18n>Commons.Baixa.copiarQr</span></a></div><sk-label class=text-center sk-value='ctrl.getString(\"Commons.Baixa.descPopupPix\")' sk-margin=\"10px 30px 0px 30px\"></sk-label><div class=wizard-modal-footer id=footer><div class=wizard-modal-footer-right><sk-span class=\"aguarde center\" sk-i18n>Commons.Baixa.buttonAguarde</sk-span><button class=\"btn btn-default\" ng-click=ctrl.onCancel()><sk-span sk-i18n>Commons.Baixa.buttonCancelar</sk-span></button></div></div></sk-vbox></sk-viewstack-content><sk-viewstack-content layout flex ng-if=ctrl.abaComprovante><sk-vbox flex><sk-vbox layout flex sk-margin-left=25px><sk-title sk-font-size=20px sk-padding-bottom=10px class=text-center><sk-icon svg-src=/mge/assets/svg/check-finish.svg style=min-width:20px></sk-icon></sk-title><sk-title sk-font-size=20px sk-padding-bottom=5px class=text-center><sk-i18n>Commons.Baixa.titlePixRecebido</sk-i18n></sk-title><sk-title sk-font-size=15px sk-padding-bottom=50px class=text-center><sk-span>{{ctrl.data}} {{ctrl.hora}}</sk-span></sk-title><sk-title sk-font-size=15px sk-padding-bottom=30px><sk-span>Valor: R${{ctrl.valor}}</sk-span></sk-title><sk-title sk-font-size=15px><sk-span>ID da Transação</sk-span><br><sk-span>{{ctrl.idTransacao}}</sk-span></sk-title></sk-vbox><div class=wizard-modal-footer id=footer><div class=wizard-modal-footer-right><button class=\"btn btn-default\" ng-click=ctrl.close(ctrl.comprovante)><sk-span sk-i18n>Commons.Baixa.buttonOk</sk-span></button></div></div></sk-vbox></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/baixa/panel/step/baixandostep.tpl.html",
    "<sk-vbox sk-height=100% sk-width=100%><sk-cabecalho-baixa ng-if=ctrl.isLoad sk-data=ctrl.dadosCabecalho sk-on-create-cabecalho-baixa=ctrl.onCreatedCabecalho(cabecalho) sk-show-botao-ver-financeiro=ctrl.showBotaoVerFinanceiro sk-on-click-ver-financeiro=ctrl.onClickVerFinanceiro()></sk-cabecalho-baixa><sk-vbox layout-padding sk-height=100% sk-width=100%><sk-vbox ng-if=ctrl.isBaixando layout-align=\"center center\" flex><span class=text-bold sk-i18n>Commons.Baixa.labelBaixando</span><div class=sk-loading-bar layout-align=\"center center\" style=\"position: relative; width: 400px\"><div class=bar-container><div class=bar1></div><div class=bar2></div></div></div></sk-vbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/baixa/panel/step/baixastep.tpl.html",
    "<sk-dataset entity-name=Financeiro sk-dataset-created=ctrl.onDatasetCreated(dataset) metadata-interceptor=ctrl.metadataInterceptor sk-standalone><sk-field pattern=*></sk-field><sk-field pattern=NOMEBCO path=Banco></sk-field><sk-field pattern=DESCRTIPTIT path=TipoTitulo></sk-field><sk-dsfield-md name=DTCHEQUE_CMC7 description=DTCHEQUE_CMC7></sk-dsfield-md></sk-dataset><sk-dataset entity-name=ImpostoFinanceiro sk-dataset-created=ctrl.onDatasetCreated(dataset) metadata-interceptor=ctrl.metadataInterceptor><sk-field pattern=*></sk-field><sk-field pattern=NOMEIMP path=Imposto></sk-field></sk-dataset><sk-cabecalho-baixa sk-data=ctrl.dataCabecalho sk-on-create-cabecalho-baixa=ctrl.onCreatedCabecalho(cabecalho) sk-show-botao-ver-financeiro=ctrl.showBotaoVerFinanceiro parent-instance=ctrl sk-on-click-ver-financeiro=ctrl.onClickVerFinanceiro()></sk-cabecalho-baixa><sk-accordion layout-top-padding layout-bottom-padding flex><sk-accordion-group heading={{ctrl.labelDadosBaixa}} is-open=true><sk-hbox flex><sk-vbox flex><sk-simple-form sk-in-line=true sk-columns=1 layout-top-padding><sk-simple-group sk-label=Commons.Impostos.labelImpostos><sk-simple-item sk-label=Commons.Baixa.labelIRRF><sk-hbox gap=10 layout-align=\"start center\"><sk-number-input sk-value=ctrl.vlrIRRF sk-enabled=ctrl.alteraImpostos sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrIRRF')\" sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrIRRF')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2></sk-number-input><sk-switch sk-value=ctrl.checkIRRF sk-true-value=true sk-false-value=false sk-enabled=ctrl.alteraImpostos sk-change=\"ctrl.addEventListener('CHANGE','checkIRRF')\"></sk-switch><span class=lblText ng-bind=ctrl.labelRetido></span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelINSS><sk-hbox gap=10 layout-align=\"start center\"><sk-number-input sk-value=ctrl.vlrINSS sk-enabled=ctrl.alteraImpostos sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrINSS')\" sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrINSS')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2></sk-number-input><sk-switch sk-value=ctrl.checkINSS sk-true-value=true sk-false-value=false sk-enabled=ctrl.alteraImpostos sk-change=\"ctrl.addEventListener('CHANGE','checkINSS')\"></sk-switch><span class=lblText ng-bind=ctrl.labelRetido></span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelISS><sk-hbox gap=10 layout-align=\"start center\"><sk-number-input sk-value=ctrl.vlrISS sk-enabled=ctrl.alteraImpostos sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrISS')\" sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrISS')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2></sk-number-input><sk-switch sk-value=ctrl.checkISS sk-true-value=true sk-false-value=false sk-enabled=ctrl.alteraImpostos sk-change=\"ctrl.addEventListener('CHANGE','checkISS')\"></sk-switch><span class=lblText ng-bind=ctrl.labelRetido></span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelVendor><sk-number-input sk-value=ctrl.vlrVendor sk-enabled=ctrl.alteraImpostos sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrVendor')\" sk-change=\"ctrl.addEventListener('CHANGE','vlrVendor')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelOutrosImpMensaisLongo><sk-hbox gap=10 layout-align=\"start center\"><sk-number-input sk-value=ctrl.vlrOutrosImpMensais sk-enabled=false sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2></sk-number-input><sk-switch sk-value=ctrl.checkReterImpostosRetroativos sk-true-value=true sk-false-value=false sk-enabled=ctrl.retencaoRetroativa></sk-switch><span class=lblText ng-bind=ctrl.labelRetido></span> <button default ng-click=ctrl.detalhesOutrosImpMensais() ng-disabled=!ctrl.btnDetalhesOutImpMenEnabled><sk-i18n>Commons.Baixa.labelDetalhesOutImpMen</sk-i18n></button></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Impostos.labelOutrosImpostos><sk-number-input sk-value=ctrl.vlrOutrosImp sk-enabled=false sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item></sk-simple-group></sk-simple-form><sk-simple-form sk-columns=1 layout-top-padding><sk-simple-group sk-label=Commons.Baixa.labelDadosAdicionaisBaixa sk-width=400><sk-simple-item sk-label=Commons.Baixa.labelEmpresa sk-required=true><sk-pesquisa-input sk-entity-name=Empresa sk-field-name=CODEMP sk-value=ctrl.empresa sk-enabled=ctrl.empresaEnabled sk-entity-change=ctrl.onChangeEmpresa()></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelTOP sk-required=true><sk-pesquisa-input sk-entity-name=TipoOperacao sk-field-name=CODTIPOPER sk-value=ctrl.top sk-enviroment-criteria=ctrl.getTipoOperacaoCriteria() sk-enabled=ctrl.topEnabled></sk-pesquisa-input></sk-simple-item></sk-simple-group></sk-simple-form><sk-simple-form sk-columns=1 layout-top-padding><sk-simple-group sk-label=Commons.Baixa.labelMovimentacaoBancaria><sk-simple-item sk-label=Commons.Baixa.labelConta sk-required=true><sk-hbox gap=10><sk-pesquisa-input sk-entity-name=ContaBancaria sk-value=ctrl.conta sk-enviroment-criteria=ctrl.environmentCriteriaContaBancaria() sk-enabled=ctrl.contaEnabled sk-entity-change=ctrl.changeConta(item)></sk-pesquisa-input><span class=lblText ng-bind=ctrl.labelVlrMoeda layout-align=\"start center\" ng-if=ctrl.hbValorMoedaVisible>:</span><sk-number-input sk-value=ctrl.valorMoeda sk-enabled=false sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=ctrl.paramDecVlrMoeda ng-if=ctrl.hbValorMoedaVisible></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelLancamento sk-required=true><sk-hbox gap=10><sk-pesquisa-input sk-entity-name=HistoricoBancario sk-value=ctrl.lancamento></sk-pesquisa-input><span class=lblText ng-bind=ctrl.labelDocumento layout-align=\"center center\"></span><sk-text-input sk-value=ctrl.documento sk-size=50></sk-text-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelHistorico><sk-text-area sk-value=ctrl.historico sk-size=ctrl.maxCharsTxtHistorico></sk-text-area></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDataConciliacao ng-if=ctrl.mostraDataConciliacao><sk-date-input sk-value=ctrl.dataConciliacao></sk-date-input></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox><sk-vbox flex><sk-simple-form sk-in-line=true sk-columns=1 layout-top-padding sk-width=640><sk-simple-group sk-label=Commons.Baixa.labelValores><sk-simple-item sk-label=Commons.Baixa.labelValor><sk-number-input sk-value=ctrl.valor sk-enabled=false sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.varCambInclusa><sk-number-input sk-value=ctrl.vlrVarCambial sk-enabled=ctrl.utilizaSankhyaCivil sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelTaxaAdmLongo><sk-number-input sk-value=ctrl.taxaAdm sk-focus=\"ctrl.addEventListener('FOCUS_IN','taxaAdm')\" sk-change=\"ctrl.addEventListener('CHANGE','taxaAdm')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDesconto><sk-number-input sk-value=ctrl.vlrDesconto sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrDesconto')\" sk-change=\"ctrl.addEventListener('CHANGE','vlrDesconto')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelMulta><sk-hbox gap=10><sk-number-input sk-value=ctrl.vlrMulta sk-enabled=ctrl.multaEdit sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrMulta')\" sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrMulta')\" sk-change=ctrl.calculaMulta() sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2></sk-number-input><sk-combobox sk-value=ctrl.tipoMulta sk-options=ctrl.optTipoMulta sk-enabled=ctrl.multaEdit sk-change=ctrl.calculaMulta() sk-width=120></sk-combobox></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelJuros><sk-hbox gap=10><sk-number-input sk-value=ctrl.vlrJuro sk-required=ctrl.juroObrig sk-focus=\"ctrl.addEventListener('FOCUS_IN','vlrJuro')\" sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrJuro')\" sk-change=ctrl.calculaJuro() sk-datagrid-editor=true sk-enabled=!ctrl.juroObrig sk-ignored-select-format=false sk-precision=2></sk-number-input><sk-combobox sk-value=ctrl.tipoJuro sk-options=ctrl.optTipoJuro sk-required=ctrl.juroObrig sk-enabled=!ctrl.juroObrig sk-change=ctrl.calculaJuro() sk-width=120></sk-combobox></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDespesaCartorio><sk-number-input sk-value=ctrl.despCartorio sk-focus=\"ctrl.addEventListener('FOCUS_IN','despCartorio')\" sk-change=\"ctrl.addEventListener('CHANGE','despCartorio')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelMultaNegociacao><sk-number-input sk-value=ctrl.multaNeg sk-enabled=false sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelJurosNegociacao><sk-number-input sk-value=ctrl.juroNeg sk-enabled=false sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelPerdaoMulta><sk-number-input sk-value=ctrl.multaLib sk-enabled=ctrl.multaLibEnabled sk-datagrid-editor=true sk-change=\"ctrl.addEventListener('CHANGE','multaLib')\" sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelPerdaoJuros><sk-number-input sk-value=ctrl.juroLib sk-enabled=ctrl.juroLibEnabled sk-focus=\"ctrl.addEventListener('FOCUS_IN','juroLib')\" sk-change=\"ctrl.addEventListener('CHANGE','juroLib')\" sk-datagrid-editor=true sk-ignored-select-format=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelTotal sk-required=true><sk-hbox gap=10><sk-number-input sk-value=ctrl.valorTotal sk-datagrid-editor=true sk-ignored-select-format=false sk-enabled=ctrl.valorTotalEnabled sk-focus=\"ctrl.addEventListener('FOCUS_IN','valorTotal')\" sk-precision=2 sk-width=175></sk-number-input><button default ng-click=ctrl.calculaOutrosImpostos()><sk-i18n>Commons.Baixa.labelRecalcular</sk-i18n></button></sk-hbox></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox></sk-hbox></sk-accordion-group><sk-accordion-group heading={{ctrl.labelPgtoVariosTitulos}} is-open=false flex><sk-viewstack id=vsVariosTitulo sk-width=100% sk-height=100% sk-selected-index=ctrl.vsVariosTituloIndex layout=column flex><sk-viewstack-content layout=row flex><sk-double-face-panel sk-dataset=ctrl.dsVariosTitulos layout flex><sk-top-bar layout-padding flex><sk-navigator dataset=ctrl.dsVariosTitulos sk-add-function=ctrl.setVariosTitulosInsertionMode() sk-show-navigation=true sk-show-add-button=true sk-show-copy-button=true sk-show-remove-button=true sk-show-cancel-button=true sk-show-save-button=true sk-show-refresh-button=false sk-edit-unique-record=false sk-compact-btn-add></sk-navigator><sk-hbox gap=5 sk-margin-left=5px><button default class=btn-header ng-click=ctrl.openInformarCMC7() tooltip=[F4] tooltip-placement=bottom sk-i18n>{{'Financeiro.MovimentacaoFinanceira.itemCMC7' | translate}}</button> <button default class=btn-header ng-click=ctrl.receberCancelarCartao() ng-disabled=!ctrl.btnRecCancCartaoEnabled ng-if=ctrl.usaRecebimentoComCartao tooltip-placement=bottom sk-i18n><span ng-bind=ctrl.labelBtnReceber></span></button></sk-hbox><sk-hbox flex layout-align=end><sk-rows-counter sk-dataset=ctrl.dsVariosTitulos></sk-rows-counter></sk-hbox></sk-top-bar><sk-face-one layout><sk-hbox sk-overflow-y=auto><sk-simple-form sk-in-line=true sk-columns=1 layout-top-padding><sk-simple-item sk-label=Commons.Baixa.labelValorBaixa sk-required=true><sk-number-input sk-dataset=ctrl.dsVariosTitulos sk-field-name=VLRBAIXA sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelTipoTitulo><sk-pesquisa-input sk-dataset=ctrl.dsVariosTitulos sk-field-name=CODTIPTIT sk-description-field-name=TipoTitulo.DESCRTIPTIT sk-entity-name=TipoTitulo sk-notify-description-change-to-data-set=false sk-enviroment-criteria=ctrl.environmentCriteriaTipoTitulo() sk-entity-change=ctrl.changeCodTipTitulo() sk-width=420></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelNumeroDocumento><sk-text-input sk-dataset=ctrl.dsVariosTitulos sk-field-name=NOSSONUM sk-width=420></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelBanco><sk-pesquisa-input sk-dataset=ctrl.dsVariosTitulos sk-field-name=CODBCO sk-entity-name=Banco sk-notify-description-change-to-data-set=true sk-width=420></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelHistorico><sk-text-area sk-dataset=ctrl.dsVariosTitulos sk-field-name=HISTORICO sk-width=420 sk-height=120></sk-text-area></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDataBaixa><sk-date-input sk-dataset=ctrl.dsVariosTitulos sk-field-name=DHBAIXA sk-width=180></sk-date-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelCodigoBarras><sk-text-input sk-dataset=ctrl.dsVariosTitulos sk-field-name=CODBARRA sk-width=500></sk-text-input></sk-simple-item></sk-simple-form></sk-hbox></sk-face-one><sk-face-two layout flex><sk-datagrid sk-dataset=ctrl.dsVariosTitulos sk-hide-cbx-column=true sk-datagrid-interceptor=ctrl sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-only-custom><sk-datagrid-custom-column sk-field-name=VLRBAIXA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODTIPTIT></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NOSSONUM sk-description=Commons.Baixa.labelNumeroDocumento></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODBCO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=HISTORICO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DHBAIXA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODBARRA></sk-datagrid-custom-column></sk-datagrid></sk-face-two></sk-double-face-panel></sk-viewstack-content><sk-viewstack-content layout=row flex><sk-hbox layout-padding><span flex class=text-bold><sk-i18n>Commons.Baixa.labelTituloDevolucaoCheque</sk-i18n></span></sk-hbox></sk-viewstack-content><sk-viewstack-content layout=row flex><sk-hbox layout-padding><span flex class=text-bold><sk-i18n>Commons.Baixa.labelJurosVariosTitulos</sk-i18n></span></sk-hbox></sk-viewstack-content></sk-viewstack><sk-footer-bar layout-top-padding><div style=height:30px><sk-hbox sk-border-top=\"1px solid #ccc\" align=\"center space-around\" layout-padding footer-container><span flex class=text-bold><sk-i18n>Commons.Baixa.labelTituloOriginal</sk-i18n>: <span class=text-bold>{{ctrl.txtTituloOriginal}}</span></span> <span flex class=text-bold><sk-i18n>Commons.Baixa.labelTotalTitulos</sk-i18n>: <span class=text-bold>{{ctrl.txtTotal}}</span></span> <span flex class=text-bold><sk-i18n>Commons.Baixa.labelDiferenca</sk-i18n>: <span class=text-bold>{{ctrl.txtDiferenca}}</span></span></sk-hbox></div></sk-footer-bar></sk-accordion-group><sk-accordion-group heading={{ctrl.labelOutrosImpostos}} is-open=false ng-if=!ctrl.isJivaW><sk-double-face-panel sk-dataset=ctrl.dsOutrosImpostos layout flex><sk-top-bar layout-padding><sk-navigator dataset=ctrl.dsOutrosImpostos sk-show-navigation=true sk-show-add-button=true sk-show-copy-button=true sk-show-remove-button=true sk-show-cancel-button=true sk-show-save-button=true sk-edit-unique-record=false sk-compact-btn-add></sk-navigator><sk-hbox flex layout-align=end><sk-rows-counter sk-dataset=ctrl.dsOutrosImpostos></sk-rows-counter></sk-hbox></sk-top-bar><sk-face-one layout flex><sk-simple-form sk-in-line=true sk-columns=1 layout-top-padding><sk-simple-item sk-label=Commons.Impostos.labelImposto sk-required=true><sk-pesquisa-input sk-dataset=ctrl.dsOutrosImpostos sk-field-name=CODIMP sk-entity-name=Imposto sk-enviroment-criteria=ctrl.enviromentCriteria() sk-width=380></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Impostos.labelTipoImposto><sk-combobox sk-dataset=ctrl.dsOutrosImpostos sk-field-name=TIPIMP sk-width=175></sk-combobox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelBase><sk-number-input sk-dataset=ctrl.dsOutrosImpostos sk-precision=2 sk-field-name=BASE sk-focus-out=ctrl.calculaValorAliquota() sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelAliquota><sk-number-input sk-dataset=ctrl.dsOutrosImpostos sk-precision=2 sk-field-name=ALIQUOTA sk-focus-out=ctrl.calculaValorAliquota() sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelValor><sk-number-input sk-dataset=ctrl.dsOutrosImpostos sk-precision=2 sk-field-name=VALOR sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDigitado><sk-switch sk-dataset=ctrl.dsOutrosImpostos sk-field-name=DIGITADO sk-true-value=S sk-false-value=N sk-width=175></sk-switch></sk-simple-item></sk-simple-form></sk-face-one><sk-face-two layout flex><sk-datagrid sk-dataset=ctrl.dsOutrosImpostos sk-hide-cbx-column=true sk-datagrid-interceptor=ctrl sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-only-custom><sk-datagrid-custom-column sk-field-name=CODIMP></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TIPIMP></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=BASE></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ALIQUOTA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VALOR></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DIGITADO></sk-datagrid-custom-column></sk-datagrid></sk-face-two></sk-double-face-panel></sk-accordion-group><sk-accordion-group heading={{ctrl.lblFechamentoBaixaMoeda}} is-open=false ng-if=ctrl.exibePainelBaixaMoeda><sk-hbox flex><sk-vbox flex><sk-simple-form sk-in-line=true sk-columns=1 layout-top-padding><sk-simple-group sk-label=Commons.Baixa.lblVlrMoeda><sk-simple-item sk-label=Commons.Baixa.lblVlrNegociacao><sk-number-input sk-value=ctrl.vlrMoedaNeg sk-enabled=false sk-precision=ctrl.paramDecVlrMoeda sk-width=175></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.lblVlrAtual sk-required=true><sk-hbox gap=5 layout-align=\"start center\"><sk-number-input sk-value=ctrl.vlrMoedaAtu sk-enabled=ctrl.vlrMoedaAtuEnabled sk-change=ctrl.changeValorMoeda() sk-precision=ctrl.paramDecVlrMoeda sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrMoedaAtu')\"></sk-number-input><sk-icon font-icon=search ng-click=ctrl.buscarCotacao()></sk-icon></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.lblVariacaoCambial><sk-number-input sk-value=ctrl.vlrVarCamb sk-enabled=false sk-precision=6 sk-width=175></sk-number-input></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox><sk-vbox flex><sk-simple-form sk-columns=1 layout-top-padding sk-width=180><sk-simple-group sk-label=Commons.Baixa.lblVlrDesdobramentoMoeda><sk-simple-item><sk-number-input sk-value=ctrl.vlrDesdobMoedaNeg sk-enabled=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item><sk-number-input sk-value=ctrl.vlrDesdobMoedaAtu sk-enabled=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item><sk-number-input sk-value=ctrl.vlrDesdobMoedaTotal sk-enabled=ctrl.vlrDesdobMoedaTotalEnabled sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrDesdobMoedaTotal')\" sk-precision=2 sk-width=175></sk-number-input></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox><sk-vbox flex><sk-simple-form sk-columns=1 layout-top-padding sk-width=180><sk-simple-group sk-label=Commons.Baixa.lblDesdobramento><sk-simple-item><sk-number-input sk-value=ctrl.vlrDesdobNeg sk-enabled=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item><sk-number-input sk-value=ctrl.vlrDesdobAtu sk-enabled=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item><sk-number-input sk-value=ctrl.vlrVaricaoDesdob sk-enabled=false sk-precision=2 sk-width=175></sk-number-input></sk-simple-item><sk-simple-item><sk-number-input sk-value=ctrl.vlrDesdobTotal sk-enabled=ctrl.vlrDesdobTotalEnabled sk-focus-out=\"ctrl.addEventListener('FOCUS_OUT','vlrDesdobTotal')\" sk-precision=2 sk-width=175></sk-number-input></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox></sk-hbox></sk-accordion-group></sk-accordion><div class=wizard-modal-footer id=footer><div class=wizard-modal-footer-right><button class=\"btn btn-default\" ng-click=ctrl.onCancel()><sk-span sk-i18n>Commons.Baixa.buttonCancelar</sk-span></button> <button class=\"btn btn-default\" ng-click=ctrl.gerarPix() ng-if=ctrl.receberComPix><sk-span sk-i18n>Commons.Baixa.buttonGerarPix</sk-span></button> <button class=\"btn btn-default\" ng-click=ctrl.validaTipoTitulo()><sk-span sk-i18n>Commons.Baixa.buttonBaixar</sk-span></button></div></div>");
  $templateCache.put("commons/baixa/panel/step/baixavlrmaiorstep.tpl.html",
    "<sk-vbox ng-if=ctrl.isLoad flex><sk-cabecalho-baixa sk-data=ctrl.dadosCabecalho sk-show-botao-ver-financeiro=ctrl.verFinanceiroVisible sk-on-create-cabecalho-baixa=ctrl.onCreatedCabecalho(cabecalho) sk-on-click-ver-financeiro=ctrl.onClickVerFinanceiro()></sk-cabecalho-baixa><sk-hbox layout-padding gap=10><sk-vbox><sk-hbox><span sk-i18n>Commons.Baixa.labelConsiderarDif</span><span>:</span></sk-hbox></sk-vbox><sk-vbox layout-align=\"start center\" gap=10 layout-top-padding flex><sk-radio-input class=radio-input sk-value=ctrl.diferenca sk-option=1 sk-change=ctrl.handleFrequence() sk-i18n>{{'Commons.Baixa.itemJuros' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.diferenca sk-option=2 sk-change=ctrl.handleFrequence() sk-i18n>{{'Commons.Baixa.itemTroco' | translate}}</sk-radio-input><sk-radio-input ng-if=ctrl.istituloCredito class=radio-input sk-value=ctrl.diferenca sk-option=3 sk-change=ctrl.handleFrequence() sk-i18n>{{'Commons.Baixa.itemCredito' | translate}}</sk-radio-input></sk-vbox></sk-hbox></sk-vbox>");
  $templateCache.put("commons/baixa/panel/step/baixavlrmenorstep.tpl.html",
    "<sk-cabecalho-baixa ng-if=ctrl.isLoading sk-data=ctrl.dataCabecalho sk-on-create-cabecalho-baixa=ctrl.onCreatedCabecalho(cabecalho) sk-show-botao-ver-financeiro=ctrl.verFinanceiroVisible sk-on-click-ver-financeiro=ctrl.onClickVerFinanceiro()></sk-cabecalho-baixa><sk-vbox layout-padding flex><sk-hbox><span class=text-bold ng-if=ctrl.boxInformacaoVisible sk-color=red ng-bind=ctrl.lblInformacaoText></span></sk-hbox><sk-hbox layout-top-padding gap=5 layout-align=\"start center\"><div><span sk-i18n>Commons.Baixa.labelConsiderarDif</span><span>:</span></div><sk-radio-input class=radio-input sk-value=ctrl.diferenca sk-option=5 sk-change=ctrl.handleFrequence() sk-width=84 sk-i18n>{{'Commons.Baixa.labelDesconto' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.diferenca sk-option=4 sk-change=ctrl.handleFrequence() sk-width=84 sk-i18n>{{'Commons.Baixa.labelPendencia' | translate}}</sk-radio-input></sk-hbox><sk-hbox gap=10 layout-align=\"start center\"><sk-switch sk-value=ctrl.opcaoCalculo sk-true-value=true sk-false-value=false sk-change=ctrl.ajustarCalculoPorDentro()></sk-switch><span sk-i18n>Commons.Baixa.labelOpcaoCalculo</span><sk-help-tip sk-i18n sk-text=Commons.Baixa.helpOpcaoCalculo></sk-help-tip></sk-hbox><sk-simple-form layout-padding sk-in-line=true sk-columns=1><sk-hbox sk-margin-left=174px gap=104 flex><span class=text-bold sk-i18n>Commons.Baixa.labelBaixaCorrente</span> <span class=text-bold sk-i18n>Commons.Baixa.labelPendencia</span> <span class=text-bold sk-i18n>Commons.Baixa.labelValorOriginal</span></sk-hbox><sk-simple-item layout-top-padding sk-label=Commons.Baixa.labelVencimento><sk-hbox gap=10><sk-date-input sk-value=ctrl.corVencimento sk-enabled=false sk-width=175></sk-date-input><sk-date-input sk-value=ctrl.penVencimento sk-enabled=ctrl.campos.penVencimento sk-width=175></sk-date-input><sk-date-input sk-value=ctrl.oriVencimento sk-enabled=false sk-width=175></sk-date-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelIRRF><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrIrrf sk-precision=2 sk-enabled=ctrl.campos.corVlrIrrf sk-focus-out=ctrl.corVlrIrrfEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrIrrf sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrIrrf sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelINSS><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrInss sk-precision=2 sk-enabled=ctrl.campos.corVlrInss sk-focus-out=ctrl.corVlrInssEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrInss sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrInss sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelISSRetido><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrIss sk-precision=2 sk-enabled=ctrl.campos.corVlrIss sk-focus-out=ctrl.corVlrIssEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrIss sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrIss sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelVendor><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrVendor sk-precision=2 sk-enabled=ctrl.campos.corVlrVendor sk-focus-out=ctrl.corVlrVendorEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrVendor sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrVendor sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelValor><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlr sk-precision=2 sk-enabled=ctrl.campos.corVlr sk-focus-out=ctrl.corVlrListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlr sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlr sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelMultaInclusa><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrMulta sk-precision=2 sk-enabled=ctrl.campos.corVlrMulta sk-focus-out=ctrl.corVlrMultaEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrMulta sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrMulta sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelMultaNeg ng-if=false><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrMultaNeg sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrMultaNeg sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrMultaNeg sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDespesaCartorio><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrDespCartorio sk-precision=2 sk-enabled=ctrl.campos.corVlrDespCartorio sk-focus-out=ctrl.corVlrDespCartorioEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrDespCartorio sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrDespCartorio sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelJuroIncluso><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrJuro sk-precision=2 sk-enabled=ctrl.campos.corVlrJuro sk-focus-out=ctrl.corVlrJuroEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrJuro sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrJuro sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelJurosNeg ng-if=false><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrJurosNeg sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrJurosNeg sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrJurosNeg sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelDesconto><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrDesconto sk-precision=2 sk-enabled=ctrl.campos.corVlrDesconto sk-focus-out=ctrl.corVlrDescontoEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrDesconto sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrDesconto sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelTaxaAdm><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrTaxaAdm sk-precision=2 sk-enabled=ctrl.campos.corVlrTaxaAdm sk-focus-out=ctrl.corVlrTaxaAdmEventListener()></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrTaxaAdm sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrTaxaAdm sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Impostos.labelOutrosImpostos><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrOutrosImp sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrOutrosImp sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrOutrosImp sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelOutrosImpMensais><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corOutrosImpMen sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penOutrosImpMen sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriOutrosImpMen sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelTotais><sk-hbox gap=10><sk-number-input sk-width=175 sk-value=ctrl.corVlrTotal sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.penVlrTotal sk-precision=2 sk-enabled=false></sk-number-input><sk-number-input sk-width=175 sk-value=ctrl.oriVlrTotal sk-precision=2 sk-enabled=false></sk-number-input></sk-hbox></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/baixa/panel/step/conclusaostep.tpl.html",
    "<sk-vbox sk-height=100% sk-width=100%><sk-cabecalho-baixa ng-if=ctrl.isLoad sk-data=ctrl.dadosCabecalho sk-show-botao-ver-financeiro=ctrl.verFinanceiroVisible sk-on-click-ver-financeiro=ctrl.onClickVerFinanceiro()></sk-cabecalho-baixa><sk-vbox sk-width=100% sk-height=100%><sk-vbox layout-align=\"center center\" flex><span class=text-bold style=\"font-size: 20px\" sk-translate>Commons.Baixa.labelSucessoBaixa</span><sk-hbox gap=8 layout-top-padding><sk-icon font-icon=info-sign></sk-icon><span sk-translate>Commons.Baixa.labelEscolherProximaAcao</span></sk-hbox><sk-hbox gap=8><button default style=margin:2px ng-click=\"ctrl.escolherAcao('FECHAR')\" sk-i18n>Geral.buttonFechar</button> <button default style=margin:2px ng-if=ctrl.fecharAplicarVisible ng-click=\"ctrl.escolherAcao('FECHAR_APLICAR')\" sk-i18n>Commons.Baixa.buttonFecharReaplicar</button> <button default style=margin:2px ng-if=ctrl.fecharBaixarProximoVisible ng-click=\"ctrl.escolherAcao('FECHAR_BAIXAR_PROXIMO')\" sk-i18n>Commons.Baixa.buttonBaixarProximo</button></sk-hbox></sk-vbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/baixa/panel/step/liberacaostep.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreatedStandAlone(dataset) sk-refresh-handler=ctrl.refreshHandlerStadAlone(request) sk-standalone><sk-dsfield-md width=900 name=MSG user-type=S description=Commons.Baixa.headerMensagem sk-i18n></sk-dsfield-md></sk-dataset><sk-vbox sk-height=100% sk-width=100% ng-if=ctrl.isLoad><sk-cabecalho-baixa sk-data=ctrl.dadosCabecalho sk-on-create-cabecalho-baixa=ctrl.onCreatedCabecalho(cabecalho) sk-show-botao-ver-financeiro=ctrl.verFinanceiroVisible sk-on-click-ver-financeiro=ctrl.onClickVerFinanceiro()></sk-cabecalho-baixa><sk-vbox flex layout-top-padding><sk-vbox flex><sk-vbox class=painel-title align=\"center center\"><span sk-i18n>Commons.Liberacoes.titleLiberacoesSolicitadas</span></sk-vbox><sk-liberacoes sk-data=ctrl.liberacoes flex></sk-liberacoes></sk-vbox><sk-hbox sk-height=220><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsMensagens flex></sk-datagrid></sk-vbox><sk-vbox flex><sk-text-area sk-value=ctrl.mensagenSelecionada></sk-text-area></sk-vbox></sk-hbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/cadastroPergunta/PainelEscolhaTipoPergunta/PainelEscolhaTipoPergunta.tpl.html",
    "<ui-carousel sk-width=100%><carousel-item><sk-hbox sk-width=100% sk-height=132px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=1 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TextField.png style=\"width: 278px; height: 112px\" ng-click=ctrl.setTipo(0) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=2 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TextArea.png style=\"width: 278px; height: 112px\" ng-click=ctrl.setTipo(1) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=135px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=3 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/RadioLinhas.png style=\"width: 278px; height: 115px\" ng-click=ctrl.setTipo(2) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=5 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/CheckLinhas.png style=\"width: 278px; height: 115px\" ng-click=ctrl.setTipo(4) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=121px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=4 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/RadioColunas.png style=\"width: 278px; height: 101px\" ng-click=ctrl.setTipo(3) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=6 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/CheckColunas.png style=\"width: 278px; height: 101px\" ng-click=ctrl.setTipo(5) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=184px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=8 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TabelaUnica.png style=\"width: 278px; height: 164px\" ng-click=ctrl.setTipo(7) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=9 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TabelaMult.png style=\"width: 278px; height: 164px\" ng-click=ctrl.setTipo(8) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=137px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=7 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/Grupo.png style=\"width: 278px; height: 117px\" ng-click=ctrl.setTipo(6) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=10 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/ListaAnexos.png style=\"width: 278px; height: 115px\" ng-click=ctrl.setTipo(9) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item></ui-carousel>");
  $templateCache.put("commons/cadastroPergunta/WizardCriacaoPergunta/WizardCriacaoPergunta.tpl.html",
    "<sk-viewstack sk-selected-index=ctrl.selectedStep id=vsFormularios sk-width=100% sk-height=100%><sk-viewstack-content id=stepTipoPergunta sk-width=100% sk-height=100%><sk-hbox sk-width=100% layout-align=\"start center\" style=background-color:#ffffd2 sk-padding=10px sk-margin=0px><span style=font-weight:bold sk-i18n>mgepesq.CadastroPergunta.ttlWizard</span></sk-hbox><ui-carousel sk-width=100%><carousel-item><sk-hbox sk-width=100% sk-height=132px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=0 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TextField.png style=\"width: 278px; height: 112px\" ng-click=ctrl.setTipo(0) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=1 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TextArea.png style=\"width: 278px; height: 112px\" ng-click=ctrl.setTipo(1) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=135px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=2 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/RadioLinhas.png style=\"width: 278px; height: 115px\" ng-click=ctrl.setTipo(2) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=4 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/CheckLinhas.png style=\"width: 278px; height: 115px\" ng-click=ctrl.setTipo(4) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=121px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=3 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/RadioColunas.png style=\"width: 278px; height: 101px\" ng-click=ctrl.setTipo(3) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=5 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/CheckColunas.png style=\"width: 278px; height: 101px\" ng-click=ctrl.setTipo(5) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=184px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=7 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TabelaUnica.png style=\"width: 278px; height: 164px\" ng-click=ctrl.setTipo(7) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=8 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/TabelaMult.png style=\"width: 278px; height: 164px\" ng-click=ctrl.setTipo(8) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item><carousel-item><sk-hbox sk-width=100% sk-height=137px><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=6 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/Grupo.png style=\"width: 278px; height: 117px\" ng-click=ctrl.setTipo(6) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox><sk-hbox sk-margin=\"0px auto\"><sk-radio-input sk-value=ctrl._tipo sk-option=9 sk-name=grupoConfig sk-margin=\"10px auto\"><img ng-src=/mge/assets/img/ListaAnexos.png style=\"width: 278px; height: 115px\" ng-click=ctrl.setTipo(9) ng-dblclick=ctrl.doubleClickItem()></sk-radio-input></sk-hbox></sk-hbox></carousel-item></ui-carousel></sk-viewstack-content><sk-viewstack-content id=stepAtributosPergunta sk-width=100% sk-height=100%><sk-hbox sk-width=100% layout-align=\"start center\" style=background-color:#ffffd2 layout-padding sk-margin=\"0px 0px 0px 0px\"><label style=\"font-weight: bold; font-size: 14; background-color:#ffffd2; padding:30\">{{ctrl.textoCabecalho}}</label></sk-hbox><sk-viewstack sk-selected-index=ctrl.selectedViewIndex id=vsFormularios sk-width=100% sk-height=100%><sk-viewstack-content id=ctrl.formularioTabular sk-width=100% sk-height=100%><sk-simple-form><sk-vbox><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblTexto sk-required=true sk-width=100% sk-height=100%><sk-text-area sk-height=100 id=comumDescricao sk-value=ctrl.descricaoValue></sk-simple-item><sk-hbox><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblGrupoPergunta sk-required=true sk-width=100% sk-height=100%><sk-pesquisa-input id=comumGrupo sk-value=ctrl.grupoValue sk-entity-name=GrupoPergunta sk-field-name=CODGRUPOPERG sk-allow-show-hierarchical-mode=true></sk-simple-item><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblQtdMaxLinhas sk-width=100% sk-height=100% ng-show=ctrl._tipoAnexo><sk-number-input id=comumMaxLinhas sk-value=ctrl.maxLinhasValue sk-field-name=QTDMAXLINHAS></sk-simple-item></sk-hbox><sk-hbox><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblNumTentativas sk-width=100% sk-height=100% ng-show=ctrl._tipoAnexo><sk-number-input id=comumNroTentativas sk-value=ctrl.nroTentativasValue sk-field-name=NROTENTATIVAS></sk-simple-item><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblQtdMaxEscolhas sk-width=100% sk-height=100% ng-show=ctrl._tipoAnexo><sk-number-input id=comumMaxEscolha sk-value=ctrl.maxEscolhaValue sk-field-name=QTDMAXESCOLHAS></sk-simple-item></sk-hbox><sk-hbox><sk-simple-item sk-width=100% sk-height=100%><sk-checkbox id=pergComumObrigatoria ng-model=ctrl.pergObrigatoriaValue><span sk-i18n>mgepesq.CadastroPergunta.ckbObrigatoria</span></sk-checkbox></sk-simple-item></sk-hbox></sk-vbox></sk-simple-form></sk-viewstack-content><sk-viewstack-content id=ctrl.formularioComum sk-width=100% sk-height=100%><sk-simple-form><sk-vbox><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblTituloTabela sk-required=true sk-width=100%><sk-text-area id=tabDescricao sk-height=100 sk-value=ctrl.descricaoValue></sk-simple-item><sk-hbox><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblGrupoPergunta sk-required=true sk-width=100%><sk-pesquisa-input id=tabGrupo sk-value=ctrl.grupoValue sk-entity-name=GrupoPergunta sk-field-name=CODGRUPOPERG sk-allow-show-hierarchical-mode=true></sk-simple-item><sk-simple-item sk-label=mgepesq.CadastroPergunta.lblQtdMaxEscolhas sk-width=100%><sk-number-input id=tab_maxEscolhas sk-value=ctrl.maxEscolhaValue sk-field-name=QTDMAXESCOLHAS></sk-simple-item></sk-hbox><sk-hbox sk-width=100%><sk-simple-item sk-width=auto><sk-checkbox id=tabAceitaObservacao ng-model=ctrl.aceitaObservacaoValue><span sk-i18n>mgepesq.CadastroPergunta.lblAceitaObeservacao</span></sk-checkbox></sk-simple-item><sk-simple-item sk-width=auto><sk-checkbox id=pergTabObrigatoria ng-model=ctrl.pergObrigatoriaValue><span sk-i18n>mgepesq.CadastroPergunta.ckbObrigatoria</span></sk-checkbox></sk-simple-item></sk-hbox></sk-vbox></sk-simple-form></sk-viewstack-content></sk-viewstack></sk-viewstack-content></sk-viewstack><sk-bottom-bar><sk-hbox layout-align=\"end center\"><button default style=margin:2px ng-click=ctrl.btnCancelar()><span sk-i18n>mgepesq.CadastroPergunta.btnCancelar</span></button> <button default style=margin:2px sk-disabled=!ctrl.permiteAnterior ng-click=ctrl.btnAnterior()><span sk-i18n>mgepesq.CadastroPergunta.btnAnterior</span></button> <button default style=margin:2px sk-disabled=!ctrl.permiteProximo ng-click=ctrl.btnProximo()><span sk-i18n>mgepesq.CadastroPergunta.btnProximo</span></button> <button primary style=margin:2px sk-disabled=!ctrl.permiteConcluir ng-click=ctrl.btnConcluir()><span sk-i18n>mgepesq.CadastroPergunta.btnConcluir</span></button></sk-hbox></sk-bottom-bar>");
  $templateCache.put("commons/cadastroPergunta/cadastropergunta.tpl.html",
    "");
  $templateCache.put("commons/cadastroSimplificadoVeiculo/cadastroSimplificadoVeiculo.tpl.html",
    "<sk-dynaform sk-entity-name=Veiculo sk-on-dynaform-loaded=\"ctrl.onDynaformLoaded(dynaform, dataset)\" sk-resource-id=br.com.sankhya.core.cad.simplificado.veiculos sk-skip-start-page=true sk-on-dbl-click=ctrl.selecionarVeiculo() sk-hide-tour=true sk-default-mode=detail sk-hide-buttons-config=true sk-show-filter=false sk-hide-button-grid=true sk-hide-entity-search-field=false sk-dynaform-interceptor=ctrl sk-form-interceptor=ctrl></sk-dynaform>");
  $templateCache.put("commons/cadastroparceirosimplificado/cadastro-parceiro-simplificado.tpl.html",
    "<sk-vbox no-padding><sk-dynaform sk-id=dynParceirosSimplificados sk-entity-name=Parceiro sk-skip-start-page=true layout=column sk-on-dynaform-loaded=ctrl.onDynaformLoaded(dynaform,dataset) , sk-other-options-loader=ctrl.otherOptionsLoader(dynaform) , sk-dynaform-interceptor=ctrl , sk-form-interceptor=ctrl sk-helper-class-name=br.com.sankhya.modelcore.helper.ParceiroSimplesDynaformHelper sk-form-interceptor=ctrl sk-hide-tour=true sk-default-mode=detail sk-show-filter=false sk-hide-button-grid=true sk-hide-entity-search-field=false sk-resource-id=ctrl.resourceID sk-hide-buttons-config=!ctrl.sup flex></sk-dynaform></sk-vbox>");
  $templateCache.put("commons/cmc7/cmc7panel.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreatedStandAlone(dataset) entity-name=ViewPrefixoCheque sk-load-records-from-server=true sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-hbox><sk-simple-form><sk-hbox><sk-simple-item sk-label=Commons.CMC7.labelComp><sk-text-input id=campoComp style=\"width: 65px\" sk-value=ctrl.txtComp sk-size=3 sk-restrict=[^0-9] sk-focus-out=ctrl.focusOutComp() sk-finish-change=\"ctrl.nextFocus('txtBancoInput')\"></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -20px\" sk-label=Commons.CMC7.labelBanco><sk-text-input style=\"width: 65px\" id=txtBancoInput sk-value=ctrl.txtBanco sk-size=3 sk-restrict=[^0-9] sk-focus-out=ctrl.focusOutBanco() sk-finish-change=\"ctrl.nextFocus('txtAgenciaInput')\"></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -20px\" sk-label=Commons.CMC7.labelAgencia><sk-hbox gap=5><sk-text-input style=\"width: 65px\" id=txtAgenciaInput sk-value=ctrl.txtAgencia sk-size=4 sk-restrict=[^0-9] sk-focus-out=ctrl.focusOutAgencia() sk-finish-change=\"ctrl.nextFocus('txtContaInput')\"></sk-text-input><sk-text-input style=\"width: 25px\" sk-value=ctrl.txtDigAgencia sk-enabled=false></sk-text-input></sk-hbox></sk-simple-item><sk-simple-item style=\"margin-left: -20px\" sk-label=Commons.CMC7.labelC1><sk-text-input style=\"width: 25px\" sk-value=ctrl.txtC1 sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -27px\" sk-label=Commons.CMC7.labelConta><sk-text-input style=\"width: 100px\" id=txtContaInput sk-value=ctrl.txtConta sk-size=10 sk-restrict=[^0-9] sk-focus-out=ctrl.focusOutConta() sk-finish-change=\"ctrl.nextFocus('txtChequeInput')\"></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -20px\" sk-label=Commons.CMC7.labelC2><sk-text-input style=\"width: 25px\" sk-value=ctrl.txtC2 sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -25px\" sk-label=Commons.CMC7.labelCheque><sk-text-input style=\"width: 65px\" id=txtChequeInput sk-value=ctrl.txtCheque sk-size=6 sk-restrict=[^0-9] sk-focus-out=ctrl.focusOutCheque()></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -20px\" sk-label=Commons.CMC7.labelC3><sk-text-input style=\"width: 25px\" sk-value=ctrl.txtC3 sk-enabled=false></sk-text-input></sk-simple-item></sk-hbox></sk-simple-form></sk-hbox><sk-simple-form sk-columns=2><sk-simple-item sk-label=Commons.CMC7.labelPrefixoCheque><sk-combobox id=comboPrefixoInput sk-value=ctrl.comboPrefixo sk-allow-null=false sk-opt-key=prefixo sk-opt-label=descricao sk-options=ctrl.opcoesComboPrefixo></sk-combobox></sk-simple-item><sk-simple-item sk-label=Commons.CMC7.labelTiposCheque><sk-combobox sk-value=ctrl.comboTipo sk-allow-null=false sk-options=ctrl.opcoesComboTipo></sk-combobox></sk-simple-item></sk-simple-form><sk-simple-form><sk-simple-item style=\"width: 100%\" sk-label=Commons.CMC7.labelBandaCMC7><sk-hbox gap=5><sk-text-input sk-value=ctrl.txtCMC71 sk-size=8 sk-finish-change=\"ctrl.nextFocus('txtCMC72Input')\"></sk-text-input><sk-text-input id=txtCMC72Input sk-value=ctrl.txtCMC72 sk-size=10 sk-finish-change=\"ctrl.nextFocus('txtCMC73Input')\"></sk-text-input><sk-text-input id=txtCMC73Input sk-value=ctrl.txtCMC73 sk-size=12 sk-change=ctrl.changeCMC73()></sk-text-input></sk-hbox></sk-simple-item><sk-vbox class=\"ng-isolate-scope col-xs-12 col-sm-12\"><sk-hbox><button default sk-value=ctrl.btnGerarBanda ng-click=ctrl.gerarBanda()>{{'Commons.CMC7.buttonGerarBanda' | translate}}</button></sk-hbox><sk-hbox layout-top-padding gap=5><sk-text-input sk-value=ctrl.txtBandaConf1></sk-text-input><sk-text-input sk-value=ctrl.txtBandaConf2></sk-text-input><sk-text-input sk-value=ctrl.txtBandaConf3></sk-text-input></sk-hbox></sk-vbox><sk-simple-item style=\"width: 100%\" flex><sk-vbox gap=15><sk-text-input sk-value=ctrl.txtBanda></sk-text-input><button default style=\"width: 13%; height: 29px\" sk-value=ctrl.btnValidarBanda ng-click=ctrl.validarBanda()>{{'Commons.CMC7.buttonValidarBanda' | translate}}</button></sk-vbox></sk-simple-item></sk-simple-form><sk-vbox><sk-simple-form style=\"width: 100%\"><sk-hbox><sk-simple-item sk-label=Commons.CMC7.labelComp><sk-text-input style=\"width: 60px\" sk-value=ctrl.txtComp2 sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -75px\" sk-label=Commons.CMC7.labelBanco><sk-text-input style=\"width: 60px\" sk-value=ctrl.txtBanco2 sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -75px\" sk-label=Commons.CMC7.labelAgencia><sk-text-input style=\"width: 60px\" sk-value=ctrl.txtAgencia2 sk-size=4 sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -75px\" sk-label=Commons.CMC7.labelConta><sk-text-input style=\"width: 100px\" sk-value=ctrl.txtConta2 sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item style=\"margin-left: -35px\" sk-label=Commons.CMC7.labelCheque><sk-text-input style=\"width: 60px\" sk-value=ctrl.txtCheque2 sk-enabled=false></sk-text-input></sk-simple-item></sk-hbox><sk-text-input style=\"margin-left: 15px;margin-right: 12px\" sk-value=ctrl.txtBanda2 sk-enabled=false></sk-text-input></sk-simple-form></sk-vbox><sk-simple-form layout-top-padding sk-columns=2><sk-simple-item sk-label=Commons.CMC7.labelDataCheque><sk-date-input sk-value=ctrl.dtCheque></sk-date-input></sk-simple-item><sk-simple-item sk-label=Commons.CMC7.labelValorCheque sk-required=true><sk-number-input sk-value=ctrl.vlrCheque sk-precision=2 sk-enabled=ctrl._vlrChequeEnabled></sk-number-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=2><sk-simple-item sk-label=Commons.CMC7.labelParceiroEmitente><sk-switch sk-value=ctrl.checkEmitenteEhParceiro sk-change=ctrl.changeCheckEmitenteEhParceiro()></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.CMC7.labelNomeEmitente><sk-text-input sk-value=ctrl.txtEmitente sk-enabled=ctrl.txtEmitenteEnabled></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.CMC7.labelCPFEmitente><sk-cgc-cpf-input sk-value=ctrl.txtCpf sk-enabled=ctrl.txtCpfEnabled></sk-cgc-cpf-input></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/coletorConferenciaLayout/coletor-conferencia-layout.tpl.html",
    "<sk-tabnavigator sk-selected-index=ctrl.selectedIndex ng-class=\"{'gray-background': ctrl.selectedIndex == 1}\"><sk-tabnavigator-item sk-label=Comercial.ConfiguracaoColetorConferencia.lblLayout></sk-tabnavigator-item><sk-tabnavigator-item sk-label=Comercial.ConfiguracaoColetorConferencia.lblOrdenacao ng-if=\"ctrl.srcUseOrd === true\"></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedIndex class=tab-container layout=column flex><sk-viewstack-content flex sk-margin=\"20px 0 0 0\"><sk-vbox flex><sk-hbox><sk-simple-form><sk-simple-item sk-label=Comercial.ConfiguracaoColetorConferencia.lblCampoApresentacao sk-width=500px style=\"padding-left: 10px !important\"><sk-hbox gap=5><sk-text-input sk-value=ctrl.fieldPresentation sk-width=400px sk-change=ctrl.fireEvent()></sk-text-input><button default class=btn-arquivo font-icon=edit tooltip=Comercial.ConfiguracaoColetorConferencia.msgEditarCampoApres ng-click=ctrl.openPresentationFieldBuilder() style=\"max-height: 25px\" sk-i18n></button></sk-hbox></sk-simple-item></sk-simple-form></sk-hbox><sk-hbox><sk-two-lists sk-src-title=Comercial.ConfiguracaoColetorConferencia.lblCamposDisponiveis sk-dest-title=Comercial.ConfiguracaoColetorConferencia.lblCamposSelecionados sk-src-data=ctrl.srcData sk-dest-data=ctrl.srcDataDest sk-src-filter-fn=\"ctrl.srcFilterFn(item, searchTerm)\" sk-dest-filter-fn=\"ctrl.destFilterFn(item, searchTerm)\" sk-on-move-item=\"ctrl.onMoveItem(item, listName)\" layout-padding><sk-src-item-tpl><div>{{item.description}}</div></sk-src-item-tpl><sk-dest-item-tpl>{{item.description}}</sk-dest-item-tpl></sk-two-lists></sk-hbox></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-margin=\"20px 0 0 0\"><sk-two-lists sk-src-title=Comercial.ConfiguracaoColetorConferencia.lblCamposDisponiveis sk-dest-title=Comercial.ConfiguracaoColetorConferencia.lblCamposSelecionados sk-src-data=ctrl.srcDataOrd sk-dest-data=ctrl.srcDataOrdDest sk-on-move-item=\"ctrl.onMoveItem(item, listName)\" layout-padding><sk-src-item-tpl><div>{{item.description}}</div></sk-src-item-tpl><sk-dest-item-tpl><sk-hbox flex><span flex>{{item.description}}</span><sk-icon svg-src=/mge/assets/svg/sort-a-z.svg ng-if=\"item.ordenacaoDescendente != 'S'\" ng-click=\"item.alterarOrdenacao(item,'S')\" class=gridconfig-sort-priority tooltip=Ascendente></sk-icon><sk-icon svg-src=/mge/assets/svg/sort-z-a.svg ng-if=\"item.ordenacaoDescendente == 'S'\" ng-click=\"item.alterarOrdenacao(item,'N')\" class=gridconfig-sort-priority tooltip=Descendente></sk-icon></sk-hbox></sk-dest-item-tpl></sk-two-lists></sk-viewstack-content></sk-viewstack>");
  $templateCache.put("commons/coletorConferenciaLayout/typeSelectColetor/type-select-coletor.tpl.html",
    "<div id={{internalDivId}} flex class=\"btn-group dropdown btn-filter-start-page\" dropdown auto-close=outsideClick dropdown-append-to-body ng-click=adjustDropdownLeft() tooltip={{getGeneralLabel()}} tooltip-append-to-body=true><button type=button ng-disabled=configDisabled class=\"btn btn-filter btn-sk-sm\" ng-class=buttonColor tooltip-append-to-body=true><sk-icon font-icon=filter></sk-icon></button> <button type=button class=\"btn dropdown-toggle\" dropdown-toggle ng-class=buttonColor><span class=caret></span></button><ul id={{internaldUlId}} class=\"sk-type-select dropdown-menu\" role=menu aria-labelledby=split-button><li ng-repeat=\"data in dataProvider\" role=menuitem layout=row><div ng-click=\"data.value = !data.value; data.changeFn(data.id, data.value);\"><sk-icon font-icon={{data.iconPath}} class=left ng-if=\"::data.iconType == 'glyphicon'\"></sk-icon><sk-icon svg-src={{data.iconPath}} class=left ng-if=\"::data.iconType == 'svg'\"></sk-icon><img src={{data.iconPath}} width={{data.width}} height={{data.height}} class=left ng-if=\"::data.iconType == 'img'\"> <span class=text ng-bind=data.label></span></div><sk-switch sk-value=data.value sk-true-value=true sk-false-value=false sk-change=\"processChange(data.id, data.value, data.changeFn);\"></sk-switch></li></ul></div>");
  $templateCache.put("commons/config/configuracaoUsuario.tpl.html",
    "<sk-form model=ctrl.formValues properties=ctrl.formProperties columns=2></sk-form>");
  $templateCache.put("commons/config/copiarConfigUsuario.tpl.html",
    "<sk-wizard sk-context=ctrl.wizardData sk-hide-indicators=false sk-on-cancel=ctrl.onCancel() sk-on-finish=ctrl.onFinish($step) layout flex><sk-step sk-title=Core.CadastroUsuarios.lblSelecioneUsuario sk-template-url=commons/config/step/stepSelecionaUsuario.tpl.html sk-controller=StepSelecionaUsuarioController sk-controller-as=ctrl></sk-step><sk-step sk-title=Core.CadastroUsuarios.lblOqueCopiar sk-template-url=commons/config/step/stepSelecionaConfig.tpl.html sk-controller=StepSelecionaConfigController sk-controller-as=ctrl></sk-step><sk-step sk-title=Core.CadastroUsuarios.lblTelas sk-template-url=commons/config/step/stepSelecionaTelas.tpl.html sk-controller=StepSelecionaTelasController sk-controller-as=ctrl sk-disabled=ctrl.desabilitaSelecaoTelas()></sk-step><sk-step sk-title=Core.CadastroUsuarios.lblAvisos sk-finalize=true><h4 sk-margin=\"10px 0 0 0\"><span sk-color=red sk-i18n>Geral.lblAtencao</span> <span sk-i18n>Core.CadastroUsuarios.messageAlertaConfiguracoes</span></h4></sk-step></sk-wizard>");
  $templateCache.put("commons/config/step/stepSelecionaConfig.tpl.html",
    "<sk-vbox class=step-container flex><sk-simple-form sk-columns=1 white flex><sk-simple-item ng-if=ctrl.isSUP><h5 class=\"text-danger text-bold\" sk-i18n>Core.CadastroUsuarios.lblAtencaoIsSup</h5></sk-simple-item><sk-simple-item><sk-hbox align=\"start center\"><label class=\"form-input-label text-bold\"><span sk-i18n>Core.CadastroUsuarios.lblTipoCopia</span><span class=required>*</span></label><span flex><sk-divider></sk-divider></span></sk-hbox><sk-vbox sk-margin=\"8px 0 0 0\"><sk-radio-input sk-value=ctrl.form.tipoCopia sk-option=P sk-change=ctrl.validacoesRadioGroup() sk-name=grupoConfig sk-margin=\"0 0 5px 0\"><span class=text-bold sk-i18n>Core.CadastroUsuarios.lblPersonalizacao</span> <span sk-i18n>Core.CadastroUsuarios.lblPersonalizacaoDetalhe</span></sk-radio-input><sk-radio-input sk-value=ctrl.form.tipoCopia sk-option=A sk-change=ctrl.validacoesRadioGroup() sk-enabled=!ctrl.isSUP sk-name=grupoConfig sk-margin=\"0 0 5px 0\"><span class=text-bold sk-i18n>Core.CadastroUsuarios.lblAcessos</span> <span sk-i18n>Core.CadastroUsuarios.lblAcessosDetalhe</span></sk-radio-input><sk-radio-input sk-value=ctrl.form.tipoCopia sk-option=TODAS sk-change=ctrl.validacoesRadioGroup() sk-enabled=!ctrl.isSUP sk-name=grupoConfig sk-margin=\"0 0 5px 0\"><span class=text-bold sk-i18n>Core.CadastroUsuarios.lblAmbos</span></sk-radio-input><sk-hbox align=\"start center\"><sk-switch sk-value=ctrl.form.checkAbaSeguranca sk-enabled=ctrl.enableCheckAbaSeguranca sk-margin=\"0 5px 0 0\"></sk-switch><span class=text-bold sk-i18n>Core.CadastroUsuarios.lblIncluirConfig</span> <span sk-i18n>Core.CadastroUsuarios.lblIncluirConfigDetalhe</span></sk-hbox></sk-vbox></sk-simple-item><sk-simple-item><sk-hbox align=\"start center\"><label class=\"form-input-label text-bold\" sk-i18n>Core.CadastroUsuarios.lblConfigTop</label><span flex><sk-divider></sk-divider></span></sk-hbox><sk-vbox gap=12 sk-margin=\"8px 0 0 0\"><sk-hbox align=\"start center\"><sk-switch sk-value=ctrl.form.checkConfigTOP sk-change=ctrl.validaCheckConfTop()></sk-switch><span class=text-bold sk-margin=\"0 5px\" sk-i18n>Core.CadastroUsuarios.lblIncluirConfigTop</span><sk-help-tip class=text-primary sk-i18n sk-text=Core.CadastroUsuarios.infoIncluirConfigTop></sk-help-tip></sk-hbox><sk-hbox align=\"start center\"><sk-switch sk-value=ctrl.form.checkCopiarRest sk-enabled=ctrl.enableCopiarRest sk-change=ctrl.validateBtnNext()></sk-switch><span class=text-bold sk-margin=\"0 0 0 5px\" sk-i18n>Core.CadastroUsuarios.lblCopiarRestricaoTop</span></sk-hbox><sk-hbox align=\"start center\"><sk-switch sk-value=ctrl.form.checkCopiarExc sk-enabled=ctrl.enableCopiarExc sk-change=ctrl.validateBtnNext()></sk-switch><span class=text-bold sk-margin=\"0 0 0 5px\" sk-i18n>Core.CadastroUsuarios.lblCopiarExcecaoTop</span></sk-hbox></sk-vbox></sk-simple-item><sk-simple-item><sk-hbox align=\"start center\"><label class=\"form-input-label text-bold\"><span sk-i18n>Core.CadastroUsuarios.lblConfigPreExist</span><span class=required>*</span></label><span flex><sk-divider></sk-divider></span></sk-hbox><sk-vbox sk-margin=\"8px 0 0 0\"><sk-hbox align=\"start center\" sk-margin=\"0 0 5px 0\"><sk-radio-input sk-value=ctrl.form.addInfoExistente sk-option=S sk-change=ctrl.validateBtnNext() sk-name=grupoAddInfo sk-margin=\"0 5px 0 0\" style=width:auto><span class=text-bold sk-i18n>Core.CadastroUsuarios.lblManterConfig</span></sk-radio-input><sk-help-tip class=text-primary sk-i18n sk-text=Core.CadastroUsuarios.infoManterConfig></sk-help-tip></sk-hbox><sk-hbox align=\"start center\" sk-margin=\"0 0 5px 0\"><sk-radio-input sk-value=ctrl.form.addInfoExistente sk-option=N sk-change=ctrl.validateBtnNext() sk-enabled=!ctrl.isSUP sk-name=grupoAddInfo sk-margin=\"0 5px 0 0\" style=width:auto><span class=text-bold sk-i18n>Core.CadastroUsuarios.lblRemoveConfig</span></sk-radio-input><sk-help-tip class=text-primary sk-i18n sk-text=Core.CadastroUsuarios.infoRemoveConfig></sk-help-tip></sk-hbox></sk-vbox></sk-simple-item><sk-simple-item sk-margin=0><sk-hbox align=\"start center\"><label class=\"form-input-label text-bold\" sk-i18n>Core.CadastroUsuarios.lblTelas</label><span flex><sk-divider></sk-divider></span></sk-hbox><sk-vbox sk-margin=\"8px 0 0 0\"><sk-hbox align=\"start center\"><sk-switch sk-value=ctrl.form.checkSelecionarTelas sk-change=ctrl.chkSelecionaTelasChange() sk-enabled=ctrl.enableCheckSelecionarTelas></sk-switch><span class=text-bold sk-margin=\"0 5px\" sk-i18n>Core.CadastroUsuarios.lblSelecionaTela</span><sk-help-tip class=text-primary sk-i18n sk-text=Core.CadastroUsuarios.infoSelecionaTela></sk-help-tip></sk-hbox></sk-vbox></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/config/step/stepSelecionaTelas.tpl.html",
    "<sk-vbox class=step-container flex><sk-two-lists sk-tree-mode=true sk-tree-ctrl=ctrl.treeCtrl sk-src-title=Core.CadastroUsuarios.lblTelasDisponivel sk-dest-title=Core.CadastroUsuarios.lblTelasSelecionados sk-src-data=ctrl.telasProvider sk-dest-data=ctrl.selecionadosProvider sk-enable-sort=false sk-move-all-to-right=false sk-move-all-to-left=false sk-handle-only-analytics=true sk-on-move-item=ctrl.onSelectItem()></sk-two-lists></sk-vbox>");
  $templateCache.put("commons/config/step/stepSelecionaUsuario.tpl.html",
    "<sk-vbox class=step-container flex><sk-two-lists sk-src-title=Core.CadastroUsuarios.lblUsuariosDisponivel sk-dest-title=Core.CadastroUsuarios.lblUsuariosSelecionados sk-src-data=ctrl.srcUserData sk-dest-data=ctrl.destUserData sk-src-filter-fn=\"ctrl.searchFilterFn(item, searchTerm)\" sk-dest-filter-fn=\"ctrl.searchFilterFn(item, searchTerm)\" sk-enable-sort=false sk-on-move-item=ctrl.onSelectItem()><sk-src-item-tpl>{{ item.CODUSU['$'] + ' - ' + item.NOMEUSU['$'] }}</sk-src-item-tpl><sk-dest-item-tpl>{{ item.CODUSU['$'] + ' - ' + item.NOMEUSU['$'] }}</sk-dest-item-tpl></sk-two-lists></sk-vbox>");
  $templateCache.put("commons/construtornomearquivo/construtornomepopup.tpl.html",
    "<sk-hbox class=construtor-nome-popup flex><sk-group-container sk-title=\"{{ ctrl.titVariaveis }}\" flex><sk-text-input sk-value=searchText layout-pedding style=\"margin-bottom: 5px\" sk-placeholder=Commons.Expressoes.lblFiltrarVariaveis sk-i18n></sk-text-input><sk-vbox flex><sk-list sk-scroll-container flex class=list-container><div layout-align=\"space-between center\" layout=row ng-repeat=\"variavel in ctrl.variaveis | filter:searchText:ctrl.compararVariavel\" ng-dblclick=ctrl.adicionarVariavel(variavel.expressao) ng-click=ctrl.visualizarResumoVariavel(variavel)><label ng-bind=variavel.nome></label><button class=\"btn btn-default btn-sk-sm\" ng-click=ctrl.adicionarVariavel(variavel.expressao)><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button></div></sk-list><div class=resumo-container flex=20 ng-if=ctrl.visibleResumoVariavel><label ng-bind=ctrl.resumoVariavel></label></div></sk-vbox></sk-group-container><sk-group-container sk-title=\"{{ ctrl.titExpressao }}\" flex><sk-text-area sk-value=ctrl.nomeArquivo class=variavel-text-area sk-component-created=ctrl.textAreaCreated($component)></sk-text-area></sk-group-container></sk-hbox>");
  $templateCache.put("commons/containerLiberacaoLimites/containerLiberacaoLimites.tpl.html",
    "<sk-dataset id=dsLibLimites entity-name=ViewLiberacaoLimite sk-dataset-created=ctrl.onDatasetCreated(dataset) metadata-interceptor=ctrl.interceptMetadata sk-standalone><sk-field pattern=*></sk-field><sk-field pattern=CODCID path=Parceiro></sk-field><sk-field pattern=NOMECID path=Parceiro.Cidade></sk-field><sk-field pattern=CODCIDENTREGA path=Parceiro.ComplementoParc></sk-field><sk-field pattern=NOMECID path=Parceiro.ComplementoParc.Cidade></sk-field><sk-field pattern=$USERFIELDS></sk-field></sk-dataset><sk-dataset id=dsItemNota entity-name=ItemNota sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandlerItens(request) crud-listener=br.com.sankhya.modelcore.crudlisteners.LiberacaoLimitesItemNotaCrudListener metadata-interceptor=ctrl sk-standalone><sk-field pattern=CODPROD,CONTROLE,USOPROD,QTDNEG,CODVOL,OBSERVACAO,CODLOCALORIG,VLRUNIT,VLRTOT,VLRDESC,PERCDESC,VLRREPRED,VLRDESCBONIF,VLRCUS></sk-field><sk-field pattern=COMPLDESC,MARCA,DECQTD,DECVLR,REFERENCIA,DESCRPROD path=Produto></sk-field><sk-field pattern=$USERFIELDS></sk-field></sk-dataset><sk-vbox sk-width=100% sk-height=100% layout=column flex><div id=vendaMais style=\"display: none\"></div><sk-vbox sk-width=100%><sk-hbox class=high-contrast-panel layout-padding sk-margin=5px style=\"border-radius: 5px; font-size: 12pt; font-weight: bold\" sk-width=100% ng-show=ctrl.ehCentral><span>{{ctrl.lblLiberacoes}}</span></sk-hbox></sk-vbox><sk-hbox flex><sk-sidenav class=sksidenav is-open=true child-layout=column sk-width=327px sk-height=100% layout flex><sk-vbox flex><sk-vbox gap=5 ng-show=ctrl.ehCentral sk-padding-left=5px flex><sk-hbox gap=5><button default ng-click=ctrl.voltarParaCentral() sk-width=100% font-icon=arrow-left>Voltar</button> <button primary ng-click=ctrl.apply() sk-width=100% font-icon=filter sk-i18n>Geral.lblAplicar</button></sk-hbox><sk-simple-form sk-columns=1><sk-vbox style=\"background: #E3E3E3; border-radius:5px\" layout-padding flex><span class=text-bold sk-i18n layout-padding>Commons.Liberacoes.labelLiberador</span><sk-simple-item style=height:45px sk-label=Geral.labelUsuario sk-required=true><sk-text-input sk-enabled=\"ctrl.souLiberador == 'N'\" sk-value=ctrl.nomeUsu></sk-text-input></sk-simple-item><sk-simple-item style=height:45px sk-label=Geral.labelSenha sk-required=true><sk-text-input sk-enabled=\"ctrl.souLiberador == 'N'\" sk-value=ctrl.senhaUsu sk-password=true sk-keydown=ctrl.atualizaLiberacoes($event)></sk-text-input></sk-simple-item><sk-simple-item style=height:45px sk-label=Commons.Liberacoes.lblSouLiberador><sk-switch sk-value=ctrl.souLiberador sk-change=ctrl.changeSouLiberador() sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item></sk-vbox></sk-simple-form><sk-vbox sk-padding-left=5px gap=2><sk-hbox layout-align=\"start center\" gap=5><span sk-i18n>Commons.Liberacoes.lblApresentar</span><hr style=\"border: 2 solid #b8b8b8; width: 100%\"></sk-hbox><sk-combobox sk-value=ctrl.tipoSlide sk-options=ctrl.tipoSlideOptions></sk-combobox></sk-vbox></sk-vbox><sk-filter-panel sk-apply-function=ctrl.apply() sk-resource-id=\"{{ ::ctrl.resourceID }}\" sk-instancia-name=\"{{ ::ctrl.filterPanelID }}\" sk-data-source=ctrl.dsLibLimites sk-is-open=true sk-has-active-filter=false sk-dynamic-filter=false sk-hide-btn-apply=true sk-filter-panel-interceptor=ctrl sk-custom-criteria-loader=ctrl.getCriteria() sk-panel-width=100% ng-show=!ctrl.ehCentral flex><default-group><sk-simple-form sk-columns=1><sk-vbox style=\"background: #E3E3E3; border-radius:5px; padding: 10px\" layout-padding flex><span class=text-bold sk-i18n layout-bottom-padding>Commons.Liberacoes.labelLiberador</span><sk-simple-item sk-label=Geral.labelUsuario sk-required=true><sk-text-input sk-enabled=\"ctrl.souLiberador == 'N'\" sk-value=ctrl.nomeUsu></sk-text-input></sk-simple-item><sk-simple-item sk-label=Geral.labelSenha sk-required=true><sk-text-input sk-enabled=\"ctrl.souLiberador == 'N'\" sk-value=ctrl.senhaUsu sk-keydown=ctrl.atualizaLiberacoes($event) sk-password=true></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblSouLiberador><sk-switch sk-value=ctrl.souLiberador sk-change=ctrl.changeSouLiberador() sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item></sk-vbox><sk-simple-item sk-label=Commons.Liberacoes.labelNroUnico layout-top-padding><sk-number-input sk-value=ctrl.nroUnico></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelPeriodoSolicitacao><sk-date-period-input sk-value=ctrl.periodo></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblApresentar layout-top-padding><sk-combobox sk-value=ctrl.tipoSlide sk-options=ctrl.tipoSlideOptions></sk-combobox></sk-simple-item></sk-simple-form></default-group><custom-group label=Commons.Liberacoes.labelFiltroSolicitantes><sk-entity-list sk-entity-name=Solicitante sk-value=ctrl.entityListSolicitantes sk-component-created=ctrl.onCreatedListSolicitantes($component) sk-show-label=true sk-show-checkbox=true sk-on-change=ctrl.onChangeSolicitante()></sk-entity-list></custom-group></sk-filter-panel></sk-vbox></sk-sidenav><sk-vbox flex><sk-hbox layout-padding sk-margin-bottom=-5px gap=5><sk-grid-config sk-config-name={{::gridConfig}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.datagrid></sk-grid-printer><sk-navigator dataset=ctrl.dsLibLimites sk-show-add-button=false sk-show-navigation=true sk-show-save-button=true sk-show-copy-button=false sk-show-remove-button=false sk-show-refresh-button=true></sk-navigator><sk-btn-other-options sk-build-on-every-click=true sk-other-options=ctrl.buildButtonOptions() ng-show=!ctrl.ehCentral></sk-btn-other-options><button default id=btnDetalhesConf ng-click=ctrl.mostraDetalhesConf() ng-disabled=!ctrl.btnDetalhesConf.enabled tooltip=Commons.Liberacoes.tooltipDetalhesConf><span sk-i18n>Commons.Liberacoes.btnDetalhesConf</span></button><sk-action-button sk-entity-name=ViewLiberacaoLimite sk-resource-id=\"{{ ::ctrl.resourceID }}\" sk-access-resource-id=\"{{ ::ctrl.resourceID }}\" sk-context=ctrl.contextoLibLimites></sk-action-button><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsLibLimites></sk-rows-counter></div></sk-hbox><sk-hbox gap=5 layout-padding sk-margin-right=5px><sk-dropdown-menu id=dropdown-analise default sk-dropdown-loaded=ctrl.onDropdownLoaded sk-always-load-properties=true sk-drop-name=dropdownAnalise sk-open-always=true sk-tooltip=Commons.Liberacoes.btnAbreAnalise sk-label=Commons.Liberacoes.btnAbreAnalise sk-font-icon=signal sk-font-icon=more sk-build-options=ctrl.buildAnaliseButtonOptions() sk-width=\"calc(150px + 26.45px)\" sk-btn-disabled=!ctrl.btnAnalise.enabled sk-build-on-every-click=true></sk-dropdown-menu><button default id=btnDetalhesNota ng-click=ctrl.mostraDetalhes() tooltip=Commons.Liberacoes.buttonDetalhesNotaTooltip sk-width=150px sk-height=28px font-icon=list-alt ng-disabled=!ctrl.btnDetalhesNota.enabled sk-i18n>Commons.Liberacoes.buttonDetalhesNota</button> <button default id=btnFichaParc ng-click=ctrl.abrirFichaParceiro() tooltip=Commons.Liberacoes.buttonFichaParceiroTooltip sk-width=150px sk-height=28px font-icon=arrow-right ng-disabled=!ctrl.btnFichaParc.enabled sk-i18n>Commons.Liberacoes.buttonFichaParceiro</button> <button default id=btnRentabilidade ng-click=ctrl.mostrarRentabilidade() tooltip=Commons.Rentabilidade.buttonRentabilidadeTooltip sk-width=150px sk-height=28px ng-disabled=!ctrl.btnRentabilidade.enabled font-icon=object-align-left sk-i18n>Commons.Rentabilidade.buttonRentabilidade</button> <button default id=btnLiberar ng-click=ctrl.mostraPopUpLiberacaoNegacao(true) tooltip=Commons.Liberacoes.buttonLiberarTooltip sk-width=150px sk-height=28px font-icon=unlock ng-disabled=!ctrl.btnLiberar.enabled sk-i18n>Commons.Liberacoes.buttonLiberar</button> <button default id=btnNegarLiberacao ng-click=ctrl.mostraPopUpLiberacaoNegacao(false) tooltip=Commons.Liberacoes.buttonNegarTooltip sk-width=150px sk-height=28px font-icon=lock ng-disabled=!ctrl.btnNegarLiberacao.enabled sk-i18n>Commons.Liberacoes.buttonNegar</button></sk-hbox><sk-resizable-rows style=\"height: 100%\"><div sk-resizable sk-direction=\"'bottom'\" sk-height=60 style=\"padding-left: 0px; padding-right: 0px; padding-top: 0px\"><sk-datagrid sk-dataset=ctrl.dsLibLimites sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=true sk-editable=false sk-disable-tour=false sk-on-dbl-click=ctrl.acaoDoubleClickLiberacao() sk-grid-config={{::gridConfig}}></sk-datagrid></div><div flex style=\"padding-left: 0px; padding-right: 0px; padding-top: 0px\"><sk-vbox flex><sk-hbox layout-padding gap=5 layout=row ng-show=\"ctrl.checkItensNota == 'S'\"><sk-grid-config sk-config-name={{::gridConfigItemNota}}></sk-grid-config><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=dsItemNota></sk-rows-counter></div></sk-hbox><sk-datagrid ng-show=\"ctrl.checkItensNota == 'S'\" sk-dataset=dsItemNota sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=true sk-editable=false sk-disable-tour=true sk-on-dbl-click=\"\" sk-grid-config={{::gridConfigItemNota}} flex></sk-datagrid></sk-vbox></div></sk-resizable-rows></sk-vbox></sk-hbox></sk-vbox>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/central/popUpOcorrenciasNotaServico.tpl.html",
    "<sk-dataset id=dataGridNotas sk-refresh-handler=ctrl.refreshHandler(request) sk-dataset-created=ctrl.onDatasetCreatedOne(dataset) sk-standalone><sk-dsfield-md name=numeroUnico description=Commons.Central.headerNroUnico sk-i18n></sk-dsfield-md><sk-dsfield-md name=numeroNota description=Commons.Central.headerNroNota sk-i18n></sk-dsfield-md><sk-dsfield-md name=statusnfe description=Commons.Central.headerStatusNFe sk-i18n></sk-dsfield-md><sk-dsfield-md name=numeroLoteNfe description=Commons.Central.headerNroLoteNFe sk-i18n></sk-dsfield-md><sk-dsfield-md name=observacaoNfe description=Commons.Central.headerObservacaoNFe sk-i18n></sk-dsfield-md><sk-dsfield-md name=statusnfse description=Commons.Central.headerStatusNFSe sk-i18n></sk-dsfield-md><sk-dsfield-md name=numeroLoteNfse description=Commons.Central.headerNroLoteNFSe sk-i18n></sk-dsfield-md><sk-dsfield-md name=observacaoNfse description=Commons.Central.headerObservacaoNFSe sk-i18n></sk-dsfield-md></sk-dataset><sk-dataset id=dataGridOcorrencias sk-refresh-handler=ctrl.refreshHandler(request) sk-dataset-created=ctrl.onDatasetCreatedTwo(dataset) sk-standalone><sk-dsfield-md name=dhocorrencia description=Commons.Central.headerDataOcorrencia sk-i18n></sk-dsfield-md><sk-dsfield-md name=usuario description=Geral.labelUsuario sk-i18n></sk-dsfield-md><sk-dsfield-md name=ocorrencias description=Commons.Central.headerStatusNFe sk-i18n></sk-dsfield-md></sk-dataset><sk-viewstack id=viewMain sk-width=100% sk-height=100%><sk-hbox ng-if=ctrl.telaOne sk-width=100% sk-height=100%><sk-vbox sk-width=100% sk-height=100%><label sk-i18n>Commons.Central.labelNotasRecusadas</label><sk-datagrid sk-dataset=ctrl.dsNotas sk-on-datagrid-loaded=ctrl.onGridLoadedOne(datagrid) sk-allow-multiple-selection=false sk-on-dbl-click=ctrl.mostraObservacao() sk-disable-tour=true sk-on-click=ctrl.verificaRowsGridNotas() sk-editable=false></sk-datagrid><label id=lblAcompanhamentoNota sk-i18n>Commons.Central.labelAcompanhamentoNota</label><sk-datagrid sk-dataset=ctrl.dsOcorrencia sk-on-datagrid-loaded=ctrl.onGridLoadedTwo(datagrid) sk-allow-multiple-selection=false sk-disable-tour=true sk-on-click=ctrl.verificaRowsGridOcorrencias() sk-on-dbl-click=ctrl.mostraDetalheOcorrencia() sk-editable=false></sk-datagrid></sk-vbox></sk-hbox><sk-hbox ng-if=ctrl.telaTwo sk-width=100% sk-height=100%><sk-vbox sk-width=100% sk-height=100%><sk-simple-form sk-columns=1><sk-simple-item><sk-label style=\"font-weight: bold\" id=labelLoteNfe sk-value=ctrl.labelLoteNfe></sk-label></sk-simple-item><span style=\"font-weight: bold\" sk-i18n>Commons.Central.headerObservacaoNFe</span><sk-text-area id=textObservacaoNfe sk-value=ctrl.textObservacaoNfe sk-height=190 sk-enabled=false></sk-text-area><sk-simple-item><sk-label style=\"font-weight: bold\" id=labelLoteNfse sk-value=ctrl.labelLoteNfse></sk-label></sk-simple-item><span style=\"font-weight: bold\" sk-i18n>Commons.Central.headerObservacaoNFSe</span><sk-text-area id=textObservacaoNfse sk-value=ctrl.textObservacaoNfse sk-height=190 sk-enabled=false></sk-text-area></sk-simple-form></sk-vbox></sk-hbox><sk-hbox ng-if=ctrl.telaThree sk-width=100% sk-height=100%><sk-vbox sk-width=100% sk-height=100%><sk-simple-form sk-columns=1><sk-simple-item sk-label=Commons.Central.headerNroUnico><sk-label id=labelNumUnico style=\"font-weight: bold\" sk-value=ctrl.labelNumUnico></sk-label></sk-simple-item><sk-simple-item sk-label=Commons.Central.headerNroNota><sk-label id=labelNuNota style=\"font-weight: bold\" sk-value=ctrl.labelNuNota></sk-label></sk-simple-item><sk-simple-item sk-label=Commons.Central.headerDataOcorrencia><sk-label id=labelDtOcorr style=\"font-weight: bold\" sk-value=ctrl.labelDtOcorr></sk-label></sk-simple-item><sk-simple-item sk-label=Geral.labelUsuario><sk-label id=labelUsuario style=\"font-weight: bold\" sk-value=ctrl.labelUsuario></sk-label></sk-simple-item></sk-simple-form><span style=\"font-weight: bold\" sk-i18n>Commons.Central.labelDetalhesOcorrencia</span><sk-text-area id=textDetalhe sk-width=100% sk-height=100% sk-enabled=false sk-value=ctrl.textDetalhe></sk-text-area></sk-vbox></sk-hbox></sk-viewstack>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/configuracaoGadgetEvento/configuracaoGadgetEvento.tpl.html",
    "<sk-dataset entity-name=GadgetEventoLiberacao id=dsGadgetEventoLiberacao sk-dataset-created=ctrl.onDatasetCreated(dataset)></sk-dataset><sk-hbox style=\"padding-bottom: 5px\"><button class=\"btn btn-default click_me\" sk-popover popover-template-url=commons/containerLiberacaoLimites/popup/configuracaoGadgetEvento/popoverComponentBI/popoverComponenteBI.tpl.html controller-name=popoverComponentBIController controller-as=ctrl show-btn-close=false create-on-load=false properties=ctrl.getPopOverProperties() popover-hide-on-button-click=true popover-hide-on-outside-click=false width=auto height=auto ds-gadget-evento-liberacao=ctlr.dsGadgetEventoLiberacao popover-listeners=ctrl.popoverMenuListeners><span sk-i18n>Geral.novo</span></button><div style=\"padding-left: 10px\"><button class=\"btn btn-default\" ng-click=ctrl.removeSelecionados() sk-i18n>Geral.removerSelecionado</button></div></sk-hbox><sk-datagrid sk-dataset=ctrl.dsGadgetEventoLiberacao sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-datagrid-interceptor=ctrl></sk-datagrid>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/configuracaoGadgetEvento/popoverComponentBI/popoverComponenteBI.tpl.html",
    "<div><sk-vbox style=\"background-color: 0xFFFFCC\"><sk-form sk-dataset=ctrl.dsGadgetEventoLiberacao style=\"width: 400px\"></sk-form><sk-hbox layout-align=\"end end\"><div style=\"padding-right: 10px\"><button class=\"btn btn-default\" ng-click=ctrl.salvaEventoLiberacaoGadget()>Salvar</button></div><div><button class=\"btn btn-default\" ng-click=ctrl.fechaPopOver()>Fechar</button></div></sk-hbox></sk-vbox></div>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/configuracoes/liberacaoLimitesConfiguracoes.tpl.html",
    "<sk-simple-form sk-columns=2><sk-simple-item sk-label=Commons.Liberacoes.labelIntervaloAtualizacaoAuto><sk-numeric-stepper sk-value=ctrl.intervaloAtualizacaoAuto sk-step-size=5 sk-sufix-char=segundos></sk-numeric-stepper></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblFiltroPeriodo><sk-hbox gap=5 style=\"align-items: center\"><sk-combobox sk-value=ctrl.filtroPeriodos sk-options=ctrl.optionsfiltroPeriodos sk-allow-null=false style=\"width: 100%\"></sk-combobox><sk-help-tip sk-i18n sk-text=Commons.Liberacoes.helpFiltroPeriodos></sk-help-tip></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelVerItensNota><sk-switch sk-value=ctrl.checkItensNota sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelRecarregarPorLiberacao><sk-switch sk-value=ctrl.checkRecarregarLibNegacao sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelConfirmarAuto><sk-switch sk-value=ctrl.checkConfirmarAutomaticamente sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelCompensarAuto><sk-switch sk-value=ctrl.checkCompensarAutomaticamente sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblPendentesPadrao><sk-hbox gap=5 style=\"align-items: center\"><sk-switch sk-value=ctrl.checkPendentesPadrao sk-true-value=S sk-false-value=N></sk-switch><sk-help-tip sk-i18n sk-text=Commons.Liberacoes.helpPendentesPadrao></sk-help-tip></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblAplicarAoAbrir><sk-hbox gap=5 style=\"align-items: center\"><sk-switch sk-value=ctrl.checkFiltrarAbertura sk-true-value=S sk-false-value=N sk-change=ctrl.verificaSup()></sk-switch><sk-help-tip sk-i18n sk-text=Commons.Liberacoes.helpAplicarAoAbrir></sk-help-tip></sk-hbox></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/detalhes/DetalhesConferenciaPopUp.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-dsfield-md name=QTDCONFERIDA description=Commons.Liberacoes.headerQtdConf user-type=F></sk-dsfield-md><sk-dsfield-md name=QTDPEDIDO description=Commons.Liberacoes.headerQtdPedido user-type=F></sk-dsfield-md><sk-dsfield-md name=CODPROD description=Commons.Liberacoes.headerCodProd user-type=I></sk-dsfield-md><sk-dsfield-md name=DIFERENCA description=Commons.Liberacoes.headerDiferenca user-type=F></sk-dsfield-md><sk-dsfield-md name=CONTROLE description=Commons.Liberacoes.headerControle user-type=S></sk-dsfield-md><sk-dsfield-md name=DESCRPROD description=Commons.Liberacoes.headerDescrProd user-type=S></sk-dsfield-md><sk-dsfield-md name=TO_MEASURE description=\"\"></sk-dsfield-md></sk-dataset><sk-datagrid sk-dataset=ctrl.dsDetalhesConf sk-on-datagrid-loaded=ctrl.onGridLoaded(datagrid) sk-allow-multiple-selection=false sk-datagrid-interceptor=ctrl sk-disable-tour=true sk-editable=false></sk-datagrid>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/detalhes/detalhesNota.tpl.html",
    "<sk-simple-form sk-columns=1 sk-in-line=true class=compact-components flex><sk-simple-item sk-label=Commons.Liberacoes.labelEmpresa class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODEMP sk-entity-name=Empresa sk-disabled=true sk-value=ctrl.pesqEmp></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelNumeroNota class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.numNota sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelSerie class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.serie></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelDataNegociacao class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.dtNegociacao></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelDataPrevisaoEnt class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.dtPrevent></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblParceiro class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODPARC sk-entity-name=Parceiro sk-disabled=true sk-value=ctrl.pesqParc></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelTipoOperacao class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODTIPOPER sk-entity-name=TipoOperacao sk-disabled=true sk-value=ctrl.pesqOperacao></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelTipoNegociacao class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODTIPVENDA sk-entity-name=TipoNegociacao sk-disabled=true sk-value=ctrl.pesqNegocia></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblNatureza class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODNAT sk-entity-name=Natureza sk-disabled=true sk-value=ctrl.pesqNatureza></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblCentroResult class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODCENCUS sk-entity-name=CentroResultado sk-disabled=true sk-value=ctrl.pesqCR></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.lblProjeto class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODPROJ sk-entity-name=Projeto sk-disabled=true sk-value=ctrl.pesqProj></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelValorNota class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.vlrNota sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelDesconto class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.vlrDesconto sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelValorFrete class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.vlrFrete sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelValorDestaque class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.vlrDestaque sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelValorOutros class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.vlrOutros sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelPrimeiroVencto class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.primeiroVencimento sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelUltimoVencto class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.ultVenc sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelPrazoMedioDias class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.prazoMedio sk-align=right></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelPlaca class=OpacidadeNotas><sk-text-input sk-text-align=right sk-disabled=true sk-value=ctrl.placa></sk-text-input></sk-simple-item><sk-simple-item sk-label={{::ctrl.lblVendedor}} class=OpacidadeNotas><sk-pesquisa-input sk-field-name=CODVEND sk-entity-name=Vendedor sk-disabled=true sk-value=ctrl.pesqVend></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelObservacoes class=OpacidadeNotas><sk-text-area sk-height=90 sk-width=300 sk-field-name=OBSERVACAO sk-disabled=false sk-change=ctrl.onChangeObservacao() sk-value=ctrl.observacao></sk-text-area></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/detalhesFechamentoCtb/detalhesFechamentoCtb.tpl.html",
    "<sk-dataset entity-name=LiberacaoBloqueioContabil sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-dataset entity-name=ItensLiberacaoBloqueioContabil parent-dataset=ctrl.dsLiberacaoBloqCtb sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-simple-form sk-columns=2 sk-dataset=ctrl.dsLiberacaoBloqCtb><sk-simple-item sk-label=mge.LiberacaoLimites.lblNuLiberacao><sk-number-input sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=NULIBERACAO sk-precision=0></sk-number-input></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblStatusLib><sk-combobox sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=STATUSLIB sk-value=ctrl.comboStatusLib.value sk-change=ctrl.onChangeComboStatuslib() sk-options=array></sk-combobox></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblTipmov><sk-combobox sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=TIPOMOV sk-value=ctrl.comboTipmov.value sk-change=ctrl.onChangeComboTipmov() sk-options=array></sk-combobox></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblTipoacao><sk-combobox sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=TIPOACAO sk-value=ctrl.comboTipoacao.value sk-change=ctrl.onChangeComboTipoacao() sk-options=array></sk-combobox></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblCodusulib><sk-pesquisa-input sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=CODUSULIB sk-value=ctrl.pesquisaCodusulib.value sk-change=ctrl.onChangePesquisaCodusulib()></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblRotinactb><sk-combobox sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=ROTINACTB sk-value=ctrl.comboRotinactb.value sk-change=ctrl.onChangeComboRotinactb() sk-options=array></sk-combobox></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblDtinilib><sk-date-input sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=DTINILIB></sk-date-input></sk-simple-item><sk-simple-item sk-label=mge.LiberacaoLimites.lblDtfinlib><sk-date-input sk-dataset=ctrl.dsLiberacaoBloqCtb sk-field-name=DTFINLIB></sk-date-input></sk-simple-item></sk-simple-form><sk-datagrid sk-dataset=ctrl.dsItensLiberacaoBloqCtb></sk-datagrid>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/detalhesImpostos/detalhesImpostos.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=CODPROD description=mge.LiberacaoLimites.lblcodprod user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRPROD description=mge.LiberacaoLimites.lbldescprod user-type=S></sk-dsfield-md><sk-dsfield-md name=DIVERGENCIA description=mge.LiberacaoLimites.lblDivegenciaSistema user-type=S></sk-dsfield-md><sk-dsfield-md name=BASESISTEMA description=mge.LiberacaoLimites.lblbasesistema user-type=F></sk-dsfield-md><sk-dsfield-md name=VLRSISTEMA description=mge.LiberacaoLimites.lblvlrsistema user-type=F></sk-dsfield-md><sk-dsfield-md name=BASEARQUIVO description=mge.LiberacaoLimites.lblbasearquivo user-type=F></sk-dsfield-md><sk-dsfield-md name=VLRARQUIVO description=mge.LiberacaoLimites.lblvlrarquivo user-type=F></sk-dsfield-md></sk-dataset><sk-hbox><sk-grid-config sk-config-name={{::gridConfig}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.datagrid></sk-grid-printer><sk-navigator dataset=ctrl.dsImpostos sk-show-add-button=false sk-show-navigation=true sk-show-save-button=false sk-show-copy-button=false sk-show-remove-button=false sk-show-refresh-button=false></sk-navigator></sk-hbox><sk-datagrid sk-dataset=ctrl.dsImpostos sk-on-datagrid-loaded=ctrl.onDataGridLoaded(datagrid) sk-grid-config={{::gridConfig}} sk-disable-tour=true><sk-datagrid-custom-column sk-field-name=CODPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=DESCRPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=DIVERGENCIA sk-visible=true><sk-datagrid-custom-column sk-field-name=BASESISTEMA sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRSISTEMA sk-visible=true><sk-datagrid-custom-column sk-field-name=BASEARQUIVO sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRARQUIVO sk-visible=true></sk-datagrid>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/detalhesProdutos/detalhesProdutos.tpl.html",
    "<sk-dataset entity-name=Produto sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=DIVERGENCIA description=mge.LiberacaoLimites.lblDivegenciaSistema user-type=S></sk-dsfield-md><sk-dsfield-md name=VALORSISTEMA description=mge.LiberacaoLimites.lblValorSistema user-type=S></sk-dsfield-md><sk-dsfield-md name=VALORARQUIVO description=mge.LiberacaoLimites.lblArquivoSistema user-type=S></sk-dsfield-md></sk-dataset><sk-hbox><sk-grid-config sk-config-name={{::gridConfig}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.datagrid></sk-grid-printer><sk-navigator dataset=ctrl.dsProdutos sk-show-add-button=false sk-show-navigation=true sk-show-save-button=false sk-show-copy-button=false sk-show-remove-button=false sk-show-refresh-button=false></sk-navigator></sk-hbox><sk-datagrid sk-dataset=ctrl.dsProdutos sk-on-datagrid-loaded=ctrl.onDataGridLoaded(datagrid) sk-grid-config={{::gridConfig}} sk-disable-tour=true sk-only-custom><sk-datagrid-custom-column sk-field-name=CODPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=DESCRPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=REFERENCIA sk-visible=true><sk-datagrid-custom-column sk-field-name=REFFORN sk-visible=true><sk-datagrid-custom-column sk-field-name=MARCA sk-visible=true><sk-datagrid-custom-column sk-field-name=DIVERGENCIA sk-visible=true><sk-datagrid-custom-column sk-field-name=VALORSISTEMA sk-visible=true><sk-datagrid-custom-column sk-field-name=VALORARQUIVO sk-visible=true></sk-datagrid>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/editarObservacao/editarObservacao.tpl.html",
    "<sk-simple-form sk-width=100% sk-height=100% sk-columns=1><sk-vbox style=\"background-color: 0xFFFFCC\"><sk-simple-item sk-label=Commons.Liberacoes.labelObsSolicitante><sk-text-area sk-value=ctrl.obsUmouVarias sk-component-created=\"\" id=txtObsSolic sk-height=30 sk-enabled=false></sk-text-area></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelObservacaoLiberador style=\"margin-top: 50px\"><sk-text-area sk-value=ctrl.obsLib sk-component-created=\"\" id=txtObsLib sk-height=30></sk-text-area></sk-simple-item></sk-vbox></sk-simple-form>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/liberarNegarLimite/liberacaoNegacaoLimitesPopUp.tpl.html",
    "<sk-vbox gap=5 flex><sk-vbox ng-show=ctrl.possuiVariosItensSelec style=\"background-color: #FFFFCC\" layout-align=\"center center\" layout-padding><span ng-bind-html=ctrl.lblInformacao></span></sk-vbox><sk-simple-form sk-in-line=true class=compact-components sk-columns=1 flex><sk-simple-item sk-label=Commons.Liberacoes.labelValorLiberado ng-if=ctrl.ehLiberacao><sk-number-input sk-precision=ctrl.valorLiberadoPrecision sk-value=ctrl.vlrLiberado></sk-simple-item><sk-simple-item sk-label=Commons.Liberacoes.labelObservacaoLiberador><sk-text-area sk-value=ctrl.txtObsLib sk-height=180></sk-text-area></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/observacaoCompl/observacaoComplPopUp.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-columns=1><sk-simple-item sk-label=Commons.Liberacoes.lblObservacaoComplementar><sk-text-area sk-value=ctrl.obsComp sk-height=180 sk-enabled=false></sk-text-area></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/containerLiberacaoLimites/popup/resultadosOrcamento/resultadosOrcamento.tpl.html",
    "<sk-hbox layout-align=\"center center\" gap=10 class=resultados flex><sk-vbox gap=10 class=resultados-labels sk-padding-top=25px><span sk-i18n>Commons.Liberacoes.lblOrcado</span> <span sk-i18n>Commons.Liberacoes.lblSuplementacao</span> <span sk-i18n>Commons.Liberacoes.lblAntecipacao</span> <span sk-i18n>Commons.Liberacoes.lblTransferencias</span> <span sk-i18n>Commons.Liberacoes.lblTransferenciasSaldo</span> <span sk-i18n>Commons.Liberacoes.lblRealizado</span> <span id=labelCompromisso sk-i18n>Commons.Liberacoes.lblCompromisso</span> <span sk-i18n>Commons.Liberacoes.lblSaldo</span> <span sk-i18n>Commons.Liberacoes.lblPendenteConfirmacao</span></sk-vbox><sk-vbox gap=10 class=resultados-no-periodo><span sk-i18n>Commons.Liberacoes.lblNoPeriodo</span> <span id=periodoOrcado>{{ ctrl.periodoOrcado }}</span> <span id=periodoSuplementacao>{{ ctrl.periodoSuplementacao }}</span> <span id=periodoAntecipacao>{{ ctrl.periodoAntecipacao }}</span> <span id=periodoTransferencias>{{ ctrl.periodoTransferencias }}</span> <span id=periodoTransferenciaDeSaldo>{{ ctrl.periodoTransferenciaDeSaldo }}</span> <span id=periodoRealizado>{{ ctrl.periodoRealizado }}</span> <span id=periodoCompromisso>{{ ctrl.periodoCompromisso }}</span> <span id=periodoSaldo>{{ ctrl.periodoSaldo }}</span> <span id=periodoPendenteDeConfirmacao>{{ ctrl.periodoPendenteDeConfirmacao }}</span></sk-vbox><sk-vbox gap=10 class=resultados-no-ano><span sk-i18n>Commons.Liberacoes.lblNoAno</span> <span id=anoOrcado>{{ ctrl.anoOrcado }}</span> <span id=anoSuplementacao>{{ ctrl.anoSuplementacao }}</span> <span id=anoAntecipacao>{{ ctrl.anoAntecipacao }}</span> <span id=anoTransferencias>{{ ctrl.anoTransferencias }}</span> <span id=anoTransferenciaDeSaldo>{{ ctrl.anoTransferenciaDeSaldo }}</span> <span id=anoRealizado>{{ ctrl.anoRealizado }}</span> <span id=anoCompromisso>{{ ctrl.anoCompromisso }}</span> <span id=anoSaldo>{{ ctrl.anoSaldo }}</span> <span id=anoPendenteDeConfirmacao>{{ ctrl.anoPendenteDeConfirmacao }}</span></sk-vbox></sk-hbox>");
  $templateCache.put("commons/controleNumeracaoPainel/controleNumeracaoPainel.tpl.html",
    "<sk-hbox flex sk-height=100%><sk-sidenav id=painelCategoriasCompacto child-layout=column class=sksidenav is-open=true child-layout=column ng-show=ctrl.showPainelCategorias flex=20><sk-hbox gap=10 class=skhbox style=\"margin-right: -3.5%;background-color: #f0f0f0;border-bottom: 1px solid #ccc\"><div layout=column><label sk-text-align=left style=\"margin-bottom: 0px; padding: 5px 5px 5px 5px\">Tipos de Operação</label></div></sk-hbox><sk-text-input sk-padding=\"5px 0px 5px 5px\" sk-value=ctrl.searchInput sk-placeholder=Pesquisar></sk-text-input><sk-vbox id=vArvore class=container-relative flex style=\"overflow-y: auto\"><sk-vbox id=vBoxArvoreTop><sk-tree id=arvoreTop flex sk-tree-control=ctrl.treeCtrl class=container-absolute sk-search-term=ctrl.searchInput sk-tree-data=ctrl.nodes sk-on-select=ctrl.arvoreCategoriaChange sk-on-toggle-or-expanded=ctrl.onToggleOrExpanded(row) sk-hide-button-container=true></sk-tree></sk-vbox><h3 style=\"padding-left: 15px\" ng-show=ctrl.noFilter>Não foram encontrados registros!</h3></sk-vbox></sk-sidenav><sk-hbox flex><sk-dynaform sk-entity-name=ControleNumeracao sk-on-dynaform-loaded=\"ctrl.onDynaformLoaded(dynaform, dataset)\" sk-dynaform-interceptor=ctrl sk-form-interceptor=ctrl sk-recursive-helper=true sk-can-back-to-old-layout=true sk-skip-start-page=true sk-hide-tour=false sk-show-filter=false sk-hide-entity-card=true sk-hide-button-favorite=true layout=column flex><dynaform-controle-numeracao><sk-header-bar><sk-label id=lblTopArvore sk-value=ctrl.lblTopArvoreText sk-show=ctrl.showPainelCategorias fontweight=bold fontsize=12></sk-header-bar></dynaform-controle-numeracao></sk-dynaform></sk-hbox></sk-hbox>");
  $templateCache.put("commons/descontopromocionais/desconto-grade-produto-popup.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=CONTROLE description=CONTROLE user-type=S width=218 sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=DESCRCONTROLE description=CONTROLE user-type=S width=218></sk-dsfield-md></sk-dataset><sk-hbox flex><sk-vbox flex gap=5><sk-search-input id=textCriteria style=\"min-width: 115px\" sk-value=ctrl.textCriteria sk-keydown=ctrl.onKeyDown($event) sk-on-click=ctrl.findControle sk-placeholder=\"Digite o texto e tecle <ENTER>\" sk-i18n></sk-search-input><sk-datagrid sk-dataset=ctrl.dsControle sk-datagrid-interceptor=ctrl sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-editable=false sk-allow-multiple-selection=true sk-hide-cbx-column=false sk-disable-pagination=true sk-disable-search=true flex></sk-datagrid></sk-vbox></sk-hbox><div class=modal-footer id=footer><div class=modal-footer-right><button class=\"btn btn-default\" ng-click=ctrl.cancelar()>Cancelar</button> <button class=\"btn btn-primary\" ng-click=ctrl.confirmar()>Confirmar</button></div></div>");
  $templateCache.put("commons/diagnosticoPreVenda/diagnosticoPreVenda.tpl.html",
    "<sk-vbox class=diagnostico-pre-venda flex><sk-hbox class=painel-principal align=\"start center\" gap=8><label class=header-text ng-bind=ctrl.headerText></label><sk-hbox class=link-button flex><sk-i18n ng-click=\"ctrl.salvarRespostas(null, true)\" tooltip-placement=bottom>Geral.buttonSalvar</sk-i18n><sk-i18n ng-click=ctrl.clickObservacaoHandler() style=\"position: relative\"><sk-i18n tooltip-placement=bottom>Commons.diagnosticoPreVenda.lblObservacoes</sk-i18n><div ng-if=ctrl.textObservacao sk-popover popover-template-url=diagnostico-observacao.html properties=getPropertiesInfo hide-on=mouseleave always-load-properties=true show-on-mouse-position=true show-on-mouse-enter=true width=auto height=auto style=\"position: absolute; width: 100%; height: 100%; top: 0\"></div></sk-i18n><sk-i18n ng-click=ctrl.closeWizard() tooltip-placement=bottom>Commons.diagnosticoPreVenda.txtRetornarfluxo</sk-i18n></sk-hbox></sk-hbox><sk-hbox ng-repeat=\"wizard in ctrl.paginaPergWizard track by $index\" flex><sk-sidenav is-open=true sk-width=280px ng-show=ctrl.showFiltroPerguntas><sk-painel-filtro-perguntas sk-perguntas-filtro=ctrl.painelFiltroPerguntas.getItems() sk-change=ctrl.aplicaFiltroPerguntas()></sk-painel-filtro-perguntas></sk-sidenav><sk-wizard sk-hide-indicators=true sk-on-cancel=ctrl.unconditionalClose() sk-context=ctrl.wizardContext sk-on-finish=ctrl.finishWizard() sk-on-step-change=\"ctrl.onStepChange($step, $index)\" layout flex><sk-step ng-repeat=\"step in wizard.steps track by $index\" sk-finalize=\"wizard.steps.length == ($index + 1)\" flex><sk-pagina-perguntas sk-perguntas=step.perguntas sk-step-control=$parent.$step sk-pagina-perguntas-created=\"ctrl.paginaPerguntasCreated(paginaPerguntas, $index)\" flex></sk-pagina-perguntas></sk-step></sk-wizard></sk-hbox></sk-vbox><script type=text/ng-template id=diagnostico-observacao.html><div style=\"white-space: break-spaces; width: 100%; height: 100%; min-width: 200px; min-height:35px\" ng-bind-html=\"observacao\"></div></script>");
  $templateCache.put("commons/diagnosticoPreVenda/grupoRespostas/grupoRespostas.tpl.html",
    "<sk-hbox ng-if=usaComboBox sk-margin-bottom=10px flex><sk-combobox sk-value=ctrl.value sk-options=ctrl.optionsResposta sk-allow-null=false sk-opt-key=CODIGO sk-width=200px sk-enabled=\"editable !== false\" sk-change=ctrl.userChangeFunction() sk-enabled=editable></sk-combobox></sk-hbox><sk-vbox ng-if=!usaComboBox gap=5 flex><sk-resposta ng-repeat=\"item in ctrl.respostasGrupo track by $index\" sk-source=item.resposta sk-radio-set=ctrl.radioSet sk-ind-grupo={{::indGrupo}} sk-change=ctrl.userChangeFunction() sk-enabled=\"editable !== false\" sk-value=ctrl.value sk-resposta-created=item.respostaCreated(resposta) sk-editable=editable flex></sk-resposta></sk-vbox>");
  $templateCache.put("commons/diagnosticoPreVenda/paginaPerguntas/paginaPerguntas.tpl.html",
    "<sk-vbox ng-show=ctrl.inicializada class=pagina-perguntas-painel layout-padding align=\"start start\" flex><sk-hbox flex=30><sk-hbox class=link-button><sk-i18n ng-click=ctrl.collapseAll()>Commons.diagnosticoPreVenda.lblMinimizarTodas</sk-i18n><sk-i18n ng-click=ctrl.expandAll()>Commons.diagnosticoPreVenda.lblExpandirTodas</sk-i18n></sk-hbox></sk-hbox><div class=panel-block-box flex><sk-vbox class=panel-block layout-padding align=\"start start\" flex><sk-vbox sk-width=100% ng-class=\"{'esconder': item.includeInLayout !== true}\" ng-repeat=\"item in ctrl.perguntas track by $index\" flex><div class=lista-pergunta></div><sk-pergunta sk-source=item.pergunta sk-value=item.value sk-nu-pesq={{::item.nuPesq}} sk-prefixo-titulo={{::item.prefixoTitulo}} sk-validate-anexo-handler=item.validarAlteracao sk-event-change=item.addEventChange sk-is-filtered=item.isFiltered sk-pergunta-created=\"ctrl.perguntaCreated(pergunta, item.pergunta.CODIGO)\" sk-enable-collapse=true flex></sk-pergunta></sk-vbox></sk-vbox></div></sk-vbox><div ng-show=!ctrl.inicializada class=pagina-perguntas-loading layout=row layout-align=\"center center\" flex><sk-icon svg-src=/mge/assets/svg/loading.svg class=spin></sk-icon><span sk-translate>Geral.lblCarregando</span></div>");
  $templateCache.put("commons/diagnosticoPreVenda/painelFiltroPerguntas/painelFiltroPerguntas.tpl.html",
    "<sk-vbox layout-padding flex sk-padding-top=0px><sk-hbox class=link-button gap=10><sk-i18n ng-click=\"setSelectionValueAll('S')\">Commons.diagnosticoPreVenda.lblMarcarTodos</sk-i18n><sk-i18n ng-click=\"setSelectionValueAll('N')\">Commons.diagnosticoPreVenda.lblDesmarcarTodos</sk-i18n></sk-hbox><sk-vbox align=\"start start\" class=painel-checkbox ng-repeat=\"item in perguntasFiltro\" flex><sk-hbox ng-show=\"item.type == 'TITLE'\" gap=5 align=\"center center\" gap=8 sk-width=100% sk-margin-top=10px><sk-vbox><label title={{item.label}} ng-bind=item.label></label></sk-vbox><sk-vbox class=horizontal-border-slim flex></sk-vbox></sk-hbox><sk-hbox ng-show=\"item.type == 'B'\" align=\"start end\" flex class=painel-checkbox-list-container><sk-vbox class=checkbox-list-span-item align=\"end end\" flex><span title={{item.label}} ng-bind=item.label></span></sk-vbox><sk-vbox align=\"end end\"><sk-checkbox ng-model=item.checked ng-click=notifyChange() class=checkbox-list-cbx-item></sk-checkbox></sk-vbox></sk-hbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/diagnosticoPreVenda/pergunta/pergunta.tpl.html",
    "<div class=pergunta-box ng-if=ctrl.subTipo layout={{ctrl.subTipo}} flex><sk-hbox style=\"margin-bottom: 5px\" gap=8><sk-vbox sk-width=13px style=\"cursor: pointer\"><sk-icon ng-if=\"!ctrl.collapsed && enableCollapse !== false\" v=2 ng-click=ctrl.collapse() font-icon=chevron-down></sk-icon><sk-icon ng-if=\"ctrl.collapsed && enableCollapse !== false\" v=2 ng-click=ctrl.expand() font-icon=chevron-right></sk-icon></sk-vbox><sk-icon class=btn-eraser v=2 font-icon=eraser tooltip=\"Limpar respostas\" tooltip-placement=bottom ng-click=ctrl.limparRespostas()></sk-icon><label title={{::ctrl.titulo}} class=form-input-titulo><sk-hbox gap=8 flex><span ng-bind=ctrl.titulo></span> <span class=required ng-if=ctrl.obrigatoria>*</span></sk-hbox></label></sk-hbox><sk-vbox ng-class=\"{'esconder': ctrl.collapsed, 'margin-row': ctrl.subTipo == 'row'}\" flex><div class=painel-respostas ng-switch=ctrl.tipoPergunta layout=column flex><div ng-switch-when=textInput flex layout={{ctrl.subTipo}}><sk-text-input sk-change=ctrl.onChange() sk-value=ctrl.value></sk-text-input></div><div ng-switch-when=textArea flex layout={{ctrl.subTipo}}><sk-text-area sk-width=100% ng-keydown=ctrl.verificaQtdMaxLinhas($event,resp.CODIGO) sk-change=ctrl.onChange() sk-value=ctrl.value sk-height=150></sk-text-area></div><div ng-switch-when=listaAnexos flex layout={{ctrl.subTipo}}></div><div ng-switch-default layout={{ctrl.subTipo}} layout-align=\"space-between start\" flex><sk-grupo-respostas ng-repeat=\"item in ctrl.gruposResposta\" sk-source=item.grupoElem sk-pergunta-grupo=item.pergunta sk-usa-combo-box=item.usaComboBox sk-multi-selecao=item.multiSelecao sk-ind-grupo={{::item.indGrupo}} sk-user-change-function=item.onUserChangeFunction sk-set-value-function=item.onSetValueFunction sk-click-observacao-handler=item.clickObservacaoHandler sk-value=ctrl.value sk-grupo-respostas-created=item.grupoRespostasCreated(grupo) sk-editable=item.editable></sk-grupo-respostas></div></div></sk-vbox></div><sk-vbox ng-if=\"ctrl.perguntasDependentes.length > 0\" ng-class=\"{'esconder': ctrl.collapsed}\" layout-padding align=\"start start\" sk-width=100% sk-margin-left=5px><sk-vbox gap=2 ng-class=\"{'esconder': item.includeInLayout !== true}\" sk-width=100% ng-repeat=\"item in ctrl.perguntasDependentes track by $index\" flex><div class=lista-pergunta></div><sk-pergunta sk-source=item.pergunta sk-value=item.value sk-nu-pesq={{::item.nuPesq}} sk-pergunta-pai=item.perguntaPai sk-prefixo-titulo={{::item.prefixoTitulo}} sk-validate-anexo-handler=item.validarAlteracao sk-pergunta-created=\"ctrl.perguntaPendCreated(pergunta, item.pergunta.CODIGO)\" sk-is-filtered=item.isFiltered sk-event-change=item.addEventChange sk-enable-collapse=false flex></sk-pergunta></sk-vbox></sk-vbox>");
  $templateCache.put("commons/diagnosticoPreVenda/resposta/resposta.tpl.html",
    "<sk-hbox gap=8><sk-vbox ng-if=radioSet flex><sk-radio-input tooltip-placement=right tooltip={{ctrl.titulo}} sk-option={{::ctrl.codigo}} sk-change=ctrl.onChange() sk-value=ctrl.value sk-name={{::ctrl.codigo}} sk-enabled=editable><span ng-bind=\"ctrl.titulo | answerLimit\"></span></sk-radio-input></sk-vbox><sk-vbox ng-if=!radioSet flex><sk-checkbox tooltip-placement=right tooltip={{ctrl.titulo}} ng-model=ctrl.value[ctrl.codigo] ng-change=ctrl.onChange() force-initial-value=false sk-enabled=editable><span ng-bind=\"ctrl.titulo | answerLimit\"></span></sk-checkbox></sk-vbox><sk-hbox gap=8 sk-disabled=ctrl.isDisabled()><sk-icon style=\"cursor: pointer\" font-icon=download-alt ng-click=ctrl.anexoRespostaViewHandler(resp) ng-if=\"source.TEMANEXO == 'S'\"></sk-icon><div ng-click=ctrl.clickObservacaoHandler(source) ng-if=\"source.ACEITAOBS == 'S'\" style=\"position: relative\"><span class=observacao-pergunta>Observação</span><div ng-if=source.observacao sk-popover popover-template-url=diagnostico-observacao.html properties=getPropertiesInfo hide-on=mouseleave always-load-properties=true show-on-mouse-position=true show-on-mouse-enter=true width=auto height=auto style=\"position: absolute; width: 100%; height: 100%; top: 0\"></div></div></sk-hbox></sk-hbox>");
  $templateCache.put("commons/edicaoseriepopup/edicaoseriepopup.tpl.html",
    "<sk-dataset id=dsSerie entity-name=SerieProduto sk-dataset-created=ctrl.onDatasetCreated(dataset) order-by=SERIE sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-vbox id=contentPopupSerie autofocus flex><sk-hbox layout-padding layout-align=\"center left\" gap=25><span style=\"font-weight: bold\">{{::ctrl.descrProduto}}</span><sk-checkbox ng-model=ctrl.modelGeracaoAutomatica ng-if=ctrl.ckcGeracaoAutomatica ng-show=ctrl.visibleGeracaoAutomatica><span sk-i18n>Comercial.CentralNotas.labelGeracaoAutomatica</span></sk-checkbox></sk-hbox><sk-hbox ng-show=ctrl.modelGeracaoAutomatica class=high-contrast-panel layout-padding layout-align=\"start center\" gap=5><span sk-i18n>Comercial.CentralNotas.labelSerieInicial</span>:<sk-text-input id=serieInicial sk-value=ctrl.serieInicial.text sk-restrict=[^0-9]></sk-text-input><button ng-click=ctrl.gerarSequencia() sk-i18n>Comercial.CentralNotas.buttonGerarSequencia</button></sk-hbox><sk-hbox layout-padding gap=5><sk-navigator id=navigator dataset=ctrl.dsSerie show-crud=ctrl.showCrud sk-show-refresh-button=false sk-show-copy-button=false sk-show-navigation=false sk-compact-btn-add=true sk-add-function=ctrl.addHandler(dataset) sk-remove-handler=ctrl.removeHandler(dataset)></sk-navigator><sk-text-input id=txtSerieGlobal sk-value=ctrl.txtSerieGlobal.text sk-change=ctrl.incluirSerieGlobal() sk-keydown=ctrl.keyDownEventsSerieGlobal($event) ng-show=ctrl.txtSerieGlobal.visible></sk-text-input><sk-hbox ng-show=ctrl.panelTextSerie layout-align=\"start center\" gap=5><sk-text-input id=textSerie autofocus sk-enabled=ctrl.textSerie.enabled sk-value=ctrl.textSerie.text sk-change=ctrl.changeSerie() sk-focus-out=ctrl.keyFocusChangeSerie() sk-keydown=ctrl.keyDownEventsSerie($event)></sk-text-input><sk-icon id=btnSearch class=icon-search font-icon=search ng-show=ctrl.btnSearchShow ng-click=ctrl.clickSearchButtonHandler()></sk-icon></sk-hbox><button ng-click=ctrl.removeSeries() sk-i18n>Comercial.CentralNotas.buttonExcluirSeries</button></sk-hbox><sk-hbox ng-show=ctrl.panelTextSmartCard layout-padding gap=5><span>{{ctrl.Nro.SmartCard}}</span><sk-text-input id=textSmartCard sk-enabled=ctrl.textSmartCard.enabled sk-value=ctrl.textSmartCard.text tooltip={{ctrl.Nro.SmartCard}} sk-keydown=ctrl.keyDownEventsSmartCard($event)></sk-text-input></sk-hbox><sk-datagrid sk-dataset=dsSerie sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/editorfiltro/editor-filtro.tpl.html",
    "<sk-hbox flex><sk-vbox flex=40><sk-search-input sk-value=ctrl.filtroArvoreCampos sk-on-click=ctrl.filterTree></sk-search-input><sk-vbox layout-top-padding flex><sk-tree layout sk-tree-data=ctrl.camposDP sk-tree-control=ctrl.treeCtrl sk-children-custom-name=campo sk-label-custom-name=descricao sk-search-term=ctrl.filtroArvoreCampos sk-on-select=ctrl.campoChanged sk-ignore-scroll-to=true sk-tooltip-placement=right></sk-tree></sk-vbox></sk-vbox><sk-vbox layout-left-padding flex><sk-vbox><sk-hbox flex><sk-hbox layout-align=\"start center\" flex><span class=text-bold ng-bind=ctrl.nomeCampo></span></sk-hbox><sk-hbox layout-align=\"end start\" flex><sk-combobox sk-width=150 sk-value=ctrl.comboExpressao sk-options=ctrl.comboExpressaoOpts sk-enabled=ctrl.podeUsarCampoAtual sk-allow-null=false></sk-combobox></sk-hbox></sk-hbox></sk-vbox><sk-vbox layout-top-padding><sk-hbox gap=8 layout-align=\"start center\" flex><sk-switch sk-value=ctrl.checkVar sk-true-value=true sk-false-value=false sk-change=ctrl.changeChkVariavel() sk-enabled=ctrl.podeUsarCampoAtual></sk-switch><sk-hbox layout-align=\"start center\" flex><span sk-i18n>Variável</span></sk-hbox><sk-text-input sk-value=ctrl.campoTexto ng-if=ctrl.campoTextoVisible sk-enabled=ctrl.habilitaControleParametro></sk-text-input><sk-number-input sk-value=ctrl.campoNumero ng-if=ctrl.campoNumeroVisible sk-precision=ctrl.campoNumeroPrecision sk-enabled=ctrl.habilitaControleParametro></sk-number-input><sk-date-input sk-value=ctlr.campoData ng-if=ctrl.campoDataVisible sk-enabled=ctrl.habilitaControleParametro></sk-date-input><sk-combobox sk-value=ctrl.campoOpcoes ng-if=ctrl.campoOpcoesVisible sk-enabled=ctrl.habilitaControleParametro></sk-combobox><sk-hbox gap=8 layout-align=\"start center\" flex><sk-switch sk-value=ctrl.checkAnd sk-true-value=true sk-false-value=false sk-change=\"ctrl.mudaOperador('E')\" sk-enabled=ctrl.podeUsarCampoAtual></sk-switch><span sk-i18n>.E.</span></sk-hbox><sk-hbox gap=8 layout-align=\"start center\" flex><sk-switch sk-value=ctrl.checkOr sk-true-value=true sk-false-value=false sk-change=\"ctrl.mudaOperador('OU')\" sk-enabled=ctrl.podeUsarCampoAtual></sk-switch><span sk-i18n>.OU.</span></sk-hbox></sk-hbox></sk-vbox><sk-vbox layout-top-padding><sk-hbox gap=10 ng-if=ctrl.editFilterBox layout-align=\"start center\" layout-top-padding flex><sk-hbox gap=10 layout-align=\"start center\"><sk-switch sk-value=ctrl.isRequired sk-true-value=true sk-false-value=false sk-enabled=ctrl.isRequiredEnabled></sk-switch><span sk-i18n>Requerido</span></sk-hbox><sk-pesquisa-input sk-entity-name=Instancia sk-value=ctrl.txiEntity ng-if=ctrl.showEntitySearch sk-enabled=ctrl.isRequiredEnabled sk-enviroment-criteria=ctrl.enviromentCriteriaEntidade()></sk-pesquisa-input><button default class=\"btn btn-default btn-sk-sm clear\" ng-click=ctrl.openEditForm() ng-disabled=!ctrl.isEditFilterEnabled tooltip=Core.FormatadorCuboRelatorio.msgEditFilterExpression tooltip-placement=bottom sk-i18n><sk-icon font-icon=\"glyphicon glyphicon-edit\"></sk-icon></button></sk-hbox></sk-vbox><sk-vbox layout-top-padding><sk-hbox layout-top-padding align=\"end center\" gap=5 flex><button default class=\"btn btn-default\" ng-click=ctrl.adicionaExpressao() ng-disabled=!ctrl.podeUsarCampoAtual sk-i18n>Adicionar</button> <button default class=\"btn btn-default\" ng-click=ctrl.limpar() sk-i18n>Limpar</button> <button default class=\"btn btn-default\" ng-click=ctrl.cleanFunction() sk-i18n>Usar Filtro Padrão</button></sk-hbox><sk-vbox layout-top-padding><sk-text-area sk-value=ctrl.filterExpression sk-change=ctrl.notifyChange() sk-component-created=ctrl.textAreaCreated($component)></sk-text-area></sk-vbox></sk-vbox></sk-vbox></sk-hbox>");
  $templateCache.put("commons/editorfiltro/popup/EditFilterPopUp.tpl.html",
    "<sk-vbox><sk-hbox layout-align=\"start center\"><sk-hbox><sk-switch id=isRequiredEdit ng-model=ctrl.ckcRequiredEdit sk-width=150px></sk-switch><sk-i18n sk-margin-right=15px>Requerido</sk-i18n></sk-hbox><sk-hbox ng-if=ctrl.showEntitySearch sk-width=100% layout-align=\"start center\"><sk-icon font-icon=search tooltip=\"{{'Geral.lblLocate' | translate}}\" ng-click=ctrl.searchEntity(ctrl.textFilter)></sk-icon><sk-text-input sk-value=ctrl.textFilter sk-margin-left=10px sk-margin-right=10px sk-width=100%></sk-text-input></sk-hbox><button buttonmode=true default tooltip=Geral.buttonOK tooltip-placement=bottom ng-click=ctrl.confirmFilterEdit() sk-height=25px sk-margin-right=5px sk-i18n>Geral.buttonOK</button> <button buttonmode=true default tooltip=Geral.buttonCancelar tooltip-placement=bottom ng-click=ctrl.closeFilterEdit() sk-height=25px sk-i18n>Geral.buttonCancelar</button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/empresa/copiarblocos/copiarblocos.tpl.html",
    "<sk-simple-form sk-columns=1><sk-simple-item sk-label=Commons.CopiarBlocos.lblEmpresaOrigem sk-bg-color=#fff><sk-pesquisa-input sk-entity-name=Empresa sk-value=ctrl.codEmp sk-enviroment-criteria=ctrl.criteria() sk-field-name=CODEMP></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-bg-color=#fff><sk-checkbox ng-model=ctrl.isSobreporConfig><sk-i18n>Commons.CopiarBlocos.lblSobreporConfig</sk-i18n></sk-checkbox></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/estornopopup/estornoMultiploPopUp/estornoMultiploPopUp.tpl.html",
    "<sk-wizard sk-hide-indicators=true sk-hide-btn-cancel=true sk-context=ctrl.wizardContext sk-on-finish=ctrl.onFinish($step) sk-using-max-height=true flex><sk-step sk-next-label=Financeiro.Estorno.buttonEstornar sk-hide-finish=true sk-hide-previous=true sk-template-url=commons/estornopopup/estornoMultiploPopUp/stepConfiguracaoEstornoMultiplo.tpl.html sk-controller=StepConfiguracaoEstornoMultiploController sk-controller-as=ctrl layout=column flex></sk-step><sk-step sk-hide-finish=true sk-hide-previous=true sk-hide-next=true sk-template-url=commons/estornopopup/estornoMultiploPopUp/stepEstornandoMultiplo.tpl.html sk-controller=StepEstornandoMultiploController sk-controller-as=ctrl layout=column flex></sk-step><sk-step sk-finish-label=Geral.buttonOK sk-hide-previous=true sk-hide-next=true sk-template-url=commons/estornopopup/estornoMultiploPopUp/stepResultadosEstornoMultiplo.tpl.html sk-controller=StepResultadosEstornoMultiploController sk-controller-as=ctrl layout=column flex></sk-step></sk-wizard>");
  $templateCache.put("commons/estornopopup/estornoMultiploPopUp/stepConfiguracaoEstornoMultiplo.tpl.html",
    "<sk-dataset entity-name=Financeiro sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-vbox layout-padding flex><sk-hbox sk-padding=\"0px 0px 10px 0px\" layout-align=\"start center\"><span class=text-bold ng-bind=ctrl.titleWarning></span></sk-hbox><sk-hbox><sk-hbox ng-show=ctrl.estornarConciliadosVisible sk-padding=\"0px 40px 10px 0px\" layout-align=\"start center\" gap=5><span><sk-i18n>Financeiro.Estorno.estornarConciliados</sk-i18n></span><sk-switch sk-value=ctrl.estornarConciliados sk-true-value=true sk-false-value=false></sk-switch><sk-help-tip sk-placement=bottom sk-text=Financeiro.Estorno.helpEstornarConciliados sk-i18n></sk-help-tip></sk-hbox><sk-hbox ng-show=ctrl.recomporOriginaisVisible sk-padding=\"0px 40px 10px 0px\" layout-align=\"start center\" gap=5><span><sk-i18n>Financeiro.Estorno.estornarTitulosOriginais</sk-i18n></span><sk-switch sk-value=ctrl.recomporOriginais sk-true-value=true sk-false-value=false></sk-switch><sk-help-tip sk-placement=bottom sk-text=Financeiro.Estorno.helpRecomporOriginais sk-i18n></sk-help-tip></sk-hbox><sk-hbox ng-show=ctrl.antecipacaoBaixaVisible sk-padding=\"0px 40px 10px 0px\" layout-align=\"start center\" gap=5><span><sk-i18n>Financeiro.Estorno.antecipacaoBaixa</sk-i18n></span><sk-switch sk-value=ctrl.antecipacaoBaixa sk-true-value=true sk-false-value=false></sk-switch><sk-help-tip sk-placement=bottom sk-text=Financeiro.Estorno.helpEstornarAntecipacaoBaixa sk-i18n></sk-help-tip></sk-hbox><sk-hbox ng-show=ctrl.estornarBaixaConjuntaVisible sk-padding=\"0px 40px 10px 0px\" layout-align=\"start center\" gap=5><span><sk-i18n>Financeiro.Estorno.lblBaixaConjunta</sk-i18n></span><sk-switch sk-value=ctrl.estornarBaixaConjunta sk-true-value=true sk-false-value=false></sk-switch><sk-help-tip sk-placement=bottom sk-text=Financeiro.Estorno.helpBaixaConjunta sk-i18n></sk-help-tip></sk-hbox></sk-hbox><sk-hbox sk-padding=\"0px 0px 5px 0px\" gap=5><sk-grid-config sk-config-name={{::gridConfig}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.dataGrid></sk-grid-printer><button small ng-click=ctrl.removerSelecionados() style=margin-right:5px;padding:3px default><sk-icon tooltip=Financeiro.Estorno.removerSelecionados tooltip-placement=bottom svg-src=btn-remove-selected.svg sk-i18n></sk-icon></button> <button small ng-click=ctrl.removerNaoSelecionados() style=margin-right:5px;padding:3px default><sk-icon tooltip=Financeiro.Estorno.removerNaoSelecionados tooltip-placement=bottom svg-src=btn-remove-deselected.svg sk-i18n></sk-icon></button><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsFinanceiros></sk-rows-counter></div></sk-hbox><sk-hbox sk-padding=\"0px 0px 5px 0px\" flex><sk-datagrid sk-dataset=ctrl.dsFinanceiros sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-datagrid-interceptor=ctrl sk-editable=false sk-grid-config={{::gridConfig}} flex></sk-datagrid></sk-hbox></sk-vbox>");
  $templateCache.put("commons/estornopopup/estornoMultiploPopUp/stepEstornandoMultiplo.tpl.html",
    "<sk-vbox layout-padding layout-align=\"center center\" sk-height=100% sk-width=100% flex><sk-vbox ng-if=ctrl.isEstornando layout-align=\"center center\" flex><sk-hbox sk-padding=\"0px 0px 10px 0px\" layout-align=\"start center\"><span class=text-bold ng-bind=ctrl.titleLoading></span></sk-hbox><div class=sk-loading-bar layout-align=\"center center\" style=\"position: relative; width: 400px\"><div class=bar-container><div class=bar1></div><div class=bar2></div></div></div></sk-vbox></sk-vbox>");
  $templateCache.put("commons/estornopopup/estornoMultiploPopUp/stepResultadosEstornoMultiplo.tpl.html",
    "<sk-dataset unique-id=dsEstornados entity-name=Financeiro sk-dataset-created=ctrl.onDatasetCreatedEstornados(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-dataset unique-id=dsNaoEstornados entity-name=Financeiro sk-dataset-created=ctrl.onDatasetCreatedNaoEstornados(dataset) sk-standalone><sk-field pattern=*></sk-field><sk-dsfield-md name=MSGIMP description=Impedimento></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-hbox ng-show=!ctrl.nenhumTituloProcessado sk-padding=\"0px 0px 5px 0px\" layout-align=\"start center\"><span class=text-bold style=\"font-size: 20px\"><sk-i18n>Financeiro.Estorno.titleResumo</sk-i18n></span></sk-hbox><sk-hbox ng-show=!ctrl.nenhumTituloProcessado sk-padding=\"0px 0px 10px 0px\" layout-align=\"start center\"><span class=text-bold><sk-i18n>Financeiro.Estorno.subTitleResumo</sk-i18n></span></sk-hbox><sk-vbox ng-show=ctrl.nenhumTituloProcessado sk-padding=\"0px 0px 10px 0px\" layout-align=\"center center\" flex><span class=text-bold><sk-i18n>Financeiro.Estorno.warningNenhumTitulo</sk-i18n></span></sk-vbox><sk-tabnavigator sk-selected-index=ctrl.selectedIndex ng-show=!ctrl.nenhumTituloProcessado><sk-tabnavigator-item class=naoEstornados sk-label=Financeiro.Estorno.titNaoEstornados ng-show=ctrl.possuiTitulosErro sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item class=estornados sk-label=Financeiro.Estorno.titEstornados ng-show=ctrl.possuiTitulosEstornados sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedIndex class=tab-container layout=column ng-show=!ctrl.nenhumTituloProcessado flex><sk-viewstack-content ng-show=ctrl.possuiTitulosErro sk-width=100% sk-height=100% flex><sk-vbox sk-width=100% sk-height=100%><sk-hbox layout-padding gap=5><sk-grid-config sk-config-name={{::gridConfigTitNaoEstornado}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.dataGridNaoEstornados></sk-grid-printer><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsTitulosNaoEstornados></sk-rows-counter></div></sk-hbox><sk-hbox sk-padding=\"0px 5px 5px 5px\" sk-height=220px><sk-datagrid sk-dataset=ctrl.dsTitulosNaoEstornados sk-on-datagrid-loaded=ctrl.onDatagridNaoEstornadosLoaded(datagrid) sk-editable=false sk-datagrid-interceptor=ctrl sk-grid-config={{::gridConfigTitNaoEstornado}} flex></sk-datagrid></sk-hbox><sk-hbox sk-padding=\"0px 5px 0px 5px\" sk-width=100%><sk-text-area sk-width=100% sk-value=ctrl.msgErroTitulo></sk-text-area></sk-hbox></sk-vbox></sk-viewstack-content><sk-viewstack-content ng-show=ctrl.possuiTitulosEstornados sk-width=100% sk-height=100%><sk-hbox layout-padding gap=5><sk-grid-config sk-config-name={{::gridConfigTitEstornado}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.dataGridEstornados></sk-grid-printer><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsTitulosEstornados></sk-rows-counter></div></sk-hbox><sk-hbox sk-height=300px flex><sk-datagrid sk-dataset=ctrl.dsTitulosEstornados sk-on-datagrid-loaded=ctrl.onDatagridEstornadosLoaded(datagrid) sk-editable=false sk-datagrid-interceptor=ctrl sk-grid-config={{::gridConfigTitEstornado}} flex></sk-datagrid></sk-hbox></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/estornopopup/estornopopup.tpl.html",
    "<sk-wizard sk-hide-indicators=true sk-on-cancel=ctrl.onCancel() sk-context=ctrl.wizardContext sk-on-finish=ctrl.onFinish($step) flex><sk-step sk-cancel-label=Geral.buttonNao sk-next-label=Geral.buttonSim sk-finish-label=Geral.buttonSim sk-hide-previous=true layout=column flex sk-template-url=commons/estornopopup/estornopopupcontainer.tpl.html sk-controller=StepConfirmaEstornoController sk-controller-as=ctrl flex></sk-step><sk-step sk-cancel-label=Geral.buttonCancelar sk-next-label=Geral.buttonSim sk-finish-label=Geral.buttonSim sk-hide-previous=true layout=column flex sk-template-url=commons/estornopopup/estornopopupcontainer.tpl.html sk-controller=StepAntecipacaoBaixaEstornoController sk-controller-as=ctrl flex></sk-step><sk-step sk-cancel-label=Geral.buttonNao sk-next-label=Geral.buttonSim sk-finish-label=Geral.buttonSim sk-hide-previous=true layout=column flex sk-template-url=commons/estornopopup/estornopopupcontainer.tpl.html sk-controller=StepTituloConciliadoEstornoController sk-controller-as=ctrl flex></sk-step><sk-step sk-i18n sk-cancel-label=Geral.buttonNao sk-next-label=Geral.buttonSim sk-finish-label=Geral.buttonSim sk-hide-previous=true layout=column flex sk-template-url=commons/estornopopup/estornopopupcontainer.tpl.html sk-controller=StepBaixadoOutrosTitulosEstornoController sk-controller-as=ctrl></sk-step><sk-step sk-i18n sk-cancel-label=Geral.buttonCancelar sk-next-label=Geral.buttonSim sk-finish-label=Financeiro.Estorno.buttonEstornar sk-hide-previous=true layout=column flex sk-template-url=commons/estornopopup/estornopopupcontainer.tpl.html sk-controller=StepRecomposicaoEstornoController sk-controller-as=ctrl></sk-step></sk-wizard>");
  $templateCache.put("commons/estornopopup/estornopopupcontainer.tpl.html",
    "<sk-hbox align=\"start center\" sk-width=100% sk-height=100%><div class=viewEstorno ng-switch=ctrl.step layout=column><div class=headerTop layout-padding ng-switch-when=ConfirmaEstorno><span class=text-bold sk-i18n>Financeiro.Estorno.messageConfirmaEstorno</span></div><span ng-switch-when=AntecipacaoBaixaEstorno><sk-vbox layout-left-padding layout-right-padding><span class=text-bold sk-color=red sk-font-size=25px sk-margin-bottom=5px style=\"line-height: normal\">{{ctrl.titleWarning}}</span> <span sk-i18n>{{ctrl.lblMsg}}</span> <span sk-i18n>{{ctrl.lblMsg2}}</span> <span sk-i18n>{{ctrl.lblMsg3}}</span> <span ng-if=ctrl.self.lblMsg4Visible sk-i18n>{{ctrl.lblMsg4}}</span> <span sk-i18n>{{ctrl.lblMsg5}}</span><sk-hbox><button default ng-click=ctrl.estornarTitulo(true) ng-if=ctrl.visibleSim sk-i18n>Geral.buttonSim</button> <button default ng-click=ctrl.estornarTitulo(false) ng-if=ctrl.visibleNao sk-i18n>Geral.buttonNao</button></sk-hbox></sk-vbox></span><span ng-switch-when=TituloConciliadoEstorno><sk-vbox layout-left-padding layout-right-padding><span class=text-bold sk-color=red sk-font-size=25px sk-margin-bottom=5px style=\"line-height: normal\">{{ctrl.titleWarning}}</span> <span sk-i18n>Financeiro.Estorno.messageTituloConciliado</span></sk-vbox></span><span ng-switch-when=BaixadoOutrosTitulosEstorno><span sk-i18n>Financeiro.Estorno.messageTituloJaBaixado</span> </span><span ng-switch-when=RecomposicaoEstorno><sk-vbox layout-left-padding layout-right-padding><span class=text-bold sk-color=red sk-font-size=25px sk-margin-bottom=5px style=\"line-height: normal\">{{ctrl.titleWarning}}</span><sk-checkbox ng-if=ctrl.wizardContext.permiteEstornoSemRecomposicao ng-model=ctrl.recompor><span sk-i18n>Financeiro.Estorno.labelRecomporTituloOriginal</span></sk-checkbox><span ng-if=!ctrl.wizardContext.permiteEstornoSemRecomposicao sk-i18n>Financeiro.Estorno.messageRecomporTituloOriginal</span></sk-vbox></span></div></sk-hbox><sk-vbox layout-padding><sk-hbox gap=5 layout-top-padding flex><span class=text-bold sk-i18n>Financeiro.Estorno.labelDataBaixa</span><span>:</span><sk-date-input sk-dataset=ctrl.wizardContext.dsFinanceiro sk-field-name=DHBAIXA sk-enabled=false></sk-date-input></sk-hbox><sk-hbox gap=5 layout-top-padding flex><span class=text-bold sk-i18n>Financeiro.Estorno.labelValorBaixado</span><span>:</span><sk-number-input sk-dataset=ctrl.wizardContext.dsFinanceiro sk-field-name=VLRBAIXA sk-enabled=false sk-width=200 sk-precision=2></sk-number-input></sk-hbox></sk-vbox><sk-simple-form layout-top-padding sk-in-line=true sk-columns=1><sk-simple-item sk-label=Financeiro.Estorno.labelContaBancaria><sk-pesquisa-input sk-dataset=ctrl.wizardContext.dsFinanceiro sk-field-name=CODCTABCOINT sk-entity-name=MovimentoBancario sk-enabled=false sk-width=400></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Financeiro.Estorno.labelHistorico><sk-text-area sk-dataset=ctrl.wizardContext.dsFinanceiro sk-field-name=HISTORICO sk-enabled=false sk-height=200 sk-width=400></sk-text-area></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/expressoes/construtorExpressoes.tpl.html",
    "<sk-hbox flex class=construtor-expressoes-container><sk-resizable-columns><sk-vbox sk-resizable sk-direction=\"'right'\" style=\"min-width: 240px; max-width: 500px\" flex><sk-title sk-text=Commons.Expressoes.labelCategorias></sk-title><sk-search-input sk-value=ctrl.srcSearchTerm sk-on-click=ctrl.filterTree></sk-search-input><sk-tree sk-tree-data=ctrl.tree sk-tree-control=ctrl.treeCtrl sk-search-term=ctrl.srcSearchTerm sk-on-select=ctrl.treeSelectedItem sk-dbl-click-fn=ctrl.addExpressao sk-ignore-scroll-to=true class=tree-categorias sk-tooltip-placement=right sk-show-card=ctrl.showCard></sk-tree><sk-text-area sk-value=ctrl.txtDescricao sk-height=70 sk-enabled=false></sk-text-area></sk-vbox><sk-hbox style=\"min-width: 150px\" flex><sk-vbox gap=2 align=\"center center\" layout-padding><button default ng-repeat=\"operador in ctrl.operadores\" ng-click=ctrl.addOperador(operador) sk-padding=0 sk-height=28px sk-min-width=53px ng-bind=operador></button></sk-vbox><sk-vbox layout-padding flex><sk-title sk-margin=\"0 0 0 7px\" sk-text=Commons.Expressoes.labelExpressaoCampo></sk-title><sk-hbox layout-padding align=\"start center\" gap=5><div><sk-checkbox ng-model=ctrl.addFinalExpressao><span sk-i18n=Commons.Expressoes.labelAcrescentarFinal></span></sk-checkbox></div><button default ng-click=ctrl.limparExpressao() sk-i18n=Commons.Expressoes.buttonLimpar></button></sk-hbox><sk-hbox flex><sk-text-area flex sk-value=ctrl.txtExpressao sk-component-created=ctrl.editorCreated($component)></sk-text-area></sk-hbox></sk-vbox></sk-hbox></sk-resizable-columns></sk-hbox>");
  $templateCache.put("commons/fichaPatrimonialPanel/fichapatrimonialpanel.tpl.html",
    "<sk-dataset entity-name=Imobilizado sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-datagrid-interceptor=ctrl><sk-field pattern=\"SALDO,CODBEMORIG,NFSAIDA,NFRETORNO,DTRETORNO,NFDEVVENDA ,NUMNOTA, DTBAIXA,NUMNOTABAIXA, CODBEMATUAL, DESCRABREV, CODPOSSUIDOR, NUNOTABAIXA, DESCRBEM, DTCOMPRA, VLRAQUISICAO, CODPOSSUIDOR, NOMEPOSSUIDOR, VLRDEP\"></sk-field><sk-field pattern=NUMCONTRATO path=Contrato></sk-field><sk-field pattern=DESCRLOCAL path=LocalEstoque></sk-field><sk-field pattern=\"DESCRPROD, CODPROD, REFERENCIA, CODVOL, MARCA, LOCALIZACAO, QTDEMB, COMPLDESC, CODGRUPOPROD\" path=Produto></sk-field><sk-field pattern=DESCRGRUPOPROD path=Produto.GrupoProduto></sk-field><sk-field pattern=\"EQUIPAMENTO, AMBIENTE, CODPARC \" path=Contrato></sk-field><sk-field pattern=\"CGC_CPF, RAZAOSOCIAL\" path=Contrato.Parceiro></sk-field><sk-field pattern=\"DTENTSAI, NUNOTASAIDA, NUNOTADEV\" path=CabecalhoNotaSaida></sk-field><sk-field pattern=\"TOTALDEP, CODBEM\" path=SaldoImobilizadoAtual></sk-field><sk-field pattern=\"CODEMP, CODDEPTO\" path=Local></sk-field><sk-field pattern=\"CODEMP, NOMEFANTASIA\" path=Empresa></sk-field><sk-field pattern=DESCRDEP path=Local.Departamento></sk-field><sk-field pattern=CODLOCAL path=LocalEstoque></sk-field></sk-dataset><sk-vbox flex sk-height=100% sk-padding=5px><sk-vbox sk-width=100% ng-show=ctrl._isModoPopup><sk-hbox><button default sk-i18n ng-click=ctrl.voltar() tooltip=Comercial.FichaPatrimonial.buttonVoltarTooltip tooltip-placement=right><sk-icon font-icon=unshare></sk-icon><sk-i18n>Comercial.FichaPatrimonial.buttonVoltar</sk-i18n></button><h5 class=text-bold style=\"margin-left: 5px\"><sk-i18n>Comercial.FichaPatrimonial.labelFichaPatrimonial</sk-i18n></h5></sk-hbox><sk-divider style=\"margin-top: 5px\"></sk-divider></sk-vbox><sk-vbox class=container-relative flex><sk-hbox layout-align=start gap=12><sk-personalized-filter sk-data-source=ctrl.dsFichaPatrimonial sk-apply-function=ctrl.aplicarAbast() sk-resource-id=\"{{ ctrl.resourceID }}\" sk-hide-apply=true></sk-personalized-filter><sk-hbox><sk-navigator sk-show-edit-button=false sk-show-add-button=false dataset=ctrl.dsFichaPatrimonial sk-compact-btn-add></sk-navigator></sk-hbox><sk-hbox flex layout-align=\"end end\" gap=12><sk-grid-printer sk-title=Comercial.FichaPatrimonial.labelFichaPatrimonial sk-grid-controller=ctrl.gridFichaPatrimonial class=btn-export></sk-grid-printer><button class=\"btn btn-default\" ng-click=ctrl.enviarSelecionados() tooltip=Comercial.FichaPatrimonial.buttonEnviarTooltip tooltip-placement=bottom sk-i18n ng-show=ctrl._isModoPopup><sk-icon font-icon=send></sk-icon><span sk-i18n=Comercial.FichaPatrimonial.buttonEnviar></span></button> <button class=\"btn btn-default\" ng-click=ctrl.permanecerEnviarSelecionados() tooltip=Comercial.FichaPatrimonial.buttonEnviarPermanecerTooltip tooltip-placement=bottom sk-i18n ng-show=ctrl._isModoPopup><sk-icon font-icon=send></sk-icon><span sk-i18n=Comercial.FichaPatrimonial.buttonEnviarPermanecer></span></button><sk-dropdown-menu sk-tooltip=Geral.buttonOutrasOpcoes sk-build-options=ctrl.buildOutrasOpcoes() sk-build-on-every-click=true sk-hiden-icon=false sk-i18n></sk-dropdown-menu><sk-hbox><sk-grid-config sk-config-name={{ctrl.gridConfig}}></sk-grid-config></sk-hbox><sk-action-button sk-entity-name=Imobilizado sk-resource-id=\"{{ ctrl.actionBtnIDImobilizado }}\" sk-access-resource-id=\"{{ ctrl.resourceID }}\" sk-context=ctrl.imobilizadoCtx ng-if=ctrl.showActionButton></sk-action-button><sk-rows-counter sk-dataset=ctrl.dsFichaPatrimonial></sk-rows-counter></sk-hbox></sk-hbox><sk-divider style=\"margin: 5px 0 0 0\"></sk-divider><sk-sidenav-horizontal style=\"height: 145px; min-height: 145px\"><sk-simple-form layout-align=start style=\"margin: 5px; padding-top: 14px; background-color: #fbfbfb; border: 1px #f2f2f2 solid\"><sk-vbox><sk-hbox sk-onload=ctrl.onLoadContainerFielsFocus($event)><sk-vbox flex><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelProduto sk-in-line=true sk-width=100% class=form-item><sk-pesquisa-input id=dbPesquisaProduto sk-value=ctrl.dbPesquisaProduto sk-entity-name=Produto sk-field-name=CODPROD sk-enabled=ctrl.dbPesquisaProdutoEnabled sk-width=100%></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelBens sk-in-line=true sk-width=100% class=form-item><sk-text-input id=txtPesqBensFp sk-value=ctrl.txtPesqBens></sk-text-input></sk-simple-item></sk-vbox><sk-vbox flex><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelPossuidor sk-in-line=true sk-width=100% class=form-item><sk-pesquisa-input id=dbPesquisaPossuidor sk-value=ctrl.dbPesquisaPossuidor sk-entity-name=Parceiro sk-field-name=CODPARC sk-target-description-field-name=RAZAOSOCIAL></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelLocal sk-in-line=true sk-width=100% class=form-item><sk-pesquisa-input id=dbPesquisaLocal sk-value=ctrl.dbPesquisaLocal sk-entity-name=LocalFinanceiro sk-field-name=CODLOCAL></sk-pesquisa-input></sk-simple-item></sk-vbox><sk-vbox flex><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelContrato sk-in-line=true sk-width=100% class=form-item><sk-pesquisa-input id=dbPesquisaContrato sk-value=ctrl.dbPesquisaContrato sk-entity-name=Contrato sk-field-name=NUMCONTRATO sk-show-description-input=ctrl.showContratoDescriptionInput()></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelGrupoProduto sk-in-line=true sk-width=100% class=form-item><sk-pesquisa-input id=dbPesquisaGrupoProduto sk-value=ctrl.dbPesquisaGrupoProduto sk-entity-name=GrupoProduto sk-field-name=CODGRUPOPROD></sk-pesquisa-input></sk-simple-item></sk-vbox></sk-hbox><sk-hbox sk-margin=\"0 0 5px 0\" style=\"padding-left: 10px\"><sk-hbox ng-show=ctrl._isModoPopup><sk-switch sk-value=ctrl.chkDisponiveis sk-true-value=S sk-false-value=N sk-change=ctrl.validarPanelFiltro()></sk-switch><label class=\"form-input-label simple-label switch-label\" ng-click=ctrl.setChkDisponiveis() sk-i18n>Comercial.FichaPatrimonial.labelApenasDisponiveis</label></sk-hbox><sk-hbox><sk-switch sk-value=ctrl.chkEstoque sk-true-value=S sk-false-value=N sk-enabled=ctrl.chkEstoqueEnabled></sk-switch><label class=\"form-input-label simple-label switch-label\" ng-click=ctrl.setChkEstoque() sk-i18n>Comercial.FichaPatrimonial.labelEmEstoque</label></sk-hbox><sk-hbox><sk-switch sk-value=ctrl.chkLocado sk-true-value=S sk-false-value=N sk-enabled=ctrl.chkLocadoEnabled></sk-switch><label class=\"form-input-label simple-label switch-label\" ng-click=ctrl.setChkLocado() sk-i18n>Comercial.FichaPatrimonial.labelLocado</label></sk-hbox><sk-hbox><sk-switch sk-value=ctrl.chkBaixado sk-true-value=S sk-false-value=N sk-enabled=ctrl.chkBaixadoEnabled></sk-switch><label class=\"form-input-label simple-label switch-label\" ng-click=ctrl.setChkBaixado() sk-i18n>Comercial.FichaPatrimonial.labelBaixado</label></sk-hbox><button class=\"btn btn-default\" ng-click=ctrl.aplicarFiltro() tooltip=Comercial.FichaPatrimonial.buttonAplicarFiltro tooltip-placement=right sk-i18n><span sk-i18n=Comercial.FichaPatrimonial.buttonAplicarFiltro></span></button></sk-hbox></sk-vbox></sk-simple-form></sk-sidenav-horizontal><sk-vbox flex><sk-hbox sk-width=100% flex sk-margin=5px><sk-datagrid layout flex sk-editable=false sk-dataset=ctrl.dsFichaPatrimonial sk-on-dbl-click=ctrl.abrirPopUpEquipamento() sk-grid-config=\"{{ ctrl.gridConfig }}\" sk-margin=10 sk-datagrid-interceptor=ctrl sk-width={{gridFichaPatrimonialPercentWidth}}% sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded(datagrid, dataset)\"></sk-datagrid><sk-vbox ng-show=ctrl.showPanelInformacoes sk-width=25%><sk-tabnavigator sk-selected-index=selectedIndex><sk-tabnavigator-item><sk-i18n>Comercial.FichaPatrimonial.labelResponsavel</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Comercial.FichaPatrimonial.labelPossuidor</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Comercial.FichaPatrimonial.labelBem</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=selectedIndex flex><sk-viewstack-content layout=column sk-height=100%><sk-simple-form sk-in-line=false sk-columns=1 flex style=\"margin-top: 5px\"><sk-vbox><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelNome><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=Contrato.Parceiro.RAZAOSOCIAL sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelContrato><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=Contrato.NUMCONTRATO sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelEquipamento><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=Contrato.EQUIPAMENTO sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelAmbiente><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=Contrato.AMBIENTE sk-enabled=false></sk-text-input></sk-simple-item></sk-vbox></sk-simple-form></sk-viewstack-content><sk-viewstack-content layout=column sk-height=100%><sk-simple-form sk-in-line=false sk-columns=1 flex style=\"margin-top: 5px\"><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelParceiro><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=CODPOSSUIDOR sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelNome><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=NOMEPOSSUIDOR sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelNroNota><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=NFSAIDA sk-enabled=false></sk-text-input></sk-simple-item></sk-simple-form></sk-viewstack-content><sk-viewstack-content layout=column sk-height=100%><sk-simple-form sk-in-line=false sk-columns=1 flex style=\"margin-top: 5px\"><sk-simple-item sk-label=Comercial.FichaPatrimonial.headerCodBem><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=CODBEM sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.headerCodProduto><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=Produto.CODPROD sk-enabled=false></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaPatrimonial.labelProduto><sk-text-input sk-dataset=ctrl.dsFichaPatrimonial sk-field-name=Produto.DESCRPROD sk-enabled=false></sk-text-input></sk-simple-item></sk-simple-form></sk-viewstack-content></sk-viewstack><sk-divider></sk-divider></sk-vbox></sk-hbox></sk-vbox><sk-divider></sk-divider><sk-hbox layout-align=\"left space-around\" layout-padding sk-bg-color=#fbfbfb><h4 flex class=text-bold><sk-i18n>Comercial.FichaPatrimonial.labelStatusBem</sk-i18n><span sk-color={{ctrl.fillcolors()}}>{{ctrl.lblStatusBem}}</span></h4><h4 flex class=text-bold style=\"text-align: end; margin-right: 30px\"><sk-i18n>Comercial.FichaPatrimonial.labelQtdBens</sk-i18n>: <span>{{ctrl.qtdBens}}</span></h4></sk-hbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/fichaPatrimonialPanel/popup/AquisicaoPopUp/AquisicaoPopUp.tpl.html",
    "<sk-dataset entity-name=MovimentacaoPisCofinsAquisicao sk-dataset-created=ctrl.onDatasetCreated(dataset) order-by=NUPARCELA,CODPROD,CODBEM,CODIMP><sk-field pattern=*></sk-field></sk-dataset><sk-vbox flex><sk-top-bar layout=row layout-padding style=\"background-color: #f0f0f0; border : 1px solid #d0c9c9\"><sk-personalized-filter sk-eh-popup=true sk-resource-id=\"{{ ::ctrl.resourceIdFilter }}\" sk-data-source=ctrl.dsMovimentacaoPisCofinsAquisicao sk-padding=\"0px 5px 0px 0px\"></sk-personalized-filter><sk-navigator dataset=ctrl.dsMovimentacaoPisCofinsAquisicao sk-show-add-button=false sk-show-remove-button=false sk-show-copy-button=false sk-compact-btn-add></sk-navigator><div layout=row layout-align=\"end center\" flex><sk-grid-printer sk-grid-controller=ctrl.dgMovimentacaoPisCofinsAquisicao sk-padding=\"0px 5px 0px 0px\"></sk-grid-printer><sk-grid-config sk-config-name=ctrl.resourceIdGridConfig sk-padding=\"0px 5px 0px 0px\"></sk-grid-config><sk-rows-counter sk-dataset=ctrl.dsMovimentacaoPisCofinsAquisicao></sk-rows-counter></div></sk-top-bar><sk-datagrid sk-dataset=ctrl.dsMovimentacaoPisCofinsAquisicao sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-config-name=ctrl.resourceIdGridConfig sk-allow-multiple-selection=false sk-editable=false></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/fichaPatrimonialPanel/popup/DepreciacaoPopUp/DepreciacaoPopUp.tpl.html",
    "<sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsSaldoImobilizado sk-editable=false sk-allow-multiple-selection=false sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-only-custom><sk-datagrid-custom-column sk-field-name=MovimentacaoImobilizado.TIPMOV sk-description=Comercial.FichaPatrimonial.headerTipoMovimento width=125 sk-enabled=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=REFERENCIA sk-description=Comercial.FichaPatrimonial.headerReferencia width=120 sk-enabled=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=SALDO sk-description=Comercial.FichaPatrimonial.headerBaseDepreciacao width=140 sk-enabled=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=MovimentacaoImobilizado.VLRDEP sk-description=Comercial.FichaPatrimonial.headerVlrDepreciacao width=140 sk-enabled=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TOTALDEP sk-description=Comercial.FichaPatrimonial.headerTotalDepreciado width=140 sk-enabled=false></sk-datagrid-custom-column></sk-datagrid></sk-vbox><sk-dataset entity-name=saldoImobilizado sk-dataset-created=ctrl.onDatasetEquipamentoCreated(dataset) sk-standalone><sk-field pattern=CODPROD except=true></sk-field><sk-field pattern=DESCRPROD path=Produto except=true></sk-field><sk-field pattern=CODBEM except=true></sk-field><sk-field pattern=\"REFERENCIA, SALDO, TOTALDEP\"></sk-field><sk-field pattern=\"VLRDEP, TIPMOV\" path=MovimentacaoImobilizado></sk-field></sk-dataset>");
  $templateCache.put("commons/fichaPatrimonialPanel/popup/EquipamentoPopUp/EquipamentoPopUp.tpl.html",
    "<sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsEquipamento sk-editable=false sk-allow-multiple-selection=false sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid)></sk-datagrid></sk-vbox><sk-dataset sk-dataset-created=ctrl.onDatasetEquipamentoCreated(dataset) sk-standalone><sk-dsfield-md name=DESCRPROD description=Comercial.FichaPatrimonial.headerComponente user-type=S width=150></sk-dsfield-md><sk-dsfield-md name=CODBEM description=Comercial.FichaPatrimonial.headerCodBem user-type=S width=100></sk-dsfield-md><sk-dsfield-md name=REFERENCIA description=Comercial.FichaPatrimonial.headerCodBarra user-type=D width=145></sk-dsfield-md><sk-dsfield-md name=COMPLDESC description=Comercial.FichaPatrimonial.headerComplemento user-type=S width=140></sk-dsfield-md><sk-dsfield-md name=TIPO description=Comercial.FichaPatrimonial.headerTipo user-type=S width=100></sk-dsfield-md><sk-dsfield-md name=CARACTERISTICAS description=Comercial.FichaPatrimonial.headerCaracteristicas user-type=S width=130></sk-dsfield-md><sk-dsfield-md name=CODPROD description=Comercial.FichaPatrimonial.headerCodProduto user-type=I width=110></sk-dsfield-md></sk-dataset>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorBuscaMagica/ConfiguradorBuscaMagica.tpl.html",
    "<sk-vbox sk-width=100% sk-height=100% sk-horizontal-align=center><sk-hbox gap=10 layout-padding><button default ng-click=$ctrl.close() sk-button-mode=true sk-padding-left=0px sk-padding-right=0px><sk-icon font-icon=arrow-left></sk-icon></button><sk-hbox layout-align=\"center center\" flex><span sk-text-align=center sk-font-weight=bold sk-font-size=14px sk-i18n>Comercial.FichaParceiro.labelCriterioBuscaMagica</span></sk-hbox></sk-hbox><sk-vbox layout-padding><span class=text-bold sk-i18n=Comercial.FichaParceiro.labelSelecioneCampos></span><sk-vbox layout-top-padding><sk-switch id=checkDescricao sk-value=campos.DESCRICAO sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelDescricao></sk-switch><sk-switch id=checkCaracteristicas sk-value=campos.CARACTERISTICAS sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelCaracteristicas></sk-switch><sk-switch id=checkComplemento sk-value=campos.COMPLEMENTO sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelComplemento></sk-switch><sk-switch id=checkReferencia sk-value=campos.REFERENCIA sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelReferencia></sk-switch><sk-switch id=checkGrupo sk-value=campos.GRUPO sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelGrupo></sk-switch><sk-switch id=checkLocalizacao sk-value=campos.LOCALIZACAO sk-true-value=S sk-false-value=N sk-change=$ctrl.salvarConfig() sk-switch-label=Comercial.FichaParceiro.labelLocalizacao></sk-switch><sk-switch id=checkMarca sk-value=campos.MARCA sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelMarca></sk-switch><sk-switch id=checkCodProd sk-value=campos.CODPROD sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelCodigoProduto></sk-switch><sk-switch id=checkRefForn sk-value=campos.REFFORN sk-change=$ctrl.salvarConfig() sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelReferenciaFornecedor></sk-switch></sk-vbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorColunas/ConfiguradorColunas.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandlerColunas(request) sk-standalone><sk-dsfield-md name=INDICE description=Comercial.FichaParceiro.headerIndice user-type=I is-pk=true></sk-dsfield-md><sk-dsfield-md name=DESCRICAO description=Comercial.FichaParceiro.headerDescricao user-type=S></sk-dsfield-md><sk-dsfield-md name=TIPO description=Comercial.FichaParceiro.headerTipo user-type=S></sk-dsfield-md></sk-dataset><sk-double-face-panel id=gridColunasPlanilha sk-dataset=ctrl.dsColunasPlanilha sk-default-face-index=GRID_FACE creation-complete=ctrl.onDoubleFacePanelCreated(gridColunasPlanilha) sk-height=100% sk-widht=100% layout flex><sk-top-bar layout-padding><sk-navigator dataset=ctrl.dsColunasPlanilha sk-save-handler=ctrl.saveHandler(request) sk-remove-handler=ctrl.removerColuna() sk-compact-btn-add=true sk-show-navigation=false sk-show-refresh-button=false sk-show-copy-button=false></sk-navigator><sk-hbox layout-align=\"end center\" flex><button default ng-click=ctrl.resolverColunas() tooltip=Comercial.FichaParceiro.buttonExecutarConsultaTooltip sk-i18n><span sk-i18n=Comercial.FichaParceiro.buttonExecutarConsulta></button></sk-hbox></sk-top-bar><sk-face-one layout-padding flex><sk-simple-form sk-columns=1 sk-in-line=true flex><sk-simple-item sk-label=Comercial.FichaParceiro.headerIndice sk-required=true><sk-text-input sk-dataset=ctrl.dsColunasPlanilha sk-field-name=INDICE sk-enabled=false sk-width=70></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.headerDescricao sk-required=true><sk-text-input sk-dataset=ctrl.dsColunasPlanilha sk-field-name=DESCRICAO sk-width=180></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelTipoApresentacao sk-required=true><sk-combobox sk-dataset=ctrl.dsColunasPlanilha sk-field-name=TIPO sk-value=ctrl.comboTipoApresentacao sk-options=ctrl.dpTipoApresentacao sk-allow-null=false sk-width=150></sk-combobox></sk-simple-item></sk-simple-form></sk-face-one><sk-face-two layout=column sk-height=100%><sk-hbox flex><sk-datagrid sk-dataset=ctrl.dsColunasPlanilha sk-datagrid-interceptor=ctrl sk-editable=false sk-allow-multiple-selection=false flex><sk-datagrid-custom-column sk-field-name=INDICE sk-visible=true><sk-datagrid-custom-column sk-field-name=DESCRICAO sk-visible=true><sk-datagrid-custom-column sk-field-name=TIPO sk-visible=true sk-cell-formatter=ctrl.buildLabelTipo></sk-datagrid><sk-vbox layout-padding layout-align=\"center center\"><sk-hbox sk-height=100 layout-align=\"center center\"><button default ng-click=ctrl.moverParaCima() tooltip=Comercial.FichaParceiro.buttonMoverCima sk-button-mode=true sk-i18n><span class=\"glyphicons glyphicons-arrow-up\"></span></button> <button default ng-click=ctrl.moverParaBaixo() tooltip=Comercial.FichaParceiro.buttonMoverBaixo sk-button-mode=true sk-i18n><span class=\"glyphicons glyphicons-arrow-down\"></span></button></sk-hbox></sk-vbox></sk-hbox></sk-face-two></sk-double-face-panel>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorConsultaProdutos/ConfiguradorConsultaProdutos.tpl.html",
    "<sk-dataset entity-name=CabecalhoNota sk-dataset-created=ctrl.onDatasetCabecalhoCreated(dataset)></sk-dataset><sk-vbox sk-width=100% sk-padding=\"0px 0px 0px 0px\" flex id=vbox-consultaProdutos><span sk-text-align=center sk-font-weight=bold sk-font-size=14px layout-padding sk-i18n>Comercial.FichaParceiro.labelConfigureFiltros</span><sk-tabnavigator sk-width=100% sk-selected-index=tab_index><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.labelEstoque</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.labelMedias</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.labelFiltroNegociacoes</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=tab_index sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content sk-width=100% sk-height=100% layout=column layout-padding flex><sk-hbox sk-height=100% sk-width=100% flex><sk-vbox sk-width=260px><sk-switch sk-true-value=true sk-false-value=false sk-value=ctrl.checkSubReserv sk-switch-label=Comercial.FichaParceiro.labelSubtrairReservas></sk-switch><sk-simple-form no-padding sk-columns=1><sk-simple-group sk-label=Comercial.FichaParceiro.labelFiltro><sk-simple-item><sk-vbox layout=column><sk-hbox gap=5 layout-bottom-padding flex><button default id=btnValidarFiltro sk-style-name=checkAll ng-click=ctrl.validarFiltro() sk-button-mode=true><span class=\"glyphicon	glyphicon glyphicon-ok\"></span> <span sk-i18n>Comercial.FichaParceiro.buttonValidarFiltro</span></button> <button default ng-click=ctrl.abrirFacilitadorConsulta() sk-button-mode=true><span class=\"glyphicon glyphicon-folder-open\"></span> <span sk-i18n>Comercial.FichaParceiro.buttonAbrirFacilitador</span></button></sk-hbox><sk-text-area id=textAreaFiltro sk-value=ctrl.textAreaFiltro sk-height=95% sk-width=100%></sk-text-area></sk-vbox></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox><sk-vbox layout-left-padding flex><sk-accordion flex close-others=true><sk-accordion-group heading={{::ctrl.labelEmpresa}} is-open=true flex><sk-vbox flex><sk-hbox gap=5 layout-padding><sk-btn-novo sk-compact=true sk-tooltip-placement=top sk-tooltip-text=\"{{'Comercial.FichaParceiro.buttonAdicionarEmpresa' | translate}}\" ng-click=ctrl.addEmpresaEstoque() sk-i18n></sk-btn-novo><button default small ng-click=ctrl.removerEmpresaEstoque() tooltip=Comercial.FichaParceiro.buttonRemoverLocal tooltip-placement=top sk-i18n><sk-icon font-icon=bin></sk-icon></button></sk-hbox><sk-vbox flex><sk-list sk-scroll-container flex class=list-container flex><div flex=grow ng-repeat=\"empresa in ctrl.listEmpresas track by $index\" ng-click=\"ctrl.empSelecionadaRemove(empresa, $index)\"><sk-hbox layout-top-padding=5 gap=5><span sk-font-size=12px>{{empresa['CODEMP'].$}}</span> <span>-</span> <span sk-font-size=12px flex>{{empresa['DESCRICAO'].$}}</span></sk-hbox></div></sk-list></sk-vbox></sk-vbox></sk-accordion-group><sk-accordion-group heading={{::ctrl.labelLocal}} is-open=false flex><sk-vbox flex><sk-hbox gap=5 layout-padding><sk-btn-novo sk-compact=true sk-tooltip-placement=top sk-tooltip-text=\"{{'Comercial.FichaParceiro.buttonAdicionarLocal' | translate}}\" ng-click=ctrl.addLocalEstoque() sk-i18n></sk-btn-novo><button default small ng-click=ctrl.removerLocalEstoque() tooltip=Comercial.FichaParceiro.buttonRemoverLocal tooltip-placement=top sk-i18n><sk-icon font-icon=bin></sk-icon></button></sk-hbox><sk-vbox flex><sk-list sk-scroll-container flex class=list-container flex><div flex=grow ng-repeat=\"local in ctrl.listLocais track by $index\" ng-click=\"ctrl.localSelecionadoRemove(local, $index)\"><sk-hbox layout-top-padding=5 gap=5><span sk-font-size=12px>{{local['CODLOCAL'].$}}</span> <span>-</span> <span sk-font-size=12px flex>{{local['DESCRLOCAL'].$}}</span></sk-hbox></div></sk-list></sk-vbox></sk-vbox></sk-accordion-group></sk-accordion></sk-vbox></sk-hbox></sk-viewstack-content><sk-viewstack-content sk-width=100% sk-height=100% layout=column sk-overflow-y=scroll layout-top-padding layout-bottom-padding flex><sk-simple-form sk-columns=1><sk-simple-group sk-label=Comercial.FichaParceiro.labelConsiderarParaMedias><sk-simple-item><sk-hbox gap=5 flex><sk-radio-input id=considerarUltimasNegs sk-label=Comercial.FichaParceiro.labelAsUltimas sk-value=ctrl.grupoQtdMedia sk-option=1 sk-width=20></sk-radio-input><span sk-i18n>Comercial.FichaParceiro.labelAsUltimas</span><sk-numeric-stepper id=ultimasNegs sk-min-value=1 sk-max-value=99999 sk-value=ctrl.ultimasNegs></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContNegociacoes</span></sk-hbox></sk-simple-item><sk-simple-item layout-top-padding><sk-hbox gap=5 flex><sk-radio-input id=considerarUltimosMeses sk-width=20 sk-option=2 sk-value=ctrl.grupoQtdMedia></sk-radio-input><span sk-i18n>Comercial.FichaParceiro.labelNegociacoesNosUltimos</span><sk-numeric-stepper id=ultimosMeses sk-min-value=1 sk-max-value=99999 sk-value=ctrl.ultimosMeses></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContMeses</span></sk-hbox></sk-simple-item></sk-simple-group></sk-simple-form></sk-viewstack-content><sk-viewstack-content sk-width=100% sk-height=100% layout=column sk-overflow-y=scroll layout-top-padding layout-bottom-padding flex><sk-simple-form sk-columns=1 sk-in-line=true layout-top-padding><sk-simple-item sk-label=Comercial.FichaParceiro.labelTipoMovimento><sk-hbox gap=10 flex><sk-switch sk-value=ctrl.checkPedidos sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelPedidos></sk-switch><sk-switch sk-value=ctrl.checkNotas sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelNotas></sk-switch><sk-switch sk-value=ctrl.checkDevolucoes sk-true-value=S sk-false-value=N sk-switch-label=Comercial.FichaParceiro.labelDevolucoes></sk-switch></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelGrupoTOPs layout-top-padding><sk-vbox sk-height=140 sk-width=220><sk-list sk-scroll-container flex class=list-container><div ng-repeat=\"grupo in ctrl.listGruposTops\"><sk-hbox layout-top-padding gap=5 flex><sk-switch sk-value=grupo.selecionado sk-true-value=S sk-false-value=N></sk-switch><span sk-font-size=12px flex>{{grupo['label']}}</span></sk-hbox></div></sk-list></sk-vbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelFiltroPersonalizado layout-top-padding><sk-personalized-filter sk-entity-name=CabecalhoNota sk-resource-id=ctrl.resourceID sk-data-source=ctrl.dsCabecalho></sk-personalized-filter></sk-simple-item></sk-simple-form></sk-viewstack-content></sk-viewstack><sk-footer-bar sk-bg-color=high-contrast><sk-hbox layout-padding layout-align=\"end end\" gap=10 flex><button default ng-click=ctrl.confirmarRestauracao() sk-button-mode=true sk-i18n>Comercial.FichaParceiro.buttonRestaurar</button> <button default ng-click=ctrl.finalizarConfiguracao(false) sk-button-mode=true sk-i18n>Geral.buttonCancelar</button> <button brand ng-click=ctrl.salvarConfig() sk-button-mode=true sk-i18n>Geral.buttonSalvar</button></sk-hbox></sk-footer-bar></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorDadosParceiro/ConfiguradorDadosParceiro.tpl.html",
    "<sk-vbox sk-width=100% layout=column id=hbox-dadosParceiro sk-padding-top=20px flex><sk-two-lists sk-src-title=Comercial.FichaParceiro.itemNaoVisiveis sk-dest-title=Comercial.FichaParceiro.itemVisiveis sk-src-data=ctrl.srcData sk-dest-data=ctrl.destData sk-on-selection-changed=\"ctrl.selectionListChange(selection, list)\" sk-dest-show-search=false sk-use-bottom-content-right=true layout-right-padding layout-left-padding flex><sk-src-item-tpl><div><span>{{item.DESCRICAO}}</span></div></sk-src-item-tpl><sk-dest-item-tpl><div><span>{{item.DESCRICAO}}</span></div></sk-dest-item-tpl></sk-two-lists><sk-hbox layout-top-padding><sk-simple-form sk-width=50% sk-columns=1 sk-in-line=true><sk-simple-group sk-label=Comercial.FichaParceiro.labelDetalhesCampo><sk-simple-item><sk-switch sk-value=ctrl.checkMostrarValor sk-true-value=true sk-false-value=false sk-change=ctrl.mudarApresentacao() sk-switch-label=Comercial.FichaParceiro.labelApresentarSomenteValor sk-width=300></sk-switch></sk-simple-item><sk-simple-item><sk-combobox sk-value=ctrl.comboFontes sk-change=ctrl.mudarFonteFamily() sk-options=ctrl.dpFontes sk-allow-null=false sk-width=160></sk-combobox></sk-simple-item><sk-simple-item><sk-hbox layout-align=\"center center\" gap=3 sk-width=260 flex><sk-color-picker sk-value=ctrl.colorFonte sk-change=ctrl.mudarCor()></sk-color-picker><sk-numeric-stepper sk-value=ctrl.tamFonte sk-min-value=8 sk-max-value=999 sk-change=ctrl.mudarTamFonte()></sk-numeric-stepper><button ng-class=\"ctrl.btnNegritoSelected ? \n" +
    "                                'btn btn-primary' : 'btn  btn-default'\" tooltip=Comercial.FichaParceiro.buttonNegrito ng-click=ctrl.mudarFonteNegrito() sk-i18n>N</button> <button ng-class=\"ctrl.btnSublinhadoSelected ? \n" +
    "                                'btn btn-primary' : 'btn  btn-default'\" style=\"text-decoration: underline\" tooltip=Comercial.FichaParceiro.buttonSublinhado ng-click=ctrl.mudarFonteSublinhado() sk-i18n>S</button> <button ng-class=\"ctrl.btnItalicoSelected ? \n" +
    "                                'btn btn-primary' : 'btn  btn-default'\" tooltip=Comercial.FichaParceiro.buttonItalico ng-click=ctrl.mudarFonteItalico() sk-i18n>I</button></sk-hbox></sk-simple-item></sk-simple-group></sk-simple-form><sk-simple-form sk-width=50% sk-columns=1 sk-in-line=true><sk-simple-group sk-label=Comercial.FichaParceiro.labelExemplo><sk-simple-item layout-top-padding><sk-vbox layout-align=\"center center\" gap=3 sk-width=280 flex><span style={{ctrl.textDemoStyle}} ng-bind=ctrl.textDemo></span></sk-vbox></sk-simple-item></sk-simple-group></sk-simple-form></sk-hbox><sk-footer-bar sk-bg-color=high-contrast><sk-hbox layout-padding=5 layout-align=\"end end\" gap=5 flex><button default ng-click=ctrl.carregarConfig(true) sk-button-mode=true sk-i18n>Comercial.FichaParceiro.buttonRestaurar</button> <button default ng-click=ctrl.finalizarConfiguracao(false) sk-button-mode=true sk-i18n>Geral.buttonCancelar</button> <button brand ng-click=ctrl.salvarConfig() sk-button-mode=true sk-i18n>Geral.buttonSalvar</button></sk-hbox></sk-footer-bar></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorIndicadores/ConfiguradorIndicadores.tpl.html",
    "<sk-vbox id=vbox-indicadores sk-widht=100% sk-overflow=auto><sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandlerIndicadores(request) sk-standalone><sk-dsfield-md name=EXIBIR description=Comercial.FichaParceiro.labelExibir user-type=S presentation-type=S><sk-options><sk-option data=S></sk-option><sk-option data=N></sk-option></sk-options></sk-dsfield-md><sk-dsfield-md name=DESCRICAO description=Comercial.FichaParceiro.headerDescricao user-type=S></sk-dsfield-md><sk-dsfield-md name=TIPO description=Comercial.FichaParceiro.headerTipo user-type=S></sk-dsfield-md><sk-dsfield-md name=CONSULTA description=Comercial.FichaParceiro.headerTipo user-type=S></sk-dsfield-md><sk-dsfield-md name=IDENTIFICADOR user-type=S></sk-dsfield-md><sk-dsfield-md name=PERSONALIZADO user-type=S></sk-dsfield-md><sk-dsfield-md name=POSSUICONFIGDETALHADA user-type=S></sk-dsfield-md><sk-dsfield-md name=MOSTRARDHBAIXA user-type=S></sk-dsfield-md></sk-dataset><sk-hbox class=high-contrast-panel layout-left-padding style=\"padding-top: 6px !important\"><span class=text-bold sk-i18n>Comercial.FichaParceiro.titleConfigureIndicadoresPainel</span><span class=text-bold>{{ctrl.tituloPainel + '\\\"'}}</span></sk-hbox><sk-double-face-panel id=doubleFaceConfig sk-on-change-face=ctrl.mudarModoFormulario() sk-default-face-index=GRID_FACE creation-complete=ctrl.onDoubleFacePanelCreated(doubleFaceConfig) sk-height=100% sk-widht=100% flex><sk-top-bar layout=row layout-padding><sk-hbox gap=2 flex><sk-btn-novo sk-compact=true sk-tooltip-placement=top sk-tooltip-text=\"{{'Comercial.FichaParceiro.buttonAdicionarIndicador' | translate}}\" ng-click=ctrl.mudarModoInsercao(true)></sk-btn-novo><button class=\"btn btn-sk-sm btn-default btn-remove\" ng-disabled=!ctrl.btnRemoveEnabled ng-click=ctrl.removerConfig() tooltip=Comercial.FichaParceiro.buttonRemoverIndicador tooltip-placement=bottom tooltip-append-to-body=true sk-i18n><sk-icon font-icon=bin></sk-icon></button> <button class=\"btn btn-sk-sm btn-default btn-save\" ng-disabled=!ctrl.statusSalvar ng-click=ctrl.salvarConfig() font-icon=ok-2 tooltip=Comercial.FichaParceiro.buttonSalvarIndicador tooltip-placement=bottom tooltip-append-to-body=true sk-i18n></button> <button class=\"btn btn-sk-sm btn-default btn-refresh\" ng-click=ctrl.refresh() tooltip=Comercial.FichaParceiro.buttonAtualizarIndicador tooltip-placement=bottom tooltip-append-to-body=true sk-i18n><sk-icon font-icon=refresh></sk-icon></button></sk-hbox></sk-top-bar><sk-face-one layout sk-overflow=auto flex><sk-tabnavigator sk-selected-index=ctrl.tabNavigatorIndex><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.labelGeral</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item sk-disabled=!ctrl.detalhesIndicadorEnabled><sk-i18n>Comercial.FichaParceiro.labelDetalhes</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item sk-disabled=!ctrl.painelColunasEnabled><sk-i18n>Comercial.FichaParceiro.labelColunas</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.tabNavigatorIndex layout=column flex><sk-viewstack-content layout flex><sk-vbox sk-width=100% sk-height=100% sk-overflow=auto><sk-simple-form layout-top-padding sk-columns=1 sk-in-line=true><sk-simple-item sk-label=Comercial.FichaParceiro.labelExibir><sk-switch sk-true-value=S sk-false-value=N sk-dataset=ctrl.dsIndicadores sk-value=ctrl.checkExibir sk-field-name=EXIBIR></sk-switch></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelDescricao sk-required=true><sk-text-input sk-dataset=ctrl.dsIndicadores sk-field-name=DESCRICAO sk-width=200></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelTipoApresentacao sk-required=true><sk-combobox sk-width=150 ng-if=ctrl.comboTipoApresentacaoVisible sk-options=ctrl.dpTipoApresentacao sk-value=ctrl.comboTipoApresentacao sk-dataset=ctrl.dsIndicadores sk-field-name=TIPO sk-allow-null=false></sk-combobox><sk-text-input ng-if=ctrl.textTipoApresentacaoVisible sk-value=ctrl.textTipoApresentacao sk-dataset=ctrl.dsIndicadores sk-field-name=TIPO sk-width=150></sk-text-input></sk-simple-item><sk-simple-group sk-label=Comercial.FichaParceiro.labelConsultaSelect ng-if=ctrl.fieldSetConsultaVisible layout=column><sk-vbox layout-padding layout=column flex><sk-hbox layout-align=\"start center\" gap=5><button default ng-click=ctrl.validarConsulta() ng-disabled=!ctrl.btnValidarConsultaEnabled sk-i18n>Comercial.FichaParceiro.buttonValidarConsulta</button> <button default ng-click=ctrl.addVariavel() tooltip=Comercial.FichaParceiro.buttonAdicionarVariavelSelec ng-enabled=ctrl.btnAddVariavelEnabled sk-i18n><span class=\"glyphicons glyphicons-arrow-down\"></span></button><sk-combobox sk-value=ctrl.comboVariaveis sk-options=ctrl.dpVariaveis sk-allow-null=false sk-width=150px></sk-combobox></sk-hbox><sk-hbox layout-top-padding flex><sk-text-area sk-enabled=ctrl.textAreaConsultaEnabled sk-dataset=ctrl.dsIndicadores sk-field-name=CONSULTA sk-value=ctrl.textAreaConsulta sk-width=100%></sk-text-area></sk-hbox></sk-vbox></sk-simple-group></sk-simple-form></sk-vbox></sk-viewstack-content><sk-viewstack-content layout flex><sk-vbox ng-if=ctrl.visibleConfiguradorUltimosMeses flex><sk-configurador-ultimos-meses sk-on-created=ctrl.onCreatedUltimosMeses(component) sk-data=ctrl.dataUltimosMeses sk-configuracao-alterada-handler=ctrl.setConfiguracaoAlteradaHandler() flex></sk-configurador-ultimos-meses></sk-vbox><sk-vbox ng-if=ctrl.visibleConfiguradorUltimasNotas flex><sk-configurador-ultimas-notas sk-on-created=ctrl.onCreatedUltimasNotas(component) sk-data=ctrl.dataUltimaNotas sk-configuracao-alterada-handler=ctrl.setConfiguracaoAlteradaHandler() flex></sk-configurador-ultimas-notas></sk-vbox><sk-vbox ng-if=ctrl.visibleConfiguradorUltimosTitulos flex><sk-configurador-ultimos-titulos sk-on-created=ctrl.onCreatedUltimosTitulos(component) sk-data=ctrl.dataUltimosTitulos sk-configuracao-alterada-handler=ctrl.setConfiguracaoAlteradaHandler() flex></sk-configurador-ultimos-titulos></sk-vbox><sk-vbox ng-if=ctrl.visibleConfiguradorAtraso flex><sk-configurador-ultimos-titulos sk-on-created=ctrl.onCreatedUltimosTitulos(component) sk-data=ctrl.dataAtraso sk-configuracao-alterada-handler=ctrl.setConfiguracaoAlteradaHandler() flex></sk-configurador-ultimos-titulos></sk-vbox><sk-vbox ng-if=ctrl.visibleConfiguradorPontualidade flex><sk-configurador-ultimos-titulos sk-on-created=ctrl.onCreatedUltimosTitulos(component) sk-data=ctrl.dataPontualidade sk-configuracao-alterada-handler=ctrl.setConfiguracaoAlteradaHandler() flex></sk-configurador-ultimos-titulos></sk-vbox></sk-viewstack-content><sk-viewstack-content layout flex><sk-configurador-colunas sk-on-created=ctrl.onCreatedConfiguradorColunas(component) sk-indicador=ctrl.dpIndicador sk-consulta-sql=ctrl.consultaSQL sk-change-handler=ctrl.changeHandlerColunas(colunas) flex></sk-configurador-colunas></sk-viewstack-content></sk-viewstack></sk-face-one><sk-face-two layout flex><sk-hbox flex><sk-datagrid sk-dataset=ctrl.dsIndicadores sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-field-name=EXIBIR sk-visible=true sk-live-check=true><sk-datagrid-custom-column sk-field-name=DESCRICAO sk-visible=true><sk-datagrid-custom-column sk-field-name=TIPO sk-visible=true sk-cell-formatter=ctrl.buildLabelTipo></sk-datagrid><sk-hbox layout-padding layout-align=\"center center\"><sk-vbox sk-height=100 layout-align=\"center center\" gap=3><button default ng-click=ctrl.moverParaCima() tooltip=Comercial.FichaParceiro.buttonMoverCima tooltip-placement=bottom sk-button-mode=true sk-i18n><span class=\"glyphicons glyphicons-arrow-up\"></span></button> <button default ng-click=ctrl.moverParaBaixo() tooltip=Comercial.FichaParceiro.buttonMoverBaixo tooltip-placement=bottom sk-button-mode=true sk-i18n><span class=\"glyphicons glyphicons-arrow-down\"></span></button></sk-vbox></sk-hbox></sk-hbox></sk-face-two></sk-double-face-panel><sk-hbox layout-padding sk-bg-color=high-contrast layout-align=\"start center\" gap=10><button default ng-click=ctrl.confirmarRestauracao() sk-i18n>Comercial.FichaParceiro.buttonRestaurar</button> <button default ng-click=ctrl.finalizarConfiguracao() sk-i18n>Geral.buttonFechar</button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorPaineis/ConfiguradorPaineis.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.createDataSet(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-dsfield-md name=IDENTIFICADOR visible></sk-dsfield-md><sk-dsfield-md name=EXIBIR description=Comercial.FichaParceiro.labelExibir user-type=S presentation-type=S><sk-options><sk-option data=S></sk-option><sk-option data=N></sk-option></sk-options></sk-dsfield-md><sk-dsfield-md name=TITULO description=Comercial.FichaParceiro.headerTituloPainel width=250></sk-dsfield-md><sk-dsfield-md name=TIPO description=Comercial.FichaParceiro.headerTipo width=120></sk-dsfield-md><sk-dsfield-md name=LINHA description=Comercial.FichaParceiro.headerOrdemLinhas width=120></sk-dsfield-md><sk-dsfield-md name=COLUNA description=Comercial.FichaParceiro.headerOrdemColunas width=120></sk-dsfield-md><sk-dsfield-md name=GADGET visible></sk-dsfield-md><sk-dsfield-md name=NUGADGET visible></sk-dsfield-md></sk-dataset><span sk-i18n=Comercial.FichaParceiro.labelConfigureOsPaneisOuCrie></span><sk-double-face-panel id=doubleFacePanel sk-default-face-index=GRID_FACE sk-double-face-panel-created=ctrl.onCreatedFace(doubleFacePanel) sk-width=100% sk-height=100% flex><sk-top-bar layout-padding><sk-hbox gap=5 flex><button default small id=btnAdd ng-click=ctrl.addPainel() sk-button-mode=true tooltip=Comercial.FichaParceiro.buttonAdicionarPainel tooltip-placement=bottom sk-i18n><sk-icon font-icon=plus></sk-icon></button> <button default small id=btnRemove sk-disabled=ctrl.btnRemoveDisabled ng-click=ctrl.removerPainel() tooltip=Comercial.FichaParceiro.buttonRemoverPainel tooltip-placement=bottom sk-i18n><sk-icon font-icon=minus class=no-text></sk-icon></button> <button default small id=btnSave sk-disabled=ctrl.statusSalvarDisabled ng-click=ctrl.salvarPaineis() tooltip=Comercial.FichaParceiro.buttonSalvarPainel tooltip-placement=bottom sk-i18n><sk-icon font-icon=ok class=no-text></sk-icon></button> <button default small id=btnRefresh ng-click=ctrl.carregarConfig() tooltip=Comercial.FichaParceiro.buttonAtualizarPaineis tooltip-placement=bottom sk-i18n><sk-icon font-icon=refresh class=no-text></sk-icon></button></sk-hbox></sk-top-bar><sk-face-one><sk-simple-form sk-in-line=true sk-columns=1><sk-simple-item sk-label=Comercial.FichaParceiro.headerExibir><sk-switch sk-field-name=EXIBIR sk-dataset=ctrl.dsPaineis sk-change=ctrl.campoAlterado() sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelTitulo sk-required=true><sk-text-input id=textTitulo sk-change=ctrl.campoAlterado() sk-field-name=TITULO sk-dataset=ctrl.dsPaineis sk-width=280></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.headerTipo><sk-combobox id=cmbTipo sk-options=list_selector sk-field-name=TIPO sk-dataset=ctrl.dsPaineis sk-change=ctrl.onChangeTipo() sk-allow-null=false sk-enabled=ctrl.comboTipoEnabled sk-width=240></sk-combobox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.itemCompBI ng-if=pesqGadgetVisible><sk-pesquisa-input id=pesqGadget sk-value=\"ctrl.pesqGadget \" sk-entity-name=Gadget sk-field-name=NUGDG sk-change=ctrl.campoAlterado() sk-width=280></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.headerOrdemLinhas sk-required=true><sk-text-input id=textLinha sk-restrict=0-9 sk-change=ctrl.campoAlterado() sk-field-name=LINHA sk-dataset=ctrl.dsPaineis sk-width=160></sk-text-input></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.headerOrdemColunas sk-required=true><sk-text-input id=textColuna sk-restrict=0-9 sk-change=ctrl.campoAlterado() sk-field-name=COLUNA sk-dataset=ctrl.dsPaineis sk-width=160></sk-text-input></sk-simple-item></sk-simple-form></sk-face-one><sk-face-two><sk-datagrid id=gridPaineis sk-datagrid-interceptor=ctrl sk-dataset=ctrl.dsPaineis sk-on-dbl-click=ctrl.mudarModoFormulario() sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('gridPaineis',datagrid)\" sk-editable=false sk-only-custom sk-width=100% sk-height=100% flex><sk-datagrid-custom-column sk-description=Comercial.FichaParceiro.headerExibir sk-field-name=EXIBIR sk-live-check=true sk-width=20></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Comercial.FichaParceiro.headerTituloPainel sk-field-name=TITULO sk-width=200></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Comercial.FichaParceiro.headerTipo sk-field-name=TIPO sk-width=120></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TIPO sk-visible=true><sk-datagrid-custom-column sk-description=Comercial.FichaParceiro.headerOrdemLinhas sk-field-name=LINHA sk-width=60></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Comercial.FichaParceiro.headerOrdemColunas sk-field-name=COLUNA sk-width=60></sk-datagrid-custom-column></sk-datagrid></sk-face-two></sk-double-face-panel>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorPlanilha/ConfiguradorPlanilha.tpl.html",
    "<div class=over100hscroll><sk-datagrid ng-if=\"dsColunas != null\" sk-dataset=dsColunas sk-width=100% sk-height=100% sk-editable=false></sk-datagrid><sk-vbox></sk-vbox></div>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorUltimasNotas/ConfiguradorUltimasNotas.tpl.html",
    "<sk-vbox layout=column layout-padding><sk-hbox gap=5 flex><sk-radio-input sk-id=radioUltimasNotas sk-value=ctrl.radioUltimosMeses sk-option=0 sk-change=ctrl.campoAlterado() sk-width=150px><sk-span sk-i18n>Comercial.FichaParceiro.labelConsiderarApenasAs</sk-span></sk-radio-input><sk-numeric-stepper sk-value=ctrl.textUltimasNotas sk-change=ctrl.campoAlterado() sk-min-value=1 sk-max-value=99999></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContUltimasNotas</span></sk-hbox><sk-hbox gap=2 flex><sk-radio-input sk-id=radioUltimosMeses sk-value=ctrl.radioUltimosMeses sk-option=1 sk-change=ctrl.campoAlterado() sk-width=170px><sk-span sk-i18n>Comercial.FichaParceiro.labelConsiderarNotasNosUltimos</sk-span></sk-radio-input><sk-numeric-stepper sk-value=ctrl.textUltimosMeses sk-change=ctrl.campoAlterado() sk-min-value=1 sk-max-value=99999></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContMeses</span></sk-hbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorUltimosMeses/ConfiguradorUltimosMeses.tpl.html",
    "<sk-simple-form layout-top-padding sk-columns=1 sk-in-line=true><sk-simple-item sk-label=Comercial.FichaParceiro.labelConsiderarNotasNosUltimos><sk-hbox gap=5 flex><sk-numeric-stepper sk-value=ctrl.textUltimosMeses sk-change=ctrl.campoAlterado() sk-min-value=1 sk-max-value=99999></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContMeses</span></sk-hbox></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/fichaparceiro/ConfiguradorUltimosTitulos/ConfiguradorUltimosTitulos.tpl.html",
    "<sk-vbox layout=column layout-padding><sk-hbox gap=5 flex><sk-radio-input sk-id=radioUltimosTitulos sk-value=ctrl.radioUltimosMeses sk-option=0 sk-change=ctrl.campoAlterado() sk-width=150px sk-name=checkTitulo><sk-span sk-i18n>Comercial.FichaParceiro.labelConsiderarApenasOs</sk-span></sk-radio-input><sk-numeric-stepper sk-value=ctrl.textUltimosTitulos sk-change=ctrl.campoAlterado() sk-min-value=1 sk-max-value=99999></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContUltimosTitulos</span></sk-hbox><sk-hbox layout-top-padding gap=2 flex><sk-radio-input sk-id=radioUltimosMeses sk-value=ctrl.radioUltimosMeses sk-option=1 sk-change=ctrl.campoAlterado() sk-width=160px sk-name=checkTitulo><sk-span sk-i18n>Comercial.FichaParceiro.labelConsiderarNotasNosUltimos</sk-span></sk-radio-input><sk-numeric-stepper sk-value=ctrl.textUltimosMeses sk-change=ctrl.campoAlterado() sk-min-value=1 sk-max-value=99999></sk-numeric-stepper><span sk-i18n>Comercial.FichaParceiro.labelContMeses</span></sk-hbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConsultaDeProdutos/ConsultaDeProdutos.tpl.html",
    "<sk-vbox sk-width=100% sk-height=100% layout-top-padding=5 flex><sk-dataset sk-dataset-created=ctrl.onDatasetCreatedNegociados(dataset) sk-refresh-handler=ctrl.refreshHandlerNegociados(request) sk-standalone><sk-dsfield-md name=CODPROD description=Comercial.ConsultaProdutos.labelCodProduto user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRPROD description=Comercial.ConsultaProdutos.labelDescrProd></sk-dsfield-md><sk-dsfield-md name=DTULTNEGOCIACAO description=Comercial.ConsultaProdutos.labelUltimaNegociacao user-type=D></sk-dsfield-md><sk-dsfield-md name=ESTOQUE description=Comercial.ConsultaProdutos.labelConsultaProduto></sk-dsfield-md><sk-dsfield-md name=MAIORVALOR description=Comercial.ConsultaProdutos.labelMaiorValor></sk-dsfield-md><sk-dsfield-md name=MARCA description=Comercial.ConsultaProdutos.labelMarca></sk-dsfield-md><sk-dsfield-md name=MENORVALOR description=Comercial.ConsultaProdutos.labelMenorValor></sk-dsfield-md><sk-dsfield-md name=NUNOTA description=NUNOTA user-type=I></sk-dsfield-md><sk-dsfield-md name=NUNOTAMAIORVALOR description=NUNOTAMAIORVALOR user-type=I></sk-dsfield-md><sk-dsfield-md name=NUNOTAMENORVALOR description=NUNOTAMENORVALOR user-type=I></sk-dsfield-md><sk-dsfield-md name=PERFILPARCEIRO description=PERFILPARCEIRO></sk-dsfield-md><sk-dsfield-md name=QTDMEDIANEG description=Comercial.ConsultaProdutos.labelMediaAtual user-type=F></sk-dsfield-md><sk-dsfield-md name=REFFORN description=Comercial.FichaParceiro.labelRefFornecedor></sk-dsfield-md><sk-dsfield-md name=ULTIMANOTA description=ULTIMANOTA></sk-dsfield-md><sk-dsfield-md name=ULTIMOVALOR description=ULTIMOVALOR user-type=F></sk-dsfield-md><sk-dsfield-md name=USOPROD description=USOPROD></sk-dsfield-md><sk-dsfield-md name=VALORATUAL description=VALORATUAL user-type=F></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetCreatedTipicos(dataset) sk-refresh-handler=ctrl.refreshHandlerProdutosTipicos(request) sk-standalone><sk-dsfield-md name=CODPROD description=Comercial.FichaParceiro.ConsultaProdutos_labelCodProduto user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRPROD description=Comercial.FichaParceiro.ConsultaProdutos_labelDescrProd></sk-dsfield-md><sk-dsfield-md name=USOPROD description=USOPROD sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=JANEGOCIADO description=JANEGOCIADO sk-visible-field=false></sk-dsfield-md></sk-dataset><sk-viewstack sk-selected-index=ctrl.seletorTela.selectedChild class=tab-container layout=column flex><sk-viewstack-content layout=column flex><sk-tabnavigator sk-selected-index=ctrl.selectedIndex><sk-tabnavigator-item ng-click=ctrl.changeTab(0) sk-label=Comercial.FichaParceiro.ConsultaProdutos_labelNegociados></sk-tabnavigator-item><sk-tabnavigator-item ng-click=ctrl.changeTab(1) sk-label=Comercial.FichaParceiro.ConsultaProdutos_labelTipicos></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedIndex class=tab-container layout=column flex><sk-viewstack-content layout=column layout-top-padding flex><sk-vbox sk-overflow-y=auto sk-height=100% class=painel_produto><sk-simple-form class=div_painel_filtro_without_padd sk-in-line=true sk-columns=1><sk-hbox layout-align=\"start center\" gap=5><a href=#! class=link_indicador ng-click=ctrl.goToConfigurarBuscaMagica() tooltip=Comercial.FichaParceiro.ConsultaProdutos_toolTipCriteriosBusca tooltip-placement=bottom sk-i18n>Comercial.FichaParceiro.ConsultaProdutos_labelBusca </a>:<sk-text-input sk-width=100% ng-model=ctrl.filtro sk-value=ctrl.valorBusca sk-keydown=ctrl.keyDownValorBusca($event) flex></sk-text-input><button ng-click=ctrl.realizarConsulta() sk-button-mode=true default><sk-i18n>Comercial.FichaParceiro.ConsultaProdutos_labelOk</sk-i18n></button></sk-hbox><sk-hbox sk-width=100% layout=row gap=5 flex><sk-radio-input class=radio-pref sk-value=ctrl.filtro_estoque sk-option=T><sk-i18n>Comercial.FichaParceiro.ConsultaProdutos_textoTodos</sk-i18n></sk-radio-input><sk-radio-input class=radio-pref sk-value=ctrl.filtro_estoque sk-option=C><sk-i18n>Comercial.FichaParceiro.ConsultaProdutos_labelComEstoque</sk-i18n></sk-radio-input><sk-radio-input class=radio-pref sk-value=ctrl.filtro_estoque sk-option=S><sk-i18n>Comercial.FichaParceiro.ConsultaProdutos_labelSemEstoque</sk-i18n></sk-radio-input></sk-hbox><sk-hbox layout-align=\"start center\" gap=5 layout-padding><sk-i18n>Comercial.FichaParceiro.labelTipo</sk-i18n>:<sk-combobox sk-width=150px sk-value=ctrl.tipo_negociacao sk-options=ctrl.listaTipoNegociacao sk-allow-null=false></sk-combobox></sk-hbox></sk-simple-form><sk-resizable-columns sk-width=100% flex><sk-vbox sk-resizable sk-relative-size={{ctrl.calculateResize()}} sk-direction=\"'right'\" layout-align=\"start center\"><sk-datagrid sk-dataset=ctrl.dsProdutosNegociados sk-on-dbl-click=\"ctrl.openApp('CAD', 'produtosNegociados')\" sk-datagrid-interceptor=ctrl sk-editable=false sk-only-custom><sk-datagrid-custom-column sk-field-name=CODPROD sk-description=Comercial.FichaParceiro.ConsultaProdutos_labelCodProduto sk-i18n></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DESCRPROD sk-description=Comercial.FichaParceiro.ConsultaProdutos_labelDescrProd sk-i18n></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DTULTNEGOCIACAO sk-description=Comercial.FichaParceiro.ConsultaProdutos_labelUltimaNegociacao sk-i18n></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=QTDMEDIANEG sk-description=Comercial.FichaParceiro.ConsultaProdutos_labelMediaAtual sk-cell-formatter=ctrl.buildLabelValorDecimal sk-i18n></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=MARCA sk-description=Comercial.FichaParceiro.ConsultaProdutos_labelMarca sk-i18n></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=REFFORN sk-description=Comercial.FichaParceiro.labelRefFornecedor sk-i18n></sk-datagrid-custom-column></sk-datagrid></sk-vbox><sk-vbox ng-if=ctrl.janelaDetalhesVisivel style=\"overflow: auto; border: 1px solid #e2e2e2; border-radius: 0px; margin-left: 10px\" flex><sk-hbox sk-width=100% class=DashWindow-TopBar><sk-vbox layout-align=\"center start\" flex><sk-i18n class=text-bold>Comercial.FichaParceiro.labelDetalhes</sk-i18n></sk-vbox><sk-vbox sk-width=30px layout-align=\"center end\" sk-padding=3px><button class=DashWindow-btn-close-details ng-click=ctrl.fecharJanelaDetalhes() tooltip=Comercial.FichaParceiro.ConsultaProdutos_toolTipFecharDetalhes tooltip-placement=bottom sk-i18n><sk-icon font-icon=remove style=\"font-size: 12px; padding-top: 2px\"></sk-icon></button></sk-vbox></sk-hbox><sk-vbox sk-width=100% flex><sk-vbox sk-width=100% gap=3 ng-repeat=\"item in ctrl.itensDetalhes\"><sk-hbox sk-width=100% sk-padding=\"10px 0px 2px 15px\"><sk-vbox sk-width=100% layout-align=\"center end\"><a href=#! class=\"link_indicador label_detalhes\" ng-bind=item.label ng-click={{item.click_function}} sk-i18n></a></sk-vbox><sk-vbox sk-width=100% layout-align=\"center start\"><span class=text_detalhes sk-padding=\"0px 0px 0px 10px\" ng-bind=item.bind_object.value></span></sk-vbox></sk-hbox></sk-vbox></sk-vbox></sk-vbox></sk-resizable-columns></sk-vbox></sk-viewstack-content><sk-viewstack-content layout-top-padding layout=column><sk-datagrid sk-dataset=ctrl.dsProdutosTipicos sk-on-dbl-click=\"ctrl.openApp('CAD', 'produtosTipicos')\" sk-datagrid-interceptor=ctrl sk-editable=false></sk-datagrid></sk-viewstack-content></sk-viewstack></sk-viewstack-content><sk-viewstack-content sk-width=100% sk-height=100% layout flex><sk-configurador-busca-magica sk-codparc=ctrl.CODPARC sk-resource-id=ctrl.resourceID sk-finish-handler=ctrl.onFinalizeConfiguracao flex></sk-configurador-busca-magica></sk-viewstack-content><sk-viewstack-content sk-width=100% sk-height=100% layout flex><sk-configurador-consulta-de-produtos sk-codparc=ctrl.CODPARC sk-resource-id=ctrl.resourceID sk-finalize=ctrl.onFinalizeConfiguracao flex></sk-configurador-consulta-de-produtos></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ConsultaEquifax/ConsultaEquifax.tpl.html",
    "<div class=DashWindow><div class=DashWindow-SubBar><table cellspacing=0 cellpadding=0 class=\"DashWindow-TopBar DashWindow-nopadding\"><tbody><tr><td align=left width=100% class=DashWindow_coluna1><div class=DashWindow-TopBar-Title title={{$ctrl.myTitulo}}>{{$ctrl.myTitulo}}</div></td><td align=left class=DashWindow_coluna2><button class=DashWindow-btn ng-click=$ctrl.atualizar()><span class=\"glyphicon glyphicon-repeat\"></span></button></td></tr></tbody></table></div><div ng-if=\"$ctrl.CODPARC == null || $ctrl.CODPARC.toString() == '' \">{{$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'messageSelecioneParceiro')}}</div><div ng-if=\"$ctrl.CODPARC != null || $ctrl.CODPARC.toString() != '' \"><iframe ng-if=mostraIframe src={{url}} style=\"width: 100%; height: 220px\" id=equifaxIframe frameborder=0></iframe></div></div>");
  $templateCache.put("commons/fichaparceiro/DadosParceiro/DadosParceiro.tpl.html",
    "<sk-vbox sk-width=100% sk-height=100% layout-top-padding=5 layout=column flex><sk-viewstack sk-selected-index=ctrl.faceDadosParceiroIndex sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content layout=column layout-align=\"center center\" flex><sk-hbox sk-height=100% sk-width=100% layout-align=\"center center\" flex><sk-title sk-i18n>Core.Parceiro.textSemInformacoes</sk-title></sk-hbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceDadosParceiroIndex sk-width=100% sk-height=100% layout layout=column flex><sk-vbox sk-overflow=auto layout=column flex><sk-tabnavigator sk-selected-index=ctrl.selectedTabIndex><sk-tabnavigator-item sk-label=Comercial.FichaParceiro.labelCadastro></sk-tabnavigator-item><sk-tabnavigator-item sk-label=Comercial.FichaParceiro.labelContato></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedTabIndex sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content layout-padding sk-width=100% sk-height=100% layout=column flex><sk-vbox sk-overflow=auto flex><div class=\"col-xs-12 dados-parceiro\"><div ng-repeat=\"(index, item) in ctrl.campos\"><span style={{ctrl.buildCamposCadastro(item)}}>{{ item.DESCRICAO }} : {{ item.$ }}</span></div></div></sk-vbox></sk-viewstack-content><sk-viewstack-content layout-padding sk-height=100% sk-width=100% flex layout><sk-vbox sk-height=100% sk-width=100% sk-overflow=auto flex><sk-dynaform id=dynaformContato sk-on-dynaform-loaded=\"ctrl.onDynaformLoaded(dynaform, dataset)\" sk-entity-name=Contato sk-skip-start-page=true sk-hide-button-favorite=true sk-hide-button-recents=true sk-dynaform-interceptor=ctrl sk-datagrid-interceptor=ctrl sk-form-interceptor=ctrl sk-helper-class-name=br.com.sankhya.modelcore.helper.ContatoFichaDeParceiroDynaformHelper></sk-dynaform></sk-vbox></sk-viewstack-content></sk-viewstack></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceDadosParceiroIndex sk-width=100% sk-height=100% layout flex><sk-configurador-dados-parceiro sk-on-created=ctrl.onCreatedConfiguradorDadosParceiro(component) sk-resource-id=ctrl.resourceID sk-finalize=ctrl.onFinalizeConfiguracao></sk-configurador-dados-parceiro></sk-viewstack-content></sk-viewstack><sk-vbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/DetalhesLimiteCredito/DetalhesLimiteCredito.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetLimCredito(dataset) sk-refresh-handler=ctrl.refreshHandlerLimCredito(request) sk-standalone><sk-dsfield-md name=MES user-type=I description=Comercial.FichaParceiro.labelMes sk-i18n></sk-dsfield-md><sk-dsfield-md name=ANO user-type=I description=Comercial.FichaParceiro.labelAno sk-i18n></sk-dsfield-md><sk-dsfield-md name=DEBITO user-type=F description=Comercial.FichaParceiro.labelDebito sk-i18n></sk-dsfield-md><sk-dsfield-md name=DISPONIVEL user-type=S description=Comercial.FichaParceiro.labelDisponivel sk-i18n></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetLimCreditoMedia(dataset) sk-refresh-handler=ctrl.refreshHandlerLimCreditoMedia(request) sk-standalone><sk-dsfield-md name=MES user-type=I description=Comercial.FichaParceiro.labelMes sk-i18n></sk-dsfield-md><sk-dsfield-md name=ANO user-type=I description=Comercial.FichaParceiro.labelAno sk-i18n></sk-dsfield-md><sk-dsfield-md name=TOTALMES user-type=F description=Comercial.FichaParceiro.labelTotalMes sk-i18n></sk-dsfield-md></sk-dataset><sk-vbox sk-width=100% sk-height=100% layout=column flex><sk-top-bar><sk-hbox gap=5 flex><button default ng-click=ctrl.onClickVoltar() sk-margin-left=5px sk-i18n>Geral.buttonVoltar</button><sk-hbox layout-align=\"center center\"><span class=text-bold ng-bind=ctrl.infoDetalhesLimCredito></span></sk-hbox></sk-hbox></sk-top-bar><sk-resizable-columns sk-height=100% sk-margin=0px sk-padding=3px><sk-resizable-rows sk-padding=0px><div sk-resizable sk-direction=\"'bottom'\" sk-height=50% sk-padding=3px><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsLimCredito sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false flex></sk-datagrid><sk-footer-bar layout-top-padding><sk-hbox gap=10 flex><sk-hbox gap=2><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelLimiteMensal</span> <span>:</span> <span ng-bind=ctrl.labelLimiteMensal></span></sk-hbox><sk-hbox gap=2><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelLimiteGlobal</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoLimTotal></span></sk-hbox><sk-hbox gap=2><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelLimiteGlobal</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoDebitoTotal></span></sk-hbox><sk-hbox gap=2><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelDisponivelGlobal</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoDebitoTotal></span></sk-hbox></sk-hbox></sk-footer-bar></sk-vbox></div><div ng-if=ctrl.painelLimCredMediaVisible sk-resizable sk-direction=\"'bottom'\" sk-height=50% sk-padding=3px><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dslimCreditoMedia sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false flex></sk-datagrid><sk-footer-bar layout-top-padding><sk-vbox><sk-hbox gap=10 flex><sk-hbox gap=2><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelParamPercAnumMedia</span> <span>:</span> <span ng-bind=ctrl.infoParamMesesMedia></span></sk-hbox><sk-hbox gap=2 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelQtdMesesMedia</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoMesesUtiliz></span></sk-hbox><sk-hbox gap=2 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelTotalDesteMes</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoTotalDesteMes></span></sk-hbox></sk-hbox><sk-hbox gap=10 flex><sk-hbox gap=2 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelParamQtdMesesMedia</span> <span>:</span> <span ng-bind=ctrl.infoParamAumMedia></span></sk-hbox><sk-hbox gap=2 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelTotalMesesAnteriores</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoTotalMesesAnt></span></sk-hbox><sk-hbox gap=2 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelMediaMaisPerc</span> <span class=text-bold>:</span> <span ng-bind=ctrl.infoMediaMaisPerc></span></sk-hbox></sk-hbox></sk-vbox></sk-footer-bar></sk-vbox></div></sk-resizable-rows></sk-resizable-columns></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/DetalhesPontualidade/DetalhesPontualidade.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetFinPontuais(dataset) sk-refresh-handler=ctrl.refreshHandlerFinPontuais(request) sk-standalone><sk-dsfield-md name=NUFIN user-type=I description=Comercial.FichaParceiro.headerNroUnico sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTNEG user-type=D description=Comercial.FichaParceiro.headerDataNegociacao sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTVENC user-type=D description=Comercial.FichaParceiro.headerDataVencimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=DHBAIXA user-type=D description=Comercial.FichaParceiro.headerDataBaixa sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESDOB user-type=F description=Comercial.FichaParceiro.headerValor sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODTIPOOPER user-type=S description=Comercial.FichaParceiro.labelTipoMovimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCROPER user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=NOMEEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODTIPTIT user-type=S description=Comercial.FichaParceiro.headerTipoTitulo sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCRTIPTIT user-type=S description=Comercial.FichaParceiro.labelTipoMovimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODNAT user-type=S description=Comercial.FichaParceiro.headerNatureza sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCRNAT user-type=S description=Comercial.FichaParceiro.headerNatureza sk-i18n></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetFinAtrasados(dataset) sk-refresh-handler=ctrl.refreshHandlerFinAtrasados(request) sk-standalone><sk-dsfield-md name=NUFIN user-type=I description=Comercial.FichaParceiro.headerNroUnico sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTNEG user-type=D description=Comercial.FichaParceiro.headerDataNegociacao sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTVENC user-type=D description=Comercial.FichaParceiro.headerDataVencimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=DHBAIXA user-type=D description=Comercial.FichaParceiro.headerDataBaixa sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESDOB user-type=F description=Comercial.FichaParceiro.headerValor sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODTIPOOPER user-type=S description=Comercial.FichaParceiro.labelTipoMovimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCROPER user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=NOMEEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODTIPTIT user-type=S description=Comercial.FichaParceiro.headerTipoTitulo sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCRTIPTIT user-type=S description=Comercial.FichaParceiro.labelTipoMovimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODNAT user-type=S description=Comercial.FichaParceiro.headerNatureza sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCRNAT user-type=S description=Comercial.FichaParceiro.headerNatureza sk-i18n></sk-dsfield-md></sk-dataset><sk-vbox sk-width=100% sk-height=100% layout=column flex><sk-top-bar layout-top-padding><sk-hbox gap=5 flex><button default ng-click=ctrl.onClickVoltar() sk-margin-left=5px sk-i18n>Geral.buttonVoltar</button><sk-hbox layout-align=\"center center\"><span class=text-bold ng-bind=ctrl.infoCabecalho></span></sk-hbox></sk-hbox></sk-top-bar><sk-resizable-columns sk-width=100% sk-height=100% sk-margin=0px sk-padding=5px flex><sk-resizable-rows sk-padding=10px><div sk-resizable sk-direction=\"'bottom'\" sk-height=50% sk-padding=5px><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsFinPontuais sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-type=I sk-field-name=NUFIN sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTNEG sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTVENC sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DHBAIXA sk-width=120></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=F sk-field-name=VLRDESDOB sk-width=100 sk-text-align=right sk-cell-formatter=ctrl.buildLabelValorDesdob></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=CODTIPOOPER sk-cell-formatter=ctrl.buildLabelTipoMovimentacao sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-text-align=left sk-field-name=CODEMP sk-cell-formatter=ctrl.buildLabelEmpresa sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-text-align=left sk-field-name=CODTIPTIT sk-cell-formatter=ctrl.buildLabelTipoTitulo sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-text-align=left sk-field-name=CODNAT sk-cell-formatter=ctrl.buildLabelNatureza sk-width=250></sk-datagrid-custom-column></sk-datagrid><sk-footer-bar layout-top-padding><sk-vbox><sk-hbox gap=10 layout-align=\"center center\" flex><sk-hbox gap=2><span class=text-bold ng-bind=ctrl.infoFinsPontuais></span></sk-hbox></sk-hbox></sk-vbox></sk-footer-bar></sk-vbox></div><div ng-if=ctrl.painelAtrasadosVisible sk-resizable sk-direction=\"'bottom'\" sk-width=100% sk-height=50% sk-padding=5px><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsFinAtrasados sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-type=I sk-field-name=NUFIN sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTNEG sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTVENC sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DHBAIXA sk-width=120></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=F sk-field-name=VLRDESDOB sk-width=100 sk-text-align=right sk-cell-formatter=ctrl.buildLabelValorDesdob></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=CODTIPOOPER sk-cell-formatter=ctrl.buildLabelTipoMovimentacao sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-text-align=left sk-field-name=CODEMP sk-cell-formatter=ctrl.buildLabelEmpresa sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-text-align=left sk-field-name=CODTIPTIT sk-cell-formatter=ctrl.buildLabelTipoTitulo sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-text-align=left sk-field-name=CODNAT sk-cell-formatter=ctrl.buildLabelNatureza sk-width=250></sk-datagrid-custom-column></sk-datagrid><sk-footer-bar layout-top-padding><sk-vbox><sk-hbox gap=10 flex><sk-hbox gap=2><span class=text-bold ng-bind=ctrl.infoFinsAtrasados></span></sk-hbox></sk-hbox></sk-vbox></sk-footer-bar></sk-vbox></div></sk-resizable-rows></sk-resizable-columns></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/DetalhesRenegociacoes/DetalhesRenegociacoes.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetRenegociacoes(dataset) sk-refresh-handler=ctrl.refreshHandleRenegociacoes(request) sk-standalone><sk-dsfield-md name=RECDESP user-type=S description=Comercial.FichaParceiro.labelRecDesp sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=NURENEG user-type=I description=Comercial.FichaParceiro.labelRenegAtual sk-i18n></sk-dsfield-md><sk-dsfield-md name=NURENEGANT user-type=I description=Comercial.FichaParceiro.labelRenegAnt sk-i18n></sk-dsfield-md><sk-dsfield-md name=NUMNOTA user-type=I description=Comercial.FichaParceiro.headerNroNota sk-i18n></sk-dsfield-md><sk-dsfield-md name=SERIENOTA user-type=S description=Comercial.FichaParceiro.labelSerie sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESDOBRAMENTO user-type=S description=Comercial.FichaParceiro.labelDesdob sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTNEG user-type=D description=Comercial.FichaParceiro.headerDataNegociacao sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTVENC user-type=D description=Comercial.FichaParceiro.headerDataVencimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=NUFIN user-type=I description=Comercial.FichaParceiro.headerNroUnico sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESC user-type=F description=Comercial.FichaParceiro.labelVlrDesconto sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESDOB user-type=F description=Comercial.FichaParceiro.labelVlrDesdob sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRJURO user-type=F description=Comercial.FichaParceiro.labelVlrJuros sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRMULTA user-type=F description=Comercial.FichaParceiro.labelVlrMulta sk-i18n></sk-dsfield-md><sk-dsfield-md name=HISTORICO user-type=S description=Comercial.FichaParceiro.labelHistorico sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODUSU user-type=I description=Comercial.FichaParceiro.labelCodUsuario sk-i18n></sk-dsfield-md><sk-dsfield-md name=NOMEUSU user-type=S description=Comercial.FichaParceiro.labelNomeUsuario sk-i18n></sk-dsfield-md><sk-dsfield-md name=DHALTER user-type=D description=Comercial.FichaParceiro.labelDtAlteracao sk-i18n></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetDetalhesRenegociacoes(dataset) sk-refresh-handler=ctrl.refreshHandlerDetalhesRenegociacoes(request) sk-standalone><sk-dsfield-md name=NURENEG user-type=I description=Comercial.FichaParceiro.labelRenegAtual sk-i18n></sk-dsfield-md><sk-dsfield-md name=NURENEGPOST user-type=I description=Comercial.FichaParceiro.labelRenegPost sk-i18n></sk-dsfield-md><sk-dsfield-md name=NUMNOTA user-type=I description=Comercial.FichaParceiro.headerNroNota sk-i18n></sk-dsfield-md><sk-dsfield-md name=SERIENOTA user-type=S description=Comercial.FichaParceiro.labelSerie sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESDOBRAMENTO user-type=S description=Comercial.FichaParceiro.labelDesdob sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTNEG user-type=D description=Comercial.FichaParceiro.headerDataNegociacao sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTVENC user-type=D description=Comercial.FichaParceiro.headerDataVencimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=NUFIN user-type=I description=Comercial.FichaParceiro.headerNroUnico sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESC user-type=S description=Comercial.FichaParceiro.labelVlrDesconto sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESDOB user-type=S description=Comercial.FichaParceiro.headerValor sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRJURO user-type=S description=Comercial.FichaParceiro.labelVlrJuros sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRMULTA user-type=S description=Comercial.FichaParceiro.labelVlrMulta sk-i18n></sk-dsfield-md><sk-dsfield-md name=HISTORICO user-type=S description=Comercial.FichaParceiro.labelHistorico sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODUSU user-type=I description=Comercial.FichaParceiro.labelCodUsuario sk-i18n></sk-dsfield-md><sk-dsfield-md name=NOMEUSU user-type=S description=Comercial.FichaParceiro.labelNomeUsuario sk-i18n></sk-dsfield-md><sk-dsfield-md name=DHALTER user-type=D description=Comercial.FichaParceiro.labelDtAlteracao sk-i18n></sk-dsfield-md></sk-dataset><sk-vbox sk-width=100% sk-height=100% layout=column flex><sk-top-bar layout-top-padding><sk-hbox gap=5 flex><button default ng-click=ctrl.onClickVoltar() sk-margin-left=5px sk-i18n>Geral.buttonVoltar</button><sk-hbox layout-align=\"center center\"><span class=text-bold ng-bind=ctrl.infoDetalhesRenegociacoes></span></sk-hbox></sk-hbox></sk-top-bar><sk-resizable-columns sk-width=100% sk-height=100% sk-margin=0px sk-padding=10px flex><sk-resizable-rows sk-padding=0px><div sk-resizable sk-direction=\"'bottom'\" sk-width=100% sk-height=50% sk-padding=0px flex><sk-vbox sk-width=100% sk-height=100%><sk-datagrid sk-dataset=ctrl.dsRenegociacoes sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-type=S sk-field-name=RECDESP sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=CODEMP sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NURENEG sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NURENEGANT sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NUMNOTA sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=SERIENOTA sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=DESDOBRAMENTO sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTNEG sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTVENC sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NUFIN sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRDESC sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRDESDOB sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRJURO sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRMULTA sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=HISTORICO sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=CODUSU sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=NOMEUSU sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DHALTER sk-width=140></sk-datagrid-custom-column></sk-datagrid><sk-footer-bar layout-top-padding layout-bottom-padding><sk-vbox><sk-hbox gap=10 flex><sk-hbox gap=2><span class=text-bold ng-bind=ctrl.infoRenegociacoesPeriodo></span></sk-hbox><sk-hbox gap=2><span class=text-bold ng-bind=ctrl.infoMaiorNegociacao></span></sk-hbox><sk-hbox gap=2><span class=text-bold ng-bind=ctrl.infoUltimaNegociacao></span></sk-hbox><sk-hbox gap=2><span class=text-bold ng-bind=ctrl.infoTotal></span></sk-hbox></sk-hbox></sk-vbox></sk-footer-bar></sk-vbox></div><div sk-padding=0px sk-width=100% sk-height=50%><sk-vbox layout-top-padding sk-width=100% sk-height=100%><sk-datagrid sk-dataset=ctrl.dsDetalhesRenegociacoes sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-type=I sk-field-name=NURENEG sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NURENEGPOST sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NUMNOTA sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=SERIENOTA sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=DESDOBRAMENTO sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTNEG sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTVENC sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=NUFIN sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRDESC sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRDESDOB sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRJURO sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=VLRMULTA sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=HISTORICO sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=I sk-field-name=CODUSU sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=NOMEUSU sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DHALTER sk-width=140></sk-datagrid-custom-column></sk-datagrid></sk-vbox></div></sk-resizable-rows></sk-resizable-columns></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/DetalhesUltimoContato/DetalhesUltimoContato.tpl.html",
    "<sk-vbox sk-width=100% sk-height=100% gap=10px flex><sk-top-bar sk-padding=5px><sk-hbox gap=5 flex><button default ng-click=ctrl.onClickVoltar() sk-margin-left=5px sk-i18n>Geral.buttonVoltar</button><sk-hbox layout-align=\"center center\" sk-width=100%><span class=text-bold ng-bind=ctrl.infoCabecalho></span></sk-hbox></sk-hbox></sk-top-bar><sk-vbox sk-margin-top=50px layout-align=\"start center\" flex><a class=lbl-link ng-click=ctrl.mostrarOS()><span ng-bind=ctrl.linkContatoOS.label></span> </a><a class=lbl-link ng-click=ctrl.mostrarTel()><span ng-bind=ctrl.linkContatoTel.label></span> </a><a class=lbl-link ng-click=ctrl.mostrarNotaPedido()><span ng-bind=ctrl.linkContatoNota.label></span></a></sk-vbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/ExibirItemRender/ExibirItemRender.tpl.html",
    "<sk-switch sk-selected=\"{data.EXIBIR.toString() == 'S'}\" ng-click=checkClick(event)></sk-switch>");
  $templateCache.put("commons/fichaparceiro/FichaParceiroContainer/FichaParceiroContainer.tpl.html",
    "<sk-vbox sk-height=100vh sk-width=100% layout=column flex><sk-top-bar class=high-contrast-panel layout-padding style=\"border-bottom: 1px solid #ccc\"><sk-hbox id=filterPanel sk-width=100% sk-direction=horizontal ng-if=!ctrl.B2BMode sk-horizontal-align=left><sk-hbox sk-width=100% sk-horizontal-align=left sk-vertical-align=middle><sk-hbox class=btn-apply><button id=btnVoltar default ng-if=ctrl.embedded ng-click=ctrl.onClickBtnVoltar() tooltip=Comercial.ConsultaProdutos.toolTipVoltar tooltip-placement=right sk-i18n><sk-icon sk-padding-left=5px font-icon=arrow-left></sk-icon><sk-i18n>Comercial.ConsultaProdutos.buttonVoltar</sk-i18n></button></sk-hbox><sk-hbox class=ficha_container_filtro_col1><label ng-click=ctrl.abrirCadastroParceiro() style=\"cursor: pointer; text-decoration: underline\" sk-i18n>Comercial.FichaParceiro.labelParceiro</label><sk-pesquisa-input id=pesqParceiro sk-entity-name=Parceiro sk-field-name=CODPARC sk-description-input=NOMEPARC sk-entity-change=ctrl.carregaInfomacaoParceiro(item) sk-value=ctrl.pesqParceiro sk-enabled=ctrl.pesqParceiroEnabled sk-enviroment-criteria=ctrl.getCriterioParceiro() sk-options=ctrl.optionsSearchParceiro sk-on-created=ctrl.filtraParceiro(pesquisaApi) sk-show-inactives=ctrl.getExibirParcInativos()></sk-pesquisa-input></sk-hbox><sk-hbox class=btn-apply><button default ng-click=ctrl.exibeInfomacaoParceiro() sk-button-mode=true sk-margin-right=8px><sk-i18n>Geral.buttonAplicar</sk-i18n></button> <button default id=btnUsarParceiro ng-if=ctrl.usarParceiroVisible tooltip=Comercial.FichaParceiro.btnUsarParceiroTooltip ng-disabled=!ctrl.usarParceiroEnabled ng-click=ctrl.usarEsteParceiro() tooltip-placement=bottom sk-button-mode=true sk-i18n><sk-i18n>Comercial.FichaParceiro.btnUsarParceiro</sk-i18n></button></sk-hbox><sk-vbox sk-align=\"start center\" class=switch-container><sk-hbox gap=10><sk-switch sk-padding-left=8 id=exibirPorMatriz sk-true-value=S sk-false-value=N sk-value=ctrl.exibirPorMatriz sk-change=ctrl.exibeInfomacaoParceiro()></sk-switch><label sk-margin-top=4px sk-i18n>Comercial.FichaParceiro.lblParceiroMatriz</label></sk-hbox><sk-hbox gap=10><sk-switch sk-padding-left=8 id=exibirParcInativos sk-true-value=true sk-false-value=false sk-value=ctrl.exibirParcInativos sk-change=ctrl.exibeInfomacaoParceiro()></sk-switch><label sk-margin-top=4px sk-i18n>Comercial.FichaParceiro.lblParceiroInativo</label></sk-hbox></sk-vbox><sk-vbox flex layout-padding><sk-btn-other-options sk-other-options=ctrl.otherOptionsLoader() sk-build-on-every-click=true></sk-btn-other-options></sk-vbox><sk-hbox class=topbar-buttons-right><button default ng-click=ctrl.abrirTelemarketing() sk-button-mode=true sk-i18n>Comercial.FichaParceiro.labelTelemarketing</button><sk-btn-place sk-destination=#s:tipdashboards></sk-btn-place><button default sk-style-name=btnEngIcon ng-click=ctrl.configurarPaineis() sk-button-mode=true tooltip=Comercial.FichaParceiro.labelConfigurarPaineis tooltip-placement=bottom ng-if=ctrl.hasConfigAccess sk-i18n><span class=\"glyphicon glyphicon-cogwheel\"></span></button></sk-hbox></sk-hbox></sk-hbox></sk-top-bar><sk-vbox flex><sk-compact-panel sk-on-created=ctrl.onCreatedCompactPanel(component) sk-data-panel=ctrl.paineisInfo sk-refresh-panel-function=ctrl.refreshPainel(id) sk-config-panel-function=ctrl.openConfigPainel(id) sk-on-resize-compact-panel=ctrl.resizeCompactPanel() sk-parent-compile=true sk-min-heigh=340 sk-min-width=400 flex></sk-compact-panel></sk-vbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/GadgetPanel/GadgetPanel.tpl.html",
    "<sk-vbox sk-width=100% sk-height=100% flex><sk-hbox ng-if=ctrl.painelInformacoesVisible sk-height=100% sk-width=100% layout-align=\"center center\" flex><sk-title style=text-align:center sk-i18n>Comercial.FichaParceiro.labelSemInformacoesGrafico</sk-title></sk-hbox><iframe ng-if=ctrl.panelGadgetVisible id=\"{{ 'gadgets-iframe-' + ctrl.nuGdg }}\" ng-src=\"{{ ctrl.src }}\" frameborder=0 scrolling=no sk-load=ctrl.onLoad() ng-style=\"{'width': '100%', 'height': '100%'}\"></iframe></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/GiroNegociacoes/GiroNegociacoes.tpl.html",
    "<sk-dataset entity-name=CabecalhoNota sk-standalone sk-dataset-created=ctrl.onDatasetCreated(dataset)><sk-field pattern=NUNOTA,NUMNOTA,DTNEG,VLRNOTA,VLRDESCTOT,TIPMOV,CODEMP,CODTIPOPER,CODTIPVENDA,CODVEND,ORDEMCARGA,CODPARCTRANSP></sk-field><sk-field pattern=NOMEFANTASIA path=Empresa></sk-field><sk-field pattern=DESCROPER path=TipoOperacao></sk-field><sk-field pattern=DESCRTIPVENDA path=TipoNegociacao></sk-field><sk-field pattern=APELIDO path=Vendedor></sk-field><sk-field pattern=CODEMPOC path=Empresa.EmpresaFinanceiro></sk-field><sk-field pattern=$USERFIELDS></sk-field></sk-dataset><sk-dataset entity-name=ItemNota sk-standalone sk-dataset-created=ctrl.onDatasetCreated(dataset) crud-listener=br.com.sankhya.modelcore.comercial.ItemNotaCrudListener before-refresh-action=ctrl.beforeRefreshActionDsItemNota><sk-field pattern=CODPROD,QTDNEG,VLRDESC,CONTROLE,QTDENTREGUE,VLRUNIT,VLRTOT></sk-field><sk-field pattern=DESCRPROD,USOPROD,DECVLR,PESOBRUTO,REFERENCIA path=Produto></sk-field><sk-field pattern=DESCRVOL path=Volume></sk-field><sk-dsfield-md name=VLRTOTLIQ description=Comercial.FichaParceiro.headerVlrTotLiq user-type=F sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRUNITLIQ description=Comercial.FichaParceiro.headerVlrUnitLiq user-type=F sk-i18n></sk-dsfield-md></sk-dataset><sk-viewstack sk-selected-index=ctrl.faceGiroIndicadoresIndex sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content layout sk-width=100% sk-height=100% flex><sk-vbox id={{ctrl.giroNegociacaoPanelId}} layout=column sk-width=100% sk-height=100% flex><sk-vbox sk-width=100% sk-height=100% ng-show=!ctrl.showGraph><sk-hbox sk-height=100% sk-width=100% layout-align=\"center center\" flex><sk-title sk-i18n>Comercial.FichaParceiro.msgloadingpanel</sk-title></sk-hbox></sk-vbox><sk-vbox sk-width=100% sk-height=100% ng-show=ctrl.showGraph flex><sk-vbox sk-width=100% ng-show=!ctrl.showGrid id=vbox-giroGrafico><sk-hbox sk-height=100% sk-width=100% layout-align=\"center center\" flex><div id={{ctrl.graficoGiroNeg}}></div></sk-hbox><sk-hbox class=bottomBarGiro align=\"center center\"><div ng-click=\"ctrl.linkInfoSelecionado('infoPendencias')\" class=\"link color-black link-giro-neg\" tooltip=Comercial.FichaParceiro.labelNegociacoesPendentes sk-i18n><span sk-i18n>Comercial.FichaParceiro.labelPendentes </span>{{ \": \" + ctrl.infoPendenciasCount }}</div><div ng-click=\"ctrl.linkInfoSelecionado('infoUltimaNegociacao')\" class=\"link color-black link-giro-neg\" tooltip={{ctrl.infoUltimaNegociacaoToolTip}}><span sk-i18n>Comercial.FichaParceiro.labelUltimaNegociacao </span>{{ \": \" + ctrl.infoUltimaNegociacao }}</div><div ng-click=\"ctrl.linkInfoSelecionado('infoMaiorNegociacao')\" class=\"link color-black link-giro-neg\" tooltip={{ctrl.infoMaiorNegociacaoToolTip}}><span sk-i18n>Comercial.FichaParceiro.labelMaiorNegociacao </span>{{ \": \" + ctrl.infoMaiorNegociacaoStr }}</div><div ng-click=\"ctrl.linkInfoSelecionado('infoTotal')\" class=\"link color-black link-giro-neg\" tooltip=Comercial.FichaParceiro.toolTipTotalNegociacoes sk-i18n><span sk-i18n>Comercial.FichaParceiro.labelTodas </span>{{ \": \" + ctrl.infoTotalCount}}</div></sk-hbox></sk-vbox><sk-vbox sk-width=100% sk-height=100% ng-show=ctrl.showGrid><sk-hbox align=\"center center\"><p class=graphTitle>{{ctrl.infoCabecalhoNegociacoes}}</p></sk-hbox><sk-hbox align=\"start center\" gap=6><button default small class=\"btn graphButton\" ng-click=ctrl.voltarGrid() sk-i18n><sk-icon font-icon=arrow-left style=\"margin-top: 5px\"></sk-icon><sk-i18n>Comercial.FichaParceiro.lblGrafico</sk-i18n></button><sk-grid-config sk-config-name={{::ctrl.gridConfigDsNota}}></sk-grid-config><button default small class=btn style=\"width: 110px\" sk-disabled=!ctrl.btnRentabilidade ng-click=ctrl.abrirPopUpRentabilidade() tooltip=Commons.Rentabilidade.buttonRentabilidadeTooltip sk-i18n>Commons.Rentabilidade.buttonRentabilidade</button> <button default small class=btn style=\"width: 120px\" sk-disabled=!ctrl.btnOrdemCarga ng-click=ctrl.abrirPopUpOrdemCarga() tooltip=Comercial.FichaParceiro.toolTipOrdemCarga sk-i18n>Comercial.FichaParceiro.lblOrdemCarga</button><sk-combobox sk-options=ctrl.seletorNotasOpcoes sk-value=ctrl.seletorNotas ng-show=ctrl.seletorNotasVisible sk-allow-null=false sk-change=ctrl.changeSeletorNotas() sk-width=100px tooltip=Comercial.FichaParceiro.toolTipFiltrarNegociacao sk-i18n></sk-combobox></sk-hbox><sk-resizable-columns sk-height=100% sk-margin=0px sk-padding=3px><sk-resizable-rows sk-padding=0px><div sk-resizable sk-direction=\"'bottom'\" sk-height=50% sk-padding=3px><sk-vbox flex><sk-datagrid sk-on-dbl-click=ctrl.abrirNotaPedito() sk-grid-config={{::ctrl.gridConfigDsNota}} sk-dataset=ctrl.dsNota sk-width=100%></sk-datagrid><sk-footer-bar layout-top-padding><sk-hbox layout-align=\"center center\"><sk-grid-config style=\"margin-right: auto\" sk-config-name={{::ctrl.gridConfigDsItemNota}}></sk-grid-config><div style=\"margin-right: 2.5px\"><sk-hbox layout-padding layout-align=\"center center\" gap=5 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelNegociacoes </span><span>:</span> <span>{{ctrl.infoQtdNegociacoes}}</span></sk-hbox></div><div style=\"margin-right: auto\"><sk-hbox layout-padding layout-align=\"center center\" gap=5 flex><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelTotal </span><span>: R$</span> <span>{{ctrl.infoValorTotalNotas}}</span></sk-hbox></div></sk-hbox></sk-footer-bar></sk-vbox></div><div sk-resizable sk-direction=\"'bottom'\" sk-height=50% sk-padding=3px><sk-vbox flex><sk-datagrid sk-on-dbl-click=ctrl.abrirTelaProdutoServico() sk-grid-config={{::ctrl.gridConfigDsItemNota}} sk-dataset=ctrl.dsItemNota sk-width=100%></sk-datagrid><sk-footer-bar layout-top-padding><sk-hbox gap=5 layout-align=\"center center\"><div><sk-hbox layout-padding layout-align=\"center center\" gap=5 tooltip=Comercial.FichaParceiro.labelProdutosTooltip flex sk-i18n><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelProdutos </span><span>:</span> <span>{{ctrl.infoQtdProdutos}}</span></sk-hbox></div><div><sk-hbox layout-padding layout-align=\"center center\" gap=5 tooltip=Comercial.FichaParceiro.labelServicosTooltip flex sk-i18n><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelServicos </span><span>:</span> <span>{{ctrl.infoQtdServicos}}</span></sk-hbox></div><div><sk-hbox layout-padding layout-align=\"center center\" gap=5 tooltip=Comercial.FichaParceiro.labelPesoTooltip flex sk-i18n><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelPeso </span><span>:</span> <span>{{ctrl.infoPeso}}</span></sk-hbox></div><div><sk-hbox layout-padding layout-align=\"center center\" gap=5 tooltip=Comercial.FichaParceiro.labelTotalTooltip flex sk-i18n><span class=text-bold sk-i18n>Comercial.FichaParceiro.labelTotal </span><span>: R$</span> <span>{{ctrl.infoValorTotalItens}}</span></sk-hbox></div></sk-hbox></sk-footer-bar></sk-vbox></div></sk-resizable-rows></sk-resizable-columns></sk-vbox></sk-vbox></sk-vbox></sk-viewstack-content><sk-viewstack-content layout><sk-vbox id=vbox-giroNegociacao style=\"overflow-y: auto\" flex><span style=\"padding: 8px; margin-left: 4px\">Configure o gráfico</span><sk-tabnavigator sk-selected-index=ctrl.configIndex sk-width=100%><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.labelGrafico</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.labelFiltros</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><div ng-if=\"ctrl.configIndex == 0\" id=div-grafico><sk-hbox layout-top-padding flex><sk-simple-form sk-in-line=true sk-columns=1><sk-simple-item sk-label=Comercial.FichaParceiro.labelMostrarGraficoPor sk-i18n><sk-combobox sk-options=ctrl.mostrarGraficoOpcoes sk-change=ctrl.changeTipoGrafico() sk-value=ctrl.comboTipoGraf sk-allow-null=false sk-width=180></sk-combobox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelTipoPeriodo sk-i18n><sk-hbox style=\"width: 200px\" align=\"start center\"><sk-radio-input class=radio-input sk-value=ctrl.grupoPeriodo sk-option=A sk-i18n><sk-i18n>Comercial.FichaParceiro.labelAnual</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.grupoPeriodo sk-option=M sk-i18n><sk-i18n>Comercial.FichaParceiro.labelMensal</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.grupoPeriodo sk-option=Q sk-i18n><sk-i18n>Comercial.FichaParceiro.labelQuinzenal</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.grupoPeriodo sk-option=S sk-i18n><sk-i18n>Comercial.FichaParceiro.labelSemanal</sk-i18n></sk-radio-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelUnidadesPeriodo sk-i18n><sk-numeric-stepper sk-value=ctrl.stepperUndPeriodo></sk-numeric-stepper></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelCheckExibePotencialCompra sk-disabled=!ctrl.checkExibePotencialCompraEnabled sk-i18n><sk-hbox><div><sk-switch sk-value=ctrl.checkExibePotencial sk-true-value=S sk-false-value=N></div><div style=\"margin-left: 8px\"><sk-color-picker sk-value=ctrl.corPotencial></sk-color-picker></div></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelCheckPeriodoFechado sk-i18n><sk-switch sk-value=ctrl.checkExibePeriodoFechado sk-true-value=S sk-false-value=N></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.lblModoInicial sk-i18n><sk-combobox sk-options=ctrl.modoInicialOpcoes sk-value=ctrl.comboModoInicial sk-allow-null=false sk-width=180></sk-combobox></sk-simple-item><sk-simple-group sk-label=Comercial.FichaParceiro.labelCoresRentabilidade><sk-simple-item sk-label=Comercial.FichaParceiro.labelMenorIgual sk-i18n><sk-hbox layout-align=\"start center\" gap=12><sk-text-input sk-restrict=[^0-9\\-] sk-width=50 sk-value=ctrl.percMenorIgual></sk-text-input><span>%</span><div><sk-color-picker sk-value=ctrl.corMenorIgual></sk-color-picker></div></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelMaior sk-i18n><sk-hbox layout-align=\"start center\" gap=12><sk-text-input sk-restrict=[^0-9\\-] sk-width=50 sk-value=ctrl.percMaior></sk-text-input><span>{{ ctrl.labelContMenor }}</span><sk-text-input sk-restrict=[^0-9\\-] sk-width=50 sk-value=ctrl.percMenor></sk-text-input><span>%</span><div><sk-color-picker sk-value=ctrl.corMaiorMenor></sk-color-picker></div></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelMaiorIgual sk-i18n><sk-hbox layout-align=\"start center\" gap=12><sk-text-input sk-restrict=[^0-9\\-] sk-width=50 sk-value=ctrl.percMaiorIgual></sk-text-input><span>%</span><div><sk-color-picker sk-value=ctrl.corMaiorIgual></sk-color-picker></div></sk-hbox></sk-simple-item></sk-simple-group></sk-simple-form></sk-hbox></div><div ng-if=\"ctrl.configIndex == 1\"><sk-hbox layout-top-padding flex><sk-simple-form sk-in-line=true sk-columns=1><sk-simple-item sk-label=Comercial.FichaParceiro.labelTipoMovimento sk-i18n><sk-hbox style=\"width: 400px\" gap=12 align=\"start center\"><span sk-i18n>Comercial.FichaParceiro.labelPedidos</span><div><sk-switch sk-value=ctrl.checkPedidos sk-true-value=S sk-false-value=N></div><span sk-i18n>Comercial.FichaParceiro.labelNotas</span><div><sk-switch sk-value=ctrl.checkNotas sk-disabled=!ctrl.enabledCheckNotas sk-true-value=S sk-false-value=N></div><span sk-i18n>Comercial.FichaParceiro.labelDevolucoes</span><div><sk-switch sk-value=ctrl.checkDevolucoes sk-disabled=!ctrl.enabledCheckDevolucoes sk-true-value=S sk-false-value=N></div></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelGrupoTOPs sk-i18n><sk-hbox style=\"margin: 10px 0px\" layout-align=\"start center\" gap=10><button default ng-click=\"ctrl.marcarDesmarcarTodos('S')\" sk-i18n>Comercial.FichaParceiro.buttonMarcar</button> <button default ng-click=\"ctrl.marcarDesmarcarTodos('N')\" sk-i18n>Comercial.FichaParceiro.buttonDesmarcar</button></sk-hbox><sk-draggable-list sk-src-data=ctrl.listaSelecionados><sk-item-tpl><sk-hbox layout-align=\"start center\" gap=8><div><sk-switch sk-value=item.selecionado sk-true-value=S sk-false-value=N></div><span>{{item.label}}</span></sk-hbox></sk-item-tpl></sk-draggable-list></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelFiltroPersonalizado sk-i18n><sk-personalized-filter sk-entity-name=CabecalhoNota sk-resource-id=\"{{ctrl.ID_GIRO_NEGOCIACOES + ':' + ctrl.resourceID}}\" sk-data-source=ctrl.dsNota></sk-personalized-filter></sk-simple-item></sk-simple-form></sk-hbox></div><sk-footer-bar><sk-hbox layout-padding sk-bg-color=high-contrast layout-align=\"start center\" gap=10 flex><button default sk-i18n ng-click=ctrl.confirmarRestauracao()>Comercial.FichaParceiro.buttonRestaurar</button> <button default sk-i18n ng-click=ctrl.config()>Geral.buttonCancelar</button> <button default style=\"margin-right: 8px\" sk-i18n ng-click=ctrl.salvarConfig()>Geral.buttonSalvar</button></sk-hbox></sk-footer-bar></sk-vbox></sk-viewstack-content></sk-viewstack>");
  $templateCache.put("commons/fichaparceiro/Indicadores/Indicadores.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetDetalhesFinanceiros(dataset) sk-refresh-handler=ctrl.refreshHandlerDetalhesFinanceiros(request) sk-standalone><sk-dsfield-md name=NUFIN user-type=I description=Comercial.FichaParceiro.headerNroUnico sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTNEG user-type=D description=Comercial.FichaParceiro.headerDataNegociacao sk-i18n></sk-dsfield-md><sk-dsfield-md name=DTVENC user-type=D description=Comercial.FichaParceiro.headerDataVencimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=DHBAIXA user-type=D description=Comercial.FichaParceiro.headerDataBaixa sk-i18n></sk-dsfield-md><sk-dsfield-md name=VLRDESDOB user-type=F description=Comercial.FichaParceiro.headerValor sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODTIPOOPER user-type=S description=Comercial.FichaParceiro.labelTipoMovimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCROPER user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=NOMEEMP user-type=S description=Comercial.FichaParceiro.labelEmpresa sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODTIPTIT user-type=S description=Comercial.FichaParceiro.headerTipoTitulo sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCRTIPTIT user-type=S description=Comercial.FichaParceiro.labelTipoMovimento sk-i18n></sk-dsfield-md><sk-dsfield-md name=CODNAT user-type=S description=Comercial.FichaParceiro.headerNatureza sk-i18n></sk-dsfield-md><sk-dsfield-md name=DESCRNAT user-type=S description=Comercial.FichaParceiro.headerNatureza sk-i18n></sk-dsfield-md></sk-dataset><sk-viewstack sk-selected-index=ctrl.dashboardIndicadoresIndex sk-width=100% sk-height=100% layout=column flex><sk-tabnavigator sk-selected-index=ctrl.dashboardIndicadoresIndex><sk-tabnavigator-item sk-label=Geral></sk-tabnavigator-item><sk-tabnavigator-item ng-if=ctrl.habilitaAbaVendaMais sk-label=\"Venda Mais\"></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack-content sk-selected-index=ctrl.dashboardIndicadoresIndex layout sk-width=100% sk-height=100% flex><sk-viewstack sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content layout sk-width=100% sk-height=100% flex><sk-vbox layout=column sk-overflow-y=auto sk-width=100% sk-height=100% flex><sk-vbox ng-if=ctrl.visibleFormIndicadores layout-padding flex><sk-vbox ng-repeat=\"indicador in ctrl.indicadores\"><sk-vbox ng-if=\"indicador.TIPO.$ != 'P'\"><sk-hbox layout-top-padding gap=5 flex><sk-hbox layout-align=\"end end\" flex><span class=link-button ng-click=ctrl.onClickIndicador(indicador)>{{indicador['DESCRICAO'].$}}</span><span>:</span></sk-hbox><sk-hbox flex><span>{{indicador['VALOR']}}</span></sk-hbox></sk-hbox></sk-vbox><sk-vbox ng-if=\"indicador.TIPO.$ == 'P'\" sk-width=100% sk-height=100% style=\"min-height: 150px\" layout-bottom-padding flex><sk-vbox flex><span class=text-bold ng-bind=\"indicador['DESCRICAO'].$\"></span><sk-datagrid sk-on-dbl-click=ctrl.openRelatorioDoubleClick() sk-on-datagrid-loaded=ctrl.onDatagridLoadeIndicadores(datagrid) sk-standalone-dataset-object=\"indicador['DADOS']\" sk-allow-multiple-selection=false sk-editable=false flex></sk-datagrid></sk-vbox></sk-vbox></sk-vbox></sk-vbox></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout flex><sk-vbox layout=column sk-width=100% sk-height=100% sk-overflow-y=auto flex><sk-configurador-indicadores sk-codparc=ctrl.codParc sk-mostrar-indicadores-sistema=!ctrl.personalizado sk-resource-id=ctrl.resourceID sk-on-save=ctrl.refresh sk-identificador-painel=ctrl.identificadorPainel sk-titulo-painel=ctrl.tituloPainel sk-finish-handler=ctrl.configuracaoFinalizada() flex></sk-configurador-indicadores></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout flex><sk-vbox flex><sk-top-bar layout-bottom-padding><sk-hbox gap=5 flex><button default ng-click=ctrl.onClikMudarFaceIndicadores() sk-margin-left=5px sk-i18n>Geral.buttonVoltar</button></sk-hbox></sk-top-bar><sk-datagrid sk-dataset=ctrl.dsDetalhesFinanceiros sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-type=I sk-field-name=NUFIN sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTNEG sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=D sk-field-name=DTVENC sk-width=140></sk-datagrid-custom-column><sk-datagrid-custom-column sk-visible=ctrl.mostrarDhBaixa sk-type=D sk-field-name=DHBAIXA sk-width=120></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=F sk-field-name=VLRDESDOB sk-width=100 sk-text-align=right sk-cell-formatter=ctrl.buildLabelValorDesdob></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-field-name=CODTIPOOPER sk-cell-formatter=ctrl.buildLabelTipoMovimentacao sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-text-align=left sk-field-name=CODEMP sk-cell-formatter=ctrl.buildLabelEmpresa sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-text-align=left sk-field-name=CODTIPTIT sk-cell-formatter=ctrl.buildLabelTipoTitulo sk-width=250></sk-datagrid-custom-column><sk-datagrid-custom-column sk-type=S sk-text-align=left sk-field-name=CODNAT sk-cell-formatter=ctrl.buildLabelNatureza sk-width=250></sk-datagrid-custom-column></sk-datagrid></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout flex><sk-vbox layout=column sk-width=100% sk-height=100% flex><sk-detalhes-renegociacoes sk-on-created=ctrl.onCreatedDetalhesRenegociacao(component) sk-cod-parc=ctrl.codParc sk-indicador=ctrl.indicadores sk-on-click-back-handler=ctrl.onClikMudarFaceIndicadores() flex></sk-detalhes-renegociacoes></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout flex><sk-vbox layout=column sk-width=100% sk-height=100% flex><sk-detalhes-limite-credito sk-on-created=ctrl.onCreatedDetalhesLimiteCredito(component) sk-cod-parc=ctrl.codParc sk-indicador=ctrl.indicadores sk-on-click-back-handler=ctrl.onClikMudarFaceIndicadores() flex></sk-detalhes-limite-credito></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout flex><sk-vbox layout=column sk-width=100% sk-height=100% flex><sk-detalhes-pontualidade sk-on-created=ctrl.onCreatedDetalhesPontualidade(component) sk-cod-parc=ctrl.codParc sk-indicador=ctrl.indicadores sk-on-click-back-handler=ctrl.onClikMudarFaceIndicadores() flex></sk-detalhes-pontualidade></sk-vbox></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.faceIndicadoresIndex sk-width=100% sk-height=100% layout flex><sk-vbox layout=column sk-width=100% sk-height=100% flex><sk-detalhes-ultimo-contato sk-on-created=ctrl.onCreatedDetalhesUltimoContato(component) sk-on-click-back-handler=ctrl.onClikMudarFaceIndicadores() flex></sk-detalhes-ultimo-contato></sk-vbox></sk-viewstack-content></sk-viewstack></sk-viewstack-content><sk-viewstack-content sk-selected-index=ctrl.dashboardIndicadoresIndex layout sk-width=100% sk-height=100% flex ng-if=ctrl.habilitaAbaVendaMais><sk-viewstack sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content layout sk-width=100% sk-height=100% flex><sk-venda-mais width=100% sk-resource-id=ctrl.resourceID sk-codparc=ctrl.codParc sk-eventbus=ctrl._eventBus></sk-venda-mais></sk-viewstack-content></sk-viewstack></sk-viewstack-content></sk-viewstack>");
  $templateCache.put("commons/fichaparceiro/OrdemCargaPopUp/OrdemCargaPopUp.tpl.html",
    "<sk-dataset id=dsOrdemCarga entity-name=OrdemCarga sk-dataset-created=$ctrl.onDatasetCreatedStandAlone(dataset)><sk-field pattern=DTINIC,DTPREVSAIDA,CODVEICULO,CODREG,CODPARCTRANSP,ROTEIRO,HORASAIDA,TIPCARGA,SITUACAO></sk-field></sk-dataset><sk-vbox sk-width=100% sk-height=100% sk-padding-left=3 sk-padding-right=3><sk-simple-form sk-in-line=true sk-columns=2><sk-simple-item sk-field-name=ORDEMCARGA sk-label=Comercial.FichaParceiro.lblOrdemCarga><sk-number-input sk-width=120px sk-dataset=dsOrdemCarga sk-field-name=ORDEMCARGA sk-precision=0 sk-enabled=false></sk-number-input></sk-simple-item><sk-simple-item sk-field-name=CODEMP sk-required=false sk-label=Comercial.FichaParceiro.labelEmpresa><sk-pesquisa-input sk-dataset=dsOrdemCarga sk-field-name=CODEMP sk-entity-name=Empresa sk-enabled=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-field-name=DTINIC sk-label=Comercial.FichaParceiro.labelDataInicio><sk-date-input sk-width=120px sk-dataset=dsOrdemCarga sk-field-name=DTINIC sk-enabled=false></sk-date-input></sk-simple-item><sk-simple-item sk-field-name=DTPREVSAIDA sk-label=Comercial.FichaParceiro.labelDataPrevistaSaida><sk-date-input sk-width=120px sk-dataset=dsOrdemCarga sk-field-name=DTPREVSAIDA sk-enabled=false></sk-date-input></sk-simple-item><sk-simple-item sk-field-name=CODVEICULO sk-required=false sk-label=Comercial.FichaParceiro.labelVeiculo><sk-pesquisa-input sk-dataset=dsOrdemCarga sk-field-name=CODVEICULO sk-entity-name=Veiculo sk-enabled=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-field-name=CODREG sk-required=false sk-label=Comercial.FichaParceiro.labelRegiao><sk-pesquisa-input sk-dataset=dsOrdemCarga sk-field-name=CODREG sk-entity-name=Regiao sk-enabled=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-field-name=CODPARCTRANSP sk-required=false sk-label=Comercial.FichaParceiro.labelParceiroTransportadora><sk-pesquisa-input sk-dataset=dsOrdemCarga sk-field-name=CODPARCTRANSP sk-entity-name=Transportadora sk-enabled=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-field-name=ROTEIRO sk-label=Comercial.FichaParceiro.labelRoteiro><sk-text-area sk-dataset=dsOrdemCarga sk-field-name=ROTEIRO sk-enabled=false></sk-text-area></sk-simple-item><sk-simple-item sk-field-name=HORASAIDA sk-label=Comercial.FichaParceiro.labelHoraSaida><sk-date-time-input sk-width=240px sk-dataset=dsOrdemCarga sk-field-name=HORASAIDA sk-enabled=false></sk-date-time-input></sk-simple-item><sk-simple-item sk-field-name=TIPCARGA sk-required=false sk-label=Comercial.FichaParceiro.labelTipoCarga><sk-combobox sk-dataset=dsOrdemCarga sk-field-name=TIPCARGA sk-enabled=false></sk-combobox></sk-simple-item><sk-simple-item sk-field-name=SITUACAO sk-required=false sk-label=Comercial.FichaParceiro.labelSituacao><sk-combobox sk-dataset=dsOrdemCarga sk-field-name=SITUACAO sk-enabled=false></sk-combobox></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/PendenciasFinanceiras/PendenciaFinanceirasConfigura.tpl.html",
    "<sk-vbox id=configPendencias sk-height=100% sk-width=100%><sk-vbox sk-height=100% sk-width=100% sk-padding-top=5 sk-padding-left=5 sk-padding-right=5><sk-vbox sk-label=\"{{$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'lblPreferencias')}}\" sk-height=100% sk-width=100% sk-padding-top=5><sk-simple-form id=form sk-padding-left=5 sk-padding-right=5><sk-switch id=tituloComBaixaFutura>{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelConsiderarBaixaFutura')}}</sk-switch><sk-simple-item sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelIntervalorVencimento')}}\" sk-direction=vertical><sk-radio-input sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelVazio')}}\" sk-option=T sk-value=config.intervalo></sk-radio-input><sk-radio-input sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelUltimaUtilizado')}}\" sk-option=N sk-value=config.intervalo></sk-radio-input><sk-radio-input sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelHoje')}}\" sk-option=H sk-value=config.intervalo></sk-radio-input><sk-radio-input sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelSemanaAtual')}}\" sk-option=S sk-value=config.intervalo></sk-radio-input><sk-radio-input sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelMesAtual')}}\" sk-option=M sk-value=config.intervalo></sk-radio-input><sk-radio-input sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelPersonalizado')}}\" sk-option=P sk-value=config.intervalo></sk-radio-input><sk-vbox sk-horizontal-align=right sk-vertical-align=middle sk-padding-left=25><sk-simple-item sk-label=\"{{$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelUltimo')}}:\" sk-direction=horizontal><sk-numeric-stepper id=ultimos sk-value=config.ultimos sk-width=50 sk-minimum=0></sk-numeric-stepper><sk-label sk-value=\"$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelDias')\"></sk-label></sk-simple-item><sk-simple-item sk-label=\"{{$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelProximo')}}:\" sk-direction=horizontal><sk-numeric-stepper id=proximos sk-value=config.proximos sk-width=50 sk-minimum=0></sk-numeric-stepper><sk-label sk-value=\"$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelDias')\"></sk-label></sk-simple-item></sk-vbox></sk-simple-item><sk-simple-item sk-label=\"{{$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelCoresGrade')}}:\" sk-direction=vertical sk-padding-top=10 sk-padding-bottom=5><sk-hbox><sk-color-picker id=colorReceita sk-value=config.color_receita></sk-color-picker><sk-label sk-value=\"$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelReceitas')\"></sk-label></sk-hbox><sk-hbox><sk-color-picker id=colorDespesa sk-value=config.color_despesa></sk-color-picker><sk-label sk-value=\"$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelDespesas')\"></sk-label></sk-hbox></sk-simple-item><sk-label sk-value=\"{{$ctrl.resourceManager.getString('Comercial:FichaParceiro', 'labelConfNiveis')}}\"></sk-label><sk-hbox><sk-hbox sk-width=100% sk-horizontal-scroll-policy=off tooltip={txtLabel.text} sk-vertical-scroll-policy=off><sk-switch id=chkBox sk-width=10></sk-switch><sk-label id=txtLabel sk-text={data.label}></sk-label></sk-hbox><sk-vbox sk-width=40 sk-height=100% sk-vertical-align=middle></sk-vbox></sk-hbox></sk-simple-form></sk-vbox><sk-vbox sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'lblGrafico')}}\" sk-padding-left=5 sk-height=100%><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelConfCores')\"></sk-label><sk-simple-form><sk-simple-item></sk-simple-item><sk-simple-item></sk-simple-item></sk-simple-form><sk-vbox sk-width=100%><sk-hbox sk-width=100% sk-padding-right=10 sk-vertical-align=middle><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'lblBaixados')\"></sk-label></sk-hbox><sk-simple-item sk-label=\"{{$ctrl.getLabel('Comercial:FichaParceiro', 'labelTipoPeriodo')}:\" sk-padding-left=20><sk-combobox id=comboTipoPeriodo></sk-combobox></sk-simple-item></sk-vbox><sk-vbox sk-width=100% sk-height=100%><sk-vbox sk-width=100%><sk-hbox sk-width=100% sk-padding-right=10 sk-vertical-align=middle><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'itemHoje')\"></sk-label></sk-hbox><sk-vbox sk-width=100% sk-padding-left=20><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelCorDaFatia') +':'\" sk-text-align=right sk-width=150></sk-label><sk-color-picker id=corFatiaHoje></sk-color-picker></sk-hbox></sk-vbox></sk-vbox><sk-vbox sk-width=100% sk-height=100%><sk-hbox sk-width=100% sk-padding-right=10 sk-vertical-align=middle><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'itemAtrasado')\"></sk-label></sk-hbox><sk-vbox sk-width=100% sk-padding-left=20><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelCorDaFatia')+':'\" sk-text-align=right sk-width=150></sk-label><sk-color-picker id=corFatiaVencendo></sk-color-picker></sk-hbox><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelAtrasadoEmAte')+':'\" sk-text-align=right sk-width=150></sk-label><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelContDias')+''\"></sk-label></sk-hbox><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelAtrasadoEmAte')+':'\" sk-text-align=right sk-width=150></sk-label><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelContDias')\"></sk-label></sk-hbox><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelAtrasadoEmAte')+':'\" sk-text-align=right sk-width=150></sk-label><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelContDias')\"></sk-label></sk-hbox></sk-vbox></sk-vbox><sk-vbox sk-width=100% sk-height=100% sk-padding-bottom=5><sk-hbox sk-width=100% sk-padding-right=10 sk-vertical-align=middle><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'itemVencendo')\"></sk-label></sk-hbox><sk-vbox sk-width=100% sk-height=100% sk-padding-left=20><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelCorDaFatia')+':'\" sk-text-align=right sk-width=150></sk-label><sk-color-picker id=corFatiaAVencer></sk-color-picker></sk-hbox><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelVencendoEmAte')+':'\" sk-text-align=right sk-width=150></sk-label><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelContDias')\"></sk-label></sk-hbox><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelVencendoEmAte')+':'\" sk-text-align=right sk-width=150></sk-label><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelContDias')\"></sk-label></sk-hbox><sk-hbox><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelVencendoEmAte')+':'\" sk-text-align=right sk-width=150></sk-label><sk-label sk-value=\"$ctrl.getLabel('Comercial:FichaParceiro', 'labelContDias')\"></sk-label></sk-hbox></sk-vbox></sk-vbox></sk-vbox></sk-vbox></sk-vbox><button ng-click=$ctrl.confirmarRestauracao() sk-button-mode=true>{{$ctrl.getLabel('Comercial:FichaParceiro', 'buttonRestaurar')}}</button> <button ng-click=\" $ctrl.config()\" sk-button-mode=true>{{$ctrl.getLabel('Geral', 'buttonCancelar')}}</button> <button ng-click=$ctrl.salvarConfig() sk-button-mode=true>{{$ctrl.getLabel('Geral', 'buttonSalvar')}}</button></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/PendenciasFinanceiras/PendenciasFinaceiras.tpl.html",
    "<sk-dataset entity-name=Financeiro sk-standalone sk-ignore-listener-methods=interceptMetadata sk-dataset-created=ctrl.onDatasetCreated(dataset)><sk-field pattern=CODCENCUS,DTNEG,DTVENC,DHBAIXA,VLRDESDOB,DESDOBRAMENTO,PRAZO,PRAZOINICIAL,VLRJUROSMAISMULTA,VLRDESC,PERCDESC,PROVISAO,CODPROJ,NUMCONTRATO,ORDEMCARGA,DTVENCINIC,CODUSUBAIXA,CODPARC,NOSSONUM,NUMDUPL,CODMOEDA,VLRMOEDA,VLRMOEDABAIXA,VLRVARCAMBIAL,VLRMULTAEMBUT,VLRJUROEMBUT,NUCOMPENS,VLRMULTANEGOC,VLRJURONEGOC,VLRMULTALIB,VLRJUROLIB,CODCONTATO,VLRLIQUIDO,HISTORICO,CODTIPOPER,CODEMP,CODTIPTIT,CODNAT,PROVISAO,NUMNOTA,RECDESP,CODPARC,VLRBAIXA,ATRASO,ATRASOINICIAL></sk-field><sk-field pattern=DESCRCENCUS path=CentroResultado></sk-field><sk-field pattern=NOMECONTATO path=Contato></sk-field><sk-field pattern=APELIDO path=Contato></sk-field><sk-field pattern=DESCROPER path=TipoOperacao></sk-field><sk-field pattern=NOMEFANTASIA path=Empresa></sk-field><sk-field pattern=DESCRTIPTIT path=TipoTitulo></sk-field><sk-field pattern=DESCRNAT path=Natureza></sk-field><sk-field pattern=NOMEPARC path=Parceiro></sk-field><sk-field pattern=CODPARCMATRIZ path=Parceiro></sk-field><sk-field pattern=NOMEPARC path=Parceiro.ParceiroMatriz></sk-field><sk-field pattern=$USERFIELDS></sk-field></sk-dataset><sk-vbox id={{ctrl.pendFinanceiroPanel}} ng-show=!ctrl.showConfig sk-width=100% class=PendenciasFinanceirasPanel layout=column flex><sk-top-bar style=\"margin-top: 4px\" ng-show=!ctrl.showGrid sk-width=100%><sk-hbox ng-if=\"ctrl.currentGraph == ctrl.codGraficoPedencias\" align=\"start center\" gap=6><button default small tooltip=Comercial.FichaParceiro.tooltipGrade tooltip-placement=bottom ng-click=ctrl.irParaModoGrade() layout-align=\"center center\" style=\"margin-left: 6px\" sk-i18n><sk-icon font-icon=table></sk-icon></button><sk-combobox sk-options=ctrl.cbSeletorBaixadosOpcoes sk-value=ctrl.cbSeletorBaixados sk-change=ctrl.refresh() sk-allow-null=false sk-width=150px></sk-combobox><button sk-i18n tooltip=Comercial.FichaParceiro.tooltipAplicarFiltro default small ng-click=ctrl.openFiltro() layout-align=\"center center\"><sk-icon font-icon=filter></sk-icon></button></sk-hbox><sk-hbox ng-show=\"ctrl.currentGraph!= ctrl.codGraficoPedencias\" align=\"start center\" gap=6 style=\"margin-top: 6px\"><button default small class=\"btn graphButton\" ng-click=ctrl.nivelAnterior() sk-i18n><sk-icon font-icon=arrow-left></sk-icon><sk-i18n>Geral.lblVoltar</sk-i18n></button></sk-hbox></sk-top-bar><sk-vbox sk-width=100% sk-height=100% ng-show=\"!ctrl.showGraph && !ctrl.showGrid\"><sk-hbox sk-height=100% sk-width=100% layout-align=\"center center\" flex><sk-title sk-i18n>Comercial.FichaParceiro.labelSemInformacoesGrafico</sk-title></sk-hbox></sk-vbox><sk-vbox sk-width=100% sk-height=100% ng-show=ctrl.showGraph flex><sk-vbox sk-width=100% sk-height=100% ng-show=!ctrl.showGrid><sk-vbox sk-height=100% sk-width=100% layout-align=\"center center\"><div id={{ctrl.codGraficoPedencias}} ng-show=\"ctrl.currentGraph == ctrl.codGraficoPedencias\"></div><div id={{ctrl.codGraficoNatureza}} ng-show=\"ctrl.currentGraph == ctrl.codGraficoNatureza\"></div><div id={{ctrl.codGraficoCR}} ng-show=\"ctrl.currentGraph == ctrl.codGraficoCR\"></div><div id={{ctrl.codGraficoTOP}} ng-show=\"ctrl.currentGraph == ctrl.codGraficoTOP\"></div><div id={{ctrl.codGraficoEmpresa}} ng-show=\"ctrl.currentGraph == ctrl.codGraficoEmpresa\"></div><div id={{ctrl.codGraficoParceiro}} ng-show=\"ctrl.currentGraph == ctrl.codGraficoParceiro\"></div></sk-vbox><sk-footer-bar ng-show=\"ctrl.currentGraph == ctrl.codGraficoPedencias\" sk-bg-color=high-contrast align=\"center center\"><sk-vbox sk-width=100% flex><sk-vbox sk-width=100%><sk-hbox align=\"center center\" gap=5 ng-show=\"ctrl.cbSeletorBaixados == 'P'\" sk-width=100%><div ng-click=\"ctrl.proximoNivel({{ctrl.codGraficoPedencias}}, ctrl.infoFinVencidosData)\" class=\"link color-black link-pend-fin\" tooltip={{ctrl.infoFinVencidosTooltip}} ng-style=ctrl.infoFinVencidosColor><span sk-font-size=12px class=text-bold>{{ctrl.infoFinVencidosLabel}}</span></div><div ng-click=\"ctrl.proximoNivel({{ctrl.codGraficoPedencias}}, ctrl.infoFinAVencerData)\" class=\"link color-black link-pend-fin\" tooltip={{ctrl.infoFinAVencerToolTip}} ng-style=ctrl.infoFinAVencerColor><span sk-font-size=12px class=text-bold>{{ctrl.infoFinAVencerLabel}}</span></div><div ng-click=\"ctrl.proximoNivel({{ctrl.codGraficoPedencias}}, ctrl.infoFinAbertosData)\" class=\"link color-black link-pend-fin\" tooltip={{ctrl.infoFinAbertosToolTip}}><span sk-font-size=12px class=text-bold>{{ctrl.infoFinAbertosLabel}}</span></div></sk-hbox><sk-hbox align=\"center center\" gap=5 ng-show=\"ctrl.cbSeletorBaixados == 'B'\" flex><div ng-click=\"ctrl.proximoNivel({{ctrl.codGraficoPedencias}}, ctrl.infoAtrasadosData)\" class=\"link color-black link-pend-fin\" tooltip={{ctrl.infoAtrasadosToolTip}}><span sk-font-size=12px class=text-bold>{{ctrl.infoAtrasadosLabel}}</span></div><div ng-click=\"ctrl.proximoNivel({{ctrl.codGraficoPedencias}}, ctrl.infoTotalData)\" class=\"link color-black link-pend-fin\" tooltip={{ctrl.infoTotalToolTip}}><span sk-font-size=12px class=text-bold>{{ctrl.infoTotalLabel}}</span></div></sk-hbox></sk-vbox><sk-hbox layout-align=\"start center\" sk-width=100% style=\"padding: 3px\" flex><sk-vbox ng-if=ctrl.prazoAtrasoRec sk-width=100% gap=3 flex><div layout=row layout-align=\"start start\" gap=3 flex><span style=\"font-size: 12px\" sk-i18n>Comercial.FichaParceiro.lblPrazoMedioRec</span> <span style=\"font-size: 12px\">: </span><span style=\"font-size: 12px\">{{ctrl.txtPrazoRec}}</span></div><div layout=row layout-align=\"start start\" gap=3 flex><span style=\"font-size: 12px\" sk-i18n>Comercial.FichaParceiro.lblAtrasoMedioRec</span> <span style=\"font-size: 12px\">: </span><span style=\"font-size: 12px\">{{ctrl.txtAtrasoRec}}</span></div></sk-vbox><sk-vbox ng-if=ctrl.prazosAtrasoDesp sk-width=100% gap=3 flex><div layout=row layout-align=\"start start\" gap=3 flex><span style=\"font-size: 12px\" sk-i18n>Comercial.FichaParceiro.lblPrazoMedioDesp</span> <span style=\"font-size: 12px\">: </span><span style=\"font-size: 12px\">{{ctrl.txtPrazoDesp}}</span></div><div layout=row layout-align=\"start start\" gap=3 flex><span style=\"font-size: 12px\" sk-i18n>Comercial.FichaParceiro.lblAtrasoMedioDesp</span> <span style=\"font-size: 12px\">: </span><span style=\"font-size: 12px\">{{ctrl.txtAtrasoDesp}}</span></div></sk-vbox></sk-hbox></sk-vbox></sk-footer-bar><sk-vbox ng-show=\"ctrl.currentGraph != ctrl.codGraficoPedencias\"><sk-hbox layout-align=\"start start\" gap=8 style=\"margin-left: 6px\"><div ng-click=ctrl.getFinanceirosToGrade() class=\"link color-black link-pend-fin\" tooltip=\"Ver títulos\"><span><sk-i18n>Comercial.FichaParceiro.btnVerTitulos</sk-i18n></span></div></sk-hbox></sk-vbox></sk-vbox></sk-vbox><sk-vbox sk-width=100% sk-height=100% ng-show=ctrl.showGrid><sk-hbox align=\"start center\" style=\"margin: 10px 0px\" gap=6><button default small class=\"btn graphButton\" ng-click=ctrl.irParaModoGrafico() sk-i18n><sk-icon font-icon=arrow-left></sk-icon><sk-i18n>Geral.lblVoltar</sk-i18n></button><sk-grid-config sk-config-name={{::ctrl.gridConfigDsFinanceiro}}></sk-grid-config><button sk-i18n tooltip=Comercial.FichaParceiro.labelModoGrafico default small ng-click=ctrl.irParaModoGraficoPendencias() layout-align=\"center center\"><sk-icon font-icon=stats></sk-icon></button> <button sk-i18n tooltip=Comercial.FichaParceiro.tooltipAplicarFiltro default small ng-click=ctrl.openFiltro() layout-align=\"center center\"><sk-icon font-icon=filter></sk-icon></button><sk-btn-other-options sk-other-options=ctrl.initMenuOutrasOpcoes()></sk-btn-other-options><span class=labelMovFin sk-i18n>Comercial.FichaParceiro.labelMovFinanc</span><sk-rows-counter style=\"margin-right: 8px\" sk-dataset=ctrl.dsFinanceiro></sk-rows-counter></sk-hbox><sk-vbox flex><sk-datagrid sk-grid-config={{::ctrl.gridConfigDsFinanceiro}} sk-dataset=ctrl.dsFinanceiro sk-on-dbl-click=ctrl.abrirTelaMovFinanceira() sk-datagrid-interceptor=ctrl sk-width=100%></sk-datagrid></sk-vbox><sk-hbox layout-align=\"space-around center\" class=bottomBarGrid style=\"margin: 8px 0px\" gap=6><div style=\"margin-left: 6px\"><sk-i18n>Comercial.FichaParceiro.labelTotalReceitas</sk-i18n><span ng-style=ctrl.buttomGridReceita>{{ctrl.totReceita}}</span></div><div><sk-i18n>Comercial.FichaParceiro.labelTotalDespesas</sk-i18n><span ng-style=ctrl.buttomGridDespesa>{{ctrl.totDespesa}}</span></div><div style=\"margin-right: 6px\"><sk-i18n>Comercial.FichaParceiro.labelCalcSaldo</sk-i18n><span ng-style=ctrl.buttomGridRecDesp>{{ctrl.totRecDesp}}</span></div></sk-hbox></sk-vbox></sk-vbox><sk-vbox ng-show=ctrl.showConfig sk-width=100% id=vbox-pendenciasFinanceiras layout=column flex><sk-tabnavigator sk-width=100% sk-selected-index=ctrl.configIndex><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.lblPreferencias</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Comercial.FichaParceiro.lblGrafico</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.configIndex sk-width=100% sk-height=100% layout=column flex><sk-viewstack-content sk-width=100% sk-height=100% layout=column layout-padding flex><div sk-overflow-y=scroll><sk-simple-form class=formPref sk-in-line=false sk-columns=1><sk-simple-item><sk-hbox style=\"width: 400px\" align=\"center center\"><div><sk-switch sk-value=ctrl.tituloComBaixaFutura sk-true-value=true sk-false-value=false></div><span style=\"margin-top: 3px\"><sk-i18n>Comercial.FichaParceiro.labelConsiderarTituloPendente</sk-i18n></span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelIntervalorVencimento sk-i18n><sk-vbox style=\"width: 200px\" align=\"start center\"><sk-radio-input class=radio-input sk-value=ctrl.intervaloVencimento sk-option=T sk-i18n><sk-i18n>Comercial.FichaParceiro.labelVazio</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.intervaloVencimento sk-option=N sk-i18n><sk-i18n>Comercial.FichaParceiro.labelUltimaUtilizado</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.intervaloVencimento sk-option=H sk-i18n><sk-i18n>Comercial.FichaParceiro.labelHoje</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.intervaloVencimento sk-option=S sk-i18n><sk-i18n>Comercial.FichaParceiro.labelSemanaAtual</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.intervaloVencimento sk-option=M sk-i18n><sk-i18n>Comercial.FichaParceiro.labelMesAtual</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.intervaloVencimento sk-option=P sk-i18n><sk-i18n>Comercial.FichaParceiro.labelPersonalizado</sk-i18n></sk-radio-input><sk-vbox sk-disabled=\"ctrl.intervaloVencimento != 'P'\" align=\"center center\"><sk-simple-item sk-label=Comercial.FichaParceiro.labelUltimo sk-i18n><sk-hbox align=\"center center\"><sk-numeric-stepper sk-value=ctrl.ultimos></sk-numeric-stepper><span style=\"margin-left: 8px\" sk-i18n>Comercial.FichaParceiro.labelDias</span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelProximo sk-i18n><sk-hbox align=\"center center\"><sk-numeric-stepper sk-value=ctrl.proximos></sk-numeric-stepper><span style=\"margin-left: 8px\" sk-i18n>Comercial.FichaParceiro.labelDias</span></sk-hbox></sk-simple-item></sk-vbox></sk-vbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelCoresGrade sk-i18n><sk-hbox layout-align=\"start center\"><sk-color-picker style=\"width: 25px; margin: 5px 0px\" sk-value=ctrl.colorReceita></sk-color-picker><span style=\"margin-left: 8px\" sk-i18n>Comercial.FichaParceiro.labelReceitas</span></sk-hbox><sk-hbox layout-align=\"start center\"><sk-color-picker style=\"width: 25px; margin: 5px 0px\" sk-value=ctrl.colorDespesa></sk-color-picker><span style=\"margin-left: 8px\" sk-i18n>Comercial.FichaParceiro.labelDespesas</span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelConfNiveis sk-i18n><sk-draggable-list style=\"width: 400px\" sk-src-data=ctrl.lstNiveis sk-api=ctrl.listApi><sk-item-tpl><sk-hbox layout-align=\"start center\" gap=8><div><sk-switch sk-value=item.selected sk-true-value=true sk-false-value=false></div><span>{{item.label}}</span></sk-hbox></sk-item-tpl></sk-draggable-list></sk-simple-item></sk-simple-form></div></sk-viewstack-content><sk-viewstack-content sk-width=100% sk-height=100% layout=column layout-padding flex><div sk-overflow-y=scroll><span style=\"margin-left: 3px; margin-top: 8px; margin-bottom: 8px\"><sk-i18n>Comercial.FichaParceiro.labelConfCores</sk-i18n></span><sk-vbox style=\"margin-left: 16px\" align=\"start center\"><sk-radio-input class=radio-input sk-value=ctrl.grupoGrafico sk-option=B sk-i18n><sk-i18n>Comercial.FichaParceiro.labelMostraGrafico</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.grupoGrafico sk-option=P sk-i18n><sk-i18n>Comercial.FichaParceiro.labelMostrarGraficoPizza</sk-i18n></sk-radio-input></sk-vbox><sk-simple-form sk-in-line=true sk-columns=1><sk-simple-group sk-label=Comercial.FichaParceiro.lblBaixados><sk-simple-item sk-label=Comercial.FichaParceiro.labelTipoPeriodo sk-i18n><sk-combobox sk-options=ctrl.comboTipoPeriodoOpcoes sk-value=ctrl.comboTipoPeriodo sk-allow-null=false sk-width=300px></sk-combobox></sk-simple-item></sk-simple-group><sk-simple-group sk-label=Comercial.FichaParceiro.itemHoje><sk-simple-item sk-label=Comercial.FichaParceiro.labelCorDaFatia sk-i18n><sk-color-picker style=\"width: 25px; margin: 5px 0px\" sk-value=ctrl.corFatiaHoje></sk-color-picker></sk-simple-item></sk-simple-group><sk-simple-group sk-label=Comercial.FichaParceiro.itemAtrasado><sk-simple-item sk-label=Comercial.FichaParceiro.labelCorDaFatia sk-i18n><sk-color-picker style=\"width: 25px; margin: 5px 0px\" sk-value=ctrl.corFatiaVencendo></sk-color-picker></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelAtrasadoEmAte sk-i18n><sk-hbox><sk-text-input sk-value=ctrl.textVenc1></sk-text-input><span class=spanGraph sk-i18n>Comercial.FichaParceiro.labelContDias</span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelAtrasadoEmAte sk-i18n><sk-hbox><sk-text-input sk-value=ctrl.textVenc2></sk-text-input><span class=spanGraph sk-i18n>Comercial.FichaParceiro.labelContDias</span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelAtrasadoEmAte sk-i18n><sk-hbox><sk-text-input sk-value=ctrl.textVenc3></sk-text-input><span class=spanGraph sk-i18n>Comercial.FichaParceiro.labelContDias</span></sk-hbox></sk-simple-item></sk-simple-group><sk-simple-group sk-label=Comercial.FichaParceiro.itemVencendo><sk-simple-item sk-label=Comercial.FichaParceiro.labelCorDaFatia sk-i18n><sk-color-picker style=\"width: 25px; margin: 5px 0px\" sk-value=ctrl.corFatiaAVencer></sk-color-picker></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelVencendoEmAte sk-i18n><sk-hbox><sk-text-input sk-value=ctrl.textAVencer1></sk-text-input><span class=spanGraph sk-i18n>Comercial.FichaParceiro.labelContDias</span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelVencendoEmAte sk-i18n><sk-hbox><sk-text-input sk-value=ctrl.textAVencer2></sk-text-input><span class=spanGraph sk-i18n>Comercial.FichaParceiro.labelContDias</span></sk-hbox></sk-simple-item><sk-simple-item sk-label=Comercial.FichaParceiro.labelVencendoEmAte sk-i18n><sk-hbox><sk-text-input sk-value=ctrl.textAVencer3></sk-text-input><span class=spanGraph sk-i18n>Comercial.FichaParceiro.labelContDias</span></sk-hbox></sk-simple-item></sk-simple-group></sk-simple-form></div></sk-viewstack-content></sk-viewstack><sk-hbox class=bottomBarGiro gap=10 align=\"end center\"><button default sk-i18n ng-click=ctrl.confirmarRestauracao()>Comercial.FichaParceiro.buttonRestaurar</button> <button default sk-i18n ng-click=ctrl.config()>Geral.buttonCancelar</button> <button default style=\"margin-right: 8px\" sk-i18n ng-click=ctrl.salvarConfig()>Geral.buttonSalvar</button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/fichaparceiro/PopUpPesquisaParceiro/PopUpPesquisaParceiro.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) entity-name=CartaoCredito sk-crud-listener=br.com.sankhya.mgefin.model.listeners.CartaoCreditoCrudListener sk-standalone></sk-dataset><sk-hbox sk-width=100%><sk-vbox><sk-simple-form sk-columns=1 sk-in-line=true><sk-simple-item sk-i18n sk-label=Comercial.FichaParceiro.labelNomeTitular><sk-text-input sk-value=ctrl.nomeText sk-width=200></sk-text-input></sk-simple-item><sk-simple-item sk-i18n sk-label=Comercial.FichaParceiro.labelCPF><sk-number-input sk-value=ctrl.cpfText sk-width=200></sk-number-input></sk-simple-item><sk-simple-item sk-i18n sk-label=Comercial.FichaParceiro.labelNumeroCartao><sk-number-input sk-value=ctrl.numCartaoText sk-width=200></sk-number-input></sk-simple-item></sk-simple-form><sk-hbox layout-padding flex><button default ng-click=ctrl.carregaFiltro() sk-i18n>Comercial.FichaParceiro.labelAplicar</button></sk-hbox></sk-vbox></sk-hbox><sk-datagrid sk-dataset=ctrl.dsCartaoCredito sk-on-dbl-click=ctrl.selecionaParceiro() sk-editable=false sk-width=100% sk-height=100%><sk-datagrid-custom-column sk-field-name=NUCCR></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPARC></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=Parceiro.RAZAOSOCIAL></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NOMENOCARTAO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NROCARTAOMASC></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=Parceiro.NOMEPARC></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CGC_CPF></sk-datagrid-custom-column></sk-datagrid>");
  $templateCache.put("commons/fichaparceiro/PopupFiltraEstoque/PopupFiltraEstoque.tpl.html",
    "<sk-dataset id=dsEstoque entity-name=Estoque sk-dataset-created=$ctrl.onDatasetCreated(dataset) sk-standalone></sk-dataset><filter-assistent form=filterConfiguradorConsultaProdutos transient-filter=transientFilter standalone-mode=true entity-name=Estoque resource-id=\"{{ $ctrl.resourceID }}\"></filter-assistent>{{$scope.transientFilter }}");
  $templateCache.put("commons/fichaparceiro/PopupFiltroPendenciasFinanceiras/PopupFiltroPendenciasFinanceiras.tpl.html",
    "<sk-simple-form sk-in-line=false sk-columns=1 style=\"overflow: hidden\"><sk-simple-item sk-label=Comercial.FichaParceiro.labelPeriodoVencimento sk-i18n><sk-date-period-input sk-value=ctrl.periodo></sk-simple-item><sk-simple-group sk-label=Comercial.FichaParceiro.labelRecDesp><sk-simple-item sk-i18n><sk-radio-input class=radio-input sk-disabled=!ctrl.chkReceitaEnabled sk-value=ctrl.groupRecDespAmbos sk-option=1 sk-i18n><sk-i18n>Comercial.FichaParceiro.labelReceitas</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-disabled=!ctrl.chkDespesaEnabled sk-value=ctrl.groupRecDespAmbos sk-option=-1 sk-i18n><sk-i18n>Comercial.FichaParceiro.labelDespesas</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-disabled=!ctrl.chkAmbosEnabled sk-value=ctrl.groupRecDespAmbos sk-option=A sk-i18n><sk-i18n>Comercial.FichaParceiro.labelAmbos</sk-i18n></sk-radio-input></sk-simple-item></sk-simple-group><sk-simple-group sk-label=Comercial.FichaParceiro.labelRealProvisao><sk-simple-item sk-i18n><sk-radio-input class=radio-input sk-value=ctrl.groupRealProvAmbos sk-option=N sk-i18n><sk-i18n>Comercial.FichaParceiro.labelReal</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.groupRealProvAmbos sk-option=S sk-i18n><sk-i18n>Comercial.FichaParceiro.labelProvisao</sk-i18n></sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.groupRealProvAmbos sk-option=A sk-i18n><sk-i18n>Comercial.FichaParceiro.labelAmbos</sk-i18n></sk-radio-input></sk-simple-item></sk-simple-group></sk-simple-form>");
  $templateCache.put("commons/fichaparceiro/VendaMais/VendaMais.tpl.html",
    "<div id=vendaMais style=width:100%></div>");
  $templateCache.put("commons/fileUpload/fileUpload.tpl.html",
    "<sk-vbox><sk-simple-form flex layout sk-only-custom><sk-simple-item sk-label=\"Selecione o arquivo:\" sk-column=2 sk-required=true sk-padding=\"15px 15px\"><sk-file-input sk-file-key={{ctrl.fileKey}} sk-name-as-value=true sk-upload-state=\"ctrl.uploadState($state, $value, $component)\"></sk-file-input></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/FormatadorCuboRelatorio.tpl.html",
    "<sk-dataset entity-name=FormatadorRelatorio sk-dataset-created=$ctrl.onDatasetCreated(dataset)><sk-field pattern=*></sk-field></sk-dataset><sk-vbox sk-height=100%><sk-vbox><sk-hbox sk-margin=15px flex><sk-navigator dataset=$ctrl.ds sk-show-navigation=false sk-show-refresh-button=false sk-compact-btn-add></sk-navigator><button id=btnOpenRelatorio buttonmode=true default tooltip=Core.FormatadorCuboRelatorio.msgAvailableReports tooltip-placement=bottom ng-click=$ctrl.openPopUpRelatorios() sk-i18n>Core.FormatadorCuboRelatorio.msgAvailableReports</button></sk-hbox><sk-form sk-dataset=$ctrl.ds sk-inline=true columns=1 sk-width=25% sk-only-custom><sk-form-custom-item sk-field-name=NOME></sk-form-custom-item><sk-form-custom-item sk-field-name=CODGRUPOREL sk-required=true></sk-form-custom-item></sk-form></sk-vbox><sk-tabnavigator sk-selected-index=$ctrl.selectedIndex><sk-tabnavigator-item sk-closeable-tabs=false><sk-i18n>Core.FormatadorCuboRelatorio.lblFields</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item sk-closeable-tabs=false><sk-i18n>Core.FormatadorCuboRelatorio.lblSettings</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=$ctrl.selectedIndex class=tab-container layout=column sk-creation-policy=all flex><sk-viewstack-content layout flex><selecao-campos sk-dataset=$ctrl.ds tipo-relatorio=$ctrl.tipoRel campos-dp=$ctrl.arvoreCampos modo-cubo=false recarrega-campos=$ctrl.carregarCamposTipoRelatorio() on-create-complete=$ctrl.onCreateCompleteSelecao($instance) layout-padding style=\"position: absolute; width: 100%; height: 100%\"></sk-viewstack-content><sk-viewstack-content layout-padding><sk-vbox sk-margin-top=10px gap=8 flex><sk-hbox gap=8><sk-vbox gap=8 sk-margin-bottom=10px><sk-checkbox ng-model=$ctrl.ckcImpDet ng-change=\"$ctrl.changeFlagResumoField('D', $ctrl.ckcImpDet)\"><sk-i18n>Core.FormatadorCuboRelatorio.lblImpDet</sk-i18n></sk-checkbox><sk-checkbox ng-model=$ctrl.ckcImpTot ng-change=\"$ctrl.changeFlagResumoField('T', $ctrl.ckcImpTot)\"><sk-i18n>Core.FormatadorCuboRelatorio.lblImpTot</sk-i18n></sk-checkbox></sk-vbox><sk-vbox gap=8 sk-margin-bottom=10px><sk-checkbox ng-model=$ctrl.ckcContReg ng-change=\"$ctrl.changeFlagResumoField('C', $ctrl.ckcContReg)\"><sk-i18n>Core.FormatadorCuboRelatorio.lblContReg</sk-i18n></sk-checkbox><sk-checkbox ng-model=$ctrl.ckcDistinct ng-change=\"$ctrl.changeFlagResumoField('I', $ctrl.ckcDistinct)\"><sk-i18n>Core.FormatadorCuboRelatorio.lblDistinct</sk-i18n></sk-checkbox></sk-vbox></sk-hbox><sk-form sk-dataset=$ctrl.ds sk-inline=true sk-width=25% layout-align=\"start center\" sk-only-custom><sk-form-custom-item sk-field-name=ORIENTACAO><sk-combobox sk-field-name=ORIENTACAO sk-dataset=$ctrl.ds sk-value=$ctrl.orientation sk-options=$ctrl.optOrientation></sk-combobox></sk-form-custom-item></sk-form><sk-title sk-i18n sk-text=Core.FormatadorCuboRelatorio.logomarca sk-font-size=12px></sk-title><sk-checkbox ng-model=$ctrl.ckcImprimeLogo sk-true-value=S sk-false-value=N ng-change=\"$ctrl.changeParamsField('ImprimirLogomarca', $ctrl.ckcImprimeLogo ? 'S' : 'N')\"><sk-i18n>Core.FormatadorCuboRelatorio.lblImprimeLogo</sk-i18n></sk-checkbox><sk-hbox layout-align=\"start center\"><sk-text-input sk-enabled=$ctrl.ckcImprimeLogo sk-value=$ctrl.logomarca sk-change=\"$ctrl.changeParamsField('PathLogomarcaSW', $ctrl.logomarca)\" sk-width=400px></sk-text-input><button type=button class=\"btn btn-default btn-sk-md\" ng-click=$ctrl.listarImagens() sk-margin-left=5px sk-height=15px tooltip=Core.FormatadorCuboRelatorio.tooltipBtnImagensModelo tooltip-placement=right sk-i18n><span>...</span></button><sk-help-tip class=text-primary ng-disabled=!$ctrl.ckcImprimeLogo sk-i18n sk-text=Core.FormatadorCuboRelatorio.helpTextBtnImagens sk-margin-left=5px></sk-help-tip></sk-hbox><sk-hbox><sk-hbox sk-width=25px></sk-hbox><sk-checkbox ng-disabled=!$ctrl.ckcImprimeLogo ng-model=$ctrl.ckcAmpliarLogo sk-true-value=S sk-false-value=N ng-change=\"$ctrl.changeParamsField('AmpliadoLogomarca', $ctrl.ckcAmpliarLogo ? 'S' : 'N')\"><sk-i18n>Core.FormatadorCuboRelatorio.lblAmpliarLogo</sk-i18n></sk-checkbox></sk-hbox><sk-hbox gap=8 layout-align=\"start center\"><sk-hbox sk-width=18px></sk-hbox><label ng-disabled=!$ctrl.ckcImprimeLogo sk-i18n=Core.FormatadorCuboRelatorio.lblAltura sk-margin-top=3px></label><sk-numeric-stepper sk-enabled=$ctrl.ckcImprimeLogo sk-value=$ctrl.alturaLogo sk-min-value=40 sk-max-value=150 sk-change=\"$ctrl.changeParamsField('AlturaLogomarca', $ctrl.alturaLogo)\"></sk-numeric-stepper><sk-hbox sk-width=25px></sk-hbox><label ng-disabled=!$ctrl.ckcImprimeLogo sk-i18n=Core.FormatadorCuboRelatorio.lblLargura sk-margin-top=3px></label><sk-numeric-stepper sk-enabled=$ctrl.ckcImprimeLogo sk-value=$ctrl.larguraLogo sk-min-value=40 sk-max-value=150 sk-change=\"$ctrl.changeParamsField('LarguraLogomarca', $ctrl.larguraLogo)\"></sk-numeric-stepper><sk-hbox sk-width=25px></sk-hbox><label sk-enabled=$ctrl.ckcImprimeLogo sk-i18n=Core.FormatadorCuboRelatorio.lblDistancia sk-margin-top=3px></label><sk-numeric-stepper sk-enabled=$ctrl.ckcImprimeLogo sk-value=$ctrl.distanciaLogo sk-min-value=0 sk-max-value=100 sk-change=\"$ctrl.changeParamsField('DistanciaLogomarca', $ctrl.distanciaLogo)\"></sk-numeric-stepper></sk-hbox></sk-vbox></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/popup/ParametrosRelatorio.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-columns=1 no-margin-bottom no-item-padding-left><div ng-repeat=\"field in $ctrl.fieldsParams\"><sk-simple-item sk-label={{field.label}} gap=5><sk-date-input ng-if=\"field.dateField == 'D'\" sk-value=field.text></sk-date-input><sk-date-time-input sk-value=field.text ng-if=\"field.dateField == 'H'\"></sk-date-time-input><sk-number-input sk-value=field.text sk-precision=field.precision ng-if=\"field.dateField == 'F' || field.dateField == 'I'\" ng-switch-when-separator=|></sk-number-input><sk-text-input sk-value=field.text ng-if=\"field.dateField == 'S'\"></sk-text-input></sk-simple-item></div></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/popup/ParametrosRelatorioPopUp.tpl.html",
    "<sk-vbox flex><parametros-relatorio on-content-created=ctrl.onContentCreated($instance)></parametros-relatorio></sk-vbox><div class=modal-footer layout=row><button default ng-click=ctrl.close()><span sk-i18n>Geral.buttonCancelar</span></button> <button default ng-click=ctrl.finish()><span sk-i18n>Geral.buttonOK</span></button> <button default ng-click=ctrl.finishSupressingParams()><span sk-i18n>Geral.buttonSupressParam</span></button></div>");
  $templateCache.put("commons/formatadorcuborelatorio/popup/PopUpImagens.tpl.html",
    "<sk-vbox flex><sk-list sk-scroll-container flex class=list-container><div layout-align=\"space-between center\" layout=row ng-repeat=\"imagem in ctrl.listaImagens track by $index\" ng-dblclick=ctrl.escolherImagem(imagem) ng-click=ctrl.setImageSelected(imagem)><span ng-bind=ctrl.getObjectValue(imagem)></span></div></sk-list></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/popup/PopUpRelatorio.tpl.html",
    "<sk-vbox flex creation-complete=ctrl.createComplete()><sk-hbox layout-padding layout-align=\"start center\" gap=8><sk-text-input sk-value=ctrl.textFilter ng-keydown=ctrl.onKeyPressLocate($event) flex></sk-text-input><sk-icon font-icon=search tooltip=\"{{'Geral.lblLocate' | translate}}\" ng-click=ctrl.locate(ctrl.textFilter)></sk-icon></sk-hbox><sk-vbox class=container-relative flex><sk-tree id=arvoreRelatorios flex class=container-absolute style=\"padding-top: 15px\" sk-tree-data=ctrl.tree sk-on-select=ctrl.onSelectTreeNode sk-tree-control=ctrl.treeControle sk-hide-button-container=true></sk-tree></sk-vbox></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/popup/SegurancaContent.tpl.html",
    "<sk-dataset sk-standalone entity-name=ControleAcessoRelatorio sk-dataset-created=ctrl.createDataSetAcessosGrupo(dataset) sk-save-handler=ctrl.save(request)><sk-field pattern=NOMEGRUPO path=GrupoUsuario></sk-field><sk-field pattern=CODUSU,CODGRUPO,CODREL,CONS,ALTERA,FILTRO,RESUMO,SEGURANCA></sk-field></sk-dataset><sk-dataset entity-name=ControleAcessoRelatorio sk-dataset-created=ctrl.createDataSet(dataset) parent-dataset=ctrl.dsAcessosGrupo><sk-field pattern=NOMEUSU path=Usuario></sk-field><sk-field pattern=CODUSU,CODGRUPO,CODREL,CONS,ALTERA,FILTRO,RESUMO,SEGURANCA></sk-field></sk-dataset><sk-vbox flex><span class=text-bold sk-i18n>Core.MgeReport.ttleGrUsers</span><sk-hbox layout=row layout-padding><sk-navigator dataset=ctrl.dsAcessosGrupo sk-show-add-button=false sk-show-remove-button=false sk-show-copy-button=false sk-show-refresh-button=false sk-compact-btn-add></sk-navigator><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsAcessosGrupo></sk-rows-counter></div></sk-hbox><sk-datagrid sk-dataset=ctrl.dsAcessosGrupo sk-editable=false sk-datagrid-interceptor=ctrl sk-only-custom flex><sk-datagrid-custom-column sk-description=Core.MgeReport.dgC.Grp sk-field-name=CODGRUPO><sk-datagrid-custom-column sk-description=Core.MgeReport.dgNGrp sk-field-name=GrupoUsuario.NOMEGRUPO><sk-datagrid-custom-column sk-description=Core.MgeReport.dgConsult sk-field-name=CONS editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.dgAlter sk-field-name=ALTERA editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.dgFilter sk-field-name=FILTRO editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.dgResume sk-field-name=RESUMO editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.btnseguranca sk-field-name=SEGURANCA editable=true sk-live-check=true></sk-datagrid-custom-column></sk-datagrid></sk-vbox><sk-vbox flex><sk-tabnavigator sk-selected-index=ctrl.navigatorIndex><sk-tabnavigator-item><sk-i18n>Core.MgeReport.lblUsers</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-hbox layout=row layout-padding><sk-navigator dataset=ctrl.dsAcessosUsuario sk-show-copy-button=false sk-show-refresh-button=false sk-compact-btn-add></sk-navigator><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsAcessosUsuario></sk-rows-counter></div></sk-hbox><sk-viewstack sk-selected-index=ctrl.navigatorIndex sk-creation-policy=all flex><sk-viewstack-content layout=column><sk-datagrid sk-dataset=ctrl.dsAcessosUsuario sk-datagrid-interceptor=ctrl sk-only-custom sk-editable=false flex><sk-datagrid-custom-column sk-description=Core.MgeReport.dgC.user sk-field-name=CODUSU><sk-datagrid-custom-column sk-description=Core.MgeReport.dgNmUser sk-field-name=Usuario.NOMEUSU><sk-datagrid-custom-column sk-description=Core.MgeReport.dgConsult sk-field-name=CONS editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.dgAlter sk-field-name=ALTERA editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.dgFilter sk-field-name=FILTRO editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=Core.MgeReport.dgResume sk-field-name=RESUMO editable=true sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-description=\"Permite Outros Usuários a Alterar\" sk-field-name=SEGURANCA editable=true sk-live-check=true></sk-datagrid-custom-column></sk-datagrid></sk-viewstack-content><sk-viewstack-content layout=column><sk-simple-form sk-columns=1 sk-width=500 flex><sk-simple-item sk-label=Core.MgeReport.frmUser><sk-pesquisa-input sk-dataset=ctrl.dsAcessosUsuario sk-field-name=CODUSU sk-entity-name=Usuario sk-description-field-name=Usuario.NOMEUSU sk-value=ctrl.pesqUser sk-enviroment-criteria=ctrl.getCriteriaUsuarios()></sk-pesquisa-input></sk-simple-item></sk-simple-form></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/selecaocampos/SelecaoCampos.tpl.html",
    "<sk-dataset entity-name=RelatorioHierarquico sk-dataset-created=$ctrl.onDatasetCreated(dataset)><sk-field pattern=*></sk-field></sk-dataset><sk-dataset id=dsListaOrdenacao sk-dataset-created=$ctrl.onDsListaOrdenacaoCreated(dataset) sk-standalone><sk-dsfield-md name=agrupado><sk-options><sk-option data=true></sk-option><sk-option data=false></sk-option><sk-options></sk-options></sk-options></sk-dsfield-md><sk-dsfield-md name=saltar><sk-options><sk-option data=true></sk-option><sk-option data=false></sk-option><sk-options></sk-options></sk-options></sk-dsfield-md><sk-dsfield-md name=label></sk-dsfield-md><sk-dsfield-md name=groupIndex></sk-dsfield-md><sk-dsfield-md name=masterGroupIndex></sk-dsfield-md></sk-dataset><sk-resizable-columns style=\"height: 100%\"><div sk-width=400px sk-resizable sk-direction=\"'right'\"><sk-vbox style=\"width: 100%; height: 100%\"><sk-hbox layout-align=\"start center\"><label sk-font-size=14px sk-margin=5px sk-i18n>Core.FormatadorCuboRelatorio.lblAvailable</label><sk-text-input sk-value=$ctrl.filtroArvoreCampos sk-keydown=$ctrl.onKeyDownFiltroArvore($event) flex></sk-text-input><sk-icon font-icon=search tooltip=\"{{'Geral.lblLocate' | translate}}\" ng-click=$ctrl.localizarItem() sk-padding=7px sk-i18n></sk-icon><sk-icon ng-if=$ctrl.btnManutencaoVisibled font-icon=\"{{$ctrl.vsDetailIndex == 0 ? 'cogwheel' : 'menu-hamburger'}}\" sk-i18n tooltip=\"{{ $ctrl.vsDetailIndex == 0 ? $ctrl.toolTipBtnManutencaoDetalhes : $ctrl.toolTipBtnManutencaoCampos }}\" tooltip-placement=right ng-click=$ctrl.changeVsDetailIndex() sk-padding=7px></sk-icon></sk-hbox><sk-vbox flex style=\"overflow-y: auto\"><sk-tree id=arvoreCamposDisponiveis flex sk-width=100% sk-heigh=100% sk-tree-data=$ctrl.treeDP sk-on-select=$ctrl.onSelectTreeNode sk-tree-control=$ctrl.treeControl sk-hide-button-container=true sk-change=$ctrl.changeCampo() sk-tree-api=$ctrl.treeApi sk-data-tip-function=$ctrl.toolTipCampos(id) sk-tooltip-placement=top sk-drag-enabled=true sk-drop-enabled=true sk-drop=$ctrl.doDragDrop(event)></sk-tree></sk-vbox></sk-vbox></div><div><sk-viewstack sk-selected-index=$ctrl.vsDetailIndex style=\"overflow: auto\" flex><sk-viewstack-content sk-id=selectionPanel layout flex><sk-resizable-rows style=\"overflow: hidden\"><div sk-height=65% sk-resizable sk-direction=\"'bottom'\"><sk-resizable-columns><div sk-resizable sk-direction=\"'right'\" sk-width=65%><sk-hbox sk-width=100%><sk-vbox layout-align=\"center center\" sk-margin-right=5px><button type=button class=\"btn btn-default btn-sk-sm\" ng-click=$ctrl.addToSelecionados($ctrl.branchSelected) tooltip=Core.FormatadorCuboRelatorio.btnAddToSelectToolTip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=$ctrl.removeFromSelecionado($ctrl.itemSelectedList) tooltip=Core.FormatadorCuboRelatorio.btnRemoveFromSelectedTooltip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/back.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=\"$ctrl.removeFromSelecionado($ctrl.listaSelecionados, false, true)\" tooltip=Core.FormatadorCuboRelatorio.btnCleanSelectedTooltip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/rewind.svg></sk-icon></button></sk-vbox><sk-vbox flex><sk-hbox sk-height=27 gap=4 layout-align=\"start center\" sk-margin-bottom=5px><label sk-font-size=14px sk-margin-bottom=0px sk-i18n>Core.FormatadorCuboRelatorio.titleSelected</label><div class=btn-group><button type=button class=\"btn btn-default btn-sk-sm\" ng-click=\"$ctrl.mudaOrdemSelecionados($ctrl.itemSelectedList, -1)\" tooltip=Core.FormatadorCuboRelatorio.btnToUpSelected tooltip-placement=bottom sk-i18n><sk-icon svg-src=/mge/assets/svg/up.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=\"$ctrl.mudaOrdemSelecionados($ctrl.itemSelectedList, 1)\" tooltip=Core.FormatadorCuboRelatorio.btnToDownSelected tooltip-placement=bottom sk-i18n><sk-icon svg-src=/mge/assets/svg/down.svg></sk-icon></button></div></sk-hbox><sk-draggable-list id=listaSelecionados sk-src-data=$ctrl.listaSelecionados sk-selected-items=$ctrl.itemSelectedList sk-on-change-item=\"$ctrl.onChangeDraggableItemList(item, positionToInsert)\" sk-api=$ctrl.listApi sk-drop=$ctrl.doDragDrop(event)><sk-item-tpl><span ng-style=\"{'font-weight': '{{isOrderField(item) ? 'bold' : 'normal'}}' }\">{{item.label}}</span></sk-item-tpl></sk-draggable-list></sk-vbox><sk-vbox ng-if=!$ctrl.modoCubo layout-align=\"center center\" sk-margin-left=5px><button type=button class=\"btn btn-default btn-sk-sm\" ng-click=$ctrl.addToOrdenacao($ctrl.listaSelecionados) tooltip=Core.FormatadorCuboRelatorio.btnAddAllToOrderToolTip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/forward.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=$ctrl.addToOrdenacao($ctrl.itemSelectedList) tooltip=Core.FormatadorCuboRelatorio.btnAddToOrderToolTip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=\"$ctrl.removeFromOrdenacao($ctrl.dsListaOrdenacao.getSelectedRecordsAsObjects(undefined, false))\" tooltip=Core.FormatadorCuboRelatorio.btnRemoveFromOrderToolTip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/back.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=$ctrl.removeFromOrdenacao($ctrl.dsListaOrdenacao.getRecordsAsObjects()) tooltip=Core.FormatadorCuboRelatorio.btnCleanOrderToolTip tooltip-placement=right sk-i18n><sk-icon svg-src=/mge/assets/svg/rewind.svg></sk-icon></button></sk-vbox></sk-hbox></div><div><sk-vbox ng-if=!$ctrl.modoCubo sk-width=100%><sk-hbox sk-height=27 gap=4 sk-margin-bottom=5px layout-align=\"start center\"><label sk-font-size=14px sk-margin-bottom=0px sk-i18n>Core.FormatadorCuboRelatorio.titleOrderList</label><div class=btn-group><button type=button class=\"btn btn-default btn-sk-sm\" ng-click=\"$ctrl.mudaOrdemQuebras('up')\" ng-disabled=$ctrl.disableBtnUpOrdem() tooltip=Core.FormatadorCuboRelatorio.btnToUpOrder tooltip-placement=bottom sk-i18n><sk-icon svg-src=/mge/assets/svg/up.svg></sk-icon></button> <button type=button class=\"btn btn-default btn-sk-sm\" ng-click=\"$ctrl.mudaOrdemQuebras('down')\" ng-disabled=$ctrl.disableBtnDownOrdem() tooltip=Core.FormatadorCuboRelatorio.btnToDownOrder tooltip-placement=bottom sk-i18n><sk-icon svg-src=/mge/assets/svg/down.svg></sk-icon></button></div></sk-hbox><sk-checkbox id=ckcReimprimir ng-model=$ctrl.ckcReimprimir sk-margin-bottom=5px ng-change=\"$ctrl.changeFlagResumoField('Q', $ctrl.ckcReimprimir)\"><sk-i18n>Core.FormatadorCuboRelatorio.lblReimprimir</sk-i18n></sk-checkbox><sk-datagrid id=listaOrdenacao sk-dataset=$ctrl.dsListaOrdenacao sk-on-datagrid-loaded=$ctrl.onDgListaOrdenacaoLoaded(datagrid) sk-editable=false sk-on-dbl-click=\"$ctrl.removeFromOrdenacao($ctrl.dsListaOrdenacao.getSelectedRecordsAsObjects(undefined, true))\" sk-allow-multiple-selection=true sk-disable-tour=true sk-datagrid-interceptor=$ctrl sk-drag-enabled=true sk-drop-enabled=true sk-drag-field-presentation=label sk-drop=$ctrl.doDragDrop(event)><sk-datagrid-custom-column sk-field-name=agrupado sk-description=Core.FormatadorCuboRelatorio.lblAgrupar sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=saltar sk-description=Core.FormatadorCuboRelatorio.lblSaltarPag sk-live-check=true sk-enabled=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=label sk-description=Core.FormatadorCuboRelatorio.lblField></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=groupIndex sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=masterGroupIndex sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-vbox></div></sk-resizable-columns></div><div style=\"height: 35%; margin-left: 4px; margin-top: 4px; margin-right: 4px\"><sk-hbox layout-align=\"start center\" sk-width=100% flex><button type=button class=\"btn btn-default btn-sk-sm\" ng-click=$ctrl.addSelecionadoFiltro() sk-margin-right=5px tooltip=Core.FormatadorCuboRelatorio.msgAdicionarCampoComoCriterio tooltip-placement=bottom sk-i18n><sk-icon svg-src=/mge/assets/svg/next.svg></sk-icon></button><sk-vbox sk-width=100% sk-height=100%><sk-hbox layout-align=\"start center\" sk-height=35px sk-margin-top=5px sk-margin-bottom=5px><label sk-font-size=14px sk-margin-right=5px sk-margin-bottom=0px sk-i18n>Core.FormatadorCuboRelatorio.titleFilterPanel</label><div class=btn-group><button ng-disabled=\"$ctrl.filterExpression == ''\" type=button class=\"btn btn-default btn-sk-sm clear\" ng-click=$ctrl.clearFilter() tooltip=Core.FormatadorCuboRelatorio.msgCleanFilterExpression tooltip-placement=bottom sk-i18n><sk-icon font-icon=delete></sk-icon></button> <button ng-disabled=\"!($ctrl.filterExpression == '' || $ctrl.filterExpression.indexOf('?') == -1)\" type=button class=\"btn btn-default btn-sk-sm clear\" ng-click=$ctrl.openEditForm() tooltip=Core.FormatadorCuboRelatorio.msgEditFilterExpression tooltip-placement=bottom sk-i18n><sk-icon font-icon=\"glyphicon glyphicon-edit\"></sk-icon></button></div></sk-hbox><sk-checkbox id=ckcImpFiltro ng-model=$ctrl.ckcImpFiltro ng-if=\"! $ctrl.modoCubo\" sk-margin-bottom=5px ng-change=\"$ctrl.changeFlagResumoField('F', $ctrl.ckcImpFiltro)\"><sk-i18n>Core.FormatadorCuboRelatorio.lblImpFiltro</sk-i18n></sk-checkbox><sk-text-area id=filterExpressionn sk-component-created=$ctrl.textAreaCreated($component) sk-value=$ctrl.filterExpression sk-dataset=$ctrl.ds sk-field-name=FILTROS sk-drag-enabled=false sk-drop-enabled=true sk-drop=$ctrl.doDragDrop(event) ondrop=drop(event) ondragover=allowDrop(event) flex></sk-text-area></sk-vbox></sk-hbox></div></sk-resizable-rows></sk-viewstack-content><sk-viewstack-content sk-id=editionPanel flex><sk-vbox gap=10 style=\"overflow: auto !important; max-height: -moz-available !important; max-height: -webkit-fill-available !important; max-height: fill-available !important\"><sk-hbox layout-align=\"start center\"><sk-navigator dataset=$ctrl.dsCampos sk-show-navigation=false sk-show-refresh-button=false sk-compact-btn-add></sk-navigator><label sk-font-size=14px sk-i18n>Core.FormatadorCuboRelatorio.lblFieldsMaintenance</label></sk-hbox><sk-hbox><sk-form id=formCampos sk-dataset=$ctrl.dsCampos sk-inline=true columns=1 sk-only-custom gap=0 sk-padding-right=5px sk-width=35%><sk-form-custom-item sk-field-name=CODUNI sk-enabled=false></sk-form-custom-item><sk-form-custom-item sk-field-name=CODCAMPO sk-enabled=false></sk-form-custom-item><sk-form-custom-item sk-field-name=CODCAMPOPAI sk-required=true sk-enabled=$ctrl.codCampoPaiEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=DESCRICAO sk-required=true sk-enabled=$ctrl.descricaoEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=TIPO sk-enabled=$ctrl.tipoEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=ALINHAMENTO ng-if=!$ctrl.modoCubo sk-enabled=$ctrl.alinhamentoEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=TOTALIZA sk-enabled=$ctrl.totalizaEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=TAMANHO ng-if=!$ctrl.modoCubo sk-enabled=$ctrl.tamanhoEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=MASCARA sk-enabled=$ctrl.mascaraEnabled></sk-form-custom-item><sk-form-custom-item sk-field-name=SANKHYA sk-enabled=false sk-required=false></sk-form-custom-item><sk-form-custom-item sk-field-name=ZERARNAQUEBRA sk-required=false ng-if=!$ctrl.modoCubo></sk-form-custom-item><sk-form-custom-item sk-field-name=SOHIERARQUIA sk-required=false></sk-form-custom-item></sk-form><sk-vbox gap=0 sk-padding-right=5px sk-width=65%><label sk-font-size=14px sk-i18n>Core.FormatadorCuboRelatorio.lblExpressao</label><sk-text-area sk-enabled=$ctrl.expressaoEnabled sk-height=130 sk-dataset=$ctrl.dsCampos sk-field-name=EXPRESSAO></sk-text-area><label sk-font-size=14px sk-padding-top=5px sk-i18n>Core.FormatadorCuboRelatorio.lblTabelas</label><sk-text-area sk-enabled=$ctrl.tabelasEnabled sk-height=130 sk-dataset=$ctrl.dsCampos sk-field-name=TABELAS></sk-text-area><label sk-font-size=14px sk-padding-top=5px sk-i18n>Core.FormatadorCuboRelatorio.lblLigacao</label><sk-text-area sk-enabled=$ctrl.ligacaoEnabled sk-height=130 sk-dataset=$ctrl.dsCampos sk-field-name=LIGACAO></sk-text-area></sk-vbox></sk-hbox></sk-vbox></sk-viewstack-content></sk-viewstack></div></sk-resizable-columns>");
  $templateCache.put("commons/formatadorcuborelatorio/selecaocampos/popup/CriterioPopUp.tpl.html",
    "<sk-vbox gap=8><sk-hbox layout-align=\"start center\" sk-margin-bottom=5px><sk-radio-input sk-font-size=12px sk-width=60px sk-value=ctrl.ligacaoValue sk-option=.E. sk-name=ctrl.ligacaoCriterio>{{'Core.FormatadorCuboRelatorio.lbrRadioAnd' | translate }}</sk-radio-input><sk-radio-input sk-font-size=12px sk-width=60px sk-value=ctrl.ligacaoValue sk-option=.OU. sk-name=ctrl.ligacaoCriterio>{{'Core.FormatadorCuboRelatorio.lbrRadioOr' | translate }}</sk-radio-input><label sk-font-size=15px sk-margin-bottom=0px>{{ctrl.labelField}}</label></sk-hbox><sk-combobox sk-value=ctrl.operadorValue sk-options=ctrl.comboOperador sk-allow-null=false sk-width=170px></sk-combobox><sk-hbox layout-align=\"start center\"><sk-checkbox ng-model=ctrl.ckcVariavel sk-margin-bottom=5px><sk-i18n sk-margin-right=5px>{{'Core.FormatadorCuboRelatorio.lblVariavel' | translate }}</sk-i18n></sk-checkbox><sk-text-input sk-enabled=!ctrl.ckcVariavel sk-value=ctrl.campoTexto sk-width=150px ng-if=ctrl.campoTextVisibled></sk-text-input><sk-number-input sk-enabled=!ctrl.ckcVariavel sk-value=ctrl.campoNumero sk-precision=ctrl.campoNumeroPrecision sk-width=150px ng-if=ctrl.campoNumeroVisibled></sk-number-input><sk-date-input sk-enabled=!ctrl.ckcVariavel sk-value=ctrl.campoData sk-width=150px ng-if=ctrl.campoDataVisibled></sk-date-input><sk-combobox sk-enabled=!ctrl.ckcVariavel sk-value=ctrl.opcoesValue sk-options=ctrl.campoOpcoes sk-width=150px ng-if=ctrl.campoOpcoesVisibled></sk-combobox></sk-hbox><sk-hbox id=filterMetadata layout-align=\"start center\" ng-disabled=!ctrl.ckcVariavel><sk-checkbox id=isRequired ng-model=ctrl.ckcIsRequired sk-margin-bottom=5px ng-disabled=!ctrl.ckcVariavel><sk-i18n sk-margin-right=40px>{{'Core.MgeReport.lblRequired' | translate }}</sk-i18n></sk-checkbox><sk-hbox ng-if=ctrl.showEntitySearch sk-width=100% layout-align=\"start center\" ng-disabled=!ctrl.ckcVariavel><sk-icon font-icon=search tooltip=\"{{'Geral.lblLocate' | translate}}\" ng-click=ctrl.searchEntity(ctrl.textFilter) sk-enabled=ctrl.ckcVariavel></sk-icon><sk-text-input sk-value=ctrl.textFilter sk-margin-left=10px sk-width=100% sk-enabled=ctrl.ckcVariavel></sk-text-input></sk-hbox></sk-hbox><sk-hbox layout-align=\"end center\"><button buttonmode=true default tooltip=Geral.buttonOK tooltip-placement=bottom ng-click=ctrl.prepareAppendCriteria() sk-width=50px sk-height=25px sk-i18n>Geral.buttonOK</button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/selecaocampos/popup/EditFilterPopUp.tpl.html",
    "<sk-vbox><sk-hbox layout-align=\"start center\"><sk-checkbox id=isRequiredEdit ng-model=ctrl.ckcRequiredEdit sk-width=150px><sk-i18n sk-margin-right=15px>{{'Core.MgeReport.lblRequired' | translate }}</sk-i18n></sk-checkbox><sk-hbox ng-if=ctrl.showEntitySearch sk-width=100% layout-align=\"start center\"><sk-icon font-icon=search tooltip=\"{{'Geral.lblLocate' | translate}}\" ng-click=ctrl.searchEntity(ctrl.textFilter)></sk-icon><sk-text-input sk-value=ctrl.textFilter sk-margin-left=10px sk-margin-right=10px sk-width=100%></sk-text-input></sk-hbox><button buttonmode=true default tooltip=Geral.buttonOK tooltip-placement=bottom ng-click=ctrl.confirmFilterEdit() sk-height=25px sk-margin-right=5px sk-i18n>Geral.buttonOK</button> <button buttonmode=true default tooltip=Geral.buttonCancelar tooltip-placement=bottom ng-click=ctrl.closeFilterEdit() sk-height=25px sk-i18n>Geral.buttonCancelar</button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/formatadorcuborelatorio/selecaocampos/popup/SeletorDetalhesQuebraPopUp.tpl.html",
    "<sk-two-lists sk-src-data=ctrl.listaDiponiveisQuebra sk-dest-data=ctrl.listaSelecionadosQuebra sk-on-move-item=\"ctrl.onMoveItems(item, listName)\" sk-enable-sort=false><sk-src-item-tpl><div>{{item.label}}</div></sk-src-item-tpl><sk-dest-item-tpl><div>{{item.label}}</div></sk-dest-item-tpl></sk-two-lists>");
  $templateCache.put("commons/formconfig/columns/formconfigcolumns.tpl.html",
    "<sk-simple-form sk-columns=1><sk-simple-group sk-label=FormConfig.lblConfigAtual><sk-simple-item style=\"margin-top: 10px\"><sk-icon font-icon=tick class=form-config-column></sk-icon><span sk-margin-left=7px><img src={{::ctrl.currentConfigImg}} tooltip={{::ctrl.currentTooltip}}></span></sk-simple-item></sk-simple-group><sk-simple-group sk-label=FormConfig.lblConfigColunas sk-margin-top=5 flex><div style=\"width: 100%; display: inline-flex\"><sk-simple-item ng-repeat=\"option in ctrl.comboDP\" sk-column=3 style=\"margin-top: 10px\"><div layout=row flex layout-align=\"start center\"><sk-radio-input sk-value=ctrl.inputValue sk-option={{option.option}} sk-name=formConfigCol style=\"width: inherit\"></sk-radio-input><img src={{::option.imgPath}} tooltip={{::option.tooltip}}></div></sk-simple-item></div><div style=\"width: 100%; display: inline-flex\"><sk-simple-item sk-label=FormConfig.lblAplicarATodasTelas flex style=margin-top:15px><sk-switch sk-value=ctrl.applyForAllScreens sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item><sk-simple-item ng-if=\"ctrl.isHierarchyDynaform === true\" flex sk-label=\"Exibir hierarquia por níveis?\" style=margin-top:15px><sk-switch sk-value=ctrl.useTreeHierarchy sk-true-value=S sk-false-value=N></sk-switch></sk-simple-item></div></sk-simple-group></sk-simple-form>");
  $templateCache.put("commons/formularioProducaoBuilder/formularioProducaoBuilder.tpl.html",
    "<sk-vbox flex class=tab-border ng-show=\"ctrl.selectedIndexTab == {{data.index}}\" ng-repeat=\"data in ctrl.listDynaforms\"><sk-hbox id={{data.id}} style=\"width:100%; height:100%\"><sk-dynaform sk-resource-id={{data.resourceId}} sk-entity-name={{data.entityName}} sk-recursive-helper=true sk-helper-class-name={{data.helperClassName}} sk-edit-unique-record=data.editUniqueRecord sk-on-dynaform-loaded=\"ctrl.onDynaformLoaded(dynaform, dataset)\" sk-hide-tour=true sk-dynaform-interceptor=ctrl sk-form-interceptor=ctrl sk-datagrid-interceptor=ctrl sk-show-label-others-filters=false sk-hide-entity-card=true sk-hide-button-favorite=true sk-hide-entity-search-field=true sk-hide-button-recents=true sk-skip-start-page=true></sk-dynaform></sk-hbox></sk-vbox>");
  $templateCache.put("commons/ftpinput/ftpinput.tpl.html",
    "<sk-hbox gap=2 class=ftpinput flex><sk-text-input sk-value=value sk-enabled=\"enabled !== false\" sk-change=onChange() flex></sk-text-input><button default ng-disabled=\"enabled == false\" font-icon=edit tooltip={{::tooltipBtnAuxiliar}} ng-click=openConstrutorFTPPopup() class=btn-ftp-edit></button> <button default ng-disabled=\"enabled == false\" font-icon=cogwheel tooltip={{::tooltipBtnTeste}} ng-click=testeConexao() class=btn-ftp-test></button></sk-hbox>");
  $templateCache.put("commons/gradeproduto/grade-produto.tpl.html",
    "<button style=\"padding: 0px 3px 0px 3px\" default small tooltip=Grade ng-click=openGrade() ng-transclude i18n>Grade Produto</button>");
  $templateCache.put("commons/gradeproduto/popup/grade-produto-popup.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-vbox flex ng-if=!ctrl.exibirErro sk-padding=5px><sk-hbox button-container ng-if=ctrl.isTabelaPreco() layout-align=\"start center\" sk-margin-top=5px sk-border=\"1px solid #ccc\"><sk-simple-form sk-columns=1 sk-margin-top=10px><sk-simple-item sk-i18n sk-label=Commons.GradeProdutos.lblTipo sk-required=true sk-in-line=true><sk-combobox sk-allow-null=false sk-value=ctrl.optionsValue sk-options=ctrl.optionsTipo sk-width=173px></sk-combobox></sk-simple-item><sk-simple-item sk-i18n sk-label=Commons.GradeProdutos.lblPreco sk-required=true sk-in-line=true><sk-hbox><sk-number-input sk-value=ctrl.vlrVenda sk-precision=ctrl.valuesPrecision></sk-number-input><button default sk-height=19px sk-margin=\"0px 10px\" ng-click=ctrl.replicarValor() sk-i18n>Commons.GradeProdutos.btnReplicar</button><sk-help-tip sk-i18n sk-text=Commons.GradeProdutos.helpReplicarPreco></sk-help-tip></sk-hbox></sk-simple-item><sk-simple-item sk-i18n sk-label=Commons.GradeProdutos.lblLocal sk-in-line=true ng-if=ctrl.usaPrecoPorLocal><sk-pesquisa-input sk-value=ctrl.codLocalOrigem sk-entity-name=LocalFinanceiro sk-field-name=CODLOCAL></sk-pesquisa-input></sk-simple-item></sk-simple-form></sk-hbox><sk-datagrid sk-dataset=ctrl.dsGrade sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-editable=ctrl.gridEditable sk-datagrid-interceptor=ctrl sk-margin-top=5px></sk-datagrid><sk-hbox button-container sk-margin-top=5px ng-if=ctrl.isCentral() sk-border=\"1px solid #ccc\" layout-align=\"start center\"><sk-simple-form sk-columns=1 ng-if=!ctrl.isTransferencia()><sk-simple-item sk-label=Local sk-in-line=true sk-margin-top=10px><sk-pesquisa-input sk-entity-name=LocalFinanceiro sk-field-name=CODLOCAL sk-value=ctrl.codLocalOrigem sk-api=ctrl.pesqLocalInput></sk-pesquisa-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=1 ng-if=ctrl.isTransferencia()><sk-simple-item sk-label=\"Local Origem\" sk-in-line=true sk-margin-top=10px><sk-pesquisa-input sk-entity-name=LocalFinanceiro sk-field-name=CODLOCAL sk-value=ctrl.codLocalOrigem sk-api=ctrl.pesqLocalInput></sk-pesquisa-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=1 ng-if=ctrl.isTransferencia()><sk-simple-item sk-label=\"Local Destino\" sk-in-line=true sk-margin-top=10px><sk-pesquisa-input sk-entity-name=LocalFinanceiroEntDest sk-field-name=CODLOCALDEST sk-value=ctrl.codLocalDestino></sk-pesquisa-input></sk-simple-item></sk-simple-form></sk-hbox><sk-hbox button-container sk-margin-top=5px ng-if=ctrl.isGradePadrao() style=\"background-color: #fff\"><sk-vbox flex layout-padding sk-border=\"1px solid #ccc\" sk-padding-left=10px style=\"background-color: #e4e4e4\"><label><span sk-i18n>Core.Produtos.labelGradePadraoCompra</span></label><sk-hbox layout-align=\"start center\" gap=8><span sk-i18n>Core.Produtos.labelGradePadrao</span><sk-switch sk-value=ctrl.grdPadraoCompr sk-change=\"ctrl.habilitarConfGrade('grdPadraoCompr')\"></sk-switch><sk-help-tip sk-class-help=text-primary sk-text=Core.Produtos.msgHelpGradePadraoMinima style=\"margin-left: 2px;  left: 90%; bottom: 18px\"></sk-help-tip></sk-hbox><sk-hbox layout-align=\"start center\" gap=8><span sk-i18n>Core.Produtos.labelGradePadraoFechada</span><sk-switch sk-value=ctrl.grdPadraoFchdCompr sk-change=\"ctrl.habilitarConfGrade('grdPadraoFchdCompr')\"></sk-switch><sk-help-tip sk-class-help=text-primary sk-text=Core.Produtos.msgHelpGradePadraoFechada style=\"margin-left: 2px;  left: 90%; bottom: 18px\"></sk-help-tip></sk-hbox></sk-vbox><sk-vbox flex layout-padding sk-border=\"1px solid #ccc\" sk-padding-left=10px style=\"background-color: #e4e4e4\"><label><span sk-i18n>Core.Produtos.labelGradePadraoVenda</span></label><sk-hbox layout-align=\"start center\" gap=8><span sk-i18n>Core.Produtos.labelGradePadrao</span><sk-switch sk-value=ctrl.grdPadraoVnd sk-change=\"ctrl.habilitarConfGrade('grdPadraoVnd')\"></sk-switch><sk-help-tip sk-class-help=text-primary sk-text=Core.Produtos.msgHelpGradePadraoMinima style=\"margin-left: 2px; left: 90%; bottom: 18px\"></sk-help-tip></sk-hbox><sk-hbox layout-align=\"start center\" gap=8><span sk-i18n>Core.Produtos.labelGradePadraoFechada</span><sk-switch sk-value=ctrl.grdPadraoFchdVnd sk-change=\"ctrl.habilitarConfGrade('grdPadraoFchdVnd')\"></sk-switch><sk-help-tip sk-class-help=text-primary sk-text=Core.Produtos.msgHelpGradePadraoFechada style=\"margin-left: 2px;  left: 90%; bottom: 18px\"></sk-help-tip></sk-hbox></sk-vbox></sk-hbox></sk-vbox><sk-hbox flex layout-align=\"center center\" ng-if=ctrl.exibirErro><label layout layout-align=\"center center\" flex><sk-icon class=icon-alert font-icon=alert sk-padding=15px sk-font-size=25px></sk-icon><span ng-if=!ctrl.isModeloGrade() sk-i18n sk-font-size=16px sk-width=600px>Commons.GradeProdutos.msgErroVbox</span> <span ng-if=ctrl.isModeloGrade() sk-i18n sk-font-size=16px sk-width=600px>Commons.GradeProdutos.msgErroVboxModelGrad</span></label></sk-hbox><div class=modal-footer id=footer><div class=modal-footer-right><button class=\"btn btn-default\" ng-show=!ctrl.isModeloGrade() ng-click=ctrl.cancelar()>Cancelar</button> <button class=\"btn btn-default\" ng-show=\"ctrl.isGradePadrao() || ctrl.isTabelaPreco()\" ng-click=ctrl.limpar()>Limpar</button> <button class=\"btn btn-default\" ng-show=ctrl.isGradePadrao() ng-click=ctrl.desvincular()>Desvincular</button> <button class=\"btn btn-primary\" ng-show=\"!ctrl.isModeloGrade() && !ctrl.exibirErro\" ng-click=ctrl.confirmar() ng-disabled=ctrl.disabledConfirmar>Confirmar</button></div></div>");
  $templateCache.put("commons/grupotop/grupotop.tpl.html",
    "<div class=grupoTop><sk-vbox class=vboxGrupoTop><sk-hbox><label class=labelGrupoTOP sk-i18n>Comercial.Gerencia.headerGrupoTOP</label><div class=btnGroup><button default class=btnMarcDesm ng-disabled=false ng-click=marcar() tooltip-placement=bottom tooltip={{::tooltipBtnMarcar}}><sk-icon font-icon=check></sk-icon><span>{{::btnMarcar}}</span></button> <button default class=btnMarcDesm ng-disabled=false ng-click=desmarcar() tooltip-placement=bottom tooltip={{::tolltipBtnDesmar}}><sk-icon font-icon=unchecked></sk-icon><span>{{::btnDesmar}}</span></button></div></sk-hbox><div class=boxGrupoTop><sk-checkbox class=groupValue ng-model=grupo.ativo ng-repeat=\"grupo in grupos\">{{grupo.nome}}</sk-checkbox></div></sk-vbox></div>");
  $templateCache.put("commons/lancadorMenu/adicionarLancador/adicionarLancador.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-columns=1><sk-simple-item sk-label=Geral.lblDescricao sk-required=true><sk-text-input sk-value=ctrl.descricao></sk-text-input></sk-simple-item></sk-simple-form><sk-vbox flex><sk-tree sk-tree-data=ctrl.arvoreMenuAtual sk-on-select=ctrl.treeSelectedItem sk-label-custom-name=descricao sk-children-custom-name=item sk-height-tree=425px sk-hide-button-container=true sk-show-card=false sk-tree-control=ctrl.treeControl sk-item-to-position=ctrl.toPosition flex></sk-tree></sk-vbox></sk-vbox>");
  $templateCache.put("commons/lancadorMenu/localizarLancador/localizarLancador.tpl.html",
    "<sk-dataset sk-standalone sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-save-handler=ctrl.save(request) sk-remove-handler=ctrl.remove(request)><sk-dsfield-md width=255 name=NOME user-type=S description=Commons.LancadorMenu.descricao sk-i18n></sk-dsfield-md><sk-dsfield-md width=600 name=CAMINHO read-only=true user-type=S description=Commons.LancadorMenu.caminho sk-i18n></sk-dsfield-md><sk-dsfield-md name=NUCONTROLE visible user-type=S description=NUCONTROLE></sk-dsfield-md><sk-dsfield-md name=RESOURCEID visible user-type=S description=RESOURCEID></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-hbox layout=row layout-padding style=\"background-color: #e4e4e4; border-top: 1px solid #ccc;border-left: 1px solid #ccc;border-right: 1px solid #ccc\"><sk-hbox gap=5 flex><sk-navigator dataset=ctrl.dsRelations sk-show-add-button=false sk-show-copy-button=false sk-show-refresh-button=false sk-show-cancel-button=false sk-show-navigation=true></sk-navigator></sk-hbox><div layout=row layout-align=\"end center\"><sk-rows-counter sk-dataset=ctrl.dsRelations></sk-rows-counter></div></sk-hbox><sk-datagrid sk-dataset=ctrl.dsRelations sk-only-custom><sk-datagrid-custom-column sk-field-name=NOME></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CAMINHO></sk-datagrid-custom-column></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/lancamentoOrdemProducao.tpl.html",
    "<sk-dataset id=dsLancamentos entity-name=LancamentoDeOP sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-dataset id=dsProcessos entity-name=ItemDeLancamentoDeOP parent-dataset=ctrl.dsLancamentos sk-save-handler=ctrl.defaultEmptySaveHandler() sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=$USERFIELDS></sk-field><sk-field pattern=*></sk-field><sk-field pattern=\"CODPRC, DESCRABREV, VERSAO, USATERCEIRO, EXIGEPEDIDO, USACONFNROLOTESP, TIPONROLOTESP\" path=ProcessoProdutivo></sk-field><sk-dsfield-md name=TAMLOTE description=Commons.LancamentoOrdem.campoTamLote user-type=F></sk-dsfield-md><sk-dsfield-md name=CALCTAMLOTE description=Commons.LancamentoOrdem.campoTamLoteAjustado user-type=F></sk-dsfield-md><sk-dsfield-md name=NROLOTE description=Commons.LancamentoOrdem.campoNroLote user-type=S></sk-dsfield-md><sk-dsfield-md name=DECQTD visible user-type=F></sk-dsfield-md><sk-dsfield-md name=TIPONROLOTE visible user-type=S></sk-dsfield-md><sk-dsfield-md name=LOTECURINGA visible user-type=S></sk-dsfield-md><sk-dsfield-md name=ESTOQUE description=Commons.LancamentoOrdem.lblQtdEstoque user-type=F></sk-dsfield-md></sk-dataset><sk-dataset id=dsProdutos entity-name=ProdutoLancamentoDeOP parent-dataset=ctrl.dsProcessos sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=\"CODPRODPA, CONTROLEPA, ESTOQUE, MULTLOTE, MINLOTE,TAMLOTEPAD, NROLOTE, TAMLOTE, CALCTAMLOTE,TIPONROLOTE, TIPOGERASERIE\"></sk-field><sk-field pattern=REFERENCIA,CODVOL,DECQTD path=Produto></sk-field></sk-dataset><sk-dataset id=dsDependencias entity-name=DependenciaLancamentoOP parent-dataset=ctrl.dsProdutos sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=\"SEQOPPI, CODPRODPI, CONTROLEPI, NECESSIDADETOTAL, QTDNECESSARIO, QTDESTOQUE, QTDPI, CONSIDERAESTOQUE, TIPOSUBOP\"></sk-field><sk-field pattern=REFERENCIA,COMPLDESC,CODVOL,DECQTD path=Produto></sk-field></sk-dataset><sk-dataset id=dsWcProcessos entity-name=ItemDeLancamentoDeOP parent-dataset=ctrl.dsProcessos sk-dataset-created=\"ctrl.onCustomDatasetCreated('dsWcProcessos',dataset, ctrl.criteriaProcessosWC)\" sk-standalone><sk-field pattern=\"NULOP, REFERENCIA, SEQOP, TAMLOTE, DESCRPROD, CODPROD, CODPLP\"></sk-field></sk-dataset><sk-dataset id=dsSerieProcessos entity-name=ItemDeLancamentoDeOP sk-dataset-created=\"ctrl.onCustomDatasetCreated('dsSerieProcessos',dataset, ctrl.criteriaProcessosWC)\" sk-standalone><sk-field pattern=\"NULOP, REFERENCIA, SEQOP, TAMLOTE, DESCRPROD, CODPROD, IDPROC, CODPLP\"></sk-field></sk-dataset><sk-dataset id=dsTercProcessos entity-name=ItemDeLancamentoDeOP sk-dataset-created=\"ctrl.onCustomDatasetCreated('dsTercProcessos',dataset, ctrl.criteriaProcessosWC)\" sk-standalone><sk-field pattern=\"NULOP, REFERENCIA, SEQOP, TAMLOTE, DESCRPROD, IDPROC, CODPROD\"></sk-field></sk-dataset><sk-dataset id=dsNumeroSerie entity-name=SerieLancamentoOP parent-dataset=ctrl.dsSerieProcessos sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-dataset id=dsWorkCenter entity-name=AlocacaoDeWorkCenterLctoOP parent-dataset=ctrl.dsWcProcessos sk-save-handler=ctrl.defaultEmptySaveHandler() sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field><sk-field pattern=TIPALOCACAO path=AlocacaoWorkCenterProcesso></sk-field></sk-dataset><sk-dataset id=dsTerceiros entity-name=TerceiroLancamentoDeOP parent-dataset=ctrl.dsTercProcessos sk-save-handler=ctrl.defaultEmptySaveHandler() sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-field pattern=*></sk-field></sk-dataset><sk-dataset id=dsSubProdutoProcessos entity-name=ItemDeLancamentoDeOP sk-dataset-created=\"ctrl.onCustomDatasetCreated('dsSubProdutoProcessos',dataset, ctrl.criteriaProcessosWC)\" sk-standalone><sk-field pattern=\"NULOP, REFERENCIA, SEQOP, TAMLOTE, DESCRPROD, IDPROC, CODPROD\"></sk-field></sk-dataset><sk-dataset id=dsSubProduto entity-name=SubProdutoLancamentoOP parent-dataset=ctrl.dsSubProdutoProcessos sk-save-handler=ctrl.defaultEmptySaveHandler() sk-dataset-created=ctrl.onDatasetCreated(dataset)><sk-field pattern=\"IDEFX, SEQLSP, CODPRODSP, CONTROLESP, NROLOTE\"></sk-field><sk-field pattern=REFERENCIA,CODVOL,DECQTD path=Produto></sk-field></sk-dataset><sk-vbox flex layout gap=8><div id=headerLancamento class=header-well><sk-hbox sk-margin-top=6px layout-align=\"begin center\" style=\"position: absolute\" ng-show=ctrl.reutilizarLancamento flex><sk-switch sk-value=ctrl.reutilizar sk-change=ctrl.changeReutilizarLancamento() sk-padding-left=15px></sk-switch><h8 sk-padding-top=3px sk-padding-left=5px style=\"font-size: 12px\" sk-i18n>Reutilizar Lançamento</h8><sk-hbox ng-show=\"ctrl.reutilizar == 'S'\"><sk-text-input sk-padding-left=5px sk-width=328px sk-value=ctrl.descrLancamento sk-focus-out=ctrl.salvaLancamento()></sk-text-input><button class=btn-descartar-lancamento default small ng-click=ctrl.descartarLancamentoSalvo() sk-margin-left=5px tooltip=\"Descartar Lançamento\" tooltip-placement=bottom sk-i18n><sk-icon font-icon=bin></sk-icon></button></sk-hbox></sk-hbox><h4 style=\"text-align: center\"><sk-i18n>Commons.LancamentoOrdem.titlePreLancamento</sk-i18n></h4></div><sk-wizard sk-hide-indicators=false sk-on-create=ctrl.onCreateWizard(wizard) sk-on-step-change=ctrl.onStepChange() sk-margin-bottom=5px sk-on-cancel=ctrl.onCancel() sk-on-finish=ctrl.onFinish($step) sk-height=100% sk-disable-key-down=true><sk-step class=step-processo sk-title=Commons.LancamentoOrdem.stepOrdem sk-finalize=ctrl.canFinalize() sk-i18n layout><sk-vbox flex sk-height=100%><sk-hbox flex=60><sk-vbox layout-align=end class=grid-processos flex><sk-top-bar class=well white sk-margin-top=5px><sk-hbox gap=8><button default small ng-click=ctrl.openGridConfig() sk-i18n tooltip=Geral.lblConfigurarGrade tooltip-placement=right><sk-icon font-icon=cogwheel></sk-icon></button><sk-btn-novo sk-on-click=ctrl.openInsertOP() ng-show=ctrl.btnInsertEnabled sk-compact=true></sk-btn-novo><button default ng-disabled=ctrl.disableRemove small ng-click=ctrl.removerProcessosSelecionados() tooltip=Commons.LancamentoOrdem.btnRemover tooltip-placement=bottom sk-i18n><sk-icon font-icon=bin></sk-icon></button> <button default small ng-click=ctrl.editQtdCoProducao() tooltip=\"Alterar Qtd. Processamento Co-produto\" tooltip-placement=bottom ng-show=ctrl.showBtnEditCoProd sk-i18n><sk-icon font-icon=edit></sk-icon></button><h7 style=\"text-align: center; margin-top: 8px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelOrdensDeProducao</b></h7><button default small ng-click=\"ctrl.abrirConfiguracoesEstoque('PA')\" tooltip=Commons.LancamentoOrdem.labelConfigEstoque tooltip-placement=bottom sk-i18n><sk-icon font-icon=filter></sk-icon></button> <button sk-i18n ng-click=ctrl.clickDependencia() ng-disabled=!ctrl.btnDependenciasEnabled() tooltip=Commons.LancamentoOrdem.tooltipDependencias tooltip-placement=bottom default><sk-icon class=icon-link svg-src=/mge/assets/svg/link.svg></sk-icon><sk-i18n>Commons.LancamentoOrdem.labelDependencias</sk-i18n></button><sk-rows-counter sk-dataset=ctrl.dsProcessos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3 layout><sk-datagrid id=dgProcessos sk-dataset=ctrl.dsProcessos sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgProcessos',datagrid)\" sk-grid-config={{::ctrl.gridProcessosConfig}} sk-editable=ctrl.isEditableDatagrids sk-allow-multiple-selection=false sk-datagrid-interceptor=ctrl sk-disable-tour=true sk-height=\"calc(100vh - 207px)\" sk-str-filtered-columns=COMPARTILHA,IDPROC><sk-datagrid-custom-column sk-field-name=ProcessoProdutivo.CODPRC sk-description=Commons.LancamentoOrdem.labelProcProdutivo></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLote></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NROLOTE sk-cell-formatter=ctrl.cellFormatterNroLote></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CALCTAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLoteAjustada></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ProcessoProdutivo.DESCRABREV sk-description=Commons.LancamentoOrdem.labelDescrProcProdutivo></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ProcessoProdutivo.USATERCEIRO sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=AlocacaoDeWorkCenterLctoOP.CODWCP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPROD sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ORDEM sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DECQTD sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ProcessoProdutivo.EXIGEPEDIDO sk-visible=false></sk-datagrid-custom-column><sk-editor-renderer><script columns=ProcessoProdutivo.CODPRC,NUNOTA,SEQNOTA,NROLOTE,TAMLOTE,$USERFIELD>function renderer() {\n" +
    "                                            return {\n" +
    "                                                getGui: function (params, originalEditor, scope, utils) {\n" +
    "                                                    if (params.colDef.field === \"ProcessoProdutivo.CODPRC\") {\n" +
    "                                                        scope.criteriaProcesso = function () {\n" +
    "                                                        	codplp = params.data.CODPLP;\n" +
    "                                                            prodParaTerc = angular.isDefined(params.data.CODPARCTERC) && params.data.CODPARCTERC != 0 ? \"S\" : \"N\";\n" +
    "                                                            codprod = params.data.CODPROD;\n" +
    "                                                            tipoOp = params.data.TIPOOP;\n" +
    "                                                            controle = \" \";\n" +
    "                                                            var criteria = Criteria();\n" +
    "\n" +
    "                                                            if (angular.isUndefined(controle) || controle === \"\") {\n" +
    "                                                                controle = \" \";\n" +
    "                                                            }\n" +
    "\n" +
    "                                                            if (!utils.mgeParameters.asBoolean(\"prod.lancar.op.versao.anterior\")) {\n" +
    "                                                                criteria.append(\"this.VERSAO = ( SELECT MAX(PRC2.VERSAO) AS VERSAO FROM TPRPRC PRC2 WHERE PRC2.CODPRC = this.CODPRC ) AND \");\n" +
    "                                                            }\n" +
    "\n" +
    "                                                            criteria.append(\"(this.CODPLP IS NULL OR this.CODPLP = \" + codplp + \")\");\n" +
    "                                                            criteria.append(\"AND this.IDPROC IN ( \");\n" +
    "                                                            criteria.append(\"SELECT LPA.IDPROC FROM TPRLPA LPA WHERE 1=1\");\n" +
    "                                                            criteria.append(\"AND EXISTS(SELECT 1 FROM TPRLPA WHERE CODPRODPA = \" + codprod + \" AND (CONTROLEPA = '\" + controle + \"') AND IDPROC = LPA.IDPROC))\");\n" +
    "                                                            criteria.append(\"AND this.PROCDESMONTE = '\" + (\"D\" === tipoOp ? \"S\" : \"N\") + \"'\");\n" +
    "                                                            if (prodParaTerc != \"N\") {\n" +
    "                                                            	criteria.append(\" AND this.PRODPARATERCEIRO <> 'N' \");\n" +
    "                                                            }\n" +
    "                                                            if (\"R\" === tipoOp) {\n" +
    "                                                                criteria.append(\" AND this.PROCREPARO = 'S' \");\n" +
    "                                                            } else {\n" +
    "                                                                criteria.append(\" AND this.PROCREPARO IS NULL \");\n" +
    "                                                            }\n" +
    "                                                            return criteria;\n" +
    "                                                        }\n" +
    "\n" +
    "                                                        scope.chgProcesso = function (item) {\n" +
    "                                                            if (angular.isDefined(item)) {\n" +
    "                                                                var request = {\n" +
    "                                                                    params: {\n" +
    "                                                                        nulop: params.data.NULOP,\n" +
    "                                                                        seqop: params.data.SEQOP,\n" +
    "                                                                        atributo: \"IDPROC\",\n" +
    "                                                                        valor: item.fields.IDPROC\n" +
    "                                                                    }\n" +
    "                                                                }\n" +
    "                                                                utils.callService(\"mgeprod@LancamentoOrdemProducaoSP.alterarAtributoProcesso\", request)\n" +
    "                                                                    .then(function (result) {\n" +
    "                                                                        scope.dataset.save(false); \n" +
    "                                                                    }).finally(function () {\n" +
    "                                                                        scope.dataset.refresh();                                                            \n" +
    "                                                                    });\n" +
    "                                                            }\n" +
    "                                                        }\n" +
    "\n" +
    "                                                        var eGui = utils.createDirective('div', {}, scope);\n" +
    "\n" +
    "                                                        var formGui = utils.createDirective('form', {\n" +
    "                                                            'name': 'inputForm',\n" +
    "                                                            'class': 'class=\"datagrid-comfortable-mode'\n" +
    "                                                        }, scope);\n" +
    "\n" +
    "                                                        var pesqGui = utils.createDirective('sk-pesquisa-input', {\n" +
    "                                                            'sk-show-description-input': 'false',\n" +
    "                                                            'class': 'sk-grid-editor undefined',\n" +
    "                                                            'sk-entity-name': 'ProcessoProdutivo',\n" +
    "                                                            'sk-enviroment-criteria': 'criteriaProcesso()',\n" +
    "                                                            'sk-target-field': 'CODPRC',\n" +
    "                                                            'sk-field-name': 'ProcessoProdutivo.CODPRC',\n" +
    "                                                            'sk-use-local-field-name': 'true',\n" +
    "                                                            'sk-data-type': \"'I'\",\n" +
    "                                                            'sk-entity-change': \"chgProcesso(item)\",\n" +
    "                                                            'sk-dataset': 'dataset',\n" +
    "                                                            'sk-options': \"{limit:0}\"\n" +
    "                                                        }, scope);\n" +
    "\n" +
    "                                                        formGui.append(pesqGui);\n" +
    "                                                        eGui.append(formGui);\n" +
    "\n" +
    "                                                        return eGui;\n" +
    "                                                    } else {\n" +
    "                                                        return originalEditor;\n" +
    "                                                    }\n" +
    "                                                },\n" +
    "                                                isCachable: function (col) {\n" +
    "                                                    return false;\n" +
    "                                                }\n" +
    "                                            }\n" +
    "                                        }</script></sk-editor-renderer></sk-datagrid></sk-hbox></sk-vbox></sk-hbox><sk-vbox ng-show=ctrl.showDgProcessos><sk-top-bar class=well white sk-margin-top=10px><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridInfoLoteConfig }}\"></sk-grid-config><button default small ng-click=ctrl.openEditarControle()><sk-icon font-icon=plus></sk-icon></button> <button default small ng-click=ctrl.removeControle() sk-i18n><sk-icon font-icon=bin></sk-icon></button><h7 style=\"text-align: center; margin-top: 8px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelAbaPA</b></h7><sk-rows-counter sk-dataset=ctrl.dsProdutos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid id=dgProdutos sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgProdutos',datagrid)\" sk-dataset=ctrl.dsProdutos sk-editable=ctrl.isEditableDatagrids sk-grid-config={{::ctrl.gridInfoLoteConfig}} sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-disable-tour=true layout sk-height=200px><sk-datagrid-custom-column sk-field-name=TAMLOTEPAD sk-description=Commons.LancamentoOrdem.labelTamLotePadrao></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TIPOGERASERIE sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=Produto.DECQTD sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLoteProduto></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NROLOTE sk-cell-formatter=ctrl.cellFormatterNroLote></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CALCTAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLoteAjustada></sk-datagrid-custom-column><sk-editor-renderer><script columns=NROLOTE,TAMLOTE>function renderer() {\n" +
    "                                        return {\n" +
    "                                            getGui: function (params, originalEditor, scope, utils) {\n" +
    "                                                return originalEditor;\n" +
    "                                            },\n" +
    "                                            isCachable: function (col) {\n" +
    "                                                return false;\n" +
    "                                            }\n" +
    "                                        }\n" +
    "                                    }</script></sk-editor-renderer></sk-datagrid></sk-hbox></sk-vbox></sk-vbox></sk-step><sk-step sk-title=Commons.LancamentoOrdem.stepWC sk-disabled=!ctrl.showWC sk-finalize=ctrl.canFinalize() sk-i18n><sk-hbox flex><sk-vbox flex=40><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridWCProcessosConfig }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelOrdensDeProducao</b></h8><sk-rows-counter sk-dataset=ctrl.dsWcProcessos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsWcProcessos sk-editable=false sk-grid-config={{::ctrl.gridWCProcessosConfig}} sk-allow-multiple-selection=false sk-disable-tour=true class=dg-item-lancamento layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ProdutoLancamentoDeOP.CODPRODPA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPLP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLoteWorkCenter></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-hbox></sk-vbox><sk-vbox sk-padding-left=5px flex><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridWC }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelCentrosDeTrabalho</b></h8><sk-rows-counter sk-dataset=ctrl.dsWorkCenter></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsWorkCenter sk-editable=ctrl.isEditableDatagrids sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgWorkCenter',datagrid)\" sk-datagrid-interceptor=ctrl sk-grid-config={{::ctrl.gridWC}} sk-allow-multiple-selection=false sk-disable-tour=true class=dg-workcenter layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDPROC sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDAWC sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=AlocacaoWorkCenterProcesso.TIPALOCACAO sk-visible=false></sk-datagrid-custom-column><sk-editor-renderer><script columns=CODWCP>function renderer() {\n" +
    "                                        return {\n" +
    "                                            getGui: function (params, originalEditor, scope, utils) {\n" +
    "                                                if (params.colDef.field === \"CODWCP\") {\n" +
    "                                                    var dataset = scope.dataset;\n" +
    "\n" +
    "                                                    scope.criteriaWorkCenter = function () {\n" +
    "                                                        var criteria = Criteria();\n" +
    "                                                        var codCwc = dataset.getFieldValueAsNumberOrZero(\"CODCWC\");\n" +
    "                                                        var codPlanta = dataset.getParentDataset().getFieldValueAsNumberOrZero(\"CODPLP\");\n" +
    "                                                        var codProd = dataset.getParentDataset().getFieldValueAsNumberOrZero(\"CODPROD\");\n" +
    "\n" +
    "                                                        criteria.append(\"this.CODCWC = ?\");\n" +
    "                                                        criteria.append(\" AND this.CODPLP = ?\");\n" +
    "                                                        criteria.addParameter(utils.criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codCwc));\n" +
    "                                                        criteria.addParameter(utils.criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codPlanta));\n" +
    "                                                        if (utils.mgeParameters.asBoolean(\"prod.filtrar.workcenter.por.pa\")) {\n" +
    "                                                            criteria.append(\" AND EXISTS (\");\n" +
    "                                                            criteria.append(\" SELECT 1 \");\n" +
    "                                                            criteria.append(\" FROM TPRWXP WXP \");\n" +
    "                                                            criteria.append(\" WHERE WXP.CODWCP = this.CODWCP AND WXP.CODPRODPA = ?)\");\n" +
    "                                                            criteria.addParameter(utils.criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codProd));\n" +
    "                                                        }\n" +
    "\n" +
    "                                                        return criteria;\n" +
    "                                                    }\n" +
    "\n" +
    "                                                    scope.chgWorkCenter = function (item) {\n" +
    "                                                        if (angular.isDefined(item)) {\n" +
    "                                                            console.log(params.data);\n" +
    "                                                            var request = {\n" +
    "                                                                params: {\n" +
    "                                                                    nulop: params.data.NULOP,\n" +
    "                                                                    seqop: params.data.SEQOP,\n" +
    "                                                                    idawc: params.data.IDAWC,\n" +
    "                                                                    codwcp: item.fields.CODWCP\n" +
    "                                                                }\n" +
    "                                                            }\n" +
    "                                                            console.log(request);\n" +
    "                                                            return utils.callService(\n" +
    "                                                                \"mgeprod@LancamentoOrdemProducaoSP.alterarAlocacaoWorkCenter\",\n" +
    "                                                                request).then(\n" +
    "                                                                    function (result) {\n" +
    "                                                                        dataset.save(false, function () {\n" +
    "                                                                            dataset.refresh();\n" +
    "                                                                        });\n" +
    "                                                                    });\n" +
    "                                                        }\n" +
    "                                                    }\n" +
    "\n" +
    "                                                    var eGui = utils.createDirective('sk-pesquisa-input', {\n" +
    "                                                        'sk-show-description-input': 'false',\n" +
    "                                                        'class': 'sk-grid-editor undefined',\n" +
    "                                                        'sk-entity-name': 'WorkCenter',\n" +
    "                                                        'sk-enviroment-criteria': 'criteriaWorkCenter()',\n" +
    "                                                        'sk-target-field': 'CODWCP',\n" +
    "                                                        'sk-dataset': 'dataset',\n" +
    "                                                        'sk-field-name': 'CODWCP',\n" +
    "                                                        'sk-use-local-field-name': 'true',\n" +
    "                                                        'sk-data-type': \"'I'\",\n" +
    "                                                        'sk-entity-change': \"chgWorkCenter(item)\"\n" +
    "                                                    }, scope);\n" +
    "\n" +
    "                                                    return eGui;\n" +
    "                                                } else {\n" +
    "                                                    return originalEditor;\n" +
    "                                                }\n" +
    "                                            },\n" +
    "                                            isCachable: function (col) {\n" +
    "                                                return false;\n" +
    "                                            }\n" +
    "                                        }\n" +
    "                                    }</script></sk-editor-renderer></sk-datagrid></sk-hbox></sk-vbox></sk-hbox></sk-step><sk-step sk-title=Commons.LancamentoOrdem.stepTerceiros sk-disabled=!ctrl.showStepParceiro sk-finalize=ctrl.canFinalize() sk-i18n><sk-hbox flex><sk-vbox flex=40><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridParcProcessosConfig }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelOrdensDeProducao</b></h8><sk-rows-counter sk-dataset=ctrl.dsTercProcessos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsTercProcessos sk-editable=false sk-grid-config={{::ctrl.gridParcProcessosConfig}} sk-allow-multiple-selection=false sk-disable-tour=true class=dg-item-lancamento layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDPROC sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ProdutoLancamentoDeOP.CODPRODPA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPLP sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox><sk-vbox sk-padding-left=5px flex><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=br.com.sankhya.prod.OrdensProducaoHTML.GridParc></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.abaTerceiros</b></h8><sk-rows-counter sk-dataset=ctrl.dsTerceiros></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsTerceiros sk-editable=ctrl.isEditableDatagrids sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgTerceiros',datagrid)\" sk-grid-config=br.com.sankhya.prod.OrdensProducaoHTML.GridParc sk-allow-multiple-selection=false sk-datagrid-interceptor=ctrl sk-disable-tour=true class=dg-terceiro layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDEFX sk-visible=false></sk-datagrid-custom-column><sk-editor-renderer><script columns=CODPARCTERC>function renderer() {\n" +
    "                                            return {\n" +
    "                                                getGui: function (params, originalEditor, scope, utils) {\n" +
    "                                                    if (params.colDef.field === \"CODPARCTERC\") {\n" +
    "                                                        var dataset = scope.dataset;\n" +
    "\n" +
    "                                                        scope.criteriaParceiro = function () {\n" +
    "                                                            var idefx = dataset.getFieldValueAsNumberOrZero(\"IDEFX\");\n" +
    "                                                            var producaoSelecionada = dataset.getParentDataset().getCurrentRowAsObject();\n" +
    "                                                            var idproc = producaoSelecionada[\"IDPROC\"];\n" +
    "                                                            var codprod = producaoSelecionada[\"CODPROD\"];\n" +
    "\n" +
    "                                                            var criteria = Criteria();\n" +
    "                                                            criteria.append(\"this.CODPARC in (SELECT CODPARCTERC FROM TPRTXPP TXPP WHERE TXPP.IDEFX = ? AND CODPRODPA = ? AND TXPP.IDPROC = ? )\");\n" +
    "                                                            criteria.addParameter(utils.criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, idefx));\n" +
    "                                                            criteria.addParameter(utils.criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, codprod));\n" +
    "                                                            criteria.addParameter(utils.criteria.buildParameter(CriteriaParameter.TYPE_NUMBER, idproc));\n" +
    "\n" +
    "                                                            return criteria;\n" +
    "                                                        }\n" +
    "\n" +
    "                                                        scope.chgParceiro = function (item) {\n" +
    "                                                            if (angular.isDefined(item)) {\n" +
    "                                                                var request = !item || isNaN(item.fields.CODPARC) ?\n" +
    "                                                                    {\n" +
    "                                                                        params: {\n" +
    "                                                                            nulop: params.data.NULOP,\n" +
    "                                                                            seqop: params.data.SEQOP,\n" +
    "                                                                            idefx: params.data.IDEFX\n" +
    "                                                                        }\n" +
    "                                                                    } : {\n" +
    "                                                                        params: {\n" +
    "                                                                            nulop: params.data.NULOP,\n" +
    "                                                                            seqop: params.data.SEQOP,\n" +
    "                                                                            idefx: params.data.IDEFX,\n" +
    "                                                                            codparcterc: parseInt(item.fields.CODPARC)\n" +
    "                                                                        }\n" +
    "                                                                    }\n" +
    "                                                                return utils.callService(\n" +
    "                                                                    \"mgeprod@LancamentoOrdemProducaoSP.alterarTerceiroProcessoProdutivo\",\n" +
    "                                                                    request).then(\n" +
    "                                                                        function (result) {\n" +
    "                                                                            dataset.save(false, function () {\n" +
    "                                                                                dataset.refresh();\n" +
    "                                                                            });\n" +
    "                                                                        });\n" +
    "                                                            }\n" +
    "                                                        }\n" +
    "\n" +
    "                                                        var eGui = utils.createDirective('sk-pesquisa-input', {\n" +
    "                                                            'sk-show-description-input': 'false',\n" +
    "                                                            'class': 'sk-grid-editor undefined',\n" +
    "                                                            'sk-entity-name': 'Parceiro',\n" +
    "                                                            'sk-enviroment-criteria': 'criteriaParceiro()',\n" +
    "                                                            'sk-target-field': 'CODPARC',\n" +
    "                                                            'sk-dataset': 'dataset',\n" +
    "                                                            'sk-field-name': 'CODPARCTERC',\n" +
    "                                                            'sk-use-local-field-name': 'true',\n" +
    "                                                            'sk-data-type': \"'I'\",\n" +
    "                                                            'sk-entity-change': \"chgParceiro(item)\",\n" +
    "                                                            'sk-use-tab-like-enter': \"true\"\n" +
    "                                                        }, scope);\n" +
    "\n" +
    "                                                        return eGui;\n" +
    "                                                    } else {\n" +
    "                                                        return originalEditor;\n" +
    "                                                    }\n" +
    "                                                },\n" +
    "                                                isCachable: function (col) {\n" +
    "                                                    return false;\n" +
    "                                                }\n" +
    "                                            }\n" +
    "                                        }</script></sk-editor-renderer></sk-datagrid></sk-hbox></sk-hbox></sk-vbox></sk-hbox></sk-step><sk-step sk-title=Commons.LancamentoOrdem.labelNumeroSerie sk-disabled=!ctrl.showStepNroSerie sk-finalize=ctrl.canFinalize() sk-i18n><sk-hbox flex><sk-vbox flex=40><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridSerieProcessosConfig }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelOrdensDeProducao</b></h8><sk-rows-counter sk-dataset=ctrl.dsSerieProcessos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsSerieProcessos sk-editable=false sk-grid-config={{::ctrl.gridSerieProcessosConfig}} sk-allow-multiple-selection=false sk-disable-tour=true class=dg-item-lancamento layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDPROC sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox><sk-vbox sk-padding-left=5px flex><sk-top-bar class=well white><sk-hbox gap=8><div class=\"btn-group dropdown btn-group-config\" dropdown dropdown-append-to-body auto-close=outsideClick sk-padding-right=5px><button ng-click=ctrl.configSerie() type=button ng-disabled=ctrl.btAddSeqDisabled class=\"btn btn-default dropdown-toggle\" dropdown-toggle><sk-i18n>Commons.LancamentoOrdem.txtAddSeries</sk-i18n><span sk-margin-left=5px class=caret></span></button><ul class=\"sk-dynaform dropdown-menu\" role=menu aria-labelledby=split-button><li role=menuitem ng-click=ctrl.insersaoAutomatica(false) ng-show=ctrl.showGerManual><div><span class=vertical-align-middle sk-translate>Commons.LancamentoOrdem.txtGeracaoMan</span></div></li><li role=menuitem ng-click=ctrl.insersaoAutomatica(true) ng-show=ctrl.showGerAuto><div><span class=vertical-align-middle sk-translate>Commons.LancamentoOrdem.txtGeracaoAuto</span></div></li><li role=menuitem ng-show=ctrl.showGerSerie><sk-hbox><span><sk-i18n>Commons.LancamentoOrdem.txtSerieInicial</sk-i18n></span><sk-number-input sk-margin-left=5px sk-value=ctrl.serieInicial></sk-number-input><button sk-margin-left=5px class=\"btn btn-default\" ng-click=ctrl.gerarSerie()><sk-i18n>Commons.LancamentoOrdem.txtGerarSerie</sk-i18n></button></sk-hbox></li><li role=menuitem ng-show=ctrl.showInclSerie><sk-hbox><span><sk-i18n>Commons.LancamentoOrdem.txtSerie</sk-i18n></span><sk-text-input sk-margin-left=5px sk-value=ctrl.nroSerie></sk-text-input><button sk-margin-left=5px class=\"btn btn-default\" ng-click=ctrl.incluiSerie()><sk-i18n>Commons.LancamentoOrdem.txtIncluirSerie</sk-i18n></button></sk-hbox></li></ul></div><button default small ng-click=ctrl.removeSerie() ng-disabled=ctrl.btAddSeqDisabled tooltip=Commons.LancamentoOrdem.btnRemover tooltip-placement=bottom sk-i18n><sk-icon font-icon=bin></sk-icon></button> <button sk-i18n ng-click=ctrl.removeSeries() ng-disabled=ctrl.btAddSeqDisabled tooltip=Commons.LancamentoOrdem.buttonExcluirSeries tooltip-placement=bottom default><sk-i18n>Commons.LancamentoOrdem.buttonExcluirSeries</sk-i18n></button><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelNroSerie</b></h8><sk-rows-counter sk-dataset=ctrl.dsNumeroSerie></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsNumeroSerie sk-editable=false sk-allow-multiple-selection=false sk-disable-tour=true class=dg-serie layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=SEQOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPRODPA sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-hbox><h8 id=txtRodape></h8></sk-vbox></sk-hbox></sk-step><sk-step sk-title=Commons.LancamentoOrdem.stepExtratoMP sk-finalize=ctrl.canFinalize() sk-i18n><sk-dataset id=dsListaMPs sk-dataset-created=\"ctrl.onExtratoDatasetCreated('dsListaMPs',dataset)\" sk-standalone><sk-dsfield-md name=CODPRODMP description=Producao.ExtratoMateriais.labelFieldCodProdMp user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRMP description=Producao.ExtratoMateriais.labelFieldDescCodProdMP user-type=S></sk-dsfield-md><sk-dsfield-md name=CONTROLEMP description=Producao.ExtratoMateriais.labelFieldControleMP user-type=S></sk-dsfield-md><sk-dsfield-md name=REFERENCIA description=Producao.ExtratoMateriais.labelFieldReferenciaMP user-type=S></sk-dsfield-md><sk-dsfield-md name=ESTOQUE description=Producao.ExtratoMateriais.labelFieldEstoqueMP user-type=I></sk-dsfield-md><sk-dsfield-md name=NECESSIDADE description=Producao.ExtratoMateriais.labelFieldNecessidadeMP user-type=F></sk-dsfield-md><sk-dsfield-md name=QTDSUBS description=Producao.ExtratoMateriais.labelFieldQtdSubsMP user-type=F></sk-dsfield-md><sk-dsfield-md name=DECQTD description=\"\" visible user-type=I></sk-dsfield-md><sk-dsfield-md name=EXISTEMPSUB description=\"\" visible user-type=S></sk-dsfield-md><sk-dsfield-md name=SALDOMP description=Producao.ExtratoMateriais.labelSaldoMP user-type=F></sk-dsfield-md><sk-dsfield-md name=QTDUSAR description=Producao.ExtratoMateriais.labelQtdUsarMP user-type=F></sk-dsfield-md><sk-dsfield-md name=UNIDADE description=Producao.ExtratoMateriais.labelFieldUnidade user-type=S></sk-dsfield-md><sk-dsfield-md name=CODPARC description=Producao.ExtratoMateriais.labelFieldCodParcTerc user-type=I></sk-dsfield-md><sk-dsfield-md name=RAZAOSOCIAL description=Producao.ExtratoMateriais.labelFieldRazaoSocial user-type=S></sk-dsfield-md><sk-dsfield-md name=DSIDENTIFIER visible user-type=S></sk-dsfield-md><sk-dsfield-md name=QTDPEDCOMPRA description=Producao.ExtratoMateriais.labelFieldQtdPedidosCompra user-type=I></sk-dsfield-md><sk-dsfield-md name=QTDOPS description=Producao.ExtratoMateriais.lblQtdOp user-type=I></sk-dsfield-md></sk-dataset><sk-dataset id=dsListaMPAlternativa sk-save-handler=ctrl.defaultEmptySaveHandler() sk-dataset-created=\"ctrl.onExtratoDatasetCreated('dsListaMPAlternativa',dataset)\" sk-standalone><sk-dsfield-md name=CHK_SELECTION description=Commons.LancamentoOrdem.lblUsar user-type=S presentation-type=S></sk-dsfield-md><sk-dsfield-md name=CODPRODMPALT description=Producao.ExtratoMateriais.labelFieldCodProdMpAlt user-type=I is-pk=true></sk-dsfield-md><sk-dsfield-md name=DESCRPRODMPALT description=Producao.ExtratoMateriais.labelFieldDescCodProdMpAlt user-type=S></sk-dsfield-md><sk-dsfield-md name=REFERENCIA description=Producao.ExtratoMateriais.labelFieldReferenciaMpAlt user-type=S></sk-dsfield-md><sk-dsfield-md name=CONTROLEMPALT description=Producao.ExtratoMateriais.labelFieldControleMpAlt user-type=S></sk-dsfield-md><sk-dsfield-md name=ESTOQUE description=Producao.ExtratoMateriais.labelFieldEstoqueMP user-type=I></sk-dsfield-md><sk-dsfield-md name=NECESSIDADE description=Producao.ExtratoMateriais.labelFieldNecessidadeMpAlt user-type=F></sk-dsfield-md><sk-dsfield-md name=QTDUSAR description=Producao.ExtratoMateriais.labelFieldQtdUsarMpAlt user-type=F></sk-dsfield-md><sk-dsfield-md name=ORDEM description=\"\" visible user-type=I></sk-dsfield-md><sk-dsfield-md name=EDITADO description=\"\" visible user-type=S></sk-dsfield-md><sk-dsfield-md name=CONJUNTO description=Producao.ExtratoMateriais.labelFieldConjuntoMpAlt user-type=I></sk-dsfield-md><sk-dsfield-md name=QTDPROPORCAO description=\"\" visible user-type=F></sk-dsfield-md><sk-dsfield-md name=QTDMISTURAMPALT description=\"\" visible user-type=F></sk-dsfield-md><sk-dsfield-md name=QTD_LANC description=Producao.ExtratoMateriais.labelFieldQtdLancMpAlt user-type=I></sk-dsfield-md><sk-dsfield-md name=DECQTD description=\"\" visible user-type=F></sk-dsfield-md><sk-dsfield-md name=SALDOMPA description=Producao.ExtratoMateriais.labelFieldSaldoMpAlt user-type=F></sk-dsfield-md><sk-dsfield-md name=UNIDADE description=Producao.ExtratoMateriais.labelFieldUnidade user-type=S></sk-dsfield-md><sk-dsfield-md name=DSIDENTIFIER visible user-type=S></sk-dsfield-md><sk-dsfield-md name=SEQMPA visible user-type=I></sk-dsfield-md></sk-dataset><sk-dataset id=dsItemLancamento sk-dataset-created=\"ctrl.onExtratoDatasetCreated('dsItemLancamento',dataset)\" sk-standalone><sk-dsfield-md name=NULOP description=\"\" visible user-type=I></sk-dsfield-md><sk-dsfield-md name=SEQOP description=Producao.ExtratoMateriais.labelFieldSequencia user-type=S></sk-dsfield-md><sk-dsfield-md name=CODPRODPA description=Producao.ExtratoMateriais.labelFieldCodProdPA user-type=I></sk-dsfield-md><sk-dsfield-md name=CONTROLEPA description=Producao.ExtratoMateriais.labelFieldControlePA user-type=S></sk-dsfield-md><sk-dsfield-md name=TAMLOTE description=Producao.ExtratoMateriais.labelFieldTamanhoLote user-type=F></sk-dsfield-md><sk-dsfield-md name=CALCTAMLOTE description=Commons.LancamentoOrdem.campoTamLoteAjustado user-type=F></sk-dsfield-md><sk-dsfield-md name=IDPROC description=\"\" visible user-type=I></sk-dsfield-md><sk-dsfield-md name=CODPLP description=\"\" visible user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRPROD description=Producao.ExtratoMateriais.labelFieldDescCodProdPA user-type=S></sk-dsfield-md></sk-dataset><sk-vbox flex sk-height=100% class=extrato-mp-resizable><sk-resizable-rows><sk-hbox sk-resizable sk-direction=\"'bottom'\" sk-height=240px><sk-vbox flex><sk-top-bar class=well white><sk-hbox gap=8><button default small ng-click=ctrl.openGridConfigExtratoMPs() sk-i18n tooltip=Geral.lblConfigurarGrade tooltip-placement=right><sk-icon font-icon=cogwheel></sk-icon></button><sk-hbox sk-margin-top=2px layout-align=\"begin center\" flex><sk-switch sk-value=ctrl.apresentarPis sk-change=ctrl.changeApresentarPIs() sk-options=ctrl.optionsNao sk-padding-left=15px></sk-switch><h8 sk-padding-top=5px sk-padding-left=5px style=\"font-size: 12px\" sk-i18n>Commons.LancamentoOrdem.labelApresentarPIs</h8></sk-hbox><h8 style=\"margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.titleMateriaPrima</b></h8><button default ng-click=ctrl.abrirPopUpDetalhamentoEntregasMP() ng-disabled=!ctrl.enabledButtonDetalhamentoEntregas tooltip=Commons.LancamentoOrdem.buttonDetalhamentoEntregas tooltip-placement=bottom sk-i18n>Commons.LancamentoOrdem.buttonDetalhamentoEntregas</button> <button default small ng-click=\"ctrl.abrirConfiguracoesEstoque('MP')\" tooltip=Commons.LancamentoOrdem.labelConfigEstoque tooltip-placement=bottom sk-i18n><sk-icon font-icon=filter></sk-icon></button><sk-rows-counter sk-dataset=ctrl.dsListaMPs></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsListaMPs sk-editable=false sk-datagrid-interceptor=ctrl sk-grid-config={{::ctrl.gridListaMPsConfig}} sk-allow-multiple-selection=false sk-disable-tour=true sk-width=100% flex layout></sk-datagrid></sk-hbox></sk-vbox></sk-hbox><sk-hbox sk-padding-top=10px flex gap=5><sk-resizable-columns><sk-vbox sk-resizable sk-direction=\"'right'\" sk-width=40% flex><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridItemLancamentoConfig }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelOrdensDeProducao</b></h8><sk-rows-counter sk-dataset=ctrl.dsItemLancamento></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsItemLancamento sk-editable=false sk-grid-config={{::ctrl.gridItemLancamentoConfig}} sk-allow-multiple-selection=false sk-disable-tour=true class=dg-produto-extrato layout><sk-datagrid-custom-column sk-field-name=TAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLoteAlternativo></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CALCTAMLOTE sk-cell-formatter=ctrl.cellFormatterTamLoteAjustadaOP></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox><sk-vbox flex><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridMPAlternativaConfig }}\"></sk-grid-config><sk-hbox><sk-switch sk-value=ctrl.selecionaMps sk-change=ctrl.clicklSelectAll() sk-options=ctrl.optionsNao></sk-switch><h8 sk-padding-top=5px sk-padding-left=5px style=\"font-size: 12px\" sk-i18n>Commons.LancamentoOrdem.lblUsarTodos</h8></sk-hbox><div class=btn-group ng-if=ctrl.btnSaveMpEnabled><button class=\"btn btn-default\" ng-click=ctrl.saveMpAlternativa() tooltip=Commons.LancamentoOrdem.labelSalvar tooltip-placement=bottom sk-i18n tooltip-append-to-body=true><sk-icon font-icon=ok-2></sk-icon></button> <button class=\"btn btn-default\" ng-click=ctrl.cancelEditionMpAlternativa() tooltip=Commons.LancamentoOrdem.labelDescartar tooltip-placement=bottom sk-i18n tooltip-append-to-body=true><sk-icon ng-show=showAlertIcon class=icon-alert font-icon=alert></sk-icon><sk-i18n>Commons.LancamentoOrdem.labelDescartar</sk-i18n></button></div><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.titleMateriaAlternativa</b></h8><button default small sk-i18n ng-click=ctrl.changeMPAPosition(1) ng-disabled=!ctrl.changeSeqMpaEnabled(-1) tooltip=Commons.LancamentoOrdem.btnMoverPrioridadeCima tooltip-placement=bottom><sk-icon font-icon=arrow-up></sk-icon></button> <button default small sk-i18n ng-click=ctrl.changeMPAPosition(-1) class=margin-right-5 ng-disabled=!ctrl.changeSeqMpaEnabled(1) tooltip=Commons.LancamentoOrdem.btnMoverPrioridadeBaixo tooltip-placement=bottom><sk-icon font-icon=arrow-down></sk-icon></button><sk-rows-counter sk-dataset=ctrl.dsListaMPAlternativa></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid id=dgMPAlternativa sk-dataset=ctrl.dsListaMPAlternativa sk-editable=true sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgMPAlternativa',datagrid)\" sk-grid-config={{::ctrl.gridMPAlternativaConfig}} sk-datagrid-interceptor=ctrl sk-disable-tour=true sk-hide-cbx-column=true class=datagrid-materia-alt layout><sk-datagrid-custom-column sk-field-name=CHK_SELECTION sk-live-check=true></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox></sk-resizable-columns></sk-hbox></sk-resizable-rows></sk-vbox></sk-step><sk-step sk-title=SubProdutos sk-disabled=!ctrl.showStepSubproduto sk-finalize=ctrl.canFinalize() sk-i18n><sk-hbox flex><sk-vbox flex=40><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridSubProdutoProcessosConfig }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>Commons.LancamentoOrdem.labelOrdensDeProducao</b></h8><sk-rows-counter sk-dataset=ctrl.dsSubProdutoProcessos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsSubProdutoProcessos sk-editable=false sk-grid-config={{::ctrl.gridSubProdutoProcessosConfig}} sk-allow-multiple-selection=false sk-disable-tour=true class=dg-item-lancamento layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDPROC sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=ProdutoLancamentoDeOP.CODPRODPA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODPLP sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox><sk-vbox sk-padding-left=5px flex><sk-top-bar class=well white><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridSubProduto }}\"></sk-grid-config><h8 style=\"text-align: center; margin-top: 5px\" flex><b sk-i18n>SubProdutos</b></h8><sk-rows-counter sk-dataset=ctrl.dsSubProduto></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsSubProduto sk-editable=ctrl.isEditableDatagrids sk-on-datagrid-loaded=\"ctrl.onDatagridLoaded('dgSubProduto',datagrid)\" sk-grid-config={{::ctrl.gridSubProduto}} sk-allow-multiple-selection=false sk-datagrid-interceptor=ctrl sk-disable-tour=true class=dg-subProduto layout><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NROLOTE sk-cell-formatter=ctrl.cellFormatterNroLoteSubProduto></sk-datagrid-custom-column><sk-editor-renderer><script columns=NROLOTE>function renderer() {\n" +
    "                                        return {\n" +
    "                                            getGui: function (params, originalEditor, scope, utils) {\n" +
    "                                                return originalEditor;\n" +
    "                                            },\n" +
    "                                            isCachable: function (col) {\n" +
    "                                                return false;\n" +
    "                                            }\n" +
    "                                        }\n" +
    "                                    }</script></sk-editor-renderer></sk-datagrid></sk-hbox></sk-hbox></sk-vbox></sk-hbox></sk-step></sk-wizard></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/configuracaoEstoque/configuracaoEstoque.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1><sk-simple-item sk-label=Commons.LancamentoOrdem.labelEmpresaParaEstoque ng-show=!ctrl.isJivaProducao><sk-combobox sk-value=ctrl.empEstoque sk-options=ctrl.optionsEmpEstoque sk-width=40%></sk-combobox></sk-simple-item><sk-simple-item sk-label=Commons.LancamentoOrdem.labelListaEmpresas ng-show=ctrl.isJivaProducao><sk-text-input sk-value=ctrl.listaEmpresas flex></sk-text-input></sk-simple-item><sk-simple-item sk-margin-bottom=30px><sk-hbox><label class=form-input-label sk-i18n>Commons.LancamentoOrdem.labelFiltroPersonalizado</label><span flex></span> <button default small class=\"btn btn-primary\" ng-click=ctrl.openFilterAssistent() tooltip=Commons.LancamentoOrdem.labelAbrirAssistente tooltip-placement=bottom sk-i18n><sk-icon font-icon=filter></sk-icon></button></sk-hbox><sk-text-area sk-value=ctrl.filtroPersonalizado sk-margin-top=5px sk-height=13px></sk-text-area></sk-simple-item><sk-simple-item sk-label=Commons.LancamentoOrdem.labelLocais sk-padding-top=30px><sk-combobox sk-value=ctrl.locais sk-options=ctrl.optionsLocais sk-change=ctrl.onLocaisChange() sk-width=60%></sk-combobox></sk-simple-item><sk-simple-item sk-label=Commons.LancamentoOrdem.labelListaInformeSeparadoVirgula><sk-text-input sk-value=ctrl.listaLocais sk-enabled=ctrl.locaisEnabled flex></sk-text-input></sk-simple-item><sk-simple-item ski18n sk-label=Commons.LancamentoOrdem.labelSubtrairReserva><sk-switch sk-value=ctrl.subtrairReserva sk-options=ctrl.optionsNao></sk-switch></sk-simple-item><sk-simple-item ski18n sk-label=Commons.LancamentoOrdem.labelApenasLotesAprovados ng-show=ctrl.showApenasAprovados><sk-switch sk-value=ctrl.apenasAprovados sk-options=ctrl.optionsNao></sk-switch></sk-simple-item><sk-simple-item ski18n sk-label=Commons.LancamentoOrdem.labelDesconsiderarVencido ng-show=ctrl.showDesconsiderarVencido><sk-switch sk-value=ctrl.desconsiderarVencido sk-options=ctrl.optionsNao></sk-switch></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/detalhamentoEntregasMP/popUpDetalhamentoEntregasMP.tpl.html",
    "<sk-dataset id=dsDetalhamentoEntregas sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=CODPRODMP description=Producao.ExtratoMateriais.labelFieldCodProdMp user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRMP description=Producao.ExtratoMateriais.labelFieldDescCodProdMP user-type=S></sk-dsfield-md><sk-dsfield-md name=DTPREV description=Producao.ExtratoMateriais.labelDataPrevisaoEntrega user-type=S></sk-dsfield-md><sk-dsfield-md name=QTD description=Producao.ExtratoMateriais.lblQuantidadePrevisaoEntrega user-type=I></sk-dsfield-md><sk-dsfield-md name=NUNOTA description=Producao.ExtratoMateriais.lblNumeroPedido user-type=I></sk-dsfield-md></sk-dataset><sk-top-bar layout=row class=well><sk-hbox gap=8 layout-align=\"start center\" flex layout-wrap><sk-grid-config sk-config-name={{::ctrl.gridConfig}}></sk-grid-config></sk-hbox><sk-hbox gap=8 layout-align=\"center center\" flex style=flex:2 layout-wrap><h8 style=\"font-weight: bold\">{{::ctrl.materiaPrima}}</h8></sk-hbox><sk-hbox gap=8 layout-align=\"end center\" flex layout-wrap><sk-rows-counter sk-dataset=ctrl.dsDetalhamentoEntregas></sk-rows-counter></sk-hbox></sk-top-bar><sk-vbox flex><sk-datagrid sk-config-name={{::ctrl.gridConfig}} class=border-dg sk-dataset=ctrl.dsDetalhamentoEntregas sk-editable=false sk-on-datagrid-loaded=onDatagridLoaded(datagrid) flex layout></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/popup-dependencias/popupDependencias.tpl.html",
    "<sk-vbox gap=5 flex><sk-top-bar white sk-margin-top=10px><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridDependenciasConfig }}\"></sk-grid-config><span flex></span><sk-rows-counter sk-dataset=ctrl.dsDependencias></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsDependencias sk-editable=false sk-datagrid-interceptor=ctrl sk-grid-config={{::ctrl.gridDependenciasConfig}} sk-allow-multiple-selection=false sk-disable-tour=true layout><sk-datagrid-custom-column sk-field-name=CODPRODPA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CONTROLEPA sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=SEQOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=Produto.DECQTD sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/popupEdicaoControle/popupEdicaoControle.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1><sk-vbox sk-margin-left=10px sk-margin-right=10px sk-margin-bottom=10px><label class=\"form-input-label simple-label required\" sk-margin-top=5px><div layout=row><span class=ng-binding>{{ctrl.labelListControle}}</span></div></label><sk-checkbox-list sk-height=300px sk-options=ctrl.optionsControle sk-value=ctrl.controlesSelecionados sk-label=Commons.LancamentoOrdem.lblMarcarDesmarcarTodos sk-height=100px></sk-vbox></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/popupEdicaoProdConjunta/popupEdicaoProdConjunta.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1><sk-simple-item sk-field-name=IDCOP sk-label=Producao.GrupoCoProduto.labelGrupoCoProduto><sk-pesquisa-input sk-data-type=\"'I'\" sk-value=ctrl.idCop sk-entity-name=GrupoCoProduto sk-enabled=false sk-field-name=IDCOP sk-data-type=\"'I'\"></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=\"MP Compartilhada: \"><sk-pesquisa-input sk-data-type=\"'I'\" sk-value=ctrl.codProdMP sk-entity-name=Produto id=pesqMpCompartilhada sk-enabled=false></sk-simple-item><sk-simple-item id=formControle sk-label=\"Controle: \" ng-show=ctrl.showControleMpComp includeinlayout=false><sk-text-input sk-value=ctrl.controleMpCompart id=inputControle sk-enabled=false></sk-simple-item><sk-simple-item paddingtop=5 sk-label=Producao.GrupoCoProduto.labelQtdProcessamento sk-required=true><sk-number-input id=inputQtdProcess sk-value=ctrl.qtdProcess sk-focus-out=ctrl.setInfoCoProduto(false)></sk-simple-item><sk-simple-item sk-label=Producao.GrupoCoProduto.labelUnidade><sk-pesquisa-input sk-data-type=\"'S'\" id=pesqUnidade sk-value=ctrl.codVol sk-entity-name=Volume sk-enviroment-criteria=ctrl.criteriaUnidade() sk-entity-change=ctrl.setInfoCoProduto(false)></sk-simple-item><sk-simple-item sk-label=\"Reproporcionalizar qtd. entre Co-produções: \"><sk-switch id=checkBoxProporcionaliza sk-value=ctrl.isProporcionaliza selected></sk-simple-item><sk-simple-item paddingtop=10 sk-label=Producao.GrupoCoProduto.labelQtdProcessamentoPadrao><sk-number-input sk-value=ctrl.qtdProcessPadrao id=inputQtdProcessPadrao precision={_decQtd} sk-enabled=false></sk-simple-item><sk-simple-item sk-label=Producao.GrupoCoProduto.labelUnPadrao><sk-pesquisa-input sk-data-type=\"'S'\" sk-value=ctrl.codVolPadrao id=pesqUnidadePadrao sk-entity-name=Volume sk-enabled=false></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/popupErrosLancamentoOP/popupErrosLancamentoOP.tpl.html",
    "<sk-dataset id=dsErros sk-dataset-created=onDatasetErros(dataset) sk-standalone><sk-dsfield-md name=tipo ski18n description=Commons.LancamentoOrdem.lblTipo user-type=S sk-cell-formatter=ctrl.cellFormatterTipo></sk-dsfield-md><sk-dsfield-md name=descricao ski18n description=Commons.LancamentoOrdem.labelDescricaoErros user-type=S></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-datagrid sk-dataset=dsErros sk-datagrid-interceptor=ctrl flex><sk-datagrid-custom-column sk-field-name=tipo sk-cell-formatter=ctrl.cellFormatterTipo></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=descricao></sk-datagrid-custom-column></sk-datagrid><sk-simple-form sk-columns=1 flex><sk-simple-item sk-i18n sk-label=Commons.LancamentoOrdem.labelDescricaoErros sk-padding-left=0px sk-padding-right=0px sk-margin-top=20px><sk-text-area sk-value=ctrl.descricao sk-height=180 sk-margin-top=5px sk-enabled=false></sk-text-area></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/popupInclusaoOP/popupInclusaoOP.tpl.html",
    "<sk-vbox><sk-simple-form sk-columns=1><sk-vbox flex layout-padding><sk-simple-item sk-field-name=TIPOOP sk-label=Commons.LancamentoOrdem.labelTipoOrdem sk-required=true><sk-combobox sk-value=ctrl.valueTipOP sk-options=ctrl.optionsTipOP sk-change=ctrl.onTipoOpChange() sk-required=true></sk-combobox></sk-simple-item><sk-simple-item ski18n sk-label=Commons.LancamentoOrdem.labelProducaoParaTerceiro><sk-switch sk-value=ctrl.producaoParaTerc sk-options=ctrl.optionsNao sk-change=ctrl.onTerceiroChange()></sk-switch></sk-simple-item><sk-simple-item sk-field-name=CODPARC sk-label=Commons.LancamentoOrdem.labelCodParceiro sk-required=true ng-show=ctrl.showParceiro><sk-pesquisa-input sk-value=ctrl.codParc sk-entity-name=Parceiro sk-entity-change=ctrl.onParceiroChange(item) sk-field-name=CODPROD sk-data-type=\"'I'\"></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-field-name=CODPLP sk-label=Commons.LancamentoOrdem.labelPlantaDeProducao sk-required=true ng-show=ctrl.showPesqPlanta><sk-pesquisa-input sk-data-type=\"'I'\" sk-value=ctrl.codPlanta sk-entity-name=PlantaManufatura sk-field-name=CODPLP sk-data-type=\"'I'\"></sk-pesquisa-input></sk-simple-item><sk-vbox id=formProducaoConjunta ng-show=ctrl.showPesqCop><sk-simple-item sk-field-name=IDCOP sk-label=Producao.GrupoCoProduto.labelGrupoCoProduto sk-required=true ng-show=ctrl.showPesqCop><sk-pesquisa-input sk-data-type=\"'I'\" sk-value=ctrl.idCop sk-entity-name=GrupoCoProduto sk-entity-change=ctrl.setInfoCoProduto(item) sk-field-name=IDCOP sk-data-type=\"'I'\"></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=\"MP Compartilhada: \"><sk-pesquisa-input sk-data-type=\"'I'\" sk-value=ctrl.codProdMP sk-entity-name=Produto id=pesqMpCompartilhada sk-enabled=false></sk-simple-item><sk-simple-item id=formControle sk-label=\"Controle: \" ng-show=ctrl.showControleMpComp includeinlayout=false><sk-text-input sk-value=ctrl.controleMpCompart id=inputControle sk-enabled=false></sk-simple-item><sk-simple-item paddingtop=5 sk-label=Producao.GrupoCoProduto.labelQtdProcessamento sk-required=true><sk-number-input id=inputQtdProcess sk-precision=ctrl.getPrecision(ctrl.decQtd) sk-value=ctrl.qtdProcess sk-focus-out=ctrl.setInfoCoProduto()></sk-simple-item><sk-simple-item sk-label=Producao.GrupoCoProduto.labelUnidade><sk-pesquisa-input sk-data-type=\"'S'\" id=pesqUnidade sk-value=ctrl.codVol sk-entity-name=Volume sk-enviroment-criteria=ctrl.criteriaUnidade() sk-entity-change=ctrl.setInfoCoProduto()></sk-simple-item><sk-simple-item sk-label=\"Reproporcionalizar qtd. entre Co-produções: \" ng-show=ctrl.showRepropQtd><sk-switch id=checkBoxProporcionaliza selected></sk-simple-item><sk-simple-item paddingtop=10 sk-label=Producao.GrupoCoProduto.labelQtdProcessamentoPadrao><sk-number-input sk-value=ctrl.qtdProcessPadrao id=inputQtdProcessPadrao precision={_decQtd} sk-enabled=false></sk-simple-item><sk-simple-item sk-label=Producao.GrupoCoProduto.labelUnPadrao><sk-pesquisa-input sk-data-type=\"'S'\" sk-value=ctrl.codVolPadrao id=pesqUnidadePadrao sk-entity-name=Volume sk-enabled=false></sk-simple-item></sk-vbox><sk-vbox id=formProducao ng-show=ctrl.showPesqProd><sk-simple-item sk-field-name=CODPROD sk-label=Commons.LancamentoOrdem.labelProduto sk-required=true ng-show=ctrl.showPesqProd><sk-pesquisa-input sk-value=ctrl.codProd sk-entity-name=Produto sk-field-name=CODPROD sk-entity-change=ctrl.onProdutoChange(item) sk-enviroment-criteria=ctrl.criteriaProduto() sk-data-type=\"'I'\"></sk-pesquisa-input></sk-simple-item><sk-vbox ng-show=ctrl.showSelecionarControle sk-margin-left=10px sk-margin-right=10px sk-margin-bottom=10px><label class=\"form-input-label simple-label required\" sk-margin-top=5px><div layout=row><span class=ng-binding>{{ctrl.labelListControle}}</span></div></label><sk-checkbox-list sk-height=300px sk-options=ctrl.optionsControle sk-value=ctrl.controlesSelecionados sk-label=Commons.LancamentoOrdem.lblMarcarDesmarcarTodos sk-on-change=ctrl.onControleChange()></sk-checkbox-list></sk-vbox><sk-simple-item ski18n sk-label=Commons.LancamentoOrdem.lblLancarMesmaOP ng-show=ctrl.showControlesMesmaOP><sk-switch sk-value=ctrl.lancarMesmaOp sk-change=ctrl.changeMesmaOP() sk-options=ctrl.optionsNao></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.LancamentoOrdem.labelLoteProducao sk-required=true><sk-text-input sk-value=ctrl.nroLote sk-size=36 sk-enabled=ctrl.fieldNroLoteEnabled></sk-text-input></sk-simple-item><sk-simple-item sk-field-name=NUNOTA sk-label=Commons.LancamentoOrdem.labelNPedido sk-required=false><sk-hbox><sk-pesquisa-input sk-value=ctrl.nroPedido sk-entity-name=CabecalhoNota sk-enviroment-criteria=ctrl.criteriaPedido() sk-data-type=\"'I'\" sk-entity-change=ctrl.onPedidoChange(item) sk-field-name=NUNOTA flex=50 sk-show-description-input=false></sk-pesquisa-input><sk-pesquisa-input sk-value=ctrl.seqNota sk-size=36 sk-entity-name=ItemNota sk-padding-left=5px sk-target-field=SEQUENCIA sk-use-local-field-name=true sk-enviroment-criteria=ctrl.criteriaSeq() sk-data-type=\"'I'\" flex sk-show-description-input=false></sk-pesquisa-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.LancamentoOrdem.labelProcesso sk-required=true><sk-pesquisa-input id=pesquisaProcesso sk-value=ctrl.codProcesso sk-entity-name=ProcessoProdutivo sk-enviroment-criteria=ctrl.criteriaProcesso() sk-target-field=CODPRC sk-use-local-field-name=true sk-entity-change=ctrl.onProcessoChange(item) sk-data-type=\"'I'\" sk-options={limit:0}></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.LancamentoOrdem.labelTamanhoLote sk-required=true><sk-hbox><sk-number-input sk-value=ctrl.tamLote sk-size=36 sk-enabled=ctrl.fieldTamLoteEnabled sk-precision=ctrl.getPrecision(ctrl.decQtd) flex></sk-number-input><sk-icon sk-i18n sk-margin=\"3px 0px 0px 10px\" id=helpTipTamLote ng-disabled=!ctrl.fieldTamLoteEnabled class=dynamic-helptip font-icon=circle-question-mark ng-click=ctrl.toggleTooltip()></sk-icon></sk-hbox></sk-simple-item></sk-vbox></sk-vbox></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/lancamentoOrdemProducao/popups/popupInfoLote/popupInfoLote.tpl.html",
    "<sk-vbox gap=5 flex><sk-top-bar white sk-margin-top=10px><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridInfoLoteConfig }}\"></sk-grid-config><span flex></span> <button default small ng-click=ctrl.abrirConfiguracoesEstoque() tooltip=Commons.LancamentoOrdem.labelConfigEstoque tooltip-placement=bottom sk-i18n><sk-icon font-icon=filter></sk-icon></button><sk-rows-counter sk-dataset=ctrl.dsProdutos></sk-rows-counter></sk-hbox></sk-top-bar><sk-hbox flex gap=3><sk-datagrid sk-dataset=ctrl.dsProdutos sk-editable=false sk-grid-config={{::ctrl.gridInfoLoteConfig}} sk-datagrid-interceptor=ctrl sk-allow-multiple-selection=false sk-disable-tour=true layout><sk-datagrid-custom-column sk-field-name=TAMLOTEPAD sk-description=Commons.LancamentoOrdem.labelTamLotePadrao></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NULOP sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TIPOGERASERIE sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=Produto.DECQTD sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NROLOTE sk-visible=false></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=TAMLOTE sk-visible=false></sk-datagrid-custom-column></sk-datagrid></sk-hbox></sk-vbox>");
  $templateCache.put("commons/layout/layout-config-tool.tpl.html",
    "<sk-vbox layout-padding flex><sk-hbox layout flex class=layout-config-tools-container><sk-icon font-icon=reply class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.desfazerUltimaAcao tooltip-placement=right sk-enabled=$ctrl.statusBtnDesfazerEnabled ng-show=$ctrl.btnDesfazerShow ng-click=$ctrl.undoLastAction() flex></sk-icon><sk-icon font-icon=bin class=btn-icon-min sk-i18n tooltip=mge.GadgetBuilder.excluirColSelecionada tooltip-placement=bottom sk-enabled=$ctrl.statusBtnExcluirEnabled ng-show=$ctrl.btnExcluirShow ng-click=$ctrl.deleteWorkBox() flex></sk-icon><sk-icon font-icon=paste class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.colarColunaTransf tooltip-placement=bottom sk-enabled=$ctrl.statusBtnColarEnabled ng-show=$ctrl.btnColarShow ng-click=$ctrl.pastWorkBox() flex></sk-icon><sk-icon font-icon=scissors class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.recortarColSelecionada tooltip-placement=bottom sk-enabled=$ctrl.statusBtnRecortarEnabled ng-show=$ctrl.btnRecortarShow ng-click=$ctrl.cutWorkBox() flex></sk-icon><sk-icon font-icon=copy class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.copiarColSelecionada tooltip-placement=bottom sk-enabled=$ctrl.statusBtnCopiarEnabled ng-show=$ctrl.btnCopiarShow ng-click=$ctrl.copyWorkBox() flex></sk-icon><sk-icon font-icon=clean class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.limparColSelecionada tooltip-placement=bottom sk-enabled=$ctrl.statusBtnLimparEnabled ng-show=$ctrl.btnLimparShow ng-click=$ctrl.clearWorkBox() flex></sk-icon><sk-icon font-icon=square-empty class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.definirColSelAreaDestaque tooltip-placement=bottom ng-show=$ctrl.btnAreaDestaqueShow ng-click=$ctrl.detachWorkBox() flex></sk-icon><sk-icon font-icon=resize-horizontal class=btn-icon-min v=2 sk-i18n tooltip=mge.GadgetBuilder.mesclarColSelecionada tooltip-placement=bottom sk-enabled=$ctrl.statusBtnMesclarEnabled ng-show=$ctrl.btnMesclarShow ng-click=$ctrl.joinWorkBoxs() flex></sk-icon><button id=idLayoutOptions class=\"btn btn-default btn-sk-sm btn-transparent-no-border text-center\" sk-popover popover-hide-on-button-click=true popover-template-url=layoutOptions.html properties=$ctrl.layoutProperties always-load-properties=true height=auto width=auto create-on-load=true sk-height=20 sk-width=50 tooltip=mge.GadgetBuilder.labelLayout sk-i18n><sk-icon class=displayBlock font-icon={{$ctrl.layoutImgSrc}} v=2></sk-icon></button></sk-hbox><span flex><sk-divider></sk-divider></span><sk-vbox flex sk-margin-top=8px><sk-tabnavigator sk-hide-show-tabs=true sk-selected-index=$ctrl.tabSelectedIndex><sk-tabnavigator-item sk-label=mge.GadgetBuilder.lblDividir sk-font-size=11px></sk-tabnavigator-item><sk-tabnavigator-item sk-label=mge.GadgetBuilder.lblInserir sk-font-size=11px></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=$ctrl.tabSelectedIndex sk-creation-policy=all class=container-config flex layout=column class=has-borders><sk-viewstack-content layout=column flex><sk-hbox flex layout-align=\"start center\" sk-padding=5px><sk-vbox layout-align=\"start end\" gap=5 flex><span sk-i18n>mge.GadgetBuilder.qtdeColunas</span><sk-text-input sk-value=$ctrl.textQtdColsDividir sk-restrict=[^0-9] sk-width=50px></sk-text-input></sk-vbox><sk-vbox class=hRule sk-height=50px></sk-vbox><sk-vbox layout-align=\"start start\" gap=10 flex><span sk-i18n>mge.GadgetBuilder.direcao</span><sk-hbox flex><sk-icon svg-src={{$ctrl.imgVerticalAlign}} ng-click=\"$ctrl.divideWorkBox('vertical')\" sk-margin-right=3px sk-i18n tooltip=mge.GadgetBuilder.dividirVerticalColSelecionada tooltip-placement=bottom flex></sk-icon><sk-icon svg-src={{$ctrl.imgHorizontalAlign}} ng-click=\"$ctrl.divideWorkBox('horizontal')\" sk-i18n tooltip=mge.GadgetBuilder.dividirHorizontalColSelecionada tooltip-placement=bottom ng-if=$ctrl.enableDivideHorizontal flex></sk-icon></sk-hbox></sk-vbox></sk-hbox></sk-viewstack-content><sk-viewstack-content layout=column flex><sk-hbox flex layout-align=\"start center\" sk-padding=5px><sk-vbox layout-align=\"start end\" gap=5 flex><span sk-i18n>mge.GadgetBuilder.qtdeColunas</span><sk-text-input sk-value=$ctrl.textQtdColsInserir sk-restrict=[^0-9] sk-width=50px></sk-text-input></sk-vbox><sk-vbox class=hRule sk-height=50px></sk-vbox><sk-vbox layout-align=\"start start\" gap=10 flex><span sk-i18n>mge.GadgetBuilder.posicao</span><sk-hbox flex><sk-icon svg-src={{$ctrl.imgHAddBoxBefore}} ng-click=\"$ctrl.insertWorkBox('before')\" sk-margin-right=3px sk-i18n tooltip=mge.GadgetBuilder.addColAntesColSelecionada tooltip-placement=bottom flex></sk-icon><sk-icon svg-src={{$ctrl.imgHAddBoxAfter}} ng-click=\"$ctrl.insertWorkBox('after')\" sk-i18n tooltip=mge.GadgetBuilder.addColDepoisColSelecionada tooltip-placement=bottom flex></sk-icon></sk-hbox></sk-vbox></sk-hbox></sk-viewstack-content></sk-viewstack></sk-vbox></sk-vbox><script type=text/ng-template id=layoutOptions.html><div layout=\"column\" flex>\n" +
    "        <sk-list id=\"listViewLayout\" sk-select-checked=\"true\" sk-scroll-container flex class=\"list-container-layout-config\">\n" +
    "            <div ng-repeat=\"layout in layoutOptions track by $index\" class=\"selectedChecked\" ng-click=\"menuLayoutChange(layout)\" >\n" +
    "                <sk-hbox align=\"start start\">\n" +
    "                    <sk-vbox sk-width=\"20px\" align=\"start start\">\n" +
    "                        <sk-icon ng-if=\"layout.toggled\" font-icon=\"check\" v=\"2\"></sk-icon>\n" +
    "                    </sk-vbox>\n" +
    "                    <label ng-bind=\"layout.label\"></label>\n" +
    "                </sk-hbox>\n" +
    "            </div>\n" +
    "        </sk-list>\n" +
    "    </div></script>");
  $templateCache.put("commons/liberacoes/liberacaoOrcamento/popupSolicLibOrcamento.tpl.html",
    "<sk-dataset id=dsTransf entity-name=Transferencia sk-dataset-created=ctrl.onDatasetCreated(dataset) metadata-interceptor=ctrl.interceptMetadata sk-standalone><sk-field pattern=\"TIPO, OBSERVACAO, CODMETA, DTREF, CODUSU, CODUSULIB, VLRDESDOB, VALOR, CODCENCUS, CODNAT, CODPROJ, CODPROD, CODLOCAL, CONTROLE, MARCA\"></sk-field></sk-dataset><sk-double-face-panel id=dfpTransf sk-dataset=ctrl.dsTransf sk-default-face-index=FORM_FACE creation-complete=ctrl.onDoubleFacePanelCreated(dfpTransf) layout flex><sk-top-bar layout=row layout-align=\"start center\" layout-padding><div class=left-container layout=row layout-align=\"space-between left\" flex><sk-navigator dataset=ctrl.dsTransf sk-show-navigation=true sk-show-add-button=false sk-show-copy-button=false sk-show-remove-button=false sk-show-refresh-button=false sk-show-cancel-button=true sk-show-save-button=true sk-compact-btn-add></sk-navigator></div><div layout=row layout-align=\"end center\"><sk-rows-counter layout-align=\"end center\" sk-dataset=ctrl.dsTransf></div></sk-top-bar><sk-face-one><sk-form id=formTranf sk-dataset=ctrl.dsTransf sk-height=100% sk-width=100% sk-padding-top=0.3% sk-columns=1 sk-inline=true sk-form-interceptor=ctrl sk-fields-order=ctrl.allFields class=compact-components flex></sk-form></sk-face-one><sk-face-two><sk-datagrid id=dbgTransf sk-grid-config=\"{{ ::ctrl.gridConfigId}}\" sk-dataset=ctrl.dsTransf sk-height=100% sk-width=100% sk-editable=false sk-on-dbl-click=ctrl.onDoubleFacePanelClick() sk-allow-multiple-selection=true sk-disable-tour=true></sk-datagrid></sk-face-two></sk-double-face-panel>");
  $templateCache.put("commons/liberacoes/liberacoes/liberacoes.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.createDataSet(dataset) entity-name=LiberacaoLimite sk-standalone><sk-field pattern=NUCHAVE,EVENTO,TABELA,SEQUENCIA,SEQCASCATA,OBSERVACAO,OBSLIB,VLRLIMITE,PERCLIMITE,DHSOLICIT,DHLIB,VLRANTERIOR,PERCANTERIOR,CODUSULIB,CODUSUSOLICIT,VLRLIBERADO,VLRTOTAL,VLRATUAL></sk-field><sk-field pattern=DESCRICAO path=ViewEventoLiberacao></sk-field><sk-dsfield-md name=ENVIANOTIF description=Commons.Liberacoes.lblNotificar presentation-type=S><sk-options><sk-option data=true></sk-option><sk-option data=false></sk-option><sk-options></sk-options></sk-options></sk-dsfield-md><sk-dsfield-md name=TIPEVENTO description=Commons.Liberacoes.labelLiberado visible></sk-dsfield-md><sk-dsfield-md name=EDITALIBERADOR description=Commons.Liberacoes.labelLiberado visible></sk-dsfield-md><sk-dsfield-md name=EDITAVLRATUAL description=Commons.Liberacoes.labelLiberado visible></sk-dsfield-md><sk-dsfield-md name=PERCATUAL description=Commons.Liberacoes.labelPercSolicitado></sk-dsfield-md><sk-dsfield-md name=HASHLIBERACAO description=Commons.Liberacoes.labelLiberado visible></sk-dsfield-md><sk-dsfield-md name=ALTEROUVALOR description=Commons.Liberacoes.labelLiberado visible></sk-dsfield-md></sk-dataset><sk-hbox style=\"width:100%; height:100%\" flex><sk-double-face-panel id=dblFacePanel sk-default-face-index=GRID_FACE creation-complete=ctrl.onDoubleFacePanelCreated(dblFacePanel) sk-change-button-actions=ctrl.changeButtonActions sk-on-change-face=ctrl.onChangeFace(face) flex><sk-top-bar layout=row layout-padding><sk-navigator dataset=ctrl.dataSet show-crud=false sk-always-navigation=true></sk-navigator><sk-hbox gap=5 align=\"start center\" flex><span><sk-i18n>Commons.Liberacoes.labelLiberador</sk-i18n>:</span><sk-pesquisa-input autofocus class=pesquisa-liberador sk-value=ctrl.pesqMultiLib sk-api=ctrl.pesqMultiLibApi sk-description-field-name=Usuario.NOMEUSU sk-field-name=CODUSULIB sk-entity-name=Usuario sk-enviroment-criteria=ctrl.criterioLiberador() id=pesquisaLiberador sk-enabled=ctrl.pesqLibEnabled></sk-pesquisa-input><button default ng-click=ctrl.liberadorHandler() sk-i18n tooltip=Commons.Liberacoes.buttonDefinirLiberadorTooltip tooltip-placement=bottom tooltip-append-to-body=true sk-enabled=ctrl.pesqLibEnabled><span sk-i18n>Commons.Liberacoes.buttonDefinirLiberador</span></button> <button default ng-click=ctrl.saveHandler() ng-show=ctrl.showControlBar id=btnSalvarLiberacoes><span sk-i18n>Commons.Liberacoes.buttonSalvarLiberacoes</span></button></sk-hbox><div layout=row layout-align=\"end center\"><sk-rows-counter sk-dataset=ctrl.dataSet></sk-rows-counter></div></sk-top-bar><sk-face-one layout flex><sk-hbox sk-padding-top=8px gap=5 sk-overflow-y=auto flex><sk-form sk-dataset=ctrl.dataSet flex sk-inline=true class=compact-components sk-only-custom no-padding><sk-form-custom-item sk-field-name=NUCHAVE sk-enabled=false></sk-form-custom-item><sk-form-custom-item sk-field-name=DHSOLICIT sk-description=Commons.Liberacoes.labelDataSolicitacao sk-enabled=false></sk-form-custom-item><sk-form-custom-item sk-field-name=DHLIB sk-description=Commons.Liberacoes.labelDataLiberacao sk-enabled=false></sk-form-custom-item><sk-form-custom-item sk-field-name=PERCLIMITE sk-description=Commons.Liberacoes.labelValorLimitante sk-required=ctrl.iteFormVlrSolicRequired><sk-hbox align=\"start center\" gap=5><sk-number-input sk-dataset=ctrl.dataSet sk-enabled=false sk-field-name=PERCLIMITE sk-precision=2 sk-custom-item-input style=\"width: 95px\"></sk-number-input><span style=\"padding-right: 4px !important\">%</span><sk-number-input sk-dataset=ctrl.dataSet sk-enabled=false sk-field-name=VLRLIMITE sk-precision=ctrl.precision sk-pretty-precision=ctrl.prettyPrecision sk-custom-item-input style=\"max-width: 125px\"></sk-number-input></sk-hbox></sk-form-custom-item><sk-form-custom-item sk-field-name=PERCATUAL sk-description=Commons.Liberacoes.labelValorSolicitado sk-required=true><sk-hbox align=\"start center\" gap=5><sk-number-input sk-enabled=ctrl.nroPercAtualEnabled sk-dataset=ctrl.dataSet sk-field-name=PERCATUAL sk-precision=ctrl.decimaisPerc sk-custom-item-input style=\"width: 95px\"></sk-number-input><span style=\"padding-right: 4px !important\">%</span><sk-number-input sk-enabled=ctrl.nroVlrAtualEnabled sk-dataset=ctrl.dataSet sk-field-name=VLRATUAL sk-precision=ctrl.precision sk-pretty-precision=ctrl.prettyPrecision sk-custom-item-input style=\"max-width: 125px\"></sk-number-input></sk-hbox></sk-form-custom-item><sk-form-custom-item sk-field-name=PERCANTERIOR sk-description=Commons.Liberacoes.labelValorSolicAnterior><sk-hbox align=\"start center\" gap=5><sk-number-input sk-dataset=ctrl.dataSet sk-enabled=false sk-field-name=PERCANTERIOR sk-precision=2 sk-custom-item-input style=\"width: 95px\"></sk-number-input><span style=\"padding-right: 4px !important\">%</span><sk-number-input sk-dataset=ctrl.dataSet sk-enabled=false sk-field-name=VLRANTERIOR sk-precision=ctrl.precision sk-pretty-precision=ctrl.prettyPrecision sk-custom-item-input style=\"max-width: 125px\"></sk-number-input></sk-hbox></sk-form-custom-item><sk-form-custom-item sk-field-name=VLRTOTAL sk-description=Commons.Liberacoes.labelValorTotal><sk-number-input sk-dataset=ctrl.dataSet sk-enabled=false sk-field-name=VLRTOTAL sk-precision=ctrl.precision sk-pretty-precision=ctrl.prettyPrecision></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=VLRLIBERADO sk-description=Commons.Liberacoes.labelValorLiberado><sk-number-input sk-dataset=ctrl.dataSet sk-enabled=false sk-field-name=VLRLIBERADO sk-precision=ctrl.precision sk-pretty-precision=ctrl.prettyPrecision></sk-number-input></sk-form-custom-item></sk-form><sk-form sk-dataset=ctrl.dataSet flex sk-inline=true class=compact-components sk-only-custom no-padding><sk-form-custom-item sk-field-name=EVENTO sk-description=Commons.Liberacoes.labelEvento sk-enabled=false sk-simple-label></sk-form-custom-item><sk-form-custom-item sk-field-name=CODUSULIB sk-description=Commons.Liberacoes.labelLiberador sk-simple-label><sk-pesquisa-input sk-enabled=ctrl.pesqLibEnabled sk-dataset=ctrl.dataSet sk-target-field=CODUSU sk-field-name=CODUSULIB sk-entity-name=Usuario sk-description-field-name=Usuario.NOMEUSU sk-enviroment-criteria=ctrl.criterioLiberador()></sk-pesquisa-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODUSUSOLICIT sk-description=Commons.Liberacoes.labelSolicitante sk-enabled=false sk-simple-label></sk-form-custom-item><sk-form-custom-item sk-field-name=OBSERVACAO sk-description=Commons.Liberacoes.labelObservacoes><sk-text-area sk-dataset=ctrl.dataSet sk-field-name=OBSERVACAO sk-height=90></sk-text-area></sk-form-custom-item><sk-form-custom-item sk-field-name=OBSLIB sk-description=Commons.Liberacoes.labelObsLiberador sk-enabled=false pop-up-edit-enabled=false><sk-text-area sk-dataset=ctrl.dataSet sk-field-name=OBSLIB sk-enabled=false sk-height=90></sk-text-area></sk-form-custom-item><sk-form-custom-item sk-field-name=ENVIANOTIF sk-description=Commons.Liberacoes.labelNotificacao><sk-switch sk-dataset=ctrl.dataSet sk-field-name=ENVIANOTIF sk-true-value=true sk-false-value=false></sk-switch></sk-form-custom-item></sk-form></sk-hbox></sk-face-one><sk-face-two layout flex><sk-datagrid sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-dataset=ctrl.dataSet sk-editable=false flex sk-datagrid-interceptor=ctrl sk-on-dbl-click=ctrl.onDblClickGrid(dblFacePanel) sk-grid-config={{::ctrl.gridConfigLiberacoes}} sk-str-filtered-columns=TABELA,SEQUENCIA,SEQCASCATA sk-after-grid-function=ctrl.focusBotaoLiberar flex><sk-datagrid-custom-column sk-field-name=ENVIANOTIF sk-live-check=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=PERCATUAL sk-cell-formatter=ctrl.cellFormatterPerc></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRATUAL sk-cell-formatter=ctrl.cellFormatterValor></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRLIBERADO sk-cell-formatter=ctrl.cellFormatterValor></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTOTAL sk-cell-formatter=ctrl.cellFormatterValor></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRANTERIOR sk-cell-formatter=ctrl.cellFormatterValor></sk-datagrid-custom-column></sk-datagrid></sk-face-two></sk-double-face-panel></sk-hbox>");
  $templateCache.put("commons/liberacoes/painelLiberacoes/painelLiberacoes.tpl.html",
    "<sk-vbox flex><sk-vbox class=painel-title align=\"center center\"><span sk-i18n>Commons.Liberacoes.titleLiberacoesSolicitadas</span></sk-vbox><sk-liberacoes sk-data=liberacoes sk-close-function=closeFunction sk-ajusta-perc-lib-lim=ajustaPercLibLim sk-precision-to-mask=precisionToMask flex></sk-liberacoes></sk-vbox>");
  $templateCache.put("commons/liberacoes/popupLiberacoes/popupLiberacoes.tpl.html",
    "<sk-liberacoes sk-data=liberacaoData sk-close-function=closeFunction() sk-ajusta-perc-lib-lim=ajustaPercLibLim sk-precision-to-mask=precisionToMask sk-show-control-bar=showControlBar flex></sk-liberacoes>");
  $templateCache.put("commons/minicard/minicard.tpl.html",
    "<sk-vbox flex class=card><sk-hbox style=\"align-items: baseline; justify-content: space-between\"><span class=\"custom-label title\" tooltip={{$ctrl.titulo}}>{{$ctrl.titulo}}</span> <span ng-hide=$ctrl.hidePercentage class=\"custom-label value\">{{$ctrl.percentage}}</span></sk-hbox><sk-hbox flex style=\"align-items: center\"><span class=\"custom-label value\">{{$ctrl.value}}</span><div class=chart-wrapper><div class=chart id={{$ctrl.chartName}}></div></div></sk-hbox><sk-hbox><span class=\"custom-label info\">{{$ctrl.info}}</span></sk-hbox></sk-vbox>");
  $templateCache.put("commons/multiplosMotivosPerda/multiplosMotivoPerdaPopUp.tpl.html",
    "<sk-vbox id=popUpDetalhamentoMotivos><sk-hbox gap=8><button default small class=btn-remove ng-click=ctrl.removerItens() ng-show=\"ctrl.idxFormInputs > 0 && !ctrl.isApontamentoConfirmado\" sk-height=28px style=\"margin-left:15px; margin-bottom:10px\"><sk-icon font-icon=bin class=\"ng-isolate-scope margin-icon\"></sk-icon><translate>Limpar</translate></button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/ordemservico/campoampliado/campoampliado.tpl.html",
    "<sk-text-area flex sk-value=ctrl.value sk-enabled=false></sk-text-area>");
  $templateCache.put("commons/ordemservico/historico/historico.tpl.html",
    "<sk-dataset entity-name=ItemOrdemServico sk-dataset-created=ctrl.onDatasetCreated(dataset) order-by=NUMITEM><sk-field pattern=INICEXEC,HRINICIAL,HRFINAL,SOLUCAO,NUMITEM,TEMPGASTO></sk-field><sk-field path=Executante pattern=NOMEUSU></sk-field></sk-dataset><sk-list class=historicoos-class flex><sk-hbox class=item-class style=\"margin: 0\" flex ng-repeat=\"item in ctrl.itens\" ng-click=ctrl.abrirTelaDeOS(item)><sk-vbox style=\"cursor:pointer; border-right:1px solid #ccc; border-bottom:1px solid #ccc\" tooltip=\"Ir para Sub-OS\" tooltip-append-to-body=true tooltip-placement=top sk-i18n flex=30><sk-hbox sk-padding=5px gap=5><i class=\"glyphicon glyphicon-user\"></i> <span flex>{{item['Executante.NOMEUSU']}}</span></sk-hbox><sk-vbox sk-padding-left=5px gap=5><span flex>{{ctrl.getLabelDtExec(item)}}</span> <span flex>{{ctrl.getLabelHoraExec(item)}}</span> <span ng-if=ctrl.getLabelTempoGasto(item) flex>{{ctrl.getLabelTempoGasto(item)}}</span></sk-vbox><sk-hbox flex layout-align=\"start start\" sk-padding=5px><span style=\"margin-right: 15px\">{{ctrl.getLabelNumItem(item)}}</span></sk-hbox></sk-vbox><sk-vbox style=\"border-bottom:1px solid #ccc\" flex><textarea id={{item.NUMITEM}} flex readonly cols=100 rows={{ctrl.getSolucaoHeight(item)}} style=\"resize: none; overflow:hidden; border-style: none\">{{ctrl.getSolucao(item)}}</textarea></sk-vbox></sk-hbox></sk-list>");
  $templateCache.put("commons/parceiro/importardadosenderecosefaz/importardadosenderecosefaz.tpl.html",
    "<div layout=column flex class=importar-dados-enderecos-sefaz-container><div class=group-container><label class=group-label sk-translate>Core.Parceiro.endereco</label><div class=form-group><label class=form-input-label><span sk-translate>Core.Parceiro.dadosSefaz</span></label><div class=inline-block><div layout=column><span class=value-text ng-bind=ctrl.sefazInfo.parceiroSefaz.CODEND></span> <span class=value-text ng-bind=\"ctrl.sefazInfo.parceiroSefaz.NUMEND + ' ' + ctrl.sefazInfo.parceiroSefaz.COMPL\"></span></div></div></div><div layout=row layout-align=\"space-between center\" flex><div class=form-group flex=65><label class=form-input-label><span sk-translate>Core.Parceiro.endereco</span><sk-icon font-icon=asterisk class=required></sk-icon></label><sk-pesquisa-input sk-entity-name=Endereco sk-value=ctrl.parcInfo.CODEND sk-entity-change=ctrl.getTipo(item)></sk-pesquisa-input></div><div class=form-group flex=30><label class=form-input-label><span sk-translate sk-remove-end-colon>Core.Parceiro.tipoEndereco</span></label><sk-text-input sk-value=ctrl.parcInfo.TIPEND sk-enabled=false></sk-text-input></div></div><div class=form-group><label class=form-input-label><span sk-translate sk-remove-end-colon>Core.Parceiro.numero</span></label><sk-text-input sk-value=ctrl.parcInfo.NUMEND></sk-text-input></div><div class=form-group><label class=form-input-label><span sk-translate sk-remove-end-colon>Core.Parceiro.complemento</span></label><sk-text-input sk-value=ctrl.parcInfo.COMPLEMENTO></sk-text-input></div></div><div class=group-container><label class=group-label sk-translate>Core.Parceiro.bairro</label><div class=form-group><label class=form-input-label><span sk-translate>Core.Parceiro.dadosSefaz</span></label><span class=value-text ng-bind=ctrl.sefazInfo.parceiroSefaz.CODBAIRRO></span></div><div class=form-group><label class=form-input-label><span sk-translate sk-remove-end-colon>Core.Parceiro.cadastro</span><sk-icon font-icon=asterisk class=required></sk-icon></label><sk-pesquisa-input sk-entity-name=Bairro sk-value=ctrl.parcInfo.CODBAI></sk-pesquisa-input></div></div><div class=group-container><label class=group-label sk-translate>Core.Parceiro.cidade</label><div class=form-group><label class=form-input-label><span sk-translate>Core.Parceiro.dadosSefaz</span></label><span class=value-text ng-bind=\"ctrl.sefazInfo.parceiroSefaz.CODCID + '-' + ctrl.sefazInfo.parceiroSefaz.UF\"></span></div><div layout=row layout-align=\"space-between center\" flex><div class=form-group flex=65><label class=form-input-label><span sk-translate sk-remove-end-colon>Core.Parceiro.cadastro</span><sk-icon font-icon=asterisk class=required></sk-icon></label><sk-pesquisa-input sk-entity-name=Cidade sk-value=ctrl.parcInfo.CODCID sk-entity-change=ctrl.getUF(item)></sk-pesquisa-input></div><div class=form-group flex=30><label class=form-input-label><span sk-translate sk-remove-end-colon>Core.Parceiro.labelUF</span></label><sk-text-input sk-value=ctrl.parcInfo.UF sk-enabled=false></sk-text-input></div></div></div></div>");
  $templateCache.put("commons/parcelamento/parcelamentopopup.tpl.html",
    "<sk-simple-form sk-columns=1 flex sk-overflow-y=auto sk-in-line=true><sk-simple-item sk-label=Commons.Parcelamento.labelNumeroParcelas><sk-numeric-stepper sk-min-value=1 sk-value=ctrl.parcelas></sk-numeric-stepper></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.lblDesdobramentoInicial><sk-hbox gap=5><sk-number-input sk-value=ctrl.desdobInicial></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelTaxaJuros><sk-hbox gap=5><sk-number-input sk-precision=7 sk-pretty-precision=2 sk-value=ctrl.taxaJuros sk-enabled=ctrl.taxaJurosEnabled></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label={{::ctrl.lblTaxaMulta}}><sk-hbox gap=5 style=\"align-items: center\"><sk-number-input sk-precision=2 sk-value=ctrl.taxaMulta sk-enabled=ctrl.taxaMultaEnabled></sk-number-input><sk-help-tip sk-i18n sk-text={{::ctrl.helpTaxaMulta}}></sk-help-tip></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl.frmParceiro sk-label=Commons.Parcelamento.labelParceiro><sk-hbox gap=5><sk-pesquisa-input sk-value=ctrl.parceiro sk-field-name=CODPARC sk-entity-name=Parceiro></sk-pesquisa-input></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl.frmEmpresa sk-label=Commons.Parcelamento.labelEmpresa><sk-hbox gap=5><sk-pesquisa-input sk-value=ctrl.empresa sk-field-name=CODEMP sk-entity-name=Empresa></sk-pesquisa-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelContaBancaria><sk-hbox gap=5><sk-pesquisa-input sk-value=ctrl.codConta sk-field-name=CODCTABCOINT sk-entity-name=ContaBancaria></sk-pesquisa-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelTipoTitulo><sk-hbox gap=5><sk-pesquisa-input sk-value=ctrl.codTipTit sk-field-name=CODTIPTIT sk-entity-name=TipoTitulo></sk-pesquisa-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelFrequencia><sk-combobox sk-change=ctrl.habilitaDias() sk-value=ctrl.frequencia sk-options=ctrl.optionsFrequencia sk-allow-null=false sk-width=27%></sk-combobox></sk-simple-item><sk-simple-item ng-if=ctrl.diasEnabled sk-label=Commons.Parcelamento.labelIntervaloDias><sk-numeric-stepper sk-min-value=1 sk-value=ctrl.dias></sk-numeric-stepper></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelComEntrada sk-i18n><sk-hbox gap=5><sk-switch sk-change=ctrl.habilitaEntrada() sk-value=ctrl.comEntrada></sk-switch><sk-number-input sk-precision=2 sk-enabled=ctrl.entradaEnabled sk-value=ctrl.entrada></sk-number-input></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelAcrescentarHistorico sk-i18n><sk-hbox gap=5><sk-switch sk-value=ctrl.nroParcela></sk-switch></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl._showCalcJuroAteData sk-label=Commons.Parcelamento.labelCalcularJuros sk-i18n><sk-hbox gap=5><sk-switch sk-value=ctrl.jurosAteDataAtual></sk-switch></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl._showConsiderarEntradaCalcJuroMulta sk-label=Commons.Parcelamento.labelConsiderarEntrada sk-i18n><sk-hbox gap=5><sk-switch sk-value=ctrl.considerarEntradaCalcJuroMulta></sk-switch></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl._podeZerarJuroMulta sk-label=Commons.Parcelamento.lblZerarJuroMulta sk-i18n><sk-hbox gap=5><sk-switch sk-value=ctrl.zerarJuroMulta sk-change=ctrl.zerarJuroMultaChange()></sk-switch></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl._showCopiarRateio sk-label=Commons.Parcelamento.labelCopiarRateioParcelas sk-i18n><sk-hbox><sk-switch sk-value=ctrl.copiarRateio></sk-switch></sk-hbox></sk-simple-item><sk-simple-item ng-if=ctrl._utilizaSankhyaCivil sk-label=\"Considera Variação Cambial p/ Juros e Multas?\" sk-i18n><sk-hbox gap=5><sk-switch sk-value=ctrl.varCambialJurMult></sk-switch></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.lblPriceJurMulDesc sk-i18n><sk-hbox gap=5 style=\"align-items: center\"><sk-switch sk-enabled=ctrl.priceJurMulDescEnabled sk-value=ctrl.priceJurMulDesc></sk-switch><sk-help-tip sk-i18n sk-text=Commons.Parcelamento.hintPriceJurMulDesc></sk-help-tip></sk-hbox></sk-simple-item></sk-simple-form><sk-accordion flex close-others=true><sk-accordion-group id=acordionTipoParcelamento heading={{::ctrl.lblTipoParcelamento}} is-open=true><sk-simple-form><sk-simple-item style=\"width: 50%\"><sk-vbox><sk-radio-input class=radio-input sk-value=ctrl.tipo sk-option={{ctrl.JUROS_SIMPLES}} sk-change=ctrl.tipoParcChange() sk-i18n>{{'Commons.Parcelamento.itemParcelamentoJuroSimples' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.tipo sk-option={{ctrl.JURO_COMPOSTO}} sk-change=ctrl.tipoParcChange() sk-i18n>{{'Commons.Parcelamento.itemParcelamentoJuroComposto' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.tipo sk-option={{ctrl.JUROS_SIMPLES_FIXA}} sk-change=ctrl.tipoParcChange() sk-i18n>{{'Commons.Parcelamento.itemParcelamentoJuroCompostoFixas' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.tipo sk-option={{ctrl.SEM_JUROS}} sk-change=ctrl.tipoParcChange() sk-i18n>{{'Commons.Parcelamento.itemDuplicacaoSemJurosMultas' | translate}}</sk-radio-input></sk-vbox></sk-simple-item></sk-simple-form></sk-accordion-group><sk-accordion-group id=acordionJuroMulta isdisabled=ctrl.panelJuroMulta heading={{::ctrl.lblJurosMulta}} is-open=true><sk-simple-form><sk-simple-item sk-label=Commons.Parcelamento.labelGravarJuros style=\"width: 50%\"><sk-vbox><sk-radio-input class=radio-input sk-value=ctrl.juros sk-option={{ctrl.SOMADO}} sk-i18n>{{'Commons.Parcelamento.itemSomadoValor' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.juros sk-option={{ctrl.SEPARADO}} sk-i18n>{{'Commons.Parcelamento.itemSeparadoValor' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.juros sk-option={{ctrl.NEGOCIADO}} sk-i18n>{{'Commons.Parcelamento.itemSeparadoValorNegociado' | translate}}</sk-radio-input></sk-vbox></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.labelGravarMulta style=\"width: 50%\"><sk-vbox><sk-radio-input class=radio-input sk-value=ctrl.multa sk-option={{ctrl.SOMADO}} sk-i18n>{{'Commons.Parcelamento.itemSomadoValor' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.multa sk-option={{ctrl.SEPARADO}} sk-i18n>{{'Commons.Parcelamento.itemSeparadoValor' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.multa sk-option={{ctrl.NEGOCIADO}} sk-i18n>{{'Commons.Parcelamento.itemSeparadoValorNegociado' | translate}}</sk-radio-input></sk-vbox></sk-simple-item></sk-simple-form></sk-accordion-group><sk-accordion-group id=acordionDtBase heading={{::ctrl.lblBaseVencimento}} is-open=true><sk-simple-form><sk-vbox><sk-simple-item style=\"width: 50%\"><sk-radio-input class=radio-input sk-value=ctrl.dtVenc sk-option={{ctrl.ORIGINAL}} sk-change=ctrl.habilitaNovaData() sk-i18n>{{'Commons.Parcelamento.itemVencimentoOriginal' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.dtVenc sk-option={{ctrl.NEGOCIACAO}} sk-change=ctrl.habilitaNovaData() sk-i18n>{{'Commons.Parcelamento.itemNegociacao' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.dtVenc sk-option={{ctrl.HOJE}} sk-change=ctrl.habilitaNovaData() sk-i18n>{{'Commons.Parcelamento.itemHoje' | translate}}</sk-radio-input><sk-hbox layout-align=\"start center\" flex><sk-radio-input sk-width=110 sk-value=ctrl.dtVenc sk-option={{ctrl.INFORMAR}} sk-change=ctrl.habilitaNovaData() sk-i18n>{{'Commons.Parcelamento.itemInformarData' | translate}}</sk-radio-input><sk-date-input sk-enabled=ctrl.novaDtVencEnabled sk-value=ctrl.novaDtVenc sk-width=140></sk-date-input></sk-hbox></sk-simple-item></sk-vbox></sk-simple-form></sk-accordion-group><sk-accordion-group id=acordionDtNegociacao heading={{::ctrl.lblDataNegociacao}} is-open=true><sk-simple-form><sk-simple-item style=\"width: 50%\"><sk-vbox><sk-radio-input class=radio-input sk-value=ctrl.dtNeg sk-option={{ctrl.ORIGINAL}} sk-i18n>{{'Commons.Parcelamento.itemNegociacaoOriginal' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.dtNeg sk-option={{ctrl.VENCIMENTO}} sk-i18n>{{'Commons.Parcelamento.itemIguaNovoVencimento' | translate}}</sk-radio-input><sk-radio-input class=radio-input sk-value=ctrl.dtNeg sk-option={{ctrl.HOJE}} sk-i18n>{{'Commons.Parcelamento.itemHoje' | translate}}</sk-radio-input></sk-vbox></sk-simple-item></sk-simple-form></sk-accordion-group></sk-accordion>");
  $templateCache.put("commons/pesquisadorNotaTransporte/pesquisadorNotaTransporte.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-in-line=true sk-columns=1 padding-bottom=10px layout-padding><sk-simple-item class=campo-pesquisa sk-width=300px sk-label=\"Pesquisar por\"><sk-combobox id=campoPesquisa sk-value=ctrl.campoPesquisa sk-options=ctrl.optionsCampoPesquisa sk-required=true sk-change=ctrl.changeCampoPesquisa()></sk-simple-item><sk-simple-item sk-margin-top=10px sk-label=\"Chave NF-e\"><sk-text-input sk-focus-out=ctrl.focusOutNfeChave() id=campoNfeChave sk-value=ctrl.campoNfeChave sk-enabled=ctrl.chaveNfeEnabled></sk-simple-item><sk-simple-item sk-margin-top=10px sk-label=Veículo><sk-pesquisa-input sk-data-type=\"'I'\" sk-enviroment-criteria=ctrl.criteriaVeiculo() sk-entity-change=ctrl.entityChangeVeiculo() sk-entity-name=Veiculo sk-field-name=CODVEICULO id=campoVeiculo sk-value=ctrl.campoVeiculo sk-enabled=ctrl.veiculoEnabled></sk-simple-item><sk-simple-item sk-width=360px sk-margin-top=10px sk-label=\"Nro. Nota\"><sk-number-input sk-focus-out=ctrl.focusOutNroNota() id=campoNroNota sk-value=ctrl.campoNroNota sk-enabled=ctrl.nroNotaEnabled></sk-simple-item><sk-simple-item sk-width=360px sk-margin-top=10px sk-label=\"Nro. único\"><sk-pesquisa-input sk-data-type=\"'I'\" sk-enviroment-criteria=ctrl.criteriaNroUnico() sk-entity-change=ctrl.entityChangeNroUnico() id=campoNroUnico sk-show-description-input=false sk-value=ctrl.campoNroUnico sk-entity-name=CabecalhoNota sk-field-name=NUNOTA sk-enabled=ctrl.nroUnicoEnabled></sk-simple-item><sk-simple-item sk-margin-top=10px sk-label=Contrato><sk-pesquisa-input sk-data-type=\"'I'\" sk-entity-change=ctrl.entityChangeContrato() sk-entity-name=ContratoArmazenagemGeral sk-field-name=NUMCONTRATO id=campoContrato sk-value=ctrl.campoContrato sk-enabled=ctrl.contratoEnabled></sk-simple-item></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/pesquisadorNotaTransporte/selecionaNota.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=CODVEICULO description=Veículo read-only=true user-type=I></sk-dsfield-md><sk-dsfield-md name=NUMNOTA description=\"Nro. Nota\" read-only=true user-type=I></sk-dsfield-md><sk-dsfield-md name=NUNOTA description=\"Nro. único\" read-only=true user-type=I></sk-dsfield-md><sk-dsfield-md name=NUMCONTRATO description=Contrato read-only=true user-type=I></sk-dsfield-md><sk-dsfield-md name=CODPARC description=\"Cód. Parceiro\" read-only=true user-type=I></sk-dsfield-md><sk-dsfield-md name=NOMEPARC description=Parceiro read-only=true user-type=S></sk-dsfield-md><sk-dsfield-md name=CODEMP visible user-type=S></sk-dsfield-md><sk-dsfield-md name=CODMOTORISTA visible user-type=S></sk-dsfield-md><sk-dsfield-md name=CHAVENFE description=\"Chave NF-e\" read-only=true user-type=S></sk-dsfield-md><sk-dsfield-md name=CODPROD description=Produto read-only=true user-type=S></sk-dsfield-md><sk-dsfield-md name=PADCLASS description=\"Pad. Classificação\" read-only=true user-type=S></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsNotaTransporte sk-allow-multiple-selection=false sk-on-dbl-click=ctrl.dblClickNota() sk-editable=false></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/planejamento-meta-orcamento.tpl.html",
    "<sk-hbox class=planejamento-metas ng-show=ctrl.showBox sk-height=100% flex><sk-vbox ng-show=ctrl.showFilter class=sidenav-meta layout-padding flex><sk-hbox class=filter-title gap=5 layout-align=\"space-between center\"><button info small ng-click=\"ctrl.showFilter = !ctrl.showFilter\" tooltip=Commons.PlanejamentoMetaOrcamento.esconderpainel tooltip-placement=right sk-i18n><sk-icon font-icon=chevron-left></sk-icon></button> <button class=\"btn btn-success\" style=\"width: 100%\" ng-click=ctrl.carregarPlanejamento(true) primary sk-i18n>Geral.buttonAplicar</button></sk-hbox><sk-simple-form sk-columns=1 no-padding><sk-hbox><sk-simple-item sk-class-help=metas-help-empresa-contabilidade sk-label=Commons.PlanejamentoMetaOrcamento.empresaContabilidade ng-if=ctrl.bloquearEmpresaDetalhe sk-required=true sk-help-tip=Commons.PlanejamentoMetaOrcamento.helpEmpresaContabilidade><sk-pesquisa-input sk-entity-name=EmpresaContabilidade sk-value=ctrl.codEmp sk-change=ctrl.onChangeEmpresa() sk-enviroment-criteria=ctrl.getCriteriaEmpresa()></sk-pesquisa-input></sk-simple-item></sk-hbox><sk-hbox><sk-simple-item sk-class-help=metas-help-periodo-contabil sk-label=Commons.PlanejamentoMetaOrcamento.periodo ng-if=ctrl.porPeriodo sk-required=true sk-help-tip=Commons.PlanejamentoMetaOrcamento.helpPeriodo><sk-pesquisa-input sk-entity-name=PeriodoContabil sk-value=ctrl.codPeriodo sk-entity-change=ctrl.onChangePeriodo() sk-enviroment-criteria=ctrl.getCriteriaPeriodo() sk-enabled=\"ctrl.codEmp != undefined\"></sk-pesquisa-input></sk-simple-item></sk-hbox><sk-hbox layout-align=\"space-between center\" gap=6 flex><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.ano ng-if=\"!ctrl.porPeriodo && !ctrl.intervalounico\"><sk-combobox sk-value=ctrl.anoPlanejamento sk-change=ctrl.limparRowdata() sk-options=ctrl.optionsAno sk-allow-null=false></sk-combobox></sk-simple-item><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.intevaloUnico ng-if=\"!ctrl.porPeriodo && ctrl.intervalounico\"><sk-date-input sk-value=ctrl.intervalounico sk-enabled=false></sk-date-input></sk-simple-item><sk-simple-item sk-label={{ctrl.lblTipoMeta}} ng-if=\"ctrl.valueDetalhe != 'NATUREZA' && ctrl.valueDetalhe != 'CTACTBPART'\"><sk-combobox sk-value=ctrl.tipoMeta sk-change=ctrl.trocarTipoMeta() sk-change=ctrl.limparRowdata() sk-options=ctrl.optionsTipo sk-allow-null=false></sk-combobox></sk-simple-item></sk-hbox><sk-vbox id=filtro-detalhe></sk-vbox><sk-simple-item ng-repeat=\"p in ctrl.comboboxOptions\" sk-label={{::p.label}} sk-required=true><sk-combobox sk-value=ctrl.valuesCombobox[p.entity] sk-change=ctrl.limparRowdata() sk-options=p.opcoes sk-allow-null=false></sk-combobox></sk-simple-item></sk-simple-form><sk-accordion close-others=true flex><sk-accordion-group ng-repeat=\"filter in ctrl.filterEntity\" heading=\"{{::ctrl.lblFiltro}} {{:: filter.label}}\" is-open=ctrl.openEnityList[filter.entity] is-disabled=false is-required=true><sk-entity-list sk-entity-name={{::filter.entity}} sk-value=ctrl.entityList[filter.field] sk-field-name={{::filter.fieldMET}} sk-show-label=true sk-show-checkbox=true sk-on-change=ctrl.limparRowdata() sk-only-one-selection=true sk-enviroment-criteria=ctrl.getEnviromentCriteria(filter.entity) sk-component-created=\"ctrl.onEntityListCreated($component, filter.entity)\" sk-allow-show-hierarchical-mode=filter.hierarchical sk-handle-only-analytics=true flex></sk-entity-list></sk-accordion-group></sk-accordion></sk-vbox><sk-vbox flex><div id=gridFlatFieldsId style=\"margin-left: 2px; margin-right: 0px; margin-top: 7px; border-bottom: 1px solid #ccc\" class=\"row sub-header\"><ul class=breadcrumbs><li><a class=active ng-bind=\"'Ano: ' + ctrl.anoPlanejamento\"></a></li><li><a class=active ng-bind=\"'Tipo Meta: ' + ctrl.exibeRecDesp\" ng-if=\"ctrl.valueDetalhe != 'NATUREZA' && ctrl.valueDetalhe != 'CTACTBPART'\"></a></li><li><a class=active ng-bind=\"'Detalhar por: ' + ctrl.campoDetalhe\"></a></li><li><a class=active ng-bind=\"'Marca: ' + ctrl.valuesCombobox.MarcaProduto\" ng-if=ctrl.showMarcaField()></a></li><li ng-repeat=\"gridFlatFields in ctrl.arvoreFiltro\"><a ng-bind=\"gridFlatFields.label + ': ' + gridFlatFields.value\"></a></li></ul></div><sk-hbox sk-bg-color=high-contrast layout-padding><button primary small ng-click=\"ctrl.showFilter = !ctrl.showFilter\" tooltip=Commons.PlanejamentoMetaOrcamento.mostrarpainel tooltip-placement=right sk-i18n><sk-icon font-icon=filter></sk-icon></button><sk-hbox ng-click=\"ctrl.showFilter = false\" button-container layout-align=\"start end\" layout-wrap flex><sk-search-input class=sk-search-input id=search-input sk-value=ctrl.filterGrade sk-placeholder=\"Digite para Filtrar...\" sk-change=ctrl.onFilterTextBoxChanged()></sk-search-input><button ng-show=!ctrl.modoCenario ng-click=ctrl.gerarMetas() ng-disabled=ctrl.isDisableBtn default ng-bind=ctrl.lblBtnConfirmar></button> <button ng-show=!ctrl.modoCenario ng-click=ctrl.limparPlanejamento() ng-disabled=\"ctrl.isDisableBtn || !ctrl.podeExcluirPlanejamento\" default sk-i18n tooltip=Commons.PlanejamentoMetaOrcamento.excluirplanejamento tooltip-placement=bottom small><sk-icon font-icon=bin></sk-icon></button> <button ng-show=!ctrl.modoCenario ng-click=ctrl.descartarAlteracoes() ng-disabled=ctrl.isDisableBtn default sk-i18n tooltip=Commons.PlanejamentoMetaOrcamento.descartaralteracoes tooltip-placement=bottom small><sk-icon svg-src=/mge/assets/svg/erase-text.svg style=\"min-width: 36px\"></sk-icon></button> <button ng-click=ctrl.carregarPlanejamento(true) ng-disabled=ctrl.isDisableBtn default sk-i18n tooltip=Navigator.lblAtualizar tooltip-placement=bottom small><sk-icon font-icon=refresh></sk-icon></button><sk-hbox gap=3 align=\"end left\" flex=6><label class=label-mes>Mês:</label><sk-combobox class=combo-mes sk-enabled=\"!ctrl.modoCenario && ctrl.mostraMes\" sk-change=ctrl.selecionaMes() sk-value=ctrl.mesSelecionado sk-options=ctrl.meses sk-allow-null=false sk-required=true></sk-combobox></sk-hbox><label sk-font-size=16px class=label-texto layout layout-align=\"center center\" sk-margin=0px flex ng-bind=ctrl.descrMeta></label><sk-hbox gap=5 align=\"end center\" flex=20><sk-hbox ng-show=ctrl.modoCenario gap=5 layout-align=\"space-between center\"><button default small ng-click=ctrl.voltarPlanejamento() tooltip=Commons.PlanejamentoMetaOrcamento.lblVoltarPlanejamento tooltip-placement=bottom sk-i18n><sk-icon font-icon=chevron-left></sk-icon></button><sk-hbox align=\"center center\" class=modo-cenario flex><label sk-margin=0px sk-font-size=20px class=label-texto sk-i18n>Commons.PlanejamentoMetaOrcamento.lblModoCenario</label></sk-hbox></sk-hbox><sk-hbox gap=5><button ng-click=ctrl.popUpSelecioneMeta(true) sk-i18n tooltip={{ctrl.lblTrocarmeta}} tooltip-placement=bottom small default><sk-icon svg-src=/mge/assets/svg/exchange.svg style=\"min-width: 36px\"></sk-icon></button> <button ng-show=!ctrl.modoCenario ng-click=ctrl.configurarGrade() default sk-i18n sk-margin-left=4px tooltip=Commons.PlanejamentoMetaOrcamento.configuracaorade tooltip-placement=bottom small><sk-icon font-icon=cogwheel></sk-icon></button><sk-action-button ng-show=!ctrl.modoCenario ng-if=\"ctrl.entityBtnAction && ctrl.ehSankhyaW\" sk-entity-name=\"{{:: ctrl.entityBtnAction}}\" sk-resource-id=\"{{ ::ctrl.actionBtnID }}\" sk-access-resource-id=\"{{ ::ctrl.resourceId }}\" sk-context=ctrl.planejamentoCtx sk-disabled=\"ctrl.rowsPsList.length == 0\"></sk-action-button><div id=report-loader></div><sk-btn-other-options ng-if=!ctrl.porPeriodo sk-other-options=ctrl.otherOptionsLoader()></sk-btn-other-options></sk-hbox></sk-hbox></sk-hbox></sk-hbox><sk-vbox ng-click=\"ctrl.showFilter = false\" flex><div id=ag-grid></div><div id=ag-grid-total></div></sk-vbox></sk-vbox></sk-hbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/ajuste-valores/ajuste-valores.tpl.html",
    "<sk-vbox flex style=\"padding-right: 3px\"><sk-hbox layout-padding style=\"border-top: 1px solid #ccc;border-left: 1px solid #ccc;border-right: 1px solid #ccc;background: #E4E4E4\" gap=5 align=\"start center\"><sk-combobox flex sk-allow-null=false sk-value=ctrl.tipo sk-options=ctrl.tipoOperacoes></sk-combobox><sk-number-input sk-width=50px sk-size=3 sk-value=ctrl.valor sk-precision=0></sk-number-input><span style=\"font-weight: bold\">%</span></sk-hbox><sk-vbox layout-padding gap=8 flex><sk-hbox align=\"start center\" gap=8><sk-switch sk-value=ctrl.valueTipo sk-change=ctrl.marcarDesmarca(ctrl.valueTipo)></sk-switch><span sk-i18n>Geral.lblMarcarDesmarcar</span></sk-hbox><sk-vbox gap=8><sk-hbox gap=10><sk-hbox flex=33 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO1']\"></sk-switch><span ng-bind=ctrl.lblPrevisto1></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto2 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO2']\"></sk-switch><span ng-bind=ctrl.lblPrevisto2></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto3 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO3']\"></sk-switch><span ng-bind=ctrl.lblPrevisto3></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto4 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO4']\"></sk-switch><span ng-bind=ctrl.lblPrevisto4></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto5 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO5']\"></sk-switch><span ng-bind=ctrl.lblPrevisto5></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto6 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO6']\"></sk-switch><span ng-bind=ctrl.lblPrevisto6></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto7 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO7']\"></sk-switch><span ng-bind=ctrl.lblPrevisto7></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto8 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO8']\"></sk-switch><span ng-bind=ctrl.lblPrevisto8></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto9 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO9']\"></sk-switch><span ng-bind=ctrl.lblPrevisto9></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto10 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO10']\"></sk-switch><span ng-bind=ctrl.lblPrevisto10></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto11 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO11']\"></sk-switch><span ng-bind=ctrl.lblPrevisto11></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto12 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO12']\"></sk-switch><span ng-bind=ctrl.lblPrevisto12></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto13 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO13']\"></sk-switch><span ng-bind=ctrl.lblPrevisto13></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto14 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO14']\"></sk-switch><span ng-bind=ctrl.lblPrevisto14></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto15 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO15']\"></sk-switch><span ng-bind=ctrl.lblPrevisto15></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto16 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO16']\"></sk-switch><span ng-bind=ctrl.lblPrevisto16></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto17 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO17']\"></sk-switch><span ng-bind=ctrl.lblPrevisto17></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto18 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO18']\"></sk-switch><span ng-bind=ctrl.lblPrevisto18></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto19 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO19']\"></sk-switch><span ng-bind=ctrl.lblPrevisto19></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto20 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO20']\"></sk-switch><span ng-bind=ctrl.lblPrevisto20></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto21 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO21']\"></sk-switch><span ng-bind=ctrl.lblPrevisto21></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto22 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO22']\"></sk-switch><span ng-bind=ctrl.lblPrevisto22></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto23 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO23']\"></sk-switch><span ng-bind=ctrl.lblPrevisto23></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto24 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO24']\"></sk-switch><span ng-bind=ctrl.lblPrevisto24></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto25 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO25']\"></sk-switch><span ng-bind=ctrl.lblPrevisto25></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto26 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO26']\"></sk-switch><span ng-bind=ctrl.lblPrevisto26></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto27 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO27']\"></sk-switch><span ng-bind=ctrl.lblPrevisto27></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto28 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO28']\"></sk-switch><span ng-bind=ctrl.lblPrevisto28></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto29 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO29']\"></sk-switch><span ng-bind=ctrl.lblPrevisto29></span></sk-hbox><sk-hbox flex=33 ng-if=ctrl.lblPrevisto30 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO30']\"></sk-switch><span ng-bind=ctrl.lblPrevisto30></span></sk-hbox></sk-hbox><sk-hbox gap=10><sk-hbox flex=33 ng-if=ctrl.lblPrevisto31 align=\"start center\" gap=8><sk-switch sk-value=\"ctrl.previsto['PREVISTO31']\"></sk-switch><span ng-bind=ctrl.lblPrevisto31></span></sk-hbox></sk-hbox></sk-vbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/buscaMeta/busca-meta.tpl.html",
    "<sk-dataset entity-name=\"{{:: ctrl.entityName}}\" sk-dataset-created=ctrl.onDatasetCreated(dataset) order-by=\"{{:: ctrl.orderBY}}\"><sk-field pattern=\"{{:: ctrl.fieldPatter}}\"></sk-field></sk-dataset><sk-vbox flex><sk-hbox style=\"background-color: #e4e4e4; border-top: 1px solid #ccc;border-left: 1px solid #ccc;border-right: 1px solid #ccc\" layout-padding><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridConfigId }}\"></sk-grid-config><sk-navigator dataset=ctrl.dsMetas sk-show-navigation=true sk-show-add-button=false sk-show-copy-button=false sk-show-remove-button=false sk-show-cancel-button=true sk-show-save-button=true sk-edit-unique-record=false></sk-navigator><sk-search-input autofocus sk-debounce=450 class=sk-search-input id=search-input sk-value=ctrl.valuePesqMeta sk-placeholder=\"Digite para Filtrar...\" sk-change=ctrl.onPesquisaMetaChanged() sk-on-click=ctrl.onPesquisaMetaChanged></sk-search-input><button primary ng-click=ctrl.iniciarPlanejamento() auto-focus><span sk-i18n={{ctrl.labelButtonSearchPlanejamento}}></span></button></sk-hbox><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsMetas></sk-rows-counter></div></sk-hbox><sk-datagrid sk-dataset=ctrl.dsMetas sk-config-name=\"{{ ::ctrl.gridConfigId }}\" sk-on-dbl-click=ctrl.iniciarPlanejamento() sk-hide-cbx-column=true sk-allow-multiple-selection=false sk-editable=false flex></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/cenarios/cenarios.tpl.html",
    "<sk-dataset entity-name=ForecastMeta sk-dataset-created=ctrl.onDatasetCreated(dataset)></sk-dataset><sk-double-face-panel ng-show=!ctrl.isComparar id=dblFacePanelForecastMeta sk-dataset=ctrl.dsForecastMeta sk-default-face-index=GRID_FACE creation-complete=ctrl.onDoubleFacePanelCreated(dblFacePanelForecastMeta) layout flex sk-change-button-actions=ctrl.changeButtonActions class=planejamento-metas><sk-top-bar layout=row layout-padding><sk-navigator dataset=ctrl.dsForecastMeta sk-show-navigation=true sk-show-add-button=false sk-show-copy-button=false sk-show-edit-button=false sk-show-cancel-button=true sk-show-save-button=true></sk-navigator><sk-hbox button-container layout-align=\"start end\" layout-wrap flex><button default ng-disabled=\"ctrl.dsForecastMeta.size() == 0\" ng-click=ctrl.resgatarCenario() primary sk-i18n>Commons.PlanejamentoMetaOrcamento.lblResgatarCenario</button></sk-hbox><sk-hbox button-container layout-align=\"end center\" layout-wrap flex><button success ng-disabled=\"ctrl.dsForecastMeta.size() == 0\" ng-click=ctrl.compararCenario() primary sk-i18n>Commons.PlanejamentoMetaOrcamento.lblCompararCenarios</button><sk-rows-counter sk-dataset=ctrl.dsForecastMeta></sk-rows-counter></sk-hbox></sk-top-bar><sk-face-one layout flex><sk-form sk-dataset=ctrl.dsForecastMeta columns=1 ng-disabled=\"ctrl.dsForecastMeta.size() == 0\" sk-only-custom><sk-form-custom-item sk-field-name=NOMECENARIO></sk-form-custom-item><sk-form-custom-item sk-field-name=OBSERVACAO><sk-text-area sk-dataset=ctrl.dsForecastMeta sk-field-name=OBSERVACAO></sk-text-area></sk-form-custom-item></sk-form></sk-face-one><sk-face-two layout sk-bg-color=#fbfbfb flex><sk-datagrid sk-grid-config={{::ctrl.gridConfig}} sk-dataset=ctrl.dsForecastMeta sk-allow-multiple-selection=false sk-on-dbl-click=ctrl.onDblClickGrid() sk-show-tour=false flex></sk-datagrid></sk-face-two></sk-double-face-panel><sk-vbox ng-show=ctrl.isComparar class=checkbox-list-cenario flex><sk-hbox style=\"border-top: 1px solid #ccc;border-left: 1px solid #ccc;border-right: 1px solid #ccc\" layout-padding button-container><sk-hbox layout-align=\"start end\"><button small font-icon=chevron-left default ng-click=\"ctrl.isComparar = !ctrl.isComparar\"></button></sk-hbox><div layout=row layout-align=\"center center\" flex><sk-title layout-align=\"center center\" sk-i18n>Commons.PlanejamentoMetaOrcamento.lblComparacao</sk-title></div><sk-hbox layout-align=\"end center\"><button ng-click=ctrl.aplicarCenario() primary sk-i18n>Geral.buttonAplicar</button></sk-hbox></sk-hbox><sk-checkbox-list sk-label={{::ctrl.lblCenarios}} sk-options=ctrl.options sk-value=ctrl.listCenarios flex></sk-checkbox-list></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/configuracaoGrid/configuracao-grid.tpl.html",
    "<sk-simple-form sk-columns=2 class=planejamento-metas flex><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.alertarAlteracao><sk-switch sk-value=ctrl.alertarAlteracao sk-change=\"ctrl.isEnableAlerta('alertarAlteracao', ctrl.alertarAlteracao)\" sk-true-value=true sk-false-value=false></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.distribuirhierarquia><sk-switch sk-value=ctrl.distribuirhierarquia sk-change=\"ctrl.isEnableAlerta('distribuirhierarquia', ctrl.distribuirhierarquia)\" sk-true-value=true sk-false-value=false></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.mostarofical><sk-switch sk-value=ctrl.previstoOficial sk-true-value=true sk-false-value=false sk-change=\"ctrl.visibleField('PREVISTOOFICIAL', ctrl.previstoOficial)\"></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.realizado><sk-switch sk-value=ctrl.realizado sk-true-value=true sk-false-value=false sk-change=\"ctrl.visibleField('REALIZADO', ctrl.realizado)\"></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.desvio><sk-switch sk-value=ctrl.diferenca sk-true-value=true sk-false-value=false sk-change=\"ctrl.visibleField('DIFERENCA', ctrl.diferenca)\"></sk-switch></sk-simple-item><sk-simple-item sk-label=Total><div class=btn-group><sk-icon class=\"btn btn-default\" style=\"min-width: 36px\" svg-src=/mge/assets/svg/pin-left.svg tooltip={{::ctrl.fixaresquerda}} tooltip-placement=bottom ng-click=\"ctrl.setColumnPinned('left')\" ng-class=\"{'btn-selecionado': ctrl.pinned == 'left'}\"></sk-icon><sk-icon class=\"btn btn-default\" style=\"min-width: 36px\" svg-src=/mge/assets/svg/circle.svg tooltip={{::ctrl.naofixar}} tooltip-placement=bottom ng-click=ctrl.setColumnPinned() ng-class=\"{'btn-selecionado': ctrl.pinned == undefined}\"></sk-icon><sk-icon class=\"btn btn-default\" style=\"min-width: 36px\" svg-src=/mge/assets/svg/pin-right.svg tooltip={{::ctrl.fixardireita}} tooltip-placement=bottom ng-click=\"ctrl.setColumnPinned('right')\" ng-class=\"{'btn-selecionado': ctrl.pinned == 'right'}\"></sk-icon></div></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/importaExportaPlanilha/cadastra-configuracao.tpl.html",
    "<sk-dataset entity-name=ConfiguracaoEstruturaPlanilha sk-dataset-created=ctrl.onDatasetCreated(dataset)></sk-dataset><sk-vbox sk-width=100% flex><sk-double-face-panel id=dblFacePanelConfiguracao sk-dataset=ctrl.dsConfiguracao sk-default-face-index=FORM_FACE creation-complete=ctrl.onDoubleFacePanelCreated(dblFacePanelConfiguracao)><sk-top-bar layout-padding><sk-hbox gap=5 flex><sk-grid-config sk-config-name=\"{{ ::ctrl.gridConfigId }}\"></sk-grid-config><sk-navigator dataset=ctrl.dsConfiguracao sk-show-add-button=true sk-add-function=ctrl.addConfiguracao(dblFacePanelConfiguracao) sk-show-copy-button=false sk-show-remove-button=true sk-show-save-button=true sk-show-cancel-button=true sk-show-edit-button=false sk-compact-btn-add></sk-navigator><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsConfiguracao></sk-rows-counter></div></sk-hbox></sk-top-bar><sk-face-one layout layout-padding flex><sk-vbox sk-width=100%><sk-form sk-dataset=ctrl.dsConfiguracao sk-columns=1 sk-inline=true class=compact-components sk-form-interceptor=ctrl flex></sk-form></sk-vbox><sk-vbox sk-width=100% gap=5><sk-form sk-columns=1 sk-inline=true class=compact-components sk-form-interceptor=ctrl model=ctrl.formDetalharPorValues properties=ctrl.formDetalharPorProperties flex></sk-form><div layout=row layout-align=\"start center\"><span style=\"font-size: 10px; font-weight: bold\" sk-i18n>Commons.PlanejamentoMetaOrcamento.helpLblDetPor</span></div></sk-vbox><sk-vbox sk-width=100% ng-show=\"ctrl.dimensoes.length > 0\" gap=5><sk-simple-form sk-columns=1 layout-padding><sk-simple-group sk-label=Commons.PlanejamentoMetaOrcamento.labelGroupDimensoes><div ng-repeat=\"dimensao in ctrl.dimensoes track by $index\" flex><sk-simple-item sk-height=40px><sk-hbox align=\"start center\" sk-width=100%><sk-hbox align=\"space-between center\" sk-width=40%><label class=form-input-label><div layout=row layout-align=end><span sk-i18n>Commons.PlanejamentoMetaOrcamento.labelEntidade</span>: <span style=\"margin-left: 5px; color:red; font-size: 23px\" class=required>*</span></div></label><sk-combobox sk-padding-right=5% sk-width=100% sk-value=dimensao.entidade sk-change=ctrl.dimensaoChanged() sk-allow-null=false sk-enabled=true sk-options=ctrl.dimensoesOptions flex></sk-combobox><sk-help-tip sk-text=Commons.PlanejamentoMetaOrcamento.helpLvlDimensoes sk-padding-right=5px sk-placement=bottom></sk-help-tip></sk-hbox><sk-hbox align=\"space-between center\" sk-width=30%><label class=form-input-label flex><div layout=row layout-align=end><span sk-i18n>Commons.PlanejamentoMetaOrcamento.labelCelCodigo</span>: <span style=\"margin-left: 5px; color:red; font-size: 23px\" class=required>*</span></div></label><sk-text-input sk-padding-right=5% sk-value=dimensao.celCodigo sk-change=ctrl.dimensaoChanged() sk-enabled=true sk-display-as-upper-case=true flex></sk-text-input><sk-help-tip sk-text=Commons.PlanejamentoMetaOrcamento.helpTipCelCodigo sk-padding-right=5px sk-placement=bottom></sk-help-tip></sk-hbox></sk-hbox></sk-simple-item></div></sk-simple-group></sk-simple-form></sk-vbox></sk-face-one><sk-face-two><sk-datagrid sk-dataset=ctrl.dsConfiguracao sk-config-name={{::ctrl.gridConfigId}} sk-margin=10 sk-editable=false sk-on-dbl-click=ctrl.onDblClickGrid(dblFacePanelConfiguracao)></sk-datagrid></sk-face-two></sk-double-face-panel></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/importaExportaPlanilha/importa-planilha.tpl.html",
    "<sk-vbox layout-align=space-between flex><sk-hbox layout-align=\"center center\" gap=8 layout-padding><sk-combobox sk-width=470px sk-value=ctrl.configSelected sk-allow-null=false sk-enabled=true sk-required=false sk-change=ctrl.buscarConfiguracoes sk-options=ctrl.configOptions></sk-combobox><button class=\"btn btn-default\" tooltip=Commons.PlanejamentoMetaOrcamento.lblExibirConfig tooltip-append-to-body=true tooltip-placement=right ng-click=ctrl.openCadastrarConfiguracao() sk-i18n><sk-icon font-icon=show-lines class=ng-isolate-scope></sk-icon></button> <button class=\"btn btn-default\" tooltip=Commons.PlanejamentoMetaOrcamento.lblEditarConfig tooltip-append-to-body=true tooltip-placement=right ng-click=ctrl.openCadastrarConfiguracao() default sk-i18n><sk-icon font-icon=pencil class=ng-isolate-scope></sk-icon></button></sk-hbox><sk-vbox><sk-file-input sk-file-key={{ctrl.chaveImport}} sk-value=ctrl.arquivoImport sk-required=true></sk-file-input></sk-vbox></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/importaExportaPlanilha/notificacoesImportacaoPopUp.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) sk-standalone><sk-dsfield-md name=nomeAba description=Commons.PlanejamentoMetaOrcamento.nomeAba user-type=S></sk-dsfield-md><sk-dsfield-md name=idCelula description=Commons.PlanejamentoMetaOrcamento.idCelula user-type=S></sk-dsfield-md><sk-dsfield-md name=descNotificacao description=Commons.PlanejamentoMetaOrcamento.descNotificacao user-type=S></sk-dsfield-md></sk-dataset><sk-vbox sk-width=100% flex><sk-datagrid sk-dataset=ctrl.dsNotificacoes sk-on-datagrid-loaded=ctrl.onDataGridLoaded(datagrid) sk-datagrid-interceptor=ctrl sk-editable=false></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/salvar-cenario/lista-cenarios.tpl.html",
    "<sk-dataset entity-name=ForecastMeta sk-dataset-created=ctrl.onDatasetCreated(dataset)></sk-dataset><sk-vbox flex><sk-hbox style=\"background-color: #e4e4e4; border-top: 1px solid #ccc;border-left: 1px solid #ccc;border-right: 1px solid #ccc\" layout-padding><sk-hbox gap=8><sk-grid-config sk-config-name=\"{{ ::ctrl.gridConfigId }}\"></sk-grid-config><sk-navigator dataset=ctrl.dsForecastMeta sk-show-navigation=true sk-show-add-button=false sk-show-copy-button=false sk-show-remove-button=false sk-show-cancel-button=false sk-show-save-button=false sk-edit-unique-record=false></sk-navigator></sk-hbox><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsForecastMeta></sk-rows-counter></div></sk-hbox><sk-datagrid sk-dataset=ctrl.dsForecastMeta sk-allow-multiple-selection=false sk-show-tour=false sk-editable=false sk-on-dbl-click=ctrl.aplicar() sk-config-name=\"{{ ::ctrl.gridConfigId }}\" flex></sk-datagrid></sk-vbox>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/salvar-cenario/salvar-cenario.tpl.html",
    "<sk-simple-form sk-columns=1 no-padding><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.lblNome sk-required=true><sk-hbox flex><sk-text-input sk-value=ctrl.nomeCenario flex></sk-text-input><button ng-click=ctrl.popUpSelecione() sk-i18n tooltip=\"Cenário existente\" tooltip-placement=bottom small default style=\"max-height: 25px\" font-icon=more></button></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.PlanejamentoMetaOrcamento.lblObservacao><sk-text-area sk-value=ctrl.observacao sk-height=190></sk-text-area></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/planejamentoMetaOrcamento/popup/visualizar-orcamento/visualizar-orcamento.tpl.html",
    "<sk-dataset entity-name=MetaAtual sk-dataset-created=ctrl.onDatasetCreated(dataset) metadata-interceptor=ctrl.interceptMetadata><sk-field pattern=*></sk-field></sk-dataset><sk-hbox flex layout=row><sk-double-face-panel id=dblFacePanel layout flex sk-dataset=ctrl.dsMetaAtual sk-default-face-index=GRID_FACE creation-complete=ctrl.onDoubleFacePanelCreated(dblFacePanel) sk-change-button-actions=ctrl.changeButtonActions><sk-top-bar layout=row layout-padding flex><sk-hbox gap=8 flex><sk-form-config sk-target-form-id=formMetaAtualId sk-config-name=mgecom.MetaAtual.configurableForm></sk-form-config><sk-navigator dataset=ctrl.dsMetaAtual sk-show-navigation=true sk-show-add-button=false sk-show-copy-button=false sk-show-remove-button=false sk-show-cancel-button=false sk-show-save-button=false sk-edit-unique-record=false></sk-navigator><div layout layout-align=\"end end\" flex><sk-rows-counter sk-dataset=ctrl.dsMetaAtual></sk-rows-counter></div></sk-hbox></sk-top-bar><sk-face-one layout flex><sk-configurable-form sk-uid=formMetaAtualId sk-dataset=ctrl.dsMetaAtual sk-api=ctrl.formApi sk-form-interceptor=ctrl columns=3></sk-configurable-form></sk-face-one><sk-face-two layout flex><sk-datagrid sk-dataset=ctrl.dsMetaAtual sk-grid-config=\"{{ ::ctrl.gridConfigId }}\" sk-editable=false sk-allow-multiple-selection=false sk-hide-cbx-column=false sk-disable-pagination=false sk-disable-search=false flex></sk-datagrid></sk-face-two></sk-double-face-panel></sk-hbox>");
  $templateCache.put("commons/popUpGadgets/popUpGadgets.tpl.html",
    "<iframe id=\"{{ 'popUpGadgets-iframe-' + ctrl.nugdg }}\" ng-src={{ctrl.src}} frameborder=0 scrolling=no sk-load=ctrl.onLoad() style=\"height: 100%\"></iframe>");
  $templateCache.put("commons/popUpParametrosEDI/popUpParametrosEDI.tpl.html",
    "<sk-simple-form sk-columns=1 sk-required=true sk-in-line=true><sk-simple-group ng-repeat=\"grupo in ctrl.dataValue.param\" sk-label={{grupo.descricao}}><sk-simple-item ng-repeat=\"item in grupo.param\" sk-label={{item.descricao}}><sk-text-input ng-if=\"item.tipo !='D' && item.tipo !='I' && item.tipo!='F'\" sk-value=item.value></sk-text-input><sk-date-input ng-if=\"item.tipo == 'D'\" sk-value=item.value></sk-date-input><sk-number-input ng-if=\"item.tipo == 'I'\" sk-precision=0 sk-value=item.value></sk-number-input><sk-number-input ng-if=\"item.tipo == 'F'\" sk-value=item.value></sk-number-input></sk-simple-item></sk-simple-group></sk-simple-form>");
  $templateCache.put("commons/preenchimentoquestionario/cabecalhoquestionario.tpl.html",
    "<div class=\"panel panel-default\"><div class=\"panel-heading panel-titulo\" sk-bg-color=gray-lighter></div><div class=panel-body><sk-hbox sk-width=100%><label ng-bind=$ctrl.textTitulo sk-font-size=16px></label></sk-hbox><sk-hbox sk-width=100% gap=5><sk-vbox sk-width=100% sk-padding-top=6px><label sk-font-size=16px ng-bind=$ctrl.textTituloDivisoria></label><sk-hbox sk-width=100% sk-height=2px sk-bg-color=black sk-padding-right=3></sk-vbox><sk-icon font-icon=circle-empty-question v=2 sk-font-size=40px></sk-icon></sk-hbox></div></div>");
  $templateCache.put("commons/preenchimentoquestionario/perguntaquestionario.tpl.html",
    "<div ng-switch=$ctrl.tipo layout=column flex><div ng-switch-when=text flex layout=column><sk-text-input ng-repeat=\"resposta in $ctrl.pergunta.resposta\" sk-change=$ctrl.onChange() sk-value=$ctrl.value[resposta.codResp]></sk-text-input></div><div ng-switch-when=textarea flex layout=column><sk-text-area ng-keydown=$ctrl.verificaQtdMaxLinhas($event,resposta.codResp) sk-change=$ctrl.onChange() ng-repeat=\"resposta in $ctrl.pergunta.resposta | limitTo:1\" sk-value=$ctrl.value[resposta.codResp]></sk-text-area></div><div ng-if=\"$ctrl.subTipo == 'column'\" ng-switch-when=radio flex layout={{$ctrl.subTipo}}><div ng-repeat=\"resposta in $ctrl.pergunta.resposta\" flex><sk-radio-input class=radio sk-option={{resposta.codResp}} sk-change=$ctrl.onChange() sk-value=$ctrl.value sk-name={{$ctrl.pergunta.codPerg}}><span ng-bind=resposta.descricao.$></span></sk-radio-input></div></div><div ng-if=\"$ctrl.subTipo == 'row'\" ng-switch-when=radio flex><div ng-repeat=\"resposta in $ctrl.pergunta.resposta\" flex class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2\"><sk-radio-input tooltip-placement=left tooltip={{resposta.descricao.$}} class=\"radio label-overflow\" sk-option={{resposta.codResp}} sk-change=$ctrl.onChange() sk-value=$ctrl.value sk-name={{$ctrl.pergunta.codPerg}}><span ng-bind=resposta.descricao.$></span></sk-radio-input></div></div><div ng-if=\"$ctrl.subTipo == 'column'\" ng-switch-when=checkbox flex layout={{$ctrl.subTipo}}><div ng-repeat=\"resposta in $ctrl.pergunta.resposta\" flex><sk-checkbox class=checkbox ng-model=$ctrl.value[resposta.codResp] ng-change=$ctrl.verificaQtdCamposMarcados(resposta.codResp) force-initial-value=false><span ng-bind=resposta.descricao.$></span></sk-checkbox></div></div><div ng-if=\"$ctrl.subTipo == 'row'\" ng-switch-when=checkbox flex><div ng-repeat=\"resposta in $ctrl.pergunta.resposta\" flex class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2\"><sk-checkbox tooltip-placement=left tooltip={{resposta.descricao.$}} class=checkbox ng-model=$ctrl.value[resposta.codResp] ng-change=$ctrl.verificaQtdCamposMarcados(resposta.codResp) force-initial-value=false><span ng-bind=resposta.descricao.$></span></sk-checkbox></div></div><div ng-switch-when=grupo flex layout=column><table><tr ng-repeat=\"resposta in $ctrl.pergunta.resposta\"><td align=right><sk-vbox><sk-hbox ng-if=\"$ctrl.pergunta.resposta.length > 1\"><span ng-bind=\"resposta.descricao.$ + ':'\"></span> <span ng-if=$ctrl.pergunta.obrigatoria sk-color=red>*</span></sk-hbox><sk-rate-input ng-if=$ctrl.isStarRating(resposta) sk-change=$ctrl.onChange() sk-value=$ctrl.value[resposta.codResp]></sk-rate-input></sk-vbox></td><td ng-if=!$ctrl.isStarRating(resposta) sk-padding=8px><sk-number-input sk-value=$ctrl.value[resposta.codResp] sk-change=$ctrl.onChange() sk-precision=2 sk-focus-out=$ctrl.verificaMaximoMinimo(resposta.codResp,$index)></sk-number-input></td></tr></table></div><div ng-switch-when=tabUnica flex layout=column><table class=table><thead><tr><th></th><th ng-repeat=\"opcao in $ctrl.pergunta.opcoes.opcao\"><span ng-bind=opcao.descricao.$></span></th></tr></thead><tbody><tr ng-repeat=\"topico in $ctrl.pergunta.topicos.topico\"><th scope=row><span ng-bind=topico.descricao.$></span> <span ng-if=$ctrl.pergunta.obrigatoria sk-color=red>*</span></th><td ng-repeat=\"resposta in topico.resposta\"><sk-radio-input sk-value=$ctrl.value[topico.codPerg] sk-change=$ctrl.onChange() sk-option=\"{{ resposta.opcao}}\" sk-name={{topico.codPerg}}></sk-radio-input></td></tr></tbody></table></div><div ng-switch-when=tabMultipla flex layout=column><table class=\"table reset-border-collapse\"><thead><tr><th></th><th ng-repeat=\"opcao in $ctrl.pergunta.opcoes.opcao\"><span ng-bind=opcao.descricao.$></span></th></tr></thead><tbody><tr ng-repeat=\"topico in $ctrl.pergunta.topicos.topico\"><th align=right><span ng-bind=\"topico.descricao.$ + ' ' + ($ctrl.pergunta.obrigatoria == 'true'?'*':'')\"></span></th><td class=text-center ng-repeat=\"resposta in topico.resposta\"><div><sk-checkbox ng-model=$ctrl.value[topico.codPerg][resposta.codResp] ng-change=\"$ctrl.verificaQtdCamposMarcados(resposta.codResp, topico.codPerg)\" force-initial-value=false></sk-checkbox></div></td></tr></tbody></table></div><div ng-switch-default><div ng-repeat=\"resposta in $ctrl.pergunta.resposta\"><span ng-bind=resposta.descricao.$></span></div></div></div>");
  $templateCache.put("commons/preenchimentoquestionario/questionario.tpl.html",
    "<sk-viewstack sk-selected-index=$ctrl.selectedIndexViewStack layout=column flex><sk-viewstack-content layout=column layout-align=\"center center\" flex><sk-icon svg-src=/mge/assets/svg/loading.svg class=spin></sk-icon><h3 sk-i18n>Commons.Questionario.messageCarregandoQuestionario</h3></sk-viewstack-content><sk-viewstack-content layout=column layout-align=\"center center\" overflow-y=auto flex><sk-vbox sk-min-height=260px layout-align=\"center center\" flex><sk-icon font-icon=notes-2 sk-font-size=60px></sk-icon><h3 class=text-bold sk-i18n>Commons.Questionario.messageRespondido</h3><h4 sk-i18n>Commons.Questionario.messageRespondaQuestionarios</h4><button default ng-click=$ctrl.editarRespotas() sk-margin-top=10px sk-i18n>Commons.Questionario.btnEditarRespostas</button></sk-vbox></sk-viewstack-content><sk-viewstack-content layout=column flex><sk-cabecalho-questionario sk-titulo-cabecalho={{$ctrl.dataProvider.descricao.$}} sk-titulo-divisoria=$ctrl.tituloDivisoria></sk-cabecalho-questionario><sk-wizard name={{$ctrl.wizardID}} sk-hide-indicators=true sk-on-cancel=$ctrl.onCancel() sk-on-finish=$ctrl.onFinish() sk-on-step-change=$ctrl.onStepChange($step) layout=column flex><sk-step ng-repeat=\"passo in $ctrl.dataProvider.passo track by $index\" sk-validate-step=$ctrl.validateStep(passo) sk-finalize=false layout=column flex><div class=questionario-pergunta ng-repeat=\"pergunta in passo.pergunta\" ng-show=$ctrl.isVisible(pergunta) ng-style=\"{'margin-left': $ctrl.getPerguntaMarginLeft(pergunta.codPerg)}\" ng-class=\"'pergunta-' + pergunta.codPerg\"><div layout=row class=\"text-bold pergunta-background\" layout-align=\"space-around center\" flex><sk-hbox align=\"start center\" flex><span class=pergunta-descricao ng-bind=\"pergunta.ordem + ')'\"></span><sk-hbox class=pergunta-descricao gap=5><span ng-bind=pergunta.descricao.$></span> <span class=required ng-if=$ctrl.pergObrigatoriaInfo[pergunta.codPerg]>*</span></sk-hbox></sk-hbox><div layout=row layout-align=\"end center\" ng-if=pergunta.aceitaObservacao sk-padding-right=8px><button ng-click=$ctrl.incluirObservacao(pergunta.codPerg) sk-i18n default tooltip=Commons.Questionario.messageAdicionarComentario ng-class=\"{'btn-danger': $ctrl.pertuntaPossuiComentario(pergunta.codPerg)}\" sk-padding=0px><sk-icon font-icon=comments no-margin></sk-icon></button></div></div><sk-pergunta-questionario sk-pergunta=pergunta sk-on-change=$ctrl.onChangeResposta() sk-value=$ctrl.respostas[pergunta.codPerg]></sk-pergunta-questionario></div></sk-step><sk-step layout=column ng-if=true sk-finalize=!$ctrl.ehPreVisualizacao layout-padding flex><div layout=column sk-min-height=260px flex><div layout=column layout-align=\"center center\" flex><sk-icon font-icon=tick sk-font-size=60px sk-color=success></sk-icon><h3 ng-show=!$ctrl.ehPreVisualizacao><sk-i18n sk-i18n-values=[$ctrl.index]>Commons.Questionario.messagePreenchimentoConcluido</sk-i18n></h3><h3 ng-show=$ctrl.ehPreVisualizacao sk-i18n>Commons.Questionario.messageConcluidaPreVisualizacao</h3></div><div ng-show=!$ctrl.ehPreVisualizacao layout=column flex><h5 sk-i18n>Commons.Questionario.messageAcrescenteObservacoes</h5><sk-text-area sk-value=$ctrl.observacao flex></sk-text-area></div></div></sk-step></sk-wizard></sk-viewstack-content></sk-viewstack><div class=questionario-footer></div>");
  $templateCache.put("commons/queryEditor/query-editor.tpl.html",
    "<meta charset=utf-8><sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-refresh-handler=ctrl.refreshHandler(request) metadata-interceptor=ctrl.metadataInterceptor sk-standalone><sk-dsfield-md name=PARAMETRO description=Commons.QueryEditor.txtParametro is-pk=true></sk-dsfield-md><sk-dsfield-md name=DESCRICAO description=Commons.QueryEditor.txtDescParametro user-type=S></sk-dsfield-md><sk-dsfield-md name=TIPO description=Commons.QueryEditor.cmbTipoParametro><sk-options><sk-option data=ENTITY label=Commons.QueryEditor.lblEntidade></sk-option><sk-option data=DP label=Commons.QueryEditor.lblPeriodo></sk-option><sk-option data=D label=Commons.QueryEditor.lblData></sk-option><sk-option data=W label=Commons.QueryEditor.lblTexto></sk-option><sk-option data=I label=Commons.QueryEditor.lblNumeroInteiro></sk-option><sk-option data=F label=Commons.QueryEditor.lblNumeroDecimal></sk-option><sk-option data=S label=Commons.QueryEditor.lblVerdadeiroFalso></sk-option><sk-option data=O label=Commons.QueryEditor.lblSingleList></sk-option></sk-options></sk-dsfield-md><sk-dsfield-md name=SALVAULTVALOR description=Commons.QueryEditor.chkSalvaUltValor presentation-type=S></sk-dsfield-md><sk-dsfield-md name=UNIDADEDADOS description=Commons.QueryEditor.unidadeDados></sk-dsfield-md><sk-dsfield-md name=CURRENTDATE description=Commons.QueryEditor.dataAtual presentation-type=S></sk-dsfield-md><sk-dsfield-md name=CHARLIMIT description=Commons.QueryEditor.limiteCaracteres user-type=I presentation-type=I></sk-dsfield-md><sk-dsfield-md name=DEFAULTVALUE description=Commons.QueryEditor.valorPadrao></sk-dsfield-md><sk-dsfield-md name=STARTVALUE description=Commons.QueryEditor.valorInicial user-type=I presentation-type=I></sk-dsfield-md><sk-dsfield-md name=DECIMALS description=Commons.QueryEditor.casasDecimais user-type=I></sk-dsfield-md><sk-dsfield-md name=ENDVALUE description=Commons.QueryEditor.valorFinal user-type=I presentation-type=I></sk-dsfield-md><sk-dsfield-md name=TRUEFALSE description=Commons.QueryEditor.valorPadrao presentation-type=S></sk-dsfield-md><sk-dsfield-md name=TIPODADO description=Commons.QueryEditor.tipoDado presentation-type=O user-type=O><sk-options><sk-option data=C label=Commons.QueryEditor.texto></sk-option><sk-option data=ENTITY label=Commons.QueryEditor.entidadeCampo></sk-option></sk-options></sk-dsfield-md><sk-dsfield-md name=TIPODADOTEXT description=Commons.QueryEditor.texto presentation-type=C user-type=C></sk-dsfield-md><sk-dsfield-md name=CAMPO description=Campo></sk-dsfield-md></sk-dataset><sk-vbox class=query-editor sk-height=100% gap=5 flex><div layout=row layout-align=\"space-between center\"><button class=\"btn btn-primary\" type=button tooltip-placement=right tooltip=Commons.QueryEditor.tooltipExecutar ng-click=ctrl.executarQuery(true) sk-i18n><sk-icon font-icon=play></sk-icon><sk-translate>Commons.QueryEditor.buttonExecutar</sk-translate></button><sk-combobox sk-value=ctrl.dataSource sk-options=ctrl.dataSources sk-width=200px tooltip-placement=left tooltip=Commons.QueryEditor.tooltipFonteDados ng-if=\"ctrl.dataSources.length > 1\" sk-allow-null=false sk-i18n></sk-combobox></div><sk-tabnavigator sk-selected-index=ctrl.selectedIndex><sk-tabnavigator-item><sk-i18n>Commons.QueryEditor.lblConsulta</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Commons.QueryEditor.lblParametro</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Commons.QueryEditor.lblResultado</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedIndex sk-on-select=ctrl.selectedStack sk-creation-policy=all flex><sk-viewstack-content layout-padding><sk-vbox style=height:310px flex><sk-simple-form sk-columns=4 no-padding><sk-hbox><sk-simple-item sk-label=Commons.QueryEditor.adicionarParametro sk-help-tip=Commons.QueryEditor.helpAdicionarParametro><sk-combobox sk-value=ctrl.variavel sk-options=ctrl.unidadeDadosOpt sk-disabled=\"ctrl.variavel === undefined\" sk-required=false></sk-combobox></sk-simple-item><sk-simple-item sk-label=\"\" style=\"padding-left: 10px\"><button class=\"btn btn-brand btn-novo-registro\" ng-class=\"{'sk-compact': compact}\" ng-disabled=\"ctrl.variavel === undefined || ctrl.variavel == ''\" ng-click=ctrl.insereValor() tooltip=\"Adicionar Parâmetro\" tooltip-append-to-body=true tooltip-placement=right><div class=icon-container><sk-icon font-icon=plus class=ng-isolate-scope><span ng-disabled=!enabled ng-show=\"visible !== false\" ng-class=\"[prefixIcon, prefixIcon + '-' + fontIcon, skClass]\" class=\"glyphicons glyphicons-plus\"></span></sk-icon></div><span class=\"entity-description ng-binding\" ng-bind=getEntityDescription()>Filtro</span></button></sk-simple-item></sk-hbox></sk-simple-form><sk-code-editor sk-mode=sql sk-value=ctrl.sql sk-change=ctrl.changeValue(value); layout flex style=height:310px></sk-code-editor></sk-vbox></sk-viewstack-content><sk-viewstack-content><sk-double-face-panel id=dblFacePanelParametros sk-dataset=ctrl.dsParameters creation-complete=ctrl.onDoubleFacePanelCreated(dblFacePanelParametros) sk-change-button-actions=ctrl.changeButtonActionsParametros sk-default-face-index=GRID_FACE style=min-height:310px><sk-top-bar layout=row layout-padding><sk-grid-config sk-config-name=\"{{ ::ctrl.gridConfigId }}\"></sk-grid-config><sk-navigator dataset=ctrl.dsParameters sk-show-navigation=true sk-show-add-button=true sk-show-copy-button=false sk-show-remove-button=true sk-show-cancel-button=true sk-show-refresh-button=false sk-show-save-button=true sk-edit-unique-record=false sk-compact-btn-add></sk-navigator><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsParameters></sk-rows-counter></div></sk-top-bar><sk-face-one><sk-vbox flex layout-top-padding><sk-form sk-dataset=ctrl.dsParameters columns=3></sk-form><sk-hbox><sk-form sk-dataset=ctrl.dsParameters sk-only-custom ng-if=ctrl.visibleForm columns=3 flex style=\"flex-grow: 1\"><sk-form-custom-item sk-field-name=SALVAULTVALOR sk-visible=ctrl.visibleSalvaUltValor></sk-form-custom-item><sk-form-custom-item sk-field-name=CURRENTDATE sk-visible=ctrl.visibleCurrentDate></sk-form-custom-item><sk-form-custom-item sk-field-name=CHARLIMIT sk-visible=ctrl.visibleCharLimit></sk-form-custom-item><sk-form-custom-item sk-field-name=DEFAULTVALUE sk-visible=ctrl.visibleDefaultVal></sk-form-custom-item><sk-form-custom-item sk-field-name=STARTVALUE sk-visible=ctrl.visibleStartVal></sk-form-custom-item><sk-form-custom-item sk-field-name=ENDVALUE sk-visible=ctrl.visibleEndVal></sk-form-custom-item><sk-form-custom-item sk-field-name=DECIMALS sk-visible=ctrl.visibleDecimals><sk-numeric-stepper sk-field-name=DECIMALS sk-dataset=ctrl.dsParameters sk-min-value=2 sk-max-value=86340></sk-numeric-stepper></sk-form-custom-item><sk-form-custom-item sk-field-name=TRUEFALSE sk-visible=ctrl.visibleTrueFalse></sk-form-custom-item><sk-form-custom-item sk-field-name=TIPODADO sk-visible=ctrl.visibleTipoDado></sk-form-custom-item><sk-form-custom-item sk-field-name=TIPODADOTEXT sk-visible=ctrl.visibleTipoDadoText></sk-form-custom-item></sk-form></sk-hbox><sk-simple-form sk-columns=3 ng-if=ctrl.visibleFormEntidade flex><sk-simple-item sk-label=Entidade sk-required=true ng-if=ctrl.visibleUnidadeDados><sk-pesquisa-input id=input-pes-unidade sk-entity-name=Instancia sk-value=ctrl.entityValue sk-field-name=NUINSTANCIA sk-enviroment-criteria=ctrl.getEntidadeCriteria() sk-show-description-input=true sk-use-local-field-name=true sk-entity-change=\"ctrl.onChangeEntidade('NUINSTANCIA')\"></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Campo sk-required=true ng-if=ctrl.visibleCampoEntidade><sk-pesquisa-input id=input-pes-campo sk-entity-name=Campo sk-value=ctrl.campoValue sk-field-name=NUCAMPO sk-enviroment-criteria=ctrl.getCampoCriteria() sk-entity-change=\"ctrl.onChangeEntidade('NUCAMPO')\"></sk-pesquisa-input></sk-simple-item></sk-simple-form></sk-vbox></sk-face-one><sk-face-two layout flex><sk-vbox flex><sk-datagrid sk-dataset=ctrl.dsParameters sk-config-name={{::ctrl.gridConfigId}} sk-editable=true sk-height=200></sk-datagrid></sk-vbox></sk-face-two></sk-double-face-panel></sk-viewstack-content><sk-viewstack-content layout-padding><sk-vbox><div id=ag-grid-result></div></sk-vbox></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/queryEditor/query-params-popup.tpl.html",
    "<sk-form properties=ctrl.formParams columns=2 sk-inline=true layout flex></sk-form>");
  $templateCache.put("commons/rateio/popup/informacoesrateiopopup.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-columns=3><sk-simple-item sk-label=Commons.Rateio.labelNumero><sk-number-input sk-value=ctrl.numeroUnico sk-precision=0 sk-enabled=false></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.Rateio.lblParceiro><sk-pesquisa-input sk-value=ctrl.pesqParceiro sk-entity-name=Parceiro sk-field-name=CODPARC sk-enabled=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Rateio.labelValor><sk-number-input sk-value=ctrl.numValor sk-enabled=false></sk-number-input></sk-simple-item></sk-simple-form><sk-rateio-panel sk-on-load-rateio-panel=ctrl.onLoadRateioPanel(rateioPanel) sk-rateio-mode=rateioFinanceiro sk-habilitar-confirmar=ctrl.habilitaConfirma(btnEnable) sk-confirmarcao-realizada-handler=ctrl.confirmarRateio() sk-parameters=ctrl.paramentrosRateioPanel sk-informativo=true flex></sk-rateio-panel></sk-vbox>");
  $templateCache.put("commons/rateio/popup/rateiopopup.tpl.html",
    "<sk-vbox flex><sk-simple-form sk-columns=1 sk-in-line=true><sk-simple-item style=\"width: 100%\" sk-label=Commons.Rateio.labelCriterioRateio><sk-hbox gap=5 style=\"align-items: center\"><sk-pesquisa-input sk-entity-name=CriterioRateio sk-field-name=CODCRITERIO sk-value=ctrl.pesqCriterioRateio sk-entity-change=ctrl.atualizarCriterioRateio(item)></sk-pesquisa-input><button default style=\"max-height: 25px\" ng-click=ctrl.atualizarCriterioRateio()>{{'Geral.buttonAplicar' | translate}}</button></sk-hbox></sk-simple-item></sk-simple-form><sk-rateio-panel sk-on-load-rateio-panel=ctrl.onLoadRateioPanel(rateioPanel) sk-rateio-mode=rateioFinanceiro sk-habilitar-confirmar=ctrl.habilitaConfirma(btnEnable) sk-show-btn-excluir=true sk-confirmarcao-realizada-handler=ctrl.finishRateio() sk-parameters=ctrl.paramentrosRateioPanel sk-eh-cadastro=true sk-informativo=ctrl.ehInformativo flex></sk-rateio-panel></sk-vbox>");
  $templateCache.put("commons/rateio/rateiopanel/rateiopanel.tpl.html",
    "<sk-vbox sk-height=100% sk-width=100% ng-if=ctrl.loadingParameters><sk-dataset entity-name={{::ctrl.EntityName}} sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=VLRRATEIO description=Commons.Rateio.labelValor user-type=F></sk-dsfield-md><sk-field pattern=*></sk-field></sk-dataset><sk-tabnavigator sk-selected-index=ctrl.selectedIndex ng-class=\"{'gray-background' : selectedIndex == 0}\"><sk-tabnavigator-item><sk-i18n>Commons.Rateio.labelManutencao</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Commons.Rateio.labelResultado</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedIndex layout=column flex sk-creation-policy=all><sk-viewstack-content layout=column flex><sk-double-face-panel id=doubleFacePanelRateioRecDesp creation-complete=ctrl.onDoubleFacePanelCreated(doubleFacePanelRateioRecDesp) sk-dataset=ctrl.dsRateio sk-change-button-actions=ctrl.changeButtonActions sk-default-face-index=GRID_FACE flex><sk-top-bar layout=row layout-padding><sk-navigator dataset=ctrl.dsRateio sk-show-refresh-button=false sk-show-add-button=!ctrl.ehInformativo sk-show-remove-button=!ctrl.ehInformativo sk-show-copy-button=true sk-save-handler=ctrl.saveHandlerRecDesp() sk-remove-handler=ctrl.removeHandlerRecDesp() sk-compact-btn-add></sk-navigator><sk-hbox gap=10><sk-hbox><button id=btnConfirmarRateio ng-if=ctrl.visibleBtnConfirm class=\"btn btn-default\" ng-click=ctrl.confirmarRateio() ng-disabled=!ctrl.btnConformarDisabled sk-i18n>Commons.Rateio.buttonConfirmar</button></sk-hbox><sk-hbox ng-if=ctrl.showBtnExcluir><button class=\"btn btn-default\" ng-click=ctrl.excluirRateio() ng-disabled=!ctrl.btnExcluirDisabled sk-i18n>Commons.Rateio.buttonExcluirRateio</button></sk-hbox><sk-hbox ng-if=ctrl.showBtnCopiar><button default sk-i18n ng-click=ctrl.abrirPesquisaCriterioRateio() tooltip=mgeos.Contratos.lbCopiarDe tooltip-placement=bottom><sk-i18n>mgeos.Contratos.lbCopiarDe</sk-i18n></button></sk-hbox></sk-hbox><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=ctrl.dsRateio></sk-rows-counter></div></sk-top-bar><sk-face-one style=\"overflow-y: auto\" layout-padding flex><sk-form sk-dataset=ctrl.dsRateio sk-fields-order=ctrl.fieldsFormOrder sk-form-interceptor=ctrl sk-inline=true flex><sk-form-custom-item sk-field-name=VLRRATEIO sk-visible=ctrl.mostrarInfoVlrRateio><sk-number-input sk-dataset=ctrl.dsRateio sk-field-name=VLRRATEIO sk-precision=9 sk-pretty-precision=2></sk-number-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODCENCUS><sk-pesquisa-input sk-allow-show-hierarchical-mode=true sk-value=ctrl.codCentroCusPesq sk-enabled=ctrl.enableCentroResultado sk-dataset=ctrl.dsRateio sk-entity-name=CentroResultado sk-field-name=CODCENCUS sk-value=ctrl.codCentroCusPesq></sk-pesquisa-input></sk-form-custom-item><sk-form-custom-item sk-field-name=AFERICAO><sk-number-input sk-dataset=ctrl.dsRateio sk-field-name=AFERICAO sk-enabled=ctrl.enabledAfericao></sk-number-input></sk-form-custom-item></sk-form></sk-face-one><sk-face-two layout=column><sk-datagrid sk-dataset=ctrl.dsRateio sk-editable=!ctrl.ehInformativo sk-datagrid-interceptor=ctrl sk-on-dbl-click=ctrl.onDblClickGrid(doubleFacePanelRateioRecDesp) sk-on-click=ctrl.btnConfirmar(true) sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid) sk-str-filtered-columns=NUMCONTRATO sk-config-name={{::ctrl.gridConfig}}></sk-datagrid></sk-face-two></sk-double-face-panel></sk-viewstack-content><sk-viewstack-content><sk-vbox layout-padding><sk-hbox><sk-radio-input sk-value=ctrl.rbgResultado sk-option=N sk-change=ctrl.atualizarGrafico(event)><sk-i18n>Commons.Rateio.lblNatureza</sk-i18n></sk-radio-input><sk-radio-input sk-value=ctrl.rbgResultado sk-option=CR sk-change=ctrl.atualizarGrafico(event)><sk-i18n>Commons.Rateio.lblCentroResultado</sk-i18n></sk-radio-input><sk-radio-input sk-value=ctrl.rbgResultado sk-option=P sk-change=ctrl.atualizarGrafico(event)><sk-i18n>Commons.Rateio.lblProjeto</sk-i18n></sk-radio-input></sk-hbox><sk-vbox flex><div id=graficoRateioID flex></div></sk-vbox></sk-vbox></sk-viewstack-content></sk-viewstack><sk-footer-bar layout-top-padding><sk-hbox class=headerTop align=\"center left\" layout-padding footer-container flex><div align=\"center left\" gap=5><span class=barraRateioPanel></span><sk-i18n>Commons.Rateio.labelRateado</sk-i18n>:<span class=valoresRateioPanel>{{ctrl.percRateado}}%</span> <span ng-if=ctrl.mostrarInfoVlrRateio class=valoresRateioPanel>{{ctrl.vlrRateado | currency: \"R$\"}}</span></div><div align=\"center left\" gap=5><span class=barraRateioPanel>|</span><sk-i18n>Commons.Rateio.labelARatear</sk-i18n>:<span class=valoresRateioPanel sk-color={{ctrl.colorARatear}}>{{ctrl.percARatear}}%</span> <span ng-if=ctrl.mostrarInfoVlrRateio class=valoresRateioPanel>{{ctrl.vlrARatear | currency: \"R$\"}}</span></div><div align=\"center left\" gap=5><span class=barraRateioPanel>|</span><sk-i18n>Commons.Rateio.labelValorTotal</sk-i18n>:<span class=valoresRateioPanel>{{ctrl.vlrTotal | currency: \"R$\"}}</span></div></sk-hbox></sk-footer-bar></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/CancelamentoCartaoPopup/CancelamentoCartaoPopup.tpl.html",
    "<sk-vbox><sk-hbox sk-width=100%><sk-vbox sk-width=70%><sk-hbox sk-width=100%><button id=btnCancelar sk-width=100% sk-height=35 ng-click=ctrl.solicitarCancelamento() ng-show=!ctrl.cancelamentoAdministrativo ng-disabled=!ctrl.btnCancelarEnabled><sk-icon svg-src=/mge/assets/svg/cancel.svg></sk-icon><sk-i18n>Commons.RecebimentoCartao.lblCancelar</sk-i18n></button><button id=btnCancelarAdmin sk-width=100% sk-height=35 ng-click=ctrl.solicitarCancelamentoAdminstrativo() ng-show=ctrl.cancelamentoAdministrativo ng-disabled=!ctrl.btnCancelarAdminEnabled><sk-icon svg-src=/mge/assets/svg/cancel.svg></sk-icon><sk-i18n>Commons.RecebimentoCartao.lblCancelar</sk-i18n></button></sk-hbox><sk-datagrid sk-dataset=ctrl.dsTransacao sk-only-custom sk-on-datagrid-loaded=ctrl.onDataGridLoaded(datagrid) sk-allow-multiple-selection=false sk-editable=false flex><sk-datagrid-custom-column sk-field-name=DTTRANSACAO sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTRANSACAO sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTAXA sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=QTDPARCELAS sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NSUCTF sk-visible=true></sk-datagrid-custom-column></sk-datagrid></sk-vbox><textarea class=cupom sk-width=30% cols=40 sk-height=360px ng-model=ctrl.cupom></textarea></sk-hbox><div id=progressBar class=progress-green ng-class=ctrl.progressBarClass ng-show=ctrl.progressBarVisible role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100><span>{{ctrl.txtProgressBar}}</span></div><sk-hbox class=width-full layout-align=\"end center\" gap=5><button default ng-click=ctrl.close()><sk-i18n>Commons.RecebimentoCartao.lblFechar</sk-i18n></button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/CancelamentoTransacaoPendentePopup/CancelamentoTransacaoPendentePopup.tpl.html",
    "<sk-vbox><sk-hbox sk-width=100%><sk-vbox sk-width=70%><sk-hbox sk-width=100%><button id=btnCancelar sk-width=100% sk-height=35 ng-click=ctrl.cancelar() ng-disabled=!ctrl.btnCancelarEnabled><sk-icon svg-src=/mge/assets/svg/cancel.svg></sk-icon><sk-i18n>Commons.RecebimentoCartao.lblCancelar</sk-i18n></button></sk-hbox><sk-datagrid sk-dataset=ctrl.dsTransacao sk-only-custom flex><sk-datagrid-custom-column sk-field-name=DTTRANSACAO sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTRANSACAO sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTAXA sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=QTDPARCELAS sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NSUCTF sk-visible=true></sk-datagrid-custom-column></sk-datagrid></sk-vbox><textarea class=cupom sk-width=30% cols=40 sk-height=360px ng-model=ctrl.cupom></textarea></sk-hbox><div id=progressBar ng-class=ctrl.progressBarClass ng-show=ctrl.progressBarVisible role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100 style=\"width: 100%; background-color:green !important\"><span>{{ctrl.txtProgressBar}}</span></div></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/CertificacaoTEFPopup/CertificacaoTEFPopup.tpl.html",
    "<sk-vbox gap=5><button id=btnExecute ng-click=ctrl.executarCertificacao() sk-width=100% sk-height=35><sk-i18n>Commons.RecebimentoCartao.lblExecutarCertificacao</sk-i18n></button><div ng-bind-html=ctrl.detalhe></div></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/PopUpVendaPOS/PopupVendaPos.tpl.html",
    "<sk-hbox><sk-dynaform sk-entity-name=TEF sk-default-mode=detail sk-on-dynaform-loaded=\"ctrl.onDynaformLoaded(dynaform, dataset)\" sk-dynaform-interceptor=ctrl sk-form-interceptor=ctrl sk-helper-class-name=br.com.sankhya.modelcore.dynaform.PopUpVendaPOSDynaformHelper sk-parent-dynaform=ctrl._dynaformFinanceiro sk-edit-unique-record=true sk-hide-tour=true></sk-dynaform></sk-hbox><sk-hbox sk-width=100% layout-align=\"end end\"><button primary ng-click=ctrl.closeButton()>{{ ::ctrl.labelButton }}</button></sk-hbox>");
  $templateCache.put("commons/recebimentocartao/PreferenciasRecebimentoPopup/PreferenciasRecebimentoCartaoPopup.tpl.html",
    "<sk-vbox><sk-simple-form ng-show=!ctrl.centraldeNotas sk-in-line=true sk-columns=1><sk-simple-item sk-label=Commons.Parcelamento.labelCalcularJuros><sk-switch sk-value=ctrl.calcularJuroAteDataAtual></sk-switch></sk-simple-item><sk-simple-item sk-label=Commons.Parcelamento.lblZerarJuroMulta><sk-switch sk-value=ctrl.zerarJuroMulta></sk-switch></sk-simple-item></sk-simple-form><sk-simple-form sk-in-line=true sk-columns=1><sk-simple-group sk-label=Commons.RecebimentoCartao.lblDadosDeBaixa><sk-simple-item sk-label=Commons.RecebimentoCartao.lblEmpresaBaixa><sk-pesquisa-input sk-entity-name=Empresa sk-field-name=CODEMP sk-value=ctrl.empresa sk-width=100%></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblContaBaixa><sk-pesquisa-input sk-entity-name=ContaBancaria sk-field-name=CODCTABCOINT sk-enviroment-criteria=ctrl.getEnvironmentCriteriaContaBancaria() sk-value=ctrl.contaBancaria sk-width=100%></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblTOPBaixa><sk-pesquisa-input sk-entity-name=TipoOperacao sk-field-name=CODTIPOPER sk-enviroment-criteria=ctrl.getEnvironmentCriteriaTipoOperacaoBaixa() sk-value=ctrl.tipOperBaixa sk-width=100%></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.Baixa.labelLancamento><sk-pesquisa-input sk-entity-name=HistoricoBancario sk-field-name=CODLANC sk-value=ctrl.lancamento sk-width=100%></sk-pesquisa-input></sk-simple-item></sk-simple-group><sk-simple-group sk-label=Commons.RecebimentoCartao.lblTituloRemanescente ng-show=!ctrl.centraldeNotas><sk-radio-input class=radio-pref sk-value=ctrl.vencTitRemanescente sk-option={{::ctrl.VENCIMENTO_MAIS_PROXIMO}} sk-enabled=enabled><sk-i18n>Commons.RecebimentoCartao.lblVencMaisProximo</sk-i18n></sk-radio-input><sk-radio-input class=radio-pref sk-value=ctrl.vencTitRemanescente sk-option={{::ctrl.VENCIMENTO_MAIS_DISTANTE}} sk-enabled=enabled><sk-i18n>Commons.RecebimentoCartao.lblVencMaisDistante</sk-i18n></sk-radio-input><sk-radio-input class=radio-pref sk-value=ctrl.vencTitRemanescente sk-option={{::ctrl.HOJE}} sk-enabled=enabled><sk-i18n>Commons.RecebimentoCartao.lblHoje</sk-i18n></sk-radio-input></sk-simple-group><sk-simple-group sk-label=Commons.RecebimentoCartao.lblTitRenegociados ng-show=!ctrl.centraldeNotas><sk-simple-item sk-label=Commons.RecebimentoCartao.lblUsarRenegociacao><sk-hbox gap=5><sk-switch sk-value=ctrl.usarRenegociacao sk-change=ctrl.changeRenegociacao()></sk-switch><sk-help-tip sk-text=Commons.RecebimentoCartao.msgUsarRenegociacaoNoReceb></sk-help-tip></sk-hbox></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblTOPRenegociacao><sk-pesquisa-input sk-entity-name=TipoOperacao sk-field-name=CODTIPOPER sk-value=ctrl.tipOperReneg sk-enviroment-criteria=ctrl.getEnvironmentCriteriaTipoOperacao() sk-width=100%></sk-pesquisa-input></sk-simple-item></sk-simple-group></sk-simple-form></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/RecebimentoCartaoAdminPopup/RecebimentoCartaoAdminPopup.tpl.html",
    "<sk-vbox sk-width=100% sk-height=500px class=main-vbox><sk-simple-form id=formRecebimento sk-in-line=true sk-columns=1 sk-width=100%><sk-simple-item sk-label=Commons.RecebimentoCartao.lblTipoTitulo sk-width=100%><sk-pesquisa-input sk-entity-name=TipoTitulo sk-field-name=CODTIPTIT sk-value=ctrl.pesqTipoTitulo sk-enviroment-criteria=ctrl.environmentCriteriaTipTit() sk-entity-change=ctrl.afterPopulateHandler sk-width=100% sk-enabled=ctrl.enabledPesqTipoTitulo></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblVlrTransacao sk-width=100%><sk-number-input sk-value=ctrl.vlrTransacaoInput sk-precision=2 sk-enabled=ctrl.enabledVlrTransacaoInput sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblQtdParcelas sk-width=100%><sk-number-input id=idQtdParcelasInput sk-value=ctrl.qtdParcelasInput sk-enabled=ctrl.enableQtdParcelasInput sk-precision=0 sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblNsu sk-width=100%><sk-number-input id=idNsuInput sk-value=ctrl.nsuInput sk-precision=0 sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblNumComprovanteVenda sk-width=100%><sk-number-input id=idNumComprovanteVendaInput sk-value=ctrl.numComprovanteVendaInput sk-precision=0 sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblAutorizacao sk-width=100%><sk-number-input id=idAutorizacaoInput sk-value=ctrl.autorizacaoInput sk-precision=0 sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblBandeira sk-width=100%><sk-text-input id=idBandeiraInput sk-value=ctrl.bandeiraInput sk-size=30 sk-width=100%></sk-text-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblDtTransacao sk-width=100%><sk-date-time-input id=idDtTransacaoInput sk-value=ctrl.dtTransacaoInput sk-width=100%></sk-date-time-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblRede sk-width=100%><sk-text-input id=idRedeInput sk-value=ctrl.redeInput sk-width=100%></sk-text-input></sk-simple-item></sk-simple-form><sk-hbox sk-width=100%><button default id=btnRegistrar ng-click=ctrl.registrar() sk-width=50% sk-height=35px><sk-i18n>Commons.RecebimentoCartao.lblRegistrarRecebimento</sk-i18n></button> <button default id=btnRegistrar ng-click=ctrl.excluir() sk-width=50% sk-height=35px><sk-i18n>Commons.RecebimentoCartao.lblExcluirRecebimento</sk-i18n></button></sk-hbox><sk-datagrid sk-dataset=ctrl.dsTransacao sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-field-name=CODTIPTIT sk-cell-formatter=ctrl.buildLabelTipoTitulo sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTRANSACAO sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=QTDPARCELAS sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=BANDEIRA sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NSUCTF sk-description=Commons.RecebimentoCartao.lblNsu sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NSUAUTORIZADORA sk-description=Commons.RecebimentoCartao.lblNumComprovanteVenda sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CODAPROVACAO sk-description=Commons.RecebimentoCartao.lblAutorizacao sk-visible=true></sk-datagrid-custom-column></sk-datagrid><sk-hbox class=width-full><p class=linhas-totais ng-bind-html=ctrl.linhaTotais></p><sk-hbox class=width-midle layout-align=\"end center\" gap=5><button default ng-click=ctrl.fechar()><sk-i18n>Commons.RecebimentoCartao.lblFechar</sk-i18n></button> <button primary ng-click=ctrl.gerarRecebimentoCartao() ng-show=ctrl.visibleBtnConcluir><sk-i18n>Geral.lblConcluir</sk-i18n></button></sk-hbox></sk-hbox></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/RecebimentoCartaoPopup/RecebimentoCartaoPopup.tpl.html",
    "<sk-vbox sk-width=100% sk-height=400px class=main-vbox style=\"overflow-y: auto\"><sk-hbox sk-width=100%><sk-vbox sk-width=70%><sk-simple-form id=formRecebimento sk-in-line=true sk-columns=1 sk-width=100%><sk-simple-item sk-label=Commons.RecebimentoCartao.lblTipoTitulo sk-width=100%><sk-pesquisa-input sk-entity-name=TipoTitulo sk-field-name=CODTIPTIT sk-value=ctrl.pesqTipoTitulo sk-enviroment-criteria=ctrl.environmentCriteriaTipTit() sk-entity-change=ctrl.afterPopulateHandler sk-width=100% sk-enabled=ctrl.enabledPesqTipoTitulo sk-change=ctrl.disableBtnReceberCancelar()></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblVlrTransacao sk-width=100%><sk-number-input sk-value=ctrl.vlrTransacaoInput sk-precision=2 sk-enabled=ctrl.enabledVlrTransacaoInput sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoCartao.lblQtdParcelas sk-width=100%><sk-number-input id=idQtdParcelasInput sk-value=ctrl.qtdParcelasInput sk-enabled=ctrl.enableQtdParcelasInput sk-precision=0 sk-width=100%></sk-number-input></sk-simple-item></sk-simple-form><button default id=btnReceberCancelar ng-disabled=!ctrl.enableBtnReceberCancelar ng-click=ctrl.receberCancelar() sk-width=100% sk-height=35px>{{ctrl.lblReceberCancelar}}</button><sk-datagrid sk-dataset=ctrl.dsTransacao sk-editable=false sk-only-custom flex><sk-datagrid-custom-column sk-field-name=CODTIPTIT sk-cell-formatter=ctrl.buildLabelTipoTitulo sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CARTAO sk-cell-formatter=ctrl.buildLabelCartao sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTRANSACAO sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=QTDPARCELAS sk-cell-formatter=ctrl.buildCelFLoat sk-visible=true></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=BANDEIRA sk-visible=true></sk-datagrid-custom-column></sk-datagrid></sk-vbox><textarea class=cupom sk-width=30% cols=40 sk-height=360px ng-model=ctrl.cupom></textarea></sk-hbox><div id=progressBar ng-class=ctrl.progressBarClass class=progress-green ng-show=ctrl.visibleProgressBar role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100><span>{{ctrl.txtProgressBar}}</span></div><sk-hbox class=width-full><p class=linhas-totais ng-bind-html=ctrl.linhaTotais></p><sk-hbox class=width-midle layout-align=\"end center\" gap=5><button default ng-click=ctrl.fechar() ng-show=\"!ctrl.wizardBaixa && ctrl.visibleBtnFechar\"><sk-i18n>Commons.RecebimentoCartao.lblFechar</sk-i18n></button> <button primary ng-click=ctrl.gerarRecebimentoCartao() ng-show=ctrl.visibleBtnConcluir><sk-i18n>Geral.lblConcluir</sk-i18n></button></sk-hbox></sk-hbox></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/RecebimentoPixTEF/RecebimentoPixTEFPopup.tpl.html",
    "<sk-vbox sk-width=100% sk-height=400px class=main-vbox><sk-simple-form id=formRecebimento sk-in-line=true sk-columns=1 sk-width=100%><sk-simple-item sk-label=Commons.RecebimentoPixTEF.lblTipoTitulo sk-width=100%><sk-pesquisa-input sk-entity-name=TipoTitulo sk-field-name=CODTIPTIT sk-value=ctrl.formConfig.pesqTipoTitulo.value sk-enviroment-criteria=ctrl.environmentCriteriaTipTit() sk-width=100% sk-enabled=ctrl.formConfig.pesqTipoTitulo.enabled></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoPixTEF.lblVlrTransacao sk-width=100%><sk-number-input sk-value=ctrl.formConfig.vlrTransacaoInput.value sk-precision=2 sk-enabled=ctrl.formConfig.vlrTransacaoInput.enabled sk-width=100%></sk-number-input></sk-simple-item><sk-simple-item sk-label=Commons.RecebimentoPixTEF.lblQtdParcelas sk-width=100%><sk-number-input id=idQtdParcelasInput sk-value=ctrl.formConfig.qtdParcelasInput.value sk-enabled=ctrl.formConfig.qtdParcelasInput.enabled sk-precision=0 sk-width=100%></sk-number-input></sk-simple-item></sk-simple-form><textarea class=cupom cols=30 sk-height=100% readonly ng-model=ctrl.cupom>\n" +
    "				</textarea><div id=progressBar ng-class=ctrl.progressBarClass class=progress-green ng-show=ctrl.visibleProgressBar role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100><span>{{ctrl.txtProgressBar}}</span></div><sk-hbox class=width-full layout-align=\"end center\" gap=5><button default ng-click=ctrl.cancelar() ng-disabled=!ctrl.btnCancelarEnabled ng-if=!ctrl.recebimentoEfetuado><sk-i18n>Commons.RecebimentoPixTEF.lblBtnCancelar</sk-i18n></button> <button primary ng-click=ctrl.receber() ng-disabled=!ctrl.btnReceberEnabled ng-if=!ctrl.recebimentoEfetuado><sk-i18n>Commons.RecebimentoPixTEF.lblBtnReceber</sk-i18n></button> <button primary ng-click=ctrl.concluir() ng-disabled=!ctrl.btnConcluirEnabled ng-if=ctrl.recebimentoEfetuado><sk-i18n>Commons.RecebimentoPixTEF.lblBtnConcluir</sk-i18n></button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/recebimentocartao/RecebimentoPixTEF/estorno/EstornoPixTEFPopup.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=NUFIN description=Commons.RecebimentoPixTEF.headerFinanceiro user-type=I></sk-dsfield-md><sk-dsfield-md name=STATUS description=Commons.RecebimentoPixTEF.headerStatus user-type=S></sk-dsfield-md><sk-dsfield-md name=IDENTIFICACAO description=Commons.RecebimentoPixTEF.headerIdentificacao user-type=I></sk-dsfield-md><sk-dsfield-md name=DTTRANSACAO description=Commons.RecebimentoPixTEF.headerDtTransacao user-type=D></sk-dsfield-md><sk-dsfield-md name=VLRTRANSACAO description=Commons.RecebimentoPixTEF.headerVlrTransacao user-type=F></sk-dsfield-md><sk-dsfield-md name=NSU description=Commons.RecebimentoPixTEF.headerNSU user-type=S></sk-dsfield-md><sk-dsfield-md name=CUPOM user-type=S></sk-dsfield-md></sk-dataset><sk-vbox sk-width=100% sk-height=100%><sk-datagrid sk-dataset=ctrl.dsTransacao sk-only-custom flex sk-editable=false sk-allow-multiple-selection=false sk-on-datagrid-loaded=ctrl.onDatagridLoaded(datagrid)><sk-datagrid-custom-column sk-field-name=NUFIN sk-visible=true sk-text-align=center sk-width=100></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=STATUS sk-visible=true sk-text-align=center sk-cell-formatter=ctrl.buildLabelStatus></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=IDENTIFICACAO sk-visible=true sk-text-align=center></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DTTRANSACAO sk-visible=true sk-text-align=center></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VLRTRANSACAO sk-visible=true sk-text-align=center></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=NSU sk-visible=true sk-text-align=center sk-cell-formatter=ctrl.buildLabelNSU></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUPOM sk-visible=false></sk-datagrid-custom-column></sk-datagrid><textarea class=cupom cols=30 sk-height=220px ng-model=ctrl.cupom></textarea><div id=progressBar class=\"progress-green progress-bar progress-bar-striped active\" ng-show=ctrl.progressBarVisible role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100><span>{{ctrl.txtProgressBar}}</span></div><sk-hbox class=width-full layout-align=\"end center\" gap=5><button default ng-disabled=!ctrl.btnFecharEnabled ng-click=ctrl.close()><sk-i18n>Commons.RecebimentoPixTEF.lblFechar</sk-i18n></button> <button default ng-if=!ctrl.estornosFinalizados ng-disabled=!ctrl.btnEstornarEnabled ng-click=ctrl.estornar()><sk-i18n>Commons.RecebimentoPixTEF.lblBtnEstornar</sk-i18n></button> <button default ng-if=ctrl.estornosFinalizados ng-click=ctrl.concluir()><sk-i18n>Commons.RecebimentoPixTEF.lblBtnConcluir</sk-i18n></button></sk-hbox></sk-vbox>");
  $templateCache.put("commons/rentabilidadepopup/rentabilidadepopup.tpl.html",
    "<sk-vbox style=\"height: 100%; width: 100%\" creation-complete=ctrl.carregaInfos()><sk-dataset id=dsProdutosComCusto sk-refresh-handler=\"\" sk-dataset-created=ctrl.onDatasetCreatedComCusto(dataset) sk-standalone><sk-dsfield-md name=MARCA description=Commons.Rentabilidade.headerMarca type=S><sk-dsfield-md name=PRECOTAB description=Commons.Rentabilidade.headerPrecoTabela type=S><sk-dsfield-md name=VLRLIQ description=Commons.Rentabilidade.headerVlrLiquido type=S><sk-dsfield-md name=VLRUNIT description=Commons.Rentabilidade.headerVlrUnitario type=S><sk-dsfield-md name=QTDNEG description=Commons.Rentabilidade.headerQtde type=S><sk-dsfield-md name=VLRTOT description=Commons.Rentabilidade.headerVlrTotal type=S><sk-dsfield-md name=DESCRPROD description=Commons.Rentabilidade.headerDescricaoProduto type=S><sk-dsfield-md name=CODPROD description=Commons.Rentabilidade.headerCodProd type=I><sk-dsfield-md name=LEGENDA description=\"Margem de Contribuição\" type=S><sk-dsfield-md name=FATURAMENTO description=\"\" type=F sk-visible=false><sk-dsfield-md name=CUSTOMERCVEND description=\"\" type=F sk-visible=false><sk-dsfield-md name=GASTOVAR description=\"\" type=F sk-visible=false><sk-dsfield-md name=GASTOFIXO description=\"\" type=F sk-visible=false><sk-dsfield-md name=MARGEMCONTRIB description=\"\" type=F sk-visible=false><sk-dsfield-md name=LUCRO description=\"\" type=F sk-visible=false><sk-dsfield-md name=CORFUNDO description=\"\" type=S sk-visible=false><sk-dsfield-md name=CORFONTE description=\"\" type=S sk-visible=false></sk-dataset><sk-dataset id=dsProdutosSemCusto sk-refresh-handler=\"\" sk-dataset-created=ctrl.onDatasetCreatedSemCusto(dataset) sk-standalone><sk-dsfield-md name=MARCA description=Commons.Rentabilidade.headerMarca type=S><sk-dsfield-md name=PRECOTAB description=Commons.Rentabilidade.headerPrecoTabela type=S><sk-dsfield-md name=VLRLIQ description=Commons.Rentabilidade.headerVlrLiquido type=S><sk-dsfield-md name=VLRUNIT description=Commons.Rentabilidade.headerVlrUnitario type=S><sk-dsfield-md name=QTDNEG description=Commons.Rentabilidade.headerQtde type=S><sk-dsfield-md name=VLRTOT description=Commons.Rentabilidade.headerVlrTotal type=S><sk-dsfield-md name=DESCRPROD description=Commons.Rentabilidade.headerDescricaoProduto type=S><sk-dsfield-md name=CODPROD description=Commons.Rentabilidade.headerCodProd type=I><sk-dsfield-md name=LEGENDA description=\"Margem de Contribuição\" type=S><sk-dsfield-md name=FATURAMENTO description=\"\" type=F sk-visible=false><sk-dsfield-md name=CUSTOMERCVEND description=\"\" type=F sk-visible=false><sk-dsfield-md name=GASTOVAR description=\"\" type=F sk-visible=false><sk-dsfield-md name=GASTOFIXO description=\"\" type=F sk-visible=false><sk-dsfield-md name=MARGEMCONTRIB description=\"\" type=F sk-visible=false><sk-dsfield-md name=LUCRO description=\"\" type=F sk-visible=false><sk-dsfield-md name=CORFUNDO description=\"\" type=S sk-visible=false><sk-dsfield-md name=CORFONTE description=\"\" type=S sk-visible=false></sk-dataset><div style=\"text-align: center; padding-bottom:1%\" layout=row ng-if=ctrl.podeExibirGrafico><h7 ng-if=!ctrl.mostraBtnRentabilidadeNota style=\"text-align: center; font-size: 13px; font-weight: 600; width: fit-content\" flex><b>{{ctrl.chartTitle}}</b></h7><div ng-if=ctrl.mostraBtnRentabilidadeNota layout=row layout-align=end flex><h7 style=\"font-size: 13px; font-weight: 600; width: fit-content\" flex><b>{{ctrl.chartTitle}}</b></h7><button deafault ng-click=ctrl.carregaChartNota() sk-i18n tooltip=Commons.Rentabilidade.buttonMostrarRentabilidade tooltip-append-to-body=true tooltip-placement=bottom style=\"min-width: fit-content; background-color: white; border: none; text-decoration: underline\">Commons.Rentabilidade.buttonMostrarRentabilidade</button></div></div><div id=graficoRentabilidade style=\"height: 33.5%; width: 100%\" ng-if=ctrl.podeExibirGrafico><sk-margem-contrib-chart fat=ctrl.fat cmv=ctrl.cmv gv=ctrl.gv gf=ctrl.gf mc=ctrl.mc lucro=ctrl.lucro show-info=true></sk-margem-contrib-chart></div><sk-tab flex layout><sk-tab-item sk-i18n label=Commons.Rentabilidade.headerProdComCusto layout flex><sk-vbox flex><sk-hbox gap=5 layout-padding><sk-grid-config sk-config-name={{ctrl.gridConfigNameComCusto}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.datagridComCusto sk-custom-entity=true sk-title=Commons.Rentabilidade.titleAnaliseRentabilidade></sk-grid-printer></sk-hbox><sk-datagrid sk-config-name={{ctrl.gridConfigNameComCusto}} sk-dataset=ctrl.datasetComCusto sk-datagrid-interceptor=ctrl sk-on-datagrid-loaded=ctrl.onDatagridLoadedComCusto(datagrid) sk-allow-multiple-selection=false sk-editable=false sk-disable-tour=true sk-only-custom sk-on-click=ctrl.datasetListenerComCusto()><sk-datagrid-custom-column sk-field-name=MARCA sk-visible=true><sk-datagrid-custom-column sk-field-name=PRECOTAB sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRLIQ sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRUNIT sk-visible=true><sk-datagrid-custom-column sk-field-name=QTDNEG sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRTOT sk-visible=true><sk-datagrid-custom-column sk-field-name=DESCRPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=CODPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=LEGENDA></sk-datagrid></sk-vbox></sk-tab-item><sk-tab-item ng-show=ctrl.dadosDatasetSemCusto sk-i18n label=Commons.Rentabilidade.headerProdSemCusto layout flex><sk-vbox flex><sk-hbox gap=5 layout-padding><sk-grid-config sk-config-name={{ctrl.gridConfigNameSemCusto}}></sk-grid-config><sk-grid-printer sk-grid-controller=ctrl.datagridSemCusto sk-custom-entity=true sk-title=Commons.Rentabilidade.titleAnaliseRentabilidade></sk-grid-printer></sk-hbox><sk-datagrid sk-config-name={{ctrl.gridConfigNameSemCusto}} sk-dataset=ctrl.datasetSemCusto sk-datagrid-interceptor=ctrl sk-on-datagrid-loaded=ctrl.onDatagridLoadedSemCusto(datagrid) sk-allow-multiple-selection=false sk-editable=false sk-disable-tour=true sk-only-custom sk-on-click=ctrl.datasetListenerSemCusto()><sk-datagrid-custom-column sk-field-name=MARCA sk-visible=true><sk-datagrid-custom-column sk-field-name=PRECOTAB sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRLIQ sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRUNIT sk-visible=true><sk-datagrid-custom-column sk-field-name=QTDNEG sk-visible=true><sk-datagrid-custom-column sk-field-name=VLRTOT sk-visible=true><sk-datagrid-custom-column sk-field-name=DESCRPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=CODPROD sk-visible=true><sk-datagrid-custom-column sk-field-name=LEGENDA></sk-datagrid></sk-vbox></sk-tab-item></sk-tab><sk-hbox ng-show=\"ctrl.temPreferencia && !ctrl.showMessageMargemNota\" style=\"width: 100%; margin-top: 5px\"><span id=labelPreferInfo style=\"margin-left: 5px\">{{ctrl.preferLabel}}</span> <span id=infoPreferencia class=boxValor style=\"margin-left: 5px; text-align: left; padding-left: 5px\">{{ctrl.preferInfo}}</span></sk-hbox><sk-hbox ng-show=ctrl.showMessageMargemNota style=\"width: 100%; margin-top: 5px; color:#FF0000; font-weight: 700\"><span style=\"margin: auto\">{{ctrl.messageMargemNota}}</span></sk-hbox></sk-vbox>");
  $templateCache.put("commons/resultadoGerLotePopUp/resultadoGerLotePopUp.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetStatusServicosCreated(dataset) sk-standalone><sk-dsfield-md name=TITULO description=Commons.Liberacoes.headerRetorno><sk-dsfield-md name=VALOR description=Commons.Liberacoes.headerValor></sk-dataset><sk-dataset sk-dataset-created=ctrl.onDatasetAvisosCreated(dataset) sk-standalone><sk-dsfield-md name=NRONOTA description=Commons.Liberacoes.headerNroNota><sk-dsfield-md name=DESCRICAO description=ctrl.description></sk-dataset><sk-accordion id=container close-others=true><sk-accordion-group heading={{::ctrl.labelStatusServicosAtivos}} is-open=true is-disabled=false ng-if=ctrl.mostraStatusServicos><sk-datagrid sk-dataset=ctrl.dsStatusServicos sk-on-datagrid-loaded=ctrl.onDatagridStatusServicosLoaded(datagrid) sk-disable-tour=true sk-editable=false sk-allow-multiple-selection=false sk-only-custom><sk-datagrid-custom-column sk-field-name=TITULO></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=VALOR></sk-datagrid-custom-column></sk-datagrid></sk-accordion-group><sk-accordion-group heading={{::ctrl.labelAvisos}} is-disabled=false ng-if=ctrl.mostraAvisos><sk-hbox gap=5 flex><sk-hdividedbox sk-margin=10 flex><sk-divided-content flex><sk-datagrid sk-dataset=ctrl.dsAvisos sk-on-datagrid-loaded=ctrl.onDatagridAvisosLoaded(datagrid) sk-datagrid-interceptor=ctrl sk-on-click=ctrl.onClick() sk-disable-tour=true sk-editable=false sk-allow-multiple-selection=false sk-only-custom sk-order-columms=ctrl.orderColumns><sk-datagrid-custom-column sk-field-name=NRONOTA></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=DESCRICAO></sk-datagrid-custom-column></sk-datagrid></sk-divided-content><sk-divided-content ng-if=ctrl.mostraDetalhes flex><div class=\"panel panel-default\"><div class=\"panel-heading heading-detalhes\"><sk-hbox flex><h4 class=\"panel-title title-detalhes\">{{ ctrl.detalhesProblema }}</h4><sk-icon class=close-detalhes svg-src=/mge/assets/svg/cancel.svg ng-click=ctrl.fecharDetalhes()></sk-icon></sk-hbox></div><div class=panel-body><sk-text-area sk-value=ctrl.textoDetalhesProblema sk-enabled=false></sk-text-area></div></div></sk-divided-content></sk-hdividedbox></sk-hbox></sk-accordion-group><sk-accordion-group heading={{::ctrl.labelLiberacoes}} is-disabled=false ng-if=ctrl.mostraLiberacoes><sk-liberacoes sk-data=ctrl.dataLiberacoes sk-parent-dataset=ctrl.dsLibLimites></sk-liberacoes></sk-accordion-group></sk-accordion>");
  $templateCache.put("commons/solucoespopup/confirmacaoPopup/confirmacaoPopup.tpl.html",
    "<div class=container-detalhes><div class=header><div class=left><strong>Confirmação de Compra</strong></div></div><br><div><strong style=\"font-size: 15px\">Informações do Pedido:</strong><br><ul style=\"list-style: none; font-size: 14px; display: inline\"><li><strong>Empresa:</strong> {{ctrl.confirmacaoCompra.empresa}}</li><li><strong>Usuário do Download:</strong> {{ctrl.confirmacaoCompra.accountEmail}}</li><li><strong>{{ctrl.lblTipoPacote}}:</strong> {{ctrl.confirmacaoCompra.nomePacote}}</li><li><strong>Valor da instalação:</strong> {{ctrl.confirmacaoCompra.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 0,00'}}</li><li ng-if=\"ctrl.tipoPacote == 'EXTENSAO'\"><strong>Valor da mensalidade:</strong> <span style=\"font-size: 15px; margin-top: 5px\">{{ctrl.confirmacaoCompra.valorMensal.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}) || 'R$ 0,00'}}</span></li><li ng-if=\"ctrl.tipoPacote == 'EXTENSAO'\"><strong>Valor da transação adicional:</strong> <span style=\"font-size: 15px; margin-top: 5px\">{{ctrl.confirmacaoCompra.valorTransacao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 0,00'}}</span></li><li ng-if=\"ctrl.tipoPacote != 'EXTENSAO'\"><strong>Forma de Pagamento:</strong> Boleto Bancário</li></ul></div><br><div class=checkbox><sk-checkbox id=checkConfirmacao ng-model=ctrl.checkConfirmacao><span ng-if=\"ctrl.tipoPacote != 'EXTENSAO'\">Estou ciente que ao confirmar, o pacote será imediatamente instalado no sistema e será gerado uma fatura no valor de {{ctrl.confirmacaoCompra.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}} para minha empresa. </span><span ng-if=\"ctrl.tipoPacote == 'EXTENSAO'\">Estou ciente que ao confirmar, o pacote será imediatamente baixado e minha empresa será cobrada pelo autor da solução os valores descritos nas informações do pedido.</span></sk-checkbox></div><div class=checkbox style=\"display: flex;margin-top: 3px\"><sk-checkbox id=checkTermoUso ng-model=ctrl.checkTermoUso></sk-checkbox><span>Estou ciente e de acordo com os <a href=https://docs.google.com/document/d/1K8BsOODBj7rxvUf-x10ktNmBRptHbOcr-9t2KAOwxaY target=_blank>termos de uso</a> da loja de soluções.</span></div></div>");
  $templateCache.put("commons/solucoespopup/detalhes-pacote/detalhesPacote.tpl.html",
    "<sk-vbox sk-position=relative class=detalhes-pacote flex><sk-vbox sk-position=absolute sk-height=100% sk-width=100% sk-overflow-y=auto><sk-hbox sk-width=100% ng-if=\"ctrl.detalhes != null\"><sk-vbox sk-width=50% layout-padding=10px><sk-hbox sk-margin-top=20px sk-margin-bottom=25px><button ng-click=ctrl.voltar() class=\"btn btn-sm btn-white\"><i class=\"fas fa-angle-left\"></i> {{ \"Commons.SolucoesPopup.botaoVoltarText\" | translate }}</button></sk-hbox><sk-vbox sk-height=auto sk-width=100%><img ng-src={{ctrl.imagens}}></sk-vbox><sk-hbox sk-margin-top=20px style=\"justify-content: space-between; padding: 0 10px\"><sk-vbox><p class=dadosPacoteTitle sk-i18n>Commons.SolucoesPopup.lblNumeroPacote</p><span>{{ctrl.id}}</span><p class=dadosPacoteTitle sk-i18n>Commons.SolucoesPopup.lblTipo</p><span>{{ctrl.tipo}}</span><p class=dadosPacoteTitle sk-i18n>Commons.SolucoesPopup.lblBancoDeDados</p><span>{{ctrl.banco}}</span></sk-vbox><sk-vbox><p class=dadosPacoteTitle sk-i18n>Commons.SolucoesPopup.lblPublicado</p><span>{{ctrl.dhPublicacao | date:dd/MM/yyyy}}</span><p class=dadosPacoteTitle sk-i18n>Commons.SolucoesPopup.lblCategoria</p><span>{{ctrl.categoria}}</span></sk-vbox></sk-hbox><sk-hbox sk-margin-top=20px><sk-vbox><sk-hbox><h2 class=nomePacote>Contatos do Autor / Suporte</h2></sk-hbox><sk-hbox ng-class=dados-pacote ng-if=\"ctrl.autor != 'Sankhya Place' && ctrl.companyId != '647'\"><sk-vbox style=\"max-width: 300px; padding: 0 5px\"><div ng-if=ctrl.companyAutor><p class=dadosPacoteTitle>Autor:</p><span>{{ctrl.companyAutor}}</span></div><div ng-if=ctrl.companyEmail><p class=dadosPacoteTitle>E-mail:</p><span>{{ctrl.companyEmail}}</span></div></sk-vbox><sk-vbox><div ng-if=ctrl.companyTelefone><p class=dadosPacoteTitle>Telefone:</p><span>{{ctrl.companyTelefone}}</span></div><div ng-if=ctrl.modeloSuporte><p class=dadosPacoteTitle>Modelo de Suporte:</p><span>{{ctrl.modeloSuporte}}</span></div></sk-vbox></sk-hbox><sk-hbox><sk-vbox><div ng-if=\"ctrl.autor == 'Sankhya Place' || ctrl.companyId == '647'\"><strong>Este pacote tem código aberto e não possui suporte. Após a instalação, você pode fazer as melhorias e ajustes se necessários.</strong></div></sk-vbox></sk-hbox></sk-vbox></sk-hbox></sk-vbox><sk-vbox sk-width=50% layout-padding=10px><div class=cabecalho><sk-hbox sk-margin-bottom=20px><h2 class=nomePacote>{{ctrl.nome}}</h2></sk-hbox><sk-hbox sk-margin-bottom=20px style=\"justify-content: space-between\"><sk-hbox sk-width=50% style=\"justify-content: space-between\"><small>{{ctrl.numDownloads}} <i class=\"fa fa-download\"></i> </small><small><i class=\"fa fa-users\"></i> {{ctrl.nota}} <span class=stars ng-bind-html=\"ctrl.nota | drawstars\"></span></small></sk-hbox><span class=statusPacote><i class=\"fa fa-check-circle\"></i><sk-i18n>Commons.SolucoesPopup.lblStatusRevisado</sk-i18n></span></sk-hbox><sk-hbox sk-margin-bottom=20px; style=\"justify-content: space-between\"><sk-hbox ng-if=ctrl.isGratis><span style=\"font-size: 15px; margin-top: 5px\" ng-if=ctrl.isGratis>Grátis</span></sk-hbox><sk-hbox ng-if=!ctrl.isGratis><p><strong>Valor da instalação: </strong><span style=\"font-size: 15px; margin-top: 5px\">{{ctrl.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 0,00'}}</span></p></sk-hbox><sk-hbox class=install><button ng-disabled=ctrl.instalando ng-if=\"!ctrl.instalando && !ctrl.instalado && !ctrl.erroInstalacao\" ng-click=ctrl.confirmInstalacao() class=\"btn btn-md\"><i class=\"fas fa-download\"></i> <span><sk-i18n>Commons.SolucoesPopup.lblBotaoInstalar</sk-i18n></span></button> <button ng-disabled=\"ctrl.erroInstalacao || ctrl.instalado\" ng-if=\"ctrl.instalando || ctrl.instalado || ctrl.erroInstalacao\" ng-class=\"{'erroInstalacao':ctrl.erroInstalacao}\" click=ctrl.confirmInstalacao() class=\"btn btn-md\"><i ng-class=\"{'fa fa-spinner fa-spin':ctrl.instalando, 'fas fa-check':ctrl.instalado,'fas fa-times':ctrl.erroInstalacao}\"></i> <span>{{ctrl.textoInstall}}</span></button></sk-hbox></sk-hbox><sk-vbox sk-margin-top=20px; ng-bind-html=ctrl.descricao></sk-vbox></div></sk-vbox></sk-hbox><div ng-if=\"ctrl.detalhes == null\"><h3 class=msg-erro>&nbsp;Esta solução foi inativada da loja de soluções. Realize a busca por outras soluções semelhantes.</h3></div></sk-vbox></sk-vbox>");
  $templateCache.put("commons/solucoespopup/lista-pacotes/pacotes.tpl.html",
    "<sk-vbox gap=5 flex><sk-search-input sk-value=ctrl.termoBuscado sk-placeholder=Commons.SolucoesPopup.searchInputPlaceHolder i18n></sk-search-input><sk-vbox sk-position=relative flex><sk-vbox sk-position=absolute sk-height=100% sk-width=100% sk-overflow-y=auto class=scrool-panel><div class=container-solucoes><div class=solucoes><sk-package-item ng-click=ctrl.detalhesPacote(solucao) ng-repeat=\"solucao in ctrl.solucoesExibidas | filter:ctrl.onDestSearchTermChange\" sk-value=solucao style=\"cursor: pointer\"></sk-package-item></div></div></sk-vbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/solucoespopup/packageItem/packageitem.tpl.html",
    "<sk-hbox gap=2 class=\"solucao pointer\" flex><sk-vbox style=\"flex-shrink: 0\" sk-border-radius=8px sk-width=95px sk-height=95px ng-class=solucao.background class=imageContainer><sk-hbox sk-width=100% sk-height=100% align=\"center start\"><sk-vbox ng-if=solucao.instalado sk-width=100% class=pacote-instalado align=\"center center\"><span sk-i18n>Commons.SolucoesPopup.lblPacoteInstalado</span></sk-vbox></sk-hbox><div class=icon><sk-icon v=2 font-icon={{solucao.iconTipo}} style=\"color: white\"></sk-icon></div><sk-hbox sk-width=100% sk-height=100% align=\"center end\"><sk-hbox sk-width=100% class=pacote-preco align=\"center center\"><span>{{solucao.isGratis == true ? 'Grátis' : solucao.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span></sk-hbox></sk-hbox></sk-vbox><sk-vbox sk-margin-left=5px gap=5px sk-width=100%><sk-hbox sk-margin-left=8px gap=5px><span class=tituloSolucao ng-bind=solucao.nome></span></sk-hbox><small><sk-hbox flex><sk-hbox sk-margin-left=5px gap=5px><sk-icon v=2 font-icon={{solucao.iconCategoria}} sk-margin-right=3px></sk-icon><span ng-bind=solucao.categoria></span></sk-hbox></sk-hbox></small><small><sk-hbox flex><sk-hbox sk-margin-left=5px gap=5px><sk-icon v=2 font-icon=users sk-margin-right=3px></sk-icon><span ng-bind=solucao.autor></span></sk-hbox></sk-hbox></small><small ng-class=\"{'oracle': solucao.banco === 'ORACLE', 'mssql': solucao.banco === 'MSSQL','both': solucao.banco === 'AMBOS'}\"><sk-hbox flex><sk-hbox sk-margin-left=5px gap=5px><sk-icon v=2 font-icon=database sk-margin-right=3px></sk-icon><span ng-bind=solucao.banco></span></sk-hbox></sk-hbox></small><small><sk-hbox flex><sk-hbox sk-margin-left=5px gap=5px><sk-icon v=2 font-icon=square-download sk-margin-right=3px></sk-icon><span ng-bind=solucao.numDownloads></span></sk-hbox></sk-hbox></small></sk-vbox></sk-hbox>");
  $templateCache.put("commons/solucoespopup/solucoes.tpl.html",
    "<sk-wizard sk-hide-indicators=true sk-hide-btn-cancel=true sk-selected-index=0 sk-creation-policy=auto layout flex><sk-step flex sk-hide-previous=true sk-hide-next=true sk-hide-finish=true sk-template-url=commons/solucoespopup/lista-pacotes/pacotes.tpl.html sk-controller=PacotesController sk-controller-as=ctrl></sk-step><sk-step flex sk-hide-previous=true sk-hide-next=true sk-hide-finish=true sk-template-url=commons/solucoespopup/detalhes-pacote/detalhesPacote.tpl.html sk-controller=DetalhesPacoteController sk-controller-as=ctrl></sk-step></sk-wizard>");
  $templateCache.put("commons/solucoespopup/termoUsoPopup/termoUsoPopup.tpl.html",
    "<div class=container-detalhes><div class=header><div><sk-icon font-icon=download-alt class=icone></sk-icon></div><div class=left><strong>Confirmação de Download</strong></div></div><br><div class=checkbox style=\"display: flex\"><sk-checkbox id=checkConfirmacao ng-model=ctrl.checkConfirmacao ng-click=ctrl.isChecked()></sk-checkbox><span>Estou ciente e de acordo com os <a href=https://docs.google.com/document/d/1K8BsOODBj7rxvUf-x10ktNmBRptHbOcr-9t2KAOwxaY target=_blank>termos de uso</a> da loja de soluções.</span></div></div>");
  $templateCache.put("commons/statusProcessoPopUp/statusProcessoPopUp.tpl.html",
    "<sk-dataset sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=status description=Commons.StatusProcesso.lblStatus></sk-dsfield-md><sk-dsfield-md name=codDescEmp description=Commons.StatusProcesso.lblEmpresa sk-visible-field=ctrl.ocultarCodDescEmp></sk-dsfield-md><sk-dsfield-md name=dataImportacao description=\"Data Processamento\" sk-visible-field=ctrl.mostrarCamposContabECD></sk-dsfield-md><sk-dsfield-md name=dataProcessamento description=\"Data Processamento\" sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=inicioPeriodo description=\"Periodo Inicial\" sk-visible-field=ctrl.mostrarCamposContabECD></sk-dsfield-md><sk-dsfield-md name=fimPeriodo description=\"Periodo Final\" sk-visible-field=ctrl.mostrarCamposContabECD></sk-dsfield-md><sk-dsfield-md name=uf description=Commons.StatusProcesso.lblUF sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=dataInicio description=Commons.StatusProcesso.lblDtInicial sk-visible-field=!ctrl.ocultarPeriodo></sk-dsfield-md><sk-dsfield-md name=dataFim description=Commons.StatusProcesso.lblDtFinal sk-visible-field=!ctrl.ocultarPeriodo></sk-dsfield-md><sk-dsfield-md name=dhExecIni description=Commons.StatusProcesso.lblDhExecInicial sk-visible-field=!ctrl.mostrarCamposContabECD></sk-dsfield-md><sk-dsfield-md name=dhExecFim description=Commons.StatusProcesso.lblDhExecFinal sk-visible-field=!ctrl.mostrarCamposContabECD></sk-dsfield-md><sk-dsfield-md name=tempoExec description=Commons.StatusProcesso.lblTempoExec></sk-dsfield-md><sk-dsfield-md name=versaoLayout description=\"Versao layout\" sk-visible-field=ctrl.mostrarCamposContabECD></sk-dsfield-md><sk-dsfield-md name=usuario description=Commons.StatusProcesso.lblUsuario></sk-dsfield-md><sk-dsfield-md name=empresa description=Commons.StatusProcesso.lblEmpresa sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=resultado description=Commons.StatusProcesso.lblResultado sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=statusLabel description=Commons.StatusProcesso.lblStatusLabel sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=codigo description=Commons.StatusProcesso.lblCodigo sk-visible-field=false></sk-dsfield-md><sk-dsfield-md name=nomeArquivo description=Commons.StatusProcesso.lblNomeArquivo sk-visible-field=false></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-accordion flex ng-show=!ctrl.mostrarHistorico close-others=false><sk-accordion-group heading={{ctrl.lblParametrosEntrada}} ng-hide=ctrl.ocultarParamsEntrada is-open=true><sk-simple-form sk-columns=2 sk-margin-top=8px><sk-simple-item sk-label=Commons.StatusProcesso.lblEmpresa ng-hide=ctrl.ocultarEmpresa><sk-pesquisa-input sk-entity-name=Empresa sk-value=ctrl.empresa sk-enabled=false></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Commons.StatusProcesso.lblUF ng-hide=ctrl.ocultarUF><sk-combobox sk-value=ctrl.uf sk-allow-null=true sk-options=ctrl.optionsUF sk-width=100% sk-enabled=false></sk-combobox></sk-simple-item><sk-simple-item sk-i18n sk-label=Commons.StatusProcesso.lblPeriodo ng-hide=ctrl.ocultarPeriodo><sk-date-period-input sk-value=ctrl.periodo sk-enabled=false></sk-date-period-input></sk-simple-item><sk-simple-item sk-label=Commons.StatusProcesso.lblUsuario ng-hide=ctrl.ocultarUsuario><sk-pesquisa-input sk-entity-name=Usuario sk-value=ctrl.usuarioLogado sk-enabled=false></sk-pesquisa-input></sk-simple-item></sk-simple-form><div id=rastreamentoEstoque ng-init=ctrl.criaCampos()></div></sk-accordion-group><sk-accordion-group heading={{ctrl.lblAndamento}} is-open=true><sk-text-area sk-value=ctrl.andamento sk-enabled=false></sk-text-area></sk-accordion-group></sk-accordion><div class=progress ng-show=!ctrl.mostrarHistorico><div ng-class=ctrl.progressBarClass role=progressbar aria-valuenow=100 aria-valuemin=0 aria-valuemax=100 style=\"width: 100%; background-color:green !important\" id=progressBar><span>{{ctrl.execucao}}</span></div></div><sk-vbox flex ng-show=ctrl.mostrarHistorico><sk-hbox><button tooltip=Commons.StatusProcesso.toolTipAtualizar class=\"btn btn-sk-sm btn-default\" ng-click=ctrl.getHistoryOfProcess() tooltip-placement=bottom sk-i18n sk-margin=\"3px 5px\"><sk-icon font-icon=refresh></sk-icon></button> <button tooltip=Commons.StatusProcesso.toolTipExcluirProcessos class=\"btn btn-sk-sm btn-default\" ng-click=ctrl.excluirProcessos() tooltip-placement=bottom sk-i18n sk-margin=\"3px 0px\"><sk-icon font-icon=bin></sk-icon></button><div flex layout-align=\"end center\"><sk-rows-counter style=float:right sk-margin-bottom=5px sk-dataset=ctrl.dsProcessos></sk-rows-counter></div></sk-hbox><sk-datagrid sk-dataset=ctrl.dsProcessos sk-allow-multiple-selection=false sk-editable=false sk-on-click=ctrl.validarAcoes() sk-on-dbl-click=ctrl.verAndamento() sk-enable-toolpanel=false></sk-datagrid></sk-vbox><sk-vbox><sk-hbox layout-align=\"end center\" sk-margin-top=8px><sk-right-bottom-bar><button class=\"btn btn-brand\" default ng-click=ctrl.baixarArquivo() tooltip-placement=bottom tooltip=Commons.StatusProcesso.btnBaixarArquivo ng-disabled=!ctrl.btnVisualizarAtivo ng-show=ctrl.mostrarDownloadArquivo sk-i18n><sk-icon font-icon=download-alt></sk-icon><span sk-i18n=Commons.StatusProcesso.btnBaixarArquivo></button> <button class=\"btn btn-danger\" default ng-click=ctrl.pararGeracao() tooltip=Commons.StatusProcesso.btnParar tooltip-placement=bottom ng-disabled=!ctrl.btnPararAtivo sk-i18n><sk-icon font-icon=stop></sk-icon><span sk-i18n=Commons.StatusProcesso.btnParar></button> <button class=\"btn btn-primary\" default ng-click=ctrl.verHistorico() sk-i18n ng-show=!ctrl.mostrarHistorico><sk-icon font-icon=show-lines></sk-icon><span sk-i18n=Commons.StatusProcesso.btnVerHistorico></button> <button class=\"btn btn-primary\" default ng-click=ctrl.verAndamento() sk-i18n ng-show=ctrl.mostrarHistorico><sk-icon font-icon=message-forward></sk-icon><span sk-i18n=Commons.StatusProcesso.btnVerAndamento></button> <button class=\"btn btn-danger\" default ng-click=ctrl.fechar() sk-i18n><sk-icon font-icon=home></sk-icon><span sk-i18n=Commons.StatusProcesso.btnFechar></button></sk-right-bottom-bar></sk-hbox></sk-vbox></sk-vbox>");
  $templateCache.put("commons/vendaMais/popupVendaMais.tpl.html",
    "<div id=vendaMaisPopup style=width:100%></div>");
  $templateCache.put("commons/verticaltimeline/verticaltimeline.tpl.html",
    "<div layout=row layout-align=\"center center\"><div><section class=conference-timeline><div class=conference-center-line></div><div class=conference-timeline-content><div class=timeline-article layout=row layout-align=\"start center\" ng-repeat=\"c in etapas\"><div class=meta-date ng-style=\"{'background-color': c.farol}\" tooltip={{::c.descricao}} tooltip-placement=bottom></div><div class=content-right-container><div class=label-data ng-bind=c.data></div><div class=content-right ng-class=\"{'alert-danger': ev.status == 'F', 'alert-success': ev.status == 'S'}\" layout=row layout-align=\"end center\" ng-repeat=\"ev in c.eventos\"><sk-hbox flex><sk-hbox flex><sk-hbox gap=5 align=\"start center\"><sk-icon sk-margin-left=2px svg-src=/mge/assets/svg/{{ev.icone}}.svg></sk-icon><div class=descricao-evento ng-bind=ev.descricao.$ tooltip={{ev.descricao.$}} tooltip-placement=bottom></div></sk-hbox></sk-hbox><sk-vbox gap=2 align=\"start end\"><span class=tipo-evento>{{ev.tipo.$}}</span><sk-icon ng-if=ev.texto.$ ng-style=\"ev.status == 'F' && {'color':'#e54326'}\" font-icon=\"{{ev.status == 'F' ? 'alert' : 'info-sign'}}\" sk-i18n tooltip={{ev.texto.$}} tooltip-placement=bottom></sk-icon></sk-vbox></sk-hbox></div></div></div></div></section></div></div>");
  $templateCache.put("commons/visualizadorCustoProducao/visualizadorCustoProducao.tpl.html",
    "<sk-dataset sk-dataset-created=\"ctrl.onDatasetCreated('dsCustoTotal', dataset)\" sk-standalone><sk-dsfield-md width=100 name=DESCRITEM description=Commons.VisualizadorCustoProducao.txtItem read-only=true user-type=S order=1></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVQTD description=Commons.VisualizadorCustoProducao.txtCusPrevQtd read-only=true user-type=F order=4></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVLOTE description=Commons.VisualizadorCustoProducao.txtCusPrevLotePadrao read-only=true user-type=F order=5></sk-dsfield-md><sk-dsfield-md width=100 name=TIPCUS visible></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=\"ctrl.onDatasetCreated('dsCustoMp', dataset)\" sk-standalone><sk-dsfield-md width=100 name=DESCRPROD description=Commons.VisualizadorCustoProducao.txtItem read-only=true user-type=S order=1></sk-dsfield-md><sk-dsfield-md width=100 name=QTDPREV description=Commons.VisualizadorCustoProducao.txtQuantidadePrevista read-only=true user-type=I order=2></sk-dsfield-md><sk-dsfield-md width=100 name=CUSATUAL description=Commons.VisualizadorCustoProducao.txtCustoAtual read-only=true user-type=F order=3></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVQTD description=Commons.VisualizadorCustoProducao.txtCusPrevQtd read-only=true user-type=F order=4></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVLOTE description=Commons.VisualizadorCustoProducao.txtCusPrevLotePadrao read-only=true user-type=F order=5></sk-dsfield-md><sk-dsfield-md width=100 name=CODPROD description=Commons.VisualizadorCustoProducao.labelCodProd read-only=true user-type=I order=6></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=\"ctrl.onDatasetCreated('dsCustoCT', dataset)\" sk-standalone><sk-dsfield-md width=100 name=DESCRPROD description=Commons.VisualizadorCustoProducao.txtItem read-only=true user-type=S order=1></sk-dsfield-md><sk-dsfield-md width=100 name=QTDPREV description=Commons.VisualizadorCustoProducao.txtQuantidadePrevista read-only=true user-type=I order=2></sk-dsfield-md><sk-dsfield-md width=100 name=CUSATUAL description=Commons.VisualizadorCustoProducao.txtCustoAtual read-only=true user-type=F order=3></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVQTD description=Commons.VisualizadorCustoProducao.txtCusPrevQtd read-only=true user-type=F order=4></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVLOTE description=Commons.VisualizadorCustoProducao.txtCusPrevLotePadrao read-only=true user-type=F order=5></sk-dsfield-md><sk-dsfield-md width=100 name=CODPROD description=Commons.VisualizadorCustoProducao.labelCodProd read-only=true user-type=I order=6></sk-dsfield-md></sk-dataset><sk-dataset sk-dataset-created=\"ctrl.onDatasetCreated('dsCustoTarifa', dataset)\" sk-standalone><sk-dsfield-md width=100 name=DESCRPROD description=Commons.VisualizadorCustoProducao.txtItem read-only=true user-type=S order=1></sk-dsfield-md><sk-dsfield-md width=100 name=QTDPREV description=Commons.VisualizadorCustoProducao.txtQuantidadePrevista read-only=true user-type=I order=2></sk-dsfield-md><sk-dsfield-md width=100 name=CUSATUAL description=Commons.VisualizadorCustoProducao.txtCustoAtual read-only=true user-type=F order=3></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVQTD description=Commons.VisualizadorCustoProducao.txtCusPrevQtd read-only=true user-type=F order=4></sk-dsfield-md><sk-dsfield-md width=100 name=CUSPREVLOTE description=Commons.VisualizadorCustoProducao.txtCusPrevLotePadrao read-only=true user-type=F order=5></sk-dsfield-md><sk-dsfield-md width=100 name=CODPROD description=Commons.VisualizadorCustoProducao.labelCodProd read-only=true user-type=I order=6></sk-dsfield-md></sk-dataset><sk-vbox flex><sk-double-face-panel id=dbfCusto sk-dataset=ctrl.dsCustoTotal sk-default-face-index=GRID_FACE><sk-top-bar layout=row layout-padding><sk-grid-config sk-config-name=\"{{ ::ctrl.gridCustoTotalConfig }}\"></sk-grid-config><h8 sk-padding-top=5px sk-margin-left=20px style=\"font-size: 12px\" sk-i18n>Commons.VisualizadorCustoProducao.labelTipoCusto</h8><sk-combobox sk-margin-top=2px sk-margin-left=5px sk-value=ctrl.tipCusto sk-options=ctrl.optionsTipCusto sk-width=175px sk-change=ctrl.onTipoCustoChange()></sk-combobox></sk-top-bar><sk-face-one><sk-vbox ng-show=\"ctrl.showCusto('M')\" flex><sk-hbox gap=8 class=well white><sk-grid-config sk-config-name={{::ctrl.gridCustoMpConfig}} tooltip-placement=right></sk-grid-config><h7 style=\"text-align: center; margin-top: 8px\" flex><b sk-i18n>Commons.VisualizadorCustoProducao.titleMP</b></h7><sk-rows-counter sk-dataset=ctrl.dsCustoMp></sk-rows-counter></sk-hbox><sk-datagrid sk-grid-config={{::ctrl.gridCustoMpConfig}} sk-dataset=ctrl.dsCustoMp sk-editable=false><sk-datagrid-custom-column sk-field-name=QTDPREV sk-cell-formatter=ctrl.customCellFormatter><sk-datagrid-custom-column sk-field-name=CUSPREVQTD sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSPREVLOTE sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSATUAL sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column></sk-datagrid-custom-column></sk-datagrid><sk-hbox><div sk-padding-left=5px><h7 style=\"text-align: center\"><b sk-i18n>Commons.VisualizadorCustoProducao.labelMP</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevQtd}}</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevpadrao}}</b></h7></div></sk-hbox></sk-vbox><sk-vbox ng-show=\"ctrl.showCusto('R')\" flex><sk-hbox gap=8 class=well white><sk-grid-config sk-config-name={{::ctrl.gridCustoCTConfig}} tooltip-placement=right></sk-grid-config><h7 style=\"text-align: center; margin-top: 8px\" flex><b sk-i18n>Commons.VisualizadorCustoProducao.titleRecursosCT</b></h7><sk-rows-counter sk-dataset=ctrl.dsCustoCT></sk-rows-counter></sk-hbox><sk-datagrid sk-grid-config={{::ctrl.gridCustoCTConfig}} sk-dataset=ctrl.dsCustoCT sk-editable=false><sk-datagrid-custom-column sk-field-name=CUSPREVQTD sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSPREVLOTE sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSATUAL sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column></sk-datagrid><sk-hbox><div sk-padding-left=5px><h7 style=\"text-align: center\"><b sk-i18n>Commons.VisualizadorCustoProducao.labelRecursosCT</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevQtd}}</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevpadrao}}</b></h7></div></sk-hbox></sk-vbox><sk-vbox ng-show=\"ctrl.showCusto('T')\" flex><sk-hbox gap=8 class=well white><sk-grid-config sk-config-name={{::ctrl.gridCustoTarifaConfig}} tooltip-placement=right></sk-grid-config><h7 style=\"text-align: center; margin-top: 8px; margin-left: 200px\" flex><b sk-i18n>Commons.VisualizadorCustoProducao.titleTarifasCIP</b></h7><sk-rows-counter sk-margin-left=200px sk-dataset=ctrl.dsCustoTarifa></sk-rows-counter></sk-hbox><sk-datagrid sk-grid-config={{::ctrl.gridCustoTarifaConfig}} sk-dataset=ctrl.dsCustoTarifa sk-editable=false><sk-datagrid-custom-column sk-field-name=CUSPREVQTD sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSPREVLOTE sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSATUAL sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column></sk-datagrid><sk-hbox><div sk-padding-left=5px><h7 style=\"text-align: center\"><b sk-i18n>Commons.VisualizadorCustoProducao.labelTarifasCIP</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevQtd}}</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevpadrao}}</b></h7></div></sk-hbox></sk-vbox></sk-face-one><sk-face-two><sk-datagrid sk-grid-config={{::ctrl.gridCustoTotalConfig}} sk-dataset=ctrl.dsCustoTotal sk-editable=false sk-on-dbl-click=dbfCusto.changeFace()><sk-datagrid-custom-column sk-field-name=CUSPREVQTD sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column><sk-datagrid-custom-column sk-field-name=CUSPREVLOTE sk-cell-formatter=ctrl.customCellFormatter></sk-datagrid-custom-column></sk-datagrid><sk-hbox><div sk-padding-left=5px><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevQtdTotal}}</b></h7></div><div class=totalizador><h7 style=\"text-align: center\"><b>{{ctrl.txtCustPrevPadraoTotal}}</b></h7></div></sk-hbox></sk-face-two></sk-double-face-panel></sk-vbox>");
  $templateCache.put("commons/visualizadorRelatoriosBase/abaAdicional/abaadicional.tpl.html",
    "<div layout=column ng-show=false flex></div>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/AgendadorRelatoriosPopUp.tpl.html",
    "<sk-dataset sk-refresh-handler=ctrl.refreshHandler(request) sk-dataset-created=ctrl.onDatasetCreated(dataset) sk-standalone><sk-dsfield-md name=SEQUENCIA user-type=I></sk-dsfield-md><sk-dsfield-md name=NURFE user-type=I></sk-dsfield-md><sk-dsfield-md name=DESCRICAO description=Core.VisualizadorRelatorios.labelDescricao user-type=S></sk-dsfield-md><sk-dsfield-md name=DHINI description=Core.VisualizadorRelatorios.labelDataPrimeiraExecucao user-type=D></sk-dsfield-md><sk-dsfield-md name=DHFIM description=Core.VisualizadorRelatorios.headerDataLimiteExecucao user-type=D></sk-dsfield-md><sk-dsfield-md name=PROXEXEC description=Core.VisualizadorRelatorios.headerDataProxEnvio user-type=D></sk-dsfield-md><sk-dsfield-md name=EXECUNICA description=Core.VisualizadorRelatorios.headerExecucaoUnica presentation-type=S></sk-dsfield-md></sk-dataset><sk-double-face-panel id=dblFacePanelAgendadorRelatorio sk-dataset=ctrl.dsAgendadorRelatorio sk-default-face-index=GRID_FACE sk-hide-button-grid-form=true creation-complete=ctrl.onDoubleFacePanelCreated(dblFacePanelAgendadorRelatorio) layout flex><sk-face-one layout flex><sk-wizard sk-disable-key-down=true sk-hide-btn-cancel=\"ctrl.wizardContext.canCancel != true\" sk-hide-indicators=false sk-on-cancel=ctrl.onCancel() sk-dataset=ctrl.dsAgendadorRelatorio id=wizardAgendador sk-on-finish=ctrl.finishTask($step) sk-on-create=ctrl.onWizardCreated(wizard) layout flex><sk-step sk-title=Core.VisualizadorRelatorios.labelDescricao sk-template-url=commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepDescricao.tpl.html sk-controller=StepDescriptionController sk-controller-as=ctrl sk-event-bus=ctrl.stepEvtBus></sk-step><sk-step sk-title=Core.VisualizadorRelatorios.labelDefinaHorariosEnvio sk-template-url=commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepDefinaHorarios.tpl.html sk-controller=StepSetTimesController sk-controller-as=ctrl></sk-step><sk-step sk-title=Core.VisualizadorRelatorios.labelDefinaDestinatarios sk-template-url=commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepSelecionaUsuario.tpl.html sk-controller=StepSelectedUserController sk-controller-as=ctrl></sk-step><sk-step sk-title=Core.VisualizadorRelatorios.labelDefinaValoresParametros sk-template-url=commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepValoresParametros.tpl.html sk-controller=StepValuesParametersController sk-hide-next=false sk-controller-as=ctrl sk-finalize=ctrl.liberarFinalizacao></sk-step></sk-wizard></sk-face-one><sk-face-two layout flex><div class=btn-group><button default class=\"btn btn-sk-sm\" ng-click=ctrl.manutencaoAgendamento() sk-i18n tooltip=Core.VisualizadorRelatorios.buttonAdicionarAgendamento tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=plus></sk-icon></button> <button default class=\"btn btn-sk-sm\" ng-click=ctrl.removerAgendamento() sk-i18n tooltip=Core.VisualizadorRelatorios.buttonRemoverAgendamento tooltip-placement=bottom tooltip-append-to-body=true ng-disabled=!ctrl.temRegistros><sk-icon font-icon=minus></sk-icon></button> <button default class=\"btn btn-sk-sm\" ng-click=ctrl.clonarAgendamento() sk-i18n tooltip=Core.VisualizadorRelatorios.buttonDuplicar tooltip-placement=bottom tooltip-append-to-body=true ng-disabled=!ctrl.temRegistros><sk-icon font-icon=duplicate></sk-icon></button> <button default class=\"btn btn-sk-sm\" ng-click=ctrl.carregarAgendamentos() sk-i18n tooltip=Core.VisualizadorRelatorios.buttonAtualizarAgendamentos tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=refresh></sk-icon></button> <button default ng-click=ctrl.executarAgendamentoManual() sk-i18n tooltip=Core.VisualizadorRelatorios.executar tooltip-placement=bottom tooltip-append-to-body=true ng-disabled=!ctrl.temRegistros><sk-icon font-icon=\"glyphicons glyphicons-play\"></sk-icon><span sk-i18n>Core.VisualizadorRelatorios.executar</span></button></div><sk-datagrid sk-dataset=ctrl.dsAgendadorRelatorio sk-allow-multiple-selection=false sk-datagrid-interceptor=ctrl sk-on-dbl-click=ctrl.manutencaoAgendamento(dblFacePanelAgendadorRelatorio)></sk-datagrid></sk-face-two></sk-double-face-panel>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepDefinaHorarios.tpl.html",
    "<br><div layout=column class=step-container flex><sk-simple-form sk-columns=4><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelDataPrimeiraExecucao sk-required=true><sk-date-time-input sk-value=ctrl.dtInicio ng-model=ctrl.dtInicio sk-change=ctrl.validateBtnNext()></sk-date-time-input></sk-simple-item><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelNaoExecutarDepois sk-required=true><sk-date-time-input sk-value=ctrl.dtFinal ng-model=ctrl.dtFinal sk-change=ctrl.validateBtnNext()></sk-date-time-input></sk-simple-item><sk-simple-item style=\"width: 18%\" sk-label=Core.VisualizadorRelatorios.labelHoraEnvio sk-required=true><sk-time-input style=\"max-width: 120px\" sk-value=ctrl.horasEnvio sk-change=ctrl.validateBtnNext() ng-model=ctrl.horasEnvio sk-field-name=HORAAGENDA1></sk-time-input></sk-simple-item><br><sk-simple-item><sk-checkbox style=\"top: 10px\" ng-model=ctrl.chkExecUnica sk-value=ctrl.chkExecUnica>{{'Core.VisualizadorRelatorios.labelEnviarUnicaVez' | translate }}</sk-checkbox></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=2><sk-simple-group sk-label=Core.VisualizadorRelatorios.labelDiasEnvio><sk-simple-item><sk-radio-input sk-value=ctrl.inputValue sk-option=rdTodoDia sk-change=ctrl.changeRadioSemana() sk-enabled=enabled sk-name=checkDay>{{'Core.VisualizadorRelatorios.itemTodoDia' | translate }}</sk-radio-input><sk-radio-input sk-value=ctrl.inputValue sk-option=daysOfTheWeek sk-change=ctrl.changeRadioSemana() sk-enabled=enabled sk-name=checkDay>{{'Core.VisualizadorRelatorios.itemPorDiasSemana' | translate }}</sk-radio-input><sk-simple-form style=\"width: 200%\"><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkDom ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.domingoLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkSeg ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.segundaLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkTer ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.tercaLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkQua ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.quartaLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkQui ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.quintaLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkSex ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.sextaLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item style=\"width: 12%\"><sk-checkbox ng-model=ctrl.chkSab ng-disabled=\"ctrl.inputValue === 'rdTodoDia' || ctrl.inputValue === 'daysOfTheMonth'\"><sk-i18n>Core.VisualizadorRelatorios.sabadoLabel</sk-i18n></sk-checkbox></sk-simple-item></sk-simple-form><sk-radio-input sk-value=ctrl.inputValue sk-option=daysOfTheMonth sk-change=ctrl.changeRadioMes() sk-enabled=enabled sk-name=checkDay>{{'Core.VisualizadorRelatorios.itemPorDiasMes' | translate }}, {{'Core.VisualizadorRelatorios.labelSeparePorVirgula' | translate }}</sk-radio-input><sk-simple-item sk-width=300px><sk-text-input sk-restrict=[^0-9\\,] sk-value=ctrl.txtDias sk-enabled=ctrl.enabledInput sk-focus-out=ctrl.changeDiasMes()></sk-text-input></sk-simple-item></sk-simple-item></sk-simple-group><sk-simple-group sk-label=Core.VisualizadorRelatorios.labelMesesEnvio><sk-simple-form sk-columns=1><sk-simple-item><sk-checkbox sk-value=ctrl.chkTodos ng-model=ctrl.chkTodos ng-change=ctrl.todosMeses(ctrl.chkTodos)>{{'Core.VisualizadorRelatorios.labelTodos' | translate }}</sk-checkbox></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=6><sk-simple-item><sk-checkbox sk-value=ctrl.chkJan ng-model=ctrl.chkJan ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.janeiroLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkFev ng-model=ctrl.chkFev ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.fevereiroLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkMar ng-model=ctrl.chkMar ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.marcoLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkAbr ng-model=ctrl.chkAbr ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.abrilLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkMai ng-model=ctrl.chkMai ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.maioLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkJun ng-model=ctrl.chkJun ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.junhoLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkJul ng-model=ctrl.chkJul ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.julhoLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkAgo ng-model=ctrl.chkAgo ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.agostoLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkSet ng-model=ctrl.chkSet ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.setembroLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkOut ng-model=ctrl.chkOut ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.outubroLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkNov ng-model=ctrl.chkNov ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.novembroLabel</sk-i18n></sk-checkbox></sk-simple-item><sk-simple-item><sk-checkbox sk-value=ctrl.chkDez ng-model=ctrl.chkDez ng-change=ctrl.validaChkMeses()><sk-i18n>Core.VisualizadorRelatorios.dezembroLabel</sk-i18n></sk-checkbox></sk-simple-item></sk-simple-form></sk-simple-group></sk-simple-form></div>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepDescricao.tpl.html",
    "<sk-simple-form sk-columns=3 sk-only-custom><sk-simple-item sk-field-name=DESCRICAO sk-label=Core.VisualizadorRelatorios.labelDescricao sk-required=true><sk-text-input sk-value=ctrl.textDescricao sk-change=validateBtnNext() sk-field-name=DESCRICAO sk-dataset=ctrl.dsAgendadorRelatorio></sk-text-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=2><sk-simple-item sk-label=Geral.labelUsuarioresp><sk-pesquisa-input sk-value=ctrl.pesquisaUsuario sk-entity-name=Usuario sk-field-name=CODUSU></sk-pesquisa-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=2><sk-simple-item sk-label=Geral.lblContaSmtp><sk-pesquisa-input sk-value=ctrl.pesquisaSmtp sk-entity-name=ServidorSMTP sk-field-name=CODSMTP></sk-pesquisa-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=3><sk-simple-item><sk-checkbox ng-model=ctrl.emailManual sk-value=ctrl.emailManual>{{'Core.VisualizadorRelatorios.labelEditarMensagemManualmente' | translate}}</sk-checkbox></sk-simple-item></sk-simple-form><hr><sk-simple-form sk-columns=3 ng-if=!ctrl.emailManual><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelArquivoModeloEmail><sk-hbox><sk-text-input sk-custom-item-input sk-value=ctrl.textModelo></sk-text-input>&nbsp;<sk-help-tip style=\"padding: 4px\" ng-click=ctrl.buildToolTipMessage() class=margin-help sk-text={{toolTipMessage}}></sk-help-tip></sk-hbox></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=1 ng-if=ctrl.emailManual><sk-simple-item sk-field-name=ASSUNTO sk-label=Core.VisualizadorRelatorios.labelAssunto><sk-text-input sk-value=ctrl.textAssunto></sk-text-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=1 ng-if=ctrl.emailManual><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelMensagem><sk-rich-text sk-dataset=ctrl.dsAgendadorRelatorio sk-field-name=ctrl.txaEmailMsg sk-value=ctrl.txaEmailMsg></sk-rich-text></sk-simple-item></sk-simple-form>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepSelecionaUsuario.tpl.html",
    "<sk-vbox class=step-container flex><br><sk-simple-form sk-columns=1><sk-simple-item><sk-checkbox sk-option=ctrl.chkDestinatariosDinamicos ng-model=ctrl.chkDestinatariosDinamicos sk-value=ctrl.chkDestinatariosDinamicos ng-change=ctrl.disabledTwoList()>{{'Core.VisualizadorRelatorios.labelUsarListaVariavelDestinatarios' | translate}}</sk-checkbox></sk-simple-item></sk-simple-form><sk-two-lists sk-src-title=Core.VisualizadorRelatorios.labelDestinatarios sk-dest-title=Core.VisualizadorRelatorios.labelDestinatariosSelecionados sk-src-data=ctrl.srcUserData sk-dest-data=ctrl.destUserData sk-src-filter-fn=\"ctrl.searchFilterFn(item, searchTerm)\" sk-dest-filter-fn=\"ctrl.searchFilterFn(item, searchTerm)\" sk-on-move-item=ctrl.onSelectItem() id=twoListVisualizadorRelatorios flex><sk-src-item-tpl>{{ item.CODDEST['$'] + ' - ' + item.NOMEDEST['$'] }}</sk-src-item-tpl><sk-dest-item-tpl>{{ item.CODDEST['$'] + ' - ' + item.NOMEDEST['$'] }}</sk-dest-item-tpl></sk-two-lists></sk-vbox>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/AgendadorRelatoriosPopUp/step/stepValoresParametros.tpl.html",
    "<div ng-if=!ctrl.chkDinamicos><div ng-repeat=\"prmtr in ctrl.parametros track by $index\"><sk-simple-form sk-columns=2 ng-if=\"prmtr.classe === 'java.math.BigDecimal' \"><sk-simple-item ng-if=\"prmtr.pesquisa === 'false' \" sk-field-name={{prmtr.nome}} sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-text-input sk-value=prmtr.valor ng-model=prmtr.valor sk-change=validateBtnFinish() sk-field-name={{prmtr.nome}}></sk-text-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=2 ng-if=\"prmtr.classe === 'java.math.BigDecimal' \"><sk-simple-item ng-if=\"prmtr.pesquisa === 'true' \" sk-field-name={{prmtr.nome}} sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-pesquisa-input sk-value=prmtr.valor ng-model=prmtr.valor sk-entity-name={{prmtr.instancia}} sk-change=validateBtnFinish() sk-field-name={{prmtr.nome}}></sk-pesquisa-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=2 ng-if=\"prmtr.classe === 'java.sql.Timestamp' \"><sk-simple-item ng-if=\"prmtr.pesquisa === 'false' \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-date-time-input sk-value=prmtr.valor ng-model=prmtr.valor sk-change=validateBtnFinish()></sk-date-time-input></sk-simple-item><sk-simple-item sk-columns=2 ng-if=\"prmtr.pesquisa === 'true' \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-date-time-input sk-value=prmtr.valor ng-model=prmtr.valor sk-change=validateBtnFinish()></sk-date-time-input></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=3 ng-if=\"prmtr.classe === 'java.lang.String' && prmtr.opcao !== undefined\"><sk-simple-item ng-if=\"prmtr.pesquisa === 'true' \" sk-field-name=prmtr.nome sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-combobox sk-options=prmtr.opcao sk-value=prmtr.valor ng-model=prmtr.valor sk-opt-key=valor sk-change=validateBtnFinish() sk-opt-label=descricao></sk-combobox></sk-simple-item><sk-simple-item sk-columns=2 ng-if=\"prmtr.pesquisa === 'false' \" sk-field-name=prmtr.nome sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-combobox sk-options=prmtr.opcao sk-value=prmtr.valor ng-model=prmtr.valor sk-opt-key=valor sk-change=validateBtnFinish() sk-opt-label=descricao></sk-combobox></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=3 ng-if=\"prmtr.classe === 'java.lang.Boolean'\"><sk-simple-item ng-if=\"prmtr.pesquisa === 'false'  \" sk-field-name=prmtr.nome sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-switch sk-true-value=true sk-false-value=false sk-value=prmtr.valor ng-model=prmtr.valor sk-opt-key=valor sk-change=validateBtnFinish() sk-opt-label=descricao></sk-switch></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=3 ng-if=\"prmtr.classe === 'java.lang.String' && prmtr.opcao === undefined\"><sk-simple-item ng-if=\"prmtr.pesquisa === 'false' \" sk-field-name=prmtr.nome sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-text-input ng-model=prmtr.valor sk-value=prmtr.valor sk-change=validateBtnFinish()></sk-text-input></sk-simple-item><sk-simple-item sk-columns=2 ng-if=\"prmtr.pesquisa === 'true' \" sk-field-name=prmtr.nome sk-label={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-text-input ng-model=prmtr.valor sk-value=prmtr.valor sk-change=validateBtnFinish()></sk-text-input></sk-simple-item></sk-simple-form></div><div ng-if=\"ctrl.parametros.length === 0\"><h2><sk-i18n>Core.VisualizadorRelatorios.naoPossuiParametro</sk-i18n></h2></div></div><sk-vbox ng-if=ctrl.chkDinamicos flex><sk-tabnavigator sk-selected-index=ctrl.navigatorIndex ng-class=\"{'gray-background': ctrl.navigatorIndex == 1}\"><sk-tabnavigator-item><sk-i18n>Core.VisualizadorRelatorios.labelConsultaSQL</sk-i18n></sk-tabnavigator-item><sk-tabnavigator-item><sk-i18n>Core.VisualizadorRelatorios.labelCamposObrigatorios</sk-i18n></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.navigatorIndex class=tab-container flex><sk-hbox flex><sk-viewstack-content><sk-simple-form><br><sk-simple-item><button default ng-click=ctrl.validarExpressao()><sk-icon font-icon=\"glyphicons glyphicons-ok-sign\" sk-i18n tooltip=Core.VisualizadorRelatorios.buttonValidarConsulta tooltip-placement=bottom tooltip-append-to-body=true></sk-icon>{{'Core.VisualizadorRelatorios.buttonValidarConsulta' | translate}}</button></sk-simple-item></sk-simple-form><sk-simple-form sk-columns=1><sk-simple-item><sk-text-area sk-height=250 sk-style=ctrl.textAreaStyle sk-value=ctrl.sql></sk-text-area></sk-simple-item></sk-simple-form></sk-viewstack-content></sk-hbox><sk-viewstack-content layout flex><sk-dataset sk-dataset-created=ctrl.onDsDetalhesCreated(dataset) sk-refresh-handler=ctrl.refreshHandlerDsDetalhes(request) sk-standalone><sk-dsfield-md name=DESCRICAO description=Core.VisualizadorRelatorios.labelDescricao></sk-dsfield-md><sk-dsfield-md name=NOME description=Core.VisualizadorRelatorios.labelCampo></sk-dsfield-md></sk-dataset><sk-datagrid sk-hide-cbx-column=true sk-dataset=ctrl.dsDetalhes></sk-datagrid></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/PopUpAdicionarLancador/PopUpAdicionarLancador.tpl.html",
    "<div layout=column class=adicionar-lancador><sk-simple-form flex=20 sk-columns=1><sk-simple-item sk-label=Geral.lblDescricao sk-required=true><sk-text-input sk-value=ctrl.descLancador></sk-text-input></sk-simple-item></sk-simple-form><sk-simple-form flex sk-columns=1><sk-simple-item sk-label=Commons.VisualizadorRelatoriosBase.labelPastaDestino sk-required=true><sk-tree sk-tree-data=ctrl.tree sk-height=190px sk-on-select=ctrl.treeSelectedItem sk-children-custom-name=item sk-label-custom-name=descricao sk-hide-button-container=true></sk-tree></sk-simple-item></sk-simple-form></div>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/PopUpLocalizarLancador/PopUpLocalizarLancador.tpl.html",
    "<sk-viewstack sk-selected-index=ctrl.selectedIndex><sk-viewstack-content layout-padding layout=column flex><div layout=row layout-align=\"space-around center\"><div class=btn-control><button class=\"btn btn-sk-sm btn-default btn-remove\" ng-click=ctrl.remove() tooltip={{::ctrl.tooltipExcluir}} tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=bin></sk-icon></button> <button class=\"btn btn-sk-sm btn-default\" ng-click=ctrl.save() tooltip={{::ctrl.tooltipSalvar}} tooltip-placement=bottom tooltip-append-to-body=true ng-disabled=ctrl.btnSaveEnabled><sk-icon font-icon=ok-2></sk-icon></button> <button class=\"btn btn-sk-sm btn-default\" ng-click=ctrl.habiliarEdicao(true) tooltip={{::ctrl.tooltipDescartar}} tooltip-placement=bottom tooltip-append-to-body=true ng-disabled=ctrl.btnCancelEnabled><sk-icon svg-src=assets/svg/cancel.svg></sk-icon></button></div><span ng-bind=\"ctrl.lbldescricao + ':'\"></span><sk-text-input flex=60 sk-value=ctrl.descricao sk-change=ctrl.habiliarEdicao(false)></sk-text-input></div><sk-list sk-closest=.list-row sk-margin=\"12px 0 0 0\"><div class=list-row ng-dblclick=ctrl.openApp(lanc.resourceID) ng-repeat=\"lanc in ctrl.lancador track by $index\"><span ng-bind=lanc.path ng-click=ctrl.selectPath(lanc)></span></div></sk-list></sk-viewstack-content><sk-viewstack-content layout=row layout-padding layout-align=\"center center\" flex><label sk-i18n>Commons.VisualizadorRelatoriosBase.naoExisteLancador</label></sk-viewstack-content></sk-viewstack>");
  $templateCache.put("commons/visualizadorRelatoriosBase/popup/PopUpVisualizarRelatorio/PopUpVisualizarRelatorio.tpl.html",
    "<div ng-if=\"ctrl.parametros.length === 0\"><sk-simple-form sk-columns=1><sk-simple-item><br><br><h5><sk-i18n>Core.VisualizadorRelatorios.nenhumaPagina</sk-i18n></h5></sk-simple-item></sk-simple-form></div><div style=\"height: 85%; overflow: auto\"><sk-simple-form sk-columns=1><div ng-repeat=\"prmtr in ctrl.parametros track by $index\"><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'false' && prmtr.classe === 'java.lang.Integer' \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.nome}} sk-required=\"prmtr.requerido === 'true' \"><sk-number-input sk-value=prmtr.valor ng-model=prmtr.valor sk-field-name={{prmtr.nome}}></sk-number-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'false' && prmtr.classe === 'java.math.BigDecimal' && prmtr.opcao === undefined \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.nome}} sk-required=\"prmtr.requerido === 'true' \"><sk-text-input sk-value=prmtr.valor ng-model=prmtr.valor sk-field-name={{prmtr.nome}}></sk-text-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'true' && prmtr.classe === 'java.math.BigDecimal' \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.nome}} sk-required=\"prmtr.requerido === 'true' \"><sk-pesquisa-input sk-value=prmtr.valor ng-model=prmtr.valor sk-entity-name={{prmtr.instancia}} sk-field-name={{prmtr.nome}} sk-data-type=prmtr.tipCampo sk-enviroment-criteria=ctrl.environmentCriteria(prmtr.expressao)></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'false' && prmtr.classe === 'java.sql.Timestamp' \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-date-time-input sk-value=prmtr.valor ng-model=prmtr.valor></sk-date-time-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'true' && prmtr.classe === 'java.sql.Timestamp'\" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.descricao}} sk-required=\"prmtr.requerido === 'true' \"><sk-date-time-input sk-value=prmtr.valor ng-model=prmtr.valor></sk-date-time-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'true' && (prmtr.classe === 'java.lang.String' || prmtr.classe === 'java.math.BigDecimal') && prmtr.opcao !== undefined \" sk-label={{prmtr.descricao}} sk-field-name=prmtr.nome sk-required=\"prmtr.requerido === 'true' \"><sk-combobox sk-value=prmtr.valor sk-options=prmtr.opcao ng-model=prmtr.valor sk-opt-key=valor sk-opt-label=descricao sk-width=30vh></sk-combobox></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'false' && (prmtr.classe === 'java.lang.String' || prmtr.classe === 'java.math.BigDecimal') && prmtr.opcao !== undefined \" sk-label={{prmtr.descricao}} sk-field-name=prmtr.nome sk-required=\"prmtr.requerido === 'true' \"><sk-combobox sk-value=prmtr.valor sk-options=prmtr.opcao ng-model=prmtr.valor sk-opt-key=valor sk-opt-label=descricao sk-width=30vh></sk-combobox></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'false' && prmtr.classe === 'java.lang.String' && prmtr.opcao === undefined \" sk-label={{prmtr.descricao}} sk-field-name=prmtr.nome sk-required=\"prmtr.requerido === 'true' \"><sk-text-input sk-value=prmtr.valor ng-model=prmtr.valor></sk-text-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'true' && prmtr.classe === 'java.lang.String' && prmtr.opcao === undefined \" sk-label={{prmtr.descricao}} sk-field-name=prmtr.nome sk-required=\"prmtr.requerido === 'true' \"><sk-pesquisa-input sk-value=prmtr.valor ng-model=prmtr.valor sk-entity-name={{prmtr.instancia}} sk-field-name={{prmtr.nome}} sk-data-type=prmtr.tipCampo sk-enviroment-criteria=ctrl.environmentCriteria(prmtr.expressao)></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-in-line=true ng-if=\"prmtr.pesquisa === 'false' && prmtr.classe === 'java.lang.Boolean' \" sk-label={{prmtr.descricao}} sk-field-name={{prmtr.nome}} sk-required=\"prmtr.requerido === 'true' \"><sk-checkbox sk-value=prmtr.valor ng-model=prmtr.valor></sk-checkbox></sk-simple-item></div></sk-simple-form></div><footer style=\"position: fixed; left: -5px; bottom: 15px; width: 100%\"><sk-simple-form sk-columns=1><sk-simple-item><div style=\"clear:both; float:right\"><button primary ng-disabled=ctrl.disabledButton ng-click=ctrl.visualizarRelatorio(ctrl.parametros)>Ok</button> <button default ng-click=ctrl.cancel()><sk-i18n>Geral.buttonFechar</sk-i18n></button></div></sk-simple-item></sk-simple-form></footer>");
  $templateCache.put("commons/visualizadorRelatoriosBase/visualizadorRelatoriosBase.tpl.html",
    "<sk-dataset entity-name=Relatorio order-by=NURFE sk-dataset-created=$ctrl.onDatasetCreated(dataset)><sk-field pattern=*></sk-field><sk-field pattern=NOMEUSU path=Usuario></sk-field><sk-field pattern=NOMEINSTANCIA path=Instancia></sk-field></sk-dataset><sk-dataset entity-name=ArquivoRelatorio parent-dataset=$ctrl.dsRelatorio sk-dataset-created=$ctrl.onDatasetCreated(dataset)><sk-field pattern=SEQUENCIA,NOME,NURFE></sk-field></sk-dataset><div flex layout=row class=visualizador-relatorios-base><sk-sidenav class=sk-sidenav is-open=true child-layout=column sk-width=325px><sk-filter-panel sk-apply-function=$ctrl.apply() sk-data-source=$ctrl.dsRelatorio sk-resource-id=\"{{ ::$ctrl.resourceID }}\" sk-filter-panel-interceptor=$ctrl sk-height=100% sk-width=100%><default-group sk-label=Commons.VisualizadorRelatorios.lbFiltrosRapidos><sk-simple-form sk-columns=1 no-padding layout-top-padding><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelCodigo><sk-pesquisa-input sk-value=$ctrl.codigoRelatorio sk-entity-name=Relatorio sk-field-name=NURFE sk-enviroment-criteria=$ctrl.getCriteriaPesquisa()></sk-pesquisa-input></sk-simple-item><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelNomeContendo><sk-text-input sk-value=$ctrl.descricaoRelatorio sk-keydown=$ctrl.onKeydown($event)></sk-text-input></sk-simple-item><sk-simple-item sk-label=Core.VisualizadorRelatorios.labelNomeArquivoContendo><sk-text-input sk-value=$ctrl.nomeArquivoRelatorio sk-keydown=$ctrl.onKeydown($event)></sk-text-input></sk-simple-item><sk-simple-item><sk-checkbox-list style=\"height: 200px\" sk-label=Core.VisualizadorRelatorios.categoria sk-options=$ctrl.options sk-value=$ctrl.value></sk-checkbox-list></sk-simple-item></sk-simple-form></default-group></sk-filter-panel></sk-sidenav><div layout=column flex><sk-double-face-panel id=dblFacePanelRelatorios sk-dataset=$ctrl.dsRelatorio creation-complete=$ctrl.onDoubleFacePanelCreated(dblFacePanelRelatorios) sk-change-button-actions=$ctrl.changeButtonActionsRelatorios layout flex><sk-top-bar layout=row layout-padding><sk-hbox gap=5 flex><sk-dropdown-menu sk-build-options=buildOptions() sk-open-always=true i18n sk-font-icon=plus sk-color-btn=brand sk-tooltip=Commons.VisualizadorRelatoriosBase.tooltipBtnAdicionarDropDown sk-margin-right=5px ng-show=\"ehTelaCadastroRelatorio() && !$ctrl.dsRelatorio.isInsertionMode()\"></sk-dropdown-menu><sk-navigator dataset=$ctrl.dsRelatorio sk-save-handler=$ctrl.saveHandler() sk-compact-btn-add sk-show-add-button=!ehTelaCadastroRelatorio()></sk-navigator><button default class=\"btn btn-sk-sm\" type=button ng-click=$ctrl.visualizarRelatorio() ng-disabled=$ctrl.buttonRelatorio sk-i18n tooltip=Core.VisualizadorRelatorios.visualizarRelatorio tooltip-placement=bottom><sk-icon svg-src=/mge/assets/svg/search.svg></sk-icon></button> <button default class=\"btn btn-sk-sm\" type=button ng-click=$ctrl.agendarRelatorios() ng-disabled=$ctrl.buttonAgendarRelatorio sk-i18n tooltip=Core.VisualizadorRelatorios.agendarRelatorio tooltip-placement=bottom><sk-icon font-icon=clock></sk-icon></button><sk-hbox ng-if=$ctrl.showBtnLayout><div ng-switch=$ctrl.btnBoleto.toString()><div ng-switch-when=true><sk-dropdown-menu sk-open-always=true sk-label=\"{{$ctrl.otherOptionsLabel()[0] ? $ctrl.otherOptionsLabel()[0] : $ctrl.txtOutrasOpcoes}}\" sk-tooltip=\"{{$ctrl.otherOptionsLabel()[0] ? $ctrl.otherOptionsLabel()[0] : $ctrl.txtOutrasOpcoes}}\" sk-build-options=$ctrl.otherOptionsLayout() i18n style=\"margin-right: 2.5px; margin-left: 2.5px\"></sk-dropdown-menu><button default class=\"btn btn-default\" type=button ng-click=$ctrl.modeloPadraoAction() ng-disabled=$ctrl.buttonAgendarRelatorio i18n tooltip={{$ctrl.txtOptionsLayout}} tooltip-placement=bottom style=\"margin-right: 2.5px; margin-left: 2.5px\">{{$ctrl.txtOptionsLayout}}</button><sk-btn-place style=margin-left:8px sk-label=\"\" sk-i18n tooltip=Core.VisualizadorRelatorios.encontreRelatorios tooltip-placement=bottom sk-destination=\"{{ ::$ctrl.abrirPlace() }}\"></sk-btn-place></div><div ng-switch-default><sk-dropdown-menu sk-hiden-icon=true sk-label=\"{{$ctrl.otherOptionsLabel ? $ctrl.otherOptionsLabel : $ctrl.txtOptionsLayout}}\" sk-tooltip=\"{{$ctrl.otherOptionsLabel ? $ctrl.otherOptionsLabel : $ctrl.txtOptionsLayout}}\" sk-build-options=$ctrl.otherOptionsLayout() ng-if=$ctrl.showBtnLayout i18n></sk-dropdown-menu><sk-btn-place style=margin-left:8px sk-label=\"\" sk-i18n tooltip=Core.VisualizadorRelatorios.encontreRelatorios tooltip-placement=bottom sk-destination=\"{{ ::$ctrl.abrirPlace() }}\"></sk-btn-place></div></div></sk-hbox><sk-hbox layout=row layout-align=\"end center\" flex gap=5><sk-entity-attach sk-entity-name=Relatorio sk-resource-id=\"{{ ::$ctrl.resourceID }}\" sk-dataset=$ctrl.dsRelatorio></sk-entity-attach><sk-btn-other-options sk-other-options=$ctrl.otherOptionsLoader()></sk-btn-other-options><sk-rows-counter sk-dataset=$ctrl.dsRelatorio></sk-rows-counter></sk-hbox></sk-hbox></sk-top-bar><sk-face-one layout flex><sk-form sk-dataset=$ctrl.dsRelatorio columns=6 sk-only-custom><sk-form-custom-item sk-field-name=NURFE sk-description=Core.VisualizadorRelatorios.labelCodigo><sk-text-input sk-field-name=NURFE sk-dataset=$ctrl.dsRelatorio sk-enabled=false></sk-text-input></sk-form-custom-item></sk-form><sk-form sk-dataset=$ctrl.dsRelatorio columns=3 sk-only-custom><sk-form-custom-item sk-field-name=DESCRICAO sk-description=Core.VisualizadorRelatorios.labelDescricao><sk-text-input sk-field-name=DESCRICAO sk-dataset=$ctrl.dsRelatorio></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CONFIG sk-visible=false></sk-form-custom-item><sk-form-custom-item sk-field-name=EXPFILTROINSTANCIA sk-visible=false></sk-form-custom-item><sk-form-custom-item sk-field-name=TIPO sk-visible=false></sk-form-custom-item><sk-form-custom-item sk-field-name=NURFE sk-visible=false></sk-form-custom-item><sk-form-custom-item sk-field-name=Instancia.NOMEINSTANCIA sk-visible=false></sk-form-custom-item><sk-form-custom-item sk-field-name=CATEGORIA sk-description=Core.VisualizadorRelatorios.categoria><sk-select-distinct-input sk-dataset=$ctrl.dsRelatorio sk-field-name=CATEGORIA sk-entity-name=Relatorio></sk-select-distinct-input></sk-form-custom-item><sk-form-custom-item sk-field-name=DHALTER sk-description=Core.VisualizadorRelatorios.labelUltimaAlteracao><sk-date-time-input sk-field-name=DHALTER sk-dataset=$ctrl.dsRelatorio sk-enabled=false></sk-date-time-input></sk-form-custom-item><sk-form-custom-item sk-field-name=CODUSU sk-description=Geral.labelUsuario sk-dataset=$ctrl.dsRelatorio sk-entity-name=Usuario sk-field-name=CODUSU sk-enabled=false sk-value=$ctrl.psqUsuario></sk-form-custom-item><sk-form-custom-item sk-field-name=IDTELA sk-description=Core.VisualizadorRelatorios.frmIdTela><sk-text-input sk-field-name=IDTELA sk-dataset=$ctrl.dsRelatorio sk-i18n tooltip=Core.VisualizadorRelatorios.tlTIdTelaInformado></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=NURFEDEPENDENTE sk-description=Core.VisualizadorRelatorios.labelRelatorioDependente sk-dataset=$ctrl.dsRelatorio sk-entity-name=RelatorioDependente></sk-form-custom-item><sk-form-custom-item sk-simple-label sk-field-name=NUINSTANCIA sk-description=Core.VisualizadorRelatorios.labelTelaOuInstancia ng-if=\"$ctrl.showTelaPersonalizada && !$ctrl.btnBoleto\"><sk-hbox><sk-pesquisa-input sk-field-name=NUINSTANCIA sk-custom-item-input sk-description=Core.VisualizadorRelatorios.labelTelaOuInstancia ng-if=$ctrl.showTelaPersonalizada sk-value=$ctrl.pesqInstancia sk-dataset=$ctrl.dsRelatorio sk-entity-name=Instancia sk-entity-change=$ctrl.getNomeInstancia(item) flex=92></sk-pesquisa-input><button id=btn-default-filter class=\"btn btn-sk-sm btn-filter\" ng-click=$ctrl.openAjudanteExpressao() sk-disabled=!$ctrl.btnFiltroInstancia tooltip=\"{{ 'FiltroPersonalizado.lblFiltroPadrao' | translate }}\" tooltip-placement=bottom tooltip-append-to-body=true><sk-icon font-icon=filter></sk-icon></button></sk-hbox></sk-form-custom-item><sk-form-custom-item sk-field-name=FORMATO sk-description=Core.VisualizadorRelatorios.labelFormatoImpressao ng-if=\"$ctrl.showTelaPersonalizada  && !$ctrl.btnBoleto\"><sk-hbox><sk-combobox sk-dataset=$ctrl.dsRelatorio sk-field-name=FORMATO sk-value=$ctrl.formatoComboBox flex=92></sk-combobox><sk-icon font-icon=circle-question-mark style=\"cursor: pointer\" ng-click=$ctrl.openFormatoHelp() sk-visible=$ctrl.helpTipVisibility ng-style=\"{'margin-left': $ctrl.marginHelper}\" class=margin-help></sk-icon></sk-hbox></sk-form-custom-item><sk-form-custom-item sk-field-name=DSNAME sk-description=Core.VisualizadorRelatorios.labelFonteDeDados><sk-combobox sk-dataset=$ctrl.dsRelatorio sk-field-name=DSNAME></sk-combobox></sk-form-custom-item><sk-form-custom-item sk-field-name=PREFIXOANEXO sk-description=Core.VisualizadorRelatorios.labelPrefixoAnexo><sk-hbox><sk-text-input sk-custom-item-input sk-dataset=$ctrl.dsRelatorio sk-field-name=PREFIXOANEXO sk-value=$ctrl.textPrefixoAnexo flex=92></sk-text-input><sk-help-tip sk-text=Core.VisualizadorRelatorios.helpPrefixoAnexo class=margin-help></sk-help-tip></sk-hbox></sk-form-custom-item><sk-form-custom-item sk-field-name=NOMEIMPRESSORA sk-visible=$ctrl.nomeImpressora><sk-text-input sk-field-name=NOMEIMPRESSORA sk-dataset=$ctrl.dsRelatorio></sk-text-input></sk-form-custom-item></sk-form><sk-form sk-dataset=$ctrl.dsRelatorio columns=3 sk-only-custom sk-margin-bottom=12px><sk-form-custom-item sk-field-name=NOMEIMPRESSORA sk-visible=$ctrl.nomeImpressora><sk-text-input sk-field-name=NOMEIMPRESSORA sk-dataset=$ctrl.dsRelatorio></sk-text-input></sk-form-custom-item></sk-form><sk-tabnavigator sk-selected-index=selectedIndex style=\"z-index: 10\"><sk-tabnavigator-item><p sk-i18n>Commons.VisualizadorRelatoriosBase.labelArquivos</p></sk-tabnavigator-item><sk-tabnavigator-item ng-repeat=\"tabInfo in $ctrl.abasAdicionais track by tabInfo.blockId\" sk-label={{tabInfo.description}}>{{tabInfo.description}}</sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=selectedIndex><sk-viewstack-content layout=column><sk-double-face-panel id=dblFacePanelArquivoRelatorio sk-dataset=$ctrl.dsArquivoRelatorio creation-complete=$ctrl.onDoubleFacePanelCreated(dblFacePanelArquivoRelatorio) sk-change-button-actions=$ctrl.changeButtonActionsArquivoRelatorio sk-default-face-index=FORM_FACE style=\"border-top: 1px solid #ccc\" layout flex><sk-top-bar layout=row layout-padding><sk-navigator dataset=$ctrl.dsArquivoRelatorio sk-show-copy-button=false sk-show-add-button=false></sk-navigator><sk-entity-attach sk-entity-name=ArquivoRelatorio sk-resource-id=\"{{ ::$ctrl.resourceID }}\" sk-dataset=$ctrl.dsArquivoRelatorio></sk-entity-attach><button default class=\"btn btn-default\" sk-margin=\"0px 0px 0px 5px\" ng-click=$ctrl.fileUpload() ng-disabled=$ctrl.buttonAdicionarArquivo sk-i18n>Commons.VisualizadorRelatoriosBase.buttonAdicionarArquivo</button> <button default class=\"btn btn-default\" sk-margin=\"0px 0px 0px 5px\" ng-click=$ctrl.download() ng-disabled=$ctrl.buttonRelatorio sk-i18n>Commons.VisualizadorRelatoriosBase.buttonDownload</button><div layout=row layout-align=\"end center\" flex><sk-rows-counter sk-dataset=$ctrl.dsArquivoRelatorio></sk-rows-counter></div></sk-top-bar><sk-face-one layout flex><sk-datagrid sk-dataset=$ctrl.dsArquivoRelatorio sk-grid-config=\"{{ ::$ctrl.gridConfigArquivoRelatorio }}\" sk-datagrid-interceptor=$ctrl sk-on-datagrid-loaded=$ctrl.onDatagridLoaded(datagrid) sk-on-dbl-click=$ctrl.onDblClickGrid(dblFacePanelArquivoRelatorio) sk-allow-multiple-selection=true sk-disable-tour=true></sk-datagrid></sk-face-one><sk-face-two layout sk-bg-color=#fbfbfb flex><sk-form sk-dataset=$ctrl.dsArquivoRelatorio columns=2 sk-only-custom><sk-form-custom-item sk-field-name=SEQUENCIA sk-description=Commons.VisualizadorRelatoriosBase.headerSequencia><sk-text-input sk-value=$ctrl.textSequencia sk-field-name=SEQUENCIA sk-enabled=false sk-dataset=$ctrl.dsArquivoRelatorio></sk-text-input></sk-form-custom-item><sk-form-custom-item sk-field-name=NOME sk-description=Commons.VisualizadorRelatoriosBase.labelNome><sk-text-input sk-field-name=NOME sk-dataset=$ctrl.dsArquivoRelatorio sk-enabled=false></sk-text-input></sk-form-custom-item></sk-form></sk-face-two></sk-double-face-panel></sk-viewstack-content><sk-viewstack-content ng-repeat=\"tabInfo in $ctrl.abasAdicionais track by tabInfo.blockId\" layout=column flex><sk-aba-adicional sk-data=tabInfo sk-properties=tabInfo.properties layout=row flex></sk-aba-adicional></sk-viewstack-content></sk-viewstack></sk-face-one><sk-face-two><sk-datagrid sk-dataset=$ctrl.dsRelatorio sk-grid-config=\"{{ ::$ctrl.gridConfigRelatorio }}\" sk-datagrid-interceptor=$ctrl sk-on-datagrid-loaded=$ctrl.onDatagridLoaded(datagrid) sk-on-dbl-click=$ctrl.onDblClickGrid(dblFacePanelRelatorios) sk-disable-tour=true sk-allow-multiple-selection=true></sk-datagrid></sk-face-two></sk-double-face-panel></div></div>");
  $templateCache.put("commons/wizardquestion/step/stepquestion.tpl.html",
    "<sk-hbox flex><sk-simple-form sk-columns=1 flex><sk-simple-group sk-label={{::ctrl.titleGroup}}></sk-simple-group></sk-simple-form></sk-hbox><sk-hbox flex><sk-form class=form-cad-simpl properties=formProperties model=formValues sk-form-interceptor=ctrl sk-columns=1 sk-inline=true flex></sk-form></sk-hbox>");
  $templateCache.put("commons/wizardquestion/step/steps.tpl.html",
    "<section layout=column flex></section>");
  $templateCache.put("commons/wizardquestion/wizardquestion.tpl.html",
    "<sk-vbox flex><sk-vbox flex><sk-viewstack class=viewstack-cad-simpl sk-selected-index=currentStep class=tab-container layout flex><sk-viewstack-content ng-repeat=\"step in steps\" layout flex><sk-step-question class=step-question-cad-simpl sk-title=step.title wizard=ctrl sk-context=wizardData sk-question=step.question></sk-step-question></sk-viewstack-content></sk-viewstack></sk-vbox><sk-hbox class=buttons-container layout-align=\"end center\"><sk-hbox class=buttons-cad-simpl><button class=\"btn btn-default\" ng-click=ctrl.cancel() ng-disabled=!canCancel>Cancelar</button> <button class=\"btn btn-default\" ng-click=ctrl.previous() ng-disabled=!canPrevious>Anterior</button> <button class=\"btn btn-default\" ng-click=ctrl.next() ng-disabled=!canNext>Próximo</button> <button class=\"btn btn-primary\" ng-click=ctrl.finish() ng-disabled=!canFinish>Concluir</button></sk-hbox></sk-hbox></sk-vbox>");
  $templateCache.put("commons/workFlow/modelerBpmn/modelerBpmn.tpl.html",
    "<sk-vbox style=\"height: 100%; width: 100%\" flex><div id=diagram-canvas flex></div><div class=modeler-canvas ng-show=showZoom><div class=btn-group><button class=\"btn btn-default\" ng-click=zoomInCanvas() tooltip=Commons.ModelerBpmn.tooltipBtnModelerZoomIn tooltip-placement=top sk-i18n small><sk-icon font-icon=zoom-in></sk-icon></button> <button class=\"btn btn-default\" ng-click=zoomOutCanvas() tooltip=Commons.ModelerBpmn.tooltipBtnModelerZoomOut tooltip-placement=top sk-i18n small><sk-icon font-icon=zoom-out></sk-icon></button> <button class=\"btn btn-default\" ng-click=zoomResetCanvas() tooltip=Commons.ModelerBpmn.tooltipBtnModelerZoomReset tooltip-placement=top sk-i18n small><sk-icon svg-src=/mge/assets/svg/zoom-target.svg></sk-icon></button></div></div></sk-vbox>");
  $templateCache.put("commons/workFlow/startingProcess/fomulario/formularioInicio.tpl.html",
    "<sk-dynaform sk-entity-name={{ctrl.entityName}} sk-on-dynaform-loaded=\"ctrl.onDynaformLoaded(dynaform, dataset)\" sk-dynaform-interceptor=ctrl sk-form-interceptor=ctrl sk-datagrid-interceptor=ctrl sk-show-filter=false sk-edit-unique-record=ctrl.uniqueRecord sk-skip-start-page=true sk-hide-entity-card=true sk-hide-entity-search-field=true sk-hide-button-favorite=true sk-hide-button-recents=true sk-hide-button-entity-attach=true sk-hide-buttons-config=true sk-hide-button-grid=ctrl.uniqueRecord sk-show-search-field=true sk-hide-tour=true sk-ignored-config-entity=true sk-form-column-number-config=3 style=\"height: 100%; position: absolute; overflow: auto\" flex></sk-dynaform>");
  $templateCache.put("commons/workFlow/startingProcess/startingProcess.tpl.html",
    "<sk-vbox flex sk-height=100% ng-if=\"ctrl.conteudoTarefa.length > 0\"><sk-tabnavigator sk-selected-index=ctrl.selectedIndexForms ng-show=\"ctrl.conteudoTarefa.length > 1\"><sk-tabnavigator-item sk-label={{conteudo.description}} ng-repeat=\"conteudo in ctrl.conteudoTarefa track by $index\"><span>{{conteudo.description}}</span></sk-tabnavigator-item></sk-tabnavigator><sk-viewstack sk-selected-index=ctrl.selectedIndexForms sk-on-select=ctrl.onSelectForms flex><sk-viewstack-content ng-repeat=\"conteudo in ctrl.conteudoTarefa track by $index\" flex><sk-formulario-inicio sk-entity=conteudo sk-create-formulario-inicio=ctrl.createFormFormatados sk-initialization=conteudo.initialization sk-form-getter=ctrl.formGetter sk-task-info=ctrl.getTaskInfo ng-if=\" conteudo.tipo != 'T' \" flex></sk-formulario-inicio><sk-tela-nativa-flow sk-src={{conteudo.url}} ng-if=\" conteudo.tipo == 'T' \" sk-height=100% sk-width=100% sk-resourceid={{::conteudo.resourceid}} sk-config-ligacao={{::conteudo.configLigacao}} sk-position=absolute sk-cardinalidade={{::conteudo.cardinalidade}}></sk-tela-nativa-flow></sk-viewstack-content></sk-viewstack></sk-vbox>");
  $templateCache.put("commons/workFlow/telaNativaFlow/telaNativaFlow.tpl.html",
    "<iframe ng-if=idtela id={{::idtela}} type=text/javascript style=\"width: 100%; height: 100%\" ng-src={{src}} frameborder=0 scrolling=yes></iframe><sk-vbox class=tela-nao-existe ng-if=!src align=\"center center\" flex><p sk-i18n>Commons.startingProcess.txtTelaNaoEncontrada</p><p sk-i18n>Commons.startingProcess.textInformeModeladorProcesso</p></sk-vbox>");
}]);
